
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire570e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire570e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
"use strict";
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("fw0lo", function(module, exports) {
"use strict";
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});
parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $4d82739dd229d539$var$Mg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Ng = null, $4d82739dd229d539$var$Og = null, $4d82739dd229d539$var$Pg = null;
function $4d82739dd229d539$var$Qg() {
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Ng = null;
}
function $4d82739dd229d539$var$Rg(a) {
    var b = $4d82739dd229d539$var$Mg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Mg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$Tg(a, b) {
    $4d82739dd229d539$var$Ng = a;
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$Ug = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$Vg(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Og) {
            if (null === $4d82739dd229d539$var$Ng) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Og = a;
            $4d82739dd229d539$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Og.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$Wg = null;
function $4d82739dd229d539$var$Xg(a) {
    null === $4d82739dd229d539$var$Wg ? $4d82739dd229d539$var$Wg = [
        a
    ] : $4d82739dd229d539$var$Wg.push(a);
}
function $4d82739dd229d539$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$Zg(a, d);
}
function $4d82739dd229d539$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$$g = !1;
function $4d82739dd229d539$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$Zg(a, c);
}
function $4d82739dd229d539$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$jh = (new $7fPBF.Component).refs;
function $4d82739dd229d539$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$L(), d = $4d82739dd229d539$var$lh(a), e = $4d82739dd229d539$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$dh(a, e, d);
        null !== b && ($4d82739dd229d539$var$mh(b, a, d, c), $4d82739dd229d539$var$eh(b, a, d));
    }
};
function $4d82739dd229d539$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$ph(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$Vg(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$nh.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4d82739dd229d539$var$jh;
    $4d82739dd229d539$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$Vg(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$nh.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $4d82739dd229d539$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$sh(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$sh(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$zh(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Ah(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Bh = $4d82739dd229d539$var$vh(!0), $4d82739dd229d539$var$Ch = $4d82739dd229d539$var$vh(!1), $4d82739dd229d539$var$Dh = {}, $4d82739dd229d539$var$Eh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh);
function $4d82739dd229d539$var$Hh(a) {
    if (a === $4d82739dd229d539$var$Dh) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$Ih(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Gh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, $4d82739dd229d539$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, b);
}
function $4d82739dd229d539$var$Jh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Gh);
}
function $4d82739dd229d539$var$Kh(a) {
    $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
    var b = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, c));
}
function $4d82739dd229d539$var$Lh(a) {
    $4d82739dd229d539$var$Fh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$Eh), $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh));
}
var $4d82739dd229d539$var$M = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nh = [];
function $4d82739dd229d539$var$Oh() {
    for(var a = 0; a < $4d82739dd229d539$var$Nh.length; a++)$4d82739dd229d539$var$Nh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Nh.length = 0;
}
var $4d82739dd229d539$var$Ph = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Qh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Rh = 0, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$P = null, $4d82739dd229d539$var$Sh = !1, $4d82739dd229d539$var$Th = !1, $4d82739dd229d539$var$Uh = 0, $4d82739dd229d539$var$Vh = 0;
function $4d82739dd229d539$var$Q() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Xh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Rh = f;
    $4d82739dd229d539$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Ph.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Yh : $4d82739dd229d539$var$Zh;
    a = c(d, e);
    if ($4d82739dd229d539$var$Th) {
        f = 0;
        do {
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$$h;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Th);
    }
    $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
    b = null !== $4d82739dd229d539$var$O && null !== $4d82739dd229d539$var$O.next;
    $4d82739dd229d539$var$Rh = 0;
    $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
    $4d82739dd229d539$var$Sh = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$bi() {
    var a = 0 !== $4d82739dd229d539$var$Uh;
    $4d82739dd229d539$var$Uh = 0;
    return a;
}
function $4d82739dd229d539$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$di() {
    if (null === $4d82739dd229d539$var$O) {
        var a = $4d82739dd229d539$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$O.next;
    var b = null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState : $4d82739dd229d539$var$P.next;
    if (null !== b) $4d82739dd229d539$var$P = b, $4d82739dd229d539$var$O = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$O = a;
        a = {
            memoizedState: $4d82739dd229d539$var$O.memoizedState,
            baseState: $4d82739dd229d539$var$O.baseState,
            baseQueue: $4d82739dd229d539$var$O.baseQueue,
            queue: $4d82739dd229d539$var$O.queue,
            next: null
        };
        null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    }
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$N.lanes |= m;
                $4d82739dd229d539$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$N.lanes |= f, $4d82739dd229d539$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$gi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$hi() {}
function $4d82739dd229d539$var$ii(a, b) {
    var c = $4d82739dd229d539$var$N, d = $4d82739dd229d539$var$di(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$Ug = !0);
    d = d.queue;
    $4d82739dd229d539$var$ji($4d82739dd229d539$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$P && $4d82739dd229d539$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
}
function $4d82739dd229d539$var$ki(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
    });
}
function $4d82739dd229d539$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$pi(a) {
    var b = $4d82739dd229d539$var$Zg(a, 1);
    null !== b && $4d82739dd229d539$var$mh(b, a, 1, -1);
}
function $4d82739dd229d539$var$qi(a) {
    var b = $4d82739dd229d539$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ri.bind(null, $4d82739dd229d539$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$si() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$ti(a, b, c, d) {
    var e = $4d82739dd229d539$var$ci();
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$ui(a, b, c, d) {
    var e = $4d82739dd229d539$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$O) {
        var g = $4d82739dd229d539$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Wh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$li(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, f, d);
}
function $4d82739dd229d539$var$vi(a, b) {
    return $4d82739dd229d539$var$ti(8390656, 8, a, b);
}
function $4d82739dd229d539$var$ji(a, b) {
    return $4d82739dd229d539$var$ui(2048, 8, a, b);
}
function $4d82739dd229d539$var$wi(a, b) {
    return $4d82739dd229d539$var$ui(4, 2, a, b);
}
function $4d82739dd229d539$var$xi(a, b) {
    return $4d82739dd229d539$var$ui(4, 4, a, b);
}
function $4d82739dd229d539$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$ui(4, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$Ai() {}
function $4d82739dd229d539$var$Bi(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Ci(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Di(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Rh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$Ug = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$N.lanes |= c, $4d82739dd229d539$var$hh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$Ei(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Qh.transition;
    $4d82739dd229d539$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Qh.transition = d;
    }
}
function $4d82739dd229d539$var$Fi() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, c);
    else if (c = $4d82739dd229d539$var$Yg(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$L();
        $4d82739dd229d539$var$mh(c, a, d, e);
        $4d82739dd229d539$var$Ji(c, b, d);
    }
}
function $4d82739dd229d539$var$ri(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$Yg(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$L(), $4d82739dd229d539$var$mh(c, a, d, e), $4d82739dd229d539$var$Ji(c, b, d));
    }
}
function $4d82739dd229d539$var$Hi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$N || null !== b && b === $4d82739dd229d539$var$N;
}
function $4d82739dd229d539$var$Ii(a, b) {
    $4d82739dd229d539$var$Th = $4d82739dd229d539$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$ai = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Q,
    useContext: $4d82739dd229d539$var$Q,
    useEffect: $4d82739dd229d539$var$Q,
    useImperativeHandle: $4d82739dd229d539$var$Q,
    useInsertionEffect: $4d82739dd229d539$var$Q,
    useLayoutEffect: $4d82739dd229d539$var$Q,
    useMemo: $4d82739dd229d539$var$Q,
    useReducer: $4d82739dd229d539$var$Q,
    useRef: $4d82739dd229d539$var$Q,
    useState: $4d82739dd229d539$var$Q,
    useDebugValue: $4d82739dd229d539$var$Q,
    useDeferredValue: $4d82739dd229d539$var$Q,
    useTransition: $4d82739dd229d539$var$Q,
    useMutableSource: $4d82739dd229d539$var$Q,
    useSyncExternalStore: $4d82739dd229d539$var$Q,
    useId: $4d82739dd229d539$var$Q,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Yh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ti(4194308, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$Gi.bind(null, $4d82739dd229d539$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$qi,
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$qi(!1), b = a[0];
        a = $4d82739dd229d539$var$Ei.bind(null, a[1]);
        $4d82739dd229d539$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$N, e = $4d82739dd229d539$var$ci();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$vi($4d82739dd229d539$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$ci(), b = $4d82739dd229d539$var$R.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Zh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$fi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$$h = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$gi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return null === $4d82739dd229d539$var$O ? b.memoizedState = a : $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Oi(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Pi || ($4d82739dd229d539$var$Pi = !0, $4d82739dd229d539$var$Qi = d);
        $4d82739dd229d539$var$Mi(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Ri(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Mi(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Si ? $4d82739dd229d539$var$Si = new Set([
            this
        ]) : $4d82739dd229d539$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$ch(-1, 1), b.tag = 2, $4d82739dd229d539$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Xi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$Ug = !1;
function $4d82739dd229d539$var$Yi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Ch(b, null, c, d) : $4d82739dd229d539$var$Bh(b, a.child, c, d);
}
function $4d82739dd229d539$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$Tg(b, e);
    d = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$cj(a, b, f, d, e);
        a = $4d82739dd229d539$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$Ug = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$$i(a, b, e);
        }
    }
    return $4d82739dd229d539$var$dj(a, b, c, d, e);
}
function $4d82739dd229d539$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj);
            $4d82739dd229d539$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= d;
    $4d82739dd229d539$var$Yi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$dj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$Tg(b, e);
    c = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$Tg(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$jj(a, b), $4d82739dd229d539$var$ph(b, c, d), $4d82739dd229d539$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$Vg(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$qh(b, g, d, l);
        $4d82739dd229d539$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof m && ($4d82739dd229d539$var$kh(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Vg(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$qh(b, g, d, k);
        $4d82739dd229d539$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof y && ($4d82739dd229d539$var$kh(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$kj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$kj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$$i(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Bh(b, a.child, null, f), b.child = $4d82739dd229d539$var$Bh(b, null, h, f)) : $4d82739dd229d539$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$Ih(a, b.containerInfo);
}
function $4d82739dd229d539$var$mj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Yi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$pj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$qj(g, d, 0, null), a = $4d82739dd229d539$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$oj(c), b.memoizedState = $4d82739dd229d539$var$nj, a) : $4d82739dd229d539$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$wh(h, f) : (f = $4d82739dd229d539$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$rj(a, b) {
    b = $4d82739dd229d539$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$tj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Bh(b, a.child, null, c);
    a = $4d82739dd229d539$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$oj(g);
        b.memoizedState = $4d82739dd229d539$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Li(f, d, void 0);
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$Ug || h) {
        d = $4d82739dd229d539$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$Zg(a, e), $4d82739dd229d539$var$mh(d, a, e, -1));
        }
        $4d82739dd229d539$var$uj();
        d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$Sg(a.return, b, c);
}
function $4d82739dd229d539$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Yi(a, b, d.children, c);
    d = $4d82739dd229d539$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$wj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$lj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Kh(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$pj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
                a = $4d82739dd229d539$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$ej(a, b, c);
    }
    return $4d82739dd229d539$var$$i(a, b, c);
}
var $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj, $4d82739dd229d539$var$Dj;
$4d82739dd229d539$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Bj = function() {};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Ej(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$Jh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Bj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Lh(b);
            var e = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
                $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$M.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$Bj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Ej(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Hj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$M.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$gj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Jj(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Lh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$M), null;
        case 4:
            return $4d82739dd229d539$var$Jh(), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Kj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Oj = !1;
function $4d82739dd229d539$var$Pj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Oj;
    $4d82739dd229d539$var$Oj = !1;
    return n;
}
function $4d82739dd229d539$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Xj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Xj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Yj = !1;
function $4d82739dd229d539$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$ak(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$ak(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Mj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Yj = !0;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Nj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Zj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Zj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Zj(a, b, c);
    }
}
function $4d82739dd229d539$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Lj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Yj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$ak(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$ek(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Qj(3, a, a.return), $4d82739dd229d539$var$Rj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Qj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            break;
        case 13:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$gk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$fk(a);
    }
}
function $4d82739dd229d539$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$jk(a, b, c);
}
function $4d82739dd229d539$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Kj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Kj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$kk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$kk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$jk(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Kj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$lk(a, b, c);
    }
}
function $4d82739dd229d539$var$lk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Sj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$hk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$mk = Math.ceil, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$pk = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$gj = 0, $4d82739dd229d539$var$fj = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$qk = null, $4d82739dd229d539$var$hh = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = 0, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$gk = 0, $4d82739dd229d539$var$Hj = Infinity, $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Pi = !1, $4d82739dd229d539$var$Qi = null, $4d82739dd229d539$var$Si = null, $4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = null, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, $4d82739dd229d539$var$Bk = -1, $4d82739dd229d539$var$Ck = 0;
function $4d82739dd229d539$var$L() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Bk ? $4d82739dd229d539$var$Bk : $4d82739dd229d539$var$Bk = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Ck && ($4d82739dd229d539$var$Ck = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Ck;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$mh(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$zk) throw $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$R) a === $4d82739dd229d539$var$R && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$rk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Ek(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Ek(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Fk.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Fk.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Gk(c, $4d82739dd229d539$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Hk(a, b) {
    $4d82739dd229d539$var$Bk = -1;
    $4d82739dd229d539$var$Ck = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Ik() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Jk(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Kk();
        if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Lk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Mk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Nk(a, h);
        }
        $4d82739dd229d539$var$Qg();
        $4d82739dd229d539$var$nk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Ok(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Pk(e) && (b = $4d82739dd229d539$var$Jk(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Ok(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$gk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Hk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Ok(a, b) {
    var c = $4d82739dd229d539$var$tk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Lk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Jk(a, b);
    2 !== a && (b = $4d82739dd229d539$var$uk, $4d82739dd229d539$var$uk = c, null !== b && $4d82739dd229d539$var$Gj(b));
    return a;
}
function $4d82739dd229d539$var$Gj(a) {
    null === $4d82739dd229d539$var$uk ? $4d82739dd229d539$var$uk = a : $4d82739dd229d539$var$uk.push.apply($4d82739dd229d539$var$uk, a);
}
function $4d82739dd229d539$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Dk(a, b) {
    b &= ~$4d82739dd229d539$var$sk;
    b &= ~$4d82739dd229d539$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Fk(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Ok(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, b), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Rk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Sk(a) {
    null !== $4d82739dd229d539$var$xk && 0 === $4d82739dd229d539$var$xk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$pk.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$pk.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Ij() {
    $4d82739dd229d539$var$gj = $4d82739dd229d539$var$fj.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$fj);
}
function $4d82739dd229d539$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$Jh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Oh();
                break;
            case 5:
                $4d82739dd229d539$var$Lh(d);
                break;
            case 4:
                $4d82739dd229d539$var$Jh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 10:
                $4d82739dd229d539$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Ij();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$R = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$wh(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$gj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$qk = null;
    $4d82739dd229d539$var$sk = $4d82739dd229d539$var$rk = $4d82739dd229d539$var$hh = 0;
    $4d82739dd229d539$var$uk = $4d82739dd229d539$var$tk = null;
    if (null !== $4d82739dd229d539$var$Wg) {
        for(b = 0; b < $4d82739dd229d539$var$Wg.length; b++)if (c = $4d82739dd229d539$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$Wg = null;
    }
    return a;
}
function $4d82739dd229d539$var$Nk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$Qg();
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
            if ($4d82739dd229d539$var$Sh) {
                for(var d = $4d82739dd229d539$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Sh = !1;
            }
            $4d82739dd229d539$var$Rh = 0;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            $4d82739dd229d539$var$ok.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$qk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Ti(f, l, b);
                            $4d82739dd229d539$var$uj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Wi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ki(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = [
                    f
                ] : $4d82739dd229d539$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Oi(f, k, b);
                            $4d82739dd229d539$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Ri(f, h, b);
                                $4d82739dd229d539$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Tk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Kk() {
    var a = $4d82739dd229d539$var$nk.current;
    $4d82739dd229d539$var$nk.current = $4d82739dd229d539$var$ai;
    return null === a ? $4d82739dd229d539$var$ai : a;
}
function $4d82739dd229d539$var$uj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$R || 0 === ($4d82739dd229d539$var$hh & 268435455) && 0 === ($4d82739dd229d539$var$rk & 268435455) || $4d82739dd229d539$var$Dk($4d82739dd229d539$var$R, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Jk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Kk();
    if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Lk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Uk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Nk(a, e);
    }
    $4d82739dd229d539$var$Qg();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$nk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$R = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Uk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Mk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Vk(a) {
    var b = $4d82739dd229d539$var$Wk(a.alternate, a, $4d82739dd229d539$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Tk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$ok.current = null;
}
function $4d82739dd229d539$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Fj(c, b, $4d82739dd229d539$var$gj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Qk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$pk.transition;
    try {
        $4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Xk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$pk.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Xk(a, b, c, d) {
    do $4d82739dd229d539$var$Ik();
    while (null !== $4d82739dd229d539$var$xk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$R && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$wk || ($4d82739dd229d539$var$wk = !0, $4d82739dd229d539$var$Gk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$pk.transition;
        $4d82739dd229d539$var$pk.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$ok.current = null;
        $4d82739dd229d539$var$Pj(a, c);
        $4d82739dd229d539$var$ek(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$ik(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$pk.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$wk && ($4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = a, $4d82739dd229d539$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Si = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Pi) throw $4d82739dd229d539$var$Pi = !1, a = $4d82739dd229d539$var$Qi, $4d82739dd229d539$var$Qi = null, a;
    0 !== ($4d82739dd229d539$var$yk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$zk++ : ($4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = a) : $4d82739dd229d539$var$zk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Ik() {
    if (null !== $4d82739dd229d539$var$xk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$yk), b = $4d82739dd229d539$var$pk.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$pk.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$xk) var d = !1;
            else {
                a = $4d82739dd229d539$var$xk;
                $4d82739dd229d539$var$xk = null;
                $4d82739dd229d539$var$yk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Tj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Rj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$pk.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Yk(a, b, c) {
    b = $4d82739dd229d539$var$Ki(c, b);
    b = $4d82739dd229d539$var$Oi(a, b, 1);
    a = $4d82739dd229d539$var$dh(a, b, 1);
    b = $4d82739dd229d539$var$L();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Ek(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(d))) {
                a = $4d82739dd229d539$var$Ki(c, a);
                a = $4d82739dd229d539$var$Ri(b, a, 1);
                b = $4d82739dd229d539$var$dh(b, a, 1);
                a = $4d82739dd229d539$var$L();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$R === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$gk ? $4d82739dd229d539$var$Lk(a, 0) : $4d82739dd229d539$var$sk |= c);
    $4d82739dd229d539$var$Ek(a, b);
}
function $4d82739dd229d539$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$L();
    a = $4d82739dd229d539$var$Zg(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Ek(a, c));
}
function $4d82739dd229d539$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Zk(a, c);
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Zk(a, c);
}
var $4d82739dd229d539$var$Wk;
$4d82739dd229d539$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$zj(a, b, c);
            $4d82739dd229d539$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$jj(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$Tg(b, c);
            e = $4d82739dd229d539$var$Xh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$ah(b), e.updater = $4d82739dd229d539$var$nh, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$rh(b, d, a, c), b = $4d82739dd229d539$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$$k(d);
                a = $4d82739dd229d539$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$aj(null, b, d, $4d82739dd229d539$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$lj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$bh(a, b);
                $4d82739dd229d539$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$$i(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Kh(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$hj(a, b), $4d82739dd229d539$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$pj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Bh(b, null, d, c) : $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$Zi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$Tg(b, c), e = $4d82739dd229d539$var$Vg(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Lg(d, b.pendingProps), e = $4d82739dd229d539$var$Lg(d.type, e), $4d82739dd229d539$var$aj(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$jj(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$Tg(b, c), $4d82739dd229d539$var$ph(b, d, e), $4d82739dd229d539$var$rh(b, d, e, c), $4d82739dd229d539$var$kj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$yj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$ej(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Gk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$al(a, b, c, d);
}
function $4d82739dd229d539$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$$k(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Ah(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Ah(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$qj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$xh(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$zh(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$ah(f);
    return a;
}
function $4d82739dd229d539$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$el(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$el(null);
    c = a.current;
    d = $4d82739dd229d539$var$L();
    e = $4d82739dd229d539$var$lh(c);
    f = $4d82739dd229d539$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$dh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Ek(a, d);
    return a;
}
function $4d82739dd229d539$var$gl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$L(), g = $4d82739dd229d539$var$lh(e);
    c = $4d82739dd229d539$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$dh(e, b, g);
    null !== a && ($4d82739dd229d539$var$mh(a, e, g, f), $4d82739dd229d539$var$eh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$jl(a, b) {
    $4d82739dd229d539$var$il(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$il(a, b);
}
function $4d82739dd229d539$var$kl() {
    return null;
}
var $4d82739dd229d539$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.render = $4d82739dd229d539$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$gl(a, b, null, null);
};
$4d82739dd229d539$var$nl.prototype.unmount = $4d82739dd229d539$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Sk(function() {
            $4d82739dd229d539$var$gl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$nl(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$ql() {}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$hl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$fl(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$ql);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$hl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$cl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$ql);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$gl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$hl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$gl(b, g, a, e);
    } else g = $4d82739dd229d539$var$rl(c, b, a, e, d);
    return $4d82739dd229d539$var$hl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Ek(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Sk(function() {
                var b = $4d82739dd229d539$var$Zg(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$L();
                    $4d82739dd229d539$var$mh(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$jl(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$jl(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$lh(a), c = $4d82739dd229d539$var$Zg(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(c, a, b, d);
        }
        $4d82739dd229d539$var$jl(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Sk;
var $4d82739dd229d539$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Rk
    ]
}, $4d82739dd229d539$var$ul = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$vl = {
    bundleType: $4d82739dd229d539$var$ul.bundleType,
    version: $4d82739dd229d539$var$ul.version,
    rendererPackageName: $4d82739dd229d539$var$ul.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$ul.findFiberByHostInstance || $4d82739dd229d539$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$wl.isDisabled && $4d82739dd229d539$var$wl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$wl.inject($4d82739dd229d539$var$vl), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$wl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$tl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$dl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Sk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$nl(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$pl(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$pl(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$sl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("33s19", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
"use strict";
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});




parcelRegister("avYnK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $7a7ba342c2fa1468$export$306c0aa65ff9ec16; }, function (v) { return $7a7ba342c2fa1468$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7a7ba342c2fa1468$export$306c0aa65ff9ec16;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $7a7ba342c2fa1468$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7a7ba342c2fa1468$var$k = "function" === typeof Object.is ? Object.is : $7a7ba342c2fa1468$var$h, $7a7ba342c2fa1468$var$l = $7fPBF.useState, $7a7ba342c2fa1468$var$m = $7fPBF.useEffect, $7a7ba342c2fa1468$var$n = $7fPBF.useLayoutEffect, $7a7ba342c2fa1468$var$p = $7fPBF.useDebugValue;
function $7a7ba342c2fa1468$var$q(a, b) {
    var d = b(), f = $7a7ba342c2fa1468$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $7a7ba342c2fa1468$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $7a7ba342c2fa1468$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $7a7ba342c2fa1468$var$m(function() {
        $7a7ba342c2fa1468$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $7a7ba342c2fa1468$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $7a7ba342c2fa1468$var$p(d);
    return d;
}
function $7a7ba342c2fa1468$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$7a7ba342c2fa1468$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $7a7ba342c2fa1468$var$t(a, b) {
    return b();
}
var $7a7ba342c2fa1468$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $7a7ba342c2fa1468$var$t : $7a7ba342c2fa1468$var$q;
$7a7ba342c2fa1468$export$306c0aa65ff9ec16 = void 0 !== $7fPBF.useSyncExternalStore ? $7fPBF.useSyncExternalStore : $7a7ba342c2fa1468$var$u;

});

parcelRegister("1gT5S", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $0ed2058c267a1c1d$export$bf730a2d8bf68b42; }, function (v) { return $0ed2058c267a1c1d$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ed2058c267a1c1d$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $hL6ll = parcelRequire("hL6ll");
function $0ed2058c267a1c1d$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0ed2058c267a1c1d$var$q = "function" === typeof Object.is ? Object.is : $0ed2058c267a1c1d$var$p, $0ed2058c267a1c1d$var$r = $hL6ll.useSyncExternalStore, $0ed2058c267a1c1d$var$t = $7fPBF.useRef, $0ed2058c267a1c1d$var$u = $7fPBF.useEffect, $0ed2058c267a1c1d$var$v = $7fPBF.useMemo, $0ed2058c267a1c1d$var$w = $7fPBF.useDebugValue;
$0ed2058c267a1c1d$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $0ed2058c267a1c1d$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $0ed2058c267a1c1d$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($0ed2058c267a1c1d$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $0ed2058c267a1c1d$var$r(a, c[0], c[1]);
    $0ed2058c267a1c1d$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $0ed2058c267a1c1d$var$w(d);
    return d;
};

});
parcelRegister("hL6ll", function(module, exports) {
"use strict";

module.exports = (parcelRequire("avYnK"));

});


parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
"use strict";
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});

parcelRegister("awO3n", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $7aa3b824230f3067$export$a7c73072b1a182ae; }, function (v) { return $7aa3b824230f3067$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $7aa3b824230f3067$export$9f27bc3417b4524d; }, function (v) { return $7aa3b824230f3067$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $7aa3b824230f3067$export$db77ccec0bb4ccac; }, function (v) { return $7aa3b824230f3067$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $7aa3b824230f3067$export$8392c0c9d3dcbd35; }, function (v) { return $7aa3b824230f3067$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7aa3b824230f3067$export$ffb0004e005737fa; }, function (v) { return $7aa3b824230f3067$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $7aa3b824230f3067$export$b624eff549462981; }, function (v) { return $7aa3b824230f3067$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $7aa3b824230f3067$export$7897aa7841a5380c; }, function (v) { return $7aa3b824230f3067$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $7aa3b824230f3067$export$602eac185826482c; }, function (v) { return $7aa3b824230f3067$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $7aa3b824230f3067$export$e2c29f18771995cb; }, function (v) { return $7aa3b824230f3067$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7aa3b824230f3067$export$5f8d39834fd61797; }, function (v) { return $7aa3b824230f3067$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7aa3b824230f3067$export$74bf444e3cd11ea5; }, function (v) { return $7aa3b824230f3067$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $7aa3b824230f3067$export$998bcd577473dd93; }, function (v) { return $7aa3b824230f3067$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $7aa3b824230f3067$export$92387174baf9b227; }, function (v) { return $7aa3b824230f3067$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $7aa3b824230f3067$export$ec112efeb987d9c6; }, function (v) { return $7aa3b824230f3067$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $7aa3b824230f3067$export$b706b080d889d2c9; }, function (v) { return $7aa3b824230f3067$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $7aa3b824230f3067$export$5be5a87408f70ddc; }, function (v) { return $7aa3b824230f3067$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $7aa3b824230f3067$export$45a5e7f76e0caa8d; }, function (v) { return $7aa3b824230f3067$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $7aa3b824230f3067$export$455c2e768291efa6; }, function (v) { return $7aa3b824230f3067$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $7aa3b824230f3067$export$9522e17588c12572; }, function (v) { return $7aa3b824230f3067$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $7aa3b824230f3067$export$2110ac352bb060b9; }, function (v) { return $7aa3b824230f3067$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $7aa3b824230f3067$export$56885ab8b9c456ab; }, function (v) { return $7aa3b824230f3067$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $7aa3b824230f3067$export$d927fcb6adf8f9de; }, function (v) { return $7aa3b824230f3067$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $7aa3b824230f3067$export$b82d16f27459e05a; }, function (v) { return $7aa3b824230f3067$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $7aa3b824230f3067$export$522c17b4f5e123e8; }, function (v) { return $7aa3b824230f3067$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $7aa3b824230f3067$export$1aabd8a0274ecfd6; }, function (v) { return $7aa3b824230f3067$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $7aa3b824230f3067$export$3d6c20d97e46b957; }, function (v) { return $7aa3b824230f3067$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $7aa3b824230f3067$export$9b621391a187a31a; }, function (v) { return $7aa3b824230f3067$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $7aa3b824230f3067$export$f5bbd400c2f4426f; }, function (v) { return $7aa3b824230f3067$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7aa3b824230f3067$export$a7c73072b1a182ae;
var $7aa3b824230f3067$export$9f27bc3417b4524d;
var $7aa3b824230f3067$export$db77ccec0bb4ccac;
var $7aa3b824230f3067$export$8392c0c9d3dcbd35;
var $7aa3b824230f3067$export$ffb0004e005737fa;
var $7aa3b824230f3067$export$b624eff549462981;
var $7aa3b824230f3067$export$7897aa7841a5380c;
var $7aa3b824230f3067$export$602eac185826482c;
var $7aa3b824230f3067$export$e2c29f18771995cb;
var $7aa3b824230f3067$export$5f8d39834fd61797;
var $7aa3b824230f3067$export$74bf444e3cd11ea5;
var $7aa3b824230f3067$export$998bcd577473dd93;
var $7aa3b824230f3067$export$92387174baf9b227;
var $7aa3b824230f3067$export$ec112efeb987d9c6;
var $7aa3b824230f3067$export$b706b080d889d2c9;
var $7aa3b824230f3067$export$5be5a87408f70ddc;
var $7aa3b824230f3067$export$45a5e7f76e0caa8d;
var $7aa3b824230f3067$export$455c2e768291efa6;
var $7aa3b824230f3067$export$9522e17588c12572;
var $7aa3b824230f3067$export$2110ac352bb060b9;
var $7aa3b824230f3067$export$56885ab8b9c456ab;
var $7aa3b824230f3067$export$d927fcb6adf8f9de;
var $7aa3b824230f3067$export$b82d16f27459e05a;
var $7aa3b824230f3067$export$522c17b4f5e123e8;
var $7aa3b824230f3067$export$1aabd8a0274ecfd6;
var $7aa3b824230f3067$export$3d6c20d97e46b957;
var $7aa3b824230f3067$export$9b621391a187a31a;
var $7aa3b824230f3067$export$f5bbd400c2f4426f;
"use strict";
var $7aa3b824230f3067$var$b = Symbol.for("react.element"), $7aa3b824230f3067$var$c = Symbol.for("react.portal"), $7aa3b824230f3067$var$d = Symbol.for("react.fragment"), $7aa3b824230f3067$var$e = Symbol.for("react.strict_mode"), $7aa3b824230f3067$var$f = Symbol.for("react.profiler"), $7aa3b824230f3067$var$g = Symbol.for("react.provider"), $7aa3b824230f3067$var$h = Symbol.for("react.context"), $7aa3b824230f3067$var$k = Symbol.for("react.server_context"), $7aa3b824230f3067$var$l = Symbol.for("react.forward_ref"), $7aa3b824230f3067$var$m = Symbol.for("react.suspense"), $7aa3b824230f3067$var$n = Symbol.for("react.suspense_list"), $7aa3b824230f3067$var$p = Symbol.for("react.memo"), $7aa3b824230f3067$var$q = Symbol.for("react.lazy"), $7aa3b824230f3067$var$t = Symbol.for("react.offscreen"), $7aa3b824230f3067$var$u;
$7aa3b824230f3067$var$u = Symbol.for("react.module.reference");
function $7aa3b824230f3067$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $7aa3b824230f3067$var$b:
                switch(a = a.type, a){
                    case $7aa3b824230f3067$var$d:
                    case $7aa3b824230f3067$var$f:
                    case $7aa3b824230f3067$var$e:
                    case $7aa3b824230f3067$var$m:
                    case $7aa3b824230f3067$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7aa3b824230f3067$var$k:
                            case $7aa3b824230f3067$var$h:
                            case $7aa3b824230f3067$var$l:
                            case $7aa3b824230f3067$var$q:
                            case $7aa3b824230f3067$var$p:
                            case $7aa3b824230f3067$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $7aa3b824230f3067$var$c:
                return r;
        }
    }
}
$7aa3b824230f3067$export$a7c73072b1a182ae = $7aa3b824230f3067$var$h;
$7aa3b824230f3067$export$9f27bc3417b4524d = $7aa3b824230f3067$var$g;
$7aa3b824230f3067$export$db77ccec0bb4ccac = $7aa3b824230f3067$var$b;
$7aa3b824230f3067$export$8392c0c9d3dcbd35 = $7aa3b824230f3067$var$l;
$7aa3b824230f3067$export$ffb0004e005737fa = $7aa3b824230f3067$var$d;
$7aa3b824230f3067$export$b624eff549462981 = $7aa3b824230f3067$var$q;
$7aa3b824230f3067$export$7897aa7841a5380c = $7aa3b824230f3067$var$p;
$7aa3b824230f3067$export$602eac185826482c = $7aa3b824230f3067$var$c;
$7aa3b824230f3067$export$e2c29f18771995cb = $7aa3b824230f3067$var$f;
$7aa3b824230f3067$export$5f8d39834fd61797 = $7aa3b824230f3067$var$e;
$7aa3b824230f3067$export$74bf444e3cd11ea5 = $7aa3b824230f3067$var$m;
$7aa3b824230f3067$export$998bcd577473dd93 = $7aa3b824230f3067$var$n;
$7aa3b824230f3067$export$92387174baf9b227 = function() {
    return !1;
};
$7aa3b824230f3067$export$ec112efeb987d9c6 = function() {
    return !1;
};
$7aa3b824230f3067$export$b706b080d889d2c9 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$h;
};
$7aa3b824230f3067$export$5be5a87408f70ddc = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$g;
};
$7aa3b824230f3067$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7aa3b824230f3067$var$b;
};
$7aa3b824230f3067$export$455c2e768291efa6 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$l;
};
$7aa3b824230f3067$export$9522e17588c12572 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$d;
};
$7aa3b824230f3067$export$2110ac352bb060b9 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$q;
};
$7aa3b824230f3067$export$56885ab8b9c456ab = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$p;
};
$7aa3b824230f3067$export$d927fcb6adf8f9de = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$c;
};
$7aa3b824230f3067$export$b82d16f27459e05a = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$f;
};
$7aa3b824230f3067$export$522c17b4f5e123e8 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$e;
};
$7aa3b824230f3067$export$1aabd8a0274ecfd6 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$m;
};
$7aa3b824230f3067$export$3d6c20d97e46b957 = function(a) {
    return $7aa3b824230f3067$var$v(a) === $7aa3b824230f3067$var$n;
};
$7aa3b824230f3067$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7aa3b824230f3067$var$d || a === $7aa3b824230f3067$var$f || a === $7aa3b824230f3067$var$e || a === $7aa3b824230f3067$var$m || a === $7aa3b824230f3067$var$n || a === $7aa3b824230f3067$var$t || "object" === typeof a && null !== a && (a.$$typeof === $7aa3b824230f3067$var$q || a.$$typeof === $7aa3b824230f3067$var$p || a.$$typeof === $7aa3b824230f3067$var$g || a.$$typeof === $7aa3b824230f3067$var$h || a.$$typeof === $7aa3b824230f3067$var$l || a.$$typeof === $7aa3b824230f3067$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$7aa3b824230f3067$export$f5bbd400c2f4426f = $7aa3b824230f3067$var$v;

});

parcelRegister("45Dw0", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /ios;fbsv\/([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("iD1YP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $4CvnI = parcelRequire("4CvnI");

var $fSa1C = parcelRequire("fSa1C");

var $93GTW = parcelRequire("93GTW");

var $8iB8h = parcelRequire("8iB8h");
var $d8fd67b3da2d43b6$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $93GTW.RawSha256();
        if (secret) {
            this.outer = new $93GTW.RawSha256();
            var inner = $d8fd67b3da2d43b6$var$bufferFromSecret(secret);
            var outer = new Uint8Array($fSa1C.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $fSa1C.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $8iB8h.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $8iB8h.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $4CvnI.__awaiter(this, void 0, void 0, function() {
            return $4CvnI.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $d8fd67b3da2d43b6$var$Sha256;
function $d8fd67b3da2d43b6$var$bufferFromSecret(secret) {
    var input = (0, $8iB8h.convertToBuffer)(secret);
    if (input.byteLength > $fSa1C.BLOCK_SIZE) {
        var bufferHash = new $93GTW.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($fSa1C.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("4CvnI", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $35d30dbd96269177$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $35d30dbd96269177$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $35d30dbd96269177$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $35d30dbd96269177$var$extendStatics = function(d, b) {
    $35d30dbd96269177$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $35d30dbd96269177$var$extendStatics(d, b);
};
function $35d30dbd96269177$export$a8ba968b8961cb8a(d, b) {
    $35d30dbd96269177$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $35d30dbd96269177$export$18ce0697a983be9b = function() {
    $35d30dbd96269177$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35d30dbd96269177$export$18ce0697a983be9b.apply(this, arguments);
};
function $35d30dbd96269177$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $35d30dbd96269177$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $35d30dbd96269177$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $35d30dbd96269177$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $35d30dbd96269177$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $35d30dbd96269177$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $35d30dbd96269177$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $35d30dbd96269177$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $35d30dbd96269177$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $35d30dbd96269177$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $35d30dbd96269177$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($35d30dbd96269177$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $35d30dbd96269177$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $35d30dbd96269177$export$10c90e4f7922046c(v) {
    return this instanceof $35d30dbd96269177$export$10c90e4f7922046c ? (this.v = v, this) : new $35d30dbd96269177$export$10c90e4f7922046c(v);
}
function $35d30dbd96269177$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $35d30dbd96269177$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $35d30dbd96269177$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $35d30dbd96269177$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $35d30dbd96269177$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $35d30dbd96269177$export$19a8beecd37a4c45 === "function" ? $35d30dbd96269177$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $35d30dbd96269177$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $35d30dbd96269177$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $35d30dbd96269177$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $35d30dbd96269177$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $35d30dbd96269177$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("fSa1C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("93GTW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $fSa1C = parcelRequire("fSa1C");
/**
 * @internal
 */ var $01b3b45334a47c4b$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($fSa1C.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $fSa1C.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $fSa1C.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $fSa1C.BLOCK_SIZE >= $fSa1C.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $fSa1C.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $fSa1C.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($fSa1C.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($fSa1C.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($fSa1C.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $fSa1C.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($fSa1C.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $01b3b45334a47c4b$var$RawSha256;

});

parcelRegister("8iB8h", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $kxwm7 = parcelRequire("kxwm7");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $kxwm7.convertToBuffer;
    }
});

var $iGC8M = parcelRequire("iGC8M");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $iGC8M.isEmptyData;
    }
});

var $c6Iyg = parcelRequire("c6Iyg");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $c6Iyg.numToUint8;
    }
});

var $kK97n = parcelRequire("kK97n");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $kK97n.uint32ArrayFrom;
    }
});

});
parcelRegister("kxwm7", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $ef3ffce0175112a7$require$Buffer = $bdjQ6.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $fHkZG = parcelRequire("fHkZG");
// Quick polyfill
var $ef3ffce0175112a7$var$fromUtf8 = typeof $ef3ffce0175112a7$require$Buffer !== "undefined" && $ef3ffce0175112a7$require$Buffer.from ? function(input) {
    return $ef3ffce0175112a7$require$Buffer.from(input, "utf8");
} : $fHkZG.fromUtf8;
function $ef3ffce0175112a7$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $ef3ffce0175112a7$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $ef3ffce0175112a7$var$convertToBuffer;

});
parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
var $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
var $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    var buf = $82a04c4ec6982288$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    var buf = $82a04c4ec6982288$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        var len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        var buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $82a04c4ec6982288$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case "ascii":
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case "base64":
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
"use strict";
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup["-".charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup["_".charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("fHkZG", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $b6db281eaac95c69$export$c7c5cef950a4d2fc; });

var $eS11n = parcelRequire("eS11n");

var $hIupL = parcelRequire("hIupL");
var $b6db281eaac95c69$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $hIupL.fromUtf8)(input) : (0, $eS11n.fromUtf8)(input);
};
var $b6db281eaac95c69$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $hIupL.toUtf8)(input) : (0, $eS11n.toUtf8)(input);
};

});
parcelRegister("eS11n", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $ad36e6a06ac20042$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $ad36e6a06ac20042$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $ad36e6a06ac20042$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $ad36e6a06ac20042$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("hIupL", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $ce5e236f17b919d1$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $ce5e236f17b919d1$export$b4b216764bb846eb; });
function $ce5e236f17b919d1$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $ce5e236f17b919d1$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("iGC8M", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $d9a9bc25be37fdd6$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $d9a9bc25be37fdd6$var$isEmptyData;

});

parcelRegister("c6Iyg", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $8d089a99d6083a5e$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $8d089a99d6083a5e$var$numToUint8;

});

parcelRegister("kK97n", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $f19f2d25d5214a83$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $f19f2d25d5214a83$var$uint32ArrayFrom;

});



parcelRegister("9GPfD", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $70dfcab4636df6ef$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function O(n) {
    g(n), n.p.forEach(S), n.p = null;
}
function g(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.O = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.g || b("ES5").S(e, r, o), o ? (i[Q].P && (O(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), O(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.g ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.O && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = "" + i[s];
                    0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.O && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.g = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? O(c) : g(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw O(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, g(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.g = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $70dfcab4636df6ef$export$2e2bcd8739ae039 = fn;

});

parcelRegister("2Bwgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $gewZ1 = parcelRequire("gewZ1");

var $hGNyO = parcelRequire("hGNyO");

var $97sHI = parcelRequire("97sHI");

var $7kpZw = parcelRequire("7kpZw");

var $7jp85 = parcelRequire("7jp85");

var $6z6zH = parcelRequire("6z6zH");

var $kJSTT = parcelRequire("kJSTT");

var $gIpnJ = parcelRequire("gIpnJ");

var $kOkmw = parcelRequire("kOkmw");
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $hGNyO.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $97sHI.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $hGNyO.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $97sHI.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $kJSTT.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kJSTT.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6z6zH.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var ResourceStore = function(_EventEmitter) {
    (0, $7jp85.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $hGNyO.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $7kpZw.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $97sHI.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $kJSTT.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kJSTT.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6z6zH.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $7jp85.default)(Translator, _EventEmitter);
    var _super = _createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $hGNyO.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $7kpZw.default)(_this));
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $7kpZw.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = baseLogger.create("translator");
        return _this;
    }
    (0, $97sHI.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $gewZ1.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
                        interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $hGNyO.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    (0, $97sHI.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $hGNyO.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = createRules();
    }
    (0, $97sHI.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $hGNyO.default)(this, Interpolator);
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $97sHI.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && options.hasOwnProperty(matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $kOkmw.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $hGNyO.default)(this, Formatter);
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, options), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, options));
                return function(val) {
                    return formatter.format(val, options.range || "day");
                };
            }),
            list: createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $97sHI.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $kJSTT.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kJSTT.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6z6zH.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $7jp85.default)(Connector, _EventEmitter);
    var _super = _createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $hGNyO.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $7kpZw.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $97sHI.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $gewZ1.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $gewZ1.default)(args[2]) === "object" || (0, $gewZ1.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, $gIpnJ.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $kJSTT.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $kJSTT.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6z6zH.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $7jp85.default)(I18n, _EventEmitter);
    var _super = _createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $hGNyO.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $7kpZw.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $7kpZw.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $6z6zH.default)(_this, (0, $7kpZw.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $97sHI.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $gewZ1.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $gIpnJ.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});
parcelRegister("gewZ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd1789e829559a04$export$2e2bcd8739ae039; });
function $bd1789e829559a04$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $bd1789e829559a04$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bd1789e829559a04$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("hGNyO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0ccd9c45306723$export$2e2bcd8739ae039; });
function $ce0ccd9c45306723$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("97sHI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a3b08850423fcc9$export$2e2bcd8739ae039; });

var $gYrn4 = parcelRequire("gYrn4");
function $6a3b08850423fcc9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $gYrn4.default)(descriptor.key), descriptor);
    }
}
function $6a3b08850423fcc9$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $6a3b08850423fcc9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6a3b08850423fcc9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});
parcelRegister("gYrn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5b77b4b54cf2068$export$2e2bcd8739ae039; });

var $gewZ1 = parcelRequire("gewZ1");

var $hR5nB = parcelRequire("hR5nB");
function $c5b77b4b54cf2068$export$2e2bcd8739ae039(arg) {
    var key = (0, $hR5nB.default)(arg, "string");
    return (0, $gewZ1.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("hR5nB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cffb8f3916f10362$export$2e2bcd8739ae039; });

var $gewZ1 = parcelRequire("gewZ1");
function $cffb8f3916f10362$export$2e2bcd8739ae039(input, hint) {
    if ((0, $gewZ1.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $gewZ1.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRegister("7kpZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $555e8ff7bf0a9fba$export$2e2bcd8739ae039; });
function $555e8ff7bf0a9fba$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("7jp85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $552dcceff88ce1d6$export$2e2bcd8739ae039; });

var $eD9jg = parcelRequire("eD9jg");
function $552dcceff88ce1d6$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $eD9jg.default)(subClass, superClass);
}

});
parcelRegister("eD9jg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa6bedefa5d40f0b$export$2e2bcd8739ae039; });
function $aa6bedefa5d40f0b$export$2e2bcd8739ae039(o, p) {
    $aa6bedefa5d40f0b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aa6bedefa5d40f0b$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("6z6zH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c7b1c9a8afe269d$export$2e2bcd8739ae039; });

var $gewZ1 = parcelRequire("gewZ1");

var $7kpZw = parcelRequire("7kpZw");
function $4c7b1c9a8afe269d$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $gewZ1.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $7kpZw.default)(self);
}

});

parcelRegister("kJSTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f19298b62e81891b$export$2e2bcd8739ae039; });
function $f19298b62e81891b$export$2e2bcd8739ae039(o) {
    $f19298b62e81891b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f19298b62e81891b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gIpnJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2b471b08da2d57f$export$2e2bcd8739ae039; });

var $gYrn4 = parcelRequire("gYrn4");
function $c2b471b08da2d57f$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $gYrn4.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("kOkmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f26845b2e8562399$export$2e2bcd8739ae039; });

var $hvaf2 = parcelRequire("hvaf2");

var $8TCJg = parcelRequire("8TCJg");

var $exjjw = parcelRequire("exjjw");

var $k7Sr3 = parcelRequire("k7Sr3");
function $f26845b2e8562399$export$2e2bcd8739ae039(arr) {
    return (0, $hvaf2.default)(arr) || (0, $8TCJg.default)(arr) || (0, $exjjw.default)(arr) || (0, $k7Sr3.default)();
}

});
parcelRegister("hvaf2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbdd46ae4fda2579$export$2e2bcd8739ae039; });
function $cbdd46ae4fda2579$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("8TCJg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a1808fb499ca83$export$2e2bcd8739ae039; });
function $67a1808fb499ca83$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("exjjw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a953211a5bcc9757$export$2e2bcd8739ae039; });

var $duAKK = parcelRequire("duAKK");
function $a953211a5bcc9757$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $duAKK.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $duAKK.default)(o, minLen);
}

});
parcelRegister("duAKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d2a960ffb40662d$export$2e2bcd8739ae039; });
function $9d2a960ffb40662d$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("k7Sr3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03c7fa93df23bd6b$export$2e2bcd8739ae039; });
function $03c7fa93df23bd6b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});
parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});



parcelRegister("8TZ45", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $67b2d4006f55ffba$export$a7c73072b1a182ae; }, function (v) { return $67b2d4006f55ffba$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $67b2d4006f55ffba$export$9f27bc3417b4524d; }, function (v) { return $67b2d4006f55ffba$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $67b2d4006f55ffba$export$db77ccec0bb4ccac; }, function (v) { return $67b2d4006f55ffba$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $67b2d4006f55ffba$export$8392c0c9d3dcbd35; }, function (v) { return $67b2d4006f55ffba$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $67b2d4006f55ffba$export$ffb0004e005737fa; }, function (v) { return $67b2d4006f55ffba$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $67b2d4006f55ffba$export$b624eff549462981; }, function (v) { return $67b2d4006f55ffba$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $67b2d4006f55ffba$export$7897aa7841a5380c; }, function (v) { return $67b2d4006f55ffba$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $67b2d4006f55ffba$export$602eac185826482c; }, function (v) { return $67b2d4006f55ffba$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $67b2d4006f55ffba$export$e2c29f18771995cb; }, function (v) { return $67b2d4006f55ffba$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $67b2d4006f55ffba$export$5f8d39834fd61797; }, function (v) { return $67b2d4006f55ffba$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $67b2d4006f55ffba$export$74bf444e3cd11ea5; }, function (v) { return $67b2d4006f55ffba$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $67b2d4006f55ffba$export$998bcd577473dd93; }, function (v) { return $67b2d4006f55ffba$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $67b2d4006f55ffba$export$92387174baf9b227; }, function (v) { return $67b2d4006f55ffba$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $67b2d4006f55ffba$export$ec112efeb987d9c6; }, function (v) { return $67b2d4006f55ffba$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $67b2d4006f55ffba$export$b706b080d889d2c9; }, function (v) { return $67b2d4006f55ffba$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $67b2d4006f55ffba$export$5be5a87408f70ddc; }, function (v) { return $67b2d4006f55ffba$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $67b2d4006f55ffba$export$45a5e7f76e0caa8d; }, function (v) { return $67b2d4006f55ffba$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $67b2d4006f55ffba$export$455c2e768291efa6; }, function (v) { return $67b2d4006f55ffba$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $67b2d4006f55ffba$export$9522e17588c12572; }, function (v) { return $67b2d4006f55ffba$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $67b2d4006f55ffba$export$2110ac352bb060b9; }, function (v) { return $67b2d4006f55ffba$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $67b2d4006f55ffba$export$56885ab8b9c456ab; }, function (v) { return $67b2d4006f55ffba$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $67b2d4006f55ffba$export$d927fcb6adf8f9de; }, function (v) { return $67b2d4006f55ffba$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $67b2d4006f55ffba$export$b82d16f27459e05a; }, function (v) { return $67b2d4006f55ffba$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $67b2d4006f55ffba$export$522c17b4f5e123e8; }, function (v) { return $67b2d4006f55ffba$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $67b2d4006f55ffba$export$1aabd8a0274ecfd6; }, function (v) { return $67b2d4006f55ffba$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $67b2d4006f55ffba$export$3d6c20d97e46b957; }, function (v) { return $67b2d4006f55ffba$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $67b2d4006f55ffba$export$9b621391a187a31a; }, function (v) { return $67b2d4006f55ffba$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $67b2d4006f55ffba$export$f5bbd400c2f4426f; }, function (v) { return $67b2d4006f55ffba$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $67b2d4006f55ffba$export$a7c73072b1a182ae;
var $67b2d4006f55ffba$export$9f27bc3417b4524d;
var $67b2d4006f55ffba$export$db77ccec0bb4ccac;
var $67b2d4006f55ffba$export$8392c0c9d3dcbd35;
var $67b2d4006f55ffba$export$ffb0004e005737fa;
var $67b2d4006f55ffba$export$b624eff549462981;
var $67b2d4006f55ffba$export$7897aa7841a5380c;
var $67b2d4006f55ffba$export$602eac185826482c;
var $67b2d4006f55ffba$export$e2c29f18771995cb;
var $67b2d4006f55ffba$export$5f8d39834fd61797;
var $67b2d4006f55ffba$export$74bf444e3cd11ea5;
var $67b2d4006f55ffba$export$998bcd577473dd93;
var $67b2d4006f55ffba$export$92387174baf9b227;
var $67b2d4006f55ffba$export$ec112efeb987d9c6;
var $67b2d4006f55ffba$export$b706b080d889d2c9;
var $67b2d4006f55ffba$export$5be5a87408f70ddc;
var $67b2d4006f55ffba$export$45a5e7f76e0caa8d;
var $67b2d4006f55ffba$export$455c2e768291efa6;
var $67b2d4006f55ffba$export$9522e17588c12572;
var $67b2d4006f55ffba$export$2110ac352bb060b9;
var $67b2d4006f55ffba$export$56885ab8b9c456ab;
var $67b2d4006f55ffba$export$d927fcb6adf8f9de;
var $67b2d4006f55ffba$export$b82d16f27459e05a;
var $67b2d4006f55ffba$export$522c17b4f5e123e8;
var $67b2d4006f55ffba$export$1aabd8a0274ecfd6;
var $67b2d4006f55ffba$export$3d6c20d97e46b957;
var $67b2d4006f55ffba$export$9b621391a187a31a;
var $67b2d4006f55ffba$export$f5bbd400c2f4426f;
"use strict";
var $67b2d4006f55ffba$var$b = Symbol.for("react.element"), $67b2d4006f55ffba$var$c = Symbol.for("react.portal"), $67b2d4006f55ffba$var$d = Symbol.for("react.fragment"), $67b2d4006f55ffba$var$e = Symbol.for("react.strict_mode"), $67b2d4006f55ffba$var$f = Symbol.for("react.profiler"), $67b2d4006f55ffba$var$g = Symbol.for("react.provider"), $67b2d4006f55ffba$var$h = Symbol.for("react.context"), $67b2d4006f55ffba$var$k = Symbol.for("react.server_context"), $67b2d4006f55ffba$var$l = Symbol.for("react.forward_ref"), $67b2d4006f55ffba$var$m = Symbol.for("react.suspense"), $67b2d4006f55ffba$var$n = Symbol.for("react.suspense_list"), $67b2d4006f55ffba$var$p = Symbol.for("react.memo"), $67b2d4006f55ffba$var$q = Symbol.for("react.lazy"), $67b2d4006f55ffba$var$t = Symbol.for("react.offscreen"), $67b2d4006f55ffba$var$u;
$67b2d4006f55ffba$var$u = Symbol.for("react.module.reference");
function $67b2d4006f55ffba$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $67b2d4006f55ffba$var$b:
                switch(a = a.type, a){
                    case $67b2d4006f55ffba$var$d:
                    case $67b2d4006f55ffba$var$f:
                    case $67b2d4006f55ffba$var$e:
                    case $67b2d4006f55ffba$var$m:
                    case $67b2d4006f55ffba$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $67b2d4006f55ffba$var$k:
                            case $67b2d4006f55ffba$var$h:
                            case $67b2d4006f55ffba$var$l:
                            case $67b2d4006f55ffba$var$q:
                            case $67b2d4006f55ffba$var$p:
                            case $67b2d4006f55ffba$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $67b2d4006f55ffba$var$c:
                return r;
        }
    }
}
$67b2d4006f55ffba$export$a7c73072b1a182ae = $67b2d4006f55ffba$var$h;
$67b2d4006f55ffba$export$9f27bc3417b4524d = $67b2d4006f55ffba$var$g;
$67b2d4006f55ffba$export$db77ccec0bb4ccac = $67b2d4006f55ffba$var$b;
$67b2d4006f55ffba$export$8392c0c9d3dcbd35 = $67b2d4006f55ffba$var$l;
$67b2d4006f55ffba$export$ffb0004e005737fa = $67b2d4006f55ffba$var$d;
$67b2d4006f55ffba$export$b624eff549462981 = $67b2d4006f55ffba$var$q;
$67b2d4006f55ffba$export$7897aa7841a5380c = $67b2d4006f55ffba$var$p;
$67b2d4006f55ffba$export$602eac185826482c = $67b2d4006f55ffba$var$c;
$67b2d4006f55ffba$export$e2c29f18771995cb = $67b2d4006f55ffba$var$f;
$67b2d4006f55ffba$export$5f8d39834fd61797 = $67b2d4006f55ffba$var$e;
$67b2d4006f55ffba$export$74bf444e3cd11ea5 = $67b2d4006f55ffba$var$m;
$67b2d4006f55ffba$export$998bcd577473dd93 = $67b2d4006f55ffba$var$n;
$67b2d4006f55ffba$export$92387174baf9b227 = function() {
    return !1;
};
$67b2d4006f55ffba$export$ec112efeb987d9c6 = function() {
    return !1;
};
$67b2d4006f55ffba$export$b706b080d889d2c9 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$h;
};
$67b2d4006f55ffba$export$5be5a87408f70ddc = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$g;
};
$67b2d4006f55ffba$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $67b2d4006f55ffba$var$b;
};
$67b2d4006f55ffba$export$455c2e768291efa6 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$l;
};
$67b2d4006f55ffba$export$9522e17588c12572 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$d;
};
$67b2d4006f55ffba$export$2110ac352bb060b9 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$q;
};
$67b2d4006f55ffba$export$56885ab8b9c456ab = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$p;
};
$67b2d4006f55ffba$export$d927fcb6adf8f9de = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$c;
};
$67b2d4006f55ffba$export$b82d16f27459e05a = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$f;
};
$67b2d4006f55ffba$export$522c17b4f5e123e8 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$e;
};
$67b2d4006f55ffba$export$1aabd8a0274ecfd6 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$m;
};
$67b2d4006f55ffba$export$3d6c20d97e46b957 = function(a) {
    return $67b2d4006f55ffba$var$v(a) === $67b2d4006f55ffba$var$n;
};
$67b2d4006f55ffba$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $67b2d4006f55ffba$var$d || a === $67b2d4006f55ffba$var$f || a === $67b2d4006f55ffba$var$e || a === $67b2d4006f55ffba$var$m || a === $67b2d4006f55ffba$var$n || a === $67b2d4006f55ffba$var$t || "object" === typeof a && null !== a && (a.$$typeof === $67b2d4006f55ffba$var$q || a.$$typeof === $67b2d4006f55ffba$var$p || a.$$typeof === $67b2d4006f55ffba$var$g || a.$$typeof === $67b2d4006f55ffba$var$h || a.$$typeof === $67b2d4006f55ffba$var$l || a.$$typeof === $67b2d4006f55ffba$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$67b2d4006f55ffba$export$f5bbd400c2f4426f = $67b2d4006f55ffba$var$v;

});

parcelRegister("ifbub", function(module, exports) {
"use strict";

});

parcelRegister("gSkQi", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eyN91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $89IRS = parcelRequire("89IRS");

var $3buYL = parcelRequire("3buYL");

var $5zYCF = parcelRequire("5zYCF");

var $bdV14 = parcelRequire("bdV14");
var $a99a5cbe9557244c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $5zYCF.RawSha256();
        if (secret) {
            this.outer = new $5zYCF.RawSha256();
            var inner = $a99a5cbe9557244c$var$bufferFromSecret(secret);
            var outer = new Uint8Array($3buYL.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $3buYL.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $bdV14.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $bdV14.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $89IRS.__awaiter)(this, void 0, void 0, function() {
            return (0, $89IRS.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $a99a5cbe9557244c$var$Sha256;
function $a99a5cbe9557244c$var$bufferFromSecret(secret) {
    var input = (0, $bdV14.convertToBuffer)(secret);
    if (input.byteLength > $3buYL.BLOCK_SIZE) {
        var bufferHash = new $5zYCF.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($3buYL.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("89IRS", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $5f01f7d5d046a198$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $5f01f7d5d046a198$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $5f01f7d5d046a198$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5f01f7d5d046a198$var$extendStatics = function(d, b) {
    $5f01f7d5d046a198$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5f01f7d5d046a198$var$extendStatics(d, b);
};
function $5f01f7d5d046a198$export$a8ba968b8961cb8a(d, b) {
    $5f01f7d5d046a198$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5f01f7d5d046a198$export$18ce0697a983be9b = function() {
    $5f01f7d5d046a198$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5f01f7d5d046a198$export$18ce0697a983be9b.apply(this, arguments);
};
function $5f01f7d5d046a198$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5f01f7d5d046a198$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5f01f7d5d046a198$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5f01f7d5d046a198$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5f01f7d5d046a198$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5f01f7d5d046a198$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5f01f7d5d046a198$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5f01f7d5d046a198$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5f01f7d5d046a198$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5f01f7d5d046a198$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5f01f7d5d046a198$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5f01f7d5d046a198$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5f01f7d5d046a198$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5f01f7d5d046a198$export$10c90e4f7922046c(v) {
    return this instanceof $5f01f7d5d046a198$export$10c90e4f7922046c ? (this.v = v, this) : new $5f01f7d5d046a198$export$10c90e4f7922046c(v);
}
function $5f01f7d5d046a198$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5f01f7d5d046a198$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5f01f7d5d046a198$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5f01f7d5d046a198$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5f01f7d5d046a198$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5f01f7d5d046a198$export$19a8beecd37a4c45 === "function" ? $5f01f7d5d046a198$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5f01f7d5d046a198$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5f01f7d5d046a198$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5f01f7d5d046a198$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5f01f7d5d046a198$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5f01f7d5d046a198$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("3buYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("5zYCF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $3buYL = parcelRequire("3buYL");
/**
 * @internal
 */ var $40ff3f0add742396$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($3buYL.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $3buYL.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $3buYL.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $3buYL.BLOCK_SIZE >= $3buYL.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $3buYL.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $3buYL.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($3buYL.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($3buYL.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($3buYL.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $3buYL.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($3buYL.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $40ff3f0add742396$var$RawSha256;

});

parcelRegister("bdV14", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $4SGUO = parcelRequire("4SGUO");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $4SGUO.convertToBuffer;
    }
});

var $jYHAu = parcelRequire("jYHAu");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $jYHAu.isEmptyData;
    }
});

var $d4Fss = parcelRequire("d4Fss");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $d4Fss.numToUint8;
    }
});

var $iwBrs = parcelRequire("iwBrs");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $iwBrs.uint32ArrayFrom;
    }
});

});
parcelRegister("4SGUO", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $38dd7eac1fe49a22$require$Buffer = $bdjQ6.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $fHkZG = parcelRequire("fHkZG");
// Quick polyfill
var $38dd7eac1fe49a22$var$fromUtf8 = typeof $38dd7eac1fe49a22$require$Buffer !== "undefined" && $38dd7eac1fe49a22$require$Buffer.from ? function(input) {
    return $38dd7eac1fe49a22$require$Buffer.from(input, "utf8");
} : $fHkZG.fromUtf8;
function $38dd7eac1fe49a22$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $38dd7eac1fe49a22$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $38dd7eac1fe49a22$var$convertToBuffer;

});

parcelRegister("jYHAu", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $e8b56e7f55c6e05b$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $e8b56e7f55c6e05b$var$isEmptyData;

});

parcelRegister("d4Fss", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $984bcec8eb18dc3f$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $984bcec8eb18dc3f$var$numToUint8;

});

parcelRegister("iwBrs", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $d7c84253d7f610e7$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $d7c84253d7f610e7$var$uint32ArrayFrom;

});



parcelRegister("adsYI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $770198bedaf11a30$export$2e2bcd8739ae039; });
function $770198bedaf11a30$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("aHcaX", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("4zsD0")), (parcelRequire("ap6ts")), (parcelRequire("1e5J8")), (parcelRequire("fVjUs")), (parcelRequire("dwzQz")), (parcelRequire("f7542")), (parcelRequire("isQGl")), (parcelRequire("5bak2")), (parcelRequire("8DYsI")), (parcelRequire("l853F")), (parcelRequire("elzly")), (parcelRequire("1cvAl")), (parcelRequire("eANE2")), (parcelRequire("SNrOX")), (parcelRequire("lEO8H")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")), (parcelRequire("3UTo5")), (parcelRequire("2KTJp")), (parcelRequire("1C52B")), (parcelRequire("7d4di")), (parcelRequire("50SJE")), (parcelRequire("6Uti1")), (parcelRequire("ciQLk")), (parcelRequire("dmbKg")), (parcelRequire("jnAoP")), (parcelRequire("hsEzO")), (parcelRequire("j1405")), (parcelRequire("iNfhv")), (parcelRequire("iPchK")), (parcelRequire("3N2Bz")), (parcelRequire("3ASIJ")), (parcelRequire("fpYAp")), (parcelRequire("fFZB9")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("hHf16", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("ifbub"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("4zsD0", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("ap6ts", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("1e5J8", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("fVjUs", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("dwzQz", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("f7542", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("isQGl", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("5bak2", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("8DYsI", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("5bak2")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("l853F", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("4zsD0")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("elzly", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("4zsD0")), (parcelRequire("l853F")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("1cvAl", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("4zsD0")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("eANE2", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("SNrOX", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("lEO8H", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("5bak2")), (parcelRequire("SNrOX")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("5Qstq", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("isQGl")), (parcelRequire("SNrOX")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("6tF5E", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("5Qstq")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("3UTo5", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("2KTJp", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("1C52B", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("7d4di", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("50SJE", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("6Uti1", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("ciQLk", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("dmbKg", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("jnAoP", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("hsEzO", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("j1405", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("iNfhv", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("fVjUs")), (parcelRequire("f7542")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("iPchK", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("fVjUs")), (parcelRequire("f7542")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("3N2Bz", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("fVjUs")), (parcelRequire("f7542")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("3ASIJ", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("fVjUs")), (parcelRequire("f7542")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("fpYAp", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("fVjUs")), (parcelRequire("f7542")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("fFZB9", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("hHf16")), (parcelRequire("fVjUs")), (parcelRequire("f7542")), (parcelRequire("5Qstq")), (parcelRequire("6tF5E")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


parcelRegister("lKcAt", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.4
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(""));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join("");
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join("");
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === "function" && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;

});

parcelRegister("gw5oW", function(module, exports) {

var $1DySm = parcelRequire("1DySm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1DySm.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRegister("1DySm", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `self`. */ var $13147c93e8511c05$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $13147c93e8511c05$var$root = $8X2yT || $13147c93e8511c05$var$freeSelf || Function("return this")();
module.exports = $13147c93e8511c05$var$root;

});
parcelRegister("8X2yT", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $6845d21fa7e75b3b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $6845d21fa7e75b3b$var$freeGlobal;

});



parcelRegister("9gBlp", function(module, exports) {

var $1DySm = parcelRequire("1DySm");

var $1Wbuo = parcelRequire("1Wbuo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1DySm.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1Wbuo;
module.exports = isBuffer;

});
parcelRegister("1Wbuo", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $16941ebaddae1967$var$stubFalse() {
    return false;
}
module.exports = $16941ebaddae1967$var$stubFalse;

});


parcelRegister("iU8uW", function(module, exports) {

var $8X2yT = parcelRequire("8X2yT");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8X2yT.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("5aIuV", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $KIXBU = parcelRequire("KIXBU");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $KIXBU.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $KIXBU.default)(Rgb, rgb, (0, $KIXBU.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $KIXBU.default)(Hsl, hsl, (0, $KIXBU.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("KIXBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08c72c3410432529$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $08c72c3410432529$export$8b58be045bf06082; });
function $08c72c3410432529$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $08c72c3410432529$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("ibKd5", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $d3dd196af489a174$export$2e2bcd8739ae039; });

var $qCBSE = parcelRequire("qCBSE");

var $1nfk9 = parcelRequire("1nfk9");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $qCBSE.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $qCBSE.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d3dd196af489a174$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $1nfk9.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("qCBSE", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $050060f58dcbf318$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan2", function () { return $050060f58dcbf318$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $050060f58dcbf318$export$50d414a77b60d802; });
$parcel$export(module.exports, "max", function () { return $050060f58dcbf318$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $050060f58dcbf318$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $050060f58dcbf318$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $050060f58dcbf318$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $050060f58dcbf318$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $050060f58dcbf318$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $050060f58dcbf318$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $050060f58dcbf318$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "acos", function () { return $050060f58dcbf318$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $050060f58dcbf318$export$41726bdb1fc63f; });
var $050060f58dcbf318$export$2335f513bbd82c6d = Math.abs;
var $050060f58dcbf318$export$b8b770ee6a0d9760 = Math.atan2;
var $050060f58dcbf318$export$50d414a77b60d802 = Math.cos;
var $050060f58dcbf318$export$8960430cfd85939f = Math.max;
var $050060f58dcbf318$export$96ec731ed4dcb222 = Math.min;
var $050060f58dcbf318$export$5de3937cb4b592ed = Math.sin;
var $050060f58dcbf318$export$eba8049fb5020b81 = Math.sqrt;
var $050060f58dcbf318$export$6c421550c66a327d = 1e-12;
var $050060f58dcbf318$export$18c7bea995a110f = Math.PI;
var $050060f58dcbf318$export$e51408a300e8929a = $050060f58dcbf318$export$18c7bea995a110f / 2;
var $050060f58dcbf318$export$a4b4b4d4d776fe92 = 2 * $050060f58dcbf318$export$18c7bea995a110f;
function $050060f58dcbf318$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $050060f58dcbf318$export$18c7bea995a110f : Math.acos(x);
}
function $050060f58dcbf318$export$41726bdb1fc63f(x) {
    return x >= 1 ? $050060f58dcbf318$export$e51408a300e8929a : x <= -1 ? -$050060f58dcbf318$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("1nfk9", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $1003d370640731b7$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $1003d370640731b7$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $1003d370640731b7$export$2e2bcd8739ae039; });
function $1003d370640731b7$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $1003d370640731b7$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$1003d370640731b7$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $1003d370640731b7$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $1003d370640731b7$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $1003d370640731b7$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $1003d370640731b7$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("b566B", function(module, exports) {

$parcel$export(module.exports, "rgb", function () { return rgb; });

var $iQqKm = parcelRequire("iQqKm");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $iQqKm.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $iQqKm.default)(Rgb, rgb, (0, $iQqKm.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $iQqKm.default)(Hsl, hsl, (0, $iQqKm.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("iQqKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db81d4a6a479d4f5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $db81d4a6a479d4f5$export$8b58be045bf06082; });
function $db81d4a6a479d4f5$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $db81d4a6a479d4f5$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("lCLl1", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $lHrSm = parcelRequire("lHrSm");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $lHrSm.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $lHrSm.default)(Rgb, rgb, (0, $lHrSm.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $lHrSm.default)(Hsl, hsl, (0, $lHrSm.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("lHrSm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcc33cafe20b2350$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $fcc33cafe20b2350$export$8b58be045bf06082; });
function $fcc33cafe20b2350$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $fcc33cafe20b2350$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("6G7B4", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $4dcc8ee6ba9d8d2a$export$2e2bcd8739ae039; });

var $jkgjv = parcelRequire("jkgjv");

var $cKhdt = parcelRequire("cKhdt");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $jkgjv.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $jkgjv.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4dcc8ee6ba9d8d2a$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $cKhdt.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("jkgjv", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $e11c8a1bbd2a9b67$export$6c421550c66a327d; });
const $e11c8a1bbd2a9b67$export$2335f513bbd82c6d = Math.abs;
const $e11c8a1bbd2a9b67$export$b8b770ee6a0d9760 = Math.atan2;
const $e11c8a1bbd2a9b67$export$50d414a77b60d802 = Math.cos;
const $e11c8a1bbd2a9b67$export$8960430cfd85939f = Math.max;
const $e11c8a1bbd2a9b67$export$96ec731ed4dcb222 = Math.min;
const $e11c8a1bbd2a9b67$export$5de3937cb4b592ed = Math.sin;
const $e11c8a1bbd2a9b67$export$eba8049fb5020b81 = Math.sqrt;
const $e11c8a1bbd2a9b67$export$6c421550c66a327d = 1e-12;
const $e11c8a1bbd2a9b67$export$18c7bea995a110f = Math.PI;
const $e11c8a1bbd2a9b67$export$e51408a300e8929a = $e11c8a1bbd2a9b67$export$18c7bea995a110f / 2;
const $e11c8a1bbd2a9b67$export$a4b4b4d4d776fe92 = 2 * $e11c8a1bbd2a9b67$export$18c7bea995a110f;
function $e11c8a1bbd2a9b67$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $e11c8a1bbd2a9b67$export$18c7bea995a110f : Math.acos(x);
}
function $e11c8a1bbd2a9b67$export$41726bdb1fc63f(x) {
    return x >= 1 ? $e11c8a1bbd2a9b67$export$e51408a300e8929a : x <= -1 ? -$e11c8a1bbd2a9b67$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("cKhdt", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $947722b74bcaf68e$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $947722b74bcaf68e$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $947722b74bcaf68e$export$2e2bcd8739ae039; });
function $947722b74bcaf68e$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $947722b74bcaf68e$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$947722b74bcaf68e$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $947722b74bcaf68e$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $947722b74bcaf68e$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $947722b74bcaf68e$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $947722b74bcaf68e$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("iKPNu", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$da74b3b51b478d4b$var$resolveConfig
});

const $da74b3b51b478d4b$var$_negateValue = /*#__PURE__*/ $da74b3b51b478d4b$var$_interopRequireDefault((parcelRequire("bzA4k")));

const $da74b3b51b478d4b$var$_corePluginList = /*#__PURE__*/ $da74b3b51b478d4b$var$_interopRequireDefault((parcelRequire("2OemL")));

const $da74b3b51b478d4b$var$_configurePlugins = /*#__PURE__*/ $da74b3b51b478d4b$var$_interopRequireDefault((parcelRequire("7I51t")));

const $da74b3b51b478d4b$var$_colors = /*#__PURE__*/ $da74b3b51b478d4b$var$_interopRequireDefault((parcelRequire("9se3A")));

var $8PBf1 = parcelRequire("8PBf1");

var $21KiV = parcelRequire("21KiV");

var $h453Q = parcelRequire("h453Q");

const $da74b3b51b478d4b$var$_isPlainObject = /*#__PURE__*/ $da74b3b51b478d4b$var$_interopRequireDefault((parcelRequire("9PvSn")));

var $6yIgu = parcelRequire("6yIgu");

var $c5ya5 = parcelRequire("c5ya5");

var $bv8pw = parcelRequire("bv8pw");

const $da74b3b51b478d4b$var$_toColorValue = /*#__PURE__*/ $da74b3b51b478d4b$var$_interopRequireDefault((parcelRequire("g4aHP")));
function $da74b3b51b478d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da74b3b51b478d4b$var$isFunction(input) {
    return typeof input === "function";
}
function $da74b3b51b478d4b$var$mergeWith(target, ...sources) {
    let customizer = sources.pop();
    for (let source of sources)for(let k in source){
        let merged = customizer(target[k], source[k]);
        if (merged === undefined) {
            if ((0, $da74b3b51b478d4b$var$_isPlainObject.default)(target[k]) && (0, $da74b3b51b478d4b$var$_isPlainObject.default)(source[k])) target[k] = $da74b3b51b478d4b$var$mergeWith({}, target[k], source[k], customizer);
            else target[k] = source[k];
        } else target[k] = merged;
    }
    return target;
}
const $da74b3b51b478d4b$var$configUtils = {
    colors: $da74b3b51b478d4b$var$_colors.default,
    negative (scale) {
        // TODO: Log that this function isn't really needed anymore?
        return Object.keys(scale).filter((key)=>scale[key] !== "0").reduce((negativeScale, key)=>{
            let negativeValue = (0, $da74b3b51b478d4b$var$_negateValue.default)(scale[key]);
            if (negativeValue !== undefined) negativeScale[`-${key}`] = negativeValue;
            return negativeScale;
        }, {});
    },
    breakpoints (screens) {
        return Object.keys(screens).filter((key)=>typeof screens[key] === "string").reduce((breakpoints, key)=>(0, $2qxEV._)((0, $9tqwB._)({}, breakpoints), {
                [`screen-${key}`]: screens[key]
            }), {});
    }
};
function $da74b3b51b478d4b$var$value(valueToResolve, ...args) {
    return $da74b3b51b478d4b$var$isFunction(valueToResolve) ? valueToResolve(...args) : valueToResolve;
}
function $da74b3b51b478d4b$var$collectExtends(items) {
    return items.reduce((merged, { extend: extend })=>{
        return $da74b3b51b478d4b$var$mergeWith(merged, extend, (mergedValue, extendValue)=>{
            if (mergedValue === undefined) return [
                extendValue
            ];
            if (Array.isArray(mergedValue)) return [
                extendValue,
                ...mergedValue
            ];
            return [
                extendValue,
                mergedValue
            ];
        });
    }, {});
}
function $da74b3b51b478d4b$var$mergeThemes(themes) {
    return (0, $2qxEV._)((0, $9tqwB._)({}, themes.reduce((merged, theme)=>(0, $8PBf1.defaults)(merged, theme), {})), {
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: $da74b3b51b478d4b$var$collectExtends(themes)
    });
}
function $da74b3b51b478d4b$var$mergeExtensionCustomizer(merged, value) {
    // When we have an array of objects, we do want to merge it
    if (Array.isArray(merged) && (0, $da74b3b51b478d4b$var$_isPlainObject.default)(merged[0])) return merged.concat(value);
    // When the incoming value is an array, and the existing config is an object, prepend the existing object
    if (Array.isArray(value) && (0, $da74b3b51b478d4b$var$_isPlainObject.default)(value[0]) && (0, $da74b3b51b478d4b$var$_isPlainObject.default)(merged)) return [
        merged,
        ...value
    ];
    // Override arrays (for example for font-families, box-shadows, ...)
    if (Array.isArray(value)) return value;
    // Execute default behaviour
    return undefined;
}
function $da74b3b51b478d4b$var$mergeExtensions(_param) {
    var { extend: extend } = _param, theme = (0, $bLhVg._)(_param, [
        "extend"
    ]);
    return $da74b3b51b478d4b$var$mergeWith(theme, extend, (themeValue, extensions)=>{
        // The `extend` property is an array, so we need to check if it contains any functions
        if (!$da74b3b51b478d4b$var$isFunction(themeValue) && !extensions.some($da74b3b51b478d4b$var$isFunction)) return $da74b3b51b478d4b$var$mergeWith({}, themeValue, ...extensions, $da74b3b51b478d4b$var$mergeExtensionCustomizer);
        return (resolveThemePath, utils)=>$da74b3b51b478d4b$var$mergeWith({}, ...[
                themeValue,
                ...extensions
            ].map((e)=>$da74b3b51b478d4b$var$value(e, resolveThemePath, utils)), $da74b3b51b478d4b$var$mergeExtensionCustomizer);
    });
}
/**
 *
 * @param {string} key
 * @return {Iterable<string[] & {alpha: string | undefined}>}
 */ function* $da74b3b51b478d4b$var$toPaths(key) {
    let path = (0, $21KiV.toPath)(key);
    if (path.length === 0) return;
    yield path;
    if (Array.isArray(key)) return;
    let pattern = /^(.*?)\s*\/\s*([^/]+)$/;
    let matches = key.match(pattern);
    if (matches !== null) {
        let [, prefix, alpha] = matches;
        let newPath = (0, $21KiV.toPath)(prefix);
        newPath.alpha = alpha;
        yield newPath;
    }
}
function $da74b3b51b478d4b$var$resolveFunctionKeys(object) {
    // theme('colors.red.500 / 0.5') -> ['colors', 'red', '500 / 0', '5]
    const resolvePath = (key, defaultValue)=>{
        for (const path of $da74b3b51b478d4b$var$toPaths(key)){
            let index = 0;
            let val = object;
            while(val !== undefined && val !== null && index < path.length){
                val = val[path[index++]];
                let shouldResolveAsFn = $da74b3b51b478d4b$var$isFunction(val) && (path.alpha === undefined || index <= path.length - 1);
                val = shouldResolveAsFn ? val(resolvePath, $da74b3b51b478d4b$var$configUtils) : val;
            }
            if (val !== undefined) {
                if (path.alpha !== undefined) {
                    let normalized = (0, $c5ya5.parseColorFormat)(val);
                    return (0, $bv8pw.withAlphaValue)(normalized, path.alpha, (0, $da74b3b51b478d4b$var$_toColorValue.default)(normalized));
                }
                if ((0, $da74b3b51b478d4b$var$_isPlainObject.default)(val)) return (0, $6yIgu.cloneDeep)(val);
                return val;
            }
        }
        return defaultValue;
    };
    Object.assign(resolvePath, (0, $9tqwB._)({
        theme: resolvePath
    }, $da74b3b51b478d4b$var$configUtils));
    return Object.keys(object).reduce((resolved, key)=>{
        resolved[key] = $da74b3b51b478d4b$var$isFunction(object[key]) ? object[key](resolvePath, $da74b3b51b478d4b$var$configUtils) : object[key];
        return resolved;
    }, {});
}
function $da74b3b51b478d4b$var$extractPluginConfigs(configs) {
    let allConfigs = [];
    configs.forEach((config)=>{
        allConfigs = [
            ...allConfigs,
            config
        ];
        var _config_plugins;
        const plugins = (_config_plugins = config === null || config === void 0 ? void 0 : config.plugins) !== null && _config_plugins !== void 0 ? _config_plugins : [];
        if (plugins.length === 0) return;
        plugins.forEach((plugin)=>{
            if (plugin.__isOptionsFunction) plugin = plugin();
            var _plugin_config;
            allConfigs = [
                ...allConfigs,
                ...$da74b3b51b478d4b$var$extractPluginConfigs([
                    (_plugin_config = plugin === null || plugin === void 0 ? void 0 : plugin.config) !== null && _plugin_config !== void 0 ? _plugin_config : {}
                ])
            ];
        });
    });
    return allConfigs;
}
function $da74b3b51b478d4b$var$resolveCorePlugins(corePluginConfigs) {
    const result = [
        ...corePluginConfigs
    ].reduceRight((resolved, corePluginConfig)=>{
        if ($da74b3b51b478d4b$var$isFunction(corePluginConfig)) return corePluginConfig({
            corePlugins: resolved
        });
        return (0, $da74b3b51b478d4b$var$_configurePlugins.default)(corePluginConfig, resolved);
    }, $da74b3b51b478d4b$var$_corePluginList.default);
    return result;
}
function $da74b3b51b478d4b$var$resolvePluginLists(pluginLists) {
    const result = [
        ...pluginLists
    ].reduceRight((resolved, pluginList)=>{
        return [
            ...resolved,
            ...pluginList
        ];
    }, []);
    return result;
}
function $da74b3b51b478d4b$var$resolveConfig(configs) {
    let allConfigs = [
        ...$da74b3b51b478d4b$var$extractPluginConfigs(configs),
        {
            prefix: "",
            important: false,
            separator: ":"
        }
    ];
    var _t_theme, _c_plugins;
    return (0, $h453Q.normalizeConfig)((0, $8PBf1.defaults)({
        theme: $da74b3b51b478d4b$var$resolveFunctionKeys($da74b3b51b478d4b$var$mergeExtensions($da74b3b51b478d4b$var$mergeThemes(allConfigs.map((t)=>{
            return (_t_theme = t === null || t === void 0 ? void 0 : t.theme) !== null && _t_theme !== void 0 ? _t_theme : {};
        })))),
        corePlugins: $da74b3b51b478d4b$var$resolveCorePlugins(allConfigs.map((c)=>c.corePlugins)),
        plugins: $da74b3b51b478d4b$var$resolvePluginLists(configs.map((c)=>{
            return (_c_plugins = c === null || c === void 0 ? void 0 : c.plugins) !== null && _c_plugins !== void 0 ? _c_plugins : [];
        }))
    }, ...allConfigs));
}

});
parcelRegister("9tqwB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e5b65c9cbae0db9$export$71511d61b312f219; });

var $cv8cX = parcelRequire("cv8cX");
function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cv8cX._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cv8cX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $919ebf39980bf8f3$export$71511d61b312f219; });
function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("2qxEV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1c481e73824c6361$export$71511d61b312f219; });
function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("bLhVg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8901fc92b5563702$export$71511d61b312f219; });

var $a7m7Z = parcelRequire("a7m7Z");
function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $a7m7Z._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("a7m7Z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $75dbb8f78ee65245$export$71511d61b312f219; });
function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("bzA4k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$86cef11920a0be14$var$negateValue
});
function $86cef11920a0be14$var$negateValue(value) {
    value = `${value}`;
    if (value === "0") return "0";
    // Flip sign of numbers
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(value)) return value.replace(/^[+-]?/, (sign)=>sign === "-" ? "" : "-");
    // What functions we support negating numeric values for
    // var() isn't inherently a numeric function but we support it anyway
    // The trigonometric functions are omitted because you'll need to use calc(…) with them _anyway_
    // to produce generally useful results and that will be covered already
    let numericFunctions = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
    ];
    for (const fn of numericFunctions){
        if (value.includes(`${fn}(`)) return `calc(${value} * -1)`;
    }
}

});

parcelRegister("2OemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$20bb651f2778f95d$var$_default
});
const $20bb651f2778f95d$var$_default = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "content"
];

});

parcelRegister("7I51t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$59d089e04f1eb1b6$var$_default
});
function $59d089e04f1eb1b6$var$_default(pluginConfig, plugins) {
    if (pluginConfig === undefined) return plugins;
    const pluginNames = Array.isArray(pluginConfig) ? pluginConfig : [
        ...new Set(plugins.filter((pluginName)=>{
            return pluginConfig !== false && pluginConfig[pluginName] !== false;
        }).concat(Object.keys(pluginConfig).filter((pluginName)=>{
            return pluginConfig[pluginName] !== false;
        })))
    ];
    return pluginNames;
}

});

parcelRegister("9se3A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$6e21a1f844b19538$var$_default
});

const $6e21a1f844b19538$var$_log = /*#__PURE__*/ $6e21a1f844b19538$var$_interopRequireDefault((parcelRequire("eIeZk")));
function $6e21a1f844b19538$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e21a1f844b19538$var$warn({ version: version, from: from, to: to }) {
    $6e21a1f844b19538$var$_log.default.warn(`${from}-color-renamed`, [
        `As of Tailwind CSS ${version}, \`${from}\` has been renamed to \`${to}\`.`,
        "Update your configuration file to silence this warning."
    ]);
}
const $6e21a1f844b19538$var$_default = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
    },
    gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
    },
    zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
    },
    neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
    },
    stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
    },
    red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
    },
    teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
    },
    cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
    },
    sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
    },
    rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
    },
    get lightBlue () {
        $6e21a1f844b19538$var$warn({
            version: "v2.2",
            from: "lightBlue",
            to: "sky"
        });
        return this.sky;
    },
    get warmGray () {
        $6e21a1f844b19538$var$warn({
            version: "v3.0",
            from: "warmGray",
            to: "stone"
        });
        return this.stone;
    },
    get trueGray () {
        $6e21a1f844b19538$var$warn({
            version: "v3.0",
            from: "trueGray",
            to: "neutral"
        });
        return this.neutral;
    },
    get coolGray () {
        $6e21a1f844b19538$var$warn({
            version: "v3.0",
            from: "coolGray",
            to: "gray"
        });
        return this.gray;
    },
    get blueGray () {
        $6e21a1f844b19538$var$warn({
            version: "v3.0",
            from: "blueGray",
            to: "slate"
        });
        return this.slate;
    }
};

});
parcelRegister("eIeZk", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ab60cd1181cb6226$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$ab60cd1181cb6226$var$_export(module.exports, {
    dim: ()=>$ab60cd1181cb6226$var$dim,
    default: ()=>$ab60cd1181cb6226$var$_default
});

const $ab60cd1181cb6226$var$_picocolors = /*#__PURE__*/ $ab60cd1181cb6226$var$_interopRequireDefault((parcelRequire("9EG5I")));
function $ab60cd1181cb6226$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $ab60cd1181cb6226$var$alreadyShown = new Set();
function $ab60cd1181cb6226$var$log(type, messages, key) {
    typeof $4ZL0H !== "undefined" && undefined;
    if (key && $ab60cd1181cb6226$var$alreadyShown.has(key)) return;
    if (key) $ab60cd1181cb6226$var$alreadyShown.add(key);
    console.warn("");
    messages.forEach((message)=>console.warn(type, "-", message));
}
function $ab60cd1181cb6226$var$dim(input) {
    return $ab60cd1181cb6226$var$_picocolors.default.dim(input);
}
const $ab60cd1181cb6226$var$_default = {
    info (key, messages) {
        $ab60cd1181cb6226$var$log($ab60cd1181cb6226$var$_picocolors.default.bold($ab60cd1181cb6226$var$_picocolors.default.cyan("info")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    warn (key, messages) {
        $ab60cd1181cb6226$var$log($ab60cd1181cb6226$var$_picocolors.default.bold($ab60cd1181cb6226$var$_picocolors.default.yellow("warn")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    },
    risk (key, messages) {
        $ab60cd1181cb6226$var$log($ab60cd1181cb6226$var$_picocolors.default.bold($ab60cd1181cb6226$var$_picocolors.default.magenta("risk")), ...Array.isArray(key) ? [
            key
        ] : [
            messages,
            key
        ]);
    }
};

});
parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = "browser";
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ""; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3a3153321729209f$var$process.cwd = function() {
    return "/";
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("9EG5I", function(module, exports) {
var $70787feb5293993e$var$x = String;
var $70787feb5293993e$var$create = function() {
    return {
        isColorSupported: false,
        reset: $70787feb5293993e$var$x,
        bold: $70787feb5293993e$var$x,
        dim: $70787feb5293993e$var$x,
        italic: $70787feb5293993e$var$x,
        underline: $70787feb5293993e$var$x,
        inverse: $70787feb5293993e$var$x,
        hidden: $70787feb5293993e$var$x,
        strikethrough: $70787feb5293993e$var$x,
        black: $70787feb5293993e$var$x,
        red: $70787feb5293993e$var$x,
        green: $70787feb5293993e$var$x,
        yellow: $70787feb5293993e$var$x,
        blue: $70787feb5293993e$var$x,
        magenta: $70787feb5293993e$var$x,
        cyan: $70787feb5293993e$var$x,
        white: $70787feb5293993e$var$x,
        gray: $70787feb5293993e$var$x,
        bgBlack: $70787feb5293993e$var$x,
        bgRed: $70787feb5293993e$var$x,
        bgGreen: $70787feb5293993e$var$x,
        bgYellow: $70787feb5293993e$var$x,
        bgBlue: $70787feb5293993e$var$x,
        bgMagenta: $70787feb5293993e$var$x,
        bgCyan: $70787feb5293993e$var$x,
        bgWhite: $70787feb5293993e$var$x,
        blackBright: $70787feb5293993e$var$x,
        redBright: $70787feb5293993e$var$x,
        greenBright: $70787feb5293993e$var$x,
        yellowBright: $70787feb5293993e$var$x,
        blueBright: $70787feb5293993e$var$x,
        magentaBright: $70787feb5293993e$var$x,
        cyanBright: $70787feb5293993e$var$x,
        whiteBright: $70787feb5293993e$var$x,
        bgBlackBright: $70787feb5293993e$var$x,
        bgRedBright: $70787feb5293993e$var$x,
        bgGreenBright: $70787feb5293993e$var$x,
        bgYellowBright: $70787feb5293993e$var$x,
        bgBlueBright: $70787feb5293993e$var$x,
        bgMagentaBright: $70787feb5293993e$var$x,
        bgCyanBright: $70787feb5293993e$var$x,
        bgWhiteBright: $70787feb5293993e$var$x
    };
};
module.exports = $70787feb5293993e$var$create();
module.exports.createColors = $70787feb5293993e$var$create;

});



parcelRegister("8PBf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "defaults", {
    enumerable: true,
    get: ()=>$66dff9829d6be6f9$var$defaults
});
function $66dff9829d6be6f9$var$defaults(target, ...sources) {
    for (let source of sources){
        for(let k in source){
            var _target_hasOwnProperty;
            if (!(target === null || target === void 0 ? void 0 : (_target_hasOwnProperty = target.hasOwnProperty) === null || _target_hasOwnProperty === void 0 ? void 0 : _target_hasOwnProperty.call(target, k))) target[k] = source[k];
        }
        for (let k1 of Object.getOwnPropertySymbols(source)){
            var _target_hasOwnProperty1;
            if (!(target === null || target === void 0 ? void 0 : (_target_hasOwnProperty1 = target.hasOwnProperty) === null || _target_hasOwnProperty1 === void 0 ? void 0 : _target_hasOwnProperty1.call(target, k1))) target[k1] = source[k1];
        }
    }
    return target;
}

});

parcelRegister("21KiV", function(module, exports) {
/**
 * Parse a path string into an array of path segments.
 *
 * Square bracket notation `a[b]` may be used to "escape" dots that would otherwise be interpreted as path separators.
 *
 * Example:
 * a -> ['a']
 * a.b.c -> ['a', 'b', 'c']
 * a[b].c -> ['a', 'b', 'c']
 * a[b.c].e.f -> ['a', 'b.c', 'e', 'f']
 * a[b][c][d] -> ['a', 'b', 'c', 'd']
 *
 * @param {string|string[]} path
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "toPath", {
    enumerable: true,
    get: ()=>$179f97d066c242ec$var$toPath
});
function $179f97d066c242ec$var$toPath(path) {
    if (Array.isArray(path)) return path;
    let openBrackets = path.split("[").length - 1;
    let closedBrackets = path.split("]").length - 1;
    if (openBrackets !== closedBrackets) throw new Error(`Path is invalid. Has unbalanced brackets: ${path}`);
    return path.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
}

});

parcelRegister("h453Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "normalizeConfig", {
    enumerable: true,
    get: ()=>$c6c6bc61f7727657$var$normalizeConfig
});

var $avdXZ = parcelRequire("avdXZ");

const $c6c6bc61f7727657$var$_log = /*#__PURE__*/ $c6c6bc61f7727657$var$_interopRequireWildcard((parcelRequire("eIeZk")));
function $c6c6bc61f7727657$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c6c6bc61f7727657$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c6c6bc61f7727657$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c6c6bc61f7727657$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c6c6bc61f7727657$var$normalizeConfig(config) {
    // Quick structure validation
    /**
   * type FilePath = string
   * type RawFile = { raw: string, extension?: string }
   * type ExtractorFn = (content: string) => Array<string>
   * type TransformerFn = (content: string) => string
   *
   * type Content =
   *   | Array<FilePath | RawFile>
   *   | {
   *       files: Array<FilePath | RawFile>,
   *       extract?: ExtractorFn | { [extension: string]: ExtractorFn }
   *       transform?: TransformerFn | { [extension: string]: TransformerFn }
   *   }
   */ let valid = (()=>{
        // `config.purge` should not exist anymore
        if (config.purge) return false;
        // `config.content` should exist
        if (!config.content) return false;
        // `config.content` should be an object or an array
        if (!Array.isArray(config.content) && !(typeof config.content === "object" && config.content !== null)) return false;
        // When `config.content` is an array, it should consist of FilePaths or RawFiles
        if (Array.isArray(config.content)) return config.content.every((path)=>{
            // `path` can be a string
            if (typeof path === "string") return true;
            // `path` can be an object { raw: string, extension?: string }
            // `raw` must be a string
            if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== "string") return false;
            // `extension` (if provided) should also be a string
            if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== "string") return false;
            return true;
        });
        // When `config.content` is an object
        if (typeof config.content === "object" && config.content !== null) {
            // Only `files`, `relative`, `extract`, and `transform` can exist in `config.content`
            if (Object.keys(config.content).some((key)=>![
                    "files",
                    "relative",
                    "extract",
                    "transform"
                ].includes(key))) return false;
            // `config.content.files` should exist of FilePaths or RawFiles
            if (Array.isArray(config.content.files)) {
                if (!config.content.files.every((path)=>{
                    // `path` can be a string
                    if (typeof path === "string") return true;
                    // `path` can be an object { raw: string, extension?: string }
                    // `raw` must be a string
                    if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== "string") return false;
                    // `extension` (if provided) should also be a string
                    if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== "string") return false;
                    return true;
                })) return false;
                // `config.content.extract` is optional, and can be a Function or a Record<String, Function>
                if (typeof config.content.extract === "object") for (let value of Object.values(config.content.extract)){
                    if (typeof value !== "function") return false;
                }
                else if (!(config.content.extract === undefined || typeof config.content.extract === "function")) return false;
                // `config.content.transform` is optional, and can be a Function or a Record<String, Function>
                if (typeof config.content.transform === "object") for (let value1 of Object.values(config.content.transform)){
                    if (typeof value1 !== "function") return false;
                }
                else if (!(config.content.transform === undefined || typeof config.content.transform === "function")) return false;
                // `config.content.relative` is optional and can be a boolean
                if (typeof config.content.relative !== "boolean" && typeof config.content.relative !== "undefined") return false;
            }
            return true;
        }
        return false;
    })();
    if (!valid) $c6c6bc61f7727657$var$_log.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]);
    // Normalize the `safelist`
    config.safelist = (()=>{
        var _purge_options;
        let { content: content, purge: purge, safelist: safelist } = config;
        if (Array.isArray(safelist)) return safelist;
        if (Array.isArray(content === null || content === void 0 ? void 0 : content.safelist)) return content.safelist;
        if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.safelist)) return purge.safelist;
        if (Array.isArray(purge === null || purge === void 0 ? void 0 : (_purge_options = purge.options) === null || _purge_options === void 0 ? void 0 : _purge_options.safelist)) return purge.options.safelist;
        return [];
    })();
    // Normalize the `blocklist`
    config.blocklist = (()=>{
        let { blocklist: blocklist } = config;
        if (Array.isArray(blocklist)) {
            if (blocklist.every((item)=>typeof item === "string")) return blocklist;
            $c6c6bc61f7727657$var$_log.default.warn("blocklist-invalid", [
                "The `blocklist` option must be an array of strings.",
                "https://tailwindcss.com/docs/content-configuration#discarding-classes"
            ]);
        }
        return [];
    })();
    // Normalize prefix option
    if (typeof config.prefix === "function") {
        $c6c6bc61f7727657$var$_log.default.warn("prefix-function", [
            "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
            "Update `prefix` in your configuration to be a string to eliminate this warning.",
            "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]);
        config.prefix = "";
    } else {
        var _config_prefix;
        config.prefix = (_config_prefix = config.prefix) !== null && _config_prefix !== void 0 ? _config_prefix : "";
    }
    // Normalize the `content`
    config.content = {
        relative: (()=>{
            let { content: content } = config;
            if (content === null || content === void 0 ? void 0 : content.relative) return content.relative;
            return (0, $avdXZ.flagEnabled)(config, "relativeContentPathsByDefault");
        })(),
        files: (()=>{
            let { content: content, purge: purge } = config;
            if (Array.isArray(purge)) return purge;
            if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.content)) return purge.content;
            if (Array.isArray(content)) return content;
            if (Array.isArray(content === null || content === void 0 ? void 0 : content.content)) return content.content;
            if (Array.isArray(content === null || content === void 0 ? void 0 : content.files)) return content.files;
            return [];
        })(),
        extract: (()=>{
            let extract = (()=>{
                var _config_purge, _config_content, _config_purge1, _config_purge_extract, _config_content1, _config_content_extract, _config_purge2, _config_purge_options, _config_content2, _config_content_options;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : _config_purge.extract) return config.purge.extract;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : _config_content.extract) return config.content.extract;
                if ((_config_purge1 = config.purge) === null || _config_purge1 === void 0 ? void 0 : (_config_purge_extract = _config_purge1.extract) === null || _config_purge_extract === void 0 ? void 0 : _config_purge_extract.DEFAULT) return config.purge.extract.DEFAULT;
                if ((_config_content1 = config.content) === null || _config_content1 === void 0 ? void 0 : (_config_content_extract = _config_content1.extract) === null || _config_content_extract === void 0 ? void 0 : _config_content_extract.DEFAULT) return config.content.extract.DEFAULT;
                if ((_config_purge2 = config.purge) === null || _config_purge2 === void 0 ? void 0 : (_config_purge_options = _config_purge2.options) === null || _config_purge_options === void 0 ? void 0 : _config_purge_options.extractors) return config.purge.options.extractors;
                if ((_config_content2 = config.content) === null || _config_content2 === void 0 ? void 0 : (_config_content_options = _config_content2.options) === null || _config_content_options === void 0 ? void 0 : _config_content_options.extractors) return config.content.options.extractors;
                return {};
            })();
            let extractors = {};
            let defaultExtractor = (()=>{
                var _config_purge, _config_purge_options, _config_content, _config_content_options;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : (_config_purge_options = _config_purge.options) === null || _config_purge_options === void 0 ? void 0 : _config_purge_options.defaultExtractor) return config.purge.options.defaultExtractor;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : (_config_content_options = _config_content.options) === null || _config_content_options === void 0 ? void 0 : _config_content_options.defaultExtractor) return config.content.options.defaultExtractor;
                return undefined;
            })();
            if (defaultExtractor !== undefined) extractors.DEFAULT = defaultExtractor;
            // Functions
            if (typeof extract === "function") extractors.DEFAULT = extract;
            else if (Array.isArray(extract)) {
                for (let { extensions: extensions, extractor: extractor } of extract !== null && extract !== void 0 ? extract : [])for (let extension of extensions)extractors[extension] = extractor;
            } else if (typeof extract === "object" && extract !== null) Object.assign(extractors, extract);
            return extractors;
        })(),
        transform: (()=>{
            let transform = (()=>{
                var _config_purge, _config_content, _config_purge1, _config_purge_transform, _config_content1, _config_content_transform;
                if ((_config_purge = config.purge) === null || _config_purge === void 0 ? void 0 : _config_purge.transform) return config.purge.transform;
                if ((_config_content = config.content) === null || _config_content === void 0 ? void 0 : _config_content.transform) return config.content.transform;
                if ((_config_purge1 = config.purge) === null || _config_purge1 === void 0 ? void 0 : (_config_purge_transform = _config_purge1.transform) === null || _config_purge_transform === void 0 ? void 0 : _config_purge_transform.DEFAULT) return config.purge.transform.DEFAULT;
                if ((_config_content1 = config.content) === null || _config_content1 === void 0 ? void 0 : (_config_content_transform = _config_content1.transform) === null || _config_content_transform === void 0 ? void 0 : _config_content_transform.DEFAULT) return config.content.transform.DEFAULT;
                return {};
            })();
            let transformers = {};
            if (typeof transform === "function") transformers.DEFAULT = transform;
            if (typeof transform === "object" && transform !== null) Object.assign(transformers, transform);
            return transformers;
        })()
    };
    // Validate globs to prevent bogus globs.
    // E.g.: `./src/*.{html}` is invalid, the `{html}` should just be `html`
    for (let file of config.content.files)if (typeof file === "string" && /{([^,]*?)}/g.test(file)) {
        $c6c6bc61f7727657$var$_log.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, $c6c6bc61f7727657$var$_log.dim)(file)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, $c6c6bc61f7727657$var$_log.dim)(file.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
    }
    return config;
}

});
parcelRegister("avdXZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $7a57a21ea5ac2d13$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$7a57a21ea5ac2d13$var$_export(module.exports, {
    flagEnabled: ()=>$7a57a21ea5ac2d13$var$flagEnabled,
    issueFlagNotices: ()=>$7a57a21ea5ac2d13$var$issueFlagNotices,
    default: ()=>$7a57a21ea5ac2d13$var$_default
});

const $7a57a21ea5ac2d13$var$_picocolors = /*#__PURE__*/ $7a57a21ea5ac2d13$var$_interopRequireDefault((parcelRequire("9EG5I")));

const $7a57a21ea5ac2d13$var$_log = /*#__PURE__*/ $7a57a21ea5ac2d13$var$_interopRequireDefault((parcelRequire("eIeZk")));

var $5Mhtp = parcelRequire("5Mhtp");
function $7a57a21ea5ac2d13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $7a57a21ea5ac2d13$var$defaults = {
    optimizeUniversalDefaults: false,
    generalizedModifiers: true,
    get disableColorOpacityUtilitiesByDefault () {
        return $5Mhtp.env.OXIDE;
    },
    get relativeContentPathsByDefault () {
        return $5Mhtp.env.OXIDE;
    }
};
let $7a57a21ea5ac2d13$var$featureFlags = {
    future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
    ],
    experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
    ]
};
function $7a57a21ea5ac2d13$var$flagEnabled(config, flag) {
    if ($7a57a21ea5ac2d13$var$featureFlags.future.includes(flag)) {
        var _config_future;
        var _config_future_flag, _ref;
        return config.future === "all" || ((_ref = (_config_future_flag = config === null || config === void 0 ? void 0 : (_config_future = config.future) === null || _config_future === void 0 ? void 0 : _config_future[flag]) !== null && _config_future_flag !== void 0 ? _config_future_flag : $7a57a21ea5ac2d13$var$defaults[flag]) !== null && _ref !== void 0 ? _ref : false);
    }
    if ($7a57a21ea5ac2d13$var$featureFlags.experimental.includes(flag)) {
        var _config_experimental;
        var _config_experimental_flag, _ref1;
        return config.experimental === "all" || ((_ref1 = (_config_experimental_flag = config === null || config === void 0 ? void 0 : (_config_experimental = config.experimental) === null || _config_experimental === void 0 ? void 0 : _config_experimental[flag]) !== null && _config_experimental_flag !== void 0 ? _config_experimental_flag : $7a57a21ea5ac2d13$var$defaults[flag]) !== null && _ref1 !== void 0 ? _ref1 : false);
    }
    return false;
}
function $7a57a21ea5ac2d13$var$experimentalFlagsEnabled(config) {
    if (config.experimental === "all") return $7a57a21ea5ac2d13$var$featureFlags.experimental;
    var _config_experimental;
    return Object.keys((_config_experimental = config === null || config === void 0 ? void 0 : config.experimental) !== null && _config_experimental !== void 0 ? _config_experimental : {}).filter((flag)=>$7a57a21ea5ac2d13$var$featureFlags.experimental.includes(flag) && config.experimental[flag]);
}
function $7a57a21ea5ac2d13$var$issueFlagNotices(config) {
    if ($7a57a21ea5ac2d13$var$experimentalFlagsEnabled(config).length > 0) {
        let changes = $7a57a21ea5ac2d13$var$experimentalFlagsEnabled(config).map((s)=>$7a57a21ea5ac2d13$var$_picocolors.default.yellow(s)).join(", ");
        $7a57a21ea5ac2d13$var$_log.default.warn("experimental-flags-enabled", [
            `You have enabled experimental features: ${changes}`,
            "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
    }
}
const $7a57a21ea5ac2d13$var$_default = $7a57a21ea5ac2d13$var$featureFlags;

});
parcelRegister("5Mhtp", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $434efd470372eaa0$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$434efd470372eaa0$var$_export(module.exports, {
    env: ()=>$434efd470372eaa0$var$env,
    contextMap: ()=>$434efd470372eaa0$var$contextMap,
    configContextMap: ()=>$434efd470372eaa0$var$configContextMap,
    contextSourcesMap: ()=>$434efd470372eaa0$var$contextSourcesMap,
    sourceHashMap: ()=>$434efd470372eaa0$var$sourceHashMap,
    NOT_ON_DEMAND: ()=>$434efd470372eaa0$var$NOT_ON_DEMAND,
    NONE: ()=>$434efd470372eaa0$var$NONE,
    resolveDebug: ()=>$434efd470372eaa0$var$resolveDebug
});

const $434efd470372eaa0$var$_packageJson = /*#__PURE__*/ $434efd470372eaa0$var$_interopRequireDefault((parcelRequire("3OYOA")));
function $434efd470372eaa0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $434efd470372eaa0$var$OXIDE_DEFAULT_ENABLED = $434efd470372eaa0$var$_packageJson.default.tailwindcss.engine === "oxide";
const $434efd470372eaa0$var$env = typeof $4ZL0H !== "undefined" ? {
    NODE_ENV: "production",
    DEBUG: $434efd470372eaa0$var$resolveDebug(undefined),
    ENGINE: $434efd470372eaa0$var$_packageJson.default.tailwindcss.engine,
    OXIDE: $434efd470372eaa0$var$resolveBoolean(undefined, $434efd470372eaa0$var$OXIDE_DEFAULT_ENABLED)
} : {
    NODE_ENV: "production",
    DEBUG: false,
    ENGINE: $434efd470372eaa0$var$_packageJson.default.tailwindcss.engine,
    OXIDE: $434efd470372eaa0$var$OXIDE_DEFAULT_ENABLED
};
const $434efd470372eaa0$var$contextMap = new Map();
const $434efd470372eaa0$var$configContextMap = new Map();
const $434efd470372eaa0$var$contextSourcesMap = new Map();
const $434efd470372eaa0$var$sourceHashMap = new Map();
const $434efd470372eaa0$var$NOT_ON_DEMAND = new String("*");
const $434efd470372eaa0$var$NONE = Symbol("__NONE__");
function $434efd470372eaa0$var$resolveBoolean(value, defaultValue) {
    if (value === undefined) return defaultValue;
    if (value === "0" || value === "false") return false;
    return true;
}
function $434efd470372eaa0$var$resolveDebug(debug) {
    if (debug === undefined) return false;
    // Environment variables are strings, so convert to boolean
    if (debug === "true" || debug === "1") return true;
    if (debug === "false" || debug === "0") return false;
    // Keep the debug convention into account:
    // DEBUG=* -> This enables all debug modes
    // DEBUG=projectA,projectB,projectC -> This enables debug for projectA, projectB and projectC
    // DEBUG=projectA:* -> This enables all debug modes for projectA (if you have sub-types)
    // DEBUG=projectA,-projectB -> This enables debug for projectA and explicitly disables it for projectB
    if (debug === "*") return true;
    let debuggers = debug.split(",").map((d)=>d.split(":")[0]);
    // Ignoring tailwindcss
    if (debuggers.includes("-tailwindcss")) return false;
    // Including tailwindcss
    if (debuggers.includes("tailwindcss")) return true;
    return false;
}

});
parcelRegister("3OYOA", function(module, exports) {
module.exports = JSON.parse('{"name":"tailwindcss","version":"3.3.1","description":"A utility-first CSS framework for rapidly building custom user interfaces.","license":"MIT","main":"lib/index.js","types":"types/index.d.ts","repository":"https://github.com/tailwindlabs/tailwindcss.git","bugs":"https://github.com/tailwindlabs/tailwindcss/issues","homepage":"https://tailwindcss.com","bin":{"tailwind":"lib/cli.js","tailwindcss":"lib/cli.js"},"tailwindcss":{"engine":"stable"},"scripts":{"prebuild":"npm run generate && rimraf lib","build":"swc src --out-dir lib --copy-files","postbuild":"esbuild lib/cli-peer-dependencies.js --bundle --platform=node --outfile=peers/index.js --define:process.env.CSS_TRANSFORMER_WASM=false","rebuild-fixtures":"npm run build && node -r @swc/register scripts/rebuildFixtures.js","style":"eslint .","pretest":"npm run generate","test":"jest","test:integrations":"npm run test --prefix ./integrations","install:integrations":"node scripts/install-integrations.js","generate:plugin-list":"node -r @swc/register scripts/create-plugin-list.js","generate:types":"node -r @swc/register scripts/generate-types.js","generate":"npm run generate:plugin-list && npm run generate:types","release-channel":"node ./scripts/release-channel.js","release-notes":"node ./scripts/release-notes.js","prepublishOnly":"npm install --force && npm run build"},"files":["src/*","cli/*","lib/*","peers/*","scripts/*.js","stubs/*","nesting/*","types/**/*","*.d.ts","*.css","*.js"],"devDependencies":{"@swc/cli":"0.1.59","@swc/core":"1.3.24","@swc/jest":"0.2.24","@swc/register":"0.1.10","autoprefixer":"^10.4.13","browserslist":"^4.21.4","concurrently":"^7.5.0","cssnano":"^5.1.14","esbuild":"^0.16.10","eslint":"^8.31.0","eslint-config-prettier":"^8.6.0","eslint-plugin-prettier":"^4.2.1","jest":"^28.1.3","jest-diff":"^28.1.3","lightningcss":"^1.18.0","prettier":"^2.8.1","rimraf":"^3.0.0","source-map-js":"^1.0.2","turbo":"^1.6.3"},"peerDependencies":{"postcss":"^8.0.9"},"dependencies":{"arg":"^5.0.2","chokidar":"^3.5.3","color-name":"^1.1.4","didyoumean":"^1.2.2","dlv":"^1.1.3","fast-glob":"^3.2.12","glob-parent":"^6.0.2","is-glob":"^4.0.3","jiti":"^1.17.2","lilconfig":"^2.0.6","micromatch":"^4.0.5","normalize-path":"^3.0.0","object-hash":"^3.0.0","picocolors":"^1.0.0","postcss":"^8.0.9","postcss-import":"^14.1.0","postcss-js":"^4.0.0","postcss-load-config":"^3.1.4","postcss-nested":"6.0.0","postcss-selector-parser":"^6.0.11","postcss-value-parser":"^4.2.0","quick-lru":"^5.1.1","resolve":"^1.22.1","sucrase":"^3.29.0"},"browserslist":["> 1%","not edge <= 18","not ie 11","not op_mini all"],"jest":{"testTimeout":30000,"setupFilesAfterEnv":["<rootDir>/jest/customMatchers.js"],"testPathIgnorePatterns":["/node_modules/","/integrations/","/standalone-cli/","\\\\.test\\\\.skip\\\\.js$"],"transformIgnorePatterns":["node_modules/(?!lightningcss)"],"transform":{"\\\\.js$":"@swc/jest","\\\\.ts$":"@swc/jest"}},"engines":{"node":">=12.13.0"}}');

});




parcelRegister("9PvSn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$72819a62b06fc6b0$var$isPlainObject
});
function $72819a62b06fc6b0$var$isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
}

});

parcelRegister("6yIgu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "cloneDeep", {
    enumerable: true,
    get: ()=>$4c6841275a4e476d$var$cloneDeep
});
function $4c6841275a4e476d$var$cloneDeep(value) {
    if (Array.isArray(value)) return value.map((child)=>$4c6841275a4e476d$var$cloneDeep(child));
    if (typeof value === "object" && value !== null) return Object.fromEntries(Object.entries(value).map(([k, v])=>[
            k,
            $4c6841275a4e476d$var$cloneDeep(v)
        ]));
    return value;
}

});

parcelRegister("c5ya5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $8cd073751b09998d$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$8cd073751b09998d$var$_export(module.exports, {
    updateAllClasses: ()=>$8cd073751b09998d$var$updateAllClasses,
    asValue: ()=>$8cd073751b09998d$var$asValue,
    parseColorFormat: ()=>$8cd073751b09998d$var$parseColorFormat,
    asColor: ()=>$8cd073751b09998d$var$asColor,
    asLookupValue: ()=>$8cd073751b09998d$var$asLookupValue,
    typeMap: ()=>$8cd073751b09998d$var$typeMap,
    coerceValue: ()=>$8cd073751b09998d$var$coerceValue,
    getMatchingTypes: ()=>$8cd073751b09998d$var$getMatchingTypes
});

const $8cd073751b09998d$var$_escapeCommas = /*#__PURE__*/ $8cd073751b09998d$var$_interopRequireDefault((parcelRequire("iq5Vk")));

var $bv8pw = parcelRequire("bv8pw");

var $iugfD = parcelRequire("iugfD");

const $8cd073751b09998d$var$_negateValue = /*#__PURE__*/ $8cd073751b09998d$var$_interopRequireDefault((parcelRequire("bzA4k")));

var $4XAks = parcelRequire("4XAks");

var $avdXZ = parcelRequire("avdXZ");
function $8cd073751b09998d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8cd073751b09998d$var$updateAllClasses(selectors, updateClass) {
    selectors.walkClasses((sel)=>{
        sel.value = updateClass(sel.value);
        if (sel.raws && sel.raws.value) sel.raws.value = (0, $8cd073751b09998d$var$_escapeCommas.default)(sel.raws.value);
    });
}
function $8cd073751b09998d$var$resolveArbitraryValue(modifier, validate) {
    if (!$8cd073751b09998d$var$isArbitraryValue(modifier)) return undefined;
    let value = modifier.slice(1, -1);
    if (!validate(value)) return undefined;
    return (0, $iugfD.normalize)(value);
}
function $8cd073751b09998d$var$asNegativeValue(modifier, lookup = {}, validate) {
    let positiveValue = lookup[modifier];
    if (positiveValue !== undefined) return (0, $8cd073751b09998d$var$_negateValue.default)(positiveValue);
    if ($8cd073751b09998d$var$isArbitraryValue(modifier)) {
        let resolved = $8cd073751b09998d$var$resolveArbitraryValue(modifier, validate);
        if (resolved === undefined) return undefined;
        return (0, $8cd073751b09998d$var$_negateValue.default)(resolved);
    }
}
function $8cd073751b09998d$var$asValue(modifier, options = {}, { validate: validate = ()=>true } = {}) {
    var _options_values;
    let value = (_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier];
    if (value !== undefined) return value;
    if (options.supportsNegativeValues && modifier.startsWith("-")) return $8cd073751b09998d$var$asNegativeValue(modifier.slice(1), options.values, validate);
    return $8cd073751b09998d$var$resolveArbitraryValue(modifier, validate);
}
function $8cd073751b09998d$var$isArbitraryValue(input) {
    return input.startsWith("[") && input.endsWith("]");
}
function $8cd073751b09998d$var$splitUtilityModifier(modifier) {
    let slashIdx = modifier.lastIndexOf("/");
    if (slashIdx === -1 || slashIdx === modifier.length - 1) return [
        modifier,
        undefined
    ];
    let arbitrary = $8cd073751b09998d$var$isArbitraryValue(modifier);
    // The modifier could be of the form `[foo]/[bar]`
    // We want to handle this case properly
    // without affecting `[foo/bar]`
    if (arbitrary && !modifier.includes("]/[")) return [
        modifier,
        undefined
    ];
    return [
        modifier.slice(0, slashIdx),
        modifier.slice(slashIdx + 1)
    ];
}
function $8cd073751b09998d$var$parseColorFormat(value) {
    if (typeof value === "string" && value.includes("<alpha-value>")) {
        let oldValue = value;
        return ({ opacityValue: opacityValue = 1 })=>oldValue.replace("<alpha-value>", opacityValue);
    }
    return value;
}
function $8cd073751b09998d$var$unwrapArbitraryModifier(modifier) {
    modifier = modifier.slice(1, -1);
    if (modifier.startsWith("--")) modifier = `var(${modifier})`;
    return modifier;
}
function $8cd073751b09998d$var$asColor(modifier, options = {}, { tailwindConfig: tailwindConfig = {} } = {}) {
    var _options_values;
    if (((_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier]) !== undefined) {
        var _options_values1;
        return $8cd073751b09998d$var$parseColorFormat((_options_values1 = options.values) === null || _options_values1 === void 0 ? void 0 : _options_values1[modifier]);
    }
    // TODO: Hoist this up to getMatchingTypes or something
    // We do this here because we need the alpha value (if any)
    let [color, alpha] = $8cd073751b09998d$var$splitUtilityModifier(modifier);
    if (alpha !== undefined) {
        var _options_values2, _tailwindConfig_theme, _tailwindConfig_theme_opacity;
        var _options_values_color;
        let normalizedColor = (_options_values_color = (_options_values2 = options.values) === null || _options_values2 === void 0 ? void 0 : _options_values2[color]) !== null && _options_values_color !== void 0 ? _options_values_color : $8cd073751b09998d$var$isArbitraryValue(color) ? color.slice(1, -1) : undefined;
        if (normalizedColor === undefined) return undefined;
        normalizedColor = $8cd073751b09998d$var$parseColorFormat(normalizedColor);
        if ($8cd073751b09998d$var$isArbitraryValue(alpha)) return (0, $bv8pw.withAlphaValue)(normalizedColor, $8cd073751b09998d$var$unwrapArbitraryModifier(alpha));
        if (((_tailwindConfig_theme = tailwindConfig.theme) === null || _tailwindConfig_theme === void 0 ? void 0 : (_tailwindConfig_theme_opacity = _tailwindConfig_theme.opacity) === null || _tailwindConfig_theme_opacity === void 0 ? void 0 : _tailwindConfig_theme_opacity[alpha]) === undefined) return undefined;
        return (0, $bv8pw.withAlphaValue)(normalizedColor, tailwindConfig.theme.opacity[alpha]);
    }
    return $8cd073751b09998d$var$asValue(modifier, options, {
        validate: $iugfD.color
    });
}
function $8cd073751b09998d$var$asLookupValue(modifier, options = {}) {
    var _options_values;
    return (_options_values = options.values) === null || _options_values === void 0 ? void 0 : _options_values[modifier];
}
function $8cd073751b09998d$var$guess(validate) {
    return (modifier, options)=>{
        return $8cd073751b09998d$var$asValue(modifier, options, {
            validate: validate
        });
    };
}
let $8cd073751b09998d$var$typeMap = {
    any: $8cd073751b09998d$var$asValue,
    color: $8cd073751b09998d$var$asColor,
    url: $8cd073751b09998d$var$guess($iugfD.url),
    image: $8cd073751b09998d$var$guess($iugfD.image),
    length: $8cd073751b09998d$var$guess($iugfD.length),
    percentage: $8cd073751b09998d$var$guess($iugfD.percentage),
    position: $8cd073751b09998d$var$guess($iugfD.position),
    lookup: $8cd073751b09998d$var$asLookupValue,
    "generic-name": $8cd073751b09998d$var$guess($iugfD.genericName),
    "family-name": $8cd073751b09998d$var$guess($iugfD.familyName),
    number: $8cd073751b09998d$var$guess($iugfD.number),
    "line-width": $8cd073751b09998d$var$guess($iugfD.lineWidth),
    "absolute-size": $8cd073751b09998d$var$guess($iugfD.absoluteSize),
    "relative-size": $8cd073751b09998d$var$guess($iugfD.relativeSize),
    shadow: $8cd073751b09998d$var$guess($iugfD.shadow),
    size: $8cd073751b09998d$var$guess($4XAks.backgroundSize)
};
let $8cd073751b09998d$var$supportedTypes = Object.keys($8cd073751b09998d$var$typeMap);
function $8cd073751b09998d$var$splitAtFirst(input, delim) {
    let idx = input.indexOf(delim);
    if (idx === -1) return [
        undefined,
        input
    ];
    return [
        input.slice(0, idx),
        input.slice(idx + 1)
    ];
}
function $8cd073751b09998d$var$coerceValue(types, modifier, options, tailwindConfig) {
    if (options.values && modifier in options.values) for (let { type: type } of types !== null && types !== void 0 ? types : []){
        let result = $8cd073751b09998d$var$typeMap[type](modifier, options, {
            tailwindConfig: tailwindConfig
        });
        if (result === undefined) continue;
        return [
            result,
            type,
            null
        ];
    }
    if ($8cd073751b09998d$var$isArbitraryValue(modifier)) {
        let arbitraryValue = modifier.slice(1, -1);
        let [explicitType, value] = $8cd073751b09998d$var$splitAtFirst(arbitraryValue, ":");
        // It could be that this resolves to `url(https` which is not a valid
        // identifier. We currently only support "simple" words with dashes or
        // underscores. E.g.: family-name
        if (!/^[\w-_]+$/g.test(explicitType)) value = arbitraryValue;
        else if (explicitType !== undefined && !$8cd073751b09998d$var$supportedTypes.includes(explicitType)) return [];
        if (value.length > 0 && $8cd073751b09998d$var$supportedTypes.includes(explicitType)) return [
            $8cd073751b09998d$var$asValue(`[${value}]`, options),
            explicitType,
            null
        ];
    }
    let matches = $8cd073751b09998d$var$getMatchingTypes(types, modifier, options, tailwindConfig);
    // Find first matching type
    for (let match of matches)return match;
    return [];
}
function* $8cd073751b09998d$var$getMatchingTypes(types, rawModifier, options, tailwindConfig) {
    let modifiersEnabled = (0, $avdXZ.flagEnabled)(tailwindConfig, "generalizedModifiers");
    let [modifier, utilityModifier] = $8cd073751b09998d$var$splitUtilityModifier(rawModifier);
    let canUseUtilityModifier = modifiersEnabled && options.modifiers != null && (options.modifiers === "any" || typeof options.modifiers === "object" && (utilityModifier && $8cd073751b09998d$var$isArbitraryValue(utilityModifier) || utilityModifier in options.modifiers));
    if (!canUseUtilityModifier) {
        modifier = rawModifier;
        utilityModifier = undefined;
    }
    if (utilityModifier !== undefined && modifier === "") modifier = "DEFAULT";
    // Check the full value first
    // TODO: Move to asValue… somehow
    if (utilityModifier !== undefined) {
        if (typeof options.modifiers === "object") {
            var _options_modifiers;
            var _options_modifiers_utilityModifier;
            let configValue = (_options_modifiers_utilityModifier = (_options_modifiers = options.modifiers) === null || _options_modifiers === void 0 ? void 0 : _options_modifiers[utilityModifier]) !== null && _options_modifiers_utilityModifier !== void 0 ? _options_modifiers_utilityModifier : null;
            if (configValue !== null) utilityModifier = configValue;
            else if ($8cd073751b09998d$var$isArbitraryValue(utilityModifier)) utilityModifier = $8cd073751b09998d$var$unwrapArbitraryModifier(utilityModifier);
        }
    }
    for (let { type: type } of types !== null && types !== void 0 ? types : []){
        let result = $8cd073751b09998d$var$typeMap[type](modifier, options, {
            tailwindConfig: tailwindConfig
        });
        if (result === undefined) continue;
        yield [
            result,
            type,
            utilityModifier !== null && utilityModifier !== void 0 ? utilityModifier : null
        ];
    }
}

});
parcelRegister("iq5Vk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$d68f4000531bf3be$var$escapeCommas
});
function $d68f4000531bf3be$var$escapeCommas(className) {
    return className.replace(/\\,/g, "\\2c ");
}

});

parcelRegister("bv8pw", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $85f91d2a02a6f53c$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$85f91d2a02a6f53c$var$_export(module.exports, {
    withAlphaValue: ()=>$85f91d2a02a6f53c$var$withAlphaValue,
    default: ()=>$85f91d2a02a6f53c$var$withAlphaVariable
});

var $iJHDG = parcelRequire("iJHDG");
function $85f91d2a02a6f53c$var$withAlphaValue(color, alphaValue, defaultValue) {
    if (typeof color === "function") return color({
        opacityValue: alphaValue
    });
    let parsed = (0, $iJHDG.parseColor)(color, {
        loose: true
    });
    if (parsed === null) return defaultValue;
    return (0, $iJHDG.formatColor)((0, $2qxEV._)((0, $9tqwB._)({}, parsed), {
        alpha: alphaValue
    }));
}
function $85f91d2a02a6f53c$var$withAlphaVariable({ color: color, property: property, variable: variable }) {
    let properties = [].concat(property);
    if (typeof color === "function") return (0, $9tqwB._)({
        [variable]: "1"
    }, Object.fromEntries(properties.map((p)=>{
        return [
            p,
            color({
                opacityVariable: variable,
                opacityValue: `var(${variable})`
            })
        ];
    })));
    const parsed = (0, $iJHDG.parseColor)(color);
    if (parsed === null) return Object.fromEntries(properties.map((p)=>[
            p,
            color
        ]));
    if (parsed.alpha !== undefined) // Has an alpha value, return color as-is
    return Object.fromEntries(properties.map((p)=>[
            p,
            color
        ]));
    return (0, $9tqwB._)({
        [variable]: "1"
    }, Object.fromEntries(properties.map((p)=>{
        return [
            p,
            (0, $iJHDG.formatColor)((0, $2qxEV._)((0, $9tqwB._)({}, parsed), {
                alpha: `var(${variable})`
            }))
        ];
    })));
}

});
parcelRegister("iJHDG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $da3e47c286dc6e4e$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$da3e47c286dc6e4e$var$_export(module.exports, {
    parseColor: ()=>$da3e47c286dc6e4e$var$parseColor,
    formatColor: ()=>$da3e47c286dc6e4e$var$formatColor
});

const $da3e47c286dc6e4e$var$_colorName = /*#__PURE__*/ $da3e47c286dc6e4e$var$_interopRequireDefault((parcelRequire("aT0G5")));
function $da3e47c286dc6e4e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let $da3e47c286dc6e4e$var$HEX = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i;
let $da3e47c286dc6e4e$var$SHORT_HEX = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i;
let $da3e47c286dc6e4e$var$VALUE = /(?:\d+|\d*\.\d+)%?/;
let $da3e47c286dc6e4e$var$SEP = /(?:\s*,\s*|\s+)/;
let $da3e47c286dc6e4e$var$ALPHA_SEP = /\s*[,/]\s*/;
let $da3e47c286dc6e4e$var$CUSTOM_PROPERTY = /var\(--(?:[^ )]*?)\)/;
let $da3e47c286dc6e4e$var$RGB = new RegExp(`^(rgba?)\\(\\s*(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source})(?:${$da3e47c286dc6e4e$var$SEP.source}(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source}))?(?:${$da3e47c286dc6e4e$var$SEP.source}(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source}))?(?:${$da3e47c286dc6e4e$var$ALPHA_SEP.source}(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source}))?\\s*\\)$`);
let $da3e47c286dc6e4e$var$HSL = new RegExp(`^(hsla?)\\(\\s*((?:${$da3e47c286dc6e4e$var$VALUE.source})(?:deg|rad|grad|turn)?|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source})(?:${$da3e47c286dc6e4e$var$SEP.source}(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source}))?(?:${$da3e47c286dc6e4e$var$SEP.source}(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source}))?(?:${$da3e47c286dc6e4e$var$ALPHA_SEP.source}(${$da3e47c286dc6e4e$var$VALUE.source}|${$da3e47c286dc6e4e$var$CUSTOM_PROPERTY.source}))?\\s*\\)$`);
function $da3e47c286dc6e4e$var$parseColor(value, { loose: loose = false } = {}) {
    var _match_, _match__toString;
    if (typeof value !== "string") return null;
    value = value.trim();
    if (value === "transparent") return {
        mode: "rgb",
        color: [
            "0",
            "0",
            "0"
        ],
        alpha: "0"
    };
    if (value in $da3e47c286dc6e4e$var$_colorName.default) return {
        mode: "rgb",
        color: $da3e47c286dc6e4e$var$_colorName.default[value].map((v)=>v.toString())
    };
    let hex = value.replace($da3e47c286dc6e4e$var$SHORT_HEX, (_, r, g, b, a)=>[
            "#",
            r,
            r,
            g,
            g,
            b,
            b,
            a ? a + a : ""
        ].join("")).match($da3e47c286dc6e4e$var$HEX);
    if (hex !== null) return {
        mode: "rgb",
        color: [
            parseInt(hex[1], 16),
            parseInt(hex[2], 16),
            parseInt(hex[3], 16)
        ].map((v)=>v.toString()),
        alpha: hex[4] ? (parseInt(hex[4], 16) / 255).toString() : undefined
    };
    var _value_match;
    let match = (_value_match = value.match($da3e47c286dc6e4e$var$RGB)) !== null && _value_match !== void 0 ? _value_match : value.match($da3e47c286dc6e4e$var$HSL);
    if (match === null) return null;
    let color = [
        match[2],
        match[3],
        match[4]
    ].filter(Boolean).map((v)=>v.toString());
    // rgba(var(--my-color), 0.1)
    // hsla(var(--my-color), 0.1)
    if (color.length === 2 && color[0].startsWith("var(")) return {
        mode: match[1],
        color: [
            color[0]
        ],
        alpha: color[1]
    };
    if (!loose && color.length !== 3) return null;
    if (color.length < 3 && !color.some((part)=>/^var\(.*?\)$/.test(part))) return null;
    return {
        mode: match[1],
        color: color,
        alpha: (_match_ = match[5]) === null || _match_ === void 0 ? void 0 : (_match__toString = _match_.toString) === null || _match__toString === void 0 ? void 0 : _match__toString.call(_match_)
    };
}
function $da3e47c286dc6e4e$var$formatColor({ mode: mode, color: color, alpha: alpha }) {
    let hasAlpha = alpha !== undefined;
    if (mode === "rgba" || mode === "hsla") return `${mode}(${color.join(", ")}${hasAlpha ? `, ${alpha}` : ""})`;
    return `${mode}(${color.join(" ")}${hasAlpha ? ` / ${alpha}` : ""})`;
}

});
parcelRegister("aT0G5", function(module, exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});



parcelRegister("iugfD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $d757a280803bc5e3$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$d757a280803bc5e3$var$_export(module.exports, {
    normalize: ()=>$d757a280803bc5e3$var$normalize,
    url: ()=>$d757a280803bc5e3$var$url,
    number: ()=>$d757a280803bc5e3$var$number,
    percentage: ()=>$d757a280803bc5e3$var$percentage,
    length: ()=>$d757a280803bc5e3$var$length,
    lineWidth: ()=>$d757a280803bc5e3$var$lineWidth,
    shadow: ()=>$d757a280803bc5e3$var$shadow,
    color: ()=>$d757a280803bc5e3$var$color,
    image: ()=>$d757a280803bc5e3$var$image,
    gradient: ()=>$d757a280803bc5e3$var$gradient,
    position: ()=>$d757a280803bc5e3$var$position,
    familyName: ()=>$d757a280803bc5e3$var$familyName,
    genericName: ()=>$d757a280803bc5e3$var$genericName,
    absoluteSize: ()=>$d757a280803bc5e3$var$absoluteSize,
    relativeSize: ()=>$d757a280803bc5e3$var$relativeSize
});

var $iJHDG = parcelRequire("iJHDG");

var $1SqOs = parcelRequire("1SqOs");

var $tzedm = parcelRequire("tzedm");
let $d757a280803bc5e3$var$cssFunctions = [
    "min",
    "max",
    "clamp",
    "calc"
];
// Ref: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Types
function $d757a280803bc5e3$var$isCSSFunction(value) {
    return $d757a280803bc5e3$var$cssFunctions.some((fn)=>new RegExp(`^${fn}\\(.*\\)`).test(value));
}
const $d757a280803bc5e3$var$placeholder = "--tw-placeholder";
const $d757a280803bc5e3$var$placeholderRe = new RegExp($d757a280803bc5e3$var$placeholder, "g");
function $d757a280803bc5e3$var$normalize(value, isRoot = true) {
    if (value.startsWith("--")) return `var(${value})`;
    // Keep raw strings if it starts with `url(`
    if (value.includes("url(")) return value.split(/(url\(.*?\))/g).filter(Boolean).map((part)=>{
        if (/^url\(.*?\)$/.test(part)) return part;
        return $d757a280803bc5e3$var$normalize(part, false);
    }).join("");
    // Convert `_` to ` `, except for escaped underscores `\_`
    value = value.replace(/([^\\])_+/g, (fullMatch, characterBefore)=>characterBefore + " ".repeat(fullMatch.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_");
    // Remove leftover whitespace
    if (isRoot) value = value.trim();
    // Add spaces around operators inside math functions like calc() that do not follow an operator
    // or '('.
    value = value.replace(/(calc|min|max|clamp)\(.+\)/g, (match)=>{
        let vars = [];
        return match.replace(/var\((--.+?)[,)]/g, (match, g1)=>{
            vars.push(g1);
            return match.replace(g1, $d757a280803bc5e3$var$placeholder);
        }).replace(/(-?\d*\.?\d(?!\b-\d.+[,)](?![^+\-/*])\D)(?:%|[a-z]+)?|\))([+\-/*])/g, "$1 $2 ").replace($d757a280803bc5e3$var$placeholderRe, ()=>vars.shift());
    });
    return value;
}
function $d757a280803bc5e3$var$url(value) {
    return value.startsWith("url(");
}
function $d757a280803bc5e3$var$number(value) {
    return !isNaN(Number(value)) || $d757a280803bc5e3$var$isCSSFunction(value);
}
function $d757a280803bc5e3$var$percentage(value) {
    return value.endsWith("%") && $d757a280803bc5e3$var$number(value.slice(0, -1)) || $d757a280803bc5e3$var$isCSSFunction(value);
}
// Please refer to MDN when updating this list:
// https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/Values_and_units
// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Container_Queries#container_query_length_units
let $d757a280803bc5e3$var$lengthUnits = [
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
];
let $d757a280803bc5e3$var$lengthUnitsPattern = `(?:${$d757a280803bc5e3$var$lengthUnits.join("|")})`;
function $d757a280803bc5e3$var$length(value) {
    return value === "0" || new RegExp(`^[+-]?[0-9]*\.?[0-9]+(?:[eE][+-]?[0-9]+)?${$d757a280803bc5e3$var$lengthUnitsPattern}$`).test(value) || $d757a280803bc5e3$var$isCSSFunction(value);
}
let $d757a280803bc5e3$var$lineWidths = new Set([
    "thin",
    "medium",
    "thick"
]);
function $d757a280803bc5e3$var$lineWidth(value) {
    return $d757a280803bc5e3$var$lineWidths.has(value);
}
function $d757a280803bc5e3$var$shadow(value) {
    let parsedShadows = (0, $1SqOs.parseBoxShadowValue)($d757a280803bc5e3$var$normalize(value));
    for (let parsedShadow of parsedShadows){
        if (!parsedShadow.valid) return false;
    }
    return true;
}
function $d757a280803bc5e3$var$color(value) {
    let colors = 0;
    let result = (0, $tzedm.splitAtTopLevelOnly)(value, "_").every((part)=>{
        part = $d757a280803bc5e3$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ((0, $iJHDG.parseColor)(part, {
            loose: true
        }) !== null) return colors++, true;
        return false;
    });
    if (!result) return false;
    return colors > 0;
}
function $d757a280803bc5e3$var$image(value) {
    let images = 0;
    let result = (0, $tzedm.splitAtTopLevelOnly)(value, ",").every((part)=>{
        part = $d757a280803bc5e3$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ($d757a280803bc5e3$var$url(part) || $d757a280803bc5e3$var$gradient(part) || [
            "element(",
            "image(",
            "cross-fade(",
            "image-set("
        ].some((fn)=>part.startsWith(fn))) {
            images++;
            return true;
        }
        return false;
    });
    if (!result) return false;
    return images > 0;
}
let $d757a280803bc5e3$var$gradientTypes = new Set([
    "linear-gradient",
    "radial-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "conic-gradient"
]);
function $d757a280803bc5e3$var$gradient(value) {
    value = $d757a280803bc5e3$var$normalize(value);
    for (let type of $d757a280803bc5e3$var$gradientTypes){
        if (value.startsWith(`${type}(`)) return true;
    }
    return false;
}
let $d757a280803bc5e3$var$validPositions = new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
]);
function $d757a280803bc5e3$var$position(value) {
    let positions = 0;
    let result = (0, $tzedm.splitAtTopLevelOnly)(value, "_").every((part)=>{
        part = $d757a280803bc5e3$var$normalize(part);
        if (part.startsWith("var(")) return true;
        if ($d757a280803bc5e3$var$validPositions.has(part) || $d757a280803bc5e3$var$length(part) || $d757a280803bc5e3$var$percentage(part)) {
            positions++;
            return true;
        }
        return false;
    });
    if (!result) return false;
    return positions > 0;
}
function $d757a280803bc5e3$var$familyName(value) {
    let fonts = 0;
    let result = (0, $tzedm.splitAtTopLevelOnly)(value, ",").every((part)=>{
        part = $d757a280803bc5e3$var$normalize(part);
        if (part.startsWith("var(")) return true;
        // If it contains spaces, then it should be quoted
        if (part.includes(" ")) {
            if (!/(['"])([^"']+)\1/g.test(part)) return false;
        }
        // If it starts with a number, it's invalid
        if (/^\d/g.test(part)) return false;
        fonts++;
        return true;
    });
    if (!result) return false;
    return fonts > 0;
}
let $d757a280803bc5e3$var$genericNames = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
]);
function $d757a280803bc5e3$var$genericName(value) {
    return $d757a280803bc5e3$var$genericNames.has(value);
}
let $d757a280803bc5e3$var$absoluteSizes = new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "x-large",
    "xxx-large"
]);
function $d757a280803bc5e3$var$absoluteSize(value) {
    return $d757a280803bc5e3$var$absoluteSizes.has(value);
}
let $d757a280803bc5e3$var$relativeSizes = new Set([
    "larger",
    "smaller"
]);
function $d757a280803bc5e3$var$relativeSize(value) {
    return $d757a280803bc5e3$var$relativeSizes.has(value);
}

});
parcelRegister("1SqOs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $15dfa20f2a0da346$var$_export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
$15dfa20f2a0da346$var$_export(module.exports, {
    parseBoxShadowValue: ()=>$15dfa20f2a0da346$var$parseBoxShadowValue,
    formatBoxShadowValue: ()=>$15dfa20f2a0da346$var$formatBoxShadowValue
});

var $tzedm = parcelRequire("tzedm");
let $15dfa20f2a0da346$var$KEYWORDS = new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
let $15dfa20f2a0da346$var$SPACE = /\ +(?![^(]*\))/g // Similar to the one above, but with spaces instead.
;
let $15dfa20f2a0da346$var$LENGTH = /^-?(\d+|\.\d+)(.*?)$/g;
function $15dfa20f2a0da346$var$parseBoxShadowValue(input) {
    let shadows = (0, $tzedm.splitAtTopLevelOnly)(input, ",");
    return shadows.map((shadow)=>{
        let value = shadow.trim();
        let result = {
            raw: value
        };
        let parts = value.split($15dfa20f2a0da346$var$SPACE);
        let seen = new Set();
        for (let part of parts){
            // Reset index, since the regex is stateful.
            $15dfa20f2a0da346$var$LENGTH.lastIndex = 0;
            // Keyword
            if (!seen.has("KEYWORD") && $15dfa20f2a0da346$var$KEYWORDS.has(part)) {
                result.keyword = part;
                seen.add("KEYWORD");
            } else if ($15dfa20f2a0da346$var$LENGTH.test(part)) {
                if (!seen.has("X")) {
                    result.x = part;
                    seen.add("X");
                } else if (!seen.has("Y")) {
                    result.y = part;
                    seen.add("Y");
                } else if (!seen.has("BLUR")) {
                    result.blur = part;
                    seen.add("BLUR");
                } else if (!seen.has("SPREAD")) {
                    result.spread = part;
                    seen.add("SPREAD");
                }
            } else if (!result.color) result.color = part;
            else {
                if (!result.unknown) result.unknown = [];
                result.unknown.push(part);
            }
        }
        // Check if valid
        result.valid = result.x !== undefined && result.y !== undefined;
        return result;
    });
}
function $15dfa20f2a0da346$var$formatBoxShadowValue(shadows) {
    return shadows.map((shadow)=>{
        if (!shadow.valid) return shadow.raw;
        return [
            shadow.keyword,
            shadow.x,
            shadow.y,
            shadow.blur,
            shadow.spread,
            shadow.color
        ].filter(Boolean).join(" ");
    }).join(", ");
}

});
parcelRegister("tzedm", function(module, exports) {
/**
 * This splits a string on a top-level character.
 *
 * Regex doesn't support recursion (at least not the JS-flavored version).
 * So we have to use a tiny state machine to keep track of paren placement.
 *
 * Expected behavior using commas:
 * var(--a, 0 0 1px rgb(0, 0, 0)), 0 0 1px rgb(0, 0, 0)
 *       ─┬─             ┬  ┬    ┬
 *        x              x  x    ╰──────── Split because top-level
 *        ╰──────────────┴──┴───────────── Ignored b/c inside >= 1 levels of parens
 *
 * @param {string} input
 * @param {string} separator
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "splitAtTopLevelOnly", {
    enumerable: true,
    get: ()=>$058e0925e7e37ec4$var$splitAtTopLevelOnly
});
function $058e0925e7e37ec4$var$splitAtTopLevelOnly(input, separator) {
    let stack = [];
    let parts = [];
    let lastPos = 0;
    let isEscaped = false;
    for(let idx = 0; idx < input.length; idx++){
        let char = input[idx];
        if (stack.length === 0 && char === separator[0] && !isEscaped) {
            if (separator.length === 1 || input.slice(idx, idx + separator.length) === separator) {
                parts.push(input.slice(lastPos, idx));
                lastPos = idx + separator.length;
            }
        }
        if (isEscaped) isEscaped = false;
        else if (char === "\\") isEscaped = true;
        if (char === "(" || char === "[" || char === "{") stack.push(char);
        else if (char === ")" && stack[stack.length - 1] === "(" || char === "]" && stack[stack.length - 1] === "[" || char === "}" && stack[stack.length - 1] === "{") stack.pop();
    }
    parts.push(input.slice(lastPos));
    return parts;
}

});



parcelRegister("4XAks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "backgroundSize", {
    enumerable: true,
    get: ()=>$39c8da4cda25ea69$var$backgroundSize
});

var $iugfD = parcelRequire("iugfD");

var $tzedm = parcelRequire("tzedm");
function $39c8da4cda25ea69$var$backgroundSize(value) {
    let keywordValues = [
        "cover",
        "contain"
    ];
    // the <length-percentage> type will probably be a css function
    // so we have to use `splitAtTopLevelOnly`
    return (0, $tzedm.splitAtTopLevelOnly)(value, ",").every((part)=>{
        let sizes = (0, $tzedm.splitAtTopLevelOnly)(part, "_").filter(Boolean);
        if (sizes.length === 1 && keywordValues.includes(sizes[0])) return true;
        if (sizes.length !== 1 && sizes.length !== 2) return false;
        return sizes.every((size)=>(0, $iugfD.length)(size) || (0, $iugfD.percentage)(size) || size === "auto");
    });
}

});


parcelRegister("g4aHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$bb25530b58262447$var$toColorValue
});
function $bb25530b58262447$var$toColorValue(maybeFunction) {
    return typeof maybeFunction === "function" ? maybeFunction({}) : maybeFunction;
}

});


parcelRegister("lmC4G", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$f8d92fd96cc92d0f$var$getAllConfigs
});

const $f8d92fd96cc92d0f$var$_configFullJs = /*#__PURE__*/ $f8d92fd96cc92d0f$var$_interopRequireDefault((parcelRequire("51iZR")));

var $avdXZ = parcelRequire("avdXZ");
function $f8d92fd96cc92d0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f8d92fd96cc92d0f$var$getAllConfigs(config) {
    var _config_presets;
    const configs = ((_config_presets = config === null || config === void 0 ? void 0 : config.presets) !== null && _config_presets !== void 0 ? _config_presets : [
        $f8d92fd96cc92d0f$var$_configFullJs.default
    ]).slice().reverse().flatMap((preset)=>$f8d92fd96cc92d0f$var$getAllConfigs(preset instanceof Function ? preset() : preset));
    const features = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
            theme: {
                ringColor: ({ theme: theme })=>(0, $9tqwB._)({
                        DEFAULT: "#3b82f67f"
                    }, theme("colors"))
            }
        },
        disableColorOpacityUtilitiesByDefault: {
            corePlugins: {
                backgroundOpacity: false,
                borderOpacity: false,
                divideOpacity: false,
                placeholderOpacity: false,
                ringOpacity: false,
                textOpacity: false
            }
        }
    };
    const experimentals = Object.keys(features).filter((feature)=>(0, $avdXZ.flagEnabled)(config, feature)).map((feature)=>features[feature]);
    return [
        config,
        ...experimentals,
        ...configs
    ];
}

});
parcelRegister("51iZR", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
module.exports = {
    content: [],
    presets: [],
    darkMode: "media",
    theme: {
        accentColor: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({}, theme("colors")), {
                auto: "auto"
            }),
        animation: {
            none: "none",
            spin: "spin 1s linear infinite",
            ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
            pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
            bounce: "bounce 1s infinite"
        },
        aria: {
            checked: 'checked="true"',
            disabled: 'disabled="true"',
            expanded: 'expanded="true"',
            hidden: 'hidden="true"',
            pressed: 'pressed="true"',
            readonly: 'readonly="true"',
            required: 'required="true"',
            selected: 'selected="true"'
        },
        aspectRatio: {
            auto: "auto",
            square: "1 / 1",
            video: "16 / 9"
        },
        backdropBlur: ({ theme: theme })=>theme("blur"),
        backdropBrightness: ({ theme: theme })=>theme("brightness"),
        backdropContrast: ({ theme: theme })=>theme("contrast"),
        backdropGrayscale: ({ theme: theme })=>theme("grayscale"),
        backdropHueRotate: ({ theme: theme })=>theme("hueRotate"),
        backdropInvert: ({ theme: theme })=>theme("invert"),
        backdropOpacity: ({ theme: theme })=>theme("opacity"),
        backdropSaturate: ({ theme: theme })=>theme("saturate"),
        backdropSepia: ({ theme: theme })=>theme("sepia"),
        backgroundColor: ({ theme: theme })=>theme("colors"),
        backgroundImage: {
            none: "none",
            "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
            "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
            "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
            "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
            "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
            "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
            "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
            "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
        },
        backgroundOpacity: ({ theme: theme })=>theme("opacity"),
        backgroundPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        backgroundSize: {
            auto: "auto",
            cover: "cover",
            contain: "contain"
        },
        blur: {
            0: "0",
            none: "0",
            sm: "4px",
            DEFAULT: "8px",
            md: "12px",
            lg: "16px",
            xl: "24px",
            "2xl": "40px",
            "3xl": "64px"
        },
        borderColor: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({}, theme("colors")), {
                DEFAULT: theme("colors.gray.200", "currentColor")
            }),
        borderOpacity: ({ theme: theme })=>theme("opacity"),
        borderRadius: {
            none: "0px",
            sm: "0.125rem",
            DEFAULT: "0.25rem",
            md: "0.375rem",
            lg: "0.5rem",
            xl: "0.75rem",
            "2xl": "1rem",
            "3xl": "1.5rem",
            full: "9999px"
        },
        borderSpacing: ({ theme: theme })=>(0, $9tqwB._)({}, theme("spacing")),
        borderWidth: {
            DEFAULT: "1px",
            0: "0px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        boxShadow: {
            sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
            DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
            inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
            none: "none"
        },
        boxShadowColor: ({ theme: theme })=>theme("colors"),
        brightness: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        caretColor: ({ theme: theme })=>theme("colors"),
        colors: ({ colors: colors })=>({
                inherit: colors.inherit,
                current: colors.current,
                transparent: colors.transparent,
                black: colors.black,
                white: colors.white,
                slate: colors.slate,
                gray: colors.gray,
                zinc: colors.zinc,
                neutral: colors.neutral,
                stone: colors.stone,
                red: colors.red,
                orange: colors.orange,
                amber: colors.amber,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                sky: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose
            }),
        columns: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            "3xs": "16rem",
            "2xs": "18rem",
            xs: "20rem",
            sm: "24rem",
            md: "28rem",
            lg: "32rem",
            xl: "36rem",
            "2xl": "42rem",
            "3xl": "48rem",
            "4xl": "56rem",
            "5xl": "64rem",
            "6xl": "72rem",
            "7xl": "80rem"
        },
        container: {},
        content: {
            none: "none"
        },
        contrast: {
            0: "0",
            50: ".5",
            75: ".75",
            100: "1",
            125: "1.25",
            150: "1.5",
            200: "2"
        },
        cursor: {
            auto: "auto",
            default: "default",
            pointer: "pointer",
            wait: "wait",
            text: "text",
            move: "move",
            help: "help",
            "not-allowed": "not-allowed",
            none: "none",
            "context-menu": "context-menu",
            progress: "progress",
            cell: "cell",
            crosshair: "crosshair",
            "vertical-text": "vertical-text",
            alias: "alias",
            copy: "copy",
            "no-drop": "no-drop",
            grab: "grab",
            grabbing: "grabbing",
            "all-scroll": "all-scroll",
            "col-resize": "col-resize",
            "row-resize": "row-resize",
            "n-resize": "n-resize",
            "e-resize": "e-resize",
            "s-resize": "s-resize",
            "w-resize": "w-resize",
            "ne-resize": "ne-resize",
            "nw-resize": "nw-resize",
            "se-resize": "se-resize",
            "sw-resize": "sw-resize",
            "ew-resize": "ew-resize",
            "ns-resize": "ns-resize",
            "nesw-resize": "nesw-resize",
            "nwse-resize": "nwse-resize",
            "zoom-in": "zoom-in",
            "zoom-out": "zoom-out"
        },
        divideColor: ({ theme: theme })=>theme("borderColor"),
        divideOpacity: ({ theme: theme })=>theme("borderOpacity"),
        divideWidth: ({ theme: theme })=>theme("borderWidth"),
        dropShadow: {
            sm: "0 1px 1px rgb(0 0 0 / 0.05)",
            DEFAULT: [
                "0 1px 2px rgb(0 0 0 / 0.1)",
                "0 1px 1px rgb(0 0 0 / 0.06)"
            ],
            md: [
                "0 4px 3px rgb(0 0 0 / 0.07)",
                "0 2px 2px rgb(0 0 0 / 0.06)"
            ],
            lg: [
                "0 10px 8px rgb(0 0 0 / 0.04)",
                "0 4px 3px rgb(0 0 0 / 0.1)"
            ],
            xl: [
                "0 20px 13px rgb(0 0 0 / 0.03)",
                "0 8px 5px rgb(0 0 0 / 0.08)"
            ],
            "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
            none: "0 0 #0000"
        },
        fill: ({ theme: theme })=>(0, $9tqwB._)({
                none: "none"
            }, theme("colors")),
        flex: {
            1: "1 1 0%",
            auto: "1 1 auto",
            initial: "0 1 auto",
            none: "none"
        },
        flexBasis: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({
                auto: "auto"
            }, theme("spacing")), {
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%"
            }),
        flexGrow: {
            0: "0",
            DEFAULT: "1"
        },
        flexShrink: {
            0: "0",
            DEFAULT: "1"
        },
        fontFamily: {
            sans: [
                "ui-sans-serif",
                "system-ui",
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "Roboto",
                '"Helvetica Neue"',
                "Arial",
                '"Noto Sans"',
                "sans-serif",
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"'
            ],
            serif: [
                "ui-serif",
                "Georgia",
                "Cambria",
                '"Times New Roman"',
                "Times",
                "serif"
            ],
            mono: [
                "ui-monospace",
                "SFMono-Regular",
                "Menlo",
                "Monaco",
                "Consolas",
                '"Liberation Mono"',
                '"Courier New"',
                "monospace"
            ]
        },
        fontSize: {
            xs: [
                "0.75rem",
                {
                    lineHeight: "1rem"
                }
            ],
            sm: [
                "0.875rem",
                {
                    lineHeight: "1.25rem"
                }
            ],
            base: [
                "1rem",
                {
                    lineHeight: "1.5rem"
                }
            ],
            lg: [
                "1.125rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            xl: [
                "1.25rem",
                {
                    lineHeight: "1.75rem"
                }
            ],
            "2xl": [
                "1.5rem",
                {
                    lineHeight: "2rem"
                }
            ],
            "3xl": [
                "1.875rem",
                {
                    lineHeight: "2.25rem"
                }
            ],
            "4xl": [
                "2.25rem",
                {
                    lineHeight: "2.5rem"
                }
            ],
            "5xl": [
                "3rem",
                {
                    lineHeight: "1"
                }
            ],
            "6xl": [
                "3.75rem",
                {
                    lineHeight: "1"
                }
            ],
            "7xl": [
                "4.5rem",
                {
                    lineHeight: "1"
                }
            ],
            "8xl": [
                "6rem",
                {
                    lineHeight: "1"
                }
            ],
            "9xl": [
                "8rem",
                {
                    lineHeight: "1"
                }
            ]
        },
        fontWeight: {
            thin: "100",
            extralight: "200",
            light: "300",
            normal: "400",
            medium: "500",
            semibold: "600",
            bold: "700",
            extrabold: "800",
            black: "900"
        },
        gap: ({ theme: theme })=>theme("spacing"),
        gradientColorStops: ({ theme: theme })=>theme("colors"),
        gradientColorStopPositions: {
            "0%": "0%",
            "5%": "5%",
            "10%": "10%",
            "15%": "15%",
            "20%": "20%",
            "25%": "25%",
            "30%": "30%",
            "35%": "35%",
            "40%": "40%",
            "45%": "45%",
            "50%": "50%",
            "55%": "55%",
            "60%": "60%",
            "65%": "65%",
            "70%": "70%",
            "75%": "75%",
            "80%": "80%",
            "85%": "85%",
            "90%": "90%",
            "95%": "95%",
            "100%": "100%"
        },
        grayscale: {
            0: "0",
            DEFAULT: "100%"
        },
        gridAutoColumns: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridAutoRows: {
            auto: "auto",
            min: "min-content",
            max: "max-content",
            fr: "minmax(0, 1fr)"
        },
        gridColumn: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-7": "span 7 / span 7",
            "span-8": "span 8 / span 8",
            "span-9": "span 9 / span 9",
            "span-10": "span 10 / span 10",
            "span-11": "span 11 / span 11",
            "span-12": "span 12 / span 12",
            "span-full": "1 / -1"
        },
        gridColumnEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridColumnStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13"
        },
        gridRow: {
            auto: "auto",
            "span-1": "span 1 / span 1",
            "span-2": "span 2 / span 2",
            "span-3": "span 3 / span 3",
            "span-4": "span 4 / span 4",
            "span-5": "span 5 / span 5",
            "span-6": "span 6 / span 6",
            "span-full": "1 / -1"
        },
        gridRowEnd: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7"
        },
        gridRowStart: {
            auto: "auto",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7"
        },
        gridTemplateColumns: {
            none: "none",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))",
            7: "repeat(7, minmax(0, 1fr))",
            8: "repeat(8, minmax(0, 1fr))",
            9: "repeat(9, minmax(0, 1fr))",
            10: "repeat(10, minmax(0, 1fr))",
            11: "repeat(11, minmax(0, 1fr))",
            12: "repeat(12, minmax(0, 1fr))"
        },
        gridTemplateRows: {
            none: "none",
            1: "repeat(1, minmax(0, 1fr))",
            2: "repeat(2, minmax(0, 1fr))",
            3: "repeat(3, minmax(0, 1fr))",
            4: "repeat(4, minmax(0, 1fr))",
            5: "repeat(5, minmax(0, 1fr))",
            6: "repeat(6, minmax(0, 1fr))"
        },
        height: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({
                auto: "auto"
            }, theme("spacing")), {
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                full: "100%",
                screen: "100vh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        hueRotate: {
            0: "0deg",
            15: "15deg",
            30: "30deg",
            60: "60deg",
            90: "90deg",
            180: "180deg"
        },
        inset: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({
                auto: "auto"
            }, theme("spacing")), {
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        invert: {
            0: "0",
            DEFAULT: "100%"
        },
        keyframes: {
            spin: {
                to: {
                    transform: "rotate(360deg)"
                }
            },
            ping: {
                "75%, 100%": {
                    transform: "scale(2)",
                    opacity: "0"
                }
            },
            pulse: {
                "50%": {
                    opacity: ".5"
                }
            },
            bounce: {
                "0%, 100%": {
                    transform: "translateY(-25%)",
                    animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
                },
                "50%": {
                    transform: "none",
                    animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
                }
            }
        },
        letterSpacing: {
            tighter: "-0.05em",
            tight: "-0.025em",
            normal: "0em",
            wide: "0.025em",
            wider: "0.05em",
            widest: "0.1em"
        },
        lineHeight: {
            none: "1",
            tight: "1.25",
            snug: "1.375",
            normal: "1.5",
            relaxed: "1.625",
            loose: "2",
            3: ".75rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem"
        },
        listStyleType: {
            none: "none",
            disc: "disc",
            decimal: "decimal"
        },
        listStyleImage: {
            none: "none"
        },
        margin: ({ theme: theme })=>(0, $9tqwB._)({
                auto: "auto"
            }, theme("spacing")),
        lineClamp: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6"
        },
        maxHeight: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({}, theme("spacing")), {
                none: "none",
                full: "100%",
                screen: "100vh",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        maxWidth: ({ theme: theme, breakpoints: breakpoints })=>(0, $9tqwB._)({
                none: "none",
                0: "0rem",
                xs: "20rem",
                sm: "24rem",
                md: "28rem",
                lg: "32rem",
                xl: "36rem",
                "2xl": "42rem",
                "3xl": "48rem",
                "4xl": "56rem",
                "5xl": "64rem",
                "6xl": "72rem",
                "7xl": "80rem",
                full: "100%",
                min: "min-content",
                max: "max-content",
                fit: "fit-content",
                prose: "65ch"
            }, breakpoints(theme("screens"))),
        minHeight: {
            0: "0px",
            full: "100%",
            screen: "100vh",
            min: "min-content",
            max: "max-content",
            fit: "fit-content"
        },
        minWidth: {
            0: "0px",
            full: "100%",
            min: "min-content",
            max: "max-content",
            fit: "fit-content"
        },
        objectPosition: {
            bottom: "bottom",
            center: "center",
            left: "left",
            "left-bottom": "left bottom",
            "left-top": "left top",
            right: "right",
            "right-bottom": "right bottom",
            "right-top": "right top",
            top: "top"
        },
        opacity: {
            0: "0",
            5: "0.05",
            10: "0.1",
            20: "0.2",
            25: "0.25",
            30: "0.3",
            40: "0.4",
            50: "0.5",
            60: "0.6",
            70: "0.7",
            75: "0.75",
            80: "0.8",
            90: "0.9",
            95: "0.95",
            100: "1"
        },
        order: {
            first: "-9999",
            last: "9999",
            none: "0",
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12"
        },
        outlineColor: ({ theme: theme })=>theme("colors"),
        outlineOffset: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        outlineWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        padding: ({ theme: theme })=>theme("spacing"),
        placeholderColor: ({ theme: theme })=>theme("colors"),
        placeholderOpacity: ({ theme: theme })=>theme("opacity"),
        ringColor: ({ theme: theme })=>(0, $9tqwB._)({
                DEFAULT: theme("colors.blue.500", "#3b82f6")
            }, theme("colors")),
        ringOffsetColor: ({ theme: theme })=>theme("colors"),
        ringOffsetWidth: {
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        ringOpacity: ({ theme: theme })=>(0, $9tqwB._)({
                DEFAULT: "0.5"
            }, theme("opacity")),
        ringWidth: {
            DEFAULT: "3px",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        rotate: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg",
            45: "45deg",
            90: "90deg",
            180: "180deg"
        },
        saturate: {
            0: "0",
            50: ".5",
            100: "1",
            150: "1.5",
            200: "2"
        },
        scale: {
            0: "0",
            50: ".5",
            75: ".75",
            90: ".9",
            95: ".95",
            100: "1",
            105: "1.05",
            110: "1.1",
            125: "1.25",
            150: "1.5"
        },
        screens: {
            sm: "640px",
            md: "768px",
            lg: "1024px",
            xl: "1280px",
            "2xl": "1536px"
        },
        scrollMargin: ({ theme: theme })=>(0, $9tqwB._)({}, theme("spacing")),
        scrollPadding: ({ theme: theme })=>theme("spacing"),
        sepia: {
            0: "0",
            DEFAULT: "100%"
        },
        skew: {
            0: "0deg",
            1: "1deg",
            2: "2deg",
            3: "3deg",
            6: "6deg",
            12: "12deg"
        },
        space: ({ theme: theme })=>(0, $9tqwB._)({}, theme("spacing")),
        spacing: {
            px: "1px",
            0: "0px",
            0.5: "0.125rem",
            1: "0.25rem",
            1.5: "0.375rem",
            2: "0.5rem",
            2.5: "0.625rem",
            3: "0.75rem",
            3.5: "0.875rem",
            4: "1rem",
            5: "1.25rem",
            6: "1.5rem",
            7: "1.75rem",
            8: "2rem",
            9: "2.25rem",
            10: "2.5rem",
            11: "2.75rem",
            12: "3rem",
            14: "3.5rem",
            16: "4rem",
            20: "5rem",
            24: "6rem",
            28: "7rem",
            32: "8rem",
            36: "9rem",
            40: "10rem",
            44: "11rem",
            48: "12rem",
            52: "13rem",
            56: "14rem",
            60: "15rem",
            64: "16rem",
            72: "18rem",
            80: "20rem",
            96: "24rem"
        },
        stroke: ({ theme: theme })=>(0, $9tqwB._)({
                none: "none"
            }, theme("colors")),
        strokeWidth: {
            0: "0",
            1: "1",
            2: "2"
        },
        supports: {},
        data: {},
        textColor: ({ theme: theme })=>theme("colors"),
        textDecorationColor: ({ theme: theme })=>theme("colors"),
        textDecorationThickness: {
            auto: "auto",
            "from-font": "from-font",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        textIndent: ({ theme: theme })=>(0, $9tqwB._)({}, theme("spacing")),
        textOpacity: ({ theme: theme })=>theme("opacity"),
        textUnderlineOffset: {
            auto: "auto",
            0: "0px",
            1: "1px",
            2: "2px",
            4: "4px",
            8: "8px"
        },
        transformOrigin: {
            center: "center",
            top: "top",
            "top-right": "top right",
            right: "right",
            "bottom-right": "bottom right",
            bottom: "bottom",
            "bottom-left": "bottom left",
            left: "left",
            "top-left": "top left"
        },
        transitionDelay: {
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionDuration: {
            DEFAULT: "150ms",
            0: "0s",
            75: "75ms",
            100: "100ms",
            150: "150ms",
            200: "200ms",
            300: "300ms",
            500: "500ms",
            700: "700ms",
            1000: "1000ms"
        },
        transitionProperty: {
            none: "none",
            all: "all",
            DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
            colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
            opacity: "opacity",
            shadow: "box-shadow",
            transform: "transform"
        },
        transitionTimingFunction: {
            DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
            linear: "linear",
            in: "cubic-bezier(0.4, 0, 1, 1)",
            out: "cubic-bezier(0, 0, 0.2, 1)",
            "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
        },
        translate: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({}, theme("spacing")), {
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                full: "100%"
            }),
        width: ({ theme: theme })=>(0, $2qxEV._)((0, $9tqwB._)({
                auto: "auto"
            }, theme("spacing")), {
                "1/2": "50%",
                "1/3": "33.333333%",
                "2/3": "66.666667%",
                "1/4": "25%",
                "2/4": "50%",
                "3/4": "75%",
                "1/5": "20%",
                "2/5": "40%",
                "3/5": "60%",
                "4/5": "80%",
                "1/6": "16.666667%",
                "2/6": "33.333333%",
                "3/6": "50%",
                "4/6": "66.666667%",
                "5/6": "83.333333%",
                "1/12": "8.333333%",
                "2/12": "16.666667%",
                "3/12": "25%",
                "4/12": "33.333333%",
                "5/12": "41.666667%",
                "6/12": "50%",
                "7/12": "58.333333%",
                "8/12": "66.666667%",
                "9/12": "75%",
                "10/12": "83.333333%",
                "11/12": "91.666667%",
                full: "100%",
                screen: "100vw",
                min: "min-content",
                max: "max-content",
                fit: "fit-content"
            }),
        willChange: {
            auto: "auto",
            scroll: "scroll-position",
            contents: "contents",
            transform: "transform"
        },
        zIndex: {
            auto: "auto",
            0: "0",
            10: "10",
            20: "20",
            30: "30",
            40: "40",
            50: "50"
        }
    },
    plugins: []
};

});


parcelRegister("l6Yrh", function(module, exports) {

var $kqnlk = parcelRequire("kqnlk");

var $aFSi5 = parcelRequire("aFSi5");

var $cErfA = parcelRequire("cErfA");

var $6oZBh = parcelRequire("6oZBh");
const [$f5e90a6b0aa732b5$var$baseFontSize, { lineHeight: $f5e90a6b0aa732b5$var$baseLineHeight }] = $cErfA.fontSize.base;
const { spacing: $f5e90a6b0aa732b5$var$spacing, borderWidth: $f5e90a6b0aa732b5$var$borderWidth, borderRadius: $f5e90a6b0aa732b5$var$borderRadius } = $cErfA;
const $f5e90a6b0aa732b5$var$forms = $aFSi5.withOptions(function(options = {
    strategy: undefined
}) {
    return function({ addBase: addBase, addComponents: addComponents, theme: theme }) {
        const strategy = options.strategy === undefined ? [
            "base",
            "class"
        ] : [
            options.strategy
        ];
        const rules = [
            {
                base: [
                    "[type='text']",
                    "[type='email']",
                    "[type='url']",
                    "[type='password']",
                    "[type='number']",
                    "[type='date']",
                    "[type='datetime-local']",
                    "[type='month']",
                    "[type='search']",
                    "[type='tel']",
                    "[type='time']",
                    "[type='week']",
                    "[multiple]",
                    "textarea",
                    "select"
                ],
                class: [
                    ".form-input",
                    ".form-textarea",
                    ".form-select",
                    ".form-multiselect"
                ],
                styles: {
                    appearance: "none",
                    "background-color": "#fff",
                    "border-color": theme("colors.gray.500", $6oZBh.gray[500]),
                    "border-width": $f5e90a6b0aa732b5$var$borderWidth["DEFAULT"],
                    "border-radius": $f5e90a6b0aa732b5$var$borderRadius.none,
                    "padding-top": $f5e90a6b0aa732b5$var$spacing[2],
                    "padding-right": $f5e90a6b0aa732b5$var$spacing[3],
                    "padding-bottom": $f5e90a6b0aa732b5$var$spacing[2],
                    "padding-left": $f5e90a6b0aa732b5$var$spacing[3],
                    "font-size": $f5e90a6b0aa732b5$var$baseFontSize,
                    "line-height": $f5e90a6b0aa732b5$var$baseLineHeight,
                    "--tw-shadow": "0 0 #0000",
                    "&:focus": {
                        outline: "2px solid transparent",
                        "outline-offset": "2px",
                        "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                        "--tw-ring-offset-width": "0px",
                        "--tw-ring-offset-color": "#fff",
                        "--tw-ring-color": theme("colors.blue.600", $6oZBh.blue[600]),
                        "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                        "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                        "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`,
                        "border-color": theme("colors.blue.600", $6oZBh.blue[600])
                    }
                }
            },
            {
                base: [
                    "input::placeholder",
                    "textarea::placeholder"
                ],
                class: [
                    ".form-input::placeholder",
                    ".form-textarea::placeholder"
                ],
                styles: {
                    color: theme("colors.gray.500", $6oZBh.gray[500]),
                    opacity: "1"
                }
            },
            {
                base: [
                    "::-webkit-datetime-edit-fields-wrapper"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit-fields-wrapper"
                ],
                styles: {
                    padding: "0"
                }
            },
            {
                // Unfortunate hack until https://bugs.webkit.org/show_bug.cgi?id=198959 is fixed.
                // This sucks because users can't change line-height with a utility on date inputs now.
                // Reference: https://github.com/twbs/bootstrap/pull/31993
                base: [
                    "::-webkit-date-and-time-value"
                ],
                class: [
                    ".form-input::-webkit-date-and-time-value"
                ],
                styles: {
                    "min-height": "1.5em"
                }
            },
            {
                // In Safari on macOS date time inputs are 4px taller than normal inputs
                // This is because there is extra padding on the datetime-edit and datetime-edit-{part}-field pseudo elements
                // See https://github.com/tailwindlabs/tailwindcss-forms/issues/95
                base: [
                    "::-webkit-datetime-edit",
                    "::-webkit-datetime-edit-year-field",
                    "::-webkit-datetime-edit-month-field",
                    "::-webkit-datetime-edit-day-field",
                    "::-webkit-datetime-edit-hour-field",
                    "::-webkit-datetime-edit-minute-field",
                    "::-webkit-datetime-edit-second-field",
                    "::-webkit-datetime-edit-millisecond-field",
                    "::-webkit-datetime-edit-meridiem-field"
                ],
                class: [
                    ".form-input::-webkit-datetime-edit",
                    ".form-input::-webkit-datetime-edit-year-field",
                    ".form-input::-webkit-datetime-edit-month-field",
                    ".form-input::-webkit-datetime-edit-day-field",
                    ".form-input::-webkit-datetime-edit-hour-field",
                    ".form-input::-webkit-datetime-edit-minute-field",
                    ".form-input::-webkit-datetime-edit-second-field",
                    ".form-input::-webkit-datetime-edit-millisecond-field",
                    ".form-input::-webkit-datetime-edit-meridiem-field"
                ],
                styles: {
                    "padding-top": 0,
                    "padding-bottom": 0
                }
            },
            {
                base: [
                    "select"
                ],
                class: [
                    ".form-select"
                ],
                styles: {
                    "background-image": `url("${$kqnlk(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path stroke="${theme("colors.gray.500", $6oZBh.gray[500])}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4"/></svg>`)}")`,
                    "background-position": `right ${$f5e90a6b0aa732b5$var$spacing[2]} center`,
                    "background-repeat": `no-repeat`,
                    "background-size": `1.5em 1.5em`,
                    "padding-right": $f5e90a6b0aa732b5$var$spacing[10],
                    "print-color-adjust": `exact`
                }
            },
            {
                base: [
                    "[multiple]"
                ],
                class: null,
                styles: {
                    "background-image": "initial",
                    "background-position": "initial",
                    "background-repeat": "unset",
                    "background-size": "initial",
                    "padding-right": $f5e90a6b0aa732b5$var$spacing[3],
                    "print-color-adjust": "unset"
                }
            },
            {
                base: [
                    `[type='checkbox']`,
                    `[type='radio']`
                ],
                class: [
                    ".form-checkbox",
                    ".form-radio"
                ],
                styles: {
                    appearance: "none",
                    padding: "0",
                    "print-color-adjust": "exact",
                    display: "inline-block",
                    "vertical-align": "middle",
                    "background-origin": "border-box",
                    "user-select": "none",
                    "flex-shrink": "0",
                    height: $f5e90a6b0aa732b5$var$spacing[4],
                    width: $f5e90a6b0aa732b5$var$spacing[4],
                    color: theme("colors.blue.600", $6oZBh.blue[600]),
                    "background-color": "#fff",
                    "border-color": theme("colors.gray.500", $6oZBh.gray[500]),
                    "border-width": $f5e90a6b0aa732b5$var$borderWidth["DEFAULT"],
                    "--tw-shadow": "0 0 #0000"
                }
            },
            {
                base: [
                    `[type='checkbox']`
                ],
                class: [
                    ".form-checkbox"
                ],
                styles: {
                    "border-radius": $f5e90a6b0aa732b5$var$borderRadius["none"]
                }
            },
            {
                base: [
                    `[type='radio']`
                ],
                class: [
                    ".form-radio"
                ],
                styles: {
                    "border-radius": "100%"
                }
            },
            {
                base: [
                    `[type='checkbox']:focus`,
                    `[type='radio']:focus`
                ],
                class: [
                    ".form-checkbox:focus",
                    ".form-radio:focus"
                ],
                styles: {
                    outline: "2px solid transparent",
                    "outline-offset": "2px",
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": "2px",
                    "--tw-ring-offset-color": "#fff",
                    "--tw-ring-color": theme("colors.blue.600", $6oZBh.blue[600]),
                    "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
                    "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
                    "box-shadow": `var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`,
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-checkbox:checked",
                    ".form-radio:checked"
                ],
                styles: {
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked`
                ],
                class: [
                    ".form-checkbox:checked"
                ],
                styles: {
                    "background-image": `url("${$kqnlk(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z"/></svg>`)}")`
                }
            },
            {
                base: [
                    `[type='radio']:checked`
                ],
                class: [
                    ".form-radio:checked"
                ],
                styles: {
                    "background-image": `url("${$kqnlk(`<svg viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="3"/></svg>`)}")`
                }
            },
            {
                base: [
                    `[type='checkbox']:checked:hover`,
                    `[type='checkbox']:checked:focus`,
                    `[type='radio']:checked:hover`,
                    `[type='radio']:checked:focus`
                ],
                class: [
                    ".form-checkbox:checked:hover",
                    ".form-checkbox:checked:focus",
                    ".form-radio:checked:hover",
                    ".form-radio:checked:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate`
                ],
                class: [
                    ".form-checkbox:indeterminate"
                ],
                styles: {
                    "background-image": `url("${$kqnlk(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h8"/></svg>`)}")`,
                    "border-color": `transparent`,
                    "background-color": `currentColor`,
                    "background-size": `100% 100%`,
                    "background-position": `center`,
                    "background-repeat": `no-repeat`
                }
            },
            {
                base: [
                    `[type='checkbox']:indeterminate:hover`,
                    `[type='checkbox']:indeterminate:focus`
                ],
                class: [
                    ".form-checkbox:indeterminate:hover",
                    ".form-checkbox:indeterminate:focus"
                ],
                styles: {
                    "border-color": "transparent",
                    "background-color": "currentColor"
                }
            },
            {
                base: [
                    `[type='file']`
                ],
                class: null,
                styles: {
                    background: "unset",
                    "border-color": "inherit",
                    "border-width": "0",
                    "border-radius": "0",
                    padding: "0",
                    "font-size": "unset",
                    "line-height": "inherit"
                }
            },
            {
                base: [
                    `[type='file']:focus`
                ],
                class: null,
                styles: {
                    outline: [
                        `1px solid ButtonText`,
                        `1px auto -webkit-focus-ring-color`
                    ]
                }
            }
        ];
        const getStrategyRules = (strategy)=>rules.map((rule)=>{
                if (rule[strategy] === null) return null;
                return {
                    [rule[strategy]]: rule.styles
                };
            }).filter(Boolean);
        if (strategy.includes("base")) addBase(getStrategyRules("base"));
        if (strategy.includes("class")) addComponents(getStrategyRules("class"));
    };
});
module.exports = $f5e90a6b0aa732b5$var$forms;

});
parcelRegister("kqnlk", function(module, exports) {

var $eRAnk = parcelRequire("eRAnk");
var $ede857c7a46d8eb7$var$REGEX = {
    whitespace: /\s+/g,
    urlHexPairs: /%[\dA-F]{2}/g,
    quotes: /"/g
};
function $ede857c7a46d8eb7$var$collapseWhitespace(str) {
    return str.trim().replace($ede857c7a46d8eb7$var$REGEX.whitespace, " ");
}
function $ede857c7a46d8eb7$var$dataURIPayload(string) {
    return encodeURIComponent(string).replace($ede857c7a46d8eb7$var$REGEX.urlHexPairs, $ede857c7a46d8eb7$var$specialHexEncode);
}
// `#` gets converted to `%23`, so quite a few CSS named colors are shorter than
// their equivalent URL-encoded hex codes.
function $ede857c7a46d8eb7$var$colorCodeToShorterNames(string) {
    Object.keys($eRAnk).forEach(function(key) {
        if ($eRAnk[key].test(string)) string = string.replace($eRAnk[key], key);
    });
    return string;
}
function $ede857c7a46d8eb7$var$specialHexEncode(match) {
    switch(match){
        case "%20":
            return " ";
        case "%3D":
            return "=";
        case "%3A":
            return ":";
        case "%2F":
            return "/";
        default:
            return match.toLowerCase(); // compresses better
    }
}
function $ede857c7a46d8eb7$var$svgToTinyDataUri(svgString) {
    if (typeof svgString !== "string") throw new TypeError("Expected a string, but received " + typeof svgString);
    // Strip the Byte-Order Mark if the SVG has one
    if (svgString.charCodeAt(0) === 0xfeff) svgString = svgString.slice(1);
    var body = $ede857c7a46d8eb7$var$colorCodeToShorterNames($ede857c7a46d8eb7$var$collapseWhitespace(svgString)).replace($ede857c7a46d8eb7$var$REGEX.quotes, "'");
    return "data:image/svg+xml," + $ede857c7a46d8eb7$var$dataURIPayload(body);
}
$ede857c7a46d8eb7$var$svgToTinyDataUri.toSrcset = function toSrcset(svgString) {
    return $ede857c7a46d8eb7$var$svgToTinyDataUri(svgString).replace(/ /g, "%20");
};
module.exports = $ede857c7a46d8eb7$var$svgToTinyDataUri;

});
parcelRegister("eRAnk", function(module, exports) {
module.exports = {
    aqua: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    azure: /#f0ffff(ff)?(?!\w)/gi,
    beige: /#f5f5dc(ff)?(?!\w)/gi,
    bisque: /#ffe4c4(ff)?(?!\w)/gi,
    black: /#000000(ff)?(?!\w)|#000(f)?(?!\w)/gi,
    blue: /#0000ff(ff)?(?!\w)|#00f(f)?(?!\w)/gi,
    brown: /#a52a2a(ff)?(?!\w)/gi,
    coral: /#ff7f50(ff)?(?!\w)/gi,
    cornsilk: /#fff8dc(ff)?(?!\w)/gi,
    crimson: /#dc143c(ff)?(?!\w)/gi,
    cyan: /#00ffff(ff)?(?!\w)|#0ff(f)?(?!\w)/gi,
    darkblue: /#00008b(ff)?(?!\w)/gi,
    darkcyan: /#008b8b(ff)?(?!\w)/gi,
    darkgrey: /#a9a9a9(ff)?(?!\w)/gi,
    darkred: /#8b0000(ff)?(?!\w)/gi,
    deeppink: /#ff1493(ff)?(?!\w)/gi,
    dimgrey: /#696969(ff)?(?!\w)/gi,
    gold: /#ffd700(ff)?(?!\w)/gi,
    green: /#008000(ff)?(?!\w)/gi,
    grey: /#808080(ff)?(?!\w)/gi,
    honeydew: /#f0fff0(ff)?(?!\w)/gi,
    hotpink: /#ff69b4(ff)?(?!\w)/gi,
    indigo: /#4b0082(ff)?(?!\w)/gi,
    ivory: /#fffff0(ff)?(?!\w)/gi,
    khaki: /#f0e68c(ff)?(?!\w)/gi,
    lavender: /#e6e6fa(ff)?(?!\w)/gi,
    lime: /#00ff00(ff)?(?!\w)|#0f0(f)?(?!\w)/gi,
    linen: /#faf0e6(ff)?(?!\w)/gi,
    maroon: /#800000(ff)?(?!\w)/gi,
    moccasin: /#ffe4b5(ff)?(?!\w)/gi,
    navy: /#000080(ff)?(?!\w)/gi,
    oldlace: /#fdf5e6(ff)?(?!\w)/gi,
    olive: /#808000(ff)?(?!\w)/gi,
    orange: /#ffa500(ff)?(?!\w)/gi,
    orchid: /#da70d6(ff)?(?!\w)/gi,
    peru: /#cd853f(ff)?(?!\w)/gi,
    pink: /#ffc0cb(ff)?(?!\w)/gi,
    plum: /#dda0dd(ff)?(?!\w)/gi,
    purple: /#800080(ff)?(?!\w)/gi,
    red: /#ff0000(ff)?(?!\w)|#f00(f)?(?!\w)/gi,
    salmon: /#fa8072(ff)?(?!\w)/gi,
    seagreen: /#2e8b57(ff)?(?!\w)/gi,
    seashell: /#fff5ee(ff)?(?!\w)/gi,
    sienna: /#a0522d(ff)?(?!\w)/gi,
    silver: /#c0c0c0(ff)?(?!\w)/gi,
    skyblue: /#87ceeb(ff)?(?!\w)/gi,
    snow: /#fffafa(ff)?(?!\w)/gi,
    tan: /#d2b48c(ff)?(?!\w)/gi,
    teal: /#008080(ff)?(?!\w)/gi,
    thistle: /#d8bfd8(ff)?(?!\w)/gi,
    tomato: /#ff6347(ff)?(?!\w)/gi,
    violet: /#ee82ee(ff)?(?!\w)/gi,
    wheat: /#f5deb3(ff)?(?!\w)/gi,
    white: /#ffffff(ff)?(?!\w)|#fff(f)?(?!\w)/gi
};

});


parcelRegister("aFSi5", function(module, exports) {

var $jgCrM = parcelRequire("jgCrM");
module.exports = ($jgCrM.__esModule ? $jgCrM : {
    default: $jgCrM
}).default;

});
parcelRegister("jgCrM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$e06d55b4a2a2b0bb$var$_default
});

const $e06d55b4a2a2b0bb$var$_createPlugin = /*#__PURE__*/ $e06d55b4a2a2b0bb$var$_interopRequireDefault((parcelRequire("jW7lo")));
function $e06d55b4a2a2b0bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e06d55b4a2a2b0bb$var$_default = $e06d55b4a2a2b0bb$var$_createPlugin.default;

});
parcelRegister("jW7lo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$e839217ef7a740ca$var$_default
});
function $e839217ef7a740ca$var$createPlugin(plugin, config) {
    return {
        handler: plugin,
        config: config
    };
}
$e839217ef7a740ca$var$createPlugin.withOptions = function(pluginFunction, configFunction = ()=>({})) {
    const optionsFunction = function(options) {
        return {
            __options: options,
            handler: pluginFunction(options),
            config: configFunction(options)
        };
    };
    optionsFunction.__isOptionsFunction = true;
    // Expose plugin dependencies so that `object-hash` returns a different
    // value if anything here changes, to ensure a rebuild is triggered.
    optionsFunction.__pluginFunction = pluginFunction;
    optionsFunction.__configFunction = configFunction;
    return optionsFunction;
};
const $e839217ef7a740ca$var$_default = $e839217ef7a740ca$var$createPlugin;

});



parcelRegister("cErfA", function(module, exports) {

var $kpR8a = parcelRequire("kpR8a");
module.exports = ($kpR8a.__esModule ? $kpR8a : {
    default: $kpR8a
}).default;

});
parcelRegister("kpR8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: ()=>$edcf5b1856ee0430$var$_default
});

var $6yIgu = parcelRequire("6yIgu");

const $edcf5b1856ee0430$var$_configFull = /*#__PURE__*/ $edcf5b1856ee0430$var$_interopRequireDefault((parcelRequire("51iZR")));
function $edcf5b1856ee0430$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $edcf5b1856ee0430$var$_default = (0, $6yIgu.cloneDeep)($edcf5b1856ee0430$var$_configFull.default.theme);

});


parcelRegister("6oZBh", function(module, exports) {

var $9se3A = parcelRequire("9se3A");
module.exports = ($9se3A.__esModule ? $9se3A : {
    default: $9se3A
}).default;

});


parcelRegister("aRkbg", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $aFSi5 = parcelRequire("aFSi5");
const $7e7e82112fc20249$var$baseStyles = {
    position: "relative",
    paddingBottom: `calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%)`
};
const $7e7e82112fc20249$var$childStyles = {
    position: "absolute",
    height: "100%",
    width: "100%",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0"
};
const $7e7e82112fc20249$var$noneComponent = {
    ".aspect-none": {
        position: "static",
        paddingBottom: "0"
    },
    ".aspect-none > *": {
        position: "static",
        height: "auto",
        width: "auto",
        top: "auto",
        right: "auto",
        bottom: "auto",
        left: "auto"
    }
};
const $7e7e82112fc20249$var$aspectRatio = $aFSi5(function({ addComponents: addComponents, matchComponents: matchComponents, theme: theme, variants: variants, e: e }) {
    const values = theme("aspectRatio");
    if (matchComponents) {
        matchComponents({
            "aspect-w": (value)=>[
                    (0, $2qxEV._)((0, $9tqwB._)({}, $7e7e82112fc20249$var$baseStyles), {
                        "--tw-aspect-w": value
                    }),
                    {
                        "> *": $7e7e82112fc20249$var$childStyles
                    }
                ],
            "aspect-h": (value)=>({
                    "--tw-aspect-h": value
                })
        }, {
            values: values
        });
        addComponents($7e7e82112fc20249$var$noneComponent);
        return;
    }
    const baseSelectors = Object.entries(values).map(([key, value])=>{
        return `.${e(`aspect-w-${key}`)}`;
    }).join(",\n");
    const childSelectors = Object.entries(values).map(([key, value])=>{
        return `.${e(`aspect-w-${key}`)} > *`;
    }).join(",\n");
    addComponents([
        {
            [baseSelectors]: $7e7e82112fc20249$var$baseStyles,
            [childSelectors]: $7e7e82112fc20249$var$childStyles
        },
        $7e7e82112fc20249$var$noneComponent,
        Object.entries(values).map(([key, value])=>{
            return {
                [`.${e(`aspect-w-${key}`)}`]: {
                    "--tw-aspect-w": value
                }
            };
        }),
        Object.entries(values).map(([key, value])=>{
            return {
                [`.${e(`aspect-h-${key}`)}`]: {
                    "--tw-aspect-h": value
                }
            };
        })
    ], variants("aspectRatio"));
}, {
    theme: {
        aspectRatio: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            7: "7",
            8: "8",
            9: "9",
            10: "10",
            11: "11",
            12: "12",
            13: "13",
            14: "14",
            15: "15",
            16: "16"
        }
    },
    variants: {
        aspectRatio: [
            "responsive"
        ]
    }
});
module.exports = $7e7e82112fc20249$var$aspectRatio;

});

parcelRegister("lECVJ", function(module, exports) {

var $aFSi5 = parcelRequire("aFSi5");

var $1l2Ix = parcelRequire("1l2Ix");

var $4qEsn = parcelRequire("4qEsn");

var $dsUJX = parcelRequire("dsUJX");

var $47zSa = parcelRequire("47zSa");
var $fc3b881fd441b64b$require$commonTrailingPseudos = $47zSa.commonTrailingPseudos;
const $fc3b881fd441b64b$var$computed = {
};
function $fc3b881fd441b64b$var$inWhere(selector, { className: className, modifier: modifier, prefix: prefix }) {
    let prefixedNot = prefix(`.not-${className}`).slice(1);
    let selectorPrefix = selector.startsWith(">") ? `${modifier === "DEFAULT" ? `.${className}` : `.${className}-${modifier}`} ` : "";
    // Parse the selector, if every component ends in the same pseudo element(s) then move it to the end
    let [trailingPseudo, rebuiltSelector] = $fc3b881fd441b64b$require$commonTrailingPseudos(selector);
    if (trailingPseudo) return `:where(${selectorPrefix}${rebuiltSelector}):not(:where([class~="${prefixedNot}"] *))${trailingPseudo}`;
    return `:where(${selectorPrefix}${selector}):not(:where([class~="${prefixedNot}"] *))`;
}
function $fc3b881fd441b64b$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
function $fc3b881fd441b64b$var$configToCss(config = {}, { target: target, className: className, modifier: modifier, prefix: prefix }) {
    function updateSelector(k, v) {
        if (target === "legacy") return [
            k,
            v
        ];
        if (Array.isArray(v)) return [
            k,
            v
        ];
        if ($fc3b881fd441b64b$var$isObject(v)) {
            let nested = Object.values(v).some($fc3b881fd441b64b$var$isObject);
            if (nested) return [
                $fc3b881fd441b64b$var$inWhere(k, {
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                }),
                v,
                Object.fromEntries(Object.entries(v).map(([k, v])=>updateSelector(k, v)))
            ];
            return [
                $fc3b881fd441b64b$var$inWhere(k, {
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                }),
                v
            ];
        }
        return [
            k,
            v
        ];
    }
    return Object.fromEntries(Object.entries($1l2Ix({}, ...Object.keys(config).filter((key)=>$fc3b881fd441b64b$var$computed[key]).map((key)=>$fc3b881fd441b64b$var$computed[key](config[key])), ...$4qEsn(config.css || {}))).map(([k, v])=>updateSelector(k, v)));
}
module.exports = $aFSi5.withOptions(({ className: className = "prose", target: target = "modern" } = {})=>{
    return function({ addVariant: addVariant, addComponents: addComponents, theme: theme, prefix: prefix }) {
        let modifiers = theme("typography");
        let options = {
            className: className,
            prefix: prefix
        };
        for (let [name, ...selectors] of [
            [
                "headings",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "th"
            ],
            [
                "h1"
            ],
            [
                "h2"
            ],
            [
                "h3"
            ],
            [
                "h4"
            ],
            [
                "h5"
            ],
            [
                "h6"
            ],
            [
                "p"
            ],
            [
                "a"
            ],
            [
                "blockquote"
            ],
            [
                "figure"
            ],
            [
                "figcaption"
            ],
            [
                "strong"
            ],
            [
                "em"
            ],
            [
                "code"
            ],
            [
                "pre"
            ],
            [
                "ol"
            ],
            [
                "ul"
            ],
            [
                "li"
            ],
            [
                "table"
            ],
            [
                "thead"
            ],
            [
                "tr"
            ],
            [
                "th"
            ],
            [
                "td"
            ],
            [
                "img"
            ],
            [
                "video"
            ],
            [
                "hr"
            ],
            [
                "lead",
                '[class~="lead"]'
            ]
        ]){
            selectors = selectors.length === 0 ? [
                name
            ] : selectors;
            let selector = target === "legacy" ? selectors.map((selector)=>`& ${selector}`) : selectors.join(", ");
            addVariant(`${className}-${name}`, target === "legacy" ? selector : `& :is(${$fc3b881fd441b64b$var$inWhere(selector, options)})`);
        }
        addComponents(Object.keys(modifiers).map((modifier)=>({
                [modifier === "DEFAULT" ? `.${className}` : `.${className}-${modifier}`]: $fc3b881fd441b64b$var$configToCss(modifiers[modifier], {
                    target: target,
                    className: className,
                    modifier: modifier,
                    prefix: prefix
                })
            })));
    };
}, ()=>{
    return {
        theme: {
            typography: $dsUJX
        }
    };
});

});
parcelRegister("1l2Ix", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("4qEsn", function(module, exports) {
/**
 * lodash 4.4.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $3398f902da04f3b8$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $3398f902da04f3b8$var$isArray(value) ? value : [
        value
    ];
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $3398f902da04f3b8$var$isArray = Array.isArray;
module.exports = $3398f902da04f3b8$var$castArray;

});

parcelRegister("dsUJX", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $6oZBh = parcelRequire("6oZBh");
const $9cd9e756bfe12b25$var$round = (num)=>num.toFixed(7).replace(/(\.[0-9]+?)0+$/, "$1").replace(/\.0$/, "");
const $9cd9e756bfe12b25$var$rem = (px)=>`${$9cd9e756bfe12b25$var$round(px / 16)}rem`;
const $9cd9e756bfe12b25$var$em = (px, base)=>`${$9cd9e756bfe12b25$var$round(px / base)}em`;
let $9cd9e756bfe12b25$var$defaultModifiers = {
    sm: {
        css: [
            {
                fontSize: $9cd9e756bfe12b25$var$rem(14),
                lineHeight: $9cd9e756bfe12b25$var$round(24 / 14),
                p: {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 14)
                },
                '[class~="lead"]': {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 14),
                    lineHeight: $9cd9e756bfe12b25$var$round(28 / 18),
                    marginTop: $9cd9e756bfe12b25$var$em(16, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 18)
                },
                blockquote: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 18),
                    paddingLeft: $9cd9e756bfe12b25$var$em(20, 18)
                },
                h1: {
                    fontSize: $9cd9e756bfe12b25$var$em(30, 14),
                    marginTop: "0",
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 30),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.2)
                },
                h2: {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 14),
                    marginTop: $9cd9e756bfe12b25$var$em(32, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.4)
                },
                h3: {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 14),
                    marginTop: $9cd9e756bfe12b25$var$em(28, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 18),
                    lineHeight: $9cd9e756bfe12b25$var$round(28 / 18)
                },
                h4: {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 14),
                    lineHeight: $9cd9e756bfe12b25$var$round(20 / 14)
                },
                img: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 14)
                },
                video: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 14)
                },
                figure: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 14)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9cd9e756bfe12b25$var$em(12, 14),
                    lineHeight: $9cd9e756bfe12b25$var$round(16 / 12),
                    marginTop: $9cd9e756bfe12b25$var$em(8, 12)
                },
                code: {
                    fontSize: $9cd9e756bfe12b25$var$em(12, 14)
                },
                "h2 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 20)
                },
                "h3 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(16, 18)
                },
                pre: {
                    fontSize: $9cd9e756bfe12b25$var$em(12, 14),
                    lineHeight: $9cd9e756bfe12b25$var$round(20 / 12),
                    marginTop: $9cd9e756bfe12b25$var$em(20, 12),
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 12),
                    borderRadius: $9cd9e756bfe12b25$var$rem(4),
                    paddingTop: $9cd9e756bfe12b25$var$em(8, 12),
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 12),
                    paddingBottom: $9cd9e756bfe12b25$var$em(8, 12),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 12)
                },
                ol: {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 14),
                    paddingLeft: $9cd9e756bfe12b25$var$em(22, 14)
                },
                ul: {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 14),
                    paddingLeft: $9cd9e756bfe12b25$var$em(22, 14)
                },
                li: {
                    marginTop: $9cd9e756bfe12b25$var$em(4, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(4, 14)
                },
                "ol > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(6, 14)
                },
                "ul > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(6, 14)
                },
                "> ul > li p": {
                    marginTop: $9cd9e756bfe12b25$var$em(8, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 14)
                },
                "> ul > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 14)
                },
                "> ul > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 14)
                },
                "> ol > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 14)
                },
                "> ol > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 14)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9cd9e756bfe12b25$var$em(8, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 14)
                },
                hr: {
                    marginTop: $9cd9e756bfe12b25$var$em(40, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 14)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9cd9e756bfe12b25$var$em(12, 14),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5)
                },
                "thead th": {
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 12),
                    paddingBottom: $9cd9e756bfe12b25$var$em(8, 12),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 12)
                },
                "thead th:first-child": {
                    paddingLeft: "0"
                },
                "thead th:last-child": {
                    paddingRight: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9cd9e756bfe12b25$var$em(8, 12),
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 12),
                    paddingBottom: $9cd9e756bfe12b25$var$em(8, 12),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 12)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingLeft: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingRight: "0"
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    base: {
        css: [
            {
                fontSize: $9cd9e756bfe12b25$var$rem(16),
                lineHeight: $9cd9e756bfe12b25$var$round(1.75),
                p: {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 16)
                },
                '[class~="lead"]': {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 16),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.6),
                    marginTop: $9cd9e756bfe12b25$var$em(24, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 20)
                },
                blockquote: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 20),
                    paddingLeft: $9cd9e756bfe12b25$var$em(20, 20)
                },
                h1: {
                    fontSize: $9cd9e756bfe12b25$var$em(36, 16),
                    marginTop: "0",
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 36),
                    lineHeight: $9cd9e756bfe12b25$var$round(40 / 36)
                },
                h2: {
                    fontSize: $9cd9e756bfe12b25$var$em(24, 16),
                    marginTop: $9cd9e756bfe12b25$var$em(48, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(32 / 24)
                },
                h3: {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 16),
                    marginTop: $9cd9e756bfe12b25$var$em(32, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.6)
                },
                h4: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 16),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5)
                },
                img: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 16)
                },
                video: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 16)
                },
                figure: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 16)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9cd9e756bfe12b25$var$em(14, 16),
                    lineHeight: $9cd9e756bfe12b25$var$round(20 / 14),
                    marginTop: $9cd9e756bfe12b25$var$em(12, 14)
                },
                code: {
                    fontSize: $9cd9e756bfe12b25$var$em(14, 16)
                },
                "h2 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(21, 24)
                },
                "h3 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 20)
                },
                pre: {
                    fontSize: $9cd9e756bfe12b25$var$em(14, 16),
                    lineHeight: $9cd9e756bfe12b25$var$round(24 / 14),
                    marginTop: $9cd9e756bfe12b25$var$em(24, 14),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 14),
                    borderRadius: $9cd9e756bfe12b25$var$rem(6),
                    paddingTop: $9cd9e756bfe12b25$var$em(12, 14),
                    paddingRight: $9cd9e756bfe12b25$var$em(16, 14),
                    paddingBottom: $9cd9e756bfe12b25$var$em(12, 14),
                    paddingLeft: $9cd9e756bfe12b25$var$em(16, 14)
                },
                ol: {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 16),
                    paddingLeft: $9cd9e756bfe12b25$var$em(26, 16)
                },
                ul: {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 16),
                    paddingLeft: $9cd9e756bfe12b25$var$em(26, 16)
                },
                li: {
                    marginTop: $9cd9e756bfe12b25$var$em(8, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 16)
                },
                "ol > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(6, 16)
                },
                "ul > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(6, 16)
                },
                "> ul > li p": {
                    marginTop: $9cd9e756bfe12b25$var$em(12, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 16)
                },
                "> ul > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 16)
                },
                "> ul > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 16)
                },
                "> ol > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 16)
                },
                "> ol > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 16)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9cd9e756bfe12b25$var$em(12, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 16)
                },
                hr: {
                    marginTop: $9cd9e756bfe12b25$var$em(48, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(48, 16)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9cd9e756bfe12b25$var$em(14, 16),
                    lineHeight: $9cd9e756bfe12b25$var$round(24 / 14)
                },
                "thead th": {
                    paddingRight: $9cd9e756bfe12b25$var$em(8, 14),
                    paddingBottom: $9cd9e756bfe12b25$var$em(8, 14),
                    paddingLeft: $9cd9e756bfe12b25$var$em(8, 14)
                },
                "thead th:first-child": {
                    paddingLeft: "0"
                },
                "thead th:last-child": {
                    paddingRight: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9cd9e756bfe12b25$var$em(8, 14),
                    paddingRight: $9cd9e756bfe12b25$var$em(8, 14),
                    paddingBottom: $9cd9e756bfe12b25$var$em(8, 14),
                    paddingLeft: $9cd9e756bfe12b25$var$em(8, 14)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingLeft: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingRight: "0"
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    lg: {
        css: [
            {
                fontSize: $9cd9e756bfe12b25$var$rem(18),
                lineHeight: $9cd9e756bfe12b25$var$round(32 / 18),
                p: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 18)
                },
                '[class~="lead"]': {
                    fontSize: $9cd9e756bfe12b25$var$em(22, 18),
                    lineHeight: $9cd9e756bfe12b25$var$round(32 / 22),
                    marginTop: $9cd9e756bfe12b25$var$em(24, 22),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 22)
                },
                blockquote: {
                    marginTop: $9cd9e756bfe12b25$var$em(40, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 24),
                    paddingLeft: $9cd9e756bfe12b25$var$em(24, 24)
                },
                h1: {
                    fontSize: $9cd9e756bfe12b25$var$em(48, 18),
                    marginTop: "0",
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 48),
                    lineHeight: $9cd9e756bfe12b25$var$round(1)
                },
                h2: {
                    fontSize: $9cd9e756bfe12b25$var$em(30, 18),
                    marginTop: $9cd9e756bfe12b25$var$em(56, 30),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 30),
                    lineHeight: $9cd9e756bfe12b25$var$round(40 / 30)
                },
                h3: {
                    fontSize: $9cd9e756bfe12b25$var$em(24, 18),
                    marginTop: $9cd9e756bfe12b25$var$em(40, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5)
                },
                h4: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(8, 18),
                    lineHeight: $9cd9e756bfe12b25$var$round(28 / 18)
                },
                img: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 18)
                },
                video: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 18)
                },
                figure: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 18)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9cd9e756bfe12b25$var$em(16, 18),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5),
                    marginTop: $9cd9e756bfe12b25$var$em(16, 16)
                },
                code: {
                    fontSize: $9cd9e756bfe12b25$var$em(16, 18)
                },
                "h2 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(26, 30)
                },
                "h3 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(21, 24)
                },
                pre: {
                    fontSize: $9cd9e756bfe12b25$var$em(16, 18),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.75),
                    marginTop: $9cd9e756bfe12b25$var$em(32, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 16),
                    borderRadius: $9cd9e756bfe12b25$var$rem(6),
                    paddingTop: $9cd9e756bfe12b25$var$em(16, 16),
                    paddingRight: $9cd9e756bfe12b25$var$em(24, 16),
                    paddingBottom: $9cd9e756bfe12b25$var$em(16, 16),
                    paddingLeft: $9cd9e756bfe12b25$var$em(24, 16)
                },
                ol: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 18),
                    paddingLeft: $9cd9e756bfe12b25$var$em(28, 18)
                },
                ul: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 18),
                    paddingLeft: $9cd9e756bfe12b25$var$em(28, 18)
                },
                li: {
                    marginTop: $9cd9e756bfe12b25$var$em(12, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 18)
                },
                "ol > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(8, 18)
                },
                "ul > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(8, 18)
                },
                "> ul > li p": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 18)
                },
                "> ul > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 18)
                },
                "> ul > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 18)
                },
                "> ol > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 18)
                },
                "> ol > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 18)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 18)
                },
                hr: {
                    marginTop: $9cd9e756bfe12b25$var$em(56, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(56, 18)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9cd9e756bfe12b25$var$em(16, 18),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5)
                },
                "thead th": {
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 16),
                    paddingBottom: $9cd9e756bfe12b25$var$em(12, 16),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 16)
                },
                "thead th:first-child": {
                    paddingLeft: "0"
                },
                "thead th:last-child": {
                    paddingRight: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9cd9e756bfe12b25$var$em(12, 16),
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 16),
                    paddingBottom: $9cd9e756bfe12b25$var$em(12, 16),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 16)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingLeft: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingRight: "0"
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    xl: {
        css: [
            {
                fontSize: $9cd9e756bfe12b25$var$rem(20),
                lineHeight: $9cd9e756bfe12b25$var$round(1.8),
                p: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 20)
                },
                '[class~="lead"]': {
                    fontSize: $9cd9e756bfe12b25$var$em(24, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5),
                    marginTop: $9cd9e756bfe12b25$var$em(24, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 24)
                },
                blockquote: {
                    marginTop: $9cd9e756bfe12b25$var$em(48, 30),
                    marginBottom: $9cd9e756bfe12b25$var$em(48, 30),
                    paddingLeft: $9cd9e756bfe12b25$var$em(32, 30)
                },
                h1: {
                    fontSize: $9cd9e756bfe12b25$var$em(56, 20),
                    marginTop: "0",
                    marginBottom: $9cd9e756bfe12b25$var$em(48, 56),
                    lineHeight: $9cd9e756bfe12b25$var$round(1)
                },
                h2: {
                    fontSize: $9cd9e756bfe12b25$var$em(36, 20),
                    marginTop: $9cd9e756bfe12b25$var$em(56, 36),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 36),
                    lineHeight: $9cd9e756bfe12b25$var$round(40 / 36)
                },
                h3: {
                    fontSize: $9cd9e756bfe12b25$var$em(30, 20),
                    marginTop: $9cd9e756bfe12b25$var$em(48, 30),
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 30),
                    lineHeight: $9cd9e756bfe12b25$var$round(40 / 30)
                },
                h4: {
                    marginTop: $9cd9e756bfe12b25$var$em(36, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.6)
                },
                img: {
                    marginTop: $9cd9e756bfe12b25$var$em(40, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 20)
                },
                video: {
                    marginTop: $9cd9e756bfe12b25$var$em(40, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 20)
                },
                figure: {
                    marginTop: $9cd9e756bfe12b25$var$em(40, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 20)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(28 / 18),
                    marginTop: $9cd9e756bfe12b25$var$em(18, 18)
                },
                code: {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 20)
                },
                "h2 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(31, 36)
                },
                "h3 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(27, 30)
                },
                pre: {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(32 / 18),
                    marginTop: $9cd9e756bfe12b25$var$em(36, 18),
                    marginBottom: $9cd9e756bfe12b25$var$em(36, 18),
                    borderRadius: $9cd9e756bfe12b25$var$rem(8),
                    paddingTop: $9cd9e756bfe12b25$var$em(20, 18),
                    paddingRight: $9cd9e756bfe12b25$var$em(24, 18),
                    paddingBottom: $9cd9e756bfe12b25$var$em(20, 18),
                    paddingLeft: $9cd9e756bfe12b25$var$em(24, 18)
                },
                ol: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 20),
                    paddingLeft: $9cd9e756bfe12b25$var$em(32, 20)
                },
                ul: {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 20),
                    paddingLeft: $9cd9e756bfe12b25$var$em(32, 20)
                },
                li: {
                    marginTop: $9cd9e756bfe12b25$var$em(12, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 20)
                },
                "ol > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(8, 20)
                },
                "ul > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(8, 20)
                },
                "> ul > li p": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 20)
                },
                "> ul > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 20)
                },
                "> ul > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 20)
                },
                "> ol > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(24, 20)
                },
                "> ol > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 20)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 20)
                },
                hr: {
                    marginTop: $9cd9e756bfe12b25$var$em(56, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(56, 20)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9cd9e756bfe12b25$var$em(18, 20),
                    lineHeight: $9cd9e756bfe12b25$var$round(28 / 18)
                },
                "thead th": {
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 18),
                    paddingBottom: $9cd9e756bfe12b25$var$em(16, 18),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 18)
                },
                "thead th:first-child": {
                    paddingLeft: "0"
                },
                "thead th:last-child": {
                    paddingRight: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9cd9e756bfe12b25$var$em(16, 18),
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 18),
                    paddingBottom: $9cd9e756bfe12b25$var$em(16, 18),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 18)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingLeft: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingRight: "0"
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    "2xl": {
        css: [
            {
                fontSize: $9cd9e756bfe12b25$var$rem(24),
                lineHeight: $9cd9e756bfe12b25$var$round(40 / 24),
                p: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 24)
                },
                '[class~="lead"]': {
                    fontSize: $9cd9e756bfe12b25$var$em(30, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(44 / 30),
                    marginTop: $9cd9e756bfe12b25$var$em(32, 30),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 30)
                },
                blockquote: {
                    marginTop: $9cd9e756bfe12b25$var$em(64, 36),
                    marginBottom: $9cd9e756bfe12b25$var$em(64, 36),
                    paddingLeft: $9cd9e756bfe12b25$var$em(40, 36)
                },
                h1: {
                    fontSize: $9cd9e756bfe12b25$var$em(64, 24),
                    marginTop: "0",
                    marginBottom: $9cd9e756bfe12b25$var$em(56, 64),
                    lineHeight: $9cd9e756bfe12b25$var$round(1)
                },
                h2: {
                    fontSize: $9cd9e756bfe12b25$var$em(48, 24),
                    marginTop: $9cd9e756bfe12b25$var$em(72, 48),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 48),
                    lineHeight: $9cd9e756bfe12b25$var$round(52 / 48)
                },
                h3: {
                    fontSize: $9cd9e756bfe12b25$var$em(36, 24),
                    marginTop: $9cd9e756bfe12b25$var$em(56, 36),
                    marginBottom: $9cd9e756bfe12b25$var$em(24, 36),
                    lineHeight: $9cd9e756bfe12b25$var$round(44 / 36)
                },
                h4: {
                    marginTop: $9cd9e756bfe12b25$var$em(40, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.5)
                },
                img: {
                    marginTop: $9cd9e756bfe12b25$var$em(48, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(48, 24)
                },
                video: {
                    marginTop: $9cd9e756bfe12b25$var$em(48, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(48, 24)
                },
                figure: {
                    marginTop: $9cd9e756bfe12b25$var$em(48, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(48, 24)
                },
                "figure > *": {
                    marginTop: "0",
                    marginBottom: "0"
                },
                figcaption: {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.6),
                    marginTop: $9cd9e756bfe12b25$var$em(20, 20)
                },
                code: {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 24)
                },
                "h2 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(42, 48)
                },
                "h3 code": {
                    fontSize: $9cd9e756bfe12b25$var$em(32, 36)
                },
                pre: {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.8),
                    marginTop: $9cd9e756bfe12b25$var$em(40, 20),
                    marginBottom: $9cd9e756bfe12b25$var$em(40, 20),
                    borderRadius: $9cd9e756bfe12b25$var$rem(8),
                    paddingTop: $9cd9e756bfe12b25$var$em(24, 20),
                    paddingRight: $9cd9e756bfe12b25$var$em(32, 20),
                    paddingBottom: $9cd9e756bfe12b25$var$em(24, 20),
                    paddingLeft: $9cd9e756bfe12b25$var$em(32, 20)
                },
                ol: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 24),
                    paddingLeft: $9cd9e756bfe12b25$var$em(38, 24)
                },
                ul: {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 24),
                    paddingLeft: $9cd9e756bfe12b25$var$em(38, 24)
                },
                li: {
                    marginTop: $9cd9e756bfe12b25$var$em(12, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(12, 24)
                },
                "ol > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(10, 24)
                },
                "ul > li": {
                    paddingLeft: $9cd9e756bfe12b25$var$em(10, 24)
                },
                "> ul > li p": {
                    marginTop: $9cd9e756bfe12b25$var$em(20, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(20, 24)
                },
                "> ul > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 24)
                },
                "> ul > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 24)
                },
                "> ol > li > *:first-child": {
                    marginTop: $9cd9e756bfe12b25$var$em(32, 24)
                },
                "> ol > li > *:last-child": {
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 24)
                },
                "ul ul, ul ol, ol ul, ol ol": {
                    marginTop: $9cd9e756bfe12b25$var$em(16, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(16, 24)
                },
                hr: {
                    marginTop: $9cd9e756bfe12b25$var$em(72, 24),
                    marginBottom: $9cd9e756bfe12b25$var$em(72, 24)
                },
                "hr + *": {
                    marginTop: "0"
                },
                "h2 + *": {
                    marginTop: "0"
                },
                "h3 + *": {
                    marginTop: "0"
                },
                "h4 + *": {
                    marginTop: "0"
                },
                table: {
                    fontSize: $9cd9e756bfe12b25$var$em(20, 24),
                    lineHeight: $9cd9e756bfe12b25$var$round(1.4)
                },
                "thead th": {
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 20),
                    paddingBottom: $9cd9e756bfe12b25$var$em(16, 20),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 20)
                },
                "thead th:first-child": {
                    paddingLeft: "0"
                },
                "thead th:last-child": {
                    paddingRight: "0"
                },
                "tbody td, tfoot td": {
                    paddingTop: $9cd9e756bfe12b25$var$em(16, 20),
                    paddingRight: $9cd9e756bfe12b25$var$em(12, 20),
                    paddingBottom: $9cd9e756bfe12b25$var$em(16, 20),
                    paddingLeft: $9cd9e756bfe12b25$var$em(12, 20)
                },
                "tbody td:first-child, tfoot td:first-child": {
                    paddingLeft: "0"
                },
                "tbody td:last-child, tfoot td:last-child": {
                    paddingRight: "0"
                }
            },
            {
                "> :first-child": {
                    marginTop: "0"
                },
                "> :last-child": {
                    marginBottom: "0"
                }
            }
        ]
    },
    // Invert (for dark mode)
    invert: {
        css: {
            "--tw-prose-body": "var(--tw-prose-invert-body)",
            "--tw-prose-headings": "var(--tw-prose-invert-headings)",
            "--tw-prose-lead": "var(--tw-prose-invert-lead)",
            "--tw-prose-links": "var(--tw-prose-invert-links)",
            "--tw-prose-bold": "var(--tw-prose-invert-bold)",
            "--tw-prose-counters": "var(--tw-prose-invert-counters)",
            "--tw-prose-bullets": "var(--tw-prose-invert-bullets)",
            "--tw-prose-hr": "var(--tw-prose-invert-hr)",
            "--tw-prose-quotes": "var(--tw-prose-invert-quotes)",
            "--tw-prose-quote-borders": "var(--tw-prose-invert-quote-borders)",
            "--tw-prose-captions": "var(--tw-prose-invert-captions)",
            "--tw-prose-code": "var(--tw-prose-invert-code)",
            "--tw-prose-pre-code": "var(--tw-prose-invert-pre-code)",
            "--tw-prose-pre-bg": "var(--tw-prose-invert-pre-bg)",
            "--tw-prose-th-borders": "var(--tw-prose-invert-th-borders)",
            "--tw-prose-td-borders": "var(--tw-prose-invert-td-borders)"
        }
    },
    // Gray color themes
    slate: {
        css: {
            "--tw-prose-body": $6oZBh.slate[700],
            "--tw-prose-headings": $6oZBh.slate[900],
            "--tw-prose-lead": $6oZBh.slate[600],
            "--tw-prose-links": $6oZBh.slate[900],
            "--tw-prose-bold": $6oZBh.slate[900],
            "--tw-prose-counters": $6oZBh.slate[500],
            "--tw-prose-bullets": $6oZBh.slate[300],
            "--tw-prose-hr": $6oZBh.slate[200],
            "--tw-prose-quotes": $6oZBh.slate[900],
            "--tw-prose-quote-borders": $6oZBh.slate[200],
            "--tw-prose-captions": $6oZBh.slate[500],
            "--tw-prose-code": $6oZBh.slate[900],
            "--tw-prose-pre-code": $6oZBh.slate[200],
            "--tw-prose-pre-bg": $6oZBh.slate[800],
            "--tw-prose-th-borders": $6oZBh.slate[300],
            "--tw-prose-td-borders": $6oZBh.slate[200],
            "--tw-prose-invert-body": $6oZBh.slate[300],
            "--tw-prose-invert-headings": $6oZBh.white,
            "--tw-prose-invert-lead": $6oZBh.slate[400],
            "--tw-prose-invert-links": $6oZBh.white,
            "--tw-prose-invert-bold": $6oZBh.white,
            "--tw-prose-invert-counters": $6oZBh.slate[400],
            "--tw-prose-invert-bullets": $6oZBh.slate[600],
            "--tw-prose-invert-hr": $6oZBh.slate[700],
            "--tw-prose-invert-quotes": $6oZBh.slate[100],
            "--tw-prose-invert-quote-borders": $6oZBh.slate[700],
            "--tw-prose-invert-captions": $6oZBh.slate[400],
            "--tw-prose-invert-code": $6oZBh.white,
            "--tw-prose-invert-pre-code": $6oZBh.slate[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $6oZBh.slate[600],
            "--tw-prose-invert-td-borders": $6oZBh.slate[700]
        }
    },
    gray: {
        css: {
            "--tw-prose-body": $6oZBh.gray[700],
            "--tw-prose-headings": $6oZBh.gray[900],
            "--tw-prose-lead": $6oZBh.gray[600],
            "--tw-prose-links": $6oZBh.gray[900],
            "--tw-prose-bold": $6oZBh.gray[900],
            "--tw-prose-counters": $6oZBh.gray[500],
            "--tw-prose-bullets": $6oZBh.gray[300],
            "--tw-prose-hr": $6oZBh.gray[200],
            "--tw-prose-quotes": $6oZBh.gray[900],
            "--tw-prose-quote-borders": $6oZBh.gray[200],
            "--tw-prose-captions": $6oZBh.gray[500],
            "--tw-prose-code": $6oZBh.gray[900],
            "--tw-prose-pre-code": $6oZBh.gray[200],
            "--tw-prose-pre-bg": $6oZBh.gray[800],
            "--tw-prose-th-borders": $6oZBh.gray[300],
            "--tw-prose-td-borders": $6oZBh.gray[200],
            "--tw-prose-invert-body": $6oZBh.gray[300],
            "--tw-prose-invert-headings": $6oZBh.white,
            "--tw-prose-invert-lead": $6oZBh.gray[400],
            "--tw-prose-invert-links": $6oZBh.white,
            "--tw-prose-invert-bold": $6oZBh.white,
            "--tw-prose-invert-counters": $6oZBh.gray[400],
            "--tw-prose-invert-bullets": $6oZBh.gray[600],
            "--tw-prose-invert-hr": $6oZBh.gray[700],
            "--tw-prose-invert-quotes": $6oZBh.gray[100],
            "--tw-prose-invert-quote-borders": $6oZBh.gray[700],
            "--tw-prose-invert-captions": $6oZBh.gray[400],
            "--tw-prose-invert-code": $6oZBh.white,
            "--tw-prose-invert-pre-code": $6oZBh.gray[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $6oZBh.gray[600],
            "--tw-prose-invert-td-borders": $6oZBh.gray[700]
        }
    },
    zinc: {
        css: {
            "--tw-prose-body": $6oZBh.zinc[700],
            "--tw-prose-headings": $6oZBh.zinc[900],
            "--tw-prose-lead": $6oZBh.zinc[600],
            "--tw-prose-links": $6oZBh.zinc[900],
            "--tw-prose-bold": $6oZBh.zinc[900],
            "--tw-prose-counters": $6oZBh.zinc[500],
            "--tw-prose-bullets": $6oZBh.zinc[300],
            "--tw-prose-hr": $6oZBh.zinc[200],
            "--tw-prose-quotes": $6oZBh.zinc[900],
            "--tw-prose-quote-borders": $6oZBh.zinc[200],
            "--tw-prose-captions": $6oZBh.zinc[500],
            "--tw-prose-code": $6oZBh.zinc[900],
            "--tw-prose-pre-code": $6oZBh.zinc[200],
            "--tw-prose-pre-bg": $6oZBh.zinc[800],
            "--tw-prose-th-borders": $6oZBh.zinc[300],
            "--tw-prose-td-borders": $6oZBh.zinc[200],
            "--tw-prose-invert-body": $6oZBh.zinc[300],
            "--tw-prose-invert-headings": $6oZBh.white,
            "--tw-prose-invert-lead": $6oZBh.zinc[400],
            "--tw-prose-invert-links": $6oZBh.white,
            "--tw-prose-invert-bold": $6oZBh.white,
            "--tw-prose-invert-counters": $6oZBh.zinc[400],
            "--tw-prose-invert-bullets": $6oZBh.zinc[600],
            "--tw-prose-invert-hr": $6oZBh.zinc[700],
            "--tw-prose-invert-quotes": $6oZBh.zinc[100],
            "--tw-prose-invert-quote-borders": $6oZBh.zinc[700],
            "--tw-prose-invert-captions": $6oZBh.zinc[400],
            "--tw-prose-invert-code": $6oZBh.white,
            "--tw-prose-invert-pre-code": $6oZBh.zinc[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $6oZBh.zinc[600],
            "--tw-prose-invert-td-borders": $6oZBh.zinc[700]
        }
    },
    neutral: {
        css: {
            "--tw-prose-body": $6oZBh.neutral[700],
            "--tw-prose-headings": $6oZBh.neutral[900],
            "--tw-prose-lead": $6oZBh.neutral[600],
            "--tw-prose-links": $6oZBh.neutral[900],
            "--tw-prose-bold": $6oZBh.neutral[900],
            "--tw-prose-counters": $6oZBh.neutral[500],
            "--tw-prose-bullets": $6oZBh.neutral[300],
            "--tw-prose-hr": $6oZBh.neutral[200],
            "--tw-prose-quotes": $6oZBh.neutral[900],
            "--tw-prose-quote-borders": $6oZBh.neutral[200],
            "--tw-prose-captions": $6oZBh.neutral[500],
            "--tw-prose-code": $6oZBh.neutral[900],
            "--tw-prose-pre-code": $6oZBh.neutral[200],
            "--tw-prose-pre-bg": $6oZBh.neutral[800],
            "--tw-prose-th-borders": $6oZBh.neutral[300],
            "--tw-prose-td-borders": $6oZBh.neutral[200],
            "--tw-prose-invert-body": $6oZBh.neutral[300],
            "--tw-prose-invert-headings": $6oZBh.white,
            "--tw-prose-invert-lead": $6oZBh.neutral[400],
            "--tw-prose-invert-links": $6oZBh.white,
            "--tw-prose-invert-bold": $6oZBh.white,
            "--tw-prose-invert-counters": $6oZBh.neutral[400],
            "--tw-prose-invert-bullets": $6oZBh.neutral[600],
            "--tw-prose-invert-hr": $6oZBh.neutral[700],
            "--tw-prose-invert-quotes": $6oZBh.neutral[100],
            "--tw-prose-invert-quote-borders": $6oZBh.neutral[700],
            "--tw-prose-invert-captions": $6oZBh.neutral[400],
            "--tw-prose-invert-code": $6oZBh.white,
            "--tw-prose-invert-pre-code": $6oZBh.neutral[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $6oZBh.neutral[600],
            "--tw-prose-invert-td-borders": $6oZBh.neutral[700]
        }
    },
    stone: {
        css: {
            "--tw-prose-body": $6oZBh.stone[700],
            "--tw-prose-headings": $6oZBh.stone[900],
            "--tw-prose-lead": $6oZBh.stone[600],
            "--tw-prose-links": $6oZBh.stone[900],
            "--tw-prose-bold": $6oZBh.stone[900],
            "--tw-prose-counters": $6oZBh.stone[500],
            "--tw-prose-bullets": $6oZBh.stone[300],
            "--tw-prose-hr": $6oZBh.stone[200],
            "--tw-prose-quotes": $6oZBh.stone[900],
            "--tw-prose-quote-borders": $6oZBh.stone[200],
            "--tw-prose-captions": $6oZBh.stone[500],
            "--tw-prose-code": $6oZBh.stone[900],
            "--tw-prose-pre-code": $6oZBh.stone[200],
            "--tw-prose-pre-bg": $6oZBh.stone[800],
            "--tw-prose-th-borders": $6oZBh.stone[300],
            "--tw-prose-td-borders": $6oZBh.stone[200],
            "--tw-prose-invert-body": $6oZBh.stone[300],
            "--tw-prose-invert-headings": $6oZBh.white,
            "--tw-prose-invert-lead": $6oZBh.stone[400],
            "--tw-prose-invert-links": $6oZBh.white,
            "--tw-prose-invert-bold": $6oZBh.white,
            "--tw-prose-invert-counters": $6oZBh.stone[400],
            "--tw-prose-invert-bullets": $6oZBh.stone[600],
            "--tw-prose-invert-hr": $6oZBh.stone[700],
            "--tw-prose-invert-quotes": $6oZBh.stone[100],
            "--tw-prose-invert-quote-borders": $6oZBh.stone[700],
            "--tw-prose-invert-captions": $6oZBh.stone[400],
            "--tw-prose-invert-code": $6oZBh.white,
            "--tw-prose-invert-pre-code": $6oZBh.stone[300],
            "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
            "--tw-prose-invert-th-borders": $6oZBh.stone[600],
            "--tw-prose-invert-td-borders": $6oZBh.stone[700]
        }
    },
    // Link-only themes (for backward compatibility)
    red: {
        css: {
            "--tw-prose-links": $6oZBh.red[600],
            "--tw-prose-invert-links": $6oZBh.red[500]
        }
    },
    orange: {
        css: {
            "--tw-prose-links": $6oZBh.orange[600],
            "--tw-prose-invert-links": $6oZBh.orange[500]
        }
    },
    amber: {
        css: {
            "--tw-prose-links": $6oZBh.amber[600],
            "--tw-prose-invert-links": $6oZBh.amber[500]
        }
    },
    yellow: {
        css: {
            "--tw-prose-links": $6oZBh.yellow[600],
            "--tw-prose-invert-links": $6oZBh.yellow[500]
        }
    },
    lime: {
        css: {
            "--tw-prose-links": $6oZBh.lime[600],
            "--tw-prose-invert-links": $6oZBh.lime[500]
        }
    },
    green: {
        css: {
            "--tw-prose-links": $6oZBh.green[600],
            "--tw-prose-invert-links": $6oZBh.green[500]
        }
    },
    emerald: {
        css: {
            "--tw-prose-links": $6oZBh.emerald[600],
            "--tw-prose-invert-links": $6oZBh.emerald[500]
        }
    },
    teal: {
        css: {
            "--tw-prose-links": $6oZBh.teal[600],
            "--tw-prose-invert-links": $6oZBh.teal[500]
        }
    },
    cyan: {
        css: {
            "--tw-prose-links": $6oZBh.cyan[600],
            "--tw-prose-invert-links": $6oZBh.cyan[500]
        }
    },
    sky: {
        css: {
            "--tw-prose-links": $6oZBh.sky[600],
            "--tw-prose-invert-links": $6oZBh.sky[500]
        }
    },
    blue: {
        css: {
            "--tw-prose-links": $6oZBh.blue[600],
            "--tw-prose-invert-links": $6oZBh.blue[500]
        }
    },
    indigo: {
        css: {
            "--tw-prose-links": $6oZBh.indigo[600],
            "--tw-prose-invert-links": $6oZBh.indigo[500]
        }
    },
    violet: {
        css: {
            "--tw-prose-links": $6oZBh.violet[600],
            "--tw-prose-invert-links": $6oZBh.violet[500]
        }
    },
    purple: {
        css: {
            "--tw-prose-links": $6oZBh.purple[600],
            "--tw-prose-invert-links": $6oZBh.purple[500]
        }
    },
    fuchsia: {
        css: {
            "--tw-prose-links": $6oZBh.fuchsia[600],
            "--tw-prose-invert-links": $6oZBh.fuchsia[500]
        }
    },
    pink: {
        css: {
            "--tw-prose-links": $6oZBh.pink[600],
            "--tw-prose-invert-links": $6oZBh.pink[500]
        }
    },
    rose: {
        css: {
            "--tw-prose-links": $6oZBh.rose[600],
            "--tw-prose-invert-links": $6oZBh.rose[500]
        }
    }
};
module.exports = (0, $9tqwB._)({
    DEFAULT: {
        css: [
            {
                color: "var(--tw-prose-body)",
                maxWidth: "65ch",
                // TODO: Figure out how to not need this, it's a merging issue
                p: {},
                '[class~="lead"]': {
                    color: "var(--tw-prose-lead)"
                },
                a: {
                    color: "var(--tw-prose-links)",
                    textDecoration: "underline",
                    fontWeight: "500"
                },
                strong: {
                    color: "var(--tw-prose-bold)",
                    fontWeight: "600"
                },
                "a strong": {
                    color: "inherit"
                },
                "blockquote strong": {
                    color: "inherit"
                },
                "thead th strong": {
                    color: "inherit"
                },
                ol: {
                    listStyleType: "decimal"
                },
                'ol[type="A"]': {
                    listStyleType: "upper-alpha"
                },
                'ol[type="a"]': {
                    listStyleType: "lower-alpha"
                },
                'ol[type="A" s]': {
                    listStyleType: "upper-alpha"
                },
                'ol[type="a" s]': {
                    listStyleType: "lower-alpha"
                },
                'ol[type="I"]': {
                    listStyleType: "upper-roman"
                },
                'ol[type="i"]': {
                    listStyleType: "lower-roman"
                },
                'ol[type="I" s]': {
                    listStyleType: "upper-roman"
                },
                'ol[type="i" s]': {
                    listStyleType: "lower-roman"
                },
                'ol[type="1"]': {
                    listStyleType: "decimal"
                },
                ul: {
                    listStyleType: "disc"
                },
                "ol > li::marker": {
                    fontWeight: "400",
                    color: "var(--tw-prose-counters)"
                },
                "ul > li::marker": {
                    color: "var(--tw-prose-bullets)"
                },
                hr: {
                    borderColor: "var(--tw-prose-hr)",
                    borderTopWidth: 1
                },
                blockquote: {
                    fontWeight: "500",
                    fontStyle: "italic",
                    color: "var(--tw-prose-quotes)",
                    borderLeftWidth: "0.25rem",
                    borderLeftColor: "var(--tw-prose-quote-borders)",
                    quotes: '"\\201C""\\201D""\\2018""\\2019"'
                },
                "blockquote p:first-of-type::before": {
                    content: "open-quote"
                },
                "blockquote p:last-of-type::after": {
                    content: "close-quote"
                },
                h1: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "800"
                },
                "h1 strong": {
                    fontWeight: "900",
                    color: "inherit"
                },
                h2: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "700"
                },
                "h2 strong": {
                    fontWeight: "800",
                    color: "inherit"
                },
                h3: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                "h3 strong": {
                    fontWeight: "700",
                    color: "inherit"
                },
                h4: {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600"
                },
                "h4 strong": {
                    fontWeight: "700",
                    color: "inherit"
                },
                // TODO: Figure out how to not need these, it's a merging issue
                img: {},
                "figure > *": {},
                figcaption: {
                    color: "var(--tw-prose-captions)"
                },
                code: {
                    color: "var(--tw-prose-code)",
                    fontWeight: "600"
                },
                "code::before": {
                    content: '"`"'
                },
                "code::after": {
                    content: '"`"'
                },
                "a code": {
                    color: "inherit"
                },
                "h1 code": {
                    color: "inherit"
                },
                "h2 code": {
                    color: "inherit"
                },
                "h3 code": {
                    color: "inherit"
                },
                "h4 code": {
                    color: "inherit"
                },
                "blockquote code": {
                    color: "inherit"
                },
                "thead th code": {
                    color: "inherit"
                },
                pre: {
                    color: "var(--tw-prose-pre-code)",
                    backgroundColor: "var(--tw-prose-pre-bg)",
                    overflowX: "auto",
                    fontWeight: "400"
                },
                "pre code": {
                    backgroundColor: "transparent",
                    borderWidth: "0",
                    borderRadius: "0",
                    padding: "0",
                    fontWeight: "inherit",
                    color: "inherit",
                    fontSize: "inherit",
                    fontFamily: "inherit",
                    lineHeight: "inherit"
                },
                "pre code::before": {
                    content: "none"
                },
                "pre code::after": {
                    content: "none"
                },
                table: {
                    width: "100%",
                    tableLayout: "auto",
                    textAlign: "left",
                    marginTop: $9cd9e756bfe12b25$var$em(32, 16),
                    marginBottom: $9cd9e756bfe12b25$var$em(32, 16)
                },
                thead: {
                    borderBottomWidth: "1px",
                    borderBottomColor: "var(--tw-prose-th-borders)"
                },
                "thead th": {
                    color: "var(--tw-prose-headings)",
                    fontWeight: "600",
                    verticalAlign: "bottom"
                },
                "tbody tr": {
                    borderBottomWidth: "1px",
                    borderBottomColor: "var(--tw-prose-td-borders)"
                },
                "tbody tr:last-child": {
                    borderBottomWidth: "0"
                },
                "tbody td": {
                    verticalAlign: "baseline"
                },
                tfoot: {
                    borderTopWidth: "1px",
                    borderTopColor: "var(--tw-prose-th-borders)"
                },
                "tfoot td": {
                    verticalAlign: "top"
                }
            },
            $9cd9e756bfe12b25$var$defaultModifiers.gray.css,
            ...$9cd9e756bfe12b25$var$defaultModifiers.base.css
        ]
    }
}, $9cd9e756bfe12b25$var$defaultModifiers);

});

parcelRegister("47zSa", function(module, exports) {

var $jt7gQ = parcelRequire("jt7gQ");

var $bNXRt = parcelRequire("bNXRt");
const $3003a47284ab2f7e$var$parseSelector = $bNXRt();
module.exports = {
    isUsableColor (color, values) {
        return $jt7gQ(values) && color !== "gray" && values[600];
    },
    /**
   * @param {string} selector
   */ commonTrailingPseudos (selector) {
        let ast = $3003a47284ab2f7e$var$parseSelector.astSync(selector);
        /** @type {import('postcss-selector-parser').Pseudo[][]} */ let matrix = [];
        // Put the pseudo elements in reverse order in a sparse, column-major 2D array
        for (let [i, sel] of ast.nodes.entries())for (const [j, child] of [
            ...sel.nodes
        ].reverse().entries()){
            // We only care about pseudo elements
            if (child.type !== "pseudo" || !child.value.startsWith("::")) break;
            matrix[j] = matrix[j] || [];
            matrix[j][i] = child;
        }
        let trailingPseudos = $bNXRt.selector();
        // At this point the pseudo elements are in a column-major 2D array
        // This means each row contains one "column" of pseudo elements from each selector
        // We can compare all the pseudo elements in a row to see if they are the same
        for (const pseudos of matrix){
            // It's a sparse 2D array so there are going to be holes in the rows
            // We skip those
            if (!pseudos) continue;
            let values = new Set([
                ...pseudos.map((p)=>p.value)
            ]);
            // The pseudo elements are not the same
            if (values.size > 1) break;
            pseudos.forEach((pseudo)=>pseudo.remove());
            trailingPseudos.prepend(pseudos[0]);
        }
        if (trailingPseudos.nodes.length) return [
            trailingPseudos.toString(),
            ast.toString()
        ];
        return [
            null,
            selector
        ];
    }
};

});
parcelRegister("jt7gQ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $03a85c59201b119a$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $03a85c59201b119a$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $03a85c59201b119a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $03a85c59201b119a$var$funcProto = Function.prototype, $03a85c59201b119a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $03a85c59201b119a$var$funcToString = $03a85c59201b119a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $03a85c59201b119a$var$hasOwnProperty = $03a85c59201b119a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $03a85c59201b119a$var$objectCtorString = $03a85c59201b119a$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $03a85c59201b119a$var$objectToString = $03a85c59201b119a$var$objectProto.toString;
/** Built-in value references. */ var $03a85c59201b119a$var$getPrototype = $03a85c59201b119a$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $03a85c59201b119a$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $03a85c59201b119a$var$isPlainObject(value) {
    if (!$03a85c59201b119a$var$isObjectLike(value) || $03a85c59201b119a$var$objectToString.call(value) != $03a85c59201b119a$var$objectTag || $03a85c59201b119a$var$isHostObject(value)) return false;
    var proto = $03a85c59201b119a$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $03a85c59201b119a$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $03a85c59201b119a$var$funcToString.call(Ctor) == $03a85c59201b119a$var$objectCtorString;
}
module.exports = $03a85c59201b119a$var$isPlainObject;

});

parcelRegister("bNXRt", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $8982b48aaa07f51b$var$_processor = $8982b48aaa07f51b$var$_interopRequireDefault((parcelRequire("cNBmx")));

var $8982b48aaa07f51b$var$selectors = $8982b48aaa07f51b$var$_interopRequireWildcard((parcelRequire("6i6fY")));
function $8982b48aaa07f51b$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $8982b48aaa07f51b$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $8982b48aaa07f51b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $8982b48aaa07f51b$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8982b48aaa07f51b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $8982b48aaa07f51b$var$parser = function parser(processor) {
    return new $8982b48aaa07f51b$var$_processor["default"](processor);
};
Object.assign($8982b48aaa07f51b$var$parser, $8982b48aaa07f51b$var$selectors);
delete $8982b48aaa07f51b$var$parser.__esModule;
var $8982b48aaa07f51b$var$_default = $8982b48aaa07f51b$var$parser;
module.exports["default"] = $8982b48aaa07f51b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("cNBmx", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $95170b0f24d1a407$var$_parser = $95170b0f24d1a407$var$_interopRequireDefault((parcelRequire("42K8s")));
function $95170b0f24d1a407$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $95170b0f24d1a407$var$Processor = /*#__PURE__*/ function() {
    function Processor(func, options) {
        this.func = func || function noop() {};
        this.funcRes = null;
        this.options = options;
    }
    var _proto = Processor.prototype;
    _proto._shouldUpdateSelector = function _shouldUpdateSelector(rule, options) {
        if (options === void 0) options = {};
        var merged = Object.assign({}, this.options, options);
        if (merged.updateSelector === false) return false;
        else return typeof rule !== "string";
    };
    _proto._isLossy = function _isLossy(options) {
        if (options === void 0) options = {};
        var merged = Object.assign({}, this.options, options);
        if (merged.lossless === false) return true;
        else return false;
    };
    _proto._root = function _root(rule, options) {
        if (options === void 0) options = {};
        var parser = new $95170b0f24d1a407$var$_parser["default"](rule, this._parseOptions(options));
        return parser.root;
    };
    _proto._parseOptions = function _parseOptions(options) {
        return {
            lossy: this._isLossy(options)
        };
    };
    _proto._run = function _run(rule, options) {
        var _this = this;
        if (options === void 0) options = {};
        return new Promise(function(resolve, reject) {
            try {
                var root = _this._root(rule, options);
                Promise.resolve(_this.func(root)).then(function(transform) {
                    var string = undefined;
                    if (_this._shouldUpdateSelector(rule, options)) {
                        string = root.toString();
                        rule.selector = string;
                    }
                    return {
                        transform: transform,
                        root: root,
                        string: string
                    };
                }).then(resolve, reject);
            } catch (e) {
                reject(e);
                return;
            }
        });
    };
    _proto._runSync = function _runSync(rule, options) {
        if (options === void 0) options = {};
        var root = this._root(rule, options);
        var transform = this.func(root);
        if (transform && typeof transform.then === "function") throw new Error("Selector processor returned a promise to a synchronous call.");
        var string = undefined;
        if (options.updateSelector && typeof rule !== "string") {
            string = root.toString();
            rule.selector = string;
        }
        return {
            transform: transform,
            root: root,
            string: string
        };
    } /**
   * Process rule into a selector AST.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {Promise<parser.Root>} The AST of the selector after processing it.
   */ ;
    _proto.ast = function ast(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.root;
        });
    } /**
   * Process rule into a selector AST synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {parser.Root} The AST of the selector after processing it.
   */ ;
    _proto.astSync = function astSync(rule, options) {
        return this._runSync(rule, options).root;
    } /**
   * Process a selector into a transformed value asynchronously
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {Promise<any>} The value returned by the processor.
   */ ;
    _proto.transform = function transform(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.transform;
        });
    } /**
   * Process a selector into a transformed value synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {any} The value returned by the processor.
   */ ;
    _proto.transformSync = function transformSync(rule, options) {
        return this._runSync(rule, options).transform;
    } /**
   * Process a selector into a new selector string asynchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {string} the selector after processing.
   */ ;
    _proto.process = function process(rule, options) {
        return this._run(rule, options).then(function(result) {
            return result.string || result.root.toString();
        });
    } /**
   * Process a selector into a new selector string synchronously.
   *
   * @param rule {postcss.Rule | string} The css selector to be processed
   * @param options The options for processing
   * @returns {string} the selector after processing.
   */ ;
    _proto.processSync = function processSync(rule, options) {
        var result = this._runSync(rule, options);
        return result.string || result.root.toString();
    };
    return Processor;
}();
module.exports["default"] = $95170b0f24d1a407$var$Processor;
module.exports = module.exports.default;

});
parcelRegister("42K8s", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $2f1b22e17fc991cd$var$_root = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("inIHk")));

var $2f1b22e17fc991cd$var$_selector = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("eid1T")));

var $2f1b22e17fc991cd$var$_className = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("akI15")));

var $2f1b22e17fc991cd$var$_comment = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("jsSX5")));

var $2f1b22e17fc991cd$var$_id = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("9TUOP")));

var $2f1b22e17fc991cd$var$_tag = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("3N0LC")));

var $2f1b22e17fc991cd$var$_string = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("jjiiN")));

var $2f1b22e17fc991cd$var$_pseudo = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("fSDJL")));

var $2f1b22e17fc991cd$var$_attribute = $2f1b22e17fc991cd$var$_interopRequireWildcard((parcelRequire("2jypc")));

var $2f1b22e17fc991cd$var$_universal = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("jDVao")));

var $2f1b22e17fc991cd$var$_combinator = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("9Rp1Y")));

var $2f1b22e17fc991cd$var$_nesting = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("bpp70")));

var $2f1b22e17fc991cd$var$_sortAscending = $2f1b22e17fc991cd$var$_interopRequireDefault((parcelRequire("95wzF")));

var $2f1b22e17fc991cd$var$_tokenize = $2f1b22e17fc991cd$var$_interopRequireWildcard((parcelRequire("c6o92")));

var $2f1b22e17fc991cd$var$tokens = $2f1b22e17fc991cd$var$_interopRequireWildcard((parcelRequire("3Ij12")));

var $2f1b22e17fc991cd$var$types = $2f1b22e17fc991cd$var$_interopRequireWildcard((parcelRequire("lskax")));

var $cxGLx = parcelRequire("cxGLx");
var $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS, $2f1b22e17fc991cd$var$_Object$assign;
function $2f1b22e17fc991cd$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $2f1b22e17fc991cd$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $2f1b22e17fc991cd$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $2f1b22e17fc991cd$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2f1b22e17fc991cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2f1b22e17fc991cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2f1b22e17fc991cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2f1b22e17fc991cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2f1b22e17fc991cd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $2f1b22e17fc991cd$var$WHITESPACE_TOKENS = ($2f1b22e17fc991cd$var$_WHITESPACE_TOKENS = {}, $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS[$2f1b22e17fc991cd$var$tokens.space] = true, $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS[$2f1b22e17fc991cd$var$tokens.cr] = true, $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS[$2f1b22e17fc991cd$var$tokens.feed] = true, $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS[$2f1b22e17fc991cd$var$tokens.newline] = true, $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS[$2f1b22e17fc991cd$var$tokens.tab] = true, $2f1b22e17fc991cd$var$_WHITESPACE_TOKENS);
var $2f1b22e17fc991cd$var$WHITESPACE_EQUIV_TOKENS = Object.assign({}, $2f1b22e17fc991cd$var$WHITESPACE_TOKENS, ($2f1b22e17fc991cd$var$_Object$assign = {}, $2f1b22e17fc991cd$var$_Object$assign[$2f1b22e17fc991cd$var$tokens.comment] = true, $2f1b22e17fc991cd$var$_Object$assign));
function $2f1b22e17fc991cd$var$tokenStart(token) {
    return {
        line: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_LINE],
        column: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_COL]
    };
}
function $2f1b22e17fc991cd$var$tokenEnd(token) {
    return {
        line: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_LINE],
        column: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_COL]
    };
}
function $2f1b22e17fc991cd$var$getSource(startLine, startColumn, endLine, endColumn) {
    return {
        start: {
            line: startLine,
            column: startColumn
        },
        end: {
            line: endLine,
            column: endColumn
        }
    };
}
function $2f1b22e17fc991cd$var$getTokenSource(token) {
    return $2f1b22e17fc991cd$var$getSource(token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_LINE], token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_COL], token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_LINE], token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_COL]);
}
function $2f1b22e17fc991cd$var$getTokenSourceSpan(startToken, endToken) {
    if (!startToken) return undefined;
    return $2f1b22e17fc991cd$var$getSource(startToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_LINE], startToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_COL], endToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_LINE], endToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_COL]);
}
function $2f1b22e17fc991cd$var$unescapeProp(node, prop) {
    var value = node[prop];
    if (typeof value !== "string") return;
    if (value.indexOf("\\") !== -1) {
        (0, $cxGLx.ensureObject)(node, "raws");
        node[prop] = (0, $cxGLx.unesc)(value);
        if (node.raws[prop] === undefined) node.raws[prop] = value;
    }
    return node;
}
function $2f1b22e17fc991cd$var$indexesOf(array, item) {
    var i = -1;
    var indexes = [];
    while((i = array.indexOf(item, i + 1)) !== -1)indexes.push(i);
    return indexes;
}
function $2f1b22e17fc991cd$var$uniqs() {
    var list = Array.prototype.concat.apply([], arguments);
    return list.filter(function(item, i) {
        return i === list.indexOf(item);
    });
}
var $2f1b22e17fc991cd$var$Parser = /*#__PURE__*/ function() {
    function Parser(rule, options) {
        if (options === void 0) options = {};
        this.rule = rule;
        this.options = Object.assign({
            lossy: false,
            safe: false
        }, options);
        this.position = 0;
        this.css = typeof this.rule === "string" ? this.rule : this.rule.selector;
        this.tokens = (0, $2f1b22e17fc991cd$var$_tokenize["default"])({
            css: this.css,
            error: this._errorGenerator(),
            safe: this.options.safe
        });
        var rootSource = $2f1b22e17fc991cd$var$getTokenSourceSpan(this.tokens[0], this.tokens[this.tokens.length - 1]);
        this.root = new $2f1b22e17fc991cd$var$_root["default"]({
            source: rootSource
        });
        this.root.errorGenerator = this._errorGenerator();
        var selector = new $2f1b22e17fc991cd$var$_selector["default"]({
            source: {
                start: {
                    line: 1,
                    column: 1
                }
            }
        });
        this.root.append(selector);
        this.current = selector;
        this.loop();
    }
    var _proto = Parser.prototype;
    _proto._errorGenerator = function _errorGenerator() {
        var _this = this;
        return function(message, errorOptions) {
            if (typeof _this.rule === "string") return new Error(message);
            return _this.rule.error(message, errorOptions);
        };
    };
    _proto.attribute = function attribute() {
        var attr = [];
        var startingToken = this.currToken;
        this.position++;
        while(this.position < this.tokens.length && this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] !== $2f1b22e17fc991cd$var$tokens.closeSquare){
            attr.push(this.currToken);
            this.position++;
        }
        if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] !== $2f1b22e17fc991cd$var$tokens.closeSquare) return this.expected("closing square bracket", this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
        var len = attr.length;
        var node = {
            source: $2f1b22e17fc991cd$var$getSource(startingToken[1], startingToken[2], this.currToken[3], this.currToken[4]),
            sourceIndex: startingToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
        };
        if (len === 1 && !~[
            $2f1b22e17fc991cd$var$tokens.word
        ].indexOf(attr[0][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE])) return this.expected("attribute", attr[0][$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
        var pos = 0;
        var spaceBefore = "";
        var commentBefore = "";
        var lastAdded = null;
        var spaceAfterMeaningfulToken = false;
        while(pos < len){
            var token = attr[pos];
            var content = this.content(token);
            var next = attr[pos + 1];
            switch(token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE]){
                case $2f1b22e17fc991cd$var$tokens.space:
                    // if (
                    //     len === 1 ||
                    //     pos === 0 && this.content(next) === '|'
                    // ) {
                    //     return this.expected('attribute', token[TOKEN.START_POS], content);
                    // }
                    spaceAfterMeaningfulToken = true;
                    if (this.options.lossy) break;
                    if (lastAdded) {
                        (0, $cxGLx.ensureObject)(node, "spaces", lastAdded);
                        var prevContent = node.spaces[lastAdded].after || "";
                        node.spaces[lastAdded].after = prevContent + content;
                        var existingComment = (0, $cxGLx.getProp)(node, "raws", "spaces", lastAdded, "after") || null;
                        if (existingComment) node.raws.spaces[lastAdded].after = existingComment + content;
                    } else {
                        spaceBefore = spaceBefore + content;
                        commentBefore = commentBefore + content;
                    }
                    break;
                case $2f1b22e17fc991cd$var$tokens.asterisk:
                    if (next[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    } else if ((!node.namespace || lastAdded === "namespace" && !spaceAfterMeaningfulToken) && next) {
                        if (spaceBefore) {
                            (0, $cxGLx.ensureObject)(node, "spaces", "attribute");
                            node.spaces.attribute.before = spaceBefore;
                            spaceBefore = "";
                        }
                        if (commentBefore) {
                            (0, $cxGLx.ensureObject)(node, "raws", "spaces", "attribute");
                            node.raws.spaces.attribute.before = spaceBefore;
                            commentBefore = "";
                        }
                        node.namespace = (node.namespace || "") + content;
                        var rawValue = (0, $cxGLx.getProp)(node, "raws", "namespace") || null;
                        if (rawValue) node.raws.namespace += content;
                        lastAdded = "namespace";
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $2f1b22e17fc991cd$var$tokens.dollar:
                    if (lastAdded === "value") {
                        var oldRawValue = (0, $cxGLx.getProp)(node, "raws", "value");
                        node.value += "$";
                        if (oldRawValue) node.raws.value = oldRawValue + "$";
                        break;
                    }
                // Falls through
                case $2f1b22e17fc991cd$var$tokens.caret:
                    if (next[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $2f1b22e17fc991cd$var$tokens.combinator:
                    if (content === "~" && next[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    }
                    if (content !== "|") {
                        spaceAfterMeaningfulToken = false;
                        break;
                    }
                    if (next[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.equals) {
                        node.operator = content;
                        lastAdded = "operator";
                    } else if (!node.namespace && !node.attribute) node.namespace = true;
                    spaceAfterMeaningfulToken = false;
                    break;
                case $2f1b22e17fc991cd$var$tokens.word:
                    if (next && this.content(next) === "|" && attr[pos + 2] && attr[pos + 2][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] !== $2f1b22e17fc991cd$var$tokens.equals && // this look-ahead probably fails with comment nodes involved.
                    !node.operator && !node.namespace) {
                        node.namespace = content;
                        lastAdded = "namespace";
                    } else if (!node.attribute || lastAdded === "attribute" && !spaceAfterMeaningfulToken) {
                        if (spaceBefore) {
                            (0, $cxGLx.ensureObject)(node, "spaces", "attribute");
                            node.spaces.attribute.before = spaceBefore;
                            spaceBefore = "";
                        }
                        if (commentBefore) {
                            (0, $cxGLx.ensureObject)(node, "raws", "spaces", "attribute");
                            node.raws.spaces.attribute.before = commentBefore;
                            commentBefore = "";
                        }
                        node.attribute = (node.attribute || "") + content;
                        var _rawValue = (0, $cxGLx.getProp)(node, "raws", "attribute") || null;
                        if (_rawValue) node.raws.attribute += content;
                        lastAdded = "attribute";
                    } else if (!node.value && node.value !== "" || lastAdded === "value" && !spaceAfterMeaningfulToken) {
                        var _unescaped = (0, $cxGLx.unesc)(content);
                        var _oldRawValue = (0, $cxGLx.getProp)(node, "raws", "value") || "";
                        var oldValue = node.value || "";
                        node.value = oldValue + _unescaped;
                        node.quoteMark = null;
                        if (_unescaped !== content || _oldRawValue) {
                            (0, $cxGLx.ensureObject)(node, "raws");
                            node.raws.value = (_oldRawValue || oldValue) + content;
                        }
                        lastAdded = "value";
                    } else {
                        var insensitive = content === "i" || content === "I";
                        if ((node.value || node.value === "") && (node.quoteMark || spaceAfterMeaningfulToken)) {
                            node.insensitive = insensitive;
                            if (!insensitive || content === "I") {
                                (0, $cxGLx.ensureObject)(node, "raws");
                                node.raws.insensitiveFlag = content;
                            }
                            lastAdded = "insensitive";
                            if (spaceBefore) {
                                (0, $cxGLx.ensureObject)(node, "spaces", "insensitive");
                                node.spaces.insensitive.before = spaceBefore;
                                spaceBefore = "";
                            }
                            if (commentBefore) {
                                (0, $cxGLx.ensureObject)(node, "raws", "spaces", "insensitive");
                                node.raws.spaces.insensitive.before = commentBefore;
                                commentBefore = "";
                            }
                        } else if (node.value || node.value === "") {
                            lastAdded = "value";
                            node.value += content;
                            if (node.raws.value) node.raws.value += content;
                        }
                    }
                    spaceAfterMeaningfulToken = false;
                    break;
                case $2f1b22e17fc991cd$var$tokens.str:
                    if (!node.attribute || !node.operator) return this.error("Expected an attribute followed by an operator preceding the string.", {
                        index: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
                    });
                    var _unescapeValue = (0, $2f1b22e17fc991cd$var$_attribute.unescapeValue)(content), unescaped = _unescapeValue.unescaped, quoteMark = _unescapeValue.quoteMark;
                    node.value = unescaped;
                    node.quoteMark = quoteMark;
                    lastAdded = "value";
                    (0, $cxGLx.ensureObject)(node, "raws");
                    node.raws.value = content;
                    spaceAfterMeaningfulToken = false;
                    break;
                case $2f1b22e17fc991cd$var$tokens.equals:
                    if (!node.attribute) return this.expected("attribute", token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS], content);
                    if (node.value) return this.error('Unexpected "=" found; an operator was already defined.', {
                        index: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
                    });
                    node.operator = node.operator ? node.operator + content : content;
                    lastAdded = "operator";
                    spaceAfterMeaningfulToken = false;
                    break;
                case $2f1b22e17fc991cd$var$tokens.comment:
                    if (lastAdded) {
                        if (spaceAfterMeaningfulToken || next && next[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.space || lastAdded === "insensitive") {
                            var lastComment = (0, $cxGLx.getProp)(node, "spaces", lastAdded, "after") || "";
                            var rawLastComment = (0, $cxGLx.getProp)(node, "raws", "spaces", lastAdded, "after") || lastComment;
                            (0, $cxGLx.ensureObject)(node, "raws", "spaces", lastAdded);
                            node.raws.spaces[lastAdded].after = rawLastComment + content;
                        } else {
                            var lastValue = node[lastAdded] || "";
                            var rawLastValue = (0, $cxGLx.getProp)(node, "raws", lastAdded) || lastValue;
                            (0, $cxGLx.ensureObject)(node, "raws");
                            node.raws[lastAdded] = rawLastValue + content;
                        }
                    } else commentBefore = commentBefore + content;
                    break;
                default:
                    return this.error('Unexpected "' + content + '" found.', {
                        index: token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
                    });
            }
            pos++;
        }
        $2f1b22e17fc991cd$var$unescapeProp(node, "attribute");
        $2f1b22e17fc991cd$var$unescapeProp(node, "namespace");
        this.newNode(new $2f1b22e17fc991cd$var$_attribute["default"](node));
        this.position++;
    } /**
   * return a node containing meaningless garbage up to (but not including) the specified token position.
   * if the token position is negative, all remaining tokens are consumed.
   *
   * This returns an array containing a single string node if all whitespace,
   * otherwise an array of comment nodes with space before and after.
   *
   * These tokens are not added to the current selector, the caller can add them or use them to amend
   * a previous node's space metadata.
   *
   * In lossy mode, this returns only comments.
   */ ;
    _proto.parseWhitespaceEquivalentTokens = function parseWhitespaceEquivalentTokens(stopPosition) {
        if (stopPosition < 0) stopPosition = this.tokens.length;
        var startPosition = this.position;
        var nodes = [];
        var space = "";
        var lastComment = undefined;
        do {
            if ($2f1b22e17fc991cd$var$WHITESPACE_TOKENS[this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE]]) {
                if (!this.options.lossy) space += this.content();
            } else if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.comment) {
                var spaces = {};
                if (space) {
                    spaces.before = space;
                    space = "";
                }
                lastComment = new $2f1b22e17fc991cd$var$_comment["default"]({
                    value: this.content(),
                    source: $2f1b22e17fc991cd$var$getTokenSource(this.currToken),
                    sourceIndex: this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS],
                    spaces: spaces
                });
                nodes.push(lastComment);
            }
        }while (++this.position < stopPosition);
        if (space) {
            if (lastComment) lastComment.spaces.after = space;
            else if (!this.options.lossy) {
                var firstToken = this.tokens[startPosition];
                var lastToken = this.tokens[this.position - 1];
                nodes.push(new $2f1b22e17fc991cd$var$_string["default"]({
                    value: "",
                    source: $2f1b22e17fc991cd$var$getSource(firstToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_LINE], firstToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_COL], lastToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_LINE], lastToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_COL]),
                    sourceIndex: firstToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS],
                    spaces: {
                        before: space,
                        after: ""
                    }
                }));
            }
        }
        return nodes;
    } /**
   * 
   * @param {*} nodes 
   */ ;
    _proto.convertWhitespaceNodesToSpace = function convertWhitespaceNodesToSpace(nodes, requiredSpace) {
        var _this2 = this;
        if (requiredSpace === void 0) requiredSpace = false;
        var space = "";
        var rawSpace = "";
        nodes.forEach(function(n) {
            var spaceBefore = _this2.lossySpace(n.spaces.before, requiredSpace);
            var rawSpaceBefore = _this2.lossySpace(n.rawSpaceBefore, requiredSpace);
            space += spaceBefore + _this2.lossySpace(n.spaces.after, requiredSpace && spaceBefore.length === 0);
            rawSpace += spaceBefore + n.value + _this2.lossySpace(n.rawSpaceAfter, requiredSpace && rawSpaceBefore.length === 0);
        });
        if (rawSpace === space) rawSpace = undefined;
        var result = {
            space: space,
            rawSpace: rawSpace
        };
        return result;
    };
    _proto.isNamedCombinator = function isNamedCombinator(position) {
        if (position === void 0) position = this.position;
        return this.tokens[position + 0] && this.tokens[position + 0][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.slash && this.tokens[position + 1] && this.tokens[position + 1][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.word && this.tokens[position + 2] && this.tokens[position + 2][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.slash;
    };
    _proto.namedCombinator = function namedCombinator() {
        if (this.isNamedCombinator()) {
            var nameRaw = this.content(this.tokens[this.position + 1]);
            var name = (0, $cxGLx.unesc)(nameRaw).toLowerCase();
            var raws = {};
            if (name !== nameRaw) raws.value = "/" + nameRaw + "/";
            var node = new $2f1b22e17fc991cd$var$_combinator["default"]({
                value: "/" + name + "/",
                source: $2f1b22e17fc991cd$var$getSource(this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_LINE], this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_COL], this.tokens[this.position + 2][$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_LINE], this.tokens[this.position + 2][$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_COL]),
                sourceIndex: this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS],
                raws: raws
            });
            this.position = this.position + 3;
            return node;
        } else this.unexpected();
    };
    _proto.combinator = function combinator() {
        var _this3 = this;
        if (this.content() === "|") return this.namespace();
         // We need to decide between a space that's a descendant combinator and meaningless whitespace at the end of a selector.
        var nextSigTokenPos = this.locateNextMeaningfulToken(this.position);
        if (nextSigTokenPos < 0 || this.tokens[nextSigTokenPos][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.comma) {
            var nodes = this.parseWhitespaceEquivalentTokens(nextSigTokenPos);
            if (nodes.length > 0) {
                var last = this.current.last;
                if (last) {
                    var _this$convertWhitespa = this.convertWhitespaceNodesToSpace(nodes), space = _this$convertWhitespa.space, rawSpace = _this$convertWhitespa.rawSpace;
                    if (rawSpace !== undefined) last.rawSpaceAfter += rawSpace;
                    last.spaces.after += space;
                } else nodes.forEach(function(n) {
                    return _this3.newNode(n);
                });
            }
            return;
        }
        var firstToken = this.currToken;
        var spaceOrDescendantSelectorNodes = undefined;
        if (nextSigTokenPos > this.position) spaceOrDescendantSelectorNodes = this.parseWhitespaceEquivalentTokens(nextSigTokenPos);
        var node;
        if (this.isNamedCombinator()) node = this.namedCombinator();
        else if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.combinator) {
            node = new $2f1b22e17fc991cd$var$_combinator["default"]({
                value: this.content(),
                source: $2f1b22e17fc991cd$var$getTokenSource(this.currToken),
                sourceIndex: this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
            });
            this.position++;
        } else if ($2f1b22e17fc991cd$var$WHITESPACE_TOKENS[this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE]]) ;
        else if (!spaceOrDescendantSelectorNodes) this.unexpected();
        if (node) {
            if (spaceOrDescendantSelectorNodes) {
                var _this$convertWhitespa2 = this.convertWhitespaceNodesToSpace(spaceOrDescendantSelectorNodes), _space = _this$convertWhitespa2.space, _rawSpace = _this$convertWhitespa2.rawSpace;
                node.spaces.before = _space;
                node.rawSpaceBefore = _rawSpace;
            }
        } else {
            // descendant combinator
            var _this$convertWhitespa3 = this.convertWhitespaceNodesToSpace(spaceOrDescendantSelectorNodes, true), _space2 = _this$convertWhitespa3.space, _rawSpace2 = _this$convertWhitespa3.rawSpace;
            if (!_rawSpace2) _rawSpace2 = _space2;
            var spaces = {};
            var raws = {
                spaces: {}
            };
            if (_space2.endsWith(" ") && _rawSpace2.endsWith(" ")) {
                spaces.before = _space2.slice(0, _space2.length - 1);
                raws.spaces.before = _rawSpace2.slice(0, _rawSpace2.length - 1);
            } else if (_space2.startsWith(" ") && _rawSpace2.startsWith(" ")) {
                spaces.after = _space2.slice(1);
                raws.spaces.after = _rawSpace2.slice(1);
            } else raws.value = _rawSpace2;
            node = new $2f1b22e17fc991cd$var$_combinator["default"]({
                value: " ",
                source: $2f1b22e17fc991cd$var$getTokenSourceSpan(firstToken, this.tokens[this.position - 1]),
                sourceIndex: firstToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS],
                spaces: spaces,
                raws: raws
            });
        }
        if (this.currToken && this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.space) {
            node.spaces.after = this.optionalSpace(this.content());
            this.position++;
        }
        return this.newNode(node);
    };
    _proto.comma = function comma() {
        if (this.position === this.tokens.length - 1) {
            this.root.trailingComma = true;
            this.position++;
            return;
        }
        this.current._inferEndPosition();
        var selector = new $2f1b22e17fc991cd$var$_selector["default"]({
            source: {
                start: $2f1b22e17fc991cd$var$tokenStart(this.tokens[this.position + 1])
            }
        });
        this.current.parent.append(selector);
        this.current = selector;
        this.position++;
    };
    _proto.comment = function comment() {
        var current = this.currToken;
        this.newNode(new $2f1b22e17fc991cd$var$_comment["default"]({
            value: this.content(),
            source: $2f1b22e17fc991cd$var$getTokenSource(current),
            sourceIndex: current[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.error = function error(message, opts) {
        throw this.root.error(message, opts);
    };
    _proto.missingBackslash = function missingBackslash() {
        return this.error("Expected a backslash preceding the semicolon.", {
            index: this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
        });
    };
    _proto.missingParenthesis = function missingParenthesis() {
        return this.expected("opening parenthesis", this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.missingSquareBracket = function missingSquareBracket() {
        return this.expected("opening square bracket", this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.unexpected = function unexpected() {
        return this.error("Unexpected '" + this.content() + "'. Escaping special characters with \\ may help.", this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.namespace = function namespace() {
        var before = this.prevToken && this.content(this.prevToken) || true;
        if (this.nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.word) {
            this.position++;
            return this.word(before);
        } else if (this.nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.asterisk) {
            this.position++;
            return this.universal(before);
        }
    };
    _proto.nesting = function nesting() {
        if (this.nextToken) {
            var nextContent = this.content(this.nextToken);
            if (nextContent === "|") {
                this.position++;
                return;
            }
        }
        var current = this.currToken;
        this.newNode(new $2f1b22e17fc991cd$var$_nesting["default"]({
            value: this.content(),
            source: $2f1b22e17fc991cd$var$getTokenSource(current),
            sourceIndex: current[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.parentheses = function parentheses() {
        var last = this.current.last;
        var unbalanced = 1;
        this.position++;
        if (last && last.type === $2f1b22e17fc991cd$var$types.PSEUDO) {
            var selector = new $2f1b22e17fc991cd$var$_selector["default"]({
                source: {
                    start: $2f1b22e17fc991cd$var$tokenStart(this.tokens[this.position - 1])
                }
            });
            var cache = this.current;
            last.append(selector);
            this.current = selector;
            while(this.position < this.tokens.length && unbalanced){
                if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.openParenthesis) unbalanced++;
                if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.closeParenthesis) unbalanced--;
                if (unbalanced) this.parse();
                else {
                    this.current.source.end = $2f1b22e17fc991cd$var$tokenEnd(this.currToken);
                    this.current.parent.source.end = $2f1b22e17fc991cd$var$tokenEnd(this.currToken);
                    this.position++;
                }
            }
            this.current = cache;
        } else {
            // I think this case should be an error. It's used to implement a basic parse of media queries
            // but I don't think it's a good idea.
            var parenStart = this.currToken;
            var parenValue = "(";
            var parenEnd;
            while(this.position < this.tokens.length && unbalanced){
                if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.openParenthesis) unbalanced++;
                if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.closeParenthesis) unbalanced--;
                parenEnd = this.currToken;
                parenValue += this.parseParenthesisToken(this.currToken);
                this.position++;
            }
            if (last) last.appendToPropertyAndEscape("value", parenValue, parenValue);
            else this.newNode(new $2f1b22e17fc991cd$var$_string["default"]({
                value: parenValue,
                source: $2f1b22e17fc991cd$var$getSource(parenStart[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_LINE], parenStart[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_COL], parenEnd[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_LINE], parenEnd[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_COL]),
                sourceIndex: parenStart[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
            }));
        }
        if (unbalanced) return this.expected("closing parenthesis", this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.pseudo = function pseudo() {
        var _this4 = this;
        var pseudoStr = "";
        var startingToken = this.currToken;
        while(this.currToken && this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.colon){
            pseudoStr += this.content();
            this.position++;
        }
        if (!this.currToken) return this.expected([
            "pseudo-class",
            "pseudo-element"
        ], this.position - 1);
        if (this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.word) this.splitWord(false, function(first, length) {
            pseudoStr += first;
            _this4.newNode(new $2f1b22e17fc991cd$var$_pseudo["default"]({
                value: pseudoStr,
                source: $2f1b22e17fc991cd$var$getTokenSourceSpan(startingToken, _this4.currToken),
                sourceIndex: startingToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
            }));
            if (length > 1 && _this4.nextToken && _this4.nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.openParenthesis) _this4.error("Misplaced parenthesis.", {
                index: _this4.nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
            });
        });
        else return this.expected([
            "pseudo-class",
            "pseudo-element"
        ], this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]);
    };
    _proto.space = function space() {
        var content = this.content(); // Handle space before and after the selector
        if (this.position === 0 || this.prevToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.comma || this.prevToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.openParenthesis || this.current.nodes.every(function(node) {
            return node.type === "comment";
        })) {
            this.spaces = this.optionalSpace(content);
            this.position++;
        } else if (this.position === this.tokens.length - 1 || this.nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.comma || this.nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.closeParenthesis) {
            this.current.last.spaces.after = this.optionalSpace(content);
            this.position++;
        } else this.combinator();
    };
    _proto.string = function string() {
        var current = this.currToken;
        this.newNode(new $2f1b22e17fc991cd$var$_string["default"]({
            value: this.content(),
            source: $2f1b22e17fc991cd$var$getTokenSource(current),
            sourceIndex: current[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
        }));
        this.position++;
    };
    _proto.universal = function universal(namespace) {
        var nextToken = this.nextToken;
        if (nextToken && this.content(nextToken) === "|") {
            this.position++;
            return this.namespace();
        }
        var current = this.currToken;
        this.newNode(new $2f1b22e17fc991cd$var$_universal["default"]({
            value: this.content(),
            source: $2f1b22e17fc991cd$var$getTokenSource(current),
            sourceIndex: current[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS]
        }), namespace);
        this.position++;
    };
    _proto.splitWord = function splitWord(namespace, firstCallback) {
        var _this5 = this;
        var nextToken = this.nextToken;
        var word = this.content();
        while(nextToken && ~[
            $2f1b22e17fc991cd$var$tokens.dollar,
            $2f1b22e17fc991cd$var$tokens.caret,
            $2f1b22e17fc991cd$var$tokens.equals,
            $2f1b22e17fc991cd$var$tokens.word
        ].indexOf(nextToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE])){
            this.position++;
            var current = this.content();
            word += current;
            if (current.lastIndexOf("\\") === current.length - 1) {
                var next = this.nextToken;
                if (next && next[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.space) {
                    word += this.requiredSpace(this.content(next));
                    this.position++;
                }
            }
            nextToken = this.nextToken;
        }
        var hasClass = $2f1b22e17fc991cd$var$indexesOf(word, ".").filter(function(i) {
            // Allow escaped dot within class name
            var escapedDot = word[i - 1] === "\\"; // Allow decimal numbers percent in @keyframes
            var isKeyframesPercent = /^\d+\.\d+%$/.test(word);
            return !escapedDot && !isKeyframesPercent;
        });
        var hasId = $2f1b22e17fc991cd$var$indexesOf(word, "#").filter(function(i) {
            return word[i - 1] !== "\\";
        }); // Eliminate Sass interpolations from the list of id indexes
        var interpolations = $2f1b22e17fc991cd$var$indexesOf(word, "#{");
        if (interpolations.length) hasId = hasId.filter(function(hashIndex) {
            return !~interpolations.indexOf(hashIndex);
        });
        var indices = (0, $2f1b22e17fc991cd$var$_sortAscending["default"])($2f1b22e17fc991cd$var$uniqs([
            0
        ].concat(hasClass, hasId)));
        indices.forEach(function(ind, i) {
            var index = indices[i + 1] || word.length;
            var value = word.slice(ind, index);
            if (i === 0 && firstCallback) return firstCallback.call(_this5, value, indices.length);
            var node;
            var current = _this5.currToken;
            var sourceIndex = current[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS] + indices[i];
            var source = $2f1b22e17fc991cd$var$getSource(current[1], current[2] + ind, current[3], current[2] + (index - 1));
            if (~hasClass.indexOf(ind)) {
                var classNameOpts = {
                    value: value.slice(1),
                    source: source,
                    sourceIndex: sourceIndex
                };
                node = new $2f1b22e17fc991cd$var$_className["default"]($2f1b22e17fc991cd$var$unescapeProp(classNameOpts, "value"));
            } else if (~hasId.indexOf(ind)) {
                var idOpts = {
                    value: value.slice(1),
                    source: source,
                    sourceIndex: sourceIndex
                };
                node = new $2f1b22e17fc991cd$var$_id["default"]($2f1b22e17fc991cd$var$unescapeProp(idOpts, "value"));
            } else {
                var tagOpts = {
                    value: value,
                    source: source,
                    sourceIndex: sourceIndex
                };
                $2f1b22e17fc991cd$var$unescapeProp(tagOpts, "value");
                node = new $2f1b22e17fc991cd$var$_tag["default"](tagOpts);
            }
            _this5.newNode(node, namespace); // Ensure that the namespace is used only once
            namespace = null;
        });
        this.position++;
    };
    _proto.word = function word(namespace) {
        var nextToken = this.nextToken;
        if (nextToken && this.content(nextToken) === "|") {
            this.position++;
            return this.namespace();
        }
        return this.splitWord(namespace);
    };
    _proto.loop = function loop() {
        while(this.position < this.tokens.length)this.parse(true);
        this.current._inferEndPosition();
        return this.root;
    };
    _proto.parse = function parse(throwOnParenthesis) {
        switch(this.currToken[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE]){
            case $2f1b22e17fc991cd$var$tokens.space:
                this.space();
                break;
            case $2f1b22e17fc991cd$var$tokens.comment:
                this.comment();
                break;
            case $2f1b22e17fc991cd$var$tokens.openParenthesis:
                this.parentheses();
                break;
            case $2f1b22e17fc991cd$var$tokens.closeParenthesis:
                if (throwOnParenthesis) this.missingParenthesis();
                break;
            case $2f1b22e17fc991cd$var$tokens.openSquare:
                this.attribute();
                break;
            case $2f1b22e17fc991cd$var$tokens.dollar:
            case $2f1b22e17fc991cd$var$tokens.caret:
            case $2f1b22e17fc991cd$var$tokens.equals:
            case $2f1b22e17fc991cd$var$tokens.word:
                this.word();
                break;
            case $2f1b22e17fc991cd$var$tokens.colon:
                this.pseudo();
                break;
            case $2f1b22e17fc991cd$var$tokens.comma:
                this.comma();
                break;
            case $2f1b22e17fc991cd$var$tokens.asterisk:
                this.universal();
                break;
            case $2f1b22e17fc991cd$var$tokens.ampersand:
                this.nesting();
                break;
            case $2f1b22e17fc991cd$var$tokens.slash:
            case $2f1b22e17fc991cd$var$tokens.combinator:
                this.combinator();
                break;
            case $2f1b22e17fc991cd$var$tokens.str:
                this.string();
                break;
            // These cases throw; no break needed.
            case $2f1b22e17fc991cd$var$tokens.closeSquare:
                this.missingSquareBracket();
            case $2f1b22e17fc991cd$var$tokens.semicolon:
                this.missingBackslash();
            default:
                this.unexpected();
        }
    } /**
   * Helpers
   */ ;
    _proto.expected = function expected(description, index, found) {
        if (Array.isArray(description)) {
            var last = description.pop();
            description = description.join(", ") + " or " + last;
        }
        var an = /^[aeiou]/.test(description[0]) ? "an" : "a";
        if (!found) return this.error("Expected " + an + " " + description + ".", {
            index: index
        });
        return this.error("Expected " + an + " " + description + ', found "' + found + '" instead.', {
            index: index
        });
    };
    _proto.requiredSpace = function requiredSpace(space) {
        return this.options.lossy ? " " : space;
    };
    _proto.optionalSpace = function optionalSpace(space) {
        return this.options.lossy ? "" : space;
    };
    _proto.lossySpace = function lossySpace(space, required) {
        if (this.options.lossy) return required ? " " : "";
        else return space;
    };
    _proto.parseParenthesisToken = function parseParenthesisToken(token) {
        var content = this.content(token);
        if (token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE] === $2f1b22e17fc991cd$var$tokens.space) return this.requiredSpace(content);
        else return content;
    };
    _proto.newNode = function newNode(node, namespace) {
        if (namespace) {
            if (/^ +$/.test(namespace)) {
                if (!this.options.lossy) this.spaces = (this.spaces || "") + namespace;
                namespace = true;
            }
            node.namespace = namespace;
            $2f1b22e17fc991cd$var$unescapeProp(node, "namespace");
        }
        if (this.spaces) {
            node.spaces.before = this.spaces;
            this.spaces = "";
        }
        return this.current.append(node);
    };
    _proto.content = function content(token) {
        if (token === void 0) token = this.currToken;
        return this.css.slice(token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.START_POS], token[$2f1b22e17fc991cd$var$_tokenize.FIELDS.END_POS]);
    };
    /**
   * returns the index of the next non-whitespace, non-comment token.
   * returns -1 if no meaningful token is found.
   */ _proto.locateNextMeaningfulToken = function locateNextMeaningfulToken(startPosition) {
        if (startPosition === void 0) startPosition = this.position + 1;
        var searchPosition = startPosition;
        while(searchPosition < this.tokens.length){
            if ($2f1b22e17fc991cd$var$WHITESPACE_EQUIV_TOKENS[this.tokens[searchPosition][$2f1b22e17fc991cd$var$_tokenize.FIELDS.TYPE]]) {
                searchPosition++;
                continue;
            } else return searchPosition;
        }
        return -1;
    };
    $2f1b22e17fc991cd$var$_createClass(Parser, [
        {
            key: "currToken",
            get: function get() {
                return this.tokens[this.position];
            }
        },
        {
            key: "nextToken",
            get: function get() {
                return this.tokens[this.position + 1];
            }
        },
        {
            key: "prevToken",
            get: function get() {
                return this.tokens[this.position - 1];
            }
        }
    ]);
    return Parser;
}();
module.exports["default"] = $2f1b22e17fc991cd$var$Parser;
module.exports = module.exports.default;

});
parcelRegister("inIHk", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $d61d0c046593c153$var$_container = $d61d0c046593c153$var$_interopRequireDefault((parcelRequire("6uNAw")));

var $lskax = parcelRequire("lskax");
function $d61d0c046593c153$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d61d0c046593c153$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d61d0c046593c153$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d61d0c046593c153$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d61d0c046593c153$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d61d0c046593c153$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d61d0c046593c153$var$_setPrototypeOf(subClass, superClass);
}
function $d61d0c046593c153$var$_setPrototypeOf(o, p) {
    $d61d0c046593c153$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d61d0c046593c153$var$_setPrototypeOf(o, p);
}
var $d61d0c046593c153$var$Root = /*#__PURE__*/ function(_Container) {
    $d61d0c046593c153$var$_inheritsLoose(Root, _Container);
    function Root(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $lskax.ROOT;
        return _this;
    }
    var _proto = Root.prototype;
    _proto.toString = function toString() {
        var str = this.reduce(function(memo, selector) {
            memo.push(String(selector));
            return memo;
        }, []).join(",");
        return this.trailingComma ? str + "," : str;
    };
    _proto.error = function error(message, options) {
        if (this._error) return this._error(message, options);
        else return new Error(message);
    };
    $d61d0c046593c153$var$_createClass(Root, [
        {
            key: "errorGenerator",
            set: function set(handler) {
                this._error = handler;
            }
        }
    ]);
    return Root;
}($d61d0c046593c153$var$_container["default"]);
module.exports["default"] = $d61d0c046593c153$var$Root;
module.exports = module.exports.default;

});
parcelRegister("6uNAw", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $4bac0290c2d2654f$var$_node = $4bac0290c2d2654f$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $4bac0290c2d2654f$var$types = $4bac0290c2d2654f$var$_interopRequireWildcard((parcelRequire("lskax")));
function $4bac0290c2d2654f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $4bac0290c2d2654f$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $4bac0290c2d2654f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $4bac0290c2d2654f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4bac0290c2d2654f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4bac0290c2d2654f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $4bac0290c2d2654f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
function $4bac0290c2d2654f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4bac0290c2d2654f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4bac0290c2d2654f$var$_arrayLikeToArray(o, minLen);
}
function $4bac0290c2d2654f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4bac0290c2d2654f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4bac0290c2d2654f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4bac0290c2d2654f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4bac0290c2d2654f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4bac0290c2d2654f$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $4bac0290c2d2654f$var$_setPrototypeOf(subClass, superClass);
}
function $4bac0290c2d2654f$var$_setPrototypeOf(o, p) {
    $4bac0290c2d2654f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4bac0290c2d2654f$var$_setPrototypeOf(o, p);
}
var $4bac0290c2d2654f$var$Container = /*#__PURE__*/ function(_Node) {
    $4bac0290c2d2654f$var$_inheritsLoose(Container, _Node);
    function Container(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        if (!_this.nodes) _this.nodes = [];
        return _this;
    }
    var _proto = Container.prototype;
    _proto.append = function append(selector) {
        selector.parent = this;
        this.nodes.push(selector);
        return this;
    };
    _proto.prepend = function prepend(selector) {
        selector.parent = this;
        this.nodes.unshift(selector);
        return this;
    };
    _proto.at = function at(index) {
        return this.nodes[index];
    };
    _proto.index = function index(child) {
        if (typeof child === "number") return child;
        return this.nodes.indexOf(child);
    };
    _proto.removeChild = function removeChild(child) {
        child = this.index(child);
        this.at(child).parent = undefined;
        this.nodes.splice(child, 1);
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        return this;
    };
    _proto.removeAll = function removeAll() {
        for(var _iterator = $4bac0290c2d2654f$var$_createForOfIteratorHelperLoose(this.nodes), _step; !(_step = _iterator()).done;){
            var node = _step.value;
            node.parent = undefined;
        }
        this.nodes = [];
        return this;
    };
    _proto.empty = function empty() {
        return this.removeAll();
    };
    _proto.insertAfter = function insertAfter(oldNode, newNode) {
        newNode.parent = this;
        var oldIndex = this.index(oldNode);
        this.nodes.splice(oldIndex + 1, 0, newNode);
        newNode.parent = this;
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (oldIndex <= index) this.indexes[id] = index + 1;
        }
        return this;
    };
    _proto.insertBefore = function insertBefore(oldNode, newNode) {
        newNode.parent = this;
        var oldIndex = this.index(oldNode);
        this.nodes.splice(oldIndex, 0, newNode);
        newNode.parent = this;
        var index;
        for(var id in this.indexes){
            index = this.indexes[id];
            if (index <= oldIndex) this.indexes[id] = index + 1;
        }
        return this;
    };
    _proto._findChildAtPosition = function _findChildAtPosition(line, col) {
        var found = undefined;
        this.each(function(node) {
            if (node.atPosition) {
                var foundChild = node.atPosition(line, col);
                if (foundChild) {
                    found = foundChild;
                    return false;
                }
            } else if (node.isAtPosition(line, col)) {
                found = node;
                return false;
            }
        });
        return found;
    } /**
   * Return the most specific node at the line and column number given.
   * The source location is based on the original parsed location, locations aren't
   * updated as selector nodes are mutated.
   * 
   * Note that this location is relative to the location of the first character
   * of the selector, and not the location of the selector in the overall document
   * when used in conjunction with postcss.
   *
   * If not found, returns undefined.
   * @param {number} line The line number of the node to find. (1-based index)
   * @param {number} col  The column number of the node to find. (1-based index)
   */ ;
    _proto.atPosition = function atPosition(line, col) {
        if (this.isAtPosition(line, col)) return this._findChildAtPosition(line, col) || this;
        else return undefined;
    };
    _proto._inferEndPosition = function _inferEndPosition() {
        if (this.last && this.last.source && this.last.source.end) {
            this.source = this.source || {};
            this.source.end = this.source.end || {};
            Object.assign(this.source.end, this.last.source.end);
        }
    };
    _proto.each = function each(callback) {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach++;
        var id = this.lastEach;
        this.indexes[id] = 0;
        if (!this.length) return undefined;
        var index, result;
        while(this.indexes[id] < this.length){
            index = this.indexes[id];
            result = callback(this.at(index), index);
            if (result === false) break;
            this.indexes[id] += 1;
        }
        delete this.indexes[id];
        if (result === false) return false;
    };
    _proto.walk = function walk(callback) {
        return this.each(function(node, i) {
            var result = callback(node, i);
            if (result !== false && node.length) result = node.walk(callback);
            if (result === false) return false;
        });
    };
    _proto.walkAttributes = function walkAttributes(callback) {
        var _this2 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.ATTRIBUTE) return callback.call(_this2, selector);
        });
    };
    _proto.walkClasses = function walkClasses(callback) {
        var _this3 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.CLASS) return callback.call(_this3, selector);
        });
    };
    _proto.walkCombinators = function walkCombinators(callback) {
        var _this4 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.COMBINATOR) return callback.call(_this4, selector);
        });
    };
    _proto.walkComments = function walkComments(callback) {
        var _this5 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.COMMENT) return callback.call(_this5, selector);
        });
    };
    _proto.walkIds = function walkIds(callback) {
        var _this6 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.ID) return callback.call(_this6, selector);
        });
    };
    _proto.walkNesting = function walkNesting(callback) {
        var _this7 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.NESTING) return callback.call(_this7, selector);
        });
    };
    _proto.walkPseudos = function walkPseudos(callback) {
        var _this8 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.PSEUDO) return callback.call(_this8, selector);
        });
    };
    _proto.walkTags = function walkTags(callback) {
        var _this9 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.TAG) return callback.call(_this9, selector);
        });
    };
    _proto.walkUniversals = function walkUniversals(callback) {
        var _this10 = this;
        return this.walk(function(selector) {
            if (selector.type === $4bac0290c2d2654f$var$types.UNIVERSAL) return callback.call(_this10, selector);
        });
    };
    _proto.split = function split(callback) {
        var _this11 = this;
        var current = [];
        return this.reduce(function(memo, node, index) {
            var split = callback.call(_this11, node);
            current.push(node);
            if (split) {
                memo.push(current);
                current = [];
            } else if (index === _this11.length - 1) memo.push(current);
            return memo;
        }, []);
    };
    _proto.map = function map(callback) {
        return this.nodes.map(callback);
    };
    _proto.reduce = function reduce(callback, memo) {
        return this.nodes.reduce(callback, memo);
    };
    _proto.every = function every(callback) {
        return this.nodes.every(callback);
    };
    _proto.some = function some(callback) {
        return this.nodes.some(callback);
    };
    _proto.filter = function filter(callback) {
        return this.nodes.filter(callback);
    };
    _proto.sort = function sort(callback) {
        return this.nodes.sort(callback);
    };
    _proto.toString = function toString() {
        return this.map(String).join("");
    };
    $4bac0290c2d2654f$var$_createClass(Container, [
        {
            key: "first",
            get: function get() {
                return this.at(0);
            }
        },
        {
            key: "last",
            get: function get() {
                return this.at(this.length - 1);
            }
        },
        {
            key: "length",
            get: function get() {
                return this.nodes.length;
            }
        }
    ]);
    return Container;
}($4bac0290c2d2654f$var$_node["default"]);
module.exports["default"] = $4bac0290c2d2654f$var$Container;
module.exports = module.exports.default;

});
parcelRegister("iA7ox", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $cxGLx = parcelRequire("cxGLx");
function $037db2e3f7450e96$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $037db2e3f7450e96$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $037db2e3f7450e96$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $037db2e3f7450e96$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $037db2e3f7450e96$var$cloneNode = function cloneNode(obj, parent) {
    if (typeof obj !== "object" || obj === null) return obj;
    var cloned = new obj.constructor();
    for(var i in obj){
        if (!obj.hasOwnProperty(i)) continue;
        var value = obj[i];
        var type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (value instanceof Array) cloned[i] = value.map(function(j) {
            return cloneNode(j, cloned);
        });
        else cloned[i] = cloneNode(value, cloned);
    }
    return cloned;
};
var $037db2e3f7450e96$var$Node = /*#__PURE__*/ function() {
    function Node(opts) {
        if (opts === void 0) opts = {};
        Object.assign(this, opts);
        this.spaces = this.spaces || {};
        this.spaces.before = this.spaces.before || "";
        this.spaces.after = this.spaces.after || "";
    }
    var _proto = Node.prototype;
    _proto.remove = function remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    };
    _proto.replaceWith = function replaceWith() {
        if (this.parent) {
            for(var index in arguments)this.parent.insertBefore(this, arguments[index]);
            this.remove();
        }
        return this;
    };
    _proto.next = function next() {
        return this.parent.at(this.parent.index(this) + 1);
    };
    _proto.prev = function prev() {
        return this.parent.at(this.parent.index(this) - 1);
    };
    _proto.clone = function clone(overrides) {
        if (overrides === void 0) overrides = {};
        var cloned = $037db2e3f7450e96$var$cloneNode(this);
        for(var name in overrides)cloned[name] = overrides[name];
        return cloned;
    } /**
   * Some non-standard syntax doesn't follow normal escaping rules for css.
   * This allows non standard syntax to be appended to an existing property
   * by specifying the escaped value. By specifying the escaped value,
   * illegal characters are allowed to be directly inserted into css output.
   * @param {string} name the property to set
   * @param {any} value the unescaped value of the property
   * @param {string} valueEscaped optional. the escaped value of the property.
   */ ;
    _proto.appendToPropertyAndEscape = function appendToPropertyAndEscape(name, value, valueEscaped) {
        if (!this.raws) this.raws = {};
        var originalValue = this[name];
        var originalEscaped = this.raws[name];
        this[name] = originalValue + value; // this may trigger a setter that updates raws, so it has to be set first.
        if (originalEscaped || valueEscaped !== value) this.raws[name] = (originalEscaped || originalValue) + valueEscaped;
        else delete this.raws[name]; // delete any escaped value that was created by the setter.
    } /**
   * Some non-standard syntax doesn't follow normal escaping rules for css.
   * This allows the escaped value to be specified directly, allowing illegal
   * characters to be directly inserted into css output.
   * @param {string} name the property to set
   * @param {any} value the unescaped value of the property
   * @param {string} valueEscaped the escaped value of the property.
   */ ;
    _proto.setPropertyAndEscape = function setPropertyAndEscape(name, value, valueEscaped) {
        if (!this.raws) this.raws = {};
        this[name] = value; // this may trigger a setter that updates raws, so it has to be set first.
        this.raws[name] = valueEscaped;
    } /**
   * When you want a value to passed through to CSS directly. This method
   * deletes the corresponding raw value causing the stringifier to fallback
   * to the unescaped value.
   * @param {string} name the property to set.
   * @param {any} value The value that is both escaped and unescaped.
   */ ;
    _proto.setPropertyWithoutEscape = function setPropertyWithoutEscape(name, value) {
        this[name] = value; // this may trigger a setter that updates raws, so it has to be set first.
        if (this.raws) delete this.raws[name];
    } /**
   *
   * @param {number} line The number (starting with 1)
   * @param {number} column The column number (starting with 1)
   */ ;
    _proto.isAtPosition = function isAtPosition(line, column) {
        if (this.source && this.source.start && this.source.end) {
            if (this.source.start.line > line) return false;
            if (this.source.end.line < line) return false;
            if (this.source.start.line === line && this.source.start.column > column) return false;
            if (this.source.end.line === line && this.source.end.column < column) return false;
            return true;
        }
        return undefined;
    };
    _proto.stringifyProperty = function stringifyProperty(name) {
        return this.raws && this.raws[name] || this[name];
    };
    _proto.valueToString = function valueToString() {
        return String(this.stringifyProperty("value"));
    };
    _proto.toString = function toString() {
        return [
            this.rawSpaceBefore,
            this.valueToString(),
            this.rawSpaceAfter
        ].join("");
    };
    $037db2e3f7450e96$var$_createClass(Node, [
        {
            key: "rawSpaceBefore",
            get: function get() {
                var rawSpace = this.raws && this.raws.spaces && this.raws.spaces.before;
                if (rawSpace === undefined) rawSpace = this.spaces && this.spaces.before;
                return rawSpace || "";
            },
            set: function set(raw) {
                (0, $cxGLx.ensureObject)(this, "raws", "spaces");
                this.raws.spaces.before = raw;
            }
        },
        {
            key: "rawSpaceAfter",
            get: function get() {
                var rawSpace = this.raws && this.raws.spaces && this.raws.spaces.after;
                if (rawSpace === undefined) rawSpace = this.spaces.after;
                return rawSpace || "";
            },
            set: function set(raw) {
                (0, $cxGLx.ensureObject)(this, "raws", "spaces");
                this.raws.spaces.after = raw;
            }
        }
    ]);
    return Node;
}();
module.exports["default"] = $037db2e3f7450e96$var$Node;
module.exports = module.exports.default;

});
parcelRegister("cxGLx", function(module, exports) {

$parcel$export(module.exports, "ensureObject", function () { return $9219bd7b576cbb29$export$b5478a1684008f71; }, function (v) { return $9219bd7b576cbb29$export$b5478a1684008f71 = v; });
$parcel$export(module.exports, "getProp", function () { return $9219bd7b576cbb29$export$88c9ddb45cea7241; }, function (v) { return $9219bd7b576cbb29$export$88c9ddb45cea7241 = v; });
$parcel$export(module.exports, "unesc", function () { return $9219bd7b576cbb29$export$9db703a29422957e; }, function (v) { return $9219bd7b576cbb29$export$9db703a29422957e = v; });
var $9219bd7b576cbb29$export$1e511d4a378977f5;
var $9219bd7b576cbb29$export$f46565c3d339d23a;
var $9219bd7b576cbb29$export$b5478a1684008f71;
var $9219bd7b576cbb29$export$88c9ddb45cea7241;
var $9219bd7b576cbb29$export$9db703a29422957e;
"use strict";
$9219bd7b576cbb29$export$1e511d4a378977f5 = true;
$9219bd7b576cbb29$export$f46565c3d339d23a = $9219bd7b576cbb29$export$b5478a1684008f71 = $9219bd7b576cbb29$export$88c9ddb45cea7241 = $9219bd7b576cbb29$export$9db703a29422957e = void 0;

var $9219bd7b576cbb29$var$_unesc = $9219bd7b576cbb29$var$_interopRequireDefault((parcelRequire("bHWQw")));
$9219bd7b576cbb29$export$9db703a29422957e = $9219bd7b576cbb29$var$_unesc["default"];

var $9219bd7b576cbb29$var$_getProp = $9219bd7b576cbb29$var$_interopRequireDefault((parcelRequire("4u5oZ")));
$9219bd7b576cbb29$export$88c9ddb45cea7241 = $9219bd7b576cbb29$var$_getProp["default"];

var $9219bd7b576cbb29$var$_ensureObject = $9219bd7b576cbb29$var$_interopRequireDefault((parcelRequire("9NnBC")));
$9219bd7b576cbb29$export$b5478a1684008f71 = $9219bd7b576cbb29$var$_ensureObject["default"];

var $9219bd7b576cbb29$var$_stripComments = $9219bd7b576cbb29$var$_interopRequireDefault((parcelRequire("4LQCu")));
$9219bd7b576cbb29$export$f46565c3d339d23a = $9219bd7b576cbb29$var$_stripComments["default"];
function $9219bd7b576cbb29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("bHWQw", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $88615b7af9b12496$var$unesc;
// Many thanks for this post which made this migration much easier.
// https://mathiasbynens.be/notes/css-escapes
/**
 * 
 * @param {string} str 
 * @returns {[string, number]|undefined}
 */ function $88615b7af9b12496$var$gobbleHex(str) {
    var lower = str.toLowerCase();
    var hex = "";
    var spaceTerminated = false;
    for(var i = 0; i < 6 && lower[i] !== undefined; i++){
        var code = lower.charCodeAt(i); // check to see if we are dealing with a valid hex char [a-f|0-9]
        var valid = code >= 97 && code <= 102 || code >= 48 && code <= 57; // https://drafts.csswg.org/css-syntax/#consume-escaped-code-point
        spaceTerminated = code === 32;
        if (!valid) break;
        hex += lower[i];
    }
    if (hex.length === 0) return undefined;
    var codePoint = parseInt(hex, 16);
    var isSurrogate = codePoint >= 0xD800 && codePoint <= 0xDFFF; // Add special case for
    // "If this number is zero, or is for a surrogate, or is greater than the maximum allowed code point"
    // https://drafts.csswg.org/css-syntax/#maximum-allowed-code-point
    if (isSurrogate || codePoint === 0x0000 || codePoint > 0x10FFFF) return [
        "\uFFFD",
        hex.length + (spaceTerminated ? 1 : 0)
    ];
    return [
        String.fromCodePoint(codePoint),
        hex.length + (spaceTerminated ? 1 : 0)
    ];
}
var $88615b7af9b12496$var$CONTAINS_ESCAPE = /\\/;
function $88615b7af9b12496$var$unesc(str) {
    var needToProcess = $88615b7af9b12496$var$CONTAINS_ESCAPE.test(str);
    if (!needToProcess) return str;
    var ret = "";
    for(var i = 0; i < str.length; i++){
        if (str[i] === "\\") {
            var gobbled = $88615b7af9b12496$var$gobbleHex(str.slice(i + 1, i + 7));
            if (gobbled !== undefined) {
                ret += gobbled[0];
                i += gobbled[1];
                continue;
            } // Retain a pair of \\ if double escaped `\\\\`
            // https://github.com/postcss/postcss-selector-parser/commit/268c9a7656fb53f543dc620aa5b73a30ec3ff20e
            if (str[i + 1] === "\\") {
                ret += "\\";
                i++;
                continue;
            } // if \\ is at the end of the string retain it
            // https://github.com/postcss/postcss-selector-parser/commit/01a6b346e3612ce1ab20219acc26abdc259ccefb
            if (str.length === i + 1) ret += str[i];
            continue;
        }
        ret += str[i];
    }
    return ret;
}
module.exports = module.exports.default;

});

parcelRegister("4u5oZ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $343e277c013636c8$var$getProp;
function $343e277c013636c8$var$getProp(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)props[_key - 1] = arguments[_key];
    while(props.length > 0){
        var prop = props.shift();
        if (!obj[prop]) return undefined;
        obj = obj[prop];
    }
    return obj;
}
module.exports = module.exports.default;

});

parcelRegister("9NnBC", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $721b0049d932776b$var$ensureObject;
function $721b0049d932776b$var$ensureObject(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)props[_key - 1] = arguments[_key];
    while(props.length > 0){
        var prop = props.shift();
        if (!obj[prop]) obj[prop] = {};
        obj = obj[prop];
    }
}
module.exports = module.exports.default;

});

parcelRegister("4LQCu", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $37945e6cf430c982$var$stripComments;
function $37945e6cf430c982$var$stripComments(str) {
    var s = "";
    var commentStart = str.indexOf("/*");
    var lastEnd = 0;
    while(commentStart >= 0){
        s = s + str.slice(lastEnd, commentStart);
        var commentEnd = str.indexOf("*/", commentStart + 2);
        if (commentEnd < 0) return s;
        lastEnd = commentEnd + 2;
        commentStart = str.indexOf("/*", lastEnd);
    }
    s = s + str.slice(lastEnd);
    return s;
}
module.exports = module.exports.default;

});



parcelRegister("lskax", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $f9ebdba067ed5583$export$1e511d4a378977f5; }, function (v) { return $f9ebdba067ed5583$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "UNIVERSAL", function () { return $f9ebdba067ed5583$export$1b322f0de0b7013c; }, function (v) { return $f9ebdba067ed5583$export$1b322f0de0b7013c = v; });
$parcel$export(module.exports, "ATTRIBUTE", function () { return $f9ebdba067ed5583$export$77a31abf1489fff; }, function (v) { return $f9ebdba067ed5583$export$77a31abf1489fff = v; });
$parcel$export(module.exports, "CLASS", function () { return $f9ebdba067ed5583$export$6120d77db9a8f6cb; }, function (v) { return $f9ebdba067ed5583$export$6120d77db9a8f6cb = v; });
$parcel$export(module.exports, "COMBINATOR", function () { return $f9ebdba067ed5583$export$79b4952c4e8820f9; }, function (v) { return $f9ebdba067ed5583$export$79b4952c4e8820f9 = v; });
$parcel$export(module.exports, "COMMENT", function () { return $f9ebdba067ed5583$export$a29989082612d0d9; }, function (v) { return $f9ebdba067ed5583$export$a29989082612d0d9 = v; });
$parcel$export(module.exports, "ID", function () { return $f9ebdba067ed5583$export$8be180ec26319f9f; }, function (v) { return $f9ebdba067ed5583$export$8be180ec26319f9f = v; });
$parcel$export(module.exports, "NESTING", function () { return $f9ebdba067ed5583$export$cc64a2a6b37abd26; }, function (v) { return $f9ebdba067ed5583$export$cc64a2a6b37abd26 = v; });
$parcel$export(module.exports, "PSEUDO", function () { return $f9ebdba067ed5583$export$92b96eef0c524913; }, function (v) { return $f9ebdba067ed5583$export$92b96eef0c524913 = v; });
$parcel$export(module.exports, "ROOT", function () { return $f9ebdba067ed5583$export$fbea82a1c0574ef4; }, function (v) { return $f9ebdba067ed5583$export$fbea82a1c0574ef4 = v; });
$parcel$export(module.exports, "SELECTOR", function () { return $f9ebdba067ed5583$export$c63acf214e1d55ea; }, function (v) { return $f9ebdba067ed5583$export$c63acf214e1d55ea = v; });
$parcel$export(module.exports, "STRING", function () { return $f9ebdba067ed5583$export$a0e01ba2ebef17f2; }, function (v) { return $f9ebdba067ed5583$export$a0e01ba2ebef17f2 = v; });
$parcel$export(module.exports, "TAG", function () { return $f9ebdba067ed5583$export$2680f340d0781853; }, function (v) { return $f9ebdba067ed5583$export$2680f340d0781853 = v; });
var $f9ebdba067ed5583$export$1e511d4a378977f5;
var $f9ebdba067ed5583$export$1b322f0de0b7013c;
var $f9ebdba067ed5583$export$77a31abf1489fff;
var $f9ebdba067ed5583$export$6120d77db9a8f6cb;
var $f9ebdba067ed5583$export$79b4952c4e8820f9;
var $f9ebdba067ed5583$export$a29989082612d0d9;
var $f9ebdba067ed5583$export$8be180ec26319f9f;
var $f9ebdba067ed5583$export$cc64a2a6b37abd26;
var $f9ebdba067ed5583$export$92b96eef0c524913;
var $f9ebdba067ed5583$export$fbea82a1c0574ef4;
var $f9ebdba067ed5583$export$c63acf214e1d55ea;
var $f9ebdba067ed5583$export$a0e01ba2ebef17f2;
var $f9ebdba067ed5583$export$2680f340d0781853;
"use strict";
$f9ebdba067ed5583$export$1e511d4a378977f5 = true;
$f9ebdba067ed5583$export$1b322f0de0b7013c = $f9ebdba067ed5583$export$77a31abf1489fff = $f9ebdba067ed5583$export$6120d77db9a8f6cb = $f9ebdba067ed5583$export$79b4952c4e8820f9 = $f9ebdba067ed5583$export$a29989082612d0d9 = $f9ebdba067ed5583$export$8be180ec26319f9f = $f9ebdba067ed5583$export$cc64a2a6b37abd26 = $f9ebdba067ed5583$export$92b96eef0c524913 = $f9ebdba067ed5583$export$fbea82a1c0574ef4 = $f9ebdba067ed5583$export$c63acf214e1d55ea = $f9ebdba067ed5583$export$a0e01ba2ebef17f2 = $f9ebdba067ed5583$export$2680f340d0781853 = void 0;
var $f9ebdba067ed5583$var$TAG = "tag";
$f9ebdba067ed5583$export$2680f340d0781853 = $f9ebdba067ed5583$var$TAG;
var $f9ebdba067ed5583$var$STRING = "string";
$f9ebdba067ed5583$export$a0e01ba2ebef17f2 = $f9ebdba067ed5583$var$STRING;
var $f9ebdba067ed5583$var$SELECTOR = "selector";
$f9ebdba067ed5583$export$c63acf214e1d55ea = $f9ebdba067ed5583$var$SELECTOR;
var $f9ebdba067ed5583$var$ROOT = "root";
$f9ebdba067ed5583$export$fbea82a1c0574ef4 = $f9ebdba067ed5583$var$ROOT;
var $f9ebdba067ed5583$var$PSEUDO = "pseudo";
$f9ebdba067ed5583$export$92b96eef0c524913 = $f9ebdba067ed5583$var$PSEUDO;
var $f9ebdba067ed5583$var$NESTING = "nesting";
$f9ebdba067ed5583$export$cc64a2a6b37abd26 = $f9ebdba067ed5583$var$NESTING;
var $f9ebdba067ed5583$var$ID = "id";
$f9ebdba067ed5583$export$8be180ec26319f9f = $f9ebdba067ed5583$var$ID;
var $f9ebdba067ed5583$var$COMMENT = "comment";
$f9ebdba067ed5583$export$a29989082612d0d9 = $f9ebdba067ed5583$var$COMMENT;
var $f9ebdba067ed5583$var$COMBINATOR = "combinator";
$f9ebdba067ed5583$export$79b4952c4e8820f9 = $f9ebdba067ed5583$var$COMBINATOR;
var $f9ebdba067ed5583$var$CLASS = "class";
$f9ebdba067ed5583$export$6120d77db9a8f6cb = $f9ebdba067ed5583$var$CLASS;
var $f9ebdba067ed5583$var$ATTRIBUTE = "attribute";
$f9ebdba067ed5583$export$77a31abf1489fff = $f9ebdba067ed5583$var$ATTRIBUTE;
var $f9ebdba067ed5583$var$UNIVERSAL = "universal";
$f9ebdba067ed5583$export$1b322f0de0b7013c = $f9ebdba067ed5583$var$UNIVERSAL;

});



parcelRegister("eid1T", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $a67cda886083380a$var$_container = $a67cda886083380a$var$_interopRequireDefault((parcelRequire("6uNAw")));

var $lskax = parcelRequire("lskax");
function $a67cda886083380a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a67cda886083380a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $a67cda886083380a$var$_setPrototypeOf(subClass, superClass);
}
function $a67cda886083380a$var$_setPrototypeOf(o, p) {
    $a67cda886083380a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a67cda886083380a$var$_setPrototypeOf(o, p);
}
var $a67cda886083380a$var$Selector = /*#__PURE__*/ function(_Container) {
    $a67cda886083380a$var$_inheritsLoose(Selector, _Container);
    function Selector(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $lskax.SELECTOR;
        return _this;
    }
    return Selector;
}($a67cda886083380a$var$_container["default"]);
module.exports["default"] = $a67cda886083380a$var$Selector;
module.exports = module.exports.default;

});

parcelRegister("akI15", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $785dea6b51996416$var$_cssesc = $785dea6b51996416$var$_interopRequireDefault((parcelRequire("fat4P")));

var $cxGLx = parcelRequire("cxGLx");

var $785dea6b51996416$var$_node = $785dea6b51996416$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $lskax = parcelRequire("lskax");
function $785dea6b51996416$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $785dea6b51996416$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $785dea6b51996416$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $785dea6b51996416$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $785dea6b51996416$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $785dea6b51996416$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $785dea6b51996416$var$_setPrototypeOf(subClass, superClass);
}
function $785dea6b51996416$var$_setPrototypeOf(o, p) {
    $785dea6b51996416$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $785dea6b51996416$var$_setPrototypeOf(o, p);
}
var $785dea6b51996416$var$ClassName = /*#__PURE__*/ function(_Node) {
    $785dea6b51996416$var$_inheritsLoose(ClassName, _Node);
    function ClassName(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $lskax.CLASS;
        _this._constructed = true;
        return _this;
    }
    var _proto = ClassName.prototype;
    _proto.valueToString = function valueToString() {
        return "." + _Node.prototype.valueToString.call(this);
    };
    $785dea6b51996416$var$_createClass(ClassName, [
        {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(v) {
                if (this._constructed) {
                    var escaped = (0, $785dea6b51996416$var$_cssesc["default"])(v, {
                        isIdentifier: true
                    });
                    if (escaped !== v) {
                        (0, $cxGLx.ensureObject)(this, "raws");
                        this.raws.value = escaped;
                    } else if (this.raws) delete this.raws.value;
                }
                this._value = v;
            }
        }
    ]);
    return ClassName;
}($785dea6b51996416$var$_node["default"]);
module.exports["default"] = $785dea6b51996416$var$ClassName;
module.exports = module.exports.default;

});
parcelRegister("fat4P", function(module, exports) {
/*! https://mths.be/cssesc v3.0.0 by @mathias */ "use strict";
var $b0ae584598c62e88$var$object = {};
var $b0ae584598c62e88$var$hasOwnProperty = $b0ae584598c62e88$var$object.hasOwnProperty;
var $b0ae584598c62e88$var$merge = function merge(options, defaults) {
    if (!options) return defaults;
    var result = {};
    for(var key in defaults)// `if (defaults.hasOwnProperty(key) { … }` is not needed here, since
    // only recognized option names are used.
    result[key] = $b0ae584598c62e88$var$hasOwnProperty.call(options, key) ? options[key] : defaults[key];
    return result;
};
var $b0ae584598c62e88$var$regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
var $b0ae584598c62e88$var$regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
var $b0ae584598c62e88$var$regexAlwaysEscape = /['"\\]/;
var $b0ae584598c62e88$var$regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
// https://mathiasbynens.be/notes/css-escapes#css
var $b0ae584598c62e88$var$cssesc = function cssesc(string, options) {
    options = $b0ae584598c62e88$var$merge(options, cssesc.options);
    if (options.quotes != "single" && options.quotes != "double") options.quotes = "single";
    var quote = options.quotes == "double" ? '"' : "'";
    var isIdentifier = options.isIdentifier;
    var firstChar = string.charAt(0);
    var output = "";
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var character = string.charAt(counter++);
        var codePoint = character.charCodeAt();
        var value = void 0;
        // If it’s not a printable ASCII character…
        if (codePoint < 0x20 || codePoint > 0x7E) {
            if (codePoint >= 0xD800 && codePoint <= 0xDBFF && counter < length) {
                // It’s a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // next character is low surrogate
                codePoint = ((codePoint & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000;
                else // It’s an unmatched surrogate; only append this code unit, in case
                // the next code unit is the high surrogate of a surrogate pair.
                counter--;
            }
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else {
            if (options.escapeEverything) {
                if ($b0ae584598c62e88$var$regexAnySingleEscape.test(character)) value = "\\" + character;
                else value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            } else if (/[\t\n\f\r\x0B]/.test(character)) value = "\\" + codePoint.toString(16).toUpperCase() + " ";
            else if (character == "\\" || !isIdentifier && (character == '"' && quote == character || character == "'" && quote == character) || isIdentifier && $b0ae584598c62e88$var$regexSingleEscape.test(character)) value = "\\" + character;
            else value = character;
        }
        output += value;
    }
    if (isIdentifier) {
        if (/^-[-\d]/.test(output)) output = "\\-" + output.slice(1);
        else if (/\d/.test(firstChar)) output = "\\3" + firstChar + " " + output.slice(1);
    }
    // Remove spaces after `\HEX` escapes that are not followed by a hex digit,
    // since they’re redundant. Note that this is only possible if the escape
    // sequence isn’t preceded by an odd number of backslashes.
    output = output.replace($b0ae584598c62e88$var$regexExcessiveSpaces, function($0, $1, $2) {
        if ($1 && $1.length % 2) // It’s not safe to remove the space, so don’t.
        return $0;
        // Strip the space.
        return ($1 || "") + $2;
    });
    if (!isIdentifier && options.wrap) return quote + output + quote;
    return output;
};
// Expose default options (so they can be overridden globally).
$b0ae584598c62e88$var$cssesc.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
};
$b0ae584598c62e88$var$cssesc.version = "3.0.0";
module.exports = $b0ae584598c62e88$var$cssesc;

});


parcelRegister("jsSX5", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $e2bb42296dba05f6$var$_node = $e2bb42296dba05f6$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $lskax = parcelRequire("lskax");
function $e2bb42296dba05f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e2bb42296dba05f6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e2bb42296dba05f6$var$_setPrototypeOf(subClass, superClass);
}
function $e2bb42296dba05f6$var$_setPrototypeOf(o, p) {
    $e2bb42296dba05f6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e2bb42296dba05f6$var$_setPrototypeOf(o, p);
}
var $e2bb42296dba05f6$var$Comment = /*#__PURE__*/ function(_Node) {
    $e2bb42296dba05f6$var$_inheritsLoose(Comment, _Node);
    function Comment(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $lskax.COMMENT;
        return _this;
    }
    return Comment;
}($e2bb42296dba05f6$var$_node["default"]);
module.exports["default"] = $e2bb42296dba05f6$var$Comment;
module.exports = module.exports.default;

});

parcelRegister("9TUOP", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $73555320c0082a26$var$_node = $73555320c0082a26$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $lskax = parcelRequire("lskax");
function $73555320c0082a26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $73555320c0082a26$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $73555320c0082a26$var$_setPrototypeOf(subClass, superClass);
}
function $73555320c0082a26$var$_setPrototypeOf(o, p) {
    $73555320c0082a26$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $73555320c0082a26$var$_setPrototypeOf(o, p);
}
var $73555320c0082a26$var$ID = /*#__PURE__*/ function(_Node) {
    $73555320c0082a26$var$_inheritsLoose(ID, _Node);
    function ID(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $lskax.ID;
        return _this;
    }
    var _proto = ID.prototype;
    _proto.valueToString = function valueToString() {
        return "#" + _Node.prototype.valueToString.call(this);
    };
    return ID;
}($73555320c0082a26$var$_node["default"]);
module.exports["default"] = $73555320c0082a26$var$ID;
module.exports = module.exports.default;

});

parcelRegister("3N0LC", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $2c268b06dba7f0a0$var$_namespace = $2c268b06dba7f0a0$var$_interopRequireDefault((parcelRequire("9gCGl")));

var $lskax = parcelRequire("lskax");
function $2c268b06dba7f0a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2c268b06dba7f0a0$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $2c268b06dba7f0a0$var$_setPrototypeOf(subClass, superClass);
}
function $2c268b06dba7f0a0$var$_setPrototypeOf(o, p) {
    $2c268b06dba7f0a0$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2c268b06dba7f0a0$var$_setPrototypeOf(o, p);
}
var $2c268b06dba7f0a0$var$Tag = /*#__PURE__*/ function(_Namespace) {
    $2c268b06dba7f0a0$var$_inheritsLoose(Tag, _Namespace);
    function Tag(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = $lskax.TAG;
        return _this;
    }
    return Tag;
}($2c268b06dba7f0a0$var$_namespace["default"]);
module.exports["default"] = $2c268b06dba7f0a0$var$Tag;
module.exports = module.exports.default;

});
parcelRegister("9gCGl", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $6bf39d1958ab195e$var$_cssesc = $6bf39d1958ab195e$var$_interopRequireDefault((parcelRequire("fat4P")));

var $cxGLx = parcelRequire("cxGLx");

var $6bf39d1958ab195e$var$_node = $6bf39d1958ab195e$var$_interopRequireDefault((parcelRequire("iA7ox")));
function $6bf39d1958ab195e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6bf39d1958ab195e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6bf39d1958ab195e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6bf39d1958ab195e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6bf39d1958ab195e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6bf39d1958ab195e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $6bf39d1958ab195e$var$_setPrototypeOf(subClass, superClass);
}
function $6bf39d1958ab195e$var$_setPrototypeOf(o, p) {
    $6bf39d1958ab195e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6bf39d1958ab195e$var$_setPrototypeOf(o, p);
}
var $6bf39d1958ab195e$var$Namespace = /*#__PURE__*/ function(_Node) {
    $6bf39d1958ab195e$var$_inheritsLoose(Namespace, _Node);
    function Namespace() {
        return _Node.apply(this, arguments) || this;
    }
    var _proto = Namespace.prototype;
    _proto.qualifiedName = function qualifiedName(value) {
        if (this.namespace) return this.namespaceString + "|" + value;
        else return value;
    };
    _proto.valueToString = function valueToString() {
        return this.qualifiedName(_Node.prototype.valueToString.call(this));
    };
    $6bf39d1958ab195e$var$_createClass(Namespace, [
        {
            key: "namespace",
            get: function get() {
                return this._namespace;
            },
            set: function set(namespace) {
                if (namespace === true || namespace === "*" || namespace === "&") {
                    this._namespace = namespace;
                    if (this.raws) delete this.raws.namespace;
                    return;
                }
                var escaped = (0, $6bf39d1958ab195e$var$_cssesc["default"])(namespace, {
                    isIdentifier: true
                });
                this._namespace = namespace;
                if (escaped !== namespace) {
                    (0, $cxGLx.ensureObject)(this, "raws");
                    this.raws.namespace = escaped;
                } else if (this.raws) delete this.raws.namespace;
            }
        },
        {
            key: "ns",
            get: function get() {
                return this._namespace;
            },
            set: function set(namespace) {
                this.namespace = namespace;
            }
        },
        {
            key: "namespaceString",
            get: function get() {
                if (this.namespace) {
                    var ns = this.stringifyProperty("namespace");
                    if (ns === true) return "";
                    else return ns;
                } else return "";
            }
        }
    ]);
    return Namespace;
}($6bf39d1958ab195e$var$_node["default"]);
module.exports["default"] = $6bf39d1958ab195e$var$Namespace;
module.exports = module.exports.default;

});


parcelRegister("jjiiN", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $e0edfd1a27bddc6b$var$_node = $e0edfd1a27bddc6b$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $lskax = parcelRequire("lskax");
function $e0edfd1a27bddc6b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e0edfd1a27bddc6b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e0edfd1a27bddc6b$var$_setPrototypeOf(subClass, superClass);
}
function $e0edfd1a27bddc6b$var$_setPrototypeOf(o, p) {
    $e0edfd1a27bddc6b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0edfd1a27bddc6b$var$_setPrototypeOf(o, p);
}
var $e0edfd1a27bddc6b$var$String = /*#__PURE__*/ function(_Node) {
    $e0edfd1a27bddc6b$var$_inheritsLoose(String, _Node);
    function String(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $lskax.STRING;
        return _this;
    }
    return String;
}($e0edfd1a27bddc6b$var$_node["default"]);
module.exports["default"] = $e0edfd1a27bddc6b$var$String;
module.exports = module.exports.default;

});

parcelRegister("fSDJL", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $b8fab91a730cd61e$var$_container = $b8fab91a730cd61e$var$_interopRequireDefault((parcelRequire("6uNAw")));

var $lskax = parcelRequire("lskax");
function $b8fab91a730cd61e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b8fab91a730cd61e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $b8fab91a730cd61e$var$_setPrototypeOf(subClass, superClass);
}
function $b8fab91a730cd61e$var$_setPrototypeOf(o, p) {
    $b8fab91a730cd61e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b8fab91a730cd61e$var$_setPrototypeOf(o, p);
}
var $b8fab91a730cd61e$var$Pseudo = /*#__PURE__*/ function(_Container) {
    $b8fab91a730cd61e$var$_inheritsLoose(Pseudo, _Container);
    function Pseudo(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = $lskax.PSEUDO;
        return _this;
    }
    var _proto = Pseudo.prototype;
    _proto.toString = function toString() {
        var params = this.length ? "(" + this.map(String).join(",") + ")" : "";
        return [
            this.rawSpaceBefore,
            this.stringifyProperty("value"),
            params,
            this.rawSpaceAfter
        ].join("");
    };
    return Pseudo;
}($b8fab91a730cd61e$var$_container["default"]);
module.exports["default"] = $b8fab91a730cd61e$var$Pseudo;
module.exports = module.exports.default;

});

parcelRegister("2jypc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $1af80b59487c32cf$export$1e511d4a378977f5; }, function (v) { return $1af80b59487c32cf$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "unescapeValue", function () { return $1af80b59487c32cf$export$1cd2dcb7d1153f00; }, function (v) { return $1af80b59487c32cf$export$1cd2dcb7d1153f00 = v; });
$parcel$export(module.exports, "default", function () { return $1af80b59487c32cf$export$2e2bcd8739ae039; }, function (v) { return $1af80b59487c32cf$export$2e2bcd8739ae039 = v; });
var $1af80b59487c32cf$export$1e511d4a378977f5;
var $1af80b59487c32cf$export$1cd2dcb7d1153f00;
var $1af80b59487c32cf$export$2e2bcd8739ae039;
"use strict";
$1af80b59487c32cf$export$1e511d4a378977f5 = true;
$1af80b59487c32cf$export$1cd2dcb7d1153f00 = $1af80b59487c32cf$var$unescapeValue;
$1af80b59487c32cf$export$2e2bcd8739ae039 = void 0;

var $1af80b59487c32cf$var$_cssesc = $1af80b59487c32cf$var$_interopRequireDefault((parcelRequire("fat4P")));

var $1af80b59487c32cf$var$_unesc = $1af80b59487c32cf$var$_interopRequireDefault((parcelRequire("bHWQw")));

var $1af80b59487c32cf$var$_namespace = $1af80b59487c32cf$var$_interopRequireDefault((parcelRequire("9gCGl")));

var $lskax = parcelRequire("lskax");
var $1af80b59487c32cf$var$_CSSESC_QUOTE_OPTIONS;
function $1af80b59487c32cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1af80b59487c32cf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1af80b59487c32cf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1af80b59487c32cf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1af80b59487c32cf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1af80b59487c32cf$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $1af80b59487c32cf$var$_setPrototypeOf(subClass, superClass);
}
function $1af80b59487c32cf$var$_setPrototypeOf(o, p) {
    $1af80b59487c32cf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1af80b59487c32cf$var$_setPrototypeOf(o, p);
}

var $4SymK = parcelRequire("4SymK");
var $1af80b59487c32cf$var$WRAPPED_IN_QUOTES = /^('|")([^]*)\1$/;
var $1af80b59487c32cf$var$warnOfDeprecatedValueAssignment = $4SymK(function() {}, "Assigning an attribute a value containing characters that might need to be escaped is deprecated. Call attribute.setValue() instead.");
var $1af80b59487c32cf$var$warnOfDeprecatedQuotedAssignment = $4SymK(function() {}, "Assigning attr.quoted is deprecated and has no effect. Assign to attr.quoteMark instead.");
var $1af80b59487c32cf$var$warnOfDeprecatedConstructor = $4SymK(function() {}, "Constructing an Attribute selector with a value without specifying quoteMark is deprecated. Note: The value should be unescaped now.");
function $1af80b59487c32cf$var$unescapeValue(value) {
    var deprecatedUsage = false;
    var quoteMark = null;
    var unescaped = value;
    var m = unescaped.match($1af80b59487c32cf$var$WRAPPED_IN_QUOTES);
    if (m) {
        quoteMark = m[1];
        unescaped = m[2];
    }
    unescaped = (0, $1af80b59487c32cf$var$_unesc["default"])(unescaped);
    if (unescaped !== value) deprecatedUsage = true;
    return {
        deprecatedUsage: deprecatedUsage,
        unescaped: unescaped,
        quoteMark: quoteMark
    };
}
function $1af80b59487c32cf$var$handleDeprecatedContructorOpts(opts) {
    if (opts.quoteMark !== undefined) return opts;
    if (opts.value === undefined) return opts;
    $1af80b59487c32cf$var$warnOfDeprecatedConstructor();
    var _unescapeValue = $1af80b59487c32cf$var$unescapeValue(opts.value), quoteMark = _unescapeValue.quoteMark, unescaped = _unescapeValue.unescaped;
    if (!opts.raws) opts.raws = {};
    if (opts.raws.value === undefined) opts.raws.value = opts.value;
    opts.value = unescaped;
    opts.quoteMark = quoteMark;
    return opts;
}
var $1af80b59487c32cf$var$Attribute = /*#__PURE__*/ function(_Namespace) {
    $1af80b59487c32cf$var$_inheritsLoose(Attribute, _Namespace);
    function Attribute(opts) {
        var _this;
        if (opts === void 0) opts = {};
        _this = _Namespace.call(this, $1af80b59487c32cf$var$handleDeprecatedContructorOpts(opts)) || this;
        _this.type = $lskax.ATTRIBUTE;
        _this.raws = _this.raws || {};
        Object.defineProperty(_this.raws, "unquoted", {
            get: $4SymK(function() {
                return _this.value;
            }, "attr.raws.unquoted is deprecated. Call attr.value instead."),
            set: $4SymK(function() {
                return _this.value;
            }, "Setting attr.raws.unquoted is deprecated and has no effect. attr.value is unescaped by default now.")
        });
        _this._constructed = true;
        return _this;
    }
    /**
   * Returns the Attribute's value quoted such that it would be legal to use
   * in the value of a css file. The original value's quotation setting
   * used for stringification is left unchanged. See `setValue(value, options)`
   * if you want to control the quote settings of a new value for the attribute.
   *
   * You can also change the quotation used for the current value by setting quoteMark.
   *
   * Options:
   *   * quoteMark {'"' | "'" | null} - Use this value to quote the value. If this
   *     option is not set, the original value for quoteMark will be used. If
   *     indeterminate, a double quote is used. The legal values are:
   *     * `null` - the value will be unquoted and characters will be escaped as necessary.
   *     * `'` - the value will be quoted with a single quote and single quotes are escaped.
   *     * `"` - the value will be quoted with a double quote and double quotes are escaped.
   *   * preferCurrentQuoteMark {boolean} - if true, prefer the source quote mark
   *     over the quoteMark option value.
   *   * smart {boolean} - if true, will select a quote mark based on the value
   *     and the other options specified here. See the `smartQuoteMark()`
   *     method.
   **/ var _proto = Attribute.prototype;
    _proto.getQuotedValue = function getQuotedValue(options) {
        if (options === void 0) options = {};
        var quoteMark = this._determineQuoteMark(options);
        var cssescopts = $1af80b59487c32cf$var$CSSESC_QUOTE_OPTIONS[quoteMark];
        var escaped = (0, $1af80b59487c32cf$var$_cssesc["default"])(this._value, cssescopts);
        return escaped;
    };
    _proto._determineQuoteMark = function _determineQuoteMark(options) {
        return options.smart ? this.smartQuoteMark(options) : this.preferredQuoteMark(options);
    } /**
   * Set the unescaped value with the specified quotation options. The value
   * provided must not include any wrapping quote marks -- those quotes will
   * be interpreted as part of the value and escaped accordingly.
   */ ;
    _proto.setValue = function setValue(value, options) {
        if (options === void 0) options = {};
        this._value = value;
        this._quoteMark = this._determineQuoteMark(options);
        this._syncRawValue();
    } /**
   * Intelligently select a quoteMark value based on the value's contents. If
   * the value is a legal CSS ident, it will not be quoted. Otherwise a quote
   * mark will be picked that minimizes the number of escapes.
   *
   * If there's no clear winner, the quote mark from these options is used,
   * then the source quote mark (this is inverted if `preferCurrentQuoteMark` is
   * true). If the quoteMark is unspecified, a double quote is used.
   *
   * @param options This takes the quoteMark and preferCurrentQuoteMark options
   * from the quoteValue method.
   */ ;
    _proto.smartQuoteMark = function smartQuoteMark(options) {
        var v = this.value;
        var numSingleQuotes = v.replace(/[^']/g, "").length;
        var numDoubleQuotes = v.replace(/[^"]/g, "").length;
        if (numSingleQuotes + numDoubleQuotes === 0) {
            var escaped = (0, $1af80b59487c32cf$var$_cssesc["default"])(v, {
                isIdentifier: true
            });
            if (escaped === v) return Attribute.NO_QUOTE;
            else {
                var pref = this.preferredQuoteMark(options);
                if (pref === Attribute.NO_QUOTE) {
                    // pick a quote mark that isn't none and see if it's smaller
                    var quote = this.quoteMark || options.quoteMark || Attribute.DOUBLE_QUOTE;
                    var opts = $1af80b59487c32cf$var$CSSESC_QUOTE_OPTIONS[quote];
                    var quoteValue = (0, $1af80b59487c32cf$var$_cssesc["default"])(v, opts);
                    if (quoteValue.length < escaped.length) return quote;
                }
                return pref;
            }
        } else if (numDoubleQuotes === numSingleQuotes) return this.preferredQuoteMark(options);
        else if (numDoubleQuotes < numSingleQuotes) return Attribute.DOUBLE_QUOTE;
        else return Attribute.SINGLE_QUOTE;
    } /**
   * Selects the preferred quote mark based on the options and the current quote mark value.
   * If you want the quote mark to depend on the attribute value, call `smartQuoteMark(opts)`
   * instead.
   */ ;
    _proto.preferredQuoteMark = function preferredQuoteMark(options) {
        var quoteMark = options.preferCurrentQuoteMark ? this.quoteMark : options.quoteMark;
        if (quoteMark === undefined) quoteMark = options.preferCurrentQuoteMark ? options.quoteMark : this.quoteMark;
        if (quoteMark === undefined) quoteMark = Attribute.DOUBLE_QUOTE;
        return quoteMark;
    };
    _proto._syncRawValue = function _syncRawValue() {
        var rawValue = (0, $1af80b59487c32cf$var$_cssesc["default"])(this._value, $1af80b59487c32cf$var$CSSESC_QUOTE_OPTIONS[this.quoteMark]);
        if (rawValue === this._value) {
            if (this.raws) delete this.raws.value;
        } else this.raws.value = rawValue;
    };
    _proto._handleEscapes = function _handleEscapes(prop, value) {
        if (this._constructed) {
            var escaped = (0, $1af80b59487c32cf$var$_cssesc["default"])(value, {
                isIdentifier: true
            });
            if (escaped !== value) this.raws[prop] = escaped;
            else delete this.raws[prop];
        }
    };
    _proto._spacesFor = function _spacesFor(name) {
        var attrSpaces = {
            before: "",
            after: ""
        };
        var spaces = this.spaces[name] || {};
        var rawSpaces = this.raws.spaces && this.raws.spaces[name] || {};
        return Object.assign(attrSpaces, spaces, rawSpaces);
    };
    _proto._stringFor = function _stringFor(name, spaceName, concat) {
        if (spaceName === void 0) spaceName = name;
        if (concat === void 0) concat = $1af80b59487c32cf$var$defaultAttrConcat;
        var attrSpaces = this._spacesFor(spaceName);
        return concat(this.stringifyProperty(name), attrSpaces);
    } /**
   * returns the offset of the attribute part specified relative to the
   * start of the node of the output string.
   *
   * * "ns" - alias for "namespace"
   * * "namespace" - the namespace if it exists.
   * * "attribute" - the attribute name
   * * "attributeNS" - the start of the attribute or its namespace
   * * "operator" - the match operator of the attribute
   * * "value" - The value (string or identifier)
   * * "insensitive" - the case insensitivity flag;
   * @param part One of the possible values inside an attribute.
   * @returns -1 if the name is invalid or the value doesn't exist in this attribute.
   */ ;
    _proto.offsetOf = function offsetOf(name) {
        var count = 1;
        var attributeSpaces = this._spacesFor("attribute");
        count += attributeSpaces.before.length;
        if (name === "namespace" || name === "ns") return this.namespace ? count : -1;
        if (name === "attributeNS") return count;
        count += this.namespaceString.length;
        if (this.namespace) count += 1;
        if (name === "attribute") return count;
        count += this.stringifyProperty("attribute").length;
        count += attributeSpaces.after.length;
        var operatorSpaces = this._spacesFor("operator");
        count += operatorSpaces.before.length;
        var operator = this.stringifyProperty("operator");
        if (name === "operator") return operator ? count : -1;
        count += operator.length;
        count += operatorSpaces.after.length;
        var valueSpaces = this._spacesFor("value");
        count += valueSpaces.before.length;
        var value = this.stringifyProperty("value");
        if (name === "value") return value ? count : -1;
        count += value.length;
        count += valueSpaces.after.length;
        var insensitiveSpaces = this._spacesFor("insensitive");
        count += insensitiveSpaces.before.length;
        if (name === "insensitive") return this.insensitive ? count : -1;
        return -1;
    };
    _proto.toString = function toString() {
        var _this2 = this;
        var selector = [
            this.rawSpaceBefore,
            "["
        ];
        selector.push(this._stringFor("qualifiedAttribute", "attribute"));
        if (this.operator && (this.value || this.value === "")) {
            selector.push(this._stringFor("operator"));
            selector.push(this._stringFor("value"));
            selector.push(this._stringFor("insensitiveFlag", "insensitive", function(attrValue, attrSpaces) {
                if (attrValue.length > 0 && !_this2.quoted && attrSpaces.before.length === 0 && !(_this2.spaces.value && _this2.spaces.value.after)) attrSpaces.before = " ";
                return $1af80b59487c32cf$var$defaultAttrConcat(attrValue, attrSpaces);
            }));
        }
        selector.push("]");
        selector.push(this.rawSpaceAfter);
        return selector.join("");
    };
    $1af80b59487c32cf$var$_createClass(Attribute, [
        {
            key: "quoted",
            get: function get() {
                var qm = this.quoteMark;
                return qm === "'" || qm === '"';
            },
            set: function set(value) {
                $1af80b59487c32cf$var$warnOfDeprecatedQuotedAssignment();
            }
        },
        {
            key: "quoteMark",
            get: function get() {
                return this._quoteMark;
            },
            set: function set(quoteMark) {
                if (!this._constructed) {
                    this._quoteMark = quoteMark;
                    return;
                }
                if (this._quoteMark !== quoteMark) {
                    this._quoteMark = quoteMark;
                    this._syncRawValue();
                }
            }
        },
        {
            key: "qualifiedAttribute",
            get: function get() {
                return this.qualifiedName(this.raws.attribute || this.attribute);
            }
        },
        {
            key: "insensitiveFlag",
            get: function get() {
                return this.insensitive ? "i" : "";
            }
        },
        {
            key: "value",
            get: function get() {
                return this._value;
            },
            set: function set(v) {
                if (this._constructed) {
                    var _unescapeValue2 = $1af80b59487c32cf$var$unescapeValue(v), deprecatedUsage = _unescapeValue2.deprecatedUsage, unescaped = _unescapeValue2.unescaped, quoteMark = _unescapeValue2.quoteMark;
                    if (deprecatedUsage) $1af80b59487c32cf$var$warnOfDeprecatedValueAssignment();
                    if (unescaped === this._value && quoteMark === this._quoteMark) return;
                    this._value = unescaped;
                    this._quoteMark = quoteMark;
                    this._syncRawValue();
                } else this._value = v;
            }
        },
        {
            key: "attribute",
            get: function get() {
                return this._attribute;
            },
            set: function set(name) {
                this._handleEscapes("attribute", name);
                this._attribute = name;
            }
        }
    ]);
    return Attribute;
}($1af80b59487c32cf$var$_namespace["default"]);
$1af80b59487c32cf$export$2e2bcd8739ae039 = $1af80b59487c32cf$var$Attribute;
$1af80b59487c32cf$var$Attribute.NO_QUOTE = null;
$1af80b59487c32cf$var$Attribute.SINGLE_QUOTE = "'";
$1af80b59487c32cf$var$Attribute.DOUBLE_QUOTE = '"';
var $1af80b59487c32cf$var$CSSESC_QUOTE_OPTIONS = ($1af80b59487c32cf$var$_CSSESC_QUOTE_OPTIONS = {
    "'": {
        quotes: "single",
        wrap: true
    },
    '"': {
        quotes: "double",
        wrap: true
    }
}, $1af80b59487c32cf$var$_CSSESC_QUOTE_OPTIONS[null] = {
    isIdentifier: true
}, $1af80b59487c32cf$var$_CSSESC_QUOTE_OPTIONS);
function $1af80b59487c32cf$var$defaultAttrConcat(attrValue, attrSpaces) {
    return "" + attrSpaces.before + attrValue + attrSpaces.after;
}

});
parcelRegister("4SymK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $38d6dce7fbf76fcf$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $38d6dce7fbf76fcf$var$deprecate(fn, msg) {
    if ($38d6dce7fbf76fcf$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($38d6dce7fbf76fcf$var$config("throwDeprecation")) throw new Error(msg);
            else if ($38d6dce7fbf76fcf$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $38d6dce7fbf76fcf$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});


parcelRegister("jDVao", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $e4ce00f3d1522078$var$_namespace = $e4ce00f3d1522078$var$_interopRequireDefault((parcelRequire("9gCGl")));

var $lskax = parcelRequire("lskax");
function $e4ce00f3d1522078$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e4ce00f3d1522078$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e4ce00f3d1522078$var$_setPrototypeOf(subClass, superClass);
}
function $e4ce00f3d1522078$var$_setPrototypeOf(o, p) {
    $e4ce00f3d1522078$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e4ce00f3d1522078$var$_setPrototypeOf(o, p);
}
var $e4ce00f3d1522078$var$Universal = /*#__PURE__*/ function(_Namespace) {
    $e4ce00f3d1522078$var$_inheritsLoose(Universal, _Namespace);
    function Universal(opts) {
        var _this;
        _this = _Namespace.call(this, opts) || this;
        _this.type = $lskax.UNIVERSAL;
        _this.value = "*";
        return _this;
    }
    return Universal;
}($e4ce00f3d1522078$var$_namespace["default"]);
module.exports["default"] = $e4ce00f3d1522078$var$Universal;
module.exports = module.exports.default;

});

parcelRegister("9Rp1Y", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $72dc7ae151c99392$var$_node = $72dc7ae151c99392$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $lskax = parcelRequire("lskax");
function $72dc7ae151c99392$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $72dc7ae151c99392$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $72dc7ae151c99392$var$_setPrototypeOf(subClass, superClass);
}
function $72dc7ae151c99392$var$_setPrototypeOf(o, p) {
    $72dc7ae151c99392$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $72dc7ae151c99392$var$_setPrototypeOf(o, p);
}
var $72dc7ae151c99392$var$Combinator = /*#__PURE__*/ function(_Node) {
    $72dc7ae151c99392$var$_inheritsLoose(Combinator, _Node);
    function Combinator(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $lskax.COMBINATOR;
        return _this;
    }
    return Combinator;
}($72dc7ae151c99392$var$_node["default"]);
module.exports["default"] = $72dc7ae151c99392$var$Combinator;
module.exports = module.exports.default;

});

parcelRegister("bpp70", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = void 0;

var $84e58240dd65a966$var$_node = $84e58240dd65a966$var$_interopRequireDefault((parcelRequire("iA7ox")));

var $lskax = parcelRequire("lskax");
function $84e58240dd65a966$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $84e58240dd65a966$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $84e58240dd65a966$var$_setPrototypeOf(subClass, superClass);
}
function $84e58240dd65a966$var$_setPrototypeOf(o, p) {
    $84e58240dd65a966$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $84e58240dd65a966$var$_setPrototypeOf(o, p);
}
var $84e58240dd65a966$var$Nesting = /*#__PURE__*/ function(_Node) {
    $84e58240dd65a966$var$_inheritsLoose(Nesting, _Node);
    function Nesting(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = $lskax.NESTING;
        _this.value = "&";
        return _this;
    }
    return Nesting;
}($84e58240dd65a966$var$_node["default"]);
module.exports["default"] = $84e58240dd65a966$var$Nesting;
module.exports = module.exports.default;

});

parcelRegister("95wzF", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $69ddd948249ab76d$var$sortAscending;
function $69ddd948249ab76d$var$sortAscending(list) {
    return list.sort(function(a, b) {
        return a - b;
    });
}
module.exports = module.exports.default;

});

parcelRegister("c6o92", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $8cf8c63fa5c680cb$export$1e511d4a378977f5; }, function (v) { return $8cf8c63fa5c680cb$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $8cf8c63fa5c680cb$export$2e2bcd8739ae039; }, function (v) { return $8cf8c63fa5c680cb$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "FIELDS", function () { return $8cf8c63fa5c680cb$export$e6909ad44e61103d; }, function (v) { return $8cf8c63fa5c680cb$export$e6909ad44e61103d = v; });
var $8cf8c63fa5c680cb$export$1e511d4a378977f5;
var $8cf8c63fa5c680cb$export$2e2bcd8739ae039;
var $8cf8c63fa5c680cb$export$e6909ad44e61103d;
"use strict";
$8cf8c63fa5c680cb$export$1e511d4a378977f5 = true;
$8cf8c63fa5c680cb$export$2e2bcd8739ae039 = $8cf8c63fa5c680cb$var$tokenize;
$8cf8c63fa5c680cb$export$e6909ad44e61103d = void 0;

var $8cf8c63fa5c680cb$var$t = $8cf8c63fa5c680cb$var$_interopRequireWildcard((parcelRequire("3Ij12")));
var $8cf8c63fa5c680cb$var$_unescapable, $8cf8c63fa5c680cb$var$_wordDelimiters;
function $8cf8c63fa5c680cb$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $8cf8c63fa5c680cb$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $8cf8c63fa5c680cb$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $8cf8c63fa5c680cb$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $8cf8c63fa5c680cb$var$unescapable = ($8cf8c63fa5c680cb$var$_unescapable = {}, $8cf8c63fa5c680cb$var$_unescapable[$8cf8c63fa5c680cb$var$t.tab] = true, $8cf8c63fa5c680cb$var$_unescapable[$8cf8c63fa5c680cb$var$t.newline] = true, $8cf8c63fa5c680cb$var$_unescapable[$8cf8c63fa5c680cb$var$t.cr] = true, $8cf8c63fa5c680cb$var$_unescapable[$8cf8c63fa5c680cb$var$t.feed] = true, $8cf8c63fa5c680cb$var$_unescapable);
var $8cf8c63fa5c680cb$var$wordDelimiters = ($8cf8c63fa5c680cb$var$_wordDelimiters = {}, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.space] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.tab] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.newline] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.cr] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.feed] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.ampersand] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.asterisk] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.bang] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.comma] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.colon] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.semicolon] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.openParenthesis] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.closeParenthesis] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.openSquare] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.closeSquare] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.singleQuote] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.doubleQuote] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.plus] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.pipe] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.tilde] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.greaterThan] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.equals] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.dollar] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.caret] = true, $8cf8c63fa5c680cb$var$_wordDelimiters[$8cf8c63fa5c680cb$var$t.slash] = true, $8cf8c63fa5c680cb$var$_wordDelimiters);
var $8cf8c63fa5c680cb$var$hex = {};
var $8cf8c63fa5c680cb$var$hexChars = "0123456789abcdefABCDEF";
for(var $8cf8c63fa5c680cb$var$i = 0; $8cf8c63fa5c680cb$var$i < $8cf8c63fa5c680cb$var$hexChars.length; $8cf8c63fa5c680cb$var$i++)$8cf8c63fa5c680cb$var$hex[$8cf8c63fa5c680cb$var$hexChars.charCodeAt($8cf8c63fa5c680cb$var$i)] = true;
/**
 *  Returns the last index of the bar css word
 * @param {string} css The string in which the word begins
 * @param {number} start The index into the string where word's first letter occurs
 */ function $8cf8c63fa5c680cb$var$consumeWord(css, start) {
    var next = start;
    var code;
    do {
        code = css.charCodeAt(next);
        if ($8cf8c63fa5c680cb$var$wordDelimiters[code]) return next - 1;
        else if (code === $8cf8c63fa5c680cb$var$t.backslash) next = $8cf8c63fa5c680cb$var$consumeEscape(css, next) + 1;
        else // All other characters are part of the word
        next++;
    }while (next < css.length);
    return next - 1;
}
/**
 *  Returns the last index of the escape sequence
 * @param {string} css The string in which the sequence begins
 * @param {number} start The index into the string where escape character (`\`) occurs.
 */ function $8cf8c63fa5c680cb$var$consumeEscape(css, start) {
    var next = start;
    var code = css.charCodeAt(next + 1);
    if ($8cf8c63fa5c680cb$var$unescapable[code]) ;
    else if ($8cf8c63fa5c680cb$var$hex[code]) {
        var hexDigits = 0; // consume up to 6 hex chars
        do {
            next++;
            hexDigits++;
            code = css.charCodeAt(next + 1);
        }while ($8cf8c63fa5c680cb$var$hex[code] && hexDigits < 6); // if fewer than 6 hex chars, a trailing space ends the escape
        if (hexDigits < 6 && code === $8cf8c63fa5c680cb$var$t.space) next++;
    } else // the next char is part of the current word
    next++;
    return next;
}
var $8cf8c63fa5c680cb$var$FIELDS = {
    TYPE: 0,
    START_LINE: 1,
    START_COL: 2,
    END_LINE: 3,
    END_COL: 4,
    START_POS: 5,
    END_POS: 6
};
$8cf8c63fa5c680cb$export$e6909ad44e61103d = $8cf8c63fa5c680cb$var$FIELDS;
function $8cf8c63fa5c680cb$var$tokenize(input) {
    var tokens = [];
    var css = input.css.valueOf();
    var _css = css, length = _css.length;
    var offset = -1;
    var line = 1;
    var start = 0;
    var end = 0;
    var code, content, endColumn, endLine, escaped, escapePos, last, lines, next, nextLine, nextOffset, quote, tokenType;
    function unclosed(what, fix) {
        if (input.safe) {
            // fyi: this is never set to true.
            css += fix;
            next = css.length - 1;
        } else throw input.error("Unclosed " + what, line, start - offset, start);
    }
    while(start < length){
        code = css.charCodeAt(start);
        if (code === $8cf8c63fa5c680cb$var$t.newline) {
            offset = start;
            line += 1;
        }
        switch(code){
            case $8cf8c63fa5c680cb$var$t.space:
            case $8cf8c63fa5c680cb$var$t.tab:
            case $8cf8c63fa5c680cb$var$t.newline:
            case $8cf8c63fa5c680cb$var$t.cr:
            case $8cf8c63fa5c680cb$var$t.feed:
                next = start;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                    if (code === $8cf8c63fa5c680cb$var$t.newline) {
                        offset = next;
                        line += 1;
                    }
                }while (code === $8cf8c63fa5c680cb$var$t.space || code === $8cf8c63fa5c680cb$var$t.newline || code === $8cf8c63fa5c680cb$var$t.tab || code === $8cf8c63fa5c680cb$var$t.cr || code === $8cf8c63fa5c680cb$var$t.feed);
                tokenType = $8cf8c63fa5c680cb$var$t.space;
                endLine = line;
                endColumn = next - offset - 1;
                end = next;
                break;
            case $8cf8c63fa5c680cb$var$t.plus:
            case $8cf8c63fa5c680cb$var$t.greaterThan:
            case $8cf8c63fa5c680cb$var$t.tilde:
            case $8cf8c63fa5c680cb$var$t.pipe:
                next = start;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $8cf8c63fa5c680cb$var$t.plus || code === $8cf8c63fa5c680cb$var$t.greaterThan || code === $8cf8c63fa5c680cb$var$t.tilde || code === $8cf8c63fa5c680cb$var$t.pipe);
                tokenType = $8cf8c63fa5c680cb$var$t.combinator;
                endLine = line;
                endColumn = start - offset;
                end = next;
                break;
            // Consume these characters as single tokens.
            case $8cf8c63fa5c680cb$var$t.asterisk:
            case $8cf8c63fa5c680cb$var$t.ampersand:
            case $8cf8c63fa5c680cb$var$t.bang:
            case $8cf8c63fa5c680cb$var$t.comma:
            case $8cf8c63fa5c680cb$var$t.equals:
            case $8cf8c63fa5c680cb$var$t.dollar:
            case $8cf8c63fa5c680cb$var$t.caret:
            case $8cf8c63fa5c680cb$var$t.openSquare:
            case $8cf8c63fa5c680cb$var$t.closeSquare:
            case $8cf8c63fa5c680cb$var$t.colon:
            case $8cf8c63fa5c680cb$var$t.semicolon:
            case $8cf8c63fa5c680cb$var$t.openParenthesis:
            case $8cf8c63fa5c680cb$var$t.closeParenthesis:
                next = start;
                tokenType = code;
                endLine = line;
                endColumn = start - offset;
                end = next + 1;
                break;
            case $8cf8c63fa5c680cb$var$t.singleQuote:
            case $8cf8c63fa5c680cb$var$t.doubleQuote:
                quote = code === $8cf8c63fa5c680cb$var$t.singleQuote ? "'" : '"';
                next = start;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) unclosed("quote", quote);
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $8cf8c63fa5c680cb$var$t.backslash){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                tokenType = $8cf8c63fa5c680cb$var$t.str;
                endLine = line;
                endColumn = start - offset;
                end = next + 1;
                break;
            default:
                if (code === $8cf8c63fa5c680cb$var$t.slash && css.charCodeAt(start + 1) === $8cf8c63fa5c680cb$var$t.asterisk) {
                    next = css.indexOf("*/", start + 2) + 1;
                    if (next === 0) unclosed("comment", "*/");
                    content = css.slice(start, next + 1);
                    lines = content.split("\n");
                    last = lines.length - 1;
                    if (last > 0) {
                        nextLine = line + last;
                        nextOffset = next - lines[last].length;
                    } else {
                        nextLine = line;
                        nextOffset = offset;
                    }
                    tokenType = $8cf8c63fa5c680cb$var$t.comment;
                    line = nextLine;
                    endLine = nextLine;
                    endColumn = next - nextOffset;
                } else if (code === $8cf8c63fa5c680cb$var$t.slash) {
                    next = start;
                    tokenType = code;
                    endLine = line;
                    endColumn = start - offset;
                    end = next + 1;
                } else {
                    next = $8cf8c63fa5c680cb$var$consumeWord(css, start);
                    tokenType = $8cf8c63fa5c680cb$var$t.word;
                    endLine = line;
                    endColumn = next - offset;
                }
                end = next + 1;
                break;
        } // Ensure that the token structure remains consistent
        tokens.push([
            tokenType,
            line,
            start - offset,
            endLine,
            endColumn,
            start,
            end // [6] End position
        ]); // Reset offset for the next token
        if (nextOffset) {
            offset = nextOffset;
            nextOffset = null;
        }
        start = end;
    }
    return tokens;
}

});
parcelRegister("3Ij12", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $2b443b4f0aafde52$export$1e511d4a378977f5; }, function (v) { return $2b443b4f0aafde52$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "combinator", function () { return $2b443b4f0aafde52$export$bc8905068a6d4174; }, function (v) { return $2b443b4f0aafde52$export$bc8905068a6d4174 = v; });
$parcel$export(module.exports, "word", function () { return $2b443b4f0aafde52$export$ac351257249182a8; }, function (v) { return $2b443b4f0aafde52$export$ac351257249182a8 = v; });
$parcel$export(module.exports, "comment", function () { return $2b443b4f0aafde52$export$4a34f930e789283c; }, function (v) { return $2b443b4f0aafde52$export$4a34f930e789283c = v; });
$parcel$export(module.exports, "str", function () { return $2b443b4f0aafde52$export$42d51816ce590c93; }, function (v) { return $2b443b4f0aafde52$export$42d51816ce590c93 = v; });
$parcel$export(module.exports, "tab", function () { return $2b443b4f0aafde52$export$62d58b1c91e8e902; }, function (v) { return $2b443b4f0aafde52$export$62d58b1c91e8e902 = v; });
$parcel$export(module.exports, "newline", function () { return $2b443b4f0aafde52$export$2ddee7401a648d43; }, function (v) { return $2b443b4f0aafde52$export$2ddee7401a648d43 = v; });
$parcel$export(module.exports, "feed", function () { return $2b443b4f0aafde52$export$93d5e4db1316498e; }, function (v) { return $2b443b4f0aafde52$export$93d5e4db1316498e = v; });
$parcel$export(module.exports, "cr", function () { return $2b443b4f0aafde52$export$cbfbec548517f2b6; }, function (v) { return $2b443b4f0aafde52$export$cbfbec548517f2b6 = v; });
$parcel$export(module.exports, "backslash", function () { return $2b443b4f0aafde52$export$799abffcbb2717d6; }, function (v) { return $2b443b4f0aafde52$export$799abffcbb2717d6 = v; });
$parcel$export(module.exports, "bang", function () { return $2b443b4f0aafde52$export$87bdb54b7ea1f8e2; }, function (v) { return $2b443b4f0aafde52$export$87bdb54b7ea1f8e2 = v; });
$parcel$export(module.exports, "slash", function () { return $2b443b4f0aafde52$export$6882e7e72b50612e; }, function (v) { return $2b443b4f0aafde52$export$6882e7e72b50612e = v; });
$parcel$export(module.exports, "doubleQuote", function () { return $2b443b4f0aafde52$export$730a07918a7a7d93; }, function (v) { return $2b443b4f0aafde52$export$730a07918a7a7d93 = v; });
$parcel$export(module.exports, "singleQuote", function () { return $2b443b4f0aafde52$export$1909b7b8a28995a9; }, function (v) { return $2b443b4f0aafde52$export$1909b7b8a28995a9 = v; });
$parcel$export(module.exports, "space", function () { return $2b443b4f0aafde52$export$a941ed4b947d12f8; }, function (v) { return $2b443b4f0aafde52$export$a941ed4b947d12f8 = v; });
$parcel$export(module.exports, "greaterThan", function () { return $2b443b4f0aafde52$export$f517ea36c68d4644; }, function (v) { return $2b443b4f0aafde52$export$f517ea36c68d4644 = v; });
$parcel$export(module.exports, "pipe", function () { return $2b443b4f0aafde52$export$a4627e546088548d; }, function (v) { return $2b443b4f0aafde52$export$a4627e546088548d = v; });
$parcel$export(module.exports, "equals", function () { return $2b443b4f0aafde52$export$e9bab7fafb253603; }, function (v) { return $2b443b4f0aafde52$export$e9bab7fafb253603 = v; });
$parcel$export(module.exports, "plus", function () { return $2b443b4f0aafde52$export$f25d54de1f4102d2; }, function (v) { return $2b443b4f0aafde52$export$f25d54de1f4102d2 = v; });
$parcel$export(module.exports, "caret", function () { return $2b443b4f0aafde52$export$e88cb2efb12ae807; }, function (v) { return $2b443b4f0aafde52$export$e88cb2efb12ae807 = v; });
$parcel$export(module.exports, "tilde", function () { return $2b443b4f0aafde52$export$a611fa4b0fba35ad; }, function (v) { return $2b443b4f0aafde52$export$a611fa4b0fba35ad = v; });
$parcel$export(module.exports, "dollar", function () { return $2b443b4f0aafde52$export$8fe35dc8637e3206; }, function (v) { return $2b443b4f0aafde52$export$8fe35dc8637e3206 = v; });
$parcel$export(module.exports, "closeSquare", function () { return $2b443b4f0aafde52$export$7b6078f56cfde01c; }, function (v) { return $2b443b4f0aafde52$export$7b6078f56cfde01c = v; });
$parcel$export(module.exports, "openSquare", function () { return $2b443b4f0aafde52$export$9ddc23fa6328dffe; }, function (v) { return $2b443b4f0aafde52$export$9ddc23fa6328dffe = v; });
$parcel$export(module.exports, "closeParenthesis", function () { return $2b443b4f0aafde52$export$aa2a86779c63174c; }, function (v) { return $2b443b4f0aafde52$export$aa2a86779c63174c = v; });
$parcel$export(module.exports, "openParenthesis", function () { return $2b443b4f0aafde52$export$c9fe493072ea3774; }, function (v) { return $2b443b4f0aafde52$export$c9fe493072ea3774 = v; });
$parcel$export(module.exports, "semicolon", function () { return $2b443b4f0aafde52$export$62fa27d385e555f3; }, function (v) { return $2b443b4f0aafde52$export$62fa27d385e555f3 = v; });
$parcel$export(module.exports, "colon", function () { return $2b443b4f0aafde52$export$3f956a517cb1b4c7; }, function (v) { return $2b443b4f0aafde52$export$3f956a517cb1b4c7 = v; });
$parcel$export(module.exports, "comma", function () { return $2b443b4f0aafde52$export$55e60fd3fa53db0b; }, function (v) { return $2b443b4f0aafde52$export$55e60fd3fa53db0b = v; });
$parcel$export(module.exports, "at", function () { return $2b443b4f0aafde52$export$493d36ec626b6698; }, function (v) { return $2b443b4f0aafde52$export$493d36ec626b6698 = v; });
$parcel$export(module.exports, "asterisk", function () { return $2b443b4f0aafde52$export$c0ec2bc372804b43; }, function (v) { return $2b443b4f0aafde52$export$c0ec2bc372804b43 = v; });
$parcel$export(module.exports, "ampersand", function () { return $2b443b4f0aafde52$export$1014e5a0857b6a20; }, function (v) { return $2b443b4f0aafde52$export$1014e5a0857b6a20 = v; });
var $2b443b4f0aafde52$export$1e511d4a378977f5;
var $2b443b4f0aafde52$export$bc8905068a6d4174;
var $2b443b4f0aafde52$export$ac351257249182a8;
var $2b443b4f0aafde52$export$4a34f930e789283c;
var $2b443b4f0aafde52$export$42d51816ce590c93;
var $2b443b4f0aafde52$export$62d58b1c91e8e902;
var $2b443b4f0aafde52$export$2ddee7401a648d43;
var $2b443b4f0aafde52$export$93d5e4db1316498e;
var $2b443b4f0aafde52$export$cbfbec548517f2b6;
var $2b443b4f0aafde52$export$799abffcbb2717d6;
var $2b443b4f0aafde52$export$87bdb54b7ea1f8e2;
var $2b443b4f0aafde52$export$6882e7e72b50612e;
var $2b443b4f0aafde52$export$730a07918a7a7d93;
var $2b443b4f0aafde52$export$1909b7b8a28995a9;
var $2b443b4f0aafde52$export$a941ed4b947d12f8;
var $2b443b4f0aafde52$export$f517ea36c68d4644;
var $2b443b4f0aafde52$export$a4627e546088548d;
var $2b443b4f0aafde52$export$e9bab7fafb253603;
var $2b443b4f0aafde52$export$f25d54de1f4102d2;
var $2b443b4f0aafde52$export$e88cb2efb12ae807;
var $2b443b4f0aafde52$export$a611fa4b0fba35ad;
var $2b443b4f0aafde52$export$8fe35dc8637e3206;
var $2b443b4f0aafde52$export$7b6078f56cfde01c;
var $2b443b4f0aafde52$export$9ddc23fa6328dffe;
var $2b443b4f0aafde52$export$aa2a86779c63174c;
var $2b443b4f0aafde52$export$c9fe493072ea3774;
var $2b443b4f0aafde52$export$62fa27d385e555f3;
var $2b443b4f0aafde52$export$3f956a517cb1b4c7;
var $2b443b4f0aafde52$export$55e60fd3fa53db0b;
var $2b443b4f0aafde52$export$493d36ec626b6698;
var $2b443b4f0aafde52$export$c0ec2bc372804b43;
var $2b443b4f0aafde52$export$1014e5a0857b6a20;
"use strict";
$2b443b4f0aafde52$export$1e511d4a378977f5 = true;
$2b443b4f0aafde52$export$bc8905068a6d4174 = $2b443b4f0aafde52$export$ac351257249182a8 = $2b443b4f0aafde52$export$4a34f930e789283c = $2b443b4f0aafde52$export$42d51816ce590c93 = $2b443b4f0aafde52$export$62d58b1c91e8e902 = $2b443b4f0aafde52$export$2ddee7401a648d43 = $2b443b4f0aafde52$export$93d5e4db1316498e = $2b443b4f0aafde52$export$cbfbec548517f2b6 = $2b443b4f0aafde52$export$799abffcbb2717d6 = $2b443b4f0aafde52$export$87bdb54b7ea1f8e2 = $2b443b4f0aafde52$export$6882e7e72b50612e = $2b443b4f0aafde52$export$730a07918a7a7d93 = $2b443b4f0aafde52$export$1909b7b8a28995a9 = $2b443b4f0aafde52$export$a941ed4b947d12f8 = $2b443b4f0aafde52$export$f517ea36c68d4644 = $2b443b4f0aafde52$export$a4627e546088548d = $2b443b4f0aafde52$export$e9bab7fafb253603 = $2b443b4f0aafde52$export$f25d54de1f4102d2 = $2b443b4f0aafde52$export$e88cb2efb12ae807 = $2b443b4f0aafde52$export$a611fa4b0fba35ad = $2b443b4f0aafde52$export$8fe35dc8637e3206 = $2b443b4f0aafde52$export$7b6078f56cfde01c = $2b443b4f0aafde52$export$9ddc23fa6328dffe = $2b443b4f0aafde52$export$aa2a86779c63174c = $2b443b4f0aafde52$export$c9fe493072ea3774 = $2b443b4f0aafde52$export$62fa27d385e555f3 = $2b443b4f0aafde52$export$3f956a517cb1b4c7 = $2b443b4f0aafde52$export$55e60fd3fa53db0b = $2b443b4f0aafde52$export$493d36ec626b6698 = $2b443b4f0aafde52$export$c0ec2bc372804b43 = $2b443b4f0aafde52$export$1014e5a0857b6a20 = void 0;
var $2b443b4f0aafde52$var$ampersand = 38; // `&`.charCodeAt(0);
$2b443b4f0aafde52$export$1014e5a0857b6a20 = $2b443b4f0aafde52$var$ampersand;
var $2b443b4f0aafde52$var$asterisk = 42; // `*`.charCodeAt(0);
$2b443b4f0aafde52$export$c0ec2bc372804b43 = $2b443b4f0aafde52$var$asterisk;
var $2b443b4f0aafde52$var$at = 64; // `@`.charCodeAt(0);
$2b443b4f0aafde52$export$493d36ec626b6698 = $2b443b4f0aafde52$var$at;
var $2b443b4f0aafde52$var$comma = 44; // `,`.charCodeAt(0);
$2b443b4f0aafde52$export$55e60fd3fa53db0b = $2b443b4f0aafde52$var$comma;
var $2b443b4f0aafde52$var$colon = 58; // `:`.charCodeAt(0);
$2b443b4f0aafde52$export$3f956a517cb1b4c7 = $2b443b4f0aafde52$var$colon;
var $2b443b4f0aafde52$var$semicolon = 59; // `;`.charCodeAt(0);
$2b443b4f0aafde52$export$62fa27d385e555f3 = $2b443b4f0aafde52$var$semicolon;
var $2b443b4f0aafde52$var$openParenthesis = 40; // `(`.charCodeAt(0);
$2b443b4f0aafde52$export$c9fe493072ea3774 = $2b443b4f0aafde52$var$openParenthesis;
var $2b443b4f0aafde52$var$closeParenthesis = 41; // `)`.charCodeAt(0);
$2b443b4f0aafde52$export$aa2a86779c63174c = $2b443b4f0aafde52$var$closeParenthesis;
var $2b443b4f0aafde52$var$openSquare = 91; // `[`.charCodeAt(0);
$2b443b4f0aafde52$export$9ddc23fa6328dffe = $2b443b4f0aafde52$var$openSquare;
var $2b443b4f0aafde52$var$closeSquare = 93; // `]`.charCodeAt(0);
$2b443b4f0aafde52$export$7b6078f56cfde01c = $2b443b4f0aafde52$var$closeSquare;
var $2b443b4f0aafde52$var$dollar = 36; // `$`.charCodeAt(0);
$2b443b4f0aafde52$export$8fe35dc8637e3206 = $2b443b4f0aafde52$var$dollar;
var $2b443b4f0aafde52$var$tilde = 126; // `~`.charCodeAt(0);
$2b443b4f0aafde52$export$a611fa4b0fba35ad = $2b443b4f0aafde52$var$tilde;
var $2b443b4f0aafde52$var$caret = 94; // `^`.charCodeAt(0);
$2b443b4f0aafde52$export$e88cb2efb12ae807 = $2b443b4f0aafde52$var$caret;
var $2b443b4f0aafde52$var$plus = 43; // `+`.charCodeAt(0);
$2b443b4f0aafde52$export$f25d54de1f4102d2 = $2b443b4f0aafde52$var$plus;
var $2b443b4f0aafde52$var$equals = 61; // `=`.charCodeAt(0);
$2b443b4f0aafde52$export$e9bab7fafb253603 = $2b443b4f0aafde52$var$equals;
var $2b443b4f0aafde52$var$pipe = 124; // `|`.charCodeAt(0);
$2b443b4f0aafde52$export$a4627e546088548d = $2b443b4f0aafde52$var$pipe;
var $2b443b4f0aafde52$var$greaterThan = 62; // `>`.charCodeAt(0);
$2b443b4f0aafde52$export$f517ea36c68d4644 = $2b443b4f0aafde52$var$greaterThan;
var $2b443b4f0aafde52$var$space = 32; // ` `.charCodeAt(0);
$2b443b4f0aafde52$export$a941ed4b947d12f8 = $2b443b4f0aafde52$var$space;
var $2b443b4f0aafde52$var$singleQuote = 39; // `'`.charCodeAt(0);
$2b443b4f0aafde52$export$1909b7b8a28995a9 = $2b443b4f0aafde52$var$singleQuote;
var $2b443b4f0aafde52$var$doubleQuote = 34; // `"`.charCodeAt(0);
$2b443b4f0aafde52$export$730a07918a7a7d93 = $2b443b4f0aafde52$var$doubleQuote;
var $2b443b4f0aafde52$var$slash = 47; // `/`.charCodeAt(0);
$2b443b4f0aafde52$export$6882e7e72b50612e = $2b443b4f0aafde52$var$slash;
var $2b443b4f0aafde52$var$bang = 33; // `!`.charCodeAt(0);
$2b443b4f0aafde52$export$87bdb54b7ea1f8e2 = $2b443b4f0aafde52$var$bang;
var $2b443b4f0aafde52$var$backslash = 92; // '\\'.charCodeAt(0);
$2b443b4f0aafde52$export$799abffcbb2717d6 = $2b443b4f0aafde52$var$backslash;
var $2b443b4f0aafde52$var$cr = 13; // '\r'.charCodeAt(0);
$2b443b4f0aafde52$export$cbfbec548517f2b6 = $2b443b4f0aafde52$var$cr;
var $2b443b4f0aafde52$var$feed = 12; // '\f'.charCodeAt(0);
$2b443b4f0aafde52$export$93d5e4db1316498e = $2b443b4f0aafde52$var$feed;
var $2b443b4f0aafde52$var$newline = 10; // '\n'.charCodeAt(0);
$2b443b4f0aafde52$export$2ddee7401a648d43 = $2b443b4f0aafde52$var$newline;
var $2b443b4f0aafde52$var$tab = 9; // '\t'.charCodeAt(0);
// Expose aliases primarily for readability.
$2b443b4f0aafde52$export$62d58b1c91e8e902 = $2b443b4f0aafde52$var$tab;
var $2b443b4f0aafde52$var$str = $2b443b4f0aafde52$var$singleQuote; // No good single character representation!
$2b443b4f0aafde52$export$42d51816ce590c93 = $2b443b4f0aafde52$var$str;
var $2b443b4f0aafde52$var$comment = -1;
$2b443b4f0aafde52$export$4a34f930e789283c = $2b443b4f0aafde52$var$comment;
var $2b443b4f0aafde52$var$word = -2;
$2b443b4f0aafde52$export$ac351257249182a8 = $2b443b4f0aafde52$var$word;
var $2b443b4f0aafde52$var$combinator = -3;
$2b443b4f0aafde52$export$bc8905068a6d4174 = $2b443b4f0aafde52$var$combinator;

});




parcelRegister("6i6fY", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $lskax = parcelRequire("lskax");
Object.keys($lskax).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $lskax[key]) return;
    module.exports[key] = $lskax[key];
});

var $1kBhS = parcelRequire("1kBhS");
Object.keys($1kBhS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1kBhS[key]) return;
    module.exports[key] = $1kBhS[key];
});

var $51o79 = parcelRequire("51o79");
Object.keys($51o79).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $51o79[key]) return;
    module.exports[key] = $51o79[key];
});

});
parcelRegister("1kBhS", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $0f849536fa9fe29e$export$1e511d4a378977f5; }, function (v) { return $0f849536fa9fe29e$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "universal", function () { return $0f849536fa9fe29e$export$253a18498b608cc0; }, function (v) { return $0f849536fa9fe29e$export$253a18498b608cc0 = v; });
$parcel$export(module.exports, "tag", function () { return $0f849536fa9fe29e$export$2b067c6666111485; }, function (v) { return $0f849536fa9fe29e$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "string", function () { return $0f849536fa9fe29e$export$22b082955e083ec3; }, function (v) { return $0f849536fa9fe29e$export$22b082955e083ec3 = v; });
$parcel$export(module.exports, "selector", function () { return $0f849536fa9fe29e$export$aea217a45095ce11; }, function (v) { return $0f849536fa9fe29e$export$aea217a45095ce11 = v; });
$parcel$export(module.exports, "root", function () { return $0f849536fa9fe29e$export$e8e78c978b129247; }, function (v) { return $0f849536fa9fe29e$export$e8e78c978b129247 = v; });
$parcel$export(module.exports, "pseudo", function () { return $0f849536fa9fe29e$export$4a40d01fa098dd92; }, function (v) { return $0f849536fa9fe29e$export$4a40d01fa098dd92 = v; });
$parcel$export(module.exports, "nesting", function () { return $0f849536fa9fe29e$export$3c4951fc6df31dde; }, function (v) { return $0f849536fa9fe29e$export$3c4951fc6df31dde = v; });
$parcel$export(module.exports, "id", function () { return $0f849536fa9fe29e$export$d560c7e4a29451c2; }, function (v) { return $0f849536fa9fe29e$export$d560c7e4a29451c2 = v; });
$parcel$export(module.exports, "comment", function () { return $0f849536fa9fe29e$export$4a34f930e789283c; }, function (v) { return $0f849536fa9fe29e$export$4a34f930e789283c = v; });
$parcel$export(module.exports, "combinator", function () { return $0f849536fa9fe29e$export$bc8905068a6d4174; }, function (v) { return $0f849536fa9fe29e$export$bc8905068a6d4174 = v; });
$parcel$export(module.exports, "className", function () { return $0f849536fa9fe29e$export$2913c0c0b5623090; }, function (v) { return $0f849536fa9fe29e$export$2913c0c0b5623090 = v; });
$parcel$export(module.exports, "attribute", function () { return $0f849536fa9fe29e$export$af4b9a83f4b00434; }, function (v) { return $0f849536fa9fe29e$export$af4b9a83f4b00434 = v; });
var $0f849536fa9fe29e$export$1e511d4a378977f5;
var $0f849536fa9fe29e$export$253a18498b608cc0;
var $0f849536fa9fe29e$export$2b067c6666111485;
var $0f849536fa9fe29e$export$22b082955e083ec3;
var $0f849536fa9fe29e$export$aea217a45095ce11;
var $0f849536fa9fe29e$export$e8e78c978b129247;
var $0f849536fa9fe29e$export$4a40d01fa098dd92;
var $0f849536fa9fe29e$export$3c4951fc6df31dde;
var $0f849536fa9fe29e$export$d560c7e4a29451c2;
var $0f849536fa9fe29e$export$4a34f930e789283c;
var $0f849536fa9fe29e$export$bc8905068a6d4174;
var $0f849536fa9fe29e$export$2913c0c0b5623090;
var $0f849536fa9fe29e$export$af4b9a83f4b00434;
"use strict";
$0f849536fa9fe29e$export$1e511d4a378977f5 = true;
$0f849536fa9fe29e$export$253a18498b608cc0 = $0f849536fa9fe29e$export$2b067c6666111485 = $0f849536fa9fe29e$export$22b082955e083ec3 = $0f849536fa9fe29e$export$aea217a45095ce11 = $0f849536fa9fe29e$export$e8e78c978b129247 = $0f849536fa9fe29e$export$4a40d01fa098dd92 = $0f849536fa9fe29e$export$3c4951fc6df31dde = $0f849536fa9fe29e$export$d560c7e4a29451c2 = $0f849536fa9fe29e$export$4a34f930e789283c = $0f849536fa9fe29e$export$bc8905068a6d4174 = $0f849536fa9fe29e$export$2913c0c0b5623090 = $0f849536fa9fe29e$export$af4b9a83f4b00434 = void 0;

var $0f849536fa9fe29e$var$_attribute = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("2jypc")));

var $0f849536fa9fe29e$var$_className = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("akI15")));

var $0f849536fa9fe29e$var$_combinator = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("9Rp1Y")));

var $0f849536fa9fe29e$var$_comment = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("jsSX5")));

var $0f849536fa9fe29e$var$_id = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("9TUOP")));

var $0f849536fa9fe29e$var$_nesting = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("bpp70")));

var $0f849536fa9fe29e$var$_pseudo = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("fSDJL")));

var $0f849536fa9fe29e$var$_root = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("inIHk")));

var $0f849536fa9fe29e$var$_selector = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("eid1T")));

var $0f849536fa9fe29e$var$_string = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("jjiiN")));

var $0f849536fa9fe29e$var$_tag = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("3N0LC")));

var $0f849536fa9fe29e$var$_universal = $0f849536fa9fe29e$var$_interopRequireDefault((parcelRequire("jDVao")));
function $0f849536fa9fe29e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $0f849536fa9fe29e$var$attribute = function attribute(opts) {
    return new $0f849536fa9fe29e$var$_attribute["default"](opts);
};
$0f849536fa9fe29e$export$af4b9a83f4b00434 = $0f849536fa9fe29e$var$attribute;
var $0f849536fa9fe29e$var$className = function className(opts) {
    return new $0f849536fa9fe29e$var$_className["default"](opts);
};
$0f849536fa9fe29e$export$2913c0c0b5623090 = $0f849536fa9fe29e$var$className;
var $0f849536fa9fe29e$var$combinator = function combinator(opts) {
    return new $0f849536fa9fe29e$var$_combinator["default"](opts);
};
$0f849536fa9fe29e$export$bc8905068a6d4174 = $0f849536fa9fe29e$var$combinator;
var $0f849536fa9fe29e$var$comment = function comment(opts) {
    return new $0f849536fa9fe29e$var$_comment["default"](opts);
};
$0f849536fa9fe29e$export$4a34f930e789283c = $0f849536fa9fe29e$var$comment;
var $0f849536fa9fe29e$var$id = function id(opts) {
    return new $0f849536fa9fe29e$var$_id["default"](opts);
};
$0f849536fa9fe29e$export$d560c7e4a29451c2 = $0f849536fa9fe29e$var$id;
var $0f849536fa9fe29e$var$nesting = function nesting(opts) {
    return new $0f849536fa9fe29e$var$_nesting["default"](opts);
};
$0f849536fa9fe29e$export$3c4951fc6df31dde = $0f849536fa9fe29e$var$nesting;
var $0f849536fa9fe29e$var$pseudo = function pseudo(opts) {
    return new $0f849536fa9fe29e$var$_pseudo["default"](opts);
};
$0f849536fa9fe29e$export$4a40d01fa098dd92 = $0f849536fa9fe29e$var$pseudo;
var $0f849536fa9fe29e$var$root = function root(opts) {
    return new $0f849536fa9fe29e$var$_root["default"](opts);
};
$0f849536fa9fe29e$export$e8e78c978b129247 = $0f849536fa9fe29e$var$root;
var $0f849536fa9fe29e$var$selector = function selector(opts) {
    return new $0f849536fa9fe29e$var$_selector["default"](opts);
};
$0f849536fa9fe29e$export$aea217a45095ce11 = $0f849536fa9fe29e$var$selector;
var $0f849536fa9fe29e$var$string = function string(opts) {
    return new $0f849536fa9fe29e$var$_string["default"](opts);
};
$0f849536fa9fe29e$export$22b082955e083ec3 = $0f849536fa9fe29e$var$string;
var $0f849536fa9fe29e$var$tag = function tag(opts) {
    return new $0f849536fa9fe29e$var$_tag["default"](opts);
};
$0f849536fa9fe29e$export$2b067c6666111485 = $0f849536fa9fe29e$var$tag;
var $0f849536fa9fe29e$var$universal = function universal(opts) {
    return new $0f849536fa9fe29e$var$_universal["default"](opts);
};
$0f849536fa9fe29e$export$253a18498b608cc0 = $0f849536fa9fe29e$var$universal;

});

parcelRegister("51o79", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $3a7fc0562560ad13$export$1e511d4a378977f5; }, function (v) { return $3a7fc0562560ad13$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "isNode", function () { return $3a7fc0562560ad13$export$8ee0fc9ee280b4ee; }, function (v) { return $3a7fc0562560ad13$export$8ee0fc9ee280b4ee = v; });
$parcel$export(module.exports, "isPseudoElement", function () { return $3a7fc0562560ad13$export$50c377054049744f; }, function (v) { return $3a7fc0562560ad13$export$50c377054049744f = v; });
$parcel$export(module.exports, "isPseudoClass", function () { return $3a7fc0562560ad13$export$4f9a537d87bfe39; }, function (v) { return $3a7fc0562560ad13$export$4f9a537d87bfe39 = v; });
$parcel$export(module.exports, "isContainer", function () { return $3a7fc0562560ad13$export$16f58a42b9d38aa; }, function (v) { return $3a7fc0562560ad13$export$16f58a42b9d38aa = v; });
$parcel$export(module.exports, "isNamespace", function () { return $3a7fc0562560ad13$export$f7be8ad7c940f0dc; }, function (v) { return $3a7fc0562560ad13$export$f7be8ad7c940f0dc = v; });
$parcel$export(module.exports, "isUniversal", function () { return $3a7fc0562560ad13$export$c7e5a35eb76305e; }, function (v) { return $3a7fc0562560ad13$export$c7e5a35eb76305e = v; });
$parcel$export(module.exports, "isTag", function () { return $3a7fc0562560ad13$export$3bf645f08efe3292; }, function (v) { return $3a7fc0562560ad13$export$3bf645f08efe3292 = v; });
$parcel$export(module.exports, "isString", function () { return $3a7fc0562560ad13$export$844ec244b1367d54; }, function (v) { return $3a7fc0562560ad13$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSelector", function () { return $3a7fc0562560ad13$export$faef9c3580d96b22; }, function (v) { return $3a7fc0562560ad13$export$faef9c3580d96b22 = v; });
$parcel$export(module.exports, "isRoot", function () { return $3a7fc0562560ad13$export$e3140dc7d0c35e48; }, function (v) { return $3a7fc0562560ad13$export$e3140dc7d0c35e48 = v; });
$parcel$export(module.exports, "isPseudo", function () { return $3a7fc0562560ad13$export$128e5790e44a4eef; }, function (v) { return $3a7fc0562560ad13$export$128e5790e44a4eef = v; });
$parcel$export(module.exports, "isNesting", function () { return $3a7fc0562560ad13$export$c0384a4fd85c6979; }, function (v) { return $3a7fc0562560ad13$export$c0384a4fd85c6979 = v; });
$parcel$export(module.exports, "isIdentifier", function () { return $3a7fc0562560ad13$export$8ce3792bf42f8358; }, function (v) { return $3a7fc0562560ad13$export$8ce3792bf42f8358 = v; });
$parcel$export(module.exports, "isComment", function () { return $3a7fc0562560ad13$export$3ab01370f5e64ac8; }, function (v) { return $3a7fc0562560ad13$export$3ab01370f5e64ac8 = v; });
$parcel$export(module.exports, "isCombinator", function () { return $3a7fc0562560ad13$export$d16bf37c1d7d3358; }, function (v) { return $3a7fc0562560ad13$export$d16bf37c1d7d3358 = v; });
$parcel$export(module.exports, "isClassName", function () { return $3a7fc0562560ad13$export$d53f3db2f43345df; }, function (v) { return $3a7fc0562560ad13$export$d53f3db2f43345df = v; });
$parcel$export(module.exports, "isAttribute", function () { return $3a7fc0562560ad13$export$7500d9bbb9458138; }, function (v) { return $3a7fc0562560ad13$export$7500d9bbb9458138 = v; });
var $3a7fc0562560ad13$export$1e511d4a378977f5;
var $3a7fc0562560ad13$export$8ee0fc9ee280b4ee;
var $3a7fc0562560ad13$export$50c377054049744f;
var $3a7fc0562560ad13$export$4f9a537d87bfe39;
var $3a7fc0562560ad13$export$16f58a42b9d38aa;
var $3a7fc0562560ad13$export$f7be8ad7c940f0dc;
var $3a7fc0562560ad13$export$c7e5a35eb76305e;
var $3a7fc0562560ad13$export$3bf645f08efe3292;
var $3a7fc0562560ad13$export$844ec244b1367d54;
var $3a7fc0562560ad13$export$faef9c3580d96b22;
var $3a7fc0562560ad13$export$e3140dc7d0c35e48;
var $3a7fc0562560ad13$export$128e5790e44a4eef;
var $3a7fc0562560ad13$export$c0384a4fd85c6979;
var $3a7fc0562560ad13$export$8ce3792bf42f8358;
var $3a7fc0562560ad13$export$3ab01370f5e64ac8;
var $3a7fc0562560ad13$export$d16bf37c1d7d3358;
var $3a7fc0562560ad13$export$d53f3db2f43345df;
var $3a7fc0562560ad13$export$7500d9bbb9458138;
"use strict";
$3a7fc0562560ad13$export$1e511d4a378977f5 = true;
$3a7fc0562560ad13$export$8ee0fc9ee280b4ee = $3a7fc0562560ad13$var$isNode;
$3a7fc0562560ad13$export$50c377054049744f = $3a7fc0562560ad13$var$isPseudoElement;
$3a7fc0562560ad13$export$4f9a537d87bfe39 = $3a7fc0562560ad13$var$isPseudoClass;
$3a7fc0562560ad13$export$16f58a42b9d38aa = $3a7fc0562560ad13$var$isContainer;
$3a7fc0562560ad13$export$f7be8ad7c940f0dc = $3a7fc0562560ad13$var$isNamespace;
$3a7fc0562560ad13$export$c7e5a35eb76305e = $3a7fc0562560ad13$export$3bf645f08efe3292 = $3a7fc0562560ad13$export$844ec244b1367d54 = $3a7fc0562560ad13$export$faef9c3580d96b22 = $3a7fc0562560ad13$export$e3140dc7d0c35e48 = $3a7fc0562560ad13$export$128e5790e44a4eef = $3a7fc0562560ad13$export$c0384a4fd85c6979 = $3a7fc0562560ad13$export$8ce3792bf42f8358 = $3a7fc0562560ad13$export$3ab01370f5e64ac8 = $3a7fc0562560ad13$export$d16bf37c1d7d3358 = $3a7fc0562560ad13$export$d53f3db2f43345df = $3a7fc0562560ad13$export$7500d9bbb9458138 = void 0;

var $lskax = parcelRequire("lskax");
var $3a7fc0562560ad13$var$_IS_TYPE;
var $3a7fc0562560ad13$var$IS_TYPE = ($3a7fc0562560ad13$var$_IS_TYPE = {}, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.ATTRIBUTE] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.CLASS] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.COMBINATOR] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.COMMENT] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.ID] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.NESTING] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.PSEUDO] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.ROOT] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.SELECTOR] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.STRING] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.TAG] = true, $3a7fc0562560ad13$var$_IS_TYPE[$lskax.UNIVERSAL] = true, $3a7fc0562560ad13$var$_IS_TYPE);
function $3a7fc0562560ad13$var$isNode(node) {
    return typeof node === "object" && $3a7fc0562560ad13$var$IS_TYPE[node.type];
}
function $3a7fc0562560ad13$var$isNodeType(type, node) {
    return $3a7fc0562560ad13$var$isNode(node) && node.type === type;
}
var $3a7fc0562560ad13$var$isAttribute = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.ATTRIBUTE);
$3a7fc0562560ad13$export$7500d9bbb9458138 = $3a7fc0562560ad13$var$isAttribute;
var $3a7fc0562560ad13$var$isClassName = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.CLASS);
$3a7fc0562560ad13$export$d53f3db2f43345df = $3a7fc0562560ad13$var$isClassName;
var $3a7fc0562560ad13$var$isCombinator = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.COMBINATOR);
$3a7fc0562560ad13$export$d16bf37c1d7d3358 = $3a7fc0562560ad13$var$isCombinator;
var $3a7fc0562560ad13$var$isComment = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.COMMENT);
$3a7fc0562560ad13$export$3ab01370f5e64ac8 = $3a7fc0562560ad13$var$isComment;
var $3a7fc0562560ad13$var$isIdentifier = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.ID);
$3a7fc0562560ad13$export$8ce3792bf42f8358 = $3a7fc0562560ad13$var$isIdentifier;
var $3a7fc0562560ad13$var$isNesting = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.NESTING);
$3a7fc0562560ad13$export$c0384a4fd85c6979 = $3a7fc0562560ad13$var$isNesting;
var $3a7fc0562560ad13$var$isPseudo = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.PSEUDO);
$3a7fc0562560ad13$export$128e5790e44a4eef = $3a7fc0562560ad13$var$isPseudo;
var $3a7fc0562560ad13$var$isRoot = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.ROOT);
$3a7fc0562560ad13$export$e3140dc7d0c35e48 = $3a7fc0562560ad13$var$isRoot;
var $3a7fc0562560ad13$var$isSelector = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.SELECTOR);
$3a7fc0562560ad13$export$faef9c3580d96b22 = $3a7fc0562560ad13$var$isSelector;
var $3a7fc0562560ad13$var$isString = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.STRING);
$3a7fc0562560ad13$export$844ec244b1367d54 = $3a7fc0562560ad13$var$isString;
var $3a7fc0562560ad13$var$isTag = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.TAG);
$3a7fc0562560ad13$export$3bf645f08efe3292 = $3a7fc0562560ad13$var$isTag;
var $3a7fc0562560ad13$var$isUniversal = $3a7fc0562560ad13$var$isNodeType.bind(null, $lskax.UNIVERSAL);
$3a7fc0562560ad13$export$c7e5a35eb76305e = $3a7fc0562560ad13$var$isUniversal;
function $3a7fc0562560ad13$var$isPseudoElement(node) {
    return $3a7fc0562560ad13$var$isPseudo(node) && node.value && (node.value.startsWith("::") || node.value.toLowerCase() === ":before" || node.value.toLowerCase() === ":after" || node.value.toLowerCase() === ":first-letter" || node.value.toLowerCase() === ":first-line");
}
function $3a7fc0562560ad13$var$isPseudoClass(node) {
    return $3a7fc0562560ad13$var$isPseudo(node) && !$3a7fc0562560ad13$var$isPseudoElement(node);
}
function $3a7fc0562560ad13$var$isContainer(node) {
    return !!($3a7fc0562560ad13$var$isNode(node) && node.walk);
}
function $3a7fc0562560ad13$var$isNamespace(node) {
    return $3a7fc0562560ad13$var$isAttribute(node) || $3a7fc0562560ad13$var$isTag(node);
}

});





parcelRegister("5LgCT", function(module, exports) {

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $aFSi5 = parcelRequire("aFSi5");
const $431e3d2e847f57ae$var$baseStyles = {
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical"
};
const $431e3d2e847f57ae$var$lineClamp = $aFSi5(function({ matchUtilities: matchUtilities, addUtilities: addUtilities, theme: theme, variants: variants, e: e }) {
    const values = theme("lineClamp");
    matchUtilities({
        "line-clamp": (value)=>(0, $2qxEV._)((0, $9tqwB._)({}, $431e3d2e847f57ae$var$baseStyles), {
                "-webkit-line-clamp": `${value}`
            })
    }, {
        values: values
    });
    addUtilities([
        {
            ".line-clamp-none": {
                "-webkit-line-clamp": "unset"
            }
        }
    ], variants("lineClamp"));
}, {
    theme: {
        lineClamp: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6"
        }
    },
    variants: {
        lineClamp: [
            "responsive"
        ]
    }
});
module.exports = $431e3d2e847f57ae$var$lineClamp;

});

parcelRegister("izvh2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $5gtWh = parcelRequire("5gtWh");
function $d853c13b2dc97120$var$emptyFunction() {}
function $d853c13b2dc97120$var$emptyFunctionWithReset() {}
$d853c13b2dc97120$var$emptyFunctionWithReset.resetWarningCache = $d853c13b2dc97120$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $5gtWh) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d853c13b2dc97120$var$emptyFunctionWithReset,
        resetWarningCache: $d853c13b2dc97120$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("5gtWh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $3d55aba8b68b60d2$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $3d55aba8b68b60d2$var$ReactPropTypesSecret;

});


parcelRegister("gDLrq", function(module, exports) {
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.35", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", VIERA = "Viera", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat(Win) Desktop"
                ]
            ],
            [
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(metasr)[\/ ]?([\w\.]+)/i,
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(chromium|instagram)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+)(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows) nt 6\.2; (arm)/i,
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Windows"
                ],
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /ios;fbsv\/([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("hHQoE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Sortable", function () { return $ce3f18abd8ce03db$export$31b3ca70d8f57423; });
$parcel$export(module.exports, "Swap", function () { return $ce3f18abd8ce03db$export$bdb5f0a1b77546f4; });
$parcel$export(module.exports, "MultiDrag", function () { return $ce3f18abd8ce03db$export$18e5d2a5d1df842d; });
$parcel$export(module.exports, "default", function () { return $ce3f18abd8ce03db$export$2e2bcd8739ae039; });
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $ce3f18abd8ce03db$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce3f18abd8ce03db$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ce3f18abd8ce03db$var$ownKeys(Object(source), true).forEach(function(key) {
            $ce3f18abd8ce03db$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ce3f18abd8ce03db$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce3f18abd8ce03db$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ce3f18abd8ce03db$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $ce3f18abd8ce03db$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ce3f18abd8ce03db$var$_typeof(obj);
}
function $ce3f18abd8ce03db$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce3f18abd8ce03db$var$_extends() {
    $ce3f18abd8ce03db$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ce3f18abd8ce03db$var$_extends.apply(this, arguments);
}
function $ce3f18abd8ce03db$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce3f18abd8ce03db$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ce3f18abd8ce03db$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ce3f18abd8ce03db$var$_toConsumableArray(arr) {
    return $ce3f18abd8ce03db$var$_arrayWithoutHoles(arr) || $ce3f18abd8ce03db$var$_iterableToArray(arr) || $ce3f18abd8ce03db$var$_unsupportedIterableToArray(arr) || $ce3f18abd8ce03db$var$_nonIterableSpread();
}
function $ce3f18abd8ce03db$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ce3f18abd8ce03db$var$_arrayLikeToArray(arr);
}
function $ce3f18abd8ce03db$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ce3f18abd8ce03db$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce3f18abd8ce03db$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce3f18abd8ce03db$var$_arrayLikeToArray(o, minLen);
}
function $ce3f18abd8ce03db$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ce3f18abd8ce03db$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $ce3f18abd8ce03db$var$version = "1.15.0";
function $ce3f18abd8ce03db$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $ce3f18abd8ce03db$var$IE11OrLess = $ce3f18abd8ce03db$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $ce3f18abd8ce03db$var$Edge = $ce3f18abd8ce03db$var$userAgent(/Edge/i);
var $ce3f18abd8ce03db$var$FireFox = $ce3f18abd8ce03db$var$userAgent(/firefox/i);
var $ce3f18abd8ce03db$var$Safari = $ce3f18abd8ce03db$var$userAgent(/safari/i) && !$ce3f18abd8ce03db$var$userAgent(/chrome/i) && !$ce3f18abd8ce03db$var$userAgent(/android/i);
var $ce3f18abd8ce03db$var$IOS = $ce3f18abd8ce03db$var$userAgent(/iP(ad|od|hone)/i);
var $ce3f18abd8ce03db$var$ChromeForAndroid = $ce3f18abd8ce03db$var$userAgent(/chrome/i) && $ce3f18abd8ce03db$var$userAgent(/android/i);
var $ce3f18abd8ce03db$var$captureMode = {
    capture: false,
    passive: false
};
function $ce3f18abd8ce03db$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$ce3f18abd8ce03db$var$IE11OrLess && $ce3f18abd8ce03db$var$captureMode);
}
function $ce3f18abd8ce03db$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$ce3f18abd8ce03db$var$IE11OrLess && $ce3f18abd8ce03db$var$captureMode);
}
function $ce3f18abd8ce03db$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $ce3f18abd8ce03db$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $ce3f18abd8ce03db$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $ce3f18abd8ce03db$var$matches(el, selector) : $ce3f18abd8ce03db$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $ce3f18abd8ce03db$var$getParentOrHost(el));
    }
    return null;
}
var $ce3f18abd8ce03db$var$R_SPACE = /\s+/g;
function $ce3f18abd8ce03db$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($ce3f18abd8ce03db$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($ce3f18abd8ce03db$var$R_SPACE, " ");
        }
    }
}
function $ce3f18abd8ce03db$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $ce3f18abd8ce03db$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $ce3f18abd8ce03db$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $ce3f18abd8ce03db$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $ce3f18abd8ce03db$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $ce3f18abd8ce03db$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $ce3f18abd8ce03db$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$ce3f18abd8ce03db$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($ce3f18abd8ce03db$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $ce3f18abd8ce03db$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($ce3f18abd8ce03db$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($ce3f18abd8ce03db$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $ce3f18abd8ce03db$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $ce3f18abd8ce03db$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $ce3f18abd8ce03db$var$getParentAutoScrollElement(el, true), elSideVal = $ce3f18abd8ce03db$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $ce3f18abd8ce03db$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $ce3f18abd8ce03db$var$getWindowScrollingElement()) break;
        parent = $ce3f18abd8ce03db$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $ce3f18abd8ce03db$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $ce3f18abd8ce03db$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $ce3f18abd8ce03db$export$31b3ca70d8f57423.dragged) && $ce3f18abd8ce03db$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $ce3f18abd8ce03db$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $ce3f18abd8ce03db$export$31b3ca70d8f57423.ghost || $ce3f18abd8ce03db$var$css(last, "display") === "none" || selector && !$ce3f18abd8ce03db$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $ce3f18abd8ce03db$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $ce3f18abd8ce03db$export$31b3ca70d8f57423.clone && (!selector || $ce3f18abd8ce03db$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $ce3f18abd8ce03db$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $ce3f18abd8ce03db$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $ce3f18abd8ce03db$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $ce3f18abd8ce03db$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $ce3f18abd8ce03db$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $ce3f18abd8ce03db$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $ce3f18abd8ce03db$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $ce3f18abd8ce03db$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $ce3f18abd8ce03db$var$getWindowScrollingElement();
}
function $ce3f18abd8ce03db$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $ce3f18abd8ce03db$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $ce3f18abd8ce03db$var$_throttleTimeout;
function $ce3f18abd8ce03db$var$throttle(callback, ms) {
    return function() {
        if (!$ce3f18abd8ce03db$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $ce3f18abd8ce03db$var$_throttleTimeout = setTimeout(function() {
                $ce3f18abd8ce03db$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $ce3f18abd8ce03db$var$cancelThrottle() {
    clearTimeout($ce3f18abd8ce03db$var$_throttleTimeout);
    $ce3f18abd8ce03db$var$_throttleTimeout = void 0;
}
function $ce3f18abd8ce03db$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $ce3f18abd8ce03db$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $ce3f18abd8ce03db$var$setRect(el, rect) {
    $ce3f18abd8ce03db$var$css(el, "position", "absolute");
    $ce3f18abd8ce03db$var$css(el, "top", rect.top);
    $ce3f18abd8ce03db$var$css(el, "left", rect.left);
    $ce3f18abd8ce03db$var$css(el, "width", rect.width);
    $ce3f18abd8ce03db$var$css(el, "height", rect.height);
}
function $ce3f18abd8ce03db$var$unsetRect(el) {
    $ce3f18abd8ce03db$var$css(el, "position", "");
    $ce3f18abd8ce03db$var$css(el, "top", "");
    $ce3f18abd8ce03db$var$css(el, "left", "");
    $ce3f18abd8ce03db$var$css(el, "width", "");
    $ce3f18abd8ce03db$var$css(el, "height", "");
}
var $ce3f18abd8ce03db$var$expando = "Sortable" + new Date().getTime();
function $ce3f18abd8ce03db$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($ce3f18abd8ce03db$var$css(child, "display") === "none" || child === $ce3f18abd8ce03db$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $ce3f18abd8ce03db$var$getRect(child)
                });
                var fromRect = $ce3f18abd8ce03db$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $ce3f18abd8ce03db$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($ce3f18abd8ce03db$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $ce3f18abd8ce03db$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $ce3f18abd8ce03db$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($ce3f18abd8ce03db$var$isRectEqual(prevFromRect, toRect) && !$ce3f18abd8ce03db$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $ce3f18abd8ce03db$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                } // if fromRect != toRect: animate
                if (!$ce3f18abd8ce03db$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $ce3f18abd8ce03db$var$css(target, "transition", "");
                $ce3f18abd8ce03db$var$css(target, "transform", "");
                var elMatrix = $ce3f18abd8ce03db$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $ce3f18abd8ce03db$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $ce3f18abd8ce03db$var$repaint(target); // repaint
                $ce3f18abd8ce03db$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $ce3f18abd8ce03db$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $ce3f18abd8ce03db$var$css(target, "transition", "");
                    $ce3f18abd8ce03db$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $ce3f18abd8ce03db$var$repaint(target) {
    return target.offsetWidth;
}
function $ce3f18abd8ce03db$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $ce3f18abd8ce03db$var$plugins = [];
var $ce3f18abd8ce03db$var$defaults = {
    initializeByDefault: true
};
var $ce3f18abd8ce03db$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $ce3f18abd8ce03db$var$defaults)if ($ce3f18abd8ce03db$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $ce3f18abd8ce03db$var$defaults[option];
        $ce3f18abd8ce03db$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $ce3f18abd8ce03db$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $ce3f18abd8ce03db$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($ce3f18abd8ce03db$var$_objectSpread2({
                sortable: sortable
            }, evt));
             // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($ce3f18abd8ce03db$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $ce3f18abd8ce03db$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized; // Add default options from plugin
            $ce3f18abd8ce03db$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $ce3f18abd8ce03db$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $ce3f18abd8ce03db$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $ce3f18abd8ce03db$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $ce3f18abd8ce03db$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$ce3f18abd8ce03db$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
    if (window.CustomEvent && !$ce3f18abd8ce03db$var$IE11OrLess && !$ce3f18abd8ce03db$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $ce3f18abd8ce03db$var$_objectSpread2($ce3f18abd8ce03db$var$_objectSpread2({}, extraEventProperties), $ce3f18abd8ce03db$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $ce3f18abd8ce03db$var$_excluded = [
    "evt"
];
var $ce3f18abd8ce03db$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $ce3f18abd8ce03db$var$_objectWithoutProperties(_ref, $ce3f18abd8ce03db$var$_excluded);
    $ce3f18abd8ce03db$var$PluginManager.pluginEvent.bind($ce3f18abd8ce03db$export$31b3ca70d8f57423)(eventName, sortable, $ce3f18abd8ce03db$var$_objectSpread2({
        dragEl: $ce3f18abd8ce03db$var$dragEl,
        parentEl: $ce3f18abd8ce03db$var$parentEl,
        ghostEl: $ce3f18abd8ce03db$var$ghostEl,
        rootEl: $ce3f18abd8ce03db$var$rootEl,
        nextEl: $ce3f18abd8ce03db$var$nextEl,
        lastDownEl: $ce3f18abd8ce03db$var$lastDownEl,
        cloneEl: $ce3f18abd8ce03db$var$cloneEl,
        cloneHidden: $ce3f18abd8ce03db$var$cloneHidden,
        dragStarted: $ce3f18abd8ce03db$var$moved,
        putSortable: $ce3f18abd8ce03db$var$putSortable,
        activeSortable: $ce3f18abd8ce03db$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $ce3f18abd8ce03db$var$oldIndex,
        oldDraggableIndex: $ce3f18abd8ce03db$var$oldDraggableIndex,
        newIndex: $ce3f18abd8ce03db$var$newIndex,
        newDraggableIndex: $ce3f18abd8ce03db$var$newDraggableIndex,
        hideGhostForTarget: $ce3f18abd8ce03db$var$_hideGhostForTarget,
        unhideGhostForTarget: $ce3f18abd8ce03db$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $ce3f18abd8ce03db$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $ce3f18abd8ce03db$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $ce3f18abd8ce03db$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $ce3f18abd8ce03db$var$_dispatchEvent(info) {
    $ce3f18abd8ce03db$var$dispatchEvent($ce3f18abd8ce03db$var$_objectSpread2({
        putSortable: $ce3f18abd8ce03db$var$putSortable,
        cloneEl: $ce3f18abd8ce03db$var$cloneEl,
        targetEl: $ce3f18abd8ce03db$var$dragEl,
        rootEl: $ce3f18abd8ce03db$var$rootEl,
        oldIndex: $ce3f18abd8ce03db$var$oldIndex,
        oldDraggableIndex: $ce3f18abd8ce03db$var$oldDraggableIndex,
        newIndex: $ce3f18abd8ce03db$var$newIndex,
        newDraggableIndex: $ce3f18abd8ce03db$var$newDraggableIndex
    }, info));
}
var $ce3f18abd8ce03db$var$dragEl, $ce3f18abd8ce03db$var$parentEl, $ce3f18abd8ce03db$var$ghostEl, $ce3f18abd8ce03db$var$rootEl, $ce3f18abd8ce03db$var$nextEl, $ce3f18abd8ce03db$var$lastDownEl, $ce3f18abd8ce03db$var$cloneEl, $ce3f18abd8ce03db$var$cloneHidden, $ce3f18abd8ce03db$var$oldIndex, $ce3f18abd8ce03db$var$newIndex, $ce3f18abd8ce03db$var$oldDraggableIndex, $ce3f18abd8ce03db$var$newDraggableIndex, $ce3f18abd8ce03db$var$activeGroup, $ce3f18abd8ce03db$var$putSortable, $ce3f18abd8ce03db$var$awaitingDragStarted = false, $ce3f18abd8ce03db$var$ignoreNextClick = false, $ce3f18abd8ce03db$var$sortables = [], $ce3f18abd8ce03db$var$tapEvt, $ce3f18abd8ce03db$var$touchEvt, $ce3f18abd8ce03db$var$lastDx, $ce3f18abd8ce03db$var$lastDy, $ce3f18abd8ce03db$var$tapDistanceLeft, $ce3f18abd8ce03db$var$tapDistanceTop, $ce3f18abd8ce03db$var$moved, $ce3f18abd8ce03db$var$lastTarget, $ce3f18abd8ce03db$var$lastDirection, $ce3f18abd8ce03db$var$pastFirstInvertThresh = false, $ce3f18abd8ce03db$var$isCircumstantialInvert = false, $ce3f18abd8ce03db$var$targetMoveDistance, // For positioning ghost absolutely
$ce3f18abd8ce03db$var$ghostRelativeParent, $ce3f18abd8ce03db$var$ghostRelativeParentInitialScroll = [], // (left, top)
$ce3f18abd8ce03db$var$_silent = false, $ce3f18abd8ce03db$var$savedInputChecked = [];
/** @const */ var $ce3f18abd8ce03db$var$documentExists = typeof document !== "undefined", $ce3f18abd8ce03db$var$PositionGhostAbsolutely = $ce3f18abd8ce03db$var$IOS, $ce3f18abd8ce03db$var$CSSFloatProperty = $ce3f18abd8ce03db$var$Edge || $ce3f18abd8ce03db$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$ce3f18abd8ce03db$var$supportDraggable = $ce3f18abd8ce03db$var$documentExists && !$ce3f18abd8ce03db$var$ChromeForAndroid && !$ce3f18abd8ce03db$var$IOS && "draggable" in document.createElement("div"), $ce3f18abd8ce03db$var$supportCssPointerEvents = function() {
    if (!$ce3f18abd8ce03db$var$documentExists) return; // false when <= IE11
    if ($ce3f18abd8ce03db$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $ce3f18abd8ce03db$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $ce3f18abd8ce03db$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $ce3f18abd8ce03db$var$getChild(el, 0, options), child2 = $ce3f18abd8ce03db$var$getChild(el, 1, options), firstChildCSS = child1 && $ce3f18abd8ce03db$var$css(child1), secondChildCSS = child2 && $ce3f18abd8ce03db$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $ce3f18abd8ce03db$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $ce3f18abd8ce03db$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$ce3f18abd8ce03db$var$CSSFloatProperty] === "none" || child2 && elCSS[$ce3f18abd8ce03db$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $ce3f18abd8ce03db$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */ $ce3f18abd8ce03db$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $ce3f18abd8ce03db$var$sortables.some(function(sortable) {
        var threshold = sortable[$ce3f18abd8ce03db$var$expando].options.emptyInsertThreshold;
        if (!threshold || $ce3f18abd8ce03db$var$lastChild(sortable)) return;
        var rect = $ce3f18abd8ce03db$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $ce3f18abd8ce03db$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $ce3f18abd8ce03db$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $ce3f18abd8ce03db$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$ce3f18abd8ce03db$var$supportCssPointerEvents && $ce3f18abd8ce03db$var$ghostEl) $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "display", "none");
}, $ce3f18abd8ce03db$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$ce3f18abd8ce03db$var$supportCssPointerEvents && $ce3f18abd8ce03db$var$ghostEl) $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "display", "");
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($ce3f18abd8ce03db$var$documentExists && !$ce3f18abd8ce03db$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($ce3f18abd8ce03db$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $ce3f18abd8ce03db$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($ce3f18abd8ce03db$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $ce3f18abd8ce03db$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$ce3f18abd8ce03db$var$expando]._onDragOver(event);
        }
    }
};
var $ce3f18abd8ce03db$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($ce3f18abd8ce03db$var$dragEl) $ce3f18abd8ce03db$var$dragEl.parentNode[$ce3f18abd8ce03db$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $ce3f18abd8ce03db$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $ce3f18abd8ce03db$var$_extends({}, options); // Export instance
    el[$ce3f18abd8ce03db$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $ce3f18abd8ce03db$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $ce3f18abd8ce03db$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$ce3f18abd8ce03db$var$Safari,
        emptyInsertThreshold: 5
    };
    $ce3f18abd8ce03db$var$PluginManager.initializePlugins(this, el, defaults); // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $ce3f18abd8ce03db$var$_prepareGroup(options); // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
     // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $ce3f18abd8ce03db$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
     // Bind events
    if (options.supportPointer) $ce3f18abd8ce03db$var$on(el, "pointerdown", this._onTapStart);
    else {
        $ce3f18abd8ce03db$var$on(el, "mousedown", this._onTapStart);
        $ce3f18abd8ce03db$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $ce3f18abd8ce03db$var$on(el, "dragover", this);
        $ce3f18abd8ce03db$var$on(el, "dragenter", this);
    }
    $ce3f18abd8ce03db$var$sortables.push(this.el); // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
    $ce3f18abd8ce03db$var$_extends(this, $ce3f18abd8ce03db$var$AnimationStateManager());
}
$ce3f18abd8ce03db$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $ce3f18abd8ce03db$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $ce3f18abd8ce03db$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $ce3f18abd8ce03db$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $ce3f18abd8ce03db$var$_saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($ce3f18abd8ce03db$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
         // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
         // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $ce3f18abd8ce03db$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $ce3f18abd8ce03db$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($ce3f18abd8ce03db$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
         // Get the index of the dragged element within its parent
        $ce3f18abd8ce03db$var$oldIndex = $ce3f18abd8ce03db$var$index(target);
        $ce3f18abd8ce03db$var$oldDraggableIndex = $ce3f18abd8ce03db$var$index(target, options.draggable); // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $ce3f18abd8ce03db$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $ce3f18abd8ce03db$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $ce3f18abd8ce03db$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $ce3f18abd8ce03db$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $ce3f18abd8ce03db$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$ce3f18abd8ce03db$var$closest(originalTarget, options.handle, el, false)) return;
         // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$ce3f18abd8ce03db$var$dragEl && target.parentNode === el) {
            var dragRect = $ce3f18abd8ce03db$var$getRect(target);
            $ce3f18abd8ce03db$var$rootEl = el;
            $ce3f18abd8ce03db$var$dragEl = target;
            $ce3f18abd8ce03db$var$parentEl = $ce3f18abd8ce03db$var$dragEl.parentNode;
            $ce3f18abd8ce03db$var$nextEl = $ce3f18abd8ce03db$var$dragEl.nextSibling;
            $ce3f18abd8ce03db$var$lastDownEl = target;
            $ce3f18abd8ce03db$var$activeGroup = options.group;
            $ce3f18abd8ce03db$export$31b3ca70d8f57423.dragged = $ce3f18abd8ce03db$var$dragEl;
            $ce3f18abd8ce03db$var$tapEvt = {
                target: $ce3f18abd8ce03db$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $ce3f18abd8ce03db$var$tapDistanceLeft = $ce3f18abd8ce03db$var$tapEvt.clientX - dragRect.left;
            $ce3f18abd8ce03db$var$tapDistanceTop = $ce3f18abd8ce03db$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $ce3f18abd8ce03db$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $ce3f18abd8ce03db$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                } // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$ce3f18abd8ce03db$var$FireFox && _this.nativeDraggable) $ce3f18abd8ce03db$var$dragEl.draggable = true;
                 // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch); // Drag start event
                $ce3f18abd8ce03db$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                }); // Chosen item
                $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, options.chosenClass, true);
            }; // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $ce3f18abd8ce03db$var$find($ce3f18abd8ce03db$var$dragEl, criteria.trim(), $ce3f18abd8ce03db$var$_disableDraggable);
            });
            $ce3f18abd8ce03db$var$on(ownerDocument, "dragover", $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent);
            $ce3f18abd8ce03db$var$on(ownerDocument, "mousemove", $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent);
            $ce3f18abd8ce03db$var$on(ownerDocument, "touchmove", $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent);
            $ce3f18abd8ce03db$var$on(ownerDocument, "mouseup", _this._onDrop);
            $ce3f18abd8ce03db$var$on(ownerDocument, "touchend", _this._onDrop);
            $ce3f18abd8ce03db$var$on(ownerDocument, "touchcancel", _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
            if ($ce3f18abd8ce03db$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $ce3f18abd8ce03db$var$dragEl.draggable = true;
            }
            $ce3f18abd8ce03db$var$pluginEvent("delayStart", this, {
                evt: evt
            }); // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($ce3f18abd8ce03db$var$Edge || $ce3f18abd8ce03db$var$IE11OrLess))) {
                if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                } // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $ce3f18abd8ce03db$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $ce3f18abd8ce03db$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $ce3f18abd8ce03db$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $ce3f18abd8ce03db$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $ce3f18abd8ce03db$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $ce3f18abd8ce03db$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $ce3f18abd8ce03db$var$dragEl && $ce3f18abd8ce03db$var$_disableDraggable($ce3f18abd8ce03db$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $ce3f18abd8ce03db$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $ce3f18abd8ce03db$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $ce3f18abd8ce03db$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $ce3f18abd8ce03db$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $ce3f18abd8ce03db$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $ce3f18abd8ce03db$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $ce3f18abd8ce03db$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $ce3f18abd8ce03db$var$on(document, "touchmove", this._onTouchMove);
            else $ce3f18abd8ce03db$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $ce3f18abd8ce03db$var$on($ce3f18abd8ce03db$var$dragEl, "dragend", this);
            $ce3f18abd8ce03db$var$on($ce3f18abd8ce03db$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $ce3f18abd8ce03db$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $ce3f18abd8ce03db$var$awaitingDragStarted = false;
        if ($ce3f18abd8ce03db$var$rootEl && $ce3f18abd8ce03db$var$dragEl) {
            $ce3f18abd8ce03db$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $ce3f18abd8ce03db$var$on(document, "dragover", $ce3f18abd8ce03db$var$_checkOutsideTargetEl);
            var options = this.options; // Apply effect
            !fallback && $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, options.dragClass, false);
            $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, options.ghostClass, true);
            $ce3f18abd8ce03db$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost(); // Drag start event
            $ce3f18abd8ce03db$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($ce3f18abd8ce03db$var$touchEvt) {
            this._lastX = $ce3f18abd8ce03db$var$touchEvt.clientX;
            this._lastY = $ce3f18abd8ce03db$var$touchEvt.clientY;
            $ce3f18abd8ce03db$var$_hideGhostForTarget();
            var target = document.elementFromPoint($ce3f18abd8ce03db$var$touchEvt.clientX, $ce3f18abd8ce03db$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($ce3f18abd8ce03db$var$touchEvt.clientX, $ce3f18abd8ce03db$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $ce3f18abd8ce03db$var$dragEl.parentNode[$ce3f18abd8ce03db$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$ce3f18abd8ce03db$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$ce3f18abd8ce03db$var$expando]._onDragOver({
                        clientX: $ce3f18abd8ce03db$var$touchEvt.clientX,
                        clientY: $ce3f18abd8ce03db$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $ce3f18abd8ce03db$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($ce3f18abd8ce03db$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $ce3f18abd8ce03db$var$ghostEl && $ce3f18abd8ce03db$var$matrix($ce3f18abd8ce03db$var$ghostEl, true), scaleX = $ce3f18abd8ce03db$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $ce3f18abd8ce03db$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $ce3f18abd8ce03db$var$PositionGhostAbsolutely && $ce3f18abd8ce03db$var$ghostRelativeParent && $ce3f18abd8ce03db$var$getRelativeScrollOffset($ce3f18abd8ce03db$var$ghostRelativeParent), dx = (touch.clientX - $ce3f18abd8ce03db$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $ce3f18abd8ce03db$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $ce3f18abd8ce03db$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $ce3f18abd8ce03db$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
            if (!$ce3f18abd8ce03db$export$31b3ca70d8f57423.active && !$ce3f18abd8ce03db$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($ce3f18abd8ce03db$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($ce3f18abd8ce03db$var$lastDx || 0);
                    ghostMatrix.f += dy - ($ce3f18abd8ce03db$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "webkitTransform", cssMatrix);
                $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "mozTransform", cssMatrix);
                $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "msTransform", cssMatrix);
                $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "transform", cssMatrix);
                $ce3f18abd8ce03db$var$lastDx = dx;
                $ce3f18abd8ce03db$var$lastDy = dy;
                $ce3f18abd8ce03db$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$ce3f18abd8ce03db$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $ce3f18abd8ce03db$var$rootEl, rect = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$dragEl, true, $ce3f18abd8ce03db$var$PositionGhostAbsolutely, true, container), options = this.options; // Position absolutely
            if ($ce3f18abd8ce03db$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $ce3f18abd8ce03db$var$ghostRelativeParent = container;
                while($ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostRelativeParent, "position") === "static" && $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostRelativeParent, "transform") === "none" && $ce3f18abd8ce03db$var$ghostRelativeParent !== document)$ce3f18abd8ce03db$var$ghostRelativeParent = $ce3f18abd8ce03db$var$ghostRelativeParent.parentNode;
                if ($ce3f18abd8ce03db$var$ghostRelativeParent !== document.body && $ce3f18abd8ce03db$var$ghostRelativeParent !== document.documentElement) {
                    if ($ce3f18abd8ce03db$var$ghostRelativeParent === document) $ce3f18abd8ce03db$var$ghostRelativeParent = $ce3f18abd8ce03db$var$getWindowScrollingElement();
                    rect.top += $ce3f18abd8ce03db$var$ghostRelativeParent.scrollTop;
                    rect.left += $ce3f18abd8ce03db$var$ghostRelativeParent.scrollLeft;
                } else $ce3f18abd8ce03db$var$ghostRelativeParent = $ce3f18abd8ce03db$var$getWindowScrollingElement();
                $ce3f18abd8ce03db$var$ghostRelativeParentInitialScroll = $ce3f18abd8ce03db$var$getRelativeScrollOffset($ce3f18abd8ce03db$var$ghostRelativeParent);
            }
            $ce3f18abd8ce03db$var$ghostEl = $ce3f18abd8ce03db$var$dragEl.cloneNode(true);
            $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$ghostEl, options.ghostClass, false);
            $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$ghostEl, options.fallbackClass, true);
            $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$ghostEl, options.dragClass, true);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "transition", "");
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "transform", "");
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "box-sizing", "border-box");
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "margin", 0);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "top", rect.top);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "left", rect.left);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "width", rect.width);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "height", rect.height);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "opacity", "0.8");
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "position", $ce3f18abd8ce03db$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "zIndex", "100000");
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "pointerEvents", "none");
            $ce3f18abd8ce03db$export$31b3ca70d8f57423.ghost = $ce3f18abd8ce03db$var$ghostEl;
            container.appendChild($ce3f18abd8ce03db$var$ghostEl); // Set transform-origin
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$ghostEl, "transform-origin", $ce3f18abd8ce03db$var$tapDistanceLeft / parseInt($ce3f18abd8ce03db$var$ghostEl.style.width) * 100 + "% " + $ce3f18abd8ce03db$var$tapDistanceTop / parseInt($ce3f18abd8ce03db$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $ce3f18abd8ce03db$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $ce3f18abd8ce03db$var$pluginEvent("setupClone", this);
        if (!$ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) {
            $ce3f18abd8ce03db$var$cloneEl = $ce3f18abd8ce03db$var$clone($ce3f18abd8ce03db$var$dragEl);
            $ce3f18abd8ce03db$var$cloneEl.removeAttribute("id");
            $ce3f18abd8ce03db$var$cloneEl.draggable = false;
            $ce3f18abd8ce03db$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$cloneEl, this.options.chosenClass, false);
            $ce3f18abd8ce03db$export$31b3ca70d8f57423.clone = $ce3f18abd8ce03db$var$cloneEl;
        } // #1143: IFrame support workaround
        _this.cloneId = $ce3f18abd8ce03db$var$_nextTick(function() {
            $ce3f18abd8ce03db$var$pluginEvent("clone", _this);
            if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $ce3f18abd8ce03db$var$rootEl.insertBefore($ce3f18abd8ce03db$var$cloneEl, $ce3f18abd8ce03db$var$dragEl);
            _this._hideClone();
            $ce3f18abd8ce03db$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, options.dragClass, true); // Set proper drop events
        if (fallback) {
            $ce3f18abd8ce03db$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $ce3f18abd8ce03db$var$off(document, "mouseup", _this._onDrop);
            $ce3f18abd8ce03db$var$off(document, "touchend", _this._onDrop);
            $ce3f18abd8ce03db$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $ce3f18abd8ce03db$var$dragEl);
            }
            $ce3f18abd8ce03db$var$on(document, "drop", _this); // #1276 fix:
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$dragEl, "transform", "translateZ(0)");
        }
        $ce3f18abd8ce03db$var$awaitingDragStarted = true;
        _this._dragStartId = $ce3f18abd8ce03db$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $ce3f18abd8ce03db$var$on(document, "selectstart", _this);
        $ce3f18abd8ce03db$var$moved = true;
        if ($ce3f18abd8ce03db$var$Safari) $ce3f18abd8ce03db$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $ce3f18abd8ce03db$export$31b3ca70d8f57423.active, isOwner = $ce3f18abd8ce03db$var$activeGroup === group, canSort = options.sort, fromSortable = $ce3f18abd8ce03db$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($ce3f18abd8ce03db$var$_silent) return;
        function dragOverEvent(name, extra) {
            $ce3f18abd8ce03db$var$pluginEvent(name, _this, $ce3f18abd8ce03db$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $ce3f18abd8ce03db$var$_onMove($ce3f18abd8ce03db$var$rootEl, el, $ce3f18abd8ce03db$var$dragEl, dragRect, target, $ce3f18abd8ce03db$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        } // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        } // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, $ce3f18abd8ce03db$var$putSortable ? $ce3f18abd8ce03db$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, options.ghostClass, true);
                }
                if ($ce3f18abd8ce03db$var$putSortable !== _this && _this !== $ce3f18abd8ce03db$export$31b3ca70d8f57423.active) $ce3f18abd8ce03db$var$putSortable = _this;
                else if (_this === $ce3f18abd8ce03db$export$31b3ca70d8f57423.active && $ce3f18abd8ce03db$var$putSortable) $ce3f18abd8ce03db$var$putSortable = null;
                 // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            } // Null lastTarget if it is not inside a previously swapped element
            if (target === $ce3f18abd8ce03db$var$dragEl && !$ce3f18abd8ce03db$var$dragEl.animated || target === el && !target.animated) $ce3f18abd8ce03db$var$lastTarget = null;
             // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $ce3f18abd8ce03db$var$dragEl.parentNode[$ce3f18abd8ce03db$var$expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
                !insertion && $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        } // Call when dragEl has been inserted
        function changed() {
            $ce3f18abd8ce03db$var$newIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl);
            $ce3f18abd8ce03db$var$newDraggableIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl, options.draggable);
            $ce3f18abd8ce03db$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $ce3f18abd8ce03db$var$newIndex,
                newDraggableIndex: $ce3f18abd8ce03db$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $ce3f18abd8ce03db$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($ce3f18abd8ce03db$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $ce3f18abd8ce03db$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $ce3f18abd8ce03db$var$parentEl !== $ce3f18abd8ce03db$var$rootEl // Reverting item into the original list
        ) : $ce3f18abd8ce03db$var$putSortable === this || (this.lastPutMode = $ce3f18abd8ce03db$var$activeGroup.checkPull(this, activeSortable, $ce3f18abd8ce03db$var$dragEl, evt)) && group.checkPut(this, activeSortable, $ce3f18abd8ce03db$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $ce3f18abd8ce03db$var$parentEl = $ce3f18abd8ce03db$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) {
                    if ($ce3f18abd8ce03db$var$nextEl) $ce3f18abd8ce03db$var$rootEl.insertBefore($ce3f18abd8ce03db$var$dragEl, $ce3f18abd8ce03db$var$nextEl);
                    else $ce3f18abd8ce03db$var$rootEl.appendChild($ce3f18abd8ce03db$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $ce3f18abd8ce03db$var$lastChild(el, options.draggable);
            if (!elLastChild || $ce3f18abd8ce03db$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $ce3f18abd8ce03db$var$dragEl) return completed(false);
                 // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $ce3f18abd8ce03db$var$getRect(target);
                if ($ce3f18abd8ce03db$var$_onMove($ce3f18abd8ce03db$var$rootEl, el, $ce3f18abd8ce03db$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($ce3f18abd8ce03db$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($ce3f18abd8ce03db$var$dragEl);
                    $ce3f18abd8ce03db$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $ce3f18abd8ce03db$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $ce3f18abd8ce03db$var$getChild(el, 0, options, true);
                if (firstChild === $ce3f18abd8ce03db$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $ce3f18abd8ce03db$var$getRect(target);
                if ($ce3f18abd8ce03db$var$_onMove($ce3f18abd8ce03db$var$rootEl, el, $ce3f18abd8ce03db$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($ce3f18abd8ce03db$var$dragEl, firstChild);
                    $ce3f18abd8ce03db$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $ce3f18abd8ce03db$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $ce3f18abd8ce03db$var$dragEl.parentNode !== el, differentRowCol = !$ce3f18abd8ce03db$var$_dragElInRowColumn($ce3f18abd8ce03db$var$dragEl.animated && $ce3f18abd8ce03db$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $ce3f18abd8ce03db$var$isScrolledPast(target, "top", "top") || $ce3f18abd8ce03db$var$isScrolledPast($ce3f18abd8ce03db$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($ce3f18abd8ce03db$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $ce3f18abd8ce03db$var$pastFirstInvertThresh = false;
                    $ce3f18abd8ce03db$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $ce3f18abd8ce03db$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $ce3f18abd8ce03db$var$isCircumstantialInvert, $ce3f18abd8ce03db$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $ce3f18abd8ce03db$var$parentEl.children[dragIndex];
                    }while (sibling && ($ce3f18abd8ce03db$var$css(sibling, "display") === "none" || sibling === $ce3f18abd8ce03db$var$ghostEl));
                } // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $ce3f18abd8ce03db$var$lastTarget = target;
                $ce3f18abd8ce03db$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $ce3f18abd8ce03db$var$_onMove($ce3f18abd8ce03db$var$rootEl, el, $ce3f18abd8ce03db$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $ce3f18abd8ce03db$var$_silent = true;
                    setTimeout($ce3f18abd8ce03db$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($ce3f18abd8ce03db$var$dragEl);
                    else target.parentNode.insertBefore($ce3f18abd8ce03db$var$dragEl, after ? nextSibling : target);
                     // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $ce3f18abd8ce03db$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $ce3f18abd8ce03db$var$parentEl = $ce3f18abd8ce03db$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$ce3f18abd8ce03db$var$isCircumstantialInvert) $ce3f18abd8ce03db$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $ce3f18abd8ce03db$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($ce3f18abd8ce03db$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $ce3f18abd8ce03db$var$off(document, "mousemove", this._onTouchMove);
        $ce3f18abd8ce03db$var$off(document, "touchmove", this._onTouchMove);
        $ce3f18abd8ce03db$var$off(document, "pointermove", this._onTouchMove);
        $ce3f18abd8ce03db$var$off(document, "dragover", $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent);
        $ce3f18abd8ce03db$var$off(document, "mousemove", $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent);
        $ce3f18abd8ce03db$var$off(document, "touchmove", $ce3f18abd8ce03db$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $ce3f18abd8ce03db$var$off(ownerDocument, "mouseup", this._onDrop);
        $ce3f18abd8ce03db$var$off(ownerDocument, "touchend", this._onDrop);
        $ce3f18abd8ce03db$var$off(ownerDocument, "pointerup", this._onDrop);
        $ce3f18abd8ce03db$var$off(ownerDocument, "touchcancel", this._onDrop);
        $ce3f18abd8ce03db$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options; // Get the index of the dragged element within its parent
        $ce3f18abd8ce03db$var$newIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl);
        $ce3f18abd8ce03db$var$newDraggableIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl, options.draggable);
        $ce3f18abd8ce03db$var$pluginEvent("drop", this, {
            evt: evt
        });
        $ce3f18abd8ce03db$var$parentEl = $ce3f18abd8ce03db$var$dragEl && $ce3f18abd8ce03db$var$dragEl.parentNode; // Get again after plugin event
        $ce3f18abd8ce03db$var$newIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl);
        $ce3f18abd8ce03db$var$newDraggableIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl, options.draggable);
        if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $ce3f18abd8ce03db$var$awaitingDragStarted = false;
        $ce3f18abd8ce03db$var$isCircumstantialInvert = false;
        $ce3f18abd8ce03db$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $ce3f18abd8ce03db$var$_cancelNextTick(this.cloneId);
        $ce3f18abd8ce03db$var$_cancelNextTick(this._dragStartId); // Unbind events
        if (this.nativeDraggable) {
            $ce3f18abd8ce03db$var$off(document, "drop", this);
            $ce3f18abd8ce03db$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($ce3f18abd8ce03db$var$Safari) $ce3f18abd8ce03db$var$css(document.body, "user-select", "");
        $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$dragEl, "transform", "");
        if (evt) {
            if ($ce3f18abd8ce03db$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $ce3f18abd8ce03db$var$ghostEl && $ce3f18abd8ce03db$var$ghostEl.parentNode && $ce3f18abd8ce03db$var$ghostEl.parentNode.removeChild($ce3f18abd8ce03db$var$ghostEl);
            if ($ce3f18abd8ce03db$var$rootEl === $ce3f18abd8ce03db$var$parentEl || $ce3f18abd8ce03db$var$putSortable && $ce3f18abd8ce03db$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $ce3f18abd8ce03db$var$cloneEl && $ce3f18abd8ce03db$var$cloneEl.parentNode && $ce3f18abd8ce03db$var$cloneEl.parentNode.removeChild($ce3f18abd8ce03db$var$cloneEl);
            if ($ce3f18abd8ce03db$var$dragEl) {
                if (this.nativeDraggable) $ce3f18abd8ce03db$var$off($ce3f18abd8ce03db$var$dragEl, "dragend", this);
                $ce3f18abd8ce03db$var$_disableDraggable($ce3f18abd8ce03db$var$dragEl);
                $ce3f18abd8ce03db$var$dragEl.style["will-change"] = ""; // Remove classes
                // ghostClass is added in dragStarted
                if ($ce3f18abd8ce03db$var$moved && !$ce3f18abd8ce03db$var$awaitingDragStarted) $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, $ce3f18abd8ce03db$var$putSortable ? $ce3f18abd8ce03db$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl, this.options.chosenClass, false); // Drag stop event
                $ce3f18abd8ce03db$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $ce3f18abd8ce03db$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($ce3f18abd8ce03db$var$rootEl !== $ce3f18abd8ce03db$var$parentEl) {
                    if ($ce3f18abd8ce03db$var$newIndex >= 0) {
                        // Add event
                        $ce3f18abd8ce03db$var$_dispatchEvent({
                            rootEl: $ce3f18abd8ce03db$var$parentEl,
                            name: "add",
                            toEl: $ce3f18abd8ce03db$var$parentEl,
                            fromEl: $ce3f18abd8ce03db$var$rootEl,
                            originalEvent: evt
                        }); // Remove event
                        $ce3f18abd8ce03db$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $ce3f18abd8ce03db$var$parentEl,
                            originalEvent: evt
                        }); // drag from one list and drop into another
                        $ce3f18abd8ce03db$var$_dispatchEvent({
                            rootEl: $ce3f18abd8ce03db$var$parentEl,
                            name: "sort",
                            toEl: $ce3f18abd8ce03db$var$parentEl,
                            fromEl: $ce3f18abd8ce03db$var$rootEl,
                            originalEvent: evt
                        });
                        $ce3f18abd8ce03db$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $ce3f18abd8ce03db$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $ce3f18abd8ce03db$var$putSortable && $ce3f18abd8ce03db$var$putSortable.save();
                } else {
                    if ($ce3f18abd8ce03db$var$newIndex !== $ce3f18abd8ce03db$var$oldIndex) {
                        if ($ce3f18abd8ce03db$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $ce3f18abd8ce03db$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $ce3f18abd8ce03db$var$parentEl,
                                originalEvent: evt
                            });
                            $ce3f18abd8ce03db$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $ce3f18abd8ce03db$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($ce3f18abd8ce03db$var$newIndex == null || $ce3f18abd8ce03db$var$newIndex === -1) {
                        $ce3f18abd8ce03db$var$newIndex = $ce3f18abd8ce03db$var$oldIndex;
                        $ce3f18abd8ce03db$var$newDraggableIndex = $ce3f18abd8ce03db$var$oldDraggableIndex;
                    }
                    $ce3f18abd8ce03db$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $ce3f18abd8ce03db$var$parentEl,
                        originalEvent: evt
                    }); // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $ce3f18abd8ce03db$var$pluginEvent("nulling", this);
        $ce3f18abd8ce03db$var$rootEl = $ce3f18abd8ce03db$var$dragEl = $ce3f18abd8ce03db$var$parentEl = $ce3f18abd8ce03db$var$ghostEl = $ce3f18abd8ce03db$var$nextEl = $ce3f18abd8ce03db$var$cloneEl = $ce3f18abd8ce03db$var$lastDownEl = $ce3f18abd8ce03db$var$cloneHidden = $ce3f18abd8ce03db$var$tapEvt = $ce3f18abd8ce03db$var$touchEvt = $ce3f18abd8ce03db$var$moved = $ce3f18abd8ce03db$var$newIndex = $ce3f18abd8ce03db$var$newDraggableIndex = $ce3f18abd8ce03db$var$oldIndex = $ce3f18abd8ce03db$var$oldDraggableIndex = $ce3f18abd8ce03db$var$lastTarget = $ce3f18abd8ce03db$var$lastDirection = $ce3f18abd8ce03db$var$putSortable = $ce3f18abd8ce03db$var$activeGroup = $ce3f18abd8ce03db$export$31b3ca70d8f57423.dragged = $ce3f18abd8ce03db$export$31b3ca70d8f57423.ghost = $ce3f18abd8ce03db$export$31b3ca70d8f57423.clone = $ce3f18abd8ce03db$export$31b3ca70d8f57423.active = null;
        $ce3f18abd8ce03db$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $ce3f18abd8ce03db$var$savedInputChecked.length = $ce3f18abd8ce03db$var$lastDx = $ce3f18abd8ce03db$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($ce3f18abd8ce03db$var$dragEl) {
                    this._onDragOver(evt);
                    $ce3f18abd8ce03db$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($ce3f18abd8ce03db$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $ce3f18abd8ce03db$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($ce3f18abd8ce03db$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $ce3f18abd8ce03db$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $ce3f18abd8ce03db$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $ce3f18abd8ce03db$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $ce3f18abd8ce03db$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$ce3f18abd8ce03db$var$expando] = null;
        $ce3f18abd8ce03db$var$off(el, "mousedown", this._onTapStart);
        $ce3f18abd8ce03db$var$off(el, "touchstart", this._onTapStart);
        $ce3f18abd8ce03db$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $ce3f18abd8ce03db$var$off(el, "dragover", this);
            $ce3f18abd8ce03db$var$off(el, "dragenter", this);
        } // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $ce3f18abd8ce03db$var$sortables.splice($ce3f18abd8ce03db$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$ce3f18abd8ce03db$var$cloneHidden) {
            $ce3f18abd8ce03db$var$pluginEvent("hideClone", this);
            if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) return;
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $ce3f18abd8ce03db$var$cloneEl.parentNode) $ce3f18abd8ce03db$var$cloneEl.parentNode.removeChild($ce3f18abd8ce03db$var$cloneEl);
            $ce3f18abd8ce03db$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($ce3f18abd8ce03db$var$cloneHidden) {
            $ce3f18abd8ce03db$var$pluginEvent("showClone", this);
            if ($ce3f18abd8ce03db$export$31b3ca70d8f57423.eventCanceled) return; // show clone at dragEl or original position
            if ($ce3f18abd8ce03db$var$dragEl.parentNode == $ce3f18abd8ce03db$var$rootEl && !this.options.group.revertClone) $ce3f18abd8ce03db$var$rootEl.insertBefore($ce3f18abd8ce03db$var$cloneEl, $ce3f18abd8ce03db$var$dragEl);
            else if ($ce3f18abd8ce03db$var$nextEl) $ce3f18abd8ce03db$var$rootEl.insertBefore($ce3f18abd8ce03db$var$cloneEl, $ce3f18abd8ce03db$var$nextEl);
            else $ce3f18abd8ce03db$var$rootEl.appendChild($ce3f18abd8ce03db$var$cloneEl);
            if (this.options.group.revertClone) this.animate($ce3f18abd8ce03db$var$dragEl, $ce3f18abd8ce03db$var$cloneEl);
            $ce3f18abd8ce03db$var$css($ce3f18abd8ce03db$var$cloneEl, "display", "");
            $ce3f18abd8ce03db$var$cloneHidden = false;
        }
    }
};
function $ce3f18abd8ce03db$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $ce3f18abd8ce03db$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$ce3f18abd8ce03db$var$expando], onMoveFn = sortable.options.onMove, retVal; // Support for new CustomEvent feature
    if (window.CustomEvent && !$ce3f18abd8ce03db$var$IE11OrLess && !$ce3f18abd8ce03db$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $ce3f18abd8ce03db$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $ce3f18abd8ce03db$var$_disableDraggable(el) {
    el.draggable = false;
}
function $ce3f18abd8ce03db$var$_unsilent() {
    $ce3f18abd8ce03db$var$_silent = false;
}
function $ce3f18abd8ce03db$var$_ghostIsFirst(evt, vertical, sortable) {
    var rect = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function $ce3f18abd8ce03db$var$_ghostIsLast(evt, vertical, sortable) {
    var rect = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function $ce3f18abd8ce03db$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $ce3f18abd8ce03db$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$ce3f18abd8ce03db$var$pastFirstInvertThresh && ($ce3f18abd8ce03db$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $ce3f18abd8ce03db$var$pastFirstInvertThresh = true;
            if (!$ce3f18abd8ce03db$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($ce3f18abd8ce03db$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $ce3f18abd8ce03db$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $ce3f18abd8ce03db$var$targetMoveDistance) return -$ce3f18abd8ce03db$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $ce3f18abd8ce03db$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $ce3f18abd8ce03db$var$_getInsertDirection(target) {
    if ($ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl) < $ce3f18abd8ce03db$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $ce3f18abd8ce03db$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $ce3f18abd8ce03db$var$_saveInputCheckedState(root) {
    $ce3f18abd8ce03db$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $ce3f18abd8ce03db$var$savedInputChecked.push(el);
    }
}
function $ce3f18abd8ce03db$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $ce3f18abd8ce03db$var$_cancelNextTick(id) {
    return clearTimeout(id);
} // Fixed #973:
if ($ce3f18abd8ce03db$var$documentExists) $ce3f18abd8ce03db$var$on(document, "touchmove", function(evt) {
    if (($ce3f18abd8ce03db$export$31b3ca70d8f57423.active || $ce3f18abd8ce03db$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
 // Export utils
$ce3f18abd8ce03db$export$31b3ca70d8f57423.utils = {
    on: $ce3f18abd8ce03db$var$on,
    off: $ce3f18abd8ce03db$var$off,
    css: $ce3f18abd8ce03db$var$css,
    find: $ce3f18abd8ce03db$var$find,
    is: function is(el, selector) {
        return !!$ce3f18abd8ce03db$var$closest(el, selector, el, false);
    },
    extend: $ce3f18abd8ce03db$var$extend,
    throttle: $ce3f18abd8ce03db$var$throttle,
    closest: $ce3f18abd8ce03db$var$closest,
    toggleClass: $ce3f18abd8ce03db$var$toggleClass,
    clone: $ce3f18abd8ce03db$var$clone,
    index: $ce3f18abd8ce03db$var$index,
    nextTick: $ce3f18abd8ce03db$var$_nextTick,
    cancelNextTick: $ce3f18abd8ce03db$var$_cancelNextTick,
    detectDirection: $ce3f18abd8ce03db$var$_detectDirection,
    getChild: $ce3f18abd8ce03db$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $ce3f18abd8ce03db$export$31b3ca70d8f57423.get = function(element) {
    return element[$ce3f18abd8ce03db$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $ce3f18abd8ce03db$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $ce3f18abd8ce03db$export$31b3ca70d8f57423.utils = $ce3f18abd8ce03db$var$_objectSpread2($ce3f18abd8ce03db$var$_objectSpread2({}, $ce3f18abd8ce03db$export$31b3ca70d8f57423.utils), plugin.utils);
        $ce3f18abd8ce03db$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $ce3f18abd8ce03db$export$31b3ca70d8f57423.create = function(el, options) {
    return new $ce3f18abd8ce03db$export$31b3ca70d8f57423(el, options);
}; // Export
$ce3f18abd8ce03db$export$31b3ca70d8f57423.version = $ce3f18abd8ce03db$var$version;
var $ce3f18abd8ce03db$var$autoScrolls = [], $ce3f18abd8ce03db$var$scrollEl, $ce3f18abd8ce03db$var$scrollRootEl, $ce3f18abd8ce03db$var$scrolling = false, $ce3f18abd8ce03db$var$lastAutoScrollX, $ce3f18abd8ce03db$var$lastAutoScrollY, $ce3f18abd8ce03db$var$touchEvt$1, $ce3f18abd8ce03db$var$pointerElemChangedInterval;
function $ce3f18abd8ce03db$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        }; // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $ce3f18abd8ce03db$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $ce3f18abd8ce03db$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $ce3f18abd8ce03db$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $ce3f18abd8ce03db$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $ce3f18abd8ce03db$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $ce3f18abd8ce03db$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $ce3f18abd8ce03db$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $ce3f18abd8ce03db$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $ce3f18abd8ce03db$var$clearPointerElemChangedInterval();
            $ce3f18abd8ce03db$var$clearAutoScrolls();
            $ce3f18abd8ce03db$var$cancelThrottle();
        },
        nulling: function nulling() {
            $ce3f18abd8ce03db$var$touchEvt$1 = $ce3f18abd8ce03db$var$scrollRootEl = $ce3f18abd8ce03db$var$scrollEl = $ce3f18abd8ce03db$var$scrolling = $ce3f18abd8ce03db$var$pointerElemChangedInterval = $ce3f18abd8ce03db$var$lastAutoScrollX = $ce3f18abd8ce03db$var$lastAutoScrollY = null;
            $ce3f18abd8ce03db$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $ce3f18abd8ce03db$var$touchEvt$1 = evt; // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $ce3f18abd8ce03db$var$Edge || $ce3f18abd8ce03db$var$IE11OrLess || $ce3f18abd8ce03db$var$Safari) {
                $ce3f18abd8ce03db$var$autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
                var ogElemScroller = $ce3f18abd8ce03db$var$getParentAutoScrollElement(elem, true);
                if ($ce3f18abd8ce03db$var$scrolling && (!$ce3f18abd8ce03db$var$pointerElemChangedInterval || x !== $ce3f18abd8ce03db$var$lastAutoScrollX || y !== $ce3f18abd8ce03db$var$lastAutoScrollY)) {
                    $ce3f18abd8ce03db$var$pointerElemChangedInterval && $ce3f18abd8ce03db$var$clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
                    $ce3f18abd8ce03db$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $ce3f18abd8ce03db$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $ce3f18abd8ce03db$var$clearAutoScrolls();
                        }
                        $ce3f18abd8ce03db$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $ce3f18abd8ce03db$var$lastAutoScrollX = x;
                    $ce3f18abd8ce03db$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $ce3f18abd8ce03db$var$getParentAutoScrollElement(elem, true) === $ce3f18abd8ce03db$var$getWindowScrollingElement()) {
                    $ce3f18abd8ce03db$var$clearAutoScrolls();
                    return;
                }
                $ce3f18abd8ce03db$var$autoScroll(evt, this.options, $ce3f18abd8ce03db$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $ce3f18abd8ce03db$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $ce3f18abd8ce03db$var$clearAutoScrolls() {
    $ce3f18abd8ce03db$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $ce3f18abd8ce03db$var$autoScrolls = [];
}
function $ce3f18abd8ce03db$var$clearPointerElemChangedInterval() {
    clearInterval($ce3f18abd8ce03db$var$pointerElemChangedInterval);
}
var $ce3f18abd8ce03db$var$autoScroll = $ce3f18abd8ce03db$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $ce3f18abd8ce03db$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn; // New scroll root, set scrollEl
    if ($ce3f18abd8ce03db$var$scrollRootEl !== rootEl) {
        $ce3f18abd8ce03db$var$scrollRootEl = rootEl;
        $ce3f18abd8ce03db$var$clearAutoScrolls();
        $ce3f18abd8ce03db$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($ce3f18abd8ce03db$var$scrollEl === true) $ce3f18abd8ce03db$var$scrollEl = $ce3f18abd8ce03db$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $ce3f18abd8ce03db$var$scrollEl;
    do {
        var el = currentParent, rect = $ce3f18abd8ce03db$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $ce3f18abd8ce03db$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$ce3f18abd8ce03db$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$ce3f18abd8ce03db$var$autoScrolls[i]) $ce3f18abd8ce03db$var$autoScrolls[i] = {};
        }
        if ($ce3f18abd8ce03db$var$autoScrolls[layersOut].vx != vx || $ce3f18abd8ce03db$var$autoScrolls[layersOut].vy != vy || $ce3f18abd8ce03db$var$autoScrolls[layersOut].el !== el) {
            $ce3f18abd8ce03db$var$autoScrolls[layersOut].el = el;
            $ce3f18abd8ce03db$var$autoScrolls[layersOut].vx = vx;
            $ce3f18abd8ce03db$var$autoScrolls[layersOut].vy = vy;
            clearInterval($ce3f18abd8ce03db$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $ce3f18abd8ce03db$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $ce3f18abd8ce03db$export$31b3ca70d8f57423.active._onTouchMove($ce3f18abd8ce03db$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $ce3f18abd8ce03db$var$autoScrolls[this.layer].vy ? $ce3f18abd8ce03db$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $ce3f18abd8ce03db$var$autoScrolls[this.layer].vx ? $ce3f18abd8ce03db$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($ce3f18abd8ce03db$export$31b3ca70d8f57423.dragged.parentNode[$ce3f18abd8ce03db$var$expando], scrollOffsetX, scrollOffsetY, evt, $ce3f18abd8ce03db$var$touchEvt$1, $ce3f18abd8ce03db$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $ce3f18abd8ce03db$var$scrollBy($ce3f18abd8ce03db$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $ce3f18abd8ce03db$var$getParentAutoScrollElement(currentParent, false)));
    $ce3f18abd8ce03db$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $ce3f18abd8ce03db$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $ce3f18abd8ce03db$var$Revert() {}
$ce3f18abd8ce03db$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $ce3f18abd8ce03db$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $ce3f18abd8ce03db$var$drop
};
$ce3f18abd8ce03db$var$_extends($ce3f18abd8ce03db$var$Revert, {
    pluginName: "revertOnSpill"
});
function $ce3f18abd8ce03db$var$Remove() {}
$ce3f18abd8ce03db$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $ce3f18abd8ce03db$var$drop
};
$ce3f18abd8ce03db$var$_extends($ce3f18abd8ce03db$var$Remove, {
    pluginName: "removeOnSpill"
});
var $ce3f18abd8ce03db$var$lastSwapEl;
function $ce3f18abd8ce03db$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $ce3f18abd8ce03db$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $ce3f18abd8ce03db$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $ce3f18abd8ce03db$var$toggleClass(target, options.swapClass, true);
                    $ce3f18abd8ce03db$var$lastSwapEl = target;
                } else $ce3f18abd8ce03db$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $ce3f18abd8ce03db$var$lastSwapEl) $ce3f18abd8ce03db$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $ce3f18abd8ce03db$var$lastSwapEl && $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$lastSwapEl, options.swapClass, false);
            if ($ce3f18abd8ce03db$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $ce3f18abd8ce03db$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $ce3f18abd8ce03db$var$swapNodes(dragEl, $ce3f18abd8ce03db$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $ce3f18abd8ce03db$var$lastSwapEl = null;
        }
    };
    return $ce3f18abd8ce03db$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $ce3f18abd8ce03db$var$lastSwapEl
            };
        }
    });
}
function $ce3f18abd8ce03db$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $ce3f18abd8ce03db$var$index(n1);
    i2 = $ce3f18abd8ce03db$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $ce3f18abd8ce03db$var$multiDragElements = [], $ce3f18abd8ce03db$var$multiDragClones = [], $ce3f18abd8ce03db$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$ce3f18abd8ce03db$var$multiDragSortable, $ce3f18abd8ce03db$var$initialFolding = false, // Initial multi-drag fold when drag started
$ce3f18abd8ce03db$var$folding = false, // Folding any other time
$ce3f18abd8ce03db$var$dragStarted = false, $ce3f18abd8ce03db$var$dragEl$1, $ce3f18abd8ce03db$var$clonesFromRect, $ce3f18abd8ce03db$var$clonesHidden;
function $ce3f18abd8ce03db$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $ce3f18abd8ce03db$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $ce3f18abd8ce03db$var$on(document, "mouseup", this._deselectMultiDrag);
                $ce3f18abd8ce03db$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $ce3f18abd8ce03db$var$on(document, "keydown", this._checkKeyDown);
        $ce3f18abd8ce03db$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($ce3f18abd8ce03db$var$multiDragElements.length && $ce3f18abd8ce03db$var$multiDragSortable === sortable) $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $ce3f18abd8ce03db$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$ce3f18abd8ce03db$var$multiDragElements.indexOf($ce3f18abd8ce03db$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $ce3f18abd8ce03db$var$multiDragElements.length; i++){
                $ce3f18abd8ce03db$var$multiDragClones.push($ce3f18abd8ce03db$var$clone($ce3f18abd8ce03db$var$multiDragElements[i]));
                $ce3f18abd8ce03db$var$multiDragClones[i].sortableIndex = $ce3f18abd8ce03db$var$multiDragElements[i].sortableIndex;
                $ce3f18abd8ce03db$var$multiDragClones[i].draggable = false;
                $ce3f18abd8ce03db$var$multiDragClones[i].style["will-change"] = "";
                $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$multiDragClones[i], this.options.selectedClass, false);
                $ce3f18abd8ce03db$var$multiDragElements[i] === $ce3f18abd8ce03db$var$dragEl$1 && $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($ce3f18abd8ce03db$var$multiDragElements.length && $ce3f18abd8ce03db$var$multiDragSortable === sortable) {
                    $ce3f18abd8ce03db$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $ce3f18abd8ce03db$var$insertMultiDragClones(false, rootEl);
            $ce3f18abd8ce03db$var$multiDragClones.forEach(function(clone) {
                $ce3f18abd8ce03db$var$css(clone, "display", "");
            });
            cloneNowShown();
            $ce3f18abd8ce03db$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $ce3f18abd8ce03db$var$multiDragClones.forEach(function(clone) {
                $ce3f18abd8ce03db$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $ce3f18abd8ce03db$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $ce3f18abd8ce03db$var$multiDragSortable) $ce3f18abd8ce03db$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $ce3f18abd8ce03db$var$index(multiDragElement);
            }); // Sort multi-drag elements
            $ce3f18abd8ce03db$var$multiDragElements = $ce3f18abd8ce03db$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $ce3f18abd8ce03db$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $ce3f18abd8ce03db$var$dragEl$1) return;
                        $ce3f18abd8ce03db$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$dragEl$1, false, true, true);
                    $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $ce3f18abd8ce03db$var$dragEl$1) return;
                        $ce3f18abd8ce03db$var$setRect(multiDragElement, dragRect);
                    });
                    $ce3f18abd8ce03db$var$folding = true;
                    $ce3f18abd8ce03db$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $ce3f18abd8ce03db$var$folding = false;
                $ce3f18abd8ce03db$var$initialFolding = false;
                if (_this2.options.animation) $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                    $ce3f18abd8ce03db$var$unsetRect(multiDragElement);
                });
                 // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $ce3f18abd8ce03db$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($ce3f18abd8ce03db$var$folding && ~$ce3f18abd8ce03db$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($ce3f18abd8ce03db$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $ce3f18abd8ce03db$var$folding ? $ce3f18abd8ce03db$var$getRect(multiDragElement) : dragRect
                    });
                    $ce3f18abd8ce03db$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $ce3f18abd8ce03db$var$folding = false;
                $ce3f18abd8ce03db$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $ce3f18abd8ce03db$var$initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $ce3f18abd8ce03db$var$multiDragElements.length > 1 && ($ce3f18abd8ce03db$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$dragEl$1, false, true, true);
                    $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $ce3f18abd8ce03db$var$dragEl$1) return;
                        $ce3f18abd8ce03db$var$setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $ce3f18abd8ce03db$var$folding = true;
                } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$ce3f18abd8ce03db$var$folding) $ce3f18abd8ce03db$var$removeMultiDragElements();
                    if ($ce3f18abd8ce03db$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $ce3f18abd8ce03db$var$clonesHidden;
                        activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$ce3f18abd8ce03db$var$clonesHidden && clonesHiddenBefore) $ce3f18abd8ce03db$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $ce3f18abd8ce03db$var$clonesFromRect
                            });
                            clone.fromRect = $ce3f18abd8ce03db$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $ce3f18abd8ce03db$var$clonesFromRect = $ce3f18abd8ce03db$var$_extends({}, dragRect);
                var dragMatrix = $ce3f18abd8ce03db$var$matrix($ce3f18abd8ce03db$var$dragEl$1, true);
                $ce3f18abd8ce03db$var$clonesFromRect.top -= dragMatrix.f;
                $ce3f18abd8ce03db$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($ce3f18abd8ce03db$var$folding) {
                $ce3f18abd8ce03db$var$folding = false;
                $ce3f18abd8ce03db$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children; // Multi-drag selection
            if (!$ce3f18abd8ce03db$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $ce3f18abd8ce03db$var$toggleClass($ce3f18abd8ce03db$var$dragEl$1, options.selectedClass, !~$ce3f18abd8ce03db$var$multiDragElements.indexOf($ce3f18abd8ce03db$var$dragEl$1));
                if (!~$ce3f18abd8ce03db$var$multiDragElements.indexOf($ce3f18abd8ce03db$var$dragEl$1)) {
                    $ce3f18abd8ce03db$var$multiDragElements.push($ce3f18abd8ce03db$var$dragEl$1);
                    $ce3f18abd8ce03db$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $ce3f18abd8ce03db$var$dragEl$1,
                        originalEvent: evt
                    }); // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $ce3f18abd8ce03db$var$lastMultiDragSelect && sortable.el.contains($ce3f18abd8ce03db$var$lastMultiDragSelect)) {
                        var lastIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$lastMultiDragSelect), currentIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$ce3f18abd8ce03db$var$multiDragElements.indexOf(children[i])) continue;
                                $ce3f18abd8ce03db$var$toggleClass(children[i], options.selectedClass, true);
                                $ce3f18abd8ce03db$var$multiDragElements.push(children[i]);
                                $ce3f18abd8ce03db$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $ce3f18abd8ce03db$var$lastMultiDragSelect = $ce3f18abd8ce03db$var$dragEl$1;
                    $ce3f18abd8ce03db$var$multiDragSortable = toSortable;
                } else {
                    $ce3f18abd8ce03db$var$multiDragElements.splice($ce3f18abd8ce03db$var$multiDragElements.indexOf($ce3f18abd8ce03db$var$dragEl$1), 1);
                    $ce3f18abd8ce03db$var$lastMultiDragSelect = null;
                    $ce3f18abd8ce03db$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $ce3f18abd8ce03db$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            } // Multi-drag drop
            if ($ce3f18abd8ce03db$var$dragStarted && this.isMultiDrag) {
                $ce3f18abd8ce03db$var$folding = false; // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$ce3f18abd8ce03db$var$expando].options.sort || parentEl !== rootEl) && $ce3f18abd8ce03db$var$multiDragElements.length > 1) {
                    var dragRect = $ce3f18abd8ce03db$var$getRect($ce3f18abd8ce03db$var$dragEl$1), multiDragIndex = $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$ce3f18abd8ce03db$var$initialFolding && options.animation) $ce3f18abd8ce03db$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$ce3f18abd8ce03db$var$initialFolding) {
                        if (options.animation) {
                            $ce3f18abd8ce03db$var$dragEl$1.fromRect = dragRect;
                            $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $ce3f18abd8ce03db$var$dragEl$1) {
                                    var rect = $ce3f18abd8ce03db$var$folding ? $ce3f18abd8ce03db$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect; // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $ce3f18abd8ce03db$var$removeMultiDragElements();
                        $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        }); // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $ce3f18abd8ce03db$var$index($ce3f18abd8ce03db$var$dragEl$1)) {
                            var update = false;
                            $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $ce3f18abd8ce03db$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) dispatchSortableEvent("update");
                        }
                    } // Must be done after capturing individual rects (scroll bar)
                    $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                        $ce3f18abd8ce03db$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $ce3f18abd8ce03db$var$multiDragSortable = toSortable;
            } // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $ce3f18abd8ce03db$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $ce3f18abd8ce03db$var$dragStarted = false;
            $ce3f18abd8ce03db$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $ce3f18abd8ce03db$var$off(document, "pointerup", this._deselectMultiDrag);
            $ce3f18abd8ce03db$var$off(document, "mouseup", this._deselectMultiDrag);
            $ce3f18abd8ce03db$var$off(document, "touchend", this._deselectMultiDrag);
            $ce3f18abd8ce03db$var$off(document, "keydown", this._checkKeyDown);
            $ce3f18abd8ce03db$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $ce3f18abd8ce03db$var$dragStarted !== "undefined" && $ce3f18abd8ce03db$var$dragStarted) return; // Only deselect if selection is in this sortable
            if ($ce3f18abd8ce03db$var$multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
            if (evt && $ce3f18abd8ce03db$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($ce3f18abd8ce03db$var$multiDragElements.length){
                var el = $ce3f18abd8ce03db$var$multiDragElements[0];
                $ce3f18abd8ce03db$var$toggleClass(el, this.options.selectedClass, false);
                $ce3f18abd8ce03db$var$multiDragElements.shift();
                $ce3f18abd8ce03db$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $ce3f18abd8ce03db$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$ce3f18abd8ce03db$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$ce3f18abd8ce03db$var$multiDragElements.indexOf(el)) return;
                if ($ce3f18abd8ce03db$var$multiDragSortable && $ce3f18abd8ce03db$var$multiDragSortable !== sortable) {
                    $ce3f18abd8ce03db$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $ce3f18abd8ce03db$var$multiDragSortable = sortable;
                }
                $ce3f18abd8ce03db$var$toggleClass(el, sortable.options.selectedClass, true);
                $ce3f18abd8ce03db$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$ce3f18abd8ce03db$var$expando], index = $ce3f18abd8ce03db$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $ce3f18abd8ce03db$var$toggleClass(el, sortable.options.selectedClass, false);
                $ce3f18abd8ce03db$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                }); // multiDragElements will already be sorted if folding
                var newIndex;
                if ($ce3f18abd8ce03db$var$folding && multiDragElement !== $ce3f18abd8ce03db$var$dragEl$1) newIndex = -1;
                else if ($ce3f18abd8ce03db$var$folding) newIndex = $ce3f18abd8ce03db$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $ce3f18abd8ce03db$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $ce3f18abd8ce03db$var$_toConsumableArray($ce3f18abd8ce03db$var$multiDragElements),
                clones: [].concat($ce3f18abd8ce03db$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $ce3f18abd8ce03db$var$insertMultiDragElements(clonesInserted, rootEl) {
    $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $ce3f18abd8ce03db$var$insertMultiDragClones(elementsInserted, rootEl) {
    $ce3f18abd8ce03db$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $ce3f18abd8ce03db$var$removeMultiDragElements() {
    $ce3f18abd8ce03db$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $ce3f18abd8ce03db$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$ce3f18abd8ce03db$export$31b3ca70d8f57423.mount(new $ce3f18abd8ce03db$var$AutoScrollPlugin());
$ce3f18abd8ce03db$export$31b3ca70d8f57423.mount($ce3f18abd8ce03db$var$Remove, $ce3f18abd8ce03db$var$Revert);
var $ce3f18abd8ce03db$export$2e2bcd8739ae039 = $ce3f18abd8ce03db$export$31b3ca70d8f57423;

});

parcelRegister("78Jai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.websocketWrapper = void 0;
var $532c5098451e162f$var$websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === "reconnect") return start;
            if (typeof val === "function") {
                console.error("Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.");
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn("The websocket's event handlers should be defined through the options object passed into useWebSocket.");
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
module.exports.websocketWrapper = $532c5098451e162f$var$websocketWrapper;
module.exports.default = module.exports.websocketWrapper;

});

/* eslint-disable import/no-duplicates */ /* eslint-disable react/jsx-filename-extension */ var $824c049f32d4395d$exports = {};
"use strict";

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));



var $7fPBF = parcelRequire("7fPBF");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $7a4462edeb17eaf0$export$13470c6f1642bbce = "Logging";
const $7a4462edeb17eaf0$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $7a4462edeb17eaf0$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c8e66b79b219dd07$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($c8e66b79b219dd07$export$a0472aa3a356446c || ($c8e66b79b219dd07$export$a0472aa3a356446c = {}));


/* eslint-disable no-console */ // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a7a5052bc2c3d966$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f {
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($a7a5052bc2c3d966$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $a7a5052bc2c3d966$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $a7a5052bc2c3d966$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $c8e66b79b219dd07$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $c8e66b79b219dd07$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        if ($a7a5052bc2c3d966$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $c8e66b79b219dd07$export$a0472aa3a356446c).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $c8e66b79b219dd07$export$a0472aa3a356446c).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $c8e66b79b219dd07$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $c8e66b79b219dd07$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $c8e66b79b219dd07$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $c8e66b79b219dd07$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $c8e66b79b219dd07$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $c8e66b79b219dd07$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $7a4462edeb17eaf0$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $c8e66b79b219dd07$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
}
$a7a5052bc2c3d966$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$a7a5052bc2c3d966$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;



class $8e83a7c7b1bfe85e$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message, name: name, recoverySuggestion: recoverySuggestion, underlyingError: underlyingError, metadata: metadata }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        if (metadata) {
            // If metadata exists, explicitly only record the following properties.
            const { extendedRequestId: extendedRequestId, httpStatusCode: httpStatusCode, requestId: requestId } = metadata;
            this.metadata = {
                extendedRequestId: extendedRequestId,
                httpStatusCode: httpStatusCode,
                requestId: requestId
            };
        }
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $8e83a7c7b1bfe85e$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $8e83a7c7b1bfe85e$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $317c15c2759ac41f$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $317c15c2759ac41f$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("Hub");
class $317c15c2759ac41f$export$6b38ef2be9abbbb9 {
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $317c15c2759ac41f$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $317c15c2759ac41f$export$aadf71dd9875dd20;
            if (!hasAccess) $317c15c2759ac41f$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: (0, $9tqwB._)({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $317c15c2759ac41f$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
            name: (0, $7a4462edeb17eaf0$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel, payload: payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $317c15c2759ac41f$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $317c15c2759ac41f$var$logger.error(e);
            }
        });
    }
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $317c15c2759ac41f$export$8c41bb232f1008b1 = new $317c15c2759ac41f$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $317c15c2759ac41f$export$45dde0743a4c8d6e = new $317c15c2759ac41f$export$6b38ef2be9abbbb9("internal-hub");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $abe1fb4ec0003df1$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $abe1fb4ec0003df1$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a16ab239475019f9$export$35210b3191d26437 = Symbol("oauth-listener");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4b186f85a229aaaa$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $4b186f85a229aaaa$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $4b186f85a229aaaa$export$1ef2e9c2da492d = (config = {})=>{
    var _aws_cognito_password_protection_settings_passwordPolicyCharacters, _aws_cognito_password_protection_settings_passwordPolicyCharacters1, _aws_cognito_password_protection_settings_passwordPolicyCharacters2, _aws_cognito_password_protection_settings_passwordPolicyCharacters3;
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey, aws_appsync_authenticationType: aws_appsync_authenticationType, aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint, aws_appsync_region: aws_appsync_region, aws_bots_config: aws_bots_config, aws_cognito_identity_pool_id: aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration: aws_cognito_mfa_configuration, aws_cognito_mfa_types: aws_cognito_mfa_types, aws_cognito_password_protection_settings: aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms, aws_cognito_signup_attributes: aws_cognito_signup_attributes, aws_cognito_social_providers: aws_cognito_social_providers, aws_cognito_username_attributes: aws_cognito_username_attributes, aws_mandatory_sign_in: aws_mandatory_sign_in, aws_mobile_analytics_app_id: aws_mobile_analytics_app_id, aws_mobile_analytics_app_region: aws_mobile_analytics_app_region, aws_user_files_s3_bucket: aws_user_files_s3_bucket, aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id: aws_user_pools_id, aws_user_pools_web_client_id: aws_user_pools_web_client_id, geo: geo, oauth: oauth, predictions: predictions, aws_cloud_logic_custom: aws_cloud_logic_custom, Notifications: Notifications, modelIntrospection: modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging, Push: Push } = Notifications !== null && Notifications !== void 0 ? Notifications : {};
    if ((InAppMessaging === null || InAppMessaging === void 0 ? void 0 : InAppMessaging.AWSPinpoint) || (Push === null || Push === void 0 ? void 0 : Push.AWSPinpoint)) {
        if (InAppMessaging === null || InAppMessaging === void 0 ? void 0 : InAppMessaging.AWSPinpoint) {
            const { appId: appId, region: region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push === null || Push === void 0 ? void 0 : Push.AWSPinpoint) {
            const { appId: appId, region: region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = (0, $2qxEV._)((0, $9tqwB._)({}, amplifyConfig.Notifications), {
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            });
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $4b186f85a229aaaa$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $4b186f85a229aaaa$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode !== null && defaultAuthMode !== void 0 ? defaultAuthMode : "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    var _aws_cognito_mfa_types_includes, _aws_cognito_mfa_types_includes1;
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: (_aws_cognito_mfa_types_includes = aws_cognito_mfa_types === null || aws_cognito_mfa_types === void 0 ? void 0 : aws_cognito_mfa_types.includes("TOTP")) !== null && _aws_cognito_mfa_types_includes !== void 0 ? _aws_cognito_mfa_types_includes : false,
        smsEnabled: (_aws_cognito_mfa_types_includes1 = aws_cognito_mfa_types === null || aws_cognito_mfa_types === void 0 ? void 0 : aws_cognito_mfa_types.includes("SMS")) !== null && _aws_cognito_mfa_types_includes1 !== void 0 ? _aws_cognito_mfa_types_includes1 : false
    } : undefined;
    var _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes, _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1, _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2, _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes = (_aws_cognito_password_protection_settings_passwordPolicyCharacters = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters.includes("REQUIRES_LOWERCASE")) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes : false,
        requireUppercase: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1 = (_aws_cognito_password_protection_settings_passwordPolicyCharacters1 = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters1 === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters1.includes("REQUIRES_UPPERCASE")) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1 !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes1 : false,
        requireNumbers: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2 = (_aws_cognito_password_protection_settings_passwordPolicyCharacters2 = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters2 === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters2.includes("REQUIRES_NUMBERS")) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2 !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes2 : false,
        requireSpecialCharacters: (_aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3 = (_aws_cognito_password_protection_settings_passwordPolicyCharacters3 = aws_cognito_password_protection_settings.passwordPolicyCharacters) === null || _aws_cognito_password_protection_settings_passwordPolicyCharacters3 === void 0 ? void 0 : _aws_cognito_password_protection_settings_passwordPolicyCharacters3.includes("REQUIRES_SYMBOLS")) !== null && _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3 !== void 0 ? _aws_cognito_password_protection_settings_passwordPolicyCharacters_includes3 : false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms !== null && aws_cognito_verification_mechanisms !== void 0 ? aws_cognito_verification_mechanisms : [],
        ...aws_cognito_signup_attributes !== null && aws_cognito_signup_attributes !== void 0 ? aws_cognito_signup_attributes : []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>(0, $2qxEV._)((0, $9tqwB._)({}, attributes), {
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    var _aws_cognito_username_attributes_includes;
    const loginWithEmailEnabled = (_aws_cognito_username_attributes_includes = aws_cognito_username_attributes === null || aws_cognito_username_attributes === void 0 ? void 0 : aws_cognito_username_attributes.includes("EMAIL")) !== null && _aws_cognito_username_attributes_includes !== void 0 ? _aws_cognito_username_attributes_includes : false;
    var _aws_cognito_username_attributes_includes1;
    const loginWithPhoneEnabled = (_aws_cognito_username_attributes_includes1 = aws_cognito_username_attributes === null || aws_cognito_username_attributes === void 0 ? void 0 : aws_cognito_username_attributes.includes("PHONE_NUMBER")) !== null && _aws_cognito_username_attributes_includes1 !== void 0 ? _aws_cognito_username_attributes_includes1 : false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = (0, $2qxEV._)((0, $9tqwB._)({}, amplifyConfig.Auth.Cognito.loginWith), {
        oauth: (0, $9tqwB._)({}, $4b186f85a229aaaa$var$getOAuthConfig(oauth), hasSocialProviderConfig && {
            providers: $4b186f85a229aaaa$var$parseSocialProviders(aws_cognito_social_providers)
        })
    });
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = (0, $2qxEV._)((0, $9tqwB._)({}, amplifyConfig.API), {
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name, endpoint: endpoint, region: region, service: service } = api;
            return (0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                [name]: (0, $9tqwB._)({
                    endpoint: endpoint
                }, service ? {
                    service: service
                } : undefined, region ? {
                    region: region
                } : undefined)
            });
        }, {})
    });
    // Predictions
    if (predictions) {
        var _predictions_convert_speechGenerator, _predictions_convert;
        var _predictions_convert_speechGenerator_defaults;
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = (_predictions_convert_speechGenerator_defaults = predictions === null || predictions === void 0 ? void 0 : (_predictions_convert = predictions.convert) === null || _predictions_convert === void 0 ? void 0 : (_predictions_convert_speechGenerator = _predictions_convert.speechGenerator) === null || _predictions_convert_speechGenerator === void 0 ? void 0 : _predictions_convert_speechGenerator.defaults) !== null && _predictions_convert_speechGenerator_defaults !== void 0 ? _predictions_convert_speechGenerator_defaults : {};
        amplifyConfig.Predictions = voiceId ? (0, $2qxEV._)((0, $9tqwB._)({}, predictions), {
            convert: (0, $2qxEV._)((0, $9tqwB._)({}, predictions.convert), {
                speechGenerator: (0, $2qxEV._)((0, $9tqwB._)({}, predictions.convert.speechGenerator), {
                    defaults: {
                        voiceId: voiceId
                    }
                })
            })
        }) : predictions;
    }
    return amplifyConfig;
};
const $4b186f85a229aaaa$var$getRedirectUrl = (redirectStr)=>{
    var _redirectStr_split;
    return (_redirectStr_split = redirectStr === null || redirectStr === void 0 ? void 0 : redirectStr.split(",")) !== null && _redirectStr_split !== void 0 ? _redirectStr_split : [];
};
const $4b186f85a229aaaa$var$getOAuthConfig = ({ domain: domain, scope: scope, redirectSignIn: redirectSignIn, redirectSignOut: redirectSignOut, responseType: responseType })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $4b186f85a229aaaa$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $4b186f85a229aaaa$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $4b186f85a229aaaa$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $2d95935af7cdf5e0$export$99bf765e6322c00(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version: version } = config;
    if (!version) return false;
    return version.startsWith("1");
}
function $2d95935af7cdf5e0$var$parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name: bucket_name, aws_region: aws_region, buckets: buckets } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region,
            buckets: buckets && $2d95935af7cdf5e0$var$createBucketInfoMap(buckets)
        }
    };
}
function $2d95935af7cdf5e0$var$parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id: user_pool_id, user_pool_client_id: user_pool_client_id, identity_pool_id: identity_pool_id, password_policy: password_policy, mfa_configuration: mfa_configuration, mfa_methods: mfa_methods, unauthenticated_identities_enabled: unauthenticated_identities_enabled, oauth: oauth, username_attributes: username_attributes, standard_required_attributes: standard_required_attributes, groups: groups } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id,
            groups: groups
        }
    };
    if (identity_pool_id) authConfig.Cognito = (0, $2qxEV._)((0, $9tqwB._)({}, authConfig.Cognito), {
        identityPoolId: identity_pool_id
    });
    var _password_policy_min_length;
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: (_password_policy_min_length = password_policy.min_length) !== null && _password_policy_min_length !== void 0 ? _password_policy_min_length : 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: $2d95935af7cdf5e0$var$getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods === null || mfa_methods === void 0 ? void 0 : mfa_methods.includes("SMS"),
        totpEnabled: mfa_methods === null || mfa_methods === void 0 ? void 0 : mfa_methods.includes("TOTP")
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === "token" ? "token" : "code",
            scopes: oauth.scopes,
            providers: $2d95935af7cdf5e0$var$getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = (0, $2qxEV._)((0, $9tqwB._)({}, authConfig.Cognito.loginWith), {
        email: username_attributes.includes("email"),
        phone: username_attributes.includes("phone_number"),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes("username")
    });
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [curr]: {
                required: true
            }
        }), {});
    return authConfig;
}
function $2d95935af7cdf5e0$export$fbb0a2a08db9629a(amplifyOutputsAnalyticsProperties) {
    if (!(amplifyOutputsAnalyticsProperties === null || amplifyOutputsAnalyticsProperties === void 0 ? void 0 : amplifyOutputsAnalyticsProperties.amazon_pinpoint)) return undefined;
    const { amazon_pinpoint: amazon_pinpoint } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function $2d95935af7cdf5e0$var$parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region: aws_region, geofence_collections: geofence_collections, maps: maps, search_indices: search_indices } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps: maps
        }
    };
}
function $2d95935af7cdf5e0$var$parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region: aws_region, default_authorization_type: default_authorization_type, url: url, api_key: api_key, model_introspection: model_introspection } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: $2d95935af7cdf5e0$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL: GraphQL
    };
}
function $2d95935af7cdf5e0$var$parseCustom(amplifyOutputsCustomProperties) {
    if (!(amplifyOutputsCustomProperties === null || amplifyOutputsCustomProperties === void 0 ? void 0 : amplifyOutputsCustomProperties.events)) return undefined;
    const { url: url, aws_region: aws_region, api_key: api_key, default_authorization_type: default_authorization_type } = amplifyOutputsCustomProperties.events;
    const Events = {
        endpoint: url,
        defaultAuthMode: $2d95935af7cdf5e0$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key
    };
    return {
        Events: Events
    };
}
function $2d95935af7cdf5e0$var$parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region: aws_region, channels: channels, amazon_pinpoint_app_id: amazon_pinpoint_app_id } = amplifyOutputsNotificationsProperties;
    const hasInAppMessaging = channels.includes("IN_APP_MESSAGING");
    const hasPushNotification = channels.includes("APNS") || channels.includes("FCM");
    if (!(hasInAppMessaging || hasPushNotification)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    if (hasPushNotification) notificationsConfig.PushNotification = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    return notificationsConfig;
}
function $2d95935af7cdf5e0$export$11d0da171d17ab63(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = $2d95935af7cdf5e0$var$parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = $2d95935af7cdf5e0$var$parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = $2d95935af7cdf5e0$export$fbb0a2a08db9629a(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = $2d95935af7cdf5e0$var$parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = $2d95935af7cdf5e0$var$parseData(amplifyOutputs.data);
    if (amplifyOutputs.custom) {
        const customConfig = $2d95935af7cdf5e0$var$parseCustom(amplifyOutputs.custom);
        if (customConfig && "Events" in customConfig) resourcesConfig.API = (0, $9tqwB._)({}, resourcesConfig.API, customConfig);
    }
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = $2d95935af7cdf5e0$var$parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const $2d95935af7cdf5e0$var$authModeNames = {
    AMAZON_COGNITO_USER_POOLS: "userPool",
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AWS_LAMBDA: "lambda",
    OPENID_CONNECT: "oidc"
};
function $2d95935af7cdf5e0$var$getGraphQLAuthMode(authType) {
    return $2d95935af7cdf5e0$var$authModeNames[authType];
}
const $2d95935af7cdf5e0$var$providerNames = {
    GOOGLE: "Google",
    LOGIN_WITH_AMAZON: "Amazon",
    FACEBOOK: "Facebook",
    SIGN_IN_WITH_APPLE: "Apple"
};
function $2d95935af7cdf5e0$var$getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if ($2d95935af7cdf5e0$var$providerNames[provider] !== undefined) oAuthProviders.push($2d95935af7cdf5e0$var$providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function $2d95935af7cdf5e0$var$getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === "OPTIONAL") return "optional";
    if (mfaConfiguration === "REQUIRED") return "on";
    return "off";
}
function $2d95935af7cdf5e0$var$createBucketInfoMap(buckets) {
    const mappedBuckets = {};
    buckets.forEach(({ name: name, bucket_name: bucketName, aws_region: region, paths: paths })=>{
        if (name in mappedBuckets) throw new Error(`Duplicate friendly name found: ${name}. Name must be unique.`);
        const sanitizedPaths = paths ? Object.entries(paths).reduce((acc, [key, value])=>{
            if (value !== undefined) acc[key] = value;
            return acc;
        }, {}) : undefined;
        mappedBuckets[name] = {
            bucketName: bucketName,
            region: region,
            paths: sanitizedPaths
        };
    });
    return mappedBuckets;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const $fefcb3235338ed7e$export$f101a69cd6dc6202 = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith("aws_"))) return (0, $4b186f85a229aaaa$export$1ef2e9c2da492d)(amplifyConfig);
    else if ((0, $2d95935af7cdf5e0$export$99bf765e6322c00)(amplifyConfig)) return (0, $2d95935af7cdf5e0$export$11d0da171d17ab63)(amplifyConfig);
    else return amplifyConfig;
};



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $1e2082910c54650f$var$extendStatics = function(d, b) {
    $1e2082910c54650f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e2082910c54650f$var$extendStatics(d, b);
};
function $1e2082910c54650f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e2082910c54650f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e2082910c54650f$export$18ce0697a983be9b = function() {
    $1e2082910c54650f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e2082910c54650f$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e2082910c54650f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e2082910c54650f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e2082910c54650f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e2082910c54650f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e2082910c54650f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e2082910c54650f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1e2082910c54650f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e2082910c54650f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e2082910c54650f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e2082910c54650f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e2082910c54650f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e2082910c54650f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e2082910c54650f$export$45d3717a4c69092e(o, m, p);
}
function $1e2082910c54650f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e2082910c54650f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e2082910c54650f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e2082910c54650f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e2082910c54650f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e2082910c54650f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e2082910c54650f$export$10c90e4f7922046c(v) {
    return this instanceof $1e2082910c54650f$export$10c90e4f7922046c ? (this.v = v, this) : new $1e2082910c54650f$export$10c90e4f7922046c(v);
}
function $1e2082910c54650f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e2082910c54650f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e2082910c54650f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e2082910c54650f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e2082910c54650f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e2082910c54650f$export$19a8beecd37a4c45 === "function" ? $1e2082910c54650f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e2082910c54650f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e2082910c54650f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $1e2082910c54650f$var$ownKeys = function(o) {
    $1e2082910c54650f$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $1e2082910c54650f$var$ownKeys(o);
};
function $1e2082910c54650f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $1e2082910c54650f$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $1e2082910c54650f$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $1e2082910c54650f$var$__setModuleDefault(result, mod);
    return result;
}
function $1e2082910c54650f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1e2082910c54650f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e2082910c54650f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e2082910c54650f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e2082910c54650f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e2082910c54650f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e2082910c54650f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e2082910c54650f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $1e2082910c54650f$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $1e2082910c54650f$export$2e2bcd8739ae039 = {
    __extends: $1e2082910c54650f$export$a8ba968b8961cb8a,
    __assign: $1e2082910c54650f$export$18ce0697a983be9b,
    __rest: $1e2082910c54650f$export$3c9a16f847548506,
    __decorate: $1e2082910c54650f$export$29e00dfd3077644b,
    __param: $1e2082910c54650f$export$d5ad3fd78186038f,
    __esDecorate: $1e2082910c54650f$export$3a84e1ae4e97e9b0,
    __runInitializers: $1e2082910c54650f$export$d831c04e792af3d,
    __propKey: $1e2082910c54650f$export$6a2a36740a146cb8,
    __setFunctionName: $1e2082910c54650f$export$d1a06452d3489bc7,
    __metadata: $1e2082910c54650f$export$f1db080c865becb9,
    __awaiter: $1e2082910c54650f$export$1050f835b63b671e,
    __generator: $1e2082910c54650f$export$67ebef60e6f28a6,
    __createBinding: $1e2082910c54650f$export$45d3717a4c69092e,
    __exportStar: $1e2082910c54650f$export$f33643c0debef087,
    __values: $1e2082910c54650f$export$19a8beecd37a4c45,
    __read: $1e2082910c54650f$export$8d051b38c9118094,
    __spread: $1e2082910c54650f$export$afc72e2116322959,
    __spreadArrays: $1e2082910c54650f$export$6388937ca91ccae8,
    __spreadArray: $1e2082910c54650f$export$1216008129fb82ed,
    __await: $1e2082910c54650f$export$10c90e4f7922046c,
    __asyncGenerator: $1e2082910c54650f$export$e427f37a30a4de9b,
    __asyncDelegator: $1e2082910c54650f$export$bbd80228419bb833,
    __asyncValues: $1e2082910c54650f$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e2082910c54650f$export$4fb47efe1390b86f,
    __importStar: $1e2082910c54650f$export$c21735bcef00d192,
    __importDefault: $1e2082910c54650f$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e2082910c54650f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e2082910c54650f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e2082910c54650f$export$81fdc39f203e4e04,
    __addDisposableResource: $1e2082910c54650f$export$88ac25d8e944e405,
    __disposeResources: $1e2082910c54650f$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $1e2082910c54650f$export$889dfb5d17574b0b
};


/**
 * @internal
 */ var $44a640a689986db5$export$b2e3d6d444266a5c = 64;
var $44a640a689986db5$export$d7bd469488748c5f = 32;
var $44a640a689986db5$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $44a640a689986db5$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $44a640a689986db5$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $aa42e34bb3828216$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $44a640a689986db5$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $44a640a689986db5$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $44a640a689986db5$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $44a640a689986db5$export$b2e3d6d444266a5c) >= (0, $44a640a689986db5$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $44a640a689986db5$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $44a640a689986db5$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $44a640a689986db5$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $44a640a689986db5$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $44a640a689986db5$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $44a640a689986db5$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $44a640a689986db5$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bbec8db74d15ff59$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $8137f175a992023b$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $bbec8db74d15ff59$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $9e37a86530cc70f5$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};





var $bdjQ6 = parcelRequire("bdjQ6");
var $70eee1bb620c97ae$require$Buffer = $bdjQ6.Buffer;
// Quick polyfill
var $70eee1bb620c97ae$var$fromUtf8 = typeof $70eee1bb620c97ae$require$Buffer !== "undefined" && $70eee1bb620c97ae$require$Buffer.from ? function(input) {
    return $70eee1bb620c97ae$require$Buffer.from(input, "utf8");
} : (0, $bbec8db74d15ff59$export$c7c5cef950a4d2fc);
function $70eee1bb620c97ae$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $70eee1bb620c97ae$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $936847308a333d71$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $9d7d19a7299be192$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $152d364a39221847$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $0805473ac8becd20$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $aa42e34bb3828216$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $936847308a333d71$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $70eee1bb620c97ae$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $aa42e34bb3828216$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $aa42e34bb3828216$export$aab6bc1ad3c77a42)();
            var inner = $0805473ac8becd20$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $44a640a689986db5$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $44a640a689986db5$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $0805473ac8becd20$var$bufferFromSecret(secret) {
    var input = (0, $70eee1bb620c97ae$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $44a640a689986db5$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $aa42e34bb3828216$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $44a640a689986db5$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $c78caa2b0705bfa1$var$SHORT_TO_HEX = {};
const $c78caa2b0705bfa1$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $c78caa2b0705bfa1$var$SHORT_TO_HEX[i] = encodedByte;
    $c78caa2b0705bfa1$var$HEX_TO_SHORT[encodedByte] = i;
}
function $c78caa2b0705bfa1$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $c78caa2b0705bfa1$var$HEX_TO_SHORT) out[i / 2] = $c78caa2b0705bfa1$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $c78caa2b0705bfa1$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $c78caa2b0705bfa1$var$SHORT_TO_HEX[bytes[i]];
    return out;
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $09d5a628b5a6a6cc$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("Auth");
class $09d5a628b5a6a6cc$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        var _authResourcesConfig_Cognito, _authResourcesConfig_Cognito1;
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
        if (authResourcesConfig && ((_authResourcesConfig_Cognito = authResourcesConfig.Cognito) === null || _authResourcesConfig_Cognito === void 0 ? void 0 : _authResourcesConfig_Cognito.userPoolEndpoint)) $09d5a628b5a6a6cc$var$logger.warn($09d5a628b5a6a6cc$var$getCustomEndpointWarningMessage("Amazon Cognito User Pool"));
        if (authResourcesConfig && ((_authResourcesConfig_Cognito1 = authResourcesConfig.Cognito) === null || _authResourcesConfig_Cognito1 === void 0 ? void 0 : _authResourcesConfig_Cognito1.identityPoolEndpoint)) $09d5a628b5a6a6cc$var$logger.warn($09d5a628b5a6a6cc$var$getCustomEndpointWarningMessage("Amazon Cognito Identity Pool"));
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
     * of non-expired tokens with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        var _this_authOptions_credentialsProvider, _this_authOptions;
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            var _tokens_accessToken_payload, _tokens_accessToken, _this_authOptions_credentialsProvider1, _this_authOptions1;
            userSub = (_tokens_accessToken = tokens.accessToken) === null || _tokens_accessToken === void 0 ? void 0 : (_tokens_accessToken_payload = _tokens_accessToken.payload) === null || _tokens_accessToken_payload === void 0 ? void 0 : _tokens_accessToken_payload.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await ((_this_authOptions1 = this.authOptions) === null || _this_authOptions1 === void 0 ? void 0 : (_this_authOptions_credentialsProvider1 = _this_authOptions1.credentialsProvider) === null || _this_authOptions_credentialsProvider1 === void 0 ? void 0 : _this_authOptions_credentialsProvider1.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            }));
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await ((_this_authOptions = this.authOptions) === null || _this_authOptions === void 0 ? void 0 : (_this_authOptions_credentialsProvider = _this_authOptions.credentialsProvider) === null || _this_authOptions_credentialsProvider === void 0 ? void 0 : _this_authOptions_credentialsProvider.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        }));
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId === null || credentialsAndIdentityId === void 0 ? void 0 : credentialsAndIdentityId.credentials,
            identityId: credentialsAndIdentityId === null || credentialsAndIdentityId === void 0 ? void 0 : credentialsAndIdentityId.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        var _this_authOptions_credentialsProvider, _this_authOptions;
        await ((_this_authOptions = this.authOptions) === null || _this_authOptions === void 0 ? void 0 : (_this_authOptions_credentialsProvider = _this_authOptions.credentialsProvider) === null || _this_authOptions_credentialsProvider === void 0 ? void 0 : _this_authOptions_credentialsProvider.clearCredentialsAndIdentityId());
    }
    async getTokens(options) {
        var _this_authOptions_tokenProvider, _this_authOptions;
        var _ref;
        return (_ref = await ((_this_authOptions = this.authOptions) === null || _this_authOptions === void 0 ? void 0 : (_this_authOptions_tokenProvider = _this_authOptions.tokenProvider) === null || _this_authOptions_tokenProvider === void 0 ? void 0 : _this_authOptions_tokenProvider.getTokens(options))) !== null && _ref !== void 0 ? _ref : undefined;
    }
}
const $09d5a628b5a6a6cc$var$getCustomEndpointWarningMessage = (target)=>`You are using a custom Amazon ${target} endpoint, ensure the endpoint is correct.`;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $f4c06b47af4364f4$export$b412d755cfa0136 {
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $fefcb3235338ed7e$export$f101a69cd6dc6202)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $abe1fb4ec0003df1$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
        this.notifyOAuthListener();
        this.isConfigured = true;
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        if (!this.isConfigured) // eslint-disable-next-line no-console
        console.warn(`Amplify has not been configured. Please call Amplify.configure() before using this service.`);
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $a16ab239475019f9$export$35210b3191d26437)](listener) {
        var _this_resourcesConfig_Auth_Cognito_loginWith, _this_resourcesConfig_Auth, _this_resourcesConfig_Auth1;
        if ((_this_resourcesConfig_Auth = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth === void 0 ? void 0 : (_this_resourcesConfig_Auth_Cognito_loginWith = _this_resourcesConfig_Auth.Cognito.loginWith) === null || _this_resourcesConfig_Auth_Cognito_loginWith === void 0 ? void 0 : _this_resourcesConfig_Auth_Cognito_loginWith.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener((_this_resourcesConfig_Auth1 = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth1 === void 0 ? void 0 : _this_resourcesConfig_Auth1.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        var _this_resourcesConfig_Auth_Cognito_loginWith, _this_resourcesConfig_Auth, _this_resourcesConfig_Auth1;
        if (!((_this_resourcesConfig_Auth = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth === void 0 ? void 0 : (_this_resourcesConfig_Auth_Cognito_loginWith = _this_resourcesConfig_Auth.Cognito.loginWith) === null || _this_resourcesConfig_Auth_Cognito_loginWith === void 0 ? void 0 : _this_resourcesConfig_Auth_Cognito_loginWith.oauth) || !this.oAuthListener) return;
        this.oAuthListener((_this_resourcesConfig_Auth1 = this.resourcesConfig.Auth) === null || _this_resourcesConfig_Auth1 === void 0 ? void 0 : _this_resourcesConfig_Auth1.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
    constructor(){
        this.oAuthListener = undefined;
        this.isConfigured = false;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $09d5a628b5a6a6cc$export$eeff9d1a8b8c057b)();
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const $f4c06b47af4364f4$export$a3858a9a153cffc7 = new $f4c06b47af4364f4$export$b412d755cfa0136();


var $9tqwB = parcelRequire("9tqwB");
var $52220af01326d1ec$exports = {};
(function(global, factory) {
    $52220af01326d1ec$exports = factory();
})($52220af01326d1ec$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $b83a7503689e94ae$export$dae7d845015939d5 {
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($52220af01326d1ec$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($52220af01326d1ec$exports))).get(key);
        return item !== null && item !== void 0 ? item : null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($52220af01326d1ec$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($52220af01326d1ec$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return (0, $9tqwB._)({
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        }, this.sameSite && {
            sameSite: this.sameSite
        });
    }
    constructor(data = {}){
        const { path: path, domain: domain, expires: expires, sameSite: sameSite, secure: secure } = data;
        this.domain = domain;
        this.path = path || "/";
        this.expires = Object.prototype.hasOwnProperty.call(data, "expires") ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, "secure") ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
}

var $81e4e4d475446781$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
    AmplifyErrorCode["NetworkError"] = "NetworkError";
})($81e4e4d475446781$export$4e712df6b850c8d0 || ($81e4e4d475446781$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d9487c97c6a24bdf$export$f5362e8a6666a455 extends (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $81e4e4d475446781$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $f8383410e34483c5$export$8536778e426ddf92 {
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $d9487c97c6a24bdf$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $d9487c97c6a24bdf$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $d9487c97c6a24bdf$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $d9487c97c6a24bdf$export$f5362e8a6666a455)();
        this.storage.clear();
    }
    constructor(storage){
        this.storage = storage;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $014ca4b264f5ab17$export$e4315e25b840a0ea {
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        var _this_storage_get;
        return (_this_storage_get = this.storage.get(key)) !== null && _this_storage_get !== void 0 ? _this_storage_get : null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
    constructor(){
        this.storage = new Map();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $0317d827175d0003$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("CoreStorageUtils");
const $0317d827175d0003$export$5d9abaf8ff62cd65 = ()=>{
    try {
        // Attempt to use localStorage directly
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
    } catch (e) {
        // Handle any errors related to localStorage access
        $0317d827175d0003$var$logger.info("localStorage not found. InMemoryStorage is used as a fallback.");
    }
    // Return in-memory storage as a fallback if localStorage is not accessible
    return new (0, $014ca4b264f5ab17$export$e4315e25b840a0ea)();
};
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $0317d827175d0003$export$518dcc1598f87b = ()=>{
    try {
        // Attempt to use sessionStorage directly
        if (typeof window !== "undefined" && window.sessionStorage) {
            // Verify we can actually use it by testing access
            window.sessionStorage.getItem("test");
            return window.sessionStorage;
        }
        throw new Error("sessionStorage is not defined");
    } catch (e) {
        // Handle any errors related to sessionStorage access
        $0317d827175d0003$var$logger.info("sessionStorage not found. InMemoryStorage is used as a fallback.");
        return new (0, $014ca4b264f5ab17$export$e4315e25b840a0ea)();
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $81bbc915e618f82b$export$bec45e7703e93690 extends (0, $f8383410e34483c5$export$8536778e426ddf92) {
    constructor(){
        super((0, $0317d827175d0003$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $9fc8e072f881c40a$export$2c4b17e1c2e0931 extends (0, $f8383410e34483c5$export$8536778e426ddf92) {
    constructor(){
        super((0, $0317d827175d0003$export$518dcc1598f87b)());
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $f85a66cc4881fa7a$export$f7640313c5d17c27 {
    get storage() {
        if (!this._storage) throw new (0, $d9487c97c6a24bdf$export$f5362e8a6666a455)();
        return this._storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ setItem(key, value) {
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ getItem(key) {
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ removeItem(key) {
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ clear() {
        this.storage.clear();
    }
    constructor(storage){
        this._storage = storage;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $79edd77f1a7dbc19$export$eb7b875b75a2c8df extends (0, $f85a66cc4881fa7a$export$f7640313c5d17c27) {
    constructor(){
        super((0, $0317d827175d0003$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6dd46fc26844509a$export$586b30dcaeecb901 = new (0, $81bbc915e618f82b$export$bec45e7703e93690)();
const $6dd46fc26844509a$export$f119d83aa936d634 = new (0, $9fc8e072f881c40a$export$2c4b17e1c2e0931)();
const $6dd46fc26844509a$export$9015f19b74348a18 = new (0, $79edd77f1a7dbc19$export$eb7b875b75a2c8df)();
const $6dd46fc26844509a$export$41feb988b3a84f03 = new (0, $f8383410e34483c5$export$8536778e426ddf92)(new (0, $014ca4b264f5ab17$export$e4315e25b840a0ea)());




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $4729d49089f76d33$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($4729d49089f76d33$export$638889172ebce0c4 || ($4729d49089f76d33$export$638889172ebce0c4 = {}));
var $4729d49089f76d33$export$3a8840c5b2ecf003;
(function(Category) {
    Category["AI"] = "ai";
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($4729d49089f76d33$export$3a8840c5b2ecf003 || ($4729d49089f76d33$export$3a8840c5b2ecf003 = {}));
var $4729d49089f76d33$export$89656a7f296a8665;
(function(AiAction) {
    AiAction["CreateConversation"] = "1";
    AiAction["GetConversation"] = "2";
    AiAction["ListConversations"] = "3";
    AiAction["DeleteConversation"] = "4";
    AiAction["SendMessage"] = "5";
    AiAction["ListMessages"] = "6";
    AiAction["OnMessage"] = "7";
    AiAction["Generation"] = "8";
    AiAction["UpdateConversation"] = "9";
})($4729d49089f76d33$export$89656a7f296a8665 || ($4729d49089f76d33$export$89656a7f296a8665 = {}));
var $4729d49089f76d33$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($4729d49089f76d33$export$30c16f5c43437fd7 || ($4729d49089f76d33$export$30c16f5c43437fd7 = {}));
var $4729d49089f76d33$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($4729d49089f76d33$export$126e20fdc0f0d34b || ($4729d49089f76d33$export$126e20fdc0f0d34b = {}));
var $4729d49089f76d33$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
    AuthAction["StartWebAuthnRegistration"] = "37";
    AuthAction["CompleteWebAuthnRegistration"] = "38";
    AuthAction["ListWebAuthnCredentials"] = "39";
    AuthAction["DeleteWebAuthnCredential"] = "40";
})($4729d49089f76d33$export$900b1436d7e65f4 || ($4729d49089f76d33$export$900b1436d7e65f4 = {}));
var $4729d49089f76d33$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($4729d49089f76d33$export$2f5a715aba4cde93 || ($4729d49089f76d33$export$2f5a715aba4cde93 = {}));
var $4729d49089f76d33$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($4729d49089f76d33$export$afafab3eb8fc6fef || ($4729d49089f76d33$export$afafab3eb8fc6fef = {}));
var $4729d49089f76d33$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($4729d49089f76d33$export$c01a8c16ffda791e || ($4729d49089f76d33$export$c01a8c16ffda791e = {}));
var $4729d49089f76d33$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($4729d49089f76d33$export$68e0695a774ab7fa || ($4729d49089f76d33$export$68e0695a774ab7fa = {}));
var $4729d49089f76d33$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($4729d49089f76d33$export$aa89b4c447a07cee || ($4729d49089f76d33$export$aa89b4c447a07cee = {}));
var $4729d49089f76d33$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($4729d49089f76d33$export$ade48b30f1e78672 || ($4729d49089f76d33$export$ade48b30f1e78672 = {}));
var $4729d49089f76d33$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($4729d49089f76d33$export$2c5ee06ab9fa5040 || ($4729d49089f76d33$export$2c5ee06ab9fa5040 = {}));
var $4729d49089f76d33$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
    StorageAction["GetDataAccess"] = "8";
    StorageAction["ListCallerAccessGrants"] = "9";
})($4729d49089f76d33$export$d4f3c54b808b00ce || ($4729d49089f76d33$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $6b62b1aa6f3c24d2$export$83d89fbfd8236492 = "6.15.7";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $4ZL0H = parcelRequire("4ZL0H");
const $0127f3951c766f62$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $0127f3951c766f62$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $0127f3951c766f62$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $0127f3951c766f62$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $0127f3951c766f62$export$ba10401363d0f7f6 = ()=>{
    return typeof $4ZL0H !== "undefined";
};
const $0127f3951c766f62$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



var $4ZL0H = parcelRequire("4ZL0H");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $f56ddfeea9bb7bdd$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $0127f3951c766f62$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $f56ddfeea9bb7bdd$export$86269c582305790() {
    return (0, $0127f3951c766f62$export$ba10401363d0f7f6)() && typeof $4ZL0H.env !== "undefined" && !!Object.keys($4ZL0H.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $d512c338bd407ffb$export$d91d90d62b78936d() {
    return (0, $0127f3951c766f62$export$daba2802a1a41c1f)() && (0, $0127f3951c766f62$export$252f88727cff70c7)(window, "__VUE");
}
function $d512c338bd407ffb$export$257a4c0f8294a101() {
    return (0, $0127f3951c766f62$export$a15eed0e463030a9)() && (0, $0127f3951c766f62$export$252f88727cff70c7)($parcel$global, "__VUE");
}




var $4ZL0H = parcelRequire("4ZL0H");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $3f1603cbc749bbf7$export$6dafc32a94edaed3() {
    return (0, $0127f3951c766f62$export$daba2802a1a41c1f)() && (0, $0127f3951c766f62$export$252f88727cff70c7)(window, "__SVELTE");
}
function $3f1603cbc749bbf7$export$819dcb7fe144d8b0() {
    return (0, $0127f3951c766f62$export$ba10401363d0f7f6)() && typeof $4ZL0H.env !== "undefined" && !!Object.keys($4ZL0H.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $766378d609be3c0a$export$f8462bcf03110eff() {
    return (0, $0127f3951c766f62$export$daba2802a1a41c1f)() && window.next && typeof window.next === "object";
}
function $766378d609be3c0a$export$61c08ed144a5d4ca() {
    return (0, $0127f3951c766f62$export$a15eed0e463030a9)() && ((0, $0127f3951c766f62$export$252f88727cff70c7)($parcel$global, "__next") || (0, $0127f3951c766f62$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $6cbc9fb90bd25077$export$bed54a4e6d9d25fb() {
    return (0, $0127f3951c766f62$export$daba2802a1a41c1f)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $6cbc9fb90bd25077$export$fb3ce982948d27e8() {
    return (0, $0127f3951c766f62$export$a15eed0e463030a9)() && typeof $parcel$global.__NUXT_PATHS__ !== "undefined";
}




var $4ZL0H = parcelRequire("4ZL0H");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $0410ae7c0fdfa1f7$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $0127f3951c766f62$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean((0, $0127f3951c766f62$export$daba2802a1a41c1f)() && typeof window.ng !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $0410ae7c0fdfa1f7$export$8ab518c8987c870f() {
    var _undefined;
    return (0, $0127f3951c766f62$export$ba10401363d0f7f6)() && typeof $4ZL0H.env === "object" && ((_undefined = undefined) === null || _undefined === void 0 ? void 0 : _undefined.startsWith("ng ")) || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $81183ae85a282e14$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $82564107e23365c8$export$85fd46d5e29a4f7e() {
    return (0, $0127f3951c766f62$export$a15eed0e463030a9)() && typeof $parcel$global.expo !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $2a2068c24bf5461f$export$41b1270b988065fb() {
    return (0, $0127f3951c766f62$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $1f03c2d8e019c7ce$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $82564107e23365c8$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $81183ae85a282e14$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $766378d609be3c0a$export$f8462bcf03110eff)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $6cbc9fb90bd25077$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $0410ae7c0fdfa1f7$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).React,
        detectionMethod: (0, $f56ddfeea9bb7bdd$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $d512c338bd407ffb$export$d91d90d62b78936d)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $3f1603cbc749bbf7$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $2a2068c24bf5461f$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $766378d609be3c0a$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $6cbc9fb90bd25077$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $f56ddfeea9bb7bdd$export$86269c582305790)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $d512c338bd407ffb$export$257a4c0f8294a101)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $0410ae7c0fdfa1f7$export$8ab518c8987c870f)
    },
    {
        platform: (0, $4729d49089f76d33$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $3f1603cbc749bbf7$export$819dcb7fe144d8b0)
    }
];
function $1f03c2d8e019c7ce$export$17b446b869dad473() {
    var _detectionMap_find;
    return ((_detectionMap_find = $1f03c2d8e019c7ce$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())) === null || _detectionMap_find === void 0 ? void 0 : _detectionMap_find.platform) || (0, $4729d49089f76d33$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $9e107109beed680c$var$frameworkCache;
const $9e107109beed680c$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $9e107109beed680c$var$resetTriggered = false;
const $9e107109beed680c$var$SSR_RESET_TIMEOUT = 10; // ms
const $9e107109beed680c$var$WEB_RESET_TIMEOUT = 10; // ms
const $9e107109beed680c$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $9e107109beed680c$export$9ce73e459ec93b6a = ()=>{
    if (!$9e107109beed680c$var$frameworkCache) {
        var _frameworkChangeObservers_pop;
        $9e107109beed680c$var$frameworkCache = (0, $1f03c2d8e019c7ce$export$17b446b869dad473)();
        if ($9e107109beed680c$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($9e107109beed680c$export$d56891f33aa26edc.length)(_frameworkChangeObservers_pop = $9e107109beed680c$export$d56891f33aa26edc.pop()) === null || _frameworkChangeObservers_pop === void 0 ? void 0 : _frameworkChangeObservers_pop();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $9e107109beed680c$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $9e107109beed680c$var$resetTimeout((0, $4729d49089f76d33$export$638889172ebce0c4).ServerSideUnknown, $9e107109beed680c$var$SSR_RESET_TIMEOUT);
        $9e107109beed680c$var$resetTimeout((0, $4729d49089f76d33$export$638889172ebce0c4).WebUnknown, $9e107109beed680c$var$WEB_RESET_TIMEOUT);
    }
    return $9e107109beed680c$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $9e107109beed680c$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($9e107109beed680c$var$resetTriggered) return;
    $9e107109beed680c$export$d56891f33aa26edc.push(fcn);
};
function $9e107109beed680c$export$d2adf65b87e47523() {
    $9e107109beed680c$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $9e107109beed680c$var$resetTimeout(framework, delay) {
    if ($9e107109beed680c$var$frameworkCache === framework && !$9e107109beed680c$var$resetTriggered) setTimeout(()=>{
        $9e107109beed680c$export$d2adf65b87e47523();
        $9e107109beed680c$var$resetTriggered = true;
        setTimeout($9e107109beed680c$export$9ce73e459ec93b6a, $9e107109beed680c$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $14d135f75564c4c8$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $14d135f75564c4c8$export$20cd2fa9001e90da = (input)=>{
    var _customUserAgentState_input_category;
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $14d135f75564c4c8$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>{
        var _acc_api;
        return (0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [api]: {
                refCount: ((_acc_api = acc[api]) === null || _acc_api === void 0 ? void 0 : _acc_api.refCount) ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        });
    }, (_customUserAgentState_input_category = $14d135f75564c4c8$var$customUserAgentState[input.category]) !== null && _customUserAgentState_input_category !== void 0 ? _customUserAgentState_input_category : {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $14d135f75564c4c8$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $14d135f75564c4c8$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $14d135f75564c4c8$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($14d135f75564c4c8$var$customUserAgentState[input.category]).length) delete $14d135f75564c4c8$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $14d135f75564c4c8$export$e399dbcfd99a2928 = (category, api)=>{
    var _customUserAgentState_category_api, _customUserAgentState_category;
    return (_customUserAgentState_category = $14d135f75564c4c8$var$customUserAgentState[category]) === null || _customUserAgentState_category === void 0 ? void 0 : (_customUserAgentState_category_api = _customUserAgentState_category[api]) === null || _customUserAgentState_category_api === void 0 ? void 0 : _customUserAgentState_category_api.additionalDetails;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f9c71e6feadb5965$var$BASE_USER_AGENT = `aws-amplify`;
/** Sanitize Amplify version string be removing special character + and character post the special character  */ const $f9c71e6feadb5965$export$b8f78c57ec316f83 = (amplifyVersion)=>amplifyVersion.replace(/\+.*/, "");
class $f9c71e6feadb5965$var$PlatformBuilder {
    get framework() {
        return (0, $9e107109beed680c$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $4729d49089f76d33$export$638889172ebce0c4).ReactNative || this.framework === (0, $4729d49089f76d33$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $9e107109beed680c$export$5d5c467ce0b213f)(fcn);
    }
    constructor(){
        this.userAgent = `${$f9c71e6feadb5965$var$BASE_USER_AGENT}/${$f9c71e6feadb5965$export$b8f78c57ec316f83((0, $6b62b1aa6f3c24d2$export$83d89fbfd8236492))}`;
    }
}
const $f9c71e6feadb5965$export$2dffd0b5373a4389 = new $f9c71e6feadb5965$var$PlatformBuilder();
const $f9c71e6feadb5965$export$7d201307d8979e21 = ({ category: category, action: action } = {})=>{
    const userAgent = [
        [
            $f9c71e6feadb5965$var$BASE_USER_AGENT,
            $f9c71e6feadb5965$export$b8f78c57ec316f83((0, $6b62b1aa6f3c24d2$export$83d89fbfd8236492))
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $9e107109beed680c$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $14d135f75564c4c8$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $f9c71e6feadb5965$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $f9c71e6feadb5965$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $afc1a5b2025f5838$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers, statusCode: statusCode } = response;
    var _headers_xamznrequestid, _ref;
    return (0, $2qxEV._)((0, $9tqwB._)({}, $afc1a5b2025f5838$var$isMetadataBearer(response) ? response.$metadata : {}), {
        httpStatusCode: statusCode,
        requestId: (_ref = (_headers_xamznrequestid = headers["x-amzn-requestid"]) !== null && _headers_xamznrequestid !== void 0 ? _headers_xamznrequestid : headers["x-amzn-request-id"]) !== null && _ref !== void 0 ? _ref : headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    });
};
const $afc1a5b2025f5838$var$isMetadataBearer = (response)=>typeof (response === null || response === void 0 ? void 0 : response.$metadata) === "object";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $949cd593c14826d9$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $949cd593c14826d9$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    var _response_headers_xamznerrortype, _ref, _ref1;
    const code = sanitizeErrorCode((_ref1 = (_ref = (_response_headers_xamznerrortype = response.headers["x-amzn-errortype"]) !== null && _response_headers_xamznerrortype !== void 0 ? _response_headers_xamznerrortype : body.code) !== null && _ref !== void 0 ? _ref : body.__type) !== null && _ref1 !== void 0 ? _ref1 : "UnknownError");
    var _body_message, _ref2;
    const message = (_ref2 = (_body_message = body.message) !== null && _body_message !== void 0 ? _body_message : body.Message) !== null && _ref2 !== void 0 ? _ref2 : "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $afc1a5b2025f5838$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $949cd593c14826d9$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $afc1a5b2025f5838$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a service API handler that accepts input as defined shape and responds conforming to defined output shape.
 * A service API handler is composed with:
 * * A transfer handler
 * * A serializer function
 * * A deserializer function
 * * A default config object
 *
 * The returned service API handler, when called, will trigger the following workflow:
 * 1. When calling the service API handler function, the default config object is merged into the input config
 * object to assign the default values of some omitted configs, resulting to a resolved config object.
 * 2. The `endpointResolver` function from the default config object will be invoked with the resolved config object and
 * API input object resulting to an endpoint instance.
 * 3. The serializer function is invoked with API input object and the endpoint instance resulting to an HTTP request
 * instance.
 * 4. The HTTP request instance and the resolved config object is passed to the transfer handler function.
 * 5. The transfer handler function resolves to an HTTP response instance(can be either successful or failed status code).
 * 6. The deserializer function is invoked with the HTTP response instance resulting to the API output object, and
 * return to the caller.
 *
 *
 * @param transferHandler Async function for dispatching HTTP requests and returning HTTP response.
 * @param serializer  Async function for converting object in defined input shape into HTTP request targeting a given
 * 	endpoint.
 * @param deserializer Async function for converting HTTP response into output object in defined output shape, or error
 * 	shape.
 * @param defaultConfig  object containing default options to be consumed by transfer handler, serializer and
 *  deserializer.
 * @returns a async service API handler function that accepts a config object and input object in defined shape, returns
 * 	an output object in defined shape. It may also throw error instance in defined shape in deserializer. The config
 *  object type is composed with options type of transferHandler, endpointResolver function as well as endpointResolver
 *  function's input options type, region string. The config object property will be marked as optional if it's also
 * 	defined in defaultConfig.
 *
 * @internal
 */ 
var $9tqwB = parcelRequire("9tqwB");
const $ba93afffa4c7aaee$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = (0, $9tqwB._)({}, defaultConfig, config);
        // We need to allow different endpoints based on both given config(other than region) and input.
        // However for most of non-S3 services, region is the only input for endpoint resolver.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, (0, $9tqwB._)({}, resolvedConfig));
        return deserializer(response);
    };
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $75b6b7052e4a4881$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $1231b78083ca59bb$export$caea50bde345f648(maxDelayMs = (0, $75b6b7052e4a4881$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $45460adf2e861c89$export$75829a87374c6534 = 3;
const $45460adf2e861c89$export$ec2fb17ba97fe7ed = "amz-sdk-invocation-id";
const $45460adf2e861c89$export$d5da05c23e67fcde = "amz-sdk-request";
const $45460adf2e861c89$export$174c32b9a171db76 = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $589339b0e81d9df9$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $1231b78083ca59bb$export$caea50bde345f648)((0, $45460adf2e861c89$export$174c32b9a171db76));
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? (0, $45460adf2e861c89$export$174c32b9a171db76) : delay;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $6c5f3907de2be0d4$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $6c5f3907de2be0d4$export$7b87435661177a94 = (errorCode)=>!!errorCode && $6c5f3907de2be0d4$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $54d06369619ec70c$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        var _ref;
        const parsedError = (_ref = error !== null && error !== void 0 ? error : await errorParser(response)) !== null && _ref !== void 0 ? _ref : undefined;
        const errorCode = (parsedError === null || parsedError === void 0 ? void 0 : parsedError.code) || (parsedError === null || parsedError === void 0 ? void 0 : parsedError.name);
        const statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
        const isRetryable = $54d06369619ec70c$var$isConnectionError(error) || $54d06369619ec70c$var$isThrottlingError(statusCode, errorCode) || (0, $6c5f3907de2be0d4$export$7b87435661177a94)(errorCode) || $54d06369619ec70c$var$isServerSideError(statusCode, errorCode);
        return {
            retryable: isRetryable
        };
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $54d06369619ec70c$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $54d06369619ec70c$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $54d06369619ec70c$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $54d06369619ec70c$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $54d06369619ec70c$var$isConnectionError = (error)=>[
        (0, $81e4e4d475446781$export$4e712df6b850c8d0).NetworkError,
        // TODO(vNext): unify the error code `ERR_NETWORK` used by the Storage XHR handler
        "ERR_NETWORK"
    ].includes(error === null || error === void 0 ? void 0 : error.name);
const $54d06369619ec70c$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $54d06369619ec70c$var$TIMEOUT_ERROR_CODES.includes(errorCode);
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $ef8896933b96c20d$export$b8d936b6160bc3fa = "cognito-identity";
const $ef8896933b96c20d$export$22a3716e7860147a = {
    service: $ef8896933b96c20d$export$b8d936b6160bc3fa,
    retryDecider: (0, $54d06369619ec70c$export$b919d98317a7685f)((0, $949cd593c14826d9$export$be467dfcc0538e25)),
    computeDelay: (0, $589339b0e81d9df9$export$caea50bde345f648),
    cache: "no-store"
};





var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

/**
 * Middleware that executes the retry logic.
 */ const $f67cb4a44b7ed433$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = (0, $45460adf2e861c89$export$75829a87374c6534), retryDecider: retryDecider, computeDelay: computeDelay, abortSignal: abortSignal })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            var _context_attemptsCount;
            let attemptsCount = (_context_attemptsCount = context.attemptsCount) !== null && _context_attemptsCount !== void 0 ? _context_attemptsCount : 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $f67cb4a44b7ed433$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $f67cb4a44b7ed433$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                var _context_attemptsCount1, _context_attemptsCount2;
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = ((_context_attemptsCount1 = context.attemptsCount) !== null && _context_attemptsCount1 !== void 0 ? _context_attemptsCount1 : 0) > attemptsCount ? (_context_attemptsCount2 = context.attemptsCount) !== null && _context_attemptsCount2 !== void 0 ? _context_attemptsCount2 : 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                const { isCredentialsExpiredError: isCredentialsExpiredError, retryable: retryable } = await retryDecider(response, error, context);
                if (retryable) {
                    // Setting isCredentialsInvalid flag to notify signing middleware to forceRefresh credentials provider.
                    context.isCredentialsExpired = !!isCredentialsExpiredError;
                    if (!(abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $f67cb4a44b7ed433$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $f67cb4a44b7ed433$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener("abort", function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $f67cb4a44b7ed433$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    var _nextHandlerOutput_$metadata;
    nextHandlerOutput.$metadata = (0, $2qxEV._)((0, $9tqwB._)({}, (_nextHandlerOutput_$metadata = nextHandlerOutput.$metadata) !== null && _nextHandlerOutput_$metadata !== void 0 ? _nextHandlerOutput_$metadata : {}), {
        attempts: attempts
    });
};











const $b83a05369fc4016f$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b83a05369fc4016f$export$2e2bcd8739ae039 = {
    randomUUID: $b83a05369fc4016f$var$randomUUID
};


let $ec61a1849b6c4b62$var$getRandomValues;
const $ec61a1849b6c4b62$var$rnds8 = new Uint8Array(16);
function $ec61a1849b6c4b62$export$2e2bcd8739ae039() {
    if (!$ec61a1849b6c4b62$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $ec61a1849b6c4b62$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $ec61a1849b6c4b62$var$getRandomValues($ec61a1849b6c4b62$var$rnds8);
}


var $c4f2079b8dd7d9bb$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $73920a555f6999aa$var$validate(uuid) {
    return typeof uuid === "string" && (0, $c4f2079b8dd7d9bb$export$2e2bcd8739ae039).test(uuid);
}
var $73920a555f6999aa$export$2e2bcd8739ae039 = $73920a555f6999aa$var$validate;


const $754041286ef37781$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$754041286ef37781$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $754041286ef37781$export$8fb373d660548968(arr, offset = 0) {
    return ($754041286ef37781$var$byteToHex[arr[offset + 0]] + $754041286ef37781$var$byteToHex[arr[offset + 1]] + $754041286ef37781$var$byteToHex[arr[offset + 2]] + $754041286ef37781$var$byteToHex[arr[offset + 3]] + "-" + $754041286ef37781$var$byteToHex[arr[offset + 4]] + $754041286ef37781$var$byteToHex[arr[offset + 5]] + "-" + $754041286ef37781$var$byteToHex[arr[offset + 6]] + $754041286ef37781$var$byteToHex[arr[offset + 7]] + "-" + $754041286ef37781$var$byteToHex[arr[offset + 8]] + $754041286ef37781$var$byteToHex[arr[offset + 9]] + "-" + $754041286ef37781$var$byteToHex[arr[offset + 10]] + $754041286ef37781$var$byteToHex[arr[offset + 11]] + $754041286ef37781$var$byteToHex[arr[offset + 12]] + $754041286ef37781$var$byteToHex[arr[offset + 13]] + $754041286ef37781$var$byteToHex[arr[offset + 14]] + $754041286ef37781$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $754041286ef37781$var$stringify(arr, offset = 0) {
    const uuid = $754041286ef37781$export$8fb373d660548968(arr, offset);
    if (!(0, $73920a555f6999aa$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $754041286ef37781$export$2e2bcd8739ae039 = $754041286ef37781$var$stringify;


function $f56c3eee4596ef3b$var$v4(options, buf, offset) {
    var _options_rng;
    if ((0, $b83a05369fc4016f$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $b83a05369fc4016f$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    var _options_random, _ref;
    const rnds = (_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, $ec61a1849b6c4b62$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $754041286ef37781$export$8fb373d660548968)(rnds);
}
var $f56c3eee4596ef3b$export$2e2bcd8739ae039 = $f56c3eee4596ef3b$var$v4;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $16f58ed2e960448a$export$80bbb53510529a00 = (0, $f56c3eee4596ef3b$export$2e2bcd8739ae039);












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects a UUID string to `amz-sdk-invocation-id` header.
 * if the header is not set already. This header is helpful to provide
 * observability to group the requests caused by automatic retry.
 *
 * This middleware is standalone because of extra UUID dependency, we will
 * NOT use this middleware for API categories.
 *
 * Ref: https://sdk.amazonaws.com/kotlin/api/smithy-kotlin/api/1.0.9/http-client/aws.smithy.kotlin.runtime.http.operation/-http-operation-context/-sdk-invocation-id.html
 */ const $4d3d56ddbc999bc2$export$b0cced6a8201397f = ()=>(next)=>{
        return async function amzSdkInvocationIdHeaderMiddleware(request) {
            if (!request.headers[0, $45460adf2e861c89$export$ec2fb17ba97fe7ed]) request.headers[0, $45460adf2e861c89$export$ec2fb17ba97fe7ed] = (0, $16f58ed2e960448a$export$80bbb53510529a00)();
            return next(request);
        };
    };



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects `amz-sdk-request` header to indicate the retry state at the time an HTTP request is made.
 * This middleware should co-exist with retryMiddleware as it relies on the retryAttempts value in middleware context
 * set by the retry middleware.
 *
 * Example header: `amz-sdk-request: attempt=1; max=3`.
 *
 * This middleware is standalone because of extra headers may conflict with custom endpoint settings(e.g. CORS), we will
 * NOT use this middleware for API categories.
 */ const $b93871e1f26a7704$export$6550d5b3b0ddb1d5 = ({ maxAttempts: maxAttempts = (0, $45460adf2e861c89$export$75829a87374c6534) })=>(next, context)=>{
        return async function amzSdkRequestHeaderMiddleware(request) {
            var _context_attemptsCount;
            const attemptsCount = (_context_attemptsCount = context.attemptsCount) !== null && _context_attemptsCount !== void 0 ? _context_attemptsCount : 0;
            request.headers[0, $45460adf2e861c89$export$d5da05c23e67fcde] = `attempt=${attemptsCount + 1}; max=${maxAttempts}`;
            return next(request);
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $10d0c09cc61c9a0b$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent", userAgentValue: userAgentValue = "" })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $ca66079b8e9b8f15$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $8af53111b163c796$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c13272803b895f61$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $c13272803b895f61$export$d2573baf35521e4c = async ({ url: url, method: method, headers: headers, body: body }, { abortSignal: abortSignal, cache: cache, withCrossDomainCredentials: withCrossDomainCredentials })=>{
    var _resp_headers;
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $c13272803b895f61$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        if (e instanceof TypeError) throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
            name: (0, $81e4e4d475446781$export$4e712df6b850c8d0).NetworkError,
            message: "A network error has occurred.",
            underlyingError: e
        });
        throw e;
    }
    const responseHeaders = {};
    (_resp_headers = resp.headers) === null || _resp_headers === void 0 ? void 0 : _resp_headers.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    var _resp_body;
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign((_resp_body = resp.body) !== null && _resp_body !== void 0 ? _resp_body : {}, {
        text: (0, $8af53111b163c796$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $8af53111b163c796$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $8af53111b163c796$export$580ad1ce15092b15)(()=>resp.json())
    });
    return (0, $2qxEV._)((0, $9tqwB._)({}, httpResponse), {
        body: bodyWithMixin
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7e769647a00a64f7$export$ed7e1ccf00f39c4a = (0, $ca66079b8e9b8f15$export$f074d76e52925468)((0, $c13272803b895f61$export$d2573baf35521e4c), [
    (0, $10d0c09cc61c9a0b$export$ff28171a05413bc5),
    (0, $4d3d56ddbc999bc2$export$b0cced6a8201397f),
    (0, $f67cb4a44b7ed433$export$72f002d3da1a429f),
    (0, $b93871e1f26a7704$export$6550d5b3b0ddb1d5)
]);
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $ea555e7b3d2f525b$export$86e9249ea12798b8 = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $9975adbd32d7ce83$export$8029646671d2c482 = (0, $ca66079b8e9b8f15$export$f074d76e52925468)((0, $7e769647a00a64f7$export$ed7e1ccf00f39c4a), [
    (0, $ea555e7b3d2f525b$export$86e9249ea12798b8)
]);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $27427f7205a77893$export$c234d706564f344 = (operation)=>(input, endpoint)=>{
        const headers = $27427f7205a77893$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $27427f7205a77893$export$a692bdb7eb624f96(endpoint, headers, body);
    };
const $27427f7205a77893$var$getSharedHeaders = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
const $27427f7205a77893$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $331ed0832fe8fff1$export$5994eaf220022b69 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $9975adbd32d7ce83$export$8029646671d2c482), (0, $27427f7205a77893$export$c234d706564f344)("GetCredentialsForIdentity"), $331ed0832fe8fff1$var$getCredentialsForIdentityDeserializer, (0, $2qxEV._)((0, $9tqwB._)({}, (0, $ef8896933b96c20d$export$22a3716e7860147a), config), {
        userAgentValue: (0, $f9c71e6feadb5965$export$ede38edb26c0bfdf)()
    }));
const $331ed0832fe8fff1$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $949cd593c14826d9$export$be467dfcc0538e25)(response);
        throw error;
    }
    const body = await (0, $949cd593c14826d9$export$759bcb35b0d1bf81)(response);
    return {
        IdentityId: body.IdentityId,
        Credentials: $331ed0832fe8fff1$var$deserializeCredentials(body.Credentials),
        $metadata: (0, $afc1a5b2025f5838$export$978f9418fe0cb26c)(response)
    };
};
const $331ed0832fe8fff1$var$deserializeCredentials = (_param = {})=>{
    var { Expiration: Expiration } = _param, rest = (0, $bLhVg._)(_param, [
        "Expiration"
    ]);
    return (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
        Expiration: Expiration && new Date(Expiration * 1000)
    });
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fb45fae2ab4b72c3$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $fb45fae2ab4b72c3$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $fb45fae2ab4b72c3$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a8960aab2348443e$export$1e303d38dab7b376 = {
    convert (input, options) {
        let inputStr = input;
        // urlSafe character replacement options conform to the base64 url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#page-7
        if (options === null || options === void 0 ? void 0 : options.urlSafe) inputStr = inputStr.replace(/-/g, "+").replace(/_/g, "/");
        return (0, $fb45fae2ab4b72c3$export$ea737e7700106b27)()(inputStr);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1a3126fc0ddd4d4c$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message, recoverySuggestion: recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $20ffe852abb0b6a9$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($20ffe852abb0b6a9$export$7b5c8b570ea8407 || ($20ffe852abb0b6a9$export$7b5c8b570ea8407 = {}));
const $20ffe852abb0b6a9$var$authConfigurationErrorMap = {
    [$20ffe852abb0b6a9$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$20ffe852abb0b6a9$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$20ffe852abb0b6a9$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$20ffe852abb0b6a9$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$20ffe852abb0b6a9$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $20ffe852abb0b6a9$export$a7a9523472993e97 = (0, $1a3126fc0ddd4d4c$export$5cb8fc27ccbe9d40)($20ffe852abb0b6a9$var$authConfigurationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $00406059b8b03c2e$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $20ffe852abb0b6a9$export$a7a9523472993e97)(assertionValid, (0, $20ffe852abb0b6a9$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $00406059b8b03c2e$export$c13e6dbaf90a8e5f(cognitoConfig) {
    var _cognitoConfig_loginWith_oauth, _cognitoConfig_loginWith, _cognitoConfig_loginWith_oauth1, _cognitoConfig_loginWith1, _cognitoConfig_loginWith_oauth2, _cognitoConfig_loginWith2, _cognitoConfig_loginWith_oauth3, _cognitoConfig_loginWith3;
    const validOAuthConfig = !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth = _cognitoConfig_loginWith.oauth) === null || _cognitoConfig_loginWith_oauth === void 0 ? void 0 : _cognitoConfig_loginWith_oauth.domain) && !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith1 = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith1 === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth1 = _cognitoConfig_loginWith1.oauth) === null || _cognitoConfig_loginWith_oauth1 === void 0 ? void 0 : _cognitoConfig_loginWith_oauth1.redirectSignOut) && !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith2 = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith2 === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth2 = _cognitoConfig_loginWith2.oauth) === null || _cognitoConfig_loginWith_oauth2 === void 0 ? void 0 : _cognitoConfig_loginWith_oauth2.redirectSignIn) && !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : (_cognitoConfig_loginWith3 = cognitoConfig.loginWith) === null || _cognitoConfig_loginWith3 === void 0 ? void 0 : (_cognitoConfig_loginWith_oauth3 = _cognitoConfig_loginWith3.oauth) === null || _cognitoConfig_loginWith_oauth3 === void 0 ? void 0 : _cognitoConfig_loginWith_oauth3.responseType);
    (0, $20ffe852abb0b6a9$export$a7a9523472993e97)(validOAuthConfig, (0, $20ffe852abb0b6a9$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $00406059b8b03c2e$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!(cognitoConfig === null || cognitoConfig === void 0 ? void 0 : cognitoConfig.identityPoolId);
    (0, $20ffe852abb0b6a9$export$a7a9523472993e97)(validConfig, (0, $20ffe852abb0b6a9$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
/**
 * Decodes payload of JWT token
 *
 * @param {String} token A string representing a token to be decoded
 * @throws {@link Error} - Throws error when token is invalid or payload malformed.
 */ function $00406059b8b03c2e$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $a8960aab2348443e$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $e7e74a7b684b93e5$export$145273558d58e0ac extends (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $e7e74a7b684b93e5$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $e7e74a7b684b93e5$export$145273558d58e0ac.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $0c265cec5f502740$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $81e4e4d475446781$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9(userPoolId) {
    const region = userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $8a019f9f7f66e79b$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1b91ec72af99207f$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $1b91ec72af99207f$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $1b91ec72af99207f$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $1b91ec72af99207f$export$fe46a12932d2550a = "AutoSignInException";
const $1b91ec72af99207f$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $1b91ec72af99207f$export$a2095d473f418f40 = "InvalidAppSchemeException";
const $1b91ec72af99207f$export$818bb4aeac915442 = "InvalidPreferredRedirectUrlException";
const $1b91ec72af99207f$export$60b68b138a52e5ae = new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
    name: $1b91ec72af99207f$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $1b91ec72af99207f$export$c1829c2a0b9b2e21 = new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
    name: $1b91ec72af99207f$export$a2095d473f418f40,
    message: "A valid non-http app scheme was not found in the config.",
    recoverySuggestion: "Please make sure a valid custom app scheme is present in the config."
});
const $1b91ec72af99207f$export$41a56a70fc1a4962 = new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
    name: $1b91ec72af99207f$export$818bb4aeac915442,
    message: "The given preferredRedirectUrl does not match any items in the redirectSignOutUrls array from the config.",
    recoverySuggestion: "Please make sure a matching preferredRedirectUrl is provided."
});
const $1b91ec72af99207f$export$27ddc47447101bcf = "InvalidOriginException";
const $1b91ec72af99207f$export$c01b4acd6291e035 = new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
    name: $1b91ec72af99207f$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $1b91ec72af99207f$export$625255707e22459c = "OAuthSignOutException";
const $1b91ec72af99207f$export$a0a904daf48e2c33 = "TokenRefreshException";
const $1b91ec72af99207f$export$606cffc85964c24b = "UnexpectedSignInInterruptionException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $2cc7ae0cece9bbf8$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $2cc7ae0cece9bbf8$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $1b91ec72af99207f$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $2cc7ae0cece9bbf8$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $1b91ec72af99207f$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $2cc7ae0cece9bbf8$export$31fce2aaeafa4b60 = new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
    name: (0, $1b91ec72af99207f$export$a0a904daf48e2c33),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $2cc7ae0cece9bbf8$export$35cfa8cbd2d5bcdd = new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
    name: (0, $1b91ec72af99207f$export$d29d1996d6b6f5e3),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $2cc7ae0cece9bbf8$export$be38b2d22222d505(tokens) {
    if ($2cc7ae0cece9bbf8$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $2cc7ae0cece9bbf8$export$31fce2aaeafa4b60;
    if (!$2cc7ae0cece9bbf8$var$isAuthenticatedWithRefreshToken(tokens)) throw $2cc7ae0cece9bbf8$export$35cfa8cbd2d5bcdd;
}
function $2cc7ae0cece9bbf8$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $1b91ec72af99207f$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $2cc7ae0cece9bbf8$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $2cc7ae0cece9bbf8$var$isAuthenticated(tokens) {
    return (tokens === null || tokens === void 0 ? void 0 : tokens.accessToken) || (tokens === null || tokens === void 0 ? void 0 : tokens.idToken);
}
function $2cc7ae0cece9bbf8$var$isAuthenticatedWithRefreshToken(tokens) {
    return $2cc7ae0cece9bbf8$var$isAuthenticated(tokens) && (tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken);
}
function $2cc7ae0cece9bbf8$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $2cc7ae0cece9bbf8$var$isAuthenticated(tokens) && !(tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken);
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $2958bc96d886ca4a$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $2958bc96d886ca4a$export$d7c12af0c0f12206 = {
    partitions: [
        $2958bc96d886ca4a$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $3444ae0b84b1d698$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions } = (0, $2958bc96d886ca4a$export$d7c12af0c0f12206);
    for (const { regions: regions, outputs: outputs, regionRegex: regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $2958bc96d886ca4a$export$72f3cee421ee8a74).outputs.dnsSuffix;
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $351b20534a6078b4$export$beb82d9d9136c16e = URL;
const $351b20534a6078b4$export$4ea7bbdac595b5fb = URLSearchParams;












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $24fdb70b7a5a8390$export$562f22ddc5fcdb97 = ({ region: region })=>({
        url: new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(`https://${(0, $ef8896933b96c20d$export$b8d936b6160bc3fa)}.${region}.${(0, $3444ae0b84b1d698$export$1c28e37cdcc37f6d)(region)}`)
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4d181d4cdd5a4992$export$e67952c510717cd6 = ({ endpointOverride: endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(endpointOverride)
        };
        return (0, $24fdb70b7a5a8390$export$562f22ddc5fcdb97)(input);
    };



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");





















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $78909364cd5a2c17$export$4dec1d0c118e41c8 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $9975adbd32d7ce83$export$8029646671d2c482), (0, $27427f7205a77893$export$c234d706564f344)("GetId"), $78909364cd5a2c17$var$getIdDeserializer, (0, $2qxEV._)((0, $9tqwB._)({}, (0, $ef8896933b96c20d$export$22a3716e7860147a), config), {
        userAgentValue: (0, $f9c71e6feadb5965$export$ede38edb26c0bfdf)()
    }));
const $78909364cd5a2c17$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $949cd593c14826d9$export$be467dfcc0538e25)(response);
        throw error;
    }
    const body = await (0, $949cd593c14826d9$export$759bcb35b0d1bf81)(response);
    return {
        IdentityId: body.IdentityId,
        $metadata: (0, $afc1a5b2025f5838$export$978f9418fe0cb26c)(response)
    };
};










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $3aa65ea20048e9db$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $cb6e52e627683d49$export$7c3e576630d5e301({ tokens: tokens, authConfig: authConfig, identityIdStore: identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    const identityId = await identityIdStore.loadIdentityId();
    if (identityId) return identityId.id;
    const logins = (tokens === null || tokens === void 0 ? void 0 : tokens.idToken) ? (0, $3aa65ea20048e9db$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
    const generatedIdentityId = await $cb6e52e627683d49$var$generateIdentityId(logins, authConfig);
    // Store generated identityId
    identityIdStore.storeIdentityId({
        id: generatedIdentityId,
        type: tokens ? "primary" : "guest"
    });
    return generatedIdentityId;
}
async function $cb6e52e627683d49$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig === null || authConfig === void 0 ? void 0 : authConfig.identityPoolId;
    const region = (0, $8a019f9f7f66e79b$export$8fb32fba519c460)(identityPoolId);
    const getId = (0, $78909364cd5a2c17$export$4dec1d0c118e41c8)({
        endpointResolver: (0, $4d181d4cdd5a4992$export$e67952c510717cd6)({
            endpointOverride: authConfig.identityPoolEndpoint
        })
    });
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    let idResult;
    // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    try {
        idResult = (await getId({
            region: region
        }, {
            IdentityPoolId: identityPoolId,
            Logins: logins
        })).IdentityId;
    } catch (e) {
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(e);
        throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)(e);
    }
    if (!idResult) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $240a56019e0bf41d$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $240a56019e0bf41d$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $240a56019e0bf41d$export$be6550e37264dc26 {
    async clearCredentialsAndIdentityId() {
        $240a56019e0bf41d$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $240a56019e0bf41d$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens } = getCredentialsOptions;
        const { authConfig: authConfig } = getCredentialsOptions;
        try {
            (0, $00406059b8b03c2e$export$8a2f5318ea3215e3)(authConfig === null || authConfig === void 0 ? void 0 : authConfig.Cognito);
        } catch (e) {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $cb6e52e627683d49$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $2cc7ae0cece9bbf8$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        var _clientResult_Credentials, _clientResult_Credentials1;
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $240a56019e0bf41d$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $8a019f9f7f66e79b$export$8fb32fba519c460)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, $331ed0832fe8fff1$export$5994eaf220022b69)({
            endpointResolver: (0, $4d181d4cdd5a4992$export$e67952c510717cd6)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region: region
            }, {
                IdentityId: identityId
            });
        } catch (e) {
            (0, $0c265cec5f502740$export$5b3890f50cd4853f)(e);
            throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)(e);
        }
        if ((clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials = clientResult.Credentials) === null || _clientResult_Credentials === void 0 ? void 0 : _clientResult_Credentials.AccessKeyId) && (clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials1 = clientResult.Credentials) === null || _clientResult_Credentials1 === void 0 ? void 0 : _clientResult_Credentials1.SecretKey)) {
            this._nextCredentialsRefresh = new Date().getTime() + $240a56019e0bf41d$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = (0, $2qxEV._)((0, $9tqwB._)({}, res), {
                isAuthenticatedCreds: false
            });
            return res;
        } else throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        var _clientResult_Credentials, _clientResult_Credentials1;
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $240a56019e0bf41d$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $3aa65ea20048e9db$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $8a019f9f7f66e79b$export$8fb32fba519c460)(authConfig.identityPoolId);
        const getCredentialsForIdentity = (0, $331ed0832fe8fff1$export$5994eaf220022b69)({
            endpointResolver: (0, $4d181d4cdd5a4992$export$e67952c510717cd6)({
                endpointOverride: authConfig.identityPoolEndpoint
            })
        });
        let clientResult;
        try {
            clientResult = await getCredentialsForIdentity({
                region: region
            }, {
                IdentityId: identityId,
                Logins: logins
            });
        } catch (e) {
            (0, $0c265cec5f502740$export$5b3890f50cd4853f)(e);
            throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)(e);
        }
        if ((clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials = clientResult.Credentials) === null || _clientResult_Credentials === void 0 ? void 0 : _clientResult_Credentials.AccessKeyId) && (clientResult === null || clientResult === void 0 ? void 0 : (_clientResult_Credentials1 = clientResult.Credentials) === null || _clientResult_Credentials1 === void 0 ? void 0 : _clientResult_Credentials1.SecretKey)) {
            var _authTokens_idToken;
            this._nextCredentialsRefresh = new Date().getTime() + $240a56019e0bf41d$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            if (clientResult.IdentityId) {
                res.identityId = clientResult.IdentityId;
                // note: the following call removes guest identityId from the persistent store (localStorage)
                this._identityIdStore.storeIdentityId({
                    id: clientResult.IdentityId,
                    type: "primary"
                });
            }
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = (0, $2qxEV._)((0, $9tqwB._)({}, res), {
                isAuthenticatedCreds: true,
                associatedIdToken: (_authTokens_idToken = authTokens.idToken) === null || _authTokens_idToken === void 0 ? void 0 : _authTokens_idToken.toString()
            });
            return res;
        } else throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        var _this__credentialsAndIdentityId, _tokens_idToken;
        return !!tokens && !!((_this__credentialsAndIdentityId = this._credentialsAndIdentityId) === null || _this__credentialsAndIdentityId === void 0 ? void 0 : _this__credentialsAndIdentityId.associatedIdToken) && ((_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.toString()) !== this._credentialsAndIdentityId.associatedIdToken;
    }
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
}





var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


const $cc868e87d279537e$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails",
    oauthMetadata: "oauthMetadata"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $858bdd2a8b4c9915$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($858bdd2a8b4c9915$export$cc5909720f29144 || ($858bdd2a8b4c9915$export$cc5909720f29144 = {}));
const $858bdd2a8b4c9915$var$tokenValidationErrorMap = {
    [$858bdd2a8b4c9915$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $858bdd2a8b4c9915$export$a7a9523472993e97 = (0, $1a3126fc0ddd4d4c$export$5cb8fc27ccbe9d40)($858bdd2a8b4c9915$var$tokenValidationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a4ad04f3855b541e$export$2c8f6d7ed1534551 = "CognitoIdentityServiceProvider";


class $381fd8e89a110cc5$export$a36be852d43d512 {
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(itString) : undefined;
            var _ref;
            const refreshToken = (_ref = await this.getKeyValueStorage().getItem(authKeys.refreshToken)) !== null && _ref !== void 0 ? _ref : undefined;
            var _ref1;
            const clockDriftString = (_ref1 = await this.getKeyValueStorage().getItem(authKeys.clockDrift)) !== null && _ref1 !== void 0 ? _ref1 : "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            var _ref2;
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: (_ref2 = await this.getDeviceMetadata()) !== null && _ref2 !== void 0 ? _ref2 : undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $858bdd2a8b4c9915$export$a7a9523472993e97)(tokens !== undefined, (0, $858bdd2a8b4c9915$export$cc5909720f29144).InvalidAuthTokens);
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        else await this.getKeyValueStorage().removeItem(authKeys.idToken);
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        else await this.getKeyValueStorage().removeItem(authKeys.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        else await this.getKeyValueStorage().removeItem(authKeys.signInDetails);
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey()),
            this.getKeyValueStorage().removeItem(authKeys.oauthMetadata)
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        var _this_authConfig;
        (0, $00406059b8b03c2e$export$80c92581e59ed502)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        const lastAuthUser = username !== null && username !== void 0 ? username : await this.getLastAuthUser();
        return $381fd8e89a110cc5$export$4647c72f6828a74d((0, $a4ad04f3855b541e$export$2c8f6d7ed1534551), `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        var _this_authConfig;
        (0, $00406059b8b03c2e$export$80c92581e59ed502)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${0, $a4ad04f3855b541e$export$2c8f6d7ed1534551}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        var _ref;
        const lastAuthUser = (_ref = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey())) !== null && _ref !== void 0 ? _ref : "username";
        return lastAuthUser;
    }
    async setOAuthMetadata(metadata) {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(oauthMetadataKey, JSON.stringify(metadata));
    }
    async getOAuthMetadata() {
        const { oauthMetadata: oauthMetadataKey } = await this.getAuthKeys();
        const oauthMetadata = await this.getKeyValueStorage().getItem(oauthMetadataKey);
        return oauthMetadata && JSON.parse(oauthMetadata);
    }
}
const $381fd8e89a110cc5$export$4647c72f6828a74d = (provider, identifier)=>{
    return $381fd8e89a110cc5$export$dfb8da757ca62eed((0, $cc868e87d279537e$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $381fd8e89a110cc5$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values((0, $9tqwB._)({}, authKeys));
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $be747de3bd8d51e9$export$dad1700b96c3a835 = {
    identityId: "identityId"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $78c6c086254cb579$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $78c6c086254cb579$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $00406059b8b03c2e$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $78c6c086254cb579$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
    }
    async loadIdentityId() {
        var _this_authConfig;
        (0, $00406059b8b03c2e$export$8a2f5318ea3215e3)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) {
                    this._hasGuestIdentityId = true;
                    return {
                        id: storedIdentityId,
                        type: "guest"
                    };
                }
                return null;
            }
        } catch (err) {
            $78c6c086254cb579$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        var _this_authConfig;
        (0, $00406059b8b03c2e$export$8a2f5318ea3215e3)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
            this._hasGuestIdentityId = true;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            if (this._hasGuestIdentityId) {
                this.keyValueStorage.removeItem(this._authKeys.identityId);
                this._hasGuestIdentityId = false;
            }
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this._hasGuestIdentityId = false;
        this.keyValueStorage = keyValueStorage;
    }
}
const $78c6c086254cb579$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $381fd8e89a110cc5$export$dfb8da757ca62eed)((0, $be747de3bd8d51e9$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $e3b846c3acf996b0$export$be43b753aec531e2 = new (0, $240a56019e0bf41d$export$be6550e37264dc26)(new (0, $78c6c086254cb579$export$3e97b78667a539a0)((0, $6dd46fc26844509a$export$586b30dcaeecb901)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $e18c274af701d28e$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $eaa97c94b62ec718$export$a0efffb4b0c72e04 = "cognito-idp";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7bee8fcf111a7841$export$54dd9d9496cb66b9 = ({ region: region })=>({
        url: new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(`https://${(0, $eaa97c94b62ec718$export$a0efffb4b0c72e04)}.${region}.${(0, $3444ae0b84b1d698$export$1c28e37cdcc37f6d)(region)}`)
    });


const $de38942cd6e4d1e5$export$9fc8f7dceefe00a6 = ({ endpointOverride: endpointOverride })=>(input)=>{
        if (endpointOverride) return {
            url: new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(endpointOverride)
        };
        return (0, $7bee8fcf111a7841$export$54dd9d9496cb66b9)(input);
    };








var $9tqwB = parcelRequire("9tqwB");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f30d53cc42dcd5e7$export$1113413e6e842bef = (operation)=>(input, endpoint)=>{
        const headers = $f30d53cc42dcd5e7$var$getSharedHeaders(operation);
        const body = JSON.stringify(input);
        return $f30d53cc42dcd5e7$var$buildHttpRpcRequest(endpoint, headers, body);
    };
const $f30d53cc42dcd5e7$var$getSharedHeaders = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
const $f30d53cc42dcd5e7$var$buildHttpRpcRequest = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8d396b19990d0ed2$export$8159795418a3e796 = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $949cd593c14826d9$export$be467dfcc0538e25)(response);
            (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
            throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
                name: error.name,
                message: error.message,
                metadata: error.$metadata
            });
        }
        return (0, $949cd593c14826d9$export$759bcb35b0d1bf81)(response);
    };






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $095d718f318a1d01$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $095d718f318a1d01$export$10f11e95d7a96f7b = (0, $ca66079b8e9b8f15$export$f074d76e52925468)((0, $7e769647a00a64f7$export$ed7e1ccf00f39c4a), [
    $095d718f318a1d01$var$disableCacheMiddlewareFactory
]);





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $529584b3e3a83558$export$22a3716e7860147a = {
    service: (0, $eaa97c94b62ec718$export$a0efffb4b0c72e04),
    retryDecider: (0, $54d06369619ec70c$export$b919d98317a7685f)((0, $949cd593c14826d9$export$be467dfcc0538e25)),
    computeDelay: (0, $589339b0e81d9df9$export$caea50bde345f648),
    get userAgentValue () {
        return (0, $f9c71e6feadb5965$export$ede38edb26c0bfdf)();
    },
    cache: "no-store"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e5d091b0fed9ab49$export$fd10af15e909e7b5 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("GetTokensFromRefreshToken"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2e89c2d60574a72a$var$refreshAuthTokensFunction = async ({ tokens: tokens, authConfig: authConfig, username: username })=>{
    var _tokens_deviceMetadata;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig === null || authConfig === void 0 ? void 0 : authConfig.Cognito);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig.Cognito;
    const region = (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId);
    (0, $2cc7ae0cece9bbf8$export$be38b2d22222d505)(tokens);
    const getTokensFromRefreshToken = (0, $e5d091b0fed9ab49$export$fd10af15e909e7b5)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { AuthenticationResult: AuthenticationResult } = await getTokensFromRefreshToken({
        region: region
    }, {
        ClientId: userPoolClientId,
        RefreshToken: tokens.refreshToken,
        DeviceKey: (_tokens_deviceMetadata = tokens.deviceMetadata) === null || _tokens_deviceMetadata === void 0 ? void 0 : _tokens_deviceMetadata.deviceKey
    });
    var _AuthenticationResult_AccessToken;
    const accessToken = (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)((_AuthenticationResult_AccessToken = AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.AccessToken) !== null && _AuthenticationResult_AccessToken !== void 0 ? _AuthenticationResult_AccessToken : "");
    const idToken = (AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.IdToken) ? (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    var _AuthenticationResult_RefreshToken;
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: (_AuthenticationResult_RefreshToken = AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.RefreshToken) !== null && _AuthenticationResult_RefreshToken !== void 0 ? _AuthenticationResult_RefreshToken : tokens.refreshToken,
        username: username
    };
};
const $2e89c2d60574a72a$export$ab413c2cb4a135d9 = (0, $e18c274af701d28e$export$cd8d22e3dc00ae5a)($2e89c2d60574a72a$var$refreshAuthTokensFunction);
const $2e89c2d60574a72a$export$d5c14381105da273 = $2e89c2d60574a72a$var$refreshAuthTokensFunction;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f03cf65cfc38a977$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $4ccc6448d80e32fa$export$b007d77a962aa175({ expiresAt: expiresAt, clockDrift: clockDrift, tolerance: tolerance = 5000 }) {
    const currentTime = Date.now();
    return currentTime + clockDrift + tolerance > expiresAt;
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $51101f22196944be$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $51101f22196944be$var$name = "CognitoIdentityServiceProvider";
class $51101f22196944be$export$9b2cef5d94f9b6e8 {
    async clearOAuthInflightData() {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($51101f22196944be$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        var _this;
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($51101f22196944be$var$V5_HOSTED_UI_KEY);
        var _split;
        const [isOAuthSignIn, preferPrivateSession] = (_split = (_this = await this.keyValueStorage.getItem(authKeys.oauthSignIn)) === null || _this === void 0 ? void 0 : _this.split(",")) !== null && _split !== void 0 ? _split : [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $51101f22196944be$var$createKeysForAuthStorage($51101f22196944be$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
}
const $51101f22196944be$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $381fd8e89a110cc5$export$dfb8da757ca62eed)((0, $2cc7ae0cece9bbf8$export$3820b4ff343394ea))(provider, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c735b702f9f18cc5$export$2ed0ec267eb6cb1c = new (0, $51101f22196944be$export$9b2cef5d94f9b6e8)((0, $6dd46fc26844509a$export$586b30dcaeecb901));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $226a063d0e4c5dea$var$inflightPromises = [];
const $226a063d0e4c5dea$export$c55b09e0e9be0d04 = (resolver)=>{
    $226a063d0e4c5dea$var$inflightPromises.push(resolver);
};
const $226a063d0e4c5dea$export$bcb0b7a105a5df59 = ()=>{
    var _inflightPromises_pop;
    while($226a063d0e4c5dea$var$inflightPromises.length)(_inflightPromises_pop = $226a063d0e4c5dea$var$inflightPromises.pop()) === null || _inflightPromises_pop === void 0 ? void 0 : _inflightPromises_pop();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d08966a42ada48ad$export$ba2f3fbc8979d2e6 {
    setAuthConfig(authConfig) {
        (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        var _tokens_idToken_payload, _tokens_idToken, _tokens_accessToken_payload, _tokens_accessToken;
        let tokens;
        try {
            var _this_authConfig;
            (0, $00406059b8b03c2e$export$80c92581e59ed502)((_this_authConfig = this.authConfig) === null || _this_authConfig === void 0 ? void 0 : _this_authConfig.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        var _tokens_idToken_payload_exp, _tokens_clockDrift;
        const idTokenExpired = !!(tokens === null || tokens === void 0 ? void 0 : tokens.idToken) && (0, $4ccc6448d80e32fa$export$b007d77a962aa175)({
            expiresAt: ((_tokens_idToken_payload_exp = (_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : (_tokens_idToken_payload = _tokens_idToken.payload) === null || _tokens_idToken_payload === void 0 ? void 0 : _tokens_idToken_payload.exp) !== null && _tokens_idToken_payload_exp !== void 0 ? _tokens_idToken_payload_exp : 0) * 1000,
            clockDrift: (_tokens_clockDrift = tokens.clockDrift) !== null && _tokens_clockDrift !== void 0 ? _tokens_clockDrift : 0
        });
        var _tokens_accessToken_payload_exp, _tokens_clockDrift1;
        const accessTokenExpired = (0, $4ccc6448d80e32fa$export$b007d77a962aa175)({
            expiresAt: ((_tokens_accessToken_payload_exp = (_tokens_accessToken = tokens.accessToken) === null || _tokens_accessToken === void 0 ? void 0 : (_tokens_accessToken_payload = _tokens_accessToken.payload) === null || _tokens_accessToken_payload === void 0 ? void 0 : _tokens_accessToken_payload.exp) !== null && _tokens_accessToken_payload_exp !== void 0 ? _tokens_accessToken_payload_exp : 0) * 1000,
            clockDrift: (_tokens_clockDrift1 = tokens.clockDrift) !== null && _tokens_clockDrift1 !== void 0 ? _tokens_clockDrift1 : 0
        });
        if ((options === null || options === void 0 ? void 0 : options.forceRefresh) || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens === null || tokens === void 0 ? void 0 : tokens.accessToken,
            idToken: tokens === null || tokens === void 0 ? void 0 : tokens.idToken,
            signInDetails: tokens === null || tokens === void 0 ? void 0 : tokens.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens, username: username }) {
        try {
            const { signInDetails: signInDetails } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(err);
        if (err.name !== (0, $81e4e4d475446781$export$4e712df6b850c8d0).NetworkError) // TODO(v6): Check errors on client
        this.clearTokens();
        (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    async setTokens({ tokens: tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
    setOAuthMetadata(metadata) {
        return this.getTokenStore().setOAuthMetadata(metadata);
    }
    getOAuthMetadata() {
        return this.getTokenStore().getOAuthMetadata();
    }
    constructor(){
        this.waitForInflightOAuth = (0, $f03cf65cfc38a977$export$4e09c449d6c407f7)() ? async ()=>{
            if (!await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $226a063d0e4c5dea$export$c55b09e0e9be0d04)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $953e49b43dd04f89$export$85b743bbda58cb6c {
    getTokens({ forceRefresh: forceRefresh } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
    constructor(){
        this.authTokenStore = new (0, $381fd8e89a110cc5$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $6dd46fc26844509a$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $d08966a42ada48ad$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $2e89c2d60574a72a$export$ab413c2cb4a135d9));
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $10e1902ea767432f$export$18e158b80aac31a7 = new (0, $953e49b43dd04f89$export$85b743bbda58cb6c)();
const { tokenOrchestrator: $10e1902ea767432f$export$66561e66d62991d0 } = $10e1902ea767432f$export$18e158b80aac31a7;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9d67c923c60ce67d$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $fefcb3235338ed7e$export$f101a69cd6dc6202)(resourceConfig);
        const cookieBasedKeyValueStorage = new (0, $b83a7503689e94ae$export$dae7d845015939d5)({
            sameSite: "lax"
        });
        const resolvedKeyValueStorage = (libraryOptions === null || libraryOptions === void 0 ? void 0 : libraryOptions.ssr) ? cookieBasedKeyValueStorage : (0, $6dd46fc26844509a$export$586b30dcaeecb901);
        const resolvedCredentialsProvider = (libraryOptions === null || libraryOptions === void 0 ? void 0 : libraryOptions.ssr) ? new (0, $240a56019e0bf41d$export$be6550e37264dc26)(new (0, $78c6c086254cb579$export$3e97b78667a539a0)(cookieBasedKeyValueStorage)) : (0, $e3b846c3acf996b0$export$be43b753aec531e2);
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) {
            (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions === null || libraryOptions === void 0 ? void 0 : libraryOptions.Auth) {
            (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $f4c06b47af4364f4$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $10e1902ea767432f$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $10e1902ea767432f$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            resolvedKeyValueStorage);
            (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).configure(resolvedResourceConfig, (0, $2qxEV._)((0, $9tqwB._)({}, libraryOptions), {
                Auth: {
                    tokenProvider: (0, $10e1902ea767432f$export$18e158b80aac31a7),
                    credentialsProvider: resolvedCredentialsProvider
                }
            }));
            return;
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            const authLibraryOptions = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).libraryOptions.Auth;
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) {
                (0, $10e1902ea767432f$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
                resolvedKeyValueStorage);
                authLibraryOptions.credentialsProvider = resolvedCredentialsProvider;
            }
            (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).configure(resolvedResourceConfig, (0, $9tqwB._)({
                Auth: authLibraryOptions
            }, libraryOptions));
            return;
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig();
    }
};



parcelRequire("fw0lo");
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
"use strict";

var $fw0lo = parcelRequire("fw0lo");
var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $fw0lo.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $fw0lo.hydrateRoot;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hL6ll = parcelRequire("hL6ll");
var $4124aa6d0b2d559b$exports = {};
"use strict";

$4124aa6d0b2d559b$exports = (parcelRequire("1gT5S"));



var $fw0lo = parcelRequire("fw0lo");


var $fw0lo = parcelRequire("fw0lo");
// Default to a dummy "batch" implementation that just runs the callback
function $147b54102b881a3c$var$defaultNoopBatch(callback) {
    callback();
}
let $147b54102b881a3c$var$batch = $147b54102b881a3c$var$defaultNoopBatch; // Allow injecting another batching function later
const $147b54102b881a3c$export$4b9874722d0da7bc = (newBatch)=>$147b54102b881a3c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $147b54102b881a3c$export$fc47d4c0ba3bd2c6 = ()=>$147b54102b881a3c$var$batch;



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $fa3c487c4b27a9d1$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
var $fa3c487c4b27a9d1$export$2e2bcd8739ae039 = $fa3c487c4b27a9d1$export$cc80c08dc91f1c00;


function $544fc39e75452adc$export$c1275ca9a6fd3ec5() {
    const contextValue = (0, $7fPBF.useContext)((0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00));
    return contextValue;
}



const $e2bbd6ac3b57d70d$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $51238fa605392ada$var$useSyncExternalStoreWithSelector = (0, $e2bbd6ac3b57d70d$export$20656a4825650bd0);
const $51238fa605392ada$export$e2e6e3f3f3b782e3 = (fn)=>{
    $51238fa605392ada$var$useSyncExternalStoreWithSelector = fn;
};
const $51238fa605392ada$var$refEquality = (a, b)=>a === b;
function $51238fa605392ada$export$2b53f90d2bd1cbfb(context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) ? (0, $544fc39e75452adc$export$c1275ca9a6fd3ec5) : ()=>(0, $7fPBF.useContext)(context);
    return function useSelector(selector, equalityFn = $51238fa605392ada$var$refEquality) {
        const { store: store, subscription: subscription, getServerState: getServerState } = useReduxContext();
        const selectedState = $51238fa605392ada$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
        (0, $7fPBF.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $51238fa605392ada$export$2105062e25df4afe = /*#__PURE__*/ $51238fa605392ada$export$2b53f90d2bd1cbfb();


function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}


function $939dffaddf93a85b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $63fc9407ef8fcdfe$exports = {};
"use strict";
var $dddaf6f84c717660$exports = {};
"use strict";

$dddaf6f84c717660$exports = (parcelRequire("45MkT"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dddaf6f84c717660$exports.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dddaf6f84c717660$exports.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component["$$typeof"]] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$63fc9407ef8fcdfe$exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;



var $7fPBF = parcelRequire("7fPBF");
var $16afbf7b1c97f0da$exports = {};
"use strict";

$16afbf7b1c97f0da$exports = (parcelRequire("awO3n"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $0cc3d3c991995d47$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $8c6c3df6a794a93c$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $0cc3d3c991995d47$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $8c6c3df6a794a93c$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $8c6c3df6a794a93c$var$verify(mapStateToProps, "mapStateToProps");
    $8c6c3df6a794a93c$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $8c6c3df6a794a93c$var$verify(mergeProps, "mergeProps");
}


const $50fa2eeb6771037b$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $50fa2eeb6771037b$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $50fa2eeb6771037b$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $50fa2eeb6771037b$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $50fa2eeb6771037b$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $c5241bafb2d740a2$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ea00bd81b65af2c1$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $70dd520dd4a0a28d$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $ea00bd81b65af2c1$export$2e2bcd8739ae039)(value)) (0, $0cc3d3c991995d47$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $ba16cca5bcca8350$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $ba16cca5bcca8350$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $ba16cca5bcca8350$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $ba16cca5bcca8350$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $ba16cca5bcca8350$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $70a95a0dca64b0aa$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $ebb95f59f9a03d77$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $ba16cca5bcca8350$export$710f7c60f68acd3e)((dispatch)=>(0, $c5241bafb2d740a2$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $ba16cca5bcca8350$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $ba16cca5bcca8350$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $70a95a0dca64b0aa$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $4f0cafcf2cdd26e7$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $ba16cca5bcca8350$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $ba16cca5bcca8350$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $70a95a0dca64b0aa$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $37149b3dce38b811$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $37149b3dce38b811$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $37149b3dce38b811$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$37149b3dce38b811$export$691c327fc30bc857 : typeof mergeProps === "function" ? $37149b3dce38b811$export$5b105939c84b5234(mergeProps) : (0, $70a95a0dca64b0aa$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $5c0c0e9f3b5cd1de$var$createListenerCollection() {
    const batch = (0, $147b54102b881a3c$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $5c0c0e9f3b5cd1de$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $5c0c0e9f3b5cd1de$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $5c0c0e9f3b5cd1de$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $5c0c0e9f3b5cd1de$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $7fPBF = parcelRequire("7fPBF");
const $18a1784061377be5$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $18a1784061377be5$export$700979bc83e7db82 = $18a1784061377be5$export$71594e8a50f746f4 ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


function $3b08520b369c7e04$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $3b08520b369c7e04$export$2e2bcd8739ae039(objA, objB) {
    if ($3b08520b369c7e04$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$3b08520b369c7e04$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $b3506cedc5494ad7$var$_excluded = [
    "reactReduxForwardedRef"
];
let $b3506cedc5494ad7$var$useSyncExternalStore = (0, $e2bbd6ac3b57d70d$export$20656a4825650bd0);
const $b3506cedc5494ad7$export$36d45daa6a4925b8 = (fn)=>{
    $b3506cedc5494ad7$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $b3506cedc5494ad7$var$EMPTY_ARRAY = [
    null,
    0
];
const $b3506cedc5494ad7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $b3506cedc5494ad7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $b3506cedc5494ad7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $18a1784061377be5$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $b3506cedc5494ad7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $b3506cedc5494ad7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $b3506cedc5494ad7$var$initStateUpdates = ()=>$b3506cedc5494ad7$var$EMPTY_ARRAY;
function $b3506cedc5494ad7$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $b3506cedc5494ad7$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $b3506cedc5494ad7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $b3506cedc5494ad7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $3b08520b369c7e04$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $3b08520b369c7e04$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $3b08520b369c7e04$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $4f0cafcf2cdd26e7$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $ebb95f59f9a03d77$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $37149b3dce38b811$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, $7fPBF.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(props, $b3506cedc5494ad7$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, $7fPBF.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $16afbf7b1c97f0da$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, $7fPBF.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, $7fPBF.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $50fa2eeb6771037b$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, $7fPBF.useMemo)(()=>{
                if (!shouldHandleStateChanges) return $b3506cedc5494ad7$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, $7fPBF.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, $7fPBF.useRef)();
            const lastWrapperProps = (0, $7fPBF.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, $7fPBF.useRef)();
            const renderIsScheduled = (0, $7fPBF.useRef)(false);
            const isProcessingDispatch = (0, $7fPBF.useRef)(false);
            const isMounted = (0, $7fPBF.useRef)(false);
            const latestSubscriptionCallbackError = (0, $7fPBF.useRef)();
            (0, $18a1784061377be5$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, $7fPBF.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, $7fPBF.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $b3506cedc5494ad7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $b3506cedc5494ad7$var$useIsomorphicLayoutEffectWithArgs($b3506cedc5494ad7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $b3506cedc5494ad7$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $18a1784061377be5$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, $7fPBF.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, $7fPBF.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Connect, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $b3506cedc5494ad7$export$2e2bcd8739ae039 = $b3506cedc5494ad7$var$connect;



var $7fPBF = parcelRequire("7fPBF");



function $4c848518e85f237d$var$Provider({ store: store, context: context, children: children, serverState: serverState }) {
    const contextValue = (0, $7fPBF.useMemo)(()=>{
        const subscription = (0, $5c0c0e9f3b5cd1de$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined
        };
    }, [
        store,
        serverState
    ]);
    const previousState = (0, $7fPBF.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, $18a1784061377be5$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $4c848518e85f237d$export$2e2bcd8739ae039 = $4c848518e85f237d$var$Provider;






var $7fPBF = parcelRequire("7fPBF");


function $65c1702f92c91515$export$671dba69185d0304(context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) ? (0, $544fc39e75452adc$export$c1275ca9a6fd3ec5) : ()=>(0, $7fPBF.useContext)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $65c1702f92c91515$export$6ccbb43953eebf8 = /*#__PURE__*/ $65c1702f92c91515$export$671dba69185d0304();


function $0503a2a6eb4cf13a$export$bc9b55530897c558(context = (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $fa3c487c4b27a9d1$export$cc80c08dc91f1c00) ? (0, $65c1702f92c91515$export$6ccbb43953eebf8) : (0, $65c1702f92c91515$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $0503a2a6eb4cf13a$export$8ad76b76a4c905f8 = /*#__PURE__*/ $0503a2a6eb4cf13a$export$bc9b55530897c558();









(0, $51238fa605392ada$export$e2e6e3f3f3b782e3)((0, $4124aa6d0b2d559b$exports.useSyncExternalStoreWithSelector));
(0, $b3506cedc5494ad7$export$36d45daa6a4925b8)((0, $hL6ll.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $147b54102b881a3c$export$4b9874722d0da7bc)((0, $fw0lo.unstable_batchedUpdates));


// see .env.<env-name> files to configure those variables
const $dd7c185588f01129$var$isLocalhost = Boolean(window.location.hostname === "localhost" || window.location.hostname === "[::1]" || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
const $dd7c185588f01129$var$redirectSignIn = [
    "http://localhost:3000/callback/",
    "https://monestry.de/callback/"
].filter(Boolean);
const $dd7c185588f01129$var$redirectSignOut = [
    "http://localhost:3000/",
    "https://monestry.de/callback/"
].filter(Boolean);
const $dd7c185588f01129$var$AMPLIFY_CONFIG = {
    Auth: {
        Cognito: {
            userPoolId: "eu-central-1_8fuw7DSci",
            userPoolClientId: "3u6lltr3nl6eefdtrmq42pspd0",
            loginWith: {
                username: true,
                oauth: {
                    domain: "monestry.auth.eu-central-1.amazoncognito.com",
                    scopes: [
                        "email",
                        "openid",
                        "aws.cognito.signin.user.admin"
                    ],
                    redirectSignIn: $dd7c185588f01129$var$redirectSignIn,
                    redirectSignOut: $dd7c185588f01129$var$redirectSignOut,
                    responseType: "code"
                }
            }
        }
    },
    API: {
        REST: {
            myAPI: {
                endpoint: "https://api.monestry.de/",
                region: "eu-central-1"
            },
            ECB: {
                endpoint: "https://data-api.ecb.europa.eu/service/data/EXR/"
            }
        }
    }
};
var $dd7c185588f01129$export$2e2bcd8739ae039 = $dd7c185588f01129$var$AMPLIFY_CONFIG;


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/prop-types */ /* eslint-disable react/no-unstable-nested-components */ /* eslint-disable object-curly-newline */ 

var $7fPBF = parcelRequire("7fPBF");
/**
 * React Router DOM v6.8.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @remix-run/router v1.3.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        $55100129ab36ed65$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$f5708dca728d7177(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$f5708dca728d7177(!allIds.has(id), 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, {
                id: id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, {
                id: id,
                children: route.children ? $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $55100129ab36ed65$var$safelyDecodeURI(pathname));
    return matches;
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$f5708dca728d7177(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:\w+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$491112666e282270(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    return path.replace(/^:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : param;
        if (param == null) $55100129ab36ed65$export$f5708dca728d7177(false, 'Missing ":' + key + '" param');
        return param;
    }).replace(/\/:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : "/" + param;
        if (param == null) $55100129ab36ed65$export$f5708dca728d7177(false, 'Missing ":' + key + '" param');
        return "/" + param;
    }) // Remove any optional markers from optional static segments
    .replace(/\?/g, "").replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $55100129ab36ed65$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $55100129ab36ed65$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $55100129ab36ed65$export$491112666e282270(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $55100129ab36ed65$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $55100129ab36ed65$export$491112666e282270(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * @private
 */ function $55100129ab36ed65$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging @remix-run/router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $55100129ab36ed65$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $55100129ab36ed65$var$isServer = !$55100129ab36ed65$var$isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    $55100129ab36ed65$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $55100129ab36ed65$export$491112666e282270(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(to, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$55100129ab36ed65$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $55100129ab36ed65$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $55100129ab36ed65$var$callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $55100129ab36ed65$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission ? submission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($55100129ab36ed65$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>fetchControllers.set(rf.key, pendingNavigationController));
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $55100129ab36ed65$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($55100129ab36ed65$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $55100129ab36ed65$var$normalizeNavigateOptions(href, opts, true);
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path,
            match: match,
            matches: matches
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $55100129ab36ed65$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $55100129ab36ed65$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $55100129ab36ed65$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $55100129ab36ed65$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($55100129ab36ed65$var$_extends({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $55100129ab36ed65$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $55100129ab36ed65$var$callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $55100129ab36ed65$export$f5708dca728d7177(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, redirect.location, $55100129ab36ed65$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $55100129ab36ed65$export$f5708dca728d7177(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $55100129ab36ed65$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let newOrigin = init.history.createURL(redirect.location).origin;
            if (window.location.origin !== newOrigin) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$55100129ab36ed65$var$callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((f)=>$55100129ab36ed65$var$callLoaderOrAction("loader", $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, router.basename))
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $55100129ab36ed65$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$491112666e282270(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$55100129ab36ed65$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$55100129ab36ed65$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "head") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "head" && method !== "options") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $55100129ab36ed65$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($55100129ab36ed65$var$isQueryRouteResponse(e)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error && !$55100129ab36ed65$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            result = await $55100129ab36ed65$var$callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $55100129ab36ed65$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$55100129ab36ed65$var$callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        submission = {
            formMethod: opts.formMethod || "get",
            formAction: $55100129ab36ed65$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    let searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((f, key)=>{
        if (!matches.some((m)=>m.route.id === f.routeId)) // This fetcher is not going to be present in the subsequent render so
        // there's no need to revalidate it
        return;
        else if (cancelledFetcherLoads.includes(key)) // This fetcher was cancelled from a prior action submission - force reload
        revalidatingFetchers.push($55100129ab36ed65$var$_extends({
            key: key
        }, f));
        else {
            // Revalidating fetchers are decoupled from the route matches since they
            // hit a static href, so they _always_ check shouldRevalidate and the
            // default is strictly if a revalidation is explicitly required (action
            // submissions, useRevalidator, X-Remix-Revalidate).
            let shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(f.match, $55100129ab36ed65$var$_extends({
                currentUrl: currentUrl,
                currentParams: state.matches[state.matches.length - 1].params,
                nextUrl: nextUrl,
                nextParams: matches[matches.length - 1].params
            }, submission, {
                actionResult: actionResult,
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            if (shouldRevalidate) revalidatingFetchers.push($55100129ab36ed65$var$_extends({
                key: key
            }, f));
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $55100129ab36ed65$export$f5708dca728d7177(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
        result = await Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
        $55100129ab36ed65$export$f5708dca728d7177(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $55100129ab36ed65$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if ($55100129ab36ed65$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($55100129ab36ed65$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $55100129ab36ed65$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $55100129ab36ed65$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $55100129ab36ed65$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $55100129ab36ed65$export$f5708dca728d7177($55100129ab36ed65$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $55100129ab36ed65$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin absolute redirects.
                // If this is a static reques, we can let it go back to the browser
                // as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                if (url.origin === currentUrl.origin) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $55100129ab36ed65$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $55100129ab36ed65$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $55100129ab36ed65$var$ResultType.error) return {
            type: resultType,
            error: new $55100129ab36ed65$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $55100129ab36ed65$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $55100129ab36ed65$export$61d759255b4eec65) return {
        type: $55100129ab36ed65$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $55100129ab36ed65$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $55100129ab36ed65$export$f5708dca728d7177(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($55100129ab36ed65$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match } = revalidatingFetchers[index];
        $55100129ab36ed65$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$f5708dca728d7177(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $55100129ab36ed65$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return result;
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isQueryRouteResponse(obj) {
    return obj && $55100129ab36ed65$var$isResponse(obj.response) && (obj.type === $55100129ab36ed65$var$ResultType.data || $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method);
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method);
}
async function $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $55100129ab36ed65$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.8.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $7fPBF = parcelRequire("7fPBF");
function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $d9fd026bfea79ab9$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $d9fd026bfea79ab9$var$is = typeof Object.is === "function" ? Object.is : $d9fd026bfea79ab9$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $d9fd026bfea79ab9$var$useState, useEffect: $d9fd026bfea79ab9$var$useEffect, useLayoutEffect: $d9fd026bfea79ab9$var$useLayoutEffect, useDebugValue: $d9fd026bfea79ab9$var$useDebugValue } = $7fPBF;
let $d9fd026bfea79ab9$var$didWarnOld18Alpha = false;
let $d9fd026bfea79ab9$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $d9fd026bfea79ab9$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $d9fd026bfea79ab9$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $d9fd026bfea79ab9$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($d9fd026bfea79ab9$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $d9fd026bfea79ab9$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($d9fd026bfea79ab9$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($d9fd026bfea79ab9$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $d9fd026bfea79ab9$var$useDebugValue(value);
    return value;
}
function $d9fd026bfea79ab9$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$d9fd026bfea79ab9$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $d9fd026bfea79ab9$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $d9fd026bfea79ab9$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $d9fd026bfea79ab9$var$isServerEnvironment = !$d9fd026bfea79ab9$var$canUseDOM;
const $d9fd026bfea79ab9$var$shim = $d9fd026bfea79ab9$var$isServerEnvironment ? $d9fd026bfea79ab9$var$useSyncExternalStore$1 : $d9fd026bfea79ab9$var$useSyncExternalStore$2;
const $d9fd026bfea79ab9$var$useSyncExternalStore = "useSyncExternalStore" in $7fPBF ? ((module)=>module.useSyncExternalStore)($7fPBF) : $d9fd026bfea79ab9$var$shim;
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: []
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let dataRouterStateContext = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorElement() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && match.route.errorElement) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorElement, null) : null;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>/*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($d9fd026bfea79ab9$var$DataRouterHook || ($d9fd026bfea79ab9$var$DataRouterHook = {}));
var $d9fd026bfea79ab9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($d9fd026bfea79ab9$var$DataRouterStateHook || ($d9fd026bfea79ab9$var$DataRouterStateHook = {}));
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return route;
}
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let [blockerKey] = $7fPBF.useState(()=>String(++$d9fd026bfea79ab9$var$blockerId));
    let blockerFunction = $7fPBF.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $7fPBF.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]);
    return blocker;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned[key]) $d9fd026bfea79ab9$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $d9fd026bfea79ab9$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/"; // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let dataRouterState = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    $7fPBF.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$f5708dca728d7177)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $d9fd026bfea79ab9$export$16da398f5434bdec(children);
    return $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($d9fd026bfea79ab9$var$AwaitRenderStatus || ($d9fd026bfea79ab9$var$AwaitRenderStatus = {}));
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : promise._data !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $d9fd026bfea79ab9$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $d9fd026bfea79ab9$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $d9fd026bfea79ab9$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $d9fd026bfea79ab9$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $a0cf24fd73ae067c$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $a0cf24fd73ae067c$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: (0, $d9fd026bfea79ab9$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: (0, $d9fd026bfea79ab9$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
/**
 * The public API for rendering a history-aware <a>.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref4, $a0cf24fd73ae067c$var$_excluded);
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if ($a0cf24fd73ae067c$var$isBrowser && typeof to === "string" && /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(to)) {
        absoluteHref = to;
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        if (targetUrl.origin === currentUrl.origin) // Strip the protocol/origin for same-origin absolute URLs
        to = targetUrl.pathname + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref5, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$FormImpl, $a0cf24fd73ae067c$var$_extends({}, props, {
        ref: ref
    }));
});
const $a0cf24fd73ae067c$var$FormImpl = /*#__PURE__*/ $7fPBF.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref6, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    return $a0cf24fd73ae067c$var$useSubmitImpl();
}
function $a0cf24fd73ae067c$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
function $a0cf24fd73ae067c$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$FormImpl, $a0cf24fd73ae067c$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !route && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
    let [fetcherKey] = $7fPBF.useState(()=>String(++$a0cf24fd73ae067c$var$fetcherId));
    let [Form] = $7fPBF.useState(()=>{
        !routeId && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
        return $a0cf24fd73ae067c$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $7fPBF.useState(()=>(href)=>{
            !router && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
            !routeId && (0, $55100129ab36ed65$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $a0cf24fd73ae067c$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $7fPBF.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $d9fd026bfea79ab9$export$2af03a1de5c0910)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $a0cf24fd73ae067c$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion


var $0bf18c8a9090be1b$exports = {};

(function(global, factory) {
    factory($0bf18c8a9090be1b$exports, (parcelRequire("7fPBF")));
})($0bf18c8a9090be1b$exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $c5451a3e792ab15d$exports = {};
var $b3fb774aba01f7f6$exports = {};
var $c10f30473eab5108$exports = {};
function $c10f30473eab5108$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c10f30473eab5108$exports = $c10f30473eab5108$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c10f30473eab5108$exports.__esModule = true, $c10f30473eab5108$exports["default"] = $c10f30473eab5108$exports, $c10f30473eab5108$var$_typeof(obj);
}
$c10f30473eab5108$exports = $c10f30473eab5108$var$_typeof, $c10f30473eab5108$exports.__esModule = true, $c10f30473eab5108$exports["default"] = $c10f30473eab5108$exports;


var $b3fb774aba01f7f6$var$_typeof = $c10f30473eab5108$exports.default;
var $4024e515f843ed36$exports = {};

var $4024e515f843ed36$var$_typeof = $c10f30473eab5108$exports.default;
function $4024e515f843ed36$var$_toPrimitive(input, hint) {
    if ($4024e515f843ed36$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4024e515f843ed36$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$4024e515f843ed36$exports = $4024e515f843ed36$var$_toPrimitive, $4024e515f843ed36$exports.__esModule = true, $4024e515f843ed36$exports["default"] = $4024e515f843ed36$exports;


function $b3fb774aba01f7f6$var$_toPropertyKey(arg) {
    var key = $4024e515f843ed36$exports(arg, "string");
    return $b3fb774aba01f7f6$var$_typeof(key) === "symbol" ? key : String(key);
}
$b3fb774aba01f7f6$exports = $b3fb774aba01f7f6$var$_toPropertyKey, $b3fb774aba01f7f6$exports.__esModule = true, $b3fb774aba01f7f6$exports["default"] = $b3fb774aba01f7f6$exports;


function $c5451a3e792ab15d$var$_defineProperty(obj, key, value) {
    key = $b3fb774aba01f7f6$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$c5451a3e792ab15d$exports = $c5451a3e792ab15d$var$_defineProperty, $c5451a3e792ab15d$exports.__esModule = true, $c5451a3e792ab15d$exports["default"] = $c5451a3e792ab15d$exports;


var $b7a29a761408b162$exports = {};
var $e54f1ea533649b71$exports = {};
function $e54f1ea533649b71$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$e54f1ea533649b71$exports = $e54f1ea533649b71$var$_objectWithoutPropertiesLoose, $e54f1ea533649b71$exports.__esModule = true, $e54f1ea533649b71$exports["default"] = $e54f1ea533649b71$exports;


function $b7a29a761408b162$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e54f1ea533649b71$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$b7a29a761408b162$exports = $b7a29a761408b162$var$_objectWithoutProperties, $b7a29a761408b162$exports.__esModule = true, $b7a29a761408b162$exports["default"] = $b7a29a761408b162$exports;



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
var $f1ee620f0561c02a$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $f1ee620f0561c02a$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3be60b4f29d3a6e3$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($f1ee620f0561c02a$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3be60b4f29d3a6e3$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3be60b4f29d3a6e3$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3be60b4f29d3a6e3$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3be60b4f29d3a6e3$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3be60b4f29d3a6e3$var$a("", t);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;


function $445d14444882807b$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $445d14444882807b$var$alreadyWarned = {};
function $445d14444882807b$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $445d14444882807b$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $445d14444882807b$var$alreadyWarned[args[0]] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $445d14444882807b$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $445d14444882807b$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}



var $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $dbc236e0ae4b1bc0$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $dbc236e0ae4b1bc0$var$htmlEntities[m];
};
var $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);
};


function $ba1062cc0d1f4b93$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba1062cc0d1f4b93$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ba1062cc0d1f4b93$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ba1062cc0d1f4b93$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ba1062cc0d1f4b93$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $dbc236e0ae4b1bc0$export$e8bacd2802a88316)
};
function $ba1062cc0d1f4b93$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $ba1062cc0d1f4b93$var$defaultOptions = $ba1062cc0d1f4b93$var$_objectSpread($ba1062cc0d1f4b93$var$_objectSpread({}, $ba1062cc0d1f4b93$var$defaultOptions), options);
}
function $ba1062cc0d1f4b93$export$212bb2fc580a90a8() {
    return $ba1062cc0d1f4b93$var$defaultOptions;
}


var $91a4dd25d142fe34$var$i18nInstance;
function $91a4dd25d142fe34$export$a039134f2fc7e0(instance) {
    $91a4dd25d142fe34$var$i18nInstance = instance;
}
function $91a4dd25d142fe34$export$64af334f494c2f47() {
    return $91a4dd25d142fe34$var$i18nInstance;
}


var $1bd7e790a57f14c4$var$_excluded = [
    "format"
], $1bd7e790a57f14c4$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $1bd7e790a57f14c4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1bd7e790a57f14c4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1bd7e790a57f14c4$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1bd7e790a57f14c4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1bd7e790a57f14c4$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $1bd7e790a57f14c4$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $1bd7e790a57f14c4$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $7fPBF.isValidElement)(child);
    });
}
function $1bd7e790a57f14c4$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $1bd7e790a57f14c4$var$mergeProps(source, target) {
    var newTarget = $1bd7e790a57f14c4$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $1bd7e790a57f14c4$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $7fPBF.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $1bd7e790a57f14c4$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $445d14444882807b$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($c10f30473eab5108$exports)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($b7a29a761408b162$exports)))(child, $1bd7e790a57f14c4$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $445d14444882807b$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $445d14444882807b$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $1bd7e790a57f14c4$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($c10f30473eab5108$exports)))(child) === "object" && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $3be60b4f29d3a6e3$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $1bd7e790a57f14c4$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1bd7e790a57f14c4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $1bd7e790a57f14c4$var$getAsArray(reactNode);
        var astNodes = $1bd7e790a57f14c4$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $1bd7e790a57f14c4$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $7fPBF.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $1bd7e790a57f14c4$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($c10f30473eab5108$exports)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($c10f30473eab5108$exports)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1bd7e790a57f14c4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($c10f30473eab5108$exports)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1bd7e790a57f14c4$var$getAsArray(children || []));
    return $1bd7e790a57f14c4$var$getChildren(result[0]);
}
function $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($b7a29a761408b162$exports)))(_ref, $1bd7e790a57f14c4$var$_excluded2);
    var i18n = i18nFromProps || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, (0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $1bd7e790a57f14c4$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}



var $318248ed98141f1b$exports = {};
function $318248ed98141f1b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$318248ed98141f1b$exports = $318248ed98141f1b$var$_classCallCheck, $318248ed98141f1b$exports.__esModule = true, $318248ed98141f1b$exports["default"] = $318248ed98141f1b$exports;


var $fadfb1ed4e4e0237$exports = {};

function $fadfb1ed4e4e0237$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b3fb774aba01f7f6$exports(descriptor.key), descriptor);
    }
}
function $fadfb1ed4e4e0237$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fadfb1ed4e4e0237$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fadfb1ed4e4e0237$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fadfb1ed4e4e0237$exports = $fadfb1ed4e4e0237$var$_createClass, $fadfb1ed4e4e0237$exports.__esModule = true, $fadfb1ed4e4e0237$exports["default"] = $fadfb1ed4e4e0237$exports;



var $7fPBF = parcelRequire("7fPBF");




var $09536692873e4879$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $ba1062cc0d1f4b93$export$2e2366488d12e20d)(instance.options.react);
        (0, $91a4dd25d142fe34$export$a039134f2fc7e0)(instance);
    }
};


function $021c8539c0651064$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $021c8539c0651064$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $021c8539c0651064$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $021c8539c0651064$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
var $021c8539c0651064$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($318248ed98141f1b$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fadfb1ed4e4e0237$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $021c8539c0651064$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($021c8539c0651064$var$_objectSpread($021c8539c0651064$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $021c8539c0651064$export$704200e5d0b9e8f() {
    var i18n = (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $69274dd39b5dbdf8$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $69274dd39b5dbdf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $69274dd39b5dbdf8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $69274dd39b5dbdf8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $69274dd39b5dbdf8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($b7a29a761408b162$exports)))(_ref, $69274dd39b5dbdf8$var$_excluded);
    var _ref2 = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce)($69274dd39b5dbdf8$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}



var $2256481b95c075e2$exports = {};
var $bee053431036be86$exports = {};
function $bee053431036be86$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bee053431036be86$exports = $bee053431036be86$var$_arrayWithHoles, $bee053431036be86$exports.__esModule = true, $bee053431036be86$exports["default"] = $bee053431036be86$exports;


var $b286c6cd02445900$exports = {};
function $b286c6cd02445900$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$b286c6cd02445900$exports = $b286c6cd02445900$var$_iterableToArrayLimit, $b286c6cd02445900$exports.__esModule = true, $b286c6cd02445900$exports["default"] = $b286c6cd02445900$exports;


var $8380ce6fc813635e$exports = {};
var $3206b548cc177746$exports = {};
function $3206b548cc177746$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$3206b548cc177746$exports = $3206b548cc177746$var$_arrayLikeToArray, $3206b548cc177746$exports.__esModule = true, $3206b548cc177746$exports["default"] = $3206b548cc177746$exports;


function $8380ce6fc813635e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3206b548cc177746$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3206b548cc177746$exports(o, minLen);
}
$8380ce6fc813635e$exports = $8380ce6fc813635e$var$_unsupportedIterableToArray, $8380ce6fc813635e$exports.__esModule = true, $8380ce6fc813635e$exports["default"] = $8380ce6fc813635e$exports;


var $0bffa24d0e2e9962$exports = {};
function $0bffa24d0e2e9962$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0bffa24d0e2e9962$exports = $0bffa24d0e2e9962$var$_nonIterableRest, $0bffa24d0e2e9962$exports.__esModule = true, $0bffa24d0e2e9962$exports["default"] = $0bffa24d0e2e9962$exports;


function $2256481b95c075e2$var$_slicedToArray(arr, i) {
    return $bee053431036be86$exports(arr) || $b286c6cd02445900$exports(arr, i) || $8380ce6fc813635e$exports(arr, i) || $0bffa24d0e2e9962$exports();
}
$2256481b95c075e2$exports = $2256481b95c075e2$var$_slicedToArray, $2256481b95c075e2$exports.__esModule = true, $2256481b95c075e2$exports["default"] = $2256481b95c075e2$exports;




var $7fPBF = parcelRequire("7fPBF");


function $9c081519ec78392c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9c081519ec78392c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9c081519ec78392c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9c081519ec78392c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9c081519ec78392c$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $9c081519ec78392c$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $021c8539c0651064$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $445d14444882807b$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $9c081519ec78392c$var$_objectSpread($9c081519ec78392c$var$_objectSpread($9c081519ec78392c$var$_objectSpread({}, (0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $445d14444882807b$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $7fPBF.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($2256481b95c075e2$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $9c081519ec78392c$var$usePrevious(joinedNS);
    var isMounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}






var $7fPBF = parcelRequire("7fPBF");


var $1b9d18dce12af9e0$var$_excluded = [
    "forwardedRef"
];
function $1b9d18dce12af9e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b9d18dce12af9e0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1b9d18dce12af9e0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1b9d18dce12af9e0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1b9d18dce12af9e0$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($b7a29a761408b162$exports)))(_ref, $1b9d18dce12af9e0$var$_excluded);
            var _useTranslation = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, $1b9d18dce12af9e0$var$_objectSpread($1b9d18dce12af9e0$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($2256481b95c075e2$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $1b9d18dce12af9e0$var$_objectSpread($1b9d18dce12af9e0$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7fPBF.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $7fPBF.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $7fPBF.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $1123dfab2acde046$var$_excluded = [
    "ns",
    "children"
];
function $1123dfab2acde046$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, (/*@__PURE__*/$parcel$interopDefault($b7a29a761408b162$exports)))(props, $1123dfab2acde046$var$_excluded);
    var _useTranslation = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($2256481b95c075e2$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $7fPBF = parcelRequire("7fPBF");

function $f40df753886fac13$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $7fPBF.createElement)((0, $021c8539c0651064$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $6dc6e4594d06aae3$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $25e3a7ece768866e$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $25e3a7ece768866e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25e3a7ece768866e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $25e3a7ece768866e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c5451a3e792ab15d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $25e3a7ece768866e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $25e3a7ece768866e$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, (/*@__PURE__*/$parcel$interopDefault($b7a29a761408b162$exports)))(_ref, $25e3a7ece768866e$var$_excluded);
            (0, $6dc6e4594d06aae3$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $7fPBF.createElement)(WrappedComponent, $25e3a7ece768866e$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $021c8539c0651064$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}




var $2af286126fb112dc$export$324d90190a8b822a = function date() {
    return "";
};
var $2af286126fb112dc$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $2af286126fb112dc$export$98e628dec113755e = function number() {
    return "";
};
var $2af286126fb112dc$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $2af286126fb112dc$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $2af286126fb112dc$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};




var $c6671b4b04086b90$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($c6671b4b04086b90$export$e24756d4ad084ce1 || ($c6671b4b04086b90$export$e24756d4ad084ce1 = {}));






















var $b395b8021c1a764c$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($b395b8021c1a764c$export$b141d049add1dcb5 || ($b395b8021c1a764c$export$b141d049add1dcb5 = {}));
















var $ae9733cdeb9be194$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($ae9733cdeb9be194$export$54765d03252bd9ed || ($ae9733cdeb9be194$export$54765d03252bd9ed = {}));


































var $f428af941b481ed7$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($f428af941b481ed7$export$6431f3fda9a48da2 || ($f428af941b481ed7$export$6431f3fda9a48da2 = {}));














class $5fc1b3e98db84538$export$a455218a85c89869 {
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
    constructor({ name: name, kind: kind = (0, $ae9733cdeb9be194$export$54765d03252bd9ed).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
}


class $ad0894e273758fde$export$833b3e5a19fb8939 {
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
}





var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
class $556d035a939794ad$export$7587955500404ec3 {
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        const cloned = new $556d035a939794ad$export$7587955500404ec3((0, $2qxEV._)((0, $9tqwB._)({}, this), {
            headers: (0, $9tqwB._)({}, this.headers)
        }));
        if (cloned.query) cloned.query = $556d035a939794ad$var$cloneQuery(cloned.query);
        return cloned;
    }
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
}
function $556d035a939794ad$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return (0, $2qxEV._)((0, $9tqwB._)({}, carry), {
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        });
    }, {});
}


class $76750c3e94ff2f32$export$1d94dfe0d9d1f1e7 {
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
}


function $fee4e776142e700e$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}








var $fcfd5fbee0313ec7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fcfd5fbee0313ec7$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fcfd5fbee0313ec7$export$2b02da34270c5ffa = function(response) {
    return $fcfd5fbee0313ec7$var$__awaiter(void 0, void 0, void 0, function() {
        var value;
        return $fcfd5fbee0313ec7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.body.getReader().read()
                    ];
                case 1:
                    value = _a.sent().value;
                    return [
                        2 /*return*/ ,
                        JSON.parse(String.fromCharCode.apply(null, value))
                    ];
            }
        });
    });
};
var $fcfd5fbee0313ec7$export$ffaff34add5e5c5 = function(response) {
    return $fcfd5fbee0313ec7$var$__awaiter(void 0, void 0, void 0, function() {
        var value;
        return $fcfd5fbee0313ec7$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        response.body.getReader().read()
                    ];
                case 1:
                    value = _a.sent().value;
                    return [
                        2 /*return*/ ,
                        String.fromCharCode.apply(null, value)
                    ];
            }
        });
    });
};


var $7cff0f7fd8f7b479$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7cff0f7fd8f7b479$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7cff0f7fd8f7b479$var$METHOD = "POST";
var $7cff0f7fd8f7b479$var$CONTENT_TYPE = "application/x-amz-json-1.1";
var $7cff0f7fd8f7b479$var$PROTOCOL = "https:";
// Targets
var $7cff0f7fd8f7b479$var$GET_ID_TARGET = "AWSCognitoIdentityService.GetId";
var $7cff0f7fd8f7b479$var$GET_TOKEN_TARGET = "AWSCognitoIdentityService.GetOpenIdToken";
var $7cff0f7fd8f7b479$var$GET_CREDENTIALS_TARGET = "AWSCognitoIdentityService.GetCredentialsForIdentity";
var $7cff0f7fd8f7b479$export$6c7d622e9507a2e = function(params) {
    return function() {
        return params.client.getCredentialsForIdentity(params.identityPoolId);
    };
};
var $7cff0f7fd8f7b479$export$e576def690e850f7 = /** @class */ function() {
    function CognitoIdentityClient(config) {
        var _this = this;
        this.getId = function(request) {
            return $7cff0f7fd8f7b479$var$__awaiter(_this, void 0, void 0, function() {
                var requestPayload, idRequest, response, e_1;
                return $7cff0f7fd8f7b479$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestPayload = JSON.stringify(request);
                            idRequest = this.getHttpRequest($7cff0f7fd8f7b479$var$GET_ID_TARGET, requestPayload);
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(idRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, $fcfd5fbee0313ec7$export$2b02da34270c5ffa)(response)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            e_1 = _a.sent();
                            throw new Error("CWR: Failed to retrieve Cognito identity: ".concat(e_1));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getOpenIdToken = function(request) {
            return $7cff0f7fd8f7b479$var$__awaiter(_this, void 0, void 0, function() {
                var requestPayload, tokenRequest, response, e_2;
                return $7cff0f7fd8f7b479$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestPayload = JSON.stringify(request);
                            tokenRequest = this.getHttpRequest($7cff0f7fd8f7b479$var$GET_TOKEN_TARGET, requestPayload);
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(tokenRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, $fcfd5fbee0313ec7$export$2b02da34270c5ffa)(response)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            e_2 = _a.sent();
                            throw new Error("CWR: Failed to retrieve Cognito OpenId token: ".concat(e_2));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getCredentialsForIdentity = function(identityId) {
            return $7cff0f7fd8f7b479$var$__awaiter(_this, void 0, void 0, function() {
                var requestPayload, credentialRequest, response, Credentials, AccessKeyId, Expiration, SecretAccessKey, SessionToken, e_3;
                return $7cff0f7fd8f7b479$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestPayload = JSON.stringify({
                                IdentityId: identityId
                            });
                            credentialRequest = this.getHttpRequest($7cff0f7fd8f7b479$var$GET_CREDENTIALS_TARGET, requestPayload);
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(credentialRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, $fcfd5fbee0313ec7$export$2b02da34270c5ffa)(response)
                            ];
                        case 2:
                            Credentials = _a.sent().Credentials;
                            AccessKeyId = Credentials.AccessKeyId, Expiration = Credentials.Expiration, SecretAccessKey = Credentials.SecretAccessKey, SessionToken = Credentials.SessionToken;
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: AccessKeyId,
                                    secretAccessKey: SecretAccessKey,
                                    sessionToken: SessionToken,
                                    expiration: new Date(Expiration * 1000)
                                }
                            ];
                        case 3:
                            e_3 = _a.sent();
                            throw new Error("CWR: Failed to retrieve credentials for Cognito identity: ".concat(e_3));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.getHttpRequest = function(target, payload) {
            return new (0, $556d035a939794ad$export$7587955500404ec3)({
                method: $7cff0f7fd8f7b479$var$METHOD,
                headers: {
                    "content-type": $7cff0f7fd8f7b479$var$CONTENT_TYPE,
                    "x-amz-target": target
                },
                protocol: $7cff0f7fd8f7b479$var$PROTOCOL,
                hostname: _this.hostname,
                body: payload
            });
        };
        this.hostname = "cognito-identity.".concat(config.region, ".amazonaws.com");
        this.fetchRequestHandler = config.fetchRequestHandler;
    }
    return CognitoIdentityClient;
}();



const $b644b14c5797f8d7$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $b644b14c5797f8d7$var$hexEncode);
const $b644b14c5797f8d7$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;



const $93f378393c51ca08$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $b644b14c5797f8d7$export$c3b4775ad75a73db)).join("/");




function $d8de6bb94ac789ce$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}


function $f02f1292dbb51eab$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}


class $f613a28573d9efe6$export$83588b87edbfa7e0 {
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $d8de6bb94ac789ce$export$6b17a39e52c8ee53)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            var _request_username;
            const username = (_request_username = request.username) !== null && _request_username !== void 0 ? _request_username : "";
            var _request_password;
            const password = (_request_password = request.password) !== null && _request_password !== void 0 ? _request_password : "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $76750c3e94ff2f32$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $76750c3e94ff2f32$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $f02f1292dbb51eab$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            abortSignal.onabort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    }
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options !== null && options !== void 0 ? options : {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
}


const $8e1eced61cdf4295$export$7753813254d72972 = {};
const $8e1eced61cdf4295$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $8e1eced61cdf4295$export$7753813254d72972[char] = i;
    $8e1eced61cdf4295$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $8e1eced61cdf4295$export$7753813254d72972[char] = index;
    $8e1eced61cdf4295$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $8e1eced61cdf4295$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $8e1eced61cdf4295$export$7753813254d72972[char] = index;
    $8e1eced61cdf4295$export$8f4022378ddff4c7[index] = char;
}
$8e1eced61cdf4295$export$7753813254d72972["+"] = 62;
$8e1eced61cdf4295$export$8f4022378ddff4c7[62] = "+";
$8e1eced61cdf4295$export$7753813254d72972["/"] = 63;
$8e1eced61cdf4295$export$8f4022378ddff4c7[63] = "/";
const $8e1eced61cdf4295$export$1c5cfd5e95b84581 = 6;
const $8e1eced61cdf4295$export$79b97ac4c24c9385 = 8;
const $8e1eced61cdf4295$export$43e943b030ae3d73 = 63;


const $40a52a0256e7d060$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $8e1eced61cdf4295$export$7753813254d72972))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $8e1eced61cdf4295$export$7753813254d72972)[input[j]] << (limit - j) * (0, $8e1eced61cdf4295$export$1c5cfd5e95b84581);
            bitLength += (0, $8e1eced61cdf4295$export$1c5cfd5e95b84581);
        } else bits >>= (0, $8e1eced61cdf4295$export$1c5cfd5e95b84581);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $8e1eced61cdf4295$export$79b97ac4c24c9385);
        const byteLength = Math.floor(bitLength / (0, $8e1eced61cdf4295$export$79b97ac4c24c9385));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $8e1eced61cdf4295$export$79b97ac4c24c9385);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};



function $2568bbba73bb4bd0$export$37cc283d8fbd3462(input) {
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $8e1eced61cdf4295$export$79b97ac4c24c9385);
            bitLength += (0, $8e1eced61cdf4295$export$79b97ac4c24c9385);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $8e1eced61cdf4295$export$1c5cfd5e95b84581));
        bits <<= bitClusterCount * (0, $8e1eced61cdf4295$export$1c5cfd5e95b84581) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $8e1eced61cdf4295$export$1c5cfd5e95b84581);
            str += (0, $8e1eced61cdf4295$export$8f4022378ddff4c7)[(bits & (0, $8e1eced61cdf4295$export$43e943b030ae3d73) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}




const $55cd0f2dd02c4c1b$export$17bf97b72e307d52 = (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob) return $55cd0f2dd02c4c1b$var$collectBlob(stream);
    return $55cd0f2dd02c4c1b$var$collectStream(stream);
};
async function $55cd0f2dd02c4c1b$var$collectBlob(blob) {
    const base64 = await $55cd0f2dd02c4c1b$var$readToBase64(blob);
    const arrayBuffer = (0, $40a52a0256e7d060$export$c537b38001c583b7)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $55cd0f2dd02c4c1b$var$collectStream(stream) {
    let res = new Uint8Array(0);
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            const prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
        }
        isDone = done;
    }
    return res;
}
function $55cd0f2dd02c4c1b$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            var _reader_result;
            const result = (_reader_result = reader.result) !== null && _reader_result !== void 0 ? _reader_result : "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}








var $0e8a4cc31e96b8d2$var$__assign = undefined && undefined.__assign || function() {
    $0e8a4cc31e96b8d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e8a4cc31e96b8d2$var$__assign.apply(this, arguments);
};
var $0e8a4cc31e96b8d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0e8a4cc31e96b8d2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0e8a4cc31e96b8d2$var$METHOD = "POST";
var $0e8a4cc31e96b8d2$var$CONTENT_TYPE = "application/x-www-form-urlencoded";
var $0e8a4cc31e96b8d2$var$PROTOCOL = "https:";
var $0e8a4cc31e96b8d2$var$ACTION = "AssumeRoleWithWebIdentity";
var $0e8a4cc31e96b8d2$var$VERSION = "2011-06-15";
var $0e8a4cc31e96b8d2$export$35ca1599e2721eb1 = /** @class */ function() {
    function StsClient(config) {
        var _this = this;
        this.assumeRoleWithWebIdentity = function(request) {
            return $0e8a4cc31e96b8d2$var$__awaiter(_this, void 0, void 0, function() {
                var requestObject, encodedBody, STSRequest, response, xmlResponse, e_1;
                return $0e8a4cc31e96b8d2$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            requestObject = $0e8a4cc31e96b8d2$var$__assign($0e8a4cc31e96b8d2$var$__assign({}, request), {
                                Action: $0e8a4cc31e96b8d2$var$ACTION,
                                Version: $0e8a4cc31e96b8d2$var$VERSION
                            });
                            encodedBody = new URLSearchParams(Object.entries(requestObject)).toString();
                            STSRequest = new (0, $556d035a939794ad$export$7587955500404ec3)({
                                method: $0e8a4cc31e96b8d2$var$METHOD,
                                headers: {
                                    "content-type": $0e8a4cc31e96b8d2$var$CONTENT_TYPE,
                                    host: this.hostname
                                },
                                protocol: $0e8a4cc31e96b8d2$var$PROTOCOL,
                                hostname: this.hostname,
                                body: encodedBody
                            });
                            return [
                                4 /*yield*/ ,
                                this.fetchRequestHandler.handle(STSRequest)
                            ];
                        case 1:
                            response = _a.sent().response;
                            return [
                                4 /*yield*/ ,
                                (0, $fcfd5fbee0313ec7$export$ffaff34add5e5c5)(response)
                            ];
                        case 2:
                            xmlResponse = _a.sent();
                            return [
                                2 /*return*/ ,
                                {
                                    accessKeyId: xmlResponse.split("<AccessKeyId>")[1].split("</AccessKeyId>")[0],
                                    secretAccessKey: xmlResponse.split("<SecretAccessKey>")[1].split("</SecretAccessKey>")[0],
                                    sessionToken: xmlResponse.split("<SessionToken>")[1].split("</SessionToken>")[0],
                                    expiration: new Date(xmlResponse.split("<Expiration>")[1].split("</Expiration>")[0])
                                }
                            ];
                        case 3:
                            e_1 = _a.sent();
                            throw new Error("CWR: Failed to retrieve credentials from STS: ".concat(e_1));
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.hostname = "sts.".concat(config.region, ".amazonaws.com");
        this.fetchRequestHandler = config.fetchRequestHandler;
    }
    return StsClient;
}();


var $ccd6d6da69a078d2$export$dad7991f0d7c4056 = "cwr_c";
var $ccd6d6da69a078d2$export$63cf0d84d808ffcc = "cwr_s";
var $ccd6d6da69a078d2$export$8dadb2caf2a12c09 = "cwr_u";
var $ccd6d6da69a078d2$export$c28b2e7e641379bf = 30000;
var $ccd6d6da69a078d2$export$d9163009b3fbaaf7 = "arw-script";
var $ccd6d6da69a078d2$export$da62d514fa80410b = "arw-module";
var $ccd6d6da69a078d2$export$cf209fc6ae98e8dd = [
    "pageId",
    "pageTags"
];


var $65343e0984f8c697$var$__assign = undefined && undefined.__assign || function() {
    $65343e0984f8c697$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $65343e0984f8c697$var$__assign.apply(this, arguments);
};
var $65343e0984f8c697$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $65343e0984f8c697$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $65343e0984f8c697$export$d9e3c9dc7eaad0c3 = /** @class */ function() {
    function Authentication(config) {
        var _this = this;
        /**
         * A credential provider which provides AWS credentials for an anonymous
         * (guest) user. These credentials are retrieved from the first successful
         * provider in a chain.
         *
         * Credentials are stored in and retrieved from localStorage. This prevents the client from having to
         * re-authenticate every time the client loads, which (1) improves the performance of the RUM web client and (2)
         * reduces the load on AWS services Cognito and STS.
         *
         * While storing credentials in localStorage puts the cookie at greater risk of being leaked through an
         * XSS attack, there is no impact if the credentials were to be leaked. This is because (1) the identity pool ID
         * and role ARN are public and (2) the credentials are for an anonymous (guest) user.
         *
         * Regarding (1), the identity pool ID and role ARN are, by necessity, public. These identifiers are shipped with
         * each application as part of Cognito's Basic (Classic) authentication flow. The identity pool ID and role ARN
         * are not secret.
         *
         * Regarding (2), the authentication chain implemented in this file only supports anonymous (guest)
         * authentication. When the Cognito authentication flow is executed, {@code AnonymousCognitoCredentialsProvider}
         * does not communicate with a login provider such as Amazon, Facebook or Google. Instead, it relies on (a) the
         * identity pool supporting unauthenticated identities and (b) the IAM role policy enabling login through the
         * identity pool. If the identity pool does not support unauthenticated identities, this authentication chain
         * will not succeed.
         *
         * Taken together, (1) and (2) mean that if these temporary credentials were to be leaked, the leaked credentials
         * would not allow a bad actor to gain access to anything which they did not already have public access to.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.ChainAnonymousCredentialsProvider = function() {
            return $65343e0984f8c697$var$__awaiter(_this, void 0, void 0, function() {
                return $65343e0984f8c697$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.AnonymousCredentialsProvider().catch(this.AnonymousStorageCredentialsProvider).catch(this.AnonymousCognitoCredentialsProvider)
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from a member variable.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCredentialsProvider = function() {
            return $65343e0984f8c697$var$__awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return $65343e0984f8c697$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            resolve(_this.credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from localStorage.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousStorageCredentialsProvider = function() {
            return $65343e0984f8c697$var$__awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return $65343e0984f8c697$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var credentials;
                            try {
                                credentials = JSON.parse(localStorage.getItem((0, $ccd6d6da69a078d2$export$dad7991f0d7c4056)));
                            } catch (e) {
                                // Error retrieving, decoding or parsing the cred string -- abort
                                return reject();
                            }
                            // The expiration property of Credentials has a date type. Because the date was serialized as a string,
                            // we need to convert it back into a date, otherwise the AWS SDK signing middleware
                            // (@aws-sdk/middleware-signing) will throw an exception and no credentials will be returned.
                            _this.credentials = $65343e0984f8c697$var$__assign($65343e0984f8c697$var$__assign({}, credentials), {
                                expiration: new Date(credentials.expiration)
                            });
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            _this.credentials = credentials;
                            resolve(credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are retrieved from Cognito's basic
         * (classic) authflow.
         *
         * See https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCognitoCredentialsProvider = function() {
            return $65343e0984f8c697$var$__awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return $65343e0984f8c697$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.cognitoIdentityClient.getId({
                            IdentityPoolId: this.config.identityPoolId
                        }).then(function(getIdResponse) {
                            return _this.cognitoIdentityClient.getOpenIdToken(getIdResponse);
                        }).then(function(getOpenIdTokenResponse) {
                            return _this.stsClient.assumeRoleWithWebIdentity({
                                RoleArn: _this.config.guestRoleArn,
                                RoleSessionName: "cwr",
                                WebIdentityToken: getOpenIdTokenResponse.Token
                            });
                        }).then(function(credentials) {
                            _this.credentials = credentials;
                            try {
                                localStorage.setItem((0, $ccd6d6da69a078d2$export$dad7991f0d7c4056), JSON.stringify(credentials));
                            } catch (e) {
                            // Ignore
                            }
                            return credentials;
                        })
                    ];
                });
            });
        };
        var region = config.identityPoolId.split(":")[0];
        this.config = config;
        this.stsClient = new (0, $0e8a4cc31e96b8d2$export$35ca1599e2721eb1)({
            fetchRequestHandler: new (0, $f613a28573d9efe6$export$83588b87edbfa7e0)(),
            region: region
        });
        this.cognitoIdentityClient = new (0, $7cff0f7fd8f7b479$export$e576def690e850f7)({
            fetchRequestHandler: new (0, $f613a28573d9efe6$export$83588b87edbfa7e0)(),
            region: region
        });
    }
    Authentication.prototype.renewCredentials = function() {
        if (!this.credentials || !this.credentials.expiration) return true;
        var renewalTime = new Date(this.credentials.expiration.getTime() - (0, $ccd6d6da69a078d2$export$c28b2e7e641379bf));
        return new Date() > renewalTime;
    };
    return Authentication;
}();





var $a820ff3a376466a8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a820ff3a376466a8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a820ff3a376466a8$export$98bfa4ab673a3dcf = /** @class */ function() {
    function EnhancedAuthentication(config) {
        var _this = this;
        /**
         * A credential provider which provides AWS credentials for an anonymous
         * (guest) user. These credentials are retrieved from the first successful
         * provider in a chain.
         *
         * Credentials are stored in and retrieved from localStorage. This prevents the client from having to
         * re-authenticate every time the client loads, which (1) improves the performance of the RUM web client and (2)
         * reduces the load on AWS services Cognito and STS.
         *
         * While storing credentials in localStorage puts the credential at greater risk of being leaked through an
         * XSS attack, there is no impact if the credentials were to be leaked. This is because (1) the identity pool ID
         * and role ARN are public and (2) the credentials are for an anonymous (guest) user.
         *
         * Regarding (1), the identity pool ID and role ARN are, by necessity, public. These identifiers are shipped with
         * each application as part of Cognito's Basic (Classic) authentication flow. The identity pool ID and role ARN
         * are not secret.
         *
         * Regarding (2), the authentication chain implemented in this file only supports anonymous (guest)
         * authentication. When the Cognito authentication flow is executed, {@code AnonymousCognitoCredentialsProvider}
         * does not communicate with a login provider such as Amazon, Facebook or Google. Instead, it relies on (a) the
         * identity pool supporting unauthenticated identities and (b) the IAM role policy enabling login through the
         * identity pool. If the identity pool does not support unauthenticated identities, this authentication chain
         * will not succeed.
         *
         * Taken together, (1) and (2) mean that if these temporary credentials were to be leaked, the leaked credentials
         * would not allow a bad actor to gain access to anything which they did not already have public access to.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.ChainAnonymousCredentialsProvider = function() {
            return $a820ff3a376466a8$var$__awaiter(_this, void 0, void 0, function() {
                return $a820ff3a376466a8$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        this.AnonymousCredentialsProvider().catch(this.AnonymousStorageCredentialsProvider).catch(this.AnonymousCognitoCredentialsProvider)
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from a member variable.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCredentialsProvider = function() {
            return $a820ff3a376466a8$var$__awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return $a820ff3a376466a8$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            resolve(_this.credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are read from localStorage.
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousStorageCredentialsProvider = function() {
            return $a820ff3a376466a8$var$__awaiter(_this, void 0, void 0, function() {
                var _this = this;
                return $a820ff3a376466a8$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        new Promise(function(resolve, reject) {
                            var credentials;
                            try {
                                credentials = JSON.parse(localStorage.getItem((0, $ccd6d6da69a078d2$export$dad7991f0d7c4056)));
                            } catch (e) {
                                // Error decoding or parsing the cookie -- abort
                                reject();
                            }
                            // The expiration property of Credentials has a date type. Because the date was serialized as a string,
                            // we need to convert it back into a date, otherwise the AWS SDK signing middleware
                            // (@aws-sdk/middleware-signing) will throw an exception and no credentials will be returned.
                            credentials.expiration = new Date(credentials.expiration);
                            _this.credentials = credentials;
                            if (_this.renewCredentials()) // The credentials have expired.
                            return reject();
                            _this.credentials = credentials;
                            resolve(credentials);
                        })
                    ];
                });
            });
        };
        /**
         * Provides credentials for an anonymous (guest) user. These credentials are retrieved from Cognito's enhanced
         * authflow.
         *
         * See https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html
         *
         * Implements CredentialsProvider = Provider<Credentials>
         */ this.AnonymousCognitoCredentialsProvider = function() {
            return $a820ff3a376466a8$var$__awaiter(_this, void 0, void 0, function() {
                var credentialProvider;
                var _this = this;
                return $a820ff3a376466a8$var$__generator(this, function(_a) {
                    credentialProvider = (0, $7cff0f7fd8f7b479$export$6c7d622e9507a2e)({
                        client: this.cognitoIdentityClient,
                        identityPoolId: this.config.identityPoolId
                    });
                    return [
                        2 /*return*/ ,
                        credentialProvider().then(function(credentials) {
                            _this.credentials = credentials;
                            try {
                                localStorage.setItem((0, $ccd6d6da69a078d2$export$dad7991f0d7c4056), JSON.stringify(credentials));
                            } catch (e) {
                            // Ignore
                            }
                            return credentials;
                        })
                    ];
                });
            });
        };
        var region = config.identityPoolId.split(":")[0];
        this.config = config;
        this.cognitoIdentityClient = new (0, $7cff0f7fd8f7b479$export$e576def690e850f7)({
            fetchRequestHandler: new (0, $f613a28573d9efe6$export$83588b87edbfa7e0)(),
            region: region
        });
    }
    EnhancedAuthentication.prototype.renewCredentials = function() {
        if (!this.credentials || !this.credentials.expiration) return true;
        var renewalTime = new Date(this.credentials.expiration.getTime() - (0, $ccd6d6da69a078d2$export$c28b2e7e641379bf));
        return new Date() > renewalTime;
    };
    return EnhancedAuthentication;
}();


var $cacbc151bd9d066e$export$78244dbb77cfa6b6 = "unknown";
var $cacbc151bd9d066e$export$615157de65e3f194 = "com.amazon.rum";
var $cacbc151bd9d066e$export$110219d0a31c1030 = "com.amazonaws.rum";
var $cacbc151bd9d066e$export$84f67200f3ded68c = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".http_event");
var $cacbc151bd9d066e$export$af74fbcbd614e4a5 = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".xray_trace_event");
var $cacbc151bd9d066e$export$8c3ab4bd9a26c2f = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".largest_contentful_paint_event");
var $cacbc151bd9d066e$export$a24e5072c9708b46 = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".first_input_delay_event");
var $cacbc151bd9d066e$export$28703fd5de30e043 = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".cumulative_layout_shift_event");
var $cacbc151bd9d066e$export$1660e080b62e9eff = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".performance_navigation_event");
var $cacbc151bd9d066e$export$bd86f19f880edb29 = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".performance_resource_event");
var $cacbc151bd9d066e$export$6e97598f167f851c = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".dom_event");
var $cacbc151bd9d066e$export$e673c7c001af6bde = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".js_error_event");
var $cacbc151bd9d066e$export$6f5334262ff98f1c = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".page_view_event");
var $cacbc151bd9d066e$export$a4d240c0ade0f57c = "".concat($cacbc151bd9d066e$export$615157de65e3f194, ".session_start_event");


var $ae9306a1f146dcf0$export$73ef013524b43f54 = /** @class */ function() {
    function InternalPlugin(name) {
        this.enabled = true;
        this.pluginId = InternalPlugin.generatePluginId(name);
    }
    InternalPlugin.generatePluginId = function(name) {
        return "".concat(InternalPlugin.idPrefix, ".").concat(name);
    };
    InternalPlugin.prototype.load = function(context) {
        var _a;
        this.context = context;
        (_a = this.onload) === null || _a === void 0 || _a.call(this);
    };
    InternalPlugin.prototype.getPluginId = function() {
        return this.pluginId;
    };
    InternalPlugin.idPrefix = (0, $cacbc151bd9d066e$export$110219d0a31c1030);
    return InternalPlugin;
}();


/**
 * The plugin manager maintains a list of plugins
 * and notifies plugins of configuration or lifecycle changes.
 */ var $ac29891f63733f60$export$f2c0a16002429d72 = /** @class */ function() {
    function PluginManager(context) {
        this.context = context;
        this.plugins = new Map();
    }
    /**
     * Add an event plugin to PluginManager and initialize the plugin.
     *
     * @param plugin The plugin which adheres to the RUM web client's plugin interface.
     */ PluginManager.prototype.addPlugin = function(plugin) {
        var pluginId = plugin.getPluginId();
        if (this.hasPlugin(pluginId)) throw new Error('Plugin "'.concat(pluginId, '" already defined in the PluginManager'));
        this.plugins.set(pluginId, plugin);
        // initialize plugin
        plugin.load(this.context);
    };
    /**
     * Update an event plugin
     *
     * @param pluginId
     * @param updateWith The config to update the plugin with.
     */ PluginManager.prototype.updatePlugin = function(pluginId, updateWith) {
        var _a;
        var plugin = this.getPlugin(pluginId);
        (_a = plugin === null || plugin === void 0 ? void 0 : plugin.update) === null || _a === void 0 || _a.call(plugin, updateWith);
    };
    /**
     * Enable all event plugins.
     */ PluginManager.prototype.enable = function() {
        this.plugins.forEach(function(p) {
            return p.enable();
        });
    };
    /**
     * Disable all event plugins.
     */ PluginManager.prototype.disable = function() {
        this.plugins.forEach(function(p) {
            return p.disable();
        });
    };
    /**
     * Return if a plugin exists.
     *
     * @param pluginId a unique identifier for the plugin
     */ PluginManager.prototype.hasPlugin = function(pluginId) {
        return Boolean(this.getPlugin(pluginId));
    };
    /**
     * Manually record data using a plugin.
     *
     * @param pluginId The unique identifier for the plugin being configured.
     * @param data The data to be recorded by the plugin.
     */ PluginManager.prototype.record = function(pluginId, data) {
        var plugin = this.getPlugin(pluginId);
        if ((plugin === null || plugin === void 0 ? void 0 : plugin.record) instanceof Function) plugin.record(data);
        else throw new Error("AWS RUM Client record: Invalid plugin ID");
    };
    PluginManager.prototype.getPlugin = function(id) {
        var _a;
        return (_a = this.plugins.get(id)) !== null && _a !== void 0 ? _a : this.plugins.get((0, $ae9306a1f146dcf0$export$73ef013524b43f54).generatePluginId(id));
    };
    return PluginManager;
}();




var $3696a3f13124f66d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3696a3f13124f66d$var$__assign = undefined && undefined.__assign || function() {
    $3696a3f13124f66d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3696a3f13124f66d$var$__assign.apply(this, arguments);
};
var $3696a3f13124f66d$export$951d4df55ff80b15 = "dom-event";
var $3696a3f13124f66d$var$defaultConfig = {
    interactionId: function() {
        return "";
    },
    enableMutationObserver: false,
    events: []
};
var $3696a3f13124f66d$export$51f3305bbc42a4a1 = /** @class */ function(_super) {
    $3696a3f13124f66d$var$__extends(DomEventPlugin, _super);
    function DomEventPlugin(config) {
        var _this = _super.call(this, $3696a3f13124f66d$export$951d4df55ff80b15) || this;
        _this.enabled = false;
        _this.eventListenerMap = new Map();
        _this.config = $3696a3f13124f66d$var$__assign($3696a3f13124f66d$var$__assign({}, $3696a3f13124f66d$var$defaultConfig), config);
        return _this;
    }
    DomEventPlugin.getElementInfo = function(event) {
        var elementInfo = {
            name: "UNKNOWN"
        };
        if (event.target instanceof Node) elementInfo.name = event.target.nodeName;
        if (event.target instanceof Element && event.target.id) elementInfo.id = event.target.id;
        return elementInfo;
    };
    DomEventPlugin.prototype.enable = function() {
        var _this = this;
        if (document.readyState !== "complete") {
            window.addEventListener("load", function() {
                return _this.enable();
            });
            return;
        }
        if (this.enabled) return;
        this.addListeners();
        if (this.config.enableMutationObserver) this.observeDOMMutation();
        this.enabled = true;
    };
    DomEventPlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.removeListeners();
        if (this.observer) this.observer.disconnect();
        this.enabled = false;
    };
    DomEventPlugin.prototype.update = function(events) {
        var _this = this;
        events.forEach(function(domEvent) {
            _this.addEventHandler(domEvent);
            _this.config.events.push(domEvent);
        });
    };
    DomEventPlugin.prototype.onload = function() {
        this.enable();
    };
    DomEventPlugin.prototype.removeListeners = function() {
        var _this = this;
        this.config.events.forEach(function(domEvent) {
            return _this.removeEventHandler(domEvent);
        });
    };
    DomEventPlugin.prototype.addListeners = function() {
        var _this = this;
        this.config.events.forEach(function(domEvent) {
            return _this.addEventHandler(domEvent);
        });
    };
    DomEventPlugin.prototype.getEventListener = function(cssLocator) {
        var _this = this;
        return function(event) {
            var _a;
            var elementInfo = DomEventPlugin.getElementInfo(event);
            var interactionId = _this.config.interactionId(event);
            var eventData = $3696a3f13124f66d$var$__assign($3696a3f13124f66d$var$__assign($3696a3f13124f66d$var$__assign({
                version: "1.1.0",
                event: event.type,
                element: elementInfo.name
            }, elementInfo.id ? {
                elementId: elementInfo.id
            } : {}), interactionId ? {
                interactionId: interactionId
            } : {}), cssLocator ? {
                cssLocator: cssLocator
            } : {});
            if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) _this.context.record((0, $cacbc151bd9d066e$export$6e97598f167f851c), eventData);
        };
    };
    DomEventPlugin.prototype.addEventHandler = function(domEvent) {
        var eventType = domEvent.event;
        var eventListener = this.getEventListener(domEvent.cssLocator);
        var identifiedElementList = [];
        var elementEventListenerList = this.eventListenerMap.has(domEvent) ? this.eventListenerMap.get(domEvent) : [];
        // first add event listener to all elements identified by the CSS locator
        if (domEvent.cssLocator) {
            var cssLocatedElements = document.querySelectorAll(domEvent.cssLocator);
            cssLocatedElements.forEach(function(element) {
                identifiedElementList.push(element);
            });
        } else if (domEvent.elementId) {
            var identifiedElement = document.getElementById(domEvent.elementId);
            if (identifiedElement) identifiedElementList.push(identifiedElement);
        } else if (domEvent.element) identifiedElementList.push(domEvent.element);
        identifiedElementList.forEach(function(element) {
            element.addEventListener(eventType, eventListener);
            elementEventListenerList.push({
                element: element,
                eventListener: eventListener
            });
        });
        this.eventListenerMap.set(domEvent, elementEventListenerList);
    };
    DomEventPlugin.prototype.removeEventHandler = function(domEvent) {
        var elementEventListenerList = this.eventListenerMap.get(domEvent);
        if (elementEventListenerList) {
            elementEventListenerList.forEach(function(elementEventListener) {
                var element = elementEventListener.element;
                var eventListener = elementEventListener.eventListener;
                element.removeEventListener(domEvent.event, eventListener);
            });
            this.eventListenerMap.delete(domEvent);
        }
    };
    DomEventPlugin.prototype.observeDOMMutation = function() {
        var _this = this;
        this.observer = new MutationObserver(function() {
            _this.removeListeners();
            _this.addListeners();
        });
        //  we track only changes to nodes/DOM elements, not attributes or characterData
        this.observer.observe(document, {
            childList: true,
            subtree: true
        });
    };
    return DomEventPlugin;
}((0, $ae9306a1f146dcf0$export$73ef013524b43f54));




var $5dbe6f89bc325e6b$var$isObject = function(error) {
    var type = typeof error;
    return (type === "object" || type === "function") && !!error;
};
var $5dbe6f89bc325e6b$var$buildBaseJsErrorEvent = function(errorEvent) {
    var rumEvent = {
        version: "1.0.0",
        type: "undefined",
        message: "undefined"
    };
    if (errorEvent.type !== undefined) rumEvent.type = errorEvent.type;
    if (errorEvent.message !== undefined) rumEvent.message = errorEvent.message;
    if (errorEvent.filename !== undefined) rumEvent.filename = errorEvent.filename;
    if (errorEvent.lineno !== undefined) rumEvent.lineno = errorEvent.lineno;
    if (errorEvent.colno !== undefined) rumEvent.colno = errorEvent.colno;
    return rumEvent;
};
var $5dbe6f89bc325e6b$var$appendErrorPrimitiveDetails = function(rumEvent, error) {
    // Keep unhandledrejection as type as it will write to rumEvent.message
    if (rumEvent.type !== "unhandledrejection") rumEvent.type = error.toString();
    rumEvent.message = error.toString();
};
var $5dbe6f89bc325e6b$var$appendErrorObjectDetails = function(rumEvent, error, stackTraceLength) {
    // error may extend Error here, but it is not guaranteed (i.e., it could
    // be any object)
    if (error.name) rumEvent.type = error.name;
    if (error.message) rumEvent.message = error.message;
    if (error.fileName) rumEvent.filename = error.fileName;
    if (error.lineNumber) rumEvent.lineno = error.lineNumber;
    if (error.columnNumber) rumEvent.colno = error.columnNumber;
    if (stackTraceLength && error.stack) rumEvent.stack = error.stack.length > stackTraceLength ? error.stack.substring(0, stackTraceLength) + "..." : error.stack;
};
var $5dbe6f89bc325e6b$export$1ffd2901c8f56573 = function(error) {
    return error !== Object(error) && error !== undefined && error !== null;
};
var $5dbe6f89bc325e6b$export$538c3c92a1912723 = function(errorEvent, stackTraceLength) {
    var rumEvent = $5dbe6f89bc325e6b$var$buildBaseJsErrorEvent(errorEvent);
    var error = errorEvent.error;
    if ($5dbe6f89bc325e6b$var$isObject(error)) $5dbe6f89bc325e6b$var$appendErrorObjectDetails(rumEvent, error, stackTraceLength);
    else if ($5dbe6f89bc325e6b$export$1ffd2901c8f56573(error)) $5dbe6f89bc325e6b$var$appendErrorPrimitiveDetails(rumEvent, error);
    return rumEvent;
};


var $a0eaa7e3f73d8780$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a0eaa7e3f73d8780$var$__assign = undefined && undefined.__assign || function() {
    $a0eaa7e3f73d8780$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a0eaa7e3f73d8780$var$__assign.apply(this, arguments);
};
var $a0eaa7e3f73d8780$export$e5e1e9745ffa96a1 = "js-error";
var $a0eaa7e3f73d8780$var$defaultConfig = {
    stackTraceLength: 1000,
    ignore: function() {
        return false;
    }
};
var $a0eaa7e3f73d8780$export$61c5f910fd4dc4fe = /** @class */ function(_super) {
    $a0eaa7e3f73d8780$var$__extends(JsErrorPlugin, _super);
    function JsErrorPlugin(config) {
        var _this = _super.call(this, $a0eaa7e3f73d8780$export$e5e1e9745ffa96a1) || this;
        _this.eventHandler = function(errorEvent) {
            if (!_this.config.ignore(errorEvent)) _this.recordJsErrorEvent(errorEvent);
        };
        _this.promiseRejectEventHandler = function(event) {
            if (!_this.config.ignore(event)) _this.recordJsErrorEvent({
                type: event.type,
                error: event.reason
            });
        };
        _this.config = $a0eaa7e3f73d8780$var$__assign($a0eaa7e3f73d8780$var$__assign({}, $a0eaa7e3f73d8780$var$defaultConfig), config);
        return _this;
    }
    JsErrorPlugin.prototype.enable = function() {
        if (this.enabled) return;
        this.addEventHandler();
        this.enabled = true;
    };
    JsErrorPlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.removeEventHandler();
        this.enabled = false;
    };
    JsErrorPlugin.prototype.record = function(error) {
        if (error instanceof ErrorEvent) this.recordJsErrorEvent(error);
        else this.recordJsErrorEvent({
            type: "error",
            error: error
        });
    };
    JsErrorPlugin.prototype.onload = function() {
        this.addEventHandler();
    };
    JsErrorPlugin.prototype.recordJsErrorEvent = function(error) {
        var _a;
        (_a = this.context) === null || _a === void 0 || _a.record((0, $cacbc151bd9d066e$export$e673c7c001af6bde), (0, $5dbe6f89bc325e6b$export$538c3c92a1912723)(error, this.config.stackTraceLength));
    };
    JsErrorPlugin.prototype.addEventHandler = function() {
        window.addEventListener("error", this.eventHandler);
        window.addEventListener("unhandledrejection", this.promiseRejectEventHandler);
    };
    JsErrorPlugin.prototype.removeEventHandler = function() {
        window.removeEventListener("error", this.eventHandler);
        window.removeEventListener("unhandledrejection", this.promiseRejectEventHandler);
    };
    return JsErrorPlugin;
}((0, $ae9306a1f146dcf0$export$73ef013524b43f54));


/**
 * Stores a cookie.
 *
 * @param name The cookie's name.
 * @param value The cookie's value.
 * @param attributes The domain where the cookie will be stored.
 * @param ttl Time to live -- expiry date is current date + ttl (do not use with {@code expires}).
 * @param expires The expiry date for the cookie (do not use with {@code ttl})
 */ var $dae870086b5e8ad6$export$6f59bc15f23c19f8 = function(name, value, attributes, ttl, expires) {
    var cookie = name + "=";
    cookie += value || "";
    if (expires !== undefined) cookie += "; Expires=".concat(expires.toUTCString());
    else if (ttl !== undefined) cookie += "; Expires=".concat($dae870086b5e8ad6$export$9c495c83dc2499f5(ttl).toUTCString());
    cookie += "; Domain=".concat(attributes.domain);
    cookie += "; Path=".concat(attributes.path);
    cookie += "; SameSite=".concat(attributes.sameSite);
    cookie += attributes.secure ? "; Secure" : "";
    document.cookie = cookie;
};
var $dae870086b5e8ad6$export$9c495c83dc2499f5 = function(ttl) {
    return new Date(new Date().getTime() + ttl * 1000);
};
var $dae870086b5e8ad6$export$6a874b7a74007875 = function(name, attributes) {
    var cookie = name + "=";
    cookie += "; Expires=".concat(new Date(0));
    cookie += "; Domain=".concat(attributes.domain);
    cookie += "; Path=".concat(attributes.path);
    cookie += "; SameSite=".concat(attributes.sameSite);
    cookie += attributes.secure ? "Secure" : "";
    document.cookie = cookie;
};
var $dae870086b5e8ad6$export$4be65e66cfa2648a = function(name) {
    var cookies = document.cookie.split("; ");
    for(var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++){
        var cookie = cookies_1[_i];
        var split = cookie.split("=");
        if (split[0] === name) return split[1];
    }
    return "";
};


const $c7def13706923903$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $c7def13706923903$export$2e2bcd8739ae039 = {
    randomUUID: $c7def13706923903$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $00300c718b1538b6$var$getRandomValues;
const $00300c718b1538b6$var$rnds8 = new Uint8Array(16);
function $00300c718b1538b6$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$00300c718b1538b6$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $00300c718b1538b6$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$00300c718b1538b6$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $00300c718b1538b6$var$getRandomValues($00300c718b1538b6$var$rnds8);
}


var $0536500b83143766$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $b1891cbde82e260a$var$validate(uuid) {
    return typeof uuid === "string" && (0, $0536500b83143766$export$2e2bcd8739ae039).test(uuid);
}
var $b1891cbde82e260a$export$2e2bcd8739ae039 = $b1891cbde82e260a$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $3f8f6077a5ea3635$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$3f8f6077a5ea3635$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $3f8f6077a5ea3635$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return ($3f8f6077a5ea3635$var$byteToHex[arr[offset + 0]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 1]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 2]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 3]] + "-" + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 4]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 5]] + "-" + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 6]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 7]] + "-" + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 8]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 9]] + "-" + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 10]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 11]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 12]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 13]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 14]] + $3f8f6077a5ea3635$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $3f8f6077a5ea3635$var$stringify(arr, offset = 0) {
    const uuid = $3f8f6077a5ea3635$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $b1891cbde82e260a$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $3f8f6077a5ea3635$export$2e2bcd8739ae039 = $3f8f6077a5ea3635$var$stringify;


function $7161f86fd2ed93bf$var$v4(options, buf, offset) {
    if ((0, $c7def13706923903$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $c7def13706923903$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $00300c718b1538b6$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $3f8f6077a5ea3635$export$8fb373d660548968)(rnds);
}
var $7161f86fd2ed93bf$export$2e2bcd8739ae039 = $7161f86fd2ed93bf$var$v4;



var $45Dw0 = parcelRequire("45Dw0");

var $0c795222251ee7c6$var$__assign = undefined && undefined.__assign || function() {
    $0c795222251ee7c6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0c795222251ee7c6$var$__assign.apply(this, arguments);
};
var $0c795222251ee7c6$export$c20df8434f9b1523 = "00000000-0000-0000-0000-000000000000";
var $0c795222251ee7c6$export$78244dbb77cfa6b6 = "unknown";
var $0c795222251ee7c6$export$c4af2ee52695516e = "desktop";
var $0c795222251ee7c6$export$14648ac0ee4d6882 = "web";
var $0c795222251ee7c6$export$a4d240c0ade0f57c = "com.amazon.rum.session_start_event";
var $0c795222251ee7c6$export$6f5f7a20f1731409 = "rum_session_start";
var $0c795222251ee7c6$export$4121f8db47b4dbc7 = "rum_session_expire";
/**
 * The session handler handles user id and session id.
 *
 * A session is the {user id, session id} tuple which groups events that occur on a single browser over a continuous
 * period of time. A session begins when no session exists or the last session has expired. If user id does not exist,
 * session handler will assign a new one and store it in cookie. If session id does not exist or has expired, session
 * handler will assign a new one and store it in cookie. Session handler detects user interactions and updates session
 * id expiration time.
 */ var $0c795222251ee7c6$export$415798a788f40554 = /** @class */ function() {
    function SessionManager(appMonitorDetails, config, record, pageManager) {
        this.appMonitorDetails = appMonitorDetails;
        this.config = config;
        this.record = record;
        this.pageManager = pageManager;
        // Initialize the session to the nil session
        this.session = {
            sessionId: $0c795222251ee7c6$export$c20df8434f9b1523,
            record: this.sample(),
            eventCount: 0
        };
        // Initialize or restore the user
        this.initializeUser();
        // Collect the user agent and domain
        this.collectAttributes();
        // Set custom session attributes
        this.addSessionAttributes(this.config.sessionAttributes);
        // Attempt to restore the previous session
        this.getSessionFromCookie();
    }
    /**
     * Returns the session ID. If no session ID exists, one will be created.
     */ SessionManager.prototype.getSession = function() {
        if (this.session.sessionId === $0c795222251ee7c6$export$c20df8434f9b1523) // The session does not exist. Create a new one.
        this.createSession();
        else if (this.session.sessionId !== $0c795222251ee7c6$export$c20df8434f9b1523 && new Date() > this.sessionExpiry) // The session has expired. Create a new one.
        this.createSession();
        return this.session;
    };
    SessionManager.prototype.getAttributes = function() {
        return this.attributes;
    };
    /**
     * Adds custom session attributes to the session's attributes
     *
     * @param sessionAttributes object containing custom attribute data in the form of key, value pairs
     */ SessionManager.prototype.addSessionAttributes = function(sessionAttributes) {
        this.attributes = $0c795222251ee7c6$var$__assign($0c795222251ee7c6$var$__assign({}, sessionAttributes), this.attributes);
    };
    SessionManager.prototype.getUserId = function() {
        if (this.useCookies()) return this.userId;
        return $0c795222251ee7c6$export$c20df8434f9b1523;
    };
    SessionManager.prototype.incrementSessionEventCount = function() {
        this.session.eventCount++;
        this.renewSession();
    };
    SessionManager.prototype.initializeUser = function() {
        var userId = "";
        this.userExpiry = new Date();
        this.userExpiry.setDate(this.userExpiry.getDate() + this.config.userIdRetentionDays);
        if (this.config.userIdRetentionDays <= 0) // Use the 'nil' UUID when the user ID will not be retained
        this.userId = "00000000-0000-0000-0000-000000000000";
        else if (this.useCookies()) {
            userId = this.getUserIdCookie();
            this.userId = userId ? userId : (0, $7161f86fd2ed93bf$export$2e2bcd8739ae039)();
            this.createOrRenewUserCookie(userId, this.userExpiry);
        } else this.userId = (0, $7161f86fd2ed93bf$export$2e2bcd8739ae039)();
    };
    SessionManager.prototype.createOrRenewSessionCookie = function(session, expires) {
        if (btoa) (0, $dae870086b5e8ad6$export$6f59bc15f23c19f8)(this.sessionCookieName(), btoa(JSON.stringify(session)), this.config.cookieAttributes, undefined, expires);
    };
    SessionManager.prototype.createOrRenewUserCookie = function(userId, expires) {
        (0, $dae870086b5e8ad6$export$6f59bc15f23c19f8)((0, $ccd6d6da69a078d2$export$8dadb2caf2a12c09), userId, this.config.cookieAttributes, undefined, expires);
    };
    SessionManager.prototype.getUserIdCookie = function() {
        return (0, $dae870086b5e8ad6$export$4be65e66cfa2648a)((0, $ccd6d6da69a078d2$export$8dadb2caf2a12c09));
    };
    SessionManager.prototype.getSessionFromCookie = function() {
        if (this.useCookies()) {
            var cookie = (0, $dae870086b5e8ad6$export$4be65e66cfa2648a)(this.sessionCookieName());
            if (cookie && atob) try {
                this.session = JSON.parse(atob(cookie));
                this.pageManager.resumeSession(this.session.page);
            } catch (e) {
            // Error decoding or parsing the cookie -- ignore
            }
        }
    };
    SessionManager.prototype.storeSessionAsCookie = function() {
        if (this.useCookies() && this.config.userIdRetentionDays > 0) this.createOrRenewUserCookie(this.userId, this.userExpiry);
        if (this.useCookies()) // Set the user cookie in case useCookies() has changed from false to true.
        this.createOrRenewSessionCookie(this.session, this.sessionExpiry);
    };
    SessionManager.prototype.createSession = function() {
        this.session = {
            sessionId: (0, $7161f86fd2ed93bf$export$2e2bcd8739ae039)(),
            record: this.sample(),
            eventCount: 0
        };
        this.session.page = this.pageManager.getPage();
        this.sessionExpiry = new Date(new Date().getTime() + this.config.sessionLengthSeconds * 1000);
        this.storeSessionAsCookie();
        this.record(this.session, $0c795222251ee7c6$export$a4d240c0ade0f57c, {
            version: "1.0.0"
        });
    };
    SessionManager.prototype.renewSession = function() {
        this.sessionExpiry = new Date(new Date().getTime() + this.config.sessionLengthSeconds * 1000);
        this.session.page = this.pageManager.getPage();
        this.storeSessionAsCookie();
    };
    SessionManager.prototype.collectAttributes = function() {
        var ua = new (0, $45Dw0.UAParser)(navigator.userAgent).getResult();
        this.attributes = {
            browserLanguage: navigator.language,
            browserName: ua.browser.name ? ua.browser.name : $0c795222251ee7c6$export$78244dbb77cfa6b6,
            browserVersion: ua.browser.version ? ua.browser.version : $0c795222251ee7c6$export$78244dbb77cfa6b6,
            osName: ua.os.name ? ua.os.name : $0c795222251ee7c6$export$78244dbb77cfa6b6,
            osVersion: ua.os.version ? ua.os.version : $0c795222251ee7c6$export$78244dbb77cfa6b6,
            // Possible device types include {console, mobile, tablet, smarttv, wearable, embedded}. If the device
            // type is undefined, there was no information indicating the device is anything other than a desktop,
            // so we assume the device is a desktop.
            deviceType: ua.device.type ? ua.device.type : $0c795222251ee7c6$export$c4af2ee52695516e,
            // This client is used exclusively in web applications.
            platformType: $0c795222251ee7c6$export$14648ac0ee4d6882,
            domain: window.location.hostname
        };
    };
    /**
     * Returns true when cookies should be used to store user ID and session ID.
     */ SessionManager.prototype.useCookies = function() {
        return navigator.cookieEnabled && this.config.allowCookies;
    };
    /**
     * Returns {@code true} when the session has been selected to be recorded.
     */ SessionManager.prototype.sample = function() {
        return Math.random() < this.config.sessionSampleRate;
    };
    SessionManager.prototype.sessionCookieName = function() {
        if (this.config.cookieAttributes.unique) return "".concat((0, $ccd6d6da69a078d2$export$63cf0d84d808ffcc), "_").concat(this.appMonitorDetails.id);
        return 0, $ccd6d6da69a078d2$export$63cf0d84d808ffcc;
    };
    return SessionManager;
}();




var $5ebbca0626b6716a$exports = {};
"use strict";
function $5ebbca0626b6716a$var$isFunction(funktion) {
    return typeof funktion === "function";
}
// Default to complaining loudly when things don't go according to plan.
var $5ebbca0626b6716a$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $5ebbca0626b6716a$var$defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
// Keep initialization idempotent.
function $5ebbca0626b6716a$var$shimmer(options) {
    if (options && options.logger) {
        if (!$5ebbca0626b6716a$var$isFunction(options.logger)) $5ebbca0626b6716a$var$logger("new logger isn't a function, not replacing");
        else $5ebbca0626b6716a$var$logger = options.logger;
    }
}
function $5ebbca0626b6716a$var$wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        $5ebbca0626b6716a$var$logger("no original function " + name + " to wrap");
        return;
    }
    if (!wrapper) {
        $5ebbca0626b6716a$var$logger("no wrapper function");
        $5ebbca0626b6716a$var$logger(new Error().stack);
        return;
    }
    if (!$5ebbca0626b6716a$var$isFunction(nodule[name]) || !$5ebbca0626b6716a$var$isFunction(wrapper)) {
        $5ebbca0626b6716a$var$logger("original object and wrapper must be functions");
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    $5ebbca0626b6716a$var$defineProperty(wrapped, "__original", original);
    $5ebbca0626b6716a$var$defineProperty(wrapped, "__unwrap", function() {
        if (nodule[name] === wrapped) $5ebbca0626b6716a$var$defineProperty(nodule, name, original);
    });
    $5ebbca0626b6716a$var$defineProperty(wrapped, "__wrapped", true);
    $5ebbca0626b6716a$var$defineProperty(nodule, name, wrapped);
    return wrapped;
}
function $5ebbca0626b6716a$var$massWrap(nodules, names, wrapper) {
    if (!nodules) {
        $5ebbca0626b6716a$var$logger("must provide one or more modules to patch");
        $5ebbca0626b6716a$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $5ebbca0626b6716a$var$logger("must provide one or more functions to wrap on modules");
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $5ebbca0626b6716a$var$wrap(nodule, name, wrapper);
        });
    });
}
function $5ebbca0626b6716a$var$unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        $5ebbca0626b6716a$var$logger("no function to unwrap.");
        $5ebbca0626b6716a$var$logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) $5ebbca0626b6716a$var$logger("no original to unwrap to -- has " + name + " already been unwrapped?");
    else return nodule[name].__unwrap();
}
function $5ebbca0626b6716a$var$massUnwrap(nodules, names) {
    if (!nodules) {
        $5ebbca0626b6716a$var$logger("must provide one or more modules to patch");
        $5ebbca0626b6716a$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $5ebbca0626b6716a$var$logger("must provide one or more functions to unwrap on modules");
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            $5ebbca0626b6716a$var$unwrap(nodule, name);
        });
    });
}
$5ebbca0626b6716a$var$shimmer.wrap = $5ebbca0626b6716a$var$wrap;
$5ebbca0626b6716a$var$shimmer.massWrap = $5ebbca0626b6716a$var$massWrap;
$5ebbca0626b6716a$var$shimmer.unwrap = $5ebbca0626b6716a$var$unwrap;
$5ebbca0626b6716a$var$shimmer.massUnwrap = $5ebbca0626b6716a$var$massUnwrap;
$5ebbca0626b6716a$exports = $5ebbca0626b6716a$var$shimmer;



var $4cecd53d91524cf5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4cecd53d91524cf5$export$97e8843a4d399c46 = /** @class */ function(_super) {
    $4cecd53d91524cf5$var$__extends(MonkeyPatched, _super);
    function MonkeyPatched() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enable = _this.patch.bind(_this, true);
        _this.disable = _this.patch.bind(_this, false);
        _this.enabled = false;
        return _this;
    }
    MonkeyPatched.prototype.patchAll = function() {
        var wrap = $5ebbca0626b6716a$exports.wrap.bind($5ebbca0626b6716a$exports);
        for(var _i = 0, _a = this.patches; _i < _a.length; _i++){
            var patch = _a[_i];
            wrap(patch.nodule, patch.name, patch.wrapper());
        }
    };
    MonkeyPatched.prototype.unpatchAll = function() {
        var unwrap = $5ebbca0626b6716a$exports.unwrap.bind($5ebbca0626b6716a$exports);
        for(var _i = 0, _a = this.patches; _i < _a.length; _i++){
            var patch = _a[_i];
            unwrap(patch.nodule, patch.name);
        }
    };
    MonkeyPatched.prototype.patch = function(shouldPatch) {
        if (shouldPatch === void 0) shouldPatch = true;
        if (this.enabled !== shouldPatch) {
            this.enabled = shouldPatch;
            if (shouldPatch) this.patchAll();
            else this.unpatchAll();
        }
    };
    return MonkeyPatched;
}((0, $ae9306a1f146dcf0$export$73ef013524b43f54));


var $3b531402d51ecbb6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Maintains the core logic for virtual page load timing functionality.
 * (1) Holds all virtual page load timing related resources
 * (2) Intercepts outgoing XMLHttpRequests and Fetch requests and listens for DOM changes
 * (3) Records virtual page load
 */ var $3b531402d51ecbb6$export$fdda9bd99b4036f7 = /** @class */ function(_super) {
    $3b531402d51ecbb6$var$__extends(VirtualPageLoadTimer, _super);
    function VirtualPageLoadTimer(pageManager, config, record) {
        var _this = _super.call(this, "virtual-page-load-timer") || this;
        _this.sendWrapper = function() {
            var self = _this;
            return function(original) {
                return function() {
                    self.recordXhr(this);
                    this.addEventListener("loadend", self.endTracking);
                    return original.apply(this, arguments);
                };
            };
        };
        /**
         * Removes the current event from either requestBuffer or ongoingRequests set.
         *
         * @param event
         */ _this.endTracking = function(e) {
            var currTime = Date.now();
            var xhr = e.target;
            xhr.removeEventListener("loadend", _this.endTracking);
            _this.removeXhr(xhr, currTime);
        };
        _this.fetch = function(original, thisArg, argsArray) {
            return original.apply(thisArg, argsArray).catch(function(error) {
                throw error;
            }).finally(_this.decrementFetchCounter);
        };
        /**
         * Increment the fetch counter in PageManager when fetch is beginning
         */ _this.fetchWrapper = function() {
            var self = _this;
            return function(original) {
                return function(input, init) {
                    self.fetchCounter += 1;
                    return self.fetch(original, this, arguments);
                };
            };
        };
        _this.decrementFetchCounter = function() {
            if (!_this.isPageLoaded) _this.latestEndTime = Date.now();
            _this.fetchCounter -= 1;
        };
        /**
         * Checks whether the virtual page is still being loaded.
         * If completed:
         * (1) Clear the timers
         * (2) Record data using NavigationEvent
         * (3) Indicate current page has finished loading
         */ _this.checkLoadStatus = function() {
            if (_this.ongoingRequests.size === 0 && _this.fetchCounter === 0) {
                clearInterval(_this.periodicCheckerId);
                clearTimeout(_this.timeoutCheckerId);
                _this.domMutationObserver.disconnect();
                _this.recordRouteChangeNavigationEvent(_this.pageManager.getPage());
                _this.periodicCheckerId = undefined;
                _this.timeoutCheckerId = undefined;
                _this.isPageLoaded = true;
            }
        };
        /** Clears timers and disconnects observer to stop page timing. */ _this.declareTimeout = function() {
            clearInterval(_this.periodicCheckerId);
            _this.periodicCheckerId = undefined;
            _this.timeoutCheckerId = undefined;
            _this.domMutationObserver.disconnect();
            _this.isPageLoaded = true;
        };
        _this.resetInterval = function() {
            _this.latestEndTime = Date.now();
            clearInterval(_this.periodicCheckerId);
            _this.periodicCheckerId = setInterval(_this.checkLoadStatus, _this.config.routeChangeComplete);
        };
        _this.moveItemsFromBuffer = function(item) {
            _this.ongoingRequests.add(item);
        };
        _this.updateLatestInteractionTime = function(e) {
            _this.latestInteractionTime = Date.now();
        };
        _this.periodicCheckerId = undefined;
        _this.timeoutCheckerId = undefined;
        _this.domMutationObserver = new MutationObserver(_this.resetInterval);
        _this.ongoingRequests = new Set();
        _this.requestBuffer = new Set();
        _this.fetchCounter = 0;
        _this.isPageLoaded = true;
        _this.latestEndTime = 0;
        _this.latestInteractionTime = 0;
        _this.config = config;
        _this.pageManager = pageManager;
        _this.record = record;
        _this.enable();
        // Start tracking the timestamps
        document.addEventListener("mousedown", _this.updateLatestInteractionTime);
        document.addEventListener("keydown", _this.updateLatestInteractionTime);
        return _this;
    }
    Object.defineProperty(VirtualPageLoadTimer.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: XMLHttpRequest.prototype,
                    name: "send",
                    wrapper: this.sendWrapper
                },
                {
                    nodule: window,
                    name: "fetch",
                    wrapper: this.fetchWrapper
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    /** Initializes timing related resources for current page. */ VirtualPageLoadTimer.prototype.startTiming = function() {
        this.latestEndTime = Date.now();
        // Clean up existing timer objects and mutationObserver
        if (this.periodicCheckerId) clearInterval(this.periodicCheckerId);
        if (this.timeoutCheckerId) clearTimeout(this.timeoutCheckerId);
        this.domMutationObserver.disconnect();
        // Initialize timer objects and start observing
        this.periodicCheckerId = setInterval(this.checkLoadStatus, this.config.routeChangeComplete);
        this.timeoutCheckerId = setTimeout(this.declareTimeout, this.config.routeChangeTimeout);
        // observing the add/delete of nodes
        this.domMutationObserver.observe(document, {
            subtree: true,
            childList: true,
            attributes: false,
            characterData: false
        });
        // Indicate page has not loaded, and carry over buffered requests.
        this.isPageLoaded = false;
        this.requestBuffer.forEach(this.moveItemsFromBuffer);
        this.requestBuffer.clear();
    };
    VirtualPageLoadTimer.prototype.recordXhr = function(item) {
        var page = this.pageManager.getPage();
        if (page && this.isPageLoaded === false) this.ongoingRequests.add(item);
        else this.requestBuffer.add(item);
    };
    VirtualPageLoadTimer.prototype.removeXhr = function(item, currTime) {
        var page = this.pageManager.getPage();
        if (page && this.ongoingRequests.has(item)) {
            this.ongoingRequests.delete(item);
            this.latestEndTime = currTime;
        } else if (this.requestBuffer.has(item)) this.requestBuffer.delete(item);
    };
    VirtualPageLoadTimer.prototype.recordRouteChangeNavigationEvent = function(page) {
        var virtualPageNavigationEvent = {
            version: "1.0.0",
            initiatorType: "route_change",
            navigationType: "navigate",
            startTime: page.start,
            duration: this.latestEndTime - page.start
        };
        if (this.record) this.record((0, $cacbc151bd9d066e$export$1660e080b62e9eff), virtualPageNavigationEvent);
    };
    return VirtualPageLoadTimer;
}((0, $4cecd53d91524cf5$export$97e8843a4d399c46));



var $a87d84a285c6c894$var$__assign = undefined && undefined.__assign || function() {
    $a87d84a285c6c894$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a87d84a285c6c894$var$__assign.apply(this, arguments);
};
/**
 * The page manager keeps the state of the current page and interaction level.
 *
 * A page is a unique view (user interface) of the application. For 'multi page' applications (i.e., 'classic' web
 * applications that have multiple html files), the page changes when the user navigates to a new web page. For
 * 'single page' applications (i.e., 'ajax' web applications that have a single html file), the page changes when (1)
 * the popstate event emitted, or (2) the application indicates a new page has loaded using the RUM agent API.
 *
 * The interaction level is the order of a page in the sequence of pages sorted by the time they were viewed.
 */ var $a87d84a285c6c894$export$b47b1e333f1bf2a6 = /** @class */ function() {
    function PageManager(config, record) {
        this.TIMEOUT = 1000;
        this.config = config;
        this.record = record;
        this.page = undefined;
        this.resumed = false;
        this.recordInteraction = false;
        this.virtualPageLoadTimer = new (0, $3b531402d51ecbb6$export$fdda9bd99b4036f7)(this, config, record);
    }
    PageManager.prototype.getPage = function() {
        return this.page;
    };
    PageManager.prototype.getAttributes = function() {
        return this.attributes;
    };
    PageManager.prototype.resumeSession = function(page) {
        this.recordInteraction = true;
        if (page) {
            this.page = page;
            this.resumed = true;
        }
    };
    PageManager.prototype.recordPageView = function(payload) {
        var pageId;
        if (typeof payload === "string") pageId = payload;
        else pageId = payload.pageId;
        if (this.useCookies()) this.recordInteraction = true;
        if (!this.page) this.createLandingPage(pageId);
        else if (this.page.pageId !== pageId) this.createNextPage(this.page, pageId);
        else if (this.resumed) {
            // Update attributes state in PageManager for event metadata
            this.collectAttributes(this.page, typeof payload === "object" ? payload : undefined);
            return;
        } else // The view has not changed.
        return;
        // this.page is guaranteed to have been initialized
        // Attributes will be added to all events as meta data
        this.collectAttributes(this.page, typeof payload === "object" ? payload : undefined);
        // The SessionManager will update its cookie with the new page
        this.recordPageViewEvent(this.page);
    };
    PageManager.prototype.createNextPage = function(currentPage, pageId) {
        var startTime = Date.now();
        var interactionTime = this.virtualPageLoadTimer.latestInteractionTime;
        // The latest interaction time (latest) is not guaranteed to be the
        // interaction that triggered the route change (actual). There are two
        // cases to consider:
        //
        // 1. Latest is older than actual. This can happen if the user navigates
        // with the browser back/forward button, or if the interaction is not a
        // click/keyup event.
        //
        // 2. Latest is newer than actual. This can happen if the user clicks or
        // types in the time between actual and when recordPageView is called.
        //
        // We believe that case (1) has a high risk of skewing route change
        // timing metrics because (a) browser navigation is common and (b) there
        // is no limit on when the latest interaction may have occurred. To
        // help mitigate this, if the route change is already longer than 1000ms,
        // then we do not bother timing the route change.
        //
        // We do not believe that case (2) has a high risk of skewing route
        // change timing, and therefore ignore case (2).
        if (!this.resumed && startTime - interactionTime <= this.TIMEOUT) {
            startTime = interactionTime;
            this.virtualPageLoadTimer.startTiming();
        }
        this.timeOnParentPage = startTime - currentPage.start;
        this.resumed = false;
        this.page = {
            pageId: pageId,
            parentPageId: currentPage.pageId,
            interaction: currentPage.interaction + 1,
            referrer: document.referrer,
            referrerDomain: this.getDomainFromReferrer(),
            start: startTime
        };
    };
    PageManager.prototype.createLandingPage = function(pageId) {
        this.page = {
            pageId: pageId,
            interaction: 0,
            referrer: document.referrer,
            referrerDomain: this.getDomainFromReferrer(),
            start: Date.now()
        };
    };
    PageManager.prototype.collectAttributes = function(page, customPageAttributes) {
        this.attributes = {
            title: document.title,
            pageId: page.pageId
        };
        if (this.recordInteraction) {
            this.attributes.interaction = page.interaction;
            if (page.parentPageId !== undefined) this.attributes.parentPageId = page.parentPageId;
        }
        if (customPageAttributes === null || customPageAttributes === void 0 ? void 0 : customPageAttributes.pageTags) this.attributes["pageTags"] = customPageAttributes["pageTags"];
        if (customPageAttributes === null || customPageAttributes === void 0 ? void 0 : customPageAttributes.pageAttributes) this.attributes = $a87d84a285c6c894$var$__assign($a87d84a285c6c894$var$__assign({}, customPageAttributes.pageAttributes), this.attributes);
    };
    PageManager.prototype.createPageViewEvent = function(page) {
        var pageViewEvent = {
            version: "1.0.0",
            pageId: page.pageId
        };
        if (this.recordInteraction) {
            pageViewEvent.interaction = page.interaction;
            pageViewEvent.pageInteractionId = page.pageId + "-" + page.interaction;
            if (page.parentPageId !== undefined) {
                pageViewEvent.parentPageInteractionId = page.parentPageId + "-" + (page.interaction - 1);
                pageViewEvent.timeOnParentPage = this.timeOnParentPage;
            }
            pageViewEvent.referrer = document.referrer;
            pageViewEvent.referrerDomain = this.getDomainFromReferrer();
        }
        return pageViewEvent;
    };
    PageManager.prototype.recordPageViewEvent = function(page) {
        this.record((0, $cacbc151bd9d066e$export$6f5334262ff98f1c), this.createPageViewEvent(page));
    };
    /**
     * Returns true when cookies should be used to store user ID and session ID.
     */ PageManager.prototype.useCookies = function() {
        return navigator.cookieEnabled && this.config.allowCookies;
    };
    /*
    Parses the domain from the referrer, if it is available
    */ PageManager.prototype.getDomainFromReferrer = function() {
        try {
            return new URL(document.referrer).hostname;
        } catch (e) {
            return document.referrer === "localhost" ? document.referrer : "";
        }
    };
    return PageManager;
}();


var $789d4e4e835226fd$var$__assign = undefined && undefined.__assign || function() {
    $789d4e4e835226fd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $789d4e4e835226fd$var$__assign.apply(this, arguments);
};
var $789d4e4e835226fd$var$webClientVersion = "1.14.0";
/**
 * A cache which stores events generated by telemetry plugins.
 *
 * The event cache stores meta data and events until they are dispatched to the
 * data plane. The event cache removes the oldest event once the cache is full
 * and a new event is added.
 */ var $789d4e4e835226fd$export$48ce5537dd58278c = /** @class */ function() {
    /**
     * @param applicationDetails Application identity and version.
     * @param batchLimit The maximum number of events that will be returned in a batch.
     * @param eventCacheSize  The maximum number of events the cache can contain before dropping events.
     * @param sessionManager  The sessionManager returns user id, session id and handles session timeout.
     * @param pageManager The pageManager returns page id.
     */ function EventCache(applicationDetails, config) {
        var _this = this;
        this.events = [];
        /**
         * Update the current page interaction for the session.
         */ this.recordPageView = function(payload) {
            if (_this.isCurrentUrlAllowed()) _this.pageManager.recordPageView(payload);
        };
        /**
         * Add an event to the cache and reset the session timer.
         *
         * If the session is being recorded, the event will be recorded.
         * If the session is not being recorded, the event will not be recorded.
         *
         * @param type The event schema.
         */ this.recordEvent = function(type, eventData) {
            if (!_this.enabled) return;
            if (_this.isCurrentUrlAllowed()) {
                var session = _this.sessionManager.getSession();
                _this.sessionManager.incrementSessionEventCount();
                if (_this.canRecord(session)) _this.addRecordToCache(type, eventData);
            }
        };
        /**
         * Returns the current session (1) if a session exists and (2) if the
         * current URL is allowed. Returns undefined otherwise.
         */ this.getSession = function() {
            if (_this.isCurrentUrlAllowed()) return _this.sessionManager.getSession();
            return undefined;
        };
        /**
         * Add a session start event to the cache.
         */ this.recordSessionInitEvent = function(session, type, eventData) {
            if (!_this.enabled) return;
            _this.sessionManager.incrementSessionEventCount();
            if (_this.canRecord(session)) _this.addRecordToCache(type, eventData);
        };
        this.canRecord = function(session) {
            return session.record && (session.eventCount <= _this.config.sessionEventLimit || _this.config.sessionEventLimit <= 0);
        };
        /**
         * Add an event to the cache.
         *
         * @param type The event schema.
         */ this.addRecordToCache = function(type, eventData) {
            if (!_this.enabled) return;
            if (_this.events.length === _this.config.eventCacheSize) // Make room in the cache by dropping the oldest event.
            _this.events.shift();
            // The data plane service model (i.e., LogEvents) does not adhere to the
            // RUM agent data model, where sessions and pages are first class
            // objects with their own attribute sets. Instead, we store session
            // attributes and page attributes together as 'meta data'.
            var metaData = $789d4e4e835226fd$var$__assign($789d4e4e835226fd$var$__assign($789d4e4e835226fd$var$__assign({}, _this.sessionManager.getAttributes()), _this.pageManager.getAttributes()), {
                version: "1.0.0",
                "aws:client": _this.installationMethod,
                "aws:clientVersion": $789d4e4e835226fd$var$webClientVersion
            });
            _this.events.push({
                details: JSON.stringify(eventData),
                id: (0, $7161f86fd2ed93bf$export$2e2bcd8739ae039)(),
                metadata: JSON.stringify(metaData),
                timestamp: new Date(),
                type: type
            });
        };
        this.appMonitorDetails = applicationDetails;
        this.config = config;
        this.enabled = true;
        this.pageManager = new (0, $a87d84a285c6c894$export$b47b1e333f1bf2a6)(config, this.recordEvent);
        this.sessionManager = new (0, $0c795222251ee7c6$export$415798a788f40554)(applicationDetails, config, this.recordSessionInitEvent, this.pageManager);
        this.installationMethod = config.client;
    }
    /**
     * The event cache will record new events or new meta data.
     */ EventCache.prototype.enable = function() {
        this.enabled = true;
    };
    /**
     * The event cache will not record new events or new meta data. Events and
     * meta data which are already in the cache will still be accessible.
     */ EventCache.prototype.disable = function() {
        this.enabled = false;
    };
    /**
     * Returns true if there are one or more events in the cache.
     */ EventCache.prototype.hasEvents = function() {
        return this.events.length !== 0;
    };
    /**
     * Removes and returns the next batch of events.
     */ EventCache.prototype.getEventBatch = function() {
        var rumEvents = [];
        if (this.events.length === 0) return rumEvents;
        if (this.events.length <= this.config.batchLimit) {
            // Return all events.
            rumEvents = this.events;
            this.events = [];
        } else // Dispatch the front of the array and retain the back of the array.
        rumEvents = this.events.splice(0, this.config.batchLimit);
        return rumEvents;
    };
    /**
     * Returns an object containing the AppMonitor ID and application version.
     */ EventCache.prototype.getAppMonitorDetails = function() {
        return this.appMonitorDetails;
    };
    /**
     * Returns an object containing the session ID and user ID.
     */ EventCache.prototype.getUserDetails = function() {
        return {
            userId: this.sessionManager.getUserId(),
            sessionId: this.sessionManager.getSession().sessionId
        };
    };
    /**
     * Set custom session attributes to add them to all event metadata.
     *
     * @param payload object containing custom attribute data in the form of key, value pairs
     */ EventCache.prototype.addSessionAttributes = function(sessionAttributes) {
        this.sessionManager.addSessionAttributes(sessionAttributes);
    };
    /**
     * Returns {@code true} if the current url matches one of the allowedPages
     * and does not match any of the deniedPages; returns {@code false}
     * otherwise.
     */ EventCache.prototype.isCurrentUrlAllowed = function() {
        var location = document.location.toString();
        var exclude = this.config.pagesToExclude.some(function(re) {
            return re.test(location);
        });
        var include = this.config.pagesToInclude.some(function(re) {
            return re.test(location);
        });
        return include && !exclude;
    };
    return EventCache;
}();


const $3fdb117a1e14316f$var$SHORT_TO_HEX = {};
const $3fdb117a1e14316f$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $3fdb117a1e14316f$var$SHORT_TO_HEX[i] = encodedByte;
    $3fdb117a1e14316f$var$HEX_TO_SHORT[encodedByte] = i;
}
function $3fdb117a1e14316f$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $3fdb117a1e14316f$var$HEX_TO_SHORT) out[i / 2] = $3fdb117a1e14316f$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $3fdb117a1e14316f$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $3fdb117a1e14316f$var$SHORT_TO_HEX[bytes[i]];
    return out;
}




var $d594df769f73eaa8$exports = {};
"use strict";
Object.defineProperty($d594df769f73eaa8$exports, "__esModule", {
    value: true
});
$d594df769f73eaa8$exports.AwsCrc32 = $d594df769f73eaa8$exports.Crc32 = $d594df769f73eaa8$exports.crc32 = void 0;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $af80b803a5d99a28$var$extendStatics = function(d, b) {
    $af80b803a5d99a28$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $af80b803a5d99a28$var$extendStatics(d, b);
};
function $af80b803a5d99a28$export$a8ba968b8961cb8a(d, b) {
    $af80b803a5d99a28$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $af80b803a5d99a28$export$18ce0697a983be9b = function() {
    $af80b803a5d99a28$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af80b803a5d99a28$export$18ce0697a983be9b.apply(this, arguments);
};
function $af80b803a5d99a28$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $af80b803a5d99a28$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $af80b803a5d99a28$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $af80b803a5d99a28$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $af80b803a5d99a28$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $af80b803a5d99a28$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $af80b803a5d99a28$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $af80b803a5d99a28$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $af80b803a5d99a28$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $af80b803a5d99a28$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $af80b803a5d99a28$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($af80b803a5d99a28$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $af80b803a5d99a28$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $af80b803a5d99a28$export$10c90e4f7922046c(v) {
    return this instanceof $af80b803a5d99a28$export$10c90e4f7922046c ? (this.v = v, this) : new $af80b803a5d99a28$export$10c90e4f7922046c(v);
}
function $af80b803a5d99a28$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $af80b803a5d99a28$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $af80b803a5d99a28$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $af80b803a5d99a28$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $af80b803a5d99a28$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $af80b803a5d99a28$export$19a8beecd37a4c45 === "function" ? $af80b803a5d99a28$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $af80b803a5d99a28$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $af80b803a5d99a28$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $af80b803a5d99a28$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $af80b803a5d99a28$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $af80b803a5d99a28$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $3b68630281216ab3$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($3b68630281216ab3$exports, "__esModule", {
    value: true
});
$3b68630281216ab3$exports.uint32ArrayFrom = $3b68630281216ab3$exports.numToUint8 = $3b68630281216ab3$exports.isEmptyData = $3b68630281216ab3$exports.convertToBuffer = void 0;
var $9710c2d5ad0ccd88$exports = {};

var $bdjQ6 = parcelRequire("bdjQ6");
var $9710c2d5ad0ccd88$require$Buffer = $bdjQ6.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($9710c2d5ad0ccd88$exports, "__esModule", {
    value: true
});
$9710c2d5ad0ccd88$exports.convertToBuffer = void 0;

var $fHkZG = parcelRequire("fHkZG");
// Quick polyfill
var $9710c2d5ad0ccd88$var$fromUtf8 = typeof $9710c2d5ad0ccd88$require$Buffer !== "undefined" && $9710c2d5ad0ccd88$require$Buffer.from ? function(input) {
    return $9710c2d5ad0ccd88$require$Buffer.from(input, "utf8");
} : $fHkZG.fromUtf8;
function $9710c2d5ad0ccd88$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $9710c2d5ad0ccd88$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
$9710c2d5ad0ccd88$exports.convertToBuffer = $9710c2d5ad0ccd88$var$convertToBuffer;


Object.defineProperty($3b68630281216ab3$exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $9710c2d5ad0ccd88$exports.convertToBuffer;
    }
});
var $e1ca75ae05811a7d$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($e1ca75ae05811a7d$exports, "__esModule", {
    value: true
});
$e1ca75ae05811a7d$exports.isEmptyData = void 0;
function $e1ca75ae05811a7d$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
$e1ca75ae05811a7d$exports.isEmptyData = $e1ca75ae05811a7d$var$isEmptyData;


Object.defineProperty($3b68630281216ab3$exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $e1ca75ae05811a7d$exports.isEmptyData;
    }
});
var $6dee841d9e296947$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($6dee841d9e296947$exports, "__esModule", {
    value: true
});
$6dee841d9e296947$exports.numToUint8 = void 0;
function $6dee841d9e296947$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
$6dee841d9e296947$exports.numToUint8 = $6dee841d9e296947$var$numToUint8;


Object.defineProperty($3b68630281216ab3$exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $6dee841d9e296947$exports.numToUint8;
    }
});
var $5d7dc1c7cf50d834$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($5d7dc1c7cf50d834$exports, "__esModule", {
    value: true
});
$5d7dc1c7cf50d834$exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $5d7dc1c7cf50d834$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
$5d7dc1c7cf50d834$exports.uint32ArrayFrom = $5d7dc1c7cf50d834$var$uint32ArrayFrom;


Object.defineProperty($3b68630281216ab3$exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $5d7dc1c7cf50d834$exports.uint32ArrayFrom;
    }
});


function $d594df769f73eaa8$var$crc32(data) {
    return new $d594df769f73eaa8$var$Crc32().update(data).digest();
}
$d594df769f73eaa8$exports.crc32 = $d594df769f73eaa8$var$crc32;
var $d594df769f73eaa8$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = $af80b803a5d99a28$export$19a8beecd37a4c45(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $d594df769f73eaa8$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
$d594df769f73eaa8$exports.Crc32 = $d594df769f73eaa8$var$Crc32;
// prettier-ignore
var $d594df769f73eaa8$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $d594df769f73eaa8$var$lookupTable = (0, $3b68630281216ab3$exports.uint32ArrayFrom)($d594df769f73eaa8$var$a_lookUpTable);
var $fccf5d9d8471f053$exports = {};
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty($fccf5d9d8471f053$exports, "__esModule", {
    value: true
});
$fccf5d9d8471f053$exports.AwsCrc32 = void 0;



var $fccf5d9d8471f053$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $d594df769f73eaa8$exports.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $3b68630281216ab3$exports.isEmptyData)(toHash)) return;
        this.crc32.update((0, $3b68630281216ab3$exports.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return $af80b803a5d99a28$export$1050f835b63b671e(this, void 0, void 0, function() {
            return $af80b803a5d99a28$export$67ebef60e6f28a6(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $3b68630281216ab3$exports.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new $d594df769f73eaa8$exports.Crc32();
    };
    return AwsCrc32;
}();
$fccf5d9d8471f053$exports.AwsCrc32 = $fccf5d9d8471f053$var$AwsCrc32;


Object.defineProperty($d594df769f73eaa8$exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $fccf5d9d8471f053$exports.AwsCrc32;
    }
});




class $02da982bb0ef3038$export$8a5e19712a0a5deb {
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $02da982bb0ef3038$var$negate(bytes);
        return new $02da982bb0ef3038$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $02da982bb0ef3038$var$negate(bytes);
        return parseInt((0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
}
function $02da982bb0ef3038$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}


class $df3afd45af9b202d$export$74fd41a85c5dcec9 {
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, $02da982bb0ef3038$export$8a5e19712a0a5deb).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$df3afd45af9b202d$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $3fdb117a1e14316f$export$1a8ceedbd5845648)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: $df3afd45af9b202d$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: $df3afd45af9b202d$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: $df3afd45af9b202d$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: $df3afd45af9b202d$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: $df3afd45af9b202d$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: $df3afd45af9b202d$var$LONG_TAG,
                        value: new (0, $02da982bb0ef3038$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $df3afd45af9b202d$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $df3afd45af9b202d$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: $df3afd45af9b202d$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $02da982bb0ef3038$export$8a5e19712a0a5deb)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $df3afd45af9b202d$var$UUID_TAG,
                        value: `${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(uuidBytes.subarray(0, 4))}-${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(uuidBytes.subarray(4, 6))}-${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(uuidBytes.subarray(6, 8))}-${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(uuidBytes.subarray(8, 10))}-${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
}
var $df3afd45af9b202d$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($df3afd45af9b202d$var$HEADER_VALUE_TYPE || ($df3afd45af9b202d$var$HEADER_VALUE_TYPE = {}));
const $df3afd45af9b202d$var$BOOLEAN_TAG = "boolean";
const $df3afd45af9b202d$var$BYTE_TAG = "byte";
const $df3afd45af9b202d$var$SHORT_TAG = "short";
const $df3afd45af9b202d$var$INT_TAG = "integer";
const $df3afd45af9b202d$var$LONG_TAG = "long";
const $df3afd45af9b202d$var$BINARY_TAG = "binary";
const $df3afd45af9b202d$var$STRING_TAG = "string";
const $df3afd45af9b202d$var$TIMESTAMP_TAG = "timestamp";
const $df3afd45af9b202d$var$UUID_TAG = "uuid";
const $df3afd45af9b202d$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;



const $4d59c9e6869fa0be$var$PRELUDE_MEMBER_LENGTH = 4;
const $4d59c9e6869fa0be$var$PRELUDE_LENGTH = $4d59c9e6869fa0be$var$PRELUDE_MEMBER_LENGTH * 2;
const $4d59c9e6869fa0be$var$CHECKSUM_LENGTH = 4;
const $4d59c9e6869fa0be$var$MINIMUM_MESSAGE_LENGTH = $4d59c9e6869fa0be$var$PRELUDE_LENGTH + $4d59c9e6869fa0be$var$CHECKSUM_LENGTH * 2;
function $4d59c9e6869fa0be$export$546b6bc432bd9a53({ byteLength: byteLength, byteOffset: byteOffset, buffer: buffer }) {
    if (byteLength < $4d59c9e6869fa0be$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32($4d59c9e6869fa0be$var$PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32($4d59c9e6869fa0be$var$PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - $4d59c9e6869fa0be$var$CHECKSUM_LENGTH, false);
    const checksummer = new (0, $d594df769f73eaa8$exports.Crc32)().update(new Uint8Array(buffer, byteOffset, $4d59c9e6869fa0be$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + $4d59c9e6869fa0be$var$PRELUDE_LENGTH, byteLength - ($4d59c9e6869fa0be$var$PRELUDE_LENGTH + $4d59c9e6869fa0be$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + $4d59c9e6869fa0be$var$PRELUDE_LENGTH + $4d59c9e6869fa0be$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $4d59c9e6869fa0be$var$PRELUDE_LENGTH + $4d59c9e6869fa0be$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($4d59c9e6869fa0be$var$PRELUDE_LENGTH + $4d59c9e6869fa0be$var$CHECKSUM_LENGTH + $4d59c9e6869fa0be$var$CHECKSUM_LENGTH))
    };
}


class $57da5b759fecf540$export$60e2ad0c77b6bab {
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body: body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, $d594df769f73eaa8$exports.Crc32)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers: headers, body: body } = (0, $4d59c9e6869fa0be$export$546b6bc432bd9a53)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, $df3afd45af9b202d$export$74fd41a85c5dcec9)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
}






class $f84b49681f4a83d1$export$4ffe73dc7dfe29dd {
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
    constructor(options){
        this.options = options;
    }
}


class $00ebce0ec941dc9a$export$1204278c33e35f1b {
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
    constructor(options){
        this.options = options;
    }
}


class $0ed8fbdea01aa9c5$export$c78403d78d3ee8a {
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
    constructor(options){
        this.options = options;
    }
}


class $41fb1d2941d4075a$export$96361fe9dd919a8e {
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
    constructor(options){
        this.options = options;
    }
}





const $4b45fe48417cace9$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};




const $02584d5d22bc4755$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $c9be84b1a61d26dd$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $02584d5d22bc4755$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $444dd1f4bb8288d7$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);




const $c78cddb2b0c6a2e2$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $c78cddb2b0c6a2e2$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $c78cddb2b0c6a2e2$export$6e114beec37430d7 = "X-Amz-Date";
const $c78cddb2b0c6a2e2$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $c78cddb2b0c6a2e2$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $c78cddb2b0c6a2e2$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $c78cddb2b0c6a2e2$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $c78cddb2b0c6a2e2$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $c78cddb2b0c6a2e2$export$9924a64a4b8b0d58 = "authorization";
const $c78cddb2b0c6a2e2$export$acf4b8bdf24aab34 = $c78cddb2b0c6a2e2$export$6e114beec37430d7.toLowerCase();
const $c78cddb2b0c6a2e2$export$c65c8c9f514da472 = "date";
const $c78cddb2b0c6a2e2$export$20d6a73fd0b10982 = [
    $c78cddb2b0c6a2e2$export$9924a64a4b8b0d58,
    $c78cddb2b0c6a2e2$export$acf4b8bdf24aab34,
    $c78cddb2b0c6a2e2$export$c65c8c9f514da472
];
const $c78cddb2b0c6a2e2$export$29961f34c719157e = $c78cddb2b0c6a2e2$export$41ae838dc1e0f082.toLowerCase();
const $c78cddb2b0c6a2e2$export$eaef12179141669a = "x-amz-content-sha256";
const $c78cddb2b0c6a2e2$export$fdc81b663012a8d2 = $c78cddb2b0c6a2e2$export$8e1383b7eea7bee.toLowerCase();
const $c78cddb2b0c6a2e2$export$96307741595055fc = "host";
const $c78cddb2b0c6a2e2$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $c78cddb2b0c6a2e2$export$8085db98abbe0597 = /^proxy-/;
const $c78cddb2b0c6a2e2$export$758380400526c39 = /^sec-/;
const $c78cddb2b0c6a2e2$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $c78cddb2b0c6a2e2$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $c78cddb2b0c6a2e2$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $c78cddb2b0c6a2e2$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $c78cddb2b0c6a2e2$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $c78cddb2b0c6a2e2$export$bf665777b4a1722f = 50;
const $c78cddb2b0c6a2e2$export$c4bf0942098f6bb = "aws4_request";
const $c78cddb2b0c6a2e2$export$274df788bdcca184 = 604800;





const $6187fda80d0cff5f$var$signingKeyCache = {};
const $6187fda80d0cff5f$var$cacheQueue = [];
const $6187fda80d0cff5f$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $c78cddb2b0c6a2e2$export$c4bf0942098f6bb}`;
const $6187fda80d0cff5f$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $6187fda80d0cff5f$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $6187fda80d0cff5f$var$signingKeyCache) return $6187fda80d0cff5f$var$signingKeyCache[cacheKey];
    $6187fda80d0cff5f$var$cacheQueue.push(cacheKey);
    while($6187fda80d0cff5f$var$cacheQueue.length > (0, $c78cddb2b0c6a2e2$export$bf665777b4a1722f))delete $6187fda80d0cff5f$var$signingKeyCache[$6187fda80d0cff5f$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $c78cddb2b0c6a2e2$export$c4bf0942098f6bb)
    ])key = await $6187fda80d0cff5f$var$hmac(sha256Constructor, key, signable);
    return $6187fda80d0cff5f$var$signingKeyCache[cacheKey] = key;
};
const $6187fda80d0cff5f$export$a31b95746ea0a30a = ()=>{
    $6187fda80d0cff5f$var$cacheQueue.length = 0;
    Object.keys($6187fda80d0cff5f$var$signingKeyCache).forEach((cacheKey)=>{
        delete $6187fda80d0cff5f$var$signingKeyCache[cacheKey];
    });
};
const $6187fda80d0cff5f$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $c9be84b1a61d26dd$export$73470fd2221e6aef)(data));
    return hash.digest();
};



const $58d1300571428780$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $c78cddb2b0c6a2e2$export$8ffdcd58c4092560) || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || (0, $c78cddb2b0c6a2e2$export$8085db98abbe0597).test(canonicalHeaderName) || (0, $c78cddb2b0c6a2e2$export$758380400526c39).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};




const $0c41a3eebb9aa731$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query).sort()){
        if (key.toLowerCase() === (0, $c78cddb2b0c6a2e2$export$29961f34c719157e)) continue;
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") serialized[key] = `${(0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(key)}=${(0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(value)}`;
        else if (Array.isArray(value)) serialized[key] = value.slice(0).sort().reduce((encoded, value)=>encoded.concat([
                `${(0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(key)}=${(0, $b644b14c5797f8d7$export$c3b4775ad75a73db)(value)}`
            ]), []).join("&");
    }
    return keys.map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};


const $8656ab51f83e0fa9$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";





const $9e6b335c7460fb73$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $c78cddb2b0c6a2e2$export$eaef12179141669a)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $8656ab51f83e0fa9$export$9dd3754ae86f0017)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $c9be84b1a61d26dd$export$73470fd2221e6aef)(body));
        return (0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(await hashCtor.digest());
    }
    return 0, $c78cddb2b0c6a2e2$export$91f7321b40d9fd07;
};


const $40c3e87a116af7ee$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $40c3e87a116af7ee$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $40c3e87a116af7ee$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");
const $4d5b1ba66aa22d54$export$d043aa0bf7223286 = (_param)=>{
    var { headers: headers, query: query } = _param, rest = (0, $bLhVg._)(_param, [
        "headers",
        "query"
    ]);
    return (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
        headers: (0, $9tqwB._)({}, headers),
        query: query ? $4d5b1ba66aa22d54$export$4923819f93729b21(query) : undefined
    });
};
const $4d5b1ba66aa22d54$export$4923819f93729b21 = (query)=>Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return (0, $2qxEV._)((0, $9tqwB._)({}, carry), {
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        });
    }, {});


const $bc9ef7e7a49c288d$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = typeof request.clone === "function" ? request.clone() : (0, $4d5b1ba66aa22d54$export$d043aa0bf7223286)(request);
    for (const name of Object.keys(headers)){
        var _options_unhoistableHeaders;
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !((_options_unhoistableHeaders = options.unhoistableHeaders) === null || _options_unhoistableHeaders === void 0 ? void 0 : _options_unhoistableHeaders.has(lname))) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return (0, $2qxEV._)((0, $9tqwB._)({}, request), {
        headers: headers,
        query: query
    });
};




const $0145e384d2419748$export$a7cfe9131aa06be4 = (request)=>{
    request = typeof request.clone === "function" ? request.clone() : (0, $4d5b1ba66aa22d54$export$d043aa0bf7223286)(request);
    for (const headerName of Object.keys(request.headers))if ((0, $c78cddb2b0c6a2e2$export$20d6a73fd0b10982).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};


const $7c7228294cc5d8f6$export$b65d57190c224ef2 = (time)=>$7c7228294cc5d8f6$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $7c7228294cc5d8f6$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};


class $4053fce55de4d1f2$export$20baf4d3f65eb30c {
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion !== null && signingRegion !== void 0 ? signingRegion : await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = $4053fce55de4d1f2$var$formatDate(signingDate);
        if (expiresIn > (0, $c78cddb2b0c6a2e2$export$274df788bdcca184)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $6187fda80d0cff5f$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
        const request = (0, $bc9ef7e7a49c288d$export$bfc08a76d4bd60f6)((0, $0145e384d2419748$export$a7cfe9131aa06be4)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $c78cddb2b0c6a2e2$export$8e1383b7eea7bee] = credentials.sessionToken;
        request.query[0, $c78cddb2b0c6a2e2$export$186cd8495ba0377d] = (0, $c78cddb2b0c6a2e2$export$863a63fba5b2ddf5);
        request.query[0, $c78cddb2b0c6a2e2$export$5c8e6dd7758f59d6] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $c78cddb2b0c6a2e2$export$6e114beec37430d7] = longDate;
        request.query[0, $c78cddb2b0c6a2e2$export$a0afe6f3bbfaf76e] = expiresIn.toString(10);
        const canonicalHeaders = (0, $58d1300571428780$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        request.query[0, $c78cddb2b0c6a2e2$export$2dcbb254f883c238] = $4053fce55de4d1f2$var$getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $c78cddb2b0c6a2e2$export$41ae838dc1e0f082] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $9e6b335c7460fb73$export$a46a74202b0efd71)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion !== null && signingRegion !== void 0 ? signingRegion : await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = $4053fce55de4d1f2$var$formatDate(signingDate);
        const scope = (0, $6187fda80d0cff5f$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
        const hashedPayload = await (0, $9e6b335c7460fb73$export$a46a74202b0efd71)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(await hash.digest());
        const stringToSign = [
            (0, $c78cddb2b0c6a2e2$export$9a1f6cf06ac56167),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerMarshaller.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion !== null && signingRegion !== void 0 ? signingRegion : await this.regionProvider();
        const { shortDate: shortDate } = $4053fce55de4d1f2$var$formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $c9be84b1a61d26dd$export$73470fd2221e6aef)(stringToSign));
        return (0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion !== null && signingRegion !== void 0 ? signingRegion : await this.regionProvider();
        const request = (0, $0145e384d2419748$export$a7cfe9131aa06be4)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = $4053fce55de4d1f2$var$formatDate(signingDate);
        const scope = (0, $6187fda80d0cff5f$export$41a9651decfe2bde)(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
        request.headers[0, $c78cddb2b0c6a2e2$export$acf4b8bdf24aab34] = longDate;
        if (credentials.sessionToken) request.headers[0, $c78cddb2b0c6a2e2$export$fdc81b663012a8d2] = credentials.sessionToken;
        const payloadHash = await (0, $9e6b335c7460fb73$export$a46a74202b0efd71)(request, this.sha256);
        if (!(0, $40c3e87a116af7ee$export$17944590be865217)((0, $c78cddb2b0c6a2e2$export$eaef12179141669a), request.headers) && this.applyChecksum) request.headers[0, $c78cddb2b0c6a2e2$export$eaef12179141669a] = payloadHash;
        const canonicalHeaders = (0, $58d1300571428780$export$859d7f1bb55e2914)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $c78cddb2b0c6a2e2$export$9924a64a4b8b0d58] = `${0, $c78cddb2b0c6a2e2$export$863a63fba5b2ddf5} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${$4053fce55de4d1f2$var$getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $0c41a3eebb9aa731$export$8fea7e63ecd1ddbb)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, $c9be84b1a61d26dd$export$73470fd2221e6aef)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, $c78cddb2b0c6a2e2$export$863a63fba5b2ddf5}
${longDate}
${credentialScope}
${(0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if ((pathSegment === null || pathSegment === void 0 ? void 0 : pathSegment.length) === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${(path === null || path === void 0 ? void 0 : path.startsWith("/")) ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && (path === null || path === void 0 ? void 0 : path.endsWith("/")) ? "/" : ""}`;
            const doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $c9be84b1a61d26dd$export$73470fd2221e6aef)(stringToSign));
        return (0, $3fdb117a1e14316f$export$7ea66e3774a60b67)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $6187fda80d0cff5f$export$8b95a069d16dd783)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.headerMarshaller = new (0, $df3afd45af9b202d$export$74fd41a85c5dcec9)((0, $444dd1f4bb8288d7$export$b4b216764bb846eb), (0, $02584d5d22bc4755$export$c7c5cef950a4d2fc));
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $4b45fe48417cace9$export$b1276c07738d6325)(region);
        this.credentialProvider = (0, $4b45fe48417cace9$export$b1276c07738d6325)(credentials);
    }
}
const $4053fce55de4d1f2$var$formatDate = (now)=>{
    const longDate = (0, $7c7228294cc5d8f6$export$b65d57190c224ef2)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const $4053fce55de4d1f2$var$getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");












var $a6775a810a6e2a75$exports = {};
"use strict";
Object.defineProperty($a6775a810a6e2a75$exports, "__esModule", {
    value: true
});

var $4CvnI = parcelRequire("4CvnI");

$4CvnI.__exportStar((parcelRequire("iD1YP")), $a6775a810a6e2a75$exports);



var $71547222d953275d$var$__assign = undefined && undefined.__assign || function() {
    $71547222d953275d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $71547222d953275d$var$__assign.apply(this, arguments);
};
var $71547222d953275d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $71547222d953275d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $71547222d953275d$var$SERVICE = "rum";
var $71547222d953275d$var$METHOD = "POST";
var $71547222d953275d$var$CONTENT_TYPE_JSON = "application/json";
var $71547222d953275d$var$CONTENT_TYPE_TEXT = "text/plain;charset=UTF-8";
var $71547222d953275d$var$REQUEST_PRESIGN_ARGS = {
    expiresIn: 60
};
var $71547222d953275d$export$81ad2d7714d130fb = /** @class */ function() {
    function DataPlaneClient(config) {
        var _this = this;
        this.sendFetch = function(putRumEventsRequest) {
            return $71547222d953275d$var$__awaiter(_this, void 0, void 0, function() {
                var options, request, httpResponse;
                return $71547222d953275d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getHttpRequestOptions(putRumEventsRequest, $71547222d953275d$var$CONTENT_TYPE_JSON)
                            ];
                        case 1:
                            options = _a.sent();
                            request = new (0, $556d035a939794ad$export$7587955500404ec3)(options);
                            if (!this.awsSigV4) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.awsSigV4.sign(request)
                            ];
                        case 2:
                            request = _a.sent();
                            _a.label = 3;
                        case 3:
                            httpResponse = this.config.fetchRequestHandler.handle(request);
                            return [
                                2 /*return*/ ,
                                httpResponse
                            ];
                    }
                });
            });
        };
        this.sendBeacon = function(putRumEventsRequest) {
            return $71547222d953275d$var$__awaiter(_this, void 0, void 0, function() {
                var options, request, httpResponse;
                return $71547222d953275d$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getHttpRequestOptions(putRumEventsRequest, $71547222d953275d$var$CONTENT_TYPE_TEXT)
                            ];
                        case 1:
                            options = _a.sent();
                            request = new (0, $556d035a939794ad$export$7587955500404ec3)(options);
                            if (!this.awsSigV4) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.awsSigV4.presign(request, $71547222d953275d$var$REQUEST_PRESIGN_ARGS)
                            ];
                        case 2:
                            request = _a.sent();
                            _a.label = 3;
                        case 3:
                            httpResponse = this.config.beaconRequestHandler.handle(request);
                            return [
                                2 /*return*/ ,
                                httpResponse
                            ];
                    }
                });
            });
        };
        this.getHttpRequestOptions = function(putRumEventsRequest, contentType) {
            return $71547222d953275d$var$__awaiter(_this, void 0, void 0, function() {
                var serializedRequest, path, options, _a, _b, _c;
                var _d, _e;
                return $71547222d953275d$var$__generator(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            serializedRequest = JSON.stringify($71547222d953275d$var$serializeRequest(putRumEventsRequest));
                            path = this.config.endpoint.pathname.replace(/\/$/, "");
                            options = {
                                method: $71547222d953275d$var$METHOD,
                                protocol: this.config.endpoint.protocol,
                                headers: {
                                    "content-type": contentType,
                                    host: this.config.endpoint.host
                                },
                                hostname: this.config.endpoint.hostname,
                                path: "".concat(path, "/appmonitors/").concat(putRumEventsRequest.AppMonitorDetails.id),
                                body: serializedRequest
                            };
                            if (!this.awsSigV4) return [
                                3 /*break*/ ,
                                2
                            ];
                            _a = [
                                $71547222d953275d$var$__assign({}, options)
                            ];
                            _d = {};
                            _b = [
                                $71547222d953275d$var$__assign({}, options.headers)
                            ];
                            _e = {};
                            _c = "X-Amz-Content-Sha256";
                            return [
                                4 /*yield*/ ,
                                $71547222d953275d$var$hashAndEncode(serializedRequest)
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                $71547222d953275d$var$__assign.apply(void 0, _a.concat([
                                    (_d.headers = $71547222d953275d$var$__assign.apply(void 0, _b.concat([
                                        (_e[_c] = _f.sent(), _e)
                                    ])), _d)
                                ]))
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                options
                            ];
                    }
                });
            });
        };
        this.config = config;
        if (config.credentials) this.awsSigV4 = new (0, $4053fce55de4d1f2$export$20baf4d3f65eb30c)({
            applyChecksum: true,
            credentials: config.credentials,
            region: config.region,
            service: $71547222d953275d$var$SERVICE,
            uriEscapePath: true,
            sha256: (0, $a6775a810a6e2a75$exports.Sha256)
        });
    }
    return DataPlaneClient;
}();
var $71547222d953275d$var$serializeRequest = function(request) {
    //  If we were using the AWS SDK client here then the serialization would be handled for us through a generated
    //  serialization/deserialization library. However, since much of the generated code is unnecessary, we do the
    //  serialization ourselves with this function.
    var serializedRumEvents = [];
    request.RumEvents.forEach(function(e) {
        return serializedRumEvents.push($71547222d953275d$var$serializeEvent(e));
    });
    var serializedRequest = {
        BatchId: request.BatchId,
        AppMonitorDetails: request.AppMonitorDetails,
        UserDetails: request.UserDetails,
        RumEvents: serializedRumEvents
    };
    return serializedRequest;
};
var $71547222d953275d$var$serializeEvent = function(event) {
    return {
        id: event.id,
        // Dates must be converted to timestamps before serialization.
        timestamp: Math.round(event.timestamp.getTime() / 1000),
        type: event.type,
        metadata: event.metadata,
        details: event.details
    };
};
var $71547222d953275d$var$hashAndEncode = function(payload) {
    return $71547222d953275d$var$__awaiter(void 0, void 0, void 0, function() {
        var sha256, _a;
        return $71547222d953275d$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    sha256 = new (0, $a6775a810a6e2a75$exports.Sha256)();
                    sha256.update(payload);
                    _a = (0, $3fdb117a1e14316f$export$7ea66e3774a60b67);
                    return [
                        4 /*yield*/ ,
                        sha256.digest()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            _b.sent()
                        ]).toLowerCase()
                    ];
            }
        });
    });
};






var $ef71d3a1a7da87bc$export$912cc95db81e02b0 = /** @class */ function() {
    function BeaconHttpHandler() {}
    BeaconHttpHandler.prototype.handle = function(request) {
        var queued = this.sendBeacon(request);
        return new Promise(function(resolve, reject) {
            if (queued) resolve({
                response: new (0, $76750c3e94ff2f32$export$1d94dfe0d9d1f1e7)({
                    statusCode: 200
                })
            });
            else reject();
        });
    };
    BeaconHttpHandler.prototype.sendBeacon = function(signedRequest) {
        var path = signedRequest.path;
        if (signedRequest.query) {
            var queryString = (0, $d8de6bb94ac789ce$export$6b17a39e52c8ee53)(signedRequest.query);
            if (queryString) path += "?".concat(queryString);
        }
        var port = signedRequest.port;
        var url = "".concat(signedRequest.protocol, "//").concat(signedRequest.hostname).concat(port ? ":".concat(port) : "").concat(path);
        return navigator.sendBeacon(url, signedRequest.body);
    };
    return BeaconHttpHandler;
}();




var $ef3d8ad8cb8b9228$export$363ac302bdbd807b = function(timeoutInMs) {
    if (timeoutInMs === void 0) timeoutInMs = 0;
    return new Promise(function(resolve, reject) {
        if (timeoutInMs) setTimeout(function() {
            var timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
};


var $25c23c9027c82048$export$83588b87edbfa7e0 = /** @class */ function() {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, fetchFunction = _b.fetchFunction, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
        this.fetchFunction = fetchFunction;
    }
    FetchHttpHandler.prototype.destroy = function() {
    // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function(request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = (0, $d8de6bb94ac789ce$export$6b17a39e52c8ee53)(request.query);
            if (queryString) path += "?".concat(queryString);
        }
        var port = request.port, method = request.method;
        var url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") requestOptions.signal = abortSignal;
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            this.fetchFunction.apply(window, [
                fetchRequest
            ]).then(function(response) {
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                for(var _i = 0, _a = fetchHeaders.entries(); _i < _a.length; _i++){
                    var pair = _a[_i];
                    transformedHeaders[pair[0]] = pair[1];
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) return response.blob().then(function(body) {
                    return {
                        response: new (0, $76750c3e94ff2f32$export$1d94dfe0d9d1f1e7)({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body
                        })
                    };
                });
                // Return the response with streaming body
                return {
                    response: new (0, $76750c3e94ff2f32$export$1d94dfe0d9d1f1e7)({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $ef3d8ad8cb8b9228$export$363ac302bdbd807b)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise(function(resolve, reject) {
            abortSignal.onabort = function() {
                var abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}();



var $5430f7a25dc3bc59$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5430f7a25dc3bc59$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * An HttpHandler which wraps other HttpHandlers to retry requests.
 *
 * Requests will be retried if (1) there is an error (e.g., with the network or
 * credentials) and the promise rejects, or (2) the response status is not 2xx.
 */ var $5430f7a25dc3bc59$export$d8b3cc770f1a0c5e = /** @class */ function() {
    function RetryHttpHandler(handler, retries, backoff) {
        if (backoff === void 0) backoff = function(n) {
            return n * 2000;
        };
        this.isStatusCode2xx = function(statusCode) {
            return statusCode >= 200 && statusCode < 300;
        };
        this.handler = handler;
        this.retries = retries;
        this.backoff = backoff;
    }
    RetryHttpHandler.prototype.handle = function(request) {
        return $5430f7a25dc3bc59$var$__awaiter(this, void 0, void 0, function() {
            var retriesLeft, response, e_1;
            return $5430f7a25dc3bc59$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        retriesLeft = this.retries;
                        _a.label = 1;
                    case 1:
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.handler.handle(request)
                        ];
                    case 3:
                        response = _a.sent();
                        if (this.isStatusCode2xx(response.response.statusCode)) return [
                            2 /*return*/ ,
                            response
                        ];
                        throw new Error("".concat(response.response.statusCode));
                    case 4:
                        e_1 = _a.sent();
                        if (!retriesLeft) throw e_1;
                        retriesLeft--;
                        return [
                            4 /*yield*/ ,
                            this.sleep(this.backoff(this.retries - retriesLeft))
                        ];
                    case 5:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    RetryHttpHandler.prototype.sleep = function(milliseconds) {
        return $5430f7a25dc3bc59$var$__awaiter(this, void 0, void 0, function() {
            return $5430f7a25dc3bc59$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        return setTimeout(resolve, milliseconds);
                    })
                ];
            });
        });
    };
    return RetryHttpHandler;
}();


var $dbab15270acbab61$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dbab15270acbab61$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $dbab15270acbab61$var$NO_CRED_MSG = "CWR: Cannot dispatch; no AWS credentials.";
var $dbab15270acbab61$export$65fee5f8f91a342f = /** @class */ function() {
    function Dispatch(region, endpoint, eventCache, config) {
        var _this = this;
        /**
         * Send meta data and events to the AWS RUM data plane service via fetch.
         */ this.dispatchFetch = function() {
            return $dbab15270acbab61$var$__awaiter(_this, void 0, void 0, function() {
                return $dbab15270acbab61$var$__generator(this, function(_a) {
                    if (this.doRequest()) return [
                        2 /*return*/ ,
                        this.rum.sendFetch(this.createRequest()).catch(this.handleReject)
                    ];
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        /**
         * Send meta data and events to the AWS RUM data plane service via beacon.
         */ this.dispatchBeacon = function() {
            return $dbab15270acbab61$var$__awaiter(_this, void 0, void 0, function() {
                var request_1;
                var _this = this;
                return $dbab15270acbab61$var$__generator(this, function(_a) {
                    if (this.doRequest()) {
                        request_1 = this.createRequest();
                        return [
                            2 /*return*/ ,
                            this.rum.sendBeacon(request_1).catch(function() {
                                return _this.rum.sendFetch(request_1);
                            })
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        /**
         * Send meta data and events to the AWS RUM data plane service via fetch.
         *
         * Returns undefined on failure.
         */ this.dispatchFetchFailSilent = function() {
            return $dbab15270acbab61$var$__awaiter(_this, void 0, void 0, function() {
                return $dbab15270acbab61$var$__generator(this, function(_a) {
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    return [
                        2 /*return*/ ,
                        this.dispatchFetch().catch(function() {})
                    ];
                });
            });
        };
        /**
         * Send meta data and events to the AWS RUM data plane service via beacon.
         *
         * Returns undefined on failure.
         */ this.dispatchBeaconFailSilent = function() {
            return $dbab15270acbab61$var$__awaiter(_this, void 0, void 0, function() {
                return $dbab15270acbab61$var$__generator(this, function(_a) {
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    return [
                        2 /*return*/ ,
                        this.dispatchBeacon().catch(function() {})
                    ];
                });
            });
        };
        this.handleReject = function(e) {
            // The handler has run out of retries. We adhere to our convention to
            // fail safe by disabling dispatch. This ensures that we will not
            // continue to attempt requests when the problem is not recoverable.
            _this.disable();
            throw e;
        };
        /**
         * The default method for creating data plane service clients.
         *
         * @param endpoint Service endpoint.
         * @param region  Service region.
         * @param credentials AWS credentials.
         */ this.defaultClientBuilder = function(endpoint, region, credentials) {
            return new (0, $71547222d953275d$export$81ad2d7714d130fb)({
                fetchRequestHandler: new (0, $5430f7a25dc3bc59$export$d8b3cc770f1a0c5e)(new (0, $25c23c9027c82048$export$83588b87edbfa7e0)({
                    fetchFunction: _this.config.fetchFunction
                }), _this.config.retries),
                beaconRequestHandler: new (0, $ef71d3a1a7da87bc$export$912cc95db81e02b0)(),
                endpoint: endpoint,
                region: region,
                credentials: credentials
            });
        };
        this.region = region;
        this.endpoint = endpoint;
        this.eventCache = eventCache;
        this.enabled = true;
        this.buildClient = config.clientBuilder || this.defaultClientBuilder;
        this.config = config;
        this.startDispatchTimer();
        if (config.signing) this.rum = {
            sendFetch: function() {
                return Promise.reject(new Error($dbab15270acbab61$var$NO_CRED_MSG));
            },
            sendBeacon: function() {
                return Promise.reject(new Error($dbab15270acbab61$var$NO_CRED_MSG));
            }
        };
        else this.rum = this.buildClient(this.endpoint, this.region, undefined);
    }
    /**
     * Dispatch will send requests to data plane.
     */ Dispatch.prototype.enable = function() {
        this.enabled = true;
        this.startDispatchTimer();
    };
    /**
     * Dispatch will not send requests to data plane.
     */ Dispatch.prototype.disable = function() {
        this.stopDispatchTimer();
        this.enabled = false;
    };
    /**
     * Set the authentication token that will be used to authenticate with the
     * data plane service (AWS auth).
     *
     * @param credentials A set of AWS credentials from the application's authflow.
     */ Dispatch.prototype.setAwsCredentials = function(credentialProvider) {
        this.rum = this.buildClient(this.endpoint, this.region, credentialProvider);
        if (typeof credentialProvider === "function") // In case a beacon in the first dispatch, we must pre-fetch credentials into a cookie so there is no delay
        // to fetch credentials while the page is closing.
        credentialProvider();
    };
    /**
     * Automatically dispatch cached events.
     */ Dispatch.prototype.startDispatchTimer = function() {
        document.addEventListener("visibilitychange", // The page is moving to the hidden state, which means it may be
        // unloaded. The sendBeacon API would typically be used in this
        // case. However, ad-blockers prevent sendBeacon from functioning.
        // We therefore have two bad options:
        //
        // (1) Use sendBeacon. Data will be lost when ad blockers are
        //     used and the page loses visibility
        // (2) Use fetch. Data will be lost when the page is unloaded
        //     before fetch completes
        //
        // A third option is to send both, however this would increase
        // bandwitch and require deduping server side.
        this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        // Using 'pagehide' is redundant most of the time (visibilitychange is
        // always fired before pagehide) but older browsers may support
        // 'pagehide' but not 'visibilitychange'.
        document.addEventListener("pagehide", this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        if (this.config.dispatchInterval <= 0 || this.dispatchTimerId) return;
        this.dispatchTimerId = window.setInterval(this.dispatchFetchFailSilent, this.config.dispatchInterval);
    };
    /**
     * Stop automatically dispatching cached events.
     */ Dispatch.prototype.stopDispatchTimer = function() {
        document.removeEventListener("visibilitychange", this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        document.removeEventListener("pagehide", this.config.useBeacon ? this.dispatchBeaconFailSilent : this.dispatchFetchFailSilent);
        if (this.dispatchTimerId) {
            window.clearInterval(this.dispatchTimerId);
            this.dispatchTimerId = undefined;
        }
    };
    Dispatch.prototype.doRequest = function() {
        return this.enabled && this.eventCache.hasEvents();
    };
    Dispatch.prototype.createRequest = function() {
        return {
            BatchId: (0, $7161f86fd2ed93bf$export$2e2bcd8739ae039)(),
            AppMonitorDetails: this.eventCache.getAppMonitorDetails(),
            UserDetails: this.eventCache.getUserDetails(),
            RumEvents: this.eventCache.getEventBatch()
        };
    };
    return Dispatch;
}();




var $95d4fa925f373a86$export$c6f9da6f70cfc2eb;
(function(ResourceType) {
    ResourceType["OTHER"] = "other";
    ResourceType["STYLESHEET"] = "stylesheet";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["SCRIPT"] = "script";
    ResourceType["IMAGE"] = "image";
    ResourceType["FONT"] = "font";
})($95d4fa925f373a86$export$c6f9da6f70cfc2eb || ($95d4fa925f373a86$export$c6f9da6f70cfc2eb = {}));
var $95d4fa925f373a86$var$extensions = [
    {
        name: $95d4fa925f373a86$export$c6f9da6f70cfc2eb.STYLESHEET,
        list: [
            "css",
            "less"
        ]
    },
    {
        name: $95d4fa925f373a86$export$c6f9da6f70cfc2eb.DOCUMENT,
        list: [
            "htm",
            "html",
            "ts",
            "doc",
            "docx",
            "pdf",
            "xls",
            "xlsx"
        ]
    },
    {
        name: $95d4fa925f373a86$export$c6f9da6f70cfc2eb.SCRIPT,
        list: [
            "js"
        ]
    },
    {
        name: $95d4fa925f373a86$export$c6f9da6f70cfc2eb.IMAGE,
        list: [
            "ai",
            "bmp",
            "gif",
            "ico",
            "jpeg",
            "jpg",
            "png",
            "ps",
            "psd",
            "svg",
            "tif",
            "tiff"
        ]
    },
    {
        name: $95d4fa925f373a86$export$c6f9da6f70cfc2eb.FONT,
        list: [
            "fnt",
            "fon",
            "otf",
            "ttf",
            "woff"
        ]
    }
];
var $95d4fa925f373a86$export$448332262467e042 = function(a) {
    for(var i = a.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var v = a[i];
        a[i] = a[j];
        a[j] = v;
    }
};
var $95d4fa925f373a86$export$a957f1dd6bc232c8 = function(url) {
    var filename = url.substring(url.lastIndexOf("/") + 1);
    var extension = filename.substring(filename.lastIndexOf(".") + 1).split(/[?#]/)[0];
    var ext = $95d4fa925f373a86$export$c6f9da6f70cfc2eb.OTHER;
    $95d4fa925f373a86$var$extensions.forEach(function(type) {
        if (type.list.indexOf(extension) > -1) ext = type.name;
    });
    return ext;
};
var $95d4fa925f373a86$export$4eb0f64bd260509b = {
    "0": "Abort Request",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "306": "Unused",
    "307": "Temporary Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Required",
    "413": "Request Entry Too Large",
    "414": "Request-URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Requested Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": 'I"m a teapot',
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported"
};


var $99953abc9b43e438$export$2d920de535135c2a = function(entry) {
    return entry.entryType === "resource" && !/^https?:/.test(entry.name);
};
var $99953abc9b43e438$export$ab51271b4ef950f = {
    eventLimit: 10,
    ignore: $99953abc9b43e438$export$2d920de535135c2a,
    recordAllTypes: [
        (0, $95d4fa925f373a86$export$c6f9da6f70cfc2eb).DOCUMENT,
        (0, $95d4fa925f373a86$export$c6f9da6f70cfc2eb).SCRIPT
    ],
    sampleTypes: [
        (0, $95d4fa925f373a86$export$c6f9da6f70cfc2eb).STYLESHEET,
        (0, $95d4fa925f373a86$export$c6f9da6f70cfc2eb).IMAGE,
        (0, $95d4fa925f373a86$export$c6f9da6f70cfc2eb).FONT,
        (0, $95d4fa925f373a86$export$c6f9da6f70cfc2eb).OTHER
    ]
};


var $0ded52bcf72e3476$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0ded52bcf72e3476$var$__assign = undefined && undefined.__assign || function() {
    $0ded52bcf72e3476$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0ded52bcf72e3476$var$__assign.apply(this, arguments);
};
var $0ded52bcf72e3476$export$7a702aa35c66590d = "navigation";
var $0ded52bcf72e3476$var$NAVIGATION = "navigation";
var $0ded52bcf72e3476$var$LOAD = "load";
/**
 * This plugin records performance timing events generated during every page load/re-load activity.
 * Paint, resource and performance event types make sense only if all or none are included.
 * For RUM, these event types are inter-dependent. So they are recorded under one plugin.
 */ var $0ded52bcf72e3476$export$cb4379c08e6ffdc7 = /** @class */ function(_super) {
    $0ded52bcf72e3476$var$__extends(NavigationPlugin, _super);
    function NavigationPlugin(config) {
        var _this = _super.call(this, $0ded52bcf72e3476$export$7a702aa35c66590d) || this;
        /**
         * Use Navigation timing Level 1 for all browsers by default -
         * https://developer.mozilla.org/en-US/docs/Web/API/Performance/timing
         *
         * If browser provides support, use Navigation Timing Level 2 specification -
         * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
         *
         * Only the current document resource is included in the performance timeline;
         * there is only one PerformanceNavigationTiming object in the performance timeline.
         * https://www.w3.org/TR/navigation-timing-2/
         */ _this.eventListener = function() {
            if (performance.getEntriesByType($0ded52bcf72e3476$var$NAVIGATION).length === 0) _this.performanceNavigationEventHandlerTimingLevel1();
            else {
                var navigationObserver = new PerformanceObserver(function(list) {
                    list.getEntries().filter(function(e) {
                        return e.entryType === $0ded52bcf72e3476$var$NAVIGATION;
                    }).filter(function(e) {
                        return !_this.config.ignore(e);
                    }).forEach(function(event) {
                        _this.performanceNavigationEventHandlerTimingLevel2(event);
                    });
                });
                navigationObserver.observe({
                    entryTypes: [
                        $0ded52bcf72e3476$var$NAVIGATION
                    ]
                });
            }
        };
        /**
         * W3C specification: https://www.w3.org/TR/navigation-timing/#sec-navigation-timing-interface
         */ _this.performanceNavigationEventHandlerTimingLevel1 = function() {
            var recordNavigation = function() {
                var _a;
                var entryData = performance.timing;
                var origin = entryData.navigationStart;
                var eventDataNavigationTimingLevel1 = {
                    version: "1.0.0",
                    initiatorType: "navigation",
                    startTime: 0,
                    unloadEventStart: entryData.unloadEventStart > 0 ? entryData.unloadEventStart - origin : 0,
                    promptForUnload: entryData.unloadEventEnd - entryData.unloadEventStart,
                    redirectStart: entryData.redirectStart > 0 ? entryData.redirectStart - origin : 0,
                    redirectTime: entryData.redirectEnd - entryData.redirectStart,
                    fetchStart: entryData.fetchStart > 0 ? entryData.fetchStart - origin : 0,
                    domainLookupStart: entryData.domainLookupStart > 0 ? entryData.domainLookupStart - origin : 0,
                    dns: entryData.domainLookupEnd - entryData.domainLookupStart,
                    connectStart: entryData.connectStart > 0 ? entryData.connectStart - origin : 0,
                    connect: entryData.connectEnd - entryData.connectStart,
                    secureConnectionStart: entryData.secureConnectionStart > 0 ? entryData.secureConnectionStart - origin : 0,
                    tlsTime: entryData.secureConnectionStart > 0 ? entryData.connectEnd - entryData.secureConnectionStart : 0,
                    requestStart: entryData.requestStart > 0 ? entryData.requestStart - origin : 0,
                    timeToFirstByte: entryData.responseStart - entryData.requestStart,
                    responseStart: entryData.responseStart > 0 ? entryData.responseStart - origin : 0,
                    responseTime: entryData.responseStart > 0 ? entryData.responseEnd - entryData.responseStart : 0,
                    domInteractive: entryData.domInteractive > 0 ? entryData.domInteractive - origin : 0,
                    domContentLoadedEventStart: entryData.domContentLoadedEventStart > 0 ? entryData.domContentLoadedEventStart - origin : 0,
                    domContentLoaded: entryData.domContentLoadedEventEnd - entryData.domContentLoadedEventStart,
                    domComplete: entryData.domComplete > 0 ? entryData.domComplete - origin : 0,
                    domProcessingTime: entryData.loadEventStart - entryData.responseEnd,
                    loadEventStart: entryData.loadEventStart > 0 ? entryData.loadEventStart - origin : 0,
                    loadEventTime: entryData.loadEventEnd - entryData.loadEventStart,
                    duration: entryData.loadEventEnd - entryData.navigationStart,
                    navigationTimingLevel: 1
                };
                if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) _this.context.record((0, $cacbc151bd9d066e$export$1660e080b62e9eff), eventDataNavigationTimingLevel1);
            };
            // Timeout is required for loadEventEnd to complete
            setTimeout(recordNavigation, 0);
        };
        /**
         * W3C specification: https://www.w3.org/TR/navigation-timing-2/#bib-navigation-timing
         */ _this.performanceNavigationEventHandlerTimingLevel2 = function(entryData) {
            var _a;
            var eventDataNavigationTimingLevel2 = {
                version: "1.0.0",
                initiatorType: entryData.initiatorType,
                navigationType: entryData.type,
                startTime: entryData.startTime,
                unloadEventStart: entryData.unloadEventStart,
                promptForUnload: entryData.unloadEventEnd - entryData.unloadEventStart,
                redirectCount: entryData.redirectCount,
                redirectStart: entryData.redirectStart,
                redirectTime: entryData.redirectEnd - entryData.redirectStart,
                workerStart: entryData.workerStart,
                workerTime: entryData.workerStart > 0 ? entryData.fetchStart - entryData.workerStart : 0,
                fetchStart: entryData.fetchStart,
                domainLookupStart: entryData.domainLookupStart,
                dns: entryData.domainLookupEnd - entryData.domainLookupStart,
                nextHopProtocol: entryData.nextHopProtocol,
                connectStart: entryData.connectStart,
                connect: entryData.connectEnd - entryData.connectStart,
                secureConnectionStart: entryData.secureConnectionStart,
                tlsTime: entryData.secureConnectionStart > 0 ? entryData.connectEnd - entryData.secureConnectionStart : 0,
                requestStart: entryData.requestStart,
                timeToFirstByte: entryData.responseStart - entryData.requestStart,
                responseStart: entryData.responseStart,
                responseTime: entryData.responseStart > 0 ? entryData.responseEnd - entryData.responseStart : 0,
                domInteractive: entryData.domInteractive,
                domContentLoadedEventStart: entryData.domContentLoadedEventStart,
                domContentLoaded: entryData.domContentLoadedEventEnd - entryData.domContentLoadedEventStart,
                domComplete: entryData.domComplete,
                domProcessingTime: entryData.loadEventStart - entryData.responseEnd,
                loadEventStart: entryData.loadEventStart,
                loadEventTime: entryData.loadEventEnd - entryData.loadEventStart,
                duration: entryData.duration,
                headerSize: entryData.transferSize - entryData.encodedBodySize,
                transferSize: entryData.transferSize,
                compressionRatio: entryData.encodedBodySize > 0 ? entryData.decodedBodySize / entryData.encodedBodySize : 0,
                navigationTimingLevel: 2
            };
            if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) _this.context.record((0, $cacbc151bd9d066e$export$1660e080b62e9eff), eventDataNavigationTimingLevel2);
        };
        _this.config = $0ded52bcf72e3476$var$__assign($0ded52bcf72e3476$var$__assign({}, (0, $99953abc9b43e438$export$ab51271b4ef950f)), config);
        return _this;
    }
    NavigationPlugin.prototype.enable = function() {
        if (this.enabled) return;
        this.enabled = true;
        window.addEventListener($0ded52bcf72e3476$var$LOAD, this.eventListener);
    };
    NavigationPlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.eventListener) window.removeEventListener($0ded52bcf72e3476$var$LOAD, this.eventListener);
    };
    /**
     * Use the loadEventEnd field from window.performance to check if the website
     * has loaded already.
     *
     * @returns boolean
     */ NavigationPlugin.prototype.hasTheWindowLoadEventFired = function() {
        if (window.performance && window.performance.getEntriesByType($0ded52bcf72e3476$var$NAVIGATION).length) {
            var navData = window.performance.getEntriesByType($0ded52bcf72e3476$var$NAVIGATION)[0];
            return Boolean(navData.loadEventEnd);
        }
        return false;
    };
    /**
     * loadEventEnd is populated as 0 if the web page has not loaded completely, even though LOAD has been fired.
     * As a result, if loadEventEnd is populated, we can ignore eventListener and record the data directly.
     * On the other hand, if not, we have to use eventListener to initializes PerformanceObserver.
     * PerformanceObserver will act as a second check for the final load timings.
     */ NavigationPlugin.prototype.onload = function() {
        var _this = this;
        if (this.enabled) {
            if (this.hasTheWindowLoadEventFired()) window.performance.getEntriesByType($0ded52bcf72e3476$var$NAVIGATION).filter(function(e) {
                return !_this.config.ignore(e);
            }).forEach(function(event) {
                return _this.performanceNavigationEventHandlerTimingLevel2(event);
            });
            else window.addEventListener($0ded52bcf72e3476$var$LOAD, this.eventListener);
        }
    };
    return NavigationPlugin;
}((0, $ae9306a1f146dcf0$export$73ef013524b43f54));






var $206a6dc3649c31d6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $206a6dc3649c31d6$var$__assign = undefined && undefined.__assign || function() {
    $206a6dc3649c31d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $206a6dc3649c31d6$var$__assign.apply(this, arguments);
};
var $206a6dc3649c31d6$export$aed49a9f1b04de97 = "resource";
var $206a6dc3649c31d6$var$RESOURCE = "resource";
var $206a6dc3649c31d6$var$LOAD = "load";
/**
 * This plugin records resource performance timing events generated during every page load/re-load.
 */ var $206a6dc3649c31d6$export$98bfd717a3d0f3b1 = /** @class */ function(_super) {
    $206a6dc3649c31d6$var$__extends(ResourcePlugin, _super);
    function ResourcePlugin(config) {
        var _this = _super.call(this, $206a6dc3649c31d6$export$aed49a9f1b04de97) || this;
        _this.resourceEventListener = function(event) {
            var recordAll = [];
            var sample = [];
            var eventCount = 0;
            var resourceObserver = new PerformanceObserver(function(list) {
                list.getEntries().filter(function(e) {
                    return e.entryType === $206a6dc3649c31d6$var$RESOURCE;
                }).filter(function(e) {
                    return !_this.config.ignore(e);
                }).forEach(function(event) {
                    // Out of n resource events, x events are recorded using Observer API
                    var type = (0, $95d4fa925f373a86$export$a957f1dd6bc232c8)(event.name);
                    if (_this.config.recordAllTypes.includes(type)) recordAll.push(event);
                    else if (_this.config.sampleTypes.includes(type)) sample.push(event);
                });
            });
            resourceObserver.observe({
                entryTypes: [
                    $206a6dc3649c31d6$var$RESOURCE
                ]
            });
            // Remaining (n-x) resource events are recorded using getEntriesByType API.
            // Note: IE11 browser does not support Performance Observer API. Handle the failure gracefully
            var events = performance.getEntriesByType($206a6dc3649c31d6$var$RESOURCE);
            if (events !== undefined && events.length > 0) events.filter(function(e) {
                return !_this.config.ignore(e);
            }).forEach(function(event) {
                var type = (0, $95d4fa925f373a86$export$a957f1dd6bc232c8)(event.name);
                if (_this.config.recordAllTypes.includes(type)) recordAll.push(event);
                else if (_this.config.sampleTypes.includes(type)) sample.push(event);
            });
            // Record events for resources in recordAllTypes
            (0, $95d4fa925f373a86$export$448332262467e042)(recordAll);
            while(recordAll.length > 0 && eventCount < _this.config.eventLimit){
                _this.recordResourceEvent(recordAll.pop());
                eventCount++;
            }
            // Record events sampled from resources in sample
            (0, $95d4fa925f373a86$export$448332262467e042)(sample);
            while(sample.length > 0 && eventCount < _this.config.eventLimit){
                _this.recordResourceEvent(sample.pop());
                eventCount++;
            }
        };
        _this.recordResourceEvent = function(entryData) {
            var _a;
            var pathRegex = /.*\/application\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/events/;
            var entryUrl = new URL(entryData.name);
            if (entryUrl.host === _this.context.config.endpointUrl.host && pathRegex.test(entryUrl.pathname)) // Ignore calls to PutRumEvents (i.e., the CloudWatch RUM data
            // plane), otherwise we end up in an infinite loop of recording
            // PutRumEvents.
            return;
            if ((_a = _this.context) === null || _a === void 0 ? void 0 : _a.record) {
                var eventData = {
                    version: "1.0.0",
                    initiatorType: entryData.initiatorType,
                    duration: entryData.duration,
                    fileType: (0, $95d4fa925f373a86$export$a957f1dd6bc232c8)(entryData.name),
                    transferSize: entryData.transferSize
                };
                if (_this.context.config.recordResourceUrl) eventData.targetUrl = entryData.name;
                _this.context.record((0, $cacbc151bd9d066e$export$bd86f19f880edb29), eventData);
            }
        };
        _this.config = $206a6dc3649c31d6$var$__assign($206a6dc3649c31d6$var$__assign({}, (0, $99953abc9b43e438$export$ab51271b4ef950f)), config);
        return _this;
    }
    ResourcePlugin.prototype.enable = function() {
        if (this.enabled) return;
        this.enabled = true;
        window.addEventListener($206a6dc3649c31d6$var$LOAD, this.resourceEventListener);
    };
    ResourcePlugin.prototype.disable = function() {
        if (!this.enabled) return;
        this.enabled = false;
        if (this.resourceEventListener) window.removeEventListener($206a6dc3649c31d6$var$LOAD, this.resourceEventListener);
    };
    ResourcePlugin.prototype.onload = function() {
        window.addEventListener($206a6dc3649c31d6$var$LOAD, this.resourceEventListener);
    };
    return ResourcePlugin;
}((0, $ae9306a1f146dcf0$export$73ef013524b43f54));



var $2af83e6c028c192a$var$e, $2af83e6c028c192a$var$n, $2af83e6c028c192a$var$t, $2af83e6c028c192a$var$r, $2af83e6c028c192a$var$i, $2af83e6c028c192a$var$a = -1, $2af83e6c028c192a$var$o = function(e) {
    addEventListener("pageshow", function(n) {
        n.persisted && ($2af83e6c028c192a$var$a = n.timeStamp, e(n));
    }, !0);
}, $2af83e6c028c192a$var$c = function() {
    return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, $2af83e6c028c192a$var$u = function() {
    var e = $2af83e6c028c192a$var$c();
    return e && e.activationStart || 0;
}, $2af83e6c028c192a$var$f = function(e, n) {
    var t = $2af83e6c028c192a$var$c(), r = "navigate";
    $2af83e6c028c192a$var$a >= 0 ? r = "back-forward-cache" : t && (document.prerendering || $2af83e6c028c192a$var$u() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-")));
    return {
        name: e,
        value: void 0 === n ? -1 : n,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: r
    };
}, $2af83e6c028c192a$var$s = function(e, n, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            var r = new PerformanceObserver(function(e) {
                Promise.resolve().then(function() {
                    n(e.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: e,
                buffered: !0
            }, t || {})), r;
        }
    } catch (e) {}
}, $2af83e6c028c192a$var$d = function(e, n, t, r) {
    var i, a;
    return function(o) {
        n.value >= 0 && (o || r) && ((a = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = a, n.rating = function(e, n) {
            return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
        }(n.value, t), e(n));
    };
}, $2af83e6c028c192a$var$l = function(e) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return e();
        });
    });
}, $2af83e6c028c192a$var$p = function(e) {
    var n = function(n) {
        "pagehide" !== n.type && "hidden" !== document.visibilityState || e(n);
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $2af83e6c028c192a$var$v = function(e) {
    var n = !1;
    return function(t) {
        n || (e(t), n = !0);
    };
}, $2af83e6c028c192a$var$m = -1, $2af83e6c028c192a$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $2af83e6c028c192a$var$g = function(e) {
    "hidden" === document.visibilityState && $2af83e6c028c192a$var$m > -1 && ($2af83e6c028c192a$var$m = "visibilitychange" === e.type ? e.timeStamp : 0, $2af83e6c028c192a$var$T());
}, $2af83e6c028c192a$var$y = function() {
    addEventListener("visibilitychange", $2af83e6c028c192a$var$g, !0), addEventListener("prerenderingchange", $2af83e6c028c192a$var$g, !0);
}, $2af83e6c028c192a$var$T = function() {
    removeEventListener("visibilitychange", $2af83e6c028c192a$var$g, !0), removeEventListener("prerenderingchange", $2af83e6c028c192a$var$g, !0);
}, $2af83e6c028c192a$var$E = function() {
    return $2af83e6c028c192a$var$m < 0 && ($2af83e6c028c192a$var$m = $2af83e6c028c192a$var$h(), $2af83e6c028c192a$var$y(), $2af83e6c028c192a$var$o(function() {
        setTimeout(function() {
            $2af83e6c028c192a$var$m = $2af83e6c028c192a$var$h(), $2af83e6c028c192a$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $2af83e6c028c192a$var$m;
        }
    };
}, $2af83e6c028c192a$var$C = function(e) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return e();
    }, !0) : e();
}, $2af83e6c028c192a$export$e610c735b5510cec = [
    1800,
    3e3
], $2af83e6c028c192a$export$52489892712e8192 = function(e, n) {
    n = n || {}, $2af83e6c028c192a$var$C(function() {
        var t, r = $2af83e6c028c192a$var$E(), i = $2af83e6c028c192a$var$f("FCP"), a = $2af83e6c028c192a$var$s("paint", function(e) {
            e.forEach(function(e) {
                "first-contentful-paint" === e.name && (a.disconnect(), e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - $2af83e6c028c192a$var$u(), 0), i.entries.push(e), t(!0)));
            });
        });
        a && (t = $2af83e6c028c192a$var$d(e, i, $2af83e6c028c192a$export$e610c735b5510cec, n.reportAllChanges), $2af83e6c028c192a$var$o(function(r) {
            i = $2af83e6c028c192a$var$f("FCP"), t = $2af83e6c028c192a$var$d(e, i, $2af83e6c028c192a$export$e610c735b5510cec, n.reportAllChanges), $2af83e6c028c192a$var$l(function() {
                i.value = performance.now() - r.timeStamp, t(!0);
            });
        }));
    });
}, $2af83e6c028c192a$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $2af83e6c028c192a$export$fc6227831ee7c7 = function(e, n) {
    n = n || {}, $2af83e6c028c192a$export$52489892712e8192($2af83e6c028c192a$var$v(function() {
        var t, r = $2af83e6c028c192a$var$f("CLS", 0), i = 0, a = [], c = function(e) {
            e.forEach(function(e) {
                if (!e.hadRecentInput) {
                    var n = a[0], t = a[a.length - 1];
                    i && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (i += e.value, a.push(e)) : (i = e.value, a = [
                        e
                    ]);
                }
            }), i > r.value && (r.value = i, r.entries = a, t());
        }, u = $2af83e6c028c192a$var$s("layout-shift", c);
        u && (t = $2af83e6c028c192a$var$d(e, r, $2af83e6c028c192a$export$3f20d8e089ac35b2, n.reportAllChanges), $2af83e6c028c192a$var$p(function() {
            c(u.takeRecords()), t(!0);
        }), $2af83e6c028c192a$var$o(function() {
            i = 0, r = $2af83e6c028c192a$var$f("CLS", 0), t = $2af83e6c028c192a$var$d(e, r, $2af83e6c028c192a$export$3f20d8e089ac35b2, n.reportAllChanges), $2af83e6c028c192a$var$l(function() {
                return t();
            });
        }), setTimeout(t, 0));
    }));
}, $2af83e6c028c192a$var$A = {
    passive: !0,
    capture: !0
}, $2af83e6c028c192a$var$I = new Date, $2af83e6c028c192a$var$P = function(r, i) {
    $2af83e6c028c192a$var$e || ($2af83e6c028c192a$var$e = i, $2af83e6c028c192a$var$n = r, $2af83e6c028c192a$var$t = new Date, $2af83e6c028c192a$var$k(removeEventListener), $2af83e6c028c192a$var$F());
}, $2af83e6c028c192a$var$F = function() {
    if ($2af83e6c028c192a$var$n >= 0 && $2af83e6c028c192a$var$n < $2af83e6c028c192a$var$t - $2af83e6c028c192a$var$I) {
        var i = {
            entryType: "first-input",
            name: $2af83e6c028c192a$var$e.type,
            target: $2af83e6c028c192a$var$e.target,
            cancelable: $2af83e6c028c192a$var$e.cancelable,
            startTime: $2af83e6c028c192a$var$e.timeStamp,
            processingStart: $2af83e6c028c192a$var$e.timeStamp + $2af83e6c028c192a$var$n
        };
        $2af83e6c028c192a$var$r.forEach(function(e) {
            e(i);
        }), $2af83e6c028c192a$var$r = [];
    }
}, $2af83e6c028c192a$var$M = function(e) {
    if (e.cancelable) {
        var n = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, n) {
            var t = function() {
                $2af83e6c028c192a$var$P(e, n), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", t, $2af83e6c028c192a$var$A), removeEventListener("pointercancel", r, $2af83e6c028c192a$var$A);
            };
            addEventListener("pointerup", t, $2af83e6c028c192a$var$A), addEventListener("pointercancel", r, $2af83e6c028c192a$var$A);
        }(n, e) : $2af83e6c028c192a$var$P(n, e);
    }
}, $2af83e6c028c192a$var$k = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(n) {
        return e(n, $2af83e6c028c192a$var$M, $2af83e6c028c192a$var$A);
    });
}, $2af83e6c028c192a$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $2af83e6c028c192a$export$134ed2977d320dfd = function(t, i) {
    i = i || {}, $2af83e6c028c192a$var$C(function() {
        var a, c = $2af83e6c028c192a$var$E(), u = $2af83e6c028c192a$var$f("FID"), l = function(e) {
            e.startTime < c.firstHiddenTime && (u.value = e.processingStart - e.startTime, u.entries.push(e), a(!0));
        }, m = function(e) {
            e.forEach(l);
        }, h = $2af83e6c028c192a$var$s("first-input", m);
        a = $2af83e6c028c192a$var$d(t, u, $2af83e6c028c192a$export$8f7f3c48ca6fbe34, i.reportAllChanges), h && $2af83e6c028c192a$var$p($2af83e6c028c192a$var$v(function() {
            m(h.takeRecords()), h.disconnect();
        })), h && $2af83e6c028c192a$var$o(function() {
            var o;
            u = $2af83e6c028c192a$var$f("FID"), a = $2af83e6c028c192a$var$d(t, u, $2af83e6c028c192a$export$8f7f3c48ca6fbe34, i.reportAllChanges), $2af83e6c028c192a$var$r = [], $2af83e6c028c192a$var$n = -1, $2af83e6c028c192a$var$e = null, $2af83e6c028c192a$var$k(addEventListener), o = l, $2af83e6c028c192a$var$r.push(o), $2af83e6c028c192a$var$F();
        });
    });
}, $2af83e6c028c192a$var$B = 0, $2af83e6c028c192a$var$R = 1 / 0, $2af83e6c028c192a$var$H = 0, $2af83e6c028c192a$var$N = function(e) {
    e.forEach(function(e) {
        e.interactionId && ($2af83e6c028c192a$var$R = Math.min($2af83e6c028c192a$var$R, e.interactionId), $2af83e6c028c192a$var$H = Math.max($2af83e6c028c192a$var$H, e.interactionId), $2af83e6c028c192a$var$B = $2af83e6c028c192a$var$H ? ($2af83e6c028c192a$var$H - $2af83e6c028c192a$var$R) / 7 + 1 : 0);
    });
}, $2af83e6c028c192a$var$O = function() {
    return $2af83e6c028c192a$var$i ? $2af83e6c028c192a$var$B : performance.interactionCount || 0;
}, $2af83e6c028c192a$var$q = function() {
    "interactionCount" in performance || $2af83e6c028c192a$var$i || ($2af83e6c028c192a$var$i = $2af83e6c028c192a$var$s("event", $2af83e6c028c192a$var$N, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $2af83e6c028c192a$export$7f4cb060ded9173c = [
    200,
    500
], $2af83e6c028c192a$var$_ = 0, $2af83e6c028c192a$var$z = function() {
    return $2af83e6c028c192a$var$O() - $2af83e6c028c192a$var$_;
}, $2af83e6c028c192a$var$G = [], $2af83e6c028c192a$var$J = {}, $2af83e6c028c192a$var$K = function(e) {
    var n = $2af83e6c028c192a$var$G[$2af83e6c028c192a$var$G.length - 1], t = $2af83e6c028c192a$var$J[e.interactionId];
    if (t || $2af83e6c028c192a$var$G.length < 10 || e.duration > n.latency) {
        if (t) t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
        else {
            var r = {
                id: e.interactionId,
                latency: e.duration,
                entries: [
                    e
                ]
            };
            $2af83e6c028c192a$var$J[r.id] = r, $2af83e6c028c192a$var$G.push(r);
        }
        $2af83e6c028c192a$var$G.sort(function(e, n) {
            return n.latency - e.latency;
        }), $2af83e6c028c192a$var$G.splice(10).forEach(function(e) {
            delete $2af83e6c028c192a$var$J[e.id];
        });
    }
}, $2af83e6c028c192a$export$6693a9916ea977ef = function(e, n) {
    n = n || {}, $2af83e6c028c192a$var$C(function() {
        $2af83e6c028c192a$var$q();
        var t, r = $2af83e6c028c192a$var$f("INP"), i = function(e) {
            e.forEach(function(e) {
                (e.interactionId && $2af83e6c028c192a$var$K(e), "first-input" === e.entryType) && !$2af83e6c028c192a$var$G.some(function(n) {
                    return n.entries.some(function(n) {
                        return e.duration === n.duration && e.startTime === n.startTime;
                    });
                }) && $2af83e6c028c192a$var$K(e);
            });
            var n, i = (n = Math.min($2af83e6c028c192a$var$G.length - 1, Math.floor($2af83e6c028c192a$var$z() / 50)), $2af83e6c028c192a$var$G[n]);
            i && i.latency !== r.value && (r.value = i.latency, r.entries = i.entries, t());
        }, a = $2af83e6c028c192a$var$s("event", i, {
            durationThreshold: n.durationThreshold || 40
        });
        t = $2af83e6c028c192a$var$d(e, r, $2af83e6c028c192a$export$7f4cb060ded9173c, n.reportAllChanges), a && (a.observe({
            type: "first-input",
            buffered: !0
        }), $2af83e6c028c192a$var$p(function() {
            i(a.takeRecords()), r.value < 0 && $2af83e6c028c192a$var$z() > 0 && (r.value = 0, r.entries = []), t(!0);
        }), $2af83e6c028c192a$var$o(function() {
            $2af83e6c028c192a$var$G = [], $2af83e6c028c192a$var$_ = $2af83e6c028c192a$var$O(), r = $2af83e6c028c192a$var$f("INP"), t = $2af83e6c028c192a$var$d(e, r, $2af83e6c028c192a$export$7f4cb060ded9173c, n.reportAllChanges);
        }));
    });
}, $2af83e6c028c192a$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $2af83e6c028c192a$var$V = {}, $2af83e6c028c192a$export$da982ced0ff8a670 = function(e, n) {
    n = n || {}, $2af83e6c028c192a$var$C(function() {
        var t, r = $2af83e6c028c192a$var$E(), i = $2af83e6c028c192a$var$f("LCP"), a = function(e) {
            var n = e[e.length - 1];
            n && n.startTime < r.firstHiddenTime && (i.value = Math.max(n.startTime - $2af83e6c028c192a$var$u(), 0), i.entries = [
                n
            ], t());
        }, c = $2af83e6c028c192a$var$s("largest-contentful-paint", a);
        if (c) {
            t = $2af83e6c028c192a$var$d(e, i, $2af83e6c028c192a$export$948521ca5b0e1b17, n.reportAllChanges);
            var m = $2af83e6c028c192a$var$v(function() {
                $2af83e6c028c192a$var$V[i.id] || (a(c.takeRecords()), c.disconnect(), $2af83e6c028c192a$var$V[i.id] = !0, t(!0));
            });
            [
                "keydown",
                "click"
            ].forEach(function(e) {
                addEventListener(e, m, !0);
            }), $2af83e6c028c192a$var$p(m), $2af83e6c028c192a$var$o(function(r) {
                i = $2af83e6c028c192a$var$f("LCP"), t = $2af83e6c028c192a$var$d(e, i, $2af83e6c028c192a$export$948521ca5b0e1b17, n.reportAllChanges), $2af83e6c028c192a$var$l(function() {
                    i.value = performance.now() - r.timeStamp, $2af83e6c028c192a$var$V[i.id] = !0, t(!0);
                });
            });
        }
    });
}, $2af83e6c028c192a$export$65c59ea8064668fc = [
    800,
    1800
], $2af83e6c028c192a$var$Y = function e(n) {
    document.prerendering ? $2af83e6c028c192a$var$C(function() {
        return e(n);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return e(n);
    }, !0) : setTimeout(n, 0);
}, $2af83e6c028c192a$export$6e8eea9a35032c92 = function(e, n) {
    n = n || {};
    var t = $2af83e6c028c192a$var$f("TTFB"), r = $2af83e6c028c192a$var$d(e, t, $2af83e6c028c192a$export$65c59ea8064668fc, n.reportAllChanges);
    $2af83e6c028c192a$var$Y(function() {
        var i = $2af83e6c028c192a$var$c();
        if (i) {
            var a = i.responseStart;
            if (a <= 0 || a > performance.now()) return;
            t.value = Math.max(a - $2af83e6c028c192a$var$u(), 0), t.entries = [
                i
            ], r(!0), $2af83e6c028c192a$var$o(function() {
                t = $2af83e6c028c192a$var$f("TTFB", 0), (r = $2af83e6c028c192a$var$d(e, t, $2af83e6c028c192a$export$65c59ea8064668fc, n.reportAllChanges))(!0);
            });
        }
    });
};



var $f92fbaa7fcb8a7c0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f92fbaa7fcb8a7c0$export$554fe89f9c8af08f = "web-vitals";
var $f92fbaa7fcb8a7c0$export$7cbffb474cd3d938 = /** @class */ function(_super) {
    $f92fbaa7fcb8a7c0$var$__extends(WebVitalsPlugin, _super);
    function WebVitalsPlugin() {
        return _super.call(this, $f92fbaa7fcb8a7c0$export$554fe89f9c8af08f) || this;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    WebVitalsPlugin.prototype.enable = function() {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    WebVitalsPlugin.prototype.disable = function() {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    WebVitalsPlugin.prototype.configure = function(config) {};
    WebVitalsPlugin.prototype.getWebVitalData = function(webVitalData, eventType) {
        var _a;
        var webVitalEvent = {
            version: "1.0.0",
            value: webVitalData.value
        };
        (_a = this.context) === null || _a === void 0 || _a.record(eventType, webVitalEvent);
    };
    WebVitalsPlugin.prototype.onload = function() {
        var _this = this;
        (0, $2af83e6c028c192a$export$da982ced0ff8a670)(function(data) {
            return _this.getWebVitalData(data, (0, $cacbc151bd9d066e$export$8c3ab4bd9a26c2f));
        });
        (0, $2af83e6c028c192a$export$134ed2977d320dfd)(function(data) {
            return _this.getWebVitalData(data, (0, $cacbc151bd9d066e$export$a24e5072c9708b46));
        });
        (0, $2af83e6c028c192a$export$fc6227831ee7c7)(function(data) {
            return _this.getWebVitalData(data, (0, $cacbc151bd9d066e$export$28703fd5de30e043));
        });
    };
    return WebVitalsPlugin;
}((0, $ae9306a1f146dcf0$export$73ef013524b43f54));



var $b06745ff3f49e4cf$export$960b9ff25e7d4257 = function(holder) {
    if (crypto) return crypto.getRandomValues(holder);
    else if (msCrypto) return msCrypto.getRandomValues(holder);
    else throw new Error("No crypto library found.");
};


var $7f8033cf43d53f8e$export$4797c43f3b8db78d = [];
for(var $7f8033cf43d53f8e$var$i = 0; $7f8033cf43d53f8e$var$i < 256; $7f8033cf43d53f8e$var$i++)$7f8033cf43d53f8e$export$4797c43f3b8db78d[$7f8033cf43d53f8e$var$i] = ($7f8033cf43d53f8e$var$i + 0x100).toString(16).substr(1);
var $7f8033cf43d53f8e$export$ebb839c3f3eafacb = "X-Amzn-Trace-Id";
var $7f8033cf43d53f8e$export$f84bd70098573c5c = {
    logicalServiceName: "rum.aws.amazon.com",
    urlsToInclude: [
        /.*/
    ],
    urlsToExclude: [
        // Cognito endpoints https://docs.aws.amazon.com/general/latest/gr/cognito_identity.html
        /cognito\-identity\.([^\.]*\.)?amazonaws\.com/,
        // STS endpoints https://docs.aws.amazon.com/general/latest/gr/sts.html
        /sts\.([^\.]*\.)?amazonaws\.com/
    ],
    stackTraceLength: 200,
    recordAllRequests: false,
    addXRayTraceIdHeader: false
};
var $7f8033cf43d53f8e$export$c51d78304e000c2c = function(status) {
    return Math.floor(status / 100) === 4;
};
var $7f8033cf43d53f8e$export$55b2fbd5d4a32495 = function(status) {
    return Math.floor(status / 100) === 5;
};
var $7f8033cf43d53f8e$export$8eb4ede327e5ef71 = function(status) {
    return status === 429;
};
var $7f8033cf43d53f8e$export$8592af4e162d7307 = function(url, config) {
    var include = config.urlsToInclude.some(function(urlPattern) {
        return urlPattern.test(url);
    });
    var exclude = config.urlsToExclude.some(function(urlPattern) {
        return urlPattern.test(url);
    });
    return include && !exclude;
};
var $7f8033cf43d53f8e$export$514ea4b24901452a = function() {
    return Date.now() / 1000;
};
var $7f8033cf43d53f8e$export$88b737bfa7ce2fae = function(input, init, traced) {
    var http = {
        request: {}
    };
    http.request.method = (init === null || init === void 0 ? void 0 : init.method) ? init.method : "GET";
    http.request.traced = traced;
    http.request.url = $7f8033cf43d53f8e$export$cba59829645cc7a(input);
    return http;
};
var $7f8033cf43d53f8e$export$f7094576f2075545 = function(name, startTime, http) {
    var traceEvent = {
        version: "1.0.0",
        name: name,
        origin: "AWS::RUM::AppMonitor",
        id: $7f8033cf43d53f8e$var$generateSegmentId(),
        start_time: startTime,
        trace_id: $7f8033cf43d53f8e$var$generateTraceId(),
        end_time: undefined,
        subsegments: [],
        in_progress: false
    };
    if (http) traceEvent.http = http;
    return traceEvent;
};
var $7f8033cf43d53f8e$export$6bd97a7d82359bfa = function(name, startTime, http) {
    var subsegment = {
        id: $7f8033cf43d53f8e$var$generateSegmentId(),
        name: name,
        start_time: startTime,
        end_time: undefined,
        in_progress: false,
        namespace: name.endsWith("amazonaws.com") ? "aws" : "remote"
    };
    if (http) subsegment.http = http;
    return subsegment;
};
var $7f8033cf43d53f8e$export$9e491b7327b04ee1 = function(request) {
    try {
        if (request.hostname) return request.hostname;
        else if (request.url) return new URL(request.url).hostname;
        else return new URL(request.toString()).hostname;
    } catch (e) {
        // The URL could not be parsed. This library's convention is to fail
        // silently to limit the risk of impacting the application being
        // monitored.  We will use the hostname of the current page instead.
        return window.location.hostname;
    }
};
var $7f8033cf43d53f8e$export$4e11e2bb9c440e30 = function(init, traceId, segmentId) {
    if (!init.headers) init.headers = {};
    init.headers[$7f8033cf43d53f8e$export$ebb839c3f3eafacb] = $7f8033cf43d53f8e$export$94fc440f3d7efb76(traceId, segmentId);
};
var $7f8033cf43d53f8e$export$c6a21fecfae362a3 = function(headers, traceId, segmentId) {
    headers.set($7f8033cf43d53f8e$export$ebb839c3f3eafacb, $7f8033cf43d53f8e$export$94fc440f3d7efb76(traceId, segmentId));
};
var $7f8033cf43d53f8e$export$94fc440f3d7efb76 = function(traceId, segmentId) {
    return "Root=" + traceId + ";Parent=" + segmentId + ";Sampled=1";
};
var $7f8033cf43d53f8e$export$cba59829645cc7a = function(resource) {
    return resource.url ? resource.url : resource.toString();
};
/**
 * Generate a globally unique trace ID.
 *
 * See https://docs.aws.amazon.com/xray/latest/devguide/xray-api-sendingdata.html
 *
 * @returns a trace id with the form '1-[unix epoch time in 8 hex digits]-[random in 24 hex digits]'
 */ var $7f8033cf43d53f8e$var$generateTraceId = function() {
    return "1-".concat($7f8033cf43d53f8e$var$hexTime(), "-").concat($7f8033cf43d53f8e$var$guid());
};
/**
 * Generate a segment ID that is unique within a trace.
 *
 * See https://docs.aws.amazon.com/xray/latest/devguide/xray-api-sendingdata.html
 *
 * @returns a segment id, which is 16 random hex digits
 */ var $7f8033cf43d53f8e$var$generateSegmentId = function() {
    var randomBytes = new Uint8Array(8);
    (0, $b06745ff3f49e4cf$export$960b9ff25e7d4257)(randomBytes);
    return $7f8033cf43d53f8e$var$uint8ArrayToHexString(randomBytes);
};
var $7f8033cf43d53f8e$var$hexTime = function() {
    return Math.floor(Date.now() / 1000).toString(16);
};
var $7f8033cf43d53f8e$var$guid = function() {
    var randomBytes = new Uint8Array(12);
    (0, $b06745ff3f49e4cf$export$960b9ff25e7d4257)(randomBytes);
    return $7f8033cf43d53f8e$var$uint8ArrayToHexString(randomBytes);
};
var $7f8033cf43d53f8e$var$uint8ArrayToHexString = function(bytes) {
    var hexString = "";
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < bytes.length; i++)hexString += $7f8033cf43d53f8e$export$4797c43f3b8db78d[bytes[i]];
    return hexString;
};


var $53dd8959b438fa3f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $53dd8959b438fa3f$export$f2f14b72ae7c1556 = /** @class */ function(_super) {
    $53dd8959b438fa3f$var$__extends(XhrError, _super);
    function XhrError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "XMLHttpRequest error";
        return _this;
    }
    return XhrError;
}(Error);




var $a7b12c345e4b02d1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a7b12c345e4b02d1$var$__assign = undefined && undefined.__assign || function() {
    $a7b12c345e4b02d1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a7b12c345e4b02d1$var$__assign.apply(this, arguments);
};
var $a7b12c345e4b02d1$export$abc7936a51035191 = "xhr";
/**
 * A plugin which initiates and records AWS X-Ray traces for XML HTTP requests (XMLHttpRequest).
 *
 * The XMLHttpRequest API is monkey patched using shimmer so all calls to XMLHttpRequest are intercepted. Only calls
 * to URLs which are on the allowlist and are not on the denylist are traced and recorded.
 *
 * The XHR events we use (i.e., onload, onerror, onabort, ontimeout) are only
 * supported by newer browsers. If we want to support older browsers we will
 * need to detect older browsers and use the onreadystatechange event.
 *
 * For example, the following sequence events occur for each case:
 *
 * Case 1: Request succeeds events
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 2, status = 200)
 * readystatechange (state = 3, status = 200)
 * readystatechange (state = 4, status = 200)
 * load
 * loadend
 *
 * Case 2: Request fails because of invalid domain or CORS failure
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 4, status = 0)
 * error
 * loadend
 *
 * Case 3: Request fails because of timeout
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 4, status = 0)
 * timeout
 * loadend
 *
 * Case 4: Request is aborted
 * -------------------------------
 * readystatechange (state = 1, status = 0)
 * loadstart
 * readystatechange (state = 2, status = 200)
 * readystatechange (state = 3, status = 200)
 * readystatechange (state = 4, status = 0)
 * abort
 * loadend
 *
 * See
 * - https://xhr.spec.whatwg.org/#event-handlers.
 * - https://xhr.spec.whatwg.org/#events
 */ var $a7b12c345e4b02d1$export$d87482b00ffaab1 = /** @class */ function(_super) {
    $a7b12c345e4b02d1$var$__extends(XhrPlugin, _super);
    function XhrPlugin(config) {
        var _this = _super.call(this, $a7b12c345e4b02d1$export$abc7936a51035191) || this;
        _this.addXRayTraceIdHeader = function() {
            return _this.config.addXRayTraceIdHeader;
        };
        _this.isTracingEnabled = function() {
            return _this.context.config.enableXRay;
        };
        _this.isSessionRecorded = function() {
            var _a;
            return ((_a = _this.context.getSession()) === null || _a === void 0 ? void 0 : _a.record) || false;
        };
        _this.handleXhrLoadEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            if (xhrDetails) {
                var endTimee = (0, $7f8033cf43d53f8e$export$514ea4b24901452a)();
                xhrDetails.trace.end_time = endTimee;
                xhrDetails.trace.subsegments[0].end_time = endTimee;
                xhrDetails.trace.subsegments[0].http.response = {
                    status: xhr.status
                };
                if ((0, $7f8033cf43d53f8e$export$8eb4ede327e5ef71)(xhr.status)) {
                    xhrDetails.trace.subsegments[0].throttle = true;
                    xhrDetails.trace.throttle = true;
                } else if ((0, $7f8033cf43d53f8e$export$c51d78304e000c2c)(xhr.status)) {
                    xhrDetails.trace.subsegments[0].error = true;
                    xhrDetails.trace.error = true;
                } else if ((0, $7f8033cf43d53f8e$export$55b2fbd5d4a32495)(xhr.status)) {
                    xhrDetails.trace.subsegments[0].fault = true;
                    xhrDetails.trace.fault = true;
                }
                var clStr = xhr.getResponseHeader("Content-Length");
                var cl = clStr ? parseInt(clStr, 10) : NaN;
                if (!isNaN(cl)) xhrDetails.trace.subsegments[0].http.response.content_length = cl;
                _this.recordTraceEvent(xhrDetails.trace);
                _this.recordHttpEventWithResponse(xhrDetails, xhr);
            }
        };
        _this.handleXhrErrorEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            var errorName = "XMLHttpRequest error";
            var errorMessage = xhr.statusText ? xhr.status.toString() + ": " + xhr.statusText : xhr.status.toString();
            if (xhrDetails) {
                var endTime = (0, $7f8033cf43d53f8e$export$514ea4b24901452a)();
                // Guidance from X-Ray documentation:
                // > Record errors in segments when your application returns an
                // > error to the user, and in subsegments when a downstream call
                // > returns an error.
                xhrDetails.trace.fault = true;
                xhrDetails.trace.end_time = endTime;
                xhrDetails.trace.subsegments[0].end_time = endTime;
                xhrDetails.trace.subsegments[0].fault = true;
                xhrDetails.trace.subsegments[0].cause = {
                    exceptions: [
                        {
                            type: errorName,
                            message: errorMessage
                        }
                    ]
                };
                _this.recordTraceEvent(xhrDetails.trace);
                _this.recordHttpEventWithError(xhrDetails, new (0, $53dd8959b438fa3f$export$f2f14b72ae7c1556)(errorMessage));
            }
        };
        _this.handleXhrAbortEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            var errorName = "XMLHttpRequest abort";
            _this.handleXhrDetailsOnError(xhrDetails, errorName);
        };
        _this.handleXhrTimeoutEvent = function(e) {
            var xhr = e.target;
            var xhrDetails = _this.xhrMap.get(xhr);
            var errorName = "XMLHttpRequest timeout";
            _this.handleXhrDetailsOnError(xhrDetails, errorName);
        };
        _this.initializeTrace = function(xhrDetails) {
            var startTime = (0, $7f8033cf43d53f8e$export$514ea4b24901452a)();
            xhrDetails.trace = (0, $7f8033cf43d53f8e$export$f7094576f2075545)(_this.config.logicalServiceName, startTime);
            xhrDetails.trace.subsegments.push((0, $7f8033cf43d53f8e$export$6bd97a7d82359bfa)((0, $7f8033cf43d53f8e$export$9e491b7327b04ee1)(xhrDetails.url), startTime, {
                request: {
                    method: xhrDetails.method,
                    url: xhrDetails.url,
                    traced: true
                }
            }));
        };
        _this.sendWrapper = function() {
            var self = _this;
            return function(original) {
                return function() {
                    var xhrDetails = self.xhrMap.get(this);
                    if (xhrDetails) {
                        this.addEventListener("load", self.handleXhrLoadEvent);
                        this.addEventListener("error", self.handleXhrErrorEvent);
                        this.addEventListener("abort", self.handleXhrAbortEvent);
                        this.addEventListener("timeout", self.handleXhrTimeoutEvent);
                        self.initializeTrace(xhrDetails);
                        if (self.isTracingEnabled() && self.addXRayTraceIdHeader() && self.isSessionRecorded()) this.setRequestHeader((0, $7f8033cf43d53f8e$export$ebb839c3f3eafacb), (0, $7f8033cf43d53f8e$export$94fc440f3d7efb76)(xhrDetails.trace.trace_id, xhrDetails.trace.subsegments[0].id));
                    }
                    return original.apply(this, arguments);
                };
            };
        };
        _this.openWrapper = function() {
            var self = _this;
            return function(original) {
                return function(method, url, async) {
                    if ((0, $7f8033cf43d53f8e$export$8592af4e162d7307)(url, self.config)) self.xhrMap.set(this, {
                        url: url,
                        method: method,
                        async: async
                    });
                    return original.apply(this, arguments);
                };
            };
        };
        _this.config = $a7b12c345e4b02d1$var$__assign($a7b12c345e4b02d1$var$__assign({}, (0, $7f8033cf43d53f8e$export$f84bd70098573c5c)), config);
        _this.xhrMap = new Map();
        return _this;
    }
    XhrPlugin.prototype.onload = function() {
        this.enable();
    };
    Object.defineProperty(XhrPlugin.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: XMLHttpRequest.prototype,
                    name: "send",
                    wrapper: this.sendWrapper
                },
                {
                    nodule: XMLHttpRequest.prototype,
                    name: "open",
                    wrapper: this.openWrapper
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    XhrPlugin.prototype.handleXhrDetailsOnError = function(xhrDetails, errorName) {
        if (xhrDetails) {
            var endTime = (0, $7f8033cf43d53f8e$export$514ea4b24901452a)();
            xhrDetails.trace.end_time = endTime;
            xhrDetails.trace.subsegments[0].end_time = endTime;
            xhrDetails.trace.subsegments[0].error = true;
            xhrDetails.trace.subsegments[0].cause = {
                exceptions: [
                    {
                        type: errorName
                    }
                ]
            };
            this.recordTraceEvent(xhrDetails.trace);
            this.recordHttpEventWithError(xhrDetails, errorName);
        }
    };
    XhrPlugin.prototype.statusOk = function(status) {
        return status >= 200 && status < 300;
    };
    XhrPlugin.prototype.recordHttpEventWithResponse = function(xhrDetails, xhr) {
        if (this.config.recordAllRequests || !this.statusOk(xhr.status)) this.context.record((0, $cacbc151bd9d066e$export$84f67200f3ded68c), {
            version: "1.0.0",
            request: {
                method: xhrDetails.method,
                url: xhrDetails.url
            },
            response: {
                status: xhr.status,
                statusText: xhr.statusText
            }
        });
    };
    XhrPlugin.prototype.recordHttpEventWithError = function(xhrDetails, error) {
        var httpEvent = {
            version: "1.0.0",
            request: {
                method: xhrDetails.method,
                url: xhrDetails.url
            }
        };
        httpEvent.error = (0, $5dbe6f89bc325e6b$export$538c3c92a1912723)({
            type: "error",
            error: error
        }, this.config.stackTraceLength);
        this.context.record((0, $cacbc151bd9d066e$export$84f67200f3ded68c), httpEvent);
    };
    XhrPlugin.prototype.recordTraceEvent = function(trace) {
        if (this.isTracingEnabled() && this.isSessionRecorded()) this.context.record((0, $cacbc151bd9d066e$export$af74fbcbd614e4a5), trace);
    };
    return XhrPlugin;
}((0, $4cecd53d91524cf5$export$97e8843a4d399c46));






var $20c56515971d9b22$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $20c56515971d9b22$var$__assign = undefined && undefined.__assign || function() {
    $20c56515971d9b22$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $20c56515971d9b22$var$__assign.apply(this, arguments);
};
var $20c56515971d9b22$export$4bbeeaa6911d8bf8 = "fetch";
/**
 * A plugin which initiates and records AWS X-Ray traces for fetch HTTP requests.
 *
 * The fetch API is monkey patched using shimmer so all calls to fetch are intercepted. Only calls to URLs which are
 * on the allowlist and are not on the denylist are traced and recorded.
 */ var $20c56515971d9b22$export$50e7c43e92b022f7 = /** @class */ function(_super) {
    $20c56515971d9b22$var$__extends(FetchPlugin, _super);
    function FetchPlugin(config) {
        var _this = _super.call(this, $20c56515971d9b22$export$4bbeeaa6911d8bf8) || this;
        _this.isTracingEnabled = function() {
            return _this.context.config.enableXRay;
        };
        _this.isSessionRecorded = function() {
            var _a;
            return ((_a = _this.context.getSession()) === null || _a === void 0 ? void 0 : _a.record) || false;
        };
        _this.beginTrace = function(input, init, argsArray) {
            var startTime = (0, $7f8033cf43d53f8e$export$514ea4b24901452a)();
            var http = (0, $7f8033cf43d53f8e$export$88b737bfa7ce2fae)(input, init, true);
            var xRayTraceEvent = (0, $7f8033cf43d53f8e$export$f7094576f2075545)(_this.config.logicalServiceName, startTime);
            var subsegment = (0, $7f8033cf43d53f8e$export$6bd97a7d82359bfa)((0, $7f8033cf43d53f8e$export$9e491b7327b04ee1)(input), startTime, http);
            xRayTraceEvent.subsegments.push(subsegment);
            if (_this.config.addXRayTraceIdHeader) _this.addXRayTraceIdHeader(input, init, argsArray, xRayTraceEvent);
            return xRayTraceEvent;
        };
        _this.addXRayTraceIdHeader = function(input, init, argsArray, xRayTraceEvent) {
            if (input.headers) return (0, $7f8033cf43d53f8e$export$c6a21fecfae362a3)(input.headers, xRayTraceEvent.trace_id, xRayTraceEvent.subsegments[0].id);
            if (!init) {
                init = {};
                [].push.call(argsArray, init);
            }
            (0, $7f8033cf43d53f8e$export$4e11e2bb9c440e30)(init, xRayTraceEvent.trace_id, xRayTraceEvent.subsegments[0].id);
        };
        _this.endTrace = function(xRayTraceEvent, response, error) {
            if (xRayTraceEvent) {
                var endTime = (0, $7f8033cf43d53f8e$export$514ea4b24901452a)();
                xRayTraceEvent.subsegments[0].end_time = endTime;
                xRayTraceEvent.end_time = endTime;
                if (response) {
                    xRayTraceEvent.subsegments[0].http.response = {
                        status: response.status
                    };
                    if ((0, $7f8033cf43d53f8e$export$8eb4ede327e5ef71)(response.status)) {
                        xRayTraceEvent.subsegments[0].throttle = true;
                        xRayTraceEvent.throttle = true;
                    } else if ((0, $7f8033cf43d53f8e$export$c51d78304e000c2c)(response.status)) {
                        xRayTraceEvent.subsegments[0].error = true;
                        xRayTraceEvent.error = true;
                    } else if ((0, $7f8033cf43d53f8e$export$55b2fbd5d4a32495)(response.status)) {
                        xRayTraceEvent.subsegments[0].fault = true;
                        xRayTraceEvent.fault = true;
                    }
                    var clStr = response.headers.get("Content-Length");
                    var cl = clStr ? parseInt(clStr, 10) : NaN;
                    if (!isNaN(cl)) xRayTraceEvent.subsegments[0].http.response.content_length = cl;
                }
                if (error) {
                    // Guidance from X-Ray documentation:
                    // > Record errors in segments when your application returns an
                    // > error to the user, and in subsegments when a downstream call
                    // > returns an error.
                    xRayTraceEvent.fault = true;
                    xRayTraceEvent.subsegments[0].fault = true;
                    if (error instanceof Object) _this.appendErrorCauseFromObject(xRayTraceEvent.subsegments[0], error);
                    else if ((0, $5dbe6f89bc325e6b$export$1ffd2901c8f56573)(error)) _this.appendErrorCauseFromPrimitive(xRayTraceEvent.subsegments[0], error.toString());
                }
                _this.context.record((0, $cacbc151bd9d066e$export$af74fbcbd614e4a5), xRayTraceEvent);
            }
        };
        _this.createHttpEvent = function(input, init) {
            var request = input;
            return {
                version: "1.0.0",
                request: {
                    url: (0, $7f8033cf43d53f8e$export$cba59829645cc7a)(input),
                    method: (init === null || init === void 0 ? void 0 : init.method) ? init.method : request.method ? request.method : "GET"
                }
            };
        };
        _this.recordHttpEventWithResponse = function(httpEvent, response) {
            if (_this.config.recordAllRequests || !response.ok) {
                httpEvent.response = {
                    status: response.status,
                    statusText: response.statusText
                };
                _this.context.record((0, $cacbc151bd9d066e$export$84f67200f3ded68c), httpEvent);
            }
        };
        _this.recordHttpEventWithError = function(httpEvent, error) {
            httpEvent.error = (0, $5dbe6f89bc325e6b$export$538c3c92a1912723)({
                type: "error",
                error: error
            }, _this.config.stackTraceLength);
            _this.context.record((0, $cacbc151bd9d066e$export$84f67200f3ded68c), httpEvent);
        };
        _this.fetch = function(original, thisArg, argsArray, input, init) {
            var httpEvent = _this.createHttpEvent(input, init);
            var trace;
            if (!(0, $7f8033cf43d53f8e$export$8592af4e162d7307)((0, $7f8033cf43d53f8e$export$cba59829645cc7a)(input), _this.config)) return original.apply(thisArg, argsArray);
            if (_this.isTracingEnabled() && _this.isSessionRecorded()) trace = _this.beginTrace(input, init, argsArray);
            return original.apply(thisArg, argsArray).then(function(response) {
                _this.endTrace(trace, response, undefined);
                _this.recordHttpEventWithResponse(httpEvent, response);
                return response;
            }).catch(function(error) {
                _this.endTrace(trace, undefined, error);
                _this.recordHttpEventWithError(httpEvent, error);
                throw error;
            });
        };
        _this.fetchWrapper = function() {
            var self = _this;
            return function(original) {
                return function(input, init) {
                    return self.fetch(original, this, arguments, input, init);
                };
            };
        };
        _this.config = $20c56515971d9b22$var$__assign($20c56515971d9b22$var$__assign({}, (0, $7f8033cf43d53f8e$export$f84bd70098573c5c)), config);
        return _this;
    }
    Object.defineProperty(FetchPlugin.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: window,
                    name: "fetch",
                    wrapper: this.fetchWrapper
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    FetchPlugin.prototype.onload = function() {
        this.enable();
    };
    FetchPlugin.prototype.appendErrorCauseFromPrimitive = function(subsegment, error) {
        subsegment.cause = {
            exceptions: [
                {
                    type: error
                }
            ]
        };
    };
    FetchPlugin.prototype.appendErrorCauseFromObject = function(subsegment, error) {
        subsegment.cause = {
            exceptions: [
                {
                    type: error.name,
                    message: error.message
                }
            ]
        };
    };
    return FetchPlugin;
}((0, $4cecd53d91524cf5$export$97e8843a4d399c46));




var $ee2dd01a38eace9c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ee2dd01a38eace9c$export$80abfd226c7e1629 = "page-view";
/**
 * A plugin which records page view transitions.
 *
 * When a session is initialized, the PageManager records the landing page. When
 * subsequent pages are viewed, this plugin updates the page.
 */ var $ee2dd01a38eace9c$export$6c67d2a2a33c65d4 = /** @class */ function(_super) {
    $ee2dd01a38eace9c$var$__extends(PageViewPlugin, _super);
    function PageViewPlugin() {
        var _this = _super.call(this, $ee2dd01a38eace9c$export$80abfd226c7e1629) || this;
        _this.pushState = function() {
            var self = _this;
            return function(original) {
                return function(data, title, url) {
                    var retVal = original.apply(this, arguments);
                    self.recordPageView();
                    return retVal;
                };
            };
        };
        _this.replaceState = function() {
            var self = _this;
            return function(original) {
                return function(data, title, url) {
                    var retVal = original.apply(this, arguments);
                    self.recordPageView();
                    return retVal;
                };
            };
        };
        _this.popstateListener = function(event) {
            _this.recordPageView();
        };
        _this.recordPageView = function() {
            _this.context.recordPageView(_this.createIdForCurrentPage());
        };
        _this.enable();
        return _this;
    }
    PageViewPlugin.prototype.onload = function() {
        this.addListener();
        this.recordPageView();
    };
    Object.defineProperty(PageViewPlugin.prototype, "patches", {
        get: function() {
            return [
                {
                    nodule: History.prototype,
                    name: "pushState",
                    wrapper: this.pushState
                },
                {
                    nodule: History.prototype,
                    name: "replaceState",
                    wrapper: this.replaceState
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    PageViewPlugin.prototype.addListener = function() {
        // popstate will fire under the following conditions:
        // (1) The history back, forward or go APIs are used
        // (2) The URI's fragment (hash) changes
        window.addEventListener("popstate", this.popstateListener);
    };
    PageViewPlugin.prototype.createIdForCurrentPage = function() {
        var path = window.location.pathname;
        var hash = window.location.hash;
        switch(this.context.config.pageIdFormat){
            case (0, $afe47eb8223b4931$export$c90c55b1ac757b61).PathAndHash:
                if (path && hash) return path + hash;
                else if (path) return path;
                else if (hash) return hash;
                return "";
            case (0, $afe47eb8223b4931$export$c90c55b1ac757b61).Hash:
                return hash ? hash : "";
            case (0, $afe47eb8223b4931$export$c90c55b1ac757b61).Path:
            default:
                return path ? path : "";
        }
    };
    return PageViewPlugin;
}((0, $4cecd53d91524cf5$export$97e8843a4d399c46));



var $afe47eb8223b4931$var$__assign = undefined && undefined.__assign || function() {
    $afe47eb8223b4931$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $afe47eb8223b4931$var$__assign.apply(this, arguments);
};
var $afe47eb8223b4931$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $afe47eb8223b4931$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $afe47eb8223b4931$var$DEFAULT_REGION = "us-west-2";
var $afe47eb8223b4931$var$DEFAULT_ENDPOINT = "https://dataplane.rum.".concat($afe47eb8223b4931$var$DEFAULT_REGION, ".amazonaws.com");
var $afe47eb8223b4931$export$6a856f7865e90ddd;
(function(TelemetryEnum) {
    TelemetryEnum["Errors"] = "errors";
    TelemetryEnum["Performance"] = "performance";
    TelemetryEnum["Interaction"] = "interaction";
    TelemetryEnum["Http"] = "http";
})($afe47eb8223b4931$export$6a856f7865e90ddd || ($afe47eb8223b4931$export$6a856f7865e90ddd = {}));
var $afe47eb8223b4931$export$c90c55b1ac757b61;
(function(PageIdFormatEnum) {
    PageIdFormatEnum["Path"] = "PATH";
    PageIdFormatEnum["Hash"] = "HASH";
    PageIdFormatEnum["PathAndHash"] = "PATH_AND_HASH";
})($afe47eb8223b4931$export$c90c55b1ac757b61 || ($afe47eb8223b4931$export$c90c55b1ac757b61 = {}));
var $afe47eb8223b4931$export$dffdab8c06109418 = function() {
    return {
        unique: false,
        domain: window.location.hostname,
        path: "/",
        sameSite: "Strict",
        secure: true
    };
};
var $afe47eb8223b4931$export$f84bd70098573c5c = function(cookieAttributes) {
    return {
        allowCookies: false,
        batchLimit: 100,
        client: (0, $ccd6d6da69a078d2$export$da62d514fa80410b),
        cookieAttributes: cookieAttributes,
        disableAutoPageView: false,
        dispatchInterval: 5000,
        enableRumClient: true,
        enableXRay: false,
        endpoint: $afe47eb8223b4931$var$DEFAULT_ENDPOINT,
        endpointUrl: new URL($afe47eb8223b4931$var$DEFAULT_ENDPOINT),
        eventCacheSize: 200,
        eventPluginsToLoad: [],
        pageIdFormat: $afe47eb8223b4931$export$c90c55b1ac757b61.Path,
        pagesToExclude: [],
        pagesToInclude: [
            /.*/
        ],
        signing: true,
        recordResourceUrl: true,
        retries: 2,
        routeChangeComplete: 100,
        routeChangeTimeout: 10000,
        sessionAttributes: {},
        sessionEventLimit: 200,
        sessionLengthSeconds: 1800,
        sessionSampleRate: 1,
        telemetries: [],
        useBeacon: true,
        userIdRetentionDays: 30
    };
};
/**
 * An orchestrator which (1) initializes cwr components and (2) provides the API for the application to interact
 * with the RUM web client. Depending on how the RUM web client was loaded, this class may be called directly, or
 * indirectly through the CommandQueue:
 * - If the client was loaded by an HTML script tag, Orchestration is called indirectly through the CommandQueue.
 * - If the client was loaded as an NPM module, Orchestration is called directly by the application.
 */ var $afe47eb8223b4931$export$fb30ce7d244fa667 = /** @class */ function() {
    /**
     * Instantiate the CloudWatch RUM web client and begin monitoring the
     * application.
     *
     * This constructor may throw a TypeError if not correctly configured. In
     * production code, wrap calls to this constructor in a try/catch block so
     * that this does not impact the application.
     *
     * @param applicationId A globally unique identifier for the CloudWatch RUM
     * app monitor which monitors your application.
     * @param applicationVersion Your application's semantic version. If you do
     * not wish to use this field then add any placeholder, such as '0.0.0'.
     * @param region The AWS region of the app monitor. For example, 'us-east-1'
     * or 'eu-west-2'.
     * @param configCookieAttributes
     * @param partialConfig An application-specific configuration for the web
     * client.
     */ function Orchestration(applicationId, applicationVersion, region, _a) {
        if (_a === void 0) _a = {};
        var configCookieAttributes = _a.cookieAttributes, partialConfig = $afe47eb8223b4931$var$__rest(_a, [
            "cookieAttributes"
        ]);
        if (typeof region === "undefined") // Provide temporary backwards compatibility if the region was not provided by the loader. This will be
        // removed when internal users have migrated to the new signature.
        region = "us-west-2";
        var cookieAttributes = $afe47eb8223b4931$var$__assign($afe47eb8223b4931$var$__assign({}, $afe47eb8223b4931$export$dffdab8c06109418()), configCookieAttributes);
        this.config = $afe47eb8223b4931$var$__assign($afe47eb8223b4931$var$__assign({
            fetchFunction: fetch
        }, $afe47eb8223b4931$export$f84bd70098573c5c(cookieAttributes)), partialConfig);
        this.config.endpoint = this.getDataPlaneEndpoint(region, partialConfig);
        // If the URL is not formatted correctly, a TypeError will be thrown.
        // This breaks our convention to fail-safe here for the sake of
        // debugging. It is expected that the application has wrapped the call
        // to the constructor in a try/catch block, as is done in the example
        // code.
        this.config.endpointUrl = new URL(this.config.endpoint);
        this.eventCache = this.initEventCache(applicationId, applicationVersion);
        this.dispatchManager = this.initDispatch(region);
        this.pluginManager = this.initPluginManager(applicationId, applicationVersion);
        if (this.config.enableRumClient) this.enable();
        else this.disable();
    }
    /**
     * Set the credential provider that will be used to authenticate with the
     * data plane service (AWS auth).
     *
     * @param credentials A provider of AWS credentials.
     */ Orchestration.prototype.setAwsCredentials = function(credentials) {
        this.dispatchManager.setAwsCredentials(credentials);
    };
    /**
     * Set custom session attributes to add them to all event metadata.
     *
     * @param payload object containing custom attribute data in the form of key, value pairs
     */ Orchestration.prototype.addSessionAttributes = function(sessionAttributes) {
        this.eventCache.addSessionAttributes(sessionAttributes);
    };
    /**
     * Add a telemetry plugin.
     *
     * @param plugin A plugin which adheres to the RUM web client's plugin interface.
     */ Orchestration.prototype.addPlugin = function(plugin) {
        this.pluginManager.addPlugin(plugin);
    };
    /**
     * Force the client to immediately dispatch events to the collector.
     */ Orchestration.prototype.dispatch = function() {
        this.dispatchManager.dispatchFetch();
    };
    /**
     * Force the client to immediately dispatch events to the collector using a beacon.
     */ Orchestration.prototype.dispatchBeacon = function() {
        this.dispatchManager.dispatchBeacon();
    };
    /**
     * When enabled, the client records and dispatches events.
     */ Orchestration.prototype.enable = function() {
        this.eventCache.enable();
        this.pluginManager.enable();
        this.dispatchManager.enable();
    };
    /**
     * When disabled, the client does not record or dispatch events.
     */ Orchestration.prototype.disable = function() {
        this.dispatchManager.disable();
        this.pluginManager.disable();
        this.eventCache.disable();
    };
    /**
     * @param allow when {@code false}, the RUM web client will not store cookies or use localstorage.
     */ Orchestration.prototype.allowCookies = function(allow) {
        this.config.allowCookies = allow;
    };
    /**
     * Update the current page the user is interacting with.
     *
     * @param payload Can be string or PageAttributes object
     * If string, payload is pageId (The unique ID for the page within the application).
     * If PageAttributes, payload contains pageId as well as page attributes to include in events with pageId
     */ Orchestration.prototype.recordPageView = function(payload) {
        this.eventCache.recordPageView(payload);
    };
    /**
     * Record an error using the JS error plugin.
     *
     * @param error An ErrorEvent, Error or primitive.
     */ Orchestration.prototype.recordError = function(error) {
        this.pluginManager.record((0, $a0eaa7e3f73d8780$export$e5e1e9745ffa96a1), error);
    };
    /**
     * Update DOM plugin to record the (additional) provided DOM events.
     *
     * @param events
     */ Orchestration.prototype.registerDomEvents = function(events) {
        this.pluginManager.updatePlugin((0, $3696a3f13124f66d$export$951d4df55ff80b15), events);
    };
    /**
     * Records a custom event.
     *
     * @param type A unique name for the type of event being recorded.
     * @param eventData A JSON object containing the event's attributes.
     */ Orchestration.prototype.recordEvent = function(eventType, eventData) {
        this.eventCache.recordEvent(eventType, eventData);
    };
    Orchestration.prototype.initEventCache = function(applicationId, applicationVersion) {
        return new (0, $789d4e4e835226fd$export$48ce5537dd58278c)({
            id: applicationId,
            version: applicationVersion
        }, this.config);
    };
    Orchestration.prototype.initDispatch = function(region) {
        var dispatch = new (0, $dbab15270acbab61$export$65fee5f8f91a342f)(region, this.config.endpointUrl, this.eventCache, this.config);
        if (this.config.identityPoolId && this.config.guestRoleArn) dispatch.setAwsCredentials(new (0, $65343e0984f8c697$export$d9e3c9dc7eaad0c3)(this.config).ChainAnonymousCredentialsProvider);
        else if (this.config.identityPoolId) dispatch.setAwsCredentials(new (0, $a820ff3a376466a8$export$98bfa4ab673a3dcf)(this.config).ChainAnonymousCredentialsProvider);
        return dispatch;
    };
    Orchestration.prototype.initPluginManager = function(applicationId, applicationVersion) {
        var BUILTIN_PLUGINS = this.constructBuiltinPlugins();
        var PLUGINS = $afe47eb8223b4931$var$__spreadArray($afe47eb8223b4931$var$__spreadArray([], BUILTIN_PLUGINS, true), this.config.eventPluginsToLoad, true);
        var pluginContext = {
            applicationId: applicationId,
            applicationVersion: applicationVersion,
            config: this.config,
            record: this.eventCache.recordEvent,
            recordPageView: this.eventCache.recordPageView,
            getSession: this.eventCache.getSession
        };
        // Initialize PluginManager
        var pluginManager = new (0, $ac29891f63733f60$export$f2c0a16002429d72)(pluginContext);
        // Load page view plugin
        if (!this.config.disableAutoPageView) pluginManager.addPlugin(new (0, $ee2dd01a38eace9c$export$6c67d2a2a33c65d4)());
        // Load plugins
        PLUGINS.forEach(function(p) {
            pluginManager.addPlugin(p);
        });
        return pluginManager;
    };
    Orchestration.prototype.constructBuiltinPlugins = function() {
        var plugins = [];
        var functor = this.telemetryFunctor();
        this.config.telemetries.forEach(function(type) {
            if (typeof type === "string" && functor[type.toLowerCase()]) plugins = $afe47eb8223b4931$var$__spreadArray($afe47eb8223b4931$var$__spreadArray([], plugins, true), functor[type.toLowerCase()]({}), true);
            else if (Array.isArray(type) && functor[type[0].toLowerCase()]) plugins = $afe47eb8223b4931$var$__spreadArray($afe47eb8223b4931$var$__spreadArray([], plugins, true), functor[type[0].toLowerCase()](type[1]), true);
        });
        return plugins;
    };
    Orchestration.prototype.getDataPlaneEndpoint = function(region, partialConfig) {
        return partialConfig.endpoint ? partialConfig.endpoint : $afe47eb8223b4931$var$DEFAULT_ENDPOINT.replace($afe47eb8223b4931$var$DEFAULT_REGION, region);
    };
    /**
     * Returns a functor which maps data collection categories to
     * instantiated plugins.
     */ Orchestration.prototype.telemetryFunctor = function() {
        var _a;
        return _a = {}, _a[$afe47eb8223b4931$export$6a856f7865e90ddd.Errors] = function(config) {
            return [
                new (0, $a0eaa7e3f73d8780$export$61c5f910fd4dc4fe)(config)
            ];
        }, _a[$afe47eb8223b4931$export$6a856f7865e90ddd.Performance] = function(config) {
            return [
                new (0, $0ded52bcf72e3476$export$cb4379c08e6ffdc7)(config),
                new (0, $206a6dc3649c31d6$export$98bfd717a3d0f3b1)(config),
                new (0, $f92fbaa7fcb8a7c0$export$7cbffb474cd3d938)()
            ];
        }, _a[$afe47eb8223b4931$export$6a856f7865e90ddd.Interaction] = function(config) {
            return [
                new (0, $3696a3f13124f66d$export$51f3305bbc42a4a1)(config)
            ];
        }, _a[$afe47eb8223b4931$export$6a856f7865e90ddd.Http] = function(config) {
            return [
                new (0, $a7b12c345e4b02d1$export$d87482b00ffaab1)(config),
                new (0, $20c56515971d9b22$export$50e7c43e92b022f7)(config)
            ];
        }, _a;
    };
    return Orchestration;
}();


// authInit.ts

var $615652efb7481f32$exports = {};
!function(t, e) {
    $615652efb7481f32$exports = e();
}($615652efb7481f32$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $0840a3787500c813$export$f91e818b28421958 = "REGISTER_SUCCESS";
const $0840a3787500c813$export$b885672bc5665ae2 = "REGISTER_FAIL";
const $0840a3787500c813$export$b25da9cb1df1f7ca = "REGISTER_CONFIRMATION_SUCCESS";
const $0840a3787500c813$export$7c504496b873f4fe = "REGISTER_CONFIRMATION_FAIL";
const $0840a3787500c813$export$acea34b366063395 = "RESEND_CONFIRMATION_EMAIL_SUCCESS";
const $0840a3787500c813$export$d3c2b0cd56b0637c = "RESEND_CONFIRMATION_EMAIL_FAIL";
const $0840a3787500c813$export$5223a5682801fa43 = "LOGIN_SUCCESS";
const $0840a3787500c813$export$d2473a15d627f3f1 = "LOGIN_FAIL";
const $0840a3787500c813$export$35e541d26a145a7c = "LOGOUT";
const $0840a3787500c813$export$145d071b2cefcb66 = "UPDATE_TOURS_SUCCESS";
const $0840a3787500c813$export$9da28f1f0b10ca02 = "UPDATE_TOURS_FAIL";
const $0840a3787500c813$export$e36d99af0a9f9ab7 = "SET_GLOBAL_TOUR_LOCK";
const $0840a3787500c813$export$4c021acc9734bf10 = "CLEAR_GLOBAL_TOUR_LOCK";
const $0840a3787500c813$export$68513b67d94d64cf = "UPDATE_COGNITO_SETTINGS_SUCCESS";
const $0840a3787500c813$export$b3ea9843eae6e10b = "UPDATE_COGNITO_SETTINGS_FAIL";
const $0840a3787500c813$export$7903306f6790930 = "UPDATE_USER_ATTRIBUTES_SUCCESS";
const $0840a3787500c813$export$f55d666114d8f75a = "UPDATE_USER_ATTRIBUTES_FAIL";
const $0840a3787500c813$export$52dd5c72d66642a1 = "CHANGE_PASSWORD_SUCCESS";
const $0840a3787500c813$export$d482da6a78662f2b = "CHANGE_PASSWORD_FAIL";
const $0840a3787500c813$export$f5c41f548f91b6d0 = "UPDATE_CATEGORY_DATA";
const $0840a3787500c813$export$e55e36ad40193eb1 = "UPDATE_CATEGORY_DATA_ERROR";
const $0840a3787500c813$export$8ebe3f77c9e07491 = "SET_CATEGORY_LOADING_STATE";
const $0840a3787500c813$export$f099dfdea5c944b8 = "CLEAR_CATEGORY_LOADING_STATE";
const $0840a3787500c813$export$759202814b0c251 = "UPDATE_ACCOUNT_IMPORT_FILE_INITIATED";
const $0840a3787500c813$export$49a3cde25ff589a7 = "UPDATE_ACCOUNT_IMPORT_FILE_SUCCESS";
const $0840a3787500c813$export$dedf1521f8a07c0c = "UPDATE_ACCOUNT_IMPORT_FILE_CLEAR_QUEUE";
const $0840a3787500c813$export$7aa7c11fd7b8cae4 = "PUT_QUOTES_SUCCESS";
const $0840a3787500c813$export$67acc615f1131e5f = "DELETE_QUOTES_SUCCESS";
const $0840a3787500c813$export$5c9345d35146cf8b = "GET_QUOTES_SUCCESS";
const $0840a3787500c813$export$ecdcb9b94b2afdcd = "UPDATE_ACCOUNT_DATA";
const $0840a3787500c813$export$19949dde355aec0c = "UPDATE_ACCOUNT_DATA_ERROR";
const $0840a3787500c813$export$18314edbcf1d3e19 = "SET_ACCOUNT_LOADING_STATE";
const $0840a3787500c813$export$8fc3d65634883eae = "CLEAR_ACCOUNT_LOADING_STATE";
const $0840a3787500c813$export$94e5d19a4914d842 = "SET_ACCOUNT_FAILED_STATE";
const $0840a3787500c813$export$f56c21b951c55d75 = "SET_MESSAGE";
const $0840a3787500c813$export$b3af722de1fd7d3c = "SET_ALERT";
const $0840a3787500c813$export$97b09ce6a5c74156 = "CLEAR_ALERT";
const $0840a3787500c813$export$46b95b1ea69baa95 = "UPDATE_ALERT_RESPONSE";
const $0840a3787500c813$export$a4c351e5b9b68a40 = "SET_APP_SIGNAL";
const $0840a3787500c813$export$80f5d6a1a3225791 = "CLEAR_APP_SIGNAL";
const $0840a3787500c813$export$30ea2bfc5f501552 = "SET_FULLSCREEN_REPORT";
const $0840a3787500c813$export$b65e917bab1efccd = "CLEAR_FULLSCREEN_REPORT";
const $0840a3787500c813$export$97ed72fda1e17d06 = "CLEAR_STORED_DATA";
const $0840a3787500c813$export$e28698d3c79cf59c = "GET_DATA_FAIL";
const $0840a3787500c813$export$1291409bdbfa36e8 = "GET_DATA_SUCCESS";
const $0840a3787500c813$export$d4ed5bb36b4b7a37 = "GET_MOCK_DATA_FAIL";
const $0840a3787500c813$export$a527c0d8fa275576 = "GET_MOCK_DATA_SUCCESS";
const $0840a3787500c813$export$52adc266e78d1cf9 = "UPDATE_STOCKS_SETTINGS_SUCCESS";
const $0840a3787500c813$export$cbb43ec3bd54a7c5 = "UPDATE_STOCKS_SETTINGS_FAIL";
const $0840a3787500c813$export$8de650585f4e7b91 = "SURVEY_SENT";
const $0840a3787500c813$export$fb9d9de77be06b63 = "SURVEY_SENDING_ERROR";
const $0840a3787500c813$export$20ab86c37788ea12 = "PAYMENT_ERROR";
const $0840a3787500c813$export$ae9959ae2f1008b7 = "PREUPDATE_PROJECT_ORDER_SEQUENCE";
const $0840a3787500c813$export$a6698c9cc0030073 = "UPDATE_PROJECT_ORDER_SEQUENCE_SUCCESS";
const $0840a3787500c813$export$af7377830008b210 = "UPDATE_PROJECT_ORDER_SEQUENCE_FAIL";
const $0840a3787500c813$export$f29c717e71981e5a = "GET_PROJECTS_SUCCESS";
const $0840a3787500c813$export$80346ac49821b129 = "GET_PROJECTS_FAIL";
const $0840a3787500c813$export$15bdd6f74fffda24 = "POST_PROJECT_SUCCESS";
const $0840a3787500c813$export$688b2f09bbdcf053 = "POST_PROJECT_FAIL";
const $0840a3787500c813$export$8d1ac4416c662465 = "UPDATE_PROJECT_SUCCESS";
const $0840a3787500c813$export$7ce38f165121a0d2 = "DELETE_PROJECT_SUCCESS";
const $0840a3787500c813$export$1fff2b06b307000a = "GET_REPORTS_SUCCESS";
const $0840a3787500c813$export$f636798969f3cf38 = "GET_REPORTS_FAIL";
const $0840a3787500c813$export$b8c0c3f58c864110 = "POST_REPORT_SUCCESS";
const $0840a3787500c813$export$e7562f784118faee = "POST_REPORT_FAIL";
const $0840a3787500c813$export$769337e69eba2e14 = "UPDATE_REPORT_SUCCESS";
const $0840a3787500c813$export$f16ef654daccea11 = "DELETE_REPORT_SUCCESS";
const $0840a3787500c813$export$a999df3591da561 = "SET_MOBILE_APP_MODE";
const $0840a3787500c813$export$bf63969c69f30522 = "UPDATE_CONSENT";


/* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9GPfD = parcelRequire("9GPfD");
function $505ebcb184373782$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $505ebcb184373782$export$2e2bcd8739ae039(obj);
}



function $27f18dd8fc16da3b$export$2e2bcd8739ae039(input, hint) {
    if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $7fddabb4b045308c$export$2e2bcd8739ae039(arg) {
    var key = (0, $27f18dd8fc16da3b$export$2e2bcd8739ae039)(arg, "string");
    return (0, $505ebcb184373782$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $8273a87573256c54$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8273a87573256c54$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8273a87573256c54$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8273a87573256c54$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $71488736b7fc99c4$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $71488736b7fc99c4$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $71488736b7fc99c4$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $71488736b7fc99c4$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $71488736b7fc99c4$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $71488736b7fc99c4$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $71488736b7fc99c4$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $71488736b7fc99c4$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $71488736b7fc99c4$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($71488736b7fc99c4$var$isDate(val)) return "date";
    if ($71488736b7fc99c4$var$isError(val)) return "error";
    var constructorName = $71488736b7fc99c4$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $71488736b7fc99c4$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $71488736b7fc99c4$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $71488736b7fc99c4$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $71488736b7fc99c4$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $71488736b7fc99c4$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(1));
        return enhancer($71488736b7fc99c4$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$71488736b7fc99c4$var$isPlainObject(action)) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $71488736b7fc99c4$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$71488736b7fc99c4$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $71488736b7fc99c4$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$71488736b7fc99c4$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $71488736b7fc99c4$export$8928921ea2d3b126 = $71488736b7fc99c4$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $71488736b7fc99c4$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $71488736b7fc99c4$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $71488736b7fc99c4$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$71488736b7fc99c4$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $71488736b7fc99c4$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $71488736b7fc99c4$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $71488736b7fc99c4$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $71488736b7fc99c4$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $71488736b7fc99c4$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $71488736b7fc99c4$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $71488736b7fc99c4$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $71488736b7fc99c4$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $71488736b7fc99c4$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $71488736b7fc99c4$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $71488736b7fc99c4$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $71488736b7fc99c4$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $71488736b7fc99c4$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($71488736b7fc99c4$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $71488736b7fc99c4$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $58b9680bf8a527fb$var$NOT_FOUND = "NOT_FOUND";
function $58b9680bf8a527fb$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $58b9680bf8a527fb$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $58b9680bf8a527fb$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $58b9680bf8a527fb$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $58b9680bf8a527fb$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $58b9680bf8a527fb$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $58b9680bf8a527fb$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $58b9680bf8a527fb$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $58b9680bf8a527fb$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $58b9680bf8a527fb$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $58b9680bf8a527fb$var$createSingletonCache(comparator) : $58b9680bf8a527fb$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $58b9680bf8a527fb$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $5c22629b42831e80$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $5c22629b42831e80$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $5c22629b42831e80$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $5c22629b42831e80$export$595d22ed68ca2841 = /* #__PURE__ */ $5c22629b42831e80$export$5943f4447f6ef248((0, $58b9680bf8a527fb$export$281bff7f05488aa2));
var $5c22629b42831e80$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $5c22629b42831e80$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $1ab49e43fd6bbe7b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $1ab49e43fd6bbe7b$var$thunk = $1ab49e43fd6bbe7b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$1ab49e43fd6bbe7b$var$thunk.withExtraArgument = $1ab49e43fd6bbe7b$var$createThunkMiddleware;
var $1ab49e43fd6bbe7b$export$2e2bcd8739ae039 = $1ab49e43fd6bbe7b$var$thunk;



var $4ZL0H = parcelRequire("4ZL0H");
var $745f2177c5cf84eb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $745f2177c5cf84eb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $745f2177c5cf84eb$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $745f2177c5cf84eb$var$__defProp = Object.defineProperty;
var $745f2177c5cf84eb$var$__defProps = Object.defineProperties;
var $745f2177c5cf84eb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $745f2177c5cf84eb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $745f2177c5cf84eb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $745f2177c5cf84eb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $745f2177c5cf84eb$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $745f2177c5cf84eb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $745f2177c5cf84eb$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($745f2177c5cf84eb$var$__hasOwnProp.call(b, prop)) $745f2177c5cf84eb$var$__defNormalProp(a, prop, b[prop]);
    if ($745f2177c5cf84eb$var$__getOwnPropSymbols) for(var _i = 0, _c = $745f2177c5cf84eb$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($745f2177c5cf84eb$var$__propIsEnum.call(b, prop)) $745f2177c5cf84eb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $745f2177c5cf84eb$var$__spreadProps = function(a, b) {
    return $745f2177c5cf84eb$var$__defProps(a, $745f2177c5cf84eb$var$__getOwnPropDescs(b));
};
var $745f2177c5cf84eb$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $745f2177c5cf84eb$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $5c22629b42831e80$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $745f2177c5cf84eb$var$__spreadArray([
            (0, $9GPfD.isDraft)(value) ? (0, $9GPfD.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $745f2177c5cf84eb$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $71488736b7fc99c4$export$f672e0b6f7222cd7;
    return (0, $71488736b7fc99c4$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $745f2177c5cf84eb$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $745f2177c5cf84eb$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $745f2177c5cf84eb$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $745f2177c5cf84eb$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $745f2177c5cf84eb$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $745f2177c5cf84eb$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $745f2177c5cf84eb$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
function $745f2177c5cf84eb$var$freezeDraftable(val) {
    return (0, $9GPfD.isDraftable)(val) ? (0, $9GPfD.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $745f2177c5cf84eb$var$isProduction = true;
var $745f2177c5cf84eb$var$prefix = "Invariant failed";
function $745f2177c5cf84eb$var$invariant(condition, message) {
    if (condition) return;
    if ($745f2177c5cf84eb$var$isProduction) throw new Error($745f2177c5cf84eb$var$prefix);
    throw new Error($745f2177c5cf84eb$var$prefix + ": " + (message || ""));
}
function $745f2177c5cf84eb$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $745f2177c5cf84eb$var$getSerialize(serializer, decycler), indent);
}
function $745f2177c5cf84eb$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $745f2177c5cf84eb$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $745f2177c5cf84eb$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $745f2177c5cf84eb$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $745f2177c5cf84eb$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $745f2177c5cf84eb$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $745f2177c5cf84eb$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $745f2177c5cf84eb$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $745f2177c5cf84eb$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $745f2177c5cf84eb$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $745f2177c5cf84eb$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $745f2177c5cf84eb$export$53b83ca8eaab0383(val);
}
function $745f2177c5cf84eb$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $745f2177c5cf84eb$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $745f2177c5cf84eb$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $745f2177c5cf84eb$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $745f2177c5cf84eb$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$745f2177c5cf84eb$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $745f2177c5cf84eb$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $745f2177c5cf84eb$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $745f2177c5cf84eb$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $745f2177c5cf84eb$export$36c1185aeee5b0a6(options);
    };
}
function $745f2177c5cf84eb$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $745f2177c5cf84eb$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($745f2177c5cf84eb$var$isBoolean(thunk)) middlewareArray.push((0, $1ab49e43fd6bbe7b$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $1ab49e43fd6bbe7b$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $745f2177c5cf84eb$var$IS_PRODUCTION = true;
function $745f2177c5cf84eb$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $745f2177c5cf84eb$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($745f2177c5cf84eb$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $71488736b7fc99c4$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$745f2177c5cf84eb$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$745f2177c5cf84eb$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $71488736b7fc99c4$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $71488736b7fc99c4$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $745f2177c5cf84eb$var$composeWithDevTools($745f2177c5cf84eb$var$__spreadValues({
        trace: !$745f2177c5cf84eb$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var storeEnhancers = [
        middlewareEnhancer
    ];
    if (Array.isArray(enhancers)) storeEnhancers = $745f2177c5cf84eb$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(storeEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $71488736b7fc99c4$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $745f2177c5cf84eb$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $745f2177c5cf84eb$var$isFSA(action) {
    return $745f2177c5cf84eb$export$53b83ca8eaab0383(action) && typeof action.type === "string" && Object.keys(action).every($745f2177c5cf84eb$var$isValidKey);
}
function $745f2177c5cf84eb$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $745f2177c5cf84eb$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $745f2177c5cf84eb$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $745f2177c5cf84eb$var$isStateFunction(x) {
    return typeof x === "function";
}
var $745f2177c5cf84eb$var$hasWarnedAboutObjectNotation = false;
function $745f2177c5cf84eb$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $745f2177c5cf84eb$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($745f2177c5cf84eb$var$isStateFunction(initialState)) getInitialState = function() {
        return $745f2177c5cf84eb$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $745f2177c5cf84eb$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $745f2177c5cf84eb$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $9GPfD.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $9GPfD.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $9GPfD.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $745f2177c5cf84eb$var$hasWarnedAboutObjectNotation2 = false;
function $745f2177c5cf84eb$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $745f2177c5cf84eb$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $4ZL0H;
    var initialState = typeof options.initialState == "function" ? options.initialState : $745f2177c5cf84eb$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $745f2177c5cf84eb$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $745f2177c5cf84eb$export$309c7a02b0b0bc62(type, prepareCallback) : $745f2177c5cf84eb$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $745f2177c5cf84eb$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $745f2177c5cf84eb$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $745f2177c5cf84eb$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $745f2177c5cf84eb$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($745f2177c5cf84eb$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $745f2177c5cf84eb$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $745f2177c5cf84eb$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $745f2177c5cf84eb$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $745f2177c5cf84eb$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $745f2177c5cf84eb$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $745f2177c5cf84eb$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $745f2177c5cf84eb$var$createSingleArgumentStateOperator(mutator) {
    var operator = $745f2177c5cf84eb$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $745f2177c5cf84eb$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $745f2177c5cf84eb$var$isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $9GPfD.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $9GPfD.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $745f2177c5cf84eb$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $745f2177c5cf84eb$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $745f2177c5cf84eb$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $745f2177c5cf84eb$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $745f2177c5cf84eb$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $745f2177c5cf84eb$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $745f2177c5cf84eb$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $745f2177c5cf84eb$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $745f2177c5cf84eb$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $745f2177c5cf84eb$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $745f2177c5cf84eb$var$createStateOperator(addOneMutably),
        addMany: $745f2177c5cf84eb$var$createStateOperator(addManyMutably),
        setOne: $745f2177c5cf84eb$var$createStateOperator(setOneMutably),
        setMany: $745f2177c5cf84eb$var$createStateOperator(setManyMutably),
        setAll: $745f2177c5cf84eb$var$createStateOperator(setAllMutably),
        updateOne: $745f2177c5cf84eb$var$createStateOperator(updateOneMutably),
        updateMany: $745f2177c5cf84eb$var$createStateOperator(updateManyMutably),
        upsertOne: $745f2177c5cf84eb$var$createStateOperator(upsertOneMutably),
        upsertMany: $745f2177c5cf84eb$var$createStateOperator(upsertManyMutably),
        removeOne: $745f2177c5cf84eb$var$createStateOperator(removeOneMutably),
        removeMany: $745f2177c5cf84eb$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $745f2177c5cf84eb$var$createSortedStateAdapter(selectId, sort) {
    var _c = $745f2177c5cf84eb$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($745f2177c5cf84eb$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $745f2177c5cf84eb$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $745f2177c5cf84eb$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $745f2177c5cf84eb$var$createStateOperator(addOneMutably),
        updateOne: $745f2177c5cf84eb$var$createStateOperator(updateOneMutably),
        upsertOne: $745f2177c5cf84eb$var$createStateOperator(upsertOneMutably),
        setOne: $745f2177c5cf84eb$var$createStateOperator(setOneMutably),
        setMany: $745f2177c5cf84eb$var$createStateOperator(setManyMutably),
        setAll: $745f2177c5cf84eb$var$createStateOperator(setAllMutably),
        addMany: $745f2177c5cf84eb$var$createStateOperator(addManyMutably),
        updateMany: $745f2177c5cf84eb$var$createStateOperator(updateManyMutably),
        upsertMany: $745f2177c5cf84eb$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $745f2177c5cf84eb$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $745f2177c5cf84eb$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $745f2177c5cf84eb$var$createInitialStateFactory();
    var selectorsFactory = $745f2177c5cf84eb$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $745f2177c5cf84eb$var$createSortedStateAdapter(selectId, sortComparer) : $745f2177c5cf84eb$var$createUnsortedStateAdapter(selectId);
    return $745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues($745f2177c5cf84eb$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $745f2177c5cf84eb$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $745f2177c5cf84eb$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $745f2177c5cf84eb$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $745f2177c5cf84eb$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $745f2177c5cf84eb$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $745f2177c5cf84eb$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $745f2177c5cf84eb$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $745f2177c5cf84eb$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $745f2177c5cf84eb$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $745f2177c5cf84eb$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $745f2177c5cf84eb$var$__spreadProps($745f2177c5cf84eb$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $745f2177c5cf84eb$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $745f2177c5cf84eb$var$__spreadProps($745f2177c5cf84eb$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $745f2177c5cf84eb$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $745f2177c5cf84eb$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $745f2177c5cf84eb$var$__spreadProps($745f2177c5cf84eb$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $745f2177c5cf84eb$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $745f2177c5cf84eb$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$745f2177c5cf84eb$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $745f2177c5cf84eb$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $745f2177c5cf84eb$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $745f2177c5cf84eb$var$RejectWithValue) throw result;
                                                if (result instanceof $745f2177c5cf84eb$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $745f2177c5cf84eb$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($745f2177c5cf84eb$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $745f2177c5cf84eb$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $745f2177c5cf84eb$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $745f2177c5cf84eb$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $745f2177c5cf84eb$var$matches = function(matcher, action) {
    if ($745f2177c5cf84eb$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $745f2177c5cf84eb$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $745f2177c5cf84eb$var$matches(matcher, action);
        });
    };
}
function $745f2177c5cf84eb$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $745f2177c5cf84eb$var$matches(matcher, action);
        });
    };
}
function $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $745f2177c5cf84eb$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $745f2177c5cf84eb$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $745f2177c5cf84eb$export$9dd1fb32974da385($745f2177c5cf84eb$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $745f2177c5cf84eb$export$9dd1fb32974da385($745f2177c5cf84eb$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $745f2177c5cf84eb$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $745f2177c5cf84eb$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$745f2177c5cf84eb$var$isAsyncThunkArray(asyncThunks)) return $745f2177c5cf84eb$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $745f2177c5cf84eb$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $745f2177c5cf84eb$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $745f2177c5cf84eb$var$noop = function() {};
var $745f2177c5cf84eb$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $745f2177c5cf84eb$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $745f2177c5cf84eb$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $745f2177c5cf84eb$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $745f2177c5cf84eb$var$task = "task";
var $745f2177c5cf84eb$var$listener = "listener";
var $745f2177c5cf84eb$var$completed = "completed";
var $745f2177c5cf84eb$var$cancelled = "cancelled";
var $745f2177c5cf84eb$var$taskCancelled = "task-" + $745f2177c5cf84eb$var$cancelled;
var $745f2177c5cf84eb$var$taskCompleted = "task-" + $745f2177c5cf84eb$var$completed;
var $745f2177c5cf84eb$var$listenerCancelled = $745f2177c5cf84eb$var$listener + "-" + $745f2177c5cf84eb$var$cancelled;
var $745f2177c5cf84eb$var$listenerCompleted = $745f2177c5cf84eb$var$listener + "-" + $745f2177c5cf84eb$var$completed;
var $745f2177c5cf84eb$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $745f2177c5cf84eb$var$task + " " + $745f2177c5cf84eb$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $745f2177c5cf84eb$var$validateActive = function(signal) {
    if (signal.aborted) throw new $745f2177c5cf84eb$export$cb1bdac908fed7f(signal.reason);
};
function $745f2177c5cf84eb$var$raceWithSignal(signal, promise2) {
    var cleanup = $745f2177c5cf84eb$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $745f2177c5cf84eb$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $745f2177c5cf84eb$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $745f2177c5cf84eb$var$noop;
    });
}
var $745f2177c5cf84eb$var$runTask = function(task2, cleanUp) {
    return $745f2177c5cf84eb$var$__async(void 0, null, function() {
        var value, error_1;
        return $745f2177c5cf84eb$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $745f2177c5cf84eb$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $745f2177c5cf84eb$var$createPause = function(signal) {
    return function(promise2) {
        return $745f2177c5cf84eb$var$catchRejection($745f2177c5cf84eb$var$raceWithSignal(signal, promise2).then(function(output) {
            $745f2177c5cf84eb$var$validateActive(signal);
            return output;
        }));
    };
};
var $745f2177c5cf84eb$var$createDelay = function(signal) {
    var pause = $745f2177c5cf84eb$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $745f2177c5cf84eb$var$assign = Object.assign;
var $745f2177c5cf84eb$var$INTERNAL_NIL_TOKEN = {};
var $745f2177c5cf84eb$var$alm = "listenerMiddleware";
var $745f2177c5cf84eb$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $745f2177c5cf84eb$var$addAbortSignalListener(parentAbortSignal, function() {
            return $745f2177c5cf84eb$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $745f2177c5cf84eb$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $745f2177c5cf84eb$var$runTask(function() {
            return $745f2177c5cf84eb$var$__async(void 0, null, function() {
                var result2;
                return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $745f2177c5cf84eb$var$validateActive(parentAbortSignal);
                            $745f2177c5cf84eb$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $745f2177c5cf84eb$var$createPause(childAbortController.signal),
                                    delay: $745f2177c5cf84eb$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $745f2177c5cf84eb$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $745f2177c5cf84eb$var$abortControllerWithReason(childAbortController, $745f2177c5cf84eb$var$taskCompleted);
        });
        return {
            result: $745f2177c5cf84eb$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $745f2177c5cf84eb$var$abortControllerWithReason(childAbortController, $745f2177c5cf84eb$var$taskCancelled);
            }
        };
    };
};
var $745f2177c5cf84eb$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $745f2177c5cf84eb$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $745f2177c5cf84eb$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $745f2177c5cf84eb$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $745f2177c5cf84eb$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $745f2177c5cf84eb$var$catchRejection(take(predicate, timeout));
    };
};
var $745f2177c5cf84eb$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $745f2177c5cf84eb$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $745f2177c5cf84eb$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $745f2177c5cf84eb$var$createListenerEntry = function(options) {
    var _c = $745f2177c5cf84eb$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $745f2177c5cf84eb$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $745f2177c5cf84eb$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $745f2177c5cf84eb$var$abortControllerWithReason(controller, $745f2177c5cf84eb$var$listenerCancelled);
    });
};
var $745f2177c5cf84eb$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($745f2177c5cf84eb$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $745f2177c5cf84eb$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $745f2177c5cf84eb$export$f03a6b845d3fb58b = $745f2177c5cf84eb$export$309c7a02b0b0bc62($745f2177c5cf84eb$var$alm + "/add");
var $745f2177c5cf84eb$export$b1b8022855fb2b71 = $745f2177c5cf84eb$export$309c7a02b0b0bc62($745f2177c5cf84eb$var$alm + "/removeAll");
var $745f2177c5cf84eb$export$b03e9483f936dccb = $745f2177c5cf84eb$export$309c7a02b0b0bc62($745f2177c5cf84eb$var$alm + "/remove");
var $745f2177c5cf84eb$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $745f2177c5cf84eb$var$__spreadArray([
        $745f2177c5cf84eb$var$alm + "/error"
    ], args));
};
function $745f2177c5cf84eb$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $745f2177c5cf84eb$var$defaultErrorHandler : _c;
    $745f2177c5cf84eb$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $745f2177c5cf84eb$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $745f2177c5cf84eb$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $745f2177c5cf84eb$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $745f2177c5cf84eb$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $745f2177c5cf84eb$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $745f2177c5cf84eb$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $745f2177c5cf84eb$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $745f2177c5cf84eb$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $745f2177c5cf84eb$var$createDelay(internalTaskController.signal),
                                pause: $745f2177c5cf84eb$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $745f2177c5cf84eb$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $745f2177c5cf84eb$var$abortControllerWithReason(controller, $745f2177c5cf84eb$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $745f2177c5cf84eb$export$cb1bdac908fed7f)) $745f2177c5cf84eb$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $745f2177c5cf84eb$var$abortControllerWithReason(internalTaskController, $745f2177c5cf84eb$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $745f2177c5cf84eb$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if ($745f2177c5cf84eb$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($745f2177c5cf84eb$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($745f2177c5cf84eb$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $745f2177c5cf84eb$var$INTERNAL_NIL_TOKEN) throw new Error($745f2177c5cf84eb$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $745f2177c5cf84eb$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $745f2177c5cf84eb$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $745f2177c5cf84eb$export$8fb31c0f05df007b = "RTK_autoBatch";
var $745f2177c5cf84eb$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$745f2177c5cf84eb$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $745f2177c5cf84eb$var$promise;
var $745f2177c5cf84eb$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($745f2177c5cf84eb$var$promise || ($745f2177c5cf84eb$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $745f2177c5cf84eb$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $745f2177c5cf84eb$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $745f2177c5cf84eb$var$createQueueWithTimer(10);
var $745f2177c5cf84eb$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $745f2177c5cf84eb$var$queueMicrotaskShim : options.type === "raf" ? $745f2177c5cf84eb$var$rAF : options.type === "callback" ? options.queueNotification : $745f2177c5cf84eb$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$745f2177c5cf84eb$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $9GPfD.enableES5)();



const $4d30dd5a74852208$var$emptyConsent = {
    essential: null,
    analytics: null,
    externalMedia: null
};
function $4d30dd5a74852208$var$getConsent() {
    const consent = localStorage.getItem("consent");
    if (consent) return JSON.parse(consent);
    return $4d30dd5a74852208$var$emptyConsent;
}
function $4d30dd5a74852208$var$createInitialState() {
    return {
        isLoggedIn: null,
        authInProgress: false,
        authStatus: null,
        mobileAppMode: false,
        profile: {
            attributes: null,
            settings: null
        },
        tourLock: null,
        payment: {
            status: "idle"
        },
        consent: $4d30dd5a74852208$var$getConsent(),
        rehydrationStatus: "notStarted"
    };
}
const $4d30dd5a74852208$var$initialState = $4d30dd5a74852208$var$createInitialState();
const $4d30dd5a74852208$var$userSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "user",
    initialState: $4d30dd5a74852208$var$initialState,
    reducers: {
        setAuthProgress (state) {
            state.authInProgress = true;
            state.authStatus = "inProgress";
        },
        setAuthFailed (state) {
            state.authInProgress = false;
            state.authStatus = "failed";
        },
        setAuthSuccess (state) {
            state.authInProgress = false;
            state.authStatus = "success";
        },
        setAuthInProgress (state, action) {
            var _action_payload;
            const nextValue = (_action_payload = action.payload) !== null && _action_payload !== void 0 ? _action_payload : true;
            state.authInProgress = Boolean(nextValue);
            state.authStatus = state.authInProgress ? "inProgress" : "idle";
        },
        setRehydrationStatus (state, action) {
            state.rehydrationStatus = action.payload;
        },
        setSettingsCurrent (state, action) {
            const nextCurrent = Number(action.payload);
            if (!Number.isFinite(nextCurrent)) return;
            if (!state.profile) state.profile = {
                attributes: null,
                settings: {}
            };
            if (!state.profile.settings) state.profile.settings = {};
            state.profile.settings.current = nextCurrent;
        },
        hydrate (state, action) {
            return (0, $9tqwB._)({}, state, action.payload);
        },
        clear (state) {
            const consent = state.consent ? (0, $9tqwB._)({}, state.consent) : $4d30dd5a74852208$var$getConsent();
            return (0, $2qxEV._)((0, $9tqwB._)({}, $4d30dd5a74852208$var$createInitialState()), {
                isLoggedIn: false,
                consent: consent
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $0840a3787500c813$export$f91e818b28421958), (state, action)=>{
            state.isLoggedIn = false;
            state.registration = action.payload;
            state.authInProgress = false;
            state.authStatus = "success";
        }).addCase((0, $0840a3787500c813$export$b885672bc5665ae2), (state)=>{
            state.isLoggedIn = false;
            state.authInProgress = false;
            state.authStatus = "failed";
        }).addCase((0, $0840a3787500c813$export$b25da9cb1df1f7ca), (state, action)=>{
            var _action_payload;
            state.registration = (0, $2qxEV._)((0, $9tqwB._)({}, state.registration || {}), {
                status: (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.status
            });
            state.authInProgress = false;
            state.authStatus = "success";
        }).addCase((0, $0840a3787500c813$export$7c504496b873f4fe), (state)=>{
            state.registration = (0, $2qxEV._)((0, $9tqwB._)({}, state.registration || {}), {
                status: "error"
            });
            state.authInProgress = false;
            state.authStatus = "failed";
        }).addCase((0, $0840a3787500c813$export$5223a5682801fa43), (state, action)=>{
            const { payload: payload } = action;
            state.isLoggedIn = true;
            var _payload_toursSeen;
            state.profile.attributes = {
                toursSeen: (_payload_toursSeen = payload === null || payload === void 0 ? void 0 : payload.toursSeen) !== null && _payload_toursSeen !== void 0 ? _payload_toursSeen : null
            };
            state.profile.settings = (0, $9tqwB._)({}, state.profile.settings || {}, (payload === null || payload === void 0 ? void 0 : payload.settings) || {});
            state.registration = {};
            state.sub = payload === null || payload === void 0 ? void 0 : payload.sub;
            state.authInProgress = false;
            state.authStatus = "success";
        }).addCase((0, $0840a3787500c813$export$d2473a15d627f3f1), (state)=>{
            state.isLoggedIn = false;
            state.profile = {
                attributes: null,
                settings: null
            };
            state.authInProgress = false;
            state.authStatus = "failed";
        }).addCase((0, $0840a3787500c813$export$35e541d26a145a7c), (state)=>{
            const consent = state.consent ? (0, $9tqwB._)({}, state.consent) : $4d30dd5a74852208$var$getConsent();
            const resetState = $4d30dd5a74852208$var$createInitialState();
            resetState.isLoggedIn = false;
            resetState.consent = consent;
            resetState.authInProgress = false;
            resetState.authStatus = "idle";
            return resetState;
        }).addCase((0, $0840a3787500c813$export$a999df3591da561), (state)=>{
            state.mobileAppMode = true;
        }).addCase((0, $0840a3787500c813$export$68513b67d94d64cf), (state, action)=>{
            var _action_payload, _action_payload1;
            state.profile.settings = (0, $9tqwB._)({}, state.profile.settings || {}, ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.settings) || {});
            state.profile.attributes = (0, $9tqwB._)({}, state.profile.attributes || {}, ((_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.attributes) || {});
        }).addCase((0, $0840a3787500c813$export$b3ea9843eae6e10b), ()=>{}).addCase((0, $0840a3787500c813$export$145d071b2cefcb66), (state, action)=>{
            state.profile.attributes = (0, $2qxEV._)((0, $9tqwB._)({}, state.profile.attributes || {}), {
                toursSeen: action.payload
            });
        }).addCase((0, $0840a3787500c813$export$9da28f1f0b10ca02), ()=>{}).addCase((0, $0840a3787500c813$export$e36d99af0a9f9ab7), (state)=>{
            state.tourLock = true;
        }).addCase((0, $0840a3787500c813$export$4c021acc9734bf10), (state)=>{
            state.tourLock = null;
        }).addCase((0, $0840a3787500c813$export$20ab86c37788ea12), (state)=>{
            state.payment.status = "error";
        }).addCase((0, $0840a3787500c813$export$bf63969c69f30522), (state, action)=>{
            state.consent = (0, $9tqwB._)({}, action.payload || {});
        }).addCase("viewer/getSharedReport/fulfilled", (state, action)=>{
            var _action_payload_user, _action_payload;
            if ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_user = _action_payload.user) === null || _action_payload_user === void 0 ? void 0 : _action_payload_user.profile) state.profile = action.payload.user.profile;
        }).addCase("SET_REHYDRATION_STATUS", (state, action)=>{
            state.rehydrationStatus = action.payload;
        });
    }
});
const { setAuthFailed: $4d30dd5a74852208$export$506e5ce4d828c47f, setAuthProgress: $4d30dd5a74852208$export$d9065efc0def3925, setAuthSuccess: $4d30dd5a74852208$export$20c07c6c70cd2bd3, setAuthInProgress: $4d30dd5a74852208$export$91d9d852dd5e31b0, setRehydrationStatus: $4d30dd5a74852208$export$b38a2c36e1f197c1, setSettingsCurrent: $4d30dd5a74852208$export$7a72443d10d90c17, hydrate: $4d30dd5a74852208$export$fa8d919ba61d84db, clear: $4d30dd5a74852208$export$42ffd38884aecdac } = $4d30dd5a74852208$var$userSlice.actions;
var $4d30dd5a74852208$export$2e2bcd8739ae039 = $4d30dd5a74852208$var$userSlice.reducer;



var $41426fe6dfa29819$exports = {};
!function(t, i) {
    $41426fe6dfa29819$exports = i();
}($41426fe6dfa29819$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
// named baselines for project mode are defined in globalBaselineView
const $35849f14f39a3bea$var$namedBaselines = {
    sameTimeLastYear: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().subtract(1, "year").startOf("day").valueOf(),
    currentYearBegin: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("year").startOf("day").valueOf(),
    previousYearBegin: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().subtract(1, "year").startOf("year").startOf("day").valueOf()
};
var $35849f14f39a3bea$export$2e2bcd8739ae039 = $35849f14f39a3bea$var$namedBaselines;


/* eslint-disable import/no-import-module-exports */ 
var $2Bwgd = parcelRequire("2Bwgd");

function $dd697eedd6fc9e50$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $21284c8d0a787799$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $21284c8d0a787799$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $21284c8d0a787799$export$2e2bcd8739ae039(obj);
}



function $cbfb381a5d149492$export$2e2bcd8739ae039(input, hint) {
    if ((0, $21284c8d0a787799$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $21284c8d0a787799$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $7e0640a47890af76$export$2e2bcd8739ae039(arg) {
    var key = (0, $cbfb381a5d149492$export$2e2bcd8739ae039)(arg, "string");
    return (0, $21284c8d0a787799$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $e9f5db8ef2f6bb5d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $7e0640a47890af76$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $e9f5db8ef2f6bb5d$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $e9f5db8ef2f6bb5d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e9f5db8ef2f6bb5d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


var $f73f86de2138df56$var$arr = [];
var $f73f86de2138df56$var$each = $f73f86de2138df56$var$arr.forEach;
var $f73f86de2138df56$var$slice = $f73f86de2138df56$var$arr.slice;
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$each.call($f73f86de2138df56$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $f73f86de2138df56$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $f73f86de2138df56$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $f73f86de2138df56$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $f73f86de2138df56$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hasLocalStorageSupport = null;
var $f73f86de2138df56$var$localStorageAvailable = function localStorageAvailable() {
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $f73f86de2138df56$var$hasSessionStorageSupport = null;
var $f73f86de2138df56$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $f73f86de2138df56$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ]
    };
}
var $f73f86de2138df56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $dd697eedd6fc9e50$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $e9f5db8ef2f6bb5d$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults());
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($f73f86de2138df56$var$cookie$1);
                this.addDetector($f73f86de2138df56$var$querystring);
                this.addDetector($f73f86de2138df56$var$localStorage);
                this.addDetector($f73f86de2138df56$var$sessionStorage);
                this.addDetector($f73f86de2138df56$var$navigator$1);
                this.addDetector($f73f86de2138df56$var$htmlTag);
                this.addDetector($f73f86de2138df56$var$path);
                this.addDetector($f73f86de2138df56$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$f73f86de2138df56$export$2e2bcd8739ae039.type = "languageDetector";


var $8441b779c9adedd6$exports = {};
$8441b779c9adedd6$exports = JSON.parse('{"general":{"findoutmore":"Mehr erfahren","getdemo":"Demo","startDemo":"Demo ausprobieren","search":"Suche","noResultsFound":"Keine Ergebnisse gefunden","freetrial":"Kostenlosen Test starten","howdowedoit":"Wie funktioniert das?","language":"Sprache","english":"Englisch","german":"Deutsch","country":"Land","germany":"Deutschland","send":"Schicken","ok":"OK","error":"Fehler","yes":"Ja","no":"Nein","success":"Erfolgreich","submit":"Speichern","continue":"Fortsetzen","cancel":"Abbrechen","next":"Weiter","back":"Zur\xfcck","subscribe":{"header":"Erhalte unseren Newsletter","body":"Neuigkeiten, Produkt-Updates und hilfreiche Tipps, in deiner Mailbox alle 2 Monate.","emailprompt":"Email-Adresse","button":"Anmelden"},"step":"Schritt","stepOf":"von","findOutMore":"Mehr herausfinden","synchronising":"Synchronisiere Daten"},"login":{"invalidUsernameOrPassword":"Benutzername oder Passwort ung\xfcltig","userNotConfirmed":"Benutzer nicht best\xe4tigt. Setze dich mit dem Support-Team in Verbindung: support@monestry.de","passwordResetRequired":"Dein Passwort muss zur\xfcckgesetzt werden, bitte nutze \'Passwort vergessen?\'-Link unten.","incorrectConfirmationCode":"Der eingegebene Best\xe4tigungscode ist leider falsch. Bitte versuche es erneut.","unknownUser":"Wir konnten einen Benutzer mit der uns von dem gew\xe4hlten externen Provider genannten Email leider nicht finden.","signInIntoYourAccount":"Anmeldung","signInWith":"Anmelden mit","enterConfirmationCode":"Authorisierungscode eingeben (aus der 2FA-App)","enterConfirmationCodeEmail":{"tip":"Wir haben dir ein Sicherheitscode per Email geschickt. Bitte trage es hier ein.","label":"Sicherheitscode","error":"Der Code muss genau 6 Zeichen lang sein."},"orContinueWith":"oder weiter mit","emailOrUsername":"Email oder Benutzername","password":"Passwort","rememberMe":"Angemeldet bleiben","forgotPassword":"Password vergessen?","signIn":"Anmelden","fieldRequired":"Dieses Feld ist erforderlich.","passwordRecovery":"Passwort zur\xfccksetzen","unableToResetPassword":"Passwort konnte nicht zur\xfcckgesetzt werden. Versuche bitte sp\xe4ter noch einmal.","enterNewPassword":"Neues Passwort eingeben","tooManyRequests":"Um deine Daten zu sch\xfctzen, ist es in den n\xe4chsten 15 Minuten nicht mehr m\xf6glich, den Passwort wieder zu \xe4ndern. Wir haben zu viele solche Anfragen erhalten."},"menu":{"features":"Features","anonymous":"Anonyme Nutzung","data":"Datenquellen","blog":"Blog","meet":"\xdcber Monestry","pricing":"Preise","demo":"Demo","dashboard":"Dashboard","login":"Anmelden","logout":"Ausloggen","register":"Registrieren","product":"Produkt","support":"Unterst\xfctzung","guide":"Handbuch","howto":"Anweisungen","contact":"Kontakt","company":"Unternehmen","about":"\xdcber uns","jobs":"Karriere","press":"Presse","partners":"Partner","legal":"Rechtliches","impressum":"Impressum","privacy":"Vertraulichkeit","agb":"AGB"},"main":{"cta":{"line-1":"Arbeitet dein Geld","line-2":"so hart wie du?","body-1":"Treffe die richtigen Entscheidungen mit Monestry - dem unabh\xe4ngigen Finanzplanner deines Vertrauens.","body-2":"Ein wirklich vollst\xe4ndiges Bild deiner Finanzen: R\xfcckblick, Gegenwart, Zukunft. Automatische Updates von mehr als 6.000 Finanzinstituten weltweit."},"partners":"Unsere vertrauten Partner","convenience":{"header":"Komfort","title":"Wir machen dein Leben einfacher","subtitle":"Monestry ist ins Leben gerufen worden, um Aufwand und Komplexit\xe4t aus Verwaltung von pers\xf6nlichen Finanzen herauszunehmen."},"complete":{"title":"Ein wirklich vollst\xe4ndiges Bild","body":"Wir wissen, dass dein Verm\xf6gen mehr als nur Bankkonten und Aktien umfasst. Wir machen es m\xf6glich, zahlreiche weitere Anlagekategorien zu pflegen: von Immobilien \xfcber Kryptow\xe4hrungen und Edelmetalle bis Wertobjekte und private Beteiligunen.","sub1":{"title":"Immobilien","body":"Wohnungen und H\xe4user, selbstgenutzt oder vermietet, stellen oft einen erheblichen Teil privates Verm\xf6gens dar. Mit Monestry kann der Wert dieser Investments einfach getrackt werden."},"sub2":{"title":"Rentenversicherungen","body":"Ein vollst\xe4ndiges Blick privater Finanzen muss auch Rentenversicherungen erfassen, die eine bedeutende Rolle in Absicherung der Rentensituation spielen k\xf6nnen."}},"current":{"title":"Marktwert auf Knopfdruck","body":"Eine Liste aller Verm\xf6gensposten mit ihrem heutigen Wert zu erstellen ist nur ein Teil der Aufgabe. Morgen haben viele dieser Posten n\xe4mlich einen anderen Wert. Und \xfcbermorgen - noch einen anderen. Monestry stellt sicher, dass alle aktualisierbaren Anlageklassen auf dem letzten Stand bleiben.","sub1":{"title":"Aktien, W\xe4hrungen und Edelmetalle","body":"Wir aktualisieren die Kurse aller Aktien, W\xe4hrungen und Kryptow\xe4hrungen sowie Marktpreise der Edelmetalle in deinem Bestand."},"sub2":{"title":"Aktueller Marktwert deiner Immobilien","body":"Monestry schickt dir kostenlos alle 6 Monate einen aktualisierten Marktwert aller deiner Immobilienobjekte. Wir nutzen die gleichen Datenquellen, wie die gro\xdfen Kreditinstitute der Republik.","link":"Wie funktioniert das?"}},"security":{"header":"Letzter Stand der Technologie","title":"Ihre Daten werden mit neusten Sicherheitsl\xf6sungen gesch\xfctzt","body":"Wir nutzen moderne Verschl\xfcsselung- und Sicherheitstechnologien, um die Nutzerdaten und unsere Systeme zu sch\xfctzen. Die Nutzer d\xfcrfen anonym bleiben, und die Daten sind von den Nutzerinformationen strikt getrennt."},"simple":{"title":"Blick in die Zukunft","body":"Was w\xe4re, wenn du in die Zukunft blicken k\xf6nntest? Wir k\xf6nnen zwar keine genauen Vorhersagen machen, aber vielleicht k\xf6nnen wir doch helfen. Nutze unsere Simulationen und Projekte, um zu sehen, wie dein Verm\xf6gen in 10, 20 oder 40 Jahren aussehen k\xf6nnte.","link":"Wie funktioniert das?","quote":"\\"Es ist unglaublich beruhigend zu sehen, wie meine Investitionen im Laufe der Zeit wachsen k\xf6nnten. Dieses Tool hat mir wirklich geholfen, mehr Vertrauen in meine langfristige Finanzstrategie zu haben.\\"","name":"Anna - Frankfurt am Main, Deutschland"},"simpleOLD":{"title":"Einfachheit als Ziel","body":"Leben und Arbeiten in moderner Zeite sind sehr komplex, weshalb wir es zu unserem vorr\xe4ngigen Ziel erkl\xe4rt haben, Monestry einfach in der Handhabung zu gestalten. Wir eliminieren die unwesentlichen Aspekte des Verm\xf6genmanagements und passen Produktvorlagen dem deutschen Markt an.","link":"Verf\xfcgbare Produkte","quote":"Cras velit quis eros eget rhoncus lacus ultrices sed diam. Sit orci risus aenean curabitur donec aliquet. Mi venenatis in euismod ut.","name":"Jane - Frankfurt am Main, Deutschland"},"saving":{"title":"Spare deine Zeit","body":"Es gibt besseres zu tun, als vor einem Spreadsheet zu sitzen und stundenlang Spalten von Zahlen manuell zu integrieren, selbst wenn es um eigenes Verm\xf6gen geht. Wir k\xfcmmern uns um das Manuelle, sodass du dich auf das Wesentliche konzentrieren kannst: die richtigen Entscheidungen f\xfcr die Zukunft zu treffen!","link":"Mehr erfahren","quote":"\\"Ich verschwende keine Zeit mehr mit Excel. Sie k\xfcmmern sich um all die Aktualisierunge, sodass ich einfach gute Entscheidungen f\xfcr meine Zukunft treffen kann. Es ist viel einfacher und spart mir eine Menge Zeit\\"","name":"Peter - Bad Homburg, Deutschland"}},"feedback":{"title":"Dein Feedback","problem":"Problem","idea":"Idee","question":"Frage","header":"Deine Mitteilung an uns:","email":"Ich m\xf6chte per Email kontaktiert werden, sobald meine Anfrage bearbeitet wird.","completed":{"success":"Vielen Dank f\xfcr deine Nachricht. Falls eine erneute Anfrage dazu n\xf6tig ist, gebe bitte die folgende Referenz an: ","failure":"Es tut uns leid, es ist momentan nicht m\xf6glich, deine Anfrage zu \xfcbermitteln. Unser Team wurde \xfcber dieses Problem informiert. Versuche bitte zu einem sp\xe4teren Zeitpunkt wieder."},"beingUploaded":"Dein Feedback wird \xfcbermittelt. Bitte warten.","uploadAttachment":"Anhang hochladen","uploadSizeLimit":"Maximale Gr\xf6\xdfe: 5MB"},"dashboard":{"accounts_header":"Deine Verm\xf6genswerte"},"page-not-found":{"header":"Es tut uns leid","title":"Diese Seite existiert nicht","body":"Folge bitte die Men\xfc-Links, um in weitere Bereiche zu gelangen.","link":"Zur\xfcck","homePage":"Startseite"},"blog":{"title":"Aus unserem Blog","subtitle":"St\xf6bere durch die Artikel und finde Tipps, wie man Monestry besser nutzen kann, unsere selbstbewussten Beitr\xe4ge zu diversen finanziellen Themen sowie Ank\xfcndigungen neuer Produktmerkmale.","filter-header":"Nach Kategorien filtern:","categories":{"blog":{"filter-title":"Alle","title":"Aus unserem Blog","subtitle":"St\xf6bere durch die Artikel und finde Tipps, wie man Monestry besser nutzen kann, unsere selbstbewussten Beitr\xe4ge zu diversen finanziellen Themen sowie Ank\xfcndigungen neuer Produktmerkmale."},"guide":{"title":"Product guide","subtitle":"Diese Artikel beschreiben alle Produktfeatures im Detail und geben Tipps, wie sie am besten genutzt werden k\xf6nnen."},"new-features":{"title":"Produkt-Ank\xfcndigungen","subtitle":"Bei Monestry entwickeln wir unser Produkt st\xe4ndig weiter, um die Verwaltung deiner Finanzen zu erleichtern. Hier findest du Ank\xfcndigungen neuer Features."},"point-of-view":{"title":"Standpunkte","subtitle":"Wir haben eine Meinung dazu, wie private Finanzen verwaltet werden sollten. Hier findest du unsere Gedanken zu diversen finanziellen Themen."},"market-overview":{"title":"Markt\xfcbersicht","subtitle":"Wir behalten den Finanz-App-Markt im Auge. Hier findest du unsere Gedanken zu den neuesten Entwicklungen."}}},"article":{"return-prev-page":"Zur\xfcck zu voriger Seite","written-by":"Verfasst von","published":"Ver\xf6ffentlicht am","updated":"aktualisiert am","related-articles":"Verwandte Beitr\xe4ge","fixed-articles-header":"Verwalte dein Verm\xf6gen einfach mit Monestry","features-title":"Unser Produkt: was k\xf6nnen wir f\xfcr dich tun?","demo-title":"Live demo: probiere es aus - ohne Anmeldung!"},"features":{"section1":{"header":"Deine Finanzen auf dem neuesten Stand","header-accent":"automatisch","body":"Monestry erschafft ein vollst\xe4ndiges Bild aller Verm\xf6genswerte und deren Wertentwicklung. Dadurch machen wir es dir leicht, deine privaten Finanzen im Griff zu halten.","one-glance":{"title":"Ihr gesamtes Verm\xf6gen auf einen Blick","body":"Das Dashboard ist das Herzst\xfcck unserer App. Hier erf\xe4hrts du, wie der aktuelle Stand deiner Finanzen ist und wie sich die einzelnen Verm\xf6genswerte entwickeln. Sein intuitives Design f\xfchrt zu allen anderen Funktionen der App.","quote":"\\"Das Dashboard vereinfacht die Dinge wirklich f\xfcr mich. Es zeigt mir ein klares Bild meiner Finanzen, stand jetzt, und was noch wichtiger ist - was meine Anlagen gebracht haben. Alles an einem Ort.\\"","person":"Lukas - Frankfurt am Main, Deutschland"},"all-classes":{"header":"Alle Anlageklassen verwalten","body":"Mache dir das ganze Ausma\xdf deines Verm\xf6gens bewusst und treffe die richtigen finanziellen Entscheidungen. Es kann wirklich \xfcberraschend sein, wie gro\xdf der Unterschied ist, wenn man ein Gesamtbild hat.","bank":{"header":"Bankkonten","body":"Der Klassiker. Behalte den \xdcberblick \xfcber deine Ersparnisse bei allen Banken."},"stocks":{"header":"Wertpapiere","body":"Ob vom Broker oder vom Arbeitgeber: mit Monestry lassen sich alle Arten von Wertpapieren und Optionen verfolgen."},"real-estate":{"header":"Immobilien","body":"Behalte den Wert deiner Immobilien im Auge, und wenn sie vermietet werden, finde heraus, wie hoch der tats\xe4chlicher Ertrag ist."},"pension":{"header":"Altersvorsorge","body":"\xdcberwache die Entwicklung deiner Altersvorsorge: gesetzliche Renten- sowie Kapitalversicherungen, Riester, R\xfcrup, bAV & Co."},"unlisted":{"header":"Private Unternehmen","body":"Was ist dein Unternehmen eigentlich wert und wie hoch die aktuellen Kapitalrenditen ist? Wir stellen schnelle Wertermittlungstools zu Verf\xfcgung."},"crypto":{"header":"Kryptow\xe4hrung","body":"Eine neue Klasse von Verm\xf6genswerten, die in kurzer Zeit sehr wertvoll werden k\xf6nnen."},"objects":{"header":"Wertgegenst\xe4nde","body":"Edelmetallen, Oldtimer, Uhren, M\xfcnzen und Schmuck k\xf6nnen einen bedeutenden Teil des Verm\xf6gens ausmachen."},"loans":{"header":"Darlehen","body":"Genommen und gegeben, Darlehen k\xf6nnen einen wesentlichen Teil deiner Ihrer finanziellen Situation ausmachen."}}},"section2":{"lead":"Automatische Aktualisierungen","header":"Wissen, was dein Verm\xf6gen wert ist","body":"Wie hoch ist dein Nettowert? Monestry hilft dir dabei, den \xdcberblick zu behalten.","valuation":{"stocks":{"header":"B\xf6rsenkurse","body":"Kurse aller Wertpapiere werden t\xe4glich aktualisiert, damit du genau wei\xdft, wie sich die aktuellen Markttrends dein Verm\xf6gen auswirken."},"unlisted":{"header":"Anteile an privaten Unternehmen","body":"Mit unseren Rechnern l\xe4sst sich der Anteilswert an einem nicht b\xf6rsennotierten Unternehmen leicht sch\xe4tzen, um dir den Umgang mit Partnern, Investoren und Banken zu erleichtern."},"metals":{"header":"Edelmetalle","body":"Wir ermitteln den aktuellen Marktwert und die Spreads f\xfcr die Edelmetalle in deinem Besitz."},"fx":{"header":"W\xe4hrungskurse","body":"Erinnerst du dich noch an 1\u20AC f\xfcr 0,85$ im Jahr 2000? Und an 1\u20AC f\xfcr 1,46$ nur acht Jahre sp\xe4ter? W\xe4hrungsschwankungen k\xf6nnen den Wert deines Verm\xf6gens erheblich ver\xe4ndern. Monestry h\xe4lt es auf dem neuesten Stand."},"real-estate":{"header":"Immobilien","body":"Beim Start und danach alle 6 Monate schicken wir dir den aktuellen Marktwert deiner Immobilien zu, der sich aus der Analyse von mehr als 200.000 aktuellen Verkaufstransaktionen in Deutschland ergibt."}}},"section3":{"goals":{"body":"Wann kannst du endlich in den Ruhestand gehen? Solltest du dein Traumferienhaus aus den Gewinnen Ihres Aktienportfolios finanzieren oder ben\xf6tigst du daf\xfcr einen Kredit? Beantworte diese und andere Fragen mit Hilfe von \\"Ziele und Simulationen\\".","header":"Ziele und Simulationen erstellen","set":{"header":"Finanzielle Ziele setzen","body":"Lege fest, wie viel Geld zur Finanzierung k\xfcnftiger Projekte ben\xf6tigt wird, und plane, von welchen Konten das Geld kommen soll."},"simulate":{"header":"K\xfcnftiges Wachstum simulieren","body":"Wie entwickelt sich dein Verm\xf6gen unter gewissen Annahmen und wieviel ist es zu verschiedenen Zeitpunkten in der Zukunft wert?"}},"reports":{"body":"Personalis Analysen und Visualisierungen, um mehr Einblick in Ihre Finanzen zu erhalten.","header":"Anpassbare Reports","pivot":{"header":"Pivot-Tabellen","body":"Wenn die voreingestellten Berichte nicht ausreichen, Pivot-Tabelle stehen zu Verf\xfcgung, um genau die Daten aufzubereiten, die du sehen m\xf6chtest."},"charts":{"header":"Diagramme erstellen","body":"Erstelle pr\xe4chtige Diagramme mit der flexiblen Diagrammerstellungs-Engine von Monestry."},"keep-eye":{"header":"Monitoring","body":"Die personalisierten Diagramme k\xf6nnen in dem Dashboard eingebettet werden, um bei jedem Besuch die wichtigsten Informationen zu sehen."}}},"section4":{"sync":{"header":"Verm\xf6genswerte aktuell halten","auto":{"header":"Automatische Synchronisierung","body":"Deine Daten k\xf6nnen automatisch von mehr als 6.000 Finanzinstituten im In- und Ausland synchronisiert werden. Wir arbeiten mit einem f\xfchrenden Finanzdatenanbieter zusammen, der seit mehr als 10 Jahren erfolgreich in diesem Bereich t\xe4tig ist. >>Erfahren Sie mehr.<<"},"edit":{"header":"Daten wie im Spreasheet anpassen","body":"Verwende ein vertrautes Spreadsheet-Stil zur Eingabe und Bearbeitung aller Daten, die manuell aktualisiert werden m\xfcssen."},"uploads":{"header":"Intelligente Uploads","body":"F\xfcr manuelle Uploads analysiert unser einfacher und intuitiver Upload-System die Daten und schl\xe4gt die Zuordnungslogik vor, die einfach per Mausklick angepasst werden kann."},"decide":{"header":"Du entscheidest","body":"Welche Konten automatisch aktualisiert werden sollen und welche mit Dateien aktualisiert ist komplett dir \xfcberlassen. Die Einstellungen k\xf6nnen jederzeit ge\xe4ndert werden."}},"foundations":{"header":"Solide Grundlagen","body":"Keine Experimente. Monestry ist mit bew\xe4hrten, modernen Technologien aufgebaut, wobei der Schwerpunkt auf Datenschutz, Sicherheit und Nachhaltigkeit liegt.","sustain":{"header":"Nachhaltige IT","body":"Keine Leerl\xe4ufe im Serverraum - die IT-Ressourcen von Monestry werden nur dann eingeschaltet, wenn sie genutzt werden."},"anonymous":{"header":"Anonymer Modus","body":"Nutze Monestry, ohne deinen Namen anzugeben. Wir tun alles, um dich und deine Daten zu sch\xfctzen."},"control":{"header":"Volle Kontrolle \xfcber eigene Daten","body":"Wir verpflichten uns, keinen Zugriff zu deinen Daten externen Unternehmen zu gew\xe4hren - wir schreiben das sogar in unseren AGBs. Wir m\xf6chten Geld verdienen, indem wir Mehrwert f\xfcr unsere Nutzer schaffen."},"neutral":{"header":"Neutral","body":"Wir verkaufen keine Finanzprodukte an dich, um von den Provisionen der Verk\xe4ufer zu profitieren."},"security":{"header":"Sicher","body":"\'Alle gespeicherten und \xfcbertragenen Daten sind mit privaten Schl\xfcsseln verschl\xfcsselt und au\xdferhalb von Monestry nicht sichtbar."},"impartial":{"header":"Unabh\xe4ngig","body":"Monestry ist im Privatbesitz und steht somit nicht unter Verkaufsdruck oder Einflu\xdf eines Finanzinstitutes."},"audit":{"header":"Regelm\xe4\xdfige Audits","body":"Wir f\xfchren regelm\xe4\xdfige Sicherheitspr\xfcfungen durch externe Berater durch, um die Sicherheit unserer Systeme zu gew\xe4hrleisten."},"german":{"header":"Made in Germany","body":"Monestry wurde in Frankfurt gegr\xfcndet, wo sich auch alle unsere IT-Systeme befinden."}},"cta":{"header":"Lass dein Geld arbeiten.","header2":"Nutze Monestry ab heute.","subheader":"Ein Monat kostenlos. Keine Kreditkarte erforderlich. Jederzeit k\xfcndbar."}}},"pricing":{"header":"W\xe4hle das richtige Paket","subheader":"Wir glauben nicht an Einheitsgr\xf6\xdfen. Deshalb haben wir vier erschwingliche Pakete geschn\xfcrt, aus denen du w\xe4hlen kannst.","most-popular":"Meistgekauft","annually":"J\xe4hrliche Abrechnung","monthly":"Monatliche Abrechnung","automaticUpdatesDisclaimer1":"* Einige Finanzinstitute erlauben keine automatischen Aktualisierungen. Siehe unsere","automaticUpdatesDisclaimer2":" Liste der unterst\xfctzten Institute.","linkToAutoUpdates":"/de/blog/anleitung/wie-halten-wir-die-daten-aktuell","products":{"frequency":"/Monat","s":{"title":"Monestry S","description":"Einfache, automatische Aktualisierungen deiner Assets.","features":["Bis zu 5 Konten","Automatische Aktualisierungen f\xfcr deutsche Konten*","Automatische Aktualisierung f\xfcr 1 ausl\xe4ndisches Konto*"],"cta":"Paket w\xe4hlen","mostPopular":false},"m":{"title":"Monestry M","description":"\xdcbernimm die Kontrolle \xfcber deine finanzielle Zukunft.","features":["Bis zu 10 Konten","Automatische Aktualisierungen f\xfcr deutsche Konten*","Automatische Aktualisierungen f\xfcr 2 ausl\xe4ndische Konten*","Automatische Bewertungen f\xfcr 1 Immobilie"],"cta":"Paket w\xe4hlen","mostPopular":false},"l":{"title":"Monestry L","description":"Endlich ein guter \xdcberblick \xfcber alle deine Verm\xf6genswerte.","features":["Bis zu 15 Konten","Automatische Aktualisierungen f\xfcr deutsche Konten*","Automatische Aktualisierungen f\xfcr 4 ausl\xe4ndische Konten*","Automatische Bewertungen f\xfcr 2 Immobilien"],"cta":"Paket w\xe4hlen","mostPopular":true},"xl":{"title":"Monestry XL","description":"Das komplette Bild deines Verm\xf6gens.","features":["Bis zu 30 Konten","Automatische Aktualisierungen f\xfcr deutsche Konten*","Automatische Aktualisierungen f\xfcr 8 ausl\xe4ndische Konten*","Automatische Bewertungen f\xfcr 3 Immobilien"],"cta":"Paket w\xe4hlen","mostPopular":false}},"faq":{"header":"\xdcber unsere Pakete","questions":[{"question":"Kann ich mein Paket nach dem Kauf \xe4ndern?","answer":"Ja, du kannst dein Paket jederzeit \xe4ndern, aber nur zu einem gr\xf6\xdferen Paket. Die \xc4nderung tritt sofort in Kraft. Du wirst mit deiner n\xe4chsten Zahlung anteilig f\xfcr den Unterschied zwischen den beiden Paketen belastet."},{"question":"Wie funktioniert die j\xe4hrliche Abrechnung?","answer":"Das ist die kosteng\xfcnstigere Zahlungsmethode. Der oben angegebene Betrag wird mit 12 multipliziert (f\xfcr die Anzahl der Monate in einem Jahr) und einmal j\xe4hrlich \xfcber dein bevorzugtes Zahlungsmittel abgerechnet. Das Abo ist 365/366 Tage g\xfcltig und kann an jedem Tag des Jahres beginnen. Das Abo verl\xe4ngert sich automatisch. Es kann am Ende des aktuellen Abozeitraums gek\xfcndigt werden - das bedeutet, das Abo bleibt bis zum Ende des Jahres aktiv."},{"question":"Wie funktioniert die monatliche Abrechnung?","answer":"Diese Option eignet sich gut, um Monestry auszuprobieren. Der oben angegebene Betrag wird einmal pro Monat berechnet. Das Abo verl\xe4ngert sich automatisch. Es kann jederzeit zum Ende des aktuellen Abozeitraums gek\xfcndigt werden - das Abo bleibt bis zum Ende des Monatszeitraums aktiv. Ein Wechsel zur j\xe4hrlichen Zahlung ist m\xf6glich und tritt in Kraft, sobald der aktuelle Monatszeitraum endet."}]}},"legal":{"toc":"Auf dieser Seite","read-full-doc":"Ganzes Dokument anzeigen","close":"Dokument schliessen","dataPrivacyContact":"Bei Anfrgen rund um Datenschutz, inklusive Informations- und L\xf6schrechte, wende dich bitte an uns per email: support@monestry.de","documents":[{"header":"Allgemeine Gesch\xe4ftsbedingungen (AGB)","subtitle":"Dieses Dokument beschreibt die Nutzungsbedingungen unserer Dienste sowie alle rechtlichen Regelungen, die Nutzerdaten betriffen.","body":"### Deutsche Version \\n\\n Lorem markdownum metus etiam oppositas Antigonen enim Bacchei ungues et ultro Helenum artus, et me laudis fixa, et. Pariter [huius](http://www.sive.com/) precantia admonuisse quove. Nemus sed inpia templis [capere](http://gravis.com/in), mihi colit ponit: illo proles thymi pactus datis iam ranas victus. \\n\\n Ibi usque vi Tantalis sonarent carpunt et. Neque manes: mensuraque, gratissime materia praebet nubibus quos: perque. Ante regnat feram? Ulciscere ecquem triplex. Nullam Magnetas puerile licet; Iovis priores quoque invenies laudat spectat pectine. \\n\\n ### Sexque et naribus motis tauri toto est. \\n\\n Subire ignarus mulcet argento penetrabile curvo hic Cinyran sinus **concipit**. Generosaque quae non spumantia ossibus tulit demens igne suam, Quirini illis retorserunt parte inhibente. Orbem passa est finite pars *spoliata Melantho* foedat. Quod neque tumentem dum. \\n\\n ### Mihi arbore possemque \\n\\n Quas habet, maledicere in est genitor capitis licet; bis terra est nomine, verso. Tale ille plausu huius, thalamis Hippomenen necem vocali si. Herbas obsuntque formae ventis, iuvenes maris me aliena nec mollia cremabis tempora velut. Formae sine parsque \\\\[Caeneus\\\\](http://horrifer-an.com/fumida.aspx) quoque exercere longa profani cessantem esse. \\n\\n ### Crudelia et lacu amplectens nomina misisset \\n\\n Et iactis refundit mecum. Pennatis sic, **in ulla** Ithaco: licebit quattuor non Ceres fraxinus praesignis colore commentaque."},{"header":"Impressum","subtitle":"Dies ist ein gesetzlich vorgeschriebenes Dokument, das die Besonderheiten dieser Website beschreibt.","body":"### Deutsche Version \\n\\n Lorem markdownum metus etiam oppositas Antigonen enim Bacchei ungues et ultro Helenum artus, et me laudis fixa, et. Pariter [huius](http://www.sive.com/) precantia admonuisse quove. Nemus sed inpia templis [capere](http://gravis.com/in), mihi colit ponit: illo proles thymi pactus datis iam ranas victus. \\n\\n Ibi usque vi Tantalis sonarent carpunt et. Neque manes: mensuraque, gratissime materia praebet nubibus quos: perque. Ante regnat feram? Ulciscere ecquem triplex. Nullam Magnetas puerile licet; Iovis priores quoque invenies laudat spectat pectine. \\n\\n ### Sexque et naribus motis tauri toto est. \\n\\n Subire ignarus mulcet argento penetrabile curvo hic Cinyran sinus **concipit**. Generosaque quae non spumantia ossibus tulit demens igne suam, Quirini illis retorserunt parte inhibente. Orbem passa est finite pars *spoliata Melantho* foedat. Quod neque tumentem dum. \\n\\n ### Mihi arbore possemque \\n\\n Quas habet, maledicere in est genitor capitis licet; bis terra est nomine, verso. Tale ille plausu huius, thalamis Hippomenen necem vocali si. Herbas obsuntque formae ventis, iuvenes maris me aliena nec mollia cremabis tempora velut. Formae sine parsque \\\\[Caeneus\\\\](http://horrifer-an.com/fumida.aspx) quoque exercere longa profani cessantem esse. \\n\\n ### Crudelia et lacu amplectens nomina misisset \\n\\n Et iactis refundit mecum. Pennatis sic, **in ulla** Ithaco: licebit quattuor non Ceres fraxinus praesignis colore commentaque."}]},"about-us":{"need-for-monestry":{"header":"Wieso braucht die Welt Monestry?*","subheader":"Monestry entstand aus dem Wunsch, einen einfachen, automatischen \xdcberblick \xfcber die gegenw\xe4rtige, aber auch vergangene und zuk\xfcnftige finanzielle Situation zu haben, und aus der Erkenntnis, dass die auf dem Markt erh\xe4ltlichen Tools dieser Erwartung nicht gerecht werden.","paragraphs":["Monestry ist f\xfcr Menschen gedacht, die ihr finanzielles Schicksal selbst in die Hand nehmen wollen und sich nicht von einer App ablenken lassen wollen, die dir Finanzprodukte verkaufen will.","Wir sind der Meinung, dass Gesch\xe4ftsmodelle, wo als Gegenleistung f\xfcr kostenlose Nutzung einer App deine Daten weiterverkauft oder dir finanzielle Produkte angeboten werden nicht in deiner besten Interesse liegen.","Stattdessen machen wir dir ein transparentes Angebot: Wir helfed dir, deine Daten auf dem neuesten Stand zu halten und stellen dir diverse Tools zur Verf\xfcgung, damit du  gute finanzielle Entscheidungen treffen kannst."],"footnote":"* Oder, in den Worten unserer Freunde zu sagen: \\"Schon wieder eine neue Finanz-App?\\""},"pillars":[{"key":"simplicity","header":"Einfach","description":"Die Welt ist auch so schon komplex genug, deshalb ist es unser oberstes Ziel, die Dinge einfach zu halten. Auch wenn manche Finanzprodukte kompliziert sind, m\xf6chten wir, dass Sie sich auf die wichtigsten Parameter konzentrieren k\xf6nnen. \\n\\n Wir wollen die Oberfl\xe4che unseres Produkts so einfach wie m\xf6glich halten. Sobald Sie sich mit den Feinheiten vertraut gemacht haben, k\xf6nnen Sie die meisten Einstellungen auf einfache Weise vornehmen.","cta":"Schaue dich das an"},{"key":"privacy","header":"Privatsph\xe4re und Vertrauen","description":"Datenschutz war schon eines unserer Hauptanliegen, lange bevor wir auch nur eine Zeile Code geschrieben haben. \\n- wir haben den \\"Anonymen Modus\\" geschaffen, in dem Sie das Produkt nutzen k\xf6nnen, ohne uns Ihren Namen oder Ihre Adresse mitzuteilen \\n- Ihre Kontodaten sind physisch von Ihren Finanzdaten getrennt, um den Schutz zu verdoppeln \\n- es gibt automatische Mechanismen, die alle Nutzerdaten auf Anfrage melden und l\xf6schen.","cta":"Wie wir das in der Praxis umsetzen"},{"key":"convenience","header":"Komfort","description":"Es ist durchaus machbar, alle Bank- und Maklerkonten mit einer Spreadsheet zu verwalten, aber wir glauben, dass Sie Ihre freie Zeit lieber anders verbringen m\xf6chten. \\n\\n Hier kommen wir ins Spiel. Alles, was automatisch aktualisiert werden kann, wird auch automatisch aktualisiert. Wenn eine Automatisierung nicht in Frage kommt, bieten wir Ihnen verschiedene einfache M\xf6glichkeiten, die Daten selbst zu aktualisieren. \\n\\n Wir m\xf6chten, dass Sie die aktuellsten Informationen in Ihrem Browser oder auf Ihrem Telefon haben. Kein m\xfchsames manuelles Aktualisieren von Tabellenkalkulationsspalten mehr!","cta":"Wie k\xf6nnen wir dir Zeit einsparen"}],"pledges":{"title":"Unsere Werte","header":"Drei Versprechen von Monestry","subheader":"Das ist unser Versprechen an dich.","items":[{"key":"one","header":"Wir dr\xe4ngen dich niemals dazu, Finanzprodukte zu kaufen, an denen wir eine Provision verdienen.","subheader":"Wir glauben, dass du in der Lage bist, die f\xfcr dich richtigen Finanzprodukte selbst zu w\xe4hlen. Wir wollen neutral und unvoreingenommen gegen\xfcber allen Produktanbietern sein."},{"key":"two","header":"Die Nutzer haben die volle Kontrolle \xfcber ihre Daten. Wir werden Ihre Daten niemals an Dritte verkaufen.","subheader":"So steht es sogar in unseren Allgemeinen Gesch\xe4ftsbedingungen. Alle Daten, die du uns anvertraust, bleiben unter deiner vollen Kontrolle."},{"key":"three","header":"Wir m\xf6chten die Identit\xe4t unserer Nutzen nicht kennen und wir bieten ihnen die M\xf6glichkeit, unsere Systeme anonym zu nutzen.","subheader":"Wir verkaufen nicht die Daten unserer Nutzer, also m\xfcssen wir ihre Identit\xe4ten nicht kennen. Steigere die Schutz deiner Privatsph\xe4re und bleibe anonym - erh\xf6he dein Komfort, indem du uns mehr Daten anvertraust."}]},"about":{"header":"\xdcber Monestry","body":"Monestry ist ein Start-up-Unternehmen, das im Jahr 2021 in Frankfurt am Main von Piotr Loboda, einem Deutschen mit polnischen Wurzeln, gegr\xfcndet wurde. Seit \xfcber 20 Jahren arbeitet Piotr Loboda als professioneller IT-Architekt und IT-Direktor in verschiedenen Unternehmen der Finanzdienstleistungsbranche. Mehr \xfcber Piotr k\xf6nnen Sie hier erfahren. \\n\\n Das Unternehmen ist zu 100% finanziert durch private deutsche Gesellschafter.\\n\\n Die Monestry GmbH ist seit ihrer Gr\xfcndung Mitglied der Industrie- und Handelskammer Frankfurt am Main und ist im Handelsregister Frankfurt am Main unter der Registernummer HRB 123844 eingetragen. \\n\\n Monestry wurde von verschiedenen \xf6ffentlichen und privaten Organisationen anerkannt und unterst\xfctzt, wie z.B. Amazon Web Services, Stripe sowie diverse KMU-Fonds der Europ\xe4ischen Union \\n\\n Wir haben mit verschiedenen Organisationen und Unternehmen zusammengearbeitet, um unseren Kunden die besten Technologiel\xf6sungen anzubieten. Zu diesen geh\xf6ren:  GoCardless, FinAPI, Faireal, Deutsche Bundesbank, European Central Bank u.v.m. \\n\\n Medienanfragen richten Sie bitte an media@monestry.de, kommerzielle Anfragen an partners@monestry.de."},"why-monestry":{"header":"Wieso \\"Monestry\\"?","body1":"Wir haben nach einem Namen gesucht, der eindeutig mit Geld als solchem in Verbindung gebracht werden kann, der in verschiedenen L\xe4ndern leicht zu verstehen, nicht zu lang und leicht zu merken ist. Wir haben zahllose Namen durchforstet (die meisten sind bereits vergeben), einige davon intern erdacht und einige mit Hilfe k\xfcnstlicher Intelligenz kreiert und uns schlie\xdflich f\xfcr \\"Monestry\\" entschieden.","body2":"\\"Monestry\\" verbindet den Wohlstand, die Stabilit\xe4t und die Diskretion eines Zisterzienserklosters in einem \xfcppigen franz\xf6sischen Wald mit viel mehr weltlichem Geld, das wir alle brauchen, um unsere irdischen Tr\xe4ume zu erf\xfcllen. Wir sprechen es aus","body3":"MO-nes-stri."}},"register":{"select":"W\xe4hlen","username":{"header":"Registriere dich - es ist einfach!","subheader":"Schritt 1 von 3. Erstelle ein Monestry-Benutzerkonto oder verwende ein bestehendes Nutzerkonto."},"package":{"header":"Fast geschafft","subheader":"Schritt 2 von 3. Mit welchem Paket m\xf6chtest du einsteigen?"},"payment":{"header":"Zahlungsmodus","subheader":"Zahlungsmodus jetzt oder erst nach dem Probemonat festlegen. Heute fallen keine Kosten an!"},"processing":{"header":"Willkommen bei Monestry!","subheader":"Bitte warte ganz kurz, wir stellen dein Dashboard bereit."},"paymentStillProcessed":"Deine Zahlung wird noch bearbeitet.","pleaseWaitWhileWeAreSettingThingsUp":"Bitte warte, w\xe4hrend wir alles f\xfcr dich einrichten.","goBack":"Zur\xfcck","signUp1":{"createNewAccount":"Erstelle ein neues Konto","email":{"label":"Deine E-Mail-Adresse","errorEmpty":"Bitte gebe eine E-Mail-Adresse an.","errorInvalid":"Deine E-Mail-Adresse scheint ung\xfcltig zu sein.","errorLength":"Deine E-Mail-Adresse darf nicht l\xe4nger als 200 Zeichen sein","errorTaken":"Diese E-Mail-Adresse ist leider nicht verf\xfcgbar.","tooltip":"Damit wir dich erreichen k\xf6nnen, wenn du z.B. dein Passwort zur\xfccksetzen musst. Du kannst deine E-Mail auch zum Anmelden verwenden."},"password":{"label":"W\xe4hle ein Passwort","hint":"Dein Passwort muss mindestens 8 Zeichen lang sein und muss mindestens einen der folgenden enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahl und ein Satzzeichen.","errorEmpty":"Bitte gib ein Passwort ein.","errorLength":"Dein Passwort darf nicht l\xe4nger als 99 Zeichen sein","errorPattern":"Dein Passwort entspricht nicht den Anforderungen."},"repeatPassword":{"label":"Wiederhole das Passwort","errorMatch":"Das wiederholte Passwort ist nicht dasselbe wie das neue Passwort."},"username":{"label":"Benutzername","tooltip":"Bitte w\xe4hle einen Benutzernamen, damit wir wissen, wie wir dich ansprechen sollen. Sp\xe4ter kannst du dich mit deiner E-MAIL oder deinem BENUTZERNAMEN anmelden.","errorRequired":"Bitte gebe einen Benutzernamen an. Wir m\xfcssen nur wissen, wie wir dich nennen sollen.","errorLength":"Dein Benutzername darf nicht l\xe4nger als 40 Zeichen sein","errorMinLength":"Dein Benutzername darf nicht k\xfcrzer als 5 Zeichen sein","errorPattern":"Du darfst in deinem Benutzernamen nur Buchstaben, Zahlen und . - _ verwenden.","errorTaken":"Dieser Benutzername ist leider nicht verf\xfcgbar."},"country":{"label":"Land","tooltip":"Warum m\xfcssen wir das wissen? Aus steuerlichen Gr\xfcnden: im Moment k\xf6nnen wir nur Rechnungen an in Deutschland wohnhafte Kunden stellen.","Germany":"Deutschland"},"baseCurrency":{"label":"Basisw\xe4hrung","tooltip":"Welcher W\xe4hrung m\xf6chtest du als Basisw\xe4hrung nutzen? Typischerweise ist das die W\xe4hrung, in der du verdienst."},"or":"oder","useExistingAccount":"... oder verwende ein bestehendes Konto.","useExistingAccountDescription":"Du kannst ein bestehendes Konto bei einem Anbieter deines Vertrauens verwenden, um dich bei Monestry anzumelden. Du kannst dann jedes Mal, wenn du dich bei Monestry anmeldest, dieses Konto verwenden.","signUpWith":"Anmelden mit"},"signUp3":{"yourOrder":"Deine Bestellung","creditCard":"Kreditkarte","crypto":"Kryptow\xe4hrungen","payNow":"Jetzt speichern","payLater":"Sp\xe4ter speichern","perMonth":" /Monat","freeUntil":"Kostenlos bis","afterwards":"danach","day":"Tag","dueToday":"Heute f\xe4llig ","dueIn30Days":"F\xe4llig am ","subscriptionRenewsOn":"Erster Monat gratis. Dein Abo verl\xe4ngert sich automatisch. Die Zahlung erfolgt","everyyear":"jedes Jahr am","everymonth":"jeden Monat am","yearBilling":"abgerechnet j\xe4hrlich.","monthBilling":"abgerechnet monatlich.","reminderEmail":"Du erh\xe4lst eine Erinnerungs-E-Mail, bevor die Zahlung f\xe4llig ist.","cancelAnyTime":"K\xfcndige jederzeit. Nach der K\xfcndigung ist dein Abo noch bis zum letzten Tag der bezahlten oder der Test-Periode.","upgradeAnyTime":"Ein Upgrade auf eine h\xf6here Produktebene ist jederzeit m\xf6glich.","upgradeSwitchToAnnual":"Upgrades auf eine h\xf6here Produktebene und der Wechsel zur erm\xe4\xdfigten j\xe4hrlichen Zahlung sind jederzeit m\xf6glich.","externalInfo":"Hinweis: aus Sicherheitsgr\xfcnden muss der Zugang \xfcber {{provider}} manchmal mehr als nur einmal best\xe4tigt werden."},"paymentSuccessful":{"stillProcessed":"Deine Zahlung wird noch bearbeitet.","registrationSuccessful":"Registrierung erfolgreich","welcome":"Willkommen!","thanksForOpening":"Danke, dass du ein Konto bei Monestry er\xf6ffnet hast.","weSentYouAnEmail":"Wir haben dir eine E-Mail geschickt, um deine Adresse zu best\xe4tigen. W\xe4hrend du wartest, warum schaust du dir nicht unser kurzes Einf\xfchrungsvideo rechts an?","enterCode":"Bitte gib den 6-stelligen Code aus dieser E-Mail in das Feld ein und dr\xfccke den unten stehenden Knopf, sobald du bereit bist.","verificationCode":"Verifizierungscode","confirmAccount":"Konto best\xe4tigen","codeError":"Dieser Code ist nicht richtig","genericError":"Es tut uns leid, es ist ein unerwarteter Fehler passiert. Bitte wende dich an support@monestry.de. Schicke uns die registrierte Email sowie diese Fehlermeldung.","federated":{"accountReady":"Dein Konto ist bereit. Du kannst dich wie gew\xfcnscht mit {{provider}} anmelden.","addPasswordLater":"Wenn du zu einem sp\xe4teren Zeitpunkt ein Monestry-Passwort deinem Konto hinzuf\xfcgen m\xf6chtest, kannst du dies tun, indem du dein Passwort vom Anmeldebildschirm aus zur\xfccksetzt.","proceedToDashboard":"Zum Dashboard gehen"},"errorMessage":{"registrationFailed":"Registrierung fehlgeschlagen","error":"Fehler","thankYouForOpening":"Danke, dass du ein Konto bei Monestry er\xf6ffnet hast.","problemWithPayment":"Leider scheint es ein Problem mit deiner Zahlung zu geben. Bitte wende dich an unser Support-Team unter support@monestry.de."}},"fallback":{"header":"E-Mail nicht verf\xfcgbar","body1":"Einige Anbieter (z.B. Facebook) teilen unter gewissen Umst\xe4nden deine verifizierte E-Mail-Adresse nicht mit. Ohne sie k\xf6nnen wir kein Konto f\xfcr dich erstellen.","body2":"Bitte gib eine E-Mail-Adresse und ein Passwort ein, um ein Konto bei uns zu erstellen.","submit":"Konto erstellen","unhandledError":{"header":"Es tut uns leid, die Registrierung ist fehlgeschlagen.","body1":"Deine Zahlung ist h\xf6chstwahrscheinlich erfolgreich durchgef\xfchrt worden, aber wir konnten dein Konto nicht fertig einrichten.","body2":"Bitte versuche sich auf unserer Homepage mit den Anmeldedaten, die du gerade verwendet hast, anzumelden. Wenn das nicht funktioniert, wende dich bitte an unser Support-Team unter support@monestry.de","message":"Bitte schicke uns die folgende Fehlermeldung:"}},"prep":{"header":"Wir bereiten Demo-Daten vor","body":"Wir bereiten gerade Demo-Daten f\xfcr dich vor, um dir den Einstieg zu erleichtern. Das dauert nur ein paar Sekunden.","account0":"[DEMO] Mein Bankkonto","account1":"[DEMO] Brokerage-Bargeldkonto","account2":"[DEMO] Sparkonto","account3":"[DEMO] Mein Aktienmakler","account4":"[DEMO] Meine Immobilie","project0":"[DEMO] Living","intialSaldo":"Anfangssaldo","purchaseAppleStock":"Kauf von Apple-Aktien","transactionFees":"Transaktionsgeb\xfchren","purchaseTeslaStock":"Kauf von Tesla-Aktien","accountRunningCost":"Kontobetriebskosten","dividendAppleStock":"Dividende Apple-Aktien","salary":"Gehalt","rentPayment":"Mietzahlung","creditCardBill":"Kreditkartenabrechnung","carRental":"Autovermietung","hotelBill":"Hotelrechnung","interestPayment":"Zinszahlung","otherParty":"Andere Partei"},"code":{"label":"Registrierungscode","link":"Registrierungscode eingeben","errorInvalid":"Code ist leider ung\xfcltig."}},"requestDemo":{"topheader":"Bevor du anf\xe4ngst","Ready to set up your demo":"Startklar?","header1":"Wir m\xf6chten unsere potenziellen Benutzer besser kennenlernen.","header2":"H\xe4ttest du etwas dagegen, anonym vier einfache Fragen zu beantworten?","numberOfAccounts":{"label":"Wie viele verschiedene Finanzprodukte hast du weltweit?","sublabel":"Einschlie\xdflich Bankkonten, Depots, Rentenprodukte, etc.","options":["0 - 5","6 - 10","11 - 20","20+"]},"incomeSaved":{"label":"Welchen Prozentsatz deines Einkommens kann dein Haushalt sparen oder investieren?","options":["<10%","10% - 20%","20% - 30%","30% - 40%","40% - 50%",">50%"]},"age":{"label":"Wie alt bist du?","options":["<25","26-35","36-45","46-55","56-65","65+"]},"workplace":{"label":"Wo arbeitest du?","options":["Gro\xdfes Unternehmen (mehr als 10.000 Mitarbeiter)","Kleines/Mittelst\xe4ndisches Unternehmen (bis zu 10.000 Mitarbeiter)","Ich besitze ein Unternehmen","Ich bin selbstst\xe4ndig"]},"howCanWeHelp":{"label":"Wie kann dir Monestry helfen? (optional)"},"Cancel":"Abbrechen","Start demo":"Demo starten","weAreSettingThingsUp":"Bitte kurz warten - wir bereiten das Demo f\xfcr dich vor."},"cookies":{"title":"Cookies","description":"Wir verwenden auf unserer Website notwendige und optionale Cookies, um unsere App zu betreiben und sie st\xe4ndig zu verbessern. Ihre Einwilligung umfasst alle vorausgew\xe4hlten / gew\xe4hlten Cookies sowie das mit ihnen verbundene Speichern und Auslesen von Informationen auf Ihrem Endger\xe4t sowie anschlie\xdfendes Auslesen und die folgende Verarbeitung personenbezogener Daten.","noTracking":"Wir zeigen keine Werbung und verwenden keine Cookies zum Tracking unserer Nutzer (sie verkn\xfcpfen Daten aus dieser App mit Daten Dritter).","legalBasis":"Die Rechtsgrundlage f\xfcr die Einwilligung im Hinblick auf die Speicherung und das Auslesen von Informationen ist \xa7 25 Abs. 1 TTDSG sowie im Hinblick auf die Verarbeitung personenbezogener Daten Art. 6 Abs. 1 lit. a DSGVO.","settingsInfo":"Sie k\xf6nnen nicht notwendige Cookies akzeptieren (\'Alle akzeptieren\') oder ablehnen (\'Nur essenzielle\'). Ihre Einstellungen sind jederzeit \xe4nderbar, auch nachtr\xe4glich \xfcber einen Link im Fu\xdfbereich unserer Website.","privacyPolicy":"Weitere Hinweise zu den verwendeten Verfahren und Ihren Rechten, erhalten Sie in unserer Datenschutzerkl\xe4rung.","onlyEssential":"Nur essenzielle","customise":"Anpassen","acceptAll":"Alle akzeptieren","customiseCookiesTitle":"Cookies anpassen","customiseCookiesDesc":"Sie k\xf6nnen die Cookies, die Sie auf dieser Website zulassen m\xf6chten, anpassen.","customiseTitle":"Cookies anpassen","customiseSubtitle":"Sie k\xf6nnen die Cookies, die Sie auf dieser Website zulassen m\xf6chten, anpassen.","essential":{"label":"Notwendig","description":"Diese Cookies sind f\xfcr das einwandfreie Funktionieren der Website erforderlich."},"marketing":{"label":"Marketing","description":"Diese Cookies werden verwendet, um Ihnen personalisierte Angebote und Inhalte bereitzustellen."},"analytics":{"label":"Analytik","description":"Diese Cookies helfen uns zu verstehen, wie Nutzer unsere App verwenden, und verbessern das Benutzererlebnis."},"externalMedia":{"label":"Externe Medien","description":"Diese Cookies erm\xf6glichen es uns, Ihnen externe Medien wie YouTube-Videos in unserer App zu zeigen."},"save":"Speichern","goBack":"Zur\xfcck"},"contact":{"header":"Kontaktiere uns","subheader":"Wie k\xf6nnen wir dir helfen?","goToLogin":"Einloggen","goToDashboard":"Dashboard","emailUs":"Schick uns eine E-Mail","prospects":{"header":"Produktfragen","body":"Wenn du Fragen zu unserem Produkt hast, sende uns bitte eine E-Mail an support@monestry.de"},"users":{"header":"Feedback | Bugs | Ideen","body":"Wenn du Feedback, Ideen oder einen Fehler gefunden hast, verwende bitte das Feedback-Link, die unten rechts auf dem Bildschirm erscheint, sobald du dich eingeloggt hast."},"dataPrivacy":{"header":"Account l\xf6schen | Datenanfragen","body":"Wenn du deinen Account l\xf6schen m\xf6chtest oder eine datenbezogene Anfrage hast, sende uns bitte eine E-Mail an support@monestry.de"},"partners":{"header":"Partnerschaften","body":"Wenn du eine Partnerschaftsidee mit uns besprechen m\xf6chtest, kontaktiere uns bitte unter partners@monestry.de"},"media":{"header":"Medienanfragen","body":"Wenn du Journalist/in bist und \xfcber uns schreiben m\xf6chtest, sende uns bitte eine E-Mail an media@monestry.de"}}}');


var $ad28983a058059e4$exports = {};
$ad28983a058059e4$exports = JSON.parse('{"general":{"findoutmore":"Find out more","getdemo":"Live demo","startDemo":"Try a demo","search":"Search","noResultsFound":"No results found","freetrial":"Start free trial","howdowedoit":"How do we do it?","language":"Language","english":"English","german":"German","country":"Country","germany":"Germany","send":"Send","ok":"OK","error":"Error","yes":"Yes","no":"No","success":"Success","submit":"Submit","continue":"Continue","cancel":"Cancel","next":"Next","back":"Back","subscribe":{"header":"Subscribe to our newsletter","body":"The latest updates, articles, and resources, sent to your inbox every 2 months.","emailprompt":"Enter your email","button":"Subscribe"},"step":"Step","stepOf":"of","findOutMore":"Find out more","synchronising":"Synchronising"},"login":{"invalidUsernameOrPassword":"Invalid username or password","userNotConfirmed":"User has not been confirmed. Please contact support at support@monestry.de","passwordResetRequired":"Your password must be reset, please do so using the \'Forgot your password?\' link below.","incorrectConfirmationCode":"The confirmation code you entered is incorrect. Please try again.","unknownUser":"We could not find a user who would have the email address given to us by the external identity provider you selected.","signInIntoYourAccount":"Sign in to your account","signInWith":"Sign in with","enterConfirmationCode":"Enter authorisation code from your app","enterConfirmationCodeEmail":{"tip":"We have sent you an email with confirmation code. Please enter it here.","label":"Enter confirmation code from email","error":"Code must be 6 digits long"},"orContinueWith":"or continue with","emailOrUsername":"Email or username","password":"Password","rememberMe":"Remember me","forgotPassword":"Forgot your password?","signIn":"Sign in","fieldRequired":"This field is required.","passwordRecovery":"Recover your password","unableToResetPassword":"We were not able to reset your password. Please try again later.","enterNewPassword":"Enter a new password","tooManyRequests":"To protect your data we had to block password changes for this account for 15 minutes. We detected too many password change attempts."},"menu":{"features":"Features","anonymous":"Anonymous use","data":"Data sources","blog":"Blog","meet":"Meet Monestry","pricing":"Pricing","demo":"Live demo","dashboard":"Dashboard","login":"Log in","logout":"Log out","register":"Sign on","product":"Product","support":"Support","guide":"User Guide","howto":"How-To Guides","contact":"Contact","company":"Company","about":"About","jobs":"Jobs","press":"Press","partners":"Partners","legal":"Legal","impressum":"Impressum","privacy":"Privacy","agb":"Terms"},"main":{"cta":{"line-1":"Make your money","line-2":"work as hard as you","body-1":"Take the right decisions with Monestry, your trusted, independent financial planning app.","body-2":"A truly complete picture of your wealth: past, present and future. Automatic updates from over 6,000 institutions worldwide."},"partners":"Our trusted partners","convenience":{"header":"Convenience","title":"We are here to make your life easier","subtitle":"Monestry was created to remove effort and complexity from managing your personal finances. Let us put you in charge of your financial future."},"complete":{"title":"A truly complete picture","body":"We know that your wealth is more than bank accounts and stocks. That is why make it possible to track a variety of many other asset categories: from real estate through cryptocurrencies and bars of precious metals to objects of value and shares of unlisted companies.","sub1":{"title":"Real estate","body":"Apartments and houses, self-used or rented out, can be a very significant part of your assets. We make it possible to track the value of that investment in an easy way."},"sub2":{"title":"Pension insurance","body":"A complete view of of your finances has to include pension insurances. They can play a significant part in how you handle your retirement finances."}},"current":{"title":"Current value at a click","body":"Making a list of all your assets and their value today is only part of task. Tomorrow many of those assets will have a different value. And the day after tomorrow - different again. Monestry makes sure that all your asset classes always remain up to date.","sub1":{"title":"Stocks, currencies and precious metals","body":"We take care of automatic updates to all the stocks, currencies, cryptocurrencies and precious metals in your accounts."},"sub2":{"title":"Market value of your real estate","body":"You will receive a free current market value update every 6 months for every real estate object in your portfolio. We use the same providers that the banks use to assess the value of your property.","link":"How do we do it?"}},"security":{"header":"State of the art","title":"Latest technology keeps your data safe","body":"We use state-of-the-art encryption and security technology for your data and all our systems. You can stay anonymous, and your account information is never stored together with your financial data."},"simple":{"title":"See the future","body":"How would you like to know that the future holds? We cannot tell you that for certain, but we can help. Use our simulations and projects to see how your wealth could look like in 10, 20 or 40 years.","link":"See how it works","quote":"\\"It\'s incredibly reassuring to see how my investments could grow over time. This tool has genuinely helped me feel more confident about my long-term financial strategy.\\"","name":"Anna - Frankfurt am Main, Germany"},"simpleOLD":{"title":"Simplicity first","body":"Modern life and modern work can be very complex. That is why making Monestry as simple to use as possible is our first priority. We weed out irrelevant aspects of wealth management and provide predefined German financial product templates.","link":"Featured products","quote":"Cras velit quis eros eget rhoncus lacus ultrices sed diam. Sit orci risus aenean curabitur donec aliquet. Mi venenatis in euismod ut.","name":"Jane - Frankfurt am Main, Germany"},"saving":{"title":"Saving you time","body":"There are better things to do than sitting in front of a spreadsheet and copy-pasting columns of numbers - even if the numbers are your constantly growing assets. Let us take care of importing and structuring all the data, so that you can focus on what is relevant - taking the right decisions about your future.","link":"Find out more","quote":"\\"I don\'t waste time on spreadsheets anymore. They handle all the data stuff, so I can just make good choices for my future. It\'s a lot easier and saves me heaps of time.\\"","name":"Peter - Bad Homburg, Germany"}},"feedback":{"title":"Your feedback","problem":"Problem","idea":"Idea","question":"Question","header":"What would you like to tell us?","email":"Send me an email once the issue is tackled.","completed":{"success":"Thank you for contacting us. If you ever need to reach out to us about this again, please use the following reference:","failure":"We are sorry: sending feedback was not possible at this time. Our support team has been notified. Please try again later."},"beingUploaded":"Your feedback is being uploaded. Please wait.","uploadAttachment":"Upload an attachment","uploadSizeLimit":"Maximum size: 5MB"},"dashboard":{"accounts_header":"Your Accounts"},"page-not-found":{"header":"We are sorry","title":"This page does not exist","body":"Please use the menu links to visit one of the other sections.","link":"Go back","homePage":"Home page"},"blog":{"title":"Aus unserem Blog","subtitle":"St\xf6bere durch die Artikel und finde Tipps, wie man Monestry besser nutzen kann, unsere selbstbewussten Beitr\xe4ge zu diversen finanziellen Themen sowie Ank\xfcndigungen neuer Produktmerkmale.","filter-header":"Filter by category:","categories":{"blog":{"filter-title":"All","title":"From the blog","subtitle":"Browse through the articles and find tips on getting more out of Monestry, our opinionated articles on several financial topics and new feature announcements."},"guide":{"title":"Product guide","subtitle":"These articles describe all the product features in detail and provide tips on how to use them."},"new-features":{"title":"Product announcements","subtitle":"At Monestry we continuously develop our product to make managing your finances easier. Here you will find new feature announcements."},"point-of-view":{"title":"Point of view","subtitle":"We have strong opinions on how personal finances should be managed. Here you will find our thoughts on several financial topics."},"market-overview":{"title":"Market overview","subtitle":"We keep our finger on the pulse of the financial app market. Here you will find our thoughts on the latest developments."}}},"article":{"return-prev-page":"Back to previous page","written-by":"Written by","published":"Published","updated":"updated","related-articles":"Related articles","fixed-articles-header":"Simplify your finances with Monestry","features-title":"Features: what can we do for you?","demo-title":"Live demo: try it out - no registration!"},"features":{"section1":{"header":"Your finances up to date","header-accent":"automatically","body":"Monestry makes it simple to manage your personal finances by giving you a complete picture of all your assets and their changing value.","one-glance":{"title":"See your wealth at one glance","body":"Dashboard is the heart of our App. This is where you see what is the current state of your finances and how are individual assets performing. Its intuitive design guides you to all other functions of the App.","quote":"\\"The dashboard really simplifies things for me. It gives a clear picture of my finances and, most importantly, how are all my assets doing, all in one place.\\"","person":"Lukas - Frankfurt am Main, Germany"},"all-classes":{"header":"Manage all asset classes","body":"Realize the full extent of your wealth and start considering them in your plans. You may be surprised how big is the difference when you have a whole picture.","bank":{"header":"Bank assets","body":"The classic. Keep track of your cash savings across as many banks as you like."},"stocks":{"header":"Securities","body":"From your broker or from your employer, you can track all kinds of securities and options with Monestry."},"real-estate":{"header":"Real estate","body":"Keep track of what your real estate is worth, and if you rent it out - find out what your real returns are."},"pension":{"header":"Pension","body":"Monitor performance of your pension investments: state pension and captial insurances, Riester, R\xfcrup and bAV."},"unlisted":{"header":"Unlisted companies","body":"Do you know what is your business worth and what is the current return on investment? We can help with professional estimates."},"crypto":{"header":"Cryptocurrency","body":"A new class of assets which can become very valuable in a short period of time."},"objects":{"header":"Objects of value","body":"Bars of precious metals, oldtimer cars, watches, coins and jewellery can be a significant part of one\'s wealth"},"loans":{"header":"Loans","body":"Owed or taken out, loans can be substantial components of your financial situation."}}},"section2":{"lead":"Automatic updates","header":"Know what your assets are worth","body":"Do you know how much your net worth is right now? Monestry helps you to stay on top of that.","valuation":{"stocks":{"header":"Stock quotes","body":"All securities across all your accounts are updated daily with their current price, so that you know how the current market trends influence your net worth."},"unlisted":{"header":"Shares of unlisted companies","body":"We give you the tools to estimate what a share in an unlisted company may be worth to help you deal with partners, investors and banks."},"metals":{"header":"Precious metals","body":"Monestry gives you an estimate of current market value and spread for the precious metals that you may own."},"fx":{"header":"Foreign exchange rates","body":"Do you remember 1\u20AC for $0.85 in 2000? And 1\u20AC for $1.46 just eight years later? Foreign currency fluctuations can significantly change your assets\\\\\' value. Monestry keeps it up to date."},"real-estate":{"header":"Real estate","body":"Every 6 months Monestry will provide you with the current market value of your properties, stemming from an analysis of more than 200,000 current sale transactions in Germany."}}},"section3":{"goals":{"body":"Do you know when will you be able to retire? Can you finance your dream vacation house from your stock portfolio gains or will you need a loan? Answer these and other questions by using Monestry\'s goals and simulations feature.","header":"Create goals and simulations","set":{"header":"Set financial goals","body":"Determine how much money will you need to finance future projects and plan what accounts will that money come from."},"simulate":{"header":"Simulate future growth","body":"Check your net worth at different moments in the future to see how much your different assets are worth then."}},"reports":{"body":"Create your own analyses and visualisations to have more insights into your finances.","header":"Use customisable reports","pivot":{"header":"Pivot tables","body":"If the pre-set reports are not enough, use a pivot table format to prepare exactly the data that you want to see."},"charts":{"header":"Design charts","body":"Create beautiful charts using Monestry\'s flexible charting engine."},"keep-eye":{"header":"Monitor the situation easily","body":"Embed your own charts in your Dashboard to see the most important information every time you visit."}}},"section4":{"sync":{"header":"Keep data in sync","auto":{"header":"Automatic synchronisation","body":"Get your data automatically from more than 60,000 financial institutions in Germany and abroad. We partner with a leading financial services data provider, active in the field for more than 10 years. Find out more."},"edit":{"header":"Edit data spreasheet-style","body":"Use a familiar spreadsheet grid to enter and edit all data which need to be updated manually."},"uploads":{"header":"Intelligent uploads","body":"For manual uploads, our simple and intuitive file upload analyses the data and suggests the correct mapping logic, easily adjustable per mouse click."},"decide":{"header":"You decide","body":"You decide which accounts to update automatically and which will be updated with files. You can also change your settings at any time."}},"foundations":{"header":"Solid foundations","body":"No experiments. Monestry is built with proven, state-of-the-art technologies, with strong focus on data privacy, security and sustainability.","sustain":{"header":"Sustainable IT","body":"No idling servers - Monestry IT resources are \\"on\\" only when they are being used."},"anonymous":{"header":"Anonymous mode","body":"Use Monestry without disclosing your name. You can count on our help protecting you and your data."},"control":{"header":"Full control over your data","body":"We pledge to never sell your data to any external company - check our T&C\'s. This isn\'t how we earn money."},"neutral":{"header":"Neutral","body":"We do not try to sell you financial products and benefit from the commissions paid for vendors."},"security":{"header":"Security","body":"\'All data in storage and in transit are encrypted with private keys and not visible outside of Monestry"},"impartial":{"header":"Impartial","body":"Monestry is independently owned and not influenced by any financial services provider."},"audit":{"header":"Regular audits","body":"We schedule regular security audits by external consultants to keep our systems safe."},"german":{"header":"Made in Germany","body":"Monestry was founded in Frankfurt and this is also where all its own IT systems are located."}},"cta":{"header":"Make your money work.","header2":"Start using Monestry today.","subheader":"One month for free. No credit card required. Cancel any time."}}},"pricing":{"header":"Choose the package that suits you best","subheader":"We know that one size does not fit all. That\'s why we created four affordable packages for you to choose from.","most-popular":"Most popular","annually":"Annual billing","monthly":"Monthly billing","automaticUpdatesDisclaimer1":"* Some of your financial institutions may not support automatic updates. Please check the ","automaticUpdatesDisclaimer2":"list of supported institutions.","linkToAutoUpdates":"/en/blog/guide/how-do-we-keep-your-financials-current","products":{"frequency":"/month","s":{"title":"Monestry S","description":"Automated updates of your assets for an easy start.","features":["Up to 5 accounts","Automatic updates for German accounts*","Automatic update for 1 foreign account*"],"cta":"Get package","mostPopular":false},"m":{"title":"Monestry M","description":"Take control of your financial future.","features":["Up to 10 accounts","Automatic updates for German accounts*","Automatic updates for 2 foreign accounts*","Automatic valuations for 1 real estate property"],"cta":"Get package","mostPopular":false},"l":{"title":"Monestry L","description":"Finally a good overview of all your assets.","features":["Up to 15 accounts","Automatic updates for German accounts*","Automatic updates for 4 foreign accounts*","Automatic valuations for 2 real estate properties"],"cta":"Get package","mostPopular":true},"xl":{"title":"Monestry XL","description":"The complete picture of your wealth.","features":["Up to 30 accounts","Automatic updates for German accounts*","Automatic updates for 8 foreign accounts*","Automatic valuations for 3 real estate properties"],"cta":"Get package","mostPopular":false}},"faq":{"header":"About our packages","questions":[{"question":"What is an account?","answer":"In Monestry each asset has its own account, e.g. a bank account, a brokerage account, a real estate property, a pension insurance, a loan etc. The number of accounts is limited by the package you choose. You can always upgrade to a larger package."},{"question":"What does >up to 5 / 10 / ... accounts< mean exactly?","answer":"The account limit is the maximum number of accounts that you can have in Monestry. If you reach the limit, you will not be able to add new accounts until you upgrade to a larger package."},{"question":"Can I change my package after I purchase?","answer":"Yes, you can change your package at any time, but only to a larger package. The change will come into effect immediatelly. You will be charged the difference between the two packages pro rata with your next payment."},{"question":"How does annual billing work?","answer":"This is the more cost-effective approach to payment. The amount indicated above is multiplied times 12 (for the number of months in a year) and charged through your preferred means of payment once per year. The subscription is valid for 365/366 days and can commence at any day of the year. The subscription will be prolonged automatically. It can be cancelled by the end of the current subscription period - that means the subscription remains active until the end of year."},{"question":"How does monthly billing work?","answer":"This option is good for trying out Monestry. The amount indicated above will be charged once per month. The subscription will be prolonged automatically. It can be cancelled at any time by the end of the current subscription period - the subscription remains active until the end of the monthly period. Switch to annual payment is possible and comes in effect as soon as the current monthly period finishes."}]}},"legal":{"toc":"On this page","read-full-doc":"Read entire document","close":"Close preview","dataPrivacyContact":"Please email us at support@monestry.de for all data privacy related inquiries, including listing and deleting user data.","documents":[{"header":"Terms & Conditions","subtitle":"This document describes the terms of use of our services as well as everything concering your data and what happens to it.","body":"### Iam adimunt fertur \\n\\n Lorem markdownum metus etiam oppositas Antigonen enim Bacchei ungues et ultro Helenum artus, et me laudis fixa, et. Pariter [huius](http://www.sive.com/) precantia admonuisse quove. Nemus sed inpia templis [capere](http://gravis.com/in), mihi colit ponit: illo proles thymi pactus datis iam ranas victus. \\n\\n Ibi usque vi Tantalis sonarent carpunt et. Neque manes: mensuraque, gratissime materia praebet nubibus quos: perque. Ante regnat feram? Ulciscere ecquem triplex. Nullam Magnetas puerile licet; Iovis priores quoque invenies laudat spectat pectine. \\n\\n ### Sexque et naribus motis tauri toto est. \\n\\n Subire ignarus mulcet argento penetrabile curvo hic Cinyran sinus **concipit**. Generosaque quae non spumantia ossibus tulit demens igne suam, Quirini illis retorserunt parte inhibente. Orbem passa est finite pars *spoliata Melantho* foedat. Quod neque tumentem dum. \\n\\n ### Mihi arbore possemque \\n\\n Quas habet, maledicere in est genitor capitis licet; bis terra est nomine, verso. Tale ille plausu huius, thalamis Hippomenen necem vocali si. Herbas obsuntque formae ventis, iuvenes maris me aliena nec mollia cremabis tempora velut. Formae sine parsque \\\\[Caeneus\\\\](http://horrifer-an.com/fumida.aspx) quoque exercere longa profani cessantem esse. \\n\\n ### Crudelia et lacu amplectens nomina misisset \\n\\n Et iactis refundit mecum. Pennatis sic, **in ulla** Ithaco: licebit quattuor non Ceres fraxinus praesignis colore commentaque."},{"header":"Impressum","subtitle":"This is a legally mandated document outlining the specifics of this website.","body":"### Iam adimunt fertur \\n\\n Lorem markdownum metus etiam oppositas Antigonen enim Bacchei ungues et ultro Helenum artus, et me laudis fixa, et. Pariter [huius](http://www.sive.com/) precantia admonuisse quove. Nemus sed inpia templis [capere](http://gravis.com/in), mihi colit ponit: illo proles thymi pactus datis iam ranas victus. \\n\\n Ibi usque vi Tantalis sonarent carpunt et. Neque manes: mensuraque, gratissime materia praebet nubibus quos: perque. Ante regnat feram? Ulciscere ecquem triplex. Nullam Magnetas puerile licet; Iovis priores quoque invenies laudat spectat pectine. \\n\\n ### Sexque et naribus motis tauri toto est. \\n\\n Subire ignarus mulcet argento penetrabile curvo hic Cinyran sinus **concipit**. Generosaque quae non spumantia ossibus tulit demens igne suam, Quirini illis retorserunt parte inhibente. Orbem passa est finite pars *spoliata Melantho* foedat. Quod neque tumentem dum. \\n\\n ### Mihi arbore possemque \\n\\n Quas habet, maledicere in est genitor capitis licet; bis terra est nomine, verso. Tale ille plausu huius, thalamis Hippomenen necem vocali si. Herbas obsuntque formae ventis, iuvenes maris me aliena nec mollia cremabis tempora velut. Formae sine parsque \\\\[Caeneus\\\\](http://horrifer-an.com/fumida.aspx) quoque exercere longa profani cessantem esse. \\n\\n ### Crudelia et lacu amplectens nomina misisset \\n\\n Et iactis refundit mecum. Pennatis sic, **in ulla** Ithaco: licebit quattuor non Ceres fraxinus praesignis colore commentaque."}]},"about-us":{"need-for-monestry":{"header":"Why does the world need Monestry?*","subheader":"Monestry arose from the desire for having a simple, automated app which provides a very clear picture of your finances\' past, present and future, and the realisation that the tools available on the market fell short of this expectation.","paragraphs":["Monestry is intended for people who want to take complete charge of their own financial fate and who do not want to be distracted by apps to sell them financial products.","We believe that free finance management apps do not have the customers\' best interest at heart. The price paid for engaging in such model is often loss of control of your most sensitive data or being led into making wrong financial choices.","Our deal is simple: we help you keep the financial information current and provide automated tools to make good financial decisions.","We don\'t want your personal data and will never sell the data you decided to share. All that kept as simple as humanly possible, as the world is already complex enough."],"footnote":"* Or, in the words of some of our friends: \\"Why create yet another financial app?\\""},"pillars":[{"key":"simplicity","header":"Simplicity","description":"The world is complex enough on its own, so we make keeping things simple our top priority. Even though some financial products are complicated, we want to let you focus on their most important parameters. \\n\\n We want to keep the surface layer of our product as simple as we can. Once you are comfortable enough to deal with finer details, you can adjust most the settings in an easy way.","cta":"See how it looks"},{"key":"privacy","header":"Privacy and Trust","description":"Data privacy has been one of our primary concerns since way before we even wrote a single line of code. \\n- we created the \u201CAnonymous Mode\u201D, where you can use the product without disclosing your name or address to us \\n- your account data are physically separated from your financial data to double the layer of protection \\n- there are automatic mechanisms in place to report on and delete all user data on request.","cta":"See how we apply it in practice"},{"key":"convenience","header":"Convenience","description":"It is possible to keep track of all your bank and brokerage accounts with a spreadsheet, but we believe that you would prefer to spend your free time differently. \\n\\n This is where we step in. Everything that can be updated automatically, will be updated automatically. If automation is not an option, we provide several simple ways to help you update the data yourself. \\n\\n We want you to have the most current information in your browser or on your phone. No more cumbersome manual updating of spreadsheet columns!","cta":"See how can we save you time"}],"pledges":{"title":"Our values","header":"The three promises of Monestry","subheader":"Here is our promise to you.","items":[{"key":"one","header":"We will never pressure you to buy financial products from which we earn commission.","subheader":"We believe you are smart enough to be able to choose the financial products that are right for you on your own. We want to be neutral and unbiased towards any and all the products providers."},{"key":"two","header":"Users have full control of their data. We will never sell your data to anyone.","subheader":"It says so in our T&Cs, so you may rest assured that any data you entrust to us, remains under your full control."},{"key":"three","header":"We do not want to know who the users are and we provide a way for users to stay anonymous.","subheader":"We do not trade our users\' data, so we have no need to know their identities. Increase your data privacy by remaining anonymous - increase your comfort level by trusting us with more data."}]},"about":{"header":"About Monestry","body":"Monestry is a start-up company founded in 2021 in Frankfurt am Main in Germany by Piotr Loboda, a German with Polish roots. For over 20 years Piotr has been working as a professional IT architect and IT director in different companies in the financial services industry. You can find out more about Piotr here. \\n\\n Monestry is 100% funded by private German investors.\\n\\n Since its inception, Monestry GmbH is a member of the Frankfurt am Main Industry Chamber and is registered in the Frankfurt am Main Trade Register under the registry number HRB 123844. \\n\\n Monestry has been recognised and backed by grants from different public and private organisations, such as Amazon Web Services, Stripe and different SMU support funds of the European Union. \\n\\n We partnered with different organisations and companies to provide the best kind of technology solutions to our clients. Among those: GoCardless, FinAPI, Faireal, Deutsche Bundesbank, European Central Bank etc.   \\n\\n For media inquires please email media@monestry.de. \\n For commercial inquires please email partners@monestry.de."},"why-monestry":{"header":"Why \\"Monestry\\"?","body1":"We have been looking for a name which is clearly linkable to money as such, easy to understand in different countries, not too long and easy to remember. We have combed through scores and scores of names (most of them already taken) some of them internally brainstormed and some of them created with the help of artificial intelligence and finally settled on \u201CMonestry\u201D.","body2":"\u201CMonestry\u201D combines the affluence, stability and discretion of a cistercian monastry in a luscious French forrest with much more secular money which we all need to fulfil our earthly dreams. We pronounce it","body3":"MOH-neh-stree."}},"register":{"select":"Select","username":{"header":"Sign up - it\'s easy!","subheader":"Step 1 of 3. Create a Monestry account or link an existing one."},"package":{"header":"Almost there","subheader":"Step 2 of 3. Which tier would you like to start with?"},"payment":{"header":"Payment details","subheader":"Save payment details now or at the end of the free trial. No charges today!"},"processing":{"header":"Welcome to Monestry!","subheader":"Please wait while we are settings things up for you."},"paymentStillProcessed":"Your payment is still being processed.","pleaseWaitWhileWeAreSettingThingsUp":"Please wait while we are setting things up for you.","goBack":"Go back","signUp1":{"createNewAccount":"Create a new account","email":{"label":"Your email address","errorEmpty":"Please specify an email address.","errorInvalid":"Your email address does not seem valid.","errorLength":"Your email cannot be longer than 200 characters","errorTaken":"This email is unfortunately not available.","tooltip":"We would like to contact you if you need to reset your password. You can use your email to login as well."},"password":{"label":"Pick a password","hint":"Your password must be at least 8 characters long and must contain at least one of the following: capital letter, small letter, number and a punctuation character.","errorEmpty":"Please provide a password.","errorLength":"Your password cannot be longer than 99 characters","errorPattern":"Your password does not meet the requirements."},"repeatPassword":{"label":"Repeat password","errorMatch":"The repeated password is not the same as the new password."},"username":{"label":"Username","tooltip":"Please choose a username so that we know how to address you. Later, you can use your EMAIL or your USERNAME to log in.","errorRequired":"Please specify a username. We just need to how to call you.","errorLength":"Your username cannot be longer than 40 characters","errorMinLength":"Your username cannot be shorter than 5 characters","errorPattern":"You may only use letters, numbers and . - _ in your username.","errorTaken":"This username is unfortunately not available."},"country":{"label":"Country of residence","tooltip":"Why do we need to know? For tax reasons: for now we can only bill customers who tell us they reside in Germany.","Germany":"Germany"},"baseCurrency":{"label":"Base currency","tooltip":"Which currency would you like to serve as your base currency? Typically this is the currency you earn in."},"or":"or","useExistingAccount":"... or use an existing account.","useExistingAccountDescription":"You can use an existing account to register with Monestry instead of creating an account here. You will then be able to use that account every time you log in to Monestry.","signUpWith":"Sign up with"},"signUp3":{"yourOrder":"Your order","creditCard":"Credit card","crypto":"Cryptocurrencies","payNow":"Save now","payLater":"Add later","freeUntil":"Free until","afterwards":"afterwards","perMonth":" /month","day":"day","dueToday":"Billed today","dueIn30Days":"Billed on","yearBilling":"billed once a year.","monthBilling":"billed every month.","subscriptionRenewsOn":"First month is free. Your subscription will renew and bill you automatically","everyyear":"every year on the","everymonth":"every month on the","reminderEmail":"You will receive an email reminder before the free period ends.","cancelAnyTime":"Cancel any time. After cancellation your subscription will still be valid until the end of trial or the paid for period.","upgradeAnyTime":"Upgrades to a higher product tier are possible at any time.","upgradeSwitchToAnnual":"Upgrades to a higher product tier and switching to discounted annual payment are possible at any time.","externalInfo":"For your security, logging in with {{provider}} might prompt you to confirm your access more than one time."},"paymentSuccessful":{"stillProcessed":"Your payment is still being processed.","registrationSuccessful":"Registration successful","welcome":"Welcome!","thanksForOpening":"Thank you for opening an account with Monestry.","weSentYouAnEmail":"We have sent you an email to confirm your address. While you wait, why don\'t you check out short introductory video to the right?","enterCode":"Once you are ready please enter the 6-digit code from that email into the box and press the button below.","verificationCode":"Verification code","confirmAccount":"Confirm account","codeError":"This is not the correct code","genericError":"We are sorry, an unhandled error has occurred. Please email us at support@monestry.de with the email address you just used and this error message.","federated":{"accountReady":"Your account is ready. You will be able to log on with {{provider}} as requested.","addPasswordLater":"If at any time you would like to add Monestry password to your account, you can do so by resetting your password from the Login screen.","proceedToDashboard":"Proceed to dashboard"},"errorMessage":{"registrationFailed":"Registration failed","error":"Error","thankYouForOpening":"Thank you for opening an account with Monestry.","problemWithPayment":"Unfortunately there seems to be a problem with your payment. Please reach out to our support team at support@monestry.de ."}},"fallback":{"header":"Email not available","body1":"Some providers (e.g. Facebook) do not share your verified email address under some specific circumstances. We cannot create an account for you without an email address.","body2":"Please enter an email address and a password to create an account with us.","submit":"Submit","unhandledError":{"header":"We are sorry, but something went wrong","body1":"Your payment was most likely successful, but we have not been able to create your account.","body2":"Please go to our homepage and try to log in with the credentials you have just used to register. If you are not able to log in, please reach out to our support team at support@monestry.de","message":"Please send us the following error message:"}},"prep":{"header":"Creating sample data","body":"We are preparing some sample data to get you started. This should only take a few seconds.","account0":"[DEMO] My bank account","account1":"[DEMO] Brokerage cash account","account2":"[DEMO] Savings account","account3":"[DEMO] My stock broker","account4":"[DEMO] My real estate","project0":"[DEMO] Living","initialSaldo":"Initial saldo","purchaseAppleStock":"Purchase Apple stock","transactionFees":"Transaction fees","purchaseTeslaStock":"Purchase Tesla stock","accountRunningCost":"Account running cost","dividendAppleStock":"Dividend Apple stock","salary":"Salary","rentPayment":"Rent payment","creditCardBill":"Credit card bill","carRental":"Car rental","hotelBill":"Hotel bill","interestPayment":"Interest payment","otherParty":"Other party"},"code":{"label":"Registration code","link":"Have a registration code?","errorInvalid":"This code is not valid."}},"requestDemo":{"topheader":"Before you start","Ready to set up your demo":"Ready to start your demo?","header1":"We would like to get to know our potential users better.","header2":"Would you mind answering four simple questions?","numberOfAccounts":{"label":"How many different financial products do you have worldwide?","sublabel":"Including bank accounts, brokerage accounts, pension accounts, etc.","options":["0 - 5","6 - 10","11 - 20","20+"]},"incomeSaved":{"label":"What percentage of your income is your household able to save or invest?","options":["<10%","10% - 20%","20% - 30%","30% - 40%","40% - 50%",">50%"]},"age":{"label":"How old are you?","options":["<25","26-35","36-45","46-55","56-65","65+"]},"workplace":{"label":"Where do you work?","options":["Large company (more than 10k employees)","Small/medium company (up to 10k employees)","I own a company","I am self-employed"]},"howCanWeHelp":{"label":"How do you think Monestry can help you? (optional)"},"Cancel":"Cancel","Start demo":"Start demo","weAreSettingThingsUp":"Please wait while we are preparing your demo account."},"cookies":{"title":"Cookies","description":"We use both necessary and optional cookies on our website to operate and continuously improve our app. Your consent includes all pre-selected/selected cookies as well as the associated storage and loading of information on your device and subsequent loading and processing of personal data.","noTracking":"We do not serve ads nor use any cookies for tracking purposes (these are those which link data from this app to 3rd party data about the user).","legalBasis":"The legal basis for consent regarding the storage and loading of information is \xa7 25 para. 1 TTDSG, and regarding the processing of personal data, Art. 6 para. 1 lit. a GDPR.","settingsInfo":"You can accept non-essential cookies (\'Accept all\') or reject them (\'Only essential\'). Your settings can be modified at any time via a link in the footer of our website.","privacyPolicy":"Further information on the procedures used and your rights can be found in our privacy policy.","onlyEssential":"Only essential","customise":"Customise","acceptAll":"Accept all","customiseTitle":"Customise cookies","customiseSubtitle":"You can customise the cookies you want to allow on this website.","essential":{"label":"Essential","description":"These cookies are necessary for the website to function properly."},"marketing":{"label":"Marketing","description":"These cookies are used to provide you with personalised offers and content."},"analytics":{"label":"Analytics","description":"These cookies help us understand how the users use our App and make the user experience better."},"externalMedia":{"label":"External media","description":"These cookies allow us to show you external media such as YouTube videos into our App."},"save":"Save","goBack":"Go back"},"contact":{"header":"Contact us","subheader":"How may we help you?","goToLogin":"Log in","goToDashboard":"Go to dashboard","emailUs":"Email us","prospects":{"header":"Product questions","body":"If you have any questions about our product, please email us at support@monestry.de"},"users":{"header":"Feedback | bugs | ideas","body":"If you have any feedback, ideas or you found a bug, please use the Feedback button which shows up in the bottom-right corner of the screen once you have logged in."},"dataPrivacy":{"header":"Delete account | data privacy requests","body":"You can cancel your account in the app, but you can also email us at support@monestry.de . You can use the same email for any data-privacy-related requests."},"partners":{"header":"Partnerships","body":"If you have a partnership idea and would like to discuss it with us, please reach out to us at partners@monestry.de"},"media":{"header":"Media inquiries","body":"If you are a journalist and would like to write about us, please email us at media@monestry.de"}}}');


var $89436ef397ee86a7$exports = {};
$89436ef397ee86a7$exports = JSON.parse('{"general":{"loginFailed":"Deine Logindaten waren falsch. Bitte versuche es erneut.","refreshTokenExpired":"Du bist aus Sicherheitsgr\xfcnden ausgeloggt worden. Bitte logge dich erneut ein.","open":"\xd6ffnen","error":"Fehler","cancel":"Abbrechen","close":"Schliessen","save":"Speichern"},"validationErrors":{"genericError":"Dieser Wert kann nicht gespeichert werden."},"schema":{"transactions":"Transaktionen","accounts":"Konten","projects":"Projekte","reports":"Reports","blog":"Blog","pleaseEnterValue":"Bitte gib einen neuen Wert f\xfcr dieses Attribut ein.","transactionTypes":{"sale":"Kauf","purchase":"Verkauf","split":"Split"},"deposits":{"transaction":{"ownName":"Transaktion","date":{"label":"Datum","description":"Transaktionsdatum."},"otherParty":{"label":"Transaktionspartei","description":"Sender oder Empf\xe4nger der Transaktion."},"otherPartyAccount":{"label":"Kontonummer","description":"IBAN (Kontonr.) des Senders oder Empf\xe4ngers der Transaktion."},"description":{"label":"Beschreibung","description":"Transaktionsbeschreibung."},"amount":{"label":"Betrag","description":"Betrag dieser Transaktion in deiner Basisw\xe4hrung."},"accountCurrencyAmount":{"label":"Betrag","description":"Betrag dieser Transaktion in der W\xe4hrung dieses Kontos."},"currency":{"label":"Kontow\xe4hrung","description":"Die W\xe4hrung, in der dieses Konto gef\xfchrt wird."},"fxAmount":{"label":"Fremdw\xe4hrungsbetrag","description":"Optional. Wenn die Transaktion urspr\xfcnglich in einer Fremdw\xe4hrung erfolgt ist, dann der Fremdw\xe4hrungsbetrag geh\xf6rt hierhin."},"fxCurrency":{"label":"Fremdw\xe4hrungs-Code","description":"Optional. Wenn die Transaktion urspr\xfcnglich in einer Fremdw\xe4hrung erfolgt ist, dann hier geh\xf6rt das 3-stellige W\xe4hrungssymbol."},"simulated":{"label":"Simulierte Transaktion","description":"Ein Zeichen in dieser Spalte bedeutet, dass dies eine fiktive (simulierte) Transaktion ist, die in der Zukunft stattfindet."},"incomeFromInterest":{"label":"Kapitaleinkommen","description":"Ein Etikett in dieser Spalte bedeutet, dass die Transaktion zu Kapitaleinkommen geh\xf6rt."}},"account":{"ownName":"Bankkonto","name":"Bankname","country":"Land","accountName":{"label":"Kontoname","tooltip":"Unter welchem Namen m\xf6chtest du dieses Konto im System sehen?","error":"Bitte gebe eine Bezeichnung f\xfcr dieses Konto ein."},"baseCurrency":{"label":"Basisw\xe4hrung","tooltip":"Welche W\xe4hrung m\xf6chtest du als Basisw\xe4hrung verwenden? In der Regel ist dies die W\xe4hrung, in der du verdienst."},"iban":{"label":"IBAN","tooltip":"Die IBAN-Nummer dieses Kontos. Beginnt mit einem Land-K\xfcrzel z.B. >DE< f\xfcr Deutschland.","placeholder":"DE12345678901234567890"},"bic":{"label":"BIC","tooltip":"Internationaler Bankcode (genannt >BIC<) f\xfcr die Bank, bei der dieses Konto gef\xfchrt wird. Bis zu 11 Zeichen lang. Dient zur Identifikation einer Bank im internationalen Kontext."},"bankName":{"label":"Bankname","tooltip":"Name der Bank, bei der dieses Konto gef\xfchrt wird.","placeholder":"Sparkasse Bielefeld"},"syncType":{"label":"Synchronisation","tooltip":"Wie sollen die Daten f\xfcr dieses Konto synchronisiert werden?","placeholder":"W\xe4hle eine Option"},"depositType":{"label":"Kontoart","tooltip":"Tagesgeld oder Girokonto?","placeholder":"W\xe4hle eine Option"},"countryCode":{"label":"Land","tooltip":"In welchem Land befindet sich dieses Konto?","placeholder":"W\xe4hle ein Land"},"category":{"label":"Kategorie","tooltip":"Welcher Anlagekategorie geh\xf6rt dieses Konto an?","placeholder":"W\xe4hle eine Option"},"parameters":{"syncType":{"manual":"Manuell","automatic":"Automatisch"},"depositType":{"savings-account":"Giro","time-deposit":"Fest- / Tagesgeld"}}}},"stocks":{"transaction":{"date":{"label":"Datum","description":"Datum der Transaktion."},"displaySymbol":{"label":"Wertpapiersymbol*","description":"Symbol des gehandelten Wertpapiers, wie ISIN, WKN oder CUSIP. Optionalfeld."},"displayName":{"label":"Wertpapiername","description":"Name des Aktienwertpapiers."},"transactionAmount":{"label":"Menge","description":"Anzahl der gekauften oder verkauften Wertpapiere."},"transactionPrice":{"label":"Preis (Basisw\xe4hrung)","description":"Einheitspreis, bezahlt in Ihrer Basisw\xe4hrung."},"transactionCurrency":{"label":"W\xe4hrung","description":"W\xe4hrung der Transaktion."},"transactionOriginalPrice":{"label":"Preis (Transaktionsw\xe4hrung)","description":"Einheitspreis, bezahlt in Transaktionsw\xe4hrung."}},"account":{"brokerName":{"label":"Brokername","tooltip":"Bei welchem Broker ist dieses Konto?","placeholder":"DepotX"},"isImported":{"label":"Dieses Konto wird erstellt.","tooltip":"Entferne das H\xe4kchen, um zu verhindern, dass dieses Konto erstellt wird."},"accountNo":{"label":"Depotnummer","tooltip":"Welche Nummer tr\xe4gt dein Depot?","placeholder":"C12345678"},"username":{"label":"Username","tooltip":"Wie lautet dein Username bei diesem Broker?","placeholder":"user01"},"syncType":{"label":"Synchronisierung","tooltip":"Wie sollen die Daten f\xfcr dieses Konto synchronisiert werden?","placeholder":"W\xe4hle eine Option"},"ownCurrentAccount":{"label":"Verkn\xfcpftes Girokonto (IBAN)","tooltip":"Welches Girokonto ist mit diesem Depot verkn\xfcpft?","placeholder":"DE12345678901234567890"},"countryCode":{"label":"Land","tooltip":"In welchem Land befindet sich dieses Konto?","placeholder":"W\xe4hle ein Land"},"connectedDepositAccounts":{"label":"Verlinkte Bankkonten","tooltip":"Auf welche Bankkonten flie\xdfen Erl\xf6se aus diesem Konto?"}}},"meta-comment":"the entries below are realEstate quotes, but this is only used in import of quotes, so leaving it be for now","realEstate":{"transaction":{"date":{"label":"Datum","description":"Datum der Bewertung."},"currency":{"label":"W\xe4hrung","description":"Die W\xe4hrung der Bewertung."},"quote":{"label":"Preis","description":"Bewertung in dieser W\xe4hrung."},"quoteBaseCurrency":{"label":"Preis (Basisw\xe4hrung)","description":"Bewertung in Ihrer Basisw\xe4hrung."}},"account":{"kindOfProperty":"Um was f\xfcr eine Immobilie handelt es sich?","connectedDepositAccounts":{"label":"Verlinkte Bankkonten","tooltip":"Auf welche Bankkonten flie\xdfen Erl\xf6se aus diesem Konto?"},"valuationParameters":{"type":{"label":"Haus oder Wohnung"},"subtype":{"label":"Art der Immobilie","description":"Was f\xfcr Haus / Wohnung ist es?","tooltip":"Welche Art von Geb\xe4ude / Wohnung ist das hier?"},"streetAddress":{"label":"Stra\xdfe und Nummer","tooltip":"Wo befindet sich deine Immobilie?","placeholder":"Hochstr. 12"},"zip":{"label":"Postleitzahl","tooltip":"Welche Postleitzahl hat deine Immobilie?","placeholder":"33602","error":"Bitte trage eine Postleitzahl ein."},"district":{"label":"Ort / Stadtteil","tooltip":"F\xfcr Immobilien in Stadtkreisen verwende bitte hier den Stadtteil. F\xfcr Immobilien in Landkreisen verwende bitte hier den Ort (ggf. Kernstadt) und KEINEN Stadtteil.","placeholder":"Mitte"},"city":{"label":"Stadtkreis / Landkreis","tooltip":"In welchem Stadt- oder Landkreis befindet sich deine Immobilie?","placeholder":"Bielefeld","error":"Bitte trage einen Stadtkreis oder Landkreis ein."},"countryCode":{"label":"Land","tooltip":"In welchem Land befindet sich deine Immobilie?","placeholder":"Deutschland","error":"Bitte trage ein Land ein."},"completeArea":{"label":"Nutzfl\xe4che","tooltip":"Wie gro\xdf ist deine gesamte Immobilie (in m\xb2)?","placeholder":"100"},"livingArea":{"label":"Wohnfl\xe4che","tooltip":"Wie gro\xdf ist die Wohnfl\xe4che der Immobilie (in m\xb2)?","placeholder":"88","error":"Bitte trage die Wohnfl\xe4che ein."},"floor":{"label":"Etage","tooltip":"In welcher Etage liegt die Immobilie?","placeholder":"3"},"totalFloors":{"label":"Anzahl Stockwerke","tooltip":"Wie viele Stockwerke hat das Geb\xe4ude insgesamt?","placeholder":"4"},"rooms":{"label":"Zimmer","tooltip":"Wie viele Zimmer hat deine Immobilie?","placeholder":"3"},"flooring":{"label":"Fu\xdfboden","tooltip":"Welche Art von Fu\xdfboden hat deine Immobilie?"},"interiorLevel":{"label":"Ausstattungsniveau","tooltip":"Wie hochwertig ist die Ausstattung deiner Immobilie?"},"condition":{"label":"Zustand","tooltip":"Wie ist der aktueller Zustand deiner Immobilie zu bewerten?"},"lotArea":{"label":"Grundst\xfccksfl\xe4che","tooltip":"Wie gro\xdf ist das Grundst\xfcck, auf dem sich deine Immobilie befindet (in Quadratmetern)?","placeholder":"450"},"constructionYear":{"label":"Baujahr","tooltip":"Wann wurde deine Immobilie gebaut?","placeholder":"2010"},"energyClass":{"label":"Energieverbrauch","tooltip":"J\xe4hrlicher Energieverbrauch in kWh/m\xb2. Wenn dir nur die Energieeffizienzklasse vorliegt, trage den Durchschnittwert f\xfcr diese Klasse ein.","placeholder":60},"heatingType":{"label":"Heizung","tooltip":"Welche Art von Heizung hat deine Immobilie?"},"floorHeating":{"label":"Fu\xdfbodenheizung?","tooltip":"Ist Fu\xdfbodenheizung vorhanden?"},"lastRenovationYear":{"label":"Letzte Renovierung","tooltip":"Wann wurde deine Immobilie zuletzt renoviert?","placeholder":"2020"},"privateParkingSpaces":{"label":"Stellpl\xe4tze","tooltip":"Wie viele reservierte Stellpl\xe4tze gibt es f\xfcr deine Immobilie?","placeholder":1},"garden":{"label":"Garten?","tooltip":"Hat deine Immobilie einen Garten?"},"bathTub":{"label":"Badewanne?","tooltip":"Gibt es in der Immobilie eine Badewanne?"},"bathWithWindows":{"label":"Tageslichtbad","tooltip":"Gibt es in der Immobilie ein Bad mit Fenster?"},"fullHeightWindows":{"label":"Bodentiefe Fenster?","tooltip":"Gibt es in der Immobilie bodentiefe Fenster?"}},"parameters":{"meta-comment":"these are also used in Real Estate API - change them there as well if changing them here","type":{"apartment":"Wohnung","building":"Geb\xe4ude"},"subtype":{"building":{"farm":"Bauernhof","special-building":"Sondergeb\xe4ude","bungalow":"Bungalow","castle":"Schloss","semi-detached":"Doppelhaush\xe4lfte","detached":"Einfamilienhaus","apartment-building":"Mehrfamilienhaus","terraced":"Reihenhaus","terraced-corner":"Eckreihenhaus","villa":"Villa","other":"Andere"},"apartment":{"top-floor":"Dachgeschoss","ground-floor":"Erdgeschoss","other-floor":"Anderes Geschoss","high-ground-floor":"Hochparterre","loft":"Loft","two-levels":"Maisonette","penthouse":"Penthouse","souterrain":"Souterrain","with-balcony":"Terrassenwohnung","other":"Andere"}},"interiorLevel":{"simple":"Einfach","normal":"Normal","high":"Gehoben","luxus":"Luxus"},"condition":{"new":"Erstbezug","newly-renovated":"Erstbezug nach Sanierung","well-maintained":"Gepflegt","modernized":"Modernisiert","flexible":"Nach Vereinbarung","like-new":"Neuwertig","needs-renovation":"Renovierungsbed\xfcrftig","refurbished":"Saniert","completely-renovated":"Vollst\xe4ndig renoviert","needs-repair":"Abbruchreif"},"heatingType":{"gas":"Gas","oil":"\xd6l","electricity":"Elektrisch","district":"Fernw\xe4rme","wood":"Holz","coal":"Kohle","solar":"Solar","block":"Blockheizung","stock":"Stockheizung","floor":"Fu\xdfbodenheizung","nachtspeicher":"Nachtspeicherheizung","w\xe4rmekraft":"W\xe4rmekraft","central":"Zentral"},"flooring":{"carpet":"Teppich","parquet":"Parkett","tiles":"Fliesen","laminate":"Laminat","floorboards":"Dielen"}}},"quote":{"label":"Preis","description":"Bewertung in dieser W\xe4hrung."},"quoteBaseCurrency":{"label":"Preis (Basisw\xe4hrung)","description":"Bewertung in deiner Basisw\xe4hrung."},"note":{"label":"Notiz","description":"Optional. Alle Bewertungsdetails, die du m\xf6glicherweise aufzeichnen m\xf6chtest."}},"loans":{"account":{"parameters":{"type":{"annuity":"Feste Rate (Annuit\xe4t)","fixedPrincipal":"Variable Rate (fester Kapitalr\xfcckzahlungsbetrag)","interestOnly":"Nur Zinsen"},"period":{"month":"Monatlich","quarter":"Viertelj\xe4hrlich","year":"J\xe4hrlich","annual":"J\xe4hrlich"},"direction":{"taken":"Empfangen","granted":"Gegeben","received":"Kredit aufgenommen"}},"type":{"label":"Darlehenstyp","tooltip":"Um welche Art von Darlehen handelt es sich? Annuit\xe4t, feste Kapitalr\xfcckzahlung usw.","placeholder":"Darlehenstyp ausw\xe4hlen","error":"Darlehenstyp ist falsch."},"direction":{"label":"Gegeben or empfangen?","tooltip":"Hast du das Darlehen gegeben oder empfangen?","error":"Darlehensart ist falsch."},"loanAmount":{"label":"Darlehensbetrag","tooltip":"Wie viel Geld hast du geliehen? Empfangene Darlehen sind negativ, gegebene Darlehen sind positiv.","placeholder":"-100000","error":"Bitte den Darlehensbetrag eingeben."},"interestRate":{"label":"Zinssatz","tooltip":"Wie hoch ist der Zinssatz deines Darlehens? \xc4nderungen w\xe4hernd der Laufzeit sind m\xf6glich.","error":"Bitte den Zinssatz eingeben."},"period":{"label":"Ratenfrequenz","tooltip":"Wie oft machst du R\xfcckzahlungen? \xc4nderungen w\xe4hernd der Laufzeit sind m\xf6glich.","error":"Bitte den frequenz eingeben."},"bankName":{"label":"Bankname","tooltip":"Die IBAN (Kontonummer) des Kontos (Darlehenskontos).","placeholder":"DE12345678901234567890"},"iban":{"label":"IBAN","tooltip":"Die IBAN-Nummer dieses Kontos. Beginnt mit einem Land-K\xfcrzel z.B. >DE< f\xfcr Deutschland.","placeholder":"DE12345678901234567890"},"percentRepaidAnnually":{"label":"Tilgung","tooltip":"Wie viel des Darlehens tilgst du j\xe4hrlich? \xc4nderungen w\xe4hernd der Laufzeit sind m\xf6glich.","error":"Bitte die Tilgungsrate eingeben."},"contractEndDate":{"label":"Enddatum des Darlehens","tooltip":"Wann endet der Darlehensvertrag?","error":"Bitte das Enddatum des Vertrags eingeben."},"connectedDepositAccounts":{"label":"Verbundenes Bankkonto/Konten","tooltip":"Welche(s) Bankkonto/Konten t\xe4tigt und empf\xe4ngt Zahlungen f\xfcr dieses Darlehen?"},"interestCalcMonthEnd":{"label":"Werden Zinsen am Monatsende berechnet?","tooltip":"Wenn deine Bank Zinsen am Monatsende berechnet, w\xe4hle >ja<."},"connectedProjectId":{"label":"Verbundenes Projekt","tooltip":"Welches Projekt zeigt den simulierten Tilgungsplan f\xfcr dieses Darlehen?"}},"transaction":{"ownName":"Transaktion","date":{"label":"Datum","description":"Datum der Transaktion."},"otherPartyIban":{"label":"Darlehenkonto","description":"Optional. IBAN (Kontonummer) deines Darlehenskontos."},"description":{"label":"Beschreibung","description":"Optional. Beschreibung der Transaktion."},"quantity":{"label":"Kapitalanteil","description":"Der Kapitalanteil dieser R\xfcckzahlung in deiner Kontow\xe4hrung."},"quantityInterest":{"label":"Zinsanteil","description":"Der Zinsanteil dieser R\xfcckzahlung in deiner Kontow\xe4hrung."}}},"pension":{"account":{"parameters":{"useSpecialQuote":{"payoutOnlyContributionsToDate":"Rente (nur Beitr\xe4ge bis heute)","payoutOnlyContributionsToDateIndexed":"Rente (nur Beitr\xe4ge bis heute, mit Wertentwicklung)","payoutAllPlannedContributions":"Rente (alle zuk\xfcnftigen Beitr\xe4ge)","payoutAllPlannedContributionsIndexed":"Rente (alle zuk\xfcnftigen Beitr\xe4ge, mit Wertentwicklung)","payoutLumpSumVerrentet":"Einmalzahlung umgewandelt in Rente"},"contributionsFrequency":{"0":"Einmalig","1":"Monatlich","3":"Viertelj\xe4hrlich","12":"J\xe4hrlich"},"payoutsFrequency":{"0":"Einmalig","1":"Monatlich","3":"Viertelj\xe4hrlich","12":"J\xe4hrlich"},"frequencyUnit":{"0":"unbegrenzt","1":"Monate","12":"Jahre"}},"product":"Rentenprodukt","connectedDepositAccounts":{"label":"Verbundene Bankkonten","tooltip":"Welche Bankkonten senden und empfangen Zahlungen f\xfcr dieses Rentenprodukt?"},"connectedDepositMode":{"error":"Bitte w\xe4hle hier eine Option aus."},"productPurchaseDate":{"label":"Kaufdatum","tooltip":"Wann begann der Vertrag? Dieses Datum muss nicht sehr genau angegeben sein, wir verwenden es, um dir die Wert\xe4nderungen seit dem Kauf anzuzeigen.","error":"Bitte gebe ein (ungef\xe4hres) Datum ein.","errorInvalid":"Bitte gebe ein g\xfcltiges Datum ein.","errorFuture":"Dieses Datum darf nicht in Zukunft liegen."},"initialQuotes":{"label":"Anf\xe4ngliche Auszahlungssch\xe4tzungen","tooltip":"Was waren die anf\xe4nglichen Auszahlungssch\xe4tzungen, die dir bei Vertragsabschluss gegeben wurden?","error":"Anf\xe4ngliche Auszahlungssch\xe4tzungen fehlen"},"contributionsSelfPaid":{"label":"Beitr\xe4ge selbst gezahlt?","tooltip":"Stelle dies auf JA, wenn du die Beitr\xe4ge zahlst. Wenn es dein Arbeitgeber ist, stelle es auf NEIN.","error":"Angabe erforderlich, ob Beitr\xe4ge selbst gezahlt sind"},"contributionsAmounts":{"label":"Beitragsh\xf6he","placeholder":100,"tooltip":"Gib die Beitragsh\xf6he ein (wenn selbst gezahlt). Du kannst sp\xe4ter unterschiedliche Betr\xe4ge f\xfcr verschiedene Zeitr\xe4ume festlegen.","error":"Bitte gebe die (ungef\xe4hre) Beitragsh\xf6he ein."},"contributionsFrequency":{"label":"Beitr\xe4gesfrequenz","tooltip":"Wie oft zahlst du Beitr\xe4ge zu diesem Produkt?","error":"Beitragsfrequenz nicht festgelegt"},"contributionsDeductible":{"label":"Sind Beitr\xe4ge steuerlich absetzbar?","tooltip":"D\xfcrfen die Beitr\xe4ge f\xfcr dieses Produkt steuerlich angesetzt werden?","error":"Bitte gebe die Information hier ein."},"contributionsIndexed":{"label":"\xc4ndern sich die Beitr\xe4ge \xfcber die Zeit?","tooltip":"Werden die Beitr\xe4ge im Zeitverlauf angepasst? Aktiviere dies, um sie mit der Inflation oder einem eigenen Zinssatz fortzuschreiben.","error":"Angabe zur Beitragsentwicklung fehlt."},"payoutsPhaseStart":{"label":"Beginn der Auszahlungsphase","tooltip":"Wann findet die erste Auszahlung statt? Wir brauchen hier lediglich ein ungef\xe4hres Datum, das sp\xe4ter noch angepasst werden kann. Dieses Datum wird zur Darstellung der k\xfcnftigen Auszahlungen verwendet.","error":"Bitte gebe hier ein Datum ein."},"payoutsFrequency":{"label":"Auszahlungsfrequenz","tooltip":"Handelt es sich um eine monatliche, viertelj\xe4hrliche, j\xe4hrliche oder einmalige Auszahlung?","error":"Auszahlungsfrequenz nicht festgelegt"},"payoutsDuration":{"label":"Dauer der Auszahlungsphase","tooltip":"Wie lange werden die Auszahlungen geleistet? Gebe die Anzahl der Monate an (12 f\xfcr ein Jahr, 120 f\xfcr zehn Jahre usw.). Bei lebenslangen Auszahlungen gebe \'0\' ein.","error":"Dauer der Auszahlungen nicht festgelegt"},"payoutsTaxable":{"label":"Auszahlungen steuerpflichtig?","tooltip":"Ist die Auszahlung steuerpflichtig?","error":"Steuerpflicht der Auszahlung nicht angegeben"},"payoutsIndexed":{"label":"Auszahlungen mit Wertentwicklung?","tooltip":"Wird der Auszahlungsbetrag \xfcber die Zeit angepasst? Aktiviere dies, um die Auszahlungen mit Inflation oder einem eigenen Satz zu indexieren.","error":"Wachstum der Auszahlung nicht festgelegt"},"discountRateIsInflation":{"label":"Inflationsrate zur Wertentwicklung verwenden?","tooltip":"W\xe4hle JA, um die Inflationsrate zu nutzen, um Wachstum von Auszahlungen / Beitr\xe4gen / aktuellen Wert zu berechnen. W\xe4hle NEIN, um einen eigenen Indexsatz anzugeben.","error":"Bitte w\xe4hle, wie die Werte in diesem Konto indexiert werden sollen."},"customDiscountRate":{"label":"Eigener Indexsatz (%)","tooltip":"J\xe4hrlicher Prozentsatz zur Indexierung von Beitr\xe4gen/Auszahlungen.","error":"Bitte gib einen eigenen Indexsatz f\xfcr Beitr\xe4ge an.","placeholder":2},"useSpecialQuote":{"label":"Berechnung des Produktwerts","tooltip":"Welche Rentensch\xe4tzung sollen wir verwenden, um den Barwert dieses Rentenprodukts zu berechnen?","error":"Rentensch\xe4tzung nicht angegeben"},"discountRate":{"label":"Produktszinssatz","tooltip":"Zinssatz, der verwendet wird, um den Barwert dieses Produkts sowie dessen zuk\xfcnftiges Wachstum zu berechnen, falls vorhanden. Lasse ihn offen, um den in den Einstellungen angegebenen Inflationszinssatz zu verwenden.","error":"Produktszinssatz nicht festgelegt","placeholder":2.3},"fxRate":{"label":"Heutiges Wechselkurs von {{accountCurrency}} zu {{baseCurrency}}:","tooltip":"Um es einfach zu halten, wir empfehlen die Verwendung von aktuellem Wechselkurs. Du kannst gerne einen anderen Wechselkurs anwenden, den f\xfcr dich langfristig besser geeignet ist.","apply":"Alles automatisch zu {{baseCurrency}} umrechnen zum Kurs "}},"transaction":{"date":{"label":"Datum","description":"An welchem Datum hat das Institut diese neue Bewertung kommuniziert?"},"currency":{"label":"W\xe4hrung","description":"Die W\xe4hrung der Bewertung."},"payoutOnlyContributionsToDate":{"label":"Rente (nur Beitr\xe4ge bis heute)","description":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du heute die Beitr\xe4ge einstellst."},"payoutOnlyContributionsToDateIndexed":{"label":"Rente (nur Beitr\xe4ge bis heute, mit Wertentwicklung)","description":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du heute die Beitr\xe4ge einstellst, mit zuk\xfcnftiger Wertentwicklung bereits angelegtes Kapitals."},"payoutAllPlannedContributions":{"label":"Rente (alle zuk\xfcnftigen Beitr\xe4ge)","description":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du die Beitr\xe4ge bis der Ende der Ansparphase zahlst."},"payoutAllPlannedContributionsIndexed":{"label":"Rente (alle zuk\xfcnftigen Beitr\xe4ge, mit Wertentwicklung)","description":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du die Beitr\xe4ge bis der Ende der Ansparphase zahlst, mit zuk\xfcnftiger Wertentwicklung bereits angelegtes Kapitals."},"payoutLumpSumVerrentet":{"label":"Einmalzahlung in lebenslange Rente umwandeln","description":"Das angesparte Kapital wird in eine lebenslange Rente umgerechnet."}}},"objectsOfValue":{"account":{"connectedDepositAccounts":{"label":"Verbundene Bankkonten","tooltip":"Welche Bankkonten erhalten Erl\xf6se aus den Verm\xf6genswerten dieses Kontos?"},"name":{"label":"Objektname","tooltip":"Unter welchem Namen soll dieses Objekt angezeigt werden?","placeholder":"Mercedes 450 SEL","error":"Bitte gib den Objektnamen an."},"currency":{"label":"Kontow\xe4hrung","tooltip":"Welche W\xe4hrung wird f\xfcr Beitr\xe4ge und Auszahlungen dieses Rentenprodukts verwendet?"},"userInputPurchaseDate":{"label":"Kaufdatum","tooltip":"Wann hast du dieses Objekt gekauft?","error":"Bitte gib das Kaufdatum an."},"userInputPurchaseValueAccountCurrency":{"label":"Kaufpreis in {{currency}}","tooltip":"Wie viel hast du f\xfcr dieses Objekt bezahlt?","error":"Bitte gib den Kaufpreis an."},"userInputPurchaseValueBaseCurrency":{"label":"Kaufpreis in {{currency}}","tooltip":"Wie viel hast du f\xfcr dieses Objekt bezahlt?","error":"Bitte gib den Kaufpreis an."},"fxRate":{"label":"Wechselkurs von {{accountCurrency}} zu {{baseCurrency}} am {{date}} war","tooltip":"Zu deiner Bequemlichkeit haben wir den Wechselkurs am von dir angegebenen Tag nachgeschlagen.","apply":"Kaufpreis in {{baseCurrency}} berechnen"},"quantity":{"label":"Gekaufte Menge","tooltip":"Falls hier zutreffend, wie viele Objekte hast du zuerst gekauft? Standardwert ist 1."}}},"metals":{"account":{"connectedDepositAccounts":{"label":"Verbundene Bankkonten","tooltip":"Welche Bankkonten erhalten Erl\xf6se aus den Verm\xf6genswerten dieses Kontos?"},"name":{"label":"Kontoname","tooltip":"Unter welchem Namen soll dieses Konto angezeigt werden?","placeholder":"Tresor","error":"Bitte gib den Kontonamen an."},"currency":{"label":"Kontow\xe4hrung","tooltip":"Welche W\xe4hrung wird f\xfcr Beitr\xe4ge und Auszahlungen dieses Kontos verwendet?"}},"transaction":{"parameters":{"assetMetal":{"gold":"Gold","silver":"Sibver","platinum":"Platin","palladium":"Palladium","other":"anderes"}}}},"unlistedShares":{"account":{"connectedDepositAccounts":{"label":"Verbundene Bankkonto(s)","tooltip":"Welche Bankkonto(s) erhalten Erl\xf6se aus den Verm\xf6genswerten dieses Kontos?","error":"Bitte w\xe4hle eine Option aus"},"connectedDepositMode":{"error":"Bitte w\xe4hle eine Option aus"},"name":{"label":"Kontoname","tooltip":"Wie hei\xdft die Firma?","placeholder":"Meine Firma","error":"Bitte gebe einen Namen an"},"currency":{"label":"Kontow\xe4hrung","tooltip":"In welcher W\xe4hrung sollen die Firmenbewertung in diesem Konto gehalten werden?"},"date":{"label":"Unternehmensgr\xfcndungsdatum","tooltip":"Wann wurde das Unternehmen gegr\xfcndet? Ein ungef\xe4hres Datum gen\xfcgt.","error":"Bitte trage ein Datum ein"},"upac":{"label":"Startkapital","tooltip":"Wie viel Startkapital hast du in das Unternehmen investiert?","placeholder":25000,"error":"Bitte trage einen Wert ein"},"upbc":{"label":"Startkapital (Basisw\xe4hrung)","tooltip":"Wie viel Startkapital ist das in deiner Basisw\xe4hrung?","placeholder":25000,"error":"Bitte trage einen Wert ein"},"quantity":{"label":"Anzahl der Aktien","tooltip":"Wie viele Aktien deiner Firma hast du gekauft? Wenn du nicht sicher bist, gebe 1 ein.","placeholder":1,"error":"Bitte trage einen Wert ein"}}},"crypto":{"account":{"connectedDepositAccounts":{"label":"Verbundene Bankkonten","tooltip":"Welche Bankkonten erhalten Erl\xf6se aus den Verm\xf6genswerten dieses Kontos?"},"name":{"label":"Kontoname","tooltip":"Unter welchem Namen soll dieses Konto angezeigt werden?","placeholder":"Tresor","error":"Bitte gib den Kontonamen an."},"brokerName":{"label":"Provider","tooltip":"Bei welcher B\xf6rse / welchem Broker ist dieses Konto?","placeholder":"Binance"},"accountNo":{"label":"Konto-ID","tooltip":"Welche ID (Nummer / Kennung) hat dieses Konto?","placeholder":"C12345678"}}}},"countryNames":{"Afghanistan":"Afghanistan","Albania":"Albanien","Algeria":"Algerien","Andorra":"Andorra","Angola":"Angola","Antigua & Barabuda":"Antigua und Barbuda","Argentina":"Argentinien","Armenia":"Armenien","Australia":"Australien","Austria":"\xd6sterreich","Azerbaijan":"Aserbaidschan","Bahamas":"Bahamas","Bahrain":"Bahrain","Bangladesh":"Bangladesch","Barbados":"Barbados","Belarus":"Wei\xdfrussland","Belgium":"Belgien","Belize":"Belize","Benin":"Benin","Bhutan":"Bhutan","Bolivia":"Bolivien","Bosnia Herzegovina":"Bosnien und Herzegowina","Botswana":"Botsuana","Brazil":"Brasilien","Brunei":"Brunei","Bulgaria":"Bulgarien","Burkina":"Burkina Faso","Burundi":"Burundi","Cambodia":"Kambodscha","Cameroon":"Kamerun","Canada":"Kanada","Cape Verde":"Kap Verde","Central African":"Zentralafrikanische Republik","Chad":"Tschad","Chile":"Chile","China":"China","Colombia":"Kolumbien","Comoros":"Komoren","Congo":"Republik Kongo","Democratic Rep. of Congo":"Demokratische Republik Kongo","Costa Rica":"Costa Rica","Croatia":"Kroatien","Cuba":"Kuba","Cyprus":"Zypern","Czechia":"Tschechien","Denmark":"D\xe4nemark","Djibouti":"Dschibuti","Dominica":"Dominica","Dominican Republic":"Dominikanische Republik","East Timor":"Osttimor","Ecuador":"Ecuador","Egypt":"\xc4gypten","El Salvador":"El Salvador","Equatorial Guinea":"\xc4quatorialguinea","Eritrea":"Eritrea","Estonia":"Estland","Ethiopia":"\xc4thiopien","Fiji":"Fidschi","Finland":"Finnland","France":"Frankreich","Gabon":"Gabun","Gambia":"Gambia","Georgia":"Georgien","Germany":"Deutschland","Ghana":"Ghana","Greece":"Griechenland","Grenada":"Grenada","Guatemala":"Guatemala","Guinea":"Guinea","Guinea Bissau":"Guinea-Bissau","Guyana":"Guyana","Haiti":"Haiti","Honduras":"Honduras","Hungary":"Ungarn","Iceland":"Island","India":"Indien","Indonesia":"Indonesien","Iran":"Iran","Iraq":"Irak","Ireland":"Irland","Israel":"Israel","Italy":"Italien","Ivory Coast":"Elfenbeink\xfcste","Jamaica":"Jamaika","Japan":"Japan","Jordan":"Jordanien","Kazakhstan":"Kasachstan","Kenya":"Kenia","Kiribati":"Kiribati","Kosovo":"Kosovo","Kuwait":"Kuwait","Kyrgyzstan":"Kirgisistan","Laos":"Laos","Latvia":"Lettland","Lebanon":"Libanon","Lesotho":"Lesotho","Liberia":"Liberia","Libya":"Libyen","Liechtenstein":"Liechtenstein","Lithuania":"Litauen","Luxembourg":"Luxemburg","Macedonia":"Nordmazedonien","Madagascar":"Madagaskar","Malawi":"Malawi","Malaysia":"Malaysia","Maldives":"Malediven","Mali":"Mali","Malta":"Malta","Marshall Islands":"Marshallinseln","Mauritania":"Mauretanien","Mauritius":"Mauritius","Mexico":"Mexiko","Micronesia":"Mikronesien","Moldova":"Moldawien","Monaco":"Monaco","Mongolia":"Mongolei","Montenegro":"Montenegro","Morocco":"Marokko","Mozambique":"Mosambik","Myanmar":"Myanmar","Namibia":"Namibia","Nauru":"Nauru","Nepal":"Nepal","Netherlands":"Niederlande","New Zealand":"Neuseeland","Nicaragua":"Nicaragua","Niger":"Niger","Nigeria":"Nigeria","North Korea":"Nordkorea","Norway":"Norwegen","Oman":"Oman","Pakistan":"Pakistan","Palau":"Palau","Panama":"Panama","Papua New Guinea":"Papua-Neuguinea","Paraguay":"Paraguay","Peru":"Peru","Philippines":"Philippinen","Poland":"Polen","Portugal":"Portugal","Qatar":"Katar","Romania":"Rum\xe4nien","Russian Federation":"Russische F\xf6deration","Rwanda":"Ruanda","St Kitts & Nevis":"St. Kitts und Nevis","St Lucia":"St. Lucia","Saint Vincent & the Grenadines":"St. Vincent und die Grenadinen","Samoa":"Samoa","San Marino":"San Marino","Sao Tome & Principe":"S\xe3o Tom\xe9 und Pr\xedncipe","Saudi Arabia":"Saudi-Arabien","Senegal":"Senegal","Serbia":"Serbien","Seychelles":"Seychellen","Sierra Leone":"Sierra Leone","Singapore":"Singapur","Slovakia":"Slowakei","Slovenia":"Slowenien","Solomon Islands":"Salomonen","Somalia":"Somalia","South Africa":"S\xfcdafrika","South Korea":"S\xfcdkorea","South Sudan":"S\xfcdsudan","Spain":"Spanien","Sri Lanka":"Sri Lanka","Sudan":"Sudan","Suriname":"Suriname","Swaziland":"Eswatini","Sweden":"Schweden","Switzerland":"Schweiz","Syria":"Syrien","Taiwan":"Taiwan","Tajikistan":"Tadschikistan","Tanzania":"Tansania","Thailand":"Thailand","Togo":"Togo","Tonga":"Tonga","Trinidad & Tobago":"Trinidad und Tobago","Tunisia":"Tunesien","Turkey":"T\xfcrkei","Turkmenistan":"Turkmenistan","Tuvalu":"Tuvalu","Uganda":"Uganda","Ukraine":"Ukraine","United Arab Emirates":"Vereinigte Arabische Emirate","United Kingdom":"Vereinigtes K\xf6nigreich","United States":"Vereinigte Staaten von Amerika","Uruguay":"Uruguay","Uzbekistan":"Usbekistan","Vanuatu":"Vanuatu","Vatican City":"Vatikanstadt","Venezuela":"Venezuela","Vietnam":"Vietnam","Yemen":"Jemen","Zambia":"Sambia","Zimbabwe":"Simbabwe"}}');


var $e67da60fce2c65c3$exports = {};
$e67da60fce2c65c3$exports = JSON.parse('{"general":{"loginFailed":"Your username or password were incorrect, please try again.","refreshTokenExpired":"You have been logged in for too long. For security reasons, please log in again.","open":"Open","save":"Save","close":"Close","cancel":"Cancel","error":"Error"},"validationErrors":{"genericError":"This value cannot be saved."},"schema":{"transactions":"Transactions","accounts":"Accounts","projects":"Projects","reports":"Reports","blog":"Blog","pleaseEnterValue":"Please enter a new value for this attribute","transactionTypes":{"sale":"sale","purchase":"purchase","split":"split"},"deposits":{"transaction":{"ownName":"Transaction","date":{"label":"Date","description":"Date of the transaction."},"otherParty":{"label":"Transaction party","description":"Sender or receipient of the transaction amount."},"otherPartyAccount":{"label":"Account number","description":"IBAN (account no.) of the sender or receipient."},"description":{"label":"Description","description":"Description of the transaction."},"amount":{"label":"Amount","description":"This transaction\'s amount of money in your base currency."},"accountCurrencyAmount":{"label":"Amount","description":"This transaction\'s amount of money in account currency."},"currency":{"label":"Account currency","description":"This account\'s currency."},"fxAmount":{"label":"Foreign currency amount","description":"Optional. If the transaction was conducted in a foreign currency, this is its original amount."},"fxCurrency":{"label":"Foreign currency symbol","description":"Optional. If the transaction was conducted in a foreign currency, this is its three-letter symbol."},"simulated":{"label":"Simulated transaction","description":"Values in this column are true (checked) if the transaction is simulated."},"incomeFromInterest":{"label":"Income from capital","description":"Values in this column are true (checked) if this transaction is an income from capital (interests, dividends etc.)."}},"account":{"ownName":"Bank account","name":"Bank name","country":"Country","accountName":{"label":"Account name","tooltip":"What name would you like to see for this account in the system?","error":"Please enter a designation for this account."},"baseCurrency":{"label":"Base currency","tooltip":"What currency does this account use?"},"iban":{"label":"IBAN","tooltip":"This account\'s IBAN (account number)","placeholder":"DE12345678901234567890"},"bic":{"label":"BIC","tooltip":"International bank code (called >BIC<) for the bank where this account is at. Up to 11 characters long. Used to identify a bank in an international setting."},"bankName":{"label":"Bank name","tooltip":"Name of the bank where this account is at.","placeholder":"Sparkasse Bielefeld"},"syncType":{"label":"Synchronisation","tooltip":"How would you like to sync this account?","placeholder":"Select sync type"},"depositType":{"label":"Account type","tooltip":"What kind of account is this?","placeholder":"Select account type"},"countryCode":{"label":"Country","tooltip":"What country is this account in?","placeholder":"Select country"},"category":{"label":"Category","tooltip":"What category does this account belong to?","placeholder":"Select category"},"parameters":{"syncType":{"manual":"manual","automatic":"automatic"},"depositType":{"savings-account":"checking","time-deposit":"savings"}}}},"stocks":{"transaction":{"date":{"label":"Date","description":"Date of the transaction."},"displaySymbol":{"label":"Security symbol*","description":"Symbol of traded security, such as ISIN, WKN or CUSIP. Optional."},"displayName":{"label":"Security name","description":"Stock name."},"transactionAmount":{"label":"Amount","description":"Quantity of securities bought or sold."},"transactionPrice":{"label":"Price (base currency)","description":"Unit price paid, in your base currency."},"transactionCurrency":{"label":"Currency","description":"Currency of the transaction."},"transactionOriginalPrice":{"label":"Price (transaction currency)","description":"Unit price paid, in transactioion currency."}},"account":{"brokerName":{"label":"Provider name","tooltip":"Which broker is this account with?","placeholder":"DepotX"},"accountNo":{"label":"Account number","tooltip":"What is the number of your brokerage account?","placeholder":"C12345678"},"username":{"label":"Username","tooltip":"What is your username for this account?","placeholder":"user01"},"syncType":{"label":"Synchronisation","tooltip":"How would you like to sync this account?","placeholder":"Select sync type"},"ownCurrentAccount":{"label":"Cash account IBAN","tooltip":"Which current account is this brokerage account linked to?","placeholder":"Select current account"},"countryCode":{"label":"Country","tooltip":"What country is this account in?","placeholder":"Select country"},"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) receive proceeds from this account\'s assets?"}}},"meta-comment":"the entries below are realEstate quotes, but this is only used in import of quotes, so leaving it be for now","realEstate":{"transaction":{"date":{"label":"Date","description":"Date of the valuation."},"currency":{"label":"Currency","description":"The currency of the valuation."},"quote":{"label":"Price","description":"Valuation in that currency."},"quoteBaseCurrency":{"label":"Price (base currency)","description":"Valuation in your base currency."},"note":{"label":"Note","description":"Optional. Any valuation details you may want to record."}},"account":{"kindOfProperty":"What kind of property is this?","connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) receive proceeds from this account\'s assets?"},"valuationParameters":{"type":{"label":"Building or apartment"},"subtype":{"label":"Property type","tooltip":"What kind of building / apartment is this?"},"streetAddress":{"label":"Street and number","tooltip":"Where is your property located?","placeholder":"Hochstr. 12"},"zip":{"label":"Postal code","tooltip":"What postal code does your property have?","placeholder":"33602","error":"Please provide a postal code."},"district":{"label":"District / Town","tooltip":"If your property is in a Stadtkreis, enter the name of the district (Stadtteil). Otherwise enter the name of the town or village.","placeholder":"Mitte"},"city":{"label":"Stadtkreis / Landkreis","tooltip":"Name of the Stadtkreis (city) or Landkreis (county) your property is located in.","placeholder":"Bielefeld","error":"Please provide Stadtkreis or Landkreis name."},"countryCode":{"label":"Country","tooltip":"What country is your property located in?","placeholder":"Germany","error":"Please provide a country."},"completeArea":{"label":"Complete floor area","tooltip":"How big is your entire property (in m\xb2)?","placeholder":"100"},"livingArea":{"label":"Floor area","tooltip":"How big is the living area of your property (in m\xb2)?","placeholder":"88","error":"Please indicate how large your property is."},"floor":{"label":"Floor","tooltip":"On which floor is your property located?","placeholder":"3"},"totalFloors":{"label":"Building floors","tooltip":"How many floors in total does the building have?","placeholder":"4"},"rooms":{"label":"Rooms","tooltip":"How many rooms does your property have?","placeholder":"3"},"flooring":{"label":"Flooring","tooltip":"What kind of flooring does your property have?"},"interiorLevel":{"label":"Interior standard","tooltip":"How would you rate the interior of your property?"},"condition":{"label":"Current condition","tooltip":"How would you rate the current condition of your property?"},"lotArea":{"label":"Lot area","tooltip":"How big is the lot your property is located on (in square meters)?","placeholder":"450"},"constructionYear":{"label":"Construction year","tooltip":"When was your property built?","placeholder":"2010"},"energyClass":{"label":"Energy consumption","tooltip":"Enter the amount of required kWh per m\xb2 per year. If you only know the energy efficiency class, look up the average value for that class and enter it here.","placeholder":60},"heatingType":{"label":"Heating type","tooltip":"What kind of heating does your property have?"},"floorHeating":{"label":"Underfloor heating?","tooltip":"Does the property have underfloor heating?"},"lastRenovationYear":{"label":"Year of last renovation","tooltip":"When was the property last renovated?","placeholder":"2020"},"privateParkingSpaces":{"label":"Parking spots","tooltip":"How many private parking spots are available for your property?","placeholder":1},"garden":{"label":"Garden?","tooltip":"Does the property have a garden?"},"bathTub":{"label":"Bathtub?","tooltip":"Does the property have a bathtub?"},"bathWithWindows":{"label":"Bath with windows?","tooltip":"Does the property have a bathroom with windows?"},"fullHeightWindows":{"label":"Full-height windows?","tooltip":"Does the property have full-height windows?"}},"parameters":{"type":{"apartment":"Apartment","building":"Building"},"subtype":{"building":{"farm":"Farm","special-building":"Special Building","bungalow":"Bungalow","castle":"Castle","semi-detached":"Semi-Detached","detached":"Detached","apartment-building":"Apartment Building","terraced":"Terraced","terraced-corner":"Terraced Corner","villa":"Villa","other":"Other"},"apartment":{"top-floor":"Top Floor","ground-floor":"Ground Floor","other-floor":"Other Floor","high-ground-floor":"High Ground Floor","loft":"Loft","two-levels":"Two Levels","penthouse":"Penthouse","souterrain":"Souterrain","with-balcony":"With Balcony","other":"Other"}},"interiorLevel":{"simple":"Simple","normal":"Normal","high":"High","luxus":"Luxury"},"condition":{"new":"New","newly-renovated":"Newly Renovated","well-maintained":"Well Maintained","modernized":"Modernized","flexible":"Flexible","like-new":"Like New","needs-renovation":"Needs Renovation","refurbished":"Refurbished","completely-renovated":"Completely Renovated","needs-repair":"Needs Repair"},"heatingType":{"gas":"Gas","oil":"Oil","electricity":"Electricity","district":"District","wood":"Wood","coal":"Coal","solar":"Solar","block":"Block","stock":"Stock","floor":"Floor","nachtspeicher":"Storage Heating","w\xe4rmekraft":"Thermal Power","central":"Central"},"flooring":{"carpet":"Carpet","parquet":"Parquet","tiles":"Tiles","laminate":"Laminate","floorboards":"Floorboards"}}}},"loans":{"account":{"parameters":{"type":{"annuity":"Fixed rate (annuity)","fixedPrincipal":"Variable rate (fixed principal)","interestOnly":"Interest only"},"period":{"month":"Monthly","quarter":"Quarterly","annual":"Yearly"},"direction":{"received":"Loan taken","granted":"Loan granted"}},"type":{"label":"Loan type","tooltip":"What kind of loan is this? Fixed rate, fixed capital repayment etc.","placeholder":"Select loan type","error":"Loan type is incorrect."},"direction":{"label":"Taken or granted?","tooltip":"Did you borrow money (loan taken) or lent it (loan granted)?","error":"Loan taken/granted is incorrect."},"loanAmount":{"label":"Loan amount (currency)","tooltip":"How much money did you borrow?","placeholder":"-100000","error":"Please enter the loan amount."},"interestRate":{"label":"Interest rate","tooltip":"What is the interest rate of your loan? Changes during loan term are possible.","error":"Please enter the interest rate."},"period":{"label":"Installment frequency","tooltip":"How often do you do repayments? Changes during loan term are possible.","error":"Please enter the loan period."},"iban":{"label":"IBAN","tooltip":"This account\'s (loan\'s account) IBAN (account number)","placeholder":"DE12345678901234567890"},"bankName":{"label":"Bank name","tooltip":"This account\'s (loan\'s account) IBAN (account number)","placeholder":"DE12345678901234567890"},"percentRepaidAnnually":{"label":"Repayment rate (Tilgung)","tooltip":"How much of the loan do you repay annually? Changes during loan term are possible.","error":"Please enter the repayment rate."},"contractEndDate":{"label":"Loan end date","tooltip":"When does the loan contract end?","error":"Please enter the contract end date."},"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) send and receive payments for this loan?"},"interestCalcMonthEnd":{"label":"Interest calculation at month end?","tooltip":"Does your bank calculate your payments at the end of the month (yes) or at its beginning?"},"connectedProjectId":{"label":"Connected project","tooltip":"Which project shows the simulated repayment schedule for this loan?"}},"transaction":{"ownName":"Transaction","date":{"label":"Date","description":"Date of the transaction."},"otherParty":{"label":"Transaction party","description":"Sender or receipient of the transaction amount."},"otherPartyIban":{"label":"Account number","description":"IBAN (account no.) of your loan account."},"description":{"label":"Description","description":"Description of the transaction."},"quantity":{"label":"Principal","description":"This repayment\'s principal part in your account currency."},"quantityInterest":{"label":"Interest","description":"This repayment\'s interest part in your account currency."}}},"pension":{"account":{"parameters":{"useSpecialQuote":{"payoutOnlyContributionsToDate":"Pension on contributions to-date","payoutOnlyContributionsToDateIndexed":"Pension on contributions to-date (with interest)","payoutAllPlannedContributions":"Pension on all future contributions","payoutAllPlannedContributionsIndexed":"Pension on all future contributions (with interest)","payoutLumpSumVerrentet":"Lump sum converted to perpetual pension"},"contributionsFrequency":{"0":"One-time","1":"Monthly","3":"Quarterly","12":"Yearly"},"payoutsFrequency":{"0":"One-time","1":"Monthly","3":"Quarterly","12":"Yearly"},"frequencyUnit":{"0":"indefinitely","1":"months","12":"years"}},"product":"pension product","name":{"label":"Pension product name","tooltip":"What is the name of this pension product?","placeholder":"My Riester pension","error":"Please provide product name."},"currency":{"label":"Account currency","tooltip":"What currency does this pension product use for contributions and payouts?"},"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) send and receive payments for this pension product?"},"connectedDepositMode":{"error":"Please select an option here."},"productPurchaseDate":{"label":"Purchase date","tooltip":"When did you purchase this product? This date does not have to be very precise, it is used to show you how the present value of this product has been changing over time.","error":"Please enter an (approximate) purchase date.","errorInvalid":"Please enter a date which is valid.","errorFuture":"This date may not be in the future"},"initialQuotes":{"label":"Original payout estimates","tooltip":"What were the initial payout estimates that were given to you when you signed the contract?","error":"Original payout estimates missing"},"contributionsSelfPaid":{"label":"Contributions self-paid?","tooltip":"Set this to YES if you pay the contributions. If it is your employer, set it to NO.","error":"Contributions self-paid require a value"},"contributionsAmounts":{"label":"Contribution amount","placeholder":100,"tooltip":"Enter the current contribution amount (if self-paid). You can set different amounts for different periods later on.","error":"Please enter an (approximate) contribution amount."},"contributionsFrequency":{"label":"Contribution frequency","tooltip":"How often do you pay contributions to this product?","error":"Contribution frequency is not set"},"contributionsDeductible":{"label":"Are contributions tax-deductible?","tooltip":"Do you receive a tax benefit on this product?","error":"Contribution deductible information is not set"},"contributionsIndexed":{"label":"Will contribution change over time?","tooltip":"Will the contribution amount be adjusted over time? Enable to index by inflation or a custom rate.","error":"Contribution growth setting is missing."},"payoutsPhaseStart":{"label":"Payout phase start","tooltip":"When is the first payout to take place? We only need an approximate date here. We use it to simulate future payouts. You can change it later.","error":"Please enter the (approximate) payout phase start date."},"payoutsFrequency":{"label":"Payout frequency","tooltip":"Is it a monthly, quarterly, annual or one-time payout?","error":"Payout frequency not set"},"payoutsDurationUserInput":{"label":"Payout paid for how long?","tooltip":"For how long will the payouts be provided? Select \'indefinitely\' from the menu if there is no end date.","error":"Payout duration not set"},"payoutsDuration":{"label":"Payout duration","tooltip":"For how long will the payouts be provided? Enter \'0\' if indefinitely, otherwise enter a number of months (12 for one year, 120 for ten years etc.).","error":"Payout duration not set"},"payoutsTaxable":{"label":"Is payout taxable?","tooltip":"Do you pay taxes on the payout you receive?","error":"Payout taxable not provided."},"payoutsIndexed":{"label":"Will payout change over time?","tooltip":"Will the payout amount be adjusted over time? Enable to index by inflation or a custom rate.","error":"Payout growth not set."},"discountRateIsInflation":{"label":"Use inflation rate to index values for this account?","tooltip":"Select YES to use inflation rate to simulate payout and contribution growth as well as calculate current value of the account. Select NO to provide your own index rate.","error":"Please choose how to index values in this account."},"customDiscountRate":{"label":"Custom index rate (%)","tooltip":"Annual percentage rate used to index contributions/payouts.","error":"Please enter a custom contribution index rate.","placeholder":2},"useSpecialQuote":{"label":"Current value calculation","tooltip":"Which pension estimate should we use to calculate the present value of this pension product?","error":"Pension estimate not provided."},"discountRate":{"label":"Product interest rate","tooltip":"Interest rate used to calculate present value of this product as well as it\'s future growth, if any. Leave it open to use the inflation rate specified in settings.","error":"Product interst rate not set.","placeholder":2.3},"fxRate":{"label":"Today\'s exchange rate of {{accountCurrency}} to {{baseCurrency}}: ","tooltip":"To keep things simple, we recommend using current exchange rate. Feel free to use any exchange rate you feel is better suited for the long term.","apply":"Automatically convert all to {{baseCurrency}}"}},"transaction":{"date":{"label":"Date","description":"On what date did the provider communicate these new values?"},"currency":{"label":"Currency","description":"The currency of the valuation."},"payoutOnlyContributionsToDate":{"label":"Pension from contributions to-date","description":"Pension that you would receive if you stopped paying contributions today."},"payoutOnlyContributionsToDateIndexed":{"label":"Pension from contributions to-date (inflation-adjusted)","description":"Pension that you would receive if you stopped paying contributions today, but growing with inflation until pension payout phase."},"payoutAllPlannedContributions":{"label":"Pension from all future contributions","description":"Pension that you would receive if you keep paying contributions until pension payout phase."},"payoutAllPlannedContributionsIndexed":{"label":"Pension from all future contributions (inflation-adjusted)","description":"Pension that you would receive if you keep paying contributions until pension payout phase, but growing with inflation until pension payout phase."},"payoutLumpSumVerrentet":{"label":"Lump sum converted to perpetual pension","description":"Capital you have accumulated will be converted into a perpetual annuity. We will automatically calculate the recurring payment."}}},"objectsOfValue":{"account":{"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) receive proceeds from this account\'s assets?"},"name":{"label":"Object name","tooltip":"Under what name shall we display this object?","placeholder":"Mercedes 450 SEL","error":"Please provide the object name."},"currency":{"label":"Account currency","tooltip":"What currency does this pension product use for contributions and payouts?"},"userInputPurchaseDate":{"label":"Purchase date","tooltip":"When did you purchase this object?","error":"Please enter the purchase date."},"userInputPurchaseValueAccountCurrency":{"label":"Purchase price in {{currency}}","tooltip":"How much did you pay for this object?","error":"Please enter the purchase value."},"userInputPurchaseValueBaseCurrency":{"label":"Purchase price in {{currency}}","tooltip":"How much did you pay for this object?","error":"Please enter the purchase value."},"fxRate":{"label":"Exchange rate of {{accountCurrency}} to {{baseCurrency}} on {{date}} was","tooltip":"For your convenience we looked up the exchange rate on the day you indicated.","apply":"Calculate purchase price in {{baseCurrency}}"},"quantity":{"label":"Quantity purchased","tooltip":"If applicable here, how many objects did you buy initially? Default value is 1."}}},"metals":{"account":{"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) receive proceeds from this account\'s assets?"},"name":{"label":"Account name","tooltip":"How would you like to call this account?","placeholder":"Bank deposit box","error":"Please provide the account name"},"currency":{"label":"Account currency","tooltip":"In which currency shall we track the assets in this account?"}},"transaction":{"parameters":{"assetMetal":{"gold":"gold","silver":"silver","platinum":"platinum","palladium":"palladium","other":"other"}}}},"unlistedShares":{"account":{"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) receive proceeds from this account\'s assets?","error":"Please select an option"},"connectedDepositMode":{"error":"Please select an option"},"name":{"label":"Company name","tooltip":"What is the name of this company?","placeholder":"My company","error":"Please provide the company name"},"currency":{"label":"Currency","tooltip":"In which currency shall we track your investments in this company?"},"date":{"label":"Company start date","tooltip":"When did you create the company? An approximate date is sufficient.","error":"Please enter a date"},"upac":{"label":"Starting capital","tooltip":"How much starting capital did you invest in the company?","placeholder":25000,"error":"Please enter a value"},"upbc":{"label":"Starting capital (base currency)","tooltip":"How much starting capital is that in your overall base currency?","placeholder":25000,"error":"Please enter a value"},"quantity":{"label":"Number of shares","tooltip":"How many shares did you assume? If not sure, enter 1.","placeholder":1,"error":"Please enter a value"}}},"crypto":{"account":{"connectedDepositAccounts":{"label":"Connected bank account(s)","tooltip":"Which bank account(s) receive proceeds from this account\'s assets?"},"name":{"label":"Account name","tooltip":"How would you like to call this account?","placeholder":"Bank deposit box","error":"Please provide the account name"},"brokerName":{"label":"Provider name","tooltip":"Which exchange or broker is this account with?","placeholder":"Binance"},"accountNo":{"label":"Account idenfitier","tooltip":"What is the identifier of your account?","placeholder":"C12345678"}}}}}');


var $c8be339546f697df$exports = {};
$c8be339546f697df$exports = JSON.parse('{"yourAssets":"Your assets","yourAssetsOn":"Your assets on","setDate":"Set date for this view","edit":"Edit","share":"Share","done":"Finish edit","pleaseWait":"Please wait while we load your data...","externalSync":"Your banks are still sending data (up to 60s)...","postFile":{"header":"Which account?","prompt":"Please select the account to which you want to import the file."},"shareReport":{"header":"Share Dashboard","tooltip":"We will create a link for you to share your dashboard with others. Please set a simple passcode to protect your data.","next":"Next","confirmation":{"copy":"Copy","copyBoth":"Send the link and the passcode to the recipient. They will get access to your dashboard with today\'s data.","securityHint":"If possible, do not send the passcode and the link in the same message or in the same chat."}},"sharedReportViewer":{"header":"Passcode","prompt":"Please enter your passcode to access the Dashboard.","reportNotFound":"Dashboard not found","unableToLoadReport":"We were unable to load the report. Please check the passcode and try again."},"categories":{"deposits":"Bank accounts","stocks":"Stockbroker accounts","pension":"Pension plans","realEstate":"Real estate","objectsOfValue":"Objects of value","metals":"Precious metals","loans":"Loans","unlistedShares":"Unlisted shares","crypto":"Cryptocurrencies"},"singleCategory":{"deposits":"Bank account","stocks":"Stock brokerage account","pension":"Pension plan","realEstate":"Real estate","objectsOfValue":"Object of value","metals":"Precious metal","loans":"Loan","unlistedShares":"Unlisted shares","crypto":"Cryptocurrency"},"sumtile":{"change":"Change vs. the same indicator in previous period.","inconsistent":"Inconsistent transactions","warning":"There are inconsistencies in your data which may affect this number. Click here to see details.","orphanedDialog":{"assetTransactionsDialogTitle":"Asset transactions with no deposit transactions","netWorthExplanation":"In order to calculate your net worth and its changes correctly, each sale of asset needs to be linked to a transaction on a bank / cash account. You can do that by labelling the correct bank transaction in your bank account.","notLinkedTransactionsExplanation":"The following transactions are not linked to any deposit transaction. Click one to go to the first linked deposit account for that transaction and label the matching transaction there.","transactionTableHeaders":{"date":"Date","assetAccount":"Asset account","assetName":"Asset name","amount":"Amount","price":"Value"},"closeButtonText":"Close"},"generalIncome":{"label":"General income","tooltip":"Income from external sources, such as employment."},"incomeFromCapital":{"label":"Income from capital","tooltip":"Income from capital, such as dividends or gains/losses from sales of investments. Blue circle next to a transaction means that this transaction is included in this category."},"assetValueIncrease":{"label":"Asset value change","tooltip":"Change in the value of assets, such as stocks, bonds, real estate, etc."},"outflows":{"label":"Outflows","tooltip":"General expenses, such as rent, utilities, etc. Purchases of investment assets are not included in this category"},"previousValue":{"label":"Baseline value","tooltip":"Total value of all your assets at the beginning of the baseline period that you selected below.","selectBaseline":"Select a baseline date:","sameTimeLastYear":"One year ago","beginning":"Beginning of this year","beginningLastYear":"Beginning of last year","custom":"Custom"},"changeInValue":{"label":"Change in value","tooltip":"Difference between the total value of all your assets at the beginning of the period that you selected and today."},"currentNetWorth":{"label":"Current net worth","tooltip":"Value of all your assets minus value of all loans that you took."}}}');


var $df15be24d07deabf$exports = {};
$df15be24d07deabf$exports = JSON.parse('{"yourAssets":"Deine Anlagen","yourAssetsOn":"Deine Anlagen am","setDate":"Datum f\xfcr diese Ansicht w\xe4hlen","edit":"Anpassen","share":"Teilen","done":"Anpassen beenden","pleaseWait":"Bitte warten, wir bereiten die Daten vor...","externalSync":"Banken senden noch Daten (bis zu 60s)...","postFile":{"header":"Welches Konto?","prompt":"Bitte w\xe4hle das Konto aus, zu dem du die Datei geh\xf6rt."},"shareReport":{"header":"Dashboard teilen","tooltip":"Wir erstellen einen Link, den du mit anderen teilen kannst. F\xfcr extra Sicherheit, setze jetzt ein Passcode, mit dem der Link gesch\xfctzt wird.","next":"Weiter","confirmation":{"copy":"Kopieren","copyBoth":"Schicke Link und Passcode an den Empf\xe4nger. Er(sie) sieht das Dashboard mit heutigen Daten.","securityHint":"Wenn m\xf6glich, schicke die beiden Codes \xfcber verschiedene Kan\xe4le (z.B. Email und Chat)."}},"sharedReportViewer":{"header":"Passcode","prompt":"Bitte gib den Passcode ein, um das Dashboard zu sehen.","reportNotFound":"Dashboard nicht gefunden","unableToLoadReport":"Das Dashboard kann nicht geladen werden. Bitte \xfcberpr\xfcfe den Passcode."},"categories":{"deposits":"Bankkonten","stocks":"Depots","pension":"Rentenprodukte","realEstate":"Immobilien","objectsOfValue":"Wertobjekte","metals":"Edelmetalle","loans":"Darlehen","unlistedShares":"Private Unternehmen","crypto":"Kryptow\xe4hrungen"},"singleCategory":{"deposits":"Bankkonto","stocks":"Depot","pension":"Rentenanlage","realEstate":"Immobilie","objectsOfValue":"Wertobjekt","metals":"Edelmetall","loans":"Darlehen","unlistedShares":"Privates Unternehmen","crypto":"Kryptow\xe4hrung"},"sumtile":{"change":"\xc4nderung gegen\xfcber dem Basisdatum.","warning":"Es gibt Unstimmigkeiten in deinen Daten, die sich auf diese Zahl auswirken k\xf6nnen. Klicke hier, um Details anzuzeigen.","inconsistent":"Unstimmigkeiten","orphanedDialog":{"assetTransactionsDialogTitle":"Transaktionen f\xfcr Verm\xf6genswerte ohne Einzahlungstransaktionen","netWorthExplanation":"Um deinen Nettowert und dessen \xc4nderungen korrekt zu berechnen, muss jeder Verkauf von Verm\xf6genswerten mit einer Transaktion auf einem Bank- oder Bar-Konto verkn\xfcpft sein. Die entsprechende Banktransaktion muss dazu getaggt werden.","notLinkedTransactionsExplanation":"Die folgenden Transaktionen sind keiner Einzahlungstransaktion zugeordnet. Klicke eine, um zum entsprechenden Bankkonto weitergeleitet zu werden, und tagge dort die passende Transaktion.","transactionTableHeaders":{"date":"Datum","assetAccount":"Verm\xf6genskonto","assetName":"Verm\xf6genswert","amount":"Betrag","price":"Wert"},"closeButtonText":"Schlie\xdfen"},"generalIncome":{"label":"Allgemeine Einnahmen","tooltip":"Einkommen aus externen Quellen, z.B. Besch\xe4ftigung."},"incomeFromCapital":{"label":"Kapitaleinkommen","tooltip":"Kapitaleinkommen erzielt seit dem Basisdatum - aus z.B. Dividenden oder Ertr\xe4gen von Verkaufen von Aktien sowie weiteren Investitionen. Blauer Kreis neben einer Transaktion bedeutet, dass sie zu dieser Kategorie geh\xf6rt."},"assetValueIncrease":{"label":"\xc4nderung des Anlagenwerts","tooltip":"Zeigt, wie sich seit Basisdatum der Wert aller Anlagen (Aktien, Immobilien etc.) ge\xe4ndert hat."},"outflows":{"label":"Allgemeine Ausgaben","tooltip":"Ausgaben, die nicht mit Investitionen zusammenh\xe4ngen, wie z.B. Miete, Nebenkosten, Eink\xe4ufe. geh\xf6ren zu dieser Kategorie. K\xe4ufe von Aktien und Investitionen geh\xf6ren hierzu nicht."},"previousValue":{"label":"Verm\xf6gen am Basisdatum","tooltip":"Gesamtwert aller Anlagen und Konten am unten gew\xe4hlten Basisdatum.","selectBaseline":"Basisdatum w\xe4hlen:","sameTimeLastYear":"Gleicher Tag letztes Jahr","beginning":"Anfang des Jahres","beginningLastYear":"Anfang des Vorjahres","custom":"Frei w\xe4hlbar"},"changeInValue":{"label":"Wert\xe4nderung","tooltip":"Wert\xe4nderung aller Anlagen und Konten zwischen dem Basisdatum und heute."},"currentNetWorth":{"label":"Aktuelles Verm\xf6gen","tooltip":"Wert deines gesamten Verm\xf6gens mit Abzug aller Schulden."}}}');


var $8ccf9bab8cf25ab0$exports = {};
$8ccf9bab8cf25ab0$exports = JSON.parse('{"projects":"Projects","reports":"Reports","help":"Help & Support","survey":"UX Test: Survey","profile":"Your profile","settings":"Settings","recommendUs":"Recommend us!","signOut":"Sign out","noMessages":"No notifications"}');


var $36ae45496b617141$exports = {};
$36ae45496b617141$exports = JSON.parse('{"projects":"Projekte","reports":"Reports","help":"Hilfe & Support","survey":"UX Test: Umfrage","profile":"Dein Profil","settings":"Einstellungen","recommendUs":"Empfehle uns!","signOut":"Abmelden","noMessages":"Keine Nachrichten vorhanden"}');


var $ef0cb480373814b3$exports = {};
$ef0cb480373814b3$exports = JSON.parse('{"internalError":{"type":"error","header":"Error","body":"The operation could not be completed.","button":"OK"},"loginFailed":{"type":"error","header":"Login failed","body":"We could not log you on at this time. Please try again or contact us if the problem persists.","button":"OK"},"userRegistrationSuccessful":{"type":"success","header":"Registration complete","body":"Your account has been successfully created. For reasons of security you will be asked to log in.","button":"OK"},"userRegistrationSuccessfulWithPassword":{"type":"success","header":"Registration complete","body":"Your account has been successfully created. Click OK to proceed to your Dashboard.","button":"OK"},"userConfirmationNotPossible":{"type":"error","header":"Registration failed","body":"Unfortunately we could not complete your registration at this time. Please contact our support at support@monestry.de.","button":"OK"},"pressOkToContinue":{"type":"warning","header":"Error","body":"Press OK to continue.","button":"OK"},"formIncomplete":{"type":"error","header":"Form incomplete","body":"Please fill out all the mandatory fields.","button":"Close"},"nothingToSave":{"type":"success","header":"Nothing to save","body":"We found no changes, so saving was not necessary.","button":"Close"},"localValidationFailed":{"type":"error","header":"We found some errors","body":"Please have a look at the spreadsheet again. The errors are indicated by red corners.","button":"Close"},"aboutToSave":{"type":"warning","header":"Your data are about to change","body":"You are about to permanently change your data. Press OK to confirm or Cancel to abort.","button":"OK","button2":"Cancel"},"saveCompleted":{"type":"success","header":"Data saved successfully","body":"Your data have been saved.","button":"Close"},"saveFailed":{"type":"error","header":"Save failed","body":"Unfortunately we could not save your changes. Please have a look at the error messages in comments.","button":"Close"},"fileUploadSuccessful":{"type":"success","header":"Success","body":"File uploaded successfully.","button":"Close"},"fileUploadFailed":{"type":"error","header":"Unable to upload file","body":"Unfortunately we could not upload the file. Please try again later.","button":"Close"},"aboutToLoseData":{"type":"warning","header":"Changes you made will be lost","body":"You are about to exit Edit mode. Press OK to confirm or Cancel to abort.","button":"OK","button2":"Cancel"},"abandonUpload":{"type":"warning","header":"Changes you made will be lost","body":"You are about to abandon this file upload. Press OK to confirm or Cancel to abort.","button":"OK","button2":"Cancel"},"youAreAboutToDeleteAccount":{"type":"warning","header":"Your data will be deleted","body":"You are about to delete this account along with all its data. Press OK to confirm or Cancel to abort.","button":"OK","button2":"Cancel"},"youAreAboutToDeleteProject":{"type":"warning","header":"This project will be permanently deleted","body":["You are about to delete this project along with all its planned transactions.","Past transactions will not be deleted.","Press OK to confirm or Cancel to abort."],"button":"OK","button2":"Cancel"},"youAreAboutToDeleteTransaction":{"type":"warning","header":"This transaction will be permanently deleted","body":"You are about to delete this transaction. Press OK to confirm or Cancel to abort.","button":"OK","button2":"Cancel"},"youAreAboutToDeleteValuation":{"type":"warning","header":"This valuation will be permanently deleted","body":"You are about to delete this valuation. Press OK to confirm or Cancel to abort.","button":"OK","button2":"Cancel"},"closeAccountDetails":{"type":"warning","header":"Changes may be lost","body":"If you made any changes, they will be lost. Continue?","button":"OK","button2":"Cancel"},"Invalid currency code":{"type":"error","header":"Invalid currency code","body":"Please enter a valid currency code.","button":"Close"},"Transaction date must be in a date format":{"type":"error","header":"Invalid transaction date","body":"Transaction date must be in a date format.","button":"Close"},"Transaction date is required":{"type":"error","header":"Missing transaction date","body":"Date is required for all transactions.","button":"Close"},"Transaction party must be shorter than 100 characters":{"type":"error","header":"Transaction party name too long","body":"Transaction party must be shorter than 100 characters.","button":"Close"},"Transaction party is required":{"type":"error","header":"Missing transaction party.","body":"A transaction party (sender or receiver) is required for all transactions.","button":"Close"},"Transaction description must be shorter than 1000 characters":{"type":"error","header":"Transaction description too long","body":"Transaction description must be shorter than 1000 characters.","button":"Close"},"Transaction description is required":{"type":"error","header":"Missing transaction description","body":"Transaction description is required for all transactions.","button":"Close"},"Amount must be a number":{"type":"error","header":"Amount must be a number","body":"All transaction amounts must be numbers and must not contain letters.","button":"Close"},"Amount is required":{"type":"error","header":"Missing transaction amount","body":"Transaction amount is mandatory for all transactions.","button":"Close"},"Currency code is required":{"type":"error","header":"Missing currency code","body":"Currency code is mandatory for all transactions","button":"Close"},"Foreign currency amount must be a number":{"type":"error","header":"Foreign currency amount must be a number","body":"All foreign currency amounts must be numbers and must not contain letters. Please enter foreign currency code in the Foreign Currency Symbol field","button":"Close"},"Foreign exchange currency is required when a foreign currency amount is specified":{"type":"error","header":"Foreign currency and transaction amount mismatch","body":"If a foreign currency or a transaction amount are part of any transaction, then both of them must be specified in every such transaction.","button":"Close"},"Currency code must be exactly 3 characters long":{"type":"error","header":"Currency code error","body":"Currency code must be exactly 3 characters long.","button":"Close"},"newPasswordSuccess":{"type":"success","header":"Success","body":"Password has been changed. Please log in with your new password.","button":"Close"},"youAreAboutToDeleteTemplateTransactions":{"type":"warning","header":"Warning","body":"All template transactions will be removed from your project. Do you want to continue?","button":"OK","button2":"Cancel"},"addTransactionManually":{"type":"warning","header":"Warning","body":"Initial purchase transaction could not be created, please add it manually.","button":"OK","button2":"Cancel"},"infoRedirectToProvider":{"type":"info","header":"Log in to your bank","body":["We will redirect you to a secure webpage of our provider. Please log in to your bank there to approve the connection.","After you have finished, you will be redirected back to Monestry.","You may need to log in more than once, as there may be several ways of accessing your bank\'s data."],"button":"OK","button2":"Cancel"},"infoNoNewAccounts":{"type":"info","header":"No new accounts","body":"All your accounts from this bank seem to be already set up. Select a different bank.","button":"OK"},"expiredCredentialsError":{"type":"info","header":"Time to renew account access","body":["Access to {{accountName}} needs to be renewed. Click OK to go to your bank now.","If you linked more than one account from this bank, you will only have to do it once."],"button":"OK","button2":"Cancel"},"signUpForNewsletter":{"type":"info","header":"Thanks for signing up!","body":["We will typically send you one email every 1-2 months about news related to our app.","We need to send you an email with a confirmation link. You can unsubscribe at any time by clicking a link in the email."],"button":"OK","button2":"Cancel"},"shareReportLinkSuccess":{"type":"success","header":"Your link and passcode","button":"OK"},"renewAccountAccessNoIbansFound":{"type":"error","header":"IBANs not found","body":["Your bank sent us the following account numbers (IBANs): {{providerIbans}}.","You have set up the following international accounts for automatic updates: {{monestryIbans}}.","Please check if your accounts in Monestry are correctly set up and adjust them if necessary."],"button":"OK"},"providerAccountsRemoved":{"type":"info","header":"Accounts removed","body":["We did not receive data for {{list}} from your bank. Those accounts seem to have been removed.","We have updated them to manually managed accounts."],"button":"OK"},"aboutToReceiveRealEstateValuation":{"type":"info","header":"Your first valuation","body":["We are about to calculate the valuation for your property. Make sure you have entered all the known details in the previous screen, as this impacts how good the valuation will be.","Press OK to confirm or Cancel to abort."],"button":"OK","button2":"Cancel"},"errorsDetected":{"type":"error","header":"Errors detected","body":"We found some errors in your data. Please correct them before proceeding.","button":"OK"}}');


var $e56722449cbfa23e$exports = {};
$e56722449cbfa23e$exports = JSON.parse('{"internalError":{"type":"error","header":"Fehler","body":"Die Operation ist leider fehlgeschlagen.","button":"OK"},"loginFailed":{"type":"error","header":"Anmeldung fehlgeschlagen","body":"Anmeldung war leider derzeit nicht m\xf6glich. Bitte versuche es erneut oder setze dich mit uns in Verbindung.","button":"OK"},"userRegistrationSuccessful":{"type":"success","header":"Registrierung erfolgreich","body":"Dein Benutzerkonto ist fertig. Du kannst dich nun anmelden.","button":"OK"},"userRegistrationSuccessfulWithPassword":{"type":"success","header":"Anmeldung erfolgreich","body":"Dein Benutzerkonto ist fertig. Aus Sicherheitsgr\xfcnden bitten wir dich, sich noch einmal einzuloggen.","button":"OK"},"userConfirmationNotPossible":{"type":"error","header":"Registrierung fehlgeschlagen","body":"Wir konnten die Registrierung nicht abschlie\xdfen. Bitte setze dich mit uns in Verbindung an support@monestry.de.","button":"OK"},"pressOkToContinue":{"type":"warning","header":"Fehler","body":"Zum Fortfahren OK klicken.","button":"OK"},"formIncomplete":{"type":"error","header":"Formular ist noch unvollst\xe4ndig","body":"Bitte erg\xe4nze alle Pflichtfelder.","button":"Schliessen"},"nothingToSave":{"type":"success","header":"Keine \xc4nderungen","body":"Keine \xc4nderungen sind festgestellt, also nichts muss gespeichert werden.","button":"Schliessen"},"localValidationFailed":{"type":"error","header":"Wir haben Fehler festgestellt","body":"Die Fehler sind nun in dem Spreadsheet rot gekennzeichnet. Bitte korrigiere diese Fehler und speichere erneut.","button":"Schliessen"},"aboutToSave":{"type":"warning","header":"Deine Daten werden ge\xe4ndert","body":"Deine Daten werden unwiderruflich ge\xe4ndert. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Abbrechen"},"saveCompleted":{"type":"success","header":"Daten erfolgreich aktualisiert.","body":"Deine Daten werden erfolgreich aktualisiert.","button":"Schliessen"},"saveFailed":{"type":"error","header":"Speichern fehlgeschlagen","body":"Wir konnten leider die \xc4nderungen nicht abspeichern. Bitte beachte die Fehlermeldungen.","button":"Schliessen"},"fileUploadSuccessful":{"type":"success","header":"Erfolg","body":"Datei erfolgreich hochgeladen.","button":"Schliessen"},"fileUploadFailed":{"type":"error","header":"Fehler","body":"Wir konnten leider die Datei nicht hochladen. Versuche bitte sp\xe4ter erneut.","button":"Schliessen"},"aboutToLoseData":{"type":"warning","header":"\xc4nderungen verwerfen?","body":"Nach Verlassen des Edit-Modus gehen alle nicht gespeicherte \xc4nderungen verloren. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Abbrechen"},"abandonUpload":{"type":"warning","header":"\xc4nderungen verwerfen?","body":"Du bist dabei, diese Datei zu verwerfen. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Abbrechen"},"youAreAboutToDeleteAccount":{"type":"warning","header":"Deine Daten werden gel\xf6scht","body":"Du bist dabei, das Konto samt allen Daten zu l\xf6schen. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Abbrechen"},"youAreAboutToDeleteProject":{"type":"warning","header":"Dieses Projekt wird gel\xf6scht","body":"Du bist dabei, das Projekt samt allen Transaktionen zu l\xf6schen. Ausgef\xfchrte Transaktionen werden nicht gel\xf6scht. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Cancel"},"youAreAboutToDeleteTransaction":{"type":"warning","header":"Diese Transaktion wird gel\xf6scht","body":"Du bist dabei, diese Transaktion permanent zu l\xf6schen. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Cancel"},"youAreAboutToDeleteValuation":{"type":"warning","header":"Diese Bewertung wird gel\xf6scht","body":"Du bist dabei, diese Bewertung permanent zu l\xf6schen. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Cancel"},"closeAccountDetails":{"type":"warning","header":"\xc4nderungen verwerfen?","body":"Ggf. get\xe4tigte \xc4nderungen werden verworfen. Bitte best\xe4tige mit OK oder kehre mit Abbrechen zur\xfcck.","button":"OK","button2":"Abbrechen"},"Invalid currency code":{"type":"error","header":"W\xe4hrungs-Code ung\xfcltig","body":"Bitte einen g\xfcltigen W\xe4hrungs-Code eingeben.","button":"Schliessen"},"Transaction date must be in a date format":{"type":"error","header":"Transaktionsdatum ung\xfcltig","body":"Transkationsdatum muss im Datumsformat sein (DD-MM-JJJJ).","button":"Schliessen"},"Transaction date is required":{"type":"error","header":"Transaktionsdatum fehlt","body":"Datum ist ein Pflichtfeld.","button":"Schliessen"},"Transaction party must be shorter than 100 characters":{"type":"error","header":"Transaktionspartei zu lang","body":"Transkationspartei darf nicht l\xe4nger als 100 Zeichen sein.","button":"Schliessen"},"Transaction party is required":{"type":"error","header":"Transaktionspartei fehlt.","body":"Transaktionspartei (Sender oder Empf\xe4nger) wird f\xfcr alle Transaktionen ben\xf6tigt.","button":"Schliessen"},"Transaction description must be shorter than 1000 characters":{"type":"error","header":"Transaktionsbeschreibung zu lang","body":"Transaktionsbeschreibung muss 1000 Zeichen nicht \xfcberschreiten.","button":"Schliessen"},"Transaction description is required":{"type":"error","header":"Transaktionsbeschreibung fehlt","body":"Transaktionsbeschreibung ist ein Pflichtfeld.","button":"Schliessen"},"Amount must be a number":{"type":"error","header":"Betrag muss ein eine Zahl sein","body":"Alle Transaktionsbetr\xe4ge m\xfcssen Zahlen sein und d\xfcrfen keine Buchstaben enthalten.","button":"Schliessen"},"Amount is required":{"type":"error","header":"Transaktionsbetrag fehlt","body":"Transaktionsbetrag ist ein Pflichtfeld.","button":"Schliessen"},"Currency code is required":{"type":"error","header":"W\xe4hrungs-Code fehlt","body":"W\xe4hrungs-Code ist ein Pflichtfeld.","button":"Schliessen"},"Foreign currency amount must be a number":{"type":"error","header":"Fremdw\xe4hrungsbetrag muss eine Zahl sein","body":"Fremdw\xe4hrungsbetrag muss eine Zahl sein und darf keine Buchstaben enthalten.","button":"Schliessen"},"Foreign exchange currency is required when a foreign currency amount is specified":{"type":"error","header":"Fremdw\xe4hrung und Fremdw\xe4hrungsbetrag stimmen nicht \xfcberein","body":"Wenn ein Fremdw\xe4hrungsbetrag angegeben ist, muss auch eine Fremdw\xe4hrung angegeben werden (sowie umgekehrt)","button":"Schliessen"},"Currency code must be exactly 3 characters long":{"type":"error","header":"W\xe4hrungs-Code hat nicht die richtige L\xe4nge","body":"W\xe4hrungs-Code darf genau 3 Zeichen lang sein.","button":"Schliessen"},"newPasswordSuccess":{"type":"success","header":"Erfolg","body":"Passwort erfolgreich ge\xe4ndert. Logge dich jetzt mit deinem neuen Passwort ein.","button":"Schliessen"},"youAreAboutToDeleteTemplateTransactions":{"type":"warning","header":"Daten werden gel\xf6scht","body":"Alle Mustertransaktionen werden l\xf6schen. Fortsetzen?","button":"OK","button2":"Abbrechen"},"infoRedirectToProvider":{"type":"info","header":"Bank-Login","body":["Wir leiten dich auf eine sichere Webseite unseres Anbieters weiter. Bitte logge dich dort bei deiner Bank ein, um die Verbindung zu genehmigen.","Nachdem du fertig bist, wirst du zu Monestry zur\xfcckgeleitet.","Es ist m\xf6glich, dass du dich mehrmals einloggen musst, da es verschiedene M\xf6glichkeiten gibt, auf die Daten deiner Bank zuzugreifen."],"button":"OK","button2":"Cancel"},"infoNoNewAccounts":{"type":"info","header":"Keine neue Konten","body":"Alle deine Konten aus dieser Bank sind bereits eingerichtet. Bitte w\xe4hle eine andere Bank.","button":"OK"},"expiredCredentialsError":{"type":"info","header":"Bank-Zugang abgelaufen","body":["Zugang f\xfcr {{accountName}} muss erneuert werden. Klicke OK, um sich erneut bei der Bank einzuloggen.","Wenn du mehr als ein Konto von dieser Bank verkn\xfcpft hast, musst du dies nur einmal tun."],"button":"OK","button2":"Abbrechen"},"signUpForNewsletter":{"type":"info","header":"Danke f\xfcr dein Interesse!","body":["Wir schicken dir in der Regel alle 1-2 Monate eine E-Mail \xfcber Neuigkeiten rund um Monestry.","Du erh\xe4lst jetzt noch eine Best\xe4tigungsemail. Abmeldung ist jederzeit m\xf6glich; ein Link dazu gibt es in der Email."],"button":"OK","button2":"Abbrechen"},"shareReportLinkSuccess":{"type":"success","header":"Dein Link und Passcode","button":"OK"},"renewAccountAccessNoIbansFound":{"type":"error","header":"IBANs nicht gefunden","body":["Deine Bank hat uns folgende Konten (IBANs) mitgeteilt: {{providerIbans}}.","Du hast jedoch in Monestry lediglich folgende ausl\xe4ndichen Konten mit automatischen Updates eingerichtet: {{monestryIbans}}.","Bitte \xfcberpr\xfcfe, ob die IBANs in Monestry korrekt sind und f\xfcge fehlende Konten hinzu."],"button":"OK"},"providerAccountsRemoved":{"type":"info","header":"Konten entfernt","body":["Wir haben keine Daten f\xfcr {{list}} von deiner Bank erhalten. Diese Konten scheinen entfernt worden zu sein.","Wir haben sie in manuell verwalteten Konten umgewandelt."],"button":"OK"},"aboutToReceiveRealEstateValuation":{"type":"info","header":"Die erste Bewertung","body":["Wir sind dabei, den Wert deiner Immobilie zu berechnen. Stelle sicher, dass du alle dir bekannten Details auf dem vorherigen Bildschirm eingegeben hast, da dies sich auf die Genauigkeit der Bewertung auswirkt.","Dr\xfccke OK, um zu best\xe4tigen, oder Abbrechen, um abzubrechen."],"button":"OK","button2":"Abbrechen"},"errorsDetected":{"type":"error","header":"Fehler entdeckt","body":"Wir haben einige Fehler in deinen Daten gefunden. Bitte korrigiere sie, bevor du fortf\xe4hrst.","button":"OK"}}');


var $d2b6746f74d64ae5$exports = {};
$d2b6746f74d64ae5$exports = JSON.parse('{"title":"Earn free months","subtitle.top":"Your recommendation","subtitle.bottom":"means a lot to us!","description":"Your friends, family, and colleagues could also benefit from using Monestry. When they purchase a Monestry subscription, both of you will receive a free month of the plan you have.","paragraphs.0.name":"How does it work?","paragraphs.0.description":"Share the information below with someone. When they purchase a Monestry subscription, both of you will receive an additional month of your plan for free.","paragraphs.1.name":"Registration code is important.","paragraphs.1.description":"The person must register using the link below or the registration code, so that we know to award a free month to you as well.","paragraphs.2.name":"Your personalized invitation.","paragraphs.2.description":"Click the button below to copy the invitation text to your clipboard. You can then paste it into an email or a message.","invitationText":"Check out this website!","invitationText0":"I\'d like to invite you to try out Monestry, a trusted financial planning app! Check it out here: http://www.monestry.de/features.","invitationText1":"It\'s free to try out for 30 days, and if you decide to subscribe, you\'ll get an additional month for free.","invitationText2":"Use this link to register: https://www.monestry.de/register?registrationCode={{code}} or enter code {{code}}","copyButton.share":"Share","copyButton.copy":"Copy"}');


var $238bcc41af14a5b1$exports = {};
$238bcc41af14a5b1$exports = JSON.parse('{"title":"Kostenlose Monate erhalten","subtitle.top":"Deine Empfehlung","subtitle.bottom":"bedeutet uns viel!","description":"Auch Ihre Freunde, Familie und Kollegen k\xf6nnen von Monestry profitieren. Wenn sie sich f\xfcr ein Monestry-Abo entscheiden, erhalten sowohl Sie als auch sie einen kostenlosen Monat des gew\xe4hlten Plans.","paragraphs.0.name":"Wie funktioniert es?","paragraphs.0.description":"Teilen Sie die unten stehenden Informationen mit jemandem. Wenn diese Person ein Monestry-Abo erwirbt, erhalten sowohl Sie als auch sie einen zus\xe4tzlichen kostenlosen Monat des Plans.","paragraphs.1.name":"Registrierungscode ist wichtig.","paragraphs.1.description":"Die Person muss den Link unten oder den Registrierungscode verwenden, damit wir Ihnen ebenfalls einen kostenlosen Monat gew\xe4hren k\xf6nnen.","paragraphs.2.name":"Ihre personalisierte Einladung.","paragraphs.2.description":"Klicken Sie auf den Button unten, um den Einladungstext in Ihre Zwischenablage zu kopieren. Sie k\xf6nnen ihn dann in eine E-Mail oder Nachricht einf\xfcgen.","invitationText":"Besuchen Sie diese Website!","invitationText.0":"Probiere mal Monestry aus, eine vertrauensw\xfcrdige Finanzplanungs-App! Schau es dir hier an: http://www.monestry.de/features.","invitationText.1":"Du kannst es 30 Tage lang kostenlos auszuprobieren, und wenn du dich f\xfcr ein Abo entscheidest, erh\xe4ltst du einen zus\xe4tzlichen Monat kostenlos.","invitationText.2":"Verwende diesen Link zur Registrierung: https://www.monestry.de/register?registrationCode={{code}} oder gib den Code {{code}} ein.","copyButton.share":"Teilen","copyButton.copy":"Kopieren","invitationText0":"Ich empfehle dir, Monestry auszuprobieren, eine neue Finanzplanungs-App! Schau es dir hier an: http://www.monestry.de/features.","invitationText1":"Du kannst es 30 Tage lang kostenlos ausprobieren, und wenn du dich entscheidest zu abonnieren, bekommst du einen zus\xe4tzlichen Monat kostenlos dazu.","invitationText2":"Benutze diesen Link, um dich anzumelden: https://www.monestry.de/register?registrationCode={{code}} oder gib den Code {{code}} bei der Anmeldung ein."}');


var $d60250523f119099$exports = {};
$d60250523f119099$exports = JSON.parse('{"dataUpdatedSuccessfully":{"type":"success","header":"Success","body":"Data have been updated."},"accountCreatedSuccessfully":{"type":"success","header":"Success","body":"Account has been created."},"accountUpdatedSuccessfully":{"type":"success","header":"Success","body":"Account has been updated."},"profileUpdatedSuccessfully":{"type":"success","header":"Success","body":"Profile updated successfully."},"profileCouldNotBeUpdated":{"type":"error","header":"Error","body":"Profile could not be updated."},"accountDeletedSuccessfully":{"type":"success","header":"Success","body":"Account has been deleted."},"dataUpdatedWithErrors":{"type":"error","header":"Error","body":"Data could not be updated."},"accountCouldNotBeCreated":{"type":"error","header":"Error","body":"Your account could not be created."},"accountCouldNotBeUpdated":{"type":"error","header":"Error","body":"Your account could not be updated."},"dataUpdateProblems":{"type":"warning","header":"Warning","body":"Some of your transactions may not have been updated."},"dataUpdateError":{"type":"error","header":"Error","body":"We could not update your data. Please check your network connection."},"projectUpdateError":{"type":"error","header":"Error","body":"We could not update your project. Please check your network connection."},"dataUpdateErrorContents":{"type":"error","header":"Error","body":"We could not update your data. Please check the form values and try again."},"checkYourData":{"type":"error","header":"Error","body":"Data could not be saved. Error messages are in cell comments."},"fileUploadAbortedSuccessfully":{"type":"success","header":"Success","body":"File upload cancelled. Data have not been changed."},"surveySendingError":{"type":"error","header":"Survey sending error","body":"We could not send your data."},"surveySentSuccessfully":{"type":"success","header":"Thank you!","body":"Survey has been sent successfully."},"transactionNotSelected":{"type":"error","header":"No transaction selected","body":"Please select a transaction to link the fee to."},"symbolNotSelected":{"type":"error","header":"No stock selected","body":"Please select the stock and account combination which generated the dividend."},"incorrectPassword":{"type":"error","header":"Incorrect password","body":"The current password was incorrect."},"attemptLimitExceeded":{"type":"error","header":"Too many attempts","body":"The system detected several password change attempts within the last few minutes. For security reasons it is now not possible to change your password. Please try again in 15 minutes."},"fileTooLarge":{"type":"error","header":"File too large","body":"We can only process files smaller than 5MB."},"fileUploadError":{"type":"warning","header":"File upload failed","body":"Some files failed to upload."},"noDataForDateFilter":{"type":"error","header":"No data found","body":"There are no data for this period. Back to previously selected period."},"transactionCreatedSuccess":{"type":"success","header":"Success","body":"Transaction created successfully."},"transactionCreatedError":{"type":"error","header":"Error","body":"Transaction could not be created."},"applyProjectTemplateSuccess":{"type":"success","header":"Success","body":"Template applied successfully."},"applyProjectTemplateError":{"type":"error","header":"Error","body":"We could not apply the template."},"noLinkedAccount":{"type":"error","header":"Error","body":"Your asset account has no linked bank account. Update your account details first."},"errorUpdatingStripe":{"type":"error","header":"Email change incomplete","body":"Your email was changed, but we could not update your payment contact email. Please reach out to our support."},"existingBankConnectionDetected":{"type":"info","header":"Bank login already exists","body":"You have already logged in to this bank. Bypassing bank login."},"newsletterSubscriptionSuccess":{"type":"success","header":"Success","body":"You have successfully registered to our newsletter."},"newsletterSubscriptionError":{"type":"error","header":"Error","body":"We could not register you to our newsletter."},"noMoreAccountsAllowed":{"type":"error","header":"Error","body":"You have reached the maximum number of accounts allowed for your subscription plan."},"inconsistentAssetTransactions":{"type":"warning","header":"Warning","body":"The asset transactions for {{displayName}} in account {{accountName}} are not in the same currency."},"moreThan1ConnectedAccountFound":{"type":"warning","header":"Warning","body":"This asset account is linked to more than 1 deposit account."},"gridGetPurchaseValuesNoRows":{"type":"warning","header":"No suitable rows found","body":"Provide asset details (weight, purity...) or remove price."},"generalError":{"type":"error","header":"Error","body":"The application encountered an error. Please try again later."},"validationError":{"type":"error","header":"Error","body":"Data incorrect - validation failed."},"renewAccountAccessSuccess":{"type":"success","header":"Success","body":"Account access renewed successfully."},"renewAccountAccessCancelled":{"type":"success","header":"Success","body":"Process cancelled successfully."},"renewAccountAccessError":{"type":"error","header":"Error","body":"We were unable to renew your account access. Please contact our support team."},"unableToUpdateAllTransactions":{"type":"warning","header":"Warning","body":"unable to update all transactions"}}');


var $025d02c4f20af15b$exports = {};
$025d02c4f20af15b$exports = JSON.parse('{"dataUpdatedSuccessfully":{"type":"success","header":"Erfolg","body":"Daten wurden erfolgreich aktualisiert."},"accountCreatedSuccessfully":{"type":"success","header":"Erfolg","body":"Konto erfolgreich angelegt."},"accountUpdatedSuccessfully":{"type":"success","header":"Erfolg","body":"Konto erfolgreich aktualisiert."},"profileUpdatedSuccessfully":{"type":"success","header":"Erfolg","body":"Profil erfolgreich aktualisiert."},"profileCouldNotBeUpdated":{"type":"error","header":"Fehler","body":"Profil konnte leider nicht aktualisiert werden."},"accountDeletedSuccessfully":{"type":"success","header":"Success","body":"Konto gel\xf6scht."},"dataUpdatedWithErrors":{"type":"error","header":"Fehler","body":"Daten konnten nicht aktualisiert werden."},"accountCouldNotBeCreated":{"type":"error","header":"Fehler","body":"Konto konnte leider nicht angelegt werden."},"accountCouldNotBeUpdated":{"type":"error","header":"Fehler","body":"Konto konnte leider nicht aktualisiert werden."},"dataUpdateProblems":{"type":"warning","header":"Warnung","body":"Einige Transaktionen k\xf6nnten leider nicht aktualisiert werden."},"dataUpdateError":{"type":"error","header":"Fehler","body":"Daten konnten leider nicht aktualisiert werden. Bitte \xfcberpr\xfcfe die Netzwerkverbindung."},"projectUpdateError":{"type":"error","header":"Error","body":"Projekt konnte leider nicht aktualisiert werden. Bitte \xfcberpr\xfcfe die Netzwerkverbindung."},"dataUpdateErrorContents":{"type":"error","header":"Fehler","body":"Daten konnten leider nicht aktualisiert werden. Bitte \xfcberpr\xfcfe die Werte des Formulars."},"checkYourData":{"type":"error","header":"Fehler","body":"\xc4nderungen nicht gespeichert. Siehe Zell-Kommentaren."},"fileUploadAbortedSuccessfully":{"type":"success","header":"Erfolg","body":"Datei-Upload storniert. Datei wurde nicht hochgeladen."},"Error. Request failed with status code 502":{"type":"error","header":"Sync fehlgeschlagen","body":"Daten konnten nicht synchronisiert werden. Bitte versuche es in 30 Sekunden noch einmal."},"surveySendingError":{"type":"error","header":"Umfrage konnte nicht geschickt werden","body":"Die Daten konnten nicht \xfcbermittelt werden."},"surveySentSuccessfully":{"type":"success","header":"Vielen Dank!","body":"Die Umfrage ist erfolgreich \xfcbermittelt worden."},"transactionNotSelected":{"type":"error","header":"Keine Transaktion ausgew\xe4hlt","body":"Bitte w\xe4hle eine Transaktion aus, die die Geb\xfchren verursacht hat."},"symbolNotSelected":{"type":"error","header":"Kein Wertpapier ausgew\xe4hlt","body":"Bitte w\xe4hle ein Wertpapier aus, das die Dividende gezahlt hat."},"incorrectPassword":{"type":"error","header":"Falsches Passwort","body":"Das bisherige Passwort war leider falsch."},"attemptLimitExceeded":{"type":"error","header":"Zu viele Versuche","body":"Wir haben zu viele Passwort-Versuche registriert und aus Sicherheitsgr\xfcnden diese Funktion tempor\xe4r gesperrt. Bitte warte 15 Minuten und versuche es dann noch einmal."},"fileTooLarge":{"type":"error","header":"Datei zu gro\xdf","body":"Wir k\xf6nnen leider nur Dateien kleiner als 5MB verarbeiten."},"fileUploadError":{"type":"warning","header":"Datei-Upload fehlgeschlagen","body":"Einige Dateien konnten nicht hochgeladen werden."},"noDataForDateFilter":{"type":"error","header":"Keine Daten","body":"F\xfcr die gew\xe4hlte Periode gebet es keine Daten. Zur\xfcck zur urspr\xfcnglich gew\xe4hlten Periode."},"applyProjectTemplateSuccess":{"type":"success","header":"Erfolg","body":"Vorlage erfolgreich angewendet."},"applyProjectTemplateError":{"type":"error","header":"Fehler","body":"Vorlage konnte nicht angewendet werden."},"addTransactionManually":{"type":"warning","header":"Warning","body":"Kauftransaktion konnte nicht automatisch registriert werden. Bitte f\xfcge sie manuell hinzu.","button":"OK","button2":"Cancel"},"noLinkedAccount":{"type":"error","header":"Error","body":"Dein Asset-Konto hat kein verkn\xfcpftes Bankkonto. Bitte erg\xe4nze dies in der Kontoansicht."},"errorUpdatingStripe":{"type":"error","header":"Emailwechsel unvollst\xe4ndig","body":"Deine E-Mail wurde ge\xe4ndert, aber leider nicht bei unserem Zahlungsdienstleister. Bitte wende dich an unseren Support."},"existingBankConnectionDetected":{"type":"info","header":"Bank-Login bereits vorhanden","body":"Du hast dich bei deiner Bank bereits eingeloggt. Login ist somit nicht mehr erforderlich."},"newsletterSubscriptionSuccess":{"type":"success","header":"Erfolg","body":"Newsletter-Anmeldung erfolgreich."},"newsletterSubscriptionError":{"type":"error","header":"Fehler","body":"Newsletter-Anmeldung fehlgeschlagen."},"noMoreAccountsAllowed":{"type":"error","header":"Fehler","body":"Du hast die maximale Anzahl an Konten des Abos erreicht."},"inconsistentAssetTransactions":{"type":"warninig","header":"Warnung","body":"Anlage-Transaktionen f\xfcr {{displayName}} in Konto {{accountName}} finden in unterschiedlichen W\xe4hrungen statt."},"moreThan1ConnectedAccountFound":{"type":"warning","header":"Warnung","body":"Dieses Anlage-Konto ist mit mehr als 1 Bankkonto verbunden."},"generalError":{"type":"error","header":"Fehler","body":"Ein Fehler ist aufgetreten. Bitte versuche es sp\xe4ter noch einmal."},"validationError":{"type":"error","header":"Fehler","body":"Daten konnten leider nicht validiert werden."},"renewAccountAccessSuccess":{"type":"success","header":"Erfolg","body":"Kontozugriff erfolgreich erneuert."},"renewAccountAccessCancelled":{"type":"success","header":"Erfolg","body":"Vorgang erfolgreich abgebrochen."},"renewAccountAccessError":{"type":"error","header":"Fehler","body":"Wir konnten den Kontozugriff nicht erneuern. Bitte kontaktiere unseren Support."},"unableToUpdateAllTransactions":{"type":"warning","header":"Warnung","body":"Nicht alle Transaktionen konnten aktualisiert werden."}}');


var $010f15a98c80264b$exports = {};
$010f15a98c80264b$exports = JSON.parse('{"addNewAccount":"Add new account","clickSubmitToContinue":"Click Submit to continue","thatsAllWeNeed":"That\'s all we need","errorCompleteStep":"Please complete the current step in order to proceed.","back":"Back","next":"Next","cancel":"Cancel","submit":"Submit","pressNextToContinue":"Press >Next< to continue.","pressSubmitToFinish":"Press >Submit< to finish.","currentBalance":"Current balance","common":{"connectedAccounts":{"title":"Which accounts do you use?","subtitle":"Link the bank accounts that fund or receive this pension\u2019s cash flows.","whenIBuy":"To {{buyOrSellText}}, I...","existingAccount":"... use existing bank accounts","existingAccountSelect":"Select one or more accounts","createAccountLater":"... use a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this {{categorySingle}} account."}},"D1":{"accountType":"Account type","whatKindOfAccount":"What kind of account do you want to add? Select the option which is the best match for your account","products":{"savings-account-giro":"Bank account for your daily expenditure and spending. You are able to withdraw and deposit money at any time.","savings-account-tagesgeld":"A savings account where - in theory - you get slightly more interest than with your Girokonto, but are often limited as to when you can withdraw.","savings-account-generic":"Bank account for your daily expenditure and spending. You are able to withdraw and deposit money at any time.","time-deposit-festgeld":"Bank deposit which you cannot withdraw until it reaches its maturity date.","time-deposit-generic":"Bank deposit which you cannot withdraw until it reaches its maturity date."}},"D2":{"automaticOrManual":"Automatic or manual updates","updateAutomatically":"Would you like us to get your data automatically? You can change it later.","automatic":{"label":"Automatic synchronisation","description":"We will set up a secure connection to your bank and take care of retrieving the lastest transactions. You may need to use your bank app to confirm that process. Manual import is still possible."},"manual":{"label":"Manual updates","description":"You can also use our intelligent data import to easily transfer data about your accounts. All you need to do is download the transactions from your bank website and upload them here."}},"D3":{"bank":"bank","banks":"banks","aBank":"a bank","yourBank":"your bank","broker":"broker","brokers":"brokers","aBroker":"a broker","yourBroker":"your broker","selectCountry":"Select country","accountCountry":"Account country","accountCountryBody":"In which country is your account (or the provider of your account) located?","selectCountryFirst":"Select account country above first.","select":"Select {{yourInstitutionType}}","retrievingInstitutions":"We are preparing the list...","nothingFound":"We cannot retrieve data from {{yourInstitutions}} in this country yet. You can add a bank manually by clicking the button below.","noSlots":"You have reached the limit of foreign {{yourInstitutions}} that we can provide automatic updates for. You can add a bank manually by clicking the button below.","noResultsFound":"No results found.","findYourBank":"Find {{yourInstitutionType}} in the list to synchronise your data automatically.","cannotFind":"If you can\'t find {{yourInstitutionType}} here, automatic data synchronisation is not yet possible. ","addManualAccount":"Add {{anInstitutionType}} manually","thisAccountManual":"This account will not be synchronised automatically. Data can be imported from a file or input manually.","thisAccountManual2":"To enable automatic synchronisation, please select {{anInstitutionType}} in the list above.","thisAccountManual3":"Press >Next< to continue.","intelligentImport":"Find your bank in the list so that our intelligent import knows what data structure to expect.","couldNotFindAnything":"We couldn\'t find anything with that term. Please try again.","youHaveSelected":"You have selected","yourSelection":"Your selection","details":"Details of the selected bank","search":"Search"},"D4":{"account":"Account","accountInfo":"Account information","accountInfoManual":"Please provide some information about your account.","accountInfoAutomatic":"We have retrieved this information about your account from your bank.","accountInfoAutomatic2":" Uncheck >This account will be created< to stop it from being created in Monestry.","connectedCashAccount":"Connected cash account","whichCashAccount":"Which cash account do you use to buy and sell securities?","whyDoWeAsk":"Why do we need a connected cash account?","whyDoWeAskAnswer":"We calculate return from investment and income from capital based on data from cash accounts, which the stocks transactions are deducted from or credited to.","notHaveAccount":"What if I don\'t have a separate cash account?","notHaveAccountAnswer":"If your broker handles all cash transactions, we will create a \'technical account\' for you so that you have a better picture of all the cash operations - just pick that option on the bottom of the form.","whenIBuy":"When I buy securities, the money...","existingAccount":"... is deducted from an existing bank account","existingAccountSelect":"Select that bank account","createTechnicalAccount":"... is deducted from a cash account at my brokerage firm","createTechnicalAccountCurrency":"In what currency is this cash account?","createAccountLater":"... is deducted from a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this account.","gettingAdditionalAccountInformation":"Getting additional account information...","providerAllAccountsAdded":"No new accounts found. All accounts have been added.","accountName":{"label":"Account name","tooltip":"What name would you like to see for this account in the system?","error":"Please enter a designation for this account."},"baseCurrency":{"label":"Base currency","tooltip":"What currency does this account use?"},"iban":{"label":"IBAN","tooltip":"This account\'s IBAN (account number)","placeholder":"DE12345678901234567890"},"bic":{"label":"BIC","tooltip":"International bank code (called >BIC<) for the bank where this account is at. Up to 11 characters long. Used to identify a bank in an international setting."},"bankName":{"label":"Bank name","tooltip":"Name of the bank where this account is at.","placeholder":"Sparkasse Bielefeld"},"brokerName":{"label":"Provider name","tooltip":"Which broker is this account with?","placeholder":"DepotX"},"accountNo":{"label":"Account number","tooltip":"What is the number of your brokerage account?","placeholder":"C12345678"},"isImported":{"label":"This account will be created.","tooltip":"Untick this box to stop this account from being created.","error":"You can only create {{num}} more accounts on your current plan.","error1":"You can only create one more account on your current plan.","error0":"You cannot create any more accounts on your current plan."},"connectedDepositMode":{"error":"Please choose how to link a deposit account to this one."}},"R1":{"accountInfo":"Account information","provideInfo":"Provide some information about your property.","oneAccount":"One account covers exactly one property - if you own more than one, create more accounts.","whyDoWeAsk":"Why do we want to know?","whyDoWeAskAnswer":"These are all the parameters used to calculate your property\'s value.","doIHaveToFillThemAllOut":"Do I have to fill out all those fields?","doIHaveToFillThemAllOutAnswer":"No, but the more information you provide, the better the automatic valuation will be.","name":{"label":"Property name","tooltip":"What name would you like to see for this property in the app?","placeholder":"Apartment in Bielefeld","error":"Please enter your designation for this property."},"originalPrice":{"label":"Purchase price","tooltip":"How much did it cost you? You can change it later.","placeholder":"456000","error":"If purchase date is provided, we will also need a purchase price for this property. You can change it later."},"date":{"label":"Purchase date","tooltip":"Since when do you own it? You can change it later.","placeholder":"2015-05-15","error":"If purchase price is entered, we will also need a purchase date for this property. You can change it later."},"automaticUpdate":{"label":"Update value automatically?","tooltip":"Turn it on to allow automatic updates for this property\'s value. You can change it later.","disabled":"Automatic value updates for your account are in use for other properties or not available."},"currency":{"label":"Currency","tooltip":"What currency would you like to track this property\'s value in? Typically this is the currency of the country where the property is located. We will automatically convert that value to your base currency."},"kindOfProperty":"What kind of property is this?","type":{"label":"Property type","apartment":"Apartment","house":"House"},"streetAddress":{"label":"Street and number","tooltip":"Where is your property located?","placeholder":"Hochstr. 12"},"zip":{"label":"Postal code","tooltip":"What postal code does your property have?","placeholder":"33602"},"city":{"label":"City / town","tooltip":"What city / town / village is your property located at?","placeholder":"Bielefeld"},"country":{"label":"Country","tooltip":"What country is your property located in?","placeholder":"Germany"},"livingArea":{"label":"Floor area","tooltip":"How big is your property (in square meters)?","placeholder":"88"},"rooms":{"label":"Rooms","tooltip":"How many rooms does your property have?","placeholder":"3"},"lotArea":{"label":"Lot area","tooltip":"How big is the lot your property is located on (in square meters)?","placeholder":"450"},"constructionYear":{"label":"Construction year","tooltip":"When was your property built?","placeholder":"2010"},"parking":{"label":"Private parking included?"}},"S1":{"accountInformation":"Account information","description":"Provide some information about your account.","whyDoWeAsk":"Why do we ask?","whyDoWeAskAnswer":"We use data like account number, username, connected cash account to link cash transactions with your stock market transactions. You don&apos;t have to provide them, but our system may not be able to link the appropriate transactions and you may need to do that manually.","name":{"label":"Account name","tooltip":"What name would you like to see for this account in this app?","placeholder":"DepotX brokerage account","error":"Please enter your designation for this account."},"brokerName":{"label":"Provider name","tooltip":"Which broker is this account with?","placeholder":"DepotX"},"accountNo":{"label":"Account number","tooltip":"What is the number of your brokerage account?","placeholder":"C12345678"},"username":{"label":"Your username for this brokerage account","tooltip":"The username you use to log in to this account.","placeholder":"ab12345678"}},"S2":{"connectedCashAccount":"Connected cash account","whichCashAccount":"Which cash account do you use to buy and sell securities?","whyDoWeAsk":"Why do we need a connected cash account?","whyDoWeAskAnswer":"We calculate return from investment and income from capital based on data from cash accounts, which the stocks transactions are deducted from or credited to.","notHaveAccount":"What if I don\'t have a separate cash account?","notHaveAccountAnswer":"If your broker handles all cash transactions, we will create a \'technical account\' for you so that you have a better picture of all the cash operations - just pick that option on the bottom of the form.","whenIBuy":"When I buy securities, the money...","existingAccount":"... is deducted from an existing bank account","existingAccountSelect":"Select that bank account","createTechnicalAccount":"... is deducted from a cash account at my brokerage firm","createTechnicalAccountCurrency":"In what currency is this cash account?","createAccountLater":"... is deducted from a bank account which I will set up later","createAccountLaterDescription":"As soon as the bank account is added, open the detail view of this account and link the bank account there."},"loans":{"given":"Loan given","taken":"Loan taken","provideSomeParameters":"Please provider some parameters which we will use to simulate future loan payments. You don\'t need to enter past changes, as they are reflected in the loan account transactions already.","loanAmount":{"label":"Loan amount","tooltip":"Enter the total amount of the loan (principal / capital only).","error":"Please enter the loan amount."},"direction":{"label":"Loan taken or given?","tooltip":"If you borrowed money, select \'taken\'; otherwise select \'given\'.","error":"Please mark if this is a taken or given loan."},"period":{"month":"month","quarter":"quarter","year":"year","label":"Installments repaid every","placeholder":"Select period","tooltip":"How often do you pay loan installments?","error":"Please select the installment period."},"interestRate":{"text":"Interest rate and in some cases the installment amount may change over time. Use >Advanced< button if you wish to enter those changes now. You can also do it later.","label":"Interest rate (%)","tooltip":"Enter the annual interest rate for the loan.","error":"Please enter the annual interest rate in %."},"endDate":{"text":"If you enter an end date, the simulation will calculate last installment as the entire outstanding debt (also know as a balloon payment or Restschuld). If you plan to take out a different loan, enter the end date here and create another loan account starting on the month of the last installment of this loan.","label":"Loan contract end date","tooltip":"When does the loan contract end? You can leave this field empty.","error":"It must be a future date"},"calculateUntilEnd":{"label":"Simulate until completely repaid","tooltip":"If you want to simulate the loan payments until the end of the loan term, select this option."},"advanced":"Advanced","installmentCalc":"Is the loan installment the same every time? Select \'Annuity\'. Is it lower every time (you pay back a fixed amount of capital every month with changing interest)? Select \'Fixed Principal\'. If you only pay back the interest (capital is repaid at term\'s end), select \'Interest Only\'. Don\'t forget to enter an end date so that we can calculate the last installment.","type":{"annuity":"Annuity","fixedPrincipal":"Fixed principal","interestOnly":"Interest only","label":"Installment type","tooltip":"How is your installment calculated? See note on the left for explanation.","error":"Please select the installment type."},"byInstallentAmount":"Enter the amount of each installment (annuity).","byTilgungsrate":"Enter the percentage of the loan amount to be repaid annually (\'Tilgunsrate\').","annuitySubtype":{"error":"Please select an option."},"annuitySubtypeAmount":{"label":"Installment amount","tooltip":"Enter the amount for your fixed installment.","error":"Please enter the amount for your fixed installment."},"annuitySubtypeTilgung":{"label":"Annual repayment rate (Tilgung) (%)","tooltip":"Specify the percentage of the loan amount to be repaid annually.","error":"Please enter the percentage of the loan amount to be repaid every year."},"fixedPrincipalSubtype":{"error":"Please select an option."},"byPrincipalRepaid":"Enter the amount of principal (capital) to be repaid in each period.","fixedPrincipalSubtypeAmount":{"label":"Principal amount","tooltip":"Enter the principal (capital) amount to be repaid in each period.","error":"Please enter the amount to be repaid in each period."},"fixedPrincipalSubtypeTilgung":{"label":"Annual repayment rate (Tilgung) (%)","tooltip":"Specify the percentage of the loan amount to be repaid annually.","error":"Please enter the percentage of the loan amount to be repaid every year."},"connectedDepositAccount":"In order to track the loan payouts and payments, we need to know which account the money is coming from and going to. If you use more than one, you can add the other account later.","connectedDepositMode":{"error":"Please choose how you\'ll connect the deposit account."},"existingAccount":"Existing account","existingAccountSelect":"Select an existing account","createAccountLater":"Create account later","createAccountLaterDescription":"You can choose to connect a deposit account later.","loanProject":"You can see the simulated future payments in Projects. If you already have a Project for this loan, select it here. If not, mark >Create new project<.","connectedProjectId":{"label":"Connected project","tooltip":"Select the project associated with this loan."},"projectCreateNew":"Create a new project","bereitstellungszinsen":{"text":"Interest before complete loan payout (Bereitstellungszinsen)","label":"Intial interest rate (%)","tooltip":"Enter the interest rate charged on the undrawn portion of the loan."},"bereitstellungszinsenSinceDate":{"label":"Beginning on","tooltip":"Specify the date from which the commitment interest will be calculated."},"interestAfterTerm":{"text":"Apply new interest after loan contract end date. This will enable \'simulate until completely repaid\' option above and apply this interest rate from the specified date.","label":"Interest after contract ends (%)","tooltip":"Enter the interest rate applicable after the initial term ends."},"interestAfterTermSinceDate":{"label":"Beginning on","tooltip":"Indicate the start date for the post-term interest rate."},"interestCalculationCutoff":"Does your bank calculate your installment on month beginning or on month end? If at month end, then all the extra repayments made in that month will already be reflected in the installment\'s interest to principal ratio. If month beginning, then they will only be reflected the following month.,","interestCalcMonthEnd":{"label":"Interest is calculated at month end","tooltip":"Toggle whether to calculate interest at the end of each month."}},"pension":{"wizardSteps":{"newAccount":{"title":"Add new account","subtitle":"Tell us basic information about this pension product so we can set up the workflow for you."},"selectProduct":{"title":"What product is this?","subtitle":"Choose the product type or template that best matches what you\u2019re adding."},"contributions":{"title":"How do you pay for it?","subtitle":"Describe how and when contributions are made so we can project the balance."},"payouts":{"title":"How will your pension be paid out?","subtitle":"Let us know the payout cadence and rules for the retirement phase."},"payoutsAmount":{"title":"How much will you receive?","subtitle":"Enter one or more future payouts. You will find them in the latest statement you received from your pension provider. Pick one to be used for net worth calculations.","useThisCta":"Use this quote","useThisActive":"\u2714\uFE0F Used for calculations","payoutsAmountUseSpecialQuoteValidation":"Select which quote to use"},"connectedAccount":{"title":"Which accounts do you use?","subtitle":"Link the bank accounts that fund or receive this pension\u2019s cash flows.","buyOrSellText":"pay contributions or receive payouts on this pension product"}},"provideInfo":"Please provide a few details about your pension account.","whyDoWeAsk":"Why do we want to know?","whyDoWeAskAnswer":"We use these parameters to calculate your pension\'s value and simulate future payments.","doIHaveToFillThemAllOut":"Do I have to fill out all those fields?","doIHaveToFillThemAllOutAnswer":"We need some information to provide meaningful information to you. Fields marked \'optional\' are not strictly required, but will be used to calculate other useful data for you.","payoutsAmountValidation":"Please enter at least one payout amount","payoutsAmountUseSpecialQuoteValidation":"Select which quote to use","useATemplate":"Use a template!","useATemplateAnswer":"The most common pension products have already been configured for you - just select one from the list.","yourPensionContributions":"Contributions - when I save","yourPensionPayouts":"Payouts - when I retire","whenIBuy":"When I buy securities, the money...","existingAccount":"... is deducted from an existing bank account","existingAccountSelect":"Select that bank account","createAccountLater":"... is deducted from a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this account.","product":{"label":"Product type","tooltip":"Select the type of pension product you have. If you can\'t find it in the list, select \'Custom\'.","pension-drv":{"name":"State pension (DRV)","description":"State pension (e.g. Deutsche Rentenversicherung) is state-managed pension scheme in Germany. Your employer and you pay contributions, and the pension is paid out by the state. Pension payouts are generally taxable and get increased over time."},"pension-betriebliche":{"name":"Company pension (Betriebliche Rente)","description":"Company pension is a pension scheme offered by your employer. Contributions are deducted from your salary before taxes, sometimes with your employer contribution. Your pension is taxed when paid out."},"pension-riester":{"name":"Riester pension","description":"Riester pension is a state-subsidised pension scheme in Germany. Contributions are tax-deductible and the pension is taxed when paid out. The minimal payout is guaranteed to be at least equal to sum of your contributions."},"pension-ruerup":{"name":"R\xfcrup pension","description":"R\xfcrup pension is a state-subsidised pension scheme in Germany. Contributions are tax-deductible and the pension is taxed when paid out."},"custom":{"name":"Custom","description":"Configure any other product."},"selected":"Selected"}},"objectsOfValue":{"accountInfo":"Add new account","provideInfo":"Please provide a few details about your pension account.","whyDoWeAsk":"Why do we want to know?","whyDoWeAskAnswer":"We use these parameters to calculate your pension\'s value and simulate future payments.","whenIBuy":"When I buy objects of value, the money...","existingAccount":"... is deducted from an existing bank account","existingAccountSelect":"Select that bank account","createAccountLater":"... is deducted from a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this account."},"metals":{"accountInfo":"Add new account","provideInfo":"You can decide how you want to structure your precious metals assets by organising them into accounts. You can create multiple accounts for different types of metals or different storage locations.","whenIBuy":"When I buy precious metals, the money...","existingAccount":"... is deducted from an existing bank account","existingAccountSelect":"Select that bank account","createAccountLater":"... is deducted from a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this account."},"unlistedShares":{"accountInfo":"Add new account","provideInfo":"Please provide a few basic details to get started. Once the account has been created, you will be able to add more investments and valuations.","whenIBuy":"When I make investments in my company, the money...","existingAccount":"... is transferred from an existing bank account","existingAccountSelect":"Select that bank account","createAccountLater":"... is transferred from a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this account.","fxRate":"Exchange rate: {{fxRate}}.","apply":"Apply"},"crypto":{"accountInfo":"Add new account","provideInfo":"Please provide some basic information about your account. Once the account is created, you can add your actual cryptocurrencies.","whenIBuy":"When I buy crypto assets, the money...","existingAccount":"... is deducted from an existing bank account","existingAccountSelect":"Select that bank account","createAccountLater":"... is deducted from a bank account which I will set up later","createAccountLaterDescription":"Once you set up that account, remember to update the linked account in this account.","createTechnicalAccount":"... is deducted from a cash account at my brokerage / exchange","createTechnicalAccountTooltip":"If you select this option, we will create a cash account automatically.","createTechnicalAccountCurrency":"In what currency is this cash account?"}}');


var $f3ea9442ec916f5d$exports = {};
$f3ea9442ec916f5d$exports = JSON.parse('{"addNewAccount":"Neues Konto hinzuf\xfcgen","clickSubmitToContinue":"Klicke auf \\"Absenden\\" um fortzufahren.","thatsAllWeNeed":"Das ist alles, was wir brauchen.","errorCompleteStep":"Schliesse bitte zuerst diesen Schritt ab.","back":"Zur\xfcck","next":"Weiter","cancel":"Abbrechen","submit":"Absenden","pressNextToContinue":"Klicke auf \\"Weiter\\" um fortzufahren.","pressSubmitToFinish":"Klicke auf \\"Absenden\\" um fortzufahren.","currentBalance":"Aktuelles Saldo","common":{"whenIBuy":"Wenn du {{categorySingle}} kaufst, das Geld...","existingAccount":"...wird von einem bestehenden Bankkonto abgezogen.","existingAccountSelect":"W\xe4hle dieses Bankkonto aus.","createAccountLater":"... wird von einem Bankkonto abgebucht, das ich sp\xe4ter einrichten werde.","createAccountLaterDescription":"Sobald du dieses Konto eingerichtet hast, denke daran, das verkn\xfcpfte Konto in diesem Konto zu aktualisieren."},"D1":{"accountType":"Kontoart","whatKindOfAccount":"Welche Art von Konto m\xf6chtest du hinzuf\xfcgen? W\xe4hle die Option, die am besten zu deinem Konto passt.","products":{"savings-account-giro":"Bankkonto f\xfcr deine t\xe4glichen Ausgaben und Ausgaben. Du kannst jederzeit Geld abheben und einzahlen.","savings-account-tagesgeld":"Ein Sparbuch, in dem du - theoretisch - etwas mehr Zinsen als mit deinem Girokonto erh\xe4ltst, aber oft daran gehindert bist, wann du abheben kannst.","savings-account-generic":"Bankkonto f\xfcr deine t\xe4glichen Ausgaben und Ausgaben. Du kannst jederzeit Geld abheben und einzahlen.","time-deposit-festgeld":"Bankeneinlage, die du bis zu ihrem F\xe4lligkeitstermin nicht abheben kannst.","time-deposit-generic":"Bankeneinlage, die du bis zu ihrem F\xe4lligkeitstermin nicht abheben kannst."}},"D2":{"automaticOrManual":"Automatisch oder manuelle Updates","updateAutomatically":"M\xf6chtest du, dass wir deine Daten automatisch abrufen? Du kannst es sp\xe4ter \xe4ndern.","automatic":{"label":"Automatische Synchronisierung","description":"Wir stellen eine sichere Verbindung zu deiner Bank her und k\xfcmmern uns um das Abrufen der letzten Transaktionen. Du musst m\xf6glicherweise deine Bank-App verwenden, um diesen Vorgang zu best\xe4tigen. Eine manuelle Import ist immer noch m\xf6glich."},"manual":{"label":"Manuelle Updates","description":"Du kannst auch unseren intelligenten Datenimport verwenden, um Daten \xfcber deine Konten einfach zu \xfcbertragen. Alles, was du tun musst, ist, die Transaktionen von deiner Bank-Website herunterzuladen und hier hochzuladen."}},"D3":{"bank":"Bank","banks":"Banken","aBank":"eine Bank","yourBank":"deine Bank","broker":"Broker","brokers":"Broker","aBroker":"einen Broker","yourBroker":"deinen Broker","accountCountry":"Land des Kontos","accountCountryBody":"In welchem Land befindet sich das Institut, wo das Konto gef\xfchrt wird?","selectCountry":"W\xe4hle Land","select":"W\xe4hle {{yourInstitutionType}} aus","selectCountryFirst":"W\xe4hle zuerst das Land oben.","retrievingInstitutions":"Wir bereiten die Liste vor...","nothingFound":"In diesem Land sind {{yourInstitutions}} leider noch nicht angebunden. F\xfcge {{yourInstitutionType}} manuell mit dem Knopf unten hinzu.","noSlots":"Du hast bereits die maximale Anzahl von automatischen Updates bei ausl\xe4ndischen Finanzinsituten erreicht. F\xfcge {{yourInstitutionType}} manuell mit dem Knopf unten hinzu.","findYourBank":"Finde {{yourInstitutionType}} in der Liste, um deine Daten automatisch zu synchronisieren.","cannotFind":"Wenn du deine Bank hier nicht finden kannst, ist eine automatische Datensynchronisierung noch nicht m\xf6glich. Geh einen Schritt zur\xfcck und w\xe4hle >Manual updates<","noResultsFound":"Keine Ergebnisse gefunden","thisAccountManual":"Dieses Konto wird nicht automatisch synchonisiert. Daten k\xf6nnem manuell importiert oder eingegeben werden.","thisAccountManual2":"Um automatische Synchronisierung zu aktivieren, w\xe4hle {{anInstitutionType}} aus der Liste oben.","thisAccountManual3":"Fortsetzen mit >Weiter<.","addManualAccount":"Bank manuell hinzuf\xfcgen","intelligentImport":"Dies ist die Liste aller Banken, wo wir deine Daten automatisch abfragen k\xf6nnen. Falls du deine Bank hier nicht finden kannst, kannst du deine Daten manuell importieren.","couldNotFindAnything":"F\xfcr diesen Begriff gab es keine Suchtreffer. Bitte versuche es erneut.","youHaveSelected":"Deine Auswahl","yourSelection":"Deine Auswahl","details":"Details der ausgew\xe4hlten Bank","search":"Suche"},"D4":{"account":"Konto","accountInfo":"Kontodaten","accountInfoManual":"Bitte gib einige Informationen zu deinem Konto an.","accountInfoAutomatic":"Deine Bank hat uns diese Kontoinformationen \xfcbermittelt.","accountInfoAutomatic2":"Deaktiviere >Dieses Konto wird erstellt<, um zu verhindern, dass es in Monestry erstellt wird.","whichCashAccount":"Welches Bankkonto verwendest du, um Wertpapiere zu kaufen und zu verkaufen?","whyDoWeAsk":"Warum ben\xf6tigen wir ein verbundenes Bankkonto?","whyDoWeAskAnswer":"Wir berechnen die Rendite aus der Investition und das Kapitaleinkommen anhand von Bewegungen auf Bankkonten, aus denen die Aktienums\xe4tze abgezogen oder gutgeschrieben werden.","notHaveAccount":"Was ist, wenn ich kein separates Bankkonto habe?","notHaveAccountAnswer":"Wenn dein Broker alle Bargeldtransaktionen abwickelt, erstellen wir ein \'technisches Konto\', damit du ein besseres Bild von allen Transaktionen hast - w\xe4hle dazu einfach die Option am Ende des Formulars.","whenIBuy":"Wenn ich Wertpapiere kaufe, wird das Geld...","existingAccount":"... von einem vorhandenen Bankkonto abgezogen","existingAccountSelect":"W\xe4hle das Bankkonto aus","createTechnicalAccount":"... von einem Bankkonto bei meiner Brokerfirma abgezogen","createTechnicalAccountCurrency":"In welcher W\xe4hrung ist dieses Bankkonto?","createAccountLater":"... von einem Bankkonto abgezogen, das ich sp\xe4ter einrichte","createAccountLaterDescription":"Sobald das neue Bankkonto angelegt wird, \xf6ffne die Detailansicht dieses Kontos und f\xfcge es hinzu.","gettingAdditionalAccountInformation":"Zus\xe4tzliche Kontoinformationen werden abgerufen...","providerAllAccountsAdded":"Keine neue Kontos gefunden. Alle Konten wurden bereits hinzugef\xfcgt.","accountName":{"label":"Kontoname","tooltip":"Unter welchem Namen m\xf6chtest du dieses Konto im System sehen?","error":"Bitte gebe eine Bezeichnung f\xfcr dieses Konto ein."},"baseCurrency":{"label":"Basisw\xe4hrung","tooltip":"Welche W\xe4hrung m\xf6chtest du als Basisw\xe4hrung verwenden? In der Regel ist dies die W\xe4hrung, in der du verdienst."},"iban":{"label":"IBAN","tooltip":"Die IBAN-Nummer dieses Kontos. Beginnt mit einem Land-K\xfcrzel z.B. >DE< f\xfcr Deutschland.","placeholder":"DE12345678901234567890"},"bic":{"label":"BIC","tooltip":"Internationaler Bankcode (genannt >BIC<) f\xfcr die Bank, bei der dieses Konto gef\xfchrt wird. Bis zu 11 Zeichen lang. Dient zur Identifikation einer Bank im internationalen Kontext."},"bankName":{"label":"Bankname","tooltip":"Name der Bank, bei der dieses Konto gef\xfchrt wird.","placeholder":"Sparkasse Bielefeld"},"brokerName":{"label":"Brokername","tooltip":"Bei welchem Broker ist dieses Konto?","placeholder":"DepotX"},"isImported":{"label":"Dieses Konto wird erstellt.","tooltip":"Entferne das H\xe4kchen, um zu verhindern, dass dieses Konto erstellt wird.","error":"Dein Abo erlaubt nur {{num}} weitere Konten.","error1":"Dein Abo erlaubt nur ein weiteres Konto.","error0":"Dein Abo erlaubt keine weitere Konten."},"connectedDepositMode":{"error":"Bitte w\xe4hle eine Option aus."},"accountNo":{"label":"Depotnummer","tooltip":"Welche Nummer tr\xe4gt dein Depot?","placeholder":"C12345678"},"connectedCashAccount":"Verbundenes Girokonto"},"R1":{"accountInfo":"Kontoinformationen","provideInfo":"Bitte gebe einige Informationen zu deiner Immobilie an.","oneAccount":"Ein Konto deckt genau eine Immobilie ab - wenn du mehr als eines hast, erstelle mehr Konten.","whyDoWeAsk":"Warum wollen wir das wissen?","whyDoWeAskAnswer":"Das sind alle Parameter, die verwendet werden, um den Wert deiner Immobilie zu berechnen.","doIHaveToFillThemAllOut":"Muss ich alle Felder ausf\xfcllen?","doIHaveToFillThemAllOutAnswer":"Nein, aber je mehr Informationen du angibst, desto genauer wird die automatische Bewertung deiner Immobilie.","name":{"label":"Immobilienname","tooltip":"Welchen Namen m\xf6chtest du in der App f\xfcr diese Immobilie sehen?","placeholder":"Wohnung in Bielefeld","error":"Bitte gebe deine Bezeichnung f\xfcr diese Immobilie an."},"originalPrice":{"label":"Kaufpreis","tooltip":"Wie viel hat die Immobilie gekostet?","placeholder":"456000","error":"Solange Kaufdatum angegeben ist, muss auch der Kaufpreis vorhanden sein. Er kann nachher ge\xe4ndert werden."},"currency":{"label":"W\xe4hrung","tooltip":"In welcher W\xe4hrung m\xf6chstest du die Wertentwicklung dieser Immobilie verfolgen? Typischerweise ist dies die Wahrung des Landes, in dem die Immobilie liegt. Umrechnung in deine Basisw\xe4hrung erfolgt automatisch."},"automaticUpdate":{"label":"Automatische Wertaktualisierung?","tooltip":"Schalte es ein, um automatische Aktualisierungen des Immobilienweres zu aktivieren. Du kannst es sp\xe4ter \xe4ndern.","disabled":"Automatische Wertaktualisierung bereits eingesetzt oder nicht verf\xfcgbar."},"date":{"label":"Kaufdatum","tooltip":"Seit wann besizt du diese Immobilie? Du kannst dieses Datum nachher \xe4ndern.","placeholder":"2015-05-15","error":"Solange Kaufpreis angegeben ist, muss auch das Kaufdatum vorhanden sein. Es kann nachher ge\xe4ndert werden."},"kindOfProperty":"Um was f\xfcr eine Immobilie handelt es sich?","type":{"label":"Immobilientyp","apartment":"Wohnung","house":"Haus"},"streetAddress":{"label":"Stra\xdfe und Nummer","tooltip":"Wo befindet sich deine Immobilie?","placeholder":"Hochstr. 12"},"zip":{"label":"Postleitzahl","tooltip":"Welche Postleitzahl hat deine Immobilie?","placeholder":"33602"},"city":{"label":"Stadt","tooltip":"In welcher Stadt / Stadt / Dorf befindet sich deine Immobilie?","placeholder":"Bielefeld"},"country":{"label":"Land","tooltip":"In welchem Land befindet sich deine Immobilie?","placeholder":"Deutschland"},"livingArea":{"label":"Gesamtfl\xe4che","tooltip":"Wie gro\xdf ist deine Immobilie (in Quadratmetern)?","placeholder":"88"},"rooms":{"label":"Zimmer","tooltip":"Wie viele Zimmer hat deine Immobilie?","placeholder":"3"},"lotArea":{"label":"Grundst\xfccksfl\xe4che","tooltip":"Wie gro\xdf ist das Grundst\xfcck, auf dem sich deine Immobilie befindet (in Quadratmetern)?","placeholder":"450"},"constructionYear":{"label":"Baujahr","tooltip":"Wann wurde deine Immobilie gebaut?","placeholder":"2010"},"parking":{"label":"Privatparkplatz inklusive?"}},"S1":{"accountInformation":"Konteninformationen","description":"Geben Sie uns einige Informationen \xfcber dein Konto.","whyDoWeAsk":"Warum fragen wir?","whyDoWeAskAnswer":"Wir verwenden Daten wie Kontonummer, Benutzername, verbundenes Cash-Konto, um Bargeldtransaktionen mit Ihren B\xf6rsentransaktionen zu verkn\xfcpfen. Du musst sie nicht angeben, aber unser System kann m\xf6glicherweise die entsprechenden Transaktionen nicht verkn\xfcpfen und du musst diese m\xf6glicherweise manuell durchf\xfchren.","name":{"label":"Kontoname","tooltip":"Welchen Namen m\xf6chtest du in dieser App f\xfcr dieses Konto sehen?","placeholder":"DepotX-Brokerkonto","error":"Bitte geben Sie Ihre Bezeichnung f\xfcr dieses Konto ein."},"username":{"label":"Dein Benutzername f\xfcr dieses Brokerkonto","tooltip":"Der Benutzername, mit dem du dich in dieses Konto einloggst.","placeholder":"ab12345678"}},"S2":{"connectedCashAccount":"Verbundenes Bankkonto","whichCashAccount":"Welches Bankkonto verwendest du, um Wertpapiere zu kaufen und zu verkaufen?","whyDoWeAsk":"Warum ben\xf6tigen wir ein verbundenes Bankkonto?","whyDoWeAskAnswer":"Wir berechnen die Rendite aus der Investition und das Kapitaleinkommen anhand von Bewegungen auf Bankkonten, aus denen die Aktienums\xe4tze abgezogen oder gutgeschrieben werden.","notHaveAccount":"Was ist, wenn ich kein separates Bankkonto habe?","notHaveAccountAnswer":"Wenn dein Broker alle Bargeldtransaktionen abwickelt, erstellen wir ein \'technisches Konto\', damit du ein besseres Bild von allen Transaktionen hast - w\xe4hle dazu einfach die Option am Ende des Formulars.","whenIBuy":"Wenn ich Wertpapiere kaufe, wird das Geld...","existingAccount":"... von einem vorhandenen Bankkonto abgezogen","existingAccountSelect":"W\xe4hle das Bankkonto aus","createTechnicalAccount":"... von einem Bankkonto bei meiner Brokerfirma abgezogen","createTechnicalAccountCurrency":"In welcher W\xe4hrung ist dieses Bankkonto?","createAccountLater":"... von einem Bankkonto abgezogen, das ich sp\xe4ter einrichte","createAccountLaterDescription":"Sobald das Bankkonto hinzugef\xfcgt wird, \xf6ffnen Du die Detailansicht dieses Kontos und verkn\xfcpfen Du das Bankkonto dort."},"loans":{"given":"Darlehen gegeben","taken":"Darlehen genommen","provideSomeParameters":"Bitte gib einige Parameter an, die wir verwenden werden, um zuk\xfcnftige Darlehenszahlungen zu simulieren. Du musst keine vergangenen \xc4nderungen eingeben, da diese bereits in den Transaktionen des Darlehenskontos ber\xfccksichtigt sind.","loanAmount":{"label":"Darlehensbetrag","tooltip":"Gib den Gesamtbetrag des Darlehens ein (nur Hauptbetrag/Kapital).","error":"Bitte gib den Darlehensbetrag ein."},"direction":{"label":"Darlehen genommen oder gegeben?","tooltip":"Wenn du Geld geliehen hast, w\xe4hle \'genommen\'; sonst w\xe4hle \'gegeben\'.","error":"Bitte markiere, ob das Darlehen genommen oder gegeben ist."},"period":{"month":"Monat","quarter":"Quartal","year":"Jahr","label":"Raten werden alle","placeholder":"Periode ausw\xe4hlen","tooltip":"Wie oft zahlst du Darlehensraten?","error":"Bitte w\xe4hle die Ratenzahlungsperiode."},"interestRate":{"text":"Zinssatz und in einigen F\xe4llen kann sich der Ratenbetrag \xfcber die Zeit \xe4ndern. Verwende die >Erweitert< Schaltfl\xe4che, wenn du diese \xc4nderungen jetzt eingeben m\xf6chtest. Du kannst dies auch sp\xe4ter tun.","label":"Zinssatz (%)","tooltip":"Gib den j\xe4hrlichen Zinssatz f\xfcr das Darlehen ein.","error":"Bitte gib den j\xe4hrlichen Zinssatz in % ein."},"endDate":{"text":"Wenn du ein Enddatum eingibst, wird die Simulation die letzte Rate als die gesamte ausstehende Schuld berechnen (auch als Ballonzahlung oder Restschuld bekannt). Wenn du vorhast, ein anderes Darlehen aufzunehmen, gib hier das Enddatum ein und erstelle ein anderes Darlehenskonto, das im Monat der letzten Rate dieses Darlehens beginnt.","label":"Enddatum des Darlehensvertrags","tooltip":"Wann endet der Darlehensvertrag? Du kannst dieses Feld leer lassen.","error":"Datum muss in Zukunft liegen."},"calculateUntilEnd":{"label":"Bis zur vollst\xe4ndigen R\xfcckzahlung simulieren","tooltip":"Wenn du die Darlehenszahlungen bis zum Ende der Darlehenslaufzeit simulieren m\xf6chtest, w\xe4hle diese Option."},"advanced":"Erweitert","installmentCalc":"Ist die Darlehensrate jedes Mal gleich? W\xe4hle \'Annuit\xe4t\'. Wird sie jedes Mal niedriger (du zahlst jeden Monat einen festen Kapitalbetrag mit wechselnden Zinsen zur\xfcck)? W\xe4hle \'Festes Kapital\'. Wenn du nur die Zinsen zur\xfcckzahlst (das Kapital wird am Ende der Laufzeit zur\xfcckgezahlt), w\xe4hle \'Nur Zinsen\'. Vergiss nicht, ein Enddatum einzugeben, damit wir die letzte Rate berechnen k\xf6nnen.","type":{"annuity":"Annuit\xe4t","fixedPrincipal":"Festes Kapital","interestOnly":"Nur Zinsen","label":"Ratentyp","tooltip":"Wie wird deine Rate berechnet? Siehe Hinweis links zur Erkl\xe4rung.","error":"Bitte w\xe4hle den Ratentyp."},"byInstallentAmount":"Gib den Betrag jeder Rate (Annuit\xe4t) ein.","byTilgungsrate":"Gib den Prozentsatz des Darlehensbetrags ein, der j\xe4hrlich zur\xfcckgezahlt werden soll (\'Tilgungsrate\').","annuitySubtype":{"error":"Bitte w\xe4hle eine Option."},"annuitySubtypeAmount":{"label":"Ratenbetrag","tooltip":"Gib den Betrag f\xfcr deine feste Rate ein.","error":"Bitte gib den Betrag f\xfcr deine feste Rate ein."},"annuitySubtypeTilgung":{"label":"J\xe4hrliche Tilgung (%)","tooltip":"Gib den Prozentsatz des Darlehensbetrags an, der j\xe4hrlich zur\xfcckgezahlt wird.","error":"Bitte gib den Prozentsatz des j\xe4hrlich zur\xfcckgezahlten Darlehensbetrags ein."},"fixedPrincipalSubtype":{"error":"Bitte w\xe4hle eine Option."},"byPrincipalRepaid":"Gib den Betrag des Kapitals (Hauptbetrag) ein, der in jeder Periode zur\xfcckgezahlt wird.","fixedPrincipalSubtypeAmount":{"label":"Hauptbetrag","tooltip":"Gib den Hauptbetrag (Kapital) ein, der in jeder Periode zur\xfcckgezahlt wird.","error":"Bitte gib den Betrag ein, der in jeder Periode zur\xfcckgezahlt wird."},"fixedPrincipalSubtypeTilgung":{"label":"J\xe4hrliche Tilgung (%)","tooltip":"Gib den Prozentsatz des Darlehensbetrags an, der j\xe4hrlich zur\xfcckgezahlt wird.","error":"Bitte gib den Prozentsatz des j\xe4hrlich zur\xfcckgezahlten Darlehensbetrags ein."},"connectedDepositAccount":"Um die Darlehensauszahlungen und -zahlungen nachzuverfolgen, m\xfcssen wir wissen, von welchem Konto das Geld kommt und wohin es geht. Wenn du mehr als eines verwendest, kannst du das andere Konto sp\xe4ter hinzuf\xfcgen.","connectedDepositMode":{"error":"Bitte w\xe4hle, wie du das Einzahlungskonto verbinden m\xf6chtest."},"existingAccount":"Bestehendes Konto","existingAccountSelect":"W\xe4hle ein bestehendes Konto","createAccountLater":"Konto sp\xe4ter erstellen","createAccountLaterDescription":"Du kannst w\xe4hlen, sp\xe4ter ein Einzahlungskonto zu verbinden.","loanProject":"Du kannst die simulierten zuk\xfcnftigen Zahlungen in Projekten sehen. Wenn du bereits ein Projekt f\xfcr dieses Darlehen hast, w\xe4hle es hier. Wenn nicht, markiere >Neues Projekt erstellen<.","connectedProjectId":{"label":"Verbundenes Projekt","tooltip":"W\xe4hle das mit diesem Darlehen verbundene Projekt."},"projectCreateNew":"Erstelle ein neues Projekt","bereitstellungszinsen":{"text":"Zinsen vor vollst\xe4ndiger Darlehensauszahlung (Bereitstellungszinsen)","label":"Anf\xe4nglicher Zinssatz (%)","tooltip":"Gib den Zinssatz ein, der auf den nicht ausgezahlten Teil des Darlehens erhoben wird."},"bereitstellungszinsenSinceDate":{"label":"Beginnend am","tooltip":"Gib das Datum an, ab dem die Bereitstellungszinsen berechnet werden."},"interestAfterTerm":{"text":"Wende neuen Zinssatz nach Ende des Darlehensvertrags an. Dies erm\xf6glicht die Option \'bis zur vollst\xe4ndigen R\xfcckzahlung simulieren\' oben und wendet diesen Zinssatz ab dem angegebenen Datum an.","label":"Zinssatz nach Vertragsende (%)","tooltip":"Gib den Zinssatz ein, der nach dem urspr\xfcnglichen Ende der Laufzeit gilt."},"interestAfterTermSinceDate":{"label":"Beginnend am","tooltip":"Gib das Startdatum f\xfcr den Zinssatz nach Vertragsende an."},"interestCalculationCutoff":"Berechnet deine Bank deine Rate zu Monatsbeginn oder zu Monatsende? Wenn am Monatsende, dann werden alle zus\xe4tzlichen R\xfcckzahlungen, die in diesem Monat gemacht wurden, bereits in der Zins-Kapital-Relation der Rate reflektiert. Wenn zu Monatsbeginn, dann werden sie erst im folgenden Monat reflektiert.","interestCalcMonthEnd":{"label":"Zinsen werden am Monatsende berechnet","tooltip":"W\xe4hle, ob die Zinsen am Ende jeden Monats berechnet werden sollen."}},"pension":{"wizardSteps":{"newAccount":{"title":"Neues Produkt","subtitle":"Gib die grundlegenden Informationen zu diesem Rentenprodukt an, damit wir den Ablauf vorbereiten k\xf6nnen."},"selectProduct":{"title":"Welche Produktart ist das?","subtitle":"W\xe4hle den Produkttyp oder die Vorlage, die am besten zu deinem Produkt passt."},"contributions":{"title":"Wie wird das Produkt bezahlt?","subtitle":"Beschreibe, wie und wann Beitr\xe4ge geleistet werden, damit wir die Entwicklung berechnen k\xf6nnen."},"payouts":{"title":"Wie wird die Rente ausgezahlt?","subtitle":"Teile uns mit, wie und in welchem Rhythmus die Auszahlungen in der Rentenphase erfolgen."},"payoutsAmount":{"title":"Wie hoch wird die Leistung?","subtitle":"Trage die erwarteten Leistungsbetr\xe4ge aus deiner Anbieterinformation ein. Du kannst mehrere Betr\xe4ge eintragen und ausw\xe4hlen, welcher f\xfcr die Verm\xf6gensberechnung verwendet wird.","useThisCta":"Diesen Wert nutzen","useThisActive":"\u2714\uFE0F Verwendet f\xfcr Berechnungen","payoutsAmountUseSpecialQuoteValidation":"W\xe4hle aus, welcher Wert genutzt werden soll"},"connectedAccount":{"title":"Welche Konten werden genutzt?","subtitle":"Verkn\xfcpfe die Bankkonten, \xfcber die Beitr\xe4ge gezahlt und Auszahlungen empfangen werden."}},"provideInfo":"Bitte gib einige Details zu deinem Rentenkonto an.","whyDoWeAsk":"Warum wollen wir das wissen?","whyDoWeAskAnswer":"Wir verwenden diese Parameter, um den Wert deiner Rente zu berechnen und zuk\xfcnftige Zahlungen zu simulieren.","doIHaveToFillThemAllOut":"Muss ich alle diese Felder ausf\xfcllen?","doIHaveToFillThemAllOutAnswer":"Wir ben\xf6tigen einige Informationen, um dir sinnvolle Ausk\xfcnfte geben zu k\xf6nnen. Felder, die als \'optional\' gekennzeichnet sind, sind nicht zwingend erforderlich, werden jedoch verwendet, um weitere n\xfctzliche Daten f\xfcr dich zu berechnen.","payoutsAmountValidation":"Bitte gib mindestens einen Auszahlungsbetrag ein","payoutsAmountUseSpecialQuoteValidation":"W\xe4hle aus, welcher Wert genutzt werden soll","useATemplate":"Benutze eine Vorlage!","useATemplateAnswer":"Die g\xe4ngigen Rentenprodukte wurden bereits f\xfcr dich konfiguriert - w\xe4hle sie einfach aus der Liste aus.","yourPensionContributions":"Beitr\xe4ge - w\xe4hrend der Ansparphase","yourPensionPayouts":"Auszahlungen - wenn du in Rente gehst","whenIBuy":"Wenn du Wertpapiere kaufst, das Geld...","existingAccount":"...wird von einem bestehenden Bankkonto abgezogen.","existingAccountSelect":"W\xe4hle dieses Bankkonto aus.","createAccountLater":"... wird von einem Bankkonto abgebucht, das ich sp\xe4ter einrichten werde.","createAccountLaterDescription":"Sobald du dieses Konto eingerichtet hast, denke daran, das verkn\xfcpfte Konto in diesem Konto zu aktualisieren."},"objectsOfValue":{"accountInfo":"Neues Konto hinzuf\xfcgen","provideInfo":"Bitte gib einige Details zu deinem Rentenkonto an.","whyDoWeAsk":"Warum fragen wir das?","whyDoWeAskAnswer":"Wir verwenden diese Parameter, um den Wert deiner Rente zu berechnen und zuk\xfcnftige Zahlungen zu simulieren.","whenIBuy":"Wenn ich Wertobjekte kaufe, wird das Geld...","existingAccount":"... von einem bestehenden Bankkonto abgebucht","existingAccountSelect":"W\xe4hle dieses Bankkonto aus","createAccountLater":"... von einem Bankkonto abgebucht, das ich sp\xe4ter einrichten werde","createAccountLaterDescription":"Sobald du dieses Konto eingerichtet hast, denke daran, das verkn\xfcpfte Konto in diesem Konto zu aktualisieren."},"metals":{"accountInfo":"Neues Konto hinzuf\xfcgen","provideInfo":"Du kannst entscheiden, wie du deine Edelmetall-Assets strukturieren m\xf6chtest, indem du sie in Konten organisierst. Du kannst mehrere Konten f\xfcr verschiedene Metallarten oder verschiedene Lagerorte erstellen.","whenIBuy":"Wenn ich Edelmetalle kaufe, wird das Geld...","existingAccount":"... von einem bestehenden Bankkonto abgebucht","existingAccountSelect":"W\xe4hle dieses Bankkonto aus","createAccountLater":"... von einem Bankkonto abgebucht, das ich sp\xe4ter einrichten werde","createAccountLaterDescription":"Sobald du dieses Konto eingerichtet hast, denke daran, das verkn\xfcpfte Konto in diesem Konto zu aktualisieren.","apply":"Anwenden"},"unlistedShares":{"accountInfo":"Neues Konto hinzuf\xfcgen","provideInfo":"Bitte gib ein paar Grundinfos ein, um loszulegen. Sobald das Konto erstellt wurde, kannst du Bewertungen und weitere Einzahlungen hinzuf\xfcgen.","whenIBuy":"Wenn ich Edelmetalle kaufe, wird das Geld...","existingAccount":"... von einem bestehenden Bankkonto abgebucht","existingAccountSelect":"W\xe4hle dieses Bankkonto aus","createAccountLater":"... von einem Bankkonto abgebucht, das ich sp\xe4ter einrichten werde","createAccountLaterDescription":"Sobald du dieses Konto eingerichtet hast, denke daran, das verkn\xfcpfte Konto in diesem Konto zu aktualisieren.","fxRate":"Wechselkurs: {{fxRate}}."},"crypto":{"accountInfo":"Neues Konto hinzuf\xfcgen","provideInfo":"Bitte gib ein paar Grundinfos ein, um loszulegen. Sobald das Konto erstellt wurde, kannst du ihm die eigentlichen Cryptoanlagen hinzuf\xfcgen.","whenIBuy":"Wenn ich Edelmetalle kaufe, wird das Geld...","existingAccount":"... von einem bestehenden Bankkonto abgebucht","existingAccountSelect":"W\xe4hle dieses Bankkonto aus","createAccountLater":"... von einem Bankkonto abgebucht, das ich sp\xe4ter einrichten werde","createAccountLaterDescription":"Sobald du dieses Konto eingerichtet hast, denke daran, das verkn\xfcpfte Konto in diesem Konto zu aktualisieren.","createTechnicalAccount":"... von einem Geldkonto bei meiner B\xf6rse / Broker abgezogen","createTechnicalAccountTooltip":"Wenn du diese Option ausw\xe4hlst, erstellen wir automatisch ein Geldkonto.","createTechnicalAccountCurrency":"In welcher W\xe4hrung ist dieses Geldkonto?","apply":"Anwenden"}}');


var $15eae19c88c523c3$exports = {};
$15eae19c88c523c3$exports = JSON.parse('{"accountDetails":"Account details","last12months":"Last 12 months (with transactions)","last10years":"Last 10 years","stats":"Stats","goToReports":"Go to reports","synchronisingChanges":"Synchronising changes...","noConnectedAccount":"Link a deposit account","initialSaldo":"Your bank did not provide any details for the initial transaction. If necessary, split it into smaller transactions and adjust dates.","help":"Click to see help for this view.","errorFieldRequired":"Field is required","errorOneRowRequired":"At least one entry is required","errorMustBePositive":"Must be positive","errorMustBeNumber":"Must be a number","multipleSelected":"You can select multiple.","effectiveDate":"Effective date","value":"Value","estimateType":"Select estimate type","quote":"Payout","quoteInCurrency":"Payout in {{currency}}","create":"Create","quotesEmptyGeneric":"Nothing to display","quotesEmptyStocksManualOnly":"Only values you entered manually are shown here. Add custom stock values in the Edit mode to see it here.","quotesEmptyStocks":{"heading":"Stock Quotes","subheading":"No synced market values available","intro":"This view currently shows only manually entered quote values for your holdings.","featureTitle":"Manual values only"},"buttons":{"duplicatesFound":"We found potential duplicates in your transactions. Please review them and uncheck the ones you don\'t need.","editYourFile":"You can edit your file now. Click >Save< to save your changes or >Cancel< to go back.","fileTransformed":"Your file has been modified to replicate the changes you made to it last time.","fileTransformedUndo":"Undo changes","firstUpload":"This is your first upload for this account. We will store your selection for future use.","loading":"Processing...","loadingTakesLong":"This process may take longer than 30 seconds.","columnMatcherHeader":"Which column from your file goes where?","columnMatcherInfo":"Drag the column headers to their correct places in the top row. Some headers may have already been placed for you. Hovering over the table icons will show a preview of your file. You don\'t have to use all the columns from your file.","columnName":"Column name","customColumnDescription":"Customised column","dragToScroll":"Drag above to scroll","occursInRows":"Occurs in rows","headersInRow":{"label":"Headers in row:","tooltip":"Which row in your file contains the column headers?"},"decimalChar":{"label":"Decimal character:","tooltip":"Does your file use a comma or a dot as the decimal character?"},"readOnly":{"tooltip":"You can add future transactions to Projects and they will appear here.","label":"This view is read-only in Project Mode."},"whatYouOwn":{"label":"What you own","tooltip":"Display a list of purchases and sales of your investments."},"whatIsItWorth":{"label":"What is it worth","tooltip":"Display changing value of your investments over time."},"payments":{"label":"Payments","tooltip":"Display contributions and payouts."},"presentValue":{"label":"Value","tooltip":"Display expected monthly payments as reported by your product provider."},"sync":{"tooltip":"Import transactions automatically."},"tableFilters":{"label":"Filter","labelWithCount":"Filter ({{count}})","tooltip":"Filter the visible rows by phrase, amount and date."},"import":{"label":"Import","tooltip":"Import transactions from a file."},"table":{"label":"Table","tooltip":"Display a list of transactions."},"grid":{"label":"Edit","tooltip":"Edit the transactions in a spreadsheet."},"wizard":{"label":"Edit","tooltip":"Edit the holdings or values through a wizard."},"holdings":{"label":"Holdings","tooltip":"Displays your holdings."},"cashflow":{"label":"Payouts & costs","tooltip":"Displays all payouts (dividends, interests, etc.) and all costs associated with this account."},"quotes":{"label":"Value","tooltip":"Displays value changes of your holdings."},"settings":{"label":"Settings","tooltip":"Display account settings."},"close":{"label":"Close","tooltip":"Abandon changes and go back to Dashboard."},"save":{"label":"Save","tooltip":"Permanently save this change."},"saveAndClose":{"label":"Save and close","tooltip":"Save this change and go back to Import screen."},"cancel":{"label":"Cancel","tooltip":"Cancel and go back to Table view."},"undo":{"label":"Undo","tooltip":"Undo last change."},"redo":{"label":"Redo","tooltip":"Repeat last change."},"uploadFiles":{"label":"Upload files","tooltip":"Upload local files to Monestry."},"cancelFileUpload":{"label":"Cancel file upload","tooltip":"Closes this dialog without uploading anything."},"resetColumns":{"label":"Reset columns","tooltip":"Resets all mappings."},"editLoadedFile":{"label":"Edit imported file","tooltip":"Edit the file you have uploaded."},"confirmAndContinue":{"label":"Confirm and continue","tooltip":"Proceeds with importing the file according to mappings specified below."},"skipThisFile":{"label":"Skip this file","tooltip":"Skips this file (without uploading it) and moves on to the next one."},"addAnotherOperation":{"label":"Add another operation","tooltip":"You can add more columns to your custom column."},"newColumn":{"label":"Add new column","tooltip":"Adds and edits new columns, based on two or more existing columns."},"columnProperties":{"label":"Properties","tooltip":""},"columnActions":{"label":"Actions","tooltip":""},"deleteThisColumn":{"label":"Delete this column","tooltip":"Deletes this column and all its contents."},"historicalValueCalc":{"label":"Don\'t know purchase price?","tooltip":"This button will estimate the purchase price based on the purchase date and attributes (weight, purity etc.). You can adjust it later."},"previous":{"label":"< Previous","tooltip":"Open details of the previous record."},"next":{"label":"Next >","tooltip":"Open details of the next record."}},"attributes":{"category":{"tooltip":"Category of this account"},"bankName":{"tooltip":"Bank providing this account"},"brokerName":{"tooltip":"Broker providing this account"},"iban":{"tooltip":"This account\'s IBAN (account number)"},"accountNo":{"tooltip":"This account\'s number","stub":"Account number?"},"bic":{"tooltip":"BIC (routing code) of the bank where this account is at"},"connectedCashAccount":{"tooltip":"Bank account where payments to and from this account are made.","error":"Error: no connected cash account found"},"streetAddress":{"tooltip":"Street address of your property"},"floorArea":{"tooltip":"Floor area of your property"},"numberOfRooms":{"tooltip":"Number of rooms in your property"},"lotArea":{"tooltip":"Area of the lot your property is on"},"constructionYear":{"tooltip":"Construction year"},"garage":{"tooltip":"Is there a garage or a dedicated parking space?"},"currency":{"tooltip":"Currency used for tracking this property\'s value"},"multiple":"connected accounts"},"columns":{"standardTooltip":"Click to sort by this column or reverse the sorting order.","emptyString":"","readOnly":"(read-only)","category":"category","date":"Date","Date (Day)":"Date","Date (Month)":"Date","Date (Year)":"Date","Income from capital":"Income from capital","accountName":"Account","displayName":"Name","total":"Total","otherParty":"Other party","otherPartyAccount":"Other party account","symbol":"Symbol","description":"Description","amount":{"label":"Amount","tooltip":"Transaction amount in your account currency. If you provide currency and the original currency amount, this field will be calculated automatically."},"label":{"label":"Label","tooltip":"What kind of transaction is this? These labels make it possible to calculate your net worth and other statistics."},"quantity":{"label":"Quantity","tooltip":"Number of assets bought (positive number) or sold (negative number)."},"principal":{"label":"Principal","tooltip":"Principal part of loan installment (i.e. repaid capital)."},"interest":{"label":"Interest","tooltip":"Interest part of loan installment (i.e. interest paid for this period)."},"iban":{"label":"IBAN","tooltip":"Other party account\'s IBAN (account number)"},"transactionAmount":{"label":"Amount","tooltip":"Amount of shares bought or sold"},"transactionPrice":{"label":"Unit price","tooltip":"Price per share, in the currency of the transaction"},"transactionCurrency":{"label":"Currency","tooltip":"Currency of the transaction"},"type":"Type","fxCurrency":{"label":"Original currency","tooltip":"Original currency of the transaction (optional)"},"fxAmount":{"label":"Original amount","tooltip":"Transaction amount in original currency (optional)"},"fxAmountInterest":{"label":"Original interest amount","tooltip":"Transaction interest amount in original currency (optional)"},"fxRate":{"label":"Exchange rate","tooltip":"Exchange rate between original currency and your account currency (calculated automatically)"},"value":"Value","rebasedOriginalValue":"Value\\n(transaction\\ncurrency)","rebasedValue":"Value\\n(base\\ncurrency)","rebasedAmount":{"label":"Amount\\nafter\\nsplits","tooltip":"If there were any splits between the transaction date and today, this is the amount of shares which these shares are now."},"assetId":{"label":"Asset","tooltip":"Which asset is this quote for?"},"assetName":{"label":"Asset name","tooltip":"How would you like to refer to this asset?"},"assetMetal":{"label":"Metal","tooltip":"What precious metal is this? Pick from a list."},"assetPurity":{"label":"Purity","tooltip":"Different forms of precious metal assets have different purities, e.g. .999 for gold. Enter the purity of your asset in parts per thousand (999 or 965)."},"assetAdditionalValue":{"label":"Extra value","tooltip":"Some coins or other assets have additional value due to their rarity or artistic significance. Enter the extra value of your asset in percent (this will be added to the pure metal value). If the metal alone is worth 100 and additional value is 20%, then we will calculate the value of this coin to be 120. When metal price increases, we will keep adding the 20% for this asset."},"assetWeight":{"label":"Weight","tooltip":"How much does this asset weigh? Please enter weight in grams."},"transactionValue":{"label":"Transaction sum","tooltip":"Optional. Quantity purchased / sold * price per unit. If you enter both those values, we will calculate it automatically."},"transactionCurrencyValue":{"label":"Original sum","tooltip":"Optional. Quantity purchased / sold * price per unit in original transation currency. If you enter both those values, we will calculate it automatically."},"rebasedOriginalPrice":{"label":"Price\\nafter\\nsplits","tooltip":"When stocks split, their price is divided as well. This is the hypothetical price per share of the transaction shares after considering all the splits that happened since."},"pricePerSquareMetre":"Price per m2","originalPricePerSquareMetre":"Price\\n(original\\ncurrency)\\nper m2","transactionType":{"label":"Transaction type","tooltip":"Purchase or sale of the property."},"realEstateTransactionPrice":{"label":"Price\\n(base\\ncurrency)","tooltip":"Shows the actual sale or purchase price, in your base currency. You can provide this price or the original price, the other will be calculated automatically."},"realEstateOriginalPrice":{"label":"Price\\n(original\\ncurrency)","tooltip":"Shows the actual sale or purchase price, in the original currency. You can provide this price or the transaction price, the other will be calculated automatically."},"source":{"label":"Source","tooltip":"Shows if the valuation comes from the valuation provider or entered manually. Click to sort by this column or reverse the sorting order."},"price":{"label":"Value\\n(base\\ncurrency)","tooltip":"Shows what price would this property be sold for at a given date, in your base currency. Click to sort by this column or reverse the sorting order.","tooltipGrid":"If you provide original currency and price, this column will be calculated automatically."},"priceShort":{"label":"Price"},"currency":"Original\\ncurrency","originalPrice":{"label":"Value\\n(original\\ncurrency)","tooltip":"Shows what price would this property be sold for at a given date, in the original currency. Click to sort by this column or reverse the sorting order.","tooltipGrid":"If you provide original currency and your base currency price, this column will be calculated automatically."},"size":{"label":"Quantity","tooltip":"Amount of still unsold securities from the transaction which took place at the specified date. Click to sort by this column or reverse the sorting order."},"split":{"label":"Split","tooltip":"Proportion of old stocks to new stocks."},"openPositionSize":{"label":"Remaining quantity","tooltip":"Amount of still unsold securities from the transaction which took place at the specified date. Click to sort by this column or reverse the sorting order."},"purchaseValue":{"label":"Purchase","tooltip":"Value when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."},"purchaseValueFull":{"label":"Purchase value","tooltip":"Value when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."},"baselineValue":{"label":"Baseline /","tooltip":"Value of the securities in your base currency at the baseline date that you selected. Click to sort by this column or reverse the sorting order."},"currentValue":{"label":"Current value","tooltip":"Current value of the securities in your base currency. Click to sort by this column or reverse the sorting order."},"purchasePrice":{"label":"Purchase /","tooltip":"Price when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."},"valueTransactionCurrency":{"label":"Value\\n(transaction\\ncurrency)","tooltip":"Optional. Value of the asset in the original transaction currency. Click to sort by this column or reverse the sorting order."},"valueAccountCurrency":{"label":"Value","tooltip":"Optional. Value of the asset in the account currency. Click to sort by this column or reverse the sorting order."},"valueBaseCurrency":{"label":"Value\\n(base\\ncurrency)","tooltip":"Optional. Value of the asset in your overall base currency. Click to sort by this column or reverse the sorting order."},"baselinePrice":{"label":"Baseline /","tooltip":"Price of the securities in your base currency at the baseline date that you selected. Click to sort by this column or reverse the sorting order."},"currentPrice":{"label":"Current price","tooltip":"Current price of the securities in your base currency. Click to sort by this column or reverse the sorting order."},"purchaseCurrentValuePrice":{"label":"Value / price","tooltip":"Price and value when purchasing the securities as well as currently, in your base currency. Click to sort by this column or reverse the sorting order."},"purchaseValuePrice":{"label":"Purchase value / price","tooltip":"Price and value when purchasing the securities in your base currency. Click to sort by this column or reverse the sorting order."},"baselineValuePrice":{"label":"Baseline value / price","tooltip":"Price and value of the securities in your base currency at the baseline date that you selected. Click to sort by this column or reverse the sorting order."},"currentValuePrice":{"label":"Current value / price","tooltip":"Current price and value of the securities in your base currency. Click to sort by this column or reverse the sorting order."},"dividendsSincePurchase":{"label":"Dividends / fees since purchase","tooltip":"Sum of all dividends and fees incurred for those securities since purchase + account costs in proportion to open position value. Click to sort by this column or reverse the sorting order."},"dividends":{"label":"Payouts / fees","tooltip":"Sum of all dividends and fees incurred for those securities since purchase. Click to sort by this column or reverse the sorting order."},"roi":{"label":"ROI total / ROI per year","tooltip":"Return on investment for your securities - total (since purchase until now) and annualised (average growth per year since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."},"roiShort":{"label":"ROI total / annual","tooltip":"Return on investment for your securities - total (since purchase until now) and annualised (average growth per year since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."},"roiOnly":{"label":"ROI","tooltip":"Return on investment for your securities - total (since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."},"payoutsSincePurchase":{"label":"Payouts since purchase","tooltip":"Payouts for assets since their purchase. Click to sort by this column or reverse the sorting order."},"feesSincePurchase":{"label":"Fees since purchase","tooltip":"Fees related to assets since their purchase. Click to sort by this column or reverse the sorting order."},"costsSincePurchase":{"label":"Costs since purchase","tooltip":"Costs related to assets since their purchase. Click to sort by this column or reverse the sorting order."},"roiAnnual":{"label":"Annual ROI","tooltip":"Return on investment for your securities - annualised (average growth per year since purchase until now). Includes dividends and fees. Click to sort by this column or reverse the sorting order."},"keepFlag":{"label":"Keep?","tooltip":"Entferne Markierung bei den Zeilen, die nicht importiert werden sollen."},"payoutOnlyContributionsToDate":{"label":"Pension from contributions\\nto-date","tooltip":"Pension that you would receive if you stopped paying contributions today."},"payoutOnlyContributionsToDateIndexed":{"label":"Pension from contributions\\nto-date (indexed)","tooltip":"Pension that you would receive if you stopped paying contributions today, but with interest applied to them until pension payout phase."},"payoutAllPlannedContributions":{"label":"Pension from all\\nfuture contributions","tooltip":"Pension that you would receive if you keep paying contributions until pension payout phase."},"payoutAllPlannedContributionsIndexed":{"label":"Pension from all\\nfuture contributions (indexed)","tooltip":"Pension that you would receive if you keep paying contributions until pension payout phase, but with interest applied to them until pension payout phase."},"payoutLumpSumVerrentet":{"label":"Lump sum converted to perpetual pension","tooltip":"Capital you have accumulated will be converted into a perpetual annuity. We will automatically calculate the recurring payment."},"note":{"label":"Note","tooltip":"Valuation details"},"proceeds":{"label":"Proceeds","tooltip":"Income from this asset"}},"deposits":{"labels":{"noLabel":{"long":"No label","short":"No label"},"investment-fees":{"long":"Transaction fees","short":"Fees"},"investment-costs":{"long":"Account costs","short":"Costs"},"investment-interest":{"long":"Account interest","short":"Interest"},"investment-dividend":{"long":"Dividend","short":"Dividend"},"investment-transfer":{"long":"Transfer","short":"Transfer"},"investment-rent":{"long":"Rent income","short":"Rent"},"investment-purchase":{"long":"Asset purchase","short":"Asset purchase"},"investment-sale":{"long":"Asset sale","short":"Asset sale"},"investment-payout":{"long":"Loan payout","short":"Loan payout"},"investment-loanRepayment":{"long":"Loan repayment","short":"Loan repayment"},"investment-loanInterest":{"long":"Loan repayment (interest)","short":"Loan interest"},"investment-loanPrincipal":{"long":"Loan repayment (principal)","short":"Loan principal"},"investment-pension":{"long":"Pension payout","short":"Pension"},"investment-contribution":{"long":"Pension contribution","short":"Contribution"}},"markThisTransaction":"Mark this transaction as","noTransactions":"No transactions found on accounts connected to this one.","noTransactionsWithin":"No similar sized transactions found within 7 days of this transaction\'s date on accounts connected to this one.","noAccounts":"No connected accounts found.","noAssets":"No assets found on connected accounts.","addTag":"Add tag","whichItem":"Which item does it apply to?"},"pension":{"import":{"title":"Which product to use?","prompt":"You seem to be importing data from rvuebersicht.de. There are more than 1 products in this file. Please select the right entry for this account.","ignore":"Ignore","cancel":"Cancel","baseCurrencyDialog":{"title":"Currency conversion","prompt":"The currency of the imported data is different from the base currency of this account. How should we convert this currency? As it is difficult to predict the future exchange rate, we suggest to use today\'s.","fxRate":"Exchange rate to use","todayFxIs":"Today\'s exchange rate is","apply":"Apply"}}},"contextMenu":{"addEmptyRowAbove":"Add empty row(s) above","addEmptyRowBelow":"Add empty row(s) below","addEmptyColumnAbove":"Add empty column(s) right","addEmptyColumnBelow":"Add empty column(s) left","duplicateRow":"Duplicate row","duplicateColumn":"Duplicate column","deleteRow":"Delete row","deleteColumn":"Delete column","cut":"Cut","copy":"Copy","paste":"Paste","download":"Export everything to file","downloadSelected":"Export selection to file"},"splitMenu":{"split":"Split","splitHeader":"Split this transaction into two or more transactions","splitInfo":"Remember to split transaction fees and purchase / sale transaction in the connected deposit account.","splitExistingDetected":"This transaction has been split already, you can edit the existing splits above.","copyAsSimulated":"Copy as simulated","copyAsSimulatedInfo":"Create a simulated transaction based on this one. You can adjust all parameters in the next screen.","showInProject":"Link to project","showInProjectInfo":"You can show this actual transacton in a Project.","aiLabelLoanRepayment":"Auto-detect interest and principal","aiLabelLoanRepaymentInfo":"Use AI to identify principal and interest for this transaction (or all selected transactions) and apply the loan repayment label automatically.","aiLabelLoanRepaymentRunning":"Processing selected transactions...","aiLabelLoanRepaymentRunningTakesUpTo30s":"This can take up to 30 seconds.","run":"Run","separateInterestFromPrincipal":"Separate interest from principal","splitAndLabelLoanInfo":"Break down this loan payment into principal and interest.","splitAndLabelLoanInfo2":"We store the bank transaction as one loan repayment and use the split between principal and interest for loan history and KPI calculations.","transactionDescriptionLabel":"Current transaction description","transactionDescriptionEmpty":"No description","calculateExpectedSplitInfo":"If there is no information about the interest and principal parts in transaction description, we can calculate them based on the loan parameters.","calculateExpectedSplit":"Calculate expected split","delete":"Delete","pressSaveToDelete":"Press >Save< to delete this transaction.","pick":"Pick a project","error":"Please verify your entry.","amountToAllocate":"Amount left to allocate","allocatedTooMuch":"Allocated too much by","amountToAllocateInterest":"Interest left to allocate","allocatedTooMuchInterest":"Allocated too much interest by","selectLoanAccount":"Select loan account"},"settings":{"symbol":"Symbol","dividend":"Dividend (% per year)","growthRate":"Growth rate (% per year)","add":"Add","simulatedAccountGrowth":{"heading":"Simulated account growth","description":"This value will be used to simulate future growth of all your stocks in this account account. See this blog entry for more information.","fieldLabel":"Growth rate","dividendPayments":"You can also simulate future dividend payments - across all stocks accounts. Enter initial dividend per share per year, it will be increased annually by the above growth rate.","dividendTooltip":"Dividend will be calculated as % of current value of the asset."},"spread":{"description":"We calculate up-to-date value of your precious metal assets based on the realistic price you will get for your asset when selling it.","description2":"This price is lower than the market price due to the margin of the buyer (called \'spread\'). We recommend a conservative spread of 10% of the market price, but you can change it here. Spread will be deducted from the current market value of your metal assets.","label":"Spread (%)","error":"Please provide a spread percentage"},"autoImportPretransformation":{"heading":"Remember file import settings","body":"Next time you import a file for this account we can automatically apply the transformations you made to import files before.","label":"Remember import settings"},"realEstateValuations":{"heading":"Select accounts for automatic valuation updates","label":"We can automatically update valuations for some of your real estate accounts. Select which ones should that be."}},"loanIndicators":{"principalRemaining":"Remaining principal","interestRemaining":"Remaining interest","history":"History","loanRepaid":"Capital repaid","loanRepaidTooltip":"What percentage of capital has been repaid to date.","interest":"Interest","interestPaid":"paid to date","interestTooltip":"Total amount of interest paid to date and what percentage of principal paid so far this is.","interestPaidToPrincipalPaid":"vs principal paid","balance":"Balance","balanceTooltip":"Remaining amount to be paid (principal + interest), if the loan is paid off according to the schedule."},"pensionIndicators":{"presentValueChanges":"Changes to expected payouts","roi":"Return on investment","sumContributions":"Contributions","sumContributionsTooltip":"Total amount of contributions paid to date.","presentValue":"Product value","presentValueTooltip":"Value of your pension product in today\'s money."},"unlistedShares":{"wizard":{"transactions":{"header":"What kind of transaction shall we add?","moreShares":"Buy more shares","moreCapital":"Increase equity capital (without emitting new shares)","sharesSale":"Sell shares","capitalDisbursement":"Receive equity capital as payout (capital disbursement)","error":"Please pick one option","formHeader":"Transaction details","submit":"Save","deleteThisTransaction":"Delete","noConnectedDeposit":"Connect a deposit account first (use the button above, just below company name).","clickToOpenDeposit":"In order to pay equity capital in or out without emitting or buying back shares, go to the connected deposit account and label your transaction as \'capital increase\' or \'capital disbursement\':","quantity":{"label":"Amount of shares","tooltip":"How many shares did you buy or sell?","error":"Please provide a number of shares"},"upac":{"label":"Price per share","tooltip":"Price per share in the account currency","error":"Please provide a price per share"},"capitalAmount":{"label":"Capital increase amount","tooltip":"By how much is the equity capital increased?","error":"Please provide a capital increase amount"},"capitalDisbursementAmount":{"label":"Capital disbursement amount","tooltip":"How much equity capital is paid out?","error":"Please provide a capital disbursement amount"},"dateUserInput":{"label":"Transaction date","tooltip":"When did the transaction take place?","error":"Please provide a transaction date"}},"valuation":{"title":"Company valuation wizard","description":"Start by selecting your company\'s lifecycle stage below or enter the valuation manually and click save.","score":{"0":{"label":"Neutral","tooltip":"Your company is in a similar position to the market / its peers"},"1":{"label":"More","tooltip":"Your company is in a better position than the market / its peers"},"2":{"label":"Much more","tooltip":"Your company is in a significantly better position than the market / its peers"},"-2":{"label":"Much less","tooltip":"Your company is in a significantly worse position than the market / its peers"},"-1":{"label":"Less","tooltip":"Your company is in a worse position than the market / its peers"}},"stage":{"label":"Stage","tooltip":"The valuation methods that we can apply depend on the stage of your company. Select the stage that best describes your company at present.","idea":{"label":"Idea","tooltip":"The company is in the idea stage. It has not yet been founded."},"prototype":{"label":"Prototype","tooltip":"The company has a prototype or the work is very advanced. Market launch has not happened yet."},"mvp":{"label":"MVP","tooltip":"The company has a minimum viable product and is testing it on the market."},"expansion":{"label":"Expansion","tooltip":"The company is growing rapidly and has a stable customer base."},"market":{"label":"Market","tooltip":"The company is well established and has a strong customer base."}},"valuationMethod":{"label":"Available valuation methods","tooltip":"Select the methods that you would like to use to value your company. You can select multiple methods."},"info":"Compare your company to similar companies in the market. The valuation methods will be applied based on the information you provide.","insufficientData":"More data needed","insufficientDataTooltip":"We need the following fields to calculate the valuation: {{fields}}.","required":"Please provide both date and valuation.","ideaStrength":{"label":"Idea strength","tooltip":"The strength of the idea or business concept behind the company"},"prototypeProgress":{"label":"Prototype progress","tooltip":"The progress made in developing the prototype of the product (\'much less\' if no prototype exists, \'much more\' if a fully tested prototype exists)"},"teamCapability":{"label":"Team capability","tooltip":"The capability and experience of the team members"},"marketingRelationships":{"label":"Marketing relationships","tooltip":"The strength and extent of marketing / supply chain relationships"},"marketTraction":{"label":"Market traction","tooltip":"Success in bringing product to the market / sales growth"},"competitiveAdvantage":{"label":"Competitive advantage","tooltip":"Is there any kind of advantage this company has against its competitors?"},"similarStartupValuationsArray":{"label":"Similar company valuations","tooltip":"Approximate valuations for similar companies"},"technologyRisk":{"label":"Technology confidence","tooltip":"Comparing to similar companies, is the technology used by this company more or less risky?"},"ipStrength":{"label":"IP strength","tooltip":"Does the company hold all key patents / IP necessary for launch and further growth?"},"totalAdressableMarketSize":{"label":"Total addressable market size","tooltip":"The total size of the market that the company can address"},"marketGrowthRate":{"label":"Market growth rate","tooltip":"The growth rate of the market in which the company operates"},"marketEntryBarriers":{"label":"Market entry barriers","tooltip":"How difficult (because of capital, tools, IP etc.) is it to start a company in this market?"},"needForMoreInvestment":{"label":"Need for more investment","tooltip":"How much more investment is needed to bring the company to the next level?"},"legalRisk":{"label":"Legal stability","tooltip":"The more legal (legislation, patents etc.) risks the company may face, the smaller the stability."},"internationalRisk":{"label":"International stability","tooltip":"The risks associated with expanding operations internationally"},"marketRisk":{"label":"Market stability","tooltip":"Is the market in which the company operates stable (\'more\') or volatile (\'less\')?"},"financialPerformance":{"label":"Financial performance","tooltip":"The financial performance of the company (profitability)"},"assetsArray":{"label":"Assets","tooltip":"An array of the company\'s assets"},"intangiblesArray":{"label":"Intangibles","tooltip":"An array of the company\'s intangible assets"},"liabilitiesArray":{"label":"Liabilities","tooltip":"An array of the company\'s liabilities"},"targetRaisedCapital":{"label":"Capital to raise","tooltip":"What capital is your company currently looking to raise?"},"cashFlowArray":{"label":"Cash flows","namePlaceholder":"Year","tooltip":"What are the expected cash flows of the company?"},"discountRate":{"label":"Discount rate (in %)","tooltip":"The discount rate used in the DCF method (cost of capital for your company, i.e. approx. what interest is the company paying on loans)"},"longTermGrowthRate":{"label":"Stable growth rate (in %)","tooltip":"Long-term, sustainable growth rate once cash flows are stable (should be conservative /2-4%/ and lower than the discount rate). Will be used to calculate the terminal value.","error":"Stable growth rate must be lower than discount rate for this calculation."},"finalQuote":{"label":"Final valuation","tooltip":"What valuation would you like to save, given the information provided?","error":"Please provide a final valuation","description":"Determine the final valuation of the company based on the information provided.","save":"Save","deleteThisQuote":"Delete this valuation","resetThisQuote":"Reset this valuation"},"percentOwned":{"label":"Percentage owned","tooltip":"What percentage of the company do you own?","error":"Please provide a percentage owned"},"methods":{"berkus":{"label":"Berkus","tooltip":"A method evaluating startups based on idea, prototype, team, market traction, and competitive advantage."},"scorecard":{"label":"Scorecard","tooltip":"A method assessing startups using a scoring system to compare various aspects such as team, product, and market."},"riskFactor":{"label":"Risk Factor","tooltip":"A method evaluating the risks involved in a startup, including technology, market, and team risks."},"valuationByStage":{"label":"Valuation by Stage","tooltip":"A method determining the valuation of a startup based on its current stage of development."},"replacementCost":{"label":"Replacement Cost","tooltip":"A method calculating the cost to replace the company\'s assets and operations."},"bookValue":{"label":"Book Value","tooltip":"A method assessing the net asset value of a company by subtracting liabilities from assets."},"fiveTimesYourRise":{"label":"Five Times Your Rise","tooltip":"A method multiplying the target capital raise by five to estimate the company\'s value."},"dcf":{"label":"DCF","tooltip":"A Discounted Cash Flow method evaluating a company based on its projected future cash flows."}}}}},"cryptoAssetMappingDialog":{"header":"Automatic price updates","prompt":"Cryptocurrencies are decentralised. To make sure we are getting the right price for your assets, we need to confirm we found the right one. Please check the following mappings and click >Save<. You may leave some of them empty if you don\'t want to update the price for this asset.","asset":"Crypto symbol","status":"Prices found","headerAssetDetails":"Find prices for:","promptAssetDetails":"These are cryptocurrencies for which we can update prices automatically. Select the one you own or search for a new keyword and click >OK<. You may leave all items unselected if they don\'t match your assets.","search":"Search prices for:","symbol":"Symbol","name":"Name","marketCap":"Market size","liquidity":"Liquidity","price":"Current price","page":"Page","pageOf":"of","next":"Next","previous":"Previous","noResults":"No prices found"},"filterDialog":{"filter":"Filter","prompt":"Select only cells which fulfill the following conditions:","is":"is","isNot":"is not","contains":"contains","doesNotContain":"does not contain","startsWith":"starts with","doesNotStartWith":"does not start with","endsWith":"ends with","doesNotEndWith":"does not end with","greaterThan":"greater than","greaterThanOrEqual":"greater than or equal to","lessThan":"less than","lessThanOrEqual":"less than or equal to","equalTo":"equal to","blank":"blank","phrase":"phrase","addMore":"Add more","cancel":"Cancel","rulesErrorLength":"Value may not exceed 200 characters.","rulesErrorNumber":"Value must be a number."},"tableFilters":{"results":"{{shown}} of {{total}} rows","clearAll":"Clear filters"},"tableFiltersDialog":{"title":"Filter list","description":"Refine the visible rows without changing your data.","searchLabel":"Search phrase","searchPlaceholder":"Description, counterparty, IBAN...","amountLabel":"Amount","amountAny":"Any amount","amountInflow":"Inflow only","amountOutflow":"Outflow only","amountZero":"Zero amount","dateLabel":"Date","dateAll":"All dates","date30d":"Last 30 days","date90d":"Last 90 days","date365d":"Last 12 months","reset":"Reset","cancel":"Cancel","apply":"Apply filters"},"gettingStarted":{"heading":"Getting started","subheading":"Fill your new account with data","intro":"It is easy to get started and it is up to you to decide how to do that.\\nRemember: everything you do can be updated later.","features":[{"name":"Enter the current saldo","description":"Click >Edit<, enter the current account saldo and save. You can add more details later."},{"name":"Import transactions from file","description":"Download a transaction extract file from your bank\'s online banking. Once you have it, press the >Import< button and follow our step-by-step instructions."},{"name":"Get transactions automatically","description":"If there is a technical link, you can get your transactions automatically. Just press the >Sync< button and we will do the rest."}],"cashflow":{"heading":"Why are there no data here?","subheading":"Tag the related payouts and costs in the connected deposit account","intro":"Add the transactions in the connected deposit account and tag them for this account so they show up here.","navigateIntro":"Open the linked deposit account to add and tag the transactions for this asset:"},"values":{"heading":"Custom values","subheading":"Maintain your own price history","intro":"Add your own prices when market data is missing or you want to override it.","features":[{"name":"Edit prices in Grid","description":"Press Edit to switch into the Grid and enter your custom prices per asset, then save."},{"name":"Import valuations","description":"Use Import to upload price data instead of typing everything manually."}]}}}');


var $d8a3bdd63b660299$exports = {};
$d8a3bdd63b660299$exports = JSON.parse('{"accountDetails":"Kontodetails","last12months":"Letzte 12 Monate (mit Transaktionen)","last10years":"Letzte 10 Jahre","stats":"Kernzahlen","goToReports":"Zu den Reports","synchronisingChanges":"Synchronisiere \xc4nderungen...","noConnectedAccount":"Bankkonto verlinken","initialSaldo":"Deine Bank gab keine Details f\xfcr eine Anfangstransaktion an. Falls n\xf6tig, teile sie in kleinere Transaktionen auf und passe die Daten an.","help":"Link zu den Hilfeseiten dieses Screens.","draft":"Deine Bank gibt keine Details f\xfcr eine Transaktion an. Falls n\xf6tig, teile sie in kleinere Transaktionen auf und passe die Daten an.","multipleSelected":"Mehrauswahl m\xf6glich","errorFieldRequired":"Feld ist erforderlich","errorOneRowRequired":"Mindestens ein Eintrag ist notwendig","errorMustBePositive":"Muss positiv sein","errorMustBeNumber":"Muss eine Zahl sein","effectiveDate":"G\xfcltig ab","value":"Wert","estimateType":"Art der Sch\xe4tzung","quote":"Auszahlung","quoteInCurrency":"Auszahlung in {{currency}}","create":"Neuer Eintrag","quotesEmptyGeneric":"Keine Daten vorhanden","quotesEmptyStocksManualOnly":"Hier werden nur manuell eingetragene Werte angezeigt. Bitte erfasse dazu einen Wert im Edit-Modus.","quotesEmptyStocks":{"heading":"Kurswerte Aktien","subheading":"Keine synchronisierten Marktwerte verf\xfcgbar","intro":"Diese Ansicht zeigt aktuell nur manuell eingetragene Kurswerte deiner Best\xe4nde.","featureTitle":"Nur manuelle Werte"},"buttons":{"duplicatesFound":"Wir haben Eintr\xe4ge identifiziert, die m\xf6glicherweise doppelt sind. Bitte \xfcberpr\xfcfe die folgenden Eintr\xe4ge und wenn gew\xfcnscht, unmarkiere die doppelten Eintr\xe4ge.","editYourFile":"Du kannst jetzt die hochgeladene Datei bearbeiten. Klicke auf >Speichern<, um deine \xc4nderungen zu speichern, oder auf >Abbrechen<, um zur\xfcckzugehen.","fileTransformed":"Deine Datei wurde ge\xe4ndert, um die \xc4nderungen von letztem Mal zu replizieren.","fileTransformedUndo":"R\xfcckg\xe4ngig machen","firstUpload":"Dies ist der erste Upload f\xfcr dieses Konto. Bitte \xfcberpr\xfcfe die folgenden Eintr\xe4ge und wenn gew\xfcnscht, unmarkiere die doppelten Eintr\xe4ge.","loading":"Datei wird verarbeitet...","loadingTakesLong":"Der Vorgang kann mehr als 30 Sekunden dauern.","columnMatcherHeader":"Spaltenzuordnung","columnMatcherInfo":"Ziehe die Spalten\xfcberschriften an ihre richtigen Stellen in der oberen Zeile. Einige \xdcberschriften wurden m\xf6glicherweise bereits f\xfcr dich platziert. Bewege den Cursor \xfcber Tabelle-Ikonen in jeder Datei-Spalte um eine Vorschau dieser Spalte anzuzeigen. Nicht alle spalten der Datei m\xfcssen verwendet werden.","columnName":"Spaltenname","customColumnDescription":"Eine zusammengesetzte Spalte","dragToScroll":"Ziehe um zu scrollen","occursInRows":"Fehler in Zeilen","headersInRow":{"label":"\xdcberschriften in Zeile","tooltip":"In welcher Zeile der Datei befinden sich die \xdcberschriften?"},"decimalChar":{"label":"Dezimalzeichen:","tooltip":"Verwendet deine Datei ein Komma oder einen Punkt als Dezimaltrennzeichen?"},"readOnly":{"tooltip":"Du kannst Transaktionen den Projekten hinzuf\xfcgen, und sie werden hier angezeigt.","label":"Diese Ansicht ist schreibgesch\xfctzt in Projekt-Modus."},"whatYouOwn":{"label":"Dein Eigentum","tooltip":"Zeige die Liste aller K\xe4ufe und Verk\xe4ufe deiner Anlagen."},"whatIsItWorth":{"label":"Wert","tooltip":"Zeige Wert\xe4nderungen deiner Anlagen in der Zeit an."},"payments":{"label":"Zahlungen","tooltip":"Zeige geleistete und erhaltene Zahlungen an."},"presentValue":{"label":"Wert","tooltip":"Zeige zu erwarteten monatlichen Zahlungen deines Produktes an (wie du sie von dem Institut erhalten hast, von dem du dieses Produkt gekauft hast)."},"sync":{"tooltip":"Transaktionen automatisch importieren."},"tableFilters":{"label":"Filter","labelWithCount":"Filter ({{count}})","tooltip":"Filtere die sichtbaren Zeilen nach Begriff, Betrag und Datum."},"import":{"label":"Import","tooltip":"Transaktionen aus einer Datei importieren."},"table":{"label":"Tabelle","tooltip":"Transaktionen anzeigen."},"grid":{"label":"Bearbeiten","tooltip":"Angezeigten Daten in Spreadsheet editierbar machen."},"wizard":{"label":"Bearbeiten","tooltip":"Bearbeite Best\xe4nde oder Werte \xfcber einen Assistenten."},"holdings":{"label":"Best\xe4nde","tooltip":"Zeigt deine Best\xe4nde an."},"cashflow":{"label":"Zahlungen","tooltip":"Zeigt alle Auszahlungen (Dividenden, Zinsen usw.) und alle Kosten, die mit diesem Konto verbunden sind."},"quotes":{"label":"Wert","tooltip":"Zeigt Wert\xe4nderungen deiner Best\xe4nde an."},"settings":{"label":"Einstellungen","tooltip":"Passe Kontoeinstellungen an."},"close":{"label":"Schliessen","tooltip":"\xc4nderungen verlassen und zum Dashboard zur\xfcckkehren."},"save":{"label":"Speichern","tooltip":"\xc4nderungen permanent speichern."},"saveAndClose":{"label":"Speichern und schliessen","tooltip":"\xc4nderungen permanent speichern und zum Import-Dialog zur\xfcckkehren."},"cancel":{"label":"Abbrechen","tooltip":"Abbrechen und zu Tabelle-Sicht zur\xfcckkehren."},"undo":{"label":"Undo","tooltip":"Letzte \xc4nderung r\xfcckg\xe4ngig machen."},"redo":{"label":"Redo","tooltip":"Letzte \xc4nderung wiederholen."},"uploadFiles":{"label":"Dateien hochladen","tooltip":"Transaktionen aus lokalen Dateien importieren."},"cancelFileUpload":{"label":"Dateiupload abbrechen","tooltip":"Schlie\xdft diesen Dialog, ohne etwas hochzuladen."},"resetColumns":{"label":"Spalten zur\xfccksetzen","tooltip":"Setzt alle Zuordnungen zur\xfcck."},"confirmAndContinue":{"label":"Best\xe4tigen und fortfahren","tooltip":"F\xe4hrt mit dem Import der Datei gem\xe4\xdf der unten angegebenen Zuordnungen fort."},"skipThisFile":{"label":"Diese Datei \xfcberspringen","tooltip":"\xdcberspringt diese Datei (ohne sie hochzuladen) und geht zur n\xe4chsten \xfcber."},"addAnotherOperation":{"label":"Weitere Operation zuf\xfcgen","tooltip":"F\xfcgt eine weitere Operation zu Berechnung dieser Spalte hinzu."},"newColumn":{"label":"Spalte hinzuf\xfcgen","tooltip":"F\xfcgt eine neue Spalte hinzu."},"editLoadedFile":{"label":"Datei editieren","tooltip":"Passe die gerade hochgeladene Datei an."},"columnProperties":{"label":"Eigenschaften","tooltip":""},"columnActions":{"label":"Aktionen","tooltip":""}},"deleteThisColumn":{"label":"Diese Spalte l\xf6schen","tooltip":"L\xf6scht diese Spalte und alle zugeordneten Daten."},"historicalValueCalc":{"label":"Kaufpreis unbekannt?","tooltip":"Wir berechnen gerne den gesch\xe4tzten Wert am Kaufdatum. Wir ben\xf6tigen dazu das Kaufdatum und die Attribute (Gewicht, Reinheit usw.)."},"previous":{"label":"< Vorherige","tooltip":"Den vorherigen Eintrag \xf6ffnen."},"next":{"label":"N\xe4chste >","tooltip":"Den n\xe4chsten Eintrag \xf6ffnen."},"attributes":{"category":{"tooltip":"Kategorie, zu dieser dieses Konto geh\xf6rt."},"bankName":{"tooltip":"Bank, die dieses Konto bereitstellt."},"brokerName":{"tooltip":"Broker, der dieses Depot bereitstellt."},"iban":{"tooltip":"IBAN-Nummer dieses Kontos."},"accountNo":{"tooltip":"Identifikator oder Nummer dieses Kontos.","stub":"Depotnummer?"},"bic":{"tooltip":"BIC (Bank-Identifikationsnummer) dieser Bank."},"connectedCashAccount":{"tooltip":"Geldkonto, worauf die Kauf- / Verkaufsbetrag sowie Rendite-Zahlungen hierf\xfcr erfolgen.","error":"Fehler: kein verbundenes Geldkonto liegt vor"},"streetAddress":{"tooltip":"Die Adresse der Immobilie"},"floorArea":{"tooltip":"Wohnfl\xe4che"},"numberOfRooms":{"tooltip":"Anzahl Zimmer"},"lotArea":{"tooltip":"Grundst\xfcckfl\xe4che"},"constructionYear":{"tooltip":"Baujahr"},"garage":{"tooltip":"Verf\xfcgt die Immobilie \xfcber eigene Garagen- oder Stellplatz?"},"currency":{"tooltip":"In welcher W\xe4hrung soll die Wert der Immobilie angegeben werden?"},"multiple":"verlinkte Konten"},"columns":{"standardTooltip":"Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern.","emptyString":"","readOnly":"(gesch\xfctzt)","category":"Kategorie","date":"Datum","Date (Day)":"Datum","Date (Month)":"Datum","Date (Year)":"Datum","Income from capital":"Kapitaleinkommen","accountName":"Kontoname","displayName":"Name","total":"Summe","otherParty":"Andere Partei","otherPartyAccount":"Andere Partei Kontonr.","symbol":"Symbol","description":"Bezeichnung","amount":{"label":"Betrag","tooltip":"Transaktionsbetrag in der W\xe4hrung dieses Kontos. Bei vorhandenen Orginalw\xe4hrung und Orginalbetrag kann der Betrag automatisch berechnet werden."},"quantity":{"label":"Anzahl","tooltip":"Anzahl der gekauften (positive Zahl) oder verkauften (negative Zahl) Assets"},"label":{"label":"Tag","tooltip":"Welche Art der Transaktion ist es? Diese Tags erm\xf6glichen Berechnung deines Verm\xf6gens sowie diversen Indikatoren."},"principal":{"label":"Kapital","tooltip":"Kapitalanteil der Kreditrate (d.h. der Betrag, der zur Tilgung des Kredits verwendet wird)."},"interest":{"label":"Zinsen","tooltip":"Zinsanteil der Kreditrate (d.h. der Betrag, der als Zinsen an den Kreditgeber gezahlt wird)."},"iban":{"label":"IBAN","tooltip":"IBAN-Nummer des Senders / Empf\xe4ngers dieser Transaktion."},"transactionAmount":{"label":"Anzahl","tooltip":"Anzahl der gehandelten Wertpapiere"},"transactionPrice":{"label":"St\xfcckpreis","tooltip":"Preis pro St\xfcck des Wertpapiers, in der W\xe4hrung der Transaktion"},"transactionCurrency":{"label":"W\xe4hrung","tooltip":"W\xe4hrung, in der die Transaktion urspr\xfcnglich get\xe4tigt wurde"},"type":"Typ","fxCurrency":{"label":"Originalw\xe4hrung","tooltip":"W\xe4hrung, in der die Transaktion urspr\xfcnglich get\xe4tigt wurde (optional)"},"fxAmount":{"label":"Originalbetrag","tooltip":"Transaktionsbetrag in der originalen W\xe4hrung (optional)"},"fxAmountInterest":{"label":"Originalzinsen","tooltip":"Transaktionszinsen in der originalen W\xe4hrung (optional)"},"fxRate":{"label":"Wechselkurs","tooltip":"Wechselkurs zwischen der originalen W\xe4hrung und der W\xe4hrung dieses Kontos (berechnet automatisch)"},"value":"Wert","rebasedOriginalValue":"Wert\\n(Transaktions-\\nw\xe4rhung)","rebasedValue":"Wert\\n(Basis-\\nw\xe4hrung)","rebasedAmount":{"label":"Anzahl\\nnach\\nSplits","tooltip":"Anzahl der Wertpapiere der Transaktion, nachdem alle Splits seit dem Transaktionsdatum ber\xfccksichtigt worden sind."},"assetId":{"label":"Asset","tooltip":"F\xfcr welches Asset ist dieser Preis?"},"assetName":{"label":"Name","tooltip":"Wie m\xf6chtest du dieses Asset nennen?"},"assetMetal":{"label":"Metall","tooltip":"Um welches Edelmetall handelt es sich? W\xe4hle aus der Liste."},"assetPurity":{"label":"Reinheit","tooltip":"Verschiedene Formen von Edelmetallverm\xf6gen haben unterschiedliche Reinheiten, z. B. .999 f\xfcr Gold. Gib die Reinheit dieses Assets in Tausendstel an (999 oder 965)."},"assetAdditionalValue":{"label":"Zusatzwert","tooltip":"Einige M\xfcnzen haben aufgrund ihrer Seltenheit oder k\xfcnstlerischen Bedeutung einen zus\xe4tzlichen Wert. Gib den Zusatzwert deines Assets in Prozent an (dies wird zum reinen Metallwert hinzugef\xfcgt). Beispiel: wenn das Metall darin allein 100 wert ist und der zus\xe4tzliche Wert 20% betr\xe4gt, berechnen wir den Wert dieser M\xfcnze als 120. Steigt der Metallpreis, addieren wir weiterhin die 20% f\xfcr diese M\xfcnze."},"assetWeight":{"label":"Gewicht","tooltip":"Wieviel wiegt dieses Asset? Trage das Gewicht in Gramm ein."},"transactionValue":{"label":"Transaktionssumme","tooltip":"Optional. Gekaufte/verkaufte Menge * Preis pro Einheit. Wenn du beide Werte eingibst, berechnen wir dies automatisch."},"transactionCurrencyValue":{"label":"Originelle Summe","tooltip":"Optional. Gekaufte/verkaufte Menge * Preis pro Einheit in der urspr\xfcnglichen Transaktionsw\xe4hrung. Wenn du beide Werte eingibst, berechnen wir dies automatisch."},"rebasedOriginalPrice":{"label":"Preis\\nnach\\nSplits","tooltip":"Wenn Wertpapiere einem Split unterworfen wurden, verringern sich ihre St\xfcckpreise verh\xe4ltnism\xe4\xdfig. Preise in dieser Spalte ber\xfccksichtigen diese \xc4nderungen."},"pricePerSquareMetre":"Preis per m","originalPricePerSquareMetre":"Preis (Original-\\nw\xe4hrung) per m","transactionType":{"label":"Transaktionsart","tooltip":"Kauf oder Verkauf der Immobilie."},"realEstateTransactionPrice":{"label":"Preis\\n(Basisw\xe4hrung)","tooltip":"Der eigentliche Kaufs- oder Verkaufspreis, in der Basisw\xe4hrung, Transaktionsw\xe4hrung kann automatisch berechnet werden. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"realEstateOriginalPrice":{"label":"Preis\\n(Originalw\xe4hrung)","tooltip":"Der eigentliche Kaufs- oder Verkaufspreis, in der eigentlichen Transaktionsw\xe4hrung, Basisw\xe4hrung kann automatisch berechnet werden.. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"source":{"label":"Quelle","tooltip":"Kommt die Bewertung von dem Provider oder ist es manuell eingepflegt? Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"price":{"label":"Wert\\n(Basis-\\nw\xe4hrung)","tooltip":"Welchen Verkaufspreis (in Basisw\xe4hrung) w\xfcrde die Immobilie an dem Datum erzielen? Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern.","tooltipGrid":"Wenn Originalw\xe4hrung und -preis vorhanden sind, wird dieses Feld automatisch berechnet."},"priceShort":{"label":"Preis"},"currency":"Originalw\xe4hrung","originalPrice":{"label":"Wert\\n(Original-\\nw\xe4hrung)","tooltip":"Welchen Verkaufspreis (in der Originalw\xe4hrung) w\xfcrde die Immobilie an dem Datum erzielen? Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern.","tooltipGrid":"Wenn leer, wird EUR eingesetzt."},"size":{"label":"Anzahl","tooltip":"Anzahl aller noch nicht verkauften Wertpapiere dieser Transaktionen. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"split":{"label":"Split","tooltip":"Verh\xe4ltnis von alten zu neuen Aktien."},"openPositionSize":{"label":"Unverkaufte Anzahl","tooltip":"Anzahl aller noch nicht verkauften Wertpapiere dieser Transaktionen. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"purchaseValue":{"label":"Kaufwert","tooltip":"Wert beim Ankauf der Wertpapiere, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"baselineValue":{"label":"Basiswert","tooltip":"Wert an dem von dir festgelegten Basisdatum, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"currentValue":{"label":"Aktueller Wert","tooltip":"Aktueller Wert der Wertpapiere in deiner Basisw\xe4rhung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"valueTransactionCurrency":{"label":"Wert\\n(Transaktions-\\nw\xe4rhung)","tooltip":"Optional. Wert der Anlage in der Transaktionsw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"valueAccountCurrency":{"label":"Wert","tooltip":"Optional. Wert der Anlage in der Kontow\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"valueBaseCurrency":{"label":"Wert\\n(Basis\\nw\xe4hrung)","tooltip":"Optional. Wert der Anlage in deiner Basissw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"purchasePrice":{"label":"Kaufpreis","tooltip":"Preis beim Ankauf der Wertpapiere, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"baselinePrice":{"label":"Basispreis","tooltip":"Preis an dem von dir festgelegten Basisdatum, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"currentPrice":{"label":"Aktueller Preis","tooltip":"Aktueller Preis und Wert der Wertpapiere in deiner Basisw\xe4rhung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"purchaseCurrentValuePrice":{"label":"Wert / Preis","tooltip":"Preis und Wert beim Ankauf der Wertpapiere sowie jetzt, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"purchaseValuePrice":{"label":"Kaufwert / -preis","tooltip":"Preis und Wert beim Ankauf der Wertpapiere, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"baselineValuePrice":{"label":"Basiswert / -preis","tooltip":"Preis und Wert an dem von dir festgelegten Basisdatum, in deiner Basisw\xe4hrung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"currentValuePrice":{"label":"Aktueller Wert / Preis","tooltip":"Aktueller Preis und Wert der Wertpapiere in deiner Basisw\xe4rhung. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"dividends":{"label":"Dividenden / Geb\xfchren","tooltip":"Summe aller Dividenden und Geb\xfchren seit dem Kauf der Wertpapiere + anteilig kontobezogenen Kosten. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"dividendsSincePurchase":{"label":"Dividenden / Geb\xfchren seit Kauf ","tooltip":"Summe aller Dividenden und Geb\xfchren seit dem Kauf der Wertpapiere. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"roi":{"label":"ROI gesamt / ROI j\xe4hrlich","tooltip":"Aktueller Wert der Wertpapiere im Verh\xe4ltnis zu dem Kaufwert (Return on Investment). Ber\xfccksichtigt Dividenden und Geb\xfchren. Gesamt und als Durchschnitt pro Jahr. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"roiShort":{"label":"ROI gesamt / j\xe4hrlich","tooltip":"Aktueller Wert der Wertpapiere im Verh\xe4ltnis zu dem Kaufwert (Return on Investment). Dividenden und Geb\xfchren inklusiv. Gesamt und als Durchschnitt pro Jahr. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"roiOnly":{"label":"ROI","tooltip":"Aktueller Wert der Wertpapiere im Verh\xe4ltnis zu dem Kaufwert (Return on Investment). Dividenden und Geb\xfchren inklusiv. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"payoutsSincePurchase":{"label":"Auszahlungen seit Kauf","tooltip":"Summe aller Auszahlungen seit dem Kauf der Assets. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"feesSincePurchase":{"label":"Geb\xfchren seit Kauf","tooltip":"Summe aller Geb\xfchren seit dem Kauf der Assets. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"costsSincePurchase":{"label":"Kosten seit Kauf","tooltip":"Summe aller Kosten seit dem Kauf der Assets. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"roiAnnual":{"label":"J\xe4hrliches ROI","tooltip":"Wie m\xfcsste der anf\xe4ngliche Betrag der Investition verzinst sein, um den aktuellen Wert zu erreichen? Ber\xfccksichtigt Dividenden und Geb\xfchren. Klicke hier um nach dieser Spalte zu sortieren oder um die Reihenfolge zu \xe4ndern."},"keepFlag":{"label":"Behalten?","tooltip":"Uncheck the rows that you want to remove from your import."},"payoutOnlyContributionsToDate":{"label":"Rente (nur Beitr\xe4ge bis heute)","tooltip":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du heute die Beitr\xe4ge einstellst."},"payoutOnlyContributionsToDateIndexed":{"label":"Rente (nur Beitr\xe4ge bis heute,\\nmit Wertentwicklung)","tooltip":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du heute die Beitr\xe4ge einstellst, mit zuk\xfcnftiger Wertentwicklung bereits angelegtes Kapitals."},"payoutAllPlannedContributions":{"label":"Rente (alle zuk\xfcnftigen Beitr\xe4ge)","tooltip":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du die Beitr\xe4ge bis der Ende der Ansparphase zahlst."},"payoutAllPlannedContributionsIndexed":{"label":"Rente (alle zuk\xfcnftigen Beitr\xe4ge,\\nmit Wertentwicklung)","tooltip":"H\xf6he der Rentenzahlungen, die du erhalten w\xfcrdest, falls du die Beitr\xe4ge bis der Ende der Ansparphase zahlst, mit zuk\xfcnftiger Wertentwicklung bereits angelegtes Kapitals."},"payoutLumpSumVerrentet":{"label":"Einmalzahlung in lebenslange Rente umwandeln","tooltip":"Das angesparte Kapital wird in eine lebenslange Rente umgerechnet."},"note":{"label":"Note","tooltip":"Valuation details"},"proceeds":{"label":"Einnahmen","tooltip":"Einnahmen von diesem Wertobjekt"}},"stocks":{"allowedTransactionTypes":["sale","purchase","split"]},"deposits":{"labels":{"noLabel":{"long":"Ohne Tag","short":"Ohne Tag"},"investment-fees":{"long":"Transaktionsgeb\xfchr","short":"Geb\xfchr"},"investment-costs":{"long":"Kontogeb\xfchr","short":"Kontogeb\xfchr"},"investment-interest":{"long":"Zinsen","short":"Zinsen"},"investment-dividend":{"long":"Dividende","short":"Dividende"},"investment-transfer":{"long":"Transfer","short":"Transfer"},"investment-rent":{"long":"Mieteinnahmen","short":"Miete"},"investment-purchase":{"long":"Asset-Kauf","short":"Asset-kauf"},"investment-sale":{"long":"Asset-Verkauf","short":"Asset-Verkauf"},"investment-payout":{"long":"Kreditauszahlung","short":"Kreditauszahlung"},"investment-loanRepayment":{"long":"Kreditrate","short":"Kreditrate"},"investment-loanInterest":{"long":"Kreditrate (Zins)","short":"Kredit (Zinsen)"},"investment-loanPrincipal":{"long":"Kreditrate (Kapital)","short":"Kredit (Kapital)"},"investment-pension":{"long":"Rente (Auszahlung)","short":"Rente"},"investment-contribution":{"long":"Rentenbeitrag","short":"Beitrag"}},"markThisTransaction":"Diese Transaktion taggen","noTransactions":"Keine mit diesem Konto verlinkten Transaktionen gefunden.","noTransactionsWithin":"Keine \xe4hnlichen, mit diesem Konto verlinkten Transaktionen gefunden, die innerhalb von 7 Tagen von dieser Transaktion stattfanden.","noAccounts":"Keine verlinkten Konten gefunden.","noAssets":"Keine Assets auf verlinkten Kontos gefunden.","addTag":"Neuer Tag","whichItem":"Auf welche(s) Konto / Transaktion bezieht sich die Transaktion?"},"pension":{"import":{"title":"Welches Produkt verwenden?","prompt":"Du scheinst Daten von rvuebersicht.de zu importieren. In dieser Datei gibt es Daten f\xfcr mehere Produkte. Bitte w\xe4hle das f\xfcr dieses Konto richtige Produkt aus.","ignore":"Ignorieren","cancel":"Cancel","baseCurrencyDialog":{"title":"Currency conversion","prompt":"The currency of the imported data is different from the base currency of this account. How should we convert this currency? As it is difficult to predict the future exchange rate, we suggest to use today\'s.","fxRate":"Exchange rate to use","todayFxIs":"Today\'s exchange rate is","apply":"Anwenden"}}},"contextMenu":{"addEmptyRowAbove":"Leere Zeile(n) oben einf\xfcgen","addEmptyRowBelow":"Leere Zeile(n) unten einzuf\xfcgen","addEmptyColumnAbove":"Leere Spalte links einf\xfcgen","addEmptyColumnBelow":"Leere Spalte rechts einf\xfcgen","duplicateRow":"Zeile duplizieren","duplicateColumn":"Spalte duplizieren","deleteRow":"Zeile l\xf6schen","deleteColumn":"Spalte l\xf6schen","cut":"Ausschneiden","copy":"Kopieren","paste":"Einf\xfcgen","download":"Alles exportieren","downloadSelected":"Markierte Zeilen exportieren"},"splitMenu":{"split":"Aufteilen","splitHeader":"Diese Transaktion in zwei oder mehr Transaktionen aufteilen","splitInfo":"Denke daran, Transaktionsgeb\xfchren und Kauf-/Verkaufstransaktionen im verbundenen Einzahlungskonto aufzuteilen.","splitExistingDetected":"Diese Transaktion wurde bereits aufgeteilt. Du kannst die Aufteilung bearbeiten oder die Aufteilung r\xfcckg\xe4ngig machen.","copyAsSimulated":"Als Simulation kopieren","copyAsSimulatedInfo":"Erstelle eine simulierte Transaktion basierend auf dieser. Du kannst alle Parameter im n\xe4chsten Bildschirm anpassen.","showInProject":"Mit Projekt verlinken","showInProjectInfo":"Du kannst diese tats\xe4chliche Transaktion in einem Projekt anzeigen.","aiLabelLoanRepayment":"Zinsen und Tilgung automatisch erkennen","aiLabelLoanRepaymentInfo":"Die KI ermittelt Tilgung und Zinsen f\xfcr diese Transaktion (oder alle ausgew\xe4hlten Transaktionen) und vergibt automatisch das Kreditraten-Label.","aiLabelLoanRepaymentRunning":"Ausgew\xe4hlte Transaktionen werden verarbeitet...","aiLabelLoanRepaymentRunningTakesUpTo30s":"Dies kann bis zu 30 Sekunden dauern.","run":"Ausf\xfchren","separateInterestFromPrincipal":"Zinsen von Tilgung trennen","splitLabelLoan":"Darlehen: teilen, verlinken + taggen.","splitLabelLoanInfo":"Teile Darlehenrate in den Zins- und Tilgungsanteil auf, verlinke sie mit dem Darlehen-Projekt und tagge sie.","splitLabelLoanInfo2":"Darlehenrate muss aufgeteilt werden, da beide Teile sich unterschiedlich auf das Kapitaleinkommen auswirken. Die Labels werden den neuen Transaktionen automatisch zugewiesen. Eine gelinkte Transaktion in dem Darlehen-Konto kann auch erstellt werden.","calculateExpectedSplitInfo":"Falls es in der Transaktion keine Infos zu der Aufteilung von Zins/Kapital dieser Rate gibt, wir k\xf6nnen sie anhand Darlehenparameter berechnen.","delete":"L\xf6schen","pressSaveToDelete":"Dr\xfccke >Speichern<, um diese Transaktion zu l\xf6schen.","pick":"Ein Projekt ausw\xe4hlen","error":"Bitte \xfcberpr\xfcfe deine Eingabe.","amountToAllocate":"Noch aufzuteilen","allocatedTooMuch":"Zu viel aufgeteilt um","amountToAllocateInterest":"Zinsen noch aufzuteilen","allocatedTooMuchInterest":"Zu viel Zinsen aufgeteilt um","selectLoanAccount":"Darlehen-Konto ausw\xe4hlen","splitAndLabelLoanInfo":"Teile diese Kreditrate in Tilgung und Zinsen auf.","splitAndLabelLoanInfo2":"Die Banktransaktion bleibt eine einzelne Kreditrate. Die Aufteilung in Tilgung und Zinsen wird fuer den Kreditverlauf und fuer KPI-Berechnungen verwendet.","transactionDescriptionLabel":"Aktuelle Transaktionsbeschreibung","transactionDescriptionEmpty":"Keine Beschreibung","calculateExpectedSplit":"Erwartete Aufteilung berechnen"},"settings":{"symbol":"Symbol","dividend":"Dividend (% pro Jahr)","growthRate":"Wachstum (% pro Jahr)","add":"Add","simulatedAccountGrowth":{"heading":"Simuliertes Kontowachstum","description":"Dieser Wert wird verwendet, um zuk\xfcnftiges Wachstum all deiner Aktien-Konten zu simulieren. Weitere Informationen findest du in diesem Blog-Eintrag.","fieldLabel":"Wachstumsrate","dividendPayments":"Du kannst auch zuk\xfcnftige Dividendenzahlungen simulieren - \xfcber alle Aktien-Konten hinweg. Gebe die erwartete Dividende pro Aktie pro Jahr an, die j\xe4hrlich um die oben angegebene Wachstumsrate erh\xf6ht wird.","dividendTooltip":"Dividende / Zins wird als % der aktuellen Wert berechnet."},"spread":{"description":"Wir berechnen den aktuellen Wert deiner Edelmetalle basierend auf dem realistischen Preis, den du beim Verkauf deines Verm\xf6genswerts erzielen wirst.","description2":"Dieser Preis ist niedriger als der Marktpreis aufgrund der Marge des K\xe4ufers (genannt \'Spread\'). Wir empfehlen einen konservativen Spread von 10% des Marktpreises, aber du kannst ihn hier \xe4ndern. Der Spread wird vom aktuellen Marktwert deiner Metallwerte abgezogen.","label":"Spread (%)","error":"Bitte gib einen Spread-Prozentsatz an"},"autoImportPretransformation":{"heading":"Importeinstellungen merken","body":"Beim n\xe4chsten Import f\xfcr dieses Konto k\xf6nnen wir deine fr\xfcheren Import-Transformationen automatisch anwenden.","label":"Importeinstellungen merken"},"realEstateValuations":{"heading":"Konten f\xfcr automatische Bewertungs-Updates ausw\xe4hlen","label":"Wir k\xf6nnen Bewertungen f\xfcr einige deiner Immobilienkonten automatisch aktualisieren. W\xe4hle aus, welche das sein sollen."}},"loanIndicators":{"principalRemaining":"Restkapital","interestRemaining":"Restzinsen","history":"Verlauf","loanRepaid":"Getilgtes Kapital","loanRepaidTooltip":"Welcher Prozentsatz des Kapitals bis heute getilgt wurde.","interest":"Zinsen","interestPaid":"bis heute gezahlt","interestTooltip":"Gesamtbetrag der bis heute gezahlten Zinsen und wie viel Prozent des bisher getilgten Kapitals das ist.","interestPaidToPrincipalPaid":"vs. getilgtes Kapital","balance":"Saldo","balanceTooltip":"Verbleibender zu zahlender Betrag (Kapital + Zinsen), wenn das Darlehen gem\xe4\xdf Tilgungsplan zur\xfcckgezahlt wird."},"pensionIndicators":{"presentValueChanges":"\xc4nderungen der erwarteten Auszahlungen","roi":"Kapitalrendite","sumContributions":"Beitr\xe4ge","sumContributionsTooltip":"Gesamtbetrag der bisher gezahlten Beitr\xe4ge.","presentValue":"Produktwert","presentValueTooltip":"Wert Ihres Pensionsprodukts in heutigem Geld."},"unlistedShares":{"wizard":{"transactions":{"header":"Welche Art von Transaktion f\xfcgen wir hinzu?","moreShares":"Neue Aktien kaufen","moreCapital":"Eigenkapital erh\xf6hen (ohne neue Aktien zu emittieren)","sharesSale":"Aktien verkaufen","capitalDisbursement":"Eigenkapital als Auszahlung erhalten (Kapitalaussch\xfcttung)","error":"Bitte w\xe4hle eine Option","formHeader":"Details der Transaktion","submit":"Speichern","deleteThisTransaction":"L\xf6schen","clickToOpenDeposit":"Um Eigenkapital ein- oder auszuzahlen, ohne Aktien zu emittieren / zur\xfcckzukaufen, gehe zum verbundenen Bankkonto und tagge deine Transaktion als \'Kapitalerh\xf6hung\' oder \'Kapitalauszahlung\':","noConnectedDeposit":"Verbinde zuerst ein Bankkonto (Button oben, direkt unter Firmenname).","quantity":{"label":"Anzahl an Aktien","tooltip":"Anzahl der Aktien, die du kaufst oder verkaufst","error":"Bitte gib eine Anzahl an"},"upac":{"label":"Preis pro St\xfcck","tooltip":"Preis pro Aktie, in der W\xe4hrung dieses Kontos","error":"Bitte gib einen Preis an"},"capitalAmount":{"label":"Kapitalerh\xf6hungsbetrag","tooltip":"Betrag, den du in das Unternehmen investierst, in der W\xe4hrung dieses Kontos","error":"Bitte gib einen Betrag an"},"capitalDisbursementAmount":{"label":"Kapitalerauszahlungsbetrag","tooltip":"Betrag, den du aus dem Eigenkapital des Unternehmen erh\xe4lst, in der W\xe4hrung dieses Kontos","error":"Bitte gib einen Betrag an"},"dateUserInput":{"label":"Datum","tooltip":"Datum der Transaktion","error":"Bitte gib ein Datum an"}},"valuation":{"title":"Firmenwert-Rechner","description":"W\xe4hle  die Lebenszyklusphase deines Unternehmens unten aus oder trage einen Wert manuell ein.","score":{"0":{"label":"Neutral","tooltip":"Dein Unternehmen ist in einer \xe4hnlichen Position wie der Markt / seine Mitbewerber"},"1":{"label":"Mehr","tooltip":"Dein Unternehmen ist in einer besseren Position als der Markt / seine Mitbewerber"},"2":{"label":"Viel mehr","tooltip":"Dein Unternehmen ist in einer deutlich besseren Position als der Markt / seine Mitbewerber"},"-2":{"label":"Viel weniger","tooltip":"Dein Unternehmen ist in einer deutlich schlechteren Position als der Markt / seine Mitbewerber"},"-1":{"label":"Weniger","tooltip":"Dein Unternehmen ist in einer schlechteren Position als der Markt / seine Mitbewerber"}},"stage":{"label":"Stage","tooltip":"Bewertungsmethoden, die wir anwenden k\xf6nnen, h\xe4ngen von der Entwicklungsphase deines Unternehmens ab. W\xe4hle die Phase aus, die das Unternehmen momentan am besten beschreibt.","idea":{"label":"Idee","tooltip":"Das Unternehmen befindet sich in der Ideenphase. Es wurde noch nicht gegr\xfcndet."},"prototype":{"label":"Prototyp","tooltip":"Das Unternehmen hat einen Prototyp oder die Arbeit ist sehr fortgeschritten. Der Markteintritt ist noch nicht erfolgt."},"mvp":{"label":"MVP","tooltip":"Das Unternehmen hat ein Minimum Viable Product und testet es auf dem Markt."},"expansion":{"label":"Expansion","tooltip":"Das Unternehmen w\xe4chst schnell und hat eine stabile Kundenbasis."},"market":{"label":"Markt","tooltip":"Das Unternehmen ist gut etabliert und hat eine starke Kundenbasis."}},"valuationMethod":{"label":"Verf\xfcgbare Bewertungsmethoden","tooltip":"W\xe4hle die Methoden aus, die du zur Bewertung deines Unternehmens verwenden m\xf6chtest. Du kannst mehrere Methoden ausw\xe4hlen."},"info":"Vergleiche dein Unternehmen mit \xe4hnlichen Unternehmen auf dem Markt. Die Bewertungsmethoden werden basierend auf den von dir bereitgestellten Informationen angewendet.","insufficientData":"Mehr Daten erforderlich","insufficientDataTooltip":"Wir brauchen noch die folgenden Infos, um die Sch\xe4tzung zu berechnen: {{fields}}.","required":"Bitte gib sowohl das Datum als auch die Bewertung an.","ideaStrength":{"label":"St\xe4rke der Idee","tooltip":"Die St\xe4rke der Idee oder des Gesch\xe4ftskonzepts hinter dem Unternehmen"},"prototypeProgress":{"label":"Prototyp Fortschritt","tooltip":"Der Fortschritt bei der Entwicklung des Produktprototyps (\'viel weniger\', wenn kein Prototyp existiert, \'viel mehr\', wenn ein vollst\xe4ndig getesteter Prototyp existiert)"},"teamCapability":{"label":"Teamf\xe4higkeit","tooltip":"Die F\xe4higkeit und Erfahrung der Teammitglieder"},"marketingRelationships":{"label":"Marketingbeziehungen","tooltip":"Die St\xe4rke und das Ausma\xdf der Marketing- / Lieferkettenbeziehungen"},"marketTraction":{"label":"Markttraktion","tooltip":"Erfolg bei der Einf\xfchrung des Produkts auf dem Markt / Umsatzwachstum"},"competitiveAdvantage":{"label":"Wettbewerbsvorteil","tooltip":"Hat dieses Unternehmen irgendeine Art von Vorteil gegen\xfcber seinen Wettbewerbern?"},"similarStartupValuationsArray":{"label":"Bewertungen \xe4hnlicher Unternehmen","tooltip":"Ungef\xe4hre Bewertungen f\xfcr \xe4hnliche Unternehmen"},"technologyRisk":{"label":"Technologisches Vertrauen","tooltip":"Im Vergleich zu \xe4hnlichen Unternehmen, ist die von diesem Unternehmen verwendete Technologie mehr oder weniger riskant?"},"ipStrength":{"label":"St\xe4rke des geistigen Eigentums","tooltip":"Besitzt das Unternehmen alle wichtigen Patente / geistiges Eigentum, die f\xfcr den Start und das weitere Wachstum notwendig sind?"},"totalAdressableMarketSize":{"label":"Gesamte adressierbare Marktgr\xf6\xdfe","tooltip":"Die Gesamtgr\xf6\xdfe des Marktes, den das Unternehmen adressieren kann"},"marketGrowthRate":{"label":"Marktwachstumsrate","tooltip":"Die Wachstumsrate des Marktes, in dem das Unternehmen t\xe4tig ist"},"marketEntryBarriers":{"label":"Markteintrittsbarrieren","tooltip":"Wie schwierig (wegen Kapital, Werkzeuge, geistiges Eigentum etc.) ist es, ein Unternehmen in diesem Markt zu gr\xfcnden?"},"needForMoreInvestment":{"label":"Bedarf an weiteren Investitionen","tooltip":"Wie viel mehr Investitionen sind erforderlich, um das Unternehmen auf die n\xe4chste Stufe zu bringen?"},"legalRisk":{"label":"Rechtliche Stabilit\xe4t","tooltip":"Je mehr rechtliche (Gesetzgebung, Patente etc.) Risiken das Unternehmen haben k\xf6nnte, desto geringer ist die Stabilit\xe4t."},"internationalRisk":{"label":"Internationale Stabilit\xe4t","tooltip":"Die Risiken im Zusammenhang mit der Ausweitung der internationalen Gesch\xe4ftst\xe4tigkeit"},"marketRisk":{"label":"Marktstabilit\xe4t","tooltip":"Ist der Markt, in dem das Unternehmen t\xe4tig ist, stabil (\'mehr\') oder volatil (\'weniger\')?"},"financialPerformance":{"label":"Finanzielle Leistung","tooltip":"Die finanzielle Leistung des Unternehmens (Rentabilit\xe4t)"},"assetsArray":{"label":"Verm\xf6genswerte","tooltip":"Eine Auflistung der Verm\xf6genswerte des Unternehmens"},"intangiblesArray":{"label":"Immaterielle Werte","tooltip":"Eine Auflistung der immateriellen Werte des Unternehmens"},"liabilitiesArray":{"label":"Verbindlichkeiten","tooltip":"Eine Auflistung der Verbindlichkeiten des Unternehmens"},"targetRaisedCapital":{"label":"Kapital zu beschaffen","tooltip":"Welches Kapital m\xf6chte dein Unternehmen derzeit beschaffen?"},"cashFlowArray":{"label":"Cashflows","namePlaceholder":"Jahr","tooltip":"Wie sehen die erwarteten Cashflows deines Unternehmens aus?"},"discountRate":{"label":"Abzinsungssatz (in %)","tooltip":"Der Abzinsungssatz, der in der DCF-Methode verwendet wird (Kapitalbeschaffungskosten f\xfcr dein Unternehmen, d.h. ungef\xe4hr welcher Zinssatz wird auf Darlehen gezahlt)"},"longTermGrowthRate":{"label":"Stabile Wachstumsrate (in %)","tooltip":"Langfristige, nachhaltige Wachstumsrate, sobald die Cashflows stabil sind (sollte konservativ sein und niedriger als der Abzinsungssatz). Wird zur Berechnung des Terminalwerts verwendet.","error":"Die stabile Wachstumsrate muss f\xfcr diese Berechnung niedriger als der Abzinsungssatz sein."},"finalQuote":{"label":"Endbewertung","tooltip":"Welche Bewertung m\xf6chtest du speichern, basierend auf den bereitgestellten Informationen?","error":"Bitte gebe eine Endbewertung an","description":"Bestimme die endg\xfcltige Bewertung des Unternehmens basierend auf den bereitgestellten Informationen.","save":"Speichern","deleteThisQuote":"Diese Bewertung l\xf6schen","resetThisQuote":"Bewertung zur\xfccksetzen"},"percentOwned":{"label":"Anteil in Besitz","tooltip":"Welchen Anteil dieses Unternehmen besitzt du?","error":"Bitte gebe den Anteil an, den du besitzt"},"methods":{"berkus":{"label":"Berkus","tooltip":"Eine Methode zur Bewertung von Startups basierend auf Idee, Prototyp, Team, Markttraktion und Wettbewerbsvorteil."},"scorecard":{"label":"Scorecard","tooltip":"Eine Methode zur Bewertung von Startups mittels eines Punktesystems, das verschiedene Aspekte wie Team, Produkt und Markt vergleicht."},"riskFactor":{"label":"Risikofaktor","tooltip":"Eine Methode zur Bewertung der Risiken eines Startups, einschlie\xdflich Technologie-, Markt- und Teamrisiken."},"valuationByStage":{"label":"Bewertung nach Phase","tooltip":"Eine Methode zur Bestimmung des Werts eines Startups basierend auf seiner aktuellen Entwicklungsphase."},"replacementCost":{"label":"Ersatzkosten","tooltip":"Eine Methode zur Berechnung der Kosten, um die Verm\xf6genswerte und den Betrieb des Unternehmens zu ersetzen."},"bookValue":{"label":"Buchwert","tooltip":"Eine Methode zur Bewertung des Nettoverm\xf6gens eines Unternehmens durch Abzug der Verbindlichkeiten von den Verm\xf6genswerten."},"fiveTimesYourRise":{"label":"F\xfcnfmal dein Kapital","tooltip":"Eine Methode, bei der das Zielkapital um das F\xfcnffache multipliziert wird, um den Unternehmenswert zu sch\xe4tzen."},"dcf":{"label":"DCF","tooltip":"Eine Discounted Cash Flow-Methode zur Bewertung eines Unternehmens basierend auf seinen prognostizierten zuk\xfcnftigen Cashflows."}}}}},"cryptoAssetMappingDialog":{"header":"Automatische Preisaktualisierungen","prompt":"Kryptow\xe4hrungen sind dezentralisiert. Um sicherzustellen, dass wir den richtigen Preis f\xfcr deine Verm\xf6genswerte ermittelt haben, \xfcberpr\xfcfe diese Zuordnungen und klicke auf >Speichern<. Wenn die vorgeschlagenen Preise zu deinem Asset nicht passen, lasse es unmarkiert.","asset":"Krypto-Symbol","status":"Preise ermittelt","headerAssetDetails":"Preise finden f\xfcr:","promptAssetDetails":"F\xfcr diese Kryptow\xe4hrungen k\xf6nnen wir die Preise automatisch aktualisieren. W\xe4hle eine aus oder suche nach einem passenden Begriff, danach klicke auf >OK<. Wenn keine der vorgeschlagenen Kryptow\xe4hrungen passt, lasse die Liste unmarkiert.","symbol":"Symbol","name":"Name","marketCap":"Marktgr\xf6\xdfe","liquidity":"Liquidit\xe4t","price":"Aktueller Preis","page":"Seite","pageOf":"von","next":"N\xe4chstes","previous":"Voheriges","noResults":"Keine Preise gefunden"},"filterDialog":{"filter":"Filter","prompt":"W\xe4hle nur Zellen aus, die folgende Bedingungen erf\xfcllen:","is":"ist","isNot":"ist nicht","contains":"enth\xe4lt","doesNotContain":"enth\xe4lt nicht","startsWith":"beginnt mit","doesNotStartWith":"beginnt nicht mit","endsWith":"endet mit","doesNotEndWith":"endet nicht mit","greaterThan":"gr\xf6\xdfer als","greaterThanOrEqual":"gr\xf6\xdfer als oder gleich","lessThan":"kleiner als","lessThanOrEqual":"kleiner als oder gleich","equalTo":"gleich","blank":"leer","phrase":"Ausdruck","addMore":"Weitere hinzuf\xfcgen","cancel":"Abbrechen","rulesErrorLength":"Der Wert darf maximal 200 Zeichen lang sein.","rulesErrorNumber":"Der Wert muss eine Zahl sein."},"tableFilters":{"results":"{{shown}} von {{total}} Zeilen","clearAll":"Filter l\xf6schen"},"tableFiltersDialog":{"title":"Liste filtern","description":"Verfeinere die sichtbaren Zeilen, ohne Daten zu ver\xe4ndern.","searchLabel":"Suchbegriff","searchPlaceholder":"Beschreibung, Gegenpartei, IBAN...","amountLabel":"Betrag","amountAny":"Beliebiger Betrag","amountInflow":"Nur Zufl\xfcsse","amountOutflow":"Nur Abfl\xfcsse","amountZero":"Betrag = 0","dateLabel":"Datum","dateAll":"Alle Daten","date30d":"Letzte 30 Tage","date90d":"Letzte 90 Tage","date365d":"Letzte 12 Monate","reset":"Zur\xfccksetzen","cancel":"Abbrechen","apply":"Filter anwenden"},"gettingStarted":{"heading":"Erste Schritte","subheading":"F\xfclle dein neues Konto mit Daten","intro":"Es ist einfach anzufangen, und du entscheidest, wie du das tun m\xf6chtest.\\nErinnere dich: Alles, was du tust, kann sp\xe4ter aktualisiert werden.","features":[{"name":"Gib das aktuelle Saldo ein","description":"Klicke auf >Bearbeiten<, gib das aktuelle Kontosaldo ein und speichere. Du kannst sp\xe4ter mehr Details hinzuf\xfcgen."},{"name":"Transaktionen aus Datei importieren","description":"Lade eine Transaktionsdatei aus dem Online-Banking deiner Bank herunter. Sobald du sie hast, dr\xfccke den >Importieren<-Button und folge unseren Schritt-f\xfcr-Schritt-Anweisungen."},{"name":"Transaktionen automatisch abrufen","description":"Wenn es eine technische Verbindung gibt, kannst du deine Transaktionen automatisch abrufen. Dr\xfccke einfach auf den >Sync<-Button und wir erledigen den Rest."}],"cashflow":{"heading":"Warum sind hier keine Daten?","subheading":"Tagge die zugeh\xf6rigen Auszahlungen und Kosten im Verrechnungskonto","intro":"Erfasse die Transaktionen im verbundenen Verrechnungskonto und tagge sie f\xfcr dieses Konto, damit sie hier erscheinen.","navigateIntro":"\xd6ffne jetzt das verkn\xfcpfte Verrechnungskonto, um die Transaktionen f\xfcr dieses Asset zu taggen:"},"values":{"heading":"Eigene Werte","subheading":"Pflege deinen Preisverlauf","intro":"Hinterlege eigene Preise, wenn Marktdaten fehlen oder \xfcberschrieben werden sollen.","features":[{"name":"Preise im Grid bearbeiten","description":"Klicke auf Bearbeiten, wechsle in den Grid-Modus und trage deine Preise pro Asset ein, dann speichern."},{"name":"Bewertungen importieren","description":"Nutze Import, um Preisdaten hochzuladen statt sie abzutippen."}]}}}');


var $2593f3b2e41cf99a$exports = {};
$2593f3b2e41cf99a$exports = JSON.parse('{"Settings":"Settings","Select a tab":"Select a tab","preferences":{"header":"Preferences","baseCurrency":"Your base currency","preferredLanguage":"Preferred language","baselineDate":"Baseline date","expectedDateFormats":"Import date formats","expectedDateFormatsInfo":"Data formats in your imported files may differ. Please update the formats you expect to see in your files, so that we may use them to convert the dates to our internal format. We will try to apply them one by one until we see a proper date, starting from the topmost one and moving down.","expectedDateFormatsAllowed":"You can use standard date formatting characters, like YYYY, MM, DD etc. For example, \'YYYY-MM-DD\' or \'DD.MM.YYYY\'. We support","expectedDateFormatsAllowedLink":"all these formats.","expectedDateFormatsError":"Please remove unsupported characters."},"simulations":{"header":"Simulations","info":"The parameters below will be used in the simulations to calculate the future growth of your assets.","slider":"Slider","setDates":"Set the start and end dates for all your projects, simulations and the Slider.","startDate":"Start date","endDate":"End date","inflation":"Inflation","inflationEnabledDescription":"If enabled, the system will automatically increase all inflows and outflows by the specified percentage every year. This will not apply to inflows and outflows for which an individual increase rate is defined.","disabled":"Disabled","enabled":"Enabled","simulatedInflationRate":"Simulated inflation rate (%)","averageInflation":"Average inflation 1982-2022 across all OCED countries was 3.55%, 2.95% in the Eurozone and 1.89% in Germany.","source":"Source ","stockMarketGrowthRate":"Category growth rates","simpleMode":"Simple mode: there is one overall growth rate which applies to all your assets (all accounts in the category).","simpleMode2":"Research shows that long-term growth rates for the stock market from historical data are around 5-6% per year.","advancedMode":"Expert mode: you can define individual growth rates for each asset. It will apply to this asset across all your accounts and non-isolated projects in the same category.","advancedMode2":"If we cannot find an individual growth rate for an asset, we will apply the general growth rate (like in simple mode).","simple":"Simple","advanced":"Expert","growthRate":"Category growth rate (%)","stockDividends":"Stock dividends","stockDividendsDescription":"Simple mode: there is one simulated dividend rate (in %) for all stocks (across all accounts). It will only be applied to stocks which yielded a dividend at least once in the past.","stockDividendsDescription2":"Expert mode: set individual dividend rates (in %) for each stock. The app will only apply dividends to stocks defined here across your stocks accounts.","dividendYield":"Dividend yield (%)","symbol":"Symbol","dividendPerYear":"Dividend (%)","add":"Add","save":"Save","cancel":"Cancel"},"account":{"header":"Account","saveChanges":"Save changes","2fa":"Two-factor authentication","changePassword":"Change password","qrCode1":"Scan the QR code with your preferred authenticator app (such as","qrCode2":"or","manualEntry":"If you prefer to enter the code manually, use the following code:","Enable":"Enable","Enabled":"Enabled","Email address":"Email address","emailInfo":"Please have your email account ready when changing your email -- we will send you a confirmation code.","pleaseEnterCode":"Please enter the confirmation code from your email.","enterAuthCode":"Enter the code from your authenticator app once you are done:","Confirm":"Confirm","Submit":"Submit","Username":"Username","Password":"Password","Enter your current password":"Enter your current password","Please enter your current password.":"Please enter your current password.","The new password cannot be the same as the current password.":"The new password cannot be the same as the current password.","Enter new password":"Enter new password","Repeat new password":"Repeat new password"},"billing":{"header":"Subscription","title":"Subscription","leadingText1":"We take your privacy seriously, therefore only our specialised payment provider has access to your payment data.","leadingText2":"Please select one of the links below to manage your subscription directly with our provider Stripe. All links open in a new tab.","currentSubscription":"Your current subscription","upgradePlan":"Upgrade your plan","paymentMethod":"Payment method","downloadInvoices":"Download invoices","cancelSubscription":"Cancel subscription"}}');


var $a259318f91bb059c$exports = {};
$a259318f91bb059c$exports = JSON.parse('{"Settings":"Einstellungen","Select a tab":"W\xe4hle einen Tab","preferences":{"header":"Pr\xe4ferenzen","baseCurrency":"Deine Basisw\xe4hrung","preferredLanguage":"Bevorzugte Sprache","baselineDate":"Basisdatum","expectedDateFormats":"Datumsformate in deinen Dateien","expectedDateFormatsInfo":"Die Datenformate in deinen importierten Dateien k\xf6nnen unterschiedlich sein. Bitte aktualisiere die Formate, die du in deinen Dateien erwartest, damit wir sie verwenden k\xf6nnen, um die Daten in unser internes Format umzuwandeln. Wir werden sie nacheinander anwenden, bis wir ein korrektes Datum sehen, beginnend mit dem obersten und dann weiter nach unten.","expectedDateFormatsAllowed":"Die App erkennt g\xe4ngige Datumsformate, wie z.B. YYYY, MM, DD, zum Beispiel \'YYYY-MM-DD\' oder \'DD.MM.YYYY\'. Wir unterst\xfctzen","expectedDateFormatsAllowedLink":"alle diese Formate.","expectedDateFormatsError":"Verwende bitte nur unterst\xfctzte Formate."},"simulations":{"header":"Simulationen","info":"Die folgenden Parameter werden in den Simulationen zur Berechnung des zuk\xfcnftigen Wachstums deiner Verm\xf6genswerte verwendet.","slider":"Schieberegler","setDates":"Lege das Start- und Enddatum f\xfcr all deine Projekte, Simulationen und den Schieberegler fest.","startDate":"Startdatum","endDate":"Enddatum","inflation":"Inflation","inflationEnabledDescription":"Wenn aktiviert, erh\xf6ht das System automatisch alle Ein- und Auszahlungen jedes Jahr um den angegebenen Prozentsatz. Dies gilt nicht f\xfcr Ein- und Auszahlungen, f\xfcr die eine individuelle Erh\xf6hungsrate festgelegt ist.","disabled":"Deaktiviert","enabled":"Aktiviert","simulatedInflationRate":"Simulierte Inflationsrate (%)","averageInflation":"Die durchschnittliche Inflation in allen OECD-L\xe4ndern betrug von 1982-2022 3,55%, in der Eurozone 2,95% und in Deutschland 1,89%. Quelle","source":"Quelle ","stockMarketGrowthRate":"Wachstumsrate der Kategorien (%)","simpleMode":"Einfacher Modus: setze einen Wachstumsfaktor f\xfcr alle Anlagen (in allen Depots / Konten in derselben Kategorie).","simpleMode2":"Anhand historischer Daten betr\xe4gt die langfristige j\xe4hrliche Wachstumsrate des Aktienmarkts ca. 5-6%.","advancedMode":"Expertenmodus: setze individuelle Wachstumsraten f\xfcr jede Aktie / Kryptow\xe4hrung. Diese gelten f\xfcr dieses Asset in allen Depots / Konten in der Kategorie.","advancedMode2":"F\xfcr Aktien / Kryptow\xe4hrungen, f\xfcr die es keine individuelle Wachstumsfaktoren gibt, gilt der allgemeine Wachstumsfaktor.","growthRate":"Wachstumsrate der Kategorie (%)","simple":"Einfach","advanced":"Expert","stockDividends":"Aktiendividenden","stockDividendsDescription":"Einfacher modus: setze eine Dividendenrendite (in %) f\xfcr alle Aktien. Wir setzen dann diese Rendite f\xfcr alle Aktien in allen Depots ein, die mindestens einmal Dividende ausgezahlt haben.","stockDividendsDescription2":"Expertenmodus: setze individuelle Dividendenrenditen (in %) f\xfcr jede dividendenbringende Aktie. Diese Renditen gelten f\xfcr alle Konten. Die Dividendenrendite werden in diesem Modus nur f\xfcr hier definierten Aktien simuliert.","dividendYield":"Dividendenrendite (%)","symbol":"Symbol","dividendPerYear":"Dividende (%)","add":"Hinzuf\xfcgen","save":"Speichern","cancel":"Abbrechen"},"account":{"header":"Nutzerkonto","saveChanges":"\xc4nderungen speichern","2fa":"Zwei-Faktor-Authentifizierung","changePassword":"Passwort \xe4ndern","qrCode1":"Scanne den QR-Code mit deiner bevorzugten Authenticator-App (wie ","qrCode2":"oder ","manualEntry":"Wenn du den Code lieber manuell eingeben m\xf6chtest, verwende den folgenden Code.","Enable":"Aktivieren","Enabled":"Aktiviert","Email address":"E-Mail-Adresse","emailInfo":"Halt dein E-Mail-Konto bereit, wenn du deine E-Mail \xe4nderst -- wir schicken dir einen Best\xe4tigungscode.","pleaseEnterCode":"Bitte gib den Best\xe4tigungscode aus deiner E-Mail ein.","enterAuthCode":"Gib den Code aus deiner Authenticator-App ein, sobald du fertig bist:","Confirm":"Best\xe4tigen","Submit":"Abschicken","Username":"Benutzername","Password":"Passwort","Enter your current password":"Gib dein aktuelles Passwort ein","Please enter your current password.":"Bitte gib dein aktuelles Passwort ein.","The new password cannot be the same as the current password.":"Das neue Passwort darf nicht dasselbe wie das aktuelle Passwort sein.","Enter new password":"Neues Passwort eingeben","Repeat new password":"Neues Passwort wiederholen"},"billing":{"header":"Abo","title":"Abo","leadingText1":"Deine Privatsph\xe4re ist uns wichtig. Nur unser spezialisiertes Payment-Provider Stripe hat Zugriff auf deine Zahlungsdaten.","leadingText2":"Folge einen der folgenden Links, um deinen Plan direkt bei Stripe zu verwalten. Alle Links \xf6ffnen in einem neuen Tab.","currentSubscription":"Aktueller Plan","upgradePlan":"Plan upgraden","paymentMethod":"Zahlungsmethode","downloadInvoices":"Rechnungen herunterladen","cancelSubscription":"Plan k\xfcndigen"}}');


var $98573a6fc3e9e42a$exports = {};
$98573a6fc3e9e42a$exports = JSON.parse('{"last12months":"Account balances","currentAllocation":"Current allocation (positive assets only)","goToReports":"Go to Reports","mostRecentTransactions":"Most recent transactions","mostRecentQuotes":"Most recent valuations","currentInformation":"Current info","currentPositions":"Current holdings","cannotDisplayNegative1":"The selected field combination yields negative values for the following combination of parameters: ","cannotDisplayNegative2":". This chart does not display negative values correctly. Please select a different set of parameters.","rebalancing":"Rebalancing","interest":"Interest","principal":"Principal"}');


var $1a761f110c49897e$exports = {};
$1a761f110c49897e$exports = JSON.parse('{"last12months":"Kontosalden","currentAllocation":"Aktuelle Aufteilung (nur positive Anlagen)","goToReports":"Zu den Reports","mostRecentTransactions":"Letzte Transaktionen","mostRecentQuotes":"Letzte Bewertungen","currentInformation":"Aktuelle Daten","currentPositions":"Aktueller Bestand","cannotDisplayNegative1":"F\xfcr eine der Kombinationen der ausgew\xe4lten Parameter hat sich eine negative Summe ergeben: ","cannotDisplayNegative2":". Dieses Diagramm kann das leider nicht richtig darstellen. Benutze eine andere Kombination.","rebalancing":"Rebalancing","interest":"Zinsen","principal":"Kapital"}');


var $de221e639d6ac29d$exports = {};
$de221e639d6ac29d$exports = JSON.parse('{"yourReports":"Your reports","selectReport":"Select report","myReport":"My report","save":"Save","cancel":"Cancel","delete":"Delete","new":"New","edit":"Edit","transactions":"Transactions","duplicate":"Duplicate","balances":"Balances","history":"History","howToUseReports":"How to use reports","switchToProjects":"Switch to project data","switchToDashboard":"Switch to dashboard data","tooltips":{"new":"Create a new report","edit":"Edit the selected report","delete":"Delete the selected report","duplicate":"Make a copy of the selected report"}}');


var $e598e33897defb54$exports = {};
$e598e33897defb54$exports = JSON.parse('{"yourReports":"Deine Reports","selectReport":"W\xe4hle einen Report","myReport":"Mein Report","save":"Speichern","cancel":"Abbrechen","delete":"L\xf6schen","new":"Neu","edit":"Anpassen","transactions":"Transaktionen","duplicate":"Duplizieren","balances":"Salden","history":"Historie","howToUseReports":"Wie nutze ich Reports?","switchToProjects":"Zur Projekt-Ansicht wechseln","switchToDashboard":"Zur Dashboard-Ansicht wechseln","tooltips":{"new":"Erstelle einen neuen Report","edit":"Bearbeite den ausgew\xe4hlten Report","delete":"L\xf6sche den ausgew\xe4hlten Report","duplicate":"Dupliziere den ausgew\xe4hlten Report"}}');


var $969a768c636c404f$exports = {};
$969a768c636c404f$exports = JSON.parse('{"newProject":"New Project","interestPayment":"Interest payment on ","dividendPayment":"Dividend payment","simulated":"Simulated","purchase":"Purchase","sale":"Sale","baseCurrency":"Project base currency","progressIndicator":"Preferred progress indicator","roi":"ROI","roiSliderDate":"ROI now","roiNextGoal":"ROI at goal","duration":"Duration","goal":"Goal","noInvestment":"No data","visible":"Visible outside of this project?","planned":"Planned","actual":"Actual gain","yes":"yes","noDraftMode":"no","delete":"Delete project","addGoal":"Add goal","addGoalDescription":"Define a goal for this project.","deleteGoal":"Delete goal","name":"Goal title","transactions":"Transactions","assets":{"label":"Project assets","tooltip":"Bank accounts and assets used in the project are displayed here."},"add":"Add transaction","addQuote":"Add future value","addQuoteDescription":"Define the future value of any asset in this project.","addQuoteButtonDisabled":"You need to add at least one asset to this project before you can add a future value.","addQuoteButtonEnabled":"Add future value of a project asset","selectDepositAccount":{"header":"Select deposit account","prompt":"Which deposit account should we use for the proceeds and costs of this asset?"},"inflow":{"labelTop":"Inflow","labelBottom":"Receive money"},"outflow":{"labelTop":"Outflow","labelBottom":"Spend money"},"transfer":{"labelTop":"Transfer","labelBottom":"between accounts"},"buy":{"labelTop":"Buy","labelBottom":"assets | deposits"},"sell":{"labelTop":"Sell","labelBottom":"assets | deposits"},"newAccount":{"label":"New","description":"New account"},"applyTemplate":"Apply project template","removeTemplate":"Remove project template","addTransaction":"Add transaction","growthRates":"Asset growth rates","growthRatesDescription":"You can define individual growth rates for each asset. They will apply to this asset in this project only.","growthRatesNonIsolated":"These growth rates also apply to assets outside of this project. Switch project to isolated mode to define project-specific growth rates.","transactionTypes":"Transaction types","transactionDetails":"Transaction details","date":"Date","transactionDate":{"label":"Transaction date","tooltip":"Always rounded down to the 1st day of current month. Adjust order of transactions within one month by dragging transactions in the correct sequence in the Project Details view.","error":"Date must be a future date. Use Account Details view to add a past transaction."},"recurringTransaction":{"label":"Should this transaction repeat regularly?"},"indexed":{"label":"Should the amount be increased every year?","byInflation":"increase by inflation rate (link)","increaseBy":"increase by"},"repeating":{"label":"Repeating pattern","every":"Repeat every","month":"months","year":"years","endBy":"Repetition should end","never":"never","after":"after","afterError":"Maximum number of periods is 999.","occurrences":"occurrences","on":"on"},"synchronising":"Synchronising...","save":"Save","cancel":"Cancel","deleteQuote":"Delete this future value","amount":{"label":"Amount","inflowsCanOnlyBePositive":"Inflows can only be positive. Use Outflows for negative transactions.","outflowsCanOnlyBeNegative":"Outflows can only be negative. Use Inflows for positive transactions.","transfersCanOnlyBePositive":"Transfers should always be positive. To define a money flow in the opposite direction, swap the To and From accounts around."},"baseCurrencyAmount":{"label":"Amount in"},"exchangeRate":{"label":"FX rate to ","mustBeGreaterThanZero":"Exchange rate must be greater than zero."},"switchToAmount":"Switch to amount","switchToFxRate":"Switch to FX rate","currency":"Currency","account":{"label":"Transaction will be deducted from this account"},"accountTo":{"label":"Transaction will appear on this account","error":"You cannot transfer money to the same account."},"transactionDescription":{"label":"Transaction description will be","placeholder":"Salary","required":"Please enter a description","length":"Description must be at least 2 characters long"},"assetAccount":{"label":"New asset will appear on this account","error":"Connected deposit account for this account is not defined."},"assetContributionLabel":{"label":"New contribution will appear on this account","error":"Connected deposit account for this account is not defined."},"designatedDepositConnectedAccountIndex":{"label":"Bank account for this transaction","error":"Error."},"assetName":{"tooltip":"This is just a placeholder information which is used for simulations.","label":"Asset name","orISIN":"or ISIN / WKN code","placeholder":"Tesla stocks"},"assetSymbol":{"tooltip":"Pick an existing asset from the list or create a new one. You can use a placeholder name, as this it is only used for simulations.","label":"Stock name / ISIN / WKN","placeholder":"DE0000A1B2C3"},"assetMetal":{"label":"Metal","error":"Please select a metal."},"assetWeight":{"label":"Weight (g)","error":"Please enter weight."},"assetPurity":{"label":"Purity (\u2030)","error":"Please enter purity in parts per 1000 (e.g. 999 or 965)."},"assetAdditionalValue":{"label":"Extra value (%)","tooltip":"Enter a percentage by which to increase this asset\'s value due to its historical or artistic value."},"assetAmount":{"label":"How many pieces of asset to","buy":"buy","sell":"sell"},"depositAmount":{"label":"Amount"},"deposit":"deposit","assetUnitPrice":{"label":"Price per unit","error":"Asset unit price must be greater than 0."},"assetContribution":{"label":"Amount","error":"Contribution must be greater than 0."},"assetUnitPriceBaseCurrency":{"label":"Price in ","error":"Asset unit price must be greater than 0."},"quote":{"label":"Price"},"quoteBaseCurrency":{"label":"Price in ","error":"Asset unit price must be greater than 0."},"todaysPrice":"Current price of {{displayName}} is","selectAnOption":"Select an option","createNewAccount":"Create new account","errorNotAllFields":"Please fill out all the fields.","templateInitialisationError":"Error while initialising project template.","quoteAlreadyExists":"Future value for this asset and date already exists. It will be overwritten if you click Save.","quoteProjectWillBeChanged":"When you click Save, this future value will become part of this project. It will be deleted if you delete the project.","isolatedWarning":"Transactions and future values are not visible outside of this project","collisions":"Which future values are we keeping?","collisionsDescription":"You are switching an isolated project to a global project. This project has some future values that are already defined in other projects. You can either keep the values from this project, or keep the values from the other projects.","asset":"Asset","thisProjectQuote":"This project","globalQuote":"Other projects","allCollisionsMustBeResolved":"Please select one of the values in each row.","recurring":"Recurring transactions","simulatedDividends":"Simulated dividends","simulatedInterest":"Simulated interest","simulatedQuotes":"Future values","applyTemplateDescription":"Apply a set of transactions and future values to your project. You can then edit them as you wish. If you don\'t like the effect, you can remove the entire template with one click.","templates":{"select":"Select","investToRent":{"name":"Buy property to rent out with a mortgage","description":"You want to buy a property to rent out. You will take out a mortgage to finance the purchase. You will rent out the property and use the rental income to pay off the mortgage. You will also pay property taxes and other expenses. You want to see how the property will perform over time.","role1":"Money for downpayment","transaction1":"First incoming transfer.","transaction2":"Second incoming transfer."}}}');


var $756253380d1ed2da$exports = {};
$756253380d1ed2da$exports = JSON.parse('{"newProject":"Neues Projekt","interestPayment":"Zinszahlung auf","dividendPayment":"Dividendenzahlung","simulated":"Simuliert","purchase":"Kauf","sale":"Verkauf","baseCurrency":"Basisw\xe4hrung f\xfcr dieses Projekt","progressIndicator":"Fortschrittsindikator","roi":"ROI","roiSliderDate":"ROI jetzt","roiNextGoal":"ROI am Ziel","duration":"Dauer","goal":"Ziel","noInvestment":"Keine Daten","visible":"Au\xdferhalb dieses Projekts sichtbar?","planned":"Geplannt","actual":"Realisiert","yes":"ja","noDraftMode":"nein","delete":"Projekt l\xf6schen","addGoal":"Neues Ziel","addGoalDescription":"Lege ein Ziel f\xfcr dieses Projekt fest.","deleteGoal":"Ziel l\xf6schen","name":"\xdcberschrift","transactions":"Transaktionen","assets":{"label":"Projektmittel","tooltip":"Hier erscheinen die in dem Projekt verwendete Bankkonten und Assets"},"add":"Neue Transaktion","addQuote":"Neuer Zukunftspreis","addQuoteDescription":"Lege den zuk\xfcnftigen Wert eines Assets fest.","addQuoteButtonDisabled":"F\xfcge mindestens ein Asset zu diesem Projekt hinzu, um einen zuk\xfcnftigen Wert hinzuf\xfcgen k\xf6nnen.","addQuoteButtonEnabled":"F\xfcge einen zuk\xfcnftigen Wert zu diesem Projekt hinzu.","inflow":{"labelTop":"Einzahlung","labelBottom":"Geld erhalten"},"outflow":{"labelTop":"Auszahlung","labelBottom":"Geld ausgeben"},"transfer":{"labelTop":"Transfer","labelBottom":"zwischen Konten"},"buy":{"labelTop":"Kaufen","labelBottom":"eine Anlage"},"sell":{"labelTop":"Verkaufen","labelBottom":"eine Anlage"},"newAccount":{"label":"Neu","description":"New account"},"applyTemplate":"Musterprojekt anwenden","removeTemplate":"Musterprojekt entfernen","addTransaction":"Transaktion hinzuf\xfcgen","growthRates":"Wachstumsraten","growthRatesDescription":"Definiere Wachstumraten f\xfcr Assets in diesem Projekt. Sie gelten nur f\xfcr dieses Projekt.","growthRatesNonIsolated":"Diese Wachstumraten gelten f\xfcr alle Assets, auch au\xdferhalb dieses Projektes. Um Wachstumraten nur f\xfcr ein Projekt festzulegen, schalte den Isolationsmodus ein.","transactionTypes":"Transaktionstypen","transactionDetails":"Transaktionsdetails","date":"Datum","transactionDate":{"label":"Transaktionsdatum","tooltip":"Immer auf den 1. Tag des aktuellen Monats gerundet. Passen Sie die Reihenfolge der Transaktionen innerhalb eines Monats durch Ziehen der Transaktionen in der richtigen Reihenfolge in der Projektdetails Ansicht an.","error":"Datum muss ein zuk\xfcnftiges Datum sein. Verwenden Sie die Kontodetails Ansicht, um eine vergangene Transaktion hinzuzuf\xfcgen."},"recurringTransaction":{"label":"Sollte diese Transaktion regelm\xe4\xdfig wiederholt werden?"},"indexed":{"label":"Soll der Betrag jedes Jahr steigen?","byInflation":"um Inflationsrate erh\xf6hen (Link)","increaseBy":"erh\xf6hen um"},"repeating":{"label":"Wiederholungsmuster","every":"Wiederhole alle","month":"Monate","year":"Jahre","endBy":"Wiederholung endet:","never":"nie","after":"nach","afterError":"Maximale Anzahl der Perioden ist 999.","occurrences":"Vorkommnissen","on":"am"},"synchronising":"Synchronisiere...","save":"Speichern","cancel":"Abbrechen","deleteQuote":"Diesen Zukunftspreis l\xf6schen","amount":{"label":"Betrag","inflowsCanOnlyBePositive":"Eing\xe4nge k\xf6nnen nur positiv sein. Verwenden Sie Auszahlungen f\xfcr negative Transaktionen.","outflowsCanOnlyBeNegative":"Auszahlungen k\xf6nnen nur negativ sein. Verwenden Sie Einzahlungen f\xfcr positive Transaktionen.","transfersCanOnlyBePositive":"Transfers sollten immer positiv sein. Um einen Geldfluss in die entgegengesetzte Richtung zu definieren, tauschen Sie die To- und From-Konten aus."},"exchangeRate":{"label":"W\xe4hrungskurs","mustBeGreaterThanZero":"W\xe4hrungskurs muss gr\xf6\xdfer als 0 sein."},"switchToAmount":"Betrag eingeben","switchToFxRate":"W\xe4hrungskurs eingeben","baseCurrencyAmount":{"label":"Betrag (Basisw\xe4hrung)"},"currency":"W\xe4hrung","account":{"label":"Die Transaktion wird von diesem Konto abgezogen"},"accountTo":{"label":"Die Transaktion wird auf diesem Konto erscheinen","error":"F\xfcr dieses Konto ist kein verbundenes Anlagekonto definiert."},"transactionDescription":{"label":"Transaktionsbeschreibung wird sein","placeholder":"Gehalt","required":"Bitte geben Sie eine Beschreibung ein","length":"Beschreibung muss mindestens 2 Zeichen lang sein"},"assetAccount":{"label":"Neue Anlage erscheint auf diesem Konto","error":"Verbundenes Anlagekonto f\xfcr dieses Konto ist nicht definiert."},"assetContributionLabel":{"label":"Neuer Beitrag auf diesem Konto","error":"Verbundenes Anlagekonto f\xfcr dieses Konto ist nicht definiert."},"designatedDepositConnectedAccountIndex":{"label":"Bankkonto f\xfcr diese Transaktion ","error":"Fehler."},"assetName":{"tooltip":"Dies ist nur eine Platzhalterinformation, die f\xfcr Simulationen verwendet wird.","label":"Anlagenname","orISIN":"oder ISIN / WKN-Code","placeholder":"Tesla Aktien"},"assetSymbol":{"tooltip":"W\xe4hle ein vorhandenes Wertpapier aus der Liste oder erstelle ein neues. Du kannst einen Platzhalternamen verwenden, da dieser nur f\xfcr Simulationen verwendet wird.","label":"Wertpapier / ISIN / WKN","placeholder":"DE0000A1B2C3"},"assetMetal":{"label":"Metal","error":"Bitte w\xe4hle das Metall aus."},"assetWeight":{"label":"Gewicht (g)","error":"Bitte trage das Gewicht in Gramm ein."},"assetPurity":{"label":"Reinheit (\u2030)","error":"Bitte trage die Reinheit in Promille (z.B. 999 oder 965) ein."},"assetAdditionalValue":{"label":"Zusatzwert (%)","tooltip":"Zus\xe4tzlicher Wert in Prozent, der \xfcber den reinen Metallwert hinausgeht (z.B. dank der artistischer oder historischer Bedeutung). Wir erh\xf6hen den Wert des Metalls um diesen Prozentsatz."},"assetAmount":{"label":"Wie viele Anlagen sollen","buy":"gekauft","sell":"verkauft"},"depositAmount":{"label":"Betrag"},"deposit":"Tagesgeld","assetUnitPrice":{"label":"Preis pro St\xfcck","error":"Der Anlageeinheitpreis muss gr\xf6\xdfer als 0 sein."},"assetContribution":{"label":"Beitrag","error":"Beitrag muss gr\xf6\xdfer als 0 sein."},"assetUnitPriceBaseCurrency":{"label":"In Basisw\xe4hrung","error":"Der Anlageeinheitpreis muss gr\xf6\xdfer als 0 sein."},"quote":{"label":"Preis"},"quoteBaseCurrency":{"label":"In Basisw\xe4hrung","error":"Der Anlageeinheitpreis muss gr\xf6\xdfer als 0 sein."},"todaysPrice":"Current price of {{displayName}} is","selectAnOption":"W\xe4hle eine Option","createNewAccount":"Neues Konto erstellen","errorNotAllFields":"Bitte f\xfclle alle Felder aus.","templateInitialisationError":"Fehler: diese Vorlage ist fehlerhaft.","quoteAlreadyExists":"Es existiert bereits einen Zukunftspreis f\xfcr dieses Asset und Preis. Sie wird durch diesen Preis ersetzt.","quoteProjectWillBeChanged":"Dieser Zukunftspreis wird diesem Projekt hinzugef\xfcgt und sp\xe4ter zusammen mit ihm gel\xf6scht.","isolatedWarning":"Die Transaktionen und Zukunftspreise sind au\xdferhalb dieses Projekt nicht sichtbar.","collisions":"Welche Zukunftspreise m\xf6chtest du behalten?","collisionsDescription":"Du wechselst ein isoliertes Projekt zu einem globalen Projekt. Dieses Projekt hat Zukunftspreise, die bereits in anderen Projekten definiert sind. Du kannst entweder die Werte von diesem Projekt behalten, oder die Werte von den anderen Projekten behalten.","asset":"Verm\xf6genswert","thisProjectQuote":"Dieses Projekt","globalQuote":"Andere Projekte","allCollisionsMustBeResolved":"Bitte w\xe4hle eine Option in jeder Zeile aus.","recurring":"Wiederholende Transaktionen","simulatedDividends":"Simulierte Dividenden","simulatedInterest":"Simulierte Zinsen","simulatedQuotes":"Zukunftspreise","applyTemplateDescription":"Wende einen Satz von Transaktionen und zuk\xfcnftigen Werten auf dein Projekt an. Du kannst sie dann nach Belieben bearbeiten. Wenn du damit nicht zufrieden bist, kannst du die gesamte Vorlage mit einem Klick entfernen.","templates":{"select":"W\xe4hlen","investToRent":{"name":"Vermietung einer Immobilie mit Darlehen","description":"Kauf einer Immobilie zum Vermieten mit Hilfe eines Hypothekdarlehen. Die Mieteinnahmen werden verwendet, um das Darlehen zur\xfcckzuzahlen.","role1":"Eigenanteil","transaction1":"Erste erhaltene \xdcberweisung.","transaction2":"Zweite erhaltene \xdcberweisung."}}}');


var $1a3f0bd52e5cb9b7$exports = {};
$1a3f0bd52e5cb9b7$exports = JSON.parse('{"Currency":"Currency","Back to calculation":"Back to calculation","Show required transactions":"Show required transactions","Recalculate":"Recalculate","Required transactions":"Required transactions","Save":"Save","Cancel":"Cancel"}');


var $e08afc18ad3ab161$exports = {};
$e08afc18ad3ab161$exports = JSON.parse('{"Currency":"W\xe4hrung","Back to calculation":"Zur\xfcck zu Kalkulation","Show required transactions":"Zu erforderlichen Transaktionen","Recalculate":"Neu berechnen","Required transactions":"Erforderliche Transaktionen","Save":"Speichern","Cancel":"Abbrechen"}');


const $0f5516e4ff7e5463$var$resources = {
    en: {
        site: (0, (/*@__PURE__*/$parcel$interopDefault($ad28983a058059e4$exports))),
        app: (0, (/*@__PURE__*/$parcel$interopDefault($e67da60fce2c65c3$exports))),
        header: (0, (/*@__PURE__*/$parcel$interopDefault($8ccf9bab8cf25ab0$exports))),
        dashboard: (0, (/*@__PURE__*/$parcel$interopDefault($c8be339546f697df$exports))),
        charts: (0, (/*@__PURE__*/$parcel$interopDefault($98573a6fc3e9e42a$exports))),
        reporting: (0, (/*@__PURE__*/$parcel$interopDefault($de221e639d6ac29d$exports))),
        addAccount: (0, (/*@__PURE__*/$parcel$interopDefault($010f15a98c80264b$exports))),
        accountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($15eae19c88c523c3$exports))),
        settings: (0, (/*@__PURE__*/$parcel$interopDefault($2593f3b2e41cf99a$exports))),
        alerts: (0, (/*@__PURE__*/$parcel$interopDefault($ef0cb480373814b3$exports))),
        invitation: (0, (/*@__PURE__*/$parcel$interopDefault($d2b6746f74d64ae5$exports))),
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($d60250523f119099$exports))),
        projects: (0, (/*@__PURE__*/$parcel$interopDefault($969a768c636c404f$exports))),
        rebalancing: (0, (/*@__PURE__*/$parcel$interopDefault($1a3f0bd52e5cb9b7$exports)))
    },
    de: {
        site: (0, (/*@__PURE__*/$parcel$interopDefault($8441b779c9adedd6$exports))),
        app: (0, (/*@__PURE__*/$parcel$interopDefault($89436ef397ee86a7$exports))),
        header: (0, (/*@__PURE__*/$parcel$interopDefault($36ae45496b617141$exports))),
        dashboard: (0, (/*@__PURE__*/$parcel$interopDefault($df15be24d07deabf$exports))),
        charts: (0, (/*@__PURE__*/$parcel$interopDefault($1a761f110c49897e$exports))),
        reporting: (0, (/*@__PURE__*/$parcel$interopDefault($e598e33897defb54$exports))),
        addAccount: (0, (/*@__PURE__*/$parcel$interopDefault($f3ea9442ec916f5d$exports))),
        accountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($d8a3bdd63b660299$exports))),
        settings: (0, (/*@__PURE__*/$parcel$interopDefault($a259318f91bb059c$exports))),
        alerts: (0, (/*@__PURE__*/$parcel$interopDefault($e56722449cbfa23e$exports))),
        invitation: (0, (/*@__PURE__*/$parcel$interopDefault($238bcc41af14a5b1$exports))),
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($025d02c4f20af15b$exports))),
        projects: (0, (/*@__PURE__*/$parcel$interopDefault($756253380d1ed2da$exports))),
        rebalancing: (0, (/*@__PURE__*/$parcel$interopDefault($e08afc18ad3ab161$exports)))
    }
};
const $0f5516e4ff7e5463$var$registerResourceBundles = ()=>{
    Object.entries($0f5516e4ff7e5463$var$resources).forEach(([lng, namespaces])=>{
        Object.entries(namespaces).forEach(([ns, data])=>{
            if ((0, $2Bwgd.default).hasResourceBundle(lng, ns)) (0, $2Bwgd.default).removeResourceBundle(lng, ns);
            (0, $2Bwgd.default).addResourceBundle(lng, ns, data);
        });
    });
};
if (!(0, $2Bwgd.default).isInitialized) (0, $2Bwgd.default).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).use((0, $09536692873e4879$export$ae7e14d40d89f296)).init({
    debug: false,
    fallbackLng: (code)=>{
        if (!(code === null || code === void 0 ? void 0 : code.startsWith("de"))) return "en";
        return [
            "de",
            "en"
        ];
    },
    supportedLngs: [
        "en",
        "de"
    ],
    detection: {
        order: [
            "path",
            "localStorage",
            "cookie",
            "sessionStorage",
            "navigator"
        ]
    },
    interpolation: {
        escapeValue: false
    },
    resources: $0f5516e4ff7e5463$var$resources
});
else {
    $0f5516e4ff7e5463$var$registerResourceBundles();
    (0, $2Bwgd.default).reloadResources();
}
if (null) null.accept([
    "./locales/de/site.json",
    "./locales/en/site.json",
    "./locales/de/app.json",
    "./locales/en/app.json",
    "./pages/locales/en/header.json",
    "./pages/locales/de/header.json",
    "./pages/locales/en/dashboard.json",
    "./pages/locales/de/dashboard.json",
    "./sections/reports/locales/en/charts.json",
    "./sections/reports/locales/de/charts.json",
    "./sections/reports/locales/en/reporting.json",
    "./sections/reports/locales/de/reporting.json",
    "./sections/addAccount/locales/en/addAccount.json",
    "./sections/addAccount/locales/de/addAccount.json",
    "./sections/accountDetails/locales/en/accountDetails.json",
    "./sections/accountDetails/locales/de/accountDetails.json",
    "./sections/settings/locales/en/settings.json",
    "./sections/settings/locales/de/settings.json",
    "./elements/locales/en/alerts.json",
    "./elements/locales/de/alerts.json",
    "./elements/locales/en/invitation.json",
    "./elements/locales/de/invitation.json",
    "./elements/locales/en/messages.json",
    "./elements/locales/de/messages.json",
    "./sections/projects/locales/en/projects.json",
    "./sections/projects/locales/de/projects.json",
    "./sections/rebalancing/locales/en/rebalancing.json",
    "./sections/rebalancing/locales/de/rebalancing.json"
], ()=>{
    $0f5516e4ff7e5463$var$registerResourceBundles();
    (0, $2Bwgd.default).reloadResources();
});
var $0f5516e4ff7e5463$export$2e2bcd8739ae039 = (0, $2Bwgd.default);



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $179015308194966e$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetch the auth session including the tokens and credentials if they are available. By default it
 * will automatically refresh expired auth tokens if a valid refresh token is present. You can force a refresh
 * of non-expired tokens with `{ forceRefresh: true }` input.
 *
 * @param options - Options configuring the fetch behavior.
 * @throws {@link AuthError} - Throws error when session information cannot be refreshed.
 * @returns Promise<AuthSession>
 */ const $427208a1215859a8$export$39430dfe49142ae = (options)=>{
    return (0, $179015308194966e$export$39430dfe49142ae)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), options);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $3f55e01dfb939081$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $3f55e01dfb939081$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes === null || attributes === void 0 ? void 0 : attributes.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}



var $9tqwB = parcelRequire("9tqwB");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b7859b3867cd5e7c$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $f9c71e6feadb5965$export$ede38edb26c0bfdf)((0, $9tqwB._)({
        category: (0, $4729d49089f76d33$export$3a8840c5b2ecf003).Auth,
        action: action
    }, customUserAgentDetails));










var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f4647acd6cd1ae16$export$9b3b12a535efe659 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("GetUser"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6dc1b07c04d36def$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    var _amplify_getConfig_Auth;
    const authConfig = (_amplify_getConfig_Auth = amplify.getConfig().Auth) === null || _amplify_getConfig_Auth === void 0 ? void 0 : _amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $179015308194966e$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    const getUser = (0, $f4647acd6cd1ae16$export$9b3b12a535efe659)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { UserAttributes: UserAttributes } = await getUser({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $3f55e01dfb939081$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $ff9346d14099d772$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $6dc1b07c04d36def$export$5dc95ecf3f16c6c9)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7));
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $454e78ed9f17249f$export$e5432d4c8eb97ea7 = async (amplify)=>{
    var _amplify_getConfig_Auth, _tokens_idToken;
    const authConfig = (_amplify_getConfig_Auth = amplify.getConfig().Auth) === null || _amplify_getConfig_Auth === void 0 ? void 0 : _amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    var _tokens_idToken_payload;
    const { "cognito:username": username, sub: sub } = (_tokens_idToken_payload = (_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.payload) !== null && _tokens_idToken_payload !== void 0 ? _tokens_idToken_payload : {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $454e78ed9f17249f$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $454e78ed9f17249f$var$getSignInDetailsFromTokens(tokens) {
    return tokens === null || tokens === void 0 ? void 0 : tokens.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $d4670e566035df31$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $454e78ed9f17249f$export$e5432d4c8eb97ea7)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7));
};



const $10933498be24bbfd$export$eeb013770cb92342 = {
    Cognito: "COGNITO",
    Google: "Google",
    Facebook: "Facebook",
    Amazon: "Amazon",
    Apple: "Apple"
};
function $10933498be24bbfd$var$attributesArrayToObject(attributes) {
    if (!attributes) return {};
    if (!Array.isArray(attributes) && typeof attributes === "object") return (0, $9tqwB._)({}, attributes);
    if (Array.isArray(attributes)) return attributes.reduce((acc, attribute)=>{
        if (attribute === null || attribute === void 0 ? void 0 : attribute.name) acc[attribute.name] = attribute.value;
        return acc;
    }, {});
    return {};
}
function $10933498be24bbfd$export$27e497d6b00ea18a(storage) {
    if (storage) (0, $10e1902ea767432f$export$18e158b80aac31a7).setKeyValueStorage(storage);
}
async function $10933498be24bbfd$export$e2edee8830cb9593(forceRefresh = false) {
    return (0, $427208a1215859a8$export$39430dfe49142ae)(forceRefresh ? {
        forceRefresh: true
    } : undefined);
}
async function $10933498be24bbfd$export$393ade1005606e67(forceRefresh = false) {
    var _session_tokens_idToken, _session_tokens;
    const session = await $10933498be24bbfd$export$e2edee8830cb9593(forceRefresh);
    return (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString();
}
async function $10933498be24bbfd$export$84773cc9bf7dbe87(forceRefresh = false) {
    var _session_tokens_accessToken, _session_tokens;
    const session = await $10933498be24bbfd$export$e2edee8830cb9593(forceRefresh);
    return (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_accessToken = _session_tokens.accessToken) === null || _session_tokens_accessToken === void 0 ? void 0 : _session_tokens_accessToken.toString();
}
async function $10933498be24bbfd$export$3fa04bebf37c9013(additionalHeaders = {}, { forceRefresh: forceRefresh = false } = {}) {
    const token = await $10933498be24bbfd$export$393ade1005606e67(forceRefresh);
    if (!token) throw new Error("Missing authentication token");
    return (0, $2qxEV._)((0, $9tqwB._)({}, additionalHeaders), {
        Authorization: token
    });
}
async function $10933498be24bbfd$export$2a5e1266bf611db7({ forceRefresh: forceRefresh = false } = {}) {
    const [session, user, attributes] = await Promise.all([
        $10933498be24bbfd$export$e2edee8830cb9593(forceRefresh),
        (0, $d4670e566035df31$export$e5432d4c8eb97ea7)(),
        (0, $ff9346d14099d772$export$5dc95ecf3f16c6c9)()
    ]);
    const attributesObject = $10933498be24bbfd$var$attributesArrayToObject(attributes);
    return (0, $2qxEV._)((0, $9tqwB._)({}, user), {
        attributes: attributesObject,
        tokens: session.tokens || null
    });
}
async function $10933498be24bbfd$export$e741ea695767fdb4() {
    const attributes = await (0, $ff9346d14099d772$export$5dc95ecf3f16c6c9)();
    return $10933498be24bbfd$var$attributesArrayToObject(attributes);
}


const $337062d98349aa9a$var$debugLevel = Number(undefined) || 0;
function $337062d98349aa9a$export$81254091b6bfbc2b(user) {
    if ($337062d98349aa9a$var$debugLevel > 2) console.info("Hub Listener: updateStoreWithAttributes(user)", user);
    const attributes = (user === null || user === void 0 ? void 0 : user.attributes) || {};
    // prepare default settings
    const defaultBaselineDate = {
        name: "sameTimeLastYear",
        date: (0, $35849f14f39a3bea$export$2e2bcd8739ae039).sameTimeLastYear
    };
    const settingsString = attributes["custom:settings"];
    const settings = settingsString ? JSON.parse(settingsString) : {
        baseCurrency: "EUR",
        baselineDate: defaultBaselineDate.date,
        namedBaseline: defaultBaselineDate.name,
        inflationRate: 3.0,
        sliderStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(10, "year").startOf("year").valueOf(),
        sliderEndDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().add(20, "year").startOf("year").valueOf(),
        expectedDateFormats: [
            "DD.MM.YYYY",
            "YYYY-MM-DD",
            "DD.MM.YY",
            "DD/MM/YYYY",
            "DD-MM-YYYY"
        ]
    };
    const locale = attributes.locale || null;
    if (locale !== (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language && (locale === null || locale === void 0 ? void 0 : locale.length) === 2) (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).changeLanguage(locale);
    const { sub: sub = null } = attributes;
    return {
        toursSeen: JSON.parse(attributes["custom:tours_seen"] || "null"),
        settings: settings,
        locale: locale,
        sub: sub
    };
}
async function $337062d98349aa9a$export$2e2bcd8739ae039(dispatch) {
    try {
        dispatch((0, $4d30dd5a74852208$export$d9065efc0def3925)()); // marks that initial check is in progress
        const user = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)();
        const payload = $337062d98349aa9a$export$81254091b6bfbc2b(user);
        if ($337062d98349aa9a$var$debugLevel > 1) console.log("initAuth: current authenticated user", user);
        dispatch({
            type: (0, $0840a3787500c813$export$5223a5682801fa43),
            payload: payload
        });
        dispatch((0, $4d30dd5a74852208$export$20c07c6c70cd2bd3)());
    } catch (err) {
        dispatch((0, $4d30dd5a74852208$export$506e5ce4d828c47f)()); // marks that initial check finished
        dispatch({
            type: (0, $0840a3787500c813$export$35e541d26a145a7c)
        });
    }
    // handle auth events
    return (0, $317c15c2759ac41f$export$8c41bb232f1008b1).listen("auth", async ({ payload: payload })=>{
        switch(payload.event){
            case "signedIn":
            case "tokenRefresh":
                try {
                    var _payload_data;
                    const userData = (payload === null || payload === void 0 ? void 0 : (_payload_data = payload.data) === null || _payload_data === void 0 ? void 0 : _payload_data.attributes) ? payload.data : await (0, $10933498be24bbfd$export$2a5e1266bf611db7)();
                    dispatch({
                        type: (0, $0840a3787500c813$export$5223a5682801fa43),
                        payload: $337062d98349aa9a$export$81254091b6bfbc2b(userData)
                    });
                    dispatch((0, $4d30dd5a74852208$export$20c07c6c70cd2bd3)());
                } catch (error) {
                    console.error("initAuth: failed to refresh user data after auth event", error);
                    dispatch((0, $4d30dd5a74852208$export$506e5ce4d828c47f)());
                    dispatch({
                        type: (0, $0840a3787500c813$export$35e541d26a145a7c)
                    });
                }
                break;
            case "signedOut":
            case "tokenRefresh_failure":
            default:
                dispatch({
                    type: (0, $0840a3787500c813$export$35e541d26a145a7c)
                });
                break;
        }
    });
}



/* eslint-disable no-restricted-syntax */ var $b1badb002678e3c8$export$f3b03d0edd9563f3;
var $b1badb002678e3c8$export$282a641876a53bc3;
var $b1badb002678e3c8$export$1a89ae3627118dd;
var $b1badb002678e3c8$export$f5462558b84dd2ed;
var $b1badb002678e3c8$export$e4ecceb4875351b5;
var $b1badb002678e3c8$export$976575134972f9a4;
var $b1badb002678e3c8$export$848620f5f2f26e86;
var $b1badb002678e3c8$export$3b6eba580b3b05c2;
var $b1badb002678e3c8$export$932592b46db185be;
var $b1badb002678e3c8$export$26e5786e8ac8e530;
var $b1badb002678e3c8$export$4f7f04ab89baffd5;
var $b1badb002678e3c8$export$b86ba1ae94e2bfc6;
var $b1badb002678e3c8$export$2a36976f17340ce9;
var $b1badb002678e3c8$export$745706c0ef8a4a95;
var $b1badb002678e3c8$export$6290422ba3eff881;
// ext/base64.js
var $b1badb002678e3c8$export$d19dfddb415836ed;
var $b1badb002678e3c8$export$d7cf0422ea26a99a;
// ext/ec*.js
var $b1badb002678e3c8$export$afd6716cdada7ed5;
var $b1badb002678e3c8$export$4723ecead0798297;
var $b1badb002678e3c8$export$726408a8537bde80;
// base64x.js
var $b1badb002678e3c8$export$2cc6664de1b990db;
var $b1badb002678e3c8$export$9cbca96477f9ae2f;
var $b1badb002678e3c8$export$44c267f4f65a8a7f;
var $b1badb002678e3c8$export$5eee626700e49209;
var $b1badb002678e3c8$export$b2d4d26b5ccff6a9;
var $b1badb002678e3c8$export$8a4767dad77d7c90;
var $b1badb002678e3c8$export$fe8597e65838ca44;
var $b1badb002678e3c8$export$7407696354668e77;
var $b1badb002678e3c8$export$698d677dfec3eedc;
var $b1badb002678e3c8$export$1d3058c7ef7b57e7;
var $b1badb002678e3c8$export$e3d76fc82b6f4709;
var $b1badb002678e3c8$export$dbc620645d9d8e1c;
var $b1badb002678e3c8$export$72c5155990131fea;
var $b1badb002678e3c8$export$7c9521958f1a8b53;
var $b1badb002678e3c8$export$60178c38071ce57;
var $b1badb002678e3c8$export$f86becda4308ac43;
var $b1badb002678e3c8$export$58845754f36e74c0;
var $b1badb002678e3c8$export$df8d81c68e1f33f4;
var $b1badb002678e3c8$export$ee29e73a50dc272a;
var $b1badb002678e3c8$export$4f67c080e58d5fc8;
var $b1badb002678e3c8$export$3d3bc10a7110335e;
var $b1badb002678e3c8$export$34dd639c3ad435e5;
var $b1badb002678e3c8$export$a2c095b78f275405;
var $b1badb002678e3c8$export$5b3955e928a80e02;
var $b1badb002678e3c8$export$3c4028916a1e7c6b;
var $b1badb002678e3c8$export$6cd6298d9192e025;
var $b1badb002678e3c8$export$dd14f12d991e544e;
var $b1badb002678e3c8$export$b44ce6106c226618;
var $b1badb002678e3c8$export$3216c5a35077bf7f;
var $b1badb002678e3c8$export$8b7fec17a71a9b41;
var $b1badb002678e3c8$export$62dfecc41a84b0d1;
var $b1badb002678e3c8$export$d6c5a18bb1fc0052;
var $b1badb002678e3c8$export$95365fd5256ec7db;
var $b1badb002678e3c8$export$d4c51f74e5089406;
var $b1badb002678e3c8$export$3c617715bb93799d;
var $b1badb002678e3c8$export$70378f11804174db;
var $b1badb002678e3c8$export$ddd58b31d8df363d;
var $b1badb002678e3c8$export$5950376737d25772;
var $b1badb002678e3c8$export$46f4a68bb92b01f3;
var $b1badb002678e3c8$export$3cf10cd345a8d2a2;
var $b1badb002678e3c8$export$6e18a9227aeed184;
var $b1badb002678e3c8$export$f8cc9a8e09bfbdc0;
var $b1badb002678e3c8$export$47b089f332e467b0;
var $b1badb002678e3c8$export$df366832902521e3;
var $b1badb002678e3c8$export$dbd72e020e0a4659;
var $b1badb002678e3c8$export$1852d16cc1fa045d;
var $b1badb002678e3c8$export$2e7bc010fb6cbef6;
var $b1badb002678e3c8$export$f407ad11b833a42c;
var $b1badb002678e3c8$export$5821a351dc01c86c;
var $b1badb002678e3c8$export$ffa65c7cd7d99bbe;
var $b1badb002678e3c8$export$6e0bc1c6de95693a;
var $b1badb002678e3c8$export$d3e8e560222ea674;
var $b1badb002678e3c8$export$ce530db93b05eeba;
var $b1badb002678e3c8$export$8bbe6e427750f06d;
// name spaces
var $b1badb002678e3c8$export$eeb0cac846251be6;
var $b1badb002678e3c8$export$7effb53edfc7fa2d;
var $b1badb002678e3c8$export$b54eb25e8c142da9;
var $b1badb002678e3c8$export$dc7009a36380caa;
var $b1badb002678e3c8$export$9a771d6906431624;

var $bdjQ6 = parcelRequire("bdjQ6");
var $b1badb002678e3c8$require$Buffer = $bdjQ6.Buffer;
var $b1badb002678e3c8$var$navigator = {};
$b1badb002678e3c8$var$navigator.userAgent = false;
var $b1badb002678e3c8$var$window = {};
/*
 * jsrsasign(all) 10.6.1 (2022-11-20) (c) 2010-2022 Kenji Urushima | kjur.github.io/jsrsasign/license
 */ /*! CryptoJS v3.1.2 core-fix.js
 * code.google.com/p/crypto-js
 * (c) 2009-2013 by Jeff Mott. All rights reserved.
 * code.google.com/p/crypto-js/wiki/License
 * THIS IS FIX of 'core.js' to fix Hmac issue.
 * https://code.google.com/p/crypto-js/issues/detail?id=84
 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
 */ var $b1badb002678e3c8$var$CryptoJS = $b1badb002678e3c8$var$CryptoJS || function(e, g) {
    var a = {};
    var b = a.lib = {};
    var j = b.Base = function() {
        function n() {}
        return {
            extend: function(p) {
                n.prototype = this;
                var o = new n();
                if (p) o.mixIn(p);
                if (!o.hasOwnProperty("init")) o.init = function() {
                    o.$super.init.apply(this, arguments);
                };
                o.init.prototype = o;
                o.$super = this;
                return o;
            },
            create: function() {
                var o = this.extend();
                o.init.apply(o, arguments);
                return o;
            },
            init: function() {},
            mixIn: function(p) {
                for(var o in p)if (p.hasOwnProperty(o)) this[o] = p[o];
                if (p.hasOwnProperty("toString")) this.toString = p.toString;
            },
            clone: function() {
                return this.init.prototype.extend(this);
            }
        };
    }();
    var l = b.WordArray = j.extend({
        init: function(o, n) {
            o = this.words = o || [];
            if (n != g) this.sigBytes = n;
            else this.sigBytes = o.length * 4;
        },
        toString: function(n) {
            return (n || h).stringify(this);
        },
        concat: function(t) {
            var q = this.words;
            var p = t.words;
            var n = this.sigBytes;
            var s = t.sigBytes;
            this.clamp();
            if (n % 4) for(var r = 0; r < s; r++){
                var o = p[r >>> 2] >>> 24 - r % 4 * 8 & 255;
                q[n + r >>> 2] |= o << 24 - (n + r) % 4 * 8;
            }
            else for(var r = 0; r < s; r += 4)q[n + r >>> 2] = p[r >>> 2];
            this.sigBytes += s;
            return this;
        },
        clamp: function() {
            var o = this.words;
            var n = this.sigBytes;
            o[n >>> 2] &= 4294967295 << 32 - n % 4 * 8;
            o.length = e.ceil(n / 4);
        },
        clone: function() {
            var n = j.clone.call(this);
            n.words = this.words.slice(0);
            return n;
        },
        random: function(p) {
            var o = [];
            for(var n = 0; n < p; n += 4)o.push(e.random() * 4294967296 | 0);
            return new l.init(o, p);
        }
    });
    var m = a.enc = {};
    var h = m.Hex = {
        stringify: function(p) {
            var r = p.words;
            var o = p.sigBytes;
            var q = [];
            for(var n = 0; n < o; n++){
                var s = r[n >>> 2] >>> 24 - n % 4 * 8 & 255;
                q.push((s >>> 4).toString(16));
                q.push((s & 15).toString(16));
            }
            return q.join("");
        },
        parse: function(p) {
            var n = p.length;
            var q = [];
            for(var o = 0; o < n; o += 2)q[o >>> 3] |= parseInt(p.substr(o, 2), 16) << 24 - o % 8 * 4;
            return new l.init(q, n / 2);
        }
    };
    var d = m.Latin1 = {
        stringify: function(q) {
            var r = q.words;
            var p = q.sigBytes;
            var n = [];
            for(var o = 0; o < p; o++){
                var s = r[o >>> 2] >>> 24 - o % 4 * 8 & 255;
                n.push(String.fromCharCode(s));
            }
            return n.join("");
        },
        parse: function(p) {
            var n = p.length;
            var q = [];
            for(var o = 0; o < n; o++)q[o >>> 2] |= (p.charCodeAt(o) & 255) << 24 - o % 4 * 8;
            return new l.init(q, n);
        }
    };
    var c = m.Utf8 = {
        stringify: function(n) {
            try {
                return decodeURIComponent(escape(d.stringify(n)));
            } catch (o) {
                throw new Error("Malformed UTF-8 data");
            }
        },
        parse: function(n) {
            return d.parse(unescape(encodeURIComponent(n)));
        }
    };
    var i = b.BufferedBlockAlgorithm = j.extend({
        reset: function() {
            this._data = new l.init();
            this._nDataBytes = 0;
        },
        _append: function(n) {
            if (typeof n == "string") n = c.parse(n);
            this._data.concat(n);
            this._nDataBytes += n.sigBytes;
        },
        _process: function(w) {
            var q = this._data;
            var x = q.words;
            var n = q.sigBytes;
            var t = this.blockSize;
            var v = t * 4;
            var u = n / v;
            if (w) u = e.ceil(u);
            else u = e.max((u | 0) - this._minBufferSize, 0);
            var s = u * t;
            var r = e.min(s * 4, n);
            if (s) {
                for(var p = 0; p < s; p += t)this._doProcessBlock(x, p);
                var o = x.splice(0, s);
                q.sigBytes -= r;
            }
            return new l.init(o, r);
        },
        clone: function() {
            var n = j.clone.call(this);
            n._data = this._data.clone();
            return n;
        },
        _minBufferSize: 0
    });
    var f = b.Hasher = i.extend({
        cfg: j.extend(),
        init: function(n) {
            this.cfg = this.cfg.extend(n);
            this.reset();
        },
        reset: function() {
            i.reset.call(this);
            this._doReset();
        },
        update: function(n) {
            this._append(n);
            this._process();
            return this;
        },
        finalize: function(n) {
            if (n) this._append(n);
            var o = this._doFinalize();
            return o;
        },
        blockSize: 16,
        _createHelper: function(n) {
            return function(p, o) {
                return new n.init(o).finalize(p);
            };
        },
        _createHmacHelper: function(n) {
            return function(p, o) {
                return new k.HMAC.init(n, o).finalize(p);
            };
        }
    });
    var k = a.algo = {};
    return a;
}(Math);
/*
CryptoJS v3.1.2 x64-core-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function(g) {
    var a = $b1badb002678e3c8$var$CryptoJS, f = a.lib, e = f.Base, h = f.WordArray, a = a.x64 = {};
    a.Word = e.extend({
        init: function(b, c) {
            this.high = b;
            this.low = c;
        }
    });
    a.WordArray = e.extend({
        init: function(b, c) {
            b = this.words = b || [];
            this.sigBytes = c != g ? c : 8 * b.length;
        },
        toX32: function() {
            for(var b = this.words, c = b.length, a = [], d = 0; d < c; d++){
                var e = b[d];
                a.push(e.high);
                a.push(e.low);
            }
            return h.create(a, this.sigBytes);
        },
        clone: function() {
            for(var b = e.clone.call(this), c = b.words = this.words.slice(0), a = c.length, d = 0; d < a; d++)c[d] = c[d].clone();
            return b;
        }
    });
})();
/*
CryptoJS v3.1.2 cipher-core.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ $b1badb002678e3c8$var$CryptoJS.lib.Cipher || function(u) {
    var g = $b1badb002678e3c8$var$CryptoJS, f = g.lib, k = f.Base, l = f.WordArray, q = f.BufferedBlockAlgorithm, r = g.enc.Base64, v = g.algo.EvpKDF, n = f.Cipher = q.extend({
        cfg: k.extend(),
        createEncryptor: function(a, b) {
            return this.create(this._ENC_XFORM_MODE, a, b);
        },
        createDecryptor: function(a, b) {
            return this.create(this._DEC_XFORM_MODE, a, b);
        },
        init: function(a, b, c) {
            this.cfg = this.cfg.extend(c);
            this._xformMode = a;
            this._key = b;
            this.reset();
        },
        reset: function() {
            q.reset.call(this);
            this._doReset();
        },
        process: function(a) {
            this._append(a);
            return this._process();
        },
        finalize: function(a) {
            a && this._append(a);
            return this._doFinalize();
        },
        keySize: 4,
        ivSize: 4,
        _ENC_XFORM_MODE: 1,
        _DEC_XFORM_MODE: 2,
        _createHelper: function(a) {
            return {
                encrypt: function(b, c, d) {
                    return ("string" == typeof c ? s : j).encrypt(a, b, c, d);
                },
                decrypt: function(b, c, d) {
                    return ("string" == typeof c ? s : j).decrypt(a, b, c, d);
                }
            };
        }
    });
    f.StreamCipher = n.extend({
        _doFinalize: function() {
            return this._process(!0);
        },
        blockSize: 1
    });
    var m = g.mode = {}, t = function(a, b, c) {
        var d = this._iv;
        d ? this._iv = u : d = this._prevBlock;
        for(var e = 0; e < c; e++)a[b + e] ^= d[e];
    }, h = (f.BlockCipherMode = k.extend({
        createEncryptor: function(a, b) {
            return this.Encryptor.create(a, b);
        },
        createDecryptor: function(a, b) {
            return this.Decryptor.create(a, b);
        },
        init: function(a, b) {
            this._cipher = a;
            this._iv = b;
        }
    })).extend();
    h.Encryptor = h.extend({
        processBlock: function(a, b) {
            var c = this._cipher, d = c.blockSize;
            t.call(this, a, b, d);
            c.encryptBlock(a, b);
            this._prevBlock = a.slice(b, b + d);
        }
    });
    h.Decryptor = h.extend({
        processBlock: function(a, b) {
            var c = this._cipher, d = c.blockSize, e = a.slice(b, b + d);
            c.decryptBlock(a, b);
            t.call(this, a, b, d);
            this._prevBlock = e;
        }
    });
    m = m.CBC = h;
    h = (g.pad = {}).Pkcs7 = {
        pad: function(a, b) {
            for(var c = 4 * b, c = c - a.sigBytes % c, d = c << 24 | c << 16 | c << 8 | c, e = [], f = 0; f < c; f += 4)e.push(d);
            c = l.create(e, c);
            a.concat(c);
        },
        unpad: function(a) {
            a.sigBytes -= a.words[a.sigBytes - 1 >>> 2] & 255;
        }
    };
    f.BlockCipher = n.extend({
        cfg: n.cfg.extend({
            mode: m,
            padding: h
        }),
        reset: function() {
            n.reset.call(this);
            var a = this.cfg, b = a.iv, a = a.mode;
            if (this._xformMode == this._ENC_XFORM_MODE) var c = a.createEncryptor;
            else c = a.createDecryptor, this._minBufferSize = 1;
            this._mode = c.call(a, this, b && b.words);
        },
        _doProcessBlock: function(a, b) {
            this._mode.processBlock(a, b);
        },
        _doFinalize: function() {
            var a = this.cfg.padding;
            if (this._xformMode == this._ENC_XFORM_MODE) {
                a.pad(this._data, this.blockSize);
                var b = this._process(!0);
            } else b = this._process(!0), a.unpad(b);
            return b;
        },
        blockSize: 4
    });
    var p = f.CipherParams = k.extend({
        init: function(a) {
            this.mixIn(a);
        },
        toString: function(a) {
            return (a || this.formatter).stringify(this);
        }
    }), m = (g.format = {}).OpenSSL = {
        stringify: function(a) {
            var b = a.ciphertext;
            a = a.salt;
            return (a ? l.create([
                1398893684,
                1701076831
            ]).concat(a).concat(b) : b).toString(r);
        },
        parse: function(a) {
            a = r.parse(a);
            var b = a.words;
            if (1398893684 == b[0] && 1701076831 == b[1]) {
                var c = l.create(b.slice(2, 4));
                b.splice(0, 4);
                a.sigBytes -= 16;
            }
            return p.create({
                ciphertext: a,
                salt: c
            });
        }
    }, j = f.SerializableCipher = k.extend({
        cfg: k.extend({
            format: m
        }),
        encrypt: function(a, b, c, d) {
            d = this.cfg.extend(d);
            var e = a.createEncryptor(c, d);
            b = e.finalize(b);
            e = e.cfg;
            return p.create({
                ciphertext: b,
                key: c,
                iv: e.iv,
                algorithm: a,
                mode: e.mode,
                padding: e.padding,
                blockSize: a.blockSize,
                formatter: d.format
            });
        },
        decrypt: function(a, b, c, d) {
            d = this.cfg.extend(d);
            b = this._parse(b, d.format);
            return a.createDecryptor(c, d).finalize(b.ciphertext);
        },
        _parse: function(a, b) {
            return "string" == typeof a ? b.parse(a, this) : a;
        }
    }), g = (g.kdf = {}).OpenSSL = {
        execute: function(a, b, c, d) {
            d || (d = l.random(8));
            a = v.create({
                keySize: b + c
            }).compute(a, d);
            c = l.create(a.words.slice(b), 4 * c);
            a.sigBytes = 4 * b;
            return p.create({
                key: a,
                iv: c,
                salt: d
            });
        }
    }, s = f.PasswordBasedCipher = j.extend({
        cfg: j.cfg.extend({
            kdf: g
        }),
        encrypt: function(a, b, c, d) {
            d = this.cfg.extend(d);
            c = d.kdf.execute(c, a.keySize, a.ivSize);
            d.iv = c.iv;
            a = j.encrypt.call(this, a, b, c.key, d);
            a.mixIn(c);
            return a;
        },
        decrypt: function(a, b, c, d) {
            d = this.cfg.extend(d);
            b = this._parse(b, d.format);
            c = d.kdf.execute(c, a.keySize, a.ivSize, b.salt);
            d.iv = c.iv;
            return j.decrypt.call(this, a, b, c.key, d);
        }
    });
}();
/*
CryptoJS v3.1.2 aes.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    for(var q = $b1badb002678e3c8$var$CryptoJS, x = q.lib.BlockCipher, r = q.algo, j = [], y = [], z = [], A = [], B = [], C = [], s = [], u = [], v = [], w = [], g = [], k = 0; 256 > k; k++)g[k] = 128 > k ? k << 1 : k << 1 ^ 283;
    for(var n = 0, l = 0, k = 0; 256 > k; k++){
        var f = l ^ l << 1 ^ l << 2 ^ l << 3 ^ l << 4, f = f >>> 8 ^ f & 255 ^ 99;
        j[n] = f;
        y[f] = n;
        var t = g[n], D = g[t], E = g[D], b = 257 * g[f] ^ 16843008 * f;
        z[n] = b << 24 | b >>> 8;
        A[n] = b << 16 | b >>> 16;
        B[n] = b << 8 | b >>> 24;
        C[n] = b;
        b = 16843009 * E ^ 65537 * D ^ 257 * t ^ 16843008 * n;
        s[f] = b << 24 | b >>> 8;
        u[f] = b << 16 | b >>> 16;
        v[f] = b << 8 | b >>> 24;
        w[f] = b;
        n ? (n = t ^ g[g[g[E ^ t]]], l ^= g[g[l]]) : n = l = 1;
    }
    var F = [
        0,
        1,
        2,
        4,
        8,
        16,
        32,
        64,
        128,
        27,
        54
    ], r = r.AES = x.extend({
        _doReset: function() {
            for(var c = this._key, e = c.words, a = c.sigBytes / 4, c = 4 * ((this._nRounds = a + 6) + 1), b = this._keySchedule = [], h = 0; h < c; h++)if (h < a) b[h] = e[h];
            else {
                var d = b[h - 1];
                h % a ? 6 < a && 4 == h % a && (d = j[d >>> 24] << 24 | j[d >>> 16 & 255] << 16 | j[d >>> 8 & 255] << 8 | j[d & 255]) : (d = d << 8 | d >>> 24, d = j[d >>> 24] << 24 | j[d >>> 16 & 255] << 16 | j[d >>> 8 & 255] << 8 | j[d & 255], d ^= F[h / a | 0] << 24);
                b[h] = b[h - a] ^ d;
            }
            e = this._invKeySchedule = [];
            for(a = 0; a < c; a++)h = c - a, d = a % 4 ? b[h] : b[h - 4], e[a] = 4 > a || 4 >= h ? d : s[j[d >>> 24]] ^ u[j[d >>> 16 & 255]] ^ v[j[d >>> 8 & 255]] ^ w[j[d & 255]];
        },
        encryptBlock: function(c, e) {
            this._doCryptBlock(c, e, this._keySchedule, z, A, B, C, j);
        },
        decryptBlock: function(c, e) {
            var a = c[e + 1];
            c[e + 1] = c[e + 3];
            c[e + 3] = a;
            this._doCryptBlock(c, e, this._invKeySchedule, s, u, v, w, y);
            a = c[e + 1];
            c[e + 1] = c[e + 3];
            c[e + 3] = a;
        },
        _doCryptBlock: function(c, e, a, b, h, d, j, m) {
            for(var n = this._nRounds, f = c[e] ^ a[0], g = c[e + 1] ^ a[1], k = c[e + 2] ^ a[2], p = c[e + 3] ^ a[3], l = 4, t = 1; t < n; t++)var q = b[f >>> 24] ^ h[g >>> 16 & 255] ^ d[k >>> 8 & 255] ^ j[p & 255] ^ a[l++], r = b[g >>> 24] ^ h[k >>> 16 & 255] ^ d[p >>> 8 & 255] ^ j[f & 255] ^ a[l++], s = b[k >>> 24] ^ h[p >>> 16 & 255] ^ d[f >>> 8 & 255] ^ j[g & 255] ^ a[l++], p = b[p >>> 24] ^ h[f >>> 16 & 255] ^ d[g >>> 8 & 255] ^ j[k & 255] ^ a[l++], f = q, g = r, k = s;
            q = (m[f >>> 24] << 24 | m[g >>> 16 & 255] << 16 | m[k >>> 8 & 255] << 8 | m[p & 255]) ^ a[l++];
            r = (m[g >>> 24] << 24 | m[k >>> 16 & 255] << 16 | m[p >>> 8 & 255] << 8 | m[f & 255]) ^ a[l++];
            s = (m[k >>> 24] << 24 | m[p >>> 16 & 255] << 16 | m[f >>> 8 & 255] << 8 | m[g & 255]) ^ a[l++];
            p = (m[p >>> 24] << 24 | m[f >>> 16 & 255] << 16 | m[g >>> 8 & 255] << 8 | m[k & 255]) ^ a[l++];
            c[e] = q;
            c[e + 1] = r;
            c[e + 2] = s;
            c[e + 3] = p;
        },
        keySize: 8
    });
    q.AES = x._createHelper(r);
})();
/*
CryptoJS v3.1.2 tripledes-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    function j(b, c) {
        var a = (this._lBlock >>> b ^ this._rBlock) & c;
        this._rBlock ^= a;
        this._lBlock ^= a << b;
    }
    function l(b, c) {
        var a = (this._rBlock >>> b ^ this._lBlock) & c;
        this._lBlock ^= a;
        this._rBlock ^= a << b;
    }
    var h = $b1badb002678e3c8$var$CryptoJS, e = h.lib, n = e.WordArray, e = e.BlockCipher, g = h.algo, q = [
        57,
        49,
        41,
        33,
        25,
        17,
        9,
        1,
        58,
        50,
        42,
        34,
        26,
        18,
        10,
        2,
        59,
        51,
        43,
        35,
        27,
        19,
        11,
        3,
        60,
        52,
        44,
        36,
        63,
        55,
        47,
        39,
        31,
        23,
        15,
        7,
        62,
        54,
        46,
        38,
        30,
        22,
        14,
        6,
        61,
        53,
        45,
        37,
        29,
        21,
        13,
        5,
        28,
        20,
        12,
        4
    ], p = [
        14,
        17,
        11,
        24,
        1,
        5,
        3,
        28,
        15,
        6,
        21,
        10,
        23,
        19,
        12,
        4,
        26,
        8,
        16,
        7,
        27,
        20,
        13,
        2,
        41,
        52,
        31,
        37,
        47,
        55,
        30,
        40,
        51,
        45,
        33,
        48,
        44,
        49,
        39,
        56,
        34,
        53,
        46,
        42,
        50,
        36,
        29,
        32
    ], r = [
        1,
        2,
        4,
        6,
        8,
        10,
        12,
        14,
        15,
        17,
        19,
        21,
        23,
        25,
        27,
        28
    ], s = [
        {
            "0": 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
        },
        {
            "0": 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
        },
        {
            "0": 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
        },
        {
            "0": 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
        },
        {
            "0": 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
        },
        {
            "0": 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
        },
        {
            "0": 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
        },
        {
            "0": 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
        }
    ], t = [
        4160749569,
        528482304,
        33030144,
        2064384,
        129024,
        8064,
        504,
        2147483679
    ], m = g.DES = e.extend({
        _doReset: function() {
            for(var b = this._key.words, c = [], a = 0; 56 > a; a++){
                var f = q[a] - 1;
                c[a] = b[f >>> 5] >>> 31 - f % 32 & 1;
            }
            b = this._subKeys = [];
            for(f = 0; 16 > f; f++){
                for(var d = b[f] = [], e = r[f], a = 0; 24 > a; a++)d[a / 6 | 0] |= c[(p[a] - 1 + e) % 28] << 31 - a % 6, d[4 + (a / 6 | 0)] |= c[28 + (p[a + 24] - 1 + e) % 28] << 31 - a % 6;
                d[0] = d[0] << 1 | d[0] >>> 31;
                for(a = 1; 7 > a; a++)d[a] >>>= 4 * (a - 1) + 3;
                d[7] = d[7] << 5 | d[7] >>> 27;
            }
            c = this._invSubKeys = [];
            for(a = 0; 16 > a; a++)c[a] = b[15 - a];
        },
        encryptBlock: function(b, c) {
            this._doCryptBlock(b, c, this._subKeys);
        },
        decryptBlock: function(b, c) {
            this._doCryptBlock(b, c, this._invSubKeys);
        },
        _doCryptBlock: function(b, c, a) {
            this._lBlock = b[c];
            this._rBlock = b[c + 1];
            j.call(this, 4, 252645135);
            j.call(this, 16, 65535);
            l.call(this, 2, 858993459);
            l.call(this, 8, 16711935);
            j.call(this, 1, 1431655765);
            for(var f = 0; 16 > f; f++){
                for(var d = a[f], e = this._lBlock, h = this._rBlock, g = 0, k = 0; 8 > k; k++)g |= s[k][((h ^ d[k]) & t[k]) >>> 0];
                this._lBlock = h;
                this._rBlock = e ^ g;
            }
            a = this._lBlock;
            this._lBlock = this._rBlock;
            this._rBlock = a;
            j.call(this, 1, 1431655765);
            l.call(this, 8, 16711935);
            l.call(this, 2, 858993459);
            j.call(this, 16, 65535);
            j.call(this, 4, 252645135);
            b[c] = this._lBlock;
            b[c + 1] = this._rBlock;
        },
        keySize: 2,
        ivSize: 2,
        blockSize: 2
    });
    h.DES = e._createHelper(m);
    g = g.TripleDES = e.extend({
        _doReset: function() {
            var b = this._key.words;
            this._des1 = m.createEncryptor(n.create(b.slice(0, 2)));
            this._des2 = m.createEncryptor(n.create(b.slice(2, 4)));
            this._des3 = m.createEncryptor(n.create(b.slice(4, 6)));
        },
        encryptBlock: function(b, c) {
            this._des1.encryptBlock(b, c);
            this._des2.decryptBlock(b, c);
            this._des3.encryptBlock(b, c);
        },
        decryptBlock: function(b, c) {
            this._des3.decryptBlock(b, c);
            this._des2.encryptBlock(b, c);
            this._des1.decryptBlock(b, c);
        },
        keySize: 6,
        ivSize: 2,
        blockSize: 2
    });
    h.TripleDES = e._createHelper(g);
})();
/*
CryptoJS v3.1.2 enc-base64.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    var h = $b1badb002678e3c8$var$CryptoJS, j = h.lib.WordArray;
    h.enc.Base64 = {
        stringify: function(b) {
            var e = b.words, f = b.sigBytes, c = this._map;
            b.clamp();
            b = [];
            for(var a = 0; a < f; a += 3)for(var d = (e[a >>> 2] >>> 24 - 8 * (a % 4) & 255) << 16 | (e[a + 1 >>> 2] >>> 24 - 8 * ((a + 1) % 4) & 255) << 8 | e[a + 2 >>> 2] >>> 24 - 8 * ((a + 2) % 4) & 255, g = 0; 4 > g && a + 0.75 * g < f; g++)b.push(c.charAt(d >>> 6 * (3 - g) & 63));
            if (e = c.charAt(64)) for(; b.length % 4;)b.push(e);
            return b.join("");
        },
        parse: function(b) {
            var e = b.length, f = this._map, c = f.charAt(64);
            c && (c = b.indexOf(c), -1 != c && (e = c));
            for(var c = [], a = 0, d = 0; d < e; d++)if (d % 4) {
                var g = f.indexOf(b.charAt(d - 1)) << 2 * (d % 4), h = f.indexOf(b.charAt(d)) >>> 6 - 2 * (d % 4);
                c[a >>> 2] |= (g | h) << 24 - 8 * (a % 4);
                a++;
            }
            return j.create(c, a);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    };
})();
/*
CryptoJS v3.1.2 md5.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function(E) {
    function h(a, f, g, j, p, h, k) {
        a = a + (f & g | ~f & j) + p + k;
        return (a << h | a >>> 32 - h) + f;
    }
    function k(a, f, g, j, p, h, k) {
        a = a + (f & j | g & ~j) + p + k;
        return (a << h | a >>> 32 - h) + f;
    }
    function l(a, f, g, j, h, k, l) {
        a = a + (f ^ g ^ j) + h + l;
        return (a << k | a >>> 32 - k) + f;
    }
    function n(a, f, g, j, h, k, l) {
        a = a + (g ^ (f | ~j)) + h + l;
        return (a << k | a >>> 32 - k) + f;
    }
    for(var r = $b1badb002678e3c8$var$CryptoJS, q = r.lib, F = q.WordArray, s = q.Hasher, q = r.algo, a = [], t = 0; 64 > t; t++)a[t] = 4294967296 * E.abs(E.sin(t + 1)) | 0;
    q = q.MD5 = s.extend({
        _doReset: function() {
            this._hash = new F.init([
                1732584193,
                4023233417,
                2562383102,
                271733878
            ]);
        },
        _doProcessBlock: function(m, f) {
            for(var g = 0; 16 > g; g++){
                var j = f + g, p = m[j];
                m[j] = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360;
            }
            var g = this._hash.words, j = m[f + 0], p = m[f + 1], q = m[f + 2], r = m[f + 3], s = m[f + 4], t = m[f + 5], u = m[f + 6], v = m[f + 7], w = m[f + 8], x = m[f + 9], y = m[f + 10], z = m[f + 11], A = m[f + 12], B = m[f + 13], C = m[f + 14], D = m[f + 15], b = g[0], c = g[1], d = g[2], e = g[3], b = h(b, c, d, e, j, 7, a[0]), e = h(e, b, c, d, p, 12, a[1]), d = h(d, e, b, c, q, 17, a[2]), c = h(c, d, e, b, r, 22, a[3]), b = h(b, c, d, e, s, 7, a[4]), e = h(e, b, c, d, t, 12, a[5]), d = h(d, e, b, c, u, 17, a[6]), c = h(c, d, e, b, v, 22, a[7]), b = h(b, c, d, e, w, 7, a[8]), e = h(e, b, c, d, x, 12, a[9]), d = h(d, e, b, c, y, 17, a[10]), c = h(c, d, e, b, z, 22, a[11]), b = h(b, c, d, e, A, 7, a[12]), e = h(e, b, c, d, B, 12, a[13]), d = h(d, e, b, c, C, 17, a[14]), c = h(c, d, e, b, D, 22, a[15]), b = k(b, c, d, e, p, 5, a[16]), e = k(e, b, c, d, u, 9, a[17]), d = k(d, e, b, c, z, 14, a[18]), c = k(c, d, e, b, j, 20, a[19]), b = k(b, c, d, e, t, 5, a[20]), e = k(e, b, c, d, y, 9, a[21]), d = k(d, e, b, c, D, 14, a[22]), c = k(c, d, e, b, s, 20, a[23]), b = k(b, c, d, e, x, 5, a[24]), e = k(e, b, c, d, C, 9, a[25]), d = k(d, e, b, c, r, 14, a[26]), c = k(c, d, e, b, w, 20, a[27]), b = k(b, c, d, e, B, 5, a[28]), e = k(e, b, c, d, q, 9, a[29]), d = k(d, e, b, c, v, 14, a[30]), c = k(c, d, e, b, A, 20, a[31]), b = l(b, c, d, e, t, 4, a[32]), e = l(e, b, c, d, w, 11, a[33]), d = l(d, e, b, c, z, 16, a[34]), c = l(c, d, e, b, C, 23, a[35]), b = l(b, c, d, e, p, 4, a[36]), e = l(e, b, c, d, s, 11, a[37]), d = l(d, e, b, c, v, 16, a[38]), c = l(c, d, e, b, y, 23, a[39]), b = l(b, c, d, e, B, 4, a[40]), e = l(e, b, c, d, j, 11, a[41]), d = l(d, e, b, c, r, 16, a[42]), c = l(c, d, e, b, u, 23, a[43]), b = l(b, c, d, e, x, 4, a[44]), e = l(e, b, c, d, A, 11, a[45]), d = l(d, e, b, c, D, 16, a[46]), c = l(c, d, e, b, q, 23, a[47]), b = n(b, c, d, e, j, 6, a[48]), e = n(e, b, c, d, v, 10, a[49]), d = n(d, e, b, c, C, 15, a[50]), c = n(c, d, e, b, t, 21, a[51]), b = n(b, c, d, e, A, 6, a[52]), e = n(e, b, c, d, r, 10, a[53]), d = n(d, e, b, c, y, 15, a[54]), c = n(c, d, e, b, p, 21, a[55]), b = n(b, c, d, e, w, 6, a[56]), e = n(e, b, c, d, D, 10, a[57]), d = n(d, e, b, c, u, 15, a[58]), c = n(c, d, e, b, B, 21, a[59]), b = n(b, c, d, e, s, 6, a[60]), e = n(e, b, c, d, z, 10, a[61]), d = n(d, e, b, c, q, 15, a[62]), c = n(c, d, e, b, x, 21, a[63]);
            g[0] = g[0] + b | 0;
            g[1] = g[1] + c | 0;
            g[2] = g[2] + d | 0;
            g[3] = g[3] + e | 0;
        },
        _doFinalize: function() {
            var a = this._data, f = a.words, g = 8 * this._nDataBytes, j = 8 * a.sigBytes;
            f[j >>> 5] |= 128 << 24 - j % 32;
            var h = E.floor(g / 4294967296);
            f[(j + 64 >>> 9 << 4) + 15] = (h << 8 | h >>> 24) & 16711935 | (h << 24 | h >>> 8) & 4278255360;
            f[(j + 64 >>> 9 << 4) + 14] = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360;
            a.sigBytes = 4 * (f.length + 1);
            this._process();
            a = this._hash;
            f = a.words;
            for(g = 0; 4 > g; g++)j = f[g], f[g] = (j << 8 | j >>> 24) & 16711935 | (j << 24 | j >>> 8) & 4278255360;
            return a;
        },
        clone: function() {
            var a = s.clone.call(this);
            a._hash = this._hash.clone();
            return a;
        }
    });
    r.MD5 = s._createHelper(q);
    r.HmacMD5 = s._createHmacHelper(q);
})(Math);
/*
CryptoJS v3.1.2 sha1-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    var k = $b1badb002678e3c8$var$CryptoJS, b = k.lib, m = b.WordArray, l = b.Hasher, d = [], b = k.algo.SHA1 = l.extend({
        _doReset: function() {
            this._hash = new m.init([
                1732584193,
                4023233417,
                2562383102,
                271733878,
                3285377520
            ]);
        },
        _doProcessBlock: function(n, p) {
            for(var a = this._hash.words, e = a[0], f = a[1], h = a[2], j = a[3], b = a[4], c = 0; 80 > c; c++){
                if (16 > c) d[c] = n[p + c] | 0;
                else {
                    var g = d[c - 3] ^ d[c - 8] ^ d[c - 14] ^ d[c - 16];
                    d[c] = g << 1 | g >>> 31;
                }
                g = (e << 5 | e >>> 27) + b + d[c];
                g = 20 > c ? g + ((f & h | ~f & j) + 1518500249) : 40 > c ? g + ((f ^ h ^ j) + 1859775393) : 60 > c ? g + ((f & h | f & j | h & j) - 1894007588) : g + ((f ^ h ^ j) - 899497514);
                b = j;
                j = h;
                h = f << 30 | f >>> 2;
                f = e;
                e = g;
            }
            a[0] = a[0] + e | 0;
            a[1] = a[1] + f | 0;
            a[2] = a[2] + h | 0;
            a[3] = a[3] + j | 0;
            a[4] = a[4] + b | 0;
        },
        _doFinalize: function() {
            var b = this._data, d = b.words, a = 8 * this._nDataBytes, e = 8 * b.sigBytes;
            d[e >>> 5] |= 128 << 24 - e % 32;
            d[(e + 64 >>> 9 << 4) + 14] = Math.floor(a / 4294967296);
            d[(e + 64 >>> 9 << 4) + 15] = a;
            b.sigBytes = 4 * d.length;
            this._process();
            return this._hash;
        },
        clone: function() {
            var b = l.clone.call(this);
            b._hash = this._hash.clone();
            return b;
        }
    });
    k.SHA1 = l._createHelper(b);
    k.HmacSHA1 = l._createHmacHelper(b);
})();
/*
CryptoJS v3.1.2 sha256-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function(k) {
    for(var g = $b1badb002678e3c8$var$CryptoJS, h = g.lib, v = h.WordArray, j = h.Hasher, h = g.algo, s = [], t = [], u = function(q) {
        return 4294967296 * (q - (q | 0)) | 0;
    }, l = 2, b = 0; 64 > b;){
        var d;
        a: {
            d = l;
            for(var w = k.sqrt(d), r = 2; r <= w; r++)if (!(d % r)) {
                d = !1;
                break a;
            }
            d = !0;
        }
        d && (8 > b && (s[b] = u(k.pow(l, 0.5))), t[b] = u(k.pow(l, 1 / 3)), b++);
        l++;
    }
    var n = [], h = h.SHA256 = j.extend({
        _doReset: function() {
            this._hash = new v.init(s.slice(0));
        },
        _doProcessBlock: function(q, h) {
            for(var a = this._hash.words, c = a[0], d = a[1], b = a[2], k = a[3], f = a[4], g = a[5], j = a[6], l = a[7], e = 0; 64 > e; e++){
                if (16 > e) n[e] = q[h + e] | 0;
                else {
                    var m = n[e - 15], p = n[e - 2];
                    n[e] = ((m << 25 | m >>> 7) ^ (m << 14 | m >>> 18) ^ m >>> 3) + n[e - 7] + ((p << 15 | p >>> 17) ^ (p << 13 | p >>> 19) ^ p >>> 10) + n[e - 16];
                }
                m = l + ((f << 26 | f >>> 6) ^ (f << 21 | f >>> 11) ^ (f << 7 | f >>> 25)) + (f & g ^ ~f & j) + t[e] + n[e];
                p = ((c << 30 | c >>> 2) ^ (c << 19 | c >>> 13) ^ (c << 10 | c >>> 22)) + (c & d ^ c & b ^ d & b);
                l = j;
                j = g;
                g = f;
                f = k + m | 0;
                k = b;
                b = d;
                d = c;
                c = m + p | 0;
            }
            a[0] = a[0] + c | 0;
            a[1] = a[1] + d | 0;
            a[2] = a[2] + b | 0;
            a[3] = a[3] + k | 0;
            a[4] = a[4] + f | 0;
            a[5] = a[5] + g | 0;
            a[6] = a[6] + j | 0;
            a[7] = a[7] + l | 0;
        },
        _doFinalize: function() {
            var d = this._data, b = d.words, a = 8 * this._nDataBytes, c = 8 * d.sigBytes;
            b[c >>> 5] |= 128 << 24 - c % 32;
            b[(c + 64 >>> 9 << 4) + 14] = k.floor(a / 4294967296);
            b[(c + 64 >>> 9 << 4) + 15] = a;
            d.sigBytes = 4 * b.length;
            this._process();
            return this._hash;
        },
        clone: function() {
            var b = j.clone.call(this);
            b._hash = this._hash.clone();
            return b;
        }
    });
    g.SHA256 = j._createHelper(h);
    g.HmacSHA256 = j._createHmacHelper(h);
})(Math);
/*
CryptoJS v3.1.2 sha224-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    var b = $b1badb002678e3c8$var$CryptoJS, d = b.lib.WordArray, a = b.algo, c = a.SHA256, a = a.SHA224 = c.extend({
        _doReset: function() {
            this._hash = new d.init([
                3238371032,
                914150663,
                812702999,
                4144912697,
                4290775857,
                1750603025,
                1694076839,
                3204075428
            ]);
        },
        _doFinalize: function() {
            var a = c._doFinalize.call(this);
            a.sigBytes -= 4;
            return a;
        }
    });
    b.SHA224 = c._createHelper(a);
    b.HmacSHA224 = c._createHmacHelper(a);
})();
/*
CryptoJS v3.1.2 sha512-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    function a() {
        return d.create.apply(d, arguments);
    }
    for(var n = $b1badb002678e3c8$var$CryptoJS, r = n.lib.Hasher, e = n.x64, d = e.Word, T = e.WordArray, e = n.algo, ea = [
        a(1116352408, 3609767458),
        a(1899447441, 602891725),
        a(3049323471, 3964484399),
        a(3921009573, 2173295548),
        a(961987163, 4081628472),
        a(1508970993, 3053834265),
        a(2453635748, 2937671579),
        a(2870763221, 3664609560),
        a(3624381080, 2734883394),
        a(310598401, 1164996542),
        a(607225278, 1323610764),
        a(1426881987, 3590304994),
        a(1925078388, 4068182383),
        a(2162078206, 991336113),
        a(2614888103, 633803317),
        a(3248222580, 3479774868),
        a(3835390401, 2666613458),
        a(4022224774, 944711139),
        a(264347078, 2341262773),
        a(604807628, 2007800933),
        a(770255983, 1495990901),
        a(1249150122, 1856431235),
        a(1555081692, 3175218132),
        a(1996064986, 2198950837),
        a(2554220882, 3999719339),
        a(2821834349, 766784016),
        a(2952996808, 2566594879),
        a(3210313671, 3203337956),
        a(3336571891, 1034457026),
        a(3584528711, 2466948901),
        a(113926993, 3758326383),
        a(338241895, 168717936),
        a(666307205, 1188179964),
        a(773529912, 1546045734),
        a(1294757372, 1522805485),
        a(1396182291, 2643833823),
        a(1695183700, 2343527390),
        a(1986661051, 1014477480),
        a(2177026350, 1206759142),
        a(2456956037, 344077627),
        a(2730485921, 1290863460),
        a(2820302411, 3158454273),
        a(3259730800, 3505952657),
        a(3345764771, 106217008),
        a(3516065817, 3606008344),
        a(3600352804, 1432725776),
        a(4094571909, 1467031594),
        a(275423344, 851169720),
        a(430227734, 3100823752),
        a(506948616, 1363258195),
        a(659060556, 3750685593),
        a(883997877, 3785050280),
        a(958139571, 3318307427),
        a(1322822218, 3812723403),
        a(1537002063, 2003034995),
        a(1747873779, 3602036899),
        a(1955562222, 1575990012),
        a(2024104815, 1125592928),
        a(2227730452, 2716904306),
        a(2361852424, 442776044),
        a(2428436474, 593698344),
        a(2756734187, 3733110249),
        a(3204031479, 2999351573),
        a(3329325298, 3815920427),
        a(3391569614, 3928383900),
        a(3515267271, 566280711),
        a(3940187606, 3454069534),
        a(4118630271, 4000239992),
        a(116418474, 1914138554),
        a(174292421, 2731055270),
        a(289380356, 3203993006),
        a(460393269, 320620315),
        a(685471733, 587496836),
        a(852142971, 1086792851),
        a(1017036298, 365543100),
        a(1126000580, 2618297676),
        a(1288033470, 3409855158),
        a(1501505948, 4234509866),
        a(1607167915, 987167468),
        a(1816402316, 1246189591)
    ], v = [], w = 0; 80 > w; w++)v[w] = a();
    e = e.SHA512 = r.extend({
        _doReset: function() {
            this._hash = new T.init([
                new d.init(1779033703, 4089235720),
                new d.init(3144134277, 2227873595),
                new d.init(1013904242, 4271175723),
                new d.init(2773480762, 1595750129),
                new d.init(1359893119, 2917565137),
                new d.init(2600822924, 725511199),
                new d.init(528734635, 4215389547),
                new d.init(1541459225, 327033209)
            ]);
        },
        _doProcessBlock: function(a, d) {
            for(var f = this._hash.words, F = f[0], e = f[1], n = f[2], r = f[3], G = f[4], H = f[5], I = f[6], f = f[7], w = F.high, J = F.low, X = e.high, K = e.low, Y = n.high, L = n.low, Z = r.high, M = r.low, $ = G.high, N = G.low, aa = H.high, O = H.low, ba = I.high, P = I.low, ca = f.high, Q = f.low, k = w, g = J, z = X, x = K, A = Y, y = L, U = Z, B = M, l = $, h = N, R = aa, C = O, S = ba, D = P, V = ca, E = Q, m = 0; 80 > m; m++){
                var s = v[m];
                if (16 > m) var j = s.high = a[d + 2 * m] | 0, b = s.low = a[d + 2 * m + 1] | 0;
                else {
                    var j = v[m - 15], b = j.high, p = j.low, j = (b >>> 1 | p << 31) ^ (b >>> 8 | p << 24) ^ b >>> 7, p = (p >>> 1 | b << 31) ^ (p >>> 8 | b << 24) ^ (p >>> 7 | b << 25), u = v[m - 2], b = u.high, c = u.low, u = (b >>> 19 | c << 13) ^ (b << 3 | c >>> 29) ^ b >>> 6, c = (c >>> 19 | b << 13) ^ (c << 3 | b >>> 29) ^ (c >>> 6 | b << 26), b = v[m - 7], W = b.high, t = v[m - 16], q = t.high, t = t.low, b = p + b.low, j = j + W + (b >>> 0 < p >>> 0 ? 1 : 0), b = b + c, j = j + u + (b >>> 0 < c >>> 0 ? 1 : 0), b = b + t, j = j + q + (b >>> 0 < t >>> 0 ? 1 : 0);
                    s.high = j;
                    s.low = b;
                }
                var W = l & R ^ ~l & S, t = h & C ^ ~h & D, s = k & z ^ k & A ^ z & A, T = g & x ^ g & y ^ x & y, p = (k >>> 28 | g << 4) ^ (k << 30 | g >>> 2) ^ (k << 25 | g >>> 7), u = (g >>> 28 | k << 4) ^ (g << 30 | k >>> 2) ^ (g << 25 | k >>> 7), c = ea[m], fa = c.high, da = c.low, c = E + ((h >>> 14 | l << 18) ^ (h >>> 18 | l << 14) ^ (h << 23 | l >>> 9)), q = V + ((l >>> 14 | h << 18) ^ (l >>> 18 | h << 14) ^ (l << 23 | h >>> 9)) + (c >>> 0 < E >>> 0 ? 1 : 0), c = c + t, q = q + W + (c >>> 0 < t >>> 0 ? 1 : 0), c = c + da, q = q + fa + (c >>> 0 < da >>> 0 ? 1 : 0), c = c + b, q = q + j + (c >>> 0 < b >>> 0 ? 1 : 0), b = u + T, s = p + s + (b >>> 0 < u >>> 0 ? 1 : 0), V = S, E = D, S = R, D = C, R = l, C = h, h = B + c | 0, l = U + q + (h >>> 0 < B >>> 0 ? 1 : 0) | 0, U = A, B = y, A = z, y = x, z = k, x = g, g = c + b | 0, k = q + s + (g >>> 0 < c >>> 0 ? 1 : 0) | 0;
            }
            J = F.low = J + g;
            F.high = w + k + (J >>> 0 < g >>> 0 ? 1 : 0);
            K = e.low = K + x;
            e.high = X + z + (K >>> 0 < x >>> 0 ? 1 : 0);
            L = n.low = L + y;
            n.high = Y + A + (L >>> 0 < y >>> 0 ? 1 : 0);
            M = r.low = M + B;
            r.high = Z + U + (M >>> 0 < B >>> 0 ? 1 : 0);
            N = G.low = N + h;
            G.high = $ + l + (N >>> 0 < h >>> 0 ? 1 : 0);
            O = H.low = O + C;
            H.high = aa + R + (O >>> 0 < C >>> 0 ? 1 : 0);
            P = I.low = P + D;
            I.high = ba + S + (P >>> 0 < D >>> 0 ? 1 : 0);
            Q = f.low = Q + E;
            f.high = ca + V + (Q >>> 0 < E >>> 0 ? 1 : 0);
        },
        _doFinalize: function() {
            var a = this._data, d = a.words, f = 8 * this._nDataBytes, e = 8 * a.sigBytes;
            d[e >>> 5] |= 128 << 24 - e % 32;
            d[(e + 128 >>> 10 << 5) + 30] = Math.floor(f / 4294967296);
            d[(e + 128 >>> 10 << 5) + 31] = f;
            a.sigBytes = 4 * d.length;
            this._process();
            return this._hash.toX32();
        },
        clone: function() {
            var a = r.clone.call(this);
            a._hash = this._hash.clone();
            return a;
        },
        blockSize: 32
    });
    n.SHA512 = r._createHelper(e);
    n.HmacSHA512 = r._createHmacHelper(e);
})();
/*
CryptoJS v3.1.2 sha384-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    var c = $b1badb002678e3c8$var$CryptoJS, a = c.x64, b = a.Word, e = a.WordArray, a = c.algo, d = a.SHA512, a = a.SHA384 = d.extend({
        _doReset: function() {
            this._hash = new e.init([
                new b.init(3418070365, 3238371032),
                new b.init(1654270250, 914150663),
                new b.init(2438529370, 812702999),
                new b.init(355462360, 4144912697),
                new b.init(1731405415, 4290775857),
                new b.init(2394180231, 1750603025),
                new b.init(3675008525, 1694076839),
                new b.init(1203062813, 3204075428)
            ]);
        },
        _doFinalize: function() {
            var a = d._doFinalize.call(this);
            a.sigBytes -= 16;
            return a;
        }
    });
    c.SHA384 = d._createHelper(a);
    c.HmacSHA384 = d._createHmacHelper(a);
})();
/*
CryptoJS v3.1.2 ripemd160-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ /*

(c) 2012 by Cedric Mesnil. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ (function() {
    var q = $b1badb002678e3c8$var$CryptoJS, d = q.lib, n = d.WordArray, p = d.Hasher, d = q.algo, x = n.create([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        7,
        4,
        13,
        1,
        10,
        6,
        15,
        3,
        12,
        0,
        9,
        5,
        2,
        14,
        11,
        8,
        3,
        10,
        14,
        4,
        9,
        15,
        8,
        1,
        2,
        7,
        0,
        6,
        13,
        11,
        5,
        12,
        1,
        9,
        11,
        10,
        0,
        8,
        12,
        4,
        13,
        3,
        7,
        15,
        14,
        5,
        6,
        2,
        4,
        0,
        5,
        9,
        7,
        12,
        2,
        10,
        14,
        1,
        3,
        8,
        11,
        6,
        15,
        13
    ]), y = n.create([
        5,
        14,
        7,
        0,
        9,
        2,
        11,
        4,
        13,
        6,
        15,
        8,
        1,
        10,
        3,
        12,
        6,
        11,
        3,
        7,
        0,
        13,
        5,
        10,
        14,
        15,
        8,
        12,
        4,
        9,
        1,
        2,
        15,
        5,
        1,
        3,
        7,
        14,
        6,
        9,
        11,
        8,
        12,
        2,
        10,
        0,
        4,
        13,
        8,
        6,
        4,
        1,
        3,
        11,
        15,
        0,
        5,
        12,
        2,
        13,
        9,
        7,
        10,
        14,
        12,
        15,
        10,
        4,
        1,
        5,
        8,
        7,
        6,
        2,
        13,
        14,
        0,
        3,
        9,
        11
    ]), z = n.create([
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8,
        7,
        6,
        8,
        13,
        11,
        9,
        7,
        15,
        7,
        12,
        15,
        9,
        11,
        7,
        13,
        12,
        11,
        13,
        6,
        7,
        14,
        9,
        13,
        15,
        14,
        8,
        13,
        6,
        5,
        12,
        7,
        5,
        11,
        12,
        14,
        15,
        14,
        15,
        9,
        8,
        9,
        14,
        5,
        6,
        8,
        6,
        5,
        12,
        9,
        15,
        5,
        11,
        6,
        8,
        13,
        12,
        5,
        12,
        13,
        14,
        11,
        8,
        5,
        6
    ]), A = n.create([
        8,
        9,
        9,
        11,
        13,
        15,
        15,
        5,
        7,
        7,
        8,
        11,
        14,
        14,
        12,
        6,
        9,
        13,
        15,
        7,
        12,
        8,
        9,
        11,
        7,
        7,
        12,
        7,
        6,
        15,
        13,
        11,
        9,
        7,
        15,
        11,
        8,
        6,
        6,
        14,
        12,
        13,
        5,
        14,
        13,
        13,
        7,
        5,
        15,
        5,
        8,
        11,
        14,
        14,
        6,
        14,
        6,
        9,
        12,
        9,
        12,
        5,
        15,
        8,
        8,
        5,
        12,
        9,
        12,
        5,
        14,
        6,
        8,
        13,
        6,
        5,
        15,
        13,
        11,
        11
    ]), B = n.create([
        0,
        1518500249,
        1859775393,
        2400959708,
        2840853838
    ]), C = n.create([
        1352829926,
        1548603684,
        1836072691,
        2053994217,
        0
    ]), d = d.RIPEMD160 = p.extend({
        _doReset: function() {
            this._hash = n.create([
                1732584193,
                4023233417,
                2562383102,
                271733878,
                3285377520
            ]);
        },
        _doProcessBlock: function(e, v) {
            for(var b = 0; 16 > b; b++){
                var c = v + b, f = e[c];
                e[c] = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360;
            }
            var c = this._hash.words, f = B.words, d = C.words, n = x.words, q = y.words, p = z.words, w = A.words, t, g, h, j, r, u, k, l, m, s;
            u = t = c[0];
            k = g = c[1];
            l = h = c[2];
            m = j = c[3];
            s = r = c[4];
            for(var a, b = 0; 80 > b; b += 1)a = t + e[v + n[b]] | 0, a = 16 > b ? a + ((g ^ h ^ j) + f[0]) : 32 > b ? a + ((g & h | ~g & j) + f[1]) : 48 > b ? a + (((g | ~h) ^ j) + f[2]) : 64 > b ? a + ((g & j | h & ~j) + f[3]) : a + ((g ^ (h | ~j)) + f[4]), a |= 0, a = a << p[b] | a >>> 32 - p[b], a = a + r | 0, t = r, r = j, j = h << 10 | h >>> 22, h = g, g = a, a = u + e[v + q[b]] | 0, a = 16 > b ? a + ((k ^ (l | ~m)) + d[0]) : 32 > b ? a + ((k & m | l & ~m) + d[1]) : 48 > b ? a + (((k | ~l) ^ m) + d[2]) : 64 > b ? a + ((k & l | ~k & m) + d[3]) : a + ((k ^ l ^ m) + d[4]), a |= 0, a = a << w[b] | a >>> 32 - w[b], a = a + s | 0, u = s, s = m, m = l << 10 | l >>> 22, l = k, k = a;
            a = c[1] + h + m | 0;
            c[1] = c[2] + j + s | 0;
            c[2] = c[3] + r + u | 0;
            c[3] = c[4] + t + k | 0;
            c[4] = c[0] + g + l | 0;
            c[0] = a;
        },
        _doFinalize: function() {
            var e = this._data, d = e.words, b = 8 * this._nDataBytes, c = 8 * e.sigBytes;
            d[c >>> 5] |= 128 << 24 - c % 32;
            d[(c + 64 >>> 9 << 4) + 14] = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360;
            e.sigBytes = 4 * (d.length + 1);
            this._process();
            e = this._hash;
            d = e.words;
            for(b = 0; 5 > b; b++)c = d[b], d[b] = (c << 8 | c >>> 24) & 16711935 | (c << 24 | c >>> 8) & 4278255360;
            return e;
        },
        clone: function() {
            var d = p.clone.call(this);
            d._hash = this._hash.clone();
            return d;
        }
    });
    q.RIPEMD160 = p._createHelper(d);
    q.HmacRIPEMD160 = p._createHmacHelper(d);
})(Math);
/*
CryptoJS v3.1.2 hmac.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    var c = $b1badb002678e3c8$var$CryptoJS, k = c.enc.Utf8;
    c.algo.HMAC = c.lib.Base.extend({
        init: function(a, b) {
            a = this._hasher = new a.init;
            "string" == typeof b && (b = k.parse(b));
            var c = a.blockSize, e = 4 * c;
            b.sigBytes > e && (b = a.finalize(b));
            b.clamp();
            for(var f = this._oKey = b.clone(), g = this._iKey = b.clone(), h = f.words, j = g.words, d = 0; d < c; d++)h[d] ^= 1549556828, j[d] ^= 909522486;
            f.sigBytes = g.sigBytes = e;
            this.reset();
        },
        reset: function() {
            var a = this._hasher;
            a.reset();
            a.update(this._iKey);
        },
        update: function(a) {
            this._hasher.update(a);
            return this;
        },
        finalize: function(a) {
            var b = this._hasher;
            a = b.finalize(a);
            b.reset();
            return b.finalize(this._oKey.clone().concat(a));
        }
    });
})();
/*
CryptoJS v3.1.2 pbkdf2-min.js
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/ (function() {
    var b = $b1badb002678e3c8$var$CryptoJS, a = b.lib, d = a.Base, m = a.WordArray, a = b.algo, q = a.HMAC, l = a.PBKDF2 = d.extend({
        cfg: d.extend({
            keySize: 4,
            hasher: a.SHA1,
            iterations: 1
        }),
        init: function(a) {
            this.cfg = this.cfg.extend(a);
        },
        compute: function(a, b) {
            for(var c = this.cfg, f = q.create(c.hasher, a), g = m.create(), d = m.create([
                1
            ]), l = g.words, r = d.words, n = c.keySize, c = c.iterations; l.length < n;){
                var h = f.update(b).finalize(d);
                f.reset();
                for(var j = h.words, s = j.length, k = h, p = 1; p < c; p++){
                    k = f.finalize(k);
                    f.reset();
                    for(var t = k.words, e = 0; e < s; e++)j[e] ^= t[e];
                }
                g.concat(h);
                r[0]++;
            }
            g.sigBytes = 4 * n;
            return g;
        }
    });
    b.PBKDF2 = function(a, b, c) {
        return l.create(c).compute(a, b);
    };
})();
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ var $b1badb002678e3c8$var$b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $b1badb002678e3c8$var$b64pad = "=";
function $b1badb002678e3c8$var$hex2b64(d) {
    var b;
    var e;
    var a = "";
    for(b = 0; b + 3 <= d.length; b += 3){
        e = parseInt(d.substring(b, b + 3), 16);
        a += $b1badb002678e3c8$var$b64map.charAt(e >> 6) + $b1badb002678e3c8$var$b64map.charAt(e & 63);
    }
    if (b + 1 == d.length) {
        e = parseInt(d.substring(b, b + 1), 16);
        a += $b1badb002678e3c8$var$b64map.charAt(e << 2);
    } else if (b + 2 == d.length) {
        e = parseInt(d.substring(b, b + 2), 16);
        a += $b1badb002678e3c8$var$b64map.charAt(e >> 2) + $b1badb002678e3c8$var$b64map.charAt((e & 3) << 4);
    }
    if ($b1badb002678e3c8$var$b64pad) while((a.length & 3) > 0)a += $b1badb002678e3c8$var$b64pad;
    return a;
}
function $b1badb002678e3c8$var$b64tohex(f) {
    var d = "";
    var e;
    var b = 0;
    var c;
    var a;
    for(e = 0; e < f.length; ++e){
        if (f.charAt(e) == $b1badb002678e3c8$var$b64pad) break;
        a = $b1badb002678e3c8$var$b64map.indexOf(f.charAt(e));
        if (a < 0) continue;
        if (b == 0) {
            d += $b1badb002678e3c8$var$int2char(a >> 2);
            c = a & 3;
            b = 1;
        } else {
            if (b == 1) {
                d += $b1badb002678e3c8$var$int2char(c << 2 | a >> 4);
                c = a & 15;
                b = 2;
            } else if (b == 2) {
                d += $b1badb002678e3c8$var$int2char(c);
                d += $b1badb002678e3c8$var$int2char(a >> 2);
                c = a & 3;
                b = 3;
            } else {
                d += $b1badb002678e3c8$var$int2char(c << 2 | a >> 4);
                d += $b1badb002678e3c8$var$int2char(a & 15);
                b = 0;
            }
        }
    }
    if (b == 1) d += $b1badb002678e3c8$var$int2char(c << 2);
    return d;
}
function $b1badb002678e3c8$var$b64toBA(e) {
    var d = $b1badb002678e3c8$var$b64tohex(e);
    var c;
    var b = new Array();
    for(c = 0; 2 * c < d.length; ++c)b[c] = parseInt(d.substring(2 * c, 2 * c + 2), 16);
    return b;
}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ var $b1badb002678e3c8$var$dbits;
var $b1badb002678e3c8$var$canary = 244837814094590;
var $b1badb002678e3c8$var$j_lm = ($b1badb002678e3c8$var$canary & 16777215) == 15715070;
function $b1badb002678e3c8$var$BigInteger(e, d, f) {
    if (e != null) {
        if ("number" == typeof e) this.fromNumber(e, d, f);
        else if (d == null && "string" != typeof e) this.fromString(e, 256);
        else this.fromString(e, d);
    }
}
function $b1badb002678e3c8$var$nbi() {
    return new $b1badb002678e3c8$var$BigInteger(null);
}
function $b1badb002678e3c8$var$am1(f, a, b, e, h, g) {
    while(--g >= 0){
        var d = a * this[f++] + b[e] + h;
        h = Math.floor(d / 67108864);
        b[e++] = d & 67108863;
    }
    return h;
}
function $b1badb002678e3c8$var$am2(f, q, r, e, o, a) {
    var k = q & 32767, p = q >> 15;
    while(--a >= 0){
        var d = this[f] & 32767;
        var g = this[f++] >> 15;
        var b = p * d + g * k;
        d = k * d + ((b & 32767) << 15) + r[e] + (o & 1073741823);
        o = (d >>> 30) + (b >>> 15) + p * g + (o >>> 30);
        r[e++] = d & 1073741823;
    }
    return o;
}
function $b1badb002678e3c8$var$am3(f, q, r, e, o, a) {
    var k = q & 16383, p = q >> 14;
    while(--a >= 0){
        var d = this[f] & 16383;
        var g = this[f++] >> 14;
        var b = p * d + g * k;
        d = k * d + ((b & 16383) << 14) + r[e] + o;
        o = (d >> 28) + (b >> 14) + p * g;
        r[e++] = d & 268435455;
    }
    return o;
}
if ($b1badb002678e3c8$var$j_lm && $b1badb002678e3c8$var$navigator.appName == "Microsoft Internet Explorer") {
    $b1badb002678e3c8$var$BigInteger.prototype.am = $b1badb002678e3c8$var$am2;
    $b1badb002678e3c8$var$dbits = 30;
} else if ($b1badb002678e3c8$var$j_lm && $b1badb002678e3c8$var$navigator.appName != "Netscape") {
    $b1badb002678e3c8$var$BigInteger.prototype.am = $b1badb002678e3c8$var$am1;
    $b1badb002678e3c8$var$dbits = 26;
} else {
    $b1badb002678e3c8$var$BigInteger.prototype.am = $b1badb002678e3c8$var$am3;
    $b1badb002678e3c8$var$dbits = 28;
}
$b1badb002678e3c8$var$BigInteger.prototype.DB = $b1badb002678e3c8$var$dbits;
$b1badb002678e3c8$var$BigInteger.prototype.DM = (1 << $b1badb002678e3c8$var$dbits) - 1;
$b1badb002678e3c8$var$BigInteger.prototype.DV = 1 << $b1badb002678e3c8$var$dbits;
var $b1badb002678e3c8$var$BI_FP = 52;
$b1badb002678e3c8$var$BigInteger.prototype.FV = Math.pow(2, $b1badb002678e3c8$var$BI_FP);
$b1badb002678e3c8$var$BigInteger.prototype.F1 = $b1badb002678e3c8$var$BI_FP - $b1badb002678e3c8$var$dbits;
$b1badb002678e3c8$var$BigInteger.prototype.F2 = 2 * $b1badb002678e3c8$var$dbits - $b1badb002678e3c8$var$BI_FP;
var $b1badb002678e3c8$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $b1badb002678e3c8$var$BI_RC = new Array();
var $b1badb002678e3c8$var$rr, $b1badb002678e3c8$var$vv;
$b1badb002678e3c8$var$rr = "0".charCodeAt(0);
for($b1badb002678e3c8$var$vv = 0; $b1badb002678e3c8$var$vv <= 9; ++$b1badb002678e3c8$var$vv)$b1badb002678e3c8$var$BI_RC[$b1badb002678e3c8$var$rr++] = $b1badb002678e3c8$var$vv;
$b1badb002678e3c8$var$rr = "a".charCodeAt(0);
for($b1badb002678e3c8$var$vv = 10; $b1badb002678e3c8$var$vv < 36; ++$b1badb002678e3c8$var$vv)$b1badb002678e3c8$var$BI_RC[$b1badb002678e3c8$var$rr++] = $b1badb002678e3c8$var$vv;
$b1badb002678e3c8$var$rr = "A".charCodeAt(0);
for($b1badb002678e3c8$var$vv = 10; $b1badb002678e3c8$var$vv < 36; ++$b1badb002678e3c8$var$vv)$b1badb002678e3c8$var$BI_RC[$b1badb002678e3c8$var$rr++] = $b1badb002678e3c8$var$vv;
function $b1badb002678e3c8$var$int2char(a) {
    return $b1badb002678e3c8$var$BI_RM.charAt(a);
}
function $b1badb002678e3c8$var$intAt(b, a) {
    var d = $b1badb002678e3c8$var$BI_RC[b.charCodeAt(a)];
    return d == null ? -1 : d;
}
function $b1badb002678e3c8$var$bnpCopyTo(b) {
    for(var a = this.t - 1; a >= 0; --a)b[a] = this[a];
    b.t = this.t;
    b.s = this.s;
}
function $b1badb002678e3c8$var$bnpFromInt(a) {
    this.t = 1;
    this.s = a < 0 ? -1 : 0;
    if (a > 0) this[0] = a;
    else if (a < -1) this[0] = a + this.DV;
    else this.t = 0;
}
function $b1badb002678e3c8$var$nbv(a) {
    var b = $b1badb002678e3c8$var$nbi();
    b.fromInt(a);
    return b;
}
function $b1badb002678e3c8$var$bnpFromString(h, c) {
    var e;
    if (c == 16) e = 4;
    else if (c == 8) e = 3;
    else {
        if (c == 256) e = 8;
        else if (c == 2) e = 1;
        else {
            if (c == 32) e = 5;
            else if (c == 4) e = 2;
            else {
                this.fromRadix(h, c);
                return;
            }
        }
    }
    this.t = 0;
    this.s = 0;
    var g = h.length, d = false, f = 0;
    while(--g >= 0){
        var a = e == 8 ? h[g] & 255 : $b1badb002678e3c8$var$intAt(h, g);
        if (a < 0) {
            if (h.charAt(g) == "-") d = true;
            continue;
        }
        d = false;
        if (f == 0) this[this.t++] = a;
        else if (f + e > this.DB) {
            this[this.t - 1] |= (a & (1 << this.DB - f) - 1) << f;
            this[this.t++] = a >> this.DB - f;
        } else this[this.t - 1] |= a << f;
        f += e;
        if (f >= this.DB) f -= this.DB;
    }
    if (e == 8 && (h[0] & 128) != 0) {
        this.s = -1;
        if (f > 0) this[this.t - 1] |= (1 << this.DB - f) - 1 << f;
    }
    this.clamp();
    if (d) $b1badb002678e3c8$var$BigInteger.ZERO.subTo(this, this);
}
function $b1badb002678e3c8$var$bnpClamp() {
    var a = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == a)--this.t;
}
function $b1badb002678e3c8$var$bnToString(c) {
    if (this.s < 0) return "-" + this.negate().toString(c);
    var e;
    if (c == 16) e = 4;
    else if (c == 8) e = 3;
    else {
        if (c == 2) e = 1;
        else if (c == 32) e = 5;
        else {
            if (c == 4) e = 2;
            else return this.toRadix(c);
        }
    }
    var g = (1 << e) - 1, l, a = false, h = "", f = this.t;
    var j = this.DB - f * this.DB % e;
    if (f-- > 0) {
        if (j < this.DB && (l = this[f] >> j) > 0) {
            a = true;
            h = $b1badb002678e3c8$var$int2char(l);
        }
        while(f >= 0){
            if (j < e) {
                l = (this[f] & (1 << j) - 1) << e - j;
                l |= this[--f] >> (j += this.DB - e);
            } else {
                l = this[f] >> (j -= e) & g;
                if (j <= 0) {
                    j += this.DB;
                    --f;
                }
            }
            if (l > 0) a = true;
            if (a) h += $b1badb002678e3c8$var$int2char(l);
        }
    }
    return a ? h : "0";
}
function $b1badb002678e3c8$var$bnNegate() {
    var a = $b1badb002678e3c8$var$nbi();
    $b1badb002678e3c8$var$BigInteger.ZERO.subTo(this, a);
    return a;
}
function $b1badb002678e3c8$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
function $b1badb002678e3c8$var$bnCompareTo(b) {
    var d = this.s - b.s;
    if (d != 0) return d;
    var c = this.t;
    d = c - b.t;
    if (d != 0) return this.s < 0 ? -d : d;
    while(--c >= 0){
        if ((d = this[c] - b[c]) != 0) return d;
    }
    return 0;
}
function $b1badb002678e3c8$var$nbits(a) {
    var c = 1, b;
    if ((b = a >>> 16) != 0) {
        a = b;
        c += 16;
    }
    if ((b = a >> 8) != 0) {
        a = b;
        c += 8;
    }
    if ((b = a >> 4) != 0) {
        a = b;
        c += 4;
    }
    if ((b = a >> 2) != 0) {
        a = b;
        c += 2;
    }
    if ((b = a >> 1) != 0) {
        a = b;
        c += 1;
    }
    return c;
}
function $b1badb002678e3c8$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $b1badb002678e3c8$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
function $b1badb002678e3c8$var$bnpDLShiftTo(c, b) {
    var a;
    for(a = this.t - 1; a >= 0; --a)b[a + c] = this[a];
    for(a = c - 1; a >= 0; --a)b[a] = 0;
    b.t = this.t + c;
    b.s = this.s;
}
function $b1badb002678e3c8$var$bnpDRShiftTo(c, b) {
    for(var a = c; a < this.t; ++a)b[a - c] = this[a];
    b.t = Math.max(this.t - c, 0);
    b.s = this.s;
}
function $b1badb002678e3c8$var$bnpLShiftTo(j, e) {
    var b = j % this.DB;
    var a = this.DB - b;
    var g = (1 << a) - 1;
    var f = Math.floor(j / this.DB), h = this.s << b & this.DM, d;
    for(d = this.t - 1; d >= 0; --d){
        e[d + f + 1] = this[d] >> a | h;
        h = (this[d] & g) << b;
    }
    for(d = f - 1; d >= 0; --d)e[d] = 0;
    e[f] = h;
    e.t = this.t + f + 1;
    e.s = this.s;
    e.clamp();
}
function $b1badb002678e3c8$var$bnpRShiftTo(g, d) {
    d.s = this.s;
    var e = Math.floor(g / this.DB);
    if (e >= this.t) {
        d.t = 0;
        return;
    }
    var b = g % this.DB;
    var a = this.DB - b;
    var f = (1 << b) - 1;
    d[0] = this[e] >> b;
    for(var c = e + 1; c < this.t; ++c){
        d[c - e - 1] |= (this[c] & f) << a;
        d[c - e] = this[c] >> b;
    }
    if (b > 0) d[this.t - e - 1] |= (this.s & f) << a;
    d.t = this.t - e;
    d.clamp();
}
function $b1badb002678e3c8$var$bnpSubTo(d, f) {
    var e = 0, g = 0, b = Math.min(d.t, this.t);
    while(e < b){
        g += this[e] - d[e];
        f[e++] = g & this.DM;
        g >>= this.DB;
    }
    if (d.t < this.t) {
        g -= d.s;
        while(e < this.t){
            g += this[e];
            f[e++] = g & this.DM;
            g >>= this.DB;
        }
        g += this.s;
    } else {
        g += this.s;
        while(e < d.t){
            g -= d[e];
            f[e++] = g & this.DM;
            g >>= this.DB;
        }
        g -= d.s;
    }
    f.s = g < 0 ? -1 : 0;
    if (g < -1) f[e++] = this.DV + g;
    else if (g > 0) f[e++] = g;
    f.t = e;
    f.clamp();
}
function $b1badb002678e3c8$var$bnpMultiplyTo(c, e) {
    var b = this.abs(), f = c.abs();
    var d = b.t;
    e.t = d + f.t;
    while(--d >= 0)e[d] = 0;
    for(d = 0; d < f.t; ++d)e[d + b.t] = b.am(0, f[d], e, d, 0, b.t);
    e.s = 0;
    e.clamp();
    if (this.s != c.s) $b1badb002678e3c8$var$BigInteger.ZERO.subTo(e, e);
}
function $b1badb002678e3c8$var$bnpSquareTo(d) {
    var a = this.abs();
    var b = d.t = 2 * a.t;
    while(--b >= 0)d[b] = 0;
    for(b = 0; b < a.t - 1; ++b){
        var e = a.am(b, a[b], d, 2 * b, 0, 1);
        if ((d[b + a.t] += a.am(b + 1, 2 * a[b], d, 2 * b + 1, e, a.t - b - 1)) >= a.DV) {
            d[b + a.t] -= a.DV;
            d[b + a.t + 1] = 1;
        }
    }
    if (d.t > 0) d[d.t - 1] += a.am(b, a[b], d, 2 * b, 0, 1);
    d.s = 0;
    d.clamp();
}
function $b1badb002678e3c8$var$bnpDivRemTo(n, h, g) {
    var w = n.abs();
    if (w.t <= 0) return;
    var k = this.abs();
    if (k.t < w.t) {
        if (h != null) h.fromInt(0);
        if (g != null) this.copyTo(g);
        return;
    }
    if (g == null) g = $b1badb002678e3c8$var$nbi();
    var d = $b1badb002678e3c8$var$nbi(), a = this.s, l = n.s;
    var v = this.DB - $b1badb002678e3c8$var$nbits(w[w.t - 1]);
    if (v > 0) {
        w.lShiftTo(v, d);
        k.lShiftTo(v, g);
    } else {
        w.copyTo(d);
        k.copyTo(g);
    }
    var p = d.t;
    var b = d[p - 1];
    if (b == 0) return;
    var o = b * (1 << this.F1) + (p > 1 ? d[p - 2] >> this.F2 : 0);
    var A = this.FV / o, z = (1 << this.F1) / o, x = 1 << this.F2;
    var u = g.t, s = u - p, f = h == null ? $b1badb002678e3c8$var$nbi() : h;
    d.dlShiftTo(s, f);
    if (g.compareTo(f) >= 0) {
        g[g.t++] = 1;
        g.subTo(f, g);
    }
    $b1badb002678e3c8$var$BigInteger.ONE.dlShiftTo(p, f);
    f.subTo(d, d);
    while(d.t < p)d[d.t++] = 0;
    while(--s >= 0){
        var c = g[--u] == b ? this.DM : Math.floor(g[u] * A + (g[u - 1] + x) * z);
        if ((g[u] += d.am(0, c, g, s, 0, p)) < c) {
            d.dlShiftTo(s, f);
            g.subTo(f, g);
            while(g[u] < --c)g.subTo(f, g);
        }
    }
    if (h != null) {
        g.drShiftTo(p, h);
        if (a != l) $b1badb002678e3c8$var$BigInteger.ZERO.subTo(h, h);
    }
    g.t = p;
    g.clamp();
    if (v > 0) g.rShiftTo(v, g);
    if (a < 0) $b1badb002678e3c8$var$BigInteger.ZERO.subTo(g, g);
}
function $b1badb002678e3c8$var$bnMod(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.abs().divRemTo(b, null, c);
    if (this.s < 0 && c.compareTo($b1badb002678e3c8$var$BigInteger.ZERO) > 0) b.subTo(c, c);
    return c;
}
function $b1badb002678e3c8$var$Classic(a) {
    this.m = a;
}
function $b1badb002678e3c8$var$cConvert(a) {
    if (a.s < 0 || a.compareTo(this.m) >= 0) return a.mod(this.m);
    else return a;
}
function $b1badb002678e3c8$var$cRevert(a) {
    return a;
}
function $b1badb002678e3c8$var$cReduce(a) {
    a.divRemTo(this.m, null, a);
}
function $b1badb002678e3c8$var$cMulTo(a, c, b) {
    a.multiplyTo(c, b);
    this.reduce(b);
}
function $b1badb002678e3c8$var$cSqrTo(a, b) {
    a.squareTo(b);
    this.reduce(b);
}
$b1badb002678e3c8$var$Classic.prototype.convert = $b1badb002678e3c8$var$cConvert;
$b1badb002678e3c8$var$Classic.prototype.revert = $b1badb002678e3c8$var$cRevert;
$b1badb002678e3c8$var$Classic.prototype.reduce = $b1badb002678e3c8$var$cReduce;
$b1badb002678e3c8$var$Classic.prototype.mulTo = $b1badb002678e3c8$var$cMulTo;
$b1badb002678e3c8$var$Classic.prototype.sqrTo = $b1badb002678e3c8$var$cSqrTo;
function $b1badb002678e3c8$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var a = this[0];
    if ((a & 1) == 0) return 0;
    var b = a & 3;
    b = b * (2 - (a & 15) * b) & 15;
    b = b * (2 - (a & 255) * b) & 255;
    b = b * (2 - ((a & 65535) * b & 65535)) & 65535;
    b = b * (2 - a * b % this.DV) % this.DV;
    return b > 0 ? this.DV - b : -b;
}
function $b1badb002678e3c8$var$Montgomery(a) {
    this.m = a;
    this.mp = a.invDigit();
    this.mpl = this.mp & 32767;
    this.mph = this.mp >> 15;
    this.um = (1 << a.DB - 15) - 1;
    this.mt2 = 2 * a.t;
}
function $b1badb002678e3c8$var$montConvert(a) {
    var b = $b1badb002678e3c8$var$nbi();
    a.abs().dlShiftTo(this.m.t, b);
    b.divRemTo(this.m, null, b);
    if (a.s < 0 && b.compareTo($b1badb002678e3c8$var$BigInteger.ZERO) > 0) this.m.subTo(b, b);
    return b;
}
function $b1badb002678e3c8$var$montRevert(a) {
    var b = $b1badb002678e3c8$var$nbi();
    a.copyTo(b);
    this.reduce(b);
    return b;
}
function $b1badb002678e3c8$var$montReduce(a) {
    while(a.t <= this.mt2)a[a.t++] = 0;
    for(var c = 0; c < this.m.t; ++c){
        var b = a[c] & 32767;
        var d = b * this.mpl + ((b * this.mph + (a[c] >> 15) * this.mpl & this.um) << 15) & a.DM;
        b = c + this.m.t;
        a[b] += this.m.am(0, d, a, c, 0, this.m.t);
        while(a[b] >= a.DV){
            a[b] -= a.DV;
            a[++b]++;
        }
    }
    a.clamp();
    a.drShiftTo(this.m.t, a);
    if (a.compareTo(this.m) >= 0) a.subTo(this.m, a);
}
function $b1badb002678e3c8$var$montSqrTo(a, b) {
    a.squareTo(b);
    this.reduce(b);
}
function $b1badb002678e3c8$var$montMulTo(a, c, b) {
    a.multiplyTo(c, b);
    this.reduce(b);
}
$b1badb002678e3c8$var$Montgomery.prototype.convert = $b1badb002678e3c8$var$montConvert;
$b1badb002678e3c8$var$Montgomery.prototype.revert = $b1badb002678e3c8$var$montRevert;
$b1badb002678e3c8$var$Montgomery.prototype.reduce = $b1badb002678e3c8$var$montReduce;
$b1badb002678e3c8$var$Montgomery.prototype.mulTo = $b1badb002678e3c8$var$montMulTo;
$b1badb002678e3c8$var$Montgomery.prototype.sqrTo = $b1badb002678e3c8$var$montSqrTo;
function $b1badb002678e3c8$var$bnpIsEven() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}
function $b1badb002678e3c8$var$bnpExp(h, j) {
    if (h > 4294967295 || h < 1) return $b1badb002678e3c8$var$BigInteger.ONE;
    var f = $b1badb002678e3c8$var$nbi(), a = $b1badb002678e3c8$var$nbi(), d = j.convert(this), c = $b1badb002678e3c8$var$nbits(h) - 1;
    d.copyTo(f);
    while(--c >= 0){
        j.sqrTo(f, a);
        if ((h & 1 << c) > 0) j.mulTo(a, d, f);
        else {
            var b = f;
            f = a;
            a = b;
        }
    }
    return j.revert(f);
}
function $b1badb002678e3c8$var$bnModPowInt(b, a) {
    var c;
    if (b < 256 || a.isEven()) c = new $b1badb002678e3c8$var$Classic(a);
    else c = new $b1badb002678e3c8$var$Montgomery(a);
    return this.exp(b, c);
}
$b1badb002678e3c8$var$BigInteger.prototype.copyTo = $b1badb002678e3c8$var$bnpCopyTo;
$b1badb002678e3c8$var$BigInteger.prototype.fromInt = $b1badb002678e3c8$var$bnpFromInt;
$b1badb002678e3c8$var$BigInteger.prototype.fromString = $b1badb002678e3c8$var$bnpFromString;
$b1badb002678e3c8$var$BigInteger.prototype.clamp = $b1badb002678e3c8$var$bnpClamp;
$b1badb002678e3c8$var$BigInteger.prototype.dlShiftTo = $b1badb002678e3c8$var$bnpDLShiftTo;
$b1badb002678e3c8$var$BigInteger.prototype.drShiftTo = $b1badb002678e3c8$var$bnpDRShiftTo;
$b1badb002678e3c8$var$BigInteger.prototype.lShiftTo = $b1badb002678e3c8$var$bnpLShiftTo;
$b1badb002678e3c8$var$BigInteger.prototype.rShiftTo = $b1badb002678e3c8$var$bnpRShiftTo;
$b1badb002678e3c8$var$BigInteger.prototype.subTo = $b1badb002678e3c8$var$bnpSubTo;
$b1badb002678e3c8$var$BigInteger.prototype.multiplyTo = $b1badb002678e3c8$var$bnpMultiplyTo;
$b1badb002678e3c8$var$BigInteger.prototype.squareTo = $b1badb002678e3c8$var$bnpSquareTo;
$b1badb002678e3c8$var$BigInteger.prototype.divRemTo = $b1badb002678e3c8$var$bnpDivRemTo;
$b1badb002678e3c8$var$BigInteger.prototype.invDigit = $b1badb002678e3c8$var$bnpInvDigit;
$b1badb002678e3c8$var$BigInteger.prototype.isEven = $b1badb002678e3c8$var$bnpIsEven;
$b1badb002678e3c8$var$BigInteger.prototype.exp = $b1badb002678e3c8$var$bnpExp;
$b1badb002678e3c8$var$BigInteger.prototype.toString = $b1badb002678e3c8$var$bnToString;
$b1badb002678e3c8$var$BigInteger.prototype.negate = $b1badb002678e3c8$var$bnNegate;
$b1badb002678e3c8$var$BigInteger.prototype.abs = $b1badb002678e3c8$var$bnAbs;
$b1badb002678e3c8$var$BigInteger.prototype.compareTo = $b1badb002678e3c8$var$bnCompareTo;
$b1badb002678e3c8$var$BigInteger.prototype.bitLength = $b1badb002678e3c8$var$bnBitLength;
$b1badb002678e3c8$var$BigInteger.prototype.mod = $b1badb002678e3c8$var$bnMod;
$b1badb002678e3c8$var$BigInteger.prototype.modPowInt = $b1badb002678e3c8$var$bnModPowInt;
$b1badb002678e3c8$var$BigInteger.ZERO = $b1badb002678e3c8$var$nbv(0);
$b1badb002678e3c8$var$BigInteger.ONE = $b1badb002678e3c8$var$nbv(1);
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function $b1badb002678e3c8$var$bnClone() {
    var a = $b1badb002678e3c8$var$nbi();
    this.copyTo(a);
    return a;
}
function $b1badb002678e3c8$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this[0] - this.DV;
        else {
            if (this.t == 0) return -1;
        }
    } else {
        if (this.t == 1) return this[0];
        else {
            if (this.t == 0) return 0;
        }
    }
    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
}
function $b1badb002678e3c8$var$bnByteValue() {
    return this.t == 0 ? this.s : this[0] << 24 >> 24;
}
function $b1badb002678e3c8$var$bnShortValue() {
    return this.t == 0 ? this.s : this[0] << 16 >> 16;
}
function $b1badb002678e3c8$var$bnpChunkSize(a) {
    return Math.floor(Math.LN2 * this.DB / Math.log(a));
}
function $b1badb002678e3c8$var$bnSigNum() {
    if (this.s < 0) return -1;
    else {
        if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
}
function $b1badb002678e3c8$var$bnpToRadix(c) {
    if (c == null) c = 10;
    if (this.signum() == 0 || c < 2 || c > 36) return "0";
    var f = this.chunkSize(c);
    var e = Math.pow(c, f);
    var i = $b1badb002678e3c8$var$nbv(e), j = $b1badb002678e3c8$var$nbi(), h = $b1badb002678e3c8$var$nbi(), g = "";
    this.divRemTo(i, j, h);
    while(j.signum() > 0){
        g = (e + h.intValue()).toString(c).substr(1) + g;
        j.divRemTo(i, j, h);
    }
    return h.intValue().toString(c) + g;
}
function $b1badb002678e3c8$var$bnpFromRadix(m, h) {
    this.fromInt(0);
    if (h == null) h = 10;
    var f = this.chunkSize(h);
    var g = Math.pow(h, f), e = false, a = 0, l = 0;
    for(var c = 0; c < m.length; ++c){
        var k = $b1badb002678e3c8$var$intAt(m, c);
        if (k < 0) {
            if (m.charAt(c) == "-" && this.signum() == 0) e = true;
            continue;
        }
        l = h * l + k;
        if (++a >= f) {
            this.dMultiply(g);
            this.dAddOffset(l, 0);
            a = 0;
            l = 0;
        }
    }
    if (a > 0) {
        this.dMultiply(Math.pow(h, a));
        this.dAddOffset(l, 0);
    }
    if (e) $b1badb002678e3c8$var$BigInteger.ZERO.subTo(this, this);
}
function $b1badb002678e3c8$var$bnpFromNumber(f, e, h) {
    if ("number" == typeof e) {
        if (f < 2) this.fromInt(1);
        else {
            this.fromNumber(f, h);
            if (!this.testBit(f - 1)) this.bitwiseTo($b1badb002678e3c8$var$BigInteger.ONE.shiftLeft(f - 1), $b1badb002678e3c8$var$op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0);
            while(!this.isProbablePrime(e)){
                this.dAddOffset(2, 0);
                if (this.bitLength() > f) this.subTo($b1badb002678e3c8$var$BigInteger.ONE.shiftLeft(f - 1), this);
            }
        }
    } else {
        var d = new Array(), g = f & 7;
        d.length = (f >> 3) + 1;
        e.nextBytes(d);
        if (g > 0) d[0] &= (1 << g) - 1;
        else d[0] = 0;
        this.fromString(d, 256);
    }
}
function $b1badb002678e3c8$var$bnToByteArray() {
    var b = this.t, c = new Array();
    c[0] = this.s;
    var e = this.DB - b * this.DB % 8, f, a = 0;
    if (b-- > 0) {
        if (e < this.DB && (f = this[b] >> e) != (this.s & this.DM) >> e) c[a++] = f | this.s << this.DB - e;
        while(b >= 0){
            if (e < 8) {
                f = (this[b] & (1 << e) - 1) << 8 - e;
                f |= this[--b] >> (e += this.DB - 8);
            } else {
                f = this[b] >> (e -= 8) & 255;
                if (e <= 0) {
                    e += this.DB;
                    --b;
                }
            }
            if ((f & 128) != 0) f |= -256;
            if (a == 0 && (this.s & 128) != (f & 128)) ++a;
            if (a > 0 || f != this.s) c[a++] = f;
        }
    }
    return c;
}
function $b1badb002678e3c8$var$bnEquals(b) {
    return this.compareTo(b) == 0;
}
function $b1badb002678e3c8$var$bnMin(b) {
    return this.compareTo(b) < 0 ? this : b;
}
function $b1badb002678e3c8$var$bnMax(b) {
    return this.compareTo(b) > 0 ? this : b;
}
function $b1badb002678e3c8$var$bnpBitwiseTo(c, h, e) {
    var d, g, b = Math.min(c.t, this.t);
    for(d = 0; d < b; ++d)e[d] = h(this[d], c[d]);
    if (c.t < this.t) {
        g = c.s & this.DM;
        for(d = b; d < this.t; ++d)e[d] = h(this[d], g);
        e.t = this.t;
    } else {
        g = this.s & this.DM;
        for(d = b; d < c.t; ++d)e[d] = h(g, c[d]);
        e.t = c.t;
    }
    e.s = h(this.s, c.s);
    e.clamp();
}
function $b1badb002678e3c8$var$op_and(a, b) {
    return a & b;
}
function $b1badb002678e3c8$var$bnAnd(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.bitwiseTo(b, $b1badb002678e3c8$var$op_and, c);
    return c;
}
function $b1badb002678e3c8$var$op_or(a, b) {
    return a | b;
}
function $b1badb002678e3c8$var$bnOr(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.bitwiseTo(b, $b1badb002678e3c8$var$op_or, c);
    return c;
}
function $b1badb002678e3c8$var$op_xor(a, b) {
    return a ^ b;
}
function $b1badb002678e3c8$var$bnXor(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.bitwiseTo(b, $b1badb002678e3c8$var$op_xor, c);
    return c;
}
function $b1badb002678e3c8$var$op_andnot(a, b) {
    return a & ~b;
}
function $b1badb002678e3c8$var$bnAndNot(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.bitwiseTo(b, $b1badb002678e3c8$var$op_andnot, c);
    return c;
}
function $b1badb002678e3c8$var$bnNot() {
    var b = $b1badb002678e3c8$var$nbi();
    for(var a = 0; a < this.t; ++a)b[a] = this.DM & ~this[a];
    b.t = this.t;
    b.s = ~this.s;
    return b;
}
function $b1badb002678e3c8$var$bnShiftLeft(b) {
    var a = $b1badb002678e3c8$var$nbi();
    if (b < 0) this.rShiftTo(-b, a);
    else this.lShiftTo(b, a);
    return a;
}
function $b1badb002678e3c8$var$bnShiftRight(b) {
    var a = $b1badb002678e3c8$var$nbi();
    if (b < 0) this.lShiftTo(-b, a);
    else this.rShiftTo(b, a);
    return a;
}
function $b1badb002678e3c8$var$lbit(a) {
    if (a == 0) return -1;
    var b = 0;
    if ((a & 65535) == 0) {
        a >>= 16;
        b += 16;
    }
    if ((a & 255) == 0) {
        a >>= 8;
        b += 8;
    }
    if ((a & 15) == 0) {
        a >>= 4;
        b += 4;
    }
    if ((a & 3) == 0) {
        a >>= 2;
        b += 2;
    }
    if ((a & 1) == 0) ++b;
    return b;
}
function $b1badb002678e3c8$var$bnGetLowestSetBit() {
    for(var a = 0; a < this.t; ++a){
        if (this[a] != 0) return a * this.DB + $b1badb002678e3c8$var$lbit(this[a]);
    }
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
function $b1badb002678e3c8$var$cbit(a) {
    var b = 0;
    while(a != 0){
        a &= a - 1;
        ++b;
    }
    return b;
}
function $b1badb002678e3c8$var$bnBitCount() {
    var c = 0, a = this.s & this.DM;
    for(var b = 0; b < this.t; ++b)c += $b1badb002678e3c8$var$cbit(this[b] ^ a);
    return c;
}
function $b1badb002678e3c8$var$bnTestBit(b) {
    var a = Math.floor(b / this.DB);
    if (a >= this.t) return this.s != 0;
    return (this[a] & 1 << b % this.DB) != 0;
}
function $b1badb002678e3c8$var$bnpChangeBit(c, b) {
    var a = $b1badb002678e3c8$var$BigInteger.ONE.shiftLeft(c);
    this.bitwiseTo(a, b, a);
    return a;
}
function $b1badb002678e3c8$var$bnSetBit(a) {
    return this.changeBit(a, $b1badb002678e3c8$var$op_or);
}
function $b1badb002678e3c8$var$bnClearBit(a) {
    return this.changeBit(a, $b1badb002678e3c8$var$op_andnot);
}
function $b1badb002678e3c8$var$bnFlipBit(a) {
    return this.changeBit(a, $b1badb002678e3c8$var$op_xor);
}
function $b1badb002678e3c8$var$bnpAddTo(d, f) {
    var e = 0, g = 0, b = Math.min(d.t, this.t);
    while(e < b){
        g += this[e] + d[e];
        f[e++] = g & this.DM;
        g >>= this.DB;
    }
    if (d.t < this.t) {
        g += d.s;
        while(e < this.t){
            g += this[e];
            f[e++] = g & this.DM;
            g >>= this.DB;
        }
        g += this.s;
    } else {
        g += this.s;
        while(e < d.t){
            g += d[e];
            f[e++] = g & this.DM;
            g >>= this.DB;
        }
        g += d.s;
    }
    f.s = g < 0 ? -1 : 0;
    if (g > 0) f[e++] = g;
    else if (g < -1) f[e++] = this.DV + g;
    f.t = e;
    f.clamp();
}
function $b1badb002678e3c8$var$bnAdd(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.addTo(b, c);
    return c;
}
function $b1badb002678e3c8$var$bnSubtract(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.subTo(b, c);
    return c;
}
function $b1badb002678e3c8$var$bnMultiply(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.multiplyTo(b, c);
    return c;
}
function $b1badb002678e3c8$var$bnSquare() {
    var a = $b1badb002678e3c8$var$nbi();
    this.squareTo(a);
    return a;
}
function $b1badb002678e3c8$var$bnDivide(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.divRemTo(b, c, null);
    return c;
}
function $b1badb002678e3c8$var$bnRemainder(b) {
    var c = $b1badb002678e3c8$var$nbi();
    this.divRemTo(b, null, c);
    return c;
}
function $b1badb002678e3c8$var$bnDivideAndRemainder(b) {
    var d = $b1badb002678e3c8$var$nbi(), c = $b1badb002678e3c8$var$nbi();
    this.divRemTo(b, d, c);
    return new Array(d, c);
}
function $b1badb002678e3c8$var$bnpDMultiply(a) {
    this[this.t] = this.am(0, a - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
function $b1badb002678e3c8$var$bnpDAddOffset(b, a) {
    if (b == 0) return;
    while(this.t <= a)this[this.t++] = 0;
    this[a] += b;
    while(this[a] >= this.DV){
        this[a] -= this.DV;
        if (++a >= this.t) this[this.t++] = 0;
        ++this[a];
    }
}
function $b1badb002678e3c8$var$NullExp() {}
function $b1badb002678e3c8$var$nNop(a) {
    return a;
}
function $b1badb002678e3c8$var$nMulTo(a, c, b) {
    a.multiplyTo(c, b);
}
function $b1badb002678e3c8$var$nSqrTo(a, b) {
    a.squareTo(b);
}
$b1badb002678e3c8$var$NullExp.prototype.convert = $b1badb002678e3c8$var$nNop;
$b1badb002678e3c8$var$NullExp.prototype.revert = $b1badb002678e3c8$var$nNop;
$b1badb002678e3c8$var$NullExp.prototype.mulTo = $b1badb002678e3c8$var$nMulTo;
$b1badb002678e3c8$var$NullExp.prototype.sqrTo = $b1badb002678e3c8$var$nSqrTo;
function $b1badb002678e3c8$var$bnPow(a) {
    return this.exp(a, new $b1badb002678e3c8$var$NullExp());
}
function $b1badb002678e3c8$var$bnpMultiplyLowerTo(b, f, e) {
    var d = Math.min(this.t + b.t, f);
    e.s = 0;
    e.t = d;
    while(d > 0)e[--d] = 0;
    var c;
    for(c = e.t - this.t; d < c; ++d)e[d + this.t] = this.am(0, b[d], e, d, 0, this.t);
    for(c = Math.min(b.t, f); d < c; ++d)this.am(0, b[d], e, d, 0, f - d);
    e.clamp();
}
function $b1badb002678e3c8$var$bnpMultiplyUpperTo(b, e, d) {
    --e;
    var c = d.t = this.t + b.t - e;
    d.s = 0;
    while(--c >= 0)d[c] = 0;
    for(c = Math.max(e - this.t, 0); c < b.t; ++c)d[this.t + c - e] = this.am(e - c, b[c], d, 0, 0, this.t + c - e);
    d.clamp();
    d.drShiftTo(1, d);
}
function $b1badb002678e3c8$var$Barrett(a) {
    this.r2 = $b1badb002678e3c8$var$nbi();
    this.q3 = $b1badb002678e3c8$var$nbi();
    $b1badb002678e3c8$var$BigInteger.ONE.dlShiftTo(2 * a.t, this.r2);
    this.mu = this.r2.divide(a);
    this.m = a;
}
function $b1badb002678e3c8$var$barrettConvert(a) {
    if (a.s < 0 || a.t > 2 * this.m.t) return a.mod(this.m);
    else {
        if (a.compareTo(this.m) < 0) return a;
        else {
            var b = $b1badb002678e3c8$var$nbi();
            a.copyTo(b);
            this.reduce(b);
            return b;
        }
    }
}
function $b1badb002678e3c8$var$barrettRevert(a) {
    return a;
}
function $b1badb002678e3c8$var$barrettReduce(a) {
    a.drShiftTo(this.m.t - 1, this.r2);
    if (a.t > this.m.t + 1) {
        a.t = this.m.t + 1;
        a.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(a.compareTo(this.r2) < 0)a.dAddOffset(1, this.m.t + 1);
    a.subTo(this.r2, a);
    while(a.compareTo(this.m) >= 0)a.subTo(this.m, a);
}
function $b1badb002678e3c8$var$barrettSqrTo(a, b) {
    a.squareTo(b);
    this.reduce(b);
}
function $b1badb002678e3c8$var$barrettMulTo(a, c, b) {
    a.multiplyTo(c, b);
    this.reduce(b);
}
$b1badb002678e3c8$var$Barrett.prototype.convert = $b1badb002678e3c8$var$barrettConvert;
$b1badb002678e3c8$var$Barrett.prototype.revert = $b1badb002678e3c8$var$barrettRevert;
$b1badb002678e3c8$var$Barrett.prototype.reduce = $b1badb002678e3c8$var$barrettReduce;
$b1badb002678e3c8$var$Barrett.prototype.mulTo = $b1badb002678e3c8$var$barrettMulTo;
$b1badb002678e3c8$var$Barrett.prototype.sqrTo = $b1badb002678e3c8$var$barrettSqrTo;
function $b1badb002678e3c8$var$bnModPow(q, f) {
    var o = q.bitLength(), h, b = $b1badb002678e3c8$var$nbv(1), v;
    if (o <= 0) return b;
    else {
        if (o < 18) h = 1;
        else if (o < 48) h = 3;
        else {
            if (o < 144) h = 4;
            else if (o < 768) h = 5;
            else h = 6;
        }
    }
    if (o < 8) v = new $b1badb002678e3c8$var$Classic(f);
    else if (f.isEven()) v = new $b1badb002678e3c8$var$Barrett(f);
    else v = new $b1badb002678e3c8$var$Montgomery(f);
    var p = new Array(), d = 3, s = h - 1, a = (1 << h) - 1;
    p[1] = v.convert(this);
    if (h > 1) {
        var A = $b1badb002678e3c8$var$nbi();
        v.sqrTo(p[1], A);
        while(d <= a){
            p[d] = $b1badb002678e3c8$var$nbi();
            v.mulTo(A, p[d - 2], p[d]);
            d += 2;
        }
    }
    var l = q.t - 1, x, u = true, c = $b1badb002678e3c8$var$nbi(), y;
    o = $b1badb002678e3c8$var$nbits(q[l]) - 1;
    while(l >= 0){
        if (o >= s) x = q[l] >> o - s & a;
        else {
            x = (q[l] & (1 << o + 1) - 1) << s - o;
            if (l > 0) x |= q[l - 1] >> this.DB + o - s;
        }
        d = h;
        while((x & 1) == 0){
            x >>= 1;
            --d;
        }
        if ((o -= d) < 0) {
            o += this.DB;
            --l;
        }
        if (u) {
            p[x].copyTo(b);
            u = false;
        } else {
            while(d > 1){
                v.sqrTo(b, c);
                v.sqrTo(c, b);
                d -= 2;
            }
            if (d > 0) v.sqrTo(b, c);
            else {
                y = b;
                b = c;
                c = y;
            }
            v.mulTo(c, p[x], b);
        }
        while(l >= 0 && (q[l] & 1 << o) == 0){
            v.sqrTo(b, c);
            y = b;
            b = c;
            c = y;
            if (--o < 0) {
                o = this.DB - 1;
                --l;
            }
        }
    }
    return v.revert(b);
}
function $b1badb002678e3c8$var$bnGCD(c) {
    var b = this.s < 0 ? this.negate() : this.clone();
    var h = c.s < 0 ? c.negate() : c.clone();
    if (b.compareTo(h) < 0) {
        var e = b;
        b = h;
        h = e;
    }
    var d = b.getLowestSetBit(), f = h.getLowestSetBit();
    if (f < 0) return b;
    if (d < f) f = d;
    if (f > 0) {
        b.rShiftTo(f, b);
        h.rShiftTo(f, h);
    }
    while(b.signum() > 0){
        if ((d = b.getLowestSetBit()) > 0) b.rShiftTo(d, b);
        if ((d = h.getLowestSetBit()) > 0) h.rShiftTo(d, h);
        if (b.compareTo(h) >= 0) {
            b.subTo(h, b);
            b.rShiftTo(1, b);
        } else {
            h.subTo(b, h);
            h.rShiftTo(1, h);
        }
    }
    if (f > 0) h.lShiftTo(f, h);
    return h;
}
function $b1badb002678e3c8$var$bnpModInt(e) {
    if (e <= 0) return 0;
    var c = this.DV % e, b = this.s < 0 ? e - 1 : 0;
    if (this.t > 0) {
        if (c == 0) b = this[0] % e;
        else for(var a = this.t - 1; a >= 0; --a)b = (c * b + this[a]) % e;
    }
    return b;
}
function $b1badb002678e3c8$var$bnModInverse(f) {
    var j = f.isEven();
    if (this.isEven() && j || f.signum() == 0) return $b1badb002678e3c8$var$BigInteger.ZERO;
    var i = f.clone(), h = this.clone();
    var g = $b1badb002678e3c8$var$nbv(1), e = $b1badb002678e3c8$var$nbv(0), l = $b1badb002678e3c8$var$nbv(0), k = $b1badb002678e3c8$var$nbv(1);
    while(i.signum() != 0){
        while(i.isEven()){
            i.rShiftTo(1, i);
            if (j) {
                if (!g.isEven() || !e.isEven()) {
                    g.addTo(this, g);
                    e.subTo(f, e);
                }
                g.rShiftTo(1, g);
            } else if (!e.isEven()) e.subTo(f, e);
            e.rShiftTo(1, e);
        }
        while(h.isEven()){
            h.rShiftTo(1, h);
            if (j) {
                if (!l.isEven() || !k.isEven()) {
                    l.addTo(this, l);
                    k.subTo(f, k);
                }
                l.rShiftTo(1, l);
            } else if (!k.isEven()) k.subTo(f, k);
            k.rShiftTo(1, k);
        }
        if (i.compareTo(h) >= 0) {
            i.subTo(h, i);
            if (j) g.subTo(l, g);
            e.subTo(k, e);
        } else {
            h.subTo(i, h);
            if (j) l.subTo(g, l);
            k.subTo(e, k);
        }
    }
    if (h.compareTo($b1badb002678e3c8$var$BigInteger.ONE) != 0) return $b1badb002678e3c8$var$BigInteger.ZERO;
    if (k.compareTo(f) >= 0) return k.subtract(f);
    if (k.signum() < 0) k.addTo(f, k);
    else return k;
    if (k.signum() < 0) return k.add(f);
    else return k;
}
var $b1badb002678e3c8$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509,
    521,
    523,
    541,
    547,
    557,
    563,
    569,
    571,
    577,
    587,
    593,
    599,
    601,
    607,
    613,
    617,
    619,
    631,
    641,
    643,
    647,
    653,
    659,
    661,
    673,
    677,
    683,
    691,
    701,
    709,
    719,
    727,
    733,
    739,
    743,
    751,
    757,
    761,
    769,
    773,
    787,
    797,
    809,
    811,
    821,
    823,
    827,
    829,
    839,
    853,
    857,
    859,
    863,
    877,
    881,
    883,
    887,
    907,
    911,
    919,
    929,
    937,
    941,
    947,
    953,
    967,
    971,
    977,
    983,
    991,
    997
];
var $b1badb002678e3c8$var$lplim = 67108864 / $b1badb002678e3c8$var$lowprimes[$b1badb002678e3c8$var$lowprimes.length - 1];
function $b1badb002678e3c8$var$bnIsProbablePrime(e) {
    var d, b = this.abs();
    if (b.t == 1 && b[0] <= $b1badb002678e3c8$var$lowprimes[$b1badb002678e3c8$var$lowprimes.length - 1]) {
        for(d = 0; d < $b1badb002678e3c8$var$lowprimes.length; ++d){
            if (b[0] == $b1badb002678e3c8$var$lowprimes[d]) return true;
        }
        return false;
    }
    if (b.isEven()) return false;
    d = 1;
    while(d < $b1badb002678e3c8$var$lowprimes.length){
        var a = $b1badb002678e3c8$var$lowprimes[d], c = d + 1;
        while(c < $b1badb002678e3c8$var$lowprimes.length && a < $b1badb002678e3c8$var$lplim)a *= $b1badb002678e3c8$var$lowprimes[c++];
        a = b.modInt(a);
        while(d < c){
            if (a % $b1badb002678e3c8$var$lowprimes[d++] == 0) return false;
        }
    }
    return b.millerRabin(e);
}
function $b1badb002678e3c8$var$bnpMillerRabin(f) {
    var g = this.subtract($b1badb002678e3c8$var$BigInteger.ONE);
    var c = g.getLowestSetBit();
    if (c <= 0) return false;
    var h = g.shiftRight(c);
    f = f + 1 >> 1;
    if (f > $b1badb002678e3c8$var$lowprimes.length) f = $b1badb002678e3c8$var$lowprimes.length;
    var b = $b1badb002678e3c8$var$nbi();
    for(var e = 0; e < f; ++e){
        b.fromInt($b1badb002678e3c8$var$lowprimes[Math.floor(Math.random() * $b1badb002678e3c8$var$lowprimes.length)]);
        var l = b.modPow(h, this);
        if (l.compareTo($b1badb002678e3c8$var$BigInteger.ONE) != 0 && l.compareTo(g) != 0) {
            var d = 1;
            while(d++ < c && l.compareTo(g) != 0){
                l = l.modPowInt(2, this);
                if (l.compareTo($b1badb002678e3c8$var$BigInteger.ONE) == 0) return false;
            }
            if (l.compareTo(g) != 0) return false;
        }
    }
    return true;
}
$b1badb002678e3c8$var$BigInteger.prototype.chunkSize = $b1badb002678e3c8$var$bnpChunkSize;
$b1badb002678e3c8$var$BigInteger.prototype.toRadix = $b1badb002678e3c8$var$bnpToRadix;
$b1badb002678e3c8$var$BigInteger.prototype.fromRadix = $b1badb002678e3c8$var$bnpFromRadix;
$b1badb002678e3c8$var$BigInteger.prototype.fromNumber = $b1badb002678e3c8$var$bnpFromNumber;
$b1badb002678e3c8$var$BigInteger.prototype.bitwiseTo = $b1badb002678e3c8$var$bnpBitwiseTo;
$b1badb002678e3c8$var$BigInteger.prototype.changeBit = $b1badb002678e3c8$var$bnpChangeBit;
$b1badb002678e3c8$var$BigInteger.prototype.addTo = $b1badb002678e3c8$var$bnpAddTo;
$b1badb002678e3c8$var$BigInteger.prototype.dMultiply = $b1badb002678e3c8$var$bnpDMultiply;
$b1badb002678e3c8$var$BigInteger.prototype.dAddOffset = $b1badb002678e3c8$var$bnpDAddOffset;
$b1badb002678e3c8$var$BigInteger.prototype.multiplyLowerTo = $b1badb002678e3c8$var$bnpMultiplyLowerTo;
$b1badb002678e3c8$var$BigInteger.prototype.multiplyUpperTo = $b1badb002678e3c8$var$bnpMultiplyUpperTo;
$b1badb002678e3c8$var$BigInteger.prototype.modInt = $b1badb002678e3c8$var$bnpModInt;
$b1badb002678e3c8$var$BigInteger.prototype.millerRabin = $b1badb002678e3c8$var$bnpMillerRabin;
$b1badb002678e3c8$var$BigInteger.prototype.clone = $b1badb002678e3c8$var$bnClone;
$b1badb002678e3c8$var$BigInteger.prototype.intValue = $b1badb002678e3c8$var$bnIntValue;
$b1badb002678e3c8$var$BigInteger.prototype.byteValue = $b1badb002678e3c8$var$bnByteValue;
$b1badb002678e3c8$var$BigInteger.prototype.shortValue = $b1badb002678e3c8$var$bnShortValue;
$b1badb002678e3c8$var$BigInteger.prototype.signum = $b1badb002678e3c8$var$bnSigNum;
$b1badb002678e3c8$var$BigInteger.prototype.toByteArray = $b1badb002678e3c8$var$bnToByteArray;
$b1badb002678e3c8$var$BigInteger.prototype.equals = $b1badb002678e3c8$var$bnEquals;
$b1badb002678e3c8$var$BigInteger.prototype.min = $b1badb002678e3c8$var$bnMin;
$b1badb002678e3c8$var$BigInteger.prototype.max = $b1badb002678e3c8$var$bnMax;
$b1badb002678e3c8$var$BigInteger.prototype.and = $b1badb002678e3c8$var$bnAnd;
$b1badb002678e3c8$var$BigInteger.prototype.or = $b1badb002678e3c8$var$bnOr;
$b1badb002678e3c8$var$BigInteger.prototype.xor = $b1badb002678e3c8$var$bnXor;
$b1badb002678e3c8$var$BigInteger.prototype.andNot = $b1badb002678e3c8$var$bnAndNot;
$b1badb002678e3c8$var$BigInteger.prototype.not = $b1badb002678e3c8$var$bnNot;
$b1badb002678e3c8$var$BigInteger.prototype.shiftLeft = $b1badb002678e3c8$var$bnShiftLeft;
$b1badb002678e3c8$var$BigInteger.prototype.shiftRight = $b1badb002678e3c8$var$bnShiftRight;
$b1badb002678e3c8$var$BigInteger.prototype.getLowestSetBit = $b1badb002678e3c8$var$bnGetLowestSetBit;
$b1badb002678e3c8$var$BigInteger.prototype.bitCount = $b1badb002678e3c8$var$bnBitCount;
$b1badb002678e3c8$var$BigInteger.prototype.testBit = $b1badb002678e3c8$var$bnTestBit;
$b1badb002678e3c8$var$BigInteger.prototype.setBit = $b1badb002678e3c8$var$bnSetBit;
$b1badb002678e3c8$var$BigInteger.prototype.clearBit = $b1badb002678e3c8$var$bnClearBit;
$b1badb002678e3c8$var$BigInteger.prototype.flipBit = $b1badb002678e3c8$var$bnFlipBit;
$b1badb002678e3c8$var$BigInteger.prototype.add = $b1badb002678e3c8$var$bnAdd;
$b1badb002678e3c8$var$BigInteger.prototype.subtract = $b1badb002678e3c8$var$bnSubtract;
$b1badb002678e3c8$var$BigInteger.prototype.multiply = $b1badb002678e3c8$var$bnMultiply;
$b1badb002678e3c8$var$BigInteger.prototype.divide = $b1badb002678e3c8$var$bnDivide;
$b1badb002678e3c8$var$BigInteger.prototype.remainder = $b1badb002678e3c8$var$bnRemainder;
$b1badb002678e3c8$var$BigInteger.prototype.divideAndRemainder = $b1badb002678e3c8$var$bnDivideAndRemainder;
$b1badb002678e3c8$var$BigInteger.prototype.modPow = $b1badb002678e3c8$var$bnModPow;
$b1badb002678e3c8$var$BigInteger.prototype.modInverse = $b1badb002678e3c8$var$bnModInverse;
$b1badb002678e3c8$var$BigInteger.prototype.pow = $b1badb002678e3c8$var$bnPow;
$b1badb002678e3c8$var$BigInteger.prototype.gcd = $b1badb002678e3c8$var$bnGCD;
$b1badb002678e3c8$var$BigInteger.prototype.isProbablePrime = $b1badb002678e3c8$var$bnIsProbablePrime;
$b1badb002678e3c8$var$BigInteger.prototype.square = $b1badb002678e3c8$var$bnSquare;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function $b1badb002678e3c8$var$Arcfour() {
    this.i = 0;
    this.j = 0;
    this.S = new Array();
}
function $b1badb002678e3c8$var$ARC4init(d) {
    var c, a, b;
    for(c = 0; c < 256; ++c)this.S[c] = c;
    a = 0;
    for(c = 0; c < 256; ++c){
        a = a + this.S[c] + d[c % d.length] & 255;
        b = this.S[c];
        this.S[c] = this.S[a];
        this.S[a] = b;
    }
    this.i = 0;
    this.j = 0;
}
function $b1badb002678e3c8$var$ARC4next() {
    var a;
    this.i = this.i + 1 & 255;
    this.j = this.j + this.S[this.i] & 255;
    a = this.S[this.i];
    this.S[this.i] = this.S[this.j];
    this.S[this.j] = a;
    return this.S[a + this.S[this.i] & 255];
}
$b1badb002678e3c8$var$Arcfour.prototype.init = $b1badb002678e3c8$var$ARC4init;
$b1badb002678e3c8$var$Arcfour.prototype.next = $b1badb002678e3c8$var$ARC4next;
function $b1badb002678e3c8$var$prng_newstate() {
    return new $b1badb002678e3c8$var$Arcfour();
}
var $b1badb002678e3c8$var$rng_psize = 256;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ var $b1badb002678e3c8$var$rng_state;
var $b1badb002678e3c8$var$rng_pool;
var $b1badb002678e3c8$var$rng_pptr;
function $b1badb002678e3c8$var$rng_seed_int(a) {
    $b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] ^= a & 255;
    $b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] ^= a >> 8 & 255;
    $b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] ^= a >> 16 & 255;
    $b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] ^= a >> 24 & 255;
    if ($b1badb002678e3c8$var$rng_pptr >= $b1badb002678e3c8$var$rng_psize) $b1badb002678e3c8$var$rng_pptr -= $b1badb002678e3c8$var$rng_psize;
}
function $b1badb002678e3c8$var$rng_seed_time() {
    $b1badb002678e3c8$var$rng_seed_int(new Date().getTime());
}
if ($b1badb002678e3c8$var$rng_pool == null) {
    $b1badb002678e3c8$var$rng_pool = new Array();
    $b1badb002678e3c8$var$rng_pptr = 0;
    var $b1badb002678e3c8$var$t;
    if ($b1badb002678e3c8$var$window !== undefined && ($b1badb002678e3c8$var$window.crypto !== undefined || $b1badb002678e3c8$var$window.msCrypto !== undefined)) {
        var $b1badb002678e3c8$var$crypto = $b1badb002678e3c8$var$window.crypto || $b1badb002678e3c8$var$window.msCrypto;
        if ($b1badb002678e3c8$var$crypto.getRandomValues) {
            var $b1badb002678e3c8$var$ua = new Uint8Array(32);
            $b1badb002678e3c8$var$crypto.getRandomValues($b1badb002678e3c8$var$ua);
            for($b1badb002678e3c8$var$t = 0; $b1badb002678e3c8$var$t < 32; ++$b1badb002678e3c8$var$t)$b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] = $b1badb002678e3c8$var$ua[$b1badb002678e3c8$var$t];
        } else if ($b1badb002678e3c8$var$navigator.appName == "Netscape" && $b1badb002678e3c8$var$navigator.appVersion < "5") {
            var $b1badb002678e3c8$var$z = $b1badb002678e3c8$var$window.crypto.random(32);
            for($b1badb002678e3c8$var$t = 0; $b1badb002678e3c8$var$t < $b1badb002678e3c8$var$z.length; ++$b1badb002678e3c8$var$t)$b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] = $b1badb002678e3c8$var$z.charCodeAt($b1badb002678e3c8$var$t) & 255;
        }
    }
    while($b1badb002678e3c8$var$rng_pptr < $b1badb002678e3c8$var$rng_psize){
        $b1badb002678e3c8$var$t = Math.floor(65536 * Math.random());
        $b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] = $b1badb002678e3c8$var$t >>> 8;
        $b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr++] = $b1badb002678e3c8$var$t & 255;
    }
    $b1badb002678e3c8$var$rng_pptr = 0;
    $b1badb002678e3c8$var$rng_seed_time();
}
function $b1badb002678e3c8$var$rng_get_byte() {
    if ($b1badb002678e3c8$var$rng_state == null) {
        $b1badb002678e3c8$var$rng_seed_time();
        $b1badb002678e3c8$var$rng_state = $b1badb002678e3c8$var$prng_newstate();
        $b1badb002678e3c8$var$rng_state.init($b1badb002678e3c8$var$rng_pool);
        for($b1badb002678e3c8$var$rng_pptr = 0; $b1badb002678e3c8$var$rng_pptr < $b1badb002678e3c8$var$rng_pool.length; ++$b1badb002678e3c8$var$rng_pptr)$b1badb002678e3c8$var$rng_pool[$b1badb002678e3c8$var$rng_pptr] = 0;
        $b1badb002678e3c8$var$rng_pptr = 0;
    }
    return $b1badb002678e3c8$var$rng_state.next();
}
function $b1badb002678e3c8$var$rng_get_bytes(b) {
    var a;
    for(a = 0; a < b.length; ++a)b[a] = $b1badb002678e3c8$var$rng_get_byte();
}
function $b1badb002678e3c8$var$SecureRandom() {}
$b1badb002678e3c8$var$SecureRandom.prototype.nextBytes = $b1badb002678e3c8$var$rng_get_bytes;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function $b1badb002678e3c8$var$parseBigInt(b, a) {
    return new $b1badb002678e3c8$var$BigInteger(b, a);
}
function $b1badb002678e3c8$var$linebrk(c, d) {
    var a = "";
    var b = 0;
    while(b + d < c.length){
        a += c.substring(b, b + d) + "\n";
        b += d;
    }
    return a + c.substring(b, c.length);
}
function $b1badb002678e3c8$var$byte2Hex(a) {
    if (a < 16) return "0" + a.toString(16);
    else return a.toString(16);
}
function $b1badb002678e3c8$var$pkcs1pad2(e, h) {
    if (h < e.length + 11) throw "Message too long for RSA";
    var g = new Array();
    var d = e.length - 1;
    while(d >= 0 && h > 0){
        var f = e.charCodeAt(d--);
        if (f < 128) g[--h] = f;
        else if (f > 127 && f < 2048) {
            g[--h] = f & 63 | 128;
            g[--h] = f >> 6 | 192;
        } else {
            g[--h] = f & 63 | 128;
            g[--h] = f >> 6 & 63 | 128;
            g[--h] = f >> 12 | 224;
        }
    }
    g[--h] = 0;
    var b = new $b1badb002678e3c8$var$SecureRandom();
    var a = new Array();
    while(h > 2){
        a[0] = 0;
        while(a[0] == 0)b.nextBytes(a);
        g[--h] = a[0];
    }
    g[--h] = 2;
    g[--h] = 0;
    return new $b1badb002678e3c8$var$BigInteger(g);
}
function $b1badb002678e3c8$var$oaep_mgf1_arr(c, a, e) {
    var b = "", d = 0;
    while(b.length < a){
        b += e(String.fromCharCode.apply(String, c.concat([
            (d & 4278190080) >> 24,
            (d & 16711680) >> 16,
            (d & 65280) >> 8,
            d & 255
        ])));
        d += 1;
    }
    return b;
}
function $b1badb002678e3c8$var$oaep_pad(q, a, f, l) {
    var c = $b1badb002678e3c8$var$KJUR.crypto.MessageDigest;
    var o = $b1badb002678e3c8$var$KJUR.crypto.Util;
    var b = null;
    if (!f) f = "sha1";
    if (typeof f === "string") {
        b = c.getCanonicalAlgName(f);
        l = c.getHashLength(b);
        f = function(i) {
            return $b1badb002678e3c8$var$hextorstr(o.hashHex($b1badb002678e3c8$var$rstrtohex(i), b));
        };
    }
    if (q.length + 2 * l + 2 > a) throw "Message too long for RSA";
    var k = "", e;
    for(e = 0; e < a - q.length - 2 * l - 2; e += 1)k += "\x00";
    var h = f("") + k + "\x01" + q;
    var g = new Array(l);
    new $b1badb002678e3c8$var$SecureRandom().nextBytes(g);
    var j = $b1badb002678e3c8$var$oaep_mgf1_arr(g, h.length, f);
    var p = [];
    for(e = 0; e < h.length; e += 1)p[e] = h.charCodeAt(e) ^ j.charCodeAt(e);
    var m = $b1badb002678e3c8$var$oaep_mgf1_arr(p, g.length, f);
    var d = [
        0
    ];
    for(e = 0; e < g.length; e += 1)d[e + 1] = g[e] ^ m.charCodeAt(e);
    return new $b1badb002678e3c8$var$BigInteger(d.concat(p));
}
function $b1badb002678e3c8$var$RSAKey() {
    this.n = null;
    this.e = 0;
    this.d = null;
    this.p = null;
    this.q = null;
    this.dmp1 = null;
    this.dmq1 = null;
    this.coeff = null;
}
function $b1badb002678e3c8$var$RSASetPublic(b, a) {
    this.isPublic = true;
    this.isPrivate = false;
    if (typeof b !== "string") {
        this.n = b;
        this.e = a;
    } else {
        if (b != null && a != null && b.length > 0 && a.length > 0) {
            this.n = $b1badb002678e3c8$var$parseBigInt(b, 16);
            this.e = parseInt(a, 16);
        } else throw "Invalid RSA public key";
    }
}
function $b1badb002678e3c8$var$RSADoPublic(a) {
    return a.modPowInt(this.e, this.n);
}
function $b1badb002678e3c8$var$RSAEncrypt(d) {
    var a = $b1badb002678e3c8$var$pkcs1pad2(d, this.n.bitLength() + 7 >> 3);
    if (a == null) return null;
    var e = this.doPublic(a);
    if (e == null) return null;
    var b = e.toString(16);
    if ((b.length & 1) == 0) return b;
    else return "0" + b;
}
function $b1badb002678e3c8$var$RSAEncryptOAEP(f, e, b) {
    var a = $b1badb002678e3c8$var$oaep_pad(f, this.n.bitLength() + 7 >> 3, e, b);
    if (a == null) return null;
    var g = this.doPublic(a);
    if (g == null) return null;
    var d = g.toString(16);
    if ((d.length & 1) == 0) return d;
    else return "0" + d;
}
$b1badb002678e3c8$var$RSAKey.prototype.doPublic = $b1badb002678e3c8$var$RSADoPublic;
$b1badb002678e3c8$var$RSAKey.prototype.setPublic = $b1badb002678e3c8$var$RSASetPublic;
$b1badb002678e3c8$var$RSAKey.prototype.encrypt = $b1badb002678e3c8$var$RSAEncrypt;
$b1badb002678e3c8$var$RSAKey.prototype.encryptOAEP = $b1badb002678e3c8$var$RSAEncryptOAEP;
$b1badb002678e3c8$var$RSAKey.prototype.type = "RSA";
/*! (c) Tom Wu, Kenji Urushima | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function $b1badb002678e3c8$var$pkcs1unpad2(g, j) {
    var a = g.toByteArray();
    var f = 0;
    while(f < a.length && a[f] == 0)++f;
    if (a.length - f != j - 1 || a[f] != 2) return null;
    ++f;
    while(a[f] != 0){
        if (++f >= a.length) return null;
    }
    var e = "";
    while(++f < a.length){
        var h = a[f] & 255;
        if (h < 128) e += String.fromCharCode(h);
        else if (h > 191 && h < 224) {
            e += String.fromCharCode((h & 31) << 6 | a[f + 1] & 63);
            ++f;
        } else {
            e += String.fromCharCode((h & 15) << 12 | (a[f + 1] & 63) << 6 | a[f + 2] & 63);
            f += 2;
        }
    }
    return e;
}
function $b1badb002678e3c8$var$oaep_mgf1_str(c, a, e) {
    var b = "", d = 0;
    while(b.length < a){
        b += e(c + String.fromCharCode.apply(String, [
            (d & 4278190080) >> 24,
            (d & 16711680) >> 16,
            (d & 65280) >> 8,
            d & 255
        ]));
        d += 1;
    }
    return b;
}
function $b1badb002678e3c8$var$oaep_unpad(o, b, g, p) {
    var e = $b1badb002678e3c8$var$KJUR.crypto.MessageDigest;
    var r = $b1badb002678e3c8$var$KJUR.crypto.Util;
    var c = null;
    if (!g) g = "sha1";
    if (typeof g === "string") {
        c = e.getCanonicalAlgName(g);
        p = e.getHashLength(c);
        g = function(d) {
            return $b1badb002678e3c8$var$hextorstr(r.hashHex($b1badb002678e3c8$var$rstrtohex(d), c));
        };
    }
    o = o.toByteArray();
    var h;
    for(h = 0; h < o.length; h += 1)o[h] &= 255;
    while(o.length < b)o.unshift(0);
    o = String.fromCharCode.apply(String, o);
    if (o.length < 2 * p + 2) throw "Cipher too short";
    var f = o.substr(1, p);
    var s = o.substr(p + 1);
    var q = $b1badb002678e3c8$var$oaep_mgf1_str(s, p, g);
    var k = [], h;
    for(h = 0; h < f.length; h += 1)k[h] = f.charCodeAt(h) ^ q.charCodeAt(h);
    var l = $b1badb002678e3c8$var$oaep_mgf1_str(String.fromCharCode.apply(String, k), o.length - p, g);
    var j = [];
    for(h = 0; h < s.length; h += 1)j[h] = s.charCodeAt(h) ^ l.charCodeAt(h);
    j = String.fromCharCode.apply(String, j);
    if (j.substr(0, p) !== g("")) throw "Hash mismatch";
    j = j.substr(p);
    var a = j.indexOf("\x01");
    var m = a != -1 ? j.substr(0, a).lastIndexOf("\x00") : -1;
    if (m + 1 != a) throw "Malformed data";
    return j.substr(a + 1);
}
function $b1badb002678e3c8$var$RSASetPrivate(c, a, b) {
    this.isPrivate = true;
    if (typeof c !== "string") {
        this.n = c;
        this.e = a;
        this.d = b;
    } else {
        if (c != null && a != null && c.length > 0 && a.length > 0) {
            this.n = $b1badb002678e3c8$var$parseBigInt(c, 16);
            this.e = parseInt(a, 16);
            this.d = $b1badb002678e3c8$var$parseBigInt(b, 16);
        } else throw "Invalid RSA private key";
    }
}
function $b1badb002678e3c8$var$RSASetPrivateEx(g, d, e, c, b, a, h, f) {
    this.isPrivate = true;
    this.isPublic = false;
    if (g == null) throw "RSASetPrivateEx N == null";
    if (d == null) throw "RSASetPrivateEx E == null";
    if (g.length == 0) throw "RSASetPrivateEx N.length == 0";
    if (d.length == 0) throw "RSASetPrivateEx E.length == 0";
    if (g != null && d != null && g.length > 0 && d.length > 0) {
        this.n = $b1badb002678e3c8$var$parseBigInt(g, 16);
        this.e = parseInt(d, 16);
        this.d = $b1badb002678e3c8$var$parseBigInt(e, 16);
        this.p = $b1badb002678e3c8$var$parseBigInt(c, 16);
        this.q = $b1badb002678e3c8$var$parseBigInt(b, 16);
        this.dmp1 = $b1badb002678e3c8$var$parseBigInt(a, 16);
        this.dmq1 = $b1badb002678e3c8$var$parseBigInt(h, 16);
        this.coeff = $b1badb002678e3c8$var$parseBigInt(f, 16);
    } else throw "Invalid RSA private key in RSASetPrivateEx";
}
function $b1badb002678e3c8$var$RSAGenerate(b, l) {
    var a = new $b1badb002678e3c8$var$SecureRandom();
    var g = b >> 1;
    this.e = parseInt(l, 16);
    var c = new $b1badb002678e3c8$var$BigInteger(l, 16);
    var d = b / 2 - 100;
    var k = $b1badb002678e3c8$var$BigInteger.ONE.shiftLeft(d);
    for(;;){
        for(;;){
            this.p = new $b1badb002678e3c8$var$BigInteger(b - g, 1, a);
            if (this.p.subtract($b1badb002678e3c8$var$BigInteger.ONE).gcd(c).compareTo($b1badb002678e3c8$var$BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) break;
        }
        for(;;){
            this.q = new $b1badb002678e3c8$var$BigInteger(g, 1, a);
            if (this.q.subtract($b1badb002678e3c8$var$BigInteger.ONE).gcd(c).compareTo($b1badb002678e3c8$var$BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) break;
        }
        if (this.p.compareTo(this.q) <= 0) {
            var j = this.p;
            this.p = this.q;
            this.q = j;
        }
        var h = this.q.subtract(this.p).abs();
        if (h.bitLength() < d || h.compareTo(k) <= 0) continue;
        var i = this.p.subtract($b1badb002678e3c8$var$BigInteger.ONE);
        var e = this.q.subtract($b1badb002678e3c8$var$BigInteger.ONE);
        var f = i.multiply(e);
        if (f.gcd(c).compareTo($b1badb002678e3c8$var$BigInteger.ONE) == 0) {
            this.n = this.p.multiply(this.q);
            if (this.n.bitLength() == b) {
                this.d = c.modInverse(f);
                this.dmp1 = this.d.mod(i);
                this.dmq1 = this.d.mod(e);
                this.coeff = this.q.modInverse(this.p);
                break;
            }
        }
    }
    this.isPrivate = true;
}
function $b1badb002678e3c8$var$RSADoPrivate(a) {
    if (this.p == null || this.q == null) return a.modPow(this.d, this.n);
    var c = a.mod(this.p).modPow(this.dmp1, this.p);
    var b = a.mod(this.q).modPow(this.dmq1, this.q);
    while(c.compareTo(b) < 0)c = c.add(this.p);
    return c.subtract(b).multiply(this.coeff).mod(this.p).multiply(this.q).add(b);
}
function $b1badb002678e3c8$var$RSADecrypt(b) {
    if (b.length != Math.ceil(this.n.bitLength() / 4)) throw new Error("wrong ctext length");
    var d = $b1badb002678e3c8$var$parseBigInt(b, 16);
    var a = this.doPrivate(d);
    if (a == null) return null;
    return $b1badb002678e3c8$var$pkcs1unpad2(a, this.n.bitLength() + 7 >> 3);
}
function $b1badb002678e3c8$var$RSADecryptOAEP(e, d, b) {
    if (e.length != Math.ceil(this.n.bitLength() / 4)) throw new Error("wrong ctext length");
    var f = $b1badb002678e3c8$var$parseBigInt(e, 16);
    var a = this.doPrivate(f);
    if (a == null) return null;
    return $b1badb002678e3c8$var$oaep_unpad(a, this.n.bitLength() + 7 >> 3, d, b);
}
$b1badb002678e3c8$var$RSAKey.prototype.doPrivate = $b1badb002678e3c8$var$RSADoPrivate;
$b1badb002678e3c8$var$RSAKey.prototype.setPrivate = $b1badb002678e3c8$var$RSASetPrivate;
$b1badb002678e3c8$var$RSAKey.prototype.setPrivateEx = $b1badb002678e3c8$var$RSASetPrivateEx;
$b1badb002678e3c8$var$RSAKey.prototype.generate = $b1badb002678e3c8$var$RSAGenerate;
$b1badb002678e3c8$var$RSAKey.prototype.decrypt = $b1badb002678e3c8$var$RSADecrypt;
$b1badb002678e3c8$var$RSAKey.prototype.decryptOAEP = $b1badb002678e3c8$var$RSADecryptOAEP;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */ function $b1badb002678e3c8$var$ECFieldElementFp(b, a) {
    this.x = a;
    this.q = b;
}
function $b1badb002678e3c8$var$feFpEquals(a) {
    if (a == this) return true;
    return this.q.equals(a.q) && this.x.equals(a.x);
}
function $b1badb002678e3c8$var$feFpToBigInteger() {
    return this.x;
}
function $b1badb002678e3c8$var$feFpNegate() {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.negate().mod(this.q));
}
function $b1badb002678e3c8$var$feFpAdd(a) {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.add(a.toBigInteger()).mod(this.q));
}
function $b1badb002678e3c8$var$feFpSubtract(a) {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.subtract(a.toBigInteger()).mod(this.q));
}
function $b1badb002678e3c8$var$feFpMultiply(a) {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.multiply(a.toBigInteger()).mod(this.q));
}
function $b1badb002678e3c8$var$feFpSquare() {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.square().mod(this.q));
}
function $b1badb002678e3c8$var$feFpDivide(a) {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.multiply(a.toBigInteger().modInverse(this.q)).mod(this.q));
}
$b1badb002678e3c8$var$ECFieldElementFp.prototype.equals = $b1badb002678e3c8$var$feFpEquals;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.toBigInteger = $b1badb002678e3c8$var$feFpToBigInteger;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.negate = $b1badb002678e3c8$var$feFpNegate;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.add = $b1badb002678e3c8$var$feFpAdd;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.subtract = $b1badb002678e3c8$var$feFpSubtract;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.multiply = $b1badb002678e3c8$var$feFpMultiply;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.square = $b1badb002678e3c8$var$feFpSquare;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.divide = $b1badb002678e3c8$var$feFpDivide;
$b1badb002678e3c8$var$ECFieldElementFp.prototype.sqrt = function() {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, this.x.sqrt().mod(this.q));
};
function $b1badb002678e3c8$var$ECPointFp(c, a, d, b) {
    this.curve = c;
    this.x = a;
    this.y = d;
    if (b == null) this.z = $b1badb002678e3c8$var$BigInteger.ONE;
    else this.z = b;
    this.zinv = null;
}
function $b1badb002678e3c8$var$pointFpGetX() {
    if (this.zinv == null) this.zinv = this.z.modInverse(this.curve.q);
    return this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
}
function $b1badb002678e3c8$var$pointFpGetY() {
    if (this.zinv == null) this.zinv = this.z.modInverse(this.curve.q);
    return this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
}
function $b1badb002678e3c8$var$pointFpEquals(a) {
    if (a == this) return true;
    if (this.isInfinity()) return a.isInfinity();
    if (a.isInfinity()) return this.isInfinity();
    var c, b;
    c = a.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(a.z)).mod(this.curve.q);
    if (!c.equals($b1badb002678e3c8$var$BigInteger.ZERO)) return false;
    b = a.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(a.z)).mod(this.curve.q);
    return b.equals($b1badb002678e3c8$var$BigInteger.ZERO);
}
function $b1badb002678e3c8$var$pointFpIsInfinity() {
    if (this.x == null && this.y == null) return true;
    return this.z.equals($b1badb002678e3c8$var$BigInteger.ZERO) && !this.y.toBigInteger().equals($b1badb002678e3c8$var$BigInteger.ZERO);
}
function $b1badb002678e3c8$var$pointFpNegate() {
    return new $b1badb002678e3c8$var$ECPointFp(this.curve, this.x, this.y.negate(), this.z);
}
function $b1badb002678e3c8$var$pointFpAdd(l) {
    if (this.isInfinity()) return l;
    if (l.isInfinity()) return this;
    var p = l.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(l.z)).mod(this.curve.q);
    var o = l.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(l.z)).mod(this.curve.q);
    if ($b1badb002678e3c8$var$BigInteger.ZERO.equals(o)) {
        if ($b1badb002678e3c8$var$BigInteger.ZERO.equals(p)) return this.twice();
        return this.curve.getInfinity();
    }
    var j = new $b1badb002678e3c8$var$BigInteger("3");
    var e = this.x.toBigInteger();
    var n = this.y.toBigInteger();
    var c = l.x.toBigInteger();
    var k = l.y.toBigInteger();
    var m = o.square();
    var i = m.multiply(o);
    var d = e.multiply(m);
    var g = p.square().multiply(this.z);
    var a = g.subtract(d.shiftLeft(1)).multiply(l.z).subtract(i).multiply(o).mod(this.curve.q);
    var h = d.multiply(j).multiply(p).subtract(n.multiply(i)).subtract(g.multiply(p)).multiply(l.z).add(p.multiply(i)).mod(this.curve.q);
    var f = i.multiply(this.z).multiply(l.z).mod(this.curve.q);
    return new $b1badb002678e3c8$var$ECPointFp(this.curve, this.curve.fromBigInteger(a), this.curve.fromBigInteger(h), f);
}
function $b1badb002678e3c8$var$pointFpTwice() {
    if (this.isInfinity()) return this;
    if (this.y.toBigInteger().signum() == 0) return this.curve.getInfinity();
    var g = new $b1badb002678e3c8$var$BigInteger("3");
    var c = this.x.toBigInteger();
    var h = this.y.toBigInteger();
    var e = h.multiply(this.z);
    var j = e.multiply(h).mod(this.curve.q);
    var i = this.curve.a.toBigInteger();
    var k = c.square().multiply(g);
    if (!$b1badb002678e3c8$var$BigInteger.ZERO.equals(i)) k = k.add(this.z.square().multiply(i));
    k = k.mod(this.curve.q);
    var b = k.square().subtract(c.shiftLeft(3).multiply(j)).shiftLeft(1).multiply(e).mod(this.curve.q);
    var f = k.multiply(g).multiply(c).subtract(j.shiftLeft(1)).shiftLeft(2).multiply(j).subtract(k.square().multiply(k)).mod(this.curve.q);
    var d = e.square().multiply(e).shiftLeft(3).mod(this.curve.q);
    return new $b1badb002678e3c8$var$ECPointFp(this.curve, this.curve.fromBigInteger(b), this.curve.fromBigInteger(f), d);
}
function $b1badb002678e3c8$var$pointFpMultiply(d) {
    if (this.isInfinity()) return this;
    if (d.signum() == 0) return this.curve.getInfinity();
    var m = d;
    var l = m.multiply(new $b1badb002678e3c8$var$BigInteger("3"));
    var b = this.negate();
    var j = this;
    var q = this.curve.q.subtract(d);
    var o = q.multiply(new $b1badb002678e3c8$var$BigInteger("3"));
    var c = new $b1badb002678e3c8$var$ECPointFp(this.curve, this.x, this.y);
    var a = c.negate();
    var g;
    for(g = l.bitLength() - 2; g > 0; --g){
        j = j.twice();
        var n = l.testBit(g);
        var f = m.testBit(g);
        if (n != f) j = j.add(n ? this : b);
    }
    for(g = o.bitLength() - 2; g > 0; --g){
        c = c.twice();
        var p = o.testBit(g);
        var r = q.testBit(g);
        if (p != r) c = c.add(p ? c : a);
    }
    return j;
}
function $b1badb002678e3c8$var$pointFpMultiplyTwo(c, a, b) {
    var d;
    if (c.bitLength() > b.bitLength()) d = c.bitLength() - 1;
    else d = b.bitLength() - 1;
    var f = this.curve.getInfinity();
    var e = this.add(a);
    while(d >= 0){
        f = f.twice();
        if (c.testBit(d)) {
            if (b.testBit(d)) f = f.add(e);
            else f = f.add(this);
        } else if (b.testBit(d)) f = f.add(a);
        --d;
    }
    return f;
}
$b1badb002678e3c8$var$ECPointFp.prototype.getX = $b1badb002678e3c8$var$pointFpGetX;
$b1badb002678e3c8$var$ECPointFp.prototype.getY = $b1badb002678e3c8$var$pointFpGetY;
$b1badb002678e3c8$var$ECPointFp.prototype.equals = $b1badb002678e3c8$var$pointFpEquals;
$b1badb002678e3c8$var$ECPointFp.prototype.isInfinity = $b1badb002678e3c8$var$pointFpIsInfinity;
$b1badb002678e3c8$var$ECPointFp.prototype.negate = $b1badb002678e3c8$var$pointFpNegate;
$b1badb002678e3c8$var$ECPointFp.prototype.add = $b1badb002678e3c8$var$pointFpAdd;
$b1badb002678e3c8$var$ECPointFp.prototype.twice = $b1badb002678e3c8$var$pointFpTwice;
$b1badb002678e3c8$var$ECPointFp.prototype.multiply = $b1badb002678e3c8$var$pointFpMultiply;
$b1badb002678e3c8$var$ECPointFp.prototype.multiplyTwo = $b1badb002678e3c8$var$pointFpMultiplyTwo;
function $b1badb002678e3c8$var$ECCurveFp(e, d, c) {
    this.q = e;
    this.a = this.fromBigInteger(d);
    this.b = this.fromBigInteger(c);
    this.infinity = new $b1badb002678e3c8$var$ECPointFp(this, null, null);
}
function $b1badb002678e3c8$var$curveFpGetQ() {
    return this.q;
}
function $b1badb002678e3c8$var$curveFpGetA() {
    return this.a;
}
function $b1badb002678e3c8$var$curveFpGetB() {
    return this.b;
}
function $b1badb002678e3c8$var$curveFpEquals(a) {
    if (a == this) return true;
    return this.q.equals(a.q) && this.a.equals(a.a) && this.b.equals(a.b);
}
function $b1badb002678e3c8$var$curveFpGetInfinity() {
    return this.infinity;
}
function $b1badb002678e3c8$var$curveFpFromBigInteger(a) {
    return new $b1badb002678e3c8$var$ECFieldElementFp(this.q, a);
}
function $b1badb002678e3c8$var$curveFpDecodePointHex(m) {
    switch(parseInt(m.substr(0, 2), 16)){
        case 0:
            return this.infinity;
        case 2:
        case 3:
            var c = m.substr(0, 2);
            var l = m.substr(2);
            var j = this.fromBigInteger(new $b1badb002678e3c8$var$BigInteger(k, 16));
            var i = this.getA();
            var h = this.getB();
            var e = j.square().add(i).multiply(j).add(h);
            var g = e.sqrt();
            if (c == "03") g = g.negate();
            return new $b1badb002678e3c8$var$ECPointFp(this, j, g);
        case 4:
        case 6:
        case 7:
            var d = (m.length - 2) / 2;
            var k = m.substr(2, d);
            var f = m.substr(d + 2, d);
            return new $b1badb002678e3c8$var$ECPointFp(this, this.fromBigInteger(new $b1badb002678e3c8$var$BigInteger(k, 16)), this.fromBigInteger(new $b1badb002678e3c8$var$BigInteger(f, 16)));
        default:
            return null;
    }
}
$b1badb002678e3c8$var$ECCurveFp.prototype.getQ = $b1badb002678e3c8$var$curveFpGetQ;
$b1badb002678e3c8$var$ECCurveFp.prototype.getA = $b1badb002678e3c8$var$curveFpGetA;
$b1badb002678e3c8$var$ECCurveFp.prototype.getB = $b1badb002678e3c8$var$curveFpGetB;
$b1badb002678e3c8$var$ECCurveFp.prototype.equals = $b1badb002678e3c8$var$curveFpEquals;
$b1badb002678e3c8$var$ECCurveFp.prototype.getInfinity = $b1badb002678e3c8$var$curveFpGetInfinity;
$b1badb002678e3c8$var$ECCurveFp.prototype.fromBigInteger = $b1badb002678e3c8$var$curveFpFromBigInteger;
$b1badb002678e3c8$var$ECCurveFp.prototype.decodePointHex = $b1badb002678e3c8$var$curveFpDecodePointHex;
/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
 */ $b1badb002678e3c8$var$ECFieldElementFp.prototype.getByteLength = function() {
    return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
};
$b1badb002678e3c8$var$ECPointFp.prototype.getEncoded = function(c) {
    var d = function(h, f) {
        var g = h.toByteArrayUnsigned();
        if (f < g.length) g = g.slice(g.length - f);
        else while(f > g.length)g.unshift(0);
        return g;
    };
    var a = this.getX().toBigInteger();
    var e = this.getY().toBigInteger();
    var b = d(a, 32);
    if (c) {
        if (e.isEven()) b.unshift(2);
        else b.unshift(3);
    } else {
        b.unshift(4);
        b = b.concat(d(e, 32));
    }
    return b;
};
$b1badb002678e3c8$var$ECPointFp.decodeFrom = function(g, c) {
    var f = c[0];
    var e = c.length - 1;
    var d = c.slice(1, 1 + e / 2);
    var b = c.slice(1 + e / 2, 1 + e);
    d.unshift(0);
    b.unshift(0);
    var a = new $b1badb002678e3c8$var$BigInteger(d);
    var h = new $b1badb002678e3c8$var$BigInteger(b);
    return new $b1badb002678e3c8$var$ECPointFp(g, g.fromBigInteger(a), g.fromBigInteger(h));
};
$b1badb002678e3c8$var$ECPointFp.decodeFromHex = function(g, c) {
    var f = c.substr(0, 2);
    var e = c.length - 2;
    var d = c.substr(2, e / 2);
    var b = c.substr(2 + e / 2, e / 2);
    var a = new $b1badb002678e3c8$var$BigInteger(d, 16);
    var h = new $b1badb002678e3c8$var$BigInteger(b, 16);
    return new $b1badb002678e3c8$var$ECPointFp(g, g.fromBigInteger(a), g.fromBigInteger(h));
};
$b1badb002678e3c8$var$ECPointFp.prototype.add2D = function(c) {
    if (this.isInfinity()) return c;
    if (c.isInfinity()) return this;
    if (this.x.equals(c.x)) {
        if (this.y.equals(c.y)) return this.twice();
        return this.curve.getInfinity();
    }
    var g = c.x.subtract(this.x);
    var e = c.y.subtract(this.y);
    var a = e.divide(g);
    var d = a.square().subtract(this.x).subtract(c.x);
    var f = a.multiply(this.x.subtract(d)).subtract(this.y);
    return new $b1badb002678e3c8$var$ECPointFp(this.curve, d, f);
};
$b1badb002678e3c8$var$ECPointFp.prototype.twice2D = function() {
    if (this.isInfinity()) return this;
    if (this.y.toBigInteger().signum() == 0) return this.curve.getInfinity();
    var b = this.curve.fromBigInteger($b1badb002678e3c8$var$BigInteger.valueOf(2));
    var e = this.curve.fromBigInteger($b1badb002678e3c8$var$BigInteger.valueOf(3));
    var a = this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(b));
    var c = a.square().subtract(this.x.multiply(b));
    var d = a.multiply(this.x.subtract(c)).subtract(this.y);
    return new $b1badb002678e3c8$var$ECPointFp(this.curve, c, d);
};
$b1badb002678e3c8$var$ECPointFp.prototype.multiply2D = function(b) {
    if (this.isInfinity()) return this;
    if (b.signum() == 0) return this.curve.getInfinity();
    var g = b;
    var f = g.multiply(new $b1badb002678e3c8$var$BigInteger("3"));
    var l = this.negate();
    var d = this;
    var c;
    for(c = f.bitLength() - 2; c > 0; --c){
        d = d.twice();
        var a = f.testBit(c);
        var j = g.testBit(c);
        if (a != j) d = d.add2D(a ? this : l);
    }
    return d;
};
$b1badb002678e3c8$var$ECPointFp.prototype.isOnCurve = function() {
    var d = this.getX().toBigInteger();
    var i = this.getY().toBigInteger();
    var f = this.curve.getA().toBigInteger();
    var c = this.curve.getB().toBigInteger();
    var h = this.curve.getQ();
    var e = i.multiply(i).mod(h);
    var g = d.multiply(d).multiply(d).add(f.multiply(d)).add(c).mod(h);
    return e.equals(g);
};
$b1badb002678e3c8$var$ECPointFp.prototype.toString = function() {
    return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")";
};
$b1badb002678e3c8$var$ECPointFp.prototype.validate = function() {
    var c = this.curve.getQ();
    if (this.isInfinity()) throw new Error("Point is at infinity.");
    var a = this.getX().toBigInteger();
    var b = this.getY().toBigInteger();
    if (a.compareTo($b1badb002678e3c8$var$BigInteger.ONE) < 0 || a.compareTo(c.subtract($b1badb002678e3c8$var$BigInteger.ONE)) > 0) throw new Error("x coordinate out of bounds");
    if (b.compareTo($b1badb002678e3c8$var$BigInteger.ONE) < 0 || b.compareTo(c.subtract($b1badb002678e3c8$var$BigInteger.ONE)) > 0) throw new Error("y coordinate out of bounds");
    if (!this.isOnCurve()) throw new Error("Point is not on the curve.");
    if (this.multiply(c).isInfinity()) throw new Error("Point is not a scalar multiple of G.");
    return true;
};
/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
 */ var $b1badb002678e3c8$var$jsonParse = function() {
    var e = "(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)";
    var j = '(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))';
    var i = '(?:"' + j + '*")';
    var d = new RegExp("(?:false|true|null|[\\{\\}\\[\\]]|" + e + "|" + i + ")", "g");
    var k = new RegExp("\\\\(?:([^u])|u(.{4}))", "g");
    var g = {
        '"': '"',
        "/": "/",
        "\\": "\\",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "	"
    };
    function h(l, m, n) {
        return m ? g[m] : String.fromCharCode(parseInt(n, 16));
    }
    var c = new String("");
    var a = "\\";
    var f = {
        "{": Object,
        "[": Array
    };
    var b = Object.hasOwnProperty;
    return function(u, q) {
        var p = u.match(d);
        var x;
        var v = p[0];
        var l = false;
        if ("{" === v) x = {};
        else if ("[" === v) x = [];
        else {
            x = [];
            l = true;
        }
        var t;
        var r = [
            x
        ];
        for(var o = 1 - l, m = p.length; o < m; ++o){
            v = p[o];
            var w;
            switch(v.charCodeAt(0)){
                default:
                    w = r[0];
                    w[t || w.length] = +v;
                    t = void 0;
                    break;
                case 34:
                    v = v.substring(1, v.length - 1);
                    if (v.indexOf(a) !== -1) v = v.replace(k, h);
                    w = r[0];
                    if (!t) {
                        if (w instanceof Array) t = w.length;
                        else {
                            t = v || c;
                            break;
                        }
                    }
                    w[t] = v;
                    t = void 0;
                    break;
                case 91:
                    w = r[0];
                    r.unshift(w[t || w.length] = []);
                    t = void 0;
                    break;
                case 93:
                    r.shift();
                    break;
                case 102:
                    w = r[0];
                    w[t || w.length] = false;
                    t = void 0;
                    break;
                case 110:
                    w = r[0];
                    w[t || w.length] = null;
                    t = void 0;
                    break;
                case 116:
                    w = r[0];
                    w[t || w.length] = true;
                    t = void 0;
                    break;
                case 123:
                    w = r[0];
                    r.unshift(w[t || w.length] = {});
                    t = void 0;
                    break;
                case 125:
                    r.shift();
                    break;
            }
        }
        if (l) {
            if (r.length !== 1) throw new Error();
            x = x[0];
        } else {
            if (r.length) throw new Error();
        }
        if (q) {
            var s = function(C, B) {
                var D = C[B];
                if (D && typeof D === "object") {
                    var n = null;
                    for(var z in D)if (b.call(D, z) && D !== C) {
                        var y = s(D, z);
                        if (y !== void 0) D[z] = y;
                        else {
                            if (!n) n = [];
                            n.push(z);
                        }
                    }
                    if (n) for(var A = n.length; --A >= 0;)delete D[n[A]];
                }
                return q.call(C, B, D);
            };
            x = s({
                "": x
            }, "");
        }
        return x;
    };
}();
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1) $b1badb002678e3c8$var$KJUR.asn1 = {};
$b1badb002678e3c8$var$KJUR.asn1.ASN1Util = new function() {
    this.integerToByteHex = function(a) {
        var b = a.toString(16);
        if (b.length % 2 == 1) b = "0" + b;
        return b;
    };
    this.bigIntToMinTwosComplementsHex = function(j) {
        var f = j.toString(16);
        if (f.substr(0, 1) != "-") {
            if (f.length % 2 == 1) f = "0" + f;
            else if (!f.match(/^[0-7]/)) f = "00" + f;
        } else {
            var a = f.substr(1);
            var e = a.length;
            if (e % 2 == 1) e += 1;
            else if (!f.match(/^[0-7]/)) e += 2;
            var g = "";
            for(var d = 0; d < e; d++)g += "f";
            var c = new $b1badb002678e3c8$var$BigInteger(g, 16);
            var b = c.xor(j).add($b1badb002678e3c8$var$BigInteger.ONE);
            f = b.toString(16).replace(/^-/, "");
        }
        return f;
    };
    this.getPEMStringFromHex = function(a, b) {
        return $b1badb002678e3c8$var$hextopem(a, b);
    };
    this.newObject = function(k) {
        var F = $b1badb002678e3c8$var$KJUR, o = F.asn1, v = o.ASN1Object, B = o.DERBoolean, e = o.DERInteger, t = o.DERBitString, h = o.DEROctetString, x = o.DERNull, y = o.DERObjectIdentifier, m = o.DEREnumerated, g = o.DERUTF8String, f = o.DERNumericString, A = o.DERPrintableString, w = o.DERTeletexString, q = o.DERIA5String, E = o.DERUTCTime, j = o.DERGeneralizedTime, b = o.DERVisibleString, l = o.DERBMPString, n = o.DERSequence, c = o.DERSet, s = o.DERTaggedObject, p = o.ASN1Util.newObject;
        if (k instanceof o.ASN1Object) return k;
        var u = Object.keys(k);
        if (u.length != 1) throw new Error("key of param shall be only one.");
        var H = u[0];
        if (":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":" + H + ":") == -1) throw new Error("undefined key: " + H);
        if (H == "bool") return new B(k[H]);
        if (H == "int") return new e(k[H]);
        if (H == "bitstr") return new t(k[H]);
        if (H == "octstr") return new h(k[H]);
        if (H == "null") return new x(k[H]);
        if (H == "oid") return new y(k[H]);
        if (H == "enum") return new m(k[H]);
        if (H == "utf8str") return new g(k[H]);
        if (H == "numstr") return new f(k[H]);
        if (H == "prnstr") return new A(k[H]);
        if (H == "telstr") return new w(k[H]);
        if (H == "ia5str") return new q(k[H]);
        if (H == "utctime") return new E(k[H]);
        if (H == "gentime") return new j(k[H]);
        if (H == "visstr") return new b(k[H]);
        if (H == "bmpstr") return new l(k[H]);
        if (H == "asn1") return new v(k[H]);
        if (H == "seq") {
            var d = k[H];
            var G = [];
            for(var z = 0; z < d.length; z++){
                var D = p(d[z]);
                G.push(D);
            }
            return new n({
                array: G
            });
        }
        if (H == "set") {
            var d = k[H];
            var G = [];
            for(var z = 0; z < d.length; z++){
                var D = p(d[z]);
                G.push(D);
            }
            return new c({
                array: G
            });
        }
        if (H == "tag") {
            var C = k[H];
            if (Object.prototype.toString.call(C) === "[object Array]" && C.length == 3) {
                var r = p(C[2]);
                return new s({
                    tag: C[0],
                    explicit: C[1],
                    obj: r
                });
            } else return new s(C);
        }
    };
    this.jsonToASN1HEX = function(b) {
        var a = this.newObject(b);
        return a.tohex();
    };
};
$b1badb002678e3c8$var$KJUR.asn1.ASN1Util.oidHexToInt = function(a) {
    var j = "";
    var k = parseInt(a.substr(0, 2), 16);
    var d = Math.floor(k / 40);
    var c = k % 40;
    var j = d + "." + c;
    var e = "";
    for(var f = 2; f < a.length; f += 2){
        var g = parseInt(a.substr(f, 2), 16);
        var h = ("00000000" + g.toString(2)).slice(-8);
        e = e + h.substr(1, 7);
        if (h.substr(0, 1) == "0") {
            var b = new $b1badb002678e3c8$var$BigInteger(e, 2);
            j = j + "." + b.toString(10);
            e = "";
        }
    }
    return j;
};
$b1badb002678e3c8$var$KJUR.asn1.ASN1Util.oidIntToHex = function(f) {
    var e = function(a) {
        var k = a.toString(16);
        if (k.length == 1) k = "0" + k;
        return k;
    };
    var d = function(o) {
        var n = "";
        var k = new $b1badb002678e3c8$var$BigInteger(o, 10);
        var a = k.toString(2);
        var l = 7 - a.length % 7;
        if (l == 7) l = 0;
        var q = "";
        for(var m = 0; m < l; m++)q += "0";
        a = q + a;
        for(var m = 0; m < a.length - 1; m += 7){
            var p = a.substr(m, 7);
            if (m != a.length - 7) p = "1" + p;
            n += e(parseInt(p, 2));
        }
        return n;
    };
    if (!f.match(/^[0-9.]+$/)) throw "malformed oid string: " + f;
    var g = "";
    var b = f.split(".");
    var j = parseInt(b[0]) * 40 + parseInt(b[1]);
    g += e(j);
    b.splice(0, 2);
    for(var c = 0; c < b.length; c++)g += d(b[c]);
    return g;
};
$b1badb002678e3c8$var$KJUR.asn1.ASN1Object = function(e) {
    var c = true;
    var b = null;
    var d = "00";
    var f = "00";
    var a = "";
    this.params = null;
    this.getLengthHexFromValue = function() {
        if (typeof this.hV == "undefined" || this.hV == null) throw new Error("this.hV is null or undefined");
        if (this.hV.length % 2 == 1) throw new Error("value hex must be even length: n=" + a.length + ",v=" + this.hV);
        var j = this.hV.length / 2;
        var i = j.toString(16);
        if (i.length % 2 == 1) i = "0" + i;
        if (j < 128) return i;
        else {
            var h = i.length / 2;
            if (h > 15) throw new Error("ASN.1 length too long to represent by 8x: n = " + j.toString(16));
            var g = 128 + h;
            return g.toString(16) + i;
        }
    };
    this.tohex = function() {
        if (this.hTLV == null || this.isModified) {
            this.hV = this.getFreshValueHex();
            this.hL = this.getLengthHexFromValue();
            this.hTLV = this.hT + this.hL + this.hV;
            this.isModified = false;
        }
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.getValueHex = function() {
        this.tohex();
        return this.hV;
    };
    this.getFreshValueHex = function() {
        return "";
    };
    this.setByParam = function(g) {
        this.params = g;
    };
    if (e != undefined) {
        if (e.tlv != undefined) {
            this.hTLV = e.tlv;
            this.isModified = false;
        }
    }
};
$b1badb002678e3c8$var$KJUR.asn1.DERAbstractString = function(c) {
    $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    var b = null;
    var a = null;
    this.getString = function() {
        return this.s;
    };
    this.setString = function(d) {
        this.hTLV = null;
        this.isModified = true;
        this.s = d;
        this.hV = $b1badb002678e3c8$var$utf8tohex(this.s).toLowerCase();
    };
    this.setStringHex = function(d) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = d;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof c != "undefined") {
        if (typeof c == "string") this.setString(c);
        else {
            if (typeof c.str != "undefined") this.setString(c.str);
            else if (typeof c.hex != "undefined") this.setStringHex(c.hex);
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERAbstractString, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERAbstractTime = function(c) {
    $b1badb002678e3c8$var$KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);
    var b = null;
    var a = null;
    this.localDateToUTC = function(g) {
        var e = g.getTime() + g.getTimezoneOffset() * 60000;
        var f = new Date(e);
        return f;
    };
    this.formatDate = function(m, o, e) {
        var g = this.zeroPadding;
        var n = this.localDateToUTC(m);
        var p = String(n.getFullYear());
        if (o == "utc") p = p.substr(2, 2);
        var l = g(String(n.getMonth() + 1), 2);
        var q = g(String(n.getDate()), 2);
        var h = g(String(n.getHours()), 2);
        var i = g(String(n.getMinutes()), 2);
        var j = g(String(n.getSeconds()), 2);
        var r = p + l + q + h + i + j;
        if (e === true) {
            var f = n.getMilliseconds();
            if (f != 0) {
                var k = g(String(f), 3);
                k = k.replace(/[0]+$/, "");
                r = r + "." + k;
            }
        }
        return r + "Z";
    };
    this.zeroPadding = function(e, d) {
        if (e.length >= d) return e;
        return new Array(d - e.length + 1).join("0") + e;
    };
    this.setByParam = function(d) {
        this.hV = null;
        this.hTLV = null;
        this.params = d;
    };
    this.getString = function() {
        return undefined;
    };
    this.setString = function(d) {
        this.hTLV = null;
        this.isModified = true;
        if (this.params == undefined) this.params = {};
        this.params.str = d;
    };
    this.setByDate = function(d) {
        this.hTLV = null;
        this.isModified = true;
        if (this.params == undefined) this.params = {};
        this.params.date = d;
    };
    this.setByDateValue = function(h, j, e, d, f, g) {
        var i = new Date(Date.UTC(h, j - 1, e, d, f, g, 0));
        this.setByDate(i);
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERAbstractTime, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERAbstractStructured = function(b) {
    $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    var a = null;
    this.setByASN1ObjectArray = function(c) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array = c;
    };
    this.appendASN1Object = function(c) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array.push(c);
    };
    this.asn1Array = new Array();
    if (typeof b != "undefined") {
        if (typeof b.array != "undefined") this.asn1Array = b.array;
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERAbstractStructured, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERBoolean = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = "01";
    if (a == false) this.hTLV = "010100";
    else this.hTLV = "0101ff";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERBoolean, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERInteger = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = "02";
    this.setByBigInteger = function(b) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(b);
    };
    this.setByInteger = function(c) {
        var b = new $b1badb002678e3c8$var$BigInteger(String(c), 10);
        this.setByBigInteger(b);
    };
    this.setValueHex = function(b) {
        this.hV = b;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof a != "undefined") {
        if (typeof a.bigint != "undefined") this.setByBigInteger(a.bigint);
        else if (typeof a["int"] != "undefined") this.setByInteger(a["int"]);
        else {
            if (typeof a == "number") this.setByInteger(a);
            else if (typeof a.hex != "undefined") this.setValueHex(a.hex);
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERInteger, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERBitString = function(b) {
    if (b !== undefined && typeof b.obj !== "undefined") {
        var a = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.newObject(b.obj);
        b.hex = "00" + a.tohex();
    }
    $b1badb002678e3c8$var$KJUR.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = "03";
    this.setHexValueIncludingUnusedBits = function(c) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = c;
    };
    this.setUnusedBitsAndHexValue = function(c, e) {
        if (c < 0 || 7 < c) throw "unused bits shall be from 0 to 7: u = " + c;
        var d = "0" + c;
        this.hTLV = null;
        this.isModified = true;
        this.hV = d + e;
    };
    this.setByBinaryString = function(e) {
        e = e.replace(/0+$/, "");
        var f = 8 - e.length % 8;
        if (f == 8) f = 0;
        e += "0000000".substr(0, f);
        var j = "";
        for(var g = 0; g < e.length - 1; g += 8){
            var d = e.substr(g, 8);
            var c = parseInt(d, 2).toString(16);
            if (c.length == 1) c = "0" + c;
            j += c;
        }
        this.hTLV = null;
        this.isModified = true;
        this.hV = "0" + f + j;
    };
    this.setByBooleanArray = function(e) {
        var d = "";
        for(var c = 0; c < e.length; c++)if (e[c] == true) d += "1";
        else d += "0";
        this.setByBinaryString(d);
    };
    this.newFalseArray = function(e) {
        var c = new Array(e);
        for(var d = 0; d < e; d++)c[d] = false;
        return c;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof b != "undefined") {
        if (typeof b == "string" && b.toLowerCase().match(/^[0-9a-f]+$/)) this.setHexValueIncludingUnusedBits(b);
        else if (typeof b.hex != "undefined") this.setHexValueIncludingUnusedBits(b.hex);
        else {
            if (typeof b.bin != "undefined") this.setByBinaryString(b.bin);
            else if (typeof b.array != "undefined") this.setByBooleanArray(b.array);
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERBitString, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DEROctetString = function(b) {
    if (b !== undefined && typeof b.obj !== "undefined") {
        var a = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.newObject(b.obj);
        b.hex = a.tohex();
    }
    $b1badb002678e3c8$var$KJUR.asn1.DEROctetString.superclass.constructor.call(this, b);
    this.hT = "04";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DEROctetString, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERNull = function() {
    $b1badb002678e3c8$var$KJUR.asn1.DERNull.superclass.constructor.call(this);
    this.hT = "05";
    this.hTLV = "0500";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERNull, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERObjectIdentifier = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = "06";
    this.setValueHex = function(b) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = b;
    };
    this.setValueOidString = function(b) {
        var c = $b1badb002678e3c8$var$oidtohex(b);
        if (c == null) throw new Error("malformed oid string: " + b);
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = c;
    };
    this.setValueName = function(c) {
        var b = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.name2oid(c);
        if (b !== "") this.setValueOidString(b);
        else throw new Error("DERObjectIdentifier oidName undefined: " + c);
    };
    this.setValueNameOrOid = function(b) {
        if (b.match(/^[0-2].[0-9.]+$/)) this.setValueOidString(b);
        else this.setValueName(b);
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    this.setByParam = function(b) {
        if (typeof b === "string") this.setValueNameOrOid(b);
        else if (b.oid !== undefined) this.setValueNameOrOid(b.oid);
        else {
            if (b.name !== undefined) this.setValueNameOrOid(b.name);
            else if (b.hex !== undefined) this.setValueHex(b.hex);
        }
    };
    if (a !== undefined) this.setByParam(a);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERObjectIdentifier, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DEREnumerated = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DEREnumerated.superclass.constructor.call(this);
    this.hT = "0a";
    this.setByBigInteger = function(b) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(b);
    };
    this.setByInteger = function(c) {
        var b = new $b1badb002678e3c8$var$BigInteger(String(c), 10);
        this.setByBigInteger(b);
    };
    this.setValueHex = function(b) {
        this.hV = b;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof a != "undefined") {
        if (typeof a["int"] != "undefined") this.setByInteger(a["int"]);
        else {
            if (typeof a == "number") this.setByInteger(a);
            else if (typeof a.hex != "undefined") this.setValueHex(a.hex);
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DEREnumerated, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.DERUTF8String = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERUTF8String.superclass.constructor.call(this, a);
    this.hT = "0c";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERUTF8String, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERNumericString = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERNumericString.superclass.constructor.call(this, a);
    this.hT = "12";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERNumericString, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERPrintableString = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERPrintableString.superclass.constructor.call(this, a);
    this.hT = "13";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERPrintableString, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERTeletexString = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERTeletexString.superclass.constructor.call(this, a);
    this.hT = "14";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERTeletexString, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERIA5String = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERIA5String.superclass.constructor.call(this, a);
    this.hT = "16";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERIA5String, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERVisibleString = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERIA5String.superclass.constructor.call(this, a);
    this.hT = "1a";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERVisibleString, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERBMPString = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERBMPString.superclass.constructor.call(this, a);
    this.hT = "1e";
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERBMPString, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.DERUTCTime = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERUTCTime.superclass.constructor.call(this, a);
    this.hT = "17";
    this.params = undefined;
    this.getFreshValueHex = function() {
        var d = this.params;
        if (this.params == undefined) d = {
            date: new Date()
        };
        if (typeof d == "string") {
            if (d.match(/^[0-9]{12}Z$/) || d.match(/^[0-9]{12}\.[0-9]+Z$/)) this.hV = $b1badb002678e3c8$var$stohex(d);
            else throw new Error("malformed string for UTCTime: " + d);
        } else {
            if (d.str != undefined) this.hV = $b1badb002678e3c8$var$stohex(d.str);
            else if (d.date == undefined && d.millis == true) {
                var c = new Date();
                this.hV = $b1badb002678e3c8$var$stohex(this.formatDate(c, "utc", true));
            } else {
                if (d.date != undefined && d.date instanceof Date) {
                    var b = d.millis === true;
                    this.hV = $b1badb002678e3c8$var$stohex(this.formatDate(d.date, "utc", b));
                } else if (d instanceof Date) this.hV = $b1badb002678e3c8$var$stohex(this.formatDate(d, "utc"));
            }
        }
        if (this.hV == undefined) throw new Error("parameter not specified properly for UTCTime");
        return this.hV;
    };
    if (a != undefined) this.setByParam(a);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERUTCTime, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractTime);
$b1badb002678e3c8$var$KJUR.asn1.DERGeneralizedTime = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, a);
    this.hT = "18";
    this.params = a;
    this.getFreshValueHex = function() {
        var d = this.params;
        if (this.params == undefined) d = {
            date: new Date()
        };
        if (typeof d == "string") {
            if (d.match(/^[0-9]{14}Z$/) || d.match(/^[0-9]{14}\.[0-9]+Z$/)) this.hV = $b1badb002678e3c8$var$stohex(d);
            else throw new Error("malformed string for GeneralizedTime: " + d);
        } else {
            if (d.str != undefined) this.hV = $b1badb002678e3c8$var$stohex(d.str);
            else if (d.date == undefined && d.millis == true) {
                var c = new Date();
                this.hV = $b1badb002678e3c8$var$stohex(this.formatDate(c, "gen", true));
            } else {
                if (d.date != undefined && d.date instanceof Date) {
                    var b = d.millis === true;
                    this.hV = $b1badb002678e3c8$var$stohex(this.formatDate(d.date, "gen", b));
                } else if (d instanceof Date) this.hV = $b1badb002678e3c8$var$stohex(this.formatDate(d, "gen"));
            }
        }
        if (this.hV == undefined) throw new Error("parameter not specified properly for GeneralizedTime");
        return this.hV;
    };
    if (a != undefined) this.setByParam(a);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERGeneralizedTime, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractTime);
$b1badb002678e3c8$var$KJUR.asn1.DERSequence = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERSequence.superclass.constructor.call(this, a);
    this.hT = "30";
    this.getFreshValueHex = function() {
        var c = "";
        for(var b = 0; b < this.asn1Array.length; b++){
            var d = this.asn1Array[b];
            c += d.tohex();
        }
        this.hV = c;
        return this.hV;
    };
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERSequence, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractStructured);
$b1badb002678e3c8$var$KJUR.asn1.DERSet = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.DERSet.superclass.constructor.call(this, a);
    this.hT = "31";
    this.sortFlag = true;
    this.getFreshValueHex = function() {
        var b = new Array();
        for(var c = 0; c < this.asn1Array.length; c++){
            var d = this.asn1Array[c];
            b.push(d.tohex());
        }
        if (this.sortFlag == true) b.sort();
        this.hV = b.join("");
        return this.hV;
    };
    if (typeof a != "undefined") {
        if (typeof a.sortflag != "undefined" && a.sortflag == false) this.sortFlag = false;
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERSet, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractStructured);
$b1badb002678e3c8$var$KJUR.asn1.DERTaggedObject = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
    var d = $b1badb002678e3c8$var$KJUR.asn1, e = $b1badb002678e3c8$var$ASN1HEX, a = e.getV, c = e.isASN1HEX, b = d.ASN1Util.newObject;
    this.hT = "a0";
    this.hV = "";
    this.isExplicit = true;
    this.asn1Object = null;
    this.params = {
        tag: "a0",
        explicit: true
    };
    this.setASN1Object = function(g, h, i) {
        this.params = {
            tag: h,
            explicit: g,
            obj: i
        };
    };
    this.getFreshValueHex = function() {
        var h = this.params;
        if (h.explicit == undefined) h.explicit = true;
        if (h.tage != undefined) {
            h.tag = h.tage;
            h.explicit = true;
        }
        if (h.tagi != undefined) {
            h.tag = h.tagi;
            h.explicit = false;
        }
        if (h.str != undefined) this.hV = $b1badb002678e3c8$var$utf8tohex(h.str);
        else if (h.hex != undefined) this.hV = h.hex;
        else {
            if (h.obj != undefined) {
                var g;
                if (h.obj instanceof d.ASN1Object) g = h.obj.tohex();
                else if (typeof h.obj == "object") g = b(h.obj).tohex();
                if (h.explicit) this.hV = g;
                else this.hV = a(g, 0);
            } else throw new Error("str, hex nor obj not specified");
        }
        if (h.tag == undefined) h.tag = "a0";
        this.hT = h.tag;
        this.hTLV = null;
        this.isModified = true;
        return this.hV;
    };
    this.setByParam = function(g) {
        this.params = g;
    };
    if (f !== undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.DERTaggedObject, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
var $b1badb002678e3c8$var$ASN1HEX = new function() {};
$b1badb002678e3c8$var$ASN1HEX.getLblen = function(c, a) {
    if (c.substr(a + 2, 1) != "8") return 1;
    var b = parseInt(c.substr(a + 3, 1));
    if (b == 0) return -1;
    if (0 < b && b < 10) return b + 1;
    return -2;
};
$b1badb002678e3c8$var$ASN1HEX.getL = function(c, b) {
    var a = $b1badb002678e3c8$var$ASN1HEX.getLblen(c, b);
    if (a < 1) return "";
    return c.substr(b + 2, a * 2);
};
$b1badb002678e3c8$var$ASN1HEX.getVblen = function(d, a) {
    var c, b;
    c = $b1badb002678e3c8$var$ASN1HEX.getL(d, a);
    if (c == "") return -1;
    if (c.substr(0, 1) === "8") b = new $b1badb002678e3c8$var$BigInteger(c.substr(2), 16);
    else b = new $b1badb002678e3c8$var$BigInteger(c, 16);
    return b.intValue();
};
$b1badb002678e3c8$var$ASN1HEX.getVidx = function(c, b) {
    var a = $b1badb002678e3c8$var$ASN1HEX.getLblen(c, b);
    if (a < 0) return a;
    return b + (a + 1) * 2;
};
$b1badb002678e3c8$var$ASN1HEX.getV = function(d, a) {
    var c = $b1badb002678e3c8$var$ASN1HEX.getVidx(d, a);
    var b = $b1badb002678e3c8$var$ASN1HEX.getVblen(d, a);
    return d.substr(c, b * 2);
};
$b1badb002678e3c8$var$ASN1HEX.getTLV = function(b, a) {
    return b.substr(a, 2) + $b1badb002678e3c8$var$ASN1HEX.getL(b, a) + $b1badb002678e3c8$var$ASN1HEX.getV(b, a);
};
$b1badb002678e3c8$var$ASN1HEX.getTLVblen = function(b, a) {
    return 2 + $b1badb002678e3c8$var$ASN1HEX.getLblen(b, a) * 2 + $b1badb002678e3c8$var$ASN1HEX.getVblen(b, a) * 2;
};
$b1badb002678e3c8$var$ASN1HEX.getNextSiblingIdx = function(d, a) {
    var c = $b1badb002678e3c8$var$ASN1HEX.getVidx(d, a);
    var b = $b1badb002678e3c8$var$ASN1HEX.getVblen(d, a);
    return c + b * 2;
};
$b1badb002678e3c8$var$ASN1HEX.getChildIdx = function(e, k) {
    var l = $b1badb002678e3c8$var$ASN1HEX;
    var j = [];
    var c, f, g;
    c = l.getVidx(e, k);
    f = l.getVblen(e, k) * 2;
    if (e.substr(k, 2) == "03") {
        c += 2;
        f -= 2;
    }
    g = 0;
    var d = c;
    while(g <= f){
        var b = l.getTLVblen(e, d);
        g += b;
        if (g <= f) j.push(d);
        d += b;
        if (g >= f) break;
    }
    return j;
};
$b1badb002678e3c8$var$ASN1HEX.getNthChildIdx = function(d, b, e) {
    var c = $b1badb002678e3c8$var$ASN1HEX.getChildIdx(d, b);
    return c[e];
};
$b1badb002678e3c8$var$ASN1HEX.getIdxbyList = function(e, d, c, i) {
    var g = $b1badb002678e3c8$var$ASN1HEX;
    var f, b;
    if (c.length == 0) {
        if (i !== undefined) {
            if (e.substr(d, 2) !== i) return -1;
        }
        return d;
    }
    f = c.shift();
    b = g.getChildIdx(e, d);
    if (f >= b.length) return -1;
    return g.getIdxbyList(e, b[f], c, i);
};
$b1badb002678e3c8$var$ASN1HEX.getIdxbyListEx = function(f, k, b, g) {
    var m = $b1badb002678e3c8$var$ASN1HEX;
    var d, l;
    if (b.length == 0) {
        if (g !== undefined) {
            if (f.substr(k, 2) !== g) return -1;
        }
        return k;
    }
    d = b.shift();
    l = m.getChildIdx(f, k);
    var j = 0;
    for(var e = 0; e < l.length; e++){
        var c = f.substr(l[e], 2);
        if (typeof d == "number" && !m.isContextTag(c) && j == d || typeof d == "string" && m.isContextTag(c, d)) return m.getIdxbyListEx(f, l[e], b, g);
        if (!m.isContextTag(c)) j++;
    }
    return -1;
};
$b1badb002678e3c8$var$ASN1HEX.getTLVbyList = function(d, c, b, f) {
    var e = $b1badb002678e3c8$var$ASN1HEX;
    var a = e.getIdxbyList(d, c, b, f);
    if (a == -1) return null;
    if (a >= d.length) return null;
    return e.getTLV(d, a);
};
$b1badb002678e3c8$var$ASN1HEX.getTLVbyListEx = function(d, c, b, f) {
    var e = $b1badb002678e3c8$var$ASN1HEX;
    var a = e.getIdxbyListEx(d, c, b, f);
    if (a == -1) return null;
    return e.getTLV(d, a);
};
$b1badb002678e3c8$var$ASN1HEX.getVbyList = function(e, c, b, g, i) {
    var f = $b1badb002678e3c8$var$ASN1HEX;
    var a, d;
    a = f.getIdxbyList(e, c, b, g);
    if (a == -1) return null;
    if (a >= e.length) return null;
    d = f.getV(e, a);
    if (i === true) d = d.substr(2);
    return d;
};
$b1badb002678e3c8$var$ASN1HEX.getVbyListEx = function(b, e, a, d, f) {
    var j = $b1badb002678e3c8$var$ASN1HEX;
    var g, c, i;
    g = j.getIdxbyListEx(b, e, a, d);
    if (g == -1) return null;
    i = j.getV(b, g);
    if (b.substr(g, 2) == "03" && f !== false) i = i.substr(2);
    return i;
};
$b1badb002678e3c8$var$ASN1HEX.getInt = function(e, b, f) {
    if (f == undefined) f = -1;
    try {
        var c = e.substr(b, 2);
        if (c != "02" && c != "03") return f;
        var a = $b1badb002678e3c8$var$ASN1HEX.getV(e, b);
        if (c == "02") return parseInt(a, 16);
        else return $b1badb002678e3c8$var$bitstrtoint(a);
    } catch (d) {
        return f;
    }
};
$b1badb002678e3c8$var$ASN1HEX.getOID = function(c, a, d) {
    if (d == undefined) d = null;
    try {
        if (c.substr(a, 2) != "06") return d;
        var e = $b1badb002678e3c8$var$ASN1HEX.getV(c, a);
        return $b1badb002678e3c8$var$hextooid(e);
    } catch (b) {
        return d;
    }
};
$b1badb002678e3c8$var$ASN1HEX.getOIDName = function(d, a, f) {
    if (f == undefined) f = null;
    try {
        var e = $b1badb002678e3c8$var$ASN1HEX.getOID(d, a, f);
        if (e == f) return f;
        var b = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name(e);
        if (b == "") return e;
        return b;
    } catch (c) {
        return f;
    }
};
$b1badb002678e3c8$var$ASN1HEX.getString = function(d, b, e) {
    if (e == undefined) e = null;
    try {
        var a = $b1badb002678e3c8$var$ASN1HEX.getV(d, b);
        return $b1badb002678e3c8$var$hextorstr(a);
    } catch (c) {
        return e;
    }
};
$b1badb002678e3c8$var$ASN1HEX.hextooidstr = function(e) {
    var h = function(b, a) {
        if (b.length >= a) return b;
        return new Array(a - b.length + 1).join("0") + b;
    };
    var l = [];
    var o = e.substr(0, 2);
    var f = parseInt(o, 16);
    l[0] = new String(Math.floor(f / 40));
    l[1] = new String(f % 40);
    var m = e.substr(2);
    var k = [];
    for(var g = 0; g < m.length / 2; g++)k.push(parseInt(m.substr(g * 2, 2), 16));
    var j = [];
    var d = "";
    for(var g = 0; g < k.length; g++)if (k[g] & 128) d = d + h((k[g] & 127).toString(2), 7);
    else {
        d = d + h((k[g] & 127).toString(2), 7);
        j.push(new String(parseInt(d, 2)));
        d = "";
    }
    var n = l.join(".");
    if (j.length > 0) n = n + "." + j.join(".");
    return n;
};
$b1badb002678e3c8$var$ASN1HEX.dump = function(t, c, l, g) {
    var p = $b1badb002678e3c8$var$ASN1HEX;
    var j = p.getV;
    var y = p.dump;
    var w = p.getChildIdx;
    var e = t;
    if (t instanceof $b1badb002678e3c8$var$KJUR.asn1.ASN1Object) e = t.tohex();
    var q = function(A, i) {
        if (A.length <= i * 2) return A;
        else {
            var v = A.substr(0, i) + "..(total " + A.length / 2 + "bytes).." + A.substr(A.length - i, i);
            return v;
        }
    };
    if (c === undefined) c = {
        ommit_long_octet: 32
    };
    if (l === undefined) l = 0;
    if (g === undefined) g = "";
    var x = c.ommit_long_octet;
    var z = e.substr(l, 2);
    if (z == "01") {
        var h = j(e, l);
        if (h == "00") return g + "BOOLEAN FALSE\n";
        else return g + "BOOLEAN TRUE\n";
    }
    if (z == "02") {
        var h = j(e, l);
        return g + "INTEGER " + q(h, x) + "\n";
    }
    if (z == "03") {
        var h = j(e, l);
        if (p.isASN1HEX(h.substr(2))) {
            var k = g + "BITSTRING, encapsulates\n";
            k = k + y(h.substr(2), c, 0, g + "  ");
            return k;
        } else return g + "BITSTRING " + q(h, x) + "\n";
    }
    if (z == "04") {
        var h = j(e, l);
        if (p.isASN1HEX(h)) {
            var k = g + "OCTETSTRING, encapsulates\n";
            k = k + y(h, c, 0, g + "  ");
            return k;
        } else return g + "OCTETSTRING " + q(h, x) + "\n";
    }
    if (z == "05") return g + "NULL\n";
    if (z == "06") {
        var m = j(e, l);
        var b = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.oidHexToInt(m);
        var o = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name(b);
        var a = b.replace(/\./g, " ");
        if (o != "") return g + "ObjectIdentifier " + o + " (" + a + ")\n";
        else return g + "ObjectIdentifier (" + a + ")\n";
    }
    if (z == "0a") return g + "ENUMERATED " + parseInt(j(e, l)) + "\n";
    if (z == "0c") return g + "UTF8String '" + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "'\n";
    if (z == "13") return g + "PrintableString '" + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "'\n";
    if (z == "14") return g + "TeletexString '" + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "'\n";
    if (z == "16") return g + "IA5String '" + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "'\n";
    if (z == "17") return g + "UTCTime " + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "\n";
    if (z == "18") return g + "GeneralizedTime " + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "\n";
    if (z == "1a") return g + "VisualString '" + $b1badb002678e3c8$var$hextoutf8(j(e, l)) + "'\n";
    if (z == "1e") return g + "BMPString '" + $b1badb002678e3c8$var$ucs2hextoutf8(j(e, l)) + "'\n";
    if (z == "30") {
        if (e.substr(l, 4) == "3000") return g + "SEQUENCE {}\n";
        var k = g + "SEQUENCE\n";
        var d = w(e, l);
        var f = c;
        if ((d.length == 2 || d.length == 3) && e.substr(d[0], 2) == "06" && e.substr(d[d.length - 1], 2) == "04") {
            var o = p.oidname(j(e, d[0]));
            var r = JSON.parse(JSON.stringify(c));
            r.x509ExtName = o;
            f = r;
        }
        for(var u = 0; u < d.length; u++)k = k + y(e, f, d[u], g + "  ");
        return k;
    }
    if (z == "31") {
        var k = g + "SET\n";
        var d = w(e, l);
        for(var u = 0; u < d.length; u++)k = k + y(e, c, d[u], g + "  ");
        return k;
    }
    var z = parseInt(z, 16);
    if ((z & 128) != 0) {
        var n = z & 31;
        if ((z & 32) != 0) {
            var k = g + "[" + n + "]\n";
            var d = w(e, l);
            for(var u = 0; u < d.length; u++)k = k + y(e, c, d[u], g + "  ");
            return k;
        } else {
            var h = j(e, l);
            if ($b1badb002678e3c8$var$ASN1HEX.isASN1HEX(h)) {
                var k = g + "[" + n + "]\n";
                k = k + y(h, c, 0, g + "  ");
                return k;
            } else {
                if (h.substr(0, 8) == "68747470") h = $b1badb002678e3c8$var$hextoutf8(h);
                else if (c.x509ExtName === "subjectAltName" && n == 2) h = $b1badb002678e3c8$var$hextoutf8(h);
            }
            var k = g + "[" + n + "] " + h + "\n";
            return k;
        }
    }
    return g + "UNKNOWN(" + z + ") " + j(e, l) + "\n";
};
$b1badb002678e3c8$var$ASN1HEX.parse = function(x) {
    var t = $b1badb002678e3c8$var$ASN1HEX, f = t.parse, a = t.isASN1HEX, l = t.getV, b = t.getTLV, y = t.getChildIdx, i = $b1badb002678e3c8$var$KJUR.asn1, e = i.ASN1Util.oidHexToInt, B = i.x509.OID.oid2name, k = $b1badb002678e3c8$var$hextoutf8, n = $b1badb002678e3c8$var$ucs2hextoutf8, q = $b1badb002678e3c8$var$iso88591hextoutf8;
    var c = {
        "0c": "utf8str",
        "12": "numstr",
        "13": "prnstr",
        "14": "telstr",
        "16": "ia5str",
        "17": "utctime",
        "18": "gentime",
        "1a": "visstr",
        "1e": "bmpstr",
        "30": "seq",
        "31": "set"
    };
    var u = function(H) {
        var D = [];
        var E = y(H, 0);
        for(var G = 0; G < E.length; G++){
            var s = E[G];
            var d = b(H, s);
            var F = f(d);
            D.push(F);
        }
        return D;
    };
    var C = x.substr(0, 2);
    var j = {};
    var p = l(x, 0);
    if (C == "01") {
        if (x == "0101ff") return {
            bool: true
        };
        return {
            bool: false
        };
    } else {
        if (C == "02") return {
            "int": {
                hex: p
            }
        };
        else {
            if (C == "03") try {
                if (p.substr(0, 2) != "00") throw "not encap";
                var v = p.substr(2);
                if (!a(v)) throw "not encap";
                return {
                    bitstr: {
                        obj: f(v)
                    }
                };
            } catch (z) {
                var m = null;
                if (p.length <= 10) m = $b1badb002678e3c8$var$bitstrtobinstr(p);
                if (m == null) return {
                    bitstr: {
                        hex: p
                    }
                };
                else return {
                    bitstr: {
                        bin: m
                    }
                };
            }
            else {
                if (C == "04") try {
                    if (!a(p)) throw "not encap";
                    return {
                        octstr: {
                            obj: f(p)
                        }
                    };
                } catch (z) {
                    return {
                        octstr: {
                            hex: p
                        }
                    };
                }
                else {
                    if (C == "05") return {
                        "null": ""
                    };
                    else if (C == "06") {
                        var g = e(p);
                        var r = B(g);
                        if (r == "") return {
                            oid: g
                        };
                        else return {
                            oid: r
                        };
                    } else {
                        if (C == "0a") {
                            if (p.length > 4) return {
                                "enum": {
                                    hex: p
                                }
                            };
                            else return {
                                "enum": parseInt(p, 16)
                            };
                        } else if (C == "30" || C == "31") {
                            j[c[C]] = u(x);
                            return j;
                        } else {
                            if (C == "14") {
                                var o = q(p);
                                j[c[C]] = {
                                    str: o
                                };
                                return j;
                            } else if (C == "1e") {
                                var o = n(p);
                                j[c[C]] = {
                                    str: o
                                };
                                return j;
                            } else {
                                if (":0c:12:13:16:17:18:1a:".indexOf(C) != -1) {
                                    var o = k(p);
                                    j[c[C]] = {
                                        str: o
                                    };
                                    return j;
                                } else if (C.match(/^8[0-9]$/)) {
                                    var o = k(p);
                                    if (o == null | o == "") return {
                                        tag: {
                                            tag: C,
                                            explicit: false,
                                            hex: p
                                        }
                                    };
                                    else {
                                        if (o.match(/[\x00-\x1F\x7F-\x9F]/) != null || o.match(/[\u0000-\u001F\u0080–\u009F]/) != null) return {
                                            tag: {
                                                tag: C,
                                                explicit: false,
                                                hex: p
                                            }
                                        };
                                        else return {
                                            tag: {
                                                tag: C,
                                                explicit: false,
                                                str: o
                                            }
                                        };
                                    }
                                } else {
                                    if (C.match(/^a[0-9]$/)) try {
                                        if (!a(p)) throw new Error("not encap");
                                        return {
                                            tag: {
                                                tag: C,
                                                explicit: true,
                                                obj: f(p)
                                            }
                                        };
                                    } catch (z) {
                                        return {
                                            tag: {
                                                tag: C,
                                                explicit: true,
                                                hex: p
                                            }
                                        };
                                    }
                                    else {
                                        var A = new $b1badb002678e3c8$var$KJUR.asn1.ASN1Object();
                                        A.hV = p;
                                        var w = A.getLengthHexFromValue();
                                        return {
                                            asn1: {
                                                tlv: C + w + p
                                            }
                                        };
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
$b1badb002678e3c8$var$ASN1HEX.isContextTag = function(c, b) {
    c = c.toLowerCase();
    var f, e;
    try {
        f = parseInt(c, 16);
    } catch (d) {
        return -1;
    }
    if (b === undefined) {
        if ((f & 192) == 128) return true;
        else return false;
    }
    try {
        var a = b.match(/^\[[0-9]+\]$/);
        if (a == null) return false;
        e = parseInt(b.substr(1, b.length - 1), 10);
        if (e > 31) return false;
        if ((f & 192) == 128 && (f & 31) == e) return true;
        return false;
    } catch (d) {
        return false;
    }
};
$b1badb002678e3c8$var$ASN1HEX.isASN1HEX = function(e) {
    var d = $b1badb002678e3c8$var$ASN1HEX;
    if (e.length % 2 == 1) return false;
    var c = d.getVblen(e, 0);
    var b = e.substr(0, 2);
    var f = d.getL(e, 0);
    var a = e.length - b.length - f.length;
    if (a == c * 2) return true;
    return false;
};
$b1badb002678e3c8$var$ASN1HEX.checkStrictDER = function(g, o, d, c, r) {
    var s = $b1badb002678e3c8$var$ASN1HEX;
    if (d === undefined) {
        if (typeof g != "string") throw new Error("not hex string");
        g = g.toLowerCase();
        if (!$b1badb002678e3c8$var$KJUR.lang.String.isHex(g)) throw new Error("not hex string");
        d = g.length;
        c = g.length / 2;
        if (c < 128) r = 1;
        else r = Math.ceil(c.toString(16)) + 1;
    }
    var k = s.getL(g, o);
    if (k.length > r * 2) throw new Error("L of TLV too long: idx=" + o);
    var n = s.getVblen(g, o);
    if (n > c) throw new Error("value of L too long than hex: idx=" + o);
    var q = s.getTLV(g, o);
    var f = q.length - 2 - s.getL(g, o).length;
    if (f !== n * 2) throw new Error("V string length and L's value not the same:" + f + "/" + n * 2);
    if (o === 0) {
        if (g.length != q.length) throw new Error("total length and TLV length unmatch:" + g.length + "!=" + q.length);
    }
    var b = g.substr(o, 2);
    if (b === "02") {
        var a = s.getVidx(g, o);
        if (g.substr(a, 2) == "00" && g.charCodeAt(a + 2) < 56) throw new Error("not least zeros for DER INTEGER");
    }
    if (parseInt(b, 16) & 32) {
        var p = s.getVblen(g, o);
        var m = 0;
        var l = s.getChildIdx(g, o);
        for(var e = 0; e < l.length; e++){
            var j = s.getTLV(g, l[e]);
            m += j.length;
            s.checkStrictDER(g, l[e], d, c, r);
        }
        if (p * 2 != m) throw new Error("sum of children's TLV length and L unmatch: " + p * 2 + "!=" + m);
    }
};
$b1badb002678e3c8$var$ASN1HEX.oidname = function(a) {
    var c = $b1badb002678e3c8$var$KJUR.asn1;
    if ($b1badb002678e3c8$var$KJUR.lang.String.isHex(a)) a = c.ASN1Util.oidHexToInt(a);
    var b = c.x509.OID.oid2name(a);
    if (b === "") b = a;
    return b;
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1) $b1badb002678e3c8$var$KJUR.asn1 = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1.x509 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1.x509) $b1badb002678e3c8$var$KJUR.asn1.x509 = {};
$b1badb002678e3c8$var$KJUR.asn1.x509.Certificate = function(h) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.Certificate.superclass.constructor.call(this);
    var d = $b1badb002678e3c8$var$KJUR, c = d.asn1, f = c.DERBitString, b = c.DERSequence, g = c.x509, a = g.TBSCertificate, e = g.AlgorithmIdentifier;
    this.params = undefined;
    this.setByParam = function(i) {
        this.params = i;
    };
    this.sign = function() {
        var l = this.params;
        var k = l.sigalg;
        if (l.sigalg.name != undefined) k = l.sigalg.name;
        var i = l.tbsobj.tohex();
        var j = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: k
        });
        j.init(l.cakey);
        j.updateHex(i);
        l.sighex = j.sign();
    };
    this.getPEM = function() {
        return $b1badb002678e3c8$var$hextopem(this.tohex(), "CERTIFICATE");
    };
    this.tohex = function() {
        var k = this.params;
        if (k.tbsobj == undefined || k.tbsobj == null) k.tbsobj = new a(k);
        if (k.sighex == undefined && k.cakey != undefined) this.sign();
        if (k.sighex == undefined) throw new Error("sighex or cakey parameter not defined");
        var i = [];
        i.push(k.tbsobj);
        i.push(new e({
            name: k.sigalg
        }));
        i.push(new f({
            hex: "00" + k.sighex
        }));
        var j = new b({
            array: i
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (h != undefined) this.params = h;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.Certificate, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.TBSCertificate = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.TBSCertificate.superclass.constructor.call(this);
    var b = $b1badb002678e3c8$var$KJUR, i = b.asn1, d = i.x509, c = i.DERTaggedObject, h = i.DERInteger, g = i.DERSequence, l = d.AlgorithmIdentifier, e = d.Time, a = d.X500Name, j = d.Extensions, k = d.SubjectPublicKeyInfo;
    this.params = null;
    this.setByParam = function(m) {
        this.params = m;
    };
    this.tohex = function() {
        var n = [];
        var q = this.params;
        if (q.version != undefined || q.version != 1) {
            var m = 2;
            if (q.version != undefined) m = q.version - 1;
            var p = new c({
                obj: new h({
                    "int": m
                })
            });
            n.push(p);
        }
        n.push(new h(q.serial));
        n.push(new l({
            name: q.sigalg
        }));
        n.push(new a(q.issuer));
        n.push(new g({
            array: [
                new e(q.notbefore),
                new e(q.notafter)
            ]
        }));
        n.push(new a(q.subject));
        n.push(new k($b1badb002678e3c8$var$KEYUTIL.getKey(q.sbjpubkey)));
        if (q.ext !== undefined && q.ext.length > 0) n.push(new c({
            tag: "a3",
            obj: new j(q.ext)
        }));
        var o = new $b1badb002678e3c8$var$KJUR.asn1.DERSequence({
            array: n
        });
        return o.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f !== undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.TBSCertificate, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.Extensions = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.Extensions.superclass.constructor.call(this);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSequence, e = b.x509;
    this.aParam = [];
    this.setByParam = function(f) {
        this.aParam = f;
    };
    this.tohex = function() {
        var f = [];
        for(var h = 0; h < this.aParam.length; h++){
            var l = this.aParam[h];
            var k = l.extname;
            var j = null;
            if (l.extn != undefined) j = new e.PrivateExtension(l);
            else if (k == "subjectKeyIdentifier") j = new e.SubjectKeyIdentifier(l);
            else {
                if (k == "keyUsage") j = new e.KeyUsage(l);
                else if (k == "subjectAltName") j = new e.SubjectAltName(l);
                else {
                    if (k == "issuerAltName") j = new e.IssuerAltName(l);
                    else if (k == "basicConstraints") j = new e.BasicConstraints(l);
                    else {
                        if (k == "nameConstraints") j = new e.NameConstraints(l);
                        else if (k == "cRLDistributionPoints") j = new e.CRLDistributionPoints(l);
                        else {
                            if (k == "certificatePolicies") j = new e.CertificatePolicies(l);
                            else if (k == "policyMappings") j = new e.PolicyMappings(l);
                            else {
                                if (k == "policyConstraints") j = new e.PolicyConstraints(l);
                                else if (k == "inhibitAnyPolicy") j = new e.InhibitAnyPolicy(l);
                                else {
                                    if (k == "authorityKeyIdentifier") j = new e.AuthorityKeyIdentifier(l);
                                    else if (k == "extKeyUsage") j = new e.ExtKeyUsage(l);
                                    else {
                                        if (k == "authorityInfoAccess") j = new e.AuthorityInfoAccess(l);
                                        else if (k == "cRLNumber") j = new e.CRLNumber(l);
                                        else {
                                            if (k == "cRLReason") j = new e.CRLReason(l);
                                            else if (k == "ocspNonce") j = new e.OCSPNonce(l);
                                            else {
                                                if (k == "ocspNoCheck") j = new e.OCSPNoCheck(l);
                                                else if (k == "adobeTimeStamp") j = new e.AdobeTimeStamp(l);
                                                else {
                                                    if (k == "subjectDirectoryAttributes") j = new e.SubjectDirectoryAttributes(l);
                                                    else throw new Error("extension not supported:" + JSON.stringify(l));
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (j != null) f.push(j);
        }
        var g = new a({
            array: f
        });
        return g.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (d != undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.Extensions, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.Extension = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.Extension.superclass.constructor.call(this);
    var f = null, a = $b1badb002678e3c8$var$KJUR, e = a.asn1, h = e.DERObjectIdentifier, i = e.DEROctetString, b = e.DERBitString, g = e.DERBoolean, c = e.DERSequence;
    this.tohex = function() {
        var m = new h({
            oid: this.oid
        });
        var l = new i({
            hex: this.getExtnValueHex()
        });
        var k = new Array();
        k.push(m);
        if (this.critical) k.push(new g());
        k.push(l);
        var j = new c({
            array: k
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.critical = false;
    if (d !== undefined) {
        if (d.critical !== undefined) this.critical = d.critical;
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.Extension, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.KeyUsage = function(c) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.KeyUsage.superclass.constructor.call(this, c);
    var b = Error;
    var a = {
        digitalSignature: 0,
        nonRepudiation: 1,
        keyEncipherment: 2,
        dataEncipherment: 3,
        keyAgreement: 4,
        keyCertSign: 5,
        cRLSign: 6,
        encipherOnly: 7,
        decipherOnly: 8
    };
    this.getExtnValueHex = function() {
        var d = this.getBinValue();
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.DERBitString({
            bin: d
        });
        return this.asn1ExtnValue.tohex();
    };
    this.getBinValue = function() {
        var d = this.params;
        if (typeof d != "object" || typeof d.names != "object" && typeof d.bin != "string") throw new b("parameter not yet set");
        if (d.names != undefined) return $b1badb002678e3c8$var$namearraytobinstr(d.names, a);
        else {
            if (d.bin != undefined) return d.bin;
            else throw new b("parameter not set properly");
        }
    };
    this.oid = "2.5.29.15";
    if (c !== undefined) this.params = c;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.KeyUsage, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.BasicConstraints = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.BasicConstraints.superclass.constructor.call(this, g);
    var c = $b1badb002678e3c8$var$KJUR.asn1, e = c.DERBoolean, f = c.DERInteger, b = c.DERSequence;
    var a = false;
    var d = -1;
    this.getExtnValueHex = function() {
        var i = new Array();
        if (this.cA) i.push(new e());
        if (this.pathLen > -1) i.push(new f({
            "int": this.pathLen
        }));
        var h = new b({
            array: i
        });
        this.asn1ExtnValue = h;
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.19";
    this.cA = false;
    this.pathLen = -1;
    if (g !== undefined) {
        if (g.cA !== undefined) this.cA = g.cA;
        if (g.pathLen !== undefined) this.pathLen = g.pathLen;
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.BasicConstraints, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.CRLDistributionPoints = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this, d);
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1, c = a.x509;
    this.getExtnValueHex = function() {
        return this.asn1ExtnValue.tohex();
    };
    this.setByDPArray = function(e) {
        var f = [];
        for(var g = 0; g < e.length; g++)if (e[g] instanceof $b1badb002678e3c8$var$KJUR.asn1.ASN1Object) f.push(e[g]);
        else {
            var h = new c.DistributionPoint(e[g]);
            f.push(h);
        }
        this.asn1ExtnValue = new a.DERSequence({
            array: f
        });
    };
    this.setByOneURI = function(f) {
        var e = new c.DistributionPoint({
            fulluri: f
        });
        this.setByDPArray([
            e
        ]);
    };
    this.oid = "2.5.29.31";
    if (d !== undefined) {
        if (d.array !== undefined) this.setByDPArray(d.array);
        else if (d.uri !== undefined) this.setByOneURI(d.uri);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.CRLDistributionPoints, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.DistributionPoint = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.DistributionPoint.superclass.constructor.call(this);
    var a = null, c = $b1badb002678e3c8$var$KJUR, b = c.asn1, d = b.x509.DistributionPointName;
    this.tohex = function() {
        var f = new b.DERSequence();
        if (this.asn1DP != null) {
            var g = new b.DERTaggedObject({
                explicit: true,
                tag: "a0",
                obj: this.asn1DP
            });
            f.appendASN1Object(g);
        }
        this.hTLV = f.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) {
        if (e.dpobj !== undefined) this.asn1DP = e.dpobj;
        else {
            if (e.dpname !== undefined) this.asn1DP = new d(e.dpname);
            else if (e.fulluri !== undefined) this.asn1DP = new d({
                full: [
                    {
                        uri: e.fulluri
                    }
                ]
            });
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.DistributionPoint, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.DistributionPointName = function(h) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.DistributionPointName.superclass.constructor.call(this);
    var g = null, d = null, a = null, f = null, c = $b1badb002678e3c8$var$KJUR, b = c.asn1, e = b.DERTaggedObject;
    this.tohex = function() {
        if (this.type != "full") throw new Error("currently type shall be 'full': " + this.type);
        this.asn1Obj = new e({
            explicit: false,
            tag: this.tag,
            obj: this.asn1V
        });
        this.hTLV = this.asn1Obj.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (h !== undefined) {
        if (b.x509.GeneralNames.prototype.isPrototypeOf(h)) {
            this.type = "full";
            this.tag = "a0";
            this.asn1V = h;
        } else {
            if (h.full !== undefined) {
                this.type = "full";
                this.tag = "a0";
                this.asn1V = new b.x509.GeneralNames(h.full);
            } else throw new Error("This class supports GeneralNames only as argument");
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.DistributionPointName, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.CertificatePolicies = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.CertificatePolicies.superclass.constructor.call(this, f);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, e = b.x509, a = b.DERSequence, d = e.PolicyInformation;
    this.params = null;
    this.getExtnValueHex = function() {
        var j = [];
        for(var h = 0; h < this.params.array.length; h++)j.push(new d(this.params.array[h]));
        var g = new a({
            array: j
        });
        this.asn1ExtnValue = g;
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.32";
    if (f !== undefined) this.params = f;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.CertificatePolicies, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.PolicyInformation = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.PolicyInformation.superclass.constructor.call(this, d);
    var c = $b1badb002678e3c8$var$KJUR.asn1, b = c.DERSequence, e = c.DERObjectIdentifier, a = c.x509.PolicyQualifierInfo;
    this.params = null;
    this.tohex = function() {
        if (this.params.policyoid === undefined && this.params.array === undefined) throw new Error("parameter oid and array missing");
        var f = [
            new e(this.params.policyoid)
        ];
        if (this.params.array !== undefined) {
            var j = [];
            for(var h = 0; h < this.params.array.length; h++)j.push(new a(this.params.array[h]));
            if (j.length > 0) f.push(new b({
                array: j
            }));
        }
        var g = new b({
            array: f
        });
        return g.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (d !== undefined) this.params = d;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.PolicyInformation, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.PolicyQualifierInfo = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.PolicyQualifierInfo.superclass.constructor.call(this, e);
    var c = $b1badb002678e3c8$var$KJUR.asn1, b = c.DERSequence, d = c.DERIA5String, f = c.DERObjectIdentifier, a = c.x509.UserNotice;
    this.params = null;
    this.tohex = function() {
        if (this.params.cps !== undefined) {
            var g = new b({
                array: [
                    new f({
                        oid: "1.3.6.1.5.5.7.2.1"
                    }),
                    new d({
                        str: this.params.cps
                    })
                ]
            });
            return g.tohex();
        }
        if (this.params.unotice != undefined) {
            var g = new b({
                array: [
                    new f({
                        oid: "1.3.6.1.5.5.7.2.2"
                    }),
                    new a(this.params.unotice)
                ]
            });
            return g.tohex();
        }
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.PolicyQualifierInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.UserNotice = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.UserNotice.superclass.constructor.call(this, e);
    var a = $b1badb002678e3c8$var$KJUR.asn1.DERSequence, d = $b1badb002678e3c8$var$KJUR.asn1.DERInteger, c = $b1badb002678e3c8$var$KJUR.asn1.x509.DisplayText, b = $b1badb002678e3c8$var$KJUR.asn1.x509.NoticeReference;
    this.params = null;
    this.tohex = function() {
        var f = [];
        if (this.params.noticeref !== undefined) f.push(new b(this.params.noticeref));
        if (this.params.exptext !== undefined) f.push(new c(this.params.exptext));
        var g = new a({
            array: f
        });
        return g.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.UserNotice, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.NoticeReference = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.NoticeReference.superclass.constructor.call(this, d);
    var a = $b1badb002678e3c8$var$KJUR.asn1.DERSequence, c = $b1badb002678e3c8$var$KJUR.asn1.DERInteger, b = $b1badb002678e3c8$var$KJUR.asn1.x509.DisplayText;
    this.params = null;
    this.tohex = function() {
        var f = [];
        if (this.params.org !== undefined) f.push(new b(this.params.org));
        if (this.params.noticenum !== undefined) {
            var h = [];
            var e = this.params.noticenum;
            for(var j = 0; j < e.length; j++)h.push(new c(e[j]));
            f.push(new a({
                array: h
            }));
        }
        if (f.length == 0) throw new Error("parameter is empty");
        var g = new a({
            array: f
        });
        return g.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (d !== undefined) this.params = d;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.NoticeReference, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.DisplayText = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.DisplayText.superclass.constructor.call(this, a);
    this.hT = "0c";
    if (a !== undefined) {
        if (a.type === "ia5") this.hT = "16";
        else {
            if (a.type === "vis") this.hT = "1a";
            else if (a.type === "bmp") this.hT = "1e";
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.DisplayText, $b1badb002678e3c8$var$KJUR.asn1.DERAbstractString);
$b1badb002678e3c8$var$KJUR.asn1.x509.PolicyMappings = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.PolicyMappings.superclass.constructor.call(this, e);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, d = b.x509, a = b.ASN1Util.newObject;
    this.params = null;
    this.getExtnValueHex = function() {
        var j = this.params;
        var f = [];
        for(var g = 0; g < j.array.length; g++){
            var h = j.array[g];
            f.push({
                seq: [
                    {
                        oid: h[0]
                    },
                    {
                        oid: h[1]
                    }
                ]
            });
        }
        this.asn1ExtnValue = a({
            seq: f
        });
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.33";
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.PolicyMappings, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.PolicyConstraints = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.PolicyConstraints.superclass.constructor.call(this, e);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, d = b.x509, a = b.ASN1Util.newObject;
    this.params = null;
    this.getExtnValueHex = function() {
        var g = this.params;
        var f = [];
        if (g.reqexp != undefined) f.push({
            tag: {
                tagi: "80",
                obj: {
                    "int": g.reqexp
                }
            }
        });
        if (g.inhibit != undefined) f.push({
            tag: {
                tagi: "81",
                obj: {
                    "int": g.inhibit
                }
            }
        });
        this.asn1ExtnValue = a({
            seq: f
        });
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.36";
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.PolicyConstraints, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.InhibitAnyPolicy = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.InhibitAnyPolicy.superclass.constructor.call(this, e);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, d = b.x509, a = b.ASN1Util.newObject;
    this.params = null;
    this.getExtnValueHex = function() {
        this.asn1ExtnValue = a({
            "int": this.params.skip
        });
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.54";
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.InhibitAnyPolicy, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.NameConstraints = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.NameConstraints.superclass.constructor.call(this, f);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, e = b.x509, a = b.ASN1Util.newObject, d = e.GeneralSubtree;
    this.params = null;
    this.getExtnValueHex = function() {
        var l = this.params;
        var g = [];
        if (l.permit != undefined && l.permit.length != undefined) {
            var k = [];
            for(var h = 0; h < l.permit.length; h++)k.push(new d(l.permit[h]));
            g.push({
                tag: {
                    tagi: "a0",
                    obj: {
                        seq: k
                    }
                }
            });
        }
        if (l.exclude != undefined && l.exclude.length != undefined) {
            var j = [];
            for(var h = 0; h < l.exclude.length; h++)j.push(new d(l.exclude[h]));
            g.push({
                tag: {
                    tagi: "a1",
                    obj: {
                        seq: j
                    }
                }
            });
        }
        this.asn1ExtnValue = a({
            seq: g
        });
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.30";
    if (f !== undefined) this.params = f;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.NameConstraints, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.GeneralSubtree = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.GeneralSubtree.superclass.constructor.call(this);
    var b = $b1badb002678e3c8$var$KJUR.asn1, d = b.x509, c = d.GeneralName, a = b.ASN1Util.newObject;
    this.params = null;
    this.setByParam = function(f) {
        this.params = f;
    };
    this.tohex = function() {
        var h = this.params;
        var f = [
            new c(h)
        ];
        if (h.min != undefined) f.push({
            tag: {
                tagi: "80",
                obj: {
                    "int": h.min
                }
            }
        });
        if (h.max != undefined) f.push({
            tag: {
                tagi: "81",
                obj: {
                    "int": h.max
                }
            }
        });
        var g = a({
            seq: f
        });
        return g.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.GeneralSubtree, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.ExtKeyUsage = function(c) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.ExtKeyUsage.superclass.constructor.call(this, c);
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1;
    this.setPurposeArray = function(d) {
        this.asn1ExtnValue = new a.DERSequence();
        for(var e = 0; e < d.length; e++){
            var f = new a.DERObjectIdentifier(d[e]);
            this.asn1ExtnValue.appendASN1Object(f);
        }
    };
    this.getExtnValueHex = function() {
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.37";
    if (c !== undefined) {
        if (c.array !== undefined) this.setPurposeArray(c.array);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.ExtKeyUsage, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.AuthorityKeyIdentifier = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this, f);
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1, d = a.DERTaggedObject, e = a.x509.GeneralNames, c = b.crypto.Util.isKey;
    this.asn1KID = null;
    this.asn1CertIssuer = null;
    this.asn1CertSN = null;
    this.getExtnValueHex = function() {
        var h = new Array();
        if (this.asn1KID) h.push(new d({
            explicit: false,
            tag: "80",
            obj: this.asn1KID
        }));
        if (this.asn1CertIssuer) h.push(new d({
            explicit: false,
            tag: "a1",
            obj: new e([
                {
                    dn: this.asn1CertIssuer
                }
            ])
        }));
        if (this.asn1CertSN) h.push(new d({
            explicit: false,
            tag: "82",
            obj: this.asn1CertSN
        }));
        var g = new a.DERSequence({
            array: h
        });
        this.asn1ExtnValue = g;
        return this.asn1ExtnValue.tohex();
    };
    this.setKIDByParam = function(i) {
        if (i.str !== undefined || i.hex !== undefined) this.asn1KID = new $b1badb002678e3c8$var$KJUR.asn1.DEROctetString(i);
        else if (typeof i === "object" && $b1badb002678e3c8$var$KJUR.crypto.Util.isKey(i) || typeof i === "string" && i.indexOf("BEGIN ") != -1) {
            var h = i;
            if (typeof i === "string") h = $b1badb002678e3c8$var$KEYUTIL.getKey(i);
            var g = $b1badb002678e3c8$var$KEYUTIL.getKeyID(h);
            this.asn1KID = new $b1badb002678e3c8$var$KJUR.asn1.DEROctetString({
                hex: g
            });
        }
    };
    this.setCertIssuerByParam = function(g) {
        if (g.str !== undefined || g.ldapstr !== undefined || g.hex !== undefined || g.certsubject !== undefined || g.certissuer !== undefined) this.asn1CertIssuer = new $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name(g);
        else if (typeof g === "string" && g.indexOf("BEGIN ") != -1 && g.indexOf("CERTIFICATE") != -1) this.asn1CertIssuer = new $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name({
            certissuer: g
        });
    };
    this.setCertSNByParam = function(i) {
        if (i.str !== undefined || i.bigint !== undefined || i.hex !== undefined) this.asn1CertSN = new $b1badb002678e3c8$var$KJUR.asn1.DERInteger(i);
        else if (typeof i === "string" && i.indexOf("BEGIN ") != -1 && i.indexOf("CERTIFICATE")) {
            var g = new $b1badb002678e3c8$var$X509();
            g.readCertPEM(i);
            var h = g.getSerialNumberHex();
            this.asn1CertSN = new $b1badb002678e3c8$var$KJUR.asn1.DERInteger({
                hex: h
            });
        }
    };
    this.oid = "2.5.29.35";
    if (f !== undefined) {
        if (f.kid !== undefined) this.setKIDByParam(f.kid);
        if (f.issuer !== undefined) this.setCertIssuerByParam(f.issuer);
        if (f.sn !== undefined) this.setCertSNByParam(f.sn);
        if (f.issuersn !== undefined && typeof f.issuersn === "string" && f.issuersn.indexOf("BEGIN ") != -1 && f.issuersn.indexOf("CERTIFICATE")) {
            this.setCertSNByParam(f.issuersn);
            this.setCertIssuerByParam(f.issuersn);
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.AuthorityKeyIdentifier, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.SubjectKeyIdentifier = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.SubjectKeyIdentifier.superclass.constructor.call(this, d);
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1, c = a.DEROctetString;
    this.asn1KID = null;
    this.getExtnValueHex = function() {
        this.asn1ExtnValue = this.asn1KID;
        return this.asn1ExtnValue.tohex();
    };
    this.setKIDByParam = function(g) {
        if (g.str !== undefined || g.hex !== undefined) this.asn1KID = new c(g);
        else if (typeof g === "object" && $b1badb002678e3c8$var$KJUR.crypto.Util.isKey(g) || typeof g === "string" && g.indexOf("BEGIN") != -1) {
            var f = g;
            if (typeof g === "string") f = $b1badb002678e3c8$var$KEYUTIL.getKey(g);
            var e = $b1badb002678e3c8$var$KEYUTIL.getKeyID(f);
            this.asn1KID = new $b1badb002678e3c8$var$KJUR.asn1.DEROctetString({
                hex: e
            });
        }
    };
    this.oid = "2.5.29.14";
    if (d !== undefined) {
        if (d.kid !== undefined) this.setKIDByParam(d.kid);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.SubjectKeyIdentifier, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.AuthorityInfoAccess = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.AuthorityInfoAccess.superclass.constructor.call(this, a);
    this.setAccessDescriptionArray = function(k) {
        var d = new Array(), b = $b1badb002678e3c8$var$KJUR, g = b.asn1, c = g.DERSequence, j = g.DERObjectIdentifier, l = g.x509.GeneralName;
        for(var f = 0; f < k.length; f++){
            var e;
            var h = k[f];
            if (h.ocsp !== undefined) e = new c({
                array: [
                    new j({
                        oid: "1.3.6.1.5.5.7.48.1"
                    }),
                    new l({
                        uri: h.ocsp
                    })
                ]
            });
            else {
                if (h.caissuer !== undefined) e = new c({
                    array: [
                        new j({
                            oid: "1.3.6.1.5.5.7.48.2"
                        }),
                        new l({
                            uri: h.caissuer
                        })
                    ]
                });
                else throw new Error("unknown AccessMethod parameter: " + JSON.stringify(h));
            }
            d.push(e);
        }
        this.asn1ExtnValue = new c({
            array: d
        });
    };
    this.getExtnValueHex = function() {
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "1.3.6.1.5.5.7.1.1";
    if (a !== undefined) {
        if (a.array !== undefined) this.setAccessDescriptionArray(a.array);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.AuthorityInfoAccess, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.SubjectAltName = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.SubjectAltName.superclass.constructor.call(this, a);
    this.setNameArray = function(b) {
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.x509.GeneralNames(b);
    };
    this.getExtnValueHex = function() {
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.17";
    if (a !== undefined) {
        if (a.array !== undefined) this.setNameArray(a.array);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.SubjectAltName, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.IssuerAltName = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.IssuerAltName.superclass.constructor.call(this, a);
    this.setNameArray = function(b) {
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.x509.GeneralNames(b);
    };
    this.getExtnValueHex = function() {
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.18";
    if (a !== undefined) {
        if (a.array !== undefined) this.setNameArray(a.array);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.IssuerAltName, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.SubjectDirectoryAttributes = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.SubjectDirectoryAttributes.superclass.constructor.call(this, e);
    var c = $b1badb002678e3c8$var$KJUR.asn1, a = c.DERSequence, b = c.ASN1Util.newObject, d = c.x509.OID.name2oid;
    this.params = null;
    this.getExtnValueHex = function() {
        var f = [];
        for(var j = 0; j < this.params.array.length; j++){
            var k = this.params.array[j];
            var h = {
                seq: [
                    {
                        oid: "1.2.3.4"
                    },
                    {
                        set: [
                            {
                                utf8str: "DE"
                            }
                        ]
                    }
                ]
            };
            if (k.attr == "dateOfBirth") {
                h.seq[0].oid = d(k.attr);
                h.seq[1].set[0] = {
                    gentime: k.str
                };
            } else if (k.attr == "placeOfBirth") {
                h.seq[0].oid = d(k.attr);
                h.seq[1].set[0] = {
                    utf8str: k.str
                };
            } else {
                if (k.attr == "gender") {
                    h.seq[0].oid = d(k.attr);
                    h.seq[1].set[0] = {
                        prnstr: k.str
                    };
                } else if (k.attr == "countryOfCitizenship") {
                    h.seq[0].oid = d(k.attr);
                    h.seq[1].set[0] = {
                        prnstr: k.str
                    };
                } else {
                    if (k.attr == "countryOfResidence") {
                        h.seq[0].oid = d(k.attr);
                        h.seq[1].set[0] = {
                            prnstr: k.str
                        };
                    } else throw new Error("unsupported attribute: " + k.attr);
                }
            }
            f.push(new b(h));
        }
        var g = new a({
            array: f
        });
        this.asn1ExtnValue = g;
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.9";
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.SubjectDirectoryAttributes, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.PrivateExtension = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.PrivateExtension.superclass.constructor.call(this, f);
    var c = $b1badb002678e3c8$var$KJUR, e = c.lang.String.isHex, b = c.asn1, d = b.x509.OID.name2oid, a = b.ASN1Util.newObject;
    this.params = null;
    this.setByParam = function(g) {
        this.oid = d(g.extname);
        this.params = g;
    };
    this.getExtnValueHex = function() {
        if (this.params.extname == undefined || this.params.extn == undefined) throw new Error("extname or extnhex not specified");
        var h = this.params.extn;
        if (typeof h == "string" && e(h)) return h;
        else {
            if (typeof h == "object") try {
                return a(h).tohex();
            } catch (g) {}
        }
        throw new Error("unsupported extn value");
    };
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.PrivateExtension, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.CRL = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.CRL.superclass.constructor.call(this);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSequence, e = b.DERBitString, f = b.x509, d = f.AlgorithmIdentifier, h = f.TBSCertList;
    this.params = undefined;
    this.setByParam = function(i) {
        this.params = i;
    };
    this.sign = function() {
        var j = new h(this.params).tohex();
        var k = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: this.params.sigalg
        });
        k.init(this.params.cakey);
        k.updateHex(j);
        var i = k.sign();
        this.params.sighex = i;
    };
    this.getPEM = function() {
        return $b1badb002678e3c8$var$hextopem(this.tohex(), "X509 CRL");
    };
    this.tohex = function() {
        var k = this.params;
        if (k.tbsobj == undefined) k.tbsobj = new h(k);
        if (k.sighex == undefined && k.cakey != undefined) this.sign();
        if (k.sighex == undefined) throw new Error("sighex or cakey parameter not defined");
        var i = [];
        i.push(k.tbsobj);
        i.push(new d({
            name: k.sigalg
        }));
        i.push(new e({
            hex: "00" + k.sighex
        }));
        var j = new a({
            array: i
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.params = g;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.CRL, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.TBSCertList = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.TBSCertList.superclass.constructor.call(this);
    var b = $b1badb002678e3c8$var$KJUR, i = b.asn1, h = i.DERInteger, g = i.DERSequence, c = i.DERTaggedObject, k = i.DERObjectIdentifier, d = i.x509, l = d.AlgorithmIdentifier, e = d.Time, j = d.Extensions, a = d.X500Name;
    this.params = null;
    this.setByParam = function(m) {
        this.params = m;
    };
    this.getRevCertSequence = function() {
        var m = [];
        var n = this.params.revcert;
        for(var o = 0; o < n.length; o++){
            var p = [
                new h(n[o].sn),
                new e(n[o].date)
            ];
            if (n[o].ext != undefined) p.push(new j(n[o].ext));
            m.push(new g({
                array: p
            }));
        }
        return new g({
            array: m
        });
    };
    this.tohex = function() {
        var n = [];
        var r = this.params;
        if (r.version != undefined) {
            var m = r.version - 1;
            var p = new h({
                "int": m
            });
            n.push(p);
        }
        n.push(new l({
            name: r.sigalg
        }));
        n.push(new a(r.issuer));
        n.push(new e(r.thisupdate));
        if (r.nextupdate != undefined) n.push(new e(r.nextupdate));
        if (r.revcert != undefined) n.push(this.getRevCertSequence());
        if (r.ext != undefined) {
            var q = new j(r.ext);
            n.push(new c({
                tag: "a0",
                explicit: true,
                obj: q
            }));
        }
        var o = new g({
            array: n
        });
        return o.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f !== undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.TBSCertList, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.CRLEntry = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.CRLEntry.superclass.constructor.call(this);
    var d = null, c = null, b = $b1badb002678e3c8$var$KJUR, a = b.asn1;
    this.setCertSerial = function(f) {
        this.sn = new a.DERInteger(f);
    };
    this.setRevocationDate = function(f) {
        this.time = new a.x509.Time(f);
    };
    this.tohex = function() {
        var f = new a.DERSequence({
            array: [
                this.sn,
                this.time
            ]
        });
        this.TLV = f.tohex();
        return this.TLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) {
        if (e.time !== undefined) this.setRevocationDate(e.time);
        if (e.sn !== undefined) this.setCertSerial(e.sn);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.CRLEntry, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.CRLNumber = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.CRLNumber.superclass.constructor.call(this, a);
    this.params = undefined;
    this.getExtnValueHex = function() {
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.DERInteger(this.params.num);
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.20";
    if (a != undefined) this.params = a;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.CRLNumber, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.CRLReason = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.CRLReason.superclass.constructor.call(this, a);
    this.params = undefined;
    this.getExtnValueHex = function() {
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.DEREnumerated(this.params.code);
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "2.5.29.21";
    if (a != undefined) this.params = a;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.CRLReason, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.OCSPNonce = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.OCSPNonce.superclass.constructor.call(this, a);
    this.params = undefined;
    this.getExtnValueHex = function() {
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.DEROctetString(this.params);
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "1.3.6.1.5.5.7.48.1.2";
    if (a != undefined) this.params = a;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.OCSPNonce, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.OCSPNoCheck = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.OCSPNoCheck.superclass.constructor.call(this, a);
    this.params = undefined;
    this.getExtnValueHex = function() {
        this.asn1ExtnValue = new $b1badb002678e3c8$var$KJUR.asn1.DERNull();
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "1.3.6.1.5.5.7.48.1.5";
    if (a != undefined) this.params = a;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.OCSPNoCheck, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.AdobeTimeStamp = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.AdobeTimeStamp.superclass.constructor.call(this, g);
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, f = b.DERInteger, d = b.DERBoolean, a = b.DERSequence, e = b.x509.GeneralName;
    this.params = null;
    this.getExtnValueHex = function() {
        var i = this.params;
        var h = [
            new f(1)
        ];
        h.push(new e({
            uri: i.uri
        }));
        if (i.reqauth != undefined) h.push(new d(i.reqauth));
        this.asn1ExtnValue = new a({
            array: h
        });
        return this.asn1ExtnValue.tohex();
    };
    this.oid = "1.2.840.113583.1.1.9.1";
    if (g !== undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.AdobeTimeStamp, $b1badb002678e3c8$var$KJUR.asn1.x509.Extension);
$b1badb002678e3c8$var$KJUR.asn1.x509.X500Name = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.superclass.constructor.call(this);
    this.asn1Array = [];
    this.paramArray = [];
    this.sRule = "utf8";
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, e = b.x509, d = e.RDN, a = $b1badb002678e3c8$var$pemtohex;
    this.setByString = function(g, l) {
        if (l !== undefined) this.sRule = l;
        var k = g.split("/");
        k.shift();
        var j = [];
        for(var m = 0; m < k.length; m++)if (k[m].match(/^[^=]+=.+$/)) j.push(k[m]);
        else {
            var h = j.length - 1;
            j[h] = j[h] + "/" + k[m];
        }
        for(var m = 0; m < j.length; m++)this.asn1Array.push(new d({
            str: j[m],
            rule: this.sRule
        }));
    };
    this.setByLdapString = function(g, h) {
        if (h !== undefined) this.sRule = h;
        var i = e.X500Name.ldapToCompat(g);
        this.setByString(i, h);
    };
    this.setByObject = function(j, i) {
        if (i !== undefined) this.sRule = i;
        for(var g in j)if (j.hasOwnProperty(g)) {
            var h = new d({
                str: g + "=" + j[g],
                rule: this.sRule
            });
            this.asn1Array ? this.asn1Array.push(h) : this.asn1Array = [
                h
            ];
        }
    };
    this.setByParam = function(h) {
        if (h.rule !== undefined) this.sRule = h.rule;
        if (h.array !== undefined) this.paramArray = h.array;
        else {
            if (h.str !== undefined) this.setByString(h.str);
            else if (h.ldapstr !== undefined) this.setByLdapString(h.ldapstr);
            else {
                if (h.hex !== undefined) this.hTLV = h.hex;
                else if (h.certissuer !== undefined) {
                    var g = new $b1badb002678e3c8$var$X509();
                    g.readCertPEM(h.certissuer);
                    this.hTLV = g.getIssuerHex();
                } else {
                    if (h.certsubject !== undefined) {
                        var g = new $b1badb002678e3c8$var$X509();
                        g.readCertPEM(h.certsubject);
                        this.hTLV = g.getSubjectHex();
                    } else if (typeof h === "object" && h.certsubject === undefined && h.certissuer === undefined) this.setByObject(h);
                }
            }
        }
    };
    this.tohex = function() {
        if (typeof this.hTLV == "string") return this.hTLV;
        if (this.asn1Array.length == 0 && this.paramArray.length > 0) for(var g = 0; g < this.paramArray.length; g++){
            var k = {
                array: this.paramArray[g]
            };
            if (this.sRule != "utf8") k.rule = this.sRule;
            var h = new d(k);
            this.asn1Array.push(h);
        }
        var j = new b.DERSequence({
            array: this.asn1Array
        });
        this.hTLV = j.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f !== undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.X500Name, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.compatToLDAP = function(d) {
    if (d.substr(0, 1) !== "/") throw "malformed input";
    var b = "";
    d = d.substr(1);
    var c = d.split("/");
    c.reverse();
    c = c.map(function(a) {
        return a.replace(/,/, "\\,");
    });
    return c.join(",");
};
$b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.onelineToLDAP = function(a) {
    return $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.compatToLDAP(a);
};
$b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.ldapToCompat = function(g) {
    var c = g.split(",");
    var e = false;
    var b = [];
    for(var f = 0; c.length > 0; f++){
        var h = c.shift();
        if (e === true) {
            var d = b.pop();
            var j = (d + "," + h).replace(/\\,/g, ",");
            b.push(j);
            e = false;
        } else b.push(h);
        if (h.substr(-1, 1) === "\\") e = true;
    }
    b = b.map(function(a) {
        return a.replace("/", "\\/");
    });
    b.reverse();
    return "/" + b.join("/");
};
$b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.ldapToOneline = function(a) {
    return $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name.ldapToCompat(a);
};
$b1badb002678e3c8$var$KJUR.asn1.x509.RDN = function(b) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.RDN.superclass.constructor.call(this);
    this.asn1Array = [];
    this.paramArray = [];
    this.sRule = "utf8";
    var a = $b1badb002678e3c8$var$KJUR.asn1.x509.AttributeTypeAndValue;
    this.setByParam = function(c) {
        if (c.rule !== undefined) this.sRule = c.rule;
        if (c.str !== undefined) this.addByMultiValuedString(c.str);
        if (c.array !== undefined) this.paramArray = c.array;
    };
    this.addByString = function(c) {
        this.asn1Array.push(new $b1badb002678e3c8$var$KJUR.asn1.x509.AttributeTypeAndValue({
            str: c,
            rule: this.sRule
        }));
    };
    this.addByMultiValuedString = function(e) {
        var c = $b1badb002678e3c8$var$KJUR.asn1.x509.RDN.parseString(e);
        for(var d = 0; d < c.length; d++)this.addByString(c[d]);
    };
    this.tohex = function() {
        if (this.asn1Array.length == 0 && this.paramArray.length > 0) for(var d = 0; d < this.paramArray.length; d++){
            var f = this.paramArray[d];
            if (f.rule !== undefined && this.sRule != "utf8") f.rule = this.sRule;
            var c = new a(f);
            this.asn1Array.push(c);
        }
        var e = new $b1badb002678e3c8$var$KJUR.asn1.DERSet({
            array: this.asn1Array
        });
        this.TLV = e.tohex();
        return this.TLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (b !== undefined) this.setByParam(b);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.RDN, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.RDN.parseString = function(m) {
    var j = m.split(/\+/);
    var h = false;
    var c = [];
    for(var g = 0; j.length > 0; g++){
        var k = j.shift();
        if (h === true) {
            var f = c.pop();
            var d = (f + "+" + k).replace(/\\\+/g, "+");
            c.push(d);
            h = false;
        } else c.push(k);
        if (k.substr(-1, 1) === "\\") h = true;
    }
    var l = false;
    var b = [];
    for(var g = 0; c.length > 0; g++){
        var k = c.shift();
        if (l === true) {
            var e = b.pop();
            if (k.match(/"$/)) {
                var d = (e + "+" + k).replace(/^([^=]+)="(.*)"$/, "$1=$2");
                b.push(d);
                l = false;
            } else b.push(e + "+" + k);
        } else b.push(k);
        if (k.match(/^[^=]+="/)) l = true;
    }
    return b;
};
$b1badb002678e3c8$var$KJUR.asn1.x509.AttributeTypeAndValue = function(c) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this);
    this.sRule = "utf8";
    this.sType = null;
    this.sValue = null;
    this.dsType = null;
    var a = $b1badb002678e3c8$var$KJUR, g = a.asn1, d = g.DERSequence, l = g.DERUTF8String, i = g.DERPrintableString, h = g.DERTeletexString, b = g.DERIA5String, e = g.DERVisibleString, k = g.DERBMPString, f = a.lang.String.isMail, j = a.lang.String.isPrintable;
    this.setByParam = function(o) {
        if (o.rule !== undefined) this.sRule = o.rule;
        if (o.ds !== undefined) this.dsType = o.ds;
        if (o.value === undefined && o.str !== undefined) {
            var n = o.str;
            var m = n.match(/^([^=]+)=(.+)$/);
            if (m) {
                this.sType = m[1];
                this.sValue = m[2];
            } else throw new Error("malformed attrTypeAndValueStr: " + attrTypeAndValueStr);
        } else {
            this.sType = o.type;
            this.sValue = o.value;
        }
    };
    this.setByString = function(n, o) {
        if (o !== undefined) this.sRule = o;
        var m = n.match(/^([^=]+)=(.+)$/);
        if (m) this.setByAttrTypeAndValueStr(m[1], m[2]);
        else throw new Error("malformed attrTypeAndValueStr: " + attrTypeAndValueStr);
    };
    this._getDsType = function() {
        var o = this.sType;
        var n = this.sValue;
        var m = this.sRule;
        if (m === "prn") {
            if (o == "CN" && f(n)) return "ia5";
            if (j(n)) return "prn";
            return "utf8";
        } else if (m === "utf8") {
            if (o == "CN" && f(n)) return "ia5";
            if (o == "C") return "prn";
            return "utf8";
        }
        return "utf8";
    };
    this.setByAttrTypeAndValueStr = function(o, n, m) {
        if (m !== undefined) this.sRule = m;
        this.sType = o;
        this.sValue = n;
    };
    this.getValueObj = function(n, m) {
        if (n == "utf8") return new l({
            str: m
        });
        if (n == "prn") return new i({
            str: m
        });
        if (n == "tel") return new h({
            str: m
        });
        if (n == "ia5") return new b({
            str: m
        });
        if (n == "vis") return new e({
            str: m
        });
        if (n == "bmp") return new k({
            str: m
        });
        throw new Error("unsupported directory string type: type=" + n + " value=" + m);
    };
    this.tohex = function() {
        if (this.dsType == null) this.dsType = this._getDsType();
        var n = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.atype2obj(this.sType);
        var m = this.getValueObj(this.dsType, this.sValue);
        var p = new d({
            array: [
                n,
                m
            ]
        });
        this.TLV = p.tohex();
        return this.TLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (c !== undefined) this.setByParam(c);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.AttributeTypeAndValue, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.SubjectPublicKeyInfo = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);
    var l = null, k = null, a = $b1badb002678e3c8$var$KJUR, j = a.asn1, i = j.DERInteger, b = j.DERBitString, m = j.DERObjectIdentifier, e = j.DERSequence, h = j.ASN1Util.newObject, d = j.x509, o = d.AlgorithmIdentifier, g = a.crypto, n = g.ECDSA, c = g.DSA;
    this.getASN1Object = function() {
        if (this.asn1AlgId == null || this.asn1SubjPKey == null) throw "algId and/or subjPubKey not set";
        var p = new e({
            array: [
                this.asn1AlgId,
                this.asn1SubjPKey
            ]
        });
        return p;
    };
    this.tohex = function() {
        var p = this.getASN1Object();
        this.hTLV = p.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setPubKey = function(q) {
        try {
            if (q instanceof $b1badb002678e3c8$var$RSAKey) {
                var u = h({
                    seq: [
                        {
                            "int": {
                                bigint: q.n
                            }
                        },
                        {
                            "int": {
                                "int": q.e
                            }
                        }
                    ]
                });
                var s = u.tohex();
                this.asn1AlgId = new o({
                    name: "rsaEncryption"
                });
                this.asn1SubjPKey = new b({
                    hex: "00" + s
                });
            }
        } catch (p) {}
        try {
            if (q instanceof $b1badb002678e3c8$var$KJUR.crypto.ECDSA) {
                var r = new m({
                    name: q.curveName
                });
                this.asn1AlgId = new o({
                    name: "ecPublicKey",
                    asn1params: r
                });
                this.asn1SubjPKey = new b({
                    hex: "00" + q.pubKeyHex
                });
            }
        } catch (p) {}
        try {
            if (q instanceof $b1badb002678e3c8$var$KJUR.crypto.DSA) {
                var r = new h({
                    seq: [
                        {
                            "int": {
                                bigint: q.p
                            }
                        },
                        {
                            "int": {
                                bigint: q.q
                            }
                        },
                        {
                            "int": {
                                bigint: q.g
                            }
                        }
                    ]
                });
                this.asn1AlgId = new o({
                    name: "dsa",
                    asn1params: r
                });
                var t = new i({
                    bigint: q.y
                });
                this.asn1SubjPKey = new b({
                    hex: "00" + t.tohex()
                });
            }
        } catch (p) {}
    };
    if (f !== undefined) this.setPubKey(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.SubjectPublicKeyInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.Time = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.Time.superclass.constructor.call(this);
    var e = null, a = null, d = $b1badb002678e3c8$var$KJUR, c = d.asn1, b = c.DERUTCTime, g = c.DERGeneralizedTime;
    this.params = null;
    this.type = null;
    this.setTimeParams = function(h) {
        this.timeParams = h;
    };
    this.setByParam = function(h) {
        this.params = h;
    };
    this.getType = function(h) {
        if (h.match(/^[0-9]{12}Z$/)) return "utc";
        if (h.match(/^[0-9]{14}Z$/)) return "gen";
        if (h.match(/^[0-9]{12}\.[0-9]+Z$/)) return "utc";
        if (h.match(/^[0-9]{14}\.[0-9]+Z$/)) return "gen";
        return null;
    };
    this.tohex = function() {
        var i = this.params;
        var h = null;
        if (typeof i == "string") i = {
            str: i
        };
        if (i != null && i.str && (i.type == null || i.type == undefined)) i.type = this.getType(i.str);
        if (i != null && i.str) {
            if (i.type == "utc") h = new b(i.str);
            if (i.type == "gen") h = new g(i.str);
        } else if (this.type == "gen") h = new g();
        else h = new b();
        if (h == null) throw new Error("wrong setting for Time");
        this.TLV = h.tohex();
        return this.TLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$KJUR.asn1.x509.Time_bak = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.Time_bak.superclass.constructor.call(this);
    var e = null, a = null, d = $b1badb002678e3c8$var$KJUR, c = d.asn1, b = c.DERUTCTime, g = c.DERGeneralizedTime;
    this.setTimeParams = function(h) {
        this.timeParams = h;
    };
    this.tohex = function() {
        var h = null;
        if (this.timeParams != null) {
            if (this.type == "utc") h = new b(this.timeParams);
            else h = new g(this.timeParams);
        } else if (this.type == "utc") h = new b();
        else h = new g();
        this.TLV = h.tohex();
        return this.TLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.type = "utc";
    if (f !== undefined) {
        if (f.type !== undefined) this.type = f.type;
        else if (f.str !== undefined) {
            if (f.str.match(/^[0-9]{12}Z$/)) this.type = "utc";
            if (f.str.match(/^[0-9]{14}Z$/)) this.type = "gen";
        }
        this.timeParams = f;
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.Time, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.AlgorithmIdentifier = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this);
    this.nameAlg = null;
    this.asn1Alg = null;
    this.asn1Params = null;
    this.paramEmpty = false;
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1, c = a.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
    this.tohex = function() {
        if (this.nameAlg === null && this.asn1Alg === null) throw new Error("algorithm not specified");
        if (this.nameAlg !== null) {
            var f = null;
            for(var h in c)if (h === this.nameAlg) f = c[h];
            if (f !== null) {
                this.hTLV = f;
                return this.hTLV;
            }
        }
        if (this.nameAlg !== null && this.asn1Alg === null) this.asn1Alg = a.x509.OID.name2obj(this.nameAlg);
        var g = [
            this.asn1Alg
        ];
        if (this.asn1Params !== null) g.push(this.asn1Params);
        var i = new a.DERSequence({
            array: g
        });
        this.hTLV = i.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) {
        if (e.name !== undefined) this.nameAlg = e.name;
        if (e.asn1params !== undefined) this.asn1Params = e.asn1params;
        if (e.paramempty !== undefined) this.paramEmpty = e.paramempty;
    }
    if (this.asn1Params === null && this.paramEmpty === false && this.nameAlg !== null) {
        if (this.nameAlg.name !== undefined) this.nameAlg = this.nameAlg.name;
        var d = this.nameAlg.toLowerCase();
        if (d.substr(-7, 7) !== "withdsa" && d.substr(-9, 9) !== "withecdsa") this.asn1Params = new a.DERNull();
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.AlgorithmIdentifier, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV = {
    SHAwithRSAandMGF1: "300d06092a864886f70d01010a3000",
    SHA256withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040201a11a301806092a864886f70d010108300b0609608648016503040201a203020120",
    SHA384withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040202a11a301806092a864886f70d010108300b0609608648016503040202a203020130",
    SHA512withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040203a11a301806092a864886f70d010108300b0609608648016503040203a203020140"
};
$b1badb002678e3c8$var$KJUR.asn1.x509.GeneralName = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.GeneralName.superclass.constructor.call(this);
    var l = {
        rfc822: "81",
        dns: "82",
        dn: "a4",
        uri: "86",
        ip: "87",
        otherName: "a0"
    }, b = $b1badb002678e3c8$var$KJUR, h = b.asn1, d = h.x509, a = d.X500Name, g = d.OtherName, e = h.DERIA5String, i = h.DERPrintableString, k = h.DEROctetString, c = h.DERTaggedObject, m = h.ASN1Object, j = Error;
    this.params = null;
    this.setByParam = function(n) {
        this.params = n;
    };
    this.tohex = function() {
        var p = this.params;
        var A, y, q;
        var y = false;
        if (p.other !== undefined) A = "a0", q = new g(p.other);
        else {
            if (p.rfc822 !== undefined) {
                A = "81";
                q = new e({
                    str: p.rfc822
                });
            } else if (p.dns !== undefined) {
                A = "82";
                q = new e({
                    str: p.dns
                });
            } else {
                if (p.dn !== undefined) {
                    A = "a4";
                    y = true;
                    if (typeof p.dn === "string") q = new a({
                        str: p.dn
                    });
                    else if (p.dn instanceof $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name) q = p.dn;
                    else q = new a(p.dn);
                } else if (p.ldapdn !== undefined) {
                    A = "a4";
                    y = true;
                    q = new a({
                        ldapstr: p.ldapdn
                    });
                } else {
                    if (p.certissuer !== undefined || p.certsubj !== undefined) {
                        A = "a4";
                        y = true;
                        var n, o;
                        var z = null;
                        if (p.certsubj !== undefined) {
                            n = false;
                            o = p.certsubj;
                        } else {
                            n = true;
                            o = p.certissuer;
                        }
                        o.match(/^[0-9A-Fa-f]+$/);
                        if (o.indexOf("-----BEGIN ") != -1) z = $b1badb002678e3c8$var$pemtohex(o);
                        if (z == null) throw new Error("certsubj/certissuer not cert");
                        var w = new $b1badb002678e3c8$var$X509();
                        w.hex = z;
                        var s;
                        if (n) s = w.getIssuerHex();
                        else s = w.getSubjectHex();
                        q = new m();
                        q.hTLV = s;
                    } else if (p.uri !== undefined) {
                        A = "86";
                        q = new e({
                            str: p.uri
                        });
                    } else {
                        if (p.ip !== undefined) {
                            A = "87";
                            var v;
                            var t = p.ip;
                            try {
                                if (t.match(/^[0-9a-f]+$/)) {
                                    var r = t.length;
                                    if (r == 8 || r == 16 || r == 32 || r == 64) v = t;
                                    else throw "err";
                                } else v = $b1badb002678e3c8$var$iptohex(t);
                            } catch (u) {
                                throw new j("malformed IP address: " + p.ip + ":" + u.message);
                            }
                            q = new k({
                                hex: v
                            });
                        } else throw new j("improper params");
                    }
                }
            }
        }
        var B = new c({
            tag: A,
            explicit: y,
            obj: q
        });
        return B.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f !== undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.GeneralName, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.GeneralNames = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.GeneralNames.superclass.constructor.call(this);
    var a = null, c = $b1badb002678e3c8$var$KJUR, b = c.asn1;
    this.setByParamArray = function(g) {
        for(var e = 0; e < g.length; e++){
            var f = new b.x509.GeneralName(g[e]);
            this.asn1Array.push(f);
        }
    };
    this.tohex = function() {
        var e = new b.DERSequence({
            array: this.asn1Array
        });
        return e.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.asn1Array = new Array();
    if (typeof d != "undefined") this.setByParamArray(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.GeneralNames, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.OtherName = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.x509.OtherName.superclass.constructor.call(this);
    var f = null, e = null, d = $b1badb002678e3c8$var$KJUR, c = d.asn1, h = c.DERObjectIdentifier, a = c.DERSequence, b = c.ASN1Util.newObject;
    this.params = null;
    this.setByParam = function(i) {
        this.params = i;
    };
    this.tohex = function() {
        var k = this.params;
        if (k.oid == undefined || k.value == undefined) throw new Error("oid or value not specified");
        var l = new h({
            oid: k.oid
        });
        var i = b({
            tag: {
                tag: "a0",
                explicit: true,
                obj: k.value
            }
        });
        var j = new a({
            array: [
                l,
                i
            ]
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g !== undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.x509.OtherName, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.x509.OID = new function() {
    var a = $b1badb002678e3c8$var$KJUR.asn1.DERObjectIdentifier;
    this.name2oidList = {
        sha1: "1.3.14.3.2.26",
        sha256: "2.16.840.1.101.3.4.2.1",
        sha384: "2.16.840.1.101.3.4.2.2",
        sha512: "2.16.840.1.101.3.4.2.3",
        sha224: "2.16.840.1.101.3.4.2.4",
        md5: "1.2.840.113549.2.5",
        md2: "1.3.14.7.2.2.1",
        ripemd160: "1.3.36.3.2.1",
        MD2withRSA: "1.2.840.113549.1.1.2",
        MD4withRSA: "1.2.840.113549.1.1.3",
        MD5withRSA: "1.2.840.113549.1.1.4",
        SHA1withRSA: "1.2.840.113549.1.1.5",
        "pkcs1-MGF": "1.2.840.113549.1.1.8",
        rsaPSS: "1.2.840.113549.1.1.10",
        SHA224withRSA: "1.2.840.113549.1.1.14",
        SHA256withRSA: "1.2.840.113549.1.1.11",
        SHA384withRSA: "1.2.840.113549.1.1.12",
        SHA512withRSA: "1.2.840.113549.1.1.13",
        SHA1withECDSA: "1.2.840.10045.4.1",
        SHA224withECDSA: "1.2.840.10045.4.3.1",
        SHA256withECDSA: "1.2.840.10045.4.3.2",
        SHA384withECDSA: "1.2.840.10045.4.3.3",
        SHA512withECDSA: "1.2.840.10045.4.3.4",
        dsa: "1.2.840.10040.4.1",
        SHA1withDSA: "1.2.840.10040.4.3",
        SHA224withDSA: "2.16.840.1.101.3.4.3.1",
        SHA256withDSA: "2.16.840.1.101.3.4.3.2",
        rsaEncryption: "1.2.840.113549.1.1.1",
        commonName: "2.5.4.3",
        countryName: "2.5.4.6",
        localityName: "2.5.4.7",
        stateOrProvinceName: "2.5.4.8",
        streetAddress: "2.5.4.9",
        organizationName: "2.5.4.10",
        organizationalUnitName: "2.5.4.11",
        domainComponent: "0.9.2342.19200300.100.1.25",
        userId: "0.9.2342.19200300.100.1.1",
        surname: "2.5.4.4",
        givenName: "2.5.4.42",
        title: "2.5.4.12",
        distinguishedName: "2.5.4.49",
        emailAddress: "1.2.840.113549.1.9.1",
        description: "2.5.4.13",
        businessCategory: "2.5.4.15",
        postalCode: "2.5.4.17",
        uniqueIdentifier: "2.5.4.45",
        organizationIdentifier: "2.5.4.97",
        jurisdictionOfIncorporationL: "1.3.6.1.4.1.311.60.2.1.1",
        jurisdictionOfIncorporationSP: "1.3.6.1.4.1.311.60.2.1.2",
        jurisdictionOfIncorporationC: "1.3.6.1.4.1.311.60.2.1.3",
        subjectDirectoryAttributes: "2.5.29.9",
        subjectKeyIdentifier: "2.5.29.14",
        keyUsage: "2.5.29.15",
        subjectAltName: "2.5.29.17",
        issuerAltName: "2.5.29.18",
        basicConstraints: "2.5.29.19",
        cRLNumber: "2.5.29.20",
        cRLReason: "2.5.29.21",
        nameConstraints: "2.5.29.30",
        cRLDistributionPoints: "2.5.29.31",
        certificatePolicies: "2.5.29.32",
        anyPolicy: "2.5.29.32.0",
        policyMappings: "2.5.29.33",
        authorityKeyIdentifier: "2.5.29.35",
        policyConstraints: "2.5.29.36",
        extKeyUsage: "2.5.29.37",
        inhibitAnyPolicy: "2.5.29.54",
        authorityInfoAccess: "1.3.6.1.5.5.7.1.1",
        ocsp: "1.3.6.1.5.5.7.48.1",
        ocspBasic: "1.3.6.1.5.5.7.48.1.1",
        ocspNonce: "1.3.6.1.5.5.7.48.1.2",
        ocspNoCheck: "1.3.6.1.5.5.7.48.1.5",
        caIssuers: "1.3.6.1.5.5.7.48.2",
        anyExtendedKeyUsage: "2.5.29.37.0",
        serverAuth: "1.3.6.1.5.5.7.3.1",
        clientAuth: "1.3.6.1.5.5.7.3.2",
        codeSigning: "1.3.6.1.5.5.7.3.3",
        emailProtection: "1.3.6.1.5.5.7.3.4",
        timeStamping: "1.3.6.1.5.5.7.3.8",
        ocspSigning: "1.3.6.1.5.5.7.3.9",
        smtpUTF8Mailbox: "1.3.6.1.5.5.7.8.9",
        dateOfBirth: "1.3.6.1.5.5.7.9.1",
        placeOfBirth: "1.3.6.1.5.5.7.9.2",
        gender: "1.3.6.1.5.5.7.9.3",
        countryOfCitizenship: "1.3.6.1.5.5.7.9.4",
        countryOfResidence: "1.3.6.1.5.5.7.9.5",
        ecPublicKey: "1.2.840.10045.2.1",
        "P-256": "1.2.840.10045.3.1.7",
        secp256r1: "1.2.840.10045.3.1.7",
        secp256k1: "1.3.132.0.10",
        secp384r1: "1.3.132.0.34",
        secp521r1: "1.3.132.0.35",
        pkcs5PBES2: "1.2.840.113549.1.5.13",
        pkcs5PBKDF2: "1.2.840.113549.1.5.12",
        "des-EDE3-CBC": "1.2.840.113549.3.7",
        data: "1.2.840.113549.1.7.1",
        "signed-data": "1.2.840.113549.1.7.2",
        "enveloped-data": "1.2.840.113549.1.7.3",
        "digested-data": "1.2.840.113549.1.7.5",
        "encrypted-data": "1.2.840.113549.1.7.6",
        "authenticated-data": "1.2.840.113549.1.9.16.1.2",
        tstinfo: "1.2.840.113549.1.9.16.1.4",
        signingCertificate: "1.2.840.113549.1.9.16.2.12",
        timeStampToken: "1.2.840.113549.1.9.16.2.14",
        signaturePolicyIdentifier: "1.2.840.113549.1.9.16.2.15",
        etsArchiveTimeStamp: "1.2.840.113549.1.9.16.2.27",
        signingCertificateV2: "1.2.840.113549.1.9.16.2.47",
        etsArchiveTimeStampV2: "1.2.840.113549.1.9.16.2.48",
        extensionRequest: "1.2.840.113549.1.9.14",
        contentType: "1.2.840.113549.1.9.3",
        messageDigest: "1.2.840.113549.1.9.4",
        signingTime: "1.2.840.113549.1.9.5",
        counterSignature: "1.2.840.113549.1.9.6",
        archiveTimeStampV3: "0.4.0.1733.2.4",
        pdfRevocationInfoArchival: "1.2.840.113583.1.1.8",
        adobeTimeStamp: "1.2.840.113583.1.1.9.1"
    };
    this.atype2oidList = {
        CN: "2.5.4.3",
        L: "2.5.4.7",
        ST: "2.5.4.8",
        O: "2.5.4.10",
        OU: "2.5.4.11",
        C: "2.5.4.6",
        STREET: "2.5.4.9",
        DC: "0.9.2342.19200300.100.1.25",
        UID: "0.9.2342.19200300.100.1.1",
        SN: "2.5.4.4",
        T: "2.5.4.12",
        DN: "2.5.4.49",
        E: "1.2.840.113549.1.9.1",
        description: "2.5.4.13",
        businessCategory: "2.5.4.15",
        postalCode: "2.5.4.17",
        serialNumber: "2.5.4.5",
        uniqueIdentifier: "2.5.4.45",
        organizationIdentifier: "2.5.4.97",
        jurisdictionOfIncorporationL: "1.3.6.1.4.1.311.60.2.1.1",
        jurisdictionOfIncorporationSP: "1.3.6.1.4.1.311.60.2.1.2",
        jurisdictionOfIncorporationC: "1.3.6.1.4.1.311.60.2.1.3"
    };
    this.objCache = {};
    this.name2obj = function(b) {
        if (typeof this.objCache[b] != "undefined") return this.objCache[b];
        if (typeof this.name2oidList[b] == "undefined") throw "Name of ObjectIdentifier not defined: " + b;
        var c = this.name2oidList[b];
        var d = new a({
            oid: c
        });
        this.objCache[b] = d;
        return d;
    };
    this.atype2obj = function(b) {
        if (this.objCache[b] !== undefined) return this.objCache[b];
        var c;
        if (b.match(/^\d+\.\d+\.[0-9.]+$/)) c = b;
        else if (this.atype2oidList[b] !== undefined) c = this.atype2oidList[b];
        else {
            if (this.name2oidList[b] !== undefined) c = this.name2oidList[b];
            else throw new Error("AttributeType name undefined: " + b);
        }
        var d = new a({
            oid: c
        });
        this.objCache[b] = d;
        return d;
    };
    this.registerOIDs = function(b) {
        if (!this.checkOIDs(b)) return;
        for(var c in b)this.name2oidList[c] = b[c];
    };
    this.checkOIDs = function(b) {
        try {
            var d = Object.keys(b);
            if (d.length == 0) return false;
            d.map(function(g, e, h) {
                var f = this[g];
                if (!f.match(/^[0-2]\.[0-9.]+$/)) throw new Error("value is not OID");
            }, b);
            return true;
        } catch (c) {
            return false;
        }
    };
};
$b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name = function(b) {
    var c = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.name2oidList;
    for(var a in c){
        if (c[a] == b) return a;
    }
    return "";
};
$b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2atype = function(b) {
    var c = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.atype2oidList;
    for(var a in c){
        if (c[a] == b) return a;
    }
    return b;
};
$b1badb002678e3c8$var$KJUR.asn1.x509.OID.name2oid = function(a) {
    if (a.match(/^[0-9.]+$/)) return a;
    var b = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.name2oidList;
    if (b[a] === undefined) return "";
    return b[a];
};
$b1badb002678e3c8$var$KJUR.asn1.x509.X509Util = {};
$b1badb002678e3c8$var$KJUR.asn1.x509.X509Util.newCertPEM = function(e) {
    var d = $b1badb002678e3c8$var$KJUR.asn1.x509, b = d.TBSCertificate, a = d.Certificate;
    var c = new a(e);
    return c.getPEM();
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1) $b1badb002678e3c8$var$KJUR.asn1 = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1.cms == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1.cms) $b1badb002678e3c8$var$KJUR.asn1.cms = {};
$b1badb002678e3c8$var$KJUR.asn1.cms.Attribute = function(f) {
    var e = Error, d = $b1badb002678e3c8$var$KJUR, c = d.asn1, b = c.DERSequence, a = c.DERSet, g = c.DERObjectIdentifier;
    this.params = null;
    this.typeOid = null;
    this.setByParam = function(h) {
        this.params = h;
    };
    this.getValueArray = function() {
        throw new e("not yet implemented abstract");
    };
    this.tohex = function() {
        var j = new g({
            oid: this.typeOid
        });
        var h = new a({
            array: this.getValueArray()
        });
        var i = new b({
            array: [
                j,
                h
            ]
        });
        return i.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.Attribute, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.ContentType = function(c) {
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1;
    a.cms.ContentType.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.3";
    this.getValueArray = function() {
        var d = new a.DERObjectIdentifier(this.params.type);
        return [
            d
        ];
    };
    if (c != undefined) this.setByParam(c);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.ContentType, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cms.MessageDigest = function(e) {
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1, c = a.DEROctetString, d = a.cms;
    d.MessageDigest.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.4";
    this.getValueArray = function() {
        var f = new c(this.params);
        return [
            f
        ];
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.MessageDigest, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cms.SigningTime = function(c) {
    var b = $b1badb002678e3c8$var$KJUR, a = b.asn1;
    a.cms.SigningTime.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.5";
    this.getValueArray = function() {
        var d = new a.x509.Time(this.params);
        return [
            d
        ];
    };
    if (c != undefined) this.setByParam(c);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SigningTime, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cms.SigningCertificate = function(h) {
    var e = Error, d = $b1badb002678e3c8$var$KJUR, c = d.asn1, b = c.DERSequence, g = c.cms, a = g.ESSCertID, f = d.crypto;
    g.SigningCertificate.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.16.2.12";
    this.getValueArray = function() {
        if (this.params == null || this.params == undefined || this.params.array == undefined) throw new e("parameter 'array' not specified");
        var o = this.params.array;
        var k = [];
        for(var l = 0; l < o.length; l++){
            var n = o[l];
            if (h.hasis == false && typeof n == "string" && (n.indexOf("-----BEGIN") != -1 || $b1badb002678e3c8$var$ASN1HEX.isASN1HEX(n))) n = {
                cert: n
            };
            if (n.hasis != false && h.hasis == false) n.hasis = false;
            k.push(new a(n));
        }
        var j = new b({
            array: k
        });
        var m = new b({
            array: [
                j
            ]
        });
        return [
            m
        ];
    };
    if (h != undefined) this.setByParam(h);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SigningCertificate, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertID = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertID.superclass.constructor.call(this);
    var d = Error, c = $b1badb002678e3c8$var$KJUR, b = c.asn1, f = b.DEROctetString, a = b.DERSequence, e = b.cms.IssuerSerial;
    this.params = null;
    this.getCertHash = function(k, h) {
        if (k.hash != undefined) return k.hash;
        if (typeof k == "string" && k.indexOf("-----BEGIN") == -1 && !$b1badb002678e3c8$var$ASN1HEX.isASN1HEX(k)) return k;
        var i;
        if (typeof k == "string") i = k;
        else {
            if (k.cert != undefined) i = k.cert;
            else throw new d("hash nor cert unspecified");
        }
        var j;
        if (i.indexOf("-----BEGIN") != -1) j = $b1badb002678e3c8$var$pemtohex(i);
        else j = i;
        if (typeof k == "string") {
            if (k.indexOf("-----BEGIN") != -1) j = $b1badb002678e3c8$var$pemtohex(k);
            else if ($b1badb002678e3c8$var$ASN1HEX.isASN1HEX(k)) j = k;
        }
        var l;
        if (k.alg != undefined) l = k.alg;
        else {
            if (h != undefined) l = h;
            else throw new d("hash alg unspecified");
        }
        return c.crypto.Util.hashHex(j, l);
    };
    this.tohex = function() {
        var k = this.params;
        var j = this.getCertHash(k, "sha1");
        var h = [];
        h.push(new f({
            hex: j
        }));
        if (typeof k == "string" && k.indexOf("-----BEGIN") != -1 || k.cert != undefined && k.hasis != false || k.issuer != undefined && k.serial != undefined) h.push(new e(k));
        var i = new a({
            array: h
        });
        return i.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertID, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.SigningCertificateV2 = function(d) {
    var h = Error, a = $b1badb002678e3c8$var$KJUR, g = a.asn1, e = g.DERSequence, b = g.x509, i = g.cms, c = i.ESSCertIDv2, f = a.crypto;
    i.SigningCertificateV2.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.16.2.47";
    this.getValueArray = function() {
        if (this.params == null || this.params == undefined || this.params.array == undefined) throw new h("parameter 'array' not specified");
        var o = this.params.array;
        var l = [];
        for(var m = 0; m < o.length; m++){
            var n = o[m];
            if ((d.alg != undefined || d.hasis == false) && typeof n == "string" && (n.indexOf("-----BEGIN") != -1 || $b1badb002678e3c8$var$ASN1HEX.isASN1HEX(n))) n = {
                cert: n
            };
            if (n.alg == undefined && d.alg != undefined) n.alg = d.alg;
            if (n.hasis != false && d.hasis == false) n.hasis = false;
            l.push(new c(n));
        }
        var k = new e({
            array: l
        });
        var j = new e({
            array: [
                k
            ]
        });
        return [
            j
        ];
    };
    if (d != undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SigningCertificateV2, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertIDv2 = function(h) {
    $b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertIDv2.superclass.constructor.call(this);
    var d = Error, c = $b1badb002678e3c8$var$KJUR, b = c.asn1, f = b.DEROctetString, a = b.DERSequence, e = b.cms.IssuerSerial, g = b.x509.AlgorithmIdentifier;
    this.params = null;
    this.tohex = function() {
        var l = this.params;
        var k = this.getCertHash(l, "sha256");
        var i = [];
        if (l.alg != undefined && l.alg != "sha256") i.push(new g({
            name: l.alg
        }));
        i.push(new f({
            hex: k
        }));
        if (typeof l == "string" && l.indexOf("-----BEGIN") != -1 || l.cert != undefined && l.hasis != false || l.issuer != undefined && l.serial != undefined) i.push(new e(l));
        var j = new a({
            array: i
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (h != undefined) this.setByParam(h);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertIDv2, $b1badb002678e3c8$var$KJUR.asn1.cms.ESSCertID);
$b1badb002678e3c8$var$KJUR.asn1.cms.IssuerSerial = function(e) {
    var i = Error, c = $b1badb002678e3c8$var$KJUR, h = c.asn1, g = h.DERInteger, f = h.DERSequence, j = h.cms, d = h.x509, a = d.GeneralNames, b = $b1badb002678e3c8$var$X509;
    j.IssuerSerial.superclass.constructor.call(this);
    this.setByParam = function(k) {
        this.params = k;
    };
    this.tohex = function() {
        var p = this.params;
        var l, r;
        if (typeof p == "string" && p.indexOf("-----BEGIN") != -1 || p.cert != undefined) {
            var n;
            if (p.cert != undefined) n = p.cert;
            else n = p;
            var k = new b();
            k.readCertPEM(n);
            l = k.getIssuer();
            r = {
                hex: k.getSerialNumberHex()
            };
        } else {
            if (p.issuer != undefined && p.serial) {
                l = p.issuer;
                r = p.serial;
            } else throw new i("cert or issuer and serial parameter not specified");
        }
        var q = new a([
            {
                dn: l
            }
        ]);
        var o = new g(r);
        var m = new f({
            array: [
                q,
                o
            ]
        });
        return m.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.IssuerSerial, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.SignerIdentifier = function(f) {
    var c = $b1badb002678e3c8$var$KJUR, i = c.asn1, h = i.DERInteger, g = i.DERSequence, l = i.cms, k = l.IssuerAndSerialNumber, d = l.SubjectKeyIdentifier, e = i.x509, a = e.X500Name, b = $b1badb002678e3c8$var$X509, j = Error;
    l.SignerIdentifier.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var o = this.params;
        if (o.type == "isssn") {
            var m = new k(o);
            return m.tohex();
        } else {
            if (o.type == "skid") {
                var n = new d(o);
                return n.tohex();
            } else throw new Error("wrong property for isssn or skid");
        }
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SignerIdentifier, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.IssuerAndSerialNumber = function(e) {
    var c = $b1badb002678e3c8$var$KJUR, h = c.asn1, g = h.DERInteger, f = h.DERSequence, j = h.cms, d = h.x509, a = d.X500Name, b = $b1badb002678e3c8$var$X509, i = Error;
    j.IssuerAndSerialNumber.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var p = this.params;
        var l, r;
        if (typeof p == "string" && p.indexOf("-----BEGIN") != -1 || p.cert != undefined) {
            var n;
            if (p.cert != undefined) n = p.cert;
            else n = p;
            var k = new b();
            k.readCertPEM(n);
            l = k.getIssuer();
            r = {
                hex: k.getSerialNumberHex()
            };
        } else {
            if (p.issuer != undefined && p.serial) {
                l = p.issuer;
                r = p.serial;
            } else throw new i("cert or issuer and serial parameter not specified");
        }
        var q = new a(l);
        var o = new g(r);
        var m = new f({
            array: [
                q,
                o
            ]
        });
        return m.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(k) {
        this.params = k;
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.IssuerAndSerialNumber, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.SubjectKeyIdentifier = function(g) {
    var d = $b1badb002678e3c8$var$KJUR, k = d.asn1, i = k.DERInteger, h = k.DERSequence, j = k.ASN1Util.newObject, m = k.cms, f = m.IssuerAndSerialName, c = m.SubjectKeyIdentifier, e = k.x509, a = e.X500Name, b = $b1badb002678e3c8$var$X509, l = Error;
    m.SubjectKeyIdentifier.superclass.constructor.call(this);
    this.tohex = function() {
        var r = this.params;
        if (r.cert == undefined && r.skid == undefined) throw new l("property cert nor skid undefined");
        var q;
        if (r.cert != undefined) {
            var n = new b(r.cert);
            var o = n.getExtSubjectKeyIdentifier();
            q = o.kid.hex;
        } else if (r.skid != undefined) q = r.skid;
        var p = j({
            tag: {
                tage: "a0",
                obj: {
                    octstr: {
                        hex: q
                    }
                }
            }
        });
        return p.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SubjectKeyIdentifier, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.AttributeList = function(f) {
    var d = Error, c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSet, e = b.cms;
    e.AttributeList.superclass.constructor.call(this);
    this.params = null;
    this.hTLV = null;
    this.setByParam = function(g) {
        this.params = g;
    };
    this.tohex = function() {
        var o = this.params;
        if (this.hTLV != null) return this.hTLV;
        var m = true;
        if (o.sortflag != undefined) m = o.sortflag;
        var j = o.array;
        var g = [];
        for(var l = 0; l < j.length; l++){
            var n = j[l];
            var k = n.attr;
            if (k == "contentType") g.push(new e.ContentType(n));
            else if (k == "messageDigest") g.push(new e.MessageDigest(n));
            else {
                if (k == "signingTime") g.push(new e.SigningTime(n));
                else if (k == "signingCertificate") g.push(new e.SigningCertificate(n));
                else {
                    if (k == "signingCertificateV2") g.push(new e.SigningCertificateV2(n));
                    else if (k == "signaturePolicyIdentifier") g.push(new $b1badb002678e3c8$var$KJUR.asn1.cades.SignaturePolicyIdentifier(n));
                    else {
                        if (k == "signatureTimeStamp" || k == "timeStampToken") g.push(new $b1badb002678e3c8$var$KJUR.asn1.cades.SignatureTimeStamp(n));
                        else throw new d("unknown attr: " + k);
                    }
                }
            }
        }
        var h = new a({
            array: g,
            sortflag: m
        });
        this.hTLV = h.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.AttributeList, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.SignerInfo = function(q) {
    var n = Error, r = $b1badb002678e3c8$var$KJUR, i = r.asn1, c = i.DERInteger, f = i.DEROctetString, h = i.DERSequence, m = i.DERTaggedObject, k = i.cms, p = k.SignerIdentifier, l = k.AttributeList, g = k.ContentType, e = k.EncapsulatedContentInfo, d = k.MessageDigest, j = k.SignedData, a = i.x509, s = a.AlgorithmIdentifier, b = r.crypto, o = $b1badb002678e3c8$var$KEYUTIL;
    k.SignerInfo.superclass.constructor.call(this);
    this.params = null;
    this.sign = function() {
        var y = this.params;
        var x = y.sigalg;
        var u = new l(y.sattrs).tohex();
        var v = o.getKey(y.signkey);
        var w = new b.Signature({
            alg: x
        });
        w.init(v);
        w.updateHex(u);
        var t = w.sign();
        y.sighex = t;
    };
    this.tohex = function() {
        var w = this.params;
        var t = [];
        t.push(new c({
            "int": w.version
        }));
        t.push(new p(w.id));
        t.push(new s({
            name: w.hashalg
        }));
        if (w.sattrs != undefined) {
            var x = new l(w.sattrs);
            try {
                t.push(new m({
                    tag: "a0",
                    explicit: false,
                    obj: x
                }));
            } catch (v) {
                throw new n("si sattr error: " + v);
            }
        }
        if (w.sigalgfield != undefined) t.push(new s({
            name: w.sigalgfield
        }));
        else t.push(new s({
            name: w.sigalg
        }));
        if (w.sighex == undefined && w.signkey != undefined) this.sign();
        t.push(new f({
            hex: w.sighex
        }));
        if (w.uattrs != undefined) {
            var x = new l(w.uattrs);
            try {
                t.push(new m({
                    tag: "a1",
                    explicit: false,
                    obj: x
                }));
            } catch (v) {
                throw new n("si uattr error: " + v);
            }
        }
        var u = new h({
            array: t
        });
        return u.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (q != undefined) this.setByParam(q);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SignerInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.EncapsulatedContentInfo = function(g) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, e = b.DERTaggedObject, a = b.DERSequence, h = b.DERObjectIdentifier, d = b.DEROctetString, f = b.cms;
    f.EncapsulatedContentInfo.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var m = this.params;
        var i = [];
        i.push(new h(m.type));
        if (m.content != undefined && (m.content.hex != undefined || m.content.str != undefined) && m.isDetached != true) {
            var k = new d(m.content);
            var l = new e({
                tag: "a0",
                explicit: true,
                obj: k
            });
            i.push(l);
        }
        var j = new a({
            array: i
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(i) {
        this.params = i;
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.EncapsulatedContentInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.ContentInfo = function(g) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, d = b.DERTaggedObject, a = b.DERSequence, h = b.DERObjectIdentifier, f = b.x509, e = f.OID.name2obj;
    $b1badb002678e3c8$var$KJUR.asn1.cms.ContentInfo.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var l = this.params;
        var i = [];
        i.push(new h(l.type));
        var k = new d({
            tag: "a0",
            explicit: true,
            obj: l.obj
        });
        i.push(k);
        var j = new a({
            array: i
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(i) {
        this.params = i;
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.ContentInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.SignedData = function(e) {
    var j = Error, a = $b1badb002678e3c8$var$KJUR, h = a.asn1, m = h.ASN1Object, g = h.DERInteger, p = h.DERSet, f = h.DERSequence, b = h.DERTaggedObject, o = h.cms, l = o.EncapsulatedContentInfo, d = o.SignerInfo, q = o.ContentInfo, k = o.CertificateSet, i = o.RevocationInfoChoices, c = h.x509, n = c.AlgorithmIdentifier;
    $b1badb002678e3c8$var$KJUR.asn1.cms.SignedData.superclass.constructor.call(this);
    this.params = null;
    this.checkAndFixParam = function() {
        var r = this.params;
        this._setDigestAlgs(r);
        this._setContentTypeByEContent(r);
        this._setMessageDigestByEContent(r);
        this._setSignerInfoVersion(r);
        this._setSignedDataVersion(r);
    };
    this._setDigestAlgs = function(v) {
        var u = {};
        var t = v.sinfos;
        for(var r = 0; r < t.length; r++){
            var s = t[r];
            u[s.hashalg] = 1;
        }
        v.hashalgs = Object.keys(u).sort();
    };
    this._setContentTypeByEContent = function(w) {
        var u = w.econtent.type;
        var v = w.sinfos;
        for(var r = 0; r < v.length; r++){
            var t = v[r];
            var s = this._getAttrParamByName(t, "contentType");
            s.type = u;
        }
    };
    this._setMessageDigestByEContent = function(r) {
        var v = r.econtent;
        var y = r.econtent.type;
        var x = v.content.hex;
        if (x == undefined && v.type == "data" && v.content.str != undefined) x = $b1badb002678e3c8$var$rstrtohex(v.content.str);
        var A = r.sinfos;
        for(var u = 0; u < A.length; u++){
            var t = A[u];
            var s = t.hashalg;
            var z = this._getAttrParamByName(t, "messageDigest");
            var w = $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(x, s);
            z.hex = w;
        }
    };
    this._getAttrParamByName = function(t, s) {
        var u = t.sattrs.array;
        for(var r = 0; r < u.length; r++){
            if (u[r].attr == s) return u[r];
        }
    };
    this._setSignerInfoVersion = function(v) {
        var t = v.sinfos;
        for(var r = 0; r < t.length; r++){
            var s = t[r];
            var u = 1;
            if (s.id.type == "skid") u = 3;
            s.version = u;
        }
    };
    this._setSignedDataVersion = function(s) {
        var r = this._getSignedDataVersion(s);
        s.version = r;
    };
    this._getSignedDataVersion = function(w) {
        if (w.revinfos != undefined) {
            var r = w.revinfos;
            for(var t = 0; t < r.length; t++){
                var s = r[t];
                if (s.ocsp != undefined) return 5;
            }
        }
        var v = w.sinfos;
        for(var t = 0; t < v.length; t++){
            var u = w.sinfos[t];
            if (u.version == 3) return 3;
        }
        if (w.econtent.type != "data") return 3;
        return 1;
    };
    this.tohex = function() {
        var y = this.params;
        if (this.getEncodedHexPrepare != undefined) this.getEncodedHexPrepare();
        if (y.fixed != true) this.checkAndFixParam();
        var r = [];
        r.push(new g({
            "int": y.version
        }));
        var w = [];
        for(var v = 0; v < y.hashalgs.length; v++){
            var t = y.hashalgs[v];
            w.push(new n({
                name: t
            }));
        }
        r.push(new p({
            array: w
        }));
        r.push(new l(y.econtent));
        if (y.certs != undefined) r.push(new k(y.certs));
        if (y.revinfos != undefined) r.push(new i(y.revinfos));
        var u = [];
        for(var v = 0; v < y.sinfos.length; v++){
            var x = y.sinfos[v];
            u.push(new d(x));
        }
        r.push(new p({
            array: u
        }));
        var s = new f({
            array: r
        });
        return s.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.getContentInfo = function() {
        var r = new q({
            type: "signed-data",
            obj: this
        });
        return r;
    };
    this.getContentInfoEncodedHex = function() {
        return this.getContentInfo().tohex();
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.SignedData, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.CertificateSet = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.cms.CertificateSet.superclass.constructor.call(this);
    var c = Error, b = $b1badb002678e3c8$var$KJUR.asn1, e = b.DERTaggedObject, a = b.DERSet, d = b.ASN1Object;
    this.params = null;
    this.tohex = function() {
        var j = this.params;
        var p = [];
        var q;
        if (j instanceof Array) q = j;
        else {
            if (j.array != undefined) q = j.array;
            else throw new c("cert array not specified");
        }
        for(var k = 0; k < q.length; k++){
            var l = q[k];
            var n = $b1badb002678e3c8$var$pemtohex(l);
            var g = new d();
            g.hTLV = n;
            p.push(g);
        }
        var m = {
            array: p
        };
        if (j.sortflag == false) m.sortflag = false;
        var o = new a(m);
        var h = new e({
            tag: "a0",
            explicit: false,
            obj: o
        });
        return h.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.CertificateSet, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoices = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoices.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var e = this.params;
        if (!e instanceof Array) throw new Error("params is not array");
        var b = [];
        for(var c = 0; c < e.length; c++)b.push(new $b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoice(e[c]));
        var d = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.newObject({
            tag: {
                tagi: "a1",
                obj: {
                    set: b
                }
            }
        });
        return d.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (a != undefined) this.setByParam(a);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoices, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoice = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoice.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var d = this.params;
        if (d.crl != undefined && typeof d.crl == "string") {
            var b = d.crl;
            if (d.crl.indexOf("-----BEGIN") != -1) b = $b1badb002678e3c8$var$pemtohex(d.crl);
            return b;
        } else {
            if (d.ocsp != undefined) {
                var c = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.newObject({
                    tag: {
                        tagi: "a1",
                        obj: new $b1badb002678e3c8$var$KJUR.asn1.cms.OtherRevocationFormat(d)
                    }
                });
                return c.tohex();
            } else throw new Error("property crl or ocsp undefined");
        }
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (a != undefined) this.setByParam(a);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.RevocationInfoChoice, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.OtherRevocationFormat = function(f) {
    $b1badb002678e3c8$var$KJUR.asn1.cms.OtherRevocationFormat.superclass.constructor.call(this);
    var d = Error, c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.ASN1Util.newObject, e = c.lang.String.isHex;
    this.params = null;
    this.tohex = function() {
        var h = this.params;
        if (h.ocsp == undefined) throw new d("property ocsp not specified");
        if (!e(h.ocsp) || !$b1badb002678e3c8$var$ASN1HEX.isASN1HEX(h.ocsp)) throw new d("ocsp value not ASN.1 hex string");
        var g = a({
            seq: [
                {
                    oid: "1.3.6.1.5.5.7.16.2"
                },
                {
                    asn1: {
                        tlv: h.ocsp
                    }
                }
            ]
        });
        return g.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cms.OtherRevocationFormat, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cms.CMSUtil = new function() {};
$b1badb002678e3c8$var$KJUR.asn1.cms.CMSUtil.newSignedData = function(a) {
    return new $b1badb002678e3c8$var$KJUR.asn1.cms.SignedData(a);
};
$b1badb002678e3c8$var$KJUR.asn1.cms.CMSUtil.verifySignedData = function(n) {
    var C = $b1badb002678e3c8$var$KJUR, p = C.asn1, s = p.cms, D = s.SignerInfo, q = s.SignedData, y = s.SigningTime, b = s.SigningCertificate, d = s.SigningCertificateV2, A = p.cades, u = A.SignaturePolicyIdentifier, i = C.lang.String.isHex, v = $b1badb002678e3c8$var$ASN1HEX, h = v.getVbyList, a = v.getTLVbyList, t = v.getIdxbyList, z = v.getChildIdx, c = v.getTLV, B = v.oidname, j = C.crypto.Util.hashHex;
    n.cms === undefined && i(n.cms);
    var E = n.cms;
    var g = function(J, H) {
        var G;
        for(var I = 3; I < 6; I++){
            G = t(J, 0, [
                1,
                0,
                I
            ]);
            if (G !== undefined) {
                var F = J.substr(G, 2);
                if (F === "a0") H.certsIdx = G;
                if (F === "a1") H.revinfosIdx = G;
                if (F === "31") H.signerinfosIdx = G;
            }
        }
    };
    var l = function(I, F) {
        var H = F.signerinfosIdx;
        if (H === undefined) return;
        var L = z(I, H);
        F.signerInfoIdxList = L;
        for(var G = 0; G < L.length; G++){
            var K = L[G];
            var J = {
                idx: K
            };
            k(I, J);
            F.signerInfos.push(J);
        }
    };
    var k = function(I, J) {
        var F = J.idx;
        J.signerid_issuer1 = a(I, F, [
            1,
            0
        ], "30");
        J.signerid_serial1 = h(I, F, [
            1,
            1
        ], "02");
        J.hashalg = B(h(I, F, [
            2,
            0
        ], "06"));
        var H = t(I, F, [
            3
        ], "a0");
        J.idxSignedAttrs = H;
        f(I, J, H);
        var G = z(I, F);
        var K = G.length;
        if (K < 6) throw "malformed SignerInfo";
        J.sigalg = B(h(I, F, [
            K - 2,
            0
        ], "06"));
        J.sigval = h(I, F, [
            K - 1
        ], "04");
    };
    var f = function(L, M, F) {
        var J = z(L, F);
        M.signedAttrIdxList = J;
        for(var K = 0; K < J.length; K++){
            var I = J[K];
            var G = h(L, I, [
                0
            ], "06");
            var H;
            if (G === "2a864886f70d010905") {
                H = $b1badb002678e3c8$var$hextoutf8(h(L, I, [
                    1,
                    0
                ]));
                M.saSigningTime = H;
            } else if (G === "2a864886f70d010904") {
                H = h(L, I, [
                    1,
                    0
                ], "04");
                M.saMessageDigest = H;
            }
        }
    };
    var w = function(G, F) {
        if (h(G, 0, [
            0
        ], "06") !== "2a864886f70d010702") return F;
        F.cmsType = "signedData";
        F.econtent = h(G, 0, [
            1,
            0,
            2,
            1,
            0
        ]);
        g(G, F);
        F.signerInfos = [];
        l(G, F);
    };
    var o = function(J, F) {
        var G = F.parse.signerInfos;
        var L = G.length;
        var K = true;
        for(var I = 0; I < L; I++){
            var H = G[I];
            e(J, F, H, I);
            if (!H.isValid) K = false;
        }
        F.isValid = K;
    };
    var x = function(F, Q, J, P) {
        var N = Q.parse.certsIdx;
        var H;
        if (Q.certs === undefined) {
            H = [];
            Q.certkeys = [];
            var K = z(F, N);
            for(var I = 0; I < K.length; I++){
                var M = c(F, K[I]);
                var O = new $b1badb002678e3c8$var$X509();
                O.readCertHex(M);
                H[I] = O;
                Q.certkeys[I] = O.getPublicKey();
            }
            Q.certs = H;
        } else H = Q.certs;
        Q.cccc = H.length;
        Q.cccci = K.length;
        for(var I = 0; I < H.length; I++){
            var L = O.getIssuerHex();
            var G = O.getSerialNumberHex();
            if (J.signerid_issuer1 === L && J.signerid_serial1 === G) J.certkey_idx = I;
        }
    };
    var e = function(F, R, I, N) {
        I.verifyDetail = {};
        var Q = I.verifyDetail;
        var K = R.parse.econtent;
        var G = I.hashalg;
        var L = I.saMessageDigest;
        Q.validMessageDigest = false;
        if (j(K, G) === L) Q.validMessageDigest = true;
        x(F, R, I, N);
        Q.validSignatureValue = false;
        var H = I.sigalg;
        var M = "31" + c(F, I.idxSignedAttrs).substr(2);
        I.signedattrshex = M;
        var J = R.certs[I.certkey_idx].getPublicKey();
        var P = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: H
        });
        P.init(J);
        P.updateHex(M);
        var O = P.verify(I.sigval);
        Q.validSignatureValue_isValid = O;
        if (O === true) Q.validSignatureValue = true;
        I.isValid = false;
        if (Q.validMessageDigest && Q.validSignatureValue) I.isValid = true;
    };
    var m = function() {};
    var r = {
        isValid: false,
        parse: {}
    };
    w(E, r.parse);
    o(E, r);
    return r;
};
$b1badb002678e3c8$var$KJUR.asn1.cms.CMSParser = function() {
    var g = Error, a = $b1badb002678e3c8$var$X509, h = new a(), l = $b1badb002678e3c8$var$ASN1HEX, i = l.getV, b = l.getTLV, f = l.getIdxbyList, c = l.getTLVbyList, d = l.getTLVbyListEx, e = l.getVbyList, k = l.getVbyListEx, j = l.getChildIdx;
    this.getCMSSignedData = function(m) {
        var o = c(m, 0, [
            1,
            0
        ]);
        var n = this.getSignedData(o);
        return n;
    };
    this.getSignedData = function(o) {
        var q = j(o, 0);
        var v = {};
        var p = i(o, q[0]);
        var n = parseInt(p, 16);
        v.version = n;
        var r = b(o, q[1]);
        v.hashalgs = this.getHashAlgArray(r);
        var t = b(o, q[2]);
        v.econtent = this.getEContent(t);
        var m = d(o, 0, [
            "[0]"
        ]);
        if (m != null) v.certs = this.getCertificateSet(m);
        var u = d(o, 0, [
            "[1]"
        ]);
        u;
        var s = d(o, 0, [
            3
        ]);
        v.sinfos = this.getSignerInfos(s);
        return v;
    };
    this.getHashAlgArray = function(s) {
        var q = j(s, 0);
        var m = new a();
        var n = [];
        for(var r = 0; r < q.length; r++){
            var p = b(s, q[r]);
            var o = m.getAlgorithmIdentifierName(p);
            n.push(o);
        }
        return n;
    };
    this.getEContent = function(m) {
        var n = {};
        var p = e(m, 0, [
            0
        ]);
        var o = e(m, 0, [
            1,
            0
        ]);
        n.type = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name($b1badb002678e3c8$var$ASN1HEX.hextooidstr(p));
        n.content = {
            hex: o
        };
        return n;
    };
    this.getSignerInfos = function(p) {
        var r = [];
        var m = j(p, 0);
        for(var n = 0; n < m.length; n++){
            var o = b(p, m[n]);
            var q = this.getSignerInfo(o);
            r.push(q);
        }
        return r;
    };
    this.getSignerInfo = function(s) {
        var y = {};
        var u = j(s, 0);
        var q = l.getInt(s, u[0], -1);
        if (q != -1) y.version = q;
        var t = b(s, u[1]);
        var p = this.getIssuerAndSerialNumber(t);
        y.id = p;
        var z = b(s, u[2]);
        var n = h.getAlgorithmIdentifierName(z);
        y.hashalg = n;
        var w = d(s, 0, [
            "[0]"
        ]);
        if (w != null) {
            var A = this.getAttributeList(w);
            y.sattrs = A;
        }
        var m = d(s, 0, [
            3
        ]);
        var x = h.getAlgorithmIdentifierName(m);
        y.sigalg = x;
        var o = k(s, 0, [
            4
        ]);
        y.sighex = o;
        var r = d(s, 0, [
            "[1]"
        ]);
        if (r != null) {
            var v = this.getAttributeList(r);
            y.uattrs = v;
        }
        return y;
    };
    this.getSignerIdentifier = function(m) {
        if (m.substr(0, 2) == "30") return this.getIssuerAndSerialNumber(m);
        else throw new Error("SKID of signerIdentifier not supported");
    };
    this.getIssuerAndSerialNumber = function(n) {
        var o = {
            type: "isssn"
        };
        var m = j(n, 0);
        var p = b(n, m[0]);
        o.issuer = h.getX500Name(p);
        var q = i(n, m[1]);
        o.serial = {
            hex: q
        };
        return o;
    };
    this.getAttributeList = function(q) {
        var m = [];
        var n = j(q, 0);
        for(var o = 0; o < n.length; o++){
            var p = b(q, n[o]);
            var r = this.getAttribute(p);
            m.push(r);
        }
        return {
            array: m
        };
    };
    this.getAttribute = function(p) {
        var t = {};
        var q = j(p, 0);
        var o = l.getOID(p, q[0]);
        var m = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name(o);
        t.attr = m;
        var r = b(p, q[1]);
        var u = j(r, 0);
        if (u.length == 1) t.valhex = b(r, u[0]);
        else {
            var s = [];
            for(var n = 0; n < u.length; n++)s.push(b(r, u[n]));
            t.valhex = s;
        }
        if (m == "contentType") this.setContentType(t);
        else if (m == "messageDigest") this.setMessageDigest(t);
        else {
            if (m == "signingTime") this.setSigningTime(t);
            else if (m == "signingCertificate") this.setSigningCertificate(t);
            else {
                if (m == "signingCertificateV2") this.setSigningCertificateV2(t);
                else if (m == "signaturePolicyIdentifier") this.setSignaturePolicyIdentifier(t);
            }
        }
        return t;
    };
    this.setContentType = function(m) {
        var n = l.getOIDName(m.valhex, 0, null);
        if (n != null) {
            m.type = n;
            delete m.valhex;
        }
    };
    this.setSigningTime = function(o) {
        var n = i(o.valhex, 0);
        var m = $b1badb002678e3c8$var$hextoutf8(n);
        o.str = m;
        delete o.valhex;
    };
    this.setMessageDigest = function(m) {
        var n = i(m.valhex, 0);
        m.hex = n;
        delete m.valhex;
    };
    this.setSigningCertificate = function(n) {
        var q = j(n.valhex, 0);
        if (q.length > 0) {
            var m = b(n.valhex, q[0]);
            var p = j(m, 0);
            var t = [];
            for(var o = 0; o < p.length; o++){
                var s = b(m, p[o]);
                var u = this.getESSCertID(s);
                t.push(u);
            }
            n.array = t;
        }
        if (q.length > 1) {
            var r = b(n.valhex, q[1]);
            n.polhex = r;
        }
        delete n.valhex;
    };
    this.setSignaturePolicyIdentifier = function(s) {
        var q = j(s.valhex, 0);
        if (q.length > 0) {
            var r = l.getOID(s.valhex, q[0]);
            s.oid = r;
        }
        if (q.length > 1) {
            var m = new a();
            var t = j(s.valhex, q[1]);
            var p = b(s.valhex, t[0]);
            var o = m.getAlgorithmIdentifierName(p);
            s.alg = o;
            var n = i(s.valhex, t[1]);
            s.hash = n;
        }
        delete s.valhex;
    };
    this.setSigningCertificateV2 = function(o) {
        var s = j(o.valhex, 0);
        if (s.length > 0) {
            var n = b(o.valhex, s[0]);
            var r = j(n, 0);
            var u = [];
            for(var q = 0; q < r.length; q++){
                var m = b(n, r[q]);
                var p = this.getESSCertIDv2(m);
                u.push(p);
            }
            o.array = u;
        }
        if (s.length > 1) {
            var t = b(o.valhex, s[1]);
            o.polhex = t;
        }
        delete o.valhex;
    };
    this.getESSCertID = function(o) {
        var p = {};
        var n = j(o, 0);
        if (n.length > 0) {
            var q = i(o, n[0]);
            p.hash = q;
        }
        if (n.length > 1) {
            var m = b(o, n[1]);
            var r = this.getIssuerSerial(m);
            if (r.serial != undefined) p.serial = r.serial;
            if (r.issuer != undefined) p.issuer = r.issuer;
        }
        return p;
    };
    this.getESSCertIDv2 = function(q) {
        var s = {};
        var p = j(q, 0);
        if (p.length < 1 || 3 < p.length) throw new g("wrong number of elements");
        var r = 0;
        if (q.substr(p[0], 2) == "30") {
            var o = b(q, p[0]);
            s.alg = h.getAlgorithmIdentifierName(o);
            r++;
        } else s.alg = "sha256";
        var n = i(q, p[r]);
        s.hash = n;
        if (p.length > r + 1) {
            var m = b(q, p[r + 1]);
            var t = this.getIssuerSerial(m);
            s.issuer = t.issuer;
            s.serial = t.serial;
        }
        return s;
    };
    this.getIssuerSerial = function(q) {
        var r = {};
        var n = j(q, 0);
        var m = b(q, n[0]);
        var p = h.getGeneralNames(m);
        var o = p[0].dn;
        r.issuer = o;
        var s = i(q, n[1]);
        r.serial = {
            hex: s
        };
        return r;
    };
    this.getCertificateSet = function(p) {
        var n = j(p, 0);
        var m = [];
        for(var o = 0; o < n.length; o++){
            var r = b(p, n[o]);
            if (r.substr(0, 2) == "30") {
                var q = $b1badb002678e3c8$var$hextopem(r, "CERTIFICATE");
                m.push(q);
            }
        }
        return {
            array: m,
            sortflag: false
        };
    };
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1) $b1badb002678e3c8$var$KJUR.asn1 = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1.tsp == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1.tsp) $b1badb002678e3c8$var$KJUR.asn1.tsp = {};
$b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampToken = function(d) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.tsp;
    a.TimeStampToken.superclass.constructor.call(this);
    this.params = null;
    this.getEncodedHexPrepare = function() {
        var e = new a.TSTInfo(this.params.econtent.content);
        this.params.econtent.content.hex = e.tohex();
    };
    if (d != undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampToken, $b1badb002678e3c8$var$KJUR.asn1.cms.SignedData);
$b1badb002678e3c8$var$KJUR.asn1.tsp.TSTInfo = function(f) {
    var m = Error, c = $b1badb002678e3c8$var$KJUR, j = c.asn1, g = j.DERSequence, i = j.DERInteger, l = j.DERBoolean, h = j.DERGeneralizedTime, n = j.DERObjectIdentifier, e = j.DERTaggedObject, k = j.tsp, d = k.MessageImprint, b = k.Accuracy, a = j.x509.X500Name, o = j.x509.GeneralName;
    k.TSTInfo.superclass.constructor.call(this);
    this.dVersion = new i({
        "int": 1
    });
    this.dPolicy = null;
    this.dMessageImprint = null;
    this.dSerial = null;
    this.dGenTime = null;
    this.dAccuracy = null;
    this.dOrdering = null;
    this.dNonce = null;
    this.dTsa = null;
    this.tohex = function() {
        var p = [
            this.dVersion
        ];
        if (this.dPolicy == null) throw new Error("policy shall be specified.");
        p.push(this.dPolicy);
        if (this.dMessageImprint == null) throw new Error("messageImprint shall be specified.");
        p.push(this.dMessageImprint);
        if (this.dSerial == null) throw new Error("serialNumber shall be specified.");
        p.push(this.dSerial);
        if (this.dGenTime == null) throw new Error("genTime shall be specified.");
        p.push(this.dGenTime);
        if (this.dAccuracy != null) p.push(this.dAccuracy);
        if (this.dOrdering != null) p.push(this.dOrdering);
        if (this.dNonce != null) p.push(this.dNonce);
        if (this.dTsa != null) p.push(this.dTsa);
        var q = new g({
            array: p
        });
        this.hTLV = q.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f !== undefined) {
        if (typeof f.policy == "string") {
            if (!f.policy.match(/^[0-9.]+$/)) throw "policy shall be oid like 0.1.4.134";
            this.dPolicy = new n({
                oid: f.policy
            });
        }
        if (f.messageImprint !== undefined) this.dMessageImprint = new d(f.messageImprint);
        if (f.serial !== undefined) this.dSerial = new i(f.serial);
        if (f.genTime !== undefined) this.dGenTime = new h(f.genTime);
        if (f.accuracy !== undefined) this.dAccuracy = new b(f.accuracy);
        if (f.ordering !== undefined && f.ordering == true) this.dOrdering = new l();
        if (f.nonce !== undefined) this.dNonce = new i(f.nonce);
        if (f.tsa !== undefined) this.dTsa = new e({
            tag: "a0",
            explicit: true,
            obj: new o({
                dn: f.tsa
            })
        });
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.TSTInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.Accuracy = function(d) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.ASN1Util.newObject;
    b.tsp.Accuracy.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var f = this.params;
        var e = [];
        if (f.seconds != undefined && typeof f.seconds == "number") e.push({
            "int": f.seconds
        });
        if (f.millis != undefined && typeof f.millis == "number") e.push({
            tag: {
                tagi: "80",
                obj: {
                    "int": f.millis
                }
            }
        });
        if (f.micros != undefined && typeof f.micros == "number") e.push({
            tag: {
                tagi: "81",
                obj: {
                    "int": f.micros
                }
            }
        });
        return a({
            seq: e
        }).tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (d != undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.Accuracy, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.MessageImprint = function(g) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSequence, d = b.DEROctetString, f = b.x509, e = f.AlgorithmIdentifier;
    b.tsp.MessageImprint.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var k = this.params;
        var j = new e({
            name: k.alg
        });
        var h = new d({
            hex: k.hash
        });
        var i = new a({
            array: [
                j,
                h
            ]
        });
        return i.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g !== undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.MessageImprint, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampReq = function(c) {
    var a = $b1badb002678e3c8$var$KJUR, f = a.asn1, d = f.DERSequence, e = f.DERInteger, h = f.DERBoolean, j = f.ASN1Object, i = f.DERObjectIdentifier, g = f.tsp, b = g.MessageImprint;
    g.TimeStampReq.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var m = this.params;
        var k = [];
        k.push(new e({
            "int": 1
        }));
        if (m.messageImprint instanceof $b1badb002678e3c8$var$KJUR.asn1.ASN1Object) k.push(m.messageImprint);
        else k.push(new b(m.messageImprint));
        if (m.policy != undefined) k.push(new i(m.policy));
        if (m.nonce != undefined) k.push(new e(m.nonce));
        if (m.certreq == true) k.push(new h());
        var l = new d({
            array: k
        });
        return l.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (c != undefined) this.setByParam(c);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampReq, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampResp = function(g) {
    var e = $b1badb002678e3c8$var$KJUR, d = e.asn1, c = d.DERSequence, f = d.ASN1Object, a = d.tsp, b = a.PKIStatusInfo;
    a.TimeStampResp.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var j = this.params;
        var h = [];
        if (j.econtent != undefined || j.tst != undefined) {
            if (j.statusinfo != undefined) h.push(new b(j.statusinfo));
            else h.push(new b("granted"));
            if (j.econtent != undefined) h.push(new a.TimeStampToken(j).getContentInfo());
            else {
                if (j.tst instanceof d.ASN1Object) h.push(j.tst);
                else throw new Error("improper member tst value");
            }
        } else {
            if (j.statusinfo != undefined) h.push(new b(j.statusinfo));
            else throw new Error("parameter for token nor statusinfo not specified");
        }
        var i = new c({
            array: h
        });
        return i.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampResp, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.PKIStatusInfo = function(d) {
    var h = Error, a = $b1badb002678e3c8$var$KJUR, g = a.asn1, e = g.DERSequence, i = g.tsp, f = i.PKIStatus, c = i.PKIFreeText, b = i.PKIFailureInfo;
    i.PKIStatusInfo.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var l = this.params;
        var j = [];
        if (typeof l == "string") j.push(new f(l));
        else {
            if (l.status == undefined) throw new h("property 'status' unspecified");
            j.push(new f(l.status));
            if (l.statusstr != undefined) j.push(new c(l.statusstr));
            if (l.failinfo != undefined) j.push(new b(l.failinfo));
        }
        var k = new e({
            array: j
        });
        return k.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (d != undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.PKIStatusInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.PKIStatus = function(g) {
    var e = Error, d = $b1badb002678e3c8$var$KJUR, c = d.asn1, f = c.DERInteger, b = c.tsp;
    b.PKIStatus.superclass.constructor.call(this);
    var a = {
        granted: 0,
        grantedWithMods: 1,
        rejection: 2,
        waiting: 3,
        revocationWarning: 4,
        revocationNotification: 5
    };
    this.params = null;
    this.tohex = function() {
        var k = this.params;
        var h, j;
        if (typeof k == "string") try {
            j = a[k];
        } catch (i) {
            throw new e("undefined name: " + k);
        }
        else {
            if (typeof k == "number") j = k;
            else throw new e("unsupported params");
        }
        return new f({
            "int": j
        }).tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.PKIStatus, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.PKIFreeText = function(g) {
    var f = Error, e = $b1badb002678e3c8$var$KJUR, d = e.asn1, b = d.DERSequence, c = d.DERUTF8String, a = d.tsp;
    a.PKIFreeText.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var l = this.params;
        if (!l instanceof Array) throw new f("wrong params: not array");
        var h = [];
        for(var k = 0; k < l.length; k++)h.push(new c({
            str: l[k]
        }));
        var j = new b({
            array: h
        });
        return j.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.PKIFreeText, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.PKIFailureInfo = function(h) {
    var f = Error, e = $b1badb002678e3c8$var$KJUR, d = e.asn1, g = d.DERBitString, b = d.tsp, c = b.PKIFailureInfo;
    var a = {
        badAlg: 0,
        badRequest: 2,
        badDataFormat: 5,
        timeNotAvailable: 14,
        unacceptedPolicy: 15,
        unacceptedExtension: 16,
        addInfoNotAvailable: 17,
        systemFailure: 25
    };
    c.superclass.constructor.call(this);
    this.params = null;
    this.getBinValue = function() {
        var n = this.params;
        var m = 0;
        if (typeof n == "number" && 0 <= n && n <= 25) {
            m |= 1 << n;
            var k = m.toString(2);
            var l = "";
            for(var j = k.length - 1; j >= 0; j--)l += k[j];
            return l;
        } else {
            if (typeof n == "string" && a[n] != undefined) return $b1badb002678e3c8$var$namearraytobinstr([
                n
            ], a);
            else {
                if (typeof n == "object" && n.length != undefined) return $b1badb002678e3c8$var$namearraytobinstr(n, a);
                else throw new f("wrong params");
            }
        }
        return;
    };
    this.tohex = function() {
        var j = this.params;
        var i = this.getBinValue();
        return new g({
            bin: i
        }).tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (h != undefined) this.setByParam(h);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.PKIFailureInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.tsp.AbstractTSAAdapter = function(a) {
    this.getTSTHex = function(c, b) {
        throw "not implemented yet";
    };
};
$b1badb002678e3c8$var$KJUR.asn1.tsp.SimpleTSAAdapter = function(e) {
    var d = $b1badb002678e3c8$var$KJUR, c = d.asn1, a = c.tsp, b = d.crypto.Util.hashHex;
    a.SimpleTSAAdapter.superclass.constructor.call(this);
    this.params = null;
    this.serial = 0;
    this.getTSTHex = function(g, f) {
        var i = b(g, f);
        this.params.econtent.content.messageImprint = {
            alg: f,
            hash: i
        };
        this.params.econtent.content.serial = {
            "int": this.serial++
        };
        var h = Math.floor(Math.random() * 1000000000);
        this.params.econtent.content.nonce = {
            "int": h
        };
        var j = new a.TimeStampToken(this.params);
        return j.getContentInfoEncodedHex();
    };
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.SimpleTSAAdapter, $b1badb002678e3c8$var$KJUR.asn1.tsp.AbstractTSAAdapter);
$b1badb002678e3c8$var$KJUR.asn1.tsp.FixedTSAAdapter = function(e) {
    var d = $b1badb002678e3c8$var$KJUR, c = d.asn1, a = c.tsp, b = d.crypto.Util.hashHex;
    a.FixedTSAAdapter.superclass.constructor.call(this);
    this.params = null;
    this.getTSTHex = function(g, f) {
        var h = b(g, f);
        this.params.econtent.content.messageImprint = {
            alg: f,
            hash: h
        };
        var i = new a.TimeStampToken(this.params);
        return i.getContentInfoEncodedHex();
    };
    if (e !== undefined) this.params = e;
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.tsp.FixedTSAAdapter, $b1badb002678e3c8$var$KJUR.asn1.tsp.AbstractTSAAdapter);
$b1badb002678e3c8$var$KJUR.asn1.tsp.TSPUtil = new function() {};
$b1badb002678e3c8$var$KJUR.asn1.tsp.TSPUtil.newTimeStampToken = function(a) {
    return new $b1badb002678e3c8$var$KJUR.asn1.tsp.TimeStampToken(a);
};
$b1badb002678e3c8$var$KJUR.asn1.tsp.TSPUtil.parseTimeStampReq = function(a) {
    var b = new $b1badb002678e3c8$var$KJUR.asn1.tsp.TSPParser();
    return b.getTimeStampReq(a);
};
$b1badb002678e3c8$var$KJUR.asn1.tsp.TSPUtil.parseMessageImprint = function(a) {
    var b = new $b1badb002678e3c8$var$KJUR.asn1.tsp.TSPParser();
    return b.getMessageImprint(a);
};
$b1badb002678e3c8$var$KJUR.asn1.tsp.TSPParser = function() {
    var e = Error, a = $b1badb002678e3c8$var$X509, f = new a(), k = $b1badb002678e3c8$var$ASN1HEX, g = k.getV, b = k.getTLV, d = k.getIdxbyList, c = k.getTLVbyListEx, i = k.getChildIdx;
    var j = [
        "granted",
        "grantedWithMods",
        "rejection",
        "waiting",
        "revocationWarning",
        "revocationNotification"
    ];
    var h = {
        0: "badAlg",
        2: "badRequest",
        5: "badDataFormat",
        14: "timeNotAvailable",
        15: "unacceptedPolicy",
        16: "unacceptedExtension",
        17: "addInfoNotAvailable",
        25: "systemFailure"
    };
    this.getResponse = function(n) {
        var l = i(n, 0);
        if (l.length == 1) return this.getPKIStatusInfo(b(n, l[0]));
        else if (l.length > 1) {
            var o = this.getPKIStatusInfo(b(n, l[0]));
            var m = b(n, l[1]);
            var p = this.getToken(m);
            p.statusinfo = o;
            return p;
        }
    };
    this.getToken = function(m) {
        var l = new $b1badb002678e3c8$var$KJUR.asn1.cms.CMSParser;
        var n = l.getCMSSignedData(m);
        this.setTSTInfo(n);
        return n;
    };
    this.setTSTInfo = function(l) {
        var o = l.econtent;
        if (o.type == "tstinfo") {
            var n = o.content.hex;
            var m = this.getTSTInfo(n);
            o.content = m;
        }
    };
    this.getTSTInfo = function(r) {
        var x = {};
        var s = i(r, 0);
        var p = g(r, s[1]);
        x.policy = $b1badb002678e3c8$var$hextooid(p);
        var o = b(r, s[2]);
        x.messageImprint = this.getMessageImprint(o);
        var u = g(r, s[3]);
        x.serial = {
            hex: u
        };
        var y = g(r, s[4]);
        x.genTime = {
            str: $b1badb002678e3c8$var$hextoutf8(y)
        };
        var q = 0;
        if (s.length > 5 && r.substr(s[5], 2) == "30") {
            var v = b(r, s[5]);
            x.accuracy = this.getAccuracy(v);
            q++;
        }
        if (s.length > 5 + q && r.substr(s[5 + q], 2) == "01") {
            var z = g(r, s[5 + q]);
            if (z == "ff") x.ordering = true;
            q++;
        }
        if (s.length > 5 + q && r.substr(s[5 + q], 2) == "02") {
            var n = g(r, s[5 + q]);
            x.nonce = {
                hex: n
            };
            q++;
        }
        if (s.length > 5 + q && r.substr(s[5 + q], 2) == "a0") {
            var m = b(r, s[5 + q]);
            m = "30" + m.substr(2);
            pGeneralNames = f.getGeneralNames(m);
            var t = pGeneralNames[0].dn;
            x.tsa = t;
            q++;
        }
        if (s.length > 5 + q && r.substr(s[5 + q], 2) == "a1") {
            var l = b(r, s[5 + q]);
            l = "30" + l.substr(2);
            var w = f.getExtParamArray(l);
            x.ext = w;
            q++;
        }
        return x;
    };
    this.getAccuracy = function(q) {
        var r = {};
        var o = i(q, 0);
        for(var p = 0; p < o.length; p++){
            var m = q.substr(o[p], 2);
            var l = g(q, o[p]);
            var n = parseInt(l, 16);
            if (m == "02") r.seconds = n;
            else {
                if (m == "80") r.millis = n;
                else if (m == "81") r.micros = n;
            }
        }
        return r;
    };
    this.getMessageImprint = function(n) {
        if (n.substr(0, 2) != "30") throw new Error("head of messageImprint hex shall be x30");
        var s = {};
        var l = i(n, 0);
        var t = d(n, 0, [
            0,
            0
        ]);
        var o = g(n, t);
        var p = k.hextooidstr(o);
        var r = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name(p);
        if (r == "") throw new Error("hashAlg name undefined: " + p);
        var m = r;
        var q = d(n, 0, [
            1
        ]);
        s.alg = m;
        s.hash = g(n, q);
        return s;
    };
    this.getPKIStatusInfo = function(o) {
        var t = {};
        var r = i(o, 0);
        var n = 0;
        try {
            var l = g(o, r[0]);
            var p = parseInt(l, 16);
            t.status = j[p];
        } catch (s) {}
        if (r.length > 1 && o.substr(r[1], 2) == "30") {
            var m = b(o, r[1]);
            t.statusstr = this.getPKIFreeText(m);
            n++;
        }
        if (r.length > n && o.substr(r[1 + n], 2) == "03") {
            var q = b(o, r[1 + n]);
            t.failinfo = this.getPKIFailureInfo(q);
        }
        return t;
    };
    this.getPKIFreeText = function(n) {
        var o = [];
        var l = i(n, 0);
        for(var m = 0; m < l.length; m++)o.push(k.getString(n, l[m]));
        return o;
    };
    this.getPKIFailureInfo = function(l) {
        var m = k.getInt(l, 0);
        if (h[m] != undefined) return h[m];
        else return m;
    };
    this.getTimeStampReq = function(q) {
        var p = {};
        p.certreq = false;
        var s = i(q, 0);
        if (s.length < 2) throw new Error("TimeStampReq must have at least 2 items");
        var n = b(q, s[1]);
        p.messageImprint = $b1badb002678e3c8$var$KJUR.asn1.tsp.TSPUtil.parseMessageImprint(n);
        for(var o = 2; o < s.length; o++){
            var m = s[o];
            var l = q.substr(m, 2);
            if (l == "06") {
                var r = g(q, m);
                p.policy = k.hextooidstr(r);
            }
            if (l == "02") p.nonce = g(q, m);
            if (l == "01") p.certreq = true;
        }
        return p;
    };
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1) $b1badb002678e3c8$var$KJUR.asn1 = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1.cades == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1.cades) $b1badb002678e3c8$var$KJUR.asn1.cades = {};
$b1badb002678e3c8$var$KJUR.asn1.cades.SignaturePolicyIdentifier = function(e) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.cades, d = a.SignaturePolicyId;
    a.SignaturePolicyIdentifier.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.16.2.15";
    this.params = null;
    this.getValueArray = function() {
        return [
            new d(this.params)
        ];
    };
    this.setByParam = function(f) {
        this.params = f;
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.SignaturePolicyIdentifier, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cades.SignaturePolicyId = function(e) {
    var a = $b1badb002678e3c8$var$KJUR, g = a.asn1, f = g.DERSequence, i = g.DERObjectIdentifier, d = g.x509, j = d.AlgorithmIdentifier, c = g.cades, h = c.SignaturePolicyId, b = c.OtherHashAlgAndValue;
    h.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var m = this.params;
        var k = [];
        k.push(new i(m.oid));
        k.push(new b(m));
        var l = new f({
            array: k
        });
        return l.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(k) {
        this.params = k;
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.SignaturePolicyId, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cades.OtherHashAlgAndValue = function(e) {
    var h = Error, a = $b1badb002678e3c8$var$KJUR, g = a.asn1, f = g.DERSequence, i = g.DEROctetString, d = g.x509, j = d.AlgorithmIdentifier, c = g.cades, b = c.OtherHashAlgAndValue;
    b.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var o = this.params;
        if (o.alg == undefined) throw new h("property 'alg' not specified");
        if (o.hash == undefined && o.cert == undefined) throw new h("property 'hash' nor 'cert' not specified");
        var m = null;
        if (o.hash != undefined) m = o.hash;
        else if (o.cert != undefined) {
            if (typeof o.cert != "string") throw new h("cert not string");
            var n = o.cert;
            if (o.cert.indexOf("-----BEGIN") != -1) n = $b1badb002678e3c8$var$pemtohex(o.cert);
            m = $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(n, o.alg);
        }
        var k = [];
        k.push(new j({
            name: o.alg
        }));
        k.push(new i({
            hex: m
        }));
        var l = new f({
            array: k
        });
        return l.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.OtherHashAlgAndValue, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cades.OtherHashValue = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.cades.OtherHashValue.superclass.constructor.call(this);
    var d = Error, c = $b1badb002678e3c8$var$KJUR, f = c.lang.String.isHex, b = c.asn1, e = b.DEROctetString, a = c.crypto.Util.hashHex;
    this.params = null;
    this.tohex = function() {
        var j = this.params;
        if (j.hash == undefined && j.cert == undefined) throw new d("hash or cert not specified");
        var h = null;
        if (j.hash != undefined) h = j.hash;
        else if (j.cert != undefined) {
            if (typeof j.cert != "string") throw new d("cert not string");
            var i = j.cert;
            if (j.cert.indexOf("-----BEGIN") != -1) i = $b1badb002678e3c8$var$pemtohex(j.cert);
            h = $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(i, "sha1");
        }
        return new e({
            hex: h
        }).tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.OtherHashValue, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cades.SignatureTimeStamp = function(h) {
    var d = Error, c = $b1badb002678e3c8$var$KJUR, f = c.lang.String.isHex, b = c.asn1, e = b.ASN1Object, g = b.x509, a = b.cades;
    a.SignatureTimeStamp.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.16.2.14";
    this.params = null;
    this.getValueArray = function() {
        var l = this.params;
        if (l.tst != undefined) {
            if (f(l.tst)) {
                var j = new e();
                j.hTLV = l.tst;
                return [
                    j
                ];
            } else {
                if (l.tst instanceof e) return [
                    l.tst
                ];
                else throw new d("params.tst has wrong value");
            }
        } else if (l.res != undefined) {
            var k = l.res;
            if (k instanceof e) k = k.tohex();
            if (typeof k != "string" || !f(k)) throw new d("params.res has wrong value");
            var i = $b1badb002678e3c8$var$ASN1HEX.getTLVbyList(k, 0, [
                1
            ]);
            var j = new e();
            j.hTLV = l.tst;
            return [
                j
            ];
        }
    };
    if (h != null) this.setByParam(h);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.SignatureTimeStamp, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cades.CompleteCertificateRefs = function(h) {
    var f = Error, e = $b1badb002678e3c8$var$KJUR, d = e.asn1, b = d.DERSequence, c = d.cades, a = c.OtherCertID, g = e.lang.String.isHex;
    c.CompleteCertificateRefs.superclass.constructor.call(this);
    this.typeOid = "1.2.840.113549.1.9.16.2.21";
    this.params = null;
    this.getValueArray = function() {
        var o = this.params;
        var k = [];
        for(var m = 0; m < o.array.length; m++){
            var n = o.array[m];
            if (typeof n == "string") {
                if (n.indexOf("-----BEGIN") != -1) n = {
                    cert: n
                };
                else {
                    if (g(n)) n = {
                        hash: n
                    };
                    else throw new f("unsupported value: " + n);
                }
            }
            if (o.alg != undefined && n.alg == undefined) n.alg = o.alg;
            if (o.hasis != undefined && n.hasis == undefined) n.hasis = o.hasis;
            var j = new a(n);
            k.push(j);
        }
        var l = new b({
            array: k
        });
        return [
            l
        ];
    };
    if (h != undefined) this.setByParam(h);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.CompleteCertificateRefs, $b1badb002678e3c8$var$KJUR.asn1.cms.Attribute);
$b1badb002678e3c8$var$KJUR.asn1.cades.OtherCertID = function(e) {
    var a = $b1badb002678e3c8$var$KJUR, h = a.asn1, f = h.DERSequence, i = h.cms, g = i.IssuerSerial, c = h.cades, d = c.OtherHashValue, b = c.OtherHashAlgAndValue;
    c.OtherCertID.superclass.constructor.call(this);
    this.params = e;
    this.tohex = function() {
        var n = this.params;
        if (typeof n == "string") {
            if (n.indexOf("-----BEGIN") != -1) n = {
                cert: n
            };
            else if (_isHex(n)) n = {
                hash: n
            };
        }
        var j = [];
        var m = null;
        if (n.alg != undefined) m = new b(n);
        else m = new d(n);
        j.push(m);
        if (n.cert != undefined && n.hasis == true || n.issuer != undefined && n.serial != undefined) {
            var l = new g(n);
            j.push(l);
        }
        var k = new f({
            array: j
        });
        return k.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e != undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.OtherCertID, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cades.OtherHash = function(g) {
    var i = Error, a = $b1badb002678e3c8$var$KJUR, h = a.asn1, j = h.cms, c = h.cades, b = c.OtherHashAlgAndValue, e = c.OtherHashValue, d = a.crypto.Util.hashHex, f = a.lang.String.isHex;
    c.OtherHash.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var l = this.params;
        if (typeof l == "string") {
            if (l.indexOf("-----BEGIN") != -1) l = {
                cert: l
            };
            else if (f(l)) l = {
                hash: l
            };
        }
        var k = null;
        if (l.alg != undefined) k = new b(l);
        else k = new e(l);
        return k.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g != undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.cades.OtherHash, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.cades.CAdESUtil = new function() {};
$b1badb002678e3c8$var$KJUR.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned = function(a) {
    var c = new $b1badb002678e3c8$var$KJUR.asn1.cms.CMSParser();
    var b = c.getCMSSignedData(a);
    return b;
};
$b1badb002678e3c8$var$KJUR.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned = function(g, q, c) {
    var p = $b1badb002678e3c8$var$ASN1HEX, s = p.getChildIdx, a = p.getTLV, l = p.getV, v = $b1badb002678e3c8$var$KJUR, h = v.asn1, n = h.ASN1Object, j = h.cms, k = j.AttributeList, w = j.SignerInfo;
    var o = {};
    var t = s(g, q);
    if (t.length != 6) throw "not supported items for SignerInfo (!=6)";
    var d = t.shift();
    o.version = a(g, d);
    var e = t.shift();
    o.si = a(g, e);
    var m = t.shift();
    o.digalg = a(g, m);
    var f = t.shift();
    o.sattrs = a(g, f);
    var i = t.shift();
    o.sigalg = a(g, i);
    var b = t.shift();
    o.sig = a(g, b);
    o.sigval = l(g, b);
    var u = null;
    o.obj = new w();
    u = new n();
    u.hTLV = o.version;
    o.obj.dCMSVersion = u;
    u = new n();
    u.hTLV = o.si;
    o.obj.dSignerIdentifier = u;
    u = new n();
    u.hTLV = o.digalg;
    o.obj.dDigestAlgorithm = u;
    u = new n();
    u.hTLV = o.sattrs;
    o.obj.dSignedAttrs = u;
    u = new n();
    u.hTLV = o.sigalg;
    o.obj.dSigAlg = u;
    u = new n();
    u.hTLV = o.sig;
    o.obj.dSig = u;
    o.obj.dUnsignedAttrs = new k();
    return o;
};
if (typeof $b1badb002678e3c8$var$KJUR.asn1.csr == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1.csr) $b1badb002678e3c8$var$KJUR.asn1.csr = {};
$b1badb002678e3c8$var$KJUR.asn1.csr.CertificationRequest = function(g) {
    var d = $b1badb002678e3c8$var$KJUR, c = d.asn1, e = c.DERBitString, b = c.DERSequence, a = c.csr, f = c.x509, h = a.CertificationRequestInfo;
    a.CertificationRequest.superclass.constructor.call(this);
    this.setByParam = function(i) {
        this.params = i;
    };
    this.sign = function() {
        var j = new h(this.params).tohex();
        var k = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: this.params.sigalg
        });
        k.init(this.params.sbjprvkey);
        k.updateHex(j);
        var i = k.sign();
        this.params.sighex = i;
    };
    this.getPEM = function() {
        return $b1badb002678e3c8$var$hextopem(this.tohex(), "CERTIFICATE REQUEST");
    };
    this.tohex = function() {
        var l = this.params;
        var j = new $b1badb002678e3c8$var$KJUR.asn1.csr.CertificationRequestInfo(this.params);
        var m = new $b1badb002678e3c8$var$KJUR.asn1.x509.AlgorithmIdentifier({
            name: l.sigalg
        });
        if (l.sighex == undefined && l.sbjprvkey != undefined) this.sign();
        if (l.sighex == undefined) throw new Error("sighex or sbjprvkey parameter not defined");
        var k = new e({
            hex: "00" + l.sighex
        });
        var i = new b({
            array: [
                j,
                m,
                k
            ]
        });
        return i.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (g !== undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.csr.CertificationRequest, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.csr.CertificationRequestInfo = function(f) {
    var b = $b1badb002678e3c8$var$KJUR, j = b.asn1, c = j.DERBitString, g = j.DERSequence, i = j.DERInteger, p = j.DERUTF8String, d = j.DERTaggedObject, h = j.ASN1Util.newObject, n = j.csr, e = j.x509, a = e.X500Name, l = e.Extensions, o = e.SubjectPublicKeyInfo, k = n.AttributeList;
    n.CertificationRequestInfo.superclass.constructor.call(this);
    this.params = null;
    this.setByParam = function(q) {
        if (q != undefined) this.params = q;
    };
    this.tohex = function() {
        var v = this.params;
        var r = [];
        r.push(new i({
            "int": 0
        }));
        r.push(new a(v.subject));
        r.push(new o($b1badb002678e3c8$var$KEYUTIL.getKey(v.sbjpubkey)));
        if (v.attrs != undefined) {
            var u = m(v.attrs);
            var t = h({
                tag: {
                    tage: "a0",
                    obj: u
                }
            });
            r.push(t);
        } else if (v.extreq != undefined) {
            var q = new l(v.extreq);
            var t = h({
                tag: {
                    tage: "a0",
                    obj: {
                        seq: [
                            {
                                oid: "1.2.840.113549.1.9.14"
                            },
                            {
                                set: [
                                    q
                                ]
                            }
                        ]
                    }
                }
            });
            r.push(t);
        } else r.push(new d({
            tag: "a0",
            explicit: false,
            obj: new p({
                str: ""
            })
        }));
        var s = new g({
            array: r
        });
        return s.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    function m(s) {
        var w = Error, v = $b1badb002678e3c8$var$KJUR.asn1.x509.Extensions;
        var y = [];
        for(var u = 0; u < s.length; u++){
            var r = s[u];
            var x = r.attr;
            if (x == "extensionRequest") {
                var t = new v(r.ext);
                var q = {
                    seq: [
                        {
                            oid: "1.2.840.113549.1.9.14"
                        },
                        {
                            set: [
                                t
                            ]
                        }
                    ]
                };
                y.push(q);
            } else if (x == "unstructuredName") {
                var q = {
                    seq: [
                        {
                            oid: "1.2.840.113549.1.9.2"
                        },
                        {
                            set: r.names
                        }
                    ]
                };
                y.push(q);
            } else {
                if (x == "challengePassword") {
                    var q = {
                        seq: [
                            {
                                oid: "1.2.840.113549.1.9.7"
                            },
                            {
                                set: [
                                    {
                                        utf8str: r.password
                                    }
                                ]
                            }
                        ]
                    };
                    y.push(q);
                } else throw new w("unknown CSR attribute");
            }
        }
        return {
            set: y
        };
    }
    if (f != undefined) this.setByParam(f);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.csr.CertificationRequestInfo, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.csr.AttributeList = function(b) {
    function a(c) {}
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.csr.AttributeList, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.csr.CSRUtil = new function() {};
$b1badb002678e3c8$var$KJUR.asn1.csr.CSRUtil.newCSRPEM = function(e) {
    var b = $b1badb002678e3c8$var$KEYUTIL, a = $b1badb002678e3c8$var$KJUR.asn1.csr;
    var c = new a.CertificationRequest(e);
    var d = c.getPEM();
    return d;
};
$b1badb002678e3c8$var$KJUR.asn1.csr.CSRUtil.getParam = function(d, a) {
    var m = $b1badb002678e3c8$var$ASN1HEX, i = m.getV, j = m.getIdxbyList, b = m.getTLVbyList, o = m.getTLVbyListEx, n = m.getVbyListEx;
    var l = function(u) {
        var t = j(u, 0, [
            0,
            3,
            0,
            0
        ], "06");
        if (i(u, t) != "2a864886f70d01090e") return null;
        return b(u, 0, [
            0,
            3,
            0,
            1,
            0
        ], "30");
    };
    var g = {};
    if (d.indexOf("-----BEGIN CERTIFICATE REQUEST") == -1) throw new Error("argument is not PEM file");
    var e = $b1badb002678e3c8$var$pemtohex(d, "CERTIFICATE REQUEST");
    if (a) g.tbs = b(e, 0, [
        0
    ]);
    try {
        var p = o(e, 0, [
            0,
            1
        ]);
        if (p == "3000") g.subject = {};
        else {
            var f = new $b1badb002678e3c8$var$X509();
            g.subject = f.getX500Name(p);
        }
    } catch (q) {}
    var k = o(e, 0, [
        0,
        2
    ]);
    var r = $b1badb002678e3c8$var$KEYUTIL.getKey(k, null, "pkcs8pub");
    g.sbjpubkey = $b1badb002678e3c8$var$KEYUTIL.getPEM(r, "PKCS8PUB");
    var c = l(e);
    var f = new $b1badb002678e3c8$var$X509();
    if (c != null) g.extreq = f.getExtParamArray(c);
    try {
        var h = o(e, 0, [
            1
        ], "30");
        var f = new $b1badb002678e3c8$var$X509();
        g.sigalg = f.getAlgorithmIdentifierName(h);
    } catch (q) {}
    try {
        var s = n(e, 0, [
            2
        ]);
        g.sighex = s;
    } catch (q) {}
    return g;
};
$b1badb002678e3c8$var$KJUR.asn1.csr.CSRUtil.verifySignature = function(b) {
    try {
        var c = null;
        if (typeof b == "string" && b.indexOf("-----BEGIN CERTIFICATE REQUEST") != -1) c = $b1badb002678e3c8$var$KJUR.asn1.csr.CSRUtil.getParam(b, true);
        else if (typeof b == "object" && b.sbjpubkey != undefined && b.sigalg != undefined && b.sighex != undefined && b.tbs != undefined) c = b;
        if (c == null) return false;
        var d = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: c.sigalg
        });
        d.init(c.sbjpubkey);
        d.updateHex(c.tbs);
        return d.verify(c.sighex);
    } catch (a) {
        alert(a);
        return false;
    }
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1 == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1) $b1badb002678e3c8$var$KJUR.asn1 = {};
if (typeof $b1badb002678e3c8$var$KJUR.asn1.ocsp == "undefined" || !$b1badb002678e3c8$var$KJUR.asn1.ocsp) $b1badb002678e3c8$var$KJUR.asn1.ocsp = {};
$b1badb002678e3c8$var$KJUR.asn1.ocsp.DEFAULT_HASH = "sha1";
$b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPResponse = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPResponse.superclass.constructor.call(this);
    var a = $b1badb002678e3c8$var$KJUR.asn1.DEREnumerated, b = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.newObject, c = $b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseBytes;
    var d = [
        "successful",
        "malformedRequest",
        "internalError",
        "tryLater",
        "_not_used_",
        "sigRequired",
        "unauthorized"
    ];
    this.params = null;
    this._getStatusCode = function() {
        var f = this.params.resstatus;
        if (typeof f == "number") return f;
        if (typeof f != "string") return -1;
        return d.indexOf(f);
    };
    this.setByParam = function(f) {
        this.params = f;
    };
    this.tohex = function() {
        var h = this.params;
        var g = this._getStatusCode();
        if (g == -1) throw new Error("responseStatus not supported: " + h.resstatus);
        if (g != 0) return b({
            seq: [
                {
                    "enum": {
                        "int": g
                    }
                }
            ]
        }).tohex();
        var f = new c(h);
        return b({
            seq: [
                {
                    "enum": {
                        "int": 0
                    }
                },
                {
                    tag: {
                        tag: "a0",
                        explicit: true,
                        obj: f
                    }
                }
            ]
        }).tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPResponse, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseBytes = function(e) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseBytes.superclass.constructor.call(this);
    var b = $b1badb002678e3c8$var$KJUR.asn1, a = b.DERSequence, f = b.DERObjectIdentifier, c = b.DEROctetString, d = b.ocsp.BasicOCSPResponse;
    this.params = null;
    this.setByParam = function(g) {
        this.params = g;
    };
    this.tohex = function() {
        var j = this.params;
        if (j.restype != "ocspBasic") throw new Error("not supported responseType: " + j.restype);
        var i = new d(j);
        var g = [];
        g.push(new f({
            name: "ocspBasic"
        }));
        g.push(new c({
            hex: i.tohex()
        }));
        var h = new a({
            array: g
        });
        return h.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseBytes, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.BasicOCSPResponse = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.BasicOCSPResponse.superclass.constructor.call(this);
    var i = Error, g = $b1badb002678e3c8$var$KJUR.asn1, j = g.ASN1Object, e = g.DERSequence, f = g.DERGeneralizedTime, c = g.DERTaggedObject, b = g.DERBitString, h = g.x509.Extensions, k = g.x509.AlgorithmIdentifier, l = g.ocsp, a = l.ResponderID;
    _SingleResponseList = l.SingleResponseList, _ResponseData = l.ResponseData;
    this.params = null;
    this.setByParam = function(m) {
        this.params = m;
    };
    this.sign = function() {
        var o = this.params;
        var m = o.tbsresp.tohex();
        var n = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: o.sigalg
        });
        n.init(o.reskey);
        n.updateHex(m);
        o.sighex = n.sign();
    };
    this.tohex = function() {
        var t = this.params;
        if (t.tbsresp == undefined) t.tbsresp = new _ResponseData(t);
        if (t.sighex == undefined && t.reskey != undefined) this.sign();
        var n = [];
        n.push(t.tbsresp);
        n.push(new k({
            name: t.sigalg
        }));
        n.push(new b({
            hex: "00" + t.sighex
        }));
        if (t.certs != undefined && t.certs.length != undefined) {
            var m = [];
            for(var q = 0; q < t.certs.length; q++){
                var s = t.certs[q];
                var r = null;
                if ($b1badb002678e3c8$var$ASN1HEX.isASN1HEX(s)) r = s;
                else {
                    if (s.match(/-----BEGIN/)) r = $b1badb002678e3c8$var$pemtohex(s);
                    else throw new i("certs[" + q + "] not hex or PEM");
                }
                m.push(new j({
                    tlv: r
                }));
            }
            var p = new e({
                array: m
            });
            n.push(new c({
                tag: "a0",
                explicit: true,
                obj: p
            }));
        }
        var o = new e({
            array: n
        });
        return o.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (d !== undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.BasicOCSPResponse, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseData = function(c) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseData.superclass.constructor.call(this);
    var h = Error, f = $b1badb002678e3c8$var$KJUR.asn1, d = f.DERSequence, e = f.DERGeneralizedTime, b = f.DERTaggedObject, g = f.x509.Extensions, i = f.ocsp, a = i.ResponderID;
    _SingleResponseList = i.SingleResponseList;
    this.params = null;
    this.tohex = function() {
        var m = this.params;
        if (m.respid != undefined) new h("respid not specified");
        if (m.prodat != undefined) new h("prodat not specified");
        if (m.array != undefined) new h("array not specified");
        var j = [];
        j.push(new a(m.respid));
        j.push(new e(m.prodat));
        j.push(new _SingleResponseList(m.array));
        if (m.ext != undefined) {
            var l = new g(m.ext);
            j.push(new b({
                tag: "a1",
                explicit: true,
                obj: l
            }));
        }
        var k = new d({
            array: j
        });
        return k.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(j) {
        this.params = j;
    };
    if (c !== undefined) this.setByParam(c);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponseData, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponderID = function(g) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponderID.superclass.constructor.call(this);
    var d = $b1badb002678e3c8$var$KJUR, c = d.asn1, b = c.ASN1Util.newObject, f = c.x509.X500Name, e = d.lang.String.isHex, a = Error;
    this.params = null;
    this.tohex = function() {
        var m = this.params;
        if (m.key != undefined) {
            var l = null;
            if (typeof m.key == "string") {
                if (e(m.key)) l = m.key;
                if (m.key.match(/-----BEGIN CERTIFICATE/)) {
                    var h = new $b1badb002678e3c8$var$X509(m.key);
                    var k = h.getExtSubjectKeyIdentifier();
                    if (k != null) l = k.kid.hex;
                }
            } else if (m.key instanceof $b1badb002678e3c8$var$X509) {
                var k = m.key.getExtSubjectKeyIdentifier();
                if (k != null) l = k.kid.hex;
            }
            if (l == null) throw new a("wrong key member value");
            var j = b({
                tag: {
                    tag: "a2",
                    explicit: true,
                    obj: {
                        octstr: {
                            hex: l
                        }
                    }
                }
            });
            return j.tohex();
        } else if (m.name != undefined) {
            var i = null;
            if (typeof m.name == "string" && m.name.match(/-----BEGIN CERTIFICATE/)) {
                var h = new $b1badb002678e3c8$var$X509(m.name);
                i = h.getSubject();
            } else {
                if (m.name instanceof $b1badb002678e3c8$var$X509) i = m.name.getSubject();
                else if (typeof m.name == "object" && (m.name.array != undefined || m.name.str != undefined)) i = m.name;
            }
            if (i == null) throw new a("wrong name member value");
            var j = b({
                tag: {
                    tag: "a1",
                    explicit: true,
                    obj: new f(i)
                }
            });
            return j.tohex();
        }
        throw new a("key or name not specified");
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(h) {
        this.params = h;
    };
    if (g !== undefined) this.setByParam(g);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.ResponderID, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.SingleResponseList = function(d) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.SingleResponseList.superclass.constructor.call(this);
    var c = $b1badb002678e3c8$var$KJUR.asn1, b = c.DERSequence, a = c.ocsp.SingleResponse;
    this.params = null;
    this.tohex = function() {
        var h = this.params;
        if (typeof h != "object" || h.length == undefined) throw new Error("params not specified properly");
        var e = [];
        for(var g = 0; g < h.length; g++)e.push(new a(h[g]));
        var f = new b({
            array: e
        });
        return f.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(e) {
        this.params = e;
    };
    if (d !== undefined) this.setByParam(d);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.SingleResponseList, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.SingleResponse = function(e) {
    var k = Error, a = $b1badb002678e3c8$var$KJUR, i = a.asn1, f = i.DERSequence, g = i.DERGeneralizedTime, b = i.DERTaggedObject, l = i.ocsp, h = l.CertID, c = l.CertStatus, d = i.x509, j = d.Extensions;
    l.SingleResponse.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var q = this.params;
        var n = [];
        if (q.certid == undefined) throw new k("certid unspecified");
        if (q.status == undefined) throw new k("status unspecified");
        if (q.thisupdate == undefined) throw new k("thisupdate unspecified");
        n.push(new h(q.certid));
        n.push(new c(q.status));
        n.push(new g(q.thisupdate));
        if (q.nextupdate != undefined) {
            var m = new g(q.nextupdate);
            n.push(new b({
                tag: "a0",
                explicit: true,
                obj: m
            }));
        }
        if (q.ext != undefined) {
            var p = new j(q.ext);
            n.push(new b({
                tag: "a1",
                explicit: true,
                obj: p
            }));
        }
        var o = new f({
            array: n
        });
        return o.tohex();
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(m) {
        this.params = m;
    };
    if (e !== undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.SingleResponse, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.CertID = function(e) {
    var b = $b1badb002678e3c8$var$KJUR, i = b.asn1, l = i.DEROctetString, h = i.DERInteger, f = i.DERSequence, d = i.x509, m = d.AlgorithmIdentifier, n = i.ocsp, k = n.DEFAULT_HASH, g = b.crypto, c = g.Util.hashHex, a = $b1badb002678e3c8$var$X509, o = $b1badb002678e3c8$var$ASN1HEX, j = o.getVbyList;
    n.CertID.superclass.constructor.call(this);
    this.DEFAULT_HASH = "sha1";
    this.params = null;
    this.setByValue = function(s, r, p, q) {
        if (q == undefined) q = this.DEFAULT_HASH;
        this.params = {
            alg: q,
            issname: s,
            isskey: r,
            sbjsn: p
        };
    };
    this.setByCert = function(p, q, r) {
        if (r == undefined) r = this.DEFAULT_HASH;
        this.params = {
            alg: r,
            issuerCert: p,
            subjectCert: q
        };
    };
    this.getParamByCerts = function(y, x, t) {
        if (t == undefined) t = this.DEFAULT_HASH;
        var q = new a(y);
        var v = new a(x);
        var s = c(q.getSubjectHex(), t);
        var u = q.getPublicKeyHex();
        var p = c(j(u, 0, [
            1
        ], "03", true), t);
        var w = v.getSerialNumberHex();
        var r = {
            alg: t,
            issname: s,
            isskey: p,
            sbjsn: w
        };
        return r;
    };
    this.tohex = function() {
        if (typeof this.params != "object") throw new Error("params not set");
        var s = this.params;
        var u, r, y, q;
        if (s.alg == undefined) q = this.DEFAULT_HASH;
        else q = s.alg;
        if (s.issuerCert != undefined && s.subjectCert != undefined) {
            var t = this.getParamByCerts(s.issuerCert, s.subjectCert, q);
            u = t.issname;
            r = t.isskey;
            y = t.sbjsn;
        } else {
            if (s.issname != undefined && s.isskey != undefined && s.sbjsn != undefined) {
                u = s.issname;
                r = s.isskey;
                y = s.sbjsn;
            } else throw new Error("required param members not defined");
        }
        var A = new m({
            name: q
        });
        var v = new l({
            hex: u
        });
        var x = new l({
            hex: r
        });
        var w = new h({
            hex: y
        });
        var z = new f({
            array: [
                A,
                v,
                x,
                w
            ]
        });
        this.hTLV = z.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) this.setByParam(e);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.CertID, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.CertStatus = function(a) {
    $b1badb002678e3c8$var$KJUR.asn1.ocsp.CertStatus.superclass.constructor.call(this);
    this.params = null;
    this.tohex = function() {
        var d = this.params;
        if (d.status == "good") return "8000";
        if (d.status == "unknown") return "8200";
        if (d.status == "revoked") {
            var c = [
                {
                    gentime: {
                        str: d.time
                    }
                }
            ];
            if (d.reason != undefined) c.push({
                tag: {
                    tag: "a0",
                    explicit: true,
                    obj: {
                        "enum": {
                            "int": d.reason
                        }
                    }
                }
            });
            var b = {
                tag: "a1",
                explicit: false,
                obj: {
                    seq: c
                }
            };
            return $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.newObject({
                tag: b
            }).tohex();
        }
        throw new Error("bad status");
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    this.setByParam = function(b) {
        this.params = b;
    };
    if (a !== undefined) this.setByParam(a);
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.CertStatus, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.Request = function(f) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSequence, d = b.ocsp;
    d.Request.superclass.constructor.call(this);
    this.dReqCert = null;
    this.dExt = null;
    this.tohex = function() {
        var g = [];
        if (this.dReqCert === null) throw "reqCert not set";
        g.push(this.dReqCert);
        var h = new a({
            array: g
        });
        this.hTLV = h.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (typeof f !== "undefined") {
        var e = new d.CertID(f);
        this.dReqCert = e;
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.Request, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.TBSRequest = function(e) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSequence, d = b.ocsp;
    d.TBSRequest.superclass.constructor.call(this);
    this.version = 0;
    this.dRequestorName = null;
    this.dRequestList = [];
    this.dRequestExt = null;
    this.setRequestListByParam = function(h) {
        var f = [];
        for(var g = 0; g < h.length; g++){
            var j = new d.Request(h[0]);
            f.push(j);
        }
        this.dRequestList = f;
    };
    this.tohex = function() {
        var f = [];
        if (this.version !== 0) throw "not supported version: " + this.version;
        if (this.dRequestorName !== null) throw "requestorName not supported";
        var h = new a({
            array: this.dRequestList
        });
        f.push(h);
        if (this.dRequestExt !== null) throw "requestExtensions not supported";
        var g = new a({
            array: f
        });
        this.hTLV = g.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (e !== undefined) {
        if (e.reqList !== undefined) this.setRequestListByParam(e.reqList);
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.TBSRequest, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPRequest = function(f) {
    var c = $b1badb002678e3c8$var$KJUR, b = c.asn1, a = b.DERSequence, d = b.ocsp;
    d.OCSPRequest.superclass.constructor.call(this);
    this.dTbsRequest = null;
    this.dOptionalSignature = null;
    this.tohex = function() {
        var g = [];
        if (this.dTbsRequest !== null) g.push(this.dTbsRequest);
        else throw "tbsRequest not set";
        if (this.dOptionalSignature !== null) throw "optionalSignature not supported";
        var h = new a({
            array: g
        });
        this.hTLV = h.tohex();
        return this.hTLV;
    };
    this.getEncodedHex = function() {
        return this.tohex();
    };
    if (f !== undefined) {
        if (f.reqList !== undefined) {
            var e = new d.TBSRequest(f);
            this.dTbsRequest = e;
        }
    }
};
$b1badb002678e3c8$var$extendClass($b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPRequest, $b1badb002678e3c8$var$KJUR.asn1.ASN1Object);
$b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPUtil = {};
$b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPUtil.getRequestHex = function(a, b, h) {
    var d = $b1badb002678e3c8$var$KJUR, c = d.asn1, e = c.ocsp;
    if (h === undefined) h = e.DEFAULT_HASH;
    var g = {
        alg: h,
        issuerCert: a,
        subjectCert: b
    };
    var f = new e.OCSPRequest({
        reqList: [
            g
        ]
    });
    return f.tohex();
};
$b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPUtil.getOCSPResponseInfo = function(b) {
    var m = $b1badb002678e3c8$var$ASN1HEX, c = m.getVbyList, k = m.getVbyListEx, e = m.getIdxbyList, d = m.getIdxbyListEx, g = m.getV;
    var n = {};
    try {
        var j = k(b, 0, [
            0
        ], "0a");
        n.responseStatus = parseInt(j, 16);
    } catch (f) {}
    if (n.responseStatus !== 0) return n;
    try {
        var i = e(b, 0, [
            1,
            0,
            1,
            0,
            0,
            2,
            0,
            1
        ]);
        if (b.substr(i, 2) === "80") n.certStatus = "good";
        else {
            if (b.substr(i, 2) === "a1") {
                n.certStatus = "revoked";
                n.revocationTime = $b1badb002678e3c8$var$hextoutf8(c(b, i, [
                    0
                ]));
            } else if (b.substr(i, 2) === "82") n.certStatus = "unknown";
        }
    } catch (f) {}
    try {
        var a = e(b, 0, [
            1,
            0,
            1,
            0,
            0,
            2,
            0,
            2
        ]);
        n.thisUpdate = $b1badb002678e3c8$var$hextoutf8(g(b, a));
    } catch (f) {}
    try {
        var l = e(b, 0, [
            1,
            0,
            1,
            0,
            0,
            2,
            0,
            3
        ]);
        if (b.substr(l, 2) === "a0") n.nextUpdate = $b1badb002678e3c8$var$hextoutf8(c(b, l, [
            0
        ]));
    } catch (f) {}
    return n;
};
$b1badb002678e3c8$var$KJUR.asn1.ocsp.OCSPParser = function() {
    var g = Error, a = $b1badb002678e3c8$var$X509, h = new a(), l = $b1badb002678e3c8$var$ASN1HEX, i = l.getV, b = l.getTLV, f = l.getIdxbyList, e = l.getVbyList, c = l.getTLVbyList, k = l.getVbyListEx, d = l.getTLVbyListEx, j = l.getChildIdx;
    this.getOCSPRequest = function(o) {
        var n = j(o, 0);
        if (n.length != 1 && n.length != 2) throw new g("wrong number elements: " + n.length);
        var m = this.getTBSRequest(b(o, n[0]));
        return m;
    };
    this.getTBSRequest = function(o) {
        var m = {};
        var n = d(o, 0, [
            0
        ], "30");
        m.array = this.getRequestList(n);
        var p = d(o, 0, [
            "[2]",
            0
        ], "30");
        if (p != null) m.ext = h.getExtParamArray(p);
        return m;
    };
    this.getRequestList = function(p) {
        var m = [];
        var n = j(p, 0);
        for(var o = 0; o < n.length; o++){
            var p = b(p, n[o]);
            m.push(this.getRequest(p));
        }
        return m;
    };
    this.getRequest = function(n) {
        var m = j(n, 0);
        if (m.length != 1 && m.length != 2) throw new g("wrong number elements: " + m.length);
        var p = this.getCertID(b(n, m[0]));
        if (m.length == 2) {
            var o = f(n, 0, [
                1,
                0
            ]);
            p.ext = h.getExtParamArray(b(n, o));
        }
        return p;
    };
    this.getCertID = function(p) {
        var o = j(p, 0);
        if (o.length != 4) throw new g("wrong number elements: " + o.length);
        var n = new a();
        var m = {};
        m.alg = n.getAlgorithmIdentifierName(b(p, o[0]));
        m.issname = i(p, o[1]);
        m.isskey = i(p, o[2]);
        m.sbjsn = i(p, o[3]);
        return m;
    };
    this.getOCSPResponse = function(r) {
        var o = j(r, 0);
        var m;
        var q = i(r, o[0]);
        var p = parseInt(q);
        if (o.length == 1) return {
            resstatus: p
        };
        var n = c(r, 0, [
            1,
            0
        ]);
        m = this.getResponseBytes(n);
        m.resstatus = p;
        return m;
    };
    this.getResponseBytes = function(p) {
        var o = j(p, 0);
        var n;
        var q = c(p, 0, [
            1,
            0
        ]);
        n = this.getBasicOCSPResponse(q);
        var m = i(p, o[0]);
        n.restype = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name($b1badb002678e3c8$var$hextooid(m));
        return n;
    };
    this.getBasicOCSPResponse = function(q) {
        var t = j(q, 0);
        var v;
        v = this.getResponseData(b(q, t[0]));
        var u = new $b1badb002678e3c8$var$X509();
        v.alg = u.getAlgorithmIdentifierName(b(q, t[1]));
        var n = i(q, t[2]);
        v.sighex = n.substr(2);
        var m = k(q, 0, [
            "[0]"
        ]);
        if (m != null) {
            var r = j(m, 0);
            var o = [];
            for(var p = 0; p < r.length; p++){
                var s = b(m, r[p]);
                o.push(s);
            }
            v.certs = o;
        }
        return v;
    };
    this.getResponseData = function(q) {
        var p = j(q, 0);
        var r = p.length;
        var o = {};
        var n = 0;
        if (q.substr(p[0], 2) == "a0") n++;
        o.respid = this.getResponderID(b(q, p[n++]));
        var t = i(q, p[n++]);
        o.prodat = $b1badb002678e3c8$var$hextoutf8(t);
        o.array = this.getSingleResponseList(b(q, p[n++]));
        if (q.substr(p[r - 1], 2) == "a1") {
            var s = c(q, p[r - 1], [
                0
            ]);
            var m = new $b1badb002678e3c8$var$X509();
            o.ext = m.getExtParamArray(s);
        }
        return o;
    };
    this.getResponderID = function(o) {
        var n = {};
        if (o.substr(0, 2) == "a2") {
            var p = e(o, 0, [
                0
            ]);
            n.key = p;
        }
        if (o.substr(0, 2) == "a1") {
            var q = c(o, 0, [
                0
            ]);
            var m = new $b1badb002678e3c8$var$X509();
            n.name = m.getX500Name(q);
        }
        return n;
    };
    this.getSingleResponseList = function(q) {
        var n = j(q, 0);
        var m = [];
        for(var o = 0; o < n.length; o++){
            var r = this.getSingleResponse(b(q, n[o]));
            m.push(r);
        }
        return m;
    };
    this.getSingleResponse = function(p) {
        var t = j(p, 0);
        var v = {};
        var r = this.getCertID(b(p, t[0]));
        v.certid = r;
        var u = this.getCertStatus(b(p, t[1]));
        v.status = u;
        if (p.substr(t[2], 2) == "18") {
            var q = i(p, t[2]);
            v.thisupdate = $b1badb002678e3c8$var$hextoutf8(q);
        }
        for(var o = 3; o < t.length; o++){
            if (p.substr(t[o], 2) == "a0") {
                var m = e(p, t[o], [
                    0
                ], "18");
                v.nextupdate = $b1badb002678e3c8$var$hextoutf8(m);
            }
            if (p.substr(t[o], 2) == "a1") {
                var s = new $b1badb002678e3c8$var$X509();
                var n = c(p, 0, [
                    o,
                    0
                ]);
                v.ext = s.getExtParamArray(n);
            }
        }
        return v;
    };
    this.getCertStatus = function(p) {
        var m = {};
        if (p == "8000") return {
            status: "good"
        };
        if (p == "8200") return {
            status: "unknown"
        };
        if (p.substr(0, 2) == "a1") {
            m.status = "revoked";
            var o = e(p, 0, [
                0
            ]);
            var n = $b1badb002678e3c8$var$hextoutf8(o);
            m.time = n;
        }
        return m;
    };
};
var $b1badb002678e3c8$var$KJUR;
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.lang == "undefined" || !$b1badb002678e3c8$var$KJUR.lang) $b1badb002678e3c8$var$KJUR.lang = {};
$b1badb002678e3c8$var$KJUR.lang.String = function() {};
function $b1badb002678e3c8$var$Base64x() {}
function $b1badb002678e3c8$var$stoBA(d) {
    var b = new Array();
    for(var c = 0; c < d.length; c++)b[c] = d.charCodeAt(c);
    return b;
}
function $b1badb002678e3c8$var$BAtos(b) {
    var d = "";
    for(var c = 0; c < b.length; c++)d = d + String.fromCharCode(b[c]);
    return d;
}
function $b1badb002678e3c8$var$BAtohex(b) {
    var e = "";
    for(var d = 0; d < b.length; d++){
        var c = b[d].toString(16);
        if (c.length == 1) c = "0" + c;
        e = e + c;
    }
    return e;
}
function $b1badb002678e3c8$var$stohex(a) {
    return $b1badb002678e3c8$var$BAtohex($b1badb002678e3c8$var$stoBA(a));
}
function $b1badb002678e3c8$var$stob64(a) {
    return $b1badb002678e3c8$var$hex2b64($b1badb002678e3c8$var$stohex(a));
}
function $b1badb002678e3c8$var$stob64u(a) {
    return $b1badb002678e3c8$var$b64tob64u($b1badb002678e3c8$var$hex2b64($b1badb002678e3c8$var$stohex(a)));
}
function $b1badb002678e3c8$var$b64utos(a) {
    return $b1badb002678e3c8$var$BAtos($b1badb002678e3c8$var$b64toBA($b1badb002678e3c8$var$b64utob64(a)));
}
function $b1badb002678e3c8$var$b64tob64u(a) {
    a = a.replace(/\=/g, "");
    a = a.replace(/\+/g, "-");
    a = a.replace(/\//g, "_");
    return a;
}
function $b1badb002678e3c8$var$b64utob64(a) {
    if (a.length % 4 == 2) a = a + "==";
    else if (a.length % 4 == 3) a = a + "=";
    a = a.replace(/-/g, "+");
    a = a.replace(/_/g, "/");
    return a;
}
function $b1badb002678e3c8$var$hextob64u(a) {
    if (a.length % 2 == 1) a = "0" + a;
    return $b1badb002678e3c8$var$b64tob64u($b1badb002678e3c8$var$hex2b64(a));
}
function $b1badb002678e3c8$var$b64utohex(a) {
    return $b1badb002678e3c8$var$b64tohex($b1badb002678e3c8$var$b64utob64(a));
}
var $b1badb002678e3c8$var$utf8tob64u, $b1badb002678e3c8$var$b64utoutf8;
if (typeof $b1badb002678e3c8$require$Buffer === "function") {
    $b1badb002678e3c8$var$utf8tob64u = function(a) {
        return $b1badb002678e3c8$var$b64tob64u($b1badb002678e3c8$require$Buffer.from(a, "utf8").toString("base64"));
    };
    $b1badb002678e3c8$var$b64utoutf8 = function(a) {
        return $b1badb002678e3c8$require$Buffer.from($b1badb002678e3c8$var$b64utob64(a), "base64").toString("utf8");
    };
} else {
    $b1badb002678e3c8$var$utf8tob64u = function(a) {
        return $b1badb002678e3c8$var$hextob64u($b1badb002678e3c8$var$uricmptohex($b1badb002678e3c8$var$encodeURIComponentAll(a)));
    };
    $b1badb002678e3c8$var$b64utoutf8 = function(a) {
        return decodeURIComponent($b1badb002678e3c8$var$hextouricmp($b1badb002678e3c8$var$b64utohex(a)));
    };
}
function $b1badb002678e3c8$var$utf8tob64(a) {
    return $b1badb002678e3c8$var$hex2b64($b1badb002678e3c8$var$uricmptohex($b1badb002678e3c8$var$encodeURIComponentAll(a)));
}
function $b1badb002678e3c8$var$b64toutf8(a) {
    return decodeURIComponent($b1badb002678e3c8$var$hextouricmp($b1badb002678e3c8$var$b64tohex(a)));
}
function $b1badb002678e3c8$var$utf8tohex(a) {
    return $b1badb002678e3c8$var$uricmptohex($b1badb002678e3c8$var$encodeURIComponentAll(a)).toLowerCase();
}
function $b1badb002678e3c8$var$hextoutf8(b) {
    try {
        return decodeURIComponent($b1badb002678e3c8$var$hextouricmp(b));
    } catch (a) {
        return null;
    }
}
function $b1badb002678e3c8$var$iso88591hextoutf8(a) {
    return $b1badb002678e3c8$var$hextoutf8($b1badb002678e3c8$var$iso88591hextoutf8hex(a));
}
function $b1badb002678e3c8$var$utf8toiso88591hex(a) {
    return $b1badb002678e3c8$var$utf8hextoiso88591hex($b1badb002678e3c8$var$utf8tohex(a));
}
function $b1badb002678e3c8$var$iso88591hextoutf8hex(e) {
    var c = e.match(/.{1,2}/g);
    var b = [];
    for(var d = 0; d < c.length; d++){
        var f = parseInt(c[d], 16);
        if (161 <= f && f <= 191) {
            b.push("c2");
            b.push(c[d]);
        } else if (192 <= f && f <= 255) {
            b.push("c3");
            b.push((f - 64).toString(16));
        } else b.push(c[d]);
    }
    return b.join("");
}
function $b1badb002678e3c8$var$utf8hextoiso88591hex(f) {
    var c = f.match(/.{1,2}/g);
    var b = [];
    for(var e = 0; e < c.length; e++){
        if (c[e] == "c2") {
            e++;
            b.push(c[e]);
        } else if (c[e] == "c3") {
            e++;
            var d = c[e];
            var g = parseInt(c[e], 16) + 64;
            b.push(g.toString(16));
        } else b.push(c[e]);
    }
    return b.join("");
}
function $b1badb002678e3c8$var$hextorstr(c) {
    var b = "";
    for(var a = 0; a < c.length - 1; a += 2)b += String.fromCharCode(parseInt(c.substr(a, 2), 16));
    return b;
}
function $b1badb002678e3c8$var$rstrtohex(c) {
    var a = "";
    for(var b = 0; b < c.length; b++)a += ("0" + c.charCodeAt(b).toString(16)).slice(-2);
    return a;
}
function $b1badb002678e3c8$var$hextob64(a) {
    return $b1badb002678e3c8$var$hex2b64(a);
}
function $b1badb002678e3c8$var$hextob64nl(b) {
    var a = $b1badb002678e3c8$var$hextob64(b);
    var c = a.replace(/(.{64})/g, "$1\r\n");
    c = c.replace(/\r\n$/, "");
    return c;
}
function $b1badb002678e3c8$var$b64nltohex(b) {
    var a = b.replace(/[^0-9A-Za-z\/+=]*/g, "");
    var c = $b1badb002678e3c8$var$b64tohex(a);
    return c;
}
function $b1badb002678e3c8$var$hextopem(a, b) {
    var c = $b1badb002678e3c8$var$hextob64nl(a);
    return "-----BEGIN " + b + "-----\r\n" + c + "\r\n-----END " + b + "-----\r\n";
}
function $b1badb002678e3c8$var$pemtohex(a, b) {
    if (a.indexOf("-----BEGIN ") == -1) throw "can't find PEM header: " + b;
    if (b !== undefined) {
        a = a.replace(new RegExp("^[^]*-----BEGIN " + b + "-----"), "");
        a = a.replace(new RegExp("-----END " + b + "-----[^]*$"), "");
    } else {
        a = a.replace(/^[^]*-----BEGIN [^-]+-----/, "");
        a = a.replace(/-----END [^-]+-----[^]*$/, "");
    }
    return $b1badb002678e3c8$var$b64nltohex(a);
}
function $b1badb002678e3c8$var$hextoArrayBuffer(d) {
    if (d.length % 2 != 0) throw "input is not even length";
    if (d.match(/^[0-9A-Fa-f]+$/) == null) throw "input is not hexadecimal";
    var b = new ArrayBuffer(d.length / 2);
    var a = new DataView(b);
    for(var c = 0; c < d.length / 2; c++)a.setUint8(c, parseInt(d.substr(c * 2, 2), 16));
    return b;
}
function $b1badb002678e3c8$var$ArrayBuffertohex(b) {
    var d = "";
    var a = new DataView(b);
    for(var c = 0; c < b.byteLength; c++)d += ("00" + a.getUint8(c).toString(16)).slice(-2);
    return d;
}
function $b1badb002678e3c8$var$zulutomsec(n) {
    var l, j, m, e, f, i, b, k;
    var a, h, g, c;
    c = n.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/);
    if (c) {
        a = c[1];
        l = parseInt(a);
        if (a.length === 2) {
            if (50 <= l && l < 100) l = 1900 + l;
            else if (0 <= l && l < 50) l = 2000 + l;
        }
        j = parseInt(c[2]) - 1;
        m = parseInt(c[3]);
        e = parseInt(c[4]);
        f = parseInt(c[5]);
        i = parseInt(c[6]);
        b = 0;
        h = c[7];
        if (h !== "") {
            g = (h.substr(1) + "00").substr(0, 3);
            b = parseInt(g);
        }
        return Date.UTC(l, j, m, e, f, i, b);
    }
    throw new Error("unsupported zulu format: " + n);
}
function $b1badb002678e3c8$var$zulutosec(a) {
    return Math.round($b1badb002678e3c8$var$zulutomsec(a) / 1000);
}
function $b1badb002678e3c8$var$zulutodate(a) {
    return new Date($b1badb002678e3c8$var$zulutomsec(a));
}
function $b1badb002678e3c8$var$datetozulu(g, e, f) {
    var b;
    var a = g.getUTCFullYear();
    if (e) {
        if (a < 1950 || 2049 < a) throw "not proper year for UTCTime: " + a;
        b = ("" + a).slice(-2);
    } else b = ("000" + a).slice(-4);
    b += ("0" + (g.getUTCMonth() + 1)).slice(-2);
    b += ("0" + g.getUTCDate()).slice(-2);
    b += ("0" + g.getUTCHours()).slice(-2);
    b += ("0" + g.getUTCMinutes()).slice(-2);
    b += ("0" + g.getUTCSeconds()).slice(-2);
    if (f) {
        var c = g.getUTCMilliseconds();
        if (c !== 0) {
            c = ("00" + c).slice(-3);
            c = c.replace(/0+$/g, "");
            b += "." + c;
        }
    }
    b += "Z";
    return b;
}
function $b1badb002678e3c8$var$uricmptohex(a) {
    return a.replace(/%/g, "");
}
function $b1badb002678e3c8$var$hextouricmp(a) {
    return a.replace(/(..)/g, "%$1");
}
function $b1badb002678e3c8$var$ipv6tohex(g) {
    var b = "malformed IPv6 address";
    if (!g.match(/^[0-9A-Fa-f:]+$/)) throw b;
    g = g.toLowerCase();
    var d = g.split(":").length - 1;
    if (d < 2) throw b;
    var e = ":".repeat(7 - d + 2);
    g = g.replace("::", e);
    var c = g.split(":");
    if (c.length != 8) throw b;
    for(var f = 0; f < 8; f++)c[f] = ("0000" + c[f]).slice(-4);
    return c.join("");
}
function $b1badb002678e3c8$var$hextoipv6(d) {
    if (!d.match(/^[0-9A-Fa-f]{32}$/)) throw new Error("malformed IPv6 address: " + d);
    d = d.toLowerCase();
    var b = d.match(/.{1,4}/g);
    b = b.map(function(a) {
        return a.replace(/^0+/, "");
    });
    b = b.map(function(a) {
        return a == "" ? "0" : a;
    });
    d = ":" + b.join(":") + ":";
    var c = d.match(/:(0:){2,}/g);
    if (c == null) return d.slice(1, -1);
    var e = c.sort().slice(-1)[0];
    d = d.replace(e.substr(0, e.length - 1), ":");
    if (d.substr(0, 2) != "::") d = d.substr(1);
    if (d.substr(-2, 2) != "::") d = d.substr(0, d.length - 1);
    return d;
}
function $b1badb002678e3c8$var$hextoip(b) {
    var c = new Error("malformed hex value");
    if (!b.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/)) throw c;
    if (b.length == 8) {
        var d;
        try {
            d = parseInt(b.substr(0, 2), 16) + "." + parseInt(b.substr(2, 2), 16) + "." + parseInt(b.substr(4, 2), 16) + "." + parseInt(b.substr(6, 2), 16);
            return d;
        } catch (a) {
            throw c;
        }
    } else {
        if (b.length == 16) try {
            return $b1badb002678e3c8$var$hextoip(b.substr(0, 8)) + "/" + $b1badb002678e3c8$var$ipprefixlen(b.substr(8));
        } catch (a) {
            throw c;
        }
        else {
            if (b.length == 32) return $b1badb002678e3c8$var$hextoipv6(b);
            else {
                if (b.length == 64) {
                    try {
                        return $b1badb002678e3c8$var$hextoipv6(b.substr(0, 32)) + "/" + $b1badb002678e3c8$var$ipprefixlen(b.substr(32));
                    } catch (a) {
                        throw c;
                    }
                    return;
                } else return b;
            }
        }
    }
}
function $b1badb002678e3c8$var$ipprefixlen(c) {
    var d = new Error("malformed mask");
    var a;
    try {
        a = new $b1badb002678e3c8$var$BigInteger(c, 16).toString(2);
    } catch (b) {
        throw d;
    }
    if (!a.match(/^1*0*$/)) throw d;
    return a.replace(/0+$/, "").length;
}
function $b1badb002678e3c8$var$iptohex(g) {
    var j = new Error("malformed IP address");
    g = g.toLowerCase(g);
    if (!g.match(/^[0-9a-f.:/]+$/)) throw j;
    if (g.match(/^[0-9.]+$/)) {
        var b = g.split(".");
        if (b.length !== 4) throw j;
        var h = "";
        try {
            for(var f = 0; f < 4; f++){
                var k = parseInt(b[f]);
                h += ("0" + k.toString(16)).slice(-2);
            }
            return h;
        } catch (e) {
            throw j;
        }
    } else if (g.match(/^[0-9.]+\/[0-9]+$/)) {
        var c = g.split("/");
        return $b1badb002678e3c8$var$iptohex(c[0]) + $b1badb002678e3c8$var$ipnetmask(parseInt(c[1]), 32);
    } else {
        if (g.match(/^[0-9a-f:]+$/) && g.indexOf(":") !== -1) return $b1badb002678e3c8$var$ipv6tohex(g);
        else {
            if (g.match(/^[0-9a-f:]+\/[0-9]+$/) && g.indexOf(":") !== -1) {
                var c = g.split("/");
                return $b1badb002678e3c8$var$ipv6tohex(c[0]) + $b1badb002678e3c8$var$ipnetmask(parseInt(c[1]), 128);
            } else throw j;
        }
    }
}
function $b1badb002678e3c8$var$ipnetmask(d, c) {
    if (c == 32 && d == 0) return "00000000";
    if (c == 128 && d == 0) return "00000000000000000000000000000000";
    var a = Array(d + 1).join("1") + Array(c - d + 1).join("0");
    return new $b1badb002678e3c8$var$BigInteger(a, 2).toString(16);
}
function $b1badb002678e3c8$var$ucs2hextoutf8(d) {
    function e(f) {
        var h = parseInt(f.substr(0, 2), 16);
        var a = parseInt(f.substr(2), 16);
        if (h == 0 & a < 128) return String.fromCharCode(a);
        if (h < 8) {
            var j = 192 | (h & 7) << 3 | (a & 192) >> 6;
            var i = 128 | a & 63;
            return $b1badb002678e3c8$var$hextoutf8(j.toString(16) + i.toString(16));
        }
        var j = 224 | (h & 240) >> 4;
        var i = 128 | (h & 15) << 2 | (a & 192) >> 6;
        var g = 128 | a & 63;
        return $b1badb002678e3c8$var$hextoutf8(j.toString(16) + i.toString(16) + g.toString(16));
    }
    var c = d.match(/.{4}/g);
    var b = c.map(e);
    return b.join("");
}
function $b1badb002678e3c8$var$encodeURIComponentAll(a) {
    var d = encodeURIComponent(a);
    var b = "";
    for(var c = 0; c < d.length; c++)if (d[c] == "%") {
        b = b + d.substr(c, 3);
        c = c + 2;
    } else b = b + "%" + $b1badb002678e3c8$var$stohex(d[c]);
    return b;
}
function $b1badb002678e3c8$var$newline_toUnix(a) {
    a = a.replace(/\r\n/mg, "\n");
    return a;
}
function $b1badb002678e3c8$var$newline_toDos(a) {
    a = a.replace(/\r\n/mg, "\n");
    a = a.replace(/\n/mg, "\r\n");
    return a;
}
$b1badb002678e3c8$var$KJUR.lang.String.isInteger = function(a) {
    if (a.match(/^[0-9]+$/)) return true;
    else {
        if (a.match(/^-[0-9]+$/)) return true;
        else return false;
    }
};
$b1badb002678e3c8$var$KJUR.lang.String.isHex = function(a) {
    return $b1badb002678e3c8$var$ishex(a);
};
function $b1badb002678e3c8$var$ishex(a) {
    if (a.length % 2 == 0 && (a.match(/^[0-9a-f]+$/) || a.match(/^[0-9A-F]+$/))) return true;
    else return false;
}
$b1badb002678e3c8$var$KJUR.lang.String.isBase64 = function(a) {
    a = a.replace(/\s+/g, "");
    if (a.match(/^[0-9A-Za-z+\/]+={0,3}$/) && a.length % 4 == 0) return true;
    else return false;
};
$b1badb002678e3c8$var$KJUR.lang.String.isBase64URL = function(a) {
    if (a.match(/[+/=]/)) return false;
    a = $b1badb002678e3c8$var$b64utob64(a);
    return $b1badb002678e3c8$var$KJUR.lang.String.isBase64(a);
};
function $b1badb002678e3c8$var$isBase64URLDot(a) {
    if (a.match(/^[0-9A-Za-z-_.]+$/)) return true;
    return false;
}
$b1badb002678e3c8$var$KJUR.lang.String.isIntegerArray = function(a) {
    a = a.replace(/\s+/g, "");
    if (a.match(/^\[[0-9,]+\]$/)) return true;
    else return false;
};
$b1badb002678e3c8$var$KJUR.lang.String.isPrintable = function(a) {
    if (a.match(/^[0-9A-Za-z '()+,-./:=?]*$/) !== null) return true;
    return false;
};
$b1badb002678e3c8$var$KJUR.lang.String.isIA5 = function(a) {
    if (a.match(/^[\x20-\x21\x23-\x7f]*$/) !== null) return true;
    return false;
};
$b1badb002678e3c8$var$KJUR.lang.String.isMail = function(a) {
    if (a.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/) !== null) return true;
    return false;
};
function $b1badb002678e3c8$var$hextoposhex(a) {
    if (a.length % 2 == 1) return "0" + a;
    if (a.substr(0, 1) > "7") return "00" + a;
    return a;
}
function $b1badb002678e3c8$var$intarystrtohex(b) {
    b = b.replace(/^\s*\[\s*/, "");
    b = b.replace(/\s*\]\s*$/, "");
    b = b.replace(/\s*/g, "");
    try {
        var c = b.split(/,/).map(function(g, e, h) {
            var f = parseInt(g);
            if (f < 0 || 255 < f) throw "integer not in range 0-255";
            var d = ("00" + f.toString(16)).slice(-2);
            return d;
        }).join("");
        return c;
    } catch (a) {
        throw "malformed integer array string: " + a;
    }
}
var $b1badb002678e3c8$var$strdiffidx = function(c, a) {
    var d = c.length;
    if (c.length > a.length) d = a.length;
    for(var b = 0; b < d; b++){
        if (c.charCodeAt(b) != a.charCodeAt(b)) return b;
    }
    if (c.length != a.length) return d;
    return -1;
};
function $b1badb002678e3c8$var$oidtohex(g) {
    var f = function(a) {
        var l = a.toString(16);
        if (l.length == 1) l = "0" + l;
        return l;
    };
    var e = function(p) {
        var o = "";
        var l = parseInt(p, 10);
        var a = l.toString(2);
        var m = 7 - a.length % 7;
        if (m == 7) m = 0;
        var r = "";
        for(var n = 0; n < m; n++)r += "0";
        a = r + a;
        for(var n = 0; n < a.length - 1; n += 7){
            var q = a.substr(n, 7);
            if (n != a.length - 7) q = "1" + q;
            o += f(parseInt(q, 2));
        }
        return o;
    };
    try {
        if (!g.match(/^[0-9.]+$/)) return null;
        var j = "";
        var b = g.split(".");
        var k = parseInt(b[0], 10) * 40 + parseInt(b[1], 10);
        j += f(k);
        b.splice(0, 2);
        for(var d = 0; d < b.length; d++)j += e(b[d]);
        return j;
    } catch (c) {
        return null;
    }
}
function $b1badb002678e3c8$var$hextooid(g) {
    if (!$b1badb002678e3c8$var$ishex(g)) return null;
    try {
        var m = [];
        var p = g.substr(0, 2);
        var e = parseInt(p, 16);
        m[0] = new String(Math.floor(e / 40));
        m[1] = new String(e % 40);
        var n = g.substr(2);
        var l = [];
        for(var f = 0; f < n.length / 2; f++)l.push(parseInt(n.substr(f * 2, 2), 16));
        var k = [];
        var d = "";
        for(var f = 0; f < l.length; f++)if (l[f] & 128) d = d + $b1badb002678e3c8$var$strpad((l[f] & 127).toString(2), 7);
        else {
            d = d + $b1badb002678e3c8$var$strpad((l[f] & 127).toString(2), 7);
            k.push(new String(parseInt(d, 2)));
            d = "";
        }
        var o = m.join(".");
        if (k.length > 0) o = o + "." + k.join(".");
        return o;
    } catch (j) {
        return null;
    }
}
var $b1badb002678e3c8$var$strpad = function(c, b, a) {
    if (a == undefined) a = "0";
    if (c.length >= b) return c;
    return new Array(b - c.length + 1).join(a) + c;
};
function $b1badb002678e3c8$var$bitstrtoint(e) {
    if (e.length % 2 != 0) return -1;
    e = e.toLowerCase();
    if (e.match(/^[0-9a-f]+$/) == null) return -1;
    try {
        var a = e.substr(0, 2);
        if (a == "00") return parseInt(e.substr(2), 16);
        var b = parseInt(a, 16);
        if (b > 7) return -1;
        var g = e.substr(2);
        var d = parseInt(g, 16).toString(2);
        if (d == "0") d = "00000000";
        d = d.slice(0, 0 - b);
        var f = parseInt(d, 2);
        if (f == NaN) return -1;
        return f;
    } catch (c) {
        return -1;
    }
}
function $b1badb002678e3c8$var$inttobitstr(e) {
    if (typeof e != "number") return null;
    if (e < 0) return null;
    var c = Number(e).toString(2);
    var b = 8 - c.length % 8;
    if (b == 8) b = 0;
    c = c + $b1badb002678e3c8$var$strpad("", b, "0");
    var d = parseInt(c, 2).toString(16);
    if (d.length % 2 == 1) d = "0" + d;
    var a = "0" + b;
    return a + d;
}
function $b1badb002678e3c8$var$bitstrtobinstr(g) {
    if (typeof g != "string") return null;
    if (g.length % 2 != 0) return null;
    if (!g.match(/^[0-9a-f]+$/)) return null;
    try {
        var c = parseInt(g.substr(0, 2), 16);
        if (c < 0 || 7 < c) return null;
        var j = g.substr(2);
        var f = "";
        for(var e = 0; e < j.length; e += 2){
            var b = j.substr(e, 2);
            var a = parseInt(b, 16).toString(2);
            a = ("0000000" + a).slice(-8);
            f += a;
        }
        return f.substr(0, f.length - c);
    } catch (d) {
        return null;
    }
}
function $b1badb002678e3c8$var$binstrtobitstr(b) {
    if (typeof b != "string") return null;
    if (b.match(/^[01]+$/) == null) return null;
    try {
        var c = parseInt(b, 2);
        return $b1badb002678e3c8$var$inttobitstr(c);
    } catch (a) {
        return null;
    }
}
function $b1badb002678e3c8$var$namearraytobinstr(e, g) {
    var f = 0;
    for(var a = 0; a < e.length; a++)f |= 1 << g[e[a]];
    var b = f.toString(2);
    var c = "";
    for(var a = b.length - 1; a >= 0; a--)c += b[a];
    return c;
}
function $b1badb002678e3c8$var$extendClass(c, a) {
    var b = function() {};
    b.prototype = a.prototype;
    c.prototype = new b();
    c.prototype.constructor = c;
    c.superclass = a.prototype;
    if (a.prototype.constructor == Object.prototype.constructor) a.prototype.constructor = a;
}
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.crypto == "undefined" || !$b1badb002678e3c8$var$KJUR.crypto) $b1badb002678e3c8$var$KJUR.crypto = {};
$b1badb002678e3c8$var$KJUR.crypto.Util = new function() {
    this.DIGESTINFOHEAD = {
        sha1: "3021300906052b0e03021a05000414",
        sha224: "302d300d06096086480165030402040500041c",
        sha256: "3031300d060960864801650304020105000420",
        sha384: "3041300d060960864801650304020205000430",
        sha512: "3051300d060960864801650304020305000440",
        md2: "3020300c06082a864886f70d020205000410",
        md5: "3020300c06082a864886f70d020505000410",
        ripemd160: "3021300906052b2403020105000414"
    };
    this.DEFAULTPROVIDER = {
        md5: "cryptojs",
        sha1: "cryptojs",
        sha224: "cryptojs",
        sha256: "cryptojs",
        sha384: "cryptojs",
        sha512: "cryptojs",
        ripemd160: "cryptojs",
        hmacmd5: "cryptojs",
        hmacsha1: "cryptojs",
        hmacsha224: "cryptojs",
        hmacsha256: "cryptojs",
        hmacsha384: "cryptojs",
        hmacsha512: "cryptojs",
        hmacripemd160: "cryptojs",
        MD5withRSA: "cryptojs/jsrsa",
        SHA1withRSA: "cryptojs/jsrsa",
        SHA224withRSA: "cryptojs/jsrsa",
        SHA256withRSA: "cryptojs/jsrsa",
        SHA384withRSA: "cryptojs/jsrsa",
        SHA512withRSA: "cryptojs/jsrsa",
        RIPEMD160withRSA: "cryptojs/jsrsa",
        MD5withECDSA: "cryptojs/jsrsa",
        SHA1withECDSA: "cryptojs/jsrsa",
        SHA224withECDSA: "cryptojs/jsrsa",
        SHA256withECDSA: "cryptojs/jsrsa",
        SHA384withECDSA: "cryptojs/jsrsa",
        SHA512withECDSA: "cryptojs/jsrsa",
        RIPEMD160withECDSA: "cryptojs/jsrsa",
        SHA1withDSA: "cryptojs/jsrsa",
        SHA224withDSA: "cryptojs/jsrsa",
        SHA256withDSA: "cryptojs/jsrsa",
        MD5withRSAandMGF1: "cryptojs/jsrsa",
        SHAwithRSAandMGF1: "cryptojs/jsrsa",
        SHA1withRSAandMGF1: "cryptojs/jsrsa",
        SHA224withRSAandMGF1: "cryptojs/jsrsa",
        SHA256withRSAandMGF1: "cryptojs/jsrsa",
        SHA384withRSAandMGF1: "cryptojs/jsrsa",
        SHA512withRSAandMGF1: "cryptojs/jsrsa",
        RIPEMD160withRSAandMGF1: "cryptojs/jsrsa"
    };
    this.CRYPTOJSMESSAGEDIGESTNAME = {
        md5: $b1badb002678e3c8$var$CryptoJS.algo.MD5,
        sha1: $b1badb002678e3c8$var$CryptoJS.algo.SHA1,
        sha224: $b1badb002678e3c8$var$CryptoJS.algo.SHA224,
        sha256: $b1badb002678e3c8$var$CryptoJS.algo.SHA256,
        sha384: $b1badb002678e3c8$var$CryptoJS.algo.SHA384,
        sha512: $b1badb002678e3c8$var$CryptoJS.algo.SHA512,
        ripemd160: $b1badb002678e3c8$var$CryptoJS.algo.RIPEMD160
    };
    this.getDigestInfoHex = function(a, b) {
        if (typeof this.DIGESTINFOHEAD[b] == "undefined") throw "alg not supported in Util.DIGESTINFOHEAD: " + b;
        return this.DIGESTINFOHEAD[b] + a;
    };
    this.getPaddedDigestInfoHex = function(h, a, j) {
        var c = this.getDigestInfoHex(h, a);
        var d = j / 4;
        if (c.length + 22 > d) throw "key is too short for SigAlg: keylen=" + j + "," + a;
        var b = "0001";
        var k = "00" + c;
        var g = "";
        var l = d - b.length - k.length;
        for(var f = 0; f < l; f += 2)g += "ff";
        var e = b + g + k;
        return e;
    };
    this.hashString = function(a, c) {
        var b = new $b1badb002678e3c8$var$KJUR.crypto.MessageDigest({
            alg: c
        });
        return b.digestString(a);
    };
    this.hashHex = function(b, c) {
        var a = new $b1badb002678e3c8$var$KJUR.crypto.MessageDigest({
            alg: c
        });
        return a.digestHex(b);
    };
    this.sha1 = function(a) {
        return this.hashString(a, "sha1");
    };
    this.sha256 = function(a) {
        return this.hashString(a, "sha256");
    };
    this.sha256Hex = function(a) {
        return this.hashHex(a, "sha256");
    };
    this.sha512 = function(a) {
        return this.hashString(a, "sha512");
    };
    this.sha512Hex = function(a) {
        return this.hashHex(a, "sha512");
    };
    this.isKey = function(a) {
        if (a instanceof $b1badb002678e3c8$var$RSAKey || a instanceof $b1badb002678e3c8$var$KJUR.crypto.DSA || a instanceof $b1badb002678e3c8$var$KJUR.crypto.ECDSA) return true;
        else return false;
    };
};
$b1badb002678e3c8$var$KJUR.crypto.Util.md5 = function(a) {
    var b = new $b1badb002678e3c8$var$KJUR.crypto.MessageDigest({
        alg: "md5",
        prov: "cryptojs"
    });
    return b.digestString(a);
};
$b1badb002678e3c8$var$KJUR.crypto.Util.ripemd160 = function(a) {
    var b = new $b1badb002678e3c8$var$KJUR.crypto.MessageDigest({
        alg: "ripemd160",
        prov: "cryptojs"
    });
    return b.digestString(a);
};
$b1badb002678e3c8$var$KJUR.crypto.Util.SECURERANDOMGEN = new $b1badb002678e3c8$var$SecureRandom();
$b1badb002678e3c8$var$KJUR.crypto.Util.getRandomHexOfNbytes = function(b) {
    var a = new Array(b);
    $b1badb002678e3c8$var$KJUR.crypto.Util.SECURERANDOMGEN.nextBytes(a);
    return $b1badb002678e3c8$var$BAtohex(a);
};
$b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerOfNbytes = function(a) {
    return new $b1badb002678e3c8$var$BigInteger($b1badb002678e3c8$var$KJUR.crypto.Util.getRandomHexOfNbytes(a), 16);
};
$b1badb002678e3c8$var$KJUR.crypto.Util.getRandomHexOfNbits = function(d) {
    var c = d % 8;
    var a = (d - c) / 8;
    var b = new Array(a + 1);
    $b1badb002678e3c8$var$KJUR.crypto.Util.SECURERANDOMGEN.nextBytes(b);
    b[0] = (255 << c & 255 ^ 255) & b[0];
    return $b1badb002678e3c8$var$BAtohex(b);
};
$b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerOfNbits = function(a) {
    return new $b1badb002678e3c8$var$BigInteger($b1badb002678e3c8$var$KJUR.crypto.Util.getRandomHexOfNbits(a), 16);
};
$b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerZeroToMax = function(b) {
    var a = b.bitLength();
    while(true){
        var c = $b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerOfNbits(a);
        if (b.compareTo(c) != -1) return c;
    }
};
$b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerMinToMax = function(e, b) {
    var c = e.compareTo(b);
    if (c == 1) throw "biMin is greater than biMax";
    if (c == 0) return e;
    var a = b.subtract(e);
    var d = $b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerZeroToMax(a);
    return d.add(e);
};
$b1badb002678e3c8$var$KJUR.crypto.MessageDigest = function(c) {
    var b = null;
    var a = null;
    var d = null;
    this.setAlgAndProvider = function(g, f) {
        g = $b1badb002678e3c8$var$KJUR.crypto.MessageDigest.getCanonicalAlgName(g);
        if (g !== null && f === undefined) f = $b1badb002678e3c8$var$KJUR.crypto.Util.DEFAULTPROVIDER[g];
        if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(g) != -1 && f == "cryptojs") {
            try {
                this.md = $b1badb002678e3c8$var$KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[g].create();
            } catch (e) {
                throw "setAlgAndProvider hash alg set fail alg=" + g + "/" + e;
            }
            this.updateString = function(h) {
                this.md.update(h);
            };
            this.updateHex = function(h) {
                var i = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(h);
                this.md.update(i);
            };
            this.digest = function() {
                var h = this.md.finalize();
                return h.toString($b1badb002678e3c8$var$CryptoJS.enc.Hex);
            };
            this.digestString = function(h) {
                this.updateString(h);
                return this.digest();
            };
            this.digestHex = function(h) {
                this.updateHex(h);
                return this.digest();
            };
        }
        if (":sha256:".indexOf(g) != -1 && f == "sjcl") {
            try {
                this.md = new sjcl.hash.sha256();
            } catch (e) {
                throw "setAlgAndProvider hash alg set fail alg=" + g + "/" + e;
            }
            this.updateString = function(h) {
                this.md.update(h);
            };
            this.updateHex = function(i) {
                var h = sjcl.codec.hex.toBits(i);
                this.md.update(h);
            };
            this.digest = function() {
                var h = this.md.finalize();
                return sjcl.codec.hex.fromBits(h);
            };
            this.digestString = function(h) {
                this.updateString(h);
                return this.digest();
            };
            this.digestHex = function(h) {
                this.updateHex(h);
                return this.digest();
            };
        }
    };
    this.updateString = function(e) {
        throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    };
    this.updateHex = function(e) {
        throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    };
    this.digest = function() {
        throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
    };
    this.digestString = function(e) {
        throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    };
    this.digestHex = function(e) {
        throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
    };
    if (c !== undefined) {
        if (c.alg !== undefined) {
            this.algName = c.alg;
            if (c.prov === undefined) this.provName = $b1badb002678e3c8$var$KJUR.crypto.Util.DEFAULTPROVIDER[this.algName];
            this.setAlgAndProvider(this.algName, this.provName);
        }
    }
};
$b1badb002678e3c8$var$KJUR.crypto.MessageDigest.getCanonicalAlgName = function(a) {
    if (typeof a === "string") {
        a = a.toLowerCase();
        a = a.replace(/-/, "");
    }
    return a;
};
$b1badb002678e3c8$var$KJUR.crypto.MessageDigest.getHashLength = function(c) {
    var b = $b1badb002678e3c8$var$KJUR.crypto.MessageDigest;
    var a = b.getCanonicalAlgName(c);
    if (b.HASHLENGTH[a] === undefined) throw "not supported algorithm: " + c;
    return b.HASHLENGTH[a];
};
$b1badb002678e3c8$var$KJUR.crypto.MessageDigest.HASHLENGTH = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    ripemd160: 20
};
$b1badb002678e3c8$var$KJUR.crypto.Mac = function(d) {
    var f = null;
    var c = null;
    var a = null;
    var e = null;
    var b = null;
    this.setAlgAndProvider = function(k, i) {
        k = k.toLowerCase();
        if (k == null) k = "hmacsha1";
        k = k.toLowerCase();
        if (k.substr(0, 4) != "hmac") throw "setAlgAndProvider unsupported HMAC alg: " + k;
        if (i === undefined) i = $b1badb002678e3c8$var$KJUR.crypto.Util.DEFAULTPROVIDER[k];
        this.algProv = k + "/" + i;
        var g = k.substr(4);
        if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(g) != -1 && i == "cryptojs") {
            try {
                var j = $b1badb002678e3c8$var$KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[g];
                this.mac = $b1badb002678e3c8$var$CryptoJS.algo.HMAC.create(j, this.pass);
            } catch (h) {
                throw "setAlgAndProvider hash alg set fail hashAlg=" + g + "/" + h;
            }
            this.updateString = function(l) {
                this.mac.update(l);
            };
            this.updateHex = function(l) {
                var m = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(l);
                this.mac.update(m);
            };
            this.doFinal = function() {
                var l = this.mac.finalize();
                return l.toString($b1badb002678e3c8$var$CryptoJS.enc.Hex);
            };
            this.doFinalString = function(l) {
                this.updateString(l);
                return this.doFinal();
            };
            this.doFinalHex = function(l) {
                this.updateHex(l);
                return this.doFinal();
            };
        }
    };
    this.updateString = function(g) {
        throw "updateString(str) not supported for this alg/prov: " + this.algProv;
    };
    this.updateHex = function(g) {
        throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
    };
    this.doFinal = function() {
        throw "digest() not supported for this alg/prov: " + this.algProv;
    };
    this.doFinalString = function(g) {
        throw "digestString(str) not supported for this alg/prov: " + this.algProv;
    };
    this.doFinalHex = function(g) {
        throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
    };
    this.setPassword = function(h) {
        if (typeof h == "string") {
            var g = h;
            if (h.length % 2 == 1 || !h.match(/^[0-9A-Fa-f]+$/)) g = $b1badb002678e3c8$var$rstrtohex(h);
            this.pass = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(g);
            return;
        }
        if (typeof h != "object") throw "KJUR.crypto.Mac unsupported password type: " + h;
        var g = null;
        if (h.hex !== undefined) {
            if (h.hex.length % 2 != 0 || !h.hex.match(/^[0-9A-Fa-f]+$/)) throw "Mac: wrong hex password: " + h.hex;
            g = h.hex;
        }
        if (h.utf8 !== undefined) g = $b1badb002678e3c8$var$utf8tohex(h.utf8);
        if (h.rstr !== undefined) g = $b1badb002678e3c8$var$rstrtohex(h.rstr);
        if (h.b64 !== undefined) g = $b1badb002678e3c8$var$b64tohex(h.b64);
        if (h.b64u !== undefined) g = $b1badb002678e3c8$var$b64utohex(h.b64u);
        if (g == null) throw "KJUR.crypto.Mac unsupported password type: " + h;
        this.pass = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(g);
    };
    if (d !== undefined) {
        if (d.pass !== undefined) this.setPassword(d.pass);
        if (d.alg !== undefined) {
            this.algName = d.alg;
            if (d.prov === undefined) this.provName = $b1badb002678e3c8$var$KJUR.crypto.Util.DEFAULTPROVIDER[this.algName];
            this.setAlgAndProvider(this.algName, this.provName);
        }
    }
};
$b1badb002678e3c8$var$KJUR.crypto.Signature = function(o) {
    var q = null;
    var n = null;
    var r = null;
    var c = null;
    var l = null;
    var d = null;
    var k = null;
    var h = null;
    var p = null;
    var e = null;
    var b = -1;
    var g = null;
    var j = null;
    var a = null;
    var i = null;
    var f = null;
    this._setAlgNames = function() {
        var s = this.algName.match(/^(.+)with(.+)$/);
        if (s) {
            this.mdAlgName = s[1].toLowerCase();
            this.pubkeyAlgName = s[2].toLowerCase();
            if (this.pubkeyAlgName == "rsaandmgf1" && this.mdAlgName == "sha") this.mdAlgName = "sha1";
        }
    };
    this._zeroPaddingOfSignature = function(x, w) {
        var v = "";
        var t = w / 4 - x.length;
        for(var u = 0; u < t; u++)v = v + "0";
        return v + x;
    };
    this.setAlgAndProvider = function(u, t) {
        this._setAlgNames();
        if (t != "cryptojs/jsrsa") throw new Error("provider not supported: " + t);
        if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName) != -1) {
            try {
                this.md = new $b1badb002678e3c8$var$KJUR.crypto.MessageDigest({
                    alg: this.mdAlgName
                });
            } catch (s) {
                throw new Error("setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + s);
            }
            this.init = function(w, x) {
                var y = null;
                try {
                    if (x === undefined) y = $b1badb002678e3c8$var$KEYUTIL.getKey(w);
                    else y = $b1badb002678e3c8$var$KEYUTIL.getKey(w, x);
                } catch (v) {
                    throw "init failed:" + v;
                }
                if (y.isPrivate === true) {
                    this.prvKey = y;
                    this.state = "SIGN";
                } else {
                    if (y.isPublic === true) {
                        this.pubKey = y;
                        this.state = "VERIFY";
                    } else throw "init failed.:" + y;
                }
            };
            this.updateString = function(v) {
                this.md.updateString(v);
            };
            this.updateHex = function(v) {
                this.md.updateHex(v);
            };
            this.sign = function() {
                this.sHashHex = this.md.digest();
                if (this.prvKey === undefined && this.ecprvhex !== undefined && this.eccurvename !== undefined && $b1badb002678e3c8$var$KJUR.crypto.ECDSA !== undefined) this.prvKey = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA({
                    curve: this.eccurvename,
                    prv: this.ecprvhex
                });
                if (this.prvKey instanceof $b1badb002678e3c8$var$RSAKey && this.pubkeyAlgName === "rsaandmgf1") this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
                else {
                    if (this.prvKey instanceof $b1badb002678e3c8$var$RSAKey && this.pubkeyAlgName === "rsa") this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
                    else if (this.prvKey instanceof $b1badb002678e3c8$var$KJUR.crypto.ECDSA) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                    else {
                        if (this.prvKey instanceof $b1badb002678e3c8$var$KJUR.crypto.DSA) this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
                        else throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
                    }
                }
                return this.hSign;
            };
            this.signString = function(v) {
                this.updateString(v);
                return this.sign();
            };
            this.signHex = function(v) {
                this.updateHex(v);
                return this.sign();
            };
            this.verify = function(v) {
                this.sHashHex = this.md.digest();
                if (this.pubKey === undefined && this.ecpubhex !== undefined && this.eccurvename !== undefined && $b1badb002678e3c8$var$KJUR.crypto.ECDSA !== undefined) this.pubKey = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA({
                    curve: this.eccurvename,
                    pub: this.ecpubhex
                });
                if (this.pubKey instanceof $b1badb002678e3c8$var$RSAKey && this.pubkeyAlgName === "rsaandmgf1") return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, v, this.mdAlgName, this.pssSaltLen);
                else {
                    if (this.pubKey instanceof $b1badb002678e3c8$var$RSAKey && this.pubkeyAlgName === "rsa") return this.pubKey.verifyWithMessageHash(this.sHashHex, v);
                    else {
                        if ($b1badb002678e3c8$var$KJUR.crypto.ECDSA !== undefined && this.pubKey instanceof $b1badb002678e3c8$var$KJUR.crypto.ECDSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, v);
                        else {
                            if ($b1badb002678e3c8$var$KJUR.crypto.DSA !== undefined && this.pubKey instanceof $b1badb002678e3c8$var$KJUR.crypto.DSA) return this.pubKey.verifyWithMessageHash(this.sHashHex, v);
                            else throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
                        }
                    }
                }
            };
        }
    };
    this.init = function(s, t) {
        throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
    };
    this.updateString = function(s) {
        throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
    };
    this.updateHex = function(s) {
        throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
    };
    this.sign = function() {
        throw "sign() not supported for this alg:prov=" + this.algProvName;
    };
    this.signString = function(s) {
        throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
    };
    this.signHex = function(s) {
        throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
    };
    this.verify = function(s) {
        throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
    };
    this.initParams = o;
    if (o !== undefined) {
        if (o.alg !== undefined) {
            this.algName = o.alg;
            if (o.prov === undefined) this.provName = $b1badb002678e3c8$var$KJUR.crypto.Util.DEFAULTPROVIDER[this.algName];
            else this.provName = o.prov;
            this.algProvName = this.algName + ":" + this.provName;
            this.setAlgAndProvider(this.algName, this.provName);
            this._setAlgNames();
        }
        if (o.psssaltlen !== undefined) this.pssSaltLen = o.psssaltlen;
        if (o.prvkeypem !== undefined) {
            if (o.prvkeypas !== undefined) throw "both prvkeypem and prvkeypas parameters not supported";
            else try {
                var q = $b1badb002678e3c8$var$KEYUTIL.getKey(o.prvkeypem);
                this.init(q);
            } catch (m) {
                throw "fatal error to load pem private key: " + m;
            }
        }
    }
};
$b1badb002678e3c8$var$KJUR.crypto.Cipher = function(a) {};
$b1badb002678e3c8$var$KJUR.crypto.Cipher.encrypt = function(e, f, d) {
    if (f instanceof $b1badb002678e3c8$var$RSAKey && f.isPublic) {
        var c = $b1badb002678e3c8$var$KJUR.crypto.Cipher.getAlgByKeyAndName(f, d);
        if (c === "RSA") return f.encrypt(e);
        if (c === "RSAOAEP") return f.encryptOAEP(e, "sha1");
        var b = c.match(/^RSAOAEP(\d+)$/);
        if (b !== null) return f.encryptOAEP(e, "sha" + b[1]);
        throw "Cipher.encrypt: unsupported algorithm for RSAKey: " + d;
    } else throw "Cipher.encrypt: unsupported key or algorithm";
};
$b1badb002678e3c8$var$KJUR.crypto.Cipher.decrypt = function(e, f, d) {
    if (f instanceof $b1badb002678e3c8$var$RSAKey && f.isPrivate) {
        var c = $b1badb002678e3c8$var$KJUR.crypto.Cipher.getAlgByKeyAndName(f, d);
        if (c === "RSA") return f.decrypt(e);
        if (c === "RSAOAEP") return f.decryptOAEP(e, "sha1");
        var b = c.match(/^RSAOAEP(\d+)$/);
        if (b !== null) return f.decryptOAEP(e, "sha" + b[1]);
        throw "Cipher.decrypt: unsupported algorithm for RSAKey: " + d;
    } else throw "Cipher.decrypt: unsupported key or algorithm";
};
$b1badb002678e3c8$var$KJUR.crypto.Cipher.getAlgByKeyAndName = function(b, a) {
    if (b instanceof $b1badb002678e3c8$var$RSAKey) {
        if (":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(a) != -1) return a;
        if (a === null || a === undefined) return "RSA";
        throw "getAlgByKeyAndName: not supported algorithm name for RSAKey: " + a;
    }
    throw "getAlgByKeyAndName: not supported algorithm name: " + a;
};
$b1badb002678e3c8$var$KJUR.crypto.OID = new function() {
    this.oidhex2name = {
        "2a864886f70d010101": "rsaEncryption",
        "2a8648ce3d0201": "ecPublicKey",
        "2a8648ce380401": "dsa",
        "2a8648ce3d030107": "secp256r1",
        "2b8104001f": "secp192k1",
        "2b81040021": "secp224r1",
        "2b8104000a": "secp256k1",
        "2b81040022": "secp384r1",
        "2b81040023": "secp521r1",
        "2a8648ce380403": "SHA1withDSA",
        "608648016503040301": "SHA224withDSA",
        "608648016503040302": "SHA256withDSA"
    };
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.crypto == "undefined" || !$b1badb002678e3c8$var$KJUR.crypto) $b1badb002678e3c8$var$KJUR.crypto = {};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA = function(e) {
    var g = "secp256r1";
    var p = null;
    var b = null;
    var i = null;
    var j = Error, f = $b1badb002678e3c8$var$BigInteger, h = $b1badb002678e3c8$var$ECPointFp, m = $b1badb002678e3c8$var$KJUR.crypto.ECDSA, c = $b1badb002678e3c8$var$KJUR.crypto.ECParameterDB, d = m.getName, q = $b1badb002678e3c8$var$ASN1HEX, n = q.getVbyListEx, k = q.isASN1HEX;
    var a = new $b1badb002678e3c8$var$SecureRandom();
    var o = null;
    this.type = "EC";
    this.isPrivate = false;
    this.isPublic = false;
    function l(x, t, w, s) {
        var r = Math.max(t.bitLength(), s.bitLength());
        var y = x.add2D(w);
        var v = x.curve.getInfinity();
        for(var u = r - 1; u >= 0; --u){
            v = v.twice2D();
            v.z = f.ONE;
            if (t.testBit(u)) {
                if (s.testBit(u)) v = v.add2D(y);
                else v = v.add2D(x);
            } else if (s.testBit(u)) v = v.add2D(w);
        }
        return v;
    }
    this.getBigRandom = function(r) {
        return new f(r.bitLength(), a).mod(r.subtract(f.ONE)).add(f.ONE);
    };
    this.setNamedCurve = function(r) {
        this.ecparams = c.getByName(r);
        this.prvKeyHex = null;
        this.pubKeyHex = null;
        this.curveName = r;
    };
    this.setPrivateKeyHex = function(r) {
        this.isPrivate = true;
        this.prvKeyHex = r;
    };
    this.setPublicKeyHex = function(r) {
        this.isPublic = true;
        this.pubKeyHex = r;
    };
    this.getPublicKeyXYHex = function() {
        var t = this.pubKeyHex;
        if (t.substr(0, 2) !== "04") throw "this method supports uncompressed format(04) only";
        var s = this.ecparams.keycharlen;
        if (t.length !== 2 + s * 2) throw "malformed public key hex length";
        var r = {};
        r.x = t.substr(2, s);
        r.y = t.substr(2 + s);
        return r;
    };
    this.getShortNISTPCurveName = function() {
        var r = this.curveName;
        if (r === "secp256r1" || r === "NIST P-256" || r === "P-256" || r === "prime256v1") return "P-256";
        if (r === "secp384r1" || r === "NIST P-384" || r === "P-384") return "P-384";
        if (r === "secp521r1" || r === "NIST P-521" || r === "P-521") return "P-521";
        return null;
    };
    this.generateKeyPairHex = function() {
        var s = this.ecparams.n;
        var u = this.getBigRandom(s);
        var r = this.ecparams.keycharlen;
        var t = ("0000000000" + u.toString(16)).slice(-r);
        this.setPrivateKeyHex(t);
        var v = this.generatePublicKeyHex();
        return {
            ecprvhex: t,
            ecpubhex: v
        };
    };
    this.generatePublicKeyHex = function() {
        var u = new f(this.prvKeyHex, 16);
        var w = this.ecparams.G.multiply(u);
        var t = w.getX().toBigInteger();
        var s = w.getY().toBigInteger();
        var r = this.ecparams.keycharlen;
        var y = ("0000000000" + t.toString(16)).slice(-r);
        var v = ("0000000000" + s.toString(16)).slice(-r);
        var x = "04" + y + v;
        this.setPublicKeyHex(x);
        return x;
    };
    this.signWithMessageHash = function(r) {
        return this.signHex(r, this.prvKeyHex);
    };
    this.signHex = function(x, u) {
        var A = new f(u, 16);
        var v = this.ecparams.n;
        var z = new f(x.substring(0, this.ecparams.keycharlen), 16);
        do {
            var w = this.getBigRandom(v);
            var B = this.ecparams.G;
            var y = B.multiply(w);
            var t = y.getX().toBigInteger().mod(v);
        }while (t.compareTo(f.ZERO) <= 0);
        var C = w.modInverse(v).multiply(z.add(A.multiply(t))).mod(v);
        return m.biRSSigToASN1Sig(t, C);
    };
    this.sign = function(w, B) {
        var z = B;
        var u = this.ecparams.n;
        var y = f.fromByteArrayUnsigned(w);
        do {
            var v = this.getBigRandom(u);
            var A = this.ecparams.G;
            var x = A.multiply(v);
            var t = x.getX().toBigInteger().mod(u);
        }while (t.compareTo($b1badb002678e3c8$var$BigInteger.ZERO) <= 0);
        var C = v.modInverse(u).multiply(y.add(z.multiply(t))).mod(u);
        return this.serializeSig(t, C);
    };
    this.verifyWithMessageHash = function(s, r) {
        return this.verifyHex(s, r, this.pubKeyHex);
    };
    this.verifyHex = function(v, y, u) {
        try {
            var t, B;
            var w = m.parseSigHex(y);
            t = w.r;
            B = w.s;
            var x = h.decodeFromHex(this.ecparams.curve, u);
            var z = new f(v.substring(0, this.ecparams.keycharlen), 16);
            return this.verifyRaw(z, t, B, x);
        } catch (A) {
            return false;
        }
    };
    this.verify = function(z, A, u) {
        var w, t;
        if (Bitcoin.Util.isArray(A)) {
            var y = this.parseSig(A);
            w = y.r;
            t = y.s;
        } else {
            if ("object" === typeof A && A.r && A.s) {
                w = A.r;
                t = A.s;
            } else throw "Invalid value for signature";
        }
        var v;
        if (u instanceof $b1badb002678e3c8$var$ECPointFp) v = u;
        else {
            if (Bitcoin.Util.isArray(u)) v = h.decodeFrom(this.ecparams.curve, u);
            else throw "Invalid format for pubkey value, must be byte array or ECPointFp";
        }
        var x = f.fromByteArrayUnsigned(z);
        return this.verifyRaw(x, w, t, v);
    };
    this.verifyRaw = function(z, t, E, y) {
        var x = this.ecparams.n;
        var D = this.ecparams.G;
        if (t.compareTo(f.ONE) < 0 || t.compareTo(x) >= 0) return false;
        if (E.compareTo(f.ONE) < 0 || E.compareTo(x) >= 0) return false;
        var A = E.modInverse(x);
        var w = z.multiply(A).mod(x);
        var u = t.multiply(A).mod(x);
        var B = D.multiply(w).add(y.multiply(u));
        var C = B.getX().toBigInteger().mod(x);
        return C.equals(t);
    };
    this.serializeSig = function(v, u) {
        var w = v.toByteArraySigned();
        var t = u.toByteArraySigned();
        var x = [];
        x.push(2);
        x.push(w.length);
        x = x.concat(w);
        x.push(2);
        x.push(t.length);
        x = x.concat(t);
        x.unshift(x.length);
        x.unshift(48);
        return x;
    };
    this.parseSig = function(y) {
        var x;
        if (y[0] != 48) throw new Error("Signature not a valid DERSequence");
        x = 2;
        if (y[x] != 2) throw new Error("First element in signature must be a DERInteger");
        var w = y.slice(x + 2, x + 2 + y[x + 1]);
        x += 2 + y[x + 1];
        if (y[x] != 2) throw new Error("Second element in signature must be a DERInteger");
        var t = y.slice(x + 2, x + 2 + y[x + 1]);
        x += 2 + y[x + 1];
        var v = f.fromByteArrayUnsigned(w);
        var u = f.fromByteArrayUnsigned(t);
        return {
            r: v,
            s: u
        };
    };
    this.parseSigCompact = function(w) {
        if (w.length !== 65) throw "Signature has the wrong length";
        var t = w[0] - 27;
        if (t < 0 || t > 7) throw "Invalid signature type";
        var x = this.ecparams.n;
        var v = f.fromByteArrayUnsigned(w.slice(1, 33)).mod(x);
        var u = f.fromByteArrayUnsigned(w.slice(33, 65)).mod(x);
        return {
            r: v,
            s: u,
            i: t
        };
    };
    this.readPKCS5PrvKeyHex = function(u) {
        if (k(u) === false) throw new Error("not ASN.1 hex string");
        var r, t, v;
        try {
            r = n(u, 0, [
                "[0]",
                0
            ], "06");
            t = n(u, 0, [
                1
            ], "04");
            try {
                v = n(u, 0, [
                    "[1]",
                    0
                ], "03");
            } catch (s) {}
        } catch (s) {
            throw new Error("malformed PKCS#1/5 plain ECC private key");
        }
        this.curveName = d(r);
        if (this.curveName === undefined) throw "unsupported curve name";
        this.setNamedCurve(this.curveName);
        this.setPublicKeyHex(v);
        this.setPrivateKeyHex(t);
        this.isPublic = false;
    };
    this.readPKCS8PrvKeyHex = function(v) {
        if (k(v) === false) throw new j("not ASN.1 hex string");
        var t, r, u, w;
        try {
            t = n(v, 0, [
                1,
                0
            ], "06");
            r = n(v, 0, [
                1,
                1
            ], "06");
            u = n(v, 0, [
                2,
                0,
                1
            ], "04");
            try {
                w = n(v, 0, [
                    2,
                    0,
                    "[1]",
                    0
                ], "03");
            } catch (s) {}
        } catch (s) {
            throw new j("malformed PKCS#8 plain ECC private key");
        }
        this.curveName = d(r);
        if (this.curveName === undefined) throw new j("unsupported curve name");
        this.setNamedCurve(this.curveName);
        this.setPublicKeyHex(w);
        this.setPrivateKeyHex(u);
        this.isPublic = false;
    };
    this.readPKCS8PubKeyHex = function(u) {
        if (k(u) === false) throw new j("not ASN.1 hex string");
        var t, r, v;
        try {
            t = n(u, 0, [
                0,
                0
            ], "06");
            r = n(u, 0, [
                0,
                1
            ], "06");
            v = n(u, 0, [
                1
            ], "03");
        } catch (s) {
            throw new j("malformed PKCS#8 ECC public key");
        }
        this.curveName = d(r);
        if (this.curveName === null) throw new j("unsupported curve name");
        this.setNamedCurve(this.curveName);
        this.setPublicKeyHex(v);
    };
    this.readCertPubKeyHex = function(t, v) {
        if (k(t) === false) throw new j("not ASN.1 hex string");
        var r, u;
        try {
            r = n(t, 0, [
                0,
                5,
                0,
                1
            ], "06");
            u = n(t, 0, [
                0,
                5,
                1
            ], "03");
        } catch (s) {
            throw new j("malformed X.509 certificate ECC public key");
        }
        this.curveName = d(r);
        if (this.curveName === null) throw new j("unsupported curve name");
        this.setNamedCurve(this.curveName);
        this.setPublicKeyHex(u);
    };
    if (e !== undefined) {
        if (e.curve !== undefined) this.curveName = e.curve;
    }
    if (this.curveName === undefined) this.curveName = g;
    this.setNamedCurve(this.curveName);
    if (e !== undefined) {
        if (e.prv !== undefined) this.setPrivateKeyHex(e.prv);
        if (e.pub !== undefined) this.setPublicKeyHex(e.pub);
    }
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.parseSigHex = function(a) {
    var b = $b1badb002678e3c8$var$KJUR.crypto.ECDSA.parseSigHexInHexRS(a);
    var d = new $b1badb002678e3c8$var$BigInteger(b.r, 16);
    var c = new $b1badb002678e3c8$var$BigInteger(b.s, 16);
    return {
        r: d,
        s: c
    };
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.parseSigHexInHexRS = function(f) {
    var j = $b1badb002678e3c8$var$ASN1HEX, i = j.getChildIdx, g = j.getV;
    j.checkStrictDER(f, 0);
    if (f.substr(0, 2) != "30") throw new Error("signature is not a ASN.1 sequence");
    var h = i(f, 0);
    if (h.length != 2) throw new Error("signature shall have two elements");
    var e = h[0];
    var d = h[1];
    if (f.substr(e, 2) != "02") throw new Error("1st item not ASN.1 integer");
    if (f.substr(d, 2) != "02") throw new Error("2nd item not ASN.1 integer");
    var c = g(f, e);
    var b = g(f, d);
    return {
        r: c,
        s: b
    };
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.asn1SigToConcatSig = function(d) {
    var e = $b1badb002678e3c8$var$KJUR.crypto.ECDSA.parseSigHexInHexRS(d);
    var b = e.r;
    var a = e.s;
    if (b.length >= 130 && b.length <= 134) {
        if (b.length % 2 != 0) throw Error("unknown ECDSA sig r length error");
        if (a.length % 2 != 0) throw Error("unknown ECDSA sig s length error");
        if (b.substr(0, 2) == "00") b = b.substr(2);
        if (a.substr(0, 2) == "00") a = a.substr(2);
        var c = Math.max(b.length, a.length);
        b = ("000000" + b).slice(-c);
        a = ("000000" + a).slice(-c);
        return b + a;
    }
    if (b.substr(0, 2) == "00" && b.length % 32 == 2) b = b.substr(2);
    if (a.substr(0, 2) == "00" && a.length % 32 == 2) a = a.substr(2);
    if (b.length % 32 == 30) b = "00" + b;
    if (a.length % 32 == 30) a = "00" + a;
    if (b.length % 32 != 0) throw Error("unknown ECDSA sig r length error");
    if (a.length % 32 != 0) throw Error("unknown ECDSA sig s length error");
    return b + a;
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.concatSigToASN1Sig = function(a) {
    if (a.length % 4 != 0) throw Error("unknown ECDSA concatinated r-s sig length error");
    var c = a.substr(0, a.length / 2);
    var b = a.substr(a.length / 2);
    return $b1badb002678e3c8$var$KJUR.crypto.ECDSA.hexRSSigToASN1Sig(c, b);
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.hexRSSigToASN1Sig = function(b, a) {
    var d = new $b1badb002678e3c8$var$BigInteger(b, 16);
    var c = new $b1badb002678e3c8$var$BigInteger(a, 16);
    return $b1badb002678e3c8$var$KJUR.crypto.ECDSA.biRSSigToASN1Sig(d, c);
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.biRSSigToASN1Sig = function(f, d) {
    var c = $b1badb002678e3c8$var$KJUR.asn1;
    var b = new c.DERInteger({
        bigint: f
    });
    var a = new c.DERInteger({
        bigint: d
    });
    var e = new c.DERSequence({
        array: [
            b,
            a
        ]
    });
    return e.tohex();
};
$b1badb002678e3c8$var$KJUR.crypto.ECDSA.getName = function(a) {
    if (a === "2b8104001f") return "secp192k1";
    if (a === "2a8648ce3d030107") return "secp256r1";
    if (a === "2b8104000a") return "secp256k1";
    if (a === "2b81040021") return "secp224r1";
    if (a === "2b81040022") return "secp384r1";
    if (a === "2b81040023") return "secp521r1";
    if ("|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(a) !== -1) return "secp256r1";
    if ("|secp256k1|".indexOf(a) !== -1) return "secp256k1";
    if ("|secp224r1|NIST P-224|P-224|".indexOf(a) !== -1) return "secp224r1";
    if ("|secp384r1|NIST P-384|P-384|".indexOf(a) !== -1) return "secp384r1";
    if ("|secp521r1|NIST P-521|P-521|".indexOf(a) !== -1) return "secp521r1";
    return null;
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.crypto == "undefined" || !$b1badb002678e3c8$var$KJUR.crypto) $b1badb002678e3c8$var$KJUR.crypto = {};
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB = new function() {
    var b = {};
    var c = {};
    function a(d) {
        return new $b1badb002678e3c8$var$BigInteger(d, 16);
    }
    this.getByName = function(e) {
        var d = e;
        if (typeof c[d] != "undefined") d = c[e];
        if (typeof b[d] != "undefined") return b[d];
        throw "unregistered EC curve name: " + d;
    };
    this.regist = function(A, l, o, g, m, e, j, f, k, u, d, x) {
        b[A] = {};
        var s = a(o);
        var z = a(g);
        var y = a(m);
        var t = a(e);
        var w = a(j);
        var r = new $b1badb002678e3c8$var$ECCurveFp(s, z, y);
        var q = r.decodePointHex("04" + f + k);
        b[A]["name"] = A;
        b[A]["keylen"] = l;
        b[A]["keycharlen"] = Math.ceil(l / 8) * 2;
        b[A]["curve"] = r;
        b[A]["G"] = q;
        b[A]["n"] = t;
        b[A]["h"] = w;
        b[A]["oid"] = d;
        b[A]["info"] = x;
        for(var v = 0; v < u.length; v++)c[u[v]] = A;
    };
};
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field");
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field");
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field");
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []);
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []);
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []);
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []);
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", [
    "NIST P-256",
    "P-256",
    "prime256v1"
]);
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", [
    "NIST P-384",
    "P-384"
]);
$b1badb002678e3c8$var$KJUR.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "00C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", [
    "NIST P-521",
    "P-521"
]);
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.crypto == "undefined" || !$b1badb002678e3c8$var$KJUR.crypto) $b1badb002678e3c8$var$KJUR.crypto = {};
$b1badb002678e3c8$var$KJUR.crypto.DSA = function() {
    var b = $b1badb002678e3c8$var$ASN1HEX, e = b.getVbyList, d = b.getVbyListEx, a = b.isASN1HEX, c = $b1badb002678e3c8$var$BigInteger;
    this.p = null;
    this.q = null;
    this.g = null;
    this.y = null;
    this.x = null;
    this.type = "DSA";
    this.isPrivate = false;
    this.isPublic = false;
    this.setPrivate = function(j, i, h, k, f) {
        this.isPrivate = true;
        this.p = j;
        this.q = i;
        this.g = h;
        this.y = k;
        this.x = f;
    };
    this.setPrivateHex = function(i, g, k, n, o) {
        var h, f, j, l, m;
        h = new $b1badb002678e3c8$var$BigInteger(i, 16);
        f = new $b1badb002678e3c8$var$BigInteger(g, 16);
        j = new $b1badb002678e3c8$var$BigInteger(k, 16);
        if (typeof n === "string" && n.length > 1) l = new $b1badb002678e3c8$var$BigInteger(n, 16);
        else l = null;
        m = new $b1badb002678e3c8$var$BigInteger(o, 16);
        this.setPrivate(h, f, j, l, m);
    };
    this.setPublic = function(i, h, f, j) {
        this.isPublic = true;
        this.p = i;
        this.q = h;
        this.g = f;
        this.y = j;
        this.x = null;
    };
    this.setPublicHex = function(k, j, i, l) {
        var g, f, m, h;
        g = new $b1badb002678e3c8$var$BigInteger(k, 16);
        f = new $b1badb002678e3c8$var$BigInteger(j, 16);
        m = new $b1badb002678e3c8$var$BigInteger(i, 16);
        h = new $b1badb002678e3c8$var$BigInteger(l, 16);
        this.setPublic(g, f, m, h);
    };
    this.signWithMessageHash = function(j) {
        var i = this.p;
        var h = this.q;
        var m = this.g;
        var o = this.y;
        var t = this.x;
        var l = $b1badb002678e3c8$var$KJUR.crypto.Util.getRandomBigIntegerMinToMax($b1badb002678e3c8$var$BigInteger.ONE.add($b1badb002678e3c8$var$BigInteger.ONE), h.subtract($b1badb002678e3c8$var$BigInteger.ONE));
        var u = j.substr(0, h.bitLength() / 4);
        var n = new $b1badb002678e3c8$var$BigInteger(u, 16);
        var f = m.modPow(l, i).mod(h);
        var w = l.modInverse(h).multiply(n.add(t.multiply(f))).mod(h);
        var v = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.jsonToASN1HEX({
            seq: [
                {
                    "int": {
                        bigint: f
                    }
                },
                {
                    "int": {
                        bigint: w
                    }
                }
            ]
        });
        return v;
    };
    this.verifyWithMessageHash = function(m, l) {
        var j = this.p;
        var h = this.q;
        var o = this.g;
        var u = this.y;
        var n = this.parseASN1Signature(l);
        var f = n[0];
        var C = n[1];
        var B = m.substr(0, h.bitLength() / 4);
        var t = new $b1badb002678e3c8$var$BigInteger(B, 16);
        if ($b1badb002678e3c8$var$BigInteger.ZERO.compareTo(f) > 0 || f.compareTo(h) > 0) throw "invalid DSA signature";
        if ($b1badb002678e3c8$var$BigInteger.ZERO.compareTo(C) >= 0 || C.compareTo(h) > 0) throw "invalid DSA signature";
        var x = C.modInverse(h);
        var k = t.multiply(x).mod(h);
        var i = f.multiply(x).mod(h);
        var A = o.modPow(k, j).multiply(u.modPow(i, j)).mod(j).mod(h);
        return A.compareTo(f) == 0;
    };
    this.parseASN1Signature = function(f) {
        try {
            var i = new c(d(f, 0, [
                0
            ], "02"), 16);
            var h = new c(d(f, 0, [
                1
            ], "02"), 16);
            return [
                i,
                h
            ];
        } catch (g) {
            throw new Error("malformed ASN.1 DSA signature");
        }
    };
    this.readPKCS5PrvKeyHex = function(j) {
        var k, i, g, l, m;
        if (a(j) === false) throw new Error("not ASN.1 hex string");
        try {
            k = d(j, 0, [
                1
            ], "02");
            i = d(j, 0, [
                2
            ], "02");
            g = d(j, 0, [
                3
            ], "02");
            l = d(j, 0, [
                4
            ], "02");
            m = d(j, 0, [
                5
            ], "02");
        } catch (f) {
            throw new Error("malformed PKCS#1/5 plain DSA private key");
        }
        this.setPrivateHex(k, i, g, l, m);
    };
    this.readPKCS8PrvKeyHex = function(j) {
        var k, i, g, l;
        if (a(j) === false) throw new Error("not ASN.1 hex string");
        try {
            k = d(j, 0, [
                1,
                1,
                0
            ], "02");
            i = d(j, 0, [
                1,
                1,
                1
            ], "02");
            g = d(j, 0, [
                1,
                1,
                2
            ], "02");
            l = d(j, 0, [
                2,
                0
            ], "02");
        } catch (f) {
            throw new Error("malformed PKCS#8 plain DSA private key");
        }
        this.setPrivateHex(k, i, g, null, l);
    };
    this.readPKCS8PubKeyHex = function(j) {
        var k, i, g, l;
        if (a(j) === false) throw new Error("not ASN.1 hex string");
        try {
            k = d(j, 0, [
                0,
                1,
                0
            ], "02");
            i = d(j, 0, [
                0,
                1,
                1
            ], "02");
            g = d(j, 0, [
                0,
                1,
                2
            ], "02");
            l = d(j, 0, [
                1,
                0
            ], "02");
        } catch (f) {
            throw new Error("malformed PKCS#8 DSA public key");
        }
        this.setPublicHex(k, i, g, l);
    };
    this.readCertPubKeyHex = function(j, m) {
        var k, i, g, l;
        if (a(j) === false) throw new Error("not ASN.1 hex string");
        try {
            k = d(j, 0, [
                0,
                5,
                0,
                1,
                0
            ], "02");
            i = d(j, 0, [
                0,
                5,
                0,
                1,
                1
            ], "02");
            g = d(j, 0, [
                0,
                5,
                0,
                1,
                2
            ], "02");
            l = d(j, 0, [
                0,
                5,
                1,
                0
            ], "02");
        } catch (f) {
            throw new Error("malformed X.509 certificate DSA public key");
        }
        this.setPublicHex(k, i, g, l);
    };
};
var $b1badb002678e3c8$var$KEYUTIL = function() {
    var d = function(p, r, q) {
        return k($b1badb002678e3c8$var$CryptoJS.AES, p, r, q);
    };
    var e = function(p, r, q) {
        return k($b1badb002678e3c8$var$CryptoJS.TripleDES, p, r, q);
    };
    var a = function(p, r, q) {
        return k($b1badb002678e3c8$var$CryptoJS.DES, p, r, q);
    };
    var k = function(s, x, u, q) {
        var r = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(x);
        var w = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(u);
        var p = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(q);
        var t = {};
        t.key = w;
        t.iv = p;
        t.ciphertext = r;
        var v = s.decrypt(t, w, {
            iv: p
        });
        return $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(v);
    };
    var l = function(p, r, q) {
        return g($b1badb002678e3c8$var$CryptoJS.AES, p, r, q);
    };
    var o = function(p, r, q) {
        return g($b1badb002678e3c8$var$CryptoJS.TripleDES, p, r, q);
    };
    var f = function(p, r, q) {
        return g($b1badb002678e3c8$var$CryptoJS.DES, p, r, q);
    };
    var g = function(t, y, v, q) {
        var s = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(y);
        var x = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(v);
        var p = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(q);
        var w = t.encrypt(s, x, {
            iv: p
        });
        var r = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(w.toString());
        var u = $b1badb002678e3c8$var$CryptoJS.enc.Base64.stringify(r);
        return u;
    };
    var i = {
        "AES-256-CBC": {
            proc: d,
            eproc: l,
            keylen: 32,
            ivlen: 16
        },
        "AES-192-CBC": {
            proc: d,
            eproc: l,
            keylen: 24,
            ivlen: 16
        },
        "AES-128-CBC": {
            proc: d,
            eproc: l,
            keylen: 16,
            ivlen: 16
        },
        "DES-EDE3-CBC": {
            proc: e,
            eproc: o,
            keylen: 24,
            ivlen: 8
        },
        "DES-CBC": {
            proc: a,
            eproc: f,
            keylen: 8,
            ivlen: 8
        }
    };
    var c = function(p) {
        return i[p]["proc"];
    };
    var m = function(p) {
        var r = $b1badb002678e3c8$var$CryptoJS.lib.WordArray.random(p);
        var q = $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(r);
        return q;
    };
    var n = function(v) {
        var w = {};
        var q = v.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));
        if (q) {
            w.cipher = q[1];
            w.ivsalt = q[2];
        }
        var p = v.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));
        if (p) w.type = p[1];
        var u = -1;
        var x = 0;
        if (v.indexOf("\r\n\r\n") != -1) {
            u = v.indexOf("\r\n\r\n");
            x = 2;
        }
        if (v.indexOf("\n\n") != -1) {
            u = v.indexOf("\n\n");
            x = 1;
        }
        var t = v.indexOf("-----END");
        if (u != -1 && t != -1) {
            var r = v.substring(u + x * 2, t - x);
            r = r.replace(/\s+/g, "");
            w.data = r;
        }
        return w;
    };
    var j = function(q, y, p) {
        var v = p.substring(0, 16);
        var t = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(v);
        var r = $b1badb002678e3c8$var$CryptoJS.enc.Utf8.parse(y);
        var u = i[q]["keylen"] + i[q]["ivlen"];
        var x = "";
        var w = null;
        for(;;){
            var s = $b1badb002678e3c8$var$CryptoJS.algo.MD5.create();
            if (w != null) s.update(w);
            s.update(r);
            s.update(t);
            w = s.finalize();
            x = x + $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(w);
            if (x.length >= u * 2) break;
        }
        var z = {};
        z.keyhex = x.substr(0, i[q]["keylen"] * 2);
        z.ivhex = x.substr(i[q]["keylen"] * 2, i[q]["ivlen"] * 2);
        return z;
    };
    var b = function(p, v, r, w) {
        var s = $b1badb002678e3c8$var$CryptoJS.enc.Base64.parse(p);
        var q = $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(s);
        var u = i[v]["proc"];
        var t = u(q, r, w);
        return t;
    };
    var h = function(p, s, q, u) {
        var r = i[s]["eproc"];
        var t = r(p, q, u);
        return t;
    };
    return {
        version: "1.0.0",
        parsePKCS5PEM: function(p) {
            return n(p);
        },
        getKeyAndUnusedIvByPasscodeAndIvsalt: function(q, p, r) {
            return j(q, p, r);
        },
        decryptKeyB64: function(p, r, q, s) {
            return b(p, r, q, s);
        },
        getDecryptedKeyHex: function(y, x) {
            var q = n(y);
            var t = q.type;
            var r = q.cipher;
            var p = q.ivsalt;
            var s = q.data;
            var w = j(r, x, p);
            var v = w.keyhex;
            var u = b(s, r, v, p);
            return u;
        },
        getEncryptedPKCS5PEMFromPrvKeyHex: function(x, s, A, t, r) {
            var p = "";
            if (typeof t == "undefined" || t == null) t = "AES-256-CBC";
            if (typeof i[t] == "undefined") throw new Error("KEYUTIL unsupported algorithm: " + t);
            if (typeof r == "undefined" || r == null) {
                var v = i[t]["ivlen"];
                var u = m(v);
                r = u.toUpperCase();
            }
            var z = j(t, A, r);
            var y = z.keyhex;
            var w = h(s, t, y, r);
            var q = w.replace(/(.{64})/g, "$1\r\n");
            var p = "-----BEGIN " + x + " PRIVATE KEY-----\r\n";
            p += "Proc-Type: 4,ENCRYPTED\r\n";
            p += "DEK-Info: " + t + "," + r + "\r\n";
            p += "\r\n";
            p += q;
            p += "\r\n-----END " + x + " PRIVATE KEY-----\r\n";
            return p;
        },
        parseHexOfEncryptedPKCS8: function(y) {
            var B = $b1badb002678e3c8$var$ASN1HEX;
            var z = B.getChildIdx;
            var w = B.getV;
            var t = {};
            var r = z(y, 0);
            if (r.length != 2) throw new Error("malformed format: SEQUENCE(0).items != 2: " + r.length);
            t.ciphertext = w(y, r[1]);
            var A = z(y, r[0]);
            if (A.length != 2) throw new Error("malformed format: SEQUENCE(0.0).items != 2: " + A.length);
            if (w(y, A[0]) != "2a864886f70d01050d") throw new Error("this only supports pkcs5PBES2");
            var p = z(y, A[1]);
            if (A.length != 2) throw new Error("malformed format: SEQUENCE(0.0.1).items != 2: " + p.length);
            var q = z(y, p[1]);
            if (q.length != 2) throw new Error("malformed format: SEQUENCE(0.0.1.1).items != 2: " + q.length);
            if (w(y, q[0]) != "2a864886f70d0307") throw "this only supports TripleDES";
            t.encryptionSchemeAlg = "TripleDES";
            t.encryptionSchemeIV = w(y, q[1]);
            var s = z(y, p[0]);
            if (s.length != 2) throw new Error("malformed format: SEQUENCE(0.0.1.0).items != 2: " + s.length);
            if (w(y, s[0]) != "2a864886f70d01050c") throw new Error("this only supports pkcs5PBKDF2");
            var x = z(y, s[1]);
            if (x.length < 2) throw new Error("malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + x.length);
            t.pbkdf2Salt = w(y, x[0]);
            var u = w(y, x[1]);
            try {
                t.pbkdf2Iter = parseInt(u, 16);
            } catch (v) {
                throw new Error("malformed format pbkdf2Iter: " + u);
            }
            return t;
        },
        getPBKDF2KeyHexFromParam: function(u, p) {
            var t = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(u.pbkdf2Salt);
            var q = u.pbkdf2Iter;
            var s = $b1badb002678e3c8$var$CryptoJS.PBKDF2(p, t, {
                keySize: 6,
                iterations: q
            });
            var r = $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(s);
            return r;
        },
        _getPlainPKCS8HexFromEncryptedPKCS8PEM: function(x, y) {
            var r = $b1badb002678e3c8$var$pemtohex(x, "ENCRYPTED PRIVATE KEY");
            var p = this.parseHexOfEncryptedPKCS8(r);
            var u = $b1badb002678e3c8$var$KEYUTIL.getPBKDF2KeyHexFromParam(p, y);
            var v = {};
            v.ciphertext = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(p.ciphertext);
            var t = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(u);
            var s = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(p.encryptionSchemeIV);
            var w = $b1badb002678e3c8$var$CryptoJS.TripleDES.decrypt(v, t, {
                iv: s
            });
            var q = $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(w);
            return q;
        },
        getKeyFromEncryptedPKCS8PEM: function(s, q) {
            var p = this._getPlainPKCS8HexFromEncryptedPKCS8PEM(s, q);
            var r = this.getKeyFromPlainPrivatePKCS8Hex(p);
            return r;
        },
        parsePlainPrivatePKCS8Hex: function(s) {
            var v = $b1badb002678e3c8$var$ASN1HEX;
            var u = v.getChildIdx;
            var t = v.getV;
            var q = {};
            q.algparam = null;
            if (s.substr(0, 2) != "30") throw new Error("malformed plain PKCS8 private key(code:001)");
            var r = u(s, 0);
            if (r.length < 3) throw new Error("malformed plain PKCS8 private key(code:002)");
            if (s.substr(r[1], 2) != "30") throw new Error("malformed PKCS8 private key(code:003)");
            var p = u(s, r[1]);
            if (p.length != 2) throw new Error("malformed PKCS8 private key(code:004)");
            if (s.substr(p[0], 2) != "06") throw new Error("malformed PKCS8 private key(code:005)");
            q.algoid = t(s, p[0]);
            if (s.substr(p[1], 2) == "06") q.algparam = t(s, p[1]);
            if (s.substr(r[2], 2) != "04") throw new Error("malformed PKCS8 private key(code:006)");
            q.keyidx = v.getVidx(s, r[2]);
            return q;
        },
        getKeyFromPlainPrivatePKCS8PEM: function(q) {
            var p = $b1badb002678e3c8$var$pemtohex(q, "PRIVATE KEY");
            var r = this.getKeyFromPlainPrivatePKCS8Hex(p);
            return r;
        },
        getKeyFromPlainPrivatePKCS8Hex: function(p) {
            var q = this.parsePlainPrivatePKCS8Hex(p);
            var r;
            if (q.algoid == "2a864886f70d010101") r = new $b1badb002678e3c8$var$RSAKey();
            else if (q.algoid == "2a8648ce380401") r = new $b1badb002678e3c8$var$KJUR.crypto.DSA();
            else {
                if (q.algoid == "2a8648ce3d0201") r = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA();
                else throw new Error("unsupported private key algorithm");
            }
            r.readPKCS8PrvKeyHex(p);
            return r;
        },
        _getKeyFromPublicPKCS8Hex: function(q) {
            var p;
            var r = $b1badb002678e3c8$var$ASN1HEX.getVbyList(q, 0, [
                0,
                0
            ], "06");
            if (r === "2a864886f70d010101") p = new $b1badb002678e3c8$var$RSAKey();
            else if (r === "2a8648ce380401") p = new $b1badb002678e3c8$var$KJUR.crypto.DSA();
            else {
                if (r === "2a8648ce3d0201") p = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA();
                else throw new Error("unsupported PKCS#8 public key hex");
            }
            p.readPKCS8PubKeyHex(q);
            return p;
        },
        parsePublicRawRSAKeyHex: function(r) {
            var u = $b1badb002678e3c8$var$ASN1HEX;
            var t = u.getChildIdx;
            var s = u.getV;
            var p = {};
            if (r.substr(0, 2) != "30") throw new Error("malformed RSA key(code:001)");
            var q = t(r, 0);
            if (q.length != 2) throw new Error("malformed RSA key(code:002)");
            if (r.substr(q[0], 2) != "02") throw new Error("malformed RSA key(code:003)");
            p.n = s(r, q[0]);
            if (r.substr(q[1], 2) != "02") throw new Error("malformed RSA key(code:004)");
            p.e = s(r, q[1]);
            return p;
        },
        parsePublicPKCS8Hex: function(t) {
            var v = $b1badb002678e3c8$var$ASN1HEX;
            var u = v.getChildIdx;
            var s = v.getV;
            var q = {};
            q.algparam = null;
            var r = u(t, 0);
            if (r.length != 2) throw new Error("outer DERSequence shall have 2 elements: " + r.length);
            var w = r[0];
            if (t.substr(w, 2) != "30") throw new Error("malformed PKCS8 public key(code:001)");
            var p = u(t, w);
            if (p.length != 2) throw new Error("malformed PKCS8 public key(code:002)");
            if (t.substr(p[0], 2) != "06") throw new Error("malformed PKCS8 public key(code:003)");
            q.algoid = s(t, p[0]);
            if (t.substr(p[1], 2) == "06") q.algparam = s(t, p[1]);
            else if (t.substr(p[1], 2) == "30") {
                q.algparam = {};
                q.algparam.p = v.getVbyList(t, p[1], [
                    0
                ], "02");
                q.algparam.q = v.getVbyList(t, p[1], [
                    1
                ], "02");
                q.algparam.g = v.getVbyList(t, p[1], [
                    2
                ], "02");
            }
            if (t.substr(r[1], 2) != "03") throw new Error("malformed PKCS8 public key(code:004)");
            q.key = s(t, r[1]).substr(2);
            return q;
        }
    };
}();
$b1badb002678e3c8$var$KEYUTIL.getKey = function(l, k, n) {
    var G = $b1badb002678e3c8$var$ASN1HEX, L = G.getChildIdx, v = G.getV, d = G.getVbyList, c = $b1badb002678e3c8$var$KJUR.crypto, i = c.ECDSA, C = c.DSA, w = $b1badb002678e3c8$var$RSAKey, M = $b1badb002678e3c8$var$pemtohex, F = $b1badb002678e3c8$var$KEYUTIL;
    if (typeof w != "undefined" && l instanceof w) return l;
    if (typeof i != "undefined" && l instanceof i) return l;
    if (typeof C != "undefined" && l instanceof C) return l;
    if (l.curve !== undefined && l.xy !== undefined && l.d === undefined) return new i({
        pub: l.xy,
        curve: l.curve
    });
    if (l.curve !== undefined && l.d !== undefined) return new i({
        prv: l.d,
        curve: l.curve
    });
    if (l.kty === undefined && l.n !== undefined && l.e !== undefined && l.d === undefined) {
        var P = new w();
        P.setPublic(l.n, l.e);
        return P;
    }
    if (l.kty === undefined && l.n !== undefined && l.e !== undefined && l.d !== undefined && l.p !== undefined && l.q !== undefined && l.dp !== undefined && l.dq !== undefined && l.co !== undefined && l.qi === undefined) {
        var P = new w();
        P.setPrivateEx(l.n, l.e, l.d, l.p, l.q, l.dp, l.dq, l.co);
        return P;
    }
    if (l.kty === undefined && l.n !== undefined && l.e !== undefined && l.d !== undefined && l.p === undefined) {
        var P = new w();
        P.setPrivate(l.n, l.e, l.d);
        return P;
    }
    if (l.p !== undefined && l.q !== undefined && l.g !== undefined && l.y !== undefined && l.x === undefined) {
        var P = new C();
        P.setPublic(l.p, l.q, l.g, l.y);
        return P;
    }
    if (l.p !== undefined && l.q !== undefined && l.g !== undefined && l.y !== undefined && l.x !== undefined) {
        var P = new C();
        P.setPrivate(l.p, l.q, l.g, l.y, l.x);
        return P;
    }
    if (l.kty === "RSA" && l.n !== undefined && l.e !== undefined && l.d === undefined) {
        var P = new w();
        P.setPublic($b1badb002678e3c8$var$b64utohex(l.n), $b1badb002678e3c8$var$b64utohex(l.e));
        return P;
    }
    if (l.kty === "RSA" && l.n !== undefined && l.e !== undefined && l.d !== undefined && l.p !== undefined && l.q !== undefined && l.dp !== undefined && l.dq !== undefined && l.qi !== undefined) {
        var P = new w();
        P.setPrivateEx($b1badb002678e3c8$var$b64utohex(l.n), $b1badb002678e3c8$var$b64utohex(l.e), $b1badb002678e3c8$var$b64utohex(l.d), $b1badb002678e3c8$var$b64utohex(l.p), $b1badb002678e3c8$var$b64utohex(l.q), $b1badb002678e3c8$var$b64utohex(l.dp), $b1badb002678e3c8$var$b64utohex(l.dq), $b1badb002678e3c8$var$b64utohex(l.qi));
        return P;
    }
    if (l.kty === "RSA" && l.n !== undefined && l.e !== undefined && l.d !== undefined) {
        var P = new w();
        P.setPrivate($b1badb002678e3c8$var$b64utohex(l.n), $b1badb002678e3c8$var$b64utohex(l.e), $b1badb002678e3c8$var$b64utohex(l.d));
        return P;
    }
    if (l.kty === "EC" && l.crv !== undefined && l.x !== undefined && l.y !== undefined && l.d === undefined) {
        var j = new i({
            curve: l.crv
        });
        var t = j.ecparams.keycharlen;
        var B = ("0000000000" + $b1badb002678e3c8$var$b64utohex(l.x)).slice(-t);
        var z = ("0000000000" + $b1badb002678e3c8$var$b64utohex(l.y)).slice(-t);
        var u = "04" + B + z;
        j.setPublicKeyHex(u);
        return j;
    }
    if (l.kty === "EC" && l.crv !== undefined && l.x !== undefined && l.y !== undefined && l.d !== undefined) {
        var j = new i({
            curve: l.crv
        });
        var t = j.ecparams.keycharlen;
        var B = ("0000000000" + $b1badb002678e3c8$var$b64utohex(l.x)).slice(-t);
        var z = ("0000000000" + $b1badb002678e3c8$var$b64utohex(l.y)).slice(-t);
        var u = "04" + B + z;
        var b = ("0000000000" + $b1badb002678e3c8$var$b64utohex(l.d)).slice(-t);
        j.setPublicKeyHex(u);
        j.setPrivateKeyHex(b);
        return j;
    }
    if (n === "pkcs5prv") {
        var J = l, G = $b1badb002678e3c8$var$ASN1HEX, N, P;
        N = L(J, 0);
        if (N.length === 9) {
            P = new w();
            P.readPKCS5PrvKeyHex(J);
        } else if (N.length === 6) {
            P = new C();
            P.readPKCS5PrvKeyHex(J);
        } else {
            if (N.length > 2 && J.substr(N[1], 2) === "04") {
                P = new i();
                P.readPKCS5PrvKeyHex(J);
            } else throw new Error("unsupported PKCS#1/5 hexadecimal key");
        }
        return P;
    }
    if (n === "pkcs8prv") {
        var P = F.getKeyFromPlainPrivatePKCS8Hex(l);
        return P;
    }
    if (n === "pkcs8pub") return F._getKeyFromPublicPKCS8Hex(l);
    if (n === "x509pub") return $b1badb002678e3c8$var$X509.getPublicKeyFromCertHex(l);
    if (l.indexOf("-END CERTIFICATE-", 0) != -1 || l.indexOf("-END X509 CERTIFICATE-", 0) != -1 || l.indexOf("-END TRUSTED CERTIFICATE-", 0) != -1) return $b1badb002678e3c8$var$X509.getPublicKeyFromCertPEM(l);
    if (l.indexOf("-END PUBLIC KEY-") != -1) {
        var O = $b1badb002678e3c8$var$pemtohex(l, "PUBLIC KEY");
        return F._getKeyFromPublicPKCS8Hex(O);
    }
    if (l.indexOf("-END RSA PRIVATE KEY-") != -1 && l.indexOf("4,ENCRYPTED") == -1) {
        var m = M(l, "RSA PRIVATE KEY");
        return F.getKey(m, null, "pkcs5prv");
    }
    if (l.indexOf("-END DSA PRIVATE KEY-") != -1 && l.indexOf("4,ENCRYPTED") == -1) {
        var I = M(l, "DSA PRIVATE KEY");
        var E = d(I, 0, [
            1
        ], "02");
        var D = d(I, 0, [
            2
        ], "02");
        var K = d(I, 0, [
            3
        ], "02");
        var r = d(I, 0, [
            4
        ], "02");
        var s = d(I, 0, [
            5
        ], "02");
        var P = new C();
        P.setPrivate(new $b1badb002678e3c8$var$BigInteger(E, 16), new $b1badb002678e3c8$var$BigInteger(D, 16), new $b1badb002678e3c8$var$BigInteger(K, 16), new $b1badb002678e3c8$var$BigInteger(r, 16), new $b1badb002678e3c8$var$BigInteger(s, 16));
        return P;
    }
    if (l.indexOf("-END EC PRIVATE KEY-") != -1 && l.indexOf("4,ENCRYPTED") == -1) {
        var m = M(l, "EC PRIVATE KEY");
        return F.getKey(m, null, "pkcs5prv");
    }
    if (l.indexOf("-END PRIVATE KEY-") != -1) return F.getKeyFromPlainPrivatePKCS8PEM(l);
    if (l.indexOf("-END RSA PRIVATE KEY-") != -1 && l.indexOf("4,ENCRYPTED") != -1) {
        var o = F.getDecryptedKeyHex(l, k);
        var H = new $b1badb002678e3c8$var$RSAKey();
        H.readPKCS5PrvKeyHex(o);
        return H;
    }
    if (l.indexOf("-END EC PRIVATE KEY-") != -1 && l.indexOf("4,ENCRYPTED") != -1) {
        var I = F.getDecryptedKeyHex(l, k);
        var P = d(I, 0, [
            1
        ], "04");
        var f = d(I, 0, [
            2,
            0
        ], "06");
        var A = d(I, 0, [
            3,
            0
        ], "03").substr(2);
        var e = "";
        if ($b1badb002678e3c8$var$KJUR.crypto.OID.oidhex2name[f] !== undefined) e = $b1badb002678e3c8$var$KJUR.crypto.OID.oidhex2name[f];
        else throw new Error("undefined OID(hex) in KJUR.crypto.OID: " + f);
        var j = new i({
            curve: e
        });
        j.setPublicKeyHex(A);
        j.setPrivateKeyHex(P);
        j.isPublic = false;
        return j;
    }
    if (l.indexOf("-END DSA PRIVATE KEY-") != -1 && l.indexOf("4,ENCRYPTED") != -1) {
        var I = F.getDecryptedKeyHex(l, k);
        var E = d(I, 0, [
            1
        ], "02");
        var D = d(I, 0, [
            2
        ], "02");
        var K = d(I, 0, [
            3
        ], "02");
        var r = d(I, 0, [
            4
        ], "02");
        var s = d(I, 0, [
            5
        ], "02");
        var P = new C();
        P.setPrivate(new $b1badb002678e3c8$var$BigInteger(E, 16), new $b1badb002678e3c8$var$BigInteger(D, 16), new $b1badb002678e3c8$var$BigInteger(K, 16), new $b1badb002678e3c8$var$BigInteger(r, 16), new $b1badb002678e3c8$var$BigInteger(s, 16));
        return P;
    }
    if (l.indexOf("-END ENCRYPTED PRIVATE KEY-") != -1) return F.getKeyFromEncryptedPKCS8PEM(l, k);
    throw new Error("not supported argument");
};
$b1badb002678e3c8$var$KEYUTIL.generateKeypair = function(a, c) {
    if (a == "RSA") {
        var b = c;
        var h = new $b1badb002678e3c8$var$RSAKey();
        h.generate(b, "10001");
        h.isPrivate = true;
        h.isPublic = true;
        var f = new $b1badb002678e3c8$var$RSAKey();
        var e = h.n.toString(16);
        var i = h.e.toString(16);
        f.setPublic(e, i);
        f.isPrivate = false;
        f.isPublic = true;
        var k = {};
        k.prvKeyObj = h;
        k.pubKeyObj = f;
        return k;
    } else {
        if (a == "EC") {
            var d = c;
            var g = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA({
                curve: d
            });
            var j = g.generateKeyPairHex();
            var h = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA({
                curve: d
            });
            h.setPublicKeyHex(j.ecpubhex);
            h.setPrivateKeyHex(j.ecprvhex);
            h.isPrivate = true;
            h.isPublic = false;
            var f = new $b1badb002678e3c8$var$KJUR.crypto.ECDSA({
                curve: d
            });
            f.setPublicKeyHex(j.ecpubhex);
            f.isPrivate = false;
            f.isPublic = true;
            var k = {};
            k.prvKeyObj = h;
            k.pubKeyObj = f;
            return k;
        } else throw new Error("unknown algorithm: " + a);
    }
};
$b1badb002678e3c8$var$KEYUTIL.getPEM = function(b, D, y, m, q, j) {
    var F = $b1badb002678e3c8$var$KJUR, k = F.asn1, z = k.DERObjectIdentifier, f = k.DERInteger, l = k.ASN1Util.newObject, a = k.x509, C = a.SubjectPublicKeyInfo, e = F.crypto, u = e.DSA, r = e.ECDSA, n = $b1badb002678e3c8$var$RSAKey;
    function A(s) {
        var H = l({
            seq: [
                {
                    "int": 0
                },
                {
                    "int": {
                        bigint: s.n
                    }
                },
                {
                    "int": s.e
                },
                {
                    "int": {
                        bigint: s.d
                    }
                },
                {
                    "int": {
                        bigint: s.p
                    }
                },
                {
                    "int": {
                        bigint: s.q
                    }
                },
                {
                    "int": {
                        bigint: s.dmp1
                    }
                },
                {
                    "int": {
                        bigint: s.dmq1
                    }
                },
                {
                    "int": {
                        bigint: s.coeff
                    }
                }
            ]
        });
        return H;
    }
    function B(H) {
        var s = l({
            seq: [
                {
                    "int": 1
                },
                {
                    octstr: {
                        hex: H.prvKeyHex
                    }
                },
                {
                    tag: [
                        "a0",
                        true,
                        {
                            oid: {
                                name: H.curveName
                            }
                        }
                    ]
                },
                {
                    tag: [
                        "a1",
                        true,
                        {
                            bitstr: {
                                hex: "00" + H.pubKeyHex
                            }
                        }
                    ]
                }
            ]
        });
        return s;
    }
    function x(s) {
        var H = l({
            seq: [
                {
                    "int": 0
                },
                {
                    "int": {
                        bigint: s.p
                    }
                },
                {
                    "int": {
                        bigint: s.q
                    }
                },
                {
                    "int": {
                        bigint: s.g
                    }
                },
                {
                    "int": {
                        bigint: s.y
                    }
                },
                {
                    "int": {
                        bigint: s.x
                    }
                }
            ]
        });
        return H;
    }
    if ((n !== undefined && b instanceof n || u !== undefined && b instanceof u || r !== undefined && b instanceof r) && b.isPublic == true && (D === undefined || D == "PKCS8PUB")) {
        var E = new C(b);
        var w = E.tohex();
        return $b1badb002678e3c8$var$hextopem(w, "PUBLIC KEY");
    }
    if (D == "PKCS1PRV" && n !== undefined && b instanceof n && (y === undefined || y == null) && b.isPrivate == true) {
        var E = A(b);
        var w = E.tohex();
        return $b1badb002678e3c8$var$hextopem(w, "RSA PRIVATE KEY");
    }
    if (D == "PKCS1PRV" && r !== undefined && b instanceof r && (y === undefined || y == null) && b.isPrivate == true) {
        var i = new z({
            name: b.curveName
        });
        var v = i.tohex();
        var h = B(b);
        var t = h.tohex();
        var p = "";
        p += $b1badb002678e3c8$var$hextopem(v, "EC PARAMETERS");
        p += $b1badb002678e3c8$var$hextopem(t, "EC PRIVATE KEY");
        return p;
    }
    if (D == "PKCS1PRV" && u !== undefined && b instanceof u && (y === undefined || y == null) && b.isPrivate == true) {
        var E = x(b);
        var w = E.tohex();
        return $b1badb002678e3c8$var$hextopem(w, "DSA PRIVATE KEY");
    }
    if (D == "PKCS5PRV" && n !== undefined && b instanceof n && y !== undefined && y != null && b.isPrivate == true) {
        var E = A(b);
        var w = E.tohex();
        if (m === undefined) m = "DES-EDE3-CBC";
        return this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", w, y, m, j);
    }
    if (D == "PKCS5PRV" && r !== undefined && b instanceof r && y !== undefined && y != null && b.isPrivate == true) {
        var E = B(b);
        var w = E.tohex();
        if (m === undefined) m = "DES-EDE3-CBC";
        return this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", w, y, m, j);
    }
    if (D == "PKCS5PRV" && u !== undefined && b instanceof u && y !== undefined && y != null && b.isPrivate == true) {
        var E = x(b);
        var w = E.tohex();
        if (m === undefined) m = "DES-EDE3-CBC";
        return this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", w, y, m, j);
    }
    var o = function(H, s) {
        var J = c(H, s);
        var I = new l({
            seq: [
                {
                    seq: [
                        {
                            oid: {
                                name: "pkcs5PBES2"
                            }
                        },
                        {
                            seq: [
                                {
                                    seq: [
                                        {
                                            oid: {
                                                name: "pkcs5PBKDF2"
                                            }
                                        },
                                        {
                                            seq: [
                                                {
                                                    octstr: {
                                                        hex: J.pbkdf2Salt
                                                    }
                                                },
                                                {
                                                    "int": J.pbkdf2Iter
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    seq: [
                                        {
                                            oid: {
                                                name: "des-EDE3-CBC"
                                            }
                                        },
                                        {
                                            octstr: {
                                                hex: J.encryptionSchemeIV
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    octstr: {
                        hex: J.ciphertext
                    }
                }
            ]
        });
        return I.tohex();
    };
    var c = function(O, P) {
        var I = 100;
        var N = $b1badb002678e3c8$var$CryptoJS.lib.WordArray.random(8);
        var M = "DES-EDE3-CBC";
        var s = $b1badb002678e3c8$var$CryptoJS.lib.WordArray.random(8);
        var J = $b1badb002678e3c8$var$CryptoJS.PBKDF2(P, N, {
            keySize: 6,
            iterations: I
        });
        var K = $b1badb002678e3c8$var$CryptoJS.enc.Hex.parse(O);
        var L = $b1badb002678e3c8$var$CryptoJS.TripleDES.encrypt(K, J, {
            iv: s
        }) + "";
        var H = {};
        H.ciphertext = L;
        H.pbkdf2Salt = $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(N);
        H.pbkdf2Iter = I;
        H.encryptionSchemeAlg = M;
        H.encryptionSchemeIV = $b1badb002678e3c8$var$CryptoJS.enc.Hex.stringify(s);
        return H;
    };
    if (D == "PKCS8PRV" && n != undefined && b instanceof n && b.isPrivate == true) {
        var g = A(b);
        var d = g.tohex();
        var E = l({
            seq: [
                {
                    "int": 0
                },
                {
                    seq: [
                        {
                            oid: {
                                name: "rsaEncryption"
                            }
                        },
                        {
                            "null": true
                        }
                    ]
                },
                {
                    octstr: {
                        hex: d
                    }
                }
            ]
        });
        var w = E.tohex();
        if (y === undefined || y == null) return $b1badb002678e3c8$var$hextopem(w, "PRIVATE KEY");
        else {
            var t = o(w, y);
            return $b1badb002678e3c8$var$hextopem(t, "ENCRYPTED PRIVATE KEY");
        }
    }
    if (D == "PKCS8PRV" && r !== undefined && b instanceof r && b.isPrivate == true) {
        var G = {
            seq: [
                {
                    "int": 1
                },
                {
                    octstr: {
                        hex: b.prvKeyHex
                    }
                }
            ]
        };
        if (typeof b.pubKeyHex == "string") G.seq.push({
            tag: [
                "a1",
                true,
                {
                    bitstr: {
                        hex: "00" + b.pubKeyHex
                    }
                }
            ]
        });
        var g = new l(G);
        var d = g.tohex();
        var E = l({
            seq: [
                {
                    "int": 0
                },
                {
                    seq: [
                        {
                            oid: {
                                name: "ecPublicKey"
                            }
                        },
                        {
                            oid: {
                                name: b.curveName
                            }
                        }
                    ]
                },
                {
                    octstr: {
                        hex: d
                    }
                }
            ]
        });
        var w = E.tohex();
        if (y === undefined || y == null) return $b1badb002678e3c8$var$hextopem(w, "PRIVATE KEY");
        else {
            var t = o(w, y);
            return $b1badb002678e3c8$var$hextopem(t, "ENCRYPTED PRIVATE KEY");
        }
    }
    if (D == "PKCS8PRV" && u !== undefined && b instanceof u && b.isPrivate == true) {
        var g = new f({
            bigint: b.x
        });
        var d = g.tohex();
        var E = l({
            seq: [
                {
                    "int": 0
                },
                {
                    seq: [
                        {
                            oid: {
                                name: "dsa"
                            }
                        },
                        {
                            seq: [
                                {
                                    "int": {
                                        bigint: b.p
                                    }
                                },
                                {
                                    "int": {
                                        bigint: b.q
                                    }
                                },
                                {
                                    "int": {
                                        bigint: b.g
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    octstr: {
                        hex: d
                    }
                }
            ]
        });
        var w = E.tohex();
        if (y === undefined || y == null) return $b1badb002678e3c8$var$hextopem(w, "PRIVATE KEY");
        else {
            var t = o(w, y);
            return $b1badb002678e3c8$var$hextopem(t, "ENCRYPTED PRIVATE KEY");
        }
    }
    throw new Error("unsupported object nor format");
};
$b1badb002678e3c8$var$KEYUTIL.getKeyFromCSRPEM = function(b) {
    var a = $b1badb002678e3c8$var$pemtohex(b, "CERTIFICATE REQUEST");
    var c = $b1badb002678e3c8$var$KEYUTIL.getKeyFromCSRHex(a);
    return c;
};
$b1badb002678e3c8$var$KEYUTIL.getKeyFromCSRHex = function(a) {
    var c = $b1badb002678e3c8$var$KEYUTIL.parseCSRHex(a);
    var b = $b1badb002678e3c8$var$KEYUTIL.getKey(c.p8pubkeyhex, null, "pkcs8pub");
    return b;
};
$b1badb002678e3c8$var$KEYUTIL.parseCSRHex = function(d) {
    var i = $b1badb002678e3c8$var$ASN1HEX;
    var f = i.getChildIdx;
    var c = i.getTLV;
    var b = {};
    var g = d;
    if (g.substr(0, 2) != "30") throw new Error("malformed CSR(code:001)");
    var e = f(g, 0);
    if (e.length < 1) throw new Error("malformed CSR(code:002)");
    if (g.substr(e[0], 2) != "30") throw new Error("malformed CSR(code:003)");
    var a = f(g, e[0]);
    if (a.length < 3) throw new Error("malformed CSR(code:004)");
    b.p8pubkeyhex = c(g, a[2]);
    return b;
};
$b1badb002678e3c8$var$KEYUTIL.getKeyID = function(f) {
    var c = $b1badb002678e3c8$var$KEYUTIL;
    var e = $b1badb002678e3c8$var$ASN1HEX;
    if (typeof f === "string" && f.indexOf("BEGIN ") != -1) f = c.getKey(f);
    var d = $b1badb002678e3c8$var$pemtohex(c.getPEM(f));
    var b = e.getIdxbyList(d, 0, [
        1
    ]);
    var a = e.getV(d, b).substring(2);
    return $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(a, "sha1");
};
$b1badb002678e3c8$var$KEYUTIL.getJWK = function(d, h, g, b, f) {
    var i;
    var k = {};
    var e;
    var c = $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex;
    if (typeof d == "string") {
        i = $b1badb002678e3c8$var$KEYUTIL.getKey(d);
        if (d.indexOf("CERTIFICATE") != -1) e = $b1badb002678e3c8$var$pemtohex(d);
    } else {
        if (typeof d == "object") {
            if (d instanceof $b1badb002678e3c8$var$X509) {
                i = d.getPublicKey();
                e = d.hex;
            } else i = d;
        } else throw new Error("unsupported keyinfo type");
    }
    if (i instanceof $b1badb002678e3c8$var$RSAKey && i.isPrivate) {
        k.kty = "RSA";
        k.n = $b1badb002678e3c8$var$hextob64u(i.n.toString(16));
        k.e = $b1badb002678e3c8$var$hextob64u(i.e.toString(16));
        k.d = $b1badb002678e3c8$var$hextob64u(i.d.toString(16));
        k.p = $b1badb002678e3c8$var$hextob64u(i.p.toString(16));
        k.q = $b1badb002678e3c8$var$hextob64u(i.q.toString(16));
        k.dp = $b1badb002678e3c8$var$hextob64u(i.dmp1.toString(16));
        k.dq = $b1badb002678e3c8$var$hextob64u(i.dmq1.toString(16));
        k.qi = $b1badb002678e3c8$var$hextob64u(i.coeff.toString(16));
    } else if (i instanceof $b1badb002678e3c8$var$RSAKey && i.isPublic) {
        k.kty = "RSA";
        k.n = $b1badb002678e3c8$var$hextob64u(i.n.toString(16));
        k.e = $b1badb002678e3c8$var$hextob64u(i.e.toString(16));
    } else {
        if (i instanceof $b1badb002678e3c8$var$KJUR.crypto.ECDSA && i.isPrivate) {
            var a = i.getShortNISTPCurveName();
            if (a !== "P-256" && a !== "P-384" && a !== "P-521") throw new Error("unsupported curve name for JWT: " + a);
            var j = i.getPublicKeyXYHex();
            k.kty = "EC";
            k.crv = a;
            k.x = $b1badb002678e3c8$var$hextob64u(j.x);
            k.y = $b1badb002678e3c8$var$hextob64u(j.y);
            k.d = $b1badb002678e3c8$var$hextob64u(i.prvKeyHex);
        } else if (i instanceof $b1badb002678e3c8$var$KJUR.crypto.ECDSA && i.isPublic) {
            var a = i.getShortNISTPCurveName();
            if (a !== "P-256" && a !== "P-384" && a !== "P-521") throw new Error("unsupported curve name for JWT: " + a);
            var j = i.getPublicKeyXYHex();
            k.kty = "EC";
            k.crv = a;
            k.x = $b1badb002678e3c8$var$hextob64u(j.x);
            k.y = $b1badb002678e3c8$var$hextob64u(j.y);
        }
    }
    if (k.kty == undefined) throw new Error("unsupported keyinfo");
    if (!i.isPrivate && h != true) k.kid = $b1badb002678e3c8$var$KJUR.jws.JWS.getJWKthumbprint(k);
    if (e != undefined && g != true) k.x5c = [
        $b1badb002678e3c8$var$hex2b64(e)
    ];
    if (e != undefined && b != true) k.x5t = $b1badb002678e3c8$var$b64tob64u($b1badb002678e3c8$var$hex2b64(c(e, "sha1")));
    if (e != undefined && f != true) k["x5t#S256"] = $b1badb002678e3c8$var$b64tob64u($b1badb002678e3c8$var$hex2b64(c(e, "sha256")));
    return k;
};
$b1badb002678e3c8$var$KEYUTIL.getJWKFromKey = function(a) {
    return $b1badb002678e3c8$var$KEYUTIL.getJWK(a, true, true, true, true);
};
$b1badb002678e3c8$var$RSAKey.getPosArrayOfChildrenFromHex = function(a) {
    return $b1badb002678e3c8$var$ASN1HEX.getChildIdx(a, 0);
};
$b1badb002678e3c8$var$RSAKey.getHexValueArrayOfChildrenFromHex = function(f) {
    var n = $b1badb002678e3c8$var$ASN1HEX;
    var i = n.getV;
    var k = $b1badb002678e3c8$var$RSAKey.getPosArrayOfChildrenFromHex(f);
    var e = i(f, k[0]);
    var j = i(f, k[1]);
    var b = i(f, k[2]);
    var c = i(f, k[3]);
    var h = i(f, k[4]);
    var g = i(f, k[5]);
    var m = i(f, k[6]);
    var l = i(f, k[7]);
    var d = i(f, k[8]);
    var k = new Array();
    k.push(e, j, b, c, h, g, m, l, d);
    return k;
};
$b1badb002678e3c8$var$RSAKey.prototype.readPrivateKeyFromPEMString = function(d) {
    var c = $b1badb002678e3c8$var$pemtohex(d);
    var b = $b1badb002678e3c8$var$RSAKey.getHexValueArrayOfChildrenFromHex(c);
    this.setPrivateEx(b[1], b[2], b[3], b[4], b[5], b[6], b[7], b[8]);
};
$b1badb002678e3c8$var$RSAKey.prototype.readPKCS5PrvKeyHex = function(c) {
    var b = $b1badb002678e3c8$var$RSAKey.getHexValueArrayOfChildrenFromHex(c);
    this.setPrivateEx(b[1], b[2], b[3], b[4], b[5], b[6], b[7], b[8]);
};
$b1badb002678e3c8$var$RSAKey.prototype.readPKCS8PrvKeyHex = function(e) {
    var c, i, k, b, a, f, d, j;
    var m = $b1badb002678e3c8$var$ASN1HEX;
    var l = m.getVbyListEx;
    if (m.isASN1HEX(e) === false) throw new Error("not ASN.1 hex string");
    try {
        c = l(e, 0, [
            2,
            0,
            1
        ], "02");
        i = l(e, 0, [
            2,
            0,
            2
        ], "02");
        k = l(e, 0, [
            2,
            0,
            3
        ], "02");
        b = l(e, 0, [
            2,
            0,
            4
        ], "02");
        a = l(e, 0, [
            2,
            0,
            5
        ], "02");
        f = l(e, 0, [
            2,
            0,
            6
        ], "02");
        d = l(e, 0, [
            2,
            0,
            7
        ], "02");
        j = l(e, 0, [
            2,
            0,
            8
        ], "02");
    } catch (g) {
        throw new Error("malformed PKCS#8 plain RSA private key");
    }
    this.setPrivateEx(c, i, k, b, a, f, d, j);
};
$b1badb002678e3c8$var$RSAKey.prototype.readPKCS5PubKeyHex = function(c) {
    var e = $b1badb002678e3c8$var$ASN1HEX;
    var b = e.getV;
    if (e.isASN1HEX(c) === false) throw new Error("keyHex is not ASN.1 hex string");
    var a = e.getChildIdx(c, 0);
    if (a.length !== 2 || c.substr(a[0], 2) !== "02" || c.substr(a[1], 2) !== "02") throw new Error("wrong hex for PKCS#5 public key");
    var f = b(c, a[0]);
    var d = b(c, a[1]);
    this.setPublic(f, d);
};
$b1badb002678e3c8$var$RSAKey.prototype.readPKCS8PubKeyHex = function(b) {
    var c = $b1badb002678e3c8$var$ASN1HEX;
    if (c.isASN1HEX(b) === false) throw new Error("not ASN.1 hex string");
    if (c.getTLVbyListEx(b, 0, [
        0,
        0
    ]) !== "06092a864886f70d010101") throw new Error("not PKCS8 RSA public key");
    var a = c.getTLVbyListEx(b, 0, [
        1,
        0
    ]);
    this.readPKCS5PubKeyHex(a);
};
$b1badb002678e3c8$var$RSAKey.prototype.readCertPubKeyHex = function(b, d) {
    var a, c;
    a = new $b1badb002678e3c8$var$X509();
    a.readCertHex(b);
    c = a.getPublicKeyHex();
    this.readPKCS8PubKeyHex(c);
};
var $b1badb002678e3c8$var$_RE_HEXDECONLY = new RegExp("[^0-9a-f]", "gi");
function $b1badb002678e3c8$var$_rsasign_getHexPaddedDigestInfoForString(d, e, a) {
    var b = function(f) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashString(f, a);
    };
    var c = b(d);
    return $b1badb002678e3c8$var$KJUR.crypto.Util.getPaddedDigestInfoHex(c, a, e);
}
function $b1badb002678e3c8$var$_zeroPaddingOfSignature(e, d) {
    var c = "";
    var a = d / 4 - e.length;
    for(var b = 0; b < a; b++)c = c + "0";
    return c + e;
}
$b1badb002678e3c8$var$RSAKey.prototype.sign = function(d, a) {
    var b = function(e) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashString(e, a);
    };
    var c = b(d);
    return this.signWithMessageHash(c, a);
};
$b1badb002678e3c8$var$RSAKey.prototype.signWithMessageHash = function(e, c) {
    var f = $b1badb002678e3c8$var$KJUR.crypto.Util.getPaddedDigestInfoHex(e, c, this.n.bitLength());
    var b = $b1badb002678e3c8$var$parseBigInt(f, 16);
    var d = this.doPrivate(b);
    var a = d.toString(16);
    return $b1badb002678e3c8$var$_zeroPaddingOfSignature(a, this.n.bitLength());
};
function $b1badb002678e3c8$var$pss_mgf1_str(c, a, e) {
    var b = "", d = 0;
    while(b.length < a){
        b += $b1badb002678e3c8$var$hextorstr(e($b1badb002678e3c8$var$rstrtohex(c + String.fromCharCode.apply(String, [
            (d & 4278190080) >> 24,
            (d & 16711680) >> 16,
            (d & 65280) >> 8,
            d & 255
        ]))));
        d += 1;
    }
    return b;
}
$b1badb002678e3c8$var$RSAKey.prototype.signPSS = function(e, a, d) {
    var c = function(f) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(f, a);
    };
    var b = c($b1badb002678e3c8$var$rstrtohex(e));
    if (d === undefined) d = -1;
    return this.signWithMessageHashPSS(b, a, d);
};
$b1badb002678e3c8$var$RSAKey.prototype.signWithMessageHashPSS = function(l, a, k) {
    var b = $b1badb002678e3c8$var$hextorstr(l);
    var g = b.length;
    var m = this.n.bitLength() - 1;
    var c = Math.ceil(m / 8);
    var d;
    var o = function(i) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(i, a);
    };
    if (k === -1 || k === undefined) k = g;
    else if (k === -2) k = c - g - 2;
    else {
        if (k < -2) throw new Error("invalid salt length");
    }
    if (c < g + k + 2) throw new Error("data too long");
    var f = "";
    if (k > 0) {
        f = new Array(k);
        new $b1badb002678e3c8$var$SecureRandom().nextBytes(f);
        f = String.fromCharCode.apply(String, f);
    }
    var n = $b1badb002678e3c8$var$hextorstr(o($b1badb002678e3c8$var$rstrtohex("\x00\x00\x00\x00\x00\x00\x00\x00" + b + f)));
    var j = [];
    for(d = 0; d < c - k - g - 2; d += 1)j[d] = 0;
    var e = String.fromCharCode.apply(String, j) + "\x01" + f;
    var h = $b1badb002678e3c8$var$pss_mgf1_str(n, e.length, o);
    var q = [];
    for(d = 0; d < e.length; d += 1)q[d] = e.charCodeAt(d) ^ h.charCodeAt(d);
    var p = 65280 >> 8 * c - m & 255;
    q[0] &= ~p;
    for(d = 0; d < g; d++)q.push(n.charCodeAt(d));
    q.push(188);
    return $b1badb002678e3c8$var$_zeroPaddingOfSignature(this.doPrivate(new $b1badb002678e3c8$var$BigInteger(q)).toString(16), this.n.bitLength());
};
function $b1badb002678e3c8$var$_rsasign_getDecryptSignatureBI(a, d, c) {
    var b = new $b1badb002678e3c8$var$RSAKey();
    b.setPublic(d, c);
    var e = b.doPublic(a);
    return e;
}
function $b1badb002678e3c8$var$_rsasign_getHexDigestInfoFromSig(a, c, b) {
    var e = $b1badb002678e3c8$var$_rsasign_getDecryptSignatureBI(a, c, b);
    var d = e.toString(16).replace(/^1f+00/, "");
    return d;
}
function $b1badb002678e3c8$var$_rsasign_getAlgNameAndHashFromHexDisgestInfo(f) {
    for(var e in $b1badb002678e3c8$var$KJUR.crypto.Util.DIGESTINFOHEAD){
        var d = $b1badb002678e3c8$var$KJUR.crypto.Util.DIGESTINFOHEAD[e];
        var b = d.length;
        if (f.substring(0, b) == d) {
            var c = [
                e,
                f.substring(b)
            ];
            return c;
        }
    }
    return [];
}
$b1badb002678e3c8$var$RSAKey.prototype.verify = function(f, l) {
    l = l.toLowerCase();
    if (l.match(/^[0-9a-f]+$/) == null) return false;
    var b = $b1badb002678e3c8$var$parseBigInt(l, 16);
    var k = this.n.bitLength();
    if (b.bitLength() > k) return false;
    var j = this.doPublic(b);
    var i = j.toString(16);
    if (i.length + 3 != k / 4) return false;
    var e = i.replace(/^1f+00/, "");
    var g = $b1badb002678e3c8$var$_rsasign_getAlgNameAndHashFromHexDisgestInfo(e);
    if (g.length == 0) return false;
    var d = g[0];
    var h = g[1];
    var a = function(m) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashString(m, d);
    };
    var c = a(f);
    return h == c;
};
$b1badb002678e3c8$var$RSAKey.prototype.verifyWithMessageHash = function(e, a) {
    if (a.length != Math.ceil(this.n.bitLength() / 4)) return false;
    var b = $b1badb002678e3c8$var$parseBigInt(a, 16);
    if (b.bitLength() > this.n.bitLength()) return 0;
    var h = this.doPublic(b);
    var g = h.toString(16).replace(/^1f+00/, "");
    var c = $b1badb002678e3c8$var$_rsasign_getAlgNameAndHashFromHexDisgestInfo(g);
    if (c.length == 0) return false;
    var d = c[0];
    var f = c[1];
    return f == e;
};
$b1badb002678e3c8$var$RSAKey.prototype.verifyPSS = function(c, b, a, f) {
    var e = function(g) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(g, a);
    };
    var d = e($b1badb002678e3c8$var$rstrtohex(c));
    if (f === undefined) f = -1;
    return this.verifyWithMessageHashPSS(d, b, a, f);
};
$b1badb002678e3c8$var$RSAKey.prototype.verifyWithMessageHashPSS = function(f, s, l, c) {
    if (s.length != Math.ceil(this.n.bitLength() / 4)) return false;
    var k = new $b1badb002678e3c8$var$BigInteger(s, 16);
    var r = function(i) {
        return $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(i, l);
    };
    var j = $b1badb002678e3c8$var$hextorstr(f);
    var h = j.length;
    var g = this.n.bitLength() - 1;
    var m = Math.ceil(g / 8);
    var q;
    if (c === -1 || c === undefined) c = h;
    else if (c === -2) c = m - h - 2;
    else {
        if (c < -2) throw new Error("invalid salt length");
    }
    if (m < h + c + 2) throw new Error("data too long");
    var a = this.doPublic(k).toByteArray();
    for(q = 0; q < a.length; q += 1)a[q] &= 255;
    while(a.length < m)a.unshift(0);
    if (a[m - 1] !== 188) throw new Error("encoded message does not end in 0xbc");
    a = String.fromCharCode.apply(String, a);
    var d = a.substr(0, m - h - 1);
    var e = a.substr(d.length, h);
    var p = 65280 >> 8 * m - g & 255;
    if ((d.charCodeAt(0) & p) !== 0) throw new Error("bits beyond keysize not zero");
    var n = $b1badb002678e3c8$var$pss_mgf1_str(e, d.length, r);
    var o = [];
    for(q = 0; q < d.length; q += 1)o[q] = d.charCodeAt(q) ^ n.charCodeAt(q);
    o[0] &= ~p;
    var b = m - h - c - 2;
    for(q = 0; q < b; q += 1){
        if (o[q] !== 0) throw new Error("leftmost octets not zero");
    }
    if (o[b] !== 1) throw new Error("0x01 marker not found");
    return e === $b1badb002678e3c8$var$hextorstr(r($b1badb002678e3c8$var$rstrtohex("\x00\x00\x00\x00\x00\x00\x00\x00" + j + String.fromCharCode.apply(String, o.slice(-c)))));
};
$b1badb002678e3c8$var$RSAKey.SALT_LEN_HLEN = -1;
$b1badb002678e3c8$var$RSAKey.SALT_LEN_MAX = -2;
$b1badb002678e3c8$var$RSAKey.SALT_LEN_RECOVER = -2;
function $b1badb002678e3c8$var$X509(v) {
    var o = $b1badb002678e3c8$var$ASN1HEX, s = o.getChildIdx, k = o.getV, y = o.dump, j = o.parse, b = o.getTLV, c = o.getVbyList, p = o.getVbyListEx, a = o.getTLVbyList, q = o.getTLVbyListEx, l = o.getIdxbyList, f = o.getIdxbyListEx, n = o.getVidx, x = o.getInt, u = o.oidname, r = o.hextooidstr, d = $b1badb002678e3c8$var$X509, w = $b1badb002678e3c8$var$pemtohex, g, m = Error;
    try {
        g = $b1badb002678e3c8$var$KJUR.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
    } catch (t) {}
    this.HEX2STAG = {
        "0c": "utf8",
        "13": "prn",
        "16": "ia5",
        "1a": "vis",
        "1e": "bmp"
    };
    this.hex = null;
    this.version = 0;
    this.foffset = 0;
    this.aExtInfo = null;
    this.getVersion = function() {
        if (this.hex === null || this.version !== 0) return this.version;
        var A = a(this.hex, 0, [
            0,
            0
        ]);
        if (A.substr(0, 2) == "a0") {
            var B = a(A, 0, [
                0
            ]);
            var z = x(B, 0);
            if (z < 0 || 2 < z) throw new Error("malformed version field");
            this.version = z + 1;
            return this.version;
        } else {
            this.version = 1;
            this.foffset = -1;
            return 1;
        }
    };
    this.getSerialNumberHex = function() {
        return p(this.hex, 0, [
            0,
            0
        ], "02");
    };
    this.getSignatureAlgorithmField = function() {
        var z = q(this.hex, 0, [
            0,
            1
        ]);
        return this.getAlgorithmIdentifierName(z);
    };
    this.getAlgorithmIdentifierName = function(z) {
        for(var A in g){
            if (z === g[A]) return A;
        }
        return u(p(z, 0, [
            0
        ], "06"));
    };
    this.getIssuer = function(A, z) {
        return this.getX500Name(this.getIssuerHex(), A, z);
    };
    this.getIssuerHex = function() {
        return a(this.hex, 0, [
            0,
            3 + this.foffset
        ], "30");
    };
    this.getIssuerString = function() {
        var z = this.getIssuer();
        return z.str;
    };
    this.getSubject = function(A, z) {
        return this.getX500Name(this.getSubjectHex(), A, z);
    };
    this.getSubjectHex = function() {
        return a(this.hex, 0, [
            0,
            5 + this.foffset
        ], "30");
    };
    this.getSubjectString = function() {
        var z = this.getSubject();
        return z.str;
    };
    this.getNotBefore = function() {
        var z = c(this.hex, 0, [
            0,
            4 + this.foffset,
            0
        ]);
        z = z.replace(/(..)/g, "%$1");
        z = decodeURIComponent(z);
        return z;
    };
    this.getNotAfter = function() {
        var z = c(this.hex, 0, [
            0,
            4 + this.foffset,
            1
        ]);
        z = z.replace(/(..)/g, "%$1");
        z = decodeURIComponent(z);
        return z;
    };
    this.getPublicKeyHex = function() {
        return this.getSPKI();
    };
    this.getSPKI = function() {
        return a(this.hex, 0, [
            0,
            6 + this.foffset
        ], "30");
    };
    this.getSPKIValue = function() {
        var z = this.getSPKI();
        if (z == null) return null;
        return c(z, 0, [
            1
        ], "03", true);
    };
    this.getPublicKeyIdx = function() {
        return l(this.hex, 0, [
            0,
            6 + this.foffset
        ], "30");
    };
    this.getPublicKeyContentIdx = function() {
        var z = this.getPublicKeyIdx();
        return l(this.hex, z, [
            1,
            0
        ], "30");
    };
    this.getPublicKey = function() {
        return $b1badb002678e3c8$var$KEYUTIL.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
    };
    this.getSignatureAlgorithmName = function() {
        var z = a(this.hex, 0, [
            1
        ], "30");
        return this.getAlgorithmIdentifierName(z);
    };
    this.getSignatureValueHex = function() {
        return c(this.hex, 0, [
            2
        ], "03", true);
    };
    this.verifySignature = function(B) {
        var C = this.getSignatureAlgorithmField();
        var z = this.getSignatureValueHex();
        var A = a(this.hex, 0, [
            0
        ], "30");
        var D = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: C
        });
        D.init(B);
        D.updateHex(A);
        return D.verify(z);
    };
    this.parseExt = function(I) {
        var B, z, D;
        if (I === undefined) {
            D = this.hex;
            if (this.version !== 3) return -1;
            B = l(D, 0, [
                0,
                7,
                0
            ], "30");
            z = s(D, B);
        } else {
            D = $b1badb002678e3c8$var$pemtohex(I);
            var E = l(D, 0, [
                0,
                3,
                0,
                0
            ], "06");
            if (k(D, E) != "2a864886f70d01090e") {
                this.aExtInfo = new Array();
                return;
            }
            B = l(D, 0, [
                0,
                3,
                0,
                1,
                0
            ], "30");
            z = s(D, B);
            this.hex = D;
        }
        this.aExtInfo = new Array();
        for(var C = 0; C < z.length; C++){
            var G = {};
            G.critical = false;
            var F = s(D, z[C]);
            var A = 0;
            if (F.length === 3) {
                G.critical = true;
                A = 1;
            }
            G.oid = o.hextooidstr(c(D, z[C], [
                0
            ], "06"));
            var H = l(D, z[C], [
                1 + A
            ]);
            G.vidx = n(D, H);
            this.aExtInfo.push(G);
        }
    };
    this.getExtInfo = function(B) {
        var z = this.aExtInfo;
        var C = B;
        if (!B.match(/^[0-9.]+$/)) C = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.name2oid(B);
        if (C === "") return undefined;
        for(var A = 0; A < z.length; A++){
            if (z[A].oid === C) return z[A];
        }
        return undefined;
    };
    this.getCriticalExtV = function(C, z, B) {
        if (z != undefined) return [
            z,
            B
        ];
        var A = this.getExtInfo(C);
        if (A == undefined) return [
            null,
            null
        ];
        return [
            b(this.hex, A.vidx),
            A.critical
        ];
    };
    this.getExtBasicConstraints = function(A, E) {
        if (A === undefined && E === undefined) {
            var C = this.getExtInfo("basicConstraints");
            if (C === undefined) return undefined;
            A = b(this.hex, C.vidx);
            E = C.critical;
        }
        var z = {
            extname: "basicConstraints"
        };
        if (E) z.critical = true;
        if (A === "3000") return z;
        if (A === "30030101ff") {
            z.cA = true;
            return z;
        }
        if (A.substr(0, 12) === "30060101ff02") {
            var D = k(A, 10);
            var B = parseInt(D, 16);
            z.cA = true;
            z.pathLen = B;
            return z;
        }
        throw new Error("hExtV parse error: " + A);
    };
    this.getExtNameConstraints = function(I, G) {
        var A = this.getCriticalExtV("nameConstraints", I, G);
        I = A[0];
        G = A[1];
        if (I == null) return undefined;
        var K = {
            extname: "nameConstraints"
        };
        if (G) K.critical = true;
        var F = s(I, 0);
        for(var D = 0; D < F.length; D++){
            var E = [];
            var B = s(I, F[D]);
            for(var C = 0; C < B.length; C++){
                var H = b(I, B[C]);
                var z = this.getGeneralSubtree(H);
                E.push(z);
            }
            var J = I.substr(F[D], 2);
            if (J == "a0") K.permit = E;
            else if (J == "a1") K.exclude = E;
        }
        return K;
    };
    this.getGeneralSubtree = function(F) {
        var D = s(F, 0);
        var C = D.length;
        if (C < 1 || 2 < C) throw new Error("wrong num elements");
        var B = this.getGeneralName(b(F, D[0]));
        for(var E = 1; E < C; E++){
            var A = F.substr(D[E], 2);
            var z = k(F, D[E]);
            var G = parseInt(z, 16);
            if (A == "80") B.min = G;
            if (A == "81") B.max = G;
        }
        return B;
    };
    this.getExtKeyUsage = function(A, C) {
        var B = this.getCriticalExtV("keyUsage", A, C);
        A = B[0];
        C = B[1];
        if (A == null) return undefined;
        var z = {
            extname: "keyUsage"
        };
        if (C) z.critical = true;
        z.names = this.getExtKeyUsageString(A).split(",");
        return z;
    };
    this.getExtKeyUsageBin = function(A) {
        if (A === undefined) {
            var B = this.getExtInfo("keyUsage");
            if (B === undefined) return "";
            A = b(this.hex, B.vidx);
        }
        if (A.length != 8 && A.length != 10) throw new Error("malformed key usage value: " + A);
        var z = "000000000000000" + parseInt(A.substr(6), 16).toString(2);
        if (A.length == 8) z = z.slice(-8);
        if (A.length == 10) z = z.slice(-16);
        z = z.replace(/0+$/, "");
        if (z == "") z = "0";
        return z;
    };
    this.getExtKeyUsageString = function(B) {
        var C = this.getExtKeyUsageBin(B);
        var z = new Array();
        for(var A = 0; A < C.length; A++)if (C.substr(A, 1) == "1") z.push($b1badb002678e3c8$var$X509.KEYUSAGE_NAME[A]);
        return z.join(",");
    };
    this.getExtSubjectKeyIdentifier = function(B, D) {
        if (B === undefined && D === undefined) {
            var C = this.getExtInfo("subjectKeyIdentifier");
            if (C === undefined) return undefined;
            B = b(this.hex, C.vidx);
            D = C.critical;
        }
        var z = {
            extname: "subjectKeyIdentifier"
        };
        if (D) z.critical = true;
        var A = k(B, 0);
        z.kid = {
            hex: A
        };
        return z;
    };
    this.getExtAuthorityKeyIdentifier = function(F, D) {
        if (F === undefined && D === undefined) {
            var z = this.getExtInfo("authorityKeyIdentifier");
            if (z === undefined) return undefined;
            F = b(this.hex, z.vidx);
            D = z.critical;
        }
        var G = {
            extname: "authorityKeyIdentifier"
        };
        if (D) G.critical = true;
        var E = s(F, 0);
        for(var A = 0; A < E.length; A++){
            var H = F.substr(E[A], 2);
            if (H === "80") G.kid = {
                hex: k(F, E[A])
            };
            if (H === "a1") {
                var C = b(F, E[A]);
                var B = this.getGeneralNames(C);
                G.issuer = B[0]["dn"];
            }
            if (H === "82") G.sn = {
                hex: k(F, E[A])
            };
        }
        return G;
    };
    this.getExtExtKeyUsage = function(C, E) {
        if (C === undefined && E === undefined) {
            var D = this.getExtInfo("extKeyUsage");
            if (D === undefined) return undefined;
            C = b(this.hex, D.vidx);
            E = D.critical;
        }
        var z = {
            extname: "extKeyUsage",
            array: []
        };
        if (E) z.critical = true;
        var A = s(C, 0);
        for(var B = 0; B < A.length; B++)z.array.push(u(k(C, A[B])));
        return z;
    };
    this.getExtExtKeyUsageName = function() {
        var D = this.getExtInfo("extKeyUsage");
        if (D === undefined) return D;
        var z = new Array();
        var C = b(this.hex, D.vidx);
        if (C === "") return z;
        var A = s(C, 0);
        for(var B = 0; B < A.length; B++)z.push(u(k(C, A[B])));
        return z;
    };
    this.getExtSubjectAltName = function(A, C) {
        if (A === undefined && C === undefined) {
            var B = this.getExtInfo("subjectAltName");
            if (B === undefined) return undefined;
            A = b(this.hex, B.vidx);
            C = B.critical;
        }
        var z = {
            extname: "subjectAltName",
            array: []
        };
        if (C) z.critical = true;
        z.array = this.getGeneralNames(A);
        return z;
    };
    this.getExtIssuerAltName = function(A, C) {
        if (A === undefined && C === undefined) {
            var B = this.getExtInfo("issuerAltName");
            if (B === undefined) return undefined;
            A = b(this.hex, B.vidx);
            C = B.critical;
        }
        var z = {
            extname: "issuerAltName",
            array: []
        };
        if (C) z.critical = true;
        z.array = this.getGeneralNames(A);
        return z;
    };
    this.getGeneralNames = function(D) {
        var B = s(D, 0);
        var z = [];
        for(var C = 0; C < B.length; C++){
            var A = this.getGeneralName(b(D, B[C]));
            if (A !== undefined) z.push(A);
        }
        return z;
    };
    this.getGeneralName = function(A) {
        var z = A.substr(0, 2);
        var C = k(A, 0);
        var B = $b1badb002678e3c8$var$hextorstr(C);
        if (z == "81") return {
            rfc822: B
        };
        if (z == "82") return {
            dns: B
        };
        if (z == "86") return {
            uri: B
        };
        if (z == "87") return {
            ip: $b1badb002678e3c8$var$hextoip(C)
        };
        if (z == "a4") return {
            dn: this.getX500Name(C)
        };
        if (z == "a0") return {
            other: this.getOtherName(A)
        };
        return undefined;
    };
    this.getExtSubjectAltName2 = function() {
        var D, G, F;
        var E = this.getExtInfo("subjectAltName");
        if (E === undefined) return E;
        var z = new Array();
        var C = b(this.hex, E.vidx);
        var A = s(C, 0);
        for(var B = 0; B < A.length; B++){
            F = C.substr(A[B], 2);
            D = k(C, A[B]);
            if (F === "81") {
                G = $b1badb002678e3c8$var$hextoutf8(D);
                z.push([
                    "MAIL",
                    G
                ]);
            }
            if (F === "82") {
                G = $b1badb002678e3c8$var$hextoutf8(D);
                z.push([
                    "DNS",
                    G
                ]);
            }
            if (F === "84") {
                G = $b1badb002678e3c8$var$X509.hex2dn(D, 0);
                z.push([
                    "DN",
                    G
                ]);
            }
            if (F === "86") {
                G = $b1badb002678e3c8$var$hextoutf8(D);
                z.push([
                    "URI",
                    G
                ]);
            }
            if (F === "87") {
                G = $b1badb002678e3c8$var$hextoip(D);
                z.push([
                    "IP",
                    G
                ]);
            }
        }
        return z;
    };
    this.getExtCRLDistributionPoints = function(D, F) {
        if (D === undefined && F === undefined) {
            var E = this.getExtInfo("cRLDistributionPoints");
            if (E === undefined) return undefined;
            D = b(this.hex, E.vidx);
            F = E.critical;
        }
        var A = {
            extname: "cRLDistributionPoints",
            array: []
        };
        if (F) A.critical = true;
        var B = s(D, 0);
        for(var C = 0; C < B.length; C++){
            var z = b(D, B[C]);
            A.array.push(this.getDistributionPoint(z));
        }
        return A;
    };
    this.getDistributionPoint = function(E) {
        var B = {};
        var C = s(E, 0);
        for(var D = 0; D < C.length; D++){
            var A = E.substr(C[D], 2);
            var z = b(E, C[D]);
            if (A == "a0") B.dpname = this.getDistributionPointName(z);
        }
        return B;
    };
    this.getDistributionPointName = function(E) {
        var B = {};
        var C = s(E, 0);
        for(var D = 0; D < C.length; D++){
            var A = E.substr(C[D], 2);
            var z = b(E, C[D]);
            if (A == "a0") B.full = this.getGeneralNames(z);
        }
        return B;
    };
    this.getExtCRLDistributionPointsURI = function() {
        var D = this.getExtCRLDistributionPoints();
        if (D == undefined) return D;
        var A = D.array;
        var z = [];
        for(var C = 0; C < A.length; C++)try {
            if (A[C].dpname.full[0].uri != undefined) z.push(A[C].dpname.full[0].uri);
        } catch (B) {}
        return z;
    };
    this.getExtAIAInfo = function() {
        var D = this.getExtInfo("authorityInfoAccess");
        if (D === undefined) return D;
        var z = {
            ocsp: [],
            caissuer: []
        };
        var A = s(this.hex, D.vidx);
        for(var B = 0; B < A.length; B++){
            var E = c(this.hex, A[B], [
                0
            ], "06");
            var C = c(this.hex, A[B], [
                1
            ], "86");
            if (E === "2b06010505073001") z.ocsp.push($b1badb002678e3c8$var$hextoutf8(C));
            if (E === "2b06010505073002") z.caissuer.push($b1badb002678e3c8$var$hextoutf8(C));
        }
        return z;
    };
    this.getExtAuthorityInfoAccess = function(G, E) {
        if (G === undefined && E === undefined) {
            var z = this.getExtInfo("authorityInfoAccess");
            if (z === undefined) return undefined;
            G = b(this.hex, z.vidx);
            E = z.critical;
        }
        var H = {
            extname: "authorityInfoAccess",
            array: []
        };
        if (E) H.critical = true;
        var F = s(G, 0);
        for(var A = 0; A < F.length; A++){
            var D = p(G, F[A], [
                0
            ], "06");
            var B = c(G, F[A], [
                1
            ], "86");
            var C = $b1badb002678e3c8$var$hextoutf8(B);
            if (D == "2b06010505073001") H.array.push({
                ocsp: C
            });
            else {
                if (D == "2b06010505073002") H.array.push({
                    caissuer: C
                });
                else throw new Error("unknown method: " + D);
            }
        }
        return H;
    };
    this.getExtCertificatePolicies = function(D, G) {
        if (D === undefined && G === undefined) {
            var F = this.getExtInfo("certificatePolicies");
            if (F === undefined) return undefined;
            D = b(this.hex, F.vidx);
            G = F.critical;
        }
        var z = {
            extname: "certificatePolicies",
            array: []
        };
        if (G) z.critical = true;
        var A = s(D, 0);
        for(var B = 0; B < A.length; B++){
            var E = b(D, A[B]);
            var C = this.getPolicyInformation(E);
            z.array.push(C);
        }
        return z;
    };
    this.getPolicyInformation = function(D) {
        var z = {};
        var F = c(D, 0, [
            0
        ], "06");
        z.policyoid = u(F);
        var G = f(D, 0, [
            1
        ], "30");
        if (G != -1) {
            z.array = [];
            var A = s(D, G);
            for(var B = 0; B < A.length; B++){
                var E = b(D, A[B]);
                var C = this.getPolicyQualifierInfo(E);
                z.array.push(C);
            }
        }
        return z;
    };
    this.getOtherName = function(B) {
        var z = {};
        var A = s(B, 0);
        var D = c(B, A[0], [], "06");
        var C = c(B, A[1], []);
        z.oid = u(D);
        z.value = j(C);
        return z;
    };
    this.getPolicyQualifierInfo = function(A) {
        var z = {};
        var B = c(A, 0, [
            0
        ], "06");
        if (B === "2b06010505070201") {
            var D = p(A, 0, [
                1
            ], "16");
            z.cps = $b1badb002678e3c8$var$hextorstr(D);
        } else if (B === "2b06010505070202") {
            var C = a(A, 0, [
                1
            ], "30");
            z.unotice = this.getUserNotice(C);
        }
        return z;
    };
    this.getUserNotice = function(D) {
        var A = {};
        var B = s(D, 0);
        for(var C = 0; C < B.length; C++){
            var z = b(D, B[C]);
            if (z.substr(0, 2) != "30") A.exptext = this.getDisplayText(z);
        }
        return A;
    };
    this.getDisplayText = function(A) {
        var B = {
            "0c": "utf8",
            "16": "ia5",
            "1a": "vis",
            "1e": "bmp"
        };
        var z = {};
        z.type = B[A.substr(0, 2)];
        z.str = $b1badb002678e3c8$var$hextorstr(k(A, 0));
        return z;
    };
    this.getExtPolicyMappings = function(G, E) {
        var z = this.getCriticalExtV("policyMappings", G, E);
        G = z[0];
        E = z[1];
        if (G == null) return undefined;
        var I = {
            extname: "policyMappings"
        };
        if (E) I.critical = true;
        try {
            var A = j(G);
            var B = A.seq;
            var F = [];
            for(var C = 0; C < B.length; C++){
                var H = B[C].seq;
                F.push([
                    H[0].oid,
                    H[1].oid
                ]);
            }
            I.array = F;
        } catch (D) {
            throw new m("malformed policyMappings");
        }
        return I;
    };
    this.getExtPolicyConstraints = function(G, D) {
        var z = this.getCriticalExtV("policyConstraints", G, D);
        G = z[0];
        D = z[1];
        if (G == null) return undefined;
        var H = {
            extname: "policyConstraints"
        };
        if (D) H.critical = true;
        var A = j(G);
        try {
            var F = A.seq;
            for(var B = 0; B < F.length; B++){
                var E = F[B].tag;
                if (E.explicit != false) continue;
                if (E.tag == "80") H.reqexp = parseInt(E.hex, 16);
                if (E.tag == "81") H.inhibit = parseInt(E.hex, 16);
            }
        } catch (C) {
            return new m("malformed policyConstraints value");
        }
        return H;
    };
    this.getExtInhibitAnyPolicy = function(A, D) {
        var C = this.getCriticalExtV("inhibitAnyPolicy", A, D);
        A = C[0];
        D = C[1];
        if (A == null) return undefined;
        var z = {
            extname: "inhibitAnyPolicy"
        };
        if (D) z.critical = true;
        var B = x(A, 0);
        if (B == -1) return new m("wrong value");
        z.skip = B;
        return z;
    };
    this.getExtCRLNumber = function(A, B) {
        var z = {
            extname: "cRLNumber"
        };
        if (B) z.critical = true;
        if (A.substr(0, 2) == "02") {
            z.num = {
                hex: k(A, 0)
            };
            return z;
        }
        throw new m("hExtV parse error: " + A);
    };
    this.getExtCRLReason = function(A, B) {
        var z = {
            extname: "cRLReason"
        };
        if (B) z.critical = true;
        if (A.substr(0, 2) == "0a") {
            z.code = parseInt(k(A, 0), 16);
            return z;
        }
        throw new Error("hExtV parse error: " + A);
    };
    this.getExtOcspNonce = function(A, C) {
        var z = {
            extname: "ocspNonce"
        };
        if (C) z.critical = true;
        var B = k(A, 0);
        z.hex = B;
        return z;
    };
    this.getExtOcspNoCheck = function(A, B) {
        var z = {
            extname: "ocspNoCheck"
        };
        if (B) z.critical = true;
        return z;
    };
    this.getExtAdobeTimeStamp = function(C, F) {
        if (C === undefined && F === undefined) {
            var E = this.getExtInfo("adobeTimeStamp");
            if (E === undefined) return undefined;
            C = b(this.hex, E.vidx);
            F = E.critical;
        }
        var z = {
            extname: "adobeTimeStamp"
        };
        if (F) z.critical = true;
        var B = s(C, 0);
        if (B.length > 1) {
            var G = b(C, B[1]);
            var A = this.getGeneralName(G);
            if (A.uri != undefined) z.uri = A.uri;
        }
        if (B.length > 2) {
            var D = b(C, B[2]);
            if (D == "0101ff") z.reqauth = true;
            if (D == "010100") z.reqauth = false;
        }
        return z;
    };
    var e = function(E) {
        var z = {};
        try {
            var B = E.seq[0].oid;
            var D = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.name2oid(B);
            z.type = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2atype(D);
            var A = E.seq[1];
            if (A.utf8str != undefined) {
                z.ds = "utf8";
                z.value = A.utf8str.str;
            } else if (A.numstr != undefined) {
                z.ds = "num";
                z.value = A.numstr.str;
            } else {
                if (A.telstr != undefined) {
                    z.ds = "tel";
                    z.value = A.telstr.str;
                } else if (A.prnstr != undefined) {
                    z.ds = "prn";
                    z.value = A.prnstr.str;
                } else {
                    if (A.ia5str != undefined) {
                        z.ds = "ia5";
                        z.value = A.ia5str.str;
                    } else if (A.visstr != undefined) {
                        z.ds = "vis";
                        z.value = A.visstr.str;
                    } else {
                        if (A.bmpstr != undefined) {
                            z.ds = "bmp";
                            z.value = A.bmpstr.str;
                        } else throw "error";
                    }
                }
            }
            return z;
        } catch (C) {
            throw new Erorr("improper ASN.1 parsed AttrTypeAndValue");
        }
    };
    var i = function(A) {
        try {
            return A.set.map(function(B) {
                return e(B);
            });
        } catch (z) {
            throw new Error("improper ASN.1 parsed RDN: " + z);
        }
    };
    var h = function(A) {
        try {
            return A.seq.map(function(B) {
                return i(B);
            });
        } catch (z) {
            throw new Error("improper ASN.1 parsed X500Name: " + z);
        }
    };
    this.getX500NameRule = function(z) {
        var G = true;
        var K = true;
        var J = false;
        var A = "";
        var D = "";
        var M = null;
        var H = [];
        for(var C = 0; C < z.length; C++){
            var E = z[C];
            for(var B = 0; B < E.length; B++)H.push(E[B]);
        }
        for(var C = 0; C < H.length; C++){
            var L = H[C];
            var N = L.ds;
            var I = L.value;
            var F = L.type;
            A += ":" + N;
            if (N != "prn" && N != "utf8" && N != "ia5") return "mixed";
            if (N == "ia5") {
                if (F != "CN") return "mixed";
                else {
                    if (!$b1badb002678e3c8$var$KJUR.lang.String.isMail(I)) return "mixed";
                    else continue;
                }
            }
            if (F == "C") {
                if (N == "prn") continue;
                else return "mixed";
            }
            D += ":" + N;
            if (M == null) M = N;
            else {
                if (M !== N) return "mixed";
            }
        }
        if (M == null) return "prn";
        else return M;
    };
    this.getAttrTypeAndValue = function(z) {
        var A = j(z);
        return e(A);
    };
    this.getRDN = function(z) {
        var A = j(z);
        return i(A);
    };
    this.getX500NameArray = function(z) {
        var A = j(z);
        return h(A);
    };
    this.getX500Name = function(C, E, D) {
        var A = this.getX500NameArray(C);
        var B = this.dnarraytostr(A);
        var z = {
            str: B
        };
        z.array = A;
        if (D == true) z.hex = C;
        if (E == true) z.canon = this.c14nRDNArray(A);
        return z;
    };
    this.readCertPEM = function(z) {
        this.readCertHex(w(z));
    };
    this.readCertHex = function(z) {
        this.hex = z;
        this.getVersion();
        try {
            l(this.hex, 0, [
                0,
                7
            ], "a3");
            this.parseExt();
        } catch (A) {}
    };
    this.getParam = function(A) {
        var z = {};
        if (A == undefined) A = {};
        z.version = this.getVersion();
        z.serial = {
            hex: this.getSerialNumberHex()
        };
        z.sigalg = this.getSignatureAlgorithmField();
        z.issuer = this.getIssuer(A.dncanon, A.dnhex);
        z.notbefore = this.getNotBefore();
        z.notafter = this.getNotAfter();
        z.subject = this.getSubject(A.dncanon, A.dnhex);
        z.sbjpubkey = $b1badb002678e3c8$var$hextopem(this.getPublicKeyHex(), "PUBLIC KEY");
        if (this.aExtInfo != undefined && this.aExtInfo.length > 0) z.ext = this.getExtParamArray();
        z.sighex = this.getSignatureValueHex();
        if (A.tbshex == true) z.tbshex = a(this.hex, 0, [
            0
        ]);
        if (A.nodnarray == true) {
            delete z.issuer.array;
            delete z.subject.array;
        }
        return z;
    };
    this.getExtParamArray = function(A) {
        if (A == undefined) {
            var C = f(this.hex, 0, [
                0,
                "[3]"
            ]);
            if (C != -1) A = q(this.hex, 0, [
                0,
                "[3]",
                0
            ], "30");
        }
        var z = [];
        var B = s(A, 0);
        for(var D = 0; D < B.length; D++){
            var F = b(A, B[D]);
            var E = this.getExtParam(F);
            if (E != null) z.push(E);
        }
        return z;
    };
    this.getExtParam = function(A) {
        var H = {};
        var C = s(A, 0);
        var D = C.length;
        if (D != 2 && D != 3) throw new Error("wrong number elements in Extension: " + D + " " + A);
        var B = r(c(A, 0, [
            0
        ], "06"));
        var F = false;
        if (D == 3 && a(A, 0, [
            1
        ]) == "0101ff") F = true;
        var G = a(A, 0, [
            D - 1,
            0
        ]);
        var E = undefined;
        if (B == "2.5.29.14") E = this.getExtSubjectKeyIdentifier(G, F);
        else {
            if (B == "2.5.29.15") E = this.getExtKeyUsage(G, F);
            else if (B == "2.5.29.17") E = this.getExtSubjectAltName(G, F);
            else {
                if (B == "2.5.29.18") E = this.getExtIssuerAltName(G, F);
                else if (B == "2.5.29.19") E = this.getExtBasicConstraints(G, F);
                else {
                    if (B == "2.5.29.30") E = this.getExtNameConstraints(G, F);
                    else if (B == "2.5.29.31") E = this.getExtCRLDistributionPoints(G, F);
                    else {
                        if (B == "2.5.29.32") E = this.getExtCertificatePolicies(G, F);
                        else if (B == "2.5.29.33") E = this.getExtPolicyMappings(G, F);
                        else {
                            if (B == "2.5.29.35") E = this.getExtAuthorityKeyIdentifier(G, F);
                            else if (B == "2.5.29.36") E = this.getExtPolicyConstraints(G, F);
                            else {
                                if (B == "2.5.29.37") E = this.getExtExtKeyUsage(G, F);
                                else if (B == "2.5.29.54") E = this.getExtInhibitAnyPolicy(G, F);
                                else {
                                    if (B == "1.3.6.1.5.5.7.1.1") E = this.getExtAuthorityInfoAccess(G, F);
                                    else if (B == "2.5.29.20") E = this.getExtCRLNumber(G, F);
                                    else {
                                        if (B == "2.5.29.21") E = this.getExtCRLReason(G, F);
                                        else if (B == "1.3.6.1.5.5.7.48.1.2") E = this.getExtOcspNonce(G, F);
                                        else {
                                            if (B == "1.3.6.1.5.5.7.48.1.5") E = this.getExtOcspNoCheck(G, F);
                                            else if (B == "1.2.840.113583.1.1.9.1") E = this.getExtAdobeTimeStamp(G, F);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (E != undefined) return E;
        var z = {
            extname: B,
            extn: G
        };
        if (F) z.critical = true;
        return z;
    };
    this.findExt = function(A, B) {
        for(var z = 0; z < A.length; z++){
            if (A[z].extname == B) return A[z];
        }
        return null;
    };
    this.updateExtCDPFullURI = function(D, z) {
        var C = this.findExt(D, "cRLDistributionPoints");
        if (C == null) return;
        if (C.array == undefined) return;
        var F = C.array;
        for(var B = 0; B < F.length; B++){
            if (F[B].dpname == undefined) continue;
            if (F[B].dpname.full == undefined) continue;
            var G = F[B].dpname.full;
            for(var A = 0; A < G.length; A++){
                var E = G[B];
                if (E.uri == undefined) continue;
                E.uri = z;
            }
        }
    };
    this.updateExtAIAOCSP = function(D, A) {
        var C = this.findExt(D, "authorityInfoAccess");
        if (C == null) return;
        if (C.array == undefined) return;
        var z = C.array;
        for(var B = 0; B < z.length; B++)if (z[B].ocsp != undefined) z[B].ocsp = A;
    };
    this.updateExtAIACAIssuer = function(D, A) {
        var C = this.findExt(D, "authorityInfoAccess");
        if (C == null) return;
        if (C.array == undefined) return;
        var z = C.array;
        for(var B = 0; B < z.length; B++)if (z[B].caissuer != undefined) z[B].caissuer = A;
    };
    this.dnarraytostr = function(B) {
        function z(C) {
            return C.map(function(D) {
                return A(D).replace(/\+/, "\\+");
            }).join("+");
        }
        function A(C) {
            return C.type + "=" + C.value;
        }
        return "/" + B.map(function(C) {
            return z(C).replace(/\//, "\\/");
        }).join("/");
    };
    this.setCanonicalizedDN = function(A) {
        var C;
        if (A.str != undefined && A.array == undefined) {
            var B = new $b1badb002678e3c8$var$KJUR.asn1.x509.X500Name({
                str: A.str
            });
            var z = B.tohex();
            C = this.getX500NameArray(z);
        } else C = A.array;
        if (A.canon == undefined) A.canon = this.c14nRDNArray(C);
    };
    this.c14nRDNArray = function(G) {
        var A = [];
        for(var C = 0; C < G.length; C++){
            var E = G[C];
            var z = [];
            for(var B = 0; B < E.length; B++){
                var D = E[B];
                var F = D.value;
                F = F.replace(/^\s*/, "");
                F = F.replace(/\s*$/, "");
                F = F.replace(/\s+/g, " ");
                F = F.toLowerCase();
                z.push(D.type.toLowerCase() + "=" + F);
            }
            A.push(z.join("+"));
        }
        return "/" + A.join("/");
    };
    this.getInfo = function() {
        var A = function(W) {
            var ac = "";
            var U = "    ";
            var Y = "\n";
            var Z = W.array;
            for(var X = 0; X < Z.length; X++){
                var V = Z[X];
                if (V.dn != undefined) ac += U + "dn: " + V.dn.str + Y;
                if (V.ip != undefined) ac += U + "ip: " + V.ip + Y;
                if (V.rfc822 != undefined) ac += U + "rfc822: " + V.rfc822 + Y;
                if (V.dns != undefined) ac += U + "dns: " + V.dns + Y;
                if (V.uri != undefined) ac += U + "uri: " + V.uri + Y;
                if (V.other != undefined) {
                    var ab = V.other.oid;
                    var aa = JSON.stringify(V.other.value).replace(/\"/g, "");
                    ac += U + "other: " + ab + "=" + aa + Y;
                }
            }
            ac = ac.replace(/\n$/, "");
            return ac;
        };
        var H = function(aa) {
            var Y = "";
            var U = aa.array;
            for(var X = 0; X < U.length; X++){
                var Z = U[X];
                Y += "    policy oid: " + Z.policyoid + "\n";
                if (Z.array === undefined) continue;
                for(var W = 0; W < Z.array.length; W++){
                    var V = Z.array[W];
                    if (V.cps !== undefined) Y += "    cps: " + V.cps + "\n";
                }
            }
            return Y;
        };
        var K = function(Y) {
            var X = "";
            var U = Y.array;
            for(var W = 0; W < U.length; W++){
                var Z = U[W];
                try {
                    if (Z.dpname.full[0].uri !== undefined) X += "    " + Z.dpname.full[0].uri + "\n";
                } catch (V) {}
                try {
                    if (Z.dname.full[0].dn.hex !== undefined) X += "    " + $b1badb002678e3c8$var$X509.hex2dn(Z.dpname.full[0].dn.hex) + "\n";
                } catch (V) {}
            }
            return X;
        };
        var I = function(Y) {
            var X = "";
            var U = Y.array;
            for(var V = 0; V < U.length; V++){
                var W = U[V];
                if (W.caissuer !== undefined) X += "    caissuer: " + W.caissuer + "\n";
                if (W.ocsp !== undefined) X += "    ocsp: " + W.ocsp + "\n";
            }
            return X;
        };
        var B = $b1badb002678e3c8$var$X509;
        var M, L, T;
        M = "Basic Fields\n";
        M += "  serial number: " + this.getSerialNumberHex() + "\n";
        M += "  signature algorithm: " + this.getSignatureAlgorithmField() + "\n";
        M += "  issuer: " + this.getIssuerString() + "\n";
        M += "  notBefore: " + this.getNotBefore() + "\n";
        M += "  notAfter: " + this.getNotAfter() + "\n";
        M += "  subject: " + this.getSubjectString() + "\n";
        M += "  subject public key info: \n";
        L = this.getPublicKey();
        M += "    key algorithm: " + L.type + "\n";
        if (L.type === "RSA") {
            M += "    n=" + $b1badb002678e3c8$var$hextoposhex(L.n.toString(16)).substr(0, 16) + "...\n";
            M += "    e=" + $b1badb002678e3c8$var$hextoposhex(L.e.toString(16)) + "\n";
        }
        T = this.aExtInfo;
        if (T !== undefined && T !== null) {
            M += "X509v3 Extensions:\n";
            for(var P = 0; P < T.length; P++){
                var R = T[P];
                var z = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2name(R.oid);
                if (z === "") z = R.oid;
                var O = "";
                if (R.critical === true) O = "CRITICAL";
                M += "  " + z + " " + O + ":\n";
                if (z === "basicConstraints") {
                    var C = this.getExtBasicConstraints();
                    if (C.cA === undefined) M += "    {}\n";
                    else {
                        M += "    cA=true";
                        if (C.pathLen !== undefined) M += ", pathLen=" + C.pathLen;
                        M += "\n";
                    }
                } else if (z == "policyMappings") {
                    var S = this.getExtPolicyMappings().array;
                    var G = S.map(function(U) {
                        var V = U;
                        return V[0] + ":" + V[1];
                    }).join(", ");
                    M += "    " + G + "\n";
                } else {
                    if (z == "policyConstraints") {
                        var N = this.getExtPolicyConstraints();
                        M += "    ";
                        if (N.reqexp != undefined) M += " reqexp=" + N.reqexp;
                        if (N.inhibit != undefined) M += " inhibit=" + N.inhibit;
                        M += "\n";
                    } else if (z == "inhibitAnyPolicy") {
                        var N = this.getExtInhibitAnyPolicy();
                        M += "    skip=" + N.skip + "\n";
                    } else {
                        if (z == "keyUsage") M += "    " + this.getExtKeyUsageString() + "\n";
                        else if (z == "subjectKeyIdentifier") M += "    " + this.getExtSubjectKeyIdentifier().kid.hex + "\n";
                        else {
                            if (z == "authorityKeyIdentifier") {
                                var D = this.getExtAuthorityKeyIdentifier();
                                if (D.kid !== undefined) M += "    kid=" + D.kid.hex + "\n";
                            } else if (z == "extKeyUsage") {
                                var Q = this.getExtExtKeyUsage().array;
                                M += "    " + Q.join(", ") + "\n";
                            } else {
                                if (z == "subjectAltName") {
                                    var E = A(this.getExtSubjectAltName());
                                    M += E + "\n";
                                } else if (z == "cRLDistributionPoints") {
                                    var J = this.getExtCRLDistributionPoints();
                                    M += K(J);
                                } else {
                                    if (z == "authorityInfoAccess") {
                                        var F = this.getExtAuthorityInfoAccess();
                                        M += I(F);
                                    } else if (z == "certificatePolicies") M += H(this.getExtCertificatePolicies());
                                }
                            }
                        }
                    }
                }
            }
        }
        M += "signature algorithm: " + this.getSignatureAlgorithmName() + "\n";
        M += "signature: " + this.getSignatureValueHex().substr(0, 16) + "...\n";
        return M;
    };
    if (typeof v == "string") {
        if (v.indexOf("-----BEGIN") != -1) this.readCertPEM(v);
        else if ($b1badb002678e3c8$var$KJUR.lang.String.isHex(v)) this.readCertHex(v);
    }
}
$b1badb002678e3c8$var$X509.hex2dn = function(e, b) {
    if (b === undefined) b = 0;
    var a = new $b1badb002678e3c8$var$X509();
    var c = $b1badb002678e3c8$var$ASN1HEX.getTLV(e, b);
    var d = a.getX500Name(e);
    return d.str;
};
$b1badb002678e3c8$var$X509.hex2rdn = function(f, b) {
    if (b === undefined) b = 0;
    if (f.substr(b, 2) !== "31") throw new Error("malformed RDN");
    var c = new Array();
    var d = $b1badb002678e3c8$var$ASN1HEX.getChildIdx(f, b);
    for(var e = 0; e < d.length; e++)c.push($b1badb002678e3c8$var$X509.hex2attrTypeValue(f, d[e]));
    c = c.map(function(a) {
        return a.replace("+", "\\+");
    });
    return c.join("+");
};
$b1badb002678e3c8$var$X509.hex2attrTypeValue = function(d, i) {
    var j = $b1badb002678e3c8$var$ASN1HEX;
    var h = j.getV;
    if (i === undefined) i = 0;
    if (d.substr(i, 2) !== "30") throw new Error("malformed attribute type and value");
    var g = j.getChildIdx(d, i);
    if (g.length !== 2 || d.substr(g[0], 2) !== "06") "malformed attribute type and value";
    var b = h(d, g[0]);
    var f = $b1badb002678e3c8$var$KJUR.asn1.ASN1Util.oidHexToInt(b);
    var e = $b1badb002678e3c8$var$KJUR.asn1.x509.OID.oid2atype(f);
    var a = h(d, g[1]);
    var c = $b1badb002678e3c8$var$hextorstr(a);
    return e + "=" + c;
};
$b1badb002678e3c8$var$X509.getPublicKeyFromCertHex = function(b) {
    var a = new $b1badb002678e3c8$var$X509();
    a.readCertHex(b);
    return a.getPublicKey();
};
$b1badb002678e3c8$var$X509.getPublicKeyFromCertPEM = function(b) {
    var a = new $b1badb002678e3c8$var$X509();
    a.readCertPEM(b);
    return a.getPublicKey();
};
$b1badb002678e3c8$var$X509.getPublicKeyInfoPropOfCertPEM = function(c) {
    var e = $b1badb002678e3c8$var$ASN1HEX;
    var g = e.getVbyList;
    var b = {};
    var a, f, d;
    b.algparam = null;
    a = new $b1badb002678e3c8$var$X509();
    a.readCertPEM(c);
    f = a.getPublicKeyHex();
    b.keyhex = g(f, 0, [
        1
    ], "03").substr(2);
    b.algoid = g(f, 0, [
        0,
        0
    ], "06");
    if (b.algoid === "2a8648ce3d0201") b.algparam = g(f, 0, [
        0,
        1
    ], "06");
    return b;
};
$b1badb002678e3c8$var$X509.KEYUSAGE_NAME = [
    "digitalSignature",
    "nonRepudiation",
    "keyEncipherment",
    "dataEncipherment",
    "keyAgreement",
    "keyCertSign",
    "cRLSign",
    "encipherOnly",
    "decipherOnly"
];
var $b1badb002678e3c8$var$X509CRL = function(e) {
    var a = $b1badb002678e3c8$var$KJUR, f = a.lang.String.isHex, m = $b1badb002678e3c8$var$ASN1HEX, k = m.getV, b = m.getTLV, h = m.getVbyList, c = m.getTLVbyList, d = m.getTLVbyListEx, i = m.getIdxbyList, g = m.getIdxbyListEx, l = m.getChildIdx, j = new $b1badb002678e3c8$var$X509();
    this.hex = null;
    this.posSigAlg = null;
    this.posRevCert = null;
    this.parsed = null;
    this._setPos = function() {
        var o = i(this.hex, 0, [
            0,
            0
        ]);
        var n = this.hex.substr(o, 2);
        if (n == "02") this.posSigAlg = 1;
        else {
            if (n == "30") this.posSigAlg = 0;
            else throw new Error("malformed 1st item of TBSCertList: " + n);
        }
        var s = i(this.hex, 0, [
            0,
            this.posSigAlg + 3
        ]);
        var r = this.hex.substr(s, 2);
        if (r == "17" || r == "18") {
            var q, p;
            q = i(this.hex, 0, [
                0,
                this.posSigAlg + 4
            ]);
            this.posRevCert = null;
            if (q != -1) {
                p = this.hex.substr(q, 2);
                if (p == "30") this.posRevCert = this.posSigAlg + 4;
            }
        } else if (r == "30") this.posRevCert = this.posSigAlg + 3;
        else {
            if (r == "a0") this.posRevCert = null;
            else throw new Error("malformed nextUpdate or revCert tag: " + r);
        }
    };
    this.getVersion = function() {
        if (this.posSigAlg == 0) return null;
        return parseInt(h(this.hex, 0, [
            0,
            0
        ], "02"), 16) + 1;
    };
    this.getSignatureAlgorithmField = function() {
        var n = c(this.hex, 0, [
            0,
            this.posSigAlg
        ], "30");
        return j.getAlgorithmIdentifierName(n);
    };
    this.getIssuer = function() {
        return j.getX500Name(this.getIssuerHex());
    };
    this.getIssuerHex = function() {
        return c(this.hex, 0, [
            0,
            this.posSigAlg + 1
        ], "30");
    };
    this.getThisUpdate = function() {
        var n = h(this.hex, 0, [
            0,
            this.posSigAlg + 2
        ]);
        return result = $b1badb002678e3c8$var$hextorstr(n);
    };
    this.getNextUpdate = function() {
        var o = i(this.hex, 0, [
            0,
            this.posSigAlg + 3
        ]);
        var n = this.hex.substr(o, 2);
        if (n != "17" && n != "18") return null;
        return $b1badb002678e3c8$var$hextorstr(k(this.hex, o));
    };
    this.getRevCertArray = function() {
        if (this.posRevCert == null) return null;
        var o = [];
        var n = i(this.hex, 0, [
            0,
            this.posRevCert
        ]);
        var p = l(this.hex, n);
        for(var q = 0; q < p.length; q++){
            var r = b(this.hex, p[q]);
            o.push(this.getRevCert(r));
        }
        return o;
    };
    this.getRevCert = function(p) {
        var o = {};
        var n = l(p, 0);
        o.sn = {
            hex: h(p, 0, [
                0
            ], "02")
        };
        o.date = $b1badb002678e3c8$var$hextorstr(h(p, 0, [
            1
        ]));
        if (n.length == 3) o.ext = j.getExtParamArray(c(p, 0, [
            2
        ]));
        return o;
    };
    this.findRevCert = function(p) {
        var n = new $b1badb002678e3c8$var$X509(p);
        var o = n.getSerialNumberHex();
        return this.findRevCertBySN(o);
    };
    this.findRevCertBySN = function(o) {
        if (this.parsed == null) this.getParam();
        if (this.parsed.revcert == null) return null;
        var n = this.parsed.revcert;
        for(var p = 0; p < n.length; p++){
            if (o == n[p].sn.hex) return n[p];
        }
        return null;
    };
    this.getSignatureValueHex = function() {
        return h(this.hex, 0, [
            2
        ], "03", true);
    };
    this.verifySignature = function(o) {
        var p = this.getSignatureAlgorithmField();
        var n = this.getSignatureValueHex();
        var q = c(this.hex, 0, [
            0
        ], "30");
        var r = new $b1badb002678e3c8$var$KJUR.crypto.Signature({
            alg: p
        });
        r.init(o);
        r.updateHex(q);
        return r.verify(n);
    };
    this.getParam = function(r) {
        var n = {};
        var p = this.getVersion();
        if (p != null) n.version = p;
        n.sigalg = this.getSignatureAlgorithmField();
        n.issuer = this.getIssuer();
        n.thisupdate = this.getThisUpdate();
        var q = this.getNextUpdate();
        if (q != null) n.nextupdate = q;
        var t = this.getRevCertArray();
        if (t != null) n.revcert = t;
        var s = g(this.hex, 0, [
            0,
            "[0]"
        ]);
        if (s != -1) {
            var o = d(this.hex, 0, [
                0,
                "[0]",
                0
            ]);
            n.ext = j.getExtParamArray(o);
        }
        n.sighex = this.getSignatureValueHex();
        this.parsed = n;
        if (typeof r == "object") {
            if (r.tbshex == true) n.tbshex = c(this.hex, 0, [
                0
            ]);
            if (r.nodnarray == true) delete n.issuer.array;
        }
        return n;
    };
    if (typeof e == "string") {
        if (f(e)) this.hex = e;
        else if (e.match(/-----BEGIN X509 CRL/)) this.hex = $b1badb002678e3c8$var$pemtohex(e);
        this._setPos();
    }
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.jws == "undefined" || !$b1badb002678e3c8$var$KJUR.jws) $b1badb002678e3c8$var$KJUR.jws = {};
$b1badb002678e3c8$var$KJUR.jws.JWS = function() {
    var b = $b1badb002678e3c8$var$KJUR, a = b.jws.JWS, c = a.isSafeJSONString;
    this.parseJWS = function(g, j) {
        if (this.parsedJWS !== undefined && (j || this.parsedJWS.sigvalH !== undefined)) return;
        var i = g.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
        if (i == null) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
        var k = i[1];
        var e = i[2];
        var l = i[3];
        var n = k + "." + e;
        this.parsedJWS = {};
        this.parsedJWS.headB64U = k;
        this.parsedJWS.payloadB64U = e;
        this.parsedJWS.sigvalB64U = l;
        this.parsedJWS.si = n;
        if (!j) {
            var h = $b1badb002678e3c8$var$b64utohex(l);
            var f = $b1badb002678e3c8$var$parseBigInt(h, 16);
            this.parsedJWS.sigvalH = h;
            this.parsedJWS.sigvalBI = f;
        }
        var d = $b1badb002678e3c8$var$b64utoutf8(k);
        var m = $b1badb002678e3c8$var$b64utoutf8(e);
        this.parsedJWS.headS = d;
        this.parsedJWS.payloadS = m;
        if (!c(d, this.parsedJWS, "headP")) throw "malformed JSON string for JWS Head: " + d;
    };
};
$b1badb002678e3c8$var$KJUR.jws.JWS.sign = function(j, w, z, A, a) {
    var x = $b1badb002678e3c8$var$KJUR, n = x.jws, r = n.JWS, h = r.readSafeJSONString, q = r.isSafeJSONString, d = x.crypto, l = d.ECDSA, p = d.Mac, c = d.Signature, u = JSON;
    var t, k, o;
    if (typeof w != "string" && typeof w != "object") throw "spHeader must be JSON string or object: " + w;
    if (typeof w == "object") {
        k = w;
        t = u.stringify(k);
    }
    if (typeof w == "string") {
        t = w;
        if (!q(t)) throw "JWS Head is not safe JSON string: " + t;
        k = h(t);
    }
    o = z;
    if (typeof z == "object") o = u.stringify(z);
    if ((j == "" || j == null) && k.alg !== undefined) j = k.alg;
    if (j != "" && j != null && k.alg === undefined) {
        k.alg = j;
        t = u.stringify(k);
    }
    if (j !== k.alg) throw "alg and sHeader.alg doesn't match: " + j + "!=" + k.alg;
    var s = null;
    if (r.jwsalg2sigalg[j] === undefined) throw "unsupported alg name: " + j;
    else s = r.jwsalg2sigalg[j];
    var e = $b1badb002678e3c8$var$utf8tob64u(t);
    var m = $b1badb002678e3c8$var$utf8tob64u(o);
    var b = e + "." + m;
    var y = "";
    if (s.substr(0, 4) == "Hmac") {
        if (A === undefined) throw "mac key shall be specified for HS* alg";
        var i = new p({
            alg: s,
            prov: "cryptojs",
            pass: A
        });
        i.updateString(b);
        y = i.doFinal();
    } else {
        if (s.indexOf("withECDSA") != -1) {
            var f = new c({
                alg: s
            });
            f.init(A, a);
            f.updateString(b);
            var g = f.sign();
            y = $b1badb002678e3c8$var$KJUR.crypto.ECDSA.asn1SigToConcatSig(g);
        } else if (s != "none") {
            var f = new c({
                alg: s
            });
            f.init(A, a);
            f.updateString(b);
            y = f.sign();
        }
    }
    var v = $b1badb002678e3c8$var$hextob64u(y);
    return b + "." + v;
};
$b1badb002678e3c8$var$KJUR.jws.JWS.verify = function(w, B, n) {
    var x = $b1badb002678e3c8$var$KJUR, q = x.jws, t = q.JWS, i = t.readSafeJSONString, e = x.crypto, p = e.ECDSA, s = e.Mac, d = e.Signature, m;
    m = $b1badb002678e3c8$var$RSAKey;
    if (!$b1badb002678e3c8$var$isBase64URLDot(w)) return false;
    var y = w.split(".");
    if (y.length !== 3) return false;
    var f = y[0];
    var r = y[1];
    var c = f + "." + r;
    var A = $b1badb002678e3c8$var$b64utohex(y[2]);
    var l = i($b1badb002678e3c8$var$b64utoutf8(y[0]));
    var k = null;
    var z = null;
    if (l.alg === undefined) throw "algorithm not specified in header";
    else {
        k = l.alg;
        z = k.substr(0, 2);
    }
    if (n != null && Object.prototype.toString.call(n) === "[object Array]" && n.length > 0) {
        var b = ":" + n.join(":") + ":";
        if (b.indexOf(":" + k + ":") == -1) throw "algorithm '" + k + "' not accepted in the list";
    }
    if (k != "none" && B === null) throw "key shall be specified to verify.";
    if (typeof B == "string" && B.indexOf("-----BEGIN ") != -1) B = $b1badb002678e3c8$var$KEYUTIL.getKey(B);
    if (z == "RS" || z == "PS") {
        if (!(B instanceof m)) throw "key shall be a RSAKey obj for RS* and PS* algs";
    }
    if (z == "ES") {
        if (!(B instanceof p)) throw "key shall be a ECDSA obj for ES* algs";
    }
    k;
    var u = null;
    if (t.jwsalg2sigalg[l.alg] === undefined) throw "unsupported alg name: " + k;
    else u = t.jwsalg2sigalg[k];
    if (u == "none") throw "not supported";
    else {
        if (u.substr(0, 4) == "Hmac") {
            var o = null;
            if (B === undefined) throw "hexadecimal key shall be specified for HMAC";
            var j = new s({
                alg: u,
                pass: B
            });
            j.updateString(c);
            o = j.doFinal();
            return A == o;
        } else if (u.indexOf("withECDSA") != -1) {
            var h = null;
            try {
                h = p.concatSigToASN1Sig(A);
            } catch (v) {
                return false;
            }
            var g = new d({
                alg: u
            });
            g.init(B);
            g.updateString(c);
            return g.verify(h);
        } else {
            var g = new d({
                alg: u
            });
            g.init(B);
            g.updateString(c);
            return g.verify(A);
        }
    }
};
$b1badb002678e3c8$var$KJUR.jws.JWS.parse = function(g) {
    var c = g.split(".");
    var b = {};
    var f, e, d;
    if (c.length != 2 && c.length != 3) throw "malformed sJWS: wrong number of '.' splitted elements";
    f = c[0];
    e = c[1];
    if (c.length == 3) d = c[2];
    b.headerObj = $b1badb002678e3c8$var$KJUR.jws.JWS.readSafeJSONString($b1badb002678e3c8$var$b64utoutf8(f));
    b.payloadObj = $b1badb002678e3c8$var$KJUR.jws.JWS.readSafeJSONString($b1badb002678e3c8$var$b64utoutf8(e));
    b.headerPP = JSON.stringify(b.headerObj, null, "  ");
    if (b.payloadObj == null) b.payloadPP = $b1badb002678e3c8$var$b64utoutf8(e);
    else b.payloadPP = JSON.stringify(b.payloadObj, null, "  ");
    if (d !== undefined) b.sigHex = $b1badb002678e3c8$var$b64utohex(d);
    return b;
};
$b1badb002678e3c8$var$KJUR.jws.JWS.verifyJWT = function(e, l, r) {
    var d = $b1badb002678e3c8$var$KJUR, j = d.jws, o = j.JWS, n = o.readSafeJSONString, p = o.inArray, f = o.includedArray;
    if (!$b1badb002678e3c8$var$isBase64URLDot(e)) return false;
    var k = e.split(".");
    if (k.length != 3) return false;
    var c = k[0];
    var i = k[1];
    var q = c + "." + i;
    var m = $b1badb002678e3c8$var$b64utohex(k[2]);
    var h = n($b1badb002678e3c8$var$b64utoutf8(c));
    var g = n($b1badb002678e3c8$var$b64utoutf8(i));
    if (h.alg === undefined) return false;
    if (r.alg === undefined) throw "acceptField.alg shall be specified";
    if (!p(h.alg, r.alg)) return false;
    if (g.iss !== undefined && typeof r.iss === "object") {
        if (!p(g.iss, r.iss)) return false;
    }
    if (g.sub !== undefined && typeof r.sub === "object") {
        if (!p(g.sub, r.sub)) return false;
    }
    if (g.aud !== undefined && typeof r.aud === "object") {
        if (typeof g.aud == "string") {
            if (!p(g.aud, r.aud)) return false;
        } else if (typeof g.aud == "object") {
            if (!f(g.aud, r.aud)) return false;
        }
    }
    var b = j.IntDate.getNow();
    if (r.verifyAt !== undefined && typeof r.verifyAt === "number") b = r.verifyAt;
    if (r.gracePeriod === undefined || typeof r.gracePeriod !== "number") r.gracePeriod = 0;
    if (g.exp !== undefined && typeof g.exp == "number") {
        if (g.exp + r.gracePeriod < b) return false;
    }
    if (g.nbf !== undefined && typeof g.nbf == "number") {
        if (b < g.nbf - r.gracePeriod) return false;
    }
    if (g.iat !== undefined && typeof g.iat == "number") {
        if (b < g.iat - r.gracePeriod) return false;
    }
    if (g.jti !== undefined && r.jti !== undefined) {
        if (g.jti !== r.jti) return false;
    }
    if (!o.verify(e, l, r.alg)) return false;
    return true;
};
$b1badb002678e3c8$var$KJUR.jws.JWS.includedArray = function(b, a) {
    var c = $b1badb002678e3c8$var$KJUR.jws.JWS.inArray;
    if (b === null) return false;
    if (typeof b !== "object") return false;
    if (typeof b.length !== "number") return false;
    for(var d = 0; d < b.length; d++){
        if (!c(b[d], a)) return false;
    }
    return true;
};
$b1badb002678e3c8$var$KJUR.jws.JWS.inArray = function(d, b) {
    if (b === null) return false;
    if (typeof b !== "object") return false;
    if (typeof b.length !== "number") return false;
    for(var c = 0; c < b.length; c++){
        if (b[c] == d) return true;
    }
    return false;
};
$b1badb002678e3c8$var$KJUR.jws.JWS.jwsalg2sigalg = {
    HS256: "HmacSHA256",
    HS384: "HmacSHA384",
    HS512: "HmacSHA512",
    RS256: "SHA256withRSA",
    RS384: "SHA384withRSA",
    RS512: "SHA512withRSA",
    ES256: "SHA256withECDSA",
    ES384: "SHA384withECDSA",
    ES512: "SHA512withECDSA",
    PS256: "SHA256withRSAandMGF1",
    PS384: "SHA384withRSAandMGF1",
    PS512: "SHA512withRSAandMGF1",
    none: "none"
};
$b1badb002678e3c8$var$KJUR.jws.JWS.isSafeJSONString = function(c, b, d) {
    var e = null;
    try {
        e = $b1badb002678e3c8$var$jsonParse(c);
        if (typeof e != "object") return 0;
        if (e.constructor === Array) return 0;
        if (b) b[d] = e;
        return 1;
    } catch (a) {
        return 0;
    }
};
$b1badb002678e3c8$var$KJUR.jws.JWS.readSafeJSONString = function(b) {
    var c = null;
    try {
        c = $b1badb002678e3c8$var$jsonParse(b);
        if (typeof c != "object") return null;
        if (c.constructor === Array) return null;
        return c;
    } catch (a) {
        return null;
    }
};
$b1badb002678e3c8$var$KJUR.jws.JWS.getEncodedSignatureValueFromJWS = function(b) {
    var a = b.match(/^[^.]+\.[^.]+\.([^.]+)$/);
    if (a == null) throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
    return a[1];
};
$b1badb002678e3c8$var$KJUR.jws.JWS.getJWKthumbprint = function(d) {
    if (d.kty !== "RSA" && d.kty !== "EC" && d.kty !== "oct") throw "unsupported algorithm for JWK Thumprint";
    var a = "{";
    if (d.kty === "RSA") {
        if (typeof d.n != "string" || typeof d.e != "string") throw "wrong n and e value for RSA key";
        a += '"e":"' + d.e + '",';
        a += '"kty":"' + d.kty + '",';
        a += '"n":"' + d.n + '"}';
    } else {
        if (d.kty === "EC") {
            if (typeof d.crv != "string" || typeof d.x != "string" || typeof d.y != "string") throw "wrong crv, x and y value for EC key";
            a += '"crv":"' + d.crv + '",';
            a += '"kty":"' + d.kty + '",';
            a += '"x":"' + d.x + '",';
            a += '"y":"' + d.y + '"}';
        } else if (d.kty === "oct") {
            if (typeof d.k != "string") throw "wrong k value for oct(symmetric) key";
            a += '"kty":"' + d.kty + '",';
            a += '"k":"' + d.k + '"}';
        }
    }
    var b = $b1badb002678e3c8$var$rstrtohex(a);
    var c = $b1badb002678e3c8$var$KJUR.crypto.Util.hashHex(b, "sha256");
    var e = $b1badb002678e3c8$var$hextob64u(c);
    return e;
};
$b1badb002678e3c8$var$KJUR.jws.IntDate = {};
$b1badb002678e3c8$var$KJUR.jws.IntDate.get = function(c) {
    var b = $b1badb002678e3c8$var$KJUR.jws.IntDate, d = b.getNow, a = b.getZulu;
    if (c == "now") return d();
    else {
        if (c == "now + 1hour") return d() + 3600;
        else {
            if (c == "now + 1day") return d() + 86400;
            else {
                if (c == "now + 1month") return d() + 2592000;
                else {
                    if (c == "now + 1year") return d() + 31536000;
                    else {
                        if (c.match(/Z$/)) return a(c);
                        else {
                            if (c.match(/^[0-9]+$/)) return parseInt(c);
                        }
                    }
                }
            }
        }
    }
    throw "unsupported format: " + c;
};
$b1badb002678e3c8$var$KJUR.jws.IntDate.getZulu = function(a) {
    return $b1badb002678e3c8$var$zulutosec(a);
};
$b1badb002678e3c8$var$KJUR.jws.IntDate.getNow = function() {
    var a = ~~(new Date() / 1000);
    return a;
};
$b1badb002678e3c8$var$KJUR.jws.IntDate.intDate2UTCString = function(a) {
    var b = new Date(a * 1000);
    return b.toUTCString();
};
$b1badb002678e3c8$var$KJUR.jws.IntDate.intDate2Zulu = function(e) {
    var i = new Date(e * 1000), h = ("0000" + i.getUTCFullYear()).slice(-4), g = ("00" + (i.getUTCMonth() + 1)).slice(-2), b = ("00" + i.getUTCDate()).slice(-2), a = ("00" + i.getUTCHours()).slice(-2), c = ("00" + i.getUTCMinutes()).slice(-2), f = ("00" + i.getUTCSeconds()).slice(-2);
    return h + g + b + a + c + f + "Z";
};
if (typeof $b1badb002678e3c8$var$KJUR == "undefined" || !$b1badb002678e3c8$var$KJUR) $b1badb002678e3c8$var$KJUR = {};
if (typeof $b1badb002678e3c8$var$KJUR.jws == "undefined" || !$b1badb002678e3c8$var$KJUR.jws) $b1badb002678e3c8$var$KJUR.jws = {};
$b1badb002678e3c8$var$KJUR.jws.JWSJS = function() {
    var c = $b1badb002678e3c8$var$KJUR, b = c.jws, a = b.JWS, d = a.readSafeJSONString;
    this.aHeader = [];
    this.sPayload = "";
    this.aSignature = [];
    this.init = function() {
        this.aHeader = [];
        this.sPayload = undefined;
        this.aSignature = [];
    };
    this.initWithJWS = function(f) {
        this.init();
        var e = f.split(".");
        if (e.length != 3) throw "malformed input JWS";
        this.aHeader.push(e[0]);
        this.sPayload = e[1];
        this.aSignature.push(e[2]);
    };
    this.addSignature = function(e, h, m, k) {
        if (this.sPayload === undefined || this.sPayload === null) throw "there's no JSON-JS signature to add.";
        var l = this.aHeader.length;
        if (this.aHeader.length != this.aSignature.length) throw "aHeader.length != aSignature.length";
        try {
            var f = $b1badb002678e3c8$var$KJUR.jws.JWS.sign(e, h, this.sPayload, m, k);
            var j = f.split(".");
            var n = j[0];
            var g = j[2];
            this.aHeader.push(j[0]);
            this.aSignature.push(j[2]);
        } catch (i) {
            if (this.aHeader.length > l) this.aHeader.pop();
            if (this.aSignature.length > l) this.aSignature.pop();
            throw "addSignature failed: " + i;
        }
    };
    this.verifyAll = function(h) {
        if (this.aHeader.length !== h.length || this.aSignature.length !== h.length) return false;
        for(var g = 0; g < h.length; g++){
            var f = h[g];
            if (f.length !== 2) return false;
            var e = this.verifyNth(g, f[0], f[1]);
            if (e === false) return false;
        }
        return true;
    };
    this.verifyNth = function(f, j, g) {
        if (this.aHeader.length <= f || this.aSignature.length <= f) return false;
        var h = this.aHeader[f];
        var k = this.aSignature[f];
        var l = h + "." + this.sPayload + "." + k;
        var e = false;
        try {
            e = a.verify(l, j, g);
        } catch (i) {
            return false;
        }
        return e;
    };
    this.readJWSJS = function(g) {
        if (typeof g === "string") {
            var f = d(g);
            if (f == null) throw "argument is not safe JSON object string";
            this.aHeader = f.headers;
            this.sPayload = f.payload;
            this.aSignature = f.signatures;
        } else try {
            if (g.headers.length > 0) this.aHeader = g.headers;
            else throw "malformed header";
            if (typeof g.payload === "string") this.sPayload = g.payload;
            else throw "malformed signatures";
            if (g.signatures.length > 0) this.aSignature = g.signatures;
            else throw "malformed signatures";
        } catch (e) {
            throw "malformed JWS-JS JSON object: " + e;
        }
    };
    this.getJSON = function() {
        return {
            headers: this.aHeader,
            payload: this.sPayload,
            signatures: this.aSignature
        };
    };
    this.isEmpty = function() {
        if (this.aHeader.length == 0) return 1;
        return 0;
    };
};
$b1badb002678e3c8$export$f3b03d0edd9563f3 = $b1badb002678e3c8$var$SecureRandom;
$b1badb002678e3c8$export$282a641876a53bc3 = $b1badb002678e3c8$var$rng_seed_time;
$b1badb002678e3c8$export$1a89ae3627118dd = $b1badb002678e3c8$var$BigInteger;
$b1badb002678e3c8$export$f5462558b84dd2ed = $b1badb002678e3c8$var$RSAKey;
$b1badb002678e3c8$export$e4ecceb4875351b5 = $b1badb002678e3c8$var$KJUR.crypto.ECDSA;
$b1badb002678e3c8$export$976575134972f9a4 = $b1badb002678e3c8$var$KJUR.crypto.DSA;
$b1badb002678e3c8$export$848620f5f2f26e86 = $b1badb002678e3c8$var$KJUR.crypto.Signature;
$b1badb002678e3c8$export$3b6eba580b3b05c2 = $b1badb002678e3c8$var$KJUR.crypto.MessageDigest;
$b1badb002678e3c8$export$932592b46db185be = $b1badb002678e3c8$var$KJUR.crypto.Mac;
$b1badb002678e3c8$export$26e5786e8ac8e530 = $b1badb002678e3c8$var$KJUR.crypto.Cipher;
$b1badb002678e3c8$export$4f7f04ab89baffd5 = $b1badb002678e3c8$var$KEYUTIL;
$b1badb002678e3c8$export$b86ba1ae94e2bfc6 = $b1badb002678e3c8$var$ASN1HEX;
$b1badb002678e3c8$export$2a36976f17340ce9 = $b1badb002678e3c8$var$X509;
$b1badb002678e3c8$export$745706c0ef8a4a95 = $b1badb002678e3c8$var$X509CRL;
$b1badb002678e3c8$export$6290422ba3eff881 = $b1badb002678e3c8$var$CryptoJS;
$b1badb002678e3c8$export$d19dfddb415836ed = $b1badb002678e3c8$var$b64tohex;
$b1badb002678e3c8$export$d7cf0422ea26a99a = $b1badb002678e3c8$var$b64toBA;
$b1badb002678e3c8$export$afd6716cdada7ed5 = $b1badb002678e3c8$var$ECFieldElementFp;
$b1badb002678e3c8$export$4723ecead0798297 = $b1badb002678e3c8$var$ECPointFp;
$b1badb002678e3c8$export$726408a8537bde80 = $b1badb002678e3c8$var$ECCurveFp;
$b1badb002678e3c8$export$2cc6664de1b990db = $b1badb002678e3c8$var$stoBA;
$b1badb002678e3c8$export$9cbca96477f9ae2f = $b1badb002678e3c8$var$BAtos;
$b1badb002678e3c8$export$44c267f4f65a8a7f = $b1badb002678e3c8$var$BAtohex;
$b1badb002678e3c8$export$5eee626700e49209 = $b1badb002678e3c8$var$stohex;
$b1badb002678e3c8$export$b2d4d26b5ccff6a9 = $b1badb002678e3c8$var$stob64;
$b1badb002678e3c8$export$8a4767dad77d7c90 = $b1badb002678e3c8$var$stob64u;
$b1badb002678e3c8$export$fe8597e65838ca44 = $b1badb002678e3c8$var$b64utos;
$b1badb002678e3c8$export$7407696354668e77 = $b1badb002678e3c8$var$b64tob64u;
$b1badb002678e3c8$export$698d677dfec3eedc = $b1badb002678e3c8$var$b64utob64;
$b1badb002678e3c8$export$1d3058c7ef7b57e7 = $b1badb002678e3c8$var$hex2b64;
$b1badb002678e3c8$export$e3d76fc82b6f4709 = $b1badb002678e3c8$var$hextob64u;
$b1badb002678e3c8$export$dbc620645d9d8e1c = $b1badb002678e3c8$var$b64utohex;
$b1badb002678e3c8$export$72c5155990131fea = $b1badb002678e3c8$var$utf8tob64u;
$b1badb002678e3c8$export$7c9521958f1a8b53 = $b1badb002678e3c8$var$b64utoutf8;
$b1badb002678e3c8$export$60178c38071ce57 = $b1badb002678e3c8$var$utf8tob64;
$b1badb002678e3c8$export$f86becda4308ac43 = $b1badb002678e3c8$var$b64toutf8;
$b1badb002678e3c8$export$58845754f36e74c0 = $b1badb002678e3c8$var$utf8tohex;
$b1badb002678e3c8$export$df8d81c68e1f33f4 = $b1badb002678e3c8$var$hextoutf8;
$b1badb002678e3c8$export$ee29e73a50dc272a = $b1badb002678e3c8$var$hextorstr;
$b1badb002678e3c8$export$4f67c080e58d5fc8 = $b1badb002678e3c8$var$rstrtohex;
$b1badb002678e3c8$export$3d3bc10a7110335e = $b1badb002678e3c8$var$hextob64;
$b1badb002678e3c8$export$34dd639c3ad435e5 = $b1badb002678e3c8$var$hextob64nl;
$b1badb002678e3c8$export$a2c095b78f275405 = $b1badb002678e3c8$var$b64nltohex;
$b1badb002678e3c8$export$5b3955e928a80e02 = $b1badb002678e3c8$var$hextopem;
$b1badb002678e3c8$export$3c4028916a1e7c6b = $b1badb002678e3c8$var$pemtohex;
$b1badb002678e3c8$export$6cd6298d9192e025 = $b1badb002678e3c8$var$hextoArrayBuffer;
$b1badb002678e3c8$export$dd14f12d991e544e = $b1badb002678e3c8$var$ArrayBuffertohex;
$b1badb002678e3c8$export$b44ce6106c226618 = $b1badb002678e3c8$var$zulutomsec;
$b1badb002678e3c8$export$3216c5a35077bf7f = $b1badb002678e3c8$var$zulutosec;
$b1badb002678e3c8$export$8b7fec17a71a9b41 = $b1badb002678e3c8$var$zulutodate;
$b1badb002678e3c8$export$62dfecc41a84b0d1 = $b1badb002678e3c8$var$datetozulu;
$b1badb002678e3c8$export$d6c5a18bb1fc0052 = $b1badb002678e3c8$var$uricmptohex;
$b1badb002678e3c8$export$95365fd5256ec7db = $b1badb002678e3c8$var$hextouricmp;
$b1badb002678e3c8$export$d4c51f74e5089406 = $b1badb002678e3c8$var$ipv6tohex;
$b1badb002678e3c8$export$3c617715bb93799d = $b1badb002678e3c8$var$hextoipv6;
$b1badb002678e3c8$export$70378f11804174db = $b1badb002678e3c8$var$hextoip;
$b1badb002678e3c8$export$ddd58b31d8df363d = $b1badb002678e3c8$var$iptohex;
$b1badb002678e3c8$export$5950376737d25772 = $b1badb002678e3c8$var$ucs2hextoutf8;
$b1badb002678e3c8$export$46f4a68bb92b01f3 = $b1badb002678e3c8$var$encodeURIComponentAll;
$b1badb002678e3c8$export$3cf10cd345a8d2a2 = $b1badb002678e3c8$var$newline_toUnix;
$b1badb002678e3c8$export$6e18a9227aeed184 = $b1badb002678e3c8$var$newline_toDos;
$b1badb002678e3c8$export$f8cc9a8e09bfbdc0 = $b1badb002678e3c8$var$hextoposhex;
$b1badb002678e3c8$export$47b089f332e467b0 = $b1badb002678e3c8$var$intarystrtohex;
$b1badb002678e3c8$export$df366832902521e3 = $b1badb002678e3c8$var$strdiffidx;
$b1badb002678e3c8$export$dbd72e020e0a4659 = $b1badb002678e3c8$var$oidtohex;
$b1badb002678e3c8$export$1852d16cc1fa045d = $b1badb002678e3c8$var$hextooid;
$b1badb002678e3c8$export$2e7bc010fb6cbef6 = $b1badb002678e3c8$var$strpad;
$b1badb002678e3c8$export$f407ad11b833a42c = $b1badb002678e3c8$var$bitstrtoint;
$b1badb002678e3c8$export$5821a351dc01c86c = $b1badb002678e3c8$var$inttobitstr;
$b1badb002678e3c8$export$ffa65c7cd7d99bbe = $b1badb002678e3c8$var$bitstrtobinstr;
$b1badb002678e3c8$export$6e0bc1c6de95693a = $b1badb002678e3c8$var$binstrtobitstr;
$b1badb002678e3c8$export$d3e8e560222ea674 = $b1badb002678e3c8$var$isBase64URLDot;
$b1badb002678e3c8$export$ce530db93b05eeba = $b1badb002678e3c8$var$namearraytobinstr;
$b1badb002678e3c8$export$8bbe6e427750f06d = $b1badb002678e3c8$var$extendClass;
$b1badb002678e3c8$export$eeb0cac846251be6 = $b1badb002678e3c8$var$KJUR;
$b1badb002678e3c8$export$7effb53edfc7fa2d = $b1badb002678e3c8$var$KJUR.crypto;
$b1badb002678e3c8$export$b54eb25e8c142da9 = $b1badb002678e3c8$var$KJUR.asn1;
$b1badb002678e3c8$export$dc7009a36380caa = $b1badb002678e3c8$var$KJUR.jws;
$b1badb002678e3c8$export$9a771d6906431624 = $b1badb002678e3c8$var$KJUR.lang;


const $d759581364115054$export$c807668e63e7354b = async (accessToken, awsconfig)=>{
    // returns true if the token can be verified, otherwise false
    // takes JWT as parameter
    // CAUTION: the verifyToken in the utils-library DOES NOT WORK in the browser environment
    // get public key from Cognito public endpoint
    function fetchPublicKeys() {
        return new Promise((resolve, reject)=>{
            // check sessionStorage if the keys are there already, if not - download and put them there
            const keys = sessionStorage.getItem("cognitoPublicKeys");
            if (keys) resolve(JSON.parse(keys));
            else fetch(`https://cognito-idp.${"eu-central-1"}.amazonaws.com/${"eu-central-1_8fuw7DSci"}/.well-known/jwks.json`).then((response)=>{
                const responseJson = response.json(); // returns a promise
                responseJson.then((json)=>{
                    sessionStorage.setItem("cognitoPublicKeys", JSON.stringify(json));
                });
                resolve(responseJson); // returns a promise
            }).catch((error)=>reject(error));
        });
    }
    let publicKeysObject;
    try {
        publicKeysObject = await fetchPublicKeys();
    // console.info('public keys fetched --> ', JSON.stringify(publicKeysObject));
    } catch (err) {
        if (err.name === "AbortError") // request was aborted
        throw new Error(`Fetch request was aborted. Details:${err}`);
        else throw new Error(`Fetch request error. Details:${err}`);
    }
    // find out which of the two keys in the file above matches the one in the token
    // attempt to verify token with both keys, if one returns true, return true, otherwise return false
    let returnObject = false;
    try {
        // eslint-disable-next-line guard-for-in
        publicKeysObject.keys.forEach((publicKey)=>{
            const result = $b1badb002678e3c8$export$eeb0cac846251be6.jws.JWS.verifyJWT(accessToken, $b1badb002678e3c8$export$4f7f04ab89baffd5.getKey(publicKey), // if this fails again for both keys, check the difference between local clock and the server clock
            // and ggf. adjust grace period here
            // more info: https://kjur.github.io/jsrsasign/api/symbols/KJUR.jws.JWS.html#.verifyJWT
            {
                alg: [
                    "RS256"
                ],
                gracePeriod: 60
            });
            if (result) returnObject = true;
        // console.info('testing key ', publicKey, 'result', result);
        });
    } catch (error) {
        throw new Error(`Error while trying to validate JWT. Details: ${error}`);
    }
    return returnObject;
};




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
// This file replaces `index.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
// This alphabet uses `A-Za-z0-9_-` symbols.
// The order of characters is optimized for better gzip and brotli compression.
// Same as in non-secure/index.js
let $41641bb5434aba01$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";


let $8136d14ed46fb244$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $8136d14ed46fb244$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    // First, a bitmask is necessary to generate the ID. The bitmask makes bytes
    // values closer to the alphabet size. The bitmask calculates the closest
    // `2^31 - 1` number, which exceeds the alphabet size.
    // For example, the bitmask for the alphabet size 30 is 31 (00011111).
    // `Math.clz32` is not used, because it is not available in browsers.
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Though, the bitmask solution is not perfect since the bytes exceeding
    // the alphabet size are refused. Therefore, to reliably generate the ID,
    // the random bytes redundancy has to be satisfied.
    // Note: every hardware random generator call is performance expensive,
    // because the system call for entropy collection takes a lot of time.
    // So, to avoid additional system calls, extra bytes are requested in advance.
    // Next, a step determines how many random bytes to generate.
    // The number of random bytes gets decided upon the ID size, mask,
    // alphabet size, and magic number 1.6 (using 1.6 peaks at performance
    // according to benchmarks).
    // `-~f => Math.ceil(f)` if f is a float
    // `-~i => i + 1` if i is an integer
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            // A compact alternative for `for (var i = 0; i < step; i++)`.
            let j = step | 0;
            while(j--){
                // Adding `|| ''` refuses a random byte that exceeds the alphabet size.
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $8136d14ed46fb244$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$8136d14ed46fb244$export$a5cee9e955a615e5(alphabet, size, $8136d14ed46fb244$export$4385e60b38654f68);
let $8136d14ed46fb244$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        // It is incorrect to use bytes exceeding the alphabet size.
        // The following mask reduces the random byte in the 0-255 value
        // range to the 0-63 value range. Therefore, adding hacks, such
        // as empty string fallback or magic numbers, is unneccessary because
        // the bitmask trims bytes down to the alphabet size.
        byte &= 63;
        if (byte < 36) // `0-9a-z`
        id += byte.toString(36);
        else if (byte < 62) // `A-Z`
        id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $c77c82c16b2a07f8$export$b855308a44508212(str) {
    return str.split("").map((char)=>char.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}








var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $70bf107705180c78$export$a7ea17e93539f9a5(hex) {
    const matchArr = hex.match(/.{2}/g) || [];
    return matchArr.map((char)=>String.fromCharCode(parseInt(char, 16))).join("");
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $bde9b561f15cfda8$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult === null || AuthenticationResult === void 0 ? void 0 : AuthenticationResult.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $10e1902ea767432f$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9269d5589ae9a3ed$export$3f27bc10068ef877 = "Unable to get user session following successful sign-in.";
const $9269d5589ae9a3ed$export$4d78d2ee899572ab = async ()=>{
    try {
        (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedIn",
            data: await (0, $d4670e566035df31$export$e5432d4c8eb97ea7)()
        }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
    } catch (error) {
        if (error.name === (0, $1b91ec72af99207f$export$d29d1996d6b6f5e3)) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: (0, $1b91ec72af99207f$export$606cffc85964c24b),
            message: $9269d5589ae9a3ed$export$3f27bc10068ef877,
            recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
        });
        throw error;
    }
};








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $07233456440bc422$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($07233456440bc422$export$12d5c695b2213c4a || ($07233456440bc422$export$12d5c695b2213c4a = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c1c2568bac613fe8$export$195137955146d376 = {
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS, TOTP, or EMAIL",
        recoverySuggestion: "Try to pass SMS, TOTP, or EMAIL as the challengeResponse"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $c1c2568bac613fe8$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($c1c2568bac613fe8$export$c3070468b9d65120 || ($c1c2568bac613fe8$export$c3070468b9d65120 = {}));
var $c1c2568bac613fe8$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($c1c2568bac613fe8$export$473ab0b56598aacd || ($c1c2568bac613fe8$export$473ab0b56598aacd = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: delete this module when the Auth class is removed.
const $add5955bfd85b0ec$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("AuthError");
class $add5955bfd85b0ec$export$145273558d58e0ac extends Error {
    constructor(type){
        const { message: message, log: log } = $add5955bfd85b0ec$export$d8113b8d790509a4[type];
        super(message);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $add5955bfd85b0ec$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $add5955bfd85b0ec$export$145273558d58e0ac.prototype);
        this.name = "AuthError";
        this.log = log || message;
        $add5955bfd85b0ec$var$logger.error(this.log);
    }
}
class $add5955bfd85b0ec$export$71192787e041818c extends $add5955bfd85b0ec$export$145273558d58e0ac {
    constructor(type){
        super(type);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $add5955bfd85b0ec$export$71192787e041818c;
        Object.setPrototypeOf(this, $add5955bfd85b0ec$export$71192787e041818c.prototype);
        this.name = "NoUserPoolError";
    }
}
const $add5955bfd85b0ec$export$d8113b8d790509a4 = {
    oauthSignInError: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).OAUTH_ERROR,
        log: "Make sure Cognito Hosted UI has been configured correctly"
    },
    noConfig: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
    },
    missingAuthConfig: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
    },
    emptyUsername: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $c1c2568bac613fe8$export$c3070468b9d65120).DEFAULT_MSG
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c0a43102ad2bfdd6$export$84cc8f04e08ffc24 = (message, recoverySuggestion)=>new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        message: message !== null && message !== void 0 ? message : "An error has occurred during the oauth process.",
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).OAuthSignInError,
        recoverySuggestion: recoverySuggestion !== null && recoverySuggestion !== void 0 ? recoverySuggestion : (0, $add5955bfd85b0ec$export$d8113b8d790509a4).oauthSignInError.log
    });



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $a5a970d23d949517$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
    AuthErrorTypes["OAuthSignInError"] = "oauthSignInError";
})($a5a970d23d949517$export$edb367c0a140d3db || ($a5a970d23d949517$export$edb367c0a140d3db = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3389ff73b0d37055$export$8963ba4ccadccff8 = "`signInWithRedirect` has been canceled.";
const $3389ff73b0d37055$export$72e3479c52537deb = "An error occurred while validating the state.";
const $3389ff73b0d37055$export$80dc16ad7fef6c6 = "Try to initiate an OAuth flow from Amplify";
const $3389ff73b0d37055$export$6925991e7e736e7 = async (state)=>{
    const savedState = await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).loadOAuthState();
    // This is because savedState only exists if the flow was initiated by Amplify
    const validatedState = state === savedState ? savedState : undefined;
    if (!validatedState) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $a5a970d23d949517$export$edb367c0a140d3db).OAuthSignInError,
        message: state === null ? $3389ff73b0d37055$export$8963ba4ccadccff8 : $3389ff73b0d37055$export$72e3479c52537deb,
        recoverySuggestion: state === null ? undefined : $3389ff73b0d37055$export$80dc16ad7fef6c6
    });
    return validatedState;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $97689c63f64ae65a$export$342f5c7ddb2087ec = async ({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, responseType: responseType, domain: domain, preferPrivateSession: preferPrivateSession })=>{
    const urlParams = new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(currentUrl);
    const error = urlParams.searchParams.get("error");
    const errorMessage = urlParams.searchParams.get("error_description");
    if (error) throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : error);
    if (responseType === "code") return $97689c63f64ae65a$var$handleCodeFlow({
        currentUrl: currentUrl,
        userAgentValue: userAgentValue,
        clientId: clientId,
        redirectUri: redirectUri,
        domain: domain,
        preferPrivateSession: preferPrivateSession
    });
    return $97689c63f64ae65a$var$handleImplicitFlow({
        currentUrl: currentUrl,
        redirectUri: redirectUri,
        preferPrivateSession: preferPrivateSession
    });
};
const $97689c63f64ae65a$var$handleCodeFlow = async ({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, domain: domain, preferPrivateSession: preferPrivateSession })=>{
    /* Convert URL into an object with parameters as keys
{ redirect_uri: 'http://localhost:3000/', response_type: 'code', ...} */ const url = new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(currentUrl);
    const code = url.searchParams.get("code");
    const state = url.searchParams.get("state");
    // if `code` or `state` is not presented in the redirect url, most likely
    // that the end user cancelled the inflight oauth flow by:
    // 1. clicking the back button of browser
    // 2. closing the provider hosted UI page and coming back to the app
    if (!code || !state) throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)("User cancelled OAuth flow.");
    // may throw error is being caught in attemptCompleteOAuthFlow.ts
    const validatedState = await (0, $3389ff73b0d37055$export$6925991e7e736e7)(state);
    const oAuthTokenEndpoint = "https://" + domain + "/oauth2/token";
    // TODO(v6): check hub events
    // dispatchAuthEvent(
    // 	'codeFlow',
    // 	{},
    // 	`Retrieving tokens from ${oAuthTokenEndpoint}`
    // );
    const codeVerifier = await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).loadPKCE();
    const oAuthTokenBody = (0, $9tqwB._)({
        grant_type: "authorization_code",
        code: code,
        client_id: clientId,
        redirect_uri: redirectUri
    }, codeVerifier ? {
        code_verifier: codeVerifier
    } : {});
    const body = Object.entries(oAuthTokenBody).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
    const { access_token: access_token, refresh_token: refreshToken, id_token: id_token, error: error, error_message: errorMessage, token_type: token_type, expires_in: expires_in } = await (await fetch(oAuthTokenEndpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            [(0, $7a4462edeb17eaf0$export$16032fc466434892)]: userAgentValue
        },
        body: body
    })).json();
    if (error) // error is being caught in attemptCompleteOAuthFlow.ts
    throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : error);
    var _ref;
    const username = (_ref = access_token && (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(access_token).payload.username) !== null && _ref !== void 0 ? _ref : "username";
    await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token,
        RefreshToken: refreshToken
    });
    return $97689c63f64ae65a$var$completeFlow({
        redirectUri: redirectUri,
        state: validatedState,
        preferPrivateSession: preferPrivateSession
    });
};
const $97689c63f64ae65a$var$handleImplicitFlow = async ({ currentUrl: currentUrl, redirectUri: redirectUri, preferPrivateSession: preferPrivateSession })=>{
    // hash is `null` if `#` doesn't exist on URL
    const url = new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(currentUrl);
    var _url_hash;
    const { id_token: id_token, access_token: access_token, state: state, token_type: token_type, expires_in: expires_in, error_description: error_description, error: error } = ((_url_hash = url.hash) !== null && _url_hash !== void 0 ? _url_hash : "#").substring(1) // Remove # from returned code
    .split("&").map((pairings)=>pairings.split("=")).reduce((accum, [k, v])=>(0, $2qxEV._)((0, $9tqwB._)({}, accum), {
            [k]: v
        }), {
        id_token: undefined,
        access_token: undefined,
        state: undefined,
        token_type: undefined,
        expires_in: undefined,
        error_description: undefined,
        error: undefined
    });
    if (error) throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)(error_description !== null && error_description !== void 0 ? error_description : error);
    if (!access_token) // error is being caught in attemptCompleteOAuthFlow.ts
    throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)("No access token returned from OAuth flow.");
    const validatedState = await (0, $3389ff73b0d37055$export$6925991e7e736e7)(state);
    var _ref;
    const username = (_ref = access_token && (0, $00406059b8b03c2e$export$9a62e6c0a30e00bc)(access_token).payload.username) !== null && _ref !== void 0 ? _ref : "username";
    await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token
    });
    return $97689c63f64ae65a$var$completeFlow({
        redirectUri: redirectUri,
        state: validatedState,
        preferPrivateSession: preferPrivateSession
    });
};
const $97689c63f64ae65a$var$completeFlow = async ({ redirectUri: redirectUri, state: state, preferPrivateSession: preferPrivateSession })=>{
    await (0, $10e1902ea767432f$export$66561e66d62991d0).setOAuthMetadata({
        oauthSignIn: true
    });
    await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).clearOAuthData();
    await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).storeOAuthSignIn(true, preferPrivateSession);
    // this should be called before any call that involves `fetchAuthSession`
    // e.g. `getCurrentUser()` below, so it allows every inflight async calls to
    //  `fetchAuthSession` can be resolved
    (0, $226a063d0e4c5dea$export$bcb0b7a105a5df59)();
    // clear history before sending out final Hub events
    $97689c63f64ae65a$var$clearHistory(redirectUri);
    if ($97689c63f64ae65a$var$isCustomState(state)) (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
        event: "customOAuthState",
        data: (0, $70bf107705180c78$export$a7ea17e93539f9a5)($97689c63f64ae65a$var$getCustomState(state))
    }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
    (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signInWithRedirect"
    }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
    await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
};
const $97689c63f64ae65a$var$isCustomState = (state)=>{
    return /-/.test(state);
};
const $97689c63f64ae65a$var$getCustomState = (state)=>{
    return state.split("-").splice(1).join("-");
};
const $97689c63f64ae65a$var$clearHistory = (redirectUri)=>{
    if (typeof window !== "undefined" && typeof window.history !== "undefined") window.history.replaceState(window.history.state, "", redirectUri);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $8e98829722d37451$export$93832c3affb240d3(redirects, preferredRedirectUrl) {
    if (preferredRedirectUrl) {
        const redirectUrl = redirects === null || redirects === void 0 ? void 0 : redirects.find((redirect)=>redirect === preferredRedirectUrl);
        if (!redirectUrl) throw 0, $1b91ec72af99207f$export$41a56a70fc1a4962;
        return redirectUrl;
    } else {
        var _redirects_find;
        const redirectUrlFromTheSameOrigin = (_redirects_find = redirects === null || redirects === void 0 ? void 0 : redirects.find($8e98829722d37451$var$isSameOriginAndPathName)) !== null && _redirects_find !== void 0 ? _redirects_find : redirects === null || redirects === void 0 ? void 0 : redirects.find($8e98829722d37451$var$isTheSameDomain);
        var _redirects_find1;
        const redirectUrlFromDifferentOrigin = (_redirects_find1 = redirects === null || redirects === void 0 ? void 0 : redirects.find($8e98829722d37451$var$isHttps)) !== null && _redirects_find1 !== void 0 ? _redirects_find1 : redirects === null || redirects === void 0 ? void 0 : redirects.find($8e98829722d37451$var$isHttp);
        if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
        else if (redirectUrlFromDifferentOrigin) throw 0, $1b91ec72af99207f$export$c01b4acd6291e035;
        throw 0, $1b91ec72af99207f$export$60b68b138a52e5ae;
    }
}
// origin + pathname => https://example.com/app
const $8e98829722d37451$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(String(window.location.origin + (window.location.pathname || "/")));
// domain => outlook.live.com, github.com
const $8e98829722d37451$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $8e98829722d37451$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $8e98829722d37451$var$isHttps = (redirect)=>redirect.startsWith("https://");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $679d4e1e6384b92f$export$9adf33f0521751a3 = async (error)=>{
    (0, $226a063d0e4c5dea$export$bcb0b7a105a5df59)();
    await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).clearOAuthInflightData();
    (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signInWithRedirect_failure",
        data: {
            error: error
        }
    }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b9294710d0eaaeff$export$602253b28f67ef40 = async (authConfig)=>{
    try {
        (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
        (0, $00406059b8b03c2e$export$c13e6dbaf90a8e5f)(authConfig);
        (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig);
    } catch (_) {
        // no-op
        // This should not happen as Amplify singleton checks the oauth config key
        // unless the oauth config object doesn't contain required properties
        return;
    }
    // No inflight OAuth
    if (!await (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
    try {
        const currentUrl = window.location.href;
        const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
        const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType } = loginWith.oauth;
        const redirectUri = (0, $8e98829722d37451$export$93832c3affb240d3)(redirectSignIn);
        await (0, $97689c63f64ae65a$export$342f5c7ddb2087ec)({
            currentUrl: currentUrl,
            clientId: userPoolClientId,
            domain: domain,
            redirectUri: redirectUri,
            responseType: responseType,
            userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignInWithRedirect)
        });
    } catch (err) {
        await (0, $679d4e1e6384b92f$export$9adf33f0521751a3)(err);
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// attach the side effect for handling the completion of an inflight oauth flow
// this side effect works only on Web
(0, $f03cf65cfc38a977$export$4e09c449d6c407f7)() && (()=>{
    // add the listener to the singleton for triggering
    (0, $f4c06b47af4364f4$export$a3858a9a153cffc7)[0, $a16ab239475019f9$export$35210b3191d26437]((0, $b9294710d0eaaeff$export$602253b28f67ef40));
})();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $406fca4d9f20ea82$export$6893de5f4e1216c3 = {
    Google: "Google",
    Facebook: "Facebook",
    Amazon: "LoginWithAmazon",
    Apple: "SignInWithApple"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $96911686737d1008$export$a673d54799039714 = async (url)=>{
    var _window;
    if (!((_window = window) === null || _window === void 0 ? void 0 : _window.location)) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c50e9c939b7b9954$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($c50e9c939b7b9954$export$3cc5c71ef5f25e57 || ($c50e9c939b7b9954$export$3cc5c71ef5f25e57 = {}));
var $c50e9c939b7b9954$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$4327725e8bb80c51 || ($c50e9c939b7b9954$export$4327725e8bb80c51 = {}));
var $c50e9c939b7b9954$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$87a956d0b1b725a1 || ($c50e9c939b7b9954$export$87a956d0b1b725a1 = {}));
var $c50e9c939b7b9954$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$b86a388af82085af || ($c50e9c939b7b9954$export$b86a388af82085af = {}));
var $c50e9c939b7b9954$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$2ec29642a27fd055 || ($c50e9c939b7b9954$export$2ec29642a27fd055 = {}));
var $c50e9c939b7b9954$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$c6d546f0ab5ecb26 || ($c50e9c939b7b9954$export$c6d546f0ab5ecb26 = {}));
var $c50e9c939b7b9954$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$315864c77a135492 || ($c50e9c939b7b9954$export$315864c77a135492 = {}));
var $c50e9c939b7b9954$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$622cff54bc9a0bb0 || ($c50e9c939b7b9954$export$622cff54bc9a0bb0 = {}));
var $c50e9c939b7b9954$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$cedaef1e1242f8be || ($c50e9c939b7b9954$export$cedaef1e1242f8be = {}));
var $c50e9c939b7b9954$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$8d5b6b7a140e0c94 || ($c50e9c939b7b9954$export$8d5b6b7a140e0c94 = {}));
var $c50e9c939b7b9954$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($c50e9c939b7b9954$export$506f117795ed2bb2 || ($c50e9c939b7b9954$export$506f117795ed2bb2 = {}));
var $c50e9c939b7b9954$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($c50e9c939b7b9954$export$9bff15c85d75f437 || ($c50e9c939b7b9954$export$9bff15c85d75f437 = {}));
var $c50e9c939b7b9954$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$2a6bba23fbf84d1b || ($c50e9c939b7b9954$export$2a6bba23fbf84d1b = {}));
var $c50e9c939b7b9954$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($c50e9c939b7b9954$export$3f7e490ba4e0b71e || ($c50e9c939b7b9954$export$3f7e490ba4e0b71e = {}));
var $c50e9c939b7b9954$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$43ac0110dfdad33b || ($c50e9c939b7b9954$export$43ac0110dfdad33b = {}));
var $c50e9c939b7b9954$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$8807b62ddb0e4d9d || ($c50e9c939b7b9954$export$8807b62ddb0e4d9d = {}));
var $c50e9c939b7b9954$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$da9908386393628f || ($c50e9c939b7b9954$export$da9908386393628f = {}));
var $c50e9c939b7b9954$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$23ea34859d89459d || ($c50e9c939b7b9954$export$23ea34859d89459d = {}));
var $c50e9c939b7b9954$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($c50e9c939b7b9954$export$d0816902ed99fce6 || ($c50e9c939b7b9954$export$d0816902ed99fce6 = {}));
var $c50e9c939b7b9954$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$44cb15f260897376 || ($c50e9c939b7b9954$export$44cb15f260897376 = {}));
var $c50e9c939b7b9954$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$a974f64d24be573a || ($c50e9c939b7b9954$export$a974f64d24be573a = {}));
var $c50e9c939b7b9954$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$527caabb62d14fe3 || ($c50e9c939b7b9954$export$527caabb62d14fe3 = {}));
var $c50e9c939b7b9954$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$de57be1863bdb9d6 || ($c50e9c939b7b9954$export$de57be1863bdb9d6 = {}));
var $c50e9c939b7b9954$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($c50e9c939b7b9954$export$eb8cb06bdb07bf0c || ($c50e9c939b7b9954$export$eb8cb06bdb07bf0c = {}));
const $c50e9c939b7b9954$export$ecd3eb1722b48d26 = "SetUpTOTPException";






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $4b4afbe5c9cb9f15$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $c1c2568bac613fe8$export$195137955146d376)[name];
    if (!assertion) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}






var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b3ee0c7434af201f$export$91f349d78bea7765 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("InitiateAuth"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));







var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ca48faf2674d523e$export$11329f5ae466ab5d = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("RespondToAuthChallenge"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $67c783f15dbab9a2$export$cf5dd9429415aa98 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("VerifySoftwareToken"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $539fedaf8e7a5889$export$6bff32634453de2a = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("AssociateSoftwareToken"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));





var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

















var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Minutes until stored session invalidates is defaulted to 3 minutes
// to maintain parity with Amazon Cognito user pools API behavior
const $e8a04c319f6c75aa$var$MS_TO_EXPIRY = 180000;
const $e8a04c319f6c75aa$var$TGT_STATE = "CognitoSignInState";
const $e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS = {
    username: `${$e8a04c319f6c75aa$var$TGT_STATE}.username`,
    challengeName: `${$e8a04c319f6c75aa$var$TGT_STATE}.challengeName`,
    signInSession: `${$e8a04c319f6c75aa$var$TGT_STATE}.signInSession`,
    expiry: `${$e8a04c319f6c75aa$var$TGT_STATE}.expiry`
};
const $e8a04c319f6c75aa$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            $e8a04c319f6c75aa$export$f0d4bc0f1640c562({
                signInSession: action.value
            });
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                signInSession: action.value
            });
        case "SET_SIGN_IN_STATE":
            $e8a04c319f6c75aa$export$f0d4bc0f1640c562(action.value);
            return (0, $9tqwB._)({}, action.value);
        case "SET_CHALLENGE_NAME":
            $e8a04c319f6c75aa$export$f0d4bc0f1640c562({
                challengeName: action.value
            });
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                challengeName: action.value
            });
        case "SET_USERNAME":
            $e8a04c319f6c75aa$export$f0d4bc0f1640c562({
                username: action.value
            });
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                username: action.value
            });
        case "SET_INITIAL_STATE":
            return $e8a04c319f6c75aa$var$getInitialState();
        case "RESET_STATE":
            $e8a04c319f6c75aa$var$clearPersistedSignInState();
            return $e8a04c319f6c75aa$var$getDefaultState();
        // this state is never reachable
        default:
            return state;
    }
};
const $e8a04c319f6c75aa$var$isExpired = (expiryDate)=>{
    const expiryTimestamp = Number(expiryDate);
    const currentTimestamp = Date.now();
    return expiryTimestamp <= currentTimestamp;
};
const $e8a04c319f6c75aa$export$ddfd5a0262ce9df3 = ()=>{
    $e8a04c319f6c75aa$export$390d5da4c63a4a41.dispatch({
        type: "RESET_STATE"
    });
};
const $e8a04c319f6c75aa$var$clearPersistedSignInState = ()=>{
    for (const stateKey of Object.values($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS))(0, $6dd46fc26844509a$export$9015f19b74348a18).removeItem(stateKey);
};
const $e8a04c319f6c75aa$var$getDefaultState = ()=>({
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    });
// Hydrate signInStore from syncSessionStorage if the session has not expired
const $e8a04c319f6c75aa$var$getInitialState = ()=>{
    const expiry = (0, $6dd46fc26844509a$export$9015f19b74348a18).getItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.expiry);
    if (!expiry || $e8a04c319f6c75aa$var$isExpired(expiry)) {
        $e8a04c319f6c75aa$var$clearPersistedSignInState();
        return $e8a04c319f6c75aa$var$getDefaultState();
    }
    var _syncSessionStorage_getItem;
    const username = (_syncSessionStorage_getItem = (0, $6dd46fc26844509a$export$9015f19b74348a18).getItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.username)) !== null && _syncSessionStorage_getItem !== void 0 ? _syncSessionStorage_getItem : undefined;
    var _syncSessionStorage_getItem1;
    const challengeName = (_syncSessionStorage_getItem1 = (0, $6dd46fc26844509a$export$9015f19b74348a18).getItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.challengeName)) !== null && _syncSessionStorage_getItem1 !== void 0 ? _syncSessionStorage_getItem1 : undefined;
    var _syncSessionStorage_getItem2;
    const signInSession = (_syncSessionStorage_getItem2 = (0, $6dd46fc26844509a$export$9015f19b74348a18).getItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.signInSession)) !== null && _syncSessionStorage_getItem2 !== void 0 ? _syncSessionStorage_getItem2 : undefined;
    return {
        username: username,
        challengeName: challengeName,
        signInSession: signInSession
    };
};
const $e8a04c319f6c75aa$var$createStore = (reducer)=>{
    let currentState = reducer($e8a04c319f6c75aa$var$getDefaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $e8a04c319f6c75aa$export$390d5da4c63a4a41 = $e8a04c319f6c75aa$var$createStore($e8a04c319f6c75aa$var$signInReducer);
function $e8a04c319f6c75aa$export$bae72361b690e075(state) {
    $e8a04c319f6c75aa$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
// Save local state into Session Storage
const $e8a04c319f6c75aa$export$f0d4bc0f1640c562 = ({ challengeName: challengeName, signInSession: signInSession, username: username })=>{
    username && (0, $6dd46fc26844509a$export$9015f19b74348a18).setItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.username, username);
    challengeName && (0, $6dd46fc26844509a$export$9015f19b74348a18).setItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.challengeName, challengeName);
    if (signInSession) {
        (0, $6dd46fc26844509a$export$9015f19b74348a18).setItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.signInSession, signInSession);
        // Updates expiry when session is passed
        (0, $6dd46fc26844509a$export$9015f19b74348a18).setItem($e8a04c319f6c75aa$var$SIGN_IN_STATE_KEYS.expiry, String(Date.now() + $e8a04c319f6c75aa$var$MS_TO_EXPIRY));
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $324eca59b34c4499$export$f71adf3ff8fcbbf8 = "Passkeys may not be supported on this device. Ensure your application is running in a secure context (HTTPS) and Web Authentication API is supported.";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $5e5c17781eec8a08$export$bf0fd5fd31fb5a90 extends (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $5e5c17781eec8a08$export$bf0fd5fd31fb5a90;
        Object.setPrototypeOf(this, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90.prototype);
    }
}
var $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e;
(function(PasskeyErrorCode) {
    // not supported
    PasskeyErrorCode["PasskeyNotSupported"] = "PasskeyNotSupported";
    // duplicate passkey
    PasskeyErrorCode["PasskeyAlreadyExists"] = "PasskeyAlreadyExists";
    // misconfigurations
    PasskeyErrorCode["InvalidPasskeyRegistrationOptions"] = "InvalidPasskeyRegistrationOptions";
    PasskeyErrorCode["InvalidPasskeyAuthenticationOptions"] = "InvalidPasskeyAuthenticationOptions";
    PasskeyErrorCode["RelyingPartyMismatch"] = "RelyingPartyMismatch";
    // failed credential creation / retrieval
    PasskeyErrorCode["PasskeyRegistrationFailed"] = "PasskeyRegistrationFailed";
    PasskeyErrorCode["PasskeyRetrievalFailed"] = "PasskeyRetrievalFailed";
    // cancel / aborts
    PasskeyErrorCode["PasskeyRegistrationCanceled"] = "PasskeyRegistrationCanceled";
    PasskeyErrorCode["PasskeyAuthenticationCanceled"] = "PasskeyAuthenticationCanceled";
    PasskeyErrorCode["PasskeyOperationAborted"] = "PasskeyOperationAborted";
})($5e5c17781eec8a08$export$8c9a5e3ce7fcf74e || ($5e5c17781eec8a08$export$8c9a5e3ce7fcf74e = {}));
const $5e5c17781eec8a08$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION = "User may have canceled the ceremony or another interruption has occurred. Check underlying error for details.";
const $5e5c17781eec8a08$var$MISCONFIGURATION_RECOVERY_SUGGESTION = "Ensure your user pool is configured to support the WEB_AUTHN as an authentication factor.";
const $5e5c17781eec8a08$export$e6bc9bceb73ec912 = {
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyNotSupported]: {
        message: "Passkeys may not be supported on this device.",
        recoverySuggestion: (0, $324eca59b34c4499$export$f71adf3ff8fcbbf8)
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.InvalidPasskeyRegistrationOptions]: {
        message: "Invalid passkey registration options.",
        recoverySuggestion: $5e5c17781eec8a08$var$MISCONFIGURATION_RECOVERY_SUGGESTION
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.InvalidPasskeyAuthenticationOptions]: {
        message: "Invalid passkey authentication options.",
        recoverySuggestion: $5e5c17781eec8a08$var$MISCONFIGURATION_RECOVERY_SUGGESTION
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyRegistrationFailed]: {
        message: "Device failed to create passkey.",
        recoverySuggestion: (0, $324eca59b34c4499$export$f71adf3ff8fcbbf8)
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyRetrievalFailed]: {
        message: "Device failed to retrieve passkey.",
        recoverySuggestion: "Passkeys may not be available on this device. Try an alternative authentication factor like PASSWORD, EMAIL_OTP, or SMS_OTP."
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyAlreadyExists]: {
        message: "Passkey already exists in authenticator.",
        recoverySuggestion: "Proceed with existing passkey or try again after deleting the credential."
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyRegistrationCanceled]: {
        message: "Passkey registration ceremony has been canceled.",
        recoverySuggestion: $5e5c17781eec8a08$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyAuthenticationCanceled]: {
        message: "Passkey authentication ceremony has been canceled.",
        recoverySuggestion: $5e5c17781eec8a08$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.PasskeyOperationAborted]: {
        message: "Passkey operation has been aborted.",
        recoverySuggestion: $5e5c17781eec8a08$var$ABORT_OR_CANCEL_RECOVERY_SUGGESTION
    },
    [$5e5c17781eec8a08$export$8c9a5e3ce7fcf74e.RelyingPartyMismatch]: {
        message: "Relying party does not match current domain.",
        recoverySuggestion: "Ensure relying party identifier matches current domain."
    }
};
const $5e5c17781eec8a08$export$3145abf24cf8a54e = (0, $1a3126fc0ddd4d4c$export$5cb8fc27ccbe9d40)($5e5c17781eec8a08$export$e6bc9bceb73ec912, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles Overlapping Passkey Errors Between Registration & Authentication
 * https://w3c.github.io/webauthn/#sctn-create-request-exceptions
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $575c2d8bc79ca685$export$4792b205fc9bc457 = (err)=>{
    if (err instanceof Error) {
        // Passkey Operation Aborted
        if (err.name === "AbortError") {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $5e5c17781eec8a08$export$e6bc9bceb73ec912)[(0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyOperationAborted];
            return new (0, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90)({
                name: (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyOperationAborted,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
        // Relying Party / Domain Mismatch
        if (err.name === "SecurityError") {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $5e5c17781eec8a08$export$e6bc9bceb73ec912)[(0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).RelyingPartyMismatch];
            return new (0, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90)({
                name: (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).RelyingPartyMismatch,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return new (0, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90)({
        name: (0, $81e4e4d475446781$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: err
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handle Passkey Authentication Errors
 * https://w3c.github.io/webauthn/#sctn-get-request-exceptions
 *
 * @param err unknown
 * @returns PasskeyError
 */ const $1a3bd6c7272571b6$export$6abde9ceb8dfddc0 = (err)=>{
    if (err instanceof (0, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90)) return err;
    if (err instanceof Error) {
        if (err.name === "NotAllowedError") {
            const { message: message, recoverySuggestion: recoverySuggestion } = (0, $5e5c17781eec8a08$export$e6bc9bceb73ec912)[(0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyAuthenticationCanceled];
            return new (0, $5e5c17781eec8a08$export$bf0fd5fd31fb5a90)({
                name: (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyAuthenticationCanceled,
                message: message,
                recoverySuggestion: recoverySuggestion,
                underlyingError: err
            });
        }
    }
    return (0, $575c2d8bc79ca685$export$4792b205fc9bc457)(err);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if passkey is supported in current context
 * Will return false if executed in non-secure context
 * @returns boolean
 */ const $bedc3c3a784a4128$export$3b0e0bb0e9c22c1a = ()=>{
    return (0, $f03cf65cfc38a977$export$4e09c449d6c407f7)() && window.isSecureContext && "credentials" in navigator && typeof window.PublicKeyCredential === "function";
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7e561ee2cf9b35d4$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2a5c07bb3584dd50$export$695b149896bd3e2a = {
    /**
     * Convert input to base64-encoded string
     * @param input - string to convert to base64
     * @param options - encoding options that can optionally produce a base64url string
     * @returns base64-encoded string
     */ convert (input, options = {
        urlSafe: false,
        skipPadding: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $7e561ee2cf9b35d4$export$7c746b75f47c9c7d)(input);
        let encodedStr = (0, $fb45fae2ab4b72c3$export$94f295707b435c6d)()(inputStr);
        // urlSafe char replacement and skipPadding options conform to the base64url spec
        // https://datatracker.ietf.org/doc/html/rfc4648#section-5
        if (options.urlSafe) encodedStr = encodedStr.replace(/\+/g, "-").replace(/\//g, "_");
        if (options.skipPadding) encodedStr = encodedStr.replace(/=/g, "");
        return encodedStr;
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// https://datatracker.ietf.org/doc/html/rfc4648#page-7
/**
 * Converts an ArrayBuffer to a base64url encoded string
 * @param buffer - the ArrayBuffer instance of a Uint8Array
 * @returns string - a base64url encoded string
 */ const $449051eee18e51c5$export$442d4feb149fcd32 = (buffer)=>{
    return (0, $2a5c07bb3584dd50$export$695b149896bd3e2a).convert(new Uint8Array(buffer), {
        urlSafe: true,
        skipPadding: true
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a base64url encoded string to an ArrayBuffer
 * @param base64url - a base64url encoded string
 * @returns ArrayBuffer
 */ const $5f30d640ed5933f7$export$9cebd483a59f0168 = (base64url)=>{
    return Uint8Array.from((0, $a8960aab2348443e$export$1e303d38dab7b376).convert(base64url, {
        urlSafe: true
    }), (x)=>x.charCodeAt(0)).buffer;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Deserializes Public Key Credential Creation Options JSON
 * @param input PasskeyCreateOptionsJson
 * @returns PublicKeyCredentialCreationOptions
 */ const $c7bd13cfccb00c51$export$a8f43933ee13e976 = (input)=>{
    const userIdBuffer = (0, $5f30d640ed5933f7$export$9cebd483a59f0168)(input.user.id);
    const challengeBuffer = (0, $5f30d640ed5933f7$export$9cebd483a59f0168)(input.challenge);
    const excludeCredentialsWithBuffer = (input.excludeCredentials || []).map((excludeCred)=>(0, $2qxEV._)((0, $9tqwB._)({}, excludeCred), {
            id: (0, $5f30d640ed5933f7$export$9cebd483a59f0168)(excludeCred.id)
        }));
    return (0, $2qxEV._)((0, $9tqwB._)({}, input), {
        excludeCredentials: excludeCredentialsWithBuffer,
        challenge: challengeBuffer,
        user: (0, $2qxEV._)((0, $9tqwB._)({}, input.user), {
            id: userIdBuffer
        })
    });
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyCreateResult
 * @returns PasskeyCreateResultJson
 */ const $c7bd13cfccb00c51$export$f686d838e2fa9da3 = (input)=>{
    const response = {
        clientDataJSON: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.clientDataJSON),
        attestationObject: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.attestationObject),
        transports: input.response.getTransports(),
        publicKeyAlgorithm: input.response.getPublicKeyAlgorithm(),
        authenticatorData: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.getAuthenticatorData())
    };
    const publicKey = input.response.getPublicKey();
    if (publicKey) response.publicKey = (0, $449051eee18e51c5$export$442d4feb149fcd32)(publicKey);
    const resultJson = {
        type: input.type,
        id: input.id,
        rawId: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.rawId),
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};
/**
 * Deserializes Public Key Credential Get Options JSON
 * @param input PasskeyGetOptionsJson
 * @returns PublicKeyCredentialRequestOptions
 */ const $c7bd13cfccb00c51$export$d3f47ce866c52e8e = (input)=>{
    const challengeBuffer = (0, $5f30d640ed5933f7$export$9cebd483a59f0168)(input.challenge);
    const allowedCredentialsWithBuffer = (input.allowCredentials || []).map((allowedCred)=>(0, $2qxEV._)((0, $9tqwB._)({}, allowedCred), {
            id: (0, $5f30d640ed5933f7$export$9cebd483a59f0168)(allowedCred.id)
        }));
    return (0, $2qxEV._)((0, $9tqwB._)({}, input), {
        challenge: challengeBuffer,
        allowCredentials: allowedCredentialsWithBuffer
    });
};
/**
 * Serializes a Public Key Credential With Attestation to JSON
 * @param input PasskeyGetResult
 * @returns PasskeyGetResultJson
 */ const $c7bd13cfccb00c51$export$1f22b133ac0d2a5 = (input)=>{
    const response = {
        clientDataJSON: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.clientDataJSON),
        authenticatorData: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.authenticatorData),
        signature: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.signature)
    };
    if (input.response.userHandle) response.userHandle = (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.response.userHandle);
    const resultJson = {
        id: input.id,
        rawId: (0, $449051eee18e51c5$export$442d4feb149fcd32)(input.rawId),
        type: input.type,
        clientExtensionResults: input.getClientExtensionResults(),
        response: response
    };
    if (input.authenticatorAttachment) resultJson.authenticatorAttachment = input.authenticatorAttachment;
    return resultJson;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $fe8fffba3e875c5a$export$c7806094d9c936a2(credential) {
    (0, $5e5c17781eec8a08$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAttestationResponse, (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyRegistrationFailed);
}
function $fe8fffba3e875c5a$export$4f19e511a89efed7(credential) {
    (0, $5e5c17781eec8a08$export$3145abf24cf8a54e)(credential && credential instanceof PublicKeyCredential && credential.response instanceof AuthenticatorAssertionResponse, (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyRetrievalFailed);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $166deef587b2a0d3$export$d7f92bd7f1e366c1 = async (input)=>{
    try {
        const isPasskeySupported = (0, $bedc3c3a784a4128$export$3b0e0bb0e9c22c1a)();
        (0, $5e5c17781eec8a08$export$3145abf24cf8a54e)(isPasskeySupported, (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).PasskeyNotSupported);
        const passkeyGetOptions = (0, $c7bd13cfccb00c51$export$d3f47ce866c52e8e)(input);
        const credential = await navigator.credentials.get({
            publicKey: passkeyGetOptions
        });
        (0, $fe8fffba3e875c5a$export$4f19e511a89efed7)(credential);
        return (0, $c7bd13cfccb00c51$export$1f22b133ac0d2a5)(credential);
    } catch (err) {
        throw (0, $1a3bd6c7272571b6$export$6abde9ceb8dfddc0)(err);
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Retrieves the device name using the User-Agent Client Hints API if available,
 * falling back to the traditional userAgent string if not.
 *
 * @returns {Promise<string>} A promise that resolves with a string representing the device name.
 *
 * Example Output:
 * navigator.userAgentData:
 *   'macOS 14.2.1 arm macOS Not A(Brand/99.0.0.0;Google Chrome/121.0.6167.160;Chromium/121.0.6167.160'
 * navigator.userAgent:
 *   'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/115.0'
 */ const $f5699ab0dcc1c3cc$export$98f0aedb14d75123 = async ()=>{
    const { userAgentData: userAgentData } = navigator;
    if (!userAgentData) return navigator.userAgent;
    const { platform: platform = "", platformVersion: platformVersion = "", model: model = "", architecture: architecture = "", fullVersionList: fullVersionList = [] } = await userAgentData.getHighEntropyValues([
        "platform",
        "platformVersion",
        "architecture",
        "model",
        "fullVersionList"
    ]);
    const versionList = fullVersionList.map((v)=>`${v.brand}/${v.version}`).join(";");
    const deviceName = [
        platform,
        platformVersion,
        architecture,
        model,
        platform,
        versionList
    ].filter((value)=>value).join(" ");
    return deviceName || navigator.userAgent;
};










var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $dede816a99b5b0dd$export$d88a63af6351a7c3 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("ConfirmDevice"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f95178834757fb76$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};


/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $74bc4d6b1fa7d633$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $74bc4d6b1fa7d633$var$nbi() {
    return new $74bc4d6b1fa7d633$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $74bc4d6b1fa7d633$var$dbits;
// JavaScript engine analysis
const $74bc4d6b1fa7d633$var$canary = 0xdeadbeefcafe;
const $74bc4d6b1fa7d633$var$j_lm = ($74bc4d6b1fa7d633$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $74bc4d6b1fa7d633$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $74bc4d6b1fa7d633$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $74bc4d6b1fa7d633$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $74bc4d6b1fa7d633$var$inBrowser = typeof navigator !== "undefined";
if ($74bc4d6b1fa7d633$var$inBrowser && $74bc4d6b1fa7d633$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.am = $74bc4d6b1fa7d633$var$am2;
    $74bc4d6b1fa7d633$var$dbits = 30;
} else if ($74bc4d6b1fa7d633$var$inBrowser && $74bc4d6b1fa7d633$var$j_lm && navigator.appName !== "Netscape") {
    $74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.am = $74bc4d6b1fa7d633$var$am1;
    $74bc4d6b1fa7d633$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.am = $74bc4d6b1fa7d633$var$am3;
    $74bc4d6b1fa7d633$var$dbits = 28;
}
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.DB = $74bc4d6b1fa7d633$var$dbits;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.DM = (1 << $74bc4d6b1fa7d633$var$dbits) - 1;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.DV = 1 << $74bc4d6b1fa7d633$var$dbits;
const $74bc4d6b1fa7d633$var$BI_FP = 52;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $74bc4d6b1fa7d633$var$BI_FP);
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.F1 = $74bc4d6b1fa7d633$var$BI_FP - $74bc4d6b1fa7d633$var$dbits;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.F2 = 2 * $74bc4d6b1fa7d633$var$dbits - $74bc4d6b1fa7d633$var$BI_FP;
// Digit conversions
const $74bc4d6b1fa7d633$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $74bc4d6b1fa7d633$var$BI_RC = [];
let $74bc4d6b1fa7d633$var$rr, $74bc4d6b1fa7d633$var$vv;
$74bc4d6b1fa7d633$var$rr = "0".charCodeAt(0);
for($74bc4d6b1fa7d633$var$vv = 0; $74bc4d6b1fa7d633$var$vv <= 9; ++$74bc4d6b1fa7d633$var$vv)$74bc4d6b1fa7d633$var$BI_RC[$74bc4d6b1fa7d633$var$rr++] = $74bc4d6b1fa7d633$var$vv;
$74bc4d6b1fa7d633$var$rr = "a".charCodeAt(0);
for($74bc4d6b1fa7d633$var$vv = 10; $74bc4d6b1fa7d633$var$vv < 36; ++$74bc4d6b1fa7d633$var$vv)$74bc4d6b1fa7d633$var$BI_RC[$74bc4d6b1fa7d633$var$rr++] = $74bc4d6b1fa7d633$var$vv;
$74bc4d6b1fa7d633$var$rr = "A".charCodeAt(0);
for($74bc4d6b1fa7d633$var$vv = 10; $74bc4d6b1fa7d633$var$vv < 36; ++$74bc4d6b1fa7d633$var$vv)$74bc4d6b1fa7d633$var$BI_RC[$74bc4d6b1fa7d633$var$rr++] = $74bc4d6b1fa7d633$var$vv;
function $74bc4d6b1fa7d633$var$int2char(n) {
    return $74bc4d6b1fa7d633$var$BI_RM.charAt(n);
}
function $74bc4d6b1fa7d633$var$intAt(s, i) {
    const c = $74bc4d6b1fa7d633$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $74bc4d6b1fa7d633$var$bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $74bc4d6b1fa7d633$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $74bc4d6b1fa7d633$var$nbv(i) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $74bc4d6b1fa7d633$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = $74bc4d6b1fa7d633$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $74bc4d6b1fa7d633$var$bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $74bc4d6b1fa7d633$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = "";
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $74bc4d6b1fa7d633$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $74bc4d6b1fa7d633$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $74bc4d6b1fa7d633$var$bnNegate() {
    const r = $74bc4d6b1fa7d633$var$nbi();
    $74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $74bc4d6b1fa7d633$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $74bc4d6b1fa7d633$var$bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $74bc4d6b1fa7d633$var$nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $74bc4d6b1fa7d633$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $74bc4d6b1fa7d633$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $74bc4d6b1fa7d633$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $74bc4d6b1fa7d633$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $74bc4d6b1fa7d633$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $74bc4d6b1fa7d633$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $74bc4d6b1fa7d633$var$bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $74bc4d6b1fa7d633$var$bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $74bc4d6b1fa7d633$var$bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $74bc4d6b1fa7d633$var$bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $74bc4d6b1fa7d633$var$nbi();
    const y = $74bc4d6b1fa7d633$var$nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - $74bc4d6b1fa7d633$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? $74bc4d6b1fa7d633$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $74bc4d6b1fa7d633$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $74bc4d6b1fa7d633$var$bnMod(a) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $74bc4d6b1fa7d633$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $74bc4d6b1fa7d633$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $74bc4d6b1fa7d633$var$bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $74bc4d6b1fa7d633$var$bnAdd(a) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $74bc4d6b1fa7d633$var$bnSubtract(a) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $74bc4d6b1fa7d633$var$bnMultiply(a) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $74bc4d6b1fa7d633$var$bnDivide(a) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $74bc4d6b1fa7d633$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $74bc4d6b1fa7d633$var$montConvert(x) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $74bc4d6b1fa7d633$var$montRevert(x) {
    const r = $74bc4d6b1fa7d633$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $74bc4d6b1fa7d633$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $74bc4d6b1fa7d633$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $74bc4d6b1fa7d633$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$74bc4d6b1fa7d633$var$Montgomery.prototype.convert = $74bc4d6b1fa7d633$var$montConvert;
$74bc4d6b1fa7d633$var$Montgomery.prototype.revert = $74bc4d6b1fa7d633$var$montRevert;
$74bc4d6b1fa7d633$var$Montgomery.prototype.reduce = $74bc4d6b1fa7d633$var$montReduce;
$74bc4d6b1fa7d633$var$Montgomery.prototype.mulTo = $74bc4d6b1fa7d633$var$montMulTo;
$74bc4d6b1fa7d633$var$Montgomery.prototype.sqrTo = $74bc4d6b1fa7d633$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $74bc4d6b1fa7d633$var$bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = $74bc4d6b1fa7d633$var$nbv(1);
    const z = new $74bc4d6b1fa7d633$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $74bc4d6b1fa7d633$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $74bc4d6b1fa7d633$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = $74bc4d6b1fa7d633$var$nbi();
    let t;
    i = $74bc4d6b1fa7d633$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.copyTo = $74bc4d6b1fa7d633$var$bnpCopyTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.fromInt = $74bc4d6b1fa7d633$var$bnpFromInt;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.fromString = $74bc4d6b1fa7d633$var$bnpFromString;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.clamp = $74bc4d6b1fa7d633$var$bnpClamp;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.dlShiftTo = $74bc4d6b1fa7d633$var$bnpDLShiftTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.drShiftTo = $74bc4d6b1fa7d633$var$bnpDRShiftTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.lShiftTo = $74bc4d6b1fa7d633$var$bnpLShiftTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.rShiftTo = $74bc4d6b1fa7d633$var$bnpRShiftTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.subTo = $74bc4d6b1fa7d633$var$bnpSubTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.multiplyTo = $74bc4d6b1fa7d633$var$bnpMultiplyTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.squareTo = $74bc4d6b1fa7d633$var$bnpSquareTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.divRemTo = $74bc4d6b1fa7d633$var$bnpDivRemTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.invDigit = $74bc4d6b1fa7d633$var$bnpInvDigit;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.addTo = $74bc4d6b1fa7d633$var$bnpAddTo;
// public
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.toString = $74bc4d6b1fa7d633$var$bnToString;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.negate = $74bc4d6b1fa7d633$var$bnNegate;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.abs = $74bc4d6b1fa7d633$var$bnAbs;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.compareTo = $74bc4d6b1fa7d633$var$bnCompareTo;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.bitLength = $74bc4d6b1fa7d633$var$bnBitLength;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.mod = $74bc4d6b1fa7d633$var$bnMod;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.equals = $74bc4d6b1fa7d633$var$bnEquals;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.add = $74bc4d6b1fa7d633$var$bnAdd;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.subtract = $74bc4d6b1fa7d633$var$bnSubtract;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.multiply = $74bc4d6b1fa7d633$var$bnMultiply;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.divide = $74bc4d6b1fa7d633$var$bnDivide;
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.prototype.modPow = $74bc4d6b1fa7d633$var$bnModPow;
// "constants"
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.ZERO = $74bc4d6b1fa7d633$var$nbv(0);
$74bc4d6b1fa7d633$export$2e2bcd8739ae039.ONE = $74bc4d6b1fa7d633$var$nbv(1);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $41365a74efffa187$export$f7340100dd3acd38 = async ({ a: a, g: g, k: k, x: x, B: B, N: N, U: U })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $48f1aab8f164ad0c$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $48f1aab8f164ad0c$export$a0f75f7d2f3bd702 = {};
const $48f1aab8f164ad0c$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $48f1aab8f164ad0c$export$a0f75f7d2f3bd702[i] = encodedByte;
    $48f1aab8f164ad0c$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $541c952574382f90$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $48f1aab8f164ad0c$export$fcb552daf117d7e3)) out[i / 2] = (0, $48f1aab8f164ad0c$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};



/**
 * @internal
 */ var $09222c3d1bf83c71$export$b2e3d6d444266a5c = 64;
var $09222c3d1bf83c71$export$d7bd469488748c5f = 32;
var $09222c3d1bf83c71$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $09222c3d1bf83c71$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $09222c3d1bf83c71$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $4e78d68c30404642$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $09222c3d1bf83c71$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $09222c3d1bf83c71$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c) >= (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $09222c3d1bf83c71$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $09222c3d1bf83c71$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $09222c3d1bf83c71$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $09222c3d1bf83c71$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3753986e01e3c7b8$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $81242077108c816e$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $3753986e01e3c7b8$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $ccf4d147411369cf$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};





var $bdjQ6 = parcelRequire("bdjQ6");
var $b6f1a1b82263e9a4$require$Buffer = $bdjQ6.Buffer;
// Quick polyfill
var $b6f1a1b82263e9a4$var$fromUtf8 = typeof $b6f1a1b82263e9a4$require$Buffer !== "undefined" && $b6f1a1b82263e9a4$require$Buffer.from ? function(input) {
    return $b6f1a1b82263e9a4$require$Buffer.from(input, "utf8");
} : (0, $3753986e01e3c7b8$export$c7c5cef950a4d2fc);
function $b6f1a1b82263e9a4$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $b6f1a1b82263e9a4$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $bcd460cf93d8dc24$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d94f5ab87bcb3e7b$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $88e3d0fc198076f7$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $5cca8895dd9e2955$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $4e78d68c30404642$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $bcd460cf93d8dc24$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $b6f1a1b82263e9a4$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $1e2082910c54650f$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $1e2082910c54650f$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $4e78d68c30404642$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $4e78d68c30404642$export$aab6bc1ad3c77a42)();
            var inner = $5cca8895dd9e2955$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $09222c3d1bf83c71$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $5cca8895dd9e2955$var$bufferFromSecret(secret) {
    var input = (0, $b6f1a1b82263e9a4$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $09222c3d1bf83c71$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $4e78d68c30404642$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $09222c3d1bf83c71$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $650e9b97a5b40413$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $48f1aab8f164ad0c$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $5172da6400a82de1$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $5cca8895dd9e2955$export$3b58ea8124ac5e28)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $650e9b97a5b40413$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $eb7ebb24f13fa7cc$export$8b112e065a8843a = (hexStr)=>(0, $5172da6400a82de1$export$629ee8d7d3ebacd1)((0, $541c952574382f90$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $5663c7f8e9c77fab$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $5663c7f8e9c77fab$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $5663c7f8e9c77fab$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $bdec25d33cc7a77b$export$e2f40082638513e7 = ({ A: A, B: B })=>{
    const U = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)((0, $eb7ebb24f13fa7cc$export$8b112e065a8843a)((0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(A) + (0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $c48a9b49f5f57a84$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $5cca8895dd9e2955$export$3b58ea8124ac5e28)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $5cca8895dd9e2955$export$3b58ea8124ac5e28)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $c37fd20bcea80132$export$d265930babe23ca5() {
    const crypto = (0, $fb45fae2ab4b72c3$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $0d63d4f005675d13$var$hexStringify(wordArray) {
    // Shortcuts
    const { words: words } = wordArray;
    const { sigBytes: sigBytes } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $0d63d4f005675d13$export$4cd4919e303276a6 {
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $c37fd20bcea80132$export$d265930babe23ca5)());
        return new $0d63d4f005675d13$export$4cd4919e303276a6(words, nBytes);
    }
    toString() {
        return $0d63d4f005675d13$var$hexStringify(this);
    }
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $de67650860fcc095$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $0d63d4f005675d13$export$4cd4919e303276a6)().random(nBytes).toString();
    return (0, $541c952574382f90$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $cf22c8abaee41e9b$export$8c487394e1c35fbe = ()=>(0, $2a5c07bb3584dd50$export$695b149896bd3e2a).convert((0, $de67650860fcc095$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $dce192301c45bf88$export$2e2bcd8739ae039 {
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $cf22c8abaee41e9b$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $5172da6400a82de1$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $650e9b97a5b40413$export$22a20ab34c1d7a2b)((0, $de67650860fcc095$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)((0, $eb7ebb24f13fa7cc$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username, password: password, serverBValue: serverBValue, salt: salt }) {
        if (serverBValue.mod(this.N).equals((0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $bdec25d33cc7a77b$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $5172da6400a82de1$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)((0, $eb7ebb24f13fa7cc$export$8b112e065a8843a)((0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $41365a74efffa187$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $c48a9b49f5f57a84$export$295a0a5429217d03)((0, $541c952574382f90$export$b772e43c3daf2e7a)((0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(S)), (0, $541c952574382f90$export$b772e43c3daf2e7a)((0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
    constructor({ userPoolName: userPoolName, a: a, g: g, A: A, N: N }){
        this.encoder = (0, $f95178834757fb76$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)((0, $eb7ebb24f13fa7cc$export$8b112e065a8843a)(`${(0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(N)}${(0, $5663c7f8e9c77fab$export$35d4ea07514a0402)(g)}`), 16);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $efe818b2b4185599$export$53a55138f9e96c65 = async ({ a: a, g: g, N: N })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $9de705fddefabf6c$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)((0, $48f1aab8f164ad0c$export$baab4dd8c7240846), 16);
    const g = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)("2", 16);
    const a = $9de705fddefabf6c$var$generateRandomBigInteger();
    const A = await (0, $efe818b2b4185599$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $dce192301c45bf88$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $9de705fddefabf6c$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $650e9b97a5b40413$export$22a20ab34c1d7a2b)((0, $de67650860fcc095$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(hexRandom, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $5614e270d557967c$export$548ed8ad974a8b30({ userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint, newDeviceMetadata: newDeviceMetadata, accessToken: accessToken }) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $9de705fddefabf6c$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata === null || newDeviceMetadata === void 0 ? void 0 : newDeviceMetadata.DeviceKey;
    const deviceGroupKey = newDeviceMetadata === null || newDeviceMetadata === void 0 ? void 0 : newDeviceMetadata.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey !== null && deviceGroupKey !== void 0 ? deviceGroupKey : "", deviceKey !== null && deviceKey !== void 0 ? deviceKey : "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $2a5c07bb3584dd50$export$695b149896bd3e2a).convert((0, $541c952574382f90$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $2a5c07bb3584dd50$export$695b149896bd3e2a).convert((0, $541c952574382f90$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        const confirmDevice = (0, $dede816a99b5b0dd$export$d88a63af6351a7c3)({
            endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await confirmDevice({
            region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceName: await (0, $f5699ab0dcc1c3cc$export$98f0aedb14d75123)(),
            DeviceKey: newDeviceMetadata === null || newDeviceMetadata === void 0 ? void 0 : newDeviceMetadata.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $f034a6258d9140be$export$77701654924537aa(challengeParameters) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { username: username, signInSession: signInSession, signInDetails: signInDetails, challengeName: challengeName } = (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).getState();
    if (challengeName !== "WEB_AUTHN" || !username) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
        message: "Unable to proceed due to invalid sign in state."
    });
    const { CREDENTIAL_REQUEST_OPTIONS: credentialRequestOptions } = challengeParameters;
    (0, $5e5c17781eec8a08$export$3145abf24cf8a54e)(!!credentialRequestOptions, (0, $5e5c17781eec8a08$export$8c9a5e3ce7fcf74e).InvalidPasskeyAuthenticationOptions);
    const cred = await (0, $166deef587b2a0d3$export$d7f92bd7f1e366c1)(JSON.parse(credentialRequestOptions));
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: authConfig.userPoolEndpoint
        })
    });
    const { ChallengeName: nextChallengeName, ChallengeParameters: nextChallengeParameters, AuthenticationResult: authenticationResult, Session: nextSession } = await respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "WEB_AUTHN",
        ChallengeResponses: {
            USERNAME: username,
            CREDENTIAL: JSON.stringify(cred)
        },
        ClientId: authConfig.userPoolClientId,
        Session: signInSession
    });
    (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
        signInSession: nextSession,
        username: username,
        challengeName: nextChallengeName,
        signInDetails: signInDetails
    });
    if (authenticationResult) {
        await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({}, authenticationResult), {
            username: username,
            NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                userPoolId: authConfig.userPoolId,
                userPoolEndpoint: authConfig.userPoolEndpoint,
                newDeviceMetadata: authenticationResult.NewDeviceMetadata,
                accessToken: authenticationResult.AccessToken
            }),
            signInDetails: signInDetails
        }));
        (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).dispatch({
            type: "RESET_STATE"
        });
        await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
        return {
            isSignedIn: true,
            nextStep: {
                signInStep: "DONE"
            }
        };
    }
    if (nextChallengeName === "WEB_AUTHN") throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
        message: "Sequential WEB_AUTHN challenges returned from underlying service cannot be handled."
    });
    return {
        challengeName: nextChallengeName,
        challengeParameters: nextChallengeParameters
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $7c70435f691a9a82$export$b6e6cdd1f90faa62({ username: username, userPoolId: userPoolId, userPoolClientId: userPoolClientId }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}

































// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $18da15b897d645fc$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $18da15b897d645fc$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $18da15b897d645fc$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $18da15b897d645fc$var$WEEK_NAMES[now.getUTCDay()];
    const month = $18da15b897d645fc$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c607c76eebac7770$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName, username: username, challengeParameters: challengeParameters, dateNow: dateNow, hkdf: hkdf })=>{
    const bufUPIDaToB = (0, $f95178834757fb76$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $f95178834757fb76$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $c607c76eebac7770$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $f95178834757fb76$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $5cca8895dd9e2955$export$3b58ea8124ac5e28)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $2a5c07bb3584dd50$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $c607c76eebac7770$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = (0, $a8960aab2348443e$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};






















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $dbc9be1bca2f75ed$export$18ec6b77c0b7fafe({ username: username, config: config, clientMetadata: clientMetadata, session: session, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    (0, $2cc7ae0cece9bbf8$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $9de705fddefabf6c$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: respondedChallengeParameters, Session: Session } = await respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    return $dbc9be1bca2f75ed$var$handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $dbc9be1bca2f75ed$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint }, tokenOrchestrator) {
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    (0, $2cc7ae0cece9bbf8$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SRP_B, 16);
    const salt = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SALT, 16);
    const { deviceKey: deviceKey } = deviceMetadata;
    const { deviceGroupKey: deviceGroupKey } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $18da15b897d645fc$export$218a6e05f05aec48)();
    var _challengeParameters_USERNAME;
    const challengeResponses = {
        USERNAME: (_challengeParameters_USERNAME = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USERNAME) !== null && _challengeParameters_USERNAME !== void 0 ? _challengeParameters_USERNAME : username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $c607c76eebac7770$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $53a8fc9ce86c8568$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = (userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split("_")[1]) || "";
    const serverBValue = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SRP_B, 16);
    const salt = new (0, $74bc4d6b1fa7d633$export$2e2bcd8739ae039)(challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SALT, 16);
    const username = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USER_ID_FOR_SRP;
    if (!username) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $18da15b897d645fc$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $c607c76eebac7770$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return (0, $dbc9be1bca2f75ed$export$18ec6b77c0b7fafe)({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $e853d20a14477d8a$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $e7e74a7b684b93e5$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $c27678b2936e095f$export$fecfbc200868d412(username) {
    const { dispatch: dispatch } = (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the Password SRP (Secure Remote Password) authentication flow.
 * This function can be used with both USER_SRP_AUTH and USER_AUTH flows.
 *
 * @param {Object} params - The parameters for the Password SRP authentication
 * @param {string} params.username - The username for authentication
 * @param {string} params.password - The user's password
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Token orchestrator for managing auth tokens
 * @param {AuthFlowType} params.authFlow - The type of authentication flow ('USER_SRP_AUTH' or 'USER_AUTH')
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred challenge type when using USER_AUTH flow
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The authentication response
 */ async function $fbaf2806080f0546$export$169bd15774e46c56({ username: username, password: password, clientMetadata: clientMetadata, config: config, tokenOrchestrator: tokenOrchestrator, authFlow: authFlow, preferredChallenge: preferredChallenge }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = (userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split("_")[1]) || "";
    const authenticationHelper = await (0, $9de705fddefabf6c$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    if (authFlow === "USER_AUTH" && preferredChallenge) authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: authFlow,
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $b3ee0c7434af201f$export$91f349d78bea7765)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const resp = await initiateAuth({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters, Session: session } = resp;
    var _challengeParameters_USERNAME;
    const activeUsername = (_challengeParameters_USERNAME = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USERNAME) !== null && _challengeParameters_USERNAME !== void 0 ? _challengeParameters_USERNAME : username;
    (0, $c27678b2936e095f$export$fecfbc200868d412)(activeUsername);
    if (resp.ChallengeName === "PASSWORD_VERIFIER") return (0, $e853d20a14477d8a$export$30f932fe98713ccc)((0, $53a8fc9ce86c8568$export$7f7b64167822fe34), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return resp;
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response for authentication.
 * Initiates the selected authentication challenge based on user choice.
 *
 * @param {Object} params - The parameters for handling the selected challenge
 * @param {string} params.username - The username for authentication
 * @param {string} params.session - The current authentication session token
 * @param {string} params.selectedChallenge - The challenge type selected by the user
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {ClientMetadata} [params.clientMetadata] - Optional metadata to be sent with auth requests
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $c1c01a890d1d6585$export$4eb37109154e77c1({ username: username, session: session, selectedChallenge: selectedChallenge, config: config, clientMetadata: clientMetadata }) {
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: config.userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(config.userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: {
            USERNAME: username,
            ANSWER: selectedChallenge
        },
        ClientId: config.userPoolClientId,
        Session: session,
        ClientMetadata: clientMetadata
    });
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password authentication.
 * This function combines the SELECT_CHALLENGE flow with standard password authentication.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $56aabce8d76586fb$export$cca550d6560f23b8(username, password, clientMetadata, config, session) {
    var _response_ChallengeParameters;
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const authParameters = {
        ANSWER: "PASSWORD",
        USERNAME: username,
        PASSWORD: password
    };
    const userContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    var _response_ChallengeParameters_USERNAME;
    const activeUsername = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : username;
    (0, $c27678b2936e095f$export$fecfbc200868d412)(activeUsername);
    return response;
}






















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles the SELECT_CHALLENGE response specifically for Password SRP authentication.
 * This function combines the SELECT_CHALLENGE flow with Password SRP protocol.
 *
 * @param {string} username - The username for authentication
 * @param {string} password - The user's password
 * @param {ClientMetadata} [clientMetadata] - Optional metadata to be sent with auth requests
 * @param {CognitoUserPoolConfig} config - Cognito User Pool configuration
 * @param {string} session - The current authentication session token
 * @param {AuthTokenOrchestrator} tokenOrchestrator - Token orchestrator for managing auth tokens
 *
 * @returns {Promise<RespondToAuthChallengeCommandOutput>} The challenge response
 */ async function $611d07fc1a285eec$export$e496ff225fdec499(username, password, clientMetadata, config, session, tokenOrchestrator) {
    var _response_ChallengeParameters;
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $9de705fddefabf6c$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        ANSWER: "PASSWORD_SRP",
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const userContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        ChallengeName: "SELECT_CHALLENGE",
        ChallengeResponses: authParameters,
        ClientId: userPoolClientId,
        ClientMetadata: clientMetadata,
        Session: session,
        UserContextData: userContextData
    });
    var _response_ChallengeParameters_USERNAME;
    const activeUsername = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : username;
    (0, $c27678b2936e095f$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === "PASSWORD_VERIFIER") return (0, $e853d20a14477d8a$export$30f932fe98713ccc)((0, $53a8fc9ce86c8568$export$7f7b64167822fe34), [
        password,
        response.ChallengeParameters,
        clientMetadata,
        response.Session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
    return response;
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d8f1cd2c50629c95$var$USER_ATTRIBUTES = "userAttributes.";
function $d8f1cd2c50629c95$var$isWebAuthnResultAuthSignInOutput(result) {
    return "isSignedIn" in result && "nextStep" in result;
}
async function $d8f1cd2c50629c95$export$6fe6331471b54d26({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await (tokenOrchestrator === null || tokenOrchestrator === void 0 ? void 0 : tokenOrchestrator.getDeviceMetadata(username));
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return (0, $dbc9be1bca2f75ed$export$18ec6b77c0b7fafe)({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d8f1cd2c50629c95$export$9b78cd405a35bccd({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, deviceName: deviceName, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    if (challengeResponse === "EMAIL") return {
        ChallengeName: "MFA_SETUP",
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["EMAIL_OTP"]'
        },
        $metadata: {}
    };
    if (challengeResponse === "TOTP") return {
        ChallengeName: "MFA_SETUP",
        Session: session,
        ChallengeParameters: {
            MFAS_CAN_SETUP: '["SOFTWARE_TOKEN_MFA"]'
        },
        $metadata: {}
    };
    const challengeResponses = {
        USERNAME: username
    };
    const isTOTPCode = /^\d+$/.test(challengeResponse);
    if (isTOTPCode) {
        const verifySoftwareToken = (0, $67c783f15dbab9a2$export$cf5dd9429415aa98)({
            endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        const { Session: Session } = await verifySoftwareToken({
            region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
        }, {
            UserCode: challengeResponse,
            Session: session,
            FriendlyDeviceName: deviceName
        });
        (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).dispatch({
            type: "SET_SIGN_IN_SESSION",
            value: Session
        });
        const jsonReq = {
            ChallengeName: "MFA_SETUP",
            ChallengeResponses: challengeResponses,
            Session: Session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
            endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    const isEmail = challengeResponse.includes("@");
    if (isEmail) {
        challengeResponses.EMAIL = challengeResponse;
        const jsonReq = {
            ChallengeName: "MFA_SETUP",
            ChallengeResponses: challengeResponses,
            Session: session,
            ClientMetadata: clientMetadata,
            ClientId: userPoolClientId
        };
        const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
            endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        return respondToAuthChallenge({
            region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
        }, jsonReq);
    }
    throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
        message: `Cannot proceed with MFA setup using challengeResponse: ${challengeResponse}`,
        recoverySuggestion: 'Try passing "EMAIL", "TOTP", a valid email, or OTP code as the challengeResponse.'
    });
}
async function $d8f1cd2c50629c95$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS" || challengeResponse === "EMAIL", (0, $07233456440bc422$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $d8f1cd2c50629c95$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d8f1cd2c50629c95$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, requiredAttributes: requiredAttributes, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const challengeResponses = (0, $2qxEV._)((0, $9tqwB._)({}, $d8f1cd2c50629c95$export$c7c9603a6b1fd815(requiredAttributes)), {
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    });
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $d8f1cd2c50629c95$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    var _response_ChallengeParameters, _response_ChallengeParameters1;
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $b3ee0c7434af201f$export$91f349d78bea7765)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    var _response_ChallengeParameters_USERNAME, _ref;
    const activeUsername = (_ref = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : (_response_ChallengeParameters1 = response.ChallengeParameters) === null || _response_ChallengeParameters1 === void 0 ? void 0 : _response_ChallengeParameters1.USER_ID_FOR_SRP) !== null && _ref !== void 0 ? _ref : username;
    (0, $c27678b2936e095f$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return (0, $dbc9be1bca2f75ed$export$18ec6b77c0b7fafe)({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d8f1cd2c50629c95$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    return (0, $fbaf2806080f0546$export$169bd15774e46c56)({
        username: username,
        password: password,
        clientMetadata: clientMetadata,
        config: config,
        tokenOrchestrator: tokenOrchestrator,
        authFlow: "USER_SRP_AUTH"
    });
}
async function $d8f1cd2c50629c95$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    var _response_ChallengeParameters;
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $b3ee0c7434af201f$export$91f349d78bea7765)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    var _response_ChallengeParameters_USERNAME;
    const activeUsername = (_response_ChallengeParameters_USERNAME = (_response_ChallengeParameters = response.ChallengeParameters) === null || _response_ChallengeParameters === void 0 ? void 0 : _response_ChallengeParameters.USERNAME) !== null && _response_ChallengeParameters_USERNAME !== void 0 ? _response_ChallengeParameters_USERNAME : username;
    (0, $c27678b2936e095f$export$fecfbc200868d412)(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return (0, $dbc9be1bca2f75ed$export$18ec6b77c0b7fafe)({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $d8f1cd2c50629c95$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const userPoolName = (userPoolId === null || userPoolId === void 0 ? void 0 : userPoolId.split("_")[1]) || "";
    const authenticationHelper = await (0, $9de705fddefabf6c$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const initiateAuth = (0, $b3ee0c7434af201f$export$91f349d78bea7765)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { ChallengeParameters: challengeParameters, Session: session } = await initiateAuth({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    var _challengeParameters_USERNAME;
    const activeUsername = (_challengeParameters_USERNAME = challengeParameters === null || challengeParameters === void 0 ? void 0 : challengeParameters.USERNAME) !== null && _challengeParameters_USERNAME !== void 0 ? _challengeParameters_USERNAME : username;
    (0, $c27678b2936e095f$export$fecfbc200868d412)(activeUsername);
    return (0, $e853d20a14477d8a$export$30f932fe98713ccc)((0, $53a8fc9ce86c8568$export$7f7b64167822fe34), [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $d8f1cd2c50629c95$export$cf152400b58b8e65(params) {
    var _Amplify_getConfig_Auth;
    const { challengeName: challengeName, challengeParameters: challengeParameters, availableChallenges: availableChallenges } = params;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            {
                const { signInSession: signInSession, username: username } = (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).getState();
                const mfaSetupTypes = $d8f1cd2c50629c95$export$d70c792e078766ea($d8f1cd2c50629c95$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP)) || [];
                const allowedMfaSetupTypes = $d8f1cd2c50629c95$export$343435e7c7c3ff0f(mfaSetupTypes);
                const isTotpMfaSetupAvailable = allowedMfaSetupTypes.includes("TOTP");
                const isEmailMfaSetupAvailable = allowedMfaSetupTypes.includes("EMAIL");
                if (isTotpMfaSetupAvailable && isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION",
                        allowedMFATypes: allowedMfaSetupTypes
                    }
                };
                if (isEmailMfaSetupAvailable) return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP"
                    }
                };
                if (isTotpMfaSetupAvailable) {
                    const associateSoftwareToken = (0, $539fedaf8e7a5889$export$6bff32634453de2a)({
                        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                            endpointOverride: authConfig.userPoolEndpoint
                        })
                    });
                    const { Session: Session, SecretCode: secretCode } = await associateSoftwareToken({
                        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(authConfig.userPoolId)
                    }, {
                        Session: signInSession
                    });
                    (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).dispatch({
                        type: "SET_SIGN_IN_SESSION",
                        value: Session
                    });
                    return {
                        isSignedIn: false,
                        nextStep: {
                            signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                            totpSetupDetails: $d8f1cd2c50629c95$export$b105c3e8e4f5ce91(secretCode, username)
                        }
                    };
                }
                throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
                    name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${mfaSetupTypes}`
                });
            }
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $d8f1cd2c50629c95$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $d8f1cd2c50629c95$export$d70c792e078766ea($d8f1cd2c50629c95$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_OTP":
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
        case "EMAIL_OTP":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "WEB_AUTHN":
            {
                const result = await (0, $f034a6258d9140be$export$77701654924537aa)(challengeParameters);
                if ($d8f1cd2c50629c95$var$isWebAuthnResultAuthSignInOutput(result)) return result;
                return $d8f1cd2c50629c95$export$cf152400b58b8e65(result);
            }
        case "PASSWORD":
        case "PASSWORD_SRP":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_PASSWORD"
                }
            };
        case "SELECT_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION",
                    availableChallenges: availableChallenges
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $d8f1cd2c50629c95$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName !== null && accountName !== void 0 ? accountName : username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $d8f1cd2c50629c95$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $c50e9c939b7b9954$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $c50e9c939b7b9954$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $d8f1cd2c50629c95$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($d8f1cd2c50629c95$var$USER_ATTRIBUTES) ? att.replace($d8f1cd2c50629c95$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $d8f1cd2c50629c95$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$d8f1cd2c50629c95$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $d8f1cd2c50629c95$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options === null || options === void 0 ? void 0 : options.userAttributes;
    const deviceName = options === null || options === void 0 ? void 0 : options.friendlyDeviceName;
    switch(challengeName){
        case "WEB_AUTHN":
        case "SELECT_CHALLENGE":
            if (challengeResponse === "PASSWORD_SRP" || challengeResponse === "PASSWORD") return {
                ChallengeName: challengeResponse,
                Session: session,
                $metadata: {}
            };
            return (0, $c1c01a890d1d6585$export$4eb37109154e77c1)({
                username: username,
                session: session,
                selectedChallenge: challengeResponse,
                config: config,
                clientMetadata: clientMetadata
            });
        case "SELECT_MFA_TYPE":
            return $d8f1cd2c50629c95$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $d8f1cd2c50629c95$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $d8f1cd2c50629c95$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return (0, $e853d20a14477d8a$export$30f932fe98713ccc)($d8f1cd2c50629c95$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SMS_MFA":
        case "SOFTWARE_TOKEN_MFA":
        case "SMS_OTP":
        case "EMAIL_OTP":
            return $d8f1cd2c50629c95$export$1ec196d12cb921db({
                challengeName: challengeName,
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "PASSWORD":
            return (0, $56aabce8d76586fb$export$cca550d6560f23b8)(username, challengeResponse, clientMetadata, config, session);
        case "PASSWORD_SRP":
            return (0, $611d07fc1a285eec$export$e496ff225fdec499)(username, challengeResponse, clientMetadata, config, session, tokenOrchestrator);
    }
    // TODO: remove this error message for production apps
    throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process.
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $d8f1cd2c50629c95$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    if (mfa === "EMAIL") mfaType = "EMAIL_OTP";
    return mfaType;
}
function $d8f1cd2c50629c95$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
    if (type === "EMAIL_OTP") return "EMAIL";
// TODO: log warning for unknown MFA type
}
function $d8f1cd2c50629c95$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($d8f1cd2c50629c95$export$6ce04ce89055b1fe).filter(Boolean);
}
function $d8f1cd2c50629c95$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $d8f1cd2c50629c95$export$343435e7c7c3ff0f(availableMfaSetupTypes) {
    return availableMfaSetupTypes.filter((authMfaType)=>authMfaType === "EMAIL" || authMfaType === "TOTP");
}
async function $d8f1cd2c50629c95$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $d4670e566035df31$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $1b91ec72af99207f$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
function $d8f1cd2c50629c95$export$cc3585de146a51be(username) {
    const state = (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).getState();
    var _state_username;
    return (_state_username = state.username) !== null && _state_username !== void 0 ? _state_username : username;
}
async function $d8f1cd2c50629c95$export$1ec196d12cb921db({ challengeName: challengeName, challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const challengeResponses = {
        USERNAME: username
    };
    if (challengeName === "EMAIL_OTP") challengeResponses.EMAIL_OTP_CODE = challengeResponse;
    if (challengeName === "SMS_MFA") challengeResponses.SMS_MFA_CODE = challengeResponse;
    if (challengeName === "SMS_OTP") challengeResponses.SMS_OTP_CODE = challengeResponse;
    if (challengeName === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = challengeResponse;
    const userContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: challengeName,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: userContextData
    };
    const respondToAuthChallenge = (0, $ca48faf2674d523e$export$11329f5ae466ab5d)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    return respondToAuthChallenge({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $aacb932adb586022$var$CODE_VERIFIER_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
/**
 *
 * @param length Desired length of the code verifier.
 *
 * **NOTE:** According to the [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 * A code verifier must be with a length >= 43 and <= 128.
 *
 * @returns An object that contains the generated `codeVerifier` and a method
 * `toCodeChallenge` to generate the code challenge from the `codeVerifier`
 * following the spec of [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2).
 */ const $aacb932adb586022$export$cf1891f923f5943a = (length)=>{
    const randomBytes = new Uint8Array(length);
    (0, $fb45fae2ab4b72c3$export$e003cc239f955cb6)().getRandomValues(randomBytes);
    let value = "";
    let codeChallenge;
    for (const byte of randomBytes)value += $aacb932adb586022$var$CODE_VERIFIER_CHARSET.charAt(byte % $aacb932adb586022$var$CODE_VERIFIER_CHARSET.length);
    return {
        value: value,
        method: "S256",
        toCodeChallenge () {
            if (codeChallenge) return codeChallenge;
            codeChallenge = $aacb932adb586022$var$generateCodeChallenge(value);
            return codeChallenge;
        }
    };
};
function $aacb932adb586022$var$generateCodeChallenge(codeVerifier) {
    const awsCryptoHash = new (0, $5cca8895dd9e2955$export$3b58ea8124ac5e28)();
    awsCryptoHash.update(codeVerifier);
    const codeChallenge = $aacb932adb586022$var$removePaddingChar((0, $2a5c07bb3584dd50$export$695b149896bd3e2a).convert(awsCryptoHash.digestSync(), {
        urlSafe: true
    }));
    return codeChallenge;
}
function $aacb932adb586022$var$removePaddingChar(base64Encoded) {
    return base64Encoded.replace(/=/g, "");
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c29b3e326cca37e9$export$9e15fb06e64c4810 = (length)=>{
    const STATE_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const result = [];
    const randomNums = new Uint8Array(length);
    (0, $fb45fae2ab4b72c3$export$e003cc239f955cb6)().getRandomValues(randomNums);
    for (const num of randomNums)result.push(STATE_CHARSET[num % STATE_CHARSET.length]);
    return result.join("");
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b64c6e1010079741$export$9ccd2716e53a229b = ()=>{
    return (0, $c29b3e326cca37e9$export$9e15fb06e64c4810)(32);
};













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fe9e4b201f57e0a7$export$35c17f3730c1b943 = (store)=>{
    async function handleCancelOAuthFlow(event) {
        const isBfcache = event.persisted;
        if (isBfcache && await store.loadOAuthInFlight()) {
            const error = (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)("User cancelled OAuth flow.");
            await (0, $679d4e1e6384b92f$export$9adf33f0521751a3)(error);
        }
        window.removeEventListener("pageshow", handleCancelOAuthFlow);
    }
    window.addEventListener("pageshow", handleCancelOAuthFlow);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs in a user with OAuth. Redirects the application to an Identity Provider.
 *
 * @param input - The SignInWithRedirectInput object, if empty it will redirect to Cognito HostedUI
 *
 * @throws AuthTokenConfigException - Thrown when the user pool config is invalid.
 * @throws OAuthNotConfigureException - Thrown when the oauth config is invalid.
 */ async function $701013124925a1b1$export$3d0a7d1372e866bb(input) {
    var _Amplify_getConfig_Auth, _input_options, _input_provider, _input_options1, _input_options2, _input_options3, _input_options4, _input_options5, _input_options6;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    (0, $00406059b8b03c2e$export$c13e6dbaf90a8e5f)(authConfig);
    (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig);
    if (!(input === null || input === void 0 ? void 0 : (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.prompt)) await (0, $d8f1cd2c50629c95$export$8061cd07f982ef08)();
    let provider = "COGNITO"; // Default
    if (typeof (input === null || input === void 0 ? void 0 : input.provider) === "string") provider = (0, $406fca4d9f20ea82$export$6893de5f4e1216c3)[input.provider];
    else if (input === null || input === void 0 ? void 0 : (_input_provider = input.provider) === null || _input_provider === void 0 ? void 0 : _input_provider.custom) provider = input.provider.custom;
    return $701013124925a1b1$var$oauthSignIn({
        oauthConfig: authConfig.loginWith.oauth,
        clientId: authConfig.userPoolClientId,
        provider: provider,
        customState: input === null || input === void 0 ? void 0 : input.customState,
        preferPrivateSession: input === null || input === void 0 ? void 0 : (_input_options1 = input.options) === null || _input_options1 === void 0 ? void 0 : _input_options1.preferPrivateSession,
        options: {
            loginHint: input === null || input === void 0 ? void 0 : (_input_options2 = input.options) === null || _input_options2 === void 0 ? void 0 : _input_options2.loginHint,
            lang: input === null || input === void 0 ? void 0 : (_input_options3 = input.options) === null || _input_options3 === void 0 ? void 0 : _input_options3.lang,
            nonce: input === null || input === void 0 ? void 0 : (_input_options4 = input.options) === null || _input_options4 === void 0 ? void 0 : _input_options4.nonce,
            prompt: input === null || input === void 0 ? void 0 : (_input_options5 = input.options) === null || _input_options5 === void 0 ? void 0 : _input_options5.prompt
        },
        authSessionOpener: input === null || input === void 0 ? void 0 : (_input_options6 = input.options) === null || _input_options6 === void 0 ? void 0 : _input_options6.authSessionOpener
    });
}
const $701013124925a1b1$var$oauthSignIn = async ({ oauthConfig: oauthConfig, provider: provider, clientId: clientId, customState: customState, preferPrivateSession: preferPrivateSession, options: options, authSessionOpener: authSessionOpener })=>{
    const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType, scopes: scopes } = oauthConfig;
    const { loginHint: loginHint, lang: lang, nonce: nonce, prompt: prompt } = options !== null && options !== void 0 ? options : {};
    const randomState = (0, $b64c6e1010079741$export$9ccd2716e53a229b)();
    const openAuthSession$1 = authSessionOpener || (0, $96911686737d1008$export$a673d54799039714);
    /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
    single-encodes/decodes url on first sign in and double-encodes/decodes url
    when user already signed in. Using encodeURIComponent, Base32, Base64 add
    characters % or = which on further encoding becomes unsafe. '=' create issue
    for parsing query params.
    Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ const state = customState ? `${randomState}-${(0, $c77c82c16b2a07f8$export$b855308a44508212)(customState)}` : randomState;
    const { value: value, method: method, toCodeChallenge: toCodeChallenge } = (0, $aacb932adb586022$export$cf1891f923f5943a)(128);
    const redirectUri = (0, $8e98829722d37451$export$93832c3affb240d3)(oauthConfig.redirectSignIn);
    if ((0, $f03cf65cfc38a977$export$4e09c449d6c407f7)()) (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).storeOAuthInFlight(true);
    (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).storeOAuthState(state);
    (0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c).storePKCE(value);
    const params = new URLSearchParams([
        [
            "redirect_uri",
            redirectUri
        ],
        [
            "response_type",
            responseType
        ],
        [
            "client_id",
            clientId
        ],
        [
            "identity_provider",
            provider
        ],
        [
            "scope",
            scopes.join(" ")
        ]
    ]);
    loginHint && params.append("login_hint", loginHint);
    lang && params.append("lang", lang);
    nonce && params.append("nonce", nonce);
    prompt && params.append("prompt", prompt.toLowerCase());
    params.append("state", state);
    if (responseType === "code") {
        params.append("code_challenge", toCodeChallenge());
        params.append("code_challenge_method", method);
    }
    // Using URL object is not supported in React Native as the `search` property is read-only
    // See: https://github.com/facebook/react-native/blob/main/packages/react-native/Libraries/Blob/URL.js
    const oAuthUrl = `https://${domain}/oauth2/authorize?${params.toString()}`;
    // this will only take effect in the following scenarios:
    // 1. the user cancels the OAuth flow on web via back button, and
    // 2. when bfcache is enabled
    (0, $fe9e4b201f57e0a7$export$35c17f3730c1b943)((0, $c735b702f9f18cc5$export$2ed0ec267eb6cb1c));
    var _ref;
    // the following is effective only in react-native as openAuthSession resolves only in react-native
    const { type: type, error: error, url: url } = (_ref = await openAuthSession$1(oAuthUrl, redirectSignIn, preferPrivateSession)) !== null && _ref !== void 0 ? _ref : {};
    try {
        if (type === "error") throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)(String(error));
        if (type === "canceled") throw (0, $c0a43102ad2bfdd6$export$84cc8f04e08ffc24)(String(type));
        if (type === "success" && url) await (0, $97689c63f64ae65a$export$342f5c7ddb2087ec)({
            currentUrl: url,
            clientId: clientId,
            domain: domain,
            redirectUri: redirectUri,
            responseType: responseType,
            userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignInWithRedirect),
            preferPrivateSession: preferPrivateSession
        });
    } catch (err) {
        await (0, $679d4e1e6384b92f$export$9adf33f0521751a3)(err);
        // rethrow the error so it can be caught by `await signInWithRedirect()` in react-native
        throw err;
    }
};





var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");














var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c7a3f0a22401ff69$export$f182f73f82c5c23a = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("ConfirmSignUp"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $4c604f65af804856$var$defaultState() {
    return {
        active: false
    };
}
const $4c604f65af804856$var$autoSignInReducer = (state, action)=>{
    switch(action.type){
        case "SET_USERNAME":
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                username: action.value
            });
        case "SET_SESSION":
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                session: action.value
            });
        case "START":
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                active: true
            });
        case "RESET":
            return $4c604f65af804856$var$defaultState();
        default:
            return state;
    }
};
const $4c604f65af804856$var$createAutoSignInStore = (reducer)=>{
    let currentState = reducer($4c604f65af804856$var$defaultState(), {
        type: "RESET"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $4c604f65af804856$export$ef87a9980a3566ca = $4c604f65af804856$var$createAutoSignInStore($4c604f65af804856$var$autoSignInReducer);







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4cbbf17ecd24694e$var$initialAutoSignIn = async ()=>{
    throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $1b91ec72af99207f$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let $4cbbf17ecd24694e$export$c5378dc7d6787fa5 = $4cbbf17ecd24694e$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $4cbbf17ecd24694e$export$7dcbf67a23c27835(callback) {
    $4cbbf17ecd24694e$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $4cbbf17ecd24694e$export$1ffa2742ce5c589b(resetCallback = true) {
    if (resetCallback) $4cbbf17ecd24694e$export$c5378dc7d6787fa5 = $4cbbf17ecd24694e$var$initialAutoSignIn;
    (0, $4c604f65af804856$export$ef87a9980a3566ca).dispatch({
        type: "RESET"
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $300b9456de38c520$export$2ce39ab6662e8c24(input) {
    var _Amplify_getConfig_Auth;
    const { username: username, confirmationCode: confirmationCode, options: options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const clientMetadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!confirmationCode, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const confirmSignUpClient = (0, $c7a3f0a22401ff69$export$f182f73f82c5c23a)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { Session: session } = await confirmSignUpClient({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options === null || options === void 0 ? void 0 : options.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            const autoSignInStoreState = (0, $4c604f65af804856$export$ef87a9980a3566ca).getState();
            if (!autoSignInStoreState.active || autoSignInStoreState.username !== username) {
                resolve(signUpOut);
                (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
                return;
            }
            (0, $4c604f65af804856$export$ef87a9980a3566ca).dispatch({
                type: "SET_SESSION",
                value: session
            });
            const stopListener = (0, $317c15c2759ac41f$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        stopListener();
                }
            });
            (0, $317c15c2759ac41f$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}


var $9tqwB = parcelRequire("9tqwB");














var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $11c1b82bde679a72$export$cf53d1782ddbc93c = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("ResendConfirmationCode"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resend the confirmation code while signing up
 *
 * @param input -  The ResendSignUpCodeInput object
 * @returns ResendSignUpCodeOutput
 * @throws service: {@link ResendConfirmationException } - Cognito service errors thrown when resending the code.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $06b9fc89b90098e0$export$b295e842f1d42d13(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const { username: username } = input;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignUpUsername);
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const clientMetadata = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const resendConfirmationCode = (0, $11c1b82bde679a72$export$cf53d1782ddbc93c)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await resendConfirmationCode({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ResendSignUpCode)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = (0, $9tqwB._)({}, CodeDeliveryDetails);
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName ? AttributeName : undefined
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $2232f5c4fc198a3f$export$d1b63878dfcc70a6() {
    return (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).Auth.clearCredentials();
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $34d9feea763257dc$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $10e1902ea767432f$export$66561e66d62991d0).clearTokens();
    await (0, $2232f5c4fc198a3f$export$d1b63878dfcc70a6)();
    (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f9a03f3682fef176$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false, redirectUrl)=>{
    (0, $00406059b8b03c2e$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
    const { domain: domain, redirectSignOut: redirectSignOut } = loginWith.oauth;
    const signoutUri = (0, $8e98829722d37451$export$93832c3affb240d3)(redirectSignOut, redirectUrl);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $96911686737d1008$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $529e139a205102a6$export$74290142c99a2f64 = async (cognitoConfig, store, tokenOrchestrator, redirectUrl)=>{
    const { isOAuthSignIn: isOAuthSignIn } = await store.loadOAuthSignIn();
    const oauthMetadata = await tokenOrchestrator.getOAuthMetadata();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $34d9feea763257dc$export$f8a4fedaab76b065)(store);
    // The isOAuthSignIn flag is propagated by the oAuthToken store which manages oauth keys in local storage only.
    // These keys are used to determine if a user is in an inflight or signedIn oauth states.
    // However, this behavior represents an issue when 2 apps share the same set of tokens in Cookie storage because the app that didn't
    // start the OAuth will not have access to the oauth keys.
    // A heuristic solution is to add oauth metadata to the tokenOrchestrator which will have access to the underlying
    // storage mechanism that is used by Amplify.
    if (isOAuthSignIn || (oauthMetadata === null || oauthMetadata === void 0 ? void 0 : oauthMetadata.oauthSignIn)) // On web, this will always end up being a void action
    return (0, $f9a03f3682fef176$export$a20426d3d43ad21f)(cognitoConfig, false, redirectUrl);
};











var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $251b343a8901127e$export$93ed00c43cc3ad50 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("RevokeToken"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));





var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $66ef7593d68f6e08$export$9ebd23b04fdf4c3a = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("GlobalSignOut"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bc3cbcb8cbfbe7ae$var$logger = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $bc3cbcb8cbfbe7ae$export$b0ac3a1c242cb1ea(input) {
    var _Amplify_getConfig_Auth;
    const cognitoConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(cognitoConfig);
    if (input === null || input === void 0 ? void 0 : input.global) await $bc3cbcb8cbfbe7ae$var$globalSignOut(cognitoConfig);
    else await $bc3cbcb8cbfbe7ae$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $00406059b8b03c2e$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        var _input_oauth;
        const oAuthStore = new (0, $51101f22196944be$export$9b2cef5d94f9b6e8)((0, $6dd46fc26844509a$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        var _ref;
        const { type: type } = (_ref = await (0, $529e139a205102a6$export$74290142c99a2f64)(cognitoConfig, oAuthStore, (0, $10e1902ea767432f$export$66561e66d62991d0), input === null || input === void 0 ? void 0 : (_input_oauth = input.oauth) === null || _input_oauth === void 0 ? void 0 : _input_oauth.redirectUrl)) !== null && _ref !== void 0 ? _ref : {};
        if (type === "error") throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
            name: (0, $1b91ec72af99207f$export$625255707e22459c),
            message: `An error occurred when attempting to log out from OAuth provider.`
        });
    } else {
        // complete sign out
        (0, $10e1902ea767432f$export$66561e66d62991d0).clearTokens();
        await (0, $2232f5c4fc198a3f$export$d1b63878dfcc70a6)();
        (0, $317c15c2759ac41f$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $317c15c2759ac41f$export$aadf71dd9875dd20));
    }
}
async function $bc3cbcb8cbfbe7ae$var$clientSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId, userPoolClientId: userPoolClientId } = cognitoConfig;
        const authTokens = await (0, $10e1902ea767432f$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $2cc7ae0cece9bbf8$export$be38b2d22222d505)(authTokens);
        if ($bc3cbcb8cbfbe7ae$var$isSessionRevocable(authTokens.accessToken)) {
            const revokeToken = (0, $251b343a8901127e$export$93ed00c43cc3ad50)({
                endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                    endpointOverride: userPoolEndpoint
                })
            });
            await revokeToken({
                region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
                userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignOut)
            }, {
                ClientId: userPoolClientId,
                Token: authTokens.refreshToken
            });
        }
    } catch (err) {
        // this shouldn't throw
        $bc3cbcb8cbfbe7ae$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $bc3cbcb8cbfbe7ae$var$globalSignOut(cognitoConfig) {
    try {
        const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = cognitoConfig;
        const authTokens = await (0, $10e1902ea767432f$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(authTokens);
        const globalSignOutClient = (0, $66ef7593d68f6e08$export$9ebd23b04fdf4c3a)({
            endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
                endpointOverride: userPoolEndpoint
            })
        });
        await globalSignOutClient({
            region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
            userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $bc3cbcb8cbfbe7ae$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $bc3cbcb8cbfbe7ae$var$isSessionRevocable = (token)=>{
    var _token_payload;
    return !!(token === null || token === void 0 ? void 0 : (_token_payload = token.payload) === null || _token_payload === void 0 ? void 0 : _token_payload.origin_jti);
};










var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $ba3895c320b5da58$export$7f948971bcf643ff(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!password, (0, $07233456440bc422$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName, ChallengeParameters: retiredChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $e853d20a14477d8a$export$30f932fe98713ccc)((0, $d8f1cd2c50629c95$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $10e1902ea767432f$export$66561e66d62991d0)
        ], username, (0, $10e1902ea767432f$export$66561e66d62991d0));
        const activeUsername = (0, $d8f1cd2c50629c95$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({
                username: activeUsername
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            }));
            (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
            await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d8f1cd2c50629c95$export$cf152400b58b8e65)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
        const result = (0, $d8f1cd2c50629c95$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");














// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $3bd56eb0fae47eec$export$2c0317ed1bbb0787(input) {
    var _Amplify_getConfig_Auth;
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const metadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!password, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName, ChallengeParameters: handledChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $d8f1cd2c50629c95$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $10e1902ea767432f$export$66561e66d62991d0));
        const activeUsername = (0, $d8f1cd2c50629c95$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({
                username: activeUsername
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            }));
            (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
            await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d8f1cd2c50629c95$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
        const result = (0, $d8f1cd2c50629c95$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $bb4ec91b917d688f$export$728178cf826a5ab9(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const { username: username, password: password } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const clientMetaData = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!password, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName, ChallengeParameters: handledChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $d8f1cd2c50629c95$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $10e1902ea767432f$export$66561e66d62991d0));
        const activeUsername = (0, $d8f1cd2c50629c95$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({
                username: activeUsername
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            }));
            (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
            await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
            (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d8f1cd2c50629c95$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
        (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
        const result = (0, $d8f1cd2c50629c95$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $7692a810967090a2$export$200af5a623414b2b(input) {
    var _Amplify_getConfig_Auth;
    const { username: username, password: password, options: options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const metadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!password, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName, ChallengeParameters: retriedChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $e853d20a14477d8a$export$30f932fe98713ccc)((0, $d8f1cd2c50629c95$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $10e1902ea767432f$export$66561e66d62991d0)
        ], username, (0, $10e1902ea767432f$export$66561e66d62991d0));
        const activeUsername = (0, $d8f1cd2c50629c95$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({}, AuthenticationResult), {
                username: activeUsername,
                NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            }));
            (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
            await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
            (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d8f1cd2c50629c95$export$cf152400b58b8e65)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
        (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
        const result = (0, $d8f1cd2c50629c95$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");































// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Handles user authentication flow with configurable challenge preferences.
 * Supports AuthFactorType challenges through the USER_AUTH flow.
 *
 * @param {HandleUserAuthFlowInput} params - Authentication flow parameters
 * @param {string} params.username - The username for authentication
 * @param {Record<string, string>} [params.clientMetadata] - Optional metadata to pass to authentication service
 * @param {CognitoUserPoolConfig} params.config - Cognito User Pool configuration
 * @param {AuthTokenOrchestrator} params.tokenOrchestrator - Manages authentication tokens and device tracking
 * @param {AuthFactorType} [params.preferredChallenge] - Optional preferred authentication method
 * @param {string} [params.password] - Required when preferredChallenge is 'PASSWORD' or 'PASSWORD_SRP'
 *
 * @returns {Promise<InitiateAuthCommandOutput>} The authentication response from Cognito
 */ async function $4d9b84350502638f$export$f21455679019a68e({ username: username, clientMetadata: clientMetadata, config: config, tokenOrchestrator: tokenOrchestrator, preferredChallenge: preferredChallenge, password: password, session: session }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = config;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const authParameters = {
        USERNAME: username
    };
    if (preferredChallenge) {
        if (preferredChallenge === "PASSWORD_SRP") {
            (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!password, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInPassword);
            return (0, $fbaf2806080f0546$export$169bd15774e46c56)({
                username: username,
                password: password,
                clientMetadata: clientMetadata,
                config: config,
                tokenOrchestrator: tokenOrchestrator,
                authFlow: "USER_AUTH",
                preferredChallenge: preferredChallenge
            });
        }
        if (preferredChallenge === "PASSWORD") {
            (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!password, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInPassword);
            authParameters.PASSWORD = password;
        }
        authParameters.PREFERRED_CHALLENGE = preferredChallenge;
    }
    const jsonReq = {
        AuthFlow: "USER_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    if (session) jsonReq.Session = session;
    const initiateAuth = (0, $b3ee0c7434af201f$export$91f349d78bea7765)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const response = await initiateAuth({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    // Set the active username immediately after successful authentication attempt
    // If a user starts a new sign-in while another sign-in is incomplete,
    // this ensures we're tracking the correct user for subsequent auth challenges.
    (0, $c27678b2936e095f$export$fecfbc200868d412)(username);
    return response;
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in through a registered email or phone number without a password by by receiving and entering an OTP.
 *
 * @param input - The SignInWithUserAuthInput object
 * @returns SignInWithUserAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password -- needs to change
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $94dafdacc2c41f5f$export$fcfa00cf0f5ec937(input) {
    var _Amplify_getConfig_Auth;
    const { username: username, password: password, options: options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_AUTH"
    };
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options === null || options === void 0 ? void 0 : options.clientMetadata;
    const preferredChallenge = options === null || options === void 0 ? void 0 : options.preferredChallenge;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignInUsername);
    try {
        const handleUserAuthFlowInput = {
            username: username,
            config: authConfig,
            tokenOrchestrator: $10e1902ea767432f$export$66561e66d62991d0,
            clientMetadata: clientMetaData,
            preferredChallenge: preferredChallenge,
            password: password
        };
        const autoSignInStoreState = (0, $4c604f65af804856$export$ef87a9980a3566ca).getState();
        if (autoSignInStoreState.active && autoSignInStoreState.username === username) handleUserAuthFlowInput.session = autoSignInStoreState.session;
        const response = await (0, $4d9b84350502638f$export$f21455679019a68e)(handleUserAuthFlowInput);
        const activeUsername = (0, $d8f1cd2c50629c95$export$cc3585de146a51be)(username);
        (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
            signInSession: response.Session,
            username: activeUsername,
            challengeName: response.ChallengeName,
            signInDetails: signInDetails
        });
        if (response.AuthenticationResult) {
            await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({
                username: activeUsername
            }, response.AuthenticationResult), {
                NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: response.AuthenticationResult.NewDeviceMetadata,
                    accessToken: response.AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            }));
            (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
            await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
            (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d8f1cd2c50629c95$export$cf152400b58b8e65)({
            challengeName: response.ChallengeName,
            challengeParameters: response.ChallengeParameters,
            availableChallenges: "AvailableChallenges" in response ? response.AvailableChallenges : undefined
        });
    } catch (error) {
        (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
        (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
        const result = (0, $d8f1cd2c50629c95$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $134afd9bfa803edb$export$9670d83f11d4b64a(input) {
    var _input_options;
    // Here we want to reset the store but not reassign the callback.
    // The callback is reset when the underlying promise resolves or rejects.
    // With the advent of session based sign in, this guarantees that the signIn API initiates a new auth flow,
    // regardless of whether it is called for a user currently engaged in an active auto sign in session.
    (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)(false);
    const authFlowType = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.authFlowType;
    await (0, $d8f1cd2c50629c95$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $bb4ec91b917d688f$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $7692a810967090a2$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $ba3895c320b5da58$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $3bd56eb0fae47eec$export$2c0317ed1bbb0787)(input);
        case "USER_AUTH":
            return (0, $94dafdacc2c41f5f$export$fcfa00cf0f5ec937)(input);
        default:
            return (0, $bb4ec91b917d688f$export$728178cf826a5ab9)(input);
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a7205b56086e6d0e$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $a7205b56086e6d0e$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $317c15c2759ac41f$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response === null || response === void 0 ? void 0 : response.isSignUpComplete) {
                        (0, $317c15c2759ac41f$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $4cbbf17ecd24694e$export$7dcbf67a23c27835)($a7205b56086e6d0e$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        clearTimeout(timeOutId);
        (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
    }, $a7205b56086e6d0e$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $a7205b56086e6d0e$var$debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $a7205b56086e6d0e$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $a7205b56086e6d0e$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            reject(new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
                name: (0, $1b91ec72af99207f$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
        } else try {
            const signInOutput = await (0, $134afd9bfa803edb$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            reject(error);
            (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $a7205b56086e6d0e$var$debouncedAutoSignInWithLink = $a7205b56086e6d0e$var$debounce($a7205b56086e6d0e$var$handleAutoSignInWithLink, 300);
const $a7205b56086e6d0e$var$debouncedAutoSignWithCodeOrUserConfirmed = $a7205b56086e6d0e$var$debounce($a7205b56086e6d0e$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
function $a7205b56086e6d0e$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $a7205b56086e6d0e$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $a7205b56086e6d0e$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        var _signInInput_options;
        const output = (signInInput === null || signInInput === void 0 ? void 0 : (_signInInput_options = signInInput.options) === null || _signInInput_options === void 0 ? void 0 : _signInInput_options.authFlowType) === "USER_AUTH" ? await (0, $94dafdacc2c41f5f$export$fcfa00cf0f5ec937)(signInInput) : await (0, $134afd9bfa803edb$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $4cbbf17ecd24694e$export$1ffa2742ce5c589b)();
    }
}
function $a7205b56086e6d0e$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $a7205b56086e6d0e$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $a7205b56086e6d0e$export$9ec2c3d010185172 = $a7205b56086e6d0e$var$autoSignInWithCode;









var $9tqwB = parcelRequire("9tqwB");










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c14fe19e6208f78b$export$f9d992c2ce90154a = ()=>async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $949cd593c14826d9$export$be467dfcc0538e25)(response);
            (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
            if (// Missing Password Error
            // 1 validation error detected: Value at 'password'failed to satisfy constraint: Member must not be null
            error.name === (0, $c50e9c939b7b9954$export$d0816902ed99fce6).InvalidParameterException && /'password'/.test(error.message) && /Member must not be null/.test(error.message)) {
                const name = (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignUpPassword;
                const { message: message, recoverySuggestion: recoverySuggestion } = (0, $c1c2568bac613fe8$export$195137955146d376)[name];
                throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
                    name: name,
                    message: message,
                    recoverySuggestion: recoverySuggestion
                });
            }
            throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        }
        return (0, $949cd593c14826d9$export$759bcb35b0d1bf81)(response);
    };
const $c14fe19e6208f78b$export$99fa98564ba4db04 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("SignUp"), $c14fe19e6208f78b$export$f9d992c2ce90154a(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $496ab4e0869013ea$export$cf64224bcd829024(input) {
    var _Amplify_getConfig_Auth;
    const { username: username, password: password, options: options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    var _authConfig_signUpVerificationMethod;
    const signUpVerificationMethod = (_authConfig_signUpVerificationMethod = authConfig === null || authConfig === void 0 ? void 0 : authConfig.signUpVerificationMethod) !== null && _authConfig_signUpVerificationMethod !== void 0 ? _authConfig_signUpVerificationMethod : "code";
    var _input_options;
    const { clientMetadata: clientMetadata, validationData: validationData, autoSignIn: autoSignIn } = (_input_options = input.options) !== null && _input_options !== void 0 ? _input_options : {};
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptySignUpUsername);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if ((signInServiceOptions === null || signInServiceOptions === void 0 ? void 0 : signInServiceOptions.authFlowType) !== "CUSTOM_WITHOUT_SRP") signInInput.password = password;
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const signUpClient = (0, $c14fe19e6208f78b$export$99fa98564ba4db04)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const signUpClientInput = {
        Username: username,
        Password: undefined,
        UserAttributes: (options === null || options === void 0 ? void 0 : options.userAttributes) && (0, $3f55e01dfb939081$export$720a7caa078a04b0)(options === null || options === void 0 ? void 0 : options.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $3f55e01dfb939081$export$720a7caa078a04b0)(validationData),
        ClientId: userPoolClientId,
        UserContextData: (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
            username: username,
            userPoolId: userPoolId,
            userPoolClientId: userPoolClientId
        })
    };
    if (password) signUpClientInput.Password = password;
    const { UserSub: userId, CodeDeliveryDetails: cdd, UserConfirmed: userConfirmed, Session: session } = await signUpClient({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SignUp)
    }, signUpClientInput);
    if (signInServiceOptions || autoSignIn === true) {
        (0, $4c604f65af804856$export$ef87a9980a3566ca).dispatch({
            type: "START"
        });
        (0, $4c604f65af804856$export$ef87a9980a3566ca).dispatch({
            type: "SET_USERNAME",
            value: username
        });
        (0, $4c604f65af804856$export$ef87a9980a3566ca).dispatch({
            type: "SET_SESSION",
            value: session
        });
    }
    const codeDeliveryDetails = {
        destination: cdd === null || cdd === void 0 ? void 0 : cdd.Destination,
        deliveryMedium: cdd === null || cdd === void 0 ? void 0 : cdd.DeliveryMedium,
        attributeName: cdd === null || cdd === void 0 ? void 0 : cdd.AttributeName
    };
    const isSignUpComplete = !!userConfirmed;
    const isAutoSignInStarted = (0, $4c604f65af804856$export$ef87a9980a3566ca).getState().active;
    // Sign Up Complete
    // No Confirm Sign In Step Required
    if (isSignUpComplete) {
        if (isAutoSignInStarted) {
            (0, $4cbbf17ecd24694e$export$7dcbf67a23c27835)((0, $a7205b56086e6d0e$export$9ec2c3d010185172)(signInInput));
            return {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "COMPLETE_AUTO_SIGN_IN"
                },
                userId: userId
            };
        }
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "DONE"
            },
            userId: userId
        };
    }
    // Sign Up Not Complete
    // Confirm Sign Up Step Required
    if (isAutoSignInStarted) {
        // Confirmation Via Link Occurs In Separate Context
        // AutoSignIn Fn Will Initiate Polling Once Executed
        if (signUpVerificationMethod === "link") {
            (0, $4cbbf17ecd24694e$export$7dcbf67a23c27835)((0, $a7205b56086e6d0e$export$feaed4858b71e8a)(signInInput));
            return {
                isSignUpComplete: false,
                nextStep: {
                    signUpStep: "COMPLETE_AUTO_SIGN_IN",
                    codeDeliveryDetails: codeDeliveryDetails
                },
                userId: userId
            };
        }
        // Confirmation Via Code Occurs In Same Context
        // AutoSignIn Next Step Will Be Returned From Confirm Sign Up
        (0, $a7205b56086e6d0e$export$385d6b43f72ecccf)(signInInput);
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: codeDeliveryDetails
        },
        userId: userId
    };
}















var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $82551ca6ac609f31$export$240a6a56ebfd6264 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("ChangePassword"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's password while authenticated.
 *
 * @param input - The UpdatePasswordInput object.
 * @throws - {@link ChangePasswordException} - Cognito service errors thrown when updating a password.
 * @throws - {@link AuthValidationErrorCode} - Validation errors thrown when oldPassword or newPassword are empty.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $6897865b04cbceda$export$e2853351e15b7895(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { oldPassword: oldPassword, newPassword: newPassword } = input;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!oldPassword, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyUpdatePassword);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!newPassword, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyUpdatePassword);
    const { tokens: tokens } = await (0, $427208a1215859a8$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    const changePassword = (0, $82551ca6ac609f31$export$240a6a56ebfd6264)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await changePassword({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).UpdatePassword)
    }, {
        AccessToken: tokens.accessToken.toString(),
        PreviousPassword: oldPassword,
        ProposedPassword: newPassword
    });
}


var $9tqwB = parcelRequire("9tqwB");














var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c57af0d1f6032b36$export$c388d1c910c14d32 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("UpdateUserAttributes"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's attributes while authenticated.
 *
 * @param input - The UpdateUserAttributesInput object
 * @returns UpdateUserAttributesOutput
 * @throws - {@link UpdateUserAttributesException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $abd26668242d1b8e$export$16ff8cb4f547be0 = async (input)=>{
    var _Amplify_getConfig_Auth;
    const { userAttributes: userAttributes, options: options } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    const clientMetadata = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $427208a1215859a8$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    const updateUserAttributesClient = (0, $c57af0d1f6032b36$export$c388d1c910c14d32)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { CodeDeliveryDetailsList: CodeDeliveryDetailsList } = await updateUserAttributesClient({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).UpdateUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString(),
        ClientMetadata: clientMetadata,
        UserAttributes: (0, $3f55e01dfb939081$export$720a7caa078a04b0)(userAttributes)
    });
    return (0, $9tqwB._)({}, $abd26668242d1b8e$var$getConfirmedAttributes(userAttributes), $abd26668242d1b8e$var$getUnConfirmedAttributes(CodeDeliveryDetailsList));
};
function $abd26668242d1b8e$var$getConfirmedAttributes(attributes) {
    var _Object_keys;
    const confirmedAttributes = {};
    (_Object_keys = Object.keys(attributes)) === null || _Object_keys === void 0 ? void 0 : _Object_keys.forEach((key)=>{
        confirmedAttributes[key] = {
            isUpdated: true,
            nextStep: {
                updateAttributeStep: "DONE"
            }
        };
    });
    return confirmedAttributes;
}
function $abd26668242d1b8e$var$getUnConfirmedAttributes(codeDeliveryDetailsList) {
    const unConfirmedAttributes = {};
    codeDeliveryDetailsList === null || codeDeliveryDetailsList === void 0 ? void 0 : codeDeliveryDetailsList.forEach((codeDeliveryDetails)=>{
        const { AttributeName: AttributeName, DeliveryMedium: DeliveryMedium, Destination: Destination } = codeDeliveryDetails;
        if (AttributeName) unConfirmedAttributes[AttributeName] = {
            isUpdated: false,
            nextStep: {
                updateAttributeStep: "CONFIRM_ATTRIBUTE_WITH_CODE",
                codeDeliveryDetails: {
                    attributeName: AttributeName,
                    deliveryMedium: DeliveryMedium,
                    destination: Destination
                }
            }
        };
    });
    return unConfirmedAttributes;
}





const $4a78ebdca8f8eb0b$var$defaultBaselineDate = {
    name: "sameTimeLastYear",
    date: (0, $35849f14f39a3bea$export$2e2bcd8739ae039).sameTimeLastYear
};
const $4a78ebdca8f8eb0b$var$debugLevel = 3;
// login handled by Amplify and Login component now
async function $4a78ebdca8f8eb0b$var$logout() {
    // get a call out to Amplify to log user out: https://github.com/aws-amplify/amplify-js/issues/614
    try {
        await (0, $bc3cbcb8cbfbe7ae$export$b0ac3a1c242cb1ea)({
            global: true
        });
        localStorage.removeItem("attributes");
    } catch (error) {
        console.log("error signing out: ", error);
    }
}
async function $4a78ebdca8f8eb0b$var$register(user) {
    if ($4a78ebdca8f8eb0b$var$debugLevel > 2) console.info("Auth.service > REGISTER: starting register for this dataset -->", JSON.stringify((0, $2qxEV._)((0, $9tqwB._)({}, user), {
        password: "********"
    })));
    const provider = user === null || user === void 0 ? void 0 : user.provider;
    let username = user === null || user === void 0 ? void 0 : user.username;
    let password = user === null || user === void 0 ? void 0 : user.password;
    // object user arrives as { user, password, email, preferred_username, tier, ... }
    // if (provider), this is the first attepmt of creating a federated user (to get the federated email); the rest is handled in federatedRegister (below)
    // because Cognito does not allow us to signUp with a preferred_username, we can only update it once the user is confirmed
    // until this moment, the username is going to be in custom:settings as "preferredUsername"
    try {
        // if we are trying to register with a provider, we need to do that first
        if (provider) {
            if ($4a78ebdca8f8eb0b$var$debugLevel > 2) console.info("Auth.service > REGISTER: federatedSignIn - stage I (do federatedSignIn and return extenrnal email) with parameter: ", provider);
            const response = await (0, $701013124925a1b1$export$3d0a7d1372e866bb)({
                provider: provider,
                customState: "thisIsTestState"
            });
            if ($4a78ebdca8f8eb0b$var$debugLevel > 2) console.info("Auth.service > REGISTER: federatedSignIn - stage I successful; waiting for callback from Cognito");
            return response; // this will anyway result in a redirect
        }
    } catch (error) {
        // if there is no Cognito user for the external email, the above will fail
        // we are expecting to see the email as error code to be used in the next step
        console.log("Auth.service > REGISTER: error in federatedSignIn (1st attempt):", error);
        if (error.message.includes("EMAIL:")) {
            username = error.code;
            password = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(); // since this is an external user signup, the password is not relevant; the user can get it reset later;
        } else throw new Error(`Auth.service > REGISTER: error while federated sign in (stage I) -- ${error}`);
    }
    let response;
    const userAttributes = {
        locale: user.locale || "de",
        "custom:settings": JSON.stringify({
            baseCurrency: user.baseCurrency,
            baselineDate: $4a78ebdca8f8eb0b$var$defaultBaselineDate.date,
            namedBaseline: $4a78ebdca8f8eb0b$var$defaultBaselineDate.name
        }),
        "custom:signup": JSON.stringify({
            preferredUsername: user.preferredUsername,
            tierId: user.tierId
        }),
        address: JSON.stringify(user.address),
        "custom:stripe_customer_id": user.stripeCustomerId,
        "custom:tours_seen": JSON.stringify([])
    };
    if (!(user === null || user === void 0 ? void 0 : user.putEmailInCustomSignupAttribute)) userAttributes.email = user.email;
    else userAttributes.name = user.email;
    try {
        if ($4a78ebdca8f8eb0b$var$debugLevel > 2) console.info("Auth.service > REGISTER: Cognito signUp with object: ", JSON.stringify((0, $2qxEV._)((0, $9tqwB._)({}, userAttributes), {
            password: "********"
        })));
        response = await (0, $496ab4e0869013ea$export$cf64224bcd829024)({
            username: user.username,
            password: user.password,
            options: {
                userAttributes: userAttributes
            }
        });
        if ($4a78ebdca8f8eb0b$var$debugLevel > 2) console.info("Auth.service > REGISTER: Cognito signUp completed with response:", response);
    } catch (error) {
        console.error("Auth.service > REGISTER: error while signing up:", error);
        throw new Error(`Auth.service > REGISTER: signupFailed --> ${error}`);
    }
    return (0, $2qxEV._)((0, $9tqwB._)({}, user), {
        status: "awaitingEmailConfirmation",
        provider: "internal"
    });
}
async function $4a78ebdca8f8eb0b$var$resendConfirmationEmail(user) {
    let response;
    try {
        const answer = await (0, $06b9fc89b90098e0$export$b295e842f1d42d13)({
            username: user.username
        });
        console.log(answer);
        // put the registration data into state for now
        response = (0, $2qxEV._)((0, $9tqwB._)({}, user), {
            status: "awaitingEmailConfirmation"
        });
    } catch (error) {
        console.log("Redux middleware: error while signing up:", error);
    }
    return response;
}
async function $4a78ebdca8f8eb0b$var$confirmUser(username, code) {
    let response;
    try {
        const responseConfirm = await (0, $300b9456de38c520$export$2ce39ab6662e8c24)({
            username: username,
            confirmationCode: code
        });
        console.log("Confirmation successful", responseConfirm);
        response = {
            status: "confirmed"
        };
    } catch (error) {
        console.log("Redux middleware: error while confirming the new account:", error);
        if (error.code === "NotAuthorizedException") // it means the user is already confirmed
        response = {
            status: "confirmed"
        };
        else throw new Error("Redux middleware: error while confirming the new account");
    }
    return response;
}
async function $4a78ebdca8f8eb0b$var$updateUserAttribute(attributeName, attributeValueAsString) {
    try {
        await (0, $abd26668242d1b8e$export$16ff8cb4f547be0)({
            userAttributes: {
                [attributeName]: attributeValueAsString
            }
        });
    } catch (error) {
        // if the user is not authenticated, we can't set up Cognito, so carry on
        if (error !== "The user is not authenticated" && (error === null || error === void 0 ? void 0 : error.message) !== "The user is not authenticated") throw new Error("cognitoUpdateFailed");
    }
}
async function $4a78ebdca8f8eb0b$var$changePassword(currentPassword, newPassword) {
    let response;
    try {
        response = await (0, $6897865b04cbceda$export$e2853351e15b7895)({
            oldPassword: currentPassword,
            newPassword: newPassword
        });
    } catch (error) {
        console.error(`changePassword error: ${error}`);
        // error code to be picked up by error handler of the action creator
        throw new Error(error.message); // 'Incorrect username or password'
    }
    return response;
}
async function $4a78ebdca8f8eb0b$var$refreshTokens() {
    try {
        const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)(true);
        console.log("createSession: ", session);
    // this throws an "NotAuthorizedException: Invalid Refresh Token" error when token is wrong
    } catch (error) {
        console.log("Redux middleware: error trying to refresh session:", error);
    }
}
async function $4a78ebdca8f8eb0b$var$addSeenTours(payload) {
    // expects string
    if (typeof payload !== "string") throw new Error("Expected parameter is id of the seen tour as string.");
    let initialToursSeen;
    let updatedToursSeen;
    try {
        const attributes = await (0, $10933498be24bbfd$export$e741ea695767fdb4)();
        if (attributes["custom:tours_seen"]) {
            const toursSeenRaw = attributes["custom:tours_seen"] || "";
            initialToursSeen = JSON.parse(toursSeenRaw);
        } else initialToursSeen = [];
        initialToursSeen = [
            ...initialToursSeen,
            payload
        ];
        await (0, $abd26668242d1b8e$export$16ff8cb4f547be0)({
            userAttributes: {
                "custom:tours_seen": JSON.stringify(initialToursSeen)
            }
        });
        updatedToursSeen = initialToursSeen;
    } catch (error) {
        console.log("Redux middleware: error while updating user attributes:", error);
        throw new Error("Redux middleware: error while updating user attributes");
    }
    //
    return updatedToursSeen;
}
async function $4a78ebdca8f8eb0b$var$updateCognitoSettings(payload) {
    // overwrites settings from payload in Cognito
    // expects object with settings { targetBaseline, namedBaseline, ... }
    let settings;
    let updatedSettings;
    try {
        const attributes = await (0, $10933498be24bbfd$export$e741ea695767fdb4)();
        settings = JSON.parse(attributes["custom:settings"]);
        updatedSettings = (0, $9tqwB._)({}, settings, payload);
        // update Cognito
        await (0, $abd26668242d1b8e$export$16ff8cb4f547be0)({
            userAttributes: {
                "custom:settings": JSON.stringify(updatedSettings)
            }
        });
    // after the update Amplify Hub has the latest version already
    } catch (error) {
        console.log("Redux middleware: error while updating user settings:", error);
        throw new Error("Redux middleware: error while updating user settings");
    }
    return payload;
}
var $4a78ebdca8f8eb0b$export$2e2bcd8739ae039 = {
    register: $4a78ebdca8f8eb0b$var$register,
    logout: $4a78ebdca8f8eb0b$var$logout,
    confirmUser: $4a78ebdca8f8eb0b$var$confirmUser,
    changePassword: $4a78ebdca8f8eb0b$var$changePassword,
    updateUserAttribute: $4a78ebdca8f8eb0b$var$updateUserAttribute,
    resendConfirmationEmail: $4a78ebdca8f8eb0b$var$resendConfirmationEmail,
    refreshTokens: $4a78ebdca8f8eb0b$var$refreshTokens,
    addSeenTours: $4a78ebdca8f8eb0b$var$addSeenTours,
    updateCognitoSettings: $4a78ebdca8f8eb0b$var$updateCognitoSettings
};


/* eslint-disable no-underscore-dangle */ // this thunk was previously part of the QUOTES reducer, but had to be moved to SHARED because it is also used by the USER reducer
// and was causing a circular dependency

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $9tqwB = parcelRequire("9tqwB");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Error class for errors that associated with unsuccessful HTTP responses.
 * It's throw by API category REST API handlers and GraphQL query handlers for now.
 */ class $acc8654184926ead$export$f2e832acab1bdd79 extends (0, $8e83a7c7b1bfe85e$export$37321a6dace1881c) {
    /**
     * The unwrapped HTTP response causing the given API error.
     */ get response() {
        return this._response ? $acc8654184926ead$var$replicateApiErrorResponse(this._response) : undefined;
    }
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $acc8654184926ead$export$f2e832acab1bdd79;
        Object.setPrototypeOf(this, $acc8654184926ead$export$f2e832acab1bdd79.prototype);
        if (params.response) this._response = params.response;
    }
}
const $acc8654184926ead$var$replicateApiErrorResponse = (response)=>(0, $2qxEV._)((0, $9tqwB._)({}, response), {
        headers: (0, $9tqwB._)({}, response.headers)
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $59c82d786907340a$export$18e4f8e37ec3871f extends (0, $acc8654184926ead$export$f2e832acab1bdd79) {
    constructor(params){
        super(params);
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $59c82d786907340a$export$18e4f8e37ec3871f;
        Object.setPrototypeOf(this, $59c82d786907340a$export$18e4f8e37ec3871f.prototype);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Internal-only class for CanceledError.
 *
 * @internal
 */ class $a22c826eb40df3d2$export$1ab0c6b20d94fa14 extends (0, $59c82d786907340a$export$18e4f8e37ec3871f) {
    constructor(params = {}){
        super((0, $9tqwB._)({
            name: "CanceledError",
            message: "Request is canceled by user"
        }, params));
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $a22c826eb40df3d2$export$1ab0c6b20d94fa14;
        Object.setPrototypeOf(this, $a22c826eb40df3d2$export$1ab0c6b20d94fa14.prototype);
    }
}
/**
 * Check if an error is caused by user calling `cancel()` in REST API.
 *
 * @note This function works **ONLY** for errors thrown by REST API. For GraphQL APIs, use `client.isCancelError(error)`
 *   instead. `client` is generated from  `generateClient()` API from `aws-amplify/api`.
 *
 * @param {unknown} error The unknown exception to be checked.
 * @returns - A boolean indicating if the error was from an upload cancellation
 */ const $a22c826eb40df3d2$export$a88a1555052550c7 = (error)=>!!error && error instanceof $a22c826eb40df3d2$export$1ab0c6b20d94fa14;




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $179309554a7f4b0f$export$8684d9f0176ec7fd;
(function(RestApiValidationErrorCode) {
    RestApiValidationErrorCode["InvalidApiName"] = "InvalidApiName";
})($179309554a7f4b0f$export$8684d9f0176ec7fd || ($179309554a7f4b0f$export$8684d9f0176ec7fd = {}));
const $179309554a7f4b0f$export$195137955146d376 = {
    [$179309554a7f4b0f$export$8684d9f0176ec7fd.InvalidApiName]: {
        message: "API name is invalid.",
        recoverySuggestion: "Check if the API name matches the one in your configuration or `aws-exports.js`"
    }
};





/**
 * Parses both AWS and non-AWS error responses coming from the users' backend code.
 * * AWS errors generated by the AWS services(e.g. API Gateway, Bedrock). They can be Signature errors,
 *   ClockSkew errors, etc. These responses will be parsed to errors with proper name and message from the AWS
 *   services.
 * * non-AWS errors thrown by the user code. They can contain any headers or body. Users need to access the
 *   error.response to get the headers and body and parse them accordingly. The JS error name and message will
 *   be `UnknownError` and `Unknown error` respectively.
 */ const $e4ec8d0675a4dd11$export$cdf23200529f687c = async (response)=>{
    if (!response) // Response is not considered an error.
    return;
    const parsedAwsError = await (0, $949cd593c14826d9$export$be467dfcc0538e25)($e4ec8d0675a4dd11$var$stubErrorResponse(response));
    if (!parsedAwsError) ;
    else {
        var _response_body;
        const bodyText = await ((_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.text());
        return $e4ec8d0675a4dd11$var$buildRestApiError(parsedAwsError, {
            statusCode: response.statusCode,
            headers: response.headers,
            body: bodyText
        });
    }
};
/**
 * The response object needs to be stub here because the parseAwsJsonError assumes the response body to be valid JSON.
 * Although this is true for AWS services, it is not true for responses from user's code. Once the response body is
 * unwrapped as JSON(and fail), it cannot be read as text again. Therefore, we need to stub the response body here to
 * make sure we can read the error response body as a JSON, and may fall back to read as text if it is not a valid JSON.
 */ const $e4ec8d0675a4dd11$var$stubErrorResponse = (response)=>{
    let bodyTextPromise;
    const bodyProxy = new Proxy(response.body, {
        get (target, prop, receiver) {
            if (prop === "json") // For potential AWS errors, error parser will try to parse the body as JSON first.
            return async ()=>{
                if (!bodyTextPromise) bodyTextPromise = target.text();
                try {
                    return JSON.parse(await bodyTextPromise);
                } catch (error) {
                    // If response body is not a valid JSON, we stub it to be an empty object and eventually parsed
                    // as an unknown error
                    return {};
                }
            };
            else if (prop === "text") // For non-AWS errors, users can access the body as a string as a fallback.
            return async ()=>{
                if (!bodyTextPromise) bodyTextPromise = target.text();
                return bodyTextPromise;
            };
            else return Reflect.get(target, prop, receiver);
        }
    });
    const responseProxy = new Proxy(response, {
        get (target, prop, receiver) {
            if (prop === "body") return bodyProxy;
            else return Reflect.get(target, prop, receiver);
        }
    });
    return responseProxy;
};
/**
 * Utility to create a new RestApiError from a service error.
 */ const $e4ec8d0675a4dd11$var$buildRestApiError = (error, response)=>{
    const restApiError = new (0, $59c82d786907340a$export$18e4f8e37ec3871f)({
        name: error === null || error === void 0 ? void 0 : error.name,
        message: error.message,
        underlyingError: error,
        response: response
    });
    // $metadata is only required for backwards compatibility.
    return Object.assign(restApiError, {
        $metadata: error.$metadata
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $012c904d7a8e89b6$export$af88d00dbe7f521 = new (0, $a7a5052bc2c3d966$export$ba6a9c7ac8291f7f)("RestApis");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $0f20d2ad25081bbc$export$52e72f0a376807e8(handler, abortController) {
    const isInternalPost = (targetHandler)=>!!abortController;
    // For creating a cancellable operation for public REST APIs, we need to create an AbortController
    // internally. Whereas for internal POST APIs, we need to accept in the AbortController from the
    // callers.
    const publicApisAbortController = new AbortController();
    const publicApisAbortSignal = publicApisAbortController.signal;
    const internalPostAbortSignal = abortController === null || abortController === void 0 ? void 0 : abortController.signal;
    let abortReason;
    const job = async ()=>{
        try {
            const response = await (isInternalPost(handler) ? handler() : handler(publicApisAbortSignal));
            if (response.statusCode >= 300) throw await (0, $e4ec8d0675a4dd11$export$cdf23200529f687c)(response);
            return response;
        } catch (error) {
            const abortSignal = internalPostAbortSignal !== null && internalPostAbortSignal !== void 0 ? internalPostAbortSignal : publicApisAbortSignal;
            const message = abortReason !== null && abortReason !== void 0 ? abortReason : abortSignal.reason;
            if (error.name === "AbortError" || (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) === true) {
                const canceledError = new (0, $a22c826eb40df3d2$export$1ab0c6b20d94fa14)((0, $2qxEV._)((0, $9tqwB._)({}, message && {
                    message: message
                }), {
                    underlyingError: error,
                    recoverySuggestion: "The API request was explicitly canceled. If this is not intended, validate if you called the `cancel()` function on the API request erroneously."
                }));
                (0, $012c904d7a8e89b6$export$af88d00dbe7f521).debug(error);
                throw canceledError;
            }
            (0, $012c904d7a8e89b6$export$af88d00dbe7f521).debug(error);
            throw error;
        }
    };
    if (isInternalPost()) return job();
    else {
        const cancel = (abortMessage)=>{
            if (publicApisAbortSignal.aborted === true) return;
            publicApisAbortController.abort(abortMessage);
            // If abort reason is not supported, set a scoped reasons instead. The reason property inside an
            // AbortSignal is a readonly property and trying to set it would throw an error.
            if (abortMessage && publicApisAbortSignal.reason !== abortMessage) abortReason = abortMessage;
        };
        return {
            response: job(),
            cancel: cancel
        };
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $23f0864265641975$export$f8920556a4a329aa = "execute-api";
const $23f0864265641975$export$30f5dbb18c8d33cd = "appsync-api";
const $23f0864265641975$export$c5a0e6a7389a299 = "us-east-1";
/**
 * The REST endpoints generated by API Gateway
 * @see {@link https://docs.aws.amazon.com/general/latest/gr/apigateway.html#apigateway_region_data_plane}
 */ const $23f0864265641975$export$df1c07b38ace96c2 = /^.+\.([a-z0-9-]+)\.([a-z0-9-]+)\.amazonaws\.com/;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Infer the signing service and region from the given URL, and for REST API only, from the Amplify configuration.
 * It supports raw API Gateway endpoint and AppSync endpoint.
 *
 * @internal
 */ const $e7091bf1bcaca72a$export$654dd12592b26445 = (url, restApiOptions)=>{
    var _restApiOptions_amplify_getConfig_API_REST, _restApiOptions_amplify_getConfig_API, _restApiOptions_amplify_getConfig;
    var _restApiOptions_amplify_getConfig_API_REST_restApiOptions_apiName;
    const { service: signingService = (0, $23f0864265641975$export$f8920556a4a329aa), region: signingRegion = (0, $23f0864265641975$export$c5a0e6a7389a299) } = (_restApiOptions_amplify_getConfig_API_REST_restApiOptions_apiName = restApiOptions === null || restApiOptions === void 0 ? void 0 : (_restApiOptions_amplify_getConfig = restApiOptions.amplify.getConfig()) === null || _restApiOptions_amplify_getConfig === void 0 ? void 0 : (_restApiOptions_amplify_getConfig_API = _restApiOptions_amplify_getConfig.API) === null || _restApiOptions_amplify_getConfig_API === void 0 ? void 0 : (_restApiOptions_amplify_getConfig_API_REST = _restApiOptions_amplify_getConfig_API.REST) === null || _restApiOptions_amplify_getConfig_API_REST === void 0 ? void 0 : _restApiOptions_amplify_getConfig_API_REST[restApiOptions === null || restApiOptions === void 0 ? void 0 : restApiOptions.apiName]) !== null && _restApiOptions_amplify_getConfig_API_REST_restApiOptions_apiName !== void 0 ? _restApiOptions_amplify_getConfig_API_REST_restApiOptions_apiName : {};
    const { hostname: hostname } = url;
    var _APIG_HOSTNAME_PATTERN_exec;
    const [, service, region] = (_APIG_HOSTNAME_PATTERN_exec = (0, $23f0864265641975$export$df1c07b38ace96c2).exec(hostname)) !== null && _APIG_HOSTNAME_PATTERN_exec !== void 0 ? _APIG_HOSTNAME_PATTERN_exec : [];
    if (service === (0, $23f0864265641975$export$f8920556a4a329aa)) // The configured endpoint is an API Gateway endpoint
    // @see: https://docs.aws.amazon.com/apigateway/latest/developerguide/how-to-call-api.html
    return {
        service: service,
        region: region !== null && region !== void 0 ? region : signingRegion
    };
    else if (service === "appsync-api") // AppSync endpoint is internally supported because GraphQL operation will send request using POST handler.
    // example: https://xxxx.appsync-api.us-east-1.amazonaws.com/graphql
    return {
        service: "appsync",
        region: region !== null && region !== void 0 ? region : signingRegion
    };
    else return {
        service: signingService,
        region: signingRegion
    };
};






var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ function $b94d8e8a7127b762$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $179309554a7f4b0f$export$195137955146d376)[name];
    if (!assertion) throw new (0, $59c82d786907340a$export$18e4f8e37ec3871f)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resolve the REST API request URL by:
 * 1. Loading the REST API endpoint from the Amplify configuration with corresponding API name.
 * 2. Appending the path to the endpoint.
 * 3. Merge the query parameters from path and the queryParameter argument which is taken from the public REST API
 *   options.
 * 4. Validating the resulting URL string.
 *
 * @internal
 */ const $f948528d13c508d9$export$74befe2cc96b2f5 = (amplify, apiName, path, queryParams)=>{
    var _amplify_getConfig_API_REST_apiName, _amplify_getConfig_API_REST, _amplify_getConfig_API, _amplify_getConfig;
    const urlStr = (_amplify_getConfig = amplify.getConfig()) === null || _amplify_getConfig === void 0 ? void 0 : (_amplify_getConfig_API = _amplify_getConfig.API) === null || _amplify_getConfig_API === void 0 ? void 0 : (_amplify_getConfig_API_REST = _amplify_getConfig_API.REST) === null || _amplify_getConfig_API_REST === void 0 ? void 0 : (_amplify_getConfig_API_REST_apiName = _amplify_getConfig_API_REST[apiName]) === null || _amplify_getConfig_API_REST_apiName === void 0 ? void 0 : _amplify_getConfig_API_REST_apiName.endpoint;
    (0, $b94d8e8a7127b762$export$45936001d12f9b53)(!!urlStr, (0, $179309554a7f4b0f$export$8684d9f0176ec7fd).InvalidApiName);
    try {
        var _location;
        let url;
        if ((0, $351b20534a6078b4$export$beb82d9d9136c16e).canParse(urlStr + path)) url = new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(urlStr + path);
        else url = new (0, $351b20534a6078b4$export$beb82d9d9136c16e)(urlStr + path, (_location = location) === null || _location === void 0 ? void 0 : _location.origin);
        if (queryParams) {
            const mergedQueryParams = new (0, $351b20534a6078b4$export$4ea7bbdac595b5fb)(url.searchParams);
            Object.entries(queryParams).forEach(([key, value])=>{
                mergedQueryParams.set(key, value);
            });
            url.search = new (0, $351b20534a6078b4$export$4ea7bbdac595b5fb)(mergedQueryParams).toString();
        }
        return url;
    } catch (error) {
        throw new (0, $59c82d786907340a$export$18e4f8e37ec3871f)((0, $2qxEV._)((0, $9tqwB._)({
            name: (0, $179309554a7f4b0f$export$8684d9f0176ec7fd).InvalidApiName
        }, (0, $179309554a7f4b0f$export$195137955146d376)[(0, $179309554a7f4b0f$export$8684d9f0176ec7fd).InvalidApiName]), {
            recoverySuggestion: `Please make sure the REST endpoint URL is a valid URL string. Got ${urlStr}`
        }));
    }
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Determines if IAM authentication should be applied for a GraphQL request.
 *
 * This function checks the `headers` of the HTTP request to determine if IAM authentication
 * is applicable. IAM authentication is considered applicable if there is no `authorization`
 * header, no `x-api-key` header, and `signingServiceInfo` is provided.
 *
 * @param request - The HTTP request object containing headers.
 * @param signingServiceInfo - Optional signing service information,
 * including service and region.
 * @returns A boolean `true` if IAM authentication should be applied.
 *
 * @internal
 */ const $0db99ad04a332e05$export$110fc5362a5a362d = ({ headers: headers }, signingServiceInfo)=>!headers.authorization && !headers["x-api-key"] && !!signingServiceInfo;
/**
 * Determines if IAM authentication should be applied for a REST request.
 *
 * This function checks the `headers` of the HTTP request to determine if IAM authentication
 * is applicable. IAM authentication is considered applicable if there is no `authorization`
 * header and `signingServiceInfo` is provided.
 *
 * @param request - The HTTP request object containing headers.
 * @param signingServiceInfo - Optional signing service information,
 * including service and region.
 * @returns A boolean `true` if IAM authentication should be applied.
 *
 * @internal
 */ const $0db99ad04a332e05$export$71fd2df8c175c331 = ({ headers: headers }, signingServiceInfo)=>!headers.authorization && !!signingServiceInfo;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $aa83b8a26643a24b$export$7dd43af7d8d48b8f = (headers, body)=>{
    const normalizedHeaders = {};
    for(const key in headers)normalizedHeaders[key.toLowerCase()] = headers[key];
    if (body) {
        const contentType = normalizedHeaders["content-type"];
        const isJsonCompatible = contentType && (contentType.startsWith("application/json") || contentType.startsWith("application/") && contentType.includes("+json"));
        if (!isJsonCompatible) normalizedHeaders["content-type"] = "application/json; charset=UTF-8";
        if (body instanceof FormData) /**
             * If body is a FormData we should not allow setting content-type.
             * It's because runtime HTTP handlers(xhr, fetch, undici, node-fetch,
             * etc.) will modify the content-type value when setting multipart
             * boundary.
             */ delete normalizedHeaders["content-type"];
    }
    return normalizedHeaders;
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns signed headers.
 *
 * @param headers `headers` from the request.
 * @returns List of headers included in canonical headers, separated by semicolons (;). This indicates which headers
 * are part of the signing process. Header names must use lowercase characters and must appear in alphabetical order.
 *
 * @internal
 */ const $fd01c9f98ce685d7$export$812d6f56efda9cfa = (headers)=>Object.keys(headers).map((key)=>key.toLowerCase()).sort().join(";");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// query params
const $92d50cddb159bf84$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $92d50cddb159bf84$export$6e114beec37430d7 = "X-Amz-Date";
const $92d50cddb159bf84$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $92d50cddb159bf84$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $92d50cddb159bf84$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $92d50cddb159bf84$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $92d50cddb159bf84$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $92d50cddb159bf84$export$8e1383b7eea7bee = "X-Amz-Security-Token";
// headers
const $92d50cddb159bf84$export$9924a64a4b8b0d58 = "authorization";
const $92d50cddb159bf84$export$96307741595055fc = "host";
const $92d50cddb159bf84$export$acf4b8bdf24aab34 = $92d50cddb159bf84$export$6e114beec37430d7.toLowerCase();
const $92d50cddb159bf84$export$fdc81b663012a8d2 = $92d50cddb159bf84$export$8e1383b7eea7bee.toLowerCase();
// identifiers
const $92d50cddb159bf84$export$c4bf0942098f6bb = "aws4_request";
const $92d50cddb159bf84$export$aba583fcf2c2a4e9 = "AWS4-HMAC-SHA256";
const $92d50cddb159bf84$export$c295e35583a9d67a = "AWS4";
// preset values
const $92d50cddb159bf84$export$b445dbfd1d7f2d42 = "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
const $92d50cddb159bf84$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the credential scope which restricts the resulting signature to the specified region and service.
 *
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns  A string representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 *
 * @internal
 */ const $2cff06b5f676eb81$export$a720a7c8dd7ab696 = (date, region, service)=>`${date}/${region}/${service}/${0, $92d50cddb159bf84$export$c4bf0942098f6bb}`;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns expected date strings to be used in signing.
 *
 * @param date JavaScript `Date` object.
 * @returns `FormattedDates` object containing the following:
 * - longDate: A date string in 'YYYYMMDDThhmmssZ' format
 * - shortDate: A date string in 'YYYYMMDD' format
 *
 * @internal
 */ const $97c20613caf353ae$export$79cc774850e3b1b = (date)=>{
    const longDate = date.toISOString().replace(/[:-]|\.\d{3}/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Extracts common values used for signing both requests and urls.
 *
 * @param options `SignRequestOptions` object containing values used to construct the signature.
 * @returns Common `SigningValues` used for signing.
 *
 * @internal
 */ const $ec71c1d2c434cbd9$export$188c70d4d3596d39 = ({ credentials: credentials, signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService, uriEscapePath: uriEscapePath = true })=>{
    // get properties from credentials
    const { accessKeyId: accessKeyId, secretAccessKey: secretAccessKey, sessionToken: sessionToken } = credentials;
    // get formatted dates for signing
    const { longDate: longDate, shortDate: shortDate } = (0, $97c20613caf353ae$export$79cc774850e3b1b)(signingDate);
    // copy header and set signing properties
    const credentialScope = (0, $2cff06b5f676eb81$export$a720a7c8dd7ab696)(shortDate, signingRegion, signingService);
    return {
        accessKeyId: accessKeyId,
        credentialScope: credentialScope,
        longDate: longDate,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
        shortDate: shortDate,
        signingRegion: signingRegion,
        signingService: signingService,
        uriEscapePath: uriEscapePath
    };
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: V6 update to different crypto dependency?
/**
 * Returns the hashed data a `Uint8Array`.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns `Uint8Array` created from the data as input to a hash function.
 */ const $34c98c634f996af8$export$1a568184069ac3c8 = (key, data)=>{
    const sha256 = new (0, $0805473ac8becd20$export$3b58ea8124ac5e28)(key !== null && key !== void 0 ? key : undefined);
    sha256.update(data);
    // TODO: V6 flip to async digest
    const hashedData = sha256.digestSync();
    return hashedData;
};
/**
 * Returns the hashed data as a hex string.
 *
 * @param key `SourceData` to be used as hashing key.
 * @param data Hashable `SourceData`.
 * @returns String using lowercase hexadecimal characters created from the data as input to a hash function.
 *
 * @internal
 */ const $34c98c634f996af8$export$45d3ccefb0f0c6da = (key, data)=>{
    const hashedData = $34c98c634f996af8$export$1a568184069ac3c8(key, data);
    return (0, $c78caa2b0705bfa1$export$7ea66e3774a60b67)(hashedData);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns canonical headers.
 *
 * @param headers Headers from the request.
 * @returns Request headers that will be signed, and their values, separated by newline characters. Header names must
 * use lowercase characters, must appear in alphabetical order, and must be followed by a colon (:). For the values,
 * trim any leading or trailing spaces, convert sequential spaces to a single space, and separate the values
 * for a multi-value header using commas.
 *
 * @internal
 */ const $eceab8b962fe91f3$export$859d7f1bb55e2914 = (headers)=>Object.entries(headers).map(([key, value])=>{
        var _value_trim_replace;
        return {
            key: key.toLowerCase(),
            value: (_value_trim_replace = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, " ")) !== null && _value_trim_replace !== void 0 ? _value_trim_replace : ""
        };
    }).sort((a, b)=>a.key < b.key ? -1 : 1).map((entry)=>`${entry.key}:${entry.value}\n`).join("");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical query string.
 *
 * @param searchParams `searchParams` from the request url.
 * @returns URL-encoded query string parameters, separated by ampersands (&). Percent-encode reserved characters,
 * including the space character. Encode names and values separately. If there are empty parameters, append the equals
 * sign to the parameter name before encoding. After encoding, sort the parameters alphabetically by key name. If there
 * is no query string, use an empty string ("").
 *
 * @internal
 */ const $e9ddeef417edbf36$export$87a9cc45e3be0a17 = (searchParams)=>Array.from(searchParams).sort(([keyA, valA], [keyB, valB])=>{
        if (keyA === keyB) return valA < valB ? -1 : 1;
        return keyA < keyB ? -1 : 1;
    }).map(([key, val])=>`${$e9ddeef417edbf36$var$escapeUri(key)}=${$e9ddeef417edbf36$var$escapeUri(val)}`).join("&");
const $e9ddeef417edbf36$var$escapeUri = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $e9ddeef417edbf36$var$hexEncode);
const $e9ddeef417edbf36$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical uri.
 *
 * @param pathname `pathname` from request url.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns URI-encoded version of the absolute path component URL (everything between the host and the question mark
 * character (?) that starts the query string parameters). If the absolute path is empty, a forward slash character (/).
 *
 * @internal
 */ const $378e22576af99ba6$export$4bbb144438cceb59 = (pathname, uriEscapePath = true)=>pathname ? uriEscapePath ? encodeURIComponent(pathname).replace(/%2F/g, "/") : pathname : "/";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the hashed payload.
 *
 * @param body `body` (payload) from the request.
 * @returns String created using the payload in the body of the HTTP request as input to a hash function. This string
 * uses lowercase hexadecimal characters. If the payload is empty, return precalculated result of an empty hash.
 *
 * @internal
 */ const $363738270536dc6e$export$b671a27d01dfc160 = (body)=>{
    // return precalculated empty hash if body is undefined or null
    if (body == null) return 0, $92d50cddb159bf84$export$b445dbfd1d7f2d42;
    if ($363738270536dc6e$var$isSourceData(body)) {
        const hashedData = (0, $34c98c634f996af8$export$45d3ccefb0f0c6da)(null, body);
        return hashedData;
    }
    // Defined body is not signable. Return unsigned payload which may or may not be accepted by the service.
    return 0, $92d50cddb159bf84$export$91f7321b40d9fd07;
};
const $363738270536dc6e$var$isSourceData = (body)=>typeof body === "string" || ArrayBuffer.isView(body) || $363738270536dc6e$var$isArrayBuffer(body);
const $363738270536dc6e$var$isArrayBuffer = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a canonical request.
 *
 * @param request `HttpRequest` from which to create the canonical request from.
 * @param uriEscapePath Whether to uri encode the path as part of canonical uri. It's used for S3 only where the
 *   pathname is already uri encoded, and the signing process is not expected to uri encode it again. Defaults to true.
 * @returns String created by by concatenating the following strings, separated by newline characters:
 * - HTTPMethod
 * - CanonicalUri
 * - CanonicalQueryString
 * - CanonicalHeaders
 * - SignedHeaders
 * - HashedPayload
 *
 * @internal
 */ const $b5d60e06a581c8ad$export$78136353678f36ec = ({ body: body, headers: headers, method: method, url: url }, uriEscapePath = true)=>[
        method,
        (0, $378e22576af99ba6$export$4bbb144438cceb59)(url.pathname, uriEscapePath),
        (0, $e9ddeef417edbf36$export$87a9cc45e3be0a17)(url.searchParams),
        (0, $eceab8b962fe91f3$export$859d7f1bb55e2914)(headers),
        (0, $fd01c9f98ce685d7$export$812d6f56efda9cfa)(headers),
        (0, $363738270536dc6e$export$b671a27d01dfc160)(body)
    ].join("\n");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a signing key to be used for signing requests.
 *
 * @param secretAccessKey AWS secret access key from credentials.
 * @param date Current date in the format 'YYYYMMDD'.
 * @param region AWS region in which the service resides.
 * @param service Service to which the signed request is being sent.
 *
 * @returns `Uint8Array` calculated from its composite parts.
 *
 * @internal
 */ const $ce72d0ecb173ff9a$export$8b95a069d16dd783 = (secretAccessKey, date, region, service)=>{
    const key = `${(0, $92d50cddb159bf84$export$c295e35583a9d67a)}${secretAccessKey}`;
    const dateKey = (0, $34c98c634f996af8$export$1a568184069ac3c8)(key, date);
    const regionKey = (0, $34c98c634f996af8$export$1a568184069ac3c8)(dateKey, region);
    const serviceKey = (0, $34c98c634f996af8$export$1a568184069ac3c8)(regionKey, service);
    const signingKey = (0, $34c98c634f996af8$export$1a568184069ac3c8)(serviceKey, (0, $92d50cddb159bf84$export$c4bf0942098f6bb));
    return signingKey;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a string to be signed.
 *
 * @param date Current date in the format 'YYYYMMDDThhmmssZ'.
 * @param credentialScope String representing the credential scope with format 'YYYYMMDD/region/service/aws4_request'.
 * @param hashedRequest Hashed canonical request.
 *
 * @returns A string created by by concatenating the following strings, separated by newline characters:
 * - Algorithm
 * - RequestDateTime
 * - CredentialScope
 * - HashedCanonicalRequest
 *
 * @internal
 */ const $f5cf288f4531ee70$export$ff872c70ad45fed1 = (date, credentialScope, hashedRequest)=>[
        (0, $92d50cddb159bf84$export$aba583fcf2c2a4e9),
        date,
        credentialScope,
        hashedRequest
    ].join("\n");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculates and returns an AWS API Signature.
 * https://docs.aws.amazon.com/IAM/latest/UserGuide/create-signed-request.html
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns AWS API Signature to sign a request or url with.
 *
 * @internal
 */ const $c49394893dee6839$export$2f768fec5d73d91a = (request, { credentialScope: credentialScope, longDate: longDate, secretAccessKey: secretAccessKey, shortDate: shortDate, signingRegion: signingRegion, signingService: signingService, uriEscapePath: uriEscapePath })=>{
    // step 1: create a canonical request
    const canonicalRequest = (0, $b5d60e06a581c8ad$export$78136353678f36ec)(request, uriEscapePath);
    // step 2: create a hash of the canonical request
    const hashedRequest = (0, $34c98c634f996af8$export$45d3ccefb0f0c6da)(null, canonicalRequest);
    // step 3: create a string to sign
    const stringToSign = (0, $f5cf288f4531ee70$export$ff872c70ad45fed1)(longDate, credentialScope, hashedRequest);
    // step 4: calculate the signature
    const signature = (0, $34c98c634f996af8$export$45d3ccefb0f0c6da)((0, $ce72d0ecb173ff9a$export$8b95a069d16dd783)(secretAccessKey, shortDate, signingRegion, signingService), stringToSign);
    return signature;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Given a `HttpRequest`, returns a Signature Version 4 signed `HttpRequest`.
 *
 * @param request `HttpRequest` to be signed.
 * @param signRequestOptions `SignRequestOptions` object containing values used to construct the signature.
 * @returns A `HttpRequest` with authentication headers which can grant temporary access to AWS resources.
 */ const $8e9aedf6517ddb77$export$aa7d25cddbad24ed = (request, options)=>{
    const signingValues = (0, $ec71c1d2c434cbd9$export$188c70d4d3596d39)(options);
    const { accessKeyId: accessKeyId, credentialScope: credentialScope, longDate: longDate, sessionToken: sessionToken } = signingValues;
    // create the request to sign
    const headers = (0, $9tqwB._)({}, request.headers);
    headers[0, $92d50cddb159bf84$export$96307741595055fc] = request.url.host;
    headers[0, $92d50cddb159bf84$export$acf4b8bdf24aab34] = longDate;
    if (sessionToken) headers[0, $92d50cddb159bf84$export$fdc81b663012a8d2] = sessionToken;
    const requestToSign = (0, $2qxEV._)((0, $9tqwB._)({}, request), {
        headers: headers
    });
    // calculate and add the signature to the request
    const signature = (0, $c49394893dee6839$export$2f768fec5d73d91a)(requestToSign, signingValues);
    const credentialEntry = `Credential=${accessKeyId}/${credentialScope}`;
    const signedHeadersEntry = `SignedHeaders=${(0, $fd01c9f98ce685d7$export$812d6f56efda9cfa)(headers)}`;
    const signatureEntry = `Signature=${signature}`;
    headers[0, $92d50cddb159bf84$export$9924a64a4b8b0d58] = `${0, $92d50cddb159bf84$export$aba583fcf2c2a4e9} ${credentialEntry}, ${signedHeadersEntry}, ${signatureEntry}`;
    return requestToSign;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */ const $26e9d76f948f9d78$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// 5 mins in milliseconds. Ref: https://github.com/aws/aws-sdk-js-v3/blob/6c0f44fab30a1bb2134af47362a31332abc3666b/packages/middleware-signing/src/utils/isClockSkewed.ts#L10
const $d52d792a6e4b181e$var$SKEW_WINDOW = 300000;
/**
 * Checks if the provided date is within the skew window of 5 minutes.
 *
 * @param clockTimeInMilliseconds Time to check for skew in milliseconds.
 * @param clockOffsetInMilliseconds Offset to check clock against in milliseconds.
 *
 * @returns True if skewed. False otherwise.
 *
 * @internal
 */ const $d52d792a6e4b181e$export$c162a01d4a03ea6f = (clockTimeInMilliseconds, clockOffsetInMilliseconds)=>Math.abs((0, $26e9d76f948f9d78$export$86d5c90340985ada)(clockOffsetInMilliseconds).getTime() - clockTimeInMilliseconds) >= $d52d792a6e4b181e$var$SKEW_WINDOW;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns the difference between clock time and the current system time if clock is skewed.
 *
 * @param clockTimeInMilliseconds Clock time in milliseconds.
 * @param currentSystemClockOffset Current system clock offset in milliseconds.
 *
 * @internal
 */ const $85a0916c68a77294$export$1ed4d48b860b1348 = (clockTimeInMilliseconds, currentSystemClockOffset)=>{
    if ((0, $d52d792a6e4b181e$export$c162a01d4a03ea6f)(clockTimeInMilliseconds, currentSystemClockOffset)) return clockTimeInMilliseconds - Date.now();
    return currentSystemClockOffset;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware that SigV4 signs request with AWS credentials, and correct system clock offset.
 * This middleware is expected to be placed after retry middleware.
 */ const $0d5cd68830afd44b$export$d8f74542d1f00e1d = ({ credentials: credentials, region: region, service: service, uriEscapePath: uriEscapePath = true })=>{
    let currentSystemClockOffset;
    return (next, context)=>async function signingMiddleware(request) {
            currentSystemClockOffset = currentSystemClockOffset !== null && currentSystemClockOffset !== void 0 ? currentSystemClockOffset : 0;
            const signRequestOptions = {
                credentials: typeof credentials === "function" ? await credentials({
                    forceRefresh: !!(context === null || context === void 0 ? void 0 : context.isCredentialsExpired)
                }) : credentials,
                signingDate: (0, $26e9d76f948f9d78$export$86d5c90340985ada)(currentSystemClockOffset),
                signingRegion: region,
                signingService: service,
                uriEscapePath: uriEscapePath
            };
            const signedRequest = await (0, $8e9aedf6517ddb77$export$aa7d25cddbad24ed)(request, signRequestOptions);
            const response = await next(signedRequest);
            // Update system clock offset if response contains date header, regardless of the status code.
            // non-2xx response will still be returned from next handler instead of thrown, because it's
            // only thrown by the retry middleware.
            const dateString = $0d5cd68830afd44b$var$getDateHeader(response);
            if (dateString) currentSystemClockOffset = (0, $85a0916c68a77294$export$1ed4d48b860b1348)(Date.parse(dateString), currentSystemClockOffset);
            return response;
        };
};
const $0d5cd68830afd44b$var$getDateHeader = ({ headers: headers } = {})=>{
    var _headers_date, _ref;
    return (_ref = (_headers_date = headers === null || headers === void 0 ? void 0 : headers.date) !== null && _headers_date !== void 0 ? _headers_date : headers === null || headers === void 0 ? void 0 : headers.Date) !== null && _ref !== void 0 ? _ref : headers === null || headers === void 0 ? void 0 : headers["x-amz-date"];
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $f094a503e4038fff$export$caa14993632515f8 = (0, $ca66079b8e9b8f15$export$f074d76e52925468)((0, $c13272803b895f61$export$d2573baf35521e4c), [
    (0, $10d0c09cc61c9a0b$export$ff28171a05413bc5),
    (0, $f67cb4a44b7ed433$export$72f002d3da1a429f),
    (0, $0d5cd68830afd44b$export$d8f74542d1f00e1d)
]);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $4d1136277ce471cd$export$ed7e1ccf00f39c4a = (0, $ca66079b8e9b8f15$export$f074d76e52925468)((0, $c13272803b895f61$export$d2573baf35521e4c), [
    (0, $10d0c09cc61c9a0b$export$ff28171a05413bc5),
    (0, $f67cb4a44b7ed433$export$72f002d3da1a429f)
]);


/**
 * Make REST API call with best-effort IAM auth.
 * @param amplify Amplify instance to to resolve credentials and tokens. Should use different instance in client-side
 *   and SSR
 * @param options Options accepted from public API options when calling the handlers.
 * @param signingServiceInfo Internal-only options enable IAM auth as well as to to overwrite the IAM signing service
 *   and region. If specified, and NONE of API Key header or Auth header is present, IAM auth will be used.
 * @param iamAuthApplicable Callback function that is used to determine if IAM Auth should be used or not.
 *
 * @internal
 */ const $e9be5ed81af393aa$export$28f1d6139f3d8c0a = async (amplify, options, iamAuthApplicable, signingServiceInfo)=>{
    var _amplify_libraryOptions_API_REST, _amplify_libraryOptions_API, _amplify_libraryOptions;
    const { url: url, method: method, headers: headers, body: body, withCredentials: withCredentials, abortSignal: abortSignal, retryStrategy: retryStrategy } = options;
    const resolvedBody = body ? body instanceof FormData ? body : JSON.stringify(body !== null && body !== void 0 ? body : "") : undefined;
    const resolvedHeaders = (0, $aa83b8a26643a24b$export$7dd43af7d8d48b8f)(headers, body);
    const request = {
        url: url,
        headers: resolvedHeaders,
        method: method,
        body: resolvedBody
    };
    const baseOptions = {
        retryDecider: $e9be5ed81af393aa$var$getRetryDeciderFromStrategy(retryStrategy !== null && retryStrategy !== void 0 ? retryStrategy : amplify === null || amplify === void 0 ? void 0 : (_amplify_libraryOptions = amplify.libraryOptions) === null || _amplify_libraryOptions === void 0 ? void 0 : (_amplify_libraryOptions_API = _amplify_libraryOptions.API) === null || _amplify_libraryOptions_API === void 0 ? void 0 : (_amplify_libraryOptions_API_REST = _amplify_libraryOptions_API.REST) === null || _amplify_libraryOptions_API_REST === void 0 ? void 0 : _amplify_libraryOptions_API_REST.retryStrategy),
        computeDelay: (0, $589339b0e81d9df9$export$caea50bde345f648),
        withCrossDomainCredentials: withCredentials,
        abortSignal: abortSignal
    };
    const isIamAuthApplicable = iamAuthApplicable(request, signingServiceInfo);
    let response;
    const credentials = await $e9be5ed81af393aa$var$resolveCredentials(amplify);
    if (isIamAuthApplicable && credentials) {
        const signingInfoFromUrl = (0, $e7091bf1bcaca72a$export$654dd12592b26445)(url);
        var _signingServiceInfo_service;
        const signingService = (_signingServiceInfo_service = signingServiceInfo === null || signingServiceInfo === void 0 ? void 0 : signingServiceInfo.service) !== null && _signingServiceInfo_service !== void 0 ? _signingServiceInfo_service : signingInfoFromUrl.service;
        var _signingServiceInfo_region;
        const signingRegion = (_signingServiceInfo_region = signingServiceInfo === null || signingServiceInfo === void 0 ? void 0 : signingServiceInfo.region) !== null && _signingServiceInfo_region !== void 0 ? _signingServiceInfo_region : signingInfoFromUrl.region;
        response = await (0, $f094a503e4038fff$export$caa14993632515f8)(request, (0, $2qxEV._)((0, $9tqwB._)({}, baseOptions), {
            credentials: credentials,
            region: signingRegion,
            service: signingService
        }));
    } else response = await (0, $4d1136277ce471cd$export$ed7e1ccf00f39c4a)(request, (0, $9tqwB._)({}, baseOptions));
    // Clean-up un-modeled properties from response.
    return {
        statusCode: response.statusCode,
        headers: response.headers,
        body: response.body
    };
};
const $e9be5ed81af393aa$var$getRetryDeciderFromStrategy = (retryStrategy)=>{
    const strategy = retryStrategy === null || retryStrategy === void 0 ? void 0 : retryStrategy.strategy;
    if (strategy === "no-retry") return ()=>Promise.resolve({
            retryable: false
        });
    return (0, $54d06369619ec70c$export$b919d98317a7685f)((0, $e4ec8d0675a4dd11$export$cdf23200529f687c));
};
const $e9be5ed81af393aa$var$resolveCredentials = async (amplify)=>{
    try {
        const { credentials: credentials } = await amplify.Auth.fetchAuthSession();
        if (credentials) return credentials;
    } catch (e) {
        (0, $012c904d7a8e89b6$export$af88d00dbe7f521).debug("No credentials available, the request will be unsigned.");
    }
    return null;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cc8b61e620d288c3$var$publicHandler = (amplify, options, method)=>(0, $0f20d2ad25081bbc$export$52e72f0a376807e8)(async (abortSignal)=>{
        var _amplify_libraryOptions_API_REST_headers, _amplify_libraryOptions_API_REST, _amplify_libraryOptions_API, _amplify_libraryOptions;
        const { apiName: apiName, options: apiOptions = {}, path: apiPath } = options;
        const url = (0, $f948528d13c508d9$export$74befe2cc96b2f5)(amplify, apiName, apiPath, apiOptions === null || apiOptions === void 0 ? void 0 : apiOptions.queryParams);
        const libraryConfigHeaders = await ((_amplify_libraryOptions = amplify.libraryOptions) === null || _amplify_libraryOptions === void 0 ? void 0 : (_amplify_libraryOptions_API = _amplify_libraryOptions.API) === null || _amplify_libraryOptions_API === void 0 ? void 0 : (_amplify_libraryOptions_API_REST = _amplify_libraryOptions_API.REST) === null || _amplify_libraryOptions_API_REST === void 0 ? void 0 : (_amplify_libraryOptions_API_REST_headers = _amplify_libraryOptions_API_REST.headers) === null || _amplify_libraryOptions_API_REST_headers === void 0 ? void 0 : _amplify_libraryOptions_API_REST_headers.call(_amplify_libraryOptions_API_REST, {
            apiName: apiName
        }));
        const { headers: invocationHeaders = {} } = apiOptions;
        const headers = (0, $9tqwB._)({}, libraryConfigHeaders, invocationHeaders);
        const signingServiceInfo = (0, $e7091bf1bcaca72a$export$654dd12592b26445)(url, {
            amplify: amplify,
            apiName: apiName
        });
        (0, $012c904d7a8e89b6$export$af88d00dbe7f521).debug(method, url, headers, `IAM signing options: ${JSON.stringify(signingServiceInfo)}`);
        return (0, $e9be5ed81af393aa$export$28f1d6139f3d8c0a)(amplify, (0, $2qxEV._)((0, $9tqwB._)({}, apiOptions), {
            url: url,
            method: method,
            headers: headers,
            abortSignal: abortSignal
        }), (0, $0db99ad04a332e05$export$71fd2df8c175c331), signingServiceInfo);
    });
const $cc8b61e620d288c3$export$3988ae62b71be9a3 = (amplify, input)=>$cc8b61e620d288c3$var$publicHandler(amplify, input, "GET");
const $cc8b61e620d288c3$export$299ba2dee77727e9 = (amplify, input)=>$cc8b61e620d288c3$var$publicHandler(amplify, input, "POST");
const $cc8b61e620d288c3$export$327f7b26ebf455db = (amplify, input)=>$cc8b61e620d288c3$var$publicHandler(amplify, input, "PUT");
const $cc8b61e620d288c3$export$1d2f21e549771e67 = (amplify, input)=>$cc8b61e620d288c3$var$publicHandler(amplify, input, "DELETE");
const $cc8b61e620d288c3$export$5fd5031fecdacec3 = (amplify, input)=>$cc8b61e620d288c3$var$publicHandler(amplify, input, "HEAD");
const $cc8b61e620d288c3$export$b76953f99ab2be78 = (amplify, input)=>$cc8b61e620d288c3$var$publicHandler(amplify, input, "PATCH");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * GET HTTP request
 * @param {GetInput} input - Input for GET operation
 * @returns {GetOperation} Operation for GET request
 * @throws - {@link RestApiError}
 * @example
 * Send a GET request
 * ```js
 * import { get, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await get({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a GET request
 *
 * ```js
 * import { get, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = get({apiName, path, options});
 * cancel(message);
 * try {
 *   await response;
 * } catch (e) {
 *   if (isCancelError(e)) {
 *    // handle request cancellation
 *   }
 *   //...
 * }
 * ```
 */ const $e7da198efd7bc70f$export$3988ae62b71be9a3 = (input)=>(0, $cc8b61e620d288c3$export$3988ae62b71be9a3)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), input);
/**
 * POST HTTP request
 * @param {PostInput} input - Input for POST operation
 * @returns {PostOperation} Operation for POST request
 * @throws - {@link RestApiError}
 * @example
 * Send a POST request
 * ```js
 * import { post, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await post({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a POST request
 *
 * ```js
 * import { post, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = post({apiName, path, options});
 * cancel(message);
 * try {
 *   await response;
 * } catch (e) {
 *   if (isCancelError(e)) {
 *    // handle request cancellation
 *   }
 *   //...
 * }
 * ```
 */ const $e7da198efd7bc70f$export$299ba2dee77727e9 = (input)=>(0, $cc8b61e620d288c3$export$299ba2dee77727e9)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), input);
/**
 * PUT HTTP request
 * @param {PutInput} input - Input for PUT operation
 * @returns {PutOperation} Operation for PUT request
 * @throws - {@link RestApiError}
 * @example
 * Send a PUT request
 * ```js
 * import { put, isCancelError } from '@aws-amplify/api';
 *
 * const { body } = await put({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 * @example
 * Cancel a PUT request
 * ```js
 * import { put, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = put({apiName, path, options});
 * cancel(message);
 * try {
 *  await response;
 * } catch (e) {
 *   if (isCancelError(e)) {
 *     // handle request cancellation
 *   }
 * //...
 * }
 * ```
 */ const $e7da198efd7bc70f$export$327f7b26ebf455db = (input)=>(0, $cc8b61e620d288c3$export$327f7b26ebf455db)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), input);
/**
 * DELETE HTTP request
 * @param {DeleteInput} input - Input for DELETE operation
 * @returns {DeleteOperation} Operation for DELETE request
 * @throws - {@link RestApiError}
 * @example
 * Send a DELETE request
 * ```js
 * import { del } from '@aws-amplify/api';
 *
 * const { statusCode } = await del({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * ```
 */ const $e7da198efd7bc70f$export$1d2f21e549771e67 = (input)=>(0, $cc8b61e620d288c3$export$1d2f21e549771e67)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), input);
/**
 * HEAD HTTP request
 * @param {HeadInput} input - Input for HEAD operation
 * @returns {HeadOperation} Operation for HEAD request
 * @throws - {@link RestApiError}
 * @example
 * Send a HEAD request
 * ```js
 * import { head, isCancelError } from '@aws-amplify/api';
 *
 * const { headers, statusCode } = await head({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     queryParams, // Optional, A map of query strings
 *   }
 * }),response;
 * ```
 *
 */ const $e7da198efd7bc70f$export$5fd5031fecdacec3 = (input)=>(0, $cc8b61e620d288c3$export$5fd5031fecdacec3)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), input);
/**
 * PATCH HTTP request
 * @param {PatchInput} input - Input for PATCH operation
 * @returns {PatchOperation} Operation for PATCH request
 * @throws - {@link RestApiError}
 * @example
 * Send a PATCH request
 * ```js
 * import { patch } from '@aws-amplify/api';
 *
 * const { body } = await patch({
 *   apiName,
 *   path,
 *   options: {
 *     headers, // Optional, A map of custom header key/values
 *     body, // Optional, JSON object or FormData
 *     queryParams, // Optional, A map of query strings
 *   }
 * }).response;
 * const data = await body.json();
 * ```
 *
 * @example
 * Cancel a PATCH request
 * ```js
 * import { patch, isCancelError } from '@aws-amplify/api';
 *
 * const { response, cancel } = patch({apiName, path, options});
 * cancel(message);
 * try {
 *  await response;
 * } catch (e) {
 *  if (isCancelError(e)) {
 *   // handle request cancellation
 *  }
 * //...
 * }
 * ```
 */ const $e7da198efd7bc70f$export$b76953f99ab2be78 = (input)=>(0, $cc8b61e620d288c3$export$b76953f99ab2be78)((0, $f4c06b47af4364f4$export$a3858a9a153cffc7), input);





async function $bad5f4197326a006$var$resolveResponse(operation, { returnFullResponse: returnFullResponse = false } = {}) {
    const { response: response } = operation;
    const restResponse = await response;
    if (returnFullResponse) return restResponse;
    const { body: body } = restResponse;
    if (!body) return undefined;
    if (typeof body.json === "function") try {
        return await body.json();
    } catch (error) {
        if (typeof body.text === "function") {
            const text = await body.text();
            try {
                return text ? JSON.parse(text) : undefined;
            } catch (e) {
                return text;
            }
        }
        throw error;
    }
    if (typeof body.text === "function") {
        const text = await body.text();
        try {
            return text ? JSON.parse(text) : undefined;
        } catch (e) {
            return text;
        }
    }
    return undefined;
}
function $bad5f4197326a006$var$buildOptions(init = {}) {
    const { headers: headers, body: body, queryStringParameters: queryStringParameters, response: response, withCredentials: withCredentials, abortController: abortController } = init, rest = (0, $bLhVg._)(init, [
        "headers",
        "body",
        "queryStringParameters",
        "response",
        "withCredentials",
        "abortController"
    ]);
    return {
        operationOptions: (0, $9tqwB._)({
            headers: headers,
            body: body,
            queryParams: queryStringParameters,
            withCredentials: withCredentials,
            abortSignal: abortController === null || abortController === void 0 ? void 0 : abortController.signal
        }, rest),
        returnFullResponse: response === true
    };
}
async function $bad5f4197326a006$export$b216272c8be3751a(apiName, path, init = {}) {
    const { operationOptions: operationOptions, returnFullResponse: returnFullResponse } = $bad5f4197326a006$var$buildOptions(init);
    const operation = (0, $e7da198efd7bc70f$export$3988ae62b71be9a3)({
        apiName: apiName,
        path: path,
        options: operationOptions
    });
    return $bad5f4197326a006$var$resolveResponse(operation, {
        returnFullResponse: returnFullResponse
    });
}
async function $bad5f4197326a006$export$bd1dc54ad3b0ef79(apiName, path, init = {}) {
    const { operationOptions: operationOptions, returnFullResponse: returnFullResponse } = $bad5f4197326a006$var$buildOptions(init);
    const operation = (0, $e7da198efd7bc70f$export$299ba2dee77727e9)({
        apiName: apiName,
        path: path,
        options: operationOptions
    });
    return $bad5f4197326a006$var$resolveResponse(operation, {
        returnFullResponse: returnFullResponse
    });
}
async function $bad5f4197326a006$export$6dd598fa143977b0(apiName, path, init = {}) {
    const { operationOptions: operationOptions, returnFullResponse: returnFullResponse } = $bad5f4197326a006$var$buildOptions(init);
    const operation = (0, $e7da198efd7bc70f$export$327f7b26ebf455db)({
        apiName: apiName,
        path: path,
        options: operationOptions
    });
    return $bad5f4197326a006$var$resolveResponse(operation, {
        returnFullResponse: returnFullResponse
    });
}
async function $bad5f4197326a006$export$bb2abc1fe2f1c239(apiName, path, init = {}) {
    const { operationOptions: operationOptions, returnFullResponse: returnFullResponse } = $bad5f4197326a006$var$buildOptions(init);
    const operation = (0, $e7da198efd7bc70f$export$1d2f21e549771e67)({
        apiName: apiName,
        path: path,
        options: operationOptions
    });
    return $bad5f4197326a006$var$resolveResponse(operation, {
        returnFullResponse: returnFullResponse
    });
}
async function $bad5f4197326a006$export$9c15fcddf857e98f(apiName, path, init = {}) {
    const { operationOptions: operationOptions, returnFullResponse: returnFullResponse } = $bad5f4197326a006$var$buildOptions(init);
    const operation = (0, $e7da198efd7bc70f$export$5fd5031fecdacec3)({
        apiName: apiName,
        path: path,
        options: operationOptions
    });
    return $bad5f4197326a006$var$resolveResponse(operation, {
        returnFullResponse: returnFullResponse
    });
}
async function $bad5f4197326a006$export$612dbba115aa5290(apiName, path, init = {}) {
    const { operationOptions: operationOptions, returnFullResponse: returnFullResponse } = $bad5f4197326a006$var$buildOptions(init);
    const operation = (0, $e7da198efd7bc70f$export$b76953f99ab2be78)({
        apiName: apiName,
        path: path,
        options: operationOptions
    });
    return $bad5f4197326a006$var$resolveResponse(operation, {
        returnFullResponse: returnFullResponse
    });
}
async function $bad5f4197326a006$var$withAuthorization(init = {}) {
    var _session_tokens_idToken, _session_tokens;
    const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
    const token = (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString();
    if (!token) throw new Error("Missing authentication token");
    return (0, $2qxEV._)((0, $9tqwB._)({}, init), {
        headers: (0, $2qxEV._)((0, $9tqwB._)({}, init.headers || {}), {
            Authorization: token
        })
    });
}
async function $bad5f4197326a006$export$f9b80e5c5f37b582(apiName, path, init = {}) {
    return $bad5f4197326a006$export$b216272c8be3751a(apiName, path, await $bad5f4197326a006$var$withAuthorization(init));
}
async function $bad5f4197326a006$export$29243fdc58d23ee6(apiName, path, init = {}) {
    return $bad5f4197326a006$export$bd1dc54ad3b0ef79(apiName, path, await $bad5f4197326a006$var$withAuthorization(init));
}
async function $bad5f4197326a006$export$8de8f9d6a7611c85(apiName, path, init = {}) {
    return $bad5f4197326a006$export$6dd598fa143977b0(apiName, path, await $bad5f4197326a006$var$withAuthorization(init));
}
async function $bad5f4197326a006$export$d94f928774096e78(apiName, path, init = {}) {
    return $bad5f4197326a006$export$bb2abc1fe2f1c239(apiName, path, await $bad5f4197326a006$var$withAuthorization(init));
}
async function $bad5f4197326a006$export$8ae90e84114eb8a1(apiName, path, init = {}) {
    return $bad5f4197326a006$export$612dbba115aa5290(apiName, path, await $bad5f4197326a006$var$withAuthorization(init));
}



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
const $b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY = "quotesBootstrapDone";
const $b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY = "quotesIsolatedBootstrapDone";
const $b38588f9e2856d34$var$inMemoryBootstrapFlags = {};
function $b38588f9e2856d34$var$getSessionStorage() {
    if (typeof window !== "undefined" && window.sessionStorage) return window.sessionStorage;
    if (typeof sessionStorage !== "undefined") return sessionStorage;
    return null;
}
function $b38588f9e2856d34$var$hasBootstrapRun(sessionKey) {
    const storage = $b38588f9e2856d34$var$getSessionStorage();
    if (storage) return storage.getItem(sessionKey) === "1";
    return $b38588f9e2856d34$var$inMemoryBootstrapFlags[sessionKey] === "1";
}
function $b38588f9e2856d34$var$markBootstrapDone(sessionKey) {
    const storage = $b38588f9e2856d34$var$getSessionStorage();
    if (storage) storage.setItem(sessionKey, "1");
    $b38588f9e2856d34$var$inMemoryBootstrapFlags[sessionKey] = "1";
}
function $b38588f9e2856d34$var$clearBootstrapDone(sessionKey) {
    const storage = $b38588f9e2856d34$var$getSessionStorage();
    if (storage) storage.removeItem(sessionKey);
    delete $b38588f9e2856d34$var$inMemoryBootstrapFlags[sessionKey];
}
function $b38588f9e2856d34$var$toNumericDate(date) {
    if (typeof date === "number" && Number.isFinite(date)) return date;
    if (typeof date === "string" && /^\d+$/.test(date)) return Number(date);
    return null;
}
function $b38588f9e2856d34$var$normalizeDates(dates = []) {
    return [
        ...new Set((dates || []).map((date)=>$b38588f9e2856d34$var$toNumericDate(date)).filter((date)=>date !== null))
    ].sort((a, b)=>a - b);
}
function $b38588f9e2856d34$var$maxDateOrNow(dates = []) {
    if (dates.length > 0) return Math.max(...dates);
    return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month").startOf("day").valueOf();
}
function $b38588f9e2856d34$var$generateMonthStartDates(start, end) {
    if (!Number.isFinite(start) || !Number.isFinite(end) || start > end) return [];
    const output = [];
    let cursor = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).startOf("month").startOf("day").valueOf();
    const limit = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(end).startOf("month").startOf("day").valueOf();
    while(cursor <= limit){
        output.push(cursor);
        cursor = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(cursor).add(1, "month").startOf("month").startOf("day").valueOf();
    }
    return output;
}
function $b38588f9e2856d34$var$collectDataTransactions(state) {
    const categories = Object.values((state === null || state === void 0 ? void 0 : state.data) || {});
    return categories.flatMap((categoryData)=>((categoryData === null || categoryData === void 0 ? void 0 : categoryData.transactions) || []).concat((categoryData === null || categoryData === void 0 ? void 0 : categoryData.simulatedTransactions) || []));
}
function $b38588f9e2856d34$var$getProviderAssetIdKey(providerAssetId) {
    if (!providerAssetId) return "";
    if (typeof providerAssetId === "object") return JSON.stringify(providerAssetId);
    return String(providerAssetId);
}
function $b38588f9e2856d34$var$toApiAsset(asset) {
    return (0, $2qxEV._)((0, $9tqwB._)({}, asset), {
        providerAssetId: (asset === null || asset === void 0 ? void 0 : asset.providerAssetId) || null,
        currency: (asset === null || asset === void 0 ? void 0 : asset.currency) || (asset === null || asset === void 0 ? void 0 : asset.transactionCurrency) || (asset === null || asset === void 0 ? void 0 : asset.assetCurrency) || (asset === null || asset === void 0 ? void 0 : asset.accountCurrency)
    });
}
function $b38588f9e2856d34$var$assetScopeKey(asset) {
    const normalized = $b38588f9e2856d34$var$toApiAsset(asset || {});
    const currency = (normalized === null || normalized === void 0 ? void 0 : normalized.currency) || "";
    return `${(normalized === null || normalized === void 0 ? void 0 : normalized.assetId) || ""}|${$b38588f9e2856d34$var$getProviderAssetIdKey(normalized === null || normalized === void 0 ? void 0 : normalized.providerAssetId)}|${currency}`;
}
function $b38588f9e2856d34$var$dedupeAssets(assets = []) {
    const seen = new Set();
    const output = [];
    assets.forEach((asset)=>{
        const normalized = $b38588f9e2856d34$var$toApiAsset(asset || {});
        if (!(normalized === null || normalized === void 0 ? void 0 : normalized.assetId)) return;
        const key = $b38588f9e2856d34$var$assetScopeKey(normalized);
        if (seen.has(key)) return;
        seen.add(key);
        output.push(normalized);
    });
    return output;
}
function $b38588f9e2856d34$var$getAssetsFromScopes(scopes = []) {
    return $b38588f9e2856d34$var$dedupeAssets((scopes || []).map((scope)=>scope === null || scope === void 0 ? void 0 : scope.asset).filter(Boolean));
}
function $b38588f9e2856d34$var$normalizeScope(scope = {}) {
    const asset = $b38588f9e2856d34$var$toApiAsset((scope === null || scope === void 0 ? void 0 : scope.asset) || {});
    if (!(asset === null || asset === void 0 ? void 0 : asset.assetId)) return null;
    const requiredDates = $b38588f9e2856d34$var$normalizeDates((scope === null || scope === void 0 ? void 0 : scope.requiredDates) || []);
    const fallbackDate = requiredDates.length > 0 ? Math.max(...requiredDates) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month").startOf("day").valueOf();
    const rawFromDate = $b38588f9e2856d34$var$toNumericDate(scope === null || scope === void 0 ? void 0 : scope.fromDate);
    const rawToDate = $b38588f9e2856d34$var$toNumericDate(scope === null || scope === void 0 ? void 0 : scope.toDate);
    const fromDate = rawFromDate === null ? fallbackDate : rawFromDate;
    const toDate = rawToDate === null ? Math.max(fromDate, fallbackDate) : rawToDate;
    const normalizedFrom = Math.min(fromDate, toDate);
    const normalizedTo = Math.max(fromDate, toDate);
    const normalizedRequiredDates = requiredDates.length > 0 ? requiredDates : [
        normalizedTo
    ];
    var _scope_includeManualQuotes;
    return {
        asset: asset,
        fromDate: normalizedFrom,
        toDate: normalizedTo,
        requiredDates: normalizedRequiredDates,
        includeManualQuotes: (_scope_includeManualQuotes = scope === null || scope === void 0 ? void 0 : scope.includeManualQuotes) !== null && _scope_includeManualQuotes !== void 0 ? _scope_includeManualQuotes : true
    };
}
function $b38588f9e2856d34$var$normalizeScopes(scopes = []) {
    const byKey = {};
    (scopes || []).forEach((scope)=>{
        const normalizedScope = $b38588f9e2856d34$var$normalizeScope(scope);
        if (!normalizedScope) return;
        const key = $b38588f9e2856d34$var$assetScopeKey(normalizedScope.asset);
        const existing = byKey[key];
        if (!existing) {
            byKey[key] = normalizedScope;
            return;
        }
        byKey[key] = (0, $2qxEV._)((0, $9tqwB._)({}, existing), {
            fromDate: Math.min(existing.fromDate, normalizedScope.fromDate),
            toDate: Math.max(existing.toDate, normalizedScope.toDate),
            requiredDates: $b38588f9e2856d34$var$normalizeDates((existing.requiredDates || []).concat(normalizedScope.requiredDates || [])),
            includeManualQuotes: Boolean(existing.includeManualQuotes || normalizedScope.includeManualQuotes)
        });
    });
    return Object.keys(byKey).sort().map((key)=>byKey[key]);
}
function $b38588f9e2856d34$var$getDatesFromScopes(scopes = []) {
    const dates = [];
    (scopes || []).forEach((scope)=>{
        dates.push(...$b38588f9e2856d34$var$normalizeDates((scope === null || scope === void 0 ? void 0 : scope.requiredDates) || []));
        const fromDate = $b38588f9e2856d34$var$toNumericDate(scope === null || scope === void 0 ? void 0 : scope.fromDate);
        if (fromDate !== null) dates.push(fromDate);
        const toDate = $b38588f9e2856d34$var$toNumericDate(scope === null || scope === void 0 ? void 0 : scope.toDate);
        if (toDate !== null) dates.push(toDate);
    });
    return $b38588f9e2856d34$var$normalizeDates(dates);
}
function $b38588f9e2856d34$var$getExpandedDatesFromScopes(scopes = []) {
    const dates = [];
    (scopes || []).forEach((scope)=>{
        const fromDate = $b38588f9e2856d34$var$toNumericDate(scope === null || scope === void 0 ? void 0 : scope.fromDate);
        const toDate = $b38588f9e2856d34$var$toNumericDate(scope === null || scope === void 0 ? void 0 : scope.toDate);
        if (fromDate !== null) dates.push(fromDate);
        if (toDate !== null) dates.push(toDate);
        dates.push(...$b38588f9e2856d34$var$normalizeDates((scope === null || scope === void 0 ? void 0 : scope.requiredDates) || []));
        if (fromDate !== null && toDate !== null) dates.push(...$b38588f9e2856d34$var$generateMonthStartDates(Math.min(fromDate, toDate), Math.max(fromDate, toDate)));
    });
    return $b38588f9e2856d34$var$normalizeDates(dates);
}
function $b38588f9e2856d34$var$collectScopeCandidatesFromTransaction(transaction = {}) {
    const category = transaction === null || transaction === void 0 ? void 0 : transaction.category;
    const providerAssetId = (transaction === null || transaction === void 0 ? void 0 : transaction.providerAssetId) || null;
    const currency = (transaction === null || transaction === void 0 ? void 0 : transaction.assetCurrency) || (transaction === null || transaction === void 0 ? void 0 : transaction.accountCurrency) || (transaction === null || transaction === void 0 ? void 0 : transaction.transactionCurrency) || (transaction === null || transaction === void 0 ? void 0 : transaction.currency);
    const scopeCandidates = [];
    if (transaction === null || transaction === void 0 ? void 0 : transaction.assetId) scopeCandidates.push({
        assetId: transaction.assetId,
        providerAssetId: providerAssetId,
        currency: currency,
        category: category
    });
    [
        "transactionCurrency",
        "accountCurrency",
        "assetCurrency",
        "currency"
    ].forEach((currencyField)=>{
        const currencyCode = transaction === null || transaction === void 0 ? void 0 : transaction[currencyField];
        if (!currencyCode) return;
        scopeCandidates.push({
            assetId: currencyCode,
            providerAssetId: null,
            currency: currencyCode,
            category: category
        });
    });
    return $b38588f9e2856d34$var$dedupeAssets(scopeCandidates);
}
function $b38588f9e2856d34$var$extractAssetsFromTransactions(transactions = []) {
    return $b38588f9e2856d34$var$dedupeAssets(transactions.flatMap((transaction)=>$b38588f9e2856d34$var$collectScopeCandidatesFromTransaction(transaction)));
}
function $b38588f9e2856d34$var$extractAssetDateBoundsFromTransactions(transactions = []) {
    const bounds = {};
    transactions.forEach((transaction)=>{
        const numericDate = $b38588f9e2856d34$var$toNumericDate(transaction === null || transaction === void 0 ? void 0 : transaction.date);
        if (numericDate === null) return;
        $b38588f9e2856d34$var$collectScopeCandidatesFromTransaction(transaction).forEach((asset)=>{
            const key = $b38588f9e2856d34$var$assetScopeKey(asset);
            if (!bounds[key]) {
                bounds[key] = {
                    minDate: numericDate,
                    maxDate: numericDate
                };
                return;
            }
            if (numericDate < bounds[key].minDate) bounds[key].minDate = numericDate;
            if (numericDate > bounds[key].maxDate) bounds[key].maxDate = numericDate;
        });
    });
    return bounds;
}
function $b38588f9e2856d34$var$normalizeIncomingRequestScope(body = {}) {
    const incomingScopes = Array.isArray(body === null || body === void 0 ? void 0 : body.scopes) ? body.scopes : [];
    const incomingAssets = incomingScopes.length > 0 ? $b38588f9e2856d34$var$getAssetsFromScopes(incomingScopes) : $b38588f9e2856d34$var$dedupeAssets((body === null || body === void 0 ? void 0 : body.assets) || []);
    const incomingDates = incomingScopes.length > 0 ? $b38588f9e2856d34$var$getDatesFromScopes(incomingScopes) : $b38588f9e2856d34$var$normalizeDates((body === null || body === void 0 ? void 0 : body.dates) || []);
    return {
        incomingAssets: incomingAssets,
        incomingDates: incomingDates
    };
}
function $b38588f9e2856d34$var$buildAssetScopes({ assets: assets, incomingDates: incomingDates, assetDateBounds: assetDateBounds }) {
    const upperBoundDate = $b38588f9e2856d34$var$maxDateOrNow(incomingDates);
    return (assets || []).map((asset)=>{
        const normalizedAsset = $b38588f9e2856d34$var$toApiAsset(asset);
        const key = $b38588f9e2856d34$var$assetScopeKey(normalizedAsset);
        const bounds = assetDateBounds[key];
        var _bounds_minDate;
        const fromDate = (_bounds_minDate = bounds === null || bounds === void 0 ? void 0 : bounds.minDate) !== null && _bounds_minDate !== void 0 ? _bounds_minDate : incomingDates.length > 0 ? Math.min(...incomingDates) : upperBoundDate;
        var _bounds_maxDate;
        const toDate = Math.max((_bounds_maxDate = bounds === null || bounds === void 0 ? void 0 : bounds.maxDate) !== null && _bounds_maxDate !== void 0 ? _bounds_maxDate : fromDate, upperBoundDate);
        // Keep requiredDates explicit; backend expands monthly dates from fromDate/toDate.
        const requiredDates = $b38588f9e2856d34$var$normalizeDates(incomingDates);
        return {
            asset: normalizedAsset,
            fromDate: fromDate,
            toDate: toDate,
            requiredDates: requiredDates.length > 0 ? requiredDates : [
                toDate
            ],
            includeManualQuotes: true
        };
    });
}
function $b38588f9e2856d34$var$buildScopedQuotesRequest(body, state, isBootstrapCall) {
    const explicitScopes = $b38588f9e2856d34$var$normalizeScopes(Array.isArray(body === null || body === void 0 ? void 0 : body.scopes) ? body.scopes : []);
    if (explicitScopes.length > 0) {
        const transactions = $b38588f9e2856d34$var$collectDataTransactions(state);
        const transactionAssets = $b38588f9e2856d34$var$extractAssetsFromTransactions(transactions);
        const assetDateBounds = $b38588f9e2856d34$var$extractAssetDateBoundsFromTransactions(transactions);
        const explicitScopeAssetKeys = new Set(explicitScopes.map((scope)=>$b38588f9e2856d34$var$assetScopeKey(scope.asset)));
        const missingBootstrapAssets = isBootstrapCall ? transactionAssets.filter((asset)=>!explicitScopeAssetKeys.has($b38588f9e2856d34$var$assetScopeKey(asset))) : [];
        const explicitScopeDates = $b38588f9e2856d34$var$getDatesFromScopes(explicitScopes);
        const bootstrapScopes = $b38588f9e2856d34$var$buildAssetScopes({
            assets: missingBootstrapAssets,
            incomingDates: explicitScopeDates,
            assetDateBounds: assetDateBounds
        });
        const scopes = $b38588f9e2856d34$var$normalizeScopes(explicitScopes.concat(bootstrapScopes));
        const isolatedDates = $b38588f9e2856d34$var$getExpandedDatesFromScopes(scopes);
        return {
            apiBody: {
                scopes: scopes,
                projectIds: Array.isArray(body === null || body === void 0 ? void 0 : body.projectIds) ? body.projectIds : []
            },
            request: {
                scopes: scopes,
                assets: scopes.map((scope)=>scope.asset),
                dates: isolatedDates,
                projectIds: Array.isArray(body === null || body === void 0 ? void 0 : body.projectIds) ? body.projectIds : []
            },
            isolatedDates: isolatedDates,
            cancelSignal: body === null || body === void 0 ? void 0 : body.cancelSignal
        };
    }
    const { incomingAssets: incomingAssets, incomingDates: incomingDates } = $b38588f9e2856d34$var$normalizeIncomingRequestScope(body);
    const transactions = $b38588f9e2856d34$var$collectDataTransactions(state);
    const transactionAssets = $b38588f9e2856d34$var$extractAssetsFromTransactions(transactions);
    const assetDateBounds = $b38588f9e2856d34$var$extractAssetDateBoundsFromTransactions(transactions);
    const requestAssets = isBootstrapCall ? $b38588f9e2856d34$var$dedupeAssets(incomingAssets.concat(transactionAssets)) : incomingAssets;
    const scopes = $b38588f9e2856d34$var$buildAssetScopes({
        assets: requestAssets,
        incomingDates: incomingDates,
        assetDateBounds: assetDateBounds
    });
    // Isolated quotes endpoint still expects explicit dates; expand fromDate/toDate ranges for monthly isolated coverage.
    const isolatedDates = $b38588f9e2856d34$var$getExpandedDatesFromScopes(scopes);
    return {
        apiBody: {
            scopes: scopes,
            projectIds: Array.isArray(body === null || body === void 0 ? void 0 : body.projectIds) ? body.projectIds : []
        },
        request: {
            scopes: scopes,
            assets: scopes.map((scope)=>scope.asset),
            dates: isolatedDates,
            projectIds: Array.isArray(body === null || body === void 0 ? void 0 : body.projectIds) ? body.projectIds : []
        },
        isolatedDates: isolatedDates,
        cancelSignal: body === null || body === void 0 ? void 0 : body.cancelSignal
    };
}
function $b38588f9e2856d34$export$ddc91e1f8a93d4cd(data, baseCurrency, expectedDate = null, expectedDateName = null) {
    const currencyCodes = data.structure.dimensions.series.find((s)=>s.id === "CURRENCY").values.map((v)=>v.id).filter((v)=>![
            "ARS",
            "DZD",
            "HRK",
            "MAD",
            "RUB",
            "TWD"
        ].includes(v)) // these codes are not available in the API, so we remove it from the list
    .concat("EUR");
    const timePeriods = data.structure.dimensions.observation // returns array of time periods as unix epoch
    .find((o)=>o.id === "TIME_PERIOD").values.map((tp)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(`${tp.start.split("+")[0]}Z`).valueOf());
    const { series: series } = data.dataSets[0];
    const observations = Object.values(series).map((x, idx)=>x.observations); // returns an array of { "0": [1.2342], "1": [1.2433] ... } for each currencyCode, corresponding to time periods
    const fxValues = observations.map((o)=>Object.values(o).flat()).concat([
        timePeriods.map(()=>1)
    ]); // for EUR, add an array of 1s
    // returns an array of arrays [[1.2342, 1.2433], [5.2334, 5.1939], ... , [1, 1]
    const currentTpMissing = expectedDate && timePeriods[timePeriods.length - 1] !== expectedDate;
    // ↑↑ this is applicable to daily mode or to first day of the month before ECB has updated its data for the day
    // if there is no data for today, take the previous available TP (no matter how old)
    if (currentTpMissing) {
        timePeriods.push(expectedDateName); // add at the end
        fxValues.forEach((fx)=>fx.push(fx[fx.length - 1])); // add at the end (copy from previous available TP)
    }
    const obj = [];
    const baseCurrencyIdx = currencyCodes.indexOf(baseCurrency);
    if (baseCurrencyIdx === -1 && baseCurrency !== "EUR") throw new Error("transformEcbResponse: illegal baseCurrency");
    currencyCodes.forEach((currCode, idxCurrCode)=>{
        timePeriods.forEach((tp, idxTp, self)=>{
            obj.push({
                assetId: currCode,
                date: tp,
                quote: 1,
                // ↓↓ if baseCurrencyIdx not found, then it is EUR; otherwise divide everything by the baseCurrency rate (so that the baseCurrency rate itself is 1)
                quoteBaseCurrency: fxValues[idxCurrCode][idxTp] / (baseCurrencyIdx === -1 ? 1 : fxValues[baseCurrencyIdx][idxTp]),
                quoteDate: typeof tp !== "number" ? self[idxTp - 1] : tp,
                currency: currCode,
                source: "api",
                projectId: null
            }); // if baseCurrencyIdx not found, then it is EUR
        });
        return obj;
    }, {});
    return obj;
}
// arguments: dates[], projectIds[] (optional) for which the quotes are needed
// updates quotes slice only for the dates and assets retrieved from API
const $b38588f9e2856d34$export$b3c9df64177c4614 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("quotes/getIsolatedQuotes", async (body, { dispatch: dispatch })=>{
    const isBootstrapCall = !$b38588f9e2856d34$var$hasBootstrapRun($b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY);
    let requestProjectIds = [];
    if (!isBootstrapCall) requestProjectIds = Array.isArray(body === null || body === void 0 ? void 0 : body.projectIds) ? body.projectIds : [];
    const requestDates = $b38588f9e2856d34$var$normalizeDates((body === null || body === void 0 ? void 0 : body.dates) || []);
    if (requestDates.length === 0) {
        dispatch({
            type: (0, $0840a3787500c813$export$a4c351e5b9b68a40),
            payload: "noProjectIdsSelected"
        });
        return {
            status: "success",
            rows: [],
            request: {
                projectIds: requestProjectIds,
                dates: requestDates
            },
            meta: {
                isBootstrapCall: isBootstrapCall,
                sessionKey: $b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY
            }
        };
    }
    let bootstrapClaimed = false;
    try {
        if (isBootstrapCall) {
            // Claim isolated bootstrap before API starts so concurrent calls don't duplicate a full isolated refresh.
            $b38588f9e2856d34$var$markBootstrapDone($b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY);
            bootstrapClaimed = true;
        }
        const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/getIsolated", {
            body: (0, $2qxEV._)((0, $9tqwB._)({}, body), {
                projectIds: requestProjectIds,
                dates: requestDates
            }),
            headers: {
                "Content-Type": "application/json"
            }
        }); // getIsolatedQuotes API expects { projectIds: [projectIds] optional, dates: [dates]}
        return {
            status: "success",
            rows: response.quotes || [],
            request: {
                projectIds: requestProjectIds,
                dates: requestDates
            },
            meta: {
                isBootstrapCall: isBootstrapCall,
                sessionKey: $b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY
            }
        };
    } catch (error) {
        if (bootstrapClaimed) // Isolated bootstrap failed, so allow the next isolated call to retry the full refresh.
        $b38588f9e2856d34$var$clearBootstrapDone($b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY);
        dispatch({
            type: (0, $0840a3787500c813$export$f56c21b951c55d75),
            payload: "dataUpdateError"
        });
        return {
            status: "error",
            rows: [],
            request: {
                projectIds: requestProjectIds,
                dates: requestDates
            },
            meta: {
                isBootstrapCall: isBootstrapCall,
                sessionKey: $b38588f9e2856d34$var$QUOTES_ISOLATED_BOOTSTRAP_SESSION_KEY
            }
        };
    }
});
// arguments: either
// - dates[], assets[{ assetId, providerAssetId, currency, [category] }]
// - scopes[{ asset, fromDate, toDate, requiredDates, includeManualQuotes }]
// for which the quotes are needed
// category is relevant mostly for crypto and stocks
// { aborted: true / false } is used by Prep component to cancel the API call when the component is re-rendered
// updates quotes slice only for the dates and assets retrieved from API
const $b38588f9e2856d34$var$getQuotes = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("quotes/getQuotes", async (body, { getState: getState, dispatch: dispatch })=>{
    var _initialState_user_profile_settings, _initialState_user_profile, _initialState_user, _requestEnvelope_apiBody_scopes, _requestEnvelope_apiBody, _requestEnvelope_cancelSignal;
    const todayUtcStart = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf();
    const initialState = getState();
    const settingsCurrent = $b38588f9e2856d34$var$toNumericDate(initialState === null || initialState === void 0 ? void 0 : (_initialState_user = initialState.user) === null || _initialState_user === void 0 ? void 0 : (_initialState_user_profile = _initialState_user.profile) === null || _initialState_user_profile === void 0 ? void 0 : (_initialState_user_profile_settings = _initialState_user_profile.settings) === null || _initialState_user_profile_settings === void 0 ? void 0 : _initialState_user_profile_settings.current);
    if (settingsCurrent !== todayUtcStart) dispatch({
        type: "user/setSettingsCurrent",
        payload: todayUtcStart
    });
    const state = settingsCurrent === todayUtcStart ? initialState : getState();
    const isBootstrapCall = !$b38588f9e2856d34$var$hasBootstrapRun($b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY);
    const requestEnvelope = $b38588f9e2856d34$var$buildScopedQuotesRequest(body, state, isBootstrapCall);
    let bootstrapClaimed = false;
    if (!((_requestEnvelope_apiBody = requestEnvelope.apiBody) === null || _requestEnvelope_apiBody === void 0 ? void 0 : (_requestEnvelope_apiBody_scopes = _requestEnvelope_apiBody.scopes) === null || _requestEnvelope_apiBody_scopes === void 0 ? void 0 : _requestEnvelope_apiBody_scopes.length)) {
        dispatch({
            type: (0, $0840a3787500c813$export$a4c351e5b9b68a40),
            payload: "noAssetsSelected"
        });
        return {
            status: "success",
            rows: [],
            request: requestEnvelope.request,
            meta: {
                isBootstrapCall: isBootstrapCall,
                sessionKey: $b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY
            }
        };
    }
    let arrayOfQuotes;
    try {
        var _requestEnvelope_cancelSignal1, _requestEnvelope_cancelSignal2;
        if (isBootstrapCall) {
            // Claim bootstrap before API starts so parallel getQuotes calls in the same tick don't trigger duplicate full bootstrap requests.
            $b38588f9e2856d34$var$markBootstrapDone($b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY);
            bootstrapClaimed = true;
        }
        const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/get", {
            body: requestEnvelope.apiBody,
            headers: {
                "Content-Type": "application/json"
            }
        }); // getQuotes API expects { scopes: [{ asset, fromDate, toDate, requiredDates, includeManualQuotes }], projectIds: []}
        if (!((_requestEnvelope_cancelSignal1 = requestEnvelope.cancelSignal) === null || _requestEnvelope_cancelSignal1 === void 0 ? void 0 : _requestEnvelope_cancelSignal1.aborted)) dispatch($b38588f9e2856d34$export$b3c9df64177c4614({
            projectIds: [],
            dates: requestEnvelope.isolatedDates
        }));
        arrayOfQuotes = response.quotes;
        if ((_requestEnvelope_cancelSignal2 = requestEnvelope.cancelSignal) === null || _requestEnvelope_cancelSignal2 === void 0 ? void 0 : _requestEnvelope_cancelSignal2.aborted) console.info("getQuotes aborted");
    } catch (error) {
        var _error_response;
        if (bootstrapClaimed) // Bootstrap failed, so release the claim and allow the next getQuotes call to retry bootstrap.
        $b38588f9e2856d34$var$clearBootstrapDone($b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY);
        console.error("Error in getQuotes", (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data);
        dispatch({
            type: (0, $0840a3787500c813$export$f56c21b951c55d75),
            payload: {
                message: "dataUpdateError"
            }
        });
        return {
            status: "error",
            rows: [],
            request: requestEnvelope.request,
            meta: {
                isBootstrapCall: isBootstrapCall,
                sessionKey: $b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY
            }
        };
    }
    if ((_requestEnvelope_cancelSignal = requestEnvelope.cancelSignal) === null || _requestEnvelope_cancelSignal === void 0 ? void 0 : _requestEnvelope_cancelSignal.aborted) {
        if (bootstrapClaimed) // Aborted bootstrap should not count as completed; keep session eligible for retry.
        $b38588f9e2856d34$var$clearBootstrapDone($b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY);
        return null;
    }
    // Keep the bootstrap claim set after success so subsequent calls stay scoped.
    return {
        status: "success",
        rows: arrayOfQuotes,
        request: requestEnvelope.request,
        meta: {
            isBootstrapCall: isBootstrapCall,
            sessionKey: $b38588f9e2856d34$var$QUOTES_BOOTSTRAP_SESSION_KEY
        }
    };
});
var // arguments: dates[] for which the quotes are needed
// updates quotes.global.fx slice only for the dates retrieved from API (all currencies available in ECB)
// TODO get baseline & co from API as well
$b38588f9e2856d34$export$2e2bcd8739ae039 = $b38588f9e2856d34$var$getQuotes;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $780d46a2914a2b26$var$stableStringify(value) {
    if (Array.isArray(value)) return `[${value.map((item)=>$780d46a2914a2b26$var$stableStringify(item)).join(",")}]`;
    if (value && typeof value === "object") {
        const keys = Object.keys(value).sort();
        return `{${keys.map((key)=>`${JSON.stringify(key)}:${$780d46a2914a2b26$var$stableStringify(value[key])}`).join(",")}}`;
    }
    return JSON.stringify(value);
}
function $780d46a2914a2b26$var$getProviderAssetIdKey(providerAssetId) {
    if (!providerAssetId) return "";
    if (typeof providerAssetId === "object") return $780d46a2914a2b26$var$stableStringify(providerAssetId);
    return String(providerAssetId);
}
function $780d46a2914a2b26$export$ad26e1307efa0bc0(date) {
    if (typeof date === "number" && Number.isFinite(date)) return date;
    if (typeof date === "string" && /^\d+$/.test(date)) return Number(date);
    return null;
}
function $780d46a2914a2b26$export$9f53b88e82f64d8d(dates = []) {
    return [
        ...new Set((dates || []).map((date)=>$780d46a2914a2b26$export$ad26e1307efa0bc0(date)).filter((date)=>date !== null))
    ].sort((a, b)=>a - b);
}
function $780d46a2914a2b26$export$fa5f548498181e2b(start, end) {
    if (!Number.isFinite(start) || !Number.isFinite(end) || start > end) return [];
    const output = [];
    let cursor = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).startOf("month").startOf("day").valueOf();
    const limit = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(end).startOf("month").startOf("day").valueOf();
    while(cursor <= limit){
        output.push(cursor);
        cursor = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(cursor).add(1, "month").startOf("month").startOf("day").valueOf();
    }
    return output;
}
function $780d46a2914a2b26$export$cba5843aafc7d0a8(asset = {}) {
    return (0, $2qxEV._)((0, $9tqwB._)({}, asset), {
        providerAssetId: (asset === null || asset === void 0 ? void 0 : asset.providerAssetId) || null,
        currency: (asset === null || asset === void 0 ? void 0 : asset.currency) || (asset === null || asset === void 0 ? void 0 : asset.transactionCurrency) || (asset === null || asset === void 0 ? void 0 : asset.assetCurrency) || (asset === null || asset === void 0 ? void 0 : asset.accountCurrency)
    });
}
function $780d46a2914a2b26$export$78413c8862b2dbcf(asset = {}) {
    const normalized = $780d46a2914a2b26$export$cba5843aafc7d0a8(asset || {});
    const currency = (normalized === null || normalized === void 0 ? void 0 : normalized.currency) || "";
    return `${(normalized === null || normalized === void 0 ? void 0 : normalized.assetId) || ""}|${$780d46a2914a2b26$var$getProviderAssetIdKey(normalized === null || normalized === void 0 ? void 0 : normalized.providerAssetId)}|${currency}`;
}
function $780d46a2914a2b26$export$dc9bd98149bc009(assets = []) {
    const seen = new Set();
    const output = [];
    (assets || []).forEach((asset)=>{
        const normalized = $780d46a2914a2b26$export$cba5843aafc7d0a8(asset || {});
        if (!(normalized === null || normalized === void 0 ? void 0 : normalized.assetId)) return;
        const key = $780d46a2914a2b26$export$78413c8862b2dbcf(normalized);
        if (seen.has(key)) return;
        seen.add(key);
        output.push(normalized);
    });
    return output;
}
function $780d46a2914a2b26$export$d6be4aeaed512e29(scope = {}) {
    const asset = $780d46a2914a2b26$export$cba5843aafc7d0a8((scope === null || scope === void 0 ? void 0 : scope.asset) || {});
    if (!(asset === null || asset === void 0 ? void 0 : asset.assetId)) return null;
    const requiredDates = $780d46a2914a2b26$export$9f53b88e82f64d8d((scope === null || scope === void 0 ? void 0 : scope.requiredDates) || []);
    const fallbackDate = requiredDates.length > 0 ? Math.max(...requiredDates) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month").startOf("day").valueOf();
    const rawFromDate = $780d46a2914a2b26$export$ad26e1307efa0bc0(scope === null || scope === void 0 ? void 0 : scope.fromDate);
    const rawToDate = $780d46a2914a2b26$export$ad26e1307efa0bc0(scope === null || scope === void 0 ? void 0 : scope.toDate);
    const fromDate = rawFromDate === null ? fallbackDate : rawFromDate;
    const toDate = rawToDate === null ? Math.max(fromDate, fallbackDate) : rawToDate;
    const normalizedFrom = Math.min(fromDate, toDate);
    const normalizedTo = Math.max(fromDate, toDate);
    const normalizedRequiredDates = requiredDates.length > 0 ? requiredDates : [
        normalizedTo
    ];
    var _scope_includeManualQuotes;
    return {
        asset: asset,
        fromDate: normalizedFrom,
        toDate: normalizedTo,
        requiredDates: normalizedRequiredDates,
        includeManualQuotes: (_scope_includeManualQuotes = scope === null || scope === void 0 ? void 0 : scope.includeManualQuotes) !== null && _scope_includeManualQuotes !== void 0 ? _scope_includeManualQuotes : true
    };
}
function $780d46a2914a2b26$export$81e0abc8b4acfa8a(scopes = []) {
    const byKey = {};
    (scopes || []).forEach((scope)=>{
        const normalizedScope = $780d46a2914a2b26$export$d6be4aeaed512e29(scope);
        if (!normalizedScope) return;
        const key = $780d46a2914a2b26$export$78413c8862b2dbcf(normalizedScope.asset);
        const existing = byKey[key];
        if (!existing) {
            byKey[key] = normalizedScope;
            return;
        }
        byKey[key] = (0, $2qxEV._)((0, $9tqwB._)({}, existing), {
            fromDate: Math.min(existing.fromDate, normalizedScope.fromDate),
            toDate: Math.max(existing.toDate, normalizedScope.toDate),
            requiredDates: $780d46a2914a2b26$export$9f53b88e82f64d8d((existing.requiredDates || []).concat(normalizedScope.requiredDates || [])),
            includeManualQuotes: Boolean(existing.includeManualQuotes || normalizedScope.includeManualQuotes)
        });
    });
    return Object.keys(byKey).sort().map((key)=>byKey[key]);
}
function $780d46a2914a2b26$export$d16e7208137dbe0b(scopes = []) {
    const dates = [];
    $780d46a2914a2b26$export$81e0abc8b4acfa8a(scopes).forEach((scope)=>{
        dates.push(scope.fromDate, scope.toDate);
        dates.push(...$780d46a2914a2b26$export$9f53b88e82f64d8d((scope === null || scope === void 0 ? void 0 : scope.requiredDates) || []));
    });
    return $780d46a2914a2b26$export$9f53b88e82f64d8d(dates);
}
function $780d46a2914a2b26$export$34edb459ca2b76c7(scopes = []) {
    const dates = [];
    $780d46a2914a2b26$export$81e0abc8b4acfa8a(scopes).forEach((scope)=>{
        const fromDate = $780d46a2914a2b26$export$ad26e1307efa0bc0(scope === null || scope === void 0 ? void 0 : scope.fromDate);
        const toDate = $780d46a2914a2b26$export$ad26e1307efa0bc0(scope === null || scope === void 0 ? void 0 : scope.toDate);
        if (fromDate !== null) dates.push(fromDate);
        if (toDate !== null) dates.push(toDate);
        dates.push(...$780d46a2914a2b26$export$9f53b88e82f64d8d((scope === null || scope === void 0 ? void 0 : scope.requiredDates) || []));
        if (fromDate !== null && toDate !== null) dates.push(...$780d46a2914a2b26$export$fa5f548498181e2b(Math.min(fromDate, toDate), Math.max(fromDate, toDate)));
    });
    return $780d46a2914a2b26$export$9f53b88e82f64d8d(dates);
}
function $780d46a2914a2b26$export$e32b69cb36738311(transaction = {}) {
    const category = transaction === null || transaction === void 0 ? void 0 : transaction.category;
    const providerAssetId = (transaction === null || transaction === void 0 ? void 0 : transaction.providerAssetId) || null;
    const currency = (transaction === null || transaction === void 0 ? void 0 : transaction.assetCurrency) || (transaction === null || transaction === void 0 ? void 0 : transaction.accountCurrency) || (transaction === null || transaction === void 0 ? void 0 : transaction.transactionCurrency) || (transaction === null || transaction === void 0 ? void 0 : transaction.currency);
    const scopeCandidates = [];
    if (transaction === null || transaction === void 0 ? void 0 : transaction.assetId) scopeCandidates.push({
        assetId: transaction.assetId,
        providerAssetId: providerAssetId,
        currency: currency,
        category: category
    });
    [
        "transactionCurrency",
        "accountCurrency",
        "assetCurrency",
        "currency"
    ].forEach((currencyField)=>{
        const currencyCode = transaction === null || transaction === void 0 ? void 0 : transaction[currencyField];
        if (!currencyCode) return;
        scopeCandidates.push({
            assetId: currencyCode,
            providerAssetId: null,
            currency: currencyCode,
            category: category
        });
    });
    return $780d46a2914a2b26$export$dc9bd98149bc009(scopeCandidates);
}
function $780d46a2914a2b26$export$c65d4f0ee0288f4b(transactions = []) {
    return $780d46a2914a2b26$export$dc9bd98149bc009(transactions.flatMap((transaction)=>$780d46a2914a2b26$export$e32b69cb36738311(transaction)));
}
function $780d46a2914a2b26$export$a9243e65b02f996b(transactions = []) {
    const bounds = {};
    (transactions || []).forEach((transaction)=>{
        const numericDate = $780d46a2914a2b26$export$ad26e1307efa0bc0(transaction === null || transaction === void 0 ? void 0 : transaction.date);
        if (numericDate === null) return;
        $780d46a2914a2b26$export$e32b69cb36738311(transaction).forEach((asset)=>{
            const key = $780d46a2914a2b26$export$78413c8862b2dbcf(asset);
            if (!bounds[key]) {
                bounds[key] = {
                    minDate: numericDate,
                    maxDate: numericDate
                };
                return;
            }
            if (numericDate < bounds[key].minDate) bounds[key].minDate = numericDate;
            if (numericDate > bounds[key].maxDate) bounds[key].maxDate = numericDate;
        });
    });
    return bounds;
}
function $780d46a2914a2b26$export$8ddf68b0fa571116(state) {
    const categories = Object.values((state === null || state === void 0 ? void 0 : state.data) || {});
    return categories.flatMap((categoryData)=>((categoryData === null || categoryData === void 0 ? void 0 : categoryData.transactions) || []).concat((categoryData === null || categoryData === void 0 ? void 0 : categoryData.simulatedTransactions) || []));
}
function $780d46a2914a2b26$export$3c2ee341cf661934({ assets: assets = [], requiredDates: requiredDates = [], assetDateBounds: assetDateBounds = {} }) {
    const normalizedAssets = $780d46a2914a2b26$export$dc9bd98149bc009(assets);
    const normalizedRequiredDates = $780d46a2914a2b26$export$9f53b88e82f64d8d(requiredDates);
    const fallbackDate = normalizedRequiredDates.length > 0 ? Math.max(...normalizedRequiredDates) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month").startOf("day").valueOf();
    const upperBoundDate = normalizedRequiredDates.length > 0 ? Math.max(...normalizedRequiredDates) : fallbackDate;
    const scopes = normalizedAssets.map((asset)=>{
        const normalizedAsset = $780d46a2914a2b26$export$cba5843aafc7d0a8(asset);
        const key = $780d46a2914a2b26$export$78413c8862b2dbcf(normalizedAsset);
        const bounds = assetDateBounds[key];
        var _bounds_minDate;
        const fromDate = (_bounds_minDate = bounds === null || bounds === void 0 ? void 0 : bounds.minDate) !== null && _bounds_minDate !== void 0 ? _bounds_minDate : fallbackDate;
        var _bounds_maxDate;
        const toDate = Math.max((_bounds_maxDate = bounds === null || bounds === void 0 ? void 0 : bounds.maxDate) !== null && _bounds_maxDate !== void 0 ? _bounds_maxDate : fromDate, upperBoundDate);
        return {
            asset: normalizedAsset,
            fromDate: fromDate,
            toDate: toDate,
            requiredDates: normalizedRequiredDates.length > 0 ? normalizedRequiredDates : [
                toDate
            ],
            includeManualQuotes: true
        };
    });
    return $780d46a2914a2b26$export$81e0abc8b4acfa8a(scopes);
}
function $780d46a2914a2b26$export$6ba18aedc42d9a39({ transactions: transactions = [], requiredDates: requiredDates = [], assets: assets = null }) {
    const effectiveAssets = Array.isArray(assets) ? assets : $780d46a2914a2b26$export$c65d4f0ee0288f4b(transactions);
    const assetDateBounds = $780d46a2914a2b26$export$a9243e65b02f996b(transactions);
    return $780d46a2914a2b26$export$3c2ee341cf661934({
        assets: effectiveAssets,
        requiredDates: requiredDates,
        assetDateBounds: assetDateBounds
    });
}


function $7df3cdf229d31ae2$var$stableStringify(value) {
    if (Array.isArray(value)) return `[${value.map((item)=>$7df3cdf229d31ae2$var$stableStringify(item)).join(",")}]`;
    if (value && typeof value === "object") {
        const keys = Object.keys(value).sort();
        return `{${keys.map((key)=>`${JSON.stringify(key)}:${$7df3cdf229d31ae2$var$stableStringify(value[key])}`).join(",")}}`;
    }
    return JSON.stringify(value);
}
function $7df3cdf229d31ae2$var$normalizeProjectIds(projectIds = []) {
    return [
        ...new Set((projectIds || []).filter(Boolean).map((projectId)=>String(projectId)))
    ].sort();
}
function $7df3cdf229d31ae2$var$normalizeRequest(scope = {}) {
    // legacy compatibility: if a caller still provides assets+dates, forward unchanged and let getQuotes normalize it.
    if (!Array.isArray(scope === null || scope === void 0 ? void 0 : scope.scopes) && Array.isArray(scope === null || scope === void 0 ? void 0 : scope.assets) && Array.isArray(scope === null || scope === void 0 ? void 0 : scope.dates)) return {
        assets: scope.assets,
        dates: scope.dates,
        projectIds: $7df3cdf229d31ae2$var$normalizeProjectIds((scope === null || scope === void 0 ? void 0 : scope.projectIds) || [])
    };
    return {
        scopes: (0, $780d46a2914a2b26$export$81e0abc8b4acfa8a)(scope.scopes || []),
        projectIds: $7df3cdf229d31ae2$var$normalizeProjectIds(scope.projectIds || [])
    };
}
function $7df3cdf229d31ae2$var$mergeRequests(left = {}, right = {}) {
    if (Array.isArray(left === null || left === void 0 ? void 0 : left.assets) || Array.isArray(right === null || right === void 0 ? void 0 : right.assets)) return $7df3cdf229d31ae2$var$normalizeRequest({
        assets: [
            ...left.assets || [],
            ...right.assets || []
        ],
        dates: [
            ...left.dates || [],
            ...right.dates || []
        ],
        projectIds: [
            ...left.projectIds || [],
            ...right.projectIds || []
        ]
    });
    return $7df3cdf229d31ae2$var$normalizeRequest({
        scopes: [
            ...left.scopes || [],
            ...right.scopes || []
        ],
        projectIds: [
            ...left.projectIds || [],
            ...right.projectIds || []
        ]
    });
}
function $7df3cdf229d31ae2$var$createScopeHash(scope = {}) {
    const normalizedScope = $7df3cdf229d31ae2$var$normalizeRequest(scope);
    if (Array.isArray(normalizedScope === null || normalizedScope === void 0 ? void 0 : normalizedScope.assets)) return $7df3cdf229d31ae2$var$stableStringify(normalizedScope);
    return $7df3cdf229d31ae2$var$stableStringify({
        scopes: normalizedScope.scopes.map((scopeItem)=>({
                asset: scopeItem.asset,
                fromDate: scopeItem.fromDate,
                toDate: scopeItem.toDate,
                requiredDates: scopeItem.requiredDates,
                includeManualQuotes: scopeItem.includeManualQuotes
            })),
        projectIds: normalizedScope.projectIds
    });
}
const $7df3cdf229d31ae2$var$DEFAULT_DEBOUNCE_MS = 250;
let $7df3cdf229d31ae2$var$pendingScope = null;
let $7df3cdf229d31ae2$var$pendingWaiters = [];
let $7df3cdf229d31ae2$var$pendingTimer = null;
const $7df3cdf229d31ae2$var$inFlightByScopeHash = new Map();
function $7df3cdf229d31ae2$var$resolveWaiters(waiters, action) {
    waiters.forEach(({ resolve: resolve })=>resolve(action));
}
function $7df3cdf229d31ae2$var$rejectWaiters(waiters, error) {
    waiters.forEach(({ reject: reject })=>reject(error));
}
function $7df3cdf229d31ae2$var$flushPendingQueue(dispatch) {
    if (!$7df3cdf229d31ae2$var$pendingScope || Array.isArray($7df3cdf229d31ae2$var$pendingScope.scopes) && $7df3cdf229d31ae2$var$pendingScope.scopes.length === 0 || Array.isArray($7df3cdf229d31ae2$var$pendingScope.assets) && $7df3cdf229d31ae2$var$pendingScope.assets.length === 0) {
        const waiters = $7df3cdf229d31ae2$var$pendingWaiters;
        $7df3cdf229d31ae2$var$pendingScope = null;
        $7df3cdf229d31ae2$var$pendingWaiters = [];
        if ($7df3cdf229d31ae2$var$pendingTimer) {
            clearTimeout($7df3cdf229d31ae2$var$pendingTimer);
            $7df3cdf229d31ae2$var$pendingTimer = null;
        }
        $7df3cdf229d31ae2$var$resolveWaiters(waiters, null);
        return Promise.resolve(null);
    }
    const scopeToDispatch = $7df3cdf229d31ae2$var$pendingScope;
    const waiters = $7df3cdf229d31ae2$var$pendingWaiters;
    $7df3cdf229d31ae2$var$pendingScope = null;
    $7df3cdf229d31ae2$var$pendingWaiters = [];
    if ($7df3cdf229d31ae2$var$pendingTimer) {
        clearTimeout($7df3cdf229d31ae2$var$pendingTimer);
        $7df3cdf229d31ae2$var$pendingTimer = null;
    }
    const scopeHash = $7df3cdf229d31ae2$var$createScopeHash(scopeToDispatch);
    const existingInFlight = $7df3cdf229d31ae2$var$inFlightByScopeHash.get(scopeHash);
    if (existingInFlight) {
        existingInFlight.then((action)=>$7df3cdf229d31ae2$var$resolveWaiters(waiters, action), (error)=>$7df3cdf229d31ae2$var$rejectWaiters(waiters, error));
        return existingInFlight;
    }
    const requestPromise = Promise.resolve(dispatch((0, $b38588f9e2856d34$export$2e2bcd8739ae039)(scopeToDispatch)));
    $7df3cdf229d31ae2$var$inFlightByScopeHash.set(scopeHash, requestPromise);
    requestPromise.then((action)=>$7df3cdf229d31ae2$var$resolveWaiters(waiters, action), (error)=>$7df3cdf229d31ae2$var$rejectWaiters(waiters, error)).finally(()=>{
        if ($7df3cdf229d31ae2$var$inFlightByScopeHash.get(scopeHash) === requestPromise) $7df3cdf229d31ae2$var$inFlightByScopeHash.delete(scopeHash);
    });
    return requestPromise;
}
function $7df3cdf229d31ae2$export$5a0d3efae517a391(scope, options = {}) {
    const { dispatch: dispatch, immediate: immediate = false, debounceMs: debounceMs = $7df3cdf229d31ae2$var$DEFAULT_DEBOUNCE_MS } = options;
    if (typeof dispatch !== "function") throw new Error("queueQuotesRequest expects options.dispatch");
    const normalizedScope = $7df3cdf229d31ae2$var$normalizeRequest(scope);
    const hasScopes = Array.isArray(normalizedScope.scopes) && normalizedScope.scopes.length > 0;
    const hasLegacyScope = Array.isArray(normalizedScope.assets) && normalizedScope.assets.length > 0 && Array.isArray(normalizedScope.dates) && normalizedScope.dates.length > 0;
    if (!hasScopes && !hasLegacyScope) return Promise.resolve(null);
    const incomingScopeHash = $7df3cdf229d31ae2$var$createScopeHash(normalizedScope);
    const existingInFlight = $7df3cdf229d31ae2$var$inFlightByScopeHash.get(incomingScopeHash);
    if (existingInFlight) return existingInFlight;
    $7df3cdf229d31ae2$var$pendingScope = $7df3cdf229d31ae2$var$pendingScope ? $7df3cdf229d31ae2$var$mergeRequests($7df3cdf229d31ae2$var$pendingScope, normalizedScope) : normalizedScope;
    const waiterPromise = new Promise((resolve, reject)=>{
        $7df3cdf229d31ae2$var$pendingWaiters.push({
            resolve: resolve,
            reject: reject
        });
    });
    if (immediate) $7df3cdf229d31ae2$var$flushPendingQueue(dispatch);
    else if (!$7df3cdf229d31ae2$var$pendingTimer) $7df3cdf229d31ae2$var$pendingTimer = setTimeout(()=>{
        $7df3cdf229d31ae2$var$flushPendingQueue(dispatch);
    }, debounceMs);
    return waiterPromise;
}
function $7df3cdf229d31ae2$export$2055c310c696837e(options = {}) {
    const { dispatch: dispatch } = options;
    if (typeof dispatch !== "function") throw new Error("flushQuotesRequestQueue expects options.dispatch");
    return $7df3cdf229d31ae2$var$flushPendingQueue(dispatch);
}
function $7df3cdf229d31ae2$export$5e96f10b5ea8fb96() {
    if ($7df3cdf229d31ae2$var$pendingTimer) clearTimeout($7df3cdf229d31ae2$var$pendingTimer);
    $7df3cdf229d31ae2$var$pendingScope = null;
    $7df3cdf229d31ae2$var$pendingWaiters = [];
    $7df3cdf229d31ae2$var$pendingTimer = null;
    $7df3cdf229d31ae2$var$inFlightByScopeHash.clear();
}



/* eslint-disable no-nested-ternary */ /* eslint-disable no-restricted-syntax */ /* eslint-disable max-len */ /* eslint-disable no-unsafe-optional-chaining */ /* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


/* eslint-disable no-param-reassign */ // koń jaki jest, każdy widzi

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $3e6d58b7292c657b$var$flatArrayToObject(arr) {
    return arr.reduce((prev, curr)=>(0, $9tqwB._)({}, prev, curr), {});
}
function $3e6d58b7292c657b$export$a537c627e243cb6e(obj, parentNames = [
    "assetId",
    "date"
], parents = []) {
    if (!obj || parents.length >= parentNames.length) return [];
    const returnObject = Object.entries(obj).map(([key, value])=>{
        // Check if the value is an object (but not an array) and if we haven't reached the max depth
        if (parents.length < parentNames.length - 1 && Object.values(value).findIndex((v)=>v && typeof v === "object" && !Array.isArray(v)) > -1) // Recurse one level deeper
        return $3e6d58b7292c657b$export$a537c627e243cb6e(value, parentNames, [
            ...parents,
            {
                [parentNames[parents.length]]: key
            }
        ]);
        // Construct the object at the current level
        return (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, $3e6d58b7292c657b$var$flatArrayToObject(parents)), {
            [parentNames[parents.length]]: key
        }), value);
    });
    return returnObject.flat();
}
function $3e6d58b7292c657b$export$acd9bbcd3834698e(arr) {
    const b = arr.map((x)=>JSON.stringify(x));
    return Array.from(new Set(b)).map((x)=>JSON.parse(x));
}
// export function arrayToObject(arr, keys) {
//   // keys is an array of strings, each string is a name of a property found within the objects in the array
//   // make this a recursive function
//   // return an object with the keys as the values of the properties named in keys
//   // EXAMPLE: [{ assetId: 'a', date: 'b', quote: 'c' }, { assetId: 'd', date: 'e', quote: 'f' }] with keys = ['assetId', 'date']
//   // will return { a: { b: { assetId: 'a', date: 'b', quote: 'c' } }, d: { e: { assetId: 'd', date: 'e', quote: 'f' } } }
//   if (!arr || !keys || keys.length === 0) throw new Error('Invalid arguments passed to misc > arrayToObject function', arr, keys);
//   if (arr.length === 0) return {};
//   keys.forEach((key) => {
//     if (!arr[0]?.[key]) {
//       console.info('Error in arrayToObject function', arr[0], keys);
//       throw new Error(`Invalid arguments passed to misc > arrayToObject function. Key ${key} not found in the array`);
//     }
//   });
//   return arr.reduce((prev, curr) => {
//     const key = curr[keys[0]];
//     if (!prev[key]) prev[key] = {};
//     if (keys.length > 1) {
//       prev[key] = arrayToObject(
//         arr.filter((x) => x[keys[0]] === key),
//         keys.slice(1),
//       );
//     } else {
//       prev[key] = curr;
//     }
//     return prev;
//   }, {});
// }
// after extensive test of this and a recurcive version, this one is faster by a factor of 100
function $3e6d58b7292c657b$var$arrayToObject2(arr, keys) {
    if (!arr || !keys || keys.length !== 2) throw new Error("Invalid arguments. The second argument must contain exactly 2 keys.");
    const returnedObject = {};
    arr.forEach((item)=>{
        const key1Value = item[keys[0]];
        const key2Value = item[keys[1]];
        if (!key1Value || !key2Value) throw new Error(`Invalid data: One of the keys is missing in the item: ${JSON.stringify(item)}`);
        // Ensure nested structure exists
        if (!returnedObject[key1Value]) returnedObject[key1Value] = {};
        // Assign the current item at the correct location
        returnedObject[key1Value][key2Value] = item;
    });
    return returnedObject;
}
function $3e6d58b7292c657b$var$arrayToObject3(arr, keys) {
    if (!arr || !keys || keys.length !== 3) throw new Error("Invalid arguments. The second argument must contain exactly 3 keys.");
    const returnedObject = {};
    arr.forEach((item)=>{
        const key1Value = item[keys[0]];
        const key2Value = item[keys[1]];
        const key3Value = item[keys[2]];
        if (!key1Value || !key2Value || !key3Value) throw new Error(`Invalid data: One of the keys is missing in the item: ${JSON.stringify(item)}`);
        // Ensure nested structure exists for key1 and key2
        if (!returnedObject[key1Value]) returnedObject[key1Value] = {};
        if (!returnedObject[key1Value][key2Value]) returnedObject[key1Value][key2Value] = {};
        // Assign the current item at the correct location
        returnedObject[key1Value][key2Value][key3Value] = item;
    });
    // Return the 3-level lookup map (projectId -> assetId -> date).
    return returnedObject;
}
function $3e6d58b7292c657b$export$d224121420685233(arr, keys) {
    if (keys.length === 2) return $3e6d58b7292c657b$var$arrayToObject2(arr, keys);
    if (keys.length === 3) return $3e6d58b7292c657b$var$arrayToObject3(arr, keys);
    throw new Error("Invalid arguments. The second argument must contain exactly 2 or 3 keys.");
}
function $3e6d58b7292c657b$export$3f063810d7bf01bd(data, params) {
    if (data.length === 0) return {};
    try {
        return data.reduce((r, o)=>{
            params.reduce(// eslint-disable-next-line no-return-assign
            (group, key, i, { length: length })=>group[o[key]] = group[o[key]] || (i + 1 === length ? [] : {}), r).push(o);
            return r;
        }, {});
    } catch (e) {
        console.error("Error in groupBy function", e);
        console.info("data", JSON.stringify(data));
        return {};
    }
}
function $3e6d58b7292c657b$export$12fa62e473adb0a3(transactions) {
    // Sort transactions by date ascendingly
    const positiveTransactions = [];
    const negativeTransactions = [];
    transactions.slice() // copy array to avoid modifying the original (it causes an error in strict mode)
    .sort((a, b)=>a.date - b.date).forEach((t)=>{
        // eslint-disable-next-line no-unused-expressions
        t.quantity >= 0 ? positiveTransactions.push(JSON.parse(JSON.stringify(t))) : negativeTransactions.push(JSON.parse(JSON.stringify(t)));
    // ↑↑ this must be a deep copy, otherwise it will modify the original array
    });
    // Process negative transactions against the positive ones
    negativeTransactions.forEach((negTrans)=>{
        let absNegQuantity = Math.abs(negTrans.quantity);
        while(absNegQuantity > 0 && positiveTransactions.length > 0){
            const posTrans = positiveTransactions[0];
            if (posTrans.quantity <= absNegQuantity) {
                // If the positive transaction is fully consumed, remove it
                absNegQuantity -= posTrans.quantity;
                positiveTransactions.shift(); // Remove this transaction as it's fully consumed
            } else {
                // If the positive transaction covers the negative, adjust its quantity
                posTrans.quantity -= absNegQuantity;
                absNegQuantity = 0; // The negative transaction is fully matched
            }
        }
    });
    // Return the remaining (or modified) positive transactions
    return positiveTransactions;
}
function $3e6d58b7292c657b$export$aeb4e5a5dec08365(transactions, reverseMode = false, throwOnOverdraft = false) {
    // Sort transactions by date ascendingly
    const positiveTransactions = [];
    const negativeTransactions = [];
    transactions.slice() // copy array to avoid modifying the original (it causes an error in strict mode)
    .sort((a, b)=>a.date - b.date)// implements reverse mode -- for loans (see comment above)
    .map((t)=>reverseMode ? (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            quantity: -t.quantity
        }) : t).forEach((t)=>{
        // eslint-disable-next-line no-unused-expressions
        t.quantity >= 0 ? positiveTransactions.push(JSON.parse(JSON.stringify((0, $2qxEV._)((0, $9tqwB._)({}, t), {
            quantityOpen: t.quantity
        })))) : negativeTransactions.push(JSON.parse(JSON.stringify(t)));
    // ↑↑ this must be a deep copy, otherwise it will modify the original array
    // create quantityOpen field for positive transactions, it equals quantity in the beginning
    });
    let i = 0;
    // Process negative transactions against the positive ones
    negativeTransactions.forEach((negTrans)=>{
        let negTransOpenQuantity = Math.abs(negTrans.quantity);
        negTrans.purchaseValueBaseCurrency = 0; // add a field to store the purchase value of the negative transaction
        // for each negative transaction go through the positive stack and "use up" their quantity
        while(negTransOpenQuantity > 0 && i < positiveTransactions.length){
            const posTrans = positiveTransactions[i];
            // we are dealing with physical quantities, so we can't have a negative quantityOpen
            if (posTrans.date <= negTrans.date && posTrans.quantityOpen <= negTransOpenQuantity) {
                // if the positive transaction is fully consumed, add quantityOpen of 0
                // console.info('Open negative quantity is: ', negTransOpenQuantity, 'next positive transaction has open quantity: ', posTrans.quantityOpen);
                // console.info('This positive transaction is consumed completely. The negative transaction has new purchaseValue of', posTrans.quantityOpen * posTrans.upbc, 'with upbc of', posTrans.upbc);
                negTransOpenQuantity -= posTrans.quantityOpen;
                negTrans.purchaseValueBaseCurrency += posTrans.quantityOpen * posTrans.upbc;
                negTrans.linkedTransactions = (negTrans.linkedTransactions || []).filter((lt)=>{
                    var _lt_tags;
                    return ((_lt_tags = lt.tags) === null || _lt_tags === void 0 ? void 0 : _lt_tags.type) !== "purchase";
                }) // remove existing purchase LT
                .concat([
                    {
                        id: posTrans.id,
                        category: posTrans.category,
                        tags: {
                            type: "purchase",
                            date: posTrans.date,
                            quantity: (reverseMode ? -1 : 1) * posTrans.quantityOpen,
                            upbc: posTrans.upbc
                        }
                    }
                ]);
                posTrans.quantityOpen = 0;
                posTrans.quantitySold = posTrans.quantity;
                i += 1;
            } else if (posTrans.date <= negTrans.date) {
                // if the positive transaction covers the negative, add quantityOpen of the remaining quantity on the negative transaction
                // console.info('Open negative quantity is: ', negTransOpenQuantity, 'next positive transaction has open quantity: ', posTrans.quantityOpen);
                // console.info('This positive transaction will still have open quantity after this negative transaction is deducted.');
                // console.info('The negative transaction has new purchaseValue of', negTransOpenQuantity * posTrans.upbc, 'with upbc of', posTrans.upbc);
                negTrans.purchaseValueBaseCurrency += negTransOpenQuantity * posTrans.upbc;
                negTrans.linkedTransactions = (negTrans.linkedTransactions || []).filter((lt)=>{
                    var _lt_tags;
                    return ((_lt_tags = lt.tags) === null || _lt_tags === void 0 ? void 0 : _lt_tags.type) !== "purchase";
                }) // remove existing purchase LT
                .concat([
                    {
                        id: posTrans.id,
                        category: posTrans.category,
                        tags: {
                            source: "applyFIFOReturnAll",
                            type: "purchase",
                            date: posTrans.date,
                            quantity: (reverseMode ? -1 : 1) * negTransOpenQuantity,
                            upbc: posTrans.upbc
                        }
                    }
                ]);
                posTrans.quantityOpen -= negTransOpenQuantity;
                negTransOpenQuantity = 0; // the negative transaction is fully matched
                posTrans.quantitySold = posTrans.quantity - posTrans.quantityOpen;
            } else if (posTrans.date > negTrans.date) {
                // if we ran out of transactions BEFORE the current sale transactions, it means the sale transaction exceeds all previous purchases
                // we throw an error here and leave it to the caller to handle it
                console.warn(`applyFIFOReturnAll: sale transaction exceeds all previous purchases for transaction ${JSON.stringify(negTrans, null, 2)}`);
                if (throwOnOverdraft) throw new Error(`applyFIFOReturnAll: sale transaction exceeds all previous purchases for transaction ${JSON.stringify(negTrans, null, 2)}`);
                negTransOpenQuantity = 0; // go to the next transaction
            // as fallback we provide purchaseValueBaseCurrency equal to the available quantity on the positive transaction
            }
        }
        // if there is open negTransOpenQuantity after getting out of the while loop, that means we ran out of positive transactions that came before this transaction
        if (negTransOpenQuantity > 0) {
            console.warn(`applyFIFOReturnAll: sale transaction exceeds all previous purchases for transaction ${JSON.stringify(negTrans, null, 2)}`);
            if (throwOnOverdraft) throw new Error(`applyFIFOReturnAll: sale transaction exceeds all previous purchases for transaction ${JSON.stringify(negTrans, null, 2)}`);
        }
    });
    // Return the remaining (or modified) positive transactions
    return positiveTransactions// first make sure that all positive transactions have quantityOpen (the ones after the last negative transaction won't have it) and quantitySold
    .map((t)=>{
        if (t.quantity < 0) return t;
        return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            quantityOpen: !t.quantityOpen && t.quantityOpen !== 0 ? t.quantity : t.quantityOpen,
            quantitySold: !t.quantitySold && t.quantitySold !== 0 ? 0 : t.quantitySold
        });
    }).concat(negativeTransactions).sort((a, b)=>a.date - b.date).map((t, idx, self)=>{
        if (reverseMode) {
            // in reverse mode we need to reverse the sign also for the "sale" transactions
            if (t.quantity < 0) // sales transactions do not need quantityOpen (we just need to reverse the sign of quantity here)
            return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
                purchaseValueBaseCurrency: -t.purchaseValueBaseCurrency,
                quantity: -t.quantity
            });
            const returnObject = (0, $2qxEV._)((0, $9tqwB._)({}, t), {
                quantityOpen: !t.quantityOpen && t.quantityOpen !== 0 ? self[idx - 1].quantityOpen : t.quantityOpen
            });
            return (0, $2qxEV._)((0, $9tqwB._)({}, returnObject), {
                quantityOpen: -returnObject.quantityOpen,
                quantity: -returnObject.quantity,
                quantitySold: -returnObject.quantitySold
            });
        }
        // if a transaction doesn't have quantityOpen here, it means it should just get one from the previous one
        if (t.quantity < 0) return t; // sale transactions don't need quantityOpen
        const returnObject = (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            quantityOpen: !t.quantityOpen && t.quantityOpen !== 0 ? self[idx - 1].quantityOpen : t.quantityOpen
        });
        // need to restore the negative sign if in reverse mode
        return returnObject;
    });
}
function $3e6d58b7292c657b$export$222ac7622a28f480(transactions, reverseMode = false) {
    const data = $3e6d58b7292c657b$export$3f063810d7bf01bd(transactions, [
        "category",
        "accountId",
        "assetId"
    ]);
    // returns { category1: { accountId1: { assetId1: [ { <transaction1> }, { <transaction2> }, ... ] } } }
    // iterate through all categories, accountIds and assetIds
    // apply FIFO to each array of transactions
    // return the resulting array
    return Object.entries(data).reduce((prev, [category, accounts])=>{
        const accountsArray = Object.entries(accounts).reduce((prevAccounts, [accountId, assets])=>{
            const assetsArray = Object.entries(assets).reduce((prevAssets, [assetId, assetTransactions])=>{
                const transactionsArray = $3e6d58b7292c657b$export$aeb4e5a5dec08365(assetTransactions, reverseMode);
                return [
                    ...prevAssets,
                    ...transactionsArray
                ];
            }, []);
            return [
                ...prevAccounts,
                ...assetsArray
            ];
        }, []);
        return [
            ...prev,
            ...accountsArray
        ];
    }, []);
}


/* eslint-disable no-lonely-if */ /* eslint-disable no-extend-native */ /* eslint-disable max-len */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $19dfc4c09d428def$var$debugLevel = 0;
// polyfill for Array.at()
if (!Array.prototype.at) Object.defineProperty(Array.prototype, "at", {
    value (index) {
        // Convert negative index to positive if needed
        // eslint-disable-next-line no-param-reassign
        index = index >= 0 ? index : this.length + index;
        // Return element at the specified index
        return this[index];
    },
    writable: true,
    configurable: true
});
function $19dfc4c09d428def$export$2e2bcd8739ae039({ quotes: quotes, requestedDates: requestedDates, growthRate: growthRate, dashboardMode: dashboardMode = "dashboard" }) {
    if (!quotes) throw new Error("Missing inputQuotes.");
    if (!requestedDates) throw new Error("Missing requestedDates.");
    if ([
        undefined,
        null
    ].includes(growthRate)) throw new Error("Missing growthRate.");
    if (quotes.some((q)=>q.assetId !== quotes[0].assetId)) throw new Error("All quotes must be for the same assetId.");
    if (typeof growthRate !== "number" || typeof quotes !== "object" || typeof requestedDates !== "object" || !requestedDates.length) throw new Error("Invalid argument type");
    if (quotes.length === 0) return [];
    if ($19dfc4c09d428def$var$debugLevel > 2) console.log(quotes, requestedDates, growthRate);
    const { assetId: assetId } = quotes[0];
    const nullQuote = {
        assetId: assetId,
        quote: null,
        currency: null,
        quoteDate: null,
        source: null,
        projectId: null
    };
    // sort quotes descending (oldest last) (make a copy to avoid mutating the original array)
    const sortedInputQuotes = [
        ...quotes
    ].sort((a, b)=>b.date - a.date);
    // sort requested dates ascending (oldest first)
    const sortedRequestedDates = [
        ...requestedDates
    ].sort((a, b)=>a - b);
    if ($19dfc4c09d428def$var$debugLevel > 2) console.log(sortedInputQuotes, sortedRequestedDates);
    // set loop variables
    const resultStack = [];
    let nextInputQuote; // undefined
    let previousInputQuote; // undefined
    let smoothingDeltaPerDay; // undefined
    let smoothingDeltaPerDayBaseCurrency; // undefined
    sortedRequestedDates.forEach((requestedDate)=>{
        // check if we need to update previous / next quote
        // is the last quote on sortedInputQuotes now older than requestedDate (now that we have moved to a new requestedDate)?
        // find the least older quote on sortedInputQuotes (i.e. there can be several older ones, but we need to see the last one "just before" requestedDate)
        // i.e. find the last quote on sortedInputQuotes, check if it is older than requestedDate, and if it is, pop it from sortedInputQuotes
        if (sortedInputQuotes.length > 0 && sortedInputQuotes.at(-1).date <= requestedDate) {
            do {
                // if yes, that means we can take it as a basis for calculation of smoothing or growth rate (for the next one or more requestedDates)
                previousInputQuote = sortedInputQuotes.pop(); // removes last item from sortedInputQuotes so that it is not there the next time we do this check
                nextInputQuote = sortedInputQuotes.at(-1); // can be undefined if there are no quotes left on sortedInputQuotes
                if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes:", "requestedDate is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "previousInputQuote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(previousInputQuote.date).format("YYYY-MM-DD"), "nextInputQuote is", nextInputQuote ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(nextInputQuote.date).format("YYYY-MM-DD") : "undefined", "do we need to continue?", nextInputQuote && nextInputQuote.date <= requestedDate);
            }while (nextInputQuote && nextInputQuote.date <= requestedDate);
            // calculate smoothing delta per day (do it here - once - for the current pair of previous / next input quote)
            if (previousInputQuote && nextInputQuote) {
                const daysBetweenPreviousAndNext = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(nextInputQuote === null || nextInputQuote === void 0 ? void 0 : nextInputQuote.date).diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(previousInputQuote.date), "day");
                smoothingDeltaPerDay = (nextInputQuote.quote - previousInputQuote.quote) / daysBetweenPreviousAndNext;
                smoothingDeltaPerDayBaseCurrency = (nextInputQuote.quoteBaseCurrency - previousInputQuote.quoteBaseCurrency) / daysBetweenPreviousAndNext;
            }
        }
        // implement the logic
        // is previousInputQuote defined? (it won't be defined if the first requestedDate is before the first quote on sortedInputQuotes)
        if (!previousInputQuote) {
            // if not, we return a null quote for this requested quote, because we have nothing to derive this quote from
            resultStack.push((0, $2qxEV._)((0, $9tqwB._)({}, nullQuote), {
                date: requestedDate
            }));
            if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes: (", quotes[0].assetId, ") requestedDate is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "and there is no previousInputQuote - returning null");
        } else {
            // there is a previousInputQuote already, so we can calculate smoothing / growthRate if needed
            if (nextInputQuote) {
                // if there is a nextInputQuote, we may have to do smoothing; for that both previous and next quotes would have to be manual
                if (previousInputQuote.source === "manual" && nextInputQuote.source === "manual") {
                    // do smoothing and return the resulting quote on resultStack
                    if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes: (", quotes[0].assetId, ") requestedDate is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "previous input quote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(previousInputQuote.date).format("YYYY-MM-DD"), "next input quote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(nextInputQuote.date).format("YYYY-MM-DD"), ", they are manual, so applying smoothing");
                    const daysBetweenPreviousAndThis = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(requestedDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(previousInputQuote.date), "day");
                    resultStack.push((0, $2qxEV._)((0, $9tqwB._)({}, previousInputQuote), {
                        source: "automatic",
                        date: requestedDate,
                        quote: previousInputQuote.quote + daysBetweenPreviousAndThis * smoothingDeltaPerDay,
                        quoteBaseCurrency: previousInputQuote.quoteBaseCurrency + daysBetweenPreviousAndThis * smoothingDeltaPerDayBaseCurrency
                    }));
                } else {
                    // if previous or next quote are not manual, we don't do smoothing and return an automatic quote for this requested quote
                    resultStack.push((0, $2qxEV._)((0, $9tqwB._)({}, previousInputQuote), {
                        source: "automatic",
                        date: requestedDate
                    }));
                    if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes: (", quotes[0].assetId, ") requestedDate is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "previous input quote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(previousInputQuote.date).format("YYYY-MM-DD"), "next input quote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(nextInputQuote.date).format("YYYY-MM-DD"), ", one of them is not manual, so returning previous quote");
                }
            } else // previousInputQuote is the last available quote, so we can apply growth rate in project mode
            // but only if 8 days have already passed since the previousInputQuote (we don't want to apply it too early to not confuse the user)
            // this may only be applied in project mode; in dashboard mode just return the last available quote for requestedDate with no changes
            // forgoing the 7 day requirement, as it seems potentially too confusing for users
            // it was one of the conditions below: && previousInputQuote.date + 7 * 24 * 60 * 60 * 1000 < requestedDate &&
            if (dashboardMode === "projects") {
                // apply growthRate and return the resulting quote on resultStack
                const daysBetweenPreviousAndThis = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(requestedDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(previousInputQuote.date), "day");
                const dailyGrowthRate = growthRate * 12 / 365.25; // growth rate is calculated by getMonthlyGrowthRateForAsset
                if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes: (", quotes[0].assetId, ") requestedDate is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "previous input quote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(previousInputQuote.date).format("YYYY-MM-DD"), ", there is no next input quote, so applying daily growth rate of", dailyGrowthRate, " based on growthRate of", growthRate);
                const quote = previousInputQuote.quote + daysBetweenPreviousAndThis * (previousInputQuote.quote * dailyGrowthRate);
                const quoteBaseCurrency = previousInputQuote.quoteBaseCurrency + daysBetweenPreviousAndThis * (previousInputQuote.quoteBaseCurrency * dailyGrowthRate);
                resultStack.push((0, $2qxEV._)((0, $9tqwB._)({}, previousInputQuote), {
                    source: "automatic",
                    date: requestedDate,
                    quote: quote,
                    quoteBaseCurrency: quoteBaseCurrency
                }));
                if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes: (", quotes[0].assetId, ") generated quote for date", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "is", quote, "(in base currency:", quoteBaseCurrency, ")");
            } else {
                // if this is not project mode, then return the last available quote for requestedDate with no changes
                if ($19dfc4c09d428def$var$debugLevel > 2) console.log("processQuotes: (", quotes[0].assetId, ") requestedDate is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(requestedDate).format("YYYY-MM-DD"), "previous input quote is", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(previousInputQuote.date).format("YYYY-MM-DD"), ", there is no next input quote, so returning the last available quote");
                resultStack.push((0, $2qxEV._)((0, $9tqwB._)({}, previousInputQuote), {
                    source: "automatic",
                    date: requestedDate
                }));
            }
        }
    });
    if ($19dfc4c09d428def$var$debugLevel > 2) console.log(resultStack);
    return resultStack;
}


/* eslint-disable no-nested-ternary */ /* eslint-disable max-len */ 

(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $4c2b6ea30fb06ed7$export$2e2bcd8739ae039(account, currentDate, discountRate, lumpSumMode = false) {
    // Destructuring relevant properties from the account object
    const { payoutsPhaseStart: payoutsPhaseStart, payoutsFrequency: payoutsFrequency, payoutsDuration: payoutsDuration } = account;
    // if (account.id === 'pH3zXbopZxLuAjNoqgO1Q') console.info('DEBUG calculatePVFactor', account, currentDate, discountRate, lumpSumMode, payoutsPhaseStart, payoutsFrequency, payoutsDuration);
    // Calculate the annual discount rate (assuming discountRate is provided as an annual percentage)
    const dayDiscountRate = discountRate / 100 / 365.25;
    const periodDiscountRate = discountRate / 100 / (12 / payoutsFrequency);
    // Calculate the number of periods from the current date to the start of the payout phase
    const daysUntilPayoutPhase = Math.max(0, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(payoutsPhaseStart).diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(currentDate), "day"));
    // console.log('daysUntilPayoutPhase', daysUntilPayoutPhase, 'current date', currentDate, 'payouts start date', payoutsPhaseStart);
    // number of complete payout periods before the end of the payouts phase
    const totalPayoutPeriods = payoutsDuration > 0 ? Math.floor(payoutsDuration / payoutsFrequency) : Number.POSITIVE_INFINITY;
    // Calculate Present Value at the time of first payout
    let pvFactor;
    if (lumpSumMode) pvFactor = 1; // lump sum IS the Present Value at the time of first payout
    else if (totalPayoutPeriods === Number.POSITIVE_INFINITY) pvFactor = periodDiscountRate > 0 ? 1 / periodDiscountRate : 0;
    else // Annuity for a given time period formula (expected monthly payment x this is the present value)
    pvFactor = (1 - (1 + periodDiscountRate) ** -totalPayoutPeriods) / periodDiscountRate;
    // console.log('future PV for 100€', account.name, pvFactor * 100);
    // Applying discounting for the time period until the first payment (if any)
    if (daysUntilPayoutPhase > 0) pvFactor /= (1 + dayDiscountRate) ** daysUntilPayoutPhase;
    return pvFactor;
}


var $3725b0e4673e1f0f$exports = {};
!function(t, s) {
    $3725b0e4673e1f0f$exports = s();
}($3725b0e4673e1f0f$exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($3725b0e4673e1f0f$exports);
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $93bb2798871a68d2$var$debugLevel = 0;
function $93bb2798871a68d2$var$quotePartitionToArray(partition, keys) {
    if (!partition) return [];
    if (Array.isArray(partition)) return partition;
    // Support canonical nested quote maps by flattening to rows for row-wise transforms.
    return (0, $3e6d58b7292c657b$export$a537c627e243cb6e)(partition, keys);
}
function $93bb2798871a68d2$var$findLatestQuoteRowOnOrBefore(quotesByDate, targetNumericDate) {
    if (!Number.isFinite(targetNumericDate)) return null;
    let latestDate = null;
    let latestRow = null;
    Object.keys(quotesByDate || {}).forEach((dateKey)=>{
        if (!/^\d+$/.test(String(dateKey))) return;
        const numericDate = Number(dateKey);
        if (!Number.isFinite(numericDate) || numericDate > targetNumericDate) return;
        if (latestDate !== null && numericDate <= latestDate) return;
        latestDate = numericDate;
        latestRow = quotesByDate[dateKey];
    });
    return latestRow;
}
function $93bb2798871a68d2$var$addNamedAliasesToAssetQuotes(quotesByDate, baselineView) {
    const result = (0, $9tqwB._)({}, quotesByDate);
    const aliasMap = [
        [
            "referenceBaseline",
            baselineView === null || baselineView === void 0 ? void 0 : baselineView.referenceBaseline
        ],
        [
            "baseline",
            baselineView === null || baselineView === void 0 ? void 0 : baselineView.baseline
        ],
        [
            "current",
            baselineView === null || baselineView === void 0 ? void 0 : baselineView.current
        ]
    ];
    aliasMap.forEach(([alias, numericDate])=>{
        const row = result[numericDate] || (alias === "current" ? $93bb2798871a68d2$var$findLatestQuoteRowOnOrBefore(result, Number(numericDate)) : null);
        if (!row) return;
        // Keep named alias rows selector-local; reducer stores numeric rows only.
        result[alias] = (0, $2qxEV._)((0, $9tqwB._)({}, row), {
            date: alias
        });
    });
    return result;
}
function $93bb2798871a68d2$var$addNamedAliasesToQuoteMap(quotesByAsset, baselineView) {
    return Object.entries(quotesByAsset || {}).reduce((acc, [assetId, dates])=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [assetId]: $93bb2798871a68d2$var$addNamedAliasesToAssetQuotes(dates, baselineView)
        }), {});
}
function $93bb2798871a68d2$var$compareObjects(obj1, obj2, parentKey = "") {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    const allKeys = new Set([
        ...keys1,
        ...keys2
    ]);
    allKeys.forEach((key)=>{
        const qualifiedKey = parentKey ? `${parentKey}.${key}` : key;
        const val1 = obj1[key];
        const val2 = obj2[key];
        if (typeof val1 === "object" && val1 !== null && typeof val2 === "object" && val2 !== null) // Recursive call for nested objects
        $93bb2798871a68d2$var$compareObjects(val1, val2, qualifiedKey);
        else if (val1 !== val2) console.log(`Difference at "${qualifiedKey}":`, val1, "vs", val2);
    });
}
const $93bb2798871a68d2$var$logSelectorChanges = (name, previousInputs, currentInputs)=>{
    previousInputs.forEach((previousInput, index)=>{
        const currentInput = currentInputs[index];
        if (previousInput !== currentInput) {
            console.log(`${name} > Input selector ${index + 1} has changed.`);
            console.log("Diffs:", $93bb2798871a68d2$var$compareObjects(previousInput, currentInput));
        }
    });
};
function $93bb2798871a68d2$export$d5476313612659dc(start, end, interval = 1) {
    // returns an array with 1st days of every month at 0:00 UTC between start and end
    // if interval > 1, reset to beginning of next quarter, half-year or year
    start = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).startOf("month").valueOf();
    while((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).month() % interval !== 0)start = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).add(1, "month").valueOf();
    const output = [];
    while(+start <= +end){
        output.push((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).valueOf());
        start = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(start).add(interval, "month");
    }
    return output;
}
const $93bb2798871a68d2$export$953186f0ec508e80 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.projects, (_projects)=>(projectId)=>{
        var _projects_find_settings, _projects_find;
        return !!((_projects_find = _projects.find((project)=>project.id === projectId)) === null || _projects_find === void 0 ? void 0 : (_projects_find_settings = _projects_find.settings) === null || _projects_find_settings === void 0 ? void 0 : _projects_find_settings.isIsolated);
    });
const $93bb2798871a68d2$export$6f2b36cdb0a7be5a = (0, $5c22629b42831e80$export$595d22ed68ca2841)($93bb2798871a68d2$export$953186f0ec508e80, ($getIsolatedAttributePerProjectId)=>($arr)=>($arr || []).filter((item)=>!$getIsolatedAttributePerProjectId(item.projectId)));
const $93bb2798871a68d2$export$8c577782bb016c47 = (0, $5c22629b42831e80$export$595d22ed68ca2841)(// keeping those separate and granular, as we do not want this to recompute when transactions & co. are updated
(state)=>state.data.deposits.accounts, (state)=>state.data.stocks.accounts, (state)=>state.data.crypto.accounts, (state)=>state.data.realEstate.accounts, (state)=>state.data.loans.accounts, (state)=>state.data.pension.accounts, (state)=>state.data.objectsOfValue.accounts, (state)=>state.data.metals.accounts, (state)=>state.data.unlistedShares.accounts, function globalAccountsViewCallback(deposits, stocks, crypto, realEstate, loans, pension, oov, metals, unlisted) {
    return deposits.concat(stocks, crypto, realEstate, loans, pension, oov, metals, unlisted);
});
function $93bb2798871a68d2$export$1e171b73d8258c20(state) {
    var _state_user_profile_settings, _state_user_profile;
    return (_state_user_profile = state.user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.sliderEndDate;
}
function $93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, transaction, projectMode = false) {
    // if project mode is off, and the transaction is already beyond the sliderDate, return [], as there is no need to unpack it
    if (!projectMode && transaction.date > baseDate) return [];
    const tags = typeof transaction.tags === "string" ? JSON.parse(transaction.tags) : transaction.tags;
    const recurring = tags === null || tags === void 0 ? void 0 : tags.recurring;
    if (!(recurring === null || recurring === void 0 ? void 0 : recurring.activated)) return transaction;
    const recurringPeriod = recurring.periodType.id;
    let annualIndexingRate = 1; // no indexing as default
    const indexing = tags === null || tags === void 0 ? void 0 : tags.indexing;
    // calculate annual indexing rate for indexed transactions
    let indexingRate = 0; // indexingRate as the user inputs it in %, like 3.04%
    if (indexing === null || indexing === void 0 ? void 0 : indexing.activated) {
        // get indexing mode from indexed object
        if (indexing.mode === "indexedByInflation") indexingRate = inflationRate;
        if (indexing.mode === "indexedByCustomRate") indexingRate = indexing.customRateInput;
        // vv validate the correctness of usage of recurring.numberOfPeriods
        annualIndexingRate = 1 + (recurringPeriod === "month" ? indexingRate / 12 * (recurring.numberOfPeriods || 1) / 100 : indexingRate * (recurring.numberOfPeriods || 1) / 100);
    }
    // if it is recurring, generate the transactions and return them as array of arrays (to be flattened later on)
    let maxDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc("2100-01-01").startOf("month").valueOf();
    let maxIndex = 10000;
    if (recurring.end === "recurringNever") maxDate = sliderMax;
    if (recurring.end === "recurringByDate") maxDate = recurring.endAfterDate;
    if (recurring.end === "recurringByOccurrence") maxIndex = Number(recurring.endAfterOccurrences);
    const unpackedTransactions = [
        transaction
    ]; // push original transaction first
    // if the recurring mode is 'year', the first transaction is in 12 months; otherwise in 1 month
    let date = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(transaction.date).startOf("month").add(recurringPeriod === "month" ? 1 * (recurring.numberOfPeriods || 1) : 12 * (recurring.numberOfPeriods || 1), "month").valueOf();
    // generate transactions until the first limit has been hit
    let counter = 1;
    while(date < maxDate && (projectMode ? true : date < baseDate) && unpackedTransactions.length <= maxIndex){
        const newTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
            id: transaction.id + date.valueOf(),
            date: date.valueOf(),
            recurringParentId: transaction.id,
            projectId: transaction.projectId,
            linkedTransactions: [
                ...transaction.linkedTransactions,
                {
                    id: transaction.id,
                    category: "deposits",
                    tags: {
                        type: "recurringParent"
                    }
                }
            ],
            tags: JSON.stringify((0, $2qxEV._)((0, $9tqwB._)({}, tags), {
                recurring: {
                    activated: false,
                    type: "recurringChild"
                }
            })),
            sortingOrderWithinMonth: transaction.sortingOrderWithinMonth ? transaction.sortingOrderWithinMonth : 0
        });
        // if deposits increase price, increase their quantity
        if (transaction.category === "deposits") {
            newTransaction.amount *= annualIndexingRate ** counter;
            newTransaction.accountCurrencyAmount *= annualIndexingRate ** counter;
            newTransaction.fxAmount *= annualIndexingRate ** counter;
            newTransaction.quantity *= annualIndexingRate ** counter;
        } else {
            // increase their prices
            // ↓↓ to maintain backward compatiblity after standardising fields
            if (transaction.category === "realEstate") newTransaction.quote *= annualIndexingRate ** counter; // amount is 1 or 0
            // ↓↓ to maintain backward compatiblity after standardising fields
            if (transaction.category === "stocks") {
                newTransaction.rebasedPrice *= annualIndexingRate ** counter;
                newTransaction.rebasedOriginalPrice *= annualIndexingRate ** counter;
                newTransaction.transactionPrice *= annualIndexingRate ** counter;
                newTransaction.transactionOriginalPrice *= annualIndexingRate ** counter;
            }
            newTransaction.upac *= annualIndexingRate ** counter; // FIX 240516 added as it seemed to be missing
            newTransaction.upbc *= annualIndexingRate ** counter;
            newTransaction.uptc *= annualIndexingRate ** counter;
        }
        unpackedTransactions.push(newTransaction);
        // increase the date of next transaction by 1 month or 12 months
        date = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(date).startOf("month").add(recurringPeriod === "month" ? 1 * (recurring.numberOfPeriods || 1) : 12 * (recurring.numberOfPeriods || 1), "month").valueOf();
        counter += 1;
    }
    return unpackedTransactions;
}
const $93bb2798871a68d2$export$855dafefacd5cd8f = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.baseDate;
}, $93bb2798871a68d2$export$1e171b73d8258c20, function unpackRecurringTransactionCallbackOuter(inflationRate, baseDate, sliderMax) {
    return function unpackRecurringTransactionCallbackInner(transaction, projectMode = false) {
        return $93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, transaction, projectMode);
    };
});
const $93bb2798871a68d2$export$ed7bd0bffee7a6a7 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>Object.keys(state.data), (state)=>state.data, (state, withIsolatedTransactions = false)=>withIsolatedTransactions, $93bb2798871a68d2$export$6f2b36cdb0a7be5a, $93bb2798871a68d2$export$855dafefacd5cd8f, (categories, data, $withIsolatedTransactions, $eliminateIsolatedTransactions, $unpackRecurringTransactions)=>{
    const transactions = categories.map((category)=>($withIsolatedTransactions ? data[category].simulatedTransactions : $eliminateIsolatedTransactions(data[category].simulatedTransactions) || []).map((transaction)=>(0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                category: category
            }))// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((t)=>$unpackRecurringTransactions)).flat();
    return transactions;
});
const $93bb2798871a68d2$export$4bb039911f93bce = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_user_profile, _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : _state_user_profile.settings;
}, (state)=>state.simulation, function globalBaselineViewCallback(settings, simulation) {
    var _settings_baselineDate;
    const baselinePeriodLengthInYears = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc((settings === null || settings === void 0 ? void 0 : settings.baselineDate) || 0), "year");
    const namedBaseline = settings === null || settings === void 0 ? void 0 : settings.namedBaseline;
    if ((simulation === null || simulation === void 0 ? void 0 : simulation.dashboardMode) === "projects") {
        // check if the current baseline setting is a "namedBaseline" setting
        // if so, keep the original intention of the setting
        // values tested here are initially defined in elements/SumTileExpandable.jsx > BaselineSelector
        // sameTimeLastYear | currentYearBegin | previousYearBegin
        const sliderDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(simulation.baseDate).startOf("day");
        const current = sliderDate.valueOf();
        if (namedBaseline === "sameTimeLastYear") return {
            baseline: sliderDate.subtract(1, "year").startOf("day").valueOf(),
            referenceBaseline: sliderDate.subtract(2, "year").startOf("day").valueOf(),
            current: current
        };
        if (namedBaseline === "currentYearBegin") {
            const baseline = sliderDate.startOf("year").valueOf();
            const referenceBaseline = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(baseline).subtract(baselinePeriodLengthInYears, "year").valueOf();
            return {
                baseline: baseline,
                referenceBaseline: referenceBaseline,
                current: current
            };
        }
        if (namedBaseline === "previousYearBegin") {
            const baseline = sliderDate.subtract(1, "year").startOf("year").valueOf();
            const referenceBaseline = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(baseline).subtract(baselinePeriodLengthInYears, "year").valueOf();
            return {
                baseline: baseline,
                referenceBaseline: referenceBaseline,
                current: current
            };
        }
        return {
            baseline: sliderDate.subtract(baselinePeriodLengthInYears, "year").valueOf(),
            referenceBaseline: sliderDate.subtract(2 * baselinePeriodLengthInYears, "year").valueOf(),
            current: current
        };
    }
    // under normal circumstances, return baseline as it is and subtract baselinePeriodLength from it to arrive at referenceBaseline
    const currentFromSettings = Number(settings === null || settings === void 0 ? void 0 : settings.current);
    const current = Number.isFinite(currentFromSettings) ? currentFromSettings : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf();
    return {
        baseline: settings === null || settings === void 0 ? void 0 : (_settings_baselineDate = settings.baselineDate) === null || _settings_baselineDate === void 0 ? void 0 : _settings_baselineDate.valueOf(),
        // just to handle the empty state put baselinePeriodLength in there
        referenceBaseline: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(settings === null || settings === void 0 ? void 0 : settings.baselineDate).subtract(baselinePeriodLengthInYears, "year").valueOf(),
        current: current
    };
});
const $93bb2798871a68d2$export$baf5c2f62dd5cf3e = (state)=>$93bb2798871a68d2$export$4bb039911f93bce(state).baseline;
const $93bb2798871a68d2$export$80e72cf626efa9e8 = (state)=>$93bb2798871a68d2$export$4bb039911f93bce(state).referenceBaseline;
const $93bb2798871a68d2$export$f4deae28f88bc4e5 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data, function assetHierarchyDnormCallback(data) {
    // we cannot use the allTransactions view here, because it uses simulatedDividendTransactions, which uses output of globalQuotesView (because dividends are a % of price)
    // we do not risk much, because transactions added before allTransactions do not have any new assetIds
    const transactions = [];
    Object.keys(data).forEach((category)=>{
        transactions.push(...data[category].transactions || []);
        transactions.push(...data[category].simulatedTransactions || []);
    });
    const result = transactions.reduce((acc, transaction)=>{
        const { category: category, accountId: accountId, assetId: assetId } = transaction;
        if (!acc[category]) acc[category] = {};
        if (!acc[category][accountId]) acc[category][accountId] = [
            assetId
        ];
        else if (!acc[category][accountId].includes(assetId)) acc[category][accountId].push(assetId);
        return acc;
    }, {});
    const output = [];
    for(const category in result)if (Object.prototype.hasOwnProperty.call(result, category)) {
        const accounts = result[category];
        for(const accountId in accounts)if (Object.prototype.hasOwnProperty.call(accounts, accountId)) {
            const assetIds = accounts[accountId];
            assetIds.forEach((assetId)=>output.push({
                    category: category,
                    accountId: accountId,
                    assetId: assetId
                }));
        }
    }
    return output;
});
const $93bb2798871a68d2$export$bc8855b14ae45a74 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data, (data)=>{
    const categories = Object.keys(data || []);
    const settings = categories.map((category)=>({
            [category]: data[category].settings
        })).reduce((acc, val)=>(0, $9tqwB._)({}, acc, val), {});
    return settings;
});
function $93bb2798871a68d2$export$cf15a845f17dabed(assetId, thisCategorySettings, accounts, $projects, isolatedProjectId) {
    let growthRate; // default value
    // for isolated project check if there are project-specific growth rates
    if (isolatedProjectId) {
        var _isolatedProject_settings_growthRates_find, _isolatedProject_settings;
        const isolatedProject = $projects.find((project)=>project.id === isolatedProjectId);
        growthRate = isolatedProject === null || isolatedProject === void 0 ? void 0 : (_isolatedProject_settings = isolatedProject.settings) === null || _isolatedProject_settings === void 0 ? void 0 : (_isolatedProject_settings_growthRates_find = _isolatedProject_settings.growthRates.find((x)=>x.symbol.id === assetId)) === null || _isolatedProject_settings_growthRates_find === void 0 ? void 0 : _isolatedProject_settings_growthRates_find.value;
        if (!growthRate && growthRate !== 0) // accept 0, but not null, undefined
        // if not existing, return category-level settings
        growthRate = thisCategorySettings === null || thisCategorySettings === void 0 ? void 0 : thisCategorySettings.growthRate;
        return growthRate / 12 / 100 || 0;
    }
    // first, is this an asset which is an account? (like realEstate)? then return the account growth rate or category-level rate as fallback
    const isAssetAnAccount = !!accounts.find((account)=>account.id === assetId); // if this asset is an account, it is like realEstate (one asset per account)
    if (isAssetAnAccount) {
        var _accounts_find_tags, _accounts_find;
        growthRate = (_accounts_find = accounts.find((account)=>account.id === assetId)) === null || _accounts_find === void 0 ? void 0 : (_accounts_find_tags = _accounts_find.tags) === null || _accounts_find_tags === void 0 ? void 0 : _accounts_find_tags.growthRate; // so get growthRate from account
        if (!growthRate && growthRate !== 0) // accept 0, but not null, undefined
        // if not existing, return category-level settings
        growthRate = thisCategorySettings === null || thisCategorySettings === void 0 ? void 0 : thisCategorySettings.growthRate;
    } else {
        var _thisCategorySettings_growthRates_find, _thisCategorySettings_growthRates;
        // if asset is not account, then this is a category with assets, so get the asset growth rate or category asset growth rate as fallback
        const assetLevelRate = (thisCategorySettings === null || thisCategorySettings === void 0 ? void 0 : (_thisCategorySettings_growthRates = thisCategorySettings.growthRates) === null || _thisCategorySettings_growthRates === void 0 ? void 0 : (_thisCategorySettings_growthRates_find = _thisCategorySettings_growthRates.find((x)=>x.symbol.id === assetId)) === null || _thisCategorySettings_growthRates_find === void 0 ? void 0 : _thisCategorySettings_growthRates_find.value) || (thisCategorySettings === null || thisCategorySettings === void 0 ? void 0 : thisCategorySettings.growthRate) || 0;
        growthRate = assetLevelRate;
    }
    return Number(growthRate) / 12 / 100 || 0;
}
// helper function used to prepare global and isolated quotes before applying project-mode calculations and returning them as globalQuotesArray
// used for:
// - handling specialQuotes for pensions (get the right specialQuote out of quote.specialQuotes based on the account setting)
//   NOTE: this can only work if assetId === accountId (currently enabled for pensions only)
//   (if there are specialQuotes, find out which are we to use from account.useSpecialQuote)
// - applying spread "in minus" as per account settings to the quotes of metals
function $93bb2798871a68d2$var$prepareQuotes(quotesInput, accounts, keys, inflationRate) {
    const allPensionAccounts = accounts.filter((a)=>a.category === "pension");
    const allMetalsAccounts = accounts.filter((a)=>a.category === "metals");
    const quotesArray = $93bb2798871a68d2$var$quotePartitionToArray(quotesInput, keys);
    if (!quotesArray || quotesArray.length === 0) return {};
    return (0, $3e6d58b7292c657b$export$d224121420685233)(quotesArray.map((q)=>{
        const thisIsPensionAccount = allPensionAccounts.find((a)=>a.id === q.assetId);
        const thisIsMetalsAccount = allMetalsAccounts.find((a)=>a.id === q.assetId);
        if (thisIsPensionAccount) try {
            if (q.date < thisIsPensionAccount.productPurchaseDate) return q; // if the quote is older than the purchase date, return unchanged (null or 0)
            const { useSpecialQuote: useSpecialQuote, discountRateIsInflation: discountRateIsInflation, customDiscountRate: customDiscountRate } = thisIsPensionAccount; // this has the quote type that we are to use for this product
            const selectedSpecialQuote = (q.specialQuotes || []).find((sq)=>sq.type === useSpecialQuote);
            // e.g. 150€ / month or 36000€ lump sum
            // 251217 there is no option of NOT using present value to calculate product value, because not using it would make no sense
            const customDiscountRateNumber = Number.isFinite(Number(customDiscountRate)) ? Number(customDiscountRate) : null;
            // Use custom rate only when explicitly selected and numeric; otherwise default to inflation mode.
            const useCustomDiscountRate = discountRateIsInflation === false && customDiscountRateNumber !== null;
            const discountRate = useCustomDiscountRate ? customDiscountRateNumber : inflationRate;
            // if (thisIsPensionAccount.id === 'pH3zXbopZxLuAjNoqgO1Q') console.log('DEBUG prepareQuotes', selectedSpecialQuote);
            if (selectedSpecialQuote) {
                const { quote: quote, quoteBaseCurrency: quoteBaseCurrency } = selectedSpecialQuote;
                // redundant through quotes 2.0 implemenation (no more named quotes in Quotes slice)
                // const handleNamedQuotesDate = Number.isInteger(q.date) ? q.date : q.namedQuoteDate; // named dates have 'baseline' etc. in the date field
                // const pvFactor = calculatePV(thisIsPensionAccount, handleNamedQuotesDate, discountRate || 0, useSpecialQuote === 'payoutLumpSumVerrentet');
                const pvFactor = (0, $4c2b6ea30fb06ed7$export$2e2bcd8739ae039)(thisIsPensionAccount, q.date, discountRate || 0, useSpecialQuote === "payoutLumpSumVerrentet");
                return (0, $2qxEV._)((0, $9tqwB._)({}, q), {
                    quote: quote * pvFactor,
                    quoteBaseCurrency: quoteBaseCurrency * pvFactor
                });
            }
            return q;
        } catch (err) {
            console.error("Error in prepareQuotes", err);
            console.error(`Parameters passed are q: ${JSON.stringify(q, null, 2)}, getPensionAccount: ${JSON.stringify(thisIsPensionAccount, null, 2)}`);
            return q;
        }
        if (thisIsMetalsAccount) try {
            const { spread: spread } = thisIsMetalsAccount.tags;
            const calculatedSpread = 1 - (spread || 0) / 100;
            return (0, $2qxEV._)((0, $9tqwB._)({}, q), {
                quote: q.quote * calculatedSpread,
                quoteBaseCurrency: q.quoteBaseCurrency * calculatedSpread
            });
        } catch (err) {
            console.error("Error in prepareQuotes", err);
            console.error(`Parameters passed are q: ${JSON.stringify(q, null, 2)}, getMetalsAccount: ${JSON.stringify(thisIsMetalsAccount, null, 2)}`);
            return q;
        }
        // if this is not a special case, just return it as is
        return q;
    }), keys);
}
function $93bb2798871a68d2$export$502b8c77f911abd0(sliderEnd, $dashboardMode, selectQuotes, accounts, $baselineView, $projects, $assetHierarchy, $settingsByCategories, $isolatedProjectId, inflationRate = null) {
    // if (debugLevel > 2) console.log('assetHierarchy', $assetHierarchy);
    const timer = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().valueOf();
    // selectQuotes can be legacy arrays or canonical nested maps.
    // handle specialQuotes for pensions and spread for metals
    const quotes = {
        global: $93bb2798871a68d2$var$prepareQuotes(selectQuotes.global, accounts, [
            "assetId",
            "date"
        ], inflationRate),
        isolated: $93bb2798871a68d2$var$prepareQuotes(selectQuotes.isolated, accounts, [
            "projectId",
            "assetId",
            "date"
        ], inflationRate)
    };
    if ($dashboardMode === "projects") {
        // in project mode generate simulated future quotes for each asset for all months between today and slider end date
        // prepare input quotes, get growthRate for each asset, and run processQuotes (smoothing wherever applicable + create future simulated quotes with applied growth rate) for each asset
        // processQuotes needs a current quote and all manual quotes for the future
        // select base quotes (either global or isolated for one project)
        // console.log('DEBUG', quotes, $isolatedProjectId, quotes.isolated);
        const isolatedQuotesForProjectId = quotes.isolated[$isolatedProjectId] || {};
        const simulated = Object.entries(($isolatedProjectId ? isolatedQuotesForProjectId : quotes.global) || []).reduce((accAssets, [assetId, inputDatesAndQuotesForAssetIdObject])=>{
            var _$assetHierarchy_find;
            // find out category of the asset (assetHierarchy is an array of all existing category-accountId-assetId)
            const category = (_$assetHierarchy_find = $assetHierarchy.find((x)=>x.assetId === assetId)) === null || _$assetHierarchy_find === void 0 ? void 0 : _$assetHierarchy_find.category;
            // get growth rate for this asset (or category-level rate if asset-/account-level not available)
            const thisCategorySettings = ($settingsByCategories === null || $settingsByCategories === void 0 ? void 0 : $settingsByCategories[category]) || {};
            const growthRate = $93bb2798871a68d2$export$cf15a845f17dabed(assetId, thisCategorySettings, accounts, $projects, $isolatedProjectId);
            const namedTimePeriods = [
                "current",
                "baseline",
                "referenceBaseline"
            ];
            // convert input quotes for this assetId to an array of quote objects
            const inputQuotesArray = Object.values(inputDatesAndQuotesForAssetIdObject).filter((quoteObject)=>!namedTimePeriods.includes(quoteObject.date)); // remove old named quotes from the list
            // take datesWithQuotesArray and extract only the quotes which change something (and not those which just "carry over" from previous month) -- this is required by processQuotes
            // if the first manual quote is in the future (e.g. the user does not own this stock yet), get rid of current quote by filtering out all quotes which have null as value
            // (Quotes API is always sending _most_recent_ value, event if that value is 3 years old)
            // pass all manual quotes to processQuotes, it will sort out the most recent date
            const uniqueCurrentAndFutureInputQuotesArray = inputQuotesArray.reduce((acc, quote)=>{
                // if there is a quote for this quoteDate already, do not add it again
                if (acc.filter((q)=>q.quoteDate === quote.quoteDate).length > 0) return acc;
                acc.push((0, $2qxEV._)((0, $9tqwB._)({}, quote), {
                    date: quote.quoteDate || quote.date
                })); // 'date' is no longer relevant here, as we have created a list of unique quoteDates
                return acc;
            }, []);
            // if (debugLevel > 2) console.log('prep monthDates', dayjs.utc().startOf('day').valueOf(), sliderEnd);
            const months = $93bb2798871a68d2$export$d5476313612659dc((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf(), sliderEnd); // this needs to generate quotes up until sliderEnd, as this is used in ProjectDetails
            const monthsIncludingNamed = months.concat([
                $baselineView.referenceBaseline,
                $baselineView.baseline,
                $baselineView.current
            ]);
            // if (debugLevel > 2) console.log('monthsIncludingNamed', monthsIncludingNamed);
            let generatedQuotesArray;
            try {
                generatedQuotesArray = (0, $19dfc4c09d428def$export$2e2bcd8739ae039)({
                    growthRate: growthRate,
                    quotes: uniqueCurrentAndFutureInputQuotesArray,
                    requestedDates: monthsIncludingNamed,
                    dashboardMode: "projects"
                });
                if ($93bb2798871a68d2$var$debugLevel > 2) console.log("generatedQuotesArray", assetId, category, "growthRate", growthRate, "settings", thisCategorySettings, generatedQuotesArray);
            } catch (e) {
                console.error("Error in processQuotesPerAssetId", e);
                console.error(`Parameters passed are assetId: ${assetId}, growthRate: ${growthRate}, inputQuotes: ${uniqueCurrentAndFutureInputQuotesArray}, requestedDates: ${monthsIncludingNamed}`);
                throw new Error(e);
            }
            const mergedQuotesNumeric = inputQuotesArray.concat(generatedQuotesArray).reduce((acc, quoteObject)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                    [quoteObject.date]: quoteObject
                }), {});
            return (0, $2qxEV._)((0, $9tqwB._)({}, accAssets), {
                [assetId]: $93bb2798871a68d2$var$addNamedAliasesToAssetQuotes(mergedQuotesNumeric, $baselineView)
            }); // reduce
        }, {});
        return simulated;
    }
    return $93bb2798871a68d2$var$addNamedAliasesToQuoteMap(quotes.global, $baselineView);
}
const $93bb2798871a68d2$export$c5fc0a509c4f2b35 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_user_profile;
    return (_state_user_profile = state.user.profile) === null || _state_user_profile === void 0 ? void 0 : _state_user_profile.settings.sliderEndDate;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>state.quotes, $93bb2798871a68d2$export$8c577782bb016c47, $93bb2798871a68d2$export$4bb039911f93bce, (state)=>state.projects, $93bb2798871a68d2$export$f4deae28f88bc4e5, $93bb2798871a68d2$export$bc8855b14ae45a74, (state)=>{
    var _state_user_profile, _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : _state_user_profile.settings.inflationRate;
}, function globalQuotesViewGenericCallback(sliderEnd, dashboardMode, quotes, accounts, baselineView, projects, assetHierarchy, settingsByCategories, inflationRate) {
    return $93bb2798871a68d2$export$502b8c77f911abd0(sliderEnd, dashboardMode, quotes, accounts, baselineView, projects, assetHierarchy, settingsByCategories, null, inflationRate);
});
function $93bb2798871a68d2$export$f1fab9431439ab20(state, isolatedProjectId) {
    var _state_user_profile, _state_simulation, _state_user_profile1, _state_user;
    return $93bb2798871a68d2$export$502b8c77f911abd0((_state_user_profile = state.user.profile) === null || _state_user_profile === void 0 ? void 0 : _state_user_profile.settings.sliderEndDate, (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode, state.quotes, $93bb2798871a68d2$export$8c577782bb016c47(state), $93bb2798871a68d2$export$4bb039911f93bce(state), state.projects, $93bb2798871a68d2$export$f4deae28f88bc4e5(state), $93bb2798871a68d2$export$bc8855b14ae45a74(state), isolatedProjectId, (_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile1 = _state_user.profile) === null || _state_user_profile1 === void 0 ? void 0 : _state_user_profile1.settings.inflationRate);
}
function $93bb2798871a68d2$export$443f4a6ebd922e0a(state, isolatedProjectId) {
    // we see calls to globalQuotesView which do have a second argument, but not a projectId (probable bug);
    // to weed them out (there is performance impact), we need to check if the second argument is a nanoid string
    if (/^[A-Za-z0-9_-]{21}$/.test(isolatedProjectId)) return $93bb2798871a68d2$export$f1fab9431439ab20(state, isolatedProjectId);
    return $93bb2798871a68d2$export$c5fc0a509c4f2b35(state);
}
function $93bb2798871a68d2$export$32058f168ca0310f(state, isolatedProjectId) {
    if (!isolatedProjectId) return (0, $3e6d58b7292c657b$export$a537c627e243cb6e)($93bb2798871a68d2$export$c5fc0a509c4f2b35(state), [
        "assetId",
        "date"
    ]);
    return (0, $3e6d58b7292c657b$export$a537c627e243cb6e)($93bb2798871a68d2$export$f1fab9431439ab20(state, isolatedProjectId), [
        "assetId",
        "date"
    ]);
}


/* eslint-disable import/no-cycle */ /* eslint-disable no-param-reassign */ // we can "afford" that, because under createSlice there is Immer which does the magic

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");
/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");
var $62f86c6ad1e80146$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $62f86c6ad1e80146$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$62f86c6ad1e80146$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$62f86c6ad1e80146$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$62f86c6ad1e80146$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $62f86c6ad1e80146$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $62f86c6ad1e80146$var$DIGIT_REGEX = /^\d+$/, $62f86c6ad1e80146$var$LEAD_DIGIT_REGEX = /^\d/, $62f86c6ad1e80146$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $62f86c6ad1e80146$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $62f86c6ad1e80146$var$MAX_CACHE_SIZE = 512;
var $62f86c6ad1e80146$var$pathCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE), $62f86c6ad1e80146$var$setCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE), $62f86c6ad1e80146$var$getCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE);
var $62f86c6ad1e80146$var$config;
$62f86c6ad1e80146$exports = {
    Cache: $62f86c6ad1e80146$var$Cache,
    split: $62f86c6ad1e80146$var$split,
    normalizePath: $62f86c6ad1e80146$var$normalizePath,
    setter: function(path) {
        var parts = $62f86c6ad1e80146$var$normalizePath(path);
        return $62f86c6ad1e80146$var$setCache.get(path) || $62f86c6ad1e80146$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $62f86c6ad1e80146$var$normalizePath(path);
        return $62f86c6ad1e80146$var$getCache.get(path) || $62f86c6ad1e80146$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($62f86c6ad1e80146$var$isQuoted(part) || $62f86c6ad1e80146$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $62f86c6ad1e80146$var$forEach(Array.isArray(path) ? path : $62f86c6ad1e80146$var$split(path), cb, thisArg);
    }
};
function $62f86c6ad1e80146$var$normalizePath(path) {
    return $62f86c6ad1e80146$var$pathCache.get(path) || $62f86c6ad1e80146$var$pathCache.set(path, $62f86c6ad1e80146$var$split(path).map(function(part) {
        return part.replace($62f86c6ad1e80146$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $62f86c6ad1e80146$var$split(path) {
    return path.match($62f86c6ad1e80146$var$SPLIT_REGEX) || [
        ""
    ];
}
function $62f86c6ad1e80146$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($62f86c6ad1e80146$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $62f86c6ad1e80146$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $62f86c6ad1e80146$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $62f86c6ad1e80146$var$hasLeadingNumber(part) {
    return part.match($62f86c6ad1e80146$var$LEAD_DIGIT_REGEX) && !part.match($62f86c6ad1e80146$var$DIGIT_REGEX);
}
function $62f86c6ad1e80146$var$hasSpecialChars(part) {
    return $62f86c6ad1e80146$var$SPEC_CHAR_REGEX.test(part);
}
function $62f86c6ad1e80146$var$shouldBeQuoted(part) {
    return !$62f86c6ad1e80146$var$isQuoted(part) && ($62f86c6ad1e80146$var$hasLeadingNumber(part) || $62f86c6ad1e80146$var$hasSpecialChars(part));
}


var $4bca57257e8cec66$exports = {};
const $4bca57257e8cec66$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $4bca57257e8cec66$var$words = (str)=>str.match($4bca57257e8cec66$var$reWords) || [];
const $4bca57257e8cec66$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $4bca57257e8cec66$var$join = (str, d)=>$4bca57257e8cec66$var$words(str).join(d).toLowerCase();
const $4bca57257e8cec66$var$camelCase = (str)=>$4bca57257e8cec66$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $4bca57257e8cec66$var$pascalCase = (str)=>$4bca57257e8cec66$var$upperFirst($4bca57257e8cec66$var$camelCase(str));
const $4bca57257e8cec66$var$snakeCase = (str)=>$4bca57257e8cec66$var$join(str, "_");
const $4bca57257e8cec66$var$kebabCase = (str)=>$4bca57257e8cec66$var$join(str, "-");
const $4bca57257e8cec66$var$sentenceCase = (str)=>$4bca57257e8cec66$var$upperFirst($4bca57257e8cec66$var$join(str, " "));
const $4bca57257e8cec66$var$titleCase = (str)=>$4bca57257e8cec66$var$words(str).map($4bca57257e8cec66$var$upperFirst).join(" ");
$4bca57257e8cec66$exports = {
    words: $4bca57257e8cec66$var$words,
    upperFirst: $4bca57257e8cec66$var$upperFirst,
    camelCase: $4bca57257e8cec66$var$camelCase,
    pascalCase: $4bca57257e8cec66$var$pascalCase,
    snakeCase: $4bca57257e8cec66$var$snakeCase,
    kebabCase: $4bca57257e8cec66$var$kebabCase,
    sentenceCase: $4bca57257e8cec66$var$sentenceCase,
    titleCase: $4bca57257e8cec66$var$titleCase
};


var $8818e0f94c57edd0$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $8818e0f94c57edd0$exports = function(edges) {
    return $8818e0f94c57edd0$var$toposort($8818e0f94c57edd0$var$uniqueNodes(edges), edges);
};
$8818e0f94c57edd0$exports.array = $8818e0f94c57edd0$var$toposort;
function $8818e0f94c57edd0$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $8818e0f94c57edd0$var$makeOutgoingEdges(edges), nodesHash = $8818e0f94c57edd0$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $8818e0f94c57edd0$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $8818e0f94c57edd0$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $8818e0f94c57edd0$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $57e52f3b537dfd4b$var$toString = Object.prototype.toString;
const $57e52f3b537dfd4b$var$errorToString = Error.prototype.toString;
const $57e52f3b537dfd4b$var$regExpToString = RegExp.prototype.toString;
const $57e52f3b537dfd4b$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $57e52f3b537dfd4b$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $57e52f3b537dfd4b$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $57e52f3b537dfd4b$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $57e52f3b537dfd4b$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $57e52f3b537dfd4b$var$symbolToString.call(val).replace($57e52f3b537dfd4b$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $57e52f3b537dfd4b$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $57e52f3b537dfd4b$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $57e52f3b537dfd4b$var$regExpToString.call(val);
    return null;
}
function $57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $57e52f3b537dfd4b$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $57e52f3b537dfd4b$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $57e52f3b537dfd4b$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $57e52f3b537dfd4b$var$_Symbol$toStringTag, $57e52f3b537dfd4b$var$_Symbol$hasInstance, $57e52f3b537dfd4b$var$_Symbol$toStringTag2;
let $57e52f3b537dfd4b$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$57e52f3b537dfd4b$var$_Symbol$toStringTag = Symbol.toStringTag;
class $57e52f3b537dfd4b$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$57e52f3b537dfd4b$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $57e52f3b537dfd4b$var$toArray(errorOrErrors).forEach((err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$57e52f3b537dfd4b$var$_Symbol$hasInstance = Symbol.hasInstance;
$57e52f3b537dfd4b$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $57e52f3b537dfd4b$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($57e52f3b537dfd4b$var$strReg, (_, key)=>$57e52f3b537dfd4b$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    static [$57e52f3b537dfd4b$var$_Symbol$hasInstance](inst) {
        return $57e52f3b537dfd4b$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $57e52f3b537dfd4b$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$57e52f3b537dfd4b$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $57e52f3b537dfd4b$export$2191b9da168c6cf0);
    }
}
let $57e52f3b537dfd4b$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $57e52f3b537dfd4b$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $57e52f3b537dfd4b$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $57e52f3b537dfd4b$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $57e52f3b537dfd4b$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $57e52f3b537dfd4b$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $57e52f3b537dfd4b$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $57e52f3b537dfd4b$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $57e52f3b537dfd4b$export$2191b9da168c6cf0.formatError($57e52f3b537dfd4b$var$mixed.notType, params);
    }
};
var $57e52f3b537dfd4b$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $57e52f3b537dfd4b$var$mixed,
    string: $57e52f3b537dfd4b$var$string,
    number: $57e52f3b537dfd4b$var$number,
    date: $57e52f3b537dfd4b$var$date,
    object: $57e52f3b537dfd4b$var$object,
    array: $57e52f3b537dfd4b$var$array,
    boolean: $57e52f3b537dfd4b$var$boolean,
    tuple: $57e52f3b537dfd4b$var$tuple
});
const $57e52f3b537dfd4b$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $57e52f3b537dfd4b$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $57e52f3b537dfd4b$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
}
const $57e52f3b537dfd4b$var$prefixes = {
    context: "$",
    value: "."
};
function $57e52f3b537dfd4b$export$eff4d24c3ff7876e(key, options) {
    return new $57e52f3b537dfd4b$var$Reference(key, options);
}
class $57e52f3b537dfd4b$var$Reference {
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $57e52f3b537dfd4b$var$prefixes.context;
        this.isValue = this.key[0] === $57e52f3b537dfd4b$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $57e52f3b537dfd4b$var$prefixes.context : this.isValue ? $57e52f3b537dfd4b$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $62f86c6ad1e80146$exports.getter)(this.path, true);
        this.map = options.map;
    }
}
// @ts-ignore
$57e52f3b537dfd4b$var$Reference.prototype.__isYupRef = true;
const $57e52f3b537dfd4b$var$isAbsent = (value)=>value == null;
function $57e52f3b537dfd4b$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $57e52f3b537dfd4b$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $57e52f3b537dfd4b$export$2191b9da168c6cf0($57e52f3b537dfd4b$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $57e52f3b537dfd4b$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $57e52f3b537dfd4b$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $62f86c6ad1e80146$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $57e52f3b537dfd4b$export$cfedb76369cc7782(obj, path, value, context) {
    return $57e52f3b537dfd4b$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $57e52f3b537dfd4b$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($57e52f3b537dfd4b$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $57e52f3b537dfd4b$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $57e52f3b537dfd4b$var$clone(src, seen = new Map()) {
    if ($57e52f3b537dfd4b$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $57e52f3b537dfd4b$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $57e52f3b537dfd4b$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($57e52f3b537dfd4b$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $57e52f3b537dfd4b$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $57e52f3b537dfd4b$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $57e52f3b537dfd4b$var$isAbsent(result)) return result;
            let formattedValue = $57e52f3b537dfd4b$export$5790025c6e6c2ba6(value);
            let formattedResult = $57e52f3b537dfd4b$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $57e52f3b537dfd4b$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $57e52f3b537dfd4b$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $57e52f3b537dfd4b$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $57e52f3b537dfd4b$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $57e52f3b537dfd4b$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $57e52f3b537dfd4b$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $57e52f3b537dfd4b$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $57e52f3b537dfd4b$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $57e52f3b537dfd4b$var$toArray(keys).map((key)=>new $57e52f3b537dfd4b$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $57e52f3b537dfd4b$var$Condition(deps, options) : $57e52f3b537dfd4b$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $57e52f3b537dfd4b$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $57e52f3b537dfd4b$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $57e52f3b537dfd4b$var$ReferenceSet();
        this._blacklist = new $57e52f3b537dfd4b$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($57e52f3b537dfd4b$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
}
// @ts-expect-error
$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $57e52f3b537dfd4b$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[alias] = $57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[alias] = $57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.notOneOf;
const $57e52f3b537dfd4b$var$returnsTrue = ()=>true;
function $57e52f3b537dfd4b$export$9b30b6294c1449a8(spec) {
    return new $57e52f3b537dfd4b$export$1e88358c94ddec71(spec);
}
class $57e52f3b537dfd4b$export$1e88358c94ddec71 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $57e52f3b537dfd4b$var$returnsTrue
        }, spec));
    }
}
$57e52f3b537dfd4b$export$9b30b6294c1449a8.prototype = $57e52f3b537dfd4b$export$1e88358c94ddec71.prototype;
function $57e52f3b537dfd4b$export$87b259aa03e3d267() {
    return new $57e52f3b537dfd4b$export$c7980688f11e1f49();
}
class $57e52f3b537dfd4b$export$c7980688f11e1f49 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    isTrue(message = $57e52f3b537dfd4b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $57e52f3b537dfd4b$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $57e52f3b537dfd4b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $57e52f3b537dfd4b$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
}
$57e52f3b537dfd4b$export$87b259aa03e3d267.prototype = $57e52f3b537dfd4b$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $57e52f3b537dfd4b$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $57e52f3b537dfd4b$var$parseIsoDate(date) {
    const struct = $57e52f3b537dfd4b$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $57e52f3b537dfd4b$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $57e52f3b537dfd4b$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $57e52f3b537dfd4b$var$toNumber(regexResult[1]),
        month: $57e52f3b537dfd4b$var$toNumber(regexResult[2], 1) - 1,
        day: $57e52f3b537dfd4b$var$toNumber(regexResult[3], 1),
        hour: $57e52f3b537dfd4b$var$toNumber(regexResult[4]),
        minute: $57e52f3b537dfd4b$var$toNumber(regexResult[5]),
        second: $57e52f3b537dfd4b$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $57e52f3b537dfd4b$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $57e52f3b537dfd4b$var$toNumber(regexResult[10]),
        minuteOffset: $57e52f3b537dfd4b$var$toNumber(regexResult[11])
    };
}
function $57e52f3b537dfd4b$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $57e52f3b537dfd4b$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $57e52f3b537dfd4b$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $57e52f3b537dfd4b$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $57e52f3b537dfd4b$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $57e52f3b537dfd4b$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $57e52f3b537dfd4b$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $57e52f3b537dfd4b$var$rIsoDateTime = new RegExp(`${$57e52f3b537dfd4b$var$yearMonthDay}T${$57e52f3b537dfd4b$var$hourMinuteSecond}(\\.\\d+)?${$57e52f3b537dfd4b$var$zOrOffset}$`);
let $57e52f3b537dfd4b$var$isTrimmed = (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.trim();
let $57e52f3b537dfd4b$var$objStringTag = ({}).toString();
function $57e52f3b537dfd4b$export$22b082955e083ec3() {
    return new $57e52f3b537dfd4b$export$49bf8b2ede5138eb();
}
class $57e52f3b537dfd4b$export$49bf8b2ede5138eb extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $57e52f3b537dfd4b$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $57e52f3b537dfd4b$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $57e52f3b537dfd4b$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $57e52f3b537dfd4b$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $57e52f3b537dfd4b$var$string.email) {
        return this.matches($57e52f3b537dfd4b$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $57e52f3b537dfd4b$var$string.url) {
        return this.matches($57e52f3b537dfd4b$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $57e52f3b537dfd4b$var$string.uuid) {
        return this.matches($57e52f3b537dfd4b$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($57e52f3b537dfd4b$var$rIsoDateTime, {
            name: "datetime",
            message: message || $57e52f3b537dfd4b$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $57e52f3b537dfd4b$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $57e52f3b537dfd4b$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $57e52f3b537dfd4b$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $57e52f3b537dfd4b$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $57e52f3b537dfd4b$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $57e52f3b537dfd4b$var$isTrimmed
        });
    }
    lowercase(message = $57e52f3b537dfd4b$var$string.lowercase) {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $57e52f3b537dfd4b$var$string.uppercase) {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $57e52f3b537dfd4b$var$objStringTag) return value;
                return strValue;
            });
        });
    }
}
$57e52f3b537dfd4b$export$22b082955e083ec3.prototype = $57e52f3b537dfd4b$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $57e52f3b537dfd4b$var$isNaN$1 = (value)=>value != +value;
function $57e52f3b537dfd4b$export$98e628dec113755e() {
    return new $57e52f3b537dfd4b$export$f192ec5e9228ab19();
}
class $57e52f3b537dfd4b$export$f192ec5e9228ab19 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    min(min, message = $57e52f3b537dfd4b$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $57e52f3b537dfd4b$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $57e52f3b537dfd4b$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $57e52f3b537dfd4b$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $57e52f3b537dfd4b$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $57e52f3b537dfd4b$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? Math[method](value) : value);
    }
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$57e52f3b537dfd4b$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
}
$57e52f3b537dfd4b$export$98e628dec113755e.prototype = $57e52f3b537dfd4b$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $57e52f3b537dfd4b$var$invalidDate = new Date("");
let $57e52f3b537dfd4b$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $57e52f3b537dfd4b$export$324d90190a8b822a() {
    return new $57e52f3b537dfd4b$export$18ec3cc5a157503f();
}
class $57e52f3b537dfd4b$export$18ec3cc5a157503f extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    prepareParam(ref, name) {
        let param;
        if (!$57e52f3b537dfd4b$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $57e52f3b537dfd4b$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
    constructor(){
        super({
            type: "date",
            check (v) {
                return $57e52f3b537dfd4b$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $57e52f3b537dfd4b$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $57e52f3b537dfd4b$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
}
$57e52f3b537dfd4b$export$18ec3cc5a157503f.INVALID_DATE = $57e52f3b537dfd4b$var$invalidDate;
$57e52f3b537dfd4b$export$324d90190a8b822a.prototype = $57e52f3b537dfd4b$export$18ec3cc5a157503f.prototype;
$57e52f3b537dfd4b$export$324d90190a8b822a.INVALID_DATE = $57e52f3b537dfd4b$var$invalidDate;
// @ts-expect-error
function $57e52f3b537dfd4b$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $62f86c6ad1e80146$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($57e52f3b537dfd4b$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($57e52f3b537dfd4b$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($8818e0f94c57edd0$exports))).array(Array.from(nodes), edges).reverse();
}
function $57e52f3b537dfd4b$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $57e52f3b537dfd4b$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $57e52f3b537dfd4b$var$findIndex(keys, a) - $57e52f3b537dfd4b$var$findIndex(keys, b);
    };
}
const $57e52f3b537dfd4b$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $57e52f3b537dfd4b$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $57e52f3b537dfd4b$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $57e52f3b537dfd4b$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($57e52f3b537dfd4b$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $57e52f3b537dfd4b$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $62f86c6ad1e80146$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $62f86c6ad1e80146$exports.getter)((0, $62f86c6ad1e80146$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $57e52f3b537dfd4b$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $57e52f3b537dfd4b$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $57e52f3b537dfd4b$var$defaultSort = $57e52f3b537dfd4b$var$sortByKeyOrder([]);
function $57e52f3b537dfd4b$export$be5493f9613cbbe(spec) {
    return new $57e52f3b537dfd4b$export$18b4fc70ec7eccf8(spec);
}
class $57e52f3b537dfd4b$export$18b4fc70ec7eccf8 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $57e52f3b537dfd4b$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$57e52f3b537dfd4b$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $57e52f3b537dfd4b$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $57e52f3b537dfd4b$var$sortFields(shape, excludedEdges);
        next._sortErrors = $57e52f3b537dfd4b$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $57e52f3b537dfd4b$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $62f86c6ad1e80146$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($57e52f3b537dfd4b$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($57e52f3b537dfd4b$var$parseJson);
    }
    noUnknown(noAllow = true, message = $57e52f3b537dfd4b$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $57e52f3b537dfd4b$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $57e52f3b537dfd4b$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $4bca57257e8cec66$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $4bca57257e8cec66$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $4bca57257e8cec66$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $57e52f3b537dfd4b$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $57e52f3b537dfd4b$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
}
$57e52f3b537dfd4b$export$be5493f9613cbbe.prototype = $57e52f3b537dfd4b$export$18b4fc70ec7eccf8.prototype;
function $57e52f3b537dfd4b$export$2f23118c22fb2630(type) {
    return new $57e52f3b537dfd4b$export$4347112b8447a7d(type);
}
class $57e52f3b537dfd4b$export$4347112b8447a7d extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($57e52f3b537dfd4b$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $57e52f3b537dfd4b$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $57e52f3b537dfd4b$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $57e52f3b537dfd4b$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $57e52f3b537dfd4b$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
}
$57e52f3b537dfd4b$export$2f23118c22fb2630.prototype = $57e52f3b537dfd4b$export$4347112b8447a7d.prototype;
// @ts-ignore
function $57e52f3b537dfd4b$export$65e3907585753458(schemas) {
    return new $57e52f3b537dfd4b$export$411c3b3687e8ecc8(schemas);
}
class $57e52f3b537dfd4b$export$411c3b3687e8ecc8 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($57e52f3b537dfd4b$var$tuple.notType);
        });
    }
}
$57e52f3b537dfd4b$export$65e3907585753458.prototype = $57e52f3b537dfd4b$export$411c3b3687e8ecc8.prototype;
function $57e52f3b537dfd4b$export$488013bae63b21da(builder) {
    return new $57e52f3b537dfd4b$var$Lazy(builder);
}
class $57e52f3b537dfd4b$var$Lazy {
    clone(spec) {
        const next = new $57e52f3b537dfd4b$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
}
function $57e52f3b537dfd4b$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $57e52f3b537dfd4b$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $57e52f3b537dfd4b$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}



const $5fdb49b92958a021$export$a01df35ce0858603 = [
    "EUR",
    "USD",
    "CHF",
    "GBP",
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BOV",
    "BRL",
    "BSD",
    "BTN",
    "BWP",
    "BYR",
    "BZD",
    "CAD",
    "CDF",
    "CHE",
    "CHW",
    "CLF",
    "CLP",
    "CNY",
    "COP",
    "COU",
    "CRC",
    "CUC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EGP",
    "ERN",
    "ETB",
    "FJD",
    "FKP",
    "GEL",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KGS",
    "KHR",
    "KMF",
    "KPW",
    "KRW",
    "KWD",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LTL",
    "LVL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRO",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MXV",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SDG",
    "SEK",
    "SGD",
    "SHP",
    "SLL",
    "SOS",
    "SRD",
    "SSP",
    "STD",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USN",
    "USS",
    "UYI",
    "UYU",
    "UZS",
    "VEF",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XAG",
    "XAU",
    "XBA",
    "XBB",
    "XBC",
    "XBD",
    "XCD",
    "XDR",
    "XOF",
    "XPD",
    "XPF",
    "XPT",
    "XTS",
    "XXX",
    "YER",
    "ZAR",
    "ZMW"
];
function $5fdb49b92958a021$export$2e2bcd8739ae039(code) {
    return $5fdb49b92958a021$export$a01df35ce0858603.indexOf(code) > 0;
}


const $5cbacbe8fcf00d67$var$countryNames = [
    "Germany",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Central African Rep",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Democratic Rep. of Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea North",
    "Korea South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "St Kitts & Nevis",
    "St Lucia",
    "Saint Vincent & the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];
const $5cbacbe8fcf00d67$export$7bc41e2d36612b98 = [
    "DE",
    "AF",
    "AL",
    "DZ",
    "AD",
    "AO",
    "AG",
    "AR",
    "AM",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BT",
    "BO",
    "BA",
    "BW",
    "BR",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "CF",
    "TD",
    "CL",
    "CN",
    "CO",
    "KM",
    "CG",
    "CD",
    "CR",
    "HR",
    "CU",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "TL",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FJ",
    "FI",
    "FR",
    "GA",
    "GM",
    "GE",
    "GH",
    "GR",
    "GD",
    "GT",
    "GN",
    "GW",
    "GY",
    "HT",
    "HN",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IL",
    "IT",
    "CI",
    "JM",
    "JP",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "XK",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MR",
    "MU",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NO",
    "OM",
    "PK",
    "PW",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PL",
    "PT",
    "QA",
    "RO",
    "RU",
    "RW",
    "KN",
    "LC",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TG",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UY",
    "UZ",
    "VU",
    "VA",
    "VE",
    "VN",
    "YE",
    "ZM",
    "ZW"
];
var $5cbacbe8fcf00d67$export$2e2bcd8739ae039 = $5cbacbe8fcf00d67$var$countryNames;



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
var $f31b2d9172e2fa32$exports = {};
!function(e, t) {
    $f31b2d9172e2fa32$exports = t();
}($f31b2d9172e2fa32$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($f31b2d9172e2fa32$exports);
// this takes a string like 3,435.23 or 2.345,23 and returns a number
// this does not handle currency symbols, only the number
function $b2cd650999f080c6$export$d24e261a538d5845(value) {
    if (value === null || value === undefined || false) return null;
    // Ensure it's a string for processing
    const stringValue = String(value);
    // Count occurrences of `.` and `,`
    const dotCount = (stringValue.match(/\./g) || []).length;
    const commaCount = (stringValue.match(/,/g) || []).length;
    // Case 1: Only one separator and it's a dot
    if (dotCount === 1 && commaCount === 0) return Number(stringValue);
    // Case 2: Only one separator and it's a comma
    if (commaCount === 1 && dotCount === 0) return Number(stringValue.replace(",", "."));
    // Case 3: More than one separator
    if (dotCount > 0 || commaCount > 0) {
        const lastDotIndex = stringValue.lastIndexOf(".");
        const lastCommaIndex = stringValue.lastIndexOf(",");
        // Determine which is the last separator
        if (lastDotIndex > lastCommaIndex) // Last separator is a dot
        return Number(stringValue.replace(/,/g, ""));
        else {
            // Last separator is a comma
            const cleaned = stringValue.replace(/\./g, "").replace(/,/, ".");
            return Number(cleaned);
        }
    }
    // Default case: No separators, assume it's a plain number
    return Number(stringValue);
}
// implements the above function in a callback to .transform()
const $b2cd650999f080c6$export$1b6bc6b48a53c3bf = (newValue, originalValue)=>{
    if (originalValue === null) return null;
    return Number.isNaN(Number(originalValue)) ? $b2cd650999f080c6$export$d24e261a538d5845(originalValue) : newValue;
};
const $b2cd650999f080c6$export$579b195c2b0d8b1d = (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().length(21).matches(/^[0-9a-z\-_]{21}$/i);
const $b2cd650999f080c6$export$217d69723f9a7022 = (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true) // Explicitly allow null
.length(3, "Currency code must be exactly 3 characters long").matches(/^[A-Z]{3}$/, "Currency code must be 3 uppercase letters").oneOf((0, $5fdb49b92958a021$export$a01df35ce0858603), "Invalid currency code");
const $b2cd650999f080c6$export$e795f858b6a66dc0 = (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().length(2, "Country code must be exactly 2 characters long").matches(/^[A-Z]{2}$/i).oneOf([
    ...(0, $5cbacbe8fcf00d67$export$7bc41e2d36612b98),
    null
], "Invalid country code");
const $b2cd650999f080c6$export$8cb48686570d87f5 = (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
    "idle",
    "loading",
    "noerrors",
    "errors",
    "failed",
    "awaitingMappingInput",
    null
], "Invalid value of account status");
const $b2cd650999f080c6$export$f2a060383955b833 = {
    provider: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        finapi: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
            providerAccountId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)(),
            providerInstitutionId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)(),
            providerAccessId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)()
        }),
        gocardless: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
            providerAccountId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)(),
            providerInstitutionId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)(),
            providerAccessId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)()
        })
    })
};
// common for deposits and stocks
const $b2cd650999f080c6$export$7ac72c4744d993db = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $9tqwB._)({
    growthRate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(null)
}, $b2cd650999f080c6$export$f2a060383955b833)).nullable(true).default(null);
const $b2cd650999f080c6$export$11c6e3494f01faad = (0, $57e52f3b537dfd4b$export$22b082955e083ec3)() // used by Browser App to mark transactions to be deleted ('delete'); tbc. if also put or post
.meta({
    hideFromImport: true
}).oneOf([
    "delete",
    "put",
    "post",
    null
]).nullable(true).default(null);
const $b2cd650999f080c6$export$b021190756747157 = {
    type: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
    recurring: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        activated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().default(false),
        numberOfPeriods: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(1),
        periodType: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
            id: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
            name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null)
        }),
        end: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "recurringNever",
            "recurringByOccurrence",
            "recurringByDate"
        ]).default("recurringNever"),
        endAfterOccurrences: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(10),
        endAfterDate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(null)
    }).nullable(true).default(null),
    indexed: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        activated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().default(false),
        mode: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "indexedByInflation",
            "indexedByCustomRate"
        ]).default("indexedByInflation"),
        customRateInput: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(null)
    }).nullable(true).default(null)
};
const $b2cd650999f080c6$export$7517018e47a259c = (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Date must be in epoch(ms) format").meta({
    dialogFormType: "date"
}).typeError("Date is invalid or missing").required("Date is required").transform((newValue, orig)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig).startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD.MM.YYYY", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD.MM.YYYY").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "YYYY.MM.DD", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "YYYY.MM.DD").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD-MM-YYYY", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD-MM-YYYY").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD-MM-YY", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD-MM-YY").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "YY-MM-DD", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "YY-MM-DD").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "MM/DD/YYYY", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "MM/DD/YYYY").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD/MM/YYYY", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD/MM/YYYY").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD MM YYYY", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "DD MM YYYY").startOf("day").valueOf();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "YYYY MM DD", true).isValid()) return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(orig, "YYYY MM DD").startOf("day").valueOf();
    return newValue; // if nothing works, give up (and cause an error to be thrown in GUI)
}).min(999999999999, "Date must be in epoch(ms) format");
function $b2cd650999f080c6$export$293b45052f6e93ba(requireMessage = ({ path: path })=>`Field ${path} is required`) {
    return (0, $57e52f3b537dfd4b$export$98e628dec113755e)().when("importFlag", {
        is: "delete",
        then: (schema)=>schema.optional().nullable(true),
        otherwise: (schema)=>schema.required(requireMessage)
    });
}
function $b2cd650999f080c6$export$4a51da9ac81c6e79(requireMessage = ({ path: path })=>`Field ${path} is required`) {
    return (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().when("importFlag", {
        is: "delete",
        then: (schema)=>schema.optional().nullable(true),
        otherwise: (schema)=>schema.required(requireMessage)
    });
}
const $b2cd650999f080c6$export$c7026760c9c90680 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
    effectiveDate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Effective date must be in epoch(ms) format").required("Effective date is required").max(9999999999999, "Timestamp must be in epoch(ms) format"),
    value: (0, $57e52f3b537dfd4b$export$9b30b6294c1449a8)().test("is-number-or-string", "The field must be either a number or a string", (value)=>typeof value === "number" || typeof value === "string")
});
const $b2cd650999f080c6$export$1863a70bef21f7da = {
    id: $b2cd650999f080c6$export$579b195c2b0d8b1d // new transactions must exist without an id first
    .nullable(true).default(null).meta({
        hideFromImport: true
    }),
    accountId: $b2cd650999f080c6$export$579b195c2b0d8b1d.required().meta({
        hideFromImport: true
    }),
    assetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
    date: $b2cd650999f080c6$export$7517018e47a259c,
    quantity: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Quantity must be a number") // always in account currency
    .transform($b2cd650999f080c6$export$1b6bc6b48a53c3bf).nullable(true).default(null),
    upac: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").concat($b2cd650999f080c6$export$293b45052f6e93ba()).transform($b2cd650999f080c6$export$1b6bc6b48a53c3bf).default(1),
    accountCurrency: $b2cd650999f080c6$export$217d69723f9a7022.meta({
        hideFromImport: true
    }).concat($b2cd650999f080c6$export$4a51da9ac81c6e79("Account currency code is required")).default("EUR"),
    assetCurrency: $b2cd650999f080c6$export$217d69723f9a7022.meta({
        hideFromImport: true
    }).concat($b2cd650999f080c6$export$4a51da9ac81c6e79("Asset currency code is required")).default("EUR"),
    upbc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").transform($b2cd650999f080c6$export$1b6bc6b48a53c3bf).nullable(true).default(null),
    uptc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").transform($b2cd650999f080c6$export$1b6bc6b48a53c3bf).nullable(true).default(null),
    transactionCurrency: $b2cd650999f080c6$export$217d69723f9a7022.meta({
        hideFromImport: true
    }).nullable(true).default(null),
    isSimulated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().meta({
        hideFromImport: true
    }).default(false),
    projectId: $b2cd650999f080c6$export$579b195c2b0d8b1d.meta({
        hideFromImport: true
    }).nullable(true).default(null),
    linkedTransactions: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().default([]).meta({
        hideFromImport: true
    }),
    tags: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().meta({
        hideFromImport: true
    }).shape((0, $9tqwB._)({
        assetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
        accountId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null)
    }, $b2cd650999f080c6$export$b021190756747157, $b2cd650999f080c6$export$f2a060383955b833)).nullable(true).default(null),
    importFlag: $b2cd650999f080c6$export$11c6e3494f01faad,
    sortingOrderWithinMonth: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().meta({
        hideFromImport: true
    }).nullable(true).default(null)
};


const $2119005918cddc33$export$8d5020816db32829 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 100 characters"),
    bankName: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(false) // required by backend for now
    .default("BANK").max(100, "Bank name must be shorter than 100 characters"),
    bic: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(11, "BIC must 11 characters or shorter"),
    iban: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(45, "IBAN must be shorter than 45 characters"),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required("Currency code is required").default("EUR"),
    countryCode: (0, $b2cd650999f080c6$export$e795f858b6a66dc0).required("Country code is required").default("DE"),
    depositType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "savings-account",
        "time-deposit",
        null
    ], "Invalid depositType").nullable(true).default(null).max(30, "DepositType is too long"),
    syncType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "manual",
        "automatic",
        null
    ], "Invalid syncType").nullable(true).default(null).max(20, "SyncType is too long"),
    status: (0, $b2cd650999f080c6$export$8cb48686570d87f5),
    statusTimestamp: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Status timestamp must be in epoch(ms) format").nullable(true).default(null).min(999999999999, "Timestamp must be in epoch(ms) format"),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db),
    importFileMappings: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().meta({
        hideFromImport: true
    }).nullable(true).default(null)
});
const $2119005918cddc33$export$d0605de541b472d8 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d // new transactions must exist without an id first
    ).nullable(true).default(null).meta({
        hideFromImport: true
    }),
    accountId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).required().meta({
        hideFromImport: true
    }),
    date: (0, $b2cd650999f080c6$export$7517018e47a259c),
    otherParty: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().transform((newValue, orig)=>String(orig) === "" || orig === null ? "null" : newValue).min(1).max(100, "Transaction party must be shorter than 100 characters"),
    otherPartyAccount: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)() // IBAN
    .max(50, "Transaction party account must be shorter than 50 characters").nullable(true).default(null),
    description: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(1000, "Transaction description must be shorter than 1000 characters").nullable(true).default(null),
    amount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Amount must be a number") // always in base currency, will be calculated in API based on currency and accountCurrencyAmount
    .meta({
        hideFromImport: true
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true).default(null),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)()).default("EUR"),
    accountCurrencyAmount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Account currency amount must be a number")// if we have fxCurrency and fxAmount then this is not required
    .when([
        "fxAmount",
        "fxCurrency"
    ], {
        is: (fxAmount, fxCurrency)=>!!fxCurrency && !fxAmount,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Account currency amount or foreign currency amount are required when foreign currency is specified")),
        otherwise: (schema)=>schema.optional().nullable(true).default(null)
    })// if the value cannot be parsed as a number, try to replace the first comma with a dot
    .transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)),
    fxAmount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Foreign exchange amount must be a number").meta({
        importOptional: true
    }).nullable(true).default(null)// this is required unless there is fxCurrency and accountCurrencyAmount
    .when([
        "fxCurrency",
        "accountCurrencyAmount"
    ], {
        is: (fxCurrency, accountCurrencyAmount)=>!!fxCurrency && !accountCurrencyAmount,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Foreign currency or account currency amount is required when foreign currency is specified")),
        otherwise: (schema)=>schema.optional()
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)),
    fxCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        importOptional: true
    }).nullable(true).default(null).when("fxAmount", {
        is: (fxAmount)=>!!fxAmount,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Foreign exchange currency is required when a foreign currency amount is specified")),
        otherwise: (schema)=>schema.optional()
    }),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // accountCurrencyAmountOriginal: number('Account currency amount must be a number')
    //   .meta({ hideFromImport: true })
    //   .transform(transformCurrencyCallback)
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // accountCurrencyConversionRate: number('Account currency conversion rate must be a number')
    //   .meta({ hideFromImport: true })
    //   .transform(transformCurrencyCallback)
    //   .nullable(true)
    //   .default(null),
    category: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default("income"),
    batchId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    parentId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    isSimulated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().meta({
        hideFromImport: true
    }).nullable(true).default(false),
    isManuallyAdjusted: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().meta({
        hideFromImport: true
    }).nullable(true).default(false),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // labelLevel2: string()
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // labelLevel3: string()
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // labelLevel4: string()
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // labelLevel5: string()
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // amountWithFees: number('Amount including fees must be a number')
    //   .meta({ hideFromImport: true })
    //   .transform(transformCurrencyCallback)
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // amountAfterFees: number('Amount after fees must be a number')
    //   .meta({ hideFromImport: true })
    //   .transform(transformCurrencyCallback)
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // fee: number('Fee amount must be a number')
    //   .meta({ hideFromImport: true })
    //   .transform(transformCurrencyCallback)
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // tax: number('Tax amount must be a number')
    //   .meta({ hideFromImport: true })
    //   .transform(transformCurrencyCallback)
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // rejectionReason: string()
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // valid: boolean()
    //   .nullable(true)
    //   .default(true),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // rebasedAmount: number('Rebased amount must be a number')
    //   .meta({ hideFromImport: true })
    //   .nullable(true)
    //   .default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // amountAfterFeesConverted: number('Amount after fees converted must be a number')
    //   .meta({ hideFromImport: true })
    //   .nullable(true)
    //   .default(null),
    projectId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).meta({
        hideFromImport: true
    }).nullable(true).default(null),
    providerAccountId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    providerTransactionId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    // 260225 - commenting out fields probably added by AI when refactoring - could not confirm that they are needed
    // ruleId: string()
    //   .meta({ hideFromImport: true })
    //   .nullable(true)
    //   .default(null),
    errorId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    importFlag: $b2cd650999f080c6$export$11c6e3494f01faad,
    label: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    tags: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().meta({
        hideFromImport: true
    }).shape((0, $9tqwB._)({
        assetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
        accountId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null)
    }, (0, $b2cd650999f080c6$export$b021190756747157), (0, $b2cd650999f080c6$export$f2a060383955b833))).nullable(true).default(null),
    sortingOrderWithinMonth: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().meta({
        hideFromImport: true
    }).nullable(true).default(null)
}, [
    [
        "fxAmount",
        "fxCurrency"
    ],
    [
        "accountCurrencyAmount",
        "fxAmount"
    ],
    [
        "accountCurrencyAmount",
        "fxCurrency"
    ]
]);
const $2119005918cddc33$export$3c400324181e2c4d = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($2119005918cddc33$export$d0605de541b472d8);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

const $258697da394e7920$export$fb087d627d520236 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    // does not have a currency!
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    brokerName: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(100, "Broker name must be shorter than 100 characters"),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 50 characters"),
    username: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(50, "Username must be shorter than 50 characters"),
    accountNo: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(50, "Account number must be shorter than 50 characters"),
    credential: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(50, "Account number must be shorter than 50 characters"),
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(false).default([]),
    ownCurrentAccount: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(45, "Cash account IBAN must be shorter than 45 characters"),
    countryCode: (0, $b2cd650999f080c6$export$e795f858b6a66dc0).required("Country code is required").default("DE"),
    syncType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).max(20, "SyncType is too long"),
    subcategory: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null).oneOf([
        "stocks",
        "crypto",
        null
    ]),
    status: (0, $b2cd650999f080c6$export$8cb48686570d87f5),
    statusTimestamp: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Status timestamp must be in epoch(ms) format").nullable(true).default(null).min(999999999999, "Timestamp must be in epoch(ms) format"),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db),
    importFileMappings: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().meta({
        hideFromImport: true
    }).nullable(true).default(null)
});
const $258697da394e7920$export$4f051dd78ba8e887 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    accountId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).meta({
        hideFromImport: true
    }).required("AccountId is required"),
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).meta({
        hideFromImport: true
    }).nullable(true).default(null),
    date: (0, $b2cd650999f080c6$export$7517018e47a259c),
    figi: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true) // when users enter transactions, there won't be a figi
    .default(null),
    providerAssetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(255, "Provider Asset ID cannot be longer than 100 characters") // database file restriction; long names are used by crypto assets in mobula api
    .meta({
        hideFromImport: true
    }).nullable(true) // when users enter transactions, there won't be a providerAssetId
    .default(null),
    displaySymbol: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Symbol (ISIN/WKN...) of the security is required")),
    displayName: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
    transactionType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Transaction type is required")).oneOf([
        "purchase",
        "sale",
        "split",
        "transfer"
    ], "Invalid transaction type"),
    splitRatioOld: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().meta({
        hideFromImport: true
    }).when("transactionType", {
        is: "split",
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Split ratio (old) is required for split transactions")),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    splitRatioNew: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().meta({
        hideFromImport: true
    }).when("transactionType", {
        is: "split",
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Split ratio (old) is required for split transactions")),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    transactionAmount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Transaction amount must be a number") // original transaction amount (never changes)
    .nullable(true).when("transactionType", {
        is: (transactionType)=>transactionType === "purchase" || transactionType === "sale",
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Transaction amount is required for purchase and sale transactions")),
        otherwise: (schema)=>schema.optional().nullable(true)
    }).when("transactionType", {
        is: (transactionType)=>transactionType === "sale",
        then: (schema)=>schema.max(0, "Transaction amount must be negative for sale transactions"),
        otherwise: (schema)=>schema.nullable(true)
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)),
    transactionPrice: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Transaction price must be a number") // original price per piece in base currency at the quote of that day
    .meta({
        hideFromImport: true
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true).default(null),
    transactionCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).when("transactionType", {
        is: (transactionType)=>transactionType === "purchase" || transactionType === "sale",
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Transaction currency is required for purchase and sale transactions")),
        otherwise: (schema)=>schema.optional().nullable(true)
    }).default("EUR"),
    transactionOriginalPrice: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Transaction FX price must be a number") // original price per piece in foreign currency; equal to transactionPrice if transaction took place in base currency
    .when([
        "transactionType",
        "transactionPrice"
    ], {
        is: (transactionType, transactionPrice)=>(transactionType === "purchase" || transactionType === "sale") && (!transactionPrice || transactionPrice.length === 0),
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Transaction original price (fx) or base currency are required for purchase and sale transactions")),
        otherwise: (schema)=>schema.optional().nullable(true)
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)),
    rebasedAmount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Rebased amount must be a number") // if stock has split, this is the adjusted amount reflecting all the subsequent splits; it can change if more splits come
    .meta({
        hideFromImport: true
    }).nullable(true).default(null).when("transactionType", {
        is: (transactionType)=>transactionType === "sale",
        then: (schema)=>schema.max(0, "Transaction amount must be negative for sale transactions"),
        otherwise: (schema)=>schema.nullable(true)
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)),
    rebasedPrice: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Rebased price must be a number") // if stock has split, this is the adjusted price in user base currency reflecting all the subsequent splits; it can change if more splits come
    .meta({
        hideFromImport: true
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true).default(null),
    rebasedOriginalPrice: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Rebased original price must be a number") // adjusted price per piece in foreign currency; equal to transactionPrice if transaction took place in base currency
    .meta({
        hideFromImport: true
    }).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true).default(null),
    linkedTransactions: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().meta({
        hideFromImport: true
    }).nullable(true).default([]),
    isSimulated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().meta({
        hideFromImport: true
    }).default(false),
    isIsolated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().meta({
        hideFromImport: true
    }).default(false),
    isManuallyAdjusted: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().meta({
        hideFromImport: true
    }).default(false),
    errorId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    transactionAmountSold: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Rebased amount sold must be a number").meta({
        hideFromImport: true
    }).nullable(true).default(null),
    rebasedAmountSold: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Rebased amount sold must be a number").meta({
        hideFromImport: true
    }).nullable(true).default(null),
    rebasedAmountSoldWhenSimulated: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Rebased amount when simulated sold must be a number").meta({
        hideFromImport: true
    }).nullable(true).default(null),
    projectId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).meta({
        hideFromImport: true
    }).nullable(true).default(null),
    tags: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$b021190756747157), (0, $b2cd650999f080c6$export$f2a060383955b833))).meta({
        hideFromImport: true
    }).nullable(true).default(null),
    importFlag: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "delete",
        "put",
        "post"
    ]).nullable(true).default(null),
    sortingOrderWithinMonth: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().meta({
        hideFromImport: true
    }).nullable(true).default(null)
}, [
    "transactionPrice",
    "transactionOriginalPrice"
]);
const $258697da394e7920$export$9890c99050a7d78e = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($258697da394e7920$export$4f051dd78ba8e887);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

const $3a1ecd75ab1ea382$export$934eb6c45067415d = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(100, "Account name may be up to 100 characters long").required(),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required(),
    status: (0, $b2cd650999f080c6$export$8cb48686570d87f5).nullable(null).default(null),
    statusTimestamp: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Status timestamp must be in epoch(ms) format").nullable(true).default(null).min(999999999999, "Timestamp must be in epoch(ms) format"),
    lastMarketPriceRetrieved: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(-2, "Market price cannot be negative").max(100000000, "Property value cannot exceed 100 000 000 EUR").nullable(null).default(null),
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(false).default([]),
    tags: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        growthRate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(null),
        nextValuationDate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("nextValuationDate must be in epoch(ms) format").nullable(true).default(undefined).min(999999999999, "nextValuationDate must be in epoch(ms) format")
    }).nullable(true).default(null),
    valuationParameters: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        type: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "apartment",
            "building",
            null
        ]).required().default("apartment"),
        subtype: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().when("type", {
            is: (type)=>type === "building",
            then: (schema)=>schema.oneOf([
                    "farm",
                    "special-building",
                    "bungalow",
                    "castle",
                    "semi-detached",
                    "detached",
                    "apartment-building",
                    "terraced",
                    "terraced-corner",
                    "villa",
                    "other",
                    null
                ]).nullable(true).default(null),
            otherwise: (schema)=>schema.oneOf([
                    "top-floor",
                    "ground-floor",
                    "other-floor",
                    "high-ground-floor",
                    "loft",
                    "two-levels",
                    "penthouse",
                    "other",
                    "souterrain",
                    "with-balcony",
                    "other",
                    null
                ]).nullable(true).default(null)
        }),
        streetAddress: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(100, "Street name w\xedth number may be up to 100 characters long").nullable(true).default(null),
        zip: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(10, "Postal code cannot be longer than 10 characters").required(),
        district: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(100, "District / Town name cannot be longer than 100 characters").nullable(true).default(null),
        city: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(100, "Stadtkreis / Landkreis name cannot be longer than 100 characters").required(),
        countryCode: (0, $b2cd650999f080c6$export$e795f858b6a66dc0).nullable(true).default("DE"),
        interiorLevel: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "simple",
            "normal",
            "high",
            "luxus",
            null
        ]).nullable(true).default(null),
        condition: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "new",
            "newly-renovated",
            "well-maintained",
            "modernized",
            "flexible",
            "like-new",
            "needs-renovation",
            "refurbished",
            "completely-renovated",
            "needs-repair",
            null
        ]),
        completeArea: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(0, "Floor area cannot be negative").max(10000, "Complete floor area cannot be larger than 10 000 sq. m.").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null),
        livingArea: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(0, "Floor area cannot be negative").max(10000, "Living floor area cannot be larger than 10 000 sq. m.").transform((value)=>Number.isNaN(value) ? null : value).required(),
        rooms: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().max(1000, "Room number cannot be larger than 1000").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null),
        lotArea: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(0, "Lot area cannot be negative").max(10000, "Lot area cannot be larger than 10000").transform((value)=>Number.isNaN(value) ? null : value) // handles ""
        .nullable(true).default(null),
        floor: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().max(1000, "Floor number cannot be larger than 1000").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null),
        totalFloors: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().max(1000, "Total floor number cannot be larger than 1000").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null),
        constructionYear: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(-2500, "Construction year cannot be lower than 2500 BC").max(2100, "Construction year cannot be higher than 2100").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null),
        lastRenovationYear: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(1800, "last renovation year cannot be lower than 1800 AD").max(2100, "Construction year cannot be higher than 2100").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null).when([
            "constructionYear"
        ], {
            is: (constructionYear)=>constructionYear !== null,
            then: (schema)=>schema.moreThan((0, $57e52f3b537dfd4b$export$eff4d24c3ff7876e)("constructionYear"), "If provided, last renovation year must be greater than construction year")
        }),
        energyClass: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((value)=>Number.isNaN(value) ? null : value) // handles ""
        .nullable(true).default(null),
        floorHeating: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
        garden: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
        heatingType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "gas",
            "oil",
            "electricity",
            "district",
            "wood",
            "coal",
            "solar",
            "block",
            "stock",
            "floor",
            "nachtspeicher",
            "w\xe4rmekraft",
            "central",
            null
        ]).nullable(true).default(null),
        bathTub: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
        bathWithWindows: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
        flooring: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "carpet",
            "parquet",
            "tiles",
            "laminate",
            "floorboards",
            null
        ]).nullable(true).default(null),
        fullHeightWindows: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
        privateParkingSpaces: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().max(9, "Private parking spaces are limited to 9").transform((value)=>Number.isNaN(value) ? null : value).nullable(true).default(null)
    }).nullable(false).default({})
});
const $3a1ecd75ab1ea382$export$6ee7acc2fdcedc63 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    accountId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).required(),
    date: (0, $b2cd650999f080c6$export$7517018e47a259c),
    amount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)()).oneOf([
        -1,
        1
    ]),
    price: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).min(0, "Price cannot be negative").max(100000000, "Price cannot exceed 100 000 000 EUR") // sanity check
    .when("originalPrice", {
        is: (originalPrice)=>!originalPrice || originalPrice.length === 0,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Either base currency price or original currency price is required.")),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)()),
    originalPrice: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).min(0, "Price cannot be negative").when("price", {
        is: (price)=>!price || price.length === 0,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Either base currency price or original currency price is required.")),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    transactionType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Transaction type is required")).oneOf([
        "purchase",
        "sale"
    ], "Invalid transaction type"),
    valid: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(true),
    linkedTransactions: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().default([]),
    isSimulated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(false),
    isIsolated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(false),
    projectId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    importFlag: $b2cd650999f080c6$export$11c6e3494f01faad,
    sortingOrderWithinMonth: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().nullable(true).default(null),
    tags: (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$b021190756747157)))
}, [
    "price",
    "originalPrice"
]);
const $3a1ecd75ab1ea382$export$5948b786dea4615d = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($3a1ecd75ab1ea382$export$6ee7acc2fdcedc63);
const $3a1ecd75ab1ea382$export$212aaea17dcd2325 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    accountId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).required(),
    errorId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
    date: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Date must be in epoch(ms) format").typeError("Date is invalid or missing").min(999999999999, "Timestamp must be in epoch(ms) format").concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)()),
    price: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true).min(0, "Valuation price cannot be negative").max(100000000, "Valuation price cannot exceed 100 000 000 EUR") // sanity check
    .when("originalPrice", {
        is: (originalPrice)=>!originalPrice || originalPrice.length === 0,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Either base currency price or original currency price is required.")).nullable(true)
    }),
    originalPrice: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true).min(0, "Valuation price cannot be negative").when("price", {
        is: (price)=>!price || price.length === 0,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Either base currency price or original currency price is required.")).nullable(true)
    }),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)()),
    source: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "own",
        "provider"
    ]).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)()),
    valid: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().required("Field valid is required").default(true),
    isSimulated: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(false),
    projectId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    importFlag: $b2cd650999f080c6$export$11c6e3494f01faad
}, [
    "price",
    "originalPrice"
]);
const $3a1ecd75ab1ea382$export$5661ad822f8afb1d = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($3a1ecd75ab1ea382$export$212aaea17dcd2325);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
const $fd6541cb8870bfa3$export$ee7a15c61bfdeb11 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
    date: (0, $b2cd650999f080c6$export$7517018e47a259c),
    assetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true) // when users enter transactions, there won't be a figi
    .default(null),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Currency code is required")).default("EUR"),
    source: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Transaction source is required")).oneOf([
        "api",
        "manual"
    ], "Invalid source type"),
    quote: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Quote must be a number") // original transaction amount (never changes)
    .transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).when("quoteBaseCurrency", {
        is: (qbc)=>!qbc && qbc !== 0 || qbc.length === 0,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Either transaction currency or base currency quote is required")).min(0),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    quoteBaseCurrency: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("QuoteBaseCurrency must be a number") // original transaction amount (never changes)
    .transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).when("quote", {
        is: (q)=>!q && q !== 0 || q.length === 0,
        then: (schema)=>schema.concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("Either transaction currency or base currency quote is required")).min(0),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    // specialQuotes can generally be empty, but if they have a record, then that record must be complete
    specialQuotes: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        type: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Special quote type is required"),
        quote: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Quote must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).required("Quote is required"),
        quoteBaseCurrency: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Quote base currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf))
    })).nullable(true).default([]),
    // optional, to store valuation details
    note: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().nullable(true).default(null),
    importFlag: $b2cd650999f080c6$export$11c6e3494f01faad
}, [
    "quote",
    "quoteBaseCurrency"
]);
const $fd6541cb8870bfa3$export$afe84a81194592dd = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($fd6541cb8870bfa3$export$ee7a15c61bfdeb11);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $5c401a4958c7a09c$export$d51f38adac1092a7 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 50 characters"),
    type: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "annuity",
        "fixedPrincipal",
        "interestOnly"
    ], "Invalid loan type").required("Loan type is required").default("annuity"),
    direction: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "granted",
        "received"
    ], "Invalid loan direction").required("Loan granted / received field is required").default("received"),
    loanAmount: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).required("Loan amount is required"),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required("Currency code is required").default("EUR"),
    interestRate: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$c7026760c9c90680)).min(1, "Interest rate must have at least one value"),
    period: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        effectiveDate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Effective date must be in epoch(ms) format").required("Effective date is required").max(9999999999999, "Timestamp must be in epoch(ms) format"),
        value: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "annual",
            "quarter",
            "month"
        ], "Invalid period value").required("Period value is required")
    })).min(1, "Period must have at least one value"),
    percentRepaidAnnually: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$c7026760c9c90680)).min(1, "Percent repaid annually must have at least one value"),
    contractEndDate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Contract end date must be in epoch(ms) format").meta({
        dialogFormType: "date"
    }).nullable(true).default(null).max(9999999999999, "Timestamp must be in epoch(ms) format"),
    schedulingExceptions: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        date: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Date must be in epoch(ms) format").required("Date is required").max(9999999999999, "Timestamp must be in epoch(ms) format"),
        type: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
            "disabled"
        ], "Invalid scheduling exception type").required("Scheduling exception type is required")
    })).nullable(false).default([]),
    interestCalcMonthEnd: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().default(true),
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(true).default([]),
    connectedProjectId: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    syncType: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "automatic",
        "manual"
    ]).required().default("manual"),
    iban: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(50, "IBAN must be shorter than 50 characters").nullable(true).default(null),
    bankName: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(100, "Bank name must be shorter than 100 characters").nullable(true).default(null),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db)
});
const $5c401a4958c7a09c$export$95eff6423824c31b = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $2qxEV._)((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$1863a70bef21f7da)), {
    assetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().meta({
        hideFromImport: true
    }).nullable(true).default(null),
    otherPartyIban: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)() // IBAN
    .max(50, "Transaction party account must be shorter than 50 characters").nullable(true).default(null),
    description: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(1000, "Transaction description must be shorter than 1000 characters").nullable(true).default(null),
    quantity: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Principal amount must be a number") // loan principal; required for loans (as loans are following the unit price quantity model)
    .transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)()).default(0),
    quantityInterest: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Interest amount must be a number") // always in account currency; interest amount
    .transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)()).default(0),
    upac: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").meta({
        hideFromImport: true
    }).required().default(1),
    upbc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").meta({
        hideFromImport: true
    }).nullable(true).default(null),
    uptc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").meta({
        hideFromImport: true
    }).nullable(true).default(null)
}));
const $5c401a4958c7a09c$export$a856f17095d848d7 = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($5c401a4958c7a09c$export$95eff6423824c31b);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $5ee4f29aaf60da17$export$c65bfcd13f0761e8 = [
    "payoutOnlyContributionsToDate",
    "payoutOnlyContributionsToDateIndexed",
    "payoutAllPlannedContributions",
    "payoutAllPlannedContributionsIndexed",
    "payoutLumpSumVerrentet"
];
const $5ee4f29aaf60da17$export$9a3a5a32f1f8e1fc = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 100 characters"),
    productPurchaseDate: (0, $b2cd650999f080c6$export$7517018e47a259c).required("Product purchase date is required"),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required("Currency code is required").default("EUR"),
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(true).default([]),
    contributionsSelfPaid: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(false),
    contributionsAmounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$c7026760c9c90680)).min(1, "Contributions must have at least one value"),
    contributionsFrequency: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(0).oneOf([
        null,
        0,
        1,
        3,
        12
    ]).nullable(true).default(null),
    contributionsDeductible: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
    contributionsIndexed: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(false),
    payoutsPhaseStart: (0, $b2cd650999f080c6$export$7517018e47a259c).nullable(true).default(null),
    payoutsFrequency: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(0).oneOf([
        null,
        0,
        1,
        3,
        12
    ]).nullable(true).default(null),
    payoutsDuration: (0, $57e52f3b537dfd4b$export$98e628dec113755e)() // Payout duration in months; 0 means indefinite
    .min(0, "Payout duration must be at least 0.").nullable(true).default(null).test("is-divisible", "Payout duration must be divisible by payout frequency with no remainder.", function(value) {
        const { payoutsFrequency: payoutsFrequency } = this.parent;
        // Ensure payoutsFrequency is not 0 to avoid division by zero
        // Also check that the value is not null and payoutsFrequency is a valid number
        if (value === 0) return true; // if payoutsDuration is 0 (indefnite), then we don't care
        return payoutsFrequency === 0 || value === null || payoutsFrequency > 0 && value % payoutsFrequency === 0;
    }),
    payoutsTaxable: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
    payoutsIndexed: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(null),
    discountRateIsInflation: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().nullable(true).default(false),
    customDiscountRate: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().when("discountRateIsInflation", {
        is: false,
        then: (schema)=>schema.nullable(false).default(0).required("Custom index rate is required when not indexing by inflation"),
        otherwise: (schema)=>schema.nullable(true).default(null)
    }),
    useSpecialQuote: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf($5ee4f29aaf60da17$export$c65bfcd13f0761e8).default("payoutAllPlannedContributionsIndexed"),
    initialQuotes: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape({
        type: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf($5ee4f29aaf60da17$export$c65bfcd13f0761e8).required("Special quote type is required in pensionAccount.initialQuotes"),
        quote: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((_, val)=>val ? Number(val) : null) // Convert invalid numbers to null
        .required("Quote must be a number"),
        quoteBaseCurrency: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().transform((_, val)=>val ? Number(val) : null) // Convert invalid numbers to null
        .required("Quote base currency must be a number")
    })).nullable(true).default([]),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db)
});
const $5ee4f29aaf60da17$export$45ff471291978734 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $2qxEV._)((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$1863a70bef21f7da)), {
    description: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(1000, "Transaction description must be shorter than 1000 characters").nullable(true).default(null),
    label: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "pension-contribution",
        "pension-payout",
        "pension-purchase"
    ], "Invalid pension transaction label").required("Transaction label is required"),
    isNotKpiRelevant: (0, $57e52f3b537dfd4b$export$87b259aa03e3d267)().default(false)
}));
const $5ee4f29aaf60da17$export$e59b728dc06f12a7 = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($5ee4f29aaf60da17$export$45ff471291978734);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $81cfed1660055fbf$export$91b8cf0e1077487a = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 100 characters"),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required("Currency code is required").default("EUR"),
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(true).default([]),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db)
});
const $81cfed1660055fbf$export$4c255d423d7ada4d = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $2qxEV._)((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$1863a70bef21f7da)), {
    description: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(1000, "Transaction description must be shorter than 1000 characters").nullable(true).default(null),
    quantity: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Quantity must be a number").nullable(true).transform((newValue, originalValue)=>{
        if (originalValue === null) return null;
        return Number.isNaN(Number(originalValue)) ? Number(originalValue.replace(/,/, ".")) : newValue;
    }).concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)()).default(1),
    upac: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true),
    accountCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Account currency code is required")).default("EUR"),
    assetCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Asset currency code is required")).default("EUR"),
    upbc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true),
    uptc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true),
    transactionCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).nullable(true).default(null)
})).transform((originalValue, originalObject)=>{
    const { upac: upac, upbc: upbc, uptc: uptc } = originalObject;
    if ((upac === null || isNaN(upac)) && (upbc === null || isNaN(upbc)) && (uptc === null || isNaN(uptc))) throw new (0, $57e52f3b537dfd4b$export$2191b9da168c6cf0)(`At least one of the prices must be a valid number`, originalValue);
    return originalValue;
});
// Comment to the .transform above:
// - this isn't ideal, but when using .when on upac, upbc and uptc, they seem to be build from top, so upac always receives undefined, undefined, which forces it to be required and not nullable, which throws an error
const $81cfed1660055fbf$export$2802f167dacb0091 = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($81cfed1660055fbf$export$4c255d423d7ada4d);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $e6c81a32d5e10529$export$1e03f85ace70b8c3 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 100 characters"),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required("Currency code is required").default("EUR"),
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(true).default([]),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db)
});
const $e6c81a32d5e10529$export$b261d2cf836a96cd = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $2qxEV._)((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$1863a70bef21f7da)), {
    assetId: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(100, "assetId must be shorter than 100 characters").required("assetId is required"),
    assetName: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().max(120, "assetName must be shorter than 120 characters").concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("assetName is required")),
    assetMetal: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().oneOf([
        "gold",
        "silver",
        "platinum",
        "palladium",
        "other"
    ]).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("assetMetal is required")).default("gold"),
    assetPurity: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(1).max(999).concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("assetPurity is required")).default(999),
    assetWeight: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(1).max(100000).concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)("assetWeight is required")).default(1),
    assetAdditionalValue: (0, $57e52f3b537dfd4b$export$98e628dec113755e)().min(0).max(1000000).nullable(true).default(null),
    quantity: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Quantity must be a number") // of asset
    .nullable(true).transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).concat((0, $b2cd650999f080c6$export$293b45052f6e93ba)()).default(1),
    upac: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true),
    accountCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Account currency code is required")).default("EUR"),
    assetCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).concat((0, $b2cd650999f080c6$export$4a51da9ac81c6e79)("Asset currency code is required")).default("EUR"),
    upbc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price base currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true),
    uptc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price transaction currency must be a number").transform((0, $b2cd650999f080c6$export$1b6bc6b48a53c3bf)).nullable(true),
    transactionCurrency: (0, $b2cd650999f080c6$export$217d69723f9a7022).meta({
        hideFromImport: true
    }).nullable(true).default(null)
})).transform((originalValue, originalObject)=>{
    const { upac: upac, upbc: upbc, uptc: uptc } = originalObject;
    if ((upac === null || isNaN(upac)) && (upbc === null || isNaN(upbc)) && (uptc === null || isNaN(uptc))) throw new (0, $57e52f3b537dfd4b$export$2191b9da168c6cf0)(`At least one of the prices must be a valid number`, originalValue);
    return originalValue;
});
// Comment to the .transform above:
// - this isn't ideal, but when using .when on upac, upbc and uptc, they seem to be build from top, so upac always receives undefined, undefined, which forces it to be required and not nullable, which throws an error
const $e6c81a32d5e10529$export$4efad9798dd0814e = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($e6c81a32d5e10529$export$b261d2cf836a96cd);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $f2b6f6a77877e6cd$export$45630267d7c975cf = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)({
    id: (0, $b2cd650999f080c6$export$579b195c2b0d8b1d).nullable(true).default(null),
    name: (0, $57e52f3b537dfd4b$export$22b082955e083ec3)().required("Account name is required").max(100, "Account name must be shorter than 100 characters"),
    currency: (0, $b2cd650999f080c6$export$217d69723f9a7022).required("Currency code is required").default("EUR"),
    // legalForm: string().oneOf(['limited', 'unlimited']).required('Legal form is required').default('limited'), // might be useful for valuations later on --> removing it for now
    connectedDepositAccounts: (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of((0, $b2cd650999f080c6$export$579b195c2b0d8b1d)).nullable(true).default([]),
    tags: (0, $b2cd650999f080c6$export$7ac72c4744d993db)
});
const $f2b6f6a77877e6cd$export$8eb3d3642b459f58 = (0, $57e52f3b537dfd4b$export$be5493f9613cbbe)().shape((0, $2qxEV._)((0, $9tqwB._)({}, (0, $b2cd650999f080c6$export$1863a70bef21f7da)), {
    upac: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price account currency must be a number").nullable(true),
    upbc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price base currency must be a number").nullable(true),
    uptc: (0, $57e52f3b537dfd4b$export$98e628dec113755e)("Unit price transaction currency must be a number").nullable(true)
})).transform((originalValue, originalObject)=>{
    const { upac: upac, upbc: upbc, uptc: uptc } = originalObject;
    if ((upac === null || isNaN(upac)) && (upbc === null || isNaN(upbc)) && (uptc === null || isNaN(uptc))) throw new (0, $57e52f3b537dfd4b$export$2191b9da168c6cf0)(`At least one of the prices must be a valid number`, originalValue);
    return originalValue;
});
// Comment to the .transform above:
// - this isn't ideal, but when using .when on upac, upbc and uptc, they seem to be build from top, so upac always receives undefined, undefined, which forces it to be required and not nullable, which throws an error
const $f2b6f6a77877e6cd$export$ef749c62f1718a7c = (0, $57e52f3b537dfd4b$export$2f23118c22fb2630)().of($f2b6f6a77877e6cd$export$8eb3d3642b459f58);


/* eslint-disable newline-per-chained-call */ /* eslint-disable react/forbid-prop-types */ 
const $1a8d54f71278e6b1$export$4acdd0865bea4cf8 = (0, $258697da394e7920$export$fb087d627d520236);
const $1a8d54f71278e6b1$export$7a517006b20774e = (0, $258697da394e7920$export$4f051dd78ba8e887);
const $1a8d54f71278e6b1$export$82f53777bf39b5c0 = (0, $258697da394e7920$export$9890c99050a7d78e);


const $56814ae52a40ecc8$var$a = 1;
var $56814ae52a40ecc8$export$2e2bcd8739ae039 = $56814ae52a40ecc8$var$a;
function $56814ae52a40ecc8$export$38fcb27197d44cf6(category, type = "transaction", getArray = false) {
    if (type === "transaction") switch(category){
        case "deposits":
            return getArray ? (0, $2119005918cddc33$export$3c400324181e2c4d) : (0, $2119005918cddc33$export$d0605de541b472d8);
        case "stocks":
            return getArray ? (0, $258697da394e7920$export$9890c99050a7d78e) : (0, $258697da394e7920$export$4f051dd78ba8e887);
        case "realEstate":
            return getArray ? (0, $3a1ecd75ab1ea382$export$5948b786dea4615d) : (0, $3a1ecd75ab1ea382$export$6ee7acc2fdcedc63);
        case "loans":
            return getArray ? (0, $5c401a4958c7a09c$export$a856f17095d848d7) : (0, $5c401a4958c7a09c$export$95eff6423824c31b);
        case "pension":
            return getArray ? (0, $5ee4f29aaf60da17$export$e59b728dc06f12a7) : (0, $5ee4f29aaf60da17$export$45ff471291978734);
        case "objectsOfValue":
            return getArray ? (0, $81cfed1660055fbf$export$2802f167dacb0091) : (0, $81cfed1660055fbf$export$4c255d423d7ada4d);
        case "metals":
            return getArray ? (0, $e6c81a32d5e10529$export$4efad9798dd0814e) : (0, $e6c81a32d5e10529$export$b261d2cf836a96cd);
        case "unlistedShares":
            return getArray ? (0, $f2b6f6a77877e6cd$export$ef749c62f1718a7c) : (0, $f2b6f6a77877e6cd$export$8eb3d3642b459f58);
        case "crypto":
            return getArray ? (0, $1a8d54f71278e6b1$export$82f53777bf39b5c0) : (0, $1a8d54f71278e6b1$export$7a517006b20774e);
        default:
            return null;
    }
    if (type === "account") switch(category){
        case "deposits":
            return 0, $2119005918cddc33$export$8d5020816db32829;
        case "stocks":
            return 0, $258697da394e7920$export$fb087d627d520236;
        case "realEstate":
            return 0, $3a1ecd75ab1ea382$export$934eb6c45067415d;
        case "loans":
            return 0, $5c401a4958c7a09c$export$d51f38adac1092a7;
        case "pension":
            return 0, $5ee4f29aaf60da17$export$9a3a5a32f1f8e1fc;
        case "objectsOfValue":
            return 0, $81cfed1660055fbf$export$91b8cf0e1077487a;
        case "metals":
            return 0, $e6c81a32d5e10529$export$1e03f85ace70b8c3;
        case "unlistedShares":
            return 0, $f2b6f6a77877e6cd$export$45630267d7c975cf;
        case "crypto":
            return 0, $1a8d54f71278e6b1$export$4acdd0865bea4cf8;
        default:
            return null;
    }
    return null;
}







const $3b9398d0f9c152fb$export$706cdae1b5419ef8 = (message, extraMessage)=>({
        type: (0, $0840a3787500c813$export$f56c21b951c55d75),
        payload: {
            message: message,
            extraMessage: extraMessage
        }
    });
const $3b9398d0f9c152fb$export$d717700e49bea38d = (payload)=>({
        type: (0, $0840a3787500c813$export$30ea2bfc5f501552),
        payload: payload
    });
const $3b9398d0f9c152fb$export$42aaef2d72c75260 = ()=>({
        type: (0, $0840a3787500c813$export$b65e917bab1efccd)
    });
function $3b9398d0f9c152fb$export$91020d7983105237(alertId, caller, callbackOk) {
    console.info(callbackOk);
    return {
        type: (0, $0840a3787500c813$export$b3af722de1fd7d3c),
        payload: {
            alertId: alertId,
            caller: caller,
            callbackOk: callbackOk
        }
    };
}
const $3b9398d0f9c152fb$export$b1c92b86428ccd0c = (buttonPressed)=>({
        type: (0, $0840a3787500c813$export$46b95b1ea69baa95),
        payload: buttonPressed
    });
const $3b9398d0f9c152fb$export$e5a625708957e77 = ()=>({
        type: (0, $0840a3787500c813$export$97b09ce6a5c74156)
    });


/* eslint-disable no-unsafe-optional-chaining */ // globals have all global objects which do not need to import any category-specific objects
// as it creates a circular dependency
// this file has selectors which need to import different category-specific objects
// eslint-disable-next-line import/prefer-default-export

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




var $2Bwgd = parcelRequire("2Bwgd");


/* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");
const $3f04f8f675be2f21$var$debugLevel = 0;
function $3f04f8f675be2f21$export$2e2bcd8739ae039(transactions) {
    const transactionsCopy = []; // when running on server, this fails saying that cannot assign to read only property linkedTransactions
    transactions.forEach((transaction)=>{
        try {
            if (transaction.accountId !== transactions[0].accountId) throw new Error("All transactions must be for the same account");
            const newTransaction = (0, $9tqwB._)({}, transaction); // to avoid modifying the original transaction
            newTransaction.linkedTransactions = newTransaction.linkedTransactions || [];
            transactionsCopy.push((0, $9tqwB._)({}, newTransaction));
        } catch (err) {
            console.error("applyUniversalFIFO error for transaction", JSON.stringify(transaction, null, 2), "error object:", err);
        }
    });
    let balance = 0;
    // Helper function to adjust open quantities and link transactions
    // expects quantityNeeded with the "purchase" transaction sign already
    function findOpenQuantity(currentTransaction, quantityNeeded) {
        if (quantityNeeded === 0) return undefined;
        let purchaseValueBaseCurrency = 0;
        const newLinkedTransactions = [];
        const quantityNeededSign = Math.sign(quantityNeeded);
        let quantityNeededAbs = Math.abs(quantityNeeded);
        transactionsCopy.forEach((transaction)=>{
            try {
                // we expect only to see quantityOpen with the "correct" sign, as the transactions with quantityOpen with the opposite sign have already been closed out by the last HYBRID transaction
                if (transaction.quantityOpen && Math.abs(transaction.quantityOpen) > 0) {
                    // we can deduct either the entire quantity needed or the entire quantityOpen, whichever is smaller
                    const quantityToDeduct = Math.min(quantityNeededAbs, Math.abs(transaction.quantityOpen));
                    if (quantityToDeduct > 0) {
                        transaction.quantityOpen -= quantityToDeduct * quantityNeededSign;
                        transaction.quantitySold = transaction.quantity - transaction.quantityOpen;
                        quantityNeededAbs -= quantityToDeduct;
                        purchaseValueBaseCurrency += transaction.upbc * quantityToDeduct * quantityNeededSign;
                        // Link the transaction
                        newLinkedTransactions.push({
                            id: transaction.id,
                            category: transactionsCopy[0].category,
                            tags: {
                                meta: {
                                    source: "applyUniversalFIFO"
                                },
                                type: "purchase",
                                date: transaction.date,
                                quantity: quantityToDeduct * quantityNeededSign,
                                upbc: transaction.upbc
                            }
                        });
                    }
                }
            } catch (err) {
                console.error("findOpenQuantity error for transaction", JSON.stringify(transaction, null, 2), err);
            }
        });
        return {
            purchaseValueBaseCurrency: purchaseValueBaseCurrency,
            newLinkedTransactions: newLinkedTransactions
        };
    }
    transactionsCopy.sort((a, b)=>a.date - b.date).forEach((transaction)=>{
        const initialBalance = balance;
        if ($3f04f8f675be2f21$var$debugLevel > 2) console.log("initialBalance", initialBalance);
        balance += transaction.quantity;
        // Determine transaction type
        let transactionType;
        if (initialBalance * transaction.quantity >= 0) transactionType = "PURCHASE";
        else if (Math.abs(initialBalance) >= Math.abs(transaction.quantity)) transactionType = "SALE";
        else transactionType = "HYBRID";
        if ($3f04f8f675be2f21$var$debugLevel > 2) console.log("transactionType", transactionType);
        if (transactionType === "PURCHASE") {
            transaction.quantityOpen = transaction.quantity;
            transaction.quantitySold = 0;
        } else {
            // if balance is 30 and this is a sale of -10, then we need to find a purchase transaction with openQuantity of 10 (SALE case)
            // if balance is 10 and this is a sale of -20, then we need to find a purchase transaction with openQuantity of 10 (HYBRID case)
            // as HYBRID cases are by definition those where intial balance is of a different sign to the transaction quantity
            // quantityNeeded is passed with the sign that is needed for the opposite transaction (i.e. the sale transaction of -10 will pass quantityNeeded of +10)
            const quantityNeeded = transactionType === "SALE" ? -transaction.quantity : initialBalance;
            const { purchaseValueBaseCurrency: purchaseValueBaseCurrency, newLinkedTransactions: newLinkedTransactions } = findOpenQuantity(transaction, quantityNeeded);
            transaction.purchaseValueBaseCurrency = purchaseValueBaseCurrency;
            transaction.linkedTransactions = [
                ...transaction.linkedTransactions,
                ...newLinkedTransactions
            ];
            if (transactionType === "HYBRID") // this is like a PURCHASE after subtracting the part which has been used to cover the SALE part of the HYBRID transaction
            transaction.quantityOpen = initialBalance + transaction.quantity;
        }
        if ($3f04f8f675be2f21$var$debugLevel > 2) console.log(JSON.stringify(transactionsCopy, null, 2));
    });
    return transactionsCopy;
}



/* eslint-disable no-unsafe-optional-chaining */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");





var $2Bwgd = parcelRequire("2Bwgd");



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $cfd21bc923628483$var$createSelectorWithDebug = (0, $5c22629b42831e80$export$5943f4447f6ef248)((0, $58b9680bf8a527fb$export$281bff7f05488aa2), // eslint-disable-next-line arrow-body-style
(a, b)=>{
    console.log("Comparing:", a, b); // Log the values being compared
    return a === b; // Use the default equality check
});
function $cfd21bc923628483$export$13834538082beca0(state) {
    var _state_data_stocks_settings, _state_data, _state_data_stocks_settings1, _state_data1, _state_data_stocks_settings2, _state_data2;
    return {
        dividendYieldAdvancedMode: ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : (_state_data_stocks_settings = _state_data.stocks.settings) === null || _state_data_stocks_settings === void 0 ? void 0 : _state_data_stocks_settings.dividendYieldAdvancedMode) || false,
        dividendYieldRates: ((_state_data1 = state.data) === null || _state_data1 === void 0 ? void 0 : (_state_data_stocks_settings1 = _state_data1.stocks.settings) === null || _state_data_stocks_settings1 === void 0 ? void 0 : _state_data_stocks_settings1.dividendYieldRates) || [],
        dividendYield: ((_state_data2 = state.data) === null || _state_data2 === void 0 ? void 0 : (_state_data_stocks_settings2 = _state_data2.stocks.settings) === null || _state_data_stocks_settings2 === void 0 ? void 0 : _state_data_stocks_settings2.dividendYield) || 0
    };
}
const $cfd21bc923628483$export$9890c99050a7d78e = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>state.simulation, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.stocks.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.stocks.simulatedTransactions;
}, (state)=>state.projects, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (dashboardMode, simulation, transactions, simulatedTransactions, projects, inflationRate, sliderMax)=>{
    let returnObject;
    if (dashboardMode === "projects") {
        const { baseDate: baseDate } = simulation;
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        returnObject = (transactions || []).concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    } else // to handle links between simulated and non-simulated transactions, there are some linkedTransactions which are simulated transactions; those need to be removed in this mode
    returnObject = (transactions || []).map((transaction)=>{
        var _transaction_linkedTransactions;
        return (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
            linkedTransactions: (_transaction_linkedTransactions = transaction.linkedTransactions) === null || _transaction_linkedTransactions === void 0 ? void 0 : _transaction_linkedTransactions.filter((txn)=>!txn.tags.isSimulated)
        });
    });
    // calculate quantityOpen for each transaction
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnObject);
});
const $cfd21bc923628483$export$2b812e2009c0324e = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>state.simulation, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.stocks.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.stocks.simulatedTransactions;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (dashboardMode, simulation, transactions, simulatedTransactions, inflationRate, sliderMax)=>{
    let returnObject;
    if (dashboardMode === "projects") {
        const { baseDate: baseDate } = simulation;
        returnObject = (transactions || []).concat(simulatedTransactions)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    } else // to handle links between simulated and non-simulated transactions, there are some linkedTransactions which are simulated transactions; those need to be removed in this mode
    returnObject = (transactions || []).map((transaction)=>{
        var _transaction_linkedTransactions;
        return (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
            assetId: transaction.figi,
            linkedTransactions: (_transaction_linkedTransactions = transaction.linkedTransactions) === null || _transaction_linkedTransactions === void 0 ? void 0 : _transaction_linkedTransactions.filter((txn)=>!txn.tags.isSimulated)
        });
    });
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnObject);
});
// this assumes that dividends are always paid in the fxCurrency of the asset
// this returns an object (!) { projectId1: [{ projectId, position: amount, currency }], projectId2: [], null: [] }
function $cfd21bc923628483$var$getPositionPerProjectIdAssetId(accountTransactions, date, assetId) {
    const transactionsInScope = accountTransactions === null || accountTransactions === void 0 ? void 0 : accountTransactions[assetId];
    const returnObject = [];
    Object.entries(transactionsInScope).forEach(([projectId, transactions])=>{
        var _Object_values_;
        // keep only purchases and sales
        const filteredTransactions = transactions.filter((txn)=>[
                "purchase",
                "sale"
            ].includes(txn.transactionType));
        // under the assumption that all transactions related to a figi have the same currency
        const currency = (_Object_values_ = Object.values(filteredTransactions)[0]) === null || _Object_values_ === void 0 ? void 0 : _Object_values_.transactionCurrency;
        const quantity = filteredTransactions.filter((tx)=>String(tx.projectId) === projectId && tx.date <= date).reduce((prev, curr)=>prev + curr.quantity, 0);
        returnObject.push({
            projectId: projectId,
            quantity: quantity,
            currency: currency
        });
    });
    return returnObject;
}
function $cfd21bc923628483$export$1db21d9369eae1d8(stockSettings, quotes, assetId, date, dividendTransactions) {
    if (!quotes[assetId] || !quotes[assetId][date]) return {};
    const { dividendYieldAdvancedMode: dividendYieldAdvancedMode, dividendYieldRates: dividendYieldRates, dividendYield: dividendYield } = stockSettings; // see above
    const { quote: quote, quoteBaseCurrency: quoteBaseCurrency, currency: currency } = quotes[assetId][date];
    // handle advanced mode
    if (dividendYieldAdvancedMode) {
        var _dividendYieldRates_find;
        const dividendPercentage = ((_dividendYieldRates_find = dividendYieldRates.find((x)=>x.symbol.id === assetId)) === null || _dividendYieldRates_find === void 0 ? void 0 : _dividendYieldRates_find.value) / 100; // values are in %
        return {
            dividendYieldBaseCurrency: quoteBaseCurrency * dividendPercentage,
            dividendYieldQuoteCurrency: quote * dividendPercentage,
            quoteCurrency: currency
        };
    }
    // handle simple mode
    // if there was at least one dividend transaction for this asset, return the overall dividend yield
    if (dividendTransactions.map((dt)=>{
        var _dt_tags;
        return (_dt_tags = dt.tags) === null || _dt_tags === void 0 ? void 0 : _dt_tags.assetId;
    }).includes(assetId)) return {
        dividendYieldBaseCurrency: quoteBaseCurrency * (dividendYield / 100),
        dividendYieldQuoteCurrency: quote * (dividendYield / 100),
        quoteCurrency: currency
    };
    return 0;
}
function $cfd21bc923628483$var$getConnectedDepositAccount(accounts, stockAccountId) {
    var _accounts_find_connectedDepositAccounts, _accounts_find;
    const connectedDepositAccountId = (_accounts_find = accounts.find((account)=>account.id === stockAccountId)) === null || _accounts_find === void 0 ? void 0 : (_accounts_find_connectedDepositAccounts = _accounts_find.connectedDepositAccounts) === null || _accounts_find_connectedDepositAccounts === void 0 ? void 0 : _accounts_find_connectedDepositAccounts[0]; // the first connected deposit account (i.e. sequence matters)
    if (!connectedDepositAccountId) return null;
    // return the entire object
    return accounts.find((account)=>account.id === connectedDepositAccountId);
// find deposit account which has this stockAccountId in its connectedAccountIds array
}
function $cfd21bc923628483$export$43a53681be4a3813(stocks, stockSettings, dividendTransactions, accounts, quotes, baseDate, sliderEndDate, baseCurrency, projectMode = false) {
    // generate a list of years in scope, starting with now() and ending with slider date
    const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "month").startOf("month").valueOf(); // start of next month
    const years = [];
    let year = startDate;
    do {
        years.push(year);
        year = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(year).add(1, "year").valueOf();
    }while (year < (projectMode ? sliderEndDate : baseDate));
    // generate a view of stock transactions grouped by accountId and figi (only for figis with a dividend growth setting)
    const stockTransactionsGroupByView = (0, $3e6d58b7292c657b$export$3f063810d7bf01bd)(stocks, [
        "accountId",
        "assetId",
        "projectId"
    ]);
    // { accountId1: { figi1: { projectId1: [], projectId2: [], null: [] }, figi2: { projectId1: [], projectId2: [], null: [] } }, accountId2: ... }
    // for each account, for each figi, for each project, calculate the position at the end of each year
    const simulatedDividendTransactions = [];
    // FIX 230706: moved from months to years, as doing it per month significantly slows down the app (see PRD-1129)
    years.forEach((date)=>{
        Object.entries(stockTransactionsGroupByView).forEach(([accountId, accountIdObject])=>{
            Object.keys(accountIdObject).forEach((assetId)=>{
                // ↓↓ returns an array with { projectId, quantity, currency } -- currency is the currency of first asset transaction
                const transactionsToCreate = $cfd21bc923628483$var$getPositionPerProjectIdAssetId(stockTransactionsGroupByView[accountId], date, assetId);
                transactionsToCreate.forEach((position)=>{
                    try {
                        if (position.quantity === 0) return;
                        // getDividendYield returns { dividendYieldBaseCurrency, dividendYieldQuoteCurrency, quoteCurrency }
                        // the returned dividendYields in currency are PER PIECE
                        const amount = ($cfd21bc923628483$export$1db21d9369eae1d8(stockSettings, quotes, assetId, date, dividendTransactions).dividendYieldBaseCurrency || 0) * position.quantity;
                        // need to convert that to account currency / base currency
                        const depositAccount = $cfd21bc923628483$var$getConnectedDepositAccount(accounts, accountId);
                        // dividends will not be added if there is no connected deposit account
                        if (!depositAccount) return;
                        const { currency: accountCurrency, id: depositAccountId } = depositAccount;
                        const newTransaction = {
                            date: date,
                            id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                            category: "deposits",
                            otherParty: (0, $2Bwgd.t)("projects:simulated"),
                            otherPartyAccount: (0, $2Bwgd.t)("projects:simulated"),
                            isSimulated: true,
                            description: `${(0, $2Bwgd.t)("projects:dividendPayment")} ${assetId} `,
                            accountId: depositAccountId,
                            label: "investment-dividend",
                            projectId: position.projectId,
                            tags: {
                                type: "inflow",
                                recurring: {
                                    activated: false
                                },
                                dividendPayment: true,
                                nonEditable: true,
                                accountId: accountId,
                                assetId: assetId
                            }
                        };
                        if (amount > 0) simulatedDividendTransactions.push(newTransaction);
                        // handle FX differences - we need to post a transaction in account currency and in base currency, but the stock position may be in a different currency
                        // each currency in quotes has a quoteBaseCurrency which is its relationship to the base currency
                        // let us figure out the base currency first
                        if (position.currency === baseCurrency) // if the position currency is the same as the base currency, we only need to post a transaction in the account currency
                        newTransaction.amount = amount; // amount is in base currency
                        else {
                            // if the position currency is different from the base currency, we need to figure out the amount in base currency
                            newTransaction.amount = amount * quotes[position.currency][date].quoteBaseCurrency;
                            newTransaction.currency = accountCurrency;
                            newTransaction.baseCurrencyAmount = amount;
                            newTransaction.baseCurrency = baseCurrency;
                        }
                    } catch (e) {
                        console.error("simulatedDividendView", e);
                        console.info("simulatedDividendView: error parameters", JSON.stringify(position, null, 2), date, accountId, assetId);
                    }
                });
            });
        });
    });
    return simulatedDividendTransactions;
}
const $cfd21bc923628483$export$ffbf01f805bb8c9b = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data.stocks.transactions, (state)=>state.data.stocks.simulatedTransactions, ($transactions, $simulatedTransactions)=>{
    const displaySymbolByAssetId = {};
    const assetIdByDisplaySymbol = {};
    const providerAssetIdByDisplaySymbol = {};
    const displayNameByDisplaySymbol = {};
    // include all transactions (also those beyond the slider date)
    ($transactions.concat($simulatedTransactions) || []).forEach((transaction)=>{
        const { figi: figi, displaySymbol: displaySymbol, displayName: displayName, providerAssetId: providerAssetId } = transaction;
        // before updating check if the updated value is null (and do not update if it is)
        // Update figis object
        if (!displaySymbolByAssetId[figi] || displaySymbol) displaySymbolByAssetId[figi] = displaySymbol;
        // Update displaySymbols object
        if (!assetIdByDisplaySymbol[displaySymbol] || figi) assetIdByDisplaySymbol[displaySymbol] = figi;
        // Update displaySymbols object
        if (!providerAssetIdByDisplaySymbol[displaySymbol] || providerAssetId) providerAssetIdByDisplaySymbol[displaySymbol] = providerAssetId;
        // Update displayNames object
        if (!displayNameByDisplaySymbol[displaySymbol] || displayName) displayNameByDisplaySymbol[displaySymbol] = displayName;
    });
    // displaySymbolByAssetId: { figi1: displaySymbol1, figi2: displaySymbol2, ... }
    // assetIdByDisplaySymbol: { displaySymbol1: figi1, displaySymbol2: figi2, ... }
    // providerAssetIdByDisplaySymbol: { displaySymbol1: providerAssetId1, displaySymbol2: providerAssetId2, ... }
    // displayNameByDisplaySymbol: { displaySymbol1: displayName1, displaySymbol2: displayName2, ... }
    return {
        displaySymbolByAssetId: displaySymbolByAssetId,
        assetIdByDisplaySymbol: assetIdByDisplaySymbol,
        providerAssetIdByDisplaySymbol: providerAssetIdByDisplaySymbol,
        displayNameByDisplaySymbol: displayNameByDisplaySymbol
    };
});



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");







/* eslint-disable max-len */ // import { nanoid } from 'nanoid';


/**
 * Calculates number of relevant decimal places for a given currency
 *
 * @param {string} currency - The currency code to get the decimal places for
 *
 * @returns {number} - The number of decimal places for the given currency
 */ function $3a8aedde2f26cb8e$export$2e2bcd8739ae039(currency, locale = "en") {
    // Use a small number to ensure decimal places are included
    const formatted = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    }).format(0.1);
    // Find the decimal separator for the current locale
    const decimalSeparator = new Intl.NumberFormat(locale).format(1.1).charAt(1);
    // Extract the part after the decimal separator
    const decimalPart = formatted.split(decimalSeparator)[1];
    // Return the number of digits after the decimal separator, or 0 if none
    return decimalPart ? decimalPart.replace(/\D/g, "").length : 0;
}


// import i18n from '../../../../i18n';
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
// expects an array of { effectiveDate, value } objects
// returns the currently applicable annual interest rate in percent (e.g. 4.5 and not 0.045)
function $e6392d36b7d388c7$var$getCurrentInterestRate(currentDate, interestRateArray) {
    if (interestRateArray.length < 1) throw new Error("getSimulatedRepaymentSchedule > getCurrentInterestRate: interestRateArray is empty");
    const interestRate = interestRateArray.filter((x)=>x.effectiveDate <= currentDate).sort((a, b)=>b.effectiveDate - a.effectiveDate)[0]; // DESC, we want to find the most recent interest rate
    if (!interestRate) {
        console.warn("getSimulatedRepaymentSchedule > getCurrentInterestRate: interestRate for period", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(currentDate).format("YYYY-MM-DD"), "not found. Using first available interest rate.");
        return interestRateArray.sort((a, b)=>a.effectiveDate - b.effectiveDate)[0].value; // ASC
    }
    return interestRate.value;
}
// expects an array of { effectiveDate, value } objects
// returns the currently applicable length of period in months
function $e6392d36b7d388c7$var$getCurrentPeriodNum(currentDate, periodArray) {
    if (periodArray.length < 1) throw new Error(" aymentSchedule > getCurrentPeriodNum: periodArray is empty");
    const period = periodArray.filter((x)=>x.effectiveDate <= currentDate).sort((a, b)=>b.effectiveDate - a.effectiveDate)[0]; // DESC, we want to find the most recent
    if (!period) {
        console.warn("getSimulatedRepaymentSchedule > getCurrentPeriodNum: period for period", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(currentDate).format("YYYY-MM-DD"), "not found. Using first available period.");
        return periodArray.sort((a, b)=>a.effectiveDate - b.effectiveDate)[0].value; // ASC
    }
    switch(period.value){
        case "month":
            return 12;
        case "quarter":
            return 4;
        case "annual":
            return 1;
        default:
            throw new Error("getSimulatedRepaymentSchedule: Invalid period");
    }
}
// expects an array of { effectiveDate, value } objects
// returns the currently applicable percent repaid annually (Tilgung)
function $e6392d36b7d388c7$var$getCurrentPercentRepaidAnnually(currentDate, periodArray) {
    if (periodArray.length < 1) throw new Error("getSimulatedRepaymentSchedule > getCurrentPercentRepaidAnnually: periodArray is empty");
    const pra = periodArray.filter((x)=>x.effectiveDate <= currentDate).sort((a, b)=>b.effectiveDate - a.effectiveDate)[0]; // DESC
    if (!pra) {
        console.warn("getSimulatedRepaymentSchedule > getCurrentPercentRepaidAnnually: period for period", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(currentDate).format("YYYY-MM-DD"), "not found. Using first available period.");
        return periodArray.sort((a, b)=>a.effectiveDate - b.effectiveDate)[0].value; // ASC
    }
    return pra.value;
}
function $e6392d36b7d388c7$var$getAnnuity(annualInterestRate, loanAmount, percentRepaidAnnually, periodNum) {
    const firstInterestPayment = loanAmount * (annualInterestRate / 100) / periodNum;
    const firstPrincipalPayment = loanAmount * (percentRepaidAnnually / 100) / periodNum;
    return firstInterestPayment + firstPrincipalPayment;
}
function $e6392d36b7d388c7$var$hasFutureEffectiveChange(scheduleItems = [], currentDate) {
    return (scheduleItems || []).some((item)=>Number(item === null || item === void 0 ? void 0 : item.effectiveDate) > currentDate);
}
function $e6392d36b7d388c7$var$hasFutureRepayment(plannedExtraRepayments = [], currentDate) {
    return (plannedExtraRepayments || []).some((item)=>Number(item === null || item === void 0 ? void 0 : item.date) > currentDate && Number(item === null || item === void 0 ? void 0 : item.quantity) > 0);
}
function $e6392d36b7d388c7$export$2e2bcd8739ae039(startDate, outstandingPrincipal, loanAccount, plannedExtraRepayments = []) {
    if (Math.abs(outstandingPrincipal) > Math.abs(loanAccount.loanAmount)) {
        console.error("getSimulatedRepaymentSchedule: outstandingPrincipal cannot be greater than loanAmount");
        return {
            schedule: [],
            sumCustomRepayment: 0,
            sumInterestPaid: 0,
            totalAmount: 0
        };
    }
    // console.log('getSimulatedRepaymentSchedule', startDate, outstandingPrincipal, loanAccount, plannedExtraRepayments);
    const { type: type, interestRate: interestRate, period: period, percentRepaidAnnually: percentRepaidAnnually, loanAmount: loanAmount, contractEndDate: contractEndDate, interestCalcMonthEnd: interestCalcMonthEnd } = loanAccount;
    const normalizedContractEndDate = Number.isFinite(contractEndDate) ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(contractEndDate).startOf("month").valueOf() : null;
    const decimalPlaces = (0, $3a8aedde2f26cb8e$export$2e2bcd8739ae039)(loanAccount.currency);
    const round = (value)=>Number(value.toFixed(decimalPlaces));
    // to simplify the code, we work on a positive loanAmount and adjust the signs at the end
    // loanAmount will be negative for loans taken and positive for loans given
    const loanAmountAbs = Math.abs(loanAmount);
    // interestOnly loans are only accepted with a contractEndDate (otherwise they run infinitely)
    if (type === "interestOnly" && !contractEndDate) throw new Error("getSimulatedRepaymentSchedule: interestOnly loans require a contractEndDate");
    // initialise variables
    let remainingLoanAmount = Math.abs(outstandingPrincipal);
    let sumInterestPaid = 0;
    let sumCustomRepayment = 0;
    let currentInstallmentDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(startDate).startOf("month");
    let totalPaymentToBePaid = 0;
    let installmentCount = 0;
    // array to hold the schedule
    const schedule = [];
    // loop through each month to catch all changes in interest rate, percentRepaidAnnually or period
    // (but only produce transactions within the period "Taktung", so every 1 / 3 / 12 months)
    while(remainingLoanAmount > 0){
        installmentCount += 1;
        if (installmentCount > 10000) {
            console.error("getSimulatedRepaymentSchedule: aborting after 10000 installments to avoid an infinite schedule loop");
            break;
        }
        const currentDate = currentInstallmentDate.valueOf();
        // update loan parameters
        const currentInterestRate = $e6392d36b7d388c7$var$getCurrentInterestRate(currentDate, interestRate);
        const currentPeriodNum = $e6392d36b7d388c7$var$getCurrentPeriodNum(currentDate, period);
        const currentPercentRepaidAnnually = $e6392d36b7d388c7$var$getCurrentPercentRepaidAnnually(currentDate, percentRepaidAnnually);
        // opening balance for the current month
        const openingBalance = remainingLoanAmount;
        // if there are any extra payments scheduled
        // we add the repayment before calculating interest for this month and add the extra payment to the principal of this
        let customRepayment = 0;
        if (plannedExtraRepayments.length > 0) {
            // find if there are any out of schedule repayments for current month and sum up the quantity (in account currency, so quantity * 1)
            // eslint-disable-next-line no-loop-func
            customRepayment = round(plannedExtraRepayments.reduce((acc, curr)=>curr.date === currentDate ? acc + curr.quantity : acc, 0));
            sumCustomRepayment += customRepayment;
        }
        let annuity;
        let currentPrincipalAmount;
        let currentInterestAmount;
        switch(type){
            case "annuity":
                // annuity is always calculated based on the INITIAL loan amount and current parameters
                annuity = round($e6392d36b7d388c7$var$getAnnuity(currentInterestRate, loanAmountAbs, currentPercentRepaidAnnually, currentPeriodNum));
                // calculate the interest for the current period
                // if interestCalcMonthEnd is true, we consider the extra payment this month already
                // otherwise it gets deducted from the remainingLoanAmount and gets considered next month
                currentInterestAmount = round((remainingLoanAmount - (interestCalcMonthEnd ? customRepayment : 0)) * (currentInterestRate / 100) * (1 / currentPeriodNum));
                // calculate the principal for the current month + add the custom repayment if existing (is default 0)
                currentPrincipalAmount = annuity - currentInterestAmount;
                totalPaymentToBePaid += annuity;
                break;
            case "fixedPrincipal":
                // calculate the principal for the current month
                currentPrincipalAmount = round(loanAmountAbs * (currentPercentRepaidAnnually / 100) / currentPeriodNum);
                // calculate the interest for the current period
                // if interestCalcMonthEnd is true, we consider the extra payment this month already
                // otherwise it gets deducted from the remainingLoanAmount and gets considered next month
                currentInterestAmount = round((remainingLoanAmount - (interestCalcMonthEnd ? customRepayment : 0)) * (currentInterestRate / 100) * (1 / currentPeriodNum));
                totalPaymentToBePaid += currentPrincipalAmount + currentInterestAmount;
                break;
            case "interestOnly":
                // calculate the interest for the current period
                currentInterestAmount = round((loanAmountAbs - (interestCalcMonthEnd ? customRepayment : 0)) * (currentInterestRate / 100) * (1 / currentPeriodNum));
                currentPrincipalAmount = 0;
                totalPaymentToBePaid += currentInterestAmount;
                break;
            default:
                throw new Error("getSimulatedRepaymentSchedule: Invalid loan type");
        }
        totalPaymentToBePaid += customRepayment;
        const principalReduction = round(currentPrincipalAmount + customRepayment);
        const hasFutureParameterChange = $e6392d36b7d388c7$var$hasFutureEffectiveChange(interestRate, currentDate) || $e6392d36b7d388c7$var$hasFutureEffectiveChange(period, currentDate) || $e6392d36b7d388c7$var$hasFutureEffectiveChange(percentRepaidAnnually, currentDate);
        const hasFutureCustomRepayment = $e6392d36b7d388c7$var$hasFutureRepayment(plannedExtraRepayments, currentDate);
        const hasFutureContractEnd = normalizedContractEndDate && normalizedContractEndDate > currentDate;
        const settlesAtContractEndThisMonth = normalizedContractEndDate && currentDate >= normalizedContractEndDate;
        const scheduleWillNeverAmortize = principalReduction <= 0 && !settlesAtContractEndThisMonth && !hasFutureParameterChange && !hasFutureCustomRepayment && !hasFutureContractEnd;
        if (scheduleWillNeverAmortize) console.error("getSimulatedRepaymentSchedule: schedule will not amortize without a future change or contract end", {
            currentDate: currentInstallmentDate.format("YYYY-MM-DD"),
            type: type,
            principalReduction: principalReduction
        });
        // reduce the remaining loan amount by the principal
        remainingLoanAmount -= principalReduction;
        // if the remaining loan amount is less than or equal to 0, make adjustments
        if (remainingLoanAmount <= 0) {
            // adjust the principal by adding the negative remaining loan amount
            currentPrincipalAmount += remainingLoanAmount;
            // set the remaining loan amount to 0
            remainingLoanAmount = 0;
        }
        // if this is the contractEndDate month, we need to return the last "balloon" installment
        if (normalizedContractEndDate && currentDate >= normalizedContractEndDate) {
            currentPrincipalAmount += remainingLoanAmount;
            // set the remaining loan amount to 0
            remainingLoanAmount = 0;
        }
        // increase the total interest paid by the monthly interest
        sumInterestPaid += currentInterestAmount;
        // reintroduce the sign which was removed from loanAmount in the beginning
        // if the loanAmount was negative, the principal and interest amounts need to POSITIVE and vice versa
        const sign = loanAmount <= 0 ? 1 : -1;
        // create an object for the current installment
        const installment = {
            date: currentDate,
            installmentDate: currentInstallmentDate.format("YYYY-MM"),
            interestRate: currentInterestRate,
            periodNum: currentPeriodNum,
            percentRepaidAnnually: currentPercentRepaidAnnually,
            openingBalance: round(openingBalance) * sign,
            currentPrincipal: round(currentPrincipalAmount) * sign,
            currentInterest: round(currentInterestAmount) * sign,
            currentRepayment: round(currentPrincipalAmount + currentInterestAmount) * sign,
            outOfScheduleRepayments: round(customRepayment) * sign,
            paymentWithOOSRepayments: round(currentPrincipalAmount + currentInterestAmount + customRepayment) * sign,
            remainingLoanAmount: round(remainingLoanAmount) * sign,
            percentLoanPaid: round((outstandingPrincipal - remainingLoanAmount) / outstandingPrincipal * 100)
        };
        // add the current installment to the schedule
        schedule.push(installment);
        // move the installment date to the next month
        const nextInstallmentDate = currentInstallmentDate.add(12 / currentPeriodNum, "month").startOf("month");
        // if the remaining loan amount is 0 or less, break the loop
        if (remainingLoanAmount <= 0 || scheduleWillNeverAmortize) break;
        currentInstallmentDate = normalizedContractEndDate && currentDate < normalizedContractEndDate && nextInstallmentDate.valueOf() > normalizedContractEndDate ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(normalizedContractEndDate).startOf("month") : nextInstallmentDate;
    }
    // reintroduce the sign which was removed from loanAmount in the beginning
    // if the loanAmount was negative, the principal and interest amounts need to POSITIVE and vice versa
    const sign = loanAmount <= 0 ? 1 : -1;
    // console.log({
    //   schedule,
    //   sumCustomRepayment: sumCustomRepayment * sign,
    //   sumInterestPaid: sumInterestPaid * sign,
    //   totalAmount: (outstandingPrincipal + sumInterestPaid + sumCustomRepayment) * sign,
    // });
    // return the schedule and calculated totals
    return {
        schedule: schedule,
        sumCustomRepayment: sumCustomRepayment * sign,
        sumInterestPaid: sumInterestPaid * sign,
        totalAmount: (outstandingPrincipal + sumInterestPaid + sumCustomRepayment) * sign
    };
}



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $2da686298e0b71ed$var$parseTags(tags) {
    return typeof tags === "string" ? JSON.parse(tags) : tags || {};
}
function $2da686298e0b71ed$var$getTransactionSign(transaction) {
    const numericValue = [
        transaction === null || transaction === void 0 ? void 0 : transaction.quantity,
        transaction === null || transaction === void 0 ? void 0 : transaction.accountCurrencyAmount,
        transaction === null || transaction === void 0 ? void 0 : transaction.amount
    ].find((value)=>typeof value === "number" && value !== 0);
    return numericValue && numericValue < 0 ? -1 : 1;
}
function $2da686298e0b71ed$var$buildDerivedId(sourceId, suffix) {
    return `${sourceId}:${suffix}`;
}
function $2da686298e0b71ed$var$getSourceUpbc(transaction, baseCurrency, currency, quotes) {
    var _quotes_currency_current, _quotes_currency;
    if (Number.isFinite(Number(transaction === null || transaction === void 0 ? void 0 : transaction.upbc)) && Number(transaction.upbc) !== 0) return Number(transaction.upbc);
    if (currency === baseCurrency) return 1;
    const currentQuoteBaseCurrency = quotes === null || quotes === void 0 ? void 0 : (_quotes_currency = quotes[currency]) === null || _quotes_currency === void 0 ? void 0 : (_quotes_currency_current = _quotes_currency.current) === null || _quotes_currency_current === void 0 ? void 0 : _quotes_currency_current.quoteBaseCurrency;
    if (currentQuoteBaseCurrency) return 1 / currentQuoteBaseCurrency;
    return 1;
}
function $2da686298e0b71ed$var$getOpeningTransactionDate(account) {
    const firstInterestRateDate = ((account === null || account === void 0 ? void 0 : account.interestRate) || []).map((item)=>item === null || item === void 0 ? void 0 : item.effectiveDate).filter((value)=>Number.isFinite(value)).sort((a, b)=>a - b)[0];
    return firstInterestRateDate || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf();
}
function $2da686298e0b71ed$var$createLoanSideTransaction({ id: id, account: account, date: date, quantity: quantity, quantityInterest: quantityInterest = 0, description: description, projectId: projectId = null, upac: upac = 1, upbc: upbc = 1, uptc: uptc = 1, isSimulated: isSimulated = false, linkedTransactions: linkedTransactions = [], tags: tags = {} }) {
    return (0, $5c401a4958c7a09c$export$95eff6423824c31b).cast({
        id: id,
        accountId: account.id,
        date: date,
        category: "loans",
        description: description,
        projectId: projectId,
        quantity: quantity,
        quantityInterest: quantityInterest,
        upac: upac,
        upbc: upbc,
        uptc: uptc,
        accountCurrency: account.currency,
        assetCurrency: account.currency,
        assetId: account.currency,
        transactionCurrency: account.currency,
        isSimulated: isSimulated,
        linkedTransactions: linkedTransactions,
        tags: tags
    });
}
function $2da686298e0b71ed$var$createRepaymentTransactionFromDeposit(transaction, account, baseCurrency, quotes) {
    var _tags_loanRepayment, _tags_loanRepayment1;
    const tags = $2da686298e0b71ed$var$parseTags(transaction.tags);
    const principal = Math.abs(Number(tags === null || tags === void 0 ? void 0 : (_tags_loanRepayment = tags.loanRepayment) === null || _tags_loanRepayment === void 0 ? void 0 : _tags_loanRepayment.principal) || 0);
    const interest = Math.abs(Number(tags === null || tags === void 0 ? void 0 : (_tags_loanRepayment1 = tags.loanRepayment) === null || _tags_loanRepayment1 === void 0 ? void 0 : _tags_loanRepayment1.interest) || 0);
    if (!principal && !interest) return null;
    const signMultiplier = $2da686298e0b71ed$var$getTransactionSign(transaction) * -1;
    return $2da686298e0b71ed$var$createLoanSideTransaction({
        id: $2da686298e0b71ed$var$buildDerivedId(transaction.id, "loan-repayment"),
        account: account,
        date: transaction.date,
        quantity: signMultiplier * principal,
        quantityInterest: signMultiplier * interest,
        description: transaction.description,
        projectId: transaction.projectId,
        upac: Number(transaction.upac) || 1,
        upbc: $2da686298e0b71ed$var$getSourceUpbc(transaction, baseCurrency, account.currency, quotes),
        uptc: Number(transaction.uptc) || 1,
        isSimulated: !!transaction.isSimulated,
        linkedTransactions: [
            {
                id: transaction.id,
                category: "deposits",
                tags: {
                    type: "transfer"
                }
            }
        ],
        tags: {
            sourceDepositTransactionId: transaction.id
        }
    });
}
function $2da686298e0b71ed$var$createPayoutTransactionFromDeposit(transaction, account, baseCurrency, quotes) {
    var _transaction_accountCurrencyAmount;
    const quantityAbsolute = Math.abs(Number((_transaction_accountCurrencyAmount = transaction.accountCurrencyAmount) !== null && _transaction_accountCurrencyAmount !== void 0 ? _transaction_accountCurrencyAmount : transaction.quantity) || 0);
    if (!quantityAbsolute) return null;
    return $2da686298e0b71ed$var$createLoanSideTransaction({
        id: $2da686298e0b71ed$var$buildDerivedId(transaction.id, "loan-payout"),
        account: account,
        date: transaction.date,
        quantity: $2da686298e0b71ed$var$getTransactionSign(transaction) * -quantityAbsolute,
        quantityInterest: 0,
        description: transaction.description,
        projectId: transaction.projectId,
        upac: Number(transaction.upac) || 1,
        upbc: $2da686298e0b71ed$var$getSourceUpbc(transaction, baseCurrency, account.currency, quotes),
        uptc: Number(transaction.uptc) || 1,
        isSimulated: !!transaction.isSimulated,
        linkedTransactions: [
            {
                id: transaction.id,
                category: "deposits",
                tags: {
                    type: "transfer"
                }
            }
        ],
        tags: {
            sourceDepositTransactionId: transaction.id
        }
    });
}
function $2da686298e0b71ed$var$createSyntheticOpeningTransaction(account, baseCurrency, quotes) {
    const quantity = Number(account === null || account === void 0 ? void 0 : account.loanAmount);
    if (!Number.isFinite(quantity) || quantity === 0) return null;
    return $2da686298e0b71ed$var$createLoanSideTransaction({
        id: $2da686298e0b71ed$var$buildDerivedId(account.id, "loan-opening"),
        account: account,
        date: $2da686298e0b71ed$var$getOpeningTransactionDate(account),
        quantity: quantity,
        quantityInterest: 0,
        description: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language === "de" ? "Anfangssaldo" : "Opening balance",
        projectId: account.connectedProjectId || null,
        upac: 1,
        upbc: $2da686298e0b71ed$var$getSourceUpbc(null, baseCurrency, account.currency, quotes),
        uptc: 1,
        tags: {
            syntheticOpening: true,
            nonEditable: true
        }
    });
}
function $2da686298e0b71ed$var$deriveRealizedLoanTransactions(depositTransactions, accounts, baseCurrency, quotes) {
    const accountById = Object.fromEntries((accounts || []).map((account)=>[
            account.id,
            account
        ]));
    const payoutTransactionCount = new Map();
    const realizedTransactions = [];
    (depositTransactions || []).forEach((transaction)=>{
        const tags = $2da686298e0b71ed$var$parseTags(transaction.tags);
        const targetAccountId = tags === null || tags === void 0 ? void 0 : tags.accountId;
        const account = accountById[targetAccountId];
        if (!account) return;
        if (transaction.label === "investment-payout") {
            const payoutTransaction = $2da686298e0b71ed$var$createPayoutTransactionFromDeposit(transaction, account, baseCurrency, quotes);
            if (payoutTransaction) {
                payoutTransactionCount.set(account.id, (payoutTransactionCount.get(account.id) || 0) + 1);
                realizedTransactions.push(payoutTransaction);
            }
            return;
        }
        if (transaction.label !== "investment-loanRepayment" || !(tags === null || tags === void 0 ? void 0 : tags.loanRepayment)) return;
        const repaymentTransaction = $2da686298e0b71ed$var$createRepaymentTransactionFromDeposit(transaction, account, baseCurrency, quotes);
        if (repaymentTransaction) realizedTransactions.push(repaymentTransaction);
    });
    (accounts || []).forEach((account)=>{
        if ((payoutTransactionCount.get(account.id) || 0) > 0) return;
        const openingTransaction = $2da686298e0b71ed$var$createSyntheticOpeningTransaction(account, baseCurrency, quotes);
        if (openingTransaction) realizedTransactions.push(openingTransaction);
    });
    return realizedTransactions.sort((a, b)=>a.date - b.date);
}
function $2da686298e0b71ed$var$applyLoanTransactionTypes(transactions, accounts) {
    return (transactions || []).map((txn)=>{
        const account = accounts.find((acc)=>acc.id === txn.accountId);
        if (!account) return txn;
        switch(account.direction){
            case "received":
                return (0, $2qxEV._)((0, $9tqwB._)({}, txn), {
                    transactionType: txn.quantity >= 0 ? "sale" : "purchase"
                });
            case "granted":
                return (0, $2qxEV._)((0, $9tqwB._)({}, txn), {
                    transactionType: txn.quantity < 0 ? "sale" : "purchase"
                });
            default:
                console.error("Unknown account direction", account.direction);
                return txn;
        }
    });
}
function $2da686298e0b71ed$var$getScheduleStartDate(realizedTransactions) {
    var _realizedTransactions_slice_sort_;
    const lastTransactionDate = (_realizedTransactions_slice_sort_ = realizedTransactions.slice().sort((a, b)=>b.date - a.date)[0]) === null || _realizedTransactions_slice_sort_ === void 0 ? void 0 : _realizedTransactions_slice_sort_.date;
    return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(lastTransactionDate || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()).add(1, "month").startOf("month").valueOf();
}
// DOES NOT return user-added out of schedule transactions (e.g. manual principal payment)
function $2da686298e0b71ed$var$transformRepaymentScheduleItemToTransaction(item, accountId, projectId, currency, baseCurrency, quotes, transactions) {
    let upbc = 1;
    if (baseCurrency !== currency) {
        var _quotes_currency_current, _quotes_currency;
        const currentQBC = (_quotes_currency = quotes[currency]) === null || _quotes_currency === void 0 ? void 0 : (_quotes_currency_current = _quotes_currency.current) === null || _quotes_currency_current === void 0 ? void 0 : _quotes_currency_current.quoteBaseCurrency;
        upbc = currentQBC && currentQBC !== 0 ? 1 / currentQBC : undefined;
        if (!upbc) {
            const lastTransaction = transactions.filter((transaction)=>transaction.accountId === accountId).sort((a, b)=>b.date - a.date)[0];
            upbc = lastTransaction === null || lastTransaction === void 0 ? void 0 : lastTransaction.upbc;
        }
        if (!upbc) throw new Error("loansTransactions > transformRepaymentScheduleItemToTransaction: no upbc found");
    }
    const linkedDepositTransctionId = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const commonProperties = (0, $5c401a4958c7a09c$export$95eff6423824c31b).cast({
        id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
        accountId: accountId,
        projectId: projectId,
        date: item.date,
        category: "loans",
        description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language === "de" ? "Darlehensrate" : "Installment"} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.date).format("YYYY-MM")}`,
        assetId: currency,
        accountCurrency: currency,
        assetCurrency: currency,
        upbc: upbc,
        upac: 1,
        uptc: 1,
        isSimulated: true,
        linkedTransactions: [
            {
                id: linkedDepositTransctionId,
                category: "deposits",
                tags: {
                    type: "transfer"
                }
            }
        ],
        tags: {
            linkedDepositTransctionId: linkedDepositTransctionId
        }
    });
    return [
        (0, $2qxEV._)((0, $9tqwB._)({}, commonProperties), {
            quantity: item.currentPrincipal,
            quantityInterest: item.currentInterest
        })
    ];
}
function $2da686298e0b71ed$var$buildLoanTransactions({ depositTransactions: depositTransactions, explicitSimulatedLoanTransactions: explicitSimulatedLoanTransactions, accounts: accounts, quotes: quotes, baseCurrency: baseCurrency, baseDate: baseDate = null }) {
    const realizedTransactions = $2da686298e0b71ed$var$deriveRealizedLoanTransactions(depositTransactions, accounts, baseCurrency, quotes);
    const transactionsWithSimulated = accounts.flatMap((loanAccount)=>{
        const thisAccountRealizedTransactions = realizedTransactions.filter((txn)=>txn.accountId === loanAccount.id);
        const thisAccountExplicitSimulatedTransactions = explicitSimulatedLoanTransactions.filter((txn)=>txn.accountId === loanAccount.id);
        const outstandingPrincipal = thisAccountRealizedTransactions.reduce((acc, transaction)=>acc + transaction.quantity, 0);
        const repaymentSchedule = (0, $e6392d36b7d388c7$export$2e2bcd8739ae039)($2da686298e0b71ed$var$getScheduleStartDate(thisAccountRealizedTransactions), outstandingPrincipal, loanAccount, thisAccountExplicitSimulatedTransactions) || {
            schedule: []
        };
        const simulatedRepaymentTransactionsForAccount = repaymentSchedule.schedule.filter((item)=>baseDate ? item.date.valueOf() <= baseDate : true).flatMap((item)=>$2da686298e0b71ed$var$transformRepaymentScheduleItemToTransaction(item, loanAccount.id, loanAccount.connectedProjectId, loanAccount.currency, baseCurrency, quotes, thisAccountRealizedTransactions));
        const reverseMode = loanAccount.direction === "received";
        const allTransactions = thisAccountRealizedTransactions.concat(thisAccountExplicitSimulatedTransactions).concat(simulatedRepaymentTransactionsForAccount);
        return (0, $3e6d58b7292c657b$export$aeb4e5a5dec08365)(allTransactions, reverseMode);
    });
    return $2da686298e0b71ed$var$applyLoanTransactionTypes(transactionsWithSimulated, accounts);
}
function $2da686298e0b71ed$var$getDashboardProjectScopedDepositTransactions(transactions, simulatedTransactions, baseDate, projects) {
    const isolatedProjectIds = (projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
        var _project_settings;
        return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
    }).map((project)=>project.id)) || [];
    const projectSimulatedTransactions = (simulatedTransactions || []).filter((txn)=>!isolatedProjectIds.includes(txn.projectId)).filter((txn)=>txn.date <= baseDate);
    return (transactions || []).concat(projectSimulatedTransactions).filter((txn)=>txn.date <= baseDate);
}
function $2da686298e0b71ed$var$getDashboardProjectScopedLoanTransactions(simulatedTransactions, baseDate, projects) {
    const isolatedProjectIds = (projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
        var _project_settings;
        return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
    }).map((project)=>project.id)) || [];
    return (simulatedTransactions || []).filter((txn)=>!isolatedProjectIds.includes(txn.projectId)).filter((txn)=>txn.date <= baseDate);
}
const $2da686298e0b71ed$export$a856f17095d848d7 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.transactions) || [];
}, (state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.simulatedTransactions) || [];
}, (state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.loans.simulatedTransactions) || [];
}, (state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.loans.accounts) || [];
}, $93bb2798871a68d2$export$443f4a6ebd922e0a, (state)=>state.simulation.dashboardMode, (state)=>state.simulation.baseDate, (state)=>state.user.profile.settings.baseCurrency, (state)=>state.projects, (depositTransactions, depositSimulatedTransactions, explicitSimulatedLoanTransactions, accounts, quotes, dashboardMode, baseDate, baseCurrency, projects)=>{
    if (dashboardMode === "dashboard") {
        const realizedTransactions = $2da686298e0b71ed$var$deriveRealizedLoanTransactions(depositTransactions, accounts, baseCurrency, quotes);
        const transactionsWithFifo = accounts.flatMap((loanAccount)=>(0, $3e6d58b7292c657b$export$aeb4e5a5dec08365)(realizedTransactions.filter((transaction)=>transaction.accountId === loanAccount.id), loanAccount.direction === "received"));
        return $2da686298e0b71ed$var$applyLoanTransactionTypes(transactionsWithFifo, accounts);
    }
    return $2da686298e0b71ed$var$buildLoanTransactions({
        depositTransactions: $2da686298e0b71ed$var$getDashboardProjectScopedDepositTransactions(depositTransactions, depositSimulatedTransactions, baseDate, projects),
        explicitSimulatedLoanTransactions: $2da686298e0b71ed$var$getDashboardProjectScopedLoanTransactions(explicitSimulatedLoanTransactions, baseDate, projects),
        accounts: accounts,
        quotes: quotes,
        baseCurrency: baseCurrency,
        baseDate: baseDate
    });
});
const $2da686298e0b71ed$export$7180e5e29ddd79ea = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.transactions) || [];
}, (state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.simulatedTransactions) || [];
}, (state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.loans.simulatedTransactions) || [];
}, (state)=>{
    var _state_data;
    return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.loans.accounts) || [];
}, $93bb2798871a68d2$export$443f4a6ebd922e0a, (state)=>state.user.profile.settings.baseCurrency, (depositTransactions, depositSimulatedTransactions, explicitSimulatedLoanTransactions, accounts, quotes, baseCurrency)=>$2da686298e0b71ed$var$buildLoanTransactions({
        depositTransactions: depositTransactions.concat(depositSimulatedTransactions),
        explicitSimulatedLoanTransactions: explicitSimulatedLoanTransactions,
        accounts: accounts,
        quotes: quotes,
        baseCurrency: baseCurrency
    }));
function $2da686298e0b71ed$var$getConnectedDepositAccountId(loanAccounts, loanAccountId) {
    var _loanAccounts_find_connectedDepositAccounts, _loanAccounts_find;
    return (_loanAccounts_find = loanAccounts.find((account)=>account.id === loanAccountId)) === null || _loanAccounts_find === void 0 ? void 0 : (_loanAccounts_find_connectedDepositAccounts = _loanAccounts_find.connectedDepositAccounts) === null || _loanAccounts_find_connectedDepositAccounts === void 0 ? void 0 : _loanAccounts_find_connectedDepositAccounts[0];
}
function $2da686298e0b71ed$var$createCanonicalDepositLoanRepayment(_loanTransaction, _loanAccounts, _depositAccounts, _quotes) {
    let depositAccount;
    try {
        var _loanTransaction_tags;
        const depositAccountId = $2da686298e0b71ed$var$getConnectedDepositAccountId(_loanAccounts, _loanTransaction.accountId);
        depositAccount = _depositAccounts.find((account)=>account.id === depositAccountId);
        if (!depositAccount) {
            console.error("No connected deposit account found for loan account", _loanTransaction.accountId);
            return null;
        }
        const principalLoanCurrency = -1 * _loanTransaction.quantity;
        const interestLoanCurrency = -1 * _loanTransaction.quantityInterest;
        let principalAccountCurrency = principalLoanCurrency;
        let interestAccountCurrency = interestLoanCurrency;
        let accountCurrencyAmount = principalAccountCurrency + interestAccountCurrency;
        let fxAmount = null;
        let fxCurrency = null;
        let uptc = 1;
        if (depositAccount.currency !== _loanTransaction.accountCurrency) {
            var _quotes_depositAccount_currency__loanTransaction_date, _quotes_depositAccount_currency, _quotes_depositAccount_currency_current, _quotes_depositAccount_currency1, _quotes__loanTransaction_accountCurrency__loanTransaction_date, _quotes__loanTransaction_accountCurrency, _quotes__loanTransaction_accountCurrency_current, _quotes__loanTransaction_accountCurrency1;
            const accountCurrencyQuote = (_quotes === null || _quotes === void 0 ? void 0 : (_quotes_depositAccount_currency = _quotes[depositAccount.currency]) === null || _quotes_depositAccount_currency === void 0 ? void 0 : (_quotes_depositAccount_currency__loanTransaction_date = _quotes_depositAccount_currency[_loanTransaction.date]) === null || _quotes_depositAccount_currency__loanTransaction_date === void 0 ? void 0 : _quotes_depositAccount_currency__loanTransaction_date.quoteBaseCurrency) || (_quotes === null || _quotes === void 0 ? void 0 : (_quotes_depositAccount_currency1 = _quotes[depositAccount.currency]) === null || _quotes_depositAccount_currency1 === void 0 ? void 0 : (_quotes_depositAccount_currency_current = _quotes_depositAccount_currency1.current) === null || _quotes_depositAccount_currency_current === void 0 ? void 0 : _quotes_depositAccount_currency_current.quoteBaseCurrency);
            const loanCurrencyQuote = (_quotes === null || _quotes === void 0 ? void 0 : (_quotes__loanTransaction_accountCurrency = _quotes[_loanTransaction.accountCurrency]) === null || _quotes__loanTransaction_accountCurrency === void 0 ? void 0 : (_quotes__loanTransaction_accountCurrency__loanTransaction_date = _quotes__loanTransaction_accountCurrency[_loanTransaction.date]) === null || _quotes__loanTransaction_accountCurrency__loanTransaction_date === void 0 ? void 0 : _quotes__loanTransaction_accountCurrency__loanTransaction_date.quoteBaseCurrency) || (_quotes === null || _quotes === void 0 ? void 0 : (_quotes__loanTransaction_accountCurrency1 = _quotes[_loanTransaction.accountCurrency]) === null || _quotes__loanTransaction_accountCurrency1 === void 0 ? void 0 : (_quotes__loanTransaction_accountCurrency_current = _quotes__loanTransaction_accountCurrency1.current) === null || _quotes__loanTransaction_accountCurrency_current === void 0 ? void 0 : _quotes__loanTransaction_accountCurrency_current.quoteBaseCurrency);
            if (accountCurrencyQuote && loanCurrencyQuote) {
                const conversionRate = loanCurrencyQuote / accountCurrencyQuote;
                principalAccountCurrency = principalLoanCurrency * conversionRate;
                interestAccountCurrency = interestLoanCurrency * conversionRate;
                accountCurrencyAmount = principalAccountCurrency + interestAccountCurrency;
                fxAmount = principalLoanCurrency + interestLoanCurrency;
                fxCurrency = _loanTransaction.accountCurrency;
                uptc = accountCurrencyAmount !== 0 ? fxAmount / accountCurrencyAmount : 1;
            }
        }
        const transaction = (0, $2119005918cddc33$export$d0605de541b472d8).cast({
            category: "deposits",
            isSimulated: true,
            otherParty: "Bank",
            id: ((_loanTransaction_tags = _loanTransaction.tags) === null || _loanTransaction_tags === void 0 ? void 0 : _loanTransaction_tags.linkedDepositTransctionId) || $2da686298e0b71ed$var$buildDerivedId(_loanTransaction.id, "deposit-loanRepayment"),
            date: _loanTransaction.date,
            description: _loanTransaction.description,
            accountId: depositAccountId,
            projectId: _loanTransaction.projectId,
            amount: accountCurrencyAmount * _loanTransaction.upbc,
            currency: depositAccount.currency,
            accountCurrencyAmount: accountCurrencyAmount,
            quantity: accountCurrencyAmount,
            upbc: _loanTransaction.upbc,
            upac: 1,
            uptc: uptc,
            fxAmount: fxAmount,
            fxCurrency: fxCurrency,
            label: "investment-loanRepayment",
            linkedTransactions: [
                {
                    id: _loanTransaction.id,
                    category: "loans",
                    tags: {
                        type: "transfer"
                    }
                }
            ],
            tags: {
                accountId: _loanTransaction.accountId,
                loanRepayment: {
                    principal: Math.abs(principalAccountCurrency),
                    interest: Math.abs(interestAccountCurrency)
                }
            }
        });
        return transaction;
    } catch (error) {
        console.error("simulatedLoanInstallmentView > transaction creation error for", _loanTransaction, error);
        console.info("simulatedLoanInstallmentView: depositAccount: ", depositAccount);
    }
    return null;
}
function $2da686298e0b71ed$export$b123009fad0a275(_loanTransactions, _loanAccounts, _depositAccounts, _quotes) {
    if (_loanAccounts.length === 0 || _depositAccounts.length === 0 || _loanTransactions.length === 0) return [];
    return _loanTransactions.filter((transaction)=>transaction.isSimulated).map((transaction)=>$2da686298e0b71ed$var$createCanonicalDepositLoanRepayment(transaction, _loanAccounts, _depositAccounts, _quotes)).filter(Boolean);
}


/* eslint-disable no-loop-func */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
const $9a12762f4ca7889e$var$selectorDebugEnabled = false;
function $9a12762f4ca7889e$var$findFirstValidQuote(quotes, date) {
    if (!quotes) return null;
    const entries = Object.entries(quotes);
    if (entries.length === 0) return null;
    if (date === undefined || date === null) return entries[0][1];
    for(let i = 0; i < entries.length; i += 1){
        const entryDate = Number(entries[i][0]);
        if (!Number.isNaN(entryDate) && entryDate > date) return entries[i][1];
    }
    return null;
}
function $9a12762f4ca7889e$export$8bdacbc6f88b684c(accounts, quotes) {
    const returnTransactions = [];
    // for each account construct single purchase transactions with quantity of 1
    accounts.forEach((account)=>{
        const { id: id, productPurchaseDate: productPurchaseDate, currency: currency } = account;
        // find the oldest quote for the account and use it as purchase's upac and upbc
        const firstValidQuote = $9a12762f4ca7889e$var$findFirstValidQuote(quotes[account.id], null); // accountId = assetId for pensions
        const { quote: quote, quoteBaseCurrency: quoteBaseCurrency } = firstValidQuote || {};
        const purchaseTransaction = {
            id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
            accountId: id,
            assetId: id,
            category: "pension",
            date: productPurchaseDate,
            quantity: 1,
            quantityOpen: 0,
            upac: quote || 0,
            accountCurrency: currency,
            assetCurrency: currency,
            upbc: quoteBaseCurrency || 0,
            uptc: null,
            transactionCurrency: null,
            isSimulated: false,
            projectId: null,
            linkedTransactions: [],
            tags: null,
            sortingOrderWithinMonth: null,
            description: `Pension purchase on ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(productPurchaseDate).format("YYYY-MM-DD")}`,
            label: "pension-purchase",
            isNotKpiRelevant: false
        };
        returnTransactions.push((0, $5ee4f29aaf60da17$export$45ff471291978734).cast(purchaseTransaction));
    });
    return returnTransactions;
}
function $9a12762f4ca7889e$var$parseTags(tags) {
    if (!tags) return {};
    if (typeof tags === "object") return tags;
    try {
        return JSON.parse(tags);
    } catch (error) {
        if ($9a12762f4ca7889e$var$selectorDebugEnabled) console.warn("pensionCashflowTransactions: could not parse transaction tags", tags, error);
        return {};
    }
}
function $9a12762f4ca7889e$export$aa22562ab88df8e9(transactions = [], pensionAccountIds = []) {
    const accountIdSet = new Set(pensionAccountIds);
    return (transactions || []).filter((transaction)=>{
        if (![
            "investment-contribution",
            "investment-pension"
        ].includes(transaction.label)) return false;
        const tags = $9a12762f4ca7889e$var$parseTags(transaction.tags);
        return accountIdSet.has(tags.accountId) || accountIdSet.has(tags.assetId);
    });
}
const $9a12762f4ca7889e$export$b2cccdcd27192b = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.pension.accounts;
}, (transactions, accounts)=>$9a12762f4ca7889e$export$aa22562ab88df8e9(transactions, (accounts || []).map((account)=>account.id)));
function $9a12762f4ca7889e$export$19ceb6f5bb1c826d(accounts = [], quotes = {}, endDate, inflationRate) {
    const returnTransactions = [];
    const monthlyInflationFactor = inflationRate ? 1 + inflationRate / 100 / 12 : 1;
    function indexByRate(amount, baseDate, targetDate, monthlyFactor) {
        if (!monthlyFactor || monthlyFactor === 1) return amount;
        const monthsDiff = Math.max(0, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(targetDate).startOf("month").diff((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(baseDate).startOf("month"), "month"));
        if (monthsDiff === 0) return amount;
        return amount * monthlyFactor ** monthsDiff;
    }
    // for each account construct a purchase transaction with quantity representing Present Value
    accounts.forEach((account)=>{
        var _account_initialQuotes_find, _account_initialQuotes_find1;
        // get from quotes, if not available, then from account.initialQuotes
        const { quote: quote, quoteBaseCurrency: quoteBaseCurrency } = $9a12762f4ca7889e$var$findFirstValidQuote(quotes[account.currency], null) || {};
        const { contributionsIndexed: contributionsIndexed, payoutsIndexed: payoutsIndexed } = account;
        // 251125 this was 1 / currentQBC and not just currentQBC
        // const upbc = (currentQBC && currentQBC !== 0 ? currentQBC : undefined) || account.initialQuotes.find((q) => q.type === account.useSpecialQuote)?.quoteBaseCurrency || 0;
        // THESE ARE CURRENT PAYOUTS (the current payout was already put into quote | quoteBaseCurrency by globalQuotesView)
        const upbc = quoteBaseCurrency || ((_account_initialQuotes_find = account.initialQuotes.find((q)=>q.type === account.useSpecialQuote)) === null || _account_initialQuotes_find === void 0 ? void 0 : _account_initialQuotes_find.quoteBaseCurrency) || 0;
        const upac = quote || ((_account_initialQuotes_find1 = account.initialQuotes.find((q)=>q.type === account.useSpecialQuote)) === null || _account_initialQuotes_find1 === void 0 ? void 0 : _account_initialQuotes_find1.quote) || 0;
        const connectedDepositAccountId = (account.connectedDepositAccounts || []).find(Boolean);
        // Cashflow transactions live on the connected deposit account. Without one there is
        // no canonical account where the contribution/payout can be represented.
        if (!connectedDepositAccountId) {
            console.warn("addSimulatedContributionsAndPayouts: no connectedDepositAccounts defined for account", account.name);
            return;
        }
        const templateTransaction = {
            id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
            accountId: connectedDepositAccountId,
            assetId: account.currency,
            category: "deposits",
            upac: upac,
            accountCurrency: account.currency,
            assetCurrency: account.currency,
            upbc: upbc,
            uptc: null,
            transactionCurrency: null,
            isSimulated: true,
            projectId: null,
            linkedTransactions: [],
            tags: {
                accountId: account.id,
                assetId: account.id
            },
            sortingOrderWithinMonth: null,
            otherParty: account.name
        };
        // contribution transactions
        if (account.contributionsSelfPaid) {
            let iterDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "month").startOf("month").valueOf(); // start today
            const sortedContributions = account.contributionsAmounts.sort((a, b)=>b.effectiveDate - a.effectiveDate); // DESC
            const contributionFrequencyMonths = Number(account.contributionsFrequency);
            const validContributionFrequency = Number.isFinite(contributionFrequencyMonths) && contributionFrequencyMonths > 0;
            // precalculate discount rate for contributions for the loop below
            const customIndexRate = Number(account.customDiscountRate);
            const monthlyCustomIndexFactor = Number.isFinite(customIndexRate) ? 1 + customIndexRate / 100 / 12 : 1;
            const contributionIndexFactor = account.discountRateIsInflation === false ? monthlyCustomIndexFactor : monthlyInflationFactor;
            let contributionLoopCounter = 0;
            while(iterDate < account.payoutsPhaseStart){
                const contribution = sortedContributions.filter((c)=>c.effectiveDate <= iterDate)[0];
                // only do indexing if account.contributionsIndexed is true
                const maybeIndexedContribution = account.contributionsIndexed ? indexByRate(Math.abs((contribution === null || contribution === void 0 ? void 0 : contribution.value) || 0), (contribution === null || contribution === void 0 ? void 0 : contribution.effectiveDate) || iterDate, iterDate, contributionIndexFactor) : (contribution === null || contribution === void 0 ? void 0 : contribution.value) || 0;
                const contributionTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, templateTransaction), {
                    date: iterDate,
                    // eslint-disable-next-line no-loop-func
                    quantity: -Math.abs(maybeIndexedContribution),
                    description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language === "de" ? "Beitrag" : "Contribution"} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(iterDate).format("YYYY-MM")}`,
                    label: "investment-contribution"
                });
                returnTransactions.push((0, $2119005918cddc33$export$d0605de541b472d8).cast(contributionTransaction));
                if (!validContributionFrequency) break; // one-time or invalid frequency -> emit one item and stop
                iterDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(iterDate).add(contributionFrequencyMonths, "month").startOf("month").valueOf();
                contributionLoopCounter += 1;
                if (contributionLoopCounter > 10000) {
                    if ($9a12762f4ca7889e$var$selectorDebugEnabled) console.error("addSimulatedContributionsAndPayouts: contribution loop limit reached, aborting loop", account.id);
                    break;
                }
            }
        }
        // payout transactions
        if (account.payoutsPhaseStart < endDate) {
            let iterDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(account.payoutsPhaseStart).startOf("month").valueOf();
            // payoutsDuration of 0 is indefinite
            const payoutsDuration = account.payoutsDuration === 0 ? Number.POSITIVE_INFINITY : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(account.payoutsPhaseStart).add(account.payoutsDuration, "month").startOf("month").valueOf();
            const payoutsFrequencyMonths = Number(account.payoutsFrequency);
            const validPayoutsFrequency = Number.isFinite(payoutsFrequencyMonths) && payoutsFrequencyMonths > 0;
            // precalculate payout discount rate
            const customIndexRate = Number(account.customDiscountRate);
            const monthlyCustomIndexFactor = Number.isFinite(customIndexRate) ? 1 + customIndexRate / 100 / 12 : 1;
            const payoutsIndexFactor = account.discountRateIsInflation === false ? monthlyCustomIndexFactor : monthlyInflationFactor;
            // incl. endDate, because when user moves the slider, we want to show the payout for the month of the slider date
            // excl. payoutDuration, because the user expects 12 payments with payment duration of 12 months, and we start in month 0
            let payoutsLoopCounter = 0;
            while(iterDate <= endDate && iterDate < payoutsDuration){
                const payoutTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, templateTransaction), {
                    date: iterDate,
                    quantity: 1,
                    upac: payoutsIndexed ? indexByRate(upac, account.payoutsPhaseStart, iterDate, payoutsIndexFactor) : upac,
                    upbc: payoutsIndexed ? indexByRate(upbc, account.payoutsPhaseStart, iterDate, payoutsIndexFactor) : upbc,
                    description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language === "de" ? "Auszahlung" : "Payout"} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(iterDate).format("YYYY-MM")}`,
                    label: "investment-pension"
                });
                returnTransactions.push((0, $2119005918cddc33$export$d0605de541b472d8).cast(payoutTransaction));
                if (!validPayoutsFrequency) break; // one-time or invalid frequency -> emit one item and stop
                iterDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(iterDate).add(payoutsFrequencyMonths, "month").startOf("month").valueOf();
                payoutsLoopCounter += 1;
                if (payoutsLoopCounter > 10000) {
                    if ($9a12762f4ca7889e$var$selectorDebugEnabled) console.error("addSimulatedContributionsAndPayouts: payout loop limit reached, aborting loop", account.id);
                    break;
                }
            }
        }
    });
    return returnTransactions;
}
const $9a12762f4ca7889e$export$e59b728dc06f12a7 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.pension.accounts;
}, $93bb2798871a68d2$export$443f4a6ebd922e0a, (accounts, quotes)=>$9a12762f4ca7889e$export$8bdacbc6f88b684c(accounts || [], quotes || {}));
const $9a12762f4ca7889e$export$7dac82169417f31a = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.pension.accounts;
}, $93bb2798871a68d2$export$443f4a6ebd922e0a, (accounts, quotes)=>$9a12762f4ca7889e$export$8bdacbc6f88b684c(accounts || [], quotes || {}));


const $a368196802fe263c$var$createSelectorWithDebug = (0, $5c22629b42831e80$export$5943f4447f6ef248)((0, $58b9680bf8a527fb$export$281bff7f05488aa2), // eslint-disable-next-line arrow-body-style
(a, b)=>{
    console.log("Comparing:", a, b); // Log the values being compared
    return a === b; // Use the default equality check
});
const $a368196802fe263c$export$a0f784ff3febaef1 = (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.accounts;
};
function $a368196802fe263c$var$parseTags(tags) {
    return typeof tags === "string" ? JSON.parse(tags) : tags || {};
}
function $a368196802fe263c$var$getTransactionSign(transaction) {
    const numericValue = [
        transaction === null || transaction === void 0 ? void 0 : transaction.quantity,
        transaction === null || transaction === void 0 ? void 0 : transaction.accountCurrencyAmount,
        transaction === null || transaction === void 0 ? void 0 : transaction.amount
    ].find((value)=>typeof value === "number" && value !== 0);
    return numericValue && numericValue < 0 ? -1 : 1;
}
function $a368196802fe263c$export$6a96360fdc4b7269(transaction) {
    var _tags_loanRepayment, _tags_loanRepayment1;
    const tags = $a368196802fe263c$var$parseTags(transaction === null || transaction === void 0 ? void 0 : transaction.tags);
    const principal = Math.abs(Number(tags === null || tags === void 0 ? void 0 : (_tags_loanRepayment = tags.loanRepayment) === null || _tags_loanRepayment === void 0 ? void 0 : _tags_loanRepayment.principal) || 0);
    const interest = Math.abs(Number(tags === null || tags === void 0 ? void 0 : (_tags_loanRepayment1 = tags.loanRepayment) === null || _tags_loanRepayment1 === void 0 ? void 0 : _tags_loanRepayment1.interest) || 0);
    return {
        tags: tags,
        principal: principal,
        interest: interest
    };
}
function $a368196802fe263c$export$91d06a5dc61bc5ed(transaction) {
    var _parseTags;
    return (transaction === null || transaction === void 0 ? void 0 : transaction.label) === "investment-loanRepayment" && !!((_parseTags = $a368196802fe263c$var$parseTags(transaction === null || transaction === void 0 ? void 0 : transaction.tags)) === null || _parseTags === void 0 ? void 0 : _parseTags.loanRepayment);
}
function $a368196802fe263c$var$createSplitDepositTransaction(transaction, splitLabel, quantityAbsolute, isInterest = false) {
    if (!quantityAbsolute) return null;
    const sign = $a368196802fe263c$var$getTransactionSign(transaction);
    const quantity = sign * quantityAbsolute;
    const upbc = Number(transaction === null || transaction === void 0 ? void 0 : transaction.upbc) || 0;
    const uptc = Number(transaction === null || transaction === void 0 ? void 0 : transaction.uptc) || 0;
    const tags = $a368196802fe263c$var$parseTags(transaction === null || transaction === void 0 ? void 0 : transaction.tags);
    return (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
        id: `${transaction.id}:${splitLabel}`,
        sourceTransactionId: transaction.id,
        label: splitLabel,
        quantity: quantity,
        accountCurrencyAmount: quantity,
        amount: quantity * upbc,
        fxAmount: uptc ? quantity * uptc : transaction === null || transaction === void 0 ? void 0 : transaction.fxAmount,
        tags: (0, $2qxEV._)((0, $9tqwB._)({}, tags), {
            loanRepayment: {
                principal: isInterest ? 0 : quantityAbsolute,
                interest: isInterest ? quantityAbsolute : 0
            }
        })
    });
}
function $a368196802fe263c$export$75c4781769918a59(transactions = []) {
    return (transactions || []).flatMap((transaction)=>{
        if (!$a368196802fe263c$export$91d06a5dc61bc5ed(transaction)) return [
            transaction
        ];
        const { principal: principal, interest: interest } = $a368196802fe263c$export$6a96360fdc4b7269(transaction);
        const splitTransactions = [
            $a368196802fe263c$var$createSplitDepositTransaction(transaction, "investment-loanPrincipal", principal),
            $a368196802fe263c$var$createSplitDepositTransaction(transaction, "investment-loanInterest", interest, true)
        ].filter(Boolean);
        return splitTransactions.length > 0 ? splitTransactions : [
            transaction
        ];
    });
}
function $a368196802fe263c$export$f77ea077e2b33bcb(accounts, accountId) {
    const targetAccount = accounts.find((account)=>account.id === accountId);
    const tags = typeof (targetAccount === null || targetAccount === void 0 ? void 0 : targetAccount.tags) === "string" ? JSON.parse(targetAccount === null || targetAccount === void 0 ? void 0 : targetAccount.tags) : targetAccount === null || targetAccount === void 0 ? void 0 : targetAccount.tags;
    return (tags === null || tags === void 0 ? void 0 : tags.growthRate) || 0;
}
function $a368196802fe263c$var$getSaldoObjectPerAccountId(accountTransactions, date) {
    var _combinedTransactions_;
    const transactionsInScope = accountTransactions;
    // this returns an object (!) { projectId1: [], projectId2: [], null: [] }
    const combinedTransactions = [];
    Object.values(transactionsInScope).forEach((projectTransaction)=>{
        const filteredTransactions = projectTransaction.filter((tx)=>tx.date <= date);
        combinedTransactions.push(...filteredTransactions);
    });
    const quantity = combinedTransactions.reduce((prev, curr)=>prev + curr.quantity, 0);
    return {
        quantity: quantity,
        currency: (_combinedTransactions_ = combinedTransactions[0]) === null || _combinedTransactions_ === void 0 ? void 0 : _combinedTransactions_.currency
    };
}
// returns an array of all projects with their position in a given stock on a given account, on a given date
function $a368196802fe263c$var$getBalanceObjectPerProjectId(accountTransactionsPerProjectId, date) {
    // returns an array with { projectId, quantity, upac, upbc, currency }
    const returnObject = [];
    Object.entries(accountTransactionsPerProjectId).forEach(([projectId, projectTransactions])=>{
        const filteredTransactions = projectTransactions.filter((tx)=>tx.date <= date);
        // const amount = filteredTransactions.reduce((prev, curr) => prev + curr.amount, 0);
        // const accountCurrencyAmount = filteredTransactions.reduce((prev, curr) => prev + curr.accountCurrencyAmount, 0);
        const quantity = filteredTransactions.reduce((prev, curr)=>prev + curr.quantity, 0);
        returnObject.push({
            projectId: projectId,
            quantity: quantity,
            upac: 1,
            upbc: projectTransactions.at(-1).upbc,
            currency: projectTransactions[0].currency
        });
    });
    return returnObject;
}
function $a368196802fe263c$export$639f3abbcc648734(baseDate, baseCurrency, quotes, sliderEndDate, depositTransactions, accounts, projectMode = false) {
    if (!depositTransactions || depositTransactions.length === 0) return [];
    // generate a list of years in scope, starting with now() and ending with slider date
    const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "month").add(1, "year").startOf("month").valueOf(); // start of next month
    const years = [
        startDate
    ];
    let year = startDate;
    while(years.at(-1) < (projectMode ? sliderEndDate : baseDate)){
        year = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(year).add(1, "year").valueOf();
        years.push(year);
    }
    // generate a view of deposits transactions grouped by accountId and projectId
    const depositsTransactionsObject = (0, $3e6d58b7292c657b$export$3f063810d7bf01bd)(depositTransactions || [], [
        "accountId",
        "projectId"
    ]);
    // { accountId1: { projectId1: [], projectId2: [], null: [] }, accountId2: ... }
    const simulatedInterestTransactions = [];
    years.forEach((date)=>{
        // for each account, for each project, calculate the position by project on a given date
        Object.keys(depositsTransactionsObject).forEach((accountId)=>{
            const projectBalanceObjectsThisAccount = $a368196802fe263c$var$getBalanceObjectPerProjectId(depositsTransactionsObject[accountId], date); // returns an array with { projectId, quantity, upac, upbc, currency }
            // handle account overdraft: https://monestry.atlassian.net/l/cp/ronMFZKM
            // calculate overall account balance on the given date (to manage overdraft caused by parallel projects)
            const currentAccountBalanceObject = $a368196802fe263c$var$getSaldoObjectPerAccountId(depositsTransactionsObject[accountId], date); // returns an array with { quantity, currency }
            projectBalanceObjectsThisAccount.forEach((projectBalanceObject)=>{
                // add simulated interest generated in previous loops to current account balance
                const simulatedInterestTransactionsBalance = simulatedInterestTransactions.filter((tx)=>tx.accountId === accountId && tx.projectId === projectBalanceObject.projectId).reduce((prev, curr)=>({
                        quantity: prev.quantity + curr.quantity
                    }), {
                    quantity: 0
                });
                // console.log('simulatedInterestTransactionsBalance', simulatedInterestTransactionsBalance);
                // the total balance on a given date is the smallest of the two balances - the one from current project and the one from the account + interest
                const currentBalanceQuantity = Math.min(currentAccountBalanceObject.quantity, projectBalanceObject.quantity) + simulatedInterestTransactionsBalance.quantity;
                const quantity = Math.max(currentBalanceQuantity, 0) * ($a368196802fe263c$export$f77ea077e2b33bcb(accounts, accountId) / 100); // see comment above currentAccountBalance definition
                // TODO PRD-1409
                // WORKAROUND: if baseCurrency is not currency, use CURRENT exchange rate from quotes
                const { currency: currency } = projectBalanceObject;
                let upbc = 1;
                if (currency !== baseCurrency) {
                    var _quotes_currency_current, _quotes_currency;
                    // upbc is by what do we need to multiply quantity (of account currency) to get base currency
                    // quoteBaseCurrency is how much is 1 unit of baseCurrency in currency, e.g. for USD it is 0.92
                    // as fallback take the most current upbc that was found by getBalanceObjectPerProjectId
                    const currentQBC = (_quotes_currency = quotes[currency]) === null || _quotes_currency === void 0 ? void 0 : (_quotes_currency_current = _quotes_currency.current) === null || _quotes_currency_current === void 0 ? void 0 : _quotes_currency_current.quoteBaseCurrency;
                    upbc = (currentQBC && currentQBC !== 0 ? 1 / currentQBC : undefined) || projectBalanceObject.upbc;
                }
                if (quantity === 0) return; // no interest to be paid
                const newTransaction = {
                    category: "deposits",
                    projectId: projectBalanceObject.projectId,
                    upac: 1,
                    upbc: upbc,
                    amount: quantity * upbc,
                    currency: currency,
                    quantity: quantity,
                    transactionCurrency: currency,
                    accountCurrency: currency,
                    assetId: currency,
                    accountId: accountId,
                    id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                    date: date,
                    otherParty: (0, $2Bwgd.t)("projects:simulated"),
                    otherPartyAccount: (0, $2Bwgd.t)("projects:simulated"),
                    isSimulated: true,
                    description: `${(0, $2Bwgd.t)("projects:interestPayment")} ${currentBalanceQuantity.toFixed(2)} ${projectBalanceObject.currency}`,
                    label: "investment-interest",
                    tags: {
                        type: "inflow",
                        recurring: {
                            activated: false
                        },
                        interestPayment: true,
                        nonEditable: true
                    }
                };
                simulatedInterestTransactions.push(newTransaction);
            });
        });
    });
    // console.log('simulatedInterestTransactions', simulatedInterestTransactions);
    return simulatedInterestTransactions;
}
const $a368196802fe263c$export$3c400324181e2c4d = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.simulatedTransactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.accounts;
}, $cfd21bc923628483$export$9890c99050a7d78e, $2da686298e0b71ed$export$a856f17095d848d7, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.loans.accounts;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.pension.accounts;
}, (state)=>state.data.stocks.settings, $93bb2798871a68d2$export$443f4a6ebd922e0a, (state)=>state.user.profile.settings.baseCurrency, (state)=>state.simulation, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (state)=>state.projects, function depositTransactionsCallback(transactions, simulatedTransactions, accounts, stocksTransactions, loanTransactions, loanAccounts, pensionAccounts, stockSettings, quotes, baseCurrency, simulation, inflationRate, sliderMax, projects) {
    const timer = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().valueOf();
    // if this is project mode, inject transactions below
    let transactionsUnpacked = transactions; // normally return plain simple transactions
    // in project mode inject simulated transactions and unpack the recurring ones
    if ((simulation === null || simulation === void 0 ? void 0 : simulation.dashboardMode) === "projects") {
        const { baseDate: baseDate } = simulation;
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        // exclude isolated projects (only show the global view)
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        // "unpack" recurring transactions
        const projectDepositTransactionsUntilSliderDateWithRecurring = transactions.concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate).flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
        // calculate simulated interest payment transactions
        const interestPaymentTransactions = projectDepositTransactionsUntilSliderDateWithRecurring.concat($a368196802fe263c$export$639f3abbcc648734(baseDate, baseCurrency, quotes, sliderMax, projectDepositTransactionsUntilSliderDateWithRecurring, accounts, false));
        // calculate simulated dividend payment transactions
        const pastDividendTransactions = projectDepositTransactionsUntilSliderDateWithRecurring.filter((transaction)=>transaction.label === "investment-dividend");
        const dividendTransactions = $cfd21bc923628483$export$43a53681be4a3813(stocksTransactions, stockSettings, pastDividendTransactions, accounts, quotes, baseDate, sliderMax, baseCurrency, false) || [];
        // calculate simulated loan installments
        const loanInstallmentTransactions = $2da686298e0b71ed$export$b123009fad0a275(loanTransactions, loanAccounts, /* deposit */ accounts, quotes);
        // calculate simulated pension contributions and payouts
        const pensionContributionsAndPayouts = $9a12762f4ca7889e$export$19ceb6f5bb1c826d(pensionAccounts, quotes, baseDate, inflationRate);
        // concatenate all results
        transactionsUnpacked = projectDepositTransactionsUntilSliderDateWithRecurring.concat(interestPaymentTransactions).concat(dividendTransactions).concat(loanInstallmentTransactions).concat(pensionContributionsAndPayouts);
    }
    // apply FIFO to all transactions, one accountId after another
    // CAUTION: deposit accounts can have a negative balance; if that is the case, FIFO must run in reverseMode
    const uniqueAccountIds = Array.from(new Set(transactionsUnpacked.map((tr)=>tr.accountId)));
    const finalArray = [];
    uniqueAccountIds.forEach((accountId)=>{
        const transactionsForAccount = transactionsUnpacked.filter((tr)=>tr.accountId === accountId);
        const transactionsAfterFifo = (0, $3f04f8f675be2f21$export$2e2bcd8739ae039)(transactionsForAccount);
        finalArray.push(transactionsForAccount.map((tr)=>(0, $2qxEV._)((0, $9tqwB._)({}, tr), {
                quantityOpen: transactionsAfterFifo.find((tx)=>tx.id === tr.id) ? transactionsAfterFifo.find((tx)=>tx.id === tr.id).quantity : 0
            })));
    });
    return finalArray.flat();
});
const $a368196802fe263c$export$5b39d5dbd8cf02b3 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.simulatedTransactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.accounts;
}, $cfd21bc923628483$export$2b812e2009c0324e, $2da686298e0b71ed$export$7180e5e29ddd79ea, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.loans.accounts;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.pension.accounts;
}, (state)=>state.data.stocks.settings, $93bb2798871a68d2$export$443f4a6ebd922e0a, (state)=>state.user.profile.settings.baseCurrency, (state)=>state.simulation, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, function depositTransactionsProjectViewCallback(transactions, simulatedTransactions, accounts, stocksTransactions, loanTransactions, loanAccounts, pensionAccounts, stockSettings, quotes, baseCurrency, simulation, inflationRate, sliderMax) {
    // if this is project mode, inject transactions below
    if ((simulation === null || simulation === void 0 ? void 0 : simulation.dashboardMode) === "projects") {
        const { baseDate: baseDate } = simulation;
        const projectDepositTransactionsUntilSliderDateWithRecurring = transactions.concat(simulatedTransactions)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
        // add simulated interest payment transactions
        const interestPaymentTransactions = $a368196802fe263c$export$639f3abbcc648734(baseDate, baseCurrency, quotes, sliderMax, projectDepositTransactionsUntilSliderDateWithRecurring, accounts, true);
        const currentDividendTransactions = projectDepositTransactionsUntilSliderDateWithRecurring.filter((transaction)=>transaction.label === "investment-dividend");
        const dividendTransactions = $cfd21bc923628483$export$43a53681be4a3813(stocksTransactions, stockSettings, currentDividendTransactions, accounts, quotes, baseDate, sliderMax, baseCurrency, true) || [];
        // calculate simulated loan installments
        const loanInstallmentTransactions = $2da686298e0b71ed$export$b123009fad0a275(loanTransactions, loanAccounts, /* deposit */ accounts, quotes);
        // calculate simulated pension contributions and payouts
        const pensionContributionsAndPayouts = $9a12762f4ca7889e$export$19ceb6f5bb1c826d(pensionAccounts, quotes, sliderMax, inflationRate);
        return projectDepositTransactionsUntilSliderDateWithRecurring.concat(interestPaymentTransactions).concat(dividendTransactions).concat(loanInstallmentTransactions).concat(pensionContributionsAndPayouts);
    }
    // otherwise return plain simple transactions
    return transactions;
});
const $a368196802fe263c$export$a8a56b40f5a06885 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($a368196802fe263c$export$3c400324181e2c4d, (transactions)=>$a368196802fe263c$export$75c4781769918a59(transactions));
const $a368196802fe263c$export$c3326d1eadff13bd = [
    "investment-fees",
    "investment-dividend",
    "investment-interest",
    "investment-costs",
    "investment-rent",
    "investment-loanInterest",
    "investment-pension"
];
const $a368196802fe263c$export$c58f7ddceaf8469f = [
    "investment-dividend",
    "investment-interest",
    "investment-rent",
    "investment-pension"
];
const $a368196802fe263c$export$47220dfe2b0dcc85 = [
    "investment-fees",
    "investment-costs",
    "investment-loanInterest"
];
const $a368196802fe263c$export$f19fca8543b3ca7c = (state)=>$a368196802fe263c$export$a8a56b40f5a06885(state).reduce((prev, curr)=>prev + ($a368196802fe263c$export$c3326d1eadff13bd.includes(curr.label) && curr.date >= $93bb2798871a68d2$export$baf5c2f62dd5cf3e(state) ? curr.quantity * curr.upbc || 0 : 0), 0);
const $a368196802fe263c$export$90f1014fd5819cb6 = (state)=>$a368196802fe263c$export$a8a56b40f5a06885(state).reduce((prev, curr)=>prev + ($a368196802fe263c$export$c3326d1eadff13bd.includes(curr.label) && curr.date <= $93bb2798871a68d2$export$baf5c2f62dd5cf3e(state) && curr.date >= $93bb2798871a68d2$export$80e72cf626efa9e8(state) ? curr.quantity * curr.upbc || 0 : 0), 0);
const $a368196802fe263c$export$57f29db9c40dbad7 = (state)=>$a368196802fe263c$export$3c400324181e2c4d(state).filter((transaction)=>{
        var _transaction_label;
        return transaction.quantity < 0 && ((_transaction_label = transaction.label) === null || _transaction_label === void 0 ? void 0 : _transaction_label.split("-")[0]) !== "investment" && transaction.date >= $93bb2798871a68d2$export$baf5c2f62dd5cf3e(state);
    }).reduce((acc, curr)=>acc + curr.quantity * curr.upbc, 0);
const $a368196802fe263c$export$43c37cdbf008db07 = (state)=>$a368196802fe263c$export$3c400324181e2c4d(state).filter(// eslint-disable-next-line max-len
    (transaction)=>{
        var _transaction_label;
        return transaction.quantity < 0 && ((_transaction_label = transaction.label) === null || _transaction_label === void 0 ? void 0 : _transaction_label.split("-")[0]) !== "investment" && transaction.date < $93bb2798871a68d2$export$baf5c2f62dd5cf3e(state) && transaction.date >= $93bb2798871a68d2$export$80e72cf626efa9e8(state);
    }).reduce((acc, curr)=>acc + curr.quantity * curr.upbc, 0);
const $a368196802fe263c$export$61408e9de6c25330 = (state)=>$a368196802fe263c$export$3c400324181e2c4d(state).filter((transaction)=>{
        var _transaction_label;
        return transaction.quantity > 0 && ((_transaction_label = transaction.label) === null || _transaction_label === void 0 ? void 0 : _transaction_label.split("-")[0]) !== "investment" && transaction.date >= $93bb2798871a68d2$export$baf5c2f62dd5cf3e(state);
    }).reduce((acc, curr)=>acc + curr.quantity * curr.upbc, 0);
const $a368196802fe263c$export$1882d03801ff41ff = (state)=>$a368196802fe263c$export$3c400324181e2c4d(state).filter(// eslint-disable-next-line max-len
    (transaction)=>{
        var _transaction_label;
        return transaction.quantity > 0 && ((_transaction_label = transaction.label) === null || _transaction_label === void 0 ? void 0 : _transaction_label.split("-")[0]) !== "investment" && transaction.date < $93bb2798871a68d2$export$baf5c2f62dd5cf3e(state) && transaction.date >= $93bb2798871a68d2$export$80e72cf626efa9e8(state);
    }).reduce((acc, curr)=>acc + curr.quantity * curr.upbc, 0);



/* eslint-disable no-unsafe-optional-chaining */ 


const $5b51de6ffad59fa2$export$5948b786dea4615d = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.realEstate.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.realEstate.simulatedTransactions;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.baseDate;
}, (state)=>state.projects, (dashboardMode, transactions, simulatedTransactions, baseDate, projects)=>{
    let returnTransactions;
    if (dashboardMode === "projects") {
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        returnTransactions = (transactions || []).concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate);
    // no recurring transactions in real estate
    } else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
const $5b51de6ffad59fa2$export$55799b72fb34a5ff = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.realEstate.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.realEstate.simulatedTransactions;
}, (dashboardMode, transactions, simulatedTransactions)=>{
    let returnTransactions;
    if (dashboardMode === "projects") returnTransactions = (transactions || []).concat(simulatedTransactions);
    else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});




/* eslint-disable no-unsafe-optional-chaining */ 


const $1b6cd2b52ee96621$export$2802f167dacb0091 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.objectsOfValue.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.objectsOfValue.simulatedTransactions;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.baseDate;
}, (state)=>state.projects, (dashboardMode, transactions, simulatedTransactions, baseDate, projects)=>{
    let returnTransactions;
    if (dashboardMode === "projects") {
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        returnTransactions = (transactions || []).concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate);
    // no recurring transactions in real estate
    } else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
const $1b6cd2b52ee96621$export$76cb96f9bf81e0e2 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.objectsOfValue.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.objectsOfValue.simulatedTransactions;
}, (dashboardMode, transactions, simulatedTransactions)=>{
    let returnTransactions;
    if (dashboardMode === "projects") returnTransactions = (transactions || []).concat(simulatedTransactions);
    else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});


/* eslint-disable no-unsafe-optional-chaining */ 


const $4678812afdc6b9f3$export$4efad9798dd0814e = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.metals.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.metals.simulatedTransactions;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.baseDate;
}, (state)=>state.projects, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (dashboardMode, transactions, simulatedTransactions, baseDate, projects, inflationRate, sliderMax)=>{
    let returnTransactions;
    if (dashboardMode === "projects") {
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        returnTransactions = (transactions || []).concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    } else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
const $4678812afdc6b9f3$export$41a7f8bac262ffd7 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.metals.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.metals.simulatedTransactions;
}, (state)=>state.simulation.baseDate, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (dashboardMode, transactions, simulatedTransactions, baseDate, inflationRate, sliderMax)=>{
    let returnTransactions;
    if (dashboardMode === "projects") returnTransactions = (transactions || []).concat(simulatedTransactions)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
    .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
function $4678812afdc6b9f3$export$d7433174c0f03d48(assetName) {
    // only leave letters and numbers, strip and trim everything else
    return assetName.replace(/[^a-zA-Z0-9]/g, "");
}
const $4678812afdc6b9f3$export$7a3c3d42e4d75513 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data.metals.transactions, (state)=>state.data.metals.simulatedTransactions, ($transactions, $simulatedTransactions)=>{
    // get all distinct combinations of assetName+assetMetal+assetPurity+assetAdditionalValue from ($transactions.concat($simulatedTransactions) || [])
    // omitting assetId because it is derived from assetName
    const uniqueCombinationsSet = new Set(($transactions.concat($simulatedTransactions) || []).map((item)=>`${item.assetName}|${item.assetMetal}|${item.assetWeight}|${item.assetPurity}|${item.assetAdditionalValue}`));
    // Convert Set to Array to get an array of unique combinations
    return Array.from(uniqueCombinationsSet).map((item)=>{
        const [assetName, assetMetal, assetWeight, assetPurity, assetAdditionalValue] = item.split("|");
        return {
            assetId: $4678812afdc6b9f3$export$d7433174c0f03d48(assetName),
            assetName: assetName,
            assetMetal: assetMetal,
            assetWeight: assetWeight,
            assetPurity: assetPurity,
            assetAdditionalValue: assetAdditionalValue
        };
    });
});


/* eslint-disable no-unsafe-optional-chaining */ 


const $84bd2b1e91f81d86$export$ef749c62f1718a7c = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.unlistedShares.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.unlistedShares.simulatedTransactions;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.baseDate;
}, (state)=>state.projects, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (dashboardMode, transactions, simulatedTransactions, baseDate, projects, inflationRate, sliderMax)=>{
    let returnTransactions;
    if (dashboardMode === "projects") {
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        returnTransactions = (transactions || []).concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    } else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
const $84bd2b1e91f81d86$export$d0d239d974aae3cd = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.unlistedShares.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.unlistedShares.simulatedTransactions;
}, (state)=>state.simulation.baseDate, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, (dashboardMode, transactions, simulatedTransactions, baseDate, inflationRate, sliderMax)=>{
    let returnTransactions;
    if (dashboardMode === "projects") returnTransactions = (transactions || []).concat(simulatedTransactions)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
    .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});


/* eslint-disable no-unsafe-optional-chaining */ 


const $e815710920e23f12$export$82f53777bf39b5c0 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.crypto.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.crypto.simulatedTransactions;
}, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.baseDate;
}, (state)=>state.projects, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, function cryptoTransactionsCallback(dashboardMode, transactions, simulatedTransactions, baseDate, projects, inflationRate, sliderMax) {
    let returnTransactions;
    if (dashboardMode === "projects") {
        const isolatedProjects = projects === null || projects === void 0 ? void 0 : projects.filter((project)=>{
            var _project_settings;
            return (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated;
        }).map((project)=>project.id);
        const simulatedTransactionsWithoutIsolated = simulatedTransactions.filter((txn)=>!isolatedProjects.includes(txn.projectId));
        returnTransactions = (transactions || []).concat(simulatedTransactionsWithoutIsolated).filter((transaction)=>transaction.date <= baseDate)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
        .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    } else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
const $e815710920e23f12$export$5ccb67b3d1fd124c = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.crypto.transactions;
}, (state)=>{
    var _state_data;
    return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.crypto.simulatedTransactions;
}, (state)=>state.simulation.baseDate, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.inflationRate;
}, (state)=>{
    var _state_user;
    return (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.profile.settings.sliderEndDate;
}, function cryptoTransactionsProjectViewCallback(dashboardMode, transactions, simulatedTransactions, baseDate, inflationRate, sliderMax) {
    let returnTransactions;
    if (dashboardMode === "projects") returnTransactions = (transactions || []).concat(simulatedTransactions)// unpack recurring transactions by creating transactions for every recurring transaction (never = until the end of slider)
    .flatMap((txn)=>$93bb2798871a68d2$export$19feb4affb158dd5(inflationRate, baseDate, sliderMax, txn));
    else returnTransactions = transactions || [];
    return (0, $3e6d58b7292c657b$export$222ac7622a28f480)(returnTransactions);
});
function $e815710920e23f12$export$846f38b287dbd57e(assetName) {
    // only leave letters and numbers, strip and trim everything else
    return assetName.replace(/[^a-zA-Z0-9]/g, "");
}
const $e815710920e23f12$export$f339a7f853313e14 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data.crypto.transactions, (state)=>state.data.crypto.simulatedTransactions, function cryptoMetadataCallback($transactions, $simulatedTransactions) {
    const displaySymbolByAssetId = {};
    const assetIdByDisplaySymbol = {};
    const providerAssetIdByDisplaySymbol = {};
    const displayNameByDisplaySymbol = {};
    // include all transactions (also those beyond the slider date)
    ($transactions.concat($simulatedTransactions) || []).forEach((transaction)=>{
        const { assetId: assetId, displaySymbol: displaySymbol, displayName: displayName, providerAssetId: providerAssetId } = transaction;
        // before updating check if the updated value is null (and do not update if it is)
        // Update assetId object
        if (!displaySymbolByAssetId[assetId] || displaySymbol) displaySymbolByAssetId[assetId] = displaySymbol;
        // Update displaySymbols object
        if (!assetIdByDisplaySymbol[displaySymbol] || assetId) assetIdByDisplaySymbol[displaySymbol] = assetId;
        // Update displaySymbols object
        if (!providerAssetIdByDisplaySymbol[displaySymbol] || providerAssetId) providerAssetIdByDisplaySymbol[displaySymbol] = providerAssetId;
        // Update displayNames object
        if (!displayNameByDisplaySymbol[displaySymbol] || displayName) displayNameByDisplaySymbol[displaySymbol] = displayName;
    });
    // displaySymbolByAssetId: { assetId1: displaySymbol1, assetId2: displaySymbol2, ... }
    // assetIdByDisplaySymbol: { displaySymbol1: figi1, displaySymbol2: figi2, ... }
    // providerAssetIdByDisplaySymbol: { displaySymbol1: providerAssetId1, displaySymbol2: providerAssetId2, ... }
    // displayNameByDisplaySymbol: { displaySymbol1: displayName1, displaySymbol2: displayName2, ... }
    return {
        displaySymbolByAssetId: displaySymbolByAssetId,
        assetIdByDisplaySymbol: assetIdByDisplaySymbol,
        providerAssetIdByDisplaySymbol: providerAssetIdByDisplaySymbol,
        displayNameByDisplaySymbol: displayNameByDisplaySymbol
    };
});





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $3679aa7475d9bd44$var$debugLevel = 0;
const $3679aa7475d9bd44$var$projectPerfDebugEnabled = false;
function $3679aa7475d9bd44$var$parseIf(str) {
    if (typeof str === "object") return str;
    return JSON.parse(str);
}
const $3679aa7475d9bd44$var$logSelectorChanges = (name, previousInputs, currentInputs)=>{
    previousInputs.forEach((previousInput, index)=>{
        const currentInput = currentInputs[index];
        if (previousInput !== currentInput) console.log(`${name} > Input selector ${index + 1} has changed.`);
    });
};
function $3679aa7475d9bd44$export$6d68928c2b6ce1a6(state) {
    const deposits = (0, $a368196802fe263c$export$3c400324181e2c4d)(state);
    const stocks = (0, $cfd21bc923628483$export$9890c99050a7d78e)(state);
    const realEstate = (0, $5b51de6ffad59fa2$export$5948b786dea4615d)(state);
    const loans = (0, $2da686298e0b71ed$export$a856f17095d848d7)(state);
    const pension = (0, $9a12762f4ca7889e$export$e59b728dc06f12a7)(state);
    const objectsOfValue = (0, $1b6cd2b52ee96621$export$2802f167dacb0091)(state);
    const metals = (0, $4678812afdc6b9f3$export$4efad9798dd0814e)(state);
    const unlistedShares = (0, $84bd2b1e91f81d86$export$ef749c62f1718a7c)(state);
    const crypto = (0, $e815710920e23f12$export$82f53777bf39b5c0)(state);
    return deposits.concat(stocks, realEstate, loans, objectsOfValue, metals, unlistedShares, crypto).concat(pension.filter((t)=>t.label === "pension-purchase"));
// only pension-purchase transactions should be used to calculate net worth (contributions and payouts do not influence its present value)
}
// returns an array of all transactions until the simulation (slider) END DATE
// the recurring / interest / dividend transactions will be created until END DATE
// regardless of the project end date
const $3679aa7475d9bd44$var$allTransactionsProjectViewMemoized = (0, $5c22629b42831e80$export$595d22ed68ca2841)((0, $a368196802fe263c$export$5b39d5dbd8cf02b3), (0, $cfd21bc923628483$export$2b812e2009c0324e), (0, $5b51de6ffad59fa2$export$55799b72fb34a5ff), (0, $2da686298e0b71ed$export$7180e5e29ddd79ea), (0, $9a12762f4ca7889e$export$7dac82169417f31a), (0, $1b6cd2b52ee96621$export$76cb96f9bf81e0e2), (0, $4678812afdc6b9f3$export$41a7f8bac262ffd7), (0, $84bd2b1e91f81d86$export$d0d239d974aae3cd), (0, $e815710920e23f12$export$5ccb67b3d1fd124c), (deposits, stocks, realEstate, loans, pension, objectsOfValue, metals, unlistedShares, crypto)=>{
    const timerStart = $3679aa7475d9bd44$var$projectPerfDebugEnabled ? Date.now() : null;
    const output = deposits.concat(stocks, realEstate, loans, pension, objectsOfValue, metals, unlistedShares, crypto);
    if ($3679aa7475d9bd44$var$projectPerfDebugEnabled) console.info("PERF allTransactionsProjectView", {
        durationMs: Date.now() - timerStart,
        total: output.length,
        deposits: deposits.length,
        stocks: stocks.length,
        realEstate: realEstate.length,
        loans: loans.length,
        pension: pension.length,
        objectsOfValue: objectsOfValue.length,
        metals: metals.length,
        unlistedShares: unlistedShares.length,
        crypto: crypto.length
    });
    return output;
});
function $3679aa7475d9bd44$export$cff1b0a315c5dec8(state) {
    return $3679aa7475d9bd44$var$allTransactionsProjectViewMemoized(state);
// 251206 FIX: I think this does not apply after Pensions 2.0 has been applied (PRD-1759) ↓↓↓
// we are passing also the non-KPI-relevant transactions which are NOT pension-purchase (only pension-purchase transactions should be used to calculate net worth and other sums)
// because ProjectTransactionList needs to show simulated contributions and payouts too and this is its data source
// all components which use allTransactionsProjectView to calculate sums / balances / indicators should filter out isNot KpiRelevant: true transactions
}
const $3679aa7475d9bd44$export$a8444181b4689d4f = $3679aa7475d9bd44$var$allTransactionsProjectViewMemoized;
const $3679aa7475d9bd44$export$67bceb1b22c62e05 = ()=>(0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$cff1b0a315c5dec8, (state, projectId)=>projectId, (transactions, projectId)=>(transactions || []).filter((item)=>item.projectId === projectId));
function $3679aa7475d9bd44$var$projectTransactionListFilterLogic(prev, curr) {
    var _projectLinkedTransaction_tags, _projectLinkedTransaction_tags1, _projectLinkedTransaction_tags2;
    const { transactionsStack: transactionsStack, sideStack: sideStack } = prev;
    const { linkedTransactions: linkedTransactions, category: category, quantity: quantity } = curr;
    const projectLinkedTransaction = linkedTransactions === null || linkedTransactions === void 0 ? void 0 : linkedTransactions.find((t)=>{
        var _t_tags;
        return [
            "transfer",
            "buy",
            "sell"
        ].includes((_t_tags = t.tags) === null || _t_tags === void 0 ? void 0 : _t_tags.type);
    });
    const checkPurchaseSale = [
        "buy",
        "sell"
    ].includes(projectLinkedTransaction === null || projectLinkedTransaction === void 0 ? void 0 : (_projectLinkedTransaction_tags = projectLinkedTransaction.tags) === null || _projectLinkedTransaction_tags === void 0 ? void 0 : _projectLinkedTransaction_tags.type);
    if ([
        "transfer"
    ].includes(projectLinkedTransaction === null || projectLinkedTransaction === void 0 ? void 0 : (_projectLinkedTransaction_tags1 = projectLinkedTransaction.tags) === null || _projectLinkedTransaction_tags1 === void 0 ? void 0 : _projectLinkedTransaction_tags1.type) && quantity < 0 || checkPurchaseSale && category === "deposits" && (projectLinkedTransaction === null || projectLinkedTransaction === void 0 ? void 0 : projectLinkedTransaction.category) !== "deposits" || checkPurchaseSale && category === "deposits" && (projectLinkedTransaction === null || projectLinkedTransaction === void 0 ? void 0 : projectLinkedTransaction.category) === "deposits" && quantity < 0) {
        const peerTransaction = transactionsStack.find((t)=>t.id === projectLinkedTransaction.id);
        if (peerTransaction) peerTransaction.hiddenTransaction = curr;
        else sideStack.push((0, $2qxEV._)((0, $9tqwB._)({}, curr), {
            peerTransactionId: projectLinkedTransaction.id
        }));
        return {
            transactionsStack: transactionsStack,
            sideStack: sideStack
        };
    }
    if ([
        "buy",
        "sell",
        "transfer"
    ].includes(projectLinkedTransaction === null || projectLinkedTransaction === void 0 ? void 0 : (_projectLinkedTransaction_tags2 = projectLinkedTransaction.tags) === null || _projectLinkedTransaction_tags2 === void 0 ? void 0 : _projectLinkedTransaction_tags2.type)) {
        const childTransactionIndex = sideStack.findIndex((t)=>t.peerTransactionId === curr.id);
        if (childTransactionIndex > -1) {
            transactionsStack.push((0, $2qxEV._)((0, $9tqwB._)({}, curr), {
                hiddenTransaction: sideStack[childTransactionIndex]
            }));
            sideStack.splice(childTransactionIndex, 1);
        } else transactionsStack.push(curr);
    } else transactionsStack.push(curr);
    return {
        transactionsStack: transactionsStack,
        sideStack: sideStack
    };
}
const $3679aa7475d9bd44$export$a942db4885b6ea2 = ()=>(0, $5c22629b42831e80$export$595d22ed68ca2841)((state, projectId)=>projectId, (state, projectId, filteredItems)=>filteredItems, (state, projectId, filteredItems, isIsolated)=>isIsolated, (state, projectId)=>state.projects.find((p)=>p.id === projectId), (state, projectId)=>($3679aa7475d9bd44$export$cff1b0a315c5dec8(state) || []).filter((item)=>item.projectId === projectId), (state, projectId, filteredItems, isIsolated)=>$93bb2798871a68d2$export$32058f168ca0310f(state, isIsolated ? projectId : undefined), (projectId, filteredItems, isIsolated, project, projectTransactions, quotesArray)=>{
        const transactionsPrep = (projectTransactions || []).reduce($3679aa7475d9bd44$var$projectTransactionListFilterLogic, {
            transactionsStack: [],
            sideStack: []
        });
        const assetIds = [
            ...new Set(((transactionsPrep === null || transactionsPrep === void 0 ? void 0 : transactionsPrep.transactionsStack) || []).filter((item)=>(item === null || item === void 0 ? void 0 : item.category) !== "deposits").map((item)=>item.assetId || item.figi))
        ];
        const quotes = (quotesArray || []).filter((item)=>item.source === "manual" && typeof item.date === "number" && item.quote !== null && item.quote !== undefined && item.date === item.quoteDate && (assetIds.includes(item.accountId) || assetIds.includes(item.figi) || assetIds.includes(item.assetId)));
        const recurringDefaultVisible = (filteredItems || []).includes("recurring") ? ((transactionsPrep === null || transactionsPrep === void 0 ? void 0 : transactionsPrep.transactionsStack) || []).filter((transaction)=>{
            var _transaction_tags_recurring, _transaction_tags;
            return (_transaction_tags = transaction.tags) === null || _transaction_tags === void 0 ? void 0 : (_transaction_tags_recurring = _transaction_tags.recurring) === null || _transaction_tags_recurring === void 0 ? void 0 : _transaction_tags_recurring.activated;
        }).map((transaction)=>transaction.id) : [];
        const filterCallback = (transaction)=>{
            if (!(filteredItems || []).includes("simulatedDividends") && transaction.label === "investment-dividend" && transaction.isSimulated) return false;
            if (!(filteredItems || []).includes("simulatedInterest") && transaction.label === "investment-interest" && transaction.isSimulated) return false;
            if (!(filteredItems || []).includes("simulatedPension") && transaction.label === "investment-pension" && transaction.isSimulated) return false;
            if (!(filteredItems || []).includes("simulatedQuotes") && Object.prototype.hasOwnProperty.call(transaction, "quote")) return false;
            return true;
        };
        const combinedItems = ((transactionsPrep === null || transactionsPrep === void 0 ? void 0 : transactionsPrep.transactionsStack) || []).concat(quotes).filter(filterCallback).concat((project === null || project === void 0 ? void 0 : project.goals) || []);
        const itemsByMonth = combinedItems.reduce((prev, item)=>{
            const key = item.date;
            const current = prev[key] || [];
            current.push(item);
            current.sort((a, b)=>a.sortingOrderWithinMonth - b.sortingOrderWithinMonth);
            return (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                [key]: current
            });
        }, {});
        return {
            projectId: projectId,
            isIsolated: isIsolated,
            recurringDefaultVisible: recurringDefaultVisible,
            itemsByMonth: itemsByMonth
        };
    });
const $3679aa7475d9bd44$export$eab475e3b4ddc367 = ()=>(0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>Object.keys(state.data), (state)=>state.data, (state)=>{
        var _state_data_realEstate, _state_data;
        return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : (_state_data_realEstate = _state_data.realEstate) === null || _state_data_realEstate === void 0 ? void 0 : _state_data_realEstate.transactions) || [];
    }, (state)=>{
        var _state_data_realEstate, _state_data;
        return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : (_state_data_realEstate = _state_data.realEstate) === null || _state_data_realEstate === void 0 ? void 0 : _state_data_realEstate.simulatedTransactions) || [];
    }, (categories, data, realEstateTransactionsRaw, realEstateSimulatedTransactionsRaw)=>{
        const allRealEstateTransactions = [
            ...realEstateTransactionsRaw,
            ...realEstateSimulatedTransactionsRaw
        ];
        const realEstateTransactionsCountByAccount = allRealEstateTransactions.reduce((acc, transaction)=>{
            const { accountId: accountId } = transaction;
            if (!acc[accountId]) acc[accountId] = 0;
            acc[accountId] += 1;
            return acc;
        }, {});
        const accounts = categories.map((category)=>(data[category].accounts || []).map((account)=>(0, $2qxEV._)((0, $9tqwB._)({}, account), {
                    category: category
                }))).flat().map((account)=>realEstateTransactionsCountByAccount[account.id] > 0 && account.category === "realEstate" ? (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                notAvailableForBuy: true
            }) : account);
        return accounts;
    });
const $3679aa7475d9bd44$export$fc2b2be653f13fa1 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data, (data)=>{
    const timerStart = $3679aa7475d9bd44$var$projectPerfDebugEnabled ? Date.now() : null;
    const ranges = {};
    Object.keys(data || {}).forEach((category)=>{
        const thisCategory = (data === null || data === void 0 ? void 0 : data[category]) || {};
        const categoryTransactions = (thisCategory.transactions || []).concat(thisCategory.simulatedTransactions || []);
        categoryTransactions.forEach((transaction)=>{
            const { projectId: projectId } = transaction;
            if (!projectId || projectId === "null") return;
            const txnDate = Number(transaction.date);
            if (!Number.isFinite(txnDate)) return;
            if (!ranges[projectId]) {
                ranges[projectId] = {
                    minDate: txnDate,
                    maxDate: txnDate
                };
                return;
            }
            if (txnDate < ranges[projectId].minDate) ranges[projectId].minDate = txnDate;
            if (txnDate > ranges[projectId].maxDate) ranges[projectId].maxDate = txnDate;
        });
    });
    if ($3679aa7475d9bd44$var$projectPerfDebugEnabled) console.info("PERF projectDateRangeById", {
        durationMs: Date.now() - timerStart,
        projects: Object.keys(ranges).length
    });
    return ranges;
});
function $3679aa7475d9bd44$var$getAccountName(accounts, accountId) {
    const account = accounts.find((a)=>a.id === accountId);
    return account === null || account === void 0 ? void 0 : account.name;
}
const $3679aa7475d9bd44$export$cb9c32c395459b9b = (0, $5c22629b42831e80$export$595d22ed68ca2841)(// prettier-ignore
$3679aa7475d9bd44$export$6d68928c2b6ce1a6, $93bb2798871a68d2$export$4bb039911f93bce, $93bb2798871a68d2$export$443f4a6ebd922e0a, $93bb2798871a68d2$export$8c577782bb016c47, function assetBalancesCallback(transactions, baselineView, quotes, accounts) {
    const assetSaleTransactions = []; // for calculating incomeFromCapitalSaleTransactions*
    const result = transactions.reduce((acc, transaction)=>{
        try {
            var _quotes_assetId_current, _quotes_assetId, _quotes_assetId_baseline, _quotes_assetId1, _quotes_assetId_referenceBaseline, _quotes_assetId2, _quotes_assetId_current1, _quotes_assetId3, _quotes_assetId_baseline1, _quotes_assetId4, _quotes_assetId_referenceBaseline1, _quotes_assetId5;
            // account currency only will destructure for deposits
            // eslint-disable-next-line max-len
            const { id: id, date: date, category: category, accountId: accountId, assetId: assetId, providerAssetId: providerAssetId, transactionType: transactionType, quantity: transactionQuantity, quantityOpen: quantityOpen, transactionCurrency: transactionCurrency, assetCurrency: assetCurrency, accountCurrency: accountCurrency, displaySymbol: displaySymbol, displayName: displayName, assetName: assetName, uptc: uptc, upbc: upbc } = transaction;
            const { baseline: b, referenceBaseline: rb } = baselineView;
            const currentQuote = ((_quotes_assetId = quotes[assetId]) === null || _quotes_assetId === void 0 ? void 0 : (_quotes_assetId_current = _quotes_assetId.current) === null || _quotes_assetId_current === void 0 ? void 0 : _quotes_assetId_current.quote) || 0; // assume 0 to indicate a problem to user without throwing NaN
            const baselineQuote = ((_quotes_assetId1 = quotes[assetId]) === null || _quotes_assetId1 === void 0 ? void 0 : (_quotes_assetId_baseline = _quotes_assetId1.baseline) === null || _quotes_assetId_baseline === void 0 ? void 0 : _quotes_assetId_baseline.quote) || 0; // if transaction happened after baseline, take transaction price, otherwise take baseline price
            const referenceQuote = ((_quotes_assetId2 = quotes[assetId]) === null || _quotes_assetId2 === void 0 ? void 0 : (_quotes_assetId_referenceBaseline = _quotes_assetId2.referenceBaseline) === null || _quotes_assetId_referenceBaseline === void 0 ? void 0 : _quotes_assetId_referenceBaseline.quote) || 0; // as above, but for referenceBaseline
            const currentQuoteBaseCurrency = ((_quotes_assetId3 = quotes[assetId]) === null || _quotes_assetId3 === void 0 ? void 0 : (_quotes_assetId_current1 = _quotes_assetId3.current) === null || _quotes_assetId_current1 === void 0 ? void 0 : _quotes_assetId_current1.quoteBaseCurrency) || 0;
            const baselineQuoteBaseCurrency = ((_quotes_assetId4 = quotes[assetId]) === null || _quotes_assetId4 === void 0 ? void 0 : (_quotes_assetId_baseline1 = _quotes_assetId4.baseline) === null || _quotes_assetId_baseline1 === void 0 ? void 0 : _quotes_assetId_baseline1.quoteBaseCurrency) || 0;
            const referenceQuoteBaseCurrency = ((_quotes_assetId5 = quotes[assetId]) === null || _quotes_assetId5 === void 0 ? void 0 : (_quotes_assetId_referenceBaseline1 = _quotes_assetId5.referenceBaseline) === null || _quotes_assetId_referenceBaseline1 === void 0 ? void 0 : _quotes_assetId_referenceBaseline1.quoteBaseCurrency) || 0;
            const transactionWithQuotes = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                baselineQuoteBaseCurrency: baselineQuoteBaseCurrency,
                referenceQuoteBaseCurrency: referenceQuoteBaseCurrency,
                baselineQuote: baselineQuote,
                referenceQuote: referenceQuote
            });
            const currentQuantity = transactionQuantity;
            const baselineQuantity = date < b ? transactionQuantity : 0;
            const referenceQuantity = date < rb ? transactionQuantity : 0;
            // baselineAssetValueChange needs to calculate FIFO on all transactions before baseline; to do that it needs to know if reverseMode must be applied
            const currentAccount = accounts.find((a)=>a.id === accountId);
            const reverseMode = !!(category === "loans" && currentAccount.direction === "taken");
            if (category !== "deposits" && transactionType === "sale") assetSaleTransactions.push(transactionWithQuotes);
            // handling asset currency: (see PRD-1424)
            // - clear for deposits (asset currency = account currency)
            // - for assets let us make an assumption that for a given account and asset combination there can only be one asset currency
            //   (i.e. if first transaction is in USD, the following transactions are in USD)
            //   If that is not the case, we will flag it as an error here and show message (we could probably convert the new currency to old currency then somehow)
            if (!acc[category]) acc[category] = {};
            if (!acc[category][accountId]) acc[category][accountId] = {};
            if (!acc[category][accountId][assetId]) acc[category][accountId][assetId] = {
                displayName: displayName || assetName || $3679aa7475d9bd44$var$getAccountName(accounts, accountId),
                displaySymbol: displaySymbol || (category === "metals" ? assetId : null),
                providerAssetId: providerAssetId || null,
                // assetCurrency: category === 'deposits' ? accountCurrency : transactionCurrency, // fixed 241116: assetCurrency is now calculated when uploading data to Redux
                assetCurrency: assetCurrency || accountCurrency,
                reverseMode: reverseMode,
                current: (0, $9tqwB._)({
                    quantity: currentQuantity,
                    quoteBaseCurrency: currentQuoteBaseCurrency,
                    quoteTransactionCurrency: currentQuote,
                    valueBaseCurrency: currentQuoteBaseCurrency * currentQuantity || 0,
                    purchaseValueBaseCurrency: upbc * quantityOpen || 0
                }, category === "deposits" && {
                    valueAccountCurrency: currentQuote * currentQuantity || 0
                }, category === "deposits" && {
                    accountCurrency: transactionCurrency
                }),
                baseline: (0, $9tqwB._)({
                    quantity: baselineQuantity,
                    quoteBaseCurrency: baselineQuoteBaseCurrency,
                    quoteTransactionCurrency: baselineQuote,
                    valueBaseCurrency: baselineQuoteBaseCurrency * baselineQuantity || 0
                }, category === "deposits" && {
                    valueAccountCurrency: currentQuote * baselineQuantity || 0
                }, category === "deposits" && {
                    accountCurrency: transactionCurrency
                }),
                referenceBaseline: (0, $9tqwB._)({
                    quantity: referenceQuantity,
                    quoteBaseCurrency: referenceQuoteBaseCurrency,
                    quoteTransactionCurrency: referenceQuote,
                    valueBaseCurrency: referenceQuoteBaseCurrency * referenceQuantity || 0
                }, category === "deposits" && {
                    valueAccountCurrency: referenceQuote * referenceQuantity || 0
                }, category === "deposits" && {
                    accountCurrency: transactionCurrency
                }),
                transactions: [
                    transactionWithQuotes
                ]
            };
            else {
                const { quantity: quantity, current: current, baseline: baseline, referenceBaseline: referenceBaseline } = acc[category][accountId][assetId];
                // handle transaction inconsistencies (i.e. situation where we have asset transactions for the same account/asset in different transactionCurrencies)
                // in general, we assume that the asset will be run in the same currency as its first purchase transaction
                // as we only sum up baseCurrency values, this is not a problem (quotes will sort it out - getQuotes gets currency parameter as part of the payload)
                // there is inconsistentAssetCurrency message already prepared, but trying to use dispatch here causes circular dependency
                if (acc[category][accountId][assetId].assetCurrency !== null && (category === "deposits" ? accountCurrency : transactionCurrency) !== null && acc[category][accountId][assetId].assetCurrency !== (category === "deposits" ? accountCurrency : transactionCurrency)) {
                    console.warn(`Transaction currency mismatch for account ${accountId} and asset ${assetId} in category ${category} - transactionId ${id}.`);
                    console.warn(`Expected ${acc[category][accountId][assetId].assetCurrency}, received ${category === "deposits" ? accountCurrency : transactionCurrency}.`);
                }
                acc[category][accountId][assetId].current = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, current), {
                    quantity: current.quantity + currentQuantity,
                    valueBaseCurrency: current.valueBaseCurrency + (currentQuoteBaseCurrency * currentQuantity || 0),
                    purchaseValueBaseCurrency: current.purchaseValueBaseCurrency + (upbc * quantityOpen || 0)
                }), category === "deposits" && {
                    valueAccountCurrency: current.valueAccountCurrency + (currentQuote * currentQuantity || 0)
                });
                acc[category][accountId][assetId].baseline = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, baseline), {
                    quantity: baseline.quantity + baselineQuantity,
                    valueBaseCurrency: baseline.valueBaseCurrency + (baselineQuoteBaseCurrency * baselineQuantity || 0)
                }), category === "deposits" && {
                    valueAccountCurrency: baseline.valueAccountCurrency + (baselineQuote * baselineQuantity || 0)
                });
                acc[category][accountId][assetId].referenceBaseline = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, referenceBaseline), {
                    quantity: referenceBaseline.quantity + referenceQuantity,
                    valueBaseCurrency: referenceBaseline.valueBaseCurrency + (referenceQuoteBaseCurrency * referenceQuantity || 0)
                }), category === "deposits" && {
                    valueAccountCurrency: referenceBaseline.valueAccountCurrency + (referenceQuote * referenceQuantity || 0)
                });
                acc[category][accountId][assetId].transactions.push(transactionWithQuotes); // for debug purposes
                // if for some reason providerAssetId has not been updated before, update it now if it is available
                if (!acc[category][accountId][assetId].providerAssetId && providerAssetId) acc[category][accountId][assetId].providerAssetId = providerAssetId;
            }
            acc.assetSaleTransactions = assetSaleTransactions;
            return acc;
        } catch (e) {
            console.error("Error in assetBalances selector", e);
            console.error("Transaction", JSON.stringify(transaction, null, 2));
            return acc;
        }
    }, {});
    return result;
});
function $3679aa7475d9bd44$var$getProjectNextGoalDate(projectId, projects) {
    const project = projects.find((p)=>p.id === projectId);
    if (!project) return null;
    const { goals: goals } = project;
    if (!goals || goals.length === 0) return null;
    return goals.sort((a, b)=>a.date - b.date)[0].date;
}
const $3679aa7475d9bd44$export$eec9018cc0c2a404 = (0, $5c22629b42831e80$export$595d22ed68ca2841)(// prettier-ignore
$3679aa7475d9bd44$export$cff1b0a315c5dec8, (state)=>state.projects, $93bb2798871a68d2$export$4bb039911f93bce, (state)=>{
    var _state_user_profile;
    return (_state_user_profile = state.user.profile) === null || _state_user_profile === void 0 ? void 0 : _state_user_profile.settings.sliderEndDate;
}, $93bb2798871a68d2$export$443f4a6ebd922e0a, $93bb2798871a68d2$export$8c577782bb016c47, $93bb2798871a68d2$export$f4deae28f88bc4e5, $93bb2798871a68d2$export$bc8855b14ae45a74, (state)=>{
    var _state_simulation;
    return (_state_simulation = state.simulation) === null || _state_simulation === void 0 ? void 0 : _state_simulation.dashboardMode;
}, (state)=>{
    var _state_user_profile_settings, _state_user_profile;
    return (_state_user_profile = state.user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.inflationRate;
}, function projectBalancesCallback(transactions, projects, baselineView, sliderEnd, quotes, accounts, assetHierarchy, settingsByCategories, dashboardMode, inflationRate) {
    // this only needs to run in project mode
    if (dashboardMode !== "projects") return {};
    const isolatedQuotesCache = {}; // cache for isolated project quotes
    const result = transactions.filter((transaction)=>transaction.projectId && transaction.projectId !== "null") // only keep project transactions
    .reduce((acc, transaction)=>{
        // account currency only will destructure for deposits
        const { date: date, category: category, projectId: projectId, accountId: accountId, assetId: assetId, quantity: transactionQuantity, transactionCurrency: transactionCurrency, accountCurrency: accountCurrency, displaySymbol: displaySymbol, displayName: displayName } = transaction;
        const { current: c } = baselineView;
        let goalDate;
        let quotesForProject;
        try {
            var _projects_find_settings, _projects_find, _quotesForProject_assetId_current, _quotesForProject_assetId, _quotesForProject_assetId1, _quotesForProject_assetId_current1, _quotesForProject_assetId2, _quotesForProject_assetId3;
            // if project has goals, this will be the date of the next (chronologically) goal; otherwise slider end date
            goalDate = $3679aa7475d9bd44$var$getProjectNextGoalDate(projectId, projects) || sliderEnd;
            const projectIsIsolated = (_projects_find = projects.find((p)=>p.id === projectId)) === null || _projects_find === void 0 ? void 0 : (_projects_find_settings = _projects_find.settings) === null || _projects_find_settings === void 0 ? void 0 : _projects_find_settings.isIsolated;
            // check cache if the quotes for this project are there; if yes, use them; if no, calculate them and put them in the cache
            if (projectIsIsolated) {
                if (!isolatedQuotesCache[projectId]) {
                    console.log("DEBUG - running runQuotesCalcs from projectBalances");
                    // Reuse the same inputs as global quote selectors to keep isolated cache behavior consistent.
                    isolatedQuotesCache[projectId] = $93bb2798871a68d2$export$502b8c77f911abd0(sliderEnd, dashboardMode, quotes, accounts, baselineView, projects, assetHierarchy, settingsByCategories, projectId, inflationRate);
                }
            }
            // if the project is isolated, use isolated quotes, otherwise use global quotes
            quotesForProject = projectIsIsolated ? isolatedQuotesCache[projectId] : quotes;
            // Guard against assets that currently have no quote row (e.g. sparse/manual-only datasets).
            const currentQuote = ((_quotesForProject_assetId = quotesForProject[assetId]) === null || _quotesForProject_assetId === void 0 ? void 0 : (_quotesForProject_assetId_current = _quotesForProject_assetId.current) === null || _quotesForProject_assetId_current === void 0 ? void 0 : _quotesForProject_assetId_current.quote) || 1; // assume 1 for this is transaction currency (ASSUMPTION: "quote" is always in transaction currency)
            const nextGoalDateQuote = ((_quotesForProject_assetId1 = quotesForProject[assetId]) === null || _quotesForProject_assetId1 === void 0 ? void 0 : _quotesForProject_assetId1[goalDate].quote) || 1;
            // Use 0 fallback when base-currency quote is missing so downstream math remains finite.
            const currentQuoteBaseCurrency = ((_quotesForProject_assetId2 = quotesForProject[assetId]) === null || _quotesForProject_assetId2 === void 0 ? void 0 : (_quotesForProject_assetId_current1 = _quotesForProject_assetId2.current) === null || _quotesForProject_assetId_current1 === void 0 ? void 0 : _quotesForProject_assetId_current1.quoteBaseCurrency) || 0; // assume 0 for this is baseCurrency (for lack of a better idea for now)
            const nextGoalDateQuoteBaseCurrency = ((_quotesForProject_assetId3 = quotesForProject[assetId]) === null || _quotesForProject_assetId3 === void 0 ? void 0 : _quotesForProject_assetId3[goalDate].quoteBaseCurrency) || 0;
            const transactionWithQuotes = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                currentQuote: currentQuote,
                currentQuoteBaseCurrency: currentQuoteBaseCurrency,
                nextGoalDate: goalDate,
                nextGoalDateQuoteBaseCurrency: nextGoalDateQuoteBaseCurrency,
                nextGoalDateQuote: nextGoalDateQuote
            });
            const currentQuantity = date <= c ? transactionQuantity : 0;
            const nextGoalDateQuantity = date <= goalDate ? transactionQuantity : 0;
            // handling asset currency: (see PRD-1424)
            // - clear for deposits (asset currency = account currency)
            // - for assets let us make an assumption that for a given account and asset combination there can only be one asset currency
            //   (i.e. if first transaction is in USD, the following transactions are in USD)
            //   If that is not the case, we will flag it as an error here and show message (we could probably convert the new currency to old currency then somehow)
            const isConsideredInvestment = [
                "investment-purchase",
                "investment-payout",
                "investment-outflow",
                "investment-contribution"
            ].includes(transaction.label);
            // PL 230415 not sure if investment-contibution should be considered investment tho
            if (!acc[projectId]) acc[projectId] = {};
            if (!acc[projectId][accountId]) acc[projectId][accountId] = {};
            if (!acc[projectId][accountId][assetId]) acc[projectId][accountId][assetId] = {
                account: accounts.find((a)=>a.id === accountId),
                displayName: displayName || $3679aa7475d9bd44$var$getAccountName(accounts, accountId),
                displaySymbol: displaySymbol || null,
                assetCurrency: category === "deposits" ? accountCurrency : transactionCurrency,
                current: {
                    quantity: currentQuantity,
                    quoteBaseCurrency: currentQuoteBaseCurrency,
                    quoteTransactionCurrency: currentQuote,
                    valueBaseCurrency: currentQuoteBaseCurrency * currentQuantity,
                    // ↓ used in ProgressRoi
                    investedAmount: isConsideredInvestment ? currentQuoteBaseCurrency * currentQuantity : 0
                },
                nextGoalDate: {
                    quantity: nextGoalDateQuantity,
                    quoteBaseCurrency: nextGoalDateQuoteBaseCurrency,
                    quoteTransactionCurrency: nextGoalDateQuote,
                    valueBaseCurrency: nextGoalDateQuantity * nextGoalDateQuoteBaseCurrency,
                    // ↓ used in ProgressRoi
                    investedAmount: isConsideredInvestment ? nextGoalDateQuantity * nextGoalDateQuoteBaseCurrency : 0
                },
                transactions: [
                    transactionWithQuotes
                ]
            };
            else {
                const { current: current, nextGoalDate: nextGoalDate } = acc[projectId][accountId][assetId];
                acc[projectId][accountId][assetId].current = (0, $2qxEV._)((0, $9tqwB._)({}, current), {
                    quantity: current.quantity + currentQuantity,
                    valueBaseCurrency: current.valueBaseCurrency + currentQuoteBaseCurrency * currentQuantity,
                    investedAmount: current.investedAmount + (isConsideredInvestment ? currentQuoteBaseCurrency * currentQuantity : 0)
                });
                acc[projectId][accountId][assetId].nextGoalDate = (0, $2qxEV._)((0, $9tqwB._)({}, nextGoalDate), {
                    quantity: nextGoalDate.quantity + nextGoalDateQuantity,
                    valueBaseCurrency: nextGoalDate.valueBaseCurrency + nextGoalDateQuoteBaseCurrency * nextGoalDateQuantity,
                    investedAmount: nextGoalDate.investedAmount + (isConsideredInvestment ? nextGoalDateQuoteBaseCurrency * nextGoalDateQuantity : 0)
                });
                acc[projectId][accountId][assetId].transactions.push(transactionWithQuotes); // for debug purposes
            }
            return acc;
        } catch (e) {
            var _quotesForProject_assetId4, _quotesForProject_assetId5;
            console.error("Error in projectBalances selector", e);
            console.info("Transaction", JSON.stringify(transaction, null, 2));
            console.info("Quotes: current", JSON.stringify((_quotesForProject_assetId4 = quotesForProject[assetId]) === null || _quotesForProject_assetId4 === void 0 ? void 0 : _quotesForProject_assetId4.current, null, 2), "nextGoalDate", JSON.stringify((_quotesForProject_assetId5 = quotesForProject[assetId]) === null || _quotesForProject_assetId5 === void 0 ? void 0 : _quotesForProject_assetId5[goalDate], null, 2));
            console.info("nextGoalDate:", goalDate, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(goalDate).format("YYYY-MM-DD"));
            return acc;
        }
    }, {});
    return result;
});
const $3679aa7475d9bd44$export$bab31b68289bf34b = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$eec9018cc0c2a404, (balances)=>{
    const { assetSaleTransactions: assetSaleTransactions } = balances, rest = (0, $bLhVg._)(balances, [
        "assetSaleTransactions"
    ]);
    return (0, $3e6d58b7292c657b$export$a537c627e243cb6e)(rest, [
        "projectId",
        "accountId",
        "assetId"
    ]);
});
const $3679aa7475d9bd44$export$700958e167898c8a = ()=>(0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$bab31b68289bf34b, (state, projectId)=>projectId, (balances, projectId)=>(balances || []).reduce((acc, item)=>item.projectId === projectId ? acc + item.current.valueBaseCurrency : acc, 0));
const $3679aa7475d9bd44$export$5c7c369f7ca49fb9 = ()=>(0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$bab31b68289bf34b, (state, projectId)=>projectId, (balances, projectId)=>{
        const projectBalancesForId = (balances || []).filter((item)=>item.projectId === projectId);
        const projectSum = projectBalancesForId.reduce((acc, item)=>acc + item.current.valueBaseCurrency, 0);
        const projectAssets = projectBalancesForId.map((item)=>({
                account: item.account,
                sum: item.current.valueBaseCurrency,
                header: item.displayName,
                assetId: item.assetId,
                accountName: item.accountName,
                accountId: item.accountId
            }));
        const assetsList = projectBalancesForId.filter((item)=>item.category !== "deposits").map((item)=>({
                accountId: item.accountId,
                sum: item.current.valueBaseCurrency,
                header: item.displayName,
                assetId: item.assetId
            }));
        return {
            projectSum: projectSum,
            projectAssets: projectAssets,
            assetsList: assetsList
        };
    });
// helper -- returns purchase value of asset sale transaction; needs baseline or referenceBaseline date as 2nd argument and array of purchase transactions to look up the purchase price
function $3679aa7475d9bd44$var$getLinkedTransactionPurchaseCost(assetTransaction, periodCutoffDate, periodQuoteBaseCurrency) {
    // get linked transactions for asset transaction passed as argument
    if (!assetTransaction) return 0;
    const { linkedTransactions: linkedTransactions } = assetTransaction;
    if (!linkedTransactions || linkedTransactions.length === 0) return 0;
    // sale transaction must be linked to a purchase transaction
    // for each linked stock transaction check if the purchase date is before the baseline date, if so, replace purchase price with baseline price
    // sample: linkedTransactions: [{ id: 'abcde', category: 'cat1', {"date": 1607731200000, "type": "purchase", "upbc": 1, "quantity": 12}}, ...]
    const purchaseCost = linkedTransactions.filter((txn)=>txn.tags.type === "purchase") // from the linkedTransactions keep only the purchase transactions (there may also be others)
    .reduce((prev, curr)=>prev + (curr.tags.date < periodCutoffDate // calculate baseline or purchase value depending on the date
         ? periodQuoteBaseCurrency // in case quote is not available
         : curr.tags.upbc) * curr.tags.quantity, 0);
    return purchaseCost;
}
const $3679aa7475d9bd44$export$8bf37f4689ad817b = (0, $5c22629b42831e80$export$595d22ed68ca2841)($93bb2798871a68d2$export$4bb039911f93bce, $3679aa7475d9bd44$export$cb9c32c395459b9b, function incomeFromCapitalSaleTransactionsCurrent(baselineView, balances) {
    const { baseline: b } = baselineView;
    const { assetSaleTransactions: assetSaleTransactions } = balances;
    if ((assetSaleTransactions || []).length === 0) return 0;
    const result = assetSaleTransactions.filter((saleTransaction)=>saleTransaction.date >= b) // only consider sale transactions after baseline
    .reduce((acc, saleTransaction)=>{
        const { quantity: quantity, upbc: upbc, baselineQuoteBaseCurrency: baselineQuoteBaseCurrency } = saleTransaction;
        return acc + -quantity * upbc - $3679aa7475d9bd44$var$getLinkedTransactionPurchaseCost(saleTransaction, b, baselineQuoteBaseCurrency);
    }, 0);
    return result;
});
const $3679aa7475d9bd44$export$c6f7c16e7cb3dcee = (0, $5c22629b42831e80$export$595d22ed68ca2841)($93bb2798871a68d2$export$4bb039911f93bce, $3679aa7475d9bd44$export$cb9c32c395459b9b, function incomeFromCapitalSaleTransactionsBaseline(baselineView, balances) {
    const { baseline: b, referenceBaseline: rb } = baselineView;
    const { assetSaleTransactions: assetSaleTransactions } = balances;
    if ((assetSaleTransactions || []).length === 0) return 0;
    const result = assetSaleTransactions.filter((saleTransaction)=>saleTransaction.date < b && saleTransaction.date >= rb) // only consider sale transactions after baseline
    .reduce((acc, saleTransaction)=>{
        const { quantity: quantity, upbc: upbc, referenceQuoteBaseCurrency: referenceQuoteBaseCurrency } = saleTransaction;
        return acc + -quantity * upbc - $3679aa7475d9bd44$var$getLinkedTransactionPurchaseCost(saleTransaction, rb, referenceQuoteBaseCurrency);
    }, 0);
    return result;
});
const $3679aa7475d9bd44$export$7cd09fd23199c464 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$cb9c32c395459b9b, function assetBalancesArrayCallback(balances) {
    const { assetSaleTransactions: assetSaleTransactions } = balances, rest = (0, $bLhVg._)(balances, [
        "assetSaleTransactions"
    ]);
    return (0, $3e6d58b7292c657b$export$a537c627e243cb6e)(rest, [
        "category",
        "accountId",
        "assetId"
    ]);
});
const $3679aa7475d9bd44$export$611bdd34eb5c8a52 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$7cd09fd23199c464, function currentNetWorth2Callback(balances) {
    return balances.reduce((acc, curr)=>{
        const { current: current } = curr;
        return acc + current.valueBaseCurrency;
    }, 0);
});
const $3679aa7475d9bd44$export$be3d5997140286cf = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$7cd09fd23199c464, function baselineNetWorthCallback(balances) {
    return balances.reduce((acc, curr)=>{
        const { baseline: baseline } = curr;
        return acc + baseline.valueBaseCurrency;
    }, 0);
});
function $3679aa7475d9bd44$export$23a65f40928a9521(balances, baselineView) {
    const allAssets = balances.map((assetObject)=>{
        // result is a sum of all current assets in baseline or purchase prices
        const sumCurrentAssetsInBaselineOrPurchasePrices = assetObject.transactions.reduce((transactionsAcc, transactionObject)=>{
            const { date: date, quantityOpen: quantityOpen, upbc: upbc, baselineQuoteBaseCurrency: baselineQuoteBaseCurrency } = transactionObject;
            return transactionsAcc + (quantityOpen || 0) * (date > baselineView.baseline ? upbc : baselineQuoteBaseCurrency);
        }, 0);
        const { current: current } = assetObject;
        return {
            displayName: assetObject.displayName,
            assetId: assetObject.assetId,
            currentQuantity: current.quantity,
            currentValueBaseCurrency: current.valueBaseCurrency,
            baselineOrPurchaseValueBaseCurrency: sumCurrentAssetsInBaselineOrPurchasePrices
        };
    });
    return allAssets;
}
function $3679aa7475d9bd44$export$832a0cdfc61d162b(balances, baselineView) {
    // go through transaction objects for each account-asset and do FIFO calculation
    // calculate the purchase/baseline values of the remaining assets and subtract it from current value
    // console.log('DEBUG aba', balances);
    const sumAllAssets = balances.reduce((assetsAcc, assetObject)=>{
        // result is a sum of all current assets in baseline or purchase prices
        const sumCurrentAssetsInBaselineOrPurchasePrices = assetObject.transactions.reduce((transactionsAcc, transactionObject)=>{
            try {
                const { date: date, quantityOpen: quantityOpen, upbc: upbc, baselineQuoteBaseCurrency: baselineQuoteBaseCurrency } = transactionObject;
                // quantityOpen is added to only the PURCHASE transactions by applyFIFOReturnAll, so we need to filter out the results of those who do not have it
                if (Number.isNaN((quantityOpen || 0) * (date > baselineView.baseline ? upbc : baselineQuoteBaseCurrency))) throw new Error("NaN in calculateCurrentAssetValueChange");
                return transactionsAcc + (quantityOpen || 0) * (date > baselineView.baseline ? upbc : baselineQuoteBaseCurrency);
            } catch (e) {
                console.error("Error in calculateCurrentAssetValueChange", e);
                console.error("Transaction", JSON.stringify(transactionObject, null, 2));
                return transactionsAcc;
            }
        }, 0);
        const { current: current } = assetObject;
        return assetsAcc + (current.valueBaseCurrency - sumCurrentAssetsInBaselineOrPurchasePrices);
    }, 0);
    return sumAllAssets;
}
const $3679aa7475d9bd44$export$de4ac74636de1fbc = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$7cd09fd23199c464, $93bb2798871a68d2$export$4bb039911f93bce, function currentAssetValueChangeCallback(balances, baselineView) {
    return $3679aa7475d9bd44$export$832a0cdfc61d162b(balances, baselineView);
});
function $3679aa7475d9bd44$export$182403c6092efd72(balances, baselineView) {
    const { baseline: b, referenceBaseline: rb } = baselineView;
    const allAssets = balances.map((assetObject)=>{
        // result is a sum of all current assets in reference or purchase prices
        const sumBaselineAssetsInReferenceOrPurchasePrices = (0, $3e6d58b7292c657b$export$aeb4e5a5dec08365)(assetObject.transactions.filter((t)=>t.date < b), assetObject.reverseMode)// applyFIFO returns an array of positive quantity transactions with remaining quantity in 'quantity' (in this case for transactions before baseline)
        .reduce((transactionsAcc, transactionObject)=>{
            const { date: date, quantityOpen: quantityOpen, upbc: upbc, referenceQuoteBaseCurrency: referenceQuoteBaseCurrency } = transactionObject;
            return transactionsAcc + (quantityOpen || 0) * (date > rb ? upbc : referenceQuoteBaseCurrency); // transactions later than baseline have already been removed
        }, 0);
        const { baseline: baseline } = assetObject;
        return {
            displayName: assetObject.displayName,
            assetId: assetObject.assetId,
            baselineQuantity: baseline.quantity,
            baselineValueBaseCurrency: baseline.valueBaseCurrency,
            referenceOrPurchaseValueBaseCurrency: sumBaselineAssetsInReferenceOrPurchasePrices
        };
    });
    return allAssets;
}
function $3679aa7475d9bd44$export$6ca0a863e30b8cb5(balances, baselineView) {
    // go through transaction objects for each account-asset and do FIFO calculation
    // calculate the purchase/baseline values of the remaining assets and subtract it from current value
    const { baseline: b, referenceBaseline: rb } = baselineView;
    const sumAllAssets = balances.reduce((assetsAcc, assetObject)=>{
        // result is a sum of all current assets in reference or purchase prices
        // assetObject.reverseMode contains information if reverseMode should be applied in this calculation (determined in accountBalances above)
        const sumBaselineAssetsInReferenceOrPurchasePrices = (0, $3e6d58b7292c657b$export$aeb4e5a5dec08365)(assetObject.transactions.filter((t)=>t.date < b), assetObject.reverseMode)// applyFIFO returns an array of positive quantity transactions with remaining quantity in 'quantity' (in this case for transactions before baseline)
        .reduce((transactionsAcc, transactionObject)=>{
            const { date: date, quantityOpen: quantityOpen, upbc: upbc, referenceQuoteBaseCurrency: referenceQuoteBaseCurrency } = transactionObject;
            return transactionsAcc + (quantityOpen || 0) * (date > rb ? upbc : referenceQuoteBaseCurrency); // transactions later than baseline have already been removed
        }, 0);
        const { baseline: baseline } = assetObject;
        return assetsAcc + (baseline.valueBaseCurrency - sumBaselineAssetsInReferenceOrPurchasePrices);
    }, 0);
    return sumAllAssets;
}
const $3679aa7475d9bd44$export$92fa9e056f78a7f9 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$7cd09fd23199c464, $93bb2798871a68d2$export$4bb039911f93bce, function baselineAssetValueChangeCallback(balances, baselineView) {
    return $3679aa7475d9bd44$export$6ca0a863e30b8cb5(balances, baselineView);
});
const $3679aa7475d9bd44$export$f63326aa9088648b = (0, $5c22629b42831e80$export$595d22ed68ca2841)((0, $a368196802fe263c$export$f19fca8543b3ca7c), $3679aa7475d9bd44$export$8bf37f4689ad817b, function incomeFromCapitalCurrentCallback(payoutsAndFees, saleTransactions) {
    return payoutsAndFees + saleTransactions;
});
const $3679aa7475d9bd44$export$16297c4826a11a44 = (0, $5c22629b42831e80$export$595d22ed68ca2841)((0, $a368196802fe263c$export$90f1014fd5819cb6), $3679aa7475d9bd44$export$c6f7c16e7cb3dcee, function incomeFromCapitalBaseline(payoutsAndFees, saleTransactions) {
    return payoutsAndFees + saleTransactions;
});
function $3679aa7475d9bd44$export$9c38a21154823fe6(state, category) {
    if (category === "stocks") return (0, $cfd21bc923628483$export$9890c99050a7d78e)(state);
    if (category === "realEstate") return (0, $5b51de6ffad59fa2$export$5948b786dea4615d)(state);
    if (category === "deposits") return (0, $a368196802fe263c$export$3c400324181e2c4d)(state);
    if (category === "loans") return (0, $2da686298e0b71ed$export$a856f17095d848d7)(state);
    if (category === "pension") return (0, $9a12762f4ca7889e$export$e59b728dc06f12a7)(state);
    if (category === "objectsOfValue") return (0, $1b6cd2b52ee96621$export$2802f167dacb0091)(state);
    if (category === "metals") return (0, $4678812afdc6b9f3$export$4efad9798dd0814e)(state);
    if (category === "unlistedShares") return (0, $84bd2b1e91f81d86$export$ef749c62f1718a7c)(state);
    if (category === "crypto") return (0, $e815710920e23f12$export$82f53777bf39b5c0)(state);
    return [];
}
function $3679aa7475d9bd44$export$783fb813252d40e6(state, category) {
    if (category === "stocks") return (0, $cfd21bc923628483$export$2b812e2009c0324e)(state);
    if (category === "realEstate") return (0, $5b51de6ffad59fa2$export$55799b72fb34a5ff)(state);
    if (category === "deposits") return (0, $a368196802fe263c$export$5b39d5dbd8cf02b3)(state);
    if (category === "loans") return (0, $2da686298e0b71ed$export$7180e5e29ddd79ea)(state);
    if (category === "pension") return (0, $9a12762f4ca7889e$export$7dac82169417f31a)(state);
    if (category === "objectsOfValue") return (0, $1b6cd2b52ee96621$export$76cb96f9bf81e0e2)(state);
    if (category === "metals") return (0, $4678812afdc6b9f3$export$41a7f8bac262ffd7)(state);
    if (category === "unlistedShares") return (0, $84bd2b1e91f81d86$export$d0d239d974aae3cd)(state);
    if (category === "crypto") return (0, $e815710920e23f12$export$5ccb67b3d1fd124c)(state);
    return [];
}
const $3679aa7475d9bd44$export$1b272b322aef6de0 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$6d68928c2b6ce1a6, $93bb2798871a68d2$export$8c577782bb016c47, $93bb2798871a68d2$export$4bb039911f93bce, function orphanedSaleTransactionsCallback($transactions, $accounts, $baselineView) {
    return $transactions// run filter by date first to limit the number of transactions that need to go through the subsequent filter
    .filter((transaction)=>transaction.date > $baselineView.referenceBaseline).filter((transaction)=>{
        const LTs = transaction.linkedTransactions || [];
        const saleToTransactionLT = LTs.find((lt)=>lt.tags.linkType === "sale-to-transaction"); // this means we need to have LTs entered on deposits also visible in assets
        return transaction.category !== "deposits" //                               only show asset transactions
         && transaction.transactionType === "sale" //                         of type 'sale'
         && (!saleToTransactionLT //                                          which either do not have a LT with linkType sale-to-transaction
         || !$transactions.find((t)=>t.id === saleToTransactionLT.id) // or they do, but the referenced transaction cannot be found
        );
    }).map((t)=>{
        const assetAccount = $accounts.find((a)=>a.id === t.accountId);
        const connectedDepositAccounts = (assetAccount.connectedDepositAccounts || []).map((id)=>$accounts.find((a)=>a.id === id)).filter((a)=>!!a); // whole Account objects without undefined
        return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            accountName: assetAccount.name,
            connectedDepositAccounts: // get the names of the connected deposit accounts (in case we need to redirect the user from the dialog to AccountDetails by passing account to setAccountDetails)
            connectedDepositAccounts
        });
    }); // attaching the entire account object, as it will then be used to pass to AccountDetails if the user clicks
});
// let previousInputs = null;
// export const genericTransactionView = (state) => {
//   const currentInputs = genericTransactionViewSource.dependencies.map((selector) => selector(state));
//   if (previousInputs) {
//     logSelectorChanges(previousInputs, currentInputs);
//   }
//   previousInputs = currentInputs;
//   return genericTransactionViewSource(state);
// };
function $3679aa7475d9bd44$var$sortByDateThenDepositsLast(a, b) {
    if (a.date !== b.date) return a.date - b.date; // sort by date in ascending order
    if (a.category === "deposits" && b.category !== "deposits") return 1; // place 'deposits' category transactions last
    if (a.category !== "deposits" && b.category === "deposits") return -1; // place 'deposits' category transactions last
    return 0;
}
// for each assetId array:
// - sort by date, ascending
// - calculate positionOnDate, valueOnDate for each row
// TODO: if performance in Dashboard is slow, may disable payoutPerPiece and related calcs depending on whether this is dashboard or reports mode
function $3679aa7475d9bd44$var$cavHelper(baselineView, quotes, cavAssetIdTransactions, assetId, accounts) {
    if ($3679aa7475d9bd44$var$debugLevel > 2) console.log("quotes view", quotes);
    // for each transaction for a given assetId in the input array calculate extra properties
    return cavAssetIdTransactions// inject placeholder items for baseline, referenceBaseline and current dates
    .concat([
        {
            date: baselineView.baseline,
            assetId: assetId,
            rowType: "kpi.baseline"
        },
        {
            date: baselineView.referenceBaseline,
            assetId: assetId,
            rowType: "kpi.referenceBaseline"
        },
        {
            date: baselineView.current,
            assetId: assetId,
            rowType: "kpi.current"
        }
    ])// IMPORTANT: asset transactions on a given day must be sorted BEFORE deposits (deposits at the end), because the fees will apply to the NEW amount of deposits!
    .sort($3679aa7475d9bd44$var$sortByDateThenDepositsLast).reduce((prev, curr)=>{
        const prevItem = prev.at(-1) || {}; // this is used to "carry over" the positionOnDate from the previous row; price is calculated from quotes;
        // calculate quotes for this row
        // if this is a purchase or sale transaction, use transaction quote (assumption)
        if ($3679aa7475d9bd44$var$debugLevel > 2) console.log("curr", curr);
        const newObject = {};
        const { displaySymbol: displaySymbol, accountId: accountId, quantity: quantity, quantityOpen: quantityOpen, rowType: rowType, date: date, upbc: upbc } = curr;
        let positionOnDate = prevItem.positionOnDate || 0;
        let openPositionOnDate = prevItem.openPositionOnDate || 0;
        const displayName = curr.displayName || curr.accountName || $3679aa7475d9bd44$var$getAccountName(accounts, assetId);
        // we are assuming that the two categories with assets (stocks, metals) have already assetNames from assets, deposits have currencies there and the rest is one per account
        if ([
            "purchase",
            "sale",
            "kpi.current",
            "kpi.baseline",
            "kpi.referenceBaseline"
        ].includes(rowType)) {
            var _accounts_find;
            // if this is a purchase, sale or kpi rowType, add positionOnDate and valueOnDate considering the amount of this transaction
            positionOnDate = !prevItem.positionOnDate ? quantity || 0 : prevItem.positionOnDate + (quantity || 0);
            if (rowType !== "sale") openPositionOnDate = !prevItem.openPositionOnDate ? quantityOpen || 0 : prevItem.openPositionOnDate + (quantityOpen || 0);
            if (!curr.displayName) newObject.displayName = displayName;
            if (!curr.assetName) newObject.assetName = displayName;
            if (!curr.displaySymbol) newObject.displaySymbol = displaySymbol;
            if (!curr.accountName) newObject.accountName = ((_accounts_find = accounts.find((a)=>a.id === accountId)) === null || _accounts_find === void 0 ? void 0 : _accounts_find.name) || "";
            // -----------------------------------------------------------------------------------------------
            // Calculate positionOnDate
            // -----------------------------------------------------------------------------------------------
            // if the previous row has a positionOnDate already, add the current quantity it; otherwise start a new positionOnDate
            newObject.positionOnDate = positionOnDate;
            newObject.openPositionOnDate = openPositionOnDate;
            newObject.positionsPerProjectId = !prevItem.positionsPerProjectId ? {
                [curr.projectId || null]: positionOnDate || 0
            } : (0, $2qxEV._)((0, $9tqwB._)({}, prevItem.positionsPerProjectId), {
                [(curr === null || curr === void 0 ? void 0 : curr.projectId) || null]: (prevItem.positionsPerProjectId[(curr === null || curr === void 0 ? void 0 : curr.projectId) || null] || 0) + (curr.quantity || 0)
            });
        } else {
            // positionOnDate is the same as the previous row
            newObject.positionOnDate = prevItem.positionOnDate || 0;
            newObject.openPositionOnDate = prevItem.openPositionOnDate || 0;
        }
        // -----------------------------------------------------------------------------------------------
        // Calculate the PAYOUT / FEE PER PIECE (dividend / interest / rent / fees / costs)
        // -----------------------------------------------------------------------------------------------
        let payoutOrFeePerPiece = 0;
        let payoutOrFeeTotalOpenQuantity = 0;
        // costs are passed from CAV as fees already (in proportion to the amount of assets in account)
        // if (curr.label && ['investment-fees', 'investment-dividend', 'investment-interest', 'investment-rent'].includes(curr.label)) { FIX PL 240326 because why not?
        if (curr.label && (0, $a368196802fe263c$export$c3326d1eadff13bd).includes(curr.label)) {
            // calculate payout per owned piece
            payoutOrFeePerPiece = curr.quantity * curr.upbc / positionOnDate;
            newObject.payoutOrFeePerPiece = payoutOrFeePerPiece;
            payoutOrFeeTotalOpenQuantity = payoutOrFeePerPiece * openPositionOnDate;
            // calculate total for all pieces still owned at current date
            if (payoutOrFeePerPiece < 0) {
                newObject.feesTotalOpenQuantity = (prevItem.feesTotalOpenQuantity || 0) + payoutOrFeeTotalOpenQuantity;
                newObject.payoutTotalOpenQuantity = prevItem.payoutTotalOpenQuantity || 0; // carry over the other one
            } else {
                newObject.payoutTotalOpenQuantity = (prevItem.payoutTotalOpenQuantity || 0) + payoutOrFeeTotalOpenQuantity;
                newObject.feesTotalOpenQuantity = prevItem.feesTotalOpenQuantity || 0; // carry over the other one
            }
            // add payoutOrFeePerPiece to each purchase transaction that came before then and is awaiting weighted annualised ROI calculation
            newObject.annualisedRoiArray = (prevItem.annualisedRoiArray || []).map((item)=>{
                const newItem = (0, $9tqwB._)({}, item);
                if (typeof payoutOrFeePerPiece !== "number") throw new Error(`payoutOrFeePerPiece is not a number ${curr}`);
                newItem.payoutsOrFeesPerPiece += payoutOrFeePerPiece;
                return newItem;
            });
        } else {
            // carry over if nothing changes
            newObject.payoutTotalOpenQuantity = prevItem.payoutTotalOpenQuantity || 0;
            newObject.feesTotalOpenQuantity = prevItem.feesTotalOpenQuantity || 0;
        }
        // -----------------------------------------------------------------------------------------------
        // Calculate ANNUALISED ROI for each purchase transaction and push it to an array
        // (to be finalised in reporting selectors)
        // -----------------------------------------------------------------------------------------------
        // annualised ROI must also consider payouts and fees for the transaction in question
        if (!newObject.annualisedRoiArray) newObject.annualisedRoiArray = [];
        if (rowType === "purchase") // for each purchase transaction add the components for calculation of transaction-based annualised ROI
        // each subsequent payout / fee transaction will add perPiece values to each purchase transaction that came before then (not here - it's where we handle them above)
        newObject.annualisedRoiArray = [
            ...prevItem.annualisedRoiArray || [],
            {
                quantityOpen: quantityOpen,
                upbc: upbc,
                yearsElapsed: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().diff(date, "day") / 365,
                payoutsOrFeesPerPiece: 0
            }
        ];
        else if (payoutOrFeePerPiece === 0) newObject.annualisedRoiArray = prevItem.annualisedRoiArray; // carry over if nothing else changes (remember this changes with some labels above too)
        // kpi.current is the last row, so we can calculate the weighted ROI here
        if (rowType === "kpi.current") {
            // adds an array of annualised ROIs for each purchase transaction with payouts and fees (we need currentValue AND payouts and fees per each purchase transaction to calculate this)
            // for the quantity which is still open, calculate annualised ROI (considering price changes since purchase as well all payouts and fees)
            const annualisedRoiArray = (prevItem.annualisedRoiArray || []).map((item)=>{
                try {
                    var _quotes_assetId_current, _quotes_assetId;
                    const { quantityOpen: _quantityOpen, upbc: _upbc, date: _date, yearsElapsed: yearsElapsed, payoutsOrFeesPerPiece: payoutsOrFeesPerPiece } = item;
                    if (_quantityOpen === 0) return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                        annualisedRoi: 0
                    }); // handle division by 0
                    var _quotes_assetId_current_quoteBaseCurrency;
                    // If current quote is missing, fall back to purchase price (no price-change contribution).
                    const currentQuoteBaseCurrency = (_quotes_assetId_current_quoteBaseCurrency = (_quotes_assetId = quotes[assetId]) === null || _quotes_assetId === void 0 ? void 0 : (_quotes_assetId_current = _quotes_assetId.current) === null || _quotes_assetId_current === void 0 ? void 0 : _quotes_assetId_current.quoteBaseCurrency) !== null && _quotes_assetId_current_quoteBaseCurrency !== void 0 ? _quotes_assetId_current_quoteBaseCurrency : _upbc;
                    return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                        annualisedRoi: (_quantityOpen * (currentQuoteBaseCurrency + payoutsOrFeesPerPiece) / (_quantityOpen * _upbc)) ** (1 / yearsElapsed) - 1
                    });
                } catch (e) {
                    console.error("Error in annualisedRoiArray calculation", e);
                    console.info("item", JSON.stringify(item, null, 2));
                    throw new Error(e);
                }
            });
            // after we know each individual purchase transaction's annualised ROI, we can calculate the weighted average of all of them with quantityOpen as weight
            const sumWeights = (annualisedRoiArray || []).reduce((acc, item)=>acc + item.quantityOpen * item.upbc, 0); // sum up all weights
            const weightedAverage = sumWeights === 0 ? 0 : annualisedRoiArray.reduce((acc, item)=>acc + item.quantityOpen * item.upbc * item.annualisedRoi, 0) / sumWeights;
            newObject.weightedAverageAnnualisedRoi = weightedAverage;
        }
        return [
            ...prev,
            (0, $9tqwB._)({}, curr, newObject)
        ];
    }, []);
}
function $3679aa7475d9bd44$var$handleDepositTransactionForCAV(accounts, t) {
    // all labelled transactions are moved to assets (except for interest, which stay; tbh. own costs should stay as well, albeit they have not been set up yet)
    if ((0, $a368196802fe263c$export$c3326d1eadff13bd).includes(t.label)) {
        var _t_tags, _t_tags1, _find;
        // console.log('handleDepoisitTransactionForCAV', t);
        const rowType = t.label.split("-")[1]; // add rowType depending on label
        if (rowType === "interest") return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            rowType: rowType
        }); // interest stays in deposits
        // else move the transaction to the asset CAV grouping
        const newAccountId = ((_t_tags = t.tags) === null || _t_tags === void 0 ? void 0 : _t_tags.accountId) || "notFound"; // override category and accountId to move it to the right asset account
        const newAssetId = ((_t_tags1 = t.tags) === null || _t_tags1 === void 0 ? void 0 : _t_tags1.assetId) || "notFound"; // override category and accountId to move it to the right asset account
        const category = (_find = (accounts || []).find((a)=>a.id === newAccountId)) === null || _find === void 0 ? void 0 : _find.category;
        return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            rowType: rowType,
            category: category,
            accountId: newAccountId,
            assetId: newAssetId
        });
    }
    // else it is a non-labelled transaction
    const rowType = t.amount >= 0 ? "purchase" : "sale"; // add rowType depending on label
    return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
        rowType: rowType,
        amountAssetCurrency: t.accountCurrencyAmount
    });
}
function $3679aa7475d9bd44$var$handleAssetTransactionForCAV(t) {
    const rowType = t.quantity >= 0 ? "purchase" : "sale";
    return (0, $2qxEV._)((0, $9tqwB._)({}, t), {
        rowType: rowType
    });
}
const $3679aa7475d9bd44$export$70d960c2428e363b = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$6d68928c2b6ce1a6, $93bb2798871a68d2$export$8c577782bb016c47, (state)=>state.simulation.dashboardMode, $93bb2798871a68d2$export$4bb039911f93bce, $93bb2798871a68d2$export$443f4a6ebd922e0a, function completeAssetViewCallback(_allTransactions, accounts, dashboardMode, baselineView, quotesView) {
    // transform incoming transactions
    const data = _allTransactions// filter out transactionType === 'split', because it causes problems to calculate positionOnDate and valueOnDate
    .filter((t)=>t.transactionType !== "split").map((t)=>{
        // labelled deposits are moved to the pertaining asset account + transformations for all categories respectively
        const t2 = t.category === "deposits" ? $3679aa7475d9bd44$var$handleDepositTransactionForCAV(accounts, t) : $3679aa7475d9bd44$var$handleAssetTransactionForCAV(t, dashboardMode);
        return t2;
    });
    // group by category, accountId, assetId
    // FIXME this is assetBalances, isn't it?
    const grouped = (0, $3e6d58b7292c657b$export$3f063810d7bf01bd)(data, [
        "category",
        "accountId",
        "assetId"
    ]);
    // results in { category: { accountId: { assetId: [transactions] } } }
    // for each assetId array run helper and updated 'grouped' array
    Object.keys(grouped).forEach((category)=>{
        Object.keys(grouped[category]).forEach((accountId)=>{
            Object.keys(grouped[category][accountId]).forEach((assetId)=>{
                // handle account-wide costs for all categories except for real estate (there accountId is always equal to assetId)
                let costTransactionsForAssets = [];
                if (category !== "realEstate" && accountId !== assetId) {
                    // how many are there assets in this account?
                    // this gets a list of all keys (assetIds) under this accountId (they must not be equal to accountId)
                    const assetsInThisAccount = Object.keys(grouped[category][accountId]);
                    // is there an assetId === accountId?
                    if (assetsInThisAccount.includes(accountId)) {
                        const numberOfAssets = assetsInThisAccount.filter((t)=>t !== accountId).length;
                        // move all account-level costs to assets, in proportion to how many assets there are in the account (like we do in Table)
                        costTransactionsForAssets = grouped[category][accountId][accountId].filter((t)=>t.label === "investment-costs").map((t)=>(0, $2qxEV._)((0, $9tqwB._)({}, t), {
                                accountLevelCost: true,
                                label: "investment-fees",
                                rowType: "fees",
                                quantity: t.quantity / numberOfAssets,
                                quantityOpen: t.quantityOpen / numberOfAssets
                            }));
                    // console.log('CAV costTransactionsForAssets', costTransactionsForAssets);
                    }
                }
                grouped[category][accountId][assetId] = $3679aa7475d9bd44$var$cavHelper(baselineView, quotesView, grouped[category][accountId][assetId].concat(costTransactionsForAssets), assetId, accounts);
            });
        });
    });
    // console.info('CAV', grouped);
    return grouped;
});






var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

/* eslint-disable no-promise-executor-return */ 
var $9tqwB = parcelRequire("9tqwB");


async function $8c33eba47c0a2532$var$callApi(method, payload, resource) {
    var _session_tokens_idToken, _session_tokens;
    const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
    const myInit = {
        headers: {
            "Content-Type": "application/json",
            Authorization: (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString()
        }
    };
    if (payload !== null && payload !== undefined) myInit.body = payload;
    let response;
    try {
        if (method === "get") response = await (0, $bad5f4197326a006$export$b216272c8be3751a)("myAPI", `projects/${resource}`, myInit);
        if (method === "post") response = await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", `projects/${resource}`, myInit);
        if (method === "put") response = await (0, $bad5f4197326a006$export$6dd598fa143977b0)("myAPI", `projects/${resource}`, myInit);
        if (method === "delete") response = await (0, $bad5f4197326a006$export$bb2abc1fe2f1c239)("myAPI", `projects/${resource}`, myInit);
    } catch (error) {
        console.log("Error while accessing API", error.response);
        throw new Error(error);
    }
    return response;
}
async function $8c33eba47c0a2532$var$getData() {
    // returns array of all projects
    try {
        const data = await $8c33eba47c0a2532$var$callApi("get", null, "");
        return data;
    } catch (e) {
        console.error("Error while accessing projects > getData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $8c33eba47c0a2532$var$postData(payload) {
    // payload is a single, complete project object
    try {
        const data = await $8c33eba47c0a2532$var$callApi("post", payload, "");
        return (0, $9tqwB._)({}, data);
    } catch (e) {
        console.error("Error while accessing projects > postData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $8c33eba47c0a2532$var$putData(payload) {
    try {
        const data = await $8c33eba47c0a2532$var$callApi("put", payload, "");
        return (0, $9tqwB._)({}, data);
    } catch (e) {
        console.error("Error while accessing projects > putData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $8c33eba47c0a2532$var$deleteData(payload) {
    try {
        const data = await $8c33eba47c0a2532$var$callApi("delete", payload, "");
        return (0, $9tqwB._)({}, data);
    } catch (e) {
        console.error("Error while accessing projects > deleteData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
var $8c33eba47c0a2532$export$2e2bcd8739ae039 = {
    getData: $8c33eba47c0a2532$var$getData,
    postData: $8c33eba47c0a2532$var$postData,
    putData: $8c33eba47c0a2532$var$putData,
    deleteData: $8c33eba47c0a2532$var$deleteData
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



/* eslint-disable import/prefer-default-export */ 
var $9tqwB = parcelRequire("9tqwB");



/* eslint-disable no-promise-executor-return */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


async function $3a090788e54645c9$var$callApi(method, payload, resource) {
    var _session_tokens_idToken, _session_tokens;
    const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
    const myInit = {
        headers: {
            "Content-Type": "application/json",
            Authorization: (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString()
        }
    };
    if (payload !== null && payload !== undefined) myInit.body = payload;
    let response;
    try {
        if (method === "get") response = await (0, $bad5f4197326a006$export$b216272c8be3751a)("myAPI", `stocks/${resource}`, myInit);
        if (method === "post") response = await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", `stocks/${resource}`, myInit);
        if (method === "put") response = await (0, $bad5f4197326a006$export$6dd598fa143977b0)("myAPI", `stocks/${resource}`, myInit);
        if (method === "delete") response = await (0, $bad5f4197326a006$export$bb2abc1fe2f1c239)("myAPI", `stocks/${resource}`, myInit);
    } catch (error) {
        console.log("Error while accessing API", error);
        throw new Error(error);
    }
    return response;
}
async function $3a090788e54645c9$var$getSettings() {
    try {
        const data = await $3a090788e54645c9$var$callApi("get", null, "settings");
        return data;
    } catch (e) {
        console.error("Error while accessing stocks > getSettings API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$getData() {
    try {
        const data = await $3a090788e54645c9$var$callApi("get", null, "data");
        return (0, $2qxEV._)((0, $9tqwB._)({}, data), {
            status: "noerrors"
        });
    } catch (e) {
        console.error("Error while accessing stocks > getData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$getDataByAccount(accountId) {
    try {
        const data = await $3a090788e54645c9$var$callApi("get", null, `data/accounts/${accountId}`);
        return (0, $2qxEV._)((0, $9tqwB._)({}, data), {
            status: "noerrors"
        });
    } catch (e) {
        console.error("Error while accessing stocks > getData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
const $3a090788e54645c9$var$clearData = ()=>0;
async function $3a090788e54645c9$var$postData(payload) {
    // expected payload: [{transaction1}, {transaction2}, ...]
    // transactions must be complete (all fields provided)
    try {
        const result = await $3a090788e54645c9$var$callApi("post", payload, "transactions");
        return result; // returns validated transactions
    } catch (e) {
        console.error("Error while accessing stocks > postData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$postAccount(payload) {
    try {
        const response = await $3a090788e54645c9$var$callApi("post", payload, "accounts");
        return response;
    } catch (e) {
        console.error("Error while accessing stocks > postAccount API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$putAccount(payload) {
    try {
        const response = await $3a090788e54645c9$var$callApi("put", payload, "accounts");
        return response;
    } catch (e) {
        console.error("Error while accessing stocks > putAccount API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$deleteAccount(payload) {
    try {
        const response = await $3a090788e54645c9$var$callApi("delete", payload, "accounts");
        return response;
    } catch (e) {
        console.error("Error while accessing stocks > deleteAccount API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$postSettings(payload) {
    try {
        const response = await $3a090788e54645c9$var$callApi("post", payload, "settings");
        return response;
    } catch (e) {
        console.error("Error while accessing stocks > postSettings API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$putSettings(payload) {
    try {
        const response = await $3a090788e54645c9$var$callApi("put", payload, "settings");
        return response;
    } catch (e) {
        console.error("Error while accessing stocks > putSettings API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $3a090788e54645c9$var$deleteSettings(payload) {
    try {
        const response = await $3a090788e54645c9$var$callApi("delete", payload, "settings");
        return response;
    } catch (e) {
        console.error("Error while accessing stocks > deleteSettings API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
// common function which polls for status and then is supposed to call the correct service and return data
async function $3a090788e54645c9$var$pollForData(batchIds) {
    // simulated polling request with getStatusPerBatchId
    await new Promise((r)=>setTimeout(r, 1500));
    // expected response:
    const status = batchIds.map((batchId)=>({
            batchId: batchId,
            status: "noerrors"
        }));
    // LOGIC BASED ON STATUS:
    // if status noerrors --> do getCleanData(batchIds)
    await new Promise((r)=>setTimeout(r, 1500));
// expected response: portion of data for the batchIds
// const response = data.transactions.filter((t) => batchIds.includes(t.batchId));
// if status awaitingMapping --> do getMappingDataPerBatchId(batchIds) // doesn't apply for grid
// if status errors --> do getErrorDataPerBatchId(batchIds)
// if (Math.random() > 1) return { ...data, status: 'errors' };
// return { ...data, status: 'noerrors' };
}
// wrapper to be called from actions
async function $3a090788e54645c9$var$postMappingData(payload, batchId) {
    // simulated POST request
    await new Promise((r)=>setTimeout(r, 500));
    // simulated polling request
    const response = await $3a090788e54645c9$var$pollForData([
        batchId
    ]);
    return response;
}
// this is doing two things:
// - post data
// - get the data containing the freshly posted data from Category Service
async function $3a090788e54645c9$var$postFile(payload) {
    // simulated POST request
    await new Promise((r)=>setTimeout(r, 500));
    // TODO here be the file column reconciliation bit
    // simulated polling request
    await new Promise((r)=>setTimeout(r, 1500));
// if (Math.random() > 1) return { ...data, status: 'errors' };
// return { ...data, status: 'noerrors' };
// throw new Error('Simulated error');
}
var $3a090788e54645c9$export$2e2bcd8739ae039 = {
    getData: $3a090788e54645c9$var$getData,
    getDataByAccount: $3a090788e54645c9$var$getDataByAccount,
    clearData: $3a090788e54645c9$var$clearData,
    postData: $3a090788e54645c9$var$postData,
    postFile: $3a090788e54645c9$var$postFile,
    postMappingData: $3a090788e54645c9$var$postMappingData,
    postAccount: $3a090788e54645c9$var$postAccount,
    putAccount: $3a090788e54645c9$var$putAccount,
    deleteAccount: $3a090788e54645c9$var$deleteAccount,
    postSettings: $3a090788e54645c9$var$postSettings,
    putSettings: $3a090788e54645c9$var$putSettings,
    deleteSettings: $3a090788e54645c9$var$deleteSettings,
    getSettings: $3a090788e54645c9$var$getSettings
};



const $c9d1d0ef1233f6f9$export$3d2507cede480fd4 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $0840a3787500c813$export$8ebe3f77c9e07491),
            payload: {
                category: "stocks"
            }
        });
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).getSettings().then((data)=>{
            // we expect { setting1: 'Value', setting2: 'Value', ... }
            dispatch({
                type: (0, $0840a3787500c813$export$52adc266e78d1cf9),
                // when set automatically via terraform this is an object already, when set manually it is a string
                payload: typeof data === "string" ? JSON.parse(data) : data
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f099dfdea5c944b8),
                payload: {
                    category: "stocks"
                }
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "dataUpdateError"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f099dfdea5c944b8),
                payload: {
                    category: "stocks"
                }
            });
            return null;
        });
    };
const $c9d1d0ef1233f6f9$export$c107f73be62f04f4 = ()=>(dispatch, getState)=>{
        dispatch({
            type: (0, $0840a3787500c813$export$8ebe3f77c9e07491),
            payload: {
                category: "stocks"
            }
        });
        dispatch($c9d1d0ef1233f6f9$export$3d2507cede480fd4());
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).getData().then((data)=>{
            // returns { transactions: [], accounts: [], status: 'noerrors' }
            // get quotes for the retrieved transactions
            const { baseline: baseline, referenceBaseline: referenceBaseline, current: current } = (0, $93bb2798871a68d2$export$4bb039911f93bce)(getState());
            // this could be a .then if we want to wait for the quotes to be retrieved before updating the store
            dispatch((0, $b38588f9e2856d34$export$2e2bcd8739ae039)({
                scopes: (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
                    transactions: data.transactions.filter((tx)=>[
                            "purchase",
                            "sale"
                        ].includes(tx.transactionType)),
                    requiredDates: (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)([
                        baseline,
                        referenceBaseline,
                        current
                    ])
                })
            }));
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                payload: {
                    stocks: {
                        accounts: data.accounts
                    },
                    status: data.status
                }
            });
            // upload non-simulated data to store
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                payload: {
                    stocks: {
                        transactions: (data.transactions || []).filter((transaction)=>!transaction.isSimulated)
                    },
                    status: "noerrors"
                }
            });
            // upload simulated data to store
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                payload: {
                    stocks: {
                        simulatedTransactions: (data.transactions || []).filter((transaction)=>!!transaction.isSimulated)
                    },
                    status: "noerrors"
                }
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f099dfdea5c944b8),
                payload: {
                    category: "stocks"
                }
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "dataUpdateError"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f099dfdea5c944b8),
                payload: {
                    category: "stocks"
                }
            });
            return Promise.reject();
        });
    };
const $c9d1d0ef1233f6f9$export$ccb8c9e7767ba586 = (accountId)=>(dispatch)=>{
        dispatch({
            type: (0, $0840a3787500c813$export$18314edbcf1d3e19),
            payload: {
                category: "stocks",
                accountId: accountId
            }
        });
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).getDataByAccount(accountId).then((data)=>{
            // returns { transactions: [], status: 'noerrors' }
            dispatch({
                type: (0, $0840a3787500c813$export$ecdcb9b94b2afdcd),
                caller: "stocksPostData",
                payload: {
                    stocks: (0, $9tqwB._)({}, data)
                }
            });
            dispatch({
                type: (0, $0840a3787500c813$export$8fc3d65634883eae),
                payload: {
                    category: "stocks",
                    accountId: accountId
                }
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "dataUpdateError"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$8fc3d65634883eae),
                payload: {
                    category: "stocks",
                    accountId: accountId
                }
            });
            return Promise.reject();
        });
    };
function $c9d1d0ef1233f6f9$export$a64fff0b451c97f2(payload, accountId) {
    return async function postStocksDataThunk(dispatch) {
        dispatch({
            type: (0, $0840a3787500c813$export$18314edbcf1d3e19),
            payload: {
                category: "stocks",
                accountId: accountId
            }
        });
        try {
            const data = await (0, $3a090788e54645c9$export$2e2bcd8739ae039).postData(payload);
            // upload non-simulated data to store
            dispatch({
                type: (0, $0840a3787500c813$export$ecdcb9b94b2afdcd),
                caller: "stocksPostData",
                payload: {
                    stocks: {
                        transactions: (data.transactions || []).filter((transaction)=>!transaction.isSimulated)
                    },
                    status: "noerrors"
                }
            });
            // upload simulated data to store
            dispatch({
                type: (0, $0840a3787500c813$export$ecdcb9b94b2afdcd),
                payload: {
                    stocks: {
                        simulatedTransactions: (data.transactions || []).filter((transaction)=>!!transaction.isSimulated)
                    },
                    status: "noerrors"
                }
            });
            if (data.status === "noerrors") dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "dataUpdatedSuccessfully"
            });
            else dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "dataUpdatedWithErrors"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$8fc3d65634883eae),
                payload: {
                    category: "stocks",
                    accountId: accountId
                }
            });
            return {
                status: "success",
                data: data
            };
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "dataUpdateProblems"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$94e5d19a4914d842),
                payload: {
                    category: "stocks",
                    accountId: accountId
                }
            });
            return {
                status: "error",
                error: error
            };
        }
    };
}
const $c9d1d0ef1233f6f9$export$71d1b45c9fc87997 = (payload)=>(dispatch)=>{
        // go post data
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).postAccount(payload).then(// returns { status: 'noerrors', accounts: [{account-object}] }
        (data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                callerId: "stocksPostAccount",
                payload: {
                    status: data.status,
                    stocks: {
                        accounts: data.accounts
                    }
                }
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountCreatedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$e55e36ad40193eb1),
                callerId: "stocksPostAccount"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountCouldNotBeCreated"
            });
            return Promise.reject();
        });
    };
const $c9d1d0ef1233f6f9$export$5c84a0791ca8b5e3 = (payload)=>(dispatch)=>{
        // payload is an object with attributes of state.data.stocks.settings in it, like { growthRate: 0.1, dividendYieldRates: [ ACN: 1.11, GM: 2.22, ...], ...}
        // the attributes will overwrite the same attributes in store
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).postSettings(payload).then(// returns { status: 'noerrors', settings: {settings-object} }
        (data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$52adc266e78d1cf9),
                payload: data
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountUpdatedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountCouldNotBeUpdated"
            });
            return Promise.reject();
        });
    };
const $c9d1d0ef1233f6f9$export$64ebf73f0218161c = (payload)=>(dispatch)=>{
        // payload is an object with attributes of state.data.stocks.settings in it, like { growthRate: 0.1, dividendYieldRates: [ ACN: 1.11, GM: 2.22, ...], ...}
        // the attributes will overwrite the same attributes in store
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).putSettings(payload).then(// returns { status: 'noerrors', settings: {settings-object} }
        (data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$52adc266e78d1cf9),
                payload: data
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountUpdatedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountCouldNotBeUpdated"
            });
            return Promise.reject();
        });
    };
const $c9d1d0ef1233f6f9$export$85cfd49285d05003 = (payload)=>(dispatch)=>{
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).putAccount(payload).then(// returns { status: 'noerrors', accounts: [{account-object}] }
        (data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                caller: "stocksPutAccount",
                payload: {
                    status: data.status,
                    stocks: {
                        accounts: data.accounts
                    }
                }
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountUpdatedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$e55e36ad40193eb1),
                caller: "stocksPutAccount"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountCouldNotBeUpdated"
            });
            return Promise.reject();
        });
    };
const $c9d1d0ef1233f6f9$export$670178f8cdaa8d7 = (payload)=>(dispatch)=>{
        (0, $3a090788e54645c9$export$2e2bcd8739ae039).deleteAccount(payload).then(// returns { status: 'noerrors', accounts: [{account-object}], transactions: ... }
        (data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                caller: "stocksDeleteAccountAccounts",
                payload: {
                    status: data.status,
                    stocks: {
                        accounts: data.accounts
                    }
                }
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f5c41f548f91b6d0),
                caller: "stocksDeleteAccountTransactions",
                payload: {
                    status: data.status,
                    stocks: {
                        transactions: data.transactions
                    }
                }
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountDeletedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$e55e36ad40193eb1),
                caller: "stocksDeleteAccount"
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "accountCouldNotBeUpdated"
            });
            return Promise.reject();
        });
    };


const $f2037232653a5c1d$export$6108e6a1856d96f2 = (payload, final = false)=>(dispatch)=>{
        // this is triggered when a user rearranges the order of transactions in a project
        // payload will be two transactions with updated sortingOrderWithinMonth fields
        // they will not necessarily come from the same category (!)
        // expected payload is an array with two full, canonical transactions
        // which will be uploaded to the state verbatim
        // final is a boolean indicating whether this is the final update
        // some updates are temporary and are not meant to be reflected in the database
        // the plan is to update the state first in this case (user expects a quick action)
        // and sent the postData orders to the server in the background, without error notifications if it fail
        // if this results to be buggy, we will need to add a spinner after each move (in the date component)
        // update state with the new sorting order
        dispatch({
            type: (0, $0840a3787500c813$export$ae9959ae2f1008b7),
            payload: payload
        });
        // do postData depending on category(!) (no post-postData state update anymore)
        // error behaviour: no error notification, just a console.log
        if (final) (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
            data: payload,
            category: "deposits",
            accountId: payload[0].accountId
        })// returns { status: 'noerrors', accounts: [{account-object}] with importFlags }
        // we are not updating the state here, as the state has been pre-updated above
        .then((data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$a6698c9cc0030073),
                payload: {}
            });
            if (data.status !== "noerrors") console.error("postNewProjectSortingOrder: postData returned errors in data.status");
            return Promise.resolve();
        }, (error)=>{
            // handles promise rejection
            console.error("postNewProjectSortingOrder: postData returned errors", error);
            return Promise.reject();
        });
    };
function $f2037232653a5c1d$export$942e92bd9e040eb(payload, cancelSignal = {
    aborted: false
}) {
    payload.forEach((item)=>{
        if (!item.category) console.error("postData wrapper: transaction is missing a category attribute:", item);
    });
    // get payload to an object { deposits: { accountId: [transaction-objects], accountId2: [transaction-objects] }, stocks: { ... } }
    const payloadByCategory = payload.reduce((acc, item)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [item.category]: (0, $2qxEV._)((0, $9tqwB._)({}, acc[item.category]), {
                [item.accountId]: [
                    ...(acc[item.category] || {})[item.accountId] || [],
                    item
                ]
            })
        }), {});
    return (dispatch)=>{
        // dispatch data to the correct category service by category, in bulk
        // postData accepts only data per account afair
        Object.keys(payloadByCategory).forEach((item)=>{
            Object.keys(payloadByCategory[item]).forEach((accountId)=>{
                dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                    data: payloadByCategory[item][accountId],
                    category: item,
                    accountId: accountId,
                    cancelSignal: cancelSignal
                }));
            });
        });
    };
}
function $f2037232653a5c1d$export$358e33178568ae3d(payload) {
    if (!payload.category) console.error("postAccount wrapper: account object is missing a category attribute:", payload);
    console.error("putMixedAccount", payload);
    return (dispatch)=>{
        // dispatch data to the correct category service by category, in bulk
        (0, $f1c3fa004749592f$export$391c5b9a9263706a)({
            data: payload,
            category: payload.category
        });
    };
}
function $f2037232653a5c1d$export$4741711f07dbb8e7(payload) {
    function validateTransaction(transaction, category) {
        // validate the transaction object, returns true if valid, false if not
        let schema;
        switch(category){
            case "deposits":
                schema = (0, $2119005918cddc33$export$d0605de541b472d8);
                break;
            case "stocks":
                schema = (0, $258697da394e7920$export$4f051dd78ba8e887);
                break;
            case "realEstate":
                schema = (0, $3a1ecd75ab1ea382$export$6ee7acc2fdcedc63);
                break;
            case "loans":
                schema = (0, $5c401a4958c7a09c$export$95eff6423824c31b);
                break;
            case "pension":
                schema = (0, $5ee4f29aaf60da17$export$45ff471291978734);
                break;
            case "objectsOfValue":
                schema = (0, $81cfed1660055fbf$export$4c255d423d7ada4d);
                break;
            case "metals":
                schema = (0, $e6c81a32d5e10529$export$b261d2cf836a96cd);
                break;
            case "unlistedShares":
                schema = (0, $f2b6f6a77877e6cd$export$8eb3d3642b459f58);
                break;
            case "crypto":
                schema = (0, $1a8d54f71278e6b1$export$7a517006b20774e);
                break;
            default:
                throw new Error(`User-defined error in validateSchema: no schema found for category ${category}`);
        }
        const castTransaction = schema.cast(transaction);
        return schema.validateSync(castTransaction, {
            abortEarly: false
        });
    }
    const validatedTransaction = validateTransaction(payload.transaction, payload.category);
    return {
        category: payload.category,
        transaction: validatedTransaction,
        validation: validatedTransaction !== null
    };
}



function $101425bdfe5b6af9$export$b00a271f69f3d728() {
    return async function getProjectsThunk(dispatch) {
        let data;
        try {
            data = await (0, $8c33eba47c0a2532$export$2e2bcd8739ae039).getData();
            dispatch({
                type: (0, $0840a3787500c813$export$f29c717e71981e5a),
                payload: data
            });
            return;
        } catch (error) {
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.log(message);
            dispatch({
                type: (0, $0840a3787500c813$export$80346ac49821b129)
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: {
                    message: message
                }
            });
        }
    };
}
const $101425bdfe5b6af9$export$757a8a8481b26284 = (payload)=>(dispatch, getState)=>{
        // get a snapshot of current Project object in case of API call fails and we will need to roll it back
        const prevState = getState().projects.filter((p)=>p.id === payload.id);
        dispatch({
            type: (0, $0840a3787500c813$export$15bdd6f74fffda24),
            payload: payload
        });
        // if the thing being changed
        dispatch({
            type: (0, $0840a3787500c813$export$a4c351e5b9b68a40),
            payload: {
                callerId: payload.id,
                message: "projectPostPutFinished"
            }
        });
        (0, $8c33eba47c0a2532$export$2e2bcd8739ae039).postData(payload).then((data)=>Promise.resolve(), (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.log(message);
            // revert state to previous state
            dispatch({
                type: (0, $0840a3787500c813$export$688b2f09bbdcf053),
                payload: prevState
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: {
                    message: "dataUpdateError"
                }
            });
            return Promise.reject();
        });
    };
const $101425bdfe5b6af9$export$d7ff2361273ba2c2 = (payload)=>(dispatch, getState)=>{
        dispatch({
            type: "SET_APP_SIGNAL",
            payload: {
                callerId: payload.id,
                message: "deleteProject"
            }
        });
        return Promise.resolve((0, $8c33eba47c0a2532$export$2e2bcd8739ae039).deleteData(payload).then(// eslint-disable-next-line arrow-body-style
        (data)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$80f5d6a1a3225791),
                payload: {
                    callerId: payload.id
                }
            });
            // get a list of all transactions with projectId from allTransactionsProjectView (to also get transactions beyond current slider date)
            const transactions = (0, $3679aa7475d9bd44$export$cff1b0a315c5dec8)(getState()).filter((t)=>t.projectId === payload.id);
            // dispatch postMixedData with importFlag of 'delete' for all transactions
            dispatch((0, $f2037232653a5c1d$export$942e92bd9e040eb)(transactions.map((t)=>(0, $2qxEV._)((0, $9tqwB._)({}, t), {
                    importFlag: "delete"
                }))));
            return dispatch({
                type: (0, $0840a3787500c813$export$7ce38f165121a0d2),
                payload: payload
            });
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            console.error(message);
            dispatch({
                type: (0, $0840a3787500c813$export$80f5d6a1a3225791),
                payload: {
                    callerId: payload.id
                }
            });
            return dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: {
                    message: "projectUpdateError"
                }
            });
        }));
    };
const $101425bdfe5b6af9$export$e71a6698fc19e7be = $101425bdfe5b6af9$export$757a8a8481b26284;


// used in AssetGrowthRate form as well as in putStockSettings redux
const $6bea581af4ee4124$export$568554344c31bfb8 = {
    growthRate: 6.02,
    growthRateAdvancedMode: false,
    growthRates: [],
    dividendYield: 2.12,
    dividendYieldAdvancedMode: false,
    dividendYieldRates: [],
    crypto: {
        growthRate: 10,
        growthRateAdvancedMode: false,
        growthRates: []
    }
};
const $6bea581af4ee4124$export$3e042c74ad7d42ae = 1;












(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $f1c3fa004749592f$var$DATA_BOOTSTRAP_SESSION_KEY_PREFIX = "dataBootstrapDone:";
const $f1c3fa004749592f$var$inMemoryDataBootstrapFlags = {};
function $f1c3fa004749592f$var$getSessionStorage() {
    if (typeof window !== "undefined" && window.sessionStorage) return window.sessionStorage;
    if (typeof sessionStorage !== "undefined") return sessionStorage;
    return null;
}
function $f1c3fa004749592f$var$getDataBootstrapSessionKey(category) {
    return `${$f1c3fa004749592f$var$DATA_BOOTSTRAP_SESSION_KEY_PREFIX}${category}`;
}
function $f1c3fa004749592f$var$hasDataBootstrapRun(category) {
    const sessionKey = $f1c3fa004749592f$var$getDataBootstrapSessionKey(category);
    const storage = $f1c3fa004749592f$var$getSessionStorage();
    if (storage) return storage.getItem(sessionKey) === "1";
    return $f1c3fa004749592f$var$inMemoryDataBootstrapFlags[sessionKey] === "1";
}
function $f1c3fa004749592f$var$markDataBootstrapDone(category) {
    const sessionKey = $f1c3fa004749592f$var$getDataBootstrapSessionKey(category);
    const storage = $f1c3fa004749592f$var$getSessionStorage();
    if (storage) storage.setItem(sessionKey, "1");
    $f1c3fa004749592f$var$inMemoryDataBootstrapFlags[sessionKey] = "1";
}
function $f1c3fa004749592f$var$clearDataBootstrapDone(category) {
    const sessionKey = $f1c3fa004749592f$var$getDataBootstrapSessionKey(category);
    const storage = $f1c3fa004749592f$var$getSessionStorage();
    if (storage) storage.removeItem(sessionKey);
    delete $f1c3fa004749592f$var$inMemoryDataBootstrapFlags[sessionKey];
}
// status 'inactive' is relevant for postFile being exposed to the endpoint
// Dashboard has to wait until we know that all getData have run (they end either in success or in error)
const $f1c3fa004749592f$var$initialState = {
    deposits: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    },
    stocks: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        settings: {},
        batchIds: null
    },
    realEstate: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: []
    },
    loans: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    },
    pension: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    },
    objectsOfValue: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    },
    metals: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    },
    unlistedShares: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    },
    crypto: {
        status: "loading",
        accounts: [],
        transactions: [],
        simulatedTransactions: [],
        batchIds: null
    }
};
function $f1c3fa004749592f$var$parseIf(exp) {
    return typeof exp === "string" ? JSON.parse(exp) : exp;
}
async function $f1c3fa004749592f$var$prepCallToApi(body) {
    const headers = await (0, $10933498be24bbfd$export$3fa04bebf37c9013)({
        "Content-Type": "application/json"
    });
    const myInit = {
        headers: headers
    };
    if (body !== undefined) myInit.body = body;
    return myInit;
}
function $f1c3fa004749592f$var$getApiErrorStatus(error) {
    var _error_response, _error_$metadata;
    return (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) || (error === null || error === void 0 ? void 0 : error.statusCode) || (error === null || error === void 0 ? void 0 : (_error_$metadata = error.$metadata) === null || _error_$metadata === void 0 ? void 0 : _error_$metadata.httpStatusCode) || null;
}
function $f1c3fa004749592f$var$getApiErrorDetails(error) {
    var _error_response;
    return (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) || (error === null || error === void 0 ? void 0 : error.message) || error;
}
// runs on transactions received from APIs, just before they are added to the store
function $f1c3fa004749592f$var$getTransactionTransformationsCallback(category) {
    return function addGenericTransactionsFieldsCallback(item) {
        // TODO this needs to be also reflected in the backend database at some point; this is a workaround for PRD-1410
        // i.e. the currency conversion should probably me moved out of the category backend and into quotes for arch consistency (for current fx value)
        if (category === "deposits") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            originalUnitPrice: 1,
            unitPrice: 1,
            tags: $f1c3fa004749592f$var$parseIf(item.tags),
            category: // new universal selectors
            category,
            assetId: item.currency,
            // at the moment when the transaction gets created, the amount is already in account currency
            // we need to show user the original _value_ i.e. quantity * uptc (we never show quantity alone)
            quantity: item.accountCurrencyAmount,
            accountCurrency: item.currency,
            upac: 1,
            upbc: item.accountCurrencyAmount ? item.amount / item.accountCurrencyAmount : 1,
            uptc: item.fxAmount && item.accountCurrencyAmount ? item.fxAmount / item.accountCurrencyAmount : 1,
            transactionCurrency: item.fxCurrency || item.currency,
            transactionType: item.accountCurrencyAmount >= 0 ? "purchase" : "sale"
        });
        if (category === "stocks" || category === "crypto") {
            const { linkedTransactions: linkedTransactions } = item;
            const parsedLT = $f1c3fa004749592f$var$parseIf(linkedTransactions) || [];
            let newLT;
            if (parsedLT.length > 0) // TODO move to backend remaps rebasedAmount and rebasedPrice to quantity and upbc / uptc
            newLT = parsedLT.map((lt)=>{
                var _lt_tags, _lt_tags1;
                if (lt.tags.type === "purchase") return (0, $2qxEV._)((0, $9tqwB._)({}, lt), {
                    tags: (0, $2qxEV._)((0, $9tqwB._)({}, lt.tags), {
                        quantity: (_lt_tags = lt.tags) === null || _lt_tags === void 0 ? void 0 : _lt_tags.rebasedAmount,
                        upbc: (_lt_tags1 = lt.tags) === null || _lt_tags1 === void 0 ? void 0 : _lt_tags1.rebasedPrice
                    })
                });
                return lt;
            });
            return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                originalUnitPrice: item.rebasedOriginalPrice,
                unitPrice: item.rebasedPrice,
                amount: item.amount || item.rebasedAmount,
                tags: $f1c3fa004749592f$var$parseIf(item.tags),
                linkedTransactions: newLT,
                category: // new universal selectors
                category,
                assetId: item.figi,
                quantity: item.rebasedAmount,
                upac: item.rebasedOriginalPrice,
                accountCurrency: item.transactionCurrency,
                upbc: item.rebasedPrice,
                uptc: item.rebasedOriginalPrice,
                transactionCurrency: item.transactionCurrency
            });
        }
        if (category === "realEstate") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            amount: item.amount || item.rebasedAmount,
            originalUnitPrice: item.rebasedOriginalPrice || item.originalPrice || 1,
            unitPrice: item.rebasedPrice || item.price || 1,
            tags: $f1c3fa004749592f$var$parseIf(item.tags),
            category: // new universal selectors
            category,
            assetId: item.accountId,
            quantity: Number(item.amount),
            // quantitySold, quantityOpen added in realEstateTransactions
            upac: item.originalPrice,
            accountCurrency: item.currency,
            upbc: item.price,
            uptc: item.originalPrice,
            transactionCurrency: item.currency,
            transactionType: Number(item.amount) >= 0 ? "purchase" : "sale"
        });
        if (category === "loans") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            category: category,
            quantity: Number(item.quantity),
            quantityInterest: Number(item.quantityInterest),
            upac: Number(item.upac),
            upbc: Number(item.upbc),
            uptc: Number(item.uptc),
            assetCurrency: item.accountCurrency,
            assetId: item.accountCurrency
        });
        if (category === "pension") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            category: category,
            quantity: Number(item.quantity),
            quantityInterest: Number(item.quantityInterest),
            upac: Number(item.upac),
            upbc: Number(item.upbc),
            uptc: Number(item.uptc),
            assetCurrency: item.accountCurrency,
            assetId: item.accountId
        });
        if (category === "objectsOfValue") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            category: category,
            quantity: Number(item.quantity),
            upac: Number(item.upac),
            upbc: Number(item.upbc),
            uptc: Number(item.uptc),
            assetCurrency: item.accountCurrency,
            assetId: item.accountId
        });
        if (category === "metals") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            category: category,
            quantity: Number(item.quantity),
            upac: Number(item.upac),
            upbc: Number(item.upbc),
            uptc: Number(item.uptc),
            assetCurrency: item.accountCurrency,
            // this field is calculated here; it is used in getQuotes API to calculate the current value of the asset based on pure metal market prices and its metal contents
            providerAssetId: {
                assetMetal: item.assetMetal,
                assetMetalWeight: item.assetWeight * (item.assetPurity / 1000)
            }
        });
        if (category === "unlistedShares") return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            category: category,
            quantity: Number(item.quantity),
            upac: Number(item.upac),
            upbc: Number(item.upbc),
            uptc: Number(item.uptc),
            assetCurrency: item.accountCurrency,
            assetId: item.accountId
        });
        return item;
    };
}
function $f1c3fa004749592f$var$getAccountTransformationCallback(category, state) {
    return function accountTransformationsCallback(a) {
        if (category === "loans") return (0, $2qxEV._)((0, $9tqwB._)({}, a), {
            category: category,
            loanAmount: Number(a.loanAmount),
            tags: $f1c3fa004749592f$var$parseIf(a.tags),
            period: $f1c3fa004749592f$var$parseIf(a.period),
            percentRepaidAnnually: $f1c3fa004749592f$var$parseIf(a.percentRepaidAnnually),
            interestRate: $f1c3fa004749592f$var$parseIf(a.interestRate),
            connectedDepositAccounts: $f1c3fa004749592f$var$parseIf(a.connectedDepositAccounts)
        });
        if (category === "pension") {
            const parsedCustomDiscountRate = a.customDiscountRate === "" || a.customDiscountRate === undefined || a.customDiscountRate === null ? null : Number(a.customDiscountRate);
            const hasExplicitDiscountMode = a.discountRateIsInflation === true || a.discountRateIsInflation === false;
            const defaultDiscountRateIsInflation = hasExplicitDiscountMode ? a.discountRateIsInflation : parsedCustomDiscountRate === null;
            return (0, $2qxEV._)((0, $9tqwB._)({}, a), {
                category: category,
                initialQuotes: $f1c3fa004749592f$var$parseIf(a.initialQuotes),
                contributionsAmounts: $f1c3fa004749592f$var$parseIf(a.contributionsAmounts),
                tags: $f1c3fa004749592f$var$parseIf(a.tags),
                connectedDepositAccounts: $f1c3fa004749592f$var$parseIf(a.connectedDepositAccounts),
                customDiscountRate: parsedCustomDiscountRate,
                // Legacy accounts may have neither discount mode nor custom rate set.
                // Defaulting to inflation keeps PV calculations non-zero and matches wizard defaults.
                discountRateIsInflation: defaultDiscountRateIsInflation
            });
        }
        return (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, a), {
            category: category,
            tags: $f1c3fa004749592f$var$parseIf(a.tags)
        }), a.valuationParameters && {
            valuationParameters: $f1c3fa004749592f$var$parseIf(a.valuationParameters)
        }), {
            importFileMappings: $f1c3fa004749592f$var$parseIf(a.importFileMappings)
        }), category !== "deposits" && {
            connectedDepositAccounts: $f1c3fa004749592f$var$parseIf(a.connectedDepositAccounts)
        });
    };
}
async function $f1c3fa004749592f$var$handleExpiredCredentialsError({ errorAccountObject: errorAccountObject, dispatch: dispatch, getState: getState, category: category }) {
    var _account_tags_provider_finapi, _account_tags_provider, _account_tags_provider_gocardless, _account_tags_provider1, _errorAccountObject_message_webForm, _errorAccountObject_message;
    console.log("handleExpiredCredentialsError for account", errorAccountObject);
    const state = getState();
    const account = (0, $93bb2798871a68d2$export$8c577782bb016c47)(state).find((a)=>a.id === errorAccountObject.accountId);
    console.log("handleExpiredCredentialsError: account", account);
    if (!account) return;
    const providerInstitutionId = ((_account_tags_provider = account.tags.provider) === null || _account_tags_provider === void 0 ? void 0 : (_account_tags_provider_finapi = _account_tags_provider.finapi) === null || _account_tags_provider_finapi === void 0 ? void 0 : _account_tags_provider_finapi.providerInstitutionId) || ((_account_tags_provider1 = account.tags.provider) === null || _account_tags_provider1 === void 0 ? void 0 : (_account_tags_provider_gocardless = _account_tags_provider1.gocardless) === null || _account_tags_provider_gocardless === void 0 ? void 0 : _account_tags_provider_gocardless.providerInstitutionId);
    const webFormUrl = (_errorAccountObject_message = errorAccountObject.message) === null || _errorAccountObject_message === void 0 ? void 0 : (_errorAccountObject_message_webForm = _errorAccountObject_message.webForm) === null || _errorAccountObject_message_webForm === void 0 ? void 0 : _errorAccountObject_message_webForm.url;
    const redirectUrl = `${window.location.origin}/addAccountCallback`;
    const abortUrl = `${window.location.origin}/${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language}/app/dashboard`;
    // show dialog to user
    window.dispatchEvent(new CustomEvent("setAlert", {
        detail: {
            id: "expiredCredentialsError",
            args: {
                accountName: account.name
            },
            caller: "getData",
            callbackOk: async ()=>{
                console.log("handleExpiredCredentialsError: starting call to API");
                const requestPayload = await $f1c3fa004749592f$var$prepCallToApi({
                    country: account.countryCode,
                    userLanguage: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language,
                    institutionId: providerInstitutionId,
                    redirectUrl: redirectUrl,
                    abortUrl: abortUrl
                });
                try {
                    // finApi already provides webFormUrl in error response, so we can use that
                    if (webFormUrl) {
                        // create localStorage object (to be reopened after coming back from webform in AddAccountCallbackReceiver / Dashboard)
                        // no need to store any additional parameters for finApi, because existing providerAccountIds remain unchanged
                        localStorage.setItem("renewAccountAccess", JSON.stringify({
                            accountId: errorAccountObject.accountId,
                            category: category
                        }));
                        // navigate to the web form
                        window.location.href = `${webFormUrl}?redirectUrl=${encodeURIComponent(redirectUrl)}&errorRedirectUrl=${encodeURIComponent(abortUrl)}&abortRedirectUrl=${encodeURIComponent(abortUrl)}`;
                    } else {
                        // returns { url, processId } or { url: null, processId: null, bankConnectionId, accounts } in the case handled just below
                        const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "deposits/webform", requestPayload);
                        console.log("handleExpiredCredentialsError: response from API", response);
                        // create localStorage object (to be reopened after coming back from webform in AddAccountCallbackReceiver / Dashboard);
                        // GC creates a new End-user Agreement ID + requsition ID with new providerAccountIds every time the EUA expires;
                        // we need to re-map our accountIds from old to new providerAccountIds by getting the new ones and mapping their IBANs to our IBANs in AddAccountCallbackReceiver;
                        // (we can retrieve the new providerAccountIds from the getAccountDetails service by processId (which is GC's requsition ID))
                        localStorage.setItem("renewAccountAccess", JSON.stringify({
                            accountId: errorAccountObject.accountId,
                            category: category,
                            reconcileAccounts: true,
                            processId: response.processId
                        }));
                        window.location.href = response.url;
                    }
                } catch (err) {
                    console.error("reducers > data > handleExpiredCredentialsError > error in API.post", err);
                }
            }
        }
    }));
}
const $f1c3fa004749592f$export$b2657fa62cdb0cb4 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/updateStoreDataWrapper", async (payload, { dispatch: dispatch })=>{
    // updateDepositAccountIds: Array<deposit accountId>
    // if delete asset account or delete asset transaction had to remove a tag from a linked deposit transaction, we need to refresh the deposit account with that transaction
    // so that the change is visible in the frontend
    const { updateDepositAccountIds: updateDepositAccountIds } = payload;
    if ((updateDepositAccountIds || []).length > 0) updateDepositAccountIds.forEach((updateDepositAccountId)=>{
        // eslint-disable-next-line no-use-before-define
        dispatch($f1c3fa004749592f$export$dd5fff820f0946a1({
            category: "deposits",
            accountId: updateDepositAccountId
        }));
    });
    // once done that, update store data through the common reducer as usual
    dispatch({
        type: "data/updateStoreData",
        payload: payload
    });
});
const $f1c3fa004749592f$export$3d2507cede480fd4 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/getStocksSettings", async (category, { dispatch: dispatch })=>{
    const payload = await $f1c3fa004749592f$var$prepCallToApi(null);
    const response = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", "stocks/settings", payload);
    // parsing: when set automatically via terraform this is an object already, when set manually it is a string
    const responseParsed = $f1c3fa004749592f$var$parseIf(response);
    const { crypto: responseCryptoSettings } = responseParsed, responseStocksSettings = (0, $bLhVg._)(responseParsed, [
        "crypto"
    ]);
    const { crypto: defaultCryptoSettings } = (0, $6bea581af4ee4124$export$568554344c31bfb8), defaultStocksSettings = (0, $bLhVg._)((0, $6bea581af4ee4124$export$568554344c31bfb8), [
        "crypto"
    ]);
    if (category === "crypto") return (0, $9tqwB._)({}, defaultCryptoSettings, responseCryptoSettings);
    return (0, $9tqwB._)({}, defaultStocksSettings, responseStocksSettings);
// state updated in getDataByCategory
});
const $f1c3fa004749592f$export$64ebf73f0218161c = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/putStocksSettings", async ({ data: data, category: category }, { dispatch: dispatch, getState: getState })=>{
    const stocksSettings = getState().data.stocks.settings;
    const cryptoSettings = getState().data.crypto.settings;
    let dataAdjusted;
    if (category === "crypto") // if this is called from crypto, then spread 'data' over the .crypto property only
    dataAdjusted = (0, $2qxEV._)((0, $9tqwB._)({}, stocksSettings), {
        crypto: (0, $9tqwB._)({}, cryptoSettings, data)
    });
    else // if this is called from stocks or with category === null
    // Planning provides only the parameters that have changed, therefore need to re-spread both stocks and crypto settings from store
    // and then spread 'data' (new changes) over them, both in stocks and in crypto (the latter can be undefined, that's ok)
    dataAdjusted = (0, $2qxEV._)((0, $9tqwB._)({}, stocksSettings, data), {
        crypto: (0, $9tqwB._)({}, cryptoSettings, data.crypto)
    });
    const payload = await $f1c3fa004749592f$var$prepCallToApi(dataAdjusted);
    const response = await (0, $bad5f4197326a006$export$8de8f9d6a7611c85)("myAPI", "stocks/settings", payload);
    const parsedResponse = $f1c3fa004749592f$var$parseIf(response);
    // this will return the entire settings object, i.e. { growthRateAdvancedMode, growthRate, ..., crypto: { growthRateAdvancedMode, growthRate, ... }}
    const { crypto: crypto } = parsedResponse, responseStocksSettings = (0, $bLhVg._)(parsedResponse, [
        "crypto"
    ]);
    // we got a response for both categories in one object, but depending on what category did we get called with (stocks, crypto, null = both) we will update the store with the correct category
    if (category === "crypto" || category === null) dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4({
        category: "crypto",
        settings: crypto
    }));
    if (category === "stocks" || category === null) dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4({
        category: "stocks",
        settings: responseStocksSettings
    }));
    return response;
});
function $f1c3fa004749592f$var$generatePensionPurchaseTransaction(accounts) {
    const returnArray = [];
    accounts.forEach((account)=>{
        returnArray.push({
            date: account.productPurchaseDate,
            assetId: account.id,
            accountCurrency: account.currency
        });
    });
    return returnArray;
}
function $f1c3fa004749592f$var$getNamedRequiredDates(state) {
    const { baseline: baseline, referenceBaseline: referenceBaseline, current: current } = (0, $93bb2798871a68d2$export$4bb039911f93bce)(state);
    return (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)([
        baseline,
        referenceBaseline,
        current
    ]);
}
const $f1c3fa004749592f$export$2f27c6ebffb46a2f = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/getAccountsByCategory", async (category, { dispatch: dispatch })=>{
    let data;
    try {
        const payload = await $f1c3fa004749592f$var$prepCallToApi(null);
        data = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/data`, payload); // crypto is a virtual category --> backend handled by stocks api
        const transformedData = data;
        transformedData.accounts = transformedData.accounts.filter((a)=>category === "crypto" ? (a === null || a === void 0 ? void 0 : a.subcategory) === "crypto" : (a === null || a === void 0 ? void 0 : a.subcategory) !== "crypto") // if this is crypto, stocks api returns also stock accounts, so we need to filter them out
        .map($f1c3fa004749592f$var$getAccountTransformationCallback(category));
        const returnPayload = {
            accounts: transformedData.accounts,
            category: category
        }; // returns { accounts: [], category: 'deposits' }
        return returnPayload;
    } catch (err) {
        console.log("error in getAccountsByCategory", $f1c3fa004749592f$var$getApiErrorDetails(err));
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
    }
    return true;
});
/**
 * Handles API call to /data, transformation and updates redux. If no call mode is passed, the backend will call provider and return both existing and new data.
 *
 * @param {string} category - category to be retrieved
 * @param {func} dispatch - passed from thunk
 * @param {func} getState - passed from thunk
 * @param {string} accountId (optional) - if not provided, the function will retrieve the entire category
 * @param {enum} callMode - one of 'newProviderData', 'existingData', null
 */ async function $f1c3fa004749592f$var$callGetDataAndTransform(category, dispatch, getState, accountId = null, callMode = null, options = {}) {
    const { replaceCategoryPartition: replaceCategoryPartition = false } = options;
    if (![
        "newProviderData",
        "existingData",
        null
    ].includes(callMode)) throw new Error("callGetDataAndTransform: callMode must be one of newProviderData, existingData, null");
    let data;
    let quotes;
    let settings;
    let fxRates;
    let payload;
    try {
        payload = await $f1c3fa004749592f$var$prepCallToApi(null);
        // call category/data in category
        data = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/data${accountId ? "/accounts/" : ""}${accountId || ""}${callMode ? `?callMode=${callMode}` : ""}`, payload); // crypto is a virtual category --> backend handled by stocks api
    } catch (err) {
        const errorStatus = $f1c3fa004749592f$var$getApiErrorStatus(err);
        // handle timeout (most likely caused by long provider data refresh times)
        if (errorStatus === 504) // retry in retryMode, which bypasses the backgroundUpdate check in the backend
        try {
            data = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/data${accountId ? "/accounts/" : ""}${accountId || ""}?retryMode=1${callMode ? `&callMode=${callMode}` : ""}`, payload); // crypto is a virtual category --> backend handled by stocks api
        } catch (err2) {
            // if it throws error again, then we have to handle it as a regular error
            console.error("Redux: data reducer: callGetDataAndTransform: retry of API.get error in category:", category, accountId ? `for accountId ${accountId}` : "", "error message:", $f1c3fa004749592f$var$getApiErrorDetails(err2));
            throw err2;
        }
        else {
            // handle non-504 errors here
            console.error("Redux: data reducer: callGetDataAndTransform: error while contacting API", $f1c3fa004749592f$var$getApiErrorDetails(err));
            throw err;
        }
    }
    // transform data
    try {
        var _promisesResponse_;
        const transformedData = data;
        transformedData.accounts = transformedData.accounts.filter((a)=>category === "crypto" ? (a === null || a === void 0 ? void 0 : a.subcategory) === "crypto" : (a === null || a === void 0 ? void 0 : a.subcategory) !== "crypto") // if this is crypto, stocks api returns also stock accounts, so we need to filter them out
        .map($f1c3fa004749592f$var$getAccountTransformationCallback(category));
        const accountIds = transformedData.accounts.map((a)=>a.id);
        transformedData.transactions = transformedData.transactions// if this is crypto / stocks, only keep transactions belonging to crypto /stocks accounts
        // (the api will return mixed transactions and they have to be separated)
        .filter((t)=>[
                "crypto",
                "stocks"
            ].includes(category) ? accountIds.includes(t.accountId) : true).map($f1c3fa004749592f$var$getTransactionTransformationsCallback(category));
        const requiredDates = $f1c3fa004749592f$var$getNamedRequiredDates(getState());
        // once we have transactions, we can get quotes (crypto shares Stocks API backend)
        if (category === "stocks" || category === "crypto") {
            quotes = (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
                scopes: (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
                    transactions: transformedData.transactions.filter((tx)=>[
                            "purchase",
                            "sale"
                        ].includes(tx.transactionType)),
                    requiredDates: requiredDates
                })
            }, {
                dispatch: dispatch,
                debounceMs: 250,
                immediate: !!accountId
            });
            settings = dispatch($f1c3fa004749592f$export$3d2507cede480fd4(category));
        } else if (category === "pension") {
            // for pension we need to consider the automatically generated purchase transaction based on whatever is in the account
            const purchaseTransactions = $f1c3fa004749592f$var$generatePensionPurchaseTransaction(transformedData.accounts);
            quotes = (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
                scopes: (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
                    transactions: transformedData.transactions.concat(purchaseTransactions),
                    requiredDates: requiredDates
                })
            }, {
                dispatch: dispatch,
                debounceMs: 250,
                immediate: !!accountId
            });
        } else quotes = (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
            scopes: (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
                transactions: transformedData.transactions,
                requiredDates: requiredDates
            })
        }, {
            dispatch: dispatch,
            debounceMs: 250,
            immediate: !!accountId
        }); // once we have transactions, we can get quotes
        const promisesResponse = await Promise.all([
            quotes,
            settings,
            fxRates
        ]);
        settings = (_promisesResponse_ = promisesResponse[1]) === null || _promisesResponse_ === void 0 ? void 0 : _promisesResponse_.payload;
        const returnPayload = (0, $2qxEV._)((0, $9tqwB._)({}, transformedData), {
            transactions: transformedData.transactions.filter((t)=>!t.isSimulated),
            simulatedTransactions: transformedData.transactions.filter((t)=>!!t.isSimulated),
            settings: settings,
            category: category,
            replaceCategoryPartition: replaceCategoryPartition
        }); // returns { transactions: [], simulatedTransactions: [], accounts: [], status: 'noerrors', category: 'deposits' }
        if (accountId) returnPayload.accountId = accountId; // if this is called from getDataByAccount, we need to return the accountId as well
        // upload data to the store
        await dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4(returnPayload));
        // handle special case of provider access expiring -- if there are any objects { accountId, code, message } (code being our own errorCode) in data.errors, it means we need to refresh the access
        const errorAccounts = data.errors;
        if (errorAccounts && errorAccounts.length > 0) // kick off the process for the first account in the list; that will take the user to the webform and back to dashboard
        // dashboard will run getData again and if the error still persists for another bank connection, it will be taken from here again
        $f1c3fa004749592f$var$handleExpiredCredentialsError({
            errorAccountObject: errorAccounts[0],
            dispatch: dispatch,
            getState: getState,
            category: category
        });
    } catch (err) {
        console.error("Redux: data reducer: callGetDataAndTransform error while transforming data");
        throw err;
    }
}
// handles both getDataByCategory and ByAccount
/**
 * getData - retrieve data from API and transform it to redux structure
 *
 * @param {string} category - category to be retrieved
 * @param {func} dispatch - passed from thunk
 * @param {func} getState - passed from thunk
 * @param {string} accountId (optional) - if not provided, the function will retrieve the entire category
 */ async function $f1c3fa004749592f$var$getData(category, dispatch, getState, accountId = null) {
    const statusActionName = accountId ? "data/updateAccountStatus" : "data/updateCategoryStatus";
    const statusPayload = accountId ? {
        category: category,
        accountId: accountId
    } : {
        category: category
    };
    const isCategoryFetch = !accountId;
    const isCategoryBootstrapCall = isCategoryFetch && !$f1c3fa004749592f$var$hasDataBootstrapRun(category);
    let bootstrapClaimed = false;
    // get data from API
    // TODO PRD-1712 call both call modes in parallel, update store separately and once both are done, update status to success
    try {
        dispatch({
            type: statusActionName,
            payload: (0, $2qxEV._)((0, $9tqwB._)({}, statusPayload), {
                status: "loading"
            })
        });
        if (isCategoryBootstrapCall) {
            // Claim category bootstrap before API starts so concurrent requests don't both run replace mode.
            $f1c3fa004749592f$var$markDataBootstrapDone(category);
            bootstrapClaimed = true;
        }
        const runParallelGetData = [
            "deposits",
            "stocks",
            "loans"
        ].includes(category);
        if (runParallelGetData) {
            const existingData = $f1c3fa004749592f$var$callGetDataAndTransform(category, dispatch, getState, accountId, "existingData", {
                replaceCategoryPartition: isCategoryBootstrapCall
            });
            const newProviderData = $f1c3fa004749592f$var$callGetDataAndTransform(category, dispatch, getState, accountId, "newProviderData", {
                replaceCategoryPartition: false
            });
            const existingDataResult = await existingData.then(()=>({
                    ok: true
                }), (error)=>({
                    ok: false,
                    error: error
                }));
            if (existingDataResult.ok) dispatch({
                type: statusActionName,
                payload: (0, $2qxEV._)((0, $9tqwB._)({}, statusPayload), {
                    status: "loadingExternal"
                })
            });
            const newProviderDataResult = await newProviderData.then(()=>({
                    ok: true
                }), (error)=>({
                    ok: false,
                    error: error
                }));
            if (!existingDataResult.ok) throw existingDataResult.error;
            if (!newProviderDataResult.ok) throw newProviderDataResult.error;
        } else await $f1c3fa004749592f$var$callGetDataAndTransform(category, dispatch, getState, accountId, "existingData", {
            replaceCategoryPartition: isCategoryBootstrapCall
        });
        dispatch({
            type: statusActionName,
            payload: (0, $2qxEV._)((0, $9tqwB._)({}, statusPayload), {
                status: "success"
            })
        });
    } catch (err) {
        if (bootstrapClaimed) // Bootstrap failed, so allow next category fetch in this session to retry authoritative replace.
        $f1c3fa004749592f$var$clearDataBootstrapDone(category);
        console.log("Redux: data reducer: API.get error in category:", category, accountId ? `for accountId ${accountId}` : "", "error message:", $f1c3fa004749592f$var$getApiErrorDetails(err));
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        dispatch({
            type: statusActionName,
            payload: (0, $2qxEV._)((0, $9tqwB._)({}, statusPayload), {
                status: "error"
            })
        });
    }
}
const $f1c3fa004749592f$export$dfb022681f1048bc = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/getDataByCategory", async (category, { dispatch: dispatch, getState: getState })=>{
    await $f1c3fa004749592f$var$getData(category, dispatch, getState);
});
const $f1c3fa004749592f$export$dd5fff820f0946a1 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/getDataByAccount", async ({ category: category, accountId: accountId }, { dispatch: dispatch, getState: getState })=>{
    if (!category || !accountId) return;
    await $f1c3fa004749592f$var$getData(category, dispatch, getState, accountId); // passing accountId starts it in byAccount mode
});
const $f1c3fa004749592f$export$4e87299c28e9a838 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/postData", async ({ data: data, category: category, accountId: accountId, cancelSignal: cancelSignal = {
    aborted: false
} }, { dispatch: dispatch, getState: getState })=>{
    let returnPayload;
    try {
        // cancelSignal is used by Prep to run unmount cleanup; when the component is re-rendered, the useEffect cleanup sets aborted to true
        // if the request is aborted, the dispatches are not run; if aborting functionality is not required, it can be omitted
        const { aborted: aborted } = cancelSignal;
        // prevent two postData for the same account at the same time
        const { status: status } = getState().data[category].accounts.find((a)=>a.id === accountId).status || ""; // FIXME handle status null
        if (status === "loading") {
            console.log("postData: already loading for", category, "accountId", accountId);
            return {};
        }
        dispatch({
            type: "data/updateCategoryStatus",
            payload: {
                category: category,
                status: "loading"
            }
        });
        const payload = await $f1c3fa004749592f$var$prepCallToApi(data);
        const response = !aborted ? await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/transactions`, payload) : {
            transactions: [],
            status: "noerrors",
            category: category
        };
        const { transactions: transactions } = response;
        const transformedTransactions = transactions.map($f1c3fa004749592f$var$getTransactionTransformationsCallback(category));
        returnPayload = (0, $2qxEV._)((0, $9tqwB._)({}, response), {
            transactions: transformedTransactions.filter((t)=>!t.isSimulated),
            simulatedTransactions: transformedTransactions.filter((t)=>!!t.isSimulated),
            category: category,
            accountId: accountId
        }); // returns { transactions: [], simulatedTransactions: [], accounts: [], status: 'noerrors', category: 'deposits', accountId: ... }
        if (!aborted && category !== "deposits" && category !== "loans") {
            const requiredDates = $f1c3fa004749592f$var$getNamedRequiredDates(getState());
            const scopeTransactions = transformedTransactions.map($f1c3fa004749592f$var$getTransactionTransformationsCallback(category));
            await (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
                scopes: (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
                    transactions: scopeTransactions,
                    requiredDates: requiredDates
                })
            }, {
                dispatch: dispatch,
                immediate: true
            }); // once we have transactions, we can get quotes
        }
        if (!aborted) dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4(returnPayload));
        dispatch({
            type: "data/updateCategoryStatus",
            payload: {
                category: category,
                status: "noerrors"
            }
        });
    } catch (err) {
        console.log("error in postData", err);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        dispatch({
            type: "data/updateCategoryStatus",
            payload: {
                category: category,
                status: "error"
            }
        });
        throw err;
    }
    return returnPayload;
});
const $f1c3fa004749592f$export$942e92bd9e040eb = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/postMixedData", async ({ payload: payload, cancelSignal: cancelSignal = {
    aborted: false
} }, { dispatch: dispatch, getState: getState })=>{
    // cancelSignal is used by Prep to run unmount cleanup; when the component is re-rendered, the useEffect cleanup sets aborted to true
    // if the request is aborted, the dispatches are not run; if aborting functionality is not required, it can be omitted
    const { aborted: aborted } = cancelSignal;
    const updatedPayload = payload.map((item)=>{
        if (!item.category) {
            console.error("postData wrapper: transaction is missing a category attribute:", item);
            throw new Error("postMixedData: detected a transaction with no category attribute.");
        }
        if (!item.accountId) {
            // running the view in projectMode, because we need to see the isolated transactions (in case we are peforming a delete op on an isolated project)
            const { accountId: accountId } = (0, $3679aa7475d9bd44$export$783fb813252d40e6)(getState(), item.category).find((t)=>t.id === item.id);
            return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                accountId: accountId
            });
        }
        return item;
    });
    // get payload to an object { deposits: { accountId: [transaction-objects], accountId2: [transaction-objects] }, stocks: { ... } }
    const payloadByCategory = updatedPayload.reduce((acc, item)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [item.category]: (0, $2qxEV._)((0, $9tqwB._)({}, acc[item.category]), {
                [item.accountId]: [
                    ...(acc[item.category] || {})[item.accountId] || [],
                    item
                ]
            })
        }), {});
    // dispatch data to the correct category service by category, in bulk
    // postData accepts only data per account afair
    const promises = [];
    if (!aborted) {
        Object.keys(payloadByCategory).forEach((item)=>{
            Object.keys(payloadByCategory[item]).forEach((accountId)=>{
                promises.push(dispatch($f1c3fa004749592f$export$4e87299c28e9a838({
                    data: payloadByCategory[item][accountId],
                    category: item,
                    accountId: accountId
                })));
            });
        });
        await Promise.all(promises);
    }
});
const $f1c3fa004749592f$export$7da7ab8978d9e8f4 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/postFileImportData", async ({ data: data, category: category, accountId: accountId }, { dispatch: dispatch })=>{
    // only keep transactions from source = 'import' which have a keepFlag of true
    const transactionToPost = data.filter((t)=>t.source === "import" && t.keepFlag === true).map((_param)=>{
        var { source: source, keepFlag: keepFlag, isDuplicate: isDuplicate } = _param, t = (0, $bLhVg._)(_param, [
            "source",
            "keepFlag",
            "isDuplicate"
        ]);
        return t;
    });
    await dispatch($f1c3fa004749592f$export$4e87299c28e9a838({
        data: transactionToPost,
        category: category,
        accountId: accountId
    }));
});
const $f1c3fa004749592f$export$391c5b9a9263706a = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/postAccount", async ({ data: data, category: category, cancelSignal: cancelSignal = {
    aborted: false
} }, { dispatch: dispatch, getState: getState })=>{
    // cancelSignal is used by Prep to run unmount cleanup; when the component is re-rendered, the useEffect cleanup sets aborted to true
    // if the request is aborted, the dispatches are not run; if aborting functionality is not required, it can be omitted
    const { aborted: aborted } = cancelSignal;
    if (!aborted) dispatch({
        // used by ColumnMatcher and by AddNewTile
        type: (0, $0840a3787500c813$export$a4c351e5b9b68a40),
        payload: {
            callerId: `post${category}Account`,
            message: "loading"
        }
    });
    try {
        const payload = await $f1c3fa004749592f$var$prepCallToApi((0, $2qxEV._)((0, $9tqwB._)({}, data), {
            importFlag: "post"
        }));
        // crypto is a virtual category --> backend handled by stocks api, but we need to provide a subcategory for stocks api to know that this is crypto
        if (category === "crypto") payload.body.subcategory = "crypto";
        const response = !aborted ? await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/accounts`, payload) // crypto is handled by stocks api
         : {
            accounts: [],
            status: "noerrors",
            category: category
        };
        // returns { accounts: [], status: 'noerrors', category: 'deposits' }
        const transformedData = response;
        transformedData.accounts = transformedData.accounts.filter((a)=>category === "crypto" ? (a === null || a === void 0 ? void 0 : a.subcategory) === "crypto" : true) // if this is crypto, stocks api returns also stock accounts, so we need to filter them out
        .map($f1c3fa004749592f$var$getAccountTransformationCallback(category));
        const account = response.accounts[0];
        const accountId = account.id;
        if (!aborted) dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4((0, $2qxEV._)((0, $9tqwB._)({}, transformedData), {
            accountId: accountId,
            category: category
        })));
        if (!aborted) dispatch({
            // used by ColumnMatcher and by AddNewTile
            type: (0, $0840a3787500c813$export$80f5d6a1a3225791),
            payload: {
                callerId: `post${category}Account`
            }
        });
        if (!aborted) {
            // dispatch(getDataByAccount({ category, accountId })); // FIX 240709 what is the point of doing that here if we post the account? it will be empty
            // WARNING only deposits and stocks (?) may have this implemented in backend
            dispatch((0, $101425bdfe5b6af9$export$b00a271f69f3d728)()); // needed for loans (connectedProjectId dialog)
            if (!aborted && category === "pension") {
                const requiredDates = (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)($f1c3fa004749592f$var$getNamedRequiredDates(getState()).concat([
                    account.productPurchaseDate
                ]));
                const fromDate = account.productPurchaseDate;
                const toDate = Math.max(fromDate, ...requiredDates);
                await (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
                    scopes: [
                        {
                            asset: {
                                assetId: accountId,
                                providerAssetId: null,
                                currency: account.currency,
                                category: category
                            },
                            fromDate: fromDate,
                            toDate: toDate,
                            requiredDates: requiredDates,
                            includeManualQuotes: true
                        }
                    ]
                }, {
                    dispatch: dispatch,
                    immediate: true
                });
            }
        } // get the newly created account (and its transactions) from the API'})
        if (aborted) console.log("postAccount: request was aborted");
        return transformedData;
    } catch (err) {
        // handle no more slots
        dispatch({
            // used by ColumnMatcher and by AddNewTile
            type: (0, $0840a3787500c813$export$80f5d6a1a3225791),
            payload: {
                callerId: `post${category}Account`
            }
        });
        if ($f1c3fa004749592f$var$getApiErrorStatus(err) === 507) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("noSlots"));
            console.error("Redux: data > postAccount: error while creating the new account (not enough slots available)", err.message);
            throw new Error("noSlotsAvailable: postAccount: error while creating the new account (not enough slots available)"); // 240221 adding this so that Prep sees postAccount failing
        // TODO this should now show up at dispatch in the component and can be handled based on split(':')[0] === 'noSlotsAvailable'
        } else {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
            console.error("Redux: data > postAccount: error while creating the new account", err.message);
            throw new Error("postAccount: error while creating the new account"); // 240221 adding this so that Prep sees postAccount failing
        }
    }
});
const $f1c3fa004749592f$export$60a9c54e51ee3879 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/putAccount", async ({ data: data, category: category }, { dispatch: dispatch })=>{
    let normalizedData = data;
    try {
        const schema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(category, "account");
        if (schema) normalizedData = schema.cast(data);
    } catch (error) {
        console.error(`putAccount: failed to cast ${category} account payload, falling back to raw data`, error);
    }
    const payload = await $f1c3fa004749592f$var$prepCallToApi((0, $2qxEV._)((0, $9tqwB._)({}, normalizedData), {
        importFlag: "put"
    })); // if importFlag is missing, the API assumes POST
    const response = await (0, $bad5f4197326a006$export$8de8f9d6a7611c85)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/accounts`, payload);
    const transformedData = response;
    transformedData.accounts = transformedData.accounts.filter((a)=>category === "crypto" ? (a === null || a === void 0 ? void 0 : a.subcategory) === "crypto" : true) // if this is crypto, stocks api returns also stock accounts, so we need to filter them out
    .map($f1c3fa004749592f$var$getAccountTransformationCallback(category));
    const accountId = response.accounts[0].id;
    dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4((0, $2qxEV._)((0, $9tqwB._)({}, transformedData), {
        accountId: accountId,
        category: category
    })));
    if (category === "deposits") dispatch({
        // used by ColumnMatcher
        type: (0, $0840a3787500c813$export$a4c351e5b9b68a40),
        payload: {
            callerId: `put${category}Account`,
            message: "success"
        }
    });
});
const $f1c3fa004749592f$export$45abfc3976589d02 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("data/deleteAccount", async ({ accountId: accountId, category: category }, { dispatch: dispatch })=>{
    const payload = await $f1c3fa004749592f$var$prepCallToApi({
        id: accountId
    }); // API expects an account object
    const response = await (0, $bad5f4197326a006$export$d94f928774096e78)("myAPI", `${(category === "crypto" ? "stocks" : category).toLowerCase()}/accounts`, payload);
    dispatch($f1c3fa004749592f$export$b2657fa62cdb0cb4((0, $2qxEV._)((0, $9tqwB._)({}, response), {
        accountId: accountId,
        category: category
    })));
    // returns { accounts: [], status: 'noerrors', category: 'deposits' }
    dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountDeletedSuccessfully"));
});
const $f1c3fa004749592f$var$dataSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "data",
    initialState: $f1c3fa004749592f$var$initialState,
    reducers: {
        hydrate (state, action) {
            // Merge the persisted state into the current state
            return (0, $9tqwB._)({}, state, action.payload);
        },
        updateCategoryStatus (state, action) {
            // expects payload = { category: 'deposits', status: 'loading' }
            state[action.payload.category].status = action.payload.status;
        },
        updateAccountStatus (state, action) {
            // expects payload = { category: 'deposits', accountId: 'account1', status: 'loading' }
            state[action.payload.category].accounts.find((a)=>a.id === action.payload.accountId).status = action.payload.status;
        },
        updateStoreData (state, action) {
            const { category: category, transactions: transactions, simulatedTransactions: simulatedTransactions, accounts: accounts, settings: settings, replaceCategoryPartition: replaceCategoryPartition } = action.payload;
            // remove from state all items whose ids are in payload add all those items from payload except those which are to be deleted
            if (replaceCategoryPartition) {
                state[category].transactions = [];
                state[category].simulatedTransactions = [];
                state[category].accounts = [];
            }
            if (transactions) {
                var _state_category;
                // handle no transactions case
                if (transactions.length === 0) (_state_category = state[category]).transactions || (_state_category.transactions = []);
                else state[category].transactions = [
                    ...state[category].transactions.filter((i)=>!transactions.some((p)=>p.id === i.id)),
                    ...transactions.filter((t)=>t.importFlag !== "delete")
                ];
            }
            if (simulatedTransactions) {
                var _state_category1;
                // handle no transactions
                if (simulatedTransactions.length === 0) (_state_category1 = state[category]).simulatedTransactions || (_state_category1.simulatedTransactions = []);
                else state[category].simulatedTransactions = [
                    ...state[category].simulatedTransactions.filter((i)=>!simulatedTransactions.some((p)=>p.id === i.id)),
                    ...simulatedTransactions.filter((t)=>t.importFlag !== "delete")
                ].map($f1c3fa004749592f$var$getTransactionTransformationsCallback(category));
            }
            if (accounts) {
                var _state_category2;
                // handle no accounts
                if (accounts.length === 0) (_state_category2 = state[category]).accounts || (_state_category2.accounts = []);
                else state[category].accounts = [
                    ...state[category].accounts.filter((xa)=>!accounts.some((na)=>na.id === xa.id)),
                    ...accounts.filter((t)=>t.importFlag !== "delete")
                ];
            }
            if (settings) state[category].settings = settings;
        }
    },
    extraReducers: {}
});
var $f1c3fa004749592f$export$2e2bcd8739ae039 = $f1c3fa004749592f$var$dataSlice.reducer;
const { updateStoreData: $f1c3fa004749592f$export$3c018e5ab718b639 } = $f1c3fa004749592f$var$dataSlice.actions;



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $8bd3fc2d0bca0786$var$getProviderAssetIdKey(providerAssetId) {
    if (!providerAssetId) return "";
    if (typeof providerAssetId === "object") return JSON.stringify(providerAssetId);
    return String(providerAssetId);
}
function $8bd3fc2d0bca0786$var$getScopedQuoteAssetsFromBalances(balances = []) {
    const seen = new Set();
    const scopedAssets = [];
    (balances || []).forEach((balance)=>{
        const assetId = balance === null || balance === void 0 ? void 0 : balance.assetId;
        const currency = (balance === null || balance === void 0 ? void 0 : balance.transactionCurrency) || (balance === null || balance === void 0 ? void 0 : balance.accountCurrency);
        const providerAssetId = (balance === null || balance === void 0 ? void 0 : balance.providerAssetId) || null;
        if (!assetId || !currency) return;
        const key = `${assetId}|${$8bd3fc2d0bca0786$var$getProviderAssetIdKey(providerAssetId)}|${currency}`;
        if (seen.has(key)) return;
        seen.add(key);
        scopedAssets.push({
            assetId: assetId,
            providerAssetId: providerAssetId,
            currency: currency
        });
    });
    return scopedAssets;
}
const $8bd3fc2d0bca0786$export$6503ec6e8aabbaf = (user)=>(dispatch)=>(0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).register(user).then((response)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$f91e818b28421958),
                payload: response
            });
            return Promise.resolve();
        }, (error)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$b885672bc5665ae2)
            });
            return Promise.reject();
        });
const $8bd3fc2d0bca0786$export$39e8c219c47713c5 = (email)=>(dispatch)=>new Promise((resolve, reject)=>{
            console.log("Redux action creators > user > registerFederated: create Cognito account for external user:", email);
            // get data from storage
            const user = JSON.parse(localStorage.getItem("signUpObject"));
            // delete password from storage
            delete user.password;
            localStorage.setItem("signUpObject", JSON.stringify(user));
            function createPassword() {
                // we need to make sure there is at least 1 capital letter, 1 small letter, 1 number and 1 special character
                const nanoid = (0, $8136d14ed46fb244$export$62e99e5c9f473d7f)("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,./<>?", 20);
                const nanoidCap = (0, $8136d14ed46fb244$export$62e99e5c9f473d7f)("ABCDEFGHIJKLMNOPQRSTUVWXYZ", 1);
                const nanoidNum = (0, $8136d14ed46fb244$export$62e99e5c9f473d7f)("0123456789", 1);
                const nanoidSpecial = (0, $8136d14ed46fb244$export$62e99e5c9f473d7f)("!@#$%^&*()_+-=[]{}|;:,./<>?", 1);
                return `${nanoidCap()}${nanoid()}${nanoidNum()}${nanoidSpecial()}`;
            }
            // create new user in Cognito with a random password (if user ever wants to use username/password login, they can have it reset)
            // need to remove provider to run Auth.register in Cognito mode
            // do not use the email, as it will send the verification code (and the user wants to use the external IdP email)
            // email will be added in the Cognito lambda PreSignUp trigger
            (0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).register((0, $2qxEV._)((0, $9tqwB._)({}, user), {
                email: email,
                password: `${createPassword()}`,
                provider: undefined,
                putEmailInCustomSignupAttribute: true
            })).then((response)=>{
                console.log("Redux action creators > USER: Cognito account created, now federate with external IdP provider.");
                (0, $701013124925a1b1$export$3d0a7d1372e866bb)({
                    provider: user.provider
                }).then(// once the Cognito account is there, reattempt federated signup
                // the above call this will anyway result in a redirect, so it doesn't matter much what happens hereafter
                ()=>{
                    resolve();
                }, (error)=>{
                    reject(error);
                });
            }, (error)=>{
                console.error("Redux action creators > USER: Error detected in AuthService.register", error);
                reject(error);
            });
        });
const $8bd3fc2d0bca0786$export$3175f325678aaf85 = (user)=>(dispatch)=>(0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).resendConfirmationEmail(user).then((response)=>{
            console.log(response);
            dispatch({
                type: (0, $0840a3787500c813$export$acea34b366063395),
                payload: response
            });
            return Promise.resolve();
        }, (error)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$d3c2b0cd56b0637c)
            });
            return Promise.reject();
        });
const $8bd3fc2d0bca0786$export$93d1a64d3f408c6 = (username, code)=>(dispatch)=>new Promise((resolve, reject)=>{
            (0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).confirmUser(username, code).then((response)=>{
                console.log(response);
                dispatch({
                    type: (0, $0840a3787500c813$export$b25da9cb1df1f7ca),
                    payload: response
                });
                return resolve();
            }, (error)=>{
                dispatch({
                    type: (0, $0840a3787500c813$export$7c504496b873f4fe)
                });
                return reject(error);
            });
        });
const $8bd3fc2d0bca0786$export$a0973bcfe11b05c9 = ()=>(dispatch)=>{
        (0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).logout();
        dispatch({
            type: (0, $0840a3787500c813$export$35e541d26a145a7c)
        });
    };
const $8bd3fc2d0bca0786$export$3c0556baabe4d535 = (attributeName, attributeValueAsString)=>(dispatch)=>Promise.resolve((0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).updateUserAttribute(attributeName, attributeValueAsString).then((data)=>{
            try {
                dispatch({
                    type: (0, $0840a3787500c813$export$7903306f6790930)
                });
            } catch (error) {
                console.error(error);
            }
            if (attributeName !== "email") // for email one still needs a confirmation code, so can't display success message just yet
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileUpdatedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            console.error("UpdateUserAttribute failed: ", error, error.message);
            if (error.message === "cognitoUpdateFailed") dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileCouldNotBeUpdated"
            });
            return Promise.reject(error.stack);
        }));
const $8bd3fc2d0bca0786$export$99d837dc30eb1ef7 = (currentPassword, newPassword)=>(dispatch)=>Promise.resolve((0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).changePassword(currentPassword, newPassword).then((data)=>{
            console.info("ChangePassword successful: ", data);
            try {
                dispatch({
                    type: (0, $0840a3787500c813$export$7903306f6790930)
                });
            } catch (error) {
                console.error(error);
            }
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileUpdatedSuccessfully"
            });
            return Promise.resolve();
        }, (error)=>{
            if (error.message === "Incorrect username or password.") dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "incorrectPassword"
            });
            else if (error.message === "Attempt limit exceeded, please try after some time.") dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "attemptLimitExceeded"
            });
            else dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileCouldNotBeUpdated"
            });
            return Promise.reject(error.stack);
        }));
const $8bd3fc2d0bca0786$export$cc7ed8db712151cc = (payload)=>(dispatch)=>(0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).addSeenTours(payload).then(// returns an array of tours seen by user from Cognito [ 'tour1', 'tour2', 'tour3' ]
        (attributes)=>{
            dispatch({
                type: (0, $0840a3787500c813$export$145d071b2cefcb66),
                payload: attributes
            });
            console.log("update attributes - dispatch complete");
            return Promise.resolve();
        }, (error)=>{
            const message = error.response && error.response.data && error.response.data.message || error.message || error.toString();
            dispatch({
                type: (0, $0840a3787500c813$export$9da28f1f0b10ca02)
            });
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: message
            });
            return Promise.reject();
        });
const $8bd3fc2d0bca0786$export$4ad354767c4d4a23 = ()=>(dispatch, getState)=>{
        // if global tour lock is available (is not true), set it to true and return true to the caller
        if (!getState().user.tourLock) {
            dispatch({
                type: (0, $0840a3787500c813$export$e36d99af0a9f9ab7)
            });
            return true;
        }
        return false;
    };
const $8bd3fc2d0bca0786$export$68424ff5d47471f2 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $0840a3787500c813$export$4c021acc9734bf10)
        });
    };
const $8bd3fc2d0bca0786$export$5e7b30d2bf9a315f = (data)=>(dispatch, getState)=>{
        // data is the settings object { namedBaseline, baselineDate, etc. }
        // the settings in Redux are initialised from storage, they are retrieved from Cognito only upon login
        (0, $4a78ebdca8f8eb0b$export$2e2bcd8739ae039).updateCognitoSettings(data); // we are not waiting for the response
        dispatch({
            type: (0, $0840a3787500c813$export$68513b67d94d64cf),
            payload: {
                settings: data
            }
        });
        console.log("test - after dispatch to Cognito, do we see the new baselines already?", (0, $93bb2798871a68d2$export$4bb039911f93bce)(getState()));
        // baselineDate has been updated, refresh only the invalidated quote scope.
        if (data.baselineDate) {
            const { baseline: baseline, referenceBaseline: referenceBaseline, current: current } = (0, $93bb2798871a68d2$export$4bb039911f93bce)(getState());
            const assets = $8bd3fc2d0bca0786$var$getScopedQuoteAssetsFromBalances((0, $3679aa7475d9bd44$export$7cd09fd23199c464)(getState()));
            // Keep refresh canonical: numeric dates only (no persisted named rows in quotes slice).
            (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
                scopes: (0, $780d46a2914a2b26$export$3c2ee341cf661934)({
                    assets: assets,
                    requiredDates: (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)([
                        baseline,
                        referenceBaseline,
                        current
                    ]),
                    assetDateBounds: (0, $780d46a2914a2b26$export$a9243e65b02f996b)((0, $780d46a2914a2b26$export$8ddf68b0fa571116)(getState()))
                })
            }, {
                dispatch: dispatch,
                immediate: true
            });
        // if baseline and/or referenceBaseline dates are in the future, quotes API will ignore them and not return any data
        // all quotes for the future are to be calculated based on growth factors (or will come indirectly from the purchase / sale prices of assets)
        }
        return Promise.resolve();
    };
function $8bd3fc2d0bca0786$export$3ab4aed8562cb58d(consent) {
    return function updateConsentInner(dispatch) {
        // update consent in localStorage
        localStorage.setItem("consent", JSON.stringify(consent));
        dispatch({
            type: (0, $0840a3787500c813$export$bf63969c69f30522),
            payload: consent
        });
        return Promise.resolve();
    };
}



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function $cbe1190893083511$export$2e2bcd8739ae039({ error: error }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex min-h-full flex-col bg-white pt-16 pb-12",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("main", {
                className: "mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex flex-shrink-0 justify-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                            href: "/",
                            className: "inline-flex",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: "Monestry"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    className: "h-12 w-auto",
                                    src: "https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600",
                                    alt: ""
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "py-16",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-base font-semibold text-brandBlue-500",
                                    children: "ERROR"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                    className: "mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                    children: "Something went wrong."
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-2 text-base text-gray-500",
                                    children: "We are sorry - the application detected an error. Refresh the page to start over."
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-6",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                        href: "/",
                                        className: "text-base font-medium text-brandBlue-500 hover:text-brandBlue-400",
                                        children: [
                                            "Go back home",
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                "aria-hidden": "true",
                                                children: " \u2192"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "p-2 mx-auto max-w-3xl text-gray-500",
                        children: "Please include the following information should you decide to contact our support."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "p-2 border mx-auto max-w-md sm:max-w-3xl text-gray-300 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: JSON.stringify(error.message)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: JSON.stringify(error.stack)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                className: "mt-8 mx-auto w-full max-w-7xl flex-shrink-0 px-4 sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
                    className: "flex justify-center space-x-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "/",
                            className: "text-sm font-medium text-gray-500 hover:text-gray-600",
                            children: "Contact Support"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "inline-block border-l border-gray-300",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "/",
                            className: "text-sm font-medium text-gray-500 hover:text-gray-600",
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "inline-block border-l border-gray-300",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "/",
                            className: "text-sm font-medium text-gray-500 hover:text-gray-600",
                            children: "Twitter"
                        })
                    ]
                })
            })
        ]
    });
}
$cbe1190893083511$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    error: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};


/* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");




var $2oXYc = parcelRequire("2oXYc");
/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable operator-linebreak */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
function $e073a2cb8d5a7292$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    }));
}


function $4d6a115e8a6240d3$export$2e2bcd8739ae039({ text: text, textColor: textColor, textColorHover: textColorHover, Icon: Icon, onClick: onClick, size: size, withAccent: withAccent, noFrame: noFrame, noFrameNoArrow: noFrameNoArrow, enabled: enabled, spinnerOn: spinnerOn, onDarkBackground: onDarkBackground, formatting: formatting, type: type, id: id, name: name }) {
    const renderFrame = noFrame || noFrameNoArrow;
    let sizeUtility;
    switch(size){
        case "md":
            sizeUtility = renderFrame ? "py-2 sm:py-1.5" : "px-3 sm:px-3 py-2 sm:py-1.5";
            break;
        case "xl":
            sizeUtility = renderFrame ? "py-2.5" : "px-3.5 py-2.5";
            break;
        case "sm":
            sizeUtility = renderFrame ? "py-2 sm:py-1" : "px-3 sm:px-2 py-2 sm:py-1";
            break;
        case "xs":
            sizeUtility = renderFrame ? "py-2 sm:py-1" : "px-3 sm:px-2 py-2 sm:py-1";
            break;
        default:
            sizeUtility = renderFrame ? "py-3 sm:py-2" : "px-4 py-3 sm:px-3 sm:py-2";
    }
    let calculatedFormatting;
    let formatSpinnerOverlay;
    // return blue clickable link
    if (withAccent && renderFrame) {
        calculatedFormatting = `${textColor || "text-brandBlue-500"} hover:${textColorHover || "text-brandBlue-600"} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500`;
        formatSpinnerOverlay = "text-brandBlue-500";
    }
    // return gray clickable link
    if (!withAccent && renderFrame) calculatedFormatting = `${onDarkBackground ? `${textColor || "text-white"} hover:${textColorHover || "text-gray-50"}` : `${textColor || "text-gray-800"} hover:${textColorHover || "text-gray-900"}`} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-800`;
    // return blue background
    if (withAccent && !renderFrame) calculatedFormatting = `${enabled ? "bg-brandBlue-500 hover:bg-brandBlue-600 focus-visible:outline-brandBlue-500" : "bg-gray-300"} ${textColor || "text-white"} shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2`;
    // return white button with gray frame (not used in the new tailwind ui version anymore)
    if (!withAccent && !renderFrame) calculatedFormatting = `${onDarkBackground ? `${textColor || "text-white"} hover:${textColorHover || "text-gray-50"}` : `${textColor || "text-gray-800"} hover:${textColorHover || "text-gray-900"}`} bg-white shadow-sm hover:bg-gray-50 ring-1 ring-inset ring-gray-300 `;
    const calculatedText = noFrame && !noFrameNoArrow ? `${text}\u{2192}` : text;
    // if 'absolute' is detected in the incoming formatting string, keep it unchanged; otherwise add 'relative'
    const incomingFormatting = formatting.split(" ").includes("absolute") ? formatting : `${formatting} relative`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", (0, $2qxEV._)((0, $9tqwB._)({
        type: type === "submit" ? "submit" : "button",
        disabled: !enabled
    }, id && {
        id: id
    }, name && {
        name: name
    }), {
        // font below sm breakpoints needs to be LARGER, because buttons must be clickable with fingers
        // also there is a minimum width for the button for the same reason
        className: `rounded-md ${sizeUtility} sm:text-sm min-w-[6rem] sm:min-w-0 font-semibold ${withAccent ? `${textColor || "text-white"}` : `${textColor || "text-gray-700"}`} ${enabled ? "animate-single-pulse" : "cursor-not-allowed opacity-50"}
        ${calculatedFormatting} flex items-center justify-center ${incomingFormatting}`,
        onClick: enabled ? (e)=>onClick(e) : ()=>{},
        children: [
            spinnerOn && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute inset-0 bg-inherit opacity-100 rounded-md flex items-center justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                    className: `${size === "xl" ? "w-5 h-5" : "w-4 h-4"} ${withAccent ? "text-white" : "text-gray-400"} animate-spin`
                })
            }),
            Icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {
                className: "text-inherit h-5 w-5"
            }),
            text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: `text-inherit ${Icon ? "ml-1.5" : ""} font-semibold leading-4`,
                children: calculatedText
            })
        ]
    }));
}
$4d6a115e8a6240d3$export$2e2bcd8739ae039.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    textColorHover: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "sm",
        "md",
        "lg",
        "xl",
        "xs"
    ]),
    withAccent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    spinnerOn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    noFrame: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    noFrameNoArrow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    onDarkBackground: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "button",
        "submit"
    ]),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$4d6a115e8a6240d3$export$2e2bcd8739ae039.defaultProps = {
    text: "",
    textColor: undefined,
    textColorHover: undefined,
    onClick: ()=>{},
    Icon: undefined,
    size: "lg",
    withAccent: false,
    enabled: true,
    spinnerOn: false,
    noFrame: false,
    noFrameNoArrow: false,
    onDarkBackground: false,
    formatting: "",
    type: "button",
    id: undefined,
    name: undefined
};



var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");
/* eslint-disable max-len */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

function $3ea1f91ff88fa2cb$export$8dedaee0e594ee0e(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        enableBackground: "new 0 0 24 24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0,0h24v24H0V0z",
                    fill: "none"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,18H4V6h16V18z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("polygon", {
                            points: "6.49,10.5 6.49,15 7.64,15 7.64,9 6.77,9 5.01,10.27 5.59,11.16"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M11.47,10.05c0.5,0,0.81,0.32,0.81,0.72c0,0.37-0.14,0.64-0.54,1.06c-0.36,0.38-1.06,1.08-2.13,2.15V15h3.89v-0.99h-2.37 l-0.03-0.05c0.68-0.68,1.15-1.14,1.4-1.39c0.61-0.6,0.92-1.22,0.92-1.86c0-0.24-0.05-1.04-0.91-1.48C12.04,9,11.25,8.87,10.56,9.2 c-0.82,0.39-0.99,1.13-1,1.15l1.01,0.42C10.67,10.44,10.95,10.05,11.47,10.05z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M16.99,13.94c-0.83,0-0.99-0.76-1.02-0.86l-1.03,0.41c0.45,1.59,2.01,1.51,2.05,1.51c1.2,0,1.68-0.72,1.76-0.85 c0.32-0.49,0.36-1.24-0.01-1.76c-0.17-0.24-0.4-0.41-0.68-0.52V11.8c0.2-0.1,0.37-0.26,0.52-0.48c0.26-0.41,0.31-1.07-0.02-1.57 C18.48,9.64,18.03,9,16.94,9c-1.26,0-1.74,0.9-1.85,1.24l0.99,0.41c0.11-0.32,0.35-0.64,0.85-0.64c0.44,0,0.75,0.26,0.75,0.65 c0,0.58-0.55,0.72-0.88,0.72h-0.46v1h0.5c0.56,0,1.04,0.24,1.04,0.79C17.88,13.66,17.4,13.94,16.99,13.94z"
                        })
                    ]
                })
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$56821bdb517423b5(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h24v24H0V0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$941fd5c4dbed963a(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h24v24H0V0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$d275b7689549104e(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h24v24H0V0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$cbfdf0bb1adba85d(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3 0a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H4v1a1 1 0 0 1-2 0V4H1a1 1 0 0 1 0-2h1V1a1 1 0 0 1 1-1zM10 2h6v2h-6V2zM8 1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1zM0 9v8a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1zm16 5v2H2v-2h14zm0-4v2H2v-2h14z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$269b5f63de8a029f(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M3 12a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2H4v1a1 1 0 0 1-2 0v-1H1a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 1-1zM10 14h6v2h-6v-2zm-2-1v4a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1zM0 1v8a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1zm16 5v2H2V6h14zm0-4v2H2V2h14z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$b9214c7e3489d8a(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M 6 3 a 1 1 90 0 1 -1 1 h -1 v 1 a 1 1 90 0 1 -2 0 V 4 h -1 a 1 1 90 0 1 -0 -2 h 1 V 1 a 1 1 90 0 1 2 -0 v 1 h 1 a 1 1 90 0 1 1 1 z M 4 10 v 6 h -2 v -6 h 2 z m 1 -2 h -4 a 1 1 90 0 0 -1 1 v 8 a 1 1 90 0 0 1 1 h 4 a 1 1 90 0 0 1 -1 V 9 a 1 1 90 0 0 -1 -1 z M 17 0 h -8 a 1 1 90 0 0 -1 1 v 16 a 1 1 90 0 0 1 1 H 17 a 1 1 90 0 0 1 -1 V 1 a 1 1 90 0 0 -1 -1 z m -5 16 h -2 V 2 H 12 v 14 z m 4 -0 h -2 V 2 H 16 v 14 z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$aefafe49c6c6aa(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M 18 3 a 1 1 90 0 1 -1 1 h -1 v 1 a 1 1 90 0 1 -2 0 V 4 h -1 a 1 1 90 0 1 -0 -2 H 14 V 1 a 1 1 90 0 1 2 -0 v 1 H 17 a 1 1 90 0 1 1 1 z M 16 10 v 6 h -2 v -6 H 16 z M 17 8 h -4 a 1 1 90 0 0 -1 1 v 8 a 1 1 90 0 0 1 1 H 17 a 1 1 90 0 0 1 -1 V 9 a 1 1 90 0 0 -1 -1 z M 9 -0 h -8 a 1 1 90 0 0 -1 1 v 16 a 1 1 90 0 0 1 1 H 9 a 1 1 90 0 0 1 -1 V 1 a 1 1 90 0 0 -1 -1 z m -5 16 h -2 V 2 h 2 v 14 z m 4 -0 h -2 V 2 h 2 v 14 z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$91d38263da9ba43b(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "m 16 4 H 2 c -0.6 0 -1 -0.4 -1 -1 S 1.4 2 2 2 H 16 C 16.6 2 17 2.4 17 3 S 16.6 4 16 4 Z m 0 4 h -14 c -0.6 0 -1 -0.4 -1 -1 s 0.4 -1 1 -1 h 14 c 0.6 0 1 0.4 1 1 s -0.4 1 -1 1 z m 1 4 v 2 c 0 1 -1 2 -2 2 h -2 c 0 0.3 0 0.5 -0.3 0.7 c -0.2 0.2 -0.4 0.3 -0.7 0.3 s -0.5 0 -0.7 -0.3 l -1 -1 c -0.4 -0.4 -0.4 -1 0 -1.4 l 1 -1 c 0.4 -0.4 1 -0.4 1.4 0 c 0.2 0.2 0.3 0.4 0.3 0.7 h 2 v -2 h -13 c -0.6 0 -1 -0.5 -1 -1 s 0.5 -1 1 -1 h 13 c 1 0 2 1 2 2 z m -15 4 H 2 c -0.6 0 -1 -0.4 -1 -1 c 0 -0.6 0.4 -1 1 -1 l 6 0 c 0.6 0 1 0.4 1 1 c 0 0.6 -0.4 1 -1 1 l -6 0 z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$c462085fb1373290(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "m 3 2 v 14 c 0 0.6 -0.4 1 -1 1 s -1 -0.4 -1 -1 v -14 c -0 -0.6 0.4 -1 1 -1 s 1 0.4 1 1 z m 4 -0 v 14 c 0 0.6 -0.4 1 -1 1 s -1 -0.4 -1 -1 v -14 c -0 -0.6 0.4 -1 1 -1 s 1 0.4 1 1 z m 4 -1 h 2 c 1 -0 2 1 2 2 v 2 c 0.3 -0 0.5 -0 0.7 0.3 c 0.2 0.2 0.3 0.4 0.3 0.7 s 0 0.5 -0.3 0.7 l -1 1 c -0.4 0.4 -1 0.4 -1.4 0 l -1 -1 c -0.4 -0.4 -0.4 -1 -0 -1.4 c 0.2 -0.2 0.4 -0.3 0.7 -0.3 v -2 h -2 v 13 c 0 0.6 -0.5 1 -1 1 s -1 -0.5 -1 -1 v -13 c -0 -1 1 -2 2 -2 z m 4 15 V 16 c 0 0.6 -0.4 1 -1 1 c -0.6 0 -1 -0.4 -1 -1 l -0 -6 c -0 -0.6 0.4 -1 1 -1 c 0.6 -0 1 0.4 1 1 l 0 6 z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$ad76ec2c15e9c66f(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                strokeWidth: "0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                id: "SVGRepo_iconCarrier",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "currentColor",
                        d: "M18 1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10.02A4.98 4.98 0 0 1 10 15V2h2v9.024a4.953 4.953 0 0 1 2-.923V2h2v8.116a5.077 5.077 0 0 1 2 .9V1zM4 16H2V2h2v14zm4 0H6V2h2v14z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "currentColor",
                        d: "M13 14h4a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1 1 1 0 0 1 1-1z"
                    })
                ]
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$32d59a8186448c4f(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        viewBox: "0 0 18 18",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                strokeWidth: "0"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                id: "SVGRepo_iconCarrier",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "currentColor",
                        d: "M17 0H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10.02a5.064 5.064 0 0 1-.9-2H2v-2h8.1a4.944 4.944 0 0 1 .923-2H2v-2h13a4.98 4.98 0 0 1 3 1.02V1a1 1 0 0 0-1-1zm-1 8H2V6h14v2zm0-4H2V2h14v2z"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "currentColor",
                        d: "M13 14h4a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1 1 1 0 0 1 1-1z"
                    })
                ]
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$fcc683c36751f67a(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        enableBackground: "new 0 0 24 24",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0,0h24v24H0V0z",
                    fill: "none"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            fill: "currentColor",
                            d: "M12,5V2L8,6l4,4V7c3.31,0,6,2.69,6,6c0,2.97-2.17,5.43-5,5.91v2.02c3.95-0.49,7-3.85,7-7.93C20,8.58,16.42,5,12,5z"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            fill: "currentColor",
                            d: "M6,13c0-1.65,0.67-3.15,1.76-4.24L6.34,7.34C4.9,8.79,4,10.79,4,13c0,4.08,3.05,7.44,7,7.93v-2.02 C8.17,18.43,6,15.97,6,13z"
                        })
                    ]
                })
            })
        ]
    }));
}
function $3ea1f91ff88fa2cb$export$59de000b07aa1ecd(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        strokeWidth: "2",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M 4 19.998 L 4 14.998 L 4.582 14.998 M 19.938 12.998 C 19.169 19.109 12.073 22.096 7.165 18.374 C 6.015 17.502 5.123 16.336 4.582 14.998 M 4.582 14.998 L 9 14.998 M 20 3.998 L 20 8.998 L 19.419 8.998 M 19.419 8.998 C 17.106 3.288 9.479 2.224 5.69 7.082 C 4.805 8.217 4.243 9.57 4.062 10.998 M 19.419 8.998 L 15 8.998",
            transform: "matrix(-1, 0, 0, -1, 24, 24.007215)"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$1195ef320508ce77(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "w-6 h-6",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$17baa5989b7e45c7(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "w-6 h-6",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$83099edae52007d2(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "w-6 h-6",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$833dc7fbd6b858f7(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "w-6 h-6",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$6c72b8f14a769aaa(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: "w-6 h-6",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
        })
    }));
}
function $3ea1f91ff88fa2cb$export$816a14cbf50fa259(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        className: "w-5 h-5",
        stroke: "none",
        fill: "currentColor",
        focusable: "false",
        "aria-hidden": "true",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
        })
    }));
}


/* eslint-disable react/jsx-filename-extension */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
function $66b1933b1224486c$var$SvgMonestrySpinner(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        preserveAspectRatio: "xMidYMid",
        width: 560,
        height: 560
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: 560,
                height: 560,
                rx: 0,
                ry: 0,
                fill: "#FFF",
                fillOpacity: 0.6
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 125V0h500v95.364C471.85 85.414 441.557 80 410 80c-55.203 0-106.537 16.567-149.3 45H0Z",
                fill: "#1797F2",
                fillOpacity: 0,
                style: {
                    opacity: 1,
                    fill: "#1797f2",
                    fillOpacity: 1
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("animate", {
                    attributeType: "auto",
                    attributeName: "fill-opacity",
                    values: "0;0;1;1",
                    calcMode: "spline",
                    keyTimes: "0;0.6;0.8;1",
                    keySplines: "0 0 1 1;0 0 1 1;0 0 1 1",
                    dur: "2s",
                    begin: "0s",
                    repeatCount: "indefinite",
                    additive: "replace",
                    accumulate: "none",
                    fill: "freeze"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 270V145h234.28c-38.114 32.7-67.004 75.847-82.231 125H0Z",
                fill: "#1797F2",
                fillOpacity: 0,
                style: {
                    opacity: 1,
                    fill: "#1797f2",
                    fillOpacity: 1
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("animate", {
                    attributeType: "auto",
                    attributeName: "fill-opacity",
                    values: "0;0;1;1",
                    calcMode: "spline",
                    keyTimes: "0;0.4;0.6;1",
                    keySplines: "0 0 1 1;0 0 1 1;0 0 1 1",
                    dur: "2s",
                    begin: "0s",
                    repeatCount: "indefinite",
                    additive: "replace",
                    accumulate: "none",
                    fill: "freeze"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 415V290h146.69c-4.378 19.297-6.69 39.378-6.69 60 0 22.41 2.73 44.18 7.876 65H0Z",
                fill: "#1797F2",
                fillOpacity: 0,
                style: {
                    opacity: 1,
                    fill: "#1797f2",
                    fillOpacity: 1
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("animate", {
                    attributeType: "auto",
                    attributeName: "fill-opacity",
                    values: "0;0;1;1",
                    calcMode: "spline",
                    keyTimes: "0;0.2;0.4;1",
                    keySplines: "0 0 1 1;0 0 1 1;0 0 1 1",
                    dur: "2s",
                    begin: "0s",
                    repeatCount: "indefinite",
                    additive: "replace",
                    accumulate: "none",
                    fill: "freeze"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 560V435h153.652c16.44 49.606 46.875 92.832 86.628 125H0Z",
                fill: "#1797F2",
                fillOpacity: 0,
                style: {
                    opacity: 1,
                    fill: "#1797f2",
                    fillOpacity: 1
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("animate", {
                    attributeType: "auto",
                    attributeName: "fill-opacity",
                    values: "0;1;1",
                    calcMode: "spline",
                    keyTimes: "0;0.2;1",
                    keySplines: "0 0 1 1;0 0 1 1",
                    dur: "2s",
                    begin: "0s",
                    repeatCount: "indefinite",
                    additive: "replace",
                    accumulate: "none",
                    fill: "freeze"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                transform: "translate(410 350)",
                opacity: 0.55,
                fill: "#FFF",
                r: 270
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                transform: "translate(410 350)",
                r: 150
            })
        ]
    }));
}
var $66b1933b1224486c$export$2e2bcd8739ae039 = $66b1933b1224486c$var$SvgMonestrySpinner;


/* eslint-disable react/jsx-filename-extension */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");
function $b9da0e09cae0be9e$var$SvgLogoNotagline(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: 831.549,
        height: 125.775
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0v16.283h-83.162V-4.484h44.245A44.42 44.42 0 0 0-14.878 2.55C-9.66 2.55-4.654 1.646 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 227.904 21.71)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-39.686v-20.767h25.73A44.688 44.688 0 0 0 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 169.937 32.137)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-24.824v-20.767H.102a44.705 44.705 0 0 0-1.279 10.604C-1.177-6.665-.761-3.266 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 150.12 64.274)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-25.88v-20.767h40.228A44.687 44.687 0 0 0 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 151.528 96.412)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h18.939l30.137-38.716V0h20.09v-73.247H51.483L20.09-33.065v-40.182H0Z",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 254.41 26.44)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h58.912v-17.16H20.09v-11.197h35.159v-16.01H20.09v-11.614h39.346v-17.266H0Z",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 359.851 26.44)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "m0 0 11.3 13.497c7.325-5.755 15.278-8.789 23.753-8.789 5.546 0 8.476 1.883 8.476 5.023v.209c0 3.14-2.406 4.709-12.452 7.116-15.591 3.557-27.624 7.952-27.624 22.916v.209c0 13.603 10.777 23.438 28.357 23.438 12.451 0 22.182-3.347 30.136-9.731l-10.15-14.336c-6.697 4.815-14.022 7.22-20.509 7.22-4.919 0-7.326-1.988-7.326-4.708v-.208c0-3.349 2.513-4.815 12.767-7.116 16.741-3.663 27.206-9.104 27.206-22.812v-.209c0-14.963-11.824-23.857-29.613-23.857C21.346-12.138 9.103-8.058 0 0",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 452.318 109.591)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-21.869v17.787h64.144V0H20.3v-55.459H0Z",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 573.333 50.156)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h34.636c11.195 0 18.939-2.93 23.857-7.846 4.29-4.292 6.487-9.838 6.487-17.058v-.209c0-11.3-5.964-18.729-15.068-22.601l17.476-25.533H44.054L29.298-51.063H20.3v-22.184H0Zm33.798-35.157c6.803 0 10.882 3.347 10.882 8.685v.207c0 5.861-4.289 8.791-10.986 8.791H20.3v-17.683z",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 642.919 26.44)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "m0 0-15.173-26.682L-30.24 0h-23.125l27.938-45.83v-27.417h20.3v27.73L22.707 0Z",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 801.273 26.44)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "m0 0-17.476-28.357L-34.951 0h-21.451v-73.247h19.882v41.96l18.625-28.565h.419L1.255-31.181v-42.066H21.45V0Z",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 75.203 26.44)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0c0-13.693-11.101-24.793-24.793-24.793-13.693 0-24.794 11.1-24.794 24.793s11.101 24.793 24.794 24.793C-11.101 24.793 0 13.693 0 0",
                style: {
                    fill: "#000",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 241.123 77.825)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-39.686v-20.767h25.73A44.688 44.688 0 0 0 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 169.937 32.137)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-24.824v-20.767H.102a44.705 44.705 0 0 0-1.279 10.604C-1.177-6.665-.761-3.266 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 150.12 64.274)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M0 0h-25.88v-20.767h40.228A44.687 44.687 0 0 0 0 0",
                style: {
                    fill: "#1797f2",
                    fillOpacity: 1,
                    fillRule: "nonzero",
                    stroke: "none"
                },
                transform: "matrix(1.33333 0 0 -1.33333 151.528 96.412)"
            })
        ]
    }));
}
var $b9da0e09cae0be9e$export$2e2bcd8739ae039 = $b9da0e09cae0be9e$var$SvgLogoNotagline;


/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/jsx-filename-extension */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function $1bd8308d52035eee$var$SvgLogoWhite(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: 851.549,
        height: 145.775
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0v16.283h-83.162V-4.484h44.245A44.42 44.42 0 0 0-14.878 2.55C-9.66 2.55-4.654 1.646 0 0",
                    style: {
                        // eslint-disable-next-line react/destructuring-assignment
                        fill: props.fillstack,
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 237.904 31.71)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-39.686v-20.767h25.73A44.688 44.688 0 0 0 0 0",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 179.937 42.137)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-24.824v-20.767H.102a44.705 44.705 0 0 0-1.279 10.604C-1.177-6.665-.761-3.266 0 0",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 160.12 74.274)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-25.88v-20.767h40.228A44.687 44.687 0 0 0 0 0",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 161.528 106.412)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h18.939l30.137-38.716V0h20.09v-73.247H51.483L20.09-33.065v-40.182H0Z",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 264.41 36.44)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h58.912v-17.16H20.09v-11.197h35.159v-16.01H20.09v-11.614h39.346v-17.266H0Z",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 369.851 36.44)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "m0 0 11.3 13.497c7.325-5.755 15.278-8.789 23.753-8.789 5.546 0 8.476 1.883 8.476 5.023v.209c0 3.14-2.406 4.709-12.452 7.116-15.591 3.557-27.624 7.952-27.624 22.916v.209c0 13.603 10.777 23.438 28.357 23.438 12.451 0 22.182-3.347 30.136-9.731l-10.15-14.336c-6.697 4.815-14.022 7.22-20.509 7.22-4.919 0-7.326-1.988-7.326-4.708v-.208c0-3.349 2.513-4.815 12.767-7.116 16.741-3.663 27.206-9.104 27.206-22.812v-.209c0-14.963-11.824-23.857-29.613-23.857C21.346-12.138 9.103-8.058 0 0",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 462.318 119.591)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-21.869v17.787h64.144V0H20.3v-55.459H0Z",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 583.333 60.156)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h34.636c11.195 0 18.939-2.93 23.857-7.846 4.29-4.292 6.487-9.838 6.487-17.058v-.209c0-11.3-5.964-18.729-15.068-22.601l17.476-25.533H44.054L29.298-51.063H20.3v-22.184H0Zm33.798-35.157c6.803 0 10.882 3.347 10.882 8.685v.207c0 5.861-4.289 8.791-10.986 8.791H20.3v-17.683z",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 652.919 36.44)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "m0 0-15.173-26.682L-30.24 0h-23.125l27.938-45.83v-27.417h20.3v27.73L22.707 0Z",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 811.273 36.44)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "m0 0-17.476-28.357L-34.951 0h-21.451v-73.247h19.882v41.96l18.625-28.565h.419L1.255-31.181v-42.066H21.45V0Z",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 85.203 36.44)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0c0-13.693-11.101-24.793-24.793-24.793-13.693 0-24.794 11.1-24.794 24.793s11.101 24.793 24.794 24.793C-11.101 24.793 0 13.693 0 0",
                    style: {
                        fill: "#fff",
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 251.123 87.825)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-39.686v-20.767h25.73A44.688 44.688 0 0 0 0 0",
                    style: {
                        fill: props.fillstack,
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 179.937 42.137)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-24.824v-20.767H.102a44.705 44.705 0 0 0-1.279 10.604C-1.177-6.665-.761-3.266 0 0",
                    style: {
                        fill: props.fillstack,
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 160.12 74.274)"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                style: {
                    fill: "#fff"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M0 0h-25.88v-20.767h40.228A44.687 44.687 0 0 0 0 0",
                    style: {
                        fill: props.fillstack,
                        fillOpacity: 1,
                        fillRule: "nonzero",
                        stroke: "none"
                    },
                    transform: "matrix(1.33333 0 0 -1.33333 161.528 106.412)"
                })
            })
        ]
    }));
}
$1bd8308d52035eee$var$SvgLogoWhite.propTypes = {
    fillstack: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$1bd8308d52035eee$var$SvgLogoWhite.defaultProps = {
    fillstack: "#202266"
};
var $1bd8308d52035eee$export$2e2bcd8739ae039 = $1bd8308d52035eee$var$SvgLogoWhite;



/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/jsx-filename-extension */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

function $12b139122e9d7192$var$SvgSymbolWhite(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        version: "1.1",
        id: "svg833",
        xmlSpace: "preserve",
        viewBox: "0 0 144.10213 144.10133",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("defs", {
                id: "defs837",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "clipPath849",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,257.598 H 751.181 V 0 H 0 Z",
                            id: "path847"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "clipPath963",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,257.598 H 751.181 V 0 H 0 Z",
                            id: "path961"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "clipPath1077",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,257.598 H 751.181 V 0 H 0 Z",
                            id: "path1075"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "clipPath1191",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,257.598 H 751.181 V 0 H 0 Z",
                            id: "path1189"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                        clipPathUnits: "userSpaceOnUse",
                        id: "clipPath1305",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,257.598 H 751.181 V 0 H 0 Z",
                            id: "path1303"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("g", {
                id: "g841",
                transform: "matrix(1.3333333,0,0,-1.3333333,-80.033464,268.45119)",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g851",
                        transform: "translate(150.6871,177.5554)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,0 V 16.283 H -83.162 V -4.484 h 44.245 c 6.94,4.445 15.185,7.034 24.039,7.034 C -9.66,2.55 -4.654,1.646 0,0",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path853"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g855",
                        transform: "translate(107.2118,169.7354)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "m 0,0 h -39.686 v -20.767 h 25.73 C -11.356,-12.565 -6.451,-5.39 0,0",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path857"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g859",
                        transform: "translate(92.349398,145.6326)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,0 H -24.824 V -20.767 H 0.102 c -0.829,3.4 -1.279,6.949 -1.279,10.604 0,3.498 0.416,6.897 1.177,10.163",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path861"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g863",
                        transform: "translate(93.405598,121.5294)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,0 H -25.88 V -20.767 H 14.348 C 7.749,-15.427 2.709,-8.244 0,0",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path865"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g953",
                        transform: "translate(160.6017,135.4698)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "m 0,0 c 0,-13.693 -11.101,-24.793 -24.793,-24.793 -13.693,0 -24.794,11.1 -24.794,24.793 0,13.693 11.101,24.793 24.794,24.793 C -11.101,24.793 0,13.693 0,0",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path955"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g969",
                        transform: "translate(107.2118,169.7354)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "m 0,0 h -39.686 v -20.767 h 25.73 C -11.356,-12.565 -6.451,-5.39 0,0",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path971"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g973",
                        transform: "translate(92.349398,145.6326)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,0 H -24.824 V -20.767 H 0.102 c -0.829,3.4 -1.279,6.949 -1.279,10.604 0,3.498 0.416,6.897 1.177,10.163",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path975"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                        id: "g977",
                        transform: "translate(93.405598,121.5294)",
                        style: {
                            fill: "#ffffff"
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                            d: "M 0,0 H -25.88 V -20.767 H 14.348 C 7.749,-15.427 2.709,-8.244 0,0",
                            style: {
                                fill: "#ffffff",
                                fillOpacity: 1,
                                fillRule: "nonzero",
                                stroke: "none"
                            },
                            id: "path979"
                        })
                    })
                ]
            })
        ]
    }));
}
var $12b139122e9d7192$export$2e2bcd8739ae039 = $12b139122e9d7192$var$SvgSymbolWhite;




const $10c3ddecbaea2060$export$42d15847cf9e98e1 = (props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $66b1933b1224486c$export$2e2bcd8739ae039), (0, $9tqwB._)({}, props));
var $10c3ddecbaea2060$export$2e2bcd8739ae039 = (0, $66b1933b1224486c$export$2e2bcd8739ae039);


function $22c5a69ba2799f42$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $22c5a69ba2799f42$var$LocalButton({ route: route, label: label, Icon: Icon, isWhite: isWhite, id: id }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                to: route,
                href: "#",
                className: $22c5a69ba2799f42$var$classNames(isWhite ? "bg-white border-2 border-brandBlue-400 text-brandBlue-500 hover:bg-opacity-75" : "bg-brandBlue-500 border-2 border-transparent text-white hover:bg-brandBlue-600", "hidden sm:inline-block py-2 px-4 rounded-md text-base font-medium"),
                children: label
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                to: route,
                href: "#",
                className: $22c5a69ba2799f42$var$classNames(isWhite ? "bg-white border-2 border-brandBlue-400 text-brandBlue-500 hover:bg-opacity-75" : "bg-brandBlue-500 border-2 border-transparent text-white hover:bg-brandBlue-600", "inline-block mt-2 sm:mt-0 sm:hidden py-2 px-4 rounded-md text-base font-medium"),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {
                    className: "h-6 w-6"
                })
            })
        ]
    });
}
$22c5a69ba2799f42$var$LocalButton.propTypes = {
    route: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    isWhite: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType.isRequired,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
function $22c5a69ba2799f42$export$2e2bcd8739ae039() {
    const { isLoggedIn: isLoggedIn } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user);
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const lang = i18n.language;
    const navigation = [
        {
            key: 1,
            name: t("site:menu.features"),
            link: `/${lang}/features`
        },
        {
            key: 2,
            name: t("site:menu.anonymous"),
            link: "/goto/anonymous-use"
        },
        {
            key: 3,
            name: t("site:menu.data"),
            link: "/goto/data-sources"
        },
        {
            key: 4,
            name: t("site:menu.blog"),
            link: `/${lang}/blog`
        },
        {
            key: 5,
            name: t("site:menu.meet"),
            link: `/${lang}/about-us`
        },
        {
            key: 6,
            name: t("site:menu.pricing"),
            link: `/${lang}/prices`
        },
        {
            key: 7,
            name: t("site:menu.demo"),
            link: `/${lang}/demo`
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "relative bg-gray-50 z-10",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("header", {
            className: "bg-white shadow relative",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
                className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
                "aria-label": "Top",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "w-full py-2 flex items-center justify-between border-b border-brandBlue-500 xl:border-none",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "py-4",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                                    to: `/${lang}/`,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "sr-only",
                                            role: "link",
                                            name: "homepage",
                                            children: "Monestry"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9da0e09cae0be9e$export$2e2bcd8739ae039), {
                                            width: "180",
                                            height: "28",
                                            viewBox: "0 0 831 126",
                                            className: "h-6 w-auto"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "hidden ml-10 space-x-6 xl:block",
                                    children: navigation.map((link)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: link.link,
                                            "data-testid": `header-${link.key}`,
                                            className: "text-l font-semibold text-gray-500 hover:text-gray-900",
                                            children: link.name
                                        }, link.key))
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "ml-10 space-x-4 flex flex-nowrap",
                                children: isLoggedIn ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            id: "dashboard",
                                            onClick: ()=>navigate(`/${lang}/app`),
                                            text: t("site:menu.dashboard"),
                                            withAccent: true
                                        }, "1"),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            id: "logout",
                                            onClick: ()=>navigate(`/${lang}/logout`),
                                            text: t("site:menu.logout"),
                                            noFrame: true
                                        }, "2")
                                    ]
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            id: "signon",
                                            onClick: ()=>navigate(`/${lang}/register`),
                                            text: t("site:menu.register"),
                                            withAccent: true
                                        }, "1"),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            id: "login",
                                            onClick: ()=>navigate(`/${lang}/login`),
                                            text: t("site:menu.login"),
                                            noFrame: true
                                        }, "2")
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "py-4 flex flex-wrap justify-center gap-4 xl:hidden",
                        children: navigation.map((link)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                href: link.href,
                                className: "text-base font-semibold text-gray-500 hover:text-indigo-50",
                                children: link.name
                            }, link.key))
                    })
                ]
            })
        })
    });
}


/* eslint-disable max-len */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable jsx-a11y/no-redundant-roles */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $01f5965251d69098$var$ChevronDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
        clipRule: "evenodd"
    }));
}
const $01f5965251d69098$var$ForwardRef = $7fPBF.forwardRef($01f5965251d69098$var$ChevronDownIcon);
var $01f5965251d69098$export$2e2bcd8739ae039 = $01f5965251d69098$var$ForwardRef;







function $913cec825392fdc0$export$f397a346e9b493ee() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function handleLanguageChange(e) {
        e.preventDefault();
        i18n.changeLanguage(e.target.value);
        // record this in user's profile as well
        dispatch((0, $8bd3fc2d0bca0786$export$3c0556baabe4d535)("locale", e.target.value));
    }
    function handleClick(e) {
        e.stopPropagation();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
        className: "mt-3 w-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                htmlFor: "language",
                className: "mt-3 sr-only",
                children: "Language"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                        id: "language",
                        name: "language",
                        className: "appearance-none block w-full bg-none bg-white border border-gray-300 rounded-md py-2 pl-3 pr-10 text-base text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                        value: i18n.language,
                        onClick: handleClick,
                        onChange: handleLanguageChange,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: "en",
                                children: t("site:general.english")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: "de",
                                children: t("site:general.german")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "pointer-events-none absolute inset-y-0 right-0 px-2 flex items-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01f5965251d69098$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 text-gray-400",
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        ]
    });
}
function $913cec825392fdc0$var$FacebookIcon(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
            clipRule: "evenodd"
        })
    }));
}
function $913cec825392fdc0$var$InstagramIcon(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z",
            clipRule: "evenodd"
        })
    }));
}
function $913cec825392fdc0$var$TwitterIcon(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
        })
    }));
}
function $913cec825392fdc0$var$GitHubIcon(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
            clipRule: "evenodd"
        })
    }));
}
function $913cec825392fdc0$var$displayCookieDialog() {
    // fire document event editConsent with no payload
    const event = new CustomEvent("editConsent");
    document.dispatchEvent(event);
}
function $913cec825392fdc0$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const [subscribeEmail, setSubscribeEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState("");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigation = {
        product: [
            {
                name: t("site:menu.features"),
                href: `/${i18n.language}/features`
            },
            {
                name: t("site:menu.anonymous"),
                href: "/goto/anonymous-use"
            },
            {
                name: t("site:menu.data"),
                href: "/goto/data-sources"
            },
            {
                name: t("site:menu.demo"),
                href: "#"
            }
        ],
        support: [
            {
                name: t("site:menu.guide"),
                href: `/${i18n.language}/blog/guide`
            },
            {
                name: t("site:menu.howto"),
                href: `/${i18n.language}/blog/guide`
            },
            {
                name: t("site:menu.contact"),
                href: `/${i18n.language}/contact`
            }
        ],
        company: [
            {
                name: t("site:menu.about"),
                href: `/${i18n.language}/blog/guide`
            },
            {
                name: t("site:menu.blog"),
                href: `/${i18n.language}/blog`
            },
            {
                name: t("site:menu.jobs"),
                href: "#"
            },
            {
                name: t("site:menu.press"),
                href: "#"
            },
            {
                name: t("site:menu.partners"),
                href: "#"
            }
        ],
        legal: [
            {
                name: t("site:menu.impressum"),
                href: `/${i18n.language}/legal`
            },
            {
                name: t("site:menu.privacy"),
                href: "#"
            },
            {
                name: t("site:menu.agb"),
                href: `/${i18n.language}/legal`
            }
        ],
        social: [
            {
                name: "Facebook",
                href: "#",
                icon: $913cec825392fdc0$var$FacebookIcon
            },
            {
                name: "Instagram",
                href: "#",
                icon: $913cec825392fdc0$var$InstagramIcon
            },
            {
                name: "Twitter",
                href: "#",
                icon: $913cec825392fdc0$var$TwitterIcon
            },
            {
                name: "GitHub",
                href: "#",
                icon: $913cec825392fdc0$var$GitHubIcon
            }
        ]
    };
    async function handleSubscribeNewsletter(e) {
        e.preventDefault();
        // fire document event editConsent with no payload
        const event = new CustomEvent("setAlert", {
            detail: {
                id: "signUpForNewsletter",
                caller: "Footer",
                callbackOk: async ()=>{
                    try {
                        await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", "customer/newsletterUser", {
                            body: {
                                email: subscribeEmail,
                                locale: i18n.language
                            }
                        });
                        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("newsletterSubscriptionSuccess"));
                    } catch (err) {
                        console.error(err);
                        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("newsletterSubscriptionError"));
                    }
                }
            }
        });
        window.dispatchEvent(event);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("footer", {
        className: "bg-gray-50",
        "aria-labelledby": "footer-heading",
        "data-testid": "footer",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                id: "footer-heading",
                className: "sr-only",
                children: "Footer"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "pb-8 xl:grid xl:grid-cols-5 xl:gap-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "grid grid-cols-2 gap-8 xl:col-span-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "md:grid md:grid-cols-2 md:gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                        children: t("site:menu.product")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                        role: "list",
                                                        className: "mt-4 space-y-4",
                                                        children: navigation.product.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                                    href: item.href,
                                                                    className: "text-base text-gray-500 hover:text-gray-900",
                                                                    children: item.name
                                                                })
                                                            }, item.name))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "mt-12 md:mt-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                        children: t("site:menu.support")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                        role: "list",
                                                        className: "mt-4 space-y-4",
                                                        children: navigation.support.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                                    href: item.href,
                                                                    className: "text-base text-gray-500 hover:text-gray-900",
                                                                    children: item.name
                                                                })
                                                            }, item.name))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "md:grid md:grid-cols-2 md:gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                        children: t("site:menu.company")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                        role: "list",
                                                        className: "mt-4 space-y-4",
                                                        children: navigation.company.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                                    href: item.href,
                                                                    className: "text-base text-gray-500 hover:text-gray-900",
                                                                    children: item.name
                                                                })
                                                            }, item.name))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "mt-12 md:mt-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                        children: t("site:menu.legal")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                                        role: "list",
                                                        className: "mt-4 space-y-4",
                                                        children: [
                                                            navigation.legal.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                                        href: item.href,
                                                                        className: "text-base text-gray-500 hover:text-gray-900",
                                                                        children: item.name
                                                                    })
                                                                }, item.name)),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: $913cec825392fdc0$var$displayCookieDialog,
                                                                    className: "text-base text-gray-500 hover:text-gray-900",
                                                                    children: "Cookies"
                                                                })
                                                            }, "cookies")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-12 xl:mt-0",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                                        className: "sm:max-w-xs",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                children: t("site:general.language")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($913cec825392fdc0$export$f397a346e9b493ee, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                                        className: "sm:max-w-xs",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                className: "mt-6 text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                                children: t("site:general.country")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                                className: "mt-3 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                        htmlFor: "country",
                                                        className: "sr-only",
                                                        children: "Country"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                                                id: "country-footer",
                                                                name: "country-footer",
                                                                className: "appearance-none block w-full bg-none bg-white border border-gray-300 rounded-md py-2 pl-3 pr-10 text-base text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                                                                defaultValue: "Germany",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                                    children: t("site:general.germany")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "pointer-events-none absolute inset-y-0 right-0 px-2 flex items-center",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01f5965251d69098$export$2e2bcd8739ae039), {
                                                                    className: "h-4 w-4 text-gray-400",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "border-t border-gray-200 pt-8 lg:flex lg:items-center lg:justify-between xl:mt-0",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: "text-sm font-semibold text-gray-400 tracking-wider uppercase",
                                        children: t("site:general.subscribe.header")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-2 text-base text-gray-500",
                                        children: t("site:general.subscribe.body")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                                className: "mt-4 sm:flex sm:max-w-md lg:mt-0",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "email-address",
                                        className: "sr-only",
                                        children: "Email address"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "email",
                                        name: "email-address",
                                        id: "email-address",
                                        autoComplete: "email",
                                        required: true,
                                        value: subscribeEmail,
                                        onChange: (e)=>setSubscribeEmail(e.target.value),
                                        className: "appearance-none min-w-0 w-full bg-white border border-gray-300 py-2 px-4 text-base rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:placeholder-gray-400 sm:max-w-xs",
                                        placeholder: t("site:general.subscribe.emailprompt")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            type: "submit",
                                            text: t("site:general.subscribe.button"),
                                            withAccent: true,
                                            onClick: handleSubscribeNewsletter
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex space-x-6 md:order-2",
                                children: navigation.social.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                        href: item.href,
                                        className: "text-gray-400 hover:text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.icon, {
                                                className: "h-6 w-6",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }, item.name))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "mt-8 text-base text-gray-400 md:mt-0 md:order-1",
                                children: [
                                    "\xa9 2021-",
                                    (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("YYYY"),
                                    " ",
                                    "Monestry GmbH. All rights reserved."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $54a7d1a042a6a79b$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $54a7d1a042a6a79b$export$4659b591c19bdf3d), t;
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $383c445be33b9dea$export$ce4ab0c55987d1ff(...n) {
    return n.filter(Boolean).join(" ");
}



var $72af10e8efa1b073$export$617d79dae526d2cf = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($72af10e8efa1b073$export$617d79dae526d2cf || {}), $72af10e8efa1b073$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($72af10e8efa1b073$export$80c0a745e59f7989 || {});
function $72af10e8efa1b073$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: a, features: s, visible: n = !0, name: l }) {
    let o = $72af10e8efa1b073$var$h(t, r);
    if (n) return $72af10e8efa1b073$var$m(o, e, a, l);
    let u = s != null ? s : 0;
    if (u & 2) {
        let { static: i = !1 } = o, d = (0, $bLhVg._)(o, [
            "static"
        ]);
        if (i) return $72af10e8efa1b073$var$m(d, e, a, l);
    }
    if (u & 1) {
        let { unmount: i = !0 } = o, d = (0, $bLhVg._)(o, [
            "unmount"
        ]);
        return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $72af10e8efa1b073$var$m((0, $2qxEV._)((0, $9tqwB._)({}, d), {
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }), e, a, l);
            }
        });
    }
    return $72af10e8efa1b073$var$m(o, e, a, l);
}
function $72af10e8efa1b073$var$m(r, t = {}, e, a) {
    var y;
    let _T = $72af10e8efa1b073$var$T(r, [
        "unmount",
        "static"
    ]), { as: s = e, children: n, refName: l = "ref" } = _T, o = (0, $bLhVg._)(_T, [
        "as",
        "children",
        "refName"
    ]), u = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, i = typeof n == "function" ? n(t) : n;
    o.className && typeof o.className == "function" && (o.className = o.className(t));
    let d = {};
    if (t) {
        let f = !1, c = [];
        for (let [p, F] of Object.entries(t))typeof F == "boolean" && (f = !0), F === !0 && c.push(p);
        f && (d["data-headlessui-state"] = c.join(" "));
    }
    if (s === (0, $7fPBF.Fragment) && Object.keys($72af10e8efa1b073$export$8e16b83750b44988(o)).length > 0) {
        if (!(0, $7fPBF.isValidElement)(i) || Array.isArray(i) && i.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${a} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(o).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let f = (0, $383c445be33b9dea$export$ce4ab0c55987d1ff)((y = i.props) == null ? void 0 : y.className, o.className), c = f ? {
            className: f
        } : {};
        return (0, $7fPBF.cloneElement)(i, Object.assign({}, $72af10e8efa1b073$var$h(i.props, $72af10e8efa1b073$export$8e16b83750b44988($72af10e8efa1b073$var$T(o, [
            "ref"
        ]))), d, u, $72af10e8efa1b073$var$O(i.ref, u.ref), c));
    }
    return (0, $7fPBF.createElement)(s, Object.assign({}, $72af10e8efa1b073$var$T(o, [
        "ref"
    ]), s !== (0, $7fPBF.Fragment) && u, s !== (0, $7fPBF.Fragment) && d), i);
}
function $72af10e8efa1b073$var$O(...r) {
    return {
        ref: r.every((t)=>t == null) ? void 0 : (t)=>{
            for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
    };
}
function $72af10e8efa1b073$var$h(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let s of r)for(let n in s)n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((s)=>[
            s,
            void 0
        ])));
    for(let s in e)Object.assign(t, {
        [s] (n, ...l) {
            let o = e[s];
            for (let u of o){
                if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
                u(n, ...l);
            }
        }
    });
    return t;
}
function $72af10e8efa1b073$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $7fPBF.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $72af10e8efa1b073$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $72af10e8efa1b073$var$T(r, t = []) {
    let e = Object.assign({}, r);
    for (let a of t)a in e && delete e[a];
    return e;
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $2028197d571918fc$var$i = Object.defineProperty;
var $2028197d571918fc$var$d = (t, e, n)=>e in t ? $2028197d571918fc$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $2028197d571918fc$var$r = (t, e, n)=>($2028197d571918fc$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $2028197d571918fc$var$o {
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
    constructor(){
        $2028197d571918fc$var$r(this, "current", this.detect());
        $2028197d571918fc$var$r(this, "handoffState", "pending");
        $2028197d571918fc$var$r(this, "currentId", 0);
    }
}
let $2028197d571918fc$export$a7b6bc01c63cdfc3 = new $2028197d571918fc$var$o;


let $9adada6c2c57de0b$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isServer ? (0, $7fPBF.useEffect)(e, f) : (0, $7fPBF.useLayoutEffect)(e, f);
};


function $2b7018cd7a1b1c81$export$86c4283a11f23f95(e) {
    let r = (0, $7fPBF.useRef)(e);
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}


let $7ace9f16f57ff3f5$export$90fc3a17d93f704c = function(t) {
    let e = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};


let $c1aa65a6b3c277bc$var$u = Symbol();
function $c1aa65a6b3c277bc$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$c1aa65a6b3c277bc$var$u]: n
    });
}
function $c1aa65a6b3c277bc$export$f6a25a78204acc7e(...t) {
    let n = (0, $7fPBF.useRef)(t);
    (0, $7fPBF.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$c1aa65a6b3c277bc$var$u])) ? void 0 : c;
}


var $e76e97d8e8b64098$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($e76e97d8e8b64098$export$4b0075e5ea5e1f26 || {});


function $9551cf0370e09058$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $9551cf0370e09058$var$i(l) ? !1 : t;
}
function $9551cf0370e09058$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

function $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa() {
    let [e, f] = (0, $7fPBF.useState)((0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isHandoffComplete);
    return e && (0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isHandoffComplete === !1 && f(!1), (0, $7fPBF.useEffect)(()=>{
        e !== !0 && f(!0);
    }, [
        e
    ]), (0, $7fPBF.useEffect)(()=>(0, $2028197d571918fc$export$a7b6bc01c63cdfc3).handoff(), []), e;
}



var $518ef203fb01499a$var$o;
let $518ef203fb01499a$export$f680877a34711e37 = ($518ef203fb01499a$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId) != null ? $518ef203fb01499a$var$o : function() {
    let n = (0, $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(n ? ()=>(0, $2028197d571918fc$export$a7b6bc01c63cdfc3).nextId() : null);
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        e === null && u((0, $2028197d571918fc$export$a7b6bc01c63cdfc3).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");




var $9tqwB = parcelRequire("9tqwB");

var $bLhVg = parcelRequire("bLhVg");

let $1f8e5f672a110f9e$var$a = "div";
var $1f8e5f672a110f9e$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($1f8e5f672a110f9e$export$617d79dae526d2cf || {});
let $1f8e5f672a110f9e$export$8dc98ba7eadeaa56 = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(t, o) {
    let { features: e = 1 } = t, r = (0, $bLhVg._)(t, [
        "features"
    ]), d = {
        ref: o,
        "aria-hidden": (e & 2) === 2 ? !0 : void 0,
        style: (0, $9tqwB._)({
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0"
        }, (e & 4) === 4 && (e & 2) !== 2 && {
            display: "none"
        })
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: r,
        slot: {},
        defaultTag: $1f8e5f672a110f9e$var$a,
        name: "Hidden"
    });
});


function $597194846d2133bb$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}


function $ae5551858911f61c$export$12b26c28a05aa001() {
    let a = [], i = [], r = {
        enqueue (e) {
            i.push(e);
        },
        addEventListener (e, t, n, s) {
            return e.addEventListener(t, n, s), r.add(()=>e.removeEventListener(t, n, s));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $597194846d2133bb$export$a5ff0d6a738703ca)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        add (e) {
            return a.push(e), ()=>{
                let t = a.indexOf(e);
                if (t >= 0) {
                    let [n] = a.splice(t, 1);
                    n();
                }
            };
        },
        dispose () {
            for (let e of a.splice(0))e();
        },
        async workQueue () {
            for (let e of i.splice(0))await e();
        },
        style (e, t, n) {
            let s = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: n
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: s
                });
            });
        }
    };
    return r;
}




function $7f54eb20f4d7e5f1$export$b204af158042fbac(r) {
    return (0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}


let $14e03ac93c8c8bff$var$f = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $14e03ac93c8c8bff$export$807a7eae502106e7 = ((r)=>(r[r.First = 1] = "First", r[r.Previous = 2] = "Previous", r[r.Next = 4] = "Next", r[r.Last = 8] = "Last", r[r.WrapAround = 16] = "WrapAround", r[r.NoScroll = 32] = "NoScroll", r))($14e03ac93c8c8bff$export$807a7eae502106e7 || {}), $14e03ac93c8c8bff$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($14e03ac93c8c8bff$export$abf286375dfa6dbd || {}), $14e03ac93c8c8bff$var$T = ((n)=>(n[n.Previous = -1] = "Previous", n[n.Next = 1] = "Next", n))($14e03ac93c8c8bff$var$T || {});
function $14e03ac93c8c8bff$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($14e03ac93c8c8bff$var$f)).sort((t, n)=>Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $14e03ac93c8c8bff$export$27112a34f2f8402d = ((n)=>(n[n.Strict = 0] = "Strict", n[n.Loose = 1] = "Loose", n))($14e03ac93c8c8bff$export$27112a34f2f8402d || {});
function $14e03ac93c8c8bff$export$ff1ec1c740b3c8d5(e, t = 0) {
    var n;
    return e === ((n = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(e)) == null ? void 0 : n.body) ? !1 : (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(t, {
        [0] () {
            return e.matches($14e03ac93c8c8bff$var$f);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($14e03ac93c8c8bff$var$f)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $14e03ac93c8c8bff$export$46388676ec35ab85(e) {
    let t = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(e);
    (0, $ae5551858911f61c$export$12b26c28a05aa001)().nextFrame(()=>{
        t && !$14e03ac93c8c8bff$export$ff1ec1c740b3c8d5(t.activeElement, 0) && $14e03ac93c8c8bff$export$5fed9cc43865dc7e(e);
    });
}
function $14e03ac93c8c8bff$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $14e03ac93c8c8bff$var$H = [
    "textarea",
    "input"
].join(",");
function $14e03ac93c8c8bff$var$w(e) {
    var t, n;
    return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, $14e03ac93c8c8bff$var$H)) != null ? n : !1;
}
function $14e03ac93c8c8bff$export$20305e96f91bf103(e, t = (n)=>n) {
    return e.slice().sort((n, l)=>{
        let o = t(n), i = t(l);
        if (o === null || i === null) return 0;
        let r = o.compareDocumentPosition(i);
        return r & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : r & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $14e03ac93c8c8bff$export$7fb6c844b485e870(e, t) {
    return $14e03ac93c8c8bff$export$82e1f4f412218a1d($14e03ac93c8c8bff$export$433aaa1f216cf32d(), t, {
        relativeTo: e
    });
}
function $14e03ac93c8c8bff$export$82e1f4f412218a1d(e, t, { sorted: n = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, r = Array.isArray(e) ? n ? $14e03ac93c8c8bff$export$20305e96f91bf103(e) : e : $14e03ac93c8c8bff$export$433aaa1f216cf32d(e);
    o.length > 0 && r.length > 1 && (r = r.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let d = (()=>{
        if (t & 5) return 1;
        if (t & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (t & 1) return 0;
        if (t & 2) return Math.max(0, r.indexOf(l)) - 1;
        if (t & 4) return Math.max(0, r.indexOf(l)) + 1;
        if (t & 8) return r.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = t & 32 ? {
        preventScroll: !0
    } : {}, c = 0, a = r.length, u;
    do {
        if (c >= a || c + a <= 0) return 0;
        let s = x + c;
        if (t & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = r[s], u == null || u.focus(p), c += d;
    }while (u !== i.activeElement);
    return t & 6 && $14e03ac93c8c8bff$var$w(u) && u.select(), u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $66f33e80775329e6$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(r);
    (0, $7fPBF.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


var $a84ce8905fd34ed3$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($a84ce8905fd34ed3$export$cacd6541cfeeb6c1 || {});
function $a84ce8905fd34ed3$export$19b797546aece48f() {
    let e = (0, $7fPBF.useRef)(0);
    return (0, $66f33e80775329e6$export$ee579bb285b8d4aa)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}



var $7fPBF = parcelRequire("7fPBF");

function $6d2f33deb59683e0$export$80c2a3957bcb42ea() {
    let e = (0, $7fPBF.useRef)(!1);
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}



var $7fPBF = parcelRequire("7fPBF");

function $0b7932f154e874bd$export$dd9fbcea3de0ae36(...e) {
    return (0, $7fPBF.useMemo)(()=>(0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(...e), [
        ...e
    ]);
}



var $7fPBF = parcelRequire("7fPBF");

function $9eb63a93d58df968$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(a);
    (0, $7fPBF.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}




var $7fPBF = parcelRequire("7fPBF");

function $2d03cf7d30b78b4f$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $7fPBF.useRef)([]), r = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(u);
    (0, $7fPBF.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}



var $7fPBF = parcelRequire("7fPBF");

function $1c5df13b27362c3d$export$fd183955ff4b45d9() {
    let [e] = (0, $7fPBF.useState)((0, $ae5551858911f61c$export$12b26c28a05aa001));
    return (0, $7fPBF.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}


let $87961d95093669cb$var$z = "div";
var $87961d95093669cb$var$A = ((t)=>(t[t.None = 1] = "None", t[t.InitialFocus = 2] = "InitialFocus", t[t.TabLock = 4] = "TabLock", t[t.FocusLock = 8] = "FocusLock", t[t.RestoreFocus = 16] = "RestoreFocus", t[t.All = 30] = "All", t))($87961d95093669cb$var$A || {});
let $87961d95093669cb$export$34eba2437817a67b = Object.assign((0, $72af10e8efa1b073$export$e43f39796049410c)(function(u, e) {
    let l = (0, $7fPBF.useRef)(null), a = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(l, e), { initialFocus: m, containers: t, features: n = 30 } = u, E = (0, $bLhVg._)(u, [
        "initialFocus",
        "containers",
        "features"
    ]);
    (0, $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa)() || (n = 1);
    let s = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(l);
    $87961d95093669cb$var$J({
        ownerDocument: s
    }, Boolean(n & 16));
    let S = $87961d95093669cb$var$Q({
        ownerDocument: s,
        container: l,
        initialFocus: m
    }, Boolean(n & 2));
    $87961d95093669cb$var$X({
        ownerDocument: s,
        container: l,
        containers: t,
        previousActiveElement: S
    }, Boolean(n & 8));
    let H = (0, $a84ce8905fd34ed3$export$19b797546aece48f)(), R = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((o)=>{
        let c = l.current;
        if (!c) return;
        ((_)=>_())(()=>{
            (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(H.current, {
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(c, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).First, {
                        skipElements: [
                            o.relatedTarget
                        ]
                    });
                },
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(c, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Last, {
                        skipElements: [
                            o.relatedTarget
                        ]
                    });
                }
            });
        });
    }), B = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), L = (0, $7fPBF.useRef)(!1), P = {
        ref: a,
        onKeyDown (o) {
            o.key == "Tab" && (L.current = !0, B.requestAnimationFrame(()=>{
                L.current = !1;
            }));
        },
        onBlur (o) {
            let c = new Set(t == null ? void 0 : t.current);
            c.add(l);
            let p = o.relatedTarget;
            p instanceof HTMLElement && p.dataset.headlessuiFocusGuard !== "true" && ($87961d95093669cb$var$h(c, p) || (L.current ? (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(l.current, (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(H.current, {
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $14e03ac93c8c8bff$export$807a7eae502106e7).Next,
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $14e03ac93c8c8bff$export$807a7eae502106e7).Previous
            }) | (0, $14e03ac93c8c8bff$export$807a7eae502106e7).WrapAround, {
                relativeTo: o.target
            }) : o.target instanceof HTMLElement && (0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(o.target)));
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, Boolean(n & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Focusable
    }), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: P,
        theirProps: E,
        defaultTag: $87961d95093669cb$var$z,
        name: "FocusTrap"
    }), Boolean(n & 4) && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Focusable
    }));
}), {
    features: $87961d95093669cb$var$A
});
function $87961d95093669cb$var$J({ ownerDocument: r }, u) {
    let e = (0, $7fPBF.useRef)(null);
    (0, $9eb63a93d58df968$export$7080b3e976bc91ab)(r == null ? void 0 : r.defaultView, "focusout", (a)=>{
        !u || e.current || (e.current = a.target);
    }, !0), (0, $2d03cf7d30b78b4f$export$3c773aa2b84f29e0)(()=>{
        u || ((r == null ? void 0 : r.activeElement) === (r == null ? void 0 : r.body) && (0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(e.current), e.current = null);
    }, [
        u
    ]);
    let l = (0, $7fPBF.useRef)(!1);
    (0, $7fPBF.useEffect)(()=>(l.current = !1, ()=>{
            l.current = !0, (0, $597194846d2133bb$export$a5ff0d6a738703ca)(()=>{
                !l.current || ((0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(e.current), e.current = null);
            });
        }), []);
}
function $87961d95093669cb$var$Q({ ownerDocument: r, container: u, initialFocus: e }, l) {
    let a = (0, $7fPBF.useRef)(null), m = (0, $6d2f33deb59683e0$export$80c2a3957bcb42ea)();
    return (0, $2d03cf7d30b78b4f$export$3c773aa2b84f29e0)(()=>{
        if (!l) return;
        let t = u.current;
        !t || (0, $597194846d2133bb$export$a5ff0d6a738703ca)(()=>{
            if (!m.current) return;
            let n = r == null ? void 0 : r.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === n) {
                    a.current = n;
                    return;
                }
            } else if (t.contains(n)) {
                a.current = n;
                return;
            }
            e != null && e.current ? (0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(e.current) : (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(t, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).First) === (0, $14e03ac93c8c8bff$export$abf286375dfa6dbd).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), a.current = r == null ? void 0 : r.activeElement;
        });
    }, [
        l
    ]), a;
}
function $87961d95093669cb$var$X({ ownerDocument: r, container: u, containers: e, previousActiveElement: l }, a) {
    let m = (0, $6d2f33deb59683e0$export$80c2a3957bcb42ea)();
    (0, $9eb63a93d58df968$export$7080b3e976bc91ab)(r == null ? void 0 : r.defaultView, "focus", (t)=>{
        if (!a || !m.current) return;
        let n = new Set(e == null ? void 0 : e.current);
        n.add(u);
        let E = l.current;
        if (!E) return;
        let s = t.target;
        s && s instanceof HTMLElement ? $87961d95093669cb$var$h(n, s) ? (l.current = s, (0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(s)) : (t.preventDefault(), t.stopPropagation(), (0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(E)) : (0, $14e03ac93c8c8bff$export$5fed9cc43865dc7e)(l.current);
    }, !0);
}
function $87961d95093669cb$var$h(r, u) {
    var e;
    for (let l of r)if ((e = l.current) != null && e.contains(u)) return !0;
    return !1;
}




let $7bb671a56735ce33$var$i = new Set, $7bb671a56735ce33$var$r = new Map;
function $7bb671a56735ce33$var$u(t) {
    t.setAttribute("aria-hidden", "true"), t.inert = !0;
}
function $7bb671a56735ce33$var$l(t) {
    let n = $7bb671a56735ce33$var$r.get(t);
    !n || (n["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", n["aria-hidden"]), t.inert = n.inert);
}
function $7bb671a56735ce33$export$af489fa7e5283cc3(t, n = !0) {
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (!n || !t.current) return;
        let o = t.current, a = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(o);
        if (!!a) {
            $7bb671a56735ce33$var$i.add(o);
            for (let e of $7bb671a56735ce33$var$r.keys())e.contains(o) && ($7bb671a56735ce33$var$l(e), $7bb671a56735ce33$var$r.delete(e));
            return a.querySelectorAll("body > *").forEach((e)=>{
                if (e instanceof HTMLElement) {
                    for (let f of $7bb671a56735ce33$var$i)if (e.contains(f)) return;
                    $7bb671a56735ce33$var$i.size === 1 && ($7bb671a56735ce33$var$r.set(e, {
                        "aria-hidden": e.getAttribute("aria-hidden"),
                        inert: e.inert
                    }), $7bb671a56735ce33$var$u(e));
                }
            }), ()=>{
                if ($7bb671a56735ce33$var$i.delete(o), $7bb671a56735ce33$var$i.size > 0) a.querySelectorAll("body > *").forEach((e)=>{
                    if (e instanceof HTMLElement && !$7bb671a56735ce33$var$r.has(e)) {
                        for (let f of $7bb671a56735ce33$var$i)if (e.contains(f)) return;
                        $7bb671a56735ce33$var$r.set(e, {
                            "aria-hidden": e.getAttribute("aria-hidden"),
                            inert: e.inert
                        }), $7bb671a56735ce33$var$u(e);
                    }
                });
                else for (let e of $7bb671a56735ce33$var$r.keys())$7bb671a56735ce33$var$l(e), $7bb671a56735ce33$var$r.delete(e);
            };
        }
    }, [
        n
    ]);
}



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



var $7fPBF = parcelRequire("7fPBF");
let $31eec9c638b8ef3a$var$e = (0, $7fPBF.createContext)(!1);
function $31eec9c638b8ef3a$export$6ecd3efa4eebe261() {
    return (0, $7fPBF.useContext)($31eec9c638b8ef3a$var$e);
}
function $31eec9c638b8ef3a$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($31eec9c638b8ef3a$var$e.Provider, {
        value: o.force
    }, o.children);
}







function $cc6203dcaeaae575$var$x(i) {
    let u = (0, $31eec9c638b8ef3a$export$6ecd3efa4eebe261)(), o = (0, $7fPBF.useContext)($cc6203dcaeaae575$var$A), e = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(i), [r, f] = (0, $7fPBF.useState)(()=>{
        if (!u && o !== null || (0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isServer) return null;
        let n = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (n) return n;
        if (e === null) return null;
        let t = e.createElement("div");
        return t.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(t);
    });
    return (0, $7fPBF.useEffect)(()=>{
        r !== null && (e != null && e.body.contains(r) || e == null || e.body.appendChild(r));
    }, [
        r,
        e
    ]), (0, $7fPBF.useEffect)(()=>{
        u || o !== null && f(o.current);
    }, [
        o,
        f,
        u
    ]), r;
}
let $cc6203dcaeaae575$var$_ = (0, $7fPBF.Fragment), $cc6203dcaeaae575$var$U = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(u, o) {
    let e = u, r = (0, $7fPBF.useRef)(null), f = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)((0, $c1aa65a6b3c277bc$export$7029785b750eb74)((a)=>{
        r.current = a;
    }), o), n = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(r), t = $cc6203dcaeaae575$var$x(r), [l] = (0, $7fPBF.useState)(()=>{
        var a;
        return (0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isServer ? null : (a = n == null ? void 0 : n.createElement("div")) != null ? a : null;
    }), b = (0, $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa)(), p = (0, $7fPBF.useRef)(!1);
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (p.current = !1, !(!t || !l)) return t.contains(l) || (l.setAttribute("data-headlessui-portal", ""), t.appendChild(l)), ()=>{
            p.current = !0, (0, $597194846d2133bb$export$a5ff0d6a738703ca)(()=>{
                var a;
                !p.current || !t || !l || (l instanceof Node && t.contains(l) && t.removeChild(l), t.childNodes.length <= 0 && ((a = t.parentElement) == null || a.removeChild(t)));
            });
        };
    }, [
        t,
        l
    ]), b ? !t || !l ? null : (0, $fw0lo.createPortal)((0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: f
        },
        theirProps: e,
        defaultTag: $cc6203dcaeaae575$var$_,
        name: "Portal"
    }), l) : null;
}), $cc6203dcaeaae575$var$j = (0, $7fPBF.Fragment), $cc6203dcaeaae575$var$A = (0, $7fPBF.createContext)(null), $cc6203dcaeaae575$var$F = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(u, o) {
    let { target: e } = u, r = (0, $bLhVg._)(u, [
        "target"
    ]), n = {
        ref: (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(o)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($cc6203dcaeaae575$var$A.Provider, {
        value: e
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: n,
        theirProps: r,
        defaultTag: $cc6203dcaeaae575$var$j,
        name: "Popover.Group"
    }));
}), $cc6203dcaeaae575$export$602eac185826482c = Object.assign($cc6203dcaeaae575$var$U, {
    Group: $cc6203dcaeaae575$var$F
});




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");





let $3eb8b29b6155d34a$var$d = (0, $7fPBF.createContext)(null);
function $3eb8b29b6155d34a$var$u() {
    let n = (0, $7fPBF.useContext)($3eb8b29b6155d34a$var$d);
    if (n === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $3eb8b29b6155d34a$var$u), t;
    }
    return n;
}
function $3eb8b29b6155d34a$export$babde88292020af7() {
    let [n, t] = (0, $7fPBF.useState)([]);
    return [
        n.length > 0 ? n.join(" ") : void 0,
        (0, $7fPBF.useMemo)(()=>function(e) {
                let i = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((r)=>(t((o)=>[
                            ...o,
                            r
                        ]), ()=>t((o)=>{
                            let s = o.slice(), p = s.indexOf(r);
                            return p !== -1 && s.splice(p, 1), s;
                        }))), a = (0, $7fPBF.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3eb8b29b6155d34a$var$d.Provider, {
                    value: a
                }, e.children);
            }, [
            t
        ])
    ];
}
let $3eb8b29b6155d34a$var$S = "p", $3eb8b29b6155d34a$export$393edc798c47379d = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(t, c) {
    let e = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: i = `headlessui-description-${e}` } = t, a = (0, $bLhVg._)(t, [
        "id"
    ]), r = $3eb8b29b6155d34a$var$u(), o = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(c);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>r.register(i), [
        i,
        r.register
    ]);
    let s = (0, $2qxEV._)((0, $9tqwB._)({
        ref: o
    }, r.props), {
        id: i
    });
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: s,
        theirProps: a,
        slot: r.slot || {},
        defaultTag: $3eb8b29b6155d34a$var$S,
        name: r.name || "Description"
    });
});



var $7fPBF = parcelRequire("7fPBF");
let $42e7df3a446fef87$var$o = (0, $7fPBF.createContext)(null);
$42e7df3a446fef87$var$o.displayName = "OpenClosedContext";
var $42e7df3a446fef87$export$7254cc27399e90bd = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($42e7df3a446fef87$export$7254cc27399e90bd || {});
function $42e7df3a446fef87$export$fc6fdf0ecf360e() {
    return (0, $7fPBF.useContext)($42e7df3a446fef87$var$o);
}
function $42e7df3a446fef87$export$2a0ed818b175f558({ value: t, children: n }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($42e7df3a446fef87$var$o.Provider, {
        value: t
    }, n);
}




var $7fPBF = parcelRequire("7fPBF");


let $980da5b2cffdcb62$var$a = (0, $7fPBF.createContext)(()=>{});
$980da5b2cffdcb62$var$a.displayName = "StackContext";
var $980da5b2cffdcb62$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($980da5b2cffdcb62$export$2dd25ef07fea092e || {});
function $980da5b2cffdcb62$export$59510f5936c4d8c4() {
    return (0, $7fPBF.useContext)($980da5b2cffdcb62$var$a);
}
function $980da5b2cffdcb62$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $980da5b2cffdcb62$export$59510f5936c4d8c4(), o = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($980da5b2cffdcb62$var$a.Provider, {
        value: o
    }, i);
}



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

function $0689a29c4910da0e$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(r);
    (0, $7fPBF.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}


function $fa9d8c8ce9154eec$export$71b2224f1ce5e08e(m, E, c = !0) {
    let i = (0, $7fPBF.useRef)(!1);
    (0, $7fPBF.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = c;
        });
    }, [
        c
    ]);
    function f(e, o) {
        if (!i.current || e.defaultPrevented) return;
        let l = function r(t) {
            return typeof t == "function" ? r(t()) : Array.isArray(t) || t instanceof Set ? t : [
                t
            ];
        }(m), n = o(e);
        if (n !== null && !!n.getRootNode().contains(n)) {
            for (let r of l){
                if (r === null) continue;
                let t = r instanceof HTMLElement ? r : r.current;
                if (t != null && t.contains(n) || e.composed && e.composedPath().includes(t)) return;
            }
            return !(0, $14e03ac93c8c8bff$export$ff1ec1c740b3c8d5)(n, (0, $14e03ac93c8c8bff$export$27112a34f2f8402d).Loose) && n.tabIndex !== -1 && e.preventDefault(), E(e, n);
        }
    }
    let u = (0, $7fPBF.useRef)(null);
    (0, $0689a29c4910da0e$export$55d2b5df396a097b)("mousedown", (e)=>{
        var o, l;
        i.current && (u.current = ((l = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : l[0]) || e.target);
    }, !0), (0, $0689a29c4910da0e$export$55d2b5df396a097b)("click", (e)=>{
        !u.current || (f(e, ()=>u.current), u.current = null);
    }, !0), (0, $0689a29c4910da0e$export$55d2b5df396a097b)("blur", (e)=>f(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
function $a3b4c12dd1e28420$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $a3b4c12dd1e28420$var$d = typeof Object.is == "function" ? Object.is : $a3b4c12dd1e28420$var$i, { useState: $a3b4c12dd1e28420$var$u, useEffect: $a3b4c12dd1e28420$var$h, useLayoutEffect: $a3b4c12dd1e28420$var$f, useDebugValue: $a3b4c12dd1e28420$var$p } = $7fPBF;
let $a3b4c12dd1e28420$var$S = !1, $a3b4c12dd1e28420$var$_ = !1;
function $a3b4c12dd1e28420$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $a3b4c12dd1e28420$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $a3b4c12dd1e28420$var$f(()=>{
        n.value = a, n.getSnapshot = t, $a3b4c12dd1e28420$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $a3b4c12dd1e28420$var$h(()=>($a3b4c12dd1e28420$var$r(n) && o({
            inst: n
        }), e(()=>{
            $a3b4c12dd1e28420$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $a3b4c12dd1e28420$var$p(a), a;
}
function $a3b4c12dd1e28420$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$a3b4c12dd1e28420$var$d(c, a);
    } catch (e) {
        return !0;
    }
}


function $178f7341bc4f9da9$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}


const $9d4954ede31286a6$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $9d4954ede31286a6$var$s = !$9d4954ede31286a6$var$r, $9d4954ede31286a6$var$c = $9d4954ede31286a6$var$s ? (0, $178f7341bc4f9da9$export$306c0aa65ff9ec16) : (0, $a3b4c12dd1e28420$export$306c0aa65ff9ec16), $9d4954ede31286a6$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $7fPBF ? ((n)=>n.useSyncExternalStore)($7fPBF) : $9d4954ede31286a6$var$c;


function $0a13a4cece8c2768$export$6ccbb43953eebf8(t) {
    return (0, $9d4954ede31286a6$export$306c0aa65ff9ec16)(t.subscribe, t.getSnapshot, t.getSnapshot);
}



function $e0dbd561a789bcf2$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}


function $a23c15a1dce2e512$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}


function $a8fab498f130e9bd$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}


function $f7285945c0185f2f$export$e3a523dfabf27286() {
    if (!(0, $a8fab498f130e9bd$export$fedb369cb70207f1)()) return {};
    let o;
    return {
        before () {
            o = window.pageYOffset;
        },
        after ({ doc: r, d: l, meta: s }) {
            function i(e) {
                return s.containers.flatMap((t)=>t()).some((t)=>t.contains(e));
            }
            l.style(r.body, "marginTop", `-${o}px`), window.scrollTo(0, 0);
            let n = null;
            l.addEventListener(r, "click", (e)=>{
                if (e.target instanceof HTMLElement) try {
                    let t = e.target.closest("a");
                    if (!t) return;
                    let { hash: c } = new URL(t.href), a = r.querySelector(c);
                    a && !i(a) && (n = a);
                } catch (e) {}
            }, !0), l.addEventListener(r, "touchmove", (e)=>{
                e.target instanceof HTMLElement && !i(e.target) && e.preventDefault();
            }, {
                passive: !1
            }), l.add(()=>{
                window.scrollTo(0, window.pageYOffset + o), n && n.isConnected && (n.scrollIntoView({
                    block: "nearest"
                }), n = null);
            });
        }
    };
}


function $b56372c287ec540f$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}


function $49b259fb6254b385$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $49b259fb6254b385$export$a4161f418919b5aa = (0, $e0dbd561a789bcf2$export$f51a9068ac82ea43)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $ae5551858911f61c$export$12b26c28a05aa001)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $49b259fb6254b385$var$m(t)
        }, c = [
            (0, $f7285945c0185f2f$export$e3a523dfabf27286)(),
            (0, $a23c15a1dce2e512$export$110627fb35ef9205)(),
            (0, $b56372c287ec540f$export$d8b6ff28805e84e9)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$49b259fb6254b385$export$a4161f418919b5aa.subscribe(()=>{
    let e = $49b259fb6254b385$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $49b259fb6254b385$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $49b259fb6254b385$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});


function $7807a6b788045565$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $0a13a4cece8c2768$export$6ccbb43953eebf8)((0, $49b259fb6254b385$export$a4161f418919b5aa)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (!(!e || !r)) return (0, $49b259fb6254b385$export$a4161f418919b5aa).dispatch("PUSH", e, n), ()=>(0, $49b259fb6254b385$export$a4161f418919b5aa).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}


var $ab39e0602eddb71e$var$Ee = ((t)=>(t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))($ab39e0602eddb71e$var$Ee || {}), $ab39e0602eddb71e$var$ve = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($ab39e0602eddb71e$var$ve || {});
let $ab39e0602eddb71e$var$be = {
    [0] (r, e) {
        return r.titleId === e.id ? r : (0, $2qxEV._)((0, $9tqwB._)({}, r), {
            titleId: e.id
        });
    }
}, $ab39e0602eddb71e$var$M = (0, $7fPBF.createContext)(null);
$ab39e0602eddb71e$var$M.displayName = "DialogContext";
function $ab39e0602eddb71e$var$L(r) {
    let e = (0, $7fPBF.useContext)($ab39e0602eddb71e$var$M);
    if (e === null) {
        let t = new Error(`<${r} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $ab39e0602eddb71e$var$L), t;
    }
    return e;
}
function $ab39e0602eddb71e$var$he(r, e, t = ()=>[
        document.body
    ]) {
    (0, $7807a6b788045565$export$bb0ae4a42bcd9e0)(r, e, (d)=>{
        var l;
        return {
            containers: [
                ...(l = d.containers) != null ? l : [],
                t
            ]
        };
    });
}
function $ab39e0602eddb71e$var$Ce(r, e) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(e.type, $ab39e0602eddb71e$var$be, r, e);
}
let $ab39e0602eddb71e$var$Oe = "div", $ab39e0602eddb71e$var$Se = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $ab39e0602eddb71e$var$Le = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, t) {
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: l = `headlessui-dialog-${d}`, open: n, onClose: o, initialFocus: a, __demoMode: c = !1 } = e, g = (0, $bLhVg._)(e, [
        "id",
        "open",
        "onClose",
        "initialFocus",
        "__demoMode"
    ]), [D, F] = (0, $7fPBF.useState)(0), i = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)();
    n === void 0 && i !== null && (n = (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i, {
        [(0, $42e7df3a446fef87$export$7254cc27399e90bd).Open]: !0,
        [(0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed]: !1
    }));
    let _ = (0, $7fPBF.useRef)(new Set), T = (0, $7fPBF.useRef)(null), J = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(T, t), U = (0, $7fPBF.useRef)(null), P = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(T), $ = e.hasOwnProperty("open") || i !== null, N = e.hasOwnProperty("onClose");
    if (!$ && !N) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!$) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!N) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof o != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${o}`);
    let s = n ? 0 : 1, [y, Q] = (0, $7fPBF.useReducer)($ab39e0602eddb71e$var$Ce, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $7fPBF.createRef)()
    }), R = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>o(!1)), W = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((p)=>Q({
            type: 0,
            id: p
        })), w = (0, $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa)() ? c ? !1 : s === 0 : !1, k = D > 1, X = (0, $7fPBF.useContext)($ab39e0602eddb71e$var$M) !== null, Z = k ? "parent" : "leaf";
    (0, $7bb671a56735ce33$export$af489fa7e5283cc3)(T, k ? w : !1);
    let Y = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        var A, f;
        return [
            ...Array.from((A = P == null ? void 0 : P.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? A : []).filter((m)=>!(m === document.body || m === document.head || !(m instanceof HTMLElement) || m.contains(U.current) || y.panelRef.current && m.contains(y.panelRef.current))),
            (f = y.panelRef.current) != null ? f : T.current
        ];
    });
    (0, $fa9d8c8ce9154eec$export$71b2224f1ce5e08e)(()=>Y(), R, w && !k), (0, $9eb63a93d58df968$export$7080b3e976bc91ab)(P == null ? void 0 : P.defaultView, "keydown", (p)=>{
        p.defaultPrevented || p.key === (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape && s === 0 && (k || (p.preventDefault(), p.stopPropagation(), R()));
    }), $ab39e0602eddb71e$var$he(P, s === 0 && !X, Y), (0, $7fPBF.useEffect)(()=>{
        if (s !== 0 || !T.current) return;
        let p = new IntersectionObserver((A)=>{
            for (let f of A)f.boundingClientRect.x === 0 && f.boundingClientRect.y === 0 && f.boundingClientRect.width === 0 && f.boundingClientRect.height === 0 && R();
        });
        return p.observe(T.current), ()=>p.disconnect();
    }, [
        s,
        T,
        R
    ]);
    let [ee, te] = (0, $3eb8b29b6155d34a$export$babde88292020af7)(), oe = (0, $7fPBF.useMemo)(()=>[
            {
                dialogState: s,
                close: R,
                setTitleId: W
            },
            y
        ], [
        s,
        y,
        R,
        W
    ]), j = (0, $7fPBF.useMemo)(()=>({
            open: s === 0
        }), [
        s
    ]), re = {
        ref: J,
        id: l,
        role: "dialog",
        "aria-modal": s === 0 ? !0 : void 0,
        "aria-labelledby": y.titleId,
        "aria-describedby": ee
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $980da5b2cffdcb62$export$4aac1a6640027f56), {
        type: "Dialog",
        enabled: s === 0,
        element: T,
        onUpdate: (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((p, A, f)=>{
            A === "Dialog" && (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(p, {
                [(0, $980da5b2cffdcb62$export$2dd25ef07fea092e).Add] () {
                    _.current.add(f), F((m)=>m + 1);
                },
                [(0, $980da5b2cffdcb62$export$2dd25ef07fea092e).Remove] () {
                    _.current.add(f), F((m)=>m - 1);
                }
            });
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $31eec9c638b8ef3a$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cc6203dcaeaae575$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ab39e0602eddb71e$var$M.Provider, {
        value: oe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cc6203dcaeaae575$export$602eac185826482c).Group, {
        target: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $31eec9c638b8ef3a$export$8f2af6644e3a3c93), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(te, {
        slot: j,
        name: "Dialog.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $87961d95093669cb$export$34eba2437817a67b), {
        initialFocus: a,
        containers: _,
        features: w ? (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(Z, {
            parent: (0, $87961d95093669cb$export$34eba2437817a67b).features.RestoreFocus,
            leaf: (0, $87961d95093669cb$export$34eba2437817a67b).features.All & ~(0, $87961d95093669cb$export$34eba2437817a67b).features.FocusLock
        }) : (0, $87961d95093669cb$export$34eba2437817a67b).features.None
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: re,
        theirProps: g,
        slot: j,
        defaultTag: $ab39e0602eddb71e$var$Oe,
        features: $ab39e0602eddb71e$var$Se,
        visible: s === 0,
        name: "Dialog"
    })))))))), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), {
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Hidden,
        ref: U
    }));
}), $ab39e0602eddb71e$var$Fe = "div", $ab39e0602eddb71e$var$ke = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, t) {
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: l = `headlessui-dialog-overlay-${d}` } = e, n = (0, $bLhVg._)(e, [
        "id"
    ]), [{ dialogState: o, close: a }] = $ab39e0602eddb71e$var$L("Dialog.Overlay"), c = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t), g = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((i)=>{
        if (i.target === i.currentTarget) {
            if ((0, $9551cf0370e09058$export$db61f031a278447c)(i.currentTarget)) return i.preventDefault();
            i.preventDefault(), i.stopPropagation(), a();
        }
    }), D = (0, $7fPBF.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: l,
            "aria-hidden": !0,
            onClick: g
        },
        theirProps: n,
        slot: D,
        defaultTag: $ab39e0602eddb71e$var$Fe,
        name: "Dialog.Overlay"
    });
}), $ab39e0602eddb71e$var$Ie = "div", $ab39e0602eddb71e$var$Me = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, t) {
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: l = `headlessui-dialog-backdrop-${d}` } = e, n = (0, $bLhVg._)(e, [
        "id"
    ]), [{ dialogState: o }, a] = $ab39e0602eddb71e$var$L("Dialog.Backdrop"), c = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t);
    (0, $7fPBF.useEffect)(()=>{
        if (a.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        a.panelRef
    ]);
    let g = (0, $7fPBF.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $31eec9c638b8ef3a$export$8f2af6644e3a3c93), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $cc6203dcaeaae575$export$602eac185826482c), null, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: l,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: g,
        defaultTag: $ab39e0602eddb71e$var$Ie,
        name: "Dialog.Backdrop"
    })));
}), $ab39e0602eddb71e$var$_e = "div", $ab39e0602eddb71e$var$we = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, t) {
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: l = `headlessui-dialog-panel-${d}` } = e, n = (0, $bLhVg._)(e, [
        "id"
    ]), [{ dialogState: o }, a] = $ab39e0602eddb71e$var$L("Dialog.Panel"), c = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t, a.panelRef), g = (0, $7fPBF.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]), D = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((i)=>{
        i.stopPropagation();
    });
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: l,
            onClick: D
        },
        theirProps: n,
        slot: g,
        defaultTag: $ab39e0602eddb71e$var$_e,
        name: "Dialog.Panel"
    });
}), $ab39e0602eddb71e$var$xe = "h2", $ab39e0602eddb71e$var$He = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, t) {
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: l = `headlessui-dialog-title-${d}` } = e, n = (0, $bLhVg._)(e, [
        "id"
    ]), [{ dialogState: o, setTitleId: a }] = $ab39e0602eddb71e$var$L("Dialog.Title"), c = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t);
    (0, $7fPBF.useEffect)(()=>(a(l), ()=>a(null)), [
        l,
        a
    ]);
    let g = (0, $7fPBF.useMemo)(()=>({
            open: o === 0
        }), [
        o
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: l
        },
        theirProps: n,
        slot: g,
        defaultTag: $ab39e0602eddb71e$var$xe,
        name: "Dialog.Title"
    });
}), $ab39e0602eddb71e$export$3ddf2d174ce01153 = Object.assign($ab39e0602eddb71e$var$Le, {
    Backdrop: $ab39e0602eddb71e$var$Me,
    Panel: $ab39e0602eddb71e$var$we,
    Overlay: $ab39e0602eddb71e$var$ke,
    Title: $ab39e0602eddb71e$var$He,
    Description: (0, $3eb8b29b6155d34a$export$393edc798c47379d)
});


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");








function $ec371da3c6bcb35b$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}




function $da958d3c26ab23f2$var$v(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $da958d3c26ab23f2$var$f(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $da958d3c26ab23f2$var$F(t, e) {
    let n = (0, $ae5551858911f61c$export$12b26c28a05aa001)();
    if (!t) return n.dispose;
    let { transitionDuration: a, transitionDelay: i } = getComputedStyle(t), [m, d] = [
        a,
        i
    ].map((o)=>{
        let [r = 0] = o.split(",").filter(Boolean).map((l)=>l.includes("ms") ? parseFloat(l) : parseFloat(l) * 1e3).sort((l, g)=>g - l);
        return r;
    });
    if (m + d !== 0) {
        let o = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), o());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $da958d3c26ab23f2$export$66bb15e2994e6a26(t, e, n, a) {
    let i = n ? "enter" : "leave", m = (0, $ae5551858911f61c$export$12b26c28a05aa001)(), d = a !== void 0 ? (0, $ec371da3c6bcb35b$export$d2de3aaeafa91619)(a) : ()=>{};
    i === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let u = (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), o = (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $da958d3c26ab23f2$var$f(t, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $da958d3c26ab23f2$var$v(t, ...u, ...r), m.nextFrame(()=>{
        $da958d3c26ab23f2$var$f(t, ...r), $da958d3c26ab23f2$var$v(t, ...o), $da958d3c26ab23f2$var$F(t, ()=>($da958d3c26ab23f2$var$f(t, ...u), $da958d3c26ab23f2$var$v(t, ...e.entered), d()));
    }), m.dispose;
}







function $005cab2b20d0acb8$export$7b286972b8d8ccbf({ container: i, direction: t, classes: o, onStart: s, onStop: u }) {
    let a = (0, $6d2f33deb59683e0$export$80c2a3957bcb42ea)(), c = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), r = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(t);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        let e = (0, $ae5551858911f61c$export$12b26c28a05aa001)();
        c.add(e.dispose);
        let n = i.current;
        if (!!n && r.current !== "idle" && !!a.current) return e.dispose(), s.current(r.current), e.add((0, $da958d3c26ab23f2$export$66bb15e2994e6a26)(n, o.current, r.current === "enter", ()=>{
            e.dispose(), u.current(r.current);
        })), e.dispose;
    }, [
        t
    ]);
}






function $b751aa1027c36e73$var$P(i = "") {
    return i.split(" ").filter((e)=>e.trim().length > 1);
}
let $b751aa1027c36e73$var$A = (0, $7fPBF.createContext)(null);
$b751aa1027c36e73$var$A.displayName = "TransitionContext";
var $b751aa1027c36e73$var$ge = ((s)=>(s.Visible = "visible", s.Hidden = "hidden", s))($b751aa1027c36e73$var$ge || {});
function $b751aa1027c36e73$var$be() {
    let i = (0, $7fPBF.useContext)($b751aa1027c36e73$var$A);
    if (i === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return i;
}
function $b751aa1027c36e73$var$Ee() {
    let i = (0, $7fPBF.useContext)($b751aa1027c36e73$var$M);
    if (i === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return i;
}
let $b751aa1027c36e73$var$M = (0, $7fPBF.createContext)(null);
$b751aa1027c36e73$var$M.displayName = "NestingContext";
function $b751aa1027c36e73$var$I(i) {
    return "children" in i ? $b751aa1027c36e73$var$I(i.children) : i.current.filter(({ el: e })=>e.current !== null).filter(({ state: e })=>e === "visible").length > 0;
}
function $b751aa1027c36e73$var$ne(i, e) {
    let s = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(i), n = (0, $7fPBF.useRef)([]), m = (0, $6d2f33deb59683e0$export$80c2a3957bcb42ea)(), y = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), b = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l, r = (0, $72af10e8efa1b073$export$80c0a745e59f7989).Hidden)=>{
        let t = n.current.findIndex(({ el: o })=>o === l);
        t !== -1 && ((0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(r, {
            [(0, $72af10e8efa1b073$export$80c0a745e59f7989).Unmount] () {
                n.current.splice(t, 1);
            },
            [(0, $72af10e8efa1b073$export$80c0a745e59f7989).Hidden] () {
                n.current[t].state = "hidden";
            }
        }), y.microTask(()=>{
            var o;
            !$b751aa1027c36e73$var$I(n) && m.current && ((o = s.current) == null || o.call(s));
        }));
    }), E = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>{
        let r = n.current.find(({ el: t })=>t === l);
        return r ? r.state !== "visible" && (r.state = "visible") : n.current.push({
            el: l,
            state: "visible"
        }), ()=>b(l, (0, $72af10e8efa1b073$export$80c0a745e59f7989).Unmount);
    }), S = (0, $7fPBF.useRef)([]), u = (0, $7fPBF.useRef)(Promise.resolve()), p = (0, $7fPBF.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), d = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l, r, t)=>{
        S.current.splice(0), e && (e.chains.current[r] = e.chains.current[r].filter(([o])=>o !== l)), e == null || e.chains.current[r].push([
            l,
            new Promise((o)=>{
                S.current.push(o);
            })
        ]), e == null || e.chains.current[r].push([
            l,
            new Promise((o)=>{
                Promise.all(p.current[r].map(([f, a])=>a)).then(()=>o());
            })
        ]), r === "enter" ? u.current = u.current.then(()=>e == null ? void 0 : e.wait.current).then(()=>t(r)) : t(r);
    }), v = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l, r, t)=>{
        Promise.all(p.current[r].splice(0).map(([o, f])=>f)).then(()=>{
            var o;
            (o = S.current.shift()) == null || o();
        }).then(()=>t(r));
    });
    return (0, $7fPBF.useMemo)(()=>({
            children: n,
            register: E,
            unregister: b,
            onStart: d,
            onStop: v,
            wait: u,
            chains: p
        }), [
        E,
        b,
        n,
        d,
        v,
        p,
        u
    ]);
}
function $b751aa1027c36e73$var$Se() {}
let $b751aa1027c36e73$var$xe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $b751aa1027c36e73$var$re(i) {
    var s;
    let e = {};
    for (let n of $b751aa1027c36e73$var$xe)e[n] = (s = i[n]) != null ? s : $b751aa1027c36e73$var$Se;
    return e;
}
function $b751aa1027c36e73$var$Pe(i) {
    let e = (0, $7fPBF.useRef)($b751aa1027c36e73$var$re(i));
    return (0, $7fPBF.useEffect)(()=>{
        e.current = $b751aa1027c36e73$var$re(i);
    }, [
        i
    ]), e;
}
let $b751aa1027c36e73$var$He = "div", $b751aa1027c36e73$var$ie = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy, $b751aa1027c36e73$var$oe = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, s) {
    let { beforeEnter: n, afterEnter: m, beforeLeave: y, afterLeave: b, enter: E, enterFrom: S, enterTo: u, entered: p, leave: d, leaveFrom: v, leaveTo: l } = e, r = (0, $bLhVg._)(e, [
        "beforeEnter",
        "afterEnter",
        "beforeLeave",
        "afterLeave",
        "enter",
        "enterFrom",
        "enterTo",
        "entered",
        "leave",
        "leaveFrom",
        "leaveTo"
    ]), t = (0, $7fPBF.useRef)(null), o = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t, s), f = r.unmount ? (0, $72af10e8efa1b073$export$80c0a745e59f7989).Unmount : (0, $72af10e8efa1b073$export$80c0a745e59f7989).Hidden, { show: a, appear: x, initial: se } = $b751aa1027c36e73$var$be(), [h, _] = (0, $7fPBF.useState)(a ? "visible" : "hidden"), K = $b751aa1027c36e73$var$Ee(), { register: D, unregister: V } = K, j = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>D(t), [
        D,
        t
    ]), (0, $7fPBF.useEffect)(()=>{
        if (f === (0, $72af10e8efa1b073$export$80c0a745e59f7989).Hidden && !!t.current) {
            if (a && h !== "visible") {
                _("visible");
                return;
            }
            return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(h, {
                ["hidden"]: ()=>V(t),
                ["visible"]: ()=>D(t)
            });
        }
    }, [
        h,
        t,
        D,
        V,
        a,
        f
    ]);
    let U = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)({
        enter: $b751aa1027c36e73$var$P(E),
        enterFrom: $b751aa1027c36e73$var$P(S),
        enterTo: $b751aa1027c36e73$var$P(u),
        entered: $b751aa1027c36e73$var$P(p),
        leave: $b751aa1027c36e73$var$P(d),
        leaveFrom: $b751aa1027c36e73$var$P(v),
        leaveTo: $b751aa1027c36e73$var$P(l)
    }), L = $b751aa1027c36e73$var$Pe({
        beforeEnter: n,
        afterEnter: m,
        beforeLeave: y,
        afterLeave: b
    }), k = (0, $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa)();
    (0, $7fPBF.useEffect)(()=>{
        if (k && h === "visible" && t.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        t,
        h,
        k
    ]);
    let G = se && !x, le = (()=>!k || G || j.current === a ? "idle" : a ? "enter" : "leave")(), ae = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((C)=>(0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(C, {
            enter: ()=>L.current.beforeEnter(),
            leave: ()=>L.current.beforeLeave(),
            idle: ()=>{}
        })), ue = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((C)=>(0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(C, {
            enter: ()=>L.current.afterEnter(),
            leave: ()=>L.current.afterLeave(),
            idle: ()=>{}
        })), w = $b751aa1027c36e73$var$ne(()=>{
        _("hidden"), V(t);
    }, K);
    (0, $005cab2b20d0acb8$export$7b286972b8d8ccbf)({
        container: t,
        classes: U,
        direction: le,
        onStart: (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)((C)=>{
            w.onStart(t, C, ae);
        }),
        onStop: (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)((C)=>{
            w.onStop(t, C, ue), C === "leave" && !$b751aa1027c36e73$var$I(w) && (_("hidden"), V(t));
        })
    }), (0, $7fPBF.useEffect)(()=>{
        !G || (f === (0, $72af10e8efa1b073$export$80c0a745e59f7989).Hidden ? j.current = null : j.current = a);
    }, [
        a,
        G,
        h
    ]);
    let B = r, de = {
        ref: o
    };
    return x && a && (0, $2028197d571918fc$export$a7b6bc01c63cdfc3).isServer && (B = (0, $2qxEV._)((0, $9tqwB._)({}, B), {
        className: (0, $383c445be33b9dea$export$ce4ab0c55987d1ff)(r.className, ...U.current.enter, ...U.current.enterFrom)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b751aa1027c36e73$var$M.Provider, {
        value: w
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $42e7df3a446fef87$export$2a0ed818b175f558), {
        value: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(h, {
            ["visible"]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open,
            ["hidden"]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed
        })
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: de,
        theirProps: B,
        defaultTag: $b751aa1027c36e73$var$He,
        features: $b751aa1027c36e73$var$ie,
        visible: h === "visible",
        name: "Transition.Child"
    })));
}), $b751aa1027c36e73$var$J = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, s) {
    let { show: n, appear: m = !1, unmount: y } = e, b = (0, $bLhVg._)(e, [
        "show",
        "appear",
        "unmount"
    ]), E = (0, $7fPBF.useRef)(null), S = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(E, s);
    (0, $93fd0dc3575a17bb$export$44ab2b9f2d09b0fa)();
    let u = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)();
    if (n === void 0 && u !== null && (n = (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(u, {
        [(0, $42e7df3a446fef87$export$7254cc27399e90bd).Open]: !0,
        [(0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed]: !1
    })), ![
        !0,
        !1
    ].includes(n)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [p, d] = (0, $7fPBF.useState)(n ? "visible" : "hidden"), v = $b751aa1027c36e73$var$ne(()=>{
        d("hidden");
    }), [l, r] = (0, $7fPBF.useState)(!0), t = (0, $7fPBF.useRef)([
        n
    ]);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        l !== !1 && t.current[t.current.length - 1] !== n && (t.current.push(n), r(!1));
    }, [
        t,
        n
    ]);
    let o = (0, $7fPBF.useMemo)(()=>({
            show: n,
            appear: m,
            initial: l
        }), [
        n,
        m,
        l
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (n) d("visible");
        else if (!$b751aa1027c36e73$var$I(v)) d("hidden");
        else {
            let a = E.current;
            if (!a) return;
            let x = a.getBoundingClientRect();
            x.x === 0 && x.y === 0 && x.width === 0 && x.height === 0 && d("hidden");
        }
    }, [
        n,
        v
    ]);
    let f = {
        unmount: y
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b751aa1027c36e73$var$M.Provider, {
        value: v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b751aa1027c36e73$var$A.Provider, {
        value: o
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: (0, $2qxEV._)((0, $9tqwB._)({}, f), {
            as: (0, $7fPBF.Fragment),
            children: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b751aa1027c36e73$var$oe, (0, $9tqwB._)({
                ref: S
            }, f, b))
        }),
        theirProps: {},
        defaultTag: (0, $7fPBF.Fragment),
        features: $b751aa1027c36e73$var$ie,
        visible: p === "visible",
        name: "Transition"
    })));
}), $b751aa1027c36e73$var$Ne = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(e, s) {
    let n = (0, $7fPBF.useContext)($b751aa1027c36e73$var$A) !== null, m = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)() !== null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, !n && m ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b751aa1027c36e73$var$J, (0, $9tqwB._)({
        ref: s
    }, e)) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($b751aa1027c36e73$var$oe, (0, $9tqwB._)({
        ref: s
    }, e)));
}), $b751aa1027c36e73$export$be58926105124dd4 = Object.assign($b751aa1027c36e73$var$J, {
    Child: $b751aa1027c36e73$var$Ne,
    Root: $b751aa1027c36e73$var$J
});





var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $68ecf30d598e901c$var$XMarkIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $68ecf30d598e901c$var$ForwardRef = $7fPBF.forwardRef($68ecf30d598e901c$var$XMarkIcon);
var $68ecf30d598e901c$export$2e2bcd8739ae039 = $68ecf30d598e901c$var$ForwardRef;






/* This example requires Tailwind CSS v2.0+ */ 
parcelRequire("7fPBF");
function $a669437859fadb04$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white shadow sm:rounded-lg",
        "data-testid": "alert-dialog",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "px-4 py-5 sm:p-6",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "text-lg leading-6 font-medium text-gray-900",
                    children: props.title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-2 max-w-xl text-sm text-gray-500",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: props.text
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-5",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:text-sm",
                        onClick: ()=>props.dialogStateCallback({
                                visible: false
                            }),
                        children: props.buttonText
                    })
                })
            ]
        })
    });
}



function $288ae22ef857ab2c$export$2e2bcd8739ae039() {
    const closeDialogInitial = {
        visible: false,
        text: "Sample text",
        title: "Sample title",
        buttonText: "OK"
    };
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [feedbackField, setFeedbackField] = (0, $7fPBF.useState)("");
    const [buttonPressed, setButton] = (0, $7fPBF.useState)("Problem");
    const [checkBoxMarked, setCheckBox] = (0, $7fPBF.useState)(false);
    const [closeDialog, setCloseDialog] = (0, $7fPBF.useState)(closeDialogInitial);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [fileArray, setFileArray] = (0, $7fPBF.useState)([]); // expects an array, convert FileList to an array before updating the state
    const [fileLoading, setFileLoading] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    const currentRoute = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    async function postData(payload, _fileArray) {
        var _session_tokens_idToken, _session_tokens;
        // get session details from Amplify.Auth
        const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
        // insert all files into the body
        const body = (0, $9tqwB._)({}, payload);
        // attach base64 encoded files to the body
        if (_fileArray.length > 0) {
            body.attachments = [];
            await Promise.all(_fileArray.map((file)=>new Promise((resolve, reject)=>{
                    const reader = new FileReader();
                    reader.onload = ()=>{
                        body.attachments.push({
                            name: file.name,
                            type: file.type,
                            data: reader.result.split(",")[1]
                        });
                        resolve();
                    };
                    reader.onerror = (error)=>{
                        reject(error);
                    };
                    reader.readAsDataURL(file);
                })));
        }
        const idToken = (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString();
        if (!idToken) throw new Error("Missing authentication token");
        const myInit = {
            body: body,
            headers: {
                "Content-Type": "application/json",
                Authorization: idToken
            }
        };
        let response;
        try {
            response = await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", "misc/feedback", myInit);
        } catch (error) {
            console.log(error.response);
            throw new Error(error);
        }
        return response;
    }
    async function handleSubmit() {
        // package all the relevant information into a payload object
        const jiraPayloadObject = {
            message: {
                type: buttonPressed,
                // make an actual (deep) copy of the state in memory to avoid circular reference
                // when running postData
                text: feedbackField,
                followUpRequested: checkBoxMarked
            },
            context: {
                currentRoute: currentRoute,
                componentState: {}
            }
        };
        // dispatch payload to lambda
        let response;
        try {
            setIsLoading(true);
            response = await postData(jiraPayloadObject, fileArray);
            setIsLoading(false);
            setOpen(false);
            setFileArray([]);
            setCloseDialog({
                visible: true,
                text: `${t("site:feedback.completed.success")} ${response.key}`,
                title: t("site:general.success"),
                buttonText: t("site:general.ok")
            });
        } catch (error) {
            setIsLoading(false);
            setOpen(false);
            setFileArray([]);
            console.log(`Jira API returned error --> ${error}`);
            setCloseDialog({
                visible: true,
                text: t("site:feedback.completed.failure"),
                title: t("site:general.error"),
                buttonText: t("site:general.ok")
            });
        }
    }
    // handle file upload
    (0, $7fPBF.useEffect)(()=>{
        if (fileArray) {
            setFileLoading(true);
            // accept multiple files and read them in parallel
            if (fileArray.length > 0) {
                // lambda can only handle 6MB, so the limit is set to 5.5MB
                const totalSize = fileArray.reduce((acc, file)=>acc + file.size, 0);
                if (totalSize > 5500000) {
                    dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileTooLarge"));
                    setFileLoading(false);
                    setFileArray(null);
                }
            }
        }
    }, [
        fileArray
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                show: open,
                as: (0, $7fPBF.Fragment),
                enter: "transform transition ease-in-out duration-500 sm:duration-700",
                enterFrom: "translate-x-full",
                enterTo: "translate-x-0",
                leave: "transform transition ease-in-out duration-500 sm:duration-700",
                leaveFrom: "translate-x-0",
                leaveTo: "translate-x-full",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153), {
                    as: "div",
                    className: "fixed inset-0 overflow-hidden z-[100]",
                    onClose: setOpen,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "absolute inset-0 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Overlay, {
                                className: "absolute inset-0"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "fixed inset-y-0 right-0 pl-10 max-w-full flex",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "w-screen max-w-md",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl",
                                        children: [
                                            isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                id: "loading",
                                                className: "absolute w-full h-full bg-blend-overlay bg-gray-200 z-50 bg-opacity-50 flex justify-center items-center",
                                                "data-testid": "feedback-overlay-gray",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "flex flex-col gap-3 text-sm text-gray-700 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$59de000b07aa1ecd), {
                                                            className: "h-12 w-12 text-gray-500 animate-spin"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "pt-2",
                                                            children: t("feedback.beingUploaded")
                                                        })
                                                    ]
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "min-h-0 flex-1 flex flex-col py-6 overflow-y-scroll",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "px-4 sm:px-6",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "flex items-start justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Title, {
                                                                    className: "text-2xl font-bold text-gray-900",
                                                                    children: t("site:feedback.title")
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "ml-3 h-7 flex items-center",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brandBlue-500",
                                                                        onClick: ()=>setOpen(false),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "Close panel"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68ecf30d598e901c$export$2e2bcd8739ae039), {
                                                                                className: "h-6 w-6",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "mt-6 relative flex-1 space-y-6 px-4 sm:px-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "w-auto",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: "relative z-0 flex shadow-sm rounded-md",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                            type: "button",
                                                                            id: "problem",
                                                                            // eslint-disable-next-line max-len
                                                                            className: classNames(buttonPressed === "Problem" ? "z-10 outline-none ring-1 ring-brandBlue-500 border-brandBlue-500" : "border-gray-300", "relative flex-1 items-center px-4 py-2 rounded-l-md border  bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"),
                                                                            onClick: ()=>setButton("Problem"),
                                                                            children: t("site:feedback.problem")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                            type: "button",
                                                                            id: "idea",
                                                                            className: classNames(buttonPressed === "Idea" ? "z-10 outline-none ring-1 ring-brandBlue-500 border-brandBlue-500" : "border-gray-300", "-ml-px relative flex-1 items-center px-4 py-2 border bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"),
                                                                            onClick: ()=>setButton("Idea"),
                                                                            children: t("site:feedback.idea")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                            type: "button",
                                                                            id: "question",
                                                                            className: classNames(buttonPressed === "Question" ? "z-10 outline-none ring-1 ring-brandBlue-500 border-brandBlue-500" : "border-gray-300", "-ml-px relative flex-1 items-center px-4 py-2 rounded-r-md border  bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"),
                                                                            onClick: ()=>setButton("Question"),
                                                                            children: t("site:feedback.question")
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "mt-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "comment",
                                                                        className: "block text-sm font-medium text-gray-700",
                                                                        children: t("site:feedback.header")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "mt-1",
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                                                            onChange: (e)=>setFeedbackField(e.target.value),
                                                                            rows: 8,
                                                                            name: "comment",
                                                                            id: "comment",
                                                                            className: "shadow-sm focus:ring-brandBlue focus:border-brandBlue block w-full sm:text-sm border-gray-300 rounded-md",
                                                                            value: feedbackField.value
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("legend", {
                                                                        className: "sr-only",
                                                                        children: "Notifications"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                        className: "relative flex items-start",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                className: "flex items-center h-5",
                                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                                    id: "send-email",
                                                                                    "aria-describedby": "comments-description",
                                                                                    name: "send-email",
                                                                                    type: "checkbox",
                                                                                    className: "focus:ring-brandBlue-500 h-4 w-4 text-brandBlue-600 border-gray-300 rounded",
                                                                                    checked: checkBoxMarked,
                                                                                    onChange: ()=>setCheckBox(!checkBoxMarked)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                className: "ml-3 text-sm",
                                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                                    htmlFor: "send-email",
                                                                                    className: "font-medium text-gray-700",
                                                                                    children: t("site:feedback.email")
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: "w-full p-6 border-2 border-gray-300 border-dashed rounded-md ",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                            className: "mb-4",
                                                                            children: (fileArray || []).length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                className: "flex gap-2",
                                                                                children: fileArray.map((file)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                        className: "flex gap-2",
                                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                                            className: "flex items-center border py-2 px-2 rounded-sm shadow-sm border-gray-300 text-sm text-gray-500",
                                                                                            children: [
                                                                                                file.name,
                                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68ecf30d598e901c$export$2e2bcd8739ae039), {
                                                                                                    className: "ml-2 w-4 h-4 text-gray-400 cursor-pointer",
                                                                                                    onClick: ()=>setFileArray(fileArray.filter((f)=>f.name !== file.name))
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }, file.name))
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                            className: "space-y-1 flex flex-col items-center",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                                                    className: "h-12 w-12 text-gray-400",
                                                                                    stroke: "currentColor",
                                                                                    fill: "none",
                                                                                    viewBox: "0 0 48 48",
                                                                                    "aria-hidden": "true",
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                                                        d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                                                                                        strokeWidth: 2,
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                    className: "flex text-sm text-gray-600",
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                                                        htmlFor: "file-upload",
                                                                                        className: "relative cursor-pointer rounded-md font-medium text-brandBlue-500 hover:text-brandBlue-400",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                                children: t("feedback.uploadAttachment")
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                                                id: "file-upload",
                                                                                                name: "file-upload",
                                                                                                type: "file",
                                                                                                accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, image/*",
                                                                                                multiple: true,
                                                                                                className: "sr-only",
                                                                                                onChange: (e)=>setFileArray(Array.from(e.target.files))
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                                    className: "text-xs text-gray-500 pb-4",
                                                                                    children: t("feedback.uploadSizeLimit")
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex-shrink-0 px-4 py-4 flex justify-end",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "button",
                                                        id: "cancel",
                                                        className: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                                        onClick: ()=>setOpen(false),
                                                        children: t("site:general.cancel")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "submit",
                                                        id: "submit",
                                                        onClick: ()=>handleSubmit(),
                                                        className: "ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                                        children: t("site:general.send")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                show: !open,
                as: (0, $7fPBF.Fragment),
                enter: "transform transition ease-in-out duration-500 sm:duration-700",
                enterFrom: "translate-x-full",
                enterTo: "translate-x-0",
                leave: "transform transition ease-in-out duration-500 sm:duration-700",
                leaveFrom: "translate-x-0",
                leaveTo: "translate-x-full",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "fixed z-[100] bottom-0 right-0 overflow-hidden",
                    "data-testid": "feedback-overlay-button",
                    children: !open ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "submit",
                        id: "feedback",
                        className: "m-4 inline-flex justify-center py-2 px-4 border border-brandBlue-500 shadow-lg text-sm font-medium rounded-md text-brandBlue-500 bg-white hover:bg-brandBlue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                        onClick: ()=>setOpen(true),
                        children: "Feedback?"
                    }) : null
                })
            }),
            closeDialog.visible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "alert-dialog",
                className: "fixed w-full z-50 overflow-hidden grid place-items-center h-screen bg-gray-400 bg-opacity-70",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a669437859fadb04$export$2e2bcd8739ae039), {
                    text: closeDialog.text,
                    title: closeDialog.title,
                    buttonText: closeDialog.buttonText,
                    dialogStateCallback: setCloseDialog
                })
            }) : null
        ]
    });
}


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable max-len */ /* This example requires Tailwind CSS v2.0+ */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $cf0ef6f622ac72ef$var$CheckIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m4.5 12.75 6 6 9-13.5"
    }));
}
const $cf0ef6f622ac72ef$var$ForwardRef = $7fPBF.forwardRef($cf0ef6f622ac72ef$var$CheckIcon);
var $cf0ef6f622ac72ef$export$2e2bcd8739ae039 = $cf0ef6f622ac72ef$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $086a7dd8f9408309$var$ExclamationCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
    }));
}
const $086a7dd8f9408309$var$ForwardRef = $7fPBF.forwardRef($086a7dd8f9408309$var$ExclamationCircleIcon);
var $086a7dd8f9408309$export$2e2bcd8739ae039 = $086a7dd8f9408309$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $344a70c9f2a7e27e$var$InformationCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    }));
}
const $344a70c9f2a7e27e$var$ForwardRef = $7fPBF.forwardRef($344a70c9f2a7e27e$var$InformationCircleIcon);
var $344a70c9f2a7e27e$export$2e2bcd8739ae039 = $344a70c9f2a7e27e$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $6513e2ba1b6537f6$var$XCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $6513e2ba1b6537f6$var$ForwardRef = $7fPBF.forwardRef($6513e2ba1b6537f6$var$XCircleIcon);
var $6513e2ba1b6537f6$export$2e2bcd8739ae039 = $6513e2ba1b6537f6$var$ForwardRef;




function $8f0e1b9f215fd49f$var$IconSuccess() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf0ef6f622ac72ef$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-green-500",
            "aria-hidden": "true"
        })
    });
}
function $8f0e1b9f215fd49f$var$IconWarning() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-50",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $086a7dd8f9408309$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-yellow-400",
            "aria-hidden": "true"
        })
    });
}
function $8f0e1b9f215fd49f$var$IconError() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-brandRed-100",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6513e2ba1b6537f6$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-brandRed-500",
            "aria-hidden": "true"
        })
    });
}
function $8f0e1b9f215fd49f$var$IconInfo() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-brandDarkBlue-100",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $344a70c9f2a7e27e$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-brandBlue-500",
            "aria-hidden": "true"
        })
    });
}
function $8f0e1b9f215fd49f$export$2e2bcd8739ae039() {
    var _buttons_, _buttons_1, _buttons_2;
    // *** THIS IS THE ONE USED BY SET_ALERT IN REDUX AND IN EVENT-BASED ***
    // AlertModalDispatch will be displayed once state.message.alert.visible is true
    // upon rendering it will read state.message.alert.id to get the alert message + button labels from i18n.app.alerts
    // onClick will set state.message.alert.visible to false and .response to the id of the button clicked
    // button: the "affirmative" button (will trigger callbackOk when pressed)
    // button2: the "negative" button (will close alert with no action when pressed)
    // if the event has a Component property, then it will be rendered instead of the body text
    // if there is no Component property, then the body text will be rendered as follows:
    // alertTexts.body can be a string or an array of strings; if the latter, then it will be split into paragraphs
    // args have named arguments which are to be used in the traslation file
    // callbackOk is the function to be called when the affirmative button is clicked
    // callbackCancel is the function to be called when the negative button is clicked
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [alert, setAlert] = (0, $7fPBF.useState)({});
    const [dispatching, setDispatching] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const selectAlert = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.alert);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("alerts");
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    // CAUTION: some components are still relying on alert status changes in state, so that has to be eliminated to move to listener-only mode
    (0, $7fPBF.useEffect)(()=>{
        function handleIncomingEvent(e) {
            console.log("handleAlertChange", e.detail);
            if (e.detail) {
                setAlert((0, $2qxEV._)((0, $9tqwB._)({}, e.detail), {
                    visible: true
                }));
                setDispatching(false); // reset state
                setOpen(true);
            } else setOpen(false);
        }
        window.addEventListener("setAlert", handleIncomingEvent);
        return ()=>window.removeEventListener("setAlert", handleIncomingEvent);
    }, []);
    const alertTexts = alert && t(alert.id, (0, $9tqwB._)({
        returnObjects: true
    }, alert.args));
    // console.log('alertTexts', alertTexts);
    // translation from selector to state, as there is not time to figure out how to make it work with headlessui
    (0, $7fPBF.useEffect)(()=>{
        if (selectAlert) {
            setAlert(selectAlert);
            setDispatching(false);
            setOpen(true);
        }
    }, [
        selectAlert
    ]);
    // if there is button2 in the i18n object, then use two buttons, otherwise just the one
    const buttons = alert && (alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.button2) ? [
        alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.button,
        alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.button2
    ] : [
        alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.button
    ];
    async function handleClick(e, mode) {
        setDispatching(true);
        try {
            // if there is a callbackOK, call it on the ok button and clear the alert
            if (alert.callbackOk && mode === "ok") {
                await alert.callbackOk();
                if (selectAlert) dispatch((0, $3b9398d0f9c152fb$export$e5a625708957e77)()); // do this only if the alert came through the selector
            } else if (alert.callbackCancel && mode === "cancel") await alert.callbackCancel();
            else if (selectAlert) // if no callback, just use the old way with publishing response in redux
            dispatch((0, $3b9398d0f9c152fb$export$b1c92b86428ccd0c)(mode === "ok" ? buttons[0].toLowerCase : buttons[1].toLowerCase)); // for backward compatibility
        } finally{
            setDispatching(false);
            setOpen(false);
            setAlert({});
        }
    }
    let Icon = $8f0e1b9f215fd49f$var$IconSuccess;
    if (alert && alertTexts.type === "error") Icon = $8f0e1b9f215fd49f$var$IconError;
    if (alert && alertTexts.type === "warning") Icon = $8f0e1b9f215fd49f$var$IconWarning;
    if (alert && alertTexts.type === "info") Icon = $8f0e1b9f215fd49f$var$IconInfo;
    return (alert === null || alert === void 0 ? void 0 : alert.visible) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $7fPBF.Fragment),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153), {
            as: "div",
            id: "alert",
            className: "fixed z-50 inset-0 overflow-y-auto",
            onClose: setOpen,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: (0, $7fPBF.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: (0, $7fPBF.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {}),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-3 text-center sm:mt-5",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Title, {
                                                    as: "h3",
                                                    className: "text-lg leading-6 font-bold text-gray-900",
                                                    children: alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.header
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-4",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "text-sm text-gray-500 leading-5",
                                                        children: [
                                                            (alert === null || alert === void 0 ? void 0 : alert.Component) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(alert.Component, (0, $9tqwB._)({}, alert === null || alert === void 0 ? void 0 : alert.componentProps)),
                                                            typeof (alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.body) === "object" && (alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.body.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                    className: "pb-2",
                                                                    children: item
                                                                }, item))),
                                                            !(alert === null || alert === void 0 ? void 0 : alert.component) && !(typeof (alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.body) === "object") && (alertTexts === null || alertTexts === void 0 ? void 0 : alertTexts.body)
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                buttons.length === 2 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-5 sm:mt-6 grid grid-cols-2 gap-3 grid-flow-row-dense",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            id: (_buttons_ = buttons[1]) === null || _buttons_ === void 0 ? void 0 : _buttons_.toLowerCase(),
                                            name: "cancelButton",
                                            text: buttons[1],
                                            onClick: (e)=>handleClick(e, "cancel"),
                                            size: "xl"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            id: (_buttons_1 = buttons[0]) === null || _buttons_1 === void 0 ? void 0 : _buttons_1.toLowerCase(),
                                            name: "affirmativeButton",
                                            text: buttons[0],
                                            onClick: (e)=>handleClick(e, "ok"),
                                            withAccent: true,
                                            spinnerOn: dispatching,
                                            size: "xl"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-5 sm:mt-6 sm:grid",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        id: (_buttons_2 = buttons[0]) === null || _buttons_2 === void 0 ? void 0 : _buttons_2.toLowerCase(),
                                        name: "affirmativeButton",
                                        text: buttons[0],
                                        onClick: (e)=>handleClick(e, "ok"),
                                        withAccent: true,
                                        spinnerOn: dispatching,
                                        size: "xl"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }) : null;
}




var $7fPBF = parcelRequire("7fPBF");
function $e20848388684b841$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $e20848388684b841$export$2e2bcd8739ae039() {
    const [tooltip, setTooltip] = (0, $7fPBF.useState)(null);
    // you can add classNames as string if necessary
    const tipRef = (0, $7fPBF.useRef)(null);
    const timeoutRef = (0, $7fPBF.useRef)(null); // to store the timeout reference
    (0, $7fPBF.useEffect)(()=>{
        const handleShowTooltip = (event)=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current); // clear any existing timeout
            // all custom parameters come in event.detail
            if (tipRef.current) {
                if (event.detail === null) {
                    tipRef.current.style.opacity = 0;
                    tipRef.current.style.transform = "translateX(6px)";
                } else {
                    setTooltip(event.detail);
                    tipRef.current.style.opacity = 1;
                    tipRef.current.style.transform = "translateX(0)";
                    // Set the timeout to reset the styles after 10 seconds
                    timeoutRef.current = setTimeout(()=>{
                        tipRef.current.style.opacity = 0;
                        tipRef.current.style.transform = "translateX(6px)";
                    }, 10000);
                }
            }
        };
        window.addEventListener("showTooltip", handleShowTooltip);
        return ()=>{
            window.removeEventListener("showTooltip", handleShowTooltip);
            if (timeoutRef.current) clearTimeout(timeoutRef.current); // clear the timeout when the component is unmounted
        };
    }, []);
    var _tooltip_y, _tooltip_x;
    // so why is this here?
    // position: absolute does not work, because parts of the tooltip are outside of the parent element and are not visible (obstructed by other elements)
    // position: fixed does not work, because one of the parent element within the table header has a filter css property and that means this is the containing element
    // and not the viewport
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        "aria-live": "assertive",
        className: "fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-[9999]",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: $e20848388684b841$var$classNames(tooltip === null || tooltip === void 0 ? void 0 : tooltip.className, tooltip === null ? "hidden" : "", "fixed prose leading-5 bg-white border border-gray-100 text-gray-900 text-xs tracking-wider rounded-sm font-light m-2 px-3 py-2 flex items-center group-hover:delay-500 z-[999]"),
            style: {
                top: ((_tooltip_y = tooltip === null || tooltip === void 0 ? void 0 : tooltip.y) !== null && _tooltip_y !== void 0 ? _tooltip_y : 0) + 5,
                left: ((_tooltip_x = tooltip === null || tooltip === void 0 ? void 0 : tooltip.x) !== null && _tooltip_x !== void 0 ? _tooltip_x : 0) + 10,
                opacity: 0,
                transform: "translateX(6px)",
                transition: "opacity 120ms ease, transform 120ms ease",
                willChange: "opacity, transform"
            },
            ref: tipRef,
            children: tooltip === null || tooltip === void 0 ? void 0 : tooltip.message
        })
    });
}


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/button-has-type */ /* eslint-disable react/jsx-no-useless-fragment */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $60f58cdd0c2aa415$var$ArrowTopRightOnSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    }));
}
const $60f58cdd0c2aa415$var$ForwardRef = $7fPBF.forwardRef($60f58cdd0c2aa415$var$ArrowTopRightOnSquareIcon);
var $60f58cdd0c2aa415$export$2e2bcd8739ae039 = $60f58cdd0c2aa415$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $952c75f5775452d5$var$BookmarkIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
    }));
}
const $952c75f5775452d5$var$ForwardRef = $7fPBF.forwardRef($952c75f5775452d5$var$BookmarkIcon);
var $952c75f5775452d5$export$2e2bcd8739ae039 = $952c75f5775452d5$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ba764ef5f1eed305$var$CheckCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $ba764ef5f1eed305$var$ForwardRef = $7fPBF.forwardRef($ba764ef5f1eed305$var$CheckCircleIcon);
var $ba764ef5f1eed305$export$2e2bcd8739ae039 = $ba764ef5f1eed305$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $f1cff91089fff251$var$ChevronDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    }));
}
const $f1cff91089fff251$var$ForwardRef = $7fPBF.forwardRef($f1cff91089fff251$var$ChevronDownIcon);
var $f1cff91089fff251$export$2e2bcd8739ae039 = $f1cff91089fff251$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $4014d622dd8a5782$var$ChevronUpIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m4.5 15.75 7.5-7.5 7.5 7.5"
    }));
}
const $4014d622dd8a5782$var$ForwardRef = $7fPBF.forwardRef($4014d622dd8a5782$var$ChevronUpIcon);
var $4014d622dd8a5782$export$2e2bcd8739ae039 = $4014d622dd8a5782$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $5171585835791f87$var$EyeSlashIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    }));
}
const $5171585835791f87$var$ForwardRef = $7fPBF.forwardRef($5171585835791f87$var$EyeSlashIcon);
var $5171585835791f87$export$2e2bcd8739ae039 = $5171585835791f87$var$ForwardRef;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");

function $67467b80232bd14a$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $67467b80232bd14a$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $7fPBF.useState)(()=>$67467b80232bd14a$var$i(t));
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        u($67467b80232bd14a$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        n || !e.current || e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}





var $7fPBF = parcelRequire("7fPBF");
var $61195c7fd2d9171b$var$t;
let $61195c7fd2d9171b$export$7568632d0d33d16d = ($61195c7fd2d9171b$var$t = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).startTransition) != null ? $61195c7fd2d9171b$var$t : function(i) {
    i();
};


var $8d33aee4c6c0ce1f$var$Q = ((l)=>(l[l.Open = 0] = "Open", l[l.Closed = 1] = "Closed", l))($8d33aee4c6c0ce1f$var$Q || {}), $8d33aee4c6c0ce1f$var$V = ((t)=>(t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))($8d33aee4c6c0ce1f$var$V || {});
let $8d33aee4c6c0ce1f$var$X = {
    [0]: (e)=>(0, $2qxEV._)((0, $9tqwB._)({}, e), {
            disclosureState: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1]: (e)=>e.disclosureState === 1 ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            disclosureState: 1
        }),
    [4] (e) {
        return e.linkedPanel === !0 ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            linkedPanel: !0
        });
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            linkedPanel: !1
        });
    },
    [2] (e, n) {
        return e.buttonId === n.buttonId ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            buttonId: n.buttonId
        });
    },
    [3] (e, n) {
        return e.panelId === n.panelId ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            panelId: n.panelId
        });
    }
}, $8d33aee4c6c0ce1f$var$B = (0, $7fPBF.createContext)(null);
$8d33aee4c6c0ce1f$var$B.displayName = "DisclosureContext";
function $8d33aee4c6c0ce1f$var$v(e) {
    let n = (0, $7fPBF.useContext)($8d33aee4c6c0ce1f$var$B);
    if (n === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $8d33aee4c6c0ce1f$var$v), l;
    }
    return n;
}
let $8d33aee4c6c0ce1f$var$h = (0, $7fPBF.createContext)(null);
$8d33aee4c6c0ce1f$var$h.displayName = "DisclosureAPIContext";
function $8d33aee4c6c0ce1f$var$K(e) {
    let n = (0, $7fPBF.useContext)($8d33aee4c6c0ce1f$var$h);
    if (n === null) {
        let l = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(l, $8d33aee4c6c0ce1f$var$K), l;
    }
    return n;
}
let $8d33aee4c6c0ce1f$var$H = (0, $7fPBF.createContext)(null);
$8d33aee4c6c0ce1f$var$H.displayName = "DisclosurePanelContext";
function $8d33aee4c6c0ce1f$var$Y() {
    return (0, $7fPBF.useContext)($8d33aee4c6c0ce1f$var$H);
}
function $8d33aee4c6c0ce1f$var$Z(e, n) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(n.type, $8d33aee4c6c0ce1f$var$X, e, n);
}
let $8d33aee4c6c0ce1f$var$ee = (0, $7fPBF.Fragment), $8d33aee4c6c0ce1f$var$te = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(n, l) {
    let { defaultOpen: y = !1 } = n, u = (0, $bLhVg._)(n, [
        "defaultOpen"
    ]), T = (0, $7fPBF.useRef)(null), t = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(l, (0, $c1aa65a6b3c277bc$export$7029785b750eb74)((a)=>{
        T.current = a;
    }, n.as === void 0 || n.as === (0, $7fPBF.Fragment))), o = (0, $7fPBF.useRef)(null), f = (0, $7fPBF.useRef)(null), s = (0, $7fPBF.useReducer)($8d33aee4c6c0ce1f$var$Z, {
        disclosureState: y ? 0 : 1,
        linkedPanel: !1,
        buttonRef: f,
        panelRef: o,
        buttonId: null,
        panelId: null
    }), [{ disclosureState: i, buttonId: p }, D] = s, d = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((a)=>{
        D({
            type: 1
        });
        let r = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(T);
        if (!r || !p) return;
        let c = (()=>a ? a instanceof HTMLElement ? a : a.current instanceof HTMLElement ? a.current : r.getElementById(p) : r.getElementById(p))();
        c == null || c.focus();
    }), P = (0, $7fPBF.useMemo)(()=>({
            close: d
        }), [
        d
    ]), A = (0, $7fPBF.useMemo)(()=>({
            open: i === 0,
            close: d
        }), [
        i,
        d
    ]), S = {
        ref: t
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($8d33aee4c6c0ce1f$var$B.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($8d33aee4c6c0ce1f$var$h.Provider, {
        value: P
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $42e7df3a446fef87$export$2a0ed818b175f558), {
        value: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i, {
            [0]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open,
            [1]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed
        })
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: S,
        theirProps: u,
        slot: A,
        defaultTag: $8d33aee4c6c0ce1f$var$ee,
        name: "Disclosure"
    }))));
}), $8d33aee4c6c0ce1f$var$ne = "button", $8d33aee4c6c0ce1f$var$le = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(n, l) {
    let y = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: u = `headlessui-disclosure-button-${y}` } = n, T = (0, $bLhVg._)(n, [
        "id"
    ]), [t, o] = $8d33aee4c6c0ce1f$var$v("Disclosure.Button"), f = $8d33aee4c6c0ce1f$var$Y(), s = f === null ? !1 : f === t.panelId, i = (0, $7fPBF.useRef)(null), p = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(i, l, s ? null : t.buttonRef);
    (0, $7fPBF.useEffect)(()=>{
        if (!s) return o({
            type: 2,
            buttonId: u
        }), ()=>{
            o({
                type: 2,
                buttonId: null
            });
        };
    }, [
        u,
        o,
        s
    ]);
    let D = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((r)=>{
        var c;
        if (s) {
            if (t.disclosureState === 1) return;
            switch(r.key){
                case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                    r.preventDefault(), r.stopPropagation(), o({
                        type: 0
                    }), (c = t.buttonRef.current) == null || c.focus();
                    break;
            }
        } else switch(r.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                r.preventDefault(), r.stopPropagation(), o({
                    type: 0
                });
                break;
        }
    }), d = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((r)=>{
        switch(r.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                r.preventDefault();
                break;
        }
    }), P = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((r)=>{
        var c;
        (0, $9551cf0370e09058$export$db61f031a278447c)(r.currentTarget) || n.disabled || (s ? (o({
            type: 0
        }), (c = t.buttonRef.current) == null || c.focus()) : o({
            type: 0
        }));
    }), A = (0, $7fPBF.useMemo)(()=>({
            open: t.disclosureState === 0
        }), [
        t
    ]), S = (0, $67467b80232bd14a$export$53652b2b272efe9c)(n, i), a = s ? {
        ref: p,
        type: S,
        onKeyDown: D,
        onClick: P
    } : {
        ref: p,
        id: u,
        type: S,
        "aria-expanded": n.disabled ? void 0 : t.disclosureState === 0,
        "aria-controls": t.linkedPanel ? t.panelId : void 0,
        onKeyDown: D,
        onKeyUp: d,
        onClick: P
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: a,
        theirProps: T,
        slot: A,
        defaultTag: $8d33aee4c6c0ce1f$var$ne,
        name: "Disclosure.Button"
    });
}), $8d33aee4c6c0ce1f$var$re = "div", $8d33aee4c6c0ce1f$var$oe = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $8d33aee4c6c0ce1f$var$se = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(n, l) {
    let y = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: u = `headlessui-disclosure-panel-${y}` } = n, T = (0, $bLhVg._)(n, [
        "id"
    ]), [t, o] = $8d33aee4c6c0ce1f$var$v("Disclosure.Panel"), { close: f } = $8d33aee4c6c0ce1f$var$K("Disclosure.Panel"), s = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(l, t.panelRef, (P)=>{
        (0, $61195c7fd2d9171b$export$7568632d0d33d16d)(()=>o({
                type: P ? 4 : 5
            }));
    });
    (0, $7fPBF.useEffect)(()=>(o({
            type: 3,
            panelId: u
        }), ()=>{
            o({
                type: 3,
                panelId: null
            });
        }), [
        u,
        o
    ]);
    let i = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)(), p = (()=>i !== null ? i === (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open : t.disclosureState === 0)(), D = (0, $7fPBF.useMemo)(()=>({
            open: t.disclosureState === 0,
            close: f
        }), [
        t,
        f
    ]), d = {
        ref: s,
        id: u
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($8d33aee4c6c0ce1f$var$H.Provider, {
        value: t.panelId
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: T,
        slot: D,
        defaultTag: $8d33aee4c6c0ce1f$var$re,
        features: $8d33aee4c6c0ce1f$var$oe,
        visible: p,
        name: "Disclosure.Panel"
    }));
}), $8d33aee4c6c0ce1f$export$74a362b31437ec83 = Object.assign($8d33aee4c6c0ce1f$var$te, {
    Button: $8d33aee4c6c0ce1f$var$le,
    Panel: $8d33aee4c6c0ce1f$var$se
});





var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $341a41b70f0b63cc$var$XMarkIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $341a41b70f0b63cc$var$ForwardRef = $7fPBF.forwardRef($341a41b70f0b63cc$var$XMarkIcon);
var $341a41b70f0b63cc$export$2e2bcd8739ae039 = $341a41b70f0b63cc$var$ForwardRef;


function $25250cd4374f51ac$export$2e2bcd8739ae039({ children: children, open: open, closeCallback: closeCallback, fixedHeight: fixedHeight, noPadding: noPadding, verticalCenter: verticalCenter, variableWidth: variableWidth, helpCallback: helpCallback }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $7fPBF.Fragment),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            id: "fullPageOverlayContainerParent",
            className: `absolute w-full z-50 top-0 left-0 md:p-8 bg-gray-300 bg-opacity-90 space-y-6
        ${verticalCenter ? "flex items-center justify-center" : ""}
        ${fixedHeight ? "h-auto min-h-full" : "h-screen overflow-y-scroll"}`,
            role: "dialog",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                as: (0, $7fPBF.Fragment),
                enter: "ease-out duration-300",
                enterFrom: "opacity-0 translate-y-4 md:translate-y-0 md:scale-95",
                enterTo: "opacity-100 translate-y-0 md:scale-100",
                leave: "ease-in duration-200",
                leaveFrom: "opacity-100 translate-y-0 md:scale-100",
                leaveTo: "opacity-0 translate-y-4 md:translate-y-0 md:scale-95",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: `relative bg-gray-50 shadow container rounded-sm mx-auto ${noPadding ? "" : "sm:px-6 lg:px-8"}
            ${fixedHeight ? "h-screen md:h-[93vh] overflow-y-auto" : ""}
            ${variableWidth ? "max-w-3xl" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "hidden sm:inline absolute top-0 right-0 m-4 cursor-pointer",
                            onClick: closeCallback,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-gray-400 hover:text-gray-500"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "sm:hidden absolute top-0 right-0 m-4 px-3 py-2 cursor-pointer text-gray-700 text-sm font-semibold rounded-md border border-gray-300",
                            onClick: closeCallback,
                            children: "Close"
                        }),
                        children
                    ]
                })
            })
        })
    });
}
$25250cd4374f51ac$export$2e2bcd8739ae039.propTypes = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    closeCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    fixedHeight: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    noPadding: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    verticalCenter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    variableWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    helpCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$25250cd4374f51ac$export$2e2bcd8739ae039.defaultProps = {
    open: true,
    closeCallback: ()=>{},
    fixedHeight: false,
    noPadding: false,
    verticalCenter: false,
    variableWidth: false,
    helpCallback: ()=>{}
};



const $8f5c04dc219edbf5$var$cookieList = [
    {
        name: "__stripe_sid",
        group: "essential",
        providerName: "Stripe",
        providerLink: "https://stripe.com",
        expiry: "Session",
        type: "Functional"
    },
    {
        name: "__stripe_mid",
        group: "essential",
        providerName: "Stripe",
        providerLink: "https://stripe.com",
        expiry: "1 year",
        type: "Functional"
    },
    {
        name: "AppleAuth",
        group: "essential",
        providerName: "Apple",
        providerLink: "https://apple.com",
        expiry: "Varies",
        type: "Authentication"
    },
    {
        name: "FacebookAuth",
        group: "essential",
        providerName: "Facebook",
        providerLink: "https://facebook.com",
        expiry: "Varies",
        type: "Authentication"
    },
    {
        name: "GoogleAuth",
        group: "essential",
        providerName: "Google",
        providerLink: "https://google.com",
        expiry: "Varies",
        type: "Authentication"
    },
    {
        name: "LinkedInAuth",
        group: "essential",
        providerName: "LinkedIn",
        providerLink: "https://linkedin.com",
        expiry: "Varies",
        type: "Authentication"
    },
    {
        name: "cws_s",
        group: "essential",
        providerName: "AWS RUM",
        providerLink: "https://aws.amazon.com",
        expiry: "Session",
        type: "Performance"
    },
    {
        name: "cws_u",
        group: "essential",
        providerName: "AWS RUM",
        providerLink: "https://aws.amazon.com",
        expiry: "1 year",
        type: "Performance"
    },
    {
        name: "CognitoAuth",
        group: "essential",
        providerName: "AWS Cognito",
        providerLink: "https://aws.amazon.com/cognito/",
        expiry: "Varies",
        type: "Authentication"
    },
    {
        name: "i18nextLng",
        group: "essential",
        providerName: "Local",
        providerLink: "",
        expiry: "1 year",
        type: "Functional"
    },
    {
        name: "YouTube",
        group: "externalMedia",
        providerName: "YouTube",
        providerLink: "https://youtube.com",
        expiry: "Varies",
        type: "Functional"
    },
    {
        name: "Consent",
        group: "essential",
        providerName: "Local",
        providerLink: "",
        expiry: "1 year",
        type: "Necessary"
    },
    {
        name: "TailwindUI",
        group: "essential",
        providerName: "TailwindUI",
        providerLink: "https://tailwindui.com",
        expiry: "Varies",
        type: "Unknown"
    },
    {
        name: "Unsplash",
        group: "essential",
        providerName: "Unsplash",
        providerLink: "https://unsplash.com",
        expiry: "Varies",
        type: "Functional"
    }
];
var $8f5c04dc219edbf5$export$2e2bcd8739ae039 = $8f5c04dc219edbf5$var$cookieList;


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
const $cd4eb6c046d46984$var$cookieGroups = [
    "essential",
    "analytics",
    "externalMedia"
];
function $cd4eb6c046d46984$var$MainPane({ handleAcceptAll: handleAcceptAll, consentState: consentState, setShowCustomisePane: setShowCustomisePane }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function handleOnlyEssential() {
        const payload = (0, $2qxEV._)((0, $9tqwB._)({}, consentState), {
            essential: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()
        });
        dispatch((0, $8bd3fc2d0bca0786$export$3ab4aed8562cb58d)(payload));
        handleAcceptAll();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "px-6 sm:px-0 py-6 sm:py-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-lg sm:text-xl font-semibold leading-6 text-gray-900",
                children: t("cookies.title")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-8 max-w-2xl text-xs sm:text-sm font-normal text-gray-500 grid grid-cols-12 gap-4 sm:gap-8 items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $952c75f5775452d5$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-brandBlue-500  justify-self-center"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-11",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: t("cookies.description")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "w-5 h-5 text-brandBlue-500 text-lg justify-self-center -mt-1 pl-1",
                        children: "\xa7"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-11",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: t("cookies.legalBasis")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba764ef5f1eed305$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-brandBlue-500 justify-self-center "
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-11",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: t("cookies.settingsInfo")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5171585835791f87$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-brandBlue-500  justify-self-center"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-11",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: t("cookies.noTracking")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60f58cdd0c2aa415$export$2e2bcd8739ae039), {
                        className: "w-5 h-5 text-brandBlue-500  justify-self-center"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "col-span-11 flex",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("cookies.privacyPolicy")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60f58cdd0c2aa415$export$2e2bcd8739ae039), {
                                className: "ml-1 w-5 h-5 text-gray-400  justify-self-center"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-8 flex justify-between space-x-2 sm:space-x-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex space-x-2 sm:space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: t("cookies.onlyEssential"),
                                onClick: handleOnlyEssential,
                                withAccent: false,
                                size: "md"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: t("cookies.customise"),
                                onClick: ()=>setShowCustomisePane(true),
                                withAccent: false,
                                size: "md"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("cookies.acceptAll"),
                        onClick: handleAcceptAll,
                        withAccent: false,
                        size: "md"
                    })
                ]
            })
        ]
    });
}
$cd4eb6c046d46984$var$MainPane.propTypes = {
    handleAcceptAll: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    consentState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        essential: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]),
        marketing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]),
        analytics: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]),
        externalMedia: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ])
    }).isRequired,
    setShowCustomisePane: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
// local form state is used to prevent the form from closing as soon as one checkbox is ticked
function $cd4eb6c046d46984$var$CustomisePane({ handleAcceptAll: handleAcceptAll, consentState: consentState, setShowCustomisePane: setShowCustomisePane }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [formState, setFormState] = (0, $7fPBF.useState)({
        essential: null,
        marketing: null,
        analytics: null,
        externalMedia: null
    });
    // synchronises redux to local form state
    (0, $7fPBF.useEffect)(()=>{
        setFormState(consentState);
    }, [
        consentState
    ]);
    // puts a mandatory true for essentials
    function getTickboxValue(group) {
        if (group === "essential") return true;
        return formState[group] !== null;
    }
    // handles save button; this is where essential gets set to true in redux / localStorage
    function handleSave(group, value) {
        const payload = (0, $2qxEV._)((0, $9tqwB._)({}, consentState), {
            [group]: value === true ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf() : null,
            essential: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()
        });
        dispatch((0, $8bd3fc2d0bca0786$export$3ab4aed8562cb58d)(payload));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "px-6 sm:px-0 py-6 sm:py-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-xl font-semibold leading-6 text-gray-900",
                children: t("cookies.customiseTitle")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-4 max-w-2xl text-xs sm:text-sm font-normal text-gray-500 grid grid-cols-12 gap-4 items-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "col-span-12",
                    children: t("cookies.customiseSubtitle")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mx-auto max-w-4xl divide-y divide-gray-900/10",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                    className: "mt-3 space-y-4 sm:space-y-6 divide-y divide-gray-900/10",
                    children: $cd4eb6c046d46984$var$cookieGroups.map((group)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83), {
                            as: "div",
                            className: "pt-6",
                            children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83).Button, {
                                                className: "w-full text-left text-xs sm:text-sm",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "mt-2 flex items-start justify-between text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "flex space-x-4 items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    checked: getTickboxValue(group),
                                                                    onChange: (e)=>setFormState((0, $2qxEV._)((0, $9tqwB._)({}, formState), {
                                                                            [group]: e.target.checked
                                                                        })),
                                                                    className: "h-4 w-4 text-brandBlue-500 focus:ring-brandBlue-400 border-gray-300 rounded"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                            className: "font-semibold text-gray-900",
                                                                            children: t(`cookies.${group}.label`)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                            className: "text-gray-500",
                                                                            children: t(`cookies.${group}.description`)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "ml-6 flex h-7 items-center",
                                                            children: open ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4014d622dd8a5782$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 sm:h-6 sm:w-6",
                                                                "aria-hidden": "true"
                                                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f1cff91089fff251$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 sm:h-6 sm:w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83).Panel, {
                                            as: "dd",
                                            className: "mt-2 px-2 sm:px-6 text-gray-500 text-sm divide-y divide-gray-900/10",
                                            children: (0, $8f5c04dc219edbf5$export$2e2bcd8739ae039).filter((cookie)=>cookie.group === group).map((cookie)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "grid grid-cols-2 sm:grid-cols-4 py-1 text-xs sm:text-sm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "text-gray-700",
                                                            children: cookie.name
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                            className: "",
                                                            href: cookie.providerLink,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: cookie.providerName
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "",
                                                            children: cookie.expiry
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "",
                                                            children: cookie.type
                                                        })
                                                    ]
                                                }, cookie.name))
                                        })
                                    ]
                                })
                        }, group))
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-12 flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: t("cookies.goBack"),
                                onClick: ()=>setShowCustomisePane(false),
                                withAccent: false,
                                size: "md"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: t("cookies.acceptAll"),
                                onClick: handleAcceptAll,
                                withAccent: false,
                                size: "md"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("cookies.save"),
                        onClick: handleSave,
                        withAccent: false,
                        size: "md"
                    })
                ]
            })
        ]
    });
}
$cd4eb6c046d46984$var$CustomisePane.propTypes = {
    handleAcceptAll: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    consentState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        essential: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]),
        marketing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]),
        analytics: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]),
        externalMedia: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ])
    }).isRequired,
    setShowCustomisePane: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $cd4eb6c046d46984$export$2e2bcd8739ae039({ children: children }) {
    // this ↓↓ just tells us if there is consent or not, the actual consent object { essential, marketing etc. }
    // is stored in redux - update it there (initialise to true to prevent flash of consent banner)
    const [consent, setConsent] = (0, $7fPBF.useState)(true);
    const [editMode, setEditMode] = (0, $7fPBF.useState)(false); // user can go back to editing their consent
    const [showCustomisePane, setShowCustomisePane] = (0, $7fPBF.useState)(false); // user can customise their consent
    const consentState = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.consent);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // consent is an object with cookie classes and nulls / dates as value
    // if there is at least one date, it means the user has seen the consent banner already
    const userHasGivenConsent = Object.values(consentState).some((value)=>value !== null);
    (0, $7fPBF.useEffect)(()=>{
        if (userHasGivenConsent) setConsent(true);
        else setConsent(false);
    }, [
        consentState
    ]);
    // handle "editConsent" document custom event - when it fires, the user wants to edit their consent, so set editMode to true
    (0, $7fPBF.useEffect)(()=>{
        const handleEditConsent = ()=>{
            setEditMode(true);
        };
        document.addEventListener("editConsent", handleEditConsent);
        return ()=>{
            document.removeEventListener("editConsent", handleEditConsent);
        };
    }, []);
    // TODO this should not show up in mobile app mode
    function handleAcceptAll() {
        const payload = Object.entries(consentState).reduce((acc, [key])=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                [key]: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()
            }), {}); // set all groups to current date
        dispatch((0, $8bd3fc2d0bca0786$export$3ab4aed8562cb58d)(payload)); // async, but no need to wait for it
        setConsent(true);
        if (editMode) setEditMode(false);
    }
    if (consent && !editMode) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            children,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25250cd4374f51ac$export$2e2bcd8739ae039), {
                open: !consent || editMode,
                verticalCenter: true,
                variableWidth: true,
                fixedHeight: showCustomisePane,
                children: showCustomisePane ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cd4eb6c046d46984$var$CustomisePane, {
                    handleAcceptAll: handleAcceptAll,
                    consentState: consentState,
                    setShowCustomisePane: setShowCustomisePane
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cd4eb6c046d46984$var$MainPane, {
                    handleAcceptAll: handleAcceptAll,
                    setShowCustomisePane: setShowCustomisePane,
                    consentState: consentState
                })
            })
        ]
    });
}
$cd4eb6c046d46984$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired
};




var $7fPBF = parcelRequire("7fPBF");




// callbacks from oauth2 and stripe are intercepted by Amplify even before this page is rendered
const $bd414f4dcab720d8$var$debugLevel = 3;
function $bd414f4dcab720d8$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register"
    });
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const registration = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.registration);
    const isLoggedIn = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.isLoggedIn);
    const selectToursSeen = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_user_profile_attributes;
        return (_state_user_profile_attributes = state.user.profile.attributes) === null || _state_user_profile_attributes === void 0 ? void 0 : _state_user_profile_attributes.toursSeen;
    });
    const status = registration === null || registration === void 0 ? void 0 : registration.status;
    const username = registration === null || registration === void 0 ? void 0 : registration.username;
    const queryParams = new URLSearchParams(location.search);
    const queryParamCode = queryParams.get("code");
    const queryParamState = queryParams.get("state");
    const queryParamSource = queryParams.get("source");
    const queryParamErrorDescription = queryParams.get("error_description");
    // to not display "we are setting up" during the oauth callback from Cognito, we are going to just render a div if both query params above are there
    const noInterstitial = queryParamCode && queryParamState;
    console.info("DEBUG", "CallbackHandler: ", registration, "query params:", Object.fromEntries(queryParams.entries()));
    (0, $7fPBF.useEffect)(()=>{
        if (status === "awaitingEmailConfirmation") {
            if ($bd414f4dcab720d8$var$debugLevel > 0) console.log(`CallbackHandler: handle redirect to '/confirm/${username}' -- confirm email after internal user creation`);
            (0, $55100129ab36ed65$export$89e12c5b50f7529d)(`/${i18n.language}/confirm/${username}`);
            if ($bd414f4dcab720d8$var$debugLevel > 2) console.log("CallbackHandler: Gonna try navigate now");
            navigate(`/${i18n.language}/confirm/${username}`);
        }
    }, [
        status
    ]);
    // ---------------------------
    // HANDLE STRIPE REDIRECT
    // ---------------------------
    // condition: the callback URL has 'source=stripe' parameter
    const didIAlreadyRun = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (didIAlreadyRun.current) return;
        if (queryParamSource !== "stripe") return;
        if ($bd414f4dcab720d8$var$debugLevel > 2) console.info("CallbackHandler: detected Stripe callback with query params", Object.fromEntries(queryParams.entries()));
        didIAlreadyRun.current = true; // ensure this effect runs only once
        const setupIntentId = queryParams.get("setup_intent");
        const setupIntentClientSecret = queryParams.get("setup_intent_client_secret");
        const payLater = queryParams.get("pay_later");
        if (!payLater) {
            sessionStorage.setItem("setupIntent", JSON.stringify({
                setupIntentId: setupIntentId,
                setupIntentClientSecret: setupIntentClientSecret
            }));
            if ($bd414f4dcab720d8$var$debugLevel > 2) console.info("CallbackHandler: the user is paying now; setupIntent stored in session storage", {
                setupIntentId: setupIntentId
            });
        } else {
            if ($bd414f4dcab720d8$var$debugLevel > 2) console.info("CallbackHandler: pay_later mode detected; payLater: true is stored in session storage");
            sessionStorage.setItem("payLater", JSON.stringify("true"));
        }
        // kick off the Cognito registration flow
        console.info("CallbackHandler: initiating Cognito registration flow after Stripe callback");
        const user = JSON.parse(localStorage.getItem("signUpObject"));
        if (!user) {
            console.error("CallbackHandler: expected signUpObject.user in localStorage NOT FOUND");
            window.location.replace("/fallback?fallbackMessage=missingSignUpObject");
            return;
        }
        try {
            // stripe setup is completed, now create the Cognito user
            dispatch((0, $8bd3fc2d0bca0786$export$6503ec6e8aabbaf)(user));
        } catch (err) {
            console.info("CallbackHandler: detected error while running register");
            window.location.replace(`/fallback?fallbackMessage=${err}`);
        }
    }, [
        dispatch,
        queryParamSource,
        location.search
    ]);
    // ---------------------------------------------
    // HANDLE COGNITO REDIRECT (signInWithRedirect)
    // ---------------------------------------------
    // condition: error_description query param exists and contains a predefined string
    (0, $7fPBF.useEffect)(()=>{
        if (!queryParamErrorDescription) return;
        if (didIAlreadyRun.current) return;
        didIAlreadyRun.current = true; // ensure this effect runs only once
        // Stage I: the only way to get federated email is to cause and handle an error
        // get email from error message and dispatch it to redux store
        const expectedErrorString = "PreSignUp failed with error Error while getting Cognito users: EMAIL:";
        if (queryParamErrorDescription && queryParamErrorDescription.includes(expectedErrorString)) {
            if ($bd414f4dcab720d8$var$debugLevel > 2) console.info("CallbackHandler: signInWithRedirect_failure handler started for string:", queryParamErrorDescription);
            const email = queryParamErrorDescription.split(expectedErrorString)[1].slice(0, -2);
            if ($bd414f4dcab720d8$var$debugLevel > 2) console.info("CallbackHandler: extracted federated email from error message", email);
            // handles the case when user has a native Cognito account, but tries to use a federated identity with a different account
            // federatedSignIn will fail, but we also need to discontinue the choreographed process triggered here
            // if there is no signUpObject, it means we are not in the registration process and the error is relevant
            const formObject = JSON.parse(localStorage.getItem("signUpObject"));
            if (!formObject) {
                if ($bd414f4dcab720d8$var$debugLevel > 2) console.error("CallbackHandler: cognitoHostedUI_failure handler: no signUpObject, redirecting back to Login");
                window.location.replace("/login?unknownUser=true");
            } else // registerFederated returns a promise
            dispatch((0, $8bd3fc2d0bca0786$export$39e8c219c47713c5)(email)).then((x)=>{
                console.log("CallbackHandler: registerFederated executed successfully, result:", x);
            }, (err)=>{
                console.warn("CallbackHandler: caught error while running registerFederated", err);
                // redirect to fallback handler
                window.location.replace(`/fallback?fallbackMessage=${queryParamErrorDescription}`);
            });
        }
    }, [
        dispatch,
        queryParamErrorDescription
    ]);
    // 240920 DEPRECATED - no longer needed for the flow - user should just proceed to login
    // Stage II: external account has been merged into the new internal account, redirect to PaymentSuccessful
    // const expectedErrorStringMerge = 'PreSignUp+failed+with+error+Error+while+linking+external+user+to+Cognito+user%3A+USERMERGED%3A';
    // ---------------------------
    // REDIRECT AFTER LOGIN
    // ---------------------------
    // TODO 251107 is this still in use?
    // wait for hubListener to report that Amplify is done signing user up and update isLoggedIn in state
    (0, $7fPBF.useEffect)(()=>{
        if (isLoggedIn) {
            if ($bd414f4dcab720d8$var$debugLevel > 0) console.log("CallbackHandler: isLoggedIn is now true -- user is logged in, redirect to '/app'");
            // if there are any toursSeen, go directly to Dashboard
            if (selectToursSeen && selectToursSeen.length > 0) navigate(`/${i18n.language}/app/dashboard`);
            else navigate(`/${i18n.language}/app/getready`);
        }
    }, [
        isLoggedIn
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "h-screen bg-white flex items-center justify-center",
        children: noInterstitial ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "text-2xl font-bold text-gray-500 animate-pulse",
            children: t("pleaseWaitWhileWeAreSettingThingsUp")
        })
    });
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
var $18522b4fc47f45cb$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $18522b4fc47f45cb$var$isDateObject = (value1)=>value1 instanceof Date;
var $18522b4fc47f45cb$var$isNullOrUndefined = (value1)=>value1 == null;
const $18522b4fc47f45cb$var$isObjectType = (value1)=>typeof value1 === "object";
var $18522b4fc47f45cb$var$isObject = (value1)=>!$18522b4fc47f45cb$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $18522b4fc47f45cb$var$isObjectType(value1) && !$18522b4fc47f45cb$var$isDateObject(value1);
var $18522b4fc47f45cb$var$getEventValue = (event)=>$18522b4fc47f45cb$var$isObject(event) && event.target ? $18522b4fc47f45cb$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $18522b4fc47f45cb$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $18522b4fc47f45cb$var$isNameInFieldArray = (names, name)=>names.has($18522b4fc47f45cb$var$getNodeParentName(name));
var $18522b4fc47f45cb$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $18522b4fc47f45cb$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $18522b4fc47f45cb$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $18522b4fc47f45cb$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== "undefined" ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($18522b4fc47f45cb$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $18522b4fc47f45cb$var$isObject(data))) {
        copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
        if (!isArray && !$18522b4fc47f45cb$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $18522b4fc47f45cb$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $18522b4fc47f45cb$var$isKey = (value1)=>/^\w*$/.test(value1);
var $18522b4fc47f45cb$var$isUndefined = (val)=>val === undefined;
var $18522b4fc47f45cb$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $18522b4fc47f45cb$var$stringToPath = (input)=>$18522b4fc47f45cb$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $18522b4fc47f45cb$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$18522b4fc47f45cb$var$isObject(object)) return defaultValue;
    const result = ($18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path)).reduce((result, key)=>$18522b4fc47f45cb$var$isNullOrUndefined(result) ? result : result[key], object);
    return $18522b4fc47f45cb$var$isUndefined(result) || result === object ? $18522b4fc47f45cb$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $18522b4fc47f45cb$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $18522b4fc47f45cb$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $18522b4fc47f45cb$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        object[key] = newValue;
        object = object[key];
    }
};
const $18522b4fc47f45cb$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $18522b4fc47f45cb$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $18522b4fc47f45cb$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
$18522b4fc47f45cb$var$HookFormContext.displayName = "HookFormContext";
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $18522b4fc47f45cb$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($18522b4fc47f45cb$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $18522b4fc47f45cb$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children } = props, data = (0, $bLhVg._)(props, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($18522b4fc47f45cb$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $18522b4fc47f45cb$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $18522b4fc47f45cb$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $18522b4fc47f45cb$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $18522b4fc47f45cb$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$606f11b2eb45ecc6(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState((0, $9tqwB._)({}, control._formState, formState));
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$18522b4fc47f45cb$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $18522b4fc47f45cb$var$isString = (value1)=>typeof value1 === "string";
var $18522b4fc47f45cb$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($18522b4fc47f45cb$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $18522b4fc47f45cb$var$isPrimitive = (value1)=>$18522b4fc47f45cb$var$isNullOrUndefined(value1) || !$18522b4fc47f45cb$var$isObjectType(value1);
function $18522b4fc47f45cb$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($18522b4fc47f45cb$var$isPrimitive(object1) || $18522b4fc47f45cb$var$isPrimitive(object2)) return Object.is(object1, object2);
    if ($18522b4fc47f45cb$var$isDateObject(object1) && $18522b4fc47f45cb$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($18522b4fc47f45cb$var$isDateObject(val1) && $18522b4fc47f45cb$var$isDateObject(val2) || $18522b4fc47f45cb$var$isObject(val1) && $18522b4fc47f45cb$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$18522b4fc47f45cb$var$deepEqual(val1, val2, _internal_visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $18522b4fc47f45cb$export$3c773aa2b84f29e0(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((values)=>{
        const formValues = $18522b4fc47f45cb$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((values)=>{
        if (!disabled) {
            const formValues = $18522b4fc47f45cb$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!$18522b4fc47f45cb$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !$18522b4fc47f45cb$var$deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            refreshValue();
        }
        return control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                refreshValue(formState.values);
            }
        });
    }, [
        control,
        exact,
        name,
        refreshValue
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // Cache the computed output to avoid duplicate calls within the same render
    // We include shouldReturnImmediate in deps to ensure proper recomputation
    const computedOutput = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        if (disabled) return null;
        const nameChanged = !controlChanged && !$18522b4fc47f45cb$var$deepEqual(prevName, name);
        const shouldReturnImmediate = controlChanged || nameChanged;
        return shouldReturnImmediate ? getCurrentOutput() : null;
    }, [
        disabled,
        controlChanged,
        name,
        prevName,
        getCurrentOutput
    ]);
    return computedOutput !== null ? computedOutput : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$e8c786024a2b0a79(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $18522b4fc47f45cb$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name, $18522b4fc47f45cb$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $18522b4fc47f45cb$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $18522b4fc47f45cb$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(props);
    const _previousNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control.register(name, (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, props.rules), {
        value: value1
    }), $18522b4fc47f45cb$var$isBoolean(props.disabled) ? {
        disabled: props.disabled
    } : {})));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $18522b4fc47f45cb$var$getEventValue(event),
                name: name
            },
            type: $18522b4fc47f45cb$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $18522b4fc47f45cb$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((elm)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(0, $2qxEV._)((0, $9tqwB._)({
            name: name,
            value: value1
        }, $18522b4fc47f45cb$var$isBoolean(disabled) || formState.disabled ? {
            disabled: formState.disabled || disabled
        } : {}), {
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const previousName = _previousNameRef.current;
        if (previousName && previousName !== name && !isArrayField) control.unregister(previousName);
        control.register(name, (0, $9tqwB._)({}, _props.current.rules, $18522b4fc47f45cb$var$isBoolean(_props.current.disabled) ? {
            disabled: _props.current.disabled
        } : {}));
        const updateMounted = (name, value1)=>{
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue));
            $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($18522b4fc47f45cb$var$isUndefined($18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name))) $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        _previousNameRef.current = name;
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $18522b4fc47f45cb$export$bd0bf19f25da8474 = (props)=>props.render($18522b4fc47f45cb$export$e8c786024a2b0a79(props));
const $18522b4fc47f45cb$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($18522b4fc47f45cb$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $18522b4fc47f45cb$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $18522b4fc47f45cb$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$a7fed597f4b8afd8(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $18522b4fc47f45cb$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus } = props, rest = (0, $bLhVg._)(props, [
        "control",
        "onSubmit",
        "children",
        "action",
        "method",
        "headers",
        "encType",
        "onError",
        "render",
        "onSuccess",
        "validateStatus"
    ]);
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $18522b4fc47f45cb$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(String(action), {
                    method: method,
                    headers: (0, $9tqwB._)({}, headers, encType && encType !== "multipart/form-data" ? {
                        "Content-Type": encType
                    } : {}),
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", (0, $9tqwB._)({
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit
    }, rest), children);
}
var $18522b4fc47f45cb$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? (0, $2qxEV._)((0, $9tqwB._)({}, errors[name]), {
        types: (0, $2qxEV._)((0, $9tqwB._)({}, errors[name] && errors[name].types ? errors[name].types : {}), {
            [type]: message || true
        })
    }) : {};
var $18522b4fc47f45cb$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $18522b4fc47f45cb$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $18522b4fc47f45cb$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $18522b4fc47f45cb$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $18522b4fc47f45cb$var$extractFormValues(fieldState, fieldValue);
            if ($18522b4fc47f45cb$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $18522b4fc47f45cb$var$isEmptyObject = (value1)=>$18522b4fc47f45cb$var$isObject(value1) && !Object.keys(value1).length;
var $18522b4fc47f45cb$var$isFileInput = (element)=>element.type === "file";
var $18522b4fc47f45cb$var$isFunction = (value1)=>typeof value1 === "function";
var $18522b4fc47f45cb$var$isHTMLElement = (value1)=>{
    if (!$18522b4fc47f45cb$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $18522b4fc47f45cb$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $18522b4fc47f45cb$var$isRadioInput = (element)=>element.type === "radio";
var $18522b4fc47f45cb$var$isRadioOrCheckbox = (ref)=>$18522b4fc47f45cb$var$isRadioInput(ref) || $18522b4fc47f45cb$var$isCheckBoxInput(ref);
var $18522b4fc47f45cb$var$live = (ref)=>$18522b4fc47f45cb$var$isHTMLElement(ref) && ref.isConnected;
function $18522b4fc47f45cb$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $18522b4fc47f45cb$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $18522b4fc47f45cb$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$18522b4fc47f45cb$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $18522b4fc47f45cb$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $18522b4fc47f45cb$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($18522b4fc47f45cb$var$isObject(childObject) && $18522b4fc47f45cb$var$isEmptyObject(childObject) || Array.isArray(childObject) && $18522b4fc47f45cb$var$isEmptyArray(childObject))) $18522b4fc47f45cb$var$unset(object, paths.slice(0, -1));
    return object;
}
var $18522b4fc47f45cb$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($18522b4fc47f45cb$var$isFunction(data[key])) return true;
    }
    return false;
};
function $18522b4fc47f45cb$var$isTraversable(value1) {
    return Array.isArray(value1) || $18522b4fc47f45cb$var$isObject(value1) && !$18522b4fc47f45cb$var$objectHasFunction(value1);
}
function $18522b4fc47f45cb$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        const value1 = data[key];
        if ($18522b4fc47f45cb$var$isTraversable(value1)) {
            fields[key] = Array.isArray(value1) ? [] : {};
            $18522b4fc47f45cb$var$markFieldsDirty(value1, fields[key]);
        } else if (!$18522b4fc47f45cb$var$isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function $18522b4fc47f45cb$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $18522b4fc47f45cb$var$markFieldsDirty(formValues);
    for(const key in data){
        const value1 = data[key];
        if ($18522b4fc47f45cb$var$isTraversable(value1)) {
            if ($18522b4fc47f45cb$var$isUndefined(formValues) || $18522b4fc47f45cb$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $18522b4fc47f45cb$var$markFieldsDirty(value1, Array.isArray(value1) ? [] : {});
            else $18522b4fc47f45cb$var$getDirtyFields(value1, $18522b4fc47f45cb$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else {
            const formValue = formValues[key];
            dirtyFieldsFromValues[key] = !$18522b4fc47f45cb$var$deepEqual(value1, formValue);
        }
    }
    return dirtyFieldsFromValues;
}
const $18522b4fc47f45cb$var$defaultResult = {
    value: false,
    isValid: false
};
const $18522b4fc47f45cb$var$validResult = {
    value: true,
    isValid: true
};
var $18522b4fc47f45cb$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$18522b4fc47f45cb$var$isUndefined(options[0].attributes.value) ? $18522b4fc47f45cb$var$isUndefined(options[0].value) || options[0].value === "" ? $18522b4fc47f45cb$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $18522b4fc47f45cb$var$validResult : $18522b4fc47f45cb$var$defaultResult;
    }
    return $18522b4fc47f45cb$var$defaultResult;
};
var $18522b4fc47f45cb$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$18522b4fc47f45cb$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $18522b4fc47f45cb$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $18522b4fc47f45cb$var$defaultReturn = {
    isValid: false,
    value: null
};
var $18522b4fc47f45cb$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $18522b4fc47f45cb$var$defaultReturn) : $18522b4fc47f45cb$var$defaultReturn;
function $18522b4fc47f45cb$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($18522b4fc47f45cb$var$isFileInput(ref)) return ref.files;
    if ($18522b4fc47f45cb$var$isRadioInput(ref)) return $18522b4fc47f45cb$var$getRadioValue(_f.refs).value;
    if ($18522b4fc47f45cb$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($18522b4fc47f45cb$var$isCheckBoxInput(ref)) return $18522b4fc47f45cb$var$getCheckboxValue(_f.refs).value;
    return $18522b4fc47f45cb$var$getFieldValueAs($18522b4fc47f45cb$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $18522b4fc47f45cb$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        field && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $18522b4fc47f45cb$var$isRegex = (value1)=>value1 instanceof RegExp;
var $18522b4fc47f45cb$var$getRuleValue = (rule)=>$18522b4fc47f45cb$var$isUndefined(rule) ? rule : $18522b4fc47f45cb$var$isRegex(rule) ? rule.source : $18522b4fc47f45cb$var$isObject(rule) ? $18522b4fc47f45cb$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $18522b4fc47f45cb$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.all,
        isOnTouch: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onTouched
    });
const $18522b4fc47f45cb$var$ASYNC_FUNCTION = "AsyncFunction";
var $18522b4fc47f45cb$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($18522b4fc47f45cb$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $18522b4fc47f45cb$var$ASYNC_FUNCTION || $18522b4fc47f45cb$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $18522b4fc47f45cb$var$ASYNC_FUNCTION));
var $18522b4fc47f45cb$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $18522b4fc47f45cb$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $18522b4fc47f45cb$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const _ref of fieldsNames || Object.keys(fields)){
        let key = _ref;
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f } = field, currentField = (0, $bLhVg._)(field, [
                "_f"
            ]);
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($18522b4fc47f45cb$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($18522b4fc47f45cb$var$isObject(currentField)) {
                if ($18522b4fc47f45cb$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $18522b4fc47f45cb$var$schemaErrorLookup(errors, _fields, name) {
    const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
    if (error || $18522b4fc47f45cb$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $18522b4fc47f45cb$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name } = formStateData, formState = (0, $bLhVg._)(formStateData, [
        "name"
    ]);
    return $18522b4fc47f45cb$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $18522b4fc47f45cb$var$VALIDATION_MODE.all));
};
var $18522b4fc47f45cb$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $18522b4fc47f45cb$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $18522b4fc47f45cb$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $18522b4fc47f45cb$var$unsetEmptyArray = (ref, name)=>!$18522b4fc47f45cb$var$compact($18522b4fc47f45cb$export$3988ae62b71be9a3(ref, name)).length && $18522b4fc47f45cb$var$unset(ref, name);
var $18522b4fc47f45cb$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name));
    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $18522b4fc47f45cb$var$getValidateError(result, ref, type = "validate") {
    if ($18522b4fc47f45cb$var$isString(result) || Array.isArray(result) && result.every($18522b4fc47f45cb$var$isString) || $18522b4fc47f45cb$var$isBoolean(result) && !result) return {
        type: type,
        message: $18522b4fc47f45cb$var$isString(result) ? result : "",
        ref: ref
    };
}
var $18522b4fc47f45cb$var$getValueAndMessage = (validationData)=>$18522b4fc47f45cb$var$isObject(validationData) && !$18522b4fc47f45cb$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $18522b4fc47f45cb$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($18522b4fc47f45cb$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $18522b4fc47f45cb$var$isRadioInput(ref);
    const isCheckBox = $18522b4fc47f45cb$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $18522b4fc47f45cb$var$isFileInput(ref)) && $18522b4fc47f45cb$var$isUndefined(ref.value) && $18522b4fc47f45cb$var$isUndefined(inputValue) || $18522b4fc47f45cb$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $18522b4fc47f45cb$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.maxLength, minType = $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = (0, $9tqwB._)({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $18522b4fc47f45cb$var$isNullOrUndefined(inputValue)) || $18522b4fc47f45cb$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$18522b4fc47f45cb$var$getCheckboxValue(refs).isValid || isRadio && !$18522b4fc47f45cb$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $18522b4fc47f45cb$var$isString(required) ? {
            value: !!required,
            message: required
        } : $18522b4fc47f45cb$var$getValueAndMessage(required);
        if (value1) {
            error[name] = (0, $9tqwB._)({
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef
            }, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$18522b4fc47f45cb$var$isNullOrUndefined(min) || !$18522b4fc47f45cb$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $18522b4fc47f45cb$var$getValueAndMessage(max);
        const minOutput = $18522b4fc47f45cb$var$getValueAndMessage(min);
        if (!$18522b4fc47f45cb$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$18522b4fc47f45cb$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$18522b4fc47f45cb$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($18522b4fc47f45cb$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($18522b4fc47f45cb$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.max, $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($18522b4fc47f45cb$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $18522b4fc47f45cb$var$getValueAndMessage(maxLength);
        const minLengthOutput = $18522b4fc47f45cb$var$getValueAndMessage(minLength);
        const exceedMax = !$18522b4fc47f45cb$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$18522b4fc47f45cb$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $18522b4fc47f45cb$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $18522b4fc47f45cb$var$getValueAndMessage(pattern);
        if ($18522b4fc47f45cb$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = (0, $9tqwB._)({
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref
            }, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($18522b4fc47f45cb$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $18522b4fc47f45cb$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = (0, $9tqwB._)({}, validateError, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($18522b4fc47f45cb$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$18522b4fc47f45cb$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $18522b4fc47f45cb$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = (0, $9tqwB._)({}, validateError, appendErrorsCurry(key, validateError.message));
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$18522b4fc47f45cb$var$isEmptyObject(validationResult)) {
                error[name] = (0, $9tqwB._)({
                    ref: inputRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $18522b4fc47f45cb$var$defaultOptions = {
    mode: $18522b4fc47f45cb$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $18522b4fc47f45cb$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $18522b4fc47f45cb$export$1361f5e0e4cca3c3(props = {}) {
    let _options = (0, $9tqwB._)({}, $18522b4fc47f45cb$var$defaultOptions, props);
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $18522b4fc47f45cb$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $18522b4fc47f45cb$var$isObject(_options.defaultValues) || $18522b4fc47f45cb$var$isObject(_options.values) ? $18522b4fc47f45cb$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $18522b4fc47f45cb$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = (0, $9tqwB._)({}, _proxyFormState);
    const _subjects = {
        array: $18522b4fc47f45cb$var$createSubject(),
        state: $18522b4fc47f45cb$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $18522b4fc47f45cb$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $18522b4fc47f45cb$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $18522b4fc47f45cb$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$18522b4fc47f45cb$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $18522b4fc47f45cb$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name, $18522b4fc47f45cb$var$isUndefined(value1) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $18522b4fc47f45cb$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $18522b4fc47f45cb$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && !_state.action && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $18522b4fc47f45cb$var$deepEqual($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $18522b4fc47f45cb$var$unset(_formState.dirtyFields, name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $18522b4fc47f45cb$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $18522b4fc47f45cb$var$unset(_formState.errors, name);
        }
        if ((error ? !$18522b4fc47f45cb$var$deepEqual(previousFieldError, error) : previousFieldError) || !$18522b4fc47f45cb$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = (0, $2qxEV._)((0, $9tqwB._)({}, fieldState, shouldUpdateValid && $18522b4fc47f45cb$var$isBoolean(isValid) ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _formState = (0, $9tqwB._)({}, _formState, updatedFormState);
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $18522b4fc47f45cb$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
            error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $18522b4fc47f45cb$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const _ref in fields){
            let name = _ref;
            const field = fields[name];
            if (field) {
                const { _f: _f } = field, fieldValue = (0, $bLhVg._)(field, [
                    "_f"
                ]);
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $18522b4fc47f45cb$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $18522b4fc47f45cb$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($18522b4fc47f45cb$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $18522b4fc47f45cb$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $18522b4fc47f45cb$var$unset(_formState.errors, _f.name));
                }
                !$18522b4fc47f45cb$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$18522b4fc47f45cb$var$live(ref)) : !$18522b4fc47f45cb$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, data), !$18522b4fc47f45cb$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$18522b4fc47f45cb$var$generateWatchOutput(names, _names, (0, $9tqwB._)({}, _state.mount ? _formValues : $18522b4fc47f45cb$var$isUndefined(defaultValue) ? _defaultValues : $18522b4fc47f45cb$var$isString(names) ? {
            [names]: defaultValue
        } : defaultValue), isGlobal, defaultValue);
    const _getFieldArray = (name)=>$18522b4fc47f45cb$var$compact($18522b4fc47f45cb$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, $18522b4fc47f45cb$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $18522b4fc47f45cb$var$isHTMLElement(fieldReference.ref) && $18522b4fc47f45cb$var$isNullOrUndefined(value1) ? "" : value1;
                if ($18522b4fc47f45cb$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($18522b4fc47f45cb$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($18522b4fc47f45cb$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $18522b4fc47f45cb$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + "." + fieldKey;
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $18522b4fc47f45cb$var$isObject(fieldValue) || field && !field._f) && !$18522b4fc47f45cb$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $18522b4fc47f45cb$var$cloneObject(value1);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $18522b4fc47f45cb$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$18522b4fc47f45cb$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $18522b4fc47f45cb$var$isWatched(name, _names) && _subjects.state.next((0, $2qxEV._)((0, $9tqwB._)({}, _formState), {
            name: name
        }));
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $18522b4fc47f45cb$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $18522b4fc47f45cb$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $18522b4fc47f45cb$var$deepEqual(fieldValue, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $18522b4fc47f45cb$var$getFieldValue(field._f) : $18522b4fc47f45cb$var$getEventValue(event);
            const isBlurEvent = event.type === $18522b4fc47f45cb$var$EVENTS.BLUR || event.type === $18522b4fc47f45cb$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$18522b4fc47f45cb$var$hasValidation(field._f) && !_options.resolver && !$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $18522b4fc47f45cb$var$skipValidation(isBlurEvent, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $18522b4fc47f45cb$var$isWatched(name, _names, isBlurEvent);
            $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$18522b4fc47f45cb$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $18522b4fc47f45cb$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === "onBlur") {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next((0, $9tqwB._)({
                    name: name
                }, watched ? {} : fieldState));
            }
            !isBlurEvent && watched && _subjects.state.next((0, $9tqwB._)({}, _formState));
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $18522b4fc47f45cb$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $18522b4fc47f45cb$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $18522b4fc47f45cb$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $18522b4fc47f45cb$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $18522b4fc47f45cb$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($18522b4fc47f45cb$var$isUndefined(name) ? name : fieldNames);
            isValid = $18522b4fc47f45cb$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next((0, $2qxEV._)((0, $9tqwB._)({}, !$18522b4fc47f45cb$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
            name: name
        }, _options.resolver || !name ? {
            isValid: isValid
        } : {}), {
            errors: _formState.errors
        }));
        options.shouldFocus && !validationResult && $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = (0, $9tqwB._)({}, _state.mount ? _formValues : _defaultValues);
        if (config) values = $18522b4fc47f45cb$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $18522b4fc47f45cb$var$isUndefined(fieldNames) ? values : $18522b4fc47f45cb$var$isString(fieldNames) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$18522b4fc47f45cb$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $18522b4fc47f45cb$var$convertToArrayPayload(name).forEach((inputName)=>$18522b4fc47f45cb$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type } = currentError, restOfErrorTree = (0, $bLhVg._)(currentError, [
            "ref",
            "message",
            "type"
        ]);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $2qxEV._)((0, $9tqwB._)({}, restOfErrorTree, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$18522b4fc47f45cb$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>"values" in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($18522b4fc47f45cb$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $18522b4fc47f45cb$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback((0, $2qxEV._)((0, $9tqwB._)({
                    values: (0, $9tqwB._)({}, _formValues)
                }, _formState, formState), {
                    defaultValues: _defaultValues
                }));
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = (0, $9tqwB._)({}, _proxySubscribeFormState, props.formState);
        return _subscribe((0, $2qxEV._)((0, $9tqwB._)({}, props), {
            formState: _proxySubscribeFormState
        }));
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $18522b4fc47f45cb$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $18522b4fc47f45cb$var$unset(_fields, fieldName);
                $18522b4fc47f45cb$var$unset(_formValues, fieldName);
            }
            !options.keepError && $18522b4fc47f45cb$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $18522b4fc47f45cb$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $18522b4fc47f45cb$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $18522b4fc47f45cb$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $18522b4fc47f45cb$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $18522b4fc47f45cb$var$cloneObject(_formValues)
        });
        _subjects.state.next((0, $9tqwB._)({}, _formState, !options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($18522b4fc47f45cb$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $18522b4fc47f45cb$var$isBoolean(options.disabled) || $18522b4fc47f45cb$var$isBoolean(_options.disabled);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, (0, $2qxEV._)((0, $9tqwB._)({}, field || {}), {
            _f: (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        }));
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $18522b4fc47f45cb$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return (0, $2qxEV._)((0, $9tqwB._)({}, disabledIsDefined ? {
            disabled: options.disabled || _options.disabled
        } : {}, _options.progressive ? {
            required: !!options.required,
            min: $18522b4fc47f45cb$var$getRuleValue(options.min),
            max: $18522b4fc47f45cb$var$getRuleValue(options.max),
            minLength: $18522b4fc47f45cb$var$getRuleValue(options.minLength),
            maxLength: $18522b4fc47f45cb$var$getRuleValue(options.maxLength),
            pattern: $18522b4fc47f45cb$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $18522b4fc47f45cb$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $18522b4fc47f45cb$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: (0, $9tqwB._)({}, field._f, radioOrCheckbox ? {
                            refs: [
                                ...refs.filter($18522b4fc47f45cb$var$live),
                                fieldRef,
                                ...Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                    {}
                                ] : []
                            ],
                            ref: {
                                type: fieldRef.type,
                                name: name
                            }
                        } : {
                            ref: fieldRef
                        })
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($18522b4fc47f45cb$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        });
    };
    const _focusError = ()=>_options.shouldFocusError && $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($18522b4fc47f45cb$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $18522b4fc47f45cb$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $18522b4fc47f45cb$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$18522b4fc47f45cb$var$unset(fieldValues, name);
            $18522b4fc47f45cb$var$unset(_formState.errors, "root");
            if ($18522b4fc47f45cb$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid((0, $9tqwB._)({}, _formState.errors), e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $18522b4fc47f45cb$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name)) {
            if ($18522b4fc47f45cb$var$isUndefined(options.defaultValue)) setValue(name, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_defaultValues, name, $18522b4fc47f45cb$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $18522b4fc47f45cb$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $18522b4fc47f45cb$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $18522b4fc47f45cb$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next((0, $9tqwB._)({}, _formState));
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $18522b4fc47f45cb$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $18522b4fc47f45cb$var$cloneObject(updatedValues);
        const isEmptyResetValues = $18522b4fc47f45cb$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(values, fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($18522b4fc47f45cb$var$isWeb && $18522b4fc47f45cb$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($18522b4fc47f45cb$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $18522b4fc47f45cb$var$cloneObject(_defaultValues) : {} : $18522b4fc47f45cb$var$cloneObject(values);
            _subjects.array.next({
                values: (0, $9tqwB._)({}, values)
            });
            _subjects.state.next({
                values: (0, $9tqwB._)({}, values)
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !$18522b4fc47f45cb$var$isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$18522b4fc47f45cb$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($18522b4fc47f45cb$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $18522b4fc47f45cb$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = (0, $9tqwB._)({}, _formState, updatedFormState);
    };
    const _resetDefaultValues = ()=>$18522b4fc47f45cb$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $9tqwB._)({}, _options, value);
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return (0, $2qxEV._)((0, $9tqwB._)({}, methods), {
        formControl: methods
    });
}
var $18522b4fc47f45cb$var$generateId = ()=>{
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $18522b4fc47f45cb$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $18522b4fc47f45cb$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$18522b4fc47f45cb$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $18522b4fc47f45cb$var$appendAt = (data, value1)=>[
        ...data,
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1)
    ];
var $18522b4fc47f45cb$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $18522b4fc47f45cb$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $18522b4fc47f45cb$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($18522b4fc47f45cb$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $18522b4fc47f45cb$var$prependAt = (data, value1)=>[
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1),
        ...$18522b4fc47f45cb$var$convertToArrayPayload(data)
    ];
function $18522b4fc47f45cb$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $18522b4fc47f45cb$var$compact(temp).length ? temp : [];
}
var $18522b4fc47f45cb$var$removeArrayAt = (data, index)=>$18522b4fc47f45cb$var$isUndefined(index) ? [] : $18522b4fc47f45cb$var$removeAtIndexes(data, $18522b4fc47f45cb$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $18522b4fc47f45cb$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $18522b4fc47f45cb$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$310131896651d559(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control._getFieldArray(name).map($18522b4fc47f45cb$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $18522b4fc47f45cb$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($18522b4fc47f45cb$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $18522b4fc47f45cb$var$appendAt(ids.current, appendValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$appendAt, {
            argA: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, 0, options);
        ids.current = $18522b4fc47f45cb$var$prependAt(ids.current, prependValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$prependAt, {
            argA: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $18522b4fc47f45cb$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name)) && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, index, options);
        ids.current = $18522b4fc47f45cb$var$insert(ids.current, index, insertValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$insert, {
            argA: index,
            argB: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $18522b4fc47f45cb$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $18522b4fc47f45cb$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $18522b4fc47f45cb$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $18522b4fc47f45cb$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $18522b4fc47f45cb$var$cloneObject(value1);
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $18522b4fc47f45cb$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($18522b4fc47f45cb$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        control._state.action = false;
        $18522b4fc47f45cb$var$isWatched(name, control._names) && control._subjects.state.next((0, $9tqwB._)({}, control._formState));
        if (_actioned.current && (!$18522b4fc47f45cb$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$18522b4fc47f45cb$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $18522b4fc47f45cb$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($18522b4fc47f45cb$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $18522b4fc47f45cb$var$getValidationModes(control._options.mode).isOnSubmit)) $18522b4fc47f45cb$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $18522b4fc47f45cb$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$18522b4fc47f45cb$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $18522b4fc47f45cb$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $18522b4fc47f45cb$var$cloneObject(control._formValues)
        });
        control._names.focus && $18522b4fc47f45cb$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        !$18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>fields.map((field, index)=>(0, $2qxEV._)((0, $9tqwB._)({}, field), {
                    [keyName]: ids.current[index] || $18522b4fc47f45cb$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $18522b4fc47f45cb$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $18522b4fc47f45cb$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = (0, $2qxEV._)((0, $9tqwB._)({}, props.formControl), {
                formState: formState
            });
            if (props.defaultValues && !$18522b4fc47f45cb$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const _createFormControl = $18522b4fc47f45cb$export$1361f5e0e4cca3c3(props), { formControl: formControl } = _createFormControl, rest = (0, $bLhVg._)(_createFormControl, [
                "formControl"
            ]);
            _formControl.current = (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
                formState: formState
            });
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState((0, $9tqwB._)({}, control._formState)),
            reRenderRoot: true
        });
        updateFormState((data)=>(0, $2qxEV._)((0, $9tqwB._)({}, data), {
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        var _a;
        if (props.values && !$18522b4fc47f45cb$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, (0, $9tqwB._)({
                keepFieldsRef: true
            }, control._options.resetOptions));
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>(0, $9tqwB._)({}, state));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next((0, $9tqwB._)({}, control._formState));
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $18522b4fc47f45cb$var$getProxyFormState(formState, control);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param names - Array of field names to watch for changes
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $18522b4fc47f45cb$export$4c68f1a79f88778c = ({ control: control, names: names, render: render })=>render($18522b4fc47f45cb$export$3c773aa2b84f29e0({
        control: control,
        name: names
    }));






/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");
function $8ff804f72e5e9a9a$export$2879604e6aec4ab(g = 0) {
    let [r, l] = (0, $7fPBF.useState)(g), u = (0, $7fPBF.useCallback)((e)=>l((a)=>a | e), [
        r
    ]), n = (0, $7fPBF.useCallback)((e)=>Boolean(r & e), [
        r
    ]), o = (0, $7fPBF.useCallback)((e)=>l((a)=>a & ~e), [
        l
    ]), s = (0, $7fPBF.useCallback)((e)=>l((a)=>a ^ e), [
        l
    ]);
    return {
        addFlag: u,
        hasFlag: n,
        removeFlag: o,
        toggleFlag: s
    };
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");





let $25facc9026f8a295$var$u = (0, $7fPBF.createContext)(null);
function $25facc9026f8a295$var$c() {
    let n = (0, $7fPBF.useContext)($25facc9026f8a295$var$u);
    if (n === null) {
        let r = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(r, $25facc9026f8a295$var$c), r;
    }
    return n;
}
function $25facc9026f8a295$export$d6875122194c7b44() {
    let [n, r] = (0, $7fPBF.useState)([]);
    return [
        n.length > 0 ? n.join(" ") : void 0,
        (0, $7fPBF.useMemo)(()=>function(e) {
                let o = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>(r((t)=>[
                            ...t,
                            l
                        ]), ()=>r((t)=>{
                            let i = t.slice(), a = i.indexOf(l);
                            return a !== -1 && i.splice(a, 1), i;
                        }))), s = (0, $7fPBF.useMemo)(()=>({
                        register: o,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    o,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($25facc9026f8a295$var$u.Provider, {
                    value: s
                }, e.children);
            }, [
            r
        ])
    ];
}
let $25facc9026f8a295$var$h = "label", $25facc9026f8a295$export$b04be29aa201d4f5 = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, d) {
    let e = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: o = `headlessui-label-${e}`, passive: s = !1 } = r, l = (0, $bLhVg._)(r, [
        "id",
        "passive"
    ]), t = $25facc9026f8a295$var$c(), i = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(d);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>t.register(o), [
        o,
        t.register
    ]);
    let a = (0, $2qxEV._)((0, $9tqwB._)({
        ref: i
    }, t.props), {
        id: o
    });
    return s && ("onClick" in a && delete a.onClick, "onClick" in l && delete l.onClick), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: a,
        theirProps: l,
        slot: t.slot || {},
        defaultTag: $25facc9026f8a295$var$h,
        name: t.name || "Label"
    });
});




var $7fPBF = parcelRequire("7fPBF");


function $1c5930309222918e$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $7fPBF.useRef)(t), l = (0, $7fPBF.useRef)(r);
    (0, $7fPBF.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (!e || !c) return;
        let n = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}




function $9ee07d5ba8162c4b$export$bc22b3e852574dab(n = {}, r = null, t = []) {
    for (let [i, o] of Object.entries(n))$9ee07d5ba8162c4b$var$f(t, $9ee07d5ba8162c4b$var$s(r, i), o);
    return t;
}
function $9ee07d5ba8162c4b$var$s(n, r) {
    return n ? n + "[" + r + "]" : r;
}
function $9ee07d5ba8162c4b$var$f(n, r, t) {
    if (Array.isArray(t)) for (let [i, o] of t.entries())$9ee07d5ba8162c4b$var$f(n, $9ee07d5ba8162c4b$var$s(r, i.toString()), o);
    else t instanceof Date ? n.push([
        r,
        t.toISOString()
    ]) : typeof t == "boolean" ? n.push([
        r,
        t ? "1" : "0"
    ]) : typeof t == "string" ? n.push([
        r,
        t
    ]) : typeof t == "number" ? n.push([
        r,
        `${t}`
    ]) : t == null ? n.push([
        r,
        ""
    ]) : $9ee07d5ba8162c4b$export$bc22b3e852574dab(t, r, n);
}
function $9ee07d5ba8162c4b$export$ee02894bdc79dd36(n) {
    var t;
    let r = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");
    if (!!r) {
        for (let i of r.elements)if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
            i.click();
            return;
        }
    }
}





var $7fPBF = parcelRequire("7fPBF");

function $52e65d40f5248976$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $7fPBF.useState)(c), e = l !== void 0, t = (0, $7fPBF.useRef)(e), u = (0, $7fPBF.useRef)(!1), d = (0, $7fPBF.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}





var $1a18a86addc0f3bc$var$he = ((t)=>(t[t.RegisterOption = 0] = "RegisterOption", t[t.UnregisterOption = 1] = "UnregisterOption", t))($1a18a86addc0f3bc$var$he || {});
let $1a18a86addc0f3bc$var$ke = {
    [0] (n, r) {
        let t = [
            ...n.options,
            {
                id: r.id,
                element: r.element,
                propsRef: r.propsRef
            }
        ];
        return (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            options: (0, $14e03ac93c8c8bff$export$20305e96f91bf103)(t, (d)=>d.element.current)
        });
    },
    [1] (n, r) {
        let t = n.options.slice(), d = n.options.findIndex((c)=>c.id === r.id);
        return d === -1 ? n : (t.splice(d, 1), (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            options: t
        }));
    }
}, $1a18a86addc0f3bc$var$$ = (0, $7fPBF.createContext)(null);
$1a18a86addc0f3bc$var$$.displayName = "RadioGroupDataContext";
function $1a18a86addc0f3bc$var$ne(n) {
    let r = (0, $7fPBF.useContext)($1a18a86addc0f3bc$var$$);
    if (r === null) {
        let t = new Error(`<${n} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $1a18a86addc0f3bc$var$ne), t;
    }
    return r;
}
let $1a18a86addc0f3bc$var$V = (0, $7fPBF.createContext)(null);
$1a18a86addc0f3bc$var$V.displayName = "RadioGroupActionsContext";
function $1a18a86addc0f3bc$var$ie(n) {
    let r = (0, $7fPBF.useContext)($1a18a86addc0f3bc$var$V);
    if (r === null) {
        let t = new Error(`<${n} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(t, $1a18a86addc0f3bc$var$ie), t;
    }
    return r;
}
function $1a18a86addc0f3bc$var$Fe(n, r) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(r.type, $1a18a86addc0f3bc$var$ke, n, r);
}
let $1a18a86addc0f3bc$var$Le = "div", $1a18a86addc0f3bc$var$Ce = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, t) {
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: c = `headlessui-radiogroup-${d}`, value: D, defaultValue: O, name: I, onChange: E, by: G = (e, i)=>e === i, disabled: h = !1 } = r, U = (0, $bLhVg._)(r, [
        "id",
        "value",
        "defaultValue",
        "name",
        "onChange",
        "by",
        "disabled"
    ]), T = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(typeof G == "string" ? (e, i)=>{
        let o = G;
        return (e == null ? void 0 : e[o]) === (i == null ? void 0 : i[o]);
    } : G), [k, F] = (0, $7fPBF.useReducer)($1a18a86addc0f3bc$var$Fe, {
        options: []
    }), a = k.options, [M, N] = (0, $25facc9026f8a295$export$d6875122194c7b44)(), [m, L] = (0, $3eb8b29b6155d34a$export$babde88292020af7)(), C = (0, $7fPBF.useRef)(null), W = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(C, t), [l, x] = (0, $52e65d40f5248976$export$454217e89aea72b)(D, E, O), s = (0, $7fPBF.useMemo)(()=>a.find((e)=>!e.propsRef.current.disabled), [
        a
    ]), b = (0, $7fPBF.useMemo)(()=>a.some((e)=>T(e.propsRef.current.value, l)), [
        a,
        l
    ]), u = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        var o;
        if (h || T(e, l)) return !1;
        let i = (o = a.find((f)=>T(f.propsRef.current.value, e))) == null ? void 0 : o.propsRef.current;
        return i != null && i.disabled ? !1 : (x == null || x(e), !0);
    });
    (0, $1c5930309222918e$export$b0abce39eb34b36)({
        container: C.current,
        accept (e) {
            return e.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : e.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (e) {
            e.setAttribute("role", "none");
        }
    });
    let K = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        let i = C.current;
        if (!i) return;
        let o = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(i), f = a.filter((p)=>p.propsRef.current.disabled === !1).map((p)=>p.element.current);
        switch(e.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                (0, $9ee07d5ba8162c4b$export$ee02894bdc79dd36)(e.currentTarget);
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowLeft:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp:
                if (e.preventDefault(), e.stopPropagation(), (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(f, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Previous | (0, $14e03ac93c8c8bff$export$807a7eae502106e7).WrapAround) === (0, $14e03ac93c8c8bff$export$abf286375dfa6dbd).Success) {
                    let y = a.find((j)=>j.element.current === (o == null ? void 0 : o.activeElement));
                    y && u(y.propsRef.current.value);
                }
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowRight:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown:
                if (e.preventDefault(), e.stopPropagation(), (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(f, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Next | (0, $14e03ac93c8c8bff$export$807a7eae502106e7).WrapAround) === (0, $14e03ac93c8c8bff$export$abf286375dfa6dbd).Success) {
                    let y = a.find((j)=>j.element.current === (o == null ? void 0 : o.activeElement));
                    y && u(y.propsRef.current.value);
                }
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                {
                    e.preventDefault(), e.stopPropagation();
                    let p = a.find((y)=>y.element.current === (o == null ? void 0 : o.activeElement));
                    p && u(p.propsRef.current.value);
                }
                break;
        }
    }), w = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>(F((0, $9tqwB._)({
            type: 0
        }, e)), ()=>F({
                type: 1,
                id: e.id
            }))), R = (0, $7fPBF.useMemo)(()=>(0, $9tqwB._)({
            value: l,
            firstOption: s,
            containsCheckedOption: b,
            disabled: h,
            compare: T
        }, k), [
        l,
        s,
        b,
        h,
        T,
        k
    ]), S = (0, $7fPBF.useMemo)(()=>({
            registerOption: w,
            change: u
        }), [
        w,
        u
    ]), ae = {
        ref: W,
        id: c,
        role: "radiogroup",
        "aria-labelledby": M,
        "aria-describedby": m,
        onKeyDown: K
    }, le = (0, $7fPBF.useMemo)(()=>({
            value: l
        }), [
        l
    ]), _ = (0, $7fPBF.useRef)(null), pe = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)();
    return (0, $7fPBF.useEffect)(()=>{
        !_.current || O !== void 0 && pe.addEventListener(_.current, "reset", ()=>{
            u(O);
        });
    }, [
        _,
        u
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(L, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(N, {
        name: "RadioGroup.Label"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1a18a86addc0f3bc$var$V.Provider, {
        value: S
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1a18a86addc0f3bc$var$$.Provider, {
        value: R
    }, I != null && l != null && (0, $9ee07d5ba8162c4b$export$bc22b3e852574dab)({
        [I]: l
    }).map(([e, i], o)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), (0, $9tqwB._)({
            features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Hidden,
            ref: o === 0 ? (f)=>{
                var p;
                _.current = (p = f == null ? void 0 : f.closest("form")) != null ? p : null;
            } : void 0
        }, (0, $72af10e8efa1b073$export$8e16b83750b44988)({
            key: e,
            as: "input",
            type: "radio",
            checked: i != null,
            hidden: !0,
            readOnly: !0,
            name: e,
            value: i
        })))), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: ae,
        theirProps: U,
        slot: le,
        defaultTag: $1a18a86addc0f3bc$var$Le,
        name: "RadioGroup"
    })))));
});
var $1a18a86addc0f3bc$var$xe = ((t)=>(t[t.Empty = 1] = "Empty", t[t.Active = 2] = "Active", t))($1a18a86addc0f3bc$var$xe || {});
let $1a18a86addc0f3bc$var$we = "div", $1a18a86addc0f3bc$var$Ie = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, t) {
    var w;
    let d = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: c = `headlessui-radiogroup-option-${d}`, value: D, disabled: O = !1 } = r, I = (0, $bLhVg._)(r, [
        "id",
        "value",
        "disabled"
    ]), E = (0, $7fPBF.useRef)(null), G = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(E, t), [h, U] = (0, $25facc9026f8a295$export$d6875122194c7b44)(), [T, k] = (0, $3eb8b29b6155d34a$export$babde88292020af7)(), { addFlag: F, removeFlag: a, hasFlag: M } = (0, $8ff804f72e5e9a9a$export$2879604e6aec4ab)(1), N = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)({
        value: D,
        disabled: O
    }), m = $1a18a86addc0f3bc$var$ne("RadioGroup.Option"), L = $1a18a86addc0f3bc$var$ie("RadioGroup.Option");
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>L.registerOption({
            id: c,
            element: E,
            propsRef: N
        }), [
        c,
        L,
        E,
        r
    ]);
    let C = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((R)=>{
        var S;
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(R.currentTarget)) return R.preventDefault();
        !L.change(D) || (F(2), (S = E.current) == null || S.focus());
    }), W = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((R)=>{
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(R.currentTarget)) return R.preventDefault();
        F(2);
    }), l = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>a(2)), x = ((w = m.firstOption) == null ? void 0 : w.id) === c, s = m.disabled || O, b = m.compare(m.value, D), u = {
        ref: G,
        id: c,
        role: "radio",
        "aria-checked": b ? "true" : "false",
        "aria-labelledby": h,
        "aria-describedby": T,
        "aria-disabled": s ? !0 : void 0,
        tabIndex: (()=>s ? -1 : b || !m.containsCheckedOption && x ? 0 : -1)(),
        onClick: s ? void 0 : C,
        onFocus: s ? void 0 : W,
        onBlur: s ? void 0 : l
    }, K = (0, $7fPBF.useMemo)(()=>({
            checked: b,
            disabled: s,
            active: M(2)
        }), [
        b,
        s,
        M
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(k, {
        name: "RadioGroup.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(U, {
        name: "RadioGroup.Label"
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: u,
        theirProps: I,
        slot: K,
        defaultTag: $1a18a86addc0f3bc$var$we,
        name: "RadioGroup.Option"
    })));
}), $1a18a86addc0f3bc$export$a98f0dcb43a68a25 = Object.assign($1a18a86addc0f3bc$var$Ce, {
    Option: $1a18a86addc0f3bc$var$Ie,
    Label: (0, $25facc9026f8a295$export$b04be29aa201d4f5),
    Description: (0, $3eb8b29b6155d34a$export$393edc798c47379d)
});






var $2oXYc = parcelRequire("2oXYc");






var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $b4cd863899309fad$var$InformationCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
        clipRule: "evenodd"
    }));
}
const $b4cd863899309fad$var$ForwardRef = $7fPBF.forwardRef($b4cd863899309fad$var$InformationCircleIcon);
var $b4cd863899309fad$export$2e2bcd8739ae039 = $b4cd863899309fad$var$ForwardRef;


/**
 * Displays a tooltip with information when hovered over.
 *
 * @param {string} info - text to be displayed in the tooltip
 * @param {string} formatting - additional classes to be applied to the tooltip
 *
 * @returns a React component
 */ function $c1f757725b2e8369$var$dispatchTooltip(payload) {
    const event = new CustomEvent("showTooltip", {
        detail: payload
    });
    window.dispatchEvent(event);
}
function $c1f757725b2e8369$export$2e2bcd8739ae039({ info: info, formatting: formatting, tooltipClassName: tooltipClassName }) {
    function handlePointerEnter(e) {
        $c1f757725b2e8369$var$dispatchTooltip({
            x: e.clientX,
            y: e.clientY,
            message: info,
            className: tooltipClassName
        });
    }
    function handlePointerMove(e) {
        $c1f757725b2e8369$var$dispatchTooltip({
            x: e.clientX,
            y: e.clientY,
            message: info,
            className: tooltipClassName
        });
    }
    function handlePointerLeave() {
        $c1f757725b2e8369$var$dispatchTooltip(null);
    }
    (0, $7fPBF.useEffect)(()=>()=>{
            $c1f757725b2e8369$var$dispatchTooltip(null);
        }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: `relative self-center ${formatting}`,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "self-center px-1.5",
            onPointerEnter: handlePointerEnter,
            onPointerMove: handlePointerMove,
            onPointerLeave: handlePointerLeave,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                className: "h-4 w-4 text-gray-300"
            })
        })
    });
}
$c1f757725b2e8369$export$2e2bcd8739ae039.propTypes = {
    info: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    tooltipClassName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$c1f757725b2e8369$export$2e2bcd8739ae039.defaultProps = {
    formatting: "",
    tooltipClassName: ""
};


// this is also hard-coded in the Quotes API getAllFx function
const $796ea4636350e237$export$a01df35ce0858603 = [
    "EUR",
    "AUD",
    "BGN",
    "BRL",
    "CAD",
    "CHF",
    "CNY",
    "CZK",
    "DKK",
    "GBP",
    "HKD",
    "HUF",
    "ILS",
    "INR",
    "ISK",
    "JPY",
    "KRW",
    "MXN",
    "MYR",
    "NOK",
    "NZD",
    "PHP",
    "PLN",
    "RON",
    "SEK",
    "SGD",
    "THB",
    "TRY",
    "USD",
    "ZAR"
];
function $796ea4636350e237$export$2e2bcd8739ae039(code) {
    return $796ea4636350e237$export$a01df35ce0858603.indexOf(code) > 0;
}




function $25222a2cc67561a6$var$SignUpButton({ label: label, icon: icon, checked: checked, onBlur: onBlur }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
            type: "button",
            onBlur: onBlur,
            className: `w-full flex justify-center my-6 py-2 px-4 border rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400
        ${checked ? "border-brandBlue-500 text-white font-medium bg-brandBlue-500 hover:bg-brandBlue-600" : "border-brandBlue-500 text-brandBlue-500 bg-white hover:bg-brandBlue-50"}`,
            children: label
        })
    });
}
$25222a2cc67561a6$var$SignUpButton.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    checked: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
async function $25222a2cc67561a6$export$160ccf2c62cf7466(username) {
    // this function calls up Cognito and tries to log in with a impossible password of 000000
    // depending on the error code we can find out if the username (alias) already exists
    let returnObject;
    try {
        await (0, $300b9456de38c520$export$2ce39ab6662e8c24)({
            username: username,
            confirmationCode: "000000",
            options: {
                forceAliasCreation: false
            }
        });
    // if the option parameter is false, the API will throw an AliasExistsException error if the phone number/email used already exists as an alias with a different user
    } catch (err) {
        console.log(err.code);
        switch(err.code){
            case "UserNotFoundException":
                return true; // username DOES NOT exist, so return true (= can be used) -- email has to be VERIFIED in order to trigger this error
            case "NotAuthorizedException":
                return false; // username EXISTS, so return false (= cannot be used)
            case "AliasExistsException":
                return false;
            default:
                return true;
        }
    }
    return returnObject;
}
function $25222a2cc67561a6$export$2e2bcd8739ae039({ formObject: formObject, formSetObject: formSetObject, goForward: goForward }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const stateData = location.state; // Pricing page redirects to here with a tierType and tierId in state which should be preselected
    const useFormObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: (0, $9tqwB._)({}, formObject, stateData)
    }); // set as subcomponent prop and unpack there, see InternalUserForm
    const { formState: formState } = useFormObject;
    const { touchedFields: touchedFields } = formState;
    function resetLeftColumn(_useFormObject) {
        _useFormObject.resetField("email", {
            keepTouched: false,
            keepError: false,
            defaultValue: ""
        });
        _useFormObject.resetField("password", {
            keepTouched: false,
            keepError: false,
            defaultValue: ""
        });
        _useFormObject.resetField("repeatPassword", {
            keepTouched: false,
            keepError: false,
            defaultValue: ""
        });
    }
    function resetRightColumn(_useFormObject) {
        _useFormObject.resetField("provider", {
            keepTouched: false,
            keepError: false,
            defaultValue: ""
        });
    }
    function onSubmit(data) {
        // on submit update parent component state
        formSetObject(Object.assign(formObject, (0, $2qxEV._)((0, $9tqwB._)({}, data), {
            userId: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)()
        })));
        goForward();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
        name: "signup1",
        className: "grid grid-cols-1 gap-1 py-8 lg:grid-cols-5",
        onSubmit: useFormObject.handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "bg-white rounded-md shadow-md p-6 lg:col-start-1 lg:col-end-3",
                "data-testid": "create-account",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$ab8fd3c1c7255dcc, {
                        useFormObject: useFormObject,
                        resetRightColumn: resetRightColumn
                    }),
                    (Object.keys(touchedFields).includes("email") || Object.keys(touchedFields).includes("password") || Object.keys(touchedFields).includes("repeatPassword")) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$4452190d80a7d3c4, {
                        useFormObject: useFormObject
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex lg:col-start-3 lg:col-end-4",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "text-center mx-auto my-auto py-4",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "font-black text-3xl lg:text-4xl",
                        children: t("or")
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "bg-white rounded-md shadow-md p-6 lg:col-start-4 lg:col-end-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$527cca386b28ecde, {
                        useFormObject: useFormObject,
                        resetLeftColumn: resetLeftColumn
                    }),
                    Object.keys(touchedFields).includes("provider") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$4452190d80a7d3c4, {
                        useFormObject: useFormObject
                    })
                ]
            })
        ]
    });
}
$25222a2cc67561a6$export$2e2bcd8739ae039.propTypes = {
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    formObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    formSetObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $25222a2cc67561a6$export$497a6aaf7dad75ee({ useFormObject: useFormObject, resetRightColumn: resetRightColumn, emailValidation: emailValidation }) {
    const rightColumn = useFormObject.watch("provider");
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
        type: "email",
        name: "email",
        id: "email",
        autoComplete: "email",
        onFocus: ()=>resetRightColumn(useFormObject),
        className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
    }, useFormObject.register("email", {
        maxLength: {
            value: 200,
            message: t("email.errorLength")
        },
        pattern: {
            value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i,
            message: t("email.errorInvalid")
        },
        validate: async (value)=>{
            if (!rightColumn && !value) return t("email.errorEmpty");
            if (value && !rightColumn && !await $25222a2cc67561a6$export$160ccf2c62cf7466(value)) return t("email.errorTaken");
            return true;
        }
    })));
}
$25222a2cc67561a6$export$497a6aaf7dad75ee.propTypes = {
    useFormObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    resetRightColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    emailValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$25222a2cc67561a6$export$497a6aaf7dad75ee.defaultProps = {
    resetRightColumn: ()=>{},
    emailValidation: async ()=>{}
};
function $25222a2cc67561a6$export$964522096592cdaa({ register: register, usernameValidation: usernameValidation }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
        type: "text",
        name: "username",
        id: "username",
        autoComplete: "username",
        className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
    }, register("username", {
        required: {
            value: true,
            message: t("username.errorRequired")
        },
        minLength: {
            value: 5,
            message: t("username.errorMinLength")
        },
        maxLength: {
            value: 40,
            message: t("username.errorLength")
        },
        pattern: {
            value: /^[a-zA-Z 0-9._-]*$/i,
            message: t("username.errorPattern")
        },
        validate: async (value)=>await usernameValidation(value) || t("username.errorTaken")
    })));
}
$25222a2cc67561a6$export$964522096592cdaa.propTypes = {
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    usernameValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$25222a2cc67561a6$export$964522096592cdaa.defaultProps = {
    usernameValidation: async ()=>{}
};
function $25222a2cc67561a6$export$d5bd4e5caf3cfbf9({ useFormObject: useFormObject, setShowPasswordTip: setShowPasswordTip, repeatPassword: repeatPassword, resetRightColumn: resetRightColumn }) {
    const rightColumn = useFormObject.watch("provider");
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    // needs showPasswordTip in state in the parent component
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
        type: "password",
        name: "password",
        id: "password",
        autoComplete: "new-password",
        className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300",
        onFocus: (e)=>{
            resetRightColumn(useFormObject);
            setShowPasswordTip(true);
        }
    }, useFormObject.register("password", {
        validate: (value)=>!(!rightColumn && !value) || t("password.errorEmpty"),
        maxLength: {
            value: 99,
            message: t("password.errorLength")
        },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`])\S{8,99}$/,
            message: t("password.errorPattern")
        },
        onBlur: async (e)=>{
            setShowPasswordTip(false);
            // if the user typed the repeated password, got a validation error and came here to fix it,
            // we need to revalidate repeatPassword as well when the user is finished here
            if (repeatPassword.current.isDirty) await useFormObject.trigger([
                "repeatPassword"
            ]);
        }
    })));
}
$25222a2cc67561a6$export$d5bd4e5caf3cfbf9.propTypes = {
    useFormObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    repeatPassword: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setShowPasswordTip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    resetRightColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$25222a2cc67561a6$export$d5bd4e5caf3cfbf9.defaultProps = {
    resetRightColumn: ()=>{}
};
function $25222a2cc67561a6$export$acef94ee3140d901({ useFormObject: useFormObject, password: password, resetRightColumn: resetRightColumn }) {
    // requires a Ref to the password input field, see above
    const rightColumn = useFormObject.watch("provider");
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
        type: "password",
        name: "repeatPassword",
        id: "repeat-password",
        autoComplete: "new-password",
        onFocus: ()=>resetRightColumn(useFormObject),
        className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
    }, useFormObject.register("repeatPassword", {
        validate: (value)=>!(!rightColumn && value !== password.current) || t("repeatPassword.errorMatch")
    })));
}
$25222a2cc67561a6$export$acef94ee3140d901.propTypes = {
    useFormObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    password: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    resetRightColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$25222a2cc67561a6$export$acef94ee3140d901.defaultProps = {
    resetRightColumn: ()=>{}
};
function $25222a2cc67561a6$export$af458ad0383d354f({ register: register, errors: errors, setError: setError, setValue: setValue, clearErrors: clearErrors }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.code"
    });
    const [visible, setVisible] = (0, $7fPBF.useState)(false);
    const [validating, setValidating] = (0, $7fPBF.useState)(false);
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    async function validateRegistrationCode(code) {
        // console.log('running validate');
        setValidating(true);
        try {
            // set error with no error message first, so that form cannot be submitted for the duration of the validation
            setError("registrationCode", {
                type: "manual",
                message: ""
            });
            const result = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `customer/registrationCodes/${code}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            clearErrors("registrationCode"); // clear manual error
            setValidating(false);
            return !!result;
        } catch (err) {
            setValidating(false);
            clearErrors("registrationCode"); // clear manual error
        }
        return false;
    }
    // handle the query parameter
    (0, $7fPBF.useEffect)(()=>{
        if (queryParams.get("registrationCode")) {
            setVisible(true);
            setValue("registrationCode", queryParams.get("registrationCode"));
        }
    }, [
        queryParams
    ]);
    if (visible) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "col-span-4 md:col-span-3",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                htmlFor: "repeat-password",
                className: "text-sm font-medium text-gray-700 flex align-baseline",
                children: [
                    t("label"),
                    validating && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                        className: "ml-2 w-4 h-4 text-gray-400 animate-spin"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-1 flex rounded-md shadow-sm",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                    type: "text",
                    name: "registrationCode",
                    id: "registrationCode",
                    className: `${visible ? "" : "hidden"} flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300`
                }, register("registrationCode", {
                    validate: async (value)=>{
                        if (value && !await validateRegistrationCode(value)) return t("errorInvalid");
                        return true;
                    }
                })))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "pt-2 sm:text-sm text-brandRed-500",
                children: (errors === null || errors === void 0 ? void 0 : errors.registrationCode) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: errors === null || errors === void 0 ? void 0 : errors.registrationCode.message
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        onClick: ()=>setVisible(true),
        className: "mt-4 col-span-4 md:col-span-3 text-left text-gray-400 text-sm font-semibold tracking-wide hover:text-gray-400 cursor-pointer",
        children: `${t("link")}\u{2192}`
    });
}
$25222a2cc67561a6$export$af458ad0383d354f.propTypes = {
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    clearErrors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$25222a2cc67561a6$export$af458ad0383d354f.defaultProps = {
    errors: {}
};
function $25222a2cc67561a6$export$ab8fd3c1c7255dcc({ useFormObject: useFormObject, resetRightColumn: resetRightColumn, emailUsernameValidation: emailUsernameValidation }) {
    const [showPasswordTip, setShowPasswordTip] = (0, $7fPBF.useState)(false);
    const { register: register, watch: watch, trigger: trigger, formState: { errors: errors }, setValue: setValue } = useFormObject;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    const password = (0, $7fPBF.useRef)({});
    password.current = watch("password", "");
    const repeatPassword = (0, $7fPBF.useRef)({});
    repeatPassword.current = watch("repeatPassword", "");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-xl leading-6 font-bold text-gray-900",
                children: t("createNewAccount")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-6 md:col-span-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                            htmlFor: "email",
                            className: "flex text-sm font-medium text-gray-700",
                            children: [
                                t("email.label"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                    info: t("email.tooltip")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "mt-1 flex rounded-md shadow-sm",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$497a6aaf7dad75ee, {
                                useFormObject: useFormObject,
                                resetRightColumn: resetRightColumn,
                                emailValidation: emailUsernameValidation
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "pt-2 sm:text-sm text-brandRed-500",
                            children: errors.email && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: errors.email.message
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-6 md:col-span-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            htmlFor: "password",
                            className: "block text-sm font-medium text-gray-700",
                            children: t("password.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "mt-1 flex rounded-md shadow-sm",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$d5bd4e5caf3cfbf9, {
                                useFormObject: useFormObject,
                                setShowPasswordTip: setShowPasswordTip,
                                repeatPassword: repeatPassword,
                                resetRightColumn: resetRightColumn
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: showPasswordTip ? "pt-2 text-gray-700 sm:text-sm" : "hidden",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("password.hint")
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "pt-2 sm:text-sm text-brandRed-500",
                            children: errors.password && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: errors.password.message
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-6 md:col-span-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            htmlFor: "repeat-password",
                            className: "block text-sm font-medium text-gray-700",
                            children: t("repeatPassword.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "mt-1 flex rounded-md shadow-sm",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$acef94ee3140d901, {
                                useFormObject: useFormObject,
                                password: password,
                                resetRightColumn: resetRightColumn
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "pt-2 sm:text-sm text-brandRed-500",
                            children: errors.repeatPassword && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: errors.repeatPassword.message
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$25222a2cc67561a6$export$ab8fd3c1c7255dcc.propTypes = {
    useFormObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    resetRightColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    emailUsernameValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$25222a2cc67561a6$export$ab8fd3c1c7255dcc.defaultProps = {
    emailUsernameValidation: async ()=>{}
};
function $25222a2cc67561a6$export$4452190d80a7d3c4({ useFormObject: useFormObject }) {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site");
    const { register: register, formState: { errors: errors }, setValue: setValue, setError: setError, clearErrors: clearErrors } = useFormObject;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-8 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "col-span-4 md:col-span-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                htmlFor: "country",
                                className: "flex text-sm font-medium text-gray-700",
                                children: [
                                    t("register.signUp1.country.label"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                        info: t("country.tooltip")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                    id: "country",
                                    name: "country",
                                    value: "Germany",
                                    autoComplete: "country-name",
                                    className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full sm:text-sm border-gray-300 rounded-md"
                                }, register("country")), {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: "Germany",
                                        children: t("register.signUp1.country.Germany")
                                    })
                                }))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "col-span-4 md:col-span-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                htmlFor: "baseCurrency",
                                className: "flex text-sm font-medium text-gray-700",
                                children: [
                                    t("register.signUp1.baseCurrency.label"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                        info: t("register.signUp1.baseCurrency.tooltip")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                    id: "baseCurrency",
                                    name: "baseCurrency",
                                    autoComplete: "currency",
                                    className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full sm:text-sm border-gray-300 rounded-md"
                                }, register("baseCurrency")), {
                                    children: (0, $796ea4636350e237$export$a01df35ce0858603).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            children: c
                                        }, c))
                                }))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "col-span-4 md:col-span-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex justify-between",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "inline-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "username",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: t("register.signUp1.username.label")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                            info: t("register.signUp1.username.tooltip")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1 flex rounded-md shadow-sm",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$964522096592cdaa, {
                                    register: register,
                                    usernameValidation: $25222a2cc67561a6$export$160ccf2c62cf7466
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500",
                                children: errors.username && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: errors.username.message
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$af458ad0383d354f, {
                        register: register,
                        errors: errors,
                        setValue: setValue,
                        setError: setError,
                        clearErrors: clearErrors
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "pt-5",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex justify-end space-x-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "submit",
                            id: "save",
                            name: "save",
                            // eslint-disable-next-line max-len
                            className: "inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                            children: t("general.next")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            // eslint-disable-next-line max-len
                            className: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                            onClick: (e)=>navigate(-1),
                            children: t("general.cancel")
                        })
                    ]
                })
            })
        ]
    });
}
$25222a2cc67561a6$export$4452190d80a7d3c4.propTypes = {
    useFormObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
function $25222a2cc67561a6$export$527cca386b28ecde({ useFormObject: useFormObject, resetLeftColumn: resetLeftColumn }) {
    const { register: register, control: control, formState: { errors: errors } } = useFormObject;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp1"
    });
    const buttons = [
        {
            label: `${t("signUpWith")} Apple`,
            icon: "apple",
            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Apple
        },
        {
            label: `${t("signUpWith")} Google`,
            icon: "google",
            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Google
        },
        {
            label: `${t("signUpWith")} Facebook`,
            icon: "facebook",
            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Facebook
        },
        {
            label: `${t("signUpWith")} Amazon`,
            icon: "amazon",
            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Amazon
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mb-10",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-xl leading-6 font-bold text-gray-900",
                children: t("useExistingAccount")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "py-6 text-gray-700 text-sm",
                children: t("useExistingAccountDescription")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                control: control,
                name: "provider",
                render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25), {
                        value: field.value,
                        onChange: field.onChange,
                        onFocus: ()=>resetLeftColumn(useFormObject),
                        children: buttons.map((b)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25).Option, {
                                value: b.provider,
                                children: ({ checked: checked })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$var$SignUpButton, {
                                        label: b.label,
                                        icon: b.icon,
                                        checked: checked,
                                        onBlur: field.onBlur
                                    })
                            }, b.provider))
                    })
            })
        ]
    });
}
$25222a2cc67561a6$export$527cca386b28ecde.propTypes = {
    useFormObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    resetLeftColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



function $5f040099692534d9$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.fallback"
    });
    const formObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur"
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    // get query parameter error from URL
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const fallbackMessage = queryParams.get("fallbackMessage");
    function onSubmit(formData) {
        setLoading(true);
        try {
            // the previously gathered user data are saved in session storage, so we need to update them there (without overwriting)
            const savedFormObject = JSON.parse(localStorage.getItem("signUpObject"));
            // signUpObject is used to maintain consistency of the user data across the registration process
            // it is first defined in SignUp3 and then used by hubListener to transition from payment to registration
            // const user = {
            //   username: formObject.userId,
            //   password: formObject.password,
            //   email: formObject.email,
            //   address: { countryCode: 'DE' },
            //   preferredUsername: formObject.username,
            //   baseCurrency: formObject.baseCurrency,
            //   locale: i18n.language,
            //   provider: formObject.provider,
            //   tierId: formObject.tierId, // in "pay later" scenario there is no payment, so tier will be set now
            // };
            // when moving from external user to internal user following changes to formObject must happen:
            // - remove provider field
            // - add email and password fields
            // register action creator will check putEmailInCustomSignupAttribute attribute (set by registerFederated when creating the native user)
            // so the email will be in the email field
            const newFormObject = (0, $2qxEV._)((0, $9tqwB._)({}, savedFormObject), {
                email: formData.email,
                password: formData.password
            });
            delete newFormObject.provider;
            localStorage.setItem("signUpObject", JSON.stringify(newFormObject));
            console.info("SignUpFallback: formObject (after changes):", newFormObject);
            // we dispatch the action (we can't await it, it is not RTK)
            dispatch((0, $8bd3fc2d0bca0786$export$6503ec6e8aabbaf)(newFormObject));
            (0, $55100129ab36ed65$export$89e12c5b50f7529d)(`/${i18n.language}/confirm/${savedFormObject.username}`);
            // sometimes redirect just doesn't work, here is the fallback in the form of 'navigate'
            navigate(`/${i18n.language}/confirm/${savedFormObject.username}`);
        } catch (error) {
            console.error("SignUpFallback: error in onSubmit:", error);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("generalError"));
            setLoading(false);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "relative bg-white",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "mx-auto lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8",
            children: [
                fallbackMessage.includes("email") ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    onSubmit: formObject.handleSubmit(onSubmit),
                    className: "px-6 pb-24 pt-10 sm:pb-32 lg:col-span-7 lg:px-0 lg:pb-56 lg:pt-30 lg:pl-24 lg:min-h-screen xl:pt-40 xl:col-span-6",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "mx-auto max-w-2xl lg:mx-0 mb-20",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                    className: "text-3xl font-black text-gray-900 sm:text-4xl",
                                    children: t("header")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-6 text-lg leading-6 text-gray-600",
                                    children: t("body1")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-6 text-lg leading-6 text-gray-600",
                                    children: t("body2")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25222a2cc67561a6$export$ab8fd3c1c7255dcc), {
                            useFormObject: formObject,
                            resetRightColumn: ()=>{},
                            emailUsernameValidation: (0, $25222a2cc67561a6$export$160ccf2c62cf7466)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            formatting: "mt-5",
                            type: "submit",
                            size: "lg",
                            withAccent: true,
                            enabled: !loading,
                            loading: loading,
                            text: t("submit")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "px-6 pb-24 pt-10 sm:pb-32 lg:col-span-7 lg:px-0 lg:pb-56 lg:pt-60 lg:pl-24 lg:min-h-screen xl:pt-80 xl:col-span-6",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mx-auto max-w-2xl lg:mx-0",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                        className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                        children: t("unhandledError.header")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-6 text-lg leading-6 text-gray-600",
                                        children: t("unhandledError.body1")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-6 text-lg leading-6 text-gray-600",
                                        children: t("unhandledError.body2")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-6 text-lg leading-6 text-gray-600",
                                        children: t("unhandledError.message")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-6 text-lg font-mono leading-6 text-gray-600",
                                        children: queryParams.get("fallbackMessage")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full",
                                src: "https://images.unsplash.com/photo-1552943272-0b58b4078e71?ixlib=rb-4.0.3&ixid=M3wzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE3MDg2Mjk3Mjl8&auto=format&fit=crop&w=2102&q=80",
                                alt: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full",
                        src: "https://images.unsplash.com/photo-1552943272-0b58b4078e71?ixlib=rb-4.0.3&ixid=M3wzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE3MDg2Mjk3Mjl8&auto=format&fit=crop&w=2102&q=80",
                        alt: ""
                    })
                })
            ]
        })
    });
}



parcelRequire("7fPBF");
/* eslint-disable max-len */ /* eslint-disable jsx-a11y/no-redundant-roles */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");



const $cd7b47490a4d308b$var$ensureTrailingSlash = (value = "")=>{
    if (!value) return "";
    return value.endsWith("/") ? value : `${value}/`;
};
const $cd7b47490a4d308b$var$fromEnv = "https://monestry.de/assets/";
const $cd7b47490a4d308b$export$fe8d61c54ed36ed5 = $cd7b47490a4d308b$var$ensureTrailingSlash($cd7b47490a4d308b$var$fromEnv);
const $cd7b47490a4d308b$export$beb10723d1b4d486 = (path = "")=>{
    if (!path || !$cd7b47490a4d308b$export$fe8d61c54ed36ed5) return path;
    return `${$cd7b47490a4d308b$export$fe8d61c54ed36ed5}${path.replace(/^\//, "")}`;
};


function $7e64ecafaa79862f$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const image = (0, $cd7b47490a4d308b$export$beb10723d1b4d486)("Man_at_a_desk_4.png");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "relative bg-gray-50",
        "data-testid": "main-hero",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("main", {
            className: "lg:relative",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "px-4 lg:w-1/2 sm:px-8 xl:pr-16",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                                className: "text-4xl tracking-tight font-black text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "block xl:inline",
                                        children: t("site:main.cta.line-1")
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {}),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "block text-brandBlue-600 xl:inline",
                                        children: t("site:main.cta.line-2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-3 max-w-md mx-auto text-lg text-gray-500 leading-8 sm:text-xl md:mt-5 md:max-w-3xl",
                                children: t("site:main.cta.body-1")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-3 max-w-md mx-auto text-lg text-gray-500 leading-8 sm:text-xl md:mt-5 md:max-w-3xl",
                                children: t("site:main.cta.body-2")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-10 sm:flex sm:justify-center lg:justify-start",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "rounded-md shadow",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            text: t("site:general.findoutmore"),
                                            onClick: ()=>navigate(`${i18n.language}/features`),
                                            withAccent: true,
                                            size: "xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-3 sm:mt-0 sm:ml-6",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            text: t("site:general.getdemo"),
                                            onClick: ()=>navigate(`${i18n.language}/demo`),
                                            size: "xl",
                                            noFrame: true
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "absolute inset-0 w-full h-full object-cover",
                        // src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80"
                        src: image,
                        alt: "a satisfied Monestry user"
                    })
                })
            ]
        })
    });
}



parcelRequire("7fPBF");
function $10c6a51f18360872$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-1 flex justify-center md:col-span-2 lg:col-span-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: "h-12",
                            src: "https://tailwindui.com/img/logos/tuple-logo-gray-400.svg",
                            alt: "Tuple"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-1 flex justify-center md:col-span-2 lg:col-span-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: "h-12",
                            src: "https://tailwindui.com/img/logos/mirage-logo-gray-400.svg",
                            alt: "Mirage"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-1 flex justify-center md:col-span-2 lg:col-span-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: "h-12",
                            src: "https://tailwindui.com/img/logos/statickit-logo-gray-400.svg",
                            alt: "StaticKit"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-1 flex justify-center md:col-span-3 lg:col-span-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: "h-12",
                            src: "https://tailwindui.com/img/logos/transistor-logo-gray-400.svg",
                            alt: "Transistor"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-2 flex justify-center md:col-span-3 lg:col-span-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: "h-12",
                            src: "https://tailwindui.com/img/logos/workcation-logo-gray-400.svg",
                            alt: "Workcation"
                        })
                    })
                ]
            })
        })
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2ccb7dca0a77963b$var$BuildingLibraryIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
    }));
}
const $2ccb7dca0a77963b$var$ForwardRef = $7fPBF.forwardRef($2ccb7dca0a77963b$var$BuildingLibraryIcon);
var $2ccb7dca0a77963b$export$2e2bcd8739ae039 = $2ccb7dca0a77963b$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $9af79d6ecc5b05c1$var$ChartBarSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
    }));
}
const $9af79d6ecc5b05c1$var$ForwardRef = $7fPBF.forwardRef($9af79d6ecc5b05c1$var$ChartBarSquareIcon);
var $9af79d6ecc5b05c1$export$2e2bcd8739ae039 = $9af79d6ecc5b05c1$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $baf6abae159fb213$var$CurrencyDollarIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $baf6abae159fb213$var$ForwardRef = $7fPBF.forwardRef($baf6abae159fb213$var$CurrencyDollarIcon);
var $baf6abae159fb213$export$2e2bcd8739ae039 = $baf6abae159fb213$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $63a505abc1d6767c$var$HomeIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
    }));
}
const $63a505abc1d6767c$var$ForwardRef = $7fPBF.forwardRef($63a505abc1d6767c$var$HomeIcon);
var $63a505abc1d6767c$export$2e2bcd8739ae039 = $63a505abc1d6767c$var$ForwardRef;




function $5a95ae4deed4bc6c$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const allAssetClasses = [
        {
            id: 1,
            name: t("site:main.complete.sub1.title"),
            description: t("site:main.complete.sub1.body"),
            icon: (0, $63a505abc1d6767c$export$2e2bcd8739ae039)
        },
        {
            id: 2,
            name: t("site:main.complete.sub2.title"),
            description: t("site:main.complete.sub2.body"),
            icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039)
        }
    ];
    const automaticUpdatesFeatures = [
        {
            id: 1,
            name: t("site:main.current.sub1.title"),
            description: t("site:main.current.sub1.body"),
            icon: (0, $baf6abae159fb213$export$2e2bcd8739ae039)
        },
        {
            id: 2,
            name: t("site:main.current.sub2.title"),
            description: t("site:main.current.sub2.body"),
            icon: (0, $9af79d6ecc5b05c1$export$2e2bcd8739ae039)
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-white",
                "data-testid": "main-section1",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "max-w-7xl mx-auto py-16 px-4 sm:py-12 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-base font-semibold text-brandBlue-500 tracking-wide uppercase",
                                children: t("site:main.convenience.header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-1 text-3xl font-black text-gray-900 sm:text-4xl sm:tracking-tight",
                                children: t("site:main.convenience.title")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "max-w-4xl mt-5 mx-auto text-xl text-gray-500",
                                children: t("site:main.convenience.subtitle")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative bg-white pt-16 pb-32 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    className: "text-3xl font-black tracking-tight text-gray-900",
                                                    children: t("site:main.complete.title")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-4 text-lg text-gray-500",
                                                    children: t("site:main.complete.body")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                                                    className: "mt-10 space-y-10",
                                                    children: allAssetClasses.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-brandBlue-500 text-white",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.icon, {
                                                                                className: "h-6 w-6",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                            "aria-level": "3",
                                                                            role: "heading",
                                                                            className: "ml-16 text-xl leading-6 font-semibold text-gray-900",
                                                                            children: item.name
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                                    className: "mt-2 ml-16 text-base text-gray-500",
                                                                    children: item.description
                                                                })
                                                            ]
                                                        }, item.id))
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-8",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                        text: t("site:general.findoutmore"),
                                                        onClick: ()=>navigate(`/${i18n.language}/features#one-glance`),
                                                        noFrame: true,
                                                        withAccent: true
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-12 sm:mt-16 lg:mt-0",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none",
                                            src: "https://tailwindui.com/img/component-images/inbox-app-screenshot-1.jpg",
                                            alt: "Dashboard screenshot 1"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-24",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    className: "text-3xl font-black tracking-tight text-gray-900",
                                                    children: t("site:main.current.title")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-4 text-lg text-gray-500",
                                                    children: t("site:main.current.body")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                                                    className: "mt-10 space-y-10",
                                                    children: automaticUpdatesFeatures.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-brandBlue-500 text-white",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.icon, {
                                                                                className: "h-6 w-6",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                            "aria-level": "3",
                                                                            role: "heading",
                                                                            className: "ml-16 text-xl leading-6 font-semibold text-gray-900",
                                                                            children: item.name
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                                    className: "mt-2 ml-16 text-base text-gray-500",
                                                                    children: item.description
                                                                })
                                                            ]
                                                        }, item.id))
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-8",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                        onClick: ()=>navigate(`/${i18n.language}/blog/guide/how-do-we-keep-your-financials-current#blog-title`),
                                                        text: t("site:general.howdowedoit"),
                                                        withAccent: true,
                                                        noFrame: true
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-12 sm:mt-16 lg:mt-0 lg:col-start-1",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pr-4 -ml-48 sm:pr-6 md:-ml-16 lg:px-0 lg:m-0 lg:relative lg:h-full",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:right-0 lg:h-full lg:w-auto lg:max-w-none",
                                            src: "https://tailwindui.com/img/component-images/inbox-app-screenshot-2.jpg",
                                            alt: "Current value screenshot 1"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


/* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");



function $b4531656d1ac3669$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white",
        "data-testid": "main-section2",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "relative overflow-hidden",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative bg-brandBlue-900",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative h-56 bg-brandBlue-500 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    className: "w-full h-full object-cover",
                                    src: "https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&sat=-100",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: "absolute inset-0 bg-gradient-to-r from-brandViolet-600 to-brandBlue-600 mix-blend-multiply"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "relative mx-auto max-w-md px-4 py-12 sm:max-w-7xl sm:px-6 sm:py-20 md:py-28 lg:px-8 lg:py-32",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "md:ml-auto md:w-1/2 md:pl-10",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "text-base font-black uppercase tracking-wider text-gray-300",
                                        children: t("site:main.security.header")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-2 text-white text-3xl font-black tracking-tight sm:text-4xl",
                                        children: t("site:main.security.title")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-3 text-lg text-gray-300",
                                        children: t("site:main.security.body")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-8",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "inline-flex rounded-md shadow",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("site:general.findoutmore"),
                                                noFrame: true,
                                                onDarkBackground: true,
                                                onClick: ()=>navigate(`${i18n.language}/blog/new-features/security-at-monestry#blog-title`)
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable max-len */ 
parcelRequire("7fPBF");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $115cc551859b34d6$var$ClockIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $115cc551859b34d6$var$ForwardRef = $7fPBF.forwardRef($115cc551859b34d6$var$ClockIcon);
var $115cc551859b34d6$export$2e2bcd8739ae039 = $115cc551859b34d6$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $1bdbb80cb7a0676c$var$SwatchIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
    }));
}
const $1bdbb80cb7a0676c$var$ForwardRef = $7fPBF.forwardRef($1bdbb80cb7a0676c$var$SwatchIcon);
var $1bdbb80cb7a0676c$export$2e2bcd8739ae039 = $1bdbb80cb7a0676c$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $fd47aa00749502e2$var$ChatBubbleLeftEllipsisIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10 2c-2.236 0-4.43.18-6.57.524C1.993 2.755 1 4.014 1 5.426v5.148c0 1.413.993 2.67 2.43 2.902.848.137 1.705.248 2.57.331v3.443a.75.75 0 0 0 1.28.53l3.58-3.579a.78.78 0 0 1 .527-.224 41.202 41.202 0 0 0 5.183-.5c1.437-.232 2.43-1.49 2.43-2.903V5.426c0-1.413-.993-2.67-2.43-2.902A41.289 41.289 0 0 0 10 2Zm0 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $fd47aa00749502e2$var$ForwardRef = $7fPBF.forwardRef($fd47aa00749502e2$var$ChatBubbleLeftEllipsisIcon);
var $fd47aa00749502e2$export$2e2bcd8739ae039 = $fd47aa00749502e2$var$ForwardRef;



function $5e7a350105c120d6$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "bg-white overflow-hidden py-4 mb-4",
            "data-testid": "main-section3",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                        className: "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
                        width: 404,
                        height: 784,
                        fill: "none",
                        viewBox: "0 0 404 784",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                    id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                                    x: 0,
                                    y: 0,
                                    width: 20,
                                    height: 20,
                                    patternUnits: "userSpaceOnUse",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                        x: 0,
                                        y: 0,
                                        width: 4,
                                        height: 4,
                                        className: "text-gray-200",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                width: 404,
                                height: 784,
                                fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "h-12 w-12 rounded-md flex items-center justify-center bg-brandBlue-500",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bdbb80cb7a0676c$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 text-white",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                className: "text-3xl font-black tracking-tight text-gray-900",
                                                children: t("site:main.simple.title")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "mt-4 text-lg text-gray-500",
                                                children: t("site:main.simple.body")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-6",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                    text: t("site:main.simple.link"),
                                                    onClick: ()=>navigate(`${i18n.language}/blog/guide/financial-simulations-with-monestry-how-does-my-wealth-grow#blog-title`),
                                                    noFrame: true,
                                                    withAccent: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-8 border-t border-gray-200 pt-6",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("blockquote", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "text-base text-gray-500",
                                                        children: t("site:main.simple.quote")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                                                    className: "mt-3",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "flex items-center space-x-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "flex-shrink-0",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd47aa00749502e2$export$2e2bcd8739ae039), {
                                                                    className: "h-6 w-6 text-brandBlue-500",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "text-base font-medium text-gray-700",
                                                                children: t("site:main.simple.name")
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-10 -mx-4 relative lg:mt-0",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                        className: "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
                                        width: 784,
                                        height: 404,
                                        fill: "none",
                                        viewBox: "0 0 784 404",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                                    id: "ca9667ae-9f92-4be7-abcb-9e3d727f2941",
                                                    x: 0,
                                                    y: 0,
                                                    width: 20,
                                                    height: 20,
                                                    patternUnits: "userSpaceOnUse",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                        x: 0,
                                                        y: 0,
                                                        width: 4,
                                                        height: 4,
                                                        className: "text-gray-200",
                                                        fill: "currentColor"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                width: 784,
                                                height: 404,
                                                fill: "url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        className: "relative mx-auto",
                                        width: 490,
                                        src: "https://tailwindui.com/img/features/feature-example-1.png",
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                        className: "hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12",
                        width: 404,
                        height: 784,
                        fill: "none",
                        viewBox: "0 0 404 784",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                    id: "64e643ad-2176-4f86-b3d7-f2c5da3b6a6d",
                                    x: 0,
                                    y: 0,
                                    width: 20,
                                    height: 20,
                                    patternUnits: "userSpaceOnUse",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                        x: 0,
                                        y: 0,
                                        width: 4,
                                        height: 4,
                                        className: "text-gray-200",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                width: 404,
                                height: 784,
                                fill: "url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "relative mt-12 sm:mt-16 lg:mt-24",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "lg:col-start-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "h-12 w-12 rounded-md flex items-center justify-center bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $115cc551859b34d6$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    className: "text-3xl font-black tracking-tight text-gray-900",
                                                    children: t("site:main.saving.title")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-4 text-lg text-gray-500",
                                                    children: t("site:main.saving.body")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "mt-6 flex space-x-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                            text: t("site:general.startDemo"),
                                                            onClick: ()=>navigate(`${i18n.language}/demo`),
                                                            withAccent: true
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                            text: t("site:main.saving.link"),
                                                            onClick: ()=>navigate(`${i18n.language}/blog/guide/manage-your-finances-the-right-way-with-an-app#blog-title`),
                                                            noFrame: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-8 border-t border-gray-200 pt-6",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("blockquote", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "text-base text-gray-500",
                                                            children: t("site:main.saving.quote")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                                                        className: "mt-3",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "flex items-center space-x-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "flex-shrink-0",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd47aa00749502e2$export$2e2bcd8739ae039), {
                                                                        className: "h-6 w-6 text-brandBlue-500",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "text-base font-medium text-gray-700",
                                                                    children: t("site:main.saving.name")
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-10 -mx-4 relative lg:mt-0 lg:col-start-1",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                            className: "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
                                            width: 784,
                                            height: 404,
                                            fill: "none",
                                            viewBox: "0 0 784 404",
                                            "aria-hidden": "true",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                                        id: "e80155a9-dfde-425a-b5ea-1f6fadd20131",
                                                        x: 0,
                                                        y: 0,
                                                        width: 20,
                                                        height: 20,
                                                        patternUnits: "userSpaceOnUse",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                            x: 0,
                                                            y: 0,
                                                            width: 4,
                                                            height: 4,
                                                            className: "text-gray-200",
                                                            fill: "currentColor"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                    width: 784,
                                                    height: 404,
                                                    fill: "url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "relative mx-auto",
                                            width: 490,
                                            src: "https://tailwindui.com/img/features/feature-example-2.png",
                                            alt: ""
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");



function $82d09a63b188895d$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site");
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "mx-auto max-w-7xl py-16 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative isolate overflow-hidden bg-brandBlue-800 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                        viewBox: "0 0 1024 1024",
                        className: "absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                cx: 512,
                                cy: 512,
                                r: 512,
                                fill: "url(#759c1415-0410-454c-8f7c-9a820de03641)",
                                fillOpacity: "0.7"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("radialGradient", {
                                    id: "759c1415-0410-454c-8f7c-9a820de03641",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                            stopColor: "#68BBF7"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("stop", {
                                            offset: 1,
                                            stopColor: "#A2D5FA"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                                className: "text-3xl font-bold tracking-tight text-white sm:text-4xl",
                                children: [
                                    t("features.section4.cta.header"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("br", {}),
                                    t("features.section4.cta.header2")
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-6 text-lg leading-8 text-gray-300",
                                children: t("features.section4.cta.subheader")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-10 flex items-center justify-center gap-x-4 lg:justify-start",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        text: t("site:general.freetrial"),
                                        onClick: ()=>navigate(`/${i18n.language}/register`)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        text: t("site:general.startDemo"),
                                        onClick: ()=>navigate(`/${i18n.language}/demo`),
                                        noFrame: true,
                                        onDarkBackground: true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "relative mt-16 h-80 lg:mt-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            className: "absolute left-0 top-0 w-[57rem] max-w-none rounded-md bg-white/5 ring-1 ring-white/10",
                            src: "https://tailwindui.com/img/component-images/dark-project-app-screenshot.png",
                            alt: "App screenshot",
                            width: 1824,
                            height: 1080
                        })
                    })
                ]
            })
        })
    });
}


function $c902abd3a8ae487e$var$Main() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        "data-testid": "topmost-node",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e64ecafaa79862f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a95ae4deed4bc6c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4531656d1ac3669$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5e7a350105c120d6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82d09a63b188895d$export$2e2bcd8739ae039), {})
        ]
    });
}
var $c902abd3a8ae487e$export$2e2bcd8739ae039 = $c902abd3a8ae487e$var$Main;


/* eslint-disable react/no-unknown-property */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/button-has-type */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ /* eslint-disable jsx-a11y/anchor-is-valid */ 

var $7fPBF = parcelRequire("7fPBF");


/* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Continues or completes the sign in process when required by the initial call to `signIn`.
 *
 * @param input -  The ConfirmSignInInput object
 * @returns ConfirmSignInOutput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link RespondToAuthChallengeException }:
 * Thrown due to an invalid auth challenge response.
 * @throws  -{@link AssociateSoftwareTokenException}:
 * Thrown due to a service error during the MFA setup process.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `challengeResponse` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $b7099efb313c03e4$export$a477d84c2f7b792a(input) {
    var _Amplify_getConfig_Auth;
    const { challengeResponse: challengeResponse, options: options } = input;
    const { username: username, challengeName: challengeName, signInSession: signInSession, signInDetails: signInDetails } = (0, $e8a04c319f6c75aa$export$390d5da4c63a4a41).getState();
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options === null || options === void 0 ? void 0 : options.clientMetadata;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!challengeResponse, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyChallengeResponse);
    if (!username || !challengeName || !signInSession) // TODO: remove this error message for production apps
    throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c1c2568bac613fe8$export$473ab0b56598aacd).SignInException,
        message: `
			An error occurred during the sign in process.

			This most likely occurred due to:
			1. signIn was not called before confirmSignIn.
			2. signIn threw an exception.
			3. page was refreshed during the sign in flow and session has expired.
			`,
        recoverySuggestion: "Make sure a successful call to signIn is made before calling confirmSignInand that the session has not expired."
    });
    try {
        const { Session: Session, ChallengeName: handledChallengeName, AuthenticationResult: AuthenticationResult, ChallengeParameters: handledChallengeParameters } = await (0, $d8f1cd2c50629c95$export$cfd8b50d0f78e4fa)(username, challengeName, signInSession, challengeResponse, authConfig, (0, $10e1902ea767432f$export$66561e66d62991d0), clientMetaData, options);
        // sets up local state used during the sign-in process
        (0, $e8a04c319f6c75aa$export$bae72361b690e075)({
            signInSession: Session,
            username: username,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $bde9b561f15cfda8$export$729df6fdd19b8b0d)((0, $2qxEV._)((0, $9tqwB._)({
                username: username
            }, AuthenticationResult), {
                NewDeviceMetadata: await (0, $5614e270d557967c$export$548ed8ad974a8b30)({
                    userPoolId: authConfig.userPoolId,
                    userPoolEndpoint: authConfig.userPoolEndpoint,
                    newDeviceMetadata: AuthenticationResult.NewDeviceMetadata,
                    accessToken: AuthenticationResult.AccessToken
                }),
                signInDetails: signInDetails
            }));
            (0, $e8a04c319f6c75aa$export$ddfd5a0262ce9df3)();
            await (0, $9269d5589ae9a3ed$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $d8f1cd2c50629c95$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $0c265cec5f502740$export$5b3890f50cd4853f)(error);
        const result = (0, $d8f1cd2c50629c95$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



function $2367fd2e47508a52$export$2e2bcd8739ae039({ setDisplayedPane: setDisplayedPane, afterLoginGoTo: afterLoginGoTo }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site");
    const [confirmationCode, setConfirmationCode] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [loginError, setLoginError] = (0, $7fPBF.useState)(undefined); // null or error message
    const form = (0, $7fPBF.useRef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { isLoggedIn: isLoggedIn } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user);
    async function handleSubmitConfirmationCode(e) {
        e.preventDefault();
        e.persist();
        setLoading(true);
        try {
            await (0, $b7099efb313c03e4$export$a477d84c2f7b792a)({
                challengeResponse: confirmationCode
            });
        } catch (error) {
            const errorCode = error.code || error.name;
            if (errorCode === "CodeMismatchException") setLoginError(t("login.incorrectConfirmationCode"));
            else {
                console.error(error);
                setLoginError(error.message);
            }
            setLoading(false);
        }
    }
    function required(value) {
        if (!value) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "alert alert-danger",
            role: "alert",
            children: t("login.fieldRequired")
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    }
    const inputRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        // Focus the input element when the component is mounted
        if (inputRef.current) inputRef.current.focus();
    }, []);
    // handle successful login
    (0, $7fPBF.useEffect)(()=>{
        // if isLoggedIn turned true and loading is true
        if (isLoggedIn === true && loading === true) {
            console.log(`Login completed. Navigating towards ${afterLoginGoTo}, isLoggedIn is ${isLoggedIn}`);
            try {
                navigate(afterLoginGoTo, {
                    replace: true
                });
                console.log(`Navigate to ${afterLoginGoTo} hook executed`);
            } catch (error) {
                console.log(`Error while rendering page ${afterLoginGoTo}`);
            }
        }
        if (isLoggedIn === true) // there is no point in showing the login form if the user is already logged in
        navigate(`/${i18n.language}/app`, {
            replace: true
        });
    }, [
        isLoggedIn
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto w-full max-w-sm lg:w-96",
        children: [
            loginError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-brandRed-500",
                id: "loginIncorrectError",
                children: loginError
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "mt-6 text-3xl font-extrabold text-gray-900 text-brand",
                children: t("login.signInIntoYourAccount")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                onSubmit: handleSubmitConfirmationCode,
                ref: form,
                className: "space-y-12 mt-8 mb-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "username",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("login.enterConfirmationCode")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "confirmationCode",
                                    name: "confirmationCode",
                                    type: "text",
                                    ref: inputRef,
                                    required: true,
                                    autoComplete: "off",
                                    // eslint-disable-next-line max-len
                                    className: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brandBlue-500 focus:border-brandBlue-500 sm:text-sm",
                                    value: confirmationCode,
                                    onChange: (e)=>setConfirmationCode(e.target.value),
                                    // eslint-disable-next-line react/no-unknown-property
                                    validations: [
                                        required
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                // eslint-disable-next-line max-len
                                className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                id: "submit",
                                type: "submit",
                                disabled: loading,
                                children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                    className: "h-4 w-4 animate-spin text-white"
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t("general.continue")
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                // eslint-disable-next-line max-len
                                className: "mt-4 w-full flex justify-center py-2 px-4 border rounded-md shadow-sm text-sm font-semibold outline-brandBlue-500 text-brandBlue-500 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                disabled: loading,
                                type: "button",
                                onClick: ()=>setDisplayedPane("login"),
                                children: t("general.cancel")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$2367fd2e47508a52$export$2e2bcd8739ae039.propTypes = {
    setDisplayedPane: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    afterLoginGoTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$2367fd2e47508a52$export$2e2bcd8739ae039.defaultProps = {
    afterLoginGoTo: null
};


/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable react/no-unknown-property */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/button-has-type */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ /* eslint-disable jsx-a11y/anchor-is-valid */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $9910eebff4621a44$var$EyeIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $9910eebff4621a44$var$ForwardRef = $7fPBF.forwardRef($9910eebff4621a44$var$EyeIcon);
var $9910eebff4621a44$export$2e2bcd8739ae039 = $9910eebff4621a44$var$ForwardRef;




function $388dff5322563cb9$export$2e2bcd8739ae039({ setDisplayedPane: setDisplayedPane, afterLoginGoTo: afterLoginGoTo }) {
    const form = (0, $7fPBF.useRef)();
    const { isLoggedIn: isLoggedIn } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user);
    const [username, setUsername] = (0, $7fPBF.useState)("");
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const [isPasswordVisible, setIsPasswordVisible] = (0, $7fPBF.useState)(false);
    const [rememberMe, setRememberMe] = (0, $7fPBF.useState)(true);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [loginError, setLoginError] = (0, $7fPBF.useState)(undefined); // null or error message
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [searchParams, setSearchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    (0, $7fPBF.useEffect)(()=>{
        // handle error when user tries to use a federated identity with an unknown email address
        // redirected from hubListener with unknownUser=true
        const unknownUser = searchParams.get("unknownUser");
        if (unknownUser) setLoginError("unknownUser");
        // remove the unknownUser param from the URL
        setSearchParams({});
    }, []);
    // if Amplify Hub detects an expiring Refresh Token, it will set a Signal in the Redux store
    // check if the Signal is there, get it into a variable and clear it from the store
    const { refreshTokenExpiringSignal: refreshTokenExpiringSignal } = (0, $51238fa605392ada$export$2105062e25df4afe)((s)=>s.message.signal);
    (0, $7fPBF.useEffect)(()=>{
        if ((refreshTokenExpiringSignal === null || refreshTokenExpiringSignal === void 0 ? void 0 : refreshTokenExpiringSignal.caller) === "RequireAuth") {
            setLoginError(refreshTokenExpiringSignal.message);
            dispatch({
                type: "CLEAR_APP_SIGNAL",
                payload: {
                    callerId: "RequireAuth"
                }
            });
        }
    }, [
        refreshTokenExpiringSignal
    ]);
    const onChangeUsername = (e)=>{
        // eslint-disable-next-line no-shadow
        const username = e.target.value;
        setUsername(username);
    };
    const onChangePassword = (e)=>{
        // eslint-disable-next-line no-shadow
        const password = e.target.value;
        setPassword(password);
    };
    function required(value) {
        if (!value) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "alert alert-danger",
            role: "alert",
            children: t("site:login.fieldRequired")
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    }
    async function handleLogin(e) {
        // console.log('handleLogin');
        e.preventDefault();
        e.persist(); // see: https://medium.com/@ian.mundy/async-event-handlers-in-react-a1590ed24399
        if (!isLoggedIn) {
            setLoading(true);
            setLoginError(null);
            const sanitizedUsername = username.trim();
            const sanitizedPassword = password.trim();
            setUsername(sanitizedUsername);
            setPassword(sanitizedPassword);
            // tokens are stored in sessionStorage by default, but if the user checks the "remember me" checkbox, they need to be persisted in localStorage
            if (rememberMe) (0, $10933498be24bbfd$export$27e497d6b00ea18a)(localStorage);
            else (0, $10933498be24bbfd$export$27e497d6b00ea18a)(sessionStorage);
            try {
                var _signInResult_nextStep;
                const signInResult = await (0, $134afd9bfa803edb$export$9670d83f11d4b64a)({
                    username: sanitizedUsername,
                    password: sanitizedPassword
                });
                const nextStep = (_signInResult_nextStep = signInResult.nextStep) === null || _signInResult_nextStep === void 0 ? void 0 : _signInResult_nextStep.signInStep;
                if (nextStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE") {
                    setLoading(false);
                    setDisplayedPane("mfa");
                } else if (nextStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
                    setLoading(false);
                    setDisplayedPane("newPassword");
                } else setLoading(false);
            } catch (err) {
                setLoading(false);
                const errorCode = err.code || err.name;
                console.log("error code", errorCode);
                if (errorCode === "UserNotConfirmedException") // The error happens if the user didn't finish the confirmation step when signing up
                // In this case you need to resend the code and confirm the user
                // About how to resend the code and confirm the user, please check the signUp part
                setLoginError("userNotConfirmed");
                else if (errorCode === "PasswordResetRequiredException") setLoginError("passwordResetRequired");
                else if (errorCode === "NotAuthorizedException" || errorCode === "UserNotFoundException") setLoginError("invalidUsernameOrPassword");
                else console.log(err);
            }
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        // if isLoggedIn turned true and loading is true
        if (isLoggedIn === true && loading === true) try {
            navigate(afterLoginGoTo || `/${i18n.language}/app`, {
                replace: true
            });
            console.log(`Navigate to ${afterLoginGoTo || `/${i18n.language}/app`} hook executed`);
        } catch (error) {
            console.log(`Error while rendering page ${afterLoginGoTo}`);
        }
        else if (isLoggedIn === true) {
            // there is no point in showing the login form if the user is already logged in
            console.log("user logged in, bypassing login form");
            navigate(`/${i18n.language}/app`, {
                replace: true
            });
        }
    }, [
        isLoggedIn
    ]);
    async function handleFederatedLogin(e, provider) {
        try {
            await (0, $701013124925a1b1$export$3d0a7d1372e866bb)(provider);
        } catch (error) {
            console.error(error);
            setLoginError("unknownUser");
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto w-full max-w-sm lg:w-96",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    loginError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-brandRed-500",
                        id: "loginIncorrectError",
                        children: t(`site:login.${loginError}`)
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "mt-6 text-3xl font-extrabold text-gray-900 text-brand",
                        children: t("site:login.signInIntoYourAccount")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-sm font-medium text-gray-700",
                                        children: t("site:login.signInWith")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-1 grid grid-cols-4 gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                    className: "w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50",
                                                    onClick: (e)=>handleFederatedLogin(e, {
                                                            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Facebook
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "sr-only",
                                                            children: `${t("site:login.signInWith")} Facebook`
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                            className: "w-5 h-5",
                                                            "aria-hidden": "true",
                                                            fill: "currentColor",
                                                            viewBox: "0 0 20 20",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                // eslint-disable-next-line max-len
                                                                d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z",
                                                                clipRule: "evenodd"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                    className: "w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50",
                                                    onClick: (e)=>handleFederatedLogin(e, {
                                                            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Google
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "sr-only",
                                                            children: `${t("site:login.signInWith")} Google`
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                                            fill: "currentColor",
                                                            className: "w-5 h-5",
                                                            version: "1.1",
                                                            id: "Capa_1",
                                                            viewBox: "0 0 210 210",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                                                    id: "SVGRepo_bgCarrier",
                                                                    strokeWidth: "0"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                                                    id: "SVGRepo_tracerCarrier",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                                                    id: "SVGRepo_iconCarrier",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                                        d: "M0,105C0,47.103,47.103,0,105,0c23.383,0,45.515,7.523,64.004,21.756l-24.4,31.696C133.172,44.652,119.477,40,105,40 c-35.841,0-65,29.159-65,65s29.159,65,65,65c28.867,0,53.398-18.913,61.852-45H105V85h105v20c0,57.897-47.103,105-105,105 S0,162.897,0,105z"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                    href: "#",
                                                    className: "w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50",
                                                    onClick: (e)=>handleFederatedLogin(e, {
                                                            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Apple
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "sr-only",
                                                            children: `${t("site:login.signInWith")} Apple`
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                            className: "w-5 h-5 -mt-0.5 mb-0.5",
                                                            "aria-hidden": "true",
                                                            fill: "currentColor",
                                                            viewBox: "-56.24 0 608.728 608.728",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                                d: "M273.81 52.973C313.806.257 369.41 0 369.41 0s8.271 49.562-31.463 97.306c-42.426 50.98-90.649 42.638-90.649 42.638s-9.055-40.094 26.512-86.971zM252.385 174.662c20.576 0 58.764-28.284 108.471-28.284 85.562 0 119.222 60.883 119.222 60.883s-65.833 33.659-65.833 115.331c0 92.133 82.01 123.885 82.01 123.885s-57.328 161.357-134.762 161.357c-35.565 0-63.215-23.967-100.688-23.967-38.188 0-76.084 24.861-100.766 24.861C89.33 608.73 0 455.666 0 332.628c0-121.052 75.612-184.554 146.533-184.554 46.105 0 81.883 26.588 105.852 26.588z"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                    href: "#",
                                                    className: "w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50",
                                                    onClick: (e)=>handleFederatedLogin(e, {
                                                            provider: (0, $10933498be24bbfd$export$eeb013770cb92342).Amazon
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "sr-only",
                                                            children: `${t("site:login.signInWith")} Amazon`
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                            className: "w-5 h-5",
                                                            "aria-hidden": "true",
                                                            fill: "currentColor",
                                                            viewBox: "0 0 35.418 35.418",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                                    d: "M20.948,9.891c-0.857,0.068-1.847,0.136-2.837,0.269c-1.516,0.195-3.032,0.461-4.284,1.053 c-2.439,0.994-4.088,3.105-4.088,6.209c0,3.898,2.506,5.875,5.669,5.875c1.057,0,1.913-0.129,2.703-0.328 c1.255-0.396,2.31-1.123,3.562-2.441c0.727,0.99,0.923,1.453,2.177,2.509c0.329,0.133,0.658,0.133,0.922-0.066 c0.791-0.659,2.174-1.848,2.901-2.508c0.328-0.267,0.263-0.66,0.066-0.992c-0.727-0.924-1.45-1.718-1.45-3.498v-5.943 c0-2.513,0.195-4.822-1.647-6.537c-1.518-1.391-3.891-1.916-5.735-1.916c-0.264,0-0.527,0-0.792,0 c-3.362,0.197-6.921,1.647-7.714,5.811c-0.13,0.525,0.267,0.726,0.53,0.793l3.691,0.464c0.396-0.07,0.593-0.398,0.658-0.73 c0.333-1.449,1.518-2.176,2.836-2.309c0.067,0,0.133,0,0.265,0c0.79,0,1.646,0.332,2.109,0.987 c0.523,0.795,0.461,1.853,0.461,2.775L20.948,9.891L20.948,9.891z M20.223,17.749c-0.461,0.925-1.253,1.519-2.11,1.718 c-0.131,0-0.327,0.068-0.526,0.068c-1.45,0-2.31-1.123-2.31-2.775c0-2.11,1.254-3.104,2.836-3.565 c0.857-0.197,1.847-0.265,2.836-0.265v0.793C20.948,15.243,21.01,16.43,20.223,17.749z M35.418,26.918v0.215 c-0.035,1.291-0.716,3.768-2.328,5.131c-0.322,0.25-0.645,0.107-0.503-0.254c0.469-1.145,1.541-3.803,1.04-4.412 c-0.355-0.465-1.826-0.43-3.079-0.322c-0.572,0.072-1.075,0.105-1.469,0.183c-0.357,0.033-0.431-0.287-0.071-0.537 c0.466-0.323,0.969-0.573,1.541-0.756c2.039-0.608,4.406-0.25,4.729,0.146C35.348,26.414,35.418,26.629,35.418,26.918z M32.016,29.428c-0.466,0.357-0.965,0.682-1.468,0.973c-3.761,2.261-8.631,3.441-12.856,3.441c-6.807,0-12.895-2.512-17.514-6.709 c-0.396-0.324-0.073-0.789,0.393-0.539C5.549,29.5,11.709,31.26,18.084,31.26c4.013,0,8.342-0.754,12.463-2.371 c0.285-0.104,0.608-0.252,0.895-0.356C32.087,28.242,32.661,28.965,32.016,29.428z"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-6 relative",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "absolute inset-0 flex items-center",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "w-full border-t border-gray-300"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "relative flex justify-center text-sm",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "px-2 bg-white text-gray-500",
                                            children: t("site:login.orContinueWith")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                            onSubmit: handleLogin,
                            ref: form,
                            className: "space-y-6",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "username",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: t("site:login.emailOrUsername")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                id: "username",
                                                name: "username",
                                                type: "text",
                                                autoComplete: "username",
                                                required: true,
                                                // eslint-disable-next-line max-len
                                                className: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brandBlue-500 focus:border-brandBlue-500 sm:text-sm",
                                                value: username,
                                                onChange: onChangeUsername,
                                                validations: [
                                                    required
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "space-y-1",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "password",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: t("site:login.password")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-1 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    id: "password",
                                                    name: "password",
                                                    type: isPasswordVisible ? "text" : "password",
                                                    autoComplete: "current-password",
                                                    required: true,
                                                    value: password,
                                                    onChange: onChangePassword,
                                                    validations: [
                                                        required
                                                    ],
                                                    // eslint-disable-next-line max-len
                                                    className: "appearance-none block w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brandBlue-500 focus:border-brandBlue-500 sm:text-sm"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>setIsPasswordVisible((prev)=>!prev),
                                                    "aria-label": isPasswordVisible ? t("site:login.hidePassword", {
                                                        defaultValue: "Hide password"
                                                    }) : t("site:login.showPassword", {
                                                        defaultValue: "Show password"
                                                    }),
                                                    "aria-pressed": isPasswordVisible,
                                                    className: "absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 focus:outline-none",
                                                    children: isPasswordVisible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5171585835791f87$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5",
                                                        "aria-hidden": "true"
                                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9910eebff4621a44$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    id: "remember-me",
                                                    name: "remember-me",
                                                    type: "checkbox",
                                                    checked: rememberMe,
                                                    onChange: ()=>setRememberMe(!rememberMe),
                                                    className: "h-4 w-4 text-brandBlue-500 focus:ring-brandBlue-500 border-gray-300 rounded"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                    htmlFor: "remember-me",
                                                    className: "ml-2 block text-sm text-gray-900",
                                                    children: t("site:login.rememberMe")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "text-sm",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                className: "font-semibold text-brandBlue-500 hover:text-brandBlue-600",
                                                onClick: ()=>setDisplayedPane("forgotPassword"),
                                                children: t("site:login.forgotPassword")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "submit",
                                        // eslint-disable-next-line max-len
                                        className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                        id: "submit",
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 animate-spin text-white"
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: t("site:login.signIn")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        // type="submit"
                                        // eslint-disable-next-line max-len
                                        className: "w-full flex justify-center py-2 px-4 border rounded-md shadow-sm text-sm font-semibold outline-brandBlue-500 text-brandBlue-500 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                        disabled: loading,
                                        onClick: ()=>navigate(-1),
                                        children: t("site:general.cancel")
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$388dff5322563cb9$export$2e2bcd8739ae039.propTypes = {
    setDisplayedPane: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    afterLoginGoTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$388dff5322563cb9$export$2e2bcd8739ae039.defaultProps = {
    afterLoginGoTo: null
};


/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable react/no-unknown-property */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/button-has-type */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ /* eslint-disable jsx-a11y/anchor-is-valid */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

















var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f0e990ac22858bb3$export$f8a72614a2df8d41 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("ForgotPassword"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resets a user's password.
 *
 * @param input -  The ResetPasswordInput object.
 * @returns ResetPasswordOutput
 * @throws -{@link ForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function $dc45ed2c50676511$export$dc726c8e334dd814(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const { username: username } = input;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyResetPasswordUsername);
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const clientMetadata = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const forgotPassword = (0, $f0e990ac22858bb3$export$f8a72614a2df8d41)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const res = await forgotPassword({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ResetPassword)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    });
    const codeDeliveryDetails = res.CodeDeliveryDetails;
    return {
        isPasswordReset: false,
        nextStep: {
            resetPasswordStep: "CONFIRM_RESET_PASSWORD_WITH_CODE",
            codeDeliveryDetails: {
                deliveryMedium: codeDeliveryDetails === null || codeDeliveryDetails === void 0 ? void 0 : codeDeliveryDetails.DeliveryMedium,
                destination: codeDeliveryDetails === null || codeDeliveryDetails === void 0 ? void 0 : codeDeliveryDetails.Destination,
                attributeName: codeDeliveryDetails === null || codeDeliveryDetails === void 0 ? void 0 : codeDeliveryDetails.AttributeName
            }
        }
    };
}



function $537cebd20ebf93c7$export$2e2bcd8739ae039({ setDisplayedPane: setDisplayedPane, setRecoveryEmail: setRecoveryEmail }) {
    const form = (0, $7fPBF.useRef)();
    const { isLoggedIn: isLoggedIn } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user);
    const [email, setEmail] = (0, $7fPBF.useState)("");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [loginError, setLoginError] = (0, $7fPBF.useState)(undefined); // null or error message
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const onChangeEmail = (e)=>{
        // eslint-disable-next-line no-shadow
        const email = e.target.value;
        setEmail(email);
    };
    function required(value) {
        if (!value) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "alert alert-danger",
            role: "alert",
            children: t("site:login.fieldRequired")
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    }
    async function handleSubmit(e) {
        e.preventDefault();
        e.persist(); // see: https://medium.com/@ian.mundy/async-event-handlers-in-react-a1590ed24399
        if (!isLoggedIn) {
            setLoading(true);
            setLoginError(null);
            try {
                const sanitizedEmail = email.trim();
                setEmail(sanitizedEmail);
                await (0, $dc45ed2c50676511$export$dc726c8e334dd814)({
                    username: sanitizedEmail
                });
                setRecoveryEmail(sanitizedEmail);
                setDisplayedPane("newPassword");
            } catch (err) {
                setLoading(false);
                const errorCode = err.code || err.name;
                console.log("error code", errorCode);
                if (errorCode === "LimitExceededException") setLoginError(t("site:login.tooManyRequests"));
                else setLoginError(t("site:login.unableToResetPassword"));
            }
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto w-full max-w-sm lg:w-96",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: loginError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "text-brandRed-500",
                    id: "loginIncorrectError",
                    children: t(`site:login.${loginError}`)
                }) : null
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        ref: form,
                        className: "space-y-16",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "mt-6 text-3xl font-extrabold text-gray-900 text-brand",
                                children: t("site:login.passwordRecovery")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "username",
                                        className: "block text-sm font-medium text-gray-700",
                                        children: t("site:login.emailOrUsername")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            id: "email",
                                            name: "email",
                                            type: "text",
                                            autoComplete: "email",
                                            required: true,
                                            className: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brandBlue-500 focus:border-brandBlue-500 sm:text-sm",
                                            value: email,
                                            onChange: onChangeEmail,
                                            validations: [
                                                required
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "submit",
                                        className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                        id: "submit",
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 animate-spin text-white"
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: t("site:general.submit")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        // type="submit"
                                        className: "mt-6 w-full flex justify-center py-2 px-4 border rounded-md shadow-sm text-sm font-semibold outline-brandBlue-500 text-brandBlue-500 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                        disabled: loading,
                                        onClick: ()=>setDisplayedPane("login"),
                                        children: t("site:general.cancel")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
$537cebd20ebf93c7$export$2e2bcd8739ae039.propTypes = {
    setDisplayedPane: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setRecoveryEmail: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable react/no-unknown-property */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/button-has-type */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
















var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $71469b0a88db19cc$export$966c1bde6d375783 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("ConfirmForgotPassword"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms the new password and verification code to reset the password.
 *
 * @param input -  The ConfirmResetPasswordInput object.
 * @throws -{@link ConfirmForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code, password or username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $6a87ef04d4fcebaa$export$890261705c8ce36b(input) {
    var _Amplify_getConfig_Auth, _input_options;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId, userPoolEndpoint: userPoolEndpoint } = authConfig;
    const { username: username, newPassword: newPassword } = input;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!username, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername);
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!newPassword, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword);
    const code = input.confirmationCode;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!code, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode);
    const metadata = (_input_options = input.options) === null || _input_options === void 0 ? void 0 : _input_options.clientMetadata;
    const UserContextData = (0, $7c70435f691a9a82$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const confirmForgotPassword = (0, $71469b0a88db19cc$export$966c1bde6d375783)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await confirmForgotPassword({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(authConfig.userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmResetPassword)
    }, {
        Username: username,
        ConfirmationCode: code,
        Password: newPassword,
        ClientMetadata: metadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
}





function $3ee6db5142e41b6e$export$2e2bcd8739ae039({ setDisplayedPane: setDisplayedPane, recoveryEmail: recoveryEmail }) {
    const { isLoggedIn: isLoggedIn } = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user);
    const [showPasswordTip, setShowPasswordTip] = (0, $7fPBF.useState)(false);
    const [isPasswordVisible, setIsPasswordVisible] = (0, $7fPBF.useState)(false);
    const [isRepeatPasswordVisible, setIsRepeatPasswordVisible] = (0, $7fPBF.useState)(false);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [loginError, setLoginError] = (0, $7fPBF.useState)(undefined);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const useFormObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            password: "",
            repeatPassword: "",
            code: ""
        }
    }); // set as subcomponent prop and unpack there, see InternalUserForm
    const { formState: formState, register: register, watch: watch, trigger: trigger } = useFormObject;
    const { errors: errors, dirtyFields: dirtyFields } = formState;
    const password = (0, $7fPBF.useRef)({});
    password.current = watch("password", "");
    const code = watch("code", "");
    const passwordRegister = register("password", {
        validate: (value)=>value || t("site:register.signUp1.password.errorEmpty"),
        maxLength: {
            value: 99,
            message: t("site:register.signUp1.password.errorLength")
        },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`])\S{8,99}$/,
            message: t("site:register.signUp1.password.errorPattern")
        },
        onBlur: async ()=>{
            setShowPasswordTip(false);
            if (dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.repeatPassword) await trigger([
                "repeatPassword"
            ]);
        }
    });
    const repeatPasswordRegister = register("repeatPassword", {
        validate: (value)=>value === password.current || t("site:register.signUp1.repeatPassword.errorMatch")
    });
    async function handleSubmit(e) {
        e.preventDefault();
        e.persist(); // see: https://medium.com/@ian.mundy/async-event-handlers-in-react-a1590ed24399
        if (!isLoggedIn) {
            setLoading(true);
            setLoginError(null);
            try {
                setLoading(true);
                const sanitizedRecoveryEmail = (recoveryEmail || "").trim();
                const sanitizedPassword = (password.current || "").trim();
                await (0, $6a87ef04d4fcebaa$export$890261705c8ce36b)({
                    username: sanitizedRecoveryEmail,
                    confirmationCode: String(code),
                    newPassword: sanitizedPassword
                });
                dispatch((0, $3b9398d0f9c152fb$export$91020d7983105237)("newPasswordSuccess", "newPasswordPane", ()=>{
                    console.log("about to go back to login");
                    setDisplayedPane("login");
                }));
            } catch (err) {
                setLoading(false);
                setLoginError(t("site:login.unableToResetPassword"));
                console.log("error code", err);
            }
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto w-full max-w-sm lg:w-96",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: loginError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "text-brandRed-500",
                    id: "loginIncorrectError",
                    children: t(`site:login.${loginError}`)
                }) : null
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-6",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "space-y-16",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "mt-6 text-3xl font-extrabold text-gray-900",
                                        children: t("site:login.enterNewPassword")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-4 text-sm font-medium text-gray-500",
                                        children: t("site:login.enterConfirmationCodeEmail.tip")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "code",
                                        className: "mb-1 block text-sm font-medium text-gray-700",
                                        children: t("site:login.enterConfirmationCodeEmail.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                        className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300",
                                        type: "number"
                                    }, register("code", {
                                        required: t("login.fieldRequired"),
                                        valueAsNumber: t("site:login.enterConfirmationCodeEmail.error"),
                                        minLength: {
                                            value: 6,
                                            message: t("site:login.enterConfirmationCodeEmail.error")
                                        },
                                        maxLength: {
                                            value: 6,
                                            message: t("site:login.enterConfirmationCodeEmail.error")
                                        }
                                    }))),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pt-2 sm:text-sm text-brandRed-500",
                                        children: (errors === null || errors === void 0 ? void 0 : errors.code) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: errors === null || errors === void 0 ? void 0 : errors.code.message
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "password",
                                        className: "mb-1 block text-sm font-medium text-gray-700",
                                        children: t("site:register.signUp1.password.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-1 relative",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                                id: "password",
                                                type: isPasswordVisible ? "text" : "password",
                                                autoComplete: "new-password",
                                                className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 pr-10"
                                            }, passwordRegister), {
                                                onFocus: ()=>setShowPasswordTip(true)
                                            })),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setIsPasswordVisible((prev)=>!prev),
                                                "aria-label": isPasswordVisible ? t("site:login.hidePassword", {
                                                    defaultValue: "Hide password"
                                                }) : t("site:login.showPassword", {
                                                    defaultValue: "Show password"
                                                }),
                                                "aria-pressed": isPasswordVisible,
                                                className: "absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 focus:outline-none",
                                                children: isPasswordVisible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5171585835791f87$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9910eebff4621a44$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: showPasswordTip ? "pt-2 text-gray-700 sm:text-sm" : "hidden",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t("site:register.signUp1.password.hint")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pt-2 sm:text-sm text-brandRed-500",
                                        children: (errors === null || errors === void 0 ? void 0 : errors.password) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: errors === null || errors === void 0 ? void 0 : errors.password.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "repeatPassword",
                                        className: "mt-6 mb-1 block text-sm font-medium text-gray-700",
                                        children: t("site:register.signUp1.repeatPassword.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-1 relative",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "repeatPassword",
                                                type: isRepeatPasswordVisible ? "text" : "password",
                                                autoComplete: "new-password",
                                                className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 pr-10"
                                            }, repeatPasswordRegister)),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setIsRepeatPasswordVisible((prev)=>!prev),
                                                "aria-label": isRepeatPasswordVisible ? t("site:login.hidePassword", {
                                                    defaultValue: "Hide password"
                                                }) : t("site:login.showPassword", {
                                                    defaultValue: "Show password"
                                                }),
                                                "aria-pressed": isRepeatPasswordVisible,
                                                className: "absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 focus:outline-none",
                                                children: isRepeatPasswordVisible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5171585835791f87$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9910eebff4621a44$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pt-2 sm:text-sm text-brandRed-500",
                                        children: (errors === null || errors === void 0 ? void 0 : errors.repeatPassword) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: errors === null || errors === void 0 ? void 0 : errors.repeatPassword.message
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "submit",
                                        // eslint-disable-next-line max-len
                                        className: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-semibold text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                        id: "submit",
                                        disabled: loading,
                                        children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4 animate-spin text-white"
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: t("site:general.submit")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        // type="submit"
                                        // eslint-disable-next-line max-len
                                        className: "mt-6 w-full flex justify-center py-2 px-4 border rounded-md shadow-sm text-sm font-semibold outline-brandBlue-500 text-brandBlue-500 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                        disabled: loading,
                                        onClick: ()=>setDisplayedPane("login"),
                                        children: t("site:general.cancel")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
$3ee6db5142e41b6e$export$2e2bcd8739ae039.propTypes = {
    setDisplayedPane: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



function $fa1bc39b019ebecd$var$Login() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const { state: state } = location; // RequireAuth in App passes the intended destination's pathname through location.state
    const [displayedPane, setDisplayedPane] = (0, $7fPBF.useState)("login");
    const [afterLoginGoTo, setAfterLoginGoTo] = (0, $7fPBF.useState)(null);
    const [recoveryEmail, setRecoveryEmail] = (0, $7fPBF.useState)(null); // user's recovery email
    (0, $7fPBF.useEffect)(()=>{
        if (state) setAfterLoginGoTo(!(state === null || state === void 0 ? void 0 : state.afterLoginGoTo) ? `/${i18n.language}/app` : state === null || state === void 0 ? void 0 : state.afterLoginGoTo);
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "min-h-full flex",
        "data-testid": "login",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex-1 flex flex-col justify-center py-48 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24",
                children: [
                    displayedPane === "login" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $388dff5322563cb9$export$2e2bcd8739ae039), {
                        setDisplayedPane: setDisplayedPane,
                        afterLoginGoTo: afterLoginGoTo
                    }),
                    displayedPane === "mfa" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2367fd2e47508a52$export$2e2bcd8739ae039), {
                        afterLoginGoTo: afterLoginGoTo,
                        setDisplayedPane: setDisplayedPane
                    }),
                    displayedPane === "forgotPassword" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $537cebd20ebf93c7$export$2e2bcd8739ae039), {
                        setDisplayedPane: setDisplayedPane,
                        setRecoveryEmail: setRecoveryEmail
                    }),
                    displayedPane === "newPassword" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ee6db5142e41b6e$export$2e2bcd8739ae039), {
                        setDisplayedPane: setDisplayedPane,
                        recoveryEmail: recoveryEmail
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "hidden lg:block relative w-0 flex-1",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: "absolute inset-0 h-full w-full object-cover",
                    // src="https://source.unsplash.com/pcKqvvuTvJM/1600x900"
                    src: (0, $cd7b47490a4d308b$export$beb10723d1b4d486)("login_photo.jpg"),
                    alt: ""
                })
            })
        ]
    });
}
var $fa1bc39b019ebecd$export$2e2bcd8739ae039 = $fa1bc39b019ebecd$var$Login;


/* eslint-disable react/destructuring-assignment */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/no-redundant-roles */ 
parcelRequire("7fPBF");


/* eslint-disable jsx-a11y/anchor-is-valid */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ee0d8d9d593dfbcf$var$ArrowTopRightOnSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M6.194 12.753a.75.75 0 0 0 1.06.053L16.5 4.44v2.81a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.553l-9.056 8.194a.75.75 0 0 0-.053 1.06Z",
        clipRule: "evenodd"
    }));
}
const $ee0d8d9d593dfbcf$var$ForwardRef = $7fPBF.forwardRef($ee0d8d9d593dfbcf$var$ArrowTopRightOnSquareIcon);
var $ee0d8d9d593dfbcf$export$2e2bcd8739ae039 = $ee0d8d9d593dfbcf$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $019bed45533ced54$var$CheckIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
        clipRule: "evenodd"
    }));
}
const $019bed45533ced54$var$ForwardRef = $7fPBF.forwardRef($019bed45533ced54$var$CheckIcon);
var $019bed45533ced54$export$2e2bcd8739ae039 = $019bed45533ced54$var$ForwardRef;


// this could be potentially fetched from stripe API
// that would require moving stripe setup from SignUp3 to SignUp2
function $79e0ab95975351a2$export$2e2bcd8739ae039() {
    return [
        {
            type: "s",
            tierId: "tier-1",
            stripePriceId: "price_1OZYbvHTQ5xnEau1N0N48iNc",
            billingFrequency: "monthly",
            monthlyPrice: 3.9
        },
        {
            type: "s",
            tierId: "tier-1",
            stripePriceId: "price_1OZYcmHTQ5xnEau1BzrFESAN",
            billingFrequency: "annually",
            monthlyPrice: 3.9
        },
        {
            type: "m",
            tierId: "tier-2",
            stripePriceId: "price_1OZYfDHTQ5xnEau13CUqRcde",
            billingFrequency: "monthly",
            monthlyPrice: 7.9
        },
        {
            type: "m",
            tierId: "tier-2",
            stripePriceId: "price_1OZYftHTQ5xnEau1gQpRpjCq",
            billingFrequency: "annually",
            monthlyPrice: 6.9
        },
        {
            type: "l",
            tierId: "tier-3",
            stripePriceId: "price_1OZYhvHTQ5xnEau1EF6jfnka",
            billingFrequency: "monthly",
            monthlyPrice: 10.9,
            mostPopular: true
        },
        {
            type: "l",
            tierId: "tier-3",
            stripePriceId: "price_1OZYixHTQ5xnEau1MiJrgHH2",
            billingFrequency: "annually",
            monthlyPrice: 9.9,
            mostPopular: true
        },
        {
            type: "xl",
            tierId: "tier-4",
            stripePriceId: "price_1OZYk7HTQ5xnEau1TqFtzhBI",
            billingFrequency: "monthly",
            monthlyPrice: 14.9
        },
        {
            type: "xl",
            tierId: "tier-4",
            stripePriceId: "price_1OZYk7HTQ5xnEau1YlzRhzdN",
            billingFrequency: "annually",
            monthlyPrice: 13.9
        }
    ];
}


function $845fa5e8f4bd3a65$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $845fa5e8f4bd3a65$export$2e2bcd8739ae039({ buttonFunction: buttonFunction, selectedTier: selectedTier }) {
    const [frequency, setFrequency] = (0, $7fPBF.useState)("annually"); // 'annually' | 'monthly'
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ], {
        keyPrefix: "pricing"
    });
    const products = (0, $79e0ab95975351a2$export$2e2bcd8739ae039)();
    const productsFilteredByAnnualBilling = products.filter((product)=>product.billingFrequency === frequency);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-16 flex justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25), {
                    value: frequency,
                    onChange: setFrequency,
                    className: "grid grid-cols-2 gap-x-1 rounded-md p-1 text-center text-sm font-semibold leading-5 ring-1 ring-inset ring-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25).Label, {
                            className: "sr-only",
                            children: "Payment frequency"
                        }),
                        [
                            "annually",
                            "monthly"
                        ].map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25).Option, {
                                value: option,
                                className: ({ checked: checked })=>$845fa5e8f4bd3a65$var$classNames(checked ? "bg-brandBlue-500 text-white" : "text-gray-500", "cursor-pointer rounded-md px-3 py-2"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t(option)
                                })
                            }, option))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4",
                children: productsFilteredByAnnualBilling.map((product)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: $845fa5e8f4bd3a65$var$classNames(selectedTier === product.tierId ? "ring-2 ring-brandBlue-500" : "ring-1 ring-gray-200", "rounded-3xl p-8"),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                id: product.tierId,
                                className: $845fa5e8f4bd3a65$var$classNames(selectedTier === product.tierId ? "text-brandBlue-500" : "text-gray-900", "text-xl font-semibold leading-8"),
                                children: t(`products.${product.type}.title`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-4 text-sm leading-6 text-gray-600",
                                children: t(`products.${product.type}.description`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "mt-6 flex items-baseline gap-x-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900",
                                        children: product.monthlyPrice.toFixed(2)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "text-sm font-semibold leading-6 text-gray-500",
                                        children: `\u{20AC}${t("products.frequency")}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                "aria-describedby": product.tierId,
                                type: "button",
                                onClick: ()=>buttonFunction(product.tierId, product.type, frequency),
                                className: $845fa5e8f4bd3a65$var$classNames(selectedTier === product.tierId ? "bg-brandBlue-500 text-white shadow-sm hover:bg-brandBlue-400" : "text-brandBlue-500 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300", // eslint-disable-next-line max-len
                                "mt-6 w-full block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500"),
                                children: t(`products.${product.type}.cta`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                className: "mt-8 space-y-3 text-sm leading-6 text-gray-600",
                                children: t(`products.${product.type}.features`, {
                                    returnObjects: true
                                }).map((feature)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                        className: "flex gap-x-3 leading-5",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $019bed45533ced54$export$2e2bcd8739ae039), {
                                                className: "h-6 w-5 flex-none text-brandBlue-500",
                                                "aria-hidden": "true"
                                            }),
                                            feature
                                        ]
                                    }, feature))
                            })
                        ]
                    }, product.tierId))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "mt-4 text-gray-500 text-sm col-span-2 col-start-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: t("automaticUpdatesDisclaimer1")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        href: t("linkToAutoUpdates"),
                        target: "_blank",
                        className: "font-medium text-brandBlue-500 hover:text-brandBlue-400",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t("automaticUpdatesDisclaimer2")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee0d8d9d593dfbcf$export$2e2bcd8739ae039), {
                                className: "inline-block w-4 h-4 ml-1",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$845fa5e8f4bd3a65$export$2e2bcd8739ae039.propTypes = {
    buttonFunction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    selectedTier: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$845fa5e8f4bd3a65$export$2e2bcd8739ae039.defaultProps = {
    selectedTier: null
};


function $cef90824264fd65e$export$2e2bcd8739ae039() {
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ], {
        keyPrefix: "pricing"
    });
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const faq = t("faq", {
        returnObjects: true
    });
    function handleClick(tierId, tierType) {
        // ('tier-1', 'xl')
        navigate(`/${i18n.language}/register`, {
            state: {
                tierType: tierType,
                tierId: tierId
            }
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        "data-testid": "pricing",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "max-w-7xl mx-auto py-16 px-4 bg-white sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "text-3xl font-black text-gray-900 text-center sm:text-5xl sm:leading-none sm:tracking-tight lg:text-6xl",
                    children: t("header")
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "mt-6 max-w-2xl text-xl mx-auto text-center text-gray-500",
                    children: t("subheader")
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $845fa5e8f4bd3a65$export$2e2bcd8739ae039), {
                    buttonFunction: handleClick
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "bg-white",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "lg:grid lg:grid-cols-3 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "text-3xl font-extrabold text-gray-900",
                                        children: t("faq.header")
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    className: "text-gray-500 col-span-2 col-start-1",
                                    children: [
                                        "Can\u2019t find the answer you\u2019re looking for? Reach out to our customer support team at",
                                        " ",
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                            href: "email:support@monestry.de",
                                            className: "font-medium text-brandBlue-500 hover:text-brandBlue-400",
                                            children: "support@monestry.de"
                                        }),
                                        " ",
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-12 lg:mt-0 lg:col-span-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                                        className: "space-y-12",
                                        children: faq.questions.map((f)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dt", {
                                                        className: "text-lg leading-6 font-medium text-gray-900",
                                                        children: f.question
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                        className: "mt-2 text-base text-gray-500",
                                                        children: f.answer
                                                    })
                                                ]
                                            }, f.question))
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");



function $f0c406b8db64f539$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "bg-white h-[75vh] flex flex-col lg:relative",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex-grow flex flex-col",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                    className: "flex-grow flex flex-col bg-white",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex-grow mx-auto max-w-7xl w-full flex flex-col px-4 sm:px-6 lg:px-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex-shrink-0 my-auto py-16 sm:py-32",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-sm font-semibold text-brandBlue-500 uppercase tracking-wide",
                                    children: t("site:page-not-found.header")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                    className: "mt-2 text-4xl font-black text-gray-900 tracking-tight sm:text-5xl",
                                    children: t("site:page-not-found.title")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-2 text-base text-gray-500",
                                    children: t("site:page-not-found.body")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-6",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        text: t("site:page-not-found.link"),
                                        noFrame: true,
                                        withAccent: true,
                                        onClick: ()=>navigate(-1)
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        text: t("site:page-not-found.homePage"),
                                        noFrame: true,
                                        withAccent: true,
                                        onClick: ()=>navigate(`/${i18n.language}/}`)
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "hidden lg:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: "absolute inset-0 h-full w-full object-cover object-bottom",
                    src: "https://images.unsplash.com/photo-1470847355775-e0e3c35a9a2c?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1825&q=80",
                    alt: ""
                })
            })
        ]
    });
}


/* eslint-disable no-eval */ /* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");


/* eslint-disable no-unsafe-optional-chaining */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $95165b7ebafa73cf$var$MagnifyingGlassIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
        clipRule: "evenodd"
    }));
}
const $95165b7ebafa73cf$var$ForwardRef = $7fPBF.forwardRef($95165b7ebafa73cf$var$MagnifyingGlassIcon);
var $95165b7ebafa73cf$export$2e2bcd8739ae039 = $95165b7ebafa73cf$var$ForwardRef;




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ee733d190e036d54$var$ChevronLeftIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $ee733d190e036d54$var$ForwardRef = $7fPBF.forwardRef($ee733d190e036d54$var$ChevronLeftIcon);
var $ee733d190e036d54$export$2e2bcd8739ae039 = $ee733d190e036d54$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $28c6eaf86f1a6031$var$ChevronRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $28c6eaf86f1a6031$var$ForwardRef = $7fPBF.forwardRef($28c6eaf86f1a6031$var$ChevronRightIcon);
var $28c6eaf86f1a6031$export$2e2bcd8739ae039 = $28c6eaf86f1a6031$var$ForwardRef;





var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $f2e799ae4c9b5694$var$ArrowDownTrayIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    }));
}
const $f2e799ae4c9b5694$var$ForwardRef = $7fPBF.forwardRef($f2e799ae4c9b5694$var$ArrowDownTrayIcon);
var $f2e799ae4c9b5694$export$2e2bcd8739ae039 = $f2e799ae4c9b5694$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $724f5757abe63378$var$AtSymbolIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
    }));
}
const $724f5757abe63378$var$ForwardRef = $7fPBF.forwardRef($724f5757abe63378$var$AtSymbolIcon);
var $724f5757abe63378$export$2e2bcd8739ae039 = $724f5757abe63378$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $4de34f51288f4739$var$BanknotesIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
    }));
}
const $4de34f51288f4739$var$ForwardRef = $7fPBF.forwardRef($4de34f51288f4739$var$BanknotesIcon);
var $4de34f51288f4739$export$2e2bcd8739ae039 = $4de34f51288f4739$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $16ec350000b30f94$var$BuildingStorefrontIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z"
    }));
}
const $16ec350000b30f94$var$ForwardRef = $7fPBF.forwardRef($16ec350000b30f94$var$BuildingStorefrontIcon);
var $16ec350000b30f94$export$2e2bcd8739ae039 = $16ec350000b30f94$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $e6e78592b1329b53$var$ChartBarIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
    }));
}
const $e6e78592b1329b53$var$ForwardRef = $7fPBF.forwardRef($e6e78592b1329b53$var$ChartBarIcon);
var $e6e78592b1329b53$export$2e2bcd8739ae039 = $e6e78592b1329b53$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $eeaa4d476c1d806f$var$CircleStackIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
    }));
}
const $eeaa4d476c1d806f$var$ForwardRef = $7fPBF.forwardRef($eeaa4d476c1d806f$var$CircleStackIcon);
var $eeaa4d476c1d806f$export$2e2bcd8739ae039 = $eeaa4d476c1d806f$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $cb2d399f75600b13$var$TrophyIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0"
    }));
}
const $cb2d399f75600b13$var$ForwardRef = $7fPBF.forwardRef($cb2d399f75600b13$var$TrophyIcon);
var $cb2d399f75600b13$export$2e2bcd8739ae039 = $cb2d399f75600b13$var$ForwardRef;


const $134ab0040d88b150$export$205e6715f8ffaf7d = {
    deposits: {
        Icon: (0, $4de34f51288f4739$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandBlue-100",
            hover: "bg-brandBlue-200",
            bottom: "bg-brandBlue-500",
            text: "text-brandBlue-600",
            ring: "ring-brandBlue-700",
            hex: "#1797f2"
        }
    },
    stocks: {
        Icon: (0, $e6e78592b1329b53$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandViolet-100",
            hover: "bg-brandViolet-200",
            bottom: "bg-brandViolet-500",
            text: "text-brandViolet-600",
            ring: "ring-brandViolet-700",
            hex: "#bb6dce"
        }
    },
    realEstate: {
        Icon: (0, $63a505abc1d6767c$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandGreen-100",
            hover: "bg-brandGreen-200",
            bottom: "bg-brandGreen-500",
            text: "text-brandGreen-600",
            ring: "ring-brandGreen-700",
            hex: "#92d050"
        }
    },
    pension: {
        Icon: (0, $115cc551859b34d6$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandOrange-100",
            hover: "bg-brandOrange-200",
            bottom: "bg-brandOrange-500",
            text: "text-brandOrange-600",
            ring: "ring-brandOrange-700",
            hex: "#ff7f50"
        }
    },
    objectsOfValue: {
        Icon: (0, $cb2d399f75600b13$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandDesertBrown-100",
            hover: "bg-brandDesertBrown-200",
            bottom: "bg-brandDesertBrown-500",
            text: "text-brandDesertBrown-600",
            ring: "ring-brandDesertBrown-700",
            hex: "#f4a460"
        }
    },
    metals: {
        Icon: (0, $eeaa4d476c1d806f$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandYellow-100",
            hover: "bg-brandYellow-200",
            bottom: "bg-brandYellow-500",
            text: "text-brandYellow-600",
            ring: "ring-brandYellow-700",
            hex: "#ffd600"
        }
    },
    loans: {
        Icon: (0, $f2e799ae4c9b5694$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandRed-100",
            hover: "bg-brandRed-200",
            bottom: "bg-brandRed-500",
            text: "text-brandRed-600",
            ring: "ring-brandRed-700",
            hex: "#ed1c23"
        }
    },
    unlistedShares: {
        Icon: (0, $16ec350000b30f94$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandEmerald-100",
            hover: "bg-brandEmerald-200",
            bottom: "bg-brandEmerald-500",
            text: "text-brandEmerald-600",
            ring: "ring-brandEmerald-700",
            hex: "#3cb371"
        }
    },
    crypto: {
        Icon: (0, $724f5757abe63378$export$2e2bcd8739ae039),
        color: {
            bg: "bg-brandDarkBlue-100",
            hover: "bg-brandDarkBlue-200",
            bottom: "bg-brandDarkBlue-500",
            text: "text-brandDarkBlue-600",
            ring: "ring-brandDarkBlue-700",
            hex: "#2e3192"
        }
    }
};
var $134ab0040d88b150$export$2e2bcd8739ae039 = $134ab0040d88b150$export$205e6715f8ffaf7d;



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
var $6e4ed87a46fed97e$exports = {};
$6e4ed87a46fed97e$exports = JSON.parse('[{"id":"manage-your-finances-with-app","en":{"displayKey":"manage-your-finances-the-right-way-with-an-app","title":"Manage your finances the right way: with an app","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/manage-your-finances-the-right-way-with-an-app"},"de":{"displayKey":"eigene-finanzen-richtig-mit-app-verwalten","title":"Eigene Finanzen richtig mit einer App verwalten","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/eigene-finanzen-richtig-mit-app-verwalten"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]},{"id":"wealth-management-with-monestry","en":{"displayKey":"wealth-management-with-monestry","title":"Wealth management with Monestry","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/wealth-management-with-monestry"},"de":{"displayKey":"verm\xf6gensmanagement-mit-monestry","title":"Verm\xf6gensmanagement mit Monestry","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/verm\xf6gensmanagement-mit-monestry"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&w=413&q=85&crop=bottom&fit=crop&h=192"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]},{"id":"financial-planning-with-monestry-set-goals","en":{"displayKey":"financial-planning-with-monestry-set-goals","title":"Financial planning with Monestry: set goals","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/financial-planning-with-monestry-set-goal"},"de":{"displayKey":"finanzielle-planung-mit-monestry-ziele-setzen","title":"Finanzielle Planung mit Monestry: Ziele setzen","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/finanzielle-planung-mit-monestry-ziele-setze"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1515986078061-ef398fc02c9b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1515986078061-ef398fc02c9b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=bottom&w=400&h=200"},"relatedPosts":["financial-simulations-with-monestry-how-does-my-wealth-grow","manage-your-finances-with-app"]},{"id":"financial-simulations-with-monestry-how-does-my-wealth-grow","en":{"displayKey":"financial-simulations-with-monestry-how-does-my-wealth-grow","title":"Financial simulations with Monestry: how does my wealth grow?","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/financial-simulations-with-monestry-how-does-my-wealth-grow"},"de":{"displayKey":"finanzielle-simulationen-mit-monestry-wie-entwickelt-sich-mein-verm\xf6gen","title":"Finanzielle Simulationen mit Monestry: wie entwickelt sich mein Verm\xf6gen?","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/finanzielle-simulationen-mit-monestry-wie-entwickelt-sich-mein-verm\xf6gen"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges&w=1&h=0.3"},"relatedPosts":["financial-planning-with-monestry-set-goals","manage-your-finances-with-app"]},{"id":"use-finance-management-app-anonymously-monestry-and-its-anonymous-mode","en":{"displayKey":"use-finance-management-app-anonymously-monestry-and-its-anonymous-mode","title":"Anonymous finance management app: Monestry and its Anonymous Mode","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"},"de":{"displayKey":"finanzen-management-app-anonym-nutzen-monestry-und-ihr-anonymes-modus","title":"Finanzen-Management-App anonym nutzen: Monestry und ihr anonymes Modus.","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/finanzen-management-app-anonym-nutzen-monestry-und-ihr-anonymes-modus"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1645481580015-4b434984c642?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1645481580015-4b434984c642?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1&h=0.33&crop=edges&q=80"},"relatedPosts":["security-at-monestry","data-privacy-at-monestry","article-id-5"]},{"id":"manage-private-finances-excel-wealth-overview","en":{"displayKey":"manage-private-finances-excel-wealth-overview","title":"Manage private finances with Excel (wealth overview)","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/point-of-view/manage-private-finances-excel-wealth-overview"},"de":{"displayKey":"private-finanzen-excel-verwalten-finanz\xfcbersicht","title":"Private Finanzen mit Excel verwalten (Finanz\xfcbersicht)","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/standpunkte/private-finanzen-excel-verwalten-finanz\xfcbersicht"},"author":"Piotr Loboda","href":"#","category":{"key":"point-of-view"},"image":{"article":"https://images.unsplash.com/photo-1622463461333-611830d028bd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top","thumb":"https://images.unsplash.com/photo-1622463461333-611830d028bd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=420&h=190&q=80&crop=edges"},"relatedPosts":["can-psd2-interfaces-be-accessed-by-individuals","manage-your-finances-with-app"]},{"id":"can-psd2-interfaces-be-accessed-by-individuals","en":{"displayKey":"can-psd2-interfaces-be-accessed-by-individuals","title":"Can PSD2 interfaces be accessed by individuals?","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/point-of-view/can-psd2-interfaces-be-accessed-by-individuals"},"de":{"displayKey":"als-privatperson-psd2-api-anbinden","title":"Kann eine Privatperson PSD2-Schnittstellen anbinden?","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/standpunkte/als-privatperson-psd2-api-anbinden"},"author":"Piotr Loboda","href":"#","category":{"key":"point-of-view"},"image":{"article":"https://images.unsplash.com/photo-1609358905581-e5381612486e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1609358905581-e5381612486e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["manage-private-finances-excel-wealth-overview","manage-your-finances-with-app","data-privacy-at-monestry"]},{"id":"do-you-really-need-banking-app-for-all-your-banks","en":{"displayKey":"do-you-really-need-banking-app-for-all-your-bank-accounts","title":"Do you really need a banking app for all your bank accounts?","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/point-of-view/do-you-really-need-banking-app-for-all-your-banks"},"de":{"displayKey":"brauchen-sie-wirklich-banking-app-f\xfcr-alle-bankkonten","title":"Brauchen Sie wirklich eine Banking-App f\xfcr alle Ihre Bankkonten?","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/standpunkte/brauchen-sie-wirklich-banking-app-f\xfcr-alle-banken"},"author":"Piotr Loboda","category":{"key":"point-of-view"},"image":{"article":"https://images.unsplash.com/photo-1560472355-536de3962603?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1560472355-536de3962603?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=entropy"},"relatedPosts":["manage-your-finances-with-app","shares-simply-explained"]},{"id":"multi-broker-apps-overview","en":{"displayKey":"multi-broker-apps-overview","title":"Multi-Broker apps: overview","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/point-of-view/multi-broker-apps-overview"},"de":{"displayKey":"multi-depotverwaltung-app-vergleich","title":"Multi-Depotverwaltung: App-vergleich","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/standpunkte/multi-depotverwaltung-app-vergleich"},"author":"Piotr Loboda","href":"#","category":{"key":"point-of-view"},"image":{"article":"https://images.unsplash.com/photo-1606189934390-2b10bb7f8094?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.15&crop=top","thumb":"https://images.unsplash.com/photo-1606189934390-2b10bb7f8094?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["manage-your-finances-with-app","financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow"]},{"id":"threshold-wealth-to-consider-private-wealth-management","en":{"displayKey":"threshold-wealth-to-consider-private-wealth-management","title":"What threshold wealth should I have to consider private wealth management?","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/point-of-view/threshold-wealth-to-consider-private-wealth-management"},"de":{"displayKey":"ab-welchem-betrag-lohnt-sich-private-verm\xf6gensverwaltung","title":"Ab welchem Betrag lohnt sich eine private Verm\xf6gensverwaltung?","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/standpunkte/ab-welchem-betrag-lohnt-sich-private-verm\xf6gensverwaltung"},"author":"Piotr Loboda","href":"#","category":{"key":"point-of-view"},"image":{"article":"https://images.unsplash.com/photo-1611937663641-5cef5189d71b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top","thumb":"https://images.unsplash.com/photo-1611937663641-5cef5189d71b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["manage-your-finances-with-app","etf-simply-explained"]},{"id":"plan-and-track-retirement-financials-with-monestry","en":{"displayKey":"plan-and-track-retirement-financials-with-monestry","title":"Plan and track retirement financials with Monestry","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/plan-and-track-retirement-financials-with-monestry"},"de":{"displayKey":"rente-planen-tracken-mit-monestry","title":"Rente planen und tracken mit Monestry","description":"Dies ist ein Platzhaltefr f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/rente-planen-tracken-mit-monestry"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1508672019048-805c876b67e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=entropy","thumb":"https://images.unsplash.com/photo-1508672019048-805c876b67e2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","manage-your-finances-with-app"]},{"id":"how-do-we-keep-your-financials-current","en":{"displayKey":"how-do-we-keep-your-financials-current","title":"Keeping your financials up to date","description":"Keeping the value of your assets up to date is no easy task. Here is how we do it for you at Monestry.","body":"At Monestry, the secure and efficient handling of your financial data is a cornerstone of our service. Here\'s a detailed look at our approach. \\n\\n### Seamless data import and security\\n\\nWe ensure that your financial data is brought into our app smoothly and securely. With automatic bank sync each time you open Monestry, your transaction data is always current. You can also manually upload transaction files or edit them directly in our user-friendly interface. Once imported, your data is encrypted and securely stored, accessible only to you.\\n\\n### Automatic updates for Banks and Brokerage Accounts\\n\\nA few years ago the EU passed a law called in short \\"PSD 2\\". That law makes it obligatory for all banks to provide a computer-to-computer services which licensed providers can call to receive user transaction data for their respective bank accounts. Naturally, those licensed providers must periodically ask you - the user - to confirm (\\"consent\\") that it is ok for them to do that on your behalf. \\n\\nSince that time several specialised companies emerged who made it their core business to help apps like Monestry access user bank data in a secure way. After a thorough analysis we have selected two leading European providers to simplify data-entry for our users. \\n\\n #### FinAPI\\n\\nEstablished in 2008 and licensed by BaFin, FinAPI is a Munich-based service provider excelling in payment and account information services. It accesses over 100 million bank accounts, handling more than 13 million requests daily. In 2019, FinAPI joined forces with SCHUFA Holding AG, a central player in Germany\'s financial system, enhancing its capability to navigate complex financial data.\\n\\n \u25B6 [German banks which can provide automated updates](/24-01-SupportedInstitutionsDE.xlsx) \\n\\n #### GoCardless\\n\\nA leading payment services company with headquarters in France and the UK, GoCardless is supervised by both ACPR and FCA. It caters to over 85,000 businesses across 30+ countries, processing over $35 billion in transactions annually. Licensed to facilitate transactions from more than 2300 banks in 31 countries, GoCardless expands our reach in providing you with a comprehensive financial overview. \\n\\n \u25B6 [Foreign banks which can provide automated updates](/24-01-SupportedInstitutionsForeign.xlsx) \\n\\n### Automatic updates for Real Estate Accounts\\n\\nSome of our packages offer automatic value updates for your real property assets in Germany. In this domain, several companies specialize in providing market value estimates for real properties. These are the same companies that banks consult during mortgage evaluations and that realtors use for property sales. Now, you too have access to their expertise. Every six months, we will obtain a new valuation for your property or properties, keeping you informed about their current market worth. \\n\\n #### Faireal\\n\\nOur partner Faireal GmbH, a Cologne-based company, has been serving banks and real estate companies in Germany since 2014. Faireal GmbH\'s property valuations are informed by a comprehensive dataset of over 20 million properties and actual transactions from more than 8000 real estate agents. This extensive database provides our users with highly accurate and reliable property valuations, akin to those used by industry professionals.\\n\\n### Automatic updates for exchange rates and quotes\\n\\n #### Exchange Rates\\n\\nFor our users engaged in global transactions or managing investments across currencies, Monestry provides daily updates on exchange rates. This feature is invaluable for those needing to navigate the complexities of international finance, whether it\'s for travel, overseas transactions, or managing a diverse investment portfolio.\\n\\n #### Bonds and Stocks Quotes\\n\\nInvestment enthusiasts will find Monestry\'s hourly updates on stock and bond prices particularly useful. While these updates aren\'t instantaneous, their frequency is sufficient for users to stay abreast of market trends and make informed decisions about their investments.\\n\\n### How current is our data?\\n\\n#### Deposits and stock transactions\\n\\n Updated every time the app starts or you sync data manually.\\n\\n#### Stock quotes\\n\\n History: close price of each day. Today: updated hourly (intraday).\\n\\n#### Exchange rates\\n\\n Updated daily (official ECB rates).\\n\\n#### Real estate valuations\\n\\n Refreshed every 6 month, based on current market data.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/how-do-we-keep-your-financials-current"},"de":{"displayKey":"wie-halten-wir-die-daten-aktuell","title":"Wie halten wir die Daten aktuell?","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"Bei Monestry ist die sichere und effiziente Verwaltung deiner Finanzdaten ein Grundpfeiler unseres Services. Hier ist ein detaillierter Einblick in unseren Ansatz.\\n\\n### Nahtloser Datenimport und Sicherheit\\n\\nWir stellen sicher, dass deine Finanzdaten reibungslos und sicher in unsere App \xfcbertragen werden. Mit automatischer Bank-Synchronisation jedes Mal, wenn du Monestry \xf6ffnest, sind deine Transaktionsdaten immer aktuell. Du kannst auch manuell Transaktionsdateien hochladen oder diese direkt in unserer benutzerfreundlichen Schnittstelle bearbeiten. Sobald importiert, werden deine Daten verschl\xfcsselt und sicher gespeichert, so dass nur du Zugriff darauf hast.\\n\\n### Automatische Aktualisierungen f\xfcr Banken und Brokerage-Konten\\n\\nVor einigen Jahren verabschiedete die EU ein Gesetz, kurz \u201EPSD 2\u201C genannt. Dieses Gesetz verpflichtet alle Banken, Computer-zu-Computer-Dienste anzubieten, die lizenzierte Anbieter anrufen k\xf6nnen, um Benutzertransaktionsdaten f\xfcr ihre jeweiligen Bankkonten zu erhalten. Nat\xfcrlich m\xfcssen diese lizenzierten Anbieter dich - den Nutzer - regelm\xe4\xdfig um Zustimmung (\u201EEinwilligung\u201C) bitten, dass es in Ordnung ist, wenn sie das in deinem Namen tun.\\n\\nSeitdem haben sich mehrere spezialisierte Unternehmen entwickelt, deren Hauptgesch\xe4ft es ist, Apps wie Monestry einen sicheren Zugang zu Benutzerbankdaten zu erm\xf6glichen. Nach einer gr\xfcndlichen Analyse haben wir zwei f\xfchrende europ\xe4ische Anbieter ausgew\xe4hlt, um die Dateneingabe f\xfcr unsere Nutzer zu vereinfachen.\\n\\n#### FinAPI\\n\\nGegr\xfcndet im Jahr 2008 und lizenziert von der BaFin, ist FinAPI ein in M\xfcnchen ans\xe4ssiger Dienstleister, der sich auf Zahlungs- und Kontoinformationsdienste spezialisiert hat. Es greift auf \xfcber 100 Millionen Bankkonten zu und bearbeitet t\xe4glich mehr als 13 Millionen Anfragen. Im Jahr 2019 schloss sich FinAPI mit der SCHUFA Holding AG zusammen, einem zentralen Akteur im deutschen Finanzsystem, um seine F\xe4higkeit zur Navigation in komplexen Finanzdaten zu verbessern. \\n\\n \u25B6 [Automatische Aktualisierungen - Liste der deutsche Banken](/24-01-SupportedInstitutionsDE.xlsx) \\n\\n#### GoCardless\\n\\nEin f\xfchrendes Zahlungsdienstleistungsunternehmen mit Hauptsitz in Frankreich und Gro\xdfbritannien, GoCardless wird sowohl von der ACPR als auch von der FCA beaufsichtigt. Es bedient \xfcber 85.000 Unternehmen in mehr als 30 L\xe4ndern und verarbeitet j\xe4hrlich \xfcber 35 Milliarden Dollar an Transaktionen. Es ist lizenziert, Transaktionen von mehr als 2300 Banken in 31 L\xe4ndern durchzuf\xfchren und erweitert unsere Reichweite, um dir einen umfassenden finanziellen \xdcberblick zu bieten. \\n\\n \u25B6 [Automatische Aktualisierungen - Liste der ausl\xe4ndische Banken](/24-01-SupportedInstitutionsForeign.xlsx) \\n\\n### Automatische Aktualisierungen f\xfcr Immobilienkonten\\n\\nEinige unserer Pakete bieten automatische Wertaktualisierungen f\xfcr deine Immobilienverm\xf6gen in Deutschland. In diesem Bereich spezialisieren sich mehrere Unternehmen auf die Bereitstellung von Marktwertsch\xe4tzungen f\xfcr Immobilien. Das sind die gleichen Unternehmen, die Banken bei der Bewertung von Hypothekenantr\xe4gen konsultieren und die Immobilienmakler f\xfcr den Verkauf von Immobilien nutzen. Jetzt hast auch du Zugang zu deren Expertise. Alle sechs Monate werden wir eine neue Bewertung f\xfcr deine Immobilie oder Immobilien einholen und dich \xfcber ihren aktuellen Marktwert informieren.\\n\\n#### Faireal\\n\\nUnser Partner Faireal GmbH, ein in K\xf6ln ans\xe4ssiges Unternehmen, bedient seit 2014 Banken und Immobilienunternehmen in Deutschland. Die Immobilienbewertungen von Faireal GmbH basieren auf einem umfassenden Datensatz von \xfcber 20 Millionen Immobilien und tats\xe4chlichen Transaktionen von mehr als 8000 Immobilienmaklern. Diese umfangreiche Datenbank bietet unseren Nutzern hochgenaue und zuverl\xe4ssige Immobilienbewertungen, vergleichbar mit denen von Branchenprofis.\\n\\n### Automatische Aktualisierungen f\xfcr Wechselkurse und Kurse\\n\\n #### Wechselkurse\\n\\nF\xfcr unsere Nutzer, die an globalen Transaktionen beteiligt sind oder Investitionen in verschiedenen W\xe4hrungen verwalten, bietet Monestry st\xfcndliche Aktualisierungen der Wechselkurse. Diese Funktion ist unverzichtbar f\xfcr dich, wenn du die Komplexit\xe4t des internationalen Finanzwesens meistern musst, sei es f\xfcr Reisen, Auslandstransaktionen oder die Verwaltung eines vielf\xe4ltigen Anlageportfolios.\\n\\n #### Anleihen- und Aktienkurse\\n\\nInvestitionsbegeisterte werden die st\xfcndlichen Aktualisierungen von Monestry zu Aktien- und Anleihepreisen besonders n\xfctzlich finden. Obwohl diese Updates nicht instant sind, ist ihre H\xe4ufigkeit ausreichend, damit du auf dem Laufenden \xfcber Markttrends bleibst und fundierte Entscheidungen \xfcber deine Investitionen treffen kannst. \\n\\n### Wie aktuell sind unsere Daten?\\n\\n#### Einlagen und Aktientransaktionen\\n\\n Aktualisierung bei jedem Start der App oder bei manueller Synchronisierung.\\n\\n#### Aktienkurse\\n\\n Historie: Schlusskurs jeden Tag. Heute: st\xfcndliche Aktualisierung (intraday).\\n\\n#### Wechselkurse\\n\\n T\xe4gliche Aktualisierung (offizielle EZB-Kurse).\\n\\n#### Immobilienbewertungen\\n\\n Aktualisierung alle 6 Monate, basierend auf aktuellen Marktdaten.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/wie-halten-wir-die-daten-aktuell"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top","thumb":"https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"},"relatedPosts":["use-finance-management-app-anonymously-monestry-and-its-anonymous-mode","security-at-monestry","data-privacy-at-monestry"]},{"id":"account-details","en":{"displayKey":"using-account-details-screen","title":"Account Details screen","description":"Keeping the value of your assets up to date is no easy task. Here is how we do it for you at Monestry.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/using-account-detail-screen"},"de":{"displayKey":"account-details-screen-nutzen","title":"Account Details Screen","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/accounts-details-screen-nutzen"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top","thumb":"https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"},"relatedPosts":["use-finance-management-app-anonymously-monestry-and-its-anonymous-mode","security-at-monestry","data-privacy-at-monestry"]},{"id":"reporting","en":{"displayKey":"using-reporting-screen","title":"Using Reports","description":"Keeping the value of your assets up to date is no easy task. Here is how we do it for you at Monestry.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/using-reporting-screen"},"de":{"displayKey":"reporting-screen-nutzen","title":"Reports nutzen","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/reporting-screen-nutzen"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=top","thumb":"https://images.unsplash.com/photo-1611095973763-414019e72400?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&crop=edges"},"relatedPosts":["use-finance-management-app-anonymously-monestry-and-its-anonymous-mode","security-at-monestry","data-privacy-at-monestry"]},{"id":"riester-rente-simply-explained","en":{"displayKey":"riester-rente-simply-explained","title":"Riester-Rente - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/riester-rente-simply-explained"},"de":{"displayKey":"riester-rente-einfach-erkl\xe4rt","title":"Riester Rente - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/riester-rente-einfach-erkl\xe4rt"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.1&crop=top","thumb":"https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["r\xfcrup-rente-simply-explained","stock-savings-plan-simply-explained","wealth-management-with-monestry"]},{"id":"r\xfcrup-rente-simply-explained","en":{"displayKey":"r\xfcrup-rente-simply-explained","title":"R\xfcrup-Rente - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/r\xfcrup-rente-simply-explained"},"de":{"displayKey":"r\xfcrup-rente-einfach-erkl\xe4rt","title":"R\xfcrup-Rente - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/r\xfcrup-rente-einfach-erkl\xe4rt"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1604156425963-9be03f86a428?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.3&crop=top","thumb":"https://images.unsplash.com/photo-1604156425963-9be03f86a428?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["riester-rente-simply-explained","stock-savings-plan-simply-explained","wealth-management-with-monestry"]},{"id":"etf-simply-explained","en":{"displayKey":"etf-r\xfcrup-rente-simply-explained","title":"ETFs - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/etf-simply-explained"},"de":{"displayKey":"etf-einfach-erkl\xe4rt","title":"ETFs - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/etf-einfach-erkl\xe4rt"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1583752028088-91e3e9880b46?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1583752028088-91e3e9880b46?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["multi-broker-apps-overview","stock-savings-plan-simply-explained","wealth-management-with-monestry"]},{"id":"shares-simply-explained","en":{"displayKey":"shares-simply-explained","title":"Shares - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/shares-simply-explained"},"de":{"displayKey":"aktien-einfach-erkl\xe4rt","title":"Aktien - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/aktien-einfach-erkl\xe4rt"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1618650551428-199e32d38059?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1618650551428-199e32d38059?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["multi-broker-apps-overview","etf-simply-explained","wealth-management-with-monestry"]},{"id":"stock-savings-plan-simply-explained","en":{"displayKey":"stock-savings-plan-simply-explained","title":"Stock savings plans - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/stock-savings-plan-simply-explained"},"de":{"displayKey":"sparplan-einfach-erkl\xe4rt","title":"Sparplan - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/sparplan-einfach-erkl\xe4r"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1633158829585-23ba8f7c8caf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["riester-rente-simply-explained","r\xfcrup-rente-simply-explained","wealth-management-with-monestry"]},{"id":"loans-simply-explained","en":{"displayKey":"loans-simply-explained","title":"Loans - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/loans-simply-explained"},"de":{"displayKey":"kredit-einfach-erkl\xe4rt","title":"Kredit - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/kredit-einfach-erkl\xe4rt"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","wealth-management-with-monestry"]},{"id":"pension-insurance-simply-explained","en":{"displayKey":"pension-insurance-simply-explained","title":"Pension insurance - simply explained.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/market-overview/pension-insurance-simply-explained"},"de":{"displayKey":"rentenversicherung-einfach-erkl\xe4rt","title":"Rentenversicherung - einfach erkl\xe4rt","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/markt\xfcbersicht/rentenversicherung-einfach-erkl\xe4rt"},"author":"Piotr Loboda","href":"#","category":{"key":"market-overview"},"image":{"article":"https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.17&crop=top","thumb":"https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["plan-and-track-retirement-financials-with-monestry","stock-savings-plan-simply-explained","wealth-management-with-monestry"]},{"id":"monestry-and-other-finance-management-applications-subjective-feature-comparison","en":{"displayKey":"monestry-and-other-finance-management-applications-subjective-feature-comparison","title":"Monestry and other finance management applications - a subjective feature comparison.","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/new-features/monestry-and-other-finance-management-applications-subjective-feature-comparison"},"de":{"displayKey":"monestry-andere-finanzmanagement-anwendungen-feature-vergleich-alternativen","title":"Monestry und andere Finanzmanagement-Anwendungen - ein subjektiver Feature-Vergleich.","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Welche Alternativen gibt es? \\n\\n Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/neue-features/monestry-andere-finanzmanagement-anwendungen-feature-vergleich-alternativen"},"author":"Piotr Loboda","href":"#","category":{"key":"new-features"},"image":{"article":"https://images.unsplash.com/photo-1513611771808-7e8ab7f1dec6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1513611771808-7e8ab7f1dec6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["wealth-management-with-monestry","do-you-really-need-banking-app-for-all-your-banks","multi-broker-apps-overview"]},{"id":"security-at-monestry","en":{"displayKey":"security-at-monestry","title":"Security at Monestry","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/new-features/security-at-monestry"},"de":{"displayKey":"sicherheit-bei-monestry","title":"Sicherheit bei Monestry","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Welche Alternativen gibt es? \\n\\n Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/neue-features/sicherheit-bei-monestry"},"author":"Piotr Loboda","href":"#","category":{"key":"new-features"},"image":{"article":"https://images.unsplash.com/photo-1582139329536-e7284fece509?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1582139329536-e7284fece509?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["data-privacy-at-monestry","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]},{"id":"data-privacy-at-monestry","en":{"displayKey":"data-privacy-at-monestry","title":"Data Privacy at Monestry","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet. \\n\\n Where we can do it automatically: banks, brokerage, some crypto, gold prices, real estate prices in Germany, unlisted companies.\\n\\n Should you choose to, you can update all the above manually as well by updating saldos or uploading transaction lists. \\n\\n Where updates are not available online, we make it simple to provide them manually: r\xfcrup / riester / insurance / betriebliche rente.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/new-features/data-privacy-at-monestry"},"de":{"displayKey":"datenschutz-bei-monestry","title":"Datenschutz bei Monestry","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Welche Alternativen gibt es? \\n\\n Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/neue-features/datenschutz-bei-monestry"},"author":"Piotr Loboda","href":"#","category":{"key":"new-features"},"image":{"article":"https://images.unsplash.com/photo-1634224152857-69c415153d4a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1634224152857-69c415153d4a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["security-at-monestry","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]},{"id":"manage-your-private-finances-with-app","hiddenFromBrowsing":true,"en":{"displayKey":"manage-your-private-finances-with-app","title":"Manage your private finances with an app","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/manage-your-private-finances-with-app"},"de":{"displayKey":"private-finanzen-richtig-mit-app-verwalten","title":"Private Finanzen richtig mit einer App verwalten","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/private-finanzen-richtig-mit-app-verwalten"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]},{"id":"manage-your-finances-better-with-app","hiddenFromBrowsing":true,"en":{"displayKey":"manage-your-finances-better-with-app","title":"Manage your finances better: with an app","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/manage-your-finances-better-with-app"},"de":{"displayKey":"eigene-finanzen-besser-mit-app-verwalten","title":"Eigene Finanzen besser mit einer App verwalten","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/anleitung/eigene-finanzen-besser-mit-app-verwalten"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]},{"id":"manage-your-private-finances-better-with-app","hiddenFromBrowsing":true,"en":{"displayKey":"manage-your-private-finances-better-with-app","title":"Manage your private finances better: with an app","description":"This is a placeholder for a future article.","body":"### Please come back at a later date. \\n\\n  This article is not available yet.","published":"March 04, 2022","datetime":"2022-03-04","readingTime":"6 Min","href":"/en/blog/guide/manage-your-private-finances-better-with-app"},"de":{"displayKey":"private-finanzen-besser-mit-app-verwalten","title":"Private Finanzen besser mit einer App verwalten","description":"Dies ist ein Platzhalter f\xfcr einen zuk\xfcnftigen Artikel.","body":"### Dieser Artikel ist noch nicht verf\xfcgbar. \\n\\n  Bitte besuche uns zu einem sp\xe4teren Zeitpunkt noch einmal.","published":"4. M\xe4rz 2022","datetime":"2020-03-04","readingTime":"6 Min","href":"/de/blog/guide/private-finanzen-besser-mit-app-verwalten"},"author":"Piotr Loboda","href":"#","category":{"key":"guide"},"image":{"article":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80&w=1&h=0.2&crop=edges","thumb":"https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"},"relatedPosts":["financial-planning-with-monestry-set-goals","financial-simulations-with-monestry-how-does-my-wealth-grow","use-finance-management-app-anonymously-monestry-and-its-anonymous-mode"]}]');



const $d34b747414d18dbe$var$STATIC_ASSET_FILENAMES = [
    "24-01-SupportedInstitutionsDE.xlsx",
    "24-01-SupportedInstitutionsForeign.xlsx",
    "logo_notagline.png",
    "logo_notagline_dark.png"
];
const $d34b747414d18dbe$var$replaceStaticLinks = (body)=>{
    if (!body) return body;
    return $d34b747414d18dbe$var$STATIC_ASSET_FILENAMES.reduce((acc, filename)=>{
        const pattern = new RegExp(`\\(/?${filename.replace(/\./g, "\\.")}\\)`, "g");
        return acc.replace(pattern, `(${(0, $cd7b47490a4d308b$export$beb10723d1b4d486)(filename)})`);
    }, body);
};
const $d34b747414d18dbe$var$posts = (0, (/*@__PURE__*/$parcel$interopDefault($6e4ed87a46fed97e$exports))).map((post)=>(0, $2qxEV._)((0, $9tqwB._)({}, post), {
        en: (0, $2qxEV._)((0, $9tqwB._)({}, post.en), {
            body: $d34b747414d18dbe$var$replaceStaticLinks(post.en.body)
        }),
        de: (0, $2qxEV._)((0, $9tqwB._)({}, post.de), {
            body: $d34b747414d18dbe$var$replaceStaticLinks(post.de.body)
        })
    }));
var $d34b747414d18dbe$export$2e2bcd8739ae039 = $d34b747414d18dbe$var$posts;



var $04989fb566a1d6e0$exports = {};
$04989fb566a1d6e0$exports = JSON.parse('[{"key":"blog","en":{"displayKey":"blog"},"de":{"displayKey":"blog"},"name":"{t(\'site:blog.title\')}","href":"#","subheader":"{t(\'site:blog.subtitle\')}","filter-visible":true},{"key":"guide","en":{"displayKey":"guide"},"de":{"displayKey":"anleitung"},"name":"{t(\'site:blog.guide.title\')}","href":"#","subheader":"{t(\'site:blog.guide.subtitle\')}","filter-visible":true},{"key":"new-features","en":{"displayKey":"new-features"},"de":{"displayKey":"neue-features"},"name":"{t(\'site:blog.new-features.title\')}","href":"#","subheader":"{t(\'site:blog.new-features.subtitle\')}","filter-visible":true},{"key":"point-of-view","en":{"displayKey":"point-of-view"},"de":{"displayKey":"standpunkte"},"name":"{t(\'site:blog.point-of-view.title\')}","href":"#","subheader":"{t(\'site:blog.point-of-views.subtitle\')}","filter-visible":true},{"key":"market-overview","en":{"displayKey":"market-overview"},"de":{"displayKey":"markt\xfcbersicht"},"name":"{t(\'site:blog.market-overview.title\')}","href":"#","subheader":"{t(\'site:blog.market-overview.subtitle\')}","filter-visible":true}]');



function $99f87ace30ad8515$export$25f4d58a6d16a7a5(categoryId, lng) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).find((c)=>c.key === categoryId)[lng].displayKey;
}
function $99f87ace30ad8515$export$ed2efc2636e0089e(articleId, lng) {
    const post = (0, $d34b747414d18dbe$export$2e2bcd8739ae039).find((p)=>p.id === articleId);
    return `${$99f87ace30ad8515$export$25f4d58a6d16a7a5(post.category.key, lng)}/${post[lng].displayKey}`;
}


function $4e9d517aec5d290d$export$2e2bcd8739ae039({ searchControl: searchControl, setSearchControl: setSearchControl, theme: theme }) {
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState("");
    let timer1;
    (0, $7fPBF.useEffect)(()=>{
        if (inputValue) {
            if (inputValue.length > 2) {
                // if this is another character entered within 800ms of the last one, cancel previous timer and set a new one
                // the searching property is already true (no need to modify state again, as it will trigger other renders)
                if ((searchControl === null || searchControl === void 0 ? void 0 : searchControl.searching) === false) setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
                    searching: true
                }));
                timer1 = setTimeout(()=>setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
                        text: inputValue
                    })), 800);
            } else setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
                text: inputValue
            }));
        }
        return ()=>{
            clearTimeout(timer1);
        };
    }, [
        inputValue
    ]);
    // blur should happen except when the user clicks within SearchResults
    // clicks within SearchResults are handled with MouseDown events instead of Click events, which do not fire blur here
    function handleOnBlur(e) {
        setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
            searching: false,
            text: ""
        }));
        setInputValue("");
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "pr-12 pl-12 xs:pl-44 md:px-12 lg:px-0",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "max-w-xs mx-auto w-full lg:max-w-lg",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                    htmlFor: "search",
                    className: "sr-only",
                    children: "Search"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: `relative ${theme === "light" ? "text-gray-400" : "text-white"} focus-within:text-gray-600`,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95165b7ebafa73cf$export$2e2bcd8739ae039), {
                                className: "h-5 w-5",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            id: "search",
                            className: `block w-full text-white bg-white bg-opacity-20 py-2 pl-10 pr-3 border ${theme === "light" ? "border-2 border-gray-300 focus:border-brandBlue-600" : "border-transparent focus:bg-opacity-100 focus:border-transparent"} rounded-md leading-5 focus:text-gray-900 placeholder-white focus:outline-none  focus:placeholder-gray-500 focus:ring-0 sm:text-sm`,
                            placeholder: "Search",
                            type: "search",
                            name: "search",
                            value: inputValue,
                            onBlur: handleOnBlur,
                            onChange: (e)=>setInputValue(e.target.value)
                        })
                    ]
                })
            ]
        })
    });
}
$4e9d517aec5d290d$export$2e2bcd8739ae039.propTypes = {
    searchControl: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setSearchControl: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$4e9d517aec5d290d$export$2e2bcd8739ae039.defaultProps = {
    theme: "dark"
};
function $4e9d517aec5d290d$var$removeMarkdownTags(str) {
    return str.replace(/!\[.*?\]\(.*?\)/g, "") // Remove images
    .replace(/\[.*?\]\(.*?\)/g, "") // Remove links
    .replace(/`.*?`/g, "") // Remove inline code
    .replace(/```[\s\S]*?```/g, "") // Remove code blocks
    .replace(/#+\s/g, "") // Remove headers
    .replace(/[*_]{1,2}(.*?)[*_]{1,2}/g, "$1") // Remove bold/italic
    .replace(/~~(.*?)~~/g, "$1") // Remove strikethrough
    .replace(/(\*\n|\*\s|\n)/g, ""); // Remove list items and new lines
}
function $4e9d517aec5d290d$export$aee53da69e9839be({ searchControl: searchControl, setSearchControl: setSearchControl, setAccount: setAccount, positionAdjustment: positionAdjustment }) {
    const [searchResults, setSearchResults] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([]);
    const [pagination, setPagination] = (0, $7fPBF.useState)({
        page: 0
    });
    const selectTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $3679aa7475d9bd44$export$6d68928c2b6ce1a6)(state));
    const selectAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $93bb2798871a68d2$export$8c577782bb016c47)(state));
    const isLoggedIn = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.isLoggedIn);
    const { text: text } = searchControl || "";
    // calculate search results
    // if text in searchControl.text appears, kick off search and upload results to local state
    (0, $7fPBF.useEffect)(()=>{
        async function asyncWrapper() {
            // if (text.length < 3) return;
            if (text.length < 3) {
                setSearchResults({});
                return;
            }
            // SEARCH TRANSACTIONS
            const resultsTransactions = new Promise((resolve, reject)=>{
                // return null if not logged in
                if (isLoggedIn) resolve(null);
                const result = selectTransactions.filter((transaction)=>{
                    // console.log('transaction', transaction);
                    // make a date searchable in a human-readable format
                    // create an array of search terms for each transaction
                    const searchTerms = [
                        (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(transaction.date).format("DD.MM.YYYY")
                    ];
                    // add category-specific search fields
                    if (transaction.category === "deposits") searchTerms.push(transaction.description, transaction.quantity * transaction.upbc, transaction.quantity * transaction.upac, transaction.otherParty, transaction.otherPartyAccount);
                    if (transaction.category === "stocks") searchTerms.push(transaction.displayName, transaction.displaySymbol, transaction.quantity, transaction.uptc);
                    // for real estate only accounts are searchable
                    // return true to filter if the searched term is found in any of the search terms
                    return searchTerms.some((term)=>String(term).toLowerCase().includes(String(text.toLowerCase())));
                });
                if (result.length === 0) {
                    setSearchResults((_param)=>{
                        var { transactions: transactions } = _param, rest = (0, $bLhVg._)(_param, [
                            "transactions"
                        ]);
                        return rest;
                    });
                    resolve(null);
                } else {
                    setSearchResults((0, $2qxEV._)((0, $9tqwB._)({}, searchResults), {
                        transactions: result
                    }));
                    resolve(null);
                }
            });
            // SEARCH ACCOUNTS
            const resultsAccounts = new Promise((resolve, reject)=>{
                // return null if not logged in
                if (isLoggedIn) resolve(null);
                const result = selectAccounts.filter((account)=>{
                    const searchTerms = [
                        account.name
                    ];
                    if (account.type === "real-estate") searchTerms.push(account.streetAddress, account.zip, account.country, account.city);
                    if (account.type === "stocks") searchTerms.push(account.brokerName, account.accountNo);
                    if (account.type === "deposits") searchTerms.push(account.iban, account.bic, account.bankName); // TODO: add syncType when translated
                    return searchTerms.some((term)=>String(term).toLowerCase().includes(String(text.toLowerCase())));
                });
                if (result.length === 0) {
                    setSearchResults((_param)=>{
                        var { accounts: accounts } = _param, rest = (0, $bLhVg._)(_param, [
                            "accounts"
                        ]);
                        return rest;
                    });
                    resolve(null);
                } else {
                    setSearchResults((0, $2qxEV._)((0, $9tqwB._)({}, searchResults), {
                        accounts: result
                    }));
                    resolve(result);
                }
            });
            // SEARCH BLOG POSTS
            const resultsBlog = new Promise((resolve, reject)=>{
                const reducedPosts = (0, $d34b747414d18dbe$export$2e2bcd8739ae039).map((post)=>({
                        id: post.id,
                        title: post[(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language].title,
                        datetime: post[(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language].datetime,
                        // remove markdown tags from body
                        body: $4e9d517aec5d290d$var$removeMarkdownTags(post[(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language].body)
                    }));
                const result = reducedPosts.filter((post)=>{
                    const searchTerms = [
                        post.title,
                        post.body,
                        post.datetime
                    ];
                    return searchTerms.some((term)=>String(term).toLowerCase().includes(String(text.toLowerCase())));
                });
                if (result.length === 0) {
                    setSearchResults((_param)=>{
                        var { blog: blog } = _param, rest = (0, $bLhVg._)(_param, [
                            "blog"
                        ]);
                        return rest;
                    });
                    resolve(null);
                } else {
                    setSearchResults((0, $2qxEV._)((0, $9tqwB._)({}, searchResults), {
                        blog: result
                    }));
                    resolve(result);
                }
            });
            await Promise.all([
                resultsTransactions,
                resultsAccounts,
                resultsBlog
            ]);
        }
        asyncWrapper();
    }, [
        searchControl.text
    ]);
    // to make sure the spinner goes away at the exact moment the results are ready:
    (0, $7fPBF.useEffect)(()=>{
        setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
            searching: false
        }));
    }, [
        searchResults
    ]);
    const topLevelDiv = (0, $7fPBF.useRef)();
    function handleOnMouseDown(e) {
        setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
            focus: "SearchResults"
        }));
    }
    function handleOnBlur(e) {
        if (searchControl.focus !== "SearchInput") setSearchControl((0, $2qxEV._)((0, $9tqwB._)({}, searchControl), {
            searching: false,
            text: ""
        }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `absolute z-50 ${positionAdjustment || "right-0 top-0"} w-full sm:max-w-5xl lg:w-[64rem] rounded-sm shadow border border-gray-400 bg-white p-4 md:mr-8`,
        // onMouseDown fires before onBlur on Input and lets us update focus state before the blur event checks it
        // then need to fire click event to make sure it acts normally for the user, see: https://stackoverflow.com/a/57630197/2540323
        onMouseDownCapture: handleOnMouseDown,
        onBlur: handleOnBlur,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "font-bold text-gray-900 text-lg",
                        children: "Search results"
                    }),
                    searchControl.searching && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 animate-spin"
                    })
                ]
            }),
            Object.entries(searchResults).map(([collection, results])=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4e9d517aec5d290d$var$SearchResultsSection, {
                    collection: collection,
                    results: results,
                    setAccount: setAccount
                }, collection)),
            searchControl.text.length <= 2 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-gray-500 italic",
                children: "Enter at least 2 characters to start search."
            }),
            searchControl.text.length > 2 && Object.keys(searchResults).length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-gray-500 italic",
                children: "Nothing found."
            })
        ]
    });
}
$4e9d517aec5d290d$export$aee53da69e9839be.propTypes = {
    searchControl: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setSearchControl: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    positionAdjustment: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$4e9d517aec5d290d$export$aee53da69e9839be.defaultProps = {
    setAccount: ()=>{},
    positionAdjustment: null
};
function $4e9d517aec5d290d$var$SearchResultsSection({ collection: collection, results: results, setAccount: setAccount }) {
    const [currentPage, setCurrentPage] = (0, $7fPBF.useState)(0);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const resultsPerPage = 5;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex gap-2 py-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "font-bold text-gray-700 text-sm uppercase tracking-wider py-2",
                        children: t(`app:schema.${collection}`)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
                        className: "isolate inline-flex -space-x-px",
                        "aria-label": "Pagination",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onMouseDown: (e)=>{
                                    e.preventDefault();
                                    if (currentPage > 0) setCurrentPage(currentPage - 1);
                                },
                                className: "relative inline-flex items-center py-0.5 px-1.5 group focus:z-20",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Previous"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee733d190e036d54$export$2e2bcd8739ae039), {
                                        className: `h-5 w-5 ${currentPage === 0 ? "text-gray-300" : "text-gray-500 group-hover:text-gray-900"}`,
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onMouseDown: (e)=>{
                                    e.preventDefault();
                                    if (currentPage < Math.floor(results.length / resultsPerPage)) setCurrentPage(currentPage + 1);
                                },
                                className: "relative inline-flex items-center py-0.5 px-1.5 text-sm font-medium text-gray-500 group focus:z-20",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "Next"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28c6eaf86f1a6031$export$2e2bcd8739ae039), {
                                        className: `h-5 w-5 ${currentPage === Math.floor(results.length / resultsPerPage) ? "text-gray-300" : "text-gray-500 group-hover:text-gray-900"}`,
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                className: "grid grid-cols-1 divide-y divide-gray-200",
                children: results.slice(0 + currentPage * resultsPerPage, resultsPerPage + currentPage * resultsPerPage).map((result)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4e9d517aec5d290d$var$SearchResultCard, {
                        result: result,
                        setAccount: setAccount,
                        currentCollection: collection
                    }, result.id))
            })
        ]
    });
}
$4e9d517aec5d290d$var$SearchResultsSection.propTypes = {
    collection: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    results: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $4e9d517aec5d290d$var$SearchResultCard({ result: result, setAccount: setAccount, currentCollection: currentCollection }) {
    const selectAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $93bb2798871a68d2$export$8c577782bb016c47)(state));
    function getAccountById(accountId) {
        return selectAccounts.find((account)=>account.id === accountId);
    }
    const [account, _] = (0, $7fPBF.useState)(getAccountById(result.accountId || result.id));
    function handleClick(e, obj) {
        // this has to handle both transactions and accounts only as blog posts are handled differently (in code)
        // it calls AccountDetails with the account object (slightly modified)
        const accountObject = (0, $2qxEV._)((0, $9tqwB._)({
            category: result.category
        }, account), {
            accountId: result.accountId || result.id
        });
        if (obj.accountId) accountObject.highlightTransactionId = result.id;
        setAccount(accountObject);
    }
    if (currentCollection === "transactions") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        id: result.id,
        type: "button",
        className: "col-span-1 px-2 py-1 bg-white hover:bg-gray-50",
        onMouseDown: (e)=>handleClick(e, result),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "w-full items-center grid grid-cols-5 space-x-3",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: `inline-block flex-shrink-0 px-2 py-0.5 text-xs font-medium ${(0, $134ab0040d88b150$export$205e6715f8ffaf7d)[account.category].color.bg} ${(0, $134ab0040d88b150$export$205e6715f8ffaf7d)[account.category].color.text}`,
                    children: account.name
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "truncate text-sm font-medium text-gray-900",
                    children: result.otherParty || result.displayName
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "truncate text-sm font-medium text-gray-900",
                    children: `${result.description || result.transactionType}`
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "truncate text-sm text-gray-500",
                    children: new Date(result.date).toLocaleDateString("de", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        timeZone: "UTC"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "truncate text-sm text-gray-500",
                    children: ((result === null || result === void 0 ? void 0 : result.accountCurrencyAmount) || (result === null || result === void 0 ? void 0 : result.transactionAmount) * (result === null || result === void 0 ? void 0 : result.transactionPrice)).toLocaleString("de", {
                        style: "currency",
                        currency: result.currency || "EUR",
                        maximumFractionDigits: 2
                    })
                })
            ]
        })
    }, result.id);
    if (currentCollection === "accounts") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        id: result.id,
        type: "button",
        className: "col-span-1 px-2 py-1 bg-white hover:bg-gray-50",
        onMouseDown: (e)=>handleClick(e, result),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "w-full items-center grid grid-cols-5 space-x-3",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: `inline-block flex-shrink-0 px-2 py-0.5 text-xs font-medium ${(0, $134ab0040d88b150$export$205e6715f8ffaf7d)[account.category].color.bg} ${(0, $134ab0040d88b150$export$205e6715f8ffaf7d)[account.category].color.text}`,
                    children: result.name
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "truncate text-sm font-medium text-gray-900",
                    children: result.bankName || result.brokerName || result.streetAddress
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "truncate text-sm font-medium text-gray-900",
                    children: result.iban || result.accountNo || result.city
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "truncate text-sm text-gray-500",
                    children: result.bic || result.country || ""
                })
            ]
        })
    }, result.id);
    if (currentCollection === "blog") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        id: result.id,
        type: "button",
        className: "col-span-1 px-2 py-1 bg-white hover:bg-gray-50",
        onMouseDown: ()=>{
            window.open(`/${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language}/blog/${(0, $99f87ace30ad8515$export$ed2efc2636e0089e)(result.id, (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language)}`, "_blank");
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "w-full items-center grid grid-cols-3 space-x-3",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "inline-block flex-shrink-0 px-2 py-0.5 text-xs font-bold text-gray-900",
                    children: "BLOG"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "col-span-2 truncate text-sm font-medium text-gray-900",
                    children: result.title
                })
            ]
        })
    }, result.id);
}
$4e9d517aec5d290d$var$SearchResultCard.propTypes = {
    result: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    currentCollection: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};




function $bfe0b5f94f2f66fb$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $bfe0b5f94f2f66fb$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [activeCategory, setActiveCategory] = (0, $7fPBF.useState)("blog"); // 'blog' means show all categories + filter
    const [searchControl, setSearchControl] = (0, $7fPBF.useState)({
        text: "",
        searching: false,
        focus: null
    }); // search results for the search bar;
    // implements "scroll to anchor" functionality
    (0, $7fPBF.useEffect)(()=>{
        const { hash: hash } = window.location;
        if (hash) {
            const element = document.getElementById(hash.slice(1));
            if (element) element.scrollIntoView();
        }
    }, []);
    function getCategoryDisplayKey(categoryKey) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).find((cat)=>cat.key === categoryKey)[i18n.language].displayKey;
    }
    function getCategoryKey(categoryDisplayKey) {
        // catch case where this is called before useEffect runs (when changing language)
        if (categoryDisplayKey) {
            const result = (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).find((cat)=>cat[i18n.language].displayKey === categoryDisplayKey);
            if (result) return result.key;
        }
        return null;
    }
    // if there exists url param after "blog/", then this is a category page, so set the appropriate state;
    // otherwise it is a main blog page and leave the initial value of 'blog'
    (0, $7fPBF.useEffect)(()=>{
        const newLocation = window.location.pathname;
        if (location.pathname !== newLocation) {
            console.log(`trying to go to ${newLocation}`);
            navigate(newLocation);
        } else if (params.cat) {
            // check if category exists -- if not, redirect to not found
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).some((cat)=>cat[i18n.language].displayKey === params.cat)) navigate(`/${i18n.language}/notfound`);
            setActiveCategory(getCategoryKey(params.cat));
        } else setActiveCategory("blog");
    }, [
        params.cat,
        i18n.language
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-28 lg:px-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute inset-0",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "bg-white h-1/3 sm:h-2/3"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative max-w-7xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative text-center mb-12",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-3xl tracking-tight font-black text-gray-900 sm:text-4xl",
                                children: t(`blog.categories.${getCategoryKey(params.cat) ? getCategoryKey(params.cat) : "blog"}.title`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-3 mb-6 max-w-4xl mx-auto text-xl text-gray-500 sm:mt-4",
                                children: t(`blog.categories.${getCategoryKey(params.cat) ? getCategoryKey(params.cat) : "blog"}.subtitle`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e9d517aec5d290d$export$2e2bcd8739ae039), {
                                searchControl: searchControl,
                                setSearchControl: setSearchControl,
                                theme: "light"
                            }),
                            searchControl.text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e9d517aec5d290d$export$aee53da69e9839be), {
                                searchControl: searchControl,
                                setSearchControl: setSearchControl,
                                positionAdjustment: "left-1/2 -translate-x-1/2 mt-4"
                            })
                        ]
                    }),
                    !params.cat ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "sm:hidden",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "tabs",
                                        className: "sr-only",
                                        children: "Select a category"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                        id: "tabs",
                                        name: "tabs",
                                        className: "block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md",
                                        defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).find((tab)=>tab.key === activeCategory).key,
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).map((tab)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                children: t(`site:blog.categories.${tab.key}.title`)
                                            }, tab.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "hidden sm:block",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
                                    className: "flex space-x-6 justify-center",
                                    "aria-label": "Tabs",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                            htmlFor: "tabs",
                                            className: "grid content-center",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "my-auto font-semibold text-base",
                                                    children: t("site:blog.filter-header")
                                                }),
                                                " "
                                            ]
                                        }),
                                        (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).map((tab)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                href: tab.href,
                                                className: $bfe0b5f94f2f66fb$var$classNames(tab.key === activeCategory ? "bg-brandBlue-100 text-brandBlue-600" : "text-gray-400 hover:text-gray-500", "px-3 py-2 font-semibold text-base rounded-md"),
                                                onClick: (e)=>setActiveCategory(tab.key),
                                                "aria-current": tab.current ? "page" : undefined,
                                                children: tab.key === "blog" ? t(`site:blog.categories.${tab.key}.filter-title`) : t(`site:blog.categories.${tab.key}.title`)
                                            }, tab.key))
                                    ]
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-6 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none",
                        children: (0, $d34b747414d18dbe$export$2e2bcd8739ae039).map((post)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                "data-testid": "blog-tile",
                                className: $bfe0b5f94f2f66fb$var$classNames((post.category.key === activeCategory || activeCategory === "blog") && !post.hiddenFromBrowsing ? null : "hidden", "flex flex-col rounded-lg shadow-lg overflow-hidden"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                    to: `/${i18n.language}/blog/${getCategoryDisplayKey(post.category.key)}/${post[i18n.language].displayKey}`,
                                    className: "block mt-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                className: "h-48 w-full object-cover",
                                                src: post.image.thumb,
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "text-sm font-semibold text-brandBlue-500 uppercase",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                            href: `/${i18n.language}/blog/${getCategoryDisplayKey(post.category.key)}/`,
                                                            className: "hover:underline",
                                                            children: t(`site:blog.categories.${post.category.key}.title`)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-1 text-xl font-semibold text-gray-900",
                                                        children: post[i18n.language].title
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-3 text-base text-gray-500",
                                                        children: post[i18n.language].description
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }, post.id))
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");



/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $7fPBF = parcelRequire("7fPBF");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $14586c46e77ba9fa$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $14586c46e77ba9fa$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $451965882c5a8799$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $451965882c5a8799$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $451965882c5a8799$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $451965882c5a8799$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $451965882c5a8799$var$point(point) {
    return $451965882c5a8799$var$index(point && point.line) + ":" + $451965882c5a8799$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $451965882c5a8799$var$position(pos) {
    return $451965882c5a8799$var$point(pos && pos.start) + "-" + $451965882c5a8799$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $451965882c5a8799$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $0aa9ed7423c10921$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $451965882c5a8799$export$c304dd45fe166145)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.file = "";
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.name = "";
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.reason = "";
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.message = "";
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.stack = "";
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.fatal = null;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.column = null;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.line = null;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.source = null;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ruleId = null;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $3f77da5648f21d15$export$bb654e07daaf8c3a = {
    basename: $3f77da5648f21d15$var$basename,
    dirname: $3f77da5648f21d15$var$dirname,
    extname: $3f77da5648f21d15$var$extname,
    join: $3f77da5648f21d15$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $3f77da5648f21d15$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $3f77da5648f21d15$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$dirname(path) {
    $3f77da5648f21d15$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $3f77da5648f21d15$var$extname(path) {
    $3f77da5648f21d15$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $3f77da5648f21d15$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $3f77da5648f21d15$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $3f77da5648f21d15$var$normalize(path) {
    $3f77da5648f21d15$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $3f77da5648f21d15$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $3f77da5648f21d15$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $3f77da5648f21d15$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $1faf6772e03c3c94$export$97a5aaf482767187 = {
    cwd: $1faf6772e03c3c94$var$cwd
};
function $1faf6772e03c3c94$var$cwd() {
    return "/";
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $95cef6ea1b5451c9$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $fefa7e5b02919ba3$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $95cef6ea1b5451c9$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $fefa7e5b02919ba3$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $fefa7e5b02919ba3$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $365ad175729fa366$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $365ad175729fa366$export$93dff69eb10dc7ce {
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $95cef6ea1b5451c9$export$8304a22d431f958)(path)) path = (0, $fefa7e5b02919ba3$export$9b2b676c902de799)(path);
        $365ad175729fa366$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $365ad175729fa366$var$assertPath(this.basename, "dirname");
        this.path = (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $365ad175729fa366$var$assertNonEmpty(basename, "basename");
        $365ad175729fa366$var$assertPart(basename, "basename");
        this.path = (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $365ad175729fa366$var$assertPart(extname, "extname");
        $365ad175729fa366$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $365ad175729fa366$var$assertNonEmpty(stem, "stem");
        $365ad175729fa366$var$assertPart(stem, "stem");
        this.path = (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $365ad175729fa366$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $95cef6ea1b5451c9$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $1faf6772e03c3c94$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $365ad175729fa366$var$order.length){
            const prop = $365ad175729fa366$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$365ad175729fa366$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $365ad175729fa366$var$assertPart(part, name) {
    if (part && part.includes((0, $3f77da5648f21d15$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $3f77da5648f21d15$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $365ad175729fa366$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $365ad175729fa366$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $365ad175729fa366$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($14586c46e77ba9fa$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $2fd75206f7b34a41$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $ce3b58bef1324512$exports = {};
"use strict";
var $ce3b58bef1324512$var$hasOwn = Object.prototype.hasOwnProperty;
var $ce3b58bef1324512$var$toStr = Object.prototype.toString;
var $ce3b58bef1324512$var$defineProperty = Object.defineProperty;
var $ce3b58bef1324512$var$gOPD = Object.getOwnPropertyDescriptor;
var $ce3b58bef1324512$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $ce3b58bef1324512$var$toStr.call(arr) === "[object Array]";
};
var $ce3b58bef1324512$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $ce3b58bef1324512$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $ce3b58bef1324512$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $ce3b58bef1324512$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $ce3b58bef1324512$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $ce3b58bef1324512$var$setProperty = function setProperty(target, options) {
    if ($ce3b58bef1324512$var$defineProperty && options.name === "__proto__") $ce3b58bef1324512$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $ce3b58bef1324512$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$ce3b58bef1324512$var$hasOwn.call(obj, name)) return void 0;
        else if ($ce3b58bef1324512$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $ce3b58bef1324512$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$ce3b58bef1324512$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $ce3b58bef1324512$var$getProperty(target, name);
            copy = $ce3b58bef1324512$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($ce3b58bef1324512$var$isPlainObject(copy) || (copyIsArray = $ce3b58bef1324512$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $ce3b58bef1324512$var$isArray(src) ? src : [];
                    } else clone = src && $ce3b58bef1324512$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $ce3b58bef1324512$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $ce3b58bef1324512$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $745e50693a2f80e0$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $8524fb273383fb8d$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $8524fb273383fb8d$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $8524fb273383fb8d$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $82354957eb1a51f9$export$7cc1b2fe10c52bb = $82354957eb1a51f9$var$base().freeze();
const $82354957eb1a51f9$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $82354957eb1a51f9$var$base() {
    const transformers = (0, $8524fb273383fb8d$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $82354957eb1a51f9$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $82354957eb1a51f9$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $82354957eb1a51f9$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $82354957eb1a51f9$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $82354957eb1a51f9$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $745e50693a2f80e0$export$2e2bcd8739ae039)(entry[1]) && (0, $745e50693a2f80e0$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($ce3b58bef1324512$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $82354957eb1a51f9$var$vfile(doc);
        const Parser = processor.Parser;
        $82354957eb1a51f9$var$assertParser("parse", Parser);
        if ($82354957eb1a51f9$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $82354957eb1a51f9$var$vfile(doc);
        const Compiler = processor.Compiler;
        $82354957eb1a51f9$var$assertCompiler("stringify", Compiler);
        $82354957eb1a51f9$var$assertNode(node);
        if ($82354957eb1a51f9$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $82354957eb1a51f9$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $82354957eb1a51f9$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $82354957eb1a51f9$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $2fd75206f7b34a41$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $82354957eb1a51f9$var$assertParser("process", processor.Parser);
        $82354957eb1a51f9$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $82354957eb1a51f9$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($82354957eb1a51f9$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $82354957eb1a51f9$var$assertParser("processSync", processor.Parser);
        $82354957eb1a51f9$var$assertCompiler("processSync", processor.Compiler);
        const file = $82354957eb1a51f9$var$vfile(doc);
        processor.process(file, done);
        $82354957eb1a51f9$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $2fd75206f7b34a41$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $82354957eb1a51f9$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($82354957eb1a51f9$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $82354957eb1a51f9$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($82354957eb1a51f9$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $82354957eb1a51f9$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $82354957eb1a51f9$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $82354957eb1a51f9$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $82354957eb1a51f9$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $745e50693a2f80e0$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $82354957eb1a51f9$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $82354957eb1a51f9$var$vfile(value) {
    return $82354957eb1a51f9$var$looksLikeAVFile(value) ? value : new (0, $365ad175729fa366$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $82354957eb1a51f9$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $82354957eb1a51f9$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($14586c46e77ba9fa$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $da74a7bb5b052f79$var$emptyOptions = {};
function $da74a7bb5b052f79$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $da74a7bb5b052f79$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml) {
    if ($da74a7bb5b052f79$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $da74a7bb5b052f79$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $da74a7bb5b052f79$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $da74a7bb5b052f79$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $da74a7bb5b052f79$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $da74a7bb5b052f79$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $6d957c9e6a169a49$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $6d957c9e6a169a49$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $6d957c9e6a169a49$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $1c4ab323543eb9b7$var$hasOwnProperty = {}.hasOwnProperty;
function $1c4ab323543eb9b7$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$1c4ab323543eb9b7$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $1c4ab323543eb9b7$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$1c4ab323543eb9b7$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $1c4ab323543eb9b7$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $1c4ab323543eb9b7$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(existing, 0, 0, before);
}
function $1c4ab323543eb9b7$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$1c4ab323543eb9b7$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $1c4ab323543eb9b7$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $1830f6c265bce764$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $9a96cd0c036af4eb$export$d65d6b62c24d5436 = $9a96cd0c036af4eb$var$regexCheck(/[A-Za-z]/);
const $9a96cd0c036af4eb$export$75c76db11865a9f4 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Za-z]/);
const $9a96cd0c036af4eb$export$4397998b34fe597d = $9a96cd0c036af4eb$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $9a96cd0c036af4eb$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e = $9a96cd0c036af4eb$var$regexCheck(/\d/);
const $9a96cd0c036af4eb$export$eca2752363989806 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Fa-f]/);
const $9a96cd0c036af4eb$export$35794a7d1db99380 = $9a96cd0c036af4eb$var$regexCheck(/[!-/:-@[-`{-~]/);
function $9a96cd0c036af4eb$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $9a96cd0c036af4eb$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $9a96cd0c036af4eb$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $9a96cd0c036af4eb$export$aa04114dd888a7a0 = $9a96cd0c036af4eb$var$regexCheck((0, $1830f6c265bce764$export$85b5101f24802e8c));
const $9a96cd0c036af4eb$export$a0ff789c034ffdf4 = $9a96cd0c036af4eb$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $9a96cd0c036af4eb$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $a27bcbb6afb3eadb$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $145b6cb5bda265c1$export$a7db06668cad9adb = {
    tokenize: $145b6cb5bda265c1$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $145b6cb5bda265c1$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $3d8796971204dffa$export$5a7bfc01df82fcd1 = {
    tokenize: $3d8796971204dffa$var$initializeDocument
};
/** @type {Construct} */ const $3d8796971204dffa$var$containerConstruct = {
    tokenize: $3d8796971204dffa$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $3d8796971204dffa$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($3d8796971204dffa$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($3d8796971204dffa$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3d8796971204dffa$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $30b85425f5f538a1$export$d50d28ce3ab2a612 = {
    tokenize: $30b85425f5f538a1$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $30b85425f5f538a1$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $7901602e44e77495$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $7901602e44e77495$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $6d957c9e6a169a49$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $7901602e44e77495$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $6d957c9e6a169a49$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $728ee34a4e233cee$export$a7db06668cad9adb = {
    tokenize: $728ee34a4e233cee$var$tokenizeContent,
    resolve: $728ee34a4e233cee$var$resolveContent
};
/** @type {Construct} */ const $728ee34a4e233cee$var$continuationConstruct = {
    tokenize: $728ee34a4e233cee$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $728ee34a4e233cee$var$resolveContent(events) {
    (0, $7901602e44e77495$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($728ee34a4e233cee$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $4320be06d95fd4d0$export$ccc7b0636abaffc3 = {
    tokenize: $4320be06d95fd4d0$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $4320be06d95fd4d0$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $30b85425f5f538a1$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $728ee34a4e233cee$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $009f2a13a0d178f2$export$50397835cbfdbc24 = {
    resolveAll: $009f2a13a0d178f2$var$createResolver()
};
const $009f2a13a0d178f2$export$22b082955e083ec3 = $009f2a13a0d178f2$var$initializeFactory("string");
const $009f2a13a0d178f2$export$6f093cfa640b7166 = $009f2a13a0d178f2$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $009f2a13a0d178f2$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $009f2a13a0d178f2$var$createResolver(field === "text" ? $009f2a13a0d178f2$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $009f2a13a0d178f2$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $009f2a13a0d178f2$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $a0bda62677f8e9a6$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $e090088a8e1afd2b$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $e090088a8e1afd2b$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $e090088a8e1afd2b$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $6d957c9e6a169a49$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $e090088a8e1afd2b$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $e090088a8e1afd2b$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $f81d41200564ef26$exports = {};

$parcel$export($f81d41200564ef26$exports, "document", function () { return $f81d41200564ef26$export$5a7bfc01df82fcd1; });
$parcel$export($f81d41200564ef26$exports, "contentInitial", function () { return $f81d41200564ef26$export$5a2181fb44b58173; });
$parcel$export($f81d41200564ef26$exports, "flowInitial", function () { return $f81d41200564ef26$export$cf8bead395eff824; });
$parcel$export($f81d41200564ef26$exports, "flow", function () { return $f81d41200564ef26$export$ccc7b0636abaffc3; });
$parcel$export($f81d41200564ef26$exports, "string", function () { return $f81d41200564ef26$export$22b082955e083ec3; });
$parcel$export($f81d41200564ef26$exports, "text", function () { return $f81d41200564ef26$export$6f093cfa640b7166; });
$parcel$export($f81d41200564ef26$exports, "insideSpan", function () { return $f81d41200564ef26$export$d44f260a3f9b69f5; });
$parcel$export($f81d41200564ef26$exports, "attentionMarkers", function () { return $f81d41200564ef26$export$b9c0b60d74426aea; });
$parcel$export($f81d41200564ef26$exports, "disable", function () { return $f81d41200564ef26$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) return 2;
}



const $ea09a4790e991212$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $ea09a4790e991212$var$tokenizeAttention,
    resolveAll: $ea09a4790e991212$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $ea09a4790e991212$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $ea09a4790e991212$var$movePoint(start, -use);
            $ea09a4790e991212$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ea09a4790e991212$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $ea09a4790e991212$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $5d74961dcf69642f$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $5d74961dcf69642f$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5d74961dcf69642f$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $9a96cd0c036af4eb$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $5b7191973b2dcb30$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation
    },
    exit: $5b7191973b2dcb30$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($5b7191973b2dcb30$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $5b7191973b2dcb30$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $be85b25963329d93$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $be85b25963329d93$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $be85b25963329d93$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $9a96cd0c036af4eb$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $270c29272498566f$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


const $5c440430e98322bd$var$own = {}.hasOwnProperty;
function $5c440430e98322bd$export$289b6a6320f709b4(value) {
    return $5c440430e98322bd$var$own.call((0, $270c29272498566f$export$ec810d1aafce79a7), value) ? (0, $270c29272498566f$export$ec810d1aafce79a7)[value] : false;
}



const $3f5b13d75c9b46b1$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $3f5b13d75c9b46b1$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3f5b13d75c9b46b1$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $9a96cd0c036af4eb$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $9a96cd0c036af4eb$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $9a96cd0c036af4eb$export$75c76db11865a9f4) && !(0, $5c440430e98322bd$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $834069fabf19784a$var$nonLazyContinuation = {
    tokenize: $834069fabf19784a$var$tokenizeNonLazyContinuation,
    partial: true
};
const $834069fabf19784a$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $834069fabf19784a$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $7dbe9fe18b3b23b2$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $7dbe9fe18b3b23b2$var$furtherStart = {
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.attempt($7dbe9fe18b3b23b2$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $23d5e8c756b561fa$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $23d5e8c756b561fa$var$tokenizeCodeText,
    resolve: $23d5e8c756b561fa$var$resolveCodeText,
    previous: $23d5e8c756b561fa$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $23d5e8c756b561fa$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $23d5e8c756b561fa$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $23d5e8c756b561fa$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $a5b0165eceaa5b2a$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $5b1b1349c9302e3d$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $3b751ecfea53c49c$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $65f43375f77b595c$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $c580fc709a668807$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $03db4060f53ac021$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $03db4060f53ac021$var$tokenizeDefinition
};
/** @type {Construct} */ const $03db4060f53ac021$var$titleBefore = {
    tokenize: $03db4060f53ac021$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($03db4060f53ac021$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $2db70170e88ebee0$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $2db70170e88ebee0$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2db70170e88ebee0$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $83113747934b3ae6$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $83113747934b3ae6$var$tokenizeHeadingAtx,
    resolve: $83113747934b3ae6$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $83113747934b3ae6$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $6d957c9e6a169a49$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $83113747934b3ae6$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $b9e56abd53b703db$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $b9e56abd53b703db$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $bc2cbab316b16c92$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $bc2cbab316b16c92$var$tokenizeHtmlFlow,
    resolveTo: $bc2cbab316b16c92$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $bc2cbab316b16c92$var$blankLineBefore = {
    tokenize: $bc2cbab316b16c92$var$tokenizeBlankLineBefore,
    partial: true
};
const $bc2cbab316b16c92$var$nonLazyContinuationStart = {
    tokenize: $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $bc2cbab316b16c92$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $b9e56abd53b703db$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($bc2cbab316b16c92$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($bc2cbab316b16c92$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $d4159befe711bc18$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $d4159befe711bc18$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d4159befe711bc18$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $2761660aaca3721f$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $2761660aaca3721f$var$tokenizeLabelEnd,
    resolveTo: $2761660aaca3721f$var$resolveToLabelEnd,
    resolveAll: $2761660aaca3721f$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $2761660aaca3721f$var$resourceConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeResource
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceFullConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceCollapsedConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($2761660aaca3721f$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($2761660aaca3721f$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($2761660aaca3721f$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $39595bc63cd49799$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $39595bc63cd49799$var$tokenizeLabelStartImage,
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $39595bc63cd49799$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $036fa9de6a4e2994$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $036fa9de6a4e2994$var$tokenizeLabelStartLink,
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $036fa9de6a4e2994$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $309179153cfedf16$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $309179153cfedf16$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $309179153cfedf16$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $e46429feccf3186d$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $e46429feccf3186d$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e46429feccf3186d$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $3c31a37b3e3d082a$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $3c31a37b3e3d082a$var$tokenizeListStart,
    continuation: {
        tokenize: $3c31a37b3e3d082a$var$tokenizeListContinuation
    },
    exit: $3c31a37b3e3d082a$var$tokenizeListEnd
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$indentConstruct = {
    tokenize: $3c31a37b3e3d082a$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $3c31a37b3e3d082a$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $e46429feccf3186d$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $3c31a37b3e3d082a$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($3c31a37b3e3d082a$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt($3c31a37b3e3d082a$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $3c31a37b3e3d082a$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $3c31a37b3e3d082a$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $151c8a7318d441a4$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $151c8a7318d441a4$var$tokenizeSetextUnderline,
    resolveTo: $151c8a7318d441a4$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $151c8a7318d441a4$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $151c8a7318d441a4$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $f81d41200564ef26$export$5a7bfc01df82fcd1 = {
    [42]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [43]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [45]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [48]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [49]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [50]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [51]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [52]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [53]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [54]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [55]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [56]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [57]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [62]: (0, $5b7191973b2dcb30$export$200dcd0a5903c968)
};
const $f81d41200564ef26$export$5a2181fb44b58173 = {
    [91]: (0, $03db4060f53ac021$export$69f215ed977cdb73)
};
const $f81d41200564ef26$export$cf8bead395eff824 = {
    [-2]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [-1]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [32]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853)
};
const $f81d41200564ef26$export$ccc7b0636abaffc3 = {
    [35]: (0, $83113747934b3ae6$export$3871e9deb360695c),
    [42]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [45]: [
        (0, $151c8a7318d441a4$export$e104e2de391dfde9),
        (0, $e46429feccf3186d$export$ba7b13e047416c03)
    ],
    [60]: (0, $bc2cbab316b16c92$export$476ac411cb7d0d8f),
    [61]: (0, $151c8a7318d441a4$export$e104e2de391dfde9),
    [95]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [96]: (0, $834069fabf19784a$export$c23e4921f8d87e7c),
    [126]: (0, $834069fabf19784a$export$c23e4921f8d87e7c)
};
const $f81d41200564ef26$export$22b082955e083ec3 = {
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [92]: (0, $be85b25963329d93$export$2005478564e78d96)
};
const $f81d41200564ef26$export$6f093cfa640b7166 = {
    [-5]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-4]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-3]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [33]: (0, $39595bc63cd49799$export$3d754936e25aa5f5),
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [42]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [60]: [
        (0, $5d74961dcf69642f$export$17ddf85e4c916ad6),
        (0, $d4159befe711bc18$export$398af27f284914fe)
    ],
    [91]: (0, $036fa9de6a4e2994$export$5c0cee0701a3b584),
    [92]: [
        (0, $2db70170e88ebee0$export$86c573ab9e06f418),
        (0, $be85b25963329d93$export$2005478564e78d96)
    ],
    [93]: (0, $2761660aaca3721f$export$470a5dafbbf62654),
    [95]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [96]: (0, $23d5e8c756b561fa$export$d24f93e715f9df88)
};
const $f81d41200564ef26$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ea09a4790e991212$export$45b92471da762af7),
        (0, $009f2a13a0d178f2$export$50397835cbfdbc24)
    ]
};
const $f81d41200564ef26$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $f81d41200564ef26$export$e20fbacbb41798b = {
    null: []
};


function $9dfba146f4c3c794$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $1c4ab323543eb9b7$export$86a865d89ef3c690)([
        $f81d41200564ef26$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $145b6cb5bda265c1$export$a7db06668cad9adb)),
        document: create((0, $3d8796971204dffa$export$5a7bfc01df82fcd1)),
        flow: create((0, $4320be06d95fd4d0$export$ccc7b0636abaffc3)),
        string: create((0, $009f2a13a0d178f2$export$22b082955e083ec3)),
        text: create((0, $009f2a13a0d178f2$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $e090088a8e1afd2b$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $2dbc8c8d3cee1d06$var$search = /[\0\t\n\r]/g;
function $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $2dbc8c8d3cee1d06$var$search.lastIndex = startPosition;
            match = $2dbc8c8d3cee1d06$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $faf817751c9db3c6$export$bd0e6e1378a871d7(events) {
    while(!(0, $7901602e44e77495$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $a72b41c19fbe228c$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}




const $516ec3b0ba9da2c8$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $516ec3b0ba9da2c8$export$a0fb664af7d0cc44(value) {
    return value.replace($516ec3b0ba9da2c8$var$characterEscapeOrReference, $516ec3b0ba9da2c8$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $516ec3b0ba9da2c8$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $a72b41c19fbe228c$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $5c440430e98322bd$export$289b6a6320f709b4)($2) || $0;
}





const $dc140a31dd8ab4b3$var$own = {}.hasOwnProperty;
const $dc140a31dd8ab4b3$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $dc140a31dd8ab4b3$var$compiler(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $dc140a31dd8ab4b3$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $dc140a31dd8ab4b3$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($dc140a31dd8ab4b3$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $dc140a31dd8ab4b3$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $dc140a31dd8ab4b3$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $451965882c5a8799$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $dc140a31dd8ab4b3$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $dc140a31dd8ab4b3$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $dc140a31dd8ab4b3$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $516ec3b0ba9da2c8$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $a72b41c19fbe228c$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $5c440430e98322bd$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $dc140a31dd8ab4b3$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $dc140a31dd8ab4b3$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $dc140a31dd8ab4b3$var$configure(combined, value);
        else $dc140a31dd8ab4b3$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $dc140a31dd8ab4b3$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($dc140a31dd8ab4b3$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $dc140a31dd8ab4b3$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $4f339a22525673d0$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $dc140a31dd8ab4b3$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $1730a6ab3d7ab9f0$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $1730a6ab3d7ab9f0$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $1730a6ab3d7ab9f0$var$characterReferences[value] + ";";
    }
}


function $b82d09afb4bbc7a9$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)($b82d09afb4bbc7a9$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $b82d09afb4bbc7a9$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}


function $5f8ac0136b7180f6$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: (0, $2qxEV._)((0, $9tqwB._)({}, JSON.parse(JSON.stringify(state.footnoteLabelProperties))), {
                    id: "footnote-label"
                }),
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $312c10cea7b70433$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $312c10cea7b70433$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $312c10cea7b70433$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $312c10cea7b70433$var$ok;
    if (typeof test === "string") return $312c10cea7b70433$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $312c10cea7b70433$var$anyFactory(test) : $312c10cea7b70433$var$propsFactory(test);
    if (typeof test === "function") return $312c10cea7b70433$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $312c10cea7b70433$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $312c10cea7b70433$export$9c68d69a4c5bbcf9(tests[index]);
    return $312c10cea7b70433$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $312c10cea7b70433$var$propsFactory(check) {
    return $312c10cea7b70433$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $312c10cea7b70433$var$typeFactory(check) {
    return $312c10cea7b70433$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $312c10cea7b70433$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $312c10cea7b70433$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $957be220cd5cf928$export$35e9368ef982300f(d) {
    return d;
}


const $9ef2eaca0b34953c$export$f4d8133c446fe484 = true;
const $9ef2eaca0b34953c$export$7f100f842f565dc9 = false;
const $9ef2eaca0b34953c$export$8773f85c2fb2c116 = "skip";
const $9ef2eaca0b34953c$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $957be220cd5cf928$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $9ef2eaca0b34953c$var$toResult(visitor(node, parents));
                if (result[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $9ef2eaca0b34953c$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $9ef2eaca0b34953c$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $9ef2eaca0b34953c$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $2ca43c18c27b56fa$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $9861e7b4f8df2806$export$771bf3e4949bfbee = $9861e7b4f8df2806$var$point("start");
const $9861e7b4f8df2806$export$da309cdce9dc2a25 = $9861e7b4f8df2806$var$point("end");
function $9861e7b4f8df2806$export$5880b8b5730aff45(node) {
    return {
        start: $9861e7b4f8df2806$export$771bf3e4949bfbee(node),
        end: $9861e7b4f8df2806$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $9861e7b4f8df2806$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $acf013c8ec81ac00$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $e939b20817da3b4f$var$own = {}.hasOwnProperty;
function $e939b20817da3b4f$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, "definition", (definition)=>{
        const id = $e939b20817da3b4f$var$clean(definition.identifier);
        if (id && !$e939b20817da3b4f$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $e939b20817da3b4f$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $e939b20817da3b4f$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $e939b20817da3b4f$var$clean(value) {
    return String(value || "").toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2009e735e4920922$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $caf09a68931aae43$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b5c217a518855008$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9739c1e1cf800b5e$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c0bba787c55d4212$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $5af8976c830555c1$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $be43365ab98ed9af$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $5af8976c830555c1$export$7f87ee744075c1ba)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9b6df163a26bd000$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $f59721a0d8aa9c1f$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $adeec68f555ea12e$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $b377321b20712ea8$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $adeec68f555ea12e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $2bb84a02d2957974$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $772ddadd8e054087$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $63d9a7473ae80c48$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $adeec68f555ea12e$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $a668870950e44a11$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $b82d09afb4bbc7a9$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $eb748566f942a1fa$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $eb748566f942a1fa$var$listLoose(parent) : $eb748566f942a1fa$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $eb748566f942a1fa$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $eb748566f942a1fa$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $eb748566f942a1fa$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7581156d9e04fe28$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $20fbb56018958335$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $2af4be4c3af73f2b$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8df89fc7fe3cfe9c$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $9257848335846de3$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $06793005ec3da281$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6181448ff3679c4d$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $012eac5e07020bbc$var$tab = 9 /* `\t` */ ;
const $012eac5e07020bbc$var$space = 32 /* ` ` */ ;
function $012eac5e07020bbc$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($012eac5e07020bbc$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($012eac5e07020bbc$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $012eac5e07020bbc$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $012eac5e07020bbc$var$tab || code === $012eac5e07020bbc$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $012eac5e07020bbc$var$tab || code === $012eac5e07020bbc$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $32a26ed6da9265ed$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $012eac5e07020bbc$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $eb5ff7d2182720ae$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $e276fa0624fad11d$export$455ce229eb3d2472 = {
    blockquote: $2009e735e4920922$export$67dc04e652a298ca,
    break: (0, $caf09a68931aae43$export$371da9dd35aba193),
    code: $b5c217a518855008$export$6565f9f03506010b,
    delete: (0, $9739c1e1cf800b5e$export$19426ff118fe8be),
    emphasis: $c0bba787c55d4212$export$bef81ba411953b51,
    footnoteReference: $5af8976c830555c1$export$7f87ee744075c1ba,
    footnote: $be43365ab98ed9af$export$3b6a720baa2c20ec,
    heading: $9b6df163a26bd000$export$46e4a324ac90507f,
    html: $f59721a0d8aa9c1f$export$c0bb0b647f701bb5,
    imageReference: $b377321b20712ea8$export$f281796f6bc3b8db,
    image: $2bb84a02d2957974$export$5c452ff88e35e47d,
    inlineCode: $772ddadd8e054087$export$91b9bee19a0d8569,
    linkReference: $63d9a7473ae80c48$export$e6c469b1b7b2bc6a,
    link: $a668870950e44a11$export$9c30223ca0a664fb,
    listItem: $eb748566f942a1fa$export$76c7e83ecc9cdf05,
    list: $7581156d9e04fe28$export$8837f4fc672e936d,
    paragraph: $20fbb56018958335$export$9c206ddddb32a9b,
    root: $2af4be4c3af73f2b$export$e8e78c978b129247,
    strong: $8df89fc7fe3cfe9c$export$59ae2c325a998f89,
    table: $9257848335846de3$export$9852986a3ec5f6a0,
    tableCell: $6181448ff3679c4d$export$e1e720e5f4603e6a,
    tableRow: $06793005ec3da281$export$ce666bf02318c957,
    text: $32a26ed6da9265ed$export$6f093cfa640b7166,
    thematicBreak: $eb5ff7d2182720ae$export$ba7b13e047416c03,
    toml: $e276fa0624fad11d$var$ignore,
    yaml: $e276fa0624fad11d$var$ignore,
    definition: $e276fa0624fad11d$var$ignore,
    footnoteDefinition: $e276fa0624fad11d$var$ignore
};
// Return nothing for nodes that are ignored.
function $e276fa0624fad11d$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $e7336a21b70de7b0$var$own = {}.hasOwnProperty;
function $e7336a21b70de7b0$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = (0, $9tqwB._)({}, (0, $e276fa0624fad11d$export$455ce229eb3d2472), settings.handlers);
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $e939b20817da3b4f$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $e7336a21b70de7b0$var$patch;
    state.applyData = $e7336a21b70de7b0$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $e7336a21b70de7b0$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$e7336a21b70de7b0$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = (0, $9tqwB._)({}, right.properties, data.hProperties);
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $acf013c8ec81ac00$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $9861e7b4f8df2806$export$771bf3e4949bfbee)(ctx),
                end: (0, $9861e7b4f8df2806$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $e7336a21b70de7b0$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $e7336a21b70de7b0$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $e7336a21b70de7b0$var$patch(from, to) {
    if (from.position) to.position = (0, $9861e7b4f8df2806$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $e7336a21b70de7b0$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = (0, $9tqwB._)({}, result.properties, hProperties);
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $e7336a21b70de7b0$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($e7336a21b70de7b0$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? (0, $2qxEV._)((0, $9tqwB._)({}, node), {
        children: $e7336a21b70de7b0$export$84bf76cd7afc7469(state, node)
    }) : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $e7336a21b70de7b0$var$defaultUnknownHandler(state, node);
}
function $e7336a21b70de7b0$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $e7336a21b70de7b0$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $e7336a21b70de7b0$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($e7336a21b70de7b0$var$own.call(data, "hProperties") || $e7336a21b70de7b0$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $e7336a21b70de7b0$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $e7336a21b70de7b0$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}


function $43774b39a057500d$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $e7336a21b70de7b0$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $5f8ac0136b7180f6$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $74ce0141155f6a3a$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $74ce0141155f6a3a$var$bridge(destination, options) : $74ce0141155f6a3a$var$mutate(destination || options);
};
var $74ce0141155f6a3a$export$2e2bcd8739ae039 = $74ce0141155f6a3a$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $74ce0141155f6a3a$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $43774b39a057500d$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $74ce0141155f6a3a$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $43774b39a057500d$export$c0e4c5cf07538633)(node, options);
}



var $2oXYc = parcelRequire("2oXYc");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $3f644418d59ec988$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $3f644418d59ec988$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $3f644418d59ec988$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $3f644418d59ec988$export$19342e026b58ebb7.prototype.space = null;


function $f22be46171b10c63$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $3f644418d59ec988$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $e193cc6bfb75f539$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $f5a64e1dc26e2922$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.space = null;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.boolean = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.booleanish = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.number = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$f5a64e1dc26e2922$export$c4868e4a24d48fad.prototype.defined = false;


var $6327116045afe73c$exports = {};

$parcel$export($6327116045afe73c$exports, "boolean", function () { return $6327116045afe73c$export$4a21f16c33752377; });
$parcel$export($6327116045afe73c$exports, "booleanish", function () { return $6327116045afe73c$export$55e9e1fbc638dc8f; });
$parcel$export($6327116045afe73c$exports, "overloadedBoolean", function () { return $6327116045afe73c$export$242ac3d3042558aa; });
$parcel$export($6327116045afe73c$exports, "number", function () { return $6327116045afe73c$export$98e628dec113755e; });
$parcel$export($6327116045afe73c$exports, "spaceSeparated", function () { return $6327116045afe73c$export$ab8645c862eb5a3e; });
$parcel$export($6327116045afe73c$exports, "commaSeparated", function () { return $6327116045afe73c$export$9c8d678629b3d3; });
$parcel$export($6327116045afe73c$exports, "commaOrSpaceSeparated", function () { return $6327116045afe73c$export$2ad25cfebf36cacd; });
let $6327116045afe73c$var$powers = 0;
const $6327116045afe73c$export$4a21f16c33752377 = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$55e9e1fbc638dc8f = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$242ac3d3042558aa = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$98e628dec113755e = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$ab8645c862eb5a3e = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$9c8d678629b3d3 = $6327116045afe73c$var$increment();
const $6327116045afe73c$export$2ad25cfebf36cacd = $6327116045afe73c$var$increment();
function $6327116045afe73c$var$increment() {
    return 2 ** ++$6327116045afe73c$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $e9abde33d3611e8d$var$checks = Object.keys($6327116045afe73c$exports);
class $e9abde33d3611e8d$export$ea6b9f0064e88c9b extends (0, $f5a64e1dc26e2922$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $e9abde33d3611e8d$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $e9abde33d3611e8d$var$checks.length){
            const check = $e9abde33d3611e8d$var$checks[index];
            $e9abde33d3611e8d$var$mark(this, $e9abde33d3611e8d$var$checks[index], (mask & $6327116045afe73c$exports[check]) === $6327116045afe73c$exports[check]);
        }
    }
}
$e9abde33d3611e8d$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $e9abde33d3611e8d$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $9241b59662c8e4b9$var$own = {}.hasOwnProperty;
function $9241b59662c8e4b9$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($9241b59662c8e4b9$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $e9abde33d3611e8d$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $e193cc6bfb75f539$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $e193cc6bfb75f539$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $3f644418d59ec988$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $f7b1fe9153b66aca$export$2bd1230ec7600845 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $2258d34ea2045e6e$export$f2913fe8983302e = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $57102789fbb4388b$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $f66392ca00ae8b5e$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $57102789fbb4388b$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $d677600be62c9ee2$export$e20c24a128671213 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $f66392ca00ae8b5e$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $f6c2d7ac952f45ea$export$4d2d26490572750a = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaColIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaColSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaControls: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaPressed: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaRowIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaRowSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaSelected: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueMin: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueNow: (0, $6327116045afe73c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $aed0b684443ef64e$export$c0bb0b647f701bb5 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $f66392ca00ae8b5e$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $6327116045afe73c$export$9c8d678629b3d3),
        acceptCharset: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        accessKey: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $6327116045afe73c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $6327116045afe73c$export$4a21f16c33752377),
        allowUserMedia: (0, $6327116045afe73c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $6327116045afe73c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        autoFocus: (0, $6327116045afe73c$export$4a21f16c33752377),
        autoPlay: (0, $6327116045afe73c$export$4a21f16c33752377),
        blocking: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        capture: (0, $6327116045afe73c$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $6327116045afe73c$export$4a21f16c33752377),
        cite: null,
        className: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        cols: (0, $6327116045afe73c$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        controls: (0, $6327116045afe73c$export$4a21f16c33752377),
        controlsList: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        coords: (0, $6327116045afe73c$export$98e628dec113755e) | (0, $6327116045afe73c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $6327116045afe73c$export$4a21f16c33752377),
        defer: (0, $6327116045afe73c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $6327116045afe73c$export$4a21f16c33752377),
        download: (0, $6327116045afe73c$export$242ac3d3042558aa),
        draggable: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $6327116045afe73c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        height: (0, $6327116045afe73c$export$98e628dec113755e),
        hidden: (0, $6327116045afe73c$export$4a21f16c33752377),
        high: (0, $6327116045afe73c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $6327116045afe73c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $6327116045afe73c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        itemRef: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        itemScope: (0, $6327116045afe73c$export$4a21f16c33752377),
        itemType: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $6327116045afe73c$export$4a21f16c33752377),
        low: (0, $6327116045afe73c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $6327116045afe73c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $6327116045afe73c$export$98e628dec113755e),
        multiple: (0, $6327116045afe73c$export$4a21f16c33752377),
        muted: (0, $6327116045afe73c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $6327116045afe73c$export$4a21f16c33752377),
        noValidate: (0, $6327116045afe73c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $6327116045afe73c$export$4a21f16c33752377),
        optimum: (0, $6327116045afe73c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $6327116045afe73c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $6327116045afe73c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        required: (0, $6327116045afe73c$export$4a21f16c33752377),
        reversed: (0, $6327116045afe73c$export$4a21f16c33752377),
        rows: (0, $6327116045afe73c$export$98e628dec113755e),
        rowSpan: (0, $6327116045afe73c$export$98e628dec113755e),
        sandbox: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $6327116045afe73c$export$4a21f16c33752377),
        seamless: (0, $6327116045afe73c$export$4a21f16c33752377),
        selected: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $6327116045afe73c$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $6327116045afe73c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $6327116045afe73c$export$98e628dec113755e),
        spellCheck: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $6327116045afe73c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $6327116045afe73c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        width: (0, $6327116045afe73c$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $6327116045afe73c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $6327116045afe73c$export$4a21f16c33752377),
        declare: (0, $6327116045afe73c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $6327116045afe73c$export$98e628dec113755e),
        leftMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        marginWidth: (0, $6327116045afe73c$export$98e628dec113755e),
        noResize: (0, $6327116045afe73c$export$4a21f16c33752377),
        noHref: (0, $6327116045afe73c$export$4a21f16c33752377),
        noShade: (0, $6327116045afe73c$export$4a21f16c33752377),
        noWrap: (0, $6327116045afe73c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $6327116045afe73c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $6327116045afe73c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $6327116045afe73c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $6327116045afe73c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $6327116045afe73c$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $6327116045afe73c$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $098f3c17bccabf6d$export$7ed1367e7fa1ad68 = (0, $9241b59662c8e4b9$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $57102789fbb4388b$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        accentHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $6327116045afe73c$export$98e628dec113755e),
        amplitude: (0, $6327116045afe73c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $6327116045afe73c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $6327116045afe73c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $6327116045afe73c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        className: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $6327116045afe73c$export$98e628dec113755e),
        diffuseConstant: (0, $6327116045afe73c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $6327116045afe73c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $6327116045afe73c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $6327116045afe73c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $6327116045afe73c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $6327116045afe73c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $6327116045afe73c$export$9c8d678629b3d3),
        g2: (0, $6327116045afe73c$export$9c8d678629b3d3),
        glyphName: (0, $6327116045afe73c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $6327116045afe73c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $6327116045afe73c$export$98e628dec113755e),
        horizOriginX: (0, $6327116045afe73c$export$98e628dec113755e),
        horizOriginY: (0, $6327116045afe73c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $6327116045afe73c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $6327116045afe73c$export$98e628dec113755e),
        k: (0, $6327116045afe73c$export$98e628dec113755e),
        k1: (0, $6327116045afe73c$export$98e628dec113755e),
        k2: (0, $6327116045afe73c$export$98e628dec113755e),
        k3: (0, $6327116045afe73c$export$98e628dec113755e),
        k4: (0, $6327116045afe73c$export$98e628dec113755e),
        kernelMatrix: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $6327116045afe73c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $6327116045afe73c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $6327116045afe73c$export$98e628dec113755e),
        overlineThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $6327116045afe73c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $6327116045afe73c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $6327116045afe73c$export$98e628dec113755e),
        pointsAtY: (0, $6327116045afe73c$export$98e628dec113755e),
        pointsAtZ: (0, $6327116045afe73c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        rev: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $6327116045afe73c$export$98e628dec113755e),
        specularExponent: (0, $6327116045afe73c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $6327116045afe73c$export$98e628dec113755e),
        strikethroughThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $6327116045afe73c$export$98e628dec113755e),
        strokeOpacity: (0, $6327116045afe73c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $6327116045afe73c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        tabIndex: (0, $6327116045afe73c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $6327116045afe73c$export$98e628dec113755e),
        targetY: (0, $6327116045afe73c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $6327116045afe73c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $6327116045afe73c$export$98e628dec113755e),
        underlineThickness: (0, $6327116045afe73c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $6327116045afe73c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $6327116045afe73c$export$98e628dec113755e),
        vMathematical: (0, $6327116045afe73c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $6327116045afe73c$export$98e628dec113755e),
        vIdeographic: (0, $6327116045afe73c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $6327116045afe73c$export$98e628dec113755e),
        vertOriginX: (0, $6327116045afe73c$export$98e628dec113755e),
        vertOriginY: (0, $6327116045afe73c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $6327116045afe73c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $84669bfd2b988556$var$valid = /^data[-\w.:]+$/i;
const $84669bfd2b988556$var$dash = /-[a-z]/g;
const $84669bfd2b988556$var$cap = /[A-Z]/g;
function $84669bfd2b988556$export$71aa6c912b956294(schema, value) {
    const normal = (0, $e193cc6bfb75f539$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $f5a64e1dc26e2922$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $84669bfd2b988556$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($84669bfd2b988556$var$dash, $84669bfd2b988556$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$84669bfd2b988556$var$dash.test(rest)) {
                let dashes = rest.replace($84669bfd2b988556$var$cap, $84669bfd2b988556$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $e9abde33d3611e8d$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $84669bfd2b988556$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $84669bfd2b988556$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $a1ae9812302ca8ea$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};



const $cad208d20be39d74$export$c0bb0b647f701bb5 = (0, $f22be46171b10c63$export$4950aa0f605343fb)([
    (0, $2258d34ea2045e6e$export$f2913fe8983302e),
    (0, $f7b1fe9153b66aca$export$2bd1230ec7600845),
    (0, $d677600be62c9ee2$export$e20c24a128671213),
    (0, $f6c2d7ac952f45ea$export$4d2d26490572750a),
    (0, $aed0b684443ef64e$export$c0bb0b647f701bb5)
], "html");
const $cad208d20be39d74$export$7ed1367e7fa1ad68 = (0, $f22be46171b10c63$export$4950aa0f605343fb)([
    (0, $2258d34ea2045e6e$export$f2913fe8983302e),
    (0, $f7b1fe9153b66aca$export$2bd1230ec7600845),
    (0, $d677600be62c9ee2$export$e20c24a128671213),
    (0, $f6c2d7ac952f45ea$export$4d2d26490572750a),
    (0, $098f3c17bccabf6d$export$7ed1367e7fa1ad68)
], "svg");



function $9cf4bbc4053065a1$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $7fPBF = parcelRequire("7fPBF");
var $1d7e3e099a09dc30$exports = {};
"use strict";

$1d7e3e099a09dc30$exports = (parcelRequire("8TZ45"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $bee6688b15c984b0$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $0d98344a9bfa0653$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $0d98344a9bfa0653$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $9323934601145f2e$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $9323934601145f2e$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


var $42244e7baa0fa7b3$exports = {};
var $0c74a7282689820a$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $0c74a7282689820a$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $0c74a7282689820a$var$NEWLINE_REGEX = /\n/g;
var $0c74a7282689820a$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $0c74a7282689820a$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $0c74a7282689820a$var$COLON_REGEX = /^:\s*/;
var $0c74a7282689820a$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $0c74a7282689820a$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $0c74a7282689820a$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $0c74a7282689820a$var$NEWLINE = "\n";
var $0c74a7282689820a$var$FORWARD_SLASH = "/";
var $0c74a7282689820a$var$ASTERISK = "*";
var $0c74a7282689820a$var$EMPTY_STRING = "";
// types
var $0c74a7282689820a$var$TYPE_COMMENT = "comment";
var $0c74a7282689820a$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $0c74a7282689820a$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($0c74a7282689820a$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($0c74a7282689820a$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($0c74a7282689820a$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($0c74a7282689820a$var$FORWARD_SLASH != style.charAt(0) || $0c74a7282689820a$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($0c74a7282689820a$var$EMPTY_STRING != style.charAt(i) && ($0c74a7282689820a$var$ASTERISK != style.charAt(i) || $0c74a7282689820a$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($0c74a7282689820a$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $0c74a7282689820a$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($0c74a7282689820a$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($0c74a7282689820a$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($0c74a7282689820a$var$VALUE_REGEX);
        var ret = pos({
            type: $0c74a7282689820a$var$TYPE_DECLARATION,
            property: $0c74a7282689820a$var$trim(prop[0].replace($0c74a7282689820a$var$COMMENT_REGEX, $0c74a7282689820a$var$EMPTY_STRING)),
            value: val ? $0c74a7282689820a$var$trim(val[0].replace($0c74a7282689820a$var$COMMENT_REGEX, $0c74a7282689820a$var$EMPTY_STRING)) : $0c74a7282689820a$var$EMPTY_STRING
        });
        // ;
        match($0c74a7282689820a$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $0c74a7282689820a$var$trim(str) {
    return str ? str.replace($0c74a7282689820a$var$TRIM_REGEX, $0c74a7282689820a$var$EMPTY_STRING) : $0c74a7282689820a$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $42244e7baa0fa7b3$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $0c74a7282689820a$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$42244e7baa0fa7b3$exports = $42244e7baa0fa7b3$var$StyleToObject;
$42244e7baa0fa7b3$exports.default = $42244e7baa0fa7b3$var$StyleToObject; // ESM support


var $1f9b0c470382ce87$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42244e7baa0fa7b3$exports)));


const $6c3e2527a0e1dced$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $6c3e2527a0e1dced$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $6c3e2527a0e1dced$var$protocols.length){
        const protocol = $6c3e2527a0e1dced$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}


const $a233c16328650932$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $a233c16328650932$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $a233c16328650932$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($a233c16328650932$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$a233c16328650932$var$tableElements.has(node.tagName) || !(0, $bee6688b15c984b0$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $a233c16328650932$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $6c3e2527a0e1dced$export$b83532a10e2e268b) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $cad208d20be39d74$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($a233c16328650932$var$own.call(node.properties, property)) $a233c16328650932$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $a233c16328650932$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $a233c16328650932$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1d7e3e099a09dc30$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = [
        name,
        position.start.line,
        position.start.column,
        index
    ].join("-");
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $a233c16328650932$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $a233c16328650932$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $a233c16328650932$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $a233c16328650932$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $a233c16328650932$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $a233c16328650932$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $a233c16328650932$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $a233c16328650932$var$addProperty(props, prop, value, ctx) {
    const info = (0, $84669bfd2b988556$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $9323934601145f2e$export$fac44ee5b035f737)(result) : (0, $0d98344a9bfa0653$export$fac44ee5b035f737)(result);
    if (info.property === "style" && typeof result === "string") result = $a233c16328650932$var$parseStyle(result);
    if (info.space && info.property) props[$a233c16328650932$var$own.call((0, $a1ae9812302ca8ea$export$d8abd7e5fb6871f9), info.property) ? (0, $a1ae9812302ca8ea$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $a233c16328650932$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $1f9b0c470382ce87$export$2e2bcd8739ae039)(value, iterator);
    } catch (e) {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $a233c16328650932$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $a233c16328650932$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $a233c16328650932$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}


const $0377b6420f25f780$var$own = {}.hasOwnProperty;
const $0377b6420f25f780$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $0377b6420f25f780$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $0377b6420f25f780$export$83ef7ab426386201(options) {
    for(const key in $0377b6420f25f780$var$deprecated)if ($0377b6420f25f780$var$own.call($0377b6420f25f780$var$deprecated, key) && $0377b6420f25f780$var$own.call(options, key)) {
        const deprecation = $0377b6420f25f780$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$0377b6420f25f780$var$changelog}#${deprecation.id}> for more info)`);
        delete $0377b6420f25f780$var$deprecated[key];
    }
    const processor = (0, $82354957eb1a51f9$export$7cc1b2fe10c52bb)().use((0, $4f339a22525673d0$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $74ce0141155f6a3a$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, options.remarkRehypeOptions), {
        allowDangerousHtml: true
    })).use(options.rehypePlugins || []).use((0, $9cf4bbc4053065a1$export$2e2bcd8739ae039), options);
    const file = new (0, $365ad175729fa366$export$93dff69eb10dc7ce)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {}, (0, $a233c16328650932$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $cad208d20be39d74$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$0377b6420f25f780$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
};



function $c10d2a13c7133395$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $c10d2a13c7133395$export$2e2bcd8739ae039(props) {
    console.log("rendering Article", new Date().toISOString().substr(14, 9));
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [thisPost, setThisPost] = (0, $7fPBF.useState)((0, $d34b747414d18dbe$export$2e2bcd8739ae039).find((post)=>post[i18n.language].displayKey === params.article));
    // implements "scroll to anchor" functionality
    (0, $7fPBF.useEffect)(()=>{
        const { hash: hash } = window.location;
        if (hash) {
            const element = document.getElementById(hash.slice(1));
            if (element) element.scrollIntoView();
        }
    }, []);
    // scroll to the top of the page (somehow it got rendered in the middle)
    (0, $7fPBF.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    function handleGoBackClick(e) {
        e.preventDefault();
        // this looks unnecessary, but if pages are accessed via the GoTo component, using "navigate(-1)" just calls out the goto page and returns here
        // there is probably an explanation, but no time to check
        if (location.state && location.state.indexOf("goto") > -1) navigate(-1);
        navigate(-1);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative bg-white overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute inset-x-0 max-w-7xl mx-auto px-4 py-8 rounded opacity-75 sm:px-6 md:grid md:grid-cols-3 md:space-x-8 lg:px-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "md:col-span-2",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "max-w-prose text-lg mx-auto",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: handleGoBackClick,
                            className: "text-white hover:text-gray-100 text-base tracking-wide",
                            children: `\u{2190} ${t("site:article.return-prev-page")}`
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "hidden md:block md:inset-y-0 md:right-0 md:h-[50vh]",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: "inset-0 h-[50vh] w-full object-cover object-bottom",
                    src: thisPost === null || thisPost === void 0 ? void 0 : thisPost.image.article,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "hidden",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative h-full text-lg max-w-prose mx-auto",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                            className: "absolute top-12 left-full transform translate-x-32",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                        id: "74b3fd99-0a6f-4271-bef2-e80eeafdf357",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                            className: "absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                        id: "f210dbf6-a58d-4871-961e-36d5016a0f49",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                            className: "absolute bottom-12 left-full transform translate-x-32",
                            width: 404,
                            height: 384,
                            fill: "none",
                            viewBox: "0 0 404 384",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                        id: "d3eb07ae-5182-43e6-857d-35c643af9034",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    width: 404,
                                    height: 384,
                                    fill: "url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "blog-title",
                className: "relative px-4 max-w-7xl mx-auto py-8 sm:px-6 md:grid md:grid-cols-3 md:space-x-8 lg:px-8 lg:py-16",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative md:col-span-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-lg max-w-prose mx-auto",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "block text-base text-left text-brandBlue-500 font-semibold tracking-wide uppercase",
                                                children: thisPost && t(`site:blog.categories.${thisPost.category.key}.title`)
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "mt-2 block text-3xl text-left leading-8 font-black tracking-tight text-gray-900 sm:text-5xl",
                                                children: thisPost && thisPost[i18n.language].title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: "mt-3 text-sm text-gray-500",
                                        children: [
                                            `${t("site:article.published")} ${thisPost && thisPost[i18n.language].published}`,
                                            thisPost && thisPost[i18n.language].updated ? `- ${t("site:article.updated")} ${thisPost && thisPost.updated}` : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto",
                                children: [
                                    console.log("rendering Markdown in tree"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0377b6420f25f780$export$83ef7ab426386201), {
                                        children: thisPost[i18n.language].body
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            thisPost && (0, $d34b747414d18dbe$export$2e2bcd8739ae039).filter((post)=>thisPost.relatedPosts.some((relatedPost)=>relatedPost === post.id)).map((post, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mb-12",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: $c10d2a13c7133395$var$classNames(idx > 0 ? "hidden" : "text-2xl font-bold text-left mb-9"),
                                            children: t("site:article.related-articles")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            "data-testid": "related-items",
                                            className: "flex flex-col rounded-lg shadow-lg overflow-hidden my-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "flex-shrink-0",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                        className: "h-48 w-full object-cover",
                                                        src: post.image.thumb,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "flex-1",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                            to: post[i18n.language].href,
                                                            className: "block mt-2",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                className: "text-xl font-semibold text-gray-900",
                                                                children: post[i18n.language].title
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, post.id)),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-2xl font-bold text-left mb-9",
                                children: t("site:article.fixed-articles-header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col rounded-lg shadow-lg overflow-hidden my-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "h-48 w-full object-cover",
                                            // eslint-disable-next-line max-len
                                            src: "https://images.unsplash.com/photo-1493723843671-1d655e66ac1c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE2NDU3ODU2MDQ&ixlib=rb-1.2.1&q=80&w=400",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                to: `/${params.lang}/features`,
                                                className: "block mt-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xl font-semibold text-gray-900",
                                                    children: t("site:article.features-title")
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col rounded-lg shadow-lg overflow-hidden my-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "h-48 w-full object-cover",
                                            src: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE2NDU3ODYwMjI&ixlib=rb-1.2.1&q=80&w=400",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                to: `/${params.lang}/demo`,
                                                className: "block mt-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xl font-semibold text-gray-900",
                                                    children: t("site:article.demo-title")
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");
/* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $5a23a98328b8cdaf$var$ArrowsRightLeftIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
    }));
}
const $5a23a98328b8cdaf$var$ForwardRef = $7fPBF.forwardRef($5a23a98328b8cdaf$var$ArrowsRightLeftIcon);
var $5a23a98328b8cdaf$export$2e2bcd8739ae039 = $5a23a98328b8cdaf$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $659c496c237fa73f$var$BoltIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
    }));
}
const $659c496c237fa73f$var$ForwardRef = $7fPBF.forwardRef($659c496c237fa73f$var$BoltIcon);
var $659c496c237fa73f$export$2e2bcd8739ae039 = $659c496c237fa73f$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $7d738768e6988915$var$BriefcaseIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
    }));
}
const $7d738768e6988915$var$ForwardRef = $7fPBF.forwardRef($7d738768e6988915$var$BriefcaseIcon);
var $7d738768e6988915$export$2e2bcd8739ae039 = $7d738768e6988915$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $54d608a39ab6c8f0$var$ComputerDesktopIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25"
    }));
}
const $54d608a39ab6c8f0$var$ForwardRef = $7fPBF.forwardRef($54d608a39ab6c8f0$var$ComputerDesktopIcon);
var $54d608a39ab6c8f0$export$2e2bcd8739ae039 = $54d608a39ab6c8f0$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $de976e929fee04ca$var$GiftIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    }));
}
const $de976e929fee04ca$var$ForwardRef = $7fPBF.forwardRef($de976e929fee04ca$var$GiftIcon);
var $de976e929fee04ca$export$2e2bcd8739ae039 = $de976e929fee04ca$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $281eba671dda59b3$var$PresentationChartLineIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
    }));
}
const $281eba671dda59b3$var$ForwardRef = $7fPBF.forwardRef($281eba671dda59b3$var$PresentationChartLineIcon);
var $281eba671dda59b3$export$2e2bcd8739ae039 = $281eba671dda59b3$var$ForwardRef;



function $0669dfea6622d5a8$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const features = [
        {
            name: `${t("site:features.section1.all-classes.bank.header")}`,
            description: `${t("site:features.section1.all-classes.bank.body")}`,
            icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.stocks.header")}`,
            description: `${t("site:features.section1.all-classes.stocks.body")}`,
            icon: (0, $281eba671dda59b3$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.real-estate.header")}`,
            description: `${t("site:features.section1.all-classes.real-estate.body")}`,
            icon: (0, $63a505abc1d6767c$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.pension.header")}`,
            description: `${t("site:features.section1.all-classes.pension.body")}`,
            icon: (0, $4de34f51288f4739$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.unlisted.header")}`,
            description: `${t("site:features.section1.all-classes.unlisted.body")}`,
            icon: (0, $7d738768e6988915$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.crypto.header")}`,
            description: `${t("site:features.section1.all-classes.crypto.body")}`,
            icon: (0, $659c496c237fa73f$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.objects.header")}`,
            description: `${t("site:features.section1.all-classes.objects.body")}`,
            icon: (0, $de976e929fee04ca$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section1.all-classes.loans.header")}`,
            description: `${t("site:features.section1.all-classes.loans.body")}`,
            icon: (0, $5a23a98328b8cdaf$export$2e2bcd8739ae039)
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: "one-glance",
        className: "pt-16 bg-gray-50 overflow-hidden lg:pt-20",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative max-w-xl mx-auto pb-20 py-4 sm:px-6 lg:px-8 lg:max-w-7xl",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                        className: "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
                        width: 404,
                        height: 784,
                        fill: "none",
                        viewBox: "0 0 404 784",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                    id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                                    x: 0,
                                    y: 0,
                                    width: 20,
                                    height: 20,
                                    patternUnits: "userSpaceOnUse",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                        x: 0,
                                        y: 0,
                                        width: 4,
                                        height: 4,
                                        className: "text-gray-200",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                width: 404,
                                height: 784,
                                fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                                className: "text-center text-3xl leading-8 font-black tracking-tight text-gray-900 sm:text-5xl",
                                children: [
                                    t("site:features.section1.header"),
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "text-brandBlue-500",
                                        children: t("site:features.section1.header-accent")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-4 max-w-2xl mx-auto text-center text-xl text-gray-500",
                                children: t("site:features.section1.body")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "relative pb-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "h-12 w-12 rounded-md flex items-center justify-center bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54d608a39ab6c8f0$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    className: "text-3xl font-black tracking-tight text-gray-900",
                                                    children: t("site:features.section1.one-glance.title")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-4 text-lg text-gray-500",
                                                    children: t("site:features.section1.one-glance.body")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-6",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                        text: t("site:general.startDemo"),
                                                        onClick: ()=>navigate(`/${i18n.language}/demo`),
                                                        withAccent: true
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-8 border-t border-gray-200 pt-6",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("blockquote", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-base text-gray-500",
                                                    children: t("site:features.section1.one-glance.quote")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                                                className: "mt-3",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "flex items-center space-x-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "flex-shrink-0",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                                className: "h-6 w-6 rounded-full",
                                                                src: "https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80",
                                                                alt: ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "text-base font-medium text-gray-700",
                                                            children: t("site:features.section1.one-glance.person")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "mt-12 sm:mt-16 lg:mt-0",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    className: "w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none",
                                    src: "https://tailwindui.com/img/component-images/inbox-app-screenshot-1.jpg",
                                    alt: "Inbox user interface"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-brandBlue-700 my-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "max-w-4xl mx-auto px-4 py-16 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:pt-24 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "text-3xl font-black text-white tracking-tight",
                            children: t("site:features.section1.all-classes.header")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-4 max-w-3xl text-lg text-indigo-200",
                            children: t("site:features.section1.all-classes.body")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-16",
                            children: features.map((feature)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "flex items-center justify-center h-12 w-12 rounded-md bg-white bg-opacity-10",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(feature.icon, {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                    className: "text-xl font-medium text-white",
                                                    children: feature.name
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-2 text-base text-indigo-200",
                                                    children: feature.description
                                                })
                                            ]
                                        })
                                    ]
                                }, feature.name))
                        })
                    ]
                })
            })
        ]
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ 
parcelRequire("7fPBF");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ba311f009fc8236f$var$BuildingOfficeIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
    }));
}
const $ba311f009fc8236f$var$ForwardRef = $7fPBF.forwardRef($ba311f009fc8236f$var$BuildingOfficeIcon);
var $ba311f009fc8236f$export$2e2bcd8739ae039 = $ba311f009fc8236f$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $678f4492084fa720$var$GlobeAltIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
    }));
}
const $678f4492084fa720$var$ForwardRef = $7fPBF.forwardRef($678f4492084fa720$var$GlobeAltIcon);
var $678f4492084fa720$export$2e2bcd8739ae039 = $678f4492084fa720$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ba321105ec05494b$var$ScaleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z"
    }));
}
const $ba321105ec05494b$var$ForwardRef = $7fPBF.forwardRef($ba321105ec05494b$var$ScaleIcon);
var $ba321105ec05494b$export$2e2bcd8739ae039 = $ba321105ec05494b$var$ForwardRef;


function $df193468c64ab159$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const features = [
        {
            name: `${t("site:features.section2.valuation.stocks.header")}`,
            description: `${t("site:features.section2.valuation.stocks.body")}`,
            icon: (0, $281eba671dda59b3$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section2.valuation.fx.header")}`,
            description: `${t("site:features.section2.valuation.fx.body")}`,
            icon: (0, $678f4492084fa720$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section2.valuation.unlisted.header")}`,
            description: `${t("site:features.section2.valuation.unlisted.body")}`,
            icon: (0, $ba311f009fc8236f$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section2.valuation.real-estate.header")}`,
            description: `${t("site:features.section2.valuation.real-estate.body")}`,
            icon: (0, $63a505abc1d6767c$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section2.valuation.metals.header")}`,
            description: `${t("site:features.section2.valuation.metals.body")}`,
            icon: (0, $ba321105ec05494b$export$2e2bcd8739ae039)
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "features-automatic-updates",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "py-12 bg-white",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "lg:text-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-base text-brandBlue-500 font-semibold tracking-wide uppercase",
                                children: t("site:features.section2.lead")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-2 text-3xl leading-8 font-black tracking-tight text-gray-900 sm:text-4xl",
                                children: t("site:features.section2.header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto",
                                children: t("site:features.section2.body")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-10",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                            className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10",
                            children: features.map((feature)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-brandBlue-500 text-white",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(feature.icon, {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "ml-16 text-xl leading-6 font-bold text-gray-900",
                                                    children: feature.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                            className: "mt-2 ml-16 text-base text-gray-500",
                                            children: feature.description
                                        })
                                    ]
                                }, feature.name))
                        })
                    })
                ]
            })
        })
    });
}



parcelRequire("7fPBF");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $27185efc0a7afaf7$var$ChartPieIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z"
    }));
}
const $27185efc0a7afaf7$var$ForwardRef = $7fPBF.forwardRef($27185efc0a7afaf7$var$ChartPieIcon);
var $27185efc0a7afaf7$export$2e2bcd8739ae039 = $27185efc0a7afaf7$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $109c079d14fe89b5$var$FlagIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5"
    }));
}
const $109c079d14fe89b5$var$ForwardRef = $7fPBF.forwardRef($109c079d14fe89b5$var$FlagIcon);
var $109c079d14fe89b5$export$2e2bcd8739ae039 = $109c079d14fe89b5$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $e130f1475b5281eb$var$TableCellsIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
    }));
}
const $e130f1475b5281eb$var$ForwardRef = $7fPBF.forwardRef($e130f1475b5281eb$var$TableCellsIcon);
var $e130f1475b5281eb$export$2e2bcd8739ae039 = $e130f1475b5281eb$var$ForwardRef;


function $b589f90f2cebd68d$var$ViewGridAddIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-6 w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"
        })
    });
}
function $b589f90f2cebd68d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const goalsFeatures = [
        {
            id: 1,
            name: `${t("site:features.section3.goals.set.header")}`,
            description: `${t("site:features.section3.goals.set.body")}`,
            icon: (0, $109c079d14fe89b5$export$2e2bcd8739ae039)
        },
        {
            id: 2,
            name: `${t("site:features.section3.goals.simulate.header")}`,
            description: `${t("site:features.section3.goals.simulate.body")}`,
            icon: (0, $e6e78592b1329b53$export$2e2bcd8739ae039)
        }
    ];
    const reportingFeatures = [
        {
            id: 1,
            name: `${t("site:features.section3.reports.pivot.header")}`,
            description: `${t("site:features.section3.reports.pivot.body")}`,
            icon: (0, $e130f1475b5281eb$export$2e2bcd8739ae039)
        },
        {
            id: 2,
            name: `${t("site:features.section3.reports.charts.header")}`,
            description: `${t("site:features.section3.reports.charts.body")}`,
            icon: (0, $27185efc0a7afaf7$export$2e2bcd8739ae039)
        },
        {
            id: 3,
            name: `${t("site:features.section3.reports.keep-eye.header")}`,
            description: `${t("site:features.section3.reports.keep-eye.body")}`,
            icon: $b589f90f2cebd68d$var$ViewGridAddIcon
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "pt-16 pb-16 bg-gray-50 overflow-hidden lg:pt-0 lg:pb-24",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                    className: "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
                    width: 404,
                    height: 784,
                    fill: "none",
                    viewBox: "0 0 404 784",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
                                x: 0,
                                y: 0,
                                width: 20,
                                height: 20,
                                patternUnits: "userSpaceOnUse",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    x: 0,
                                    y: 0,
                                    width: 4,
                                    height: 4,
                                    className: "text-gray-200",
                                    fill: "currentColor"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            width: 404,
                            height: 784,
                            fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative mt-12 lg:mt-24 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: "text-2xl font-black text-gray-900 tracking-tight sm:text-4xl",
                                    children: t("site:features.section3.goals.header")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-3 text-lg text-gray-500",
                                    children: t("site:features.section3.goals.body")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                                    className: "mt-10 space-y-10",
                                    children: goalsFeatures.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-brandBlue-500 text-white",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.icon, {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "ml-16 text-xl leading-6 font-bold text-gray-900",
                                                            children: item.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                    className: "mt-2 ml-16 text-base text-gray-500",
                                                    children: item.description
                                                })
                                            ]
                                        }, item.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "mt-10 -mx-4 relative lg:mt-0",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                    className: "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
                                    width: 784,
                                    height: 404,
                                    fill: "none",
                                    viewBox: "0 0 784 404",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                                id: "ca9667ae-9f92-4be7-abcb-9e3d727f2941",
                                                x: 0,
                                                y: 0,
                                                width: 20,
                                                height: 20,
                                                patternUnits: "userSpaceOnUse",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                    x: 0,
                                                    y: 0,
                                                    width: 4,
                                                    height: 4,
                                                    className: "text-gray-200",
                                                    fill: "currentColor"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            width: 784,
                                            height: 404,
                                            fill: "url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    className: "relative mx-auto",
                                    width: 490,
                                    src: "https://tailwindui.com/img/features/feature-example-1.png",
                                    alt: ""
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                    className: "hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12",
                    width: 404,
                    height: 784,
                    fill: "none",
                    viewBox: "0 0 404 784",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                id: "64e643ad-2176-4f86-b3d7-f2c5da3b6a6d",
                                x: 0,
                                y: 0,
                                width: 20,
                                height: 20,
                                patternUnits: "userSpaceOnUse",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    x: 0,
                                    y: 0,
                                    width: 4,
                                    height: 4,
                                    className: "text-gray-200",
                                    fill: "currentColor"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            width: 404,
                            height: 784,
                            fill: "url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "relative mt-12 sm:mt-16 lg:mt-24",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "lg:col-start-2",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: "text-2xl font-black text-gray-900 tracking-tight sm:text-4xl",
                                        children: t("site:features.section3.reports.header")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-3 text-lg text-gray-500",
                                        children: t("site:features.section3.reports.body")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                                        className: "mt-10 space-y-10",
                                        children: reportingFeatures.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-brandBlue-500 text-white",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.icon, {
                                                                    className: "h-6 w-6",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                className: "ml-16 text-xl leading-6 font-bold text-gray-900",
                                                                children: item.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                        className: "mt-2 ml-16 text-base text-gray-500",
                                                        children: item.description
                                                    })
                                                ]
                                            }, item.id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-10 -mx-4 relative lg:mt-0 lg:col-start-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                        className: "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
                                        width: 784,
                                        height: 404,
                                        fill: "none",
                                        viewBox: "0 0 784 404",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                                    id: "e80155a9-dfde-425a-b5ea-1f6fadd20131",
                                                    x: 0,
                                                    y: 0,
                                                    width: 20,
                                                    height: 20,
                                                    patternUnits: "userSpaceOnUse",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                        x: 0,
                                                        y: 0,
                                                        width: 4,
                                                        height: 4,
                                                        className: "text-gray-200",
                                                        fill: "currentColor"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                width: 784,
                                                height: 404,
                                                fill: "url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        className: "relative mx-auto",
                                        width: 490,
                                        src: "https://tailwindui.com/img/features/feature-example-2.png",
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



parcelRequire("7fPBF");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $87675a230b6696fd$var$ArrowPathIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const $87675a230b6696fd$var$ForwardRef = $7fPBF.forwardRef($87675a230b6696fd$var$ArrowPathIcon);
var $87675a230b6696fd$export$2e2bcd8739ae039 = $87675a230b6696fd$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $996d3b1e18685651$var$HandRaisedIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002"
    }));
}
const $996d3b1e18685651$var$ForwardRef = $7fPBF.forwardRef($996d3b1e18685651$var$HandRaisedIcon);
var $996d3b1e18685651$export$2e2bcd8739ae039 = $996d3b1e18685651$var$ForwardRef;



function $feb7d96aac96707b$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const features = [
        {
            name: `${t("site:features.section4.sync.auto.header")}`,
            // FIXME: link missing
            description: `${t("site:features.section4.sync.auto.body")}`,
            icon: (0, $87675a230b6696fd$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section4.sync.edit.header")}`,
            description: `${t("site:features.section4.sync.edit.body")}`,
            icon: (0, $e130f1475b5281eb$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section4.sync.uploads.header")}`,
            description: `${t("site:features.section4.sync.uploads.body")}`,
            icon: (0, $659c496c237fa73f$export$2e2bcd8739ae039)
        },
        {
            name: `${t("site:features.section4.sync.decide.header")}`,
            description: `${t("site:features.section4.sync.decide.body")}`,
            icon: (0, $996d3b1e18685651$export$2e2bcd8739ae039)
        }
    ];
    const foundations = [
        {
            name: `${t("site:features.section4.foundations.sustain.header")}`,
            description: `${t("site:features.section4.foundations.sustain.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.anonymous.header")}`,
            description: `${t("site:features.section4.foundations.anonymous.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.control.header")}`,
            description: `${t("site:features.section4.foundations.control.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.neutral.header")}`,
            description: `${t("site:features.section4.foundations.neutral.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.security.header")}`,
            description: `${t("site:features.section4.foundations.security.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.impartial.header")}`,
            description: `${t("site:features.section4.foundations.impartial.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.audit.header")}`,
            description: `${t("site:features.section4.foundations.audit.body")}`
        },
        {
            name: `${t("site:features.section4.foundations.german.header")}`,
            description: `${t("site:features.section4.foundations.german.body")}`
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-gray-50 overflow-hidden",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                            className: "absolute top-0 left-full transform -translate-x-1/2 -translate-y-3/4 lg:left-auto lg:right-full lg:translate-x-2/3 lg:translate-y-1/4",
                            width: 404,
                            height: 784,
                            fill: "none",
                            viewBox: "0 0 404 784",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                        id: "8b1b5f72-e944-4457-af67-0c6d15a99f38",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    width: 404,
                                    height: 784,
                                    fill: "url(#8b1b5f72-e944-4457-af67-0c6d15a99f38)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative lg:grid lg:grid-cols-3 lg:gap-x-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "lg:col-span-1",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "text-3xl font-black tracking-tight text-gray-900 sm:text-4xl",
                                        children: t("site:features.section4.sync.header")
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                                    className: "mt-10 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 lg:mt-0 lg:col-span-2",
                                    children: features.map((feature)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "flex items-center justify-center h-12 w-12 rounded-md bg-brandBlue-500 text-white",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(feature.icon, {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "mt-5 text-xl leading-6 font-bold text-gray-900",
                                                            children: feature.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                    className: "mt-2 text-base text-gray-500",
                                                    children: feature.description
                                                })
                                            ]
                                        }, feature.name))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "max-w-3xl mx-auto text-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                    className: "text-4xl font-black text-gray-900",
                                    children: t("site:features.section4.foundations.header")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-4 text-lg text-gray-500",
                                    children: t("site:features.section4.foundations.body")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                            className: "mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8",
                            children: foundations.map((feature)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf0ef6f622ac72ef$export$2e2bcd8739ae039), {
                                                    className: "absolute h-6 w-6 text-green-500",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "ml-9 text-xl leading-6 font-bold text-gray-900",
                                                    children: feature.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                            className: "mt-2 ml-9 text-base text-gray-500",
                                            children: feature.description
                                        })
                                    ]
                                }, feature.name))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82d09a63b188895d$export$2e2bcd8739ae039), {})
        ]
    });
}


function $7a8f971b6181bbfd$export$2e2bcd8739ae039() {
    // implements "scroll to anchor" functionality
    (0, $7fPBF.useEffect)(()=>{
        const { hash: hash } = window.location;
        if (hash) {
            const element = document.getElementById(hash.slice(1));
            if (element) element.scrollIntoView();
        }
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        "data-testid": "features-topmost",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0669dfea6622d5a8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $df193468c64ab159$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b589f90f2cebd68d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $feb7d96aac96707b$export$2e2bcd8739ae039), {})
        ]
    });
}


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");




var $2oXYc = parcelRequire("2oXYc");

/* eslint-disable max-len */ const $90c24e89ce000f4f$var$datenschutz = `## 1. Datenschutz auf einen Blick

### Allgemeine Hinweise Die folgenden Hinweise geben einen einfachen \xdcberblick dar\xfcber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Ausf\xfchrliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgef\xfchrten Datenschutzerkl\xe4rung.

### Datenerfassung auf dieser Website

#### Wer ist verantwortlich f\xfcr die Datenerfassung auf dieser Website?

Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten k\xf6nnen Sie dem Abschnitt \u{201E}Hinweis zur Verantwortlichen Stelle\u{201C} in dieser Datenschutzerkl\xe4rung entnehmen.

#### Wie erfassen wir Ihre Daten?

Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.

Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.

#### Wof\xfcr nutzen wir Ihre Daten?

Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gew\xe4hrleisten. Andere Daten k\xf6nnen zur Analyse Ihres Nutzerverhaltens verwendet werden.

#### Welche Rechte haben Sie bez\xfcglich Ihrer Daten?

Sie haben jederzeit das Recht, unentgeltlich Auskunft \xfcber Herkunft, Empf\xe4nger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben au\xdferdem ein Recht, die Berichtigung oder L\xf6schung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, k\xf6nnen Sie diese Einwilligung jederzeit f\xfcr die Zukunft widerrufen. Au\xdferdem haben Sie das Recht, unter bestimmten Umst\xe4nden die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zust\xe4ndigen Aufsichtsbeh\xf6rde zu.

Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k\xf6nnen Sie sich jederzeit an uns wenden.

### Analyse-Tools und Tools von Dritt\xadanbietern

Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.

Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerkl\xe4rung.

## 2. Hosting

Wir hosten die Inhalte unserer Website bei folgendem Anbieter:

### Amazon Web Services (AWS)

Anbieter ist die Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, 1855 Luxemburg (nachfolgend AWS).

Wenn Sie unsere Website besuchen, werden Ihre personenbezogenen Daten auf den Servern von AWS verarbeitet. Hierbei k\xf6nnen auch personenbezogene Daten an das Mutterunternehmen von AWS in die USA \xfcbermittelt werden. Die Daten\xfcbertragung in die USA wird auf die EU-Standardvertragsklauseln gest\xfctzt. Details finden Sie hier: [https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/](https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/).

Weitere Informationen entnehmen Sie der Datenschutzerkl\xe4rung von AWS: [https://aws.amazon.com/de/privacy/?nc1=f_pr](https://aws.amazon.com/de/privacy/?nc1=f_pr).

Die Verwendung von AWS erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer m\xf6glichst zuverl\xe4ssigen Darstellung unserer Website. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z.B. Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.

Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u{201E}EU-US Data Privacy Framework\u{201C} (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: [https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active](https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active)

#### Auftragsverarbeitung

Wir haben einen Vertrag \xfcber Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Hierbei handelt es sich um einen datenschutzrechtlich vorgeschriebenen Vertrag, der gew\xe4hrleistet, dass dieser die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.

## 3. Allgemeine Hinweise und Pflicht\xadinformationen

### Datenschutz

Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers\xf6nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung.

Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers\xf6nlich identifiziert werden k\xf6nnen. Die vorliegende Datenschutzerkl\xe4rung erl\xe4utert, welche Daten wir erheben und wof\xfcr wir sie nutzen. Sie erl\xe4utert auch, wie und zu welchem Zweck das geschieht.

Wir weisen darauf hin, dass die Daten\xfcbertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl\xfccken aufweisen kann. Ein l\xfcckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m\xf6glich.

### Hinweis zur verantwortlichen Stelle

Die verantwortliche Stelle f\xfcr die Datenverarbeitung auf dieser Website ist:

Monestry GmbH
Datenschutz
K\xe4thchen-Paulus-Str. 18
60486 Frankfurt am Main

Telefon: +4915147787321
E-Mail: support@monestry.de

Verantwortliche Stelle ist die nat\xfcrliche oder juristische Person, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. \xc4.) entscheidet.

### Speicherdauer

Soweit innerhalb dieser Datenschutzerkl\xe4rung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck f\xfcr die Datenverarbeitung entf\xe4llt. Wenn Sie ein berechtigtes L\xf6schersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gel\xf6scht, sofern wir keine anderen rechtlich zul\xe4ssigen Gr\xfcnde f\xfcr die Speicherung Ihrer personenbezogenen Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die L\xf6schung nach Fortfall dieser Gr\xfcnde.

### Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website

Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO verarbeitet werden. Im Falle einer ausdr\xfccklichen Einwilligung in die \xdcbertragung personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung au\xdferdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in Ihr Endger\xe4t (z.B. via Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zus\xe4tzlich auf Grundlage von \xa7 25 Abs. 1 TTDSG. Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserf\xfcllung oder zur Durchf\xfchrung vorvertraglicher Ma\xdfnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erf\xfcllung einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. \xdcber die jeweils im Einzelfall einschl\xe4gigen Rechtsgrundlagen wird in den folgenden Abs\xe4tzen dieser Datenschutzerkl\xe4rung informiert.

### Empf\xe4nger von personenbezogenen Daten

Im Rahmen unserer Gesch\xe4ftst\xe4tigkeit arbeiten wir mit verschiedenen externen Stellen zusammen. Dabei ist teilweise auch eine \xdcbermittlung von personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer Vertragserf\xfcllung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z.B. Weitergabe von Daten an Steuerbeh\xf6rden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf Grundlage eines g\xfcltigen Vertrags \xfcber Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein Vertrag \xfcber gemeinsame Verarbeitung geschlossen.

### Widerruf Ihrer Einwilligung zur Datenverarbeitung

Viele Datenverarbeitungsvorg\xe4nge sind nur mit Ihrer ausdr\xfccklichen Einwilligung m\xf6glich. Sie k\xf6nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtm\xe4\xdfigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber\xfchrt.

### Widerspruchsrecht gegen die Datenerhebung in besonderen F\xe4llen sowie gegen Direktwerbung (Art. 21 DSGVO)

WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GR\xdcNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH F\xdcR EIN AUF DIESE BESTIMMUNGEN GEST\xdcTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKL\xc4RUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR K\xd6NNEN ZWINGENDE SCHUTZW\xdcRDIGE GR\xdcNDE F\xdcR DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN \xdcBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUS\xdcBUNG ODER VERTEIDIGUNG VON RECHTSANSPR\xdcCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).

WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH F\xdcR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).

### Beschwerde\xadrecht bei der zust\xe4ndigen Aufsichts\xadbeh\xf6rde

Im Falle von Verst\xf6\xdfen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbeh\xf6rde, insbesondere in dem Mitgliedstaat ihres gew\xf6hnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutma\xdflichen Versto\xdfes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.

### Recht auf Daten\xad\xfcbertrag\xadbarkeit

Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf\xfcllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g\xe4ngigen, maschinenlesbaren Format aush\xe4ndigen zu lassen. Sofern Sie die direkte \xdcbertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.

### Auskunft, Berichtigung und L\xf6schung

Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft \xfcber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf\xe4nger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder L\xf6schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k\xf6nnen Sie sich jederzeit an uns wenden.

### Recht auf Einschr\xe4nkung der Verarbeitung

Sie haben das Recht, die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu k\xf6nnen Sie sich jederzeit an uns wenden. Das Recht auf Einschr\xe4nkung der Verarbeitung besteht in folgenden F\xe4llen:

*   Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, ben\xf6tigen wir in der Regel Zeit, um dies zu \xfcberpr\xfcfen. F\xfcr die Dauer der Pr\xfcfung haben Sie das Recht, die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
*   Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtm\xe4\xdfig geschah/geschieht, k\xf6nnen Sie statt der L\xf6schung die Einschr\xe4nkung der Datenverarbeitung verlangen.
*   Wenn wir Ihre personenbezogenen Daten nicht mehr ben\xf6tigen, Sie sie jedoch zur Aus\xfcbung, Verteidigung oder Geltendmachung von Rechtsanspr\xfcchen ben\xf6tigen, haben Sie das Recht, statt der L\xf6schung die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
*   Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abw\xe4gung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen \xfcberwiegen, haben Sie das Recht, die Einschr\xe4nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.

Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschr\xe4nkt haben, d\xfcrfen diese Daten \u{2013} von ihrer Speicherung abgesehen \u{2013} nur mit Ihrer Einwilligung oder zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen oder zum Schutz der Rechte einer anderen nat\xfcrlichen oder juristischen Person oder aus Gr\xfcnden eines wichtigen \xf6ffentlichen Interesses der Europ\xe4ischen Union oder eines Mitgliedstaats verarbeitet werden.

### SSL- bzw. TLS-Verschl\xfcsselung

Diese Seite nutzt aus Sicherheitsgr\xfcnden und zum Schutz der \xdcbertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschl\xfcsselung. Eine verschl\xfcsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von \u{201E}http://\u{201C} auf \u{201E}https://\u{201C} wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.

Wenn die SSL- bzw. TLS-Verschl\xfcsselung aktiviert ist, k\xf6nnen die Daten, die Sie an uns \xfcbermitteln, nicht von Dritten mitgelesen werden.

### Widerspruch gegen Werbe-E-Mails

Der Nutzung von im Rahmen der Impressumspflicht ver\xf6ffentlichten Kontaktdaten zur \xdcbersendung von nicht ausdr\xfccklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich ausdr\xfccklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.

## 4. Datenerfassung auf dieser Website

### Cookies

Unsere Internetseiten verwenden so genannte \u{201E}Cookies\u{201C}. Cookies sind kleine Datenpakete und richten auf Ihrem Endger\xe4t keinen Schaden an. Sie werden entweder vor\xfcbergehend f\xfcr die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endger\xe4t gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gel\xf6scht. Permanente Cookies bleiben auf Ihrem Endger\xe4t gespeichert, bis Sie diese selbst l\xf6schen oder eine automatische L\xf6schung durch Ihren Webbrowser erfolgt.

Cookies k\xf6nnen von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party-Cookies). Third-Party-Cookies erm\xf6glichen die Einbindung bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z.B. Cookies zur Abwicklung von Zahlungsdienstleistungen).

Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Webseitenfunktionen ohne diese nicht funktionieren w\xfcrden (z.B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies k\xf6nnen zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet werden.

Cookies, die zur Durchf\xfchrung des elektronischen Kommunikationsvorgangs, zur Bereitstellung bestimmter, von Ihnen erw\xfcnschter Funktionen (z.B. f\xfcr die Warenkorbfunktion) oder zur Optimierung der Website (z.B. Cookies zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von notwendigen Cookies zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TTDSG); die Einwilligung ist jederzeit widerrufbar.

Sie k\xf6nnen Ihren Browser so einstellen, dass Sie \xfcber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f\xfcr bestimmte F\xe4lle oder generell ausschlie\xdfen sowie das automatische L\xf6schen der Cookies beim Schlie\xdfen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit\xe4t dieser Website eingeschr\xe4nkt sein.

Welche Cookies und Dienste auf dieser Website eingesetzt werden, k\xf6nnen Sie dieser Datenschutzerkl\xe4rung entnehmen.

### Anfrage per E-Mail, Telefon oder Telefax

Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.

Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erf\xfcllung eines Vertrags zusammenh\xe4ngt oder zur Durchf\xfchrung vorvertraglicher Ma\xdfnahmen erforderlich ist. In allen \xfcbrigen F\xe4llen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.

Die von Ihnen an uns per Kontaktanfragen \xfcbersandten Daten verbleiben bei uns, bis Sie uns zur L\xf6schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck f\xfcr die Datenspeicherung entf\xe4llt (z.B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen \u{2013} insbesondere gesetzliche Aufbewahrungsfristen \u{2013} bleiben unber\xfchrt.

## 5. Analyse-Tools und Werbung

### Matomo

Diese Website benutzt den Open Source Webanalysedienst Matomo.

Mit Hilfe von Matomo sind wir in der Lage Daten \xfcber die Nutzung unserer Website durch die Websitebesucher zu erfassen und zu analysieren. Hierdurch k\xf6nnen wir u.a. herausfinden, wann welche Seitenaufrufe get\xe4tigt wurden und aus welcher Region sie kommen. Au\xdferdem erfassen wir verschiedene Logdateien (z.B. IP-Adresse, Referrer, verwendete Browser und Betriebssysteme) und k\xf6nnen messen, ob unsere Websitebesucher bestimmte Aktionen durchf\xfchren (z.B. Klicks, K\xe4ufe u. \xc4.).

Die Nutzung dieses Analyse-Tools erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z.B. Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.

#### Hosting

Wir hosten Matomo ausschlie\xdflich auf unseren eigenen Servern, sodass alle Analysedaten bei uns verbleiben und nicht weitergegeben werden.

## 6. Newsletter

### Newsletter\xaddaten

Wenn Sie den auf der Website angebotenen Newsletter beziehen m\xf6chten, ben\xf6tigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die \xdcberpr\xfcfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters einverstanden sind. Weitere Daten werden nicht bzw. nur auf freiwilliger Basis erhoben. Diese Daten verwenden wir ausschlie\xdflich f\xfcr den Versand der angeforderten Informationen und geben diese nicht an Dritte weiter.

Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten erfolgt ausschlie\xdflich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters k\xf6nnen Sie jederzeit widerrufen, etwa \xfcber den \u{201E}Austragen\u{201C}-Link im Newsletter. Die Rechtm\xe4\xdfigkeit der bereits erfolgten Datenverarbeitungsvorg\xe4nge bleibt vom Widerruf unber\xfchrt.

Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der Abbestellung des Newsletters oder nach Zweckfortfall aus der Newsletterverteilerliste gel\xf6scht. Wir behalten uns vor, E-Mail-Adressen aus unserem Newsletterverteiler nach eigenem Ermessen im Rahmen unseres berechtigten Interesses nach Art. 6 Abs. 1 lit. f DSGVO zu l\xf6schen oder zu sperren.

Daten, die zu anderen Zwecken bei uns gespeichert wurden, bleiben hiervon unber\xfchrt.

Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in einer Blacklist gespeichert, sofern dies zur Verhinderung k\xfcnftiger Mailings erforderlich ist. Die Daten aus der Blacklist werden nur f\xfcr diesen Zweck verwendet und nicht mit anderen Daten zusammengef\xfchrt. Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht befristet. **Sie k\xf6nnen der Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes Interesse \xfcberwiegen.**

## 7. Plugins und Tools

### YouTube mit erweitertem Datenschutz

Diese Website bindet Videos der Website YouTube ein. Betreiber der Seiten ist die Google Ireland Limited (\u{201E}Google\u{201C}), Gordon House, Barrow Street, Dublin 4, Irland.

Wir nutzen YouTube im erweiterten Datenschutzmodus. Dieser Modus bewirkt laut YouTube, dass YouTube keine Informationen \xfcber die Besucher auf dieser Website speichert, bevor diese sich das Video ansehen. Die Weitergabe von Daten an YouTube-Partner wird durch den erweiterten Datenschutzmodus hingegen nicht zwingend ausgeschlossen. So stellt YouTube \u{2013} unabh\xe4ngig davon, ob Sie sich ein Video ansehen \u{2013} eine Verbindung zum Google Marketing Netzwerk her.

Sobald Sie ein YouTube-Video auf dieser Website starten, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie besucht haben. Wenn Sie in Ihrem YouTube-Account eingeloggt sind, erm\xf6glichen Sie YouTube, Ihr Surfverhalten direkt Ihrem pers\xf6nlichen Profil zuzuordnen. Dies k\xf6nnen Sie verhindern, indem Sie sich aus Ihrem YouTube-Account ausloggen.

Des Weiteren kann YouTube nach Starten eines Videos verschiedene Cookies auf Ihrem Endger\xe4t speichern oder vergleichbare Wiedererkennungstechnologien (z.B. Device-Fingerprinting) einsetzen. Auf diese Weise kann YouTube Informationen \xfcber Besucher dieser Website erhalten. Diese Informationen werden u.a. verwendet, um Videostatistiken zu erfassen, die Anwenderfreundlichkeit zu verbessern und Betrugsversuchen vorzubeugen.

Gegebenenfalls k\xf6nnen nach dem Start eines YouTube-Videos weitere Datenverarbeitungsvorg\xe4nge ausgel\xf6st werden, auf die wir keinen Einfluss haben.

Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z.B. Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.

Weitere Informationen \xfcber Datenschutz bei YouTube finden Sie in deren Datenschutzerkl\xe4rung unter: [https://policies.google.com/privacy?hl=de](https://policies.google.com/privacy?hl=de).

Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u{201E}EU-US Data Privacy Framework\u{201C} (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: [https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active](https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active)

### Google Fonts (lokales Hosting)

Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Google Fonts, die von Google bereitgestellt werden. Die Google Fonts sind lokal installiert. Eine Verbindung zu Servern von Google findet dabei nicht statt.

Weitere Informationen zu Google Fonts finden Sie unter [https://developers.google.com/fonts/faq](https://developers.google.com/fonts/faq) und in der Datenschutzerkl\xe4rung von Google: [https://policies.google.com/privacy?hl=de](https://policies.google.com/privacy?hl=de).

### Google reCAPTCHA

Wir nutzen \u{201E}Google reCAPTCHA\u{201C} (im Folgenden \u{201E}reCAPTCHA\u{201C}) auf dieser Website. Anbieter ist die Google Ireland Limited (\u{201E}Google\u{201C}), Gordon House, Barrow Street, Dublin 4, Irland.

Mit reCAPTCHA soll \xfcberpr\xfcft werden, ob die Dateneingabe auf dieser Website (z.B. in einem Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt. Hierzu analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand verschiedener Merkmale. Diese Analyse beginnt automatisch, sobald der Websitebesucher die Website betritt. Zur Analyse wertet reCAPTCHA verschiedene Informationen aus (z.B. IP-Adresse, Verweildauer des Websitebesuchers auf der Website oder vom Nutzer get\xe4tigte Mausbewegungen). Die bei der Analyse erfassten Daten werden an Google weitergeleitet.

Die reCAPTCHA-Analysen laufen vollst\xe4ndig im Hintergrund. Websitebesucher werden nicht darauf hingewiesen, dass eine Analyse stattfindet.

Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse daran, seine Webangebote vor missbr\xe4uchlicher automatisierter Aussp\xe4hung und vor SPAM zu sch\xfctzen. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie\xdflich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und \xa7 25 Abs. 1 TTDSG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im Endger\xe4t des Nutzers (z.B. Device-Fingerprinting) im Sinne des TTDSG umfasst. Die Einwilligung ist jederzeit widerrufbar.

Weitere Informationen zu Google reCAPTCHA entnehmen Sie den Google-Datenschutzbestimmungen und den Google Nutzungsbedingungen unter folgenden Links: [https://policies.google.com/privacy?hl=de](https://policies.google.com/privacy?hl=de) und [https://policies.google.com/terms?hl=de](https://policies.google.com/terms?hl=de).

Das Unternehmen verf\xfcgt \xfcber eine Zertifizierung nach dem \u{201E}EU-US Data Privacy Framework\u{201C} (DPF). Der DPF ist ein \xdcbereinkommen zwischen der Europ\xe4ischen Union und den USA, der die Einhaltung europ\xe4ischer Datenschutzstandards bei Datenverarbeitungen in den USA gew\xe4hrleisten soll. Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem Link: [https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active](https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active)

Quelle ist e-recht24`;
var $90c24e89ce000f4f$export$2e2bcd8739ae039 = $90c24e89ce000f4f$var$datenschutz;


/* eslint-disable max-len */ const $d35047d7aa12d0a0$var$datenschutz = `## 1. Data Protection at a Glance

### General Information
The following information provides a simple overview of what happens to your personal data when you visit this website. Personal data is any data that can personally identify you. Detailed information on data protection can be found in our [privacy policy](link-to-privacy-policy) listed below this text.

### Data Collection on this Website

#### Who is responsible for data collection on this website?

The data processing on this website is carried out by the website operator. You can find their contact details in the "Controller's Contact Information" section of this [privacy policy](link-to-privacy-policy).

#### How do we collect your data?

Your data is collected in part by you providing it to us. This can include data you enter into a contact form, for example.

Other data is automatically collected or with your consent when you visit the website through our IT systems. These are primarily technical data (e.g., internet browser, operating system, or time of page access). This data is collected automatically as soon as you enter this website.

#### What do we use your data for?

Some of the data is collected to ensure the proper functioning of the website. Other data may be used for analyzing your user behavior.

#### What rights do you have regarding your data?

You have the right to receive information about the origin, recipient, and purpose of your stored personal data at any time free of charge. You also have the right to request the correction or deletion of this data. If you have given consent to data processing, you can revoke this consent at any time for the future. Furthermore, you have the right to request the restriction of the processing of your personal data under certain circumstances. You also have the right to lodge a complaint with the competent supervisory authority.

For this and other questions regarding data protection, you can contact us at any time.

### Analysis Tools and Third-Party Tools

When visiting this website, your surfing behavior may be statistically evaluated. This is primarily done with so-called analysis programs.

Detailed information about these analysis programs can be found in the following privacy policy.

## 2. Hosting

We host the content of our website with the following provider:

### Amazon Web Services (AWS)

The provider is Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, 1855 Luxembourg (hereinafter AWS).

When you visit our website, your personal data is processed on AWS servers. Personal data may also be transferred to AWS's parent company in the USA. The data transfer to the USA is based on EU Standard Contractual Clauses. Details can be found here: [https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/](https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/).

For further information, please refer to AWS's privacy policy: [https://aws.amazon.com/de/privacy/?nc1=f_pr](https://aws.amazon.com/de/privacy/?nc1=f_pr).

The use of AWS is based on Article 6(1)(f) of the GDPR. We have a legitimate interest in providing a reliable presentation of our website. If consent is requested, the processing is carried out exclusively based on Article 6(1)(a) of the GDPR and \xa7 25(1) TTDSG, insofar as the consent includes the storage of cookies or access to information on the user's device (e.g., Device-Fingerprinting) as defined by TTDSG. Consent can be revoked at any time.

The company is certified under the "EU-US Data Privacy Framework" (DPF). The DPF is an agreement between the European Union and the USA aimed at ensuring compliance with European data protection standards for data processing in the USA. Every company certified under the DPF commits to adhering to these data protection standards. Further information can be obtained from the provider at the following link: [https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active](https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt0000000TOWQAA4&status=Active)

#### Data Processing Agreement

We have entered into a Data Processing Agreement (DPA) for the use of the above-mentioned service. This is a legally required data protection agreement that ensures that this service processes the personal data of our website visitors only according to our instructions and in compliance with the GDPR.

## 3. General Information and Mandatory Information

### Data Protection

The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the applicable data protection regulations and this privacy policy.

When you use this website, various personal data is collected. Personal data is data that can personally identify you. This privacy policy explains what data we collect and how and for what purpose it is used. It also informs you that data transmission over the Internet (e.g., when communicating via email) may have security vulnerabilities, and complete protection of data from access by third parties is not possible.

### Controller's Contact Information

The controller responsible for data processing on this website is:

Monestry GmbH
Data Protection
K\xe4thchen-Paulus-Str. 18
60486 Frankfurt am Main

Phone: +4915147787321
Email: support@monestry.de

The controller is the natural or legal person who alone or jointly with others decides on the purposes and means of processing personal data (e.g., names, email addresses, etc.).

### Data Retention Period

Unless a specific retention period is mentioned within this privacy policy, your personal data will remain with us until the purpose of data processing ceases. If you request the deletion of your data or revoke your consent to data processing, your data will be deleted unless we have other legally permissible reasons for storing your personal data (e.g., tax or commercial retention periods); in the latter case, the deletion will occur after these reasons no longer apply.

### General Information about the Legal Basis for Data Processing on this Website

If you have given your consent to data processing, we process your personal data on the basis of Article 6(1)(a) GDPR or Article 9(2)(a) GDPR, if special categories of data according to Article 9(1) GDPR are processed. In the case of explicit consent to the transfer of personal data to third countries, data processing is also based on Article 49(1)(a) GDPR. If you have given your consent to the storage of cookies or access to information on your device (e.g., via Device-Fingerprinting), data processing also occurs based on \xa7 25(1) TTDSG. Consent can be revoked at any time. If your data is necessary for the performance of a contract or for the implementation of pre-contractual measures, we process your data based on Article 6(1)(b) GDPR. Furthermore, we process your data if it is necessary to fulfill a legal obligation based on Article 6(1)(c) GDPR. Data processing may also occur based on our legitimate interest under Article 6(1)(f) GDPR. The relevant legal bases for data processing in specific cases are provided in the following paragraphs of this privacy policy.

### Recipients of Personal Data

In the course of our business activities, we work with various external entities. In some cases, the transfer of personal data to these external entities is necessary. We only disclose personal data to external entities when it is necessary as part of fulfilling a contract, when we are legally obligated to do so (e.g., disclosing data to tax authorities), when we have a legitimate interest under Article 6(1)(f) GDPR in disclosing data, or when other legal grounds permit data disclosure. When using data processors, we only disclose personal data of our customers based on a valid data processing agreement. In the case of joint processing, a joint processing agreement is concluded.

### Revocation of Your Consent to Data Processing

Many data processing operations are only possible with your express consent. You can revoke consent you have already given at any time. The legality of data processing carried out before revocation remains unaffected by the revocation.

### Right to Object to Data Collection in Special Cases and Direct Marketing (Article 21 GDPR)

IF DATA PROCESSING IS BASED ON ARTICLE 6(1)(E) OR (F) GDPR, YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA AT ANY TIME FOR REASONS ARISING FROM YOUR PARTICULAR SITUATION, INCLUDING PROFILING BASED ON THESE PROVISIONS. THE RESPECTIVE LEGAL BASIS FOR DATA PROCESSING IS PROVIDED IN THIS PRIVACY POLICY. IF YOU OBJECT, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL DATA UNLESS WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR PROCESSING THAT OVERRIDE YOUR INTERESTS, RIGHTS, AND FREEDOMS, OR THE PROCESSING SERVES TO ASSERT, EXERCISE, OR DEFEND LEGAL CLAIMS (OBJECTION PURSUANT TO ARTICLE 21(1) GDPR).

IF YOUR PERSONAL DATA IS PROCESSED FOR THE PURPOSE OF DIRECT MARKETING, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF YOUR PERSONAL DATA FOR THE PURPOSES OF SUCH ADVERTISING; THIS ALSO APPLIES TO PROFILING TO THE EXTENT THAT IT IS RELATED TO SUCH DIRECT MARKETING. IF YOU OBJECT, YOUR PERSONAL DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR THE PURPOSE OF DIRECT MARKETING (OBJECTION PURSUANT TO ARTICLE 21(2) GDPR).

### Right to Lodge a Complaint with the Supervisory Authority

In the event of breaches of the GDPR, data subjects have the right to lodge a complaint with a supervisory authority, in particular in the member state of their habitual residence, place of work, or place of the alleged infringement. The right to lodge a complaint is without prejudice to any other administrative or judicial remedies.

### Right to Data Portability

You have the right to have data that we process automatically based on your consent or in fulfillment of a contract handed over to you or to a third party in a common, machine-readable format. If you request the direct transfer of data to another responsible party, this will only be done to the extent that it is technically feasible.

### Information, Correction, and Deletion

Within the framework of applicable legal provisions, you have the right to obtain free information about your stored personal data, its origin and recipient, and the purpose of data processing, and, if applicable, a right to correction or deletion of this data. For this purpose and for any further questions about personal data, you can always contact us.

### Right to Restrict Processing

You have the right to request the restriction of the processing of your personal data. To do so, you can always contact us. The right to restrict processing exists in the following cases:

*   If you dispute the accuracy of your personal data stored with us, we usually need time to verify this. For the duration of the examination, you have the right to request the restriction of the processing of your personal data.
*   If the processing of your personal data is unlawful, you can request the restriction of data processing instead of deletion.
*   If we no longer need your personal data, but you need it for the exercise, defense, or assertion of legal claims, you have the right to request the restriction of the processing of your personal data instead of deletion.
*   If you have filed an objection pursuant to Article 21(1) GDPR, a balance must be struck between your interests and ours. As long as it is not yet clear whose interests prevail, you have the right to request the restriction of the processing of your personal data.

If you have restricted the processing of your personal data, such data \u{2013} apart from being stored \u{2013} may only be processed with your consent or for the assertion, exercise, or defense of legal claims or for the protection of the rights of another natural or legal person or for reasons of important public interest of the European Union or a member state.
### SSL or TLS Encryption

For security reasons and to protect the transmission of confidential content, such as orders or inquiries that you send to us as the website operator, this site uses SSL or TLS encryption. You can recognize an encrypted connection by the fact that the address line of the browser changes from "http://" to "https://" and by the lock symbol in your browser line. When SSL or TLS encryption is activated, the data you transmit to us cannot be read by third parties.

### Objection to Promotional Emails

We hereby expressly prohibit the use of contact data published in the context of website legal notice requirements with regard to sending promotional and informational materials not expressly requested. The website operators expressly reserve the right to take legal action in the event of unsolicited sending of promotional information, for example through spam emails.

## 4. Data Collection on this Website

### Cookies

Our websites use so-called "cookies". Cookies are small data packets that do not harm your device. They are either temporarily stored for the duration of a session (session cookies) or permanently (persistent cookies) on your device. Session cookies are automatically deleted after your visit ends. Persistent cookies remain stored on your device until you delete them manually or they are automatically deleted by your web browser.

Cookies can come from us (first-party cookies) or from third-party companies (so-called third-party cookies). Third-party cookies allow the integration of certain services from third-party companies within websites (e.g., cookies for processing payment services).

Cookies have various functions. Many cookies are technically necessary, as certain website functions would not work without them (e.g., the shopping cart function or video display). Other cookies may be used for user behavior analysis or advertising purposes.

Cookies that are necessary for the electronic communication process, the provision of certain functions requested by you (e.g., shopping cart function), or for the optimization of the website (e.g., cookies for measuring web audience) are stored based on Article 6(1)(f) GDPR, unless another legal basis is specified. The website operator has a legitimate interest in storing necessary cookies for the technically error-free and optimized provision of its services. If consent for the storage of cookies and similar recognition technologies has been requested, processing is based solely on this consent (Article 6(1)(a) GDPR and \xa7 25(1) TTDSG); consent can be revoked at any time.

You can configure your browser to inform you about the setting of cookies and to allow cookies only on an individual basis, to accept cookies for specific cases or to exclude them generally, and to activate the automatic deletion of cookies when you close your browser. If cookies are deactivated, the functionality of this website may be limited.

You can find information on which cookies and services are used on this website in this privacy policy.

### Contact via Email, Telephone, or Fax

If you contact us via email, telephone, or fax, your inquiry, including all resulting personal data (name, inquiry), will be stored and processed by us for the purpose of processing your request. We do not disclose this data without your consent.

The processing of this data is based on Article 6(1)(b) GDPR, provided your inquiry is related to the performance of a contract or is necessary for the implementation of pre-contractual measures. In all other cases, the processing is based on our legitimate interest in effectively processing the inquiries directed to us (Article 6(1)(f) GDPR) or on your consent (Article 6(1)(a) GDPR) if requested; consent can be revoked at any time.

The data you send us via contact inquiries will remain with us until you request deletion, revoke your consent to storage, or the purpose for data storage no longer applies (e.g., after processing your request is completed). Mandatory statutory provisions - especially statutory retention periods - remain unaffected.

## 5. Analysis Tools and Advertising

### Matomo

This website uses the open-source web analysis service Matomo.

With Matomo, we are able to collect and analyze data about the use of our website by website visitors. This allows us to determine, among other things, when specific page views were made and from which region they originate. We also collect various log files (e.g., IP address, referrer, used browsers, and operating systems) and can measure whether our website visitors perform specific actions (e.g., clicks, purchases, etc.).

The use of this analysis tool is based on Article 6(1)(f) GDPR. The website operator has a legitimate interest in analyzing user behavior in order to optimize both its web offering and its advertising. If consent for this analysis tool has been requested, processing is based solely on this consent (Article 6(1)(a) GDPR and \xa7 25(1) TTDSG, insofar as the consent includes the storage of cookies or access to information on the user's device (e.g., Device-Fingerprinting) as defined by the TTDSG. Consent can be revoked at any time.

#### Hosting

We exclusively host Matomo on our own servers, ensuring that all analysis data remains with us and is not shared with others.

## 6. Newsletter

### Newsletter Data

If you wish to subscribe to the newsletter offered on the website, we require your email address and information that allows us to verify that you are the owner of the provided email address and agree to receive the newsletter. No further data is collected, or it is collected only on a voluntary basis. We use this data exclusively for sending the requested information and do not share it with third parties.

The processing of data entered into the newsletter registration form is based solely on your consent (Article 6(1)(a) GDPR). The consent given for data storage, the email address, and their use for sending the newsletter can be revoked at any time, for example via the "Unsubscribe" link in the newsletter. The legality of data processing operations already carried out remains unaffected by the revocation.

The data you provide us for the purpose of subscribing to the newsletter will be stored by us or the newsletter service provider until you unsubscribe from the newsletter or the purpose for data storage no longer applies. We reserve the right to delete or block email addresses from our newsletter distribution list at our discretion within the scope of our legitimate interests under Article 6(1)(f) GDPR.

Data stored by us for other purposes remains unaffected.

After unsubscribing from the newsletter distribution list, your email address may be stored in a blacklist by us or the newsletter service provider, if this is necessary to prevent future mailings. The data from the blacklist is used only for this purpose and is not merged with other data. This serves both your and our interest in compliance with legal requirements when sending newsletters (legitimate interest within the meaning of Article 6(1)(f) GDPR). The storage in the blacklist is not time-limited. **You can object to the storage if your interests outweigh our legitimate interest.**

## 7. Plugins and Tools

### YouTube with Enhanced Privacy

This website embeds videos from the YouTube website. The operator of these pages is Google Ireland Limited ("Google"), Gordon House, Barrow Street, Dublin 4, Ireland.

We use YouTube in enhanced privacy mode. According to YouTube, this mode means that YouTube does not store information about visitors to this website before they watch the video. However, the enhanced privacy mode does not necessarily exclude data transfer to YouTube partners. Regardless of whether you watch a video, YouTube establishes a connection to the Google Marketing Network.

When you start a YouTube video on this website, a connection to YouTube's servers is established. YouTube is notified of which of our pages you have visited. If you are logged into your YouTube account, you enable YouTube to directly associate your browsing behavior with your personal profile. You can prevent this by logging out of your YouTube account.

Furthermore, after starting a video, YouTube may store various cookies on your device or use similar recognition technologies (e.g., Device-Fingerprinting). This allows YouTube to obtain information about visitors to this website. This information is used, among other things, to record video statistics, improve user-friendliness, and prevent fraud.

Additional data processing operations may be triggered after starting a YouTube video, over which we have no influence.

The use of YouTube is in the interest of an attractive presentation of our online offerings. This constitutes a legitimate interest within the meaning of Article 6(1)(f) GDPR. If consent has been requested, the processing is based exclusively on Article 6(1)(a) GDPR and \xa7 25(1) TTDSG, insofar as the consent includes the storage of cookies or access to information on the user's device (e.g., Device-Fingerprinting) as defined by the TTDSG. Consent can be revoked at any time.

Further information on data protection at YouTube can be found in their privacy policy at: [https://policies.google.com/privacy?hl=en](https://policies.google.com/privacy?hl=en).

The company has a certification under the "EU-US Data Privacy Framework" (DPF). The DPF is an agreement between the European Union and the United States that is intended to ensure compliance with European data protection standards for data processing in the United States. Each company certified under the DPF commits to complying with these data protection standards. Further information can be obtained from the provider at the following link: [https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active](https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&status=Active)

### Google Fonts (Local Hosting)

This page uses so-called Google Fonts for the uniform display of fonts, provided by Google. Google Fonts are installed locally. There is no connection to Google's servers.

For more information about Google Fonts, please visit [https://developers.google.com/fonts/faq](https://developers.google.com/fonts/faq) and Google's privacy policy: [https://policies.google.com/privacy?hl=en](https://policies.google.com/privacy?hl=en).

### Google reCAPTCHA

We use "Google reCAPTCHA" (hereinafter "reCAPTCHA") on this website. The provider is Google Ireland Limited ("Google"), Gordon House, Barrow Street, Dublin 4, Ireland.

reCAPTCHA is intended to check whether data entry on this website (e.g., in a contact form) is done by a human or an automated program. For this purpose, reCAPTCHA analyzes the behavior of website visitors based on various characteristics. This analysis starts automatically as soon as the website visitor enters the website. For analysis, reCAPTCHA evaluates various information (e.g., IP address, length of stay on the website, or mouse movements made by the user). The data collected during the analysis is forwarded to Google.

The reCAPTCHA analyses run entirely in the background. Website visitors are not informed that an analysis is taking place.

The storage and analysis of the data is based on Article 6(1)(f) GDPR. The website operator has a legitimate interest in protecting its web offers from abusive automated spying and spam. If the appropriate consent has been obtained, the processing is carried out exclusively on the basis of Article 6(1)(a) GDPR and \xa7 25(1) TTDSG, insofar as the consent includes the storage of cookies or access to information on the user's device (e.g., Device-Fingerprinting) as defined by the TTDSG. Consent can be revoked at any time.

Further information on Google reCAPTCHA can be found in Google's privacy policy and terms of use at the following links: [https://policies.google.com/privacy?hl=en](https://policies.google.com/privacy?hl=en) and [https://policies.google.com/terms?hl=en](https://policies.google.com/terms?hl=en).

The company has a certification under the "EU-US Data Privacy Framework" (DPF). The DPF is an agreement between the European Union and the United States that is intended to ensure compliance with European data protection standards for data processing in the United States. Each company certified under the DPF commits to complying with these data protection standards. Further information can be obtained from the provider at the following link: [https://www.dataprivacyframework.gov/s/participant-search/participant-detail?contact=true&id=a2zt000000001L5AAI&

Source is e-recht24`;
var $d35047d7aa12d0a0$export$2e2bcd8739ae039 = $d35047d7aa12d0a0$var$datenschutz;


function $4be5a3aa576d176c$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
// pass component as prop to display it in the document
// pass body as markdown string to display it in the document
function $4be5a3aa576d176c$var$SingleDocument({ header: header, about: about, body: body }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const [fullyOpen, setFullyOpen] = (0, $7fPBF.useState)(false);
    function handleClick(e) {
        e.preventDefault();
        setFullyOpen(!fullyOpen);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
        "aria-labelledby": "single-document",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: $4be5a3aa576d176c$var$classNames(fullyOpen ? null : "max-h-96", "relative bg-white shadow sm:rounded-lg overflow-hidden pb-12"),
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "px-4 py-5 sm:px-6",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            id: "applicant-information-title",
                            className: "text-xl leading-6 font-black text-gray-900",
                            children: header
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-1 max-w-2xl text-sm text-gray-500",
                            children: about
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "border-t border-gray-200 px-4 py-5 sm:px-6",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                        className: "grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "sm:col-span-2",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                className: "mt-1 text-sm text-gray-900 prose-base prose-p:text-gray-500 prose-h3:font-bold",
                                children: body && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0377b6420f25f780$export$83ef7ab426386201), {
                                    children: body
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "absolute bottom-0 w-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "/",
                        className: "block bg-gray-100 text-sm font-medium text-gray-500 text-center px-4 py-4 hover:text-gray-700 sm:rounded-b-lg",
                        onClick: handleClick,
                        children: fullyOpen ? t("site:legal.close") : t("site:legal.read-full-doc")
                    })
                })
            ]
        })
    });
}
$4be5a3aa576d176c$var$SingleDocument.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    about: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$4be5a3aa576d176c$var$SingleDocument.defaultProps = {
    body: ""
};
function $4be5a3aa576d176c$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const docRef = (0, $7fPBF.useRef)();
    const docs = t("site:legal.documents", {
        returnObjects: true
    });
    function handleScroll(e) {
        e.preventDefault();
        docRef.current.scrollIntoView({
            behavior: "smooth"
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "min-h-full",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
            className: "py-10 bg-gray-50",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-6 lg:col-start-1 lg:col-span-2",
                        children: [
                            i18n.language === "en" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4be5a3aa576d176c$var$SingleDocument, {
                                header: "Data privacy",
                                about: "This is a legally mandated document which describes how we handle data privacy.",
                                body: (0, $d35047d7aa12d0a0$export$2e2bcd8739ae039)
                            }),
                            i18n.language === "de" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4be5a3aa576d176c$var$SingleDocument, {
                                header: "Datenschutzerkl\xe4rung",
                                about: "Dies ist ein gesetzlich vorgeschriebenes Dokument, das beschreibt, wie wir mit Datenschutz umgehen.",
                                body: (0, $90c24e89ce000f4f$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "rounded-md bg-blue-50 p-4",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-shrink-0",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-blue-400",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "ml-3 flex-1 md:flex md:justify-between",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "text-sm text-blue-700",
                                                children: t("site:legal.dataPrivacyContact")
                                            })
                                        })
                                    ]
                                })
                            }),
                            docs.map((doc)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    ref: docRef,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4be5a3aa576d176c$var$SingleDocument, {
                                        header: doc.header,
                                        about: doc.subtitle,
                                        body: doc.body
                                    })
                                }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        "aria-labelledby": "timeline-title",
                        className: "lg:col-start-3 lg:col-span-1 relative",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        id: "toc-title",
                                        className: "text-xl font-black text-gray-900",
                                        children: t("site:legal.toc")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-3 flow-root",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                            children: docs.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "min-w-0 pt-1.5",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "py-1",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                className: "text-sm text-gray-500",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                                    href: "#",
                                                                    className: "font-medium text-base text-gray-500",
                                                                    onClick: handleScroll,
                                                                    children: item.header
                                                                })
                                                            })
                                                        })
                                                    })
                                                }, item.header))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col rounded-lg shadow overflow-hidden my-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "h-48 w-full object-cover",
                                            // eslint-disable-next-line max-len
                                            src: "https://images.unsplash.com/photo-1493723843671-1d655e66ac1c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE2NDU3ODU2MDQ&ixlib=rb-1.2.1&q=80&w=400",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                to: `/${i18n.language}/features`,
                                                className: "block mt-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xl font-semibold text-gray-900",
                                                    children: t("site:article.features-title")
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col rounded-lg shadow overflow-hidden my-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "h-48 w-full object-cover",
                                            src: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE2NDU3ODYwMjI&ixlib=rb-1.2.1&q=80&w=400",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                to: `/${i18n.language}/demo`,
                                                className: "block mt-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xl font-semibold text-gray-900",
                                                    children: t("site:article.demo-title")
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}


/* eslint-disable max-len */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
parcelRequire("7fPBF");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $7779c5da2da7ba04$var$BookOpenIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
    }));
}
const $7779c5da2da7ba04$var$ForwardRef = $7fPBF.forwardRef($7779c5da2da7ba04$var$BookOpenIcon);
var $7779c5da2da7ba04$export$2e2bcd8739ae039 = $7779c5da2da7ba04$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $6d44c5cf90b9d5b6$var$BugAntIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
    }));
}
const $6d44c5cf90b9d5b6$var$ForwardRef = $7fPBF.forwardRef($6d44c5cf90b9d5b6$var$BugAntIcon);
var $6d44c5cf90b9d5b6$export$2e2bcd8739ae039 = $6d44c5cf90b9d5b6$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $724de86516382175$var$ChatBubbleLeftRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
    }));
}
const $724de86516382175$var$ForwardRef = $7fPBF.forwardRef($724de86516382175$var$ChatBubbleLeftRightIcon);
var $724de86516382175$export$2e2bcd8739ae039 = $724de86516382175$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $c4b83d8f86a0d3ca$var$PencilSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
    }));
}
const $c4b83d8f86a0d3ca$var$ForwardRef = $7fPBF.forwardRef($c4b83d8f86a0d3ca$var$PencilSquareIcon);
var $c4b83d8f86a0d3ca$export$2e2bcd8739ae039 = $c4b83d8f86a0d3ca$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $d6e4df0cf6950ffd$var$UserGroupIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
    }));
}
const $d6e4df0cf6950ffd$var$ForwardRef = $7fPBF.forwardRef($d6e4df0cf6950ffd$var$UserGroupIcon);
var $d6e4df0cf6950ffd$export$2e2bcd8739ae039 = $d6e4df0cf6950ffd$var$ForwardRef;


function $5d8a82b288135cc1$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ], {
        keyPrefix: "contact"
    });
    const isLoggedIn = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.isLoggedIn);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative bg-white",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "lg:absolute lg:inset-0 lg:left-1/2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    className: "h-64 w-full bg-gray-50 object-cover sm:h-80 lg:absolute lg:h-full",
                    // eslint-disable-next-line max-len
                    src: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-x=.4&w=2560&h=3413&&q=80",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "pb-24 pt-12 sm:pb-32 sm:pt-20 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:pt-16",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "px-6 lg:px-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mx-auto max-w-xl lg:mx-0 lg:max-w-lg",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-3xl font-black tracking-tight text-gray-900",
                                children: t("header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-2 text-xl leading-8 text-gray-500",
                                children: t("subheader")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mx-auto mt-20 max-w-lg space-y-16",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-x-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $724de86516382175$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-base font-semibold leading-7 text-gray-900",
                                                        children: t("prospects.header")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-2 leading-7 text-gray-600",
                                                        children: t("prospects.body")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                            href: "mailto:support@monestry.de",
                                                            className: "text-sm font-semibold leading-6 text-brandBlue-500",
                                                            children: [
                                                                t("emailUs"),
                                                                " ",
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "\u2192"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-x-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6d44c5cf90b9d5b6$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-base font-semibold leading-7 text-gray-900",
                                                        children: t("users.header")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-2 leading-7 text-gray-600",
                                                        children: t("users.body")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-4",
                                                        children: isLoggedIn ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                            to: `/${i18n.language}/app`,
                                                            className: "text-sm font-semibold leading-6 text-brandBlue-500",
                                                            children: [
                                                                t("goToDashboad"),
                                                                " ",
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "\u2192"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                            to: `/${i18n.language}/login`,
                                                            className: "text-sm font-semibold leading-6 text-brandBlue-500",
                                                            children: [
                                                                t("goToLogin"),
                                                                " ",
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "\u2192"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-x-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c4b83d8f86a0d3ca$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-base font-semibold leading-7 text-gray-900",
                                                        children: t("dataPrivacy.header")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-2 leading-7 text-gray-600",
                                                        children: t("dataPrivacy.body")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                            href: "mailto:support@monestry.de",
                                                            className: "text-sm font-semibold leading-6 text-brandBlue-500",
                                                            children: [
                                                                t("emailUs"),
                                                                " ",
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "\u2192"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-x-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6e4df0cf6950ffd$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-base font-semibold leading-7 text-gray-900",
                                                        children: t("partners.header")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-2 leading-7 text-gray-600",
                                                        children: t("partners.body")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                            href: "mailto:partners@monestry.de",
                                                            className: "text-sm font-semibold leading-6 text-brandBlue-500",
                                                            children: [
                                                                t("emailUs"),
                                                                " ",
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "\u2192"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-x-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brandBlue-500",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7779c5da2da7ba04$export$2e2bcd8739ae039), {
                                                    className: "h-6 w-6 text-white",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-base font-semibold leading-7 text-gray-900",
                                                        children: t("media.header")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-2 leading-7 text-gray-600",
                                                        children: t("media.body")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                            href: "mailto:media@monestry.de",
                                                            className: "text-sm font-semibold leading-6 text-brandBlue-500",
                                                            children: [
                                                                t("emailUs"),
                                                                " ",
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    "aria-hidden": "true",
                                                                    children: "\u2192"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




const $d9ac7831776a0adc$var$debugLevel = 0;
function $d9ac7831776a0adc$var$translateByDisplayKey(displayKey, previousLng, currentLng, category = true) {
    if (category) {
        const result = (0, (/*@__PURE__*/$parcel$interopDefault($04989fb566a1d6e0$exports))).find((cat)=>cat[previousLng].displayKey === displayKey);
        if (result) return result[currentLng].displayKey;
        return null;
    }
    return (0, $d34b747414d18dbe$export$2e2bcd8739ae039).find((post)=>post[previousLng].displayKey === displayKey)[currentLng].displayKey;
}
function $d9ac7831776a0adc$export$2e2bcd8739ae039({ i18next: i18next }) {
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    (0, $7fPBF.useEffect)(()=>{
        if ($d9ac7831776a0adc$var$debugLevel > 2) console.info(`LanguageChangeWrapper: i18n.language: ${i18n.language}, location.pathname: ${location.pathname}, location.search: ${location.search}`);
        let targetPath;
        const lng = i18n.language;
        const previousLng = location.pathname.split("/")[1];
        // every time i18n.language changes and if it is not the initial render, run url translation
        if (lng !== previousLng) {
            // for all routes, just swap the language code in the path
            if (i18next.options.supportedLngs.some((language)=>language === location.pathname.split("/")[1])) // if there is a supported language code in the url, replace it with the target language code
            // else assume this was an url without language code (monestry.de/features) and add language code (monestry.de/en/features)
            // (if it is wrong, it will get routed to the 404 page)
            targetPath = `/${lng}${location.pathname.substring(3)}`;
            else targetPath = `/${lng}${location.pathname}`;
            // special case: for SEO purposes the URLs for blog / category / article pages need to be translated
            // those URLs are like: /blog, /blog/:cat, /blog/:cat/:article
            const blog = location.pathname.split("/")[2];
            const cat = location.pathname.split("/")[3];
            const article = location.pathname.split("/")[4];
            if (blog === "blog" && (cat === null || cat === void 0 ? void 0 : cat.length) > 0 && previousLng !== lng) {
                if (article && article.length > 0) // case article
                targetPath = `/${lng}/blog/${$d9ac7831776a0adc$var$translateByDisplayKey(cat, previousLng, lng)}/${$d9ac7831776a0adc$var$translateByDisplayKey(article, previousLng, lng, false)}`;
                else // case category
                targetPath = `/${lng}/blog/${$d9ac7831776a0adc$var$translateByDisplayKey(cat, previousLng, lng)}`;
            }
            if ($d9ac7831776a0adc$var$debugLevel > 2) console.info(`LanguageChangeWrapper: ${location.pathname} -> ${targetPath}, search: ${location.search}`);
            // navigate does not pass query parameters in URL, and in some cases (e.g. callback from Cognito for Amplify) this is needed
            // UPDATE 230425: it seems to work now;
            // if (location.search.length > 0) {
            //   console.log(redirect(`${targetPath}${location.search}`));
            // } else {
            navigate({
                pathname: targetPath,
                search: location.search
            });
        // }
        }
    }, [
        i18n.language
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {});
}
$d9ac7831776a0adc$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    i18next: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};


/* eslint-disable no-alert */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");




var $9tqwB = parcelRequire("9tqwB");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");













let $f18565a07c992db3$var$b = (0, $7fPBF.createContext)(null);
$f18565a07c992db3$var$b.displayName = "GroupContext";
let $f18565a07c992db3$var$Y = (0, $7fPBF.Fragment);
function $f18565a07c992db3$var$Z(y) {
    let [t, a] = (0, $7fPBF.useState)(null), [s, m] = (0, $25facc9026f8a295$export$d6875122194c7b44)(), [c, o] = (0, $3eb8b29b6155d34a$export$babde88292020af7)(), p = (0, $7fPBF.useMemo)(()=>({
            switch: t,
            setSwitch: a,
            labelledby: s,
            describedby: c
        }), [
        t,
        a,
        s,
        c
    ]), d = {}, h = y;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(o, {
        name: "Switch.Description"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(m, {
        name: "Switch.Label",
        props: {
            onClick () {
                !t || (t.click(), t.focus({
                    preventScroll: !0
                }));
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f18565a07c992db3$var$b.Provider, {
        value: p
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: d,
        theirProps: h,
        defaultTag: $f18565a07c992db3$var$Y,
        name: "Switch.Group"
    }))));
}
let $f18565a07c992db3$var$ee = "button", $f18565a07c992db3$var$te = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(t, a) {
    let s = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: m = `headlessui-switch-${s}`, checked: c, defaultChecked: o = !1, onChange: p, name: d, value: h } = t, v = (0, $bLhVg._)(t, [
        "id",
        "checked",
        "defaultChecked",
        "onChange",
        "name",
        "value"
    ]), r = (0, $7fPBF.useContext)($f18565a07c992db3$var$b), u = (0, $7fPBF.useRef)(null), k = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(u, a, r === null ? null : r.setSwitch), [n, i] = (0, $52e65d40f5248976$export$454217e89aea72b)(c, p, o), T = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>i == null ? void 0 : i(!n)), g = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(e.currentTarget)) return e.preventDefault();
        e.preventDefault(), T();
    }), C = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        e.key === (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space ? (e.preventDefault(), T()) : e.key === (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter && (0, $9ee07d5ba8162c4b$export$ee02894bdc79dd36)(e.currentTarget);
    }), D = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>e.preventDefault()), L = (0, $7fPBF.useMemo)(()=>({
            checked: n
        }), [
        n
    ]), R = {
        id: m,
        ref: k,
        role: "switch",
        type: (0, $67467b80232bd14a$export$53652b2b272efe9c)(t, u),
        tabIndex: 0,
        "aria-checked": n,
        "aria-labelledby": r == null ? void 0 : r.labelledby,
        "aria-describedby": r == null ? void 0 : r.describedby,
        onClick: g,
        onKeyUp: C,
        onKeyPress: D
    }, A = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)();
    return (0, $7fPBF.useEffect)(()=>{
        var E;
        let e = (E = u.current) == null ? void 0 : E.closest("form");
        !e || o !== void 0 && A.addEventListener(e, "reset", ()=>{
            i(o);
        });
    }, [
        u,
        i
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, d != null && n && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), (0, $9tqwB._)({
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Hidden
    }, (0, $72af10e8efa1b073$export$8e16b83750b44988)({
        as: "input",
        type: "checkbox",
        hidden: !0,
        readOnly: !0,
        checked: n,
        name: d,
        value: h
    }))), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: R,
        theirProps: v,
        slot: L,
        defaultTag: $f18565a07c992db3$var$ee,
        name: "Switch"
    }));
}), $f18565a07c992db3$export$b5d5cf8927ab7262 = Object.assign($f18565a07c992db3$var$te, {
    Group: $f18565a07c992db3$var$Z,
    Label: (0, $25facc9026f8a295$export$b04be29aa201d4f5),
    Description: (0, $3eb8b29b6155d34a$export$393edc798c47379d)
});




function $079c73b4144e3c9b$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $079c73b4144e3c9b$export$2e2bcd8739ae039() {
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [submitted, setSubmitted] = (0, $7fPBF.useState)(false);
    const { register: register, control: control, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur"
    });
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    // onSubmit determines what happens with form data onSubmit
    async function onSubmit(data) {
        let response;
        if (!submitted) {
            var _session_tokens_idToken, _session_tokens;
            setLoading(true);
            // on submit update parent component state
            const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
            const myInit = {
                body: data,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString()
                }
            };
            try {
                response = await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", "misc/survey", myInit);
                setLoading(false);
                setSubmitted(true);
                window.alert("Thanks for your help! Your feedback has been submitted.");
            } catch (error) {
                console.log("Error while accessing API", error);
                window.alert("Error: we have not been able to submit your survey.");
                setLoading(false);
            }
        }
        return response;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "relative bg-gray-50 pt-4 pb-20 px-4 sm:px-6 lg:pb-28 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "absolute inset-0",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-white h-1/3 sm:h-[51%]"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative max-w-7xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "text-base font-semibold text-brandBlue-600 tracking-wide uppercase",
                                        children: "Feedback"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-1 text-4xl font-black text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                                        children: "What did you think?"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "max-w-xl mt-5 mx-auto text-xl text-gray-500",
                                        children: "Would you mind answering a few questions about your experience today?"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-6 max-w-lg mx-auto grid gap-5 lg:grid-cols-2 lg:max-w-none",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "flex flex-col rounded-lg shadow-lg overflow-hidden p-8 bg-white space-y-10",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                            htmlFor: "about",
                                                            className: "block font-medium text-base text-gray-700 leading-5 pb-2",
                                                            children: "1. After what you have seen today, what three words would you use to describe Monestry?"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "mt-1",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $9tqwB._)({
                                                                    id: "threeWords",
                                                                    name: "threeWords",
                                                                    rows: 2,
                                                                    className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                                                    defaultValue: ""
                                                                }, register("threeWords", {
                                                                    required: {
                                                                        value: true,
                                                                        message: "Please enter something."
                                                                    },
                                                                    maxLength: {
                                                                        value: 200,
                                                                        message: "If you have a longer comment, please use the box in question 5."
                                                                    }
                                                                }))),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                    className: "mt-2 text-sm text-gray-500",
                                                                    children: "Enter any words that spontaneously come to your mind."
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: "pt-2 sm:text-sm text-brandRed-500",
                                                                    children: [
                                                                        " ",
                                                                        errors.threeWords && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            children: errors.threeWords.message
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                            htmlFor: "about",
                                                            className: "block font-medium text-base text-gray-700 leading-5 pb-4",
                                                            children: "2. Was is easy to find your way around the app?"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                            control: control,
                                                            name: "easyway",
                                                            render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                                                    as: "div",
                                                                    className: "flex items-center justify-center w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                                            as: "span",
                                                                            className: "mr-3",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                className: "text-sm font-medium text-gray-900",
                                                                                children: "Yes"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), (0, $2qxEV._)((0, $9tqwB._)({}, field), {
                                                                            checked: field.value,
                                                                            onChange: field.onChange,
                                                                            className: $079c73b4144e3c9b$var$classNames(field.value ? "bg-brandBlue-500" : "bg-gray-200", "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"),
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                "aria-hidden": "true",
                                                                                className: $079c73b4144e3c9b$var$classNames(field.value ? "translate-x-5" : "translate-x-0", "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
                                                                            })
                                                                        })),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                                            as: "span",
                                                                            className: "ml-3",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                className: "text-sm font-medium text-gray-900",
                                                                                children: "No"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                            htmlFor: "about",
                                                            className: "block font-medium text-base text-gray-700 leading-5 pb-4",
                                                            children: "3. Did it feel natural / intuitive to move around the app?"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                            control: control,
                                                            name: "intuitive",
                                                            render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                                                    as: "div",
                                                                    className: "flex items-center justify-center w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                                            as: "span",
                                                                            className: "mr-3",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                className: "text-sm font-medium text-gray-900",
                                                                                children: "Yes"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), (0, $2qxEV._)((0, $9tqwB._)({}, field), {
                                                                            checked: field.value,
                                                                            onChange: field.onChange,
                                                                            className: $079c73b4144e3c9b$var$classNames(field.value ? "bg-brandBlue-500" : "bg-gray-200", "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"),
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                "aria-hidden": "true",
                                                                                className: $079c73b4144e3c9b$var$classNames(field.value ? "translate-x-5" : "translate-x-0", "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
                                                                            })
                                                                        })),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                                            as: "span",
                                                                            className: "ml-3",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                className: "text-sm font-medium text-gray-900",
                                                                                children: "No"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex flex-col rounded-lg shadow-lg overflow-hidden p-8 bg-white space-y-10",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "block font-medium text-base text-gray-700 leading-5 pb-4",
                                                        children: "4. Did the app appear..."
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "relative pt-1 flex flex-col space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "grid grid-cols-12 content-center items-center justify-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "clutteredSpacious",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Cluttered"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        type: "range",
                                                                        className: "form-range appearance-none w-4/5 h-1 p-0 bg-gray-200 text-brandBlue-500 col-span-6 focus:outline-none focus:ring-0 focus:shadow-none",
                                                                        min: "0",
                                                                        max: "3",
                                                                        step: "1",
                                                                        id: "clutteredSpacious"
                                                                    }, register("clutteredSpacious"))),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "clutteredSpacious",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Spacious"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "grid grid-cols-12 content-center items-center justify-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "traditionalModern",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Traditional"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        type: "range",
                                                                        className: "form-range appearance-none w-4/5 h-1 p-0 bg-gray-200 text-brandBlue-500 col-span-6 focus:outline-none focus:ring-0 focus:shadow-none",
                                                                        min: "0",
                                                                        max: "3",
                                                                        step: "1",
                                                                        id: "traditionalModern"
                                                                    }, register("traditionalModern"))),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "traditionalModern",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Modern"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "grid grid-cols-12 content-center items-center justify-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "simpleComplex",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Simple"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        type: "range",
                                                                        className: "form-range appearance-none w-4/5 h-1 p-0 bg-gray-200 text-brandBlue-500 col-span-6 focus:outline-none focus:ring-0 focus:shadow-none",
                                                                        min: "0",
                                                                        max: "3",
                                                                        step: "1",
                                                                        id: "simpleComplex"
                                                                    }, register("simpleComplex"))),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "simpleComplex",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Complex"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "grid grid-cols-12 content-center items-center justify-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "conventionalInnovative",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Conventional"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        type: "range",
                                                                        className: "form-range appearance-none w-4/5 h-1 p-0 bg-gray-200 text-brandBlue-500 col-span-6 focus:outline-none focus:ring-0 focus:shadow-none",
                                                                        min: "0",
                                                                        max: "3",
                                                                        step: "1",
                                                                        id: "conventionalInnovative"
                                                                    }, register("conventionalInnovative"))),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "conventionalInnovative",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Innovative"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "grid grid-cols-12 content-center items-center justify-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "dubiousTrustworthy",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Dubious"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        type: "range",
                                                                        className: "form-range appearance-none w-4/5 h-1 p-0 bg-gray-200 text-brandBlue-500 col-span-6 focus:outline-none focus:ring-0 focus:shadow-none",
                                                                        min: "0",
                                                                        max: "3",
                                                                        step: "1",
                                                                        id: "dubiousTrustworthy"
                                                                    }, register("dubiousTrustworthy"))),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "dubiousTrustworthy",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Trustworthy"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "grid grid-cols-12 content-center items-center justify-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "amateurishProfessional",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Amateurish"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        type: "range",
                                                                        className: "form-range appearance-none w-4/5 h-1 p-0 bg-gray-200 text-brandBlue-500 col-span-6 focus:outline-none focus:ring-0 focus:shadow-none",
                                                                        min: "0",
                                                                        max: "3",
                                                                        step: "1",
                                                                        id: "amateurishProfessional"
                                                                    }, register("amateurishProfessional"))),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                        htmlFor: "amateurishProfessional",
                                                                        className: "form-label uppercase text-xs leading-loose text-gray-500 col-span-2",
                                                                        children: "Professional"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "col-span-1"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "rounded-lg shadow-lg overflow-hidden p-8 mt-6 bg-white gap-6",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "about",
                                            className: "block font-medium text-base text-gray-700 leading-5 pb-2",
                                            children: "(optional) 5. You may have now a better idea on how the finished product might look like. Is there anything the app may be missing? Do you have any other comments?"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $9tqwB._)({
                                                id: "comment",
                                                name: "comment",
                                                rows: 10,
                                                className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                                defaultValue: ""
                                            }, register("comment", {
                                                maxLength: {
                                                    value: 5000,
                                                    message: "If you have a longer comment, please call Piotr :-)."
                                                }
                                            })))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex justify-end rounded-lg shadow-lg overflow-hidden p-6 bg-white mt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>navigate(-1),
                                            className: "inline-flex items-center px-4 py-2 mr-4 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-400 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                                            children: "Cancel"
                                        }),
                                        loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "text-white h-4 w-4 mx-2 animate-spin"
                                            })
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            type: "submit",
                                            className: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                                            value: "Send"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




parcelRequire("7fPBF");

function $05a2551e51078849$export$2e2bcd8739ae039() {
    // this component is to be used for routing to pages within the domain
    // as well as retrieving language versions of the url
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    let target;
    switch(params.target){
        case "anonymous-use":
            switch(i18n.language){
                case "de":
                    target = "/de/blog/anleitung/finanzen-management-app-anonym-nutzen-monestry-und-ihr-anonymes-modus";
                    break;
                default:
                    target = "/en/blog/guide/use-finance-management-app-anonymously-monestry-and-its-anonymous-mode";
                    break;
            }
            break;
        case "data-sources":
            switch(i18n.language){
                case "de":
                    target = "/de/blog/anleitung/wie-halten-wir-die-daten-aktuell";
                    break;
                default:
                    target = "/en/blog/guide/how-do-we-keep-your-financials-current";
                    break;
            }
            break;
        default:
            break;
    }
    console.log("returning target:", target);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: target,
        state: `{ origin: /goto/${params.target} }`
    });
}




var $7fPBF = parcelRequire("7fPBF");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $5447142bb9d66128$var$CogIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
    }));
}
const $5447142bb9d66128$var$ForwardRef = $7fPBF.forwardRef($5447142bb9d66128$var$CogIcon);
var $5447142bb9d66128$export$2e2bcd8739ae039 = $5447142bb9d66128$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $048e1bee881296bf$var$ShieldCheckIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
    }));
}
const $048e1bee881296bf$var$ForwardRef = $7fPBF.forwardRef($048e1bee881296bf$var$ShieldCheckIcon);
var $048e1bee881296bf$export$2e2bcd8739ae039 = $048e1bee881296bf$var$ForwardRef;


const $7547909ad8280f0f$var$icons = {
    simplicity: {
        icon: (0, $cf0ef6f622ac72ef$export$2e2bcd8739ae039),
        href: "/"
    },
    privacy: {
        icon: (0, $048e1bee881296bf$export$2e2bcd8739ae039),
        href: "/"
    },
    convenience: {
        icon: (0, $5447142bb9d66128$export$2e2bcd8739ae039),
        href: "/"
    },
    one: {
        icon: "https://images.unsplash.com/photo-1557576146-047908becbb4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
    },
    two: {
        icon: "https://images.unsplash.com/photo-1568548527144-383edf5c2728?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=256&h=256&q=80&crop=focalpoint&fp-x=0.45&fp-y=0.6&fp-z=1.2"
    },
    three: {
        icon: "https://images.unsplash.com/photo-1556917452-890eed890648?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&facepad=2&w=256&h=256&q=80&crop=focalpoint&fp-x=0.75&fp-y=0.6&fp-z=1"
    }
};
function $7547909ad8280f0f$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const pillars = t("site:about-us.pillars", {
        returnObjects: true
    });
    const pledges = t("site:about-us.pledges", {
        returnObjects: true
    });
    pillars[0].link = `/${i18n.language}/features#one-glance`; // "simplicity"
    pillars[1].link = `/${i18n.language}/blog/new-features/data-privacy-at-monestry#blog-title`; // "privacy"
    pillars[2].link = `/${i18n.language}/features#features-automatic-updates`; // "convenience"
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative pb-32 bg-gray-800",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "absolute inset-0",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        className: "w-full h-full object-cover",
                                        src: "https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "absolute inset-0 bg-brandDarkBlue-800 mix-blend-multiply",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                        className: "text-4xl font-black tracking-tight text-white md:text-5xl lg:text-6xl",
                                        children: t("about-us.need-for-monestry.header")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-9 max-w-3xl text-2xl text-brandBlue-100",
                                        children: t("about-us.need-for-monestry.subheader")
                                    }),
                                    t("about-us.need-for-monestry.paragraphs", {
                                        returnObjects: true
                                    }).map((paragraph)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "mt-6 max-w-3xl text-xl text-brandBlue-100",
                                            children: paragraph
                                        })),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-9 max-w-3xl text-xl italic text-brandBlue-100",
                                        children: t("about-us.need-for-monestry.footnote")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: "-mt-32 max-w-7xl mx-auto relative z-10 pb-32 px-4 sm:px-6 lg:px-8",
                        "aria-labelledby": "contact-heading",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "sr-only",
                                id: "values-heading",
                                children: "Our values"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8",
                                children: pillars.map((pillar)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex flex-col bg-white rounded-2xl shadow-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex-1 relative pt-16 px-6 pb-8 md:px-8",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "absolute top-0 p-5 inline-block bg-brandBlue-500 rounded-xl shadow-lg transform -translate-y-1/2",
                                                        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7547909ad8280f0f$var$icons[pillar.key].icon, {
                                                            className: "h-8 w-8 text-white",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                        className: "text-2xl font-black text-gray-900",
                                                        children: pillar.header
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0377b6420f25f780$export$83ef7ab426386201), {
                                                        className: "mt-6 prose",
                                                        children: pillar.description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "p-6 bg-gray-50 rounded-bl-2xl rounded-br-2xl md:px-8",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                                                    to: pillar.link,
                                                    className: "text-base font-medium text-brandBlue-600 hover:text-brandBlue-700",
                                                    children: [
                                                        pillar.cta,
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            "aria-hidden": "true",
                                                            children: " \u2192"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, pillar.name))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "max-w-7xl mx-auto py-8 px-4 sm:py-12 sm:px-6 lg:px-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "text-base font-semibold text-brandBlue-500 tracking-wide uppercase",
                            children: t("about-us.pledges.title")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-1 text-4xl font-black text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                            children: t("about-us.pledges.header")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "max-w-xl mt-5 mx-auto text-xl text-gray-500",
                            children: t("about-us.pledges.subheader")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                className: "bg-white overflow-hidden",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative max-w-7xl mx-auto pt-20 pb-12 px-4 sm:px-6 lg:px-8 lg:py-20",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                            className: "absolute top-full left-0 transform translate-x-80 -translate-y-24 lg:hidden",
                            width: 784,
                            height: 404,
                            fill: "none",
                            viewBox: "0 0 784 404",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                        id: "e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    width: 784,
                                    height: 404,
                                    fill: "url(#e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                            className: "hidden lg:block absolute right-full top-1/2 transform translate-x-1/2 -translate-y-1/2",
                            width: 404,
                            height: 784,
                            fill: "none",
                            viewBox: "0 0 404 784",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                        id: "56409614-3d62-4985-9a10-7ca758a8f4f0",
                                        x: 0,
                                        y: 0,
                                        width: 20,
                                        height: 20,
                                        patternUnits: "userSpaceOnUse",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                            x: 0,
                                            y: 0,
                                            width: 4,
                                            height: 4,
                                            className: "text-gray-200",
                                            fill: "currentColor"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    width: 404,
                                    height: 784,
                                    fill: "url(#56409614-3d62-4985-9a10-7ca758a8f4f0)"
                                })
                            ]
                        }),
                        pledges.items.map((pledge)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative mb-10 lg:flex lg:items-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "hidden lg:block lg:flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "h-64 w-64 rounded-full xl:h-80 xl:w-80",
                                            src: $7547909ad8280f0f$var$icons[pledge.key].icon,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "relative lg:ml-10",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                className: "absolute top-0 left-0 transform -translate-x-8 -translate-y-24 h-36 w-36 text-indigo-200 opacity-50",
                                                stroke: "currentColor",
                                                fill: "none",
                                                viewBox: "0 0 144 144",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                    strokeWidth: 2,
                                                    d: "M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("blockquote", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-3xl leading-9 font-bold text-gray-900",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            children: pledge.header
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                                                        className: "mt-8",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "flex",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "ml-4 lg:ml-0",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "text-lg font-medium text-gray-900",
                                                                    children: pledge.subheader
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "lg:grid lg:grid-cols-3 lg:gap-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                                    className: "text-4xl font-black text-gray-900",
                                    children: [
                                        t("site:about-us.about.header"),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-12 text-lg lg:mt-0 lg:col-span-2",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0377b6420f25f780$export$83ef7ab426386201), {
                                    className: "prose prose-lg",
                                    children: t("about-us.about.body")
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-white py-8 lg:py-24",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative py-24 px-8 bg-brandBlue-500 rounded-xl shadow-2xl overflow-hidden lg:px-16 lg:grid lg:grid-cols-2 lg:gap-x-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "absolute inset-0 opacity-50 filter saturate-0 mix-blend-multiply",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: "https://images.unsplash.com/photo-1601381718415-a05fb0a261f3?ixid=MXwxMjA3fDB8MHxwcm9maWxlLXBhZ2V8ODl8fHxlbnwwfHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1216&q=80",
                                    alt: "",
                                    className: "w-full h-full object-cover"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "relative lg:col-span-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-6 text-white",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            className: "text-2xl font-black my-4 sm:text-4xl",
                                            children: t("site:about-us.why-monestry.header")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-base font-medium my-4 sm:text-xl",
                                            children: t("site:about-us.why-monestry.body1")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                            className: "text-base font-medium my-4 sm:text-xl",
                                            children: [
                                                t("site:about-us.why-monestry.body2"),
                                                " ",
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "italic",
                                                    children: t("site:about-us.why-monestry.body3")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/* eslint-disable no-return-assign */ 

var $7fPBF = parcelRequire("7fPBF");

/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $ifbub = parcelRequire("ifbub");
var $a1a91b25d7598376$require$Buffer = $ifbub.Buffer;

var $ifbub = parcelRequire("ifbub");
var $a1a91b25d7598376$var$XLSX = {};
$a1a91b25d7598376$var$XLSX.version = "0.19.2";
var $a1a91b25d7598376$var$current_codepage = 1200, $a1a91b25d7598376$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $a1a91b25d7598376$var$$cptable;
var $a1a91b25d7598376$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $a1a91b25d7598376$var$CS2CP = {
    /*::[*/ 0: 1252,
    /* ANSI */ /*::[*/ 1: 65001,
    /* DEFAULT */ /*::[*/ 2: 65001,
    /* SYMBOL */ /*::[*/ 77: 10000,
    /* MAC */ /*::[*/ 128: 932,
    /* SHIFTJIS */ /*::[*/ 129: 949,
    /* HANGUL */ /*::[*/ 130: 1361,
    /* JOHAB */ /*::[*/ 134: 936,
    /* GB2312 */ /*::[*/ 136: 950,
    /* CHINESEBIG5 */ /*::[*/ 161: 1253,
    /* GREEK */ /*::[*/ 162: 1254,
    /* TURKISH */ /*::[*/ 163: 1258,
    /* VIETNAMESE */ /*::[*/ 177: 1255,
    /* HEBREW */ /*::[*/ 178: 1256,
    /* ARABIC */ /*::[*/ 186: 1257,
    /* BALTIC */ /*::[*/ 204: 1251,
    /* RUSSIAN */ /*::[*/ 222: 874,
    /* THAI */ /*::[*/ 238: 1250,
    /* EASTEUROPE */ /*::[*/ 255: 1252,
    /* OEM */ /*::[*/ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $a1a91b25d7598376$var$set_ansi = function(cp /*:number*/ ) {
    if ($a1a91b25d7598376$var$VALID_ANSI.indexOf(cp) == -1) return;
    $a1a91b25d7598376$var$current_ansi = $a1a91b25d7598376$var$CS2CP[0] = cp;
};
function $a1a91b25d7598376$var$reset_ansi() {
    $a1a91b25d7598376$var$set_ansi(1252);
}
var $a1a91b25d7598376$var$set_cp = function(cp /*:number*/ ) {
    $a1a91b25d7598376$var$current_codepage = cp;
    $a1a91b25d7598376$var$set_ansi(cp);
};
function $a1a91b25d7598376$var$reset_cp() {
    $a1a91b25d7598376$var$set_cp(1200);
    $a1a91b25d7598376$var$reset_ansi();
}
function $a1a91b25d7598376$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $a1a91b25d7598376$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $a1a91b25d7598376$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $a1a91b25d7598376$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $a1a91b25d7598376$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $a1a91b25d7598376$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $a1a91b25d7598376$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $a1a91b25d7598376$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $a1a91b25d7598376$export$58f247d16f363b86(cptable) {
    $a1a91b25d7598376$var$$cptable = cptable;
    $a1a91b25d7598376$var$set_cp = function(cp /*:number*/ ) {
        $a1a91b25d7598376$var$current_codepage = cp;
        $a1a91b25d7598376$var$set_ansi(cp);
    };
    $a1a91b25d7598376$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $a1a91b25d7598376$var$$cptable.utils.decode(1200, $a1a91b25d7598376$var$char_codes(data.slice(2)));
        return data;
    };
    $a1a91b25d7598376$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($a1a91b25d7598376$var$current_codepage === 1200) return String.fromCharCode(x);
        return $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $a1a91b25d7598376$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_ansi, [
            x
        ])[0];
    };
    $a1a91b25d7598376$var$cpdoit();
}
var $a1a91b25d7598376$var$DENSE = null;
var $a1a91b25d7598376$var$DIF_XL = true;
var $a1a91b25d7598376$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $a1a91b25d7598376$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/^data:([^\/]+\/[^\/]+)?;base64\,/, "").replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $a1a91b25d7598376$var$has_buf = /*#__PURE__*/ function() {
    return typeof $a1a91b25d7598376$require$Buffer !== "undefined" && typeof $ifbub !== "undefined" && typeof $ifbub.versions !== "undefined" && !!$ifbub.versions.node;
}();
var $a1a91b25d7598376$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $a1a91b25d7598376$require$Buffer !== "undefined") {
        var nbfs = !$a1a91b25d7598376$require$Buffer.from;
        if (!nbfs) try {
            $a1a91b25d7598376$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $a1a91b25d7598376$require$Buffer(buf, enc) : new $a1a91b25d7598376$require$Buffer(buf);
        } : $a1a91b25d7598376$require$Buffer.from.bind($a1a91b25d7598376$require$Buffer);
    }
    return function() {};
}();
var $a1a91b25d7598376$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $a1a91b25d7598376$require$Buffer === "undefined") return false;
    var x = $a1a91b25d7598376$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $a1a91b25d7598376$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.alloc ? $a1a91b25d7598376$require$Buffer.alloc(len) : new $a1a91b25d7598376$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $a1a91b25d7598376$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.allocUnsafe ? $a1a91b25d7598376$require$Buffer.allocUnsafe(len) : new $a1a91b25d7598376$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $a1a91b25d7598376$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $a1a91b25d7598376$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === "undefined") return $a1a91b25d7598376$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $a1a91b25d7598376$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $a1a91b25d7598376$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === "undefined") throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $a1a91b25d7598376$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == "undefined") throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $a1a91b25d7598376$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $a1a91b25d7598376$var$bconcat = $a1a91b25d7598376$var$has_buf ? function(bufs) {
    return $a1a91b25d7598376$require$Buffer.concat(bufs.map(function(buf) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(buf) ? buf : $a1a91b25d7598376$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($a1a91b25d7598376$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $a1a91b25d7598376$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $a1a91b25d7598376$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $a1a91b25d7598376$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $a1a91b25d7598376$var$bconcat(out);
}
var $a1a91b25d7598376$var$chr0 = /\u0000/g, $a1a91b25d7598376$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $a1a91b25d7598376$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $a1a91b25d7598376$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill("0", d - t.length) + t;
}
function $a1a91b25d7598376$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill(" ", d - t.length) + t;
}
function $a1a91b25d7598376$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $a1a91b25d7598376$var$fill(" ", d - t.length);
}
function $a1a91b25d7598376$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $a1a91b25d7598376$var$fill("0", d - t.length) + t;
}
function $a1a91b25d7598376$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill("0", d - t.length) + t;
}
var $a1a91b25d7598376$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $a1a91b25d7598376$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $a1a91b25d7598376$var$p2_32 || v < -$a1a91b25d7598376$var$p2_32) return $a1a91b25d7598376$var$pad0r1(v, d);
    var i = Math.round(v);
    return $a1a91b25d7598376$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $a1a91b25d7598376$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $a1a91b25d7598376$var$days /*:Array<Array<string> >*/  = [
    [
        "Sun",
        "Sunday"
    ],
    [
        "Mon",
        "Monday"
    ],
    [
        "Tue",
        "Tuesday"
    ],
    [
        "Wed",
        "Wednesday"
    ],
    [
        "Thu",
        "Thursday"
    ],
    [
        "Fri",
        "Friday"
    ],
    [
        "Sat",
        "Saturday"
    ]
];
var $a1a91b25d7598376$var$months /*:Array<Array<string> >*/  = [
    [
        "J",
        "Jan",
        "January"
    ],
    [
        "F",
        "Feb",
        "February"
    ],
    [
        "M",
        "Mar",
        "March"
    ],
    [
        "A",
        "Apr",
        "April"
    ],
    [
        "M",
        "May",
        "May"
    ],
    [
        "J",
        "Jun",
        "June"
    ],
    [
        "J",
        "Jul",
        "July"
    ],
    [
        "A",
        "Aug",
        "August"
    ],
    [
        "S",
        "Sep",
        "September"
    ],
    [
        "O",
        "Oct",
        "October"
    ],
    [
        "N",
        "Nov",
        "November"
    ],
    [
        "D",
        "Dec",
        "December"
    ]
];
function $a1a91b25d7598376$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = "General";
    t[1] = "0";
    t[2] = "0.00";
    t[3] = "#,##0";
    t[4] = "#,##0.00";
    t[9] = "0%";
    t[10] = "0.00%";
    t[11] = "0.00E+00";
    t[12] = "# ?/?";
    t[13] = "# ??/??";
    t[14] = "m/d/yy";
    t[15] = "d-mmm-yy";
    t[16] = "d-mmm";
    t[17] = "mmm-yy";
    t[18] = "h:mm AM/PM";
    t[19] = "h:mm:ss AM/PM";
    t[20] = "h:mm";
    t[21] = "h:mm:ss";
    t[22] = "m/d/yy h:mm";
    t[37] = "#,##0 ;(#,##0)";
    t[38] = "#,##0 ;[Red](#,##0)";
    t[39] = "#,##0.00;(#,##0.00)";
    t[40] = "#,##0.00;[Red](#,##0.00)";
    t[45] = "mm:ss";
    t[46] = "[h]:mm:ss";
    t[47] = "mmss.0";
    t[48] = "##0.0E+0";
    t[49] = "@";
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $a1a91b25d7598376$var$table_fmt = {
    0: "General",
    1: "0",
    2: "0.00",
    3: "#,##0",
    4: "#,##0.00",
    9: "0%",
    10: "0.00%",
    11: "0.00E+00",
    12: "# ?/?",
    13: "# ??/??",
    14: "m/d/yy",
    15: "d-mmm-yy",
    16: "d-mmm",
    17: "mmm-yy",
    18: "h:mm AM/PM",
    19: "h:mm:ss AM/PM",
    20: "h:mm",
    21: "h:mm:ss",
    22: "m/d/yy h:mm",
    37: "#,##0 ;(#,##0)",
    38: "#,##0 ;[Red](#,##0)",
    39: "#,##0.00;(#,##0.00)",
    40: "#,##0.00;[Red](#,##0.00)",
    45: "mm:ss",
    46: "[h]:mm:ss",
    47: "mmss.0",
    48: "##0.0E+0",
    49: "@",
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $a1a91b25d7598376$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $a1a91b25d7598376$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $a1a91b25d7598376$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $a1a91b25d7598376$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $a1a91b25d7598376$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
var $a1a91b25d7598376$var$SSFbasedate = /*#__PURE__*/ new Date(1899, 11, 31, 0, 0, 0);
var $a1a91b25d7598376$var$SSFdnthresh = /*#__PURE__*/ $a1a91b25d7598376$var$SSFbasedate.getTime();
var $a1a91b25d7598376$var$SSFbase1904 = /*#__PURE__*/ new Date(1900, 2, 1, 0, 0, 0);
function $a1a91b25d7598376$var$datenum_local(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126230400000;
    else if (v >= $a1a91b25d7598376$var$SSFbase1904) epoch += 86400000;
    return (epoch - ($a1a91b25d7598376$var$SSFdnthresh + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $a1a91b25d7598376$var$SSFbasedate.getTimezoneOffset()) * 60000)) / 86400000;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $a1a91b25d7598376$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $a1a91b25d7598376$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $a1a91b25d7598376$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $a1a91b25d7598376$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $a1a91b25d7598376$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $a1a91b25d7598376$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $a1a91b25d7598376$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $a1a91b25d7598376$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $a1a91b25d7598376$var$SSF_large_exp(v);
    return $a1a91b25d7598376$var$SSF_strip_decimal($a1a91b25d7598376$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $a1a91b25d7598376$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "TRUE" : "FALSE";
        case "number":
            return (v | 0) === v ? v.toString(10) : $a1a91b25d7598376$var$SSF_general_num(v);
        case "undefined":
            return "";
        case "object":
            if (v == null) return "";
            if (v instanceof Date) return $a1a91b25d7598376$var$SSF_format(14, $a1a91b25d7598376$var$datenum_local(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $a1a91b25d7598376$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $a1a91b25d7598376$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $a1a91b25d7598376$var$months[val.m - 1][1];
                case 5:
                    return $a1a91b25d7598376$var$months[val.m - 1][0];
                default:
                    return $a1a91b25d7598376$var$months[val.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $a1a91b25d7598376$var$days[val.q][0];
                default:
                    return $a1a91b25d7598376$var$days[val.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.H;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad hour format: " + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val.M;
                    outl = fmt.length;
                    break;
                default:
                    throw "bad minute format: " + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != "s" && fmt != "ss" && fmt != ".0" && fmt != ".00" && fmt != ".000") throw "bad second format: " + fmt;
            if (val.u === 0 && (fmt == "s" || fmt == "ss")) return $a1a91b25d7598376$var$pad0(val.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val.S + val.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === "s") return ss === 0 ? "0" : "" + ss / tt;
            o = $a1a91b25d7598376$var$pad0(ss, 2 + ss0);
            if (fmt === "ss") return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case "[h]":
                case "[hh]":
                    out = val.D * 24 + val.H;
                    break;
                case "[m]":
                case "[mm]":
                    out = (val.D * 24 + val.H) * 60 + val.M;
                    break;
                case "[s]":
                case "[ss]":
                    out = ((val.D * 24 + val.H) * 60 + val.M) * 60 + Math.round(val.S + val.u);
                    break;
                default:
                    throw "bad abstime format: " + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $a1a91b25d7598376$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $a1a91b25d7598376$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $a1a91b25d7598376$var$pct1 = /%/g;
function $a1a91b25d7598376$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($a1a91b25d7598376$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $a1a91b25d7598376$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $a1a91b25d7598376$var$fill("%", mul);
}
function $a1a91b25d7598376$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $a1a91b25d7598376$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $a1a91b25d7598376$var$write_num_exp(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $a1a91b25d7598376$var$write_num_exp(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $a1a91b25d7598376$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $a1a91b25d7598376$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $a1a91b25d7598376$var$fill(" ", r[1].length + 1 + r[4].length) : $a1a91b25d7598376$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$pad0(myd, r[4].length));
}
function $a1a91b25d7598376$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $a1a91b25d7598376$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $a1a91b25d7598376$var$dec1 = /^#*0*\.([0#]+)/;
var $a1a91b25d7598376$var$closeparen = /\).*[0#]/;
var $a1a91b25d7598376$var$phone = /\(###\) ###\\?-####/;
function $a1a91b25d7598376$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $a1a91b25d7598376$var$rnd(val /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val * dd) / dd;
}
function $a1a91b25d7598376$var$dec(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val - Math.floor(val), dd = Math.pow(10, d);
    if (d < ("" + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $a1a91b25d7598376$var$carry(val /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ("" + Math.round((val - Math.floor(val)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $a1a91b25d7598376$var$flr(val /*:number*/ ) /*:string*/ {
    if (val < 2147483647 && val > -2147483648) return "" + (val >= 0 ? val | 0 : val - 1 | 0);
    return "" + Math.floor(val);
}
function $a1a91b25d7598376$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($a1a91b25d7598376$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $a1a91b25d7598376$var$write_num_flt("n", ffmt, val);
        return "(" + $a1a91b25d7598376$var$write_num_flt("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $a1a91b25d7598376$var$write_num_cm(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $a1a91b25d7598376$var$write_num_pct(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $a1a91b25d7598376$var$write_num_exp(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $a1a91b25d7598376$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $a1a91b25d7598376$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $a1a91b25d7598376$var$pad0r(val, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($a1a91b25d7598376$var$frac1)) return $a1a91b25d7598376$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $a1a91b25d7598376$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($a1a91b25d7598376$var$dec1)) {
        o = $a1a91b25d7598376$var$rnd(val, r[1].length).replace(/^([^\.]+)$/, "$1." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.$/, "." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $a1a91b25d7598376$var$fill("0", $a1a91b25d7598376$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $a1a91b25d7598376$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $a1a91b25d7598376$var$write_num_flt(type, fmt, -val) : $a1a91b25d7598376$var$commaify("" + (Math.floor(val) + $a1a91b25d7598376$var$carry(val, r[1].length))) + "." + $a1a91b25d7598376$var$pad0($a1a91b25d7598376$var$dec(val, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $a1a91b25d7598376$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($a1a91b25d7598376$var$phone)) {
        o = $a1a91b25d7598376$var$write_num_flt(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $a1a91b25d7598376$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $a1a91b25d7598376$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $a1a91b25d7598376$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $a1a91b25d7598376$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$rpad_(ff[2], ri) : $a1a91b25d7598376$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $a1a91b25d7598376$var$pad0r(val, 0);
        if (fmt.length <= o.length) return o;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $a1a91b25d7598376$var$dec(val, r[1].length);
        return val < 0 ? "-" + $a1a91b25d7598376$var$write_num_flt(type, fmt, -val) : $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$flr(val)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $a1a91b25d7598376$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $a1a91b25d7598376$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "#,##0.00", val);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "###,##0.00", val).replace(/^0\./, ".");
        case "#,###.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "#,##0.00", val).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $a1a91b25d7598376$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $a1a91b25d7598376$var$write_num(type, fmt.substr(0, idx), val / Math.pow(10, 3 * (fmt.length - idx)));
}
function $a1a91b25d7598376$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($a1a91b25d7598376$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $a1a91b25d7598376$var$write_num(type, sfmt, val * Math.pow(10, 2 * mul)) + $a1a91b25d7598376$var$fill("%", mul);
}
function $a1a91b25d7598376$var$write_num_exp2(fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val == 0) return "0.0E+0";
        else if (val < 0) return "-" + $a1a91b25d7598376$var$write_num_exp2(fmt, -val);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf("E");
        var ee = Math.floor(Math.log(val) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $a1a91b25d7598376$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($a1a91b25d7598376$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val >= 0) return $a1a91b25d7598376$var$write_num_int("n", ffmt, val);
        return "(" + $a1a91b25d7598376$var$write_num_int("n", ffmt, -val) + ")";
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $a1a91b25d7598376$var$write_num_cm2(type, fmt, val);
    if (fmt.indexOf("%") !== -1) return $a1a91b25d7598376$var$write_num_pct2(type, fmt, val);
    if (fmt.indexOf("E") !== -1) return $a1a91b25d7598376$var$write_num_exp2(fmt, val);
    if (fmt.charCodeAt(0) === 36) return "$" + $a1a91b25d7598376$var$write_num_int(type, fmt.substr(fmt.charAt(1) == " " ? 2 : 1), val);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $a1a91b25d7598376$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val;
        if (val === 0) o = "";
        return o.length > fmt.length ? o : $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($a1a91b25d7598376$var$frac1)) return $a1a91b25d7598376$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $a1a91b25d7598376$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($a1a91b25d7598376$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val).replace(/^([^\.]+)$/, "$1." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.$/, "." + $a1a91b25d7598376$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $a1a91b25d7598376$var$fill("0", $a1a91b25d7598376$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $a1a91b25d7598376$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val < 0 ? "-" + $a1a91b25d7598376$var$write_num_int(type, fmt, -val) : $a1a91b25d7598376$var$commaify("" + val) + "." + $a1a91b25d7598376$var$fill("0", r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $a1a91b25d7598376$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val));
        ri = 0;
        return $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === "0" ? "0" : "";
        }));
    }
    if (fmt.match($a1a91b25d7598376$var$phone)) {
        o = $a1a91b25d7598376$var$write_num_int(type, "##########", val);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $a1a91b25d7598376$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $a1a91b25d7598376$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $a1a91b25d7598376$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $a1a91b25d7598376$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$rpad_(ff[2], ri) : $a1a91b25d7598376$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val;
        if (fmt.length <= o.length) return o;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val < 0 ? "-" + $a1a91b25d7598376$var$write_num_int(type, fmt, -val) : $a1a91b25d7598376$var$commaify("" + val).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $a1a91b25d7598376$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $a1a91b25d7598376$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $a1a91b25d7598376$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $a1a91b25d7598376$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val) + $a1a91b25d7598376$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $a1a91b25d7598376$var$write_num(type /*:string*/ , fmt /*:string*/ , val /*:number*/ ) /*:string*/ {
    return (val | 0) === val ? $a1a91b25d7598376$var$write_num_int(type, fmt, val) : $a1a91b25d7598376$var$write_num_flt(type, fmt, val);
}
function $a1a91b25d7598376$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $a1a91b25d7598376$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $a1a91b25d7598376$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            if ($a1a91b25d7598376$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case "\\":
            i += 2;
            break;
        case "_":
            i += 2;
            break;
        case "@":
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            return true;
        case "A":
        case "a":
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.match($a1a91b25d7598376$var$SSF_abstime)) return true;
            break;
        case ".":
        /* falls through */ case "0":
        case "#":
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == "\\" && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case "?":
            while(fmt.charAt(++i) === c);
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break;
        case "(":
        case ")":
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case " ":
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $a1a91b25d7598376$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = "t", dt, j, cc;
    var hr = "H";
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case "G":
            /* General */ if (!$a1a91b25d7598376$var$SSF_isgeneral(fmt, i)) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "G",
                v: "General"
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: "t",
                v: o
            };
            ++i;
            break;
        case "\\":
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : "t";
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case "_":
            out[out.length] = {
                t: "t",
                v: " "
            };
            i += 2;
            break;
        case "@":
            /* Text Placeholder */ out[out.length] = {
                t: "T",
                v: v
            };
            ++i;
            break;
        case "B":
        case "b":
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "X",
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case "M":
        case "D":
        case "Y":
        case "H":
        case "S":
        case "E":
            c = c.toLowerCase();
        /* falls through */ case "m":
        case "d":
        case "y":
        case "h":
        case "s":
        case "e":
        case "g":
            if (v < 0) return "";
            if (dt == null) {
                dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === "m" && lst.toLowerCase() === "h") c = "M";
            if (c === "h") c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "A":
        case "a":
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = "T";
                hr = "h";
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = "T";
                i += 5;
                hr = "h";
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = "T";
                i += 5;
                hr = "h";
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === "T") return "";
            out[out.length] = q;
            lst = c;
            break;
        case "[":
            o = c;
            while(fmt.charAt(i++) !== "]" && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== "]") throw 'unterminated "[" block: |' + o + "|";
            if (o.match($a1a91b25d7598376$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: "Z",
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$a1a91b25d7598376$var$fmt_is_date(fmt)) out[out.length] = {
                    t: "t",
                    v: o
                };
            }
            break;
        /* Numbers */ case ".":
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: "s",
                    v: o
                };
                break;
            }
        /* falls through */ case "0":
        case "#":
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: "n",
                v: o
            };
            break;
        case "?":
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case "*":
            ++i;
            if (fmt.charAt(i) == " " || fmt.charAt(i) == "*") ++i;
            break; // **
        case "(":
        case ")":
            out[out.length] = {
                t: flen === 1 ? "t" : c,
                v: c
            };
            ++i;
            break;
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: "D",
                v: o
            };
            break;
        case " ":
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case "$":
            out[out.length] = {
                t: "t",
                v: "$"
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error("unrecognized character " + c + " in " + fmt);
            out[out.length] = {
                t: "t",
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = "t"; i >= 0; --i)switch(out[i].t){
        case "h":
        case "H":
            out[i].t = hr;
            lst = "h";
            if (bt < 1) bt = 1;
            break;
        case "s":
            if (ssm = out[i].v.match(/\.0+$/)) ss0 = Math.max(ss0, ssm[0].length - 1);
            if (bt < 3) bt = 3;
        /* falls through */ case "d":
        case "y":
        case "M":
        case "e":
            lst = out[i].t;
            break;
        case "m":
            if (lst === "s") {
                out[i].t = "M";
                if (bt < 2) bt = 2;
            }
            break;
        case "X":
            break;
        case "Z":
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ switch(bt){
        case 0:
            break;
        case 1:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            break;
        case 2:
            /*::if(!dt) break;*/ if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case "t":
        case "T":
        case " ":
        case "D":
            break;
        case "X":
            out[i].v = "";
            out[i].t = ";";
            break;
        case "d":
        case "m":
        case "y":
        case "h":
        case "H":
        case "M":
        case "s":
        case "e":
        case "b":
        case "Z":
            /*::if(!dt) throw "unreachable"; */ out[i].v = $a1a91b25d7598376$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = "t";
            break;
        case "n":
        case "?":
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === "?" || out[jj + 1].t === "t" && out[jj + 1].v === "/") || out[i].t === "(" && (c === " " || c === "n" || c === ")") || c === "t" && (out[jj].v === "/" || out[jj].v === " " && out[jj + 1] != null && out[jj + 1].t == "?"))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case "G":
            out[i].t = "t";
            out[i].v = $a1a91b25d7598376$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $a1a91b25d7598376$var$write_num("n", nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $a1a91b25d7598376$var$write_num("n", nstr, myv);
            if (myv < 0 && out[0] && out[0].t == "t") {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != "t" && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || "n?".indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || "n?(".indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = "t";
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && "n?".indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $a1a91b25d7598376$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = "t";
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $a1a91b25d7598376$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $a1a91b25d7598376$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $a1a91b25d7598376$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $a1a91b25d7598376$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($a1a91b25d7598376$var$cfregex2);
        var m2 = fmt[1].match($a1a91b25d7598376$var$cfregex2);
        return $a1a91b25d7598376$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $a1a91b25d7598376$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $a1a91b25d7598376$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $a1a91b25d7598376$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$a1a91b25d7598376$var$SSF_default_map[fmt]] || $a1a91b25d7598376$var$table_fmt[$a1a91b25d7598376$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $a1a91b25d7598376$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($a1a91b25d7598376$var$SSF_isgeneral(sfmt, 0)) return $a1a91b25d7598376$var$SSF_general(v, o);
    if (v instanceof Date) v = $a1a91b25d7598376$var$datenum_local(v, o.date1904);
    var f = $a1a91b25d7598376$var$choose_fmt(sfmt, v);
    if ($a1a91b25d7598376$var$SSF_isgeneral(f[1])) return $a1a91b25d7598376$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    return $a1a91b25d7598376$var$eval_fmt(f[1], v, o, f[0]);
}
function $a1a91b25d7598376$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != "number") {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($a1a91b25d7598376$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($a1a91b25d7598376$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $a1a91b25d7598376$var$table_fmt[idx] = fmt;
    return idx;
}
function $a1a91b25d7598376$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $a1a91b25d7598376$var$SSF_load(tbl[i], i);
}
function $a1a91b25d7598376$var$make_ssf() {
    $a1a91b25d7598376$var$table_fmt = $a1a91b25d7598376$var$SSF_init_table();
}
var $a1a91b25d7598376$export$40d8edd678456c2b = {
    format: $a1a91b25d7598376$var$SSF_format,
    load: $a1a91b25d7598376$var$SSF_load,
    _table: $a1a91b25d7598376$var$table_fmt,
    load_table: $a1a91b25d7598376$var$SSF_load_table,
    parse_date_code: $a1a91b25d7598376$var$SSF_parse_date_code,
    is_date: $a1a91b25d7598376$var$fmt_is_date,
    get_table: function get_table() {
        return $a1a91b25d7598376$export$40d8edd678456c2b._table = $a1a91b25d7598376$var$table_fmt;
    }
};
var $a1a91b25d7598376$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": "General",
    "24": "General",
    "25": "General",
    "26": "General",
    "27": "m/d/yy",
    "28": "m/d/yy",
    "29": "m/d/yy",
    "30": "m/d/yy",
    "31": "m/d/yy",
    "32": "h:mm:ss",
    "33": "h:mm:ss",
    "34": "h:mm:ss",
    "35": "h:mm:ss",
    "36": "m/d/yy",
    "41": '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    "50": "m/d/yy",
    "51": "m/d/yy",
    "52": "m/d/yy",
    "53": "m/d/yy",
    "54": "m/d/yy",
    "55": "m/d/yy",
    "56": "m/d/yy",
    "57": "m/d/yy",
    "58": "m/d/yy",
    "59": "0",
    "60": "0.00",
    "61": "#,##0",
    "62": "#,##0.00",
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": "0%",
    "68": "0.00%",
    "69": "# ?/?",
    "70": "# ??/??",
    "71": "m/d/yy",
    "72": "m/d/yy",
    "73": "d-mmm-yy",
    "74": "d-mmm",
    "75": "mmm-yy",
    "76": "h:mm",
    "77": "h:mm:ss",
    "78": "m/d/yy h:mm",
    "79": "mm:ss",
    "80": "[h]:mm:ss",
    "81": "mmss.0"
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $a1a91b25d7598376$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $a1a91b25d7598376$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $a1a91b25d7598376$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($a1a91b25d7598376$var$dateNFregex, "(\\d+)");
    return new RegExp("^" + fmt + "$");
}
function $a1a91b25d7598376$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($a1a91b25d7598376$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case "y":
                Y = v;
                break;
            case "d":
                d = v;
                break;
            case "h":
                H = v;
                break;
            case "s":
                S = v;
                break;
            case "m":
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $a1a91b25d7598376$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $a1a91b25d7598376$var$SSF__load(fmt, idx) {
    return $a1a91b25d7598376$var$SSF_load($a1a91b25d7598376$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $a1a91b25d7598376$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = "1.2.0";
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== "undefined" ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== "undefined" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $a1a91b25d7598376$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = "1.2.2";
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val.setMilliseconds(0);
        val.setFullYear(ymd + 1980);
        val.setMonth(m - 1);
        val.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val.setHours(hms);
        val.setMinutes(M);
        val.setSeconds(S << 1);
        return val;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $a1a91b25d7598376$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $a1a91b25d7598376$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, "i");
        if (mver === 3 && dir_cnt !== 0) throw new Error("# Directory Sectors: Expected 0 saw " + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, "i");
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk("00100000", "Mini Stream Cutoff Size: ");
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, "i");
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, "i");
        // First DIFAT sector location
        difat_start = blob.read_shift(4, "i");
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, "i");
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, "i");
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, "Header Signature: ");
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, "u");
        return [
            blob.read_shift(2, "u"),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error("Sector Shift: Expected 9 saw " + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error("Sector Shift: Expected 12 saw " + shift);
                break;
            default:
                throw new Error("Sector Shift: Expected 9 or 12 saw " + shift);
        }
        // Mini Sector Shift
        blob.chk("0600", "Mini Sector Shift: ");
        // Reserved
        blob.chk("000000000000", "Reserved: ");
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $a1a91b25d7598376$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $a1a91b25d7598376$var$new_buf(0);
        return $a1a91b25d7598376$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $a1a91b25d7598376$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($a1a91b25d7598376$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $a1a91b25d7598376$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $a1a91b25d7598376$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $a1a91b25d7598376$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $a1a91b25d7598376$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $a1a91b25d7598376$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $a1a91b25d7598376$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, "i"),
                R: blob.read_shift(4, "i"),
                C: blob.read_shift(4, "i"),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, "i"),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, "i");
            o.size = blob.read_shift(4, "i");
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = "fat";
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = "minifat";
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $a1a91b25d7598376$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($a1a91b25d7598376$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $a1a91b25d7598376$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($a1a91b25d7598376$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\x01Sh33tJ5";
        if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $a1a91b25d7598376$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == "mad") return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case "zip":
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $a1a91b25d7598376$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 32) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 32));
                _nm = _nm.slice(0, 32);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($a1a91b25d7598376$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($a1a91b25d7598376$var$chr1);
        UCPath = UCPath.replace($a1a91b25d7598376$var$chr0, "");
        if (m) UCPath = UCPath.replace($a1a91b25d7598376$var$chr1, "!");
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($a1a91b25d7598376$var$chr1, "!") : UCFullPaths[w]).replace($a1a91b25d7598376$var$chr0, "") == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($a1a91b25d7598376$var$chr1, "!") : UCPaths[w]).replace($a1a91b25d7598376$var$chr0, "") == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = "d0cf11e0a1b11ae1";
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = "00000000000000000000000000000000";
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: "3e00",
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            "unknown",
            "storage",
            "stream",
            "lockbytes",
            "property",
            "root"
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $a1a91b25d7598376$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.isBuffer(o) ? o : $a1a91b25d7598376$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $a1a91b25d7598376$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== "undefined";
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($a1a91b25d7598376$var$has_buf) {
            var o = $a1a91b25d7598376$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $a1a91b25d7598376$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $a1a91b25d7598376$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $a1a91b25d7598376$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== "undefined") console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = ef[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $a1a91b25d7598376$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $a1a91b25d7598376$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $a1a91b25d7598376$var$CRC32.bstr(fi.content, 0) : $a1a91b25d7598376$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $a1a91b25d7598376$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $a1a91b25d7598376$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $a1a91b25d7598376$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $a1a91b25d7598376$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $a1a91b25d7598376$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $a1a91b25d7598376$var$bconcat([
            $a1a91b25d7598376$var$bconcat(out /*:any*/ ),
            $a1a91b25d7598376$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $a1a91b25d7598376$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $a1a91b25d7598376$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^(.*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case "base64":
                fdata = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(data.slice(di).join("")));
                break;
            case "quoted-printable":
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = "------=" + boundary;
        var out = [
            "MIME-Version: 1.0",
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            "",
            "",
            ""
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\x01Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push("Content-Location: " + (opts.root || "file:///C:/SheetJS/") + fp);
            out.push("Content-Transfer-Encoding: " + (qp ? "quoted-printable" : "base64"));
            out.push("Content-Type: " + get_content_type(fi, fp));
            out.push("");
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + "--\r\n");
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $a1a91b25d7598376$var$ReadShift,
        CheckField: $a1a91b25d7598376$var$CheckField,
        prep_blob: $a1a91b25d7598376$var$prep_blob,
        bconcat: $a1a91b25d7598376$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $a1a91b25d7598376$var$_fs;
function $a1a91b25d7598376$export$a48eb669e1768bcf(fs) {
    $a1a91b25d7598376$var$_fs = fs;
}
/* normalize data for blob ctor */ function $a1a91b25d7598376$var$blobify(data) {
    if (typeof data === "string") return $a1a91b25d7598376$var$s2ab(data);
    if (Array.isArray(data)) return $a1a91b25d7598376$var$a2u(data);
    return data;
}
/* write or download file */ function $a1a91b25d7598376$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $a1a91b25d7598376$var$_fs !== "undefined" && $a1a91b25d7598376$var$_fs.writeFileSync) return enc ? $a1a91b25d7598376$var$_fs.writeFileSync(fname, payload, enc) : $a1a91b25d7598376$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== "undefined") {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $a1a91b25d7598376$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $a1a91b25d7598376$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== "undefined") return IE_SaveFile(data, fname);
    if (typeof Blob !== "undefined") {
        var blob = new Blob([
            $a1a91b25d7598376$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== "undefined" && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== "undefined") return saveAs(blob, fname);
        if (typeof URL !== "undefined" && typeof document !== "undefined" && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === "object" && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== "undefined") setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        }
    }
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $a1a91b25d7598376$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $a1a91b25d7598376$var$read_binary(path /*:string*/ ) {
    if (typeof $a1a91b25d7598376$var$_fs !== "undefined") return $a1a91b25d7598376$var$_fs.readFileSync(path);
    if (typeof Deno !== "undefined") return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== "undefined" && typeof File !== "undefined" && typeof Folder !== "undefined") try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || !e.message.match(/onstruct/)) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $a1a91b25d7598376$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $a1a91b25d7598376$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $a1a91b25d7598376$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $a1a91b25d7598376$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $a1a91b25d7598376$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $a1a91b25d7598376$var$basedate = /*#__PURE__*/ new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function $a1a91b25d7598376$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    if (date1904) epoch -= 126316800000;
    var dnthresh = /*#__PURE__*/ $a1a91b25d7598376$var$basedate.getTime() + /*#__PURE__*/ (v.getTimezoneOffset() - /*#__PURE__*/ $a1a91b25d7598376$var$basedate.getTimezoneOffset()) * 60000;
    return (epoch - dnthresh) / 86400000;
}
var $a1a91b25d7598376$var$refdate = /*#__PURE__*/ new Date();
var $a1a91b25d7598376$var$dnthresh = /*#__PURE__*/ $a1a91b25d7598376$var$basedate.getTime() + /*#__PURE__*/ ($a1a91b25d7598376$var$refdate.getTimezoneOffset() - /*#__PURE__*/ $a1a91b25d7598376$var$basedate.getTimezoneOffset()) * 60000;
var $a1a91b25d7598376$var$refoffset = /*#__PURE__*/ $a1a91b25d7598376$var$refdate.getTimezoneOffset();
function $a1a91b25d7598376$var$numdate(v /*:number*/ ) /*:Date*/ {
    var out = new Date();
    out.setTime(v * 86400000 + $a1a91b25d7598376$var$dnthresh);
    if (out.getTimezoneOffset() !== $a1a91b25d7598376$var$refoffset) out.setTime(out.getTime() + (out.getTimezoneOffset() - $a1a91b25d7598376$var$refoffset) * 60000);
    return out;
}
/* ISO 8601 Duration */ function $a1a91b25d7598376$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case "Y":
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case "D":
                mt *= 24;
            /* falls through */ case "H":
                mt *= 60;
            /* falls through */ case "M":
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case "S":
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
var $a1a91b25d7598376$var$good_pd_date_1 = /*#__PURE__*/ new Date("2017-02-19T19:06:09.000Z");
var $a1a91b25d7598376$var$good_pd_date = /*#__PURE__*/ isNaN(/*#__PURE__*/ $a1a91b25d7598376$var$good_pd_date_1.getFullYear()) ? /*#__PURE__*/ new Date("2/19/17") : $a1a91b25d7598376$var$good_pd_date_1;
var $a1a91b25d7598376$var$good_pd = /*#__PURE__*/ $a1a91b25d7598376$var$good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */ function $a1a91b25d7598376$var$parseDate(str /*:string|Date*/ , fixdate /*:?number*/ ) /*:Date*/ {
    var d = new Date(str);
    if ($a1a91b25d7598376$var$good_pd) {
        /*:: if(fixdate == null) fixdate = 0; */ if (fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        else if (fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
        return d;
    }
    if (str instanceof Date) return str;
    if ($a1a91b25d7598376$var$good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
        var s = d.getFullYear();
        if (str.indexOf("" + s) > -1) return d;
        d.setFullYear(d.getFullYear() + 100);
        return d;
    }
    var n = str.match(/\d+/g) || [
        "2017",
        "2",
        "19",
        "0",
        "0",
        "0"
    ];
    var out = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
    if (str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60000);
    return out;
}
function $a1a91b25d7598376$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(arr)) {
        if (debomit && $a1a91b25d7598376$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $a1a91b25d7598376$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $a1a91b25d7598376$var$utf8write($a1a91b25d7598376$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $a1a91b25d7598376$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $a1a91b25d7598376$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20AC": "\x80",
            "\u201A": "\x82",
            "\u0192": "\x83",
            "\u201E": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02C6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017D": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201C": "\x93",
            "\u201D": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02DC": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203A": "\x9b",
            "\u0153": "\x9c",
            "\u017E": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [];
    for(var i = 0; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
    return o.join("");
}
function $a1a91b25d7598376$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != "undefined" && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != "object" || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $a1a91b25d7598376$var$dup(o[k]);
    return out;
}
function $a1a91b25d7598376$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $a1a91b25d7598376$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(](.*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $a1a91b25d7598376$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
function $a1a91b25d7598376$var$fuzzytime1(M) /*:Date*/ {
    /* TODO: 1904 adjustment, keep in sync with base date */ if (!M[2]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0);
    if (M[3]) {
        if (M[4]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000);
        else return new Date(1899, 11, 30, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000);
    } else if (M[5]) return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0);
    else return new Date(1899, 11, 30, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0);
}
var $a1a91b25d7598376$var$lower_months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
function $a1a91b25d7598376$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($a1a91b25d7598376$var$FDRE1);
    if (M) return $a1a91b25d7598376$var$fuzzytime1(M);
    var o = new Date(s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $a1a91b25d7598376$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\]/)) return n;
    return o;
}
var $a1a91b25d7598376$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $a1a91b25d7598376$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $a1a91b25d7598376$var$cc2str(data.content, true);
    if (data.data) return $a1a91b25d7598376$var$debom(data.data);
    if (data.asNodeBuffer && $a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$debom(data.asNodeBuffer().toString("binary"));
    if (data.asBinary) return $a1a91b25d7598376$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $a1a91b25d7598376$var$debom($a1a91b25d7598376$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $a1a91b25d7598376$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $a1a91b25d7598376$var$char_codes(data.data);
    if (data.asNodeBuffer && $a1a91b25d7598376$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $a1a91b25d7598376$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $a1a91b25d7598376$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $a1a91b25d7598376$var$getdatabin(data) : $a1a91b25d7598376$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $a1a91b25d7598376$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $a1a91b25d7598376$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, "\\"), g = f.replace(/\\/g, "/");
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $a1a91b25d7598376$var$getzipfile(zip, file /*:string*/ ) {
    var o = $a1a91b25d7598376$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $a1a91b25d7598376$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $a1a91b25d7598376$var$getdata($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $a1a91b25d7598376$var$getdatastr($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $a1a91b25d7598376$var$getdatabin($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$zipentries(zip) {
    var k = zip.FullPaths || $a1a91b25d7598376$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != "/") o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $a1a91b25d7598376$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (typeof content == "string") {
            var res;
            if ($a1a91b25d7598376$var$has_buf) res = $a1a91b25d7598376$var$Buffer_from(content);
            else res = $a1a91b25d7598376$var$utf8decode(content);
            return $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $a1a91b25d7598376$var$zip_new() {
    return $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new();
}
function $a1a91b25d7598376$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $a1a91b25d7598376$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split("/");
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split("/");
    while(target.length !== 0){
        var step = target.shift();
        if (step === "..") result.pop();
        else if (step !== ".") result.push(step);
    }
    return result.join("/");
}
var $a1a91b25d7598376$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $a1a91b25d7598376$var$attregexg = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $a1a91b25d7598376$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, $a1a91b25d7598376$var$tagregex2 = /<[^>]*>/g;
var $a1a91b25d7598376$var$tagregex = /*#__PURE__*/ $a1a91b25d7598376$var$XML_HEADER.match($a1a91b25d7598376$var$tagregex1) ? $a1a91b25d7598376$var$tagregex1 : $a1a91b25d7598376$var$tagregex2;
var $a1a91b25d7598376$var$nsregex = /<\w*:/, $a1a91b25d7598376$var$nsregex2 = /<(\/?)\w+:/;
function $a1a91b25d7598376$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i];
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $a1a91b25d7598376$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($a1a91b25d7598376$var$nsregex2, "<$1");
}
var $a1a91b25d7598376$var$encodings = {
    "&quot;": '"',
    "&apos;": "'",
    "&gt;": ">",
    "&lt;": "<",
    "&amp;": "&"
};
var $a1a91b25d7598376$var$rencoding = /*#__PURE__*/ $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $a1a91b25d7598376$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + "", i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $a1a91b25d7598376$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $a1a91b25d7598376$var$decregex = /[&<>'"]/g, $a1a91b25d7598376$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $a1a91b25d7598376$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace($a1a91b25d7598376$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $a1a91b25d7598376$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $a1a91b25d7598376$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $a1a91b25d7598376$var$htmlcharegex = /[\u0000-\u001f]/g;
function $a1a91b25d7598376$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($a1a91b25d7598376$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $a1a91b25d7598376$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + "";
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace($a1a91b25d7598376$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $a1a91b25d7598376$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $a1a91b25d7598376$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $a1a91b25d7598376$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case "1":
        case "true":
            return true;
        case 0:
        case false:
        case "0":
        case "false":
            return false;
    }
    return false;
}
function $a1a91b25d7598376$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $a1a91b25d7598376$var$utf8readb(data) {
    var out = $a1a91b25d7598376$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString("ucs2");
}
function $a1a91b25d7598376$var$utf8readc(data) {
    return $a1a91b25d7598376$var$Buffer_from(data, "binary").toString("utf8");
}
var $a1a91b25d7598376$var$utf8corpus = "foo bar baz\xe2\x98\x83\xf0\x9f\x8d\xa3";
var $a1a91b25d7598376$var$utf8read = $a1a91b25d7598376$var$has_buf && /*#__PURE__*/ ($a1a91b25d7598376$var$utf8readc($a1a91b25d7598376$var$utf8corpus) == /*#__PURE__*/ $a1a91b25d7598376$var$utf8reada($a1a91b25d7598376$var$utf8corpus) && $a1a91b25d7598376$var$utf8readc || /*#__PURE__*/ $a1a91b25d7598376$var$utf8readb($a1a91b25d7598376$var$utf8corpus) == /*#__PURE__*/ $a1a91b25d7598376$var$utf8reada($a1a91b25d7598376$var$utf8corpus) && $a1a91b25d7598376$var$utf8readb) || $a1a91b25d7598376$var$utf8reada;
var $a1a91b25d7598376$var$utf8write /*:StringConv*/  = $a1a91b25d7598376$var$has_buf ? function(data) {
    return $a1a91b25d7598376$var$Buffer_from(data, "utf8").toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
// matches <foo>...</foo> extracts content
var $a1a91b25d7598376$var$matchtag = /*#__PURE__*/ function() {
    var mtcache /*:{[k:string]:RegExp}*/  = {} /*:any*/ ;
    return function matchtag(f /*:string*/ , g /*:?string*/ ) /*:RegExp*/ {
        var t = f + "|" + (g || "");
        if (mtcache[t]) return mtcache[t];
        return mtcache[t] = new RegExp("<(?:\\w+:)?" + f + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + f + ">", g || "");
    };
}();
var $a1a91b25d7598376$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            "nbsp",
            " "
        ],
        [
            "middot",
            "\xb7"
        ],
        [
            "quot",
            '"'
        ],
        [
            "apos",
            "'"
        ],
        [
            "gt",
            ">"
        ],
        [
            "lt",
            "<"
        ],
        [
            "amp",
            "&"
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp("&" + x[0] + ";", "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/[\t\n\r ]+$/, "")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $a1a91b25d7598376$var$vtregex = /*#__PURE__*/ function() {
    var vt_cache = {};
    return function vt_regex(bt) {
        if (vt_cache[bt] !== undefined) return vt_cache[bt];
        return vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", "g");
    };
}();
var $a1a91b25d7598376$var$vtvregex = /<\/?(?:vt:)?variant>/g, $a1a91b25d7598376$var$vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function $a1a91b25d7598376$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $a1a91b25d7598376$var$parsexmltag(data);
    var matches /*:Array<string>*/  = data.match($a1a91b25d7598376$var$vtregex(h.baseType)) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($a1a91b25d7598376$var$vtvregex, "").match($a1a91b25d7598376$var$vtmregex);
        if (v) res.push({
            v: $a1a91b25d7598376$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $a1a91b25d7598376$var$wtregex = /(^\s|\s$|\n)/;
function $a1a91b25d7598376$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return "<" + f + (g.match($a1a91b25d7598376$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f + ">";
}
function $a1a91b25d7598376$var$wxt_helper(h) /*:string*/ {
    return $a1a91b25d7598376$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $a1a91b25d7598376$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return "<" + f + (h != null ? $a1a91b25d7598376$var$wxt_helper(h) : "") + (g != null ? (g.match($a1a91b25d7598376$var$wtregex) ? ' xml:space="preserve"' : "") + ">" + g + "</" + f : "/") + ">";
}
function $a1a91b25d7598376$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $a1a91b25d7598376$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case "string":
            var o = $a1a91b25d7598376$var$writextag("vt:lpwstr", $a1a91b25d7598376$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case "number":
            return $a1a91b25d7598376$var$writextag((s | 0) == s ? "vt:i4" : "vt:r8", $a1a91b25d7598376$var$escapexml(String(s)));
        case "boolean":
            return $a1a91b25d7598376$var$writextag("vt:bool", s ? "true" : "false");
    }
    if (s instanceof Date) return $a1a91b25d7598376$var$writextag("vt:filetime", $a1a91b25d7598376$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $a1a91b25d7598376$var$xlml_normalize(d) /*:string*/ {
    if ($a1a91b25d7598376$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $a1a91b25d7598376$require$Buffer.isBuffer(d)) return d.toString("utf8");
    if (typeof d === "string") return d;
    /* duktape */ if (typeof Uint8Array !== "undefined" && d instanceof Uint8Array) return $a1a91b25d7598376$var$utf8read($a1a91b25d7598376$var$a2s($a1a91b25d7598376$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags */ var $a1a91b25d7598376$var$xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/](?:[^>=]|="[^"]*?")*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var $a1a91b25d7598376$var$XMLNS = {
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: "http://schemas.openxmlformats.org/package/2006/content-types",
    RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
    TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
    "dc": "http://purl.org/dc/elements/1.1/",
    "dcterms": "http://purl.org/dc/terms/",
    "dcmitype": "http://purl.org/dc/dcmitype/",
    "mx": "http://schemas.microsoft.com/office/mac/excel/2008/main",
    "r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
    "sjs": "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
    "vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
    "xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "xsd": "http://www.w3.org/2001/XMLSchema"
} /*:any*/ ;
var $a1a91b25d7598376$var$XMLNS_main = [
    "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
    "http://purl.oclc.org/ooxml/spreadsheetml/main",
    "http://schemas.microsoft.com/office/excel/2006/main",
    "http://schemas.microsoft.com/office/excel/2006/2"
];
var $a1a91b25d7598376$var$XLMLNS = {
    "o": "urn:schemas-microsoft-com:office:office",
    "x": "urn:schemas-microsoft-com:office:excel",
    "ss": "urn:schemas-microsoft-com:office:spreadsheet",
    "dt": "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
    "mv": "http://macVmlSchemaUri",
    "v": "urn:schemas-microsoft-com:vml",
    "html": "http://www.w3.org/TR/REC-html40"
} /*:any*/ ;
function $a1a91b25d7598376$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $a1a91b25d7598376$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $a1a91b25d7598376$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $a1a91b25d7598376$var$__toBuffer = $a1a91b25d7598376$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $a1a91b25d7598376$require$Buffer.isBuffer(bufs[0][0]) ? $a1a91b25d7598376$require$Buffer.concat(bufs[0].map(function(x) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(x) ? x : $a1a91b25d7598376$var$Buffer_from(x);
    })) : $a1a91b25d7598376$var$___toBuffer(bufs);
} : $a1a91b25d7598376$var$___toBuffer;
var $a1a91b25d7598376$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($a1a91b25d7598376$var$__readUInt16LE(b, i)));
    return ss.join("").replace($a1a91b25d7598376$var$chr0, "");
};
var $a1a91b25d7598376$var$__utf16le = $a1a91b25d7598376$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___utf16le(b, s, e);
    return b.toString("utf16le", s, e).replace($a1a91b25d7598376$var$chr0, "") /*.replace(chr1,'!')*/ ;
} : $a1a91b25d7598376$var$___utf16le;
var $a1a91b25d7598376$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $a1a91b25d7598376$var$__hexlify = $a1a91b25d7598376$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $a1a91b25d7598376$require$Buffer.isBuffer(b) ? b.toString("hex", s, s + l) : $a1a91b25d7598376$var$___hexlify(b, s, l);
} : $a1a91b25d7598376$var$___hexlify;
var $a1a91b25d7598376$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($a1a91b25d7598376$var$__readUInt8(b, i)));
    return ss.join("");
};
var $a1a91b25d7598376$var$__utf8 = $a1a91b25d7598376$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $a1a91b25d7598376$require$Buffer.isBuffer(b) ? b.toString("utf8", s, e) : $a1a91b25d7598376$var$___utf8(b, s, e);
} : $a1a91b25d7598376$var$___utf8;
var $a1a91b25d7598376$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__lpstr = $a1a91b25d7598376$var$___lpstr;
var $a1a91b25d7598376$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__cpstr = $a1a91b25d7598376$var$___cpstr;
var $a1a91b25d7598376$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__lpwstr = $a1a91b25d7598376$var$___lpwstr;
var $a1a91b25d7598376$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $a1a91b25d7598376$var$__lpp4 = $a1a91b25d7598376$var$___lpp4;
var $a1a91b25d7598376$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $a1a91b25d7598376$var$__8lpp4 = $a1a91b25d7598376$var$___8lpp4;
var $a1a91b25d7598376$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $a1a91b25d7598376$var$read_double_le(b, idx);
};
var $a1a91b25d7598376$var$__double = $a1a91b25d7598376$var$___double;
var $a1a91b25d7598376$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($a1a91b25d7598376$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $a1a91b25d7598376$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $a1a91b25d7598376$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString("utf8", i + 4, i + 4 + len - 1) : "";
    };
    $a1a91b25d7598376$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len - 1);
    };
    $a1a91b25d7598376$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf16le", i + 4, i + 4 + len);
    };
    $a1a91b25d7598376$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString("utf8", i + 4, i + 4 + len);
    };
    $a1a91b25d7598376$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($a1a91b25d7598376$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $a1a91b25d7598376$var$___double(b, i);
    };
    $a1a91b25d7598376$var$is_buf = function is_buf_b(a) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $a1a91b25d7598376$var$cpdoit() {
    $a1a91b25d7598376$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($a1a91b25d7598376$var$chr0, "");
    };
    $a1a91b25d7598376$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $a1a91b25d7598376$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $a1a91b25d7598376$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $a1a91b25d7598376$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $a1a91b25d7598376$var$$cptable !== "undefined") $a1a91b25d7598376$var$cpdoit();
var $a1a91b25d7598376$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $a1a91b25d7598376$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $a1a91b25d7598376$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $a1a91b25d7598376$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $a1a91b25d7598376$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $a1a91b25d7598376$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $a1a91b25d7598376$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case "dbcs":
            loc = this.l;
            if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(this) && $a1a91b25d7598376$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($a1a91b25d7598376$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case "utf8":
            o = $a1a91b25d7598376$var$__utf8(this, this.l, this.l + size);
            break;
        case "utf16le":
            size *= 2;
            o = $a1a91b25d7598376$var$__utf16le(this, this.l, this.l + size);
            break;
        case "wstr":
            if (typeof $a1a91b25d7598376$var$$cptable !== "undefined") o = $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $a1a91b25d7598376$var$ReadShift.call(this, size, "dbcs");
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case "lpstr-ansi":
            o = $a1a91b25d7598376$var$__lpstr(this, this.l);
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        case "lpstr-cp":
            o = $a1a91b25d7598376$var$__cpstr(this, this.l);
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case "lpwstr":
            o = $a1a91b25d7598376$var$__lpwstr(this, this.l);
            size = 4 + 2 * $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case "lpp4":
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            o = $a1a91b25d7598376$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case "8lpp4":
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            o = $a1a91b25d7598376$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case "cstr":
            size = 0;
            o = "";
            while((w = $a1a91b25d7598376$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($a1a91b25d7598376$var$_getchar(w));
            o = oo.join("");
            break;
        case "_wstr":
            size = 0;
            o = "";
            while((w = $a1a91b25d7598376$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($a1a91b25d7598376$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case "dbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $a1a91b25d7598376$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $a1a91b25d7598376$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($a1a91b25d7598376$var$_getchar($a1a91b25d7598376$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case "cpstr":
            if (typeof $a1a91b25d7598376$var$$cptable !== "undefined") {
                o = $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case "sbcs-cont":
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $a1a91b25d7598376$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $a1a91b25d7598376$var$ReadShift.call(this, size - i, w ? "dbcs-cont" : "sbcs-cont");
                    return oo.join("") + vv;
                }
                oo.push($a1a91b25d7598376$var$_getchar($a1a91b25d7598376$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $a1a91b25d7598376$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === "i" ? $a1a91b25d7598376$var$__readInt16LE : $a1a91b25d7598376$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === "i" || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $a1a91b25d7598376$var$__readInt32LE : $a1a91b25d7598376$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === "f") {
                        if (size == 8) oR = $a1a91b25d7598376$var$__double(this, this.l);
                        else oR = $a1a91b25d7598376$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $a1a91b25d7598376$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $a1a91b25d7598376$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
    b[idx + 2] = val >>> 16 & 0xFF;
    b[idx + 3] = val >>> 24 & 0xFF;
};
var $a1a91b25d7598376$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >> 8 & 0xFF;
    b[idx + 2] = val >> 16 & 0xFF;
    b[idx + 3] = val >> 24 & 0xFF;
};
var $a1a91b25d7598376$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val & 0xFF;
    b[idx + 1] = val >>> 8 & 0xFF;
};
function $a1a91b25d7598376$var$WriteShift(t /*:number*/ , val /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === "dbcs") {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)$a1a91b25d7598376$var$__writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
        size = 2 * val.length;
    } else if (f === "sbcs" || f == "cpstr") {
        if (typeof $a1a91b25d7598376$var$$cptable !== "undefined" && $a1a91b25d7598376$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i){
                var cpp = $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, val.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val.length;
        } else if (typeof $a1a91b25d7598376$var$$cptable !== "undefined" && f == "cpstr") {
            cpp = $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_codepage, val);
            /* replace null bytes with _ when relevant */ if (cpp.length == val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[i] == 0 && val.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val.length) {
                for(i = 0; i < val.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val = val.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val.length; ++i)this[this.l + i] = val.charCodeAt(i) & 0xFF;
            size = val.length;
        }
    } else if (f === "hex") {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === "utf16le") {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val.length, t); ++i){
            var cc = val.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val & 0xFF;
            val >>>= 8;
            this[this.l + 1] = val & 0xFF;
            val >>>= 8;
            this[this.l + 2] = val & 0xFF;
            break;
        case 4:
            size = 4;
            $a1a91b25d7598376$var$__writeUInt32LE(this, val, this.l);
            break;
        case 8:
            size = 8;
            if (f === "f") {
                $a1a91b25d7598376$var$write_double_le(this, val, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $a1a91b25d7598376$var$__writeInt32LE(this, val, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $a1a91b25d7598376$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $a1a91b25d7598376$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + "Expected " + hexstr + " saw " + m);
    this.l += hexstr.length >> 1;
}
function $a1a91b25d7598376$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $a1a91b25d7598376$var$ReadShift /*:: :any)*/ ;
    blob.chk = $a1a91b25d7598376$var$CheckField;
    blob.write_shift = $a1a91b25d7598376$var$WriteShift;
}
function $a1a91b25d7598376$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $a1a91b25d7598376$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $a1a91b25d7598376$var$new_raw_buf(sz);
    $a1a91b25d7598376$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $a1a91b25d7598376$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $a1a91b25d7598376$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $a1a91b25d7598376$var$XLSBRecordEnum[RT] || $a1a91b25d7598376$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $a1a91b25d7598376$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $a1a91b25d7598376$var$has_buf ? 256 : 2048;
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $a1a91b25d7598376$var$new_buf(sz);
        $a1a91b25d7598376$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $a1a91b25d7598376$var$bconcat(bufs);
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $a1a91b25d7598376$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $a1a91b25d7598376$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $a1a91b25d7598376$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $a1a91b25d7598376$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $a1a91b25d7598376$var$shift_range_xls(cell, range, opts) {
    var out = $a1a91b25d7598376$var$dup(cell);
    out.s = $a1a91b25d7598376$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $a1a91b25d7598376$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $a1a91b25d7598376$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $a1a91b25d7598376$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $a1a91b25d7598376$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $a1a91b25d7598376$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $a1a91b25d7598376$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $a1a91b25d7598376$var$fix_row(s);
    return s;
}
function $a1a91b25d7598376$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(r.e.r);
    }
    return $a1a91b25d7598376$var$encode_cell_xls(r.s, opts.biff) + ":" + $a1a91b25d7598376$var$encode_cell_xls(r.e, opts.biff);
}
function $a1a91b25d7598376$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($a1a91b25d7598376$var$unfix_row(rowstr), 10) - 1;
}
function $a1a91b25d7598376$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $a1a91b25d7598376$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $a1a91b25d7598376$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $a1a91b25d7598376$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $a1a91b25d7598376$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $a1a91b25d7598376$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $a1a91b25d7598376$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $a1a91b25d7598376$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $a1a91b25d7598376$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $a1a91b25d7598376$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $a1a91b25d7598376$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $a1a91b25d7598376$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $a1a91b25d7598376$var$decode_cell(range),
        e: $a1a91b25d7598376$var$decode_cell(range)
    };
    return {
        s: $a1a91b25d7598376$var$decode_cell(range.slice(0, idx)),
        e: $a1a91b25d7598376$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $a1a91b25d7598376$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === "undefined" || typeof ce === "number") /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $a1a91b25d7598376$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== "string") cs = $a1a91b25d7598376$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== "string") ce = $a1a91b25d7598376$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $a1a91b25d7598376$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $a1a91b25d7598376$var$decode_range(a1);
    return "$" + $a1a91b25d7598376$var$encode_col(s.s.c) + "$" + $a1a91b25d7598376$var$encode_row(s.s.r) + ":$" + $a1a91b25d7598376$var$encode_col(s.e.c) + "$" + $a1a91b25d7598376$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $a1a91b25d7598376$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $a1a91b25d7598376$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $a1a91b25d7598376$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == "d" && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, q ? $a1a91b25d7598376$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $a1a91b25d7598376$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $a1a91b25d7598376$var$datenum(v) : v);
    } catch (e) {
        return "" + v;
    }
}
function $a1a91b25d7598376$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == "z") return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == "d" && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $a1a91b25d7598376$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $a1a91b25d7598376$var$safe_format_cell(cell, cell.v);
    return $a1a91b25d7598376$var$safe_format_cell(cell, v);
}
function $a1a91b25d7598376$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $a1a91b25d7598376$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($a1a91b25d7598376$var$DENSE != null && dense == null) dense = $a1a91b25d7598376$var$DENSE;
    var ws /*:Worksheet*/  = _ws || {} /*:any*/ ;
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $a1a91b25d7598376$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
        if (!ws["!ref"]) ws["!ref"] = "A1:A1";
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = _range.e.r + 1;
    }
    var row = [];
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R, __Rstr = "" + (__R + 1);
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        for(var C = 0; C != data[R].length; ++C){
            if (typeof data[R][C] === "undefined") continue;
            var cell /*:Cell*/  = {
                v: data[R][C]
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            if (data[R][C] && typeof data[R][C] === "object" && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data[R][C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = "n";
                    else if (o.nullError) {
                        cell.t = "e";
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = "z";
                } else if (typeof cell.v === "number") cell.t = "n";
                else if (typeof cell.v === "boolean") cell.t = "b";
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                    if (o.cellDates) {
                        cell.t = "d";
                        cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, $a1a91b25d7598376$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = "n";
                        cell.v = $a1a91b25d7598376$var$datenum(cell.v, o.date1904);
                        cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = "s";
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $a1a91b25d7598376$var$encode_col(__C) + __Rstr /*:any*/ ;
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (range.s.c < 10000000) ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $a1a91b25d7598376$var$sheet_add_aoa(null, data, opts);
}
function $a1a91b25d7598376$var$parse_Int32LE(data) {
    return data.read_shift(4, "i");
}
function $a1a91b25d7598376$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $a1a91b25d7598376$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $a1a91b25d7598376$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $a1a91b25d7598376$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $a1a91b25d7598376$var$write_StrRun(run, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $a1a91b25d7598376$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $a1a91b25d7598376$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($a1a91b25d7598376$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $a1a91b25d7598376$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $a1a91b25d7598376$var$parse_BrtCommentText = $a1a91b25d7598376$var$parse_RichStr;
function $a1a91b25d7598376$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $a1a91b25d7598376$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $a1a91b25d7598376$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $a1a91b25d7598376$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $a1a91b25d7598376$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $a1a91b25d7598376$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $a1a91b25d7598376$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $a1a91b25d7598376$var$parse_XLSBCodeName = $a1a91b25d7598376$var$parse_XLWideString;
var $a1a91b25d7598376$var$write_XLSBCodeName = $a1a91b25d7598376$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $a1a91b25d7598376$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, "dbcs");
}
function $a1a91b25d7598376$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, "dbcs");
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $a1a91b25d7598376$var$parse_XLNameWideString = $a1a91b25d7598376$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $a1a91b25d7598376$var$parse_RelID = $a1a91b25d7598376$var$parse_XLNullableWideString;
var $a1a91b25d7598376$var$write_RelID = $a1a91b25d7598376$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $a1a91b25d7598376$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $a1a91b25d7598376$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $a1a91b25d7598376$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $a1a91b25d7598376$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $a1a91b25d7598376$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $a1a91b25d7598376$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $a1a91b25d7598376$var$parse_UncheckedRfX = $a1a91b25d7598376$var$parse_RfX;
var $a1a91b25d7598376$var$write_UncheckedRfX = $a1a91b25d7598376$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $a1a91b25d7598376$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, "f");
}
function $a1a91b25d7598376$var$write_Xnum(data, o) {
    return (o || $a1a91b25d7598376$var$new_buf(8)).write_shift(8, data, "f");
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $a1a91b25d7598376$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, "i");
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $a1a91b25d7598376$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $a1a91b25d7598376$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $a1a91b25d7598376$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $a1a91b25d7598376$var$write_BrtColor(color, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || "FFFFFF";
        if (typeof rgb == "number") rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $a1a91b25d7598376$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $a1a91b25d7598376$var$write_FontFlags(font, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $a1a91b25d7598376$var$parse_ClipboardFormatOrAnsiString(o) {
    return $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, 1);
}
function $a1a91b25d7598376$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $a1a91b25d7598376$var$VT_I2 = 0x0002;
var $a1a91b25d7598376$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $a1a91b25d7598376$var$VT_BOOL = 0x000B;
var $a1a91b25d7598376$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $a1a91b25d7598376$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $a1a91b25d7598376$var$VT_FILETIME = 0x0040;
var $a1a91b25d7598376$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $a1a91b25d7598376$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $a1a91b25d7598376$var$VT_VECTOR_VARIANT = 0x100C;
var $a1a91b25d7598376$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $a1a91b25d7598376$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $a1a91b25d7598376$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $a1a91b25d7598376$var$VT_CUSTOM = [
    $a1a91b25d7598376$var$VT_STRING,
    $a1a91b25d7598376$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $a1a91b25d7598376$var$DocSummaryPIDDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $a1a91b25d7598376$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Category",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "PresentationFormat",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "ByteCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x05: {
        n: "LineCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x06: {
        n: "ParagraphCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x07: {
        n: "SlideCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x08: {
        n: "NoteCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x09: {
        n: "HiddenCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x0a: {
        n: "MultimediaClipCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x0b: {
        n: "ScaleCrop",
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    /*::[*/ 0x0c: {
        n: "HeadingPairs",
        t: $a1a91b25d7598376$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    /*::[*/ 0x0d: {
        n: "TitlesOfParts",
        t: $a1a91b25d7598376$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    /*::[*/ 0x0e: {
        n: "Manager",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x0f: {
        n: "Company",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x10: {
        n: "LinksUpToDate",
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    /*::[*/ 0x11: {
        n: "CharacterCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x13: {
        n: "SharedDoc",
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    /*::[*/ 0x16: {
        n: "HyperlinksChanged",
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    /*::[*/ 0x17: {
        n: "AppVersion",
        t: $a1a91b25d7598376$var$VT_I4,
        p: "version"
    },
    /*::[*/ 0x18: {
        n: "DigSig",
        t: $a1a91b25d7598376$var$VT_BLOB
    },
    /*::[*/ 0x1A: {
        n: "ContentType",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x1B: {
        n: "ContentStatus",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x1C: {
        n: "Language",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x1D: {
        n: "Version",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $a1a91b25d7598376$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $a1a91b25d7598376$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $a1a91b25d7598376$var$SummaryPIDSI = {
    /*::[*/ 0x01: {
        n: "CodePage",
        t: $a1a91b25d7598376$var$VT_I2
    },
    /*::[*/ 0x02: {
        n: "Title",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x03: {
        n: "Subject",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x04: {
        n: "Author",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x05: {
        n: "Keywords",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x06: {
        n: "Comments",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x07: {
        n: "Template",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x08: {
        n: "LastAuthor",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x09: {
        n: "RevNumber",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x0A: {
        n: "EditTime",
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    /*::[*/ 0x0B: {
        n: "LastPrinted",
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    /*::[*/ 0x0C: {
        n: "CreatedDate",
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    /*::[*/ 0x0D: {
        n: "ModifiedDate",
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    /*::[*/ 0x0E: {
        n: "PageCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x0F: {
        n: "WordCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x10: {
        n: "CharCount",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0x11: {
        n: "Thumbnail",
        t: $a1a91b25d7598376$var$VT_CF
    },
    /*::[*/ 0x12: {
        n: "Application",
        t: $a1a91b25d7598376$var$VT_STRING
    },
    /*::[*/ 0x13: {
        n: "DocSecurity",
        t: $a1a91b25d7598376$var$VT_I4
    },
    /*::[*/ 0xFF: {},
    /* [MS-OLEPS] 2.18 */ /*::[*/ 0x80000000: {
        n: "Locale",
        t: $a1a91b25d7598376$var$VT_UI4
    },
    /*::[*/ 0x80000003: {
        n: "Behavior",
        t: $a1a91b25d7598376$var$VT_UI4
    },
    /*::[*/ 0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $a1a91b25d7598376$var$CountryEnum = {
    /*::[*/ 0x0001: "US",
    /*::[*/ 0x0002: "CA",
    /*::[*/ 0x0003: "",
    /*::[*/ 0x0007: "RU",
    /*::[*/ 0x0014: "EG",
    /*::[*/ 0x001E: "GR",
    /*::[*/ 0x001F: "NL",
    /*::[*/ 0x0020: "BE",
    /*::[*/ 0x0021: "FR",
    /*::[*/ 0x0022: "ES",
    /*::[*/ 0x0024: "HU",
    /*::[*/ 0x0027: "IT",
    /*::[*/ 0x0029: "CH",
    /*::[*/ 0x002B: "AT",
    /*::[*/ 0x002C: "GB",
    /*::[*/ 0x002D: "DK",
    /*::[*/ 0x002E: "SE",
    /*::[*/ 0x002F: "NO",
    /*::[*/ 0x0030: "PL",
    /*::[*/ 0x0031: "DE",
    /*::[*/ 0x0034: "MX",
    /*::[*/ 0x0037: "BR",
    /*::[*/ 0x003d: "AU",
    /*::[*/ 0x0040: "NZ",
    /*::[*/ 0x0042: "TH",
    /*::[*/ 0x0051: "JP",
    /*::[*/ 0x0052: "KR",
    /*::[*/ 0x0054: "VN",
    /*::[*/ 0x0056: "CN",
    /*::[*/ 0x005A: "TR",
    /*::[*/ 0x0069: "JS",
    /*::[*/ 0x00D5: "DZ",
    /*::[*/ 0x00D8: "MA",
    /*::[*/ 0x00DA: "LY",
    /*::[*/ 0x015F: "PT",
    /*::[*/ 0x0162: "IS",
    /*::[*/ 0x0166: "FI",
    /*::[*/ 0x01A4: "CZ",
    /*::[*/ 0x0376: "TW",
    /*::[*/ 0x03C1: "LB",
    /*::[*/ 0x03C2: "JO",
    /*::[*/ 0x03C3: "SY",
    /*::[*/ 0x03C4: "IQ",
    /*::[*/ 0x03C5: "KW",
    /*::[*/ 0x03C6: "SA",
    /*::[*/ 0x03CB: "AE",
    /*::[*/ 0x03CC: "IL",
    /*::[*/ 0x03CE: "QA",
    /*::[*/ 0x03D5: "IR",
    /*::[*/ 0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $a1a91b25d7598376$var$XLSFillPattern = [
    null,
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
function $a1a91b25d7598376$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $a1a91b25d7598376$var$_XLSIcv = /*#__PURE__*/ $a1a91b25d7598376$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $a1a91b25d7598376$var$XLSIcv = /*#__PURE__*/ $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $a1a91b25d7598376$var$BErr = {
    /*::[*/ 0x00: "#NULL!",
    /*::[*/ 0x07: "#DIV/0!",
    /*::[*/ 0x0F: "#VALUE!",
    /*::[*/ 0x17: "#REF!",
    /*::[*/ 0x1D: "#NAME?",
    /*::[*/ 0x24: "#NUM!",
    /*::[*/ 0x2A: "#N/A",
    /*::[*/ 0x2B: "#GETTING_DATA",
    /*::[*/ 0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $a1a91b25d7598376$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $a1a91b25d7598376$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $a1a91b25d7598376$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $a1a91b25d7598376$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $a1a91b25d7598376$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$parse_ct(data /*:?string*/ ) {
    var ct = $a1a91b25d7598376$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0].replace($a1a91b25d7598376$var$nsregex, "<")){
            case "<?xml":
                break;
            case "<Types":
                ct.xmlns = y["xmlns" + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case "<Default":
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case "<Override":
                if (ct[$a1a91b25d7598376$var$ct2type[y.ContentType]] !== undefined) ct[$a1a91b25d7598376$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $a1a91b25d7598376$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $a1a91b25d7598376$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $a1a91b25d7598376$var$evert_arr($a1a91b25d7598376$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $a1a91b25d7598376$var$XML_HEADER;
        o[o.length] = $a1a91b25d7598376$var$writextag("Types", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS.CT,
            "xmlns:xsd": $a1a91b25d7598376$var$XMLNS.xsd,
            "xmlns:xsi": $a1a91b25d7598376$var$XMLNS.xsi
        });
        o = o.concat([
            [
                "xml",
                "application/xml"
            ],
            [
                "bin",
                "application/vnd.ms-excel.sheet.binary.macroEnabled.main"
            ],
            [
                "vml",
                "application/vnd.openxmlformats-officedocument.vmlDrawing"
            ],
            [
                "data",
                "application/vnd.openxmlformats-officedocument.model+data"
            ],
            /* from test files */ [
                "bmp",
                "image/bmp"
            ],
            [
                "png",
                "image/png"
            ],
            [
                "gif",
                "image/gif"
            ],
            [
                "emf",
                "image/x-emf"
            ],
            [
                "wmf",
                "image/x-wmf"
            ],
            [
                "jpg",
                "image/jpeg"
            ],
            [
                "jpeg",
                "image/jpeg"
            ],
            [
                "tif",
                "image/tiff"
            ],
            [
                "tiff",
                "image/tiff"
            ],
            [
                "pdf",
                "application/pdf"
            ],
            [
                "rels",
                "application/vnd.openxmlformats-package.relationships+xml"
            ]
        ].map(function(x) {
            return $a1a91b25d7598376$var$writextag("Default", null, {
                "Extension": x[0],
                "ContentType": x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $a1a91b25d7598376$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $a1a91b25d7598376$var$CT_LIST[w][opts.bookType] || $a1a91b25d7598376$var$CT_LIST[w]["xlsx"]
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $a1a91b25d7598376$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": $a1a91b25d7598376$var$CT_LIST[w][opts.bookType] || $a1a91b25d7598376$var$CT_LIST[w]["xlsx"]
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $a1a91b25d7598376$var$writextag("Override", null, {
                "PartName": (v[0] == "/" ? "" : "/") + v,
                "ContentType": type2ct[t][0]
            });
        });
    };
    f1("workbooks");
    f2("sheets");
    f2("charts");
    f3("themes");
    [
        "strs",
        "styles"
    ].forEach(f1);
    [
        "coreprops",
        "extprops",
        "custprops"
    ].forEach(f3);
    f3("vba");
    f3("comments");
    f3("threadedcomments");
    f3("drawings");
    f2("metadata");
    f3("people");
    if (!raw && o.length > 2) {
        o[o.length] = "</Types>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $a1a91b25d7598376$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $a1a91b25d7598376$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + "_rels/" + file.slice(n + 1) + ".rels";
}
function $a1a91b25d7598376$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== "/") currentFilePath = "/" + currentFilePath;
    var hash = {};
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === "<Relationship") {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $a1a91b25d7598376$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === "External" ? y.Target : $a1a91b25d7598376$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $a1a91b25d7598376$var$write_rels(rels) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("Relationships", null, {
            //'xmlns:ns0': XMLNS.RELS,
            "xmlns": $a1a91b25d7598376$var$XMLNS.RELS
        })
    ];
    $a1a91b25d7598376$var$keys(rels["!id"]).forEach(function(rid) {
        o[o.length] = $a1a91b25d7598376$var$writextag("Relationship", null, rels["!id"][rid]);
    });
    if (o.length > 2) {
        o[o.length] = "</Relationships>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $a1a91b25d7598376$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels["!id"]) rels["!id"] = {};
    if (!rels["!idx"]) rels["!idx"] = 1;
    if (rId < 0) for(rId = rels["!idx"]; rels["!id"]["rId" + rId]; ++rId);
    rels["!idx"] = rId + 1;
    relobj.Id = "rId" + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $a1a91b25d7598376$var$RELS.HLINK,
        $a1a91b25d7598376$var$RELS.XPATH,
        $a1a91b25d7598376$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels["!id"][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels["!id"][relobj.Id] = relobj;
    rels[("/" + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */ /* Part 3 Section 4 Manifest File */ var $a1a91b25d7598376$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $a1a91b25d7598376$var$parse_manifest(d, opts) {
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break; // 4.2 <manifest:manifest>
        case "file-entry":
            FEtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $a1a91b25d7598376$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $a1a91b25d7598376$var$write_manifest(manifest /*:Array<Array<string> >*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
/* Part 3 Section 6 Metadata Manifest File */ function $a1a91b25d7598376$var$write_rdf_type(file /*:string*/ , res /*:string*/ , tag /*:?string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $a1a91b25d7598376$var$write_rdf_has(base /*:string*/ , file /*:string*/ ) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $a1a91b25d7598376$var$write_rdf(rdf) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($a1a91b25d7598376$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($a1a91b25d7598376$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($a1a91b25d7598376$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
/* TODO: pull properties */ function $a1a91b25d7598376$var$write_meta_ods() /*:string*/ {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $a1a91b25d7598376$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $a1a91b25d7598376$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        "date"
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        "date"
    ]
];
var $a1a91b25d7598376$var$CORE_PROPS_REGEX /*:Array<RegExp>*/  = /*#__PURE__*/ function() {
    var r = new Array($a1a91b25d7598376$var$CORE_PROPS.length);
    for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i];
        var g = "(?:" + f[0].slice(0, f[0].indexOf(":")) + ":)" + f[0].slice(f[0].indexOf(":") + 1);
        r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)</" + g + ">");
    }
    return r;
}();
function $a1a91b25d7598376$var$parse_core_props(data) {
    var p = {};
    data = $a1a91b25d7598376$var$utf8read(data);
    for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i], cur = data.match($a1a91b25d7598376$var$CORE_PROPS_REGEX[i]);
        if (cur != null && cur.length > 0) p[f[1]] = $a1a91b25d7598376$var$unescapexml(cur[1]);
        if (f[2] === "date" && p[f[1]]) p[f[1]] = $a1a91b25d7598376$var$parseDate(p[f[1]]);
    }
    return p;
}
function $a1a91b25d7598376$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $a1a91b25d7598376$var$escapexml(g);
    o[o.length] = h ? $a1a91b25d7598376$var$writextag(f, g, h) : $a1a91b25d7598376$var$writetag(f, g);
}
function $a1a91b25d7598376$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("cp:coreProperties", null, {
            //'xmlns': XMLNS.CORE_PROPS,
            "xmlns:cp": $a1a91b25d7598376$var$XMLNS.CORE_PROPS,
            "xmlns:dc": $a1a91b25d7598376$var$XMLNS.dc,
            "xmlns:dcterms": $a1a91b25d7598376$var$XMLNS.dcterms,
            "xmlns:dcmitype": $a1a91b25d7598376$var$XMLNS.dcmitype,
            "xmlns:xsi": $a1a91b25d7598376$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $a1a91b25d7598376$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $a1a91b25d7598376$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $a1a91b25d7598376$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $a1a91b25d7598376$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $a1a91b25d7598376$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = "</cp:coreProperties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $a1a91b25d7598376$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $a1a91b25d7598376$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $a1a91b25d7598376$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $a1a91b25d7598376$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $a1a91b25d7598376$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $a1a91b25d7598376$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $a1a91b25d7598376$var$utf8read(data);
    $a1a91b25d7598376$var$EXT_PROPS.forEach(function(f) {
        var xml = (data.match($a1a91b25d7598376$var$matchtag(f[0])) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $a1a91b25d7598376$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)</" + f[0] + ">"));
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $a1a91b25d7598376$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $a1a91b25d7598376$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $a1a91b25d7598376$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $a1a91b25d7598376$var$XML_HEADER;
    o[o.length] = $a1a91b25d7598376$var$writextag("Properties", null, {
        "xmlns": $a1a91b25d7598376$var$XMLNS.EXT_PROPS,
        "xmlns:vt": $a1a91b25d7598376$var$XMLNS.vt
    });
    $a1a91b25d7598376$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case "string":
                v = $a1a91b25d7598376$var$escapexml(String(cp[f[1]]));
                break;
            case "bool":
                v = cp[f[1]] ? "true" : "false";
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W("HeadingPairs", W("vt:vector", W("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + W("vt:variant", W("vt:i4", String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W("TitlesOfParts", W("vt:vector", cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $a1a91b25d7598376$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $a1a91b25d7598376$var$custregex = /<[^>]+>[^<]*/g;
function $a1a91b25d7598376$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($a1a91b25d7598376$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<Properties":
                break;
            case "<property":
                name = $a1a91b25d7598376$var$unescapexml(y.name);
                break;
            case "</property>":
                name = null;
                break;
            default:
                if (x.indexOf("<vt:") === 0) {
                    var toks = x.split(">");
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case "lpstr":
                        case "bstr":
                        case "lpwstr":
                            p[name] = $a1a91b25d7598376$var$unescapexml(text);
                            break;
                        case "bool":
                            p[name] = $a1a91b25d7598376$var$parsexmlbool(text);
                            break;
                        case "i1":
                        case "i2":
                        case "i4":
                        case "i8":
                        case "int":
                        case "uint":
                            p[name] = parseInt(text, 10);
                            break;
                        case "r4":
                        case "r8":
                        case "decimal":
                            p[name] = parseFloat(text);
                            break;
                        case "filetime":
                        case "date":
                            p[name] = $a1a91b25d7598376$var$parseDate(text);
                            break;
                        case "cy":
                        case "error":
                            p[name] = $a1a91b25d7598376$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == "/") break;
                            if (opts.WTF && typeof console !== "undefined") console.warn("Unexpected", x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $a1a91b25d7598376$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("Properties", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS.CUST_PROPS,
            "xmlns:vt": $a1a91b25d7598376$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $a1a91b25d7598376$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $a1a91b25d7598376$var$writextag("property", $a1a91b25d7598376$var$write_vt(cp[k], true), {
            "fmtid": "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
            "pid": pid,
            "name": $a1a91b25d7598376$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = "</Properties>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $a1a91b25d7598376$var$XLMLDocPropsMap = {
    Title: "Title",
    Subject: "Subject",
    Author: "Author",
    Keywords: "Keywords",
    Comments: "Description",
    LastAuthor: "LastAuthor",
    RevNumber: "Revision",
    Application: "AppName",
    /* TotalTime: 'TotalTime', */ LastPrinted: "LastPrinted",
    CreatedDate: "Created",
    ModifiedDate: "LastSaved",
    /* Pages */ /* Words */ /* Characters */ Category: "Category",
    /* PresentationFormat */ Manager: "Manager",
    Company: "Company",
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: "Version",
    ContentStatus: "ContentStatus",
    /* NOTE: missing from schema */ Identifier: "Identifier",
    /* NOTE: missing from schema */ Language: "Language" /* NOTE: missing from schema */ 
};
var $a1a91b25d7598376$var$evert_XLMLDPM;
function $a1a91b25d7598376$var$xlml_set_prop(Props, tag /*:string*/ , val) {
    if (!$a1a91b25d7598376$var$evert_XLMLDPM) $a1a91b25d7598376$var$evert_XLMLDPM = $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$XLMLDocPropsMap);
    tag = $a1a91b25d7598376$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val;
}
function $a1a91b25d7598376$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$keys($a1a91b25d7598376$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i)if ($a1a91b25d7598376$var$CORE_PROPS[i][1] == m) return $a1a91b25d7598376$var$CORE_PROPS[i];
        for(i = 0; i < $a1a91b25d7598376$var$EXT_PROPS.length; ++i)if ($a1a91b25d7598376$var$EXT_PROPS[i][1] == m) return $a1a91b25d7598376$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case "date":
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == "number") m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($a1a91b25d7598376$var$writetag($a1a91b25d7598376$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $a1a91b25d7598376$var$writextag("DocumentProperties", o.join(""), {
        xmlns: $a1a91b25d7598376$var$XLMLNS.o
    });
}
function $a1a91b25d7598376$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = "CustomDocumentProperties";
    var o /*:Array<string>*/  = [];
    if (Props) $a1a91b25d7598376$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i)if (k == $a1a91b25d7598376$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $a1a91b25d7598376$var$EXT_PROPS.length; ++i)if (k == $a1a91b25d7598376$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($a1a91b25d7598376$var$writextag($a1a91b25d7598376$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $a1a91b25d7598376$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == "number") {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($a1a91b25d7598376$var$writextag($a1a91b25d7598376$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return "<" + T + ' xmlns="' + $a1a91b25d7598376$var$XLMLNS.o + '">' + o.join("") + "</" + T + ">";
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $a1a91b25d7598376$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $a1a91b25d7598376$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $a1a91b25d7598376$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, "lpstr-cp");
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $a1a91b25d7598376$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, "lpwstr");
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $a1a91b25d7598376$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $a1a91b25d7598376$var$parse_lpwstr(blob);
    return $a1a91b25d7598376$var$parse_lpstr(blob, stringType, pad);
}
function $a1a91b25d7598376$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $a1a91b25d7598376$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $a1a91b25d7598376$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $a1a91b25d7598376$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $a1a91b25d7598376$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, "lpwstr").replace($a1a91b25d7598376$var$chr0, "");
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $a1a91b25d7598376$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, "lpstr-cp").replace($a1a91b25d7598376$var$chr0, "");
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $a1a91b25d7598376$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $a1a91b25d7598376$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($a1a91b25d7598376$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $a1a91b25d7598376$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? "utf16le" : "utf8").replace($a1a91b25d7598376$var$chr0, "").replace($a1a91b25d7598376$var$chr1, "!");
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $a1a91b25d7598376$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $a1a91b25d7598376$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $a1a91b25d7598376$var$VT_VARIANT) {
        if (t !== type && $a1a91b25d7598376$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error("Expected type " + type + " saw " + t);
    }
    switch(type === $a1a91b25d7598376$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, "i");
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, "i");
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            return $a1a91b25d7598376$var$parse_lpstr(blob, t, 4).replace($a1a91b25d7598376$var$chr0, "");
        case 0x1F /*VT_LPWSTR*/ :
            return $a1a91b25d7598376$var$parse_lpwstr(blob);
        case 0x40 /*VT_FILETIME*/ :
            return $a1a91b25d7598376$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $a1a91b25d7598376$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $a1a91b25d7598376$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $a1a91b25d7598376$var$parse_VtString(blob, t, !opts.raw).replace($a1a91b25d7598376$var$chr0, "");
        case 0x51 /*VT_USTR*/ :
            return $a1a91b25d7598376$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($a1a91b25d7598376$var$chr0, "");
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $a1a91b25d7598376$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $a1a91b25d7598376$var$parse_VtVecLpwstrValue(blob) : $a1a91b25d7598376$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $a1a91b25d7598376$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $a1a91b25d7598376$var$new_buf(4), p = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $a1a91b25d7598376$var$new_buf(8);
            p.write_shift(8, value, "f");
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $a1a91b25d7598376$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $a1a91b25d7598376$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $a1a91b25d7598376$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $a1a91b25d7598376$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + " at " + blob.l + " :" + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === "version") PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $a1a91b25d7598376$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_I2);
                $a1a91b25d7598376$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $a1a91b25d7598376$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $a1a91b25d7598376$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val = $a1a91b25d7598376$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/\u0000+$/, "");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4, "i");
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val = blob.read_shift(8, "f");
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val = $a1a91b25d7598376$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val = $a1a91b25d7598376$var$parseDate($a1a91b25d7598376$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $a1a91b25d7598376$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $a1a91b25d7598376$var$guess_property_type(val /*:any*/ ) /*:number*/ {
    switch(typeof val){
        case "boolean":
            return 0x0B;
        case "number":
            return (val | 0) == val ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $a1a91b25d7598376$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $a1a91b25d7598376$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $a1a91b25d7598376$var$new_buf(8), pio = $a1a91b25d7598376$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $a1a91b25d7598376$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $a1a91b25d7598376$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $a1a91b25d7598376$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $a1a91b25d7598376$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($a1a91b25d7598376$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $a1a91b25d7598376$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val.split(".");
                val = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $a1a91b25d7598376$var$write_TypedPropertyValue(pinfo.t, val);
        } else {
            var T = $a1a91b25d7598376$var$guess_property_type(val);
            if (T == -1) {
                T = 0x1F;
                val = String(val);
            }
            pr = $a1a91b25d7598376$var$write_TypedPropertyValue(T, val);
        }
        prop.push(pr);
        pio = $a1a91b25d7598376$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $a1a91b25d7598376$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $a1a91b25d7598376$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $a1a91b25d7598376$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk("feff", "Byte Order: ");
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $a1a91b25d7598376$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $a1a91b25d7598376$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $a1a91b25d7598376$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $a1a91b25d7598376$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $a1a91b25d7598376$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $a1a91b25d7598376$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $a1a91b25d7598376$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $a1a91b25d7598376$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $a1a91b25d7598376$var$bconcat(bufs);
}
function $a1a91b25d7598376$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $a1a91b25d7598376$var$writezeroes(n, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $a1a91b25d7598376$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $a1a91b25d7598376$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $a1a91b25d7598376$var$writebool(v /*:any*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $a1a91b25d7598376$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, "u");
}
function $a1a91b25d7598376$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $a1a91b25d7598376$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $a1a91b25d7598376$var$parslurp(blob, length, $a1a91b25d7598376$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $a1a91b25d7598376$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $a1a91b25d7598376$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(1, t == "e" ? +v : +!!v);
    o.write_shift(1, t == "e" ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = "sbcs-cont";
    var cp = $a1a91b25d7598376$var$current_codepage;
    if (opts && opts.biff >= 8) $a1a91b25d7598376$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = "dbcs-cont";
    } else if (opts.biff == 12) encoding = "wstr";
    if (opts.biff >= 2 && opts.biff <= 5) encoding = "cpstr";
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $a1a91b25d7598376$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $a1a91b25d7598376$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $a1a91b25d7598376$var$current_codepage;
    $a1a91b25d7598376$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? "dbcs-cont" : "sbcs-cont";
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $a1a91b25d7598376$var$current_codepage = cp;
    return z;
}
function $a1a91b25d7598376$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $a1a91b25d7598376$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $a1a91b25d7598376$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, "utf16le");
    var out = [
        hdr,
        otext
    ];
    return $a1a91b25d7598376$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, "cpstr");
        if (opts.biff >= 12) return blob.read_shift(cch, "dbcs-cont");
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, "sbcs-cont");
    else retval = blob.read_shift(cch, "dbcs-cont");
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $a1a91b25d7598376$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $a1a91b25d7598376$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? "cpstr" : "sbcs-cont");
}
/* TODO: BIFF5 and lower, codepage awareness */ function $a1a91b25d7598376$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, "utf16le");
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $a1a91b25d7598376$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $a1a91b25d7598376$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, "utf16le").replace($a1a91b25d7598376$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $a1a91b25d7598376$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, "lpstr-ansi");
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, "utf16le").replace($a1a91b25d7598376$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $a1a91b25d7598376$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $a1a91b25d7598376$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $a1a91b25d7598376$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $a1a91b25d7598376$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, "utf16le").replace($a1a91b25d7598376$var$chr0, "") : "";
    return o;
}
function $a1a91b25d7598376$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $a1a91b25d7598376$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $a1a91b25d7598376$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $a1a91b25d7598376$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $a1a91b25d7598376$var$write_Hyperlink(hl) {
    var out = $a1a91b25d7598376$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $a1a91b25d7598376$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $a1a91b25d7598376$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $a1a91b25d7598376$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $a1a91b25d7598376$var$parse_LongRGB(blob, length) {
    var x = $a1a91b25d7598376$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $a1a91b25d7598376$var$parse_XLSCell(blob /*::, length*/ ) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ixfe = blob.read_shift(2);
    return {
        r: rw,
        c: col,
        ixfe: ixfe
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $a1a91b25d7598376$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $a1a91b25d7598376$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $a1a91b25d7598376$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, "i"), itabLast = blob.read_shift(w, "i");
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $a1a91b25d7598376$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $a1a91b25d7598376$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $a1a91b25d7598376$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $a1a91b25d7598376$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $a1a91b25d7598376$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $a1a91b25d7598376$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $a1a91b25d7598376$var$parse_Ref = $a1a91b25d7598376$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $a1a91b25d7598376$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $a1a91b25d7598376$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $a1a91b25d7598376$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $a1a91b25d7598376$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $a1a91b25d7598376$var$FtTab = {
    /*::[*/ 0x00: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtEnd */ /*::[*/ 0x04: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtMacro */ /*::[*/ 0x05: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtButton */ /*::[*/ 0x06: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtGmo */ /*::[*/ 0x07: $a1a91b25d7598376$var$parse_FtCf,
    /* FtCf */ /*::[*/ 0x08: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtPioGrbit */ /*::[*/ 0x09: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtPictFmla */ /*::[*/ 0x0A: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCbls */ /*::[*/ 0x0B: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtRbo */ /*::[*/ 0x0C: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtSbs */ /*::[*/ 0x0D: $a1a91b25d7598376$var$parse_FtNts,
    /* FtNts */ /*::[*/ 0x0E: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtSbsFmla */ /*::[*/ 0x0F: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtGboData */ /*::[*/ 0x10: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtEdoData */ /*::[*/ 0x11: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtRboData */ /*::[*/ 0x12: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCblsData */ /*::[*/ 0x13: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtLbsData */ /*::[*/ 0x14: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCblsFmla */ /*::[*/ 0x15: $a1a91b25d7598376$var$parse_FtCmo
};
function $a1a91b25d7598376$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts.push($a1a91b25d7598376$var$FtTab[ft](blob, tgt - blob.l));
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $a1a91b25d7598376$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $a1a91b25d7598376$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case "biff8":
            break;
        case "biff5":
            h = 0x0500;
            w = 8;
            break;
        case "biff4":
            h = 0x0004;
            w = 6;
            break;
        case "biff3":
            h = 0x0003;
            w = 6;
            break;
        case "biff2":
            h = 0x0002;
            w = 4;
            break;
        case "xla":
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $a1a91b25d7598376$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $a1a91b25d7598376$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $a1a91b25d7598376$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $a1a91b25d7598376$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $a1a91b25d7598376$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $a1a91b25d7598376$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $a1a91b25d7598376$var$parse_BoundSheet8(blob, length, opts) {
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = "Worksheet";
            break;
        case 1:
            dt = "Macrosheet";
            break;
        case 2:
            dt = "Chartsheet";
            break;
        case 6:
            dt = "VBAModule";
            break;
    }
    var name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $a1a91b25d7598376$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $a1a91b25d7598376$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? "sbcs" : "utf16le");
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $a1a91b25d7598376$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($a1a91b25d7598376$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $a1a91b25d7598376$var$write_SST(sst, opts) {
    var header = $a1a91b25d7598376$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $a1a91b25d7598376$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $a1a91b25d7598376$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $a1a91b25d7598376$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $a1a91b25d7598376$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $a1a91b25d7598376$var$parse_ForceFullCalculation(blob) {
    var header = $a1a91b25d7598376$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $a1a91b25d7598376$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $a1a91b25d7598376$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $a1a91b25d7598376$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $a1a91b25d7598376$var$write_Window1() {
    var o = $a1a91b25d7598376$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $a1a91b25d7598376$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $a1a91b25d7598376$var$write_Window2(view) {
    var o = $a1a91b25d7598376$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $a1a91b25d7598376$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $a1a91b25d7598376$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $a1a91b25d7598376$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $a1a91b25d7598376$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $a1a91b25d7598376$var$parse_LabelSst(blob) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $a1a91b25d7598376$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(10);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $a1a91b25d7598376$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) blob.l++;
    var str = $a1a91b25d7598376$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $a1a91b25d7598376$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? "utf16le" : "sbcs");
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $a1a91b25d7598376$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $a1a91b25d7598376$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $a1a91b25d7598376$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? "sbcs" : "utf16le");
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $a1a91b25d7598376$var$parse_BIFF2Format = $a1a91b25d7598376$var$parse_XLUnicodeString2;
/* [MS-XLS] 2.4.90 */ function $a1a91b25d7598376$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $a1a91b25d7598376$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $a1a91b25d7598376$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $a1a91b25d7598376$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $a1a91b25d7598376$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $a1a91b25d7598376$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($a1a91b25d7598376$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $a1a91b25d7598376$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $a1a91b25d7598376$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $a1a91b25d7598376$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $a1a91b25d7598376$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $a1a91b25d7598376$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $a1a91b25d7598376$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $a1a91b25d7598376$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.134 */ function $a1a91b25d7598376$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $a1a91b25d7598376$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $a1a91b25d7598376$var$parse_BoolErr(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2 || length == 9) ++blob.l;
    var val = $a1a91b25d7598376$var$parse_Bes(blob, 2);
    cell.val = val;
    cell.t = val === true || val === false ? "b" : "e";
    return cell;
}
function $a1a91b25d7598376$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    $a1a91b25d7598376$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $a1a91b25d7598376$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    var xnum = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $a1a91b25d7598376$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(14);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    $a1a91b25d7598376$var$write_Xnum(v, o);
    return o;
}
var $a1a91b25d7598376$var$parse_XLHeaderFooter = $a1a91b25d7598376$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $a1a91b25d7598376$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($a1a91b25d7598376$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $a1a91b25d7598376$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $a1a91b25d7598376$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $a1a91b25d7598376$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $a1a91b25d7598376$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $a1a91b25d7598376$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: verify filename encoding */ function $a1a91b25d7598376$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($a1a91b25d7598376$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $a1a91b25d7598376$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $a1a91b25d7598376$var$parse_ShrFmla(blob, length, opts) {
    var ref = $a1a91b25d7598376$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $a1a91b25d7598376$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $a1a91b25d7598376$var$parse_Array(blob, length, opts) {
    var ref = $a1a91b25d7598376$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $a1a91b25d7598376$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $a1a91b25d7598376$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 TODO: BIFF5 */ function $a1a91b25d7598376$var$parse_NoteSh(blob, length, opts) {
    if (opts.biff < 8) return;
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    if (opts.biff < 8) blob.read_shift(1);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $a1a91b25d7598376$var$parse_Note(blob, length, opts) {
    /* TODO: Support revisions */ return $a1a91b25d7598376$var$parse_NoteSh(blob, length, opts);
}
/* [MS-XLS] 2.4.168 */ function $a1a91b25d7598376$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($a1a91b25d7598376$var$parse_Ref8U(blob, length));
    return merges;
}
function $a1a91b25d7598376$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$a1a91b25d7598376$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $a1a91b25d7598376$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $a1a91b25d7598376$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $a1a91b25d7598376$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $a1a91b25d7598376$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $a1a91b25d7598376$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $a1a91b25d7598376$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($a1a91b25d7598376$var$parse_BIFF5OT[ot] || $a1a91b25d7598376$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $a1a91b25d7598376$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $a1a91b25d7598376$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $a1a91b25d7598376$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $a1a91b25d7598376$var$parse_HLink(blob, length) {
    var ref = $a1a91b25d7598376$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $a1a91b25d7598376$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $a1a91b25d7598376$var$write_HLink(hl) {
    var O = $a1a91b25d7598376$var$new_buf(24);
    var ref = $a1a91b25d7598376$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $a1a91b25d7598376$var$bconcat([
        O,
        $a1a91b25d7598376$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $a1a91b25d7598376$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $a1a91b25d7598376$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, "dbcs-cont");
    wzTooltip = wzTooltip.replace($a1a91b25d7598376$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $a1a91b25d7598376$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $a1a91b25d7598376$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $a1a91b25d7598376$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $a1a91b25d7598376$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $a1a91b25d7598376$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $a1a91b25d7598376$var$CountryEnum[d] || d;
    return o;
}
function $a1a91b25d7598376$var$write_Country(o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $a1a91b25d7598376$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($a1a91b25d7598376$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $a1a91b25d7598376$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($a1a91b25d7598376$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $a1a91b25d7598376$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $a1a91b25d7598376$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $a1a91b25d7598376$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $a1a91b25d7598376$var$write_ColInfo(col, idx) {
    var o = $a1a91b25d7598376$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $a1a91b25d7598376$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    o.footer = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $a1a91b25d7598376$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $a1a91b25d7598376$var$write_RRTabId(n /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $a1a91b25d7598376$var$parse_Blank = $a1a91b25d7598376$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $a1a91b25d7598376$var$parse_Scl = $a1a91b25d7598376$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $a1a91b25d7598376$var$parse_String = $a1a91b25d7598376$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $a1a91b25d7598376$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $a1a91b25d7598376$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var str = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = "str";
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$parse_BIFF2NUM(blob /*::, length*/ ) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $a1a91b25d7598376$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(15);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    out.write_shift(8, val, "f");
    return out;
}
function $a1a91b25d7598376$var$parse_BIFF2INT(blob) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    ++blob.l;
    var num = blob.read_shift(2);
    cell.t = "n";
    cell.val = num;
    return cell;
}
function $a1a91b25d7598376$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    out.write_shift(2, val);
    return out;
}
function $a1a91b25d7598376$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, "sbcs-cont");
}
/* TODO: convert to BIFF8 font struct */ function $a1a91b25d7598376$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $a1a91b25d7598376$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    var cch = blob.read_shift(2);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = "str";
    cell.val = str;
    return cell;
}
var $a1a91b25d7598376$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $a1a91b25d7598376$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /* shapefile DBF extension */ /*::[*/ 0x00: 20127,
        /*::[*/ 0x08: 865,
        /*::[*/ 0x09: 437,
        /*::[*/ 0x0A: 850,
        /*::[*/ 0x0B: 437,
        /*::[*/ 0x0D: 437,
        /*::[*/ 0x0E: 850,
        /*::[*/ 0x0F: 437,
        /*::[*/ 0x10: 850,
        /*::[*/ 0x11: 437,
        /*::[*/ 0x12: 850,
        /*::[*/ 0x13: 932,
        /*::[*/ 0x14: 850,
        /*::[*/ 0x15: 437,
        /*::[*/ 0x16: 850,
        /*::[*/ 0x17: 865,
        /*::[*/ 0x18: 437,
        /*::[*/ 0x19: 437,
        /*::[*/ 0x1A: 850,
        /*::[*/ 0x1B: 437,
        /*::[*/ 0x1C: 863,
        /*::[*/ 0x1D: 850,
        /*::[*/ 0x1F: 852,
        /*::[*/ 0x22: 852,
        /*::[*/ 0x23: 852,
        /*::[*/ 0x24: 860,
        /*::[*/ 0x25: 850,
        /*::[*/ 0x26: 866,
        /*::[*/ 0x37: 850,
        /*::[*/ 0x40: 852,
        /*::[*/ 0x4D: 936,
        /*::[*/ 0x4E: 949,
        /*::[*/ 0x4F: 950,
        /*::[*/ 0x50: 874,
        /*::[*/ 0x57: 1252,
        /*::[*/ 0x58: 1252,
        /*::[*/ 0x59: 1252,
        /*::[*/ 0x6C: 863,
        /*::[*/ 0x86: 737,
        /*::[*/ 0x87: 852,
        /*::[*/ 0x88: 857,
        /*::[*/ 0xCC: 1257,
        /*::[*/ 0xFF: 16969
    };
    var dbf_reverse_map = $a1a91b25d7598376$var$evert({
        /*::[*/ 0x01: 437,
        /*::[*/ 0x02: 850,
        /*::[*/ 0x03: 1252,
        /*::[*/ 0x04: 10000,
        /*::[*/ 0x64: 852,
        /*::[*/ 0x65: 866,
        /*::[*/ 0x66: 865,
        /*::[*/ 0x67: 861,
        /*::[*/ 0x68: 895,
        /*::[*/ 0x69: 620,
        /*::[*/ 0x6A: 737,
        /*::[*/ 0x6B: 857,
        /*::[*/ 0x78: 950,
        /*::[*/ 0x79: 949,
        /*::[*/ 0x7A: 936,
        /*::[*/ 0x7B: 932,
        /*::[*/ 0x7C: 874,
        /*::[*/ 0x7D: 1255,
        /*::[*/ 0x7E: 1256,
        /*::[*/ 0x96: 10007,
        /*::[*/ 0x97: 10029,
        /*::[*/ 0x98: 10006,
        /*::[*/ 0xC8: 1250,
        /*::[*/ 0xC9: 1251,
        /*::[*/ 0xCA: 1254,
        /*::[*/ 0xCB: 1253,
        /*::[*/ 0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $a1a91b25d7598376$var$new_raw_buf(1);
        switch(opts.type){
            case "base64":
                d = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(buf));
                break;
            case "binary":
                d = $a1a91b25d7598376$var$s2a(buf);
                break;
            case "buffer":
            case "array":
                d = buf;
                break;
        }
        $a1a91b25d7598376$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $a1a91b25d7598376$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n].*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case "B":
                    if ((!vfp || field.len != 8) && opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "G":
                case "P":
                    if (opts.WTF) console.log("Skipping " + field.name + ":" + field.type);
                    break;
                case "+":
                case "0":
                case "@":
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "O":
                case "T":
                case "Y":
                    break;
                default:
                    throw new Error("Unknown Field Type: " + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $a1a91b25d7598376$var$prep_blob(dd, 0);
                var s = typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(current_cp, dd) : $a1a91b25d7598376$var$a2s(dd);
                switch(fields[C].type){
                    case "C":
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/\s+$/, "");
                        break;
                    case "D":
                        if (s.length === 8) out[R][C] = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
                        else out[R][C] = s;
                        break;
                    case "F":
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case "+":
                    case "I":
                        out[R][C] = l7 ? dd.read_shift(-4, "i") ^ 0x80000000 : dd.read_shift(4, "i");
                        break;
                    case "L":
                        switch(s.trim().toUpperCase()){
                            case "Y":
                            case "T":
                                out[R][C] = true;
                                break;
                            case "N":
                            case "F":
                                out[R][C] = false;
                                break;
                            case "":
                            case "?":
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case "M":
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case "N":
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case "@":
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, "f") - 0x388317533400);
                        break;
                    case "T":
                        out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4));
                        break;
                    case "Y":
                        out[R][C] = dd.read_shift(4, "i") / 1e4 + dd.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
                        break;
                    case "O":
                        out[R][C] = -dd.read_shift(-8, "f");
                        break;
                    case "B":
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, "f");
                            break;
                        }
                    /* falls through */ case "G":
                    case "P":
                        dd.l += fields[C].len;
                        break;
                    case "0":
                        if (fields[C].name === "_NullFlags") break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $a1a91b25d7598376$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $a1a91b25d7598376$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        "B": 8,
        "C": 250,
        "L": 1,
        "D": 8,
        "?": 0,
        "": 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        var old_cp = $a1a91b25d7598376$var$current_codepage;
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        var aoa /*:AOA*/  = $a1a91b25d7598376$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === "number") headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== "string") throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = "", _guess = "", maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = "?";
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case "number":
                        _guess = "B";
                        break;
                    case "string":
                        _guess = "C";
                        break;
                    case "boolean":
                        _guess = "L";
                        break;
                    case "object":
                        _guess = col[j] instanceof Date ? "D" : "C";
                        break;
                    default:
                        _guess = "C";
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $a1a91b25d7598376$var$$cptable !== "undefined" && typeof col[j] == "string" ? $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? "C" : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == "C") {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == "B" && _guess == "N") {
                guess = "N";
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == "C" || _guess == "N" ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $a1a91b25d7598376$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $a1a91b25d7598376$var$current_codepage + ", using 1252");
            $a1a91b25d7598376$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == "?" ? "C" : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case "L":
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case "B":
                        rout.write_shift(8, data[i][j] || 0, "f");
                        break;
                    case "N":
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case "D":
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case "C":
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $a1a91b25d7598376$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $a1a91b25d7598376$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        /*::[*/ 0: 176,
        /*::[*/ 1: 177,
        /*::[*/ 2: 178,
        /*::[*/ 3: 179,
        /*::[*/ 5: 181,
        /*::[*/ 6: 182,
        /*::[*/ 7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\x1bN(" + $a1a91b25d7598376$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $a1a91b25d7598376$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $a1a91b25d7598376$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case "base64":
                return sylk_to_aoa_str($a1a91b25d7598376$var$Base64_decode(d), opts);
            case "binary":
                return sylk_to_aoa_str(d, opts);
            case "buffer":
                return sylk_to_aoa_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString("binary") : $a1a91b25d7598376$var$a2s(d), opts);
            case "array":
                return sylk_to_aoa_str($a1a91b25d7598376$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $a1a91b25d7598376$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\x00").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val;
            if (rstr.length > 0) switch(RT){
                case "ID":
                    break; /* header */ 
                case "E":
                    break; /* EOF */ 
                case "B":
                    break; /* dimensions */ 
                case "O":
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "V":
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case "W":
                    break; /* window */ 
                case "P":
                    switch(record[1].charAt(0)){
                        case "P":
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case "NN":
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "N":
                            nn.Name = record[rj].slice(1);
                            break;
                        case "E":
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $a1a91b25d7598376$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case "C":
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "A":
                            break; // TODO: comment
                        case "X":
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "K":
                            val = record[rj].slice(1);
                            if (val.charAt(0) === '"') {
                                val = val.slice(1, val.length - 1);
                                cell_t = "s";
                            } else if (val === "TRUE" || val === "FALSE") {
                                val = val === "TRUE";
                                cell_t = "b";
                            } else if (!isNaN($a1a91b25d7598376$var$fuzzynum(val))) {
                                val = $a1a91b25d7598376$var$fuzzynum(val);
                                cell_t = "n";
                                if (next_cell_format !== null && $a1a91b25d7598376$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val = $a1a91b25d7598376$var$numdate(wb.Workbook.WBProps.date1904 ? val + 1462 : val);
                                    cell_t = "d";
                                }
                            } else if (!isNaN($a1a91b25d7598376$var$fuzzydate(val).getDate())) {
                                val = $a1a91b25d7598376$var$parseDate(val);
                                cell_t = "d";
                                if (!opts.cellDates) {
                                    cell_t = "n";
                                    val = $a1a91b25d7598376$var$datenum(val, wb.Workbook.WBProps.date1904);
                                }
                            }
                            if (typeof $a1a91b25d7598376$var$$cptable !== "undefined" && typeof val == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, val);
                            C_seen_K = true;
                            break;
                        case "E":
                            C_seen_E = true;
                            formula = $a1a91b25d7598376$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case "S":
                            C_seen_S = true;
                            break;
                        case "G":
                            break; // unknown
                        case "R":
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case "C":
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $a1a91b25d7598376$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $a1a91b25d7598376$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: "n",
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    break;
                case "F":
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case "X":
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case "Y":
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case "M":
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case "F":
                            break; /* ??? */ 
                        case "G":
                            break; /* hide grid */ 
                        case "P":
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case "S":
                            break; /* cell style */ 
                        case "D":
                            break; /* column */ 
                        case "N":
                            break; /* font */ 
                        case "W":
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case "C":
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case "R":
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $a1a91b25d7598376$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht["!rows"] = rowinfo;
        if (colinfo.length > 0) sht["!cols"] = colinfo;
        colinfo.forEach(function(col) {
            $a1a91b25d7598376$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $a1a91b25d7598376$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $a1a91b25d7598376$var$aoa_to_sheet(aoa, _opts);
        $a1a91b25d7598376$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $a1a91b25d7598376$var$sheet_to_workbook(o, opts);
        $a1a91b25d7598376$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case "n":
                o += cell.v || 0;
                if (cell.f && !cell.F) o += ";E" + $a1a91b25d7598376$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case "b":
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case "e":
                o += cell.w || cell.v;
                break;
            case "d":
                o += '"' + (cell.w || cell.v) + '"';
                break;
            case "s":
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == "number" && !col.wpx) col.wpx = $a1a91b25d7598376$var$width2px(col.width);
                if (typeof col.wpx == "number" && !col.wch) col.wch = $a1a91b25d7598376$var$px2char(col.wpx);
                if (typeof col.wch == "number") rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $a1a91b25d7598376$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        preamble.push("P;PGeneral");
        preamble.push("F;P0;DG0G8;M255");
        if (ws["!cols"]) write_ws_cols_sylk(preamble, ws["!cols"]);
        if (ws["!rows"]) write_ws_rows_sylk(preamble, ws["!rows"]);
        preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        for(var R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            var p = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts)); // TODO: pass date1904 info
            }
            o.push(p.join(RS));
        }
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $a1a91b25d7598376$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case "base64":
                return dif_to_aoa_str($a1a91b25d7598376$var$Base64_decode(d), opts);
            case "binary":
                return dif_to_aoa_str(d, opts);
            case "buffer":
                return dif_to_aoa_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString("binary") : $a1a91b25d7598376$var$a2s(d), opts);
            case "array":
                return dif_to_aoa_str($a1a91b25d7598376$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === "BOT") {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === "BOT") {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== "EOD") throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === "TRUE") arr[R][C] = true;
                    else if (data === "FALSE") arr[R][C] = false;
                    else if (!isNaN($a1a91b25d7598376$var$fuzzynum(value))) arr[R][C] = $a1a91b25d7598376$var$fuzzynum(value);
                    else if (!isNaN($a1a91b25d7598376$var$fuzzydate(value).getDate())) arr[R][C] = $a1a91b25d7598376$var$parseDate(value);
                    else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($a1a91b25d7598376$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== "" ? data : null;
                    break;
            }
            if (data === "EOD") break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $a1a91b25d7598376$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $a1a91b25d7598376$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return '1,0\r\n"' + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $a1a91b25d7598376$var$DIF_XL;
        var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            'TABLE\r\n0,1\r\n"sheetjs"\r\n',
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + '\r\n""\r\n',
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + '\r\n""\r\n',
            'DATA\r\n0,0\r\n""\r\n'
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += '1,0\r\n""\r\n';
                    continue;
                }
                switch(cell.t){
                    case "n":
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += '1,0\r\n""';
                        } else if (cell.v == null) p += '1,0\r\n""';
                        else p += make_value(cell.v, "V");
                        break;
                    case "b":
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case "s":
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case "d":
                        if (!cell.w) cell.w = $a1a91b25d7598376$var$SSF_format(cell.z || $a1a91b25d7598376$var$table_fmt[14], $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += '1,0\r\n""';
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $a1a91b25d7598376$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split("\n"), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== "cell") continue;
            var addr = $a1a91b25d7598376$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case "t":
                    arr[R][C] = decode(record[3]);
                    break;
                case "v":
                    arr[R][C] = +record[3];
                    break;
                case "vtf":
                    var _f = record[record.length - 1];
                /* falls through */ case "vtc":
                    switch(record[3]){
                        case "nl":
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = +record[4];
                            break;
                    }
                    if (record[2] == "vtf") arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $a1a91b25d7598376$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $a1a91b25d7598376$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws["!ref"]) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === "z") continue;
            oo = [
                "cell",
                coord,
                "t"
            ];
            switch(cell.t){
                case "s":
                case "str":
                    oo.push(encode(cell.v));
                    break;
                case "n":
                    if (!cell.f) {
                        oo[2] = "v";
                        oo[3] = cell.v;
                    } else {
                        oo[2] = "vtf";
                        oo[3] = "n";
                        oo[4] = cell.v;
                        oo[5] = encode(cell.f);
                    }
                    break;
                case "b":
                    oo[2] = "vt" + (cell.f ? "f" : "c");
                    oo[3] = "nl";
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? "TRUE" : "FALSE"));
                    break;
                case "d":
                    var t = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v));
                    oo[2] = "vtc";
                    oo[3] = "nd";
                    oo[4] = "" + t;
                    oo[5] = cell.w || $a1a91b25d7598376$var$SSF_format(cell.z || $a1a91b25d7598376$var$table_fmt[14], t);
                    break;
                case "e":
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $a1a91b25d7598376$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === "TRUE") arr[R][C] = true;
        else if (data === "FALSE") arr[R][C] = false;
        else if (!isNaN($a1a91b25d7598376$var$fuzzynum(data))) arr[R][C] = $a1a91b25d7598376$var$fuzzynum(data);
        else if (!isNaN($a1a91b25d7598376$var$fuzzydate(data).getDate())) arr[R][C] = $a1a91b25d7598376$var$parseDate(data);
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        /*::[*/ 0x2C: ",",
        /*::[*/ 0x09: "	",
        /*::[*/ 0x3B: ";",
        /*::[*/ 0x7C: "|"
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        /*::[*/ 0x2C: 3,
        /*::[*/ 0x09: 2,
        /*::[*/ 0x3B: 1,
        /*::[*/ 0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $a1a91b25d7598376$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (s.length === 0) cell.t = "z";
            else if (o.raw) {
                cell.t = "s";
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = "s";
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = "s";
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($a1a91b25d7598376$var$fuzzyfmla(s)) {
                    cell.t = "n";
                    cell.f = s.slice(1);
                } else {
                    cell.t = "s";
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = "b";
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = "b";
                cell.v = false;
            } else if (!isNaN(v = $a1a91b25d7598376$var$fuzzynum(s))) {
                cell.t = "n";
                if (o.cellText !== false) cell.w = s;
                cell.v = v;
            } else if (!isNaN((v = $a1a91b25d7598376$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                var k = 0;
                if (_re && s.match(_re)) {
                    s = $a1a91b25d7598376$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    k = 1;
                    v = $a1a91b25d7598376$var$parseDate(s, k);
                }
                if (o.cellDates) {
                    cell.t = "d";
                    cell.v = v;
                } else {
                    cell.t = "n";
                    cell.v = $a1a91b25d7598376$var$datenum(v);
                }
                if (o.cellText !== false) cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, cell.v instanceof Date ? $a1a91b25d7598376$var$datenum(cell.v) : cell.v);
                if (!o.cellNF) delete cell.z;
            } else {
                cell.t = "s";
                cell.v = s;
            }
            if (cell.t == "z") ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("	") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $a1a91b25d7598376$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == "string" ? [
            0,
            0,
            0,
            0
        ] : $a1a91b25d7598376$var$firstbyte(d, opts);
        switch(opts.type){
            case "base64":
                str = $a1a91b25d7598376$var$Base64_decode(d);
                break;
            case "binary":
                str = d;
                break;
            case "buffer":
                if (opts.codepage == 65001) str = d.toString("utf8"); // TODO: test if buf
                else if (opts.codepage && typeof $a1a91b25d7598376$var$$cptable !== "undefined") str = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, d);
                else str = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString("binary") : $a1a91b25d7598376$var$a2s(d);
                break;
            case "array":
                str = $a1a91b25d7598376$var$cc2str(d);
                break;
            case "string":
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $a1a91b25d7598376$var$utf8read(str.slice(3));
        else if (opts.type != "string" && opts.type != "buffer" && opts.codepage == 65001) str = $a1a91b25d7598376$var$utf8read(str);
        else if (opts.type == "binary" && typeof $a1a91b25d7598376$var$$cptable !== "undefined" && opts.codepage) str = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, $a1a91b25d7598376$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $a1a91b25d7598376$var$ETH.to_sheet(opts.type == "string" ? str : $a1a91b25d7598376$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $a1a91b25d7598376$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $a1a91b25d7598376$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $a1a91b25d7598376$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
        return $a1a91b25d7598376$var$PRN.to_workbook(d, opts);
    }
}
var $a1a91b25d7598376$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $a1a91b25d7598376$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case "base64":
                return lotus_to_workbook_buf($a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(d)), opts);
            case "binary":
                return lotus_to_workbook_buf($a1a91b25d7598376$var$s2a(d), opts);
            case "buffer":
            case "array":
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val;
                        if (val >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val) next_n = val;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        if (o.works || o.works2) val[1].v = val[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if (RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
                            val[1].z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                            if (o.cellDates) {
                                val[1].t = "d";
                                val[1].v = $a1a91b25d7598376$var$numdate(val[1].v);
                            }
                        }
                        if (o.qpro) {
                            if (val[3] > sidx) {
                                s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val[0].r] || [])[val[0].c] : s[$a1a91b25d7598376$var$encode_cell(val[0])];
                        if (tmpcell) {
                            tmpcell.t = val[1].t;
                            tmpcell.v = val[1].v;
                            if (val[1].z != null) tmpcell.z = val[1].z;
                            if (val[1].f != null) tmpcell.f = val[1].f;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$a1a91b25d7598376$var$encode_cell(val[0])] = val[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    default:
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val[1].v.charCodeAt(0) < 0x30) val[1].v = val[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val[1].v = val[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val[3] > sidx) {
                            s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val[0].r]) sdata[val[0].r] = [];
                            sdata[val[0].r][val[0].c] = val[1];
                        } else s[$a1a91b25d7598376$var$encode_cell(val[0])] = val[1];
                        if (refguess.e.c < val[0].c) refguess.e.c = val[0].c;
                        if (refguess.e.r < val[0].r) refguess.e.r = val[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val[0]] = val[1];
                        if (val[0] == sidx) n = val[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $a1a91b25d7598376$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ if (cell.t == "n") {
                    if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
                    else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
                } else {
                    var str = $a1a91b25d7598376$var$format_cell(cell);
                    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $a1a91b25d7598376$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $a1a91b25d7598376$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $a1a91b25d7598376$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $a1a91b25d7598376$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $a1a91b25d7598376$var$format_cell(cell);
                        /* TODO: max len? */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $a1a91b25d7598376$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $a1a91b25d7598376$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $a1a91b25d7598376$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $a1a91b25d7598376$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = "s";
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, "utf8");
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, "cstr");
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, "i");
        return o;
    }
    function write_INTEGER(R, C, v) {
        var o = $a1a91b25d7598376$var$new_buf(7);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, v, "i");
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, "f");
        return o;
    }
    function write_NUMBER(R, C, v) {
        var o = $a1a91b25d7598376$var$new_buf(13);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, v, "f");
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, "f");
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $a1a91b25d7598376$var$encode_col(V) : $a1a91b25d7598376$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        // 0x36 DATE
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        // 0x40 TIME
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, "f"));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: "n",
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = "s";
        o[1].v = blob.read_shift(length - 4, "cstr");
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $a1a91b25d7598376$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $a1a91b25d7598376$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, "f");
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, "cstr") : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, "cstr");
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $a1a91b25d7598376$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        /*::[*/ 0x0000: {
            n: "BOF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "CALCMODE"
        },
        /*::[*/ 0x0003: {
            n: "CALCORDER"
        },
        /*::[*/ 0x0004: {
            n: "SPLIT"
        },
        /*::[*/ 0x0005: {
            n: "SYNC"
        },
        /*::[*/ 0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        /*::[*/ 0x0007: {
            n: "WINDOW1"
        },
        /*::[*/ 0x0008: {
            n: "COLW1"
        },
        /*::[*/ 0x0009: {
            n: "WINTWO"
        },
        /*::[*/ 0x000A: {
            n: "COLW2"
        },
        /*::[*/ 0x000B: {
            n: "NAME"
        },
        /*::[*/ 0x000C: {
            n: "BLANK"
        },
        /*::[*/ 0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        /*::[*/ 0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        /*::[*/ 0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        /*::[*/ 0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        /*::[*/ 0x0018: {
            n: "TABLE"
        },
        /*::[*/ 0x0019: {
            n: "ORANGE"
        },
        /*::[*/ 0x001A: {
            n: "PRANGE"
        },
        /*::[*/ 0x001B: {
            n: "SRANGE"
        },
        /*::[*/ 0x001C: {
            n: "FRANGE"
        },
        /*::[*/ 0x001D: {
            n: "KRANGE1"
        },
        /*::[*/ 0x0020: {
            n: "HRANGE"
        },
        /*::[*/ 0x0023: {
            n: "KRANGE2"
        },
        /*::[*/ 0x0024: {
            n: "PROTEC"
        },
        /*::[*/ 0x0025: {
            n: "FOOTER"
        },
        /*::[*/ 0x0026: {
            n: "HEADER"
        },
        /*::[*/ 0x0027: {
            n: "SETUP"
        },
        /*::[*/ 0x0028: {
            n: "MARGINS"
        },
        /*::[*/ 0x0029: {
            n: "LABELFMT"
        },
        /*::[*/ 0x002A: {
            n: "TITLES"
        },
        /*::[*/ 0x002B: {
            n: "SHEETJS"
        },
        /*::[*/ 0x002D: {
            n: "GRAPH"
        },
        /*::[*/ 0x002E: {
            n: "NGRAPH"
        },
        /*::[*/ 0x002F: {
            n: "CALCCOUNT"
        },
        /*::[*/ 0x0030: {
            n: "UNFORMATTED"
        },
        /*::[*/ 0x0031: {
            n: "CURSORW12"
        },
        /*::[*/ 0x0032: {
            n: "WINDOW"
        },
        /*::[*/ 0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        /*::[*/ 0x0037: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0038: {
            n: "LOCKED"
        },
        /*::[*/ 0x003C: {
            n: "QUERY"
        },
        /*::[*/ 0x003D: {
            n: "QUERYNAME"
        },
        /*::[*/ 0x003E: {
            n: "PRINT"
        },
        /*::[*/ 0x003F: {
            n: "PRINTNAME"
        },
        /*::[*/ 0x0040: {
            n: "GRAPH2"
        },
        /*::[*/ 0x0041: {
            n: "GRAPHNAME"
        },
        /*::[*/ 0x0042: {
            n: "ZOOM"
        },
        /*::[*/ 0x0043: {
            n: "SYMSPLIT"
        },
        /*::[*/ 0x0044: {
            n: "NSROWS"
        },
        /*::[*/ 0x0045: {
            n: "NSCOLS"
        },
        /*::[*/ 0x0046: {
            n: "RULER"
        },
        /*::[*/ 0x0047: {
            n: "NNAME"
        },
        /*::[*/ 0x0048: {
            n: "ACOMM"
        },
        /*::[*/ 0x0049: {
            n: "AMACRO"
        },
        /*::[*/ 0x004A: {
            n: "PARSE"
        },
        /*::[*/ 0x0066: {
            n: "PRANGES??"
        },
        /*::[*/ 0x0067: {
            n: "RRANGES??"
        },
        /*::[*/ 0x0068: {
            n: "FNAME??"
        },
        /*::[*/ 0x0069: {
            n: "MRANGES??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        /*::[*/ 0x00FF: {
            n: "BOF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        /*::[*/ 0x0000: {
            n: "BOF"
        },
        /*::[*/ 0x0001: {
            n: "EOF"
        },
        /*::[*/ 0x0002: {
            n: "PASSWORD"
        },
        /*::[*/ 0x0003: {
            n: "CALCSET"
        },
        /*::[*/ 0x0004: {
            n: "WINDOWSET"
        },
        /*::[*/ 0x0005: {
            n: "SHEETCELLPTR"
        },
        /*::[*/ 0x0006: {
            n: "SHEETLAYOUT"
        },
        /*::[*/ 0x0007: {
            n: "COLUMNWIDTH"
        },
        /*::[*/ 0x0008: {
            n: "HIDDENCOLUMN"
        },
        /*::[*/ 0x0009: {
            n: "USERRANGE"
        },
        /*::[*/ 0x000A: {
            n: "SYSTEMRANGE"
        },
        /*::[*/ 0x000B: {
            n: "ZEROFORCE"
        },
        /*::[*/ 0x000C: {
            n: "SORTKEYDIR"
        },
        /*::[*/ 0x000D: {
            n: "FILESEAL"
        },
        /*::[*/ 0x000E: {
            n: "DATAFILLNUMS"
        },
        /*::[*/ 0x000F: {
            n: "PRINTMAIN"
        },
        /*::[*/ 0x0010: {
            n: "PRINTSTRING"
        },
        /*::[*/ 0x0011: {
            n: "GRAPHMAIN"
        },
        /*::[*/ 0x0012: {
            n: "GRAPHSTRING"
        },
        /*::[*/ 0x0013: {
            n: "??"
        },
        /*::[*/ 0x0014: {
            n: "ERRCELL"
        },
        /*::[*/ 0x0015: {
            n: "NACELL"
        },
        /*::[*/ 0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        /*::[*/ 0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        /*::[*/ 0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        /*::[*/ 0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        /*::[*/ 0x001A: {
            n: "FORMULA1A"
        },
        /*::[*/ 0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        /*::[*/ 0x001C: {
            n: "DTLABELMISC"
        },
        /*::[*/ 0x001D: {
            n: "DTLABELCELL"
        },
        /*::[*/ 0x001E: {
            n: "GRAPHWINDOW"
        },
        /*::[*/ 0x001F: {
            n: "CPA"
        },
        /*::[*/ 0x0020: {
            n: "LPLAUTO"
        },
        /*::[*/ 0x0021: {
            n: "QUERY"
        },
        /*::[*/ 0x0022: {
            n: "HIDDENSHEET"
        },
        /*::[*/ 0x0023: {
            n: "??"
        },
        /*::[*/ 0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        /*::[*/ 0x0026: {
            n: "??"
        },
        /*::[*/ 0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        /*::[*/ 0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        /*::[*/ 0x008E: {
            n: "??"
        },
        /*::[*/ 0x0093: {
            n: "??"
        },
        /*::[*/ 0x0096: {
            n: "??"
        },
        /*::[*/ 0x0097: {
            n: "??"
        },
        /*::[*/ 0x0098: {
            n: "??"
        },
        /*::[*/ 0x0099: {
            n: "??"
        },
        /*::[*/ 0x009A: {
            n: "??"
        },
        /*::[*/ 0x009B: {
            n: "??"
        },
        /*::[*/ 0x009C: {
            n: "??"
        },
        /*::[*/ 0x00A3: {
            n: "??"
        },
        /*::[*/ 0x00AE: {
            n: "??"
        },
        /*::[*/ 0x00AF: {
            n: "??"
        },
        /*::[*/ 0x00B0: {
            n: "??"
        },
        /*::[*/ 0x00B1: {
            n: "??"
        },
        /*::[*/ 0x00B8: {
            n: "??"
        },
        /*::[*/ 0x00B9: {
            n: "??"
        },
        /*::[*/ 0x00BA: {
            n: "??"
        },
        /*::[*/ 0x00BB: {
            n: "??"
        },
        /*::[*/ 0x00BC: {
            n: "??"
        },
        /*::[*/ 0x00C3: {
            n: "??"
        },
        /*::[*/ 0x00C9: {
            n: "??"
        },
        /*::[*/ 0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        /*::[*/ 0x00CD: {
            n: "??"
        },
        /*::[*/ 0x00CE: {
            n: "??"
        },
        /*::[*/ 0x00CF: {
            n: "??"
        },
        /*::[*/ 0x00D0: {
            n: "??"
        },
        /*::[*/ 0x0100: {
            n: "??"
        },
        /*::[*/ 0x0103: {
            n: "??"
        },
        /*::[*/ 0x0104: {
            n: "??"
        },
        /*::[*/ 0x0105: {
            n: "??"
        },
        /*::[*/ 0x0106: {
            n: "??"
        },
        /*::[*/ 0x0107: {
            n: "??"
        },
        /*::[*/ 0x0109: {
            n: "??"
        },
        /*::[*/ 0x010A: {
            n: "??"
        },
        /*::[*/ 0x010B: {
            n: "??"
        },
        /*::[*/ 0x010C: {
            n: "??"
        },
        /*::[*/ 0x010E: {
            n: "??"
        },
        /*::[*/ 0x010F: {
            n: "??"
        },
        /*::[*/ 0x0180: {
            n: "??"
        },
        /*::[*/ 0x0185: {
            n: "??"
        },
        /*::[*/ 0x0186: {
            n: "??"
        },
        /*::[*/ 0x0189: {
            n: "??"
        },
        /*::[*/ 0x018C: {
            n: "??"
        },
        /*::[*/ 0x0200: {
            n: "??"
        },
        /*::[*/ 0x0202: {
            n: "??"
        },
        /*::[*/ 0x0201: {
            n: "??"
        },
        /*::[*/ 0x0204: {
            n: "??"
        },
        /*::[*/ 0x0205: {
            n: "??"
        },
        /*::[*/ 0x0280: {
            n: "??"
        },
        /*::[*/ 0x0281: {
            n: "??"
        },
        /*::[*/ 0x0282: {
            n: "??"
        },
        /*::[*/ 0x0283: {
            n: "??"
        },
        /*::[*/ 0x0284: {
            n: "??"
        },
        /*::[*/ 0x0285: {
            n: "??"
        },
        /*::[*/ 0x0286: {
            n: "??"
        },
        /*::[*/ 0x0287: {
            n: "??"
        },
        /*::[*/ 0x0288: {
            n: "??"
        },
        /*::[*/ 0x0292: {
            n: "??"
        },
        /*::[*/ 0x0293: {
            n: "??"
        },
        /*::[*/ 0x0294: {
            n: "??"
        },
        /*::[*/ 0x0295: {
            n: "??"
        },
        /*::[*/ 0x0296: {
            n: "??"
        },
        /*::[*/ 0x0299: {
            n: "??"
        },
        /*::[*/ 0x029A: {
            n: "??"
        },
        /*::[*/ 0x0300: {
            n: "??"
        },
        /*::[*/ 0x0304: {
            n: "??"
        },
        /*::[*/ 0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        /*::[*/ 0x0640: {
            n: "??"
        },
        /*::[*/ 0x0642: {
            n: "??"
        },
        /*::[*/ 0x0701: {
            n: "??"
        },
        /*::[*/ 0x0702: {
            n: "??"
        },
        /*::[*/ 0x0703: {
            n: "??"
        },
        /*::[*/ 0x0704: {
            n: "??"
        },
        /*::[*/ 0x0780: {
            n: "??"
        },
        /*::[*/ 0x0800: {
            n: "??"
        },
        /*::[*/ 0x0801: {
            n: "??"
        },
        /*::[*/ 0x0804: {
            n: "??"
        },
        /*::[*/ 0x0A80: {
            n: "??"
        },
        /*::[*/ 0x2AF6: {
            n: "??"
        },
        /*::[*/ 0x3231: {
            n: "??"
        },
        /*::[*/ 0x6E49: {
            n: "??"
        },
        /*::[*/ 0x6F44: {
            n: "??"
        },
        /*::[*/ 0xFFFF: {
            n: ""
        }
    };
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $a1a91b25d7598376$var$prep_blob(d, 0);
        var o = opts || {};
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $a1a91b25d7598376$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, "cstr"));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, "cstr");
                    }
                    if (!sname) sname = $a1a91b25d7598376$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                    $a1a91b25d7598376$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $a1a91b25d7598376$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1);
                        if (flags & 0x80) p.l += 2;
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, "i")
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, "f")
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, "f")
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, "i");
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = cell;
                            } else s[CC + $a1a91b25d7598376$var$encode_row(R)] = cell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $a1a91b25d7598376$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $a1a91b25d7598376$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($a1a91b25d7598376$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $a1a91b25d7598376$var$parsexmltag(m[i]);
        switch(y[0].replace(/\w*:/g, "")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case "<condense":
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case "<extend":
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case "<shadow":
                if (!y.val) break;
            /* falls through */ case "<shadow>":
            case "<shadow/>":
                font.shadow = 1;
                break;
            case "</shadow>":
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case "<charset":
                if (y.val == "1") break;
                font.cp = $a1a91b25d7598376$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case "<outline":
                if (!y.val) break;
            /* falls through */ case "<outline>":
            case "<outline/>":
                font.outline = 1;
                break;
            case "</outline>":
                break;
            /* 18.4.5 rFont CT_FontName */ case "<rFont":
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                if (!y.val) break;
            /* falls through */ case "<strike>":
            case "<strike/>":
                font.strike = 1;
                break;
            case "</strike>":
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                if (!y.val) break;
                switch(y.val){
                    case "double":
                        font.uval = "double";
                        break;
                    case "singleAccounting":
                        font.uval = "single-accounting";
                        break;
                    case "doubleAccounting":
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case "<u>":
            case "<u/>":
                font.u = 1;
                break;
            case "</u>":
                break;
            /* 18.8.2 b */ case "<b":
                if (y.val == "0") break;
            /* falls through */ case "<b>":
            case "<b/>":
                font.b = 1;
                break;
            case "</b>":
                break;
            /* 18.8.26 i */ case "<i":
                if (y.val == "0") break;
            /* falls through */ case "<i>":
            case "<i/>":
                font.i = 1;
                break;
            case "</i>":
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case "<color":
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case "<color>":
            case "<color/>":
            case "</color>":
                break;
            /* 18.8.18 family ST_FontFamily */ case "<family":
                font.family = y.val;
                break;
            case "<family>":
            case "<family/>":
            case "</family>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case "<vertAlign":
                font.valign = y.val;
                break;
            case "<vertAlign>":
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case "<scheme":
                break;
            case "<scheme>":
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error("Unrecognized rich format " + y[0]);
        }
    }
    return font;
}
var $a1a91b25d7598376$var$parse_rs = /*#__PURE__*/ function() {
    var tregex = $a1a91b25d7598376$var$matchtag("t"), rpregex = $a1a91b25d7598376$var$matchtag("rPr");
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = r.match(tregex) /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: "s",
            v: $a1a91b25d7598376$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = r.match(rpregex);
        if (rpr) o.s = $a1a91b25d7598376$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $a1a91b25d7598376$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, "<br/>") + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $a1a91b25d7598376$var$sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, $a1a91b25d7598376$var$sirregex = /<(?:\w+:)?r\b[^>]*>/;
var $a1a91b25d7598376$var$sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function $a1a91b25d7598376$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $a1a91b25d7598376$var$utf8read(x);
        if (html) z.h = $a1a91b25d7598376$var$escapehtml(z.t);
    } else if (/*y = */ x.match($a1a91b25d7598376$var$sirregex)) {
        z.r = $a1a91b25d7598376$var$utf8read(x);
        z.t = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read((x.replace($a1a91b25d7598376$var$sirphregex, "").match($a1a91b25d7598376$var$sitregex) || []).join("").replace($a1a91b25d7598376$var$tagregex, "")), true);
        if (html) z.h = $a1a91b25d7598376$var$rs_to_html($a1a91b25d7598376$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $a1a91b25d7598376$var$sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var $a1a91b25d7598376$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $a1a91b25d7598376$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $a1a91b25d7598376$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = data.match($a1a91b25d7598376$var$sstr0);
    if (sst) {
        ss = sst[2].replace($a1a91b25d7598376$var$sstr1, "").split($a1a91b25d7598376$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $a1a91b25d7598376$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $a1a91b25d7598376$var$parsexmltag(sst[1]);
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $a1a91b25d7598376$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $a1a91b25d7598376$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = $a1a91b25d7598376$var$writextag("sst", null, {
        xmlns: $a1a91b25d7598376$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($a1a91b25d7598376$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $a1a91b25d7598376$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = "</sst>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $a1a91b25d7598376$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $a1a91b25d7598376$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_sst(val, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val[0];
                s.Unique = val[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $a1a91b25d7598376$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $a1a91b25d7598376$var$write_BrtSSTItem = $a1a91b25d7598376$var$write_RichStr;
function $a1a91b25d7598376$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x009F /* BrtBeginSst */ , $a1a91b25d7598376$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$a1a91b25d7598376$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $a1a91b25d7598376$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $a1a91b25d7598376$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $a1a91b25d7598376$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $a1a91b25d7598376$var$$cptable !== "undefined") return $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $a1a91b25d7598376$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, "lpp4");
    o.R = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.U = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.W = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $a1a91b25d7598376$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, "lpp4")
    });
    o.name = blob.read_shift(0, "lpp4");
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $a1a91b25d7598376$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($a1a91b25d7598376$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $a1a91b25d7598376$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, "lpp4"));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $a1a91b25d7598376$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, "lpp4");
    o.name = blob.read_shift(0, "lpp4");
    o.R = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.U = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.W = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $a1a91b25d7598376$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $a1a91b25d7598376$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, "8lpp4");
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $a1a91b25d7598376$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw "Unrecognized encryption algorithm: " + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, "utf16le");
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $a1a91b25d7598376$var$parse_EncryptionInfo(blob) {
    var vers = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $a1a91b25d7598376$var$parse_EncryptionHeader(blob, sz);
    var verifier = $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, "utf8");
    var o = {};
    xml.replace($a1a91b25d7598376$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<encryption":
            case "</encryption>":
                break;
            case "<keyData":
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case "<dataIntegrity":
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case "<keyEncryptors>":
            case "<keyEncryptors":
                o.encs = [];
                break;
            case "</keyEncryptors>":
                break;
            case "<keyEncryptor":
                o.uri = y.uri;
                break;
            case "</keyEncryptor>":
                break;
            case "<encryptedKey":
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $a1a91b25d7598376$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error("unrecognized minor version code: " + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error("unrecognized major version code: " + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $a1a91b25d7598376$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $a1a91b25d7598376$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw "unrecognized version code " + vers.Major + " : " + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $a1a91b25d7598376$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $a1a91b25d7598376$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $a1a91b25d7598376$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $a1a91b25d7598376$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $a1a91b25d7598376$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $a1a91b25d7598376$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $a1a91b25d7598376$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $a1a91b25d7598376$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $a1a91b25d7598376$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $a1a91b25d7598376$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $a1a91b25d7598376$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $a1a91b25d7598376$var$parseuint16(blob),
        verificationBytes: $a1a91b25d7598376$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $a1a91b25d7598376$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $a1a91b25d7598376$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $a1a91b25d7598376$var$parse_RC4Header(blob, length);
    else o.Data = $a1a91b25d7598376$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $a1a91b25d7598376$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $a1a91b25d7598376$var$parse_FilePassHeader(blob, length - 2, o);
    else $a1a91b25d7598376$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $a1a91b25d7598376$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$Base64_decode(d), opts);
        case "binary":
            return $a1a91b25d7598376$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString("binary") : $a1a91b25d7598376$var$a2s(d), opts);
        case "array":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $a1a91b25d7598376$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = str.match(/\\trowd[\s\S]*?\\row\b/g);
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($a1a91b25d7598376$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $a1a91b25d7598376$var$fuzzynum(cell.v);
                        }
                        if (dense) row[C] = cell;
                        else ws[$a1a91b25d7598376$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$rtf_to_workbook(d, opts) {
    var wb = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $a1a91b25d7598376$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $a1a91b25d7598376$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $a1a91b25d7598376$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $a1a91b25d7598376$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $a1a91b25d7598376$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $a1a91b25d7598376$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $a1a91b25d7598376$var$rgb2HSL($a1a91b25d7598376$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $a1a91b25d7598376$var$rgb2Hex($a1a91b25d7598376$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $a1a91b25d7598376$var$DEF_MDW = 6, $a1a91b25d7598376$var$MAX_MDW = 15, $a1a91b25d7598376$var$MIN_MDW = 1, $a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$DEF_MDW;
function $a1a91b25d7598376$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $a1a91b25d7598376$var$MDW) / 256) * $a1a91b25d7598376$var$MDW);
}
function $a1a91b25d7598376$var$px2char(px) {
    return Math.floor((px - 5) / $a1a91b25d7598376$var$MDW * 100 + 0.5) / 100;
}
function $a1a91b25d7598376$var$char2width(chr) {
    return Math.round((chr * $a1a91b25d7598376$var$MDW + 5) / $a1a91b25d7598376$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $a1a91b25d7598376$var$cycle_width(collw) {
    return $a1a91b25d7598376$var$char2width($a1a91b25d7598376$var$px2char($a1a91b25d7598376$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $a1a91b25d7598376$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw)), _MDW = $a1a91b25d7598376$var$MDW;
    if (delta > 0.005) {
        for($a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$MIN_MDW; $a1a91b25d7598376$var$MDW < $a1a91b25d7598376$var$MAX_MDW; ++$a1a91b25d7598376$var$MDW)if (Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw));
            _MDW = $a1a91b25d7598376$var$MDW;
        }
    }
    $a1a91b25d7598376$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $a1a91b25d7598376$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $a1a91b25d7598376$var$width2px(coll.width);
        coll.wch = $a1a91b25d7598376$var$px2char(coll.wpx);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $a1a91b25d7598376$var$px2char(coll.wpx);
        coll.width = $a1a91b25d7598376$var$char2width(coll.wch);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    } else if (typeof coll.wch == "number") {
        coll.width = $a1a91b25d7598376$var$char2width(coll.wch);
        coll.wpx = $a1a91b25d7598376$var$width2px(coll.width);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $a1a91b25d7598376$var$DEF_PPI = 96, $a1a91b25d7598376$var$PPI = $a1a91b25d7598376$var$DEF_PPI;
function $a1a91b25d7598376$var$px2pt(px) {
    return px * 96 / $a1a91b25d7598376$var$PPI;
}
function $a1a91b25d7598376$var$pt2px(pt) {
    return pt * $a1a91b25d7598376$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $a1a91b25d7598376$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $a1a91b25d7598376$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<borders":
            case "<borders>":
            case "</borders>":
                break;
            /* 18.8.4 border CT_Border */ case "<border":
            case "<border>":
            case "<border/>":
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $a1a91b25d7598376$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $a1a91b25d7598376$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case "</border>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<left/>":
                break;
            case "<left":
            case "<left>":
                break;
            case "</left>":
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case "<right/>":
                break;
            case "<right":
            case "<right>":
                break;
            case "</right>":
                break;
            /* 18.8.43 top CT_BorderPr */ case "<top/>":
                break;
            case "<top":
            case "<top>":
                break;
            case "</top>":
                break;
            /* 18.8.6 bottom CT_BorderPr */ case "<bottom/>":
                break;
            case "<bottom":
            case "<bottom>":
                break;
            case "</bottom>":
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case "<diagonal":
            case "<diagonal>":
            case "<diagonal/>":
                break;
            case "</diagonal>":
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case "<horizontal":
            case "<horizontal>":
            case "<horizontal/>":
                break;
            case "</horizontal>":
                break;
            /* 18.8.44 vertical CT_BorderPr */ case "<vertical":
            case "<vertical>":
            case "<vertical/>":
                break;
            case "</vertical>":
                break;
            /* 18.8.37 start CT_BorderPr */ case "<start":
            case "<start>":
            case "<start/>":
                break;
            case "</start>":
                break;
            /* 18.8.16 end CT_BorderPr */ case "<end":
            case "<end>":
            case "<end/>":
                break;
            case "</end>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color>":
                break;
            case "<color/>":
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in borders");
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $a1a91b25d7598376$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<fills":
            case "<fills>":
            case "</fills>":
                break;
            /* 18.8.20 fill CT_Fill */ case "<fill>":
            case "<fill":
            case "<fill/>":
                fill = {};
                styles.Fills.push(fill);
                break;
            case "</fill>":
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case "<gradientFill>":
                break;
            case "<gradientFill":
            case "</gradientFill>":
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case "<patternFill":
            case "<patternFill>":
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case "<patternFill/>":
            case "</patternFill>":
                break;
            /* 18.8.3 bgColor CT_Color */ case "<bgColor":
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case "<bgColor/>":
            case "</bgColor>":
                break;
            /* 18.8.19 fgColor CT_Color */ case "<fgColor":
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case "<fgColor/>":
            case "</fgColor>":
                break;
            /* 18.8.38 stop CT_GradientStop */ case "<stop":
            case "<stop/>":
                break;
            case "</stop>":
                break;
            /* 18.8.? color CT_Color */ case "<color":
            case "<color/>":
                break;
            case "</color>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fills");
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $a1a91b25d7598376$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<fonts":
            case "<fonts>":
            case "</fonts>":
                break;
            /* 18.8.22 font CT_Font */ case "<font":
            case "<font>":
                break;
            case "</font>":
            case "<font/>":
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case "<name":
                if (y.val) font.name = $a1a91b25d7598376$var$utf8read(y.val);
                break;
            case "<name/>":
            case "</name>":
                break;
            /* 18.8.2  b CT_BooleanProperty */ case "<b":
                font.bold = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<b/>":
                font.bold = 1;
                break;
            /* 18.8.26 i CT_BooleanProperty */ case "<i":
                font.italic = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<i/>":
                font.italic = 1;
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case "<u":
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case "<u/>":
                font.underline = 1;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case "<strike":
                font.strike = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<strike/>":
                font.strike = 1;
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case "<outline":
                font.outline = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<outline/>":
                font.outline = 1;
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case "<shadow":
                font.shadow = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<shadow/>":
                font.shadow = 1;
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case "<condense":
                font.condense = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<condense/>":
                font.condense = 1;
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case "<extend":
                font.extend = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case "<extend/>":
                font.extend = 1;
                break;
            /* 18.4.11 sz CT_FontSize */ case "<sz":
                if (y.val) font.sz = +y.val;
                break;
            case "<sz/>":
            case "</sz>":
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case "<vertAlign":
                if (y.val) font.vertAlign = y.val;
                break;
            case "<vertAlign/>":
            case "</vertAlign>":
                break;
            /* 18.8.18 family CT_FontFamily */ case "<family":
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case "<family/>":
            case "</family>":
                break;
            /* 18.8.35 scheme CT_FontScheme */ case "<scheme":
                if (y.val) font.scheme = y.val;
                break;
            case "<scheme/>":
            case "</scheme>":
                break;
            /* 18.4.1 charset CT_IntProperty */ case "<charset":
                if (y.val == "1") break;
                y.codepage = $a1a91b25d7598376$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.?.? color CT_Color */ case "<color":
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $a1a91b25d7598376$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $a1a91b25d7598376$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $a1a91b25d7598376$var$XLSIcv[1];
                    if (!icv) icv = $a1a91b25d7598376$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case "<color/>":
            case "</color>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in fonts");
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $a1a91b25d7598376$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $a1a91b25d7598376$var$keys($a1a91b25d7598376$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $a1a91b25d7598376$var$table_fmt[k[i]];
    var m = t[0].match($a1a91b25d7598376$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $a1a91b25d7598376$var$parsexmltag(m[i]);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<numFmts":
            case "</numFmts>":
            case "<numFmts/>":
            case "<numFmts>":
                break;
            case "<numFmt":
                var f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $a1a91b25d7598376$var$SSF__load(f, j);
                }
                break;
            case "</numFmt>":
                break;
            default:
                if (opts.WTF) throw new Error("unrecognized " + y[0] + " in numFmts");
        }
    }
}
function $a1a91b25d7598376$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $a1a91b25d7598376$var$writextag("numFmt", null, {
            numFmtId: i,
            formatCode: $a1a91b25d7598376$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $a1a91b25d7598376$var$writextag("numFmts", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $a1a91b25d7598376$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $a1a91b25d7598376$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $a1a91b25d7598376$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x), i = 0;
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<cellXfs":
            case "<cellXfs>":
            case "<cellXfs/>":
            case "</cellXfs>":
                break;
            /* 18.8.45 xf CT_Xf */ case "<xf":
            case "<xf/>":
                xf = y;
                delete xf[0];
                for(i = 0; i < $a1a91b25d7598376$var$cellXF_uint.length; ++i)if (xf[$a1a91b25d7598376$var$cellXF_uint[i]]) xf[$a1a91b25d7598376$var$cellXF_uint[i]] = parseInt(xf[$a1a91b25d7598376$var$cellXF_uint[i]], 10);
                for(i = 0; i < $a1a91b25d7598376$var$cellXF_bool.length; ++i)if (xf[$a1a91b25d7598376$var$cellXF_bool[i]]) xf[$a1a91b25d7598376$var$cellXF_bool[i]] = $a1a91b25d7598376$var$parsexmlbool(xf[$a1a91b25d7598376$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case "</xf>":
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case "<alignment":
            case "<alignment/>":
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $a1a91b25d7598376$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case "</alignment>":
                break;
            /* 18.8.33 protection CT_CellProtection */ case "<protection":
                break;
            case "</protection>":
            case "<protection/>":
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case "<AlternateContent":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error("unrecognized " + y[0] + " in cellXfs");
                }
        }
    });
}
function $a1a91b25d7598376$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $a1a91b25d7598376$var$writextag("cellXfs", null);
    cellXfs.forEach(function(c) {
        o[o.length] = $a1a91b25d7598376$var$writextag("xf", null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $a1a91b25d7598376$var$writextag("cellXfs", null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $a1a91b25d7598376$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
    var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
    var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
    var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
    var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = data.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = data.match(numFmtRegex)) $a1a91b25d7598376$var$parse_numFmts(t, styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = data.match(fontsRegex)) $a1a91b25d7598376$var$parse_fonts(t, styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = data.match(fillsRegex)) $a1a91b25d7598376$var$parse_fills(t, styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = data.match(bordersRegex)) $a1a91b25d7598376$var$parse_borders(t, styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = data.match(cellXfRegex)) $a1a91b25d7598376$var$parse_cellXfs(t, styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $a1a91b25d7598376$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("styleSheet", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS_main[0],
            "xmlns:vt": $a1a91b25d7598376$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $a1a91b25d7598376$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $a1a91b25d7598376$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = "</styleSheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $a1a91b25d7598376$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $a1a91b25d7598376$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $a1a91b25d7598376$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $a1a91b25d7598376$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $a1a91b25d7598376$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $a1a91b25d7598376$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $a1a91b25d7598376$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $a1a91b25d7598376$var$parse_XLWideString(data, length - 21);
    return out;
}
function $a1a91b25d7598376$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $a1a91b25d7598376$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $a1a91b25d7598376$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $a1a91b25d7598376$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $a1a91b25d7598376$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $a1a91b25d7598376$var$parse_BrtFill = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$write_BrtFill(fill, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(84);
    if (!$a1a91b25d7598376$var$rev_XLSBFillPTNames) $a1a91b25d7598376$var$rev_XLSBFillPTNames = $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$XLSBFillPTNames);
    var fls /*:number*/  = $a1a91b25d7598376$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $a1a91b25d7598376$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $a1a91b25d7598376$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $a1a91b25d7598376$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $a1a91b25d7598376$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $a1a91b25d7598376$var$write_Blxf(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $a1a91b25d7598376$var$parse_BrtBorder = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$write_BrtBorder(border, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* top */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* bottom */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* left */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* right */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $a1a91b25d7598376$var$write_BrtStyle(style, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $a1a91b25d7598376$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $a1a91b25d7598376$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $a1a91b25d7598376$var$new_buf(2052);
    o.write_shift(4, cnt);
    $a1a91b25d7598376$var$write_XLNullableWideString(defTableStyle, o);
    $a1a91b25d7598376$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $a1a91b25d7598376$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $a1a91b25d7598376$var$table_fmt)styles.NumberFmt[y] = $a1a91b25d7598376$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_sty(val, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val[0]] = val[1];
                $a1a91b25d7598376$var$SSF__load(val[1], val[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val);
                if (val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val.color.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $a1a91b25d7598376$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $a1a91b25d7598376$var$write_record(ba, 0x002C /* BrtFmt */ , $a1a91b25d7598376$var$write_BrtFmt(i, NF[i]));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $a1a91b25d7598376$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002B /* BrtFont */ , $a1a91b25d7598376$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $a1a91b25d7598376$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $a1a91b25d7598376$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x025B /* BrtBeginFills */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002D /* BrtFill */ , $a1a91b25d7598376$var$write_BrtFill({
        patternType: "none"
    }));
    $a1a91b25d7598376$var$write_record(ba, 0x002D /* BrtFill */ , $a1a91b25d7598376$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $a1a91b25d7598376$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $a1a91b25d7598376$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002E /* BrtBorder */ , $a1a91b25d7598376$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $a1a91b25d7598376$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $a1a91b25d7598376$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $a1a91b25d7598376$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002F /* BrtXF */ , $a1a91b25d7598376$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $a1a91b25d7598376$var$write_CELLXFS_bin(ba, data) {
    $a1a91b25d7598376$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $a1a91b25d7598376$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $a1a91b25d7598376$var$write_record(ba, 0x002F /* BrtXF */ , $a1a91b25d7598376$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $a1a91b25d7598376$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $a1a91b25d7598376$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x0030 /* BrtStyle */ , $a1a91b25d7598376$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $a1a91b25d7598376$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $a1a91b25d7598376$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $a1a91b25d7598376$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $a1a91b25d7598376$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $a1a91b25d7598376$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $a1a91b25d7598376$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $a1a91b25d7598376$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $a1a91b25d7598376$var$write_sty_bin(wb, opts) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $a1a91b25d7598376$var$write_FMTS_bin(ba, wb.SSF);
    $a1a91b25d7598376$var$write_FONTS_bin(ba, wb);
    $a1a91b25d7598376$var$write_FILLS_bin(ba, wb);
    $a1a91b25d7598376$var$write_BORDERS_bin(ba, wb);
    $a1a91b25d7598376$var$write_CELLSTYLEXFS_bin(ba, wb);
    $a1a91b25d7598376$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $a1a91b25d7598376$var$write_STYLES_bin(ba, wb);
    $a1a91b25d7598376$var$write_DXFS_bin(ba, wb);
    $a1a91b25d7598376$var$write_TABLESTYLES_bin(ba, wb);
    $a1a91b25d7598376$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $a1a91b25d7598376$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $a1a91b25d7598376$var$XLSXThemeClrScheme = [
    "</a:lt1>",
    "</a:dk1>",
    "</a:lt2>",
    "</a:dk2>",
    "</a:accent1>",
    "</a:accent2>",
    "</a:accent3>",
    "</a:accent4>",
    "</a:accent5>",
    "</a:accent6>",
    "</a:hlink>",
    "</a:folHlink>"
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $a1a91b25d7598376$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case "<a:clrScheme":
            case "</a:clrScheme>":
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case "<a:srgbClr":
                color.rgb = y.val;
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case "<a:sysClr":
                color.rgb = y.lastClr;
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case "<a:dk1>":
            case "</a:dk1>":
            case "<a:lt1>":
            case "</a:lt1>":
            case "<a:dk2>":
            case "</a:dk2>":
            case "<a:lt2>":
            case "</a:lt2>":
            case "<a:accent1>":
            case "</a:accent1>":
            case "<a:accent2>":
            case "</a:accent2>":
            case "<a:accent3>":
            case "</a:accent3>":
            case "<a:accent4>":
            case "</a:accent4>":
            case "<a:accent5>":
            case "</a:accent5>":
            case "<a:accent6>":
            case "</a:accent6>":
            case "<a:hlink>":
            case "</a:hlink>":
            case "<a:folHlink>":
            case "</a:folHlink>":
                if (y[0].charAt(1) === "/") {
                    themes.themeElements.clrScheme[$a1a91b25d7598376$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error("Unrecognized " + y[0] + " in clrScheme");
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $a1a91b25d7598376$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $a1a91b25d7598376$var$parse_fmtScheme() {}
var $a1a91b25d7598376$var$clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var $a1a91b25d7598376$var$fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var $a1a91b25d7598376$var$fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
/* 20.1.6.10 themeElements CT_BaseStyles */ function $a1a91b25d7598376$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    [
        /* clrScheme CT_ColorScheme */ [
            "clrScheme",
            $a1a91b25d7598376$var$clrsregex,
            $a1a91b25d7598376$var$parse_clrScheme
        ],
        /* fontScheme CT_FontScheme */ [
            "fontScheme",
            $a1a91b25d7598376$var$fntsregex,
            $a1a91b25d7598376$var$parse_fontScheme
        ],
        /* fmtScheme CT_StyleMatrix */ [
            "fmtScheme",
            $a1a91b25d7598376$var$fmtsregex,
            $a1a91b25d7598376$var$parse_fmtScheme
        ]
    ].forEach(function(m) {
        if (!(t = data.match(m[1]))) throw new Error(m[0] + " not found in themeElements");
        m[2](t, themes, opts);
    });
}
var $a1a91b25d7598376$var$themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
/* 14.2.7 Theme Part */ function $a1a91b25d7598376$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $a1a91b25d7598376$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = data.match($a1a91b25d7598376$var$themeltregex))) throw new Error("themeElements not found in theme");
    $a1a91b25d7598376$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $a1a91b25d7598376$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = "<a:themeElements>";
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = "</a:clrScheme>";
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = "<a:majorFont>";
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:majorFont>";
    o[o.length] = "<a:minorFont>";
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = "</a:minorFont>";
    o[o.length] = "</a:fontScheme>";
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = "<a:fillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:fillStyleLst>";
    o[o.length] = "<a:lnStyleLst>";
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = "</a:lnStyleLst>";
    o[o.length] = "<a:effectStyleLst>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "<a:effectStyle>";
    o[o.length] = "<a:effectLst>";
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = "</a:effectLst>";
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = "</a:effectStyle>";
    o[o.length] = "</a:effectStyleLst>";
    o[o.length] = "<a:bgFillStyleLst>";
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = "<a:gsLst>";
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = "</a:gsLst>";
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = "</a:gradFill>";
    o[o.length] = "</a:bgFillStyleLst>";
    o[o.length] = "</a:fmtScheme>";
    o[o.length] = "</a:themeElements>";
    o[o.length] = "<a:objectDefaults>";
    o[o.length] = "<a:spDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = "</a:spDef>";
    o[o.length] = "<a:lnDef>";
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = "</a:lnDef>";
    o[o.length] = "</a:objectDefaults>";
    o[o.length] = "<a:extraClrSchemeLst/>";
    o[o.length] = "</a:theme>";
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $a1a91b25d7598376$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $a1a91b25d7598376$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $a1a91b25d7598376$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $a1a91b25d7598376$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $a1a91b25d7598376$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $a1a91b25d7598376$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $a1a91b25d7598376$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $a1a91b25d7598376$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $a1a91b25d7598376$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $a1a91b25d7598376$var$parse_IcvXF(blob, length) {
    return $a1a91b25d7598376$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $a1a91b25d7598376$var$parse_XFExtGradient(blob, length) {
    return $a1a91b25d7598376$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $a1a91b25d7598376$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $a1a91b25d7598376$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $a1a91b25d7598376$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $a1a91b25d7598376$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($a1a91b25d7598376$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $a1a91b25d7598376$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $a1a91b25d7598376$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $a1a91b25d7598376$var$parse_XLWideString(data, length - 8)
    };
}
function $a1a91b25d7598376$var$write_BrtMdtinfo(data) {
    var o = $a1a91b25d7598376$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $a1a91b25d7598376$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $a1a91b25d7598376$var$write_BrtMdb(mdb) {
    var o = $a1a91b25d7598376$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $a1a91b25d7598376$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $a1a91b25d7598376$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $a1a91b25d7598376$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $a1a91b25d7598376$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $a1a91b25d7598376$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $a1a91b25d7598376$var$recordhopper(data, function(val, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val.name
                });
                break;
            case 51:
                val.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $a1a91b25d7598376$var$write_xlmeta_bin() {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 332);
    $a1a91b25d7598376$var$write_record(ba, 334, $a1a91b25d7598376$var$write_UInt32LE(1));
    $a1a91b25d7598376$var$write_record(ba, 335, $a1a91b25d7598376$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $a1a91b25d7598376$var$write_record(ba, 336);
    $a1a91b25d7598376$var$write_record(ba, 339, $a1a91b25d7598376$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $a1a91b25d7598376$var$write_record(ba, 52);
    $a1a91b25d7598376$var$write_record(ba, 35, $a1a91b25d7598376$var$write_UInt32LE(514));
    $a1a91b25d7598376$var$write_record(ba, 4096, $a1a91b25d7598376$var$write_UInt32LE(0));
    $a1a91b25d7598376$var$write_record(ba, 4097, $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_record(ba, 36);
    $a1a91b25d7598376$var$write_record(ba, 53);
    $a1a91b25d7598376$var$write_record(ba, 340);
    $a1a91b25d7598376$var$write_record(ba, 337, $a1a91b25d7598376$var$write_BrtBeginEsmdb(1, true));
    $a1a91b25d7598376$var$write_record(ba, 51, $a1a91b25d7598376$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $a1a91b25d7598376$var$write_record(ba, 338);
    $a1a91b25d7598376$var$write_record(ba, 333);
    return ba.end();
}
function $a1a91b25d7598376$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($a1a91b25d7598376$var$tagregex, function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_xlmeta_xml() {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $a1a91b25d7598376$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0]){
            case "<?xml":
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case "<calcChain":
            case "<calcChain>":
            case "</calcChain>":
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case "<c":
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $a1a91b25d7598376$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $a1a91b25d7598376$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = "1";
    if (flags & 0x8) out.a = "1";
    return out;
}
/* 18.6 Calculation Chain */ function $a1a91b25d7598376$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_cc(val, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $a1a91b25d7598376$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $a1a91b25d7598376$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $a1a91b25d7598376$var$recordhopper(data, function xlink_parse(val, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $a1a91b25d7598376$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/) || [
        "",
        ""
    ])[1];
    return rels["!id"][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $a1a91b25d7598376$var$write_vml(rId /*:number*/ , comments) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $a1a91b25d7598376$var$writextag("xml", null, {
            "xmlns:v": $a1a91b25d7598376$var$XLMLNS.v,
            "xmlns:o": $a1a91b25d7598376$var$XLMLNS.o,
            "xmlns:x": $a1a91b25d7598376$var$XLMLNS.x,
            "xmlns:mv": $a1a91b25d7598376$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $a1a91b25d7598376$var$writextag("o:shapelayout", $a1a91b25d7598376$var$writextag("o:idmap", null, {
            "v:ext": "edit",
            "data": rId
        }), {
            "v:ext": "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($a1a91b25d7598376$var$writextag("v:shapetype", [
        $a1a91b25d7598376$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $a1a91b25d7598376$var$writextag("v:path", null, {
            gradientshapeok: "t",
            "o:connecttype": "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        "o:spt": 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($a1a91b25d7598376$var$write_vml_comment(x, _shapeid));
    });
    o.push("</xml>");
    return o.join("");
}
function $a1a91b25d7598376$var$write_vml_comment(x, _shapeid) /*:string*/ {
    var c = $a1a91b25d7598376$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        "color2": "#BEFF82",
        "type": "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $a1a91b25d7598376$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        "v:ext": "view"
    }) : null;
    var fillxml = $a1a91b25d7598376$var$writextag("v:fill", fillparm, fillopts);
    var shadata = {
        on: "t",
        "obscured": "t"
    } /*:any*/ ;
    return [
        "<v:shape" + $a1a91b25d7598376$var$wxt_helper({
            id: "_x0000_s" + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + ">",
        fillxml,
        $a1a91b25d7598376$var$writextag("v:shadow", null, shadata),
        $a1a91b25d7598376$var$writextag("v:path", null, {
            "o:connecttype": "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        "<x:MoveWithCells/>",
        "<x:SizeWithCells/>",
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $a1a91b25d7598376$var$writetag("x:Anchor", [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $a1a91b25d7598376$var$writetag("x:AutoFill", "False"),
        $a1a91b25d7598376$var$writetag("x:Row", String(c.r)),
        $a1a91b25d7598376$var$writetag("x:Column", String(c.c)),
        x[1].hidden ? "" : "<x:Visible/>",
        "</x:ClientData>",
        "</v:shape>"
    ].join("");
}
function $a1a91b25d7598376$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $a1a91b25d7598376$var$decode_cell(comment.ref);
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $a1a91b25d7598376$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $a1a91b25d7598376$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
        if (!cm) return;
        var y = $a1a91b25d7598376$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $a1a91b25d7598376$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
        var rt = !!textMatch && !!textMatch[1] && $a1a91b25d7598376$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $a1a91b25d7598376$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("comments", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $a1a91b25d7598376$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($a1a91b25d7598376$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $a1a91b25d7598376$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($a1a91b25d7598376$var$escapexml(c.a)) + '"><text>');
            o.push($a1a91b25d7598376$var$writetag("t", c.t == null ? "" : $a1a91b25d7598376$var$escapexml(c.t)));
            o.push("</text></comment>");
        });
        else {
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($a1a91b25d7598376$var$writetag("t", $a1a91b25d7598376$var$escapexml(t)));
            o.push("</text></comment>");
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = "</comments>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $a1a91b25d7598376$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case "<ThreadedComments":
                break;
            case "</ThreadedComments>":
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case "<threadedComment":
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case "</threadedComment>":
                if (comment.t != null) out.push(comment);
                break;
            case "<text>":
            case "<text":
                tidx = idx + x.length;
                break;
            case "</text>":
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case "<mentions":
            case "<mentions>":
                pass = true;
                break;
            case "</mentions>":
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("ThreadedComments", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($a1a91b25d7598376$var$writextag("threadedComment", $a1a91b25d7598376$var$writetag("text", c.t || ""), tcopts));
        });
    });
    o.push("</ThreadedComments>");
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $a1a91b25d7598376$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 2.4.85 personList CT_PersonList */ case "<personList":
                break;
            case "</personList>":
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case "<person":
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case "</person>":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in threaded comments");
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("personList", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS.TCMNT,
            "xmlns:x": $a1a91b25d7598376$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($a1a91b25d7598376$var$writextag("person", null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $a1a91b25d7598376$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $a1a91b25d7598376$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $a1a91b25d7598376$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $a1a91b25d7598376$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $a1a91b25d7598376$var$parse_BrtCommentAuthor = $a1a91b25d7598376$var$parse_XLWideString;
function $a1a91b25d7598376$var$write_BrtCommentAuthor(data) {
    return $a1a91b25d7598376$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $a1a91b25d7598376$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_cmnt(val, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val.t;
                c.h = val.h;
                c.r = val.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $a1a91b25d7598376$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $a1a91b25d7598376$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $a1a91b25d7598376$var$write_BrtCommentAuthor(c.a));
        });
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            c.iauthor = iauthor.indexOf(c.a);
            var range = {
                s: $a1a91b25d7598376$var$decode_cell(comment[0]),
                e: $a1a91b25d7598376$var$decode_cell(comment[0])
            };
            $a1a91b25d7598376$var$write_record(ba, 0x027B /* BrtBeginComment */ , $a1a91b25d7598376$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $a1a91b25d7598376$var$write_record(ba, 0x027D /* BrtCommentText */ , $a1a91b25d7598376$var$write_BrtCommentText(c));
            $a1a91b25d7598376$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $a1a91b25d7598376$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $a1a91b25d7598376$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $a1a91b25d7598376$var$make_vba_xls(cfb) {
    var newcfb = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $a1a91b25d7598376$export$9f0e51cd97c572a.write(newcfb);
}
function $a1a91b25d7598376$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $a1a91b25d7598376$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $a1a91b25d7598376$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $a1a91b25d7598376$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        "!type": "dialog"
    };
}
function $a1a91b25d7598376$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
function $a1a91b25d7598376$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        "!type": "macro"
    };
}
/* TODO: it will be useful to parse the function str */ var $a1a91b25d7598376$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(C) + (rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $a1a91b25d7598376$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var $a1a91b25d7598376$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($a1a91b25d7598376$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $a1a91b25d7598376$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $a1a91b25d7598376$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $a1a91b25d7598376$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($a1a91b25d7598376$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $a1a91b25d7598376$var$encode_col($a1a91b25d7598376$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $a1a91b25d7598376$var$encode_row($a1a91b25d7598376$var$decode_row($5) + delta.r));
    });
}
function $a1a91b25d7598376$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $a1a91b25d7598376$var$decode_range(range), s = r.s, c = $a1a91b25d7598376$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $a1a91b25d7598376$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $a1a91b25d7598376$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $a1a91b25d7598376$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $a1a91b25d7598376$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $a1a91b25d7598376$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $a1a91b25d7598376$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var C = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $a1a91b25d7598376$var$parse_ColRelU(blob, 2), R = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $a1a91b25d7598376$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var C = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $a1a91b25d7598376$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $a1a91b25d7598376$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $a1a91b25d7598376$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $a1a91b25d7598376$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $a1a91b25d7598376$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $a1a91b25d7598376$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $a1a91b25d7598376$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $a1a91b25d7598376$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $a1a91b25d7598376$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $a1a91b25d7598376$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, "i");
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $a1a91b25d7598376$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $a1a91b25d7598376$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $a1a91b25d7598376$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $a1a91b25d7598376$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $a1a91b25d7598376$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $a1a91b25d7598376$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $a1a91b25d7598376$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $a1a91b25d7598376$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $a1a91b25d7598376$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $a1a91b25d7598376$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $a1a91b25d7598376$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $a1a91b25d7598376$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $a1a91b25d7598376$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $a1a91b25d7598376$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $a1a91b25d7598376$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $a1a91b25d7598376$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $a1a91b25d7598376$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $a1a91b25d7598376$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $a1a91b25d7598376$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $a1a91b25d7598376$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $a1a91b25d7598376$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $a1a91b25d7598376$var$FtabArgc[iftab],
        $a1a91b25d7598376$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $a1a91b25d7598376$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $a1a91b25d7598376$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $a1a91b25d7598376$var$Ftab : $a1a91b25d7598376$var$Cetab)[tab[1]]
    ];
}
function $a1a91b25d7598376$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $a1a91b25d7598376$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $a1a91b25d7598376$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, "i"),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $a1a91b25d7598376$var$parse_PtgErr(blob) {
    blob.l++;
    return $a1a91b25d7598376$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $a1a91b25d7598376$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $a1a91b25d7598376$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $a1a91b25d7598376$var$parse_PtgNum(blob) {
    blob.l++;
    return $a1a91b25d7598376$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $a1a91b25d7598376$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $a1a91b25d7598376$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val[0]){
        case 0x02:
            val[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val[0]){
        case 0x04:
            /* SerBool -- boolean */ val[1] = $a1a91b25d7598376$var$parsebool(blob, 1) ? "TRUE" : "FALSE";
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val[1] = $a1a91b25d7598376$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val[1] = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val[1] = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val[0]); /* Unreachable */ 
    }
    return val;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $a1a91b25d7598376$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $a1a91b25d7598376$var$parse_UncheckedRfX : $a1a91b25d7598376$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $a1a91b25d7598376$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $a1a91b25d7598376$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $a1a91b25d7598376$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $a1a91b25d7598376$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $a1a91b25d7598376$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $a1a91b25d7598376$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, "i"); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $a1a91b25d7598376$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $a1a91b25d7598376$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $a1a91b25d7598376$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $a1a91b25d7598376$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $a1a91b25d7598376$var$parse_PtgMemErr = $a1a91b25d7598376$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $a1a91b25d7598376$var$parse_PtgMemNoMem = $a1a91b25d7598376$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $a1a91b25d7598376$var$parse_PtgTbl = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $a1a91b25d7598376$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $a1a91b25d7598376$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $a1a91b25d7598376$var$parse_PtgElfCol = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $a1a91b25d7598376$var$parse_PtgElfColS = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $a1a91b25d7598376$var$parse_PtgElfColSV = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $a1a91b25d7598376$var$parse_PtgElfColV = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $a1a91b25d7598376$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $a1a91b25d7598376$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $a1a91b25d7598376$var$parse_PtgElfRadical = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $a1a91b25d7598376$var$parse_PtgElfRadicalLel = $a1a91b25d7598376$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $a1a91b25d7598376$var$parse_PtgElfRadicalS = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $a1a91b25d7598376$var$parse_PtgElfRw = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $a1a91b25d7598376$var$parse_PtgElfRwV = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $a1a91b25d7598376$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $a1a91b25d7598376$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $a1a91b25d7598376$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $a1a91b25d7598376$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $a1a91b25d7598376$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $a1a91b25d7598376$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $a1a91b25d7598376$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $a1a91b25d7598376$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $a1a91b25d7598376$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $a1a91b25d7598376$var$PtgTypes = {
    /*::[*/ 0x01: {
        n: "PtgExp",
        f: $a1a91b25d7598376$var$parse_PtgExp
    },
    /*::[*/ 0x02: {
        n: "PtgTbl",
        f: $a1a91b25d7598376$var$parse_PtgTbl
    },
    /*::[*/ 0x03: {
        n: "PtgAdd",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x04: {
        n: "PtgSub",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x05: {
        n: "PtgMul",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x06: {
        n: "PtgDiv",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x07: {
        n: "PtgPower",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x08: {
        n: "PtgConcat",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x09: {
        n: "PtgLt",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x0A: {
        n: "PtgLe",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x0B: {
        n: "PtgEq",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x0C: {
        n: "PtgGe",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x0D: {
        n: "PtgGt",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x0E: {
        n: "PtgNe",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x0F: {
        n: "PtgIsect",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x10: {
        n: "PtgUnion",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x11: {
        n: "PtgRange",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x12: {
        n: "PtgUplus",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x13: {
        n: "PtgUminus",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x14: {
        n: "PtgPercent",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x15: {
        n: "PtgParen",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x16: {
        n: "PtgMissArg",
        f: $a1a91b25d7598376$var$parseread1
    },
    /*::[*/ 0x17: {
        n: "PtgStr",
        f: $a1a91b25d7598376$var$parse_PtgStr
    },
    /*::[*/ 0x1A: {
        n: "PtgSheet",
        f: $a1a91b25d7598376$var$parse_PtgSheet
    },
    /*::[*/ 0x1B: {
        n: "PtgEndSheet",
        f: $a1a91b25d7598376$var$parse_PtgEndSheet
    },
    /*::[*/ 0x1C: {
        n: "PtgErr",
        f: $a1a91b25d7598376$var$parse_PtgErr
    },
    /*::[*/ 0x1D: {
        n: "PtgBool",
        f: $a1a91b25d7598376$var$parse_PtgBool
    },
    /*::[*/ 0x1E: {
        n: "PtgInt",
        f: $a1a91b25d7598376$var$parse_PtgInt
    },
    /*::[*/ 0x1F: {
        n: "PtgNum",
        f: $a1a91b25d7598376$var$parse_PtgNum
    },
    /*::[*/ 0x20: {
        n: "PtgArray",
        f: $a1a91b25d7598376$var$parse_PtgArray
    },
    /*::[*/ 0x21: {
        n: "PtgFunc",
        f: $a1a91b25d7598376$var$parse_PtgFunc
    },
    /*::[*/ 0x22: {
        n: "PtgFuncVar",
        f: $a1a91b25d7598376$var$parse_PtgFuncVar
    },
    /*::[*/ 0x23: {
        n: "PtgName",
        f: $a1a91b25d7598376$var$parse_PtgName
    },
    /*::[*/ 0x24: {
        n: "PtgRef",
        f: $a1a91b25d7598376$var$parse_PtgRef
    },
    /*::[*/ 0x25: {
        n: "PtgArea",
        f: $a1a91b25d7598376$var$parse_PtgArea
    },
    /*::[*/ 0x26: {
        n: "PtgMemArea",
        f: $a1a91b25d7598376$var$parse_PtgMemArea
    },
    /*::[*/ 0x27: {
        n: "PtgMemErr",
        f: $a1a91b25d7598376$var$parse_PtgMemErr
    },
    /*::[*/ 0x28: {
        n: "PtgMemNoMem",
        f: $a1a91b25d7598376$var$parse_PtgMemNoMem
    },
    /*::[*/ 0x29: {
        n: "PtgMemFunc",
        f: $a1a91b25d7598376$var$parse_PtgMemFunc
    },
    /*::[*/ 0x2A: {
        n: "PtgRefErr",
        f: $a1a91b25d7598376$var$parse_PtgRefErr
    },
    /*::[*/ 0x2B: {
        n: "PtgAreaErr",
        f: $a1a91b25d7598376$var$parse_PtgAreaErr
    },
    /*::[*/ 0x2C: {
        n: "PtgRefN",
        f: $a1a91b25d7598376$var$parse_PtgRefN
    },
    /*::[*/ 0x2D: {
        n: "PtgAreaN",
        f: $a1a91b25d7598376$var$parse_PtgAreaN
    },
    /*::[*/ 0x2E: {
        n: "PtgMemAreaN",
        f: $a1a91b25d7598376$var$parse_PtgMemAreaN
    },
    /*::[*/ 0x2F: {
        n: "PtgMemNoMemN",
        f: $a1a91b25d7598376$var$parse_PtgMemNoMemN
    },
    /*::[*/ 0x39: {
        n: "PtgNameX",
        f: $a1a91b25d7598376$var$parse_PtgNameX
    },
    /*::[*/ 0x3A: {
        n: "PtgRef3d",
        f: $a1a91b25d7598376$var$parse_PtgRef3d
    },
    /*::[*/ 0x3B: {
        n: "PtgArea3d",
        f: $a1a91b25d7598376$var$parse_PtgArea3d
    },
    /*::[*/ 0x3C: {
        n: "PtgRefErr3d",
        f: $a1a91b25d7598376$var$parse_PtgRefErr3d
    },
    /*::[*/ 0x3D: {
        n: "PtgAreaErr3d",
        f: $a1a91b25d7598376$var$parse_PtgAreaErr3d
    },
    /*::[*/ 0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $a1a91b25d7598376$var$PtgDupes = {
    /*::[*/ 0x40: 0x20,
    /*::[*/ 0x60: 0x20,
    /*::[*/ 0x41: 0x21,
    /*::[*/ 0x61: 0x21,
    /*::[*/ 0x42: 0x22,
    /*::[*/ 0x62: 0x22,
    /*::[*/ 0x43: 0x23,
    /*::[*/ 0x63: 0x23,
    /*::[*/ 0x44: 0x24,
    /*::[*/ 0x64: 0x24,
    /*::[*/ 0x45: 0x25,
    /*::[*/ 0x65: 0x25,
    /*::[*/ 0x46: 0x26,
    /*::[*/ 0x66: 0x26,
    /*::[*/ 0x47: 0x27,
    /*::[*/ 0x67: 0x27,
    /*::[*/ 0x48: 0x28,
    /*::[*/ 0x68: 0x28,
    /*::[*/ 0x49: 0x29,
    /*::[*/ 0x69: 0x29,
    /*::[*/ 0x4A: 0x2A,
    /*::[*/ 0x6A: 0x2A,
    /*::[*/ 0x4B: 0x2B,
    /*::[*/ 0x6B: 0x2B,
    /*::[*/ 0x4C: 0x2C,
    /*::[*/ 0x6C: 0x2C,
    /*::[*/ 0x4D: 0x2D,
    /*::[*/ 0x6D: 0x2D,
    /*::[*/ 0x4E: 0x2E,
    /*::[*/ 0x6E: 0x2E,
    /*::[*/ 0x4F: 0x2F,
    /*::[*/ 0x6F: 0x2F,
    /*::[*/ 0x58: 0x22,
    /*::[*/ 0x78: 0x22,
    /*::[*/ 0x59: 0x39,
    /*::[*/ 0x79: 0x39,
    /*::[*/ 0x5A: 0x3A,
    /*::[*/ 0x7A: 0x3A,
    /*::[*/ 0x5B: 0x3B,
    /*::[*/ 0x7B: 0x3B,
    /*::[*/ 0x5C: 0x3C,
    /*::[*/ 0x7C: 0x3C,
    /*::[*/ 0x5D: 0x3D,
    /*::[*/ 0x7D: 0x3D
};
var $a1a91b25d7598376$var$Ptg18 = {
    /*::[*/ 0x01: {
        n: "PtgElfLel",
        f: $a1a91b25d7598376$var$parse_PtgElfLel
    },
    /*::[*/ 0x02: {
        n: "PtgElfRw",
        f: $a1a91b25d7598376$var$parse_PtgElfRw
    },
    /*::[*/ 0x03: {
        n: "PtgElfCol",
        f: $a1a91b25d7598376$var$parse_PtgElfCol
    },
    /*::[*/ 0x06: {
        n: "PtgElfRwV",
        f: $a1a91b25d7598376$var$parse_PtgElfRwV
    },
    /*::[*/ 0x07: {
        n: "PtgElfColV",
        f: $a1a91b25d7598376$var$parse_PtgElfColV
    },
    /*::[*/ 0x0A: {
        n: "PtgElfRadical",
        f: $a1a91b25d7598376$var$parse_PtgElfRadical
    },
    /*::[*/ 0x0B: {
        n: "PtgElfRadicalS",
        f: $a1a91b25d7598376$var$parse_PtgElfRadicalS
    },
    /*::[*/ 0x0D: {
        n: "PtgElfColS",
        f: $a1a91b25d7598376$var$parse_PtgElfColS
    },
    /*::[*/ 0x0F: {
        n: "PtgElfColSV",
        f: $a1a91b25d7598376$var$parse_PtgElfColSV
    },
    /*::[*/ 0x10: {
        n: "PtgElfRadicalLel",
        f: $a1a91b25d7598376$var$parse_PtgElfRadicalLel
    },
    /*::[*/ 0x19: {
        n: "PtgList",
        f: $a1a91b25d7598376$var$parse_PtgList
    },
    /*::[*/ 0x1D: {
        n: "PtgSxName",
        f: $a1a91b25d7598376$var$parse_PtgSxName
    },
    /*::[*/ 0xFF: {}
};
var $a1a91b25d7598376$var$Ptg19 = {
    /*::[*/ 0x00: {
        n: "PtgAttrNoop",
        f: $a1a91b25d7598376$var$parse_PtgAttrNoop
    },
    /*::[*/ 0x01: {
        n: "PtgAttrSemi",
        f: $a1a91b25d7598376$var$parse_PtgAttrSemi
    },
    /*::[*/ 0x02: {
        n: "PtgAttrIf",
        f: $a1a91b25d7598376$var$parse_PtgAttrIf
    },
    /*::[*/ 0x04: {
        n: "PtgAttrChoose",
        f: $a1a91b25d7598376$var$parse_PtgAttrChoose
    },
    /*::[*/ 0x08: {
        n: "PtgAttrGoto",
        f: $a1a91b25d7598376$var$parse_PtgAttrGoto
    },
    /*::[*/ 0x10: {
        n: "PtgAttrSum",
        f: $a1a91b25d7598376$var$parse_PtgAttrSum
    },
    /*::[*/ 0x20: {
        n: "PtgAttrBaxcel",
        f: $a1a91b25d7598376$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x21: {
        n: "PtgAttrBaxcel",
        f: $a1a91b25d7598376$var$parse_PtgAttrBaxcel
    },
    /*::[*/ 0x40: {
        n: "PtgAttrSpace",
        f: $a1a91b25d7598376$var$parse_PtgAttrSpace
    },
    /*::[*/ 0x41: {
        n: "PtgAttrSpaceSemi",
        f: $a1a91b25d7598376$var$parse_PtgAttrSpaceSemi
    },
    /*::[*/ 0x80: {
        n: "PtgAttrIfError",
        f: $a1a91b25d7598376$var$parse_PtgAttrIfError
    },
    /*::[*/ 0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $a1a91b25d7598376$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case "PtgArray":
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $a1a91b25d7598376$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case "PtgMemArea":
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $a1a91b25d7598376$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case "PtgExp":
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case "PtgList":
        /* TODO: PtgList -> PtgExtraList */ case "PtgElfRadicalS":
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case "PtgElfColS":
        /* TODO: PtgElfColS -> PtgExtraElf */ case "PtgElfColSV":
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($a1a91b25d7598376$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $a1a91b25d7598376$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $a1a91b25d7598376$var$PtgTypes[id] || $a1a91b25d7598376$var$PtgTypes[$a1a91b25d7598376$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $a1a91b25d7598376$var$Ptg18 : $a1a91b25d7598376$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $a1a91b25d7598376$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $a1a91b25d7598376$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $a1a91b25d7598376$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $a1a91b25d7598376$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $a1a91b25d7598376$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $a1a91b25d7598376$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $a1a91b25d7598376$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $a1a91b25d7598376$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $a1a91b25d7598376$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case "PtgUminus":
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case "PtgUplus":
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case "PtgPercent":
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case "PtgAdd":
            /* [MS-XLS] 2.5.198.26 */ case "PtgConcat":
            /* [MS-XLS] 2.5.198.43 */ case "PtgDiv":
            /* [MS-XLS] 2.5.198.45 */ case "PtgEq":
            /* [MS-XLS] 2.5.198.56 */ case "PtgGe":
            /* [MS-XLS] 2.5.198.64 */ case "PtgGt":
            /* [MS-XLS] 2.5.198.65 */ case "PtgLe":
            /* [MS-XLS] 2.5.198.68 */ case "PtgLt":
            /* [MS-XLS] 2.5.198.69 */ case "PtgMul":
            /* [MS-XLS] 2.5.198.75 */ case "PtgNe":
            /* [MS-XLS] 2.5.198.78 */ case "PtgPower":
            /* [MS-XLS] 2.5.198.82 */ case "PtgSub":
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $a1a91b25d7598376$var$PtgBinOp[f[0]] + e1);
                break;
            case "PtgIsect":
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case "PtgUnion":
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case "PtgRange":
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($a1a91b25d7598376$var$make_3d_range(e2, e1));
                break;
            case "PtgAttrChoose":
                break;
            case "PtgAttrGoto":
                break;
            case "PtgAttrIf":
                break;
            case "PtgAttrIfError":
                break;
            case "PtgRef":
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $a1a91b25d7598376$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case "PtgRefN":
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $a1a91b25d7598376$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case "PtgRef3d":
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $a1a91b25d7598376$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $a1a91b25d7598376$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case "PtgFunc":
            /* [MS-XLS] 2.5.198.62 */ case "PtgFuncVar":
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === "User") func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case "PtgBool":
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case "PtgInt":
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgNum":
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case "PtgStr":
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case "PtgErr":
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case "PtgAreaN":
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $a1a91b25d7598376$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea":
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $a1a91b25d7598376$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgArea3d":
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $a1a91b25d7598376$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case "PtgAttrSum":
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case "PtgAttrBaxcel":
            /* [MS-XLS] 2.5.198.33 */ case "PtgAttrSemi":
                break;
            case "PtgName":
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case "PtgNameX":
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($a1a91b25d7598376$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case "PtgParen":
                /* [MS-XLS] 2.5.198.80 */ var lp = "(", rp = ")";
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case "PtgRefErr":
                /* [MS-XLS] 2.5.198.86 */ stack.push("#REF!");
                break;
            case "PtgRefErr3d":
                /* [MS-XLS] 2.5.198.87 */ stack.push("#REF!");
                break;
            case "PtgExp":
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$a1a91b25d7598376$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$a1a91b25d7598376$var$encode_cell(c)];
                    stack.push($a1a91b25d7598376$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($a1a91b25d7598376$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case "PtgArray":
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $a1a91b25d7598376$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case "PtgMemArea":
                break;
            case "PtgAttrSpace":
            /* [MS-XLS] 2.5.198.38 */ case "PtgAttrSpaceSemi":
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case "PtgTbl":
                break;
            case "PtgMemErr":
                break;
            case "PtgMissArg":
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case "PtgAreaErr":
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case "PtgAreaErr3d":
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case "PtgList":
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case "PtgMemAreaN":
            case "PtgMemNoMemN":
            case "PtgAttrNoop":
            case "PtgSheet":
            case "PtgEndSheet":
                break;
            case "PtgMemFunc":
                break;
            case "PtgMemNoMem":
                break;
            case "PtgElfCol":
            /* [MS-XLS] 2.5.198.46 */ case "PtgElfColS":
            /* [MS-XLS] 2.5.198.47 */ case "PtgElfColSV":
            /* [MS-XLS] 2.5.198.48 */ case "PtgElfColV":
            /* [MS-XLS] 2.5.198.49 */ case "PtgElfLel":
            /* [MS-XLS] 2.5.198.50 */ case "PtgElfRadical":
            /* [MS-XLS] 2.5.198.51 */ case "PtgElfRadicalLel":
            /* [MS-XLS] 2.5.198.52 */ case "PtgElfRadicalS":
            /* [MS-XLS] 2.5.198.53 */ case "PtgElfRw":
            /* [MS-XLS] 2.5.198.54 */ case "PtgElfRwV":
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case "PtgSxName":
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error("Unrecognized Formula Token: " + String(f));
            default:
                throw new Error("Unrecognized Formula Token: " + String(f));
        }
        var PtgNonDisp = [
            "PtgAttrSpace",
            "PtgAttrSpaceSemi",
            "PtgAttrGoto"
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $a1a91b25d7598376$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $a1a91b25d7598376$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $a1a91b25d7598376$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $a1a91b25d7598376$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $a1a91b25d7598376$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $a1a91b25d7598376$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $a1a91b25d7598376$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($a1a91b25d7598376$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $a1a91b25d7598376$var$parse_Xnum(blob),
        "n"
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                "s"
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                "b"
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                "e"
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                "s"
            ];
    }
    return [];
}
function $a1a91b25d7598376$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $a1a91b25d7598376$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $a1a91b25d7598376$var$write_Xnum(value);
    return $a1a91b25d7598376$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $a1a91b25d7598376$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6);
    if (opts.biff == 2) ++blob.l;
    var val = $a1a91b25d7598376$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $a1a91b25d7598376$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val[1]
    };
}
function $a1a91b25d7598376$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $a1a91b25d7598376$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $a1a91b25d7598376$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $a1a91b25d7598376$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $a1a91b25d7598376$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $a1a91b25d7598376$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $a1a91b25d7598376$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $a1a91b25d7598376$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $a1a91b25d7598376$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBArrayParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBCellParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBNameParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBSharedParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $a1a91b25d7598376$var$write_XLSBFormulaNum(val /*:number*/ ) {
    if ((val | 0) == val && val < Math.pow(2, 16) && val >= 0) {
        var oint = $a1a91b25d7598376$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $a1a91b25d7598376$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $a1a91b25d7598376$var$write_XLSBFormulaErr(val /*:number*/ ) {
    var oint = $a1a91b25d7598376$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $a1a91b25d7598376$var$write_XLSBFormulaBool(val /*:boolean*/ ) {
    var oint = $a1a91b25d7598376$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $a1a91b25d7598376$var$write_XLSBFormulaStr(val /*:string*/ ) {
    var preamble = $a1a91b25d7598376$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val.length);
    var body = $a1a91b25d7598376$var$new_buf(2 * val.length);
    body.write_shift(2 * val.length, val, "utf16le");
    var postamble = $a1a91b25d7598376$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $a1a91b25d7598376$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $a1a91b25d7598376$var$write_XLSBFormulaRef(str) {
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    var out = $a1a91b25d7598376$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $a1a91b25d7598376$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $a1a91b25d7598376$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $a1a91b25d7598376$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $a1a91b25d7598376$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $a1a91b25d7598376$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $a1a91b25d7598376$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $a1a91b25d7598376$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    str = parts[0];
    var out = $a1a91b25d7598376$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $a1a91b25d7598376$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $a1a91b25d7598376$var$decode_range(_str);
    var out = $a1a91b25d7598376$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $a1a91b25d7598376$var$write_XLSBFormula(val /*:string|number*/ , wb) {
    if (typeof val == "number") return $a1a91b25d7598376$var$write_XLSBFormulaNum(val);
    if (typeof val == "boolean") return $a1a91b25d7598376$var$write_XLSBFormulaBool(val);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val)) return $a1a91b25d7598376$var$write_XLSBFormulaErr(+$a1a91b25d7598376$var$RBErr[val]);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRef(val);
    if (val.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRange(val);
    if (val.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaArea3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRef3D(val, wb);
    if (val.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRangeWS(val, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val)) return $a1a91b25d7598376$var$write_XLSBFormulaRefErr3D(val, wb);
    if (/^".*"$/.test(val)) return $a1a91b25d7598376$var$write_XLSBFormulaStr(val);
    if (/^[+-]\d+$/.test(val)) return $a1a91b25d7598376$var$write_XLSBFormulaNum(parseInt(val, 10));
    throw "Formula |" + val + "| not supported for XLSB";
}
var $a1a91b25d7598376$var$write_XLSBNameParsedFormula = $a1a91b25d7598376$var$write_XLSBFormula;
var $a1a91b25d7598376$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $a1a91b25d7598376$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $a1a91b25d7598376$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $a1a91b25d7598376$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $a1a91b25d7598376$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($a1a91b25d7598376$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $a1a91b25d7598376$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $a1a91b25d7598376$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".");
}
var $a1a91b25d7598376$var$strs = {}; // shared strings
var $a1a91b25d7598376$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $a1a91b25d7598376$var$browser_has_Map = typeof Map !== "undefined";
function $a1a91b25d7598376$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($a1a91b25d7598376$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $a1a91b25d7598376$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($a1a91b25d7598376$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $a1a91b25d7598376$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $a1a91b25d7598376$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $a1a91b25d7598376$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $a1a91b25d7598376$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $a1a91b25d7598376$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == "xlml") defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $a1a91b25d7598376$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $a1a91b25d7598376$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $a1a91b25d7598376$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles) {
    try {
        if (opts.cellNF) p.z = $a1a91b25d7598376$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === "z" && !opts.cellStyles) return;
    if (p.t === "d" && typeof p.v === "string") p.v = $a1a91b25d7598376$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== "z") try {
        if ($a1a91b25d7598376$var$table_fmt[fmtid] == null) $a1a91b25d7598376$var$SSF__load($a1a91b25d7598376$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === "e") p.w = p.w || $a1a91b25d7598376$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(p.v);
            } else if (p.t === "d") {
                var dd = $a1a91b25d7598376$var$datenum(p.v);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $a1a91b25d7598376$var$SSF_general(p.v, $a1a91b25d7598376$var$_ssfopts);
        } else if (p.t === "d") p.w = $a1a91b25d7598376$var$SSF_format(fmtid, $a1a91b25d7598376$var$datenum(p.v), $a1a91b25d7598376$var$_ssfopts);
        else p.w = $a1a91b25d7598376$var$SSF_format(fmtid, p.v, $a1a91b25d7598376$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $a1a91b25d7598376$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws["!ref"]) {
        var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws["!ref"]);
    }
}
function $a1a91b25d7598376$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $a1a91b25d7598376$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $a1a91b25d7598376$var$encode_range(d);
}
var $a1a91b25d7598376$var$mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var $a1a91b25d7598376$var$sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var $a1a91b25d7598376$var$hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var $a1a91b25d7598376$var$dimregex = /"(\w*:\w*)"/;
var $a1a91b25d7598376$var$colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var $a1a91b25d7598376$var$afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var $a1a91b25d7598376$var$marginregex = /<(?:\w:)?pageMargins[^>]*\/>/g;
var $a1a91b25d7598376$var$sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var $a1a91b25d7598376$var$sheetprregex2 = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var $a1a91b25d7598376$var$svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
/* 18.3 Worksheets */ function $a1a91b25d7598376$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = data.match($a1a91b25d7598376$var$sheetdataregex);
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($a1a91b25d7598376$var$sheetprregex);
    if (sheetPr) $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = data1.match($a1a91b25d7598376$var$sheetprregex2)) $a1a91b25d7598376$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($a1a91b25d7598376$var$dimregex);
        if (ref && !(opts && opts.nodim)) $a1a91b25d7598376$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = data1.match($a1a91b25d7598376$var$svsregex);
    if (svs && svs[1]) $a1a91b25d7598376$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($a1a91b25d7598376$var$colregex);
        if (cols) $a1a91b25d7598376$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $a1a91b25d7598376$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($a1a91b25d7598376$var$afregex);
    if (afilter) s["!autofilter"] = $a1a91b25d7598376$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($a1a91b25d7598376$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $a1a91b25d7598376$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf('"') + 1));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($a1a91b25d7598376$var$hlinkregex);
    if (hlink) $a1a91b25d7598376$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($a1a91b25d7598376$var$marginregex);
    if (margins) s["!margins"] = $a1a91b25d7598376$var$parse_ws_xml_margins($a1a91b25d7598376$var$parsexmltag(margins[0]));
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $a1a91b25d7598376$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $a1a91b25d7598376$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    return s;
}
function $a1a91b25d7598376$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $a1a91b25d7598376$var$encode_range(merges[i]) + '"/>';
    return o + "</mergeCells>";
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $a1a91b25d7598376$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(data.codeName));
}
function $a1a91b25d7598376$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $a1a91b25d7598376$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== "xlsx" && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $a1a91b25d7598376$var$utf8write($a1a91b25d7598376$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $a1a91b25d7598376$var$writextag("outlinePr", null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $a1a91b25d7598376$var$writextag("sheetPr", payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $a1a91b25d7598376$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $a1a91b25d7598376$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $a1a91b25d7598376$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $a1a91b25d7598376$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $a1a91b25d7598376$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $a1a91b25d7598376$var$writextag("sheetProtection", null, o);
}
function $a1a91b25d7598376$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val = $a1a91b25d7598376$var$parsexmltag($a1a91b25d7598376$var$utf8read(data[i]), true);
        if (!val.ref) return;
        var rel = ((rels || {})["!id"] || [])[val.id];
        if (rel) {
            val.Target = rel.Target;
            if (val.location) val.Target += "#" + $a1a91b25d7598376$var$unescapexml(val.location);
        } else {
            val.Target = "#" + $a1a91b25d7598376$var$unescapexml(val.location);
            rel = {
                Target: val.Target,
                TargetMode: "Internal"
            };
        }
        val.Rel = rel;
        if (val.tooltip) {
            val.Tooltip = val.tooltip;
            delete val.tooltip;
        }
        var rng = $a1a91b25d7598376$var$safe_decode_range(val.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val;
            }
        }
    }
}
function $a1a91b25d7598376$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $a1a91b25d7598376$var$write_ws_xml_margins(margin) /*:string*/ {
    $a1a91b25d7598376$var$default_margins(margin);
    return $a1a91b25d7598376$var$writextag("pageMargins", null, margin);
}
function $a1a91b25d7598376$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $a1a91b25d7598376$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $a1a91b25d7598376$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $a1a91b25d7598376$var$find_mdw_colw(coll.width);
        }
        $a1a91b25d7598376$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $a1a91b25d7598376$var$dup(coll);
    }
}
function $a1a91b25d7598376$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $a1a91b25d7598376$var$writextag("col", null, $a1a91b25d7598376$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $a1a91b25d7598376$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $a1a91b25d7598376$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $a1a91b25d7598376$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $a1a91b25d7598376$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $a1a91b25d7598376$var$decode_range(ws["!ref"]).e.r;
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $a1a91b25d7598376$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $a1a91b25d7598376$var$sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/g;
function $a1a91b25d7598376$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($a1a91b25d7598376$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $a1a91b25d7598376$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $a1a91b25d7598376$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $a1a91b25d7598376$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $a1a91b25d7598376$var$writextag("sheetViews", $a1a91b25d7598376$var$writextag("sheetView", null, sview), {});
}
function $a1a91b25d7598376$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts /*::, idx, wb*/ ) /*:string*/ {
    if (cell.c) ws["!comments"].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "n":
            vv = "" + cell.v;
            break;
        case "e":
            vv = $a1a91b25d7598376$var$BErr[cell.v];
            break;
        case "d":
            if (opts && opts.cellDates) vv = $a1a91b25d7598376$var$parseDate(cell.v, -1).toISOString();
            else {
                cell = $a1a91b25d7598376$var$dup(cell);
                cell.t = "n";
                vv = "" + (cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v)));
            }
            if (typeof cell.z === "undefined") cell.z = $a1a91b25d7598376$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $a1a91b25d7598376$var$writetag("v", $a1a91b25d7598376$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case "n":
            break;
        case "d":
            o.t = "d";
            break;
        case "b":
            o.t = "b";
            break;
        case "e":
            o.t = "e";
            break;
        case "z":
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $a1a91b25d7598376$var$writetag("v", "" + $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $a1a91b25d7598376$var$writextag("f", $a1a91b25d7598376$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $a1a91b25d7598376$var$escapexml(vv);
        ws["!links"].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $a1a91b25d7598376$var$writextag("c", v, o);
}
var $a1a91b25d7598376$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
    var refregex = /ref=["']([^"']*)["']/;
    var match_v = $a1a91b25d7598376$var$matchtag("v"), match_f = $a1a91b25d7598376$var$matchtag("f");
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $a1a91b25d7598376$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $a1a91b25d7598376$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $a1a91b25d7598376$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $a1a91b25d7598376$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $a1a91b25d7598376$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $a1a91b25d7598376$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $a1a91b25d7598376$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $a1a91b25d7598376$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = d.match(match_v)) != null && /*::cref != null && */ cref[1] !== "") p.v = $a1a91b25d7598376$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = d.match(match_f)) != null && /*::cref != null && */ cref[1] !== "") {
                        /* TODO: match against XLSXFutureFunctions */ p.f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(cref[1]), true);
                        if (!opts.xlfn) p.f = $a1a91b25d7598376$var$_xlfn(p.f);
                        if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                            p.F = (d.match(refregex) || [])[1];
                            if (p.F.indexOf(":") > -1) arrayf.push([
                                $a1a91b25d7598376$var$safe_decode_range(p.F),
                                p.F
                            ]);
                        } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                            // TODO: parse formula
                            ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                            var ___f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(cref[1]));
                            if (!opts.xlfn) ___f = $a1a91b25d7598376$var$_xlfn(___f);
                            sharedf[parseInt(ftag.si, 10)] = [
                                ftag,
                                ___f,
                                tag.r
                            ];
                        }
                    } else if (cref = d.match(/<f[^>]*\/>/)) {
                        ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $a1a91b25d7598376$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $a1a91b25d7598376$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case "n":
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else p.v = parseFloat(p.v);
                        break;
                    case "s":
                        if (typeof p.v == "undefined") {
                            if (!sheetStubs) continue;
                            p.t = "z";
                        } else {
                            sstr = $a1a91b25d7598376$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case "str":
                        p.t = "s";
                        p.v = p.v != null ? $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(p.v), true) : "";
                        if (opts.cellHTML) p.h = $a1a91b25d7598376$var$escapehtml(p.v);
                        break;
                    case "inlineStr":
                        cref = d.match(isregex);
                        p.t = "s";
                        if (cref != null && (sstr = $a1a91b25d7598376$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case "b":
                        p.v = $a1a91b25d7598376$var$parsexmlbool(p.v);
                        break;
                    case "d":
                        if (opts.cellDates) p.v = $a1a91b25d7598376$var$parseDate(p.v, 1);
                        else {
                            p.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(p.v, 1));
                            p.t = "n";
                        }
                        break;
                    /* error string in .w, number in .v */ case "e":
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $a1a91b25d7598376$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $a1a91b25d7598376$var$safe_format(p, fmtid, fillid, opts, themes, styles);
                if (opts.cellDates && do_format && p.t == "n" && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[fmtid])) {
                    p.t = "d";
                    p.v = $a1a91b25d7598376$var$numdate(p.v);
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == "XLDAPR") p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $a1a91b25d7598376$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $a1a91b25d7598376$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s["!rows"] = rows;
    };
}();
function $a1a91b25d7598376$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws["!rows"];
    var dense = ws["!data"] != null;
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $a1a91b25d7598376$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $a1a91b25d7598376$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $a1a91b25d7598376$var$writextag("row", r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $a1a91b25d7598376$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $a1a91b25d7598376$var$writextag("row", "", params);
        }
    }
    return o.join("");
}
function $a1a91b25d7598376$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag("worksheet", null, {
            "xmlns": $a1a91b25d7598376$var$XMLNS_main[0],
            "xmlns:r": $a1a91b25d7598376$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws["!ref"] || "A1";
    var range = $a1a91b25d7598376$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws["!comments"] = [];
    var _drawing = [];
    $a1a91b25d7598376$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $a1a91b25d7598376$var$writextag("dimension", null, {
        "ref": ref
    });
    o[o.length] = $a1a91b25d7598376$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $a1a91b25d7598376$var$writextag("sheetFormatPr", null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || "16",
        baseColWidth: opts.sheetFormat.baseColWidth || "10",
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || "7"
    });
    if (ws["!cols"] != null && ws["!cols"].length > 0) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_cols(ws, ws["!cols"]);
    o[sidx = o.length] = "<sheetData/>";
    ws["!links"] = [];
    if (ws["!ref"] != null) {
        rdata = $a1a91b25d7598376$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = "</sheetData>";
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws["!protect"]) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_protection(ws["!protect"]);
    /* protectedRanges */ /* scenarios */ if (ws["!autofilter"] != null) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_autofilter(ws["!autofilter"], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws["!merges"] != null && ws["!merges"].length > 0) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_merges(ws["!merges"]);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws["!links"]/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws["!links"]/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $a1a91b25d7598376$var$add_rels(rels, -1, $a1a91b25d7598376$var$escapexml(l[1].Target).replace(/#.*$/, ""), $a1a91b25d7598376$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $a1a91b25d7598376$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $a1a91b25d7598376$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $a1a91b25d7598376$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws["!links"];
    /* printOptions */ if (ws["!margins"] != null) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_margins(ws["!margins"]);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $a1a91b25d7598376$var$writetag("ignoredErrors", $a1a91b25d7598376$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $a1a91b25d7598376$var$RELS.DRAW);
        o[o.length] = $a1a91b25d7598376$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws["!drawing"] = _drawing;
    }
    if (ws["!comments"].length > 0) {
        rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $a1a91b25d7598376$var$RELS.VML);
        o[o.length] = $a1a91b25d7598376$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws["!legacy"] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = "</worksheet>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $a1a91b25d7598376$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $a1a91b25d7598376$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $a1a91b25d7598376$var$new_buf(145);
    var row = (ws["!rows"] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $a1a91b25d7598376$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$a1a91b25d7598376$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$write_row_header(ba, ws, range, R) {
    var o = $a1a91b25d7598376$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws["!rows"] || [])[R]) $a1a91b25d7598376$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $a1a91b25d7598376$var$parse_BrtWsDim = $a1a91b25d7598376$var$parse_UncheckedRfX;
var $a1a91b25d7598376$var$write_BrtWsDim = $a1a91b25d7598376$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $a1a91b25d7598376$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $a1a91b25d7598376$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $a1a91b25d7598376$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $a1a91b25d7598376$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $a1a91b25d7598376$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $a1a91b25d7598376$var$parse_BrtCellBlank(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $a1a91b25d7598376$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    return $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
}
function $a1a91b25d7598376$var$parse_BrtShortBlank(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $a1a91b25d7598376$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    return $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $a1a91b25d7598376$var$parse_BrtCellBool(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $a1a91b25d7598376$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortBool(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        "b"
    ];
}
function $a1a91b25d7598376$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(5);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $a1a91b25d7598376$var$parse_BrtCellError(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $a1a91b25d7598376$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortError(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        "e"
    ];
}
function $a1a91b25d7598376$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $a1a91b25d7598376$var$parse_BrtCellIsst(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $a1a91b25d7598376$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortIsst(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        "s"
    ];
}
function $a1a91b25d7598376$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $a1a91b25d7598376$var$parse_BrtCellReal(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $a1a91b25d7598376$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(16);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_Xnum(cell.v, o);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortReal(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $a1a91b25d7598376$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $a1a91b25d7598376$var$parse_BrtCellRk(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $a1a91b25d7598376$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_RkNumber(cell.v, o);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortRk(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_RkNumber(data);
    return [
        cell,
        value,
        "n"
    ];
}
function $a1a91b25d7598376$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $a1a91b25d7598376$var$parse_BrtCellRString(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_RichStr(data);
    return [
        cell,
        value,
        "is"
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $a1a91b25d7598376$var$parse_BrtCellSt(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $a1a91b25d7598376$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12 + 4 * cell.v.length);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$parse_BrtShortSt(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    return [
        cell,
        value,
        "str"
    ];
}
function $a1a91b25d7598376$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8 + 4 * data.length);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $a1a91b25d7598376$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "b"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $a1a91b25d7598376$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        "e"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $a1a91b25d7598376$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        "n"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $a1a91b25d7598376$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts["!row"];
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        "str"
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $a1a91b25d7598376$var$parse_BrtMergeCell = $a1a91b25d7598376$var$parse_UncheckedRfX;
var $a1a91b25d7598376$var$write_BrtMergeCell = $a1a91b25d7598376$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $a1a91b25d7598376$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $a1a91b25d7598376$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    var relId = $a1a91b25d7598376$var$parse_XLNullableWideString(data);
    var loc = $a1a91b25d7598376$var$parse_XLWideString(data);
    var tooltip = $a1a91b25d7598376$var$parse_XLWideString(data);
    var display = $a1a91b25d7598376$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $a1a91b25d7598376$var$write_BrtHLink(l, rId) {
    var o = $a1a91b25d7598376$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $a1a91b25d7598376$var$write_UncheckedRfX({
        s: $a1a91b25d7598376$var$decode_cell(l[0]),
        e: $a1a91b25d7598376$var$decode_cell(l[0])
    }, o);
    $a1a91b25d7598376$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $a1a91b25d7598376$var$write_XLWideString(loc || "", o);
    $a1a91b25d7598376$var$write_XLWideString(l[1].Tooltip || "", o);
    $a1a91b25d7598376$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $a1a91b25d7598376$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $a1a91b25d7598376$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $a1a91b25d7598376$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $a1a91b25d7598376$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $a1a91b25d7598376$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $a1a91b25d7598376$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(18);
    var p = $a1a91b25d7598376$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == "number") flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $a1a91b25d7598376$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $a1a91b25d7598376$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $a1a91b25d7598376$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $a1a91b25d7598376$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $a1a91b25d7598376$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(48);
    $a1a91b25d7598376$var$default_margins(margins);
    $a1a91b25d7598376$var$BrtMarginKeys.forEach(function(k) {
        $a1a91b25d7598376$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $a1a91b25d7598376$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $a1a91b25d7598376$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $a1a91b25d7598376$var$write_BrtCellIgnoreEC(ref) {
    var o = $a1a91b25d7598376$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $a1a91b25d7598376$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $a1a91b25d7598376$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(66);
    o.write_shift(2, sp.password ? $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $a1a91b25d7598376$var$parse_BrtDVal() {}
function $a1a91b25d7598376$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $a1a91b25d7598376$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        "!id": {}
    };
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts["!row"] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $a1a91b25d7598376$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $a1a91b25d7598376$var$parse_BrtShortReal
    };
    var cm, vm;
    $a1a91b25d7598376$var$recordhopper(data, function ws_parse(val, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $a1a91b25d7598376$var$encode_row(R = row.r);
                opts["!row"] = row.r;
                if (val.hidden || val.hpt || val.level != null) {
                    if (val.hpt) val.hpx = $a1a91b25d7598376$var$pt2px(val.hpt);
                    rowinfo[val.r] = val;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val[2]
                } /*:any*/ ;
                switch(val[2]){
                    case "n":
                        p.v = val[1];
                        break;
                    case "s":
                        sstr = $a1a91b25d7598376$var$strs[val[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case "b":
                        p.v = val[1] ? true : false;
                        break;
                    case "e":
                        p.v = val[1];
                        if (opts.cellText !== false) p.w = $a1a91b25d7598376$var$BErr[p.v];
                        break;
                    case "str":
                        p.t = "s";
                        p.v = val[1];
                        break;
                    case "is":
                        p.t = "s";
                        p.v = val[1].t;
                        break;
                }
                if (cf = styles.CellXf[val[0].iStyleRef]) $a1a91b25d7598376$var$safe_format(p, cf.numFmtId, null, opts, themes, styles);
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$a1a91b25d7598376$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $a1a91b25d7598376$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val.length > 3) p.f = val[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == "n" && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[cf.numFmtId])) {
                    var _d = $a1a91b25d7598376$var$SSF_parse_date_code(p.v);
                    if (_d) {
                        p.t = "d";
                        p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
                    }
                }
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: "z",
                    v: void 0
                } /*:any*/ ;
                C = val[0].c == -1 ? C + 1 : val[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$a1a91b25d7598376$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == "XLDAPR") p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels["!id"][val.relId];
                if (rel) {
                    val.Target = rel.Target;
                    if (val.loc) val.Target += "#" + val.loc;
                    val.Rel = rel;
                } else if (val.relId == "") val.Target = "#" + val.loc;
                for(R = val.rfx.s.r; R <= val.rfx.e.r; ++R)for(C = val.rfx.s.c; C <= val.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: "z",
                        v: undefined
                    };
                    s["!data"][R][C].l = val;
                } else {
                    addr = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: "z",
                        v: undefined
                    };
                    s[addr].l = val;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val);
                cell = opts.dense ? s["!data"][R][C] : s[$a1a91b25d7598376$var$encode_col(C) + rr];
                cell.f = $a1a91b25d7598376$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $a1a91b25d7598376$var$encode_range(val[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$a1a91b25d7598376$var$encode_cell(val[0].s)] = val[1];
                cell = opts.dense ? s["!data"][R][C] : s[$a1a91b25d7598376$var$encode_col(C) + rr];
                cell.f = $a1a91b25d7598376$var$stringify_formula(val[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val.e >= val.s){
                    colinfo[val.e--] = {
                        width: val.w / 256,
                        hidden: !!(val.flags & 0x01),
                        level: val.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $a1a91b25d7598376$var$find_mdw_colw(val.w / 256);
                    }
                    $a1a91b25d7598376$var$process_col(colinfo[val.e + 1]);
                }
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s["!autofilter"] = {
                    ref: $a1a91b25d7598376$var$encode_range(val)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s["!margins"] = val;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                if (val.above || val.left) s["!outline"] = {
                    above: val.above,
                    left: val.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts["!row"];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $a1a91b25d7598376$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $a1a91b25d7598376$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $a1a91b25d7598376$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    return s;
}
/* TODO: something useful -- this is a stub */ function $a1a91b25d7598376$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws["!comments"].push([
        $a1a91b25d7598376$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case "b":
            vv = cell.v ? "1" : "0";
            break;
        case "d":
            cell = $a1a91b25d7598376$var$dup(cell);
            cell.z = cell.z || $a1a91b25d7598376$var$table_fmt[14];
            cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v));
            cell.t = "n";
            break;
        /* falls through */ case "n":
        case "e":
            vv = "" + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws["!links"].push([
        $a1a91b25d7598376$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case "s":
        case "str":
            if (opts.bookSST) {
                vv = $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $a1a91b25d7598376$var$write_BrtShortIsst(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $a1a91b25d7598376$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0011 /* BrtShortSt */ , $a1a91b25d7598376$var$write_BrtShortSt(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0006 /* BrtCellSt */ , $a1a91b25d7598376$var$write_BrtCellSt(cell, o));
            }
            return true;
        case "n":
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000D /* BrtShortRk */ , $a1a91b25d7598376$var$write_BrtShortRk(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0002 /* BrtCellRk */ , $a1a91b25d7598376$var$write_BrtCellRk(cell, o));
            } else if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0010 /* BrtShortReal */ , $a1a91b25d7598376$var$write_BrtShortReal(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0005 /* BrtCellReal */ , $a1a91b25d7598376$var$write_BrtCellReal(cell, o));
            return true;
        case "b":
            o.t = "b";
            if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000F /* BrtShortBool */ , $a1a91b25d7598376$var$write_BrtShortBool(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0004 /* BrtCellBool */ , $a1a91b25d7598376$var$write_BrtCellBool(cell, o));
            return true;
        case "e":
            o.t = "e";
            if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000C /* BrtShortBlank */ , $a1a91b25d7598376$var$write_BrtShortBlank(cell, o));
    else $a1a91b25d7598376$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $a1a91b25d7598376$var$write_BrtCellBlank(cell, o));
    return true;
}
function $a1a91b25d7598376$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"] || "A1"), ref, rr = "", cols /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null;
    var cap = range.e.r;
    if (ws["!rows"]) cap = Math.max(range.e.r, ws["!rows"].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $a1a91b25d7598376$var$encode_row(R);
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $a1a91b25d7598376$var$write_row_header(ba, ws, range, R);
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $a1a91b25d7598376$var$encode_col(C);
            ref = cols[C] + rr;
            var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $a1a91b25d7598376$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
        }
    }
    $a1a91b25d7598376$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $a1a91b25d7598376$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!merges"]) return;
    $a1a91b25d7598376$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $a1a91b25d7598376$var$write_BrtBeginMergeCells(ws["!merges"].length));
    ws["!merges"].forEach(function(m) {
        $a1a91b25d7598376$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $a1a91b25d7598376$var$write_BrtMergeCell(m));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $a1a91b25d7598376$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws["!cols"]) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws["!cols"].forEach(function(m, i) {
        if (m) $a1a91b25d7598376$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $a1a91b25d7598376$var$write_BrtColInfo(i, m));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $a1a91b25d7598376$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws["!ref"]) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $a1a91b25d7598376$var$write_BrtCellIgnoreEC($a1a91b25d7598376$var$safe_decode_range(ws["!ref"])));
    $a1a91b25d7598376$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $a1a91b25d7598376$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws["!links"].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $a1a91b25d7598376$var$add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), $a1a91b25d7598376$var$RELS.HLINK);
        $a1a91b25d7598376$var$write_record(ba, 0x01EE /* BrtHLink */ , $a1a91b25d7598376$var$write_BrtHLink(l, rId));
    });
    delete ws["!links"];
}
function $a1a91b25d7598376$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws["!comments"].length > 0) {
        var rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $a1a91b25d7598376$var$RELS.VML);
        $a1a91b25d7598376$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $a1a91b25d7598376$var$write_RelID("rId" + rId));
        ws["!legacy"] = rId;
    }
}
function $a1a91b25d7598376$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws["!autofilter"]) return;
    var data = ws["!autofilter"];
    var ref = typeof data.ref === "string" ? data.ref : $a1a91b25d7598376$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $a1a91b25d7598376$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $a1a91b25d7598376$var$decode_range(ws["!ref"]).e.r;
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != "_xlnm._FilterDatabase") continue;
        if (name.Sheet != idx) continue;
        name.Ref = $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: "_xlnm._FilterDatabase",
        Sheet: idx,
        Ref: $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref)
    });
    $a1a91b25d7598376$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $a1a91b25d7598376$var$write_UncheckedRfX($a1a91b25d7598376$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $a1a91b25d7598376$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $a1a91b25d7598376$var$write_WSVIEWS2(ba, ws, Workbook) {
    $a1a91b25d7598376$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $a1a91b25d7598376$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $a1a91b25d7598376$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $a1a91b25d7598376$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $a1a91b25d7598376$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $a1a91b25d7598376$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $a1a91b25d7598376$var$write_SHEETPROTECT(ba, ws) {
    if (!ws["!protect"]) return;
    /* [BrtSheetProtectionIso] */ $a1a91b25d7598376$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $a1a91b25d7598376$var$write_BrtSheetProtection(ws["!protect"]));
}
function $a1a91b25d7598376$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws["!links"] = [];
    /* passed back to write_zip and removed there */ ws["!comments"] = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws["!outline"]) $a1a91b25d7598376$var$write_record(ba, 0x0093 /* BrtWsProp */ , $a1a91b25d7598376$var$write_BrtWsProp(c, ws["!outline"]));
    $a1a91b25d7598376$var$write_record(ba, 0x0094 /* BrtWsDim */ , $a1a91b25d7598376$var$write_BrtWsDim(r));
    $a1a91b25d7598376$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $a1a91b25d7598376$var$write_WSFMTINFO(ba, ws);
    $a1a91b25d7598376$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $a1a91b25d7598376$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $a1a91b25d7598376$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $a1a91b25d7598376$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $a1a91b25d7598376$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $a1a91b25d7598376$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws["!margins"]) $a1a91b25d7598376$var$write_record(ba, 0x01DC /* BrtMargins */ , $a1a91b25d7598376$var$write_BrtMargins(ws["!margins"]));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $a1a91b25d7598376$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $a1a91b25d7598376$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $a1a91b25d7598376$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $a1a91b25d7598376$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $a1a91b25d7598376$var$unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || [
        "",
        "General"
    ])[1]);
    (data.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(F) {
        f = F.replace(/<.*?>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $a1a91b25d7598376$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ (data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(nc) {
        var cache = $a1a91b25d7598376$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $a1a91b25d7598376$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: "n",
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $a1a91b25d7598376$var$encode_row(i)] = {
                t: "n",
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $a1a91b25d7598376$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($a1a91b25d7598376$var$sheetprregex);
    if (sheetPr) $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s["!rel"] = m[1];
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $a1a91b25d7598376$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $a1a91b25d7598376$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $a1a91b25d7598376$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        "!id": {}
    };
    var s = {
        "!type": "chart",
        "!drawel": null,
        "!rel": ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function cs_parse(val, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s["!rel"] = val;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val.name) wb.Sheets[idx].CodeName = val.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels["!id"][s["!rel"]]) s["!drawel"] = rels["!id"][s["!rel"]];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $a1a91b25d7598376$var$WBPropsDef = [
    [
        "allowRefreshQuery",
        false,
        "bool"
    ],
    [
        "autoCompressPictures",
        true,
        "bool"
    ],
    [
        "backupFile",
        false,
        "bool"
    ],
    [
        "checkCompatibility",
        false,
        "bool"
    ],
    [
        "CodeName",
        ""
    ],
    [
        "date1904",
        false,
        "bool"
    ],
    [
        "defaultThemeVersion",
        0,
        "int"
    ],
    [
        "filterPrivacy",
        false,
        "bool"
    ],
    [
        "hidePivotFieldList",
        false,
        "bool"
    ],
    [
        "promptedSolutions",
        false,
        "bool"
    ],
    [
        "publishItems",
        false,
        "bool"
    ],
    [
        "refreshAllConnections",
        false,
        "bool"
    ],
    [
        "saveExternalLinkValues",
        true,
        "bool"
    ],
    [
        "showBorderUnselectedTables",
        true,
        "bool"
    ],
    [
        "showInkAnnotation",
        true,
        "bool"
    ],
    [
        "showObjects",
        "all"
    ],
    [
        "showPivotChartFilter",
        false,
        "bool"
    ],
    [
        "updateLinks",
        "userSet"
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $a1a91b25d7598376$var$WBViewDef = [
    [
        "activeTab",
        0,
        "int"
    ],
    [
        "autoFilterDateGrouping",
        true,
        "bool"
    ],
    [
        "firstSheet",
        0,
        "int"
    ],
    [
        "minimized",
        false,
        "bool"
    ],
    [
        "showHorizontalScroll",
        true,
        "bool"
    ],
    [
        "showSheetTabs",
        true,
        "bool"
    ],
    [
        "showVerticalScroll",
        true,
        "bool"
    ],
    [
        "tabRatio",
        600,
        "int"
    ],
    [
        "visibility",
        "visible"
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $a1a91b25d7598376$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $a1a91b25d7598376$var$CalcPrDef = [
    [
        "calcCompleted",
        "true"
    ],
    [
        "calcMode",
        "auto"
    ],
    [
        "calcOnSave",
        "true"
    ],
    [
        "concurrentCalc",
        "true"
    ],
    [
        "fullCalcOnLoad",
        "false"
    ],
    [
        "fullPrecision",
        "true"
    ],
    [
        "iterate",
        "false"
    ],
    [
        "iterateCount",
        "100"
    ],
    [
        "iterateDelta",
        "0.001"
    ],
    [
        "refMode",
        "A1"
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $a1a91b25d7598376$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $a1a91b25d7598376$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $a1a91b25d7598376$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $a1a91b25d7598376$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $a1a91b25d7598376$var$parse_wb_defaults(wb) {
    $a1a91b25d7598376$var$push_defaults(wb.WBProps, $a1a91b25d7598376$var$WBPropsDef);
    $a1a91b25d7598376$var$push_defaults(wb.CalcPr, $a1a91b25d7598376$var$CalcPrDef);
    $a1a91b25d7598376$var$push_defaults_array(wb.WBView, $a1a91b25d7598376$var$WBViewDef);
    $a1a91b25d7598376$var$push_defaults_array(wb.Sheets, $a1a91b25d7598376$var$SheetDef);
    $a1a91b25d7598376$var$_ssfopts.date1904 = $a1a91b25d7598376$var$parsexmlbool(wb.WBProps.date1904);
}
function $a1a91b25d7598376$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $a1a91b25d7598376$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $a1a91b25d7598376$var$badchars = /*#__PURE__*/ ":][*?/\\".split("");
function $a1a91b25d7598376$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    if (n.length > 31) {
        if (safe) return false;
        throw new Error("Sheet names cannot exceed 31 chars");
    }
    var _good = true;
    $a1a91b25d7598376$var$badchars.forEach(function(c) {
        if (n.indexOf(c) == -1) return;
        if (!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        _good = false;
    });
    return _good;
}
function $a1a91b25d7598376$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $a1a91b25d7598376$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $a1a91b25d7598376$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $a1a91b25d7598376$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$a1a91b25d7598376$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $a1a91b25d7598376$var$formula_quote_sheet_name(n) + "!" + $a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $a1a91b25d7598376$var$wbnsregex = /<\w+:workbook/;
function $a1a91b25d7598376$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case "<workbook":
                if (x.match($a1a91b25d7598376$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case "</workbook>":
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case "<fileVersion":
                delete y[0];
                wb.AppVersion = y;
                break;
            case "<fileVersion/>":
            case "</fileVersion>":
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case "<fileSharing":
                break;
            case "<fileSharing/>":
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case "<workbookPr":
            case "<workbookPr/>":
                $a1a91b25d7598376$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $a1a91b25d7598376$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $a1a91b25d7598376$var$utf8read(y.codeName);
                break;
            case "</workbookPr>":
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case "<workbookProtection":
                break;
            case "<workbookProtection/>":
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case "<bookViews":
            case "<bookViews>":
            case "</bookViews>":
                break;
            /* 18.2.30   workbookView CT_BookView + */ case "<workbookView":
            case "<workbookView/>":
                delete y[0];
                wb.WBView.push(y);
                break;
            case "</workbookView>":
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case "<sheets":
            case "<sheets>":
            case "</sheets>":
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case "<sheet":
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case "</sheet>":
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case "<functionGroups":
            case "<functionGroups/>":
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case "<functionGroup":
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case "<externalReferences":
            case "</externalReferences>":
            case "<externalReferences>":
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case "<externalReference":
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case "<definedNames/>":
                break;
            case "<definedNames>":
            case "<definedNames":
                pass = true;
                break;
            case "</definedNames>":
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case "<definedName":
                dname = {};
                dname.Name = $a1a91b25d7598376$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($a1a91b25d7598376$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case "</definedName>":
                dname.Ref = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case "<definedName/>":
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case "<calcPr":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "<calcPr/>":
                delete y[0];
                wb.CalcPr = y;
                break;
            case "</calcPr>":
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case "<oleSize":
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case "<customWorkbookViews>":
            case "</customWorkbookViews>":
            case "<customWorkbookViews":
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case "<customWorkbookView":
            case "</customWorkbookView>":
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case "<pivotCaches>":
            case "</pivotCaches>":
            case "<pivotCaches":
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case "<pivotCache":
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case "<smartTagPr":
            case "<smartTagPr/>":
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case "<smartTagTypes":
            case "<smartTagTypes>":
            case "</smartTagTypes>":
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case "<smartTagType":
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case "<webPublishing":
            case "<webPublishing/>":
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case "<fileRecoveryPr":
            case "<fileRecoveryPr/>":
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case "<webPublishObjects>":
            case "<webPublishObjects":
            case "</webPublishObjects>":
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case "<webPublishObject":
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            /* 18.2.7  ext CT_Extension + */ case "<ext":
                pass = true;
                break; //TODO: check with versions of excel
            case "</ext>":
                pass = false;
                break;
            /* Others */ case "<ArchID":
                break;
            case "<AlternateContent":
            case "<AlternateContent>":
                pass = true;
                break;
            case "</AlternateContent>":
                pass = false;
                break;
            /* TODO */ case "<revisionPtr":
                break;
            default:
                if (!pass && opts.WTF) throw new Error("unrecognized " + y[0] + " in workbook");
        }
        return x;
    });
    if ($a1a91b25d7598376$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $a1a91b25d7598376$var$parse_wb_defaults(wb);
    return wb;
}
function $a1a91b25d7598376$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = $a1a91b25d7598376$var$writextag("workbook", null, {
        "xmlns": $a1a91b25d7598376$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        "xmlns:r": $a1a91b25d7598376$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $a1a91b25d7598376$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $a1a91b25d7598376$var$writextag("workbookPr", null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $a1a91b25d7598376$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $a1a91b25d7598376$var$writextag("sheet", null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $a1a91b25d7598376$var$writextag("definedName", $a1a91b25d7598376$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = "</workbook>";
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $a1a91b25d7598376$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $a1a91b25d7598376$var$parse_RelID(data, length - 8);
    z.name = $a1a91b25d7598376$var$parse_XLWideString(data);
    return z;
}
function $a1a91b25d7598376$var$write_BrtBundleSh(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $a1a91b25d7598376$var$write_RelID(data.strRelID, o);
    $a1a91b25d7598376$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $a1a91b25d7598376$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $a1a91b25d7598376$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $a1a91b25d7598376$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $a1a91b25d7598376$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $a1a91b25d7598376$var$parse_XLNameWideString(data);
    var formula = $a1a91b25d7598376$var$parse_XLSBNameParsedFormula(data, 0, opts);
    var comment = $a1a91b25d7598376$var$parse_XLNullableWideString(data);
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $a1a91b25d7598376$var$write_BrtName(name, wb) {
    var o = $a1a91b25d7598376$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($a1a91b25d7598376$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $a1a91b25d7598376$var$write_XLWideString(dname),
        $a1a91b25d7598376$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($a1a91b25d7598376$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $a1a91b25d7598376$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $a1a91b25d7598376$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $a1a91b25d7598376$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $a1a91b25d7598376$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $a1a91b25d7598376$var$parse_BrtFRTArchID$
    };
    $a1a91b25d7598376$var$recordhopper(data, function hopper_wb(val, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val.name);
                wb.Sheets.push(val);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val.Sheet != null) opts.SID = val.Sheet;
                val.Ref = $a1a91b25d7598376$var$stringify_formula(val.Ptg, null, null, supbooks, opts);
                delete opts.SID;
                delete val.Ptg;
                Names.push(val);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val
                ];
                else supbooks.push([
                    RT,
                    val
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                supbooks.XTI = supbooks.XTI.concat(val);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $a1a91b25d7598376$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $a1a91b25d7598376$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $a1a91b25d7598376$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: "rId" + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $a1a91b25d7598376$var$write_record(ba, 0x009C /* BrtBundleSh */ , $a1a91b25d7598376$var$write_BrtBundleSh(d));
    }
    $a1a91b25d7598376$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $a1a91b25d7598376$var$write_BrtFileVersion(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_XLWideString("SheetJS", o);
    $a1a91b25d7598376$var$write_XLWideString($a1a91b25d7598376$var$XLSX.version, o);
    $a1a91b25d7598376$var$write_XLWideString($a1a91b25d7598376$var$XLSX.version, o);
    $a1a91b25d7598376$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $a1a91b25d7598376$var$write_BrtBookView(idx, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $a1a91b25d7598376$var$write_record(ba, 0x009E /* BrtBookView */ , $a1a91b25d7598376$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $a1a91b25d7598376$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $a1a91b25d7598376$var$write_record(ba, 0x0027 /* BrtName */ , $a1a91b25d7598376$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $a1a91b25d7598376$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $a1a91b25d7598376$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $a1a91b25d7598376$var$write_EXTERNALS_xlsb(ba, wb) {
    $a1a91b25d7598376$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $a1a91b25d7598376$var$write_record(ba, 0x016A /* BrtExternSheet */ , $a1a91b25d7598376$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $a1a91b25d7598376$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $a1a91b25d7598376$var$write_wb_bin(wb, opts) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $a1a91b25d7598376$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $a1a91b25d7598376$var$write_record(ba, 0x0099 /* BrtWbProp */ , $a1a91b25d7598376$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $a1a91b25d7598376$var$write_BOOKVIEWS(ba, wb, opts);
    $a1a91b25d7598376$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $a1a91b25d7598376$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $a1a91b25d7598376$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $a1a91b25d7598376$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $a1a91b25d7598376$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_wb_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_wb_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $a1a91b25d7598376$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $a1a91b25d7598376$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_sst_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_sst_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_comments_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_comments_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $a1a91b25d7598376$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $a1a91b25d7598376$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $a1a91b25d7598376$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $a1a91b25d7598376$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $a1a91b25d7598376$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $a1a91b25d7598376$var$attregexg2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $a1a91b25d7598376$var$attregex2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $a1a91b25d7598376$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($a1a91b25d7598376$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $a1a91b25d7598376$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($a1a91b25d7598376$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $a1a91b25d7598376$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $a1a91b25d7598376$var$xlml_format(format, value) /*:string*/ {
    var fmt = $a1a91b25d7598376$var$XLMLFormatMap[format] || $a1a91b25d7598376$var$unescapexml(format);
    if (fmt === "General") return $a1a91b25d7598376$var$SSF_general(value);
    return $a1a91b25d7598376$var$SSF_format(fmt, value);
}
function $a1a91b25d7598376$var$xlml_set_custprop(Custprops, key, cp, val /*:string*/ ) {
    var oval /*:any*/  = val;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $a1a91b25d7598376$var$parsexmlbool(val);
            break;
        case "i2":
        case "int":
            oval = parseInt(val, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val);
            break;
        case "date":
        case "dateTime.tz":
            oval = $a1a91b25d7598376$var$parseDate(val);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$a1a91b25d7598376$var$unescapexml(key)] = oval;
}
function $a1a91b25d7598376$var$safe_format_xlml(cell /*:Cell*/ , nf, o) {
    if (cell.t === "z") return;
    if (!o || o.cellText !== false) try {
        if (cell.t === "e") cell.w = cell.w || $a1a91b25d7598376$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === "n") {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $a1a91b25d7598376$var$SSF_general_num(cell.v);
            } else cell.w = $a1a91b25d7598376$var$SSF_general(cell.v);
        } else cell.w = $a1a91b25d7598376$var$xlml_format(nf || "General", cell.v);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $a1a91b25d7598376$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == "n" && $a1a91b25d7598376$var$fmt_is_date(z)) {
            var _d = $a1a91b25d7598376$var$SSF_parse_date_code(cell.v);
            if (_d) {
                cell.t = "d";
                cell.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $a1a91b25d7598376$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $a1a91b25d7598376$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $a1a91b25d7598376$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        if (styles[sid].nf) nf = styles[sid].nf;
        if (styles[sid].Interior) interiors.push(styles[sid].Interior);
        if (!styles[sid].Parent) break;
        sid = styles[sid].Parent;
    }
    switch(data.Type){
        case "Boolean":
            cell.t = "b";
            cell.v = $a1a91b25d7598376$var$parsexmlbool(xml);
            break;
        case "String":
            cell.t = "s";
            cell.r = $a1a91b25d7598376$var$xlml_fixstr($a1a91b25d7598376$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $a1a91b25d7598376$var$unescapexml(ss || xml).replace(/<.*?>/g, "") : cell.r; // todo: BR etc
            break;
        case "DateTime":
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = ($a1a91b25d7598376$var$parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / 86400000;
            if (cell.v !== cell.v) cell.v = $a1a91b25d7598376$var$unescapexml(xml);
            else if (cell.v < 60) cell.v = cell.v - 1;
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case "Number":
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = "n";
            break;
        case "Error":
            cell.t = "e";
            cell.v = $a1a91b25d7598376$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = "z";
            else {
                cell.t = "s";
                cell.v = $a1a91b25d7598376$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $a1a91b25d7598376$var$safe_format_xlml(cell, nf, o);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $a1a91b25d7598376$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $a1a91b25d7598376$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $a1a91b25d7598376$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $a1a91b25d7598376$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $a1a91b25d7598376$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $a1a91b25d7598376$var$xlml_prefix_dname(dname) {
    return $a1a91b25d7598376$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $a1a91b25d7598376$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $a1a91b25d7598376$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $a1a91b25d7598376$var$make_ssf();
    var str = $a1a91b25d7598376$var$debom($a1a91b25d7598376$var$xlml_normalize(d));
    if (opts.type == "binary" || opts.type == "array" || opts.type == "base64") {
        if (typeof $a1a91b25d7598376$var$$cptable !== "undefined") str = $a1a91b25d7598376$var$$cptable.utils.decode(65001, $a1a91b25d7598376$var$char_codes(str));
        else str = $a1a91b25d7598376$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $a1a91b25d7598376$var$dup(opts);
        _o.type = "string";
        return $a1a91b25d7598376$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $a1a91b25d7598376$var$html_to_workbook(str, opts);
    $a1a91b25d7598376$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $a1a91b25d7598376$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $a1a91b25d7598376$var$table_fmt[15],
        "Short Date": $a1a91b25d7598376$var$table_fmt[14],
        "Long Time": $a1a91b25d7598376$var$table_fmt[19],
        "Medium Time": $a1a91b25d7598376$var$table_fmt[18],
        "Short Time": $a1a91b25d7598376$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $a1a91b25d7598376$var$table_fmt[2],
        "Standard": $a1a91b25d7598376$var$table_fmt[4],
        "Percent": $a1a91b25d7598376$var$table_fmt[10],
        "Scientific": $a1a91b25d7598376$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $a1a91b25d7598376$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "");
    var raw_Rn3 = "";
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case "data" /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === "/") {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === "/") $a1a91b25d7598376$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts);
            else {
                ss = "";
                dtag = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case "cell" /*case 'Cell'*/ :
            if (Rn[1] === "/") {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$a1a91b25d7598376$var$encode_col(c) + $a1a91b25d7598376$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $a1a91b25d7598376$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: "z"
                                };
                            } else cursheet[$a1a91b25d7598376$var$encode_col(cma) + $a1a91b25d7598376$var$encode_row(cmd)] = {
                                t: "z"
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $a1a91b25d7598376$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case "row" /*case 'Row'*/ :
            if (Rn[1] === "/" || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $a1a91b25d7598376$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case "worksheet" /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                sheetname = $a1a91b25d7598376$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case "table" /*case 'Table'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case "style" /*case 'Style'*/ :
            if (Rn[1] === "/") $a1a91b25d7598376$var$process_style_xlml(styles, stag, opts);
            else stag = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            break;
        case "numberformat" /*case 'NumberFormat'*/ :
            stag.nf = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($a1a91b25d7598376$var$XLMLFormatMap[stag.nf]) stag.nf = $a1a91b25d7598376$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($a1a91b25d7598376$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($a1a91b25d7598376$var$table_fmt[ssfidx] == null) {
                    $a1a91b25d7598376$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case "column" /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ "table") break;
            if (Rn[1] === "/") break;
            csty = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $a1a91b25d7598376$var$process_col(cstys[_col]);
            }
            if (seencol) $a1a91b25d7598376$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $a1a91b25d7598376$var$dup(csty);
            break;
        case "namedrange" /*case 'NamedRange'*/ :
            if (Rn[1] === "/") break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $a1a91b25d7598376$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $a1a91b25d7598376$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $a1a91b25d7598376$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case "namedcell" /*case 'NamedCell'*/ :
            break;
        case "b" /*case 'B'*/ :
            break;
        case "i" /*case 'I'*/ :
            break;
        case "u" /*case 'U'*/ :
            break;
        case "s" /*case 'S'*/ :
            break;
        case "em" /*case 'EM'*/ :
            break;
        case "h2" /*case 'H2'*/ :
            break;
        case "h3" /*case 'H3'*/ :
            break;
        case "sub" /*case 'Sub'*/ :
            break;
        case "sup" /*case 'Sup'*/ :
            break;
        case "span" /*case 'Span'*/ :
            break;
        case "alignment" /*case 'Alignment'*/ :
            break;
        case "borders" /*case 'Borders'*/ :
            break;
        case "border" /*case 'Border'*/ :
            break;
        case "font" /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case "interior" /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            break;
        case "protection" /*case 'Protection'*/ :
            break;
        case "author" /*case 'Author'*/ :
        case "title" /*case 'Title'*/ :
        case "description" /*case 'Description'*/ :
        case "created" /*case 'Created'*/ :
        case "keywords" /*case 'Keywords'*/ :
        case "subject" /*case 'Subject'*/ :
        case "category" /*case 'Category'*/ :
        case "company" /*case 'Company'*/ :
        case "lastauthor" /*case 'LastAuthor'*/ :
        case "lastsaved" /*case 'LastSaved'*/ :
        case "lastprinted" /*case 'LastPrinted'*/ :
        case "version" /*case 'Version'*/ :
        case "revision" /*case 'Revision'*/ :
        case "totaltime" /*case 'TotalTime'*/ :
        case "hyperlinkbase" /*case 'HyperlinkBase'*/ :
        case "manager" /*case 'Manager'*/ :
        case "contentstatus" /*case 'ContentStatus'*/ :
        case "identifier" /*case 'Identifier'*/ :
        case "language" /*case 'Language'*/ :
        case "appname" /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $a1a91b25d7598376$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case "paragraphs" /*case 'Paragraphs'*/ :
            break;
        case "styles" /*case 'Styles'*/ :
        case "workbook" /*case 'Workbook'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case "comment" /*case 'Comment'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $a1a91b25d7598376$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case "autofilter" /*case 'AutoFilter'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                var AutoFilter = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                cursheet["!autofilter"] = {
                    ref: $a1a91b25d7598376$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case "name" /*case 'Name'*/ :
            break;
        case "datavalidation" /*case 'DataValidation'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "pixelsperinch" /*case 'PixelsPerInch'*/ :
            break;
        case "componentoptions" /*case 'ComponentOptions'*/ :
        case "documentproperties" /*case 'DocumentProperties'*/ :
        case "customdocumentproperties" /*case 'CustomDocumentProperties'*/ :
        case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
        case "pivottable" /*case 'PivotTable'*/ :
        case "pivotcache" /*case 'PivotCache'*/ :
        case "names" /*case 'Names'*/ :
        case "mapinfo" /*case 'MapInfo'*/ :
        case "pagebreaks" /*case 'PageBreaks'*/ :
        case "querytable" /*case 'QueryTable'*/ :
        case "sorting" /*case 'Sorting'*/ :
        case "schema" /*case 'Schema'*/ :
        case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
        case "smarttagtype" /*case 'SmartTagType'*/ :
        case "smarttags" /*case 'SmartTags'*/ :
        case "excelworkbook" /*case 'ExcelWorkbook'*/ :
        case "workbookoptions" /*case 'WorkbookOptions'*/ :
        case "worksheetoptions" /*case 'WorksheetOptions'*/ :
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "null" /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $a1a91b25d7598376$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $a1a91b25d7598376$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case "officedocumentsettings" /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case "allowpng" /*case 'AllowPNG'*/ :
                            break;
                        case "removepersonalinformation" /*case 'RemovePersonalInformation'*/ :
                            break;
                        case "downloadcomponents" /*case 'DownloadComponents'*/ :
                            break;
                        case "locationofcomponents" /*case 'LocationOfComponents'*/ :
                            break;
                        case "colors" /*case 'Colors'*/ :
                            break;
                        case "color" /*case 'Color'*/ :
                            break;
                        case "index" /*case 'Index'*/ :
                            break;
                        case "rgb" /*case 'RGB'*/ :
                            break;
                        case "targetscreensize" /*case 'TargetScreenSize'*/ :
                            break;
                        case "readonlyrecommended" /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case "componentoptions" /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case "toolbar" /*case 'Toolbar'*/ :
                            break;
                        case "hideofficelogo" /*case 'HideOfficeLogo'*/ :
                            break;
                        case "spreadsheetautofit" /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case "label" /*case 'Label'*/ :
                            break;
                        case "caption" /*case 'Caption'*/ :
                            break;
                        case "maxheight" /*case 'MaxHeight'*/ :
                            break;
                        case "maxwidth" /*case 'MaxWidth'*/ :
                            break;
                        case "nextsheetnumber" /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case "excelworkbook" /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case "date1904" /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case "windowheight" /*case 'WindowHeight'*/ :
                            break;
                        case "windowwidth" /*case 'WindowWidth'*/ :
                            break;
                        case "windowtopx" /*case 'WindowTopX'*/ :
                            break;
                        case "windowtopy" /*case 'WindowTopY'*/ :
                            break;
                        case "tabratio" /*case 'TabRatio'*/ :
                            break;
                        case "protectstructure" /*case 'ProtectStructure'*/ :
                            break;
                        case "protectwindow" /*case 'ProtectWindow'*/ :
                            break;
                        case "protectwindows" /*case 'ProtectWindows'*/ :
                            break;
                        case "activesheet" /*case 'ActiveSheet'*/ :
                            break;
                        case "displayinknotes" /*case 'DisplayInkNotes'*/ :
                            break;
                        case "firstvisiblesheet" /*case 'FirstVisibleSheet'*/ :
                            break;
                        case "supbook" /*case 'SupBook'*/ :
                            break;
                        case "sheetname" /*case 'SheetName'*/ :
                            break;
                        case "sheetindex" /*case 'SheetIndex'*/ :
                            break;
                        case "sheetindexfirst" /*case 'SheetIndexFirst'*/ :
                            break;
                        case "sheetindexlast" /*case 'SheetIndexLast'*/ :
                            break;
                        case "dll" /*case 'Dll'*/ :
                            break;
                        case "acceptlabelsinformulas" /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case "donotsavelinkvalues" /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case "iteration" /*case 'Iteration'*/ :
                            break;
                        case "maxiterations" /*case 'MaxIterations'*/ :
                            break;
                        case "maxchange" /*case 'MaxChange'*/ :
                            break;
                        case "path" /*case 'Path'*/ :
                            break;
                        case "xct" /*case 'Xct'*/ :
                            break;
                        case "count" /*case 'Count'*/ :
                            break;
                        case "selectedsheets" /*case 'SelectedSheets'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        case "uncalced" /*case 'Uncalced'*/ :
                            break;
                        case "startupprompt" /*case 'StartupPrompt'*/ :
                            break;
                        case "crn" /*case 'Crn'*/ :
                            break;
                        case "externname" /*case 'ExternName'*/ :
                            break;
                        case "formula" /*case 'Formula'*/ :
                            break;
                        case "colfirst" /*case 'ColFirst'*/ :
                            break;
                        case "collast" /*case 'ColLast'*/ :
                            break;
                        case "wantadvise" /*case 'WantAdvise'*/ :
                            break;
                        case "boolean" /*case 'Boolean'*/ :
                            break;
                        case "error" /*case 'Error'*/ :
                            break;
                        case "text" /*case 'Text'*/ :
                            break;
                        case "ole" /*case 'OLE'*/ :
                            break;
                        case "noautorecover" /*case 'NoAutoRecover'*/ :
                            break;
                        case "publishobjects" /*case 'PublishObjects'*/ :
                            break;
                        case "donotcalculatebeforesave" /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "refmoder1c1" /*case 'RefModeR1C1'*/ :
                            break;
                        case "embedsavesmarttags" /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case "workbookoptions" /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case "owcversion" /*case 'OWCVersion'*/ :
                            break;
                        case "height" /*case 'Height'*/ :
                            break;
                        case "width" /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case "worksheetoptions" /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case "visible" /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case "header" /*case 'Header'*/ :
                            if (!cursheet["!margins"]) $a1a91b25d7598376$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].header = +$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "footer" /*case 'Footer'*/ :
                            if (!cursheet["!margins"]) $a1a91b25d7598376$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin)) cursheet["!margins"].footer = +$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case "pagemargins" /*case 'PageMargins'*/ :
                            var pagemargins = $a1a91b25d7598376$var$parsexmltag(Rn[0]);
                            if (!cursheet["!margins"]) $a1a91b25d7598376$var$default_margins(cursheet["!margins"] = {}, "xlml");
                            if (!isNaN(+pagemargins.Top)) cursheet["!margins"].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet["!margins"].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet["!margins"].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet["!margins"].bottom = +pagemargins.Bottom;
                            break;
                        case "displayrighttoleft" /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case "freezepanes" /*case 'FreezePanes'*/ :
                            break;
                        case "frozennosplit" /*case 'FrozenNoSplit'*/ :
                            break;
                        case "splithorizontal" /*case 'SplitHorizontal'*/ :
                        case "splitvertical" /*case 'SplitVertical'*/ :
                            break;
                        case "donotdisplaygridlines" /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case "activerow" /*case 'ActiveRow'*/ :
                            break;
                        case "activecol" /*case 'ActiveCol'*/ :
                            break;
                        case "toprowbottompane" /*case 'TopRowBottomPane'*/ :
                            break;
                        case "leftcolumnrightpane" /*case 'LeftColumnRightPane'*/ :
                            break;
                        case "unsynced" /*case 'Unsynced'*/ :
                            break;
                        case "print" /*case 'Print'*/ :
                            break;
                        case "printerrors" /*case 'PrintErrors'*/ :
                            break;
                        case "panes" /*case 'Panes'*/ :
                            break;
                        case "scale" /*case 'Scale'*/ :
                            break;
                        case "pane" /*case 'Pane'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "layout" /*case 'Layout'*/ :
                            break;
                        case "pagesetup" /*case 'PageSetup'*/ :
                            break;
                        case "selected" /*case 'Selected'*/ :
                            break;
                        case "protectobjects" /*case 'ProtectObjects'*/ :
                            break;
                        case "enableselection" /*case 'EnableSelection'*/ :
                            break;
                        case "protectscenarios" /*case 'ProtectScenarios'*/ :
                            break;
                        case "validprinterinfo" /*case 'ValidPrinterInfo'*/ :
                            break;
                        case "horizontalresolution" /*case 'HorizontalResolution'*/ :
                            break;
                        case "verticalresolution" /*case 'VerticalResolution'*/ :
                            break;
                        case "numberofcopies" /*case 'NumberofCopies'*/ :
                            break;
                        case "activepane" /*case 'ActivePane'*/ :
                            break;
                        case "toprowvisible" /*case 'TopRowVisible'*/ :
                            break;
                        case "leftcolumnvisible" /*case 'LeftColumnVisible'*/ :
                            break;
                        case "fittopage" /*case 'FitToPage'*/ :
                            break;
                        case "rangeselection" /*case 'RangeSelection'*/ :
                            break;
                        case "papersizeindex" /*case 'PaperSizeIndex'*/ :
                            break;
                        case "pagelayoutzoom" /*case 'PageLayoutZoom'*/ :
                            break;
                        case "pagebreakzoom" /*case 'PageBreakZoom'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "fitwidth" /*case 'FitWidth'*/ :
                            break;
                        case "fitheight" /*case 'FitHeight'*/ :
                            break;
                        case "commentslayout" /*case 'CommentsLayout'*/ :
                            break;
                        case "zoom" /*case 'Zoom'*/ :
                            break;
                        case "lefttoright" /*case 'LeftToRight'*/ :
                            break;
                        case "gridlines" /*case 'Gridlines'*/ :
                            break;
                        case "allowsort" /*case 'AllowSort'*/ :
                            break;
                        case "allowfilter" /*case 'AllowFilter'*/ :
                            break;
                        case "allowinsertrows" /*case 'AllowInsertRows'*/ :
                            break;
                        case "allowdeleterows" /*case 'AllowDeleteRows'*/ :
                            break;
                        case "allowinsertcols" /*case 'AllowInsertCols'*/ :
                            break;
                        case "allowdeletecols" /*case 'AllowDeleteCols'*/ :
                            break;
                        case "allowinserthyperlinks" /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case "allowformatcells" /*case 'AllowFormatCells'*/ :
                            break;
                        case "allowsizecols" /*case 'AllowSizeCols'*/ :
                            break;
                        case "allowsizerows" /*case 'AllowSizeRows'*/ :
                            break;
                        case "nosummaryrowsbelowdetail" /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case "tabcolorindex" /*case 'TabColorIndex'*/ :
                            break;
                        case "donotdisplayheadings" /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case "showpagelayoutzoom" /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case "nosummarycolumnsrightdetail" /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case "blackandwhite" /*case 'BlackAndWhite'*/ :
                            break;
                        case "donotdisplayzeros" /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case "displaypagebreak" /*case 'DisplayPageBreak'*/ :
                            break;
                        case "rowcolheadings" /*case 'RowColHeadings'*/ :
                            break;
                        case "donotdisplayoutline" /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case "noorientation" /*case 'NoOrientation'*/ :
                            break;
                        case "allowusepivottables" /*case 'AllowUsePivotTables'*/ :
                            break;
                        case "zeroheight" /*case 'ZeroHeight'*/ :
                            break;
                        case "viewablerange" /*case 'ViewableRange'*/ :
                            break;
                        case "selection" /*case 'Selection'*/ :
                            break;
                        case "protectcontents" /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case "pivottable" /*case 'PivotTable'*/ :
                case "pivotcache" /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case "immediateitemsondrop" /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case "showpagemultipleitemlabel" /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case "compactrowindent" /*case 'CompactRowIndent'*/ :
                            break;
                        case "location" /*case 'Location'*/ :
                            break;
                        case "pivotfield" /*case 'PivotField'*/ :
                            break;
                        case "orientation" /*case 'Orientation'*/ :
                            break;
                        case "layoutform" /*case 'LayoutForm'*/ :
                            break;
                        case "layoutsubtotallocation" /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case "layoutcompactrow" /*case 'LayoutCompactRow'*/ :
                            break;
                        case "position" /*case 'Position'*/ :
                            break;
                        case "pivotitem" /*case 'PivotItem'*/ :
                            break;
                        case "datatype" /*case 'DataType'*/ :
                            break;
                        case "datafield" /*case 'DataField'*/ :
                            break;
                        case "sourcename" /*case 'SourceName'*/ :
                            break;
                        case "parentfield" /*case 'ParentField'*/ :
                            break;
                        case "ptlineitems" /*case 'PTLineItems'*/ :
                            break;
                        case "ptlineitem" /*case 'PTLineItem'*/ :
                            break;
                        case "countofsameitems" /*case 'CountOfSameItems'*/ :
                            break;
                        case "item" /*case 'Item'*/ :
                            break;
                        case "itemtype" /*case 'ItemType'*/ :
                            break;
                        case "ptsource" /*case 'PTSource'*/ :
                            break;
                        case "cacheindex" /*case 'CacheIndex'*/ :
                            break;
                        case "consolidationreference" /*case 'ConsolidationReference'*/ :
                            break;
                        case "filename" /*case 'FileName'*/ :
                            break;
                        case "reference" /*case 'Reference'*/ :
                            break;
                        case "nocolumngrand" /*case 'NoColumnGrand'*/ :
                            break;
                        case "norowgrand" /*case 'NoRowGrand'*/ :
                            break;
                        case "blanklineafteritems" /*case 'BlankLineAfterItems'*/ :
                            break;
                        case "hidden" /*case 'Hidden'*/ :
                            break;
                        case "subtotal" /*case 'Subtotal'*/ :
                            break;
                        case "basefield" /*case 'BaseField'*/ :
                            break;
                        case "mapchilditems" /*case 'MapChildItems'*/ :
                            break;
                        case "function" /*case 'Function'*/ :
                            break;
                        case "refreshonfileopen" /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case "printsettitles" /*case 'PrintSetTitles'*/ :
                            break;
                        case "mergelabels" /*case 'MergeLabels'*/ :
                            break;
                        case "defaultversion" /*case 'DefaultVersion'*/ :
                            break;
                        case "refreshname" /*case 'RefreshName'*/ :
                            break;
                        case "refreshdate" /*case 'RefreshDate'*/ :
                            break;
                        case "refreshdatecopy" /*case 'RefreshDateCopy'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        case "versionlastupdate" /*case 'VersionLastUpdate'*/ :
                            break;
                        case "versionupdateablemin" /*case 'VersionUpdateableMin'*/ :
                            break;
                        case "versionrefreshablemin" /*case 'VersionRefreshableMin'*/ :
                            break;
                        case "calculation" /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case "pagebreaks" /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case "colbreaks" /*case 'ColBreaks'*/ :
                            break;
                        case "colbreak" /*case 'ColBreak'*/ :
                            break;
                        case "rowbreaks" /*case 'RowBreaks'*/ :
                            break;
                        case "rowbreak" /*case 'RowBreak'*/ :
                            break;
                        case "colstart" /*case 'ColStart'*/ :
                            break;
                        case "colend" /*case 'ColEnd'*/ :
                            break;
                        case "rowend" /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case "autofilter" /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case "autofiltercolumn" /*case 'AutoFilterColumn'*/ :
                            break;
                        case "autofiltercondition" /*case 'AutoFilterCondition'*/ :
                            break;
                        case "autofilterand" /*case 'AutoFilterAnd'*/ :
                            break;
                        case "autofilteror" /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case "querytable" /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case "id" /*case 'Id'*/ :
                            break;
                        case "autoformatfont" /*case 'AutoFormatFont'*/ :
                            break;
                        case "autoformatpattern" /*case 'AutoFormatPattern'*/ :
                            break;
                        case "querysource" /*case 'QuerySource'*/ :
                            break;
                        case "querytype" /*case 'QueryType'*/ :
                            break;
                        case "enableredirections" /*case 'EnableRedirections'*/ :
                            break;
                        case "refreshedinxl9" /*case 'RefreshedInXl9'*/ :
                            break;
                        case "urlstring" /*case 'URLString'*/ :
                            break;
                        case "htmltables" /*case 'HTMLTables'*/ :
                            break;
                        case "connection" /*case 'Connection'*/ :
                            break;
                        case "commandtext" /*case 'CommandText'*/ :
                            break;
                        case "refreshinfo" /*case 'RefreshInfo'*/ :
                            break;
                        case "notitles" /*case 'NoTitles'*/ :
                            break;
                        case "nextid" /*case 'NextId'*/ :
                            break;
                        case "columninfo" /*case 'ColumnInfo'*/ :
                            break;
                        case "overwritecells" /*case 'OverwriteCells'*/ :
                            break;
                        case "donotpromptforfile" /*case 'DoNotPromptForFile'*/ :
                            break;
                        case "textwizardsettings" /*case 'TextWizardSettings'*/ :
                            break;
                        case "source" /*case 'Source'*/ :
                            break;
                        case "number" /*case 'Number'*/ :
                            break;
                        case "decimal" /*case 'Decimal'*/ :
                            break;
                        case "thousandseparator" /*case 'ThousandSeparator'*/ :
                            break;
                        case "trailingminusnumbers" /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case "formatsettings" /*case 'FormatSettings'*/ :
                            break;
                        case "fieldtype" /*case 'FieldType'*/ :
                            break;
                        case "delimiters" /*case 'Delimiters'*/ :
                            break;
                        case "tab" /*case 'Tab'*/ :
                            break;
                        case "comma" /*case 'Comma'*/ :
                            break;
                        case "autoformatname" /*case 'AutoFormatName'*/ :
                            break;
                        case "versionlastedit" /*case 'VersionLastEdit'*/ :
                            break;
                        case "versionlastrefresh" /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "datavalidation" /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case "sorting" /*case 'Sorting'*/ :
                case "conditionalformatting" /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case "range" /*case 'Range'*/ :
                            break;
                        case "type" /*case 'Type'*/ :
                            break;
                        case "min" /*case 'Min'*/ :
                            break;
                        case "max" /*case 'Max'*/ :
                            break;
                        case "sort" /*case 'Sort'*/ :
                            break;
                        case "descending" /*case 'Descending'*/ :
                            break;
                        case "order" /*case 'Order'*/ :
                            break;
                        case "casesensitive" /*case 'CaseSensitive'*/ :
                            break;
                        case "value" /*case 'Value'*/ :
                            break;
                        case "errorstyle" /*case 'ErrorStyle'*/ :
                            break;
                        case "errormessage" /*case 'ErrorMessage'*/ :
                            break;
                        case "errortitle" /*case 'ErrorTitle'*/ :
                            break;
                        case "cellrangelist" /*case 'CellRangeList'*/ :
                            break;
                        case "inputmessage" /*case 'InputMessage'*/ :
                            break;
                        case "inputtitle" /*case 'InputTitle'*/ :
                            break;
                        case "combohide" /*case 'ComboHide'*/ :
                            break;
                        case "inputhide" /*case 'InputHide'*/ :
                            break;
                        case "condition" /*case 'Condition'*/ :
                            break;
                        case "qualifier" /*case 'Qualifier'*/ :
                            break;
                        case "useblank" /*case 'UseBlank'*/ :
                            break;
                        case "value1" /*case 'Value1'*/ :
                            break;
                        case "value2" /*case 'Value2'*/ :
                            break;
                        case "format" /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case "mapinfo" /*case 'MapInfo'*/ :
                case "schema" /*case 'Schema'*/ :
                case "data" /*case 'data'*/ :
                    switch(Rn[3]){
                        case "map" /*case 'Map'*/ :
                            break;
                        case "entry" /*case 'Entry'*/ :
                            break;
                        case "range" /*case 'Range'*/ :
                            break;
                        case "xpath" /*case 'XPath'*/ :
                            break;
                        case "field" /*case 'Field'*/ :
                            break;
                        case "xsdtype" /*case 'XSDType'*/ :
                            break;
                        case "filteron" /*case 'FilterOn'*/ :
                            break;
                        case "aggregate" /*case 'Aggregate'*/ :
                            break;
                        case "elementtype" /*case 'ElementType'*/ :
                            break;
                        case "attributetype" /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case "schema" /*case 'schema'*/ :
                        case "element" /*case 'element'*/ :
                        case "complextype" /*case 'complexType'*/ :
                        case "datatype" /*case 'datatype'*/ :
                        case "all" /*case 'all'*/ :
                        case "attribute" /*case 'attribute'*/ :
                        case "extends" /*case 'extends'*/ :
                            break;
                        case "row" /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case "smarttags" /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ "customdocumentproperties") {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $a1a91b25d7598376$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw "Unrecognized tag: " + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $a1a91b25d7598376$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $a1a91b25d7598376$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $a1a91b25d7598376$var$parse_xlml_xml($a1a91b25d7598376$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $a1a91b25d7598376$var$parse_xlml_xml(data, opts);
        case "array":
            return $a1a91b25d7598376$var$parse_xlml_xml($a1a91b25d7598376$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $a1a91b25d7598376$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($a1a91b25d7598376$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($a1a91b25d7598376$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $a1a91b25d7598376$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $a1a91b25d7598376$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($a1a91b25d7598376$var$writextag("NumberFormat", null, {
            "ss:Format": $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($a1a91b25d7598376$var$writextag("Style", payload.join(""), o));
    });
    return $a1a91b25d7598376$var$writextag("Styles", styles.join(""));
}
function $a1a91b25d7598376$var$write_name_xlml(n) {
    return $a1a91b25d7598376$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $a1a91b25d7598376$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $a1a91b25d7598376$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($a1a91b25d7598376$var$write_name_xlml(n));
    }
    return $a1a91b25d7598376$var$writextag("Names", out.join(""));
}
function $a1a91b25d7598376$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($a1a91b25d7598376$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $a1a91b25d7598376$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws["!margins"]) {
        o.push("<PageSetup>");
        if (ws["!margins"].header) o.push($a1a91b25d7598376$var$writextag("Header", null, {
            "x:Margin": ws["!margins"].header
        }));
        if (ws["!margins"].footer) o.push($a1a91b25d7598376$var$writextag("Footer", null, {
            "x:Margin": ws["!margins"].footer
        }));
        o.push($a1a91b25d7598376$var$writextag("PageMargins", null, {
            "x:Bottom": ws["!margins"].bottom || "0.75",
            "x:Left": ws["!margins"].left || "0.7",
            "x:Right": ws["!margins"].right || "0.7",
            "x:Top": ws["!margins"].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($a1a91b25d7598376$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws["!protect"]) {
        o.push($a1a91b25d7598376$var$writetag("ProtectContents", "True"));
        if (ws["!protect"].objects) o.push($a1a91b25d7598376$var$writetag("ProtectObjects", "True"));
        if (ws["!protect"].scenarios) o.push($a1a91b25d7598376$var$writetag("ProtectScenarios", "True"));
        if (ws["!protect"].selectLockedCells != null && !ws["!protect"].selectLockedCells) o.push($a1a91b25d7598376$var$writetag("EnableSelection", "NoSelection"));
        else if (ws["!protect"].selectUnlockedCells != null && !ws["!protect"].selectUnlockedCells) o.push($a1a91b25d7598376$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws["!protect"][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $a1a91b25d7598376$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $a1a91b25d7598376$var$XLMLNS.x
    });
}
function $a1a91b25d7598376$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    return comments.map(function(c) {
        // TODO: formatted text
        var t = $a1a91b25d7598376$var$xlml_unfixstr(c.t || "");
        var d = $a1a91b25d7598376$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        return $a1a91b25d7598376$var$writextag("Comment", d, {
            "ss:Author": c.a
        });
    }).join("");
}
function $a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $a1a91b25d7598376$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $a1a91b25d7598376$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $a1a91b25d7598376$var$escapexml(cell.l.Tooltip);
    }
    if (ws["!merges"]) {
        var marr = ws["!merges"];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr["ss:MergeAcross"] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr["ss:MergeDown"] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case "z":
            if (!opts.sheetStubs) return "";
            break;
        case "n":
            t = "Number";
            p = String(cell.v);
            break;
        case "b":
            t = "Boolean";
            p = cell.v ? "1" : "0";
            break;
        case "e":
            t = "Error";
            p = $a1a91b25d7598376$var$BErr[cell.v];
            break;
        case "d":
            t = "DateTime";
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $a1a91b25d7598376$var$table_fmt[14];
            break;
        case "s":
            t = "String";
            p = $a1a91b25d7598376$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == "z" ? "" : '<Data ss:Type="' + t + '">' + _v + "</Data>";
    if ((cell.c || []).length > 0) m += $a1a91b25d7598376$var$write_ws_xlml_comment(cell.c);
    return $a1a91b25d7598376$var$writextag("Cell", m, attr);
}
function $a1a91b25d7598376$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $a1a91b25d7598376$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + ">";
}
/* TODO */ function $a1a91b25d7598376$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws["!ref"]) return "";
    var range /*:Range*/  = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
    var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws["!cols"]) ws["!cols"].forEach(function(n, i) {
        $a1a91b25d7598376$var$process_col(n);
        var w = !!n.width;
        var p = $a1a91b25d7598376$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k["ss:Width"] = $a1a91b25d7598376$var$width2px(p.width);
        if (n.hidden) k["ss:Hidden"] = "1";
        o.push($a1a91b25d7598376$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $a1a91b25d7598376$var$write_ws_xlml_row(R, (ws["!rows"] || [])[R])
        ];
        for(var C = range.s.c; C <= range.e.c; ++C){
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var addr = {
                r: R,
                c: C
            };
            var ref = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $a1a91b25d7598376$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $a1a91b25d7598376$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $a1a91b25d7598376$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($a1a91b25d7598376$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $a1a91b25d7598376$var$a1_to_rc($a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $a1a91b25d7598376$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($a1a91b25d7598376$var$write_props_xlml(wb, opts));
    d.push($a1a91b25d7598376$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push("");
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($a1a91b25d7598376$var$writextag("Worksheet", $a1a91b25d7598376$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $a1a91b25d7598376$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $a1a91b25d7598376$var$write_sty_xlml(wb, opts);
    d[3] = $a1a91b25d7598376$var$write_names_xlml(wb, opts);
    return $a1a91b25d7598376$var$XML_HEADER + $a1a91b25d7598376$var$writextag("Workbook", d.join(""), {
        "xmlns": $a1a91b25d7598376$var$XLMLNS.ss,
        "xmlns:o": $a1a91b25d7598376$var$XLMLNS.o,
        "xmlns:x": $a1a91b25d7598376$var$XLMLNS.x,
        "xmlns:ss": $a1a91b25d7598376$var$XLMLNS.ss,
        "xmlns:dt": $a1a91b25d7598376$var$XLMLNS.dt,
        "xmlns:html": $a1a91b25d7598376$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $a1a91b25d7598376$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $a1a91b25d7598376$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $a1a91b25d7598376$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $a1a91b25d7598376$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $a1a91b25d7598376$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l), next = $a1a91b25d7598376$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $a1a91b25d7598376$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $a1a91b25d7598376$var$XLSRecordEnum[nextrt = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $a1a91b25d7598376$var$bconcat(bufs);
    $a1a91b25d7598376$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $a1a91b25d7598376$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === "z") return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF) p.z = $a1a91b25d7598376$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === "e") p.w = p.w || $a1a91b25d7598376$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === "n") {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(p.v);
            } else p.w = $a1a91b25d7598376$var$SSF_general(p.v);
        } else p.w = $a1a91b25d7598376$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == "n" && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $a1a91b25d7598376$var$SSF_parse_date_code(p.v);
        if (_d) {
            p.t = "d";
            p.v = new Date(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u);
        }
    }
}
function $a1a91b25d7598376$var$make_cell(val, ixfe, t) /*:Cell*/ {
    return {
        v: val,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $a1a91b25d7598376$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($a1a91b25d7598376$var$DENSE != null && options.dense == null) options.dense = $a1a91b25d7598376$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $a1a91b25d7598376$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $a1a91b25d7598376$var$XLSIcv[icv];
        return $a1a91b25d7598376$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(cell, line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $a1a91b25d7598376$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $a1a91b25d7598376$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $a1a91b25d7598376$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $a1a91b25d7598376$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $a1a91b25d7598376$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $a1a91b25d7598376$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $a1a91b25d7598376$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val = /*::(*/ $a1a91b25d7598376$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $a1a91b25d7598376$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val.fDialog) out["!type"] = "dialog";
                    if (!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x00e0 /* XF */ :
                    XFs.push(val);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val.Name,
                        Ref: $a1a91b25d7598376$var$stringify_formula(val.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val.itab > 0) last_lbl.Sheet = val.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val);
                    if (val.Name == "_xlnm._FilterDatabase" && val.itab > 0) {
                        if (val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == "PtgArea3d") FilterDatabases[val.itab - 1] = {
                            ref: $a1a91b25d7598376$var$encode_range(val.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
                    supbooks.XTI = supbooks.XTI.concat(val);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val !== 0 && opts.WTF) console.error("Password verifier: " + val);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[val.pos] = val;
                    opts.snames.push(val.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        /*::[*/ 0x0009: 2,
                        /*::[*/ 0x0209: 3,
                        /*::[*/ 0x0409: 4
                    })[RecordType] || ({
                        /*::[*/ 0x0200: 2,
                        /*::[*/ 0x0300: 3,
                        /*::[*/ 0x0400: 4,
                        /*::[*/ 0x0500: 5,
                        /*::[*/ 0x0600: 8,
                        /*::[*/ 0x0002: 2,
                        /*::[*/ 0x0007: 2
                    })[val.BIFFVer] || 8;
                    opts.biffguess = val.BIFFVer == 0;
                    if (val.BIFFVer == 0 && val.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $a1a91b25d7598376$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
                    if (file_depth++) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $a1a91b25d7598376$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val.dt == 0x20) out["!type"] = "chart";
                    if (val.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val.r] || [])[val.c] : out[$a1a91b25d7598376$var$encode_col(val.c) + $a1a91b25d7598376$var$encode_row(val.r)]) ++val.c;
                    }
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe] || {},
                        v: val.val,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.val,
                        t: val.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val.ixfe,
                        XF: XFs[val.ixfe],
                        v: val.rknum,
                        t: "n"
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val.c; j <= val.C; ++j){
                        var ixfe = val.rkrec[j - val.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val.rkrec[j - val.c][1],
                            t: "n"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val.val == "String") {
                        last_formula = val;
                        break;
                    }
                    temp_val = $a1a91b25d7598376$var$make_cell(val.val, val.cell.ixfe, val.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == "PtgExp") {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $a1a91b25d7598376$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(val.formula, range, val.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val.cell, temp_val, options);
                    last_formula = val;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val;
                        temp_val = $a1a91b25d7598376$var$make_cell(val, last_formula.cell.ixfe, "s");
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val);
                    var _arraystart = $a1a91b25d7598376$var$encode_cell(val[0].s);
                    cc = options.dense ? (out["!data"][val[0].s.r] || [])[val[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $a1a91b25d7598376$var$stringify_formula(val[1], range, val[0], supbooks, opts);
                        cc.F = $a1a91b25d7598376$var$encode_range(val[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$a1a91b25d7598376$var$encode_cell(last_formula.cell)] = val[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$a1a91b25d7598376$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $a1a91b25d7598376$var$stringify_formula(val[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $a1a91b25d7598376$var$make_cell(sst[val.isst].t, val.ixfe, "s");
                    if (sst[val.isst].h) temp_val.h = sst[val.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val.ixfe,
                            XF: XFs[val.ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val.c,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val.c; _j <= val.C; ++_j){
                        var _ixfe = val.ixfe[_j - val.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: "z"
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $a1a91b25d7598376$var$make_cell(val.val, val.ixfe, "s");
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val.c,
                        r: val.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff == 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($a1a91b25d7598376$var$table_fmt[b4idx] == val[1]) break;
                        if (b4idx >= 163) $a1a91b25d7598376$var$SSF__load(val[1], BIFF2Fmt + 163);
                    } else $a1a91b25d7598376$var$SSF__load(val[1], val[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($a1a91b25d7598376$var$table_fmt[b2idx] == val) break;
                    if (b2idx >= 163) $a1a91b25d7598376$var$SSF__load(val, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val);
                    break;
                case 0x005d /* Obj */ :
                    objects[val.cmo[0]] = opts.lastobj = val;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$a1a91b25d7598376$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$a1a91b25d7598376$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    if (opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */ 
                    cc = options.dense ? (out["!data"][val[0].r] || [])[val[0].c] : out[$a1a91b25d7598376$var$encode_cell(val[0])];
                    var noteobj = objects[val[2]];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val[0].r]) out["!data"][val[0].r] = [];
                            cc = out["!data"][val[0].r][val[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$a1a91b25d7598376$var$encode_cell(val[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val[0].r);
                        range.s.r = Math.min(range.s.r, val[0].r);
                        range.e.c = Math.max(range.e.c, val[0].c);
                        range.s.c = Math.min(range.s.c, val[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    cmnt = {
                        a: val[1],
                        t: noteobj.TxO.t
                    };
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $a1a91b25d7598376$var$update_xfext(XFs[val.ixfe], val.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val.e >= val.s){
                        colinfo[val.e--] = {
                            width: val.w / 256,
                            level: val.level || 0,
                            hidden: !!(val.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $a1a91b25d7598376$var$find_mdw_colw(val.w / 256);
                        }
                        $a1a91b25d7598376$var$process_col(colinfo[val.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val.level != null) {
                        rowinfo[val.r] = rowobj;
                        rowobj.level = val.level;
                    }
                    if (val.hidden) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val.hpt) {
                        rowinfo[val.r] = rowobj;
                        rowobj.hpt = val.hpt;
                        rowobj.hpx = $a1a91b25d7598376$var$pt2px(val.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out["!margins"]) $a1a91b25d7598376$var$default_margins(out["!margins"] = {});
                    out["!margins"][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out["!margins"]) $a1a91b25d7598376$var$default_margins(out["!margins"] = {});
                    out["!margins"].header = val.header;
                    out["!margins"].footer = val.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val;
                    break;
                case 0x008c /* Country */ :
                    country = val;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
                    else wsprops.CodeName = val || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $a1a91b25d7598376$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]["!autofilter"] = r;
    });
    wb.Strings = sst;
    wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $a1a91b25d7598376$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $a1a91b25d7598376$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/!DocumentSummaryInformation");
    if (DSI && DSI.size > 0) try {
        var DocSummary = $a1a91b25d7598376$var$parse_PropertySetStream(DSI, $a1a91b25d7598376$var$DocSummaryPIDDSI, $a1a91b25d7598376$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/!SummaryInformation");
    if (SI && SI.size > 0) try {
        var Summary = $a1a91b25d7598376$var$parse_PropertySetStream(SI, $a1a91b25d7598376$var$SummaryPIDSI, $a1a91b25d7598376$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $a1a91b25d7598376$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $a1a91b25d7598376$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $a1a91b25d7598376$var$evert_key($a1a91b25d7598376$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $a1a91b25d7598376$var$evert_key($a1a91b25d7598376$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $a1a91b25d7598376$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $a1a91b25d7598376$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($a1a91b25d7598376$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $a1a91b25d7598376$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05SummaryInformation", $a1a91b25d7598376$var$write_PropertySetStream(SEntries, $a1a91b25d7598376$var$PSCLSID.SI, SummaryRE, $a1a91b25d7598376$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\x05DocumentSummaryInformation", $a1a91b25d7598376$var$write_PropertySetStream(DSEntries, $a1a91b25d7598376$var$PSCLSID.DSI, DocSummaryRE, $a1a91b25d7598376$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $a1a91b25d7598376$var$PSCLSID.UDI));
}
function $a1a91b25d7598376$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $a1a91b25d7598376$var$fix_read_opts(options);
    $a1a91b25d7598376$var$reset_cp();
    if (options.codepage) $a1a91b25d7598376$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/encryption")) throw new Error("File is password-protected");
        CompObj = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "!CompObj");
        WB = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/Workbook") || $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/Book");
    } else {
        switch(options.type){
            case "base64":
                cfb = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(cfb));
                break;
            case "binary":
                cfb = $a1a91b25d7598376$var$s2a(cfb);
                break;
            case "buffer":
                break;
            case "array":
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $a1a91b25d7598376$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $a1a91b25d7598376$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $a1a91b25d7598376$var$has_buf ? "buffer" : "array";
        if (WB && WB.content) WorkbookP = $a1a91b25d7598376$var$parse_workbook(WB.content, options);
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "PerfectOffice_MAIN")) && _data.content) WorkbookP = $a1a91b25d7598376$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "NativeContent_MAIN")) && _data.content) WorkbookP = $a1a91b25d7598376$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "MN0")) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/_VBA_PROJECT_CUR/VBA/dir")) WorkbookP.vbaraw = $a1a91b25d7598376$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $a1a91b25d7598376$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $a1a91b25d7598376$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $a1a91b25d7598376$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $a1a91b25d7598376$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $a1a91b25d7598376$var$fill_vba_xls(cfb, $a1a91b25d7598376$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $a1a91b25d7598376$var$XLSBRecordEnum = {
    /*::[*/ 0x0000: {
        f: $a1a91b25d7598376$var$parse_BrtRowHdr
    },
    /*::[*/ 0x0001: {
        f: $a1a91b25d7598376$var$parse_BrtCellBlank
    },
    /*::[*/ 0x0002: {
        f: $a1a91b25d7598376$var$parse_BrtCellRk
    },
    /*::[*/ 0x0003: {
        f: $a1a91b25d7598376$var$parse_BrtCellError
    },
    /*::[*/ 0x0004: {
        f: $a1a91b25d7598376$var$parse_BrtCellBool
    },
    /*::[*/ 0x0005: {
        f: $a1a91b25d7598376$var$parse_BrtCellReal
    },
    /*::[*/ 0x0006: {
        f: $a1a91b25d7598376$var$parse_BrtCellSt
    },
    /*::[*/ 0x0007: {
        f: $a1a91b25d7598376$var$parse_BrtCellIsst
    },
    /*::[*/ 0x0008: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaString
    },
    /*::[*/ 0x0009: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaNum
    },
    /*::[*/ 0x000A: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaBool
    },
    /*::[*/ 0x000B: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaError
    },
    /*::[*/ 0x000C: {
        f: $a1a91b25d7598376$var$parse_BrtShortBlank
    },
    /*::[*/ 0x000D: {
        f: $a1a91b25d7598376$var$parse_BrtShortRk
    },
    /*::[*/ 0x000E: {
        f: $a1a91b25d7598376$var$parse_BrtShortError
    },
    /*::[*/ 0x000F: {
        f: $a1a91b25d7598376$var$parse_BrtShortBool
    },
    /*::[*/ 0x0010: {
        f: $a1a91b25d7598376$var$parse_BrtShortReal
    },
    /*::[*/ 0x0011: {
        f: $a1a91b25d7598376$var$parse_BrtShortSt
    },
    /*::[*/ 0x0012: {
        f: $a1a91b25d7598376$var$parse_BrtShortIsst
    },
    /*::[*/ 0x0013: {
        f: $a1a91b25d7598376$var$parse_RichStr
    },
    /*::[*/ 0x0014: {},
    /*::[*/ 0x0015: {},
    /*::[*/ 0x0016: {},
    /*::[*/ 0x0017: {},
    /*::[*/ 0x0018: {},
    /*::[*/ 0x0019: {},
    /*::[*/ 0x001A: {},
    /*::[*/ 0x001B: {},
    /*::[*/ 0x001C: {},
    /*::[*/ 0x001D: {},
    /*::[*/ 0x001E: {},
    /*::[*/ 0x001F: {},
    /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {},
    /*::[*/ 0x0022: {},
    /*::[*/ 0x0023: {
        T: 1
    },
    /*::[*/ 0x0024: {
        T: -1
    },
    /*::[*/ 0x0025: {
        T: 1
    },
    /*::[*/ 0x0026: {
        T: -1
    },
    /*::[*/ 0x0027: {
        f: $a1a91b25d7598376$var$parse_BrtName
    },
    /*::[*/ 0x0028: {},
    /*::[*/ 0x002A: {},
    /*::[*/ 0x002B: {
        f: $a1a91b25d7598376$var$parse_BrtFont
    },
    /*::[*/ 0x002C: {
        f: $a1a91b25d7598376$var$parse_BrtFmt
    },
    /*::[*/ 0x002D: {
        f: $a1a91b25d7598376$var$parse_BrtFill
    },
    /*::[*/ 0x002E: {
        f: $a1a91b25d7598376$var$parse_BrtBorder
    },
    /*::[*/ 0x002F: {
        f: $a1a91b25d7598376$var$parse_BrtXF
    },
    /*::[*/ 0x0030: {},
    /*::[*/ 0x0031: {
        f: $a1a91b25d7598376$var$parse_Int32LE
    },
    /*::[*/ 0x0032: {},
    /*::[*/ 0x0033: {
        f: $a1a91b25d7598376$var$parse_BrtMdb
    },
    /*::[*/ 0x0034: {
        T: 1
    },
    /*::[*/ 0x0035: {
        T: -1
    },
    /*::[*/ 0x0036: {
        T: 1
    },
    /*::[*/ 0x0037: {
        T: -1
    },
    /*::[*/ 0x0038: {
        T: 1
    },
    /*::[*/ 0x0039: {
        T: -1
    },
    /*::[*/ 0x003A: {},
    /*::[*/ 0x003B: {},
    /*::[*/ 0x003C: {
        f: $a1a91b25d7598376$var$parse_ColInfo
    },
    /*::[*/ 0x003E: {
        f: $a1a91b25d7598376$var$parse_BrtCellRString
    },
    /*::[*/ 0x003F: {
        f: $a1a91b25d7598376$var$parse_BrtCalcChainItem$
    },
    /*::[*/ 0x0040: {
        f: $a1a91b25d7598376$var$parse_BrtDVal
    },
    /*::[*/ 0x0041: {},
    /*::[*/ 0x0042: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {},
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0046: {},
    /*::[*/ 0x0080: {},
    /*::[*/ 0x0081: {
        T: 1
    },
    /*::[*/ 0x0082: {
        T: -1
    },
    /*::[*/ 0x0083: {
        T: 1,
        f: $a1a91b25d7598376$var$parsenoop,
        p: 0
    },
    /*::[*/ 0x0084: {
        T: -1
    },
    /*::[*/ 0x0085: {
        T: 1
    },
    /*::[*/ 0x0086: {
        T: -1
    },
    /*::[*/ 0x0087: {
        T: 1
    },
    /*::[*/ 0x0088: {
        T: -1
    },
    /*::[*/ 0x0089: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginWsView
    },
    /*::[*/ 0x008A: {
        T: -1
    },
    /*::[*/ 0x008B: {
        T: 1
    },
    /*::[*/ 0x008C: {
        T: -1
    },
    /*::[*/ 0x008D: {
        T: 1
    },
    /*::[*/ 0x008E: {
        T: -1
    },
    /*::[*/ 0x008F: {
        T: 1
    },
    /*::[*/ 0x0090: {
        T: -1
    },
    /*::[*/ 0x0091: {
        T: 1
    },
    /*::[*/ 0x0092: {
        T: -1
    },
    /*::[*/ 0x0093: {
        f: $a1a91b25d7598376$var$parse_BrtWsProp
    },
    /*::[*/ 0x0094: {
        f: $a1a91b25d7598376$var$parse_BrtWsDim,
        p: 16
    },
    /*::[*/ 0x0097: {
        f: $a1a91b25d7598376$var$parse_BrtPane
    },
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {
        f: $a1a91b25d7598376$var$parse_BrtWbProp
    },
    /*::[*/ 0x009A: {},
    /*::[*/ 0x009B: {},
    /*::[*/ 0x009C: {
        f: $a1a91b25d7598376$var$parse_BrtBundleSh
    },
    /*::[*/ 0x009D: {},
    /*::[*/ 0x009E: {},
    /*::[*/ 0x009F: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginSst
    },
    /*::[*/ 0x00A0: {
        T: -1
    },
    /*::[*/ 0x00A1: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_UncheckedRfX
    },
    /*::[*/ 0x00A2: {
        T: -1
    },
    /*::[*/ 0x00A3: {
        T: 1
    },
    /*::[*/ 0x00A4: {
        T: -1
    },
    /*::[*/ 0x00A5: {
        T: 1
    },
    /*::[*/ 0x00A6: {
        T: -1
    },
    /*::[*/ 0x00A7: {},
    /*::[*/ 0x00A8: {},
    /*::[*/ 0x00A9: {},
    /*::[*/ 0x00AA: {},
    /*::[*/ 0x00AB: {},
    /*::[*/ 0x00AC: {
        T: 1
    },
    /*::[*/ 0x00AD: {
        T: -1
    },
    /*::[*/ 0x00AE: {},
    /*::[*/ 0x00AF: {},
    /*::[*/ 0x00B0: {
        f: $a1a91b25d7598376$var$parse_BrtMergeCell
    },
    /*::[*/ 0x00B1: {
        T: 1
    },
    /*::[*/ 0x00B2: {
        T: -1
    },
    /*::[*/ 0x00B3: {
        T: 1
    },
    /*::[*/ 0x00B4: {
        T: -1
    },
    /*::[*/ 0x00B5: {
        T: 1
    },
    /*::[*/ 0x00B6: {
        T: -1
    },
    /*::[*/ 0x00B7: {
        T: 1
    },
    /*::[*/ 0x00B8: {
        T: -1
    },
    /*::[*/ 0x00B9: {
        T: 1
    },
    /*::[*/ 0x00BA: {
        T: -1
    },
    /*::[*/ 0x00BB: {
        T: 1
    },
    /*::[*/ 0x00BC: {
        T: -1
    },
    /*::[*/ 0x00BD: {
        T: 1
    },
    /*::[*/ 0x00BE: {
        T: -1
    },
    /*::[*/ 0x00BF: {
        T: 1
    },
    /*::[*/ 0x00C0: {
        T: -1
    },
    /*::[*/ 0x00C1: {
        T: 1
    },
    /*::[*/ 0x00C2: {
        T: -1
    },
    /*::[*/ 0x00C3: {
        T: 1
    },
    /*::[*/ 0x00C4: {
        T: -1
    },
    /*::[*/ 0x00C5: {
        T: 1
    },
    /*::[*/ 0x00C6: {
        T: -1
    },
    /*::[*/ 0x00C7: {
        T: 1
    },
    /*::[*/ 0x00C8: {
        T: -1
    },
    /*::[*/ 0x00C9: {
        T: 1
    },
    /*::[*/ 0x00CA: {
        T: -1
    },
    /*::[*/ 0x00CB: {
        T: 1
    },
    /*::[*/ 0x00CC: {
        T: -1
    },
    /*::[*/ 0x00CD: {
        T: 1
    },
    /*::[*/ 0x00CE: {
        T: -1
    },
    /*::[*/ 0x00CF: {
        T: 1
    },
    /*::[*/ 0x00D0: {
        T: -1
    },
    /*::[*/ 0x00D1: {
        T: 1
    },
    /*::[*/ 0x00D2: {
        T: -1
    },
    /*::[*/ 0x00D3: {
        T: 1
    },
    /*::[*/ 0x00D4: {
        T: -1
    },
    /*::[*/ 0x00D5: {
        T: 1
    },
    /*::[*/ 0x00D6: {
        T: -1
    },
    /*::[*/ 0x00D7: {
        T: 1
    },
    /*::[*/ 0x00D8: {
        T: -1
    },
    /*::[*/ 0x00D9: {
        T: 1
    },
    /*::[*/ 0x00DA: {
        T: -1
    },
    /*::[*/ 0x00DB: {
        T: 1
    },
    /*::[*/ 0x00DC: {
        T: -1
    },
    /*::[*/ 0x00DD: {
        T: 1
    },
    /*::[*/ 0x00DE: {
        T: -1
    },
    /*::[*/ 0x00DF: {
        T: 1
    },
    /*::[*/ 0x00E0: {
        T: -1
    },
    /*::[*/ 0x00E1: {
        T: 1
    },
    /*::[*/ 0x00E2: {
        T: -1
    },
    /*::[*/ 0x00E3: {
        T: 1
    },
    /*::[*/ 0x00E4: {
        T: -1
    },
    /*::[*/ 0x00E5: {
        T: 1
    },
    /*::[*/ 0x00E6: {
        T: -1
    },
    /*::[*/ 0x00E7: {
        T: 1
    },
    /*::[*/ 0x00E8: {
        T: -1
    },
    /*::[*/ 0x00E9: {
        T: 1
    },
    /*::[*/ 0x00EA: {
        T: -1
    },
    /*::[*/ 0x00EB: {
        T: 1
    },
    /*::[*/ 0x00EC: {
        T: -1
    },
    /*::[*/ 0x00ED: {
        T: 1
    },
    /*::[*/ 0x00EE: {
        T: -1
    },
    /*::[*/ 0x00EF: {
        T: 1
    },
    /*::[*/ 0x00F0: {
        T: -1
    },
    /*::[*/ 0x00F1: {
        T: 1
    },
    /*::[*/ 0x00F2: {
        T: -1
    },
    /*::[*/ 0x00F3: {
        T: 1
    },
    /*::[*/ 0x00F4: {
        T: -1
    },
    /*::[*/ 0x00F5: {
        T: 1
    },
    /*::[*/ 0x00F6: {
        T: -1
    },
    /*::[*/ 0x00F7: {
        T: 1
    },
    /*::[*/ 0x00F8: {
        T: -1
    },
    /*::[*/ 0x00F9: {
        T: 1
    },
    /*::[*/ 0x00FA: {
        T: -1
    },
    /*::[*/ 0x00FB: {
        T: 1
    },
    /*::[*/ 0x00FC: {
        T: -1
    },
    /*::[*/ 0x00FD: {
        T: 1
    },
    /*::[*/ 0x00FE: {
        T: -1
    },
    /*::[*/ 0x00FF: {
        T: 1
    },
    /*::[*/ 0x0100: {
        T: -1
    },
    /*::[*/ 0x0101: {
        T: 1
    },
    /*::[*/ 0x0102: {
        T: -1
    },
    /*::[*/ 0x0103: {
        T: 1
    },
    /*::[*/ 0x0104: {
        T: -1
    },
    /*::[*/ 0x0105: {
        T: 1
    },
    /*::[*/ 0x0106: {
        T: -1
    },
    /*::[*/ 0x0107: {
        T: 1
    },
    /*::[*/ 0x0108: {
        T: -1
    },
    /*::[*/ 0x0109: {
        T: 1
    },
    /*::[*/ 0x010A: {
        T: -1
    },
    /*::[*/ 0x010B: {
        T: 1
    },
    /*::[*/ 0x010C: {
        T: -1
    },
    /*::[*/ 0x010D: {
        T: 1
    },
    /*::[*/ 0x010E: {
        T: -1
    },
    /*::[*/ 0x010F: {
        T: 1
    },
    /*::[*/ 0x0110: {
        T: -1
    },
    /*::[*/ 0x0111: {
        T: 1
    },
    /*::[*/ 0x0112: {
        T: -1
    },
    /*::[*/ 0x0113: {
        T: 1
    },
    /*::[*/ 0x0114: {
        T: -1
    },
    /*::[*/ 0x0115: {},
    /*::[*/ 0x0116: {
        T: 1
    },
    /*::[*/ 0x0117: {
        T: -1
    },
    /*::[*/ 0x0118: {
        T: 1
    },
    /*::[*/ 0x0119: {
        T: -1
    },
    /*::[*/ 0x011A: {
        T: 1
    },
    /*::[*/ 0x011B: {
        T: 1
    },
    /*::[*/ 0x011C: {
        T: -1
    },
    /*::[*/ 0x011D: {
        T: 1
    },
    /*::[*/ 0x011E: {
        T: -1
    },
    /*::[*/ 0x011F: {
        T: 1
    },
    /*::[*/ 0x0120: {
        T: -1
    },
    /*::[*/ 0x0121: {
        T: 1
    },
    /*::[*/ 0x0122: {
        T: -1
    },
    /*::[*/ 0x0123: {
        T: 1
    },
    /*::[*/ 0x0124: {
        T: -1
    },
    /*::[*/ 0x0125: {
        T: 1
    },
    /*::[*/ 0x0126: {
        T: -1
    },
    /*::[*/ 0x0127: {
        T: 1
    },
    /*::[*/ 0x0128: {
        T: -1
    },
    /*::[*/ 0x0129: {
        T: 1
    },
    /*::[*/ 0x012A: {
        T: -1
    },
    /*::[*/ 0x012B: {
        T: 1
    },
    /*::[*/ 0x012C: {
        T: -1
    },
    /*::[*/ 0x012D: {
        T: 1
    },
    /*::[*/ 0x012E: {
        T: -1
    },
    /*::[*/ 0x012F: {
        T: 1
    },
    /*::[*/ 0x0130: {
        T: -1
    },
    /*::[*/ 0x0131: {
        T: 1
    },
    /*::[*/ 0x0132: {
        T: -1
    },
    /*::[*/ 0x0133: {
        T: 1
    },
    /*::[*/ 0x0134: {
        T: -1
    },
    /*::[*/ 0x0135: {
        T: 1
    },
    /*::[*/ 0x0136: {
        T: -1
    },
    /*::[*/ 0x0137: {
        T: 1
    },
    /*::[*/ 0x0138: {
        T: -1
    },
    /*::[*/ 0x0139: {
        T: -1
    },
    /*::[*/ 0x013A: {
        T: 1
    },
    /*::[*/ 0x013B: {
        T: -1
    },
    /*::[*/ 0x013C: {
        T: 1
    },
    /*::[*/ 0x013D: {
        T: -1
    },
    /*::[*/ 0x013E: {
        T: 1
    },
    /*::[*/ 0x013F: {
        T: -1
    },
    /*::[*/ 0x0140: {
        T: 1
    },
    /*::[*/ 0x0141: {
        T: -1
    },
    /*::[*/ 0x0142: {
        T: 1
    },
    /*::[*/ 0x0143: {
        T: -1
    },
    /*::[*/ 0x0144: {
        T: 1
    },
    /*::[*/ 0x0145: {
        T: -1
    },
    /*::[*/ 0x0146: {
        T: 1
    },
    /*::[*/ 0x0147: {
        T: -1
    },
    /*::[*/ 0x0148: {
        T: 1
    },
    /*::[*/ 0x0149: {
        T: -1
    },
    /*::[*/ 0x014A: {
        T: 1
    },
    /*::[*/ 0x014B: {
        T: -1
    },
    /*::[*/ 0x014C: {
        T: 1
    },
    /*::[*/ 0x014D: {
        T: -1
    },
    /*::[*/ 0x014E: {
        T: 1
    },
    /*::[*/ 0x014F: {
        f: $a1a91b25d7598376$var$parse_BrtMdtinfo
    },
    /*::[*/ 0x0150: {
        T: -1
    },
    /*::[*/ 0x0151: {
        f: $a1a91b25d7598376$var$parse_BrtBeginEsmdb,
        T: 1
    },
    /*::[*/ 0x0152: {
        T: -1
    },
    /*::[*/ 0x0153: {
        T: 1
    },
    /*::[*/ 0x0154: {
        T: -1
    },
    /*::[*/ 0x0155: {
        T: 1
    },
    /*::[*/ 0x0156: {
        T: -1
    },
    /*::[*/ 0x0157: {
        T: 1
    },
    /*::[*/ 0x0158: {
        T: -1
    },
    /*::[*/ 0x0159: {
        T: 1
    },
    /*::[*/ 0x015A: {
        T: -1
    },
    /*::[*/ 0x015B: {
        T: 1
    },
    /*::[*/ 0x015C: {
        T: -1
    },
    /*::[*/ 0x015D: {
        T: 1
    },
    /*::[*/ 0x015E: {
        T: -1
    },
    /*::[*/ 0x015F: {},
    /*::[*/ 0x0160: {},
    /*::[*/ 0x0161: {
        T: 1
    },
    /*::[*/ 0x0162: {
        T: -1
    },
    /*::[*/ 0x0163: {
        f: $a1a91b25d7598376$var$parse_RelID
    },
    /*::[*/ 0x0165: {},
    /*::[*/ 0x0166: {},
    /*::[*/ 0x0167: {},
    /*::[*/ 0x0168: {
        T: 1
    },
    /*::[*/ 0x0169: {},
    /*::[*/ 0x016A: {
        f: $a1a91b25d7598376$var$parse_ExternSheet
    },
    /*::[*/ 0x016B: {},
    /*::[*/ 0x016C: {},
    /*::[*/ 0x016E: {},
    /*::[*/ 0x016F: {},
    /*::[*/ 0x0170: {},
    /*::[*/ 0x0171: {},
    /*::[*/ 0x0172: {},
    /*::[*/ 0x0173: {},
    /*::[*/ 0x0174: {
        T: 1
    },
    /*::[*/ 0x0175: {
        T: -1
    },
    /*::[*/ 0x0176: {
        T: 1
    },
    /*::[*/ 0x0177: {
        T: -1
    },
    /*::[*/ 0x0178: {
        T: 1
    },
    /*::[*/ 0x0179: {
        T: -1
    },
    /*::[*/ 0x017A: {
        T: 1
    },
    /*::[*/ 0x017B: {
        T: -1
    },
    /*::[*/ 0x017C: {
        T: 1
    },
    /*::[*/ 0x017D: {
        T: -1
    },
    /*::[*/ 0x017E: {
        T: 1
    },
    /*::[*/ 0x017F: {
        T: -1
    },
    /*::[*/ 0x0180: {
        T: 1
    },
    /*::[*/ 0x0181: {
        T: -1
    },
    /*::[*/ 0x0182: {
        T: 1
    },
    /*::[*/ 0x0183: {
        T: -1
    },
    /*::[*/ 0x0184: {
        T: 1
    },
    /*::[*/ 0x0185: {
        T: -1
    },
    /*::[*/ 0x0186: {
        T: 1
    },
    /*::[*/ 0x0187: {
        T: -1
    },
    /*::[*/ 0x0188: {
        T: 1
    },
    /*::[*/ 0x0189: {
        T: -1
    },
    /*::[*/ 0x018A: {
        T: 1
    },
    /*::[*/ 0x018B: {
        T: -1
    },
    /*::[*/ 0x018C: {},
    /*::[*/ 0x018D: {},
    /*::[*/ 0x018E: {},
    /*::[*/ 0x018F: {},
    /*::[*/ 0x0190: {},
    /*::[*/ 0x0191: {
        T: 1
    },
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x0199: {},
    /*::[*/ 0x019A: {},
    /*::[*/ 0x019B: {},
    /*::[*/ 0x019C: {},
    /*::[*/ 0x019D: {},
    /*::[*/ 0x019E: {},
    /*::[*/ 0x019F: {},
    /*::[*/ 0x01A0: {},
    /*::[*/ 0x01A1: {},
    /*::[*/ 0x01A2: {},
    /*::[*/ 0x01A3: {},
    /*::[*/ 0x01A4: {},
    /*::[*/ 0x01A5: {},
    /*::[*/ 0x01A6: {
        T: 1
    },
    /*::[*/ 0x01A7: {
        T: 1
    },
    /*::[*/ 0x01A8: {
        T: -1
    },
    /*::[*/ 0x01A9: {
        T: -1
    },
    /*::[*/ 0x01AA: {
        f: $a1a91b25d7598376$var$parse_BrtArrFmla
    },
    /*::[*/ 0x01AB: {
        f: $a1a91b25d7598376$var$parse_BrtShrFmla
    },
    /*::[*/ 0x01AC: {},
    /*::[*/ 0x01AD: {
        T: 1
    },
    /*::[*/ 0x01AE: {
        T: -1
    },
    /*::[*/ 0x01AF: {
        T: 1
    },
    /*::[*/ 0x01B0: {
        T: -1
    },
    /*::[*/ 0x01B1: {
        T: 1
    },
    /*::[*/ 0x01B2: {
        T: -1
    },
    /*::[*/ 0x01B3: {
        T: 1
    },
    /*::[*/ 0x01B4: {
        T: -1
    },
    /*::[*/ 0x01B5: {
        T: 1
    },
    /*::[*/ 0x01B6: {
        T: -1
    },
    /*::[*/ 0x01B7: {
        T: 1
    },
    /*::[*/ 0x01B8: {
        T: -1
    },
    /*::[*/ 0x01B9: {
        T: 1
    },
    /*::[*/ 0x01BA: {
        T: -1
    },
    /*::[*/ 0x01BB: {
        T: 1
    },
    /*::[*/ 0x01BC: {
        T: -1
    },
    /*::[*/ 0x01BD: {
        T: 1
    },
    /*::[*/ 0x01BE: {
        T: -1
    },
    /*::[*/ 0x01BF: {
        T: 1
    },
    /*::[*/ 0x01C0: {
        T: -1
    },
    /*::[*/ 0x01C1: {
        T: 1
    },
    /*::[*/ 0x01C2: {
        T: -1
    },
    /*::[*/ 0x01C3: {
        T: 1
    },
    /*::[*/ 0x01C4: {
        T: -1
    },
    /*::[*/ 0x01C5: {
        T: 1
    },
    /*::[*/ 0x01C6: {
        T: -1
    },
    /*::[*/ 0x01C7: {
        T: 1
    },
    /*::[*/ 0x01C8: {
        T: -1
    },
    /*::[*/ 0x01C9: {
        T: 1
    },
    /*::[*/ 0x01CA: {
        T: -1
    },
    /*::[*/ 0x01CB: {
        T: 1
    },
    /*::[*/ 0x01CC: {
        T: -1
    },
    /*::[*/ 0x01CD: {
        T: 1
    },
    /*::[*/ 0x01CE: {
        T: -1
    },
    /*::[*/ 0x01CF: {
        T: 1
    },
    /*::[*/ 0x01D0: {
        T: -1
    },
    /*::[*/ 0x01D1: {
        T: 1
    },
    /*::[*/ 0x01D2: {
        T: -1
    },
    /*::[*/ 0x01D3: {
        T: 1
    },
    /*::[*/ 0x01D4: {
        T: -1
    },
    /*::[*/ 0x01D5: {
        T: 1
    },
    /*::[*/ 0x01D6: {
        T: -1
    },
    /*::[*/ 0x01D7: {},
    /*::[*/ 0x01D8: {},
    /*::[*/ 0x01D9: {
        T: 1
    },
    /*::[*/ 0x01DA: {
        T: -1
    },
    /*::[*/ 0x01DB: {},
    /*::[*/ 0x01DC: {
        f: $a1a91b25d7598376$var$parse_BrtMargins
    },
    /*::[*/ 0x01DD: {},
    /*::[*/ 0x01DE: {},
    /*::[*/ 0x01DF: {
        T: 1
    },
    /*::[*/ 0x01E0: {
        T: -1
    },
    /*::[*/ 0x01E1: {
        T: 1
    },
    /*::[*/ 0x01E2: {
        T: -1
    },
    /*::[*/ 0x01E3: {
        T: 1
    },
    /*::[*/ 0x01E4: {
        T: -1
    },
    /*::[*/ 0x01E5: {
        f: $a1a91b25d7598376$var$parse_BrtWsFmtInfo
    },
    /*::[*/ 0x01E6: {
        T: 1
    },
    /*::[*/ 0x01E7: {
        T: -1
    },
    /*::[*/ 0x01E8: {
        T: 1
    },
    /*::[*/ 0x01E9: {
        T: -1
    },
    /*::[*/ 0x01EA: {
        T: 1
    },
    /*::[*/ 0x01EB: {
        T: -1
    },
    /*::[*/ 0x01EC: {
        T: 1
    },
    /*::[*/ 0x01ED: {
        T: -1
    },
    /*::[*/ 0x01EE: {
        f: $a1a91b25d7598376$var$parse_BrtHLink
    },
    /*::[*/ 0x01EF: {
        T: 1
    },
    /*::[*/ 0x01F0: {
        T: -1
    },
    /*::[*/ 0x01F1: {
        T: 1
    },
    /*::[*/ 0x01F2: {
        T: -1
    },
    /*::[*/ 0x01F3: {},
    /*::[*/ 0x01F4: {
        T: 1
    },
    /*::[*/ 0x01F5: {
        T: -1
    },
    /*::[*/ 0x01F6: {
        T: 1
    },
    /*::[*/ 0x01F7: {
        T: -1
    },
    /*::[*/ 0x01F8: {},
    /*::[*/ 0x01F9: {
        T: 1
    },
    /*::[*/ 0x01FA: {
        T: -1
    },
    /*::[*/ 0x01FB: {},
    /*::[*/ 0x01FC: {
        T: 1
    },
    /*::[*/ 0x01FD: {
        T: -1
    },
    /*::[*/ 0x01FE: {
        T: 1
    },
    /*::[*/ 0x01FF: {
        T: -1
    },
    /*::[*/ 0x0200: {},
    /*::[*/ 0x0201: {},
    /*::[*/ 0x0202: {
        T: 1
    },
    /*::[*/ 0x0203: {
        T: -1
    },
    /*::[*/ 0x0204: {
        T: 1
    },
    /*::[*/ 0x0205: {
        T: -1
    },
    /*::[*/ 0x0206: {
        T: 1
    },
    /*::[*/ 0x0207: {
        T: -1
    },
    /*::[*/ 0x0208: {
        T: 1
    },
    /*::[*/ 0x0209: {
        T: -1
    },
    /*::[*/ 0x020A: {},
    /*::[*/ 0x020B: {},
    /*::[*/ 0x020C: {},
    /*::[*/ 0x020D: {},
    /*::[*/ 0x020E: {},
    /*::[*/ 0x020F: {},
    /*::[*/ 0x0210: {
        T: 1
    },
    /*::[*/ 0x0211: {
        T: -1
    },
    /*::[*/ 0x0212: {
        T: 1
    },
    /*::[*/ 0x0213: {
        T: -1
    },
    /*::[*/ 0x0214: {
        T: 1
    },
    /*::[*/ 0x0215: {
        T: -1
    },
    /*::[*/ 0x0216: {},
    /*::[*/ 0x0217: {},
    /*::[*/ 0x0218: {},
    /*::[*/ 0x0219: {},
    /*::[*/ 0x021A: {
        T: 1
    },
    /*::[*/ 0x021B: {
        T: -1
    },
    /*::[*/ 0x021C: {
        T: 1
    },
    /*::[*/ 0x021D: {
        T: -1
    },
    /*::[*/ 0x021E: {
        T: 1
    },
    /*::[*/ 0x0224: {},
    /*::[*/ 0x0225: {},
    /*::[*/ 0x0226: {
        f: $a1a91b25d7598376$var$parse_RelID
    },
    /*::[*/ 0x0227: {},
    /*::[*/ 0x0228: {},
    /*::[*/ 0x0229: {},
    /*::[*/ 0x022A: {
        T: 1
    },
    /*::[*/ 0x022B: {
        T: -1
    },
    /*::[*/ 0x022C: {
        T: 1
    },
    /*::[*/ 0x022D: {
        T: -1
    },
    /*::[*/ 0x022E: {
        T: 1
    },
    /*::[*/ 0x022F: {
        T: -1
    },
    /*::[*/ 0x0230: {
        T: 1
    },
    /*::[*/ 0x0231: {
        T: -1
    },
    /*::[*/ 0x0232: {},
    /*::[*/ 0x0234: {},
    /*::[*/ 0x0235: {
        T: 1
    },
    /*::[*/ 0x0236: {
        T: -1
    },
    /*::[*/ 0x0239: {
        T: 1
    },
    /*::[*/ 0x023A: {
        T: -1
    },
    /*::[*/ 0x023C: {},
    /*::[*/ 0x023D: {
        T: 1
    },
    /*::[*/ 0x023E: {
        T: -1
    },
    /*::[*/ 0x0241: {},
    /*::[*/ 0x0242: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0244: {},
    /*::[*/ 0x0245: {},
    /*::[*/ 0x0246: {},
    /*::[*/ 0x0247: {},
    /*::[*/ 0x0248: {},
    /*::[*/ 0x0249: {},
    /*::[*/ 0x024A: {},
    /*::[*/ 0x024B: {},
    /*::[*/ 0x024C: {
        T: -1
    },
    /*::[*/ 0x024D: {},
    /*::[*/ 0x024E: {
        T: 1
    },
    /*::[*/ 0x024F: {
        T: -1
    },
    /*::[*/ 0x0250: {
        T: 1
    },
    /*::[*/ 0x0251: {
        T: -1
    },
    /*::[*/ 0x0252: {
        T: 1
    },
    /*::[*/ 0x0253: {
        T: -1
    },
    /*::[*/ 0x0254: {},
    /*::[*/ 0x0255: {
        T: 1
    },
    /*::[*/ 0x0256: {
        T: -1
    },
    /*::[*/ 0x0257: {
        T: 1
    },
    /*::[*/ 0x0258: {
        T: -1
    },
    /*::[*/ 0x0259: {
        T: 1
    },
    /*::[*/ 0x025A: {
        T: -1
    },
    /*::[*/ 0x025B: {
        T: 1
    },
    /*::[*/ 0x025C: {
        T: -1
    },
    /*::[*/ 0x025D: {
        T: 1
    },
    /*::[*/ 0x025E: {
        T: -1
    },
    /*::[*/ 0x025F: {},
    /*::[*/ 0x0260: {
        T: 1
    },
    /*::[*/ 0x0261: {
        T: -1
    },
    /*::[*/ 0x0262: {},
    /*::[*/ 0x0263: {
        T: 1
    },
    /*::[*/ 0x0264: {
        T: -1
    },
    /*::[*/ 0x0265: {
        T: 1
    },
    /*::[*/ 0x0266: {
        T: -1
    },
    /*::[*/ 0x0267: {
        T: 1
    },
    /*::[*/ 0x0268: {
        T: -1
    },
    /*::[*/ 0x0269: {
        T: 1
    },
    /*::[*/ 0x026A: {
        T: -1
    },
    /*::[*/ 0x026B: {
        T: 1
    },
    /*::[*/ 0x026C: {
        T: -1
    },
    /*::[*/ 0x0271: {},
    /*::[*/ 0x0272: {
        T: 1
    },
    /*::[*/ 0x0273: {
        T: -1
    },
    /*::[*/ 0x0274: {
        T: 1
    },
    /*::[*/ 0x0275: {
        T: -1
    },
    /*::[*/ 0x0276: {
        T: 1
    },
    /*::[*/ 0x0277: {
        T: -1
    },
    /*::[*/ 0x0278: {
        f: $a1a91b25d7598376$var$parse_BrtCommentAuthor
    },
    /*::[*/ 0x0279: {
        T: 1
    },
    /*::[*/ 0x027A: {
        T: -1
    },
    /*::[*/ 0x027B: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginComment
    },
    /*::[*/ 0x027C: {
        T: -1
    },
    /*::[*/ 0x027D: {
        f: $a1a91b25d7598376$var$parse_BrtCommentText
    },
    /*::[*/ 0x027E: {
        T: 1
    },
    /*::[*/ 0x027F: {},
    /*::[*/ 0x0280: {
        T: -1
    },
    /*::[*/ 0x0281: {
        T: 1
    },
    /*::[*/ 0x0282: {
        T: -1
    },
    /*::[*/ 0x0283: {
        T: 1
    },
    /*::[*/ 0x0284: {},
    /*::[*/ 0x0285: {
        T: -1
    },
    /*::[*/ 0x0286: {
        T: 1
    },
    /*::[*/ 0x0288: {
        T: 1
    },
    /*::[*/ 0x0289: {},
    /*::[*/ 0x028A: {
        T: -1
    },
    /*::[*/ 0x028B: {
        f: $a1a91b25d7598376$var$parse_BrtCsProp
    },
    /*::[*/ 0x028C: {},
    /*::[*/ 0x028D: {
        T: 1
    },
    /*::[*/ 0x028E: {
        T: -1
    },
    /*::[*/ 0x028F: {
        T: 1
    },
    /*::[*/ 0x0290: {
        T: -1
    },
    /*::[*/ 0x0291: {
        T: 1
    },
    /*::[*/ 0x0292: {
        T: -1
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0294: {
        T: 1
    },
    /*::[*/ 0x0295: {},
    /*::[*/ 0x0296: {
        T: -1
    },
    /*::[*/ 0x0297: {},
    /*::[*/ 0x0298: {
        T: 1
    },
    /*::[*/ 0x0299: {},
    /*::[*/ 0x029A: {
        T: -1
    },
    /*::[*/ 0x029B: {},
    /*::[*/ 0x029C: {},
    /*::[*/ 0x029D: {},
    /*::[*/ 0x029F: {
        T: 1
    },
    /*::[*/ 0x02A0: {
        T: -1
    },
    /*::[*/ 0x02A1: {
        T: 1
    },
    /*::[*/ 0x02A2: {
        T: -1
    },
    /*::[*/ 0x02A3: {},
    /*::[*/ 0x02A4: {},
    /*::[*/ 0x02A5: {},
    /*::[*/ 0x02A6: {},
    /*::[*/ 0x02A7: {},
    /*::[*/ 0x02A8: {},
    /*::[*/ 0x02A9: {},
    /*::[*/ 0x0400: {},
    /*::[*/ 0x0401: {},
    /*::[*/ 0x0402: {
        T: 1
    },
    /*::[*/ 0x0403: {
        T: -1
    },
    /*::[*/ 0x0404: {
        T: 1
    },
    /*::[*/ 0x0405: {
        T: -1
    },
    /*::[*/ 0x0406: {},
    /*::[*/ 0x0407: {
        T: 1
    },
    /*::[*/ 0x0408: {
        T: -1
    },
    /*::[*/ 0x0409: {
        T: 1
    },
    /*::[*/ 0x040A: {
        T: -1
    },
    /*::[*/ 0x040B: {},
    /*::[*/ 0x040C: {},
    /*::[*/ 0x040D: {},
    /*::[*/ 0x040E: {
        T: 1
    },
    /*::[*/ 0x040F: {
        T: -1
    },
    /*::[*/ 0x0410: {},
    /*::[*/ 0x0411: {
        T: 1
    },
    /*::[*/ 0x0412: {
        T: -1
    },
    /*::[*/ 0x0413: {},
    /*::[*/ 0x0414: {},
    /*::[*/ 0x0415: {},
    /*::[*/ 0x0416: {
        T: 1
    },
    /*::[*/ 0x0417: {
        T: -1
    },
    /*::[*/ 0x0418: {
        T: 1
    },
    /*::[*/ 0x0419: {
        T: -1
    },
    /*::[*/ 0x041A: {},
    /*::[*/ 0x041B: {
        T: 1
    },
    /*::[*/ 0x041C: {
        T: 1
    },
    /*::[*/ 0x041D: {
        f: $a1a91b25d7598376$var$parse_BrtDVal14
    },
    /*::[*/ 0x041E: {
        T: 1
    },
    /*::[*/ 0x041F: {},
    /*::[*/ 0x0420: {
        T: 1
    },
    /*::[*/ 0x0421: {
        T: -1
    },
    /*::[*/ 0x0422: {
        T: 1
    },
    /*::[*/ 0x0423: {
        T: -1
    },
    /*::[*/ 0x0425: {},
    /*::[*/ 0x0426: {
        T: 1
    },
    /*::[*/ 0x0427: {
        T: -1
    },
    /*::[*/ 0x0428: {
        T: 1
    },
    /*::[*/ 0x0429: {
        T: -1
    },
    /*::[*/ 0x042A: {
        T: 1
    },
    /*::[*/ 0x042B: {
        T: -1
    },
    /*::[*/ 0x042C: {
        T: 1
    },
    /*::[*/ 0x042D: {
        T: -1
    },
    /*::[*/ 0x042E: {
        T: 1
    },
    /*::[*/ 0x042F: {
        T: -1
    },
    /*::[*/ 0x0430: {
        T: 1
    },
    /*::[*/ 0x0431: {
        T: -1
    },
    /*::[*/ 0x0433: {
        T: 1
    },
    /*::[*/ 0x0434: {
        T: -1
    },
    /*::[*/ 0x0435: {
        T: 1
    },
    /*::[*/ 0x0436: {
        T: -1
    },
    /*::[*/ 0x0437: {
        T: 1
    },
    /*::[*/ 0x0438: {
        T: -1
    },
    /*::[*/ 0x0439: {
        T: 1
    },
    /*::[*/ 0x043A: {
        T: -1
    },
    /*::[*/ 0x043B: {
        T: 1
    },
    /*::[*/ 0x043C: {
        T: -1
    },
    /*::[*/ 0x043D: {},
    /*::[*/ 0x043E: {
        T: 1
    },
    /*::[*/ 0x043F: {
        T: -1
    },
    /*::[*/ 0x0440: {
        T: 1
    },
    /*::[*/ 0x0441: {
        T: -1
    },
    /*::[*/ 0x0442: {
        T: 1
    },
    /*::[*/ 0x0443: {
        T: -1
    },
    /*::[*/ 0x0444: {
        T: 1
    },
    /*::[*/ 0x0445: {
        T: -1
    },
    /*::[*/ 0x0446: {
        T: 1
    },
    /*::[*/ 0x0447: {
        T: -1
    },
    /*::[*/ 0x0448: {},
    /*::[*/ 0x0449: {
        T: 1
    },
    /*::[*/ 0x044A: {},
    /*::[*/ 0x044B: {
        T: -1
    },
    /*::[*/ 0x044C: {
        T: 1
    },
    /*::[*/ 0x044D: {
        T: -1
    },
    /*::[*/ 0x044E: {},
    /*::[*/ 0x044F: {},
    /*::[*/ 0x0450: {},
    /*::[*/ 0x0451: {},
    /*::[*/ 0x0457: {},
    /*::[*/ 0x0458: {},
    /*::[*/ 0x0459: {
        T: 1
    },
    /*::[*/ 0x045A: {
        T: -1
    },
    /*::[*/ 0x045B: {
        T: 1
    },
    /*::[*/ 0x045C: {
        T: -1
    },
    /*::[*/ 0x045D: {},
    /*::[*/ 0x045E: {
        T: 1
    },
    /*::[*/ 0x045F: {
        T: -1
    },
    /*::[*/ 0x0460: {
        T: 1
    },
    /*::[*/ 0x0461: {
        T: -1
    },
    /*::[*/ 0x0462: {
        T: 1
    },
    /*::[*/ 0x0463: {
        T: -1
    },
    /*::[*/ 0x0464: {
        T: 1
    },
    /*::[*/ 0x0465: {
        T: -1
    },
    /*::[*/ 0x0466: {},
    /*::[*/ 0x0468: {
        T: 1
    },
    /*::[*/ 0x0469: {
        T: -1
    },
    /*::[*/ 0x046A: {},
    /*::[*/ 0x046B: {
        T: 1
    },
    /*::[*/ 0x046C: {
        T: -1
    },
    /*::[*/ 0x046D: {
        T: 1
    },
    /*::[*/ 0x046E: {
        T: -1
    },
    /*::[*/ 0x046F: {
        T: 1
    },
    /*::[*/ 0x0470: {
        T: -1
    },
    /*::[*/ 0x0471: {
        T: 1
    },
    /*::[*/ 0x0472: {
        T: -1
    },
    /*::[*/ 0x0473: {
        T: 1
    },
    /*::[*/ 0x0474: {
        T: -1
    },
    /*::[*/ 0x0475: {},
    /*::[*/ 0x0476: {
        T: 1
    },
    /*::[*/ 0x0477: {
        T: -1
    },
    /*::[*/ 0x0478: {
        T: 1
    },
    /*::[*/ 0x0479: {
        T: -1
    },
    /*::[*/ 0x047A: {},
    /*::[*/ 0x047B: {
        T: 1
    },
    /*::[*/ 0x047C: {
        T: -1
    },
    /*::[*/ 0x047D: {
        T: 1
    },
    /*::[*/ 0x047E: {
        T: -1
    },
    /*::[*/ 0x0480: {
        T: 1
    },
    /*::[*/ 0x0481: {
        T: -1
    },
    /*::[*/ 0x0482: {
        T: -1
    },
    /*::[*/ 0x0483: {
        T: -1
    },
    /*::[*/ 0x0484: {
        T: -1
    },
    /*::[*/ 0x0485: {
        T: 1
    },
    /*::[*/ 0x0486: {
        T: -1
    },
    /*::[*/ 0x0487: {
        T: 1
    },
    /*::[*/ 0x0488: {
        T: -1
    },
    /*::[*/ 0x0489: {
        T: 1
    },
    /*::[*/ 0x048A: {
        T: -1
    },
    /*::[*/ 0x048B: {
        T: 1
    },
    /*::[*/ 0x048C: {
        T: -1
    },
    /*::[*/ 0x048D: {
        T: 1
    },
    /*::[*/ 0x048E: {
        T: -1
    },
    /*::[*/ 0x048F: {
        T: 1
    },
    /*::[*/ 0x0490: {
        T: -1
    },
    /*::[*/ 0x0491: {
        T: 1
    },
    /*::[*/ 0x0492: {
        T: -1
    },
    /*::[*/ 0x0493: {},
    /*::[*/ 0x0494: {
        T: 1
    },
    /*::[*/ 0x0495: {
        T: -1
    },
    /*::[*/ 0x0499: {},
    /*::[*/ 0x049A: {
        T: 1
    },
    /*::[*/ 0x049C: {},
    /*::[*/ 0x049D: {},
    /*::[*/ 0x049E: {},
    /*::[*/ 0x0800: {
        T: 1
    },
    /*::[*/ 0x0801: {
        T: -1
    },
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {
        T: 1
    },
    /*::[*/ 0x0804: {
        T: -1
    },
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {
        T: 1
    },
    /*::[*/ 0x0808: {
        T: -1
    },
    /*::[*/ 0x0809: {
        T: 1
    },
    /*::[*/ 0x080A: {
        T: -1
    },
    /*::[*/ 0x080C: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0814: {
        T: 1
    },
    /*::[*/ 0x0815: {
        T: -1
    },
    /*::[*/ 0x0816: {},
    /*::[*/ 0x0817: {},
    /*::[*/ 0x0818: {
        T: 1
    },
    /*::[*/ 0x0819: {
        T: -1
    },
    /*::[*/ 0x081B: {},
    /*::[*/ 0x081C: {},
    /*::[*/ 0x081D: {
        T: 1
    },
    /*::[*/ 0x081E: {
        T: -1
    },
    /*::[*/ 0x081F: {},
    /*::[*/ 0x0820: {
        T: 1
    },
    /*::[*/ 0x0821: {
        T: -1
    },
    /*::[*/ 0x0822: {},
    /*::[*/ 0x0823: {
        T: 1
    },
    /*::[*/ 0x0824: {
        T: -1
    },
    /*::[*/ 0x0825: {
        T: 1
    },
    /*::[*/ 0x0826: {
        T: -1
    },
    /*::[*/ 0x0827: {
        T: 1
    },
    /*::[*/ 0x0828: {
        T: -1
    },
    /*::[*/ 0x0829: {
        T: 1
    },
    /*::[*/ 0x082A: {
        T: -1
    },
    /*::[*/ 0x082B: {},
    /*::[*/ 0x082C: {},
    /*::[*/ 0x082D: {
        T: 1
    },
    /*::[*/ 0x082E: {
        T: -1
    },
    /*::[*/ 0x082F: {},
    /*::[*/ 0x0830: {
        T: 1
    },
    /*::[*/ 0x0831: {
        T: -1
    },
    /*::[*/ 0x0832: {
        T: 1
    },
    /*::[*/ 0x0833: {
        T: -1
    },
    /*::[*/ 0x0834: {
        T: 1
    },
    /*::[*/ 0x0835: {
        T: -1
    },
    /*::[*/ 0x0836: {},
    /*::[*/ 0x0837: {
        T: 1
    },
    /*::[*/ 0x0838: {
        T: -1
    },
    /*::[*/ 0x0839: {},
    /*::[*/ 0x083A: {
        T: 1
    },
    /*::[*/ 0x083B: {
        T: -1
    },
    /*::[*/ 0x083C: {},
    /*::[*/ 0x083D: {
        T: 1
    },
    /*::[*/ 0x083E: {
        T: -1
    },
    /*::[*/ 0x083F: {
        T: 1
    },
    /*::[*/ 0x0840: {
        T: -1
    },
    /*::[*/ 0x0841: {
        T: 1
    },
    /*::[*/ 0x0842: {
        T: -1
    },
    /*::[*/ 0x0843: {},
    /*::[*/ 0x0844: {},
    /*::[*/ 0x0845: {},
    /*::[*/ 0x0846: {
        T: 1
    },
    /*::[*/ 0x0847: {
        T: -1
    },
    /*::[*/ 0x0848: {},
    /*::[*/ 0x0849: {
        T: 1
    },
    /*::[*/ 0x084A: {
        T: -1
    },
    /*::[*/ 0x084B: {
        T: 1
    },
    /*::[*/ 0x084C: {
        T: -1
    },
    /*::[*/ 0x084D: {},
    /*::[*/ 0x084E: {
        T: 1
    },
    /*::[*/ 0x084F: {
        T: -1
    },
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {
        T: 1
    },
    /*::[*/ 0x0852: {
        T: -1
    },
    /*::[*/ 0x0853: {
        T: 1
    },
    /*::[*/ 0x0854: {
        T: -1
    },
    /*::[*/ 0x0855: {
        T: 1
    },
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {
        T: 1
    },
    /*::[*/ 0x085A: {
        T: -1
    },
    /*::[*/ 0x085B: {
        T: 1
    },
    /*::[*/ 0x085C: {
        T: -1
    },
    /*::[*/ 0x085D: {},
    /*::[*/ 0x0C00: {},
    /*::[*/ 0x0C01: {},
    /*::[*/ 0x1000: {
        T: 1
    },
    /*::[*/ 0x1001: {
        T: -1
    },
    /*::[*/ 0x138A: {
        T: 1
    },
    /*::[*/ 0x138B: {
        T: -1
    },
    /*::[*/ 0x13D9: {
        T: 1
    },
    /*::[*/ 0x13DA: {
        T: -1
    },
    /*::[*/ 0x13DB: {},
    /*::[*/ 0x13DC: {
        T: 1
    },
    /*::[*/ 0x13DD: {
        T: -1
    },
    /*::[*/ 0x13DE: {
        T: 1
    },
    /*::[*/ 0x13DF: {
        T: -1
    },
    /*::[*/ 0x13E0: {},
    /*::[*/ 0x13E1: {},
    /*::[*/ 0x13E2: {},
    /*::[*/ 0x13E4: {
        T: 1
    },
    /*::[*/ 0x13E5: {
        T: -1
    },
    /*::[*/ 0x13E6: {},
    /*::[*/ 0x13E7: {
        T: 1
    },
    /*::[*/ 0x13E8: {
        T: -1
    },
    /*::[*/ 0x13E9: {},
    /*::[*/ 0x13EB: {},
    /*::[*/ 0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $a1a91b25d7598376$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ /*::[*/ 0x0006: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    /*::[*/ 0x000a: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x000c: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x000d: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x000e: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x000f: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0010: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    /*::[*/ 0x0011: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0012: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0013: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x0014: {
        f: $a1a91b25d7598376$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0015: {
        f: $a1a91b25d7598376$var$parse_XLHeaderFooter
    },
    /*::[*/ 0x0017: {
        f: $a1a91b25d7598376$var$parse_ExternSheet
    },
    /*::[*/ 0x0018: {
        f: $a1a91b25d7598376$var$parse_Lbl
    },
    /*::[*/ 0x0019: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x001a: {},
    /*::[*/ 0x001b: {},
    /*::[*/ 0x001c: {
        f: $a1a91b25d7598376$var$parse_Note
    },
    /*::[*/ 0x001d: {},
    /*::[*/ 0x0022: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0023: {
        f: $a1a91b25d7598376$var$parse_ExternName
    },
    /*::[*/ 0x0026: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    /*::[*/ 0x0027: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    /*::[*/ 0x0028: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    /*::[*/ 0x0029: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    /*::[*/ 0x002a: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x002b: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x002f: {
        f: $a1a91b25d7598376$var$parse_FilePass
    },
    /*::[*/ 0x0031: {
        f: $a1a91b25d7598376$var$parse_Font
    },
    /*::[*/ 0x0033: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x003c: {},
    /*::[*/ 0x003d: {
        f: $a1a91b25d7598376$var$parse_Window1
    },
    /*::[*/ 0x0040: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0041: {
        f: $a1a91b25d7598376$var$parse_Pane
    },
    /*::[*/ 0x0042: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x004d: {},
    /*::[*/ 0x0050: {},
    /*::[*/ 0x0051: {},
    /*::[*/ 0x0052: {},
    /*::[*/ 0x0055: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x0059: {},
    /*::[*/ 0x005a: {},
    /*::[*/ 0x005b: {},
    /*::[*/ 0x005c: {
        f: $a1a91b25d7598376$var$parse_WriteAccess
    },
    /*::[*/ 0x005d: {
        f: $a1a91b25d7598376$var$parse_Obj
    },
    /*::[*/ 0x005e: {},
    /*::[*/ 0x005f: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0060: {},
    /*::[*/ 0x0061: {},
    /*::[*/ 0x0063: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x007d: {
        f: $a1a91b25d7598376$var$parse_ColInfo
    },
    /*::[*/ 0x0080: {
        f: $a1a91b25d7598376$var$parse_Guts
    },
    /*::[*/ 0x0081: {
        f: $a1a91b25d7598376$var$parse_WsBool
    },
    /*::[*/ 0x0082: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x0083: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0084: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0085: {
        f: $a1a91b25d7598376$var$parse_BoundSheet8
    },
    /*::[*/ 0x0086: {},
    /*::[*/ 0x008c: {
        f: $a1a91b25d7598376$var$parse_Country
    },
    /*::[*/ 0x008d: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x0090: {},
    /*::[*/ 0x0092: {
        f: $a1a91b25d7598376$var$parse_Palette
    },
    /*::[*/ 0x0097: {},
    /*::[*/ 0x0098: {},
    /*::[*/ 0x0099: {},
    /*::[*/ 0x009a: {},
    /*::[*/ 0x009b: {},
    /*::[*/ 0x009c: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x009d: {},
    /*::[*/ 0x009e: {},
    /*::[*/ 0x00a0: {
        f: $a1a91b25d7598376$var$parse_Scl
    },
    /*::[*/ 0x00a1: {
        f: $a1a91b25d7598376$var$parse_Setup
    },
    /*::[*/ 0x00ae: {},
    /*::[*/ 0x00af: {},
    /*::[*/ 0x00b0: {},
    /*::[*/ 0x00b1: {},
    /*::[*/ 0x00b2: {},
    /*::[*/ 0x00b4: {},
    /*::[*/ 0x00b5: {},
    /*::[*/ 0x00b6: {},
    /*::[*/ 0x00b8: {},
    /*::[*/ 0x00b9: {},
    /*::[*/ 0x00bd: {
        f: $a1a91b25d7598376$var$parse_MulRk
    },
    /*::[*/ 0x00be: {
        f: $a1a91b25d7598376$var$parse_MulBlank
    },
    /*::[*/ 0x00c1: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x00c5: {},
    /*::[*/ 0x00c6: {},
    /*::[*/ 0x00c7: {},
    /*::[*/ 0x00c8: {},
    /*::[*/ 0x00c9: {},
    /*::[*/ 0x00ca: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x00cb: {},
    /*::[*/ 0x00cc: {},
    /*::[*/ 0x00cd: {},
    /*::[*/ 0x00ce: {},
    /*::[*/ 0x00cf: {},
    /*::[*/ 0x00d0: {},
    /*::[*/ 0x00d1: {},
    /*::[*/ 0x00d2: {},
    /*::[*/ 0x00d3: {},
    /*::[*/ 0x00d5: {},
    /*::[*/ 0x00d7: {},
    /*::[*/ 0x00d8: {},
    /*::[*/ 0x00d9: {},
    /*::[*/ 0x00da: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x00dc: {},
    /*::[*/ 0x00dd: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x00de: {},
    /*::[*/ 0x00e0: {
        f: $a1a91b25d7598376$var$parse_XF
    },
    /*::[*/ 0x00e1: {
        f: $a1a91b25d7598376$var$parse_InterfaceHdr
    },
    /*::[*/ 0x00e2: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x00e3: {},
    /*::[*/ 0x00e5: {
        f: $a1a91b25d7598376$var$parse_MergeCells
    },
    /*::[*/ 0x00e9: {},
    /*::[*/ 0x00eb: {},
    /*::[*/ 0x00ec: {},
    /*::[*/ 0x00ed: {},
    /*::[*/ 0x00ef: {},
    /*::[*/ 0x00f0: {},
    /*::[*/ 0x00f1: {},
    /*::[*/ 0x00f2: {},
    /*::[*/ 0x00f4: {},
    /*::[*/ 0x00f5: {},
    /*::[*/ 0x00f6: {},
    /*::[*/ 0x00f7: {},
    /*::[*/ 0x00f8: {},
    /*::[*/ 0x00f9: {},
    /*::[*/ 0x00fb: {},
    /*::[*/ 0x00fc: {
        f: $a1a91b25d7598376$var$parse_SST
    },
    /*::[*/ 0x00fd: {
        f: $a1a91b25d7598376$var$parse_LabelSst
    },
    /*::[*/ 0x00ff: {
        f: $a1a91b25d7598376$var$parse_ExtSST
    },
    /*::[*/ 0x0100: {},
    /*::[*/ 0x0103: {},
    /*::[*/ 0x0122: {},
    /*::[*/ 0x0137: {},
    /*::[*/ 0x0138: {},
    /*::[*/ 0x013b: {},
    /*::[*/ 0x013d: {
        f: $a1a91b25d7598376$var$parseuint16a
    },
    /*::[*/ 0x013e: {},
    /*::[*/ 0x013f: {},
    /*::[*/ 0x0140: {},
    /*::[*/ 0x014a: {},
    /*::[*/ 0x014b: {},
    /*::[*/ 0x014d: {},
    /*::[*/ 0x014e: {},
    /*::[*/ 0x014f: {},
    /*::[*/ 0x0150: {},
    /*::[*/ 0x0151: {},
    /*::[*/ 0x0152: {},
    /*::[*/ 0x0153: {},
    /*::[*/ 0x0154: {},
    /*::[*/ 0x015f: {},
    /*::[*/ 0x0160: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x0161: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x0191: {},
    /*::[*/ 0x0192: {},
    /*::[*/ 0x0193: {},
    /*::[*/ 0x0194: {},
    /*::[*/ 0x0195: {},
    /*::[*/ 0x0196: {},
    /*::[*/ 0x0197: {},
    /*::[*/ 0x0198: {},
    /*::[*/ 0x01a9: {},
    /*::[*/ 0x01aa: {},
    /*::[*/ 0x01ab: {},
    /*::[*/ 0x01ac: {},
    /*::[*/ 0x01ad: {},
    /*::[*/ 0x01ae: {
        f: $a1a91b25d7598376$var$parse_SupBook
    },
    /*::[*/ 0x01af: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x01b0: {},
    /*::[*/ 0x01b1: {},
    /*::[*/ 0x01b2: {},
    /*::[*/ 0x01b5: {},
    /*::[*/ 0x01b6: {
        f: $a1a91b25d7598376$var$parse_TxO
    },
    /*::[*/ 0x01b7: {
        f: $a1a91b25d7598376$var$parsebool
    },
    /*::[*/ 0x01b8: {
        f: $a1a91b25d7598376$var$parse_HLink
    },
    /*::[*/ 0x01b9: {},
    /*::[*/ 0x01ba: {
        f: $a1a91b25d7598376$var$parse_XLUnicodeString
    },
    /*::[*/ 0x01bb: {},
    /*::[*/ 0x01bc: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x01bd: {},
    /*::[*/ 0x01be: {},
    /*::[*/ 0x01c0: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x01c1: {
        f: $a1a91b25d7598376$var$parse_RecalcId,
        r: 2
    },
    /*::[*/ 0x01c2: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x0200: {
        f: $a1a91b25d7598376$var$parse_Dimensions
    },
    /*::[*/ 0x0201: {
        f: $a1a91b25d7598376$var$parse_Blank
    },
    /*::[*/ 0x0203: {
        f: $a1a91b25d7598376$var$parse_Number
    },
    /*::[*/ 0x0204: {
        f: $a1a91b25d7598376$var$parse_Label
    },
    /*::[*/ 0x0205: {
        f: $a1a91b25d7598376$var$parse_BoolErr
    },
    /*::[*/ 0x0207: {
        f: $a1a91b25d7598376$var$parse_String
    },
    /*::[*/ 0x0208: {
        f: $a1a91b25d7598376$var$parse_Row
    },
    /*::[*/ 0x020b: {},
    /*::[*/ 0x0221: {
        f: $a1a91b25d7598376$var$parse_Array
    },
    /*::[*/ 0x0225: {
        f: $a1a91b25d7598376$var$parse_DefaultRowHeight
    },
    /*::[*/ 0x0236: {},
    /*::[*/ 0x023e: {
        f: $a1a91b25d7598376$var$parse_Window2
    },
    /*::[*/ 0x027e: {
        f: $a1a91b25d7598376$var$parse_RK
    },
    /*::[*/ 0x0293: {},
    /*::[*/ 0x0418: {},
    /*::[*/ 0x041e: {
        f: $a1a91b25d7598376$var$parse_Format
    },
    /*::[*/ 0x043c: {},
    /*::[*/ 0x04bc: {
        f: $a1a91b25d7598376$var$parse_ShrFmla
    },
    /*::[*/ 0x0800: {
        f: $a1a91b25d7598376$var$parse_HLinkTooltip
    },
    /*::[*/ 0x0801: {},
    /*::[*/ 0x0802: {},
    /*::[*/ 0x0803: {},
    /*::[*/ 0x0804: {},
    /*::[*/ 0x0805: {},
    /*::[*/ 0x0806: {},
    /*::[*/ 0x0807: {},
    /*::[*/ 0x0808: {},
    /*::[*/ 0x0809: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    /*::[*/ 0x080a: {},
    /*::[*/ 0x080b: {},
    /*::[*/ 0x080c: {},
    /*::[*/ 0x080d: {},
    /*::[*/ 0x080e: {},
    /*::[*/ 0x080f: {},
    /*::[*/ 0x0810: {},
    /*::[*/ 0x0812: {},
    /*::[*/ 0x0813: {},
    /*::[*/ 0x0850: {},
    /*::[*/ 0x0851: {},
    /*::[*/ 0x0852: {},
    /*::[*/ 0x0853: {},
    /*::[*/ 0x0854: {},
    /*::[*/ 0x0855: {},
    /*::[*/ 0x0856: {},
    /*::[*/ 0x0857: {},
    /*::[*/ 0x0858: {},
    /*::[*/ 0x0859: {},
    /*::[*/ 0x085a: {},
    /*::[*/ 0x0862: {},
    /*::[*/ 0x0863: {
        r: 12
    },
    /*::[*/ 0x0864: {},
    /*::[*/ 0x0865: {},
    /*::[*/ 0x0866: {},
    /*::[*/ 0x0867: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x0868: {},
    /*::[*/ 0x086a: {},
    /*::[*/ 0x086b: {},
    /*::[*/ 0x086c: {},
    /*::[*/ 0x0871: {},
    /*::[*/ 0x0872: {},
    /*::[*/ 0x0874: {},
    /*::[*/ 0x0875: {},
    /*::[*/ 0x0876: {},
    /*::[*/ 0x0877: {},
    /*::[*/ 0x0878: {},
    /*::[*/ 0x0879: {},
    /*::[*/ 0x087a: {},
    /*::[*/ 0x087b: {},
    /*::[*/ 0x087c: {
        f: $a1a91b25d7598376$var$parse_XFCRC,
        r: 12
    },
    /*::[*/ 0x087d: {
        f: $a1a91b25d7598376$var$parse_XFExt,
        r: 12
    },
    /*::[*/ 0x087e: {},
    /*::[*/ 0x087f: {},
    /*::[*/ 0x0884: {},
    /*::[*/ 0x0885: {},
    /*::[*/ 0x0886: {},
    /*::[*/ 0x0887: {},
    /*::[*/ 0x0888: {},
    /*::[*/ 0x0889: {},
    /*::[*/ 0x088a: {},
    /*::[*/ 0x088b: {},
    /*::[*/ 0x088c: {
        f: $a1a91b25d7598376$var$parsebool,
        r: 12
    },
    /*::[*/ 0x088d: {},
    /*::[*/ 0x088e: {
        r: 12
    },
    /*::[*/ 0x088f: {},
    /*::[*/ 0x0890: {},
    /*::[*/ 0x0892: {},
    /*::[*/ 0x0893: {},
    /*::[*/ 0x0894: {
        f: $a1a91b25d7598376$var$parse_NameCmt,
        r: 12
    },
    /*::[*/ 0x0895: {},
    /*::[*/ 0x0896: {
        f: $a1a91b25d7598376$var$parse_Theme,
        r: 12
    },
    /*::[*/ 0x0897: {},
    /*::[*/ 0x0898: {},
    /*::[*/ 0x0899: {},
    /*::[*/ 0x089a: {
        f: $a1a91b25d7598376$var$parse_MTRSettings,
        r: 12
    },
    /*::[*/ 0x089b: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    /*::[*/ 0x089c: {},
    /*::[*/ 0x089d: {},
    /*::[*/ 0x089e: {},
    /*::[*/ 0x089f: {},
    /*::[*/ 0x08a3: {
        f: $a1a91b25d7598376$var$parse_ForceFullCalculation
    },
    /*::[*/ 0x08a4: {},
    /*::[*/ 0x08a5: {},
    /*::[*/ 0x08a6: {},
    /*::[*/ 0x08a7: {},
    /*::[*/ 0x1001: {},
    /*::[*/ 0x1002: {},
    /*::[*/ 0x1003: {},
    /*::[*/ 0x1006: {},
    /*::[*/ 0x1007: {},
    /*::[*/ 0x1009: {},
    /*::[*/ 0x100a: {},
    /*::[*/ 0x100b: {},
    /*::[*/ 0x100c: {},
    /*::[*/ 0x100d: {},
    /*::[*/ 0x1014: {},
    /*::[*/ 0x1015: {},
    /*::[*/ 0x1016: {},
    /*::[*/ 0x1017: {},
    /*::[*/ 0x1018: {},
    /*::[*/ 0x1019: {},
    /*::[*/ 0x101a: {},
    /*::[*/ 0x101b: {},
    /*::[*/ 0x101c: {},
    /*::[*/ 0x101d: {},
    /*::[*/ 0x101e: {},
    /*::[*/ 0x101f: {},
    /*::[*/ 0x1020: {},
    /*::[*/ 0x1021: {},
    /*::[*/ 0x1022: {},
    /*::[*/ 0x1024: {},
    /*::[*/ 0x1025: {},
    /*::[*/ 0x1026: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x1027: {},
    /*::[*/ 0x1032: {},
    /*::[*/ 0x1033: {},
    /*::[*/ 0x1034: {},
    /*::[*/ 0x1035: {},
    /*::[*/ 0x103a: {},
    /*::[*/ 0x103c: {},
    /*::[*/ 0x103d: {},
    /*::[*/ 0x103e: {},
    /*::[*/ 0x103f: {},
    /*::[*/ 0x1040: {},
    /*::[*/ 0x1041: {},
    /*::[*/ 0x1043: {},
    /*::[*/ 0x1044: {
        f: $a1a91b25d7598376$var$parse_ShtProps
    },
    /*::[*/ 0x1045: {},
    /*::[*/ 0x1046: {},
    /*::[*/ 0x1048: {},
    /*::[*/ 0x104a: {},
    /*::[*/ 0x104b: {},
    /*::[*/ 0x104e: {},
    /*::[*/ 0x104f: {},
    /*::[*/ 0x1050: {},
    /*::[*/ 0x1051: {},
    /*::[*/ 0x105b: {},
    /*::[*/ 0x105c: {
        f: $a1a91b25d7598376$var$parse_ClrtClient
    },
    /*::[*/ 0x105d: {},
    /*::[*/ 0x105f: {},
    /*::[*/ 0x1060: {},
    /*::[*/ 0x1061: {},
    /*::[*/ 0x1062: {},
    /*::[*/ 0x1063: {},
    /*::[*/ 0x1064: {},
    /*::[*/ 0x1065: {},
    /*::[*/ 0x1066: {},
    /*::[*/ 0x1067: {},
    /*::[*/ 0x1068: {},
    /*::[*/ 0x0000: {
        f: $a1a91b25d7598376$var$parse_Dimensions
    },
    /*::[*/ 0x0001: {},
    /*::[*/ 0x0002: {
        f: $a1a91b25d7598376$var$parse_BIFF2INT
    },
    /*::[*/ 0x0003: {
        f: $a1a91b25d7598376$var$parse_BIFF2NUM
    },
    /*::[*/ 0x0004: {
        f: $a1a91b25d7598376$var$parse_BIFF2STR
    },
    /*::[*/ 0x0005: {
        f: $a1a91b25d7598376$var$parse_BoolErr
    },
    /*::[*/ 0x0007: {
        f: $a1a91b25d7598376$var$parse_BIFF2STRING
    },
    /*::[*/ 0x0008: {},
    /*::[*/ 0x0009: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    /*::[*/ 0x000b: {},
    /*::[*/ 0x0016: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x001e: {
        f: $a1a91b25d7598376$var$parse_BIFF2Format
    },
    /*::[*/ 0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ /*::[*/ 0x0020: {},
    /*::[*/ 0x0021: {
        f: $a1a91b25d7598376$var$parse_Array
    },
    /*::[*/ 0x0024: {},
    /*::[*/ 0x0025: {
        f: $a1a91b25d7598376$var$parse_DefaultRowHeight
    },
    // 0x2c ??
    // 0x2d ??
    // 0x2e ??
    // 0x30 FONTCOUNT: number of fonts
    /*::[*/ 0x0032: {
        f: $a1a91b25d7598376$var$parse_BIFF2FONTXTRA
    },
    // 0x35: INFOOPTS
    // 0x36: TABLE (BIFF2 only)
    // 0x37: TABLE2 (BIFF2 only)
    // 0x38: WNDESK
    // 0x39 ??
    // 0x3a: BEGINPREF
    // 0x3b: ENDPREF
    /*::[*/ 0x003e: {},
    // 0x3f ??
    // 0x46: SHOWSCROLL
    // 0x47: SHOWFORMULA
    // 0x48: STATUSBAR
    // 0x49: SHORTMENUS
    // 0x4A:
    // 0x4B:
    // 0x4C:
    // 0x4E:
    // 0x4F:
    // 0x58: TOOLBAR (BIFF3)
    /* - - - */ /*::[*/ 0x0034: {},
    /*::[*/ 0x0043: {},
    /*::[*/ 0x0044: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    /*::[*/ 0x0045: {},
    /*::[*/ 0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ /*::[*/ 0x007e: {},
    /* Not necessarily same as 0x027e */ /*::[*/ 0x007f: {
        f: $a1a91b25d7598376$var$parse_ImData
    },
    /*::[*/ 0x0087: {},
    /*::[*/ 0x0088: {},
    /*::[*/ 0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    // 0x8F
    /*::[*/ 0x0091: {},
    // 0x93 STYLE
    /*::[*/ 0x0094: {},
    /*::[*/ 0x0095: {},
    /*::[*/ 0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    /*::[*/ 0x00a9: {},
    /*::[*/ 0x00ab: {},
    /*::[*/ 0x00bc: {},
    /* Not necessarily same as 0x04bc */ /*::[*/ 0x00bf: {},
    /*::[*/ 0x00c0: {},
    /*::[*/ 0x00c2: {},
    /*::[*/ 0x00c3: {},
    /*::[*/ 0x00d6: {
        f: $a1a91b25d7598376$var$parse_RString
    },
    /*::[*/ 0x00df: {},
    /*::[*/ 0x00ea: {},
    /*::[*/ 0x0162: {},
    /*::[*/ 0x01a5: {},
    /*::[*/ 0x0206: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    /*::[*/ 0x0209: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    /*::[*/ 0x0218: {
        f: $a1a91b25d7598376$var$parse_Lbl
    },
    /*::[*/ 0x0223: {
        f: $a1a91b25d7598376$var$parse_ExternName
    },
    /*::[*/ 0x0231: {},
    /*::[*/ 0x0243: {},
    /*::[*/ 0x0406: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    /*::[*/ 0x0409: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    /*::[*/ 0x0443: {},
    /*::[*/ 0x086d: {},
    /*::[*/ 0x0873: {},
    /*::[*/ 0x0881: {},
    /*::[*/ 0x08c0: {},
    /*::[*/ 0x08c1: {},
    /*::[*/ 0x08c2: {},
    /*::[*/ 0x08c3: {},
    /*::[*/ 0x08c4: {},
    /*::[*/ 0x08c5: {},
    /*::[*/ 0x08c6: {},
    /*::[*/ 0x08c7: {},
    /*::[*/ 0x08c8: {},
    /*::[*/ 0x08c9: {},
    /*::[*/ 0x08ca: {},
    /*::[*/ 0x08cb: {},
    /*::[*/ 0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ /*::[*/ 0x0065: {},
    /*::[*/ 0x0066: {},
    /*::[*/ 0x0069: {},
    /*::[*/ 0x006a: {},
    /*::[*/ 0x006b: {},
    /*::[*/ 0x006d: {},
    /*::[*/ 0x0070: {},
    /*::[*/ 0x0072: {},
    /*::[*/ 0x7262: {}
};
function $a1a91b25d7598376$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $a1a91b25d7598376$var$is_buf(payload)) ba.push(payload);
}
function $a1a91b25d7598376$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $a1a91b25d7598376$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $a1a91b25d7598376$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ ) {
    if (!out) out = $a1a91b25d7598376$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(2, 0);
    out.write_shift(1, 0);
    return out;
}
function $a1a91b25d7598376$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val, t /*:?string*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    $a1a91b25d7598376$var$write_Bes(val, t || "b", out);
    return out;
}
/* TODO: codepage, large strings */ function $a1a91b25d7598376$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val) {
    var out = $a1a91b25d7598376$var$new_buf(8 + 2 * val.length);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val.length);
    out.write_shift(val.length, val, "sbcs");
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $a1a91b25d7598376$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/  /*::, opts*/ ) {
    if (cell.v != null) switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v)) : cell.v;
            if (v == (v | 0) && v >= 0 && v < 65536) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0002, $a1a91b25d7598376$var$write_BIFF2INT(R, C, v));
            else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0003, $a1a91b25d7598376$var$write_BIFF2NUM(R, C, v));
            return;
        case "b":
        case "e":
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case "s":
        case "str":
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0004, $a1a91b25d7598376$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0001, $a1a91b25d7598376$var$write_BIFF2Cell(null, R, C));
}
function $a1a91b25d7598376$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts /*::, wb:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"] || "A1"), ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, 0x3FFF);
    }
    var row = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $a1a91b25d7598376$var$write_ws_biff2_cell(ba, cell, R, C, opts);
        }
    }
}
/* Based on test files */ function $a1a91b25d7598376$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $a1a91b25d7598376$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $a1a91b25d7598376$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $a1a91b25d7598376$var$write_BOF(wb, 0x10, o));
    /* ... */ $a1a91b25d7598376$var$write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    /* ... */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
function $a1a91b25d7598376$var$write_FONTS_biff8(ba, data, opts) {
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0031 /* Font */ , $a1a91b25d7598376$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $a1a91b25d7598376$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $a1a91b25d7598376$var$write_biff_rec(ba, 0x041E /* Format */ , $a1a91b25d7598376$var$write_Format(i, NF[i], opts));
    });
}
function $a1a91b25d7598376$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $a1a91b25d7598376$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $a1a91b25d7598376$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $a1a91b25d7598376$var$write_Ref8U($a1a91b25d7598376$var$safe_decode_range(ws["!ref"] || "A1"), o);
    o.write_shift(4, 4);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $a1a91b25d7598376$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$a1a91b25d7598376$var$write_biff_rec(ba, 0x00e0 /* XF */ , $a1a91b25d7598376$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00e0 /* XF */ , $a1a91b25d7598376$var$write_XF(c, 0, opts));
    });
}
function $a1a91b25d7598376$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws["!links"].length; ++R){
        var HL = ws["!links"][R];
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $a1a91b25d7598376$var$write_HLink(HL));
        if (HL[1].Tooltip) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $a1a91b25d7598376$var$write_HLinkTooltip(HL));
    }
    delete ws["!links"];
}
function $a1a91b25d7598376$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $a1a91b25d7598376$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $a1a91b25d7598376$var$write_ColInfo($a1a91b25d7598376$var$col_obj_w(idx, col), idx));
    });
}
function $a1a91b25d7598376$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts) {
    var os = 16 + $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x0201 /* Blank */ , $a1a91b25d7598376$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0006 /* Formula */ , $a1a91b25d7598376$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case "d":
        case "n":
            var v = cell.t == "d" ? $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v)) : cell.v;
            /* TODO: emit RK as appropriate */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0203 /* Number */ , $a1a91b25d7598376$var$write_Number(R, C, v, os, opts));
            break;
        case "b":
        case "e":
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case "s":
        case "str":
            if (opts.bookSST) {
                var isst = $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $a1a91b25d7598376$var$write_LabelSst(R, C, isst, os, opts));
            } else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0204 /* Label */ , $a1a91b25d7598376$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0201 /* Blank */ , $a1a91b25d7598376$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $a1a91b25d7598376$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws["!ref"] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.c, MAX_ROWS - 1);
    }
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0809, $a1a91b25d7598376$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $a1a91b25d7598376$var$writeuint16(100));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $a1a91b25d7598376$var$writebool(true));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $a1a91b25d7598376$var$write_Xnum(0.001));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $a1a91b25d7598376$var$writebool(true));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0080 /* Guts */ , $a1a91b25d7598376$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $a1a91b25d7598376$var$writebool(false));
    /* ... */ if (b8) $a1a91b25d7598376$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $a1a91b25d7598376$var$write_Dimensions(range, opts));
    /* ... */ if (b8) ws["!links"] = [];
    var comments = [];
    var row = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var cell = dense ? row[C] : ws[ref];
            if (!cell) continue;
            /* write cell */ $a1a91b25d7598376$var$write_ws_biff8_cell(ba, cell, R, C, opts);
            if (b8 && cell.l) ws["!links"].push([
                ref,
                cell.l
            ]);
            if (b8 && cell.c) comments.push([
                ref,
                cell.c
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ // if(b8) comments.forEach(function(comment) { write_biff_rec(ba, 0x001c /* Note */, write_NoteSh(comment)); });
    /* ... */ if (b8) $a1a91b25d7598376$var$write_biff_rec(ba, 0x023e /* Window2 */ , $a1a91b25d7598376$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws["!merges"] || []).length) $a1a91b25d7598376$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $a1a91b25d7598376$var$write_MergeCells(ws["!merges"]));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $a1a91b25d7598376$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $a1a91b25d7598376$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $a1a91b25d7598376$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $a1a91b25d7598376$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $a1a91b25d7598376$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0809, $a1a91b25d7598376$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $a1a91b25d7598376$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $a1a91b25d7598376$var$writeuint16(0x04b0) : null);
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00c1 /* Mms */ , $a1a91b25d7598376$var$writezeroes(2));
    if (b5) $a1a91b25d7598376$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $a1a91b25d7598376$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $a1a91b25d7598376$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $a1a91b25d7598376$var$write_biff_rec(A, 0x0042 /* CodePage */ , $a1a91b25d7598376$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x0161 /* DSF */ , $a1a91b25d7598376$var$writeuint16(0));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x013d /* RRTabId */ , $a1a91b25d7598376$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $a1a91b25d7598376$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $a1a91b25d7598376$var$write_biff_rec(A, 0x01ba /* CodeName */ , $a1a91b25d7598376$var$write_XLUnicodeString(cname, opts));
    }
    $a1a91b25d7598376$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $a1a91b25d7598376$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $a1a91b25d7598376$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0012 /* Protect */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0013 /* Password */ , $a1a91b25d7598376$var$writeuint16(0));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $a1a91b25d7598376$var$writebool(false));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $a1a91b25d7598376$var$writeuint16(0));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x003d /* Window1 */ , $a1a91b25d7598376$var$write_Window1(opts));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0040 /* Backup */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x008d /* HideObj */ , $a1a91b25d7598376$var$writeuint16(0));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $a1a91b25d7598376$var$writebool($a1a91b25d7598376$var$safe1904(wb) == "true"));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $a1a91b25d7598376$var$writebool(true));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00DA /* BookBool */ , $a1a91b25d7598376$var$writeuint16(0));
    /* ... */ $a1a91b25d7598376$var$write_FONTS_biff8(A, wb, opts);
    $a1a91b25d7598376$var$write_FMTS_biff8(A, wb.SSF, opts);
    $a1a91b25d7598376$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $a1a91b25d7598376$var$writebool(false));
    var a = A.end();
    var C = $a1a91b25d7598376$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $a1a91b25d7598376$var$write_biff_rec(C, 0x008C /* Country */ , $a1a91b25d7598376$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */ /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $a1a91b25d7598376$var$write_biff_continue(C, 0x00FC /* SST */ , $a1a91b25d7598376$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $a1a91b25d7598376$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $a1a91b25d7598376$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $a1a91b25d7598376$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $a1a91b25d7598376$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $a1a91b25d7598376$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $a1a91b25d7598376$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $a1a91b25d7598376$var$fix_write_opts(o);
    o.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $a1a91b25d7598376$var$write_ws_biff8(i, o, wb);
    bufs.unshift($a1a91b25d7598376$var$write_biff8_global(wb, bufs, o));
    return $a1a91b25d7598376$var$bconcat(bufs);
}
function $a1a91b25d7598376$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $a1a91b25d7598376$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $a1a91b25d7598376$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $a1a91b25d7598376$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $a1a91b25d7598376$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = str.replace(/<!--.*?-->/g, "");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $a1a91b25d7598376$var$split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $a1a91b25d7598376$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $a1a91b25d7598376$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: "s",
                v: m
            };
            if (opts.raw || !m.trim().length || _t == "s") ;
            else if (m === "TRUE") o = {
                t: "b",
                v: true
            };
            else if (m === "FALSE") o = {
                t: "b",
                v: false
            };
            else if (!isNaN($a1a91b25d7598376$var$fuzzynum(m))) o = {
                t: "n",
                v: $a1a91b25d7598376$var$fuzzynum(m)
            };
            else if (!isNaN($a1a91b25d7598376$var$fuzzydate(m).getDate())) {
                o = {
                    t: "d",
                    v: $a1a91b25d7598376$var$parseDate(m)
                } /*:any*/ ;
                if (!opts.cellDates) o = {
                    t: "n",
                    v: $a1a91b25d7598376$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $a1a91b25d7598376$var$table_fmt[14];
            }
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $a1a91b25d7598376$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws["!merges"] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $a1a91b25d7598376$var$escapehtml(cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + "</span>";
        else if (cell) {
            sp["data-t"] = cell && cell.t || "z";
            if (cell.v != null) sp["data-v"] = cell.v;
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target + '">' + w + "</a>";
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($a1a91b25d7598376$var$writextag("td", w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $a1a91b25d7598376$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $a1a91b25d7598376$var$HTML_END = "</body></html>";
function $a1a91b25d7598376$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $a1a91b25d7598376$var$book_new();
    mtch.forEach(function(s, idx) {
        $a1a91b25d7598376$var$book_append_sheet(wb, $a1a91b25d7598376$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $a1a91b25d7598376$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + "<table" + (o && o.id ? ' id="' + o.id + '"' : "") + ">";
}
function $a1a91b25d7598376$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $a1a91b25d7598376$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $a1a91b25d7598376$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    out.push($a1a91b25d7598376$var$make_html_preamble(ws, r, o));
    for(var R = r.s.r; R <= r.e.r; ++R)out.push($a1a91b25d7598376$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $a1a91b25d7598376$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == "number") or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $a1a91b25d7598376$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws["!cols"] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($a1a91b25d7598376$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $a1a91b25d7598376$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute("data-v") ? elt.getAttribute("data-v") : elt.hasAttribute("v") ? elt.getAttribute("v") : $a1a91b25d7598376$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute("data-z") || elt.getAttribute("z");
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: "s",
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || "z";
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (v === "TRUE") o = {
                    t: "b",
                    v: true
                };
                else if (v === "FALSE") o = {
                    t: "b",
                    v: false
                };
                else if (!isNaN($a1a91b25d7598376$var$fuzzynum(v))) o = {
                    t: "n",
                    v: $a1a91b25d7598376$var$fuzzynum(v)
                };
                else if (!isNaN($a1a91b25d7598376$var$fuzzydate(v).getDate())) {
                    o = {
                        t: "d",
                        v: $a1a91b25d7598376$var$parseDate(v)
                    } /*:any*/ ;
                    if (!opts.cellDates) o = {
                        t: "n",
                        v: $a1a91b25d7598376$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                }
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != "javascript:") o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws["!merges"] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    if (R >= sheetRows) ws["!fullref"] = $a1a91b25d7598376$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $a1a91b25d7598376$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $a1a91b25d7598376$var$sheet_add_dom(ws, table, _opts);
}
function $a1a91b25d7598376$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $a1a91b25d7598376$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = "";
    var get_computed_style /*:?function*/  = $a1a91b25d7598376$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue("display");
    if (!display) display = element.style && element.style.display;
    return display === "none";
}
/* global getComputedStyle */ function $a1a91b25d7598376$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === "function") return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === "function") return getComputedStyle;
    return null;
}
/* OpenDocument */ function $a1a91b25d7598376$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, "\n");
    var v = $a1a91b25d7598376$var$unescapexml(fixed.replace(/<[^>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $a1a91b25d7598376$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        /* Number Format Definitions */ case "number-style":
        case "currency-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
        case "text-style":
            if (Rn[1] === "/") {
                infmt = false;
                if (NFtag["truncate-on-overflow"] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                infmt = true;
                NF = "";
                NFtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case "boolean-style":
            if (Rn[1] === "/") {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                infmt = true;
                NF = "";
                NFtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case "boolean":
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case "text":
            if (Rn[1] === "/") {
                payload = str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == "<number:percentage-style") NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            break;
        case "day":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case "day-of-week":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case "era":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case "hours":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case "minutes":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case "month":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case "seconds":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $a1a91b25d7598376$var$fill("0", +y["decimal-places"]);
            break;
        case "year":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case "am-pm":
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case "week-of-year":
        case "quarter":
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case "fill-character":
            if (Rn[1] === "/") {
                payload = str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            break;
        case "scientific-number":
            // TODO: find a mapping for all parameters
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            NF += "0." + $a1a91b25d7598376$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $a1a91b25d7598376$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($a1a91b25d7598376$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $a1a91b25d7598376$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case "fraction":
            // TODO: find a mapping for all parameters
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $a1a91b25d7598376$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $a1a91b25d7598376$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $a1a91b25d7598376$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case "currency-symbol":
            // TODO: localization with [$-...]
            if (Rn[1] === "/") NF += '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== "/") tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case "text-properties":
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case "text-content":
            NF += "@";
            break;
        case "map":
            // TODO: handle more complex maps
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if ($a1a91b25d7598376$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case "number":
            // TODO: handle all the attributes
            if (Rn[1] === "/") break;
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $a1a91b25d7598376$var$fill("0", +y["min-integer-digits"] || 1);
            if ($a1a91b25d7598376$var$parsexmlbool(y["grouping"])) tNF = $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $a1a91b25d7598376$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $a1a91b25d7598376$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case "embedded-text":
            // TODO: verify interplay with grouping et al
            if (Rn[1] === "/") {
                if (etpos == 0) NF += '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
                etpos = -+$a1a91b25d7598376$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $a1a91b25d7598376$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ ;
    var textR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    var baddate = 0;
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = str.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_.*$/, "")){
        case "table":
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === "/") {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                else ws["!ref"] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws["!fullref"] = ws["!ref"];
                    range.e.r = opts.sheetRows - 1;
                    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                }
                if (merges.length) ws["!merges"] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== "undefined") JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") {
                sheetag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case "table-row-group":
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case "table-row":
        case "\u884C":
            if (Rn[1] === "/") {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag["number-rows-repeated"] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case "covered-table-cell":
            if (Rn[1] !== "/") ++C;
            if (opts.sheetStubs) {
                if (opts.dense) {
                    if (!ws["!data"][R]) ws["!data"][R] = [];
                    ws["!data"][R][C] = {
                        t: "z"
                    };
                } else ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })] = {
                    t: "z"
                };
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case "table-cell":
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === "/") {
                ++C;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                q = {
                    t: "z",
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $a1a91b25d7598376$var$ods_to_csf_formula($a1a91b25d7598376$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"]) == "string") {
                    q.t = "s";
                    q.v = $a1a91b25d7598376$var$unescapexml(ctag["string-value"] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== "/") {
                ++C;
                textp = "";
                textpidx = 0;
                textR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag["value-type"],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $a1a91b25d7598376$var$unescapexml(ctag.formula);
                    if (ctag["number-matrix-columns-spanned"] && ctag["number-matrix-rows-spanned"]) {
                        mR = parseInt(ctag["number-matrix-rows-spanned"], 10) || 0;
                        mC = parseInt(ctag["number-matrix-columns-spanned"], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $a1a91b25d7598376$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $a1a91b25d7598376$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag["number-columns-spanned"] || ctag["number-rows-spanned"]) {
                    mR = parseInt(ctag["number-rows-spanned"], 10) || 0;
                    mC = parseInt(ctag["number-columns-spanned"], 10) || 0;
                    mrange = {
                        s: {
                            r: R,
                            c: C
                        },
                        e: {
                            r: R + mR - 1,
                            c: C + mC - 1
                        }
                    };
                    merges.push(mrange);
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag["number-columns-repeated"]) colpeat = parseInt(ctag["number-columns-repeated"], 10);
                /* 19.385 office:value-type */ switch(q.t){
                    case "boolean":
                        q.t = "b";
                        q.v = $a1a91b25d7598376$var$parsexmlbool(ctag["boolean-value"]) || +ctag["boolean-value"] >= 1;
                        break;
                    case "float":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "percentage":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "currency":
                        q.t = "n";
                        q.v = parseFloat(ctag.value);
                        break;
                    case "date":
                        q.t = "d";
                        q.v = $a1a91b25d7598376$var$parseDate(ctag["date-value"]);
                        if (!opts.cellDates) {
                            q.t = "n";
                            q.v = $a1a91b25d7598376$var$datenum(q.v, WB.WBProps.date1904) - baddate;
                        }
                        if (!q.z) q.z = "m/d/yy";
                        break;
                    case "time":
                        q.t = "n";
                        q.v = $a1a91b25d7598376$var$parse_isodur(ctag["time-value"]) / 86400;
                        if (opts.cellDates) {
                            q.t = "d";
                            q.v = $a1a91b25d7598376$var$numdate(q.v);
                        }
                        if (!q.z) q.z = "HH:MM:SS";
                        break;
                    case "number":
                        q.t = "n";
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === "string" || q.t === "text" || !q.t) {
                            q.t = "s";
                            if (ctag["string-value"] != null) {
                                textp = $a1a91b25d7598376$var$unescapexml(ctag["string-value"]);
                                textR = [];
                            }
                        } else throw new Error("Unsupported value type " + q.t);
                }
            } else {
                isstub = false;
                if (q.t === "s") {
                    q.v = textp || "";
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $a1a91b25d7598376$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $a1a91b25d7598376$var$dup(q);
                        } else {
                            ws[$a1a91b25d7598376$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$a1a91b25d7598376$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $a1a91b25d7598376$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag["number-columns-repeated"] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case "document":
        case "document-content":
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case "spreadsheet":
        case "\u4E3B\u4F53":
        case "scripts":
        case "styles":
        case "font-face-decls":
        case "master-styles":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                true
            ]);
            break;
        case "annotation":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            creator = "";
            creatoridx = 0;
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "creator":
            if (Rn[1] === "/") creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case "meta":
        case "\u5143\u6570\u636E":
        case "settings":
        case "config-item-set":
        case "config-item-map-indexed":
        case "config-item-map-entry":
        case "config-item-map-named":
        case "shapes":
        case "frame":
        case "text-box":
        case "image":
        case "data-pilot-tables":
        case "list-style":
        case "form":
        case "dde-links":
        case "event-listeners":
        case "chart":
            if (Rn[1] === "/") {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case "scientific-number":
        case "currency-symbol":
        case "fill-character":
            break;
        case "text-style":
        case "boolean-style":
        case "number-style":
        case "currency-style":
        case "percentage-style":
        case "date-style":
        case "time-style":
            if (Rn[1] === "/") {
                var xlmlidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
                $a1a91b25d7598376$var$parse_ods_styles(str.slice(nfidx, $a1a91b25d7598376$var$xlmlregex.lastIndex), _opts, number_format_map);
                $a1a91b25d7598376$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== "/") nfidx = $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case "script":
            break; // 3.13 <office:script>
        case "libraries":
            break; // TODO: <ooo:libraries>
        case "automatic-styles":
            break; // 3.15.3 <office:automatic-styles>
        case "default-style":
        case "page-layout":
            break; // TODO: <style:page-layout>
        case "style":
            var styletag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case "map":
            break; // 16.3 <style:map>
        case "font-face":
            break; // 16.21 <style:font-face>
        case "paragraph-properties":
            break; // 17.6 <style:paragraph-properties>
        case "table-properties":
            break; // 17.15 <style:table-properties>
        case "table-column-properties":
            break; // 17.16 <style:table-column-properties>
        case "table-row-properties":
            break; // 17.17 <style:table-row-properties>
        case "table-cell-properties":
            break; // 17.18 <style:table-cell-properties>
        case "number":
            break;
        case "fraction":
            break; // TODO 16.27.6 <number:fraction>
        case "day":
        case "month":
        case "year":
        case "era":
        case "day-of-week":
        case "week-of-year":
        case "quarter":
        case "hours":
        case "minutes":
        case "seconds":
        case "am-pm":
            break;
        case "boolean":
            break; // 16.27.24 <number:boolean>
        case "text":
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case "number-style":
                case "date-style":
                case "time-style":
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case "named-range":
            tag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            _Ref = $a1a91b25d7598376$var$ods_to_csf_3D(tag["cell-range-address"]);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + "!" + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case "text-content":
            break; // 16.27.27 <number:text-content>
        case "text-properties":
            break; // 16.27.27 <style:text-properties>
        case "embedded-text":
            break; // 16.27.4 <number:embedded-text>
        case "body":
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case "forms":
            break; // 12.25.2 13.2
        case "table-column":
            break; // 9.1.6 <table:table-column>
        case "table-header-rows":
            break; // 9.1.7 <table:table-header-rows>
        case "table-rows":
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case "table-column-group":
            break; // 9.1.10 <table:table-column-group>
        case "table-header-columns":
            break; // 9.1.11 <table:table-header-columns>
        case "table-columns":
            break; // 9.1.12 <table:table-columns>
        case "null-date":
            tag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                /* falls through */ case "1900-01-01":
                    baddate = 0;
            }
            break;
        case "graphic-properties":
            break; // 17.21 <style:graphic-properties>
        case "calculation-settings":
            break; // 9.4.1 <table:calculation-settings>
        case "named-expressions":
            break; // 9.4.11 <table:named-expressions>
        case "label-range":
            break; // 9.4.9 <table:label-range>
        case "label-ranges":
            break; // 9.4.10 <table:label-ranges>
        case "named-expression":
            break; // 9.4.13 <table:named-expression>
        case "sort":
            break; // 9.4.19 <table:sort>
        case "sort-by":
            break; // 9.4.20 <table:sort-by>
        case "sort-groups":
            break; // 9.4.22 <table:sort-groups>
        case "tab":
            break; // 6.1.4 <text:tab>
        case "line-break":
            break; // 6.1.5 <text:line-break>
        case "span":
            break; // 6.1.7 <text:span>
        case "p":
        case "\u6587\u672C\u4E32":
            if ([
                "master-styles"
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === "/" && (!ctag || !ctag["string-value"])) {
                var ptp = $a1a91b25d7598376$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else {
                textptag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case "s":
            break; // <text:s>
        case "database-range":
            if (Rn[1] === "/") break;
            try {
                _Ref = $a1a91b25d7598376$var$ods_to_csf_3D($a1a91b25d7598376$var$parsexmltag(Rn[0])["target-range-address"]);
                Sheets[_Ref[0]]["!autofilter"] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case "date":
            break; // <*:date>
        case "object":
            break; // 10.4.6.2 <draw:object>
        case "title":
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case "desc":
            break; // <*:desc>
        case "binary-data":
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case "table-source":
            break; // 9.2.6
        case "scenario":
            break; // 9.2.6
        case "iteration":
            break; // 9.4.3 <table:iteration>
        case "content-validations":
            break; // 9.4.4 <table:
        case "content-validation":
            break; // 9.4.5 <table:
        case "help-message":
            break; // 9.4.6 <table:
        case "error-message":
            break; // 9.4.7 <table:
        case "database-ranges":
            break; // 9.4.14 <table:database-ranges>
        case "filter":
            break; // 9.5.2 <table:filter>
        case "filter-and":
            break; // 9.5.3 <table:filter-and>
        case "filter-or":
            break; // 9.5.4 <table:filter-or>
        case "filter-condition":
            break; // 9.5.5 <table:filter-condition>
        case "list-level-style-bullet":
            break; // 16.31 <text:
        case "list-level-style-number":
            break; // 16.32 <text:
        case "list-level-properties":
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case "sender-firstname":
        case "sender-lastname":
        case "sender-initials":
        case "sender-title":
        case "sender-position":
        case "sender-email":
        case "sender-phone-private":
        case "sender-fax":
        case "sender-company":
        case "sender-phone-work":
        case "sender-street":
        case "sender-city":
        case "sender-postal-code":
        case "sender-country":
        case "sender-state-or-province":
        case "author-name":
        case "author-initials":
        case "chapter":
        case "file-name":
        case "template-name":
        case "sheet-name":
            break;
        case "event-listener":
            break;
        /* TODO: FODS Properties */ case "initial-creator":
        case "creation-date":
        case "print-date":
        case "generator":
        case "document-statistic":
        case "user-defined":
        case "editing-duration":
        case "editing-cycles":
            break;
        /* TODO: FODS Config */ case "config-item":
            break;
        /* TODO: style tokens */ case "page-number":
            break; // TODO <text:page-number>
        case "page-count":
            break; // TODO <text:page-count>
        case "time":
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case "cell-range-source":
            break; // 9.3.1 <table:
        case "detective":
            break; // 9.3.2 <table:
        case "operation":
            break; // 9.3.3 <table:
        case "highlighted-range":
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case "data-pilot-table":
        case "source-cell-range":
        case "source-service":
        case "data-pilot-field":
        case "data-pilot-level":
        case "data-pilot-subtotals":
        case "data-pilot-subtotal":
        case "data-pilot-members":
        case "data-pilot-member":
        case "data-pilot-display-info":
        case "data-pilot-sort-info":
        case "data-pilot-layout-info":
        case "data-pilot-field-reference":
        case "data-pilot-groups":
        case "data-pilot-group":
        case "data-pilot-group-member":
            break;
        /* 10.3 Drawing Shapes */ case "rect":
            break;
        /* 14.6 DDE Connections */ case "dde-connection-decls":
        case "dde-connection-decl":
        case "dde-link":
        case "dde-source":
            break;
        case "properties":
            break; // 13.7 <form:properties>
        case "property":
            break; // 13.8 <form:property>
        case "a":
            if (Rn[1] !== "/") {
                atag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $a1a91b25d7598376$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $a1a91b25d7598376$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case "table-protection":
            break;
        case "data-pilot-grand-total":
            break; // <table:
        case "office-document-common-attrs":
            break; // bare
        default:
            switch(Rn[2]){
                case "dc:":
                case "calcext:":
                case "loext:":
                case "ooo:":
                case "chartooo:":
                case "draw:":
                case "style:":
                case "chart:":
                case "form:":
                case "uof:":
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $a1a91b25d7598376$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($a1a91b25d7598376$var$safegetzipfile(zip, "META-INF/manifest.xml")) $a1a91b25d7598376$var$parse_manifest($a1a91b25d7598376$var$getzipdata(zip, "META-INF/manifest.xml"), opts);
    var styles = $a1a91b25d7598376$var$getzipstr(zip, "styles.xml");
    var Styles = styles && $a1a91b25d7598376$var$parse_ods_styles($a1a91b25d7598376$var$utf8read(styles), opts);
    var content = $a1a91b25d7598376$var$getzipstr(zip, "content.xml");
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $a1a91b25d7598376$var$parse_content_xml($a1a91b25d7598376$var$utf8read(content), opts, Styles);
    if ($a1a91b25d7598376$var$safegetzipfile(zip, "meta.xml")) wb.Props = $a1a91b25d7598376$var$parse_core_props($a1a91b25d7598376$var$getzipdata(zip, "meta.xml"));
    wb.bookType = "ods";
    return wb;
}
function $a1a91b25d7598376$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $a1a91b25d7598376$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $a1a91b25d7598376$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        "<office:master-styles>",
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        "<style:header/>",
        '<style:header-left style:display="false"/>',
        "<style:footer/>",
        '<style:footer-left style:display="false"/>',
        "</style:master-page>",
        "</office:master-styles>"
    ].join("");
    var payload = "<office:document-styles " + $a1a91b25d7598376$var$wxt_helper({
        "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        "office:version": "1.2"
    }) + ">" + master_styles + "</office:document-styles>";
    return function wso() {
        return $a1a91b25d7598376$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $a1a91b25d7598376$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += "<number:fill-character>" + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + "</number:fill-character>";
            } else payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + "</number:text>";
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $a1a91b25d7598376$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $a1a91b25d7598376$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $a1a91b25d7598376$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c.slice(1).replace(/""/g, '"')) + "</number:text>";
                    break;
                case "/":
                    payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c) + "</number:text>";
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts["number:truncate-on-overflow"] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + "/>";
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c.slice(1).replace(/""/g, '"')) + "</number:text>";
                    break;
                case "/":
                    payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c) + "</number:text>";
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += "<number:am-pm/>";
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += "<number:am-pm/>";
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += "<number:fill-character>" + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + "</number:fill-character>";
            } else payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + "</number:text>";
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += "<number:" + (np[3] ? "scientific-" : "") + "number" + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + ">" + /* TODO: interstitial text placeholders */ "</number:" + (np[3] ? "scientific-" : "") + "number>";
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += "<number:text>" + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + "</number:text>";
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $a1a91b25d7598376$var$writextag("number:" + type + "-style", payload, nopts);
}
function $a1a91b25d7598376$var$write_names_ods(Names, SheetNames, idx) {
    var scoped = Names.filter(function(name) {
        return name.Sheet == (idx == -1 ? null : idx);
    });
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = $a1a91b25d7598376$var$csf_to_ods_3D(name.Ref);
        return "        " + $a1a91b25d7598376$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.]?[^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $a1a91b25d7598376$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ ) /*:string*/ {
        return $a1a91b25d7598376$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = "          <table:table-cell />\n";
    var covered_cell_xml = "          <table:covered-table-cell/>\n";
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $a1a91b25d7598376$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $a1a91b25d7598376$var$decode_range(ws["!ref"] || "A1");
        var marr /*:Array<Range>*/  = ws["!merges"] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push("        <table:table-column" + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : "") + "></table:table-column>\n");
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + "></table:table-row>\n");
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push("        <table:table-row" + H + ">\n");
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct["table:number-columns-spanned"] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct["table:number-rows-spanned"] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push(covered_cell_xml);
                    continue;
                }
                var ref = $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct["table:formula"] = $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $a1a91b25d7598376$var$decode_range(cell.F);
                            ct["table:number-matrix-columns-spanned"] = _Fref.e.c - _Fref.s.c + 1;
                            ct["table:number-matrix-rows-spanned"] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case "b":
                        textp = cell.v ? "TRUE" : "FALSE";
                        ct["office:value-type"] = "boolean";
                        ct["office:boolean-value"] = cell.v ? "true" : "false";
                        break;
                    case "n":
                        textp = cell.w || String(cell.v || 0);
                        ct["office:value-type"] = "float";
                        ct["office:value"] = cell.v || 0;
                        break;
                    case "s":
                    case "str":
                        textp = cell.v == null ? "" : cell.v;
                        ct["office:value-type"] = "string";
                        break;
                    case "d":
                        textp = cell.w || $a1a91b25d7598376$var$parseDate(cell.v).toISOString();
                        ct["office:value-type"] = "date";
                        ct["office:date-value"] = $a1a91b25d7598376$var$parseDate(cell.v).toISOString();
                        ct["table:style-name"] = "ce1";
                        break;
                    //case 'e':
                    default:
                        o.push(null_cell_xml);
                        continue;
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $a1a91b25d7598376$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = "../" + _tgt;
                    text_p = $a1a91b25d7598376$var$writextag("text:a", text_p, {
                        "xlink:href": _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                o.push("          " + $a1a91b25d7598376$var$writextag("table:table-cell", $a1a91b25d7598376$var$writextag("text:p", text_p, {}), ct) + "\n");
            }
            o.push("        </table:table-row>\n");
        }
        if ((wb.Workbook || {}).Names) o.push($a1a91b25d7598376$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push("      </table:table>\n");
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(" <office:automatic-styles>\n");
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $a1a91b25d7598376$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push("  </style:style>\n");
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push("  </style:style>\n");
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push("  </style:style>\n");
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push('   <number:day number:style="long"/>\n');
        o.push("   <number:text>/</number:text>\n");
        o.push("   <number:year/>\n");
        o.push("  </number:date-style>\n");
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $a1a91b25d7598376$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $a1a91b25d7598376$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(" </office:automatic-styles>\n");
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $a1a91b25d7598376$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $a1a91b25d7598376$var$wxt_helper({
            "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "xmlns:dc": "http://purl.org/dc/elements/1.1/",
            "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            "xmlns:math": "http://www.w3.org/1998/Math/MathML",
            "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            "xmlns:ooo": "http://openoffice.org/2004/office",
            "xmlns:ooow": "http://openoffice.org/2004/writer",
            "xmlns:oooc": "http://openoffice.org/2004/calc",
            "xmlns:dom": "http://www.w3.org/2001/xml-events",
            "xmlns:xforms": "http://www.w3.org/2002/xforms",
            "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            "xmlns:rpt": "http://openoffice.org/2005/report",
            "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
            "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
            "xmlns:tableooo": "http://openoffice.org/2009/table",
            "xmlns:drawooo": "http://openoffice.org/2010/draw",
            "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
            "office:version": "1.2"
        });
        var fods = $a1a91b25d7598376$var$wxt_helper({
            "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push("<office:document" + attr + fods + ">\n");
            o.push($a1a91b25d7598376$var$write_meta_ods().replace(/<office:document-meta.*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push("<office:document-content" + attr + ">\n");
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push("  <office:body>\n");
        o.push("    <office:spreadsheet>\n");
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs));
        if ((wb.Workbook || {}).Names) o.push($a1a91b25d7598376$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push("    </office:spreadsheet>\n");
        o.push("  </office:body>\n");
        if (opts.bookType == "fods") o.push("</office:document>");
        else o.push("</office:document-content>");
        return o.join("");
    };
}();
function $a1a91b25d7598376$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $a1a91b25d7598376$var$write_content_ods(wb, opts);
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $a1a91b25d7598376$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$XML_HEADER + $a1a91b25d7598376$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $a1a91b25d7598376$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $a1a91b25d7598376$require$Buffer !== "undefined") {
            if (typeof $a1a91b25d7598376$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $a1a91b25d7598376$require$Buffer.from == "function" ? $a1a91b25d7598376$require$Buffer.from([
                72,
                62
            ]) : new $a1a91b25d7598376$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $a1a91b25d7598376$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $a1a91b25d7598376$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $a1a91b25d7598376$var$utf8read($a1a91b25d7598376$var$a2s(u8));
}
function $a1a91b25d7598376$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$utf8write(str));
}
function $a1a91b25d7598376$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $a1a91b25d7598376$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $a1a91b25d7598376$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $a1a91b25d7598376$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $a1a91b25d7598376$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $a1a91b25d7598376$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$a1a91b25d7598376$var$subarray](0, L);
}
function $a1a91b25d7598376$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($a1a91b25d7598376$var$parse_varint49(buf, ptr));
    return out;
}
function $a1a91b25d7598376$var$write_packed_varints(nums) {
    return $a1a91b25d7598376$var$u8concat(nums.map(function(x) {
        return $a1a91b25d7598376$var$write_varint49(x);
    }));
}
function $a1a91b25d7598376$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        i32 |= (buf[l] & 127) << 28;
    }
    return i32;
}
function $a1a91b25d7598376$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $a1a91b25d7598376$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$a1a91b25d7598376$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$a1a91b25d7598376$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
                data = buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$a1a91b25d7598376$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $a1a91b25d7598376$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($a1a91b25d7598376$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($a1a91b25d7598376$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $a1a91b25d7598376$var$u8concat(out);
}
function $a1a91b25d7598376$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $a1a91b25d7598376$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
        var ai = $a1a91b25d7598376$var$parse_shallow(buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $a1a91b25d7598376$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $a1a91b25d7598376$var$parse_shallow(b.data);
            var fl = $a1a91b25d7598376$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $a1a91b25d7598376$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $a1a91b25d7598376$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $a1a91b25d7598376$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $a1a91b25d7598376$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $a1a91b25d7598376$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $a1a91b25d7598376$var$write_shallow(ai);
        bufs.push($a1a91b25d7598376$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $a1a91b25d7598376$var$u8concat(bufs);
}
function $a1a91b25d7598376$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$a1a91b25d7598376$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $a1a91b25d7598376$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $a1a91b25d7598376$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $a1a91b25d7598376$var$parse_snappy_chunk(t, buf[$a1a91b25d7598376$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $a1a91b25d7598376$var$u8concat(out);
}
function $a1a91b25d7598376$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $a1a91b25d7598376$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$a1a91b25d7598376$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $a1a91b25d7598376$var$u8concat(out);
}
var $a1a91b25d7598376$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: []
    };
};
function $a1a91b25d7598376$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $a1a91b25d7598376$var$parse_old_storage(buf, lut, v) {
    var dv = $a1a91b25d7598376$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) ret = {
                t: "s",
                v: lut.rsst[ridx]
            };
            else throw new Error("Unsupported cell type ".concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
    }
    if (zidx > -1) $a1a91b25d7598376$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $a1a91b25d7598376$var$parse_new_storage(buf, lut) {
    var dv = $a1a91b25d7598376$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (fields & 1) {
        d128 = $a1a91b25d7598376$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + dv.getFloat64(doff, true) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            ret = {
                t: "d",
                v: dt
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            ret = {
                t: "s",
                v: lut.rsst[ridx]
            };
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 8160) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (zidx > -1) $a1a91b25d7598376$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $a1a91b25d7598376$var$write_new_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $a1a91b25d7598376$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            out[1] = 2;
            $a1a91b25d7598376$var$writeDecimal128LE(out, l, cell.v);
            flags |= 1;
            l += 16;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            var isst = sst.indexOf(s);
            if (isst == -1) sst[isst = sst.length] = s;
            out[1] = 3;
            dv.setUint32(l, isst, true);
            flags |= 8;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out[$a1a91b25d7598376$var$subarray](0, l);
}
function $a1a91b25d7598376$var$write_old_storage(cell, sst) {
    var out = new Uint8Array(32), dv = $a1a91b25d7598376$var$u8_to_dataview(out), l = 12, flags = 0;
    out[0] = 4;
    switch(cell.t){
        case "n":
            out[2] = 2;
            dv.setFloat64(l, cell.v, true);
            flags |= 32;
            l += 8;
            break;
        case "b":
            out[2] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            flags |= 32;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            var isst = sst.indexOf(s);
            if (isst == -1) sst[isst = sst.length] = s;
            out[2] = 3;
            dv.setUint32(l, isst, true);
            flags |= 16;
            l += 4;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, flags, true);
    return out[$a1a91b25d7598376$var$subarray](0, l);
}
function $a1a91b25d7598376$var$parse_cell_storage(buf, lut) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $a1a91b25d7598376$var$parse_old_storage(buf, lut, buf[0]);
        case 5:
            return $a1a91b25d7598376$var$parse_new_storage(buf, lut);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $a1a91b25d7598376$var$parse_TSP_Reference(buf) {
    var pb = $a1a91b25d7598376$var$parse_shallow(buf);
    return $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data);
}
function $a1a91b25d7598376$var$write_TSP_Reference(idx) {
    return $a1a91b25d7598376$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(idx)
            }
        ]
    ]);
}
function $a1a91b25d7598376$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $a1a91b25d7598376$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $a1a91b25d7598376$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $a1a91b25d7598376$var$parse_TST_TableDataList(M, root) {
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var type = $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var le = $a1a91b25d7598376$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $a1a91b25d7598376$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $a1a91b25d7598376$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$a1a91b25d7598376$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $a1a91b25d7598376$var$parse_shallow(rt.data);
                var rtpref = M[$a1a91b25d7598376$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $a1a91b25d7598376$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $a1a91b25d7598376$var$parse_shallow(rtpref.data);
                data[key] = tswpsa[3].map(function(x) {
                    return $a1a91b25d7598376$var$u8str(x.data);
                }).join("");
                break;
            case 2:
                data[key] = $a1a91b25d7598376$var$parse_shallow(le[6][0].data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $a1a91b25d7598376$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $a1a91b25d7598376$var$parse_shallow(u8);
    var R = $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $a1a91b25d7598376$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $a1a91b25d7598376$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $a1a91b25d7598376$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$a1a91b25d7598376$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$a1a91b25d7598376$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $a1a91b25d7598376$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($a1a91b25d7598376$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $a1a91b25d7598376$var$mappa(pb[5], function(u8) {
        return $a1a91b25d7598376$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $a1a91b25d7598376$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $a1a91b25d7598376$var$parse_TST_TableModelArchive(M, root, ws) {
    var _a, _b, _c, _d, _e, _f;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($a1a91b25d7598376$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($a1a91b25d7598376$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $a1a91b25d7598376$var$parse_shallow(pb[4][0].data);
    var lut = $a1a91b25d7598376$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[11]) == null ? void 0 : _b[0]) lut.ofmt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_c = store[17]) == null ? void 0 : _c[0]) lut.rsst = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_d = store[22]) == null ? void 0 : _d[0]) lut.nfmt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
        var tl = $a1a91b25d7598376$var$parse_shallow(t.data);
        var ref2 = M[$a1a91b25d7598376$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $a1a91b25d7598376$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $a1a91b25d7598376$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $a1a91b25d7598376$var$parse_cell_storage(buf, lut);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_e = store[13]) == null ? void 0 : _e[0]) {
        var ref = M[$a1a91b25d7598376$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $a1a91b25d7598376$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_f = $a1a91b25d7598376$var$parse_shallow(ref.data)) == null ? void 0 : _f[1].map(function(pi) {
            var merge = $a1a91b25d7598376$var$parse_shallow(pi.data);
            var origin = $a1a91b25d7598376$var$u8_to_dataview($a1a91b25d7598376$var$parse_shallow(merge[1][0].data)[1][0].data), size = $a1a91b25d7598376$var$u8_to_dataview($a1a91b25d7598376$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
}
function $a1a91b25d7598376$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$a1a91b25d7598376$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $a1a91b25d7598376$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $a1a91b25d7598376$var$parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
}
function $a1a91b25d7598376$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $a1a91b25d7598376$var$mappa(pb[2], $a1a91b25d7598376$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($a1a91b25d7598376$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $a1a91b25d7598376$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $a1a91b25d7598376$var$book_new();
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $a1a91b25d7598376$var$mappa(pb[1], $a1a91b25d7598376$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $a1a91b25d7598376$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $a1a91b25d7598376$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $a1a91b25d7598376$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $a1a91b25d7598376$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $a1a91b25d7598376$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $a1a91b25d7598376$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $a1a91b25d7598376$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $a1a91b25d7598376$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $a1a91b25d7598376$var$write_TST_TileRowInfo(data, SST, wide) {
    var _a, _b;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $a1a91b25d7598376$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $a1a91b25d7598376$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null) {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(typeof data[C]){
            case "string":
                celload = $a1a91b25d7598376$var$write_new_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                _celload = $a1a91b25d7598376$var$write_old_storage({
                    t: "s",
                    v: data[C]
                }, SST);
                break;
            case "number":
                celload = $a1a91b25d7598376$var$write_new_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                _celload = $a1a91b25d7598376$var$write_old_storage({
                    t: "n",
                    v: data[C]
                }, SST);
                break;
            case "boolean":
                celload = $a1a91b25d7598376$var$write_new_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                _celload = $a1a91b25d7598376$var$write_old_storage({
                    t: "b",
                    v: data[C]
                }, SST);
                break;
            default:
                if (data[C] instanceof Date) {
                    celload = $a1a91b25d7598376$var$write_new_storage({
                        t: "s",
                        v: data[C].toISOString()
                    }, SST);
                    _celload = $a1a91b25d7598376$var$write_old_storage({
                        t: "s",
                        v: data[C].toISOString()
                    }, SST);
                    break;
                }
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $a1a91b25d7598376$var$write_varint49(cnt);
    tri[5][0].data = $a1a91b25d7598376$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $a1a91b25d7598376$var$u8concat(cell_storage);
    tri[3][0].data = $a1a91b25d7598376$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $a1a91b25d7598376$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $a1a91b25d7598376$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $a1a91b25d7598376$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $a1a91b25d7598376$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($a1a91b25d7598376$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $a1a91b25d7598376$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $a1a91b25d7598376$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $a1a91b25d7598376$var$build_numbers_deps(cfb);
    var docroot = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $a1a91b25d7598376$var$mappa($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1], $a1a91b25d7598376$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $a1a91b25d7598376$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $a1a91b25d7598376$var$mappa($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1], $a1a91b25d7598376$var$parse_TSP_Reference);
        }
        $a1a91b25d7598376$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $a1a91b25d7598376$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data);
        sheetref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $a1a91b25d7598376$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(doc);
    });
    var tiaref = -1;
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $a1a91b25d7598376$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $a1a91b25d7598376$var$mappa(sa[2], $a1a91b25d7598376$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $a1a91b25d7598376$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $a1a91b25d7598376$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            var loc2 = deps[newsheetref].location;
            loc2 = loc2.replace(/^Root Entry\//, "");
            loc2 = loc2.replace(/^Index\//, "").replace(/\.iwa$/, "");
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                var parentidx = mlist[3].findIndex(function(m) {
                    var _a, _b;
                    var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
                    if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc2;
                    if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc2) return true;
                    return false;
                });
                var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
                if (!parent[6]) parent[6] = [];
                parent[6].push({
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(tiaref)
                            }
                        ]
                    ])
                });
                mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
                ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
            });
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sa);
    });
    var tmaref = -1;
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $a1a91b25d7598376$var$parse_shallow(tiaroot.messages[0].data);
        var da = $a1a91b25d7598376$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $a1a91b25d7598376$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $a1a91b25d7598376$var$write_shallow(da);
        var oldtmaref = $a1a91b25d7598376$var$parse_TSP_Reference(tia[2][0].data);
        $a1a91b25d7598376$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $a1a91b25d7598376$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(tmaref);
        var tma = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(tia);
    });
    var loc = deps[tmaref].location;
    loc = loc.replace(/^Root Entry\//, "");
    loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $a1a91b25d7598376$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $a1a91b25d7598376$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(wsidx.toString(16).padStart(4, "0")));
        tma[1][0].data = $a1a91b25d7598376$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $a1a91b25d7598376$var$parse_shallow(tma[45][0].data);
            var ref = $a1a91b25d7598376$var$parse_TSP_Reference(srrta[1][0].data);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $a1a91b25d7598376$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $a1a91b25d7598376$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $a1a91b25d7598376$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $a1a91b25d7598376$var$parse_TSP_Reference(hsea[8][0].data);
                    $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $a1a91b25d7598376$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $a1a91b25d7598376$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $a1a91b25d7598376$var$parse_TSP_Reference(store[n][0].data);
            var newref = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldref);
            $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location;
                newloc = newloc.replace(/^Root Entry\//, "");
                newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8(newloc.replace(/-.*$/, ""))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8(newloc)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(Math.max(newref + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a3, _b2;
                        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
                        if ((_a3 = mm[3]) == null ? void 0 : _a3[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $a1a91b25d7598376$var$write_TSP_Reference(newref);
        });
        var row_headers = $a1a91b25d7598376$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $a1a91b25d7598376$var$parse_TSP_Reference(tspref.data);
            var newref = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldref);
            $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location;
                newloc = newloc.replace(/^Root Entry\//, "");
                newloc = newloc.replace(/^Index\//, "").replace(/\.iwa$/, "");
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8(newloc.replace(/-.*$/, ""))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8(newloc)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(Math.max(newref + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a2, _b2;
                        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
                        if ((_a2 = mm[3]) == null ? void 0 : _a2[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            tspref.data = $a1a91b25d7598376$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $a1a91b25d7598376$var$write_shallow(row_headers);
        var tiles = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $a1a91b25d7598376$var$parse_shallow(t.data);
            var oldtileref = $a1a91b25d7598376$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $a1a91b25d7598376$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldtileref);
                $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newtileref);
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    oldtile
                ])));
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(Math.max(newtileref + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    var parentidx = mlist[3].findIndex(function(m) {
                        var _a2, _b2;
                        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
                        if ((_a2 = mm[3]) == null ? void 0 : _a2[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
                        if (((_b2 = mm[2]) == null ? void 0 : _b2[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
                        return false;
                    });
                    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
                    if (!parent[6]) parent[6] = [];
                    parent[6].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newtileref)
                                }
                            ]
                        ])
                    });
                    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(newtileref);
            t.data = $a1a91b25d7598376$var$write_shallow(tst);
        });
        store[3][0].data = $a1a91b25d7598376$var$write_shallow(tiles);
        tma[4][0].data = $a1a91b25d7598376$var$write_shallow(store);
        tmaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(tma);
    });
}
function $a1a91b25d7598376$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$stru8(wsname)
            }
        ];
        drawables = $a1a91b25d7598376$var$mappa(sheetref[2], $a1a91b25d7598376$var$parse_TSP_Reference);
        docroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sheetref);
    });
    var tia = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $a1a91b25d7598376$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $a1a91b25d7598376$var$USE_WIDE_ROWS = true;
function $a1a91b25d7598376$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($a1a91b25d7598376$var$encode_range(range)));
    var data = $a1a91b25d7598376$var$sheet_to_json(ws, {
        range: range,
        header: 1
    });
    var SST = [
        "~Sh33tJ5~"
    ];
    var loc = deps[tmaref].location;
    loc = loc.replace(/^Root Entry\//, "");
    loc = loc.replace(/^Index\//, "").replace(/\.iwa$/, "");
    var pb = $a1a91b25d7598376$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $a1a91b25d7598376$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $a1a91b25d7598376$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $a1a91b25d7598376$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(store[1][0].data)[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $a1a91b25d7598376$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $a1a91b25d7598376$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $a1a91b25d7598376$var$write_varint49(R2);
            _bucket[4][0].data = $a1a91b25d7598376$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $a1a91b25d7598376$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $a1a91b25d7598376$var$write_shallow(base_bucket);
    });
    var col_header_ref = $a1a91b25d7598376$var$parse_TSP_Reference(store[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $a1a91b25d7598376$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $a1a91b25d7598376$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $a1a91b25d7598376$var$write_varint49(C);
            _bucket[4][0].data = $a1a91b25d7598376$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $a1a91b25d7598376$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $a1a91b25d7598376$var$write_shallow(base_bucket);
    });
    var rbtree = $a1a91b25d7598376$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(tstride)
        }
    ];
    var tileref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $a1a91b25d7598376$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        var parentidx = mlist[3].findIndex(function(m) {
            var _a, _b;
            var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
            if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
            if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
            return false;
        });
        var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
        if (!parent[6]) parent[6] = [];
        parent[6] = parent[6].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
    });
    $a1a91b25d7598376$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49($a1a91b25d7598376$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $a1a91b25d7598376$var$write_TST_TileRowInfo(data[R], SST, $a1a91b25d7598376$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $a1a91b25d7598376$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $a1a91b25d7598376$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $a1a91b25d7598376$var$write_iwam(6002, $a1a91b25d7598376$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
            newtile
        ]));
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.max(newtileid + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            var parentidx = mlist[3].findIndex(function(m) {
                var _a, _b;
                var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
                if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
                if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
                return false;
            });
            var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
            if (!parent[6]) parent[6] = [];
            parent[6].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(newtileid)
                        }
                    ]
                ])
            });
            mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
            ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
        });
        $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $a1a91b25d7598376$var$write_shallow(tilestore);
    store[9][0].data = $a1a91b25d7598376$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $a1a91b25d7598376$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $a1a91b25d7598376$var$write_iwam(6144, $a1a91b25d7598376$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $a1a91b25d7598376$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $a1a91b25d7598376$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_TSP_Reference(mergeid)
            }
        ];
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
            var parentidx = mlist[3].findIndex(function(m) {
                var _a, _b;
                var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
                if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
                if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
                return false;
            });
            var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
            if (!parent[6]) parent[6] = [];
            parent[6].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(mergeid)
                        }
                    ]
                ])
            });
            mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
            ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
        });
        $a1a91b25d7598376$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $a1a91b25d7598376$var$parse_TSP_Reference(store[4][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $a1a91b25d7598376$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        SST.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sstdata);
    });
    pb[4][0].data = $a1a91b25d7598376$var$write_shallow(store);
    tmaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(pb);
}
function $a1a91b25d7598376$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === "n") opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $a1a91b25d7598376$var$fix_read_opts(opts) {
    $a1a91b25d7598376$var$fix_opts_func([
        [
            "cellNF",
            false
        ],
        /* emit cell number format string as .z */ [
            "cellHTML",
            true
        ],
        /* emit html string as .h */ [
            "cellFormula",
            true
        ],
        /* emit formulae as .f */ [
            "cellStyles",
            false
        ],
        /* emits style/theme as .s */ [
            "cellText",
            true
        ],
        /* emit formatted text as .w */ [
            "cellDates",
            false
        ],
        /* emit date cells with type `d` */ [
            "sheetStubs",
            false
        ],
        /* emit empty cells */ [
            "sheetRows",
            0,
            "n"
        ],
        /* read n rows (0 = read all rows) */ [
            "bookDeps",
            false
        ],
        /* parse calculation chains */ [
            "bookSheets",
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            "bookProps",
            false
        ],
        /* only try to get properties (no Sheets) */ [
            "bookFiles",
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            "bookVBA",
            false
        ],
        /* include vba raw data (vbaraw) */ [
            "password",
            ""
        ],
        /* password */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $a1a91b25d7598376$var$fix_write_opts(opts) {
    $a1a91b25d7598376$var$fix_opts_func([
        [
            "cellDates",
            false
        ],
        /* write date cells with type `d` */ [
            "bookSST",
            false
        ],
        /* Generate Shared String Table */ [
            "bookType",
            "xlsx"
        ],
        /* Type of workbook (xlsx/m/b) */ [
            "compression",
            false
        ],
        /* Use file compression */ [
            "WTF",
            false
        ]
    ])(opts);
}
function $a1a91b25d7598376$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($a1a91b25d7598376$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($a1a91b25d7598376$var$RELS.CS && n == $a1a91b25d7598376$var$RELS.CS) return "chart";
    if ($a1a91b25d7598376$var$RELS.DS && n == $a1a91b25d7598376$var$RELS.DS) return "dialog";
    if ($a1a91b25d7598376$var$RELS.MS && n == $a1a91b25d7598376$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $a1a91b25d7598376$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels["!id"][w.id].Target,
                $a1a91b25d7598376$var$get_sheet_type(wbrels["!id"][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $a1a91b25d7598376$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, relsPath, true), path);
        var data = $a1a91b25d7598376$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case "sheet":
                _ws = $a1a91b25d7598376$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "chart":
                _ws = $a1a91b25d7598376$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws["!drawel"]) break;
                var dfile = $a1a91b25d7598376$var$resolve_path(_ws["!drawel"].Target, path);
                var drelsp = $a1a91b25d7598376$var$get_rels_path(dfile);
                var draw = $a1a91b25d7598376$var$parse_drawing($a1a91b25d7598376$var$getzipstr(zip, dfile, true), $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $a1a91b25d7598376$var$resolve_path(draw, dfile);
                var crelsp = $a1a91b25d7598376$var$get_rels_path(chartp);
                _ws = $a1a91b25d7598376$var$parse_chart($a1a91b25d7598376$var$getzipstr(zip, chartp, true), chartp, opts, $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case "macro":
                _ws = $a1a91b25d7598376$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case "dialog":
                _ws = $a1a91b25d7598376$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $a1a91b25d7598376$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $a1a91b25d7598376$var$RELS.CMNT) {
                dfile = $a1a91b25d7598376$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $a1a91b25d7598376$var$parse_cmnt($a1a91b25d7598376$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $a1a91b25d7598376$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $a1a91b25d7598376$var$RELS.TCMNT) {
                dfile = $a1a91b25d7598376$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($a1a91b25d7598376$var$parse_tcmnt_xml($a1a91b25d7598376$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $a1a91b25d7598376$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $a1a91b25d7598376$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == "/" ? x.slice(1) : x;
}
function $a1a91b25d7598376$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $a1a91b25d7598376$var$make_ssf();
    opts = opts || {};
    $a1a91b25d7598376$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($a1a91b25d7598376$var$safegetzipfile(zip, "META-INF/manifest.xml")) return $a1a91b25d7598376$var$parse_ods(zip, opts);
    /* UOC */ if ($a1a91b25d7598376$var$safegetzipfile(zip, "objectdata.xml")) return $a1a91b25d7598376$var$parse_ods(zip, opts);
    /* Numbers */ if ($a1a91b25d7598376$var$safegetzipfile(zip, "Index/Document.iwa")) {
        if (typeof Uint8Array == "undefined") throw new Error("NUMBERS file parsing requires Uint8Array support");
        if (typeof $a1a91b25d7598376$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $a1a91b25d7598376$var$parse_numbers_iwa(zip, opts);
            var _zip = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new();
            $a1a91b25d7598376$var$zipentries(zip).forEach(function(e) {
                $a1a91b25d7598376$var$zip_add_file(_zip, e, $a1a91b25d7598376$var$getzipbin(zip, e));
            });
            return $a1a91b25d7598376$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error("Unsupported NUMBERS file");
    }
    if (!$a1a91b25d7598376$var$safegetzipfile(zip, "[Content_Types].xml")) {
        if ($a1a91b25d7598376$var$safegetzipfile(zip, "index.xml.gz")) throw new Error("Unsupported NUMBERS 08 file");
        if ($a1a91b25d7598376$var$safegetzipfile(zip, "index.xml")) throw new Error("Unsupported NUMBERS 09 file");
        var index_zip = $a1a91b25d7598376$export$9f0e51cd97c572a.find(zip, "Index.zip");
        if (index_zip) {
            opts = $a1a91b25d7598376$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $a1a91b25d7598376$require$Buffer.isBuffer(index_zip.content)) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $a1a91b25d7598376$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error("Unsupported ZIP file");
    }
    var entries = $a1a91b25d7598376$var$zipentries(zip);
    var dir = $a1a91b25d7598376$var$parse_ct($a1a91b25d7598376$var$getzipstr(zip, "[Content_Types].xml"));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($a1a91b25d7598376$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$a1a91b25d7598376$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $a1a91b25d7598376$var$strs = [];
        if (dir.sst) try {
            $a1a91b25d7598376$var$strs = $a1a91b25d7598376$var$parse_sst($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $a1a91b25d7598376$var$parse_theme_xml($a1a91b25d7598376$var$getzipstr(zip, dir.themes[0].replace(/^\//, ""), true) || "", opts);
        if (dir.style) styles = $a1a91b25d7598376$var$parse_sty($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, $a1a91b25d7598376$var$get_rels_path($a1a91b25d7598376$var$strip_front_slash(link))), link);
            return $a1a91b25d7598376$var$parse_xlink($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $a1a91b25d7598376$var$parse_wb($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $a1a91b25d7598376$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $a1a91b25d7598376$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $a1a91b25d7598376$var$getzipstr(zip, $a1a91b25d7598376$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $a1a91b25d7598376$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== "undefined") out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $a1a91b25d7598376$var$parse_cc($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$a1a91b25d7598376$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = "xl/_rels/workbook." + wbext + ".rels";
    var wbrels = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $a1a91b25d7598376$var$parse_xlmeta($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $a1a91b25d7598376$var$parse_people_xml($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $a1a91b25d7598376$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $a1a91b25d7598376$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = "xl/" + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$a1a91b25d7598376$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$a1a91b25d7598376$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = "xl/worksheets/sheet" + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $a1a91b25d7598376$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $a1a91b25d7598376$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $a1a91b25d7598376$var$CT_VBA) out.vbaraw = $a1a91b25d7598376$var$getzipdata(zip, "xl/vbaProject.bin", true);
    }
    // TODO: pass back content types metdata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $a1a91b25d7598376$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = "Workbook", data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = "/!DataSpaces/Version";
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $a1a91b25d7598376$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = "/!DataSpaces/DataSpaceMap";
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $a1a91b25d7598376$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace";
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $a1a91b25d7598376$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary";
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $a1a91b25d7598376$var$parse_Primary(data.content);
    } catch (e) {}
    f = "/EncryptionInfo";
    data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $a1a91b25d7598376$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = "/EncryptedPackage";
    data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== "undefined") return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== "undefined") return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $a1a91b25d7598376$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($a1a91b25d7598376$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $a1a91b25d7598376$var$new_ct();
    $a1a91b25d7598376$var$fix_write_opts(opts = opts || {});
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 2, f, $a1a91b25d7598376$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 3, f, $a1a91b25d7598376$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $a1a91b25d7598376$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $a1a91b25d7598376$var$add_rels(opts.rels, 4, f, $a1a91b25d7598376$var$RELS.CUST_PROPS);
    }
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                cf = "xl/comments" + rId + "." + wbext;
                $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $a1a91b25d7598376$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $a1a91b25d7598376$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $a1a91b25d7598376$var$write_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $a1a91b25d7598376$var$zip_add_file(zip, $a1a91b25d7598376$var$get_rels_path(f), $a1a91b25d7598376$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $a1a91b25d7598376$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 1, f, $a1a91b25d7598376$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $a1a91b25d7598376$var$write_theme(wb.Themes, opts);
    $a1a91b25d7598376$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $a1a91b25d7598376$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "styles." + wbext, $a1a91b25d7598376$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $a1a91b25d7598376$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $a1a91b25d7598376$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $a1a91b25d7598376$var$RELS.XLMETA);
    $a1a91b25d7598376$var$zip_add_file(zip, "[Content_Types].xml", $a1a91b25d7598376$var$write_ct(ct, opts));
    $a1a91b25d7598376$var$zip_add_file(zip, "_rels/.rels", $a1a91b25d7598376$var$write_rels(opts.rels));
    $a1a91b25d7598376$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $a1a91b25d7598376$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $a1a91b25d7598376$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($a1a91b25d7598376$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $a1a91b25d7598376$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $a1a91b25d7598376$var$new_ct();
    $a1a91b25d7598376$var$fix_write_opts(opts = opts || {});
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 2, f, $a1a91b25d7598376$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 3, f, $a1a91b25d7598376$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $a1a91b25d7598376$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $a1a91b25d7598376$var$add_rels(opts.rels, 4, f, $a1a91b25d7598376$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            "!id": {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.WS[0]);
        if (ws) {
            var comments = ws["!comments"];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $a1a91b25d7598376$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $a1a91b25d7598376$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $a1a91b25d7598376$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws["!legacy"]) {
                if (need_vml) $a1a91b25d7598376$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $a1a91b25d7598376$var$write_vml(rId, ws["!comments"]));
            }
            delete ws["!comments"];
            delete ws["!legacy"];
        }
        if (wsrels["!id"].rId1) $a1a91b25d7598376$var$zip_add_file(zip, $a1a91b25d7598376$var$get_rels_path(f), $a1a91b25d7598376$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $a1a91b25d7598376$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 1, f, $a1a91b25d7598376$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $a1a91b25d7598376$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "styles." + wbext, $a1a91b25d7598376$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $a1a91b25d7598376$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $a1a91b25d7598376$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $a1a91b25d7598376$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_people_xml(people, opts));
        ct.people.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "persons/person.xml", $a1a91b25d7598376$var$RELS.PEOPLE);
    }
    $a1a91b25d7598376$var$zip_add_file(zip, "[Content_Types].xml", $a1a91b25d7598376$var$write_ct(ct, opts));
    $a1a91b25d7598376$var$zip_add_file(zip, "_rels/.rels", $a1a91b25d7598376$var$write_rels(opts.rels));
    $a1a91b25d7598376$var$zip_add_file(zip, "xl/_rels/workbook." + wbext + ".rels", $a1a91b25d7598376$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $a1a91b25d7598376$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case "buffer":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case "base64":
            x = $a1a91b25d7598376$var$Base64_decode(f.slice(0, 12));
            break;
        case "binary":
            x = f;
            break;
        case "array":
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $a1a91b25d7598376$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $a1a91b25d7598376$var$parse_xlsxcfb(cfb, opts);
    return $a1a91b25d7598376$export$b41972a043aba84c(cfb, opts);
}
function $a1a91b25d7598376$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $a1a91b25d7598376$var$zip_read(d, o);
    return $a1a91b25d7598376$export$b165387946f79a1(zip, o);
}
function $a1a91b25d7598376$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $a1a91b25d7598376$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $a1a91b25d7598376$var$PRN.to_workbook(data, o);
}
function $a1a91b25d7598376$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $a1a91b25d7598376$var$firstbyte(data, o);
    switch(o.type){
        case "base64":
            str = $a1a91b25d7598376$var$Base64_decode(data);
            break;
        case "binary":
            str = data;
            break;
        case "buffer":
            str = data.toString("binary");
            break;
        case "array":
            str = $a1a91b25d7598376$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $a1a91b25d7598376$var$utf8read(str);
    o.type = "binary";
    return $a1a91b25d7598376$var$read_plaintext(str, o);
}
function $a1a91b25d7598376$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == "base64") d = $a1a91b25d7598376$var$Base64_decode(d);
    d = typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, d.slice(2), "str") : $a1a91b25d7598376$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $a1a91b25d7598376$var$read_plaintext(d, o);
}
function $a1a91b25d7598376$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $a1a91b25d7598376$var$utf8write(data);
}
function $a1a91b25d7598376$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $a1a91b25d7598376$var$PRN.to_workbook(data, o);
    }
    return $a1a91b25d7598376$var$PRN.to_workbook(d, o);
}
function $a1a91b25d7598376$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $a1a91b25d7598376$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $a1a91b25d7598376$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(data), (o = $a1a91b25d7598376$var$dup(o), o.type = "array", o));
    if (typeof Uint8Array !== "undefined" && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $a1a91b25d7598376$var$_ssfopts = {};
    if (o.dateNF) $a1a91b25d7598376$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $a1a91b25d7598376$var$has_buf ? "buffer" : "binary";
        d = $a1a91b25d7598376$var$read_binary(data);
        if (typeof Uint8Array !== "undefined" && !$a1a91b25d7598376$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $a1a91b25d7598376$var$bstrify(data);
    }
    if (o.type == "array" && typeof Uint8Array !== "undefined" && data instanceof Uint8Array && typeof ArrayBuffer !== "undefined") {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $a1a91b25d7598376$var$dup(o);
            o.type = "array";
            return $a1a91b25d7598376$export$aafa59e2e03f2942($a1a91b25d7598376$var$ab2a(d), o);
        }
    }
    switch((n = $a1a91b25d7598376$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $a1a91b25d7598376$var$read_cfb($a1a91b25d7598376$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $a1a91b25d7598376$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $a1a91b25d7598376$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $a1a91b25d7598376$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $a1a91b25d7598376$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $a1a91b25d7598376$var$read_zip(d, o) : $a1a91b25d7598376$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $a1a91b25d7598376$var$parse_xlml(d, o) : $a1a91b25d7598376$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $a1a91b25d7598376$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $a1a91b25d7598376$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $a1a91b25d7598376$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $a1a91b25d7598376$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($a1a91b25d7598376$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $a1a91b25d7598376$var$DBF.to_workbook(d, o);
    return $a1a91b25d7598376$var$read_prn(data, d, o, str);
}
function $a1a91b25d7598376$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = "file";
    return $a1a91b25d7598376$export$aafa59e2e03f2942(filename, o);
}
function $a1a91b25d7598376$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $a1a91b25d7598376$var$write_dl(o.file, $a1a91b25d7598376$export$9f0e51cd97c572a.write(cfb, {
                type: $a1a91b25d7598376$var$has_buf ? "buffer" : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $a1a91b25d7598376$export$9f0e51cd97c572a.write(cfb, o);
}
function $a1a91b25d7598376$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $a1a91b25d7598376$var$write_ods(wb, opts);
        case "numbers":
            return $a1a91b25d7598376$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $a1a91b25d7598376$var$write_zip_xlsb(wb, opts);
        default:
            return $a1a91b25d7598376$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $a1a91b25d7598376$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $a1a91b25d7598376$var$dup(opts || {});
    var z = $a1a91b25d7598376$var$write_zip(wb, o);
    return $a1a91b25d7598376$var$write_zip_denouement(z, o);
}
function $a1a91b25d7598376$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $a1a91b25d7598376$var$dup(opts || {});
    var z = $a1a91b25d7598376$var$write_zip_xlsx(wb, o);
    return $a1a91b25d7598376$var$write_zip_denouement(z, o);
}
function $a1a91b25d7598376$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $a1a91b25d7598376$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = "DEFLATE";
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $a1a91b25d7598376$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($a1a91b25d7598376$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== "undefined") return $a1a91b25d7598376$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $a1a91b25d7598376$var$write_dl(o.file, out);
    return o.type == "string" ? $a1a91b25d7598376$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $a1a91b25d7598376$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $a1a91b25d7598376$var$write_xlscfb(wb, o);
    return $a1a91b25d7598376$var$write_cfb_ctr(cfb, o);
}
function $a1a91b25d7598376$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$Base64_encode($a1a91b25d7598376$var$utf8write(o));
        case "binary":
            return $a1a91b25d7598376$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, o, "utf8");
        case "buffer":
            if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(o, "utf8");
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $a1a91b25d7598376$var$write_string_type(o, {
                type: "binary"
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $a1a91b25d7598376$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, out, "binary");
        case "buffer":
            if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(out, "binary");
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $a1a91b25d7598376$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == "base64" ? $a1a91b25d7598376$var$Base64_encode(bstr) : opts.type == "string" ? $a1a91b25d7598376$var$utf8read(bstr) : bstr;
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $a1a91b25d7598376$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $a1a91b25d7598376$var$reset_cp();
    $a1a91b25d7598376$var$check_wb(wb);
    var o = $a1a91b25d7598376$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $a1a91b25d7598376$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $a1a91b25d7598376$var$s2ab(out);
    }
    return $a1a91b25d7598376$var$write_zip_typeXLSX(wb, o);
}
function $a1a91b25d7598376$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $a1a91b25d7598376$var$reset_cp();
    $a1a91b25d7598376$var$check_wb(wb);
    var o = $a1a91b25d7598376$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $a1a91b25d7598376$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $a1a91b25d7598376$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || "xlsb"){
        case "xml":
        case "xlml":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$write_xlml(wb, o), o);
        case "slk":
        case "sylk":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case "htm":
        case "html":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "txt":
            return $a1a91b25d7598376$var$write_stxt_type($a1a91b25d7598376$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "csv":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\uFEFF");
        case "dif":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "dbf":
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "prn":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "rtf":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "eth":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "fods":
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$write_ods(wb, o), o);
        case "wk1":
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case "wk3":
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$WK_.book_to_wk3(wb, o), o);
        case "biff2":
            if (!o.biff) o.biff = 2; /* falls through */ 
        case "biff3":
            if (!o.biff) o.biff = 3; /* falls through */ 
        case "biff4":
            if (!o.biff) o.biff = 4;
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$write_biff_buf(wb, o), o);
        case "biff5":
            if (!o.biff) o.biff = 5; /* falls through */ 
        case "biff8":
        case "xla":
        case "xls":
            if (!o.biff) o.biff = 8;
            return $a1a91b25d7598376$var$write_cfb_type(wb, o);
        case "xlsx":
        case "xlsm":
        case "xlam":
        case "xlsb":
        case "numbers":
        case "ods":
            return $a1a91b25d7598376$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $a1a91b25d7598376$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $a1a91b25d7598376$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    return $a1a91b25d7598376$export$68d8715fc104d294(wb, o);
}
function $a1a91b25d7598376$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    return $a1a91b25d7598376$export$f6ca43591cb061b1(wb, o);
}
function $a1a91b25d7598376$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = "file";
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    o.type = "buffer";
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $a1a91b25d7598376$var$_fs.writeFile(filename, $a1a91b25d7598376$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $a1a91b25d7598376$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $a1a91b25d7598376$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, "__rowNum__", {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val === undefined || val.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val.v;
        switch(val.t){
            case "z":
                if (v == null) break;
                continue;
            case "e":
                v = v == 0 ? null : void 0;
                break;
            case "s":
            case "d":
            case "b":
            case "n":
                break;
            default:
                throw new Error("unrecognized type " + val.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = raw && (val.t !== "n" || val.t === "n" && o.rawNumbers !== false) ? v : $a1a91b25d7598376$var$format_cell(val, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $a1a91b25d7598376$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case "string":
            r = $a1a91b25d7598376$var$safe_decode_range(range);
            break;
        case "number":
            r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $a1a91b25d7598376$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $a1a91b25d7598376$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $a1a91b25d7598376$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $a1a91b25d7598376$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $a1a91b25d7598376$var$qreg = /"/g;
function $a1a91b25d7598376$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $a1a91b25d7598376$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val == null) txt = "";
        else if (val.v != null) {
            isempty = false;
            txt = "" + (o.rawNumbers && val.t == "n" ? val.v : $a1a91b25d7598376$var$format_cell(val, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = '"' + txt.replace($a1a91b25d7598376$var$qreg, '""') + '"';
                break;
            }
            if (txt == "ID") txt = '"ID"';
        } else if (val.f != null && !val.F) {
            isempty = false;
            txt = "=" + val.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($a1a91b25d7598376$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $a1a91b25d7598376$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $a1a91b25d7598376$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
        if (row == null) continue;
        if (o.strip) row = row.replace(endregex, "");
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $a1a91b25d7598376$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "	";
    opts.RS = "\n";
    var s = $a1a91b25d7598376$var$sheet_to_csv(sheet, opts);
    if (typeof $a1a91b25d7598376$var$$cptable == "undefined" || opts.type == "string") return s;
    var o = $a1a91b25d7598376$var$$cptable.utils.encode(1200, s, "str");
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $a1a91b25d7598376$var$sheet_to_formulae(sheet /*:Worksheet*/ ) /*:Array<string>*/ {
    var y = "", x, val = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val = x.f;
            else if (x.t == "z") continue;
            else if (x.t == "n" && x.v != null) val = "" + x.v;
            else if (x.t == "b") val = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == "s") val = "'" + x.v;
            else val = "" + x.v;
            cmds[cmds.length] = y + "=" + val;
        }
    }
    return cmds;
}
function $a1a91b25d7598376$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($a1a91b25d7598376$var$DENSE != null && dense == null) dense = $a1a91b25d7598376$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == "number") _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $a1a91b25d7598376$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $a1a91b25d7598376$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = "z";
            var z = "";
            var ref = dense ? "" : $a1a91b25d7598376$var$encode_col(_C + C) + $a1a91b25d7598376$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === "object" && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == "number") t = "n";
                else if (typeof v == "boolean") t = "b";
                else if (typeof v == "string") t = "s";
                else if (v instanceof Date) {
                    t = "d";
                    if (!o.cellDates) {
                        t = "n";
                        v = $a1a91b25d7598376$var$datenum(v);
                    }
                    z = cell != null && cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = "e";
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $a1a91b25d7598376$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: "s",
        v: hdr[C]
    };
    else ws[$a1a91b25d7598376$var$encode_col(C + _C) + __R] = {
        t: "s",
        v: hdr[C]
    };
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $a1a91b25d7598376$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $a1a91b25d7598376$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $a1a91b25d7598376$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: "z"
            });
        }
        return ws[R] || (ws[R] = {
            t: "z"
        });
    }
    /* cell address object */ if (typeof R != "number") return $a1a91b25d7598376$var$ws_get_cell_stub(ws, $a1a91b25d7598376$var$encode_cell(R));
    /* R and C are 0-based indices */ return $a1a91b25d7598376$var$ws_get_cell_stub(ws, $a1a91b25d7598376$var$encode_col(C || 0) + $a1a91b25d7598376$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $a1a91b25d7598376$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank workbook object */ function $a1a91b25d7598376$var$book_new() /*:Workbook*/ {
    return {
        SheetNames: [],
        Sheets: {}
    };
}
/* add a worksheet to the end of a given workbook */ function $a1a91b25d7598376$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0) {
        var m = name.match(/(^.*?)(\d+)$/);
        i = m && +m[2] || 0;
        var root = m && m[1] || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $a1a91b25d7598376$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $a1a91b25d7598376$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $a1a91b25d7598376$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $a1a91b25d7598376$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $a1a91b25d7598376$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $a1a91b25d7598376$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $a1a91b25d7598376$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $a1a91b25d7598376$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $a1a91b25d7598376$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $a1a91b25d7598376$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $a1a91b25d7598376$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $a1a91b25d7598376$var$ws_get_cell_stub(ws, R, C);
        cell.t = "n";
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(wsr);
    return ws;
}
var $a1a91b25d7598376$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $a1a91b25d7598376$var$encode_col,
    encode_row: $a1a91b25d7598376$var$encode_row,
    encode_cell: $a1a91b25d7598376$var$encode_cell,
    encode_range: $a1a91b25d7598376$var$encode_range,
    decode_col: $a1a91b25d7598376$var$decode_col,
    decode_row: $a1a91b25d7598376$var$decode_row,
    split_cell: $a1a91b25d7598376$var$split_cell,
    decode_cell: $a1a91b25d7598376$var$decode_cell,
    decode_range: $a1a91b25d7598376$var$decode_range,
    format_cell: $a1a91b25d7598376$var$format_cell,
    sheet_add_aoa: $a1a91b25d7598376$var$sheet_add_aoa,
    sheet_add_json: $a1a91b25d7598376$var$sheet_add_json,
    sheet_add_dom: $a1a91b25d7598376$var$sheet_add_dom,
    aoa_to_sheet: $a1a91b25d7598376$var$aoa_to_sheet,
    json_to_sheet: $a1a91b25d7598376$var$json_to_sheet,
    table_to_sheet: $a1a91b25d7598376$var$parse_dom_table,
    table_to_book: $a1a91b25d7598376$var$table_to_book,
    sheet_to_csv: $a1a91b25d7598376$var$sheet_to_csv,
    sheet_to_txt: $a1a91b25d7598376$var$sheet_to_txt,
    sheet_to_json: $a1a91b25d7598376$var$sheet_to_json,
    sheet_to_html: $a1a91b25d7598376$var$sheet_to_html,
    sheet_to_formulae: $a1a91b25d7598376$var$sheet_to_formulae,
    sheet_to_row_object_array: $a1a91b25d7598376$var$sheet_to_json,
    sheet_get_cell: $a1a91b25d7598376$var$ws_get_cell_stub,
    book_new: $a1a91b25d7598376$var$book_new,
    book_append_sheet: $a1a91b25d7598376$var$book_append_sheet,
    book_set_sheet_visibility: $a1a91b25d7598376$var$book_set_sheet_visibility,
    cell_set_number_format: $a1a91b25d7598376$var$cell_set_number_format,
    cell_set_hyperlink: $a1a91b25d7598376$var$cell_set_hyperlink,
    cell_set_internal_link: $a1a91b25d7598376$var$cell_set_internal_link,
    cell_add_comment: $a1a91b25d7598376$var$cell_add_comment,
    sheet_set_array_formula: $a1a91b25d7598376$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $a1a91b25d7598376$var$_Readable;
function $a1a91b25d7598376$var$set_readable(R) {
    $a1a91b25d7598376$var$_Readable = R;
}
function $a1a91b25d7598376$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var endregex = new RegExp((FS == "|" ? "\\|" : FS) + "+$");
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $a1a91b25d7598376$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, o);
            if (row != null) {
                if (o.strip) row = row.replace(endregex, "");
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $a1a91b25d7598376$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $a1a91b25d7598376$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $a1a91b25d7598376$var$HTML_END;
    stream.push(header);
    var r = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    stream.push($a1a91b25d7598376$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($a1a91b25d7598376$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $a1a91b25d7598376$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val = {
        t: "n",
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case "string":
            r = $a1a91b25d7598376$var$safe_decode_range(range);
            break;
        case "number":
            r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $a1a91b25d7598376$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $a1a91b25d7598376$var$encode_col(C);
        val = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val == null) val = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $a1a91b25d7598376$var$format_cell(val, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $a1a91b25d7598376$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
var $a1a91b25d7598376$export$4938110305e6185f = {
    to_json: $a1a91b25d7598376$var$write_json_stream,
    to_html: $a1a91b25d7598376$var$write_html_stream,
    to_csv: $a1a91b25d7598376$var$write_csv_stream,
    set_readable: $a1a91b25d7598376$var$set_readable
};
const $a1a91b25d7598376$export$83d89fbfd8236492 = $a1a91b25d7598376$var$XLSX.version;
var $a1a91b25d7598376$export$2e2bcd8739ae039 = {
    parse_xlscfb: $a1a91b25d7598376$export$b41972a043aba84c,
    parse_zip: $a1a91b25d7598376$export$b165387946f79a1,
    read: $a1a91b25d7598376$export$aafa59e2e03f2942,
    readFile: $a1a91b25d7598376$export$72c04af63de9061a,
    readFileSync: $a1a91b25d7598376$export$72c04af63de9061a,
    write: $a1a91b25d7598376$export$68d8715fc104d294,
    writeFile: $a1a91b25d7598376$export$552bfb764b5cd2b4,
    writeFileSync: $a1a91b25d7598376$export$552bfb764b5cd2b4,
    writeFileAsync: $a1a91b25d7598376$export$25469296c4b8ebda,
    writeXLSX: $a1a91b25d7598376$export$f6ca43591cb061b1,
    writeFileXLSX: $a1a91b25d7598376$export$40a06aea54ee074e,
    utils: $a1a91b25d7598376$export$eab97d15b1788b8d,
    set_fs: $a1a91b25d7598376$export$a48eb669e1768bcf,
    set_cptable: $a1a91b25d7598376$export$58f247d16f363b86,
    stream: $a1a91b25d7598376$export$4938110305e6185f,
    SSF: $a1a91b25d7598376$export$40d8edd678456c2b,
    CFB: $a1a91b25d7598376$export$9f0e51cd97c572a
};


var $cc5debf93af04dae$exports = {};

$parcel$export($cc5debf93af04dae$exports, "version", function () { return $cc5debf93af04dae$export$83d89fbfd8236492; });
$parcel$export($cc5debf93af04dae$exports, "cptable", function () { return $cc5debf93af04dae$export$70da684357f001c0; });
$parcel$export($cc5debf93af04dae$exports, "utils", function () { return $cc5debf93af04dae$export$eab97d15b1788b8d; });
/*! cpexcel.mjs (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W100 */ 
var $ifbub = parcelRequire("ifbub");
var $cc5debf93af04dae$require$Buffer = $ifbub.Buffer;
const $cc5debf93af04dae$export$83d89fbfd8236492 = "1.15.0";
const $cc5debf93af04dae$export$70da684357f001c0 = {};
$cc5debf93af04dae$export$70da684357f001c0[437] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[620] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\u0105\xe7\xea\xeb\xe8\xef\xee\u0107\xc4\u0104\u0118\u0119\u0142\xf4\xf6\u0106\xfb\xf9\u015A\xd6\xdc\xa2\u0141\xa5\u015B\u0192\u0179\u017B\xf3\xd3\u0144\u0143\u017A\u017C\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[737] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[850] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[852] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[857] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[861] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[865] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[866] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[874] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[895] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u010C\xfc\xe9\u010F\xe4\u010E\u0164\u010D\u011B\u011A\u0139\xcd\u013E\u01EA\xc4\xc1\xc9\u017E\u017D\xf4\xf6\xd3\u016F\xda\xfd\xd6\xdc\u0160\u013D\xdd\u0158\u0165\xe1\xed\xf3\xfa\u0148\u0147\u016E\xd4\u0161\u0159\u0155\u0154\xbc\xa7\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[932] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF61\uFF62\uFF63\uFF64\uFF65\uFF66\uFF67\uFF68\uFF69\uFF6A\uFF6B\uFF6C\uFF6D\uFF6E\uFF6F\uFF70\uFF71\uFF72\uFF73\uFF74\uFF75\uFF76\uFF77\uFF78\uFF79\uFF7A\uFF7B\uFF7C\uFF7D\uFF7E\uFF7F\uFF80\uFF81\uFF82\uFF83\uFF84\uFF85\uFF86\uFF87\uFF88\uFF89\uFF8A\uFF8B\uFF8C\uFF8D\uFF8E\uFF8F\uFF90\uFF91\uFF92\uFF93\uFF94\uFF95\uFF96\uFF97\uFF98\uFF99\uFF9A\uFF9B\uFF9C\uFF9D\uFF9E\uFF9F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\uFF0B\uFF0D\xb1\xd7\uFFFD\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6\uFFFD\uFFFD\uFFFD\uFFFD\u25EF\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\uFFFD\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\uFFFD\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\u246A\u246B\u246C\u246D\u246E\u246F\u2470\u2471\u2472\u2473\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFFD\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u337B\uFFFD\u301D\u301F\u2116\u33CD\u2121\u32A4\u32A5\u32A6\u32A7\u32A8\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\uFFFD\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\uFFFD\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\uFFFD\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\uFFFD\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\uFFFD\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\uFFFD\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\uFFFD\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\uFFFD\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\uFFFD\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\uFFFD\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\uFFFD\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\uFFFD\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\uFFFD\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\uFFFD\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\uFFFD\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\uFFFD\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\uFFFD\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\uFFFD\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\uFFFD\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\uFFFD\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\uFFFD\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\uFFFD\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\uFFFD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\uFFFD\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\uFFFD\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\uFFFD\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\uFFFD\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\uFFFD\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\uFFFD\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\uFFFD\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\uFFFD\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\uFFFD\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\uFFFD\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFFFD\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\uFFFD\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFE2\uFFE4\uFF07\uFF02\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\uFFFD\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFFFD\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[936] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A\u4E6B\u4E6C\u4E6D\u4E6E\u4E6F\u4E72\u4E74\u4E75\u4E76\u4E77\u4E78\u4E79\u4E7A\u4E7B\u4E7C\u4E7D\u4E7F\u4E80\u4E81\u4E82\u4E83\u4E84\u4E85\u4E87\u4E8A\uFFFD\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02\u4F03\u4F04\u4F05\u4F06\u4F07\u4F08\u4F0B\u4F0C\u4F12\u4F13\u4F14\u4F15\u4F16\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F3F\u4F40\u4F41\u4F42\u4F44\u4F45\u4F47\u4F48\u4F49\u4F4A\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4FA4\u4FAB\u4FAD\u4FB0\u4FB1\u4FB2\u4FB3\u4FB4\u4FB6\u4FB7\u4FB8\u4FB9\u4FBA\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2\u4FD3\u4FD4\u4FD5\u4FD6\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF\u5000\u5001\u5002\u5003\u5004\u5005\u5006\u5007\u5008\u5009\u500A\uFFFD\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F\u5030\u5031\u5032\u5033\u5034\u5035\u5036\u5037\u5038\u5039\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050\u5051\u5052\u5053\u5054\u5056\u5057\u5058\u5059\u505B\u505D\u505E\u505F\u5060\u5061\u5062\u5063\u5064\u5066\u5067\u5068\u5069\u506A\u506B\u506D\u506E\u506F\u5070\u5071\u5072\u5073\u5074\u5075\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E\u508F\u5090\u5091\u5092\u5093\u5094\u5095\u5096\u5097\u5098\u5099\u509A\u509B\u509C\u509D\u509E\u509F\u50A0\u50A1\u50A2\u50A4\u50A6\u50AA\u50AB\u50AD\u50AE\u50AF\u50B0\u50B1\u50B3\u50B4\u50B5\u50B6\u50B7\u50B8\u50B9\u50BC\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u50BD\u50BE\u50BF\u50C0\u50C1\u50C2\u50C3\u50C4\u50C5\u50C6\u50C7\u50C8\u50C9\u50CA\u50CB\u50CC\u50CD\u50CE\u50D0\u50D1\u50D2\u50D3\u50D4\u50D5\u50D7\u50D8\u50D9\u50DB\u50DC\u50DD\u50DE\u50DF\u50E0\u50E1\u50E2\u50E3\u50E4\u50E5\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6\u50F7\u50F8\u50F9\u50FA\u50FC\u50FD\u50FE\u50FF\u5100\u5101\u5102\u5103\u5104\u5105\u5108\uFFFD\u5109\u510A\u510C\u510D\u510E\u510F\u5110\u5111\u5113\u5114\u5115\u5116\u5117\u5118\u5119\u511A\u511B\u511C\u511D\u511E\u511F\u5120\u5122\u5123\u5124\u5125\u5126\u5127\u5128\u5129\u512A\u512B\u512C\u512D\u512E\u512F\u5130\u5131\u5132\u5133\u5134\u5135\u5136\u5137\u5138\u5139\u513A\u513B\u513C\u513D\u513E\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D\u515E\u515F\u5160\u5161\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6\u51A7\u51A8\u51A9\u51AA\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2\u51D3\u51D4\u51D5\u51D6\u51D7\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5\u51E6\u51E7\u51E8\u51E9\u51EA\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244\u5245\u5246\u5247\u5248\u5249\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258\uFFFD\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273\u5274\u5275\u5276\u5277\u5278\u5279\u527A\u527B\u527C\u527E\u5280\u5283\u5284\u5285\u5286\u5287\u5289\u528A\u528B\u528C\u528D\u528E\u528F\u5291\u5292\u5294\u5295\u5296\u5297\u5298\u5299\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4\u52B5\u52B6\u52B7\u52B8\u52B9\u52BA\u52BB\u52BC\u52BD\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9\u52DA\u52DB\u52DC\u52DD\u52DE\u52E0\u52E1\u52E2\u52E3\u52E5\u52E6\u52E7\u52E8\u52E9\u52EA\u52EB\u52EC\u52ED\u52EE\u52EF\u52F1\u52F2\u52F3\u52F4\u52F5\u52F6\u52F7\u52F8\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[133] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F\u5330\u5331\u5332\u5333\u5334\u5335\u5336\u5337\u5338\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F\uFFFD\u5390\u5391\u5392\u5393\u5394\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF\u53B0\u53B1\u53B2\u53B3\u53B4\u53B5\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3\u53C4\u53C5\u53C6\u53C7\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D\u545E\u545F\u5460\u5461\u5463\u5465\u5467\u5469\u546A\u546B\u546C\u546D\u546E\u546F\u5470\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1\uFFFD".split("");
    for(j = 0; j != D[133].length; ++j)if (D[133][j].charCodeAt(0) !== 0xFFFD) {
        e[D[133][j]] = 34048 + j;
        d[34048 + j] = D[133][j];
    }
    D[134] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0\u54E1\u54E2\u54E3\u54E4\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4\u54F5\u54F6\u54F7\u54F8\u54F9\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A\u550B\u550C\u550D\u550E\u5512\u5513\u5515\u5516\u5517\u5518\u5519\u551A\u551C\u551D\u551E\u551F\u5521\u5525\u5526\uFFFD\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B\u554C\u554D\u554E\u554F\u5551\u5552\u5553\u5554\u5557\u5558\u5559\u555A\u555B\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F\u5570\u5571\u5572\u5573\u5574\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0\u55A1\u55A2\u55A3\u55A4\u55A5\u55A6\u55A8\u55A9\u55AA\u55AB\u55AC\u55AD\u55AE\u55AF\u55B0\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF\u55C0\u55C1\u55C2\u55C3\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7\u55D8\u55D9\u55DA\u55DB\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8\u55F9\u55FA\u55FB\u55FC\u55FF\u5602\u5603\u5604\u5605\uFFFD".split("");
    for(j = 0; j != D[134].length; ++j)if (D[134][j].charCodeAt(0) !== 0xFFFD) {
        e[D[134][j]] = 34304 + j;
        d[34304 + j] = D[134][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5606\u5607\u560A\u560B\u560D\u5610\u5611\u5612\u5613\u5614\u5615\u5616\u5617\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640\u5641\u5642\u5643\u5644\u5645\u5646\u5647\u5648\u5649\u564A\u564B\u564F\u5650\u5651\u5652\u5653\u5655\u5656\u565A\u565B\u565D\u565E\u565F\u5660\u5661\uFFFD\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D\u567E\u567F\u5680\u5681\u5682\u5683\u5684\u5687\u5688\u5689\u568A\u568B\u568C\u568D\u5690\u5691\u5692\u5694\u5695\u5696\u5697\u5698\u5699\u569A\u569B\u569C\u569D\u569E\u569F\u56A0\u56A1\u56A2\u56A4\u56A5\u56A6\u56A7\u56A8\u56A9\u56AA\u56AB\u56AC\u56AD\u56AE\u56B0\u56B1\u56B2\u56B3\u56B4\u56B5\u56B6\u56B8\u56B9\u56BA\u56BB\u56BD\u56BE\u56BF\u56C0\u56C1\u56C2\u56C3\u56C4\u56C5\u56C6\u56C7\u56C8\u56C9\u56CB\u56CC\u56CD\u56CE\u56CF\u56D0\u56D1\u56D2\u56D3\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5\u56E6\u56E7\u56E8\u56E9\u56EA\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B\u570C\u570D\u570E\u570F\u5710\u5711\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5712\u5713\u5714\u5715\u5716\u5717\u5718\u5719\u571A\u571B\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734\u5735\u5736\u5737\u5738\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752\u5753\u5754\u5755\u5756\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780\uFFFD\u5781\u5787\u5788\u5789\u578A\u578D\u578E\u578F\u5790\u5791\u5794\u5795\u5796\u5797\u5798\u5799\u579A\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9\u57BA\u57BB\u57BC\u57BD\u57BE\u57BF\u57C0\u57C1\u57C4\u57C5\u57C6\u57C7\u57C8\u57C9\u57CA\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5\u57E6\u57E7\u57E8\u57E9\u57EA\u57EB\u57EC\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825\u5826\u5827\u5828\u5829\u582B\u582C\u582D\u582E\u582F\u5831\u5832\u5833\u5834\u5836\u5837\u5838\u5839\u583A\u583B\u583C\u583D\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u583E\u583F\u5840\u5841\u5842\u5843\u5845\u5846\u5847\u5848\u5849\u584A\u584B\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859\u585A\u585B\u585C\u585D\u585F\u5860\u5861\u5862\u5863\u5864\u5866\u5867\u5868\u5869\u586A\u586D\u586E\u586F\u5870\u5871\u5872\u5873\u5874\u5875\u5876\u5877\u5878\u5879\u587A\u587B\u587C\u587D\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C\uFFFD\u588D\u588E\u588F\u5890\u5891\u5894\u5895\u5896\u5897\u5898\u589B\u589C\u589D\u58A0\u58A1\u58A2\u58A3\u58A4\u58A5\u58A6\u58A7\u58AA\u58AB\u58AC\u58AD\u58AE\u58AF\u58B0\u58B1\u58B2\u58B3\u58B4\u58B5\u58B6\u58B7\u58B8\u58B9\u58BA\u58BB\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6\u58C7\u58C8\u58C9\u58CA\u58CB\u58CC\u58CD\u58CE\u58CF\u58D0\u58D2\u58D3\u58D4\u58D6\u58D7\u58D8\u58D9\u58DA\u58DB\u58DC\u58DD\u58DE\u58DF\u58E0\u58E1\u58E2\u58E3\u58E5\u58E6\u58E7\u58E8\u58E9\u58EA\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA\u58FB\u58FC\u58FD\u58FE\u58FF\u5900\u5901\u5903\u5905\u5906\u5908\u5909\u590A\u590B\u590C\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B\u595C\u595D\u595E\u595F\u5961\u5963\u5964\u5966\u5967\u5968\u5969\u596A\u596B\u596C\u596D\u596E\u596F\u5970\u5971\u5972\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6\uFFFD\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3\u59B4\u59B5\u59B6\u59B7\u59B8\u59BA\u59BC\u59BD\u59BF\u59C0\u59C1\u59C2\u59C3\u59C4\u59C5\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE\u59DF\u59E0\u59E1\u59E2\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED\u59EE\u59EF\u59F0\u59F1\u59F2\u59F3\u59F4\u59F5\u59F6\u59F7\u59F8\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A\u5A2B\u5A2C\u5A2D\u5A2E\u5A2F\u5A30\u5A33\u5A35\u5A37\u5A38\u5A39\u5A3A\u5A3B\u5A3D\u5A3E\u5A3F\u5A41\u5A42\u5A43\u5A44\u5A45\u5A47\u5A48\u5A4B\u5A4C\u5A4D\u5A4E\u5A4F\u5A50\u5A51\u5A52\u5A53\u5A54\u5A56\u5A57\u5A58\u5A59\u5A5B\u5A5C\u5A5D\u5A5E\u5A5F\u5A60\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B\u5A6C\u5A6D\u5A6E\u5A6F\u5A70\u5A71\u5A72\u5A73\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80\u5A81\u5A82\u5A83\u5A84\u5A85\u5A86\u5A87\u5A88\u5A89\u5A8A\u5A8B\u5A8C\u5A8D\u5A8E\u5A8F\u5A90\u5A91\u5A93\u5A94\u5A95\u5A96\u5A97\u5A98\u5A99\u5A9C\u5A9D\u5A9E\u5A9F\u5AA0\u5AA1\u5AA2\u5AA3\u5AA4\u5AA5\u5AA6\u5AA7\u5AA8\u5AA9\u5AAB\u5AAC\uFFFD\u5AAD\u5AAE\u5AAF\u5AB0\u5AB1\u5AB4\u5AB6\u5AB7\u5AB9\u5ABA\u5ABB\u5ABC\u5ABD\u5ABF\u5AC0\u5AC3\u5AC4\u5AC5\u5AC6\u5AC7\u5AC8\u5ACA\u5ACB\u5ACD\u5ACE\u5ACF\u5AD0\u5AD1\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC\u5AED\u5AEE\u5AEF\u5AF0\u5AF2\u5AF3\u5AF4\u5AF5\u5AF6\u5AF7\u5AF8\u5AF9\u5AFA\u5AFB\u5AFC\u5AFD\u5AFE\u5AFF\u5B00\u5B01\u5B02\u5B03\u5B04\u5B05\u5B06\u5B07\u5B08\u5B0A\u5B0B\u5B0C\u5B0D\u5B0E\u5B0F\u5B10\u5B11\u5B12\u5B13\u5B14\u5B15\u5B18\u5B19\u5B1A\u5B1B\u5B1C\u5B1D\u5B1E\u5B1F\u5B20\u5B21\u5B22\u5B23\u5B24\u5B25\u5B26\u5B27\u5B28\u5B29\u5B2A\u5B2B\u5B2C\u5B2D\u5B2E\u5B2F\u5B30\u5B31\u5B33\u5B35\u5B36\u5B38\u5B39\u5B3A\u5B3B\u5B3C\u5B3D\u5B3E\u5B3F\u5B41\u5B42\u5B43\u5B44\u5B45\u5B46\u5B47\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B48\u5B49\u5B4A\u5B4B\u5B4C\u5B4D\u5B4E\u5B4F\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF\uFFFD\u5BD1\u5BD4\u5BD5\u5BD6\u5BD7\u5BD8\u5BD9\u5BDA\u5BDB\u5BDC\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9\u5BEA\u5BEB\u5BEC\u5BED\u5BEF\u5BF1\u5BF2\u5BF3\u5BF4\u5BF5\u5BF6\u5BF7\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67\u5C68\u5C69\u5C6A\u5C6B\u5C6C\u5C6D\u5C70\u5C72\u5C73\u5C74\u5C75\u5C76\u5C77\u5C78\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83\u5C84\u5C85\u5C86\u5C87\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D\u5C9E\u5C9F\u5CA0\u5CA1\u5CA4\u5CA5\u5CA6\u5CA7\u5CA8\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5\u5CC6\u5CC7\u5CC8\u5CC9\u5CCA\u5CCC\u5CCD\u5CCE\u5CCF\u5CD0\u5CD1\u5CD3\u5CD4\u5CD5\u5CD6\u5CD7\u5CD8\u5CDA\u5CDB\u5CDC\u5CDD\u5CDE\u5CDF\u5CE0\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1\u5CF2\u5CF3\u5CF4\u5CF5\u5CF6\u5CF7\u5CF8\u5CF9\u5CFA\u5CFC\u5CFD\u5CFE\u5CFF\u5D00\uFFFD\u5D01\u5D04\u5D05\u5D08\u5D09\u5D0A\u5D0B\u5D0C\u5D0D\u5D0F\u5D10\u5D11\u5D12\u5D13\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F\u5D20\u5D21\u5D22\u5D23\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F\u5D30\u5D31\u5D32\u5D33\u5D35\u5D36\u5D37\u5D38\u5D39\u5D3A\u5D3B\u5D3C\u5D3F\u5D40\u5D41\u5D42\u5D43\u5D44\u5D45\u5D46\u5D48\u5D49\u5D4D\u5D4E\u5D4F\u5D50\u5D51\u5D52\u5D53\u5D54\u5D55\u5D56\u5D57\u5D59\u5D5A\u5D5C\u5D5E\u5D5F\u5D60\u5D61\u5D62\u5D63\u5D64\u5D65\u5D66\u5D67\u5D68\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75\u5D76\u5D77\u5D78\u5D79\u5D7A\u5D7B\u5D7C\u5D7D\u5D7E\u5D7F\u5D80\u5D81\u5D83\u5D84\u5D85\u5D86\u5D87\u5D88\u5D89\u5D8A\u5D8B\u5D8C\u5D8D\u5D8E\u5D8F\u5D90\u5D91\u5D92\u5D93\u5D94\u5D95\u5D96\u5D97\u5D98\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5DA1\u5DA2\u5DA3\u5DA4\u5DA5\u5DA6\u5DA7\u5DA8\u5DA9\u5DAA\u5DAB\u5DAC\u5DAD\u5DAE\u5DAF\u5DB0\u5DB1\u5DB2\u5DB3\u5DB4\u5DB5\u5DB6\u5DB8\u5DB9\u5DBA\u5DBB\u5DBC\u5DBD\u5DBE\u5DBF\u5DC0\u5DC1\u5DC2\u5DC3\u5DC4\u5DC6\u5DC7\u5DC8\u5DC9\u5DCA\u5DCB\u5DCC\u5DCE\u5DCF\u5DD0\u5DD1\u5DD2\u5DD3\u5DD4\u5DD5\u5DD6\u5DD7\u5DD8\u5DD9\u5DDA\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED\uFFFD\u5DF0\u5DF5\u5DF6\u5DF8\u5DF9\u5DFA\u5DFB\u5DFC\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E\u5E1F\u5E20\u5E21\u5E22\u5E23\u5E24\u5E25\u5E28\u5E29\u5E2A\u5E2B\u5E2C\u5E2F\u5E30\u5E32\u5E33\u5E34\u5E35\u5E36\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46\u5E47\u5E48\u5E49\u5E4A\u5E4B\u5E4D\u5E4E\u5E4F\u5E50\u5E51\u5E52\u5E53\u5E56\u5E57\u5E58\u5E59\u5E5A\u5E5C\u5E5D\u5E5F\u5E60\u5E63\u5E64\u5E65\u5E66\u5E67\u5E68\u5E69\u5E6A\u5E6B\u5E6C\u5E6D\u5E6E\u5E6F\u5E70\u5E71\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8\u5EA9\u5EAA\u5EAB\u5EAC\u5EAE\u5EAF\u5EB0\u5EB1\u5EB2\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF\u5EC0\u5EC1\u5EC2\u5EC3\u5EC4\u5EC5\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5EC6\u5EC7\u5EC8\u5ECB\u5ECC\u5ECD\u5ECE\u5ECF\u5ED0\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC\u5EDD\u5EDE\u5EDF\u5EE0\u5EE1\u5EE2\u5EE3\u5EE4\u5EE5\u5EE6\u5EE7\u5EE9\u5EEB\u5EEC\u5EED\u5EEE\u5EEF\u5EF0\u5EF1\u5EF2\u5EF3\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24\uFFFD\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32\u5F33\u5F34\u5F35\u5F36\u5F37\u5F38\u5F3B\u5F3D\u5F3E\u5F3F\u5F41\u5F42\u5F43\u5F44\u5F45\u5F46\u5F47\u5F48\u5F49\u5F4A\u5F4B\u5F4C\u5F4D\u5F4E\u5F4F\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2\u5FA3\u5FA4\u5FA5\u5FA6\u5FA7\u5FA9\u5FAB\u5FAC\u5FAF\u5FB0\u5FB1\u5FB2\u5FB3\u5FB4\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE\u5FBF\u5FC0\u5FC1\u5FC2\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030\u6031\u6032\u6033\u6034\u6036\u6037\u6038\u6039\u603A\u603D\u603E\u6040\u6044\u6045\u6046\u6047\u6048\u6049\u604A\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080\uFFFD\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD\u60BE\u60BF\u60C0\u60C1\u60C2\u60C3\u60C4\u60C7\u60C8\u60C9\u60CC\u60CD\u60CE\u60CF\u60D0\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1\u60E2\u60E3\u60E4\u60E5\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB\u60FC\u60FD\u60FE\u60FF\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110\u6111\u6112\u6113\u6114\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C\u612D\u612E\u612F\u6130\u6131\u6132\u6133\u6134\u6135\u6136\u6137\u6138\u6139\u613A\u613B\u613C\u613D\u613E\u6140\u6141\u6142\u6143\u6144\u6145\u6146\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156\u6157\u6158\u6159\u615A\u615B\u615C\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169\u616A\u616B\u616C\u616D\u616E\u616F\u6171\u6172\u6173\u6174\u6176\u6178\u6179\u617A\u617B\u617C\u617D\u617E\u617F\u6180\u6181\u6182\u6183\u6184\u6185\u6186\u6187\u6188\u6189\u618A\u618C\u618D\u618F\u6190\u6191\u6192\u6193\u6195\uFFFD\u6196\u6197\u6198\u6199\u619A\u619B\u619C\u619E\u619F\u61A0\u61A1\u61A2\u61A3\u61A4\u61A5\u61A6\u61AA\u61AB\u61AD\u61AE\u61AF\u61B0\u61B1\u61B2\u61B3\u61B4\u61B5\u61B6\u61B8\u61B9\u61BA\u61BB\u61BC\u61BD\u61BF\u61C0\u61C1\u61C3\u61C4\u61C5\u61C6\u61C7\u61C9\u61CC\u61CD\u61CE\u61CF\u61D0\u61D3\u61D5\u61D6\u61D7\u61D8\u61D9\u61DA\u61DB\u61DC\u61DD\u61DE\u61DF\u61E0\u61E1\u61E2\u61E3\u61E4\u61E5\u61E7\u61E8\u61E9\u61EA\u61EB\u61EC\u61ED\u61EE\u61EF\u61F0\u61F1\u61F2\u61F3\u61F4\u61F6\u61F7\u61F8\u61F9\u61FA\u61FB\u61FC\u61FD\u61FE\u6200\u6201\u6202\u6203\u6204\u6205\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238\u6239\u623A\u623B\u623C\u6242\u6244\u6245\u6246\u624A\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C\u625D\u625E\u625F\u6260\u6261\u6262\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B\u628C\u628D\u628E\u628F\u6290\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1\uFFFD\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333\u6334\u6335\u6336\u6337\u6338\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356\u6357\u6358\u6359\u635A\u635B\u635C\u635D\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399\u639A\u639B\u639C\u639D\u639E\u639F\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7\u63D8\u63D9\u63DA\u63DB\u63DC\u63DD\u63DF\u63E2\u63E4\u63E5\u63E6\u63E7\u63E8\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406\u6407\u6408\u6409\u640A\u640D\u640E\u6411\u6412\u6415\u6416\u6417\u6418\u6419\u641A\u641D\u641F\u6422\u6423\u6424\uFFFD\u6425\u6427\u6428\u6429\u642B\u642E\u642F\u6430\u6431\u6432\u6433\u6435\u6436\u6437\u6438\u6439\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B\u644C\u644D\u644E\u644F\u6450\u6451\u6453\u6455\u6456\u6457\u6459\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6462\u6463\u6464\u6465\u6466\u6468\u646A\u646B\u646C\u646E\u646F\u6470\u6471\u6472\u6473\u6474\u6475\u6476\u6477\u647B\u647C\u647D\u647E\u647F\u6480\u6481\u6483\u6486\u6488\u6489\u648A\u648B\u648C\u648D\u648E\u648F\u6490\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F\u64A0\u64A1\u64A2\u64A3\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6\u64C7\u64C8\u64C9\u64CA\u64CB\u64CC\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7\u64E8\u64E9\u64EA\u64EB\u64EC\u64ED\u64EE\u64EF\u64F0\u64F1\u64F2\u64F3\u64F4\u64F5\u64F6\u64F7\u64F8\u64F9\u64FA\u64FB\u64FC\u64FD\u64FE\u64FF\u6501\u6502\u6503\u6504\u6505\u6506\u6507\u6508\u650A\u650B\u650C\u650D\u650E\u650F\u6510\u6511\u6513\u6514\u6515\u6516\u6517\u6519\u651A\u651B\u651C\u651D\u651E\u651F\u6520\u6521\uFFFD\u6522\u6523\u6524\u6526\u6527\u6528\u6529\u652A\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540\u6541\u6542\u6543\u6544\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578\u6579\u657A\u657B\u657C\u657D\u657E\u657F\u6580\u6581\u6582\u6583\u6584\u6585\u6586\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1\u65B2\u65B3\u65B4\u65B5\u65B6\u65B7\u65B8\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8\u65D9\u65DA\u65DB\u65DC\u65DD\u65DE\u65DF\u65E1\u65E3\u65E4\u65EA\u65EB\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB\u65FC\u65FD\u65FE\u65FF\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637\u6638\u6639\u663A\u663B\u663D\u663F\u6640\u6642\u6644\u6645\u6646\u6647\u6648\u6649\u664A\u664D\u664E\u6650\u6651\u6658\uFFFD\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669\u666A\u666B\u666C\u666D\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698\u6699\u669A\u669B\u669C\u669E\u669F\u66A0\u66A1\u66A2\u66A3\u66A4\u66A5\u66A6\u66A9\u66AA\u66AB\u66AC\u66AD\u66AF\u66B0\u66B1\u66B2\u66B3\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF\u66C0\u66C1\u66C2\u66C3\u66C4\u66C5\u66C6\u66C7\u66C8\u66C9\u66CA\u66CB\u66CC\u66CD\u66CE\u66CF\u66D0\u66D1\u66D2\u66D3\u66D4\u66D5\u66D6\u66D7\u66D8\u66DA\u66DE\u66DF\u66E0\u66E1\u66E2\u66E3\u66E4\u66E5\u66E7\u66E8\u66EA\u66EB\u66EC\u66ED\u66EE\u66EF\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720\u6721\u6722\u6723\u6724\u6725\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757\u6758\u6759\u675A\u675B\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776\uFFFD\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9\u67BA\u67BB\u67BC\u67BD\u67BE\u67BF\u67C0\u67C2\u67C5\u67C6\u67C7\u67C8\u67C9\u67CA\u67CB\u67CC\u67CD\u67CE\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5\u67F6\u67F7\u67F8\u67F9\u67FA\u67FB\u67FC\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818\u6819\u681A\u681B\u681C\u681E\u681F\u6820\u6822\u6823\u6824\u6825\u6826\u6827\u6828\u682B\u682C\u682D\u682E\u682F\u6830\u6831\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856\u6857\u6858\u6859\u685A\u685B\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u685C\u685D\u685E\u685F\u686A\u686C\u686D\u686E\u686F\u6870\u6871\u6872\u6873\u6875\u6878\u6879\u687A\u687B\u687C\u687D\u687E\u687F\u6880\u6882\u6884\u6887\u6888\u6889\u688A\u688B\u688C\u688D\u688E\u6890\u6891\u6892\u6894\u6895\u6896\u6898\u6899\u689A\u689B\u689C\u689D\u689E\u689F\u68A0\u68A1\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8\uFFFD\u68B9\u68BA\u68BB\u68BC\u68BD\u68BE\u68BF\u68C1\u68C3\u68C4\u68C5\u68C6\u68C7\u68C8\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB\u68DC\u68DD\u68DE\u68DF\u68E1\u68E2\u68E4\u68E5\u68E6\u68E7\u68E8\u68E9\u68EA\u68EB\u68EC\u68ED\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906\u6907\u6908\u6909\u690A\u690C\u690F\u6911\u6913\u6914\u6915\u6916\u6917\u6918\u6919\u691A\u691B\u691C\u691D\u691E\u6921\u6922\u6923\u6925\u6926\u6927\u6928\u6929\u692A\u692B\u692C\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943\u6944\u6945\u6946\u6947\u6948\u6949\u694A\u694B\u694C\u694D\u694E\u694F\u6950\u6951\u6952\u6953\u6955\u6956\u6958\u6959\u695B\u695C\u695F\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972\u6973\u6974\u6975\u6976\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E\u698F\u6990\u6991\u6992\u6993\u6996\u6997\u6999\u699A\u699D\u699E\u699F\u69A0\u69A1\u69A2\u69A3\u69A4\u69A5\u69A6\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD\uFFFD\u69BE\u69BF\u69C0\u69C2\u69C3\u69C4\u69C5\u69C6\u69C7\u69C8\u69C9\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5\u69D6\u69D7\u69D8\u69D9\u69DA\u69DC\u69DD\u69DE\u69E1\u69E2\u69E3\u69E4\u69E5\u69E6\u69E7\u69E8\u69E9\u69EA\u69EB\u69EC\u69EE\u69EF\u69F0\u69F1\u69F3\u69F4\u69F5\u69F6\u69F7\u69F8\u69F9\u69FA\u69FB\u69FC\u69FE\u6A00\u6A01\u6A02\u6A03\u6A04\u6A05\u6A06\u6A07\u6A08\u6A09\u6A0B\u6A0C\u6A0D\u6A0E\u6A0F\u6A10\u6A11\u6A12\u6A13\u6A14\u6A15\u6A16\u6A19\u6A1A\u6A1B\u6A1C\u6A1D\u6A1E\u6A20\u6A22\u6A23\u6A24\u6A25\u6A26\u6A27\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36\u6A37\u6A38\u6A39\u6A3A\u6A3B\u6A3C\u6A3F\u6A40\u6A41\u6A42\u6A43\u6A45\u6A46\u6A48\u6A49\u6A4A\u6A4B\u6A4C\u6A4D\u6A4E\u6A4F\u6A51\u6A52\u6A53\u6A54\u6A55\u6A56\u6A57\u6A5A\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A5C\u6A5D\u6A5E\u6A5F\u6A60\u6A62\u6A63\u6A64\u6A66\u6A67\u6A68\u6A69\u6A6A\u6A6B\u6A6C\u6A6D\u6A6E\u6A6F\u6A70\u6A72\u6A73\u6A74\u6A75\u6A76\u6A77\u6A78\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85\u6A86\u6A87\u6A88\u6A89\u6A8A\u6A8B\u6A8C\u6A8D\u6A8F\u6A92\u6A93\u6A94\u6A95\u6A96\u6A98\u6A99\u6A9A\u6A9B\u6A9C\u6A9D\u6A9E\u6A9F\u6AA1\u6AA2\u6AA3\u6AA4\u6AA5\u6AA6\uFFFD\u6AA7\u6AA8\u6AAA\u6AAD\u6AAE\u6AAF\u6AB0\u6AB1\u6AB2\u6AB3\u6AB4\u6AB5\u6AB6\u6AB7\u6AB8\u6AB9\u6ABA\u6ABB\u6ABC\u6ABD\u6ABE\u6ABF\u6AC0\u6AC1\u6AC2\u6AC3\u6AC4\u6AC5\u6AC6\u6AC7\u6AC8\u6AC9\u6ACA\u6ACB\u6ACC\u6ACD\u6ACE\u6ACF\u6AD0\u6AD1\u6AD2\u6AD3\u6AD4\u6AD5\u6AD6\u6AD7\u6AD8\u6AD9\u6ADA\u6ADB\u6ADC\u6ADD\u6ADE\u6ADF\u6AE0\u6AE1\u6AE2\u6AE3\u6AE4\u6AE5\u6AE6\u6AE7\u6AE8\u6AE9\u6AEA\u6AEB\u6AEC\u6AED\u6AEE\u6AEF\u6AF0\u6AF1\u6AF2\u6AF3\u6AF4\u6AF5\u6AF6\u6AF7\u6AF8\u6AF9\u6AFA\u6AFB\u6AFC\u6AFD\u6AFE\u6AFF\u6B00\u6B01\u6B02\u6B03\u6B04\u6B05\u6B06\u6B07\u6B08\u6B09\u6B0A\u6B0B\u6B0C\u6B0D\u6B0E\u6B0F\u6B10\u6B11\u6B12\u6B13\u6B14\u6B15\u6B16\u6B17\u6B18\u6B19\u6B1A\u6B1B\u6B1C\u6B1D\u6B1E\u6B1F\u6B25\u6B26\u6B28\u6B29\u6B2A\u6B2B\u6B2C\u6B2D\u6B2E\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D\u6B4E\u6B4F\u6B50\u6B51\u6B52\u6B53\u6B54\u6B55\u6B56\u6B57\u6B58\u6B5A\u6B5B\u6B5C\u6B5D\u6B5E\u6B5F\u6B60\u6B61\u6B68\u6B69\u6B6B\u6B6C\u6B6D\u6B6E\u6B6F\u6B70\u6B71\u6B72\u6B73\u6B74\u6B75\u6B76\u6B77\u6B78\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88\uFFFD\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C\u6B9D\u6B9E\u6B9F\u6BA0\u6BA2\u6BA3\u6BA4\u6BA5\u6BA6\u6BA7\u6BA8\u6BA9\u6BAB\u6BAC\u6BAD\u6BAE\u6BAF\u6BB0\u6BB1\u6BB2\u6BB6\u6BB8\u6BB9\u6BBA\u6BBB\u6BBC\u6BBD\u6BBE\u6BC0\u6BC3\u6BC4\u6BC6\u6BC7\u6BC8\u6BC9\u6BCA\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC\u6BDD\u6BDE\u6BDF\u6BE0\u6BE2\u6BE3\u6BE4\u6BE5\u6BE6\u6BE7\u6BE8\u6BE9\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE\u6BFF\u6C00\u6C01\u6C02\u6C03\u6C04\u6C08\u6C09\u6C0A\u6C0B\u6C0C\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B\u6C4C\u6C4D\u6C4E\u6C4F\u6C51\u6C52\u6C53\u6C56\u6C58\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B\u6C6C\u6C6D\u6C6E\u6C6F\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8\uFFFD\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F\u6D20\u6D21\u6D22\u6D23\u6D24\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D\u6D7E\u6D7F\u6D80\u6D81\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96\u6D97\u6D98\u6D99\u6D9A\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9\u6DBA\u6DBB\u6DBC\u6DBD\u6DBE\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD\u6DFE\u6DFF\u6E00\u6E01\u6E02\u6E03\u6E04\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35\uFFFD\u6E36\u6E37\u6E39\u6E3B\u6E3C\u6E3D\u6E3E\u6E3F\u6E40\u6E41\u6E42\u6E45\u6E46\u6E47\u6E48\u6E49\u6E4A\u6E4B\u6E4C\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60\u6E61\u6E62\u6E63\u6E64\u6E65\u6E66\u6E67\u6E68\u6E69\u6E6A\u6E6C\u6E6D\u6E6F\u6E70\u6E71\u6E72\u6E73\u6E74\u6E75\u6E76\u6E77\u6E78\u6E79\u6E7A\u6E7B\u6E7C\u6E7D\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A\u6E8B\u6E8C\u6E8D\u6E8E\u6E91\u6E92\u6E93\u6E94\u6E95\u6E96\u6E97\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA\u6EEB\u6EEC\u6EED\u6EEE\u6EEF\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA\u6EFB\u6EFC\u6EFD\u6EFE\u6EFF\u6F00\u6F01\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A\u6F0B\u6F0C\u6F0D\u6F0E\u6F10\u6F11\u6F12\u6F16\u6F17\u6F18\u6F19\u6F1A\u6F1B\u6F1C\u6F1D\u6F1E\u6F1F\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37\u6F38\u6F39\u6F3A\u6F3B\u6F3C\u6F3D\u6F3F\u6F40\u6F41\u6F42\uFFFD\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E\u6F4F\u6F50\u6F51\u6F52\u6F53\u6F54\u6F55\u6F56\u6F57\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67\u6F68\u6F69\u6F6A\u6F6B\u6F6C\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D\u6F7E\u6F7F\u6F80\u6F81\u6F82\u6F83\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F\u6F90\u6F91\u6F92\u6F93\u6F94\u6F95\u6F96\u6F97\u6F98\u6F99\u6F9A\u6F9B\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2\u6FA3\u6FA4\u6FA5\u6FA6\u6FA8\u6FA9\u6FAA\u6FAB\u6FAC\u6FAD\u6FAE\u6FAF\u6FB0\u6FB1\u6FB2\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA\u6FBB\u6FBC\u6FBD\u6FBE\u6FBF\u6FC1\u6FC3\u6FC4\u6FC5\u6FC6\u6FC7\u6FC8\u6FCA\u6FCB\u6FCC\u6FCD\u6FCE\u6FCF\u6FD0\u6FD3\u6FD4\u6FD5\u6FD6\u6FD7\u6FD8\u6FD9\u6FDA\u6FDB\u6FDC\u6FDD\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FE6\u6FE7\u6FE8\u6FE9\u6FEA\u6FEB\u6FEC\u6FED\u6FF0\u6FF1\u6FF2\u6FF3\u6FF4\u6FF5\u6FF6\u6FF7\u6FF8\u6FF9\u6FFA\u6FFB\u6FFC\u6FFD\u6FFE\u6FFF\u7000\u7001\u7002\u7003\u7004\u7005\u7006\u7007\u7008\u7009\u700A\u700B\u700C\u700D\u700E\u700F\u7010\u7012\u7013\u7014\u7015\u7016\u7017\u7018\u7019\u701C\u701D\u701E\u701F\u7020\u7021\u7022\u7024\u7025\u7026\u7027\u7028\u7029\u702A\uFFFD\u702B\u702C\u702D\u702E\u702F\u7030\u7031\u7032\u7033\u7034\u7036\u7037\u7038\u703A\u703B\u703C\u703D\u703E\u703F\u7040\u7041\u7042\u7043\u7044\u7045\u7046\u7047\u7048\u7049\u704A\u704B\u704D\u704E\u7050\u7051\u7052\u7053\u7054\u7055\u7056\u7057\u7058\u7059\u705A\u705B\u705C\u705D\u705F\u7060\u7061\u7062\u7063\u7064\u7065\u7066\u7067\u7068\u7069\u706A\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E\u709F\u70A0\u70A1\u70A2\u70A3\u70A4\u70A5\u70A6\u70A7\u70A8\u70A9\u70AA\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB\u70CC\u70CD\u70CE\u70CF\u70D0\u70D1\u70D2\u70D3\u70D4\u70D5\u70D6\u70D7\u70DA\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0\u70F1\u70F2\u70F3\u70F4\u70F5\u70F6\u70F8\u70FA\u70FB\u70FC\u70FE\u70FF\u7100\u7101\u7102\u7103\u7104\u7105\u7106\u7107\u7108\u710B\u710C\u710D\u710E\u710F\u7111\u7112\u7114\u7117\u711B\u711C\u711D\u711E\u711F\u7120\u7121\u7122\u7123\u7124\u7125\u7127\u7128\u7129\u712A\u712B\u712C\u712D\u712E\u7132\u7133\u7134\uFFFD\u7135\u7137\u7138\u7139\u713A\u713B\u713C\u713D\u713E\u713F\u7140\u7141\u7142\u7143\u7144\u7146\u7147\u7148\u7149\u714B\u714D\u714F\u7150\u7151\u7152\u7153\u7154\u7155\u7156\u7157\u7158\u7159\u715A\u715B\u715D\u715F\u7160\u7161\u7162\u7163\u7165\u7169\u716A\u716B\u716C\u716D\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E\u717F\u7180\u7181\u7182\u7183\u7185\u7186\u7187\u7188\u7189\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A\u719B\u719C\u719D\u719E\u71A1\u71A2\u71A3\u71A4\u71A5\u71A6\u71A7\u71A9\u71AA\u71AB\u71AD\u71AE\u71AF\u71B0\u71B1\u71B2\u71B4\u71B6\u71B7\u71B8\u71BA\u71BB\u71BC\u71BD\u71BE\u71BF\u71C0\u71C1\u71C2\u71C4\u71C5\u71C6\u71C7\u71C8\u71C9\u71CA\u71CB\u71CC\u71CD\u71CF\u71D0\u71D1\u71D2\u71D3\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[160] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u71D6\u71D7\u71D8\u71D9\u71DA\u71DB\u71DC\u71DD\u71DE\u71DF\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8\u71E9\u71EA\u71EB\u71EC\u71ED\u71EF\u71F0\u71F1\u71F2\u71F3\u71F4\u71F5\u71F6\u71F7\u71F8\u71FA\u71FB\u71FC\u71FD\u71FE\u71FF\u7200\u7201\u7202\u7203\u7204\u7205\u7207\u7208\u7209\u720A\u720B\u720C\u720D\u720E\u720F\u7210\u7211\u7212\u7213\u7214\u7215\u7216\u7217\u7218\u7219\u721A\uFFFD\u721B\u721C\u721E\u721F\u7220\u7221\u7222\u7223\u7224\u7225\u7226\u7227\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240\u7241\u7242\u7243\u7244\u7245\u7246\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285\u7286\u7287\u7288\u7289\u728C\u728E\u7290\u7291\u7293\u7294\u7295\u7296\u7297\u7298\u7299\u729A\u729B\u729C\u729D\u729E\u72A0\u72A1\u72A2\u72A3\u72A4\u72A5\u72A6\u72A7\u72A8\u72A9\u72AA\u72AB\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA\u72BB\u72BC\u72BD\u72BE\u72BF\u72C0\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB\uFFFD".split("");
    for(j = 0; j != D[160].length; ++j)if (D[160][j].charCodeAt(0) !== 0xFFFD) {
        e[D[160][j]] = 40960 + j;
        d[40960 + j] = D[160][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2488\u2489\u248A\u248B\u248C\u248D\u248E\u248F\u2490\u2491\u2492\u2493\u2494\u2495\u2496\u2497\u2498\u2499\u249A\u249B\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\u2483\u2484\u2485\u2486\u2487\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\uFFFD\uFFFD\u3220\u3221\u3222\u3223\u3224\u3225\u3226\u3227\u3228\u3229\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u216A\u216B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF01\uFF02\uFF03\uFFE5\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44\uFFFD\uFFFD\uFE3B\uFE3C\uFE37\uFE38\uFE31\uFFFD\uFE33\uFE34\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550\u2551\u2552\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\u256D\u256E\u256F\u2570\u2571\u2572\u2573\u2581\u2582\u2583\u2584\u2585\u2586\u2587\uFFFD\u2588\u2589\u258A\u258B\u258C\u258D\u258E\u258F\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251\uFFFD\u0144\u0148\uFFFD\u0261\uFFFD\uFFFD\uFFFD\uFFFD\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4\uFFFD\u2121\u3231\uFFFD\u2010\uFFFD\uFFFD\uFFFD\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49\uFE4A\uFE4B\uFE4C\uFE4D\uFE4E\uFE4F\uFE50\uFE51\uFE52\uFE54\uFE55\uFE56\uFE57\uFE59\uFE5A\uFE5B\uFE5C\uFE5D\uFE5E\uFE5F\uFE60\uFE61\uFFFD\uFE62\uFE63\uFE64\uFE65\uFE66\uFE68\uFE69\uFE6A\uFE6B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3007\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2501\u2502\u2503\u2504\u2505\u2506\u2507\u2508\u2509\u250A\u250B\u250C\u250D\u250E\u250F\u2510\u2511\u2512\u2513\u2514\u2515\u2516\u2517\u2518\u2519\u251A\u251B\u251C\u251D\u251E\u251F\u2520\u2521\u2522\u2523\u2524\u2525\u2526\u2527\u2528\u2529\u252A\u252B\u252C\u252D\u252E\u252F\u2530\u2531\u2532\u2533\u2534\u2535\u2536\u2537\u2538\u2539\u253A\u253B\u253C\u253D\u253E\u253F\u2540\u2541\u2542\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\u254B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72DC\u72DD\u72DF\u72E2\u72E3\u72E4\u72E5\u72E6\u72E7\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304\u7305\u7306\u7307\u7308\u7309\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340\u7341\u7342\u7343\u7344\u7345\u7346\u7347\u7348\uFFFD\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358\u7359\u735A\u735B\u735C\u735D\u735E\u735F\u7361\u7362\u7363\u7364\u7365\u7366\u7367\u7368\u7369\u736A\u736B\u736E\u7370\u7371\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7372\u7373\u7374\u7375\u7376\u7377\u7378\u7379\u737A\u737B\u737C\u737D\u737F\u7380\u7381\u7382\u7383\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3\u73A4\u73A5\u73A6\u73A7\u73A8\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3\u73C4\u73C5\u73C6\u73C7\uFFFD\u73CB\u73CC\u73CE\u73D2\u73D3\u73D4\u73D5\u73D6\u73D7\u73D8\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3\u73F4\u73F5\u73F6\u73F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u73F8\u73F9\u73FA\u73FB\u73FC\u73FD\u73FE\u73FF\u7400\u7401\u7402\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411\u7412\u7413\u7414\u7415\u7416\u7417\u7418\u7419\u741C\u741D\u741E\u741F\u7420\u7421\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437\u7438\u7439\u743A\u743B\u743D\u743E\u743F\u7440\u7442\u7443\u7444\u7445\u7446\u7447\u7448\u7449\u744A\u744B\u744C\u744D\uFFFD\u744E\u744F\u7450\u7451\u7452\u7453\u7454\u7456\u7458\u745D\u7460\u7461\u7462\u7463\u7464\u7465\u7466\u7467\u7468\u7469\u746A\u746B\u746C\u746E\u746F\u7471\u7472\u7473\u7474\u7475\u7478\u7479\u747A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491\u7492\u7493\u7494\u7495\u7496\u7497\u7498\u7499\u749A\u749B\u749D\u749F\u74A0\u74A1\u74A2\u74A3\u74A4\u74A5\u74A6\u74AA\u74AB\u74AC\u74AD\u74AE\u74AF\u74B0\u74B1\u74B2\u74B3\u74B4\u74B5\u74B6\u74B7\u74B8\u74B9\u74BB\u74BC\u74BD\u74BE\u74BF\u74C0\u74C1\u74C2\u74C3\u74C4\u74C5\u74C6\u74C7\uFFFD\u74C8\u74C9\u74CA\u74CB\u74CC\u74CD\u74CE\u74CF\u74D0\u74D1\u74D3\u74D4\u74D5\u74D6\u74D7\u74D8\u74D9\u74DA\u74DB\u74DD\u74DF\u74E1\u74E5\u74E7\u74E8\u74E9\u74EA\u74EB\u74EC\u74ED\u74F0\u74F1\u74F2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74F3\u74F5\u74F8\u74F9\u74FA\u74FB\u74FC\u74FD\u74FE\u7500\u7501\u7502\u7503\u7505\u7506\u7507\u7508\u7509\u750A\u750B\u750C\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520\u7521\u7522\u7523\u7524\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558\uFFFD\u755D\u755E\u755F\u7560\u7561\u7562\u7563\u7564\u7567\u7568\u7569\u756B\u756C\u756D\u756E\u756F\u7570\u7571\u7573\u7575\u7576\u7577\u757A\u757B\u757C\u757D\u757E\u7580\u7581\u7582\u7584\u7585\u7587\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6\u75A7\u75A8\u75A9\u75AA\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607\uFFFD\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7645\u7646\u7647\u7648\u7649\u764A\u764B\u764E\u764F\u7650\u7651\u7652\u7653\u7655\u7657\u7658\u7659\u765A\u765B\u765D\u765F\u7660\u7661\u7662\u7664\u7665\u7666\u7667\u7668\u7669\u766A\u766C\u766D\u766E\u7670\u7671\u7672\u7673\u7674\u7675\u7676\u7677\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B\uFFFD\u769C\u769D\u769E\u769F\u76A0\u76A1\u76A2\u76A3\u76A5\u76A6\u76A7\u76A8\u76A9\u76AA\u76AB\u76AC\u76AD\u76AF\u76B0\u76B3\u76B5\u76B6\u76B7\u76B8\u76B9\u76BA\u76BB\u76BC\u76BD\u76BE\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0\u76E1\u76E2\u76E3\u76E4\u76E6\u76E7\u76E8\u76E9\u76EA\u76EB\u76EC\u76ED\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E\u770F\u7710\u7711\u7712\u7713\u7714\u7715\u7716\u7717\u7718\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B\uFFFD\u772C\u772E\u7730\u7731\u7732\u7733\u7734\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748\u7749\u774A\u774B\u774C\u774D\u774E\u774F\u7752\u7753\u7754\u7755\u7756\u7757\u7758\u7759\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D\u776E\u776F\u7770\u7771\u7772\u7773\u7774\u7775\u7776\u7777\u7778\u777A\u777B\u777C\u7781\u7782\u7783\u7786\u7787\u7788\u7789\u778A\u778B\u778F\u7790\u7793\u7794\u7795\u7796\u7797\u7798\u7799\u779A\u779B\u779C\u779D\u779E\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6\u77B7\u77B8\u77B9\u77BA\uFFFD\u77BC\u77BE\u77C0\u77C1\u77C2\u77C3\u77C4\u77C5\u77C6\u77C7\u77C8\u77C9\u77CA\u77CB\u77CC\u77CE\u77CF\u77D0\u77D1\u77D2\u77D3\u77D4\u77D5\u77D6\u77D8\u77D9\u77DA\u77DD\u77DE\u77DF\u77E0\u77E1\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803\u7804\u7805\u7806\u7807\u7808\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A\uFFFD\u785B\u785C\u785E\u785F\u7860\u7861\u7862\u7863\u7864\u7865\u7866\u7867\u7868\u7869\u786F\u7870\u7871\u7872\u7873\u7874\u7875\u7876\u7878\u7879\u787A\u787B\u787D\u787E\u787F\u7880\u7881\u7882\u7883\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8\u78A9\u78AA\u78AB\u78AC\u78AD\u78AE\u78AF\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA\u78DB\u78DC\u78DD\u78DE\u78DF\u78E0\u78E1\u78E2\u78E3\uFFFD\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED\u78EE\u78EF\u78F0\u78F1\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB\u78FC\u78FD\u78FE\u78FF\u7900\u7902\u7903\u7904\u7906\u7907\u7908\u7909\u790A\u790B\u790C\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u790D\u790E\u790F\u7910\u7911\u7912\u7914\u7915\u7916\u7917\u7918\u7919\u791A\u791B\u791C\u791D\u791F\u7920\u7921\u7922\u7923\u7925\u7926\u7927\u7928\u7929\u792A\u792B\u792C\u792D\u792E\u792F\u7930\u7931\u7932\u7933\u7935\u7936\u7937\u7938\u7939\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A\u794B\u794C\u794D\u794E\u794F\u7950\u7951\u7952\u7954\u7955\u7958\u7959\u7961\u7963\uFFFD\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970\u7971\u7972\u7973\u7974\u7975\u7976\u7979\u797B\u797C\u797D\u797E\u797F\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7993\u7994\u7995\u7996\u7997\u7998\u7999\u799B\u799C\u799D\u799E\u799F\u79A0\u79A1\u79A2\u79A3\u79A4\u79A5\u79A6\u79A8\u79A9\u79AA\u79AB\u79AC\u79AD\u79AE\u79AF\u79B0\u79B1\u79B2\u79B4\u79B5\u79B6\u79B7\u79B8\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9\u79DA\u79DB\u79DC\u79DD\u79DE\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA\uFFFD\u79EC\u79EE\u79F1\u79F2\u79F3\u79F4\u79F5\u79F6\u79F7\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F\u7A10\u7A11\u7A12\u7A13\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A1D\u7A1F\u7A21\u7A22\u7A24\u7A25\u7A26\u7A27\u7A28\u7A29\u7A2A\u7A2B\u7A2C\u7A2D\u7A2E\u7A2F\u7A30\u7A31\u7A32\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40\u7A41\u7A42\u7A43\u7A44\u7A45\u7A47\u7A48\u7A49\u7A4A\u7A4B\u7A4C\u7A4D\u7A4E\u7A4F\u7A50\u7A52\u7A53\u7A54\u7A55\u7A56\u7A58\u7A59\u7A5A\u7A5B\u7A5C\u7A5D\u7A5E\u7A5F\u7A60\u7A61\u7A62\u7A63\u7A64\u7A65\u7A66\u7A67\u7A68\uFFFD\u7A69\u7A6A\u7A6B\u7A6C\u7A6D\u7A6E\u7A6F\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE\u7AAF\u7AB0\u7AB1\u7AB2\u7AB4\u7AB5\u7AB6\u7AB7\u7AB8\u7AB9\u7ABA\u7ABB\u7ABC\u7ABD\u7ABE\u7AC0\u7AC1\u7AC2\u7AC3\u7AC4\u7AC5\u7AC6\u7AC7\u7AC8\u7AC9\u7ACA\u7ACC\u7ACD\u7ACE\u7ACF\u7AD0\u7AD1\u7AD2\u7AD3\u7AD4\u7AD5\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7\u7AE8\u7AE9\u7AEA\u7AEB\u7AEC\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3\uFFFD\u7AF4\u7AF5\u7AF6\u7AF7\u7AF8\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F\u7B40\u7B41\u7B42\u7B43\u7B44\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63\u7B64\u7B65\u7B66\u7B67\u7B68\u7B69\u7B6A\u7B6B\u7B6C\u7B6D\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86\u7B87\u7B88\u7B89\u7B8A\u7B8B\u7B8C\u7B8E\u7B8F\uFFFD\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9\u7BBA\u7BBB\u7BBC\u7BBD\u7BBE\u7BBF\u7BC0\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4\u7BD5\u7BD6\u7BD7\u7BD8\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2\u7BF3\u7BF4\u7BF5\u7BF6\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF\u7C00\u7C01\u7C02\u7C03\u7C04\u7C05\u7C06\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10\u7C11\u7C12\u7C13\u7C14\u7C15\u7C17\u7C18\u7C19\uFFFD\u7C1A\u7C1B\u7C1C\u7C1D\u7C1E\u7C20\u7C21\u7C22\u7C23\u7C24\u7C25\u7C28\u7C29\u7C2B\u7C2C\u7C2D\u7C2E\u7C2F\u7C30\u7C31\u7C32\u7C33\u7C34\u7C35\u7C36\u7C37\u7C39\u7C3A\u7C3B\u7C3C\u7C3D\u7C3E\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7C43\u7C44\u7C45\u7C46\u7C47\u7C48\u7C49\u7C4A\u7C4B\u7C4C\u7C4E\u7C4F\u7C50\u7C51\u7C52\u7C53\u7C54\u7C55\u7C56\u7C57\u7C58\u7C59\u7C5A\u7C5B\u7C5C\u7C5D\u7C5E\u7C5F\u7C60\u7C61\u7C62\u7C63\u7C64\u7C65\u7C66\u7C67\u7C68\u7C69\u7C6A\u7C6B\u7C6C\u7C6D\u7C6E\u7C6F\u7C70\u7C71\u7C72\u7C75\u7C76\u7C77\u7C78\u7C79\u7C7A\u7C7E\u7C7F\u7C80\u7C81\u7C82\u7C83\u7C84\u7C85\u7C86\u7C87\uFFFD\u7C88\u7C8A\u7C8B\u7C8C\u7C8D\u7C8E\u7C8F\u7C90\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4\u7CB5\u7CB6\u7CB7\u7CB8\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE\u7CCF\u7CD0\u7CD1\u7CD2\u7CD3\u7CD4\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1\u7CE2\u7CE3\u7CE4\u7CE5\u7CE6\u7CE7\u7CE9\u7CEA\u7CEB\u7CEC\u7CED\u7CEE\u7CF0\u7CF1\u7CF2\u7CF3\u7CF4\u7CF5\u7CF6\u7CF7\u7CF9\u7CFA\u7CFC\u7CFD\u7CFE\u7CFF\u7D00\u7D01\u7D02\u7D03\u7D04\u7D05\u7D06\u7D07\u7D08\u7D09\u7D0B\u7D0C\u7D0D\u7D0E\u7D0F\u7D10\uFFFD\u7D11\u7D12\u7D13\u7D14\u7D15\u7D16\u7D17\u7D18\u7D19\u7D1A\u7D1B\u7D1C\u7D1D\u7D1E\u7D1F\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30\u7D31\u7D32\u7D33\u7D34\u7D35\u7D36\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D37\u7D38\u7D39\u7D3A\u7D3B\u7D3C\u7D3D\u7D3E\u7D3F\u7D40\u7D41\u7D42\u7D43\u7D44\u7D45\u7D46\u7D47\u7D48\u7D49\u7D4A\u7D4B\u7D4C\u7D4D\u7D4E\u7D4F\u7D50\u7D51\u7D52\u7D53\u7D54\u7D55\u7D56\u7D57\u7D58\u7D59\u7D5A\u7D5B\u7D5C\u7D5D\u7D5E\u7D5F\u7D60\u7D61\u7D62\u7D63\u7D64\u7D65\u7D66\u7D67\u7D68\u7D69\u7D6A\u7D6B\u7D6C\u7D6D\u7D6F\u7D70\u7D71\u7D72\u7D73\u7D74\u7D75\u7D76\uFFFD\u7D78\u7D79\u7D7A\u7D7B\u7D7C\u7D7D\u7D7E\u7D7F\u7D80\u7D81\u7D82\u7D83\u7D84\u7D85\u7D86\u7D87\u7D88\u7D89\u7D8A\u7D8B\u7D8C\u7D8D\u7D8E\u7D8F\u7D90\u7D91\u7D92\u7D93\u7D94\u7D95\u7D96\u7D97\u7D98\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D99\u7D9A\u7D9B\u7D9C\u7D9D\u7D9E\u7D9F\u7DA0\u7DA1\u7DA2\u7DA3\u7DA4\u7DA5\u7DA7\u7DA8\u7DA9\u7DAA\u7DAB\u7DAC\u7DAD\u7DAF\u7DB0\u7DB1\u7DB2\u7DB3\u7DB4\u7DB5\u7DB6\u7DB7\u7DB8\u7DB9\u7DBA\u7DBB\u7DBC\u7DBD\u7DBE\u7DBF\u7DC0\u7DC1\u7DC2\u7DC3\u7DC4\u7DC5\u7DC6\u7DC7\u7DC8\u7DC9\u7DCA\u7DCB\u7DCC\u7DCD\u7DCE\u7DCF\u7DD0\u7DD1\u7DD2\u7DD3\u7DD4\u7DD5\u7DD6\u7DD7\u7DD8\u7DD9\uFFFD\u7DDA\u7DDB\u7DDC\u7DDD\u7DDE\u7DDF\u7DE0\u7DE1\u7DE2\u7DE3\u7DE4\u7DE5\u7DE6\u7DE7\u7DE8\u7DE9\u7DEA\u7DEB\u7DEC\u7DED\u7DEE\u7DEF\u7DF0\u7DF1\u7DF2\u7DF3\u7DF4\u7DF5\u7DF6\u7DF7\u7DF8\u7DF9\u7DFA\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7DFB\u7DFC\u7DFD\u7DFE\u7DFF\u7E00\u7E01\u7E02\u7E03\u7E04\u7E05\u7E06\u7E07\u7E08\u7E09\u7E0A\u7E0B\u7E0C\u7E0D\u7E0E\u7E0F\u7E10\u7E11\u7E12\u7E13\u7E14\u7E15\u7E16\u7E17\u7E18\u7E19\u7E1A\u7E1B\u7E1C\u7E1D\u7E1E\u7E1F\u7E20\u7E21\u7E22\u7E23\u7E24\u7E25\u7E26\u7E27\u7E28\u7E29\u7E2A\u7E2B\u7E2C\u7E2D\u7E2E\u7E2F\u7E30\u7E31\u7E32\u7E33\u7E34\u7E35\u7E36\u7E37\u7E38\u7E39\uFFFD\u7E3A\u7E3C\u7E3D\u7E3E\u7E3F\u7E40\u7E42\u7E43\u7E44\u7E45\u7E46\u7E48\u7E49\u7E4A\u7E4B\u7E4C\u7E4D\u7E4E\u7E4F\u7E50\u7E51\u7E52\u7E53\u7E54\u7E55\u7E56\u7E57\u7E58\u7E59\u7E5A\u7E5B\u7E5C\u7E5D\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E5E\u7E5F\u7E60\u7E61\u7E62\u7E63\u7E64\u7E65\u7E66\u7E67\u7E68\u7E69\u7E6A\u7E6B\u7E6C\u7E6D\u7E6E\u7E6F\u7E70\u7E71\u7E72\u7E73\u7E74\u7E75\u7E76\u7E77\u7E78\u7E79\u7E7A\u7E7B\u7E7C\u7E7D\u7E7E\u7E7F\u7E80\u7E81\u7E83\u7E84\u7E85\u7E86\u7E87\u7E88\u7E89\u7E8A\u7E8B\u7E8C\u7E8D\u7E8E\u7E8F\u7E90\u7E91\u7E92\u7E93\u7E94\u7E95\u7E96\u7E97\u7E98\u7E99\u7E9A\u7E9C\u7E9D\u7E9E\uFFFD\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B\u7F3C\u7F3D\u7F3E\u7F3F\u7F40\u7F41\u7F43\u7F46\u7F47\u7F48\u7F49\u7F4A\u7F4B\u7F4C\u7F4D\u7F4E\u7F4F\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63\u7F64\u7F65\u7F66\u7F67\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82\u7F83\u7F84\u7F85\u7F86\u7F87\u7F88\u7F89\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F92\u7F93\u7F95\u7F96\u7F97\u7F98\u7F99\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8\u7FA9\u7FAA\u7FAB\u7FAC\u7FAD\u7FAE\u7FB1\uFFFD\u7FB3\u7FB4\u7FB5\u7FB6\u7FB7\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF\u7FD0\u7FD1\u7FD2\u7FD3\u7FD6\u7FD7\u7FD9\u7FDA\u7FDB\u7FDC\u7FDD\u7FDE\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4\u7FF5\u7FF6\u7FF7\u7FF8\u7FF9\u7FFA\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B\u802C\u802D\u802E\u802F\u8030\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057\uFFFD\u8059\u805B\u805C\u805D\u805E\u805F\u8060\u8061\u8062\u8063\u8064\u8065\u8066\u8067\u8068\u806B\u806C\u806D\u806E\u806F\u8070\u8072\u8073\u8074\u8075\u8076\u8077\u8078\u8079\u807A\u807B\u807C\u807D\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u807E\u8081\u8082\u8085\u8088\u808A\u808D\u808E\u808F\u8090\u8091\u8092\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7\u80C8\u80C9\u80CA\u80CB\u80CF\u80D0\u80D1\u80D2\u80D3\u80D4\u80D5\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B\uFFFD\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F\u8120\u8121\u8122\u8123\u8124\u8125\u8126\u8127\u8128\u8129\u812A\u812B\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139\u813A\u813B\u813C\u813D\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8140\u8141\u8142\u8143\u8144\u8145\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B\u815C\u815D\u815E\u815F\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183\u8184\u8185\u8186\u8187\u8189\u818B\u818C\u818D\u818E\u8190\u8192\u8193\u8194\u8195\u8196\u8197\u8199\u819A\u819E\u819F\u81A0\u81A1\u81A2\u81A4\u81A5\uFFFD\u81A7\u81A9\u81AB\u81AC\u81AD\u81AE\u81AF\u81B0\u81B1\u81B2\u81B4\u81B5\u81B6\u81B7\u81B8\u81B9\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD\u81CE\u81CF\u81D0\u81D1\u81D2\u81D3\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81D4\u81D5\u81D6\u81D7\u81D8\u81D9\u81DA\u81DB\u81DC\u81DD\u81DE\u81DF\u81E0\u81E1\u81E2\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE\u81EF\u81F0\u81F1\u81F2\u81F5\u81F6\u81F7\u81F8\u81F9\u81FA\u81FD\u81FF\u8203\u8207\u8208\u8209\u820A\u820B\u820E\u820F\u8211\u8213\u8215\u8216\u8217\u8218\u8219\u821A\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F\uFFFD\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250\u8251\u8252\u8253\u8254\u8255\u8256\u8257\u8259\u825B\u825C\u825D\u825E\u8260\u8261\u8262\u8263\u8264\u8265\u8266\u8267\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8\uFFFD\u82FA\u82FC\u82FD\u82FE\u82FF\u8300\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D\u831E\u831F\u8320\u8321\u8322\u8323\u8324\u8325\u8326\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A\u834B\u834C\u834D\u834E\u8353\u8355\u8356\u8357\u8358\u8359\u835D\u8362\u8370\u8371\u8372\u8373\u8374\u8375\u8376\u8379\u837A\u837E\u837F\u8380\u8381\u8382\u8383\u8384\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1\u83A2\u83A3\u83A4\u83A5\u83A6\u83A7\u83AC\u83AD\u83AE\uFFFD\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u83EE\u83EF\u83F3\u83F4\u83F5\u83F6\u83F7\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412\u8413\u8414\u8415\u8416\u8417\u8419\u841A\u841B\u841E\u841F\u8420\u8421\u8422\u8423\u8429\u842A\u842B\u842C\u842D\u842E\u842F\u8430\u8432\u8433\u8434\u8435\u8436\u8437\u8439\u843A\u843B\u843E\u843F\u8440\u8441\u8442\u8443\u8444\u8445\u8447\u8448\u8449\uFFFD\u844A\u844B\u844C\u844D\u844E\u844F\u8450\u8452\u8453\u8454\u8455\u8456\u8458\u845D\u845E\u845F\u8460\u8462\u8464\u8465\u8466\u8467\u8468\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u847D\u847E\u847F\u8480\u8481\u8483\u8484\u8485\u8486\u848A\u848D\u848F\u8490\u8491\u8492\u8493\u8494\u8495\u8496\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2\u84A3\u84A4\u84A5\u84A6\u84A7\u84A8\u84A9\u84AA\u84AB\u84AC\u84AD\u84AE\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7\uFFFD\u84D8\u84D9\u84DA\u84DB\u84DC\u84DE\u84E1\u84E2\u84E4\u84E7\u84E8\u84E9\u84EA\u84EB\u84ED\u84EE\u84EF\u84F1\u84F2\u84F3\u84F4\u84F5\u84F6\u84F7\u84F8\u84F9\u84FA\u84FB\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8503\u8504\u8505\u8506\u8507\u8508\u8509\u850A\u850B\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522\u8523\u8524\u8525\u8526\u8527\u8528\u8529\u852A\u852D\u852E\u852F\u8530\u8531\u8532\u8533\u8534\u8535\u8536\u853E\u853F\u8540\u8541\u8542\u8544\u8545\u8546\u8547\u854B\u854C\u854D\u854E\u854F\u8550\u8551\u8552\u8553\u8554\u8555\uFFFD\u8557\u8558\u855A\u855B\u855C\u855D\u855F\u8560\u8561\u8562\u8563\u8565\u8566\u8567\u8569\u856A\u856B\u856C\u856D\u856E\u856F\u8570\u8571\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8582\u8583\u8586\u8588\u8589\u858A\u858B\u858C\u858D\u858E\u8590\u8591\u8592\u8593\u8594\u8595\u8596\u8597\u8598\u8599\u859A\u859D\u859E\u859F\u85A0\u85A1\u85A2\u85A3\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1\u85B2\u85B3\u85B4\u85B5\u85B6\u85B8\u85BA\u85BB\u85BC\u85BD\u85BE\u85BF\u85C0\u85C2\u85C3\u85C4\u85C5\u85C6\u85C7\u85C8\u85CA\u85CB\u85CC\u85CD\u85CE\u85D1\u85D2\uFFFD\u85D4\u85D6\u85D7\u85D8\u85D9\u85DA\u85DB\u85DD\u85DE\u85DF\u85E0\u85E1\u85E2\u85E3\u85E5\u85E6\u85E7\u85E8\u85EA\u85EB\u85EC\u85ED\u85EE\u85EF\u85F0\u85F1\u85F2\u85F3\u85F4\u85F5\u85F6\u85F7\u85F8\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u85F9\u85FA\u85FC\u85FD\u85FE\u8600\u8601\u8602\u8603\u8604\u8606\u8607\u8608\u8609\u860A\u860B\u860C\u860D\u860E\u860F\u8610\u8612\u8613\u8614\u8615\u8617\u8618\u8619\u861A\u861B\u861C\u861D\u861E\u861F\u8620\u8621\u8622\u8623\u8624\u8625\u8626\u8628\u862A\u862B\u862C\u862D\u862E\u862F\u8630\u8631\u8632\u8633\u8634\u8635\u8636\u8637\u8639\u863A\u863B\u863D\u863E\u863F\u8640\uFFFD\u8641\u8642\u8643\u8644\u8645\u8646\u8647\u8648\u8649\u864A\u864B\u864C\u8652\u8653\u8655\u8656\u8657\u8658\u8659\u865B\u865C\u865D\u865F\u8660\u8661\u8663\u8664\u8665\u8666\u8667\u8668\u8669\u866A\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u866D\u866F\u8670\u8672\u8673\u8674\u8675\u8676\u8677\u8678\u8683\u8684\u8685\u8686\u8687\u8688\u8689\u868E\u868F\u8690\u8691\u8692\u8694\u8696\u8697\u8698\u8699\u869A\u869B\u869E\u869F\u86A0\u86A1\u86A2\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB\u86BC\u86BD\u86BE\u86BF\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC\uFFFD\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740\u8741\u8742\u8743\u8744\u8745\u8746\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A\u875B\u875C\u875D\u875E\u875F\u8761\u8762\u8766\u8767\u8768\u8769\u876A\u876B\u876C\u876D\u876F\u8771\u8772\u8773\u8775\uFFFD\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E\u878F\u8790\u8791\u8792\u8794\u8795\u8796\u8798\u8799\u879A\u879B\u879C\u879D\u879E\u87A0\u87A1\u87A2\u87A3\u87A4\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1\u87C2\u87C3\u87C4\u87C5\u87C7\u87C8\u87C9\u87CC\u87CD\u87CE\u87CF\u87D0\u87D4\u87D5\u87D6\u87D7\u87D8\u87D9\u87DA\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF\u87F0\u87F1\u87F2\u87F3\u87F4\u87F5\u87F6\u87F7\u87F8\uFFFD\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804\u8805\u8806\u8807\u8808\u8809\u880B\u880C\u880D\u880E\u880F\u8810\u8811\u8812\u8814\u8817\u8818\u8819\u881A\u881C\u881D\u881E\u881F\u8820\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8824\u8825\u8826\u8827\u8828\u8829\u882A\u882B\u882C\u882D\u882E\u882F\u8830\u8831\u8833\u8834\u8835\u8836\u8837\u8838\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846\u8847\u8848\u8849\u884A\u884B\u884E\u884F\u8850\u8851\u8852\u8853\u8855\u8856\u8858\u885A\u885B\u885C\u885D\u885E\u885F\u8860\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A\uFFFD\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897\u8898\u8899\u889A\u889B\u889D\u889E\u889F\u88A0\u88A1\u88A3\u88A5\u88A6\u88A7\u88A8\u88A9\u88AA\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u88AC\u88AE\u88AF\u88B0\u88B2\u88B3\u88B4\u88B5\u88B6\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA\u88DB\u88DC\u88DD\u88DE\u88E0\u88E1\u88E6\u88E7\u88E9\u88EA\u88EB\u88EC\u88ED\u88EE\u88EF\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903\u8904\u8905\u8906\u8907\u8908\uFFFD\u8909\u890B\u890C\u890D\u890E\u890F\u8911\u8914\u8915\u8916\u8917\u8918\u891C\u891D\u891E\u891F\u8920\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8938\u8939\u893A\u893B\u893C\u893D\u893E\u893F\u8940\u8942\u8943\u8945\u8946\u8947\u8948\u8949\u894A\u894B\u894C\u894D\u894E\u894F\u8950\u8951\u8952\u8953\u8954\u8955\u8956\u8957\u8958\u8959\u895A\u895B\u895C\u895D\u8960\u8961\u8962\u8963\u8964\u8965\u8967\u8968\u8969\u896A\u896B\u896C\u896D\u896E\u896F\u8970\u8971\u8972\u8973\u8974\u8975\u8976\u8977\u8978\u8979\u897A\u897C\uFFFD\u897D\u897E\u8980\u8982\u8984\u8985\u8987\u8988\u8989\u898A\u898B\u898C\u898D\u898E\u898F\u8990\u8991\u8992\u8993\u8994\u8995\u8996\u8997\u8998\u8999\u899A\u899B\u899C\u899D\u899E\u899F\u89A0\u89A1\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89A2\u89A3\u89A4\u89A5\u89A6\u89A7\u89A8\u89A9\u89AA\u89AB\u89AC\u89AD\u89AE\u89AF\u89B0\u89B1\u89B2\u89B3\u89B4\u89B5\u89B6\u89B7\u89B8\u89B9\u89BA\u89BB\u89BC\u89BD\u89BE\u89BF\u89C0\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4\u89F5\u89F6\u89F7\u89F8\u89F9\u89FA\uFFFD\u89FB\u89FC\u89FD\u89FE\u89FF\u8A01\u8A02\u8A03\u8A04\u8A05\u8A06\u8A08\u8A09\u8A0A\u8A0B\u8A0C\u8A0D\u8A0E\u8A0F\u8A10\u8A11\u8A12\u8A13\u8A14\u8A15\u8A16\u8A17\u8A18\u8A19\u8A1A\u8A1B\u8A1C\u8A1D\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A1E\u8A1F\u8A20\u8A21\u8A22\u8A23\u8A24\u8A25\u8A26\u8A27\u8A28\u8A29\u8A2A\u8A2B\u8A2C\u8A2D\u8A2E\u8A2F\u8A30\u8A31\u8A32\u8A33\u8A34\u8A35\u8A36\u8A37\u8A38\u8A39\u8A3A\u8A3B\u8A3C\u8A3D\u8A3F\u8A40\u8A41\u8A42\u8A43\u8A44\u8A45\u8A46\u8A47\u8A49\u8A4A\u8A4B\u8A4C\u8A4D\u8A4E\u8A4F\u8A50\u8A51\u8A52\u8A53\u8A54\u8A55\u8A56\u8A57\u8A58\u8A59\u8A5A\u8A5B\u8A5C\u8A5D\u8A5E\uFFFD\u8A5F\u8A60\u8A61\u8A62\u8A63\u8A64\u8A65\u8A66\u8A67\u8A68\u8A69\u8A6A\u8A6B\u8A6C\u8A6D\u8A6E\u8A6F\u8A70\u8A71\u8A72\u8A73\u8A74\u8A75\u8A76\u8A77\u8A78\u8A7A\u8A7B\u8A7C\u8A7D\u8A7E\u8A7F\u8A80\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A81\u8A82\u8A83\u8A84\u8A85\u8A86\u8A87\u8A88\u8A8B\u8A8C\u8A8D\u8A8E\u8A8F\u8A90\u8A91\u8A92\u8A94\u8A95\u8A96\u8A97\u8A98\u8A99\u8A9A\u8A9B\u8A9C\u8A9D\u8A9E\u8A9F\u8AA0\u8AA1\u8AA2\u8AA3\u8AA4\u8AA5\u8AA6\u8AA7\u8AA8\u8AA9\u8AAA\u8AAB\u8AAC\u8AAD\u8AAE\u8AAF\u8AB0\u8AB1\u8AB2\u8AB3\u8AB4\u8AB5\u8AB6\u8AB7\u8AB8\u8AB9\u8ABA\u8ABB\u8ABC\u8ABD\u8ABE\u8ABF\u8AC0\u8AC1\u8AC2\uFFFD\u8AC3\u8AC4\u8AC5\u8AC6\u8AC7\u8AC8\u8AC9\u8ACA\u8ACB\u8ACC\u8ACD\u8ACE\u8ACF\u8AD0\u8AD1\u8AD2\u8AD3\u8AD4\u8AD5\u8AD6\u8AD7\u8AD8\u8AD9\u8ADA\u8ADB\u8ADC\u8ADD\u8ADE\u8ADF\u8AE0\u8AE1\u8AE2\u8AE3\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AE4\u8AE5\u8AE6\u8AE7\u8AE8\u8AE9\u8AEA\u8AEB\u8AEC\u8AED\u8AEE\u8AEF\u8AF0\u8AF1\u8AF2\u8AF3\u8AF4\u8AF5\u8AF6\u8AF7\u8AF8\u8AF9\u8AFA\u8AFB\u8AFC\u8AFD\u8AFE\u8AFF\u8B00\u8B01\u8B02\u8B03\u8B04\u8B05\u8B06\u8B08\u8B09\u8B0A\u8B0B\u8B0C\u8B0D\u8B0E\u8B0F\u8B10\u8B11\u8B12\u8B13\u8B14\u8B15\u8B16\u8B17\u8B18\u8B19\u8B1A\u8B1B\u8B1C\u8B1D\u8B1E\u8B1F\u8B20\u8B21\u8B22\u8B23\uFFFD\u8B24\u8B25\u8B27\u8B28\u8B29\u8B2A\u8B2B\u8B2C\u8B2D\u8B2E\u8B2F\u8B30\u8B31\u8B32\u8B33\u8B34\u8B35\u8B36\u8B37\u8B38\u8B39\u8B3A\u8B3B\u8B3C\u8B3D\u8B3E\u8B3F\u8B40\u8B41\u8B42\u8B43\u8B44\u8B45\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B46\u8B47\u8B48\u8B49\u8B4A\u8B4B\u8B4C\u8B4D\u8B4E\u8B4F\u8B50\u8B51\u8B52\u8B53\u8B54\u8B55\u8B56\u8B57\u8B58\u8B59\u8B5A\u8B5B\u8B5C\u8B5D\u8B5E\u8B5F\u8B60\u8B61\u8B62\u8B63\u8B64\u8B65\u8B67\u8B68\u8B69\u8B6A\u8B6B\u8B6D\u8B6E\u8B6F\u8B70\u8B71\u8B72\u8B73\u8B74\u8B75\u8B76\u8B77\u8B78\u8B79\u8B7A\u8B7B\u8B7C\u8B7D\u8B7E\u8B7F\u8B80\u8B81\u8B82\u8B83\u8B84\u8B85\u8B86\uFFFD\u8B87\u8B88\u8B89\u8B8A\u8B8B\u8B8C\u8B8D\u8B8E\u8B8F\u8B90\u8B91\u8B92\u8B93\u8B94\u8B95\u8B96\u8B97\u8B98\u8B99\u8B9A\u8B9B\u8B9C\u8B9D\u8B9E\u8B9F\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8C38\u8C39\u8C3A\u8C3B\u8C3C\u8C3D\u8C3E\u8C3F\u8C40\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D\u8C4E\u8C4F\u8C50\u8C51\u8C52\u8C53\u8C54\u8C56\u8C57\u8C58\u8C59\u8C5B\u8C5C\u8C5D\u8C5E\u8C5F\u8C60\u8C63\u8C64\u8C65\u8C66\u8C67\u8C68\u8C69\u8C6C\u8C6D\u8C6E\u8C6F\u8C70\u8C71\u8C72\u8C74\u8C75\u8C76\u8C77\u8C7B\u8C7C\u8C7D\u8C7E\u8C7F\u8C80\u8C81\u8C83\u8C84\u8C86\u8C87\uFFFD\u8C88\u8C8B\u8C8D\u8C8E\u8C8F\u8C90\u8C91\u8C92\u8C93\u8C95\u8C96\u8C97\u8C99\u8C9A\u8C9B\u8C9C\u8C9D\u8C9E\u8C9F\u8CA0\u8CA1\u8CA2\u8CA3\u8CA4\u8CA5\u8CA6\u8CA7\u8CA8\u8CA9\u8CAA\u8CAB\u8CAC\u8CAD\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8CAE\u8CAF\u8CB0\u8CB1\u8CB2\u8CB3\u8CB4\u8CB5\u8CB6\u8CB7\u8CB8\u8CB9\u8CBA\u8CBB\u8CBC\u8CBD\u8CBE\u8CBF\u8CC0\u8CC1\u8CC2\u8CC3\u8CC4\u8CC5\u8CC6\u8CC7\u8CC8\u8CC9\u8CCA\u8CCB\u8CCC\u8CCD\u8CCE\u8CCF\u8CD0\u8CD1\u8CD2\u8CD3\u8CD4\u8CD5\u8CD6\u8CD7\u8CD8\u8CD9\u8CDA\u8CDB\u8CDC\u8CDD\u8CDE\u8CDF\u8CE0\u8CE1\u8CE2\u8CE3\u8CE4\u8CE5\u8CE6\u8CE7\u8CE8\u8CE9\u8CEA\u8CEB\u8CEC\uFFFD\u8CED\u8CEE\u8CEF\u8CF0\u8CF1\u8CF2\u8CF3\u8CF4\u8CF5\u8CF6\u8CF7\u8CF8\u8CF9\u8CFA\u8CFB\u8CFC\u8CFD\u8CFE\u8CFF\u8D00\u8D01\u8D02\u8D03\u8D04\u8D05\u8D06\u8D07\u8D08\u8D09\u8D0A\u8D0B\u8D0C\u8D0D\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D0E\u8D0F\u8D10\u8D11\u8D12\u8D13\u8D14\u8D15\u8D16\u8D17\u8D18\u8D19\u8D1A\u8D1B\u8D1C\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78\u8D79\u8D7A\u8D7B\u8D7C\u8D7D\u8D7E\u8D7F\u8D80\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C\u8D8D\u8D8E\u8D8F\u8D90\u8D92\u8D93\u8D95\u8D96\u8D97\u8D98\u8D99\u8D9A\u8D9B\u8D9C\u8D9D\u8D9E\u8DA0\u8DA1\uFFFD\u8DA2\u8DA4\u8DA5\u8DA6\u8DA7\u8DA8\u8DA9\u8DAA\u8DAB\u8DAC\u8DAD\u8DAE\u8DAF\u8DB0\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE\u8DFF\u8E00\u8E01\u8E02\u8E03\u8E04\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15\u8E16\u8E17\u8E18\u8E19\u8E1A\u8E1B\u8E1C\u8E20\u8E21\u8E24\u8E25\u8E26\u8E27\u8E28\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E\uFFFD\u8E3F\u8E43\u8E45\u8E46\u8E4C\u8E4D\u8E4E\u8E4F\u8E50\u8E53\u8E54\u8E55\u8E56\u8E57\u8E58\u8E5A\u8E5B\u8E5C\u8E5D\u8E5E\u8E5F\u8E60\u8E61\u8E62\u8E63\u8E64\u8E65\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E73\u8E75\u8E77\u8E78\u8E79\u8E7A\u8E7B\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88\u8E89\u8E8A\u8E8B\u8E8C\u8E8D\u8E8E\u8E91\u8E92\u8E93\u8E95\u8E96\u8E97\u8E98\u8E99\u8E9A\u8E9B\u8E9D\u8E9F\u8EA0\u8EA1\u8EA2\u8EA3\u8EA4\u8EA5\u8EA6\u8EA7\u8EA8\u8EA9\u8EAA\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3\u8EB4\u8EB5\u8EB6\u8EB7\u8EB8\u8EB9\u8EBB\u8EBC\u8EBD\u8EBE\u8EBF\u8EC0\u8EC1\u8EC2\uFFFD\u8EC3\u8EC4\u8EC5\u8EC6\u8EC7\u8EC8\u8EC9\u8ECA\u8ECB\u8ECC\u8ECD\u8ECF\u8ED0\u8ED1\u8ED2\u8ED3\u8ED4\u8ED5\u8ED6\u8ED7\u8ED8\u8ED9\u8EDA\u8EDB\u8EDC\u8EDD\u8EDE\u8EDF\u8EE0\u8EE1\u8EE2\u8EE3\u8EE4\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8EE5\u8EE6\u8EE7\u8EE8\u8EE9\u8EEA\u8EEB\u8EEC\u8EED\u8EEE\u8EEF\u8EF0\u8EF1\u8EF2\u8EF3\u8EF4\u8EF5\u8EF6\u8EF7\u8EF8\u8EF9\u8EFA\u8EFB\u8EFC\u8EFD\u8EFE\u8EFF\u8F00\u8F01\u8F02\u8F03\u8F04\u8F05\u8F06\u8F07\u8F08\u8F09\u8F0A\u8F0B\u8F0C\u8F0D\u8F0E\u8F0F\u8F10\u8F11\u8F12\u8F13\u8F14\u8F15\u8F16\u8F17\u8F18\u8F19\u8F1A\u8F1B\u8F1C\u8F1D\u8F1E\u8F1F\u8F20\u8F21\u8F22\u8F23\uFFFD\u8F24\u8F25\u8F26\u8F27\u8F28\u8F29\u8F2A\u8F2B\u8F2C\u8F2D\u8F2E\u8F2F\u8F30\u8F31\u8F32\u8F33\u8F34\u8F35\u8F36\u8F37\u8F38\u8F39\u8F3A\u8F3B\u8F3C\u8F3D\u8F3E\u8F3F\u8F40\u8F41\u8F42\u8F43\u8F44\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F45\u8F46\u8F47\u8F48\u8F49\u8F4A\u8F4B\u8F4C\u8F4D\u8F4E\u8F4F\u8F50\u8F51\u8F52\u8F53\u8F54\u8F55\u8F56\u8F57\u8F58\u8F59\u8F5A\u8F5B\u8F5C\u8F5D\u8F5E\u8F5F\u8F60\u8F61\u8F62\u8F63\u8F64\u8F65\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6\uFFFD\u8FC9\u8FCA\u8FCB\u8FCC\u8FCD\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9019\u901C\u9023\u9024\u9025\u9027\u9028\u9029\u902A\u902B\u902C\u9030\u9031\u9032\u9033\u9034\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048\u9049\u904A\u904B\u904C\u904E\u9054\u9055\u9056\u9059\u905A\u905C\u905D\u905E\u905F\u9060\u9061\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F\u9070\u9071\u9072\u9073\u9076\u9077\u9078\u9079\u907A\u907B\u907C\u907E\u9081\uFFFD\u9084\u9085\u9086\u9087\u9089\u908A\u908C\u908D\u908E\u908F\u9090\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105\u9106\u9107\u9108\u9109\u910A\u910B\u910C\u910D\u910E\u910F\u9110\u9111\u9112\u9113\u9114\u9115\u9116\u9117\u9118\u911A\u911B\u911C\uFFFD\u911D\u911F\u9120\u9121\u9124\u9125\u9126\u9127\u9128\u9129\u912A\u912B\u912C\u912D\u912E\u9130\u9132\u9133\u9134\u9135\u9136\u9137\u9138\u913A\u913B\u913C\u913D\u913E\u913F\u9140\u9141\u9142\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180\u9181\u9182\u9183\u9184\u9186\u9188\u918A\u918E\u918F\u9193\u9194\u9195\u9196\u9197\u9198\u9199\u919C\u919D\u919E\u919F\u91A0\u91A1\u91A4\u91A5\u91A6\u91A7\u91A8\u91A9\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB\uFFFD\u91BC\u91BD\u91BE\u91BF\u91C0\u91C1\u91C2\u91C3\u91C4\u91C5\u91C6\u91C8\u91CB\u91D0\u91D2\u91D3\u91D4\u91D5\u91D6\u91D7\u91D8\u91D9\u91DA\u91DB\u91DD\u91DE\u91DF\u91E0\u91E1\u91E2\u91E3\u91E4\u91E5\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u91E6\u91E7\u91E8\u91E9\u91EA\u91EB\u91EC\u91ED\u91EE\u91EF\u91F0\u91F1\u91F2\u91F3\u91F4\u91F5\u91F6\u91F7\u91F8\u91F9\u91FA\u91FB\u91FC\u91FD\u91FE\u91FF\u9200\u9201\u9202\u9203\u9204\u9205\u9206\u9207\u9208\u9209\u920A\u920B\u920C\u920D\u920E\u920F\u9210\u9211\u9212\u9213\u9214\u9215\u9216\u9217\u9218\u9219\u921A\u921B\u921C\u921D\u921E\u921F\u9220\u9221\u9222\u9223\u9224\uFFFD\u9225\u9226\u9227\u9228\u9229\u922A\u922B\u922C\u922D\u922E\u922F\u9230\u9231\u9232\u9233\u9234\u9235\u9236\u9237\u9238\u9239\u923A\u923B\u923C\u923D\u923E\u923F\u9240\u9241\u9242\u9243\u9244\u9245\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967\u9968\u9969\u996A\u996B\u996C\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9246\u9247\u9248\u9249\u924A\u924B\u924C\u924D\u924E\u924F\u9250\u9251\u9252\u9253\u9254\u9255\u9256\u9257\u9258\u9259\u925A\u925B\u925C\u925D\u925E\u925F\u9260\u9261\u9262\u9263\u9264\u9265\u9266\u9267\u9268\u9269\u926A\u926B\u926C\u926D\u926E\u926F\u9270\u9271\u9272\u9273\u9275\u9276\u9277\u9278\u9279\u927A\u927B\u927C\u927D\u927E\u927F\u9280\u9281\u9282\u9283\u9284\u9285\uFFFD\u9286\u9287\u9288\u9289\u928A\u928B\u928C\u928D\u928F\u9290\u9291\u9292\u9293\u9294\u9295\u9296\u9297\u9298\u9299\u929A\u929B\u929C\u929D\u929E\u929F\u92A0\u92A1\u92A2\u92A3\u92A4\u92A5\u92A6\u92A7\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92A8\u92A9\u92AA\u92AB\u92AC\u92AD\u92AF\u92B0\u92B1\u92B2\u92B3\u92B4\u92B5\u92B6\u92B7\u92B8\u92B9\u92BA\u92BB\u92BC\u92BD\u92BE\u92BF\u92C0\u92C1\u92C2\u92C3\u92C4\u92C5\u92C6\u92C7\u92C9\u92CA\u92CB\u92CC\u92CD\u92CE\u92CF\u92D0\u92D1\u92D2\u92D3\u92D4\u92D5\u92D6\u92D7\u92D8\u92D9\u92DA\u92DB\u92DC\u92DD\u92DE\u92DF\u92E0\u92E1\u92E2\u92E3\u92E4\u92E5\u92E6\u92E7\u92E8\uFFFD\u92E9\u92EA\u92EB\u92EC\u92ED\u92EE\u92EF\u92F0\u92F1\u92F2\u92F3\u92F4\u92F5\u92F6\u92F7\u92F8\u92F9\u92FA\u92FB\u92FC\u92FD\u92FE\u92FF\u9300\u9301\u9302\u9303\u9304\u9305\u9306\u9307\u9308\u9309\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u930A\u930B\u930C\u930D\u930E\u930F\u9310\u9311\u9312\u9313\u9314\u9315\u9316\u9317\u9318\u9319\u931A\u931B\u931C\u931D\u931E\u931F\u9320\u9321\u9322\u9323\u9324\u9325\u9326\u9327\u9328\u9329\u932A\u932B\u932C\u932D\u932E\u932F\u9330\u9331\u9332\u9333\u9334\u9335\u9336\u9337\u9338\u9339\u933A\u933B\u933C\u933D\u933F\u9340\u9341\u9342\u9343\u9344\u9345\u9346\u9347\u9348\u9349\uFFFD\u934A\u934B\u934C\u934D\u934E\u934F\u9350\u9351\u9352\u9353\u9354\u9355\u9356\u9357\u9358\u9359\u935A\u935B\u935C\u935D\u935E\u935F\u9360\u9361\u9362\u9363\u9364\u9365\u9366\u9367\u9368\u9369\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u936C\u936D\u936E\u936F\u9370\u9371\u9372\u9373\u9374\u9375\u9376\u9377\u9378\u9379\u937A\u937B\u937C\u937D\u937E\u937F\u9380\u9381\u9382\u9383\u9384\u9385\u9386\u9387\u9388\u9389\u938A\u938B\u938C\u938D\u938E\u9390\u9391\u9392\u9393\u9394\u9395\u9396\u9397\u9398\u9399\u939A\u939B\u939C\u939D\u939E\u939F\u93A0\u93A1\u93A2\u93A3\u93A4\u93A5\u93A6\u93A7\u93A8\u93A9\u93AA\u93AB\uFFFD\u93AC\u93AD\u93AE\u93AF\u93B0\u93B1\u93B2\u93B3\u93B4\u93B5\u93B6\u93B7\u93B8\u93B9\u93BA\u93BB\u93BC\u93BD\u93BE\u93BF\u93C0\u93C1\u93C2\u93C3\u93C4\u93C5\u93C6\u93C7\u93C8\u93C9\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93CE\u93CF\u93D0\u93D1\u93D2\u93D3\u93D4\u93D5\u93D7\u93D8\u93D9\u93DA\u93DB\u93DC\u93DD\u93DE\u93DF\u93E0\u93E1\u93E2\u93E3\u93E4\u93E5\u93E6\u93E7\u93E8\u93E9\u93EA\u93EB\u93EC\u93ED\u93EE\u93EF\u93F0\u93F1\u93F2\u93F3\u93F4\u93F5\u93F6\u93F7\u93F8\u93F9\u93FA\u93FB\u93FC\u93FD\u93FE\u93FF\u9400\u9401\u9402\u9403\u9404\u9405\u9406\u9407\u9408\u9409\u940A\u940B\u940C\u940D\uFFFD\u940E\u940F\u9410\u9411\u9412\u9413\u9414\u9415\u9416\u9417\u9418\u9419\u941A\u941B\u941C\u941D\u941E\u941F\u9420\u9421\u9422\u9423\u9424\u9425\u9426\u9427\u9428\u9429\u942A\u942B\u942C\u942D\u942E\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21\u7F22\u7F23\u7F24\u7F25\u7F26\u7F27\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F\u7F30\u7F31\u7F32\u7F33\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u942F\u9430\u9431\u9432\u9433\u9434\u9435\u9436\u9437\u9438\u9439\u943A\u943B\u943C\u943D\u943F\u9440\u9441\u9442\u9443\u9444\u9445\u9446\u9447\u9448\u9449\u944A\u944B\u944C\u944D\u944E\u944F\u9450\u9451\u9452\u9453\u9454\u9455\u9456\u9457\u9458\u9459\u945A\u945B\u945C\u945D\u945E\u945F\u9460\u9461\u9462\u9463\u9464\u9465\u9466\u9467\u9468\u9469\u946A\u946C\u946D\u946E\u946F\uFFFD\u9470\u9471\u9472\u9473\u9474\u9475\u9476\u9477\u9478\u9479\u947A\u947B\u947C\u947D\u947E\u947F\u9480\u9481\u9482\u9483\u9484\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577\u9578\u9579\u957A\u957B\u957C\u957D\u957E\u9580\u9581\u9582\u9583\u9584\u9585\u9586\u9587\u9588\u9589\u958A\u958B\u958C\u958D\u958E\u958F\u9590\u9591\u9592\u9593\u9594\u9595\u9596\u9597\u9598\u9599\u959A\u959B\u959C\u959D\u959E\u959F\u95A0\u95A1\u95A2\u95A3\u95A4\u95A5\u95A6\u95A7\u95A8\u95A9\u95AA\uFFFD\u95AB\u95AC\u95AD\u95AE\u95AF\u95B0\u95B1\u95B2\u95B3\u95B4\u95B5\u95B6\u95B7\u95B8\u95B9\u95BA\u95BB\u95BC\u95BD\u95BE\u95BF\u95C0\u95C1\u95C2\u95C3\u95C4\u95C5\u95C6\u95C7\u95C8\u95C9\u95CA\u95CB\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u95CC\u95CD\u95CE\u95CF\u95D0\u95D1\u95D2\u95D3\u95D4\u95D5\u95D6\u95D7\u95D8\u95D9\u95DA\u95DB\u95DC\u95DD\u95DE\u95DF\u95E0\u95E1\u95E2\u95E3\u95E4\u95E5\u95E6\u95E7\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623\u9624\u9625\u9626\u9627\u9628\u9629\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657\uFFFD\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D\u966E\u966F\u9670\u9671\u9673\u9678\u9679\u967A\u967B\u967C\u967D\u967E\u967F\u9680\u9681\u9682\u9683\u9684\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D\u969E\u969F\u96A0\u96A1\u96A2\u96A3\u96A4\u96A5\u96A6\u96A8\u96A9\u96AA\u96AB\u96AC\u96AD\u96AE\u96AF\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6\u96D7\u96D8\u96D9\u96DA\u96DB\u96DC\u96DD\u96DE\u96DF\u96E1\u96E2\u96E3\u96E4\u96E5\u96E6\u96E7\u96EB\uFFFD\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717\u9718\u9719\u971A\u971B\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9721\u9722\u9723\u9724\u9725\u9726\u9727\u9728\u9729\u972B\u972C\u972E\u972F\u9731\u9733\u9734\u9735\u9736\u9737\u973A\u973B\u973C\u973D\u973F\u9740\u9741\u9742\u9743\u9744\u9745\u9746\u9747\u9748\u9749\u974A\u974B\u974C\u974D\u974E\u974F\u9750\u9751\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A\u976B\u976C\u976D\u976E\u976F\u9770\u9771\uFFFD\u9772\u9775\u9777\u9778\u9779\u977A\u977B\u977D\u977E\u977F\u9780\u9781\u9782\u9783\u9784\u9786\u9787\u9788\u9789\u978A\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799\u979A\u979B\u979C\u979D\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u979E\u979F\u97A1\u97A2\u97A4\u97A5\u97A6\u97A7\u97A8\u97A9\u97AA\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5\u97B6\u97B7\u97B8\u97B9\u97BA\u97BB\u97BC\u97BD\u97BE\u97BF\u97C0\u97C1\u97C2\u97C3\u97C4\u97C5\u97C6\u97C7\u97C8\u97C9\u97CA\u97CB\u97CC\u97CD\u97CE\u97CF\u97D0\u97D1\u97D2\u97D3\u97D4\u97D5\u97D6\u97D7\u97D8\u97D9\u97DA\u97DB\u97DC\u97DD\u97DE\u97DF\u97E0\u97E1\u97E2\u97E3\uFFFD\u97E4\u97E5\u97E8\u97EE\u97EF\u97F0\u97F1\u97F2\u97F4\u97F7\u97F8\u97F9\u97FA\u97FB\u97FC\u97FD\u97FE\u97FF\u9800\u9801\u9802\u9803\u9804\u9805\u9806\u9807\u9808\u9809\u980A\u980B\u980C\u980D\u980E\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u980F\u9810\u9811\u9812\u9813\u9814\u9815\u9816\u9817\u9818\u9819\u981A\u981B\u981C\u981D\u981E\u981F\u9820\u9821\u9822\u9823\u9824\u9825\u9826\u9827\u9828\u9829\u982A\u982B\u982C\u982D\u982E\u982F\u9830\u9831\u9832\u9833\u9834\u9835\u9836\u9837\u9838\u9839\u983A\u983B\u983C\u983D\u983E\u983F\u9840\u9841\u9842\u9843\u9844\u9845\u9846\u9847\u9848\u9849\u984A\u984B\u984C\u984D\uFFFD\u984E\u984F\u9850\u9851\u9852\u9853\u9854\u9855\u9856\u9857\u9858\u9859\u985A\u985B\u985C\u985D\u985E\u985F\u9860\u9861\u9862\u9863\u9864\u9865\u9866\u9867\u9868\u9869\u986A\u986B\u986C\u986D\u986E\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6\u94B7\u94B8\u94B9\u94BA\u94BC\u94BD\u94BF\u94C4\u94C8\u94C9\u94CA\u94CB\u94CC\u94CD\u94CE\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u986F\u9870\u9871\u9872\u9873\u9874\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8\u98A9\u98AA\u98AB\u98AC\u98AD\u98AE\u98AF\u98B0\u98B1\u98B2\u98B3\u98B4\u98B5\u98B6\u98B7\u98B8\u98B9\u98BA\u98BB\u98BC\u98BD\u98BE\u98BF\u98C0\u98C1\u98C2\u98C3\u98C4\u98C5\u98C6\u98C7\u98C8\u98C9\u98CA\u98CB\u98CC\u98CD\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0\u98E1\u98E2\u98E3\u98E4\uFFFD\u98E5\u98E6\u98E9\u98EA\u98EB\u98EC\u98ED\u98EE\u98EF\u98F0\u98F1\u98F2\u98F3\u98F4\u98F5\u98F6\u98F7\u98F8\u98F9\u98FA\u98FB\u98FC\u98FD\u98FE\u98FF\u9900\u9901\u9902\u9903\u9904\u9905\u9906\u9907\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512\u9513\u9514\u9515\u9516\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564\u9565\u9566\u9567\u9568\u9569\u956A\u956B\u956C\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9908\u9909\u990A\u990B\u990C\u990E\u990F\u9911\u9912\u9913\u9914\u9915\u9916\u9917\u9918\u9919\u991A\u991B\u991C\u991D\u991E\u991F\u9920\u9921\u9922\u9923\u9924\u9925\u9926\u9927\u9928\u9929\u992A\u992B\u992C\u992D\u992F\u9930\u9931\u9932\u9933\u9934\u9935\u9936\u9937\u9938\u9939\u993A\u993B\u993C\u993D\u993E\u993F\u9940\u9941\u9942\u9943\u9944\u9945\u9946\u9947\u9948\u9949\uFFFD\u994A\u994B\u994C\u994D\u994E\u994F\u9950\u9951\u9952\u9953\u9956\u9957\u9958\u9959\u995A\u995B\u995C\u995D\u995E\u995F\u9960\u9961\u9962\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28\u9E29\u9E2A\u9E2B\u9E2C\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66\u9E67\u9E68\u9E69\u9E6A\u9E6B\u9E6C\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u998C\u998E\u999A\u999B\u999C\u999D\u999E\u999F\u99A0\u99A1\u99A2\u99A3\u99A4\u99A6\u99A7\u99A9\u99AA\u99AB\u99AC\u99AD\u99AE\u99AF\u99B0\u99B1\u99B2\u99B3\u99B4\u99B5\u99B6\u99B7\u99B8\u99B9\u99BA\u99BB\u99BC\u99BD\u99BE\u99BF\u99C0\u99C1\u99C2\u99C3\u99C4\u99C5\u99C6\u99C7\u99C8\u99C9\u99CA\u99CB\u99CC\u99CD\u99CE\u99CF\u99D0\u99D1\u99D2\u99D3\u99D4\u99D5\u99D6\u99D7\u99D8\uFFFD\u99D9\u99DA\u99DB\u99DC\u99DD\u99DE\u99DF\u99E0\u99E1\u99E2\u99E3\u99E4\u99E5\u99E6\u99E7\u99E8\u99E9\u99EA\u99EB\u99EC\u99ED\u99EE\u99EF\u99F0\u99F1\u99F2\u99F3\u99F4\u99F5\u99F6\u99F7\u99F8\u99F9\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u99FA\u99FB\u99FC\u99FD\u99FE\u99FF\u9A00\u9A01\u9A02\u9A03\u9A04\u9A05\u9A06\u9A07\u9A08\u9A09\u9A0A\u9A0B\u9A0C\u9A0D\u9A0E\u9A0F\u9A10\u9A11\u9A12\u9A13\u9A14\u9A15\u9A16\u9A17\u9A18\u9A19\u9A1A\u9A1B\u9A1C\u9A1D\u9A1E\u9A1F\u9A20\u9A21\u9A22\u9A23\u9A24\u9A25\u9A26\u9A27\u9A28\u9A29\u9A2A\u9A2B\u9A2C\u9A2D\u9A2E\u9A2F\u9A30\u9A31\u9A32\u9A33\u9A34\u9A35\u9A36\u9A37\u9A38\uFFFD\u9A39\u9A3A\u9A3B\u9A3C\u9A3D\u9A3E\u9A3F\u9A40\u9A41\u9A42\u9A43\u9A44\u9A45\u9A46\u9A47\u9A48\u9A49\u9A4A\u9A4B\u9A4C\u9A4D\u9A4E\u9A4F\u9A50\u9A51\u9A52\u9A53\u9A54\u9A55\u9A56\u9A57\u9A58\u9A59\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A5A\u9A5B\u9A5C\u9A5D\u9A5E\u9A5F\u9A60\u9A61\u9A62\u9A63\u9A64\u9A65\u9A66\u9A67\u9A68\u9A69\u9A6A\u9A6B\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9\u9AAA\u9AAB\u9AAC\u9AAD\u9AAE\u9AAF\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6\u9AC7\u9AC8\u9AC9\u9ACA\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC\uFFFD\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0\u9AF1\u9AF2\u9AF3\u9AF4\u9AF5\u9AF6\u9AF7\u9AF8\u9AFA\u9AFC\u9AFD\u9AFE\u9AFF\u9B00\u9B01\u9B02\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B07\u9B09\u9B0A\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B11\u9B12\u9B14\u9B15\u9B16\u9B17\u9B18\u9B19\u9B1A\u9B1B\u9B1C\u9B1D\u9B1E\u9B20\u9B21\u9B22\u9B24\u9B25\u9B26\u9B27\u9B28\u9B29\u9B2A\u9B2B\u9B2C\u9B2D\u9B2E\u9B30\u9B31\u9B33\u9B34\u9B35\u9B36\u9B37\u9B38\u9B39\u9B3A\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55\u9B56\u9B57\u9B58\u9B59\u9B5A\uFFFD\u9B5B\u9B5C\u9B5D\u9B5E\u9B5F\u9B60\u9B61\u9B62\u9B63\u9B64\u9B65\u9B66\u9B67\u9B68\u9B69\u9B6A\u9B6B\u9B6C\u9B6D\u9B6E\u9B6F\u9B70\u9B71\u9B72\u9B73\u9B74\u9B75\u9B76\u9B77\u9B78\u9B79\u9B7A\u9B7B\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B7C\u9B7D\u9B7E\u9B7F\u9B80\u9B81\u9B82\u9B83\u9B84\u9B85\u9B86\u9B87\u9B88\u9B89\u9B8A\u9B8B\u9B8C\u9B8D\u9B8E\u9B8F\u9B90\u9B91\u9B92\u9B93\u9B94\u9B95\u9B96\u9B97\u9B98\u9B99\u9B9A\u9B9B\u9B9C\u9B9D\u9B9E\u9B9F\u9BA0\u9BA1\u9BA2\u9BA3\u9BA4\u9BA5\u9BA6\u9BA7\u9BA8\u9BA9\u9BAA\u9BAB\u9BAC\u9BAD\u9BAE\u9BAF\u9BB0\u9BB1\u9BB2\u9BB3\u9BB4\u9BB5\u9BB6\u9BB7\u9BB8\u9BB9\u9BBA\uFFFD\u9BBB\u9BBC\u9BBD\u9BBE\u9BBF\u9BC0\u9BC1\u9BC2\u9BC3\u9BC4\u9BC5\u9BC6\u9BC7\u9BC8\u9BC9\u9BCA\u9BCB\u9BCC\u9BCD\u9BCE\u9BCF\u9BD0\u9BD1\u9BD2\u9BD3\u9BD4\u9BD5\u9BD6\u9BD7\u9BD8\u9BD9\u9BDA\u9BDB\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9BDC\u9BDD\u9BDE\u9BDF\u9BE0\u9BE1\u9BE2\u9BE3\u9BE4\u9BE5\u9BE6\u9BE7\u9BE8\u9BE9\u9BEA\u9BEB\u9BEC\u9BED\u9BEE\u9BEF\u9BF0\u9BF1\u9BF2\u9BF3\u9BF4\u9BF5\u9BF6\u9BF7\u9BF8\u9BF9\u9BFA\u9BFB\u9BFC\u9BFD\u9BFE\u9BFF\u9C00\u9C01\u9C02\u9C03\u9C04\u9C05\u9C06\u9C07\u9C08\u9C09\u9C0A\u9C0B\u9C0C\u9C0D\u9C0E\u9C0F\u9C10\u9C11\u9C12\u9C13\u9C14\u9C15\u9C16\u9C17\u9C18\u9C19\u9C1A\uFFFD\u9C1B\u9C1C\u9C1D\u9C1E\u9C1F\u9C20\u9C21\u9C22\u9C23\u9C24\u9C25\u9C26\u9C27\u9C28\u9C29\u9C2A\u9C2B\u9C2C\u9C2D\u9C2E\u9C2F\u9C30\u9C31\u9C32\u9C33\u9C34\u9C35\u9C36\u9C37\u9C38\u9C39\u9C3A\u9C3B\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85\u9F86\u9F87\u9F88\u9F89\u9F8A\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E\u9C9F\u9CA0\u9CA1\u9CA2\u9CA3\u9CA5\u9CA6\u9CA7\u9CA8\u9CA9\u9CAB\u9CAD\u9CAE\u9CB0\u9CB1\u9CB2\u9CB3\u9CB4\u9CB5\u9CB6\u9CB7\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9C3C\u9C3D\u9C3E\u9C3F\u9C40\u9C41\u9C42\u9C43\u9C44\u9C45\u9C46\u9C47\u9C48\u9C49\u9C4A\u9C4B\u9C4C\u9C4D\u9C4E\u9C4F\u9C50\u9C51\u9C52\u9C53\u9C54\u9C55\u9C56\u9C57\u9C58\u9C59\u9C5A\u9C5B\u9C5C\u9C5D\u9C5E\u9C5F\u9C60\u9C61\u9C62\u9C63\u9C64\u9C65\u9C66\u9C67\u9C68\u9C69\u9C6A\u9C6B\u9C6C\u9C6D\u9C6E\u9C6F\u9C70\u9C71\u9C72\u9C73\u9C74\u9C75\u9C76\u9C77\u9C78\u9C79\u9C7A\uFFFD\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE\u9CBF\u9CC0\u9CC1\u9CC2\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC\u9CCD\u9CCE\u9CCF\u9CD0\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9CE3\u9CE4\u9CE5\u9CE6\u9CE7\u9CE8\u9CE9\u9CEA\u9CEB\u9CEC\u9CED\u9CEE\u9CEF\u9CF0\u9CF1\u9CF2\u9CF3\u9CF4\u9CF5\u9CF6\u9CF7\u9CF8\u9CF9\u9CFA\u9CFB\u9CFC\u9CFD\u9CFE\u9CFF\u9D00\u9D01\u9D02\u9D03\u9D04\u9D05\u9D06\u9D07\u9D08\u9D09\u9D0A\u9D0B\u9D0C\u9D0D\u9D0E\u9D0F\u9D10\u9D11\u9D12\u9D13\u9D14\u9D15\u9D16\u9D17\u9D18\u9D19\u9D1A\u9D1B\u9D1C\u9D1D\u9D1E\u9D1F\u9D20\u9D21\uFFFD\u9D22\u9D23\u9D24\u9D25\u9D26\u9D27\u9D28\u9D29\u9D2A\u9D2B\u9D2C\u9D2D\u9D2E\u9D2F\u9D30\u9D31\u9D32\u9D33\u9D34\u9D35\u9D36\u9D37\u9D38\u9D39\u9D3A\u9D3B\u9D3C\u9D3D\u9D3E\u9D3F\u9D40\u9D41\u9D42\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D43\u9D44\u9D45\u9D46\u9D47\u9D48\u9D49\u9D4A\u9D4B\u9D4C\u9D4D\u9D4E\u9D4F\u9D50\u9D51\u9D52\u9D53\u9D54\u9D55\u9D56\u9D57\u9D58\u9D59\u9D5A\u9D5B\u9D5C\u9D5D\u9D5E\u9D5F\u9D60\u9D61\u9D62\u9D63\u9D64\u9D65\u9D66\u9D67\u9D68\u9D69\u9D6A\u9D6B\u9D6C\u9D6D\u9D6E\u9D6F\u9D70\u9D71\u9D72\u9D73\u9D74\u9D75\u9D76\u9D77\u9D78\u9D79\u9D7A\u9D7B\u9D7C\u9D7D\u9D7E\u9D7F\u9D80\u9D81\uFFFD\u9D82\u9D83\u9D84\u9D85\u9D86\u9D87\u9D88\u9D89\u9D8A\u9D8B\u9D8C\u9D8D\u9D8E\u9D8F\u9D90\u9D91\u9D92\u9D93\u9D94\u9D95\u9D96\u9D97\u9D98\u9D99\u9D9A\u9D9B\u9D9C\u9D9D\u9D9E\u9D9F\u9DA0\u9DA1\u9DA2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9DA3\u9DA4\u9DA5\u9DA6\u9DA7\u9DA8\u9DA9\u9DAA\u9DAB\u9DAC\u9DAD\u9DAE\u9DAF\u9DB0\u9DB1\u9DB2\u9DB3\u9DB4\u9DB5\u9DB6\u9DB7\u9DB8\u9DB9\u9DBA\u9DBB\u9DBC\u9DBD\u9DBE\u9DBF\u9DC0\u9DC1\u9DC2\u9DC3\u9DC4\u9DC5\u9DC6\u9DC7\u9DC8\u9DC9\u9DCA\u9DCB\u9DCC\u9DCD\u9DCE\u9DCF\u9DD0\u9DD1\u9DD2\u9DD3\u9DD4\u9DD5\u9DD6\u9DD7\u9DD8\u9DD9\u9DDA\u9DDB\u9DDC\u9DDD\u9DDE\u9DDF\u9DE0\u9DE1\uFFFD\u9DE2\u9DE3\u9DE4\u9DE5\u9DE6\u9DE7\u9DE8\u9DE9\u9DEA\u9DEB\u9DEC\u9DED\u9DEE\u9DEF\u9DF0\u9DF1\u9DF2\u9DF3\u9DF4\u9DF5\u9DF6\u9DF7\u9DF8\u9DF9\u9DFA\u9DFB\u9DFC\u9DFD\u9DFE\u9DFF\u9E00\u9E01\u9E02\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9E03\u9E04\u9E05\u9E06\u9E07\u9E08\u9E09\u9E0A\u9E0B\u9E0C\u9E0D\u9E0E\u9E0F\u9E10\u9E11\u9E12\u9E13\u9E14\u9E15\u9E16\u9E17\u9E18\u9E19\u9E1A\u9E1B\u9E1C\u9E1D\u9E1E\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74\u9E75\u9E76\u9E77\u9E78\u9E79\u9E7A\u9E7B\u9E7C\u9E7D\u9E80\uFFFD\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C\u9E8D\u9E8E\u9E8F\u9E90\u9E91\u9E94\u9E95\u9E96\u9E97\u9E98\u9E99\u9E9A\u9E9B\u9E9C\u9E9E\u9EA0\u9EA1\u9EA2\u9EA3\u9EA4\u9EA5\u9EA7\u9EA8\u9EA9\u9EAA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9EAB\u9EAC\u9EAD\u9EAE\u9EAF\u9EB0\u9EB1\u9EB2\u9EB3\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF\u9EC0\u9EC1\u9EC2\u9EC3\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF3\u9EF4\u9EF5\u9EF6\u9EF7\u9EF8\u9EFA\u9EFD\u9EFF\u9F00\u9F01\u9F02\u9F03\u9F04\u9F05\uFFFD\u9F06\u9F07\u9F08\u9F09\u9F0A\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A\u9F1B\u9F1C\u9F1D\u9F1E\u9F1F\u9F21\u9F23\u9F24\u9F25\u9F26\u9F27\u9F28\u9F29\u9F2A\u9F2B\u9F2D\u9F2E\u9F30\u9F31\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    D[253] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F32\u9F33\u9F34\u9F35\u9F36\u9F38\u9F3A\u9F3C\u9F3F\u9F40\u9F41\u9F42\u9F43\u9F45\u9F46\u9F47\u9F48\u9F49\u9F4A\u9F4B\u9F4C\u9F4D\u9F4E\u9F4F\u9F52\u9F53\u9F54\u9F55\u9F56\u9F57\u9F58\u9F59\u9F5A\u9F5B\u9F5C\u9F5D\u9F5E\u9F5F\u9F60\u9F61\u9F62\u9F63\u9F64\u9F65\u9F66\u9F67\u9F68\u9F69\u9F6A\u9F6B\u9F6C\u9F6D\u9F6E\u9F6F\u9F70\u9F71\u9F72\u9F73\u9F74\u9F75\u9F76\u9F77\u9F78\uFFFD\u9F79\u9F7A\u9F7B\u9F7C\u9F7D\u9F7E\u9F81\u9F82\u9F8D\u9F8E\u9F8F\u9F90\u9F91\u9F92\u9F93\u9F94\u9F95\u9F96\u9F97\u9F98\u9F9C\u9F9D\u9F9E\u9FA1\u9FA2\u9FA3\u9FA4\u9FA5\uF92C\uF979\uF995\uF9E7\uF9F1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[253].length; ++j)if (D[253][j].charCodeAt(0) !== 0xFFFD) {
        e[D[253][j]] = 64768 + j;
        d[64768 + j] = D[253][j];
    }
    D[254] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[254].length; ++j)if (D[254][j].charCodeAt(0) !== 0xFFFD) {
        e[D[254][j]] = 65024 + j;
        d[65024 + j] = D[254][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[949] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[129] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC02\uAC03\uAC05\uAC06\uAC0B\uAC0C\uAC0D\uAC0E\uAC0F\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25\uAC26\uAC27\uAC28\uAC29\uAC2A\uAC2B\uAC2E\uAC32\uAC33\uAC34\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41\uAC42\uAC43\uAC44\uAC45\uAC46\uAC47\uAC48\uAC49\uAC4A\uAC4C\uAC4E\uAC4F\uAC50\uAC51\uAC52\uAC53\uAC55\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D\uAC5E\uAC5F\uAC60\uAC61\uAC62\uAC63\uAC64\uAC65\uAC66\uAC67\uAC68\uAC69\uAC6A\uAC6B\uAC6C\uAC6D\uAC6E\uAC6F\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B\uAC7C\uAC7D\uAC7E\uAC7F\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95\uAC96\uAC97\uAC98\uAC99\uAC9A\uAC9B\uAC9E\uACA2\uACA3\uACA4\uACA5\uACA6\uACA7\uACAB\uACAD\uACAE\uACB1\uACB2\uACB3\uACB4\uACB5\uACB6\uACB7\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD\uACCE\uACCF\uACD0\uACD1\uACD2\uACD3\uACD4\uACD6\uACD8\uACD9\uACDA\uACDB\uACDC\uACDD\uACDE\uACDF\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7\uACF8\uACF9\uACFA\uACFB\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07\uAD08\uAD09\uAD0A\uAD0B\uAD0E\uAD10\uAD12\uAD13\uFFFD".split("");
    for(j = 0; j != D[129].length; ++j)if (D[129][j].charCodeAt(0) !== 0xFFFD) {
        e[D[129][j]] = 33024 + j;
        d[33024 + j] = D[129][j];
    }
    D[130] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21\uAD22\uAD23\uAD24\uAD25\uAD26\uAD27\uAD28\uAD2A\uAD2B\uAD2E\uAD2F\uAD30\uAD31\uAD32\uAD33\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D\uAD3E\uAD3F\uAD40\uAD41\uAD42\uAD43\uAD46\uAD48\uAD4A\uAD4B\uAD4C\uAD4D\uAD4E\uAD4F\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAD59\uAD5A\uAD5B\uAD5C\uAD5D\uAD5E\uAD5F\uAD60\uAD62\uAD64\uAD65\uAD66\uAD67\uAD68\uAD69\uAD6A\uAD6B\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83\uAD84\uAD85\uAD86\uAD87\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91\uAD92\uAD93\uAD94\uAD95\uAD96\uAD97\uAD98\uAD99\uAD9A\uAD9B\uAD9E\uAD9F\uADA0\uADA1\uADA2\uADA3\uADA5\uADA6\uADA7\uADA8\uADA9\uADAA\uADAB\uADAC\uADAD\uADAE\uADAF\uADB0\uADB1\uADB2\uADB3\uADB4\uADB5\uADB6\uADB8\uADB9\uADBA\uADBB\uADBC\uADBD\uADBE\uADBF\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9\uADCA\uADCB\uADCC\uADCD\uADCE\uADCF\uADD2\uADD4\uADD5\uADD6\uADD7\uADD8\uADD9\uADDA\uADDB\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5\uADE6\uADE7\uADE8\uADE9\uADEA\uADEB\uADEC\uADED\uADEE\uADEF\uADF0\uADF1\uADF2\uADF3\uADF4\uADF5\uADF6\uADF7\uFFFD".split("");
    for(j = 0; j != D[130].length; ++j)if (D[130][j].charCodeAt(0) !== 0xFFFD) {
        e[D[130][j]] = 33280 + j;
        d[33280 + j] = D[130][j];
    }
    D[131] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uADFA\uADFB\uADFD\uADFE\uAE02\uAE03\uAE04\uAE05\uAE06\uAE07\uAE0A\uAE0C\uAE0E\uAE0F\uAE10\uAE11\uAE12\uAE13\uAE15\uAE16\uAE17\uAE18\uAE19\uAE1A\uAE1B\uAE1C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAE1D\uAE1E\uAE1F\uAE20\uAE21\uAE22\uAE23\uAE24\uAE25\uAE26\uAE27\uAE28\uAE29\uAE2A\uAE2B\uAE2C\uAE2D\uAE2E\uAE2F\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57\uAE58\uAE59\uAE5A\uAE5B\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71\uAE72\uAE73\uAE74\uAE75\uAE76\uAE77\uAE7A\uAE7E\uAE7F\uAE80\uAE81\uAE82\uAE83\uAE86\uAE87\uAE88\uAE89\uAE8A\uAE8B\uAE8D\uAE8E\uAE8F\uAE90\uAE91\uAE92\uAE93\uAE94\uAE95\uAE96\uAE97\uAE98\uAE99\uAE9A\uAE9B\uAE9C\uAE9D\uAE9E\uAE9F\uAEA0\uAEA1\uAEA2\uAEA3\uAEA4\uAEA5\uAEA6\uAEA7\uAEA8\uAEA9\uAEAA\uAEAB\uAEAC\uAEAD\uAEAE\uAEAF\uAEB0\uAEB1\uAEB2\uAEB3\uAEB4\uAEB5\uAEB6\uAEB7\uAEB8\uAEB9\uAEBA\uAEBB\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5\uAEC6\uAEC7\uAEC8\uAEC9\uAECA\uAECB\uAECE\uAED2\uAED3\uAED4\uAED5\uAED6\uAED7\uAEDA\uAEDB\uAEDD\uAEDE\uAEDF\uAEE0\uAEE1\uAEE2\uAEE3\uAEE4\uAEE5\uFFFD".split("");
    for(j = 0; j != D[131].length; ++j)if (D[131][j].charCodeAt(0) !== 0xFFFD) {
        e[D[131][j]] = 33536 + j;
        d[33536 + j] = D[131][j];
    }
    D[132] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE\uAEEF\uAEF0\uAEF1\uAEF2\uAEF3\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD\uAEFE\uAEFF\uAF00\uAF01\uAF02\uAF03\uAF04\uAF05\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11\uAF12\uAF13\uAF14\uAF15\uAF16\uAF17\uAF18\uAF19\uAF1A\uAF1B\uAF1C\uAF1D\uAF1E\uAF1F\uAF20\uAF21\uAF22\uAF23\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAF24\uAF25\uAF26\uAF27\uAF28\uAF29\uAF2A\uAF2B\uAF2E\uAF2F\uAF31\uAF33\uAF35\uAF36\uAF37\uAF38\uAF39\uAF3A\uAF3B\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A\uAF4B\uAF4C\uAF4D\uAF4E\uAF4F\uAF51\uAF52\uAF53\uAF54\uAF55\uAF56\uAF57\uAF58\uAF59\uAF5A\uAF5B\uAF5E\uAF5F\uAF60\uAF61\uAF62\uAF63\uAF66\uAF67\uAF68\uAF69\uAF6A\uAF6B\uAF6C\uAF6D\uAF6E\uAF6F\uAF70\uAF71\uAF72\uAF73\uAF74\uAF75\uAF76\uAF77\uAF78\uAF7A\uAF7B\uAF7C\uAF7D\uAF7E\uAF7F\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89\uAF8A\uAF8B\uAF8C\uAF8D\uAF8E\uAF8F\uAF92\uAF93\uAF94\uAF96\uAF97\uAF98\uAF99\uAF9A\uAF9B\uAF9D\uAF9E\uAF9F\uAFA0\uAFA1\uAFA2\uAFA3\uAFA4\uAFA5\uAFA6\uAFA7\uAFA8\uAFA9\uAFAA\uAFAB\uAFAC\uAFAD\uAFAE\uAFAF\uAFB0\uAFB1\uAFB2\uAFB3\uAFB4\uAFB5\uAFB6\uAFB7\uAFBA\uAFBB\uAFBD\uAFBE\uFFFD".split("");
    for(j = 0; j != D[132].length; ++j)if (D[132][j].charCodeAt(0) !== 0xFFFD) {
        e[D[132][j]] = 33792 + j;
        d[33792 + j] = D[132][j];
    }
    D[133] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAFBF\uAFC1\uAFC2\uAFC3\uAFC4\uAFC5\uAFC6\uAFCA\uAFCC\uAFCF\uAFD0\uAFD1\uAFD2\uAFD3\uAFD5\uAFD6\uAFD7\uAFD8\uAFD9\uAFDA\uAFDB\uAFDD\uAFDE\uAFDF\uAFE0\uAFE1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uAFE2\uAFE3\uAFE4\uAFE5\uAFE6\uAFE7\uAFEA\uAFEB\uAFEC\uAFED\uAFEE\uAFEF\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9\uAFFA\uAFFB\uAFFC\uAFFD\uAFFE\uAFFF\uB002\uB003\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB005\uB006\uB007\uB008\uB009\uB00A\uB00B\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015\uB016\uB017\uB018\uB019\uB01A\uB01B\uB01E\uB01F\uB020\uB021\uB022\uB023\uB024\uB025\uB026\uB027\uB029\uB02A\uB02B\uB02C\uB02D\uB02E\uB02F\uB030\uB031\uB032\uB033\uB034\uB035\uB036\uB037\uB038\uB039\uB03A\uB03B\uB03C\uB03D\uB03E\uB03F\uB040\uB041\uB042\uB043\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E\uB05F\uB060\uB061\uB062\uB063\uB064\uB065\uB066\uB067\uB068\uB069\uB06A\uB06B\uB06C\uB06D\uB06E\uB06F\uB070\uB071\uB072\uB073\uB074\uB075\uB076\uB077\uB078\uB079\uB07A\uB07B\uB07E\uB07F\uB081\uB082\uB083\uB085\uB086\uB087\uB088\uB089\uB08A\uB08B\uB08E\uB090\uB092\uB093\uB094\uB095\uB096\uB097\uB09B\uB09D\uB09E\uB0A3\uB0A4\uFFFD".split("");
    for(j = 0; j != D[133].length; ++j)if (D[133][j].charCodeAt(0) !== 0xFFFD) {
        e[D[133][j]] = 34048 + j;
        d[34048 + j] = D[133][j];
    }
    D[134] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD\uB0BE\uB0BF\uB0C0\uB0C1\uB0C2\uB0C3\uB0C6\uB0CA\uB0CB\uB0CC\uB0CD\uB0CE\uB0CF\uB0D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9\uB0DA\uB0DB\uB0DC\uB0DD\uB0DE\uB0DF\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6\uB0E7\uB0E8\uB0E9\uB0EA\uB0EB\uB0EC\uB0ED\uB0EE\uB0EF\uB0F0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB0F1\uB0F2\uB0F3\uB0F4\uB0F5\uB0F6\uB0F7\uB0F8\uB0F9\uB0FA\uB0FB\uB0FC\uB0FD\uB0FE\uB0FF\uB100\uB101\uB102\uB103\uB104\uB105\uB106\uB107\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E\uB11F\uB120\uB121\uB122\uB126\uB127\uB129\uB12A\uB12B\uB12D\uB12E\uB12F\uB130\uB131\uB132\uB133\uB136\uB13A\uB13B\uB13C\uB13D\uB13E\uB13F\uB142\uB143\uB145\uB146\uB147\uB149\uB14A\uB14B\uB14C\uB14D\uB14E\uB14F\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161\uB162\uB163\uB164\uB165\uB166\uB167\uB168\uB169\uB16A\uB16B\uB16C\uB16D\uB16E\uB16F\uB170\uB171\uB172\uB173\uB174\uB175\uB176\uB177\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183\uB184\uB185\uB186\uB187\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D\uFFFD".split("");
    for(j = 0; j != D[134].length; ++j)if (D[134][j].charCodeAt(0) !== 0xFFFD) {
        e[D[134][j]] = 34304 + j;
        d[34304 + j] = D[134][j];
    }
    D[135] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB19E\uB19F\uB1A0\uB1A1\uB1A2\uB1A3\uB1A4\uB1A5\uB1A6\uB1A7\uB1A9\uB1AA\uB1AB\uB1AC\uB1AD\uB1AE\uB1AF\uB1B0\uB1B1\uB1B2\uB1B3\uB1B4\uB1B5\uB1B6\uB1B7\uB1B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB1B9\uB1BA\uB1BB\uB1BC\uB1BD\uB1BE\uB1BF\uB1C0\uB1C1\uB1C2\uB1C3\uB1C4\uB1C5\uB1C6\uB1C7\uB1C8\uB1C9\uB1CA\uB1CB\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB1D6\uB1D7\uB1D8\uB1D9\uB1DA\uB1DB\uB1DE\uB1E0\uB1E1\uB1E2\uB1E3\uB1E4\uB1E5\uB1E6\uB1E7\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1\uB1F2\uB1F3\uB1F4\uB1F5\uB1F6\uB1F7\uB1F8\uB1FA\uB1FC\uB1FE\uB1FF\uB200\uB201\uB202\uB203\uB206\uB207\uB209\uB20A\uB20D\uB20E\uB20F\uB210\uB211\uB212\uB213\uB216\uB218\uB21A\uB21B\uB21C\uB21D\uB21E\uB21F\uB221\uB222\uB223\uB224\uB225\uB226\uB227\uB228\uB229\uB22A\uB22B\uB22C\uB22D\uB22E\uB22F\uB230\uB231\uB232\uB233\uB235\uB236\uB237\uB238\uB239\uB23A\uB23B\uB23D\uB23E\uB23F\uB240\uB241\uB242\uB243\uB244\uB245\uB246\uB247\uB248\uB249\uB24A\uB24B\uB24C\uB24D\uB24E\uB24F\uB250\uB251\uB252\uB253\uB254\uB255\uB256\uB257\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261\uB262\uB263\uB264\uB265\uB266\uB267\uB26A\uB26B\uB26C\uB26D\uB26E\uFFFD".split("");
    for(j = 0; j != D[135].length; ++j)if (D[135][j].charCodeAt(0) !== 0xFFFD) {
        e[D[135][j]] = 34560 + j;
        d[34560 + j] = D[135][j];
    }
    D[136] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB26F\uB270\uB271\uB272\uB273\uB276\uB277\uB278\uB279\uB27A\uB27B\uB27D\uB27E\uB27F\uB280\uB281\uB282\uB283\uB286\uB287\uB288\uB28A\uB28B\uB28C\uB28D\uB28E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B\uB29C\uB29D\uB29E\uB29F\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB2B8\uB2B9\uB2BA\uB2BB\uB2BC\uB2BD\uB2BE\uB2BF\uB2C0\uB2C1\uB2C2\uB2C3\uB2C4\uB2C5\uB2C6\uB2C7\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3\uB2D4\uB2D5\uB2D6\uB2D7\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309\uB30A\uB30B\uB30C\uB30D\uB30E\uB30F\uB312\uB316\uB317\uB318\uB319\uB31A\uB31B\uB31D\uB31E\uB31F\uB320\uB321\uB322\uB323\uB324\uB325\uB326\uB327\uB328\uB329\uB32A\uB32B\uB32C\uB32D\uB32E\uB32F\uB330\uB331\uB332\uB333\uB334\uB335\uB336\uB337\uB338\uB339\uB33A\uB33B\uB33C\uB33D\uB33E\uB33F\uB340\uB341\uB342\uB343\uB344\uB345\uB346\uB347\uB348\uB349\uB34A\uB34B\uB34C\uB34D\uB34E\uB34F\uB350\uB351\uB352\uB353\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363\uFFFD".split("");
    for(j = 0; j != D[136].length; ++j)if (D[136][j].charCodeAt(0) !== 0xFFFD) {
        e[D[136][j]] = 34816 + j;
        d[34816 + j] = D[136][j];
    }
    D[137] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379\uB37A\uB37B\uB37C\uB37D\uB37E\uB37F\uB382\uB386\uB387\uB388\uB389\uB38A\uB38B\uB38D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB38E\uB38F\uB391\uB392\uB393\uB395\uB396\uB397\uB398\uB399\uB39A\uB39B\uB39C\uB39D\uB39E\uB39F\uB3A2\uB3A3\uB3A4\uB3A5\uB3A6\uB3A7\uB3A9\uB3AA\uB3AB\uB3AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB3AE\uB3AF\uB3B0\uB3B1\uB3B2\uB3B3\uB3B4\uB3B5\uB3B6\uB3B7\uB3B8\uB3B9\uB3BA\uB3BB\uB3BC\uB3BD\uB3BE\uB3BF\uB3C0\uB3C1\uB3C2\uB3C3\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9\uB3EA\uB3EB\uB3EC\uB3ED\uB3EE\uB3EF\uB3F0\uB3F1\uB3F2\uB3F3\uB3F4\uB3F5\uB3F6\uB3F7\uB3F8\uB3F9\uB3FA\uB3FB\uB3FD\uB3FE\uB3FF\uB400\uB401\uB402\uB403\uB404\uB405\uB406\uB407\uB408\uB409\uB40A\uB40B\uB40C\uB40D\uB40E\uB40F\uB411\uB412\uB413\uB414\uB415\uB416\uB417\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421\uB422\uB423\uB424\uB425\uB426\uB427\uB42A\uB42C\uB42D\uB42E\uB42F\uB430\uB431\uB432\uB433\uB435\uB436\uB437\uB438\uB439\uB43A\uB43B\uB43C\uB43D\uB43E\uB43F\uB440\uB441\uB442\uB443\uB444\uFFFD".split("");
    for(j = 0; j != D[137].length; ++j)if (D[137][j].charCodeAt(0) !== 0xFFFD) {
        e[D[137][j]] = 35072 + j;
        d[35072 + j] = D[137][j];
    }
    D[138] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB445\uB446\uB447\uB448\uB449\uB44A\uB44B\uB44C\uB44D\uB44E\uB44F\uB452\uB453\uB455\uB456\uB457\uB459\uB45A\uB45B\uB45C\uB45D\uB45E\uB45F\uB462\uB464\uB466\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB467\uB468\uB469\uB46A\uB46B\uB46D\uB46E\uB46F\uB470\uB471\uB472\uB473\uB474\uB475\uB476\uB477\uB478\uB479\uB47A\uB47B\uB47C\uB47D\uB47E\uB47F\uB481\uB482\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB483\uB484\uB485\uB486\uB487\uB489\uB48A\uB48B\uB48C\uB48D\uB48E\uB48F\uB490\uB491\uB492\uB493\uB494\uB495\uB496\uB497\uB498\uB499\uB49A\uB49B\uB49C\uB49E\uB49F\uB4A0\uB4A1\uB4A2\uB4A3\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD\uB4AE\uB4AF\uB4B0\uB4B1\uB4B2\uB4B3\uB4B4\uB4B6\uB4B8\uB4BA\uB4BB\uB4BC\uB4BD\uB4BE\uB4BF\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9\uB4CA\uB4CB\uB4CC\uB4CD\uB4CE\uB4CF\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6\uB4D7\uB4D8\uB4D9\uB4DA\uB4DB\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7\uB4E8\uB4E9\uB4EA\uB4EB\uB4EE\uB4F0\uB4F2\uB4F3\uB4F4\uB4F5\uB4F6\uB4F7\uB4F9\uB4FA\uB4FB\uB4FC\uB4FD\uB4FE\uB4FF\uB500\uB501\uB502\uB503\uB504\uB505\uB506\uB507\uB508\uB509\uB50A\uB50B\uB50C\uB50D\uB50E\uB50F\uB510\uB511\uB512\uB513\uB516\uB517\uB519\uB51A\uB51D\uFFFD".split("");
    for(j = 0; j != D[138].length; ++j)if (D[138][j].charCodeAt(0) !== 0xFFFD) {
        e[D[138][j]] = 35328 + j;
        d[35328 + j] = D[138][j];
    }
    D[139] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB51E\uB51F\uB520\uB521\uB522\uB523\uB526\uB52B\uB52C\uB52D\uB52E\uB52F\uB532\uB533\uB535\uB536\uB537\uB539\uB53A\uB53B\uB53C\uB53D\uB53E\uB53F\uB542\uB546\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555\uB556\uB557\uB558\uB559\uB55A\uB55B\uB55E\uB562\uB563\uB564\uB565\uB566\uB567\uB568\uB569\uB56A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB56B\uB56C\uB56D\uB56E\uB56F\uB570\uB571\uB572\uB573\uB574\uB575\uB576\uB577\uB578\uB579\uB57A\uB57B\uB57C\uB57D\uB57E\uB57F\uB580\uB581\uB582\uB583\uB584\uB585\uB586\uB587\uB588\uB589\uB58A\uB58B\uB58C\uB58D\uB58E\uB58F\uB590\uB591\uB592\uB593\uB594\uB595\uB596\uB597\uB598\uB599\uB59A\uB59B\uB59C\uB59D\uB59E\uB59F\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6\uB5B7\uB5B8\uB5B9\uB5BA\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5\uB5C6\uB5C7\uB5C8\uB5C9\uB5CA\uB5CB\uB5CE\uB5D2\uB5D3\uB5D4\uB5D5\uB5D6\uB5D7\uB5D9\uB5DA\uB5DB\uB5DC\uB5DD\uB5DE\uB5DF\uB5E0\uB5E1\uB5E2\uB5E3\uB5E4\uB5E5\uB5E6\uB5E7\uB5E8\uB5E9\uB5EA\uB5EB\uB5ED\uB5EE\uB5EF\uB5F0\uB5F1\uB5F2\uB5F3\uB5F4\uB5F5\uB5F6\uB5F7\uB5F8\uB5F9\uB5FA\uB5FB\uB5FC\uB5FD\uB5FE\uB5FF\uFFFD".split("");
    for(j = 0; j != D[139].length; ++j)if (D[139][j].charCodeAt(0) !== 0xFFFD) {
        e[D[139][j]] = 35584 + j;
        d[35584 + j] = D[139][j];
    }
    D[140] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB600\uB601\uB602\uB603\uB604\uB605\uB606\uB607\uB608\uB609\uB60A\uB60B\uB60C\uB60D\uB60E\uB60F\uB612\uB613\uB615\uB616\uB617\uB619\uB61A\uB61B\uB61C\uB61D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB61E\uB61F\uB620\uB621\uB622\uB623\uB624\uB626\uB627\uB628\uB629\uB62A\uB62B\uB62D\uB62E\uB62F\uB630\uB631\uB632\uB633\uB635\uB636\uB637\uB638\uB639\uB63A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB63B\uB63C\uB63D\uB63E\uB63F\uB640\uB641\uB642\uB643\uB644\uB645\uB646\uB647\uB649\uB64A\uB64B\uB64C\uB64D\uB64E\uB64F\uB650\uB651\uB652\uB653\uB654\uB655\uB656\uB657\uB658\uB659\uB65A\uB65B\uB65C\uB65D\uB65E\uB65F\uB660\uB661\uB662\uB663\uB665\uB666\uB667\uB669\uB66A\uB66B\uB66C\uB66D\uB66E\uB66F\uB670\uB671\uB672\uB673\uB674\uB675\uB676\uB677\uB678\uB679\uB67A\uB67B\uB67C\uB67D\uB67E\uB67F\uB680\uB681\uB682\uB683\uB684\uB685\uB686\uB687\uB688\uB689\uB68A\uB68B\uB68C\uB68D\uB68E\uB68F\uB690\uB691\uB692\uB693\uB694\uB695\uB696\uB697\uB698\uB699\uB69A\uB69B\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5\uB6A6\uB6A7\uB6A8\uB6A9\uB6AA\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2\uB6B3\uB6B4\uB6B5\uB6B6\uB6B7\uB6B8\uB6B9\uB6BA\uB6BB\uB6BC\uB6BD\uB6BE\uB6BF\uB6C0\uB6C1\uB6C2\uFFFD".split("");
    for(j = 0; j != D[140].length; ++j)if (D[140][j].charCodeAt(0) !== 0xFFFD) {
        e[D[140][j]] = 35840 + j;
        d[35840 + j] = D[140][j];
    }
    D[141] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6C3\uB6C4\uB6C5\uB6C6\uB6C7\uB6C8\uB6C9\uB6CA\uB6CB\uB6CC\uB6CD\uB6CE\uB6CF\uB6D0\uB6D1\uB6D2\uB6D3\uB6D5\uB6D6\uB6D7\uB6D8\uB6D9\uB6DA\uB6DB\uB6DC\uB6DD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6DE\uB6DF\uB6E0\uB6E1\uB6E2\uB6E3\uB6E4\uB6E5\uB6E6\uB6E7\uB6E8\uB6E9\uB6EA\uB6EB\uB6EC\uB6ED\uB6EE\uB6EF\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB6FB\uB6FC\uB6FD\uB6FE\uB6FF\uB702\uB703\uB704\uB706\uB707\uB708\uB709\uB70A\uB70B\uB70C\uB70D\uB70E\uB70F\uB710\uB711\uB712\uB713\uB714\uB715\uB716\uB717\uB718\uB719\uB71A\uB71B\uB71C\uB71D\uB71E\uB71F\uB720\uB721\uB722\uB723\uB724\uB725\uB726\uB727\uB72A\uB72B\uB72D\uB72E\uB731\uB732\uB733\uB734\uB735\uB736\uB737\uB73A\uB73C\uB73D\uB73E\uB73F\uB740\uB741\uB742\uB743\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D\uB74E\uB74F\uB750\uB751\uB752\uB753\uB756\uB757\uB758\uB759\uB75A\uB75B\uB75C\uB75D\uB75E\uB75F\uB761\uB762\uB763\uB765\uB766\uB767\uB769\uB76A\uB76B\uB76C\uB76D\uB76E\uB76F\uB772\uB774\uB776\uB777\uB778\uB779\uB77A\uB77B\uB77E\uB77F\uB781\uB782\uB783\uB785\uB786\uB787\uB788\uB789\uB78A\uB78B\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E\uFFFD".split("");
    for(j = 0; j != D[141].length; ++j)if (D[141][j].charCodeAt(0) !== 0xFFFD) {
        e[D[141][j]] = 36096 + j;
        d[36096 + j] = D[141][j];
    }
    D[142] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB79F\uB7A1\uB7A2\uB7A3\uB7A4\uB7A5\uB7A6\uB7A7\uB7AA\uB7AE\uB7AF\uB7B0\uB7B1\uB7B2\uB7B3\uB7B6\uB7B7\uB7B9\uB7BA\uB7BB\uB7BC\uB7BD\uB7BE\uB7BF\uB7C0\uB7C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB7C2\uB7C3\uB7C4\uB7C5\uB7C6\uB7C8\uB7CA\uB7CB\uB7CC\uB7CD\uB7CE\uB7CF\uB7D0\uB7D1\uB7D2\uB7D3\uB7D4\uB7D5\uB7D6\uB7D7\uB7D8\uB7D9\uB7DA\uB7DB\uB7DC\uB7DD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB7DE\uB7DF\uB7E0\uB7E1\uB7E2\uB7E3\uB7E4\uB7E5\uB7E6\uB7E7\uB7E8\uB7E9\uB7EA\uB7EB\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5\uB7F6\uB7F7\uB7F8\uB7F9\uB7FA\uB7FB\uB7FE\uB802\uB803\uB804\uB805\uB806\uB80A\uB80B\uB80D\uB80E\uB80F\uB811\uB812\uB813\uB814\uB815\uB816\uB817\uB81A\uB81C\uB81E\uB81F\uB820\uB821\uB822\uB823\uB826\uB827\uB829\uB82A\uB82B\uB82D\uB82E\uB82F\uB830\uB831\uB832\uB833\uB836\uB83A\uB83B\uB83C\uB83D\uB83E\uB83F\uB841\uB842\uB843\uB845\uB846\uB847\uB848\uB849\uB84A\uB84B\uB84C\uB84D\uB84E\uB84F\uB850\uB852\uB854\uB855\uB856\uB857\uB858\uB859\uB85A\uB85B\uB85E\uB85F\uB861\uB862\uB863\uB865\uB866\uB867\uB868\uB869\uB86A\uB86B\uB86E\uB870\uB872\uB873\uB874\uB875\uB876\uB877\uB879\uB87A\uB87B\uB87D\uB87E\uB87F\uB880\uB881\uB882\uB883\uB884\uFFFD".split("");
    for(j = 0; j != D[142].length; ++j)if (D[142][j].charCodeAt(0) !== 0xFFFD) {
        e[D[142][j]] = 36352 + j;
        d[36352 + j] = D[142][j];
    }
    D[143] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB885\uB886\uB887\uB888\uB889\uB88A\uB88B\uB88C\uB88E\uB88F\uB890\uB891\uB892\uB893\uB894\uB895\uB896\uB897\uB898\uB899\uB89A\uB89B\uB89C\uB89D\uB89E\uB89F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB8A0\uB8A1\uB8A2\uB8A3\uB8A4\uB8A5\uB8A6\uB8A7\uB8A9\uB8AA\uB8AB\uB8AC\uB8AD\uB8AE\uB8AF\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9\uB8BA\uB8BB\uB8BC\uB8BD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6\uB8C7\uB8C8\uB8C9\uB8CA\uB8CB\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5\uB8D6\uB8D7\uB8D8\uB8D9\uB8DA\uB8DB\uB8DC\uB8DE\uB8E0\uB8E2\uB8E3\uB8E4\uB8E5\uB8E6\uB8E7\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1\uB8F2\uB8F3\uB8F4\uB8F5\uB8F6\uB8F7\uB8FA\uB8FC\uB8FE\uB8FF\uB900\uB901\uB902\uB903\uB905\uB906\uB907\uB908\uB909\uB90A\uB90B\uB90C\uB90D\uB90E\uB90F\uB910\uB911\uB912\uB913\uB914\uB915\uB916\uB917\uB919\uB91A\uB91B\uB91C\uB91D\uB91E\uB91F\uB921\uB922\uB923\uB924\uB925\uB926\uB927\uB928\uB929\uB92A\uB92B\uB92C\uB92D\uB92E\uB92F\uB930\uB931\uB932\uB933\uB934\uB935\uB936\uB937\uB938\uB939\uB93A\uB93B\uB93E\uB93F\uB941\uB942\uB943\uB945\uB946\uB947\uB948\uB949\uB94A\uB94B\uB94D\uB94E\uB950\uB952\uB953\uB954\uB955\uB956\uB957\uFFFD".split("");
    for(j = 0; j != D[143].length; ++j)if (D[143][j].charCodeAt(0) !== 0xFFFD) {
        e[D[143][j]] = 36608 + j;
        d[36608 + j] = D[143][j];
    }
    D[144] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB95A\uB95B\uB95D\uB95E\uB95F\uB961\uB962\uB963\uB964\uB965\uB966\uB967\uB96A\uB96C\uB96E\uB96F\uB970\uB971\uB972\uB973\uB976\uB977\uB979\uB97A\uB97B\uB97D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB97E\uB97F\uB980\uB981\uB982\uB983\uB986\uB988\uB98B\uB98C\uB98F\uB990\uB991\uB992\uB993\uB994\uB995\uB996\uB997\uB998\uB999\uB99A\uB99B\uB99C\uB99D\uB99E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uB99F\uB9A0\uB9A1\uB9A2\uB9A3\uB9A4\uB9A5\uB9A6\uB9A7\uB9A8\uB9A9\uB9AA\uB9AB\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5\uB9B6\uB9B7\uB9B8\uB9B9\uB9BA\uB9BB\uB9BE\uB9C0\uB9C2\uB9C3\uB9C4\uB9C5\uB9C6\uB9C7\uB9CA\uB9CB\uB9CD\uB9D3\uB9D4\uB9D5\uB9D6\uB9D7\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED\uB9EE\uB9EF\uB9F0\uB9F1\uB9F2\uB9F3\uB9F6\uB9FB\uB9FC\uB9FD\uB9FE\uB9FF\uBA02\uBA03\uBA04\uBA05\uBA06\uBA07\uBA09\uBA0A\uBA0B\uBA0C\uBA0D\uBA0E\uBA0F\uBA10\uBA11\uBA12\uBA13\uBA14\uBA16\uBA17\uBA18\uBA19\uBA1A\uBA1B\uBA1C\uBA1D\uBA1E\uBA1F\uBA20\uBA21\uBA22\uBA23\uBA24\uBA25\uBA26\uBA27\uBA28\uBA29\uBA2A\uBA2B\uBA2C\uBA2D\uBA2E\uBA2F\uBA30\uBA31\uBA32\uBA33\uBA34\uBA35\uBA36\uBA37\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46\uFFFD".split("");
    for(j = 0; j != D[144].length; ++j)if (D[144][j].charCodeAt(0) !== 0xFFFD) {
        e[D[144][j]] = 36864 + j;
        d[36864 + j] = D[144][j];
    }
    D[145] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D\uBA5E\uBA5F\uBA60\uBA61\uBA62\uBA63\uBA66\uBA6A\uBA6B\uBA6C\uBA6D\uBA6E\uBA6F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79\uBA7A\uBA7B\uBA7C\uBA7D\uBA7E\uBA7F\uBA80\uBA81\uBA82\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D\uBA8E\uBA8F\uBA90\uBA91\uBA92\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBA93\uBA94\uBA95\uBA96\uBA97\uBA98\uBA99\uBA9A\uBA9B\uBA9C\uBA9D\uBA9E\uBA9F\uBAA0\uBAA1\uBAA2\uBAA3\uBAA4\uBAA5\uBAA6\uBAA7\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3\uBAB4\uBAB5\uBAB6\uBAB7\uBABA\uBABC\uBABE\uBABF\uBAC0\uBAC1\uBAC2\uBAC3\uBAC5\uBAC6\uBAC7\uBAC9\uBACA\uBACB\uBACC\uBACD\uBACE\uBACF\uBAD0\uBAD1\uBAD2\uBAD3\uBAD4\uBAD5\uBAD6\uBAD7\uBADA\uBADB\uBADC\uBADD\uBADE\uBADF\uBAE0\uBAE1\uBAE2\uBAE3\uBAE4\uBAE5\uBAE6\uBAE7\uBAE8\uBAE9\uBAEA\uBAEB\uBAEC\uBAED\uBAEE\uBAEF\uBAF0\uBAF1\uBAF2\uBAF3\uBAF4\uBAF5\uBAF6\uBAF7\uBAF8\uBAF9\uBAFA\uBAFB\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05\uBB06\uBB07\uBB08\uBB09\uBB0A\uBB0B\uBB0C\uBB0E\uBB10\uBB12\uBB13\uBB14\uBB15\uBB16\uBB17\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21\uBB22\uBB23\uBB24\uBB25\uBB26\uBB27\uFFFD".split("");
    for(j = 0; j != D[145].length; ++j)if (D[145][j].charCodeAt(0) !== 0xFFFD) {
        e[D[145][j]] = 37120 + j;
        d[37120 + j] = D[145][j];
    }
    D[146] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB28\uBB2A\uBB2C\uBB2D\uBB2E\uBB2F\uBB30\uBB31\uBB32\uBB33\uBB37\uBB39\uBB3A\uBB3F\uBB40\uBB41\uBB42\uBB43\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB53\uBB55\uBB56\uBB57\uBB59\uBB5A\uBB5B\uBB5C\uBB5D\uBB5E\uBB5F\uBB60\uBB62\uBB64\uBB65\uBB66\uBB67\uBB68\uBB69\uBB6A\uBB6B\uBB6D\uBB6E\uBB6F\uBB70\uBB71\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBB72\uBB73\uBB74\uBB75\uBB76\uBB77\uBB78\uBB79\uBB7A\uBB7B\uBB7C\uBB7D\uBB7E\uBB7F\uBB80\uBB81\uBB82\uBB83\uBB84\uBB85\uBB86\uBB87\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91\uBB92\uBB93\uBB94\uBB95\uBB96\uBB97\uBB98\uBB99\uBB9A\uBB9B\uBB9C\uBB9D\uBB9E\uBB9F\uBBA0\uBBA1\uBBA2\uBBA3\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD\uBBAE\uBBAF\uBBB0\uBBB1\uBBB2\uBBB3\uBBB5\uBBB6\uBBB8\uBBB9\uBBBA\uBBBB\uBBBC\uBBBD\uBBBE\uBBBF\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9\uBBCA\uBBCB\uBBCC\uBBCD\uBBCE\uBBCF\uBBD1\uBBD2\uBBD4\uBBD5\uBBD6\uBBD7\uBBD8\uBBD9\uBBDA\uBBDB\uBBDC\uBBDD\uBBDE\uBBDF\uBBE0\uBBE1\uBBE2\uBBE3\uBBE4\uBBE5\uBBE6\uBBE7\uBBE8\uBBE9\uBBEA\uBBEB\uBBEC\uBBED\uBBEE\uBBEF\uBBF0\uBBF1\uBBF2\uBBF3\uBBF4\uBBF5\uBBF6\uBBF7\uBBFA\uBBFB\uBBFD\uBBFE\uBC01\uFFFD".split("");
    for(j = 0; j != D[146].length; ++j)if (D[146][j].charCodeAt(0) !== 0xFFFD) {
        e[D[146][j]] = 37376 + j;
        d[37376 + j] = D[146][j];
    }
    D[147] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC03\uBC04\uBC05\uBC06\uBC07\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC36\uBC37\uBC39\uBC3A\uBC3B\uBC3C\uBC3D\uBC3E\uBC3F\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51\uBC52\uBC53\uBC54\uBC55\uBC56\uBC57\uBC58\uBC59\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBC5A\uBC5B\uBC5C\uBC5E\uBC5F\uBC60\uBC61\uBC62\uBC63\uBC64\uBC65\uBC66\uBC67\uBC68\uBC69\uBC6A\uBC6B\uBC6C\uBC6D\uBC6E\uBC6F\uBC70\uBC71\uBC72\uBC73\uBC74\uBC75\uBC76\uBC77\uBC78\uBC79\uBC7A\uBC7B\uBC7C\uBC7D\uBC7E\uBC7F\uBC80\uBC81\uBC82\uBC83\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F\uBC90\uBC91\uBC92\uBC93\uBC96\uBC98\uBC9B\uBC9C\uBC9D\uBC9E\uBC9F\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9\uBCAA\uBCAB\uBCAC\uBCAD\uBCAE\uBCAF\uBCB2\uBCB6\uBCB7\uBCB8\uBCB9\uBCBA\uBCBB\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5\uBCC6\uBCC7\uBCC8\uBCC9\uBCCA\uBCCB\uBCCC\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD\uBCDE\uBCDF\uBCE0\uBCE1\uBCE2\uBCE3\uBCE4\uBCE5\uBCE6\uBCE7\uBCE8\uBCE9\uBCEA\uBCEB\uBCEC\uBCED\uBCEE\uBCEF\uBCF0\uBCF1\uBCF2\uBCF3\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD\uFFFD".split("");
    for(j = 0; j != D[147].length; ++j)if (D[147][j].charCodeAt(0) !== 0xFFFD) {
        e[D[147][j]] = 37632 + j;
        d[37632 + j] = D[147][j];
    }
    D[148] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBCFE\uBCFF\uBD00\uBD01\uBD02\uBD03\uBD06\uBD08\uBD0A\uBD0B\uBD0C\uBD0D\uBD0E\uBD0F\uBD11\uBD12\uBD13\uBD15\uBD16\uBD17\uBD18\uBD19\uBD1A\uBD1B\uBD1C\uBD1D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBD1E\uBD1F\uBD20\uBD21\uBD22\uBD23\uBD25\uBD26\uBD27\uBD28\uBD29\uBD2A\uBD2B\uBD2D\uBD2E\uBD2F\uBD30\uBD31\uBD32\uBD33\uBD34\uBD35\uBD36\uBD37\uBD38\uBD39\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBD3A\uBD3B\uBD3C\uBD3D\uBD3E\uBD3F\uBD41\uBD42\uBD43\uBD44\uBD45\uBD46\uBD47\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51\uBD52\uBD53\uBD54\uBD55\uBD56\uBD57\uBD5A\uBD5B\uBD5C\uBD5D\uBD5E\uBD5F\uBD60\uBD61\uBD62\uBD63\uBD65\uBD66\uBD67\uBD69\uBD6A\uBD6B\uBD6C\uBD6D\uBD6E\uBD6F\uBD70\uBD71\uBD72\uBD73\uBD74\uBD75\uBD76\uBD77\uBD78\uBD79\uBD7A\uBD7B\uBD7C\uBD7D\uBD7E\uBD7F\uBD82\uBD83\uBD85\uBD86\uBD8B\uBD8C\uBD8D\uBD8E\uBD8F\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D\uBD9E\uBD9F\uBDA0\uBDA1\uBDA2\uBDA3\uBDA5\uBDA6\uBDA7\uBDA8\uBDA9\uBDAA\uBDAB\uBDAC\uBDAD\uBDAE\uBDAF\uBDB1\uBDB2\uBDB3\uBDB4\uBDB5\uBDB6\uBDB7\uBDB9\uBDBA\uBDBB\uBDBC\uBDBD\uBDBE\uBDBF\uBDC0\uBDC1\uBDC2\uBDC3\uBDC4\uBDC5\uBDC6\uBDC7\uBDC8\uBDC9\uBDCA\uBDCB\uBDCC\uBDCD\uBDCE\uBDCF\uBDD0\uBDD1\uFFFD".split("");
    for(j = 0; j != D[148].length; ++j)if (D[148][j].charCodeAt(0) !== 0xFFFD) {
        e[D[148][j]] = 37888 + j;
        d[37888 + j] = D[148][j];
    }
    D[149] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD\uBDDE\uBDDF\uBDE0\uBDE1\uBDE2\uBDE3\uBDE4\uBDE5\uBDE6\uBDE7\uBDE8\uBDEA\uBDEB\uBDEC\uBDED\uBDEE\uBDEF\uBDF1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9\uBDFA\uBDFB\uBDFC\uBDFD\uBDFE\uBDFF\uBE01\uBE02\uBE04\uBE06\uBE07\uBE08\uBE09\uBE0A\uBE0B\uBE0E\uBE0F\uBE11\uBE12\uBE13\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBE15\uBE16\uBE17\uBE18\uBE19\uBE1A\uBE1B\uBE1E\uBE20\uBE21\uBE22\uBE23\uBE24\uBE25\uBE26\uBE27\uBE28\uBE29\uBE2A\uBE2B\uBE2C\uBE2D\uBE2E\uBE2F\uBE30\uBE31\uBE32\uBE33\uBE34\uBE35\uBE36\uBE37\uBE38\uBE39\uBE3A\uBE3B\uBE3C\uBE3D\uBE3E\uBE3F\uBE40\uBE41\uBE42\uBE43\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F\uBE50\uBE51\uBE52\uBE53\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B\uBE6C\uBE6D\uBE6E\uBE6F\uBE72\uBE76\uBE77\uBE78\uBE79\uBE7A\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85\uBE86\uBE87\uBE88\uBE89\uBE8A\uBE8B\uBE8E\uBE92\uBE93\uBE94\uBE95\uBE96\uBE97\uBE9A\uBE9B\uBE9C\uBE9D\uBE9E\uBE9F\uBEA0\uBEA1\uBEA2\uBEA3\uBEA4\uBEA5\uBEA6\uBEA7\uBEA9\uBEAA\uBEAB\uBEAC\uBEAD\uBEAE\uBEAF\uBEB0\uBEB1\uBEB2\uBEB3\uBEB4\uBEB5\uBEB6\uBEB7\uFFFD".split("");
    for(j = 0; j != D[149].length; ++j)if (D[149][j].charCodeAt(0) !== 0xFFFD) {
        e[D[149][j]] = 38144 + j;
        d[38144 + j] = D[149][j];
    }
    D[150] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBEB8\uBEB9\uBEBA\uBEBB\uBEBC\uBEBD\uBEBE\uBEBF\uBEC0\uBEC1\uBEC2\uBEC3\uBEC4\uBEC5\uBEC6\uBEC7\uBEC8\uBEC9\uBECA\uBECB\uBECC\uBECD\uBECE\uBECF\uBED2\uBED3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBED5\uBED6\uBED9\uBEDA\uBEDB\uBEDC\uBEDD\uBEDE\uBEDF\uBEE1\uBEE2\uBEE6\uBEE7\uBEE8\uBEE9\uBEEA\uBEEB\uBEED\uBEEE\uBEEF\uBEF0\uBEF1\uBEF2\uBEF3\uBEF4\uBEF5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBEF6\uBEF7\uBEF8\uBEF9\uBEFA\uBEFB\uBEFC\uBEFD\uBEFE\uBEFF\uBF00\uBF02\uBF03\uBF04\uBF05\uBF06\uBF07\uBF0A\uBF0B\uBF0C\uBF0D\uBF0E\uBF0F\uBF10\uBF11\uBF12\uBF13\uBF14\uBF15\uBF16\uBF17\uBF1A\uBF1E\uBF1F\uBF20\uBF21\uBF22\uBF23\uBF24\uBF25\uBF26\uBF27\uBF28\uBF29\uBF2A\uBF2B\uBF2C\uBF2D\uBF2E\uBF2F\uBF30\uBF31\uBF32\uBF33\uBF34\uBF35\uBF36\uBF37\uBF38\uBF39\uBF3A\uBF3B\uBF3C\uBF3D\uBF3E\uBF3F\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49\uBF4A\uBF4B\uBF4C\uBF4D\uBF4E\uBF4F\uBF52\uBF53\uBF54\uBF56\uBF57\uBF58\uBF59\uBF5A\uBF5B\uBF5C\uBF5D\uBF5E\uBF5F\uBF60\uBF61\uBF62\uBF63\uBF64\uBF65\uBF66\uBF67\uBF68\uBF69\uBF6A\uBF6B\uBF6C\uBF6D\uBF6E\uBF6F\uBF70\uBF71\uBF72\uBF73\uBF74\uBF75\uBF76\uBF77\uBF78\uBF79\uBF7A\uBF7B\uBF7C\uBF7D\uBF7E\uBF7F\uBF80\uBF81\uBF82\uFFFD".split("");
    for(j = 0; j != D[150].length; ++j)if (D[150][j].charCodeAt(0) !== 0xFFFD) {
        e[D[150][j]] = 38400 + j;
        d[38400 + j] = D[150][j];
    }
    D[151] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBF83\uBF84\uBF85\uBF86\uBF87\uBF88\uBF89\uBF8A\uBF8B\uBF8C\uBF8D\uBF8E\uBF8F\uBF90\uBF91\uBF92\uBF93\uBF95\uBF96\uBF97\uBF98\uBF99\uBF9A\uBF9B\uBF9C\uBF9D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBF9E\uBF9F\uBFA0\uBFA1\uBFA2\uBFA3\uBFA4\uBFA5\uBFA6\uBFA7\uBFA8\uBFA9\uBFAA\uBFAB\uBFAC\uBFAD\uBFAE\uBFAF\uBFB1\uBFB2\uBFB3\uBFB4\uBFB5\uBFB6\uBFB7\uBFB8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uBFB9\uBFBA\uBFBB\uBFBC\uBFBD\uBFBE\uBFBF\uBFC0\uBFC1\uBFC2\uBFC3\uBFC4\uBFC6\uBFC7\uBFC8\uBFC9\uBFCA\uBFCB\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5\uBFD6\uBFD7\uBFD8\uBFD9\uBFDA\uBFDB\uBFDD\uBFDE\uBFE0\uBFE2\uBFE3\uBFE4\uBFE5\uBFE6\uBFE7\uBFE8\uBFE9\uBFEA\uBFEB\uBFEC\uBFED\uBFEE\uBFEF\uBFF0\uBFF1\uBFF2\uBFF3\uBFF4\uBFF5\uBFF6\uBFF7\uBFF8\uBFF9\uBFFA\uBFFB\uBFFC\uBFFD\uBFFE\uBFFF\uC000\uC001\uC002\uC003\uC004\uC005\uC006\uC007\uC008\uC009\uC00A\uC00B\uC00C\uC00D\uC00E\uC00F\uC010\uC011\uC012\uC013\uC014\uC015\uC016\uC017\uC018\uC019\uC01A\uC01B\uC01C\uC01D\uC01E\uC01F\uC020\uC021\uC022\uC023\uC024\uC025\uC026\uC027\uC028\uC029\uC02A\uC02B\uC02C\uC02D\uC02E\uC02F\uC030\uC031\uC032\uC033\uC034\uC035\uC036\uC037\uC038\uC039\uC03A\uC03B\uC03D\uC03E\uC03F\uFFFD".split("");
    for(j = 0; j != D[151].length; ++j)if (D[151][j].charCodeAt(0) !== 0xFFFD) {
        e[D[151][j]] = 38656 + j;
        d[38656 + j] = D[151][j];
    }
    D[152] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC040\uC041\uC042\uC043\uC044\uC045\uC046\uC047\uC048\uC049\uC04A\uC04B\uC04C\uC04D\uC04E\uC04F\uC050\uC052\uC053\uC054\uC055\uC056\uC057\uC059\uC05A\uC05B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC05D\uC05E\uC05F\uC061\uC062\uC063\uC064\uC065\uC066\uC067\uC06A\uC06B\uC06C\uC06D\uC06E\uC06F\uC070\uC071\uC072\uC073\uC074\uC075\uC076\uC077\uC078\uC079\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC07A\uC07B\uC07C\uC07D\uC07E\uC07F\uC080\uC081\uC082\uC083\uC084\uC085\uC086\uC087\uC088\uC089\uC08A\uC08B\uC08C\uC08D\uC08E\uC08F\uC092\uC093\uC095\uC096\uC097\uC099\uC09A\uC09B\uC09C\uC09D\uC09E\uC09F\uC0A2\uC0A4\uC0A6\uC0A7\uC0A8\uC0A9\uC0AA\uC0AB\uC0AE\uC0B1\uC0B2\uC0B7\uC0B8\uC0B9\uC0BA\uC0BB\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1\uC0D2\uC0D3\uC0D4\uC0D5\uC0D6\uC0D7\uC0DA\uC0DE\uC0DF\uC0E0\uC0E1\uC0E2\uC0E3\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED\uC0EE\uC0EF\uC0F0\uC0F1\uC0F2\uC0F3\uC0F6\uC0F8\uC0FA\uC0FB\uC0FC\uC0FD\uC0FE\uC0FF\uC101\uC102\uC103\uC105\uC106\uC107\uC109\uC10A\uC10B\uC10C\uC10D\uC10E\uC10F\uC111\uC112\uC113\uC114\uC116\uC117\uC118\uC119\uC11A\uC11B\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E\uFFFD".split("");
    for(j = 0; j != D[152].length; ++j)if (D[152][j].charCodeAt(0) !== 0xFFFD) {
        e[D[152][j]] = 38912 + j;
        d[38912 + j] = D[152][j];
    }
    D[153] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141\uC142\uC143\uC144\uC145\uC146\uC147\uC14A\uC14E\uC14F\uC150\uC151\uC152\uC153\uC156\uC157\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC159\uC15A\uC15B\uC15D\uC15E\uC15F\uC160\uC161\uC162\uC163\uC166\uC16A\uC16B\uC16C\uC16D\uC16E\uC16F\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC17C\uC17D\uC17E\uC17F\uC180\uC181\uC182\uC183\uC184\uC186\uC187\uC188\uC189\uC18A\uC18B\uC18F\uC191\uC192\uC193\uC195\uC197\uC198\uC199\uC19A\uC19B\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1\uC1B2\uC1B3\uC1B4\uC1B5\uC1B6\uC1B7\uC1B8\uC1B9\uC1BA\uC1BB\uC1BC\uC1BE\uC1BF\uC1C0\uC1C1\uC1C2\uC1C3\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD\uC1CE\uC1CF\uC1D0\uC1D1\uC1D2\uC1D3\uC1D5\uC1D6\uC1D9\uC1DA\uC1DB\uC1DC\uC1DD\uC1DE\uC1DF\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9\uC1EA\uC1EB\uC1EC\uC1ED\uC1EE\uC1EF\uC1F2\uC1F4\uC1F5\uC1F6\uC1F7\uC1F8\uC1F9\uC1FA\uC1FB\uC1FE\uC1FF\uC201\uC202\uC203\uC205\uC206\uC207\uC208\uC209\uC20A\uC20B\uC20E\uC210\uC212\uC213\uC214\uC215\uC216\uC217\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223\uFFFD".split("");
    for(j = 0; j != D[153].length; ++j)if (D[153][j].charCodeAt(0) !== 0xFFFD) {
        e[D[153][j]] = 39168 + j;
        d[39168 + j] = D[153][j];
    }
    D[154] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235\uC236\uC237\uC238\uC239\uC23A\uC23B\uC23C\uC23D\uC23E\uC23F\uC240\uC241\uC242\uC243\uC244\uC245\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC246\uC247\uC249\uC24A\uC24B\uC24C\uC24D\uC24E\uC24F\uC252\uC253\uC255\uC256\uC257\uC259\uC25A\uC25B\uC25C\uC25D\uC25E\uC25F\uC261\uC262\uC263\uC264\uC266\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC267\uC268\uC269\uC26A\uC26B\uC26E\uC26F\uC271\uC272\uC273\uC275\uC276\uC277\uC278\uC279\uC27A\uC27B\uC27E\uC280\uC282\uC283\uC284\uC285\uC286\uC287\uC28A\uC28B\uC28C\uC28D\uC28E\uC28F\uC291\uC292\uC293\uC294\uC295\uC296\uC297\uC299\uC29A\uC29C\uC29E\uC29F\uC2A0\uC2A1\uC2A2\uC2A3\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE\uC2AF\uC2B0\uC2B1\uC2B2\uC2B3\uC2B6\uC2B8\uC2BA\uC2BB\uC2BC\uC2BD\uC2BE\uC2BF\uC2C0\uC2C1\uC2C2\uC2C3\uC2C4\uC2C5\uC2C6\uC2C7\uC2C8\uC2C9\uC2CA\uC2CB\uC2CC\uC2CD\uC2CE\uC2CF\uC2D0\uC2D1\uC2D2\uC2D3\uC2D4\uC2D5\uC2D6\uC2D7\uC2D8\uC2D9\uC2DA\uC2DB\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5\uC2E6\uC2E7\uC2E8\uC2E9\uC2EA\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301\uC302\uC303\uC304\uC305\uC306\uC307\uC30A\uC30B\uC30E\uC30F\uFFFD".split("");
    for(j = 0; j != D[154].length; ++j)if (D[154][j].charCodeAt(0) !== 0xFFFD) {
        e[D[154][j]] = 39424 + j;
        d[39424 + j] = D[154][j];
    }
    D[155] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D\uC31E\uC31F\uC320\uC321\uC322\uC323\uC326\uC327\uC32A\uC32B\uC32C\uC32D\uC32E\uC32F\uC330\uC331\uC332\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC333\uC334\uC335\uC336\uC337\uC338\uC339\uC33A\uC33B\uC33C\uC33D\uC33E\uC33F\uC340\uC341\uC342\uC343\uC344\uC346\uC347\uC348\uC349\uC34A\uC34B\uC34C\uC34D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC34E\uC34F\uC350\uC351\uC352\uC353\uC354\uC355\uC356\uC357\uC358\uC359\uC35A\uC35B\uC35C\uC35D\uC35E\uC35F\uC360\uC361\uC362\uC363\uC364\uC365\uC366\uC367\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373\uC374\uC375\uC376\uC377\uC37A\uC37B\uC37E\uC37F\uC380\uC381\uC382\uC383\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D\uC38E\uC38F\uC390\uC391\uC392\uC393\uC394\uC395\uC396\uC397\uC398\uC399\uC39A\uC39B\uC39C\uC39D\uC39E\uC39F\uC3A0\uC3A1\uC3A2\uC3A3\uC3A4\uC3A5\uC3A6\uC3A7\uC3A8\uC3A9\uC3AA\uC3AB\uC3AC\uC3AD\uC3AE\uC3AF\uC3B0\uC3B1\uC3B2\uC3B3\uC3B4\uC3B5\uC3B6\uC3B7\uC3B8\uC3B9\uC3BA\uC3BB\uC3BC\uC3BD\uC3BE\uC3BF\uC3C1\uC3C2\uC3C3\uC3C4\uC3C5\uC3C6\uC3C7\uC3C8\uC3C9\uC3CA\uC3CB\uC3CC\uC3CD\uC3CE\uC3CF\uC3D0\uC3D1\uC3D2\uC3D3\uC3D4\uC3D5\uC3D6\uC3D7\uC3DA\uFFFD".split("");
    for(j = 0; j != D[155].length; ++j)if (D[155][j].charCodeAt(0) !== 0xFFFD) {
        e[D[155][j]] = 39680 + j;
        d[39680 + j] = D[155][j];
    }
    D[156] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3\uC3E4\uC3E5\uC3E6\uC3E7\uC3EA\uC3EB\uC3EC\uC3EE\uC3EF\uC3F0\uC3F1\uC3F2\uC3F3\uC3F6\uC3F7\uC3F9\uC3FA\uC3FB\uC3FC\uC3FD\uC3FE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC3FF\uC400\uC401\uC402\uC403\uC404\uC405\uC406\uC407\uC409\uC40A\uC40B\uC40C\uC40D\uC40E\uC40F\uC411\uC412\uC413\uC414\uC415\uC416\uC417\uC418\uC419\uC41A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC41B\uC41C\uC41D\uC41E\uC41F\uC420\uC421\uC422\uC423\uC425\uC426\uC427\uC428\uC429\uC42A\uC42B\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435\uC436\uC437\uC438\uC439\uC43A\uC43B\uC43E\uC43F\uC440\uC441\uC442\uC443\uC444\uC445\uC446\uC447\uC449\uC44A\uC44B\uC44C\uC44D\uC44E\uC44F\uC450\uC451\uC452\uC453\uC454\uC455\uC456\uC457\uC458\uC459\uC45A\uC45B\uC45C\uC45D\uC45E\uC45F\uC460\uC461\uC462\uC463\uC466\uC467\uC469\uC46A\uC46B\uC46D\uC46E\uC46F\uC470\uC471\uC472\uC473\uC476\uC477\uC478\uC47A\uC47B\uC47C\uC47D\uC47E\uC47F\uC481\uC482\uC483\uC484\uC485\uC486\uC487\uC488\uC489\uC48A\uC48B\uC48C\uC48D\uC48E\uC48F\uC490\uC491\uC492\uC493\uC495\uC496\uC497\uC498\uC499\uC49A\uC49B\uC49D\uC49E\uC49F\uC4A0\uC4A1\uC4A2\uC4A3\uC4A4\uC4A5\uC4A6\uC4A7\uC4A8\uC4A9\uFFFD".split("");
    for(j = 0; j != D[156].length; ++j)if (D[156][j].charCodeAt(0) !== 0xFFFD) {
        e[D[156][j]] = 39936 + j;
        d[39936 + j] = D[156][j];
    }
    D[157] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4AA\uC4AB\uC4AC\uC4AD\uC4AE\uC4AF\uC4B0\uC4B1\uC4B2\uC4B3\uC4B4\uC4B5\uC4B6\uC4B7\uC4B9\uC4BA\uC4BB\uC4BD\uC4BE\uC4BF\uC4C0\uC4C1\uC4C2\uC4C3\uC4C4\uC4C5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4C6\uC4C7\uC4C8\uC4C9\uC4CA\uC4CB\uC4CC\uC4CD\uC4CE\uC4CF\uC4D0\uC4D1\uC4D2\uC4D3\uC4D4\uC4D5\uC4D6\uC4D7\uC4D8\uC4D9\uC4DA\uC4DB\uC4DC\uC4DD\uC4DE\uC4DF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC4E0\uC4E1\uC4E2\uC4E3\uC4E4\uC4E5\uC4E6\uC4E7\uC4E8\uC4EA\uC4EB\uC4EC\uC4ED\uC4EE\uC4EF\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502\uC503\uC504\uC505\uC506\uC507\uC508\uC509\uC50A\uC50B\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515\uC516\uC517\uC518\uC519\uC51A\uC51B\uC51D\uC51E\uC51F\uC520\uC521\uC522\uC523\uC524\uC525\uC526\uC527\uC52A\uC52B\uC52D\uC52E\uC52F\uC531\uC532\uC533\uC534\uC535\uC536\uC537\uC53A\uC53C\uC53E\uC53F\uC540\uC541\uC542\uC543\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569\uC56A\uC56B\uC56C\uC56D\uC56E\uC56F\uC572\uC576\uC577\uC578\uC579\uC57A\uC57B\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594\uFFFD".split("");
    for(j = 0; j != D[157].length; ++j)if (D[157][j].charCodeAt(0) !== 0xFFFD) {
        e[D[157][j]] = 40192 + j;
        d[40192 + j] = D[157][j];
    }
    D[158] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1\uC5A2\uC5A3\uC5A4\uC5A5\uC5A6\uC5A7\uC5A8\uC5AA\uC5AB\uC5AC\uC5AD\uC5AE\uC5AF\uC5B0\uC5B1\uC5B2\uC5B3\uC5B6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC5B7\uC5BA\uC5BF\uC5C0\uC5C1\uC5C2\uC5C3\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9\uC5DA\uC5DB\uC5DC\uC5DD\uC5DE\uC5DF\uC5E2\uC5E4\uC5E6\uC5E7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611\uC612\uC613\uC614\uC615\uC616\uC617\uC61A\uC61D\uC61E\uC61F\uC620\uC621\uC622\uC623\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649\uC64A\uC64B\uC64C\uC64D\uC64E\uC64F\uC652\uC656\uC657\uC658\uC659\uC65A\uC65B\uC65E\uC65F\uC661\uC662\uC663\uC664\uC665\uC666\uC667\uC668\uC669\uC66A\uC66B\uC66D\uC66E\uC670\uC672\uC673\uC674\uC675\uC676\uC677\uC67A\uC67B\uC67D\uC67E\uC67F\uC681\uC682\uC683\uC684\uC685\uC686\uC687\uC68A\uC68C\uC68E\uC68F\uC690\uC691\uC692\uC693\uC696\uC697\uC699\uC69A\uC69B\uC69D\uC69E\uC69F\uC6A0\uC6A1\uC6A2\uC6A3\uC6A6\uFFFD".split("");
    for(j = 0; j != D[158].length; ++j)if (D[158][j].charCodeAt(0) !== 0xFFFD) {
        e[D[158][j]] = 40448 + j;
        d[40448 + j] = D[158][j];
    }
    D[159] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6A8\uC6AA\uC6AB\uC6AC\uC6AD\uC6AE\uC6AF\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB\uC6BC\uC6BD\uC6BE\uC6BF\uC6C2\uC6C4\uC6C6\uC6C7\uC6C8\uC6C9\uC6CA\uC6CB\uC6CE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5\uC6D6\uC6D7\uC6D8\uC6D9\uC6DA\uC6DB\uC6DE\uC6DF\uC6E2\uC6E3\uC6E4\uC6E5\uC6E6\uC6E7\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC6F3\uC6F4\uC6F5\uC6F6\uC6F7\uC6FA\uC6FB\uC6FC\uC6FE\uC6FF\uC700\uC701\uC702\uC703\uC706\uC707\uC709\uC70A\uC70B\uC70D\uC70E\uC70F\uC710\uC711\uC712\uC713\uC716\uC718\uC71A\uC71B\uC71C\uC71D\uC71E\uC71F\uC722\uC723\uC725\uC726\uC727\uC729\uC72A\uC72B\uC72C\uC72D\uC72E\uC72F\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745\uC746\uC747\uC748\uC749\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761\uC762\uC763\uC764\uC765\uC766\uC767\uC769\uC76A\uC76C\uC76D\uC76E\uC76F\uC770\uC771\uC772\uC773\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B\uC79C\uC79D\uC79E\uC79F\uC7A2\uC7A7\uC7A8\uC7A9\uC7AA\uC7AB\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7\uFFFD".split("");
    for(j = 0; j != D[159].length; ++j)if (D[159][j].charCodeAt(0) !== 0xFFFD) {
        e[D[159][j]] = 40704 + j;
        d[40704 + j] = D[159][j];
    }
    D[160] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2\uC7C3\uC7C4\uC7C5\uC7C6\uC7C7\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1\uC7D2\uC7D3\uC7D4\uC7D5\uC7D6\uC7D7\uC7D9\uC7DA\uC7DB\uC7DC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7DE\uC7DF\uC7E0\uC7E1\uC7E2\uC7E3\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED\uC7EE\uC7EF\uC7F0\uC7F1\uC7F2\uC7F3\uC7F4\uC7F5\uC7F6\uC7F7\uC7F8\uC7F9\uC7FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC7FB\uC7FC\uC7FD\uC7FE\uC7FF\uC802\uC803\uC805\uC806\uC807\uC809\uC80B\uC80C\uC80D\uC80E\uC80F\uC812\uC814\uC817\uC818\uC819\uC81A\uC81B\uC81E\uC81F\uC821\uC822\uC823\uC825\uC826\uC827\uC828\uC829\uC82A\uC82B\uC82E\uC830\uC832\uC833\uC834\uC835\uC836\uC837\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841\uC842\uC843\uC844\uC845\uC846\uC847\uC84A\uC84B\uC84E\uC84F\uC850\uC851\uC852\uC853\uC855\uC856\uC857\uC858\uC859\uC85A\uC85B\uC85C\uC85D\uC85E\uC85F\uC860\uC861\uC862\uC863\uC864\uC865\uC866\uC867\uC868\uC869\uC86A\uC86B\uC86C\uC86D\uC86E\uC86F\uC872\uC873\uC875\uC876\uC877\uC879\uC87B\uC87C\uC87D\uC87E\uC87F\uC882\uC884\uC888\uC889\uC88A\uC88E\uC88F\uC890\uC891\uC892\uC893\uC895\uC896\uC897\uC898\uC899\uC89A\uC89B\uC89C\uC89E\uC8A0\uC8A2\uC8A3\uC8A4\uFFFD".split("");
    for(j = 0; j != D[160].length; ++j)if (D[160][j].charCodeAt(0) !== 0xFFFD) {
        e[D[160][j]] = 40960 + j;
        d[40960 + j] = D[160][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8A5\uC8A6\uC8A7\uC8A9\uC8AA\uC8AB\uC8AC\uC8AD\uC8AE\uC8AF\uC8B0\uC8B1\uC8B2\uC8B3\uC8B4\uC8B5\uC8B6\uC8B7\uC8B8\uC8B9\uC8BA\uC8BB\uC8BE\uC8BF\uC8C0\uC8C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD\uC8CE\uC8CF\uC8D0\uC8D1\uC8D2\uC8D3\uC8D6\uC8D8\uC8DA\uC8DB\uC8DC\uC8DD\uC8DE\uC8DF\uC8E2\uC8E3\uC8E5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC8E6\uC8E7\uC8E8\uC8E9\uC8EA\uC8EB\uC8EC\uC8ED\uC8EE\uC8EF\uC8F0\uC8F1\uC8F2\uC8F3\uC8F4\uC8F6\uC8F7\uC8F8\uC8F9\uC8FA\uC8FB\uC8FE\uC8FF\uC901\uC902\uC903\uC907\uC908\uC909\uC90A\uC90B\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC910\uC912\uC913\uC914\uC915\uC916\uC917\uC919\uC91A\uC91B\uC91C\uC91D\uC91E\uC91F\uC920\uC921\uC922\uC923\uC924\uC925\uC926\uC927\uC928\uC929\uC92A\uC92B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC92D\uC92E\uC92F\uC930\uC931\uC932\uC933\uC935\uC936\uC937\uC938\uC939\uC93A\uC93B\uC93C\uC93D\uC93E\uC93F\uC940\uC941\uC942\uC943\uC944\uC945\uC946\uC947\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC948\uC949\uC94A\uC94B\uC94C\uC94D\uC94E\uC94F\uC952\uC953\uC955\uC956\uC957\uC959\uC95A\uC95B\uC95C\uC95D\uC95E\uC95F\uC962\uC964\uC965\uC966\uC967\uC968\uC969\uC96A\uC96B\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC971\uC972\uC973\uC975\uC976\uC977\uC978\uC979\uC97A\uC97B\uC97D\uC97E\uC97F\uC980\uC981\uC982\uC983\uC984\uC985\uC986\uC987\uC98A\uC98B\uC98D\uC98E\uC98F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC991\uC992\uC993\uC994\uC995\uC996\uC997\uC99A\uC99C\uC99E\uC99F\uC9A0\uC9A1\uC9A2\uC9A3\uC9A4\uC9A5\uC9A6\uC9A7\uC9A8\uC9A9\uC9AA\uC9AB\uC9AC\uC9AD\uC9AE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC9AF\uC9B0\uC9B1\uC9B2\uC9B3\uC9B4\uC9B5\uC9B6\uC9B7\uC9B8\uC9B9\uC9BA\uC9BB\uC9BC\uC9BD\uC9BE\uC9BF\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB\uC9CC\uC9CD\uC9CE\uC9CF\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01\uFF02\uFF03\uFF04\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFFE6\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2\uC9F3\uC9F4\uC9F5\uC9F6\uC9F7\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA05\uCA06\uCA07\uCA0A\uCA0E\uCA0F\uCA10\uCA11\uCA12\uCA13\uCA15\uCA16\uCA17\uCA19\uCA1A\uCA1B\uCA1C\uCA1D\uCA1E\uCA1F\uCA20\uCA21\uCA22\uCA23\uCA24\uCA25\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA26\uCA27\uCA28\uCA2A\uCA2B\uCA2C\uCA2D\uCA2E\uCA2F\uCA30\uCA31\uCA32\uCA33\uCA34\uCA35\uCA36\uCA37\uCA38\uCA39\uCA3A\uCA3B\uCA3C\uCA3D\uCA3E\uCA3F\uCA40\uCA41\uCA42\uCA43\uCA44\uCA45\uCA46\u3131\u3132\u3133\u3134\u3135\u3136\u3137\u3138\u3139\u313A\u313B\u313C\u313D\u313E\u313F\u3140\u3141\u3142\u3143\u3144\u3145\u3146\u3147\u3148\u3149\u314A\u314B\u314C\u314D\u314E\u314F\u3150\u3151\u3152\u3153\u3154\u3155\u3156\u3157\u3158\u3159\u315A\u315B\u315C\u315D\u315E\u315F\u3160\u3161\u3162\u3163\u3164\u3165\u3166\u3167\u3168\u3169\u316A\u316B\u316C\u316D\u316E\u316F\u3170\u3171\u3172\u3173\u3174\u3175\u3176\u3177\u3178\u3179\u317A\u317B\u317C\u317D\u317E\u317F\u3180\u3181\u3182\u3183\u3184\u3185\u3186\u3187\u3188\u3189\u318A\u318B\u318C\u318D\u318E\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA47\uCA48\uCA49\uCA4A\uCA4B\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55\uCA56\uCA57\uCA58\uCA59\uCA5A\uCA5B\uCA5E\uCA62\uCA63\uCA64\uCA65\uCA66\uCA67\uCA69\uCA6A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA6B\uCA6C\uCA6D\uCA6E\uCA6F\uCA70\uCA71\uCA72\uCA73\uCA74\uCA75\uCA76\uCA77\uCA78\uCA79\uCA7A\uCA7B\uCA7C\uCA7E\uCA7F\uCA80\uCA81\uCA82\uCA83\uCA85\uCA86\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCA87\uCA88\uCA89\uCA8A\uCA8B\uCA8C\uCA8D\uCA8E\uCA8F\uCA90\uCA91\uCA92\uCA93\uCA94\uCA95\uCA96\uCA97\uCA99\uCA9A\uCA9B\uCA9C\uCA9D\uCA9E\uCA9F\uCAA0\uCAA1\uCAA2\uCAA3\uCAA4\uCAA5\uCAA6\uCAA7\u2170\u2171\u2172\u2173\u2174\u2175\u2176\u2177\u2178\u2179\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAA8\uCAA9\uCAAA\uCAAB\uCAAC\uCAAD\uCAAE\uCAAF\uCAB0\uCAB1\uCAB2\uCAB3\uCAB4\uCAB5\uCAB6\uCAB7\uCAB8\uCAB9\uCABA\uCABB\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAC6\uCAC7\uCAC8\uCAC9\uCACA\uCACB\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA\uCADB\uCADC\uCADD\uCADE\uCADF\uCAE1\uCAE2\uCAE3\uCAE4\uCAE5\uCAE6\uCAE7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCAE8\uCAE9\uCAEA\uCAEB\uCAED\uCAEE\uCAEF\uCAF0\uCAF1\uCAF2\uCAF3\uCAF5\uCAF6\uCAF7\uCAF8\uCAF9\uCAFA\uCAFB\uCAFC\uCAFD\uCAFE\uCAFF\uCB00\uCB01\uCB02\uCB03\uCB04\uCB05\uCB06\uCB07\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB0B\uCB0C\uCB0D\uCB0E\uCB0F\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19\uCB1A\uCB1B\uCB1C\uCB1D\uCB1E\uCB1F\uCB22\uCB23\uCB24\uCB25\uCB26\uCB27\uCB28\uCB29\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB2A\uCB2B\uCB2C\uCB2D\uCB2E\uCB2F\uCB30\uCB31\uCB32\uCB33\uCB34\uCB35\uCB36\uCB37\uCB38\uCB39\uCB3A\uCB3B\uCB3C\uCB3D\uCB3E\uCB3F\uCB40\uCB42\uCB43\uCB44\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51\uCB52\uCB53\uCB54\uCB55\uCB56\uCB57\uCB5A\uCB5B\uCB5C\uCB5E\uCB5F\uCB60\uCB61\uCB62\uCB63\uCB65\uCB66\uCB67\uCB68\uCB69\uCB6A\uCB6B\uCB6C\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399\u339A\u339B\u339C\u339D\u339E\u339F\u33A0\u33A1\u33A2\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0\u33B1\u33B2\u33B3\u33B4\u33B5\u33B6\u33B7\u33B8\u33B9\u3380\u3381\u3382\u3383\u3384\u33BA\u33BB\u33BC\u33BD\u33BE\u33BF\u3390\u3391\u3392\u3393\u3394\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB6D\uCB6E\uCB6F\uCB70\uCB71\uCB72\uCB73\uCB74\uCB75\uCB76\uCB77\uCB7A\uCB7B\uCB7C\uCB7D\uCB7E\uCB7F\uCB80\uCB81\uCB82\uCB83\uCB84\uCB85\uCB86\uCB87\uCB88\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCB89\uCB8A\uCB8B\uCB8C\uCB8D\uCB8E\uCB8F\uCB90\uCB91\uCB92\uCB93\uCB94\uCB95\uCB96\uCB97\uCB98\uCB99\uCB9A\uCB9B\uCB9D\uCB9E\uCB9F\uCBA0\uCBA1\uCBA2\uCBA3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBA4\uCBA5\uCBA6\uCBA7\uCBA8\uCBA9\uCBAA\uCBAB\uCBAC\uCBAD\uCBAE\uCBAF\uCBB0\uCBB1\uCBB2\uCBB3\uCBB4\uCBB5\uCBB6\uCBB7\uCBB9\uCBBA\uCBBB\uCBBC\uCBBD\uCBBE\uCBBF\uCBC0\uCBC1\uCBC2\uCBC3\uCBC4\xc6\xd0\xaa\u0126\uFFFD\u0132\uFFFD\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A\uFFFD\u3260\u3261\u3262\u3263\u3264\u3265\u3266\u3267\u3268\u3269\u326A\u326B\u326C\u326D\u326E\u326F\u3270\u3271\u3272\u3273\u3274\u3275\u3276\u3277\u3278\u3279\u327A\u327B\u24D0\u24D1\u24D2\u24D3\u24D4\u24D5\u24D6\u24D7\u24D8\u24D9\u24DA\u24DB\u24DC\u24DD\u24DE\u24DF\u24E0\u24E1\u24E2\u24E3\u24E4\u24E5\u24E6\u24E7\u24E8\u24E9\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\u246A\u246B\u246C\u246D\u246E\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBC5\uCBC6\uCBC7\uCBC8\uCBC9\uCBCA\uCBCB\uCBCC\uCBCD\uCBCE\uCBCF\uCBD0\uCBD1\uCBD2\uCBD3\uCBD5\uCBD6\uCBD7\uCBD8\uCBD9\uCBDA\uCBDB\uCBDC\uCBDD\uCBDE\uCBDF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA\uCBEB\uCBEC\uCBED\uCBEE\uCBEF\uCBF0\uCBF1\uCBF2\uCBF3\uCBF4\uCBF5\uCBF6\uCBF7\uCBF8\uCBF9\uCBFA\uCBFB\uCBFC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCBFD\uCBFE\uCBFF\uCC00\uCC01\uCC02\uCC03\uCC04\uCC05\uCC06\uCC07\uCC08\uCC09\uCC0A\uCC0B\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15\uCC16\uCC17\uCC18\uCC19\uCC1A\uCC1B\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200\u3201\u3202\u3203\u3204\u3205\u3206\u3207\u3208\u3209\u320A\u320B\u320C\u320D\u320E\u320F\u3210\u3211\u3212\u3213\u3214\u3215\u3216\u3217\u3218\u3219\u321A\u321B\u249C\u249D\u249E\u249F\u24A0\u24A1\u24A2\u24A3\u24A4\u24A5\u24A6\u24A7\u24A8\u24A9\u24AA\u24AB\u24AC\u24AD\u24AE\u24AF\u24B0\u24B1\u24B2\u24B3\u24B4\u24B5\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31\uCC32\uCC33\uCC34\uCC35\uCC36\uCC37\uCC3A\uCC3F\uCC40\uCC41\uCC42\uCC43\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC4F\uCC50\uCC51\uCC52\uCC53\uCC56\uCC5A\uCC5B\uCC5C\uCC5D\uCC5E\uCC5F\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69\uCC6A\uCC6B\uCC6C\uCC6D\uCC6E\uCC6F\uCC71\uCC72\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC73\uCC74\uCC76\uCC77\uCC78\uCC79\uCC7A\uCC7B\uCC7C\uCC7D\uCC7E\uCC7F\uCC80\uCC81\uCC82\uCC83\uCC84\uCC85\uCC86\uCC87\uCC88\uCC89\uCC8A\uCC8B\uCC8C\uCC8D\uCC8E\uCC8F\uCC90\uCC91\uCC92\uCC93\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1\uCCA2\uCCA3\uCCA4\uCCA5\uCCA6\uCCA7\uCCAA\uCCAE\uCCAF\uCCB0\uCCB1\uCCB2\uCCB3\uCCB6\uCCB7\uCCB9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCBA\uCCBB\uCCBD\uCCBE\uCCBF\uCCC0\uCCC1\uCCC2\uCCC3\uCCC6\uCCC8\uCCCA\uCCCB\uCCCC\uCCCD\uCCCE\uCCCF\uCCD1\uCCD2\uCCD3\uCCD5\uCCD6\uCCD7\uCCD8\uCCD9\uCCDA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCDB\uCCDC\uCCDD\uCCDE\uCCDF\uCCE0\uCCE1\uCCE2\uCCE3\uCCE5\uCCE6\uCCE7\uCCE8\uCCE9\uCCEA\uCCEB\uCCED\uCCEE\uCCEF\uCCF1\uCCF2\uCCF3\uCCF4\uCCF5\uCCF6\uCCF7\uCCF8\uCCF9\uCCFA\uCCFB\uCCFC\uCCFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCCFE\uCCFF\uCD00\uCD02\uCD03\uCD04\uCD05\uCD06\uCD07\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11\uCD12\uCD13\uCD14\uCD15\uCD16\uCD17\uCD1A\uCD1C\uCD1E\uCD1F\uCD20\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D\uCD2E\uCD2F\uCD30\uCD31\uCD32\uCD33\uCD34\uCD35\uCD36\uCD37\uCD38\uCD3A\uCD3B\uCD3C\uCD3D\uCD3E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD3F\uCD40\uCD41\uCD42\uCD43\uCD44\uCD45\uCD46\uCD47\uCD48\uCD49\uCD4A\uCD4B\uCD4C\uCD4D\uCD4E\uCD4F\uCD50\uCD51\uCD52\uCD53\uCD54\uCD55\uCD56\uCD57\uCD58\uCD59\uCD5A\uCD5B\uCD5D\uCD5E\uCD5F\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD61\uCD62\uCD63\uCD65\uCD66\uCD67\uCD68\uCD69\uCD6A\uCD6B\uCD6E\uCD70\uCD72\uCD73\uCD74\uCD75\uCD76\uCD77\uCD79\uCD7A\uCD7B\uCD7C\uCD7D\uCD7E\uCD7F\uCD80\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCD81\uCD82\uCD83\uCD84\uCD85\uCD86\uCD87\uCD89\uCD8A\uCD8B\uCD8C\uCD8D\uCD8E\uCD8F\uCD90\uCD91\uCD92\uCD93\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA\uCDAB\uCDAC\uCDAD\uCDAE\uCDAF\uCDB1\uCDB2\uCDB3\uCDB4\uCDB5\uCDB6\uCDB7\uCDB8\uCDB9\uCDBA\uCDBB\uCDBC\uCDBD\uCDBE\uCDBF\uCDC0\uCDC1\uCDC2\uCDC3\uCDC5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDC6\uCDC7\uCDC8\uCDC9\uCDCA\uCDCB\uCDCD\uCDCE\uCDCF\uCDD1\uCDD2\uCDD3\uCDD4\uCDD5\uCDD6\uCDD7\uCDD8\uCDD9\uCDDA\uCDDB\uCDDC\uCDDD\uCDDE\uCDDF\uCDE0\uCDE1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCDE2\uCDE3\uCDE4\uCDE5\uCDE6\uCDE7\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1\uCDF2\uCDF3\uCDF4\uCDF5\uCDF6\uCDF7\uCDFA\uCDFC\uCDFE\uCDFF\uCE00\uCE01\uCE02\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D\uCE0E\uCE0F\uCE10\uCE11\uCE12\uCE13\uCE15\uCE16\uCE17\uCE18\uCE1A\uCE1B\uCE1C\uCE1D\uCE1E\uCE1F\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36\uCE37\uCE38\uCE39\uCE3A\uCE3B\uCE3C\uCE3D\uCE3E\uCE3F\uCE40\uCE41\uCE42\uCE43\uCE44\uCE45\uCE46\uCE47\uCE48\uCE49\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE4A\uCE4B\uCE4C\uCE4D\uCE4E\uCE4F\uCE50\uCE51\uCE52\uCE53\uCE54\uCE55\uCE56\uCE57\uCE5A\uCE5B\uCE5D\uCE5E\uCE62\uCE63\uCE64\uCE65\uCE66\uCE67\uCE6A\uCE6C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE6E\uCE6F\uCE70\uCE71\uCE72\uCE73\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D\uCE7E\uCE7F\uCE80\uCE81\uCE82\uCE83\uCE86\uCE88\uCE8A\uCE8B\uCE8C\uCE8D\uCE8E\uCE8F\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCE9A\uCE9B\uCE9C\uCE9D\uCE9E\uCE9F\uCEA2\uCEA6\uCEA7\uCEA8\uCEA9\uCEAA\uCEAB\uCEAE\uCEAF\uCEB0\uCEB1\uCEB2\uCEB3\uCEB4\uCEB5\uCEB6\uCEB7\uCEB8\uCEB9\uCEBA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCEBB\uCEBC\uCEBD\uCEBE\uCEBF\uCEC0\uCEC2\uCEC3\uCEC4\uCEC5\uCEC6\uCEC7\uCEC8\uCEC9\uCECA\uCECB\uCECC\uCECD\uCECE\uCECF\uCED0\uCED1\uCED2\uCED3\uCED4\uCED5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCED6\uCED7\uCED8\uCED9\uCEDA\uCEDB\uCEDC\uCEDD\uCEDE\uCEDF\uCEE0\uCEE1\uCEE2\uCEE3\uCEE6\uCEE7\uCEE9\uCEEA\uCEED\uCEEE\uCEEF\uCEF0\uCEF1\uCEF2\uCEF3\uCEF6\uCEFA\uCEFB\uCEFC\uCEFD\uCEFE\uCEFF\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10\uAC11\uAC12\uAC13\uAC14\uAC15\uAC16\uAC17\uAC19\uAC1A\uAC1B\uAC1C\uAC1D\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09\uCF0A\uCF0B\uCF0C\uCF0D\uCF0E\uCF0F\uCF12\uCF14\uCF16\uCF17\uCF18\uCF19\uCF1A\uCF1B\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF25\uCF26\uCF27\uCF28\uCF29\uCF2A\uCF2B\uCF2E\uCF32\uCF33\uCF34\uCF35\uCF36\uCF37\uCF39\uCF3A\uCF3B\uCF3C\uCF3D\uCF3E\uCF3F\uCF40\uCF41\uCF42\uCF43\uCF44\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF45\uCF46\uCF47\uCF48\uCF49\uCF4A\uCF4B\uCF4C\uCF4D\uCF4E\uCF4F\uCF50\uCF51\uCF52\uCF53\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D\uCF5E\uCF5F\uCF60\uCF61\uCF62\uCF63\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79\uCF7A\uCF7B\uCF7C\uCF7D\uCF7E\uCF7F\uCF81\uCF82\uCF83\uCF84\uCF86\uCF87\uCF88\uCF89\uCF8A\uCF8B\uCF8D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCF8E\uCF8F\uCF90\uCF91\uCF92\uCF93\uCF94\uCF95\uCF96\uCF97\uCF98\uCF99\uCF9A\uCF9B\uCF9C\uCF9D\uCF9E\uCF9F\uCFA0\uCFA2\uCFA3\uCFA4\uCFA5\uCFA6\uCFA7\uCFA9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFAA\uCFAB\uCFAC\uCFAD\uCFAE\uCFAF\uCFB1\uCFB2\uCFB3\uCFB4\uCFB5\uCFB6\uCFB7\uCFB8\uCFB9\uCFBA\uCFBB\uCFBC\uCFBD\uCFBE\uCFBF\uCFC0\uCFC1\uCFC2\uCFC3\uCFC5\uCFC6\uCFC7\uCFC8\uCFC9\uCFCA\uCFCB\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFCC\uCFCD\uCFCE\uCFCF\uCFD0\uCFD1\uCFD2\uCFD3\uCFD4\uCFD5\uCFD6\uCFD7\uCFD8\uCFD9\uCFDA\uCFDB\uCFDC\uCFDD\uCFDE\uCFDF\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uCFEA\uCFEB\uCFEC\uCFED\uCFEE\uCFEF\uCFF2\uCFF4\uCFF6\uCFF7\uCFF8\uCFF9\uCFFA\uCFFB\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005\uD006\uD007\uD008\uD009\uD00A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD00B\uD00C\uD00D\uD00E\uD00F\uD010\uD012\uD013\uD014\uD015\uD016\uD017\uD019\uD01A\uD01B\uD01C\uD01D\uD01E\uD01F\uD020\uD021\uD022\uD023\uD024\uD025\uD026\uD027\uD028\uD029\uD02A\uD02B\uD02C\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB\uB0AC\uB0AD\uB0AE\uB0AF\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD02E\uD02F\uD030\uD031\uD032\uD033\uD036\uD037\uD039\uD03A\uD03B\uD03D\uD03E\uD03F\uD040\uD041\uD042\uD043\uD046\uD048\uD04A\uD04B\uD04C\uD04D\uD04E\uD04F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD051\uD052\uD053\uD055\uD056\uD057\uD059\uD05A\uD05B\uD05C\uD05D\uD05E\uD05F\uD061\uD062\uD063\uD064\uD065\uD066\uD067\uD068\uD069\uD06A\uD06B\uD06E\uD06F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD071\uD072\uD073\uD075\uD076\uD077\uD078\uD079\uD07A\uD07B\uD07E\uD07F\uD080\uD082\uD083\uD084\uD085\uD086\uD087\uD088\uD089\uD08A\uD08B\uD08C\uD08D\uD08E\uD08F\uD090\uD091\uD092\uD093\uD094\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB\uB2EC\uB2ED\uB2EE\uB2EF\uB2F3\uB2F4\uB2F5\uB2F7\uB2F8\uB2F9\uB2FA\uB2FB\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD095\uD096\uD097\uD098\uD099\uD09A\uD09B\uD09C\uD09D\uD09E\uD09F\uD0A0\uD0A1\uD0A2\uD0A3\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD\uD0AE\uD0AF\uD0B0\uD0B1\uD0B2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD0B3\uD0B6\uD0B8\uD0BA\uD0BB\uD0BC\uD0BD\uD0BE\uD0BF\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA\uD0CB\uD0CC\uD0CD\uD0CE\uD0CF\uD0D2\uD0D6\uD0D7\uD0D8\uD0D9\uD0DA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5\uD0E6\uD0E7\uD0E8\uD0E9\uD0EA\uD0EB\uD0EE\uD0F2\uD0F3\uD0F4\uD0F5\uD0F6\uD0F7\uD0F9\uD0FA\uD0FB\uD0FC\uD0FD\uD0FE\uD0FF\uD100\uD101\uD102\uD103\uD104\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD105\uD106\uD107\uD108\uD109\uD10A\uD10B\uD10C\uD10E\uD10F\uD110\uD111\uD112\uD113\uD114\uD115\uD116\uD117\uD118\uD119\uD11A\uD11B\uD11C\uD11D\uD11E\uD11F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD120\uD121\uD122\uD123\uD124\uD125\uD126\uD127\uD128\uD129\uD12A\uD12B\uD12C\uD12D\uD12E\uD12F\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD13F\uD142\uD146\uD147\uD148\uD149\uD14A\uD14B\uD14E\uD14F\uD151\uD152\uD153\uD155\uD156\uD157\uD158\uD159\uD15A\uD15B\uD15E\uD160\uD162\uD163\uD164\uD165\uD166\uD167\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD16E\uD16F\uD170\uD171\uD172\uD173\uD174\uD175\uD176\uD177\uD178\uD179\uD17A\uD17B\uD17D\uD17E\uD17F\uD180\uD181\uD182\uD183\uD185\uD186\uD187\uD189\uD18A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD18B\uD18C\uD18D\uD18E\uD18F\uD190\uD191\uD192\uD193\uD194\uD195\uD196\uD197\uD198\uD199\uD19A\uD19B\uD19C\uD19D\uD19E\uD19F\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1A9\uD1AA\uD1AB\uD1AC\uD1AD\uD1AE\uD1AF\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1\uD1C2\uD1C3\uD1C4\uD1C5\uD1C6\uD1C7\uD1C8\uD1C9\uD1CA\uD1CB\uD1CC\uD1CD\uD1CE\uD1CF\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1D0\uD1D1\uD1D2\uD1D3\uD1D4\uD1D5\uD1D6\uD1D7\uD1D9\uD1DA\uD1DB\uD1DC\uD1DD\uD1DE\uD1DF\uD1E0\uD1E1\uD1E2\uD1E3\uD1E4\uD1E5\uD1E6\uD1E7\uD1E8\uD1E9\uD1EA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD1EB\uD1EC\uD1ED\uD1EE\uD1EF\uD1F0\uD1F1\uD1F2\uD1F3\uD1F5\uD1F6\uD1F7\uD1F9\uD1FA\uD1FB\uD1FC\uD1FD\uD1FE\uD1FF\uD200\uD201\uD202\uD203\uD204\uD205\uD206\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD208\uD20A\uD20B\uD20C\uD20D\uD20E\uD20F\uD211\uD212\uD213\uD214\uD215\uD216\uD217\uD218\uD219\uD21A\uD21B\uD21C\uD21D\uD21E\uD21F\uD220\uD221\uD222\uD223\uD224\uD225\uD226\uD227\uD228\uD229\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE\uB9CF\uB9D0\uB9D1\uB9D2\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235\uD236\uD237\uD238\uD239\uD23A\uD23B\uD23E\uD240\uD242\uD243\uD244\uD245\uD246\uD247\uD249\uD24A\uD24B\uD24C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD24D\uD24E\uD24F\uD250\uD251\uD252\uD253\uD254\uD255\uD256\uD257\uD258\uD259\uD25A\uD25B\uD25D\uD25E\uD25F\uD260\uD261\uD262\uD263\uD265\uD266\uD267\uD268\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD269\uD26A\uD26B\uD26C\uD26D\uD26E\uD26F\uD270\uD271\uD272\uD273\uD274\uD275\uD276\uD277\uD278\uD279\uD27A\uD27B\uD27C\uD27D\uD27E\uD27F\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14\uBC15\uBC16\uBC17\uBC18\uBC1B\uBC1C\uBC1D\uBC1E\uBC1F\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296\uD297\uD298\uD299\uD29A\uD29B\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5\uD2A6\uD2A7\uD2A8\uD2A9\uD2AA\uD2AB\uD2AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2AE\uD2AF\uD2B0\uD2B2\uD2B3\uD2B4\uD2B5\uD2B6\uD2B7\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3\uD2C4\uD2C5\uD2C6\uD2C7\uD2CA\uD2CC\uD2CD\uD2CE\uD2CF\uD2D0\uD2D1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD\uD2DE\uD2DF\uD2E0\uD2E1\uD2E2\uD2E3\uD2E6\uD2E7\uD2E8\uD2E9\uD2EA\uD2EB\uD2EC\uD2ED\uD2EE\uD2EF\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD2FB\uD2FC\uD2FD\uD2FE\uD2FF\uD302\uD304\uD306\uD307\uD308\uD309\uD30A\uD30B\uD30F\uD311\uD312\uD313\uD315\uD317\uD318\uD319\uD31A\uD31B\uD31E\uD322\uD323\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331\uD332\uD333\uD334\uD335\uD336\uD337\uD33A\uD33E\uD33F\uD340\uD341\uD342\uD343\uD346\uD347\uD348\uD349\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD34A\uD34B\uD34C\uD34D\uD34E\uD34F\uD350\uD351\uD352\uD353\uD354\uD355\uD356\uD357\uD358\uD359\uD35A\uD35B\uD35C\uD35D\uD35E\uD35F\uD360\uD361\uD362\uD363\uD364\uD365\uD366\uD367\uD368\uD369\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD36A\uD36B\uD36C\uD36D\uD36E\uD36F\uD370\uD371\uD372\uD373\uD374\uD375\uD376\uD377\uD378\uD379\uD37A\uD37B\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD388\uD389\uD38A\uD38B\uD38E\uD392\uD393\uD394\uD395\uD396\uD397\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1\uD3A2\uD3A3\uD3A4\uD3A5\uD3A6\uD3A7\uD3AA\uD3AC\uD3AE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3AF\uD3B0\uD3B1\uD3B2\uD3B3\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD\uD3BE\uD3BF\uD3C0\uD3C1\uD3C2\uD3C3\uD3C6\uD3C7\uD3CA\uD3CB\uD3CC\uD3CD\uD3CE\uD3CF\uD3D1\uD3D2\uD3D3\uD3D4\uD3D5\uD3D6\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C\uC11D\uC11E\uC11F\uC120\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3D7\uD3D9\uD3DA\uD3DB\uD3DC\uD3DD\uD3DE\uD3DF\uD3E0\uD3E2\uD3E4\uD3E5\uD3E6\uD3E7\uD3E8\uD3E9\uD3EA\uD3EB\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402\uD403\uD404\uD405\uD406\uD407\uD409\uD40A\uD40B\uD40C\uD40D\uD40E\uD40F\uD410\uD411\uD412\uD413\uD414\uD415\uD416\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD417\uD418\uD419\uD41A\uD41B\uD41C\uD41E\uD41F\uD420\uD421\uD422\uD423\uD424\uD425\uD426\uD427\uD428\uD429\uD42A\uD42B\uD42C\uD42D\uD42E\uD42F\uD430\uD431\uD432\uD433\uD434\uD435\uD436\uD437\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD438\uD439\uD43A\uD43B\uD43C\uD43D\uD43E\uD43F\uD441\uD442\uD443\uD445\uD446\uD447\uD448\uD449\uD44A\uD44B\uD44C\uD44D\uD44E\uD44F\uD450\uD451\uD452\uD453\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD454\uD455\uD456\uD457\uD458\uD459\uD45A\uD45B\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465\uD466\uD467\uD468\uD469\uD46A\uD46B\uD46C\uD46E\uD470\uD471\uD472\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD473\uD474\uD475\uD476\uD477\uD47A\uD47B\uD47D\uD47E\uD481\uD483\uD484\uD485\uD486\uD487\uD48A\uD48C\uD48E\uD48F\uD490\uD491\uD492\uD493\uD495\uD496\uD497\uD498\uD499\uD49A\uD49B\uD49C\uD49D\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4\uC5C5\uC5C6\uC5C7\uC5C8\uC5C9\uC5CA\uC5CC\uC5CE\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD49E\uD49F\uD4A0\uD4A1\uD4A2\uD4A3\uD4A4\uD4A5\uD4A6\uD4A7\uD4A8\uD4AA\uD4AB\uD4AC\uD4AD\uD4AE\uD4AF\uD4B0\uD4B1\uD4B2\uD4B3\uD4B4\uD4B5\uD4B6\uD4B7\uD4B8\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4B9\uD4BA\uD4BB\uD4BC\uD4BD\uD4BE\uD4BF\uD4C0\uD4C1\uD4C2\uD4C3\uD4C4\uD4C5\uD4C6\uD4C7\uD4C8\uD4C9\uD4CA\uD4CB\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4D6\uD4D7\uD4D8\uD4D9\uD4DA\uD4DB\uD4DD\uD4DE\uD4E0\uD4E1\uD4E2\uD4E3\uD4E4\uD4E5\uD4E6\uD4E7\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1\uD4F2\uD4F3\uD4F4\uD4F5\uD4F6\uD4F7\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC\uC5FD\uC5FE\uC5FF\uC600\uC601\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD4FE\uD4FF\uD500\uD501\uD502\uD503\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D\uD50E\uD50F\uD510\uD511\uD512\uD513\uD516\uD518\uD519\uD51A\uD51B\uD51C\uD51D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD51E\uD51F\uD520\uD521\uD522\uD523\uD524\uD525\uD526\uD527\uD528\uD529\uD52A\uD52B\uD52C\uD52D\uD52E\uD52F\uD530\uD531\uD532\uD533\uD534\uD535\uD536\uD537\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545\uD546\uD547\uD548\uD549\uD54A\uD54B\uD54E\uD550\uD552\uD553\uD554\uD555\uD556\uD557\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751\uC752\uC753\uC754\uC755\uC756\uC757\uC758\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD564\uD566\uD567\uD56A\uD56C\uD56E\uD56F\uD570\uD571\uD572\uD573\uD576\uD577\uD579\uD57A\uD57B\uD57D\uD57E\uD57F\uD580\uD581\uD582\uD583\uD586\uD58A\uD58B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD58C\uD58D\uD58E\uD58F\uD591\uD592\uD593\uD594\uD595\uD596\uD597\uD598\uD599\uD59A\uD59B\uD59C\uD59D\uD59E\uD59F\uD5A0\uD5A1\uD5A2\uD5A3\uD5A4\uD5A6\uD5A7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5A8\uD5A9\uD5AA\uD5AB\uD5AC\uD5AD\uD5AE\uD5AF\uD5B0\uD5B1\uD5B2\uD5B3\uD5B4\uD5B5\uD5B6\uD5B7\uD5B8\uD5B9\uD5BA\uD5BB\uD5BC\uD5BD\uD5BE\uD5BF\uD5C0\uD5C1\uD5C2\uD5C3\uD5C4\uD5C5\uD5C6\uD5C7\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3\uD5D4\uD5D5\uD5D6\uD5D7\uD5DA\uD5DC\uD5DE\uD5DF\uD5E0\uD5E1\uD5E2\uD5E3\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD5EF\uD5F0\uD5F1\uD5F2\uD5F3\uD5F6\uD5F8\uD5FA\uD5FB\uD5FC\uD5FD\uD5FE\uD5FF\uD602\uD603\uD605\uD606\uD607\uD609\uD60A\uD60B\uD60C\uD60D\uD60E\uD60F\uD612\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD616\uD617\uD618\uD619\uD61A\uD61B\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625\uD626\uD627\uD628\uD629\uD62A\uD62B\uD62C\uD62E\uD62F\uD630\uD631\uD632\uD633\uD634\uD635\uD636\uD637\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D\uD65E\uD65F\uD660\uD661\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD662\uD663\uD664\uD665\uD666\uD668\uD66A\uD66B\uD66C\uD66D\uD66E\uD66F\uD672\uD673\uD675\uD676\uD677\uD678\uD679\uD67A\uD67B\uD67C\uD67D\uD67E\uD67F\uD680\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD681\uD682\uD684\uD686\uD687\uD688\uD689\uD68A\uD68B\uD68E\uD68F\uD691\uD692\uD693\uD695\uD696\uD697\uD698\uD699\uD69A\uD69B\uD69C\uD69E\uD6A0\uD6A2\uD6A3\uD6A4\uD6A5\uD6A6\uD6A7\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1\uD6B2\uD6B3\uD6B4\uD6B5\uD6B6\uD6B7\uD6B8\uD6BA\uD6BC\uD6BD\uD6BE\uD6BF\uD6C0\uD6C1\uD6C2\uD6C3\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA\uD6DB\uD6DC\uD6DD\uD6DE\uD6DF\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9\uD6EA\uD6EB\uD6EC\uD6ED\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6\uD6F7\uD6F8\uD6F9\uD6FA\uD6FB\uD6FE\uD6FF\uD701\uD702\uD703\uD705\uD706\uD707\uD708\uD709\uD70A\uD70B\uD70C\uD70D\uD70E\uD70F\uD710\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721\uD722\uD723\uD724\uD725\uD726\uD727\uD72A\uD72C\uD72E\uD72F\uD730\uD731\uD732\uD733\uD736\uD737\uD739\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD73A\uD73B\uD73D\uD73E\uD73F\uD740\uD741\uD742\uD743\uD745\uD746\uD748\uD74A\uD74B\uD74C\uD74D\uD74E\uD74F\uD752\uD753\uD755\uD75A\uD75B\uD75C\uD75D\uD75E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775\uD776\uD777\uD778\uD779\uD77A\uD77B\uD77E\uD77F\uD780\uD782\uD783\uD784\uD785\uD786\uD787\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD78D\uD78E\uD78F\uD791\uD792\uD793\uD794\uD795\uD796\uD797\uD79A\uD79C\uD79E\uD79F\uD7A0\uD7A1\uD7A2\uD7A3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E\uF90F\uF910\uF911\uF912\uF913\u90A3\uF914\uF915\uF916\uF917\uF918\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928\uF929\uF92A\uF92B\uF92C\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933\uF934\uF935\uF936\uF937\uF938\u99D1\uF939\uF93A\uF93B\uF93C\uF93D\uF93E\uF93F\uF940\uF941\uF942\uF943\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A\uF94B\uF94C\uF94D\uF94E\uF94F\uF950\uF951\u5AE9\u8A25\u677B\u7D10\uF952\uF953\uF954\uF955\uF956\uF957\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    D[250] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B\uFFFD".split("");
    for(j = 0; j != D[250].length; ++j)if (D[250][j].charCodeAt(0) !== 0xFFFD) {
        e[D[250][j]] = 64000 + j;
        d[64000 + j] = D[250][j];
    }
    D[251] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575\uFFFD".split("");
    for(j = 0; j != D[251].length; ++j)if (D[251][j].charCodeAt(0) !== 0xFFFD) {
        e[D[251][j]] = 64256 + j;
        d[64256 + j] = D[251][j];
    }
    D[252] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6\uFFFD".split("");
    for(j = 0; j != D[252].length; ++j)if (D[252][j].charCodeAt(0) !== 0xFFFD) {
        e[D[252][j]] = 64512 + j;
        d[64512 + j] = D[252][j];
    }
    D[253] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70\uFFFD".split("");
    for(j = 0; j != D[253].length; ++j)if (D[253][j].charCodeAt(0) !== 0xFFFD) {
        e[D[253][j]] = 64768 + j;
        d[64768 + j] = D[253][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[950] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62\uFE63\uFE64\uFE65\uFE66\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581\u2582\u2583\u2584\u2585\u2586\u2587\u2588\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u3021\u3022\u3023\u3024\u3025\u3026\u3027\u3028\u3029\u5341\u5344\u5345\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF57\uFF58\uFF59\uFF5A\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\u02D9\u02C9\u02CA\u02C7\u02CB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[170] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644\uFFFD".split("");
    for(j = 0; j != D[170].length; ++j)if (D[170][j].charCodeAt(0) !== 0xFFFD) {
        e[D[170][j]] = 43520 + j;
        d[43520 + j] = D[170][j];
    }
    D[171] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7\uFFFD".split("");
    for(j = 0; j != D[171].length; ++j)if (D[171][j].charCodeAt(0) !== 0xFFFD) {
        e[D[171][j]] = 43776 + j;
        d[43776 + j] = D[171][j];
    }
    D[172] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004\uFFFD".split("");
    for(j = 0; j != D[172].length; ++j)if (D[172][j].charCodeAt(0) !== 0xFFFD) {
        e[D[172][j]] = 44032 + j;
        d[44032 + j] = D[172][j];
    }
    D[173] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA\uFFFD".split("");
    for(j = 0; j != D[173].length; ++j)if (D[173][j].charCodeAt(0) !== 0xFFFD) {
        e[D[173][j]] = 44288 + j;
        d[44288 + j] = D[173][j];
    }
    D[174] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93\uFFFD".split("");
    for(j = 0; j != D[174].length; ++j)if (D[174][j].charCodeAt(0) !== 0xFFFD) {
        e[D[174][j]] = 44544 + j;
        d[44544 + j] = D[174][j];
    }
    D[175] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343\uFFFD".split("");
    for(j = 0; j != D[175].length; ++j)if (D[175][j].charCodeAt(0) !== 0xFFFD) {
        e[D[175][j]] = 44800 + j;
        d[44800 + j] = D[175][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    D[248] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A\uFFFD".split("");
    for(j = 0; j != D[248].length; ++j)if (D[248][j].charCodeAt(0) !== 0xFFFD) {
        e[D[248][j]] = 63488 + j;
        d[63488 + j] = D[248][j];
    }
    D[249] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593\uFFFD".split("");
    for(j = 0; j != D[249].length; ++j)if (D[249][j].charCodeAt(0) !== 0xFFFD) {
        e[D[249][j]] = 63744 + j;
        d[63744 + j] = D[249][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1250] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1251] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1252] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1253] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1254] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1255] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\uFFFD\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1256] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1257] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[1258] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10000] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10006] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10007] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10008] = function() {
    var d = [], e = {}, D = [], j;
    D[0] = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\x80\uF8D8\uF8D9\uF8DA\uF8DB\uF8DC\uF8DD\uF8DE\uF8DF\uF8E0\uF8E1\uF8E2\uF8E3\uF8E4\uF8E5\uF8E6\uF8E7\uF8E8\uF8E9\uF8EA\uF8EB\uF8EC\uF8ED\uF8EE\uF8EF\uF8F0\uF8F1\uF8F2\uF8F3\uF8F4\uF8F5\uF8F6\uF8F7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uF8F8\uF8F9\uF8FA\uF8FB\uF8FC\uF8FD\uF8FE\uF8FF".split("");
    for(j = 0; j != D[0].length; ++j)if (D[0][j].charCodeAt(0) !== 0xFFFD) {
        e[D[0][j]] = 0 + j;
        d[0 + j] = D[0][j];
    }
    D[161] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3000\u3001\u3002\u30FB\u02C9\u02C7\xa8\u3003\u3005\u2015\uFF5E\uFFFD\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013\uFFFD".split("");
    for(j = 0; j != D[161].length; ++j)if (D[161][j].charCodeAt(0) !== 0xFFFD) {
        e[D[161][j]] = 41216 + j;
        d[41216 + j] = D[161][j];
    }
    D[162] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2488\u2489\u248A\u248B\u248C\u248D\u248E\u248F\u2490\u2491\u2492\u2493\u2494\u2495\u2496\u2497\u2498\u2499\u249A\u249B\u2474\u2475\u2476\u2477\u2478\u2479\u247A\u247B\u247C\u247D\u247E\u247F\u2480\u2481\u2482\u2483\u2484\u2485\u2486\u2487\u2460\u2461\u2462\u2463\u2464\u2465\u2466\u2467\u2468\u2469\uFFFD\uFFFD\u3220\u3221\u3222\u3223\u3224\u3225\u3226\u3227\u3228\u3229\uFFFD\uFFFD\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u216A\u216B\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[162].length; ++j)if (D[162][j].charCodeAt(0) !== 0xFFFD) {
        e[D[162][j]] = 41472 + j;
        d[41472 + j] = D[162][j];
    }
    D[163] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFF01\uFF02\uFF03\uFFE5\uFF05\uFF06\uFF07\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A\uFF3B\uFF3C\uFF3D\uFF3E\uFF3F\uFF40\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A\uFF5B\uFF5C\uFF5D\uFFE3\uFFFD".split("");
    for(j = 0; j != D[163].length; ++j)if (D[163][j].charCodeAt(0) !== 0xFFFD) {
        e[D[163][j]] = 41728 + j;
        d[41728 + j] = D[163][j];
    }
    D[164] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[164].length; ++j)if (D[164][j].charCodeAt(0) !== 0xFFFD) {
        e[D[164][j]] = 41984 + j;
        d[41984 + j] = D[164][j];
    }
    D[165] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[165].length; ++j)if (D[165][j].charCodeAt(0) !== 0xFFFD) {
        e[D[165][j]] = 42240 + j;
        d[42240 + j] = D[165][j];
    }
    D[166] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[166].length; ++j)if (D[166][j].charCodeAt(0) !== 0xFFFD) {
        e[D[166][j]] = 42496 + j;
        d[42496 + j] = D[166][j];
    }
    D[167] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[167].length; ++j)if (D[167][j].charCodeAt(0) !== 0xFFFD) {
        e[D[167][j]] = 42752 + j;
        d[42752 + j] = D[167][j];
    }
    D[168] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u3105\u3106\u3107\u3108\u3109\u310A\u310B\u310C\u310D\u310E\u310F\u3110\u3111\u3112\u3113\u3114\u3115\u3116\u3117\u3118\u3119\u311A\u311B\u311C\u311D\u311E\u311F\u3120\u3121\u3122\u3123\u3124\u3125\u3126\u3127\u3128\u3129\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[168].length; ++j)if (D[168][j].charCodeAt(0) !== 0xFFFD) {
        e[D[168][j]] = 43008 + j;
        d[43008 + j] = D[168][j];
    }
    D[169] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2500\u2501\u2502\u2503\u2504\u2505\u2506\u2507\u2508\u2509\u250A\u250B\u250C\u250D\u250E\u250F\u2510\u2511\u2512\u2513\u2514\u2515\u2516\u2517\u2518\u2519\u251A\u251B\u251C\u251D\u251E\u251F\u2520\u2521\u2522\u2523\u2524\u2525\u2526\u2527\u2528\u2529\u252A\u252B\u252C\u252D\u252E\u252F\u2530\u2531\u2532\u2533\u2534\u2535\u2536\u2537\u2538\u2539\u253A\u253B\u253C\u253D\u253E\u253F\u2540\u2541\u2542\u2543\u2544\u2545\u2546\u2547\u2548\u2549\u254A\u254B\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[169].length; ++j)if (D[169][j].charCodeAt(0) !== 0xFFFD) {
        e[D[169][j]] = 43264 + j;
        d[43264 + j] = D[169][j];
    }
    D[176] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265\uFFFD".split("");
    for(j = 0; j != D[176].length; ++j)if (D[176][j].charCodeAt(0) !== 0xFFFD) {
        e[D[176][j]] = 45056 + j;
        d[45056 + j] = D[176][j];
    }
    D[177] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\uFFFD".split("");
    for(j = 0; j != D[177].length; ++j)if (D[177][j].charCodeAt(0) !== 0xFFFD) {
        e[D[177][j]] = 45312 + j;
        d[45312 + j] = D[177][j];
    }
    D[178] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316\uFFFD".split("");
    for(j = 0; j != D[178].length; ++j)if (D[178][j].charCodeAt(0) !== 0xFFFD) {
        e[D[178][j]] = 45568 + j;
        d[45568 + j] = D[178][j];
    }
    D[179] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\uFFFD".split("");
    for(j = 0; j != D[179].length; ++j)if (D[179][j].charCodeAt(0) !== 0xFFFD) {
        e[D[179][j]] = 45824 + j;
        d[45824 + j] = D[179][j];
    }
    D[180] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\uFFFD".split("");
    for(j = 0; j != D[180].length; ++j)if (D[180][j].charCodeAt(0) !== 0xFFFD) {
        e[D[180][j]] = 46080 + j;
        d[46080 + j] = D[180][j];
    }
    D[181] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\uFFFD".split("");
    for(j = 0; j != D[181].length; ++j)if (D[181][j].charCodeAt(0) !== 0xFFFD) {
        e[D[181][j]] = 46336 + j;
        d[46336 + j] = D[181][j];
    }
    D[182] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\uFFFD".split("");
    for(j = 0; j != D[182].length; ++j)if (D[182][j].charCodeAt(0) !== 0xFFFD) {
        e[D[182][j]] = 46592 + j;
        d[46592 + j] = D[182][j];
    }
    D[183] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\uFFFD".split("");
    for(j = 0; j != D[183].length; ++j)if (D[183][j].charCodeAt(0) !== 0xFFFD) {
        e[D[183][j]] = 46848 + j;
        d[46848 + j] = D[183][j];
    }
    D[184] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9\uFFFD".split("");
    for(j = 0; j != D[184].length; ++j)if (D[184][j].charCodeAt(0) !== 0xFFFD) {
        e[D[184][j]] = 47104 + j;
        d[47104 + j] = D[184][j];
    }
    D[185] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8\uFFFD".split("");
    for(j = 0; j != D[185].length; ++j)if (D[185][j].charCodeAt(0) !== 0xFFFD) {
        e[D[185][j]] = 47360 + j;
        d[47360 + j] = D[185][j];
    }
    D[186] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\uFFFD".split("");
    for(j = 0; j != D[186].length; ++j)if (D[186][j].charCodeAt(0) !== 0xFFFD) {
        e[D[186][j]] = 47616 + j;
        d[47616 + j] = D[186][j];
    }
    D[187] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\uFFFD".split("");
    for(j = 0; j != D[187].length; ++j)if (D[187][j].charCodeAt(0) !== 0xFFFD) {
        e[D[187][j]] = 47872 + j;
        d[47872 + j] = D[187][j];
    }
    D[188] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\uFFFD".split("");
    for(j = 0; j != D[188].length; ++j)if (D[188][j].charCodeAt(0) !== 0xFFFD) {
        e[D[188][j]] = 48128 + j;
        d[48128 + j] = D[188][j];
    }
    D[189] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\uFFFD".split("");
    for(j = 0; j != D[189].length; ++j)if (D[189][j].charCodeAt(0) !== 0xFFFD) {
        e[D[189][j]] = 48384 + j;
        d[48384 + j] = D[189][j];
    }
    D[190] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB\uFFFD".split("");
    for(j = 0; j != D[190].length; ++j)if (D[190][j].charCodeAt(0) !== 0xFFFD) {
        e[D[190][j]] = 48640 + j;
        d[48640 + j] = D[190][j];
    }
    D[191] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\uFFFD".split("");
    for(j = 0; j != D[191].length; ++j)if (D[191][j].charCodeAt(0) !== 0xFFFD) {
        e[D[191][j]] = 48896 + j;
        d[48896 + j] = D[191][j];
    }
    D[192] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\uFFFD".split("");
    for(j = 0; j != D[192].length; ++j)if (D[192][j].charCodeAt(0) !== 0xFFFD) {
        e[D[192][j]] = 49152 + j;
        d[49152 + j] = D[192][j];
    }
    D[193] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF\uFFFD".split("");
    for(j = 0; j != D[193].length; ++j)if (D[193][j].charCodeAt(0) !== 0xFFFD) {
        e[D[193][j]] = 49408 + j;
        d[49408 + j] = D[193][j];
    }
    D[194] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\uFFFD".split("");
    for(j = 0; j != D[194].length; ++j)if (D[194][j].charCodeAt(0) !== 0xFFFD) {
        e[D[194][j]] = 49664 + j;
        d[49664 + j] = D[194][j];
    }
    D[195] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478\uFFFD".split("");
    for(j = 0; j != D[195].length; ++j)if (D[195][j].charCodeAt(0) !== 0xFFFD) {
        e[D[195][j]] = 49920 + j;
        d[49920 + j] = D[195][j];
    }
    D[196] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81\uFFFD".split("");
    for(j = 0; j != D[196].length; ++j)if (D[196][j].charCodeAt(0) !== 0xFFFD) {
        e[D[196][j]] = 50176 + j;
        d[50176 + j] = D[196][j];
    }
    D[197] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\uFFFD".split("");
    for(j = 0; j != D[197].length; ++j)if (D[197][j].charCodeAt(0) !== 0xFFFD) {
        e[D[197][j]] = 50432 + j;
        d[50432 + j] = D[197][j];
    }
    D[198] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390\uFFFD".split("");
    for(j = 0; j != D[198].length; ++j)if (D[198][j].charCodeAt(0) !== 0xFFFD) {
        e[D[198][j]] = 50688 + j;
        d[50688 + j] = D[198][j];
    }
    D[199] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\uFFFD".split("");
    for(j = 0; j != D[199].length; ++j)if (D[199][j].charCodeAt(0) !== 0xFFFD) {
        e[D[199][j]] = 50944 + j;
        d[50944 + j] = D[199][j];
    }
    D[200] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1\uFFFD".split("");
    for(j = 0; j != D[200].length; ++j)if (D[200][j].charCodeAt(0) !== 0xFFFD) {
        e[D[200][j]] = 51200 + j;
        d[51200 + j] = D[200][j];
    }
    D[201] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3\uFFFD".split("");
    for(j = 0; j != D[201].length; ++j)if (D[201][j].charCodeAt(0) !== 0xFFFD) {
        e[D[201][j]] = 51456 + j;
        d[51456 + j] = D[201][j];
    }
    D[202] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\uFFFD".split("");
    for(j = 0; j != D[202].length; ++j)if (D[202][j].charCodeAt(0) !== 0xFFFD) {
        e[D[202][j]] = 51712 + j;
        d[51712 + j] = D[202][j];
    }
    D[203] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854\uFFFD".split("");
    for(j = 0; j != D[203].length; ++j)if (D[203][j].charCodeAt(0) !== 0xFFFD) {
        e[D[203][j]] = 51968 + j;
        d[51968 + j] = D[203][j];
    }
    D[204] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3\uFFFD".split("");
    for(j = 0; j != D[204].length; ++j)if (D[204][j].charCodeAt(0) !== 0xFFFD) {
        e[D[204][j]] = 52224 + j;
        d[52224 + j] = D[204][j];
    }
    D[205] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01\uFFFD".split("");
    for(j = 0; j != D[205].length; ++j)if (D[205][j].charCodeAt(0) !== 0xFFFD) {
        e[D[205][j]] = 52480 + j;
        d[52480 + j] = D[205][j];
    }
    D[206] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\uFFFD".split("");
    for(j = 0; j != D[206].length; ++j)if (D[206][j].charCodeAt(0) !== 0xFFFD) {
        e[D[206][j]] = 52736 + j;
        d[52736 + j] = D[206][j];
    }
    D[207] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\uFFFD".split("");
    for(j = 0; j != D[207].length; ++j)if (D[207][j].charCodeAt(0) !== 0xFFFD) {
        e[D[207][j]] = 52992 + j;
        d[52992 + j] = D[207][j];
    }
    D[208] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\uFFFD".split("");
    for(j = 0; j != D[208].length; ++j)if (D[208][j].charCodeAt(0) !== 0xFFFD) {
        e[D[208][j]] = 53248 + j;
        d[53248 + j] = D[208][j];
    }
    D[209] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476\uFFFD".split("");
    for(j = 0; j != D[209].length; ++j)if (D[209][j].charCodeAt(0) !== 0xFFFD) {
        e[D[209][j]] = 53504 + j;
        d[53504 + j] = D[209][j];
    }
    D[210] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\uFFFD".split("");
    for(j = 0; j != D[210].length; ++j)if (D[210][j].charCodeAt(0) !== 0xFFFD) {
        e[D[210][j]] = 53760 + j;
        d[53760 + j] = D[210][j];
    }
    D[211] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\uFFFD".split("");
    for(j = 0; j != D[211].length; ++j)if (D[211][j].charCodeAt(0) !== 0xFFFD) {
        e[D[211][j]] = 54016 + j;
        d[54016 + j] = D[211][j];
    }
    D[212] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67\uFFFD".split("");
    for(j = 0; j != D[212].length; ++j)if (D[212][j].charCodeAt(0) !== 0xFFFD) {
        e[D[212][j]] = 54272 + j;
        d[54272 + j] = D[212][j];
    }
    D[213] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\uFFFD".split("");
    for(j = 0; j != D[213].length; ++j)if (D[213][j].charCodeAt(0) !== 0xFFFD) {
        e[D[213][j]] = 54528 + j;
        d[54528 + j] = D[213][j];
    }
    D[214] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\uFFFD".split("");
    for(j = 0; j != D[214].length; ++j)if (D[214][j].charCodeAt(0) !== 0xFFFD) {
        e[D[214][j]] = 54784 + j;
        d[54784 + j] = D[214][j];
    }
    D[215] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD".split("");
    for(j = 0; j != D[215].length; ++j)if (D[215][j].charCodeAt(0) !== 0xFFFD) {
        e[D[215][j]] = 55040 + j;
        d[55040 + j] = D[215][j];
    }
    D[216] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D\uFFFD".split("");
    for(j = 0; j != D[216].length; ++j)if (D[216][j].charCodeAt(0) !== 0xFFFD) {
        e[D[216][j]] = 55296 + j;
        d[55296 + j] = D[216][j];
    }
    D[217] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC\uFFFD".split("");
    for(j = 0; j != D[217].length; ++j)if (D[217][j].charCodeAt(0) !== 0xFFFD) {
        e[D[217][j]] = 55552 + j;
        d[55552 + j] = D[217][j];
    }
    D[218] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA\uFFFD".split("");
    for(j = 0; j != D[218].length; ++j)if (D[218][j].charCodeAt(0) !== 0xFFFD) {
        e[D[218][j]] = 55808 + j;
        d[55808 + j] = D[218][j];
    }
    D[219] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD\uFFFD".split("");
    for(j = 0; j != D[219].length; ++j)if (D[219][j].charCodeAt(0) !== 0xFFFD) {
        e[D[219][j]] = 56064 + j;
        d[56064 + j] = D[219][j];
    }
    D[220] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365\uFFFD".split("");
    for(j = 0; j != D[220].length; ++j)if (D[220][j].charCodeAt(0) !== 0xFFFD) {
        e[D[220][j]] = 56320 + j;
        d[56320 + j] = D[220][j];
    }
    D[221] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A\uFFFD".split("");
    for(j = 0; j != D[221].length; ++j)if (D[221][j].charCodeAt(0) !== 0xFFFD) {
        e[D[221][j]] = 56576 + j;
        d[56576 + j] = D[221][j];
    }
    D[222] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496\uFFFD".split("");
    for(j = 0; j != D[222].length; ++j)if (D[222][j].charCodeAt(0) !== 0xFFFD) {
        e[D[222][j]] = 56832 + j;
        d[56832 + j] = D[222][j];
    }
    D[223] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C\uFFFD".split("");
    for(j = 0; j != D[223].length; ++j)if (D[223][j].charCodeAt(0) !== 0xFFFD) {
        e[D[223][j]] = 57088 + j;
        d[57088 + j] = D[223][j];
    }
    D[224] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C\uFFFD".split("");
    for(j = 0; j != D[224].length; ++j)if (D[224][j].charCodeAt(0) !== 0xFFFD) {
        e[D[224][j]] = 57344 + j;
        d[57344 + j] = D[224][j];
    }
    D[225] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA\uFFFD".split("");
    for(j = 0; j != D[225].length; ++j)if (D[225][j].charCodeAt(0) !== 0xFFFD) {
        e[D[225][j]] = 57600 + j;
        d[57600 + j] = D[225][j];
    }
    D[226] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967\u9968\u9969\u996A\u996B\u996C\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042\uFFFD".split("");
    for(j = 0; j != D[226].length; ++j)if (D[226][j].charCodeAt(0) !== 0xFFFD) {
        e[D[226][j]] = 57856 + j;
        d[57856 + j] = D[226][j];
    }
    D[227] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE\uFFFD".split("");
    for(j = 0; j != D[227].length; ++j)if (D[227][j].charCodeAt(0) !== 0xFFFD) {
        e[D[227][j]] = 58112 + j;
        d[58112 + j] = D[227][j];
    }
    D[228] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1\uFFFD".split("");
    for(j = 0; j != D[228].length; ++j)if (D[228][j].charCodeAt(0) !== 0xFFFD) {
        e[D[228][j]] = 58368 + j;
        d[58368 + j] = D[228][j];
    }
    D[229] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3\uFFFD".split("");
    for(j = 0; j != D[229].length; ++j)if (D[229][j].charCodeAt(0) !== 0xFFFD) {
        e[D[229][j]] = 58624 + j;
        d[58624 + j] = D[229][j];
    }
    D[230] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9\uFFFD".split("");
    for(j = 0; j != D[230].length; ++j)if (D[230][j].charCodeAt(0) !== 0xFFFD) {
        e[D[230][j]] = 58880 + j;
        d[58880 + j] = D[230][j];
    }
    D[231] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21\u7F22\u7F23\u7F24\u7F25\u7F26\u7F27\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F\u7F30\u7F31\u7F32\u7F33\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C\uFFFD".split("");
    for(j = 0; j != D[231].length; ++j)if (D[231][j].charCodeAt(0) !== 0xFFFD) {
        e[D[231][j]] = 59136 + j;
        d[59136 + j] = D[231][j];
    }
    D[232] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9\uFFFD".split("");
    for(j = 0; j != D[232].length; ++j)if (D[232][j].charCodeAt(0) !== 0xFFFD) {
        e[D[232][j]] = 59392 + j;
        d[59392 + j] = D[232][j];
    }
    D[233] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B\uFFFD".split("");
    for(j = 0; j != D[233].length; ++j)if (D[233][j].charCodeAt(0) !== 0xFFFD) {
        e[D[233][j]] = 59648 + j;
        d[59648 + j] = D[233][j];
    }
    D[234] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0\uFFFD".split("");
    for(j = 0; j != D[234].length; ++j)if (D[234][j].charCodeAt(0) !== 0xFFFD) {
        e[D[234][j]] = 59904 + j;
        d[59904 + j] = D[234][j];
    }
    D[235] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB\uFFFD".split("");
    for(j = 0; j != D[235].length; ++j)if (D[235][j].charCodeAt(0) !== 0xFFFD) {
        e[D[235][j]] = 60160 + j;
        d[60160 + j] = D[235][j];
    }
    D[236] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0\uFFFD".split("");
    for(j = 0; j != D[236].length; ++j)if (D[236][j].charCodeAt(0) !== 0xFFFD) {
        e[D[236][j]] = 60416 + j;
        d[60416 + j] = D[236][j];
    }
    D[237] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768\uFFFD".split("");
    for(j = 0; j != D[237].length; ++j)if (D[237][j].charCodeAt(0) !== 0xFFFD) {
        e[D[237][j]] = 60672 + j;
        d[60672 + j] = D[237][j];
    }
    D[238] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6\u94B7\u94B8\u94B9\u94BA\u94BC\u94BD\u94BF\u94C4\u94C8\u94C9\u94CA\u94CB\u94CC\u94CD\u94CE\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA\uFFFD".split("");
    for(j = 0; j != D[238].length; ++j)if (D[238][j].charCodeAt(0) !== 0xFFFD) {
        e[D[238][j]] = 60928 + j;
        d[60928 + j] = D[238][j];
    }
    D[239] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512\u9513\u9514\u9515\u9516\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564\u9565\u9566\u9567\u9568\u9569\u956A\u956B\u956C\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14\uFFFD".split("");
    for(j = 0; j != D[239].length; ++j)if (D[239][j].charCodeAt(0) !== 0xFFFD) {
        e[D[239][j]] = 61184 + j;
        d[61184 + j] = D[239][j];
    }
    D[240] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28\u9E29\u9E2A\u9E2B\u9E2C\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66\u9E67\u9E68\u9E69\u9E6A\u9E6B\u9E6C\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619\uFFFD".split("");
    for(j = 0; j != D[240].length; ++j)if (D[240][j].charCodeAt(0) !== 0xFFFD) {
        e[D[240][j]] = 61440 + j;
        d[61440 + j] = D[240][j];
    }
    D[241] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883\uFFFD".split("");
    for(j = 0; j != D[241].length; ++j)if (D[241][j].charCodeAt(0) !== 0xFFFD) {
        e[D[241][j]] = 61696 + j;
        d[61696 + j] = D[241][j];
    }
    D[242] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2\uFFFD".split("");
    for(j = 0; j != D[242].length; ++j)if (D[242][j].charCodeAt(0) !== 0xFFFD) {
        e[D[242][j]] = 61952 + j;
        d[61952 + j] = D[242][j];
    }
    D[243] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B\uFFFD".split("");
    for(j = 0; j != D[243].length; ++j)if (D[243][j].charCodeAt(0) !== 0xFFFD) {
        e[D[243][j]] = 62208 + j;
        d[62208 + j] = D[243][j];
    }
    D[244] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164\uFFFD".split("");
    for(j = 0; j != D[244].length; ++j)if (D[244][j].charCodeAt(0) !== 0xFFFD) {
        e[D[244][j]] = 62464 + j;
        d[62464 + j] = D[244][j];
    }
    D[245] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC\uFFFD".split("");
    for(j = 0; j != D[245].length; ++j)if (D[245][j].charCodeAt(0) !== 0xFFFD) {
        e[D[245][j]] = 62720 + j;
        d[62720 + j] = D[245][j];
    }
    D[246] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85\u9F86\u9F87\u9F88\u9F89\u9F8A\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E\u9C9F\u9CA0\u9CA1\u9CA2\u9CA3\u9CA5\u9CA6\u9CA7\u9CA8\u9CA9\u9CAB\u9CAD\u9CAE\u9CB0\u9CB1\u9CB2\u9CB3\u9CB4\u9CB5\u9CB6\u9CB7\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB\uFFFD".split("");
    for(j = 0; j != D[246].length; ++j)if (D[246][j].charCodeAt(0) !== 0xFFFD) {
        e[D[246][j]] = 62976 + j;
        d[62976 + j] = D[246][j];
    }
    D[247] = "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u9CCC\u9CCD\u9CCE\u9CCF\u9CD0\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44\uFFFD".split("");
    for(j = 0; j != D[247].length; ++j)if (D[247][j].charCodeAt(0) !== 0xFFFD) {
        e[D[247][j]] = 63232 + j;
        d[63232 + j] = D[247][j];
    }
    return {
        "enc": e,
        "dec": d
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10029] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10079] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[10081] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
$cc5debf93af04dae$export$70da684357f001c0[28591] = function() {
    var d = "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff", D = [], e = {};
    for(var i = 0; i != d.length; ++i){
        if (d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i;
        D[i] = d.charAt(i);
    }
    return {
        "enc": e,
        "dec": D
    };
}();
/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ft=javascript: */ var $cc5debf93af04dae$var$cpt = $cc5debf93af04dae$export$70da684357f001c0;
/*global module, Buffer */ var $cc5debf93af04dae$var$magic /*:{[id:CPIndex]:string}*/  = {
    "1200": "utf16le",
    "1201": "utf16be",
    "12000": "utf32le",
    "12001": "utf32be",
    "16969": "utf64le",
    "20127": "ascii",
    "65000": "utf7",
    "65001": "utf8"
};
var $cc5debf93af04dae$var$sbcs_cache /*:Array<number>*/  = [
    874,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    10000
];
var $cc5debf93af04dae$var$dbcs_cache /*:Array<number>*/  = [
    932,
    936,
    949,
    950
];
var $cc5debf93af04dae$var$magic_cache /*:Array<number>*/  = [
    65001
];
var $cc5debf93af04dae$var$magic_decode /*:DecoderMap*/  = {};
var $cc5debf93af04dae$var$magic_encode /*:EncoderMap*/  = {};
var $cc5debf93af04dae$var$cpdcache /*:DecoderMap*/  = {};
var $cc5debf93af04dae$var$cpecache /*:EncoderMap*/  = {};
var $cc5debf93af04dae$var$sfcc = function sfcc(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $cc5debf93af04dae$var$cca = function cca(x /*:string*/ ) /*:number*/ {
    return x.charCodeAt(0);
};
var $cc5debf93af04dae$var$has_buf /*:boolean*/  = typeof $cc5debf93af04dae$require$Buffer !== "undefined";
var $cc5debf93af04dae$var$Buffer_from = function() {};
if ($cc5debf93af04dae$var$has_buf) {
    var $cc5debf93af04dae$var$nbfs = !$cc5debf93af04dae$require$Buffer.from;
    if (!$cc5debf93af04dae$var$nbfs) try {
        $cc5debf93af04dae$require$Buffer.from("foo", "utf8");
    } catch (e) {
        $cc5debf93af04dae$var$nbfs = true;
    }
    $cc5debf93af04dae$var$Buffer_from = $cc5debf93af04dae$var$nbfs ? function(buf, enc) {
        return enc ? new $cc5debf93af04dae$require$Buffer(buf, enc) : new $cc5debf93af04dae$require$Buffer(buf);
    } : $cc5debf93af04dae$require$Buffer.from.bind($cc5debf93af04dae$require$Buffer);
    // $FlowIgnore
    if (!$cc5debf93af04dae$require$Buffer.allocUnsafe) $cc5debf93af04dae$require$Buffer.allocUnsafe = function(n) {
        return new $cc5debf93af04dae$require$Buffer(n);
    };
    var $cc5debf93af04dae$var$mdl = 1024, $cc5debf93af04dae$var$mdb = $cc5debf93af04dae$require$Buffer.allocUnsafe($cc5debf93af04dae$var$mdl);
    var $cc5debf93af04dae$var$make_EE = function make_EE(E /*:EMap*/ ) /*:Buffer*/ {
        var EE = $cc5debf93af04dae$require$Buffer.allocUnsafe(65536);
        for(var i = 0; i < 65536; ++i)EE[i] = 0;
        var keys /*:Array<string>*/  = Object.keys(E), len = keys.length;
        for(var ee = 0, e = keys[ee]; ee < len; ++ee){
            if (!(e = keys[ee])) continue;
            EE[e.charCodeAt(0)] = E[e];
        }
        return EE;
    };
    var $cc5debf93af04dae$var$sbcs_encode = function make_sbcs_encode(cp /*:CPIndex*/ ) /*:Encoder*/ {
        var EE /*:Buffer*/  = $cc5debf93af04dae$var$make_EE($cc5debf93af04dae$var$cpt[cp].enc);
        return function sbcs_e(data /*:StrData*/ , ofmt /*:?string*/ ) {
            var len = data.length;
            var out /*:Buffer*/ , i = 0, j = 0, D = 0, w = 0;
            if (typeof data === "string") {
                out = $cc5debf93af04dae$require$Buffer.allocUnsafe(len);
                for(i = 0; i < len; ++i)out[i] = EE[data.charCodeAt(i)];
            } else if (/*:: data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) {
                out = $cc5debf93af04dae$require$Buffer.allocUnsafe(2 * len);
                j = 0;
                for(i = 0; i < len; ++i){
                    D = data[i];
                    if (D < 128) out[j++] = EE[D];
                    else if (D < 224) {
                        out[j++] = EE[((D & 31) << 6) + (data[i + 1] & 63)];
                        ++i;
                    } else if (D < 240) {
                        out[j++] = EE[((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63)];
                        i += 2;
                    } else {
                        w = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
                        i += 3;
                        if (w < 65536) out[j++] = EE[w];
                        else {
                            w -= 65536;
                            out[j++] = EE[0xD800 + (w >> 10 & 1023)];
                            out[j++] = EE[0xDC00 + (w & 1023)];
                        }
                    }
                }
                out = out.slice(0, j);
            } else {
                out = $cc5debf93af04dae$require$Buffer.allocUnsafe(len);
                for(i = 0; i < len; ++i)out[i] = EE[/*::(*/ data[i]/*:: :any)*/ .charCodeAt(0)];
            }
            if (!ofmt || ofmt === "buf") return out;
            if (ofmt !== "arr") return out.toString("binary");
            return [].slice.call(out);
        };
    };
    var $cc5debf93af04dae$var$sbcs_decode = function make_sbcs_decode(cp /*:CPIndex*/ ) /*:Decoder*/ {
        var D /*:DMap*/  = $cc5debf93af04dae$var$cpt[cp].dec;
        var DD = $cc5debf93af04dae$require$Buffer.allocUnsafe(131072), d = 0, c = "";
        for(d = 0; d < D.length; ++d){
            if (!(c = D[d])) continue;
            var w = c.charCodeAt(0);
            DD[2 * d] = w & 255;
            DD[2 * d + 1] = w >> 8;
        }
        return function sbcs_d(data /*:Data*/ ) /*:string*/ {
            var len = data.length, i = 0, j = 0;
            if (2 * len > $cc5debf93af04dae$var$mdl) {
                $cc5debf93af04dae$var$mdl = 2 * len;
                $cc5debf93af04dae$var$mdb = $cc5debf93af04dae$require$Buffer.allocUnsafe($cc5debf93af04dae$var$mdl);
            }
            if (/*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) for(i = 0; i < len; i++){
                j = 2 * data[i];
                $cc5debf93af04dae$var$mdb[2 * i] = DD[j];
                $cc5debf93af04dae$var$mdb[2 * i + 1] = DD[j + 1];
            }
            else if (typeof data === "string") for(i = 0; i < len; i++){
                j = 2 * data.charCodeAt(i);
                $cc5debf93af04dae$var$mdb[2 * i] = DD[j];
                $cc5debf93af04dae$var$mdb[2 * i + 1] = DD[j + 1];
            }
            else for(i = 0; i < len; i++){
                j = 2 * data[i];
                $cc5debf93af04dae$var$mdb[2 * i] = DD[j];
                $cc5debf93af04dae$var$mdb[2 * i + 1] = DD[j + 1];
            }
            return $cc5debf93af04dae$var$mdb.slice(0, 2 * len).toString("ucs2");
        };
    };
    var $cc5debf93af04dae$var$dbcs_encode = function make_dbcs_encode(cp /*:CPIndex*/ ) /*:Encoder*/ {
        var E /*:EMap*/  = $cc5debf93af04dae$var$cpt[cp].enc;
        var EE = $cc5debf93af04dae$require$Buffer.allocUnsafe(131072);
        for(var i = 0; i < 131072; ++i)EE[i] = 0;
        var keys = Object.keys(E);
        for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee){
            if (!(e = keys[ee])) continue;
            var f = e.charCodeAt(0);
            EE[2 * f] = E[e] & 255;
            EE[2 * f + 1] = E[e] >> 8;
        }
        return function dbcs_e(data /*:StrData*/ , ofmt /*:?string*/ ) /*:any*/ {
            var len = data.length, out = $cc5debf93af04dae$require$Buffer.allocUnsafe(2 * len), i = 0, j = 0, jj = 0, k = 0, D = 0;
            if (typeof data === "string") {
                for(i = k = 0; i < len; ++i){
                    j = data.charCodeAt(i) * 2;
                    out[k++] = EE[j + 1] || EE[j];
                    if (EE[j + 1] > 0) out[k++] = EE[j];
                }
                out = out.slice(0, k);
            } else if (/*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) {
                for(i = k = 0; i < len; ++i){
                    D = data[i];
                    if (D < 128) j = D;
                    else if (D < 224) {
                        j = ((D & 31) << 6) + (data[i + 1] & 63);
                        ++i;
                    } else if (D < 240) {
                        j = ((D & 15) << 12) + ((data[i + 1] & 63) << 6) + (data[i + 2] & 63);
                        i += 2;
                    } else {
                        j = ((D & 7) << 18) + ((data[i + 1] & 63) << 12) + ((data[i + 2] & 63) << 6) + (data[i + 3] & 63);
                        i += 3;
                    }
                    if (j < 65536) {
                        j *= 2;
                        out[k++] = EE[j + 1] || EE[j];
                        if (EE[j + 1] > 0) out[k++] = EE[j];
                    } else {
                        jj = j - 65536;
                        j = 2 * (0xD800 + (jj >> 10 & 1023));
                        out[k++] = EE[j + 1] || EE[j];
                        if (EE[j + 1] > 0) out[k++] = EE[j];
                        j = 2 * (0xDC00 + (jj & 1023));
                        out[k++] = EE[j + 1] || EE[j];
                        if (EE[j + 1] > 0) out[k++] = EE[j];
                    }
                }
                out = out.slice(0, k);
            } else for(i = k = 0; i < len; i++){
                j = /*::(*/ data[i]/*:: :any)*/ .charCodeAt(0) * 2;
                out[k++] = EE[j + 1] || EE[j];
                if (EE[j + 1] > 0) out[k++] = EE[j];
            }
            if (!ofmt || ofmt === "buf") return out;
            if (ofmt !== "arr") return out.toString("binary");
            return [].slice.call(out);
        };
    };
    var $cc5debf93af04dae$var$dbcs_decode = function make_dbcs_decode(cp /*:CPIndex*/ ) /*:Decoder*/ {
        var D /*:DMap*/  = $cc5debf93af04dae$var$cpt[cp].dec;
        var DD = $cc5debf93af04dae$require$Buffer.allocUnsafe(131072), d = 0, c, w = 0, j = 0, i = 0;
        for(i = 0; i < 65536; ++i){
            DD[2 * i] = 0xFF;
            DD[2 * i + 1] = 0xFD;
        }
        for(d = 0; d < D.length; ++d){
            if (!(c = D[d])) continue;
            w = c.charCodeAt(0);
            j = 2 * d;
            DD[j] = w & 255;
            DD[j + 1] = w >> 8;
        }
        return function dbcs_d(data /*:Data*/ ) /*:string*/ {
            var len = data.length, out = $cc5debf93af04dae$require$Buffer.allocUnsafe(2 * len), i = 0, j = 0, k = 0;
            if (/*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) for(i = 0; i < len; i++){
                j = 2 * data[i];
                if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                    j = 2 * ((data[i] << 8) + data[i + 1]);
                    ++i;
                }
                out[k++] = DD[j];
                out[k++] = DD[j + 1];
            }
            else if (typeof data === "string") for(i = 0; i < len; i++){
                j = 2 * data.charCodeAt(i);
                if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                    j = 2 * ((data.charCodeAt(i) << 8) + data.charCodeAt(i + 1));
                    ++i;
                }
                out[k++] = DD[j];
                out[k++] = DD[j + 1];
            }
            else for(i = 0; i < len; i++){
                j = 2 * data[i];
                if (DD[j] === 0xFF && DD[j + 1] === 0xFD) {
                    j = 2 * ((data[i] << 8) + data[i + 1]);
                    ++i;
                }
                out[k++] = DD[j];
                out[k++] = DD[j + 1];
            }
            return out.slice(0, k).toString("ucs2");
        };
    };
    $cc5debf93af04dae$var$magic_decode[65001] = function utf8_d(data /*:Data*/ ) /*:string*/ {
        if (typeof data === "string") return utf8_d(data.split("").map($cc5debf93af04dae$var$cca));
        var len = data.length, w = 0, ww = 0;
        if (4 * len > $cc5debf93af04dae$var$mdl) {
            $cc5debf93af04dae$var$mdl = 4 * len;
            $cc5debf93af04dae$var$mdb = $cc5debf93af04dae$require$Buffer.allocUnsafe($cc5debf93af04dae$var$mdl);
        }
        var i = 0;
        if (len >= 3 && data[0] == 0xEF) {
            if (data[1] == 0xBB && data[2] == 0xBF) i = 3;
        }
        for(var j = 1, k = 0, D = 0; i < len; i += j){
            j = 1;
            D = data[i];
            if (D < 128) w = D;
            else if (D < 224) {
                w = (D & 31) * 64 + (data[i + 1] & 63);
                j = 2;
            } else if (D < 240) {
                w = ((D & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
                j = 3;
            } else {
                w = (D & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
                j = 4;
            }
            if (w < 65536) {
                $cc5debf93af04dae$var$mdb[k++] = w & 255;
                $cc5debf93af04dae$var$mdb[k++] = w >> 8;
            } else {
                w -= 65536;
                ww = 0xD800 + (w >> 10 & 1023);
                w = 0xDC00 + (w & 1023);
                $cc5debf93af04dae$var$mdb[k++] = ww & 255;
                $cc5debf93af04dae$var$mdb[k++] = ww >>> 8;
                $cc5debf93af04dae$var$mdb[k++] = w & 255;
                $cc5debf93af04dae$var$mdb[k++] = w >>> 8 & 255;
            }
        }
        return $cc5debf93af04dae$var$mdb.slice(0, k).toString("ucs2");
    };
    $cc5debf93af04dae$var$magic_encode[65001] = function utf8_e(data /*:StrData*/ , ofmt /*:?string*/ ) /*:any*/ {
        if ($cc5debf93af04dae$var$has_buf && /*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) {
            if (!ofmt || ofmt === "buf") return data;
            if (ofmt !== "arr") return data.toString("binary");
            return [].slice.call(data);
        }
        /*::
      // data cannot be a buffer at this point
      if(data instanceof Buffer) throw "";
*/ var len = data.length, w = 0, ww = 0, j = 0;
        var direct = typeof data === "string";
        if (4 * len > $cc5debf93af04dae$var$mdl) {
            $cc5debf93af04dae$var$mdl = 4 * len;
            $cc5debf93af04dae$var$mdb = $cc5debf93af04dae$require$Buffer.allocUnsafe($cc5debf93af04dae$var$mdl);
        }
        for(var i = 0; i < len; ++i){
            w = direct /*::&& typeof data === "string" */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
            if (w <= 0x007F) $cc5debf93af04dae$var$mdb[j++] = w;
            else if (w <= 0x07FF) {
                $cc5debf93af04dae$var$mdb[j++] = 192 + (w >> 6);
                $cc5debf93af04dae$var$mdb[j++] = 128 + (w & 63);
            } else if (w >= 0xD800 && w <= 0xDFFF) {
                w -= 0xD800;
                ++i;
                ww = (direct /*::&& typeof data === "string" */  ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
                $cc5debf93af04dae$var$mdb[j++] = 240 + (ww >>> 18 & 0x07);
                $cc5debf93af04dae$var$mdb[j++] = 144 + (ww >>> 12 & 0x3F);
                $cc5debf93af04dae$var$mdb[j++] = 128 + (ww >>> 6 & 0x3F);
                $cc5debf93af04dae$var$mdb[j++] = 128 + (ww & 0x3F);
            } else {
                $cc5debf93af04dae$var$mdb[j++] = 224 + (w >> 12);
                $cc5debf93af04dae$var$mdb[j++] = 128 + (w >> 6 & 63);
                $cc5debf93af04dae$var$mdb[j++] = 128 + (w & 63);
            }
        }
        if (!ofmt || ofmt === "buf") return $cc5debf93af04dae$var$mdb.slice(0, j);
        if (ofmt !== "arr") return $cc5debf93af04dae$var$mdb.slice(0, j).toString("binary");
        return [].slice.call($cc5debf93af04dae$var$mdb, 0, j);
    };
}
var $cc5debf93af04dae$var$encache = function encache() {
    if ($cc5debf93af04dae$var$has_buf) {
        if ($cc5debf93af04dae$var$cpdcache[$cc5debf93af04dae$var$sbcs_cache[0]]) return;
        var i = 0, s = 0;
        for(i = 0; i < $cc5debf93af04dae$var$sbcs_cache.length; ++i){
            s = $cc5debf93af04dae$var$sbcs_cache[i];
            if ($cc5debf93af04dae$var$cpt[s]) {
                $cc5debf93af04dae$var$cpdcache[s] = $cc5debf93af04dae$var$sbcs_decode(s);
                $cc5debf93af04dae$var$cpecache[s] = $cc5debf93af04dae$var$sbcs_encode(s);
            }
        }
        for(i = 0; i < $cc5debf93af04dae$var$dbcs_cache.length; ++i){
            s = $cc5debf93af04dae$var$dbcs_cache[i];
            if ($cc5debf93af04dae$var$cpt[s]) {
                $cc5debf93af04dae$var$cpdcache[s] = $cc5debf93af04dae$var$dbcs_decode(s);
                $cc5debf93af04dae$var$cpecache[s] = $cc5debf93af04dae$var$dbcs_encode(s);
            }
        }
        for(i = 0; i < $cc5debf93af04dae$var$magic_cache.length; ++i){
            s = $cc5debf93af04dae$var$magic_cache[i];
            if ($cc5debf93af04dae$var$magic_decode[s]) $cc5debf93af04dae$var$cpdcache[s] = $cc5debf93af04dae$var$magic_decode[s];
            if ($cc5debf93af04dae$var$magic_encode[s]) $cc5debf93af04dae$var$cpecache[s] = $cc5debf93af04dae$var$magic_encode[s];
        }
    }
};
var $cc5debf93af04dae$var$null_enc = function(data /*:StrData*/ , ofmt /*:?string*/ ) {
    return "";
};
var $cc5debf93af04dae$var$cp_decache = function cp_decache(cp /*:CPIndex*/ ) /*:void*/ {
    delete $cc5debf93af04dae$var$cpdcache[cp];
    delete $cc5debf93af04dae$var$cpecache[cp];
};
var $cc5debf93af04dae$var$decache = function decache() {
    if ($cc5debf93af04dae$var$has_buf) {
        if (!$cc5debf93af04dae$var$cpdcache[$cc5debf93af04dae$var$sbcs_cache[0]]) return;
        $cc5debf93af04dae$var$sbcs_cache.forEach($cc5debf93af04dae$var$cp_decache);
        $cc5debf93af04dae$var$dbcs_cache.forEach($cc5debf93af04dae$var$cp_decache);
        $cc5debf93af04dae$var$magic_cache.forEach($cc5debf93af04dae$var$cp_decache);
    }
    $cc5debf93af04dae$var$last_enc = $cc5debf93af04dae$var$null_enc;
    $cc5debf93af04dae$var$last_cp = 0;
};
var $cc5debf93af04dae$var$cache = {
    encache: $cc5debf93af04dae$var$encache,
    decache: $cc5debf93af04dae$var$decache,
    sbcs: $cc5debf93af04dae$var$sbcs_cache,
    dbcs: $cc5debf93af04dae$var$dbcs_cache
};
$cc5debf93af04dae$var$encache();
var $cc5debf93af04dae$var$BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $cc5debf93af04dae$var$SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
var $cc5debf93af04dae$var$last_enc /*:Encoder*/  = $cc5debf93af04dae$var$null_enc, $cc5debf93af04dae$var$last_cp /*:CPIndex*/  = 0;
var $cc5debf93af04dae$var$encode = function encode(cp /*:CPIndex*/ , data /*:StrData*/ , ofmt /*:?string*/ ) /*:OutType*/ {
    if (cp === $cc5debf93af04dae$var$last_cp && $cc5debf93af04dae$var$last_enc) return $cc5debf93af04dae$var$last_enc(data, ofmt);
    if ($cc5debf93af04dae$var$cpecache[cp]) {
        $cc5debf93af04dae$var$last_enc = $cc5debf93af04dae$var$cpecache[$cc5debf93af04dae$var$last_cp = cp];
        return $cc5debf93af04dae$var$last_enc(data, ofmt);
    }
    if ($cc5debf93af04dae$var$has_buf && /*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) data = data.toString("utf8");
    /*::
      // data cannot be a buffer at this point
      if(data instanceof Buffer) throw "";
*/ var len = data.length;
    var out = $cc5debf93af04dae$var$has_buf ? $cc5debf93af04dae$require$Buffer.allocUnsafe(4 * len) : [], w = 0, i = 0, j = 0, ww = 0;
    var C /*:CPEntry*/  = $cc5debf93af04dae$var$cpt[cp], E /*:EMap*/ , M /*:string*/  = "";
    var isstr = typeof data === "string";
    if (C && (E = C.enc)) for(i = 0; i < len; ++i, ++j){
        w = E[isstr /*:: && typeof data == 'string' */  ? data.charAt(i) : data[i]];
        if (w > 255) {
            out[j] = w >> 8;
            out[++j] = w & 255;
        } else out[j] = w & 255;
    }
    else if (M = $cc5debf93af04dae$var$magic[cp]) switch(M){
        case "utf8":
            if ($cc5debf93af04dae$var$has_buf && isstr /*:: && typeof data == 'string' */ ) {
                out = $cc5debf93af04dae$var$Buffer_from(data, M);
                j = out.length;
                break;
            }
            for(i = 0; i < len; ++i, ++j){
                w = isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
                if (w <= 0x007F) out[j] = w;
                else if (w <= 0x07FF) {
                    out[j] = 192 + (w >> 6);
                    out[++j] = 128 + (w & 63);
                } else if (w >= 0xD800 && w <= 0xDFFF) {
                    w -= 0xD800;
                    ww = (isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
                    out[j] = 240 + (ww >>> 18 & 0x07);
                    out[++j] = 144 + (ww >>> 12 & 0x3F);
                    out[++j] = 128 + (ww >>> 6 & 0x3F);
                    out[++j] = 128 + (ww & 0x3F);
                } else {
                    out[j] = 224 + (w >> 12);
                    out[++j] = 128 + (w >> 6 & 63);
                    out[++j] = 128 + (w & 63);
                }
            }
            break;
        case "ascii":
            if ($cc5debf93af04dae$var$has_buf && typeof data === "string") {
                out = $cc5debf93af04dae$var$Buffer_from(data, M);
                j = out.length;
                break;
            }
            for(i = 0; i < len; ++i, ++j){
                w = isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
                if (w <= 0x007F) out[j] = w;
                else throw new Error("bad ascii " + w);
            }
            break;
        case "utf16le":
            if ($cc5debf93af04dae$var$has_buf && typeof data === "string") {
                out = $cc5debf93af04dae$var$Buffer_from(data, M);
                j = out.length;
                break;
            }
            for(i = 0; i < len; ++i){
                w = isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
                out[j++] = w & 255;
                out[j++] = w >> 8;
            }
            break;
        case "utf16be":
            for(i = 0; i < len; ++i){
                w = isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
                out[j++] = w >> 8;
                out[j++] = w & 255;
            }
            break;
        case "utf32le":
            for(i = 0; i < len; ++i){
                w = isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
                if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
                out[j++] = w & 255;
                w >>= 8;
                out[j++] = w & 255;
                w >>= 8;
                out[j++] = w & 255;
                w >>= 8;
                out[j++] = w & 255;
            }
            break;
        case "utf32be":
            for(i = 0; i < len; ++i){
                w = isstr /*:: && typeof data == 'string' */  ? data.charCodeAt(i) : data[i].charCodeAt(0);
                if (w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + (w - 0xD800 << 10) + (data[++i].charCodeAt(0) - 0xDC00);
                out[j + 3] = w & 255;
                w >>= 8;
                out[j + 2] = w & 255;
                w >>= 8;
                out[j + 1] = w & 255;
                w >>= 8;
                out[j] = w & 255;
                j += 4;
            }
            break;
        case "utf7":
            for(i = 0; i < len; i++){
                /*::
      // data cannot be a buffer at this point
      if(data instanceof Buffer) throw "";
*/ var c /*:string*/  = isstr /*:: && typeof data == 'string' */  ? data.charAt(i) : data[i].charAt(0);
                if (c === "+") {
                    out[j++] = 0x2b;
                    out[j++] = 0x2d;
                    continue;
                }
                if ($cc5debf93af04dae$var$SetD.indexOf(c) > -1) {
                    out[j++] = c.charCodeAt(0);
                    continue;
                }
                var tt = encode(1201, c);
                out[j++] = 0x2b;
                out[j++] = $cc5debf93af04dae$var$BM.charCodeAt(tt[0] >> 2);
                out[j++] = $cc5debf93af04dae$var$BM.charCodeAt(((tt[0] & 0x03) << 4) + ((tt[1] || 0) >> 4));
                out[j++] = $cc5debf93af04dae$var$BM.charCodeAt(((tt[1] & 0x0F) << 2) + ((tt[2] || 0) >> 6));
                out[j++] = 0x2d;
            }
            break;
        default:
            throw new Error("Unsupported magic: " + cp + " " + $cc5debf93af04dae$var$magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    out = out.slice(0, j);
    if (!$cc5debf93af04dae$var$has_buf) return ofmt == "str" ? out /*:any*/ .map($cc5debf93af04dae$var$sfcc).join("") : out;
    if (!ofmt || ofmt === "buf") return out;
    if (ofmt !== "arr") return /*::((*/ out /*:: :any) :Buffer)*/ .toString("binary");
    return [].slice.call(out);
};
var $cc5debf93af04dae$var$decode = function decode(cp /*:CPIndex*/ , data /*:Data*/ ) /*:string*/ {
    var F /*:Decoder*/ ;
    if (F = $cc5debf93af04dae$var$cpdcache[cp]) return F(data);
    if (typeof data === "string") return decode(cp, data.split("").map($cc5debf93af04dae$var$cca));
    var len = data.length, out = new Array(len), s = "", w = 0, i = 0, j = 1, k = 0, ww = 0;
    var C /*:CPEntry*/  = $cc5debf93af04dae$var$cpt[cp], D /*:DMap*/ , M = "";
    if (C && (D = C.dec)) for(i = 0; i < len; i += j){
        j = 2;
        s = D[(data[i] << 8) + data[i + 1]];
        if (!s) {
            j = 1;
            s = D[data[i]];
        }
        if (!s) throw new Error("Unrecognized code: " + data[i] + " " + data[i + j - 1] + " " + i + " " + j + " " + D[data[i]]);
        out[k++] = s;
    }
    else if (M = $cc5debf93af04dae$var$magic[cp]) switch(M){
        case "utf8":
            if (len >= 3 && data[0] == 0xEF) {
                if (data[1] == 0xBB && data[2] == 0xBF) i = 3;
            }
            for(; i < len; i += j){
                j = 1;
                if (data[i] < 128) w = data[i];
                else if (data[i] < 224) {
                    w = (data[i] & 31) * 64 + (data[i + 1] & 63);
                    j = 2;
                } else if (data[i] < 240) {
                    w = ((data[i] & 15) << 12) + (data[i + 1] & 63) * 64 + (data[i + 2] & 63);
                    j = 3;
                } else {
                    w = (data[i] & 7) * 262144 + ((data[i + 1] & 63) << 12) + (data[i + 2] & 63) * 64 + (data[i + 3] & 63);
                    j = 4;
                }
                if (w < 65536) out[k++] = String.fromCharCode(w);
                else {
                    w -= 65536;
                    ww = 0xD800 + (w >> 10 & 1023);
                    w = 0xDC00 + (w & 1023);
                    out[k++] = String.fromCharCode(ww);
                    out[k++] = String.fromCharCode(w);
                }
            }
            break;
        case "ascii":
            if ($cc5debf93af04dae$var$has_buf && /*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) return data.toString(M);
            for(i = 0; i < len; i++)out[i] = String.fromCharCode(data[i]);
            k = len;
            break;
        case "utf16le":
            if (len >= 2 && data[0] == 0xFF) {
                if (data[1] == 0xFE) i = 2;
            }
            if ($cc5debf93af04dae$var$has_buf && /*::data instanceof Buffer && */ $cc5debf93af04dae$require$Buffer.isBuffer(data)) return data.toString(M);
            j = 2;
            for(; i + 1 < len; i += j)out[k++] = String.fromCharCode((data[i + 1] << 8) + data[i]);
            break;
        case "utf16be":
            if (len >= 2 && data[0] == 0xFE) {
                if (data[1] == 0xFF) i = 2;
            }
            j = 2;
            for(; i + 1 < len; i += j)out[k++] = String.fromCharCode((data[i] << 8) + data[i + 1]);
            break;
        case "utf32le":
            if (len >= 4 && data[0] == 0xFF) {
                if (data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
            }
            j = 4;
            for(; i < len; i += j){
                w = (data[i + 3] << 24) + (data[i + 2] << 16) + (data[i + 1] << 8) + data[i];
                if (w > 0xFFFF) {
                    w -= 0x10000;
                    out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
                    out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
                } else out[k++] = String.fromCharCode(w);
            }
            break;
        case "utf32be":
            if (len >= 4 && data[3] == 0xFF) {
                if (data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
            }
            j = 4;
            for(; i < len; i += j){
                w = (data[i] << 24) + (data[i + 1] << 16) + (data[i + 2] << 8) + data[i + 3];
                if (w > 0xFFFF) {
                    w -= 0x10000;
                    out[k++] = String.fromCharCode(0xD800 + (w >> 10 & 0x3FF));
                    out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
                } else out[k++] = String.fromCharCode(w);
            }
            break;
        case "utf7":
            if (len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
                if (len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
                else if (data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
            }
            for(; i < len; i += j){
                if (data[i] !== 0x2b) {
                    j = 1;
                    out[k++] = String.fromCharCode(data[i]);
                    continue;
                }
                j = 1;
                if (data[i + 1] === 0x2d) {
                    j = 2;
                    out[k++] = "+";
                    continue;
                }
                // eslint-disable-next-line no-useless-escape
                while(String.fromCharCode(data[i + j]).match(/[A-Za-z0-9+\/]/))j++;
                var dash = 0;
                if (data[i + j] === 0x2d) {
                    ++j;
                    dash = 1;
                }
                var tt = [];
                var o64 = "";
                var c1 = 0, c2 = 0, c3 = 0;
                var e1 = 0, e2 = 0, e3 = 0, e4 = 0;
                for(var l = 1; l < j - dash;){
                    e1 = $cc5debf93af04dae$var$BM.indexOf(String.fromCharCode(data[i + l++]));
                    e2 = $cc5debf93af04dae$var$BM.indexOf(String.fromCharCode(data[i + l++]));
                    c1 = e1 << 2 | e2 >> 4;
                    tt.push(c1);
                    e3 = $cc5debf93af04dae$var$BM.indexOf(String.fromCharCode(data[i + l++]));
                    if (e3 === -1) break;
                    c2 = (e2 & 15) << 4 | e3 >> 2;
                    tt.push(c2);
                    e4 = $cc5debf93af04dae$var$BM.indexOf(String.fromCharCode(data[i + l++]));
                    if (e4 === -1) break;
                    c3 = (e3 & 3) << 6 | e4;
                    if (e4 < 64) tt.push(c3);
                }
                o64 = decode(1201, tt);
                for(l = 0; l < o64.length; ++l)out[k++] = o64.charAt(l);
            }
            break;
        default:
            throw new Error("Unsupported magic: " + cp + " " + $cc5debf93af04dae$var$magic[cp]);
    }
    else throw new Error("Unrecognized CP: " + cp);
    return out.slice(0, k).join("");
};
var $cc5debf93af04dae$var$hascp = function hascp(cp /*:number*/ ) /*:boolean*/ {
    return !!($cc5debf93af04dae$var$cpt[cp] || $cc5debf93af04dae$var$magic[cp]);
};
const $cc5debf93af04dae$export$eab97d15b1788b8d = {
    decode: $cc5debf93af04dae$var$decode,
    encode: $cc5debf93af04dae$var$encode,
    hascp: $cc5debf93af04dae$var$hascp,
    magic: $cc5debf93af04dae$var$magic,
    cache: $cc5debf93af04dae$var$cache
};


(0, $a1a91b25d7598376$export$58f247d16f363b86)($cc5debf93af04dae$exports);
function $9acad1ca7ba10f0a$export$2e2bcd8739ae039() {
    const [fileList, setFileList] = (0, $7fPBF.useState)([]);
    (0, $7fPBF.useEffect)(async ()=>{
        if (fileList.length > 0) {
            // TODO parallelise this for multiple files
            const promises = Array.from(fileList).map((file)=>file.arrayBuffer());
            Promise.all(promises).then((results)=>{
                results.forEach((item)=>{
                    const fileRead = (0, $a1a91b25d7598376$export$aafa59e2e03f2942)(item, {
                        raw: true,
                        codepage: 65001
                    }); // handle locale-specific things in ColumnMatcher
                    console.log("fileRead", fileRead.Sheets);
                    console.log("results", (0, $a1a91b25d7598376$export$eab97d15b1788b8d).sheet_to_json(fileRead.Sheets[fileRead.SheetNames[0]], {
                        header: 1
                    }));
                });
            });
        }
    }, [
        fileList
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: "loaded"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex text-sm text-gray-600 p-10",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                    htmlFor: "file-upload",
                    className: "relative cursor-pointer bg-gray-50 rounded-md font-medium text-brandBlue-500 hover:text-brandBlue-400",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: "Upload a file"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            id: "file-upload",
                            name: "file-upload",
                            type: "file",
                            className: "sr-only",
                            onChange: (e)=>setFileList(e.target.files)
                        })
                    ]
                })
            })
        ]
    });
}


/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ /* This example requires Tailwind CSS v2.0+ */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ecc4fe7bc6f465a6$var$InformationCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $ecc4fe7bc6f465a6$var$ForwardRef = $7fPBF.forwardRef($ecc4fe7bc6f465a6$var$InformationCircleIcon);
var $ecc4fe7bc6f465a6$export$2e2bcd8739ae039 = $ecc4fe7bc6f465a6$var$ForwardRef;



function $ee486cb89111f160$export$8d8dc7d5f743331b({ messageObject: messageObject, show: show, handleClose: handleClose }) {
    $ee486cb89111f160$export$8d8dc7d5f743331b.propTypes = {
        messageObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        show: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    };
    $ee486cb89111f160$export$8d8dc7d5f743331b.defaultProps = {
        messageObject: {
            message: null
        },
        show: true,
        handleClose: undefined
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("messages");
    const { message: message, extraMessage: extraMessage } = messageObject;
    const isToast = handleClose !== undefined;
    const messageTexts = t(message, {
        returnObjects: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "w-full flex flex-col items-center space-y-4 sm:items-end",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
            show: show,
            as: (0, $7fPBF.Fragment),
            enter: "transform ease-out duration-300 transition",
            enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
            enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
            leave: "transition ease-in duration-100",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "message",
                className: `max-w-sm w-full bg-white pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden ${isToast ? "shadow-lg rounded-lg" : ""}`,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "p-4",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex-shrink-0",
                                children: [
                                    message && messageTexts.type === "success" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba764ef5f1eed305$export$2e2bcd8739ae039), {
                                        className: "h-7 w-7 text-green-500",
                                        "aria-hidden": "true"
                                    }),
                                    message && messageTexts.type === "warning" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $086a7dd8f9408309$export$2e2bcd8739ae039), {
                                        className: "h-7 w-7 text-yellow-400",
                                        "aria-hidden": "true"
                                    }),
                                    message && messageTexts.type === "error" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6513e2ba1b6537f6$export$2e2bcd8739ae039), {
                                        className: "h-7 w-7 text-brandRed-500",
                                        "aria-hidden": "true"
                                    }),
                                    message && messageTexts.type === "info" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                        className: "h-7 w-7 text-brandBlue-500",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-base ml-3 w-0 flex-1 pt-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "font-medium text-gray-900",
                                        children: messageTexts.header
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-1 text-gray-500",
                                        children: messageTexts.body || message
                                    }),
                                    extraMessage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-1 text-gray-400",
                                        children: extraMessage
                                    })
                                ]
                            }),
                            handleClose && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "ml-4 flex-shrink-0 flex",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    type: "button",
                                    className: "bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                                    onClick: handleClose,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "sr-only",
                                            children: "Close"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
function $ee486cb89111f160$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("messages");
    const [show, setShow] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const currentMessage = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.message);
    const messages = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.messages) || [];
    // message is { message: <string>, extraMessage: <string> }; message is a string found in i18n.messages, extraMessage is a string passed in the action (usually error message)
    const stackedMessageObject = messages.at(-1);
    const messageObject = (stackedMessageObject === null || stackedMessageObject === void 0 ? void 0 : stackedMessageObject.message) === currentMessage ? stackedMessageObject : {
        message: currentMessage
    };
    // const thereIsAMessage = messages && messages.length > 0;
    function handleClose() {
        setShow(false);
        setTimeout(()=>{
            // After 500 ms (so that the user does not see null before the fade-out animation is ready) reset message value (kept for backward compatibility)
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)(null));
        }, 500);
    }
    // make the message disappear after a few seconds
    (0, $7fPBF.useEffect)(()=>{
        // let timeId;
        // let timeDisappear;
        // if this is an error, keep the message longer
        const timeToTimeout = t(`${messageObject === null || messageObject === void 0 ? void 0 : messageObject.message}.type`) === "error" ? 10000 : 5000;
        // if (thereIsAMessage) {
        setShow(true);
        const timeDisappear = setTimeout(()=>{
            // first set the show value to false - this will trigger the fade-out animation
            setShow(false);
        }, timeToTimeout - 500);
        const timeId = setTimeout(()=>{
            // then reset the message in state to not display an empty component
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)(null));
        }, timeToTimeout);
        // }
        return ()=>{
            clearTimeout(timeId);
            clearTimeout(timeDisappear);
        };
    }, [
        messages,
        currentMessage
    ]);
    // handle initial state (no messages) - do not render anything
    if (!currentMessage) return true;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            "aria-live": "assertive",
            className: "fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-[9999]",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ee486cb89111f160$export$8d8dc7d5f743331b, {
                messageObject: messageObject,
                show: show,
                handleClose: handleClose
            })
        })
    });
}


/* eslint-disable no-promise-executor-return */ /* eslint-disable no-param-reassign */ 

var $7fPBF = parcelRequire("7fPBF");









/* eslint-disable no-nested-ternary */ /* eslint-disable import/no-cycle */ /* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


parcelRequire("gSkQi");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $5fdae6729b4c77e7$var$NAMED_DATE_KEYS = new Set([
    "current",
    "baseline",
    "referenceBaseline"
]);
function $5fdae6729b4c77e7$var$toNumericDate(date) {
    if (typeof date === "number" && Number.isFinite(date)) return date;
    if (typeof date === "string" && /^\d+$/.test(date)) return Number(date);
    return null;
}
function $5fdae6729b4c77e7$var$isNamedDate(date) {
    return $5fdae6729b4c77e7$var$NAMED_DATE_KEYS.has(String(date));
}
function $5fdae6729b4c77e7$var$getNamedRequiredDates(state) {
    const { baseline: baseline, referenceBaseline: referenceBaseline, current: current } = (0, $93bb2798871a68d2$export$4bb039911f93bce)(state);
    return (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)([
        baseline,
        referenceBaseline,
        current
    ]);
}
// Normalize global quote rows into canonical map shape: global[assetId][date] = row.
function $5fdae6729b4c77e7$var$normalizeGlobalRows(rows = []) {
    return (rows || []).reduce((acc, quote)=>{
        if (!(quote === null || quote === void 0 ? void 0 : quote.assetId)) return acc;
        if ($5fdae6729b4c77e7$var$isNamedDate(quote.date)) return acc;
        const numericDate = $5fdae6729b4c77e7$var$toNumericDate(quote.date);
        if (numericDate === null) return acc;
        if (!acc[quote.assetId]) acc[quote.assetId] = {};
        acc[quote.assetId][numericDate] = (0, $2qxEV._)((0, $9tqwB._)({}, quote), {
            date: numericDate
        });
        return acc;
    }, {});
}
// Normalize isolated quote rows into canonical map shape: isolated[projectId][assetId][date] = row.
function $5fdae6729b4c77e7$var$normalizeIsolatedRows(rows = []) {
    return (rows || []).reduce((acc, quote)=>{
        if (!(quote === null || quote === void 0 ? void 0 : quote.projectId) || !(quote === null || quote === void 0 ? void 0 : quote.assetId)) return acc;
        if ($5fdae6729b4c77e7$var$isNamedDate(quote.date)) return acc;
        const numericDate = $5fdae6729b4c77e7$var$toNumericDate(quote.date);
        if (numericDate === null) return acc;
        if (!acc[quote.projectId]) acc[quote.projectId] = {};
        if (!acc[quote.projectId][quote.assetId]) acc[quote.projectId][quote.assetId] = {};
        acc[quote.projectId][quote.assetId][numericDate] = (0, $2qxEV._)((0, $9tqwB._)({}, quote), {
            date: numericDate
        });
        return acc;
    }, {});
}
function $5fdae6729b4c77e7$var$flattenGlobalMap(globalMap = {}) {
    return Object.entries(globalMap).flatMap(([assetId, dates])=>Object.entries(dates || {}).map(([date, quote])=>(0, $2qxEV._)((0, $9tqwB._)({}, quote), {
                assetId: assetId,
                date: $5fdae6729b4c77e7$var$toNumericDate(date) || quote.date
            })));
}
function $5fdae6729b4c77e7$var$flattenIsolatedMap(isolatedMap = {}) {
    return Object.entries(isolatedMap).flatMap(([projectId, assets])=>Object.entries(assets || {}).flatMap(([assetId, dates])=>Object.entries(dates || {}).map(([date, quote])=>(0, $2qxEV._)((0, $9tqwB._)({}, quote), {
                    projectId: projectId,
                    assetId: assetId,
                    date: $5fdae6729b4c77e7$var$toNumericDate(date) || quote.date
                }))));
}
function $5fdae6729b4c77e7$var$normalizeGlobalPartition(partition) {
    if (Array.isArray(partition)) return $5fdae6729b4c77e7$var$normalizeGlobalRows(partition);
    if (partition && typeof partition === "object") return $5fdae6729b4c77e7$var$normalizeGlobalRows($5fdae6729b4c77e7$var$flattenGlobalMap(partition));
    return {};
}
function $5fdae6729b4c77e7$var$normalizeIsolatedPartition(partition) {
    if (Array.isArray(partition)) return $5fdae6729b4c77e7$var$normalizeIsolatedRows(partition);
    if (partition && typeof partition === "object") return $5fdae6729b4c77e7$var$normalizeIsolatedRows($5fdae6729b4c77e7$var$flattenIsolatedMap(partition));
    return {};
}
function $5fdae6729b4c77e7$var$mergeGlobalRows(globalState, rows = []) {
    rows.forEach((quote)=>{
        const numericDate = $5fdae6729b4c77e7$var$toNumericDate(quote === null || quote === void 0 ? void 0 : quote.date);
        if (!(quote === null || quote === void 0 ? void 0 : quote.assetId) || numericDate === null || $5fdae6729b4c77e7$var$isNamedDate(quote.date)) return;
        if (!globalState[quote.assetId]) globalState[quote.assetId] = {};
        globalState[quote.assetId][numericDate] = (0, $2qxEV._)((0, $9tqwB._)({}, quote), {
            date: numericDate
        });
    });
}
function $5fdae6729b4c77e7$var$replaceGlobalPartitions(globalState, requestedAssets = []) {
    const requestedAssetIds = [
        ...new Set((requestedAssets || []).map((asset)=>asset === null || asset === void 0 ? void 0 : asset.assetId).filter(Boolean))
    ];
    requestedAssetIds.forEach((assetId)=>{
        delete globalState[assetId];
    });
}
function $5fdae6729b4c77e7$var$mergeIsolatedRows(isolatedState, rows = []) {
    rows.forEach((quote)=>{
        const numericDate = $5fdae6729b4c77e7$var$toNumericDate(quote === null || quote === void 0 ? void 0 : quote.date);
        if (!(quote === null || quote === void 0 ? void 0 : quote.projectId) || !(quote === null || quote === void 0 ? void 0 : quote.assetId) || numericDate === null || $5fdae6729b4c77e7$var$isNamedDate(quote.date)) return;
        if (!isolatedState[quote.projectId]) isolatedState[quote.projectId] = {};
        if (!isolatedState[quote.projectId][quote.assetId]) isolatedState[quote.projectId][quote.assetId] = {};
        isolatedState[quote.projectId][quote.assetId][numericDate] = (0, $2qxEV._)((0, $9tqwB._)({}, quote), {
            date: numericDate
        });
    });
}
function $5fdae6729b4c77e7$var$deleteGlobalQuote(globalState, assetId, date) {
    if (!(globalState === null || globalState === void 0 ? void 0 : globalState[assetId])) return;
    delete globalState[assetId][date];
    if (Object.keys(globalState[assetId]).length === 0) delete globalState[assetId];
}
function $5fdae6729b4c77e7$var$deleteIsolatedQuote(isolatedState, projectId, assetId, date) {
    var _isolatedState_projectId;
    if (!(isolatedState === null || isolatedState === void 0 ? void 0 : (_isolatedState_projectId = isolatedState[projectId]) === null || _isolatedState_projectId === void 0 ? void 0 : _isolatedState_projectId[assetId])) return;
    delete isolatedState[projectId][assetId][date];
    if (Object.keys(isolatedState[projectId][assetId]).length === 0) delete isolatedState[projectId][assetId];
    if (Object.keys(isolatedState[projectId]).length === 0) delete isolatedState[projectId];
}
const $5fdae6729b4c77e7$var$initialState = {
    global: {},
    isolated: {},
    // Keep basic sync metadata in slice for future scoped refresh bookkeeping.
    meta: {
        schemaVersion: 2,
        lastGlobalSyncAt: null,
        lastIsolatedSyncAt: null,
        lastScopes: {}
    }
};
async function $5fdae6729b4c77e7$export$a4a871b2b150f352(body) {
    const headers = await (0, $10933498be24bbfd$export$3fa04bebf37c9013)({
        "Content-Type": "application/json"
    });
    const myInit = {
        headers: headers
    };
    if (body !== undefined) myInit.body = body;
    return myInit;
}
const $5fdae6729b4c77e7$export$c6fa390c7be98ae9 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("quotes/putQuotes", async ({ body: body, category: category, accountId: accountId }, { dispatch: dispatch, getState: getState })=>{
    var _state_data_category, _state_data;
    const payload = await $5fdae6729b4c77e7$export$a4a871b2b150f352(body);
    const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/put", payload);
    const state = getState();
    const requiredDates = $5fdae6729b4c77e7$var$getNamedRequiredDates(state);
    const getQuotesScope = (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
        transactions: (((_state_data = state.data) === null || _state_data === void 0 ? void 0 : (_state_data_category = _state_data[category]) === null || _state_data_category === void 0 ? void 0 : _state_data_category.transactions) || []).filter((t)=>t.accountId === accountId),
        requiredDates: requiredDates
    });
    await dispatch((0, $b38588f9e2856d34$export$2e2bcd8739ae039)({
        scopes: getQuotesScope
    })); // wait for getQuotes to finish
    return response.quotes;
});
const $5fdae6729b4c77e7$export$94d4ced2a464cebd = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("quotes/putOrDeleteQuotes", async ({ arrayOfQuotes: arrayOfQuotes, accountId: accountId }, { dispatch: dispatch, getState: getState })=>{
    const allDistinctIncomingDates = [
        ...new Set(arrayOfQuotes.map((q)=>q.date))
    ];
    const allDistinctIncomingAssetIds = [
        ...new Set(arrayOfQuotes.map((q)=>q.assetId))
    ];
    const earliestQuoteDate = Math.min(...arrayOfQuotes.map((q)=>q.date)); // Math.min requires a comma-separated list of arguments
    const putItems = arrayOfQuotes.filter((q)=>q.importFlag !== "delete");
    const payloadPut = await $5fdae6729b4c77e7$export$a4a871b2b150f352(putItems);
    const deleteItems = arrayOfQuotes.filter((q)=>q.importFlag === "delete");
    const payloadDelete = await $5fdae6729b4c77e7$export$a4a871b2b150f352(deleteItems);
    const promises = [];
    if (putItems.length > 0) promises.push((0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/put", payloadPut));
    if (deleteItems.length > 0) promises.push((0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/delete", payloadDelete));
    await Promise.all(promises);
    const state = getState();
    // we have changed some quotes above, so we need to run getQuotes to refresh them in state
    // select all assetIds in the transactions, and if we are only doing that for an account, filter by that account
    // in addition, only get dates which happen after the earliest quote date (so that we don't have to refresh the entire past where nothing has changed)
    // we try to find out the transactions so that we know which dates and assetIds / providerAssetIds / currencies to get quotes for
    const transactionsInScope = (0, $3679aa7475d9bd44$export$cff1b0a315c5dec8)(state).filter((t)=>(accountId ? t.accountId === accountId : true) && t.date >= earliestQuoteDate && t.category !== "deposits");
    // FIXME this doesn't seem to be the most efficient way of doing this
    // there are cases when there are no transactions after the earliestQuoteDate (e.g. when adding realEstate valuation)
    // to handle this, fetch all assetId-date pairs for the assetIds for which we are updating the quotes
    if (accountId && transactionsInScope.length === 0) {
        const accountTransactions = (0, $3679aa7475d9bd44$export$cff1b0a315c5dec8)(state).filter((t)=>allDistinctIncomingAssetIds.includes(t.assetId));
        if (accountTransactions.length > 0) transactionsInScope.push(...accountTransactions);
    }
    const requiredDates = (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)($5fdae6729b4c77e7$var$getNamedRequiredDates(state).concat(allDistinctIncomingDates));
    const transactionScopes = (0, $780d46a2914a2b26$export$6ba18aedc42d9a39)({
        transactions: transactionsInScope,
        requiredDates: requiredDates
    });
    // remove deleted items from store immediately (async refresh below will repopulate)
    if (deleteItems.length > 0) dispatch({
        type: "quotes/removeQuotes",
        payload: deleteItems
    });
    // Handle manual/non-transaction assets by adding explicit fallback scopes for incoming assetIds.
    const existingAssetIds = new Set(transactionScopes.map((scope)=>{
        var _scope_asset;
        return scope === null || scope === void 0 ? void 0 : (_scope_asset = scope.asset) === null || _scope_asset === void 0 ? void 0 : _scope_asset.assetId;
    }).filter(Boolean));
    const fallbackFromDate = requiredDates.length > 0 ? Math.min(...requiredDates) : earliestQuoteDate;
    const fallbackToDate = requiredDates.length > 0 ? Math.max(...requiredDates) : earliestQuoteDate;
    const fallbackScopes = allDistinctIncomingAssetIds.filter((assetId)=>!!assetId && !existingAssetIds.has(assetId)).map((assetId)=>{
        const incomingQuote = arrayOfQuotes.find((quote)=>quote.assetId === assetId);
        return {
            asset: (0, $9tqwB._)({
                assetId: assetId,
                providerAssetId: null
            }, (incomingQuote === null || incomingQuote === void 0 ? void 0 : incomingQuote.currency) ? {
                currency: incomingQuote.currency
            } : {}),
            fromDate: fallbackFromDate,
            toDate: fallbackToDate,
            requiredDates: requiredDates.length > 0 ? requiredDates : [
                fallbackToDate
            ],
            includeManualQuotes: true
        };
    });
    const scopes = (0, $780d46a2914a2b26$export$81e0abc8b4acfa8a)(transactionScopes.concat(fallbackScopes));
    await dispatch((0, $b38588f9e2856d34$export$2e2bcd8739ae039)({
        scopes: scopes
    }));
    return arrayOfQuotes;
});
const $5fdae6729b4c77e7$var$quotesSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "quotes",
    initialState: $5fdae6729b4c77e7$var$initialState,
    reducers: {
        removeQuotes (state, action) {
            const toDelete = action.payload || [];
            if (!toDelete.length) return;
            // Remove by nested path; if projectId is omitted keep legacy behavior and remove matching global + isolated entries.
            toDelete.forEach((quote)=>{
                const numericDate = $5fdae6729b4c77e7$var$toNumericDate(quote === null || quote === void 0 ? void 0 : quote.date);
                if (!(quote === null || quote === void 0 ? void 0 : quote.assetId) || numericDate === null) return;
                if (quote.projectId) {
                    $5fdae6729b4c77e7$var$deleteIsolatedQuote(state.isolated, quote.projectId, quote.assetId, numericDate);
                    return;
                }
                $5fdae6729b4c77e7$var$deleteGlobalQuote(state.global, quote.assetId, numericDate);
                Object.keys(state.isolated || {}).forEach((projectId)=>{
                    $5fdae6729b4c77e7$var$deleteIsolatedQuote(state.isolated, projectId, quote.assetId, numericDate);
                });
            });
        },
        hydrate (state, action) {
            const incoming = action.payload || {};
            var _incoming_global, _incoming_isolated;
            // Hydration migration: accept legacy arrays or nested maps and normalize to canonical nested state.
            return (0, $2qxEV._)((0, $9tqwB._)({}, state, incoming), {
                global: $5fdae6729b4c77e7$var$normalizeGlobalPartition((_incoming_global = incoming.global) !== null && _incoming_global !== void 0 ? _incoming_global : state.global),
                isolated: $5fdae6729b4c77e7$var$normalizeIsolatedPartition((_incoming_isolated = incoming.isolated) !== null && _incoming_isolated !== void 0 ? _incoming_isolated : state.isolated),
                meta: (0, $2qxEV._)((0, $9tqwB._)({}, state.meta, incoming.meta || {}), {
                    schemaVersion: 2
                })
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase((0, $b38588f9e2856d34$export$2e2bcd8739ae039).fulfilled, function getQuotesFulfilledCallback(state, action) {
            var _action_payload, _action_payload1, _action_payload_request, _action_payload2, _action_payload_request_scopes, _action_payload_request1, _action_payload3, _action_meta_arg, _action_meta, _action_meta_arg_scopes, _action_meta_arg1, _action_meta1, _action_payload_meta, _action_payload4;
            if (!action.payload || ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.status) === "error") return;
            const rows = Array.isArray(action.payload) ? action.payload : Array.isArray((_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.rows) ? action.payload.rows : [];
            const requestAssets = ((_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : (_action_payload_request = _action_payload2.request) === null || _action_payload_request === void 0 ? void 0 : _action_payload_request.assets) || ((_action_payload3 = action.payload) === null || _action_payload3 === void 0 ? void 0 : (_action_payload_request1 = _action_payload3.request) === null || _action_payload_request1 === void 0 ? void 0 : (_action_payload_request_scopes = _action_payload_request1.scopes) === null || _action_payload_request_scopes === void 0 ? void 0 : _action_payload_request_scopes.map((scope)=>scope === null || scope === void 0 ? void 0 : scope.asset).filter(Boolean)) || ((_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : (_action_meta_arg = _action_meta.arg) === null || _action_meta_arg === void 0 ? void 0 : _action_meta_arg.assets) || ((_action_meta1 = action.meta) === null || _action_meta1 === void 0 ? void 0 : (_action_meta_arg1 = _action_meta1.arg) === null || _action_meta_arg1 === void 0 ? void 0 : (_action_meta_arg_scopes = _action_meta_arg1.scopes) === null || _action_meta_arg_scopes === void 0 ? void 0 : _action_meta_arg_scopes.map((scope)=>scope === null || scope === void 0 ? void 0 : scope.asset).filter(Boolean)) || [];
            const shouldReplacePartitions = Boolean((_action_payload4 = action.payload) === null || _action_payload4 === void 0 ? void 0 : (_action_payload_meta = _action_payload4.meta) === null || _action_payload_meta === void 0 ? void 0 : _action_payload_meta.isBootstrapCall);
            if (shouldReplacePartitions) // Bootstrap refresh replaces full per-asset partitions so stale hydrated rows are removed.
            $5fdae6729b4c77e7$var$replaceGlobalPartitions(state.global, requestAssets);
            if (rows.length > 0) // Persist only canonical numeric rows; named baseline/current aliases are derived in selectors.
            $5fdae6729b4c77e7$var$mergeGlobalRows(state.global, rows);
            if (shouldReplacePartitions || rows.length > 0) state.meta.lastGlobalSyncAt = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf();
        }).addCase((0, $b38588f9e2856d34$export$b3c9df64177c4614).fulfilled, function getIsolatedQuotesFulfilledCallback(state, action) {
            var _action_payload, _action_payload1, _action_payload_meta, _action_payload2;
            if (!action.payload || ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.status) === "error") return;
            const rows = Array.isArray(action.payload) ? action.payload : Array.isArray((_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.rows) ? action.payload.rows : [];
            const shouldReplaceAllIsolated = Boolean((_action_payload2 = action.payload) === null || _action_payload2 === void 0 ? void 0 : (_action_payload_meta = _action_payload2.meta) === null || _action_payload_meta === void 0 ? void 0 : _action_payload_meta.isBootstrapCall);
            if (shouldReplaceAllIsolated) // Isolated bootstrap refresh is authoritative for all projects; clear stale isolated rows first.
            state.isolated = {};
            if (rows.length > 0) $5fdae6729b4c77e7$var$mergeIsolatedRows(state.isolated, rows);
            if (shouldReplaceAllIsolated || rows.length > 0) state.meta.lastIsolatedSyncAt = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf();
        });
    }
});
var $5fdae6729b4c77e7$export$2e2bcd8739ae039 = $5fdae6729b4c77e7$var$quotesSlice.reducer;



/* eslint-disable max-len */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
// take transaction object and clone it, changing the 'date' field beginning at fromDate, ending at toDate, and incrementing by interval + intervalType (1 'month')
function $d35cafa685a59c6c$var$cloneTransaction({ fromDate: fromDate, toDate: toDate, transaction: transaction, interval: interval = 12, intervalType: intervalType = "month" }) {
    if (!fromDate || !toDate || !transaction) throw new Error("cloneTransaction: missing arguments");
    const clonedTransaction = (0, $9tqwB._)({}, transaction);
    const clonedTransactions = [];
    let date = fromDate;
    while(date.isBefore(toDate)){
        clonedTransaction.id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
        clonedTransaction.date = date.startOf("day").valueOf();
        clonedTransactions.push((0, $9tqwB._)({}, clonedTransaction));
        date = date.add(interval, intervalType);
    }
    return clonedTransactions;
}
function $d35cafa685a59c6c$export$2e2bcd8739ae039(t) {
    // const t = i18n.t.bind(i18n);
    // putting the template objects here, so that the t function can be applied
    // template accounts
    const stockAccount = {
        category: "stocks",
        subcategory: null,
        statusTimestamp: null,
        syncType: null,
        ownCurrentAccount: null,
        connectedDepositAccounts: null,
        accountNo: "",
        username: "",
        name: "DUMMY ACCOUNT",
        brokerName: "",
        id: null,
        tags: null,
        importFileMappings: null
    };
    const depositAccount = {
        category: "deposits",
        bankName: "My Demo Bank",
        name: "DUMMY",
        iban: "DE49201304000055555551",
        bic: "ABCDEFGHIJ",
        currency: "EUR",
        syncType: "manual",
        depositType: "savings-account",
        tags: null,
        importFileMappings: null,
        countryCode: "DE"
    };
    const realEstateAccount = {
        category: "realEstate",
        connectedDepositAccounts: null,
        lastMarketPriceRetrieved: null,
        statusTimestamp: null,
        status: null,
        currency: "EUR",
        name: "DUMMY property",
        id: null,
        tags: {
            growthRate: 3.2
        },
        valuationParameters: {
            garage: false,
            constructionYear: null,
            lotArea: null,
            rooms: 5,
            livingArea: 100,
            countryCode: "DE",
            city: "Bielefeld",
            zip: "33602",
            streetAddress: "",
            type: "apartment"
        }
    };
    const depositTransaction = {
        category: "deposits",
        id: null,
        accountId: null,
        date: new Date(),
        otherParty: t("otherParty"),
        otherPartyAccount: null,
        description: "DUMMY",
        amount: 1000.5,
        currency: "EUR",
        accountCurrencyAmount: 1000.5,
        fxAmount: null,
        fxCurrency: null,
        batchId: null,
        linkedTransactions: [],
        isSimulated: false,
        isIsolated: false,
        isManuallyAdjusted: false,
        projectId: null,
        parentId: null,
        errorId: null,
        importFlag: null,
        label: null,
        tags: {
            assetId: null,
            accountId: null,
            indexed: null,
            recurring: null,
            type: null
        },
        sortingOrderWithinMonth: null,
        importFileMappings: null
    };
    const stocksTransaction = {
        category: "stocks",
        sortingOrderWithinMonth: null,
        importFlag: "post",
        tags: {
            indexed: null
        },
        projectId: null,
        rebasedAmountSoldWhenSimulated: null,
        rebasedAmountSold: null,
        transactionAmountSold: null,
        errorId: null,
        isManuallyAdjusted: false,
        isIsolated: false,
        isSimulated: false,
        linkedTransactions: [],
        rebasedOriginalPrice: null,
        rebasedPrice: null,
        transactionType: "purchase",
        rebasedAmount: null,
        transactionPrice: null,
        transactionOriginalPrice: 89.32,
        transactionCurrency: "EUR",
        transactionAmount: 20,
        splitRatioNew: null,
        splitRatioOld: null,
        displayName: "DE12345",
        displaySymbol: "DE12345",
        providerAssetId: null,
        figi: null,
        date: 1688169600000,
        id: "piFWNgHTjNOl2tydBHCMV",
        accountId: "DUMMYstockAccount0001",
        currency: "EUR"
    };
    const realEstateTransaction = {
        category: "realEstate",
        tags: {
            indexed: null,
            recurring: null,
            type: null
        },
        sortingOrderWithinMonth: null,
        importFlag: "post",
        projectId: null,
        isIsolated: false,
        isSimulated: false,
        linkedTransactions: [],
        valid: true,
        transactionType: "purchase",
        currency: "EUR",
        price: 500000,
        originalPrice: 500000,
        amount: 1,
        date: 1661388800000,
        accountId: null,
        id: undefined,
        errorId: null
    };
    const date0 = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc();
    const depositAccount0Id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const depositAccount1Id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const depositAccount2Id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const stockAccount1Id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const realEstateAccount1Id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const aaplDepositSide = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const tslaDepositSide = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const realEstateDepositSide = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const project0 = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    return {
        accounts: [
            (0, $2qxEV._)((0, $9tqwB._)({}, depositAccount), {
                id: depositAccount0Id,
                name: t("account0"),
                iban: "DE49201304000055550001"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositAccount), {
                id: depositAccount1Id,
                name: t("account1"),
                iban: "DE68500105178297336485"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositAccount), {
                id: depositAccount2Id,
                name: t("account2"),
                iban: "DE88500105176414922794",
                depositType: "savings-account"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, stockAccount), {
                id: stockAccount1Id,
                name: t("account3"),
                connectedDepositAccounts: [
                    depositAccount1Id
                ]
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, realEstateAccount), {
                id: realEstateAccount1Id,
                name: t("account4"),
                connectedDepositAccounts: [
                    depositAccount0Id
                ]
            })
        ],
        transactions: [
            // stocks account goes first, we need to update quotes
            (0, $2qxEV._)((0, $9tqwB._)({}, stocksTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: stockAccount1Id,
                transactionOriginalPrice: 150,
                transactionCurrency: "USD",
                currency: "USD",
                date: date0.subtract(19, "months").startOf("day").valueOf(),
                transactionAmount: 10,
                displayName: "Apple Inc.",
                displaySymbol: "US0378331005",
                linkedTransactions: [
                    {
                        id: aaplDepositSide,
                        category: "deposits",
                        tags: {
                            type: "buy",
                            linkType: "purchase-to-transaction"
                        }
                    }
                ]
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, stocksTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: stockAccount1Id,
                transactionOriginalPrice: 200,
                transactionCurrency: "USD",
                currency: "USD",
                date: date0.subtract(18, "months").startOf("day").valueOf(),
                transactionAmount: 10,
                displayName: "Tesla",
                displaySymbol: "US88160R1014",
                linkedTransactions: [
                    {
                        id: tslaDepositSide,
                        category: "deposits",
                        tags: {
                            type: "buy",
                            linkType: "purchase-to-transaction"
                        }
                    }
                ]
            }),
            // brokerage bank account
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("initialSaldo"),
                amount: 50000,
                accountCurrencyAmount: 50000,
                accountId: depositAccount1Id,
                date: date0.subtract(40, "months").startOf().valueOf()
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: aaplDepositSide,
                description: t("purchaseAppleStock"),
                amount: null,
                accountCurrencyAmount: null,
                fxCurrency: "USD",
                fxAmount: undefined,
                accountId: depositAccount1Id,
                date: date0.subtract(19, "months").startOf("day").valueOf(),
                label: "investment-purchase"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("transactionFees"),
                amount: -9.9,
                accountCurrencyAmount: -9.9,
                accountId: depositAccount1Id,
                date: date0.subtract(19, "months").startOf("day").valueOf(),
                label: "investment-fees",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction.tags), {
                    assetId: "AAPL",
                    accountId: stockAccount1Id
                })
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: tslaDepositSide,
                description: t("purchaseTeslaStock"),
                amount: null,
                accountCurrencyAmount: null,
                fxCurrency: "USD",
                fxAmount: undefined,
                accountId: depositAccount1Id,
                date: date0.subtract(18, "months").startOf("day").valueOf(),
                label: "investment-purchase"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("transactionFees"),
                amount: -9.9,
                accountCurrencyAmount: -9.9,
                accountId: depositAccount1Id,
                date: date0.subtract(18, "months").startOf("day").valueOf(),
                label: "investment-fees",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction.tags), {
                    assetId: "TSLA",
                    accountId: stockAccount1Id
                })
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("accountRunningCost"),
                amount: -19.9,
                accountCurrencyAmount: -19.9,
                accountId: depositAccount1Id,
                date: date0.subtract(16, "months").startOf("month").valueOf(),
                label: "investment-costs",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction.tags), {
                    assetId: stockAccount1Id,
                    accountId: stockAccount1Id
                })
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("accountRunningCost"),
                amount: -19.9,
                accountCurrencyAmount: -19.9,
                accountId: depositAccount1Id,
                date: date0.subtract(4, "months").startOf("month").valueOf(),
                label: "investment-costs",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction.tags), {
                    assetId: stockAccount1Id,
                    accountId: stockAccount1Id
                })
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("dividendAppleStock"),
                amount: 25.3,
                accountCurrencyAmount: 25.3,
                fxAmount: 27.2,
                fxCurrency: "USD",
                accountId: depositAccount1Id,
                date: date0.subtract(13, "months").startOf("month").valueOf(),
                label: "investment-dividend",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction.tags), {
                    assetId: "AAPL",
                    accountId: stockAccount1Id
                })
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("dividendAppleStock"),
                amount: 25.3,
                accountCurrencyAmount: 25.3,
                fxAmount: 27.2,
                fxCurrency: "USD",
                accountId: depositAccount1Id,
                date: date0.subtract(1, "months").startOf("month").valueOf(),
                label: "investment-dividend",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction.tags), {
                    assetId: "TESL",
                    accountId: stockAccount1Id
                })
            }),
            // my bank account - historical transactions
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("initialSaldo"),
                amount: 20000,
                accountCurrencyAmount: 20000,
                accountId: depositAccount0Id,
                date: date0.subtract(48, "months").startOf("day").valueOf()
            }),
            // *** if using cloneTransaction, put all transactions that will be updated by the calling component before them, as they need to be updated by index in this array ***
            ...$d35cafa685a59c6c$var$cloneTransaction({
                fromDate: date0.subtract(2, "years"),
                toDate: date0,
                transaction: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                    description: t("salary"),
                    amount: 7500,
                    accountCurrencyAmount: 7500,
                    accountId: depositAccount0Id
                }),
                interval: 1
            }),
            ...$d35cafa685a59c6c$var$cloneTransaction({
                fromDate: date0.subtract(2, "years").add(5, "day"),
                toDate: date0,
                transaction: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                    description: t("rentPayment"),
                    amount: -1500,
                    accountCurrencyAmount: -1500,
                    accountId: depositAccount0Id
                }),
                interval: 1
            }),
            ...$d35cafa685a59c6c$var$cloneTransaction({
                fromDate: date0.subtract(2, "years").add(10, "day"),
                toDate: date0,
                transaction: (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                    description: t("creditCardBill"),
                    amount: -2500,
                    accountCurrencyAmount: -2500,
                    accountId: depositAccount0Id
                }),
                interval: 1
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("carRental"),
                amount: 1250,
                accountCurrencyAmount: 1250,
                fxAmount: 1380,
                fxCurrency: "CHF",
                accountId: depositAccount0Id,
                date: date0.subtract(13, "months").startOf("day").valueOf()
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("hotelBill"),
                amount: 1500,
                accountCurrencyAmount: 1500,
                fxAmount: 1550,
                fxCurrency: "CHF",
                accountId: depositAccount0Id,
                date: date0.subtract(13, "months").add(10, "days").startOf("day").valueOf()
            }),
            // my bank account - simulated transactions
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("salary"),
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "month").startOf("month").valueOf(),
                amount: 7500,
                accountCurrencyAmount: 7500,
                accountId: depositAccount0Id,
                isSimulated: true,
                projectId: project0,
                tags: {
                    indexed: null,
                    recurring: {
                        endAfterDate: 1686823434489,
                        endAfterOccurrences: 48,
                        end: "recurringByOccurrence",
                        periodType: {
                            id: "month",
                            name: "months"
                        },
                        numberOfPeriods: 1,
                        activated: true
                    },
                    type: "inflow",
                    accountId: null,
                    assetId: null,
                    indexing: {
                        activated: true,
                        mode: "indexedByCustomRate",
                        customRateInput: "2"
                    }
                },
                transactionType: "inflow"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "month").startOf("month").valueOf(),
                description: t("rentPayment"),
                amount: -1500,
                accountCurrencyAmount: -1500,
                accountId: depositAccount0Id,
                isSimulated: true,
                projectId: project0,
                tags: {
                    indexed: null,
                    recurring: {
                        endAfterDate: 1686823434489,
                        endAfterOccurrences: 48,
                        end: "recurringByOccurrence",
                        periodType: {
                            id: "month",
                            name: "months"
                        },
                        numberOfPeriods: 1,
                        activated: true
                    },
                    type: "outflow",
                    accountId: null,
                    assetId: null,
                    indexing: {
                        activated: true,
                        mode: "indexedByCustomRate",
                        customRateInput: "2"
                    }
                },
                transactionType: "outflow"
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "month").startOf("month").valueOf(),
                description: t("creditCardBill"),
                amount: -2500,
                accountCurrencyAmount: -2500,
                accountId: depositAccount0Id,
                isSimulated: true,
                projectId: project0,
                tags: {
                    indexed: null,
                    recurring: {
                        endAfterDate: 1686823434489,
                        endAfterOccurrences: 48,
                        end: "recurringByOccurrence",
                        periodType: {
                            id: "month",
                            name: "months"
                        },
                        numberOfPeriods: 1,
                        activated: true
                    },
                    type: "outflow",
                    accountId: null,
                    assetId: null,
                    indexing: {
                        activated: true,
                        mode: "indexedByCustomRate",
                        customRateInput: "2"
                    }
                },
                transactionType: "outflow"
            }),
            // savings account
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("initialSaldo"),
                amount: 100000,
                accountCurrencyAmount: 100000,
                accountId: depositAccount2Id,
                date: date0.subtract(46, "months").startOf("day").valueOf()
            }),
            (0, $2qxEV._)((0, $9tqwB._)({}, depositTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                description: t("interestPayment"),
                amount: 120,
                accountCurrencyAmount: 120,
                accountId: depositAccount2Id,
                date: date0.subtract(3, "months").startOf("day").valueOf(),
                label: "investment-interest"
            }),
            // real estate account
            //
            (0, $2qxEV._)((0, $9tqwB._)({}, realEstateTransaction), {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: realEstateAccount1Id,
                date: date0.subtract(7, "years").startOf("day").valueOf(),
                linkedTransactions: [
                    {
                        id: realEstateDepositSide,
                        category: "deposits",
                        tags: {
                            type: "buy",
                            linkType: "purchase-to-transaction"
                        }
                    }
                ],
                price: 500000,
                originalPrice: 500000
            })
        ],
        // CAUTION: quotes are hardcoded to realEstate in Prep for now
        quotes: [
            {
                assetId: realEstateAccount1Id,
                date: date0.subtract(5, "years").startOf("day").valueOf(),
                quote: 540000,
                currency: "EUR",
                quoteBaseCurrency: 540000
            },
            {
                assetId: realEstateAccount1Id,
                date: date0.subtract(3, "years").startOf("day").valueOf(),
                quote: 565000,
                currency: "EUR",
                quoteBaseCurrency: 565000
            },
            {
                assetId: realEstateAccount1Id,
                date: date0.subtract(1, "years").startOf("day").valueOf(),
                quote: 582000,
                currency: "EUR",
                quoteBaseCurrency: 582000
            }
        ],
        projects: [
            {
                id: project0,
                name: t("project0"),
                settings: {
                    progressIndicator: "roi",
                    currency: "EUR",
                    isIsolated: false
                },
                comments: []
            }
        ]
    };
}



const $796298027c39e19e$var$debugLevel = 3;

(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
async function $796298027c39e19e$export$c4476faa626d31c(dispatch, navigate, t, i18n, promisesManagedByParent, rGetQuotes, postCallsDone) {
    var _rGetQuotes_payload_find, _rGetQuotes_payload, _rGetQuotes_payload_find1, _rGetQuotes_payload1;
    const cancelSignal = false; // TODO remove it from here once the component is stable
    if ($796298027c39e19e$var$debugLevel > 2) console.log("seedDemoData: starting");
    // run a few API calls via axios to seed the demo data
    const aaplDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().subtract(19, "months").startOf("day").valueOf();
    const tslaDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().subtract(18, "months").startOf("day").valueOf();
    if ($796298027c39e19e$var$debugLevel > 2) console.log("seedDemoData: dispatching quotes");
    // eslint-disable-next-line no-param-reassign
    rGetQuotes = await dispatch((0, $b38588f9e2856d34$export$2e2bcd8739ae039)({
        scopes: [
            {
                asset: {
                    providerAssetId: "AAPL",
                    assetId: "dummyAAAPPPPLLL",
                    currency: "USD",
                    category: "stocks"
                },
                fromDate: aaplDate,
                toDate: aaplDate,
                requiredDates: [
                    aaplDate
                ],
                includeManualQuotes: true
            },
            {
                asset: {
                    providerAssetId: "TSLA",
                    assetId: "dummyTTSSSSLLAA",
                    currency: "USD",
                    category: "stocks"
                },
                fromDate: tslaDate,
                toDate: tslaDate,
                requiredDates: [
                    tslaDate
                ],
                includeManualQuotes: true
            }
        ]
    }));
    const AAPL = rGetQuotes === null || rGetQuotes === void 0 ? void 0 : (_rGetQuotes_payload = rGetQuotes.payload) === null || _rGetQuotes_payload === void 0 ? void 0 : (_rGetQuotes_payload_find = _rGetQuotes_payload.find((q)=>q.assetId === "dummyAAAPPPPLLL" && String(q.date) === String(aaplDate))) === null || _rGetQuotes_payload_find === void 0 ? void 0 : _rGetQuotes_payload_find.quote;
    // TSLA was split, so the original price needs to be multiplied by 3 (FMP returns rebased quotes only)
    // eslint-disable-next-line no-unsafe-optional-chaining
    const TSLA = (rGetQuotes === null || rGetQuotes === void 0 ? void 0 : (_rGetQuotes_payload1 = rGetQuotes.payload) === null || _rGetQuotes_payload1 === void 0 ? void 0 : (_rGetQuotes_payload_find1 = _rGetQuotes_payload1.find((q)=>q.assetId === "dummyTTSSSSLLAA" && String(q.date) === String(tslaDate))) === null || _rGetQuotes_payload_find1 === void 0 ? void 0 : _rGetQuotes_payload_find1.quote) * 3;
    const payload = (0, $d35cafa685a59c6c$export$2e2bcd8739ae039)(t); // pass the translation function to have labels translated
    // get quotes from API and set prices in both stocks and deposit transactions
    // stocks
    payload.transactions[0].transactionOriginalPrice = AAPL;
    payload.transactions[1].transactionOriginalPrice = TSLA;
    // deposits
    payload.transactions[3].fxAmount = AAPL * payload.transactions[0].transactionAmount;
    payload.transactions[5].fxAmount = TSLA * payload.transactions[1].transactionAmount;
    // useEffect cleanup sets aborted to true
    // my guess is that when useEffect is executed, all promises land in the macrotask queue at the time of execution
    // when StrictMode re-mounts this component, getQuotes above are running (and are being aborted as planned), but all promises below have been queued and are not running yet
    // eslint-disable-next-line no-param-reassign
    promisesManagedByParent = [];
    if (!cancelSignal.aborted) {
        if (!postCallsDone.current[0]) {
            payload.accounts.forEach((a)=>{
                // validate accounts with schema
                const schema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(a.category, "account");
                try {
                    const validationResult = schema.validateSync(a);
                } catch (e) {
                    console.error("error when validating schema for", a, e);
                }
                if (!cancelSignal.aborted) promisesManagedByParent.push(dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                    category: a.category,
                    data: a,
                    cancelSignal: cancelSignal
                })));
                if ($796298027c39e19e$var$debugLevel > 2) console.log("starting dispatch postAccount for", a, "aborted is", JSON.stringify(cancelSignal));
            });
            // create all accounts first
            const response1 = await Promise.allSettled(promisesManagedByParent);
            // if any of the promises failed, log the error
            response1.forEach((r)=>{
                // response is the RTK output object; if it has error property, it means the promise was rejected
                if (r.error) console.error("error in account promise", JSON.stringify(r.error, null, 2));
            });
            // mark accounts post calls as done
            postCallsDone.current[0] = true;
        }
        // validate transactions with schema
        payload.transactions.forEach((x)=>{
            const schema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(x.category, "transaction");
            try {
                const validationResult = schema.validateSync(x);
            } catch (e) {
                console.error("error when validating schema for", x, e);
            }
        });
        // reset promises array from parent if the thing hasn't been cancelled and if this post has not been done during a previous render
        // eslint-disable-next-line no-param-reassign
        promisesManagedByParent = [];
        if (!postCallsDone.current[1]) {
            if (!cancelSignal.aborted) promisesManagedByParent.push(dispatch((0, $f2037232653a5c1d$export$942e92bd9e040eb)(payload.transactions)));
            if ($796298027c39e19e$var$debugLevel > 2) console.log("starting dispatch postAccount for postMixedData", "aborted is", JSON.stringify(cancelSignal));
            // vv this will only work if quotes are realEstate
            if (!cancelSignal.aborted) promisesManagedByParent.push(dispatch((0, $5fdae6729b4c77e7$export$c6fa390c7be98ae9)({
                body: payload.quotes,
                category: "realEstate",
                accountId: payload.quotes[0].assetId
            })));
            // mark transactions post calls as done
            postCallsDone.current[1] = true;
        }
        if (!postCallsDone.current[2]) {
            if ($796298027c39e19e$var$debugLevel > 2) console.log("starting dispatch postAccount for projects", "aborted is", JSON.stringify(cancelSignal), "postCallsDone[2]", JSON.stringify(postCallsDone.current[2]));
            if (!cancelSignal.aborted && !postCallsDone.current[2]) payload.projects.forEach((p)=>promisesManagedByParent.push(dispatch((0, $101425bdfe5b6af9$export$757a8a8481b26284)(p))));
            if ($796298027c39e19e$var$debugLevel > 2) console.log("starting dispatch postAccount for projects", "aborted is", JSON.stringify(cancelSignal));
            // mark projects post calls as done
            postCallsDone.current[2] = true;
        }
        const response2 = await Promise.allSettled(promisesManagedByParent);
        // if any of the promises failed, log the error
        response2.forEach((r)=>{
            if (r.error) console.log("error in transaction / quote promise", JSON.stringify(r.error, null, 2));
        });
    }
}
function $796298027c39e19e$export$2e2bcd8739ae039() {
    // upon initialising it should run a 5 second timer and redirect to /app/dashboard
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ], {
        keyPrefix: "register.prep"
    });
    const [showContent, setShowContent] = (0, $7fPBF.useState)(false); // so that it does not show content before decision on whether to show this component or not has been taken
    // (federated signIn and signUp only can forward to /getready, not directly to /app/)
    // refs hold values across renders and do not trigger re-renders (state changes do)
    const postCallsDone = (0, $7fPBF.useRef)([
        false,
        false,
        false
    ]); // accounts, transactions, projects (quotes we need to repeat before each posts anyway)
    const seedDemoDataIsRunning = (0, $7fPBF.useRef)(false);
    const userRef = (0, $7fPBF.useRef)(null);
    // get user to component state first (so that it does not cause duplications due to uncancelled promises when re-rendering this component)
    (0, $7fPBF.useEffect)(()=>{
        async function setUser() {
            const user = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
                forceRefresh: true
            });
            userRef.current = user;
            const selectToursSeen = user.attributes["custom:tours_seen"] && JSON.parse(user.attributes["custom:tours_seen"]);
            if (selectToursSeen && selectToursSeen.length > 0) navigate(`/${i18n.language}/app/dashboard`);
            else setShowContent(true);
            if ($796298027c39e19e$var$debugLevel > 2) console.log("Prep: user retrieved successfully");
        }
        if (!userRef.current) setUser();
    }, []);
    // when user is updated in component state, run seedDemoData
    // make sure only one copy of seedDemoData runs at the same time, as they are POST calls
    // postCallsDone stores the status of the needed POST calls, so that they are not repeated
    (0, $7fPBF.useEffect)(()=>{
        let rGetQuotes;
        const promises = [];
        // only execute if user is set, because we need to know if the user has seen any tours
        // (if not, then this is a first-time user and we need to get data)
        if (userRef.current) {
            // declare API calls here, so that we may cancel them from the useEffect cleanup
            const selectToursSeen = userRef.current.attributes["custom:tours_seen"] && JSON.parse(userRef.current.attributes["custom:tours_seen"]);
            if ($796298027c39e19e$var$debugLevel > 2) console.log("Prep: selectToursSeen", selectToursSeen);
            if (!selectToursSeen || selectToursSeen.length === 0) {
                // if seedDemoData is running (triggered by an earlier render), wait for it to finish
                while(seedDemoDataIsRunning.current)// eslint-disable-next-line no-await-in-loop
                new Promise((resolve)=>setTimeout(resolve, 333)).then(()=>console.log("Prep: waiting for seedDemoData to be free"));
                // if seedDemoData is not running (triggered by an earlier render), start it
                if (!seedDemoDataIsRunning.current) {
                    seedDemoDataIsRunning.current = true;
                    $796298027c39e19e$export$c4476faa626d31c(dispatch, navigate, t, i18n, promises, rGetQuotes, postCallsDone).then(()=>{
                        if ($796298027c39e19e$var$debugLevel > 2) console.info("Prep > seedDemoData: finished without errors, moving on to Dashboard");
                        navigate(`/${i18n.language}/app/dashboard`);
                    }, (e)=>{
                        console.error("Error: Prep > seedDemoData", e);
                        if ($796298027c39e19e$var$debugLevel > 2) console.info("Prep > seedDemoData: errors caught, moving on to Dashboard");
                        navigate(`/${i18n.language}/app/dashboard`);
                    });
                    seedDemoDataIsRunning.current = false;
                }
            }
        }
        // cleanup / abort sequence
        // ATTENTION: this cleanup callback is created on the first render; it will hold on to the variables from that first render (including state!)
        // the only way to pass "current" variables is to "tunnel" them through a ref
        return ()=>{
            if ($796298027c39e19e$var$debugLevel > 2) console.log("Prep: cleanup started, resetting seedDemoDataIsRunning");
            seedDemoDataIsRunning.current = false;
            if (typeof rGetQuotes === "function") rGetQuotes.abort();
            // isAbortedRef.current = { aborted: true };
            promises.forEach((p)=>{
                const pr = promises.pop();
                if (typeof pr === "function") pr.abort();
            });
        };
    }, [
        userRef.current
    ]);
    return showContent ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "relative bg-white",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "mx-auto lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "px-6 pb-24 pt-10 sm:pb-32 lg:col-span-7 lg:px-0 lg:pb-56 lg:pt-60 lg:pl-24 lg:min-h-screen xl:pt-80 xl:col-span-6",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mx-auto max-w-2xl lg:mx-0",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                className: "mt-24 text-4xl font-bold tracking-tight text-gray-900 sm:mt-10 sm:text-6xl",
                                children: t("header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-6 text-lg leading-6 text-gray-600",
                                children: t("body")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-8 flex items-center gap-x-6",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                    className: "w-8 h-8 text-gray-300 animate-spin"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "relative lg:col-span-5 lg:-mr-8 xl:absolute xl:inset-0 xl:left-1/2 xl:mr-0",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto lg:h-full",
                        src: "https://images.unsplash.com/photo-1498758536662-35b82cd15e29?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2102&q=80",
                        alt: ""
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
}


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");











(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $227577e82c4e93d6$var$QuestionComponent({ fieldName: fieldName, control: control }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "requestDemo"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
        name: fieldName,
        control: control,
        defaultValue: "",
        render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-full p-4 border border-gray-300 rounded-md shadow-sm",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex flex-col justify-start",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-center",
                            children: t(`${fieldName}.label`)
                        }),
                        t(`${fieldName}.sublabel`) !== `requestDemo.${fieldName}.sublabel` && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-center text-sm text-gray-500 italic mt-2",
                            children: t(`${fieldName}.sublabel`)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "mt-4 flex flex-row gap-2 flex-wrap justify-center",
                            children: (t(`${fieldName}.options`, {
                                returnObjects: true
                            }) || []).map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    // eslint-disable-next-line max-len
                                    className: `rounded ${field.value === option ? "bg-brandBlue-100" : "bg-white hover:bg-gray-50"} px-2 py-1 text-sm font-normal text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 `,
                                    onClick: ()=>{
                                        // setSelectedOption(option);
                                        field.onChange(option);
                                    },
                                    children: option
                                }, option))
                        })
                    ]
                })
            })
    });
}
$227577e82c4e93d6$var$QuestionComponent.propTypes = {
    fieldName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
function $227577e82c4e93d6$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "requestDemo"
    });
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { handleSubmit: handleSubmit, register: register, control: control, formState: { errors: errors } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        // this is the equivalent of switching off the "remember me" option, which would save stuff in local storage instead
        (0, $10933498be24bbfd$export$27e497d6b00ea18a)(sessionStorage);
    }, []);
    function checkNanoid(value) {
        const combinedRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).*$/;
        // Return true if the expression matches the combined regular expression, otherwise return false
        return combinedRegex.test(value);
    }
    async function onSubmit(formData) {
        setIsLoading(true);
        // sign user out (in case signed)
        await (0, $bc3cbcb8cbfbe7ae$export$b0ac3a1c242cb1ea)({
            global: true
        });
        // generate nanoid
        let username;
        do username = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
        while (!checkNanoid(username));
        // register demo account
        let response;
        try {
            response = await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", "customer/demo", {
                body: {
                    userId: username,
                    surveyData: (0, $9tqwB._)({
                        timestamp: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()
                    }, formData)
                }
            });
            if (response) {
                await (0, $134afd9bfa803edb$export$9670d83f11d4b64a)({
                    username: username,
                    password: username
                });
                navigate(`/${i18n.language}/app/getready`);
            }
        } catch (error) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
        }
    }
    if (isLoading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "w-full h-[85vh] relative max-w-7xl mx-auto",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "w-full h-full flex justify-center items-center text-2xl animate-pulse text-gray-500 font-bold",
            children: t("pleaseWaitWhileWeAreSettingThingsUp")
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "relative max-w-7xl mx-auto",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "text-base font-semibold text-brandBlue-600 tracking-wide uppercase",
                            children: t("topheader")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-1 text-4xl font-black text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl",
                            children: t("Ready to set up your demo")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "max-w-xl mt-5 mx-auto text-xl text-gray-500",
                            children: t("header1")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "max-w-xl mx-auto text-xl text-gray-500",
                            children: t("header2")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-12 grid md:grid-cols-2 gap-4 justify-items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($227577e82c4e93d6$var$QuestionComponent, {
                            fieldName: "numberOfAccounts",
                            control: control
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($227577e82c4e93d6$var$QuestionComponent, {
                            fieldName: "incomeSaved",
                            control: control
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($227577e82c4e93d6$var$QuestionComponent, {
                            fieldName: "age",
                            control: control
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($227577e82c4e93d6$var$QuestionComponent, {
                            fieldName: "workplace",
                            control: control
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "w-full p-4 border border-gray-300 rounded-md shadow-sm md:col-span-2",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col justify-start",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-center",
                                        children: t("howCanWeHelp.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                        type: "text",
                                        autoComplete: "off",
                                        className: "mt-4 rounded-md border border-gray-300 shadow-sm focus:ring-brandBlue-500 focus:border-brandBlue-500 block w-full h-24 md:h-12 sm:text-sm"
                                    }, register("howCanWeHelp")))
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 flex space-x-4 justify-end",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "rounded-md bg-white px-3.5 py-2.5 text-sm font-normal text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
                            children: t("Cancel")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: handleSubmit(onSubmit),
                            // eslint-disable-next-line max-len
                            className: "rounded-md bg-brandBlue-500 px-3.5 py-2.5 text-sm font-normal text-white shadow-sm hover:bg-brandBlue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500",
                            children: t("Start demo")
                        })
                    ]
                })
            ]
        })
    });
}




var $7fPBF = parcelRequire("7fPBF");



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $5578ec1dc18d671c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $411d94524a9cdc1d$export$a143d493d941bafc;
var $411d94524a9cdc1d$export$e4cf37d7f6fb9e0a;
var $411d94524a9cdc1d$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $411d94524a9cdc1d$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
var $c10879e6d2766179$exports = {};
var $c10879e6d2766179$var$toString = {}.toString;
$c10879e6d2766179$exports = Array.isArray || function(arr) {
    return $c10879e6d2766179$var$toString.call(arr) == "[object Array]";
};


$411d94524a9cdc1d$export$a143d493d941bafc = $411d94524a9cdc1d$var$Buffer;
$411d94524a9cdc1d$export$e4cf37d7f6fb9e0a = $411d94524a9cdc1d$var$SlowBuffer;
$411d94524a9cdc1d$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $411d94524a9cdc1d$var$typedArraySupport();
$411d94524a9cdc1d$export$599f31c3813fae4d = $411d94524a9cdc1d$var$kMaxLength();
function $411d94524a9cdc1d$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $411d94524a9cdc1d$var$kMaxLength() {
    return $411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $411d94524a9cdc1d$var$createBuffer(that, length) {
    if ($411d94524a9cdc1d$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $411d94524a9cdc1d$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $411d94524a9cdc1d$var$Buffer(arg, encodingOrOffset, length) {
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $411d94524a9cdc1d$var$Buffer)) return new $411d94524a9cdc1d$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $411d94524a9cdc1d$var$allocUnsafe(this, arg);
    }
    return $411d94524a9cdc1d$var$from(this, arg, encodingOrOffset, length);
}
$411d94524a9cdc1d$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$411d94524a9cdc1d$var$Buffer._augment = function(arr) {
    arr.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    return arr;
};
function $411d94524a9cdc1d$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $411d94524a9cdc1d$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $411d94524a9cdc1d$var$fromString(that, value, encodingOrOffset);
    return $411d94524a9cdc1d$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $411d94524a9cdc1d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $411d94524a9cdc1d$var$from(null, value, encodingOrOffset, length);
};
if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $411d94524a9cdc1d$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $411d94524a9cdc1d$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $411d94524a9cdc1d$var$Buffer[Symbol.species] === $411d94524a9cdc1d$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($411d94524a9cdc1d$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $411d94524a9cdc1d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $411d94524a9cdc1d$var$alloc(that, size, fill, encoding) {
    $411d94524a9cdc1d$var$assertSize(size);
    if (size <= 0) return $411d94524a9cdc1d$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $411d94524a9cdc1d$var$createBuffer(that, size).fill(fill, encoding) : $411d94524a9cdc1d$var$createBuffer(that, size).fill(fill);
    return $411d94524a9cdc1d$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $411d94524a9cdc1d$var$Buffer.alloc = function(size, fill, encoding) {
    return $411d94524a9cdc1d$var$alloc(null, size, fill, encoding);
};
function $411d94524a9cdc1d$var$allocUnsafe(that, size) {
    $411d94524a9cdc1d$var$assertSize(size);
    that = $411d94524a9cdc1d$var$createBuffer(that, size < 0 ? 0 : $411d94524a9cdc1d$var$checked(size) | 0);
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $411d94524a9cdc1d$var$Buffer.allocUnsafe = function(size) {
    return $411d94524a9cdc1d$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $411d94524a9cdc1d$var$Buffer.allocUnsafeSlow = function(size) {
    return $411d94524a9cdc1d$var$allocUnsafe(null, size);
};
function $411d94524a9cdc1d$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$411d94524a9cdc1d$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $411d94524a9cdc1d$var$byteLength(string, encoding) | 0;
    that = $411d94524a9cdc1d$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $411d94524a9cdc1d$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $411d94524a9cdc1d$var$checked(array.length) | 0;
    that = $411d94524a9cdc1d$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $411d94524a9cdc1d$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $411d94524a9cdc1d$var$fromArrayLike(that, array);
    return that;
}
function $411d94524a9cdc1d$var$fromObject(that, obj) {
    if ($411d94524a9cdc1d$var$Buffer.isBuffer(obj)) {
        var len = $411d94524a9cdc1d$var$checked(obj.length) | 0;
        that = $411d94524a9cdc1d$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $411d94524a9cdc1d$var$isnan(obj.length)) return $411d94524a9cdc1d$var$createBuffer(that, 0);
            return $411d94524a9cdc1d$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $c10879e6d2766179$exports(obj.data)) return $411d94524a9cdc1d$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $411d94524a9cdc1d$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $411d94524a9cdc1d$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $411d94524a9cdc1d$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $411d94524a9cdc1d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $411d94524a9cdc1d$var$Buffer.alloc(+length);
}
$411d94524a9cdc1d$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$411d94524a9cdc1d$var$Buffer.compare = function compare(a, b) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(a) || !$411d94524a9cdc1d$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$411d94524a9cdc1d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$411d94524a9cdc1d$var$Buffer.concat = function concat(list, length) {
    if (!$c10879e6d2766179$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $411d94524a9cdc1d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $411d94524a9cdc1d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$411d94524a9cdc1d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $411d94524a9cdc1d$var$byteLength(string, encoding) {
    if ($411d94524a9cdc1d$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $411d94524a9cdc1d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $411d94524a9cdc1d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $411d94524a9cdc1d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$411d94524a9cdc1d$var$Buffer.byteLength = $411d94524a9cdc1d$var$byteLength;
function $411d94524a9cdc1d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $411d94524a9cdc1d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $411d94524a9cdc1d$var$utf8Slice(this, start, end);
        case "ascii":
            return $411d94524a9cdc1d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $411d94524a9cdc1d$var$latin1Slice(this, start, end);
        case "base64":
            return $411d94524a9cdc1d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $411d94524a9cdc1d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$411d94524a9cdc1d$var$Buffer.prototype._isBuffer = true;
function $411d94524a9cdc1d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$411d94524a9cdc1d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$411d94524a9cdc1d$var$swap(this, i, i + 1);
    return this;
};
$411d94524a9cdc1d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $411d94524a9cdc1d$var$swap(this, i, i + 3);
        $411d94524a9cdc1d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$411d94524a9cdc1d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $411d94524a9cdc1d$var$swap(this, i, i + 7);
        $411d94524a9cdc1d$var$swap(this, i + 1, i + 6);
        $411d94524a9cdc1d$var$swap(this, i + 2, i + 5);
        $411d94524a9cdc1d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$411d94524a9cdc1d$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $411d94524a9cdc1d$var$utf8Slice(this, 0, length);
    return $411d94524a9cdc1d$var$slowToString.apply(this, arguments);
};
$411d94524a9cdc1d$var$Buffer.prototype.equals = function equals(b) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $411d94524a9cdc1d$var$Buffer.compare(this, b) === 0;
};
$411d94524a9cdc1d$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $411d94524a9cdc1d$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$411d94524a9cdc1d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $411d94524a9cdc1d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $411d94524a9cdc1d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($411d94524a9cdc1d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $411d94524a9cdc1d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $411d94524a9cdc1d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $411d94524a9cdc1d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$411d94524a9cdc1d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$411d94524a9cdc1d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $411d94524a9cdc1d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$411d94524a9cdc1d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $411d94524a9cdc1d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $411d94524a9cdc1d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $411d94524a9cdc1d$var$utf8Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $411d94524a9cdc1d$var$asciiWrite(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$asciiToBytes(string), buf, offset, length);
}
function $411d94524a9cdc1d$var$latin1Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$asciiWrite(buf, string, offset, length);
}
function $411d94524a9cdc1d$var$base64Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$base64ToBytes(string), buf, offset, length);
}
function $411d94524a9cdc1d$var$ucs2Write(buf, string, offset, length) {
    return $411d94524a9cdc1d$var$blitBuffer($411d94524a9cdc1d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$411d94524a9cdc1d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $411d94524a9cdc1d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $411d94524a9cdc1d$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $411d94524a9cdc1d$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $411d94524a9cdc1d$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $411d94524a9cdc1d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $411d94524a9cdc1d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$411d94524a9cdc1d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $411d94524a9cdc1d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $411d94524a9cdc1d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $411d94524a9cdc1d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $411d94524a9cdc1d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $411d94524a9cdc1d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $411d94524a9cdc1d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $411d94524a9cdc1d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $411d94524a9cdc1d$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $411d94524a9cdc1d$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $411d94524a9cdc1d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $411d94524a9cdc1d$var$toHex(buf[i]);
    return out;
}
function $411d94524a9cdc1d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$411d94524a9cdc1d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $411d94524a9cdc1d$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $411d94524a9cdc1d$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $411d94524a9cdc1d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$411d94524a9cdc1d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$411d94524a9cdc1d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$411d94524a9cdc1d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$411d94524a9cdc1d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$411d94524a9cdc1d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$411d94524a9cdc1d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$411d94524a9cdc1d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$411d94524a9cdc1d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $411d94524a9cdc1d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$411d94524a9cdc1d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$411d94524a9cdc1d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $411d94524a9cdc1d$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $411d94524a9cdc1d$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $411d94524a9cdc1d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$411d94524a9cdc1d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $411d94524a9cdc1d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $411d94524a9cdc1d$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $411d94524a9cdc1d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $411d94524a9cdc1d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeFloat(this, value, offset, true, noAssert);
};
$411d94524a9cdc1d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeFloat(this, value, offset, false, noAssert);
};
function $411d94524a9cdc1d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $411d94524a9cdc1d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$411d94524a9cdc1d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeDouble(this, value, offset, true, noAssert);
};
$411d94524a9cdc1d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $411d94524a9cdc1d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$411d94524a9cdc1d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$411d94524a9cdc1d$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$411d94524a9cdc1d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$411d94524a9cdc1d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $411d94524a9cdc1d$var$Buffer.isBuffer(val) ? val : $411d94524a9cdc1d$var$utf8ToBytes(new $411d94524a9cdc1d$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $411d94524a9cdc1d$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $411d94524a9cdc1d$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $411d94524a9cdc1d$var$stringtrim(str).replace($411d94524a9cdc1d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $411d94524a9cdc1d$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $411d94524a9cdc1d$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $411d94524a9cdc1d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $411d94524a9cdc1d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $411d94524a9cdc1d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $411d94524a9cdc1d$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($411d94524a9cdc1d$var$base64clean(str));
}
function $411d94524a9cdc1d$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $411d94524a9cdc1d$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}


var $b1d4dbaa5514b99a$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $b1d4dbaa5514b99a$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$b1d4dbaa5514b99a$var$crypto && typeof window !== "undefined" && window.msCrypto) $b1d4dbaa5514b99a$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$b1d4dbaa5514b99a$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $b1d4dbaa5514b99a$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$b1d4dbaa5514b99a$var$crypto && true) try {
    $b1d4dbaa5514b99a$var$crypto = (parcelRequire("ifbub"));
} catch (err) {}
function $b1d4dbaa5514b99a$export$2e2bcd8739ae039() {
    if ($b1d4dbaa5514b99a$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $b1d4dbaa5514b99a$var$crypto.getRandomValues === "function") try {
            return $b1d4dbaa5514b99a$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $b1d4dbaa5514b99a$var$crypto.randomBytes === "function") try {
            return $b1d4dbaa5514b99a$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $a9fb8c8e5b047730$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $a9fb8c8e5b047730$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $b1d4dbaa5514b99a$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $a9fb8c8e5b047730$var$hexStringify(this);
    };
    return WordArray;
}();


var $f0fc6b161cb35602$exports = {};
"use strict";
Object.defineProperty($f0fc6b161cb35602$exports, "__esModule", {
    value: true
});

var $89IRS = parcelRequire("89IRS");

(0, $89IRS.__exportStar)((parcelRequire("eyN91")), $f0fc6b161cb35602$exports);


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $3e40ba1bd46c35ab$export$2e2bcd8739ae039 = $3e40ba1bd46c35ab$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $3e40ba1bd46c35ab$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $3e40ba1bd46c35ab$var$nbi() {
    return new $3e40ba1bd46c35ab$var$BigInteger(null);
}
// Bits per digit
var $3e40ba1bd46c35ab$var$dbits;
// JavaScript engine analysis
var $3e40ba1bd46c35ab$var$canary = 0xdeadbeefcafe;
var $3e40ba1bd46c35ab$var$j_lm = ($3e40ba1bd46c35ab$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $3e40ba1bd46c35ab$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $3e40ba1bd46c35ab$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $3e40ba1bd46c35ab$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $3e40ba1bd46c35ab$var$inBrowser = typeof navigator !== "undefined";
if ($3e40ba1bd46c35ab$var$inBrowser && $3e40ba1bd46c35ab$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $3e40ba1bd46c35ab$var$BigInteger.prototype.am = $3e40ba1bd46c35ab$var$am2;
    $3e40ba1bd46c35ab$var$dbits = 30;
} else if ($3e40ba1bd46c35ab$var$inBrowser && $3e40ba1bd46c35ab$var$j_lm && navigator.appName != "Netscape") {
    $3e40ba1bd46c35ab$var$BigInteger.prototype.am = $3e40ba1bd46c35ab$var$am1;
    $3e40ba1bd46c35ab$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $3e40ba1bd46c35ab$var$BigInteger.prototype.am = $3e40ba1bd46c35ab$var$am3;
    $3e40ba1bd46c35ab$var$dbits = 28;
}
$3e40ba1bd46c35ab$var$BigInteger.prototype.DB = $3e40ba1bd46c35ab$var$dbits;
$3e40ba1bd46c35ab$var$BigInteger.prototype.DM = (1 << $3e40ba1bd46c35ab$var$dbits) - 1;
$3e40ba1bd46c35ab$var$BigInteger.prototype.DV = 1 << $3e40ba1bd46c35ab$var$dbits;
var $3e40ba1bd46c35ab$var$BI_FP = 52;
$3e40ba1bd46c35ab$var$BigInteger.prototype.FV = Math.pow(2, $3e40ba1bd46c35ab$var$BI_FP);
$3e40ba1bd46c35ab$var$BigInteger.prototype.F1 = $3e40ba1bd46c35ab$var$BI_FP - $3e40ba1bd46c35ab$var$dbits;
$3e40ba1bd46c35ab$var$BigInteger.prototype.F2 = 2 * $3e40ba1bd46c35ab$var$dbits - $3e40ba1bd46c35ab$var$BI_FP;
// Digit conversions
var $3e40ba1bd46c35ab$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $3e40ba1bd46c35ab$var$BI_RC = new Array();
var $3e40ba1bd46c35ab$var$rr, $3e40ba1bd46c35ab$var$vv;
$3e40ba1bd46c35ab$var$rr = "0".charCodeAt(0);
for($3e40ba1bd46c35ab$var$vv = 0; $3e40ba1bd46c35ab$var$vv <= 9; ++$3e40ba1bd46c35ab$var$vv)$3e40ba1bd46c35ab$var$BI_RC[$3e40ba1bd46c35ab$var$rr++] = $3e40ba1bd46c35ab$var$vv;
$3e40ba1bd46c35ab$var$rr = "a".charCodeAt(0);
for($3e40ba1bd46c35ab$var$vv = 10; $3e40ba1bd46c35ab$var$vv < 36; ++$3e40ba1bd46c35ab$var$vv)$3e40ba1bd46c35ab$var$BI_RC[$3e40ba1bd46c35ab$var$rr++] = $3e40ba1bd46c35ab$var$vv;
$3e40ba1bd46c35ab$var$rr = "A".charCodeAt(0);
for($3e40ba1bd46c35ab$var$vv = 10; $3e40ba1bd46c35ab$var$vv < 36; ++$3e40ba1bd46c35ab$var$vv)$3e40ba1bd46c35ab$var$BI_RC[$3e40ba1bd46c35ab$var$rr++] = $3e40ba1bd46c35ab$var$vv;
function $3e40ba1bd46c35ab$var$int2char(n) {
    return $3e40ba1bd46c35ab$var$BI_RM.charAt(n);
}
function $3e40ba1bd46c35ab$var$intAt(s, i) {
    var c = $3e40ba1bd46c35ab$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $3e40ba1bd46c35ab$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $3e40ba1bd46c35ab$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $3e40ba1bd46c35ab$var$nbv(i) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $3e40ba1bd46c35ab$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $3e40ba1bd46c35ab$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $3e40ba1bd46c35ab$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $3e40ba1bd46c35ab$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $3e40ba1bd46c35ab$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $3e40ba1bd46c35ab$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $3e40ba1bd46c35ab$var$bnNegate() {
    var r = $3e40ba1bd46c35ab$var$nbi();
    $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $3e40ba1bd46c35ab$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $3e40ba1bd46c35ab$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $3e40ba1bd46c35ab$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $3e40ba1bd46c35ab$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $3e40ba1bd46c35ab$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $3e40ba1bd46c35ab$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $3e40ba1bd46c35ab$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $3e40ba1bd46c35ab$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $3e40ba1bd46c35ab$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $3e40ba1bd46c35ab$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $3e40ba1bd46c35ab$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $3e40ba1bd46c35ab$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $3e40ba1bd46c35ab$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $3e40ba1bd46c35ab$var$nbi();
    var y = $3e40ba1bd46c35ab$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $3e40ba1bd46c35ab$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $3e40ba1bd46c35ab$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $3e40ba1bd46c35ab$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $3e40ba1bd46c35ab$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $3e40ba1bd46c35ab$var$bnMod(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($3e40ba1bd46c35ab$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $3e40ba1bd46c35ab$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $3e40ba1bd46c35ab$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $3e40ba1bd46c35ab$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $3e40ba1bd46c35ab$var$bnAdd(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $3e40ba1bd46c35ab$var$bnSubtract(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $3e40ba1bd46c35ab$var$bnMultiply(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $3e40ba1bd46c35ab$var$bnDivide(a) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $3e40ba1bd46c35ab$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $3e40ba1bd46c35ab$var$montConvert(x) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($3e40ba1bd46c35ab$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $3e40ba1bd46c35ab$var$montRevert(x) {
    var r = $3e40ba1bd46c35ab$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $3e40ba1bd46c35ab$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $3e40ba1bd46c35ab$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $3e40ba1bd46c35ab$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$3e40ba1bd46c35ab$var$Montgomery.prototype.convert = $3e40ba1bd46c35ab$var$montConvert;
$3e40ba1bd46c35ab$var$Montgomery.prototype.revert = $3e40ba1bd46c35ab$var$montRevert;
$3e40ba1bd46c35ab$var$Montgomery.prototype.reduce = $3e40ba1bd46c35ab$var$montReduce;
$3e40ba1bd46c35ab$var$Montgomery.prototype.mulTo = $3e40ba1bd46c35ab$var$montMulTo;
$3e40ba1bd46c35ab$var$Montgomery.prototype.sqrTo = $3e40ba1bd46c35ab$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $3e40ba1bd46c35ab$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $3e40ba1bd46c35ab$var$nbv(1), z = new $3e40ba1bd46c35ab$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $3e40ba1bd46c35ab$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $3e40ba1bd46c35ab$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $3e40ba1bd46c35ab$var$nbi(), t;
    i = $3e40ba1bd46c35ab$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$3e40ba1bd46c35ab$var$BigInteger.prototype.copyTo = $3e40ba1bd46c35ab$var$bnpCopyTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.fromInt = $3e40ba1bd46c35ab$var$bnpFromInt;
$3e40ba1bd46c35ab$var$BigInteger.prototype.fromString = $3e40ba1bd46c35ab$var$bnpFromString;
$3e40ba1bd46c35ab$var$BigInteger.prototype.clamp = $3e40ba1bd46c35ab$var$bnpClamp;
$3e40ba1bd46c35ab$var$BigInteger.prototype.dlShiftTo = $3e40ba1bd46c35ab$var$bnpDLShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.drShiftTo = $3e40ba1bd46c35ab$var$bnpDRShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.lShiftTo = $3e40ba1bd46c35ab$var$bnpLShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.rShiftTo = $3e40ba1bd46c35ab$var$bnpRShiftTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.subTo = $3e40ba1bd46c35ab$var$bnpSubTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.multiplyTo = $3e40ba1bd46c35ab$var$bnpMultiplyTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.squareTo = $3e40ba1bd46c35ab$var$bnpSquareTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.divRemTo = $3e40ba1bd46c35ab$var$bnpDivRemTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.invDigit = $3e40ba1bd46c35ab$var$bnpInvDigit;
$3e40ba1bd46c35ab$var$BigInteger.prototype.addTo = $3e40ba1bd46c35ab$var$bnpAddTo;
// public
$3e40ba1bd46c35ab$var$BigInteger.prototype.toString = $3e40ba1bd46c35ab$var$bnToString;
$3e40ba1bd46c35ab$var$BigInteger.prototype.negate = $3e40ba1bd46c35ab$var$bnNegate;
$3e40ba1bd46c35ab$var$BigInteger.prototype.abs = $3e40ba1bd46c35ab$var$bnAbs;
$3e40ba1bd46c35ab$var$BigInteger.prototype.compareTo = $3e40ba1bd46c35ab$var$bnCompareTo;
$3e40ba1bd46c35ab$var$BigInteger.prototype.bitLength = $3e40ba1bd46c35ab$var$bnBitLength;
$3e40ba1bd46c35ab$var$BigInteger.prototype.mod = $3e40ba1bd46c35ab$var$bnMod;
$3e40ba1bd46c35ab$var$BigInteger.prototype.equals = $3e40ba1bd46c35ab$var$bnEquals;
$3e40ba1bd46c35ab$var$BigInteger.prototype.add = $3e40ba1bd46c35ab$var$bnAdd;
$3e40ba1bd46c35ab$var$BigInteger.prototype.subtract = $3e40ba1bd46c35ab$var$bnSubtract;
$3e40ba1bd46c35ab$var$BigInteger.prototype.multiply = $3e40ba1bd46c35ab$var$bnMultiply;
$3e40ba1bd46c35ab$var$BigInteger.prototype.divide = $3e40ba1bd46c35ab$var$bnDivide;
$3e40ba1bd46c35ab$var$BigInteger.prototype.modPow = $3e40ba1bd46c35ab$var$bnModPow;
// "constants"
$3e40ba1bd46c35ab$var$BigInteger.ZERO = $3e40ba1bd46c35ab$var$nbv(0);
$3e40ba1bd46c35ab$var$BigInteger.ONE = $3e40ba1bd46c35ab$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $88865c6be67431f3$var$randomBytes(nBytes) {
    return (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(new (0, $a9fb8c8e5b047730$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $88865c6be67431f3$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $88865c6be67431f3$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $88865c6be67431f3$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $88865c6be67431f3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)($88865c6be67431f3$var$initN, 16);
        this.g = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $88865c6be67431f3$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $88865c6be67431f3$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $88865c6be67431f3$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $411d94524a9cdc1d$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $411d94524a9cdc1d$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $f0fc6b161cb35602$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $88865c6be67431f3$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $88865c6be67431f3$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $9cace9e0163889ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $411d94524a9cdc1d$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $41c9382bb6a72dfa$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $41c9382bb6a72dfa$var$_setPrototypeOf(t, o);
}
function $41c9382bb6a72dfa$var$_setPrototypeOf(t, e) {
    return $41c9382bb6a72dfa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $41c9382bb6a72dfa$var$_setPrototypeOf(t, e);
}
/** @class */ var $41c9382bb6a72dfa$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    $41c9382bb6a72dfa$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    return CognitoAccessToken;
}((0, $9cace9e0163889ff$export$2e2bcd8739ae039));



function $d9c1dd270429cf89$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $d9c1dd270429cf89$var$_setPrototypeOf(t, o);
}
function $d9c1dd270429cf89$var$_setPrototypeOf(t, e) {
    return $d9c1dd270429cf89$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $d9c1dd270429cf89$var$_setPrototypeOf(t, e);
}
/** @class */ var $d9c1dd270429cf89$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    $d9c1dd270429cf89$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    return CognitoIdToken;
}((0, $9cace9e0163889ff$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $fdaf527344dd671b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $4c68ad5a26d6b3ee$export$83d89fbfd8236492 = "5.0.4";


var $37924787154e0cec$var$BASE_USER_AGENT = "aws-amplify/" + (0, $4c68ad5a26d6b3ee$export$83d89fbfd8236492);
var $37924787154e0cec$export$2dffd0b5373a4389 = {
    userAgent: $37924787154e0cec$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $37924787154e0cec$export$7935961ef7719cb0 = function getUserAgent() {
    return $37924787154e0cec$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $37924787154e0cec$export$2e2bcd8739ae039 = $37924787154e0cec$export$2dffd0b5373a4389;







/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $45e3ad811e5296cd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $cd3600c8771307cd$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $cd3600c8771307cd$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $cd3600c8771307cd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $cd3600c8771307cd$var$weekNames[now.getUTCDay()];
        var month = $cd3600c8771307cd$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $559b6e1d514a188f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $d3c0ec7e73282823$var$dataMemory = {};
var $d3c0ec7e73282823$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $d3c0ec7e73282823$var$dataMemory[key] = value;
        return $d3c0ec7e73282823$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($d3c0ec7e73282823$var$dataMemory, key) ? $d3c0ec7e73282823$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $d3c0ec7e73282823$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $d3c0ec7e73282823$var$dataMemory = {};
        return $d3c0ec7e73282823$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $d3c0ec7e73282823$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $d3c0ec7e73282823$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $a44bf0d9fbe2b4df$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $a44bf0d9fbe2b4df$var$userAgent = $a44bf0d9fbe2b4df$var$isNavigatorAvailable ? (0, $37924787154e0cec$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var $a44bf0d9fbe2b4df$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $d3c0ec7e73282823$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $cd3600c8771307cd$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $411d94524a9cdc1d$export$a143d493d941bafc).concat([
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var _respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return _respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    _respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $a44bf0d9fbe2b4df$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $cd3600c8771307cd$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $3e40ba1bd46c35ab$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $411d94524a9cdc1d$export$a143d493d941bafc).concat([
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $f0fc6b161cb35602$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $88865c6be67431f3$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $411d94524a9cdc1d$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $a44bf0d9fbe2b4df$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $559b6e1d514a188f$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $d9c1dd270429cf89$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $41c9382bb6a72dfa$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $fdaf527344dd671b$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $45e3ad811e5296cd$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.requestWithRetry("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $d9c1dd270429cf89$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $41c9382bb6a72dfa$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $fdaf527344dd671b$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $45e3ad811e5296cd$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $0ecd5c8b07acacb9$exports = {};


$0ecd5c8b07acacb9$exports = self.fetch || (self.fetch = (parcelRequire("adsYI")).default || (parcelRequire("adsYI")));



var $217cbcb095508b55$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $217cbcb095508b55$export$2ef00488675027c = "auth";


// constructor
function $a3aa897b4733833f$var$UserAgent() {}
// public
$a3aa897b4733833f$var$UserAgent.prototype.userAgent = (0, $37924787154e0cec$export$7935961ef7719cb0)();
var $a3aa897b4733833f$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($a3aa897b4733833f$var$UserAgent.prototype.userAgent && !$a3aa897b4733833f$var$UserAgent.prototype.userAgent.includes(content)) $a3aa897b4733833f$var$UserAgent.prototype.userAgent = $a3aa897b4733833f$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$a3aa897b4733833f$var$UserAgent.prototype.userAgent || $a3aa897b4733833f$var$UserAgent.prototype.userAgent === "") $a3aa897b4733833f$var$UserAgent.prototype.userAgent = content;
};
var $a3aa897b4733833f$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $a3aa897b4733833f$var$UserAgent.category = (0, $217cbcb095508b55$export$2ef00488675027c);
};
var $a3aa897b4733833f$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $a3aa897b4733833f$var$UserAgent.framework = framework;
};
var $a3aa897b4733833f$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $a3aa897b4733833f$var$UserAgent.category ? " " + $a3aa897b4733833f$var$UserAgent.category : "";
    var uaFramework = $a3aa897b4733833f$var$UserAgent.framework ? " framework/" + $a3aa897b4733833f$var$UserAgent.framework : "";
    var userAgent = "" + $a3aa897b4733833f$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$a3aa897b4733833f$export$2e2bcd8739ae039 = $a3aa897b4733833f$var$UserAgent;


function $aad7c33fb80d1a83$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $aad7c33fb80d1a83$var$_setPrototypeOf(t, o);
}
function $aad7c33fb80d1a83$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $aad7c33fb80d1a83$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$aad7c33fb80d1a83$var$_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $aad7c33fb80d1a83$var$_construct(t, arguments, $aad7c33fb80d1a83$var$_getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $aad7c33fb80d1a83$var$_setPrototypeOf(Wrapper, t);
    }, $aad7c33fb80d1a83$var$_wrapNativeSuper(t);
}
function $aad7c33fb80d1a83$var$_construct(t, e, r) {
    if ($aad7c33fb80d1a83$var$_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $aad7c33fb80d1a83$var$_setPrototypeOf(p, r.prototype), p;
}
function $aad7c33fb80d1a83$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($aad7c33fb80d1a83$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $aad7c33fb80d1a83$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function $aad7c33fb80d1a83$var$_setPrototypeOf(t, e) {
    return $aad7c33fb80d1a83$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $aad7c33fb80d1a83$var$_setPrototypeOf(t, e);
}
function $aad7c33fb80d1a83$var$_getPrototypeOf(t) {
    return $aad7c33fb80d1a83$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $aad7c33fb80d1a83$var$_getPrototypeOf(t);
}
var $aad7c33fb80d1a83$var$CognitoError = /*#__PURE__*/ function(_Error) {
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    $aad7c33fb80d1a83$var$_inheritsLoose(CognitoError, _Error);
    return CognitoError;
}(/*#__PURE__*/ $aad7c33fb80d1a83$var$_wrapNativeSuper(Error));
/** @class */ var $aad7c33fb80d1a83$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $aad7c33fb80d1a83$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $aad7c33fb80d1a83$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $a3aa897b4733833f$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $aad7c33fb80d1a83$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $aad7c33fb80d1a83$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    $aad7c33fb80d1a83$var$_inheritsLoose(NonRetryableError, _Error2);
    return NonRetryableError;
}(/*#__PURE__*/ $aad7c33fb80d1a83$var$_wrapNativeSuper(Error));
var $aad7c33fb80d1a83$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $aad7c33fb80d1a83$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $aad7c33fb80d1a83$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $aad7c33fb80d1a83$var$logger.debug("error on " + functionToRetry.name, err);
        if ($aad7c33fb80d1a83$var$isNonRetryableError(err)) {
            $aad7c33fb80d1a83$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $aad7c33fb80d1a83$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $aad7c33fb80d1a83$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $aad7c33fb80d1a83$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $aad7c33fb80d1a83$var$MAX_DELAY_MS = 300000;
function $aad7c33fb80d1a83$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $aad7c33fb80d1a83$var$MAX_DELAY_MS;
    return $aad7c33fb80d1a83$var$retry(functionToRetry, args, $aad7c33fb80d1a83$var$jitteredBackoff(maxDelayMs));
}




var $eb46ddfd02c1d36e$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $eb46ddfd02c1d36e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $eb46ddfd02c1d36e$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $aad7c33fb80d1a83$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $d3c0ec7e73282823$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $a44bf0d9fbe2b4df$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $a44bf0d9fbe2b4df$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $de309840e50e5fe9$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $de309840e50e5fe9$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $7bb5d86070c49555$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $de309840e50e5fe9$exports.set(key, value, options);
        return $de309840e50e5fe9$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $de309840e50e5fe9$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $de309840e50e5fe9$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $de309840e50e5fe9$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();











var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

const $01ad73ae33b4f3c5$var$initialState = {
    alert: null,
    message: null,
    messages: [],
    tooltip: null,
    tiletip: null,
    signal: {},
    fullscreenReport: null
};
function $01ad73ae33b4f3c5$export$2e2bcd8739ae039(state = $01ad73ae33b4f3c5$var$initialState, action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $0840a3787500c813$export$f56c21b951c55d75:
            {
                const { message: message } = payload;
                if (message === null) // for compatibility reasons, clears the message property
                return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                    message: null
                });
                return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                    message: message,
                    // message stack (NotificationMessage and Toast components display the last one from here); payload is { message, extraMessage }
                    // handle payload as string and as { message, extraMessage }
                    messages: [
                        ...state.messages,
                        payload.message ? payload : {
                            message: payload
                        }
                    ]
                });
            }
        case 0, $0840a3787500c813$export$30ea2bfc5f501552:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                fullscreenReport: payload
            });
        case 0, $0840a3787500c813$export$b65e917bab1efccd:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                fullscreenReport: null
            });
        case 0, $0840a3787500c813$export$b3af722de1fd7d3c:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                alert: {
                    visible: true,
                    id: payload.alertId,
                    caller: payload.caller,
                    callbackOk: payload.callbackOk
                }
            });
        case 0, $0840a3787500c813$export$46b95b1ea69baa95:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                alert: (0, $2qxEV._)((0, $9tqwB._)({}, state.alert), {
                    visible: false,
                    response: payload
                })
            });
        case 0, $0840a3787500c813$export$97b09ce6a5c74156:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                alert: null
            });
        case 0, $0840a3787500c813$export$a4c351e5b9b68a40:
            // expecting payload: { callerId: 'string', message: 'string' or boolean}
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                signal: (0, $2qxEV._)((0, $9tqwB._)({}, state.signal), {
                    [payload === null || payload === void 0 ? void 0 : payload.callerId]: payload === null || payload === void 0 ? void 0 : payload.message
                })
            });
        case 0, $0840a3787500c813$export$80f5d6a1a3225791:
            // expecting payload: { callerId: 'string'}
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                signal: (0, $2qxEV._)((0, $9tqwB._)({}, state.signal), {
                    [payload === null || payload === void 0 ? void 0 : payload.callerId]: null
                })
            });
        default:
            return state;
    }
}




/* eslint-disable import/no-cycle */ /* eslint-disable no-param-reassign */ 






(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $47d2e16a1696e57a$var$baseDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "year").startOf("month").valueOf();
const $47d2e16a1696e57a$var$initialState = {
    baseDate: $47d2e16a1696e57a$var$baseDate.valueOf(),
    dashboardMode: "dashboard",
    slider: {
        min: new Date("2015-01-01T00:00:00Z").valueOf(),
        max: new Date("2031-01-01T00:00:00Z").valueOf()
    }
};
function $47d2e16a1696e57a$var$getProviderAssetIdKey(providerAssetId) {
    if (!providerAssetId) return "";
    if (typeof providerAssetId === "object") return JSON.stringify(providerAssetId);
    return String(providerAssetId);
}
function $47d2e16a1696e57a$var$getScopedQuoteAssetsFromBalances(balances = []) {
    const seen = new Set();
    const scopedAssets = [];
    (balances || []).forEach((balance)=>{
        const assetId = balance === null || balance === void 0 ? void 0 : balance.assetId;
        const currency = (balance === null || balance === void 0 ? void 0 : balance.transactionCurrency) || (balance === null || balance === void 0 ? void 0 : balance.accountCurrency);
        const providerAssetId = (balance === null || balance === void 0 ? void 0 : balance.providerAssetId) || null;
        if (!assetId || !currency) return;
        const key = `${assetId}|${$47d2e16a1696e57a$var$getProviderAssetIdKey(providerAssetId)}|${currency}`;
        if (seen.has(key)) return;
        seen.add(key);
        scopedAssets.push({
            assetId: assetId,
            providerAssetId: providerAssetId,
            currency: currency
        });
    });
    return scopedAssets;
}
const $47d2e16a1696e57a$var$simulationSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "simulation",
    initialState: $47d2e16a1696e57a$var$initialState,
    reducers: {
        setSimulationBaseDate (state, action) {
            const { newDate: newDate } = action.payload;
            // check if we are receiving a correct argument
            if (Number.isNaN(newDate)) throw new Error(`Error: setSimulationBaseDate expects a valid Number (got ${newDate} instead)`);
            // force set argument to be the midnight of the 1st calendar day of the month
            const transformedDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(newDate).startOf("month");
            state.baseDate = transformedDate.valueOf();
        },
        setDashboardMode (state, action) {
            const { dashboardMode: dashboardMode } = action.payload;
            if (![
                "dashboard",
                "projects"
            ].includes(dashboardMode)) throw new Error(`Error: setDashboardMode expects a valid dashboardMode (got ${dashboardMode} instead)`);
            state.dashboardMode = dashboardMode;
        }
    }
});
var $47d2e16a1696e57a$export$2e2bcd8739ae039 = $47d2e16a1696e57a$var$simulationSlice.reducer;
const { setDashboardMode: $47d2e16a1696e57a$export$d807a8f4979ccad4, setSimulationBaseDate: $47d2e16a1696e57a$export$96730043f947c07e } = $47d2e16a1696e57a$var$simulationSlice.actions;
const $47d2e16a1696e57a$export$284f9e3210b39fb4 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("simulation/setSimulationBaseDateAndUpdateQuotes", async ({ newDate: newDate }, { dispatch: dispatch, getState: getState })=>{
    var _getState_simulation;
    // check if we are receiving a correct argument
    // if null is passed as newDate, use the current baseDate and just get quotes (used when initialising Dashboard in project mode)
    if (newDate !== null && Number.isNaN(newDate.valueOf())) throw new Error(`Error: setSimulationBaseDate expects a Number or a null (got ${newDate} instead)`);
    const { baseline: baseline, referenceBaseline: referenceBaseline } = (0, $93bb2798871a68d2$export$4bb039911f93bce)(getState());
    let transformedDate;
    if (newDate) {
        // force-set argument to be the midnight of the 1st calendar day of the month
        transformedDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(newDate).startOf("month").valueOf();
        // await dispatch set simulation basedate (sliderDate)
        await dispatch($47d2e16a1696e57a$export$96730043f947c07e({
            newDate: transformedDate
        }));
    }
    if (newDate === null) transformedDate = (_getState_simulation = getState().simulation) === null || _getState_simulation === void 0 ? void 0 : _getState_simulation.baseDate;
    // Baseline/slider updates invalidate a narrow quote scope:
    // refresh only currently relevant assets and numeric baseline/reference/current dates.
    const assets = $47d2e16a1696e57a$var$getScopedQuoteAssetsFromBalances((0, $3679aa7475d9bd44$export$7cd09fd23199c464)(getState()));
    await (0, $7df3cdf229d31ae2$export$5a0d3efae517a391)({
        scopes: (0, $780d46a2914a2b26$export$3c2ee341cf661934)({
            assets: assets,
            requiredDates: (0, $780d46a2914a2b26$export$9f53b88e82f64d8d)([
                baseline,
                referenceBaseline,
                transformedDate
            ]),
            assetDateBounds: (0, $780d46a2914a2b26$export$a9243e65b02f996b)((0, $780d46a2914a2b26$export$8ddf68b0fa571116)(getState()))
        })
    }, {
        dispatch: dispatch,
        immediate: true
    });
    return {
        transformedDate: transformedDate
    };
});


/* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");



const $c082dd6d1850ff9b$var$initialState = {
    survey: {
        status: "idle",
        error: null,
        result: null
    },
    estimataCities: null,
    estimataCitiesStatus: "idle",
    estimataCitiesError: null
};
const $c082dd6d1850ff9b$export$4a54c8d3f6f8e667 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("misc/postSurvey", async (body = {}, { dispatch: dispatch, rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "misc/survey", {
            body: body,
            headers: {
                "Content-Type": "application/json"
            }
        });
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("surveySentSuccessfully"));
        return response;
    } catch (error) {
        var _error_response_data, _error_response;
        const message = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.toString()) || "Unknown error";
        console.error(message);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("surveySendingError"));
        return rejectWithValue(message);
    }
});
const $c082dd6d1850ff9b$export$37a10b117bbddcb = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("misc/getEstimataCities", async (body, { dispatch: dispatch, rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", "realestate/estimata/cities", {
            headers: {
                "Content-Type": "application/json"
            }
        }); // returns array of arrays
        return response;
    } catch (error) {
        var _error_response_data, _error_response;
        const message = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.toString()) || "Unknown error";
        console.error(message);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("surveySendingError"));
        return rejectWithValue(message);
    }
});
const $c082dd6d1850ff9b$var$miscSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "misc",
    initialState: $c082dd6d1850ff9b$var$initialState,
    reducers: {
        resetSurveyState (state) {
            state.survey = (0, $9tqwB._)({}, $c082dd6d1850ff9b$var$initialState.survey);
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($c082dd6d1850ff9b$export$4a54c8d3f6f8e667.pending, (state)=>{
            state.survey.status = "loading";
            state.survey.error = null;
        }).addCase($c082dd6d1850ff9b$export$4a54c8d3f6f8e667.fulfilled, (state, action)=>{
            state.survey.status = "succeeded";
            state.survey.result = action.payload;
        }).addCase($c082dd6d1850ff9b$export$4a54c8d3f6f8e667.rejected, (state, action)=>{
            var _action_error;
            state.survey.status = "failed";
            state.survey.error = action.payload || ((_action_error = action.error) === null || _action_error === void 0 ? void 0 : _action_error.message) || "Unknown error";
        }).addCase($c082dd6d1850ff9b$export$37a10b117bbddcb.pending, (state)=>{
            state.estimataCitiesStatus = "loading";
            state.estimataCitiesError = null;
        }).addCase($c082dd6d1850ff9b$export$37a10b117bbddcb.fulfilled, (state, action)=>{
            state.estimataCitiesStatus = "succeeded";
            state.estimataCities = action.payload;
        }).addCase($c082dd6d1850ff9b$export$37a10b117bbddcb.rejected, (state, action)=>{
            var _action_error;
            state.estimataCitiesStatus = "failed";
            state.estimataCitiesError = action.payload || ((_action_error = action.error) === null || _action_error === void 0 ? void 0 : _action_error.message) || "Unknown error";
        });
    }
});
const { resetSurveyState: $c082dd6d1850ff9b$export$170455934aa89296 } = $c082dd6d1850ff9b$var$miscSlice.actions;
var $c082dd6d1850ff9b$export$2e2bcd8739ae039 = $c082dd6d1850ff9b$var$miscSlice.reducer;



function $c534ad61c7751c43$export$2e2bcd8739ae039(state = [], action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $0840a3787500c813$export$f29c717e71981e5a:
            return [
                ...payload
            ];
        case 0, $0840a3787500c813$export$15bdd6f74fffda24:
        case 0, $0840a3787500c813$export$688b2f09bbdcf053:
            // payload is a complete Project object
            // remove current Project by that id from state (if existing)
            // and add the new one from payload
            // FAIL does technically the same as success, but with a different payload (the original state of store)
            return state.filter((project)=>project.id !== payload.id).concat(payload);
        case 0, $0840a3787500c813$export$7ce38f165121a0d2:
            // payload is the complete project object or just its id in an object { id: 123 }
            return state.filter((project)=>project.id !== payload.id);
        default:
            return state;
    }
}


/* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");


/* eslint-disable no-promise-executor-return */ 
var $9tqwB = parcelRequire("9tqwB");


async function $46fcae15df3b34ae$var$callApi(method, payload, resource) {
    var _session_tokens_idToken, _session_tokens;
    const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
    const myInit = {
        headers: {
            "Content-Type": "application/json",
            Authorization: (_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.toString()
        }
    };
    if (payload !== null && payload !== undefined) myInit.body = payload;
    let response;
    try {
        if (method === "get") response = await (0, $bad5f4197326a006$export$b216272c8be3751a)("myAPI", `reports/${resource}`, myInit);
        if (method === "post") response = await (0, $bad5f4197326a006$export$bd1dc54ad3b0ef79)("myAPI", `reports/${resource}`, myInit);
        if (method === "put") response = await (0, $bad5f4197326a006$export$6dd598fa143977b0)("myAPI", `reports/${resource}`, myInit);
        if (method === "delete") response = await (0, $bad5f4197326a006$export$bb2abc1fe2f1c239)("myAPI", `reports/${resource}`, myInit);
    } catch (error) {
        console.log("Error while accessing API", error.response);
        throw new Error(error);
    }
    return response;
}
async function $46fcae15df3b34ae$var$getData() {
    try {
        // returns array of all projects
        const data = await $46fcae15df3b34ae$var$callApi("get", null, "");
        return data;
    } catch (e) {
        console.error("Error while accessing reports > getData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $46fcae15df3b34ae$var$postData(payload) {
    try {
        const data = await $46fcae15df3b34ae$var$callApi("post", payload, "");
        return (0, $9tqwB._)({}, data);
    } catch (e) {
        console.error("Error while accessing reports > postData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $46fcae15df3b34ae$var$putData(payload) {
    try {
        const data = await $46fcae15df3b34ae$var$callApi("put", payload, "");
        return (0, $9tqwB._)({}, data);
    } catch (e) {
        console.error("Error while accessing reports > putData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
async function $46fcae15df3b34ae$var$deleteData(payload) {
    try {
        const data = await $46fcae15df3b34ae$var$callApi("delete", payload, "");
        return (0, $9tqwB._)({}, data);
    } catch (e) {
        console.error("Error while accessing reports > deleteData API.");
        console.error(`Lambda error message: ${e.response.data}, statusCode: ${e.response.status}, statusText: ${e.response.statusText}`);
        throw new Error(e.response.data); // error message from the backend lambda
    }
}
var $46fcae15df3b34ae$export$2e2bcd8739ae039 = {
    getData: $46fcae15df3b34ae$var$getData,
    postData: $46fcae15df3b34ae$var$postData,
    putData: $46fcae15df3b34ae$var$putData,
    deleteData: $46fcae15df3b34ae$var$deleteData
};


const $d3284a471a952054$var$allDepositTransactions = {
    vals: [
        "amount"
    ],
    userId: "jiZoVK1rpJEbfxwfX8LKJ",
    cols: [],
    dataScope: "transactions",
    rows: [
        "Date (Day)",
        "id",
        "accountName",
        "otherParty",
        "description",
        "currency",
        "amount"
    ],
    rendererName: "List",
    id: "yAuSzwA-k5fA3DXW2O50M",
    name: "All deposit transactions",
    readOnly: true,
    aggregatorName: "Sum",
    hiddenRows: [
        1
    ]
};
var $d3284a471a952054$export$2e2bcd8739ae039 = $d3284a471a952054$var$allDepositTransactions;


const $0f1cef2e461754dc$var$allStockPositions = {
    name: "All stock positions",
    readOnly: true,
    dataScope: "balances",
    // dataScope: 'transactions',
    cols: [],
    rows: [],
    vals: [],
    aggregatorName: "Count",
    rendererName: "Stock Positions",
    id: "1FbUpr7zh4oIvNwDscQkf"
};
var $0f1cef2e461754dc$export$2e2bcd8739ae039 = $0f1cef2e461754dc$var$allStockPositions;


const $fef984f88795535d$var$allAssetsByROI = {
    vals: [
        "amount"
    ],
    userId: "jiZoVK1rpJEbfxwfX8LKJ",
    cols: [],
    dataScope: "assets",
    rows: [
        "category",
        "accountName",
        "displayName",
        "purchaseValue",
        "payoutsSincePurchase",
        "feesSincePurchase",
        "currentValue",
        "roi",
        "roiAnnual"
    ],
    rendererName: "List",
    id: "qWoSEGOkfwQt16iRbkB89",
    name: "Owned assets with ROI",
    readOnly: true,
    aggregatorName: "Sum"
};
var $fef984f88795535d$export$2e2bcd8739ae039 = $fef984f88795535d$var$allAssetsByROI;


const $2ac1f7d6b11cfce1$var$allAssetsSunburst = {
    userId: "jiZoVK1rpJEbfxwfX8LKJ",
    cols: [
        "displayName"
    ],
    dataScope: "assets",
    dataStructure: "hierarchy",
    rows: [
        "category",
        "accountName"
    ],
    vals: [
        "currentValue"
    ],
    rendererName: "Pie chart, multi-layers",
    rendererType: "nivo",
    id: "allAssetsSunburstxxxx",
    name: "Owned assets - pie chart",
    readOnly: true,
    aggregatorName: "Sum"
};
var $2ac1f7d6b11cfce1$export$2e2bcd8739ae039 = $2ac1f7d6b11cfce1$var$allAssetsSunburst;


// instructions: leave 1 account in accountName filter and 12 most recent months with data in date filter
const $44ff510aeee14a04$var$transactions12m = {
    vals: [
        "amount"
    ],
    cols: [
        "accountName",
        "Transaction sign"
    ],
    dataScope: "transactions",
    rows: [
        "Date (Month)"
    ],
    rendererName: "Bar chart, vertical, diverging, stacked",
    rendererType: "nivo",
    id: "transactionsByMonthxx",
    name: "Deposits, transactions stacked by month",
    aggregatorName: "Sum",
    readOnly: true
};
var $44ff510aeee14a04$export$2e2bcd8739ae039 = $44ff510aeee14a04$var$transactions12m;


const $5b2ff690ae349b40$var$assetsBalanceChanges = {
    cols: [
        "accountName"
    ],
    dataScope: "snapshots",
    rows: [
        "Date (Year)"
    ],
    rendererName: "Area chart",
    id: "assetBalancesOverTime",
    name: "Asset balance changes",
    readOnly: true,
    aggregatorName: "Sum",
    vals: [
        "value"
    ]
};
var $5b2ff690ae349b40$export$2e2bcd8739ae039 = $5b2ff690ae349b40$var$assetsBalanceChanges;


const $b20f99fc20c49f2b$var$inflowsByType = {
    id: "inflowsByTypexxxxxxxx",
    name: "Income from capital vs other inflows",
    dataScope: "snapshots",
    cols: [
        "inflowType"
    ],
    rows: [
        "Date (Year)"
    ],
    vals: [
        "inflowValue"
    ],
    aggregatorName: "Sum",
    rendererName: "Bar chart, vertical, grouped",
    valueFilter: {},
    readOnly: true
};
var $b20f99fc20c49f2b$export$2e2bcd8739ae039 = $b20f99fc20c49f2b$var$inflowsByType;


// instructions: leave 1 account in accountName filter and 12 most recent months with data in date filter
const $57796e77f3d3dd93$var$assetsByMonthStacked = {
    vals: [
        "value"
    ],
    cols: [
        "displayName"
    ],
    dataScope: "snapshots",
    rows: [
        "Date (Month)"
    ],
    rendererName: "Bar chart, vertical, diverging, stacked",
    rendererType: "nivo",
    id: "snapshotsByMonthxxxxx",
    name: "Assets snapshot, stacked, by month",
    aggregatorName: "Sum",
    readOnly: true
};
var $57796e77f3d3dd93$export$2e2bcd8739ae039 = $57796e77f3d3dd93$var$assetsByMonthStacked;


// instructions: leave 1 account in accountName filter and 12 most recent months with data in date filter
const $dcb29d535f871e05$var$realEstate10y = {
    vals: [
        "value"
    ],
    cols: [
        "accountName"
    ],
    dataScope: "snapshots",
    rows: [
        "Date (Year)"
    ],
    rendererName: "Bar chart, vertical, grouped",
    rendererType: "nivo",
    id: "realEstateByMonthxxxx",
    name: "Real Estate, value by year",
    aggregatorName: "Maximum",
    readOnly: true
};
var $dcb29d535f871e05$export$2e2bcd8739ae039 = $dcb29d535f871e05$var$realEstate10y;


const $c047eb209f251e9b$var$kpiReport = {
    name: "KPI Report (EN only)",
    readOnly: true,
    dataScope: "balances",
    cols: [],
    rows: [],
    vals: [],
    aggregatorName: "Count",
    rendererName: "KPI Report",
    id: "kpiReportxxxxxxxxxxxx"
};
var $c047eb209f251e9b$export$2e2bcd8739ae039 = $c047eb209f251e9b$var$kpiReport;


const $0f04a41f753777e1$var$kpiReport = {
    name: "KPI Report (new, EN only)",
    readOnly: true,
    dataScope: "balances",
    cols: [],
    rows: [],
    vals: [],
    aggregatorName: "Count",
    rendererName: "KPI Report Unisel",
    id: "kpiReportUniselxxxxxx"
};
var $0f04a41f753777e1$export$2e2bcd8739ae039 = $0f04a41f753777e1$var$kpiReport;


// instructions: leave 1 account in accountName filter and 12 most recent months with data in date filter
const $a4d1d3fa6ccec5f4$var$quotesByYearLine = {
    vals: [
        "quote"
    ],
    cols: [
        "date"
    ],
    dataScope: "quotes",
    rows: [
        "displayName"
    ],
    rendererName: "Line chart, horizontal",
    rendererType: "nivo",
    id: "quoteByYearLinexxxxxx",
    name: "Quotes snapshot, line chart, by year",
    aggregatorName: "Sum",
    readOnly: true
};
var $a4d1d3fa6ccec5f4$export$2e2bcd8739ae039 = $a4d1d3fa6ccec5f4$var$quotesByYearLine;


const $46a39964551de26f$var$prebuiltReportDefs = [
    (0, $d3284a471a952054$export$2e2bcd8739ae039),
    (0, $0f1cef2e461754dc$export$2e2bcd8739ae039),
    (0, $fef984f88795535d$export$2e2bcd8739ae039),
    (0, $2ac1f7d6b11cfce1$export$2e2bcd8739ae039),
    (0, $44ff510aeee14a04$export$2e2bcd8739ae039),
    (0, $5b2ff690ae349b40$export$2e2bcd8739ae039),
    (0, $b20f99fc20c49f2b$export$2e2bcd8739ae039),
    (0, $57796e77f3d3dd93$export$2e2bcd8739ae039),
    (0, $dcb29d535f871e05$export$2e2bcd8739ae039),
    (0, $c047eb209f251e9b$export$2e2bcd8739ae039),
    (0, $0f04a41f753777e1$export$2e2bcd8739ae039),
    (0, $a4d1d3fa6ccec5f4$export$2e2bcd8739ae039)
];
var $46a39964551de26f$export$2e2bcd8739ae039 = $46a39964551de26f$var$prebuiltReportDefs;



const $34d01d41f17850bb$export$9dc937f1c1abf620 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("reports/getReports", async (_, { dispatch: dispatch, getState: getState })=>{
    try {
        const response = await (0, $46fcae15df3b34ae$export$2e2bcd8739ae039).getData();
        return response;
    } catch (error) {
        console.log("Redux > reports > getReports error:", error);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
    }
    return null;
});
const $34d01d41f17850bb$export$c8ce4d616f681ea6 = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("reports/postReport", async (report, { dispatch: dispatch, getState: getState })=>{
    try {
        const response = await (0, $46fcae15df3b34ae$export$2e2bcd8739ae039).postData(report);
        dispatch({
            type: (0, $0840a3787500c813$export$a4c351e5b9b68a40),
            payload: {
                callerId: report.id,
                message: "reportPostPutFinished"
            }
        });
        return response;
    } catch (error) {
        console.log("Redux > reports > postReport error:", error);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
    }
    return null;
});
const $34d01d41f17850bb$export$4f2fb5656642a535 = $34d01d41f17850bb$export$c8ce4d616f681ea6;
const $34d01d41f17850bb$export$da764d61c8c69f9a = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("reports/deleteReport", async (reportId, { dispatch: dispatch, getState: getState })=>{
    try {
        const response = await (0, $46fcae15df3b34ae$export$2e2bcd8739ae039).deleteData({
            id: reportId
        });
        return (0, $9tqwB._)({
            id: reportId
        }, response); // Assuming deleteData returns something useful; adjust as needed
    } catch (error) {
        console.log("Redux > reports > deleteReport error:", error);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
    }
    return null;
});
const $34d01d41f17850bb$export$df8c1303c2e7c6bb = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("reports/updateReport", async (report)=>{
    const response = await (0, $46fcae15df3b34ae$export$2e2bcd8739ae039).putData(report);
    return response;
});
const $34d01d41f17850bb$var$initialState = $46a39964551de26f$export$2e2bcd8739ae039;
const $34d01d41f17850bb$var$reportsSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "reports",
    initialState: $34d01d41f17850bb$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($34d01d41f17850bb$export$9dc937f1c1abf620.fulfilled, (state, action)=>{
            // this is apparently how array operations are done on Immer / RTK
            // Efficiently create a set of ids from the payload for faster lookups
            const payloadIds = new Set(action.payload.map((r)=>r.id));
            // Filter the state directly by mutating it
            const filteredState = state.filter((report)=>!payloadIds.has(report.id));
            // Use state.splice to clear the array and push new items
            state.splice(0, state.length, ...filteredState, ...action.payload);
        })// this was already fired on PENDING before, is that a good idea?
        .addCase($34d01d41f17850bb$export$c8ce4d616f681ea6.fulfilled, (state, action)=>{
            state.push(action.payload);
        }).addCase($34d01d41f17850bb$export$da764d61c8c69f9a.fulfilled, (state, action)=>{
            state = state.filter((report)=>report.id !== action.payload.id);
        }).addCase($34d01d41f17850bb$export$df8c1303c2e7c6bb.fulfilled, (state, action)=>{
            const index = state.findIndex((report)=>report.id === action.payload.id);
            if (index !== -1) state[index] = action.payload;
        });
    }
});
var $34d01d41f17850bb$export$2e2bcd8739ae039 = $34d01d41f17850bb$var$reportsSlice.reducer;


/* eslint-disable import/no-cycle */ /* eslint-disable no-param-reassign */ 
"use strict";
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $4ZL0H = parcelRequire("4ZL0H");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if ($77146a31cb578292$var$kindOf(val) !== "object") return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($77146a31cb578292$var$toStringTag in val) && !($77146a31cb578292$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $77146a31cb578292$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $77146a31cb578292$var$isFunction(thing.append) && ((kind = $77146a31cb578292$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest("URLSearchParams");
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $77146a31cb578292$var$findKey(result, key) || key;
        if ($77146a31cb578292$var$isPlainObject(result[targetKey]) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(result[targetKey], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) a[key] = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest("HTMLFormElement");
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest("RegExp");
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === "FormData" && thing[$77146a31cb578292$var$iterator]);
}
const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $77146a31cb578292$var$isArray(source) ? [] : {};
                $77146a31cb578292$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest("AsyncFunction");
const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
const $77146a31cb578292$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($77146a31cb578292$var$_global) : typeof $4ZL0H !== "undefined" && $4ZL0H.nextTick || $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $b9cc6960093b095e$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $77146a31cb578292$export$2e2bcd8739ae039).inherits($b9cc6960093b095e$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $77146a31cb578292$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $b9cc6960093b095e$var$prototype = $b9cc6960093b095e$var$AxiosError.prototype;
const $b9cc6960093b095e$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $b9cc6960093b095e$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($b9cc6960093b095e$var$AxiosError, $b9cc6960093b095e$var$descriptors);
Object.defineProperty($b9cc6960093b095e$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$b9cc6960093b095e$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($b9cc6960093b095e$var$prototype);
    (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    const msg = error && error.message ? error.message : "Error";
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    $b9cc6960093b095e$var$AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, "cause", {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || "Error";
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;


// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;



var $bdjQ6 = parcelRequire("bdjQ6");
var $19044a9fa7281693$require$Buffer = $bdjQ6.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject((0, $77146a31cb578292$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $31df7fcb8acaa73a$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $19044a9fa7281693$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(value) || (0, $77146a31cb578292$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $77146a31cb578292$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $19044a9fa7281693$export$2e2bcd8739ae039)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a2774d1dd3bec636$var$encode);
    } : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4a4d655613ae826e$var$encode;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $a2774d1dd3bec636$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $ec4d8e24b0699790$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;





"use strict";
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};




var $9tqwB = parcelRequire("9tqwB");



var $9tqwB = parcelRequire("9tqwB");

"use strict";
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $a2774d1dd3bec636$export$2e2bcd8739ae039);


"use strict";
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9a13f762833a66d0$export$2e2bcd8739ae039,
        FormData: $16325b87e107b4bc$export$2e2bcd8739ae039,
        Blob: $650c3d387ae3fbd4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $1bbd8fa0325c4f9a$exports = {};

$parcel$export($1bbd8fa0325c4f9a$exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export($1bbd8fa0325c4f9a$exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export($1bbd8fa0325c4f9a$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export($1bbd8fa0325c4f9a$exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $f9f874191f496b63$export$2e2bcd8739ae039 = (0, $9tqwB._)({}, $1bbd8fa0325c4f9a$exports, (0, $e4489594588108ef$export$2e2bcd8739ae039));


"use strict";
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(data, new (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $9tqwB._)({
        visitor: function(value, key, path, helpers) {
            if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).isNode && (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(formData) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $77146a31cb578292$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $7e146da7bba06216$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $24febbb5d340c733$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBuffer(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isStream(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isFile(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f1a69cd24a140b61$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $77146a31cb578292$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $19044a9fa7281693$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isResponse(data) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $77146a31cb578292$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(e, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $f9f874191f496b63$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $77146a31cb578292$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c7e8ef3e2bb241a6$var$$internals = Symbol("internals");
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : String(value);
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $77146a31cb578292$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $cf2275aca40d6d88$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(header) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(entry)) throw TypeError("Object iterator must return a key-value pair");
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $77146a31cb578292$export$2e2bcd8739ae039).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;


"use strict";
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $f6ac833a4b31e3dc$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $b9cc6960093b095e$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $77146a31cb578292$export$2e2bcd8739ae039).inherits($f6ac833a4b31e3dc$var$CanceledError, (0, $b9cc6960093b095e$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;







"use strict";
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;



const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $d592abf0a04957f1$export$2e2bcd8739ae039)(50, 250);
    return (0, $5603d643a9d93c92$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $f9f874191f496b63$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin), (0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $f9f874191f496b63$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === "undefined") return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push("secure");
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join("; ");
    },
    read (name) {
        if (typeof document === "undefined") return null;
        const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000, "/");
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $12188e34b7070552$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $f55e71b6c54c4376$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}



var $9tqwB = parcelRequire("9tqwB");


"use strict";
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039) ? (0, $9tqwB._)({}, thing) : thing;
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(target) && (0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $77146a31cb578292$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(Object.keys((0, $9tqwB._)({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $b00a7ead3edff84a$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $4a4d655613ae826e$export$2e2bcd8739ae039)((0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                "content-type",
                "content-length"
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $f9f874191f496b63$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $82d74b1a5a0a01da$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $534b3794da5c002d$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $2c92173995cdc070$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("Request aborted", (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : "Network Error";
            const err = new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(msg, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $7e146da7bba06216$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT : (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $de65761df8a598af$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $2ecf5cf4c0202afd$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $f9f874191f496b63$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");






const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $b9cc6960093b095e$export$2e2bcd8739ae039) ? err : new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;


const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $77146a31cb578292$export$2e2bcd8739ae039);
const $c2191f87f9ef3849$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $77146a31cb578292$export$2e2bcd8739ae039).global);
const { ReadableStream: $c2191f87f9ef3849$var$ReadableStream, TextEncoder: $c2191f87f9ef3849$var$TextEncoder } = (0, $77146a31cb578292$export$2e2bcd8739ae039).global;
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    env = (0, $77146a31cb578292$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $c2191f87f9ef3849$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $c2191f87f9ef3849$var$isFunction(envFetch) : typeof fetch === "function";
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction($c2191f87f9ef3849$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $c2191f87f9ef3849$var$TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new $c2191f87f9ef3849$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
            body: new $c2191f87f9ef3849$var$ReadableStream(),
            method: "POST",
            get duplex () {
                duplexAccessed = true;
                return "half";
            }
        }).headers.has("Content-Type");
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            "text",
            "arrayBuffer",
            "blob",
            "formData",
            "stream"
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $f9f874191f496b63$export$2e2bcd8739ae039).origin, {
                method: "POST",
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $77146a31cb578292$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
        if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $b00a7ead3edff84a$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + "").toLowerCase() : "text";
        let composedSignal = (0, $62bdf0498e608a4a$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: "POST",
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $de65761df8a598af$export$d9fadd12586c18d6)(requestContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $c626b6acbc30fe14$export$b0119225647bd83)(_request.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $77146a31cb578292$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = (0, $2qxEV._)((0, $9tqwB._)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    "status",
                    "statusText",
                    "headers"
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $77146a31cb578292$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
                const [onProgress, flush] = onDownloadProgress && (0, $de65761df8a598af$export$d9fadd12586c18d6)(responseContentLength, (0, $de65761df8a598af$export$c1b28109d46c3592)((0, $de65761df8a598af$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $c626b6acbc30fe14$export$b0119225647bd83)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || "text";
            let responseData = await resolvers[(0, $77146a31cb578292$export$2e2bcd8739ae039).findKey(resolvers, responseType) || "text"](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $2c92173995cdc070$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("Network Error", (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, $b9cc6960093b095e$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $c036c406f3928265$var$knownAdapters = {
    http: (0, $31df7fcb8acaa73a$export$2e2bcd8739ae039),
    xhr: (0, $2cabe869ce51dbf6$export$2e2bcd8739ae039),
    fetch: {
        get: $c2191f87f9ef3849$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $c036c406f3928265$var$getAdapter(adapters, config) {
    adapters = (0, $77146a31cb578292$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
        let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($c036c406f3928265$var$renderReason).join("\n") : " " + $c036c406f3928265$var$renderReason(reasons[0]) : "as no adapter specified";
        throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $c036c406f3928265$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $c036c406f3928265$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $a5e696f232d0dc12$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $36f1aa490c1da053$export$2e2bcd8739ae039)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $0cb2ce7608ace114$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $95be4ecd446de127$export$a4ad2735b021c132 = "1.13.2";



"use strict";
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $95be4ecd446de127$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("options must be an object", (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $b9cc6960093b095e$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $b9cc6960093b095e$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};



"use strict";
const $66f2b8a41463d1e8$var$validators = (0, $1ad671c27810423e$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $77146a31cb578292$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $1ad671c27810423e$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling("baseURL"),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $a98a53c8a75f9db0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3d132bbf7812485b$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $2ec1d7b86495f966$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $4a4d655613ae826e$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)(),
            response: new (0, $ec4d8e24b0699790$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $77146a31cb578292$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    $66f2b8a41463d1e8$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;






"use strict";
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $77146a31cb578292$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $4c852d2f6a5a0387$export$2e2bcd8739ae039)((0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $77146a31cb578292$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $3d132bbf7812485b$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $a5e696f232d0dc12$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $66f2b8a41463d1e8$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $f6ac833a4b31e3dc$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.CancelToken = (0, $f4994f37c883aea2$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.isCancel = (0, $36f1aa490c1da053$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.VERSION = (0, $95be4ecd446de127$export$a4ad2735b021c132);
$747d656b899e6115$var$axios.toFormData = (0, $19044a9fa7281693$export$2e2bcd8739ae039);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $b9cc6960093b095e$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $8145c4b68bfee186$export$2e2bcd8739ae039);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $ec03acb464b74212$export$2e2bcd8739ae039);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $3d132bbf7812485b$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $c7e8ef3e2bb241a6$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $24febbb5d340c733$export$2e2bcd8739ae039)((0, $77146a31cb578292$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $c036c406f3928265$export$2e2bcd8739ae039).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $a9353565c2e0947e$export$2e2bcd8739ae039);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a } = (0, $747d656b899e6115$export$2e2bcd8739ae039);





var $0d58d623e17e46e6$exports = {};
$0d58d623e17e46e6$exports = JSON.parse('[{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2018-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-06-01T00:00:00.000Z","value":2964.99995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-07-01T00:00:00.000Z","value":3192.4999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-08-01T00:00:00.000Z","value":3007.5001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-09-01T00:00:00.000Z","value":3016,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-10-01T00:00:00.000Z","value":3164.99995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-11-01T00:00:00.000Z","value":3452.00005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2019-12-01T00:00:00.000Z","value":3405.5000499999996,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-01-01T00:00:00.000Z","value":3372.0001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-02-01T00:00:00.000Z","value":3051,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-03-01T00:00:00.000Z","value":2654.9999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-04-01T00:00:00.000Z","value":2049,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-05-01T00:00:00.000Z","value":2334.49995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-06-01T00:00:00.000Z","value":2440.74995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-07-01T00:00:00.000Z","value":2466.5001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-08-01T00:00:00.000Z","value":2329.9999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-09-01T00:00:00.000Z","value":2541,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-10-01T00:00:00.000Z","value":2570.0001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-11-01T00:00:00.000Z","value":2361.7500499999996,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2020-12-01T00:00:00.000Z","value":3052.49995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-01-01T00:00:00.000Z","value":3233.4999000000003,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-02-01T00:00:00.000Z","value":3234.9998499999997,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-03-01T00:00:00.000Z","value":3457.5001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-04-01T00:00:00.000Z","value":3575,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-05-01T00:00:00.000Z","value":3372.4998499999997,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-06-01T00:00:00.000Z","value":3391.9998,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-07-01T00:00:00.000Z","value":3359.0000000000005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-08-01T00:00:00.000Z","value":3318.99985,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-09-01T00:00:00.000Z","value":3244.4999500000004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-10-01T00:00:00.000Z","value":3249.4999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-11-01T00:00:00.000Z","value":3154.5,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2021-12-01T00:00:00.000Z","value":2914.99995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-01-01T00:00:00.000Z","value":3085.00005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-02-01T00:00:00.000Z","value":3406.49985,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-03-01T00:00:00.000Z","value":2795.0001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-04-01T00:00:00.000Z","value":2613.5,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-05-01T00:00:00.000Z","value":2517.4999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-06-01T00:00:00.000Z","value":2596.99995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-07-01T00:00:00.000Z","value":2087.0000999999997,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-08-01T00:00:00.000Z","value":2174,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-09-01T00:00:00.000Z","value":2090.74995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-10-01T00:00:00.000Z","value":1970.0001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-11-01T00:00:00.000Z","value":2283.4999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2022-12-01T00:00:00.000Z","value":2397.7501,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-01-01T00:00:00.000Z","value":2323.7499,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-02-01T00:00:00.000Z","value":2641,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-03-01T00:00:00.000Z","value":2434.25005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-04-01T00:00:00.000Z","value":2424.74995,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-05-01T00:00:00.000Z","value":2346.5,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-06-01T00:00:00.000Z","value":2239.7499,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-07-01T00:00:00.000Z","value":2225.5,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-08-01T00:00:00.000Z","value":2435.5,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-09-01T00:00:00.000Z","value":2345,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-10-01T00:00:00.000Z","value":2130,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-11-01T00:00:00.000Z","value":2117.5,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2023-12-01T00:00:00.000Z","value":2162,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","displayName":"BASF (DE000BASF111)"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2018-12-01T00:00:00.000Z","value":15723.2,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-01-01T00:00:00.000Z","value":13778.16,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-02-01T00:00:00.000Z","value":14516.6,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-03-01T00:00:00.000Z","value":15370.279999999999,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-04-01T00:00:00.000Z","value":17020.28,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-05-01T00:00:00.000Z","value":18766.28,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-06-01T00:00:00.000Z","value":15700.84,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-07-01T00:00:00.000Z","value":17760.16,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-08-01T00:00:00.000Z","value":18885.56,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-09-01T00:00:00.000Z","value":18916.28,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-10-01T00:00:00.000Z","value":20609.280000000002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-11-01T00:00:00.000Z","value":22967.96,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2019-12-01T00:00:00.000Z","value":24334.36,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-01-01T00:00:00.000Z","value":26138.52,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-02-01T00:00:00.000Z","value":28005.8,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-03-01T00:00:00.000Z","value":24902.96,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-04-01T00:00:00.000Z","value":22030,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-05-01T00:00:00.000Z","value":26579.64,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-06-01T00:00:00.000Z","value":28952.879999999997,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-07-01T00:00:00.000Z","value":32510.719999999998,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-08-01T00:00:00.000Z","value":35874.4,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-09-01T00:00:00.000Z","value":44775.159999999996,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-10-01T00:00:00.000Z","value":39751.52,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-11-01T00:00:00.000Z","value":37223.44,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2020-12-01T00:00:00.000Z","value":41016.04,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-01-01T00:00:00.000Z","value":43253.2,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-02-01T00:00:00.000Z","value":44402.52,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-03-01T00:00:00.000Z","value":42409.36,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-04-01T00:00:00.000Z","value":41886.6,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-05-01T00:00:00.000Z","value":43522.6,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-06-01T00:00:00.000Z","value":40664.2,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-07-01T00:00:00.000Z","value":46203.28,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-08-01T00:00:00.000Z","value":49065.68,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-09-01T00:00:00.000Z","value":51623.92,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-10-01T00:00:00.000Z","value":49189.64,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-11-01T00:00:00.000Z","value":51463.12,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2021-12-01T00:00:00.000Z","value":58253.48,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-01-01T00:00:00.000Z","value":62712.36,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-02-01T00:00:00.000Z","value":62028.4,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-03-01T00:00:00.000Z","value":58484.159999999996,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-04-01T00:00:00.000Z","value":63087.24,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-05-01T00:00:00.000Z","value":59829.240000000005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-06-01T00:00:00.000Z","value":55530.240000000005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-07-01T00:00:00.000Z","value":53306.479999999996,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-08-01T00:00:00.000Z","value":63133.00000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-09-01T00:00:00.000Z","value":63158.72000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-10-01T00:00:00.000Z","value":56709.079999999994,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-11-01T00:00:00.000Z","value":60581.079999999994,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2022-12-01T00:00:00.000Z","value":56747.64,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-01-01T00:00:00.000Z","value":48726.799999999996,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-02-01T00:00:00.000Z","value":53398.2,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-03-01T00:00:00.000Z","value":54402.840000000004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-04-01T00:00:00.000Z","value":60652.880000000005,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-05-01T00:00:00.000Z","value":61775.8,"incomeFromCapital":6423.920219784079,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-05-01T00:00:00.000Z","value":0,"incomeFromCapital":6423.920219784079,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":6423.920219784079,"Date (Month)":"2023-05","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-06-01T00:00:00.000Z","value":57240.904,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-07-01T00:00:00.000Z","value":60693.74,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-08-01T00:00:00.000Z","value":60626.624,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-09-01T00:00:00.000Z","value":59402.794,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-10-01T00:00:00.000Z","value":54947.502,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-11-01T00:00:00.000Z","value":56135.326,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2023-12-01T00:00:00.000Z","value":59789.986000000004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","displayName":"Apple (US0378331005)"},{"date":"2012-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2012-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2012-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2012-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2013-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2014-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2015-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2016-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2017-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2018-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2019-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2020-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2021-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-01-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-02-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-03-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-04-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-05-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-06-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-07-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-08-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-09-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-10-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-11-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2022-12-01T00:00:00.000Z","value":400000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-01-01T00:00:00.000Z","value":493500,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-02-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-03-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-04-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-05-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-06-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-07-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-08-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-09-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-10-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-11-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2023-12-01T00:00:00.000Z","value":495000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","displayName":"Real estate asset"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":550000,"inflowType":"inflow","inflowValue":550000,"Date (Month)":"2018-06","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-07-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-08-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-09-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-10-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-11-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2018-12-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-01-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-02-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-03-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-04-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-05-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-06-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-07-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-08-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-09-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-10-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-11-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2019-12-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-01-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-02-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-03-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-04-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-05-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-06-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-07-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-08-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-09-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-10-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-11-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2020-12-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-01-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-02-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-03-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-04-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-05-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-06-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-07-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-08-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-09-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-10-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-11-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2021-12-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-01-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-02-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-03-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-04-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-05-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-06-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-07-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-08-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-09-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-10-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-11-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2022-12-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-01-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-02-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-03-01T00:00:00.000Z","value":550000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-04-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-05-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-06-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-07-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-08-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-09-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-10-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-11-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2023-12-01T00:00:00.000Z","value":549456.75,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","displayName":"Bank for real estate"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":100000,"inflowType":"inflow","inflowValue":100000,"Date (Month)":"2015-04","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-05-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-06-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-07-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-08-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-09-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-10-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-11-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2015-12-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-01-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-02-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-03-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-04-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-05-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-06-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-07-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-08-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-09-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-10-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-11-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2016-12-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-01-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-02-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-03-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-04-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-05-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-06-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-07-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-08-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-09-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-10-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-11-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2017-12-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-01-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-02-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-03-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-04-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-05-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-06-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-07-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-08-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-09-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-10-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-11-01T00:00:00.000Z","value":100000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2018-12-01T00:00:00.000Z","value":99954.5378,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-01-01T00:00:00.000Z","value":99954.5378,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-02-01T00:00:00.000Z","value":99954.5378,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-03-01T00:00:00.000Z","value":99954.5378,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-04-01T00:00:00.000Z","value":99954.5378,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-05-01T00:00:00.000Z","value":99954.5378,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-06-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-07-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-08-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-09-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-10-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-11-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2019-12-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-01-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-02-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-03-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-04-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-05-01T00:00:00.000Z","value":96329.63780000001,"incomeFromCapital":0,"inflows":2000,"inflowType":"inflow","inflowValue":2000,"Date (Month)":"2020-05","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-06-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-07-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-08-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-09-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-10-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-11-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2020-12-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-01-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-02-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-03-01T00:00:00.000Z","value":98329.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-04-01T00:00:00.000Z","value":98383.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-05-01T00:00:00.000Z","value":98383.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-06-01T00:00:00.000Z","value":98383.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-07-01T00:00:00.000Z","value":98383.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-08-01T00:00:00.000Z","value":98383.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-09-01T00:00:00.000Z","value":98383.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-10-01T00:00:00.000Z","value":98513.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-11-01T00:00:00.000Z","value":98513.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2021-12-01T00:00:00.000Z","value":98513.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-01-01T00:00:00.000Z","value":98513.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-02-01T00:00:00.000Z","value":98513.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-03-01T00:00:00.000Z","value":98513.63780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-04-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-05-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-06-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-07-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-08-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-09-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-10-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-11-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2022-12-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-01-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-02-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-03-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-04-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-05-01T00:00:00.000Z","value":98666.13780000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-06-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-07-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-08-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-09-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-10-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-11-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2023-12-01T00:00:00.000Z","value":107749.58510000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","displayName":"Bank for brokerage"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2018-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2019-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":20000,"inflowType":"inflow","inflowValue":20000,"Date (Month)":"2020-01","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-02-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-03-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-04-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-05-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-06-01T00:00:00.000Z","value":18000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-07-01T00:00:00.000Z","value":18000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-08-01T00:00:00.000Z","value":18000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-09-01T00:00:00.000Z","value":18000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-10-01T00:00:00.000Z","value":14833,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-11-01T00:00:00.000Z","value":16983,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2020-11","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2020-12-01T00:00:00.000Z","value":19133,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2020-12","Date (Year)":"2020","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-01-01T00:00:00.000Z","value":21283,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-01","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-02-01T00:00:00.000Z","value":23433,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-02","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-03-01T00:00:00.000Z","value":25036.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-03","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-04-01T00:00:00.000Z","value":27186.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-04","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-05-01T00:00:00.000Z","value":29336.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-05","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-06-01T00:00:00.000Z","value":31486.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-06","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-07-01T00:00:00.000Z","value":33636.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-07","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-08-01T00:00:00.000Z","value":35786.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-08","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-09-01T00:00:00.000Z","value":37936.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-09","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-10-01T00:00:00.000Z","value":40086.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-11-01T00:00:00.000Z","value":42236.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-11","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2021-12-01T00:00:00.000Z","value":44386.79,"incomeFromCapital":0,"inflows":6500,"inflowType":"inflow","inflowValue":6500,"Date (Month)":"2021-12","Date (Year)":"2021","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-01-01T00:00:00.000Z","value":46536.79,"incomeFromCapital":0,"inflows":4850,"inflowType":"inflow","inflowValue":4850,"Date (Month)":"2022-01","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-02-01T00:00:00.000Z","value":47536.79,"incomeFromCapital":0,"inflows":5000,"inflowType":"inflow","inflowValue":5000,"Date (Month)":"2022-02","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-03-01T00:00:00.000Z","value":48536.79,"incomeFromCapital":0,"inflows":7700,"inflowType":"inflow","inflowValue":7700,"Date (Month)":"2022-03","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-04-01T00:00:00.000Z","value":50846.79,"incomeFromCapital":0,"inflows":10000,"inflowType":"inflow","inflowValue":10000,"Date (Month)":"2022-04","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-05-01T00:00:00.000Z","value":54846.79,"incomeFromCapital":0,"inflows":6250,"inflowType":"inflow","inflowValue":6250,"Date (Month)":"2022-05","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-06-01T00:00:00.000Z","value":58096.79,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2022-06","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-07-01T00:00:00.000Z","value":60846.79,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-08-01T00:00:00.000Z","value":63996.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2022-08","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-09-01T00:00:00.000Z","value":66746.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2022-09","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-10-01T00:00:00.000Z","value":69496.79000000001,"incomeFromCapital":0,"inflows":6950,"inflowType":"inflow","inflowValue":6950,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-11-01T00:00:00.000Z","value":71946.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2022-11","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2022-12-01T00:00:00.000Z","value":74696.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2022-12","Date (Year)":"2022","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-01-01T00:00:00.000Z","value":77446.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2023-01","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-02-01T00:00:00.000Z","value":80196.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2023-02","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-03-01T00:00:00.000Z","value":82946.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2023-03","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-04-01T00:00:00.000Z","value":85443.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2023-04","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-05-01T00:00:00.000Z","value":88193.79000000001,"incomeFromCapital":0,"inflows":6750,"inflowType":"inflow","inflowValue":6750,"Date (Month)":"2023-05","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-06-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-07-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-08-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-09-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-10-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-11-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2023-12-01T00:00:00.000Z","value":90943.79000000001,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","displayName":"Bank for cost of living"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":20000,"inflowType":"inflow","inflowValue":20000,"Date (Month)":"2017-12","Date (Year)":"2017","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-01-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-02-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-03-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-04-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-05-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-06-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-07-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-08-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-09-01T00:00:00.000Z","value":20000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-10-01T00:00:00.000Z","value":20000,"incomeFromCapital":2,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-10-01T00:00:00.000Z","value":0,"incomeFromCapital":2,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":2,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-11-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2018-12-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-01-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-02-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-03-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-04-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-05-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-06-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-07-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-08-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-09-01T00:00:00.000Z","value":20002,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-10-01T00:00:00.000Z","value":20002,"incomeFromCapital":2,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-10-01T00:00:00.000Z","value":0,"incomeFromCapital":2,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":2,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-11-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2019-12-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-01-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-02-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-03-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-04-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-05-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-06-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-07-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-08-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-09-01T00:00:00.000Z","value":20004,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-10-01T00:00:00.000Z","value":20004,"incomeFromCapital":2,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-10-01T00:00:00.000Z","value":0,"incomeFromCapital":2,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":2,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-11-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2020-12-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-01-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-02-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-03-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-04-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-05-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-06-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-07-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-08-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-09-01T00:00:00.000Z","value":20006,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-10-01T00:00:00.000Z","value":20006,"incomeFromCapital":2,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-10-01T00:00:00.000Z","value":0,"incomeFromCapital":2,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":2,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-11-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2021-12-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-01-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-02-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-03-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-04-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-05-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-06-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-07-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-08-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-09-01T00:00:00.000Z","value":20008,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-10-01T00:00:00.000Z","value":20008,"incomeFromCapital":2,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-10-01T00:00:00.000Z","value":0,"incomeFromCapital":2,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":2,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-11-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2022-12-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-01-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-02-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-03-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-04-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-05-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-06-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-07-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-08-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-09-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-10-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-11-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2023-12-01T00:00:00.000Z","value":20010,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","displayName":"Bank for deposit"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2018-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2019-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2020-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":40000,"inflowType":"inflow","inflowValue":40000,"Date (Month)":"2021-07","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-08-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-09-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-10-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-11-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2021-12-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-01-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-02-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-03-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-04-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-05-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-06-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-07-01T00:00:00.000Z","value":40000,"incomeFromCapital":400,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-07-01T00:00:00.000Z","value":0,"incomeFromCapital":400,"inflows":0,"inflowType":"incomeFromCapital","inflowValue":400,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-08-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-09-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-10-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-11-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2022-12-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-01-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-01","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-02-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-03-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-04-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-05-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-06-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-07-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-08-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-09-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-10-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-11-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2023-12-01T00:00:00.000Z","value":40000,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","displayName":"Bank for deposit 2"},{"date":"2012-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-09","Date (Year)":"2012","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2012-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-10","Date (Year)":"2012","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2012-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-11","Date (Year)":"2012","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2012-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2012-12","Date (Year)":"2012","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-01","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-02","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-03","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-04","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-05","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-06","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-07","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-08","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-09","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-10","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-11","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2013-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2013-12","Date (Year)":"2013","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-01","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-02","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-03","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-04","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-05","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-06","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-07","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-08","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-09","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-10","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-11","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2014-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2014-12","Date (Year)":"2014","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-01","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-02","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-03","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-04","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-05","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-06","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-07","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-08","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-09","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-10","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-11","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2015-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2015-12","Date (Year)":"2015","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-01","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-02","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-03","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-04","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-05","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-06","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-07","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-08","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-09","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-10","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-11","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2016-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2016-12","Date (Year)":"2016","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-01","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-02","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-03","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-04","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-05","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-06","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-07","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-08","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-09","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-10","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-11","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2017-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2017-12","Date (Year)":"2017","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-01","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-02","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-03","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-04","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-05","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-06","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-07","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-08","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-09","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-10","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-11","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2018-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2018-12","Date (Year)":"2018","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-01","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-02","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-03","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-04","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-05","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-06","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-07","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-08","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-09","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-10","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-11","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2019-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2019-12","Date (Year)":"2019","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-01","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-02","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-03","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-04","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-05","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-06","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-07","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-08","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-09","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-10","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-11","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2020-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2020-12","Date (Year)":"2020","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-01","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-02","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-03","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-04","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-05","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-06","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-07","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-08","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-09","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-10","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-11","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2021-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2021-12","Date (Year)":"2021","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-01","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-02-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-02","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-03-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-03","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-04-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-04","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-05-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-05","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-06-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-06","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-07-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-07","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-08-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-08","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-09-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-09","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-10-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-10","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-11-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-11","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2022-12-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2022-12","Date (Year)":"2022","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-01-01T00:00:00.000Z","value":0,"incomeFromCapital":0,"inflows":10137.8751,"inflowType":"inflow","inflowValue":10137.8751,"Date (Month)":"2023-01","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-02-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-02","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-03-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-03","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-04-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-04","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-05-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-05","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-06-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-06","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-07-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-07","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-08-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-08","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-09-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-09","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-10-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-10","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-11-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-11","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"},{"date":"2023-12-01T00:00:00.000Z","value":10137.8751,"incomeFromCapital":0,"inflows":0,"inflowType":"inflow","inflowValue":0,"Date (Month)":"2023-12","Date (Year)":"2023","category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","displayName":"Bank for fx deposit"}]');


var $f4babe0724a8aa19$exports = {};
$f4babe0724a8aa19$exports = JSON.parse('[{"category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5SYB8","date":1701508602330,"displayName":"BASF (DE000BASF111)","purchaseValue":3604.9999999999995,"currentValue":2162,"currency":"EUR","payoutsSincePurchase":361.5,"feesSincePurchase":-19.9,"roi":"-30,55\xa0%","roiAnnualData":[{"roiAnnual":-0.07635740974504368,"weight":50}],"roiAnnual":"-7,64\xa0%","formattingLevel":null},{"category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","assetId":"BBG001S5N8V8","date":1701508602330,"displayName":"Apple (US0378331005)","purchaseValue":60282.64599999999,"currentValue":65021.600000000006,"currency":"USD","payoutsSincePurchase":307.27500000000003,"feesSincePurchase":-101.66,"roi":"8,20\xa0%","roiAnnualData":[{"roiAnnual":0.015612206060211076,"weight":340}],"roiAnnual":"1,56\xa0%","formattingLevel":null},{"category":"realEstate","accountId":"0LBYVRlkkfRWVNk0y2c4a","accountName":"Real estate asset","assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1701508602330,"displayName":"Real estate asset","purchaseValue":400000,"currentValue":495000,"currency":"EUR","payoutsSincePurchase":0,"feesSincePurchase":0,"roi":"23,75\xa0%","roiAnnualData":[{"roiAnnual":0.01910741560370588,"weight":1}],"roiAnnual":"1,91\xa0%","formattingLevel":null},{"category":"deposits","accountId":"-b3jqm5IvL6kobgCcdICR","accountName":"Bank for real estate","assetId":"-b3jqm5IvL6kobgCcdICR","date":1701508602330,"displayName":"Bank for real estate","purchaseValue":0,"currentValue":549456.75,"currency":"EUR","payoutsSincePurchase":0,"feesSincePurchase":0,"roi":"\u221E\xa0%","roiAnnualData":[{"roiAnnual":null,"weight":-543.25},{"roiAnnual":null,"weight":550000}],"roiAnnual":"NaN\xa0%","formattingLevel":null},{"category":"deposits","accountId":"AUAMQVhQaeLIHriycINeL","accountName":"Bank for brokerage","assetId":"AUAMQVhQaeLIHriycINeL","date":1701508602330,"displayName":"Bank for brokerage","purchaseValue":0,"currentValue":107749.58510000001,"currency":"EUR","payoutsSincePurchase":0,"feesSincePurchase":0,"roi":"-\u221E\xa0%","roiAnnualData":[{"roiAnnual":null,"weight":69},{"roiAnnual":null,"weight":-10},{"roiAnnual":null,"weight":-15},{"roiAnnual":null,"weight":9083.4473},{"roiAnnual":null,"weight":-15.5622},{"roiAnnual":null,"weight":162.5},{"roiAnnual":null,"weight":-3605},{"roiAnnual":null,"weight":-29.9},{"roiAnnual":null,"weight":2000},{"roiAnnual":null,"weight":130},{"roiAnnual":null,"weight":100000},{"roiAnnual":null,"weight":-19.9}],"roiAnnual":"NaN\xa0%","formattingLevel":null},{"category":"deposits","accountId":"CJ2-NiJHmIDdTI_f9UuXs","accountName":"Bank for cost of living","assetId":"CJ2-NiJHmIDdTI_f9UuXs","date":1701508602332,"displayName":"Bank for cost of living","purchaseValue":0,"currentValue":90943.79000000001,"currency":"EUR","payoutsSincePurchase":0,"feesSincePurchase":0,"roi":"-\u221E\xa0%","roiAnnualData":[{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":5000},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-317},{"roiAnnual":null,"weight":-253},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":4850},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-2000},{"roiAnnual":null,"weight":100},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":100},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6250},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":400},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-2350},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":7700},{"roiAnnual":null,"weight":10000},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-4500},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-546.21},{"roiAnnual":null,"weight":20000},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-3890},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-2500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":6500},{"roiAnnual":null,"weight":6750},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-1500},{"roiAnnual":null,"weight":-2850},{"roiAnnual":null,"weight":-2850}],"roiAnnual":"NaN\xa0%","formattingLevel":null},{"category":"deposits","accountId":"EXWO7q0zVnuwvj4yJ305w","accountName":"Bank for deposit","assetId":"EXWO7q0zVnuwvj4yJ305w","date":1701508602341,"displayName":"Bank for deposit","purchaseValue":358420020,"currentValue":20010,"currency":"EUR","payoutsSincePurchase":10.000999800059978,"feesSincePurchase":0,"roi":"-50,00\xa0%","roiAnnualData":[{"roiAnnual":-0.12530456364704712,"weight":2},{"roiAnnual":-0.6883341934874894,"weight":1100},{"roiAnnual":-0.15293742440995417,"weight":2},{"roiAnnual":-0.2732660974292125,"weight":2},{"roiAnnual":-0.8058808485599509,"weight":18900},{"roiAnnual":-0.19627672735661306,"weight":2},{"roiAnnual":-0.4467147205806653,"weight":2}],"roiAnnual":"-79,91\xa0%","formattingLevel":null},{"category":"deposits","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","accountName":"Bank for deposit 2","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","date":1701508602341,"displayName":"Bank for deposit 2","purchaseValue":1600000000,"currentValue":40000,"currency":"EUR","payoutsSincePurchase":0,"feesSincePurchase":0,"roi":"-100,00\xa0%","roiAnnualData":[{"roiAnnual":-0.987391633831109,"weight":40000}],"roiAnnual":"-98,74\xa0%","formattingLevel":null},{"category":"deposits","accountId":"lyFDhscwJibqb-sf3pocN","accountName":"Bank for fx deposit","assetId":"lyFDhscwJibqb-sf3pocN","date":1701508602342,"displayName":"Bank for fx deposit","purchaseValue":0,"currentValue":10137.8751,"currency":"CHF","payoutsSincePurchase":0,"feesSincePurchase":0,"roi":"\u221E\xa0%","roiAnnualData":[{"roiAnnual":null,"weight":10137.8751}],"roiAnnual":"\u221E\xa0%","formattingLevel":null},{"category":"stocks","accountId":"SKxazU1TIynqfmDvfUR1g","accountName":"DKB Depot","date":1701508602342,"displayName":"\u03A3","purchaseValue":63887.64599999999,"currentValue":67183.6,"payoutsSincePurchase":668.7750000000001,"feesSincePurchase":-121.56,"roi":"6,02\xa0%","roiAnnual":"1,56\xa0%","formattingLevel":1},{"category":"stocks","accountName":"\u03A3","date":1701508602342,"displayName":"\u03A3","purchaseValue":63887.64599999999,"currentValue":67183.6,"payoutsSincePurchase":668.7750000000001,"feesSincePurchase":-121.56,"roi":"6,02\xa0%","roiAnnual":"1,56\xa0%","formattingLevel":0}]');


var $8a9daab45a308cb9$exports = {};
$8a9daab45a308cb9$exports = JSON.parse('{"stocks":{"SKxazU1TIynqfmDvfUR1g":{"BBG001S5N8V8":[{"id":"EcHfZXVMS395YtxSQQbiB","userId":"TestUserTier2Loadedxx","date":1541030400000,"accountId":"SKxazU1TIynqfmDvfUR1g","figi":"BBG001S5N8V8","providerAssetId":"AAPL","transactionType":"purchase","displayName":"Apple","displaySymbol":"US0378331005","errorId":null,"projectId":null,"isManuallyAdjusted":false,"isSimulated":false,"rebasedOriginalPrice":50.5,"rebasedPrice":44.3255,"rebasedAmount":400,"rebasedAmountSold":-60,"rebasedAmountSoldWhenSimulated":-60,"transactionOriginalPrice":202,"transactionCurrency":"USD","transactionPrice":177.3019,"transactionAmount":100,"transactionAmountSold":-15,"splitRatioNew":null,"splitRatioOld":null,"tags":{"type":null,"indexed":null,"recurring":null},"sortingOrderWithinMonth":null,"currency":"USD","linkedTransactions":[{"id":"7rcZwnrwaZIKhSQp60rPl","category":"stocks","tags":{"date":1682985600000,"type":"sale","isSimulated":false,"rebasedPrice":151.39078887368902,"rebasedAmount":60}}],"category":"stocks","assetId":"BBG001S5N8V8","amount":400,"originalUnitPrice":50.5,"unitPrice":44.3255,"accountName":"DKB Depot","openAmount":340,"unsold":340,"rowType":"purchase","positionOnDate":400,"positionsPerProjectId":{"null":400},"valueOnDateTransactionCurrency":20200,"valueOnDate":17730.2},{"date":1638316800000,"assetId":"BBG001S5N8V8","rowType":"kpi.referenceBaseline","currency":"USD","displayName":"Apple","displaySymbol":"US0378331005","accountName":"DKB Depot","positionOnDate":400,"positionsPerProjectId":{"null":400},"valueOnDateTransactionCurrency":65908,"valueOnDate":58253.48},{"date":1669852800000,"assetId":"BBG001S5N8V8","rowType":"kpi.baseline","currency":"USD","displayName":"Apple","displaySymbol":"US0378331005","accountName":"DKB Depot","positionOnDate":400,"positionsPerProjectId":{"null":400},"valueOnDateTransactionCurrency":59324,"valueOnDate":56747.64},{"id":"7rcZwnrwaZIKhSQp60rPl","userId":"TestUserTier2Loadedxx","date":1682985600000,"accountId":"SKxazU1TIynqfmDvfUR1g","figi":"BBG001S5N8V8","providerAssetId":"AAPL","transactionType":"sale","displayName":"Apple","displaySymbol":"US0378331005","errorId":null,"projectId":null,"isManuallyAdjusted":false,"isSimulated":false,"rebasedOriginalPrice":166,"rebasedPrice":151.3908,"rebasedAmount":-60,"rebasedAmountSold":0,"rebasedAmountSoldWhenSimulated":null,"transactionOriginalPrice":166,"transactionCurrency":"USD","transactionPrice":151.3908,"transactionAmount":-60,"transactionAmountSold":0,"splitRatioNew":null,"splitRatioOld":null,"tags":{"purchaseValue":2659.527780215922,"incomeFromCapital":6423.91955220542,"unableToMapToProviderAssetId":false},"sortingOrderWithinMonth":null,"currency":"USD","linkedTransactions":[{"id":"EcHfZXVMS395YtxSQQbiB","category":"stocks","tags":{"date":1541030400000,"type":"purchase","isSimulated":false,"rebasedPrice":44.3254630035987,"rebasedAmount":60}}],"category":"stocks","assetId":"BBG001S5N8V8","amount":-60,"originalUnitPrice":166,"unitPrice":151.3908,"accountName":"DKB Depot","openAmount":-60,"rowType":"sale","positionOnDate":340,"positionsPerProjectId":{"null":340},"valueOnDateTransactionCurrency":56440,"valueOnDate":51472.872},{"date":1701475200000,"assetId":"BBG001S5N8V8","rowType":"kpi.current","currency":"USD","displayName":"Apple","displaySymbol":"US0378331005","accountName":"DKB Depot","positionOnDate":340,"positionsPerProjectId":{"null":340},"valueOnDateTransactionCurrency":65021.600000000006,"valueOnDate":59789.986000000004}],"BBG001S5SYB8":[{"id":"8Dazmw3aq9ftU5tkiNdfY","userId":"TestUserTier2Loadedxx","date":1556755200000,"accountId":"SKxazU1TIynqfmDvfUR1g","figi":"BBG001S5SYB8","providerAssetId":"BAS.F","transactionType":"purchase","displayName":"BASF","displaySymbol":"DE000BASF111","errorId":null,"projectId":null,"isManuallyAdjusted":false,"isSimulated":false,"rebasedOriginalPrice":72.1,"rebasedPrice":72.1,"rebasedAmount":50,"rebasedAmountSold":0,"rebasedAmountSoldWhenSimulated":0,"transactionOriginalPrice":72.1,"transactionCurrency":"EUR","transactionPrice":72.1,"transactionAmount":50,"transactionAmountSold":0,"splitRatioNew":null,"splitRatioOld":null,"tags":{"type":null,"indexed":null,"recurring":null},"sortingOrderWithinMonth":null,"currency":"EUR","linkedTransactions":[],"category":"stocks","assetId":"BBG001S5SYB8","amount":50,"originalUnitPrice":72.1,"unitPrice":72.1,"accountName":"DKB Depot","openAmount":50,"rowType":"purchase","positionOnDate":50,"positionsPerProjectId":{"null":50},"valueOnDateTransactionCurrency":3604.9999999999995,"valueOnDate":3604.9999999999995},{"date":1638316800000,"assetId":"BBG001S5SYB8","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"BASF","displaySymbol":"DE000BASF111","accountName":"DKB Depot","positionOnDate":50,"positionsPerProjectId":{"null":50},"valueOnDateTransactionCurrency":2914.99995,"valueOnDate":2914.99995},{"date":1669852800000,"assetId":"BBG001S5SYB8","rowType":"kpi.baseline","currency":"EUR","displayName":"BASF","displaySymbol":"DE000BASF111","accountName":"DKB Depot","positionOnDate":50,"positionsPerProjectId":{"null":50},"valueOnDateTransactionCurrency":2397.7501,"valueOnDate":2397.7501},{"date":1701475200000,"assetId":"BBG001S5SYB8","rowType":"kpi.current","currency":"EUR","displayName":"BASF","displaySymbol":"DE000BASF111","accountName":"DKB Depot","positionOnDate":50,"positionsPerProjectId":{"null":50},"valueOnDateTransactionCurrency":2162,"valueOnDate":2162}],"BAS.F":[{"id":"y-Fr26F2C6vERrrQL-FB7","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Transaktionsgeb\xfchren Kauf BASF","amount":-19.9,"currency":"EUR","accountCurrencyAmount":-19.9,"fxAmount":null,"fxCurrency":null,"date":1556755200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-fees","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[{"id":"8Dazmw3aq9ftU5tkiNdfY","category":"stocks","tags":{"linkType":"fee-to-transaction"}},{"id":"iO2r1oCZVIMbUJT-Ggumx","category":"stocks","tags":{"linkType":"fee-to-transaction"}}],"category":"stocks","assetId":"BAS.F","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-19.9,"transactionPrice":-19.9,"transactionCurrency":"EUR","openAmount":-19.9,"rebasedAmount":-19.9,"displayName":"Bank for brokerage","rowType":"fees","positionOnDate":0},{"id":"-wuGAmqRhO5ttBrQhvSSf","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Dividenden / Zinsen","amount":69,"currency":"EUR","accountCurrencyAmount":69,"fxAmount":null,"fxCurrency":null,"date":1615766400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-dividend","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"stocks","assetId":"BAS.F","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":69,"transactionPrice":69,"transactionCurrency":"EUR","openAmount":69,"rebasedAmount":69,"displayName":"Bank for brokerage","rowType":"dividend","positionOnDate":0},{"id":"T5XUL37Ptjma52D0MydQR","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Dividenden / Zinsen","amount":130,"currency":"EUR","accountCurrencyAmount":130,"fxAmount":null,"fxCurrency":null,"date":1631664000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-dividend","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"stocks","assetId":"BAS.F","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":130,"transactionPrice":130,"transactionCurrency":"EUR","openAmount":130,"rebasedAmount":130,"displayName":"Bank for brokerage","rowType":"dividend","positionOnDate":0},{"date":1638316800000,"assetId":"BAS.F","rowType":"kpi.referenceBaseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"id":"MoTxK3yaKV3JRyV5v8vNU","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Dividenden / Zinsen","amount":162.5,"currency":"EUR","accountCurrencyAmount":162.5,"fxAmount":null,"fxCurrency":null,"date":1647302400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-dividend","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"stocks","assetId":"BAS.F","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":162.5,"transactionPrice":162.5,"transactionCurrency":"EUR","openAmount":162.5,"rebasedAmount":162.5,"displayName":"Bank for brokerage","rowType":"dividend","positionOnDate":0},{"date":1669852800000,"assetId":"BAS.F","rowType":"kpi.baseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"date":1701475200000,"assetId":"BAS.F","rowType":"kpi.current","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0}],"SKxazU1TIynqfmDvfUR1g":[{"id":"EE5FgU0hKIz5o_LMvkjWL","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Kontof\xfchrungsgeb\xfchren ","amount":-15,"currency":"EUR","accountCurrencyAmount":-15,"fxAmount":null,"fxCurrency":null,"date":1614556800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-costs","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"SKxazU1TIynqfmDvfUR1g","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"stocks","assetId":"SKxazU1TIynqfmDvfUR1g","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-15,"transactionPrice":-15,"transactionCurrency":"EUR","openAmount":-15,"rebasedAmount":-15,"displayName":"Bank for brokerage","rowType":"costs","positionOnDate":0},{"date":1638316800000,"assetId":"SKxazU1TIynqfmDvfUR1g","rowType":"kpi.referenceBaseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"id":"4sni0J65uwDx2QKIIqnTz","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Kontof\xfchrungsgeb\xfchren","amount":-10,"currency":"EUR","accountCurrencyAmount":-10,"fxAmount":null,"fxCurrency":null,"date":1646092800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-costs","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"SKxazU1TIynqfmDvfUR1g","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"stocks","assetId":"SKxazU1TIynqfmDvfUR1g","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-10,"transactionPrice":-10,"transactionCurrency":"EUR","openAmount":-10,"rebasedAmount":-10,"displayName":"Bank for brokerage","rowType":"costs","positionOnDate":0},{"date":1669852800000,"assetId":"SKxazU1TIynqfmDvfUR1g","rowType":"kpi.baseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"date":1701475200000,"assetId":"SKxazU1TIynqfmDvfUR1g","rowType":"kpi.current","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0}],"AAPL":[{"id":"RG2Ix5aAKpCHvWhgIWkg-","userId":"TestUserTier2Loadedxx","accountId":"SKxazU1TIynqfmDvfUR1g","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Transaktionsgeb\xfchren Kauf AAPL","amount":-29.9,"currency":"EUR","accountCurrencyAmount":-29.9,"fxAmount":null,"fxCurrency":null,"date":1541030400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-fees","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"AAPL","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[{"id":"E-kX0-PILO-5P-_Bdsyx4","category":"stocks","tags":{"type":"fee-to-transaction"}},{"id":"EcHfZXVMS395YtxSQQbiB","category":"stocks","tags":{"linkType":"fee-to-transaction"}}],"category":"stocks","assetId":"AAPL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-29.9,"transactionPrice":-29.9,"transactionCurrency":"EUR","openAmount":-29.9,"rebasedAmount":-29.9,"displayName":"Bank for brokerage","rowType":"fees","positionOnDate":0},{"date":1638316800000,"assetId":"AAPL","rowType":"kpi.referenceBaseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"date":1669852800000,"assetId":"AAPL","rowType":"kpi.baseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"date":1701475200000,"assetId":"AAPL","rowType":"kpi.current","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0}]}},"realEstate":{"0LBYVRlkkfRWVNk0y2c4a":{"0LBYVRlkkfRWVNk0y2c4a":[{"id":"7TLzk2epzuio98ia27Z15","userId":"TestUserTier2Loadedxx","accountId":"0LBYVRlkkfRWVNk0y2c4a","date":1346457600000,"price":400000,"currency":"EUR","originalPrice":400000,"transactionType":"purchase","valid":true,"projectId":null,"linkedTransactions":[],"isSimulated":null,"amount":true,"sortingOrderWithinMonth":0,"tags":{},"category":"realEstate","assetId":"0LBYVRlkkfRWVNk0y2c4a","originalUnitPrice":400000,"unitPrice":400000,"accountName":"Real estate asset","transactionAmount":true,"rebasedAmount":true,"transactionPrice":400000,"transactionCurrency":"EUR","openAmount":1,"displayName":"Real estate asset","rowType":"purchase","positionOnDate":true,"positionsPerProjectId":{"null":true},"valueOnDateTransactionCurrency":400000,"valueOnDate":400000},{"date":1638316800000,"assetId":"0LBYVRlkkfRWVNk0y2c4a","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"Real estate asset","accountName":"Real estate asset","positionOnDate":1,"positionsPerProjectId":{"null":1},"valueOnDateTransactionCurrency":400000,"valueOnDate":400000},{"date":1669852800000,"assetId":"0LBYVRlkkfRWVNk0y2c4a","rowType":"kpi.baseline","currency":"EUR","displayName":"Real estate asset","accountName":"Real estate asset","positionOnDate":1,"positionsPerProjectId":{"null":1},"valueOnDateTransactionCurrency":400000,"valueOnDate":400000},{"id":"ckOAEiHdq9AAfCvkgzbre","userId":"TestUserTier2Loadedxx","accountId":"0LBYVRlkkfRWVNk0y2c4a","otherParty":"Handwerker GbR","otherPartyAccount":null,"description":"Rechnung Renovierung 12/3/23","amount":-543.25,"currency":"EUR","accountCurrencyAmount":-543.25,"fxAmount":null,"fxCurrency":null,"date":1677628800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-costs","isManuallyAdjusted":null,"tags":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","accountId":"0LBYVRlkkfRWVNk0y2c4a"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"realEstate","assetId":"0LBYVRlkkfRWVNk0y2c4a","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for real estate","transactionAmount":-543.25,"transactionPrice":-543.25,"transactionCurrency":"EUR","openAmount":-543.25,"rebasedAmount":-543.25,"displayName":"Bank for real estate","rowType":"costs","positionOnDate":1},{"date":1701475200000,"assetId":"0LBYVRlkkfRWVNk0y2c4a","rowType":"kpi.current","currency":"EUR","displayName":"Real estate asset","accountName":"Real estate asset","positionOnDate":1,"positionsPerProjectId":{"null":1},"valueOnDateTransactionCurrency":495000,"valueOnDate":495000}]}},"deposits":{"IRHUSsu_Vp9quJ5CJ_MlG":{"IRHUSsu_Vp9quJ5CJ_MlG":[{"id":"54Z0IHjPF8klVokVvxpoY","userId":"TestUserTier2Loadedxx","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","otherParty":"initial saldo","otherPartyAccount":null,"description":"initial saldo","amount":40000,"currency":"EUR","accountCurrencyAmount":40000,"fxAmount":null,"fxCurrency":null,"date":1625097600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit 2","transactionAmount":40000,"transactionPrice":40000,"transactionCurrency":"EUR","openAmount":40000,"rebasedAmount":40000,"displayName":"Bank for deposit 2","rowType":"purchase","amountAssetCurrency":40000,"positionOnDate":40000,"positionsPerProjectId":{"null":40000},"valueOnDateTransactionCurrency":40000,"valueOnDate":40000},{"date":1638316800000,"assetId":"IRHUSsu_Vp9quJ5CJ_MlG","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"Bank for deposit 2","accountName":"Bank for deposit 2","positionOnDate":40000,"positionsPerProjectId":{"null":40000},"valueOnDateTransactionCurrency":40000,"valueOnDate":40000},{"id":"k8k-uu7uEmrv22Nov7YVB","userId":"TestUserTier2Loadedxx","accountId":"IRHUSsu_Vp9quJ5CJ_MlG","otherParty":"Bank for deposits 2","otherPartyAccount":null,"description":"Zinsen Tagesgeld","amount":400,"currency":"EUR","accountCurrencyAmount":400,"fxAmount":null,"fxCurrency":null,"date":1656633600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"IRHUSsu_Vp9quJ5CJ_MlG","accountId":"IRHUSsu_Vp9quJ5CJ_MlG"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"IRHUSsu_Vp9quJ5CJ_MlG","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":400,"transactionPrice":400,"transactionCurrency":"EUR","openAmount":400,"rebasedAmount":400,"displayName":"Bank for cost of living","rowType":"interest","positionOnDate":40000},{"date":1669852800000,"assetId":"IRHUSsu_Vp9quJ5CJ_MlG","rowType":"kpi.baseline","currency":"EUR","displayName":"Bank for deposit 2","accountName":"Bank for deposit 2","positionOnDate":40000,"positionsPerProjectId":{"null":40000},"valueOnDateTransactionCurrency":40000,"valueOnDate":40000},{"date":1701475200000,"assetId":"IRHUSsu_Vp9quJ5CJ_MlG","rowType":"kpi.current","currency":"EUR","displayName":"Bank for deposit 2","accountName":"Bank for deposit 2","positionOnDate":40000,"positionsPerProjectId":{"null":40000},"valueOnDateTransactionCurrency":40000,"valueOnDate":40000}]},"EXWO7q0zVnuwvj4yJ305w":{"EXWO7q0zVnuwvj4yJ305w":[{"id":"dRRHBD6XMQp8a44trj90w","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"me","otherPartyAccount":"DE12345678912345697833","description":"initial ","amount":1100,"currency":"EUR","accountCurrencyAmount":1100,"fxAmount":null,"fxCurrency":null,"date":1512086400000,"batchId":null,"projectId":null,"parentId":"c1zXe1n73jsBGQLI5cXQq","isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":1100,"transactionPrice":1100,"transactionCurrency":"EUR","openAmount":1100,"rebasedAmount":1100,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":1100,"positionOnDate":1100,"positionsPerProjectId":{"null":1100},"valueOnDateTransactionCurrency":1100,"valueOnDate":1100},{"id":"ILc3WwwH0mtqJ2iMKskkh","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"me","otherPartyAccount":"DE12345678912345697833","description":"initial ","amount":18900,"currency":"EUR","accountCurrencyAmount":18900,"fxAmount":null,"fxCurrency":null,"date":1512086400000,"batchId":null,"projectId":null,"parentId":"c1zXe1n73jsBGQLI5cXQq","isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":18900,"transactionPrice":18900,"transactionCurrency":"EUR","openAmount":18900,"rebasedAmount":18900,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":18900,"positionOnDate":20000,"positionsPerProjectId":{"null":20000},"valueOnDateTransactionCurrency":20000,"valueOnDate":20000},{"id":"9RAuacnFTPAAI9hJJGYND","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1538352000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"interest","positionOnDate":20000},{"id":"9RAuacnFTPAAI9hJJGYND","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1538352000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":2,"positionOnDate":20002,"positionsPerProjectId":{"null":20002},"valueOnDateTransactionCurrency":20002,"valueOnDate":20002},{"id":"fKLr0hOn84wcKYwXUaV43","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1569888000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"interest","positionOnDate":20002},{"id":"fKLr0hOn84wcKYwXUaV43","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1569888000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":2,"positionOnDate":20004,"positionsPerProjectId":{"null":20004},"valueOnDateTransactionCurrency":20004,"valueOnDate":20004},{"id":"IWe-7BAzyj2IKbe6wiVUu","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1601510400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"interest","positionOnDate":20004},{"id":"IWe-7BAzyj2IKbe6wiVUu","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1601510400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":2,"positionOnDate":20006,"positionsPerProjectId":{"null":20006},"valueOnDateTransactionCurrency":20006,"valueOnDate":20006},{"id":"ihbGc1XxLhZCJ5vufr9p0","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1633046400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"interest","positionOnDate":20006},{"id":"ihbGc1XxLhZCJ5vufr9p0","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1633046400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":2,"positionOnDate":20008,"positionsPerProjectId":{"null":20008},"valueOnDateTransactionCurrency":20008,"valueOnDate":20008},{"date":1638316800000,"assetId":"EXWO7q0zVnuwvj4yJ305w","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"Bank for deposit","accountName":"Bank for deposit","positionOnDate":20008,"positionsPerProjectId":{"null":20008},"valueOnDateTransactionCurrency":20008,"valueOnDate":20008},{"id":"sP9BKBJ8YFk28wJynJ5ZC","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1664582400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"interest","positionOnDate":20008},{"id":"sP9BKBJ8YFk28wJynJ5ZC","userId":"TestUserTier2Loadedxx","accountId":"EXWO7q0zVnuwvj4yJ305w","otherParty":"Commerzbank","otherPartyAccount":"none","description":"Zinsen","amount":2,"currency":"EUR","accountCurrencyAmount":2,"fxAmount":null,"fxCurrency":null,"date":1664582400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"EXWO7q0zVnuwvj4yJ305w","accountId":"EXWO7q0zVnuwvj4yJ305w"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"EXWO7q0zVnuwvj4yJ305w","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for deposit","transactionAmount":2,"transactionPrice":2,"transactionCurrency":"EUR","openAmount":2,"rebasedAmount":2,"displayName":"Bank for deposit","rowType":"purchase","amountAssetCurrency":2,"positionOnDate":20010,"positionsPerProjectId":{"null":20010},"valueOnDateTransactionCurrency":20010,"valueOnDate":20010},{"date":1669852800000,"assetId":"EXWO7q0zVnuwvj4yJ305w","rowType":"kpi.baseline","currency":"EUR","displayName":"Bank for deposit","accountName":"Bank for deposit","positionOnDate":20010,"positionsPerProjectId":{"null":20010},"valueOnDateTransactionCurrency":20010,"valueOnDate":20010},{"date":1701475200000,"assetId":"EXWO7q0zVnuwvj4yJ305w","rowType":"kpi.current","currency":"EUR","displayName":"Bank for deposit","accountName":"Bank for deposit","positionOnDate":20010,"positionsPerProjectId":{"null":20010},"valueOnDateTransactionCurrency":20010,"valueOnDate":20010}]},"-b3jqm5IvL6kobgCcdICR":{"-b3jqm5IvL6kobgCcdICR":[{"id":"wHQ91su-MwMeeHYk1_iEn","userId":"TestUserTier2Loadedxx","accountId":"-b3jqm5IvL6kobgCcdICR","otherParty":"initial saldo","otherPartyAccount":"initial saldo","description":"initial saldo","amount":550000,"currency":"EUR","accountCurrencyAmount":550000,"fxAmount":null,"fxCurrency":null,"date":1527897600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"-b3jqm5IvL6kobgCcdICR","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for real estate","transactionAmount":550000,"transactionPrice":550000,"transactionCurrency":"EUR","openAmount":550000,"rebasedAmount":550000,"displayName":"Bank for real estate","rowType":"purchase","amountAssetCurrency":550000,"positionOnDate":550000,"positionsPerProjectId":{"null":550000},"valueOnDateTransactionCurrency":550000,"valueOnDate":550000},{"date":1638316800000,"assetId":"-b3jqm5IvL6kobgCcdICR","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"Bank for real estate","accountName":"Bank for real estate","positionOnDate":550000,"positionsPerProjectId":{"null":550000},"valueOnDateTransactionCurrency":550000,"valueOnDate":550000},{"date":1669852800000,"assetId":"-b3jqm5IvL6kobgCcdICR","rowType":"kpi.baseline","currency":"EUR","displayName":"Bank for real estate","accountName":"Bank for real estate","positionOnDate":550000,"positionsPerProjectId":{"null":550000},"valueOnDateTransactionCurrency":550000,"valueOnDate":550000},{"id":"ckOAEiHdq9AAfCvkgzbre","userId":"TestUserTier2Loadedxx","accountId":"-b3jqm5IvL6kobgCcdICR","otherParty":"Handwerker GbR","otherPartyAccount":null,"description":"Rechnung Renovierung 12/3/23","amount":-543.25,"currency":"EUR","accountCurrencyAmount":-543.25,"fxAmount":null,"fxCurrency":null,"date":1677628800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-costs","isManuallyAdjusted":null,"tags":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","accountId":"0LBYVRlkkfRWVNk0y2c4a"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"-b3jqm5IvL6kobgCcdICR","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for real estate","transactionAmount":-543.25,"transactionPrice":-543.25,"transactionCurrency":"EUR","openAmount":-543.25,"rebasedAmount":-543.25,"displayName":"Bank for real estate","rowType":"sale","amountAssetCurrency":-543.25,"positionOnDate":549456.75,"positionsPerProjectId":{"null":549456.75},"valueOnDateTransactionCurrency":549456.75,"valueOnDate":549456.75},{"date":1701475200000,"assetId":"-b3jqm5IvL6kobgCcdICR","rowType":"kpi.current","currency":"EUR","displayName":"Bank for real estate","accountName":"Bank for real estate","positionOnDate":549456.75,"positionsPerProjectId":{"null":549456.75},"valueOnDateTransactionCurrency":549456.75,"valueOnDate":549456.75}]},"AUAMQVhQaeLIHriycINeL":{"AUAMQVhQaeLIHriycINeL":[{"id":"WJNxppJLD-uFFEk_KZYJ1","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"own","otherPartyAccount":null,"description":"initial booking","amount":100000,"currency":"EUR","accountCurrencyAmount":100000,"fxAmount":null,"fxCurrency":null,"date":1427846400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":100000,"transactionPrice":100000,"transactionCurrency":"EUR","openAmount":100000,"rebasedAmount":100000,"displayName":"Bank for brokerage","rowType":"purchase","amountAssetCurrency":100000,"positionOnDate":100000,"positionsPerProjectId":{"null":100000},"valueOnDateTransactionCurrency":100000,"valueOnDate":100000},{"id":"LlKSrDIKVf2By8_bh6Z80","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB ","otherPartyAccount":null,"description":"Depot Nr. 56547783 Kauf AAPL 100 Stk.","amount":-15.5622,"currency":"EUR","accountCurrencyAmount":-15.5622,"fxAmount":-17.73,"fxCurrency":"USD","date":1541030400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-purchase","isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-15.5622,"transactionPrice":-15.5622,"transactionCurrency":"EUR","openAmount":-15.5622,"rebasedAmount":-15.5622,"displayName":"Bank for brokerage","rowType":"sale","amountAssetCurrency":-15.5622,"positionOnDate":99984.4378,"positionsPerProjectId":{"null":99984.4378},"valueOnDateTransactionCurrency":99984.4378,"valueOnDate":99984.4378},{"id":"RG2Ix5aAKpCHvWhgIWkg-","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Transaktionsgeb\xfchren Kauf AAPL","amount":-29.9,"currency":"EUR","accountCurrencyAmount":-29.9,"fxAmount":null,"fxCurrency":null,"date":1541030400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-fees","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"AAPL","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[{"id":"E-kX0-PILO-5P-_Bdsyx4","category":"stocks","tags":{"type":"fee-to-transaction"}},{"id":"EcHfZXVMS395YtxSQQbiB","category":"stocks","tags":{"linkType":"fee-to-transaction"}}],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-29.9,"transactionPrice":-29.9,"transactionCurrency":"EUR","openAmount":-29.9,"rebasedAmount":-29.9,"displayName":"Bank for brokerage","rowType":"sale","amountAssetCurrency":-29.9,"positionOnDate":99954.5378,"positionsPerProjectId":{"null":99954.5378},"valueOnDateTransactionCurrency":99954.5378,"valueOnDate":99954.5378},{"id":"oORs6F46DBdnTK-KQInyf","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Kauf BASF 50 Stk.","amount":-3605,"currency":"EUR","accountCurrencyAmount":-3605,"fxAmount":null,"fxCurrency":null,"date":1556755200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-purchase","isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-3605,"transactionPrice":-3605,"transactionCurrency":"EUR","openAmount":-3605,"rebasedAmount":-3605,"displayName":"Bank for brokerage","rowType":"sale","amountAssetCurrency":-3605,"positionOnDate":96349.5378,"positionsPerProjectId":{"null":96349.5378},"valueOnDateTransactionCurrency":96349.5378,"valueOnDate":96349.5378},{"id":"y-Fr26F2C6vERrrQL-FB7","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Transaktionsgeb\xfchren Kauf BASF","amount":-19.9,"currency":"EUR","accountCurrencyAmount":-19.9,"fxAmount":null,"fxCurrency":null,"date":1556755200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-fees","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[{"id":"8Dazmw3aq9ftU5tkiNdfY","category":"stocks","tags":{"linkType":"fee-to-transaction"}},{"id":"iO2r1oCZVIMbUJT-Ggumx","category":"stocks","tags":{"linkType":"fee-to-transaction"}}],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-19.9,"transactionPrice":-19.9,"transactionCurrency":"EUR","openAmount":-19.9,"rebasedAmount":-19.9,"displayName":"Bank for brokerage","rowType":"sale","amountAssetCurrency":-19.9,"positionOnDate":96329.63780000001,"positionsPerProjectId":{"null":96329.63780000001},"valueOnDateTransactionCurrency":96329.63780000001,"valueOnDate":96329.63780000001},{"id":"SD6J4UL8PVRijjBNPZibb","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"Dave Brubeck","otherPartyAccount":"DE02500105170137075030","description":"internal transfer","amount":2000,"currency":"EUR","accountCurrencyAmount":2000,"fxAmount":null,"fxCurrency":null,"date":1588291200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":2000,"transactionPrice":2000,"transactionCurrency":"EUR","openAmount":2000,"rebasedAmount":2000,"displayName":"Bank for brokerage","rowType":"purchase","amountAssetCurrency":2000,"positionOnDate":98329.63780000001,"positionsPerProjectId":{"null":98329.63780000001},"valueOnDateTransactionCurrency":98329.63780000001,"valueOnDate":98329.63780000001},{"id":"EE5FgU0hKIz5o_LMvkjWL","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Kontof\xfchrungsgeb\xfchren ","amount":-15,"currency":"EUR","accountCurrencyAmount":-15,"fxAmount":null,"fxCurrency":null,"date":1614556800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-costs","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"SKxazU1TIynqfmDvfUR1g","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-15,"transactionPrice":-15,"transactionCurrency":"EUR","openAmount":-15,"rebasedAmount":-15,"displayName":"Bank for brokerage","rowType":"sale","amountAssetCurrency":-15,"positionOnDate":98314.63780000001,"positionsPerProjectId":{"null":98314.63780000001},"valueOnDateTransactionCurrency":98314.63780000001,"valueOnDate":98314.63780000001},{"id":"-wuGAmqRhO5ttBrQhvSSf","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Dividenden / Zinsen","amount":69,"currency":"EUR","accountCurrencyAmount":69,"fxAmount":null,"fxCurrency":null,"date":1615766400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-dividend","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":69,"transactionPrice":69,"transactionCurrency":"EUR","openAmount":69,"rebasedAmount":69,"displayName":"Bank for brokerage","rowType":"purchase","amountAssetCurrency":69,"positionOnDate":98383.63780000001,"positionsPerProjectId":{"null":98383.63780000001},"valueOnDateTransactionCurrency":98383.63780000001,"valueOnDate":98383.63780000001},{"id":"T5XUL37Ptjma52D0MydQR","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Dividenden / Zinsen","amount":130,"currency":"EUR","accountCurrencyAmount":130,"fxAmount":null,"fxCurrency":null,"date":1631664000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-dividend","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":130,"transactionPrice":130,"transactionCurrency":"EUR","openAmount":130,"rebasedAmount":130,"displayName":"Bank for brokerage","rowType":"purchase","amountAssetCurrency":130,"positionOnDate":98513.63780000001,"positionsPerProjectId":{"null":98513.63780000001},"valueOnDateTransactionCurrency":98513.63780000001,"valueOnDate":98513.63780000001},{"date":1638316800000,"assetId":"AUAMQVhQaeLIHriycINeL","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"Bank for brokerage","accountName":"Bank for brokerage","positionOnDate":98513.63780000001,"positionsPerProjectId":{"null":98513.63780000001},"valueOnDateTransactionCurrency":98513.63780000001,"valueOnDate":98513.63780000001},{"id":"4sni0J65uwDx2QKIIqnTz","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Kontof\xfchrungsgeb\xfchren","amount":-10,"currency":"EUR","accountCurrencyAmount":-10,"fxAmount":null,"fxCurrency":null,"date":1646092800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-costs","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"SKxazU1TIynqfmDvfUR1g","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":-10,"transactionPrice":-10,"transactionCurrency":"EUR","openAmount":-10,"rebasedAmount":-10,"displayName":"Bank for brokerage","rowType":"sale","amountAssetCurrency":-10,"positionOnDate":98503.63780000001,"positionsPerProjectId":{"null":98503.63780000001},"valueOnDateTransactionCurrency":98503.63780000001,"valueOnDate":98503.63780000001},{"id":"MoTxK3yaKV3JRyV5v8vNU","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Dividenden / Zinsen","amount":162.5,"currency":"EUR","accountCurrencyAmount":162.5,"fxAmount":null,"fxCurrency":null,"date":1647302400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-dividend","isManuallyAdjusted":null,"tags":{"type":null,"assetId":"BAS.F","indexed":null,"accountId":"SKxazU1TIynqfmDvfUR1g","recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":162.5,"transactionPrice":162.5,"transactionCurrency":"EUR","openAmount":162.5,"rebasedAmount":162.5,"displayName":"Bank for brokerage","rowType":"purchase","amountAssetCurrency":162.5,"positionOnDate":98666.13780000001,"positionsPerProjectId":{"null":98666.13780000001},"valueOnDateTransactionCurrency":98666.13780000001,"valueOnDate":98666.13780000001},{"date":1669852800000,"assetId":"AUAMQVhQaeLIHriycINeL","rowType":"kpi.baseline","currency":"EUR","displayName":"Bank for brokerage","accountName":"Bank for brokerage","positionOnDate":98666.13780000001,"positionsPerProjectId":{"null":98666.13780000001},"valueOnDateTransactionCurrency":98666.13780000001,"valueOnDate":98666.13780000001},{"id":"JpyKtleDwf5XEVVmuQ8Gl","userId":"TestUserTier2Loadedxx","accountId":"AUAMQVhQaeLIHriycINeL","otherParty":"DKB","otherPartyAccount":null,"description":"Depot Nr. 56547783 Transaktionsgeb\xfchren Verkauf AAPL 60 St","amount":9083.4473,"currency":"EUR","accountCurrencyAmount":9083.4473,"fxAmount":9960,"fxCurrency":"USD","date":1682985600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-sale","isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[{"id":"7rcZwnrwaZIKhSQp60rPl","category":"stocks","tags":{"linkType":"sale-to-transaction"}}],"category":"deposits","assetId":"AUAMQVhQaeLIHriycINeL","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for brokerage","transactionAmount":9083.4473,"transactionPrice":9083.4473,"transactionCurrency":"EUR","openAmount":9083.4473,"rebasedAmount":9083.4473,"displayName":"Bank for brokerage","rowType":"purchase","amountAssetCurrency":9083.4473,"positionOnDate":107749.58510000001,"positionsPerProjectId":{"null":107749.58510000001},"valueOnDateTransactionCurrency":107749.58510000001,"valueOnDate":107749.58510000001},{"date":1701475200000,"assetId":"AUAMQVhQaeLIHriycINeL","rowType":"kpi.current","currency":"EUR","displayName":"Bank for brokerage","accountName":"Bank for brokerage","positionOnDate":107749.58510000001,"positionsPerProjectId":{"null":107749.58510000001},"valueOnDateTransactionCurrency":107749.58510000001,"valueOnDate":107749.58510000001}]},"CJ2-NiJHmIDdTI_f9UuXs":{"CJ2-NiJHmIDdTI_f9UuXs":[{"id":"usD9GGkEY8Vgf4Bzo1HO-","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"initial saldo","otherPartyAccount":null,"description":"initial saldo","amount":20000,"currency":"EUR","accountCurrencyAmount":20000,"fxAmount":null,"fxCurrency":null,"date":1577836800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":20000,"transactionPrice":20000,"transactionCurrency":"EUR","openAmount":20000,"rebasedAmount":20000,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":20000,"positionOnDate":20000,"positionsPerProjectId":{"null":20000},"valueOnDateTransactionCurrency":20000,"valueOnDate":20000},{"id":"d3QCZMWgZJfQOmW60dsvj","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Dave Brubeck","otherPartyAccount":"DE02120300000000202051","description":"internal transfer","amount":-2000,"currency":"EUR","accountCurrencyAmount":-2000,"fxAmount":null,"fxCurrency":null,"date":1588291200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2000,"transactionPrice":-2000,"transactionCurrency":"EUR","openAmount":-2000,"rebasedAmount":-2000,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2000,"positionOnDate":18000,"positionsPerProjectId":{"null":18000},"valueOnDateTransactionCurrency":18000,"valueOnDate":18000},{"id":"9LQMsnWVBbm0dcXp8ZbrJ","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Avis AG","otherPartyAccount":"DE12387618273672636322","description":"Mietwagen-Rechnung ","amount":-317,"currency":"EUR","accountCurrencyAmount":-317,"fxAmount":-313,"fxCurrency":"CHF","date":1600300800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-317,"transactionPrice":-317,"transactionCurrency":"EUR","openAmount":-317,"rebasedAmount":-317,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-317,"positionOnDate":17683,"positionsPerProjectId":{"null":17683},"valueOnDateTransactionCurrency":17683,"valueOnDate":17683},{"id":"sDYdMXblsBRgUsTeVBK4L","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1601251200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":14833,"positionsPerProjectId":{"null":14833},"valueOnDateTransactionCurrency":14833,"valueOnDate":14833},{"id":"ghglCj86BOYDPDVKao66t","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4860","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1601510400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":21333,"positionsPerProjectId":{"null":21333},"valueOnDateTransactionCurrency":21333,"valueOnDate":21333},{"id":"Esqc1Tn8T0kA0o8kjYgVb","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1602288000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":19833,"positionsPerProjectId":{"null":19833},"valueOnDateTransactionCurrency":19833,"valueOnDate":19833},{"id":"5FUV0z1_YeLpiQ6KCucCp","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1603843200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":16983,"positionsPerProjectId":{"null":16983},"valueOnDateTransactionCurrency":16983,"valueOnDate":16983},{"id":"VDNA1g-gbd4teRwujHSfL","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4859","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1604188800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":23483,"positionsPerProjectId":{"null":23483},"valueOnDateTransactionCurrency":23483,"valueOnDate":23483},{"id":"DD_8cyDC4E6hJjHUlzQhV","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1604966400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":21983,"positionsPerProjectId":{"null":21983},"valueOnDateTransactionCurrency":21983,"valueOnDate":21983},{"id":"SklcLhdDtx44aRXXN_sJB","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1606521600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":19133,"positionsPerProjectId":{"null":19133},"valueOnDateTransactionCurrency":19133,"valueOnDate":19133},{"id":"34_uKEdswbfPMmYi3okdg","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4858","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1606780800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":25633,"positionsPerProjectId":{"null":25633},"valueOnDateTransactionCurrency":25633,"valueOnDate":25633},{"id":"qqE1OwLxvg4pEDHAbNLjr","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1607558400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":24133,"positionsPerProjectId":{"null":24133},"valueOnDateTransactionCurrency":24133,"valueOnDate":24133},{"id":"VbNTdYcEkSOkCqxALN94c","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1609113600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":21283,"positionsPerProjectId":{"null":21283},"valueOnDateTransactionCurrency":21283,"valueOnDate":21283},{"id":"yDUtW0xHV-aoVexssWMVE","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4857","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1609459200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":27783,"positionsPerProjectId":{"null":27783},"valueOnDateTransactionCurrency":27783,"valueOnDate":27783},{"id":"zGyWUosMOjIjUO2llm9JD","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1610236800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":26283,"positionsPerProjectId":{"null":26283},"valueOnDateTransactionCurrency":26283,"valueOnDate":26283},{"id":"rSPjjGgzU3NKMdT0fVNoH","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1611792000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":23433,"positionsPerProjectId":{"null":23433},"valueOnDateTransactionCurrency":23433,"valueOnDate":23433},{"id":"Ww5olKNjbY1-MIwOGCxwB","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4856","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1612137600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":29933,"positionsPerProjectId":{"null":29933},"valueOnDateTransactionCurrency":29933,"valueOnDate":29933},{"id":"UrNWZ2TgoHR1pJ6ioTsmk","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Handwerker GbR","otherPartyAccount":null,"description":"Rechnung 12/233/21","amount":-546.21,"currency":"EUR","accountCurrencyAmount":-546.21,"fxAmount":null,"fxCurrency":null,"date":1612224000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-546.21,"transactionPrice":-546.21,"transactionCurrency":"EUR","openAmount":-546.21,"rebasedAmount":-546.21,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-546.21,"positionOnDate":29386.79,"positionsPerProjectId":{"null":29386.79},"valueOnDateTransactionCurrency":29386.79,"valueOnDate":29386.79},{"id":"jgKCFtgSM-1BbsKJDpw87","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1612915200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":27886.79,"positionsPerProjectId":{"null":27886.79},"valueOnDateTransactionCurrency":27886.79,"valueOnDate":27886.79},{"id":"E1TIl2Rw0bSufQ7QkjxZo","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4858","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1614470400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":25036.79,"positionsPerProjectId":{"null":25036.79},"valueOnDateTransactionCurrency":25036.79,"valueOnDate":25036.79},{"id":"mucDdxZgos49pSKfJ9EtA","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1614556800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":31536.79,"positionsPerProjectId":{"null":31536.79},"valueOnDateTransactionCurrency":31536.79,"valueOnDate":31536.79},{"id":"-oYtAmJSjCupLydPCRqK6","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1615334400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":30036.79,"positionsPerProjectId":{"null":30036.79},"valueOnDateTransactionCurrency":30036.79,"valueOnDate":30036.79},{"id":"73B2iFv1LijYpuA9ZMdGU","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4857","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1616889600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":27186.79,"positionsPerProjectId":{"null":27186.79},"valueOnDateTransactionCurrency":27186.79,"valueOnDate":27186.79},{"id":"GU-MKsUSUGi7QdGUpzy-g","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1617235200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":33686.79,"positionsPerProjectId":{"null":33686.79},"valueOnDateTransactionCurrency":33686.79,"valueOnDate":33686.79},{"id":"NC_EArhIlvyBpSOzz8W3t","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1618012800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":32186.79,"positionsPerProjectId":{"null":32186.79},"valueOnDateTransactionCurrency":32186.79,"valueOnDate":32186.79},{"id":"3SlAQQIey9hvBuIRDve-m","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4856","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1619568000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":29336.79,"positionsPerProjectId":{"null":29336.79},"valueOnDateTransactionCurrency":29336.79,"valueOnDate":29336.79},{"id":"bMcKjWk1OE9GACGuF5Kur","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1619827200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":35836.79,"positionsPerProjectId":{"null":35836.79},"valueOnDateTransactionCurrency":35836.79,"valueOnDate":35836.79},{"id":"5u0OpUh42_jNJ4OgM7X1Q","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1620604800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":34336.79,"positionsPerProjectId":{"null":34336.79},"valueOnDateTransactionCurrency":34336.79,"valueOnDate":34336.79},{"id":"_F4GHxNmaFRrc_n8lFKEb","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4858","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1622160000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":31486.79,"positionsPerProjectId":{"null":31486.79},"valueOnDateTransactionCurrency":31486.79,"valueOnDate":31486.79},{"id":"Tg5BJT5F5f_PSK8dMAL-z","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1622505600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":37986.79,"positionsPerProjectId":{"null":37986.79},"valueOnDateTransactionCurrency":37986.79,"valueOnDate":37986.79},{"id":"bIaG0Jm3mrybBaKomKfh2","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1623283200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":36486.79,"positionsPerProjectId":{"null":36486.79},"valueOnDateTransactionCurrency":36486.79,"valueOnDate":36486.79},{"id":"zMA7Ib9n3k4wgcn0wjQep","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4857","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1624838400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":33636.79,"positionsPerProjectId":{"null":33636.79},"valueOnDateTransactionCurrency":33636.79,"valueOnDate":33636.79},{"id":"bf-cV0inlYPD5BcC6zai3","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1625097600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":40136.79,"positionsPerProjectId":{"null":40136.79},"valueOnDateTransactionCurrency":40136.79,"valueOnDate":40136.79},{"id":"SlaU9IQLfnu7gOn4xz_Jl","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1625875200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":38636.79,"positionsPerProjectId":{"null":38636.79},"valueOnDateTransactionCurrency":38636.79,"valueOnDate":38636.79},{"id":"zDGz8kPd3lk1rHX4xcZV1","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4860","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1627430400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":35786.79,"positionsPerProjectId":{"null":35786.79},"valueOnDateTransactionCurrency":35786.79,"valueOnDate":35786.79},{"id":"P48u4wBfX3xZPQHgjqtg8","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1627776000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":42286.79,"positionsPerProjectId":{"null":42286.79},"valueOnDateTransactionCurrency":42286.79,"valueOnDate":42286.79},{"id":"0HK29b4YAMJIIwrR8p_y1","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1628553600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":40786.79,"positionsPerProjectId":{"null":40786.79},"valueOnDateTransactionCurrency":40786.79,"valueOnDate":40786.79},{"id":"G2df6niByJVi1WQNSZEt6","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4859","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1630108800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":37936.79,"positionsPerProjectId":{"null":37936.79},"valueOnDateTransactionCurrency":37936.79,"valueOnDate":37936.79},{"id":"Ysvj7Y-jCbMHIM-l-mxIc","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1630454400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":44436.79,"positionsPerProjectId":{"null":44436.79},"valueOnDateTransactionCurrency":44436.79,"valueOnDate":44436.79},{"id":"t6yZPKJ0CfCvJpteWMMr4","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1631232000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":42936.79,"positionsPerProjectId":{"null":42936.79},"valueOnDateTransactionCurrency":42936.79,"valueOnDate":42936.79},{"id":"D2SAFp465_vXcQQ7rphNr","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4858","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1632787200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":40086.79,"positionsPerProjectId":{"null":40086.79},"valueOnDateTransactionCurrency":40086.79,"valueOnDate":40086.79},{"id":"S3O2Z9we8Faf0QFWvyk3U","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1633046400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":46586.79,"positionsPerProjectId":{"null":46586.79},"valueOnDateTransactionCurrency":46586.79,"valueOnDate":46586.79},{"id":"pSbtXojtc50MvMOHD1MZP","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1633824000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":45086.79,"positionsPerProjectId":{"null":45086.79},"valueOnDateTransactionCurrency":45086.79,"valueOnDate":45086.79},{"id":"QzpdJuhUGmVk8NoAQbRSP","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4857","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1635379200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":42236.79,"positionsPerProjectId":{"null":42236.79},"valueOnDateTransactionCurrency":42236.79,"valueOnDate":42236.79},{"id":"Y-gInjA8xdsSJmpcJ4_CG","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1635724800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":48736.79,"positionsPerProjectId":{"null":48736.79},"valueOnDateTransactionCurrency":48736.79,"valueOnDate":48736.79},{"id":"qPT0DYA4fhZX9RMBVpD0X","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1636502400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":47236.79,"positionsPerProjectId":{"null":47236.79},"valueOnDateTransactionCurrency":47236.79,"valueOnDate":47236.79},{"id":"tiTTxhYZNNwLPzFuK4Zq3","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4856","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1638057600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":44386.79,"positionsPerProjectId":{"null":44386.79},"valueOnDateTransactionCurrency":44386.79,"valueOnDate":44386.79},{"id":"Ikz4KfiK_0qb20MXnbEjN","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6500,"currency":"EUR","accountCurrencyAmount":6500,"fxAmount":null,"fxCurrency":null,"date":1638316800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6500,"transactionPrice":6500,"transactionCurrency":"EUR","openAmount":6500,"rebasedAmount":6500,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6500,"positionOnDate":50886.79,"positionsPerProjectId":{"null":50886.79},"valueOnDateTransactionCurrency":50886.79,"valueOnDate":50886.79},{"date":1638316800000,"assetId":"CJ2-NiJHmIDdTI_f9UuXs","rowType":"kpi.referenceBaseline","currency":"EUR","displayName":"Bank for cost of living","accountName":"Bank for cost of living","positionOnDate":50886.79,"positionsPerProjectId":{"null":50886.79},"valueOnDateTransactionCurrency":50886.79,"valueOnDate":50886.79},{"id":"hq4xHAXopCAnTNaKDs-N0","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1639094400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":49386.79,"positionsPerProjectId":{"null":49386.79},"valueOnDateTransactionCurrency":49386.79,"valueOnDate":49386.79},{"id":"u_vFNpRwd0JR0tZZx9yyV","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4859","amount":-2850,"currency":"EUR","accountCurrencyAmount":-2850,"fxAmount":null,"fxCurrency":null,"date":1640649600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2850,"transactionPrice":-2850,"transactionCurrency":"EUR","openAmount":-2850,"rebasedAmount":-2850,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2850,"positionOnDate":46536.79,"positionsPerProjectId":{"null":46536.79},"valueOnDateTransactionCurrency":46536.79,"valueOnDate":46536.79},{"id":"cWxMCZ-J5apkgisNfjMut","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":4850,"currency":"EUR","accountCurrencyAmount":4850,"fxAmount":null,"fxCurrency":null,"date":1640995200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":4850,"transactionPrice":4850,"transactionCurrency":"EUR","openAmount":4850,"rebasedAmount":4850,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":4850,"positionOnDate":51386.79,"positionsPerProjectId":{"null":51386.79},"valueOnDateTransactionCurrency":51386.79,"valueOnDate":51386.79},{"id":"scZVjHgEJkwblPEc-fIJR","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1641772800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":49886.79,"positionsPerProjectId":{"null":49886.79},"valueOnDateTransactionCurrency":49886.79,"valueOnDate":49886.79},{"id":"NCwhZMEyCkLmiER5Zmxlq","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4858","amount":-2350,"currency":"EUR","accountCurrencyAmount":-2350,"fxAmount":null,"fxCurrency":null,"date":1643328000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2350,"transactionPrice":-2350,"transactionCurrency":"EUR","openAmount":-2350,"rebasedAmount":-2350,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2350,"positionOnDate":47536.79,"positionsPerProjectId":{"null":47536.79},"valueOnDateTransactionCurrency":47536.79,"valueOnDate":47536.79},{"id":"7qcl1TcTl_7l2P8ATtMdK","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":5000,"currency":"EUR","accountCurrencyAmount":5000,"fxAmount":null,"fxCurrency":null,"date":1643673600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":5000,"transactionPrice":5000,"transactionCurrency":"EUR","openAmount":5000,"rebasedAmount":5000,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":5000,"positionOnDate":52536.79,"positionsPerProjectId":{"null":52536.79},"valueOnDateTransactionCurrency":52536.79,"valueOnDate":52536.79},{"id":"3m0OADQP6boadQdt3a09m","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1644451200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":51036.79,"positionsPerProjectId":{"null":51036.79},"valueOnDateTransactionCurrency":51036.79,"valueOnDate":51036.79},{"id":"wKvrA2xiy_Cql_GhFF3Nr","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4857","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1646006400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":48536.79,"positionsPerProjectId":{"null":48536.79},"valueOnDateTransactionCurrency":48536.79,"valueOnDate":48536.79},{"id":"nskSKomr6uu0V7g59Il6S","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":7700,"currency":"EUR","accountCurrencyAmount":7700,"fxAmount":null,"fxCurrency":null,"date":1646092800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":7700,"transactionPrice":7700,"transactionCurrency":"EUR","openAmount":7700,"rebasedAmount":7700,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":7700,"positionOnDate":56236.79,"positionsPerProjectId":{"null":56236.79},"valueOnDateTransactionCurrency":56236.79,"valueOnDate":56236.79},{"id":"hRjJsRZKbKzvDTBfgGLia","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1646870400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":54736.79,"positionsPerProjectId":{"null":54736.79},"valueOnDateTransactionCurrency":54736.79,"valueOnDate":54736.79},{"id":"V9gQ2mnk0SR-Iq0-1CBzP","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4856","amount":-3890,"currency":"EUR","accountCurrencyAmount":-3890,"fxAmount":null,"fxCurrency":null,"date":1648425600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-3890,"transactionPrice":-3890,"transactionCurrency":"EUR","openAmount":-3890,"rebasedAmount":-3890,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-3890,"positionOnDate":50846.79,"positionsPerProjectId":{"null":50846.79},"valueOnDateTransactionCurrency":50846.79,"valueOnDate":50846.79},{"id":"nXTBUijnOyo_Kt8xEjQlj","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":10000,"currency":"EUR","accountCurrencyAmount":10000,"fxAmount":null,"fxCurrency":null,"date":1648771200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":10000,"transactionPrice":10000,"transactionCurrency":"EUR","openAmount":10000,"rebasedAmount":10000,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":10000,"positionOnDate":60846.79,"positionsPerProjectId":{"null":60846.79},"valueOnDateTransactionCurrency":60846.79,"valueOnDate":60846.79},{"id":"2ezbtD-JZbNokiZRxx1nI","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1649548800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":59346.79,"positionsPerProjectId":{"null":59346.79},"valueOnDateTransactionCurrency":59346.79,"valueOnDate":59346.79},{"id":"TSfqBC-A2YLOa44LNfFmY","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-4500,"currency":"EUR","accountCurrencyAmount":-4500,"fxAmount":null,"fxCurrency":null,"date":1651104000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-4500,"transactionPrice":-4500,"transactionCurrency":"EUR","openAmount":-4500,"rebasedAmount":-4500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-4500,"positionOnDate":54846.79,"positionsPerProjectId":{"null":54846.79},"valueOnDateTransactionCurrency":54846.79,"valueOnDate":54846.79},{"id":"ffoHDAy2zx_gB_SgISZA_","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6250,"currency":"EUR","accountCurrencyAmount":6250,"fxAmount":null,"fxCurrency":null,"date":1651363200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6250,"transactionPrice":6250,"transactionCurrency":"EUR","openAmount":6250,"rebasedAmount":6250,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6250,"positionOnDate":61096.79,"positionsPerProjectId":{"null":61096.79},"valueOnDateTransactionCurrency":61096.79,"valueOnDate":61096.79},{"id":"cJHAMJo4ty1EXON4Ie2rM","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1652140800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":59596.79,"positionsPerProjectId":{"null":59596.79},"valueOnDateTransactionCurrency":59596.79,"valueOnDate":59596.79},{"id":"bjZg2XaGcaLyRaijdsToI","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1653696000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":58096.79,"positionsPerProjectId":{"null":58096.79},"valueOnDateTransactionCurrency":58096.79,"valueOnDate":58096.79},{"id":"HcpJx56a3K1LxBSPldp7N","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1654041600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":64846.79,"positionsPerProjectId":{"null":64846.79},"valueOnDateTransactionCurrency":64846.79,"valueOnDate":64846.79},{"id":"0dVYSoo-AhZGOtu76GYQG","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1654819200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":63346.79,"positionsPerProjectId":{"null":63346.79},"valueOnDateTransactionCurrency":63346.79,"valueOnDate":63346.79},{"id":"h1wa1f8o7QE9hot8JvpUU","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1656374400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":0,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":60846.79,"positionsPerProjectId":{"null":60846.79},"valueOnDateTransactionCurrency":60846.79,"valueOnDate":60846.79},{"id":"-UhCYWgGdlX4vp-zjHYhE","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1656633600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":67596.79000000001,"positionsPerProjectId":{"null":67596.79000000001},"valueOnDateTransactionCurrency":67596.79000000001,"valueOnDate":67596.79000000001},{"id":"k8k-uu7uEmrv22Nov7YVB","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Bank for deposits 2","otherPartyAccount":null,"description":"Zinsen Tagesgeld","amount":400,"currency":"EUR","accountCurrencyAmount":400,"fxAmount":null,"fxCurrency":null,"date":1656633600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":"investment-interest","isManuallyAdjusted":null,"tags":{"assetId":"IRHUSsu_Vp9quJ5CJ_MlG","accountId":"IRHUSsu_Vp9quJ5CJ_MlG"},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":400,"transactionPrice":400,"transactionCurrency":"EUR","openAmount":400,"rebasedAmount":400,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":400,"positionOnDate":67996.79000000001,"positionsPerProjectId":{"null":67996.79000000001},"valueOnDateTransactionCurrency":67996.79000000001,"valueOnDate":67996.79000000001},{"id":"61wbS4jQeAbj_8KZVllCZ","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1657411200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":66496.79000000001,"positionsPerProjectId":{"null":66496.79000000001},"valueOnDateTransactionCurrency":66496.79000000001,"valueOnDate":66496.79000000001},{"id":"40VzlDQ7b20whGDYfaflE","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1658966400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":63996.79000000001,"positionsPerProjectId":{"null":63996.79000000001},"valueOnDateTransactionCurrency":63996.79000000001,"valueOnDate":63996.79000000001},{"id":"ChCykvbEOr2axaIOax8f4","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1659312000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":70746.79000000001,"positionsPerProjectId":{"null":70746.79000000001},"valueOnDateTransactionCurrency":70746.79000000001,"valueOnDate":70746.79000000001},{"id":"NFow7M62KGhQzxjNEsOC_","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1660089600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":69246.79000000001,"positionsPerProjectId":{"null":69246.79000000001},"valueOnDateTransactionCurrency":69246.79000000001,"valueOnDate":69246.79000000001},{"id":"d8s7zUx7BjjIeReb78KWI","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1661644800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":66746.79000000001,"positionsPerProjectId":{"null":66746.79000000001},"valueOnDateTransactionCurrency":66746.79000000001,"valueOnDate":66746.79000000001},{"id":"slCGuNGnEaNOIixHUb9Dk","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1661990400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":73496.79000000001,"positionsPerProjectId":{"null":73496.79000000001},"valueOnDateTransactionCurrency":73496.79000000001,"valueOnDate":73496.79000000001},{"id":"U22rw9szJ9eIqLVQcNTm5","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1662768000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":71996.79000000001,"positionsPerProjectId":{"null":71996.79000000001},"valueOnDateTransactionCurrency":71996.79000000001,"valueOnDate":71996.79000000001},{"id":"p_01jHH2cg1pm6QEoLcd2","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1664323200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":69496.79000000001,"positionsPerProjectId":{"null":69496.79000000001},"valueOnDateTransactionCurrency":69496.79000000001,"valueOnDate":69496.79000000001},{"id":"8Q0O_rzvkydxKDAJpuVQ0","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1664582400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":76246.79000000001,"positionsPerProjectId":{"null":76246.79000000001},"valueOnDateTransactionCurrency":76246.79000000001,"valueOnDate":76246.79000000001},{"id":"gxMQVa7WKuSramzpSwZP_","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-500,"currency":"EUR","accountCurrencyAmount":-500,"fxAmount":null,"fxCurrency":null,"date":1665014400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-500,"transactionPrice":-500,"transactionCurrency":"EUR","openAmount":-500,"rebasedAmount":-500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-500,"positionOnDate":75746.79000000001,"positionsPerProjectId":{"null":75746.79000000001},"valueOnDateTransactionCurrency":75746.79000000001,"valueOnDate":75746.79000000001},{"id":"DIdsMfpxXUvepHgitox6x","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"St. Claus","otherPartyAccount":null,"description":"Geschenk","amount":100,"currency":"EUR","accountCurrencyAmount":100,"fxAmount":null,"fxCurrency":null,"date":1665100800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":100,"transactionPrice":100,"transactionCurrency":"EUR","openAmount":100,"rebasedAmount":100,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":100,"positionOnDate":75846.79000000001,"positionsPerProjectId":{"null":75846.79000000001},"valueOnDateTransactionCurrency":75846.79000000001,"valueOnDate":75846.79000000001},{"id":"D7N0amVKiy7AoyLnI572i","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"St. Claus","otherPartyAccount":null,"description":"Geschenkt","amount":100,"currency":"EUR","accountCurrencyAmount":100,"fxAmount":null,"fxCurrency":null,"date":1665187200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":100,"transactionPrice":100,"transactionCurrency":"EUR","openAmount":100,"rebasedAmount":100,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":100,"positionOnDate":75946.79000000001,"positionsPerProjectId":{"null":75946.79000000001},"valueOnDateTransactionCurrency":75946.79000000001,"valueOnDate":75946.79000000001},{"id":"hBplWkErF7yIeMSg__GTs","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1665360000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":74446.79000000001,"positionsPerProjectId":{"null":74446.79000000001},"valueOnDateTransactionCurrency":74446.79000000001,"valueOnDate":74446.79000000001},{"id":"6rljnAxMkcH7sGPq0phbw","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1666915200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":71946.79000000001,"positionsPerProjectId":{"null":71946.79000000001},"valueOnDateTransactionCurrency":71946.79000000001,"valueOnDate":71946.79000000001},{"id":"sE8LlQCDgJsREkZi8dY_L","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1667260800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":78696.79000000001,"positionsPerProjectId":{"null":78696.79000000001},"valueOnDateTransactionCurrency":78696.79000000001,"valueOnDate":78696.79000000001},{"id":"FqL-AR21myOIn6gQZHrVT","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1668038400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":77196.79000000001,"positionsPerProjectId":{"null":77196.79000000001},"valueOnDateTransactionCurrency":77196.79000000001,"valueOnDate":77196.79000000001},{"id":"GL3Zt_JlaHRLY_4rstSlb","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1669593600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":74696.79000000001,"positionsPerProjectId":{"null":74696.79000000001},"valueOnDateTransactionCurrency":74696.79000000001,"valueOnDate":74696.79000000001},{"id":"F_F0dZq2cfwlYN1YsliJ3","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1669852800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":81446.79000000001,"positionsPerProjectId":{"null":81446.79000000001},"valueOnDateTransactionCurrency":81446.79000000001,"valueOnDate":81446.79000000001},{"date":1669852800000,"assetId":"CJ2-NiJHmIDdTI_f9UuXs","rowType":"kpi.baseline","currency":"EUR","displayName":"Bank for cost of living","accountName":"Bank for cost of living","positionOnDate":81446.79000000001,"positionsPerProjectId":{"null":81446.79000000001},"valueOnDateTransactionCurrency":81446.79000000001,"valueOnDate":81446.79000000001},{"id":"bZKXl9Pobnx75rqtmzblA","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1670630400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":79946.79000000001,"positionsPerProjectId":{"null":79946.79000000001},"valueOnDateTransactionCurrency":79946.79000000001,"valueOnDate":79946.79000000001},{"id":"TdmLQHHE9CY-pnHC812iQ","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1672185600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":77446.79000000001,"positionsPerProjectId":{"null":77446.79000000001},"valueOnDateTransactionCurrency":77446.79000000001,"valueOnDate":77446.79000000001},{"id":"Tr-_-c1o0KnojlzTicRi2","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1672531200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":84196.79000000001,"positionsPerProjectId":{"null":84196.79000000001},"valueOnDateTransactionCurrency":84196.79000000001,"valueOnDate":84196.79000000001},{"id":"s5rC2aiaPmccn7u8k5xo4","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1673308800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":82696.79000000001,"positionsPerProjectId":{"null":82696.79000000001},"valueOnDateTransactionCurrency":82696.79000000001,"valueOnDate":82696.79000000001},{"id":"g_ySU3eb7eogm2WCaQ3-6","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1674864000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":80196.79000000001,"positionsPerProjectId":{"null":80196.79000000001},"valueOnDateTransactionCurrency":80196.79000000001,"valueOnDate":80196.79000000001},{"id":"L-otyUKpq0Ny1ZLgBpMTU","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1675209600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":86946.79000000001,"positionsPerProjectId":{"null":86946.79000000001},"valueOnDateTransactionCurrency":86946.79000000001,"valueOnDate":86946.79000000001},{"id":"ThLoCV0-e3TFwR2V_WFNX","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1675987200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":85446.79000000001,"positionsPerProjectId":{"null":85446.79000000001},"valueOnDateTransactionCurrency":85446.79000000001,"valueOnDate":85446.79000000001},{"id":"nhTbHinwMxztP2M1IZ-bz","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1677542400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":82946.79000000001,"positionsPerProjectId":{"null":82946.79000000001},"valueOnDateTransactionCurrency":82946.79000000001,"valueOnDate":82946.79000000001},{"id":"9mhKCL0Z9a9YurjJl64Kz","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Hertz CH AG","otherPartyAccount":null,"description":"Rg.-Nr. 123223123/263","amount":-253,"currency":"EUR","accountCurrencyAmount":-253,"fxAmount":-252.9241,"fxCurrency":"CHF","date":1677628800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{"type":null,"assetId":null,"indexed":null,"accountId":null,"recurring":null},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-253,"transactionPrice":-253,"transactionCurrency":"EUR","openAmount":-253,"rebasedAmount":-253,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-253,"positionOnDate":82693.79000000001,"positionsPerProjectId":{"null":82693.79000000001},"valueOnDateTransactionCurrency":82693.79000000001,"valueOnDate":82693.79000000001},{"id":"w5Ehx6Ld_Uie_ZcsMFOGl","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1677628800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":89443.79000000001,"positionsPerProjectId":{"null":89443.79000000001},"valueOnDateTransactionCurrency":89443.79000000001,"valueOnDate":89443.79000000001},{"id":"9ipDEjgMVgMMiZZilg4i0","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1678406400000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":87943.79000000001,"positionsPerProjectId":{"null":87943.79000000001},"valueOnDateTransactionCurrency":87943.79000000001,"valueOnDate":87943.79000000001},{"id":"TmLbtK9lM3RhDfDtCS4Mn","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1679961600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":85443.79000000001,"positionsPerProjectId":{"null":85443.79000000001},"valueOnDateTransactionCurrency":85443.79000000001,"valueOnDate":85443.79000000001},{"id":"6OsugM3udfth-4rYCAu_C","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1680307200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":92193.79000000001,"positionsPerProjectId":{"null":92193.79000000001},"valueOnDateTransactionCurrency":92193.79000000001,"valueOnDate":92193.79000000001},{"id":"2mvoi6LjTt-Gj4ZQ0KNwz","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1681084800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":90693.79000000001,"positionsPerProjectId":{"null":90693.79000000001},"valueOnDateTransactionCurrency":90693.79000000001,"valueOnDate":90693.79000000001},{"id":"txyO_XhlAfD_mZU9QZOBQ","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1682640000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":88193.79000000001,"positionsPerProjectId":{"null":88193.79000000001},"valueOnDateTransactionCurrency":88193.79000000001,"valueOnDate":88193.79000000001},{"id":"ZCT1wW0xyQfgdbBdn7Vrn","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Arbeitgeber AG","otherPartyAccount":"DE02100500000054540402","description":"Gehalt","amount":6750,"currency":"EUR","accountCurrencyAmount":6750,"fxAmount":null,"fxCurrency":null,"date":1682899200000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":6750,"transactionPrice":6750,"transactionCurrency":"EUR","openAmount":6750,"rebasedAmount":6750,"displayName":"Bank for cost of living","rowType":"purchase","amountAssetCurrency":6750,"positionOnDate":94943.79000000001,"positionsPerProjectId":{"null":94943.79000000001},"valueOnDateTransactionCurrency":94943.79000000001,"valueOnDate":94943.79000000001},{"id":"4ZeYmvQ_ZfdmoiZRrHvcd","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"Vonovia AG","otherPartyAccount":null,"description":"Miete","amount":-1500,"currency":"EUR","accountCurrencyAmount":-1500,"fxAmount":null,"fxCurrency":null,"date":1683676800000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-1500,"transactionPrice":-1500,"transactionCurrency":"EUR","openAmount":-1500,"rebasedAmount":-1500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-1500,"positionOnDate":93443.79000000001,"positionsPerProjectId":{"null":93443.79000000001},"valueOnDateTransactionCurrency":93443.79000000001,"valueOnDate":93443.79000000001},{"id":"d2Fh2VZ0G2VYaDYIPVKSw","userId":"TestUserTier2Loadedxx","accountId":"CJ2-NiJHmIDdTI_f9UuXs","otherParty":"American Express","otherPartyAccount":null,"description":"Kreditkarte 4160xxxxxxxxx4855","amount":-2500,"currency":"EUR","accountCurrencyAmount":-2500,"fxAmount":null,"fxCurrency":null,"date":1685232000000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":null,"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"CJ2-NiJHmIDdTI_f9UuXs","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for cost of living","transactionAmount":-2500,"transactionPrice":-2500,"transactionCurrency":"EUR","openAmount":-2500,"rebasedAmount":-2500,"displayName":"Bank for cost of living","rowType":"sale","amountAssetCurrency":-2500,"positionOnDate":90943.79000000001,"positionsPerProjectId":{"null":90943.79000000001},"valueOnDateTransactionCurrency":90943.79000000001,"valueOnDate":90943.79000000001},{"date":1701475200000,"assetId":"CJ2-NiJHmIDdTI_f9UuXs","rowType":"kpi.current","currency":"EUR","displayName":"Bank for cost of living","accountName":"Bank for cost of living","positionOnDate":90943.79000000001,"positionsPerProjectId":{"null":90943.79000000001},"valueOnDateTransactionCurrency":90943.79000000001,"valueOnDate":90943.79000000001}]},"lyFDhscwJibqb-sf3pocN":{"lyFDhscwJibqb-sf3pocN":[{"date":1638316800000,"assetId":"lyFDhscwJibqb-sf3pocN","rowType":"kpi.referenceBaseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"date":1669852800000,"assetId":"lyFDhscwJibqb-sf3pocN","rowType":"kpi.baseline","currency":null,"displayName":null,"displaySymbol":null,"accountName":null,"positionOnDate":0,"positionsPerProjectId":{"null":0},"valueOnDateTransactionCurrency":0,"valueOnDate":0},{"id":"tvVU7XBydpXJRHegRrosi","userId":"TestUserTier2Loadedxx","accountId":"lyFDhscwJibqb-sf3pocN","otherParty":"Grandpa","otherPartyAccount":"CH8451978641397864","description":"Gift","amount":10137.8751,"currency":"CHF","accountCurrencyAmount":10000,"fxAmount":null,"fxCurrency":null,"date":1673049600000,"batchId":null,"projectId":null,"parentId":null,"isSimulated":false,"label":null,"isManuallyAdjusted":null,"tags":{},"sortingOrderWithinMonth":null,"linkedTransactions":[],"category":"deposits","assetId":"lyFDhscwJibqb-sf3pocN","originalUnitPrice":1,"unitPrice":1,"accountName":"Bank for fx deposit","transactionAmount":10137.8751,"transactionPrice":10000,"transactionCurrency":"CHF","openAmount":10137.8751,"rebasedAmount":10137.8751,"displayName":"Bank for fx deposit","rowType":"purchase","amountAssetCurrency":10000,"positionOnDate":10137.8751,"positionsPerProjectId":{"null":10137.8751},"valueOnDateTransactionCurrency":10137.8751,"valueOnDate":10137.8751},{"date":1701475200000,"assetId":"lyFDhscwJibqb-sf3pocN","rowType":"kpi.current","currency":"CHF","displayName":"Bank for fx deposit","accountName":"Bank for fx deposit","positionOnDate":10137.8751,"positionsPerProjectId":{"null":10137.8751},"valueOnDateTransactionCurrency":10137.8751,"valueOnDate":10137.8751}]}}}');


var $a4f21fb9a02b461c$exports = {};
$a4f21fb9a02b461c$exports = JSON.parse('{"BBG001S5N8V8":{"current":{"assetId":"BBG001S5N8V8","date":1701475200000,"quote":191.24,"quoteDate":1701388800000,"currency":"USD","projectId":null,"source":"api","quoteBaseCurrency":175.8529}},"BBG001S5SYB8":{"current":{"assetId":"BBG001S5SYB8","date":1701475200000,"quote":43.24,"quoteDate":1701388800000,"currency":"EUR","projectId":null,"source":"api","quoteBaseCurrency":43.24}},"0LBYVRlkkfRWVNk0y2c4a":{"1701475200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1701475200000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1701388800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1701388800000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1698796800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1698796800000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1696118400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1696118400000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1693526400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1693526400000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1690848000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1690848000000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1688169600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1688169600000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1685577600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1685577600000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1682899200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1682899200000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1680307200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1680307200000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1677628800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1677628800000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1675209600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1675209600000,"quote":495000,"quoteDate":1675209600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":495000},"1672531200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1672531200000,"quote":493500,"quoteDate":1672531200000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":493500},"1669852800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1669852800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1667260800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1667260800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1664582400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1664582400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1661990400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1661990400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1659312000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1659312000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1656633600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1656633600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1654041600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1654041600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1651363200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1651363200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1648771200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1648771200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1646092800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1646092800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1643673600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1643673600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1640995200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1640995200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1638316800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1638316800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1635724800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1635724800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1633046400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1633046400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1630454400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1630454400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1627776000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1627776000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1625097600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1625097600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1622505600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1622505600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1619827200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1619827200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1617235200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1617235200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1614556800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1614556800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1612137600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1612137600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1609459200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1609459200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1606780800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1606780800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1604188800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1604188800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1601510400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1601510400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1598918400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1598918400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1596240000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1596240000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1593561600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1593561600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1590969600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1590969600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1588291200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1588291200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1585699200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1585699200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1583020800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1583020800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1580515200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1580515200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1577836800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1577836800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1575158400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1575158400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1572566400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1572566400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1569888000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1569888000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1567296000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1567296000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1564617600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1564617600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1561939200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1561939200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1559347200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1559347200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1556668800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1556668800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1554076800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1554076800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1551398400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1551398400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1548979200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1548979200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1546300800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1546300800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1543622400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1543622400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1541030400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1541030400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1538352000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1538352000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1535760000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1535760000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1533081600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1533081600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1530403200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1530403200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1527811200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1527811200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1525132800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1525132800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1522540800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1522540800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1519862400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1519862400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1517443200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1517443200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1514764800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1514764800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1512086400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1512086400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1509494400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1509494400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1506816000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1506816000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1504224000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1504224000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1501545600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1501545600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1498867200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1498867200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1496275200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1496275200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1493596800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1493596800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1491004800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1491004800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1488326400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1488326400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1485907200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1485907200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1483228800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1483228800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1480550400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1480550400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1477958400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1477958400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1475280000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1475280000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1472688000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1472688000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1470009600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1470009600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1467331200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1467331200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1464739200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1464739200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1462060800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1462060800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1459468800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1459468800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1456790400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1456790400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1454284800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1454284800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1451606400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1451606400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1448928000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1448928000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1446336000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1446336000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1443657600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1443657600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1441065600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1441065600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1438387200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1438387200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1435708800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1435708800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1433116800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1433116800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1430438400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1430438400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1427846400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1427846400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1425168000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1425168000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1422748800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1422748800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1420070400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1420070400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1417392000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1417392000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1414800000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1414800000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1412121600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1412121600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1409529600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1409529600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1406851200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1406851200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1404172800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1404172800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1401580800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1401580800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1398902400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1398902400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1396310400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1396310400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1393632000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1393632000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1391212800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1391212800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1388534400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1388534400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1385856000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1385856000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1383264000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1383264000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1380585600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1380585600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1377993600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1377993600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1375315200000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1375315200000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1372636800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1372636800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1370044800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1370044800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1367366400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1367366400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1364774400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1364774400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1362096000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1362096000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1359676800000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1359676800000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1356998400000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1356998400000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1354320000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1354320000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1351728000000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1351728000000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1349049600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1349049600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000},"1346457600000":{"assetId":"0LBYVRlkkfRWVNk0y2c4a","date":1346457600000,"quote":400000,"quoteDate":1346457600000,"currency":"EUR","projectId":"null","source":"manual","quoteBaseCurrency":400000}}}');


const $875553580f16c828$var$data = {
    metadata: {
        publishedOn: 1701475200000
    },
    baseCurrency: "EUR",
    kpis: {
        currentNetWorth: 100000,
        inflows: 6750,
        inflowsReferencePeriod: 5000,
        incomeFromCapital: -288,
        incomeFromCapitalReferencePeriod: -244,
        assetValueChange: 1100,
        assetValueChangeReferencePeriod: 1050,
        outflows: -4000,
        outflowsReferencePeriod: -3500,
        baselineNetWorth: 80000,
        baselineDate: 1640991600000
    },
    accounts: [
        // just balances
        {
            id: "tghb1",
            category: "deposits",
            name: "Account 1",
            balance: 20560,
            currency: "EUR"
        },
        {
            id: "tghb2",
            category: "deposits",
            name: "Account 2",
            balance: 1852,
            currency: "CHF"
        },
        {
            id: "tghb3",
            category: "deposits",
            name: "Account 3",
            balance: 0,
            currency: "EUR"
        },
        {
            id: "tghb4",
            category: "stocks",
            name: "Depot Account",
            balance: 13500,
            currency: "EUR"
        },
        {
            id: "tghb5",
            category: "realEstate",
            name: "Hochstr. 19",
            balance: 430500,
            currency: "EUR"
        }
    ],
    reportData: {
        snapshots: (/*@__PURE__*/$parcel$interopDefault($0d58d623e17e46e6$exports)),
        balances: (/*@__PURE__*/$parcel$interopDefault($f4babe0724a8aa19$exports)),
        completeAssetView: (/*@__PURE__*/$parcel$interopDefault($8a9daab45a308cb9$exports)),
        quotes: (/*@__PURE__*/$parcel$interopDefault($a4f21fb9a02b461c$exports))
    }
};
var $875553580f16c828$export$2e2bcd8739ae039 = $875553580f16c828$var$data;



var $aHcaX = parcelRequire("aHcaX");
var $9d91e3163899ed11$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $9d91e3163899ed11$require$Buffer = $bdjQ6.Buffer;

var $4ZL0H = parcelRequire("4ZL0H");
!function(e) {
    $9d91e3163899ed11$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\x00\x00",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\x00", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\x00", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\x00\x00\x00\x00" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\x00\x00\x00\x00" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $9d91e3163899ed11$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($9d91e3163899ed11$require$Buffer.from && $9d91e3163899ed11$require$Buffer.from !== Uint8Array.from) return $9d91e3163899ed11$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $9d91e3163899ed11$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($9d91e3163899ed11$require$Buffer.alloc) return $9d91e3163899ed11$require$Buffer.alloc(e);
                        var t = new $9d91e3163899ed11$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $9d91e3163899ed11$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $9d91e3163899ed11$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $9d91e3163899ed11$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4ZL0H.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


async function $823559e2ad8601a2$export$916028779a480722(base64EncodedString, passcode) {
    let decrypted;
    try {
        // Decrypt the file using the passcode
        decrypted = (0, (/*@__PURE__*/$parcel$interopDefault($aHcaX))).AES.decrypt(base64EncodedString, passcode).toString((0, (/*@__PURE__*/$parcel$interopDefault($aHcaX))).enc.Utf8);
    } catch (error) {
        console.error("Error decrypting file: ", error);
        throw error;
    }
    try {
        // Instantiate JSZip
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($9d91e3163899ed11$exports)))();
        // Load decrypted data into JSZip
        const unzippedFiles = await zip.loadAsync(decrypted);
        // Process the unzipped files as needed
        // For example, to log the names of the files in the ZIP
        unzippedFiles.forEach((path, f)=>{
            console.log(path, f);
        });
        // Assuming there's only one file in the zip and it's a JSON
        const fileNames = Object.keys(unzippedFiles.files);
        if (fileNames.length === 0) throw new Error("No files found in the zip archive.");
        else if (fileNames.length > 1) throw new Error("More than one file found in the zip archive.");
        // Extract the first file's content
        const fileContent = await unzippedFiles.file(fileNames[0]).async("string");
        // Parse the JSON content and return
        return JSON.parse(fileContent);
    } catch (error) {
        console.error("Error unzipping file: ", error);
        throw error;
    }
}
async function $823559e2ad8601a2$export$f873c76b98145f10(obj, passcode) {
    try {
        // Convert the object to a JSON string
        const jsonString = JSON.stringify(obj);
        console.log("jsonString length: ", jsonString.length);
        // Create a new JSZip instance
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($9d91e3163899ed11$exports)))();
        // Add the JSON string to the zip
        // The file inside the zip will be named 'file.json'
        zip.file("file.json", jsonString);
        // Generate the zip file as a binary string
        const zipContent = await zip.generateAsync({
            type: "binarystring",
            compression: "DEFLATE",
            compressionOptions: {
                level: 9
            }
        });
        console.log("Zip file size: ", zipContent.length);
        // Encrypt the zipped content using the password
        const encrypted = (0, (/*@__PURE__*/$parcel$interopDefault($aHcaX))).AES.encrypt(zipContent, passcode);
        console.log("Encrypted length: ", encrypted.toString().length);
        return encrypted.toString(); // toString() is supposed to return a base64-encoded string
    } catch (error) {
        console.error("Error zipping and encrypting object: ", error);
        throw error;
    }
}



/* eslint-disable import/prefer-default-export */ /* eslint-disable no-param-reassign */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $26dbabe73f482390$exports = {};
var $f328ff7ee4fde81a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f328ff7ee4fde81a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$f328ff7ee4fde81a$exports = $f328ff7ee4fde81a$var$isObject;


var $f76380021e37252e$exports = {};

var $1DySm = parcelRequire("1DySm");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f76380021e37252e$var$now = function() {
    return $1DySm.Date.now();
};
$f76380021e37252e$exports = $f76380021e37252e$var$now;


var $027fc05d9ba60754$exports = {};
var $f49ef2e63e1337d0$exports = {};
var $6abb93fe126bbf26$exports = {};
/** Used to match a single whitespace character. */ var $6abb93fe126bbf26$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6abb93fe126bbf26$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6abb93fe126bbf26$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6abb93fe126bbf26$exports = $6abb93fe126bbf26$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $f49ef2e63e1337d0$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $f49ef2e63e1337d0$var$baseTrim(string) {
    return string ? string.slice(0, $6abb93fe126bbf26$exports(string) + 1).replace($f49ef2e63e1337d0$var$reTrimStart, "") : string;
}
$f49ef2e63e1337d0$exports = $f49ef2e63e1337d0$var$baseTrim;



var $2fffc1449db40502$exports = {};
var $ae3fe6c5950c122e$exports = {};
var $c9c36e86f7d6f497$exports = {};

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $c9c36e86f7d6f497$var$Symbol = $1DySm.Symbol;
$c9c36e86f7d6f497$exports = $c9c36e86f7d6f497$var$Symbol;


var $76f84bdae49ee13c$exports = {};

/** Used for built-in method references. */ var $76f84bdae49ee13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $76f84bdae49ee13c$var$hasOwnProperty = $76f84bdae49ee13c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76f84bdae49ee13c$var$nativeObjectToString = $76f84bdae49ee13c$var$objectProto.toString;
/** Built-in value references. */ var $76f84bdae49ee13c$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $76f84bdae49ee13c$var$getRawTag(value) {
    var isOwn = $76f84bdae49ee13c$var$hasOwnProperty.call(value, $76f84bdae49ee13c$var$symToStringTag), tag = value[$76f84bdae49ee13c$var$symToStringTag];
    try {
        value[$76f84bdae49ee13c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $76f84bdae49ee13c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$76f84bdae49ee13c$var$symToStringTag] = tag;
        else delete value[$76f84bdae49ee13c$var$symToStringTag];
    }
    return result;
}
$76f84bdae49ee13c$exports = $76f84bdae49ee13c$var$getRawTag;


var $77d9fbfccc3fe2a6$exports = {};
/** Used for built-in method references. */ var $77d9fbfccc3fe2a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77d9fbfccc3fe2a6$var$nativeObjectToString = $77d9fbfccc3fe2a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77d9fbfccc3fe2a6$var$objectToString(value) {
    return $77d9fbfccc3fe2a6$var$nativeObjectToString.call(value);
}
$77d9fbfccc3fe2a6$exports = $77d9fbfccc3fe2a6$var$objectToString;


/** `Object#toString` result references. */ var $ae3fe6c5950c122e$var$nullTag = "[object Null]", $ae3fe6c5950c122e$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ae3fe6c5950c122e$var$symToStringTag = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ae3fe6c5950c122e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ae3fe6c5950c122e$var$undefinedTag : $ae3fe6c5950c122e$var$nullTag;
    return $ae3fe6c5950c122e$var$symToStringTag && $ae3fe6c5950c122e$var$symToStringTag in Object(value) ? $76f84bdae49ee13c$exports(value) : $77d9fbfccc3fe2a6$exports(value);
}
$ae3fe6c5950c122e$exports = $ae3fe6c5950c122e$var$baseGetTag;


var $97dbbc1a069ce16a$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97dbbc1a069ce16a$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$97dbbc1a069ce16a$exports = $97dbbc1a069ce16a$var$isObjectLike;


/** `Object#toString` result references. */ var $2fffc1449db40502$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2fffc1449db40502$var$isSymbol(value) {
    return typeof value == "symbol" || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $2fffc1449db40502$var$symbolTag;
}
$2fffc1449db40502$exports = $2fffc1449db40502$var$isSymbol;


/** Used as references for various `Number` constants. */ var $027fc05d9ba60754$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $027fc05d9ba60754$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $027fc05d9ba60754$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $027fc05d9ba60754$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $027fc05d9ba60754$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $027fc05d9ba60754$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($2fffc1449db40502$exports(value)) return $027fc05d9ba60754$var$NAN;
    if ($f328ff7ee4fde81a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $f328ff7ee4fde81a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $f49ef2e63e1337d0$exports(value);
    var isBinary = $027fc05d9ba60754$var$reIsBinary.test(value);
    return isBinary || $027fc05d9ba60754$var$reIsOctal.test(value) ? $027fc05d9ba60754$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $027fc05d9ba60754$var$reIsBadHex.test(value) ? $027fc05d9ba60754$var$NAN : +value;
}
$027fc05d9ba60754$exports = $027fc05d9ba60754$var$toNumber;


/** Error message constants. */ var $26dbabe73f482390$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $26dbabe73f482390$var$nativeMax = Math.max, $26dbabe73f482390$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $26dbabe73f482390$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($26dbabe73f482390$var$FUNC_ERROR_TEXT);
    wait = $027fc05d9ba60754$exports(wait) || 0;
    if ($f328ff7ee4fde81a$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $26dbabe73f482390$var$nativeMax($027fc05d9ba60754$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $26dbabe73f482390$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f76380021e37252e$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f76380021e37252e$exports());
    }
    function debounced() {
        var time = $f76380021e37252e$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$26dbabe73f482390$exports = $26dbabe73f482390$var$debounce;







const $1d60fcd5cdaf946c$var$debugLevel = 0;
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $1d60fcd5cdaf946c$var$createSelectorWithDebug = (0, $5c22629b42831e80$export$5943f4447f6ef248)((0, $58b9680bf8a527fb$export$281bff7f05488aa2), // eslint-disable-next-line arrow-body-style
(a, b)=>{
    console.log("Comparing:", a, b); // Log the values being compared
    return a === b; // Use the default equality check
});
function $1d60fcd5cdaf946c$export$d4f24855aa828946(oldValue, newValue) {
    // this is a rather crude way which just checks if the arrays are the same length
    // this should ideally be lodash's isEqual, should this method not work
    if (oldValue.length === newValue.length) return true;
    return false;
}
function $1d60fcd5cdaf946c$var$parseIf(str) {
    if (typeof str === "object") return str;
    return JSON.parse(str);
}
function $1d60fcd5cdaf946c$var$localeStringToDate(str, locale = "de") {
    const formatter = Intl.DateTimeFormat(locale);
    const dateFormat = formatter.formatToParts(new Date(1670799600000));
    const dateParts = dateFormat.filter((x)=>x.type !== "literal").map((x)=>x.type); // returns ['year', 'month', 'day'] or similar, depending on the locale
    const strArray = str.split(/\D+/);
    return new Date(strArray[dateParts.indexOf("year")], strArray[dateParts.indexOf("month")] - 1, strArray[dateParts.indexOf("day")]);
}
const $1d60fcd5cdaf946c$var$logSelectorChanges = (name, previousInputs, currentInputs)=>{
    previousInputs.forEach((previousInput, index)=>{
        const currentInput = currentInputs[index];
        if (previousInput !== currentInput) console.log(`${name} > Input selector ${index + 1} has changed.`);
    });
};
const $1d60fcd5cdaf946c$export$c374296273e9912a = (0, $5c22629b42831e80$export$595d22ed68ca2841)($a368196802fe263c$export$3c400324181e2c4d, $93bb2798871a68d2$export$8c577782bb016c47, (state)=>state.projects, $3679aa7475d9bd44$export$6d68928c2b6ce1a6, function selectorDatascopeTransactionsCallback(deposits, selectAccounts, selectProjects, allTransactions) {
    if ($1d60fcd5cdaf946c$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), "beginning execution of selectorDatascopeTransactions");
    const returnedObject = {
        derivedAttributes: {
            "Date (Day)": (record)=>new Date(record.date).toLocaleDateString("de", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    timeZone: "UTC"
                }),
            "Date (Month)": (record)=>`${new Date(record.date).getUTCFullYear()}-${new Date(record.date).toLocaleDateString("de", {
                    month: "2-digit",
                    timeZone: "UTC"
                })}`,
            "Date (Year)": (record)=>new Date(record.date).getUTCFullYear(),
            "Transaction sign": (record)=>record.amount >= 0 ? "positive" : "negative"
        },
        sorters: {
            "Date (Day)": (a, b)=>$1d60fcd5cdaf946c$var$localeStringToDate(a) - $1d60fcd5cdaf946c$var$localeStringToDate(b)
        },
        hiddenAttributes: [
            "date",
            "batchId",
            "isSimulated",
            "parentId",
            "linkedTransactions",
            "sortingOrderWithinMonth",
            "tags",
            "userId",
            "accountId"
        ],
        data: (deposits || []).map((item)=>{
            try {
                var _selectAccounts_find, _selectProjects_find;
                const finalObject = (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                    category: "deposits",
                    accountName: (_selectAccounts_find = selectAccounts.find((acc)=>acc.id === item.accountId)) === null || _selectAccounts_find === void 0 ? void 0 : _selectAccounts_find.name,
                    projectName: (_selectProjects_find = selectProjects.find((acc)=>acc.id === item.projectId)) === null || _selectProjects_find === void 0 ? void 0 : _selectProjects_find.name
                });
                // this deposit transaction, if marked as sale, will have a linked transaction to an asset category of tags.linkType 'sale-to-transaction'
                // get the id of that linked (asset) transaction, find it in allTransactions and read its purchaseValueBaseCurrency
                // (it will already be calculated as a sum of purchaseValue all its linked purchase transactions by applyFIFO)
                // disabled, see comment PL 240327 above
                // if (item.label === 'investment-sale' || item.label === 'investment-loanPrincipal') {
                //   const linkedAssetSaleTransactionId = item.linkedTransactions.find((lt) => lt.tags?.linkType === 'sale-to-transaction')?.id;
                //   const linkedAssetSaleTransaction = allTransactions.find((txn) => txn.id === linkedAssetSaleTransactionId);
                //   finalObject.incomeFromCapital = item.quantity * item.upbc - (linkedAssetSaleTransaction?.purchaseValueBaseCurrency || null);
                // }
                return finalObject;
            } catch (err) {
                console.error("selectorDatascopeTransactions: error in data mapping", err, "item:", item);
            }
            return item;
        })
    };
    if ($1d60fcd5cdaf946c$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), "finished execution of selectorDatascopeTransactions");
    return returnedObject;
});
// the quotes service is supposed to provide monthly quotes for all assets since their purchase date;
// this has to handle deposits as well
function $1d60fcd5cdaf946c$var$getAssetPriceAtDate(quotes, assetId, targetDate) {
    if (!quotes[assetId]) // console.info(`getAssetPriceAtDate: no quotes for assetId ${assetId}`);
    return 1;
    if (!quotes[assetId][targetDate]) // console.info(`getAssetPriceAtDate: no quotes for assetId ${assetId} on date ${targetDate}`);
    return 1;
    return quotes[assetId][targetDate].quoteBaseCurrency || 1;
}
// let previousInputs2 = null;
// const getPayoutsPerTransactionSinceDate = (state) => {
//   const currentInputs = getPayoutsPerTransactionSinceDateSource.dependencies.map((selector) => selector(state));
//   if (previousInputs2) {
//     logSelectorChanges('getPayoutsPerTransactionSinceDate', previousInputs2, currentInputs);
//   }
//   previousInputs2 = currentInputs;
//   return getPayoutsPerTransactionSinceDateSource(state);
// };
// prepare list of months for the snapshots, starting at the oldest transaction
// const theOldestTransactionDate = createSelector((state) => selectors.allTransactions(state), (transactions) => transactions.sort((a, b) => a.date - b.date)[0]?.date);
const $1d60fcd5cdaf946c$var$selectMonthStarts = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$6d68928c2b6ce1a6, function selectMonthStartsCallback(transactions) {
    var _transactions_sort_;
    const theOldestTransactionDate = (_transactions_sort_ = transactions.sort((a, b)=>a.date - b.date)[0]) === null || _transactions_sort_ === void 0 ? void 0 : _transactions_sort_.date;
    const returnArray = [];
    let newMonth = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(theOldestTransactionDate).startOf("month").toDate();
    // while (newMonth.valueOf() < dayjs.utc().valueOf()) {
    // ↓↓ if we add a new asset and it doesn't have any transactions before current month, it will not be shown in the snapshots, hence adding one more month
    while(newMonth.valueOf() < (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()){
        returnArray.push(newMonth);
        newMonth = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(newMonth).add(1, "month").startOf("month").toDate();
    }
    // returnArray.push(dayjs.utc().startOf('day').toDate()); // add current day // FIXME this probably should be current from baselineView
    // FIXME this also leads to the situation where we have the 05.2024 month (created in the while loop above) + another 05.2024 (resulting from this "current" row)
    return returnArray;
});
// ----------------------------------------------------------------------------
// ATOMIC DATA (ASSET-LEVEL)
// Group data by category, account and assetId
// ----------------------------------------------------------------------------
// generate data grouped by account and assetId / figi
const $1d60fcd5cdaf946c$var$atomicData = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$7cd09fd23199c464, $93bb2798871a68d2$export$8c577782bb016c47, $3679aa7475d9bd44$export$70d960c2428e363b, function atomicDataCallback(aba, selectAccounts, cav) {
    if (aba.length === 0) return [];
    // console.log('DEBUG atomicData aba', aba, 'cav', cav);
    const atomicDataReturnObject = aba.map((item)=>{
        var _selectAccounts_find;
        const { category: category, accountId: accountId, assetId: assetId, current: current } = item;
        const cavCurrentRecord = cav[category][accountId][assetId].find((t)=>t.rowType === "kpi.current");
        const accountName = (_selectAccounts_find = selectAccounts.find((a)=>a.id === accountId)) === null || _selectAccounts_find === void 0 ? void 0 : _selectAccounts_find.name;
        // we don't do ROI for current accounts, but we can do it for time deposits
        const purchaseValue = category === "deposits" ? 0 : item.current.purchaseValueBaseCurrency; // logic: displaying beginning saldo as "purchase" is confusing
        const currentValue = current.valueBaseCurrency;
        const payoutsSincePurchase = cavCurrentRecord.payoutTotalOpenQuantity;
        const feesSincePurchase = cavCurrentRecord.feesTotalOpenQuantity;
        let roi = 0;
        if (category === "deposits") // this has to be adjusted in Account- and Category-level further down too
        roi = currentValue === 0 ? 0 : (payoutsSincePurchase + feesSincePurchase) / currentValue;
        else roi = purchaseValue === 0 ? 0 : (currentValue + payoutsSincePurchase + feesSincePurchase - purchaseValue) / purchaseValue;
        return {
            key: item.assetId ? `${item.assetId}-${item.accountId}` : item.accountId.toString(),
            category: item.category,
            accountId: item.accountId,
            accountName: accountName,
            assetId: item.assetId,
            displayName: item.displayName ? `${item.displayName}${item.displaySymbol ? ` (${item.displaySymbol})` : ""}` : accountName,
            date: new Date().valueOf(),
            currentPrice: item.current.quoteBaseCurrency,
            purchaseValue: purchaseValue,
            currentValue: currentValue,
            payoutsSincePurchase: payoutsSincePurchase,
            feesSincePurchase: feesSincePurchase,
            roi: roi,
            roiAnnual: cavCurrentRecord.weightedAverageAnnualisedRoi
        };
    });
    // add annualisedRoiArray from kpi.current (the final one) to be used to calculate account and category level annualised ROI
    // console.log('atomicDataReturnObject', atomicDataReturnObject);
    return atomicDataReturnObject;
});
// for 'snapshots' it is enough to get snapshot data from each assetId/accountId combination and flatten them into a common array
const $1d60fcd5cdaf946c$var$allowedLabels = [
    "investment-dividend",
    "investment-interest",
    "investment-pension",
    "investment-rent",
    "investment-loanInterest"
]; // get sale from here or from the asset transaction itself?
// 'pension' added here on 240413, might be wrong, but from context seems to be correct here
function $1d60fcd5cdaf946c$var$assetPiecesOwnedAtDate(cavAssetTransactions, { category: category, accountId: accountId, assetId: assetId }, date) {
    // returns: openAmount on a date (number of pieces owned at that date per accountId|assetId combination)
    // for realEstate, this is always 1 (to speed up calculations)
    if (category === "realEstate") return 1;
    // calculated like: sum of transactionAmount for a given assetId (e.g. figi) bought and sold before (=owned on) a given date
    // if there are split transactions, apply split ratio to the total transactionAmount before the split transaction and carry on
    let result = 0;
    cavAssetTransactions.filter((t)=>t.date <= date).sort((a, b)=>a.date - b.date).forEach((t)=>{
        // if the transaction is a split, update the splitMultiplier
        if (t.transactionType === "split") result *= t.splitRatioNew / t.splitRatioOld; // multiply pre-split total quantity by split ratio
        else result += t.transactionAmount || t.quantity || 0; // use transasctionAmount for stocks / crypto, otherwise quantity
    });
    return result;
}
// pre-aggregate income from capital payments by accountId, assetId and calendar month to speed up calculations later
// income from capital via asset sale handled below
const $1d60fcd5cdaf946c$var$incomeFromCapitalPaymentsByMonth = (0, $5c22629b42831e80$export$595d22ed68ca2841)($a368196802fe263c$export$a8a56b40f5a06885, function incomeFromCapitalPaymentsByMonthCallback(depositTransactions) {
    return (depositTransactions || []).reduce((prev, curr)=>{
        var _parseIf, _parseIf1;
        // only leave in transactions of interest
        if (!$1d60fcd5cdaf946c$var$allowedLabels.includes(curr.label)) return prev;
        const month = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(curr.date).format("YYYY-MM");
        const assetAccountId = (_parseIf = $1d60fcd5cdaf946c$var$parseIf(curr.tags)) === null || _parseIf === void 0 ? void 0 : _parseIf.accountId;
        const assetId = ((_parseIf1 = $1d60fcd5cdaf946c$var$parseIf(curr.tags)) === null || _parseIf1 === void 0 ? void 0 : _parseIf1.assetId) || assetAccountId;
        if (!prev[month]) prev[month] = {};
        if (!prev[month][assetAccountId]) prev[month][assetAccountId] = {};
        if (!prev[month][assetAccountId][assetId]) prev[month][assetAccountId][assetId] = 0;
        prev[month][assetAccountId][assetId] += curr.quantity * curr.upbc;
        return prev;
    }, {});
});
// handle income from capital via asset sale
// no preaggregation here, as we don't expect a lot of data
const $1d60fcd5cdaf946c$var$incomeFromCapitalAssetSalesByMonth = (0, $5c22629b42831e80$export$595d22ed68ca2841)($3679aa7475d9bd44$export$6d68928c2b6ce1a6, function incomeFromCapitalAssetSalesByMonthCallback(allTransactions) {
    return (allTransactions || []).reduce((prev, x)=>{
        var _x_linkedTransactions;
        // keep only asset sale transactions
        if (x.category === "deposits" || x.rebasedAmount > 0) return prev;
        const purchaseValue = (_x_linkedTransactions = x.linkedTransactions) === null || _x_linkedTransactions === void 0 ? void 0 : _x_linkedTransactions.reduce((prevLt, currLt)=>prevLt + currLt.tags.rebasedPrice * currLt.tags.rebasedAmount, 0);
        const assetAccountId = x.accountId;
        const { assetId: assetId } = x;
        const month = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(x.date).format("YYYY-MM");
        if (!prev[month]) prev[month] = {};
        if (!prev[month][assetAccountId]) prev[month][assetAccountId] = {};
        if (!prev[month][assetAccountId][assetId]) prev[month][assetAccountId][assetId] = 0;
        prev[month][assetAccountId][assetId] += -(x.rebasedAmount * x.transactionPrice) - purchaseValue;
        return prev;
    }, {});
});
// get inflows to compare with income from capital
const $1d60fcd5cdaf946c$var$inflowsByMonth = (0, $5c22629b42831e80$export$595d22ed68ca2841)($a368196802fe263c$export$3c400324181e2c4d, function inflowsByMonthCallback(depositTransactions) {
    return (depositTransactions || []).reduce((prev, curr)=>{
        var _curr_label;
        // this is inflows, so only positive amount transactions which do not have any 'investment-*' label
        if (((_curr_label = curr.label) === null || _curr_label === void 0 ? void 0 : _curr_label.split("-")[0]) === "investment" || curr.amount < 0) return prev;
        const { accountId: accountId } = curr;
        const assetId = accountId;
        const month = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(curr.date).format("YYYY-MM");
        if (!prev[month]) prev[month] = {};
        if (!prev[month][accountId]) prev[month][accountId] = {};
        if (!prev[month][accountId][assetId]) prev[month][accountId][assetId] = 0;
        prev[month][accountId][assetId] += curr.amount;
        return prev;
    }, {});
});
// ----------------------------------------------------------------------------
// SNAPSHOTS
// For every category-account-asset combination calculate
// the value of the asset at the beginning of each month since data start
// ----------------------------------------------------------------------------
const $1d60fcd5cdaf946c$var$atomicDataWithSnapshotsCore = (0, $5c22629b42831e80$export$595d22ed68ca2841)($1d60fcd5cdaf946c$var$atomicData, $1d60fcd5cdaf946c$var$selectMonthStarts, $3679aa7475d9bd44$export$cb9c32c395459b9b, $93bb2798871a68d2$export$443f4a6ebd922e0a, $1d60fcd5cdaf946c$var$incomeFromCapitalPaymentsByMonth, $1d60fcd5cdaf946c$var$incomeFromCapitalAssetSalesByMonth, $1d60fcd5cdaf946c$var$inflowsByMonth, // eslint-disable-next-line max-len
function atomicDataWithSnapshotsCallback($atomicData, $monthStarts, ab, quotes, $incomeFromCapitalPaymentsByMonth, $incomeFromCapitalAssetSalesByMonth, $inflowsByMonth) {
    // console.log(dayjs().format('mm:ss.SSS'), 'atomicDataWithSnapshotsCore: calculating...');
    return $atomicData.map((item)=>{
        // console.log('assetBalances', ab);
        const atomicDataWithSnapshotsReturnObject = (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            snapshots: $monthStarts.flatMap((monthStart)=>{
                var _$incomeFromCapitalPaymentsByMonth_monthStartString_accountId, _$incomeFromCapitalPaymentsByMonth_monthStartString, _$incomeFromCapitalAssetSalesByMonth_monthStartString_accountId, _$incomeFromCapitalAssetSalesByMonth_monthStartString, _$inflowsByMonth_monthStartString_accountId, _$inflowsByMonth_monthStartString;
                // this returns an array, which is then flattened; it can return one or more rows, depending on if inflows and incomeFromCapital happened in the same month
                const returnArray = [];
                const { category: category, accountId: accountId, assetId: assetId } = item;
                const monthStartString = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(monthStart).format("YYYY-MM");
                // eslint-disable-next-line max-len
                const incomeFromCapital = (((_$incomeFromCapitalPaymentsByMonth_monthStartString = $incomeFromCapitalPaymentsByMonth[monthStartString]) === null || _$incomeFromCapitalPaymentsByMonth_monthStartString === void 0 ? void 0 : (_$incomeFromCapitalPaymentsByMonth_monthStartString_accountId = _$incomeFromCapitalPaymentsByMonth_monthStartString[accountId]) === null || _$incomeFromCapitalPaymentsByMonth_monthStartString_accountId === void 0 ? void 0 : _$incomeFromCapitalPaymentsByMonth_monthStartString_accountId[assetId]) || 0) + (((_$incomeFromCapitalAssetSalesByMonth_monthStartString = $incomeFromCapitalAssetSalesByMonth[monthStartString]) === null || _$incomeFromCapitalAssetSalesByMonth_monthStartString === void 0 ? void 0 : (_$incomeFromCapitalAssetSalesByMonth_monthStartString_accountId = _$incomeFromCapitalAssetSalesByMonth_monthStartString[accountId]) === null || _$incomeFromCapitalAssetSalesByMonth_monthStartString_accountId === void 0 ? void 0 : _$incomeFromCapitalAssetSalesByMonth_monthStartString_accountId[assetId]) || 0);
                const inflows = item.category !== "deposits" ? 0 : ((_$inflowsByMonth_monthStartString = $inflowsByMonth[monthStartString]) === null || _$inflowsByMonth_monthStartString === void 0 ? void 0 : (_$inflowsByMonth_monthStartString_accountId = _$inflowsByMonth_monthStartString[accountId]) === null || _$inflowsByMonth_monthStartString_accountId === void 0 ? void 0 : _$inflowsByMonth_monthStartString_accountId[assetId]) || 0;
                // if (item.category === 'stocks') {
                //   console.log(
                //     'reportingSelector > snapshots: assetId',
                //     item.assetId,
                //     'month',
                //     dayjs(monthStart).format('YYYY-MM'),
                //     'priceAtDate',
                //     getAssetPriceAtDate(quotes, item.assetId, monthStart.valueOf()),
                //     'assetPiecesOwnedAtDate',
                //     assetPiecesOwnedAtDate(ab[category][accountId][assetId].transactions, item, monthStart),
                //   );
                // }
                const record = {
                    date: monthStart,
                    value: $1d60fcd5cdaf946c$var$getAssetPriceAtDate(quotes, item.assetId, monthStart.valueOf()) * $1d60fcd5cdaf946c$var$assetPiecesOwnedAtDate(ab[category][accountId][assetId].transactions, item, monthStart),
                    incomeFromCapital: // asset sale gains, dividends/interest for that month -- show it for the receiving accounts or for the asset accounts (the deposit txns will have acnt and asset id in tags)?
                    incomeFromCapital,
                    inflows: inflows
                };
                // we always need at least 1 record for a monthEnd, so let it be the inflow record
                returnArray.push((0, $2qxEV._)((0, $9tqwB._)({}, record), {
                    inflowType: "inflow",
                    inflowValue: inflows
                })); // FIXME: are we sure this always says 'inflow'? How is this field used?
                // Bar chart needs a column with keys (inflowType) which it can aggregate according to those values (inflowValue)
                // so if there is incomeFromCapital, return another record for the same monthEnd
                if (incomeFromCapital > 0) returnArray.push((0, $2qxEV._)((0, $9tqwB._)({}, record), {
                    inflowType: "incomeFromCapital",
                    inflowValue: incomeFromCapital,
                    value: 0
                }));
                // FIX -- 230530: both the 'inflow' snapshot as well as the 'incomeFromCapital' snapshot have 'volume' property which shows in the "last 12 months" bar chart twice
                // FIX -- 230530: removing the value from the 'incomeFromCapital' snapshot
                return returnArray;
            })
        });
        // console.log('atomicDataWithSnapshotsReturnObject', atomicDataWithSnapshotsReturnObject);
        return atomicDataWithSnapshotsReturnObject;
    });
});
const $1d60fcd5cdaf946c$var$atomicDataWithSnapshotsDebounceWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($26dbabe73f482390$exports)))((state)=>$1d60fcd5cdaf946c$var$atomicDataWithSnapshotsCore(state), 1000, {
    leading: true,
    trailing: true
});
const $1d60fcd5cdaf946c$export$d2bd4dba3f9dc76f = (state)=>$1d60fcd5cdaf946c$var$atomicDataWithSnapshotsDebounceWrapper(state);
const $1d60fcd5cdaf946c$export$aca71f994eb15241 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($1d60fcd5cdaf946c$export$d2bd4dba3f9dc76f, function selectorDatascopeSnapshotsCallback($atomicDataWithSnapshots) {
    const atomicDataWithSnapshotsReturnObject = ($atomicDataWithSnapshots || []).flatMap((item)=>item.snapshots.filter((snapshot)=>!!(snapshot === null || snapshot === void 0 ? void 0 : snapshot.date)).map((snapshot)=>(0, $2qxEV._)((0, $9tqwB._)({}, snapshot), {
                "Date (Month)": (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(snapshot.date).format("YYYY-MM"),
                "Date (Year)": (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(snapshot.date).format("YYYY"),
                category: item.category,
                accountId: item.accountId,
                accountName: item.accountName,
                assetId: item.assetId,
                displayName: item.displayName
            })));
    // send this from a debounced selector to let ChartWrapper know that it should refresh the data
    window.dispatchEvent(new CustomEvent("reportingDebouncingFinished"));
    return {
        data: atomicDataWithSnapshotsReturnObject,
        derivedAttributes: {},
        hiddenAttributes: [
            "accountId",
            "figi",
            "roiAnnualData",
            "formattingLevel"
        ]
    };
});
const $1d60fcd5cdaf946c$var$selectorDatascopeSnapshotsDebounceWrapper = (0, (/*@__PURE__*/$parcel$interopDefault($26dbabe73f482390$exports)))((state)=>$1d60fcd5cdaf946c$export$aca71f994eb15241(state), 1000, {
    leading: true,
    trailing: true
});
const $1d60fcd5cdaf946c$export$4eb51271a86d155c = (state)=>$1d60fcd5cdaf946c$var$selectorDatascopeSnapshotsDebounceWrapper(state);
// ----------------------------------------------------------------------------
// ACCOUNT LEVEL DATA
// Aggregate asset-level records to account level
// ----------------------------------------------------------------------------
const $1d60fcd5cdaf946c$var$accountLevelData = (0, $5c22629b42831e80$export$595d22ed68ca2841)($1d60fcd5cdaf946c$var$atomicData, function accountLevelDataCallback($atomicData) {
    const returnArray = $atomicData.reduce((acc, item)=>{
        // see if there is already an entry for this category and account combination
        const previousRecord = acc.findIndex((x)=>x.category === item.category && x.accountId === item.accountId);
        // insert data
        if (previousRecord === -1) // insert new record
        acc.push({
            category: item.category,
            accountId: item.accountId,
            accountName: item.accountName,
            date: new Date().valueOf(),
            displayName: "\u03A3",
            purchaseValue: item.purchaseValue,
            currentValue: item.currentValue,
            payoutsSincePurchase: item.payoutsSincePurchase,
            feesSincePurchase: item.feesSincePurchase,
            roiAnnualProduct: item.roiAnnual * item.currentValue,
            roiAnnualDenominator: item.currentValue,
            formattingLevel: 1
        });
        else {
            // update existing record
            const i = acc[previousRecord];
            i.purchaseValue += item.purchaseValue;
            i.currentValue += item.currentValue;
            i.payoutsSincePurchase += item.payoutsSincePurchase;
            i.feesSincePurchase += item.feesSincePurchase;
            i.roiAnnualProduct += item.roiAnnual * item.currentValue;
            i.roiAnnualDenominator += item.currentValue;
        }
        // apply some more formatting
        const i = acc[previousRecord === -1 ? acc.length - 1 : previousRecord];
        // this  will happen several times, but only the last time will be shown
        i.roi = item.category === "deposits" // this has to be adjusted in Asset- and Category-level further down too
         ? (i.payoutsSincePurchase + i.feesSincePurchase) / i.currentValue : (i.currentValue + i.payoutsSincePurchase + i.feesSincePurchase - i.purchaseValue) / i.purchaseValue;
        // calculate annualised ROI as weighted average of assets by current value
        i.roiAnnual = i.roiAnnualProduct / i.roiAnnualDenominator;
        // return the whole array back at the end
        // console.log('accountLevelData', acc);
        return acc;
    }, []);
    // console.log('accountLevelData', returnArray);
    return returnArray;
});
// ----------------------------------------------------------------------------
// CATEGORY-LEVEL DATA
// Aggregate account-level records to category level
// ----------------------------------------------------------------------------
const $1d60fcd5cdaf946c$var$categoryLevelData = (0, $5c22629b42831e80$export$595d22ed68ca2841)($1d60fcd5cdaf946c$var$accountLevelData, function categoryLevelDataCallback($accountLevelData) {
    return $accountLevelData.reduce((acc, item)=>{
        // see if there is already an entry for this category
        const previousRecord = acc.findIndex((x)=>x.category === item.category);
        // start entry for this category
        if (previousRecord === -1) acc.push({
            category: item.category,
            accountName: "\u03A3",
            date: new Date().valueOf(),
            displayName: "\u03A3",
            purchaseValue: item.purchaseValue,
            currentValue: item.currentValue,
            payoutsSincePurchase: item.payoutsSincePurchase,
            feesSincePurchase: item.feesSincePurchase,
            roiAnnualProduct: item.roiAnnual * item.currentValue,
            roiAnnualDenominator: item.currentValue,
            formattingLevel: 0
        });
        else {
            // add current account's data to existing category
            const i = acc[previousRecord];
            i.purchaseValue += item.purchaseValue;
            i.currentValue += item.currentValue;
            i.payoutsSincePurchase += item.payoutsSincePurchase;
            i.feesSincePurchase += item.feesSincePurchase;
            i.roiAnnualProduct += item.roiAnnual * item.currentValue;
            i.roiAnnualDenominator += item.currentValue;
        }
        // apply some more formatting
        const j = acc[previousRecord === -1 ? acc.length - 1 : previousRecord];
        // this will happen several times, but only the last time will be shown
        j.roi = item.category === "deposits" // this has to be adjusted in Asset- and Account-level further down too)
         ? (j.payoutsSincePurchase + j.feesSincePurchase) / j.currentValue : (j.currentValue + j.payoutsSincePurchase + j.feesSincePurchase - j.purchaseValue) / j.purchaseValue;
        // calculate annualised ROI as weighted average of assets by current value
        j.roiAnnual = j.roiAnnualProduct / j.roiAnnualDenominator;
        // return the whole array back at the end
        // console.log('categoryLevelData', acc);
        return acc;
    }, []);
});
const $1d60fcd5cdaf946c$export$71ce51cc869e0be6 = (0, $5c22629b42831e80$export$595d22ed68ca2841)($1d60fcd5cdaf946c$var$atomicData, $1d60fcd5cdaf946c$var$accountLevelData, $1d60fcd5cdaf946c$var$categoryLevelData, function selectorDatascopeAssetsCallback($atomicData, $accountLevelData, $categoryLevelData) {
    return {
        derivedAttributes: {},
        hiddenAttributes: [
            "accountId",
            "figi",
            "roiAnnualData",
            "formattingLevel"
        ],
        data: $atomicData.concat($accountLevelData).concat($categoryLevelData)// add formatting (the List renderer is not able to do this)
        .map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                roi: x.roi.toLocaleString("de", {
                    style: "percent",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                roiAnnual: x.roiAnnual.toLocaleString("de", {
                    style: "percent",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }))
    };
});
const $1d60fcd5cdaf946c$export$15a43e3a08e9cc8d = (0, $5c22629b42831e80$export$595d22ed68ca2841)($93bb2798871a68d2$export$443f4a6ebd922e0a, $3679aa7475d9bd44$export$7cd09fd23199c464, function selectorDatascopeQuotesCallback(quotes, aba) {
    return {
        derivedAttributes: {},
        hiddenAttributes: [],
        data: (0, $3e6d58b7292c657b$export$a537c627e243cb6e)(quotes, [
            "assetId",
            "date"
        ]).map((item)=>{
            var _aba_find;
            return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                displayName: (_aba_find = aba.find((x)=>x.assetId === item.assetId)) === null || _aba_find === void 0 ? void 0 : _aba_find.displayName
            });
        })
    };
});
function $1d60fcd5cdaf946c$export$2e2bcd8739ae039(state, requestedSelector) {
    switch(requestedSelector){
        case "assets":
            return $1d60fcd5cdaf946c$export$71ce51cc869e0be6(state);
        case "quotes":
            return $1d60fcd5cdaf946c$export$15a43e3a08e9cc8d(state);
        case "snapshots":
            return $1d60fcd5cdaf946c$export$4eb51271a86d155c(state);
        case "transactions":
            return $1d60fcd5cdaf946c$export$c374296273e9912a(state);
        default:
            return {
                data: [],
                derivedAttributes: {},
                hiddenAttributes: []
            };
    }
}




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
const $978bd0b55383d4f0$var$initialState = {};
function $978bd0b55383d4f0$var$convertBlobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = ()=>{
            const conversionResult = reader.result;
            resolve(conversionResult.substr(conversionResult.indexOf(",") + 1));
        };
        reader.readAsDataURL(blob);
    });
}
const $978bd0b55383d4f0$export$91b19c3b6ec0ccaa = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("viewer/getSharedReport", async ({ reportId: reportId, passcode: passcode }, { dispatch: dispatch, getState: getState })=>{
    const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).get(`https://monestry-shared-reports-${"prod"}.s3.eu-central-1.amazonaws.com/${reportId}.zip`, {
        responseType: "blob"
    });
    const file = response.data; // this file is of type Blob
    const base64EncodedEncryptedZip = await $978bd0b55383d4f0$var$convertBlobToBase64(file);
    const unzippedObject = await (0, $823559e2ad8601a2$export$916028779a480722)(base64EncodedEncryptedZip, passcode); // returns a js object which needs to go directly to state
    return unzippedObject; // extra reducer on the bottom takes the object and puts it in state
});
function $978bd0b55383d4f0$var$getAccountBalance(state, accountId) {
    return (0, $3679aa7475d9bd44$export$7cd09fd23199c464)(state).filter((item)=>item.accountId === accountId).reduce((prev, curr)=>prev + curr.current.valueBaseCurrency, 0);
}
const $978bd0b55383d4f0$export$d695d27904197b5a = (0, $745f2177c5cf84eb$export$6abd22dc03e5063f)("viewer/postSharedReport", async ({ passcode: passcode }, { dispatch: dispatch, getState: getState })=>{
    const state = getState();
    const selectCompleteAssetView = (0, $3679aa7475d9bd44$export$70d960c2428e363b)(state);
    const allStockAssetIds = Object.keys((0, $cfd21bc923628483$export$ffbf01f805bb8c9b)(state).displaySymbolByAssetId); // this is a dictionary, but its keys are all stock assetIds
    const allRealEstateAssetIds = Object.keys(selectCompleteAssetView.realEstate); // array of assetIds of all the real estate
    // for the stock positions report, we need all current quotes for each stock
    const selectGlobalQuotesView = (0, $93bb2798871a68d2$export$443f4a6ebd922e0a)(state);
    const quotes = {};
    allStockAssetIds.forEach((assetId)=>{
        var _selectGlobalQuotesView_assetId;
        quotes[assetId] = {};
        quotes[assetId].current = (_selectGlobalQuotesView_assetId = selectGlobalQuotesView[assetId]) === null || _selectGlobalQuotesView_assetId === void 0 ? void 0 : _selectGlobalQuotesView_assetId.current;
    });
    // for the real estate value chart, we need all real estate assets quote objects
    allRealEstateAssetIds.forEach((assetId)=>{
        quotes[assetId] = selectGlobalQuotesView[assetId];
    });
    // start constructing the report viewer object
    const reportViewerObject = {
        metadata: {
            publishedOn: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()
        },
        baseCurrency: state.user.profile.settings.baseCurrency,
        user: {
            profile: state.user.profile
        },
        kpis: {
            // CAUTION: the fields on the viewer side do not match the selector names (because the selector names have been changed following UNISEL)
            currentNetWorth: (0, $3679aa7475d9bd44$export$611bdd34eb5c8a52)(state),
            inflows: (0, $a368196802fe263c$export$61408e9de6c25330)(state),
            inflowsReferencePeriod: (0, $a368196802fe263c$export$1882d03801ff41ff)(state),
            incomeFromCapital: (0, $3679aa7475d9bd44$export$f63326aa9088648b)(state),
            incomeFromCapitalReferencePeriod: (0, $3679aa7475d9bd44$export$16297c4826a11a44)(state),
            assetValueChange: (0, $3679aa7475d9bd44$export$de4ac74636de1fbc)(state),
            assetValueChangeReferencePeriod: (0, $3679aa7475d9bd44$export$92fa9e056f78a7f9)(state),
            outflows: (0, $a368196802fe263c$export$57f29db9c40dbad7)(state),
            outflowsReferencePeriod: (0, $a368196802fe263c$export$43c37cdbf008db07)(state),
            baselineNetWorth: (0, $3679aa7475d9bd44$export$be3d5997140286cf)(state),
            baselineDate: state.user.profile.settings.baselineDate
        },
        accounts: (0, $93bb2798871a68d2$export$8c577782bb016c47)(state).map((account)=>({
                id: account.id,
                category: account.category,
                name: account.name,
                currency: account.currency,
                balance: $978bd0b55383d4f0$var$getAccountBalance(state, account.id)
            })),
        reportData: {
            snapshots: (0, $1d60fcd5cdaf946c$export$2e2bcd8739ae039)(state, "snapshots").data,
            balances: (0, $1d60fcd5cdaf946c$export$2e2bcd8739ae039)(state, "assets").data,
            completeAssetView: selectCompleteAssetView,
            quotes: quotes
        }
    };
    // zip and send to customer/shareReport POST
    const zippedObject = await (0, $823559e2ad8601a2$export$f873c76b98145f10)(reportViewerObject, passcode);
    const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "customer/shareReport", {
        body: zippedObject,
        headers: {
            "Content-Type": "application/json"
        }
    });
    return response;
});
const $978bd0b55383d4f0$var$viewerSlice = (0, $745f2177c5cf84eb$export$4d8d9bd83c24ae8b)({
    name: "viewer",
    initialState: $978bd0b55383d4f0$var$initialState,
    extraReducers: (builder)=>{
        builder.addCase($978bd0b55383d4f0$export$91b19c3b6ec0ccaa.fulfilled, (state, action)=>{
            Object.assign(state, action.payload); // when doing state = action.payload state doesn't get mutated, but reassiged, so it is not noticed
        });
    }
});
var $978bd0b55383d4f0$export$2e2bcd8739ae039 = $978bd0b55383d4f0$var$viewerSlice.reducer;



var $lKcAt = parcelRequire("lKcAt");

var $aHcaX = parcelRequire("aHcaX");
// indexedDBUtils.js
const $5f2f08c7e6608317$var$DB_NAME = "monestry";
const $5f2f08c7e6608317$var$STORE_NAME = "redux";
const $5f2f08c7e6608317$var$DB_VERSION = 1;
// Initialize the IndexedDB
const $5f2f08c7e6608317$var$openDB = ()=>new Promise((resolve, reject)=>{
        const request = indexedDB.open($5f2f08c7e6608317$var$DB_NAME, $5f2f08c7e6608317$var$DB_VERSION);
        // Handle upgrades (creating object stores)
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            if (!db.objectStoreNames.contains($5f2f08c7e6608317$var$STORE_NAME)) db.createObjectStore($5f2f08c7e6608317$var$STORE_NAME, {
                keyPath: "sliceName"
            });
        };
        request.onsuccess = (event)=>{
            resolve(event.target.result);
        };
        request.onerror = (event)=>{
            reject(new Error(`Error opening IndexedDB: ${event.target.errorCode}`));
        };
    });
const $5f2f08c7e6608317$export$a03b9d32e27b566 = async (sliceName, encryptedData)=>{
    // console.info(`Saving slice to IndexedDB: ${sliceName}`);
    const db = await $5f2f08c7e6608317$var$openDB();
    const transaction = db.transaction($5f2f08c7e6608317$var$STORE_NAME, "readwrite");
    const store = transaction.objectStore($5f2f08c7e6608317$var$STORE_NAME);
    const request = store.put({
        sliceName: sliceName,
        encryptedData: encryptedData
    });
    return new Promise((resolve, reject)=>{
        request.onsuccess = ()=>resolve();
        request.onerror = (event)=>reject(new Error(`Error saving slice: ${event.target.errorCode}`));
    });
};
const $5f2f08c7e6608317$export$ae6b3e7ea93fe912 = async (sliceName)=>{
    const db = await $5f2f08c7e6608317$var$openDB();
    const transaction = db.transaction($5f2f08c7e6608317$var$STORE_NAME, "readonly");
    const store = transaction.objectStore($5f2f08c7e6608317$var$STORE_NAME);
    const request = store.get(sliceName);
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            if (event.target.result) resolve(event.target.result.encryptedData);
            else resolve(null); // No data found
        };
        request.onerror = (event)=>reject(new Error(`Error loading slice: ${event.target.errorCode}`));
    });
};


const $e1c7027cb8d52cb1$var$debounceTimers = {};
/**
 * Waits for 1000 ms and if no other action is dispatched in the meantime, persists the slice to localStorage.
 * Applies compression and encryption before saving the slice.
 *
 * @param {array} sliceNames
 */ const $e1c7027cb8d52cb1$var$asyncPersistSlicesMiddleware = (sliceNames)=>(store)=>(next)=>(action)=>{
                const result = next(action); // Let Redux continue with the action
                // console.log('Persists slices:', sliceNames, action);
                const state = store.getState();
                sliceNames.forEach((sliceName)=>{
                    var _state_user;
                    const slice = state[sliceName];
                    const key = state === null || state === void 0 ? void 0 : (_state_user = state.user) === null || _state_user === void 0 ? void 0 : _state_user.sub;
                    if (!key) return;
                    if (slice) {
                        // Clear any existing debounce timer for this slice
                        if ($e1c7027cb8d52cb1$var$debounceTimers[sliceName]) clearTimeout($e1c7027cb8d52cb1$var$debounceTimers[sliceName]);
                        // Set a new debounce timer for the slice
                        $e1c7027cb8d52cb1$var$debounceTimers[sliceName] = setTimeout(async ()=>{
                            try {
                                // Step 1: Compress the slice
                                const compressed = (0, $lKcAt.compressToUTF16)(JSON.stringify(slice));
                                // Step 2: Encrypt using idToken as the key
                                const encrypted = (0, (/*@__PURE__*/$parcel$interopDefault($aHcaX))).AES.encrypt(compressed, key).toString();
                                // Step 3: Save to IndexedDB asynchronously
                                await (0, $5f2f08c7e6608317$export$a03b9d32e27b566)(sliceName, encrypted);
                            } catch (error) {
                                console.error(`Error persisting slice '${sliceName}' asynchronously`, error);
                            }
                        }, 1000); // 1 second debounce time
                    }
                });
                return result;
            };
var $e1c7027cb8d52cb1$export$2e2bcd8739ae039 = $e1c7027cb8d52cb1$var$asyncPersistSlicesMiddleware;


const $4d18ceaae7c86bf3$var$slicesToPersist = [
    "data",
    "quotes",
    "misc"
];
var $4d18ceaae7c86bf3$export$2e2bcd8739ae039 = $4d18ceaae7c86bf3$var$slicesToPersist;


// help debug state mutations between dispatches
const $2994cb1ba75a7bb3$var$logValueChangesMiddleware = (store)=>(next)=>(action)=>{
            const prevState = store.getState();
            const result = next(action);
            const nextState = store.getState();
            const changedModules = [];
            // log all actions in console
            console.log("STORE: Action:", action.type);
            const valueName = "projects"; // replace with the name of the value you want to log
            if (prevState[valueName] !== nextState[valueName]) {
                // if state[valueName] does no longer refer to the same memory address, log it
                // console.log(`Value ${valueName} changed from ${JSON.stringify(prevState[valueName], null, 2)} to ${JSON.stringify(nextState[valueName], null, 2)}`);
                // eslint-disable-next-line no-restricted-syntax
                for(const moduleName in nextState)if (nextState[moduleName] !== prevState[moduleName]) changedModules.push(moduleName);
                if (changedModules.length > 0) console.log(`STORE Modules ${changedModules.join(", ")} changed`);
            }
            return result;
        };
// Automatically adds the thunk middleware and the Redux DevTools extension
const $2994cb1ba75a7bb3$var$store = (0, $745f2177c5cf84eb$export$7d8a5b498da695ac)({
    // Automatically calls `combineReducers`
    reducer: {
        user: $4d30dd5a74852208$export$2e2bcd8739ae039,
        message: $01ad73ae33b4f3c5$export$2e2bcd8739ae039,
        data: $f1c3fa004749592f$export$2e2bcd8739ae039,
        simulation: $47d2e16a1696e57a$export$2e2bcd8739ae039,
        misc: $c082dd6d1850ff9b$export$2e2bcd8739ae039,
        projects: $c534ad61c7751c43$export$2e2bcd8739ae039,
        reports: $34d01d41f17850bb$export$2e2bcd8739ae039,
        quotes: $5fdae6729b4c77e7$export$2e2bcd8739ae039,
        viewer: $978bd0b55383d4f0$export$2e2bcd8739ae039
    },
    devTools: false,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: [
                    "SET_ALERT"
                ],
                // Ignore these field paths in all actions
                ignoredActionPaths: [
                    "message.alert.callbackOk"
                ],
                // Ignore these paths in the state
                ignoredPaths: [
                    "message.alert.callbackOk"
                ]
            }
        }).concat((0, $e1c7027cb8d52cb1$export$2e2bcd8739ae039)((0, $4d18ceaae7c86bf3$export$2e2bcd8739ae039)))
});
var // const state = new Proxy(store.getState(), {
//   set: (target, property, value) => {
//     console.log('State changed:', value);
//     // eslint-disable-next-line no-param-reassign
//     target[property] = value;
//     return true;
//   },
// });
// store.subscribe(() => {
//   Object.assign(state, store.getState());
// });
$2994cb1ba75a7bb3$export$2e2bcd8739ae039 = $2994cb1ba75a7bb3$var$store;







// const debugLevel = process.env.REACT_APP_MDEBUG || 3;
const $a4825c1c5096d0fb$var$debugLevel = 0;
function $a4825c1c5096d0fb$export$81254091b6bfbc2b(user, store) {
    if ($a4825c1c5096d0fb$var$debugLevel > 2) console.info("Hub Listener: updateStoreWithAttributes(user)", user);
    // prepare data
    const defaultBaselineDate = {
        name: "sameTimeLastYear",
        date: (0, $35849f14f39a3bea$export$2e2bcd8739ae039).sameTimeLastYear
    };
    const settingsString = user.attributes["custom:settings"];
    const settings = settingsString ? JSON.parse(settingsString) : {
        baseCurrency: "EUR",
        baselineDate: defaultBaselineDate.date,
        namedBaseline: defaultBaselineDate.name,
        inflationRate: 3.0,
        sliderStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(10, "year").startOf("year").valueOf(),
        sliderEndDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().add(20, "year").startOf("year").valueOf(),
        expectedDateFormats: [
            "DD.MM.YYYY",
            "YYYY-MM-DD",
            "DD.MM.YY",
            "DD/MM/YYYY",
            "DD-MM-YYYY"
        ]
    };
    const locale = user.attributes.locale || null;
    if (locale !== (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language && (locale === null || locale === void 0 ? void 0 : locale.length) === 2) (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).changeLanguage(locale);
    // needed for persist.js
    const { sub: sub } = user.attributes;
    store.dispatch({
        type: (0, $0840a3787500c813$export$5223a5682801fa43),
        // just send settings and toursseen, the rest is not needed
        // INFO: toursSeen are used in the Prep component to determine whether to create demo data or not (if there are no toursSeen, then it will create demo data)
        payload: {
            toursSeen: JSON.parse(user.attributes["custom:tours_seen"] || "null"),
            settings: settings,
            locale: locale,
            sub: sub
        }
    });
}
const $a4825c1c5096d0fb$var$eventAliasMap = {
    signedIn: "signIn",
    signedOut: "signOut",
    tokenRefreshFailure: "tokenRefresh_failure",
    tokenRefreshFailed: "tokenRefresh_failure",
    userDeleted: "signOut"
};
function $a4825c1c5096d0fb$export$2e2bcd8739ae039(capsule, store) {
    var _capsule_payload;
    const payload = (_capsule_payload = capsule === null || capsule === void 0 ? void 0 : capsule.payload) !== null && _capsule_payload !== void 0 ? _capsule_payload : {};
    const originalEvent = payload === null || payload === void 0 ? void 0 : payload.event;
    var _eventAliasMap_originalEvent;
    const event = originalEvent ? (_eventAliasMap_originalEvent = $a4825c1c5096d0fb$var$eventAliasMap[originalEvent]) !== null && _eventAliasMap_originalEvent !== void 0 ? _eventAliasMap_originalEvent : originalEvent : originalEvent;
    const { data: data } = payload;
    // Listening for all messages
    if ($a4825c1c5096d0fb$var$debugLevel > 2) console.info("Amplify hub event", {
        originalEvent: originalEvent,
        normalizedEvent: event,
        data: data,
        source: capsule === null || capsule === void 0 ? void 0 : capsule.source
    });
    if (!event && !(data === null || data === void 0 ? void 0 : data.url)) return;
    // INFO: (apparently) Amplify "recognises" a callback by specific query parameters in the URL (e.g. setup_intent, id_token, code, state).
    // INFO: Amplify emits a parsingCallbackUrl on its 'auth' channel when the website is loaded, and passes the URL as payload.data.url
    // INFO: the functions here are executed before CallbackHandler had a chance to run
    // handle application start ---------------------------------------------------------------------------------------------------
    // 251106 now handled by initAuth
    // handle token refresh failure -----------------------------------------------------------------------------------------------
    if (event === "tokenRefresh_failure") store.dispatch({
        type: "SET_APP_SIGNAL",
        payload: {
            callerId: "RequireAuth",
            message: "tokenRefresh_failure"
        }
    });
    // handle signIN --------------------------------------------------------------------------------------------------------------
    // 251107 handled in initAuth
    // handle FEDERATED signUP ---------------------------------------------------------------------------------------------------
    // 251107 moved to CallbackHandler.jsx
    // handle signOUT -------------------------------------------------------------------------------------------------------------
    if (event === "signOut") // does it have to happen in PerformLogout AND here?
    store.dispatch({
        type: (0, $0840a3787500c813$export$35e541d26a145a7c)
    });
}



function $4031aa798bd048f3$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // ↓ this function is called by the mobile app to transfer the refresh token to the web app
    // mobile app webview calls this function with the refresh token as a parameter (it is exposed below as a method of the window object)
    function cleanupLogin(username, refreshToken) {
        // Configure user and user pool details
        const userPoolData = {
            UserPoolId: "eu-central-1_8fuw7DSci",
            ClientId: "3u6lltr3nl6eefdtrmq42pspd0"
        };
        let user;
        let userPool;
        let refreshTokenObj;
        try {
            userPool = new (0, $eb46ddfd02c1d36e$export$2e2bcd8739ae039)(userPoolData);
            user = new (0, $a44bf0d9fbe2b4df$export$2e2bcd8739ae039)({
                Username: username,
                Pool: userPool
            });
            refreshTokenObj = new (0, $fdaf527344dd671b$export$2e2bcd8739ae039)({
                RefreshToken: refreshToken
            });
        } catch (e) {
            console.error("Error creating user or refresh token object", e);
            return false;
        }
        user.refreshSession(refreshTokenObj, (err, session)=>{
            // break here if there is an error
            if (err) {
                console.error("Refresh session failed", err);
                return false;
            }
            // At this point, the user session is refreshed
            (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
                forceRefresh: true
            }).then((cognitoUser)=>{
                // console.log('User is authenticated:', cognitoUser);
                // just like with normal login, get user settings (attributes) from Cognito to store
                (0, $a4825c1c5096d0fb$export$81254091b6bfbc2b)(cognitoUser, (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039));
                // set mobileModeOn in store for app-wide use
                dispatch({
                    type: (0, $0840a3787500c813$export$a999df3591da561)
                });
                window.cleanupLogin = null; // self-destruct after use
                if (window.mobileApp) console.log("Mobile app detected on channel >mobileApp<");
                navigate(`/${i18n.language}/app`); // redirect to Dashboard after successful login
                return true; // this is the only positive return value
            }).catch((e)=>{
                console.log("User is not authenticated:", e);
            });
            return false;
        });
        return false;
    }
    (0, $7fPBF.useEffect)(()=>{
        // expose cleanupLogin function to the mobile app
        window.cleanupLogin = cleanupLogin;
        if (window.mobileApp) {
            console.log("Mobile app detected on channel >mobileApp<");
            window.mobileApp.postMessage("mobileLoginReady");
        } else console.error("Mobile app not detected.");
        return ()=>{
            window.cleanupLogin = null;
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "w-screen h-screen flex flex-col gap-4 justify-center items-center text-gray-400",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
            className: "h-16 w-16 animate-spin"
        })
    });
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");







async function $e4f4fda4de0cf2ab$export$310b945cb782b1b7(obj, keyName) {
    const stringifiedObject = JSON.stringify(obj);
    const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($9d91e3163899ed11$exports)))();
    zip.file("temp.zip", stringifiedObject);
    const base64 = await zip.generateAsync({
        type: "base64"
    });
    localStorage.setItem(keyName, base64);
}
async function $e4f4fda4de0cf2ab$export$eb09a3dde63b84a2(keyName) {
    try {
        // Step 1: Retrieve the zipped, base64-encoded state from localStorage
        const base64 = localStorage.getItem(keyName);
        if (!base64) {
            console.info("returning null from decodeObjectFromLocalStorage");
            return null;
        }
        // Step 2: Convert base64 to binary and unzip it to get the encrypted state
        const zip = new (0, (/*@__PURE__*/$parcel$interopDefault($9d91e3163899ed11$exports)))();
        await zip.loadAsync(base64, {
            base64: true
        });
        const stringifiedObject = await zip.file("temp.zip").async("text");
        // Step 4: Parse the JSON string to get the original object
        const obj = JSON.parse(stringifiedObject);
        localStorage.removeItem(keyName);
        return obj;
    } catch (error) {
        console.error("Failed to decode the object from localStorage", error);
        throw error;
    }
}



const $eb95f7d31be4645b$var$providerCancellationTokens = [
    "cancel",
    "cancelled",
    "canceled",
    "abort",
    "aborted",
    "access_denied"
];
function $eb95f7d31be4645b$export$2e2bcd8739ae039(search) {
    const queryParams = new URLSearchParams(search);
    return Array.from(queryParams.entries()).some(([key, value])=>{
        const normalizedKey = key.toLowerCase();
        const normalizedValue = String(value).toLowerCase();
        if ($eb95f7d31be4645b$var$providerCancellationTokens.some((token)=>normalizedKey.includes(token))) return normalizedValue !== "false";
        return [
            "error",
            "error_description",
            "status",
            "reason"
        ].includes(normalizedKey) && $eb95f7d31be4645b$var$providerCancellationTokens.some((token)=>normalizedValue.includes(token));
    });
}


function $55bdb067c8415ec9$export$2e2bcd8739ae039() {
    // get store from state, unpack it and replace store
    // get addAccountState from state, unpack it and navigate to AddAccount (tbd.)
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        async function runUseEffect() {
            // if there is addAccountState in localStorage, then this is use case 1
            const addAccountState = await (0, $e4f4fda4de0cf2ab$export$eb09a3dde63b84a2)("addAccountState");
            // console.info('AddAccountCallbackReceiver: addAccountState', addAccountState);
            if (addAccountState) {
                const updatedState = (0, $2qxEV._)((0, $9tqwB._)({}, addAccountState), {
                    displayedStep: addAccountState.displayedStep + 1,
                    // Dashboard will not change displayedStep when it receives addModeState (Dashboard also must handle browser back button from WebForm, in which case it needs to go back to the previous step)
                    doNotChangeDisplayedStep: true
                });
                updatedState.workflowStepStatus[addAccountState.displayedStep] = true; // update workflowStepStatus of the current step
                // console.log('navigating to /:lang:/app/dashboard with state ', { addAccountState: updatedState }, 'in localStorage');
                (0, $e4f4fda4de0cf2ab$export$310b945cb782b1b7)(updatedState, "addAccountState").then(()=>{
                    navigate(`/${i18n.language}/app/dashboard`);
                });
            }
            // if there is renewAccountAccess in localStorage, then it is use case 2
            const renewAccountAccess = JSON.parse(localStorage.getItem("renewAccountAccess"));
            if (renewAccountAccess) {
                console.info("AddAccountCallbackReceiver: user is refreshing access to an already existing account with renewAccountAccess", renewAccountAccess);
                if ((0, $eb95f7d31be4645b$export$2e2bcd8739ae039)(location.search)) {
                    console.info("AddAccountCallbackReceiver: provider callback indicates the user cancelled the account access renewal.");
                    navigate(`/${i18n.language}/app/dashboard`, {
                        state: {
                            renewAccountAccess: (0, $2qxEV._)((0, $9tqwB._)({}, renewAccountAccess), {
                                cancelled: true
                            })
                        }
                    });
                    return;
                }
                // console.log('navigating to /:lang:/app/dashboard with state ', { renewAccountAccess }, 'in localStorage');
                // because GC creates new End-Aser Agreement, new Requisition and new providerAccountIds, we must update "our" accounts before proceeding to Dashboard
                // (FA only updates its "requisition", so the providerAccountIds remain unchanged - we only need to do this for GC)
                if (renewAccountAccess.reconcileAccounts) {
                    console.info("AddAccountCallbackReceiver: reconcileAccounts flag detected, started GC account reconciliation.");
                    // need to load deposit accounts into state and get provider account details from backend
                    const promises1 = [
                        // get account data into state
                        dispatch((0, $f1c3fa004749592f$export$2f27c6ebffb46a2f)("deposits", true)),
                        // using a dummy country code of GC to indicate to backend that we want to hit the GC endpoint
                        (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `deposits/processids/${renewAccountAccess.processId}?country=GC`, {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                    const [outputDispatch, result] = await Promise.all(promises1);
                    console.info("AddAccountCallbackReceiver: provider accounts data received:", result);
                    console.info("AddAccountCallbackReceiver: existing accounts data received:", outputDispatch);
                    // returned object is { accounts: [], providerAccessId } // the latter being either bankConnectionId for finapi or requisitionId for gocardless
                    // we need to update the accounts in the store with the new providerAccountIds
                    const promises = [];
                    const depositAccounts = outputDispatch.payload.accounts;
                    const depositAccountsGC = depositAccounts.length > 0 ? depositAccounts.filter((account)=>{
                        var _account_tags_provider, _account_tags;
                        return Object.keys(((_account_tags = account.tags) === null || _account_tags === void 0 ? void 0 : (_account_tags_provider = _account_tags.provider) === null || _account_tags_provider === void 0 ? void 0 : _account_tags_provider.gocardless) || {}).length > 0;
                    }) : [];
                    // console.log('AddAccountCallbackReceiver: GC accounts in state:', depositAccountsGC);
                    result.accounts.forEach((providerAccountObject)=>{
                        // console.log('AddAccountCallbackReceiver: processing provider account:', providerAccountObject);
                        // find the account in the store by iban
                        const account = depositAccountsGC.find((acc)=>acc.iban === providerAccountObject.iban);
                        if (!account) return; // if account not found, skip to next account (user may have deleted this one)
                        console.info(`AddAccountCallbackReceiver: updating account ${account.name || JSON.stringify(account)} with the new providerAccountId and providerAccessId:`);
                        // update new requisitionId and new accountId
                        promises.push(dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
                            data: (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                                tags: (0, $2qxEV._)((0, $9tqwB._)({}, account.tags), {
                                    provider: {
                                        finapi: {},
                                        gocardless: (0, $2qxEV._)((0, $9tqwB._)({}, account.tags.provider.gocardless), {
                                            providerAccessId: result.providerAccessId,
                                            providerAccountId: providerAccountObject.providerAccountId
                                        })
                                    }
                                })
                            }),
                            category: "deposits"
                        })));
                    });
                    try {
                        if (promises.length > 0) {
                            await Promise.all(promises);
                            console.info("AddAccountCallbackReceiver: accounts updated in database");
                            navigate(`/${i18n.language}/app/dashboard`, {
                                state: {
                                    renewAccountAccess: renewAccountAccess
                                }
                            });
                        } else {
                            // display dialog to user saying "we have received ibans A, B from provider, but we could not find any accounts with these ibans in our system (there are only C, D)"
                            // this should not happen, as the ibans should not change
                            console.info("AddAccountCallbackReceiver: no existing accounts found with ibans maching those provided by provider, displaying alert to user");
                            const event = new CustomEvent("setAlert", {
                                detail: {
                                    id: "renewAccountAccessNoIbansFound",
                                    args: {
                                        providerIbans: result.accounts.map((acc)=>acc.iban).join(", "),
                                        monestryIbans: depositAccountsGC.map((acc)=>acc.iban).join(", ")
                                    },
                                    caller: "AddAccountCallbackReceiver",
                                    callbackOk: ()=>{
                                        localStorage.removeItem("renewAccountAccess");
                                        // navigate back to dashboard in "regular mode", to avoid showing the "renewal success" message
                                        navigate(`/${i18n.language}/app/dashboard`);
                                    }
                                }
                            });
                            window.dispatchEvent(event);
                        }
                    } catch (error) {
                        // if this fails, tell user to contact support
                        console.error("Error updating accounts in store", error);
                        localStorage.removeItem("renewAccountAccess");
                        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)({
                            message: "renewAccountAccessError"
                        }));
                        // navigate back to dashboard in "regular mode", to avoid showing the "renewal success" message
                        navigate(`/${i18n.language}/app/dashboard`);
                    }
                } else {
                    // if there is no reconcileAccounts flag (this would make it a FinApi case), just navigate to Dashboard with renewAccountAccess
                    console.info("AddAccountCallbackReceiver: no reconcileAccounts flag detected, this is FinAPI case so account reconciliation is not needed. Navigating to Dashboard with renewAccountAccess.");
                    navigate(`/${i18n.language}/app/dashboard`, {
                        state: {
                            renewAccountAccess: renewAccountAccess
                        }
                    });
                }
            }
        }
        runUseEffect();
    }, [
        dispatch,
        i18n.language,
        location.search,
        navigate
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "absolute inset-0 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
            className: "w-10 h-10 text-gray-400 animate-spin"
        })
    });
}


// eslint-disable-next-line import/prefer-default-export
const $89a24f7a54799e2c$export$1f4cdefbb27eb35e = [
    "deposits",
    "stocks",
    "realEstate",
    "loans",
    "pension",
    "objectsOfValue",
    "metals",
    "unlistedShares",
    "crypto"
]; // eslint-disable-next-line import/prefer-default-export
 // export const enabledCategories = ['pension', 'realEstate'];



/* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-restricted-syntax */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");





/* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/mouse-events-have-key-events */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $81b875b650c1863f$var$PlusIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4.5v15m7.5-7.5h-15"
    }));
}
const $81b875b650c1863f$var$ForwardRef = $7fPBF.forwardRef($81b875b650c1863f$var$PlusIcon);
var $81b875b650c1863f$export$2e2bcd8739ae039 = $81b875b650c1863f$var$ForwardRef;






/* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/mouse-events-have-key-events */ /* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2e86494ac28b7748$var$TrashIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    }));
}
const $2e86494ac28b7748$var$ForwardRef = $7fPBF.forwardRef($2e86494ac28b7748$var$TrashIcon);
var $2e86494ac28b7748$export$2e2bcd8739ae039 = $2e86494ac28b7748$var$ForwardRef;




/* eslint-disable react/no-array-index-key */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $778f4e3e2e2497ea$export$2e2bcd8739ae039({ account: account, category: category, currencyCodeFormat: currencyCodeFormat, showInBaseCurrency: showInBaseCurrency, isViewer: isViewer }) {
    // ↓↓ asset accounts may have assets in different currencies, so suming them up in their different currencies makes no sense
    if (category !== "deposits" && !showInBaseCurrency) {
        console.error("AccountSum: the following error happened while rendering AccountSum for account ", account, " and category ", category, showInBaseCurrency);
        throw new Error("AccountSum: showInBaseCurrency must be true for category other than deposits");
    }
    if (!account) return true;
    const accountCurrency = (account === null || account === void 0 ? void 0 : account.currency) || "EUR";
    const baseCurrency = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.baseCurrency) : (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const currentAccountData = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.accounts).filter((a)=>a.id === account.id) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$7cd09fd23199c464)).filter((a)=>a.accountId === account.id);
    // console.log('DEBUG currentAccountData', category, currentAccountData);
    // assetBalancesArray selector returns an ARRAY
    // console.log('DEBUG ab', useSelector(assetBalances));
    // console.log('DEBUG aba', useSelector(assetBalancesArray));
    // console.log('DEBUG pb', useSelector(projectBalances), useSelector(projectBalancesArray));
    // DEPOSITS
    // special case: this may have to display sum in account currency AND in base currency
    if (category === "deposits") {
        // receives a list of transactions per account and the asccount object
        // returns a number of span objects which together constitute the output of toLocaleString with the currency code or symbol
        // if a currency code is returned instead of symbol, it will be formatted with currencyCodeFormat prop
        // prettier-ignore
        const sum = isViewer ? currentAccountData[0].balance : currentAccountData.reduce((acc, curr)=>acc + showInBaseCurrency ? curr.current.valueBaseCurrency : curr.current.valueAccountCurrency, 0); // takes the returned ARRAY and sums up the values
        // handle three-letter currency codes in the localeString
        const a = new Intl.NumberFormat("de", {
            style: "currency",
            currency: showInBaseCurrency ? baseCurrency : accountCurrency || "EUR",
            maximumFractionDigits: 0
        }).formatToParts(sum); // generates an array with [{type:"",value:""}] of all the components of the output string of toLocaleString()
        // add foreign currency tag
        if (showInBaseCurrency && accountCurrency !== baseCurrency) a.push({
            type: "fxTag",
            value: accountCurrency
        });
        return a.map((item, idx)=>{
            if (item.type === "currency" && item.value.length > 1) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: currencyCodeFormat,
                children: item.value
            }, idx);
            if (item.type === "fxTag") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "text-gray-300 text-xs font-normal h-5 mt-[0.2rem] ml-2 py-[0.08rem] md:py-0.5 px-1 border border-gray-300 rounded",
                children: item.value
            }, idx);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: item.value
            }, idx);
        });
    }
    // ALL OTHER CATEGORIES
    try {
        const sum = isViewer ? currentAccountData[0].balance : currentAccountData.reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            children: sum.toLocaleString("de", {
                style: "currency",
                currency: baseCurrency,
                maximumFractionDigits: 0
            })
        });
    } catch (err) {
        console.error("AccountSum: the following error happened while rendering AccountSum for account ", account, " data object:", currentAccountData, err);
        throw new Error("AccountSum: an error happened while rendering AccountSum");
    }
}
$778f4e3e2e2497ea$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    currencyCodeFormat: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    showInBaseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$778f4e3e2e2497ea$export$2e2bcd8739ae039.defaultProps = {
    currencyCodeFormat: "",
    showInBaseCurrency: true,
    isViewer: false
};



function $f71f19ab74e4d742$export$2e2bcd8739ae039({ account: account, category: category, Icon: Icon, color: color, setAccount: setAccount, editMode: editMode, isViewer: isViewer, accountThatIsLoading: accountThatIsLoading }) {
    const [mouseover, setMouseover] = (0, $7fPBF.useState)(false);
    const [delayHandler, setDelayHandler] = (0, $7fPBF.useState)(null);
    const [deleteButton, setDeleteButton] = (0, $7fPBF.useState)(false);
    const [loadingStatus, setLoadingStatus] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const userBaseCurrency = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.baseCurrency) : (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const isDisabled = (accountThatIsLoading === null || accountThatIsLoading === void 0 ? void 0 : accountThatIsLoading.id) === account.id;
    function handleCustomEvent(payload) {
        const event = new CustomEvent("showTransactionPreview", {
            detail: payload
        });
        window.dispatchEvent(event);
    }
    async function handleMouseOver(e) {
        if (window.innerWidth < 1280) return; // don't show tiletip on small screens
        if (isViewer) return; // don't show tiletip for viewer
        // if we are in edit mode, do delete icon instead of show recent transactions table
        if (editMode) setDeleteButton(true);
        else {
            if (!mouseover) setDelayHandler(setTimeout(()=>{
                handleCustomEvent({
                    account: account,
                    userBaseCurrency: userBaseCurrency
                });
            }, 500));
            setMouseover(true); // to only enable one mouseover at a time
        }
    }
    function handleMouseOut(e) {
        // console.log('starting handleMouseOut');
        handleCustomEvent(null);
        setMouseover(false);
        clearTimeout(delayHandler);
        setDelayHandler(null);
        setDeleteButton(false);
    }
    // handle response from the alert dialog
    const alertId = "youAreAboutToDeleteAccount"; // responses: ok | cancel
    // realEstate deleteAccount seems to set the signal
    // handles click: if Edit Mode is on, it displayed the delete button and on click dispatches deleteAccount
    // if Edit Mode not on, it opens AccountDetails view
    async function handleClick(e) {
        if (isViewer) return; // don't open details for viewer
        if (isDisabled) return; // don't do anything if the tile is disabled
        if (editMode) // show the dispatch modal and define the callback
        window.dispatchEvent(new CustomEvent("setAlert", {
            detail: {
                id: alertId,
                caller: account.id,
                callbackOk: async ()=>{
                    const response = await dispatch((0, $f1c3fa004749592f$export$45abfc3976589d02)({
                        accountId: account.id,
                        category: category
                    })); // returns the /fulfilled action from thunk
                    if (response.meta.requestStatus !== "fulfilled") dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated"));
                    dispatch((0, $3b9398d0f9c152fb$export$e5a625708957e77)());
                }
            }
        }));
        else setAccount(account);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b751aa1027c36e73$export$be58926105124dd4), {
        as: "div",
        className: `col-span-1 relative bg-white pb-2 pr-4 w-full max-w-[18rem] sm:min-w-full shadow rounded-md ${isViewer || isDisabled ? "cursor-default" : "cursor-pointer hover:bg-gray-50"}`,
        // puppeteer doesn't support -_ in class names and ids, so remove them
        // id={`tile${category}${account.id.replaceAll('-', '').replaceAll('_', '')}`}
        id: `tile${category}${account.id.replace(/[^a-zA-Z0-9]/g, "")}`,
        appear: true,
        show: true,
        enter: "transition-opacity duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-150",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        onPointerEnter: handleMouseOver,
        onFocus: handleMouseOver,
        onPointerLeave: handleMouseOut,
        onBlur: handleMouseOut,
        onClick: handleClick,
        onKeyPress: ()=>{},
        role: "button",
        tabIndex: "0",
        children: [
            deleteButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute w-full h-full flex justify-center rounded-lg items-center bg-gray-100 opacity-80",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2e86494ac28b7748$export$2e2bcd8739ae039), {
                    className: "w-12 h-12 text-gray-400 opacity-100"
                })
            }),
            loadingStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute w-full h-full flex justify-center rounded-lg items-center bg-gray-100 opacity-80 z-10",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                    className: "w-8 h-8 text-gray-500 opacity-100 animate-spin"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "h-full",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "py-3 md:py-4 grid grid-cols-4 space-x-2 items-stretch h-full",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "col-span-1 flex items-center justify-center",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {
                                className: "text-gray-400 w-5 md:w-6 h-5 md:h-6 order-2"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "col-span-3 justify-between flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-gray-500 text-xs md:text-sm leading-4 truncate",
                                    children: account.name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    id: `tile-${account.id.replace(/[^a-zA-Z0-9]/g, "")}-sum`,
                                    // providing text-base makes the sm and md values not works
                                    // also, the font in text-base and font-bold looks distorted, so using scale to correct
                                    className: "text-gray-900 md:pt-1 text-[1rem] font-bold sm:text-lg md:text-xl flex transform scale-y-110 sm:scale-y-100",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $778f4e3e2e2497ea$export$2e2bcd8739ae039), {
                                        account: account,
                                        category: category,
                                        currencyCodeFormat: "text-base",
                                        showInBaseCurrency: true,
                                        isViewer: isViewer
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: `absolute bottom-0 h-2 ${color.bottom} w-full rounded-b-md`
            })
        ]
    });
}
$f71f19ab74e4d742$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "deposits",
        "stocks",
        "realEstate",
        "pension",
        "objectsOfValue",
        "metals",
        "unlistedShares",
        "loans",
        "crypto"
    ]).isRequired,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    editMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    accountThatIsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
};
$f71f19ab74e4d742$export$2e2bcd8739ae039.defaultProps = {
    setAccount: ()=>{},
    isViewer: false,
    accountThatIsLoading: {
        id: null
    }
};






function $2343165816cf73bf$var$AddNewTile({ category: category, addMode: addMode, setAddMode: setAddMode, setEditMode: setEditMode }) {
    const signal = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.signal[`post${category}Account`]);
    const [signalLock, setSignalLock] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // set edit mode to false as soon as the signal is off
    (0, $7fPBF.useEffect)(()=>{
        // set signalLock to true when it is turned on (so that we know it was on before)
        if (signal) setSignalLock(true);
        // if signalLock is on (meaning it was on before) and signal is off (meaning it got switched off), set editMode to false
        if (!signal && signalLock) setEditMode(false);
    }, [
        signal
    ]);
    async function handleClick() {
        if ((0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e).includes(category)) {
            const user = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
                forceRefresh: true
            });
            const allowedAccounts = JSON.parse(user.attributes["custom:all_account_slots"]);
            console.log("all_account_slots", allowedAccounts);
            const availableAccounts = allowedAccounts.filter((a)=>a === null).length;
            if (availableAccounts > 0) setAddMode((0, $2qxEV._)((0, $9tqwB._)({}, addMode), {
                visible: true,
                category: category
            }));
            else dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("noMoreAccountsAllowed"));
        } else // eslint-disable-next-line no-alert
        alert("This category is not enabled yet.");
    }
    // this is the "add new" tile
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        // eslint-disable-next-line max-len
        className: "relative col-span-1 grid columns-1 justify-center items-center w-full max-w-[18rem] h-full border-dashed border-2 border-gray-300 sm:min-w-full rounded-md cursor-pointer hover:bg-gray-100",
        id: `add-new-${category}-button`,
        // on click update the Dashboard addMode state so that the AddAccount component is displayed and the current category is passed as a prop
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "align-middle",
            children: signal ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$59de000b07aa1ecd), {
                className: "w-8 h-8 text-gray-400 opacity-100 animate-spin"
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81b875b650c1863f$export$2e2bcd8739ae039), {
                className: "mx-auto h-9 w-9 text-gray-400"
            })
        })
    });
}
$2343165816cf73bf$var$AddNewTile.propTypes = {
    addMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAddMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setEditMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $2343165816cf73bf$export$2e2bcd8739ae039({ category: category, editMode: editMode, setEditMode: setEditMode, addMode: addMode, setAddMode: setAddMode, setAccount: setAccount, isViewer: isViewer }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [spinner, setSpinner] = (0, $7fPBF.useState)(!isViewer); // do not show spinner in viewer mode
    const [externalSyncText, setExternalSyncText] = (0, $7fPBF.useState)(false);
    const accounts = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.accounts).filter((a)=>a.category === category) : (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data[category].accounts);
    const accountThatIsLoading = accounts.find((a)=>[
            "loading",
            "loadingExternal"
        ].includes(a.status)); // this has an accountId which can be used by Tiles AND as a boolean
    const categoryStatus = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data[category].status);
    const isCategoryLoading = [
        "loading",
        "loadingExternal"
    ].includes(categoryStatus);
    function handleSync() {
        setSpinner(true);
        dispatch((0, $f1c3fa004749592f$export$dfb022681f1048bc)(category)).then(()=>{
            setSpinner(false);
        });
    }
    // synchonise category / accounts status with component (e.g. if getData is triggered from outside)
    (0, $7fPBF.useEffect)(()=>{
        if (isCategoryLoading || accountThatIsLoading) {
            setSpinner(true);
            if (categoryStatus === "loadingExternal") setExternalSyncText(true);
        // if (categoryStatus === 'loadingExternal') console.log('setting external text to true');
        } else {
            setSpinner(false);
            setExternalSyncText(false);
        // console.log('setting external text to false');
        }
    }, [
        isCategoryLoading,
        accountThatIsLoading,
        categoryStatus
    ]);
    if (accounts.length === 0 && !spinner && !editMode) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
        "aria-labelledby": "category-components",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "bg-opacity-0 overflow-hidden py-2 md:py-6 md:px-4",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "sr-only",
                    id: "quick-links-title",
                    children: t(`categories.${category}`)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "pb-6 flex justify-between items-center space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex gap-2 text-gray-500",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-lg sm:text-xl font-bold",
                                children: t(`categories.${category}`)
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex space-x-4 align-middle",
                            children: [
                                externalSyncText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-xs text-gray-400 my-auto",
                                    children: t("externalSync")
                                }),
                                !editMode && !isViewer && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    onClick: handleSync,
                                    text: "Sync",
                                    textColor: "text-gray-400",
                                    textColorHover: "text-gray-500",
                                    formatting: "bg-gray-50 hover:bg-gray-100 px-2",
                                    noFrameNoArrow: true,
                                    size: "xl",
                                    Icon: (0, $3ea1f91ff88fa2cb$export$59de000b07aa1ecd),
                                    spinnerOn: spinner
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-2 xl:grid-cols-3 gap-4 justify-items-center align-middle",
                    children: [
                        editMode === true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "sm:hidden w-full h-full col-span-1 max-w-[18rem]",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2343165816cf73bf$var$AddNewTile, {
                                category: category,
                                addMode: addMode,
                                setAddMode: setAddMode,
                                setEditMode: setEditMode
                            })
                        }) : null,
                        accounts.slice() // copy array
                        .sort((a, b)=>a.name.localeCompare(b.name)).map((account, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f71f19ab74e4d742$export$2e2bcd8739ae039), {
                                account: account,
                                category: category,
                                index: idx,
                                color: (0, $134ab0040d88b150$export$205e6715f8ffaf7d)[category].color,
                                Icon: (0, $134ab0040d88b150$export$205e6715f8ffaf7d)[category].Icon,
                                setAccount: setAccount,
                                editMode: editMode,
                                isViewer: isViewer,
                                accountThatIsLoading: accountThatIsLoading
                            }, account.id)),
                        editMode === true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "hidden sm:block w-full h-full col-span-1 max-w-[18rem] sm:min-w-full sm:min-h-[4.75rem]",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($2343165816cf73bf$var$AddNewTile, {
                                category: category,
                                addMode: addMode,
                                setAddMode: setAddMode,
                                setEditMode: setEditMode
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
}
$2343165816cf73bf$export$2e2bcd8739ae039.propTypes = {
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "deposits",
        "stocks",
        "realEstate",
        "pension",
        "objectsOfValue",
        "metals",
        "unlistedShares",
        "loans",
        "crypto"
    ]).isRequired,
    editMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setEditMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    addMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAddMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$2343165816cf73bf$export$2e2bcd8739ae039.defaultProps = {
    editMode: false,
    isViewer: false
};


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $a66f03c34074fce6$exports = {};
"use strict";
Object.defineProperty($a66f03c34074fce6$exports, "__esModule", {
    value: true
});
var $a66f03c34074fce6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $a66f03c34074fce6$var$_react2 = $a66f03c34074fce6$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $a66f03c34074fce6$var$_propTypes2 = $a66f03c34074fce6$var$_interopRequireDefault($2oXYc);
var $25ed1e0e429105db$exports = {};
"use strict";
Object.defineProperty($25ed1e0e429105db$exports, "__esModule", {
    value: true
});
$25ed1e0e429105db$exports.PivotData = $25ed1e0e429105db$exports.sortAs = $25ed1e0e429105db$exports.getSort = $25ed1e0e429105db$exports.numberFormat = $25ed1e0e429105db$exports.naturalSort = $25ed1e0e429105db$exports.locales = $25ed1e0e429105db$exports.derivers = $25ed1e0e429105db$exports.aggregators = $25ed1e0e429105db$exports.aggregatorTemplates = undefined;
var $25ed1e0e429105db$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $25ed1e0e429105db$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $2oXYc = parcelRequire("2oXYc");
var $25ed1e0e429105db$var$_propTypes2 = $25ed1e0e429105db$var$_interopRequireDefault($2oXYc);
function $25ed1e0e429105db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25ed1e0e429105db$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $25ed1e0e429105db$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS201: Simplify complex destructure assignments
 * DS203: Remove `|| {}` from converted for-own loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ var $25ed1e0e429105db$var$addSeparators = function addSeparators(nStr, thousandsSep, decimalSep) {
    var x = String(nStr).split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? decimalSep + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while(rgx.test(x1))x1 = x1.replace(rgx, "$1" + thousandsSep + "$2");
    return x1 + x2;
};
var $25ed1e0e429105db$var$numberFormat = function numberFormat(opts_in) {
    var defaults = {
        digitsAfterDecimal: 2,
        scaler: 1,
        thousandsSep: ",",
        decimalSep: ".",
        prefix: "",
        suffix: ""
    };
    var opts = Object.assign({}, defaults, opts_in);
    return function(x) {
        if (isNaN(x) || !isFinite(x)) return "";
        var result = $25ed1e0e429105db$var$addSeparators((opts.scaler * x).toFixed(opts.digitsAfterDecimal), opts.thousandsSep, opts.decimalSep);
        return "" + opts.prefix + result + opts.suffix;
    };
};
var $25ed1e0e429105db$var$rx = /(\d+)|(\D+)/g;
var $25ed1e0e429105db$var$rd = /\d/;
var $25ed1e0e429105db$var$rz = /^0/;
var $25ed1e0e429105db$var$naturalSort = function naturalSort(as, bs) {
    // nulls first
    if (bs !== null && as === null) return -1;
    if (as !== null && bs === null) return 1;
    // then raw NaNs
    if (typeof as === "number" && isNaN(as)) return -1;
    if (typeof bs === "number" && isNaN(bs)) return 1;
    // numbers and numbery strings group together
    var nas = Number(as);
    var nbs = Number(bs);
    if (nas < nbs) return -1;
    if (nas > nbs) return 1;
    // within that, true numbers before numbery strings
    if (typeof as === "number" && typeof bs !== "number") return -1;
    if (typeof bs === "number" && typeof as !== "number") return 1;
    if (typeof as === "number" && typeof bs === "number") return 0;
    // 'Infinity' is a textual number, so less than 'A'
    if (isNaN(nbs) && !isNaN(nas)) return -1;
    if (isNaN(nas) && !isNaN(nbs)) return 1;
    // finally, "smart" string sorting per http://stackoverflow.com/a/4373421/112871
    var a = String(as);
    var b = String(bs);
    if (a === b) return 0;
    if (!$25ed1e0e429105db$var$rd.test(a) || !$25ed1e0e429105db$var$rd.test(b)) return a > b ? 1 : -1;
    // special treatment for strings containing digits
    a = a.match($25ed1e0e429105db$var$rx);
    b = b.match($25ed1e0e429105db$var$rx);
    while(a.length && b.length){
        var a1 = a.shift();
        var b1 = b.shift();
        if (a1 !== b1) {
            if ($25ed1e0e429105db$var$rd.test(a1) && $25ed1e0e429105db$var$rd.test(b1)) return a1.replace($25ed1e0e429105db$var$rz, ".0") - b1.replace($25ed1e0e429105db$var$rz, ".0");
            return a1 > b1 ? 1 : -1;
        }
    }
    return a.length - b.length;
};
var $25ed1e0e429105db$var$sortAs = function sortAs(order) {
    var mapping = {};
    // sort lowercased keys similarly
    var l_mapping = {};
    for(var i in order){
        var x = order[i];
        mapping[x] = i;
        if (typeof x === "string") l_mapping[x.toLowerCase()] = i;
    }
    return function(a, b) {
        if (a in mapping && b in mapping) return mapping[a] - mapping[b];
        else if (a in mapping) return -1;
        else if (b in mapping) return 1;
        else if (a in l_mapping && b in l_mapping) return l_mapping[a] - l_mapping[b];
        else if (a in l_mapping) return -1;
        else if (b in l_mapping) return 1;
        return $25ed1e0e429105db$var$naturalSort(a, b);
    };
};
var $25ed1e0e429105db$var$getSort = function getSort(sorters, attr) {
    if (sorters) {
        if (typeof sorters === "function") {
            var sort = sorters(attr);
            if (typeof sort === "function") return sort;
        } else if (attr in sorters) return sorters[attr];
    }
    return $25ed1e0e429105db$var$naturalSort;
};
// aggregator templates default to US number formatting but this is overrideable
var $25ed1e0e429105db$var$usFmt = $25ed1e0e429105db$var$numberFormat();
var $25ed1e0e429105db$var$usFmtInt = $25ed1e0e429105db$var$numberFormat({
    digitsAfterDecimal: 0
});
var $25ed1e0e429105db$var$usFmtPct = $25ed1e0e429105db$var$numberFormat({
    digitsAfterDecimal: 1,
    scaler: 100,
    suffix: "%"
});
var $25ed1e0e429105db$var$aggregatorTemplates = {
    count: function count() {
        var formatter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $25ed1e0e429105db$var$usFmtInt;
        return function() {
            return function() {
                return {
                    count: 0,
                    push: function push() {
                        this.count++;
                    },
                    value: function value() {
                        return this.count;
                    },
                    format: formatter
                };
            };
        };
    },
    uniques: function uniques(fn) {
        var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $25ed1e0e429105db$var$usFmtInt;
        return function(_ref) {
            var _ref2 = $25ed1e0e429105db$var$_slicedToArray(_ref, 1), attr = _ref2[0];
            return function() {
                return {
                    uniq: [],
                    push: function push(record) {
                        if (!Array.from(this.uniq).includes(record[attr])) this.uniq.push(record[attr]);
                    },
                    value: function value() {
                        return fn(this.uniq);
                    },
                    format: formatter,
                    numInputs: typeof attr !== "undefined" ? 0 : 1
                };
            };
        };
    },
    sum: function sum() {
        var formatter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $25ed1e0e429105db$var$usFmt;
        return function(_ref3) {
            var _ref4 = $25ed1e0e429105db$var$_slicedToArray(_ref3, 1), attr = _ref4[0];
            return function() {
                return {
                    sum: 0,
                    push: function push(record) {
                        if (!isNaN(parseFloat(record[attr]))) this.sum += parseFloat(record[attr]);
                    },
                    value: function value() {
                        return this.sum;
                    },
                    format: formatter,
                    numInputs: typeof attr !== "undefined" ? 0 : 1
                };
            };
        };
    },
    extremes: function extremes(mode) {
        var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $25ed1e0e429105db$var$usFmt;
        return function(_ref5) {
            var _ref6 = $25ed1e0e429105db$var$_slicedToArray(_ref5, 1), attr = _ref6[0];
            return function(data) {
                return {
                    val: null,
                    sorter: $25ed1e0e429105db$var$getSort(typeof data !== "undefined" ? data.sorters : null, attr),
                    push: function push(record) {
                        var x = record[attr];
                        if ([
                            "min",
                            "max"
                        ].includes(mode)) {
                            x = parseFloat(x);
                            if (!isNaN(x)) this.val = Math[mode](x, this.val !== null ? this.val : x);
                        }
                        if (mode === "first" && this.sorter(x, this.val !== null ? this.val : x) <= 0) this.val = x;
                        if (mode === "last" && this.sorter(x, this.val !== null ? this.val : x) >= 0) this.val = x;
                    },
                    value: function value() {
                        return this.val;
                    },
                    format: function format(x) {
                        if (isNaN(x)) return x;
                        return formatter(x);
                    },
                    numInputs: typeof attr !== "undefined" ? 0 : 1
                };
            };
        };
    },
    quantile: function quantile(q) {
        var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $25ed1e0e429105db$var$usFmt;
        return function(_ref7) {
            var _ref8 = $25ed1e0e429105db$var$_slicedToArray(_ref7, 1), attr = _ref8[0];
            return function() {
                return {
                    vals: [],
                    push: function push(record) {
                        var x = parseFloat(record[attr]);
                        if (!isNaN(x)) this.vals.push(x);
                    },
                    value: function value() {
                        if (this.vals.length === 0) return null;
                        this.vals.sort(function(a, b) {
                            return a - b;
                        });
                        var i = (this.vals.length - 1) * q;
                        return (this.vals[Math.floor(i)] + this.vals[Math.ceil(i)]) / 2.0;
                    },
                    format: formatter,
                    numInputs: typeof attr !== "undefined" ? 0 : 1
                };
            };
        };
    },
    runningStat: function runningStat() {
        var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "mean";
        var ddof = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $25ed1e0e429105db$var$usFmt;
        return function(_ref9) {
            var _ref10 = $25ed1e0e429105db$var$_slicedToArray(_ref9, 1), attr = _ref10[0];
            return function() {
                return {
                    n: 0.0,
                    m: 0.0,
                    s: 0.0,
                    push: function push(record) {
                        var x = parseFloat(record[attr]);
                        if (isNaN(x)) return;
                        this.n += 1.0;
                        if (this.n === 1.0) this.m = x;
                        var m_new = this.m + (x - this.m) / this.n;
                        this.s = this.s + (x - this.m) * (x - m_new);
                        this.m = m_new;
                    },
                    value: function value() {
                        if (mode === "mean") {
                            if (this.n === 0) return 0 / 0;
                            return this.m;
                        }
                        if (this.n <= ddof) return 0;
                        switch(mode){
                            case "var":
                                return this.s / (this.n - ddof);
                            case "stdev":
                                return Math.sqrt(this.s / (this.n - ddof));
                            default:
                                throw new Error("unknown mode for runningStat");
                        }
                    },
                    format: formatter,
                    numInputs: typeof attr !== "undefined" ? 0 : 1
                };
            };
        };
    },
    sumOverSum: function sumOverSum() {
        var formatter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $25ed1e0e429105db$var$usFmt;
        return function(_ref11) {
            var _ref12 = $25ed1e0e429105db$var$_slicedToArray(_ref11, 2), num = _ref12[0], denom = _ref12[1];
            return function() {
                return {
                    sumNum: 0,
                    sumDenom: 0,
                    push: function push(record) {
                        if (!isNaN(parseFloat(record[num]))) this.sumNum += parseFloat(record[num]);
                        if (!isNaN(parseFloat(record[denom]))) this.sumDenom += parseFloat(record[denom]);
                    },
                    value: function value() {
                        return this.sumNum / this.sumDenom;
                    },
                    format: formatter,
                    numInputs: typeof num !== "undefined" && typeof denom !== "undefined" ? 0 : 2
                };
            };
        };
    },
    fractionOf: function fractionOf(wrapped) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "total";
        var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $25ed1e0e429105db$var$usFmtPct;
        return function() {
            for(var _len = arguments.length, x = Array(_len), _key = 0; _key < _len; _key++)x[_key] = arguments[_key];
            return function(data, rowKey, colKey) {
                return {
                    selector: ({
                        total: [
                            [],
                            []
                        ],
                        row: [
                            rowKey,
                            []
                        ],
                        col: [
                            [],
                            colKey
                        ]
                    })[type],
                    inner: wrapped.apply(undefined, $25ed1e0e429105db$var$_toConsumableArray(Array.from(x || [])))(data, rowKey, colKey),
                    push: function push(record) {
                        this.inner.push(record);
                    },
                    format: formatter,
                    value: function value() {
                        return this.inner.value() / data.getAggregator.apply(data, $25ed1e0e429105db$var$_toConsumableArray(Array.from(this.selector || []))).inner.value();
                    },
                    numInputs: wrapped.apply(undefined, $25ed1e0e429105db$var$_toConsumableArray(Array.from(x || [])))().numInputs
                };
            };
        };
    }
};
$25ed1e0e429105db$var$aggregatorTemplates.countUnique = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.uniques(function(x) {
        return x.length;
    }, f);
};
$25ed1e0e429105db$var$aggregatorTemplates.listUnique = function(s) {
    return $25ed1e0e429105db$var$aggregatorTemplates.uniques(function(x) {
        return x.join(s);
    }, function(x) {
        return x;
    });
};
$25ed1e0e429105db$var$aggregatorTemplates.max = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.extremes("max", f);
};
$25ed1e0e429105db$var$aggregatorTemplates.min = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.extremes("min", f);
};
$25ed1e0e429105db$var$aggregatorTemplates.first = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.extremes("first", f);
};
$25ed1e0e429105db$var$aggregatorTemplates.last = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.extremes("last", f);
};
$25ed1e0e429105db$var$aggregatorTemplates.median = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.quantile(0.5, f);
};
$25ed1e0e429105db$var$aggregatorTemplates.average = function(f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.runningStat("mean", 1, f);
};
$25ed1e0e429105db$var$aggregatorTemplates.var = function(ddof, f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.runningStat("var", ddof, f);
};
$25ed1e0e429105db$var$aggregatorTemplates.stdev = function(ddof, f) {
    return $25ed1e0e429105db$var$aggregatorTemplates.runningStat("stdev", ddof, f);
};
// default aggregators & renderers use US naming and number formatting
var $25ed1e0e429105db$var$aggregators = function(tpl) {
    return {
        Count: tpl.count($25ed1e0e429105db$var$usFmtInt),
        "Count Unique Values": tpl.countUnique($25ed1e0e429105db$var$usFmtInt),
        "List Unique Values": tpl.listUnique(", "),
        Sum: tpl.sum($25ed1e0e429105db$var$usFmt),
        "Integer Sum": tpl.sum($25ed1e0e429105db$var$usFmtInt),
        Average: tpl.average($25ed1e0e429105db$var$usFmt),
        Median: tpl.median($25ed1e0e429105db$var$usFmt),
        "Sample Variance": tpl.var(1, $25ed1e0e429105db$var$usFmt),
        "Sample Standard Deviation": tpl.stdev(1, $25ed1e0e429105db$var$usFmt),
        Minimum: tpl.min($25ed1e0e429105db$var$usFmt),
        Maximum: tpl.max($25ed1e0e429105db$var$usFmt),
        First: tpl.first($25ed1e0e429105db$var$usFmt),
        Last: tpl.last($25ed1e0e429105db$var$usFmt),
        "Sum over Sum": tpl.sumOverSum($25ed1e0e429105db$var$usFmt),
        "Sum as Fraction of Total": tpl.fractionOf(tpl.sum(), "total", $25ed1e0e429105db$var$usFmtPct),
        "Sum as Fraction of Rows": tpl.fractionOf(tpl.sum(), "row", $25ed1e0e429105db$var$usFmtPct),
        "Sum as Fraction of Columns": tpl.fractionOf(tpl.sum(), "col", $25ed1e0e429105db$var$usFmtPct),
        "Count as Fraction of Total": tpl.fractionOf(tpl.count(), "total", $25ed1e0e429105db$var$usFmtPct),
        "Count as Fraction of Rows": tpl.fractionOf(tpl.count(), "row", $25ed1e0e429105db$var$usFmtPct),
        "Count as Fraction of Columns": tpl.fractionOf(tpl.count(), "col", $25ed1e0e429105db$var$usFmtPct)
    };
}($25ed1e0e429105db$var$aggregatorTemplates);
var $25ed1e0e429105db$var$locales = {
    en: {
        aggregators: $25ed1e0e429105db$var$aggregators,
        localeStrings: {
            renderError: "An error occurred rendering the PivotTable results.",
            computeError: "An error occurred computing the PivotTable results.",
            uiRenderError: "An error occurred rendering the PivotTable UI.",
            selectAll: "Select All",
            selectNone: "Select None",
            tooMany: "(too many to list)",
            filterResults: "Filter values",
            apply: "Apply",
            cancel: "Cancel",
            totals: "Totals",
            vs: "vs",
            by: "by"
        }
    }
};
// dateFormat deriver l10n requires month and day names to be passed in directly
var $25ed1e0e429105db$var$mthNamesEn = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $25ed1e0e429105db$var$dayNamesEn = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
var $25ed1e0e429105db$var$zeroPad = function zeroPad(number) {
    return ("0" + number).substr(-2, 2);
}; // eslint-disable-line no-magic-numbers
var $25ed1e0e429105db$var$derivers = {
    bin: function bin(col, binWidth) {
        return function(record) {
            return record[col] - record[col] % binWidth;
        };
    },
    dateFormat: function dateFormat(col, formatString) {
        var utcOutput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var mthNames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $25ed1e0e429105db$var$mthNamesEn;
        var dayNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $25ed1e0e429105db$var$dayNamesEn;
        var utc = utcOutput ? "UTC" : "";
        return function(record) {
            var date = new Date(Date.parse(record[col]));
            if (isNaN(date)) return "";
            return formatString.replace(/%(.)/g, function(m, p) {
                switch(p){
                    case "y":
                        return date["get" + utc + "FullYear"]();
                    case "m":
                        return $25ed1e0e429105db$var$zeroPad(date["get" + utc + "Month"]() + 1);
                    case "n":
                        return mthNames[date["get" + utc + "Month"]()];
                    case "d":
                        return $25ed1e0e429105db$var$zeroPad(date["get" + utc + "Date"]());
                    case "w":
                        return dayNames[date["get" + utc + "Day"]()];
                    case "x":
                        return date["get" + utc + "Day"]();
                    case "H":
                        return $25ed1e0e429105db$var$zeroPad(date["get" + utc + "Hours"]());
                    case "M":
                        return $25ed1e0e429105db$var$zeroPad(date["get" + utc + "Minutes"]());
                    case "S":
                        return $25ed1e0e429105db$var$zeroPad(date["get" + utc + "Seconds"]());
                    default:
                        return "%" + p;
                }
            });
        };
    }
};
/*
Data Model class
*/ var $25ed1e0e429105db$var$PivotData = function() {
    function PivotData() {
        var _this = this;
        var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $25ed1e0e429105db$var$_classCallCheck(this, PivotData);
        this.props = Object.assign({}, PivotData.defaultProps, inputProps);
        $25ed1e0e429105db$var$_propTypes2.default.checkPropTypes(PivotData.propTypes, this.props, "prop", "PivotData");
        this.aggregator = this.props.aggregators[this.props.aggregatorName](this.props.vals);
        this.tree = {};
        this.rowKeys = [];
        this.colKeys = [];
        this.rowTotals = {};
        this.colTotals = {};
        this.allTotal = this.aggregator(this, [], []);
        this.sorted = false;
        // iterate through input, accumulating data for cells
        PivotData.forEachRecord(this.props.data, this.props.derivedAttributes, function(record) {
            if (_this.filter(record)) _this.processRecord(record);
        });
    }
    $25ed1e0e429105db$var$_createClass(PivotData, [
        {
            key: "filter",
            value: function filter(record) {
                for(var k in this.props.valueFilter){
                    if (record[k] in this.props.valueFilter[k]) return false;
                }
                return true;
            }
        },
        {
            key: "forEachMatchingRecord",
            value: function forEachMatchingRecord(criteria, callback) {
                var _this2 = this;
                return PivotData.forEachRecord(this.props.data, this.props.derivedAttributes, function(record) {
                    if (!_this2.filter(record)) return;
                    for(var k in criteria){
                        var v = criteria[k];
                        if (v !== (k in record ? record[k] : "null")) return;
                    }
                    callback(record);
                });
            }
        },
        {
            key: "arrSort",
            value: function arrSort(attrs) {
                var _this3 = this;
                var a = void 0;
                var sortersArr = function() {
                    var result = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(attrs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            a = _step.value;
                            result.push($25ed1e0e429105db$var$getSort(_this3.props.sorters, a));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    return result;
                }();
                return function(a, b) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = Object.keys(sortersArr || {})[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var i = _step2.value;
                            var sorter = sortersArr[i];
                            var comparison = sorter(a[i], b[i]);
                            if (comparison !== 0) return comparison;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                        } finally{
                            if (_didIteratorError2) throw _iteratorError2;
                        }
                    }
                    return 0;
                };
            }
        },
        {
            key: "sortKeys",
            value: function sortKeys() {
                var _this4 = this;
                if (!this.sorted) {
                    this.sorted = true;
                    var v = function v(r, c) {
                        return _this4.getAggregator(r, c).value();
                    };
                    switch(this.props.rowOrder){
                        case "value_a_to_z":
                            this.rowKeys.sort(function(a, b) {
                                return $25ed1e0e429105db$var$naturalSort(v(a, []), v(b, []));
                            });
                            break;
                        case "value_z_to_a":
                            this.rowKeys.sort(function(a, b) {
                                return -$25ed1e0e429105db$var$naturalSort(v(a, []), v(b, []));
                            });
                            break;
                        default:
                            this.rowKeys.sort(this.arrSort(this.props.rows));
                    }
                    switch(this.props.colOrder){
                        case "value_a_to_z":
                            this.colKeys.sort(function(a, b) {
                                return $25ed1e0e429105db$var$naturalSort(v([], a), v([], b));
                            });
                            break;
                        case "value_z_to_a":
                            this.colKeys.sort(function(a, b) {
                                return -$25ed1e0e429105db$var$naturalSort(v([], a), v([], b));
                            });
                            break;
                        default:
                            this.colKeys.sort(this.arrSort(this.props.cols));
                    }
                }
            }
        },
        {
            key: "getColKeys",
            value: function getColKeys() {
                this.sortKeys();
                return this.colKeys;
            }
        },
        {
            key: "getRowKeys",
            value: function getRowKeys() {
                this.sortKeys();
                return this.rowKeys;
            }
        },
        {
            key: "processRecord",
            value: function processRecord(record) {
                // this code is called in a tight loop
                var colKey = [];
                var rowKey = [];
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = Array.from(this.props.cols)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var x = _step3.value;
                        colKey.push(x in record ? record[x] : "null");
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                    } finally{
                        if (_didIteratorError3) throw _iteratorError3;
                    }
                }
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;
                try {
                    for(var _iterator4 = Array.from(this.props.rows)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                        var _x16 = _step4.value;
                        rowKey.push(_x16 in record ? record[_x16] : "null");
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) _iterator4.return();
                    } finally{
                        if (_didIteratorError4) throw _iteratorError4;
                    }
                }
                var flatRowKey = rowKey.join(String.fromCharCode(0));
                var flatColKey = colKey.join(String.fromCharCode(0));
                this.allTotal.push(record);
                if (rowKey.length !== 0) {
                    if (!this.rowTotals[flatRowKey]) {
                        this.rowKeys.push(rowKey);
                        this.rowTotals[flatRowKey] = this.aggregator(this, rowKey, []);
                    }
                    this.rowTotals[flatRowKey].push(record);
                }
                if (colKey.length !== 0) {
                    if (!this.colTotals[flatColKey]) {
                        this.colKeys.push(colKey);
                        this.colTotals[flatColKey] = this.aggregator(this, [], colKey);
                    }
                    this.colTotals[flatColKey].push(record);
                }
                if (colKey.length !== 0 && rowKey.length !== 0) {
                    if (!this.tree[flatRowKey]) this.tree[flatRowKey] = {};
                    if (!this.tree[flatRowKey][flatColKey]) this.tree[flatRowKey][flatColKey] = this.aggregator(this, rowKey, colKey);
                    this.tree[flatRowKey][flatColKey].push(record);
                }
            }
        },
        {
            key: "getAggregator",
            value: function getAggregator(rowKey, colKey) {
                var agg = void 0;
                var flatRowKey = rowKey.join(String.fromCharCode(0));
                var flatColKey = colKey.join(String.fromCharCode(0));
                if (rowKey.length === 0 && colKey.length === 0) agg = this.allTotal;
                else if (rowKey.length === 0) agg = this.colTotals[flatColKey];
                else if (colKey.length === 0) agg = this.rowTotals[flatRowKey];
                else agg = this.tree[flatRowKey][flatColKey];
                return agg || {
                    value: function value() {
                        return null;
                    },
                    format: function format() {
                        return "";
                    }
                };
            }
        }
    ]);
    return PivotData;
}();
// can handle arrays or jQuery selections of tables
$25ed1e0e429105db$var$PivotData.forEachRecord = function(input, derivedAttributes, f) {
    var addRecord = void 0, record = void 0;
    if (Object.getOwnPropertyNames(derivedAttributes).length === 0) addRecord = f;
    else addRecord = function addRecord(record) {
        for(var k in derivedAttributes){
            var derived = derivedAttributes[k](record);
            if (derived !== null) record[k] = derived;
        }
        return f(record);
    };
    // if it's a function, have it call us back
    if (typeof input === "function") return input(addRecord);
    else if (Array.isArray(input)) {
        if (Array.isArray(input[0])) // array of arrays
        return function() {
            var result = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;
            try {
                for(var _iterator5 = Object.keys(input || {})[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                    var i = _step5.value;
                    var compactRecord = input[i];
                    if (i > 0) {
                        record = {};
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;
                        try {
                            for(var _iterator6 = Object.keys(input[0] || {})[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                var j = _step6.value;
                                var k = input[0][j];
                                record[k] = compactRecord[j];
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) _iterator6.return();
                            } finally{
                                if (_didIteratorError6) throw _iteratorError6;
                            }
                        }
                        result.push(addRecord(record));
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) _iterator5.return();
                } finally{
                    if (_didIteratorError5) throw _iteratorError5;
                }
            }
            return result;
        }();
        // array of objects
        return function() {
            var result1 = [];
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;
            try {
                for(var _iterator7 = Array.from(input)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true){
                    record = _step7.value;
                    result1.push(addRecord(record));
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) _iterator7.return();
                } finally{
                    if (_didIteratorError7) throw _iteratorError7;
                }
            }
            return result1;
        }();
    }
    throw new Error("unknown input format");
};
$25ed1e0e429105db$var$PivotData.defaultProps = {
    aggregators: $25ed1e0e429105db$var$aggregators,
    cols: [],
    rows: [],
    vals: [],
    aggregatorName: "Count",
    sorters: {},
    valueFilter: {},
    rowOrder: "key_a_to_z",
    colOrder: "key_a_to_z",
    derivedAttributes: {}
};
$25ed1e0e429105db$var$PivotData.propTypes = {
    data: $25ed1e0e429105db$var$_propTypes2.default.oneOfType([
        $25ed1e0e429105db$var$_propTypes2.default.array,
        $25ed1e0e429105db$var$_propTypes2.default.object,
        $25ed1e0e429105db$var$_propTypes2.default.func
    ]).isRequired,
    aggregatorName: $25ed1e0e429105db$var$_propTypes2.default.string,
    cols: $25ed1e0e429105db$var$_propTypes2.default.arrayOf($25ed1e0e429105db$var$_propTypes2.default.string),
    rows: $25ed1e0e429105db$var$_propTypes2.default.arrayOf($25ed1e0e429105db$var$_propTypes2.default.string),
    vals: $25ed1e0e429105db$var$_propTypes2.default.arrayOf($25ed1e0e429105db$var$_propTypes2.default.string),
    valueFilter: $25ed1e0e429105db$var$_propTypes2.default.objectOf($25ed1e0e429105db$var$_propTypes2.default.objectOf($25ed1e0e429105db$var$_propTypes2.default.bool)),
    sorters: $25ed1e0e429105db$var$_propTypes2.default.oneOfType([
        $25ed1e0e429105db$var$_propTypes2.default.func,
        $25ed1e0e429105db$var$_propTypes2.default.objectOf($25ed1e0e429105db$var$_propTypes2.default.func)
    ]),
    derivedAttributes: $25ed1e0e429105db$var$_propTypes2.default.objectOf($25ed1e0e429105db$var$_propTypes2.default.func),
    rowOrder: $25ed1e0e429105db$var$_propTypes2.default.oneOf([
        "key_a_to_z",
        "value_a_to_z",
        "value_z_to_a"
    ]),
    colOrder: $25ed1e0e429105db$var$_propTypes2.default.oneOf([
        "key_a_to_z",
        "value_a_to_z",
        "value_z_to_a"
    ])
};
$25ed1e0e429105db$exports.aggregatorTemplates = $25ed1e0e429105db$var$aggregatorTemplates;
$25ed1e0e429105db$exports.aggregators = $25ed1e0e429105db$var$aggregators;
$25ed1e0e429105db$exports.derivers = $25ed1e0e429105db$var$derivers;
$25ed1e0e429105db$exports.locales = $25ed1e0e429105db$var$locales;
$25ed1e0e429105db$exports.naturalSort = $25ed1e0e429105db$var$naturalSort;
$25ed1e0e429105db$exports.numberFormat = $25ed1e0e429105db$var$numberFormat;
$25ed1e0e429105db$exports.getSort = $25ed1e0e429105db$var$getSort;
$25ed1e0e429105db$exports.sortAs = $25ed1e0e429105db$var$sortAs;
$25ed1e0e429105db$exports.PivotData = $25ed1e0e429105db$var$PivotData;


var $85bd0a75814cec49$exports = {};
"use strict";
Object.defineProperty($85bd0a75814cec49$exports, "__esModule", {
    value: true
});
var $85bd0a75814cec49$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $85bd0a75814cec49$var$_react2 = $85bd0a75814cec49$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $85bd0a75814cec49$var$_propTypes2 = $85bd0a75814cec49$var$_interopRequireDefault($2oXYc);

function $85bd0a75814cec49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85bd0a75814cec49$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $85bd0a75814cec49$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $85bd0a75814cec49$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// helper function for setting row/col-span in pivotTableRenderer
var $85bd0a75814cec49$var$spanSize = function spanSize(arr, i, j) {
    var x = void 0;
    if (i !== 0) {
        var asc = void 0, end = void 0;
        var noDraw = true;
        for(x = 0, end = j, asc = end >= 0; asc ? x <= end : x >= end; asc ? x++ : x--)if (arr[i - 1][x] !== arr[i][x]) noDraw = false;
        if (noDraw) return -1;
    }
    var len = 0;
    while(i + len < arr.length){
        var asc1 = void 0, end1 = void 0;
        var stop = false;
        for(x = 0, end1 = j, asc1 = end1 >= 0; asc1 ? x <= end1 : x >= end1; asc1 ? x++ : x--)if (arr[i][x] !== arr[i + len][x]) stop = true;
        if (stop) break;
        len++;
    }
    return len;
};
function $85bd0a75814cec49$var$redColorScaleGenerator(values) {
    var min = Math.min.apply(Math, values);
    var max = Math.max.apply(Math, values);
    return function(x) {
        // eslint-disable-next-line no-magic-numbers
        var nonRed = 255 - Math.round(255 * (x - min) / (max - min));
        return {
            backgroundColor: "rgb(255," + nonRed + "," + nonRed + ")"
        };
    };
}
function $85bd0a75814cec49$var$makeRenderer() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var TableRenderer = function(_React$PureComponent) {
        $85bd0a75814cec49$var$_inherits(TableRenderer, _React$PureComponent);
        function TableRenderer() {
            $85bd0a75814cec49$var$_classCallCheck(this, TableRenderer);
            return $85bd0a75814cec49$var$_possibleConstructorReturn(this, (TableRenderer.__proto__ || Object.getPrototypeOf(TableRenderer)).apply(this, arguments));
        }
        $85bd0a75814cec49$var$_createClass(TableRenderer, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var pivotData = new $25ed1e0e429105db$exports.PivotData(this.props);
                    var colAttrs = pivotData.props.cols;
                    var rowAttrs = pivotData.props.rows;
                    var rowKeys = pivotData.getRowKeys();
                    var colKeys = pivotData.getColKeys();
                    var grandTotalAggregator = pivotData.getAggregator([], []);
                    var valueCellColors = function valueCellColors() {};
                    var rowTotalColors = function rowTotalColors() {};
                    var colTotalColors = function colTotalColors() {};
                    if (opts.heatmapMode) {
                        var colorScaleGenerator = this.props.tableColorScaleGenerator;
                        var rowTotalValues = colKeys.map(function(x) {
                            return pivotData.getAggregator([], x).value();
                        });
                        rowTotalColors = colorScaleGenerator(rowTotalValues);
                        var colTotalValues = rowKeys.map(function(x) {
                            return pivotData.getAggregator(x, []).value();
                        });
                        colTotalColors = colorScaleGenerator(colTotalValues);
                        if (opts.heatmapMode === "full") {
                            var allValues = [];
                            rowKeys.map(function(r) {
                                return colKeys.map(function(c) {
                                    return allValues.push(pivotData.getAggregator(r, c).value());
                                });
                            });
                            var colorScale = colorScaleGenerator(allValues);
                            valueCellColors = function valueCellColors(r, c, v) {
                                return colorScale(v);
                            };
                        } else if (opts.heatmapMode === "row") {
                            var rowColorScales = {};
                            rowKeys.map(function(r) {
                                var rowValues = colKeys.map(function(x) {
                                    return pivotData.getAggregator(r, x).value();
                                });
                                rowColorScales[r] = colorScaleGenerator(rowValues);
                            });
                            valueCellColors = function valueCellColors(r, c, v) {
                                return rowColorScales[r](v);
                            };
                        } else if (opts.heatmapMode === "col") {
                            var colColorScales = {};
                            colKeys.map(function(c) {
                                var colValues = rowKeys.map(function(x) {
                                    return pivotData.getAggregator(x, c).value();
                                });
                                colColorScales[c] = colorScaleGenerator(colValues);
                            });
                            valueCellColors = function valueCellColors(r, c, v) {
                                return colColorScales[c](v);
                            };
                        }
                    }
                    var getClickHandler = this.props.tableOptions && this.props.tableOptions.clickCallback ? function(value, rowValues, colValues) {
                        var filters = {};
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(colAttrs || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                var attr = colAttrs[i];
                                if (colValues[i] !== null) filters[attr] = colValues[i];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                            } finally{
                                if (_didIteratorError) throw _iteratorError;
                            }
                        }
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = Object.keys(rowAttrs || {})[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var _i = _step2.value;
                                var attr = rowAttrs[_i];
                                if (rowValues[_i] !== null) filters[attr] = rowValues[_i];
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                            } finally{
                                if (_didIteratorError2) throw _iteratorError2;
                            }
                        }
                        return function(e) {
                            return _this2.props.tableOptions.clickCallback(e, value, filters, pivotData);
                        };
                    } : null;
                    return $85bd0a75814cec49$var$_react2.default.createElement("table", {
                        className: "pvtTable"
                    }, $85bd0a75814cec49$var$_react2.default.createElement("thead", null, colAttrs.map(function(c, j) {
                        return $85bd0a75814cec49$var$_react2.default.createElement("tr", {
                            key: "colAttr" + j
                        }, j === 0 && rowAttrs.length !== 0 && $85bd0a75814cec49$var$_react2.default.createElement("th", {
                            colSpan: rowAttrs.length,
                            rowSpan: colAttrs.length
                        }), $85bd0a75814cec49$var$_react2.default.createElement("th", {
                            className: "pvtAxisLabel"
                        }, c), colKeys.map(function(colKey, i) {
                            var x = $85bd0a75814cec49$var$spanSize(colKeys, i, j);
                            if (x === -1) return null;
                            return $85bd0a75814cec49$var$_react2.default.createElement("th", {
                                className: "pvtColLabel",
                                key: "colKey" + i,
                                colSpan: x,
                                rowSpan: j === colAttrs.length - 1 && rowAttrs.length !== 0 ? 2 : 1
                            }, colKey[j]);
                        }), j === 0 && $85bd0a75814cec49$var$_react2.default.createElement("th", {
                            className: "pvtTotalLabel",
                            rowSpan: colAttrs.length + (rowAttrs.length === 0 ? 0 : 1)
                        }, "Totals"));
                    }), rowAttrs.length !== 0 && $85bd0a75814cec49$var$_react2.default.createElement("tr", null, rowAttrs.map(function(r, i) {
                        return $85bd0a75814cec49$var$_react2.default.createElement("th", {
                            className: "pvtAxisLabel",
                            key: "rowAttr" + i
                        }, r);
                    }), $85bd0a75814cec49$var$_react2.default.createElement("th", {
                        className: "pvtTotalLabel"
                    }, colAttrs.length === 0 ? "Totals" : null))), $85bd0a75814cec49$var$_react2.default.createElement("tbody", null, rowKeys.map(function(rowKey, i) {
                        var totalAggregator = pivotData.getAggregator(rowKey, []);
                        return $85bd0a75814cec49$var$_react2.default.createElement("tr", {
                            key: "rowKeyRow" + i
                        }, rowKey.map(function(txt, j) {
                            var x = $85bd0a75814cec49$var$spanSize(rowKeys, i, j);
                            if (x === -1) return null;
                            return $85bd0a75814cec49$var$_react2.default.createElement("th", {
                                key: "rowKeyLabel" + i + "-" + j,
                                className: "pvtRowLabel",
                                rowSpan: x,
                                colSpan: j === rowAttrs.length - 1 && colAttrs.length !== 0 ? 2 : 1
                            }, txt);
                        }), colKeys.map(function(colKey, j) {
                            var aggregator = pivotData.getAggregator(rowKey, colKey);
                            return $85bd0a75814cec49$var$_react2.default.createElement("td", {
                                className: "pvtVal",
                                key: "pvtVal" + i + "-" + j,
                                onClick: getClickHandler && getClickHandler(aggregator.value(), rowKey, colKey),
                                style: valueCellColors(rowKey, colKey, aggregator.value())
                            }, aggregator.format(aggregator.value()));
                        }), $85bd0a75814cec49$var$_react2.default.createElement("td", {
                            className: "pvtTotal",
                            onClick: getClickHandler && getClickHandler(totalAggregator.value(), rowKey, [
                                null
                            ]),
                            style: colTotalColors(totalAggregator.value())
                        }, totalAggregator.format(totalAggregator.value())));
                    }), $85bd0a75814cec49$var$_react2.default.createElement("tr", null, $85bd0a75814cec49$var$_react2.default.createElement("th", {
                        className: "pvtTotalLabel",
                        colSpan: rowAttrs.length + (colAttrs.length === 0 ? 0 : 1)
                    }, "Totals"), colKeys.map(function(colKey, i) {
                        var totalAggregator = pivotData.getAggregator([], colKey);
                        return $85bd0a75814cec49$var$_react2.default.createElement("td", {
                            className: "pvtTotal",
                            key: "total" + i,
                            onClick: getClickHandler && getClickHandler(totalAggregator.value(), [
                                null
                            ], colKey),
                            style: rowTotalColors(totalAggregator.value())
                        }, totalAggregator.format(totalAggregator.value()));
                    }), $85bd0a75814cec49$var$_react2.default.createElement("td", {
                        onClick: getClickHandler && getClickHandler(grandTotalAggregator.value(), [
                            null
                        ], [
                            null
                        ]),
                        className: "pvtGrandTotal"
                    }, grandTotalAggregator.format(grandTotalAggregator.value())))));
                }
            }
        ]);
        return TableRenderer;
    }($85bd0a75814cec49$var$_react2.default.PureComponent);
    TableRenderer.defaultProps = $25ed1e0e429105db$exports.PivotData.defaultProps;
    TableRenderer.propTypes = $25ed1e0e429105db$exports.PivotData.propTypes;
    TableRenderer.defaultProps.tableColorScaleGenerator = $85bd0a75814cec49$var$redColorScaleGenerator;
    TableRenderer.defaultProps.tableOptions = {};
    TableRenderer.propTypes.tableColorScaleGenerator = $85bd0a75814cec49$var$_propTypes2.default.func;
    TableRenderer.propTypes.tableOptions = $85bd0a75814cec49$var$_propTypes2.default.object;
    return TableRenderer;
}
var $85bd0a75814cec49$var$TSVExportRenderer = function(_React$PureComponent2) {
    $85bd0a75814cec49$var$_inherits(TSVExportRenderer, _React$PureComponent2);
    function TSVExportRenderer() {
        $85bd0a75814cec49$var$_classCallCheck(this, TSVExportRenderer);
        return $85bd0a75814cec49$var$_possibleConstructorReturn(this, (TSVExportRenderer.__proto__ || Object.getPrototypeOf(TSVExportRenderer)).apply(this, arguments));
    }
    $85bd0a75814cec49$var$_createClass(TSVExportRenderer, [
        {
            key: "render",
            value: function render() {
                var pivotData = new $25ed1e0e429105db$exports.PivotData(this.props);
                var rowKeys = pivotData.getRowKeys();
                var colKeys = pivotData.getColKeys();
                if (rowKeys.length === 0) rowKeys.push([]);
                if (colKeys.length === 0) colKeys.push([]);
                var headerRow = pivotData.props.rows.map(function(r) {
                    return r;
                });
                if (colKeys.length === 1 && colKeys[0].length === 0) headerRow.push(this.props.aggregatorName);
                else colKeys.map(function(c) {
                    return headerRow.push(c.join("-"));
                });
                var result = rowKeys.map(function(r) {
                    var row = r.map(function(x) {
                        return x;
                    });
                    colKeys.map(function(c) {
                        var v = pivotData.getAggregator(r, c).value();
                        row.push(v ? v : "");
                    });
                    return row;
                });
                result.unshift(headerRow);
                return $85bd0a75814cec49$var$_react2.default.createElement("textarea", {
                    value: result.map(function(r) {
                        return r.join("	");
                    }).join("\n"),
                    style: {
                        width: window.innerWidth / 2,
                        height: window.innerHeight / 2
                    },
                    readOnly: true
                });
            }
        }
    ]);
    return TSVExportRenderer;
}($85bd0a75814cec49$var$_react2.default.PureComponent);
$85bd0a75814cec49$var$TSVExportRenderer.defaultProps = $25ed1e0e429105db$exports.PivotData.defaultProps;
$85bd0a75814cec49$var$TSVExportRenderer.propTypes = $25ed1e0e429105db$exports.PivotData.propTypes;
$85bd0a75814cec49$exports.default = {
    Table: $85bd0a75814cec49$var$makeRenderer(),
    "Table Heatmap": $85bd0a75814cec49$var$makeRenderer({
        heatmapMode: "full"
    }),
    "Table Col Heatmap": $85bd0a75814cec49$var$makeRenderer({
        heatmapMode: "col"
    }),
    "Table Row Heatmap": $85bd0a75814cec49$var$makeRenderer({
        heatmapMode: "row"
    }),
    "Exportable TSV": $85bd0a75814cec49$var$TSVExportRenderer
};
$85bd0a75814cec49$exports = $85bd0a75814cec49$exports["default"];


var $a66f03c34074fce6$var$_TableRenderers2 = $a66f03c34074fce6$var$_interopRequireDefault($85bd0a75814cec49$exports);
function $a66f03c34074fce6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a66f03c34074fce6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a66f03c34074fce6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a66f03c34074fce6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable react/prop-types */ // eslint can't see inherited propTypes!
var $a66f03c34074fce6$var$PivotTable = function(_React$PureComponent) {
    $a66f03c34074fce6$var$_inherits(PivotTable, _React$PureComponent);
    function PivotTable() {
        $a66f03c34074fce6$var$_classCallCheck(this, PivotTable);
        return $a66f03c34074fce6$var$_possibleConstructorReturn(this, (PivotTable.__proto__ || Object.getPrototypeOf(PivotTable)).apply(this, arguments));
    }
    $a66f03c34074fce6$var$_createClass(PivotTable, [
        {
            key: "render",
            value: function render() {
                var Renderer = this.props.renderers[this.props.rendererName in this.props.renderers ? this.props.rendererName : Object.keys(this.props.renderers)[0]];
                return $a66f03c34074fce6$var$_react2.default.createElement(Renderer, this.props);
            }
        }
    ]);
    return PivotTable;
}($a66f03c34074fce6$var$_react2.default.PureComponent);
$a66f03c34074fce6$var$PivotTable.propTypes = Object.assign({}, $25ed1e0e429105db$exports.PivotData.propTypes, {
    rendererName: $a66f03c34074fce6$var$_propTypes2.default.string,
    renderers: $a66f03c34074fce6$var$_propTypes2.default.objectOf($a66f03c34074fce6$var$_propTypes2.default.func)
});
$a66f03c34074fce6$var$PivotTable.defaultProps = Object.assign({}, $25ed1e0e429105db$exports.PivotData.defaultProps, {
    rendererName: "Table",
    renderers: $a66f03c34074fce6$var$_TableRenderers2.default
});
$a66f03c34074fce6$exports.default = $a66f03c34074fce6$var$PivotTable;
$a66f03c34074fce6$exports = $a66f03c34074fce6$exports["default"];




var $9tqwB = parcelRequire("9tqwB");


var $9tqwB = parcelRequire("9tqwB");
/* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");
let $27c38ae2c9666902$var$updateQueue = $27c38ae2c9666902$var$makeQueue();
const $27c38ae2c9666902$export$27f233d61a9e2fa4 = (fn)=>$27c38ae2c9666902$var$schedule(fn, $27c38ae2c9666902$var$updateQueue);
let $27c38ae2c9666902$var$writeQueue = $27c38ae2c9666902$var$makeQueue();
$27c38ae2c9666902$export$27f233d61a9e2fa4.write = (fn)=>$27c38ae2c9666902$var$schedule(fn, $27c38ae2c9666902$var$writeQueue);
let $27c38ae2c9666902$var$onStartQueue = $27c38ae2c9666902$var$makeQueue();
$27c38ae2c9666902$export$27f233d61a9e2fa4.onStart = (fn)=>$27c38ae2c9666902$var$schedule(fn, $27c38ae2c9666902$var$onStartQueue);
let $27c38ae2c9666902$var$onFrameQueue = $27c38ae2c9666902$var$makeQueue();
$27c38ae2c9666902$export$27f233d61a9e2fa4.onFrame = (fn)=>$27c38ae2c9666902$var$schedule(fn, $27c38ae2c9666902$var$onFrameQueue);
let $27c38ae2c9666902$var$onFinishQueue = $27c38ae2c9666902$var$makeQueue();
$27c38ae2c9666902$export$27f233d61a9e2fa4.onFinish = (fn)=>$27c38ae2c9666902$var$schedule(fn, $27c38ae2c9666902$var$onFinishQueue);
let $27c38ae2c9666902$var$timeouts = [];
$27c38ae2c9666902$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    let time = $27c38ae2c9666902$export$27f233d61a9e2fa4.now() + ms;
    let cancel = ()=>{
        let i = $27c38ae2c9666902$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $27c38ae2c9666902$var$timeouts.splice(i, 1);
        $27c38ae2c9666902$var$pendingCount -= ~i ? 1 : 0;
    };
    let timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $27c38ae2c9666902$var$timeouts.splice($27c38ae2c9666902$var$findTimeout(time), 0, timeout);
    $27c38ae2c9666902$var$pendingCount += 1;
    $27c38ae2c9666902$var$start();
    return timeout;
};
let $27c38ae2c9666902$var$findTimeout = (time)=>~(~$27c38ae2c9666902$var$timeouts.findIndex((t)=>t.time > time) || ~$27c38ae2c9666902$var$timeouts.length);
$27c38ae2c9666902$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $27c38ae2c9666902$var$onStartQueue.delete(fn);
    $27c38ae2c9666902$var$onFrameQueue.delete(fn);
    $27c38ae2c9666902$var$updateQueue.delete(fn);
    $27c38ae2c9666902$var$writeQueue.delete(fn);
    $27c38ae2c9666902$var$onFinishQueue.delete(fn);
};
$27c38ae2c9666902$export$27f233d61a9e2fa4.sync = (fn)=>{
    $27c38ae2c9666902$var$sync = true;
    $27c38ae2c9666902$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $27c38ae2c9666902$var$sync = false;
};
$27c38ae2c9666902$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $27c38ae2c9666902$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $27c38ae2c9666902$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
let $27c38ae2c9666902$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : ()=>{};
$27c38ae2c9666902$export$27f233d61a9e2fa4.use = (impl)=>$27c38ae2c9666902$var$nativeRaf = impl;
$27c38ae2c9666902$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$27c38ae2c9666902$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$27c38ae2c9666902$export$27f233d61a9e2fa4.catch = console.error;
$27c38ae2c9666902$export$27f233d61a9e2fa4.frameLoop = "always";
$27c38ae2c9666902$export$27f233d61a9e2fa4.advance = ()=>{
    if ($27c38ae2c9666902$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $27c38ae2c9666902$var$update();
};
let $27c38ae2c9666902$var$ts = -1;
let $27c38ae2c9666902$var$pendingCount = 0;
let $27c38ae2c9666902$var$sync = false;
function $27c38ae2c9666902$var$schedule(fn, queue) {
    if ($27c38ae2c9666902$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $27c38ae2c9666902$var$start();
    }
}
function $27c38ae2c9666902$var$start() {
    if ($27c38ae2c9666902$var$ts < 0) {
        $27c38ae2c9666902$var$ts = 0;
        if ($27c38ae2c9666902$export$27f233d61a9e2fa4.frameLoop !== "demand") $27c38ae2c9666902$var$nativeRaf($27c38ae2c9666902$var$loop);
    }
}
function $27c38ae2c9666902$var$stop() {
    $27c38ae2c9666902$var$ts = -1;
}
function $27c38ae2c9666902$var$loop() {
    if (~$27c38ae2c9666902$var$ts) {
        $27c38ae2c9666902$var$nativeRaf($27c38ae2c9666902$var$loop);
        $27c38ae2c9666902$export$27f233d61a9e2fa4.batchedUpdates($27c38ae2c9666902$var$update);
    }
}
function $27c38ae2c9666902$var$update() {
    let prevTs = $27c38ae2c9666902$var$ts;
    $27c38ae2c9666902$var$ts = $27c38ae2c9666902$export$27f233d61a9e2fa4.now();
    let count = $27c38ae2c9666902$var$findTimeout($27c38ae2c9666902$var$ts);
    if (count) {
        $27c38ae2c9666902$var$eachSafely($27c38ae2c9666902$var$timeouts.splice(0, count), (t)=>t.handler());
        $27c38ae2c9666902$var$pendingCount -= count;
    }
    $27c38ae2c9666902$var$onStartQueue.flush();
    $27c38ae2c9666902$var$updateQueue.flush(prevTs ? Math.min(64, $27c38ae2c9666902$var$ts - prevTs) : 16.667);
    $27c38ae2c9666902$var$onFrameQueue.flush();
    $27c38ae2c9666902$var$writeQueue.flush();
    $27c38ae2c9666902$var$onFinishQueue.flush();
    if (!$27c38ae2c9666902$var$pendingCount) $27c38ae2c9666902$var$stop();
}
function $27c38ae2c9666902$var$makeQueue() {
    let next = new Set();
    let current = next;
    return {
        add (fn) {
            $27c38ae2c9666902$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $27c38ae2c9666902$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = new Set();
                $27c38ae2c9666902$var$pendingCount -= current.size;
                $27c38ae2c9666902$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $27c38ae2c9666902$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $27c38ae2c9666902$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $27c38ae2c9666902$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
const $27c38ae2c9666902$export$ef91a23fc803e177 = {
    count () {
        return $27c38ae2c9666902$var$pendingCount;
    },
    isRunning () {
        return $27c38ae2c9666902$var$ts >= 0;
    },
    clear () {
        $27c38ae2c9666902$var$ts = -1;
        $27c38ae2c9666902$var$timeouts = [];
        $27c38ae2c9666902$var$onStartQueue = $27c38ae2c9666902$var$makeQueue();
        $27c38ae2c9666902$var$updateQueue = $27c38ae2c9666902$var$makeQueue();
        $27c38ae2c9666902$var$onFrameQueue = $27c38ae2c9666902$var$makeQueue();
        $27c38ae2c9666902$var$writeQueue = $27c38ae2c9666902$var$makeQueue();
        $27c38ae2c9666902$var$onFinishQueue = $27c38ae2c9666902$var$makeQueue();
        $27c38ae2c9666902$var$pendingCount = 0;
    }
};



var $7fPBF = parcelRequire("7fPBF");
function $590a6a92cd2ccef6$export$8793edee2d425525() {}
const $590a6a92cd2ccef6$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $590a6a92cd2ccef6$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === undefined
};
function $590a6a92cd2ccef6$export$248d38f6296296c5(a, b) {
    if ($590a6a92cd2ccef6$export$226b3eccf92c9ed9.arr(a)) {
        if (!$590a6a92cd2ccef6$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
const $590a6a92cd2ccef6$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $590a6a92cd2ccef6$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($590a6a92cd2ccef6$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
const $590a6a92cd2ccef6$export$45b10814cc054894 = (a)=>$590a6a92cd2ccef6$export$226b3eccf92c9ed9.und(a) ? [] : $590a6a92cd2ccef6$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $590a6a92cd2ccef6$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $590a6a92cd2ccef6$export$79b2f7037acddd43(items, iterator);
    }
}
const $590a6a92cd2ccef6$export$7ba486852759e806 = (queue, ...args)=>$590a6a92cd2ccef6$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
const $590a6a92cd2ccef6$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
let $590a6a92cd2ccef6$var$createStringInterpolator$1;
let $590a6a92cd2ccef6$var$to;
let $590a6a92cd2ccef6$var$colors$1 = null;
let $590a6a92cd2ccef6$var$skipAnimation = false;
let $590a6a92cd2ccef6$var$willAdvance = $590a6a92cd2ccef6$export$8793edee2d425525;
const $590a6a92cd2ccef6$var$assign = (globals)=>{
    if (globals.to) $590a6a92cd2ccef6$var$to = globals.to;
    if (globals.now) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== undefined) $590a6a92cd2ccef6$var$colors$1 = globals.colors;
    if (globals.skipAnimation != null) $590a6a92cd2ccef6$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $590a6a92cd2ccef6$var$createStringInterpolator$1 = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $590a6a92cd2ccef6$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $590a6a92cd2ccef6$export$cceeabf822b64fc0 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    get createStringInterpolator () {
        return $590a6a92cd2ccef6$var$createStringInterpolator$1;
    },
    get to () {
        return $590a6a92cd2ccef6$var$to;
    },
    get colors () {
        return $590a6a92cd2ccef6$var$colors$1;
    },
    get skipAnimation () {
        return $590a6a92cd2ccef6$var$skipAnimation;
    },
    get willAdvance () {
        return $590a6a92cd2ccef6$var$willAdvance;
    },
    assign: $590a6a92cd2ccef6$var$assign
});
const $590a6a92cd2ccef6$var$startQueue = new Set();
let $590a6a92cd2ccef6$var$currentFrame = [];
let $590a6a92cd2ccef6$var$prevFrame = [];
let $590a6a92cd2ccef6$var$priority = 0;
const $590a6a92cd2ccef6$export$a57f5080a3bcc90a = {
    get idle () {
        return !$590a6a92cd2ccef6$var$startQueue.size && !$590a6a92cd2ccef6$var$currentFrame.length;
    },
    start (animation) {
        if ($590a6a92cd2ccef6$var$priority > animation.priority) {
            $590a6a92cd2ccef6$var$startQueue.add(animation);
            (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).onStart($590a6a92cd2ccef6$var$flushStartQueue);
        } else {
            $590a6a92cd2ccef6$var$startSafely(animation);
            (0, $27c38ae2c9666902$export$27f233d61a9e2fa4)($590a6a92cd2ccef6$var$advance);
        }
    },
    advance: $590a6a92cd2ccef6$var$advance,
    sort (animation) {
        if ($590a6a92cd2ccef6$var$priority) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).onFrame(()=>$590a6a92cd2ccef6$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $590a6a92cd2ccef6$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $590a6a92cd2ccef6$var$currentFrame.splice(prevIndex, 1);
                $590a6a92cd2ccef6$var$startUnsafely(animation);
            }
        }
    },
    clear () {
        $590a6a92cd2ccef6$var$currentFrame = [];
        $590a6a92cd2ccef6$var$startQueue.clear();
    }
};
function $590a6a92cd2ccef6$var$flushStartQueue() {
    $590a6a92cd2ccef6$var$startQueue.forEach($590a6a92cd2ccef6$var$startSafely);
    $590a6a92cd2ccef6$var$startQueue.clear();
    (0, $27c38ae2c9666902$export$27f233d61a9e2fa4)($590a6a92cd2ccef6$var$advance);
}
function $590a6a92cd2ccef6$var$startSafely(animation) {
    if (!$590a6a92cd2ccef6$var$currentFrame.includes(animation)) $590a6a92cd2ccef6$var$startUnsafely(animation);
}
function $590a6a92cd2ccef6$var$startUnsafely(animation) {
    $590a6a92cd2ccef6$var$currentFrame.splice($590a6a92cd2ccef6$var$findIndex($590a6a92cd2ccef6$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $590a6a92cd2ccef6$var$advance(dt) {
    const nextFrame = $590a6a92cd2ccef6$var$prevFrame;
    for(let i = 0; i < $590a6a92cd2ccef6$var$currentFrame.length; i++){
        const animation = $590a6a92cd2ccef6$var$currentFrame[i];
        $590a6a92cd2ccef6$var$priority = animation.priority;
        if (!animation.idle) {
            $590a6a92cd2ccef6$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $590a6a92cd2ccef6$var$priority = 0;
    $590a6a92cd2ccef6$var$prevFrame = $590a6a92cd2ccef6$var$currentFrame;
    $590a6a92cd2ccef6$var$prevFrame.length = 0;
    $590a6a92cd2ccef6$var$currentFrame = nextFrame;
    return $590a6a92cd2ccef6$var$currentFrame.length > 0;
}
function $590a6a92cd2ccef6$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
const $590a6a92cd2ccef6$export$8f45430ccf837300 = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
};
const $590a6a92cd2ccef6$var$NUMBER = "[-+]?\\d*\\.?\\d+";
const $590a6a92cd2ccef6$var$PERCENTAGE = $590a6a92cd2ccef6$var$NUMBER + "%";
function $590a6a92cd2ccef6$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const $590a6a92cd2ccef6$export$8972dc0e6ad9238f = new RegExp("rgb" + $590a6a92cd2ccef6$var$call($590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$NUMBER));
const $590a6a92cd2ccef6$export$4e46ac54fc82cf3b = new RegExp("rgba" + $590a6a92cd2ccef6$var$call($590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$NUMBER));
const $590a6a92cd2ccef6$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $590a6a92cd2ccef6$var$call($590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$PERCENTAGE, $590a6a92cd2ccef6$var$PERCENTAGE));
const $590a6a92cd2ccef6$export$810b04175080204c = new RegExp("hsla" + $590a6a92cd2ccef6$var$call($590a6a92cd2ccef6$var$NUMBER, $590a6a92cd2ccef6$var$PERCENTAGE, $590a6a92cd2ccef6$var$PERCENTAGE, $590a6a92cd2ccef6$var$NUMBER));
const $590a6a92cd2ccef6$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $590a6a92cd2ccef6$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const $590a6a92cd2ccef6$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
const $590a6a92cd2ccef6$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
function $590a6a92cd2ccef6$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
    if (match = $590a6a92cd2ccef6$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($590a6a92cd2ccef6$var$colors$1 && $590a6a92cd2ccef6$var$colors$1[color] !== undefined) return $590a6a92cd2ccef6$var$colors$1[color];
    if (match = $590a6a92cd2ccef6$export$8972dc0e6ad9238f.exec(color)) return ($590a6a92cd2ccef6$var$parse255(match[1]) << 24 | $590a6a92cd2ccef6$var$parse255(match[2]) << 16 | $590a6a92cd2ccef6$var$parse255(match[3]) << 8 | 0x000000ff) >>> 0;
    if (match = $590a6a92cd2ccef6$export$4e46ac54fc82cf3b.exec(color)) return ($590a6a92cd2ccef6$var$parse255(match[1]) << 24 | $590a6a92cd2ccef6$var$parse255(match[2]) << 16 | $590a6a92cd2ccef6$var$parse255(match[3]) << 8 | $590a6a92cd2ccef6$var$parse1(match[4])) >>> 0;
    if (match = $590a6a92cd2ccef6$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
    if (match = $590a6a92cd2ccef6$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $590a6a92cd2ccef6$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
    if (match = $590a6a92cd2ccef6$export$8f4a7c0bb78e6ea8.exec(color)) return ($590a6a92cd2ccef6$var$hslToRgb($590a6a92cd2ccef6$var$parse360(match[1]), $590a6a92cd2ccef6$var$parsePercentage(match[2]), $590a6a92cd2ccef6$var$parsePercentage(match[3])) | 0x000000ff) >>> 0;
    if (match = $590a6a92cd2ccef6$export$810b04175080204c.exec(color)) return ($590a6a92cd2ccef6$var$hslToRgb($590a6a92cd2ccef6$var$parse360(match[1]), $590a6a92cd2ccef6$var$parsePercentage(match[2]), $590a6a92cd2ccef6$var$parsePercentage(match[3])) | $590a6a92cd2ccef6$var$parse1(match[4])) >>> 0;
    return null;
}
function $590a6a92cd2ccef6$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $590a6a92cd2ccef6$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $590a6a92cd2ccef6$var$hue2rgb(p, q, h + 1 / 3);
    const g = $590a6a92cd2ccef6$var$hue2rgb(p, q, h);
    const b = $590a6a92cd2ccef6$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $590a6a92cd2ccef6$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $590a6a92cd2ccef6$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $590a6a92cd2ccef6$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $590a6a92cd2ccef6$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
function $590a6a92cd2ccef6$export$61db176b839af1f(input) {
    let int32Color = $590a6a92cd2ccef6$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    let r = (int32Color & 0xff000000) >>> 24;
    let g = (int32Color & 0x00ff0000) >>> 16;
    let b = (int32Color & 0x0000ff00) >>> 8;
    let a = (int32Color & 0x000000ff) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
const $590a6a92cd2ccef6$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($590a6a92cd2ccef6$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($590a6a92cd2ccef6$export$226b3eccf92c9ed9.arr(range)) return $590a6a92cd2ccef6$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($590a6a92cd2ccef6$export$226b3eccf92c9ed9.str(range.output[0])) return $590a6a92cd2ccef6$var$createStringInterpolator$1(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range = $590a6a92cd2ccef6$var$findRange(input, inputRange);
        return $590a6a92cd2ccef6$var$interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $590a6a92cd2ccef6$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $590a6a92cd2ccef6$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
function $590a6a92cd2ccef6$var$_extends() {
    $590a6a92cd2ccef6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $590a6a92cd2ccef6$var$_extends.apply(this, arguments);
}
const $590a6a92cd2ccef6$var$$get = Symbol.for("FluidValue.get");
const $590a6a92cd2ccef6$var$$observers = Symbol.for("FluidValue.observers");
const $590a6a92cd2ccef6$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$590a6a92cd2ccef6$var$$get]);
const $590a6a92cd2ccef6$export$e37b7520edd66839 = (arg)=>arg && arg[$590a6a92cd2ccef6$var$$get] ? arg[$590a6a92cd2ccef6$var$$get]() : arg;
const $590a6a92cd2ccef6$export$133f54e9f7cf1796 = (target)=>target[$590a6a92cd2ccef6$var$$observers] || null;
function $590a6a92cd2ccef6$export$8cbca1207adce0c0(observer, event) {
    if (observer.eventObserved) observer.eventObserved(event);
    else observer(event);
}
function $590a6a92cd2ccef6$export$31752c40a5fab62a(target, event) {
    let observers = target[$590a6a92cd2ccef6$var$$observers];
    if (observers) observers.forEach((observer)=>{
        $590a6a92cd2ccef6$export$8cbca1207adce0c0(observer, event);
    });
}
class $590a6a92cd2ccef6$export$aff8e1ac1a016a2 {
    constructor(get){
        this[$590a6a92cd2ccef6$var$$get] = void 0;
        this[$590a6a92cd2ccef6$var$$observers] = void 0;
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $590a6a92cd2ccef6$export$a3b4618659637aa3(this, get);
    }
}
const $590a6a92cd2ccef6$export$a3b4618659637aa3 = (target, get)=>$590a6a92cd2ccef6$var$setHidden(target, $590a6a92cd2ccef6$var$$get, get);
function $590a6a92cd2ccef6$export$72d604e3f8d000a5(target, observer) {
    if (target[$590a6a92cd2ccef6$var$$get]) {
        let observers = target[$590a6a92cd2ccef6$var$$observers];
        if (!observers) $590a6a92cd2ccef6$var$setHidden(target, $590a6a92cd2ccef6$var$$observers, observers = new Set());
        if (!observers.has(observer)) {
            observers.add(observer);
            if (target.observerAdded) target.observerAdded(observers.size, observer);
        }
    }
    return observer;
}
function $590a6a92cd2ccef6$export$7a0eb830d336339b(target, observer) {
    let observers = target[$590a6a92cd2ccef6$var$$observers];
    if (observers && observers.has(observer)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer);
        else target[$590a6a92cd2ccef6$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer);
    }
}
const $590a6a92cd2ccef6$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
const $590a6a92cd2ccef6$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const $590a6a92cd2ccef6$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
const $590a6a92cd2ccef6$var$unitRegex = new RegExp(`(${$590a6a92cd2ccef6$var$numberRegex.source})(%|[a-z]+)`, "i");
const $590a6a92cd2ccef6$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const $590a6a92cd2ccef6$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
const $590a6a92cd2ccef6$var$variableToRgba = (input)=>{
    const [token, fallback] = $590a6a92cd2ccef6$var$parseCSSVariable(input);
    if (!token || $590a6a92cd2ccef6$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const _value = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (_value) return _value;
        else return input;
    } else if (fallback && $590a6a92cd2ccef6$var$cssVariableRegex.test(fallback)) return $590a6a92cd2ccef6$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
const $590a6a92cd2ccef6$var$parseCSSVariable = (current)=>{
    const match = $590a6a92cd2ccef6$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
let $590a6a92cd2ccef6$var$namedColorRegex;
const $590a6a92cd2ccef6$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
const $590a6a92cd2ccef6$export$4759a013d387347a = (config)=>{
    if (!$590a6a92cd2ccef6$var$namedColorRegex) $590a6a92cd2ccef6$var$namedColorRegex = $590a6a92cd2ccef6$var$colors$1 ? new RegExp(`(${Object.keys($590a6a92cd2ccef6$var$colors$1).join("|")})(?!\\w)`, "g") : /^\b$/;
    const output = config.output.map((value)=>{
        return $590a6a92cd2ccef6$export$e37b7520edd66839(value).replace($590a6a92cd2ccef6$var$cssVariableRegex, $590a6a92cd2ccef6$var$variableToRgba).replace($590a6a92cd2ccef6$var$colorRegex, $590a6a92cd2ccef6$export$61db176b839af1f).replace($590a6a92cd2ccef6$var$namedColorRegex, $590a6a92cd2ccef6$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($590a6a92cd2ccef6$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output)=>$590a6a92cd2ccef6$export$b12af43b97697ef5($590a6a92cd2ccef6$var$_extends({}, config, {
            output: output
        })));
    return (input)=>{
        var _output$find;
        const missingUnit = !$590a6a92cd2ccef6$var$unitRegex.test(output[0]) && ((_output$find = output.find((value)=>$590a6a92cd2ccef6$var$unitRegex.test(value))) == null ? void 0 : _output$find.replace($590a6a92cd2ccef6$var$numberRegex, ""));
        let i = 0;
        return output[0].replace($590a6a92cd2ccef6$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($590a6a92cd2ccef6$var$rgbaRegex, $590a6a92cd2ccef6$var$rgbaRound);
    };
};
const $590a6a92cd2ccef6$var$prefix = "react-spring: ";
const $590a6a92cd2ccef6$var$once = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$590a6a92cd2ccef6$var$prefix}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
const $590a6a92cd2ccef6$var$warnInterpolate = $590a6a92cd2ccef6$var$once(console.warn);
function $590a6a92cd2ccef6$export$2abfcde8ae218ba8() {
    $590a6a92cd2ccef6$var$warnInterpolate(`${$590a6a92cd2ccef6$var$prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const $590a6a92cd2ccef6$var$warnDirectCall = $590a6a92cd2ccef6$var$once(console.warn);
function $590a6a92cd2ccef6$export$d99d974913ad3b12() {
    $590a6a92cd2ccef6$var$warnDirectCall(`${$590a6a92cd2ccef6$var$prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function $590a6a92cd2ccef6$export$75bed621f62abfa9(value) {
    return $590a6a92cd2ccef6$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || !$590a6a92cd2ccef6$export$48d7c418edadb60c() && $590a6a92cd2ccef6$var$cssVariableRegex.test(value) || value in ($590a6a92cd2ccef6$var$colors$1 || {}));
}
const $590a6a92cd2ccef6$export$e5c5a5f917a5871c = typeof window !== "undefined" && window.document && window.document.createElement ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
const $590a6a92cd2ccef6$var$useIsMounted = ()=>{
    const isMounted = (0, $7fPBF.useRef)(false);
    $590a6a92cd2ccef6$export$e5c5a5f917a5871c(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
function $590a6a92cd2ccef6$export$91db9bc4f8ac944a() {
    const update = (0, $7fPBF.useState)()[1];
    const isMounted = $590a6a92cd2ccef6$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $590a6a92cd2ccef6$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $7fPBF.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $7fPBF.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $590a6a92cd2ccef6$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $7fPBF.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = undefined;
    }, [
        cache
    ]);
    return cache.result;
}
function $590a6a92cd2ccef6$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
const $590a6a92cd2ccef6$export$392544347a18b6ea = (effect)=>(0, $7fPBF.useEffect)(effect, $590a6a92cd2ccef6$var$emptyDeps);
const $590a6a92cd2ccef6$var$emptyDeps = [];
function $590a6a92cd2ccef6$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $5695012d6ed98c47$var$$node = Symbol.for("Animated:node");
const $5695012d6ed98c47$export$3df5e165e801a70f = (value)=>!!value && value[$5695012d6ed98c47$var$$node] === value;
const $5695012d6ed98c47$export$6b63995194a3a9e4 = (owner)=>owner && owner[$5695012d6ed98c47$var$$node];
const $5695012d6ed98c47$export$b553cb5b22b81b04 = (owner, node)=>(0, $590a6a92cd2ccef6$export$5c74248ea0e35446)(owner, $5695012d6ed98c47$var$$node, node);
const $5695012d6ed98c47$export$ccab2b64c5d440 = (owner)=>owner && owner[$5695012d6ed98c47$var$$node] && owner[$5695012d6ed98c47$var$$node].getPayload();
class $5695012d6ed98c47$export$31627395a3b18e54 {
    getPayload() {
        return this.payload || [];
    }
    constructor(){
        this.payload = void 0;
        $5695012d6ed98c47$export$b553cb5b22b81b04(this, this);
    }
}
class $5695012d6ed98c47$export$cb1e8f3c05d37ad5 extends $5695012d6ed98c47$export$31627395a3b18e54 {
    static create(value) {
        return new $5695012d6ed98c47$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this.done = true;
        this.elapsedTime = void 0;
        this.lastPosition = void 0;
        this.lastVelocity = void 0;
        this.v0 = void 0;
        this.durationProgress = 0;
        this._value = _value;
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
}
class $5695012d6ed98c47$export$f6c6c4cbd7fa5b93 extends $5695012d6ed98c47$export$cb1e8f3c05d37ad5 {
    static create(value) {
        return new $5695012d6ed98c47$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        let value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $590a6a92cd2ccef6$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = void 0;
        this._toString = (0, $590a6a92cd2ccef6$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
}
const $5695012d6ed98c47$var$TreeContext = {
    dependencies: null
};
class $5695012d6ed98c47$export$f1b0b9e366a6e2d4 extends $5695012d6ed98c47$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($5695012d6ed98c47$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    _makePayload(source) {
        if (source) {
            const payload = new Set();
            (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    _addToPayload(source) {
        if ($5695012d6ed98c47$var$TreeContext.dependencies && (0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(source)) $5695012d6ed98c47$var$TreeContext.dependencies.add(source);
        const payload = $5695012d6ed98c47$export$ccab2b64c5d440(source);
        if (payload) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
}
class $5695012d6ed98c47$export$ede394683406942d extends $5695012d6ed98c47$export$f1b0b9e366a6e2d4 {
    static create(source) {
        return new $5695012d6ed98c47$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($5695012d6ed98c47$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
}
function $5695012d6ed98c47$var$makeAnimated(value) {
    const nodeType = (0, $590a6a92cd2ccef6$export$75bed621f62abfa9)(value) ? $5695012d6ed98c47$export$f6c6c4cbd7fa5b93 : $5695012d6ed98c47$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $5695012d6ed98c47$export$e6b77ddbe47b132e(value) {
    const parentNode = $5695012d6ed98c47$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(value) ? $5695012d6ed98c47$export$ede394683406942d : (0, $590a6a92cd2ccef6$export$75bed621f62abfa9)(value) ? $5695012d6ed98c47$export$f6c6c4cbd7fa5b93 : $5695012d6ed98c47$export$cb1e8f3c05d37ad5;
}
function $5695012d6ed98c47$var$_extends() {
    $5695012d6ed98c47$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5695012d6ed98c47$var$_extends.apply(this, arguments);
}
const $5695012d6ed98c47$var$withAnimated = (Component, host)=>{
    const hasInstance = !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $7fPBF.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $7fPBF.useRef)(null);
        const ref = hasInstance && (0, $7fPBF.useCallback)((value)=>{
            instanceRef.current = $5695012d6ed98c47$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $5695012d6ed98c47$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $590a6a92cd2ccef6$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $5695012d6ed98c47$var$PropsObserver(callback, deps);
        const observerRef = (0, $7fPBF.useRef)();
        (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
            observerRef.current = observer;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(deps, (dep)=>(0, $590a6a92cd2ccef6$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $590a6a92cd2ccef6$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $7fPBF.useEffect)(callback, []);
        (0, $590a6a92cd2ccef6$export$392544347a18b6ea)(()=>()=>{
                const observer = observerRef.current;
                (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(observer.deps, (dep)=>(0, $590a6a92cd2ccef6$export$7a0eb830d336339b)(dep, observer));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return $7fPBF.createElement(Component, $5695012d6ed98c47$var$_extends({}, usedProps, {
            ref: ref
        }));
    });
};
class $5695012d6ed98c47$var$PropsObserver {
    eventObserved(event) {
        if (event.type == "change") (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
}
function $5695012d6ed98c47$var$getAnimatedState(props, host) {
    const dependencies = new Set();
    $5695012d6ed98c47$var$TreeContext.dependencies = dependencies;
    if (props.style) props = $5695012d6ed98c47$var$_extends({}, props, {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $5695012d6ed98c47$export$f1b0b9e366a6e2d4(props);
    $5695012d6ed98c47$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $5695012d6ed98c47$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
const $5695012d6ed98c47$var$cacheKey = Symbol.for("AnimatedComponent");
const $5695012d6ed98c47$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: _applyAnimatedValues = ()=>false, createAnimatedStyle: _createAnimatedStyle = (style)=>new $5695012d6ed98c47$export$f1b0b9e366a6e2d4(style), getComponentProps: _getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: _applyAnimatedValues,
        createAnimatedStyle: _createAnimatedStyle,
        getComponentProps: _getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $5695012d6ed98c47$var$getDisplayName(Component) || "Anonymous";
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $5695012d6ed98c47$var$withAnimated(Component, hostConfig));
        else Component = Component[$5695012d6ed98c47$var$cacheKey] || (Component[$5695012d6ed98c47$var$cacheKey] = $5695012d6ed98c47$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(components)) key = $5695012d6ed98c47$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
const $5695012d6ed98c47$var$getDisplayName = (arg)=>(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;






function $27d73b36303119b6$var$_extends() {
    $27d73b36303119b6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27d73b36303119b6$var$_extends.apply(this, arguments);
}
function $27d73b36303119b6$var$callProp(value, ...args) {
    return (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
const $27d73b36303119b6$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $590a6a92cd2ccef6$export$45b10814cc054894)(value).includes(key)));
const $27d73b36303119b6$var$resolveProp = (prop, key)=>(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
const $27d73b36303119b6$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : undefined;
const $27d73b36303119b6$var$noopTransform = (value)=>value;
const $27d73b36303119b6$var$getDefaultProps = (props, transform = $27d73b36303119b6$var$noopTransform)=>{
    let keys = $27d73b36303119b6$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(value)) defaults[key] = value;
    }
    return defaults;
};
const $27d73b36303119b6$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
const $27d73b36303119b6$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    keys: 1,
    callId: 1,
    parentId: 1
};
function $27d73b36303119b6$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$27d73b36303119b6$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $27d73b36303119b6$export$b971039a739bf227(props) {
    const to = $27d73b36303119b6$var$getForwardProps(props);
    if (to) {
        const out = {
            to: to
        };
        (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(props, (val, key)=>key in to || (out[key] = val));
        return out;
    }
    return $27d73b36303119b6$var$_extends({}, props);
}
function $27d73b36303119b6$var$computeGoal(value) {
    value = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(value);
    return (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(value) ? value.map($27d73b36303119b6$var$computeGoal) : (0, $590a6a92cd2ccef6$export$75bed621f62abfa9)(value) ? (0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $27d73b36303119b6$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $27d73b36303119b6$var$isAsyncTo(to) {
    return (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(to) || (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(to) && (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(to[0]);
}
function $27d73b36303119b6$var$detachRefs(ctrl, ref) {
    var _ctrl$ref;
    (_ctrl$ref = ctrl.ref) == null || _ctrl$ref.delete(ctrl);
    ref == null || ref.delete(ctrl);
}
function $27d73b36303119b6$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl$ref2;
        (_ctrl$ref2 = ctrl.ref) == null || _ctrl$ref2.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
function $27d73b36303119b6$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1000) {
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $27d73b36303119b6$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(queues[i] || [], (update)=>ctrl.queue.push(update)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
const $27d73b36303119b6$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
const $27d73b36303119b6$var$c1 = 1.70158;
const $27d73b36303119b6$var$c2 = $27d73b36303119b6$var$c1 * 1.525;
const $27d73b36303119b6$var$c3 = $27d73b36303119b6$var$c1 + 1;
const $27d73b36303119b6$var$c4 = 2 * Math.PI / 3;
const $27d73b36303119b6$var$c5 = 2 * Math.PI / 4.5;
const $27d73b36303119b6$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
const $27d73b36303119b6$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$27d73b36303119b6$var$c3 * x * x * x - $27d73b36303119b6$var$c1 * x * x,
    easeOutBack: (x)=>1 + $27d73b36303119b6$var$c3 * Math.pow(x - 1, 3) + $27d73b36303119b6$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($27d73b36303119b6$var$c2 + 1) * 2 * x - $27d73b36303119b6$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($27d73b36303119b6$var$c2 + 1) * (x * 2 - 2) + $27d73b36303119b6$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $27d73b36303119b6$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $27d73b36303119b6$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $27d73b36303119b6$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $27d73b36303119b6$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $27d73b36303119b6$var$bounceOut(1 - x),
    easeOutBounce: $27d73b36303119b6$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $27d73b36303119b6$var$bounceOut(1 - 2 * x)) / 2 : (1 + $27d73b36303119b6$var$bounceOut(2 * x - 1)) / 2
};
const $27d73b36303119b6$var$defaults = $27d73b36303119b6$var$_extends({}, $27d73b36303119b6$export$e506a1d27d1eaa20.default, {
    mass: 1,
    damping: 1,
    easing: $27d73b36303119b6$export$15a0bf1b4bbacad8.linear,
    clamp: false
});
class $27d73b36303119b6$var$AnimationConfig {
    constructor(){
        this.tension = void 0;
        this.friction = void 0;
        this.frequency = void 0;
        this.damping = void 0;
        this.mass = void 0;
        this.velocity = 0;
        this.restVelocity = void 0;
        this.precision = void 0;
        this.progress = void 0;
        this.duration = void 0;
        this.easing = void 0;
        this.clamp = void 0;
        this.bounce = void 0;
        this.decay = void 0;
        this.round = void 0;
        Object.assign(this, $27d73b36303119b6$var$defaults);
    }
}
function $27d73b36303119b6$var$mergeConfig(config, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = $27d73b36303119b6$var$_extends({}, defaultConfig);
        $27d73b36303119b6$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = $27d73b36303119b6$var$_extends({}, defaultConfig, newConfig);
    }
    $27d73b36303119b6$var$sanitizeConfig(config, newConfig);
    Object.assign(config, newConfig);
    for(const key in $27d73b36303119b6$var$defaults)if (config[key] == null) config[key] = $27d73b36303119b6$var$defaults[key];
    let { mass: mass, frequency: frequency, damping: damping } = config;
    if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config;
}
function $27d73b36303119b6$var$sanitizeConfig(config, props) {
    if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.decay)) config.duration = undefined;
    else {
        const isTensionConfig = !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.tension) || !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.damping) || !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.mass)) {
            config.duration = undefined;
            config.decay = undefined;
        }
        if (isTensionConfig) config.frequency = undefined;
    }
}
const $27d73b36303119b6$var$emptyArray = [];
class $27d73b36303119b6$var$Animation {
    constructor(){
        this.changed = false;
        this.values = $27d73b36303119b6$var$emptyArray;
        this.toValues = null;
        this.fromValues = $27d73b36303119b6$var$emptyArray;
        this.to = void 0;
        this.from = void 0;
        this.config = new $27d73b36303119b6$var$AnimationConfig();
        this.immediate = false;
    }
}
function $27d73b36303119b6$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        var _props$cancel;
        let delay;
        let timeout;
        let cancel = $27d73b36303119b6$var$matchProp((_props$cancel = props.cancel) != null ? _props$cancel : defaultProps == null ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $27d73b36303119b6$var$matchProp(props.pause, key);
            let pause = defaultProps == null ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $27d73b36303119b6$var$matchProp(pause, key);
            delay = $27d73b36303119b6$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start($27d73b36303119b6$var$_extends({}, props, {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
const $27d73b36303119b6$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $27d73b36303119b6$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $27d73b36303119b6$var$getNoopResult(target.get()) : $27d73b36303119b6$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
const $27d73b36303119b6$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
const $27d73b36303119b6$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
const $27d73b36303119b6$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
function $27d73b36303119b6$var$runAsync(to, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to;
        const defaultProps = $27d73b36303119b6$var$getDefaultProps(props, (value, key)=>key === "onRest" ? undefined : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = callId <= (state.cancelId || 0) && $27d73b36303119b6$var$getCancelledResult(target) || callId !== state.asyncId && $27d73b36303119b6$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $27d73b36303119b6$export$d362d093fa99dc7();
            const skipAnimationSignal = new $27d73b36303119b6$var$SkipAniamtionSignal();
            return (async ()=>{
                if ((0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).skipAnimation) {
                    $27d73b36303119b6$var$stopAsync(state);
                    skipAnimationSignal.result = $27d73b36303119b6$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(arg1) ? $27d73b36303119b6$var$_extends({}, arg1) : $27d73b36303119b6$var$_extends({}, arg2, {
                    to: arg1
                });
                props.parentId = callId;
                (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props[key])) props[key] = value;
                });
                const result = await target.start(props);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result;
            })();
        };
        let result;
        if ((0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).skipAnimation) {
            $27d73b36303119b6$var$stopAsync(state);
            return $27d73b36303119b6$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(to)) animating = (async (queue)=>{
                for (const props of queue)await animate(props);
            })(to);
            else animating = Promise.resolve(to(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $27d73b36303119b6$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $27d73b36303119b6$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $27d73b36303119b6$var$SkipAniamtionSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : undefined;
                state.promise = parentId ? prevPromise : undefined;
            }
        }
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(onRest)) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $27d73b36303119b6$var$stopAsync(state, cancelId) {
    (0, $590a6a92cd2ccef6$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = undefined;
    if (cancelId) state.cancelId = cancelId;
}
class $27d73b36303119b6$export$d362d093fa99dc7 extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
        this.result = void 0;
    }
}
class $27d73b36303119b6$var$SkipAniamtionSignal extends Error {
    constructor(){
        super("SkipAnimationSignal");
        this.result = void 0;
    }
}
const $27d73b36303119b6$var$isFrameValue = (value)=>value instanceof $27d73b36303119b6$export$8229896f80e2495e;
let $27d73b36303119b6$var$nextId$1 = 1;
class $27d73b36303119b6$export$8229896f80e2495e extends (0, $590a6a92cd2ccef6$export$aff8e1ac1a016a2) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    get() {
        const node = (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    to(...args) {
        return (0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).to(this, args);
    }
    interpolate(...args) {
        (0, $590a6a92cd2ccef6$export$2abfcde8ae218ba8)();
        return (0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    _attach() {}
    _detach() {}
    _onChange(value, idle = false) {
        (0, $590a6a92cd2ccef6$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    _onPriorityChange(priority) {
        if (!this.idle) (0, $590a6a92cd2ccef6$export$a57f5080a3bcc90a).sort(this);
        (0, $590a6a92cd2ccef6$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(...args){
        super(...args);
        this.id = $27d73b36303119b6$var$nextId$1++;
        this.key = void 0;
        this._priority = 0;
    }
}
const $27d73b36303119b6$var$$P = Symbol.for("SpringPhase");
const $27d73b36303119b6$var$HAS_ANIMATED = 1;
const $27d73b36303119b6$var$IS_ANIMATING = 2;
const $27d73b36303119b6$var$IS_PAUSED = 4;
const $27d73b36303119b6$var$hasAnimated = (target)=>(target[$27d73b36303119b6$var$$P] & $27d73b36303119b6$var$HAS_ANIMATED) > 0;
const $27d73b36303119b6$var$isAnimating = (target)=>(target[$27d73b36303119b6$var$$P] & $27d73b36303119b6$var$IS_ANIMATING) > 0;
const $27d73b36303119b6$var$isPaused = (target)=>(target[$27d73b36303119b6$var$$P] & $27d73b36303119b6$var$IS_PAUSED) > 0;
const $27d73b36303119b6$var$setActiveBit = (target, active)=>active ? target[$27d73b36303119b6$var$$P] |= $27d73b36303119b6$var$IS_ANIMATING | $27d73b36303119b6$var$HAS_ANIMATED : target[$27d73b36303119b6$var$$P] &= ~$27d73b36303119b6$var$IS_ANIMATING;
const $27d73b36303119b6$var$setPausedBit = (target, paused)=>paused ? target[$27d73b36303119b6$var$$P] |= $27d73b36303119b6$var$IS_PAUSED : target[$27d73b36303119b6$var$$P] &= ~$27d73b36303119b6$var$IS_PAUSED;
class $27d73b36303119b6$export$5854d13427d5a954 extends $27d73b36303119b6$export$8229896f80e2495e {
    get idle() {
        return !($27d73b36303119b6$var$isAnimating(this) || this._state.asyncTo) || $27d73b36303119b6$var$isPaused(this);
    }
    get goal() {
        return (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $5695012d6ed98c47$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node)=>node.lastVelocity || 0);
    }
    get hasAnimated() {
        return $27d73b36303119b6$var$hasAnimated(this);
    }
    get isAnimating() {
        return $27d73b36303119b6$var$isAnimating(this);
    }
    get isPaused() {
        return $27d73b36303119b6$var$isPaused(this);
    }
    get isDelayed() {
        return this._state.delayed;
    }
    advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { config: config, toValues: toValues } = anim;
        const payload = (0, $5695012d6ed98c47$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $590a6a92cd2ccef6$export$45b10814cc054894)((0, $590a6a92cd2ccef6$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node, i)=>{
            if (node.done) return;
            const to = node.constructor == (0, $5695012d6ed98c47$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to;
            if (!finished) {
                position = node.lastPosition;
                if (config.tension <= 0) {
                    node.done = true;
                    return;
                }
                let elapsed = node.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node.v0 != null ? node.v0 : node.v0 = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(config.velocity) ? config.velocity[i] : config.velocity;
                let velocity;
                if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(config.duration)) {
                    let p = 1;
                    if (config.duration > 0) {
                        if (this._memoizedDuration !== config.duration) {
                            this._memoizedDuration = config.duration;
                            if (node.durationProgress > 0) {
                                node.elapsedTime = config.duration * node.durationProgress;
                                elapsed = node.elapsedTime += dt;
                            }
                        }
                        p = (config.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node.durationProgress = p;
                    }
                    position = from + config.easing(p) * (to - from);
                    velocity = (position - node.lastPosition) / dt;
                    finished = p == 1;
                } else if (config.decay) {
                    const decay = config.decay === true ? 0.998 : config.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node.lastPosition - position) < 0.1;
                    velocity = v0 * e;
                } else {
                    velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
                    const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
                    const restVelocity = config.restVelocity || precision / 10;
                    const bounceFactor = config.clamp ? 0 : config.bounce;
                    const canBounce = !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to ? node.v0 > 0 : from < to;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to || position > to == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to;
                            }
                        }
                        const springForce = -config.tension * 0.000001 * (position - to);
                        const dampingForce = -config.friction * 0.001 * velocity;
                        const acceleration = (springForce + dampingForce) / config.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node.done = true;
            else idle = false;
            if (node.setValue(position, config.round)) changed = true;
        });
        const node = (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    set(value) {
        (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    pause() {
        this._update({
            pause: true
        });
    }
    resume() {
        this._update({
            pause: false
        });
    }
    finish() {
        if ($27d73b36303119b6$var$isAnimating(this)) {
            const { to: to, config: config } = this.animation;
            (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config.decay) this._set(to, false);
                this._stop();
            });
        }
        return this;
    }
    update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to, arg2) {
        let queue;
        if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(to)) queue = [
            (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(to) ? to : $27d73b36303119b6$var$_extends({}, arg2, {
                to: to
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$27d73b36303119b6$var$getCombinedResult(this, results));
    }
    stop(cancel) {
        const { to: to } = this.animation;
        this._focus(this.get());
        $27d73b36303119b6$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to, cancel));
        return this;
    }
    reset() {
        this._update({
            reset: true
        });
    }
    eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    _prepareNode(props) {
        const key = this.key || "";
        let { to: to, from: from } = props;
        to = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(to) ? to[key] : to;
        if (to == null || $27d73b36303119b6$var$isAsyncTo(to)) to = undefined;
        from = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = undefined;
        const range = {
            to: to,
            from: from
        };
        if (!$27d73b36303119b6$var$hasAnimated(this)) {
            if (props.reverse) [to, from] = [
                from,
                to
            ];
            from = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(from);
            if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this)) this._set(to);
        }
        return range;
    }
    _update(_ref, isLoop) {
        let props = $27d73b36303119b6$var$_extends({}, _ref);
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $27d73b36303119b6$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $27d73b36303119b6$var$resolveProp(value, key) : value));
        $27d73b36303119b6$var$mergeActiveFn(this, props, "onProps");
        $27d73b36303119b6$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $27d73b36303119b6$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$27d73b36303119b6$var$isPaused(this)) {
                        $27d73b36303119b6$var$setPausedBit(this, true);
                        (0, $590a6a92cd2ccef6$export$7ba486852759e806)(state.pauseQueue);
                        $27d73b36303119b6$var$sendEvent(this, "onPause", $27d73b36303119b6$var$getFinishedResult(this, $27d73b36303119b6$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($27d73b36303119b6$var$isPaused(this)) {
                        $27d73b36303119b6$var$setPausedBit(this, false);
                        if ($27d73b36303119b6$var$isAnimating(this)) this._resume();
                        (0, $590a6a92cd2ccef6$export$7ba486852759e806)(state.resumeQueue);
                        $27d73b36303119b6$var$sendEvent(this, "onResume", $27d73b36303119b6$var$getFinishedResult(this, $27d73b36303119b6$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $27d73b36303119b6$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($27d73b36303119b6$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($27d73b36303119b6$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(to))) to = from;
        if (props.reverse) [to, from] = [
            from,
            to
        ];
        const hasFromChanged = !(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(to, prevTo);
        if (hasToChanged) this._focus(to);
        const hasAsyncTo = $27d73b36303119b6$var$isAsyncTo(props.to);
        const { config: config } = anim;
        const { decay: decay, velocity: velocity } = config;
        if (hasToProp || hasFromProp) config.velocity = 0;
        if (props.config && !hasAsyncTo) $27d73b36303119b6$var$mergeConfig(config, $27d73b36303119b6$var$callProp(props.config, key), props.config !== defaultProps.config ? $27d73b36303119b6$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this);
        if (!node || (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(to)) return resolve($27d73b36303119b6$var$getFinishedResult(this, true));
        const reset = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(from) && $27d73b36303119b6$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $27d73b36303119b6$var$computeGoal(to);
        const isAnimatable = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(goal) || (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(goal) || (0, $590a6a92cd2ccef6$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $27d73b36303119b6$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $5695012d6ed98c47$export$e6b77ddbe47b132e)(to);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(to);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$27d73b36303119b6$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $590a6a92cd2ccef6$export$248d38f6296296c5)($27d73b36303119b6$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(config.decay, decay) || !(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(config.velocity, velocity)) started = true;
        }
        if (finished && $27d73b36303119b6$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(to) ? null : goalType == (0, $5695012d6ed98c47$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $590a6a92cd2ccef6$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)($27d73b36303119b6$var$ACTIVE_EVENTS, (type)=>$27d73b36303119b6$var$mergeActiveFn(this, props, type));
                const result = $27d73b36303119b6$var$getFinishedResult(this, $27d73b36303119b6$var$checkFinished(this, prevTo));
                (0, $590a6a92cd2ccef6$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest == null || onRest(result, this);
                    if (reset) $27d73b36303119b6$var$callProp(defaultProps.onRest, result);
                    else anim.onStart == null || anim.onStart(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($27d73b36303119b6$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($27d73b36303119b6$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($27d73b36303119b6$var$getNoopResult(value));
    }
    _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $590a6a92cd2ccef6$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $590a6a92cd2ccef6$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to } = this.animation;
        if ((0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(to)) {
            (0, $590a6a92cd2ccef6$export$72d604e3f8d000a5)(to, this);
            if ($27d73b36303119b6$var$isFrameValue(to)) priority = to.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to } = this.animation;
        if ((0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(to)) (0, $590a6a92cd2ccef6$export$7a0eb830d336339b)(to, this);
    }
    _set(arg, idle = true) {
        const value = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(arg);
        if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $5695012d6ed98c47$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $5695012d6ed98c47$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $27d73b36303119b6$var$sendEvent(this, "onStart", $27d73b36303119b6$var$getFinishedResult(this, $27d73b36303119b6$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $27d73b36303119b6$var$callProp(this.animation.onChange, value, this);
        }
        $27d73b36303119b6$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    _start() {
        const anim = this.animation;
        (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this).reset((0, $590a6a92cd2ccef6$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$27d73b36303119b6$var$isAnimating(this)) {
            $27d73b36303119b6$var$setActiveBit(this, true);
            if (!$27d73b36303119b6$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $590a6a92cd2ccef6$export$a57f5080a3bcc90a).start(this);
    }
    _stop(goal, cancel) {
        if ($27d73b36303119b6$var$isAnimating(this)) {
            $27d73b36303119b6$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = undefined;
            (0, $590a6a92cd2ccef6$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $27d73b36303119b6$var$getCancelledResult(this.get()) : $27d73b36303119b6$var$getFinishedResult(this.get(), $27d73b36303119b6$var$checkFinished(this, goal != null ? goal : anim.to));
            (0, $590a6a92cd2ccef6$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $27d73b36303119b6$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        this.key = void 0;
        this.animation = new $27d73b36303119b6$var$Animation();
        this.queue = void 0;
        this.defaultProps = {};
        this._state = {
            paused: false,
            delayed: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._pendingCalls = new Set();
        this._lastCallId = 0;
        this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(arg1) || !(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(arg1) ? $27d73b36303119b6$var$_extends({}, arg1) : $27d73b36303119b6$var$_extends({}, arg2, {
                from: arg1
            });
            if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
}
function $27d73b36303119b6$var$checkFinished(target, to) {
    const goal = $27d73b36303119b6$var$computeGoal(to);
    const value = $27d73b36303119b6$var$computeGoal(target.get());
    return (0, $590a6a92cd2ccef6$export$248d38f6296296c5)(value, goal);
}
function $27d73b36303119b6$var$createLoopUpdate(props, loop = props.loop, to = props.to) {
    let loopRet = $27d73b36303119b6$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $27d73b36303119b6$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $27d73b36303119b6$var$createUpdate($27d73b36303119b6$var$_extends({}, props, {
            loop: loop,
            default: false,
            pause: undefined,
            to: !reverse || $27d73b36303119b6$var$isAsyncTo(to) ? to : undefined,
            from: reset ? props.from : undefined,
            reset: reset
        }, overrides));
    }
}
function $27d73b36303119b6$var$createUpdate(props) {
    const { to: to, from: from } = props = $27d73b36303119b6$export$b971039a739bf227(props);
    const keys = new Set();
    if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(to)) $27d73b36303119b6$var$findDefined(to, keys);
    if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(from)) $27d73b36303119b6$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $27d73b36303119b6$var$declareUpdate(props) {
    const update = $27d73b36303119b6$var$createUpdate(props);
    if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(update.default)) update.default = $27d73b36303119b6$var$getDefaultProps(update);
    return update;
}
function $27d73b36303119b6$var$findDefined(values, keys) {
    (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
const $27d73b36303119b6$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $27d73b36303119b6$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $27d73b36303119b6$var$getDefaultProp(props, type) ? $27d73b36303119b6$var$resolveProp(props[type], target.key) : undefined;
}
function $27d73b36303119b6$var$sendEvent(target, type, ...args) {
    var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;
    (_target$animation$typ = (_target$animation = target.animation)[type]) == null || _target$animation$typ.call(_target$animation, ...args);
    (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) == null || _target$defaultProps$.call(_target$defaultProps, ...args);
}
const $27d73b36303119b6$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
let $27d73b36303119b6$var$nextId = 1;
class $27d73b36303119b6$export$bd0bf19f25da8474 {
    get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    update(props) {
        if (props) this.queue.push($27d73b36303119b6$var$createUpdate(props));
        return this;
    }
    start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $590a6a92cd2ccef6$export$45b10814cc054894)(props).map($27d73b36303119b6$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $27d73b36303119b6$var$prepareKeys(this, queue);
        return $27d73b36303119b6$var$flushUpdateQueue(this, queue);
    }
    stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $590a6a92cd2ccef6$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $27d73b36303119b6$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    pause(keys) {
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $590a6a92cd2ccef6$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    resume(keys) {
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $590a6a92cd2ccef6$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    each(iterator) {
        (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $590a6a92cd2ccef6$export$4909b86c8034bf73)(onStart, ([onStart, result])=>{
                result.value = this.get();
                onStart(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $590a6a92cd2ccef6$export$4909b86c8034bf73)(onChange, ([onChange, result])=>{
            result.value = values;
            onChange(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $590a6a92cd2ccef6$export$4909b86c8034bf73)(onRest, ([onRest, result])=>{
                result.value = values;
                onRest(result, this, this._item);
            });
        }
    }
    eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
    constructor(props, flush){
        this.id = $27d73b36303119b6$var$nextId++;
        this.springs = {};
        this.queue = [];
        this.ref = void 0;
        this._flush = void 0;
        this._initialProps = void 0;
        this._lastAsyncId = 0;
        this._active = new Set();
        this._changed = new Set();
        this._started = false;
        this._item = void 0;
        this._state = {
            paused: false,
            pauseQueue: new Set(),
            resumeQueue: new Set(),
            timeouts: new Set()
        };
        this._events = {
            onStart: new Map(),
            onChange: new Map(),
            onRest: new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush) this._flush = flush;
        if (props) this.start($27d73b36303119b6$var$_extends({
            default: true
        }, props));
    }
}
function $27d73b36303119b6$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$27d73b36303119b6$var$flushUpdate(ctrl, props))).then((results)=>$27d73b36303119b6$var$getCombinedResult(ctrl, results));
}
async function $27d73b36303119b6$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(to) || (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(to) ? to : undefined;
    if (asyncTo) {
        props.to = undefined;
        props.onRest = undefined;
        if (defaults) defaults.onRest = undefined;
    } else (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)($27d73b36303119b6$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result = queue.get(handler);
                if (result) {
                    if (!finished) result.finished = false;
                    if (cancelled) result.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults) defaults[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $590a6a92cd2ccef6$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $27d73b36303119b6$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($27d73b36303119b6$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $590a6a92cd2ccef6$export$8793edee2d425525),
            resume: (0, $590a6a92cd2ccef6$export$8793edee2d425525),
            start (props, resolve) {
                if (cancel) {
                    $27d73b36303119b6$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($27d73b36303119b6$var$getCancelledResult(ctrl));
                } else {
                    props.onRest = onRest;
                    resolve($27d73b36303119b6$var$runAsync(asyncTo, props, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $27d73b36303119b6$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $27d73b36303119b6$var$createLoopUpdate(props, loop, to);
        if (nextProps) {
            $27d73b36303119b6$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $27d73b36303119b6$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $27d73b36303119b6$var$getSprings(ctrl, props) {
    const springs = $27d73b36303119b6$var$_extends({}, ctrl.springs);
    if (props) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $590a6a92cd2ccef6$export$45b10814cc054894)(props), (props)=>{
        if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props.keys)) props = $27d73b36303119b6$var$createUpdate(props);
        if (!(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(props.to)) props = $27d73b36303119b6$var$_extends({}, props, {
            to: undefined
        });
        $27d73b36303119b6$var$prepareSprings(springs, props, (key)=>{
            return $27d73b36303119b6$var$createSpring(key);
        });
    });
    $27d73b36303119b6$var$setSprings(ctrl, springs);
    return springs;
}
function $27d73b36303119b6$var$setSprings(ctrl, springs) {
    (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $590a6a92cd2ccef6$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $27d73b36303119b6$var$createSpring(key, observer) {
    const spring = new $27d73b36303119b6$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $590a6a92cd2ccef6$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $27d73b36303119b6$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $27d73b36303119b6$var$prepareKeys(ctrl, queue) {
    (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(queue, (props)=>{
        $27d73b36303119b6$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $27d73b36303119b6$var$createSpring(key, ctrl);
        });
    });
}
function $27d73b36303119b6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $27d73b36303119b6$var$_excluded$3 = [
    "children"
];
const $27d73b36303119b6$export$f12a216ec50d2cf1 = (_ref)=>{
    let { children: children } = _ref, props = $27d73b36303119b6$var$_objectWithoutPropertiesLoose(_ref, $27d73b36303119b6$var$_excluded$3);
    const inherited = (0, $7fPBF.useContext)($27d73b36303119b6$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $590a6a92cd2ccef6$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $27d73b36303119b6$var$ctx;
    return $7fPBF.createElement(Provider, {
        value: props
    }, children);
};
const $27d73b36303119b6$var$ctx = $27d73b36303119b6$var$makeContext($27d73b36303119b6$export$f12a216ec50d2cf1, {});
$27d73b36303119b6$export$f12a216ec50d2cf1.Provider = $27d73b36303119b6$var$ctx.Provider;
$27d73b36303119b6$export$f12a216ec50d2cf1.Consumer = $27d73b36303119b6$var$ctx.Consumer;
function $27d73b36303119b6$var$makeContext(target, init) {
    Object.assign(target, $7fPBF.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
const $27d73b36303119b6$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef = function SpringRef(props) {
        (0, $590a6a92cd2ccef6$export$d99d974913ad3b12)();
        const results = [];
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update = _getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.current = current;
    SpringRef.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef.pause = function() {
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef.resume = function() {
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef.set = function(values) {
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.set(values));
    };
    SpringRef.start = function(props) {
        const results = [];
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update = this._getProps(props, ctrl, i);
                if (update) results.push(ctrl.start(update));
            }
        });
        return results;
    };
    SpringRef.stop = function() {
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef.update = function(props) {
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function _getProps(arg, ctrl, index) {
        return (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef._getProps = _getProps;
    return SpringRef;
};
function $27d73b36303119b6$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $7fPBF.useMemo)(()=>propsFn || arguments.length == 3 ? $27d73b36303119b6$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $7fPBF.useRef)(0);
    const forceUpdate = (0, $590a6a92cd2ccef6$export$91db9bc4f8ac944a)();
    const state = (0, $7fPBF.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates) {
                const springs = $27d73b36303119b6$var$getSprings(ctrl, updates);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $27d73b36303119b6$var$flushUpdateQueue(ctrl, updates) : new Promise((resolve)=>{
                    $27d73b36303119b6$var$setSprings(ctrl, springs);
                    state.queue.push(()=>{
                        resolve($27d73b36303119b6$var$flushUpdateQueue(ctrl, updates));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $7fPBF.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $590a6a92cd2ccef6$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $7fPBF.useMemo)(()=>{
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $27d73b36303119b6$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $7fPBF.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $27d73b36303119b6$export$bd0bf19f25da8474(null, state.flush));
            const update = propsFn ? propsFn(i, ctrl) : props[i];
            if (update) updates[i] = $27d73b36303119b6$var$declareUpdate(update);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$27d73b36303119b6$var$getSprings(ctrl, updates[i]));
    const context = (0, $7fPBF.useContext)($27d73b36303119b6$export$f12a216ec50d2cf1);
    const prevContext = (0, $590a6a92cd2ccef6$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $27d73b36303119b6$var$hasProps(context);
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref == null || ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update = updates[i];
            if (update) {
                $27d73b36303119b6$var$replaceRef(ctrl, update.ref);
                if (ctrl.ref) ctrl.queue.push(update);
                else ctrl.start(update);
            }
        });
    });
    (0, $590a6a92cd2ccef6$export$392544347a18b6ea)(()=>()=>{
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>$27d73b36303119b6$var$_extends({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
function $27d73b36303119b6$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $27d73b36303119b6$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
const $27d73b36303119b6$var$initSpringRef = ()=>$27d73b36303119b6$export$2471ae76e2946684();
const $27d73b36303119b6$export$564bff9c23cad2ca = ()=>(0, $7fPBF.useState)($27d73b36303119b6$var$initSpringRef)[0];
function $27d73b36303119b6$export$250279104b4672ed(length, propsArg, deps) {
    var _passedRef;
    const propsFn = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = undefined;
    const result = $27d73b36303119b6$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, deps || [
        {}
    ]);
    const ref = (_passedRef = passedRef) != null ? _passedRef : result[1];
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(ref.current, (ctrl, i)=>{
            const parent = ref.current[i + (reverse ? 1 : -1)];
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        ref["_getProps"] = (propsArg, ctrl, i)=>{
            const props = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    ref["start"] = (propsArg)=>{
        const results = [];
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(ref.current, (ctrl, i)=>{
            const props = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(propsArg) ? propsArg(i, ctrl) : propsArg;
            const parent = ref.current[i + (reverse ? 1 : -1)];
            if (parent) results.push(ctrl.start($27d73b36303119b6$var$_extends({}, props, {
                to: parent.springs
            })));
            else results.push(ctrl.start($27d73b36303119b6$var$_extends({}, props)));
        });
        return results;
    };
    return result[0];
}
let $27d73b36303119b6$var$TransitionPhase;
(function(TransitionPhase) {
    TransitionPhase["MOUNT"] = "mount";
    TransitionPhase["ENTER"] = "enter";
    TransitionPhase["UPDATE"] = "update";
    TransitionPhase["LEAVE"] = "leave";
})($27d73b36303119b6$var$TransitionPhase || ($27d73b36303119b6$var$TransitionPhase = {}));
function $27d73b36303119b6$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $7fPBF.useMemo)(()=>propsFn || arguments.length == 3 ? $27d73b36303119b6$export$2471ae76e2946684() : void 0, []);
    const items = (0, $590a6a92cd2ccef6$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $7fPBF.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $590a6a92cd2ccef6$export$392544347a18b6ea)(()=>{
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
            var _t$ctrl$ref;
            (_t$ctrl$ref = t.ctrl.ref) == null || _t$ctrl$ref.add(t.ctrl);
            const change = changes.get(t);
            if (change) t.ctrl.start(change.payload);
        });
        return ()=>{
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $27d73b36303119b6$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $27d73b36303119b6$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>(0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $27d73b36303119b6$var$detachRefs(ctrl, ref);
            $27d73b36303119b6$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: $27d73b36303119b6$var$TransitionPhase.MOUNT,
                ctrl: new $27d73b36303119b6$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = $27d73b36303119b6$var$_extends({}, t, {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $590a6a92cd2ccef6$export$91db9bc4f8ac944a)();
    const defaultProps = $27d73b36303119b6$var$getDefaultProps(props);
    const changes = new Map();
    const exitingTransitions = (0, $7fPBF.useRef)(new Map());
    const forceChange = (0, $7fPBF.useRef)(false);
    (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to;
        let phase;
        let propsDelay = $27d73b36303119b6$var$callProp(p.delay || 0, key);
        if (prevPhase == $27d73b36303119b6$var$TransitionPhase.MOUNT) {
            to = p.enter;
            phase = $27d73b36303119b6$var$TransitionPhase.ENTER;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != $27d73b36303119b6$var$TransitionPhase.LEAVE) {
                if (isLeave) {
                    to = p.leave;
                    phase = $27d73b36303119b6$var$TransitionPhase.LEAVE;
                } else if (to = p.update) phase = $27d73b36303119b6$var$TransitionPhase.UPDATE;
                else return;
            } else if (!isLeave) {
                to = p.enter;
                phase = $27d73b36303119b6$var$TransitionPhase.ENTER;
            } else return;
        }
        to = $27d73b36303119b6$var$callProp(to, t.item, i);
        to = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).obj(to) ? $27d73b36303119b6$export$b971039a739bf227(to) : {
            to: to
        };
        if (!to.config) {
            const config = propsConfig || defaultProps.config;
            to.config = $27d73b36303119b6$var$callProp(config, t.item, i, phase);
        }
        delay += trail;
        const payload = $27d73b36303119b6$var$_extends({}, defaultProps, {
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            reset: false
        }, to);
        if (phase == $27d73b36303119b6$var$TransitionPhase.ENTER && (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(payload.from)) {
            const _p = propsFn ? propsFn() : props;
            const from = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(_p.initial) || prevTransitions ? _p.from : _p.initial;
            payload.from = $27d73b36303119b6$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $27d73b36303119b6$var$callProp(onResolve, result);
            const transitions = usedTransitions.current;
            const t = transitions.find((t)=>t.key === key);
            if (!t) return;
            if (result.cancelled && t.phase != $27d73b36303119b6$var$TransitionPhase.UPDATE) return;
            if (t.ctrl.idle) {
                const idle = transitions.every((t)=>t.ctrl.idle);
                if (t.phase == $27d73b36303119b6$var$TransitionPhase.LEAVE) {
                    const expiry = $27d73b36303119b6$var$callProp(expires, t.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions.some((t)=>t.expired)) {
                    exitingTransitions.current.delete(t);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $27d73b36303119b6$var$getSprings(t.ctrl, payload);
        if (phase === $27d73b36303119b6$var$TransitionPhase.LEAVE && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $7fPBF.useContext)($27d73b36303119b6$export$f12a216ec50d2cf1);
    const prevContext = (0, $590a6a92cd2ccef6$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $27d73b36303119b6$var$hasProps(context);
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
        if (hasContext) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $590a6a92cd2ccef6$export$e5c5a5f917a5871c)(()=>{
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref == null || ref.add(ctrl);
            if (hasContext && phase == $27d73b36303119b6$var$TransitionPhase.ENTER) ctrl.start({
                default: context
            });
            if (payload) {
                $27d73b36303119b6$var$replaceRef(ctrl, payload.ref);
                if (ctrl.ref && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>$7fPBF.createElement($7fPBF.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render($27d73b36303119b6$var$_extends({}, springs), t.item, t, i);
            return elem && elem.type ? $7fPBF.createElement(elem.type, $27d73b36303119b6$var$_extends({}, elem.props, {
                key: (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).str(t.key) || (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
let $27d73b36303119b6$var$nextKey = 1;
function $27d73b36303119b6$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t)=>t.item === item && t.phase !== $27d73b36303119b6$var$TransitionPhase.LEAVE && !reused.has(t));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $27d73b36303119b6$var$nextKey++;
        });
    }
    return (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(keys) ? items : (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $590a6a92cd2ccef6$export$45b10814cc054894)(keys);
}
const $27d73b36303119b6$var$_excluded$2 = [
    "children"
];
function $27d73b36303119b6$export$a500e5b516cedfc(_ref) {
    let { children: children } = _ref, props = $27d73b36303119b6$var$_objectWithoutPropertiesLoose(_ref, $27d73b36303119b6$var$_excluded$2);
    return children($27d73b36303119b6$export$c4af9125706c4d30(props));
}
const $27d73b36303119b6$var$_excluded$1 = [
    "items",
    "children"
];
function $27d73b36303119b6$export$3b8b9d47fbf8fd2b(_ref) {
    let { items: items, children: children } = _ref, props = $27d73b36303119b6$var$_objectWithoutPropertiesLoose(_ref, $27d73b36303119b6$var$_excluded$1);
    const trails = $27d73b36303119b6$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
const $27d73b36303119b6$var$_excluded = [
    "items",
    "children"
];
function $27d73b36303119b6$export$be58926105124dd4(_ref) {
    let { items: items, children: children } = _ref, props = $27d73b36303119b6$var$_objectWithoutPropertiesLoose(_ref, $27d73b36303119b6$var$_excluded);
    return $27d73b36303119b6$export$7b286972b8d8ccbf(items, props)(children);
}
class $27d73b36303119b6$export$b0cc4f9860136880 extends $27d73b36303119b6$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $590a6a92cd2ccef6$export$248d38f6296296c5)(value, oldValue)) {
            (0, $5695012d6ed98c47$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $27d73b36303119b6$var$checkIdle(this._active)) $27d73b36303119b6$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $590a6a92cd2ccef6$export$e37b7520edd66839)) : (0, $590a6a92cd2ccef6$export$45b10814cc054894)((0, $590a6a92cd2ccef6$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$27d73b36303119b6$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $5695012d6ed98c47$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).skipAnimation) {
                (0, $27c38ae2c9666902$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $27d73b36303119b6$var$becomeIdle(this);
            } else (0, $590a6a92cd2ccef6$export$a57f5080a3bcc90a).start(this);
        }
    }
    _attach() {
        let priority = 1;
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $590a6a92cd2ccef6$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(source)) (0, $590a6a92cd2ccef6$export$72d604e3f8d000a5)(source, this);
            if ($27d73b36303119b6$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    _detach() {
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $590a6a92cd2ccef6$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(source)) (0, $590a6a92cd2ccef6$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $27d73b36303119b6$var$becomeIdle(this);
    }
    eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $590a6a92cd2ccef6$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($27d73b36303119b6$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.key = void 0;
        this.idle = true;
        this.calc = void 0;
        this._active = new Set();
        this.source = source;
        this.calc = (0, $590a6a92cd2ccef6$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $5695012d6ed98c47$export$e6b77ddbe47b132e)(value);
        (0, $5695012d6ed98c47$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
}
function $27d73b36303119b6$var$isIdle(source) {
    return source.idle !== false;
}
function $27d73b36303119b6$var$checkIdle(active) {
    return !active.size || Array.from(active).every($27d73b36303119b6$var$isIdle);
}
function $27d73b36303119b6$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)((0, $5695012d6ed98c47$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $590a6a92cd2ccef6$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
const $27d73b36303119b6$export$2c618a4308a30424 = (source, ...args)=>new $27d73b36303119b6$export$b0cc4f9860136880(source, args);
const $27d73b36303119b6$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $590a6a92cd2ccef6$export$2abfcde8ae218ba8)(), new $27d73b36303119b6$export$b0cc4f9860136880(source, args));
(0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $590a6a92cd2ccef6$export$4759a013d387347a,
    to: (source, args)=>new $27d73b36303119b6$export$b0cc4f9860136880(source, args)
});
const $27d73b36303119b6$export$722fbec263ad908a = (0, $590a6a92cd2ccef6$export$a57f5080a3bcc90a).advance;



var $fw0lo = parcelRequire("fw0lo");


function $8b3e789bcbac6fcf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $8b3e789bcbac6fcf$var$_excluded$2 = [
    "style",
    "children",
    "scrollTop",
    "scrollLeft"
];
const $8b3e789bcbac6fcf$var$isCustomPropRE = /^--/;
function $8b3e789bcbac6fcf$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$8b3e789bcbac6fcf$var$isCustomPropRE.test(name) && !($8b3e789bcbac6fcf$var$isUnitlessNumber.hasOwnProperty(name) && $8b3e789bcbac6fcf$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
const $8b3e789bcbac6fcf$var$attributeCache = {};
function $8b3e789bcbac6fcf$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const _ref = props, { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft } = _ref, attributes = $8b3e789bcbac6fcf$var$_objectWithoutPropertiesLoose(_ref, $8b3e789bcbac6fcf$var$_excluded$2);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $8b3e789bcbac6fcf$var$attributeCache[name] || ($8b3e789bcbac6fcf$var$attributeCache[name] = name.replace(/([A-Z])/g, (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(let name in style)if (style.hasOwnProperty(name)) {
        const value = $8b3e789bcbac6fcf$var$dangerousStyleValue(name, style[name]);
        if ($8b3e789bcbac6fcf$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
}
let $8b3e789bcbac6fcf$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
const $8b3e789bcbac6fcf$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
const $8b3e789bcbac6fcf$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$8b3e789bcbac6fcf$var$isUnitlessNumber = Object.keys($8b3e789bcbac6fcf$var$isUnitlessNumber).reduce((acc, prop)=>{
    $8b3e789bcbac6fcf$var$prefixes.forEach((prefix)=>acc[$8b3e789bcbac6fcf$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $8b3e789bcbac6fcf$var$isUnitlessNumber);
const $8b3e789bcbac6fcf$var$_excluded$1 = [
    "x",
    "y",
    "z"
];
const $8b3e789bcbac6fcf$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const $8b3e789bcbac6fcf$var$pxTransforms = /^(translate)/;
const $8b3e789bcbac6fcf$var$degTransforms = /^(rotate|skew)/;
const $8b3e789bcbac6fcf$var$addUnit = (value, unit)=>(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
const $8b3e789bcbac6fcf$var$isValueIdentity = (value, id)=>(0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$8b3e789bcbac6fcf$var$isValueIdentity(v, id)) : (0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
class $8b3e789bcbac6fcf$var$AnimatedStyle extends (0, $5695012d6ed98c47$export$f1b0b9e366a6e2d4) {
    constructor(_ref){
        let { x: x, y: y, z: z } = _ref, style = $8b3e789bcbac6fcf$var$_objectWithoutPropertiesLoose(_ref, $8b3e789bcbac6fcf$var$_excluded$1);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$8b3e789bcbac6fcf$var$addUnit(v, "px")).join(",")})`,
                    $8b3e789bcbac6fcf$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $590a6a92cd2ccef6$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($8b3e789bcbac6fcf$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $8b3e789bcbac6fcf$var$pxTransforms.test(key) ? "px" : $8b3e789bcbac6fcf$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $590a6a92cd2ccef6$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x, y, z, deg])=>[
                        `rotate3d(${x},${y},${z},${$8b3e789bcbac6fcf$var$addUnit(deg, unit)})`,
                        $8b3e789bcbac6fcf$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$8b3e789bcbac6fcf$var$addUnit(v, unit)).join(",")})`,
                        $8b3e789bcbac6fcf$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $8b3e789bcbac6fcf$var$FluidTransform(inputs, transforms);
        super(style);
    }
}
class $8b3e789bcbac6fcf$var$FluidTransform extends (0, $590a6a92cd2ccef6$export$aff8e1ac1a016a2) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $590a6a92cd2ccef6$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $590a6a92cd2ccef6$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $590a6a92cd2ccef6$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    observerAdded(count) {
        if (count == 1) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(input, (value)=>(0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(value) && (0, $590a6a92cd2ccef6$export$72d604e3f8d000a5)(value, this)));
    }
    observerRemoved(count) {
        if (count == 0) (0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $590a6a92cd2ccef6$export$79b2f7037acddd43)(input, (value)=>(0, $590a6a92cd2ccef6$export$57ea7e3a7f6280c7)(value) && (0, $590a6a92cd2ccef6$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $590a6a92cd2ccef6$export$31752c40a5fab62a)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this._value = null;
        this.inputs = inputs;
        this.transforms = transforms;
    }
}
const $8b3e789bcbac6fcf$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
const $8b3e789bcbac6fcf$var$_excluded = [
    "scrollTop",
    "scrollLeft"
];
(0, $590a6a92cd2ccef6$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $fw0lo.unstable_batchedUpdates),
    createStringInterpolator: $590a6a92cd2ccef6$export$4759a013d387347a,
    colors: $590a6a92cd2ccef6$export$8f45430ccf837300
});
const $8b3e789bcbac6fcf$var$host = (0, $5695012d6ed98c47$export$4ee5c78f6dcbcef)($8b3e789bcbac6fcf$var$primitives, {
    applyAnimatedValues: $8b3e789bcbac6fcf$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $8b3e789bcbac6fcf$var$AnimatedStyle(style),
    getComponentProps: (_ref)=>{
        let props = $8b3e789bcbac6fcf$var$_objectWithoutPropertiesLoose(_ref, $8b3e789bcbac6fcf$var$_excluded);
        return props;
    }
});
const $8b3e789bcbac6fcf$export$407448d2b89b1813 = $8b3e789bcbac6fcf$var$host.animated;




function $c39e9a0d065c63c9$var$v() {
    return $c39e9a0d065c63c9$var$v = Object.assign || function(t) {
        for(var i = 1; i < arguments.length; i++){
            var o = arguments[i];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
        }
        return t;
    }, $c39e9a0d065c63c9$var$v.apply(this, arguments);
}
var $c39e9a0d065c63c9$var$x = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
}, $c39e9a0d065c63c9$var$m = function(t, i) {
    return "translate(" + t + "px, " + i + "px)";
}, $c39e9a0d065c63c9$export$57a09c4864b20b90 = (0, $7fPBF.memo)(function(t) {
    var o, n = t.position, r = t.anchor, e = t.children, l = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), u = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), p = u.animate, f = u.config, g = (0, $0332e848e6fa2251$export$e295b0c537d32d7d)(), b = g[0], w = g[1], T = (0, $7fPBF.useRef)(!1), C = void 0, E = !1, P = w.width > 0 && w.height > 0, N = Math.round(n[0]), V = Math.round(n[1]);
    P && ("top" === r ? (N -= w.width / 2, V -= w.height + 14) : "right" === r ? (N += 14, V -= w.height / 2) : "bottom" === r ? (N -= w.width / 2, V += 14) : "left" === r ? (N -= w.width + 14, V -= w.height / 2) : "center" === r && (N -= w.width / 2, V -= w.height / 2), C = {
        transform: $c39e9a0d065c63c9$var$m(N, V)
    }, T.current || (E = !0), T.current = [
        N,
        V
    ]);
    var j = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        to: C,
        config: f,
        immediate: !p || E
    }), O = $c39e9a0d065c63c9$var$v({}, $c39e9a0d065c63c9$var$x, l.tooltip, {
        transform: null != (o = j.transform) ? o : $c39e9a0d065c63c9$var$m(N, V)
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).div, {
        ref: b,
        style: O,
        children: e
    });
});
$c39e9a0d065c63c9$export$57a09c4864b20b90.displayName = "TooltipWrapper";
var $c39e9a0d065c63c9$export$5a7f9a6004988d01 = (0, $7fPBF.memo)(function(t) {
    var i = t.size, o = void 0 === i ? 12 : i, n = t.color, r = t.style;
    return (0, $824c049f32d4395d$exports.jsx)("span", {
        style: $c39e9a0d065c63c9$var$v({
            display: "block",
            width: o,
            height: o,
            background: n
        }, void 0 === r ? {} : r)
    });
}), $c39e9a0d065c63c9$export$d5f52d71198e271a = (0, $7fPBF.memo)(function(t) {
    var i, o = t.id, n = t.value, r = t.format, e = t.enableChip, l = void 0 !== e && e, a = t.color, c = t.renderContent, s = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), d = (0, $0332e848e6fa2251$export$422f9765e6971fdf)(r);
    if ("function" == typeof c) i = c();
    else {
        var f = n;
        void 0 !== d && void 0 !== f && (f = d(f)), i = (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: s.tooltip.basic,
            children: [
                l && (0, $824c049f32d4395d$exports.jsx)($c39e9a0d065c63c9$export$5a7f9a6004988d01, {
                    color: a,
                    style: s.tooltip.chip
                }),
                void 0 !== f ? (0, $824c049f32d4395d$exports.jsxs)("span", {
                    children: [
                        o,
                        ": ",
                        (0, $824c049f32d4395d$exports.jsx)("strong", {
                            children: "" + f
                        })
                    ]
                }) : o
            ]
        });
    }
    return (0, $824c049f32d4395d$exports.jsx)("div", {
        style: s.tooltip.container,
        children: i
    });
}), $c39e9a0d065c63c9$var$T = {
    width: "100%",
    borderCollapse: "collapse"
}, $c39e9a0d065c63c9$export$4b779126465c60ce = (0, $7fPBF.memo)(function(t) {
    var i, o = t.title, n = t.rows, r = void 0 === n ? [] : n, e = t.renderContent, l = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    return r.length ? (i = "function" == typeof e ? e() : (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            o && o,
            (0, $824c049f32d4395d$exports.jsx)("table", {
                style: $c39e9a0d065c63c9$var$v({}, $c39e9a0d065c63c9$var$T, l.tooltip.table),
                children: (0, $824c049f32d4395d$exports.jsx)("tbody", {
                    children: r.map(function(t, i) {
                        return (0, $824c049f32d4395d$exports.jsx)("tr", {
                            children: t.map(function(t, i) {
                                return (0, $824c049f32d4395d$exports.jsx)("td", {
                                    style: l.tooltip.tableCell,
                                    children: t
                                }, i);
                            })
                        }, i);
                    })
                })
            })
        ]
    }), (0, $824c049f32d4395d$exports.jsx)("div", {
        style: l.tooltip.container,
        children: i
    })) : null;
});
$c39e9a0d065c63c9$export$4b779126465c60ce.displayName = "TableTooltip";
var $c39e9a0d065c63c9$var$E = (0, $7fPBF.memo)(function(t) {
    var i = t.x0, n = t.x1, r = t.y0, e = t.y1, l = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), d = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), u = d.animate, p = d.config, f = (0, $7fPBF.useMemo)(function() {
        return $c39e9a0d065c63c9$var$v({}, l.crosshair.line, {
            pointerEvents: "none"
        });
    }, [
        l.crosshair.line
    ]), x = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x1: i,
        x2: n,
        y1: r,
        y2: e,
        config: p,
        immediate: !u
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).line, $c39e9a0d065c63c9$var$v({}, x, {
        fill: "none",
        style: f
    }));
});
$c39e9a0d065c63c9$var$E.displayName = "CrosshairLine";
var $c39e9a0d065c63c9$export$2a195a185c8aa9e = (0, $7fPBF.memo)(function(t) {
    var i, o, n = t.width, r = t.height, e = t.type, l = t.x, a = t.y;
    return "cross" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    }, o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }) : "top-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "top" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    } : "top-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "right" === e ? o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    } : "bottom-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "bottom" === e ? i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    } : "bottom-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "left" === e ? o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    } : "x" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    } : "y" === e && (o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }), (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            i && (0, $824c049f32d4395d$exports.jsx)($c39e9a0d065c63c9$var$E, {
                x0: i.x0,
                x1: i.x1,
                y0: i.y0,
                y1: i.y1
            }),
            o && (0, $824c049f32d4395d$exports.jsx)($c39e9a0d065c63c9$var$E, {
                x0: o.x0,
                x1: o.x1,
                y0: o.y0,
                y1: o.y1
            })
        ]
    });
});
$c39e9a0d065c63c9$export$2a195a185c8aa9e.displayName = "Crosshair";
var $c39e9a0d065c63c9$export$d344f0e974db1e2e = (0, $7fPBF.createContext)({
    showTooltipAt: function() {},
    showTooltipFromEvent: function() {},
    hideTooltip: function() {}
}), $c39e9a0d065c63c9$export$3a517200cf5bfc1b = {
    isVisible: !1,
    position: [
        null,
        null
    ],
    content: null,
    anchor: null
}, $c39e9a0d065c63c9$export$c7027a64d546bf1d = (0, $7fPBF.createContext)($c39e9a0d065c63c9$export$3a517200cf5bfc1b), $c39e9a0d065c63c9$export$85cc26a2c4544aaa = function(t) {
    var i = (0, $7fPBF.useState)($c39e9a0d065c63c9$export$3a517200cf5bfc1b), n = i[0], l = i[1], a = (0, $7fPBF.useCallback)(function(t, i, o) {
        var n = i[0], r = i[1];
        void 0 === o && (o = "top"), l({
            isVisible: !0,
            position: [
                n,
                r
            ],
            anchor: o,
            content: t
        });
    }, [
        l
    ]), c = (0, $7fPBF.useCallback)(function(i, o, n) {
        void 0 === n && (n = "top");
        var r = t.current.getBoundingClientRect(), e = t.current.offsetWidth, a = e === r.width ? 1 : e / r.width, c = (o.clientX - r.left) * a, h = (o.clientY - r.top) * a;
        "left" !== n && "right" !== n || (n = c < r.width / 2 ? "right" : "left"), l({
            isVisible: !0,
            position: [
                c,
                h
            ],
            anchor: n,
            content: i
        });
    }, [
        t,
        l
    ]), h = (0, $7fPBF.useCallback)(function() {
        l($c39e9a0d065c63c9$export$3a517200cf5bfc1b);
    }, [
        l
    ]);
    return {
        actions: (0, $7fPBF.useMemo)(function() {
            return {
                showTooltipAt: a,
                showTooltipFromEvent: c,
                hideTooltip: h
            };
        }, [
            a,
            c,
            h
        ]),
        state: n
    };
}, $c39e9a0d065c63c9$export$1c4b08e0eca38426 = function() {
    var t = (0, $7fPBF.useContext)($c39e9a0d065c63c9$export$d344f0e974db1e2e);
    if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
    return t;
}, $c39e9a0d065c63c9$export$b6b30c61d706ffee = function() {
    var t = (0, $7fPBF.useContext)($c39e9a0d065c63c9$export$c7027a64d546bf1d);
    if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
    return t;
}, $c39e9a0d065c63c9$export$dd4f39ed288d94c9 = function(t) {
    return t.isVisible;
}, $c39e9a0d065c63c9$export$28c660c63b792dea = function() {
    var t = $c39e9a0d065c63c9$export$b6b30c61d706ffee();
    return $c39e9a0d065c63c9$export$dd4f39ed288d94c9(t) ? (0, $824c049f32d4395d$exports.jsx)($c39e9a0d065c63c9$export$57a09c4864b20b90, {
        position: t.position,
        anchor: t.anchor,
        children: t.content
    }) : null;
}, $c39e9a0d065c63c9$export$f78649fb9ca566b8 = function(t) {
    var i = t.container, o = t.children, n = $c39e9a0d065c63c9$export$85cc26a2c4544aaa(i), r = n.actions, e = n.state;
    return (0, $824c049f32d4395d$exports.jsx)($c39e9a0d065c63c9$export$d344f0e974db1e2e.Provider, {
        value: r,
        children: (0, $824c049f32d4395d$exports.jsx)($c39e9a0d065c63c9$export$c7027a64d546bf1d.Provider, {
            value: e,
            children: o
        })
    });
};


var $357f6a405ce5423a$exports = {};
var $11770314f73a602c$exports = {};
var $75b9f8e835026959$exports = {};
var $d3ce36181053a891$exports = {};
var $b3532018e1ff9eab$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b3532018e1ff9eab$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$b3532018e1ff9eab$exports = $b3532018e1ff9eab$var$listCacheClear;


var $0c46ef5003b13e31$exports = {};
var $38429cb5a86e691c$exports = {};
var $881bebc960934ade$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $881bebc960934ade$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$881bebc960934ade$exports = $881bebc960934ade$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $38429cb5a86e691c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($881bebc960934ade$exports(array[length][0], key)) return length;
    }
    return -1;
}
$38429cb5a86e691c$exports = $38429cb5a86e691c$var$assocIndexOf;


/** Used for built-in method references. */ var $0c46ef5003b13e31$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $0c46ef5003b13e31$var$splice = $0c46ef5003b13e31$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0c46ef5003b13e31$var$listCacheDelete(key) {
    var data = this.__data__, index = $38429cb5a86e691c$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $0c46ef5003b13e31$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$0c46ef5003b13e31$exports = $0c46ef5003b13e31$var$listCacheDelete;


var $e1040571ebb469f5$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1040571ebb469f5$var$listCacheGet(key) {
    var data = this.__data__, index = $38429cb5a86e691c$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e1040571ebb469f5$exports = $e1040571ebb469f5$var$listCacheGet;


var $7021072296e166d7$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7021072296e166d7$var$listCacheHas(key) {
    return $38429cb5a86e691c$exports(this.__data__, key) > -1;
}
$7021072296e166d7$exports = $7021072296e166d7$var$listCacheHas;


var $c0f6fe3ec712f3b3$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $c0f6fe3ec712f3b3$var$listCacheSet(key, value) {
    var data = this.__data__, index = $38429cb5a86e691c$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$c0f6fe3ec712f3b3$exports = $c0f6fe3ec712f3b3$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d3ce36181053a891$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d3ce36181053a891$var$ListCache.prototype.clear = $b3532018e1ff9eab$exports;
$d3ce36181053a891$var$ListCache.prototype["delete"] = $0c46ef5003b13e31$exports;
$d3ce36181053a891$var$ListCache.prototype.get = $e1040571ebb469f5$exports;
$d3ce36181053a891$var$ListCache.prototype.has = $7021072296e166d7$exports;
$d3ce36181053a891$var$ListCache.prototype.set = $c0f6fe3ec712f3b3$exports;
$d3ce36181053a891$exports = $d3ce36181053a891$var$ListCache;


var $a7beb0ce4fa4126e$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a7beb0ce4fa4126e$var$stackClear() {
    this.__data__ = new $d3ce36181053a891$exports;
    this.size = 0;
}
$a7beb0ce4fa4126e$exports = $a7beb0ce4fa4126e$var$stackClear;


var $0766dee8ae28686e$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0766dee8ae28686e$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$0766dee8ae28686e$exports = $0766dee8ae28686e$var$stackDelete;


var $e9cab4f83b8cf2e9$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e9cab4f83b8cf2e9$var$stackGet(key) {
    return this.__data__.get(key);
}
$e9cab4f83b8cf2e9$exports = $e9cab4f83b8cf2e9$var$stackGet;


var $37e4c239050b91e3$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $37e4c239050b91e3$var$stackHas(key) {
    return this.__data__.has(key);
}
$37e4c239050b91e3$exports = $37e4c239050b91e3$var$stackHas;


var $f707f5e6173bece0$exports = {};

var $3b45073a9f2f1273$exports = {};
var $95eb055fdd27d869$exports = {};
var $b8bc552383eab615$exports = {};
var $07bc7c115e963817$exports = {};


/** `Object#toString` result references. */ var $07bc7c115e963817$var$asyncTag = "[object AsyncFunction]", $07bc7c115e963817$var$funcTag = "[object Function]", $07bc7c115e963817$var$genTag = "[object GeneratorFunction]", $07bc7c115e963817$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $07bc7c115e963817$var$isFunction(value) {
    if (!$f328ff7ee4fde81a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $ae3fe6c5950c122e$exports(value);
    return tag == $07bc7c115e963817$var$funcTag || tag == $07bc7c115e963817$var$genTag || tag == $07bc7c115e963817$var$asyncTag || tag == $07bc7c115e963817$var$proxyTag;
}
$07bc7c115e963817$exports = $07bc7c115e963817$var$isFunction;


var $e9fd1b1d57dc1cf8$exports = {};
var $1822c948e6f3062a$exports = {};

var $1DySm = parcelRequire("1DySm");
/** Used to detect overreaching core-js shims. */ var $1822c948e6f3062a$var$coreJsData = $1DySm["__core-js_shared__"];
$1822c948e6f3062a$exports = $1822c948e6f3062a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $e9fd1b1d57dc1cf8$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1822c948e6f3062a$exports && $1822c948e6f3062a$exports.keys && $1822c948e6f3062a$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e9fd1b1d57dc1cf8$var$isMasked(func) {
    return !!$e9fd1b1d57dc1cf8$var$maskSrcKey && $e9fd1b1d57dc1cf8$var$maskSrcKey in func;
}
$e9fd1b1d57dc1cf8$exports = $e9fd1b1d57dc1cf8$var$isMasked;



var $f4933d7f0a06eb7d$exports = {};
/** Used for built-in method references. */ var $f4933d7f0a06eb7d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $f4933d7f0a06eb7d$var$funcToString = $f4933d7f0a06eb7d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $f4933d7f0a06eb7d$var$toSource(func) {
    if (func != null) {
        try {
            return $f4933d7f0a06eb7d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$f4933d7f0a06eb7d$exports = $f4933d7f0a06eb7d$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b8bc552383eab615$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b8bc552383eab615$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $b8bc552383eab615$var$funcProto = Function.prototype, $b8bc552383eab615$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b8bc552383eab615$var$funcToString = $b8bc552383eab615$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b8bc552383eab615$var$hasOwnProperty = $b8bc552383eab615$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $b8bc552383eab615$var$reIsNative = RegExp("^" + $b8bc552383eab615$var$funcToString.call($b8bc552383eab615$var$hasOwnProperty).replace($b8bc552383eab615$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b8bc552383eab615$var$baseIsNative(value) {
    if (!$f328ff7ee4fde81a$exports(value) || $e9fd1b1d57dc1cf8$exports(value)) return false;
    var pattern = $07bc7c115e963817$exports(value) ? $b8bc552383eab615$var$reIsNative : $b8bc552383eab615$var$reIsHostCtor;
    return pattern.test($f4933d7f0a06eb7d$exports(value));
}
$b8bc552383eab615$exports = $b8bc552383eab615$var$baseIsNative;


var $0f77ce8dc1867245$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $0f77ce8dc1867245$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$0f77ce8dc1867245$exports = $0f77ce8dc1867245$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $95eb055fdd27d869$var$getNative(object, key) {
    var value = $0f77ce8dc1867245$exports(object, key);
    return $b8bc552383eab615$exports(value) ? value : undefined;
}
$95eb055fdd27d869$exports = $95eb055fdd27d869$var$getNative;



var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $3b45073a9f2f1273$var$Map = $95eb055fdd27d869$exports($1DySm, "Map");
$3b45073a9f2f1273$exports = $3b45073a9f2f1273$var$Map;


var $a6cc38418910b2e0$exports = {};
var $640327eb3d1069cf$exports = {};
var $3e17215e62373b7a$exports = {};
var $c25654624248087e$exports = {};
var $84cf21ec84c19391$exports = {};

/* Built-in method references that are verified to be native. */ var $84cf21ec84c19391$var$nativeCreate = $95eb055fdd27d869$exports(Object, "create");
$84cf21ec84c19391$exports = $84cf21ec84c19391$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c25654624248087e$var$hashClear() {
    this.__data__ = $84cf21ec84c19391$exports ? $84cf21ec84c19391$exports(null) : {};
    this.size = 0;
}
$c25654624248087e$exports = $c25654624248087e$var$hashClear;


var $9b031a80da354f86$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9b031a80da354f86$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$9b031a80da354f86$exports = $9b031a80da354f86$var$hashDelete;


var $bb2415c9bb53848d$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $bb2415c9bb53848d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $bb2415c9bb53848d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bb2415c9bb53848d$var$hasOwnProperty = $bb2415c9bb53848d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $bb2415c9bb53848d$var$hashGet(key) {
    var data = this.__data__;
    if ($84cf21ec84c19391$exports) {
        var result = data[key];
        return result === $bb2415c9bb53848d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $bb2415c9bb53848d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$bb2415c9bb53848d$exports = $bb2415c9bb53848d$var$hashGet;


var $057fe85caf4b041d$exports = {};

/** Used for built-in method references. */ var $057fe85caf4b041d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $057fe85caf4b041d$var$hasOwnProperty = $057fe85caf4b041d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $057fe85caf4b041d$var$hashHas(key) {
    var data = this.__data__;
    return $84cf21ec84c19391$exports ? data[key] !== undefined : $057fe85caf4b041d$var$hasOwnProperty.call(data, key);
}
$057fe85caf4b041d$exports = $057fe85caf4b041d$var$hashHas;


var $83a7ac52366bc66e$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $83a7ac52366bc66e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $83a7ac52366bc66e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $84cf21ec84c19391$exports && value === undefined ? $83a7ac52366bc66e$var$HASH_UNDEFINED : value;
    return this;
}
$83a7ac52366bc66e$exports = $83a7ac52366bc66e$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3e17215e62373b7a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$3e17215e62373b7a$var$Hash.prototype.clear = $c25654624248087e$exports;
$3e17215e62373b7a$var$Hash.prototype["delete"] = $9b031a80da354f86$exports;
$3e17215e62373b7a$var$Hash.prototype.get = $bb2415c9bb53848d$exports;
$3e17215e62373b7a$var$Hash.prototype.has = $057fe85caf4b041d$exports;
$3e17215e62373b7a$var$Hash.prototype.set = $83a7ac52366bc66e$exports;
$3e17215e62373b7a$exports = $3e17215e62373b7a$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $640327eb3d1069cf$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $3e17215e62373b7a$exports,
        "map": new ($3b45073a9f2f1273$exports || $d3ce36181053a891$exports),
        "string": new $3e17215e62373b7a$exports
    };
}
$640327eb3d1069cf$exports = $640327eb3d1069cf$var$mapCacheClear;


var $575eb14ab2b31b03$exports = {};
var $e7e2cfab823d50ee$exports = {};
var $66c884747b0ddd4d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $66c884747b0ddd4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$66c884747b0ddd4d$exports = $66c884747b0ddd4d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e7e2cfab823d50ee$var$getMapData(map, key) {
    var data = map.__data__;
    return $66c884747b0ddd4d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$e7e2cfab823d50ee$exports = $e7e2cfab823d50ee$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $575eb14ab2b31b03$var$mapCacheDelete(key) {
    var result = $e7e2cfab823d50ee$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$575eb14ab2b31b03$exports = $575eb14ab2b31b03$var$mapCacheDelete;


var $2fe6cdb7e5c793dc$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2fe6cdb7e5c793dc$var$mapCacheGet(key) {
    return $e7e2cfab823d50ee$exports(this, key).get(key);
}
$2fe6cdb7e5c793dc$exports = $2fe6cdb7e5c793dc$var$mapCacheGet;


var $22b760cf30a31377$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $22b760cf30a31377$var$mapCacheHas(key) {
    return $e7e2cfab823d50ee$exports(this, key).has(key);
}
$22b760cf30a31377$exports = $22b760cf30a31377$var$mapCacheHas;


var $b39e430f93ec17f8$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b39e430f93ec17f8$var$mapCacheSet(key, value) {
    var data = $e7e2cfab823d50ee$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$b39e430f93ec17f8$exports = $b39e430f93ec17f8$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a6cc38418910b2e0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a6cc38418910b2e0$var$MapCache.prototype.clear = $640327eb3d1069cf$exports;
$a6cc38418910b2e0$var$MapCache.prototype["delete"] = $575eb14ab2b31b03$exports;
$a6cc38418910b2e0$var$MapCache.prototype.get = $2fe6cdb7e5c793dc$exports;
$a6cc38418910b2e0$var$MapCache.prototype.has = $22b760cf30a31377$exports;
$a6cc38418910b2e0$var$MapCache.prototype.set = $b39e430f93ec17f8$exports;
$a6cc38418910b2e0$exports = $a6cc38418910b2e0$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $f707f5e6173bece0$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $f707f5e6173bece0$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $d3ce36181053a891$exports) {
        var pairs = data.__data__;
        if (!$3b45073a9f2f1273$exports || pairs.length < $f707f5e6173bece0$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $a6cc38418910b2e0$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$f707f5e6173bece0$exports = $f707f5e6173bece0$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $75b9f8e835026959$var$Stack(entries) {
    var data = this.__data__ = new $d3ce36181053a891$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$75b9f8e835026959$var$Stack.prototype.clear = $a7beb0ce4fa4126e$exports;
$75b9f8e835026959$var$Stack.prototype["delete"] = $0766dee8ae28686e$exports;
$75b9f8e835026959$var$Stack.prototype.get = $e9cab4f83b8cf2e9$exports;
$75b9f8e835026959$var$Stack.prototype.has = $37e4c239050b91e3$exports;
$75b9f8e835026959$var$Stack.prototype.set = $f707f5e6173bece0$exports;
$75b9f8e835026959$exports = $75b9f8e835026959$var$Stack;


var $9b274535da61f7ac$exports = {};
var $21a9c399fabc76fe$exports = {};
var $25e57808ab068dc5$exports = {};

var $25e57808ab068dc5$var$defineProperty = function() {
    try {
        var func = $95eb055fdd27d869$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$25e57808ab068dc5$exports = $25e57808ab068dc5$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $21a9c399fabc76fe$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $25e57808ab068dc5$exports) $25e57808ab068dc5$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$21a9c399fabc76fe$exports = $21a9c399fabc76fe$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9b274535da61f7ac$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$881bebc960934ade$exports(object[key], value) || value === undefined && !(key in object)) $21a9c399fabc76fe$exports(object, key, value);
}
$9b274535da61f7ac$exports = $9b274535da61f7ac$var$assignMergeValue;


var $1a862ca629cc3032$exports = {};
var $3bb6739cad2da2c9$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $3bb6739cad2da2c9$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$3bb6739cad2da2c9$exports = $3bb6739cad2da2c9$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1a862ca629cc3032$var$baseFor = $3bb6739cad2da2c9$exports();
$1a862ca629cc3032$exports = $1a862ca629cc3032$var$baseFor;


var $87d173ffbe9197ab$exports = {};


var $gw5oW = parcelRequire("gw5oW");
var $cc7eebd1be87fe1c$exports = {};
var $c5a4265f8c412cdf$exports = {};
var $82ae00c827cb4de5$exports = {};

var $1DySm = parcelRequire("1DySm");
/** Built-in value references. */ var $82ae00c827cb4de5$var$Uint8Array = $1DySm.Uint8Array;
$82ae00c827cb4de5$exports = $82ae00c827cb4de5$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $c5a4265f8c412cdf$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $82ae00c827cb4de5$exports(result).set(new $82ae00c827cb4de5$exports(arrayBuffer));
    return result;
}
$c5a4265f8c412cdf$exports = $c5a4265f8c412cdf$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $cc7eebd1be87fe1c$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $c5a4265f8c412cdf$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$cc7eebd1be87fe1c$exports = $cc7eebd1be87fe1c$var$cloneTypedArray;


var $99a0ab0777733779$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $99a0ab0777733779$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$99a0ab0777733779$exports = $99a0ab0777733779$var$copyArray;


var $12b2001e80f30af2$exports = {};
var $777a1d7f7e87fc01$exports = {};

/** Built-in value references. */ var $777a1d7f7e87fc01$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $777a1d7f7e87fc01$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$f328ff7ee4fde81a$exports(proto)) return {};
        if ($777a1d7f7e87fc01$var$objectCreate) return $777a1d7f7e87fc01$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$777a1d7f7e87fc01$exports = $777a1d7f7e87fc01$var$baseCreate;


var $2272f6d455ebd3b2$exports = {};
var $fdcd49ef52ce3234$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fdcd49ef52ce3234$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fdcd49ef52ce3234$exports = $fdcd49ef52ce3234$var$overArg;


/** Built-in value references. */ var $2272f6d455ebd3b2$var$getPrototype = $fdcd49ef52ce3234$exports(Object.getPrototypeOf, Object);
$2272f6d455ebd3b2$exports = $2272f6d455ebd3b2$var$getPrototype;


var $b56b06902d83e6f4$exports = {};
/** Used for built-in method references. */ var $b56b06902d83e6f4$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $b56b06902d83e6f4$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $b56b06902d83e6f4$var$objectProto;
    return value === proto;
}
$b56b06902d83e6f4$exports = $b56b06902d83e6f4$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $12b2001e80f30af2$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$b56b06902d83e6f4$exports(object) ? $777a1d7f7e87fc01$exports($2272f6d455ebd3b2$exports(object)) : {};
}
$12b2001e80f30af2$exports = $12b2001e80f30af2$var$initCloneObject;


var $4f4b95b8aefe4d77$exports = {};
var $16682bb217664efe$exports = {};


/** `Object#toString` result references. */ var $16682bb217664efe$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $16682bb217664efe$var$baseIsArguments(value) {
    return $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $16682bb217664efe$var$argsTag;
}
$16682bb217664efe$exports = $16682bb217664efe$var$baseIsArguments;



/** Used for built-in method references. */ var $4f4b95b8aefe4d77$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4f4b95b8aefe4d77$var$hasOwnProperty = $4f4b95b8aefe4d77$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $4f4b95b8aefe4d77$var$propertyIsEnumerable = $4f4b95b8aefe4d77$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $4f4b95b8aefe4d77$var$isArguments = $16682bb217664efe$exports(function() {
    return arguments;
}()) ? $16682bb217664efe$exports : function(value) {
    return $97dbbc1a069ce16a$exports(value) && $4f4b95b8aefe4d77$var$hasOwnProperty.call(value, "callee") && !$4f4b95b8aefe4d77$var$propertyIsEnumerable.call(value, "callee");
};
$4f4b95b8aefe4d77$exports = $4f4b95b8aefe4d77$var$isArguments;


var $579b9ba2588bb9de$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $579b9ba2588bb9de$var$isArray = Array.isArray;
$579b9ba2588bb9de$exports = $579b9ba2588bb9de$var$isArray;


var $3eeaf96deac4f54c$exports = {};
var $4506257970d5c979$exports = {};

var $13758fcec31fd7af$exports = {};
/** Used as references for various `Number` constants. */ var $13758fcec31fd7af$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $13758fcec31fd7af$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $13758fcec31fd7af$var$MAX_SAFE_INTEGER;
}
$13758fcec31fd7af$exports = $13758fcec31fd7af$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4506257970d5c979$var$isArrayLike(value) {
    return value != null && $13758fcec31fd7af$exports(value.length) && !$07bc7c115e963817$exports(value);
}
$4506257970d5c979$exports = $4506257970d5c979$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $3eeaf96deac4f54c$var$isArrayLikeObject(value) {
    return $97dbbc1a069ce16a$exports(value) && $4506257970d5c979$exports(value);
}
$3eeaf96deac4f54c$exports = $3eeaf96deac4f54c$var$isArrayLikeObject;



var $9gBlp = parcelRequire("9gBlp");


var $46e9524417ce8039$exports = {};



/** `Object#toString` result references. */ var $46e9524417ce8039$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $46e9524417ce8039$var$funcProto = Function.prototype, $46e9524417ce8039$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $46e9524417ce8039$var$funcToString = $46e9524417ce8039$var$funcProto.toString;
/** Used to check objects for own properties. */ var $46e9524417ce8039$var$hasOwnProperty = $46e9524417ce8039$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $46e9524417ce8039$var$objectCtorString = $46e9524417ce8039$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $46e9524417ce8039$var$isPlainObject(value) {
    if (!$97dbbc1a069ce16a$exports(value) || $ae3fe6c5950c122e$exports(value) != $46e9524417ce8039$var$objectTag) return false;
    var proto = $2272f6d455ebd3b2$exports(value);
    if (proto === null) return true;
    var Ctor = $46e9524417ce8039$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $46e9524417ce8039$var$funcToString.call(Ctor) == $46e9524417ce8039$var$objectCtorString;
}
$46e9524417ce8039$exports = $46e9524417ce8039$var$isPlainObject;


var $91935e2ee1691ad1$exports = {};
var $409cf0e4c937c990$exports = {};



/** `Object#toString` result references. */ var $409cf0e4c937c990$var$argsTag = "[object Arguments]", $409cf0e4c937c990$var$arrayTag = "[object Array]", $409cf0e4c937c990$var$boolTag = "[object Boolean]", $409cf0e4c937c990$var$dateTag = "[object Date]", $409cf0e4c937c990$var$errorTag = "[object Error]", $409cf0e4c937c990$var$funcTag = "[object Function]", $409cf0e4c937c990$var$mapTag = "[object Map]", $409cf0e4c937c990$var$numberTag = "[object Number]", $409cf0e4c937c990$var$objectTag = "[object Object]", $409cf0e4c937c990$var$regexpTag = "[object RegExp]", $409cf0e4c937c990$var$setTag = "[object Set]", $409cf0e4c937c990$var$stringTag = "[object String]", $409cf0e4c937c990$var$weakMapTag = "[object WeakMap]";
var $409cf0e4c937c990$var$arrayBufferTag = "[object ArrayBuffer]", $409cf0e4c937c990$var$dataViewTag = "[object DataView]", $409cf0e4c937c990$var$float32Tag = "[object Float32Array]", $409cf0e4c937c990$var$float64Tag = "[object Float64Array]", $409cf0e4c937c990$var$int8Tag = "[object Int8Array]", $409cf0e4c937c990$var$int16Tag = "[object Int16Array]", $409cf0e4c937c990$var$int32Tag = "[object Int32Array]", $409cf0e4c937c990$var$uint8Tag = "[object Uint8Array]", $409cf0e4c937c990$var$uint8ClampedTag = "[object Uint8ClampedArray]", $409cf0e4c937c990$var$uint16Tag = "[object Uint16Array]", $409cf0e4c937c990$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $409cf0e4c937c990$var$typedArrayTags = {};
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$float64Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$int32Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint8ClampedTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint16Tag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$uint32Tag] = true;
$409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$argsTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$arrayBufferTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$boolTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dataViewTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$dateTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$errorTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$funcTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$mapTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$numberTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$objectTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$regexpTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$setTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$stringTag] = $409cf0e4c937c990$var$typedArrayTags[$409cf0e4c937c990$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $409cf0e4c937c990$var$baseIsTypedArray(value) {
    return $97dbbc1a069ce16a$exports(value) && $13758fcec31fd7af$exports(value.length) && !!$409cf0e4c937c990$var$typedArrayTags[$ae3fe6c5950c122e$exports(value)];
}
$409cf0e4c937c990$exports = $409cf0e4c937c990$var$baseIsTypedArray;


var $c4aeaafb4421a79e$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c4aeaafb4421a79e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$c4aeaafb4421a79e$exports = $c4aeaafb4421a79e$var$baseUnary;



var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $91935e2ee1691ad1$var$nodeIsTypedArray = $iU8uW && $iU8uW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $91935e2ee1691ad1$var$isTypedArray = $91935e2ee1691ad1$var$nodeIsTypedArray ? $c4aeaafb4421a79e$exports($91935e2ee1691ad1$var$nodeIsTypedArray) : $409cf0e4c937c990$exports;
$91935e2ee1691ad1$exports = $91935e2ee1691ad1$var$isTypedArray;


var $5f52dd2d8e7c7951$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $5f52dd2d8e7c7951$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$5f52dd2d8e7c7951$exports = $5f52dd2d8e7c7951$var$safeGet;


var $e3512f9985c9fa65$exports = {};
var $2089e20ff6782bbb$exports = {};
var $40601a0f588600f2$exports = {};


/** Used for built-in method references. */ var $40601a0f588600f2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $40601a0f588600f2$var$hasOwnProperty = $40601a0f588600f2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $40601a0f588600f2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($40601a0f588600f2$var$hasOwnProperty.call(object, key) && $881bebc960934ade$exports(objValue, value)) || value === undefined && !(key in object)) $21a9c399fabc76fe$exports(object, key, value);
}
$40601a0f588600f2$exports = $40601a0f588600f2$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2089e20ff6782bbb$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $21a9c399fabc76fe$exports(object, key, newValue);
        else $40601a0f588600f2$exports(object, key, newValue);
    }
    return object;
}
$2089e20ff6782bbb$exports = $2089e20ff6782bbb$var$copyObject;


var $9602693ae93bd599$exports = {};
var $14f0cee26f6289b7$exports = {};
var $2af85a3e5a570ba7$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $2af85a3e5a570ba7$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$2af85a3e5a570ba7$exports = $2af85a3e5a570ba7$var$baseTimes;





var $9gBlp = parcelRequire("9gBlp");
var $a4ac18a3b008eabc$exports = {};
/** Used as references for various `Number` constants. */ var $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a4ac18a3b008eabc$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a4ac18a3b008eabc$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a4ac18a3b008eabc$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $a4ac18a3b008eabc$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$a4ac18a3b008eabc$exports = $a4ac18a3b008eabc$var$isIndex;



/** Used for built-in method references. */ var $14f0cee26f6289b7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $14f0cee26f6289b7$var$hasOwnProperty = $14f0cee26f6289b7$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $14f0cee26f6289b7$var$arrayLikeKeys(value, inherited) {
    var isArr = $579b9ba2588bb9de$exports(value), isArg = !isArr && $4f4b95b8aefe4d77$exports(value), isBuff = !isArr && !isArg && $9gBlp(value), isType = !isArr && !isArg && !isBuff && $91935e2ee1691ad1$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $2af85a3e5a570ba7$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $14f0cee26f6289b7$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $a4ac18a3b008eabc$exports(key, length)))) result.push(key);
    return result;
}
$14f0cee26f6289b7$exports = $14f0cee26f6289b7$var$arrayLikeKeys;


var $6da7867fd755f301$exports = {};


var $4ca1dbf1eb816bbd$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4ca1dbf1eb816bbd$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$4ca1dbf1eb816bbd$exports = $4ca1dbf1eb816bbd$var$nativeKeysIn;


/** Used for built-in method references. */ var $6da7867fd755f301$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6da7867fd755f301$var$hasOwnProperty = $6da7867fd755f301$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6da7867fd755f301$var$baseKeysIn(object) {
    if (!$f328ff7ee4fde81a$exports(object)) return $4ca1dbf1eb816bbd$exports(object);
    var isProto = $b56b06902d83e6f4$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$6da7867fd755f301$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$6da7867fd755f301$exports = $6da7867fd755f301$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9602693ae93bd599$var$keysIn(object) {
    return $4506257970d5c979$exports(object) ? $14f0cee26f6289b7$exports(object, true) : $6da7867fd755f301$exports(object);
}
$9602693ae93bd599$exports = $9602693ae93bd599$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $e3512f9985c9fa65$var$toPlainObject(value) {
    return $2089e20ff6782bbb$exports(value, $9602693ae93bd599$exports(value));
}
$e3512f9985c9fa65$exports = $e3512f9985c9fa65$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $87d173ffbe9197ab$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $5f52dd2d8e7c7951$exports(object, key), srcValue = $5f52dd2d8e7c7951$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $9b274535da61f7ac$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $579b9ba2588bb9de$exports(srcValue), isBuff = !isArr && $9gBlp(srcValue), isTyped = !isArr && !isBuff && $91935e2ee1691ad1$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($579b9ba2588bb9de$exports(objValue)) newValue = objValue;
            else if ($3eeaf96deac4f54c$exports(objValue)) newValue = $99a0ab0777733779$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $gw5oW(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $cc7eebd1be87fe1c$exports(srcValue, true);
            } else newValue = [];
        } else if ($46e9524417ce8039$exports(srcValue) || $4f4b95b8aefe4d77$exports(srcValue)) {
            newValue = objValue;
            if ($4f4b95b8aefe4d77$exports(objValue)) newValue = $e3512f9985c9fa65$exports(objValue);
            else if (!$f328ff7ee4fde81a$exports(objValue) || $07bc7c115e963817$exports(objValue)) newValue = $12b2001e80f30af2$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $9b274535da61f7ac$exports(object, key, newValue);
}
$87d173ffbe9197ab$exports = $87d173ffbe9197ab$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $11770314f73a602c$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $1a862ca629cc3032$exports(source, function(srcValue, key) {
        stack || (stack = new $75b9f8e835026959$exports);
        if ($f328ff7ee4fde81a$exports(srcValue)) $87d173ffbe9197ab$exports(object, source, key, srcIndex, $11770314f73a602c$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($5f52dd2d8e7c7951$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $9b274535da61f7ac$exports(object, key, newValue);
        }
    }, $9602693ae93bd599$exports);
}
$11770314f73a602c$exports = $11770314f73a602c$var$baseMerge;


var $9097e5d13cb7b5f3$exports = {};
var $6b119307bcdda881$exports = {};
var $e4dbcba8665d9b6c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e4dbcba8665d9b6c$var$identity(value) {
    return value;
}
$e4dbcba8665d9b6c$exports = $e4dbcba8665d9b6c$var$identity;


var $edebe4cd16ce0339$exports = {};
var $2c8082d1abd12c9f$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $2c8082d1abd12c9f$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$2c8082d1abd12c9f$exports = $2c8082d1abd12c9f$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $edebe4cd16ce0339$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $edebe4cd16ce0339$var$overRest(func, start, transform) {
    start = $edebe4cd16ce0339$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $edebe4cd16ce0339$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $2c8082d1abd12c9f$exports(func, this, otherArgs);
    };
}
$edebe4cd16ce0339$exports = $edebe4cd16ce0339$var$overRest;


var $e94006b0ead3bc9b$exports = {};
var $10869bce639d4319$exports = {};
var $f24125b8d605265c$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $f24125b8d605265c$var$constant(value) {
    return function() {
        return value;
    };
}
$f24125b8d605265c$exports = $f24125b8d605265c$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $10869bce639d4319$var$baseSetToString = !$25e57808ab068dc5$exports ? $e4dbcba8665d9b6c$exports : function(func, string) {
    return $25e57808ab068dc5$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $f24125b8d605265c$exports(string),
        "writable": true
    });
};
$10869bce639d4319$exports = $10869bce639d4319$var$baseSetToString;


var $1159b1adb5e363bf$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $1159b1adb5e363bf$var$HOT_COUNT = 800, $1159b1adb5e363bf$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1159b1adb5e363bf$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $1159b1adb5e363bf$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $1159b1adb5e363bf$var$nativeNow(), remaining = $1159b1adb5e363bf$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $1159b1adb5e363bf$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$1159b1adb5e363bf$exports = $1159b1adb5e363bf$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e94006b0ead3bc9b$var$setToString = $1159b1adb5e363bf$exports($10869bce639d4319$exports);
$e94006b0ead3bc9b$exports = $e94006b0ead3bc9b$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $6b119307bcdda881$var$baseRest(func, start) {
    return $e94006b0ead3bc9b$exports($edebe4cd16ce0339$exports(func, start, $e4dbcba8665d9b6c$exports), func + "");
}
$6b119307bcdda881$exports = $6b119307bcdda881$var$baseRest;


var $18da533e307f2df0$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $18da533e307f2df0$var$isIterateeCall(value, index, object) {
    if (!$f328ff7ee4fde81a$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $4506257970d5c979$exports(object) && $a4ac18a3b008eabc$exports(index, object.length) : type == "string" && index in object) return $881bebc960934ade$exports(object[index], value);
    return false;
}
$18da533e307f2df0$exports = $18da533e307f2df0$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $9097e5d13cb7b5f3$var$createAssigner(assigner) {
    return $6b119307bcdda881$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $18da533e307f2df0$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$9097e5d13cb7b5f3$exports = $9097e5d13cb7b5f3$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $357f6a405ce5423a$var$merge = $9097e5d13cb7b5f3$exports(function(object, source, srcIndex) {
    $11770314f73a602c$exports(object, source, srcIndex);
});
$357f6a405ce5423a$exports = $357f6a405ce5423a$var$merge;


var $f7bfd9e73571977c$exports = {};
var $e913f1fcbff7147e$exports = {};
var $23e5d07d36d464f0$exports = {};

var $69479e268680fe10$exports = {};


/** Used to match property names within property paths. */ var $69479e268680fe10$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $69479e268680fe10$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $69479e268680fe10$var$isKey(value, object) {
    if ($579b9ba2588bb9de$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $2fffc1449db40502$exports(value)) return true;
    return $69479e268680fe10$var$reIsPlainProp.test(value) || !$69479e268680fe10$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$69479e268680fe10$exports = $69479e268680fe10$var$isKey;


var $a3922e70313d25cb$exports = {};
var $032fe0d410f8199d$exports = {};
var $5021746db8365e7e$exports = {};

/** Error message constants. */ var $5021746db8365e7e$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5021746db8365e7e$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($5021746db8365e7e$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5021746db8365e7e$var$memoize.Cache || $a6cc38418910b2e0$exports);
    return memoized;
}
// Expose `MapCache`.
$5021746db8365e7e$var$memoize.Cache = $a6cc38418910b2e0$exports;
$5021746db8365e7e$exports = $5021746db8365e7e$var$memoize;


/** Used as the maximum memoize cache size. */ var $032fe0d410f8199d$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $032fe0d410f8199d$var$memoizeCapped(func) {
    var result = $5021746db8365e7e$exports(func, function(key) {
        if (cache.size === $032fe0d410f8199d$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$032fe0d410f8199d$exports = $032fe0d410f8199d$var$memoizeCapped;


/** Used to match property names within property paths. */ var $a3922e70313d25cb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a3922e70313d25cb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a3922e70313d25cb$var$stringToPath = $032fe0d410f8199d$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($a3922e70313d25cb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a3922e70313d25cb$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$a3922e70313d25cb$exports = $a3922e70313d25cb$var$stringToPath;


var $78eb02cd4ef313ef$exports = {};
var $0e09541fbe2727c0$exports = {};

var $4c0f1a1d993f5976$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4c0f1a1d993f5976$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$4c0f1a1d993f5976$exports = $4c0f1a1d993f5976$var$arrayMap;




/** Used as references for various `Number` constants. */ var $0e09541fbe2727c0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0e09541fbe2727c0$var$symbolProto = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.prototype : undefined, $0e09541fbe2727c0$var$symbolToString = $0e09541fbe2727c0$var$symbolProto ? $0e09541fbe2727c0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0e09541fbe2727c0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($579b9ba2588bb9de$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $4c0f1a1d993f5976$exports(value, $0e09541fbe2727c0$var$baseToString) + "";
    if ($2fffc1449db40502$exports(value)) return $0e09541fbe2727c0$var$symbolToString ? $0e09541fbe2727c0$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$0e09541fbe2727c0$var$INFINITY ? "-0" : result;
}
$0e09541fbe2727c0$exports = $0e09541fbe2727c0$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $78eb02cd4ef313ef$var$toString(value) {
    return value == null ? "" : $0e09541fbe2727c0$exports(value);
}
$78eb02cd4ef313ef$exports = $78eb02cd4ef313ef$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $23e5d07d36d464f0$var$castPath(value, object) {
    if ($579b9ba2588bb9de$exports(value)) return value;
    return $69479e268680fe10$exports(value, object) ? [
        value
    ] : $a3922e70313d25cb$exports($78eb02cd4ef313ef$exports(value));
}
$23e5d07d36d464f0$exports = $23e5d07d36d464f0$var$castPath;


var $09a75ffd36bdbd18$exports = {};

/** Used as references for various `Number` constants. */ var $09a75ffd36bdbd18$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $09a75ffd36bdbd18$var$toKey(value) {
    if (typeof value == "string" || $2fffc1449db40502$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$09a75ffd36bdbd18$var$INFINITY ? "-0" : result;
}
$09a75ffd36bdbd18$exports = $09a75ffd36bdbd18$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $e913f1fcbff7147e$var$baseGet(object, path) {
    path = $23e5d07d36d464f0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$09a75ffd36bdbd18$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$e913f1fcbff7147e$exports = $e913f1fcbff7147e$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $f7bfd9e73571977c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $e913f1fcbff7147e$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$f7bfd9e73571977c$exports = $f7bfd9e73571977c$var$get;


var $3487eb305ae0d41f$exports = {};
var $a4ce95537effb69e$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $a4ce95537effb69e$var$baseSet(object, path, value, customizer) {
    if (!$f328ff7ee4fde81a$exports(object)) return object;
    path = $23e5d07d36d464f0$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $09a75ffd36bdbd18$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $f328ff7ee4fde81a$exports(objValue) ? objValue : $a4ac18a3b008eabc$exports(path[index + 1]) ? [] : {};
        }
        $40601a0f588600f2$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$a4ce95537effb69e$exports = $a4ce95537effb69e$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $3487eb305ae0d41f$var$set(object, path, value) {
    return object == null ? object : $a4ce95537effb69e$exports(object, path, value);
}
$3487eb305ae0d41f$exports = $3487eb305ae0d41f$var$set;


function $2a2619fae9aaf4f3$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $19ae46dee023ee5d$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $19ae46dee023ee5d$var$reB = new RegExp($19ae46dee023ee5d$var$reA.source, "g");
function $19ae46dee023ee5d$var$zero(b) {
    return function() {
        return b;
    };
}
function $19ae46dee023ee5d$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $19ae46dee023ee5d$export$2e2bcd8739ae039(a, b) {
    var bi = $19ae46dee023ee5d$var$reA.lastIndex = $19ae46dee023ee5d$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $19ae46dee023ee5d$var$reA.exec(a)) && (bm = $19ae46dee023ee5d$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $2a2619fae9aaf4f3$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $19ae46dee023ee5d$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $19ae46dee023ee5d$var$one(q[0].x) : $19ae46dee023ee5d$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}



var $3424b9151e51ad58$exports = {};



/** `Object#toString` result references. */ var $3424b9151e51ad58$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3424b9151e51ad58$var$isString(value) {
    return typeof value == "string" || !$579b9ba2588bb9de$exports(value) && $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $3424b9151e51ad58$var$stringTag;
}
$3424b9151e51ad58$exports = $3424b9151e51ad58$var$isString;



var $0af9c5bb33cc0648$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $0af9c5bb33cc0648$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$0af9c5bb33cc0648$exports = $0af9c5bb33cc0648$var$last;



function $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


const $46022730ab65113e$export$e4f898ab14d9d460 = Symbol("implicit");
function $46022730ab65113e$export$2e2bcd8739ae039() {
    var index = new Map(), domain = [], range = [], unknown = $46022730ab65113e$export$e4f898ab14d9d460;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $46022730ab65113e$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new Map();
        for (const value of _){
            const key = value + "";
            if (index.has(key)) continue;
            index.set(key, domain.push(value));
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $46022730ab65113e$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}

function $afd6b0667cb96baf$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $b954e02a9be0ac41$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $b954e02a9be0ac41$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $b954e02a9be0ac41$var$ascendingComparator(f) {
    return (d, x)=>(0, $afd6b0667cb96baf$export$2e2bcd8739ae039)(f(d), x);
}


function $5608f247111d06e6$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $5608f247111d06e6$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $6060bf4675fd0b91$var$ascendingBisect = (0, $b954e02a9be0ac41$export$2e2bcd8739ae039)((0, $afd6b0667cb96baf$export$2e2bcd8739ae039));
const $6060bf4675fd0b91$export$4d945ad3ad5751b0 = $6060bf4675fd0b91$var$ascendingBisect.right;
const $6060bf4675fd0b91$export$df7d25c84ebd12a5 = $6060bf4675fd0b91$var$ascendingBisect.left;
const $6060bf4675fd0b91$export$c1cb828b1117c77b = (0, $b954e02a9be0ac41$export$2e2bcd8739ae039)((0, $5608f247111d06e6$export$2e2bcd8739ae039)).center;
var $6060bf4675fd0b91$export$2e2bcd8739ae039 = $6060bf4675fd0b91$export$4d945ad3ad5751b0;


var $48f1022f08c36146$var$e10 = Math.sqrt(50), $48f1022f08c36146$var$e5 = Math.sqrt(10), $48f1022f08c36146$var$e2 = Math.sqrt(2);
function $48f1022f08c36146$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $48f1022f08c36146$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $48f1022f08c36146$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $48f1022f08c36146$var$e10 ? 10 : error >= $48f1022f08c36146$var$e5 ? 5 : error >= $48f1022f08c36146$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $48f1022f08c36146$var$e10 ? 10 : error >= $48f1022f08c36146$var$e5 ? 5 : error >= $48f1022f08c36146$var$e2 ? 2 : 1);
}
function $48f1022f08c36146$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $48f1022f08c36146$var$e10) step1 *= 10;
    else if (error >= $48f1022f08c36146$var$e5) step1 *= 5;
    else if (error >= $48f1022f08c36146$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}




var $5aIuV = parcelRequire("5aIuV");

var $5aIuV = parcelRequire("5aIuV");
function $2341f3cb1083f279$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $2341f3cb1083f279$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $2341f3cb1083f279$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $ed5694f62b8b8864$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $2341f3cb1083f279$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


function $c46cbbe7a5fa4c6f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $601acd475c2c4471$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $601acd475c2c4471$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $601acd475c2c4471$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $601acd475c2c4471$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $c46cbbe7a5fa4c6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $601acd475c2c4471$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $601acd475c2c4471$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $601acd475c2c4471$var$exponential(a, b, y) : (0, $c46cbbe7a5fa4c6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $601acd475c2c4471$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $601acd475c2c4471$var$linear(a, d) : (0, $c46cbbe7a5fa4c6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $078cf6b37c3db2d2$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $601acd475c2c4471$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $5aIuV.rgb)(start)).r, (end = (0, $5aIuV.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $601acd475c2c4471$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $078cf6b37c3db2d2$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $5aIuV.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $078cf6b37c3db2d2$export$2c0e28f2e2852d3f = $078cf6b37c3db2d2$var$rgbSpline((0, $2341f3cb1083f279$export$2e2bcd8739ae039));
var $078cf6b37c3db2d2$export$53d5214f625ccd4c = $078cf6b37c3db2d2$var$rgbSpline((0, $ed5694f62b8b8864$export$2e2bcd8739ae039));



function $62b19a085f1bc9cc$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $62b19a085f1bc9cc$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $ebd184a7b7e65524$export$2e2bcd8739ae039(a, b) {
    return ((0, $62b19a085f1bc9cc$export$5cd576d1827d40c8)(b) ? (0, $62b19a085f1bc9cc$export$2e2bcd8739ae039) : $ebd184a7b7e65524$export$15d09067c6a5ee49)(a, b);
}
function $ebd184a7b7e65524$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $1277998f8de56db8$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $d97504c83b33e911$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $f9b28c3ae0b722ba$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf909bec33888072$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $1277998f8de56db8$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $5f258ca1e029c89d$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $5f258ca1e029c89d$var$reB = new RegExp($5f258ca1e029c89d$var$reA.source, "g");
function $5f258ca1e029c89d$var$zero(b) {
    return function() {
        return b;
    };
}
function $5f258ca1e029c89d$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $5f258ca1e029c89d$export$2e2bcd8739ae039(a, b) {
    var bi = $5f258ca1e029c89d$var$reA.lastIndex = $5f258ca1e029c89d$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $5f258ca1e029c89d$var$reA.exec(a)) && (bm = $5f258ca1e029c89d$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $f9b28c3ae0b722ba$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $5f258ca1e029c89d$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $5f258ca1e029c89d$var$one(q[0].x) : $5f258ca1e029c89d$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $1277998f8de56db8$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $c46cbbe7a5fa4c6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $f9b28c3ae0b722ba$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $5aIuV.default)(b)) ? (b = c, $078cf6b37c3db2d2$export$2e2bcd8739ae039) : (0, $5f258ca1e029c89d$export$2e2bcd8739ae039) : b instanceof (0, $5aIuV.default) ? (0, $078cf6b37c3db2d2$export$2e2bcd8739ae039) : b instanceof Date ? (0, $d97504c83b33e911$export$2e2bcd8739ae039) : (0, $62b19a085f1bc9cc$export$5cd576d1827d40c8)(b) ? (0, $62b19a085f1bc9cc$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $ebd184a7b7e65524$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf909bec33888072$export$2e2bcd8739ae039) : (0, $f9b28c3ae0b722ba$export$2e2bcd8739ae039))(a, b);
}

function $456fea91e42dbc6f$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $73497b6d2bd60396$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $754cda13766e90d1$export$2e2bcd8739ae039(x) {
    return +x;
}


var $39cfcf291c7bc8aa$var$unit = [
    0,
    1
];
function $39cfcf291c7bc8aa$export$f0954fd7d5368655(x) {
    return x;
}
function $39cfcf291c7bc8aa$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $73497b6d2bd60396$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $39cfcf291c7bc8aa$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $39cfcf291c7bc8aa$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $39cfcf291c7bc8aa$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $39cfcf291c7bc8aa$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $39cfcf291c7bc8aa$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $39cfcf291c7bc8aa$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $6060bf4675fd0b91$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $39cfcf291c7bc8aa$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $39cfcf291c7bc8aa$export$6b468dcfb64c653c() {
    var domain = $39cfcf291c7bc8aa$var$unit, range = $39cfcf291c7bc8aa$var$unit, interpolate = (0, $1277998f8de56db8$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $39cfcf291c7bc8aa$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $39cfcf291c7bc8aa$export$f0954fd7d5368655) clamp = $39cfcf291c7bc8aa$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $39cfcf291c7bc8aa$var$polymap : $39cfcf291c7bc8aa$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $f9b28c3ae0b722ba$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $754cda13766e90d1$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $456fea91e42dbc6f$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $39cfcf291c7bc8aa$export$f0954fd7d5368655, rescale()) : clamp !== $39cfcf291c7bc8aa$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $39cfcf291c7bc8aa$export$2e2bcd8739ae039() {
    return $39cfcf291c7bc8aa$export$6b468dcfb64c653c()($39cfcf291c7bc8aa$export$f0954fd7d5368655, $39cfcf291c7bc8aa$export$f0954fd7d5368655);
}




function $07b1bfcca94cff64$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $07b1bfcca94cff64$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $42144e863e2c031a$export$2e2bcd8739ae039(x) {
    return x = (0, $07b1bfcca94cff64$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $c0aa066677fd4623$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $2d398aa01d263524$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $fa586b3bd9779819$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $fa586b3bd9779819$export$2e2bcd8739ae039(specifier) {
    if (!(match = $fa586b3bd9779819$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $fa586b3bd9779819$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$fa586b3bd9779819$export$2e2bcd8739ae039.prototype = $fa586b3bd9779819$export$963aac351db36ed4.prototype; // instanceof
function $fa586b3bd9779819$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$fa586b3bd9779819$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $492893b96b60aa6a$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $79732e004e59935a$export$6863724d9a42263;
function $79732e004e59935a$export$2e2bcd8739ae039(x, p) {
    var d = (0, $07b1bfcca94cff64$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($79732e004e59935a$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $07b1bfcca94cff64$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $659f670923a90e0b$export$2e2bcd8739ae039(x, p) {
    var d = (0, $07b1bfcca94cff64$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $2920d64551b9c012$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $07b1bfcca94cff64$export$2e2bcd8739ae039),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $659f670923a90e0b$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $659f670923a90e0b$export$2e2bcd8739ae039),
    "s": (0, $79732e004e59935a$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};



function $d003d5731f1069d8$export$2e2bcd8739ae039(x) {
    return x;
}


var $f032f29830e4a5bf$var$map = Array.prototype.map, $f032f29830e4a5bf$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $f032f29830e4a5bf$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $d003d5731f1069d8$export$2e2bcd8739ae039) : (0, $c0aa066677fd4623$export$2e2bcd8739ae039)($f032f29830e4a5bf$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $d003d5731f1069d8$export$2e2bcd8739ae039) : (0, $2d398aa01d263524$export$2e2bcd8739ae039)($f032f29830e4a5bf$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $fa586b3bd9779819$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $2920d64551b9c012$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $2920d64551b9c012$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $492893b96b60aa6a$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $f032f29830e4a5bf$var$prefixes[8 + (0, $79732e004e59935a$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $fa586b3bd9779819$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $42144e863e2c031a$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $f032f29830e4a5bf$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $f979cbd3e1200bf1$var$locale;
var $f979cbd3e1200bf1$export$d9468344d3651243;
var $f979cbd3e1200bf1$export$8d85692a469dde6f;
$f979cbd3e1200bf1$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $f979cbd3e1200bf1$export$2e2bcd8739ae039(definition) {
    $f979cbd3e1200bf1$var$locale = (0, $f032f29830e4a5bf$export$2e2bcd8739ae039)(definition);
    $f979cbd3e1200bf1$export$d9468344d3651243 = $f979cbd3e1200bf1$var$locale.format;
    $f979cbd3e1200bf1$export$8d85692a469dde6f = $f979cbd3e1200bf1$var$locale.formatPrefix;
    return $f979cbd3e1200bf1$var$locale;
}


function $10c1b131ad630542$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $42144e863e2c031a$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $2330bd6e996ae48f$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $42144e863e2c031a$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $42144e863e2c031a$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $cf48ffcf3023f148$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $42144e863e2c031a$export$2e2bcd8739ae039)(max) - (0, $42144e863e2c031a$export$2e2bcd8739ae039)(step)) + 1;
}


function $b7d00bc80ead132c$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $48f1022f08c36146$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $fa586b3bd9779819$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $2330bd6e996ae48f$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $f979cbd3e1200bf1$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $cf48ffcf3023f148$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $10c1b131ad630542$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $f979cbd3e1200bf1$export$d9468344d3651243)(specifier);
}


function $43657edf9f9313df$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $48f1022f08c36146$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $b7d00bc80ead132c$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $48f1022f08c36146$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $43657edf9f9313df$export$2e2bcd8739ae039() {
    var scale = (0, $39cfcf291c7bc8aa$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $39cfcf291c7bc8aa$export$784d13d8ee351f07)(scale, $43657edf9f9313df$export$2e2bcd8739ae039());
    };
    (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $43657edf9f9313df$export$16a5d4b4a61a274d(scale);
}



function $2d4e99e5984fdf9f$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $6060bf4675fd0b91$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $2d4e99e5984fdf9f$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply((0, $43657edf9f9313df$export$16a5d4b4a61a274d)(scale), arguments);
}







function $67cb6af6bded2fe6$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $2a0a0e4ba4b52637$var$transformLog(x) {
    return Math.log(x);
}
function $2a0a0e4ba4b52637$var$transformExp(x) {
    return Math.exp(x);
}
function $2a0a0e4ba4b52637$var$transformLogn(x) {
    return -Math.log(-x);
}
function $2a0a0e4ba4b52637$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $2a0a0e4ba4b52637$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $2a0a0e4ba4b52637$var$powp(base) {
    return base === 10 ? $2a0a0e4ba4b52637$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $2a0a0e4ba4b52637$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $2a0a0e4ba4b52637$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $2a0a0e4ba4b52637$export$860836db074028f0(transform) {
    var scale = transform($2a0a0e4ba4b52637$var$transformLog, $2a0a0e4ba4b52637$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $2a0a0e4ba4b52637$var$logp(base), pows = $2a0a0e4ba4b52637$var$powp(base);
        if (domain()[0] < 0) {
            logs = $2a0a0e4ba4b52637$var$reflect(logs), pows = $2a0a0e4ba4b52637$var$reflect(pows);
            transform($2a0a0e4ba4b52637$var$transformLogn, $2a0a0e4ba4b52637$var$transformExpn);
        } else transform($2a0a0e4ba4b52637$var$transformLog, $2a0a0e4ba4b52637$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $48f1022f08c36146$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $48f1022f08c36146$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $f979cbd3e1200bf1$export$d9468344d3651243)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $67cb6af6bded2fe6$export$2e2bcd8739ae039)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $2a0a0e4ba4b52637$export$2e2bcd8739ae039() {
    var scale = $2a0a0e4ba4b52637$export$860836db074028f0((0, $39cfcf291c7bc8aa$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $39cfcf291c7bc8aa$export$784d13d8ee351f07)(scale, $2a0a0e4ba4b52637$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $e73aca1ccf43f2f6$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $e73aca1ccf43f2f6$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $e73aca1ccf43f2f6$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($e73aca1ccf43f2f6$var$transformSymlog(c), $e73aca1ccf43f2f6$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($e73aca1ccf43f2f6$var$transformSymlog(c = +_), $e73aca1ccf43f2f6$var$transformSymexp(c)) : c;
    };
    return (0, $43657edf9f9313df$export$16a5d4b4a61a274d)(scale);
}
function $e73aca1ccf43f2f6$export$2e2bcd8739ae039() {
    var scale = $e73aca1ccf43f2f6$export$4602684e614eba38((0, $39cfcf291c7bc8aa$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $39cfcf291c7bc8aa$export$784d13d8ee351f07)(scale, $e73aca1ccf43f2f6$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $db11d499e1656b02$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $db11d499e1656b02$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $db11d499e1656b02$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $db11d499e1656b02$export$34695211ec403a46(transform) {
    var scale = transform((0, $39cfcf291c7bc8aa$export$f0954fd7d5368655), (0, $39cfcf291c7bc8aa$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $39cfcf291c7bc8aa$export$f0954fd7d5368655), (0, $39cfcf291c7bc8aa$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($db11d499e1656b02$var$transformSqrt, $db11d499e1656b02$var$transformSquare) : transform($db11d499e1656b02$var$transformPow(exponent), $db11d499e1656b02$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $43657edf9f9313df$export$16a5d4b4a61a274d)(scale);
}
function $db11d499e1656b02$export$2e2bcd8739ae039() {
    var scale = $db11d499e1656b02$export$34695211ec403a46((0, $39cfcf291c7bc8aa$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $39cfcf291c7bc8aa$export$784d13d8ee351f07)(scale, $db11d499e1656b02$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $db11d499e1656b02$export$eba8049fb5020b81() {
    return $db11d499e1656b02$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $50d03fd061729af1$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $39cfcf291c7bc8aa$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $1277998f8de56db8$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $456fea91e42dbc6f$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $50d03fd061729af1$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $50d03fd061729af1$export$2e2bcd8739ae039() {
    var scale = (0, $43657edf9f9313df$export$16a5d4b4a61a274d)($50d03fd061729af1$var$transformer()((0, $39cfcf291c7bc8aa$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $50d03fd061729af1$export$784d13d8ee351f07(scale, $50d03fd061729af1$export$2e2bcd8739ae039());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50d03fd061729af1$export$6843e08bf2ff981f() {
    var scale = (0, $2a0a0e4ba4b52637$export$860836db074028f0)($50d03fd061729af1$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $50d03fd061729af1$export$784d13d8ee351f07(scale, $50d03fd061729af1$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50d03fd061729af1$export$9d4af4de62c81941() {
    var scale = (0, $e73aca1ccf43f2f6$export$4602684e614eba38)($50d03fd061729af1$var$transformer());
    scale.copy = function() {
        return $50d03fd061729af1$export$784d13d8ee351f07(scale, $50d03fd061729af1$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50d03fd061729af1$export$de9f78581b4f2405() {
    var scale = (0, $db11d499e1656b02$export$34695211ec403a46)($50d03fd061729af1$var$transformer());
    scale.copy = function() {
        return $50d03fd061729af1$export$784d13d8ee351f07(scale, $50d03fd061729af1$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50d03fd061729af1$export$413d935127ed466e() {
    return $50d03fd061729af1$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}


function $b39ca9f81589cb4d$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}



var $dc66659e379ed9f8$export$2e2bcd8739ae039 = (scheme)=>(0, $078cf6b37c3db2d2$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $d3ed090c8c94b4e2$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $d3ed090c8c94b4e2$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($d3ed090c8c94b4e2$export$3005042704f95a69);



var $219f70bda2a84288$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $219f70bda2a84288$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($219f70bda2a84288$export$3005042704f95a69);



var $847f46a436bbc72d$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $847f46a436bbc72d$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($847f46a436bbc72d$export$3005042704f95a69);



var $a88f39e40f768068$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $a88f39e40f768068$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($a88f39e40f768068$export$3005042704f95a69);


var $KIXBU = parcelRequire("KIXBU");

var $5aIuV = parcelRequire("5aIuV");
var $f0e0ac7109b193dc$export$b1b275608b2b1b8 = Math.PI / 180;
var $f0e0ac7109b193dc$export$b2ba2578f2c43d74 = 180 / Math.PI;


var $d4ecd222ec6efac1$var$A = -0.14861, $d4ecd222ec6efac1$var$B = 1.78277, $d4ecd222ec6efac1$var$C = -0.29227, $d4ecd222ec6efac1$var$D = -0.90649, $d4ecd222ec6efac1$var$E = 1.97294, $d4ecd222ec6efac1$var$ED = $d4ecd222ec6efac1$var$E * $d4ecd222ec6efac1$var$D, $d4ecd222ec6efac1$var$EB = $d4ecd222ec6efac1$var$E * $d4ecd222ec6efac1$var$B, $d4ecd222ec6efac1$var$BC_DA = $d4ecd222ec6efac1$var$B * $d4ecd222ec6efac1$var$C - $d4ecd222ec6efac1$var$D * $d4ecd222ec6efac1$var$A;
function $d4ecd222ec6efac1$var$cubehelixConvert(o) {
    if (o instanceof $d4ecd222ec6efac1$export$57ed4bde61a1e2f2) return new $d4ecd222ec6efac1$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $5aIuV.Rgb))) o = (0, $5aIuV.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($d4ecd222ec6efac1$var$BC_DA * b + $d4ecd222ec6efac1$var$ED * r - $d4ecd222ec6efac1$var$EB * g) / ($d4ecd222ec6efac1$var$BC_DA + $d4ecd222ec6efac1$var$ED - $d4ecd222ec6efac1$var$EB), bl = b - l, k = ($d4ecd222ec6efac1$var$E * (g - l) - $d4ecd222ec6efac1$var$C * bl) / $d4ecd222ec6efac1$var$D, s = Math.sqrt(k * k + bl * bl) / ($d4ecd222ec6efac1$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $f0e0ac7109b193dc$export$b2ba2578f2c43d74) - 120 : NaN;
    return new $d4ecd222ec6efac1$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $d4ecd222ec6efac1$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $d4ecd222ec6efac1$var$cubehelixConvert(h) : new $d4ecd222ec6efac1$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $d4ecd222ec6efac1$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $KIXBU.default)($d4ecd222ec6efac1$export$57ed4bde61a1e2f2, $d4ecd222ec6efac1$export$2e2bcd8739ae039, (0, $KIXBU.extend)((0, $5aIuV.Color), {
    brighter: function(k) {
        k = k == null ? (0, $5aIuV.brighter) : Math.pow((0, $5aIuV.brighter), k);
        return new $d4ecd222ec6efac1$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $5aIuV.darker) : Math.pow((0, $5aIuV.darker), k);
        return new $d4ecd222ec6efac1$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $f0e0ac7109b193dc$export$b1b275608b2b1b8), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $5aIuV.Rgb)(255 * (l + a * ($d4ecd222ec6efac1$var$A * cosh + $d4ecd222ec6efac1$var$B * sinh)), 255 * (l + a * ($d4ecd222ec6efac1$var$C * cosh + $d4ecd222ec6efac1$var$D * sinh)), 255 * (l + a * ($d4ecd222ec6efac1$var$E * cosh)), this.opacity);
    }
}));




function $1620f30d75e638e1$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(start)).h, (end = (0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(end)).h), s = (0, $601acd475c2c4471$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $601acd475c2c4471$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $601acd475c2c4471$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $1620f30d75e638e1$export$2e2bcd8739ae039 = $1620f30d75e638e1$var$cubehelix((0, $601acd475c2c4471$export$97d7b0c7ddb78dcf));
var $1620f30d75e638e1$export$934fa09ad474a1b4 = $1620f30d75e638e1$var$cubehelix((0, $601acd475c2c4471$export$2e2bcd8739ae039));


var $ab9b1c4ea6725a3f$export$fc70efcec537be98 = (0, $1620f30d75e638e1$export$934fa09ad474a1b4)((0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $ab9b1c4ea6725a3f$export$c5cedbc1ab3be2c3 = (0, $1620f30d75e638e1$export$934fa09ad474a1b4)((0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $ab9b1c4ea6725a3f$var$c = (0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)();
function $ab9b1c4ea6725a3f$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $ab9b1c4ea6725a3f$var$c.h = 360 * t - 100;
    $ab9b1c4ea6725a3f$var$c.s = 1.5 - 1.5 * ts;
    $ab9b1c4ea6725a3f$var$c.l = 0.8 - 0.9 * ts;
    return $ab9b1c4ea6725a3f$var$c + "";
}



var $8e7823d310a8100b$export$2e2bcd8739ae039 = (0, $1620f30d75e638e1$export$934fa09ad474a1b4)((0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $d4ecd222ec6efac1$export$2e2bcd8739ae039)(-240, 0.5, 1.0));



var $f64a1aea510bd318$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $f64a1aea510bd318$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($f64a1aea510bd318$export$3005042704f95a69);



var $eaf5757e5e20111c$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $eaf5757e5e20111c$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($eaf5757e5e20111c$export$3005042704f95a69);



var $61efc056027c6f83$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $61efc056027c6f83$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($61efc056027c6f83$export$3005042704f95a69);


function $566595be19c6c616$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $566595be19c6c616$export$2e2bcd8739ae039 = $566595be19c6c616$var$ramp((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $566595be19c6c616$export$c41e69203f572e8d = $566595be19c6c616$var$ramp((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $566595be19c6c616$export$ad0c8285c8ea6dbd = $566595be19c6c616$var$ramp((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $566595be19c6c616$export$6664860a633d9daf = $566595be19c6c616$var$ramp((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



var $ef09f7e7ba00ec44$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $ef09f7e7ba00ec44$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($ef09f7e7ba00ec44$export$3005042704f95a69);



var $28098c54962f3133$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $28098c54962f3133$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($28098c54962f3133$export$3005042704f95a69);



var $6691be584654a0aa$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $6691be584654a0aa$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($6691be584654a0aa$export$3005042704f95a69);



var $a1632d99e2d37bcf$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $a1632d99e2d37bcf$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($a1632d99e2d37bcf$export$3005042704f95a69);



var $45b9b6cfaa33816b$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $45b9b6cfaa33816b$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($45b9b6cfaa33816b$export$3005042704f95a69);



var $7826a5e6af7d98b9$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $7826a5e6af7d98b9$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($7826a5e6af7d98b9$export$3005042704f95a69);



var $3f77df9b475c140b$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $3f77df9b475c140b$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($3f77df9b475c140b$export$3005042704f95a69);



var $6e8094f4389eb035$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $6e8094f4389eb035$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($6e8094f4389eb035$export$3005042704f95a69);



var $5eca65edfa5e3362$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $5eca65edfa5e3362$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($5eca65edfa5e3362$export$3005042704f95a69);



var $38219aed23964a40$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $38219aed23964a40$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($38219aed23964a40$export$3005042704f95a69);



var $fdda3d661f15ff0a$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $fdda3d661f15ff0a$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($fdda3d661f15ff0a$export$3005042704f95a69);



var $62dcbf6105c53d0a$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $62dcbf6105c53d0a$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($62dcbf6105c53d0a$export$3005042704f95a69);



var $d0c8a68d89733660$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $d0c8a68d89733660$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($d0c8a68d89733660$export$3005042704f95a69);



var $1630ec0b370e5912$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $1630ec0b370e5912$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($1630ec0b370e5912$export$3005042704f95a69);



var $41e2d3efba46b464$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $41e2d3efba46b464$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($41e2d3efba46b464$export$3005042704f95a69);


var $5aIuV = parcelRequire("5aIuV");
var $2f36c4634cfbe4b2$var$c = (0, $5aIuV.rgb)(), $2f36c4634cfbe4b2$var$pi_1_3 = Math.PI / 3, $2f36c4634cfbe4b2$var$pi_2_3 = Math.PI * 2 / 3;
function $2f36c4634cfbe4b2$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $2f36c4634cfbe4b2$var$c.r = 255 * (x = Math.sin(t)) * x;
    $2f36c4634cfbe4b2$var$c.g = 255 * (x = Math.sin(t + $2f36c4634cfbe4b2$var$pi_1_3)) * x;
    $2f36c4634cfbe4b2$var$c.b = 255 * (x = Math.sin(t + $2f36c4634cfbe4b2$var$pi_2_3)) * x;
    return $2f36c4634cfbe4b2$var$c + "";
}



var $8d06221358a48e3e$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $8d06221358a48e3e$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($8d06221358a48e3e$export$3005042704f95a69);



var $12aeccb6028274a3$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $12aeccb6028274a3$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($12aeccb6028274a3$export$3005042704f95a69);



var $86f372b7a8c1dbdd$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $86f372b7a8c1dbdd$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($86f372b7a8c1dbdd$export$3005042704f95a69);



var $be31442e924737ac$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $be31442e924737ac$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($be31442e924737ac$export$3005042704f95a69);



var $886c368be80910b3$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $b39ca9f81589cb4d$export$2e2bcd8739ae039));
var $886c368be80910b3$export$2e2bcd8739ae039 = (0, $dc66659e379ed9f8$export$2e2bcd8739ae039)($886c368be80910b3$export$3005042704f95a69);


var $faaa9454e2cc6c8f$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");


var $93b217b96440b4ce$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");


var $45decd1672a2c6a3$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");


var $97d8980b55e3f341$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $e8dfd5913f0417f3$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");


var $29119ca77ee513ac$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");


var $bc101e1e75979858$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");


var $81fba5de2439dc06$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");


var $dc42a0703a8adee7$export$2e2bcd8739ae039 = (0, $b39ca9f81589cb4d$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");



var $81ee6696873b1a9a$exports = {};
var $90d7e56fa7ea939c$exports = {};
var $7d2f3a0d9ce14f26$exports = {};

var $f6f0f11ce35948e9$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $f6f0f11ce35948e9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f6f0f11ce35948e9$var$setCacheAdd(value) {
    this.__data__.set(value, $f6f0f11ce35948e9$var$HASH_UNDEFINED);
    return this;
}
$f6f0f11ce35948e9$exports = $f6f0f11ce35948e9$var$setCacheAdd;


var $f0633ffdd75034a5$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f0633ffdd75034a5$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$f0633ffdd75034a5$exports = $f0633ffdd75034a5$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7d2f3a0d9ce14f26$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $a6cc38418910b2e0$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7d2f3a0d9ce14f26$var$SetCache.prototype.add = $7d2f3a0d9ce14f26$var$SetCache.prototype.push = $f6f0f11ce35948e9$exports;
$7d2f3a0d9ce14f26$var$SetCache.prototype.has = $f0633ffdd75034a5$exports;
$7d2f3a0d9ce14f26$exports = $7d2f3a0d9ce14f26$var$SetCache;


var $6d186121efb321b5$exports = {};
var $87eaa0c999d1fce0$exports = {};
var $45fe5e20b6ff07af$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $45fe5e20b6ff07af$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$45fe5e20b6ff07af$exports = $45fe5e20b6ff07af$var$baseFindIndex;


var $b4cbf4afe6020a3c$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $b4cbf4afe6020a3c$var$baseIsNaN(value) {
    return value !== value;
}
$b4cbf4afe6020a3c$exports = $b4cbf4afe6020a3c$var$baseIsNaN;


var $c7636be3605d889e$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c7636be3605d889e$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$c7636be3605d889e$exports = $c7636be3605d889e$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87eaa0c999d1fce0$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $c7636be3605d889e$exports(array, value, fromIndex) : $45fe5e20b6ff07af$exports(array, $b4cbf4afe6020a3c$exports, fromIndex);
}
$87eaa0c999d1fce0$exports = $87eaa0c999d1fce0$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $6d186121efb321b5$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $87eaa0c999d1fce0$exports(array, value, 0) > -1;
}
$6d186121efb321b5$exports = $6d186121efb321b5$var$arrayIncludes;


var $c0d14eba3105b20d$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c0d14eba3105b20d$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$c0d14eba3105b20d$exports = $c0d14eba3105b20d$var$arrayIncludesWith;




var $601e4ed5362647b9$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $601e4ed5362647b9$var$cacheHas(cache, key) {
    return cache.has(key);
}
$601e4ed5362647b9$exports = $601e4ed5362647b9$var$cacheHas;


/** Used as the size to enable large array optimizations. */ var $90d7e56fa7ea939c$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $90d7e56fa7ea939c$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $6d186121efb321b5$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $4c0f1a1d993f5976$exports(values, $c4aeaafb4421a79e$exports(iteratee));
    if (comparator) {
        includes = $c0d14eba3105b20d$exports;
        isCommon = false;
    } else if (values.length >= $90d7e56fa7ea939c$var$LARGE_ARRAY_SIZE) {
        includes = $601e4ed5362647b9$exports;
        isCommon = false;
        values = new $7d2f3a0d9ce14f26$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$90d7e56fa7ea939c$exports = $90d7e56fa7ea939c$var$baseDifference;




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $81ee6696873b1a9a$var$without = $6b119307bcdda881$exports(function(array, values) {
    return $3eeaf96deac4f54c$exports(array) ? $90d7e56fa7ea939c$exports(array, values) : [];
});
$81ee6696873b1a9a$exports = $81ee6696873b1a9a$var$without;


function $057edd14d2e89b9f$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $057edd14d2e89b9f$export$957f7263e89bedd2(context) {
    this._context = context;
}
$057edd14d2e89b9f$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $057edd14d2e89b9f$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $057edd14d2e89b9f$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $057edd14d2e89b9f$export$2e2bcd8739ae039(context) {
    return new $057edd14d2e89b9f$export$957f7263e89bedd2(context);
}

function $f17ae3fe134e84b4$export$2e2bcd8739ae039() {}



function $6fb2f44dbcd8b8cd$var$BasisClosed(context) {
    this._context = context;
}
$6fb2f44dbcd8b8cd$var$BasisClosed.prototype = {
    areaStart: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    areaEnd: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $057edd14d2e89b9f$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $6fb2f44dbcd8b8cd$export$2e2bcd8739ae039(context) {
    return new $6fb2f44dbcd8b8cd$var$BasisClosed(context);
}


function $daf5476d3d8d82c6$var$BasisOpen(context) {
    this._context = context;
}
$daf5476d3d8d82c6$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $057edd14d2e89b9f$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $daf5476d3d8d82c6$export$2e2bcd8739ae039(context) {
    return new $daf5476d3d8d82c6$var$BasisOpen(context);
}


function $fc59b80ba28997f1$var$Bundle(context, beta) {
    this._basis = new (0, $057edd14d2e89b9f$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$fc59b80ba28997f1$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $fc59b80ba28997f1$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $057edd14d2e89b9f$export$957f7263e89bedd2)(context) : new $fc59b80ba28997f1$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);


var $1nfk9 = parcelRequire("1nfk9");

var $1nfk9 = parcelRequire("1nfk9");
function $92af638e5ea5d76b$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$92af638e5ea5d76b$export$da3940d7e9162858.prototype = {
    areaStart: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    areaEnd: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $1nfk9.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $92af638e5ea5d76b$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $92af638e5ea5d76b$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $1nfk9 = parcelRequire("1nfk9");
function $cad95e957f5f2cf2$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$cad95e957f5f2cf2$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $1nfk9.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $cad95e957f5f2cf2$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $cad95e957f5f2cf2$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $ibKd5 = parcelRequire("ibKd5");


var $ibKd5 = parcelRequire("ibKd5");
function $a6ca9f61f1518e27$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$a6ca9f61f1518e27$var$CatmullRomClosed.prototype = {
    areaStart: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    areaEnd: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $ibKd5.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a6ca9f61f1518e27$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $a6ca9f61f1518e27$var$CatmullRomClosed(context, alpha) : new (0, $92af638e5ea5d76b$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $ibKd5 = parcelRequire("ibKd5");
function $f2bf92d30ef53143$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f2bf92d30ef53143$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $ibKd5.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f2bf92d30ef53143$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f2bf92d30ef53143$var$CatmullRomOpen(context, alpha) : new (0, $cad95e957f5f2cf2$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

function $ef8d0d3e260330b4$var$Linear(context) {
    this._context = context;
}
$ef8d0d3e260330b4$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $ef8d0d3e260330b4$export$2e2bcd8739ae039(context) {
    return new $ef8d0d3e260330b4$var$Linear(context);
}


function $8397ca2590b4eb43$var$LinearClosed(context) {
    this._context = context;
}
$8397ca2590b4eb43$var$LinearClosed.prototype = {
    areaStart: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    areaEnd: (0, $f17ae3fe134e84b4$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $8397ca2590b4eb43$export$2e2bcd8739ae039(context) {
    return new $8397ca2590b4eb43$var$LinearClosed(context);
}

function $52138155fb87d3d5$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $52138155fb87d3d5$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($52138155fb87d3d5$var$sign(s0) + $52138155fb87d3d5$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $52138155fb87d3d5$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $52138155fb87d3d5$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $52138155fb87d3d5$var$MonotoneX(context) {
    this._context = context;
}
$52138155fb87d3d5$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $52138155fb87d3d5$var$point(this, this._t0, $52138155fb87d3d5$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $52138155fb87d3d5$var$point(this, $52138155fb87d3d5$var$slope2(this, t1 = $52138155fb87d3d5$var$slope3(this, x, y)), t1);
                break;
            default:
                $52138155fb87d3d5$var$point(this, this._t0, t1 = $52138155fb87d3d5$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $52138155fb87d3d5$var$MonotoneY(context) {
    this._context = new $52138155fb87d3d5$var$ReflectContext(context);
}
($52138155fb87d3d5$var$MonotoneY.prototype = Object.create($52138155fb87d3d5$var$MonotoneX.prototype)).point = function(x, y) {
    $52138155fb87d3d5$var$MonotoneX.prototype.point.call(this, y, x);
};
function $52138155fb87d3d5$var$ReflectContext(context) {
    this._context = context;
}
$52138155fb87d3d5$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $52138155fb87d3d5$export$99563b5420dbdc55(context) {
    return new $52138155fb87d3d5$var$MonotoneX(context);
}
function $52138155fb87d3d5$export$8b5360456d6bdb88(context) {
    return new $52138155fb87d3d5$var$MonotoneY(context);
}

function $9eb0ee98a9fc61ab$var$Natural(context) {
    this._context = context;
}
$9eb0ee98a9fc61ab$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $9eb0ee98a9fc61ab$var$controlPoints(x), py = $9eb0ee98a9fc61ab$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $9eb0ee98a9fc61ab$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $9eb0ee98a9fc61ab$export$2e2bcd8739ae039(context) {
    return new $9eb0ee98a9fc61ab$var$Natural(context);
}

function $bd4b92113ce6a649$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$bd4b92113ce6a649$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $bd4b92113ce6a649$export$2e2bcd8739ae039(context) {
    return new $bd4b92113ce6a649$var$Step(context, 0.5);
}
function $bd4b92113ce6a649$export$10eafa5b7478b343(context) {
    return new $bd4b92113ce6a649$var$Step(context, 0);
}
function $bd4b92113ce6a649$export$793b3db073781cbb(context) {
    return new $bd4b92113ce6a649$var$Step(context, 1);
}

function $5e295988ef475abe$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

function $ac4071e3d42adef3$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $9f8b1cc3c0f88e61$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $ac4071e3d42adef3$export$2e2bcd8739ae039)(series, order);
}


function $70650e77b689ed1a$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $ac4071e3d42adef3$export$2e2bcd8739ae039)(series, order);
}


function $35e8556efa62b994$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $ac4071e3d42adef3$export$2e2bcd8739ae039)(series, order);
}

function $4edcea54ce45e1e9$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $1b8a167c972a865b$export$2e2bcd8739ae039(series) {
    var sums = series.map($1b8a167c972a865b$export$8a63f25cc62965f1);
    return (0, $4edcea54ce45e1e9$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $1b8a167c972a865b$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}


function $bbaab929e9beb03a$export$2e2bcd8739ae039(series) {
    return (0, $1b8a167c972a865b$export$2e2bcd8739ae039)(series).reverse();
}


function $e198628b7fa6e29c$export$2e2bcd8739ae039(series) {
    var peaks = series.map($e198628b7fa6e29c$var$peak);
    return (0, $4edcea54ce45e1e9$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $e198628b7fa6e29c$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $a166888d2ade1ac4$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $1b8a167c972a865b$export$8a63f25cc62965f1)), order = (0, $e198628b7fa6e29c$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}


function $1e5ebec8ad49b204$export$2e2bcd8739ae039(series) {
    return (0, $4edcea54ce45e1e9$export$2e2bcd8739ae039)(series).reverse();
}



var $f46ddf93f25a113e$var$t0 = new Date, $f46ddf93f25a113e$var$t1 = new Date;
function $f46ddf93f25a113e$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $f46ddf93f25a113e$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $f46ddf93f25a113e$var$t0.setTime(+start), $f46ddf93f25a113e$var$t1.setTime(+end);
            floori($f46ddf93f25a113e$var$t0), floori($f46ddf93f25a113e$var$t1);
            return Math.floor(count($f46ddf93f25a113e$var$t0, $f46ddf93f25a113e$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


var $dcc93f619686d410$export$79ef0e34099623dc = 1e3;
var $dcc93f619686d410$export$683905d551c33fa9 = 6e4;
var $dcc93f619686d410$export$4157bf0c8e241659 = 36e5;
var $dcc93f619686d410$export$353686095f4fbf45 = 864e5;
var $dcc93f619686d410$export$c241eb88520d5016 = 6048e5;


var $f9bfc74b1f2f6f8a$var$day = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dcc93f619686d410$export$683905d551c33fa9)) / (0, $dcc93f619686d410$export$353686095f4fbf45);
}, function(date) {
    return date.getDate() - 1;
});
var $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039 = $f9bfc74b1f2f6f8a$var$day;
var $f9bfc74b1f2f6f8a$export$3cf5dda4201cc0f2 = $f9bfc74b1f2f6f8a$var$day.range;



function $ed25e5cb4307b03a$var$weekday(i) {
    return (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dcc93f619686d410$export$683905d551c33fa9)) / (0, $dcc93f619686d410$export$c241eb88520d5016);
    });
}
var $ed25e5cb4307b03a$export$fb3ee18ed410cc21 = $ed25e5cb4307b03a$var$weekday(0);
var $ed25e5cb4307b03a$export$6416afaab03bc9b8 = $ed25e5cb4307b03a$var$weekday(1);
var $ed25e5cb4307b03a$export$cb8f040f5d17ac7b = $ed25e5cb4307b03a$var$weekday(2);
var $ed25e5cb4307b03a$export$347581849975dfc8 = $ed25e5cb4307b03a$var$weekday(3);
var $ed25e5cb4307b03a$export$2f2b56683a3e5629 = $ed25e5cb4307b03a$var$weekday(4);
var $ed25e5cb4307b03a$export$59b8c2ccd931d806 = $ed25e5cb4307b03a$var$weekday(5);
var $ed25e5cb4307b03a$export$478ceadebff4d377 = $ed25e5cb4307b03a$var$weekday(6);
var $ed25e5cb4307b03a$export$e8daabaa40641211 = $ed25e5cb4307b03a$export$fb3ee18ed410cc21.range;
var $ed25e5cb4307b03a$export$74e5b559c235c00e = $ed25e5cb4307b03a$export$6416afaab03bc9b8.range;
var $ed25e5cb4307b03a$export$e7d6aa4fb107bc56 = $ed25e5cb4307b03a$export$cb8f040f5d17ac7b.range;
var $ed25e5cb4307b03a$export$fcd5880b20bb06a8 = $ed25e5cb4307b03a$export$347581849975dfc8.range;
var $ed25e5cb4307b03a$export$682716b7bbe33641 = $ed25e5cb4307b03a$export$2f2b56683a3e5629.range;
var $ed25e5cb4307b03a$export$482924968ca86084 = $ed25e5cb4307b03a$export$59b8c2ccd931d806.range;
var $ed25e5cb4307b03a$export$7d755172c9cda9d2 = $ed25e5cb4307b03a$export$478ceadebff4d377.range;


var $c352773cb286f235$var$year = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$c352773cb286f235$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $c352773cb286f235$export$2e2bcd8739ae039 = $c352773cb286f235$var$year;
var $c352773cb286f235$export$6fda41c7fb23acf9 = $c352773cb286f235$var$year.range;



var $6c634b9d3e4c05fe$var$utcDay = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $dcc93f619686d410$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $6c634b9d3e4c05fe$export$2e2bcd8739ae039 = $6c634b9d3e4c05fe$var$utcDay;
var $6c634b9d3e4c05fe$export$d277e198508549a1 = $6c634b9d3e4c05fe$var$utcDay.range;



function $24ffb3b67dc2c085$var$utcWeekday(i) {
    return (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $dcc93f619686d410$export$c241eb88520d5016);
    });
}
var $24ffb3b67dc2c085$export$4898b06303a92011 = $24ffb3b67dc2c085$var$utcWeekday(0);
var $24ffb3b67dc2c085$export$9cfc53b9cfafd080 = $24ffb3b67dc2c085$var$utcWeekday(1);
var $24ffb3b67dc2c085$export$2a6d545f77eceb15 = $24ffb3b67dc2c085$var$utcWeekday(2);
var $24ffb3b67dc2c085$export$a5c25d8ed64433c4 = $24ffb3b67dc2c085$var$utcWeekday(3);
var $24ffb3b67dc2c085$export$1db08111baec2f53 = $24ffb3b67dc2c085$var$utcWeekday(4);
var $24ffb3b67dc2c085$export$29265e34dd5921f7 = $24ffb3b67dc2c085$var$utcWeekday(5);
var $24ffb3b67dc2c085$export$85b74dad05049604 = $24ffb3b67dc2c085$var$utcWeekday(6);
var $24ffb3b67dc2c085$export$6f3e1c2b0f7d7880 = $24ffb3b67dc2c085$export$4898b06303a92011.range;
var $24ffb3b67dc2c085$export$1d2d8b858bb366f9 = $24ffb3b67dc2c085$export$9cfc53b9cfafd080.range;
var $24ffb3b67dc2c085$export$1d5f6785fc7f30f8 = $24ffb3b67dc2c085$export$2a6d545f77eceb15.range;
var $24ffb3b67dc2c085$export$7a75faf0e37ef4af = $24ffb3b67dc2c085$export$a5c25d8ed64433c4.range;
var $24ffb3b67dc2c085$export$417eb959611b2f2f = $24ffb3b67dc2c085$export$1db08111baec2f53.range;
var $24ffb3b67dc2c085$export$59d308db7af08c64 = $24ffb3b67dc2c085$export$29265e34dd5921f7.range;
var $24ffb3b67dc2c085$export$a124108a0a7f34c8 = $24ffb3b67dc2c085$export$85b74dad05049604.range;


var $f493836e09c314f1$var$utcYear = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$f493836e09c314f1$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $f493836e09c314f1$export$2e2bcd8739ae039 = $f493836e09c314f1$var$utcYear;
var $f493836e09c314f1$export$3e24d311e17f5802 = $f493836e09c314f1$var$utcYear.range;


function $18c99194dde505b2$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $18c99194dde505b2$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $18c99194dde505b2$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $18c99194dde505b2$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $18c99194dde505b2$var$formatRe(locale_periods), periodLookup = $18c99194dde505b2$var$formatLookup(locale_periods), weekdayRe = $18c99194dde505b2$var$formatRe(locale_weekdays), weekdayLookup = $18c99194dde505b2$var$formatLookup(locale_weekdays), shortWeekdayRe = $18c99194dde505b2$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $18c99194dde505b2$var$formatLookup(locale_shortWeekdays), monthRe = $18c99194dde505b2$var$formatRe(locale_months), monthLookup = $18c99194dde505b2$var$formatLookup(locale_months), shortMonthRe = $18c99194dde505b2$var$formatRe(locale_shortMonths), shortMonthLookup = $18c99194dde505b2$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $18c99194dde505b2$var$formatDayOfMonth,
        "e": $18c99194dde505b2$var$formatDayOfMonth,
        "f": $18c99194dde505b2$var$formatMicroseconds,
        "g": $18c99194dde505b2$var$formatYearISO,
        "G": $18c99194dde505b2$var$formatFullYearISO,
        "H": $18c99194dde505b2$var$formatHour24,
        "I": $18c99194dde505b2$var$formatHour12,
        "j": $18c99194dde505b2$var$formatDayOfYear,
        "L": $18c99194dde505b2$var$formatMilliseconds,
        "m": $18c99194dde505b2$var$formatMonthNumber,
        "M": $18c99194dde505b2$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $18c99194dde505b2$var$formatUnixTimestamp,
        "s": $18c99194dde505b2$var$formatUnixTimestampSeconds,
        "S": $18c99194dde505b2$var$formatSeconds,
        "u": $18c99194dde505b2$var$formatWeekdayNumberMonday,
        "U": $18c99194dde505b2$var$formatWeekNumberSunday,
        "V": $18c99194dde505b2$var$formatWeekNumberISO,
        "w": $18c99194dde505b2$var$formatWeekdayNumberSunday,
        "W": $18c99194dde505b2$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $18c99194dde505b2$var$formatYear,
        "Y": $18c99194dde505b2$var$formatFullYear,
        "Z": $18c99194dde505b2$var$formatZone,
        "%": $18c99194dde505b2$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $18c99194dde505b2$var$formatUTCDayOfMonth,
        "e": $18c99194dde505b2$var$formatUTCDayOfMonth,
        "f": $18c99194dde505b2$var$formatUTCMicroseconds,
        "g": $18c99194dde505b2$var$formatUTCYearISO,
        "G": $18c99194dde505b2$var$formatUTCFullYearISO,
        "H": $18c99194dde505b2$var$formatUTCHour24,
        "I": $18c99194dde505b2$var$formatUTCHour12,
        "j": $18c99194dde505b2$var$formatUTCDayOfYear,
        "L": $18c99194dde505b2$var$formatUTCMilliseconds,
        "m": $18c99194dde505b2$var$formatUTCMonthNumber,
        "M": $18c99194dde505b2$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $18c99194dde505b2$var$formatUnixTimestamp,
        "s": $18c99194dde505b2$var$formatUnixTimestampSeconds,
        "S": $18c99194dde505b2$var$formatUTCSeconds,
        "u": $18c99194dde505b2$var$formatUTCWeekdayNumberMonday,
        "U": $18c99194dde505b2$var$formatUTCWeekNumberSunday,
        "V": $18c99194dde505b2$var$formatUTCWeekNumberISO,
        "w": $18c99194dde505b2$var$formatUTCWeekdayNumberSunday,
        "W": $18c99194dde505b2$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $18c99194dde505b2$var$formatUTCYear,
        "Y": $18c99194dde505b2$var$formatUTCFullYear,
        "Z": $18c99194dde505b2$var$formatUTCZone,
        "%": $18c99194dde505b2$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $18c99194dde505b2$var$parseDayOfMonth,
        "e": $18c99194dde505b2$var$parseDayOfMonth,
        "f": $18c99194dde505b2$var$parseMicroseconds,
        "g": $18c99194dde505b2$var$parseYear,
        "G": $18c99194dde505b2$var$parseFullYear,
        "H": $18c99194dde505b2$var$parseHour24,
        "I": $18c99194dde505b2$var$parseHour24,
        "j": $18c99194dde505b2$var$parseDayOfYear,
        "L": $18c99194dde505b2$var$parseMilliseconds,
        "m": $18c99194dde505b2$var$parseMonthNumber,
        "M": $18c99194dde505b2$var$parseMinutes,
        "p": parsePeriod,
        "q": $18c99194dde505b2$var$parseQuarter,
        "Q": $18c99194dde505b2$var$parseUnixTimestamp,
        "s": $18c99194dde505b2$var$parseUnixTimestampSeconds,
        "S": $18c99194dde505b2$var$parseSeconds,
        "u": $18c99194dde505b2$var$parseWeekdayNumberMonday,
        "U": $18c99194dde505b2$var$parseWeekNumberSunday,
        "V": $18c99194dde505b2$var$parseWeekNumberISO,
        "w": $18c99194dde505b2$var$parseWeekdayNumberSunday,
        "W": $18c99194dde505b2$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $18c99194dde505b2$var$parseYear,
        "Y": $18c99194dde505b2$var$parseFullYear,
        "Z": $18c99194dde505b2$var$parseZone,
        "%": $18c99194dde505b2$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $18c99194dde505b2$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $18c99194dde505b2$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $18c99194dde505b2$var$utcDate($18c99194dde505b2$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).ceil(week) : (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)(week);
                    week = (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $18c99194dde505b2$var$localDate($18c99194dde505b2$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).ceil(week) : (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8)(week);
                    week = (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $18c99194dde505b2$var$utcDate($18c99194dde505b2$var$newDate(d.y, 0, 1)).getUTCDay() : $18c99194dde505b2$var$localDate($18c99194dde505b2$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $18c99194dde505b2$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $18c99194dde505b2$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $18c99194dde505b2$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $18c99194dde505b2$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $18c99194dde505b2$var$numberRe = /^\s*\d+/, $18c99194dde505b2$var$percentRe = /^%/, $18c99194dde505b2$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $18c99194dde505b2$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $18c99194dde505b2$var$requote(s) {
    return s.replace($18c99194dde505b2$var$requoteRe, "\\$&");
}
function $18c99194dde505b2$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($18c99194dde505b2$var$requote).join("|") + ")", "i");
}
function $18c99194dde505b2$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $18c99194dde505b2$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseWeekNumberSunday(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseWeekNumberISO(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseWeekNumberMonday(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseFullYear(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseYear(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseQuarter(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseMonthNumber(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseDayOfMonth(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseDayOfYear(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseHour24(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseMinutes(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseSeconds(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseMilliseconds(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseMicroseconds(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseLiteralPercent(d, string, i) {
    var n = $18c99194dde505b2$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $18c99194dde505b2$var$parseUnixTimestamp(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $18c99194dde505b2$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $18c99194dde505b2$var$formatDayOfMonth(d, p) {
    return $18c99194dde505b2$var$pad(d.getDate(), p, 2);
}
function $18c99194dde505b2$var$formatHour24(d, p) {
    return $18c99194dde505b2$var$pad(d.getHours(), p, 2);
}
function $18c99194dde505b2$var$formatHour12(d, p) {
    return $18c99194dde505b2$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $18c99194dde505b2$var$formatDayOfYear(d, p) {
    return $18c99194dde505b2$var$pad(1 + (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $18c99194dde505b2$var$formatMilliseconds(d, p) {
    return $18c99194dde505b2$var$pad(d.getMilliseconds(), p, 3);
}
function $18c99194dde505b2$var$formatMicroseconds(d, p) {
    return $18c99194dde505b2$var$formatMilliseconds(d, p) + "000";
}
function $18c99194dde505b2$var$formatMonthNumber(d, p) {
    return $18c99194dde505b2$var$pad(d.getMonth() + 1, p, 2);
}
function $18c99194dde505b2$var$formatMinutes(d, p) {
    return $18c99194dde505b2$var$pad(d.getMinutes(), p, 2);
}
function $18c99194dde505b2$var$formatSeconds(d, p) {
    return $18c99194dde505b2$var$pad(d.getSeconds(), p, 2);
}
function $18c99194dde505b2$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $18c99194dde505b2$var$formatWeekNumberSunday(d, p) {
    return $18c99194dde505b2$var$pad((0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $18c99194dde505b2$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
}
function $18c99194dde505b2$var$formatWeekNumberISO(d, p) {
    d = $18c99194dde505b2$var$dISO(d);
    return $18c99194dde505b2$var$pad((0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d) + ((0, $c352773cb286f235$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $18c99194dde505b2$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $18c99194dde505b2$var$formatWeekNumberMonday(d, p) {
    return $18c99194dde505b2$var$pad((0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $18c99194dde505b2$var$formatYear(d, p) {
    return $18c99194dde505b2$var$pad(d.getFullYear() % 100, p, 2);
}
function $18c99194dde505b2$var$formatYearISO(d, p) {
    d = $18c99194dde505b2$var$dISO(d);
    return $18c99194dde505b2$var$pad(d.getFullYear() % 100, p, 2);
}
function $18c99194dde505b2$var$formatFullYear(d, p) {
    return $18c99194dde505b2$var$pad(d.getFullYear() % 10000, p, 4);
}
function $18c99194dde505b2$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
    return $18c99194dde505b2$var$pad(d.getFullYear() % 10000, p, 4);
}
function $18c99194dde505b2$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $18c99194dde505b2$var$pad(z / 60 | 0, "0", 2) + $18c99194dde505b2$var$pad(z % 60, "0", 2);
}
function $18c99194dde505b2$var$formatUTCDayOfMonth(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCDate(), p, 2);
}
function $18c99194dde505b2$var$formatUTCHour24(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCHours(), p, 2);
}
function $18c99194dde505b2$var$formatUTCHour12(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $18c99194dde505b2$var$formatUTCDayOfYear(d, p) {
    return $18c99194dde505b2$var$pad(1 + (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $18c99194dde505b2$var$formatUTCMilliseconds(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $18c99194dde505b2$var$formatUTCMicroseconds(d, p) {
    return $18c99194dde505b2$var$formatUTCMilliseconds(d, p) + "000";
}
function $18c99194dde505b2$var$formatUTCMonthNumber(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $18c99194dde505b2$var$formatUTCMinutes(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCMinutes(), p, 2);
}
function $18c99194dde505b2$var$formatUTCSeconds(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCSeconds(), p, 2);
}
function $18c99194dde505b2$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $18c99194dde505b2$var$formatUTCWeekNumberSunday(d, p) {
    return $18c99194dde505b2$var$pad((0, $24ffb3b67dc2c085$export$4898b06303a92011).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $18c99194dde505b2$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
}
function $18c99194dde505b2$var$formatUTCWeekNumberISO(d, p) {
    d = $18c99194dde505b2$var$UTCdISO(d);
    return $18c99194dde505b2$var$pad((0, $24ffb3b67dc2c085$export$1db08111baec2f53).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d) + ((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $18c99194dde505b2$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $18c99194dde505b2$var$formatUTCWeekNumberMonday(d, p) {
    return $18c99194dde505b2$var$pad((0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $18c99194dde505b2$var$formatUTCYear(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $18c99194dde505b2$var$formatUTCYearISO(d, p) {
    d = $18c99194dde505b2$var$UTCdISO(d);
    return $18c99194dde505b2$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $18c99194dde505b2$var$formatUTCFullYear(d, p) {
    return $18c99194dde505b2$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $18c99194dde505b2$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
    return $18c99194dde505b2$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $18c99194dde505b2$var$formatUTCZone() {
    return "+0000";
}
function $18c99194dde505b2$var$formatLiteralPercent() {
    return "%";
}
function $18c99194dde505b2$var$formatUnixTimestamp(d) {
    return +d;
}
function $18c99194dde505b2$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $3fa0d48148b775ea$var$locale;
var $3fa0d48148b775ea$export$94f4d87fad5dcf9a;
var $3fa0d48148b775ea$export$32b9cd16e1b8c8d2;
var $3fa0d48148b775ea$export$1a08fe38f63ebbbb;
var $3fa0d48148b775ea$export$3edae9cf8e233729;
$3fa0d48148b775ea$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $3fa0d48148b775ea$export$2e2bcd8739ae039(definition) {
    $3fa0d48148b775ea$var$locale = (0, $18c99194dde505b2$export$2e2bcd8739ae039)(definition);
    $3fa0d48148b775ea$export$94f4d87fad5dcf9a = $3fa0d48148b775ea$var$locale.format;
    $3fa0d48148b775ea$export$32b9cd16e1b8c8d2 = $3fa0d48148b775ea$var$locale.parse;
    $3fa0d48148b775ea$export$1a08fe38f63ebbbb = $3fa0d48148b775ea$var$locale.utcFormat;
    $3fa0d48148b775ea$export$3edae9cf8e233729 = $3fa0d48148b775ea$var$locale.utcParse;
    return $3fa0d48148b775ea$var$locale;
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $bd136de90080c1b8$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $bd136de90080c1b8$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $bd136de90080c1b8$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$bd136de90080c1b8$var$componentWillMount.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $bd136de90080c1b8$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $bd136de90080c1b8$var$componentWillMount;
        prototype.componentWillReceiveProps = $bd136de90080c1b8$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $bd136de90080c1b8$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


var $94d5cdcf6924d946$export$be63e0664592e141 = function(t) {
    return "string" == typeof t ? t : t ? t.displayName || t.name || "Component" : void 0;
}, $94d5cdcf6924d946$export$b7c688f26e0b9b7c = function(t, r) {
    return function(n) {
        return n[t] = r, n;
    };
}, $94d5cdcf6924d946$export$ce7d0f83c324f6cf = function(t) {
    return $94d5cdcf6924d946$export$b7c688f26e0b9b7c("displayName", t);
}, $94d5cdcf6924d946$var$p = Object.prototype.hasOwnProperty;
function $94d5cdcf6924d946$var$c(t, r) {
    return t === r ? 0 !== t || 0 !== r || 1 / t == 1 / r : t != t && r != r;
}
function $94d5cdcf6924d946$export$d36bdfa510afb180(t, r) {
    if ($94d5cdcf6924d946$var$c(t, r)) return !0;
    if ("object" != typeof t || null === t || "object" != typeof r || null === r) return !1;
    var n = Object.keys(t), e = Object.keys(r);
    if (n.length !== e.length) return !1;
    for(var o = 0; o < n.length; o++)if (!$94d5cdcf6924d946$var$p.call(r, n[o]) || !$94d5cdcf6924d946$var$c(t[n[o]], r[n[o]])) return !1;
    return !0;
}
function $94d5cdcf6924d946$var$a() {
    return $94d5cdcf6924d946$var$a = Object.assign || function(t) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var e in n)Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
        }
        return t;
    }, $94d5cdcf6924d946$var$a.apply(this, arguments);
}
function $94d5cdcf6924d946$var$f(t, r) {
    t.prototype = Object.create(r.prototype), t.prototype.constructor = t, $94d5cdcf6924d946$var$s(t, r);
}
function $94d5cdcf6924d946$var$s(t, r) {
    return $94d5cdcf6924d946$var$s = Object.setPrototypeOf || function(t, r) {
        return t.__proto__ = r, t;
    }, $94d5cdcf6924d946$var$s(t, r);
}
var $94d5cdcf6924d946$export$234d6aee19c01743 = function(t, r) {
    return r + "(" + $94d5cdcf6924d946$export$be63e0664592e141(t) + ")";
}, $94d5cdcf6924d946$export$ea8391e230935df = function(n) {
    return function(e) {
        var o = (0, $7fPBF.createFactory)(e), p = function(t) {
            function r() {
                return t.apply(this, arguments) || this;
            }
            $94d5cdcf6924d946$var$f(r, t);
            var e = r.prototype;
            return e.shouldComponentUpdate = function(t) {
                return n(this.props, t);
            }, e.render = function() {
                return o(this.props);
            }, r;
        }((0, $7fPBF.Component));
        return p;
    };
}, $94d5cdcf6924d946$export$48ec4a2b1cfc6557 = function(t) {
    var r = $94d5cdcf6924d946$export$ea8391e230935df(function(t, r) {
        return !$94d5cdcf6924d946$export$d36bdfa510afb180(t, r);
    });
    return r(t);
}, $94d5cdcf6924d946$export$f672e0b6f7222cd7 = function() {
    for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
    return r.reduce(function(t, r) {
        return function() {
            return t(r.apply(void 0, arguments));
        };
    }, function(t) {
        return t;
    });
}, $94d5cdcf6924d946$var$d = function(t, r) {
    for(var n = {}, e = 0; e < r.length; e++){
        var o = r[e];
        t.hasOwnProperty(o) && (n[o] = t[o]);
    }
    return n;
}, $94d5cdcf6924d946$export$6bb05b1ab09a4158 = function(e, o) {
    return function(p) {
        var c = (0, $7fPBF.createFactory)(p), s = "function" == typeof e ? e : function(t, r) {
            return !$94d5cdcf6924d946$export$d36bdfa510afb180($94d5cdcf6924d946$var$d(t, e), $94d5cdcf6924d946$var$d(r, e));
        }, v = function(t) {
            function r() {
                for(var r, n = arguments.length, e = new Array(n), u = 0; u < n; u++)e[u] = arguments[u];
                return (r = t.call.apply(t, [
                    this
                ].concat(e)) || this).state = {
                    computedProps: o(r.props),
                    prevProps: r.props
                }, r;
            }
            return $94d5cdcf6924d946$var$f(r, t), r.getDerivedStateFromProps = function(t, r) {
                return s(r.prevProps, t) ? {
                    computedProps: o(t),
                    prevProps: t
                } : {
                    prevProps: t
                };
            }, r.prototype.render = function() {
                return c($94d5cdcf6924d946$var$a({}, this.props, this.state.computedProps));
            }, r;
        }((0, $7fPBF.Component));
        return (0, $bd136de90080c1b8$export$cea1c58a6db52bca)(v), v;
    };
}, $94d5cdcf6924d946$export$9c21a3269931e1e6 = function(r) {
    return function(n) {
        var e = (0, $7fPBF.createFactory)(n), o = function(t) {
            return e(t);
        };
        return o.defaultProps = r, o;
    };
}, $94d5cdcf6924d946$export$19c55c6cefb3b57 = function(r) {
    var n, e = (n = function(t) {
        return $94d5cdcf6924d946$var$a({}, t, "function" == typeof r ? r(t) : r);
    }, function(r) {
        var e = (0, $7fPBF.createFactory)(r), o = function(t) {
            return e(n(t));
        };
        return o;
    });
    return e;
}, $94d5cdcf6924d946$export$3f05a82d2bb032cc = function(t) {
    return $94d5cdcf6924d946$export$b7c688f26e0b9b7c("propTypes", t);
}, $94d5cdcf6924d946$export$29d22fcef0a54f1b = function(n, e, o) {
    return function(p) {
        var c = (0, $7fPBF.createFactory)(p), i = function(t) {
            function r() {
                for(var r, n = arguments.length, e = new Array(n), u = 0; u < n; u++)e[u] = arguments[u];
                return (r = t.call.apply(t, [
                    this
                ].concat(e)) || this).state = {
                    stateValue: "function" == typeof o ? o(r.props) : o
                }, r.updateStateValue = function(t, n) {
                    return r.setState(function(r) {
                        var n = r.stateValue;
                        return {
                            stateValue: "function" == typeof t ? t(n) : t
                        };
                    }, n);
                }, r;
            }
            return $94d5cdcf6924d946$var$f(r, t), r.prototype.render = function() {
                var t;
                return c($94d5cdcf6924d946$var$a({}, this.props, ((t = {})[n] = this.state.stateValue, t[e] = this.updateStateValue, t)));
            }, r;
        }((0, $7fPBF.Component));
        return i;
    };
};


var $034d80e6a88ef527$exports = {};
var $7c952302caee51c1$exports = {};
var $c633adf42a0b7174$exports = {};

var $1443c170489acf32$exports = {};

var $c264d15e7c8deb78$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c264d15e7c8deb78$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c264d15e7c8deb78$exports = $c264d15e7c8deb78$var$arraySome;



/** Used to compose bitmasks for value comparisons. */ var $1443c170489acf32$var$COMPARE_PARTIAL_FLAG = 1, $1443c170489acf32$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1443c170489acf32$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1443c170489acf32$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1443c170489acf32$var$COMPARE_UNORDERED_FLAG ? new $7d2f3a0d9ce14f26$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c264d15e7c8deb78$exports(other, function(othValue, othIndex) {
                if (!$601e4ed5362647b9$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$1443c170489acf32$exports = $1443c170489acf32$var$equalArrays;


var $31649b4ecd936387$exports = {};




var $29990a2aa372abaa$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $29990a2aa372abaa$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$29990a2aa372abaa$exports = $29990a2aa372abaa$var$mapToArray;


var $edfe5dc5ee94a646$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $edfe5dc5ee94a646$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$edfe5dc5ee94a646$exports = $edfe5dc5ee94a646$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG = 1, $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $31649b4ecd936387$var$boolTag = "[object Boolean]", $31649b4ecd936387$var$dateTag = "[object Date]", $31649b4ecd936387$var$errorTag = "[object Error]", $31649b4ecd936387$var$mapTag = "[object Map]", $31649b4ecd936387$var$numberTag = "[object Number]", $31649b4ecd936387$var$regexpTag = "[object RegExp]", $31649b4ecd936387$var$setTag = "[object Set]", $31649b4ecd936387$var$stringTag = "[object String]", $31649b4ecd936387$var$symbolTag = "[object Symbol]";
var $31649b4ecd936387$var$arrayBufferTag = "[object ArrayBuffer]", $31649b4ecd936387$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $31649b4ecd936387$var$symbolProto = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.prototype : undefined, $31649b4ecd936387$var$symbolValueOf = $31649b4ecd936387$var$symbolProto ? $31649b4ecd936387$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $31649b4ecd936387$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $31649b4ecd936387$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $31649b4ecd936387$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $82ae00c827cb4de5$exports(object), new $82ae00c827cb4de5$exports(other))) return false;
            return true;
        case $31649b4ecd936387$var$boolTag:
        case $31649b4ecd936387$var$dateTag:
        case $31649b4ecd936387$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $881bebc960934ade$exports(+object, +other);
        case $31649b4ecd936387$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $31649b4ecd936387$var$regexpTag:
        case $31649b4ecd936387$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $31649b4ecd936387$var$mapTag:
            var convert = $29990a2aa372abaa$exports;
        case $31649b4ecd936387$var$setTag:
            var isPartial = bitmask & $31649b4ecd936387$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $edfe5dc5ee94a646$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $31649b4ecd936387$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1443c170489acf32$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $31649b4ecd936387$var$symbolTag:
            if ($31649b4ecd936387$var$symbolValueOf) return $31649b4ecd936387$var$symbolValueOf.call(object) == $31649b4ecd936387$var$symbolValueOf.call(other);
    }
    return false;
}
$31649b4ecd936387$exports = $31649b4ecd936387$var$equalByTag;


var $f7bae1035bea0715$exports = {};
var $b43254fda44c104a$exports = {};
var $5b332bf09b0c6ec2$exports = {};
var $efe685e6768936ef$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $efe685e6768936ef$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$efe685e6768936ef$exports = $efe685e6768936ef$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5b332bf09b0c6ec2$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $579b9ba2588bb9de$exports(object) ? result : $efe685e6768936ef$exports(result, symbolsFunc(object));
}
$5b332bf09b0c6ec2$exports = $5b332bf09b0c6ec2$var$baseGetAllKeys;


var $f7bf8d1519698205$exports = {};
var $d53366b2ff590363$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $d53366b2ff590363$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$d53366b2ff590363$exports = $d53366b2ff590363$var$arrayFilter;


var $fd38b0983d4c349d$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $fd38b0983d4c349d$var$stubArray() {
    return [];
}
$fd38b0983d4c349d$exports = $fd38b0983d4c349d$var$stubArray;


/** Used for built-in method references. */ var $f7bf8d1519698205$var$objectProto = Object.prototype;
/** Built-in value references. */ var $f7bf8d1519698205$var$propertyIsEnumerable = $f7bf8d1519698205$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f7bf8d1519698205$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $f7bf8d1519698205$var$getSymbols = !$f7bf8d1519698205$var$nativeGetSymbols ? $fd38b0983d4c349d$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $d53366b2ff590363$exports($f7bf8d1519698205$var$nativeGetSymbols(object), function(symbol) {
        return $f7bf8d1519698205$var$propertyIsEnumerable.call(object, symbol);
    });
};
$f7bf8d1519698205$exports = $f7bf8d1519698205$var$getSymbols;


var $0fce4239ee480ef0$exports = {};

var $bdfe3da66489f7d9$exports = {};

var $220737c9fb125768$exports = {};

/* Built-in method references for those with the same name as other `lodash` methods. */ var $220737c9fb125768$var$nativeKeys = $fdcd49ef52ce3234$exports(Object.keys, Object);
$220737c9fb125768$exports = $220737c9fb125768$var$nativeKeys;


/** Used for built-in method references. */ var $bdfe3da66489f7d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdfe3da66489f7d9$var$hasOwnProperty = $bdfe3da66489f7d9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bdfe3da66489f7d9$var$baseKeys(object) {
    if (!$b56b06902d83e6f4$exports(object)) return $220737c9fb125768$exports(object);
    var result = [];
    for(var key in Object(object))if ($bdfe3da66489f7d9$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$bdfe3da66489f7d9$exports = $bdfe3da66489f7d9$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0fce4239ee480ef0$var$keys(object) {
    return $4506257970d5c979$exports(object) ? $14f0cee26f6289b7$exports(object) : $bdfe3da66489f7d9$exports(object);
}
$0fce4239ee480ef0$exports = $0fce4239ee480ef0$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $b43254fda44c104a$var$getAllKeys(object) {
    return $5b332bf09b0c6ec2$exports(object, $0fce4239ee480ef0$exports, $f7bf8d1519698205$exports);
}
$b43254fda44c104a$exports = $b43254fda44c104a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f7bae1035bea0715$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7bae1035bea0715$var$hasOwnProperty = $f7bae1035bea0715$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f7bae1035bea0715$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f7bae1035bea0715$var$COMPARE_PARTIAL_FLAG, objProps = $b43254fda44c104a$exports(object), objLength = objProps.length, othProps = $b43254fda44c104a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f7bae1035bea0715$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$f7bae1035bea0715$exports = $f7bae1035bea0715$var$equalObjects;


var $288c148fae7027f4$exports = {};
var $4e72a091824b54c2$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $4e72a091824b54c2$var$DataView = $95eb055fdd27d869$exports($1DySm, "DataView");
$4e72a091824b54c2$exports = $4e72a091824b54c2$var$DataView;



var $c7bc43de39f545d4$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $c7bc43de39f545d4$var$Promise = $95eb055fdd27d869$exports($1DySm, "Promise");
$c7bc43de39f545d4$exports = $c7bc43de39f545d4$var$Promise;


var $2a4786f2dfc898c9$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $2a4786f2dfc898c9$var$Set = $95eb055fdd27d869$exports($1DySm, "Set");
$2a4786f2dfc898c9$exports = $2a4786f2dfc898c9$var$Set;


var $e262a6fad30144cf$exports = {};


var $1DySm = parcelRequire("1DySm");
/* Built-in method references that are verified to be native. */ var $e262a6fad30144cf$var$WeakMap = $95eb055fdd27d869$exports($1DySm, "WeakMap");
$e262a6fad30144cf$exports = $e262a6fad30144cf$var$WeakMap;




/** `Object#toString` result references. */ var $288c148fae7027f4$var$mapTag = "[object Map]", $288c148fae7027f4$var$objectTag = "[object Object]", $288c148fae7027f4$var$promiseTag = "[object Promise]", $288c148fae7027f4$var$setTag = "[object Set]", $288c148fae7027f4$var$weakMapTag = "[object WeakMap]";
var $288c148fae7027f4$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $288c148fae7027f4$var$dataViewCtorString = $f4933d7f0a06eb7d$exports($4e72a091824b54c2$exports), $288c148fae7027f4$var$mapCtorString = $f4933d7f0a06eb7d$exports($3b45073a9f2f1273$exports), $288c148fae7027f4$var$promiseCtorString = $f4933d7f0a06eb7d$exports($c7bc43de39f545d4$exports), $288c148fae7027f4$var$setCtorString = $f4933d7f0a06eb7d$exports($2a4786f2dfc898c9$exports), $288c148fae7027f4$var$weakMapCtorString = $f4933d7f0a06eb7d$exports($e262a6fad30144cf$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $288c148fae7027f4$var$getTag = $ae3fe6c5950c122e$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($4e72a091824b54c2$exports && $288c148fae7027f4$var$getTag(new $4e72a091824b54c2$exports(new ArrayBuffer(1))) != $288c148fae7027f4$var$dataViewTag || $3b45073a9f2f1273$exports && $288c148fae7027f4$var$getTag(new $3b45073a9f2f1273$exports) != $288c148fae7027f4$var$mapTag || $c7bc43de39f545d4$exports && $288c148fae7027f4$var$getTag($c7bc43de39f545d4$exports.resolve()) != $288c148fae7027f4$var$promiseTag || $2a4786f2dfc898c9$exports && $288c148fae7027f4$var$getTag(new $2a4786f2dfc898c9$exports) != $288c148fae7027f4$var$setTag || $e262a6fad30144cf$exports && $288c148fae7027f4$var$getTag(new $e262a6fad30144cf$exports) != $288c148fae7027f4$var$weakMapTag) $288c148fae7027f4$var$getTag = function(value) {
    var result = $ae3fe6c5950c122e$exports(value), Ctor = result == $288c148fae7027f4$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $f4933d7f0a06eb7d$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $288c148fae7027f4$var$dataViewCtorString:
            return $288c148fae7027f4$var$dataViewTag;
        case $288c148fae7027f4$var$mapCtorString:
            return $288c148fae7027f4$var$mapTag;
        case $288c148fae7027f4$var$promiseCtorString:
            return $288c148fae7027f4$var$promiseTag;
        case $288c148fae7027f4$var$setCtorString:
            return $288c148fae7027f4$var$setTag;
        case $288c148fae7027f4$var$weakMapCtorString:
            return $288c148fae7027f4$var$weakMapTag;
    }
    return result;
};
$288c148fae7027f4$exports = $288c148fae7027f4$var$getTag;




var $9gBlp = parcelRequire("9gBlp");

/** Used to compose bitmasks for value comparisons. */ var $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c633adf42a0b7174$var$argsTag = "[object Arguments]", $c633adf42a0b7174$var$arrayTag = "[object Array]", $c633adf42a0b7174$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c633adf42a0b7174$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c633adf42a0b7174$var$hasOwnProperty = $c633adf42a0b7174$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c633adf42a0b7174$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $579b9ba2588bb9de$exports(object), othIsArr = $579b9ba2588bb9de$exports(other), objTag = objIsArr ? $c633adf42a0b7174$var$arrayTag : $288c148fae7027f4$exports(object), othTag = othIsArr ? $c633adf42a0b7174$var$arrayTag : $288c148fae7027f4$exports(other);
    objTag = objTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : objTag;
    othTag = othTag == $c633adf42a0b7174$var$argsTag ? $c633adf42a0b7174$var$objectTag : othTag;
    var objIsObj = objTag == $c633adf42a0b7174$var$objectTag, othIsObj = othTag == $c633adf42a0b7174$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $9gBlp(object)) {
        if (!$9gBlp(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $75b9f8e835026959$exports);
        return objIsArr || $91935e2ee1691ad1$exports(object) ? $1443c170489acf32$exports(object, other, bitmask, customizer, equalFunc, stack) : $31649b4ecd936387$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c633adf42a0b7174$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c633adf42a0b7174$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $75b9f8e835026959$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $75b9f8e835026959$exports);
    return $f7bae1035bea0715$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c633adf42a0b7174$exports = $c633adf42a0b7174$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $7c952302caee51c1$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$97dbbc1a069ce16a$exports(value) && !$97dbbc1a069ce16a$exports(other)) return value !== value && other !== other;
    return $c633adf42a0b7174$exports(value, other, bitmask, customizer, $7c952302caee51c1$var$baseIsEqual, stack);
}
$7c952302caee51c1$exports = $7c952302caee51c1$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $034d80e6a88ef527$var$isEqual(value, other) {
    return $7c952302caee51c1$exports(value, other);
}
$034d80e6a88ef527$exports = $034d80e6a88ef527$var$isEqual;



var $c4b8aa507fc568ca$exports = {};
var $297742e3367c75f6$exports = {};
var $ed78d5d8c8a5f2ed$exports = {};



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $ed78d5d8c8a5f2ed$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $e913f1fcbff7147e$exports(object, path);
        if (predicate(value, path)) $a4ce95537effb69e$exports(result, $23e5d07d36d464f0$exports(path, object), value);
    }
    return result;
}
$ed78d5d8c8a5f2ed$exports = $ed78d5d8c8a5f2ed$var$basePickBy;


var $065767a6557522ec$exports = {};
var $f39b1c537d656d19$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f39b1c537d656d19$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$f39b1c537d656d19$exports = $f39b1c537d656d19$var$baseHasIn;


var $e115c865f83e382c$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $e115c865f83e382c$var$hasPath(object, path, hasFunc) {
    path = $23e5d07d36d464f0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $09a75ffd36bdbd18$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $13758fcec31fd7af$exports(length) && $a4ac18a3b008eabc$exports(key, length) && ($579b9ba2588bb9de$exports(object) || $4f4b95b8aefe4d77$exports(object));
}
$e115c865f83e382c$exports = $e115c865f83e382c$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $065767a6557522ec$var$hasIn(object, path) {
    return object != null && $e115c865f83e382c$exports(object, path, $f39b1c537d656d19$exports);
}
$065767a6557522ec$exports = $065767a6557522ec$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $297742e3367c75f6$var$basePick(object, paths) {
    return $ed78d5d8c8a5f2ed$exports(object, paths, function(value, path) {
        return $065767a6557522ec$exports(object, path);
    });
}
$297742e3367c75f6$exports = $297742e3367c75f6$var$basePick;


var $db84991f1e88e6f3$exports = {};
var $7d14839a974b02f5$exports = {};
var $df6466a12cae3866$exports = {};

var $2e55701aa5e08350$exports = {};



/** Built-in value references. */ var $2e55701aa5e08350$var$spreadableSymbol = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $2e55701aa5e08350$var$isFlattenable(value) {
    return $579b9ba2588bb9de$exports(value) || $4f4b95b8aefe4d77$exports(value) || !!($2e55701aa5e08350$var$spreadableSymbol && value && value[$2e55701aa5e08350$var$spreadableSymbol]);
}
$2e55701aa5e08350$exports = $2e55701aa5e08350$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $df6466a12cae3866$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $2e55701aa5e08350$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $df6466a12cae3866$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $efe685e6768936ef$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$df6466a12cae3866$exports = $df6466a12cae3866$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $7d14839a974b02f5$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $df6466a12cae3866$exports(array, 1) : [];
}
$7d14839a974b02f5$exports = $7d14839a974b02f5$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $db84991f1e88e6f3$var$flatRest(func) {
    return $e94006b0ead3bc9b$exports($edebe4cd16ce0339$exports(func, undefined, $7d14839a974b02f5$exports), func + "");
}
$db84991f1e88e6f3$exports = $db84991f1e88e6f3$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $c4b8aa507fc568ca$var$pick = $db84991f1e88e6f3$exports(function(object, paths) {
    return object == null ? {} : $297742e3367c75f6$exports(object, paths);
});
$c4b8aa507fc568ca$exports = $c4b8aa507fc568ca$var$pick;


function $0332e848e6fa2251$var$Gr() {
    return $0332e848e6fa2251$var$Gr = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
        return e;
    }, $0332e848e6fa2251$var$Gr.apply(this, arguments);
}
function $0332e848e6fa2251$var$Br(e, r) {
    return $0332e848e6fa2251$var$Br = Object.setPrototypeOf || function(e, r) {
        return e.__proto__ = r, e;
    }, $0332e848e6fa2251$var$Br(e, r);
}
function $0332e848e6fa2251$var$Lr(e, r) {
    if (null == e) return {};
    var t, i, n = {}, o = Object.keys(e);
    for(i = 0; i < o.length; i++)t = o[i], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
var $0332e848e6fa2251$var$Ir = {
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    fontFamily: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
}, $0332e848e6fa2251$export$7c9b9140cfc20fb9 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    domain: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        line: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            stroke: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
            strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
            strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
        }).isRequired
    }).isRequired,
    ticks: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        line: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            stroke: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
            strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
            strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
        }).isRequired,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir)).isRequired
    }).isRequired,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir)).isRequired
    }).isRequired
}), $0332e848e6fa2251$export$f4dacb01e3bec6aa = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    line: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }).isRequired
}), $0332e848e6fa2251$export$5ce02678e5a3589b = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            fill: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
            opacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
        }).isRequired,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir, {
            opacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
        })).isRequired
    }).isRequired,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir)).isRequired
}), $0332e848e6fa2251$export$6601ea7d14f6350c = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir)).isRequired
}), $0332e848e6fa2251$export$eb57deacafb972d4 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir)).isRequired
}), $0332e848e6fa2251$export$a02298887f2390f9 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir)).isRequired
}), $0332e848e6fa2251$export$6c764636cab0210b = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    line: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        strokeDasharray: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }).isRequired
}), $0332e848e6fa2251$export$fd4544ad90251680 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$var$Ir, {
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    })).isRequired,
    link: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }).isRequired,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        stroke: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        strokeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }).isRequired,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        fill: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        outlineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        outlineColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }).isRequired
}), $0332e848e6fa2251$export$5d9ef733eb1e744b = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    fontFamily: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    axis: $0332e848e6fa2251$export$7c9b9140cfc20fb9.isRequired,
    grid: $0332e848e6fa2251$export$f4dacb01e3bec6aa.isRequired,
    legends: $0332e848e6fa2251$export$5ce02678e5a3589b.isRequired,
    labels: $0332e848e6fa2251$export$6601ea7d14f6350c.isRequired,
    dots: $0332e848e6fa2251$export$eb57deacafb972d4.isRequired,
    markers: $0332e848e6fa2251$export$a02298887f2390f9,
    crosshair: $0332e848e6fa2251$export$6c764636cab0210b.isRequired,
    annotations: $0332e848e6fa2251$export$fd4544ad90251680.isRequired
}), $0332e848e6fa2251$export$164de7ab8df77ef0 = {
    background: "transparent",
    fontFamily: "sans-serif",
    fontSize: 11,
    textColor: "#333333",
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        hidden: {
            symbol: {
                fill: "#333333",
                opacity: .6
            },
            text: {
                fill: "#333333",
                opacity: .6
            }
        },
        text: {},
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {
                fontSize: 10
            }
        },
        title: {
            text: {}
        }
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        },
        tableCellValue: {
            fontWeight: "bold"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: .75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        }
    }
}, $0332e848e6fa2251$var$Jr = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.title.text",
    "legends.text",
    "legends.ticks.text",
    "legends.title.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
], $0332e848e6fa2251$export$582fa4e2a9b13dde = function(e, r) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($357f6a405ce5423a$exports)))({}, e, r);
    return $0332e848e6fa2251$var$Jr.forEach(function(e) {
        void 0 === (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(t, e + ".fontFamily") && (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(t, e + ".fontFamily", t.fontFamily), void 0 === (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(t, e + ".fontSize") && (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(t, e + ".fontSize", t.fontSize), void 0 === (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(t, e + ".fill") && (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(t, e + ".fill", t.textColor);
    }), t;
}, $0332e848e6fa2251$export$1855e60b4fae8997 = (0, $7fPBF.createContext)(), $0332e848e6fa2251$export$e9d875263f86dcb4 = function(e) {
    var t = e.children, i = e.animate, n = e.stiffness, o = e.damping, a = e.config, s = (0, $7fPBF.useMemo)(function() {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(a) ? (0, $27d73b36303119b6$export$e506a1d27d1eaa20)[a] : a;
        return {
            animate: i,
            springConfig: {
                stiffness: n,
                damping: o
            },
            config: e
        };
    }, [
        i,
        n,
        o,
        a
    ]);
    return (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$1855e60b4fae8997.Provider, {
        value: s,
        children: t
    });
}, $0332e848e6fa2251$export$99a092eaa44be1c8 = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    motionStiffness: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    motionDamping: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf(Object.keys((0, $27d73b36303119b6$export$e506a1d27d1eaa20))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            mass: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            tension: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            friction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            clamp: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
            precision: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            velocity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            duration: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            easing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
        })
    ])
};
$0332e848e6fa2251$export$e9d875263f86dcb4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    animate: $0332e848e6fa2251$export$99a092eaa44be1c8.animate,
    stiffness: $0332e848e6fa2251$export$99a092eaa44be1c8.motionStiffness,
    damping: $0332e848e6fa2251$export$99a092eaa44be1c8.motionDamping,
    config: $0332e848e6fa2251$export$99a092eaa44be1c8.motionConfig
};
var $0332e848e6fa2251$export$465303079ec41f9d = {
    animate: !0,
    stiffness: 90,
    damping: 15,
    config: "default"
};
$0332e848e6fa2251$export$e9d875263f86dcb4.defaultProps = $0332e848e6fa2251$export$465303079ec41f9d;
var $0332e848e6fa2251$export$72acc3dc9629d75d = function() {
    return (0, $7fPBF.useContext)($0332e848e6fa2251$export$1855e60b4fae8997);
}, $0332e848e6fa2251$export$6b8391a1442f2172 = function(e) {
    var t = $0332e848e6fa2251$export$72acc3dc9629d75d(), o = t.animate, a = t.config, s = function(e) {
        var r = (0, $7fPBF.useRef)();
        return (0, $7fPBF.useEffect)(function() {
            r.current = e;
        }, [
            e
        ]), r.current;
    }(e), l = (0, $7fPBF.useMemo)(function() {
        return (0, $19ae46dee023ee5d$export$2e2bcd8739ae039)(s, e);
    }, [
        s,
        e
    ]), d = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: !0,
        config: a,
        immediate: !o
    }).value;
    return (0, $27d73b36303119b6$export$2c618a4308a30424)(d, l);
}, $0332e848e6fa2251$export$77ddf829b5125d20 = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $219f70bda2a84288$export$3005042704f95a69)),
    PRGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $a1632d99e2d37bcf$export$3005042704f95a69)),
    PiYG: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $6691be584654a0aa$export$3005042704f95a69)),
    PuOr: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3f77df9b475c140b$export$3005042704f95a69)),
    RdBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $38219aed23964a40$export$3005042704f95a69)),
    RdGy: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $fdda3d661f15ff0a$export$3005042704f95a69)),
    RdYlBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $d0c8a68d89733660$export$3005042704f95a69)),
    RdYlGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $1630ec0b370e5912$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $8d06221358a48e3e$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $d3ed090c8c94b4e2$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $eaf5757e5e20111c$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $61efc056027c6f83$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $ef09f7e7ba00ec44$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $5eca65edfa5e3362$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $41e2d3efba46b464$export$3005042704f95a69)),
    BuGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $847f46a436bbc72d$export$3005042704f95a69)),
    BuPu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $a88f39e40f768068$export$3005042704f95a69)),
    GnBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $f64a1aea510bd318$export$3005042704f95a69)),
    OrRd: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $28098c54962f3133$export$3005042704f95a69)),
    PuBuGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $7826a5e6af7d98b9$export$3005042704f95a69)),
    PuBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $45b9b6cfaa33816b$export$3005042704f95a69)),
    PuRd: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $6e8094f4389eb035$export$3005042704f95a69)),
    RdPu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $62dcbf6105c53d0a$export$3005042704f95a69)),
    YlGnBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $86f372b7a8c1dbdd$export$3005042704f95a69)),
    YlGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $12aeccb6028274a3$export$3005042704f95a69)),
    YlOrBr: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $be31442e924737ac$export$3005042704f95a69)),
    YlOrRd: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $886c368be80910b3$export$3005042704f95a69))
}, $0332e848e6fa2251$export$6dc823b35197e3c3 = Object.keys($0332e848e6fa2251$export$77ddf829b5125d20), $0332e848e6fa2251$export$8d3d36a98ebb26b6 = function(e) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return e;
    }
    if ($0332e848e6fa2251$export$77ddf829b5125d20[e]) return (0, $2d4e99e5984fdf9f$export$2e2bcd8739ae039)().range($0332e848e6fa2251$export$77ddf829b5125d20[e]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($579b9ba2588bb9de$exports)))(e)) return (0, $2d4e99e5984fdf9f$export$2e2bcd8739ae039)().range(e);
    throw new Error("Unable to guess quantize color scale from '" + e + "',\nmust be a function or one of:\n'" + $0332e848e6fa2251$export$6dc823b35197e3c3.join("', '") + "'");
}, $0332e848e6fa2251$var$st = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $93b217b96440b4ce$export$2e2bcd8739ae039),
    accent: (0, $faaa9454e2cc6c8f$export$2e2bcd8739ae039),
    dark2: (0, $45decd1672a2c6a3$export$2e2bcd8739ae039),
    paired: (0, $97d8980b55e3f341$export$2e2bcd8739ae039),
    pastel1: (0, $e8dfd5913f0417f3$export$2e2bcd8739ae039),
    pastel2: (0, $29119ca77ee513ac$export$2e2bcd8739ae039),
    set1: (0, $bc101e1e75979858$export$2e2bcd8739ae039),
    set2: (0, $81fba5de2439dc06$export$2e2bcd8739ae039),
    set3: (0, $dc42a0703a8adee7$export$2e2bcd8739ae039),
    brown_blueGreen: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $219f70bda2a84288$export$3005042704f95a69)),
    purpleRed_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $a1632d99e2d37bcf$export$3005042704f95a69)),
    pink_yellowGreen: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $6691be584654a0aa$export$3005042704f95a69)),
    purple_orange: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3f77df9b475c140b$export$3005042704f95a69)),
    red_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $38219aed23964a40$export$3005042704f95a69)),
    red_grey: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $fdda3d661f15ff0a$export$3005042704f95a69)),
    red_yellow_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $d0c8a68d89733660$export$3005042704f95a69)),
    red_yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $1630ec0b370e5912$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $8d06221358a48e3e$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $d3ed090c8c94b4e2$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $eaf5757e5e20111c$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $61efc056027c6f83$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $ef09f7e7ba00ec44$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $5eca65edfa5e3362$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $41e2d3efba46b464$export$3005042704f95a69)),
    blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $847f46a436bbc72d$export$3005042704f95a69)),
    blue_purple: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $a88f39e40f768068$export$3005042704f95a69)),
    green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $f64a1aea510bd318$export$3005042704f95a69)),
    orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $28098c54962f3133$export$3005042704f95a69)),
    purple_blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $7826a5e6af7d98b9$export$3005042704f95a69)),
    purple_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $45b9b6cfaa33816b$export$3005042704f95a69)),
    purple_red: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $6e8094f4389eb035$export$3005042704f95a69)),
    red_purple: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $62dcbf6105c53d0a$export$3005042704f95a69)),
    yellow_green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $86f372b7a8c1dbdd$export$3005042704f95a69)),
    yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $12aeccb6028274a3$export$3005042704f95a69)),
    yellow_orange_brown: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $be31442e924737ac$export$3005042704f95a69)),
    yellow_orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $886c368be80910b3$export$3005042704f95a69))
}, $0332e848e6fa2251$export$b48661626a811234 = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
], $0332e848e6fa2251$export$6638ab0298ebe095 = {
    brown_blueGreen: (0, $219f70bda2a84288$export$2e2bcd8739ae039),
    purpleRed_green: (0, $a1632d99e2d37bcf$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $6691be584654a0aa$export$2e2bcd8739ae039),
    purple_orange: (0, $3f77df9b475c140b$export$2e2bcd8739ae039),
    red_blue: (0, $38219aed23964a40$export$2e2bcd8739ae039),
    red_grey: (0, $fdda3d661f15ff0a$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $d0c8a68d89733660$export$2e2bcd8739ae039),
    red_yellow_green: (0, $1630ec0b370e5912$export$2e2bcd8739ae039),
    spectral: (0, $8d06221358a48e3e$export$2e2bcd8739ae039),
    blues: (0, $d3ed090c8c94b4e2$export$2e2bcd8739ae039),
    greens: (0, $eaf5757e5e20111c$export$2e2bcd8739ae039),
    greys: (0, $61efc056027c6f83$export$2e2bcd8739ae039),
    oranges: (0, $ef09f7e7ba00ec44$export$2e2bcd8739ae039),
    purples: (0, $5eca65edfa5e3362$export$2e2bcd8739ae039),
    reds: (0, $41e2d3efba46b464$export$2e2bcd8739ae039),
    viridis: (0, $566595be19c6c616$export$2e2bcd8739ae039),
    inferno: (0, $566595be19c6c616$export$ad0c8285c8ea6dbd),
    magma: (0, $566595be19c6c616$export$c41e69203f572e8d),
    plasma: (0, $566595be19c6c616$export$6664860a633d9daf),
    warm: (0, $ab9b1c4ea6725a3f$export$fc70efcec537be98),
    cool: (0, $ab9b1c4ea6725a3f$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $8e7823d310a8100b$export$2e2bcd8739ae039),
    blue_green: (0, $847f46a436bbc72d$export$2e2bcd8739ae039),
    blue_purple: (0, $a88f39e40f768068$export$2e2bcd8739ae039),
    green_blue: (0, $f64a1aea510bd318$export$2e2bcd8739ae039),
    orange_red: (0, $28098c54962f3133$export$2e2bcd8739ae039),
    purple_blue_green: (0, $7826a5e6af7d98b9$export$2e2bcd8739ae039),
    purple_blue: (0, $45b9b6cfaa33816b$export$2e2bcd8739ae039),
    purple_red: (0, $6e8094f4389eb035$export$2e2bcd8739ae039),
    red_purple: (0, $62dcbf6105c53d0a$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $86f372b7a8c1dbdd$export$2e2bcd8739ae039),
    yellow_green: (0, $12aeccb6028274a3$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $be31442e924737ac$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $886c368be80910b3$export$2e2bcd8739ae039),
    rainbow: (0, $ab9b1c4ea6725a3f$export$2e2bcd8739ae039),
    sinebow: (0, $2f36c4634cfbe4b2$export$2e2bcd8739ae039)
}, $0332e848e6fa2251$export$277274330ffd2780 = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
], $0332e848e6fa2251$export$cec134b1a1fa53dd = function() {
    return (0, $46022730ab65113e$export$2e2bcd8739ae039)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
}, $0332e848e6fa2251$export$75f9af112506f7de = function(e, r) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(e)) {
        var t = $0332e848e6fa2251$var$st[e];
        if (void 0 !== t) {
            var i = (0, $46022730ab65113e$export$2e2bcd8739ae039)(t);
            return i.type = "ordinal", i;
        }
        if (void 0 !== r && 0 === e.indexOf("seq:")) {
            var n = $0332e848e6fa2251$export$6638ab0298ebe095[e.slice(4)];
            if (void 0 !== n) {
                var o = (0, $50d03fd061729af1$export$2e2bcd8739ae039)(n).domain(r.domain());
                return o.type = "sequential", o;
            }
        }
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($579b9ba2588bb9de$exports)))(e)) {
        var a = (0, $46022730ab65113e$export$2e2bcd8739ae039)(e);
        return a.type = "ordinal", a;
    }
    return function() {
        return e;
    };
}, $0332e848e6fa2251$export$51f2761e5fe5ca10 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($0332e848e6fa2251$export$6dc823b35197e3c3),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)
]), $0332e848e6fa2251$export$3794d272a0540747 = {
    basis: (0, $057edd14d2e89b9f$export$2e2bcd8739ae039),
    basisClosed: (0, $6fb2f44dbcd8b8cd$export$2e2bcd8739ae039),
    basisOpen: (0, $daf5476d3d8d82c6$export$2e2bcd8739ae039),
    bundle: (0, $fc59b80ba28997f1$export$2e2bcd8739ae039),
    cardinal: (0, $1nfk9.default),
    cardinalClosed: (0, $92af638e5ea5d76b$export$2e2bcd8739ae039),
    cardinalOpen: (0, $cad95e957f5f2cf2$export$2e2bcd8739ae039),
    catmullRom: (0, $ibKd5.default),
    catmullRomClosed: (0, $a6ca9f61f1518e27$export$2e2bcd8739ae039),
    catmullRomOpen: (0, $f2bf92d30ef53143$export$2e2bcd8739ae039),
    linear: (0, $ef8d0d3e260330b4$export$2e2bcd8739ae039),
    linearClosed: (0, $8397ca2590b4eb43$export$2e2bcd8739ae039),
    monotoneX: (0, $52138155fb87d3d5$export$99563b5420dbdc55),
    monotoneY: (0, $52138155fb87d3d5$export$8b5360456d6bdb88),
    natural: (0, $9eb0ee98a9fc61ab$export$2e2bcd8739ae039),
    step: (0, $bd4b92113ce6a649$export$2e2bcd8739ae039),
    stepAfter: (0, $bd4b92113ce6a649$export$793b3db073781cbb),
    stepBefore: (0, $bd4b92113ce6a649$export$10eafa5b7478b343)
}, $0332e848e6fa2251$export$a2965cde22c100c0 = Object.keys($0332e848e6fa2251$export$3794d272a0540747), $0332e848e6fa2251$export$eef91b92fd6d82fc = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($0332e848e6fa2251$export$a2965cde22c100c0), $0332e848e6fa2251$export$2a904d581bf09f5e = $0332e848e6fa2251$export$a2965cde22c100c0.filter(function(e) {
    return e.endsWith("Closed");
}), $0332e848e6fa2251$export$66e85fc6ea12b97e = (0, (/*@__PURE__*/$parcel$interopDefault($81ee6696873b1a9a$exports)))($0332e848e6fa2251$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $0332e848e6fa2251$export$6d32fc0bcd3f8555 = (0, (/*@__PURE__*/$parcel$interopDefault($81ee6696873b1a9a$exports)))($0332e848e6fa2251$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $0332e848e6fa2251$export$b417d9aa8a99ac1a = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($0332e848e6fa2251$export$6d32fc0bcd3f8555), $0332e848e6fa2251$export$99f526a753d63ebe = function(e) {
    if (!$0332e848e6fa2251$export$3794d272a0540747[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return $0332e848e6fa2251$export$3794d272a0540747[e];
}, $0332e848e6fa2251$export$395ebfe7dd3d9f57 = {
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    })).isRequired,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        match: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                "*"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
        ]).isRequired
    })).isRequired
}, $0332e848e6fa2251$export$9c0ef4eef492d11d = {
    ascending: (0, $1b8a167c972a865b$export$2e2bcd8739ae039),
    descending: (0, $bbaab929e9beb03a$export$2e2bcd8739ae039),
    insideOut: (0, $a166888d2ade1ac4$export$2e2bcd8739ae039),
    none: (0, $4edcea54ce45e1e9$export$2e2bcd8739ae039),
    reverse: (0, $1e5ebec8ad49b204$export$2e2bcd8739ae039)
}, $0332e848e6fa2251$export$a8ec30103cd71280 = Object.keys($0332e848e6fa2251$export$9c0ef4eef492d11d), $0332e848e6fa2251$export$85e7401689f2f2cf = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($0332e848e6fa2251$export$a8ec30103cd71280), $0332e848e6fa2251$export$1d5443ca84f6d0f0 = function(e) {
    return $0332e848e6fa2251$export$9c0ef4eef492d11d[e];
}, $0332e848e6fa2251$export$ab3c04d5a3b28998 = {
    expand: (0, $9f8b1cc3c0f88e61$export$2e2bcd8739ae039),
    diverging: (0, $5e295988ef475abe$export$2e2bcd8739ae039),
    none: (0, $ac4071e3d42adef3$export$2e2bcd8739ae039),
    silhouette: (0, $70650e77b689ed1a$export$2e2bcd8739ae039),
    wiggle: (0, $35e8556efa62b994$export$2e2bcd8739ae039)
}, $0332e848e6fa2251$export$31340e546ce1c184 = Object.keys($0332e848e6fa2251$export$ab3c04d5a3b28998), $0332e848e6fa2251$export$73f4209297f0de27 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($0332e848e6fa2251$export$31340e546ce1c184), $0332e848e6fa2251$export$5c9f4d1b003c0909 = function(e) {
    return $0332e848e6fa2251$export$ab3c04d5a3b28998[e];
}, $0332e848e6fa2251$export$5d66dd569e74301b = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    top: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
}).isRequired, $0332e848e6fa2251$export$34f44898ffea24c3 = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
], $0332e848e6fa2251$export$6da2372f044c5e36 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($0332e848e6fa2251$export$34f44898ffea24c3), $0332e848e6fa2251$export$1db72d8ab19b94d9 = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $0332e848e6fa2251$export$99f526a753d63ebe(e);
    }, [
        e
    ]);
}, $0332e848e6fa2251$export$2785d5ef2943fe58 = !0, $0332e848e6fa2251$export$bcf754ee2d5727f7 = 90, $0332e848e6fa2251$export$6bb389bedeee99d3 = 15, $0332e848e6fa2251$export$a4dcb37d1b87cf96 = $0332e848e6fa2251$export$cec134b1a1fa53dd, $0332e848e6fa2251$export$1570875fb8f3b023 = (0, $46022730ab65113e$export$2e2bcd8739ae039)((0, $dc42a0703a8adee7$export$2e2bcd8739ae039)), $0332e848e6fa2251$export$6728fea658cfb92e = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $0332e848e6fa2251$export$d04af0e501fb729f = function(e, t, i) {
    return void 0 === i && (i = {}), (0, $7fPBF.useMemo)(function() {
        var r = $0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$export$6728fea658cfb92e, i);
        return {
            margin: r,
            innerWidth: e - r.left - r.right,
            innerHeight: t - r.top - r.bottom,
            outerWidth: e,
            outerHeight: t
        };
    }, [
        e,
        t,
        i.top,
        i.right,
        i.bottom,
        i.left
    ]);
}, $0332e848e6fa2251$export$e295b0c537d32d7d = function() {
    var e = (0, $7fPBF.useRef)(null), r = (0, $7fPBF.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }), t = r[0], a = r[1], s = (0, $7fPBF.useState)(function() {
        return "undefined" != typeof window ? new ResizeObserver(function(e) {
            var r = e[0];
            return a(r.contentRect);
        }) : null;
    })[0];
    return (0, $7fPBF.useEffect)(function() {
        return e.current && null !== s && s.observe(e.current), function() {
            null !== s && s.disconnect();
        };
    }, []), [
        e,
        t
    ];
}, $0332e848e6fa2251$export$7394831711fe34f = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $0332e848e6fa2251$export$582fa4e2a9b13dde($0332e848e6fa2251$export$164de7ab8df77ef0, e);
    }, [
        e
    ]);
}, $0332e848e6fa2251$export$f037bf6aad5a4e75 = function(e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? (0, $3fa0d48148b775ea$export$94f4d87fad5dcf9a)(e.slice("5")) : (0, $f979cbd3e1200bf1$export$d9468344d3651243)(e) : function(e) {
        return "" + e;
    };
}, $0332e848e6fa2251$export$422f9765e6971fdf = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $0332e848e6fa2251$export$f037bf6aad5a4e75(e);
    }, [
        e
    ]);
}, $0332e848e6fa2251$export$84c6f02482759c25 = (0, $7fPBF.createContext)(), $0332e848e6fa2251$var$Ht = {}, $0332e848e6fa2251$export$d8964aec282183a3 = function(e) {
    var r = e.theme, t = void 0 === r ? $0332e848e6fa2251$var$Ht : r, i = e.children, n = $0332e848e6fa2251$export$7394831711fe34f(t);
    return (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$84c6f02482759c25.Provider, {
        value: n,
        children: i
    });
};
$0332e848e6fa2251$export$d8964aec282183a3.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
};
var $0332e848e6fa2251$export$93d4e7f90805808f = function() {
    return (0, $7fPBF.useContext)($0332e848e6fa2251$export$84c6f02482759c25);
}, $0332e848e6fa2251$var$Jt = function(e) {
    var r = e.children, t = e.condition, i = e.wrapper;
    return t ? (0, $7fPBF.cloneElement)(i, {}, r) : r;
};
$0332e848e6fa2251$var$Jt.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    condition: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).element.isRequired
};
var $0332e848e6fa2251$var$Qt = {
    position: "relative"
}, $0332e848e6fa2251$export$42a852a2b6b56249 = function(e) {
    var r = e.children, t = e.theme, n = e.renderWrapper, o = void 0 === n || n, a = e.isInteractive, s = void 0 === a || a, l = e.animate, d = e.motionStiffness, u = e.motionDamping, f = e.motionConfig, h = (0, $7fPBF.useRef)(null);
    return (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$d8964aec282183a3, {
        theme: t,
        children: (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$e9d875263f86dcb4, {
            animate: l,
            stiffness: d,
            damping: u,
            config: f,
            children: (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$f78649fb9ca566b8), {
                container: h,
                children: (0, $824c049f32d4395d$exports.jsxs)($0332e848e6fa2251$var$Jt, {
                    condition: o,
                    wrapper: (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: $0332e848e6fa2251$var$Qt,
                        ref: h
                    }),
                    children: [
                        r,
                        s && (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$28c660c63b792dea), {})
                    ]
                })
            })
        })
    });
};
$0332e848e6fa2251$export$42a852a2b6b56249.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).element.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    motionStiffness: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    motionDamping: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0332e848e6fa2251$export$8793edee2d425525 = function() {}, $0332e848e6fa2251$var$ei = {
    position: "relative"
}, $0332e848e6fa2251$export$c2b4ab1564fcaab4 = function(e) {
    var t = e.children, n = e.theme, o = e.isInteractive, a = void 0 === o || o, l = e.renderWrapper, d = void 0 === l || l, u = e.animate, f = e.motionStiffness, c = e.motionDamping, b = e.motionConfig, y = (0, $7fPBF.useRef)(null), v = (0, $c39e9a0d065c63c9$export$85cc26a2c4544aaa)(y), R = v.actions, q = v.state, k = (0, $7fPBF.useCallback)(function(e, r) {
        return R.showTooltipFromEvent(e, r);
    }, [
        R.showTooltipFromEvent
    ]), _ = (0, $7fPBF.useMemo)(function() {
        return {
            showTooltip: a ? k : $0332e848e6fa2251$export$8793edee2d425525,
            hideTooltip: a ? R.hideTooltip : $0332e848e6fa2251$export$8793edee2d425525
        };
    }, [
        R.hideTooltip,
        a,
        k
    ]);
    return (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$d8964aec282183a3, {
        theme: n,
        children: (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$e9d875263f86dcb4, {
            animate: u,
            stiffness: f,
            damping: c,
            config: b,
            children: (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d344f0e974db1e2e).Provider, {
                value: R,
                children: (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$c7027a64d546bf1d).Provider, {
                    value: q,
                    children: (0, $824c049f32d4395d$exports.jsxs)($0332e848e6fa2251$var$Jt, {
                        condition: d,
                        wrapper: (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: $0332e848e6fa2251$var$ei,
                            ref: y
                        }),
                        children: [
                            t(_),
                            a && (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$28c660c63b792dea), {})
                        ]
                    })
                })
            })
        })
    });
};
$0332e848e6fa2251$export$c2b4ab1564fcaab4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    motionStiffness: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    motionDamping: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0332e848e6fa2251$export$fa6e408d6a7d6214 = function(e) {
    var r = e.children, t = $0332e848e6fa2251$export$e295b0c537d32d7d(), i = t[0], n = t[1], o = n.width > 0 && n.height > 0;
    return (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: i,
        style: {
            width: "100%",
            height: "100%"
        },
        children: o && r({
            width: n.width,
            height: n.height
        })
    });
};
$0332e848e6fa2251$export$fa6e408d6a7d6214.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
var $0332e848e6fa2251$var$ii = [
    "id",
    "colors"
], $0332e848e6fa2251$export$39a41c7169757633 = function(e) {
    var r = e.id, t = e.colors, i = $0332e848e6fa2251$var$Lr(e, $0332e848e6fa2251$var$ii);
    return (0, $824c049f32d4395d$exports.jsx)("linearGradient", $0332e848e6fa2251$var$Gr({
        id: r,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, i, {
        children: t.map(function(e) {
            var r = e.offset, t = e.color, i = e.opacity;
            return (0, $824c049f32d4395d$exports.jsx)("stop", {
                offset: r + "%",
                stopColor: t,
                stopOpacity: void 0 !== i ? i : 1
            }, r);
        })
    }));
};
$0332e848e6fa2251$export$39a41c7169757633.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        offset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        opacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    })).isRequired,
    gradientTransform: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0332e848e6fa2251$export$78f14b2164360f92 = function(e, r, t) {
    return void 0 === t && (t = {}), $0332e848e6fa2251$var$Gr({
        id: e,
        type: "linearGradient",
        colors: r
    }, t);
}, $0332e848e6fa2251$export$a3bca081a57901da = {
    linearGradient: $0332e848e6fa2251$export$39a41c7169757633
}, $0332e848e6fa2251$export$5e799d98c1ab7521 = (0, $7fPBF.memo)(function(e) {
    var r = e.id, t = e.background, i = e.color, n = e.size, o = e.padding, a = e.stagger, s = n + o, l = n / 2, d = o / 2;
    return !0 === a && (s = 2 * n + 2 * o), (0, $824c049f32d4395d$exports.jsxs)("pattern", {
        id: r,
        width: s,
        height: s,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: s,
                height: s,
                fill: t
            }),
            (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: d + l,
                cy: d + l,
                r: l,
                fill: i
            }),
            a && (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 1.5 * o + n + l,
                cy: 1.5 * o + n + l,
                r: l,
                fill: i
            })
        ]
    });
});
$0332e848e6fa2251$export$5e799d98c1ab7521.displayName = "PatternDots", $0332e848e6fa2251$export$5e799d98c1ab7521.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
}, $0332e848e6fa2251$export$5e799d98c1ab7521.defaultProps = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
};
var $0332e848e6fa2251$export$27feaeda534cb3 = function(e, r) {
    return void 0 === r && (r = {}), $0332e848e6fa2251$var$Gr({
        id: e,
        type: "patternDots"
    }, r);
}, $0332e848e6fa2251$export$6eec49b1a6289c4e = 2 * Math.PI, $0332e848e6fa2251$export$c9fcf1a7df975d78 = function(e) {
    return e * Math.PI / 180;
}, $0332e848e6fa2251$export$c41dd2a8460d3196 = function(e) {
    return 180 * e / Math.PI;
}, $0332e848e6fa2251$export$61f3799bad189d2e = function(e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
}, $0332e848e6fa2251$export$2e16b01652730550 = function(e, r) {
    return {
        x: Math.cos(e) * r,
        y: Math.sin(e) * r
    };
}, $0332e848e6fa2251$export$c2f0a4925e526958 = function(e) {
    var r = e % 360;
    return r < 0 && (r += 360), r;
}, $0332e848e6fa2251$export$c2bacc09869b390f = function(e) {
    return e - $0332e848e6fa2251$export$6eec49b1a6289c4e * Math.floor((e + Math.PI) / $0332e848e6fa2251$export$6eec49b1a6289c4e);
}, $0332e848e6fa2251$export$e3df76cf4464bc81 = function(e) {
    return e < 0 ? 360 - -e % 360 : e % 360;
}, $0332e848e6fa2251$export$a9f93668da7e35c9 = function(e, r, t) {
    void 0 === t && (t = 360);
    var i = r;
    return Math.abs(r - e) > t && (i = e + (r > e ? t : -t)), [
        e,
        i
    ];
}, $0332e848e6fa2251$export$1abb91cfca1e2069 = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end",
            start: "start",
            middle: "middle",
            end: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right",
            start: "left",
            middle: "center",
            end: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
}, $0332e848e6fa2251$export$60f5dce4201c524 = function(e, r, t, i) {
    void 0 === i && (i = "svg");
    var n = $0332e848e6fa2251$export$1abb91cfca1e2069[i], o = $0332e848e6fa2251$export$2e16b01652730550(r - Math.PI / 2, e), a = o.x, s = o.y, l = $0332e848e6fa2251$export$c41dd2a8460d3196(r), d = n.align.center, u = n.baseline.bottom;
    return t > 0 ? (d = n.align.right, u = n.baseline.center) : t < 0 && (d = n.align.left, u = n.baseline.center), 0 !== t && l > 180 && (l -= 180, d = d === n.align.right ? n.align.left : n.align.right), {
        x: a,
        y: s,
        rotate: l += t,
        align: d,
        baseline: u
    };
}, $0332e848e6fa2251$export$ace8c9d56fb83ed1 = (0, $7fPBF.memo)(function(e) {
    var r = e.id, t = e.spacing, i = e.rotation, n = e.background, o = e.color, a = e.lineWidth, s = Math.round(i) % 360, l = Math.abs(t);
    s > 180 ? s -= 360 : s > 90 ? s -= 180 : s < -180 ? s += 360 : s < -90 && (s += 180);
    var d, u = l, f = l;
    return 0 === s ? d = "\n                M 0 0 L " + u + " 0\n                M 0 " + f + " L " + u + " " + f + "\n            " : 90 === s ? d = "\n                M 0 0 L 0 " + f + "\n                M " + u + " 0 L " + u + " " + f + "\n            " : (u = Math.abs(l / Math.sin($0332e848e6fa2251$export$c9fcf1a7df975d78(s))), f = l / Math.sin($0332e848e6fa2251$export$c9fcf1a7df975d78(90 - s)), d = s > 0 ? "\n                    M 0 " + -f + " L " + 2 * u + " " + f + "\n                    M " + -u + " " + -f + " L " + u + " " + f + "\n                    M " + -u + " 0 L " + u + " " + 2 * f + "\n                " : "\n                    M " + -u + " " + f + " L " + u + " " + -f + "\n                    M " + -u + " " + 2 * f + " L " + 2 * u + " " + -f + "\n                    M 0 " + 2 * f + " L " + 2 * u + " 0\n                "), (0, $824c049f32d4395d$exports.jsxs)("pattern", {
        id: r,
        width: u,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: u,
                height: f,
                fill: n,
                stroke: "rgba(255, 0, 0, 0.1)",
                strokeWidth: 0
            }),
            (0, $824c049f32d4395d$exports.jsx)("path", {
                d: d,
                strokeWidth: a,
                stroke: o,
                strokeLinecap: "square"
            })
        ]
    });
});
$0332e848e6fa2251$export$ace8c9d56fb83ed1.displayName = "PatternLines", $0332e848e6fa2251$export$ace8c9d56fb83ed1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    spacing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
}, $0332e848e6fa2251$export$ace8c9d56fb83ed1.defaultProps = {
    spacing: 5,
    rotation: 0,
    color: "#000000",
    background: "#ffffff",
    lineWidth: 2
};
var $0332e848e6fa2251$export$5487da9d0b1282d9 = function(e, r) {
    return void 0 === r && (r = {}), $0332e848e6fa2251$var$Gr({
        id: e,
        type: "patternLines"
    }, r);
}, $0332e848e6fa2251$export$e9fa09500a728054 = (0, $7fPBF.memo)(function(e) {
    var r = e.id, t = e.background, i = e.color, n = e.size, o = e.padding, a = e.stagger, s = n + o, l = o / 2;
    return !0 === a && (s = 2 * n + 2 * o), (0, $824c049f32d4395d$exports.jsxs)("pattern", {
        id: r,
        width: s,
        height: s,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: s,
                height: s,
                fill: t
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                x: l,
                y: l,
                width: n,
                height: n,
                fill: i
            }),
            a && (0, $824c049f32d4395d$exports.jsx)("rect", {
                x: 1.5 * o + n,
                y: 1.5 * o + n,
                width: n,
                height: n,
                fill: i
            })
        ]
    });
});
$0332e848e6fa2251$export$e9fa09500a728054.displayName = "PatternSquares", $0332e848e6fa2251$export$e9fa09500a728054.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
}, $0332e848e6fa2251$export$e9fa09500a728054.defaultProps = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
};
var $0332e848e6fa2251$export$1b1d9cb2f82cf47f = function(e, r) {
    return void 0 === r && (r = {}), $0332e848e6fa2251$var$Gr({
        id: e,
        type: "patternSquares"
    }, r);
}, $0332e848e6fa2251$export$691ec77bd278f3b0 = {
    patternDots: $0332e848e6fa2251$export$5e799d98c1ab7521,
    patternLines: $0332e848e6fa2251$export$ace8c9d56fb83ed1,
    patternSquares: $0332e848e6fa2251$export$e9fa09500a728054
}, $0332e848e6fa2251$var$xi = [
    "type"
], $0332e848e6fa2251$var$Oi = $0332e848e6fa2251$var$Gr({}, $0332e848e6fa2251$export$a3bca081a57901da, $0332e848e6fa2251$export$691ec77bd278f3b0), $0332e848e6fa2251$var$Ci = function(e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : (0, $824c049f32d4395d$exports.jsx)("defs", {
        "aria-hidden": !0,
        children: r.map(function(e) {
            var r = e.type, t = $0332e848e6fa2251$var$Lr(e, $0332e848e6fa2251$var$xi);
            return $0332e848e6fa2251$var$Oi[r] ? (0, $7fPBF.createElement)($0332e848e6fa2251$var$Oi[r], $0332e848e6fa2251$var$Gr({
                key: t.id
            }, t)) : null;
        })
    });
};
$0332e848e6fa2251$var$Ci.propTypes = {
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf(Object.keys($0332e848e6fa2251$var$Oi)).isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }))
};
var $0332e848e6fa2251$export$b2bdceae9588b42d = (0, $7fPBF.memo)($0332e848e6fa2251$var$Ci), $0332e848e6fa2251$export$21d9f1931ef75b56 = function(e) {
    var r = e.width, t = e.height, i = e.margin, n = e.defs, o = e.children, a = e.role, s = e.ariaLabel, l = e.ariaLabelledBy, d = e.ariaDescribedBy, u = e.isFocusable, f = $0332e848e6fa2251$export$93d4e7f90805808f();
    return (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: r,
        height: t,
        role: a,
        "aria-label": s,
        "aria-labelledby": l,
        "aria-describedby": d,
        focusable: u,
        tabIndex: u ? 0 : void 0,
        children: [
            (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$b2bdceae9588b42d, {
                defs: n
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: r,
                height: t,
                fill: f.background
            }),
            (0, $824c049f32d4395d$exports.jsx)("g", {
                transform: "translate(" + i.left + "," + i.top + ")",
                children: o
            })
        ]
    });
};
$0332e848e6fa2251$export$21d9f1931ef75b56.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        left: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
    }).isRequired,
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node
    ]).isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    isFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    ariaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    ariaDescribedBy: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0332e848e6fa2251$var$zi = function(e) {
    var r = e.size, t = e.color, i = e.borderWidth, n = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("circle", {
        r: r / 2,
        fill: t,
        stroke: n,
        strokeWidth: i,
        style: {
            pointerEvents: "none"
        }
    });
};
$0332e848e6fa2251$var$zi.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
var $0332e848e6fa2251$var$Pi = (0, $7fPBF.memo)($0332e848e6fa2251$var$zi), $0332e848e6fa2251$var$Ti = function(e) {
    var r = e.x, t = e.y, i = e.symbol, n = void 0 === i ? $0332e848e6fa2251$var$Pi : i, o = e.size, a = e.datum, s = e.color, l = e.borderWidth, u = e.borderColor, f = e.label, c = e.labelTextAnchor, p = void 0 === c ? "middle" : c, h = e.labelYOffset, g = void 0 === h ? -12 : h, m = $0332e848e6fa2251$export$93d4e7f90805808f(), b = $0332e848e6fa2251$export$72acc3dc9629d75d(), y = b.animate, v = b.config, R = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        transform: "translate(" + r + ", " + t + ")",
        config: v,
        immediate: !y
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        transform: R.transform,
        style: {
            pointerEvents: "none"
        },
        children: [
            (0, $7fPBF.createElement)(n, {
                size: o,
                color: s,
                datum: a,
                borderWidth: l,
                borderColor: u
            }),
            f && (0, $824c049f32d4395d$exports.jsx)("text", {
                textAnchor: p,
                y: g,
                style: m.dots.text,
                children: f
            })
        ]
    });
};
$0332e848e6fa2251$var$Ti.propTypes = {
    x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    labelTextAnchor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    labelYOffset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
};
var $0332e848e6fa2251$export$ca30f0ad55489a87 = (0, $7fPBF.memo)($0332e848e6fa2251$var$Ti), $0332e848e6fa2251$var$ji = function(e) {
    var r = e.width, t = e.height, i = e.axis, n = e.scale, o = e.value, a = e.lineStyle, s = e.textStyle, l = e.legend, d = e.legendPosition, u = e.legendOffsetX, f = e.legendOffsetY, c = e.legendOrientation, p = $0332e848e6fa2251$export$93d4e7f90805808f(), h = 0, g = 0, m = 0, b = 0;
    "y" === i ? (m = n(o), g = r) : (h = n(o), b = t);
    var y = null;
    if (l) {
        var v = function(e) {
            var r = e.axis, t = e.width, i = e.height, n = e.position, o = e.offsetX, a = e.offsetY, s = e.orientation, l = 0, d = 0, u = "vertical" === s ? -90 : 0, f = "start";
            if ("x" === r) switch(n){
                case "top-left":
                    l = -o, d = a, f = "end";
                    break;
                case "top":
                    d = -a, f = "horizontal" === s ? "middle" : "start";
                    break;
                case "top-right":
                    l = o, d = a, f = "horizontal" === s ? "start" : "end";
                    break;
                case "right":
                    l = o, d = i / 2, f = "horizontal" === s ? "start" : "middle";
                    break;
                case "bottom-right":
                    l = o, d = i - a, f = "start";
                    break;
                case "bottom":
                    d = i + a, f = "horizontal" === s ? "middle" : "end";
                    break;
                case "bottom-left":
                    d = i - a, l = -o, f = "horizontal" === s ? "end" : "start";
                    break;
                case "left":
                    l = -o, d = i / 2, f = "horizontal" === s ? "end" : "middle";
            }
            else switch(n){
                case "top-left":
                    l = o, d = -a, f = "start";
                    break;
                case "top":
                    l = t / 2, d = -a, f = "horizontal" === s ? "middle" : "start";
                    break;
                case "top-right":
                    l = t - o, d = -a, f = "horizontal" === s ? "end" : "start";
                    break;
                case "right":
                    l = t + o, f = "horizontal" === s ? "start" : "middle";
                    break;
                case "bottom-right":
                    l = t - o, d = a, f = "end";
                    break;
                case "bottom":
                    l = t / 2, d = a, f = "horizontal" === s ? "middle" : "end";
                    break;
                case "bottom-left":
                    l = o, d = a, f = "horizontal" === s ? "start" : "end";
                    break;
                case "left":
                    l = -o, f = "horizontal" === s ? "end" : "middle";
            }
            return {
                x: l,
                y: d,
                rotation: u,
                textAnchor: f
            };
        }({
            axis: i,
            width: r,
            height: t,
            position: d,
            offsetX: u,
            offsetY: f,
            orientation: c
        });
        y = (0, $824c049f32d4395d$exports.jsx)("text", {
            transform: "translate(" + v.x + ", " + v.y + ") rotate(" + v.rotation + ")",
            textAnchor: v.textAnchor,
            dominantBaseline: "central",
            style: s,
            children: l
        });
    }
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        transform: "translate(" + h + ", " + m + ")",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("line", {
                x1: 0,
                x2: g,
                y1: 0,
                y2: b,
                stroke: p.markers.lineColor,
                strokeWidth: p.markers.lineStrokeWidth,
                style: a
            }),
            y
        ]
    });
};
$0332e848e6fa2251$var$ji.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "x",
        "y"
    ]).isRequired,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
    ]).isRequired,
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    legendPosition: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]),
    legendOffsetX: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    legendOffsetY: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    legendOrientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired
}, $0332e848e6fa2251$var$ji.defaultProps = {
    legendPosition: "top-right",
    legendOffsetX: 14,
    legendOffsetY: 14,
    legendOrientation: "horizontal"
};
var $0332e848e6fa2251$export$2b29c35b9bad49e4 = (0, $7fPBF.memo)($0332e848e6fa2251$var$ji), $0332e848e6fa2251$var$Gi = function(e) {
    var r = e.markers, t = e.width, i = e.height, n = e.xScale, o = e.yScale;
    return r && 0 !== r.length ? r.map(function(e, r) {
        return (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$2b29c35b9bad49e4, $0332e848e6fa2251$var$Gr({}, e, {
            width: t,
            height: i,
            scale: "y" === e.axis ? o : n
        }), r);
    }) : null;
};
$0332e848e6fa2251$var$Gi.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    xScale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    yScale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    markers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ]).isRequired,
        lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    }))
};
var $0332e848e6fa2251$export$81759e11f9e58ea4 = (0, $7fPBF.memo)($0332e848e6fa2251$var$Gi), $0332e848e6fa2251$export$15d5069d1550e563 = function() {
    return (0, $94d5cdcf6924d946$export$f672e0b6f7222cd7)((0, $94d5cdcf6924d946$export$9c21a3269931e1e6)({
        margin: $0332e848e6fa2251$export$6728fea658cfb92e
    }), (0, $94d5cdcf6924d946$export$3f05a82d2bb032cc)({
        width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        margin: $0332e848e6fa2251$export$5d66dd569e74301b
    }), (0, $94d5cdcf6924d946$export$6bb05b1ab09a4158)(function(e, r) {
        return e.width !== r.width || e.height !== r.height || !(0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(e.margin, r.margin);
    }, function(e) {
        var r = Object.assign({}, $0332e848e6fa2251$export$6728fea658cfb92e, e.margin);
        return {
            margin: r,
            width: e.width - r.left - r.right,
            height: e.height - r.top - r.bottom,
            outerWidth: e.width,
            outerHeight: e.height
        };
    }));
}, $0332e848e6fa2251$export$ccaa479bac708af6 = function() {
    return (0, $94d5cdcf6924d946$export$f672e0b6f7222cd7)((0, $94d5cdcf6924d946$export$3f05a82d2bb032cc)($0332e848e6fa2251$export$99a092eaa44be1c8), (0, $94d5cdcf6924d946$export$9c21a3269931e1e6)({
        animate: true,
        motionDamping: 15,
        motionStiffness: 90
    }));
}, $0332e848e6fa2251$export$e8748c6a27b910dc = function(e) {
    var r, t = void 0 === e ? {} : e, i = t.srcKey, n = void 0 === i ? "theme" : i, o = t.destKey, a = void 0 === o ? "theme" : o;
    return (0, $94d5cdcf6924d946$export$f672e0b6f7222cd7)((0, $94d5cdcf6924d946$export$3f05a82d2bb032cc)(((r = {})[n] = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object, r)), (0, $94d5cdcf6924d946$export$6bb05b1ab09a4158)([
        n
    ], function(e) {
        var r;
        return (r = {})[a] = $0332e848e6fa2251$export$582fa4e2a9b13dde($0332e848e6fa2251$export$164de7ab8df77ef0, e[n]), r;
    }));
}, $0332e848e6fa2251$var$Ai = [
    "theme",
    "renderWrapper",
    "animate",
    "motionStiffness",
    "motionDamping",
    "motionConfig"
], $0332e848e6fa2251$export$4cbbe0314aa930ae = function(e) {
    return function(r) {
        var t, i;
        function n() {
            return r.apply(this, arguments) || this;
        }
        return i = r, (t = n).prototype = Object.create(i.prototype), t.prototype.constructor = t, $0332e848e6fa2251$var$Br(t, i), n.prototype.render = function() {
            var r = this.props, t = r.theme, i = r.renderWrapper, n = r.animate, o = r.motionStiffness, a = r.motionDamping, s = r.motionConfig, l = $0332e848e6fa2251$var$Lr(r, $0332e848e6fa2251$var$Ai);
            return (0, $824c049f32d4395d$exports.jsx)($0332e848e6fa2251$export$42a852a2b6b56249, {
                theme: t,
                renderWrapper: i,
                isInteractive: l.isInteractive,
                animate: n,
                motionStiffness: o,
                motionDamping: a,
                motionConfig: s,
                children: (0, $824c049f32d4395d$exports.jsx)(e, $0332e848e6fa2251$var$Gr({}, l))
            });
        }, n;
    }((0, $7fPBF.Component));
}, $0332e848e6fa2251$export$192dc59ac6f86c95 = function(e, r) {
    var t, i = (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e);
    };
    return r && (t = (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(r) ? r : (0, $f979cbd3e1200bf1$export$d9468344d3651243)(r)), t ? function(e) {
        return t(i(e));
    } : i;
}, $0332e848e6fa2251$export$3cc9373c3cf93eff = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e);
    };
}, $0332e848e6fa2251$export$2d590546cbb7e3ad = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $0332e848e6fa2251$export$3cc9373c3cf93eff(e);
    }, [
        e
    ]);
}, $0332e848e6fa2251$export$605481d5cadc9728 = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
], $0332e848e6fa2251$export$d3a11e7b798643fd = function(e, r, t) {
    var i = r.width - e.width, n = r.height - e.height, o = 0, a = 0;
    return "center" === t && (o = i / 2, a = n / 2), "top" === t && (o = i / 2), "top-right" === t && (o = i), "right" === t && (o = i, a = n / 2), "bottom-right" === t && (o = i, a = n), "bottom" === t && (o = i / 2, a = n), "bottom-left" === t && (a = n), "left" === t && (a = n / 2), [
        o,
        a
    ];
}, $0332e848e6fa2251$export$79376507b09a66f = function(e, r, t, i) {
    var n = t - e, o = i - r;
    return n *= n, o *= o, Math.sqrt(n + o);
}, $0332e848e6fa2251$export$b363da9ded343252 = function(e, r, t, i) {
    var n = Math.atan2(i - r, t - e) - Math.PI / 2;
    return n > 0 ? n : 2 * Math.PI + n;
}, $0332e848e6fa2251$export$be302859f014f482 = function(e, r, t, i, n, o) {
    return e <= n && n <= e + t && r <= o && o <= r + i;
}, $0332e848e6fa2251$export$2396fb9a7906fd81 = function(e, r) {
    var t = r.clientX, i = r.clientY, n = e.getBoundingClientRect(), o = e.getBBox(), a = o.width === n.width ? 1 : o.width / n.width;
    return [
        (t - n.left) * a,
        (i - n.top) * a
    ];
}, $0332e848e6fa2251$var$Zi = Object.keys($0332e848e6fa2251$export$a3bca081a57901da), $0332e848e6fa2251$var$$i = Object.keys($0332e848e6fa2251$export$691ec77bd278f3b0), $0332e848e6fa2251$export$468af463e7cc9c6f = function(e, r, t) {
    if ("*" === e) return !0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e)) return e(r);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(e)) {
        var i = t ? (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, t) : r;
        return (0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c4b8aa507fc568ca$exports)))(i, Object.keys(e)), e);
    }
    return !1;
}, $0332e848e6fa2251$export$dc35cf769e3afe34 = function(e, r, t, i) {
    var n = void 0 === i ? {} : i, o = n.dataKey, a = n.colorKey, s = void 0 === a ? "color" : a, l = n.targetKey, d = void 0 === l ? "fill" : l, u = [], f = {};
    return e.length && r.length && (u = [].concat(e), r.forEach(function(r) {
        for(var i = function(i) {
            var n = t[i], a = n.id, l = n.match;
            if ($0332e848e6fa2251$export$468af463e7cc9c6f(l, r, o)) {
                var c = e.find(function(e) {
                    return e.id === a;
                });
                if (c) {
                    if ($0332e848e6fa2251$var$$i.includes(c.type)) {
                        if ("inherit" === c.background || "inherit" === c.color) {
                            var p = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, s), h = c.background, g = c.color, m = a;
                            "inherit" === c.background && (m = m + ".bg." + p, h = p), "inherit" === c.color && (m = m + ".fg." + p, g = p), (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, d, "url(#" + m + ")"), f[m] || (u.push($0332e848e6fa2251$var$Gr({}, c, {
                                id: m,
                                background: h,
                                color: g
                            })), f[m] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, d, "url(#" + a + ")");
                    } else if ($0332e848e6fa2251$var$Zi.includes(c.type)) {
                        if (c.colors.map(function(e) {
                            return e.color;
                        }).includes("inherit")) {
                            var b = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, s), R = a, q = $0332e848e6fa2251$var$Gr({}, c, {
                                colors: c.colors.map(function(e, r) {
                                    return "inherit" !== e.color ? e : (R = R + "." + r + "." + b, $0332e848e6fa2251$var$Gr({}, e, {
                                        color: "inherit" === e.color ? b : e.color
                                    }));
                                })
                            });
                            q.id = R, (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, d, "url(#" + R + ")"), f[R] || (u.push(q), f[R] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, d, "url(#" + a + ")");
                    }
                }
                return "break";
            }
        }, n = 0; n < t.length; n++){
            if ("break" === i(n)) break;
        }
    })), u;
};






var $7fPBF = parcelRequire("7fPBF");
function $f709ef59e5226708$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

function $6c5ade950d6c9501$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}





var $7fPBF = parcelRequire("7fPBF");

var $b566B = parcelRequire("b566B");

var $2oXYc = parcelRequire("2oXYc");
function $c4db8ce4bcfa23b1$export$2e2bcd8739ae039(interpolate, values) {
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}









function $f54c9799d04b82ad$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $39cfcf291c7bc8aa$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $c4db8ce4bcfa23b1$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $1277998f8de56db8$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $456fea91e42dbc6f$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $f54c9799d04b82ad$export$2e2bcd8739ae039() {
    var scale = (0, $43657edf9f9313df$export$16a5d4b4a61a274d)($f54c9799d04b82ad$var$transformer()((0, $39cfcf291c7bc8aa$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $50d03fd061729af1$export$784d13d8ee351f07)(scale, $f54c9799d04b82ad$export$2e2bcd8739ae039());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f54c9799d04b82ad$export$5f0266a9159c47fb() {
    var scale = (0, $2a0a0e4ba4b52637$export$860836db074028f0)($f54c9799d04b82ad$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $50d03fd061729af1$export$784d13d8ee351f07)(scale, $f54c9799d04b82ad$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f54c9799d04b82ad$export$50b3da713cf557c6() {
    var scale = (0, $e73aca1ccf43f2f6$export$4602684e614eba38)($f54c9799d04b82ad$var$transformer());
    scale.copy = function() {
        return (0, $50d03fd061729af1$export$784d13d8ee351f07)(scale, $f54c9799d04b82ad$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f54c9799d04b82ad$export$d6cedcc63bf26e7e() {
    var scale = (0, $db11d499e1656b02$export$34695211ec403a46)($f54c9799d04b82ad$var$transformer());
    scale.copy = function() {
        return (0, $50d03fd061729af1$export$784d13d8ee351f07)(scale, $f54c9799d04b82ad$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $a59e96b6fe4cbbe6$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $f54c9799d04b82ad$export$33ddefb5c4ab9e9c() {
    return $f54c9799d04b82ad$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}


function $18aed9a2ed048594$var$qe() {
    return $18aed9a2ed048594$var$qe = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $18aed9a2ed048594$var$qe.apply(this, arguments);
}
function $18aed9a2ed048594$var$Se(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var n = 0, t = new Array(r); n < r; n++)t[n] = e[n];
    return t;
}
function $18aed9a2ed048594$var$Re(e, r) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (n) return (n = n.call(e)).next.bind(n);
    if (Array.isArray(e) || (n = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $18aed9a2ed048594$var$Se(e, r);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $18aed9a2ed048594$var$Se(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        n && (e = n);
        var t = 0;
        return function() {
            return t >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[t++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $18aed9a2ed048594$export$8382cb219651957d = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $93b217b96440b4ce$export$2e2bcd8739ae039),
    accent: (0, $faaa9454e2cc6c8f$export$2e2bcd8739ae039),
    dark2: (0, $45decd1672a2c6a3$export$2e2bcd8739ae039),
    paired: (0, $97d8980b55e3f341$export$2e2bcd8739ae039),
    pastel1: (0, $e8dfd5913f0417f3$export$2e2bcd8739ae039),
    pastel2: (0, $29119ca77ee513ac$export$2e2bcd8739ae039),
    set1: (0, $bc101e1e75979858$export$2e2bcd8739ae039),
    set2: (0, $81fba5de2439dc06$export$2e2bcd8739ae039),
    set3: (0, $dc42a0703a8adee7$export$2e2bcd8739ae039)
}, $18aed9a2ed048594$export$480d437bf98751ba = Object.keys($18aed9a2ed048594$export$8382cb219651957d), $18aed9a2ed048594$export$b42e9133a3bfc0c2 = {
    brown_blueGreen: (0, $219f70bda2a84288$export$3005042704f95a69),
    purpleRed_green: (0, $a1632d99e2d37bcf$export$3005042704f95a69),
    pink_yellowGreen: (0, $6691be584654a0aa$export$3005042704f95a69),
    purple_orange: (0, $3f77df9b475c140b$export$3005042704f95a69),
    red_blue: (0, $38219aed23964a40$export$3005042704f95a69),
    red_grey: (0, $fdda3d661f15ff0a$export$3005042704f95a69),
    red_yellow_blue: (0, $d0c8a68d89733660$export$3005042704f95a69),
    red_yellow_green: (0, $1630ec0b370e5912$export$3005042704f95a69),
    spectral: (0, $8d06221358a48e3e$export$3005042704f95a69)
}, $18aed9a2ed048594$export$63357c6d2f7b8781 = Object.keys($18aed9a2ed048594$export$b42e9133a3bfc0c2), $18aed9a2ed048594$export$d9c06f2af83aa27b = {
    brown_blueGreen: (0, $219f70bda2a84288$export$2e2bcd8739ae039),
    purpleRed_green: (0, $a1632d99e2d37bcf$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $6691be584654a0aa$export$2e2bcd8739ae039),
    purple_orange: (0, $3f77df9b475c140b$export$2e2bcd8739ae039),
    red_blue: (0, $38219aed23964a40$export$2e2bcd8739ae039),
    red_grey: (0, $fdda3d661f15ff0a$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $d0c8a68d89733660$export$2e2bcd8739ae039),
    red_yellow_green: (0, $1630ec0b370e5912$export$2e2bcd8739ae039),
    spectral: (0, $8d06221358a48e3e$export$2e2bcd8739ae039)
}, $18aed9a2ed048594$export$db45d8c654873588 = {
    blues: (0, $d3ed090c8c94b4e2$export$3005042704f95a69),
    greens: (0, $eaf5757e5e20111c$export$3005042704f95a69),
    greys: (0, $61efc056027c6f83$export$3005042704f95a69),
    oranges: (0, $ef09f7e7ba00ec44$export$3005042704f95a69),
    purples: (0, $5eca65edfa5e3362$export$3005042704f95a69),
    reds: (0, $41e2d3efba46b464$export$3005042704f95a69),
    blue_green: (0, $847f46a436bbc72d$export$3005042704f95a69),
    blue_purple: (0, $a88f39e40f768068$export$3005042704f95a69),
    green_blue: (0, $f64a1aea510bd318$export$3005042704f95a69),
    orange_red: (0, $28098c54962f3133$export$3005042704f95a69),
    purple_blue_green: (0, $7826a5e6af7d98b9$export$3005042704f95a69),
    purple_blue: (0, $45b9b6cfaa33816b$export$3005042704f95a69),
    purple_red: (0, $6e8094f4389eb035$export$3005042704f95a69),
    red_purple: (0, $62dcbf6105c53d0a$export$3005042704f95a69),
    yellow_green_blue: (0, $86f372b7a8c1dbdd$export$3005042704f95a69),
    yellow_green: (0, $12aeccb6028274a3$export$3005042704f95a69),
    yellow_orange_brown: (0, $be31442e924737ac$export$3005042704f95a69),
    yellow_orange_red: (0, $886c368be80910b3$export$3005042704f95a69)
}, $18aed9a2ed048594$export$6c6944263c7cbb3b = Object.keys($18aed9a2ed048594$export$db45d8c654873588), $18aed9a2ed048594$export$21dd087678fc5202 = {
    blues: (0, $d3ed090c8c94b4e2$export$2e2bcd8739ae039),
    greens: (0, $eaf5757e5e20111c$export$2e2bcd8739ae039),
    greys: (0, $61efc056027c6f83$export$2e2bcd8739ae039),
    oranges: (0, $ef09f7e7ba00ec44$export$2e2bcd8739ae039),
    purples: (0, $5eca65edfa5e3362$export$2e2bcd8739ae039),
    reds: (0, $41e2d3efba46b464$export$2e2bcd8739ae039),
    turbo: (0, $6c5ade950d6c9501$export$2e2bcd8739ae039),
    viridis: (0, $566595be19c6c616$export$2e2bcd8739ae039),
    inferno: (0, $566595be19c6c616$export$ad0c8285c8ea6dbd),
    magma: (0, $566595be19c6c616$export$c41e69203f572e8d),
    plasma: (0, $566595be19c6c616$export$6664860a633d9daf),
    cividis: (0, $f709ef59e5226708$export$2e2bcd8739ae039),
    warm: (0, $ab9b1c4ea6725a3f$export$fc70efcec537be98),
    cool: (0, $ab9b1c4ea6725a3f$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $8e7823d310a8100b$export$2e2bcd8739ae039),
    blue_green: (0, $847f46a436bbc72d$export$2e2bcd8739ae039),
    blue_purple: (0, $a88f39e40f768068$export$2e2bcd8739ae039),
    green_blue: (0, $f64a1aea510bd318$export$2e2bcd8739ae039),
    orange_red: (0, $28098c54962f3133$export$2e2bcd8739ae039),
    purple_blue_green: (0, $7826a5e6af7d98b9$export$2e2bcd8739ae039),
    purple_blue: (0, $45b9b6cfaa33816b$export$2e2bcd8739ae039),
    purple_red: (0, $6e8094f4389eb035$export$2e2bcd8739ae039),
    red_purple: (0, $62dcbf6105c53d0a$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $86f372b7a8c1dbdd$export$2e2bcd8739ae039),
    yellow_green: (0, $12aeccb6028274a3$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $be31442e924737ac$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $886c368be80910b3$export$2e2bcd8739ae039)
}, $18aed9a2ed048594$export$2ad73d393c16f81c = $18aed9a2ed048594$var$qe({}, $18aed9a2ed048594$export$8382cb219651957d, $18aed9a2ed048594$export$b42e9133a3bfc0c2, $18aed9a2ed048594$export$db45d8c654873588), $18aed9a2ed048594$export$b48661626a811234 = Object.keys($18aed9a2ed048594$export$2ad73d393c16f81c), $18aed9a2ed048594$export$9f49cca6c7d1dda4 = function(e) {
    return $18aed9a2ed048594$export$480d437bf98751ba.includes(e);
}, $18aed9a2ed048594$export$4d028a51ab424d0b = function(e) {
    return $18aed9a2ed048594$export$63357c6d2f7b8781.includes(e);
}, $18aed9a2ed048594$export$166c33132082d11d = function(e) {
    return $18aed9a2ed048594$export$6c6944263c7cbb3b.includes(e);
}, $18aed9a2ed048594$export$66bec3b8446aaf18 = {
    rainbow: (0, $ab9b1c4ea6725a3f$export$2e2bcd8739ae039),
    sinebow: (0, $2f36c4634cfbe4b2$export$2e2bcd8739ae039)
}, $18aed9a2ed048594$export$6638ab0298ebe095 = $18aed9a2ed048594$var$qe({}, $18aed9a2ed048594$export$d9c06f2af83aa27b, $18aed9a2ed048594$export$21dd087678fc5202, $18aed9a2ed048594$export$66bec3b8446aaf18), $18aed9a2ed048594$export$277274330ffd2780 = Object.keys($18aed9a2ed048594$export$6638ab0298ebe095), $18aed9a2ed048594$export$acb96d3092c0904 = function(e, r) {
    if ("function" == typeof e) return e;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.theme;
        }(e)) {
            if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
            var n = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e.theme);
            if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
            return function() {
                return n;
            };
        }
        if (function(e) {
            return void 0 !== e.from;
        }(e)) {
            var t = function(r) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e.from);
            };
            if (Array.isArray(e.modifiers)) {
                for(var o, i = [], u = function() {
                    var e = o.value, r = e[0], n = e[1];
                    if ("brighter" === r) i.push(function(e) {
                        return e.brighter(n);
                    });
                    else if ("darker" === r) i.push(function(e) {
                        return e.darker(n);
                    });
                    else {
                        if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                        i.push(function(e) {
                            return e.opacity = n, e;
                        });
                    }
                }, a = $18aed9a2ed048594$var$Re(e.modifiers); !(o = a()).done;)u();
                return 0 === i.length ? t : function(e) {
                    return i.reduce(function(e, r) {
                        return r(e);
                    }, (0, $b566B.rgb)(t(e))).toString();
                };
            }
            return t;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return e;
    };
}, $18aed9a2ed048594$export$2a9e363116151414 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $18aed9a2ed048594$export$acb96d3092c0904(e, r);
    }, [
        e,
        r
    ]);
}, $18aed9a2ed048594$export$9ef95eaec260ee21 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        scheme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($18aed9a2ed048594$export$b48661626a811234).isRequired,
        size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        datum: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
]), $18aed9a2ed048594$export$5f5a386483e6fff5 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        from: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array)
    })
]), $18aed9a2ed048594$export$30c0b047d59c1130 = {
    scheme: "turbo"
}, $18aed9a2ed048594$export$3c410d9d0181bae0 = function(e, r) {
    var n = e.minValue, t = e.maxValue, o = void 0 !== n ? n : r.min, i = void 0 !== t ? t : r.max, u = (0, $50d03fd061729af1$export$2e2bcd8739ae039)().domain([
        o,
        i
    ]).clamp(!0);
    if ("colors" in e) u.range(e.colors);
    else if ("interpolator" in e) u.interpolator(e.interpolator);
    else {
        var a, l = null != (a = e.scheme) ? a : $18aed9a2ed048594$export$30c0b047d59c1130.scheme;
        u.interpolator($18aed9a2ed048594$export$6638ab0298ebe095[l]);
    }
    return u;
}, $18aed9a2ed048594$export$13bad8adfa9d5e5 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $18aed9a2ed048594$export$3c410d9d0181bae0(e, r);
    }, [
        e,
        r
    ]);
}, $18aed9a2ed048594$export$83a83df24724477a = {
    scheme: "red_yellow_blue",
    divergeAt: .5
}, $18aed9a2ed048594$export$d2925809ff5420bc = function(e, r) {
    var n, t = e.minValue, o = e.maxValue, i = void 0 !== t ? t : r.min, u = void 0 !== o ? o : r.max, a = [
        i,
        i + (u - i) / 2,
        u
    ], l = .5 - (null != (n = e.divergeAt) ? n : $18aed9a2ed048594$export$83a83df24724477a.divergeAt), s = (0, $f54c9799d04b82ad$export$2e2bcd8739ae039)().domain(a).clamp(!0), c = function(e) {
        return String(e);
    };
    if ("colors" in e) c = (0, $f54c9799d04b82ad$export$2e2bcd8739ae039)().domain(a.map(function(e) {
        return e - l * (u - i);
    })).range(e.colors).interpolator();
    else if ("interpolator" in e) c = e.interpolator;
    else {
        var f, p = null != (f = e.scheme) ? f : $18aed9a2ed048594$export$83a83df24724477a.scheme;
        c = $18aed9a2ed048594$export$6638ab0298ebe095[p];
    }
    return s.interpolator(function(e) {
        return c(e + l);
    });
}, $18aed9a2ed048594$export$92d4d3b6e140b0d1 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $18aed9a2ed048594$export$d2925809ff5420bc(e, r);
    }, [
        e,
        r
    ]);
}, $18aed9a2ed048594$export$19b16327818185cf = {
    scheme: "turbo",
    steps: 7
}, $18aed9a2ed048594$export$8442947f078400fb = function(e, r) {
    var n = (0, $2d4e99e5984fdf9f$export$2e2bcd8739ae039)().domain(e.domain || [
        r.min,
        r.max
    ]).nice();
    if ("colors" in e) n.range(e.colors);
    else {
        var t = e.scheme || $18aed9a2ed048594$export$19b16327818185cf.scheme, o = void 0 === e.steps ? $18aed9a2ed048594$export$19b16327818185cf.steps : e.steps, i = $18aed9a2ed048594$export$6638ab0298ebe095[t], u = Array.from({
            length: o
        }).map(function(e, r) {
            return i(r * (1 / (o - 1)));
        });
        n.range(u);
    }
    return n;
}, $18aed9a2ed048594$export$aeb5c6e1cabe7efa = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $18aed9a2ed048594$export$8442947f078400fb(e, r);
    }, [
        e,
        r
    ]);
}, $18aed9a2ed048594$export$351e3420d10d6780 = function(e, r) {
    if (function(e) {
        return "sequential" === e.type;
    }(e)) return $18aed9a2ed048594$export$3c410d9d0181bae0(e, r);
    if (function(e) {
        return "diverging" === e.type;
    }(e)) return $18aed9a2ed048594$export$d2925809ff5420bc(e, r);
    if (function(e) {
        return "quantize" === e.type;
    }(e)) return $18aed9a2ed048594$export$8442947f078400fb(e, r);
    throw new Error("Invalid continuous color scale config");
}, $18aed9a2ed048594$export$4796b471538d60f8 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $18aed9a2ed048594$export$351e3420d10d6780(e, r);
    }, [
        e,
        r
    ]);
}, $18aed9a2ed048594$export$f6ca0f82846310a7 = function(e, r) {
    void 0 === r && (r = 16);
    var n = e.domain();
    if ("thresholds" in e) {
        var t = [], o = (0, $43657edf9f9313df$export$2e2bcd8739ae039)().domain(n).range([
            0,
            1
        ]);
        return e.range().forEach(function(r, n) {
            var i = e.invertExtent(r), u = i[0], a = i[1];
            t.push({
                key: n + ".0",
                offset: o(u),
                stopColor: r
            }), t.push({
                key: n + ".1",
                offset: o(a),
                stopColor: r
            });
        }), t;
    }
    var i = e.copy();
    return 2 === n.length ? i.domain([
        0,
        1
    ]) : 3 === n.length && i.domain([
        0,
        .5,
        1
    ]), i.ticks(r).map(function(e) {
        return {
            key: "" + e,
            offset: e,
            stopColor: "" + i(e)
        };
    });
}, $18aed9a2ed048594$export$c3ea10dbbf6bbab3 = function(e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(e, r);
    };
    if (Array.isArray(e)) {
        var t = (0, $46022730ab65113e$export$2e2bcd8739ae039)(e), o = function(e) {
            return t(n(e));
        };
        return o.scale = t, o;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.datum;
        }(e)) return function(r) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e.datum);
        };
        if (function(e) {
            return void 0 !== e.scheme;
        }(e)) {
            if ($18aed9a2ed048594$export$9f49cca6c7d1dda4(e.scheme)) {
                var i = (0, $46022730ab65113e$export$2e2bcd8739ae039)($18aed9a2ed048594$export$2ad73d393c16f81c[e.scheme]), u = function(e) {
                    return i(n(e));
                };
                return u.scale = i, u;
            }
            if ($18aed9a2ed048594$export$4d028a51ab424d0b(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
                var a = (0, $46022730ab65113e$export$2e2bcd8739ae039)($18aed9a2ed048594$export$2ad73d393c16f81c[e.scheme][e.size || 11]), l = function(e) {
                    return a(n(e));
                };
                return l.scale = a, l;
            }
            if ($18aed9a2ed048594$export$166c33132082d11d(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
                var s = (0, $46022730ab65113e$export$2e2bcd8739ae039)($18aed9a2ed048594$export$2ad73d393c16f81c[e.scheme][e.size || 9]), c = function(e) {
                    return s(n(e));
                };
                return c.scale = s, c;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return e;
    };
}, $18aed9a2ed048594$export$47939777be1516f5 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $18aed9a2ed048594$export$c3ea10dbbf6bbab3(e, r);
    }, [
        e,
        r
    ]);
};


var $dd1da3dd953a1510$var$pi = Math.PI, $dd1da3dd953a1510$var$tau = 2 * $dd1da3dd953a1510$var$pi, $dd1da3dd953a1510$var$epsilon = 1e-6, $dd1da3dd953a1510$var$tauEpsilon = $dd1da3dd953a1510$var$tau - $dd1da3dd953a1510$var$epsilon;
function $dd1da3dd953a1510$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $dd1da3dd953a1510$var$path() {
    return new $dd1da3dd953a1510$var$Path;
}
$dd1da3dd953a1510$var$Path.prototype = $dd1da3dd953a1510$var$path.prototype = {
    constructor: $dd1da3dd953a1510$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $dd1da3dd953a1510$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $dd1da3dd953a1510$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($dd1da3dd953a1510$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $dd1da3dd953a1510$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $dd1da3dd953a1510$var$epsilon || Math.abs(this._y1 - y0) > $dd1da3dd953a1510$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $dd1da3dd953a1510$var$tau + $dd1da3dd953a1510$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $dd1da3dd953a1510$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $dd1da3dd953a1510$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $dd1da3dd953a1510$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $dd1da3dd953a1510$export$2e2bcd8739ae039 = $dd1da3dd953a1510$var$path;


function $678454dfdfb67fe3$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}



var $qCBSE = parcelRequire("qCBSE");
function $e7ead23dd5fd5e5a$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $e7ead23dd5fd5e5a$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $e7ead23dd5fd5e5a$var$arcStartAngle(d) {
    return d.startAngle;
}
function $e7ead23dd5fd5e5a$var$arcEndAngle(d) {
    return d.endAngle;
}
function $e7ead23dd5fd5e5a$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $e7ead23dd5fd5e5a$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $qCBSE.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $e7ead23dd5fd5e5a$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $qCBSE.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $qCBSE.sqrt)((0, $qCBSE.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $e7ead23dd5fd5e5a$export$2e2bcd8739ae039() {
    var innerRadius = $e7ead23dd5fd5e5a$var$arcInnerRadius, outerRadius = $e7ead23dd5fd5e5a$var$arcOuterRadius, cornerRadius = (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $e7ead23dd5fd5e5a$var$arcStartAngle, endAngle = $e7ead23dd5fd5e5a$var$arcEndAngle, padAngle = $e7ead23dd5fd5e5a$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $qCBSE.halfPi), a1 = endAngle.apply(this, arguments) - (0, $qCBSE.halfPi), da = (0, $qCBSE.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $dd1da3dd953a1510$export$2e2bcd8739ae039)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $qCBSE.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $qCBSE.tau) - (0, $qCBSE.epsilon)) {
            context.moveTo(r1 * (0, $qCBSE.cos)(a0), r1 * (0, $qCBSE.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $qCBSE.epsilon)) {
                context.moveTo(r0 * (0, $qCBSE.cos)(a1), r0 * (0, $qCBSE.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $qCBSE.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $qCBSE.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $qCBSE.min)((0, $qCBSE.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $qCBSE.epsilon)) {
                var p0 = (0, $qCBSE.asin)(rp / r0 * (0, $qCBSE.sin)(ap)), p1 = (0, $qCBSE.asin)(rp / r1 * (0, $qCBSE.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $qCBSE.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $qCBSE.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $qCBSE.cos)(a01), y01 = r1 * (0, $qCBSE.sin)(a01), x10 = r0 * (0, $qCBSE.cos)(a10), y10 = r0 * (0, $qCBSE.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $qCBSE.epsilon)) {
                var x11 = r1 * (0, $qCBSE.cos)(a11), y11 = r1 * (0, $qCBSE.sin)(a11), x00 = r0 * (0, $qCBSE.cos)(a00), y00 = r0 * (0, $qCBSE.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $qCBSE.pi) && (oc = $e7ead23dd5fd5e5a$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $qCBSE.sin)((0, $qCBSE.acos)((ax * bx + ay * by) / ((0, $qCBSE.sqrt)(ax * ax + ay * ay) * (0, $qCBSE.sqrt)(bx * bx + by * by))) / 2), lc = (0, $qCBSE.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $qCBSE.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $qCBSE.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $qCBSE.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $qCBSE.epsilon)) {
                t0 = $e7ead23dd5fd5e5a$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $e7ead23dd5fd5e5a$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $qCBSE.atan2)(t0.y01, t0.x01), (0, $qCBSE.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $qCBSE.atan2)(t0.y01, t0.x01), (0, $qCBSE.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $qCBSE.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $qCBSE.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $qCBSE.atan2)(t1.y11, t1.x11), (0, $qCBSE.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $qCBSE.epsilon)) || !(da0 > (0, $qCBSE.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $qCBSE.epsilon)) {
                t0 = $e7ead23dd5fd5e5a$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $e7ead23dd5fd5e5a$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $qCBSE.atan2)(t0.y01, t0.x01), (0, $qCBSE.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $qCBSE.atan2)(t0.y01, t0.x01), (0, $qCBSE.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $qCBSE.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $qCBSE.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $qCBSE.atan2)(t1.y11, t1.x11), (0, $qCBSE.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $qCBSE.pi) / 2;
        return [
            (0, $qCBSE.cos)(a) * r,
            (0, $qCBSE.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}




function $30204b10fe7aac69$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $30204b10fe7aac69$export$4a5767248b18ef41(p) {
    return p[1];
}


function $b88cb4978b49d732$export$2e2bcd8739ae039() {
    var x = (0, $30204b10fe7aac69$export$d141bba7fdc215a3), y = (0, $30204b10fe7aac69$export$4a5767248b18ef41), defined = (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(true), context = null, curve = (0, $ef8d0d3e260330b4$export$2e2bcd8739ae039), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $dd1da3dd953a1510$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}


function $f9647e1e2a37a3bb$var$M() {
    return $f9647e1e2a37a3bb$var$M = Object.assign || function(t) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $f9647e1e2a37a3bb$var$M.apply(this, arguments);
}
var $f9647e1e2a37a3bb$var$k = {
    pointerEvents: "none"
}, $f9647e1e2a37a3bb$var$C = function(n) {
    var e = n.label, r = n.style, a = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        transform: r.transform,
        opacity: r.progress,
        style: $f9647e1e2a37a3bb$var$k,
        children: (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
            textAnchor: "middle",
            dominantBaseline: "central",
            style: $f9647e1e2a37a3bb$var$M({}, a.labels.text, {
                fill: r.textColor
            }),
            children: e
        })
    });
}, $f9647e1e2a37a3bb$var$b = function(t) {
    var n = t % (2 * Math.PI);
    return n < 0 && (n += 2 * Math.PI), n;
}, $f9647e1e2a37a3bb$var$L = function(t, n) {
    return t.filter(function(t) {
        return Math.abs((0, $0332e848e6fa2251$export$c41dd2a8460d3196)(t.arc.endAngle - t.arc.startAngle)) >= n;
    });
}, $f9647e1e2a37a3bb$var$P = function(t, n, e, r, i) {
    return [
        "A",
        t,
        t,
        0,
        n,
        e,
        r,
        i
    ].join(" ");
}, $f9647e1e2a37a3bb$export$d2a093ad2bac157 = [
    "startAngle",
    "middleAngle",
    "endAngle",
    "innerRadius",
    "centerRadius",
    "outerRadius",
    "pushIn",
    "pushOut"
], $f9647e1e2a37a3bb$export$81e64a3650c150c1 = {
    startAngle: {
        enter: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                endAngle: t.startAngle
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                startAngle: t.endAngle
            });
        }
    },
    middleAngle: {
        enter: function(t) {
            var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
            return $f9647e1e2a37a3bb$var$M({}, t, {
                startAngle: n,
                endAngle: n
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
            return $f9647e1e2a37a3bb$var$M({}, t, {
                startAngle: n,
                endAngle: n
            });
        }
    },
    endAngle: {
        enter: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                startAngle: t.endAngle
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                endAngle: t.startAngle
            });
        }
    },
    innerRadius: {
        enter: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                outerRadius: t.innerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: t.outerRadius
            });
        }
    },
    centerRadius: {
        enter: function(t) {
            var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: n,
                outerRadius: n
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: n,
                outerRadius: n
            });
        }
    },
    outerRadius: {
        enter: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: t.outerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                outerRadius: t.innerRadius
            });
        }
    },
    pushIn: {
        enter: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
                outerRadius: t.innerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: t.outerRadius,
                outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
            });
        }
    },
    pushOut: {
        enter: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: t.outerRadius,
                outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $f9647e1e2a37a3bb$var$M({}, t, {
                innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
                outerRadius: t.innerRadius
            });
        }
    }
}, $f9647e1e2a37a3bb$export$a313c3952fef8fc3 = function(t, n) {
    return (0, $7fPBF.useMemo)(function() {
        var e = $f9647e1e2a37a3bb$export$81e64a3650c150c1[t];
        return {
            enter: function(t) {
                return $f9647e1e2a37a3bb$var$M({
                    progress: 0
                }, e.enter(t.arc), n ? n.enter(t) : {});
            },
            update: function(t) {
                return $f9647e1e2a37a3bb$var$M({
                    progress: 1
                }, e.update(t.arc), n ? n.update(t) : {});
            },
            leave: function(t) {
                return $f9647e1e2a37a3bb$var$M({
                    progress: 0
                }, e.leave(t.arc), n ? n.leave(t) : {});
            }
        };
    }, [
        t,
        n
    ]);
}, $f9647e1e2a37a3bb$export$f7b13546106819e8 = function(t, n) {
    var e = (0, $0332e848e6fa2251$export$61f3799bad189d2e)(t) - Math.PI / 2, r = t.innerRadius + (t.outerRadius - t.innerRadius) * n;
    return (0, $0332e848e6fa2251$export$2e16b01652730550)(e, r);
}, $f9647e1e2a37a3bb$export$aee1f2bb11698da9 = function(t) {
    return function(e, r, i, a) {
        return (0, $27d73b36303119b6$export$2c618a4308a30424)([
            e,
            r,
            i,
            a
        ], function(n, e, r, i) {
            var a = $f9647e1e2a37a3bb$export$f7b13546106819e8({
                startAngle: n,
                endAngle: e,
                innerRadius: r,
                outerRadius: i
            }, t);
            return "translate(" + a.x + "," + a.y + ")";
        });
    };
}, $f9647e1e2a37a3bb$export$e64eb3d94f48a98e = function(t, n, r, i) {
    void 0 === n && (n = .5), void 0 === r && (r = "innerRadius");
    var a = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), o = a.animate, u = a.config, l = $f9647e1e2a37a3bb$export$a313c3952fef8fc3(r, i);
    return {
        transition: (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(t, {
            keys: function(t) {
                return t.id;
            },
            initial: l.update,
            from: l.enter,
            enter: l.update,
            update: l.update,
            leave: l.leave,
            config: u,
            immediate: !o
        }),
        interpolate: $f9647e1e2a37a3bb$export$aee1f2bb11698da9(n)
    };
}, $f9647e1e2a37a3bb$export$92aaf3f031db9626 = function(t) {
    var n = t.data, e = t.offset, r = void 0 === e ? .5 : e, i = t.skipAngle, a = void 0 === i ? 0 : i, o = t.computeExtraProps, u = void 0 === o ? function() {
        return {};
    } : o;
    return (0, $7fPBF.useMemo)(function() {
        return $f9647e1e2a37a3bb$var$L(n, a).map(function(t) {
            var n = $f9647e1e2a37a3bb$export$f7b13546106819e8(t.arc, r);
            return $f9647e1e2a37a3bb$var$M({}, u(t), {
                x: n.x,
                y: n.y,
                data: t
            });
        });
    }, [
        n,
        r,
        a,
        u
    ]);
}, $f9647e1e2a37a3bb$export$6aed5a877c5fc8a1 = function(t) {
    var n = t.center, e = t.data, r = t.transitionMode, o = t.label, u = t.radiusOffset, l = t.skipAngle, s = t.textColor, f = t.component, c = void 0 === f ? $f9647e1e2a37a3bb$var$C : f, g = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(o), h = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), x = (0, $18aed9a2ed048594$export$2a9e363116151414)(s, h), m = (0, $7fPBF.useMemo)(function() {
        return e.filter(function(t) {
            return Math.abs((0, $0332e848e6fa2251$export$c41dd2a8460d3196)(t.arc.endAngle - t.arc.startAngle)) >= l;
        });
    }, [
        e,
        l
    ]), y = $f9647e1e2a37a3bb$export$e64eb3d94f48a98e(m, u, r), k = y.transition, b = y.interpolate, L = c;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + n[0] + "," + n[1] + ")",
        children: k(function(t, n) {
            return (0, $7fPBF.createElement)(L, {
                key: n.id,
                datum: n,
                label: g(n),
                style: $f9647e1e2a37a3bb$var$M({}, t, {
                    transform: b(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
                    textColor: x(n)
                })
            });
        })
    });
}, $f9647e1e2a37a3bb$export$3162ce2b4ca97f8a = function(t, n, e) {
    t.textAlign = "center", t.textBaseline = "middle", t.font = e.labels.text.fontSize + "px " + e.labels.text.fontFamily, n.forEach(function(n) {
        t.fillStyle = n.textColor, t.fillText("" + n.label, n.x, n.y);
    });
}, $f9647e1e2a37a3bb$export$13804dbea81a51a5 = function(t) {
    var n = t.data, e = t.offset, r = t.skipAngle, a = t.label, o = t.textColor, u = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(a), l = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), s = (0, $18aed9a2ed048594$export$2a9e363116151414)(o, l), f = (0, $7fPBF.useCallback)(function(t) {
        return {
            label: u(t),
            textColor: s(t)
        };
    }, [
        u,
        s
    ]);
    return $f9647e1e2a37a3bb$export$92aaf3f031db9626({
        data: n,
        offset: e,
        skipAngle: r,
        computeExtraProps: f
    });
}, $f9647e1e2a37a3bb$export$6749c13ec724bdf8 = $f9647e1e2a37a3bb$var$C, $f9647e1e2a37a3bb$var$G = function(n) {
    var e = n.label, r = n.style, a = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        opacity: r.opacity,
        children: [
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
                fill: "none",
                stroke: r.linkColor,
                strokeWidth: r.thickness,
                d: r.path
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                transform: r.textPosition,
                textAnchor: r.textAnchor,
                dominantBaseline: "central",
                style: $f9647e1e2a37a3bb$var$M({}, a.labels.text, {
                    fill: r.textColor
                }),
                children: e
            })
        ]
    });
}, $f9647e1e2a37a3bb$export$248385da08f607e = function(t) {
    var n = $f9647e1e2a37a3bb$var$b(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2);
    return n < Math.PI / 2 || n > 1.5 * Math.PI ? "start" : "end";
}, $f9647e1e2a37a3bb$export$67742f271c0ba17f = function(t, n, e, r) {
    var i, a, u = $f9647e1e2a37a3bb$var$b(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2), l = (0, $0332e848e6fa2251$export$2e16b01652730550)(u, t.outerRadius + n), s = (0, $0332e848e6fa2251$export$2e16b01652730550)(u, t.outerRadius + n + e);
    return u < Math.PI / 2 || u > 1.5 * Math.PI ? (i = "after", a = {
        x: s.x + r,
        y: s.y
    }) : (i = "before", a = {
        x: s.x - r,
        y: s.y
    }), {
        side: i,
        points: [
            l,
            s,
            a
        ]
    };
}, $f9647e1e2a37a3bb$var$H = (0, $b88cb4978b49d732$export$2e2bcd8739ae039)().x(function(t) {
    return t.x;
}).y(function(t) {
    return t.y;
}), $f9647e1e2a37a3bb$var$J = function(t, e, r, i, a, o, u) {
    return (0, $27d73b36303119b6$export$2c618a4308a30424)([
        t,
        e,
        r,
        i,
        a,
        o,
        u
    ], function(t, n, e, r, i, a, o) {
        var u = $f9647e1e2a37a3bb$export$67742f271c0ba17f({
            startAngle: t,
            endAngle: n,
            innerRadius: e,
            outerRadius: r
        }, i, a, o).points;
        return $f9647e1e2a37a3bb$var$H(u);
    });
}, $f9647e1e2a37a3bb$var$K = function(t, e, r, i) {
    return (0, $27d73b36303119b6$export$2c618a4308a30424)([
        t,
        e,
        r,
        i
    ], function(t, n, e, r) {
        return $f9647e1e2a37a3bb$export$248385da08f607e({
            startAngle: t,
            endAngle: n,
            innerRadius: e,
            outerRadius: r
        });
    });
}, $f9647e1e2a37a3bb$var$N = function(t, e, r, i, a, o, u, l) {
    return (0, $27d73b36303119b6$export$2c618a4308a30424)([
        t,
        e,
        r,
        i,
        a,
        o,
        u,
        l
    ], function(t, n, e, r, i, a, o, u) {
        var l = $f9647e1e2a37a3bb$export$67742f271c0ba17f({
            startAngle: t,
            endAngle: n,
            innerRadius: e,
            outerRadius: r
        }, i, a, o), s = l.points, d = l.side, f = s[2];
        return "before" === d ? f.x -= u : f.x += u, "translate(" + f.x + "," + f.y + ")";
    });
}, $f9647e1e2a37a3bb$export$5a16238ff9674f1b = function(t) {
    var n = t.data, r = t.offset, a = void 0 === r ? 0 : r, o = t.diagonalLength, u = t.straightLength, l = t.skipAngle, d = void 0 === l ? 0 : l, f = t.textOffset, c = t.linkColor, g = t.textColor, p = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), h = p.animate, A = p.config, x = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), m = (0, $18aed9a2ed048594$export$2a9e363116151414)(c, x), y = (0, $18aed9a2ed048594$export$2a9e363116151414)(g, x), M = function(t, n) {
        return (0, $7fPBF.useMemo)(function() {
            return $f9647e1e2a37a3bb$var$L(t, n);
        }, [
            t,
            n
        ]);
    }(n, d), k = function(t) {
        var n = t.offset, e = t.diagonalLength, r = t.straightLength, i = t.textOffset, a = t.getLinkColor, o = t.getTextColor;
        return (0, $7fPBF.useMemo)(function() {
            return {
                enter: function(t) {
                    return {
                        startAngle: t.arc.startAngle,
                        endAngle: t.arc.endAngle,
                        innerRadius: t.arc.innerRadius,
                        outerRadius: t.arc.outerRadius,
                        offset: n,
                        diagonalLength: 0,
                        straightLength: 0,
                        textOffset: i,
                        linkColor: a(t),
                        textColor: o(t),
                        opacity: 0
                    };
                },
                update: function(t) {
                    return {
                        startAngle: t.arc.startAngle,
                        endAngle: t.arc.endAngle,
                        innerRadius: t.arc.innerRadius,
                        outerRadius: t.arc.outerRadius,
                        offset: n,
                        diagonalLength: e,
                        straightLength: r,
                        textOffset: i,
                        linkColor: a(t),
                        textColor: o(t),
                        opacity: 1
                    };
                },
                leave: function(t) {
                    return {
                        startAngle: t.arc.startAngle,
                        endAngle: t.arc.endAngle,
                        innerRadius: t.arc.innerRadius,
                        outerRadius: t.arc.outerRadius,
                        offset: n,
                        diagonalLength: 0,
                        straightLength: 0,
                        textOffset: i,
                        linkColor: a(t),
                        textColor: o(t),
                        opacity: 0
                    };
                }
            };
        }, [
            e,
            r,
            i,
            a,
            o
        ]);
    }({
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: f,
        getLinkColor: m,
        getTextColor: y
    });
    return {
        transition: (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(M, {
            keys: function(t) {
                return t.id;
            },
            initial: k.update,
            from: k.enter,
            enter: k.update,
            update: k.update,
            leave: k.leave,
            config: A,
            immediate: !h
        }),
        interpolateLink: $f9647e1e2a37a3bb$var$J,
        interpolateTextAnchor: $f9647e1e2a37a3bb$var$K,
        interpolateTextPosition: $f9647e1e2a37a3bb$var$N
    };
}, $f9647e1e2a37a3bb$export$ea70f6ffe59d94b1 = function(t) {
    var n = t.center, e = t.data, r = t.label, i = t.skipAngle, a = t.offset, o = t.diagonalLength, u = t.straightLength, l = t.strokeWidth, s = t.textOffset, f = t.textColor, c = t.linkColor, g = t.component, h = void 0 === g ? $f9647e1e2a37a3bb$var$G : g, v = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(r), x = $f9647e1e2a37a3bb$export$5a16238ff9674f1b({
        data: e,
        skipAngle: i,
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: s,
        linkColor: c,
        textColor: f
    }), R = x.transition, m = x.interpolateLink, y = x.interpolateTextAnchor, k = x.interpolateTextPosition, C = h;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + n[0] + "," + n[1] + ")",
        children: R(function(t, n) {
            return (0, $7fPBF.createElement)(C, {
                key: n.id,
                datum: n,
                label: v(n),
                style: $f9647e1e2a37a3bb$var$M({}, t, {
                    thickness: l,
                    path: m(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength),
                    textAnchor: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
                    textPosition: k(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength, t.textOffset)
                })
            });
        })
    });
}, $f9647e1e2a37a3bb$export$3aacf153e19c708d = function(t, n, e, r) {
    t.textBaseline = "middle", t.font = e.labels.text.fontSize + "px " + e.labels.text.fontFamily, n.forEach(function(n) {
        t.fillStyle = n.textColor, t.textAlign = (0, $0332e848e6fa2251$export$1abb91cfca1e2069).canvas.align[n.textAnchor], t.fillText("" + n.label, n.x, n.y), t.beginPath(), t.strokeStyle = n.linkColor, t.lineWidth = r, n.points.forEach(function(n, e) {
            0 === e ? t.moveTo(n.x, n.y) : t.lineTo(n.x, n.y);
        }), t.stroke();
    });
}, $f9647e1e2a37a3bb$export$1b7846c545dc3357 = function(t) {
    var n = t.data, e = t.skipAngle, r = void 0 === e ? 0 : e, i = t.offset, o = void 0 === i ? .5 : i, u = t.diagonalLength, l = t.straightLength, s = t.computeExtraProps, d = void 0 === s ? function() {
        return {};
    } : s, f = (0, $7fPBF.useMemo)(function() {
        return n.filter(function(t) {
            return Math.abs((0, $0332e848e6fa2251$export$c41dd2a8460d3196)(t.arc.endAngle - t.arc.startAngle)) >= r;
        }).map(function(t) {
            return $f9647e1e2a37a3bb$var$M({}, $f9647e1e2a37a3bb$export$67742f271c0ba17f(t.arc, o, u, l), {
                data: t
            });
        });
    }, [
        n,
        r,
        o,
        u,
        l
    ]);
    return (0, $7fPBF.useMemo)(function() {
        return f.map(function(t) {
            return $f9647e1e2a37a3bb$var$M({}, d(t), t);
        });
    }, [
        f,
        d
    ]);
}, $f9647e1e2a37a3bb$export$a2fecac67fe4140c = function(t) {
    var n = t.data, e = t.skipAngle, r = t.offset, a = t.diagonalLength, o = t.straightLength, u = t.textOffset, l = void 0 === u ? 0 : u, s = t.label, f = t.linkColor, c = t.textColor, g = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(s), p = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), h = (0, $18aed9a2ed048594$export$2a9e363116151414)(f, p), v = (0, $18aed9a2ed048594$export$2a9e363116151414)(c, p), A = (0, $7fPBF.useCallback)(function(t) {
        var n, e = {
            x: t.points[2].x,
            y: t.points[2].y
        };
        return "before" === t.side ? (e.x -= l, n = "end") : (e.x += l, n = "start"), $f9647e1e2a37a3bb$var$M({}, e, {
            label: g(t.data),
            linkColor: h(t.data),
            textAnchor: n,
            textColor: v(t.data)
        });
    }, [
        g,
        h,
        v,
        l
    ]);
    return $f9647e1e2a37a3bb$export$1b7846c545dc3357({
        data: n,
        skipAngle: e,
        offset: r,
        diagonalLength: a,
        straightLength: o,
        computeExtraProps: A
    });
}, $f9647e1e2a37a3bb$export$da1cc05ae2b05876 = $f9647e1e2a37a3bb$var$G, $f9647e1e2a37a3bb$var$$ = [
    "animated"
], $f9647e1e2a37a3bb$export$7f622f5e9941ffc5 = function(e) {
    var r = e.animated, i = function(t, n) {
        if (null == t) return {};
        var e, r, i = {}, a = Object.keys(t);
        for(r = 0; r < a.length; r++)e = a[r], n.indexOf(e) >= 0 || (i[e] = t[e]);
        return i;
    }(e, $f9647e1e2a37a3bb$var$$);
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, $f9647e1e2a37a3bb$var$M({
        d: (0, $27d73b36303119b6$export$2c618a4308a30424)([
            r.radius,
            r.startAngle,
            r.endAngle
        ], function(t, n, e) {
            return function(t, n, e) {
                var r = Math.min(n, e), i = Math.max(n, e), a = (0, $0332e848e6fa2251$export$2e16b01652730550)((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(i), t), l = (0, $0332e848e6fa2251$export$2e16b01652730550)((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(r), t);
                if (i - r >= 360) {
                    var s = (0, $0332e848e6fa2251$export$2e16b01652730550)((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(r + 180), t);
                    return [
                        "M " + a.x + " " + a.y,
                        $f9647e1e2a37a3bb$var$P(t, 1, 1, s.x, s.y),
                        "M " + a.x + " " + a.y,
                        $f9647e1e2a37a3bb$var$P(t, 1, 0, s.x, s.y)
                    ].join(" ");
                }
                var d = i - r <= 180 ? 0 : 1;
                return [
                    "M " + a.x + " " + a.y,
                    $f9647e1e2a37a3bb$var$P(t, d, 0, l.x, l.y)
                ].join(" ");
            }(t, n, e);
        })
    }, i));
}, $f9647e1e2a37a3bb$export$a259dbdc51948277 = function(n) {
    var e = n.datum, r = n.style, i = n.onClick, a = n.onMouseEnter, o = n.onMouseMove, u = n.onMouseLeave, l = (0, $7fPBF.useCallback)(function(t) {
        return null == i ? void 0 : i(e, t);
    }, [
        i,
        e
    ]), s = (0, $7fPBF.useCallback)(function(t) {
        return null == a ? void 0 : a(e, t);
    }, [
        a,
        e
    ]), d = (0, $7fPBF.useCallback)(function(t) {
        return null == o ? void 0 : o(e, t);
    }, [
        o,
        e
    ]), f = (0, $7fPBF.useCallback)(function(t) {
        return null == u ? void 0 : u(e, t);
    }, [
        u,
        e
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
        d: r.path,
        opacity: r.opacity,
        fill: e.fill || r.color,
        stroke: r.borderColor,
        strokeWidth: r.borderWidth,
        onClick: i ? l : void 0,
        onMouseEnter: a ? s : void 0,
        onMouseMove: o ? d : void 0,
        onMouseLeave: u ? f : void 0
    });
}, $f9647e1e2a37a3bb$export$c01f32ffac6cf6f5 = function(t, e, r, i, a) {
    return (0, $27d73b36303119b6$export$2c618a4308a30424)([
        t,
        e,
        r,
        i
    ], function(t, n, e, r) {
        return a({
            startAngle: t,
            endAngle: n,
            innerRadius: Math.max(0, e),
            outerRadius: Math.max(0, r)
        });
    });
}, $f9647e1e2a37a3bb$export$36567afd66e798ad = function(t, n, r) {
    void 0 === n && (n = "innerRadius");
    var i = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), a = i.animate, o = i.config, u = $f9647e1e2a37a3bb$export$a313c3952fef8fc3(n, r);
    return {
        transition: (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(t, {
            keys: function(t) {
                return t.id;
            },
            initial: u.update,
            from: u.enter,
            enter: u.update,
            update: u.update,
            leave: u.leave,
            config: o,
            immediate: !a
        }),
        interpolate: $f9647e1e2a37a3bb$export$c01f32ffac6cf6f5
    };
}, $f9647e1e2a37a3bb$export$aa2d92ba89b625ed = function(t) {
    var n = t.center, e = t.data, r = t.arcGenerator, a = t.borderWidth, o = t.borderColor, u = t.onClick, l = t.onMouseEnter, s = t.onMouseMove, d = t.onMouseLeave, f = t.transitionMode, c = t.component, g = void 0 === c ? $f9647e1e2a37a3bb$export$a259dbdc51948277 : c, h = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), v = (0, $18aed9a2ed048594$export$2a9e363116151414)(o, h), x = $f9647e1e2a37a3bb$export$36567afd66e798ad(e, f, {
        enter: function(t) {
            return {
                opacity: 0,
                color: t.color,
                borderColor: v(t)
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                color: t.color,
                borderColor: v(t)
            };
        },
        leave: function(t) {
            return {
                opacity: 0,
                color: t.color,
                borderColor: v(t)
            };
        }
    }), m = x.transition, y = x.interpolate, k = g;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + n[0] + "," + n[1] + ")",
        children: m(function(t, n) {
            return (0, $7fPBF.createElement)(k, {
                key: n.id,
                datum: n,
                style: $f9647e1e2a37a3bb$var$M({}, t, {
                    borderWidth: a,
                    path: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, r)
                }),
                onClick: u,
                onMouseEnter: l,
                onMouseMove: s,
                onMouseLeave: d
            });
        })
    });
}, $f9647e1e2a37a3bb$export$ac350cdccf8fe5e4 = function(t, n, e, r, i, a) {
    void 0 === a && (a = !0);
    var l = [], s = (0, $0332e848e6fa2251$export$2e16b01652730550)((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(r), e);
    l.push([
        s.x,
        s.y
    ]);
    var d = (0, $0332e848e6fa2251$export$2e16b01652730550)((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(i), e);
    l.push([
        d.x,
        d.y
    ]);
    for(var f = Math.round(Math.min(r, i)); f <= Math.round(Math.max(r, i)); f++)if (f % 90 == 0) {
        var c = (0, $0332e848e6fa2251$export$2e16b01652730550)((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(f), e);
        l.push([
            c.x,
            c.y
        ]);
    }
    l = l.map(function(e) {
        var r = e[0], i = e[1];
        return [
            t + r,
            n + i
        ];
    }), a && l.push([
        t,
        n
    ]);
    var g = l.map(function(t) {
        return t[0];
    }), p = l.map(function(t) {
        return t[1];
    }), h = Math.min.apply(Math, g), v = Math.max.apply(Math, g), A = Math.min.apply(Math, p);
    return {
        points: l,
        x: h,
        y: A,
        width: v - h,
        height: Math.max.apply(Math, p) - A
    };
}, $f9647e1e2a37a3bb$export$c1d34fa0d5d8e0e2 = function(t, n, e, r, i, a) {
    var o = (0, $0332e848e6fa2251$export$79376507b09a66f)(i, a, t, n);
    return o < e && o > r;
}, $f9647e1e2a37a3bb$export$f797b637b9988726 = function(t, n, e, r, i, a, o) {
    if ($f9647e1e2a37a3bb$export$c1d34fa0d5d8e0e2(t, n, e, r, a, o)) {
        var u = (0, $0332e848e6fa2251$export$b363da9ded343252)(a, o, t, n);
        return i.find(function(t) {
            var n = t.startAngle, e = t.endAngle;
            return u >= n && u < e;
        });
    }
}, $f9647e1e2a37a3bb$export$7b66ccfb3ae3d569 = function(t, n) {
    var e = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), i = e.animate, a = e.config, o = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        startAngle: t.arc.startAngle,
        endAngle: t.arc.endAngle,
        innerRadius: t.arc.innerRadius,
        outerRadius: t.arc.outerRadius,
        config: a,
        immediate: !i
    });
    return $f9647e1e2a37a3bb$var$M({}, o, {
        path: $f9647e1e2a37a3bb$export$c01f32ffac6cf6f5(o.startAngle, o.endAngle, o.innerRadius, o.outerRadius, n)
    });
}, $f9647e1e2a37a3bb$export$9dba50da1768ab65 = function(t) {
    var n = void 0 === t ? {} : t, e = n.cornerRadius, r = void 0 === e ? 0 : e, i = n.padAngle, a = void 0 === i ? 0 : i;
    return (0, $7fPBF.useMemo)(function() {
        return (0, $e7ead23dd5fd5e5a$export$2e2bcd8739ae039)().innerRadius(function(t) {
            return t.innerRadius;
        }).outerRadius(function(t) {
            return t.outerRadius;
        }).cornerRadius(r).padAngle(a);
    }, [
        r,
        a
    ]);
};




function $e78424344ab9ea1f$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $e78424344ab9ea1f$export$2e2bcd8739ae039() {
    return this.eachAfter($e78424344ab9ea1f$var$count);
}


function $7e2608081e98421c$export$2e2bcd8739ae039(callback) {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            callback(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
    return this;
}


function $b40faa655ac07ace$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], children, i;
    while(node = nodes.pop()){
        callback(node), children = node.children;
        if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}


function $265baa99397b43fb$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n;
    while(node = nodes.pop()){
        next.push(node), children = node.children;
        if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback(node);
    return this;
}


function $42042d133c2279b9$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}


function $69aff20629ff7758$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}


function $0902070a1f42a16d$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $0902070a1f42a16d$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $0902070a1f42a16d$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}


function $1e4234451d59b88f$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}


function $dc3dbff2c4222d06$export$2e2bcd8739ae039() {
    var nodes = [];
    this.each(function(node) {
        nodes.push(node);
    });
    return nodes;
}


function $c5f72a243f7cbd7b$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}


function $04ca87ccc67fdeae$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}


function $166c72ae2a5c0694$export$2e2bcd8739ae039(data, children) {
    var root = new $166c72ae2a5c0694$export$85c928794f8d04d4(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = $166c72ae2a5c0694$var$defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new $166c72ae2a5c0694$export$85c928794f8d04d4(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore($166c72ae2a5c0694$export$5af32d52ab5dfd57);
}
function $166c72ae2a5c0694$var$node_copy() {
    return $166c72ae2a5c0694$export$2e2bcd8739ae039(this).eachBefore($166c72ae2a5c0694$var$copyData);
}
function $166c72ae2a5c0694$var$defaultChildren(d) {
    return d.children;
}
function $166c72ae2a5c0694$var$copyData(node) {
    node.data = node.data.data;
}
function $166c72ae2a5c0694$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $166c72ae2a5c0694$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$166c72ae2a5c0694$export$85c928794f8d04d4.prototype = $166c72ae2a5c0694$export$2e2bcd8739ae039.prototype = {
    constructor: $166c72ae2a5c0694$export$85c928794f8d04d4,
    count: (0, $e78424344ab9ea1f$export$2e2bcd8739ae039),
    each: (0, $7e2608081e98421c$export$2e2bcd8739ae039),
    eachAfter: (0, $265baa99397b43fb$export$2e2bcd8739ae039),
    eachBefore: (0, $b40faa655ac07ace$export$2e2bcd8739ae039),
    sum: (0, $42042d133c2279b9$export$2e2bcd8739ae039),
    sort: (0, $69aff20629ff7758$export$2e2bcd8739ae039),
    path: (0, $0902070a1f42a16d$export$2e2bcd8739ae039),
    ancestors: (0, $1e4234451d59b88f$export$2e2bcd8739ae039),
    descendants: (0, $dc3dbff2c4222d06$export$2e2bcd8739ae039),
    leaves: (0, $c5f72a243f7cbd7b$export$2e2bcd8739ae039),
    links: (0, $04ca87ccc67fdeae$export$2e2bcd8739ae039),
    copy: $166c72ae2a5c0694$var$node_copy
};

function $223bb0c882681b6f$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}


function $ee41f855f383c65b$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}


function $669650112604b322$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $223bb0c882681b6f$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $ee41f855f383c65b$export$2e2bcd8739ae039)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}


var $60d3fa686d955280$exports = {};
var $f69c86ceef3a17b2$exports = {};

var $a3dabfafa21b6614$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a3dabfafa21b6614$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$a3dabfafa21b6614$exports = $a3dabfafa21b6614$var$arrayEach;



var $65b2863dcb7dc1a3$exports = {};


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $65b2863dcb7dc1a3$var$baseAssign(object, source) {
    return object && $2089e20ff6782bbb$exports(source, $0fce4239ee480ef0$exports(source), object);
}
$65b2863dcb7dc1a3$exports = $65b2863dcb7dc1a3$var$baseAssign;


var $58ef0f8ba3c6d113$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $58ef0f8ba3c6d113$var$baseAssignIn(object, source) {
    return object && $2089e20ff6782bbb$exports(source, $9602693ae93bd599$exports(source), object);
}
$58ef0f8ba3c6d113$exports = $58ef0f8ba3c6d113$var$baseAssignIn;



var $gw5oW = parcelRequire("gw5oW");

var $c0761f09fe7e3110$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c0761f09fe7e3110$var$copySymbols(source, object) {
    return $2089e20ff6782bbb$exports(source, $f7bf8d1519698205$exports(source), object);
}
$c0761f09fe7e3110$exports = $c0761f09fe7e3110$var$copySymbols;


var $6e816135bde431a4$exports = {};

var $b463bdab801260c4$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $b463bdab801260c4$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b463bdab801260c4$var$getSymbolsIn = !$b463bdab801260c4$var$nativeGetSymbols ? $fd38b0983d4c349d$exports : function(object) {
    var result = [];
    while(object){
        $efe685e6768936ef$exports(result, $f7bf8d1519698205$exports(object));
        object = $2272f6d455ebd3b2$exports(object);
    }
    return result;
};
$b463bdab801260c4$exports = $b463bdab801260c4$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $6e816135bde431a4$var$copySymbolsIn(source, object) {
    return $2089e20ff6782bbb$exports(source, $b463bdab801260c4$exports(source), object);
}
$6e816135bde431a4$exports = $6e816135bde431a4$var$copySymbolsIn;



var $6e54e90bc363339e$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6e54e90bc363339e$var$getAllKeysIn(object) {
    return $5b332bf09b0c6ec2$exports(object, $9602693ae93bd599$exports, $b463bdab801260c4$exports);
}
$6e54e90bc363339e$exports = $6e54e90bc363339e$var$getAllKeysIn;



var $40dda5fd764f7548$exports = {};
/** Used for built-in method references. */ var $40dda5fd764f7548$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $40dda5fd764f7548$var$hasOwnProperty = $40dda5fd764f7548$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $40dda5fd764f7548$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $40dda5fd764f7548$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$40dda5fd764f7548$exports = $40dda5fd764f7548$var$initCloneArray;


var $c7fabaf74bcca905$exports = {};

var $b105e513df4d9f6e$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $b105e513df4d9f6e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $c5a4265f8c412cdf$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$b105e513df4d9f6e$exports = $b105e513df4d9f6e$var$cloneDataView;


var $a7e8313cd867d9c7$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $a7e8313cd867d9c7$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $a7e8313cd867d9c7$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $a7e8313cd867d9c7$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$a7e8313cd867d9c7$exports = $a7e8313cd867d9c7$var$cloneRegExp;


var $9039dc7ee5ee9432$exports = {};

/** Used to convert symbols to primitives and strings. */ var $9039dc7ee5ee9432$var$symbolProto = $c9c36e86f7d6f497$exports ? $c9c36e86f7d6f497$exports.prototype : undefined, $9039dc7ee5ee9432$var$symbolValueOf = $9039dc7ee5ee9432$var$symbolProto ? $9039dc7ee5ee9432$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $9039dc7ee5ee9432$var$cloneSymbol(symbol) {
    return $9039dc7ee5ee9432$var$symbolValueOf ? Object($9039dc7ee5ee9432$var$symbolValueOf.call(symbol)) : {};
}
$9039dc7ee5ee9432$exports = $9039dc7ee5ee9432$var$cloneSymbol;



/** `Object#toString` result references. */ var $c7fabaf74bcca905$var$boolTag = "[object Boolean]", $c7fabaf74bcca905$var$dateTag = "[object Date]", $c7fabaf74bcca905$var$mapTag = "[object Map]", $c7fabaf74bcca905$var$numberTag = "[object Number]", $c7fabaf74bcca905$var$regexpTag = "[object RegExp]", $c7fabaf74bcca905$var$setTag = "[object Set]", $c7fabaf74bcca905$var$stringTag = "[object String]", $c7fabaf74bcca905$var$symbolTag = "[object Symbol]";
var $c7fabaf74bcca905$var$arrayBufferTag = "[object ArrayBuffer]", $c7fabaf74bcca905$var$dataViewTag = "[object DataView]", $c7fabaf74bcca905$var$float32Tag = "[object Float32Array]", $c7fabaf74bcca905$var$float64Tag = "[object Float64Array]", $c7fabaf74bcca905$var$int8Tag = "[object Int8Array]", $c7fabaf74bcca905$var$int16Tag = "[object Int16Array]", $c7fabaf74bcca905$var$int32Tag = "[object Int32Array]", $c7fabaf74bcca905$var$uint8Tag = "[object Uint8Array]", $c7fabaf74bcca905$var$uint8ClampedTag = "[object Uint8ClampedArray]", $c7fabaf74bcca905$var$uint16Tag = "[object Uint16Array]", $c7fabaf74bcca905$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $c7fabaf74bcca905$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $c7fabaf74bcca905$var$arrayBufferTag:
            return $c5a4265f8c412cdf$exports(object);
        case $c7fabaf74bcca905$var$boolTag:
        case $c7fabaf74bcca905$var$dateTag:
            return new Ctor(+object);
        case $c7fabaf74bcca905$var$dataViewTag:
            return $b105e513df4d9f6e$exports(object, isDeep);
        case $c7fabaf74bcca905$var$float32Tag:
        case $c7fabaf74bcca905$var$float64Tag:
        case $c7fabaf74bcca905$var$int8Tag:
        case $c7fabaf74bcca905$var$int16Tag:
        case $c7fabaf74bcca905$var$int32Tag:
        case $c7fabaf74bcca905$var$uint8Tag:
        case $c7fabaf74bcca905$var$uint8ClampedTag:
        case $c7fabaf74bcca905$var$uint16Tag:
        case $c7fabaf74bcca905$var$uint32Tag:
            return $cc7eebd1be87fe1c$exports(object, isDeep);
        case $c7fabaf74bcca905$var$mapTag:
            return new Ctor;
        case $c7fabaf74bcca905$var$numberTag:
        case $c7fabaf74bcca905$var$stringTag:
            return new Ctor(object);
        case $c7fabaf74bcca905$var$regexpTag:
            return $a7e8313cd867d9c7$exports(object);
        case $c7fabaf74bcca905$var$setTag:
            return new Ctor;
        case $c7fabaf74bcca905$var$symbolTag:
            return $9039dc7ee5ee9432$exports(object);
    }
}
$c7fabaf74bcca905$exports = $c7fabaf74bcca905$var$initCloneByTag;





var $9gBlp = parcelRequire("9gBlp");
var $d35f249bf74f5b20$exports = {};
var $49b4f3766c6a52a4$exports = {};


/** `Object#toString` result references. */ var $49b4f3766c6a52a4$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $49b4f3766c6a52a4$var$baseIsMap(value) {
    return $97dbbc1a069ce16a$exports(value) && $288c148fae7027f4$exports(value) == $49b4f3766c6a52a4$var$mapTag;
}
$49b4f3766c6a52a4$exports = $49b4f3766c6a52a4$var$baseIsMap;




var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $d35f249bf74f5b20$var$nodeIsMap = $iU8uW && $iU8uW.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $d35f249bf74f5b20$var$isMap = $d35f249bf74f5b20$var$nodeIsMap ? $c4aeaafb4421a79e$exports($d35f249bf74f5b20$var$nodeIsMap) : $49b4f3766c6a52a4$exports;
$d35f249bf74f5b20$exports = $d35f249bf74f5b20$var$isMap;



var $718b96ea68d38ebf$exports = {};
var $b21a62d39edec39c$exports = {};


/** `Object#toString` result references. */ var $b21a62d39edec39c$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $b21a62d39edec39c$var$baseIsSet(value) {
    return $97dbbc1a069ce16a$exports(value) && $288c148fae7027f4$exports(value) == $b21a62d39edec39c$var$setTag;
}
$b21a62d39edec39c$exports = $b21a62d39edec39c$var$baseIsSet;




var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $718b96ea68d38ebf$var$nodeIsSet = $iU8uW && $iU8uW.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $718b96ea68d38ebf$var$isSet = $718b96ea68d38ebf$var$nodeIsSet ? $c4aeaafb4421a79e$exports($718b96ea68d38ebf$var$nodeIsSet) : $b21a62d39edec39c$exports;
$718b96ea68d38ebf$exports = $718b96ea68d38ebf$var$isSet;




/** Used to compose bitmasks for cloning. */ var $f69c86ceef3a17b2$var$CLONE_DEEP_FLAG = 1, $f69c86ceef3a17b2$var$CLONE_FLAT_FLAG = 2, $f69c86ceef3a17b2$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $f69c86ceef3a17b2$var$argsTag = "[object Arguments]", $f69c86ceef3a17b2$var$arrayTag = "[object Array]", $f69c86ceef3a17b2$var$boolTag = "[object Boolean]", $f69c86ceef3a17b2$var$dateTag = "[object Date]", $f69c86ceef3a17b2$var$errorTag = "[object Error]", $f69c86ceef3a17b2$var$funcTag = "[object Function]", $f69c86ceef3a17b2$var$genTag = "[object GeneratorFunction]", $f69c86ceef3a17b2$var$mapTag = "[object Map]", $f69c86ceef3a17b2$var$numberTag = "[object Number]", $f69c86ceef3a17b2$var$objectTag = "[object Object]", $f69c86ceef3a17b2$var$regexpTag = "[object RegExp]", $f69c86ceef3a17b2$var$setTag = "[object Set]", $f69c86ceef3a17b2$var$stringTag = "[object String]", $f69c86ceef3a17b2$var$symbolTag = "[object Symbol]", $f69c86ceef3a17b2$var$weakMapTag = "[object WeakMap]";
var $f69c86ceef3a17b2$var$arrayBufferTag = "[object ArrayBuffer]", $f69c86ceef3a17b2$var$dataViewTag = "[object DataView]", $f69c86ceef3a17b2$var$float32Tag = "[object Float32Array]", $f69c86ceef3a17b2$var$float64Tag = "[object Float64Array]", $f69c86ceef3a17b2$var$int8Tag = "[object Int8Array]", $f69c86ceef3a17b2$var$int16Tag = "[object Int16Array]", $f69c86ceef3a17b2$var$int32Tag = "[object Int32Array]", $f69c86ceef3a17b2$var$uint8Tag = "[object Uint8Array]", $f69c86ceef3a17b2$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f69c86ceef3a17b2$var$uint16Tag = "[object Uint16Array]", $f69c86ceef3a17b2$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $f69c86ceef3a17b2$var$cloneableTags = {};
$f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$argsTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$arrayTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$arrayBufferTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$dataViewTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$boolTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$dateTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$float32Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$float64Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$int8Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$int16Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$int32Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$mapTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$numberTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$objectTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$regexpTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$setTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$stringTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$symbolTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$uint8Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$uint8ClampedTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$uint16Tag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$uint32Tag] = true;
$f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$errorTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$funcTag] = $f69c86ceef3a17b2$var$cloneableTags[$f69c86ceef3a17b2$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $f69c86ceef3a17b2$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $f69c86ceef3a17b2$var$CLONE_DEEP_FLAG, isFlat = bitmask & $f69c86ceef3a17b2$var$CLONE_FLAT_FLAG, isFull = bitmask & $f69c86ceef3a17b2$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$f328ff7ee4fde81a$exports(value)) return value;
    var isArr = $579b9ba2588bb9de$exports(value);
    if (isArr) {
        result = $40dda5fd764f7548$exports(value);
        if (!isDeep) return $99a0ab0777733779$exports(value, result);
    } else {
        var tag = $288c148fae7027f4$exports(value), isFunc = tag == $f69c86ceef3a17b2$var$funcTag || tag == $f69c86ceef3a17b2$var$genTag;
        if ($9gBlp(value)) return $gw5oW(value, isDeep);
        if (tag == $f69c86ceef3a17b2$var$objectTag || tag == $f69c86ceef3a17b2$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $12b2001e80f30af2$exports(value);
            if (!isDeep) return isFlat ? $6e816135bde431a4$exports(value, $58ef0f8ba3c6d113$exports(result, value)) : $c0761f09fe7e3110$exports(value, $65b2863dcb7dc1a3$exports(result, value));
        } else {
            if (!$f69c86ceef3a17b2$var$cloneableTags[tag]) return object ? value : {};
            result = $c7fabaf74bcca905$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $75b9f8e835026959$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($718b96ea68d38ebf$exports(value)) value.forEach(function(subValue) {
        result.add($f69c86ceef3a17b2$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($d35f249bf74f5b20$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $f69c86ceef3a17b2$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $6e54e90bc363339e$exports : $b43254fda44c104a$exports : isFlat ? $9602693ae93bd599$exports : $0fce4239ee480ef0$exports;
    var props = isArr ? undefined : keysFunc(value);
    $a3dabfafa21b6614$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $40601a0f588600f2$exports(result, key, $f69c86ceef3a17b2$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$f69c86ceef3a17b2$exports = $f69c86ceef3a17b2$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $60d3fa686d955280$var$CLONE_DEEP_FLAG = 1, $60d3fa686d955280$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $60d3fa686d955280$var$cloneDeep(value) {
    return $f69c86ceef3a17b2$exports(value, $60d3fa686d955280$var$CLONE_DEEP_FLAG | $60d3fa686d955280$var$CLONE_SYMBOLS_FLAG);
}
$60d3fa686d955280$exports = $60d3fa686d955280$var$cloneDeep;


var $5cbcadbe316600de$exports = {};

var $06e3445471e22668$exports = {};


var $bf70b66c162aef31$exports = {};
var $26276a5f2fd81978$exports = {};
var $d1efba33353344a0$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $d1efba33353344a0$var$COMPARE_PARTIAL_FLAG = 1, $d1efba33353344a0$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $d1efba33353344a0$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $75b9f8e835026959$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $7c952302caee51c1$exports(srcValue, objValue, $d1efba33353344a0$var$COMPARE_PARTIAL_FLAG | $d1efba33353344a0$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$d1efba33353344a0$exports = $d1efba33353344a0$var$baseIsMatch;


var $0c264c2d18b81eb5$exports = {};
var $1fffae593e239b7a$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1fffae593e239b7a$var$isStrictComparable(value) {
    return value === value && !$f328ff7ee4fde81a$exports(value);
}
$1fffae593e239b7a$exports = $1fffae593e239b7a$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $0c264c2d18b81eb5$var$getMatchData(object) {
    var result = $0fce4239ee480ef0$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1fffae593e239b7a$exports(value)
        ];
    }
    return result;
}
$0c264c2d18b81eb5$exports = $0c264c2d18b81eb5$var$getMatchData;


var $8bf164e6cb59822f$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $8bf164e6cb59822f$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$8bf164e6cb59822f$exports = $8bf164e6cb59822f$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $26276a5f2fd81978$var$baseMatches(source) {
    var matchData = $0c264c2d18b81eb5$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $8bf164e6cb59822f$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $d1efba33353344a0$exports(object, source, matchData);
    };
}
$26276a5f2fd81978$exports = $26276a5f2fd81978$var$baseMatches;


var $952f5322c982d82b$exports = {};







/** Used to compose bitmasks for value comparisons. */ var $952f5322c982d82b$var$COMPARE_PARTIAL_FLAG = 1, $952f5322c982d82b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $952f5322c982d82b$var$baseMatchesProperty(path, srcValue) {
    if ($69479e268680fe10$exports(path) && $1fffae593e239b7a$exports(srcValue)) return $8bf164e6cb59822f$exports($09a75ffd36bdbd18$exports(path), srcValue);
    return function(object) {
        var objValue = $f7bfd9e73571977c$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $065767a6557522ec$exports(object, path) : $7c952302caee51c1$exports(srcValue, objValue, $952f5322c982d82b$var$COMPARE_PARTIAL_FLAG | $952f5322c982d82b$var$COMPARE_UNORDERED_FLAG);
    };
}
$952f5322c982d82b$exports = $952f5322c982d82b$var$baseMatchesProperty;




var $2e890ca2b88f7d2c$exports = {};
var $e8a9c7d31faa2cc3$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e8a9c7d31faa2cc3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$e8a9c7d31faa2cc3$exports = $e8a9c7d31faa2cc3$var$baseProperty;


var $e6abd5b3ef04327c$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e6abd5b3ef04327c$var$basePropertyDeep(path) {
    return function(object) {
        return $e913f1fcbff7147e$exports(object, path);
    };
}
$e6abd5b3ef04327c$exports = $e6abd5b3ef04327c$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $2e890ca2b88f7d2c$var$property(path) {
    return $69479e268680fe10$exports(path) ? $e8a9c7d31faa2cc3$exports($09a75ffd36bdbd18$exports(path)) : $e6abd5b3ef04327c$exports(path);
}
$2e890ca2b88f7d2c$exports = $2e890ca2b88f7d2c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $bf70b66c162aef31$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $e4dbcba8665d9b6c$exports;
    if (typeof value == "object") return $579b9ba2588bb9de$exports(value) ? $952f5322c982d82b$exports(value[0], value[1]) : $26276a5f2fd81978$exports(value);
    return $2e890ca2b88f7d2c$exports(value);
}
$bf70b66c162aef31$exports = $bf70b66c162aef31$var$baseIteratee;


var $096af2082e63acfa$exports = {};
var $7ebb68e7a3797e10$exports = {};
var $feac72adfe18f958$exports = {};


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $feac72adfe18f958$var$baseForOwn(object, iteratee) {
    return object && $1a862ca629cc3032$exports(object, iteratee, $0fce4239ee480ef0$exports);
}
$feac72adfe18f958$exports = $feac72adfe18f958$var$baseForOwn;


var $a19fb4a1ae1d38c6$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $a19fb4a1ae1d38c6$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$4506257970d5c979$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$a19fb4a1ae1d38c6$exports = $a19fb4a1ae1d38c6$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $7ebb68e7a3797e10$var$baseEach = $a19fb4a1ae1d38c6$exports($feac72adfe18f958$exports);
$7ebb68e7a3797e10$exports = $7ebb68e7a3797e10$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $096af2082e63acfa$var$baseMap(collection, iteratee) {
    var index = -1, result = $4506257970d5c979$exports(collection) ? Array(collection.length) : [];
    $7ebb68e7a3797e10$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$096af2082e63acfa$exports = $096af2082e63acfa$var$baseMap;


var $9cc81b309921e28a$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9cc81b309921e28a$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$9cc81b309921e28a$exports = $9cc81b309921e28a$var$baseSortBy;



var $4de0c06f5a982b80$exports = {};
var $730e73ab53b8c757$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $730e73ab53b8c757$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $2fffc1449db40502$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $2fffc1449db40502$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$730e73ab53b8c757$exports = $730e73ab53b8c757$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4de0c06f5a982b80$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $730e73ab53b8c757$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$4de0c06f5a982b80$exports = $4de0c06f5a982b80$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $06e3445471e22668$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $4c0f1a1d993f5976$exports(iteratees, function(iteratee) {
        if ($579b9ba2588bb9de$exports(iteratee)) return function(value) {
            return $e913f1fcbff7147e$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $e4dbcba8665d9b6c$exports
    ];
    var index = -1;
    iteratees = $4c0f1a1d993f5976$exports(iteratees, $c4aeaafb4421a79e$exports($bf70b66c162aef31$exports));
    var result = $096af2082e63acfa$exports(collection, function(value, key, collection) {
        var criteria = $4c0f1a1d993f5976$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $9cc81b309921e28a$exports(result, function(object, other) {
        return $4de0c06f5a982b80$exports(object, other, orders);
    });
}
$06e3445471e22668$exports = $06e3445471e22668$var$baseOrderBy;




/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5cbcadbe316600de$var$sortBy = $6b119307bcdda881$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $18da533e307f2df0$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $18da533e307f2df0$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $06e3445471e22668$exports(collection, $df6466a12cae3866$exports(iteratees, 1), []);
});
$5cbcadbe316600de$exports = $5cbcadbe316600de$var$sortBy;



function $5972336576a78c6b$var$R() {
    return $5972336576a78c6b$var$R = Object.assign || function(r) {
        for(var e = 1; e < arguments.length; e++){
            var o = arguments[e];
            for(var t in o)Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
        }
        return r;
    }, $5972336576a78c6b$var$R.apply(this, arguments);
}
var $5972336576a78c6b$export$9c21a3269931e1e6 = {
    id: "id",
    value: "value",
    cornerRadius: 0,
    layers: [
        "arcs",
        "arcLabels"
    ],
    colors: {
        scheme: "nivo"
    },
    colorBy: "id",
    inheritColorFromParent: !0,
    childColor: {
        from: "color"
    },
    borderWidth: 1,
    borderColor: "white",
    enableArcLabels: !1,
    arcLabel: "formattedValue",
    arcLabelsRadiusOffset: .5,
    arcLabelsSkipAngle: 0,
    arcLabelsTextColor: {
        theme: "labels.text.fill"
    },
    animate: !0,
    motionConfig: "gentle",
    transitionMode: "innerRadius",
    isInteractive: !0,
    defs: [],
    fill: [],
    tooltip: function(r) {
        var e = r.id, o = r.formattedValue, t = r.color;
        return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d5f52d71198e271a), {
            id: e,
            value: o,
            enableChip: !0,
            color: t
        });
    },
    role: "img"
}, $5972336576a78c6b$export$2446bcde3da71a40 = function(e) {
    var o = e.data, a = e.id, l = void 0 === a ? $5972336576a78c6b$export$9c21a3269931e1e6.id : a, d = e.value, c = void 0 === d ? $5972336576a78c6b$export$9c21a3269931e1e6.value : d, s = e.valueFormat, v = e.radius, f = e.cornerRadius, h = void 0 === f ? $5972336576a78c6b$export$9c21a3269931e1e6.cornerRadius : f, m = e.colors, p = void 0 === m ? $5972336576a78c6b$export$9c21a3269931e1e6.colors : m, R = e.colorBy, F = void 0 === R ? $5972336576a78c6b$export$9c21a3269931e1e6.colorBy : R, I = e.inheritColorFromParent, W = void 0 === I ? $5972336576a78c6b$export$9c21a3269931e1e6.inheritColorFromParent : I, k = e.childColor, A = void 0 === k ? $5972336576a78c6b$export$9c21a3269931e1e6.childColor : k, O = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), G = (0, $18aed9a2ed048594$export$47939777be1516f5)(p, F), P = (0, $18aed9a2ed048594$export$2a9e363116151414)(A, O), w = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(l), B = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(c), E = (0, $0332e848e6fa2251$export$422f9765e6971fdf)(s), T = (0, $7fPBF.useMemo)(function() {
        var r, e = (0, (/*@__PURE__*/$parcel$interopDefault($60d3fa686d955280$exports)))(o), t = (0, $166c72ae2a5c0694$export$2e2bcd8739ae039)(e).sum(B), n = (0, $669650112604b322$export$2e2bcd8739ae039)().size([
            2 * Math.PI,
            v * v
        ])(t).descendants().slice(1), i = null != (r = t.value) ? r : 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5cbcadbe316600de$exports)))(n, "depth").reduce(function(r, e) {
            var o, t = w(e.data), n = e.value, a = 100 * n / i, l = e.ancestors().map(function(r) {
                return w(r.data);
            }), d = {
                startAngle: e.x0,
                endAngle: e.x1,
                innerRadius: Math.sqrt(e.y0),
                outerRadius: Math.sqrt(e.y1)
            };
            e.parent && (o = r.find(function(r) {
                return r.id === w(e.parent.data);
            }));
            var c = {
                id: t,
                path: l,
                value: n,
                percentage: a,
                formattedValue: s ? E(n) : a.toFixed(2) + "%",
                color: "",
                arc: d,
                data: e.data,
                depth: e.depth,
                height: e.height
            };
            return W && o && c.depth > 1 ? c.color = P(o, c) : c.color = G(c), [].concat(r, [
                c
            ]);
        }, []);
    }, [
        o,
        v,
        B,
        w,
        s,
        E,
        G,
        W,
        P
    ]);
    return {
        arcGenerator: (0, $f9647e1e2a37a3bb$export$9dba50da1768ab65)({
            cornerRadius: h
        }),
        nodes: T
    };
}, $5972336576a78c6b$export$b480c185e51a4d89 = function(e) {
    var o = e.nodes, t = e.arcGenerator, n = e.centerX, i = e.centerY, a = e.radius;
    return (0, $7fPBF.useMemo)(function() {
        return {
            nodes: o,
            arcGenerator: t,
            centerX: n,
            centerY: i,
            radius: a
        };
    }, [
        o,
        t,
        n,
        i,
        a
    ]);
}, $5972336576a78c6b$var$W = function(o) {
    var t = o.center, n = o.data, i = o.arcGenerator, a = o.borderWidth, l = o.borderColor, d = o.isInteractive, c = o.onClick, s = o.onMouseEnter, u = o.onMouseMove, f = o.onMouseLeave, h = o.tooltip, b = o.transitionMode, C = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), g = C.showTooltipFromEvent, M = C.hideTooltip, L = (0, $7fPBF.useMemo)(function() {
        if (d) return function(r, e) {
            null == c || c(r, e);
        };
    }, [
        d,
        c
    ]), y = (0, $7fPBF.useMemo)(function() {
        if (d) return function(r, o) {
            g((0, $7fPBF.createElement)(h, r), o), null == s || s(r, o);
        };
    }, [
        d,
        g,
        h,
        s
    ]), R = (0, $7fPBF.useMemo)(function() {
        if (d) return function(r, o) {
            g((0, $7fPBF.createElement)(h, r), o), null == u || u(r, o);
        };
    }, [
        d,
        g,
        h,
        u
    ]), x = (0, $7fPBF.useMemo)(function() {
        if (d) return function(r, e) {
            M(), null == f || f(r, e);
        };
    }, [
        d,
        M,
        f
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $f9647e1e2a37a3bb$export$aa2d92ba89b625ed), {
        center: t,
        data: n,
        arcGenerator: i,
        borderWidth: a,
        borderColor: l,
        transitionMode: b,
        onClick: L,
        onMouseEnter: y,
        onMouseMove: R,
        onMouseLeave: x
    });
}, $5972336576a78c6b$var$k = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $5972336576a78c6b$var$A = function(t) {
    var n = t.data, i = t.id, a = void 0 === i ? $5972336576a78c6b$export$9c21a3269931e1e6.id : i, s = t.value, u = void 0 === s ? $5972336576a78c6b$export$9c21a3269931e1e6.value : s, v = t.valueFormat, h = t.cornerRadius, m = void 0 === h ? $5972336576a78c6b$export$9c21a3269931e1e6.cornerRadius : h, b = t.layers, C = void 0 === b ? $5972336576a78c6b$export$9c21a3269931e1e6.layers : b, g = t.colors, M = void 0 === g ? $5972336576a78c6b$export$9c21a3269931e1e6.colors : g, L = t.colorBy, y = void 0 === L ? $5972336576a78c6b$export$9c21a3269931e1e6.colorBy : L, R = t.inheritColorFromParent, k = void 0 === R ? $5972336576a78c6b$export$9c21a3269931e1e6.inheritColorFromParent : R, A = t.childColor, O = void 0 === A ? $5972336576a78c6b$export$9c21a3269931e1e6.childColor : A, G = t.borderWidth, P = void 0 === G ? $5972336576a78c6b$export$9c21a3269931e1e6.borderWidth : G, w = t.borderColor, B = void 0 === w ? $5972336576a78c6b$export$9c21a3269931e1e6.borderColor : w, E = t.margin, T = t.width, X = t.height, Y = t.enableArcLabels, j = void 0 === Y ? $5972336576a78c6b$export$9c21a3269931e1e6.enableArcLabels : Y, K = t.arcLabel, S = void 0 === K ? $5972336576a78c6b$export$9c21a3269931e1e6.arcLabel : K, V = t.arcLabelsRadiusOffset, q = void 0 === V ? $5972336576a78c6b$export$9c21a3269931e1e6.arcLabelsRadiusOffset : V, H = t.arcLabelsSkipAngle, z = void 0 === H ? $5972336576a78c6b$export$9c21a3269931e1e6.arcLabelsSkipAngle : H, D = t.arcLabelsTextColor, J = void 0 === D ? $5972336576a78c6b$export$9c21a3269931e1e6.arcLabelsTextColor : D, N = t.arcLabelsComponent, Q = t.defs, U = void 0 === Q ? $5972336576a78c6b$export$9c21a3269931e1e6.defs : Q, Z = t.fill, $ = void 0 === Z ? $5972336576a78c6b$export$9c21a3269931e1e6.fill : Z, _ = t.transitionMode, rr = void 0 === _ ? $5972336576a78c6b$export$9c21a3269931e1e6.transitionMode : _, er = t.isInteractive, or = void 0 === er ? $5972336576a78c6b$export$9c21a3269931e1e6.isInteractive : er, tr = t.onClick, nr = t.onMouseEnter, ir = t.onMouseLeave, ar = t.onMouseMove, lr = t.tooltip, dr = void 0 === lr ? $5972336576a78c6b$export$9c21a3269931e1e6.tooltip : lr, cr = t.role, sr = void 0 === cr ? $5972336576a78c6b$export$9c21a3269931e1e6.role : cr, ur = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(T, X, E), vr = ur.innerHeight, fr = ur.innerWidth, hr = ur.margin, mr = ur.outerHeight, pr = ur.outerWidth, br = (0, $7fPBF.useMemo)(function() {
        return {
            radius: Math.min(fr, vr) / 2,
            centerX: fr / 2,
            centerY: vr / 2
        };
    }, [
        vr,
        fr
    ]), Cr = br.centerX, gr = br.centerY, Mr = br.radius, Lr = $5972336576a78c6b$export$2446bcde3da71a40({
        data: n,
        id: a,
        value: u,
        valueFormat: v,
        radius: Mr,
        cornerRadius: m,
        colors: M,
        colorBy: y,
        inheritColorFromParent: k,
        childColor: O
    }), yr = Lr.arcGenerator, Rr = Lr.nodes, xr = (0, $0332e848e6fa2251$export$dc35cf769e3afe34)(U, Rr, $, {
        dataKey: ".",
        colorKey: "color",
        targetKey: "fill"
    }), Fr = {
        arcs: null,
        arcLabels: null
    };
    C.includes("arcs") && (Fr.arcs = (0, $824c049f32d4395d$exports.jsx)($5972336576a78c6b$var$W, {
        center: [
            Cr,
            gr
        ],
        data: Rr,
        arcGenerator: yr,
        borderWidth: P,
        borderColor: B,
        transitionMode: rr,
        isInteractive: or,
        tooltip: dr,
        onClick: tr,
        onMouseEnter: nr,
        onMouseLeave: ir,
        onMouseMove: ar
    }, "arcs")), j && C.includes("arcLabels") && (Fr.arcLabels = (0, $824c049f32d4395d$exports.jsx)((0, $f9647e1e2a37a3bb$export$6aed5a877c5fc8a1), {
        center: [
            Cr,
            gr
        ],
        data: Rr,
        label: S,
        radiusOffset: q,
        skipAngle: z,
        textColor: J,
        transitionMode: rr,
        component: N
    }, "arcLabels"));
    var Ir = $5972336576a78c6b$export$b480c185e51a4d89({
        nodes: Rr,
        arcGenerator: yr,
        centerX: Cr,
        centerY: gr,
        radius: Mr
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$21d9f1931ef75b56), {
        width: pr,
        height: mr,
        defs: xr,
        margin: hr,
        role: sr,
        children: C.map(function(r, t) {
            return void 0 !== Fr[r] ? Fr[r] : "function" == typeof r ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: (0, $7fPBF.createElement)(r, Ir)
            }, t) : null;
        })
    });
}, $5972336576a78c6b$export$752bb734852130ea = function(r) {
    var e = r.isInteractive, o = void 0 === e ? $5972336576a78c6b$export$9c21a3269931e1e6.isInteractive : e, t = r.animate, n = void 0 === t ? $5972336576a78c6b$export$9c21a3269931e1e6.animate : t, i = r.motionConfig, l = void 0 === i ? $5972336576a78c6b$export$9c21a3269931e1e6.motionConfig : i, d = r.theme, c = r.renderWrapper, s = function(r, e) {
        if (null == r) return {};
        var o, t, n = {}, i = Object.keys(r);
        for(t = 0; t < i.length; t++)o = i[t], e.indexOf(o) >= 0 || (n[o] = r[o]);
        return n;
    }(r, $5972336576a78c6b$var$k);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$42a852a2b6b56249), {
        isInteractive: o,
        animate: n,
        motionConfig: l,
        theme: d,
        renderWrapper: c,
        children: (0, $824c049f32d4395d$exports.jsx)($5972336576a78c6b$var$A, $5972336576a78c6b$var$R({
            isInteractive: o
        }, s))
    });
}, $5972336576a78c6b$export$b73a7b7298e6a7d1 = function(r) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(e) {
            var o = e.width, t = e.height;
            return (0, $824c049f32d4395d$exports.jsx)($5972336576a78c6b$export$752bb734852130ea, $5972336576a78c6b$var$R({
                width: o,
                height: t
            }, r));
        }
    });
};




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $796a20745a834567$var$ArrowsPointingOutIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z",
        clipRule: "evenodd"
    }));
}
const $796a20745a834567$var$ForwardRef = $7fPBF.forwardRef($796a20745a834567$var$ArrowsPointingOutIcon);
var $796a20745a834567$export$2e2bcd8739ae039 = $796a20745a834567$var$ForwardRef;




var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $5cf990a811bbb736$export$2e2bcd8739ae039(props) {
    const theme = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const { id: id, value: value, formattedValue: formattedValue } = props;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: (0, $9tqwB._)({}, theme.tooltip.container),
        className: "text-sm rounded-md shadow",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "text-white",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "font-bold text-white",
                        children: id
                    }),
                    `: ${value.toLocaleString("de", {
                        style: "currency",
                        currency: baseCurrency || "EUR",
                        maximumFractionDigits: 0
                    })}`
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-white",
                children: `${formattedValue}`
            })
        ]
    });
}
$5cf990a811bbb736$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    formattedValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$5cf990a811bbb736$export$2e2bcd8739ae039.defaultProps = {
    id: "",
    value: 0,
    formattedValue: ""
};



const $cfa42d96aefa350c$var$colors = [
    "rgba(23, 151, 242, 1)",
    "rgba(146, 208, 80, 1)",
    "rgba(187, 109, 206, 1)",
    "rgba(255, 214, 0, 1)",
    "rgba(237, 28, 35, 1)",
    "rgba(46, 49, 146, 1"
];
const $cfa42d96aefa350c$var$debugFlag = 0;
function $cfa42d96aefa350c$var$CenteredMetric(props) {
    const { nodes: nodes, centerX: centerX, centerY: centerY } = props;
    const total = nodes.reduce((totl, item)=>item.depth === 1 ? totl + item.value : totl, 0);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("text", {
        x: centerX,
        y: centerY,
        textAnchor: "middle",
        dominantBaseline: "central",
        style: {
            fontSize: "32px",
            fontWeight: 700
        },
        children: Number.parseFloat(`${total}`).toLocaleString("de", {
            style: "currency",
            currency: baseCurrency || "EUR",
            maximumFractionDigits: 0
        })
    });
}
function $cfa42d96aefa350c$export$75278c933ffb8ec(props) {
    const pivotData = new (0, $25ed1e0e429105db$exports.PivotData)(props);
    const rowKeys = pivotData.getRowKeys();
    const colKeys = pivotData.getColKeys();
    const hideFullscreenButton = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>!state.message.fullscreenReport);
    const [chartErrorMessage, setChartErrorMessage] = (0, $7fPBF.useState)(null);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    let fullAggName = props.aggregatorName;
    const numInputs = props.aggregators[fullAggName]([])().numInputs || 0;
    if (numInputs !== 0) fullAggName += ` of ${props.vals.slice(0, numInputs).join(", ")}`;
    // all the possible combinations of main key category fields [[2015, 'DKB Giro'], [2017, 'Festgeld'],[2019, 'Festgeld'] ...]
    if ($cfa42d96aefa350c$var$debugFlag > 2) console.log("rowKeys", rowKeys);
    // all the possible combinations of the secondary key category fields [['American Express', 'EUR'], ['Arbeitgeber AG', 'EUR'], ['Avis AG', 'EUR']...]
    if ($cfa42d96aefa350c$var$debugFlag > 2) console.log("colKeys", colKeys);
    if ($cfa42d96aefa350c$var$debugFlag > 2) console.log("pivotData with props", pivotData);
    // rowKeys and colKeys have all the needed combinations of keys already
    // e.g. [[2015, 'EUR'], [2015, 'USD'], [2016, 'EUR'], [2017, 'EUR']]
    // even if there are more than 1 attribute in each group
    // so all that needs to happen is to produce for each object (which is an array) in rowKeys
    // an object with the joinedKey
    const rowNames = pivotData.props.rows; // ["Date (Year)", "accountName"]
    const colNames = pivotData.props.cols; // names of the fields that go to secondary category ["otherParty", "currency"]
    let data = [];
    // transform data from PivotTable to hierarchy structure
    const rowKeysByName = rowNames.reduce((prevRowName, currRowName, rowNameIdx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevRowName), {
            [currRowName]: rowKeys.reduce((prevRowKey, currRowKey)=>{
                if (!prevRowKey.includes(currRowKey[rowNameIdx])) prevRowKey.push(currRowKey[rowNameIdx]);
                return prevRowKey;
            }, [])
        }), {});
    const colKeysByName = colNames.reduce((prevColName, currColName, colNameIdx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevColName), {
            [currColName]: colKeys.reduce((prevColKey, currColKey)=>{
                if (!prevColKey.includes(currColKey[colNameIdx])) prevColKey.push(currColKey[colNameIdx]);
                return prevColKey;
            }, [])
        }), {});
    const keysByName = (0, $9tqwB._)({}, rowKeysByName, colKeysByName);
    if ($cfa42d96aefa350c$var$debugFlag > 2) console.info("keysByName", keysByName);
    // this has all unique values organised by field name, i.e.:
    // { 'Date (Year)': [2015, 2016, 2017, 2018, 2019], 'accountName': ['DKB Giro', 'Festgeld', 'Girokonto', 'Kreditkarte', 'Sparkonto'], ... }
    // the sequence of keys is the hierarchy structure, i.e.: first object goes on top level, then the next object goes as a child of the first object, etc.
    // TODO this has some room for improvement, because this includes all possible combinations of keys, and not only those with data
    const valueToBeAggregated = pivotData.props.vals[0];
    function getAggregate(parents) {
        // takes the array with all parent key-value arrays and returns the sum of all values matching those criteria
        const returnObject = pivotData.props.data.filter((x)=>x.displayName !== "\u03A3" && x.accountName !== "\u03A3").reduce((prev, curr)=>{
            if (curr.formattingLevel) return prev; // for performance reasons, skip all summary rows
            // go through all summary rows, lowest level only
            // only add value when ALL the parent level's conditions from 'parents' are met
            // i.e. if parents is [['category', 'deposits'], ['accountName', 'DKB Giro']]
            // then only add value when both conditions are met
            if ($cfa42d96aefa350c$var$debugFlag > 2) console.info("testing condition match for parents ", JSON.stringify(parents), " and record ", curr);
            if (parents.every((parent)=>curr[parent[0]] === parent[1])) {
                if ($cfa42d96aefa350c$var$debugFlag > 2) console.info("found condition match for parents ", JSON.stringify(parents), " which is ", curr);
                return prev + curr[valueToBeAggregated];
            }
            return prev;
        }, 0);
        if ($cfa42d96aefa350c$var$debugFlag > 2) console.info("returning aggregate", returnObject, " for parents ", JSON.stringify(parents), " and field being aggregated ", valueToBeAggregated);
        return returnObject;
    }
    const hierarchyLevels = Object.keys(keysByName).length;
    // CAUTION: Nivo seems to expect each node to have a unique id, so we need to split the label from the id
    function generateChildrenHierarchy(keyIndex, parents = []) {
        var _Object_values_keyIndex;
        // stop recursion when the lowest level is reached
        if (keyIndex === hierarchyLevels) return [];
        // keyIndex is the level of hierarchy, starts with 0 and adds 1 for each level
        // parents is a "key-value" array containing all "group by" fields and their values, i.e. [['category', 'deposits'], ['accountName', 'DKB Giro']]
        if ($cfa42d96aefa350c$var$debugFlag > 2) console.info("starting generateChildrenHierarchy for keyIndex", keyIndex, ", parents ", parents);
        // keysByName contains all values of fields:
        // { 'Date (Year)': [2015, 2016, 2017, 2018, 2019], 'accountName': ['DKB Giro', 'Festgeld', 'Girokonto', 'Kreditkarte', 'Sparkonto'], ... }
        const returnGenerateChildrenHierarchy = (_Object_values_keyIndex = Object.values(keysByName)[keyIndex]) === null || _Object_values_keyIndex === void 0 ? void 0 : _Object_values_keyIndex.reduce((cum, val)=>{
            // for all values of the field, i.e. 'Date (Year)' - 2007, 2009, 2010 ...
            const newParents = [
                ...parents,
                [
                    Object.keys(keysByName)[keyIndex],
                    val
                ]
            ]; // add the current key-value pair, to be passed to child recursion
            const children = generateChildrenHierarchy(keyIndex + 1, newParents); // this returns [] when recursion bottom is reached
            // calculate the value of all children, if this is null, then skip this node
            let value = getAggregate(newParents);
            if (value === 0) return cum;
            // handle the data exception: it is impossible to display a negative chart value
            if (value < 0) value = 0;
            const returnObject = {
                // name: val,
                name: newParents.map((parent)=>parent[1]).join(" - "),
                label: val,
                // insert key-value pair of current level as a parent, i.e. ['category', 'deposits']
                parents: newParents
            };
            // prevent adding children if there is only one, it has the same name and it has a value (i.e. it is the last level)
            if (keyIndex === Object.keys(keysByName).length - 1 || children.length === 1 && children[0].value === value && children[0].label === val) // if this is the last level, then add the value
            returnObject.value = value;
            else returnObject.children = children;
            return [
                ...cum,
                returnObject
            ];
        }, []);
        if ($cfa42d96aefa350c$var$debugFlag > 2) console.info("keyIndex", keyIndex, "parents", parents, "returnedObject", returnGenerateChildrenHierarchy);
        return returnGenerateChildrenHierarchy;
    }
    // generate hierarchical data structure
    data = {
        name: "root",
        children: generateChildrenHierarchy(0)
    };
    // sunburst chart with drill-down needs a state to manipulate the data when user wants to drill down
    // initialise state with data object, if avaliable
    const [chartData, setChartData] = (0, $7fPBF.useState)(data);
    (0, $7fPBF.useEffect)(()=>{
        // make sure data object is updated when the data are updated
        setChartData(data);
    }, [
        pivotData.props.data,
        rowNames,
        colNames,
        pivotData.props.vals
    ]);
    // helper functions to enable drill-down in Sunburst chart
    const flatten = (dataLocal)=>dataLocal.reduce((acc, item)=>{
            if (item.children) return [
                ...acc,
                item,
                ...flatten(item.children)
            ];
            return [
                ...acc,
                item
            ];
        }, []);
    function findObject(dataLocal, name) {
        return dataLocal.find((searchedName)=>searchedName.name === name);
    }
    // looks up the "official" colors based on category
    function getAccountColor(accountCategory) {
        if (accountCategory) return (0, $134ab0040d88b150$export$205e6715f8ffaf7d)[accountCategory].color.hex;
        return null;
    }
    // colors are assigned to the first level of hierarchy (e.g. category for the assets sunburst chart)
    // the first attribute of keysByName object will have an array with those values
    function getDrillDownColor(node) {
        var _colors_topLevelKeyValues_map_indexOf;
        // converting them both to String is necessary because the values in the keysByName object are strings and the values in the node.parents array are sometimes numbers (like years)
        const itemName = node.id.split(" - ")[0]; // caution: this only works as long as the id follows the naming convention <category> - <accountName>
        const hierarchyLevel = node.path.length - 1; // starts at 0 for root
        const opacityModifier = 1 - hierarchyLevel / 7;
        const topLevelKeyValues = Object.values(keysByName)[0];
        if (!topLevelKeyValues) return "#000000";
        // console.log('DEBUG getDrillDownColor', itemName, node, topLevelKeyValues);
        // try to get the color from the account category; if that doesn't work, assign the same color for the same itemNam
        // apply opacity modifier (hex's format is #rrggbbaa)
        const opacityModifierHex = Math.floor(opacityModifier * 255).toString(16).padStart(2, "0");
        return `${getAccountColor(itemName)}${opacityModifierHex}` || ((_colors_topLevelKeyValues_map_indexOf = $cfa42d96aefa350c$var$colors[topLevelKeyValues.map((x)=>String(x)).indexOf(itemName)]) === null || _colors_topLevelKeyValues_map_indexOf === void 0 ? void 0 : _colors_topLevelKeyValues_map_indexOf.replace("1)", `${opacityModifier})`));
    }
    const commonProps = (0, $9tqwB._)({
        margin: {
            top: 10,
            right: 10,
            bottom: 10,
            left: 10
        },
        theme: {
            fontFamily: "Lato",
            tooltip: {
                container: {
                    background: "#333"
                }
            }
        },
        padding: 0.2,
        id: "name",
        value: "value",
        colors: getDrillDownColor,
        cornerRadius: 2,
        inheritColorFromParent: false,
        animate: true,
        motionConfig: "gentle",
        // ['default', 'gentle', 'wobbly', 'stiff', 'slow', 'molasses'],
        layers: [
            "arcs",
            "arcLabels",
            $cfa42d96aefa350c$var$CenteredMetric
        ],
        enableArcLabels: true,
        arcLabel: (node)=>node.data.label,
        arcLabelsSkipAngle: 20,
        arcLabelsTextColor: {
            from: "color",
            modifiers: [
                [
                    "darker",
                    2
                ]
            ]
        },
        tooltip: (0, $5cf990a811bbb736$export$2e2bcd8739ae039),
        transitionMode: "pushIn",
        data: chartData,
        onClick: (clickedData)=>{
            const foundObject = findObject(flatten(chartData.children), clickedData.id);
            if (foundObject && foundObject.children) setChartData(foundObject);
        }
    }, pivotData.props.layoutOptions);
    function handleFullscreen() {
        dispatch((0, $3b9398d0f9c152fb$export$d717700e49bea38d)(pivotData.props));
    }
    if ($cfa42d96aefa350c$var$debugFlag > 2) console.log(data);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative w-full h-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "absolute z-10 flex gap-1 items-start",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "px-2 py-2 border rounded-md text-sm text-gray-700 hover:bg-gray-50",
                        onClick: ()=>setChartData(data),
                        children: "Reset"
                    }),
                    hideFullscreenButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "px-2 py-2 border rounded-md text-sm text-gray-500 hover:bg-gray-50",
                        onClick: handleFullscreen,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $796a20745a834567$export$2e2bcd8739ae039), {
                            className: "h-5 w-5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5972336576a78c6b$export$b73a7b7298e6a7d1), (0, $9tqwB._)({}, commonProps))
        ]
    });
}
function $cfa42d96aefa350c$var$makeNivoRenderer(NivoChart) {
    return $cfa42d96aefa350c$export$75278c933ffb8ec;
}
function $cfa42d96aefa350c$export$2e2bcd8739ae039() {
    return {
        "Pie chart, multi-layers": $cfa42d96aefa350c$var$makeNivoRenderer((0, $5972336576a78c6b$export$b73a7b7298e6a7d1))
    };
}


/* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");



function $ad81ce180dd1d3ec$var$v() {
    return $ad81ce180dd1d3ec$var$v = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var o = arguments[i];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
        }
        return t;
    }, $ad81ce180dd1d3ec$var$v.apply(this, arguments);
}
var $ad81ce180dd1d3ec$var$x = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
}, $ad81ce180dd1d3ec$var$m = function(t, i) {
    return "translate(" + t + "px, " + i + "px)";
}, $ad81ce180dd1d3ec$export$57a09c4864b20b90 = (0, $7fPBF.memo)(function(t) {
    var o, n = t.position, r = t.anchor, e = t.children, l = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), d = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), y = d.animate, f = d.config, b = (0, $ceac9f6897e0c09e$export$e295b0c537d32d7d)(), g = b[0], w = b[1], T = (0, $7fPBF.useRef)(!1), C = void 0, E = !1, P = w.width > 0 && w.height > 0, j = Math.round(n[0]), N = Math.round(n[1]);
    P && ("top" === r ? (j -= w.width / 2, N -= w.height + 14) : "right" === r ? (j += 14, N -= w.height / 2) : "bottom" === r ? (j -= w.width / 2, N += 14) : "left" === r ? (j -= w.width + 14, N -= w.height / 2) : "center" === r && (j -= w.width / 2, N -= w.height / 2), C = {
        transform: $ad81ce180dd1d3ec$var$m(j, N)
    }, T.current || (E = !0), T.current = [
        j,
        N
    ]);
    var O = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        to: C,
        config: f,
        immediate: !y || E
    }), V = $ad81ce180dd1d3ec$var$v({}, $ad81ce180dd1d3ec$var$x, l.tooltip.wrapper, {
        transform: null != (o = O.transform) ? o : $ad81ce180dd1d3ec$var$m(j, N),
        opacity: O.transform ? 1 : 0
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).div, {
        ref: g,
        style: V,
        children: e
    });
});
$ad81ce180dd1d3ec$export$57a09c4864b20b90.displayName = "TooltipWrapper";
var $ad81ce180dd1d3ec$export$5a7f9a6004988d01 = (0, $7fPBF.memo)(function(t) {
    var i = t.size, o = void 0 === i ? 12 : i, n = t.color, r = t.style;
    return (0, $824c049f32d4395d$exports.jsx)("span", {
        style: $ad81ce180dd1d3ec$var$v({
            display: "block",
            width: o,
            height: o,
            background: n
        }, void 0 === r ? {} : r)
    });
}), $ad81ce180dd1d3ec$export$d5f52d71198e271a = (0, $7fPBF.memo)(function(t) {
    var i, o = t.id, n = t.value, r = t.format, e = t.enableChip, l = void 0 !== e && e, a = t.color, c = t.renderContent, h = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), u = (0, $ceac9f6897e0c09e$export$422f9765e6971fdf)(r);
    if ("function" == typeof c) i = c();
    else {
        var f = n;
        void 0 !== u && void 0 !== f && (f = u(f)), i = (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: h.tooltip.basic,
            children: [
                l && (0, $824c049f32d4395d$exports.jsx)($ad81ce180dd1d3ec$export$5a7f9a6004988d01, {
                    color: a,
                    style: h.tooltip.chip
                }),
                void 0 !== f ? (0, $824c049f32d4395d$exports.jsxs)("span", {
                    children: [
                        o,
                        ": ",
                        (0, $824c049f32d4395d$exports.jsx)("strong", {
                            children: "" + f
                        })
                    ]
                }) : o
            ]
        });
    }
    return (0, $824c049f32d4395d$exports.jsx)("div", {
        style: h.tooltip.container,
        children: i
    });
}), $ad81ce180dd1d3ec$var$T = {
    width: "100%",
    borderCollapse: "collapse"
}, $ad81ce180dd1d3ec$export$4b779126465c60ce = (0, $7fPBF.memo)(function(t) {
    var i, o = t.title, n = t.rows, r = void 0 === n ? [] : n, e = t.renderContent, l = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)();
    return r.length ? (i = "function" == typeof e ? e() : (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            o && o,
            (0, $824c049f32d4395d$exports.jsx)("table", {
                style: $ad81ce180dd1d3ec$var$v({}, $ad81ce180dd1d3ec$var$T, l.tooltip.table),
                children: (0, $824c049f32d4395d$exports.jsx)("tbody", {
                    children: r.map(function(t, i) {
                        return (0, $824c049f32d4395d$exports.jsx)("tr", {
                            children: t.map(function(t, i) {
                                return (0, $824c049f32d4395d$exports.jsx)("td", {
                                    style: l.tooltip.tableCell,
                                    children: t
                                }, i);
                            })
                        }, i);
                    })
                })
            })
        ]
    }), (0, $824c049f32d4395d$exports.jsx)("div", {
        style: l.tooltip.container,
        children: i
    })) : null;
});
$ad81ce180dd1d3ec$export$4b779126465c60ce.displayName = "TableTooltip";
var $ad81ce180dd1d3ec$var$E = (0, $7fPBF.memo)(function(t) {
    var i = t.x0, n = t.x1, r = t.y0, e = t.y1, l = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), u = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), d = u.animate, y = u.config, f = (0, $7fPBF.useMemo)(function() {
        return $ad81ce180dd1d3ec$var$v({}, l.crosshair.line, {
            pointerEvents: "none"
        });
    }, [
        l.crosshair.line
    ]), x = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x1: i,
        x2: n,
        y1: r,
        y2: e,
        config: y,
        immediate: !d
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).line, $ad81ce180dd1d3ec$var$v({}, x, {
        fill: "none",
        style: f
    }));
});
$ad81ce180dd1d3ec$var$E.displayName = "CrosshairLine";
var $ad81ce180dd1d3ec$export$2a195a185c8aa9e = (0, $7fPBF.memo)(function(t) {
    var i, o, n = t.width, r = t.height, e = t.type, l = t.x, a = t.y;
    return "cross" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    }, o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }) : "top-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "top" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    } : "top-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "right" === e ? o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    } : "bottom-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "bottom" === e ? i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    } : "bottom-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "left" === e ? o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    } : "x" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    } : "y" === e && (o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }), (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            i && (0, $824c049f32d4395d$exports.jsx)($ad81ce180dd1d3ec$var$E, {
                x0: i.x0,
                x1: i.x1,
                y0: i.y0,
                y1: i.y1
            }),
            o && (0, $824c049f32d4395d$exports.jsx)($ad81ce180dd1d3ec$var$E, {
                x0: o.x0,
                x1: o.x1,
                y0: o.y0,
                y1: o.y1
            })
        ]
    });
});
$ad81ce180dd1d3ec$export$2a195a185c8aa9e.displayName = "Crosshair";
var $ad81ce180dd1d3ec$export$d344f0e974db1e2e = (0, $7fPBF.createContext)({
    showTooltipAt: function() {},
    showTooltipFromEvent: function() {},
    hideTooltip: function() {}
}), $ad81ce180dd1d3ec$export$3a517200cf5bfc1b = {
    isVisible: !1,
    position: [
        null,
        null
    ],
    content: null,
    anchor: null
}, $ad81ce180dd1d3ec$export$c7027a64d546bf1d = (0, $7fPBF.createContext)($ad81ce180dd1d3ec$export$3a517200cf5bfc1b), $ad81ce180dd1d3ec$export$85cc26a2c4544aaa = function(t) {
    var i = (0, $7fPBF.useState)($ad81ce180dd1d3ec$export$3a517200cf5bfc1b), n = i[0], l = i[1], a = (0, $7fPBF.useCallback)(function(t, i, o) {
        var n = i[0], r = i[1];
        void 0 === o && (o = "top"), l({
            isVisible: !0,
            position: [
                n,
                r
            ],
            anchor: o,
            content: t
        });
    }, [
        l
    ]), c = (0, $7fPBF.useCallback)(function(i, o, n) {
        void 0 === n && (n = "top");
        var r = t.current.getBoundingClientRect(), e = t.current.offsetWidth, a = e === r.width ? 1 : e / r.width, c = "touches" in o ? o.touches[0] : o, s = c.clientX, h = c.clientY, u = (s - r.left) * a, d = (h - r.top) * a;
        "left" !== n && "right" !== n || (n = u < r.width / 2 ? "right" : "left"), l({
            isVisible: !0,
            position: [
                u,
                d
            ],
            anchor: n,
            content: i
        });
    }, [
        t,
        l
    ]), s = (0, $7fPBF.useCallback)(function() {
        l($ad81ce180dd1d3ec$export$3a517200cf5bfc1b);
    }, [
        l
    ]);
    return {
        actions: (0, $7fPBF.useMemo)(function() {
            return {
                showTooltipAt: a,
                showTooltipFromEvent: c,
                hideTooltip: s
            };
        }, [
            a,
            c,
            s
        ]),
        state: n
    };
}, $ad81ce180dd1d3ec$export$1c4b08e0eca38426 = function() {
    var t = (0, $7fPBF.useContext)($ad81ce180dd1d3ec$export$d344f0e974db1e2e);
    if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
    return t;
}, $ad81ce180dd1d3ec$export$b6b30c61d706ffee = function() {
    var t = (0, $7fPBF.useContext)($ad81ce180dd1d3ec$export$c7027a64d546bf1d);
    if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
    return t;
}, $ad81ce180dd1d3ec$export$dd4f39ed288d94c9 = function(t) {
    return t.isVisible;
}, $ad81ce180dd1d3ec$export$28c660c63b792dea = function() {
    var t = $ad81ce180dd1d3ec$export$b6b30c61d706ffee();
    return $ad81ce180dd1d3ec$export$dd4f39ed288d94c9(t) ? (0, $824c049f32d4395d$exports.jsx)($ad81ce180dd1d3ec$export$57a09c4864b20b90, {
        position: t.position,
        anchor: t.anchor,
        children: t.content
    }) : null;
}, $ad81ce180dd1d3ec$export$f78649fb9ca566b8 = function(t) {
    var i = t.container, o = t.children, n = $ad81ce180dd1d3ec$export$85cc26a2c4544aaa(i), r = n.actions, e = n.state;
    return (0, $824c049f32d4395d$exports.jsx)($ad81ce180dd1d3ec$export$d344f0e974db1e2e.Provider, {
        value: r,
        children: (0, $824c049f32d4395d$exports.jsx)($ad81ce180dd1d3ec$export$c7027a64d546bf1d.Provider, {
            value: e,
            children: o
        })
    });
};





function $4ebe18b1b418bf55$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $48b4bf19d8759a09$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $48b4bf19d8759a09$var$reB = new RegExp($48b4bf19d8759a09$var$reA.source, "g");
function $48b4bf19d8759a09$var$zero(b) {
    return function() {
        return b;
    };
}
function $48b4bf19d8759a09$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $48b4bf19d8759a09$export$2e2bcd8739ae039(a, b) {
    var bi = $48b4bf19d8759a09$var$reA.lastIndex = $48b4bf19d8759a09$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $48b4bf19d8759a09$var$reA.exec(a)) && (bm = $48b4bf19d8759a09$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $4ebe18b1b418bf55$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $48b4bf19d8759a09$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $48b4bf19d8759a09$var$one(q[0].x) : $48b4bf19d8759a09$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}







class $50993c2d9b36286e$export$dcc6fb7d82b5bc7b extends Map {
    get(key) {
        return super.get($50993c2d9b36286e$var$intern_get(this, key));
    }
    has(key) {
        return super.has($50993c2d9b36286e$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($50993c2d9b36286e$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($50993c2d9b36286e$var$intern_delete(this, key));
    }
    constructor(entries, key = $50993c2d9b36286e$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
}
class $50993c2d9b36286e$export$55278c3294239828 extends Set {
    has(value) {
        return super.has($50993c2d9b36286e$var$intern_get(this, value));
    }
    add(value) {
        return super.add($50993c2d9b36286e$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($50993c2d9b36286e$var$intern_delete(this, value));
    }
    constructor(values, key = $50993c2d9b36286e$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
}
function $50993c2d9b36286e$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $50993c2d9b36286e$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $50993c2d9b36286e$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function $50993c2d9b36286e$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $eaed823ec896ae20$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $eaed823ec896ae20$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


const $0ae5395125647844$export$e4f898ab14d9d460 = Symbol("implicit");
function $0ae5395125647844$export$2e2bcd8739ae039() {
    var index = new (0, $50993c2d9b36286e$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $0ae5395125647844$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $0ae5395125647844$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $50993c2d9b36286e$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0ae5395125647844$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}

function $147ee30c57a726b4$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $865e54520006ff6d$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $3034080dc078938c$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $147ee30c57a726b4$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $147ee30c57a726b4$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $147ee30c57a726b4$export$2e2bcd8739ae039) || f === (0, $865e54520006ff6d$export$2e2bcd8739ae039) ? f : $3034080dc078938c$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $3034080dc078938c$var$zero() {
    return 0;
}


function $3075b45343d53b23$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $3075b45343d53b23$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $eb9dba87048e243f$var$ascendingBisect = (0, $3034080dc078938c$export$2e2bcd8739ae039)((0, $147ee30c57a726b4$export$2e2bcd8739ae039));
const $eb9dba87048e243f$export$4d945ad3ad5751b0 = $eb9dba87048e243f$var$ascendingBisect.right;
const $eb9dba87048e243f$export$df7d25c84ebd12a5 = $eb9dba87048e243f$var$ascendingBisect.left;
const $eb9dba87048e243f$export$c1cb828b1117c77b = (0, $3034080dc078938c$export$2e2bcd8739ae039)((0, $3075b45343d53b23$export$2e2bcd8739ae039)).center;
var $eb9dba87048e243f$export$2e2bcd8739ae039 = $eb9dba87048e243f$export$4d945ad3ad5751b0;


const $0133508c2a5a0194$var$e10 = Math.sqrt(50), $0133508c2a5a0194$var$e5 = Math.sqrt(10), $0133508c2a5a0194$var$e2 = Math.sqrt(2);
function $0133508c2a5a0194$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $0133508c2a5a0194$var$e10 ? 10 : error >= $0133508c2a5a0194$var$e5 ? 5 : error >= $0133508c2a5a0194$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $0133508c2a5a0194$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $0133508c2a5a0194$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $0133508c2a5a0194$var$tickSpec(stop, start, count) : $0133508c2a5a0194$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $0133508c2a5a0194$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $0133508c2a5a0194$var$tickSpec(start, stop, count)[2];
}
function $0133508c2a5a0194$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $0133508c2a5a0194$export$bc64d00cc98e7e95(stop, start, count) : $0133508c2a5a0194$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}




var $lCLl1 = parcelRequire("lCLl1");

var $lCLl1 = parcelRequire("lCLl1");
function $c7158e81d45c3a88$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $c7158e81d45c3a88$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $c7158e81d45c3a88$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $02e9c20fce02cd11$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $c7158e81d45c3a88$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $d2cb3578c16633fd$export$2e2bcd8739ae039 = (x)=>()=>x;


function $a5e76551932d03d7$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $a5e76551932d03d7$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $a5e76551932d03d7$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $a5e76551932d03d7$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $d2cb3578c16633fd$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $a5e76551932d03d7$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $a5e76551932d03d7$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $a5e76551932d03d7$var$exponential(a, b, y) : (0, $d2cb3578c16633fd$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $a5e76551932d03d7$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $a5e76551932d03d7$var$linear(a, d) : (0, $d2cb3578c16633fd$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $0ccb89cfd7361f92$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $a5e76551932d03d7$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $lCLl1.rgb)(start)).r, (end = (0, $lCLl1.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $a5e76551932d03d7$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $0ccb89cfd7361f92$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $lCLl1.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $0ccb89cfd7361f92$export$2c0e28f2e2852d3f = $0ccb89cfd7361f92$var$rgbSpline((0, $c7158e81d45c3a88$export$2e2bcd8739ae039));
var $0ccb89cfd7361f92$export$53d5214f625ccd4c = $0ccb89cfd7361f92$var$rgbSpline((0, $02e9c20fce02cd11$export$2e2bcd8739ae039));



function $fb1aa86fb7d60067$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $fb1aa86fb7d60067$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $5d95537f98501973$export$2e2bcd8739ae039(a, b) {
    return ((0, $fb1aa86fb7d60067$export$5cd576d1827d40c8)(b) ? (0, $fb1aa86fb7d60067$export$2e2bcd8739ae039) : $5d95537f98501973$export$15d09067c6a5ee49)(a, b);
}
function $5d95537f98501973$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $b65d8bb781662799$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $29ea35b3827e5388$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}




function $f84558c5906f0693$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $b65d8bb781662799$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}





function $b65d8bb781662799$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $d2cb3578c16633fd$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $4ebe18b1b418bf55$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $lCLl1.default)(b)) ? (b = c, $0ccb89cfd7361f92$export$2e2bcd8739ae039) : (0, $48b4bf19d8759a09$export$2e2bcd8739ae039) : b instanceof (0, $lCLl1.default) ? (0, $0ccb89cfd7361f92$export$2e2bcd8739ae039) : b instanceof Date ? (0, $29ea35b3827e5388$export$2e2bcd8739ae039) : (0, $fb1aa86fb7d60067$export$5cd576d1827d40c8)(b) ? (0, $fb1aa86fb7d60067$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $5d95537f98501973$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $f84558c5906f0693$export$2e2bcd8739ae039) : (0, $4ebe18b1b418bf55$export$2e2bcd8739ae039))(a, b);
}

function $b0ce28d6113463f1$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $ab92c0a35137f8fb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $1308aa7206bf2218$export$2e2bcd8739ae039(x) {
    return +x;
}


var $dd7e4e0e97e8ad6b$var$unit = [
    0,
    1
];
function $dd7e4e0e97e8ad6b$export$f0954fd7d5368655(x) {
    return x;
}
function $dd7e4e0e97e8ad6b$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ab92c0a35137f8fb$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $dd7e4e0e97e8ad6b$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $dd7e4e0e97e8ad6b$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $dd7e4e0e97e8ad6b$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $dd7e4e0e97e8ad6b$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $dd7e4e0e97e8ad6b$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $dd7e4e0e97e8ad6b$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $eb9dba87048e243f$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $dd7e4e0e97e8ad6b$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $dd7e4e0e97e8ad6b$export$6b468dcfb64c653c() {
    var domain = $dd7e4e0e97e8ad6b$var$unit, range = $dd7e4e0e97e8ad6b$var$unit, interpolate = (0, $b65d8bb781662799$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $dd7e4e0e97e8ad6b$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $dd7e4e0e97e8ad6b$export$f0954fd7d5368655) clamp = $dd7e4e0e97e8ad6b$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $dd7e4e0e97e8ad6b$var$polymap : $dd7e4e0e97e8ad6b$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $4ebe18b1b418bf55$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $1308aa7206bf2218$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $b0ce28d6113463f1$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $dd7e4e0e97e8ad6b$export$f0954fd7d5368655, rescale()) : clamp !== $dd7e4e0e97e8ad6b$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $dd7e4e0e97e8ad6b$export$2e2bcd8739ae039() {
    return $dd7e4e0e97e8ad6b$export$6b468dcfb64c653c()($dd7e4e0e97e8ad6b$export$f0954fd7d5368655, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655);
}





function $b780c84e11463cbf$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $0133508c2a5a0194$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $fa586b3bd9779819$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $2330bd6e996ae48f$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $f979cbd3e1200bf1$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $cf48ffcf3023f148$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $10c1b131ad630542$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $f979cbd3e1200bf1$export$d9468344d3651243)(specifier);
}


function $8b8f36a539eb80e5$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $0133508c2a5a0194$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $b780c84e11463cbf$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $0133508c2a5a0194$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $8b8f36a539eb80e5$export$2e2bcd8739ae039() {
    var scale = (0, $dd7e4e0e97e8ad6b$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $dd7e4e0e97e8ad6b$export$784d13d8ee351f07)(scale, $8b8f36a539eb80e5$export$2e2bcd8739ae039());
    };
    (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $8b8f36a539eb80e5$export$16a5d4b4a61a274d(scale);
}



function $701754d8f18cf864$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $eb9dba87048e243f$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $701754d8f18cf864$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply((0, $8b8f36a539eb80e5$export$16a5d4b4a61a274d)(scale), arguments);
}







function $f3dad0f4212a0070$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $a5d1681d8e40f4e7$var$transformLog(x) {
    return Math.log(x);
}
function $a5d1681d8e40f4e7$var$transformExp(x) {
    return Math.exp(x);
}
function $a5d1681d8e40f4e7$var$transformLogn(x) {
    return -Math.log(-x);
}
function $a5d1681d8e40f4e7$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $a5d1681d8e40f4e7$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $a5d1681d8e40f4e7$var$powp(base) {
    return base === 10 ? $a5d1681d8e40f4e7$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $a5d1681d8e40f4e7$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $a5d1681d8e40f4e7$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $a5d1681d8e40f4e7$export$860836db074028f0(transform) {
    const scale = transform($a5d1681d8e40f4e7$var$transformLog, $a5d1681d8e40f4e7$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $a5d1681d8e40f4e7$var$logp(base), pows = $a5d1681d8e40f4e7$var$powp(base);
        if (domain()[0] < 0) {
            logs = $a5d1681d8e40f4e7$var$reflect(logs), pows = $a5d1681d8e40f4e7$var$reflect(pows);
            transform($a5d1681d8e40f4e7$var$transformLogn, $a5d1681d8e40f4e7$var$transformExpn);
        } else transform($a5d1681d8e40f4e7$var$transformLog, $a5d1681d8e40f4e7$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $0133508c2a5a0194$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $0133508c2a5a0194$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $fa586b3bd9779819$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $f979cbd3e1200bf1$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $f3dad0f4212a0070$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $a5d1681d8e40f4e7$export$2e2bcd8739ae039() {
    const scale = $a5d1681d8e40f4e7$export$860836db074028f0((0, $dd7e4e0e97e8ad6b$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $dd7e4e0e97e8ad6b$export$784d13d8ee351f07)(scale, $a5d1681d8e40f4e7$export$2e2bcd8739ae039()).base(scale.base());
    (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $acc2eb21ce565e92$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $acc2eb21ce565e92$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $acc2eb21ce565e92$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($acc2eb21ce565e92$var$transformSymlog(c), $acc2eb21ce565e92$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($acc2eb21ce565e92$var$transformSymlog(c = +_), $acc2eb21ce565e92$var$transformSymexp(c)) : c;
    };
    return (0, $8b8f36a539eb80e5$export$16a5d4b4a61a274d)(scale);
}
function $acc2eb21ce565e92$export$2e2bcd8739ae039() {
    var scale = $acc2eb21ce565e92$export$4602684e614eba38((0, $dd7e4e0e97e8ad6b$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $dd7e4e0e97e8ad6b$export$784d13d8ee351f07)(scale, $acc2eb21ce565e92$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $3131db795c4cb389$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $3131db795c4cb389$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $3131db795c4cb389$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $3131db795c4cb389$export$34695211ec403a46(transform) {
    var scale = transform((0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655), (0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655), (0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($3131db795c4cb389$var$transformSqrt, $3131db795c4cb389$var$transformSquare) : transform($3131db795c4cb389$var$transformPow(exponent), $3131db795c4cb389$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $8b8f36a539eb80e5$export$16a5d4b4a61a274d)(scale);
}
function $3131db795c4cb389$export$2e2bcd8739ae039() {
    var scale = $3131db795c4cb389$export$34695211ec403a46((0, $dd7e4e0e97e8ad6b$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $dd7e4e0e97e8ad6b$export$784d13d8ee351f07)(scale, $3131db795c4cb389$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $3131db795c4cb389$export$eba8049fb5020b81() {
    return $3131db795c4cb389$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $1e2488e4583916b4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $b65d8bb781662799$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $b0ce28d6113463f1$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $1e2488e4583916b4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $1e2488e4583916b4$export$2e2bcd8739ae039() {
    var scale = (0, $8b8f36a539eb80e5$export$16a5d4b4a61a274d)($1e2488e4583916b4$var$transformer()((0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $1e2488e4583916b4$export$784d13d8ee351f07(scale, $1e2488e4583916b4$export$2e2bcd8739ae039());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1e2488e4583916b4$export$6843e08bf2ff981f() {
    var scale = (0, $a5d1681d8e40f4e7$export$860836db074028f0)($1e2488e4583916b4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $1e2488e4583916b4$export$784d13d8ee351f07(scale, $1e2488e4583916b4$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1e2488e4583916b4$export$9d4af4de62c81941() {
    var scale = (0, $acc2eb21ce565e92$export$4602684e614eba38)($1e2488e4583916b4$var$transformer());
    scale.copy = function() {
        return $1e2488e4583916b4$export$784d13d8ee351f07(scale, $1e2488e4583916b4$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1e2488e4583916b4$export$de9f78581b4f2405() {
    var scale = (0, $3131db795c4cb389$export$34695211ec403a46)($1e2488e4583916b4$var$transformer());
    scale.copy = function() {
        return $1e2488e4583916b4$export$784d13d8ee351f07(scale, $1e2488e4583916b4$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1e2488e4583916b4$export$413d935127ed466e() {
    return $1e2488e4583916b4$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}


function $bb016a9f292c1741$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}



var $631c5cdfe1010ca5$export$2e2bcd8739ae039 = (scheme)=>(0, $0ccb89cfd7361f92$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $f7446b8c7cd79059$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $f7446b8c7cd79059$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($f7446b8c7cd79059$export$3005042704f95a69);



var $4ca4fb75e5a423d5$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $4ca4fb75e5a423d5$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($4ca4fb75e5a423d5$export$3005042704f95a69);



var $a2c8e9b842322913$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $a2c8e9b842322913$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($a2c8e9b842322913$export$3005042704f95a69);



var $d79efb228ae4624f$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $d79efb228ae4624f$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($d79efb228ae4624f$export$3005042704f95a69);


var $lHrSm = parcelRequire("lHrSm");

var $lCLl1 = parcelRequire("lCLl1");
const $906ba38d592c50bd$export$8449e153fbd325fc = Math.PI / 180;
const $906ba38d592c50bd$export$41fc368e1a942b97 = 180 / Math.PI;


var $cb064f2625a5f232$var$A = -0.14861, $cb064f2625a5f232$var$B = 1.78277, $cb064f2625a5f232$var$C = -0.29227, $cb064f2625a5f232$var$D = -0.90649, $cb064f2625a5f232$var$E = 1.97294, $cb064f2625a5f232$var$ED = $cb064f2625a5f232$var$E * $cb064f2625a5f232$var$D, $cb064f2625a5f232$var$EB = $cb064f2625a5f232$var$E * $cb064f2625a5f232$var$B, $cb064f2625a5f232$var$BC_DA = $cb064f2625a5f232$var$B * $cb064f2625a5f232$var$C - $cb064f2625a5f232$var$D * $cb064f2625a5f232$var$A;
function $cb064f2625a5f232$var$cubehelixConvert(o) {
    if (o instanceof $cb064f2625a5f232$export$57ed4bde61a1e2f2) return new $cb064f2625a5f232$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $lCLl1.Rgb))) o = (0, $lCLl1.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($cb064f2625a5f232$var$BC_DA * b + $cb064f2625a5f232$var$ED * r - $cb064f2625a5f232$var$EB * g) / ($cb064f2625a5f232$var$BC_DA + $cb064f2625a5f232$var$ED - $cb064f2625a5f232$var$EB), bl = b - l, k = ($cb064f2625a5f232$var$E * (g - l) - $cb064f2625a5f232$var$C * bl) / $cb064f2625a5f232$var$D, s = Math.sqrt(k * k + bl * bl) / ($cb064f2625a5f232$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $906ba38d592c50bd$export$41fc368e1a942b97) - 120 : NaN;
    return new $cb064f2625a5f232$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $cb064f2625a5f232$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $cb064f2625a5f232$var$cubehelixConvert(h) : new $cb064f2625a5f232$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $cb064f2625a5f232$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $lHrSm.default)($cb064f2625a5f232$export$57ed4bde61a1e2f2, $cb064f2625a5f232$export$2e2bcd8739ae039, (0, $lHrSm.extend)((0, $lCLl1.Color), {
    brighter (k) {
        k = k == null ? (0, $lCLl1.brighter) : Math.pow((0, $lCLl1.brighter), k);
        return new $cb064f2625a5f232$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $lCLl1.darker) : Math.pow((0, $lCLl1.darker), k);
        return new $cb064f2625a5f232$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $906ba38d592c50bd$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $lCLl1.Rgb)(255 * (l + a * ($cb064f2625a5f232$var$A * cosh + $cb064f2625a5f232$var$B * sinh)), 255 * (l + a * ($cb064f2625a5f232$var$C * cosh + $cb064f2625a5f232$var$D * sinh)), 255 * (l + a * ($cb064f2625a5f232$var$E * cosh)), this.opacity);
    }
}));




function $1cfcbb4531d383e8$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $cb064f2625a5f232$export$2e2bcd8739ae039)(start)).h, (end = (0, $cb064f2625a5f232$export$2e2bcd8739ae039)(end)).h), s = (0, $a5e76551932d03d7$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $a5e76551932d03d7$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $a5e76551932d03d7$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $1cfcbb4531d383e8$export$2e2bcd8739ae039 = $1cfcbb4531d383e8$var$cubehelix((0, $a5e76551932d03d7$export$97d7b0c7ddb78dcf));
var $1cfcbb4531d383e8$export$934fa09ad474a1b4 = $1cfcbb4531d383e8$var$cubehelix((0, $a5e76551932d03d7$export$2e2bcd8739ae039));


var $aa1dc4855b4fb73a$export$fc70efcec537be98 = (0, $1cfcbb4531d383e8$export$934fa09ad474a1b4)((0, $cb064f2625a5f232$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $cb064f2625a5f232$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $aa1dc4855b4fb73a$export$c5cedbc1ab3be2c3 = (0, $1cfcbb4531d383e8$export$934fa09ad474a1b4)((0, $cb064f2625a5f232$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $cb064f2625a5f232$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $aa1dc4855b4fb73a$var$c = (0, $cb064f2625a5f232$export$2e2bcd8739ae039)();
function $aa1dc4855b4fb73a$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $aa1dc4855b4fb73a$var$c.h = 360 * t - 100;
    $aa1dc4855b4fb73a$var$c.s = 1.5 - 1.5 * ts;
    $aa1dc4855b4fb73a$var$c.l = 0.8 - 0.9 * ts;
    return $aa1dc4855b4fb73a$var$c + "";
}



var $b98f19dff4332012$export$2e2bcd8739ae039 = (0, $1cfcbb4531d383e8$export$934fa09ad474a1b4)((0, $cb064f2625a5f232$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $cb064f2625a5f232$export$2e2bcd8739ae039)(-240, 0.5, 1.0));



var $40927aa6b8f77f0f$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $40927aa6b8f77f0f$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($40927aa6b8f77f0f$export$3005042704f95a69);



var $3a66f9057929a79b$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $3a66f9057929a79b$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($3a66f9057929a79b$export$3005042704f95a69);



var $f64ce98f053d3c1f$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $f64ce98f053d3c1f$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($f64ce98f053d3c1f$export$3005042704f95a69);


function $1cfa41501e7d069c$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $1cfa41501e7d069c$export$2e2bcd8739ae039 = $1cfa41501e7d069c$var$ramp((0, $bb016a9f292c1741$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $1cfa41501e7d069c$export$c41e69203f572e8d = $1cfa41501e7d069c$var$ramp((0, $bb016a9f292c1741$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $1cfa41501e7d069c$export$ad0c8285c8ea6dbd = $1cfa41501e7d069c$var$ramp((0, $bb016a9f292c1741$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $1cfa41501e7d069c$export$6664860a633d9daf = $1cfa41501e7d069c$var$ramp((0, $bb016a9f292c1741$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



var $b1f714e4e4b5adf6$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $b1f714e4e4b5adf6$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($b1f714e4e4b5adf6$export$3005042704f95a69);



var $03b2383dd0bc50f4$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $03b2383dd0bc50f4$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($03b2383dd0bc50f4$export$3005042704f95a69);



var $916ef83d77ec7e5c$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $916ef83d77ec7e5c$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($916ef83d77ec7e5c$export$3005042704f95a69);



var $690b3d0fd5c4fa3e$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $690b3d0fd5c4fa3e$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($690b3d0fd5c4fa3e$export$3005042704f95a69);



var $3949a449725c7bcf$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $3949a449725c7bcf$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($3949a449725c7bcf$export$3005042704f95a69);



var $3888a5c20c404764$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $3888a5c20c404764$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($3888a5c20c404764$export$3005042704f95a69);



var $c76084b8a3907b15$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $c76084b8a3907b15$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($c76084b8a3907b15$export$3005042704f95a69);



var $7bd35661446703e9$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $7bd35661446703e9$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($7bd35661446703e9$export$3005042704f95a69);



var $885c97e4dd2e4422$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $885c97e4dd2e4422$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($885c97e4dd2e4422$export$3005042704f95a69);



var $9bc47d279cd4b969$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $9bc47d279cd4b969$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($9bc47d279cd4b969$export$3005042704f95a69);



var $2d70e60074d77a9b$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $2d70e60074d77a9b$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($2d70e60074d77a9b$export$3005042704f95a69);



var $cfe4c086b06bdbca$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $cfe4c086b06bdbca$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($cfe4c086b06bdbca$export$3005042704f95a69);



var $cc0d3e6a75793f0c$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $cc0d3e6a75793f0c$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($cc0d3e6a75793f0c$export$3005042704f95a69);



var $fb00ca5476c43131$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $fb00ca5476c43131$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($fb00ca5476c43131$export$3005042704f95a69);



var $cbf39e6a8bf8c1a3$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $cbf39e6a8bf8c1a3$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($cbf39e6a8bf8c1a3$export$3005042704f95a69);


var $lCLl1 = parcelRequire("lCLl1");
var $45301daac27a7a0d$var$c = (0, $lCLl1.rgb)(), $45301daac27a7a0d$var$pi_1_3 = Math.PI / 3, $45301daac27a7a0d$var$pi_2_3 = Math.PI * 2 / 3;
function $45301daac27a7a0d$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $45301daac27a7a0d$var$c.r = 255 * (x = Math.sin(t)) * x;
    $45301daac27a7a0d$var$c.g = 255 * (x = Math.sin(t + $45301daac27a7a0d$var$pi_1_3)) * x;
    $45301daac27a7a0d$var$c.b = 255 * (x = Math.sin(t + $45301daac27a7a0d$var$pi_2_3)) * x;
    return $45301daac27a7a0d$var$c + "";
}



var $7f958806be18ac58$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $7f958806be18ac58$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($7f958806be18ac58$export$3005042704f95a69);



var $07bef80147eac796$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $07bef80147eac796$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($07bef80147eac796$export$3005042704f95a69);



var $bfa6a20338713c31$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $bfa6a20338713c31$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($bfa6a20338713c31$export$3005042704f95a69);



var $5c0c674af7fafdec$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $5c0c674af7fafdec$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($5c0c674af7fafdec$export$3005042704f95a69);



var $de24445d9010aa31$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $bb016a9f292c1741$export$2e2bcd8739ae039));
var $de24445d9010aa31$export$2e2bcd8739ae039 = (0, $631c5cdfe1010ca5$export$2e2bcd8739ae039)($de24445d9010aa31$export$3005042704f95a69);


var $19d018fb519d54fd$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");


var $9ea3dd4fdadefd0a$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");


var $7779d20e0fc477c0$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");


var $34fed29c954f6730$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $ef3181ffb4185d42$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");


var $786f1d0067ffea6a$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");


var $2f85dc235274390a$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");


var $80f74c9d958fa597$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");


var $7958a448ec490cf3$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");




function $6faea3746a35a674$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $6faea3746a35a674$export$957f7263e89bedd2(context) {
    this._context = context;
}
$6faea3746a35a674$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $6faea3746a35a674$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $6faea3746a35a674$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $6faea3746a35a674$export$2e2bcd8739ae039(context) {
    return new $6faea3746a35a674$export$957f7263e89bedd2(context);
}

function $0011527904463bbe$export$2e2bcd8739ae039() {}



function $1138e00666d598a4$var$BasisClosed(context) {
    this._context = context;
}
$1138e00666d598a4$var$BasisClosed.prototype = {
    areaStart: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    areaEnd: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $6faea3746a35a674$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $1138e00666d598a4$export$2e2bcd8739ae039(context) {
    return new $1138e00666d598a4$var$BasisClosed(context);
}


function $12cd6759e665391e$var$BasisOpen(context) {
    this._context = context;
}
$12cd6759e665391e$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6faea3746a35a674$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $12cd6759e665391e$export$2e2bcd8739ae039(context) {
    return new $12cd6759e665391e$var$BasisOpen(context);
}


function $332dc67fa055f029$var$Bundle(context, beta) {
    this._basis = new (0, $6faea3746a35a674$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$332dc67fa055f029$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $332dc67fa055f029$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $6faea3746a35a674$export$957f7263e89bedd2)(context) : new $332dc67fa055f029$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);


var $cKhdt = parcelRequire("cKhdt");

var $cKhdt = parcelRequire("cKhdt");
function $c9866b5bab8eb0c7$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c9866b5bab8eb0c7$export$da3940d7e9162858.prototype = {
    areaStart: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    areaEnd: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $cKhdt.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c9866b5bab8eb0c7$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c9866b5bab8eb0c7$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $cKhdt = parcelRequire("cKhdt");
function $45e6d0dcc1b9e7f0$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$45e6d0dcc1b9e7f0$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $cKhdt.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $45e6d0dcc1b9e7f0$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $45e6d0dcc1b9e7f0$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $6G7B4 = parcelRequire("6G7B4");


var $6G7B4 = parcelRequire("6G7B4");
function $218f7bda61b1d403$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$218f7bda61b1d403$var$CatmullRomClosed.prototype = {
    areaStart: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    areaEnd: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $6G7B4.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $218f7bda61b1d403$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $218f7bda61b1d403$var$CatmullRomClosed(context, alpha) : new (0, $c9866b5bab8eb0c7$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $6G7B4 = parcelRequire("6G7B4");
function $2dcafd9dedc42e9e$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$2dcafd9dedc42e9e$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6G7B4.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $2dcafd9dedc42e9e$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $2dcafd9dedc42e9e$var$CatmullRomOpen(context, alpha) : new (0, $45e6d0dcc1b9e7f0$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

function $ddb89b6f130198b9$var$Linear(context) {
    this._context = context;
}
$ddb89b6f130198b9$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $ddb89b6f130198b9$export$2e2bcd8739ae039(context) {
    return new $ddb89b6f130198b9$var$Linear(context);
}


function $5baadbab21e74cd5$var$LinearClosed(context) {
    this._context = context;
}
$5baadbab21e74cd5$var$LinearClosed.prototype = {
    areaStart: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    areaEnd: (0, $0011527904463bbe$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $5baadbab21e74cd5$export$2e2bcd8739ae039(context) {
    return new $5baadbab21e74cd5$var$LinearClosed(context);
}

function $83e1e52e12ebf7b6$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $83e1e52e12ebf7b6$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($83e1e52e12ebf7b6$var$sign(s0) + $83e1e52e12ebf7b6$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $83e1e52e12ebf7b6$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $83e1e52e12ebf7b6$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $83e1e52e12ebf7b6$var$MonotoneX(context) {
    this._context = context;
}
$83e1e52e12ebf7b6$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $83e1e52e12ebf7b6$var$point(this, this._t0, $83e1e52e12ebf7b6$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $83e1e52e12ebf7b6$var$point(this, $83e1e52e12ebf7b6$var$slope2(this, t1 = $83e1e52e12ebf7b6$var$slope3(this, x, y)), t1);
                break;
            default:
                $83e1e52e12ebf7b6$var$point(this, this._t0, t1 = $83e1e52e12ebf7b6$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $83e1e52e12ebf7b6$var$MonotoneY(context) {
    this._context = new $83e1e52e12ebf7b6$var$ReflectContext(context);
}
($83e1e52e12ebf7b6$var$MonotoneY.prototype = Object.create($83e1e52e12ebf7b6$var$MonotoneX.prototype)).point = function(x, y) {
    $83e1e52e12ebf7b6$var$MonotoneX.prototype.point.call(this, y, x);
};
function $83e1e52e12ebf7b6$var$ReflectContext(context) {
    this._context = context;
}
$83e1e52e12ebf7b6$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $83e1e52e12ebf7b6$export$99563b5420dbdc55(context) {
    return new $83e1e52e12ebf7b6$var$MonotoneX(context);
}
function $83e1e52e12ebf7b6$export$8b5360456d6bdb88(context) {
    return new $83e1e52e12ebf7b6$var$MonotoneY(context);
}

function $160cb7d7a7ffcd09$var$Natural(context) {
    this._context = context;
}
$160cb7d7a7ffcd09$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $160cb7d7a7ffcd09$var$controlPoints(x), py = $160cb7d7a7ffcd09$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $160cb7d7a7ffcd09$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $160cb7d7a7ffcd09$export$2e2bcd8739ae039(context) {
    return new $160cb7d7a7ffcd09$var$Natural(context);
}

function $1f5b97e3d1f7329f$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1f5b97e3d1f7329f$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1f5b97e3d1f7329f$export$2e2bcd8739ae039(context) {
    return new $1f5b97e3d1f7329f$var$Step(context, 0.5);
}
function $1f5b97e3d1f7329f$export$10eafa5b7478b343(context) {
    return new $1f5b97e3d1f7329f$var$Step(context, 0);
}
function $1f5b97e3d1f7329f$export$793b3db073781cbb(context) {
    return new $1f5b97e3d1f7329f$var$Step(context, 1);
}

function $15ee0fa0ceb6123a$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

function $5e9c35a540f1fc5a$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $20a285b4d9174da7$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $5e9c35a540f1fc5a$export$2e2bcd8739ae039)(series, order);
}


function $065abbd70dde12e9$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $5e9c35a540f1fc5a$export$2e2bcd8739ae039)(series, order);
}


function $13f3984b534593cf$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $5e9c35a540f1fc5a$export$2e2bcd8739ae039)(series, order);
}

function $fcb8b9669a144823$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $3a02ce64ce502abc$export$2e2bcd8739ae039(series) {
    var sums = series.map($3a02ce64ce502abc$export$8a63f25cc62965f1);
    return (0, $fcb8b9669a144823$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $3a02ce64ce502abc$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}


function $e09590ce84b12c2b$export$2e2bcd8739ae039(series) {
    return (0, $3a02ce64ce502abc$export$2e2bcd8739ae039)(series).reverse();
}


function $c2a8abbf0d09cff5$export$2e2bcd8739ae039(series) {
    var peaks = series.map($c2a8abbf0d09cff5$var$peak);
    return (0, $fcb8b9669a144823$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $c2a8abbf0d09cff5$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $59e2caf3828cc255$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $3a02ce64ce502abc$export$8a63f25cc62965f1)), order = (0, $c2a8abbf0d09cff5$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}


function $07fc755dc0f0a225$export$2e2bcd8739ae039(series) {
    return (0, $fcb8b9669a144823$export$2e2bcd8739ae039)(series).reverse();
}




function $95479ec86af7adab$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $95479ec86af7adab$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $95479ec86af7adab$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $95479ec86af7adab$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $95479ec86af7adab$var$formatRe(locale_periods), periodLookup = $95479ec86af7adab$var$formatLookup(locale_periods), weekdayRe = $95479ec86af7adab$var$formatRe(locale_weekdays), weekdayLookup = $95479ec86af7adab$var$formatLookup(locale_weekdays), shortWeekdayRe = $95479ec86af7adab$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $95479ec86af7adab$var$formatLookup(locale_shortWeekdays), monthRe = $95479ec86af7adab$var$formatRe(locale_months), monthLookup = $95479ec86af7adab$var$formatLookup(locale_months), shortMonthRe = $95479ec86af7adab$var$formatRe(locale_shortMonths), shortMonthLookup = $95479ec86af7adab$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $95479ec86af7adab$var$formatDayOfMonth,
        "e": $95479ec86af7adab$var$formatDayOfMonth,
        "f": $95479ec86af7adab$var$formatMicroseconds,
        "g": $95479ec86af7adab$var$formatYearISO,
        "G": $95479ec86af7adab$var$formatFullYearISO,
        "H": $95479ec86af7adab$var$formatHour24,
        "I": $95479ec86af7adab$var$formatHour12,
        "j": $95479ec86af7adab$var$formatDayOfYear,
        "L": $95479ec86af7adab$var$formatMilliseconds,
        "m": $95479ec86af7adab$var$formatMonthNumber,
        "M": $95479ec86af7adab$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $95479ec86af7adab$var$formatUnixTimestamp,
        "s": $95479ec86af7adab$var$formatUnixTimestampSeconds,
        "S": $95479ec86af7adab$var$formatSeconds,
        "u": $95479ec86af7adab$var$formatWeekdayNumberMonday,
        "U": $95479ec86af7adab$var$formatWeekNumberSunday,
        "V": $95479ec86af7adab$var$formatWeekNumberISO,
        "w": $95479ec86af7adab$var$formatWeekdayNumberSunday,
        "W": $95479ec86af7adab$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $95479ec86af7adab$var$formatYear,
        "Y": $95479ec86af7adab$var$formatFullYear,
        "Z": $95479ec86af7adab$var$formatZone,
        "%": $95479ec86af7adab$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $95479ec86af7adab$var$formatUTCDayOfMonth,
        "e": $95479ec86af7adab$var$formatUTCDayOfMonth,
        "f": $95479ec86af7adab$var$formatUTCMicroseconds,
        "g": $95479ec86af7adab$var$formatUTCYearISO,
        "G": $95479ec86af7adab$var$formatUTCFullYearISO,
        "H": $95479ec86af7adab$var$formatUTCHour24,
        "I": $95479ec86af7adab$var$formatUTCHour12,
        "j": $95479ec86af7adab$var$formatUTCDayOfYear,
        "L": $95479ec86af7adab$var$formatUTCMilliseconds,
        "m": $95479ec86af7adab$var$formatUTCMonthNumber,
        "M": $95479ec86af7adab$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $95479ec86af7adab$var$formatUnixTimestamp,
        "s": $95479ec86af7adab$var$formatUnixTimestampSeconds,
        "S": $95479ec86af7adab$var$formatUTCSeconds,
        "u": $95479ec86af7adab$var$formatUTCWeekdayNumberMonday,
        "U": $95479ec86af7adab$var$formatUTCWeekNumberSunday,
        "V": $95479ec86af7adab$var$formatUTCWeekNumberISO,
        "w": $95479ec86af7adab$var$formatUTCWeekdayNumberSunday,
        "W": $95479ec86af7adab$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $95479ec86af7adab$var$formatUTCYear,
        "Y": $95479ec86af7adab$var$formatUTCFullYear,
        "Z": $95479ec86af7adab$var$formatUTCZone,
        "%": $95479ec86af7adab$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $95479ec86af7adab$var$parseDayOfMonth,
        "e": $95479ec86af7adab$var$parseDayOfMonth,
        "f": $95479ec86af7adab$var$parseMicroseconds,
        "g": $95479ec86af7adab$var$parseYear,
        "G": $95479ec86af7adab$var$parseFullYear,
        "H": $95479ec86af7adab$var$parseHour24,
        "I": $95479ec86af7adab$var$parseHour24,
        "j": $95479ec86af7adab$var$parseDayOfYear,
        "L": $95479ec86af7adab$var$parseMilliseconds,
        "m": $95479ec86af7adab$var$parseMonthNumber,
        "M": $95479ec86af7adab$var$parseMinutes,
        "p": parsePeriod,
        "q": $95479ec86af7adab$var$parseQuarter,
        "Q": $95479ec86af7adab$var$parseUnixTimestamp,
        "s": $95479ec86af7adab$var$parseUnixTimestampSeconds,
        "S": $95479ec86af7adab$var$parseSeconds,
        "u": $95479ec86af7adab$var$parseWeekdayNumberMonday,
        "U": $95479ec86af7adab$var$parseWeekNumberSunday,
        "V": $95479ec86af7adab$var$parseWeekNumberISO,
        "w": $95479ec86af7adab$var$parseWeekdayNumberSunday,
        "W": $95479ec86af7adab$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $95479ec86af7adab$var$parseYear,
        "Y": $95479ec86af7adab$var$parseFullYear,
        "Z": $95479ec86af7adab$var$parseZone,
        "%": $95479ec86af7adab$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $95479ec86af7adab$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $95479ec86af7adab$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $95479ec86af7adab$var$utcDate($95479ec86af7adab$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).ceil(week) : (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)(week);
                    week = (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $95479ec86af7adab$var$localDate($95479ec86af7adab$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).ceil(week) : (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8)(week);
                    week = (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $95479ec86af7adab$var$utcDate($95479ec86af7adab$var$newDate(d.y, 0, 1)).getUTCDay() : $95479ec86af7adab$var$localDate($95479ec86af7adab$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $95479ec86af7adab$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $95479ec86af7adab$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $95479ec86af7adab$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $95479ec86af7adab$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $95479ec86af7adab$var$numberRe = /^\s*\d+/, $95479ec86af7adab$var$percentRe = /^%/, $95479ec86af7adab$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $95479ec86af7adab$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $95479ec86af7adab$var$requote(s) {
    return s.replace($95479ec86af7adab$var$requoteRe, "\\$&");
}
function $95479ec86af7adab$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($95479ec86af7adab$var$requote).join("|") + ")", "i");
}
function $95479ec86af7adab$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $95479ec86af7adab$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseWeekNumberSunday(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseWeekNumberISO(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseWeekNumberMonday(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseFullYear(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseYear(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseQuarter(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseMonthNumber(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseDayOfMonth(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseDayOfYear(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseHour24(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseMinutes(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseSeconds(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseMilliseconds(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseMicroseconds(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseLiteralPercent(d, string, i) {
    var n = $95479ec86af7adab$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $95479ec86af7adab$var$parseUnixTimestamp(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $95479ec86af7adab$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $95479ec86af7adab$var$formatDayOfMonth(d, p) {
    return $95479ec86af7adab$var$pad(d.getDate(), p, 2);
}
function $95479ec86af7adab$var$formatHour24(d, p) {
    return $95479ec86af7adab$var$pad(d.getHours(), p, 2);
}
function $95479ec86af7adab$var$formatHour12(d, p) {
    return $95479ec86af7adab$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $95479ec86af7adab$var$formatDayOfYear(d, p) {
    return $95479ec86af7adab$var$pad(1 + (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $95479ec86af7adab$var$formatMilliseconds(d, p) {
    return $95479ec86af7adab$var$pad(d.getMilliseconds(), p, 3);
}
function $95479ec86af7adab$var$formatMicroseconds(d, p) {
    return $95479ec86af7adab$var$formatMilliseconds(d, p) + "000";
}
function $95479ec86af7adab$var$formatMonthNumber(d, p) {
    return $95479ec86af7adab$var$pad(d.getMonth() + 1, p, 2);
}
function $95479ec86af7adab$var$formatMinutes(d, p) {
    return $95479ec86af7adab$var$pad(d.getMinutes(), p, 2);
}
function $95479ec86af7adab$var$formatSeconds(d, p) {
    return $95479ec86af7adab$var$pad(d.getSeconds(), p, 2);
}
function $95479ec86af7adab$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $95479ec86af7adab$var$formatWeekNumberSunday(d, p) {
    return $95479ec86af7adab$var$pad((0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $95479ec86af7adab$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
}
function $95479ec86af7adab$var$formatWeekNumberISO(d, p) {
    d = $95479ec86af7adab$var$dISO(d);
    return $95479ec86af7adab$var$pad((0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d) + ((0, $c352773cb286f235$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $95479ec86af7adab$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $95479ec86af7adab$var$formatWeekNumberMonday(d, p) {
    return $95479ec86af7adab$var$pad((0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $95479ec86af7adab$var$formatYear(d, p) {
    return $95479ec86af7adab$var$pad(d.getFullYear() % 100, p, 2);
}
function $95479ec86af7adab$var$formatYearISO(d, p) {
    d = $95479ec86af7adab$var$dISO(d);
    return $95479ec86af7adab$var$pad(d.getFullYear() % 100, p, 2);
}
function $95479ec86af7adab$var$formatFullYear(d, p) {
    return $95479ec86af7adab$var$pad(d.getFullYear() % 10000, p, 4);
}
function $95479ec86af7adab$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
    return $95479ec86af7adab$var$pad(d.getFullYear() % 10000, p, 4);
}
function $95479ec86af7adab$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $95479ec86af7adab$var$pad(z / 60 | 0, "0", 2) + $95479ec86af7adab$var$pad(z % 60, "0", 2);
}
function $95479ec86af7adab$var$formatUTCDayOfMonth(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCDate(), p, 2);
}
function $95479ec86af7adab$var$formatUTCHour24(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCHours(), p, 2);
}
function $95479ec86af7adab$var$formatUTCHour12(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $95479ec86af7adab$var$formatUTCDayOfYear(d, p) {
    return $95479ec86af7adab$var$pad(1 + (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $95479ec86af7adab$var$formatUTCMilliseconds(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $95479ec86af7adab$var$formatUTCMicroseconds(d, p) {
    return $95479ec86af7adab$var$formatUTCMilliseconds(d, p) + "000";
}
function $95479ec86af7adab$var$formatUTCMonthNumber(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $95479ec86af7adab$var$formatUTCMinutes(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCMinutes(), p, 2);
}
function $95479ec86af7adab$var$formatUTCSeconds(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCSeconds(), p, 2);
}
function $95479ec86af7adab$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $95479ec86af7adab$var$formatUTCWeekNumberSunday(d, p) {
    return $95479ec86af7adab$var$pad((0, $24ffb3b67dc2c085$export$4898b06303a92011).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $95479ec86af7adab$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
}
function $95479ec86af7adab$var$formatUTCWeekNumberISO(d, p) {
    d = $95479ec86af7adab$var$UTCdISO(d);
    return $95479ec86af7adab$var$pad((0, $24ffb3b67dc2c085$export$1db08111baec2f53).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d) + ((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $95479ec86af7adab$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $95479ec86af7adab$var$formatUTCWeekNumberMonday(d, p) {
    return $95479ec86af7adab$var$pad((0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $95479ec86af7adab$var$formatUTCYear(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $95479ec86af7adab$var$formatUTCYearISO(d, p) {
    d = $95479ec86af7adab$var$UTCdISO(d);
    return $95479ec86af7adab$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $95479ec86af7adab$var$formatUTCFullYear(d, p) {
    return $95479ec86af7adab$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $95479ec86af7adab$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
    return $95479ec86af7adab$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $95479ec86af7adab$var$formatUTCZone() {
    return "+0000";
}
function $95479ec86af7adab$var$formatLiteralPercent() {
    return "%";
}
function $95479ec86af7adab$var$formatUnixTimestamp(d) {
    return +d;
}
function $95479ec86af7adab$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $8b6f069f85db80e1$var$locale;
var $8b6f069f85db80e1$export$94f4d87fad5dcf9a;
var $8b6f069f85db80e1$export$32b9cd16e1b8c8d2;
var $8b6f069f85db80e1$export$1a08fe38f63ebbbb;
var $8b6f069f85db80e1$export$3edae9cf8e233729;
$8b6f069f85db80e1$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $8b6f069f85db80e1$export$2e2bcd8739ae039(definition) {
    $8b6f069f85db80e1$var$locale = (0, $95479ec86af7adab$export$2e2bcd8739ae039)(definition);
    $8b6f069f85db80e1$export$94f4d87fad5dcf9a = $8b6f069f85db80e1$var$locale.format;
    $8b6f069f85db80e1$export$32b9cd16e1b8c8d2 = $8b6f069f85db80e1$var$locale.parse;
    $8b6f069f85db80e1$export$1a08fe38f63ebbbb = $8b6f069f85db80e1$var$locale.utcFormat;
    $8b6f069f85db80e1$export$3edae9cf8e233729 = $8b6f069f85db80e1$var$locale.utcParse;
    return $8b6f069f85db80e1$var$locale;
}





var $ceac9f6897e0c09e$export$164de7ab8df77ef0 = {
    background: "transparent",
    text: {
        fontFamily: "sans-serif",
        fontSize: 11,
        fill: "#333333",
        outlineWidth: 0,
        outlineColor: "transparent",
        outlineOpacity: 1
    },
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        hidden: {
            symbol: {
                fill: "#333333",
                opacity: .6
            },
            text: {
                fill: "#333333",
                opacity: .6
            }
        },
        text: {},
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {
                fontSize: 10
            }
        },
        title: {
            text: {}
        }
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        },
        tableCellValue: {
            fontWeight: "bold"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: .75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        }
    }
};
function $ceac9f6897e0c09e$var$jr() {
    return $ceac9f6897e0c09e$var$jr = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }, $ceac9f6897e0c09e$var$jr.apply(this, arguments);
}
function $ceac9f6897e0c09e$var$Sr(e, r) {
    return $ceac9f6897e0c09e$var$Sr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, $ceac9f6897e0c09e$var$Sr(e, r);
}
function $ceac9f6897e0c09e$var$Br(e, r) {
    if (null == e) return {};
    var t, n, i = {}, o = Object.keys(e);
    for(n = 0; n < o.length; n++)t = o[n], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
var $ceac9f6897e0c09e$var$Gr = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.title.text",
    "legends.text",
    "legends.ticks.text",
    "legends.title.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
], $ceac9f6897e0c09e$export$3c296778d829b724 = function(e, r) {
    return $ceac9f6897e0c09e$var$jr({}, r, e);
}, $ceac9f6897e0c09e$export$582fa4e2a9b13dde = function(e, r) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($357f6a405ce5423a$exports)))({}, e, r);
    return $ceac9f6897e0c09e$var$Gr.forEach(function(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(t, e, $ceac9f6897e0c09e$export$3c296778d829b724((0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(t, e), t.text));
    }), t;
}, $ceac9f6897e0c09e$export$1855e60b4fae8997 = (0, $7fPBF.createContext)(), $ceac9f6897e0c09e$export$465303079ec41f9d = {
    animate: !0,
    config: "default"
}, $ceac9f6897e0c09e$export$e9d875263f86dcb4 = function(e) {
    var t = e.children, n = e.animate, i = void 0 === n || n, o = e.config, l = void 0 === o ? "default" : o, a = (0, $7fPBF.useMemo)(function() {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(l) ? (0, $27d73b36303119b6$export$e506a1d27d1eaa20)[l] : l;
        return {
            animate: i,
            config: e
        };
    }, [
        i,
        l
    ]);
    return (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$1855e60b4fae8997.Provider, {
        value: a,
        children: t
    });
}, $ceac9f6897e0c09e$export$99a092eaa44be1c8 = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf(Object.keys((0, $27d73b36303119b6$export$e506a1d27d1eaa20))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            mass: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            tension: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            friction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            clamp: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
            precision: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            velocity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            duration: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            easing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
        })
    ])
};
$ceac9f6897e0c09e$export$e9d875263f86dcb4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    animate: $ceac9f6897e0c09e$export$99a092eaa44be1c8.animate,
    config: $ceac9f6897e0c09e$export$99a092eaa44be1c8.motionConfig
};
var $ceac9f6897e0c09e$export$72acc3dc9629d75d = function() {
    return (0, $7fPBF.useContext)($ceac9f6897e0c09e$export$1855e60b4fae8997);
}, $ceac9f6897e0c09e$export$6b8391a1442f2172 = function(e) {
    var t = $ceac9f6897e0c09e$export$72acc3dc9629d75d(), o = t.animate, l = t.config, a = function(e) {
        var r = (0, $7fPBF.useRef)();
        return (0, $7fPBF.useEffect)(function() {
            r.current = e;
        }, [
            e
        ]), r.current;
    }(e), d = (0, $7fPBF.useMemo)(function() {
        return (0, $48b4bf19d8759a09$export$2e2bcd8739ae039)(a, e);
    }, [
        a,
        e
    ]), s = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: !0,
        config: l,
        immediate: !o
    }).value;
    return (0, $27d73b36303119b6$export$2c618a4308a30424)(s, d);
}, $ceac9f6897e0c09e$export$77ddf829b5125d20 = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $4ca4fb75e5a423d5$export$3005042704f95a69)),
    PRGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $690b3d0fd5c4fa3e$export$3005042704f95a69)),
    PiYG: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $916ef83d77ec7e5c$export$3005042704f95a69)),
    PuOr: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $c76084b8a3907b15$export$3005042704f95a69)),
    RdBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $9bc47d279cd4b969$export$3005042704f95a69)),
    RdGy: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $2d70e60074d77a9b$export$3005042704f95a69)),
    RdYlBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $cc0d3e6a75793f0c$export$3005042704f95a69)),
    RdYlGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $fb00ca5476c43131$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $7f958806be18ac58$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $f7446b8c7cd79059$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3a66f9057929a79b$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $f64ce98f053d3c1f$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $b1f714e4e4b5adf6$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $885c97e4dd2e4422$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $cbf39e6a8bf8c1a3$export$3005042704f95a69)),
    BuGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $a2c8e9b842322913$export$3005042704f95a69)),
    BuPu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $d79efb228ae4624f$export$3005042704f95a69)),
    GnBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $40927aa6b8f77f0f$export$3005042704f95a69)),
    OrRd: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $03b2383dd0bc50f4$export$3005042704f95a69)),
    PuBuGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3888a5c20c404764$export$3005042704f95a69)),
    PuBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3949a449725c7bcf$export$3005042704f95a69)),
    PuRd: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $7bd35661446703e9$export$3005042704f95a69)),
    RdPu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $cfe4c086b06bdbca$export$3005042704f95a69)),
    YlGnBu: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $bfa6a20338713c31$export$3005042704f95a69)),
    YlGn: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $07bef80147eac796$export$3005042704f95a69)),
    YlOrBr: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $5c0c674af7fafdec$export$3005042704f95a69)),
    YlOrRd: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $de24445d9010aa31$export$3005042704f95a69))
}, $ceac9f6897e0c09e$export$6dc823b35197e3c3 = Object.keys($ceac9f6897e0c09e$export$77ddf829b5125d20), $ceac9f6897e0c09e$export$8d3d36a98ebb26b6 = function(e) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return e;
    }
    if ($ceac9f6897e0c09e$export$77ddf829b5125d20[e]) return (0, $701754d8f18cf864$export$2e2bcd8739ae039)().range($ceac9f6897e0c09e$export$77ddf829b5125d20[e]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($579b9ba2588bb9de$exports)))(e)) return (0, $701754d8f18cf864$export$2e2bcd8739ae039)().range(e);
    throw new Error("Unable to guess quantize color scale from '" + e + "',\nmust be a function or one of:\n'" + $ceac9f6897e0c09e$export$6dc823b35197e3c3.join("', '") + "'");
}, $ceac9f6897e0c09e$var$Nr = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $9ea3dd4fdadefd0a$export$2e2bcd8739ae039),
    accent: (0, $19d018fb519d54fd$export$2e2bcd8739ae039),
    dark2: (0, $7779d20e0fc477c0$export$2e2bcd8739ae039),
    paired: (0, $34fed29c954f6730$export$2e2bcd8739ae039),
    pastel1: (0, $ef3181ffb4185d42$export$2e2bcd8739ae039),
    pastel2: (0, $786f1d0067ffea6a$export$2e2bcd8739ae039),
    set1: (0, $2f85dc235274390a$export$2e2bcd8739ae039),
    set2: (0, $80f74c9d958fa597$export$2e2bcd8739ae039),
    set3: (0, $7958a448ec490cf3$export$2e2bcd8739ae039),
    brown_blueGreen: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $4ca4fb75e5a423d5$export$3005042704f95a69)),
    purpleRed_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $690b3d0fd5c4fa3e$export$3005042704f95a69)),
    pink_yellowGreen: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $916ef83d77ec7e5c$export$3005042704f95a69)),
    purple_orange: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $c76084b8a3907b15$export$3005042704f95a69)),
    red_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $9bc47d279cd4b969$export$3005042704f95a69)),
    red_grey: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $2d70e60074d77a9b$export$3005042704f95a69)),
    red_yellow_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $cc0d3e6a75793f0c$export$3005042704f95a69)),
    red_yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $fb00ca5476c43131$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $7f958806be18ac58$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $f7446b8c7cd79059$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3a66f9057929a79b$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $f64ce98f053d3c1f$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $b1f714e4e4b5adf6$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $885c97e4dd2e4422$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $cbf39e6a8bf8c1a3$export$3005042704f95a69)),
    blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $a2c8e9b842322913$export$3005042704f95a69)),
    blue_purple: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $d79efb228ae4624f$export$3005042704f95a69)),
    green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $40927aa6b8f77f0f$export$3005042704f95a69)),
    orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $03b2383dd0bc50f4$export$3005042704f95a69)),
    purple_blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3888a5c20c404764$export$3005042704f95a69)),
    purple_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $3949a449725c7bcf$export$3005042704f95a69)),
    purple_red: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $7bd35661446703e9$export$3005042704f95a69)),
    red_purple: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $cfe4c086b06bdbca$export$3005042704f95a69)),
    yellow_green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $bfa6a20338713c31$export$3005042704f95a69)),
    yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $07bef80147eac796$export$3005042704f95a69)),
    yellow_orange_brown: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $5c0c674af7fafdec$export$3005042704f95a69)),
    yellow_orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))((0, $de24445d9010aa31$export$3005042704f95a69))
}, $ceac9f6897e0c09e$export$b48661626a811234 = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
], $ceac9f6897e0c09e$export$6638ab0298ebe095 = {
    brown_blueGreen: (0, $4ca4fb75e5a423d5$export$2e2bcd8739ae039),
    purpleRed_green: (0, $690b3d0fd5c4fa3e$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $916ef83d77ec7e5c$export$2e2bcd8739ae039),
    purple_orange: (0, $c76084b8a3907b15$export$2e2bcd8739ae039),
    red_blue: (0, $9bc47d279cd4b969$export$2e2bcd8739ae039),
    red_grey: (0, $2d70e60074d77a9b$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $cc0d3e6a75793f0c$export$2e2bcd8739ae039),
    red_yellow_green: (0, $fb00ca5476c43131$export$2e2bcd8739ae039),
    spectral: (0, $7f958806be18ac58$export$2e2bcd8739ae039),
    blues: (0, $f7446b8c7cd79059$export$2e2bcd8739ae039),
    greens: (0, $3a66f9057929a79b$export$2e2bcd8739ae039),
    greys: (0, $f64ce98f053d3c1f$export$2e2bcd8739ae039),
    oranges: (0, $b1f714e4e4b5adf6$export$2e2bcd8739ae039),
    purples: (0, $885c97e4dd2e4422$export$2e2bcd8739ae039),
    reds: (0, $cbf39e6a8bf8c1a3$export$2e2bcd8739ae039),
    viridis: (0, $1cfa41501e7d069c$export$2e2bcd8739ae039),
    inferno: (0, $1cfa41501e7d069c$export$ad0c8285c8ea6dbd),
    magma: (0, $1cfa41501e7d069c$export$c41e69203f572e8d),
    plasma: (0, $1cfa41501e7d069c$export$6664860a633d9daf),
    warm: (0, $aa1dc4855b4fb73a$export$fc70efcec537be98),
    cool: (0, $aa1dc4855b4fb73a$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $b98f19dff4332012$export$2e2bcd8739ae039),
    blue_green: (0, $a2c8e9b842322913$export$2e2bcd8739ae039),
    blue_purple: (0, $d79efb228ae4624f$export$2e2bcd8739ae039),
    green_blue: (0, $40927aa6b8f77f0f$export$2e2bcd8739ae039),
    orange_red: (0, $03b2383dd0bc50f4$export$2e2bcd8739ae039),
    purple_blue_green: (0, $3888a5c20c404764$export$2e2bcd8739ae039),
    purple_blue: (0, $3949a449725c7bcf$export$2e2bcd8739ae039),
    purple_red: (0, $7bd35661446703e9$export$2e2bcd8739ae039),
    red_purple: (0, $cfe4c086b06bdbca$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $bfa6a20338713c31$export$2e2bcd8739ae039),
    yellow_green: (0, $07bef80147eac796$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $5c0c674af7fafdec$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $de24445d9010aa31$export$2e2bcd8739ae039),
    rainbow: (0, $aa1dc4855b4fb73a$export$2e2bcd8739ae039),
    sinebow: (0, $45301daac27a7a0d$export$2e2bcd8739ae039)
}, $ceac9f6897e0c09e$export$277274330ffd2780 = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
], $ceac9f6897e0c09e$export$cec134b1a1fa53dd = function() {
    return (0, $0ae5395125647844$export$2e2bcd8739ae039)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
}, $ceac9f6897e0c09e$export$75f9af112506f7de = function(e, r) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3424b9151e51ad58$exports)))(e)) {
        var t = $ceac9f6897e0c09e$var$Nr[e];
        if (void 0 !== t) {
            var n = (0, $0ae5395125647844$export$2e2bcd8739ae039)(t);
            return n.type = "ordinal", n;
        }
        if (void 0 !== r && 0 === e.indexOf("seq:")) {
            var i = $ceac9f6897e0c09e$export$6638ab0298ebe095[e.slice(4)];
            if (void 0 !== i) {
                var o = (0, $1e2488e4583916b4$export$2e2bcd8739ae039)(i).domain(r.domain());
                return o.type = "sequential", o;
            }
        }
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($579b9ba2588bb9de$exports)))(e)) {
        var l = (0, $0ae5395125647844$export$2e2bcd8739ae039)(e);
        return l.type = "ordinal", l;
    }
    return function() {
        return e;
    };
}, $ceac9f6897e0c09e$export$51f2761e5fe5ca10 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($ceac9f6897e0c09e$export$6dc823b35197e3c3),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)
]), $ceac9f6897e0c09e$export$3794d272a0540747 = {
    basis: (0, $6faea3746a35a674$export$2e2bcd8739ae039),
    basisClosed: (0, $1138e00666d598a4$export$2e2bcd8739ae039),
    basisOpen: (0, $12cd6759e665391e$export$2e2bcd8739ae039),
    bundle: (0, $332dc67fa055f029$export$2e2bcd8739ae039),
    cardinal: (0, $cKhdt.default),
    cardinalClosed: (0, $c9866b5bab8eb0c7$export$2e2bcd8739ae039),
    cardinalOpen: (0, $45e6d0dcc1b9e7f0$export$2e2bcd8739ae039),
    catmullRom: (0, $6G7B4.default),
    catmullRomClosed: (0, $218f7bda61b1d403$export$2e2bcd8739ae039),
    catmullRomOpen: (0, $2dcafd9dedc42e9e$export$2e2bcd8739ae039),
    linear: (0, $ddb89b6f130198b9$export$2e2bcd8739ae039),
    linearClosed: (0, $5baadbab21e74cd5$export$2e2bcd8739ae039),
    monotoneX: (0, $83e1e52e12ebf7b6$export$99563b5420dbdc55),
    monotoneY: (0, $83e1e52e12ebf7b6$export$8b5360456d6bdb88),
    natural: (0, $160cb7d7a7ffcd09$export$2e2bcd8739ae039),
    step: (0, $1f5b97e3d1f7329f$export$2e2bcd8739ae039),
    stepAfter: (0, $1f5b97e3d1f7329f$export$793b3db073781cbb),
    stepBefore: (0, $1f5b97e3d1f7329f$export$10eafa5b7478b343)
}, $ceac9f6897e0c09e$export$a2965cde22c100c0 = Object.keys($ceac9f6897e0c09e$export$3794d272a0540747), $ceac9f6897e0c09e$export$2a904d581bf09f5e = $ceac9f6897e0c09e$export$a2965cde22c100c0.filter(function(e) {
    return e.endsWith("Closed");
}), $ceac9f6897e0c09e$export$66e85fc6ea12b97e = (0, (/*@__PURE__*/$parcel$interopDefault($81ee6696873b1a9a$exports)))($ceac9f6897e0c09e$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $ceac9f6897e0c09e$export$6d32fc0bcd3f8555 = (0, (/*@__PURE__*/$parcel$interopDefault($81ee6696873b1a9a$exports)))($ceac9f6897e0c09e$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $ceac9f6897e0c09e$export$99f526a753d63ebe = function(e) {
    if (!$ceac9f6897e0c09e$export$3794d272a0540747[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return $ceac9f6897e0c09e$export$3794d272a0540747[e];
}, $ceac9f6897e0c09e$export$9c0ef4eef492d11d = {
    ascending: (0, $3a02ce64ce502abc$export$2e2bcd8739ae039),
    descending: (0, $e09590ce84b12c2b$export$2e2bcd8739ae039),
    insideOut: (0, $59e2caf3828cc255$export$2e2bcd8739ae039),
    none: (0, $fcb8b9669a144823$export$2e2bcd8739ae039),
    reverse: (0, $07fc755dc0f0a225$export$2e2bcd8739ae039)
}, $ceac9f6897e0c09e$export$a8ec30103cd71280 = Object.keys($ceac9f6897e0c09e$export$9c0ef4eef492d11d), $ceac9f6897e0c09e$export$1d5443ca84f6d0f0 = function(e) {
    return $ceac9f6897e0c09e$export$9c0ef4eef492d11d[e];
}, $ceac9f6897e0c09e$export$ab3c04d5a3b28998 = {
    expand: (0, $20a285b4d9174da7$export$2e2bcd8739ae039),
    diverging: (0, $15ee0fa0ceb6123a$export$2e2bcd8739ae039),
    none: (0, $5e9c35a540f1fc5a$export$2e2bcd8739ae039),
    silhouette: (0, $065abbd70dde12e9$export$2e2bcd8739ae039),
    wiggle: (0, $13f3984b534593cf$export$2e2bcd8739ae039)
}, $ceac9f6897e0c09e$export$31340e546ce1c184 = Object.keys($ceac9f6897e0c09e$export$ab3c04d5a3b28998), $ceac9f6897e0c09e$export$5c9f4d1b003c0909 = function(e) {
    return $ceac9f6897e0c09e$export$ab3c04d5a3b28998[e];
}, $ceac9f6897e0c09e$export$5d66dd569e74301b = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
    top: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
}).isRequired, $ceac9f6897e0c09e$export$34f44898ffea24c3 = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
], $ceac9f6897e0c09e$export$6da2372f044c5e36 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf($ceac9f6897e0c09e$export$34f44898ffea24c3), $ceac9f6897e0c09e$export$1db72d8ab19b94d9 = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $ceac9f6897e0c09e$export$99f526a753d63ebe(e);
    }, [
        e
    ]);
}, $ceac9f6897e0c09e$export$2785d5ef2943fe58 = !0, $ceac9f6897e0c09e$export$a4dcb37d1b87cf96 = $ceac9f6897e0c09e$export$cec134b1a1fa53dd, $ceac9f6897e0c09e$export$1570875fb8f3b023 = (0, $0ae5395125647844$export$2e2bcd8739ae039)((0, $7958a448ec490cf3$export$2e2bcd8739ae039)), $ceac9f6897e0c09e$export$6728fea658cfb92e = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $ceac9f6897e0c09e$export$d04af0e501fb729f = function(e, t, n) {
    return void 0 === n && (n = {}), (0, $7fPBF.useMemo)(function() {
        var r = $ceac9f6897e0c09e$var$jr({}, $ceac9f6897e0c09e$export$6728fea658cfb92e, n);
        return {
            margin: r,
            innerWidth: e - r.left - r.right,
            innerHeight: t - r.top - r.bottom,
            outerWidth: e,
            outerHeight: t
        };
    }, [
        e,
        t,
        n.top,
        n.right,
        n.bottom,
        n.left
    ]);
}, $ceac9f6897e0c09e$export$e295b0c537d32d7d = function() {
    var e = (0, $7fPBF.useRef)(null), r = (0, $7fPBF.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }), t = r[0], l = r[1], a = (0, $7fPBF.useState)(function() {
        return "undefined" == typeof ResizeObserver ? null : new ResizeObserver(function(e) {
            var r = e[0];
            return l(r.contentRect);
        });
    })[0];
    return (0, $7fPBF.useEffect)(function() {
        return e.current && null !== a && a.observe(e.current), function() {
            null !== a && a.disconnect();
        };
    }, []), [
        e,
        t
    ];
}, $ceac9f6897e0c09e$export$7394831711fe34f = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $ceac9f6897e0c09e$export$582fa4e2a9b13dde($ceac9f6897e0c09e$export$164de7ab8df77ef0, e);
    }, [
        e
    ]);
}, $ceac9f6897e0c09e$export$f037bf6aad5a4e75 = function(e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? (0, $8b6f069f85db80e1$export$94f4d87fad5dcf9a)(e.slice("5")) : (0, $f979cbd3e1200bf1$export$d9468344d3651243)(e) : function(e) {
        return "" + e;
    };
}, $ceac9f6897e0c09e$export$422f9765e6971fdf = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $ceac9f6897e0c09e$export$f037bf6aad5a4e75(e);
    }, [
        e
    ]);
}, $ceac9f6897e0c09e$export$84c6f02482759c25 = (0, $7fPBF.createContext)(), $ceac9f6897e0c09e$var$Ct = {}, $ceac9f6897e0c09e$export$d8964aec282183a3 = function(e) {
    var r = e.theme, t = void 0 === r ? $ceac9f6897e0c09e$var$Ct : r, n = e.children, i = $ceac9f6897e0c09e$export$7394831711fe34f(t);
    return (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$84c6f02482759c25.Provider, {
        value: i,
        children: n
    });
};
$ceac9f6897e0c09e$export$d8964aec282183a3.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
};
var $ceac9f6897e0c09e$export$93d4e7f90805808f = function() {
    return (0, $7fPBF.useContext)($ceac9f6897e0c09e$export$84c6f02482759c25);
}, $ceac9f6897e0c09e$var$Tt = [
    "outlineWidth",
    "outlineColor",
    "outlineOpacity"
], $ceac9f6897e0c09e$export$c30625df7c8afdb5 = function(e) {
    return e.outlineWidth, e.outlineColor, e.outlineOpacity, $ceac9f6897e0c09e$var$Br(e, $ceac9f6897e0c09e$var$Tt);
}, $ceac9f6897e0c09e$var$Pt = function(e) {
    var r = e.children, t = e.condition, n = e.wrapper;
    return t ? (0, $7fPBF.cloneElement)(n, {}, r) : r;
};
$ceac9f6897e0c09e$var$Pt.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    condition: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).element.isRequired
};
var $ceac9f6897e0c09e$var$jt = {
    position: "relative"
}, $ceac9f6897e0c09e$export$42a852a2b6b56249 = function(e) {
    var r = e.children, t = e.theme, i = e.renderWrapper, o = void 0 === i || i, l = e.isInteractive, a = void 0 === l || l, d = e.animate, s = e.motionConfig, u = (0, $7fPBF.useRef)(null);
    return (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$d8964aec282183a3, {
        theme: t,
        children: (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$e9d875263f86dcb4, {
            animate: d,
            config: s,
            children: (0, $824c049f32d4395d$exports.jsx)((0, $ad81ce180dd1d3ec$export$f78649fb9ca566b8), {
                container: u,
                children: (0, $824c049f32d4395d$exports.jsxs)($ceac9f6897e0c09e$var$Pt, {
                    condition: o,
                    wrapper: (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: $ceac9f6897e0c09e$var$jt,
                        ref: u
                    }),
                    children: [
                        r,
                        a && (0, $824c049f32d4395d$exports.jsx)((0, $ad81ce180dd1d3ec$export$28c660c63b792dea), {})
                    ]
                })
            })
        })
    });
};
$ceac9f6897e0c09e$export$42a852a2b6b56249.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).element.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $ceac9f6897e0c09e$export$8793edee2d425525 = function() {}, $ceac9f6897e0c09e$var$Gt = {
    position: "relative"
}, $ceac9f6897e0c09e$export$c2b4ab1564fcaab4 = function(e) {
    var t = e.children, i = e.theme, o = e.isInteractive, l = void 0 === o || o, d = e.renderWrapper, s = void 0 === d || d, u = e.animate, c = e.motionConfig, f = (0, $7fPBF.useRef)(null), m = (0, $ad81ce180dd1d3ec$export$85cc26a2c4544aaa)(f), y = m.actions, v = m.state, _ = (0, $7fPBF.useCallback)(function(e, r) {
        return y.showTooltipFromEvent(e, r);
    }, [
        y.showTooltipFromEvent
    ]), w = (0, $7fPBF.useMemo)(function() {
        return {
            showTooltip: l ? _ : $ceac9f6897e0c09e$export$8793edee2d425525,
            hideTooltip: l ? y.hideTooltip : $ceac9f6897e0c09e$export$8793edee2d425525
        };
    }, [
        y.hideTooltip,
        l,
        _
    ]);
    return (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$d8964aec282183a3, {
        theme: i,
        children: (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$e9d875263f86dcb4, {
            animate: u,
            config: c,
            children: (0, $824c049f32d4395d$exports.jsx)((0, $ad81ce180dd1d3ec$export$d344f0e974db1e2e).Provider, {
                value: y,
                children: (0, $824c049f32d4395d$exports.jsx)((0, $ad81ce180dd1d3ec$export$c7027a64d546bf1d).Provider, {
                    value: v,
                    children: (0, $824c049f32d4395d$exports.jsxs)($ceac9f6897e0c09e$var$Pt, {
                        condition: s,
                        wrapper: (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: $ceac9f6897e0c09e$var$Gt,
                            ref: f
                        }),
                        children: [
                            t(w),
                            l && (0, $824c049f32d4395d$exports.jsx)((0, $ad81ce180dd1d3ec$export$28c660c63b792dea), {})
                        ]
                    })
                })
            })
        })
    });
};
$ceac9f6897e0c09e$export$c2b4ab1564fcaab4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $ceac9f6897e0c09e$export$fa6e408d6a7d6214 = function(e) {
    var r = e.children, t = $ceac9f6897e0c09e$export$e295b0c537d32d7d(), n = t[0], i = t[1], o = i.width > 0 && i.height > 0;
    return (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: n,
        style: {
            width: "100%",
            height: "100%"
        },
        children: o && r({
            width: i.width,
            height: i.height
        })
    });
};
$ceac9f6897e0c09e$export$fa6e408d6a7d6214.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
var $ceac9f6897e0c09e$var$Yt = [
    "id",
    "colors"
], $ceac9f6897e0c09e$export$39a41c7169757633 = function(e) {
    var r = e.id, t = e.colors, n = $ceac9f6897e0c09e$var$Br(e, $ceac9f6897e0c09e$var$Yt);
    return (0, $824c049f32d4395d$exports.jsx)("linearGradient", $ceac9f6897e0c09e$var$jr({
        id: r,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, n, {
        children: t.map(function(e) {
            var r = e.offset, t = e.color, n = e.opacity;
            return (0, $824c049f32d4395d$exports.jsx)("stop", {
                offset: r + "%",
                stopColor: t,
                stopOpacity: void 0 !== n ? n : 1
            }, r);
        })
    }));
};
$ceac9f6897e0c09e$export$39a41c7169757633.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        offset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        opacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    })).isRequired,
    gradientTransform: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $ceac9f6897e0c09e$export$78f14b2164360f92 = function(e, r, t) {
    return void 0 === t && (t = {}), $ceac9f6897e0c09e$var$jr({
        id: e,
        type: "linearGradient",
        colors: r
    }, t);
}, $ceac9f6897e0c09e$export$a3bca081a57901da = {
    linearGradient: $ceac9f6897e0c09e$export$39a41c7169757633
}, $ceac9f6897e0c09e$export$10b6027261f7f537 = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, $ceac9f6897e0c09e$export$5e799d98c1ab7521 = (0, $7fPBF.memo)(function(e) {
    var r = e.id, t = e.background, n = void 0 === t ? $ceac9f6897e0c09e$export$10b6027261f7f537.background : t, i = e.color, o = void 0 === i ? $ceac9f6897e0c09e$export$10b6027261f7f537.color : i, l = e.size, a = void 0 === l ? $ceac9f6897e0c09e$export$10b6027261f7f537.size : l, d = e.padding, s = void 0 === d ? $ceac9f6897e0c09e$export$10b6027261f7f537.padding : d, u = e.stagger, c = void 0 === u ? $ceac9f6897e0c09e$export$10b6027261f7f537.stagger : u, f = a + s, p = a / 2, h = s / 2;
    return !0 === c && (f = 2 * a + 2 * s), (0, $824c049f32d4395d$exports.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: f,
                height: f,
                fill: n
            }),
            (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: h + p,
                cy: h + p,
                r: p,
                fill: o
            }),
            c && (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: 1.5 * s + a + p,
                cy: 1.5 * s + a + p,
                r: p,
                fill: o
            })
        ]
    });
});
$ceac9f6897e0c09e$export$5e799d98c1ab7521.displayName = "PatternDots", $ceac9f6897e0c09e$export$5e799d98c1ab7521.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};
var $ceac9f6897e0c09e$export$27feaeda534cb3 = function(e, r) {
    return void 0 === r && (r = {}), $ceac9f6897e0c09e$var$jr({
        id: e,
        type: "patternDots"
    }, r);
}, $ceac9f6897e0c09e$export$6eec49b1a6289c4e = 2 * Math.PI, $ceac9f6897e0c09e$export$c9fcf1a7df975d78 = function(e) {
    return e * Math.PI / 180;
}, $ceac9f6897e0c09e$export$c41dd2a8460d3196 = function(e) {
    return 180 * e / Math.PI;
}, $ceac9f6897e0c09e$export$61f3799bad189d2e = function(e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
}, $ceac9f6897e0c09e$export$2e16b01652730550 = function(e, r) {
    return {
        x: Math.cos(e) * r,
        y: Math.sin(e) * r
    };
}, $ceac9f6897e0c09e$export$c2f0a4925e526958 = function(e) {
    var r = e % 360;
    return r < 0 && (r += 360), r;
}, $ceac9f6897e0c09e$export$c2bacc09869b390f = function(e) {
    return e - $ceac9f6897e0c09e$export$6eec49b1a6289c4e * Math.floor((e + Math.PI) / $ceac9f6897e0c09e$export$6eec49b1a6289c4e);
}, $ceac9f6897e0c09e$export$e3df76cf4464bc81 = function(e) {
    return e < 0 ? 360 - -e % 360 : e % 360;
}, $ceac9f6897e0c09e$export$a9f93668da7e35c9 = function(e, r, t) {
    void 0 === t && (t = 360);
    var n = r;
    return Math.abs(r - e) > t && (n = e + (r > e ? t : -t)), [
        e,
        n
    ];
}, $ceac9f6897e0c09e$export$1abb91cfca1e2069 = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end",
            start: "start",
            middle: "middle",
            end: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right",
            start: "left",
            middle: "center",
            end: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
}, $ceac9f6897e0c09e$export$60f5dce4201c524 = function(e, r, t, n) {
    void 0 === n && (n = "svg");
    var i = $ceac9f6897e0c09e$export$1abb91cfca1e2069[n], o = $ceac9f6897e0c09e$export$2e16b01652730550(r - Math.PI / 2, e), l = o.x, a = o.y, d = $ceac9f6897e0c09e$export$c41dd2a8460d3196(r), s = i.align.center, u = i.baseline.bottom;
    return t > 0 ? (s = i.align.right, u = i.baseline.center) : t < 0 && (s = i.align.left, u = i.baseline.center), 0 !== t && d > 180 && (d -= 180, s = s === i.align.right ? i.align.left : i.align.right), {
        x: l,
        y: a,
        rotate: d += t,
        align: s,
        baseline: u
    };
}, $ceac9f6897e0c09e$export$ab8a77d3b63d684d = {
    spacing: 5,
    rotation: 0,
    background: "#000000",
    color: "#ffffff",
    lineWidth: 2
}, $ceac9f6897e0c09e$export$ace8c9d56fb83ed1 = (0, $7fPBF.memo)(function(e) {
    var r = e.id, t = e.spacing, n = void 0 === t ? $ceac9f6897e0c09e$export$ab8a77d3b63d684d.spacing : t, i = e.rotation, o = void 0 === i ? $ceac9f6897e0c09e$export$ab8a77d3b63d684d.rotation : i, l = e.background, a = void 0 === l ? $ceac9f6897e0c09e$export$ab8a77d3b63d684d.background : l, d = e.color, s = void 0 === d ? $ceac9f6897e0c09e$export$ab8a77d3b63d684d.color : d, u = e.lineWidth, c = void 0 === u ? $ceac9f6897e0c09e$export$ab8a77d3b63d684d.lineWidth : u, f = Math.round(o) % 360, p = Math.abs(n);
    f > 180 ? f -= 360 : f > 90 ? f -= 180 : f < -180 ? f += 360 : f < -90 && (f += 180);
    var h, g = p, b = p;
    return 0 === f ? h = "\n                M 0 0 L " + g + " 0\n                M 0 " + b + " L " + g + " " + b + "\n            " : 90 === f ? h = "\n                M 0 0 L 0 " + b + "\n                M " + g + " 0 L " + g + " " + b + "\n            " : (g = Math.abs(p / Math.sin($ceac9f6897e0c09e$export$c9fcf1a7df975d78(f))), b = p / Math.sin($ceac9f6897e0c09e$export$c9fcf1a7df975d78(90 - f)), h = f > 0 ? "\n                    M 0 " + -b + " L " + 2 * g + " " + b + "\n                    M " + -g + " " + -b + " L " + g + " " + b + "\n                    M " + -g + " 0 L " + g + " " + 2 * b + "\n                " : "\n                    M " + -g + " " + b + " L " + g + " " + -b + "\n                    M " + -g + " " + 2 * b + " L " + 2 * g + " " + -b + "\n                    M 0 " + 2 * b + " L " + 2 * g + " 0\n                "), (0, $824c049f32d4395d$exports.jsxs)("pattern", {
        id: r,
        width: g,
        height: b,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: g,
                height: b,
                fill: a,
                stroke: "rgba(255, 0, 0, 0.1)",
                strokeWidth: 0
            }),
            (0, $824c049f32d4395d$exports.jsx)("path", {
                d: h,
                strokeWidth: c,
                stroke: s,
                strokeLinecap: "square"
            })
        ]
    });
});
$ceac9f6897e0c09e$export$ace8c9d56fb83ed1.displayName = "PatternLines", $ceac9f6897e0c09e$export$ace8c9d56fb83ed1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    spacing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
};
var $ceac9f6897e0c09e$export$5487da9d0b1282d9 = function(e, r) {
    return void 0 === r && (r = {}), $ceac9f6897e0c09e$var$jr({
        id: e,
        type: "patternLines"
    }, r);
}, $ceac9f6897e0c09e$export$412f5384ba9b0c31 = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, $ceac9f6897e0c09e$export$e9fa09500a728054 = (0, $7fPBF.memo)(function(e) {
    var r = e.id, t = e.color, n = void 0 === t ? $ceac9f6897e0c09e$export$412f5384ba9b0c31.color : t, i = e.background, o = void 0 === i ? $ceac9f6897e0c09e$export$412f5384ba9b0c31.background : i, l = e.size, a = void 0 === l ? $ceac9f6897e0c09e$export$412f5384ba9b0c31.size : l, d = e.padding, s = void 0 === d ? $ceac9f6897e0c09e$export$412f5384ba9b0c31.padding : d, u = e.stagger, c = void 0 === u ? $ceac9f6897e0c09e$export$412f5384ba9b0c31.stagger : u, f = a + s, p = s / 2;
    return !0 === c && (f = 2 * a + 2 * s), (0, $824c049f32d4395d$exports.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: f,
                height: f,
                fill: o
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                x: p,
                y: p,
                width: a,
                height: a,
                fill: n
            }),
            c && (0, $824c049f32d4395d$exports.jsx)("rect", {
                x: 1.5 * s + a,
                y: 1.5 * s + a,
                width: a,
                height: a,
                fill: n
            })
        ]
    });
});
$ceac9f6897e0c09e$export$e9fa09500a728054.displayName = "PatternSquares", $ceac9f6897e0c09e$export$e9fa09500a728054.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};
var $ceac9f6897e0c09e$export$1b1d9cb2f82cf47f = function(e, r) {
    return void 0 === r && (r = {}), $ceac9f6897e0c09e$var$jr({
        id: e,
        type: "patternSquares"
    }, r);
}, $ceac9f6897e0c09e$export$691ec77bd278f3b0 = {
    patternDots: $ceac9f6897e0c09e$export$5e799d98c1ab7521,
    patternLines: $ceac9f6897e0c09e$export$ace8c9d56fb83ed1,
    patternSquares: $ceac9f6897e0c09e$export$e9fa09500a728054
}, $ceac9f6897e0c09e$var$cn = [
    "type"
], $ceac9f6897e0c09e$var$fn = $ceac9f6897e0c09e$var$jr({}, $ceac9f6897e0c09e$export$a3bca081a57901da, $ceac9f6897e0c09e$export$691ec77bd278f3b0), $ceac9f6897e0c09e$var$pn = function(e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : (0, $824c049f32d4395d$exports.jsx)("defs", {
        "aria-hidden": !0,
        children: r.map(function(e) {
            var r = e.type, t = $ceac9f6897e0c09e$var$Br(e, $ceac9f6897e0c09e$var$cn);
            return $ceac9f6897e0c09e$var$fn[r] ? (0, $7fPBF.createElement)($ceac9f6897e0c09e$var$fn[r], $ceac9f6897e0c09e$var$jr({
                key: t.id
            }, t)) : null;
        })
    });
};
$ceac9f6897e0c09e$var$pn.propTypes = {
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf(Object.keys($ceac9f6897e0c09e$var$fn)).isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }))
};
var $ceac9f6897e0c09e$export$b2bdceae9588b42d = (0, $7fPBF.memo)($ceac9f6897e0c09e$var$pn), $ceac9f6897e0c09e$export$21d9f1931ef75b56 = function(e) {
    var r = e.width, t = e.height, n = e.margin, i = e.defs, o = e.children, l = e.role, a = e.ariaLabel, d = e.ariaLabelledBy, s = e.ariaDescribedBy, u = e.isFocusable, c = $ceac9f6897e0c09e$export$93d4e7f90805808f();
    return (0, $824c049f32d4395d$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: r,
        height: t,
        role: l,
        "aria-label": a,
        "aria-labelledby": d,
        "aria-describedby": s,
        focusable: u,
        tabIndex: u ? 0 : void 0,
        children: [
            (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$b2bdceae9588b42d, {
                defs: i
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: r,
                height: t,
                fill: c.background
            }),
            (0, $824c049f32d4395d$exports.jsx)("g", {
                transform: "translate(" + n.left + "," + n.top + ")",
                children: o
            })
        ]
    });
};
$ceac9f6897e0c09e$export$21d9f1931ef75b56.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        left: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
    }).isRequired,
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node
    ]).isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    isFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    ariaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    ariaDescribedBy: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $ceac9f6897e0c09e$var$bn = function(e) {
    var r = e.size, t = e.color, n = e.borderWidth, i = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("circle", {
        r: r / 2,
        fill: t,
        stroke: i,
        strokeWidth: n,
        style: {
            pointerEvents: "none"
        }
    });
};
$ceac9f6897e0c09e$var$bn.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
var $ceac9f6897e0c09e$var$mn = (0, $7fPBF.memo)($ceac9f6897e0c09e$var$bn), $ceac9f6897e0c09e$var$yn = function(e) {
    var r = e.x, t = e.y, n = e.symbol, i = void 0 === n ? $ceac9f6897e0c09e$var$mn : n, o = e.size, l = e.datum, a = e.color, d = e.borderWidth, u = e.borderColor, c = e.label, f = e.labelTextAnchor, p = void 0 === f ? "middle" : f, h = e.labelYOffset, g = void 0 === h ? -12 : h, b = $ceac9f6897e0c09e$export$93d4e7f90805808f(), m = $ceac9f6897e0c09e$export$72acc3dc9629d75d(), y = m.animate, v = m.config, _ = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        transform: "translate(" + r + ", " + t + ")",
        config: v,
        immediate: !y
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        transform: _.transform,
        style: {
            pointerEvents: "none"
        },
        children: [
            (0, $7fPBF.createElement)(i, {
                size: o,
                color: a,
                datum: l,
                borderWidth: d,
                borderColor: u
            }),
            c && (0, $824c049f32d4395d$exports.jsx)("text", {
                textAnchor: p,
                y: g,
                style: $ceac9f6897e0c09e$export$c30625df7c8afdb5(b.dots.text),
                children: c
            })
        ]
    });
};
$ceac9f6897e0c09e$var$yn.propTypes = {
    x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    labelTextAnchor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    labelYOffset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
};
var $ceac9f6897e0c09e$export$ca30f0ad55489a87 = (0, $7fPBF.memo)($ceac9f6897e0c09e$var$yn), $ceac9f6897e0c09e$var$_n = function(e) {
    var r = e.width, t = e.height, n = e.axis, i = e.scale, o = e.value, l = e.lineStyle, a = e.textStyle, d = e.legend, s = e.legendPosition, u = void 0 === s ? "top-right" : s, c = e.legendOffsetX, f = void 0 === c ? 14 : c, p = e.legendOffsetY, h = void 0 === p ? 14 : p, g = e.legendOrientation, b = void 0 === g ? "horizontal" : g, m = $ceac9f6897e0c09e$export$93d4e7f90805808f(), y = 0, v = 0, _ = 0, w = 0;
    "y" === n ? (_ = i(o), v = r) : (y = i(o), w = t);
    var k = null;
    if (d) {
        var R = function(e) {
            var r = e.axis, t = e.width, n = e.height, i = e.position, o = e.offsetX, l = e.offsetY, a = e.orientation, d = 0, s = 0, u = "vertical" === a ? -90 : 0, c = "start";
            if ("x" === r) switch(i){
                case "top-left":
                    d = -o, s = l, c = "end";
                    break;
                case "top":
                    s = -l, c = "horizontal" === a ? "middle" : "start";
                    break;
                case "top-right":
                    d = o, s = l, c = "horizontal" === a ? "start" : "end";
                    break;
                case "right":
                    d = o, s = n / 2, c = "horizontal" === a ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = o, s = n - l, c = "start";
                    break;
                case "bottom":
                    s = n + l, c = "horizontal" === a ? "middle" : "end";
                    break;
                case "bottom-left":
                    s = n - l, d = -o, c = "horizontal" === a ? "end" : "start";
                    break;
                case "left":
                    d = -o, s = n / 2, c = "horizontal" === a ? "end" : "middle";
            }
            else switch(i){
                case "top-left":
                    d = o, s = -l, c = "start";
                    break;
                case "top":
                    d = t / 2, s = -l, c = "horizontal" === a ? "middle" : "start";
                    break;
                case "top-right":
                    d = t - o, s = -l, c = "horizontal" === a ? "end" : "start";
                    break;
                case "right":
                    d = t + o, c = "horizontal" === a ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = t - o, s = l, c = "end";
                    break;
                case "bottom":
                    d = t / 2, s = l, c = "horizontal" === a ? "middle" : "end";
                    break;
                case "bottom-left":
                    d = o, s = l, c = "horizontal" === a ? "start" : "end";
                    break;
                case "left":
                    d = -o, c = "horizontal" === a ? "end" : "middle";
            }
            return {
                x: d,
                y: s,
                rotation: u,
                textAnchor: c
            };
        }({
            axis: n,
            width: r,
            height: t,
            position: u,
            offsetX: f,
            offsetY: h,
            orientation: b
        });
        k = (0, $824c049f32d4395d$exports.jsx)("text", {
            transform: "translate(" + R.x + ", " + R.y + ") rotate(" + R.rotation + ")",
            textAnchor: R.textAnchor,
            dominantBaseline: "central",
            style: a,
            children: d
        });
    }
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        transform: "translate(" + y + ", " + _ + ")",
        children: [
            (0, $824c049f32d4395d$exports.jsx)("line", {
                x1: 0,
                x2: v,
                y1: 0,
                y2: w,
                stroke: m.markers.lineColor,
                strokeWidth: m.markers.lineStrokeWidth,
                style: l
            }),
            k
        ]
    });
};
$ceac9f6897e0c09e$var$_n.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "x",
        "y"
    ]).isRequired,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
    ]).isRequired,
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    legendPosition: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]),
    legendOffsetX: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    legendOffsetY: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    legendOrientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired
};
var $ceac9f6897e0c09e$export$2b29c35b9bad49e4 = (0, $7fPBF.memo)($ceac9f6897e0c09e$var$_n), $ceac9f6897e0c09e$var$kn = function(e) {
    var r = e.markers, t = e.width, n = e.height, i = e.xScale, o = e.yScale;
    return r && 0 !== r.length ? r.map(function(e, r) {
        return (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$2b29c35b9bad49e4, $ceac9f6897e0c09e$var$jr({}, e, {
            width: t,
            height: n,
            scale: "y" === e.axis ? o : i
        }), r);
    }) : null;
};
$ceac9f6897e0c09e$var$kn.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    xScale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    yScale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    markers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ]).isRequired,
        lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    }))
};
var $ceac9f6897e0c09e$export$81759e11f9e58ea4 = (0, $7fPBF.memo)($ceac9f6897e0c09e$var$kn), $ceac9f6897e0c09e$var$xn = [
    "theme",
    "renderWrapper",
    "animate",
    "motionConfig"
], $ceac9f6897e0c09e$export$4cbbe0314aa930ae = function(e) {
    return function(r) {
        var t, n;
        function i() {
            return r.apply(this, arguments) || this;
        }
        return n = r, (t = i).prototype = Object.create(n.prototype), t.prototype.constructor = t, $ceac9f6897e0c09e$var$Sr(t, n), i.prototype.render = function() {
            var r = this.props, t = r.theme, n = r.renderWrapper, i = r.animate, o = r.motionConfig, l = $ceac9f6897e0c09e$var$Br(r, $ceac9f6897e0c09e$var$xn);
            return (0, $824c049f32d4395d$exports.jsx)($ceac9f6897e0c09e$export$42a852a2b6b56249, {
                theme: t,
                renderWrapper: n,
                isInteractive: l.isInteractive,
                animate: i,
                motionConfig: o,
                children: (0, $824c049f32d4395d$exports.jsx)(e, $ceac9f6897e0c09e$var$jr({}, l))
            });
        }, i;
    }((0, $7fPBF.Component));
}, $ceac9f6897e0c09e$export$192dc59ac6f86c95 = function(e, r) {
    var t, n = (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e);
    };
    return r && (t = (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(r) ? r : (0, $f979cbd3e1200bf1$export$d9468344d3651243)(r)), t ? function(e) {
        return t(n(e));
    } : n;
}, $ceac9f6897e0c09e$export$3cc9373c3cf93eff = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e);
    };
}, $ceac9f6897e0c09e$export$2d590546cbb7e3ad = function(e) {
    return (0, $7fPBF.useMemo)(function() {
        return $ceac9f6897e0c09e$export$3cc9373c3cf93eff(e);
    }, [
        e
    ]);
}, $ceac9f6897e0c09e$export$605481d5cadc9728 = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
], $ceac9f6897e0c09e$export$d3a11e7b798643fd = function(e, r, t) {
    var n = r.width - e.width, i = r.height - e.height, o = 0, l = 0;
    return "center" === t && (o = n / 2, l = i / 2), "top" === t && (o = n / 2), "top-right" === t && (o = n), "right" === t && (o = n, l = i / 2), "bottom-right" === t && (o = n, l = i), "bottom" === t && (o = n / 2, l = i), "bottom-left" === t && (l = i), "left" === t && (l = i / 2), [
        o,
        l
    ];
}, $ceac9f6897e0c09e$export$79376507b09a66f = function(e, r, t, n) {
    var i = t - e, o = n - r;
    return i *= i, o *= o, Math.sqrt(i + o);
}, $ceac9f6897e0c09e$export$b363da9ded343252 = function(e, r, t, n) {
    var i = Math.atan2(n - r, t - e) - Math.PI / 2;
    return i > 0 ? i : 2 * Math.PI + i;
}, $ceac9f6897e0c09e$export$be302859f014f482 = function(e, r, t, n, i, o) {
    return e <= i && i <= e + t && r <= o && o <= r + n;
}, $ceac9f6897e0c09e$export$2396fb9a7906fd81 = function(e, r) {
    var t, n = "touches" in r ? r.touches[0] : r, i = n.clientX, o = n.clientY, l = e.getBoundingClientRect(), a = (t = void 0 !== e.getBBox ? e.getBBox() : {
        width: e.offsetWidth || 0,
        height: e.offsetHeight || 0
    }).width === l.width ? 1 : t.width / l.width;
    return [
        (i - l.left) * a,
        (o - l.top) * a
    ];
}, $ceac9f6897e0c09e$var$Bn = Object.keys($ceac9f6897e0c09e$export$a3bca081a57901da), $ceac9f6897e0c09e$var$Gn = Object.keys($ceac9f6897e0c09e$export$691ec77bd278f3b0), $ceac9f6897e0c09e$export$468af463e7cc9c6f = function(e, r, t) {
    if ("*" === e) return !0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($07bc7c115e963817$exports)))(e)) return e(r);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(e)) {
        var n = t ? (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, t) : r;
        return (0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($c4b8aa507fc568ca$exports)))(n, Object.keys(e)), e);
    }
    return !1;
}, $ceac9f6897e0c09e$export$dc35cf769e3afe34 = function(e, r, t, n) {
    var i = void 0 === n ? {} : n, o = i.dataKey, l = i.colorKey, a = void 0 === l ? "color" : l, d = i.targetKey, s = void 0 === d ? "fill" : d, u = [], c = {};
    return e.length && r.length && (u = [].concat(e), r.forEach(function(r) {
        for(var n = function() {
            var n = t[i], l = n.id, d = n.match;
            if ($ceac9f6897e0c09e$export$468af463e7cc9c6f(d, r, o)) {
                var f = e.find(function(e) {
                    return e.id === l;
                });
                if (f) {
                    if ($ceac9f6897e0c09e$var$Gn.includes(f.type)) {
                        if ("inherit" === f.background || "inherit" === f.color) {
                            var p = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, a), h = f.background, g = f.color, b = l;
                            "inherit" === f.background && (b = b + ".bg." + p, h = p), "inherit" === f.color && (b = b + ".fg." + p, g = p), (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, s, "url(#" + b + ")"), c[b] || (u.push($ceac9f6897e0c09e$var$jr({}, f, {
                                id: b,
                                background: h,
                                color: g
                            })), c[b] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, s, "url(#" + l + ")");
                    } else if ($ceac9f6897e0c09e$var$Bn.includes(f.type)) {
                        if (f.colors.map(function(e) {
                            return e.color;
                        }).includes("inherit")) {
                            var m = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, a), _ = l, w = $ceac9f6897e0c09e$var$jr({}, f, {
                                colors: f.colors.map(function(e, r) {
                                    return "inherit" !== e.color ? e : (_ = _ + "." + r + "." + m, $ceac9f6897e0c09e$var$jr({}, e, {
                                        color: "inherit" === e.color ? m : e.color
                                    }));
                                })
                            });
                            w.id = _, (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, s, "url(#" + _ + ")"), c[_] || (u.push(w), c[_] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($3487eb305ae0d41f$exports)))(r, s, "url(#" + l + ")");
                    }
                }
                return "break";
            }
        }, i = 0; i < t.length; i++){
            if ("break" === n()) break;
        }
    })), u;
};





var $51de7ad69d90896e$exports = {};
var $ab3e81e3191a16f7$exports = {};




var $fa874c262754487d$exports = {};

var $7cd962ea8094c633$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $7cd962ea8094c633$var$noop() {
// No operation performed.
}
$7cd962ea8094c633$exports = $7cd962ea8094c633$var$noop;



/** Used as references for various `Number` constants. */ var $fa874c262754487d$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $fa874c262754487d$var$createSet = !($2a4786f2dfc898c9$exports && 1 / $edfe5dc5ee94a646$exports(new $2a4786f2dfc898c9$exports([
    ,
    -0
]))[1] == $fa874c262754487d$var$INFINITY) ? $7cd962ea8094c633$exports : function(values) {
    return new $2a4786f2dfc898c9$exports(values);
};
$fa874c262754487d$exports = $fa874c262754487d$var$createSet;



/** Used as the size to enable large array optimizations. */ var $ab3e81e3191a16f7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $ab3e81e3191a16f7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $6d186121efb321b5$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $c0d14eba3105b20d$exports;
    } else if (length >= $ab3e81e3191a16f7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $fa874c262754487d$exports(array);
        if (set) return $edfe5dc5ee94a646$exports(set);
        isCommon = false;
        includes = $601e4ed5362647b9$exports;
        seen = new $7d2f3a0d9ce14f26$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$ab3e81e3191a16f7$exports = $ab3e81e3191a16f7$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $51de7ad69d90896e$var$uniq(array) {
    return array && array.length ? $ab3e81e3191a16f7$exports(array) : [];
}
$51de7ad69d90896e$exports = $51de7ad69d90896e$var$uniq;


var $99c2840ed14736a0$exports = {};


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $99c2840ed14736a0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ab3e81e3191a16f7$exports(array, $bf70b66c162aef31$exports(iteratee, 2)) : [];
}
$99c2840ed14736a0$exports = $99c2840ed14736a0$var$uniqBy;




var $48be745e7f0b6343$exports = {};
var $e592e2facae8ddf7$exports = {};


/** `Object#toString` result references. */ var $e592e2facae8ddf7$var$dateTag = "[object Date]";
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function $e592e2facae8ddf7$var$baseIsDate(value) {
    return $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $e592e2facae8ddf7$var$dateTag;
}
$e592e2facae8ddf7$exports = $e592e2facae8ddf7$var$baseIsDate;




var $iU8uW = parcelRequire("iU8uW");
/* Node.js helper references. */ var $48be745e7f0b6343$var$nodeIsDate = $iU8uW && $iU8uW.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var $48be745e7f0b6343$var$isDate = $48be745e7f0b6343$var$nodeIsDate ? $c4aeaafb4421a79e$exports($48be745e7f0b6343$var$nodeIsDate) : $e592e2facae8ddf7$exports;
$48be745e7f0b6343$exports = $48be745e7f0b6343$var$isDate;



function $c4a115a3f8332c88$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}




function $867097c2e7d6d907$export$2e2bcd8739ae039() {
    var scale = (0, $0ae5395125647844$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $c4a115a3f8332c88$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $867097c2e7d6d907$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $867097c2e7d6d907$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $867097c2e7d6d907$var$pointish(copy());
    };
    return scale;
}
function $867097c2e7d6d907$export$105684a3041cb6f3() {
    return $867097c2e7d6d907$var$pointish($867097c2e7d6d907$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

const $3a31e5e80e2db607$var$t0 = new Date, $3a31e5e80e2db607$var$t1 = new Date;
function $3a31e5e80e2db607$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $3a31e5e80e2db607$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $3a31e5e80e2db607$var$t0.setTime(+start), $3a31e5e80e2db607$var$t1.setTime(+end);
            floori($3a31e5e80e2db607$var$t0), floori($3a31e5e80e2db607$var$t1);
            return Math.floor(count($3a31e5e80e2db607$var$t0, $3a31e5e80e2db607$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $bc0f6470f3eca303$export$79ef0e34099623dc = 1000;
const $bc0f6470f3eca303$export$683905d551c33fa9 = $bc0f6470f3eca303$export$79ef0e34099623dc * 60;
const $bc0f6470f3eca303$export$4157bf0c8e241659 = $bc0f6470f3eca303$export$683905d551c33fa9 * 60;
const $bc0f6470f3eca303$export$353686095f4fbf45 = $bc0f6470f3eca303$export$4157bf0c8e241659 * 24;
const $bc0f6470f3eca303$export$c241eb88520d5016 = $bc0f6470f3eca303$export$353686095f4fbf45 * 7;
const $bc0f6470f3eca303$export$ab95684df7020b26 = $bc0f6470f3eca303$export$353686095f4fbf45 * 30;
const $bc0f6470f3eca303$export$61f8ee2d834c6959 = $bc0f6470f3eca303$export$353686095f4fbf45 * 365;


const $2f46cb4a96a2ec77$export$8888529b966033e5 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $bc0f6470f3eca303$export$683905d551c33fa9)) / (0, $bc0f6470f3eca303$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $2f46cb4a96a2ec77$export$6657a54f3034cf45 = $2f46cb4a96a2ec77$export$8888529b966033e5.range;
const $2f46cb4a96a2ec77$export$c8cbc42cefd47140 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $2f46cb4a96a2ec77$export$d277e198508549a1 = $2f46cb4a96a2ec77$export$c8cbc42cefd47140.range;
const $2f46cb4a96a2ec77$export$fb065be2d7ea4a71 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $bc0f6470f3eca303$export$353686095f4fbf45));
});
const $2f46cb4a96a2ec77$export$a491caaf5e9481aa = $2f46cb4a96a2ec77$export$fb065be2d7ea4a71.range;



const $4e5b137486e2e52a$export$46c68a5833bc315b = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $bc0f6470f3eca303$export$79ef0e34099623dc) - date.getMinutes() * (0, $bc0f6470f3eca303$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $bc0f6470f3eca303$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $4e5b137486e2e52a$export$fb843f9087cd5235 = $4e5b137486e2e52a$export$46c68a5833bc315b.range;
const $4e5b137486e2e52a$export$31f6f2b3c63ac75e = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $bc0f6470f3eca303$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $4e5b137486e2e52a$export$6e7a76cd5f50b719 = $4e5b137486e2e52a$export$31f6f2b3c63ac75e.range;



const $833a32771971ee15$export$a7e4c34a52f0576 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $bc0f6470f3eca303$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $bc0f6470f3eca303$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $833a32771971ee15$export$186d65358374c0a2 = $833a32771971ee15$export$a7e4c34a52f0576.range;
const $833a32771971ee15$export$efe6712d6003761b = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $bc0f6470f3eca303$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $833a32771971ee15$export$cedd563624e8ee50 = $833a32771971ee15$export$efe6712d6003761b.range;


const $1e795a6ed9817b8c$export$7e1084fb688591c1 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $1e795a6ed9817b8c$export$3e24aa839cd0f1c4 = $1e795a6ed9817b8c$export$7e1084fb688591c1.range;
const $1e795a6ed9817b8c$export$cd49b3d2bcfe50d5 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $1e795a6ed9817b8c$export$49159f585997498 = $1e795a6ed9817b8c$export$cd49b3d2bcfe50d5.range;



const $b1abecffa78ce16e$export$3d3c77ce7df7d30d = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $bc0f6470f3eca303$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $bc0f6470f3eca303$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $b1abecffa78ce16e$export$4792e48abc550fa1 = $b1abecffa78ce16e$export$3d3c77ce7df7d30d.range;




const $25df5067a1250b42$export$edc5e5cb87280477 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$25df5067a1250b42$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $25df5067a1250b42$export$edc5e5cb87280477;
    return (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $25df5067a1250b42$export$9a27fac83d67afd3 = $25df5067a1250b42$export$edc5e5cb87280477.range;








function $8aaf89c651dbff15$var$timeWeekday(i) {
    return (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $bc0f6470f3eca303$export$683905d551c33fa9)) / (0, $bc0f6470f3eca303$export$c241eb88520d5016);
    });
}
const $8aaf89c651dbff15$export$22ee6205b762968c = $8aaf89c651dbff15$var$timeWeekday(0);
const $8aaf89c651dbff15$export$e79bbe0177cf1b01 = $8aaf89c651dbff15$var$timeWeekday(1);
const $8aaf89c651dbff15$export$57c0658c29f77708 = $8aaf89c651dbff15$var$timeWeekday(2);
const $8aaf89c651dbff15$export$3fbeef226c256e43 = $8aaf89c651dbff15$var$timeWeekday(3);
const $8aaf89c651dbff15$export$608689422d5cf9f4 = $8aaf89c651dbff15$var$timeWeekday(4);
const $8aaf89c651dbff15$export$548e5227aa183dca = $8aaf89c651dbff15$var$timeWeekday(5);
const $8aaf89c651dbff15$export$c56a3ad248908e19 = $8aaf89c651dbff15$var$timeWeekday(6);
const $8aaf89c651dbff15$export$eac514c8a8674eba = $8aaf89c651dbff15$export$22ee6205b762968c.range;
const $8aaf89c651dbff15$export$f7219b1481948356 = $8aaf89c651dbff15$export$e79bbe0177cf1b01.range;
const $8aaf89c651dbff15$export$77e22b12c5bed05b = $8aaf89c651dbff15$export$57c0658c29f77708.range;
const $8aaf89c651dbff15$export$b85d407a471809e8 = $8aaf89c651dbff15$export$3fbeef226c256e43.range;
const $8aaf89c651dbff15$export$c1bc1c49254c8855 = $8aaf89c651dbff15$export$608689422d5cf9f4.range;
const $8aaf89c651dbff15$export$3691a1557fff46f1 = $8aaf89c651dbff15$export$548e5227aa183dca.range;
const $8aaf89c651dbff15$export$b755452d02cba8d2 = $8aaf89c651dbff15$export$c56a3ad248908e19.range;
function $8aaf89c651dbff15$var$utcWeekday(i) {
    return (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $bc0f6470f3eca303$export$c241eb88520d5016);
    });
}
const $8aaf89c651dbff15$export$4898b06303a92011 = $8aaf89c651dbff15$var$utcWeekday(0);
const $8aaf89c651dbff15$export$9cfc53b9cfafd080 = $8aaf89c651dbff15$var$utcWeekday(1);
const $8aaf89c651dbff15$export$2a6d545f77eceb15 = $8aaf89c651dbff15$var$utcWeekday(2);
const $8aaf89c651dbff15$export$a5c25d8ed64433c4 = $8aaf89c651dbff15$var$utcWeekday(3);
const $8aaf89c651dbff15$export$1db08111baec2f53 = $8aaf89c651dbff15$var$utcWeekday(4);
const $8aaf89c651dbff15$export$29265e34dd5921f7 = $8aaf89c651dbff15$var$utcWeekday(5);
const $8aaf89c651dbff15$export$85b74dad05049604 = $8aaf89c651dbff15$var$utcWeekday(6);
const $8aaf89c651dbff15$export$6f3e1c2b0f7d7880 = $8aaf89c651dbff15$export$4898b06303a92011.range;
const $8aaf89c651dbff15$export$1d2d8b858bb366f9 = $8aaf89c651dbff15$export$9cfc53b9cfafd080.range;
const $8aaf89c651dbff15$export$1d5f6785fc7f30f8 = $8aaf89c651dbff15$export$2a6d545f77eceb15.range;
const $8aaf89c651dbff15$export$7a75faf0e37ef4af = $8aaf89c651dbff15$export$a5c25d8ed64433c4.range;
const $8aaf89c651dbff15$export$417eb959611b2f2f = $8aaf89c651dbff15$export$1db08111baec2f53.range;
const $8aaf89c651dbff15$export$59d308db7af08c64 = $8aaf89c651dbff15$export$29265e34dd5921f7.range;
const $8aaf89c651dbff15$export$a124108a0a7f34c8 = $8aaf89c651dbff15$export$85b74dad05049604.range;




const $a174ba44333660ce$export$cd17cfe45df0c046 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$a174ba44333660ce$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $a174ba44333660ce$export$69a4e90dd2cc3bd1 = $a174ba44333660ce$export$cd17cfe45df0c046.range;
const $a174ba44333660ce$export$d5c3802e389714c4 = (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$a174ba44333660ce$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $3a31e5e80e2db607$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $a174ba44333660ce$export$3e24d311e17f5802 = $a174ba44333660ce$export$d5c3802e389714c4.range;


function $d2b73a2a72d12fff$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $b1abecffa78ce16e$export$3d3c77ce7df7d30d),
            1,
            (0, $bc0f6470f3eca303$export$79ef0e34099623dc)
        ],
        [
            (0, $b1abecffa78ce16e$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $bc0f6470f3eca303$export$79ef0e34099623dc)
        ],
        [
            (0, $b1abecffa78ce16e$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $bc0f6470f3eca303$export$79ef0e34099623dc)
        ],
        [
            (0, $b1abecffa78ce16e$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $bc0f6470f3eca303$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $bc0f6470f3eca303$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $bc0f6470f3eca303$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $bc0f6470f3eca303$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $bc0f6470f3eca303$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $bc0f6470f3eca303$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $bc0f6470f3eca303$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $bc0f6470f3eca303$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $bc0f6470f3eca303$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $bc0f6470f3eca303$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $bc0f6470f3eca303$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $bc0f6470f3eca303$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $bc0f6470f3eca303$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $bc0f6470f3eca303$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $bc0f6470f3eca303$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $3034080dc078938c$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $0133508c2a5a0194$export$81087d9b915d4ede)(start / (0, $bc0f6470f3eca303$export$61f8ee2d834c6959), stop / (0, $bc0f6470f3eca303$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $25df5067a1250b42$export$edc5e5cb87280477).every(Math.max((0, $0133508c2a5a0194$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$d2b73a2a72d12fff$export$826ba5ae907e9767, $d2b73a2a72d12fff$export$6262d8d056ea44c4] = $d2b73a2a72d12fff$var$ticker((0, $a174ba44333660ce$export$d5c3802e389714c4), (0, $1e795a6ed9817b8c$export$cd49b3d2bcfe50d5), (0, $8aaf89c651dbff15$export$4898b06303a92011), (0, $2f46cb4a96a2ec77$export$fb065be2d7ea4a71), (0, $4e5b137486e2e52a$export$31f6f2b3c63ac75e), (0, $833a32771971ee15$export$efe6712d6003761b));
const [$d2b73a2a72d12fff$export$60c76498552d28a6, $d2b73a2a72d12fff$export$69511150134dd174] = $d2b73a2a72d12fff$var$ticker((0, $a174ba44333660ce$export$cd17cfe45df0c046), (0, $1e795a6ed9817b8c$export$7e1084fb688591c1), (0, $8aaf89c651dbff15$export$22ee6205b762968c), (0, $2f46cb4a96a2ec77$export$8888529b966033e5), (0, $4e5b137486e2e52a$export$46c68a5833bc315b), (0, $833a32771971ee15$export$a7e4c34a52f0576));






function $faa1bf90c57c59a5$var$date(t) {
    return new Date(t);
}
function $faa1bf90c57c59a5$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $faa1bf90c57c59a5$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $dd7e4e0e97e8ad6b$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $faa1bf90c57c59a5$var$number)) : domain().map($faa1bf90c57c59a5$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $f3dad0f4212a0070$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $dd7e4e0e97e8ad6b$export$784d13d8ee351f07)(scale, $faa1bf90c57c59a5$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $faa1bf90c57c59a5$export$2e2bcd8739ae039() {
    return (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply($faa1bf90c57c59a5$export$56bbcdb8aca31149((0, $d2b73a2a72d12fff$export$60c76498552d28a6), (0, $d2b73a2a72d12fff$export$69511150134dd174), (0, $a174ba44333660ce$export$cd17cfe45df0c046), (0, $1e795a6ed9817b8c$export$7e1084fb688591c1), (0, $8aaf89c651dbff15$export$22ee6205b762968c), (0, $2f46cb4a96a2ec77$export$8888529b966033e5), (0, $4e5b137486e2e52a$export$46c68a5833bc315b), (0, $833a32771971ee15$export$a7e4c34a52f0576), (0, $b1abecffa78ce16e$export$3d3c77ce7df7d30d), (0, $8b6f069f85db80e1$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $f29dbaf1185c8eb7$export$2e2bcd8739ae039() {
    return (0, $eaed823ec896ae20$export$23c7bb9e6558da2a).apply((0, $faa1bf90c57c59a5$export$56bbcdb8aca31149)((0, $d2b73a2a72d12fff$export$826ba5ae907e9767), (0, $d2b73a2a72d12fff$export$6262d8d056ea44c4), (0, $a174ba44333660ce$export$d5c3802e389714c4), (0, $1e795a6ed9817b8c$export$cd49b3d2bcfe50d5), (0, $8aaf89c651dbff15$export$4898b06303a92011), (0, $2f46cb4a96a2ec77$export$c8cbc42cefd47140), (0, $4e5b137486e2e52a$export$31f6f2b3c63ac75e), (0, $833a32771971ee15$export$efe6712d6003761b), (0, $b1abecffa78ce16e$export$3d3c77ce7df7d30d), (0, $8b6f069f85db80e1$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}



var $0a4f2ea6a399e57c$var$millisecond = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$0a4f2ea6a399e57c$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $0a4f2ea6a399e57c$var$millisecond;
    return (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $0a4f2ea6a399e57c$export$2e2bcd8739ae039 = $0a4f2ea6a399e57c$var$millisecond;
var $0a4f2ea6a399e57c$export$9a27fac83d67afd3 = $0a4f2ea6a399e57c$var$millisecond.range;



var $a0afe0478049aed0$var$second = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $dcc93f619686d410$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $dcc93f619686d410$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $a0afe0478049aed0$export$2e2bcd8739ae039 = $a0afe0478049aed0$var$second;
var $a0afe0478049aed0$export$4792e48abc550fa1 = $a0afe0478049aed0$var$second.range;



var $e0aa5ec14ef0a46b$var$minute = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dcc93f619686d410$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $dcc93f619686d410$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $dcc93f619686d410$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $e0aa5ec14ef0a46b$export$2e2bcd8739ae039 = $e0aa5ec14ef0a46b$var$minute;
var $e0aa5ec14ef0a46b$export$666252b437cce0c7 = $e0aa5ec14ef0a46b$var$minute.range;



var $0ae44b21dbe28022$var$hour = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dcc93f619686d410$export$79ef0e34099623dc) - date.getMinutes() * (0, $dcc93f619686d410$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $dcc93f619686d410$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $dcc93f619686d410$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $0ae44b21dbe28022$export$2e2bcd8739ae039 = $0ae44b21dbe28022$var$hour;
var $0ae44b21dbe28022$export$8d468796d69cdad1 = $0ae44b21dbe28022$var$hour.range;


var $336fadb86a1aa786$var$month = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $336fadb86a1aa786$export$2e2bcd8739ae039 = $336fadb86a1aa786$var$month;
var $336fadb86a1aa786$export$16352d1b10c5eb38 = $336fadb86a1aa786$var$month.range;



var $6aae7f14f39f2299$var$utcMinute = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $dcc93f619686d410$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $dcc93f619686d410$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $6aae7f14f39f2299$export$2e2bcd8739ae039 = $6aae7f14f39f2299$var$utcMinute;
var $6aae7f14f39f2299$export$cedd563624e8ee50 = $6aae7f14f39f2299$var$utcMinute.range;



var $55f91410e648a6d4$var$utcHour = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $dcc93f619686d410$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $dcc93f619686d410$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $55f91410e648a6d4$export$2e2bcd8739ae039 = $55f91410e648a6d4$var$utcHour;
var $55f91410e648a6d4$export$6e7a76cd5f50b719 = $55f91410e648a6d4$var$utcHour.range;


var $906890fbeeca539b$var$utcMonth = (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $906890fbeeca539b$export$2e2bcd8739ae039 = $906890fbeeca539b$var$utcMonth;
var $906890fbeeca539b$export$49159f585997498 = $906890fbeeca539b$var$utcMonth.range;



function $ee31ac98501255d1$var$$() {
    return $ee31ac98501255d1$var$$ = Object.assign ? Object.assign.bind() : function(n) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var e in r)Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
        }
        return n;
    }, $ee31ac98501255d1$var$$.apply(this, arguments);
}
var $ee31ac98501255d1$export$6dcdc1137d8ab211 = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
], $ee31ac98501255d1$export$1dc82d6660f2ea1c = [
    function(n) {
        return n.setMilliseconds(0);
    },
    function(n) {
        return n.setSeconds(0);
    },
    function(n) {
        return n.setMinutes(0);
    },
    function(n) {
        return n.setHours(0);
    },
    function(n) {
        return n.setDate(1);
    },
    function(n) {
        return n.setMonth(0);
    }
], $ee31ac98501255d1$export$43fb64d4d70cf1d2 = {
    millisecond: [],
    second: $ee31ac98501255d1$export$1dc82d6660f2ea1c.slice(0, 1),
    minute: $ee31ac98501255d1$export$1dc82d6660f2ea1c.slice(0, 2),
    hour: $ee31ac98501255d1$export$1dc82d6660f2ea1c.slice(0, 3),
    day: $ee31ac98501255d1$export$1dc82d6660f2ea1c.slice(0, 4),
    month: $ee31ac98501255d1$export$1dc82d6660f2ea1c.slice(0, 5),
    year: $ee31ac98501255d1$export$1dc82d6660f2ea1c.slice(0, 6)
}, $ee31ac98501255d1$export$317f4d4c07f3c42a = function(n) {
    return function(t) {
        return $ee31ac98501255d1$export$43fb64d4d70cf1d2[n].forEach(function(n) {
            n(t);
        }), t;
    };
}, $ee31ac98501255d1$export$daf307d3fe6dfa68 = function(n) {
    var t = n.format, r = void 0 === t ? "native" : t, e = n.precision, a = void 0 === e ? "millisecond" : e, u = n.useUTC, c = void 0 === u || u, s = $ee31ac98501255d1$export$317f4d4c07f3c42a(a);
    return function(n) {
        if (void 0 === n) return n;
        if ("native" === r || n instanceof Date) return s(n);
        var t = c ? (0, $8b6f069f85db80e1$export$3edae9cf8e233729)(r) : (0, $8b6f069f85db80e1$export$32b9cd16e1b8c8d2)(r);
        return s(t(n));
    };
}, $ee31ac98501255d1$export$4e095c21b86a0457 = function(n, t, r, e) {
    var a, i, o, c, s = n.min, d = void 0 === s ? 0 : s, f = n.max, l = void 0 === f ? "auto" : f, m = n.stacked, v = void 0 !== m && m, y = n.reverse, p = void 0 !== y && y, h = n.clamp, g = void 0 !== h && h, x = n.nice, k = void 0 !== x && x;
    "auto" === d ? a = !0 === v ? null != (i = t.minStacked) ? i : 0 : t.min : a = d;
    "auto" === l ? o = !0 === v ? null != (c = t.maxStacked) ? c : 0 : t.max : o = l;
    var T = (0, $8b8f36a539eb80e5$export$2e2bcd8739ae039)().rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).domain(p ? [
        o,
        a
    ] : [
        a,
        o
    ]).clamp(g);
    return !0 === k ? T.nice() : "number" == typeof k && T.nice(k), $ee31ac98501255d1$export$4fd02d345bf145e3(T, v);
}, $ee31ac98501255d1$export$4fd02d345bf145e3 = function(n, t) {
    void 0 === t && (t = !1);
    var r = n;
    return r.type = "linear", r.stacked = t, r;
}, $ee31ac98501255d1$export$9abcadf788874abe = function(n, t, r) {
    var e = (0, $867097c2e7d6d907$export$105684a3041cb6f3)().range([
        0,
        r
    ]).domain(t.all);
    return e.type = "point", e;
}, $ee31ac98501255d1$export$a8f33a545c6650d6 = function(n) {
    var t = n;
    return t.type = "point", t;
}, $ee31ac98501255d1$export$e9706c87cd649069 = function(n, t, r, e) {
    var a = n.round, i = void 0 === a || a, o = (0, $867097c2e7d6d907$export$2e2bcd8739ae039)().range("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).domain(t.all).round(i);
    return $ee31ac98501255d1$export$c88e9eb2fbaf2089(o);
}, $ee31ac98501255d1$export$c88e9eb2fbaf2089 = function(n) {
    var t = n;
    return t.type = "band", t;
}, $ee31ac98501255d1$export$27d74465d4d4bf01 = function(n, t, r) {
    var e, a, i = n.format, o = void 0 === i ? "native" : i, u = n.precision, c = void 0 === u ? "millisecond" : u, s = n.min, l = void 0 === s ? "auto" : s, m = n.max, v = void 0 === m ? "auto" : m, y = n.useUTC, p = void 0 === y || y, h = n.nice, g = void 0 !== h && h, x = $ee31ac98501255d1$export$daf307d3fe6dfa68({
        format: o,
        precision: c,
        useUTC: p
    });
    e = "auto" === l ? x(t.min) : "native" !== o ? x(l) : l, a = "auto" === v ? x(t.max) : "native" !== o ? x(v) : v;
    var k = p ? (0, $f29dbaf1185c8eb7$export$2e2bcd8739ae039)() : (0, $faa1bf90c57c59a5$export$2e2bcd8739ae039)();
    k.range([
        0,
        r
    ]), e && a && k.domain([
        e,
        a
    ]), !0 === g ? k.nice() : "object" != typeof g && "number" != typeof g || k.nice(g);
    var T = k;
    return T.type = "time", T.useUTC = p, T;
}, $ee31ac98501255d1$export$554cc426a2d37672 = function(n, t, r, e) {
    var a, i = n.base, o = void 0 === i ? 10 : i, u = n.min, c = void 0 === u ? "auto" : u, s = n.max, d = void 0 === s ? "auto" : s;
    if (t.all.some(function(n) {
        return 0 === n;
    })) throw new Error("a log scale domain must not include or cross zero");
    var f, m, v = !1;
    if (t.all.filter(function(n) {
        return null != n;
    }).forEach(function(n) {
        v || (void 0 === a ? a = Math.sign(n) : Math.sign(n) !== a && (v = !0));
    }), v) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
    f = "auto" === c ? t.min : c, m = "auto" === d ? t.max : d;
    var y = (0, $a5d1681d8e40f4e7$export$2e2bcd8739ae039)().domain([
        f,
        m
    ]).rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).base(o).nice();
    return y.type = "log", y;
}, $ee31ac98501255d1$export$8e14d6e8a8fc902c = function(n, t, r, e) {
    var a, i, o = n.constant, u = void 0 === o ? 1 : o, c = n.min, s = void 0 === c ? "auto" : c, d = n.max, f = void 0 === d ? "auto" : d, l = n.reverse, v = void 0 !== l && l;
    a = "auto" === s ? t.min : s, i = "auto" === f ? t.max : f;
    var y = (0, $acc2eb21ce565e92$export$2e2bcd8739ae039)().constant(u).rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).nice();
    !0 === v ? y.domain([
        i,
        a
    ]) : y.domain([
        a,
        i
    ]);
    var p = y;
    return p.type = "symlog", p;
}, $ee31ac98501255d1$export$9aa6d07acb85188c = function(n) {
    return "x" === n ? "y" : "x";
}, $ee31ac98501255d1$export$6ab1df3197f7c641 = function(n, t) {
    return n === t;
}, $ee31ac98501255d1$export$562cdc7d09e1fa5a = function(n, t) {
    return n.getTime() === t.getTime();
};
function $ee31ac98501255d1$export$5268a4c29077d335(n, t, r, e) {
    switch(n.type){
        case "linear":
            return $ee31ac98501255d1$export$4e095c21b86a0457(n, t, r, e);
        case "point":
            return $ee31ac98501255d1$export$9abcadf788874abe(n, t, r);
        case "band":
            return $ee31ac98501255d1$export$e9706c87cd649069(n, t, r, e);
        case "time":
            return $ee31ac98501255d1$export$27d74465d4d4bf01(n, t, r);
        case "log":
            return $ee31ac98501255d1$export$554cc426a2d37672(n, t, r, e);
        case "symlog":
            return $ee31ac98501255d1$export$8e14d6e8a8fc902c(n, t, r, e);
        default:
            throw new Error("invalid scale spec");
    }
}
var $ee31ac98501255d1$var$sn = function(n, t, r) {
    var e;
    if ("stacked" in r && r.stacked) {
        var a = n.data["x" === t ? "xStacked" : "yStacked"];
        return null == a ? null : r(a);
    }
    return null != (e = r(n.data[t])) ? e : null;
}, $ee31ac98501255d1$export$4d0b292d246e5304 = function(n, t, r, e, a) {
    var i = n.map(function(n) {
        return function(n) {
            return $ee31ac98501255d1$var$$({}, n, {
                data: n.data.map(function(n) {
                    return {
                        data: $ee31ac98501255d1$var$$({}, n)
                    };
                })
            });
        }(n);
    }), o = $ee31ac98501255d1$export$ebc19db715008482(i, t, r);
    "stacked" in t && !0 === t.stacked && $ee31ac98501255d1$var$vn(o, i), "stacked" in r && !0 === r.stacked && $ee31ac98501255d1$var$yn(o, i);
    var u = $ee31ac98501255d1$export$5268a4c29077d335(t, o.x, e, "x"), c = $ee31ac98501255d1$export$5268a4c29077d335(r, o.y, a, "y"), s = i.map(function(n) {
        return $ee31ac98501255d1$var$$({}, n, {
            data: n.data.map(function(n) {
                return $ee31ac98501255d1$var$$({}, n, {
                    position: {
                        x: $ee31ac98501255d1$var$sn(n, "x", u),
                        y: $ee31ac98501255d1$var$sn(n, "y", c)
                    }
                });
            })
        });
    });
    return $ee31ac98501255d1$var$$({}, o, {
        series: s,
        xScale: u,
        yScale: c
    });
}, $ee31ac98501255d1$export$ebc19db715008482 = function(n, t, r) {
    return {
        x: $ee31ac98501255d1$export$b510e85f598a24fb(n, "x", t),
        y: $ee31ac98501255d1$export$b510e85f598a24fb(n, "y", r)
    };
}, $ee31ac98501255d1$export$b510e85f598a24fb = function(a, i, o, u) {
    var c = void 0 === u ? {} : u, s = c.getValue, d = void 0 === s ? function(n) {
        return n.data[i];
    } : s, f = c.setValue, l = void 0 === f ? function(n, t) {
        n.data[i] = t;
    } : f;
    if ("linear" === o.type) a.forEach(function(n) {
        n.data.forEach(function(n) {
            var t = d(n);
            t && l(n, parseFloat(String(t)));
        });
    });
    else if ("time" === o.type && "native" !== o.format) {
        var m = $ee31ac98501255d1$export$daf307d3fe6dfa68(o);
        a.forEach(function(n) {
            n.data.forEach(function(n) {
                var t = d(n);
                t && l(n, m(t));
            });
        });
    }
    var v = [];
    switch(a.forEach(function(n) {
        n.data.forEach(function(n) {
            v.push(d(n));
        });
    }), o.type){
        case "linear":
            var y = (0, (/*@__PURE__*/$parcel$interopDefault($5cbcadbe316600de$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($51de7ad69d90896e$exports)))(v).filter(function(n) {
                return null !== n;
            }), function(n) {
                return n;
            });
            return {
                all: y,
                min: Math.min.apply(Math, y),
                max: Math.max.apply(Math, y)
            };
        case "time":
            var p = (0, (/*@__PURE__*/$parcel$interopDefault($99c2840ed14736a0$exports)))(v, function(n) {
                return n.getTime();
            }).slice(0).sort(function(n, t) {
                return t.getTime() - n.getTime();
            }).reverse();
            return {
                all: p,
                min: p[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(p)
            };
        default:
            var h = (0, (/*@__PURE__*/$parcel$interopDefault($51de7ad69d90896e$exports)))(v);
            return {
                all: h,
                min: h[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(h)
            };
    }
}, $ee31ac98501255d1$export$c6f16b50cdeeb77c = function(n, t, r) {
    var i = $ee31ac98501255d1$export$9aa6d07acb85188c(n), o = [];
    t[i].all.forEach(function(t) {
        var u = (0, (/*@__PURE__*/$parcel$interopDefault($48be745e7f0b6343$exports)))(t) ? $ee31ac98501255d1$export$562cdc7d09e1fa5a : $ee31ac98501255d1$export$6ab1df3197f7c641, c = [];
        r.forEach(function(r) {
            var a = r.data.find(function(n) {
                return u(n.data[i], t);
            }), s = null, d = null;
            if (void 0 !== a) {
                if (null !== (s = a.data[n])) {
                    var f = (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(c);
                    void 0 === f ? d = s : null !== f && (d = f + s);
                }
                a.data["x" === n ? "xStacked" : "yStacked"] = d;
            }
            c.push(d), null !== d && o.push(d);
        });
    }), t[n].minStacked = Math.min.apply(Math, o), t[n].maxStacked = Math.max.apply(Math, o);
}, $ee31ac98501255d1$var$vn = function(n, t) {
    return $ee31ac98501255d1$export$c6f16b50cdeeb77c("x", n, t);
}, $ee31ac98501255d1$var$yn = function(n, t) {
    return $ee31ac98501255d1$export$c6f16b50cdeeb77c("y", n, t);
}, $ee31ac98501255d1$export$6eebe39d34e5b9b7 = function(n) {
    var t = n.bandwidth();
    if (0 === t) return n;
    var r = t / 2;
    return n.round() && (r = Math.round(r)), function(t) {
        var e;
        return (null != (e = n(t)) ? e : 0) + r;
    };
}, $ee31ac98501255d1$var$hn = {
    millisecond: [
        (0, $0a4f2ea6a399e57c$export$2e2bcd8739ae039),
        (0, $0a4f2ea6a399e57c$export$2e2bcd8739ae039)
    ],
    second: [
        (0, $a0afe0478049aed0$export$2e2bcd8739ae039),
        (0, $a0afe0478049aed0$export$2e2bcd8739ae039)
    ],
    minute: [
        (0, $e0aa5ec14ef0a46b$export$2e2bcd8739ae039),
        (0, $6aae7f14f39f2299$export$2e2bcd8739ae039)
    ],
    hour: [
        (0, $0ae44b21dbe28022$export$2e2bcd8739ae039),
        (0, $55f91410e648a6d4$export$2e2bcd8739ae039)
    ],
    day: [
        (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(n) {
            return n.setHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setDate(n.getDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        }),
        (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(n) {
            return n.setUTCHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setUTCDate(n.getUTCDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        })
    ],
    week: [
        (0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21),
        (0, $24ffb3b67dc2c085$export$4898b06303a92011)
    ],
    sunday: [
        (0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21),
        (0, $24ffb3b67dc2c085$export$4898b06303a92011)
    ],
    monday: [
        (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8),
        (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)
    ],
    tuesday: [
        (0, $ed25e5cb4307b03a$export$cb8f040f5d17ac7b),
        (0, $24ffb3b67dc2c085$export$2a6d545f77eceb15)
    ],
    wednesday: [
        (0, $ed25e5cb4307b03a$export$347581849975dfc8),
        (0, $24ffb3b67dc2c085$export$a5c25d8ed64433c4)
    ],
    thursday: [
        (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629),
        (0, $24ffb3b67dc2c085$export$1db08111baec2f53)
    ],
    friday: [
        (0, $ed25e5cb4307b03a$export$59b8c2ccd931d806),
        (0, $24ffb3b67dc2c085$export$29265e34dd5921f7)
    ],
    saturday: [
        (0, $ed25e5cb4307b03a$export$478ceadebff4d377),
        (0, $24ffb3b67dc2c085$export$85b74dad05049604)
    ],
    month: [
        (0, $336fadb86a1aa786$export$2e2bcd8739ae039),
        (0, $906890fbeeca539b$export$2e2bcd8739ae039)
    ],
    year: [
        (0, $c352773cb286f235$export$2e2bcd8739ae039),
        (0, $f493836e09c314f1$export$2e2bcd8739ae039)
    ]
}, $ee31ac98501255d1$var$gn = Object.keys($ee31ac98501255d1$var$hn), $ee31ac98501255d1$var$xn = new RegExp("^every\\s*(\\d+)?\\s*(" + $ee31ac98501255d1$var$gn.join("|") + ")s?$", "i"), $ee31ac98501255d1$export$6524ae923f6f50f3 = function(n, t) {
    if (Array.isArray(t)) return t;
    if ("string" == typeof t && "useUTC" in n) {
        var r = t.match($ee31ac98501255d1$var$xn);
        if (r) {
            var e = r[1], a = r[2], i = $ee31ac98501255d1$var$hn[a][n.useUTC ? 1 : 0];
            if ("day" === a) {
                var o, u, c = n.domain(), s = c[0], d = c[1], f = new Date(d);
                return f.setDate(f.getDate() + 1), null != (o = null == (u = i.every(Number(null != e ? e : 1))) ? void 0 : u.range(s, f)) ? o : [];
            }
            if (void 0 === e) return n.ticks(i);
            var l = i.every(Number(e));
            if (l) return n.ticks(l);
        }
        throw new Error("Invalid tickValues: " + t);
    }
    if ("ticks" in n) {
        if (void 0 === t) return n.ticks();
        if ("number" == typeof (m = t) && isFinite(m) && Math.floor(m) === m) return n.ticks(t);
    }
    var m;
    return n.domain();
};



function $61394014a6be57c7$var$p() {
    return $61394014a6be57c7$var$p = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $61394014a6be57c7$var$p.apply(this, arguments);
}
var $61394014a6be57c7$var$b = function(t) {
    var e, i = t.axis, n = t.scale, r = t.ticksPosition, o = t.tickValues, l = t.tickSize, s = t.tickPadding, c = t.tickRotation, f = t.truncateTickAt, u = t.engine, d = void 0 === u ? "svg" : u, x = (0, $ee31ac98501255d1$export$6524ae923f6f50f3)(n, o), m = (0, $ceac9f6897e0c09e$export$1abb91cfca1e2069)[d], k = "bandwidth" in n ? (0, $ee31ac98501255d1$export$6eebe39d34e5b9b7)(n) : n, g = {
        lineX: 0,
        lineY: 0
    }, v = {
        textX: 0,
        textY: 0
    }, b = "object" == typeof document && "rtl" === document.dir, P = m.align.center, T = m.baseline.center;
    "x" === i ? (e = function(t) {
        var e;
        return {
            x: null != (e = k(t)) ? e : 0,
            y: 0
        };
    }, g.lineY = l * ("after" === r ? 1 : -1), v.textY = (l + s) * ("after" === r ? 1 : -1), T = "after" === r ? m.baseline.top : m.baseline.bottom, 0 === c ? P = m.align.center : "after" === r && c < 0 || "before" === r && c > 0 ? (P = m.align[b ? "left" : "right"], T = m.baseline.center) : ("after" === r && c > 0 || "before" === r && c < 0) && (P = m.align[b ? "right" : "left"], T = m.baseline.center)) : (e = function(t) {
        var e;
        return {
            x: 0,
            y: null != (e = k(t)) ? e : 0
        };
    }, g.lineX = l * ("after" === r ? 1 : -1), v.textX = (l + s) * ("after" === r ? 1 : -1), P = "after" === r ? m.align.left : m.align.right);
    return {
        ticks: x.map(function(t) {
            var i = "string" == typeof t ? function(t) {
                var e = String(t).length;
                return f && f > 0 && e > f ? "" + String(t).slice(0, f).concat("...") : "" + t;
            }(t) : t;
            return $61394014a6be57c7$var$p({
                key: t instanceof Date ? "" + t.valueOf() : "" + t,
                value: i
            }, e(t), g, v);
        }),
        textAlign: P,
        textBaseline: T
    };
}, $61394014a6be57c7$var$P = function(t, e) {
    if (void 0 === t || "function" == typeof t) return t;
    if ("time" === e.type) {
        var i = (0, $8b6f069f85db80e1$export$94f4d87fad5dcf9a)(t);
        return function(t) {
            return i(t instanceof Date ? t : new Date(t));
        };
    }
    return (0, $f979cbd3e1200bf1$export$d9468344d3651243)(t);
}, $61394014a6be57c7$var$T = function(t) {
    var e, i = t.width, n = t.height, r = t.scale, a = t.axis, o = t.values, l = (e = o, Array.isArray(e) ? o : void 0) || (0, $ee31ac98501255d1$export$6524ae923f6f50f3)(r, o), s = "bandwidth" in r ? (0, $ee31ac98501255d1$export$6eebe39d34e5b9b7)(r) : r, c = "x" === a ? l.map(function(t) {
        var e, i;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: null != (e = s(t)) ? e : 0,
            x2: null != (i = s(t)) ? i : 0,
            y1: 0,
            y2: n
        };
    }) : l.map(function(t) {
        var e, n;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: 0,
            x2: i,
            y1: null != (e = s(t)) ? e : 0,
            y2: null != (n = s(t)) ? n : 0
        };
    });
    return c;
}, $61394014a6be57c7$export$3704f81c1ca961a8 = (0, $7fPBF.memo)(function(t) {
    var e, n = t.value, r = t.format, a = t.lineX, s = t.lineY, c = t.onClick, u = t.textBaseline, d = t.textAnchor, x = t.animatedProps, m = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), y = m.axis.ticks.line, h = m.axis.ticks.text, v = null != (e = null == r ? void 0 : r(n)) ? e : n, b = (0, $7fPBF.useMemo)(function() {
        var t = {
            opacity: x.opacity
        };
        return c ? {
            style: $61394014a6be57c7$var$p({}, t, {
                cursor: "pointer"
            }),
            onClick: function(t) {
                return c(t, v);
            }
        } : {
            style: t
        };
    }, [
        x.opacity,
        c,
        v
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, $61394014a6be57c7$var$p({
        transform: x.transform
    }, b, {
        children: [
            (0, $824c049f32d4395d$exports.jsx)("line", {
                x1: 0,
                x2: a,
                y1: 0,
                y2: s,
                style: y
            }),
            h.outlineWidth > 0 && (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                dominantBaseline: u,
                textAnchor: d,
                transform: x.textTransform,
                style: h,
                strokeWidth: 2 * h.outlineWidth,
                stroke: h.outlineColor,
                strokeLinejoin: "round",
                children: "" + v
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                dominantBaseline: u,
                textAnchor: d,
                transform: x.textTransform,
                style: (0, $ceac9f6897e0c09e$export$c30625df7c8afdb5)(h),
                children: "" + v
            })
        ]
    }));
}), $61394014a6be57c7$export$c5639fd237d7a900 = function(e) {
    var r = e.axis, a = e.scale, l = e.x, c = void 0 === l ? 0 : l, x = e.y, m = void 0 === x ? 0 : x, y = e.length, h = e.ticksPosition, T = e.tickValues, S = e.tickSize, W = void 0 === S ? 5 : S, w = e.tickPadding, B = void 0 === w ? 5 : w, X = e.tickRotation, Y = void 0 === X ? 0 : X, C = e.format, O = e.renderTick, j = void 0 === O ? $61394014a6be57c7$export$3704f81c1ca961a8 : O, z = e.truncateTickAt, V = e.legend, D = e.legendPosition, R = void 0 === D ? "end" : D, E = e.legendOffset, q = void 0 === E ? 0 : E, F = e.onClick, L = e.ariaHidden, N = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), H = N.axis.legend.text, I = (0, $7fPBF.useMemo)(function() {
        return $61394014a6be57c7$var$P(C, a);
    }, [
        C,
        a
    ]), J = $61394014a6be57c7$var$b({
        axis: r,
        scale: a,
        ticksPosition: h,
        tickValues: T,
        tickSize: W,
        tickPadding: B,
        tickRotation: Y,
        truncateTickAt: z
    }), G = J.ticks, K = J.textAlign, M = J.textBaseline, Q = null;
    if (void 0 !== V) {
        var U, Z = 0, $ = 0, _ = 0;
        "y" === r ? (_ = -90, Z = q, "start" === R ? (U = "start", $ = y) : "middle" === R ? (U = "middle", $ = y / 2) : "end" === R && (U = "end")) : ($ = q, "start" === R ? U = "start" : "middle" === R ? (U = "middle", Z = y / 2) : "end" === R && (U = "end", Z = y)), Q = (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                H.outlineWidth > 0 && (0, $824c049f32d4395d$exports.jsx)("text", {
                    transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
                    textAnchor: U,
                    style: $61394014a6be57c7$var$p({
                        dominantBaseline: "central"
                    }, H),
                    strokeWidth: 2 * H.outlineWidth,
                    stroke: H.outlineColor,
                    strokeLinejoin: "round",
                    children: V
                }),
                (0, $824c049f32d4395d$exports.jsx)("text", {
                    transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
                    textAnchor: U,
                    style: $61394014a6be57c7$var$p({
                        dominantBaseline: "central"
                    }, H),
                    children: V
                })
            ]
        });
    }
    var tt = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), et = tt.animate, it = tt.config, nt = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        transform: "translate(" + c + "," + m + ")",
        lineX2: "x" === r ? y : 0,
        lineY2: "x" === r ? 0 : y,
        config: it,
        immediate: !et
    }), rt = (0, $7fPBF.useCallback)(function(t) {
        return {
            opacity: 1,
            transform: "translate(" + t.x + "," + t.y + ")",
            textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + Y + ")"
        };
    }, [
        Y
    ]), at = (0, $7fPBF.useCallback)(function(t) {
        return {
            opacity: 0,
            transform: "translate(" + t.x + "," + t.y + ")",
            textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + Y + ")"
        };
    }, [
        Y
    ]), ot = (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(G, {
        keys: function(t) {
            return t.key;
        },
        initial: rt,
        from: at,
        enter: rt,
        update: rt,
        leave: {
            opacity: 0
        },
        config: it,
        immediate: !et
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        transform: nt.transform,
        "aria-hidden": L,
        children: [
            ot(function(e, i, n, r) {
                return $7fPBF.createElement(j, $61394014a6be57c7$var$p({
                    tickIndex: r,
                    format: I,
                    rotate: Y,
                    textBaseline: M,
                    textAnchor: K,
                    truncateTickAt: z,
                    animatedProps: e
                }, i, F ? {
                    onClick: F
                } : {}));
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).line, {
                style: N.axis.domain.line,
                x1: 0,
                x2: nt.lineX2,
                y1: 0,
                y2: nt.lineY2
            }),
            Q
        ]
    });
}, $61394014a6be57c7$export$d06866a9fb0606da = (0, $7fPBF.memo)($61394014a6be57c7$export$c5639fd237d7a900), $61394014a6be57c7$export$878041e1e4cd4218 = [
    "top",
    "right",
    "bottom",
    "left"
], $61394014a6be57c7$export$387a78ab20784494 = (0, $7fPBF.memo)(function(t) {
    var e = t.xScale, i = t.yScale, n = t.width, r = t.height, a = {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left
    };
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: $61394014a6be57c7$export$878041e1e4cd4218.map(function(t) {
            var o = a[t];
            if (!o) return null;
            var l = "top" === t || "bottom" === t;
            return (0, $824c049f32d4395d$exports.jsx)($61394014a6be57c7$export$d06866a9fb0606da, $61394014a6be57c7$var$p({}, o, {
                axis: l ? "x" : "y",
                x: "right" === t ? n : 0,
                y: "bottom" === t ? r : 0,
                scale: l ? e : i,
                length: l ? n : r,
                ticksPosition: "top" === t || "left" === t ? "before" : "after",
                truncateTickAt: o.truncateTickAt
            }), t);
        })
    });
}), $61394014a6be57c7$export$cb089865d3c60926 = (0, $7fPBF.memo)(function(t) {
    var e = t.animatedProps, i = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)();
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).line, $61394014a6be57c7$var$p({}, e, i.grid.line));
}), $61394014a6be57c7$export$36506d95c1656a54 = (0, $7fPBF.memo)(function(t) {
    var e = t.lines, i = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), n = i.animate, a = i.config, o = (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(e, {
        keys: function(t) {
            return t.key;
        },
        initial: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        from: function(t) {
            return {
                opacity: 0,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        enter: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        leave: {
            opacity: 0
        },
        config: a,
        immediate: !n
    });
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        children: o(function(t, e) {
            return (0, $7fPBF.createElement)($61394014a6be57c7$export$cb089865d3c60926, $61394014a6be57c7$var$p({}, e, {
                key: e.key,
                animatedProps: t
            }));
        })
    });
}), $61394014a6be57c7$export$ef2184bd89960b14 = (0, $7fPBF.memo)(function(t) {
    var e = t.width, n = t.height, r = t.xScale, a = t.yScale, o = t.xValues, l = t.yValues, s = (0, $7fPBF.useMemo)(function() {
        return !!r && $61394014a6be57c7$var$T({
            width: e,
            height: n,
            scale: r,
            axis: "x",
            values: o
        });
    }, [
        r,
        o,
        e,
        n
    ]), c = (0, $7fPBF.useMemo)(function() {
        return !!a && $61394014a6be57c7$var$T({
            width: e,
            height: n,
            scale: a,
            axis: "y",
            values: l
        });
    }, [
        n,
        e,
        a,
        l
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            s && (0, $824c049f32d4395d$exports.jsx)($61394014a6be57c7$export$36506d95c1656a54, {
                lines: s
            }),
            c && (0, $824c049f32d4395d$exports.jsx)($61394014a6be57c7$export$36506d95c1656a54, {
                lines: c
            })
        ]
    });
}), $61394014a6be57c7$export$b3252c0e7f5dbc3f = function(t, e) {
    var i, n = e.axis, r = e.scale, a = e.x, o = void 0 === a ? 0 : a, l = e.y, s = void 0 === l ? 0 : l, f = e.length, u = e.ticksPosition, d = e.tickValues, x = e.tickSize, m = void 0 === x ? 5 : x, y = e.tickPadding, h = void 0 === y ? 5 : y, k = e.tickRotation, g = void 0 === k ? 0 : k, v = e.format, p = e.legend, P = e.legendPosition, T = void 0 === P ? "end" : P, A = e.legendOffset, S = void 0 === A ? 0 : A, W = e.theme, w = $61394014a6be57c7$var$b({
        axis: n,
        scale: r,
        ticksPosition: u,
        tickValues: d,
        tickSize: m,
        tickPadding: h,
        tickRotation: g,
        engine: "canvas"
    }), B = w.ticks, X = w.textAlign, Y = w.textBaseline;
    t.save(), t.translate(o, s), t.textAlign = X, t.textBaseline = Y;
    var C = W.axis.ticks.text;
    t.font = (C.fontWeight ? C.fontWeight + " " : "") + C.fontSize + "px " + C.fontFamily, (null != (i = W.axis.domain.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.domain.line.strokeWidth), t.lineCap = "square", W.axis.domain.line.stroke && (t.strokeStyle = W.axis.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === n ? f : 0, "x" === n ? 0 : f), t.stroke());
    var O = "function" == typeof v ? v : function(t) {
        return "" + t;
    };
    if (B.forEach(function(e) {
        var i;
        (null != (i = W.axis.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.ticks.line.strokeWidth), t.lineCap = "square", W.axis.ticks.line.stroke && (t.strokeStyle = W.axis.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
        var n = O(e.value);
        t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate((0, $ceac9f6897e0c09e$export$c9fcf1a7df975d78)(g)), C.outlineWidth > 0 && (t.strokeStyle = C.outlineColor, t.lineWidth = 2 * C.outlineWidth, t.lineJoin = "round", t.strokeText("" + n, 0, 0)), W.axis.ticks.text.fill && (t.fillStyle = C.fill), t.fillText("" + n, 0, 0), t.restore();
    }), void 0 !== p) {
        var j = 0, z = 0, V = 0, D = "center";
        "y" === n ? (V = -90, j = S, "start" === T ? (D = "start", z = f) : "middle" === T ? (D = "center", z = f / 2) : "end" === T && (D = "end")) : (z = S, "start" === T ? D = "start" : "middle" === T ? (D = "center", j = f / 2) : "end" === T && (D = "end", j = f)), t.translate(j, z), t.rotate((0, $ceac9f6897e0c09e$export$c9fcf1a7df975d78)(V)), t.font = (W.axis.legend.text.fontWeight ? W.axis.legend.text.fontWeight + " " : "") + W.axis.legend.text.fontSize + "px " + W.axis.legend.text.fontFamily, W.axis.legend.text.fill && (t.fillStyle = W.axis.legend.text.fill), t.textAlign = D, t.textBaseline = "middle", t.fillText(p, 0, 0);
    }
    t.restore();
}, $61394014a6be57c7$export$6f12c0e853c1bfff = function(t, e) {
    var i = e.xScale, n = e.yScale, r = e.width, a = e.height, o = e.top, l = e.right, s = e.bottom, c = e.left, f = e.theme, u = {
        top: o,
        right: l,
        bottom: s,
        left: c
    };
    $61394014a6be57c7$export$878041e1e4cd4218.forEach(function(e) {
        var o = u[e];
        if (!o) return null;
        var l = "top" === e || "bottom" === e, s = "top" === e || "left" === e ? "before" : "after", c = l ? i : n, d = $61394014a6be57c7$var$P(o.format, c);
        $61394014a6be57c7$export$b3252c0e7f5dbc3f(t, $61394014a6be57c7$var$p({}, o, {
            axis: l ? "x" : "y",
            x: "right" === e ? r : 0,
            y: "bottom" === e ? a : 0,
            scale: c,
            format: d,
            length: l ? r : a,
            ticksPosition: s,
            theme: f
        }));
    });
}, $61394014a6be57c7$export$5eea7e798580e5d1 = function(t, e) {
    var i = e.width, n = e.height, r = e.scale, a = e.axis, o = e.values;
    $61394014a6be57c7$var$T({
        width: i,
        height: n,
        scale: r,
        axis: a,
        values: o
    }).forEach(function(e) {
        t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
    });
};





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $f7f65d32f1ac0162$exports = {};

var $7734a7a282e2319a$exports = {};

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7734a7a282e2319a$var$baseFilter(collection, predicate) {
    var result = [];
    $7ebb68e7a3797e10$exports(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
$7734a7a282e2319a$exports = $7734a7a282e2319a$var$baseFilter;




/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $f7f65d32f1ac0162$var$filter(collection, predicate) {
    var func = $579b9ba2588bb9de$exports(collection) ? $d53366b2ff590363$exports : $7734a7a282e2319a$exports;
    return func(collection, $bf70b66c162aef31$exports(predicate, 3));
}
$f7f65d32f1ac0162$exports = $f7f65d32f1ac0162$var$filter;


var $e41840ebc3ba4945$exports = {};


/** `Object#toString` result references. */ var $e41840ebc3ba4945$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $e41840ebc3ba4945$var$isNumber(value) {
    return typeof value == "number" || $97dbbc1a069ce16a$exports(value) && $ae3fe6c5950c122e$exports(value) == $e41840ebc3ba4945$var$numberTag;
}
$e41840ebc3ba4945$exports = $e41840ebc3ba4945$var$isNumber;


var $5d7b9877f2cb2dac$exports = {};


var $ee23a7636d1cfd0c$exports = {};


var $40a1a8c335eb5e09$exports = {};

var $0372dacbc03388e3$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $0372dacbc03388e3$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$0372dacbc03388e3$exports = $0372dacbc03388e3$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $40a1a8c335eb5e09$var$parent(object, path) {
    return path.length < 2 ? object : $e913f1fcbff7147e$exports(object, $0372dacbc03388e3$exports(path, 0, -1));
}
$40a1a8c335eb5e09$exports = $40a1a8c335eb5e09$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $ee23a7636d1cfd0c$var$baseUnset(object, path) {
    path = $23e5d07d36d464f0$exports(path, object);
    object = $40a1a8c335eb5e09$exports(object, path);
    return object == null || delete object[$09a75ffd36bdbd18$exports($0af9c5bb33cc0648$exports(path))];
}
$ee23a7636d1cfd0c$exports = $ee23a7636d1cfd0c$var$baseUnset;




var $f7b755a84f5e1f0a$exports = {};

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $f7b755a84f5e1f0a$var$customOmitClone(value) {
    return $46e9524417ce8039$exports(value) ? undefined : value;
}
$f7b755a84f5e1f0a$exports = $f7b755a84f5e1f0a$var$customOmitClone;




/** Used to compose bitmasks for cloning. */ var $5d7b9877f2cb2dac$var$CLONE_DEEP_FLAG = 1, $5d7b9877f2cb2dac$var$CLONE_FLAT_FLAG = 2, $5d7b9877f2cb2dac$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $5d7b9877f2cb2dac$var$omit = $db84991f1e88e6f3$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $4c0f1a1d993f5976$exports(paths, function(path) {
        path = $23e5d07d36d464f0$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $2089e20ff6782bbb$exports(object, $6e54e90bc363339e$exports(object), result);
    if (isDeep) result = $f69c86ceef3a17b2$exports(result, $5d7b9877f2cb2dac$var$CLONE_DEEP_FLAG | $5d7b9877f2cb2dac$var$CLONE_FLAT_FLAG | $5d7b9877f2cb2dac$var$CLONE_SYMBOLS_FLAG, $f7b755a84f5e1f0a$exports);
    var length = paths.length;
    while(length--)$ee23a7636d1cfd0c$exports(result, paths[length]);
    return result;
});
$5d7b9877f2cb2dac$exports = $5d7b9877f2cb2dac$var$omit;





function $f962d83699f3530e$var$g() {
    return $f962d83699f3530e$var$g = Object.assign ? Object.assign.bind() : function(t) {
        for(var n = 1; n < arguments.length; n++){
            var i = arguments[n];
            for(var o in i)Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
        }
        return t;
    }, $f962d83699f3530e$var$g.apply(this, arguments);
}
var $f962d83699f3530e$export$9c21a3269931e1e6 = {
    dotSize: 4,
    noteWidth: 120,
    noteTextOffset: 8,
    animate: !0
}, $f962d83699f3530e$export$b752e15d208daa11 = function(n) {
    var i = typeof n;
    return (0, $7fPBF.isValidElement)(n) || "string" === i || "function" === i || "object" === i;
}, $f962d83699f3530e$export$ec43ae0bd4891d2c = function(t) {
    var n = typeof t;
    return "string" === n || "function" === n;
}, $f962d83699f3530e$export$394411129f5b3217 = function(t) {
    return "circle" === t.type;
}, $f962d83699f3530e$export$42c56693a07b2355 = function(t) {
    return "dot" === t.type;
}, $f962d83699f3530e$export$3d983e5b537acf00 = function(t) {
    return "rect" === t.type;
}, $f962d83699f3530e$export$3fdd15c76e321976 = function(t) {
    var n = t.data, i = t.annotations, e = t.getPosition, r = t.getDimensions;
    return i.reduce(function(t, i) {
        var s = i.offset || 0;
        return [].concat(t, (0, (/*@__PURE__*/$parcel$interopDefault($f7f65d32f1ac0162$exports)))(n, i.match).map(function(t) {
            var n = e(t), o = r(t);
            return ($f962d83699f3530e$export$394411129f5b3217(i) || $f962d83699f3530e$export$3d983e5b537acf00(i)) && (o.size = o.size + 2 * s, o.width = o.width + 2 * s, o.height = o.height + 2 * s), $f962d83699f3530e$var$g({}, (0, (/*@__PURE__*/$parcel$interopDefault($5d7b9877f2cb2dac$exports)))(i, [
                "match",
                "offset"
            ]), n, o, {
                size: i.size || o.size,
                datum: t
            });
        }));
    }, []);
}, $f962d83699f3530e$export$6b6253c1fb6a326 = function(t, n, i, o) {
    var e = Math.atan2(o - n, i - t);
    return (0, $ceac9f6897e0c09e$export$c2f0a4925e526958)((0, $ceac9f6897e0c09e$export$c41dd2a8460d3196)(e));
}, $f962d83699f3530e$export$4268c10ab17f5aad = function(t) {
    var n, i, o = t.x, a = t.y, r = t.noteX, s = t.noteY, h = t.noteWidth, d = void 0 === h ? $f962d83699f3530e$export$9c21a3269931e1e6.noteWidth : h, c = t.noteTextOffset, f = void 0 === c ? $f962d83699f3530e$export$9c21a3269931e1e6.noteTextOffset : c;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e41840ebc3ba4945$exports)))(r)) n = o + r;
    else {
        if (void 0 === r.abs) throw new Error("noteX should be either a number or an object containing an 'abs' property");
        n = r.abs;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e41840ebc3ba4945$exports)))(s)) i = a + s;
    else {
        if (void 0 === s.abs) throw new Error("noteY should be either a number or an object containing an 'abs' property");
        i = s.abs;
    }
    var y = o, x = a, m = $f962d83699f3530e$export$6b6253c1fb6a326(o, a, n, i);
    if ($f962d83699f3530e$export$394411129f5b3217(t)) {
        var p = (0, $ceac9f6897e0c09e$export$2e16b01652730550)((0, $ceac9f6897e0c09e$export$c9fcf1a7df975d78)(m), t.size / 2);
        y += p.x, x += p.y;
    }
    if ($f962d83699f3530e$export$3d983e5b537acf00(t)) {
        var g = Math.round((m + 90) / 45) % 8;
        0 === g && (x -= t.height / 2), 1 === g && (y += t.width / 2, x -= t.height / 2), 2 === g && (y += t.width / 2), 3 === g && (y += t.width / 2, x += t.height / 2), 4 === g && (x += t.height / 2), 5 === g && (y -= t.width / 2, x += t.height / 2), 6 === g && (y -= t.width / 2), 7 === g && (y -= t.width / 2, x -= t.height / 2);
    }
    var W = n, v = n;
    return (m + 90) % 360 > 180 ? (W -= d, v -= d) : v += d, {
        points: [
            [
                y,
                x
            ],
            [
                n,
                i
            ],
            [
                v,
                i
            ]
        ],
        text: [
            W,
            i - f
        ],
        angle: m + 90
    };
}, $f962d83699f3530e$export$ede9be424e8ef89a = function(t) {
    var i = t.data, o = t.annotations, e = t.getPosition, a = t.getDimensions;
    return (0, $7fPBF.useMemo)(function() {
        return $f962d83699f3530e$export$3fdd15c76e321976({
            data: i,
            annotations: o,
            getPosition: e,
            getDimensions: a
        });
    }, [
        i,
        o,
        e,
        a
    ]);
}, $f962d83699f3530e$export$c11be6015db56468 = function(t) {
    var i = t.annotations;
    return (0, $7fPBF.useMemo)(function() {
        return i.map(function(t) {
            return $f962d83699f3530e$var$g({}, t, {
                computed: $f962d83699f3530e$export$4268c10ab17f5aad($f962d83699f3530e$var$g({}, t))
            });
        });
    }, [
        i
    ]);
}, $f962d83699f3530e$export$c1818d27abb74e50 = function(t) {
    return (0, $7fPBF.useMemo)(function() {
        return $f962d83699f3530e$export$4268c10ab17f5aad(t);
    }, [
        t
    ]);
}, $f962d83699f3530e$var$T = function(t) {
    var n = t.datum, o = t.x, e = t.y, r = t.note, s = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), l = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), u = l.animate, c = l.config, k = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x: o,
        y: e,
        config: c,
        immediate: !u
    });
    return "function" == typeof r ? (0, $7fPBF.createElement)(r, {
        x: o,
        y: e,
        datum: n
    }) : (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            s.annotations.text.outlineWidth > 0 && (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                x: k.x,
                y: k.y,
                style: $f962d83699f3530e$var$g({}, s.annotations.text, {
                    strokeLinejoin: "round",
                    strokeWidth: 2 * s.annotations.text.outlineWidth,
                    stroke: s.annotations.text.outlineColor
                }),
                children: r
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                x: k.x,
                y: k.y,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($5d7b9877f2cb2dac$exports)))(s.annotations.text, [
                    "outlineWidth",
                    "outlineColor"
                ]),
                children: r
            })
        ]
    });
}, $f962d83699f3530e$var$E = function(t) {
    var i = t.points, o = t.isOutline, e = void 0 !== o && o, a = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), r = (0, $7fPBF.useMemo)(function() {
        var t = i[0];
        return i.slice(1).reduce(function(t, n) {
            return t + " L" + n[0] + "," + n[1];
        }, "M" + t[0] + "," + t[1]);
    }, [
        i
    ]), s = (0, $ceac9f6897e0c09e$export$6b8391a1442f2172)(r);
    if (e && a.annotations.link.outlineWidth <= 0) return null;
    var l = $f962d83699f3530e$var$g({}, a.annotations.link);
    return e && (l.strokeLinecap = "square", l.strokeWidth = a.annotations.link.strokeWidth + 2 * a.annotations.link.outlineWidth, l.stroke = a.annotations.link.outlineColor, l.opacity = a.annotations.link.outlineOpacity), (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
        fill: "none",
        d: s,
        style: l
    });
}, $f962d83699f3530e$var$I = function(t) {
    var n = t.x, i = t.y, o = t.size, e = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), a = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), r = a.animate, s = a.config, l = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x: n,
        y: i,
        radius: o / 2,
        config: s,
        immediate: !r
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            e.annotations.outline.outlineWidth > 0 && (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).circle, {
                cx: l.x,
                cy: l.y,
                r: l.radius,
                style: $f962d83699f3530e$var$g({}, e.annotations.outline, {
                    fill: "none",
                    strokeWidth: e.annotations.outline.strokeWidth + 2 * e.annotations.outline.outlineWidth,
                    stroke: e.annotations.outline.outlineColor,
                    opacity: e.annotations.outline.outlineOpacity
                })
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).circle, {
                cx: l.x,
                cy: l.y,
                r: l.radius,
                style: e.annotations.outline
            })
        ]
    });
}, $f962d83699f3530e$var$D = function(t) {
    var n = t.x, i = t.y, o = t.size, e = void 0 === o ? $f962d83699f3530e$export$9c21a3269931e1e6.dotSize : o, a = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), r = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), s = r.animate, l = r.config, u = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x: n,
        y: i,
        radius: e / 2,
        config: l,
        immediate: !s
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            a.annotations.outline.outlineWidth > 0 && (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).circle, {
                cx: u.x,
                cy: u.y,
                r: u.radius,
                style: $f962d83699f3530e$var$g({}, a.annotations.outline, {
                    fill: "none",
                    strokeWidth: 2 * a.annotations.outline.outlineWidth,
                    stroke: a.annotations.outline.outlineColor,
                    opacity: a.annotations.outline.outlineOpacity
                })
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).circle, {
                cx: u.x,
                cy: u.y,
                r: u.radius,
                style: a.annotations.symbol
            })
        ]
    });
}, $f962d83699f3530e$var$L = function(t) {
    var n = t.x, i = t.y, o = t.width, e = t.height, a = t.borderRadius, r = void 0 === a ? 6 : a, s = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), l = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), u = l.animate, c = l.config, k = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x: n - o / 2,
        y: i - e / 2,
        width: o,
        height: e,
        config: c,
        immediate: !u
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            s.annotations.outline.outlineWidth > 0 && (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).rect, {
                x: k.x,
                y: k.y,
                rx: r,
                ry: r,
                width: k.width,
                height: k.height,
                style: $f962d83699f3530e$var$g({}, s.annotations.outline, {
                    fill: "none",
                    strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth,
                    stroke: s.annotations.outline.outlineColor,
                    opacity: s.annotations.outline.outlineOpacity
                })
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).rect, {
                x: k.x,
                y: k.y,
                rx: r,
                ry: r,
                width: k.width,
                height: k.height,
                style: s.annotations.outline
            })
        ]
    });
}, $f962d83699f3530e$export$9279461326b8700a = function(t) {
    var n = t.datum, i = t.x, o = t.y, e = t.note, a = $f962d83699f3530e$export$c1818d27abb74e50(t);
    if (!$f962d83699f3530e$export$b752e15d208daa11(e)) throw new Error("note should be a valid react element");
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (0, $824c049f32d4395d$exports.jsx)($f962d83699f3530e$var$E, {
                points: a.points,
                isOutline: !0
            }),
            $f962d83699f3530e$export$394411129f5b3217(t) && (0, $824c049f32d4395d$exports.jsx)($f962d83699f3530e$var$I, {
                x: i,
                y: o,
                size: t.size
            }),
            $f962d83699f3530e$export$42c56693a07b2355(t) && (0, $824c049f32d4395d$exports.jsx)($f962d83699f3530e$var$D, {
                x: i,
                y: o,
                size: t.size
            }),
            $f962d83699f3530e$export$3d983e5b537acf00(t) && (0, $824c049f32d4395d$exports.jsx)($f962d83699f3530e$var$L, {
                x: i,
                y: o,
                width: t.width,
                height: t.height,
                borderRadius: t.borderRadius
            }),
            (0, $824c049f32d4395d$exports.jsx)($f962d83699f3530e$var$E, {
                points: a.points
            }),
            (0, $824c049f32d4395d$exports.jsx)($f962d83699f3530e$var$T, {
                datum: n,
                x: a.text[0],
                y: a.text[1],
                note: e
            })
        ]
    });
}, $f962d83699f3530e$var$q = function(t, n) {
    n.forEach(function(n, i) {
        var o = n[0], e = n[1];
        0 === i ? t.moveTo(o, e) : t.lineTo(o, e);
    });
}, $f962d83699f3530e$export$630dcbe11859bd26 = function(t, n) {
    var i = n.annotations, o = n.theme;
    0 !== i.length && (t.save(), i.forEach(function(n) {
        if (!$f962d83699f3530e$export$ec43ae0bd4891d2c(n.note)) throw new Error("note is invalid for canvas implementation");
        o.annotations.link.outlineWidth > 0 && (t.lineCap = "square", t.strokeStyle = o.annotations.link.outlineColor, t.lineWidth = o.annotations.link.strokeWidth + 2 * o.annotations.link.outlineWidth, t.beginPath(), $f962d83699f3530e$var$q(t, n.computed.points), t.stroke(), t.lineCap = "butt"), $f962d83699f3530e$export$394411129f5b3217(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), $f962d83699f3530e$export$42c56693a07b2355(n) && o.annotations.symbol.outlineWidth > 0 && (t.strokeStyle = o.annotations.symbol.outlineColor, t.lineWidth = 2 * o.annotations.symbol.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), $f962d83699f3530e$export$3d983e5b537acf00(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), t.strokeStyle = o.annotations.link.stroke, t.lineWidth = o.annotations.link.strokeWidth, t.beginPath(), $f962d83699f3530e$var$q(t, n.computed.points), t.stroke(), $f962d83699f3530e$export$394411129f5b3217(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), $f962d83699f3530e$export$42c56693a07b2355(n) && (t.fillStyle = o.annotations.symbol.fill, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.fill()), $f962d83699f3530e$export$3d983e5b537acf00(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), "function" == typeof n.note ? n.note(t, {
            datum: n.datum,
            x: n.computed.text[0],
            y: n.computed.text[1],
            theme: o
        }) : (t.font = o.annotations.text.fontSize + "px " + o.annotations.text.fontFamily, t.textAlign = "left", t.textBaseline = "alphabetic", t.fillStyle = o.annotations.text.fill, t.strokeStyle = o.annotations.text.outlineColor, t.lineWidth = 2 * o.annotations.text.outlineWidth, o.annotations.text.outlineWidth > 0 && (t.lineJoin = "round", t.strokeText(n.note, n.computed.text[0], n.computed.text[1]), t.lineJoin = "miter"), t.fillText(n.note, n.computed.text[0], n.computed.text[1]));
    }), t.restore());
};






function $b506bc0528406ee2$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

function $7e4d486495f0c321$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}


var $735985f4e3791a92$export$2e2bcd8739ae039 = (0, $bb016a9f292c1741$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");



var $7fPBF = parcelRequire("7fPBF");



var $lCLl1 = parcelRequire("lCLl1");

var $2oXYc = parcelRequire("2oXYc");

function $65d5e2c5d94ea978$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $b65d8bb781662799$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}









function $b565366ec99878f9$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $65d5e2c5d94ea978$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $b65d8bb781662799$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $b0ce28d6113463f1$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b565366ec99878f9$export$2e2bcd8739ae039() {
    var scale = (0, $8b8f36a539eb80e5$export$16a5d4b4a61a274d)($b565366ec99878f9$var$transformer()((0, $dd7e4e0e97e8ad6b$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $1e2488e4583916b4$export$784d13d8ee351f07)(scale, $b565366ec99878f9$export$2e2bcd8739ae039());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b565366ec99878f9$export$5f0266a9159c47fb() {
    var scale = (0, $a5d1681d8e40f4e7$export$860836db074028f0)($b565366ec99878f9$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $1e2488e4583916b4$export$784d13d8ee351f07)(scale, $b565366ec99878f9$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b565366ec99878f9$export$50b3da713cf557c6() {
    var scale = (0, $acc2eb21ce565e92$export$4602684e614eba38)($b565366ec99878f9$var$transformer());
    scale.copy = function() {
        return (0, $1e2488e4583916b4$export$784d13d8ee351f07)(scale, $b565366ec99878f9$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b565366ec99878f9$export$d6cedcc63bf26e7e() {
    var scale = (0, $3131db795c4cb389$export$34695211ec403a46)($b565366ec99878f9$var$transformer());
    scale.copy = function() {
        return (0, $1e2488e4583916b4$export$784d13d8ee351f07)(scale, $b565366ec99878f9$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $eaed823ec896ae20$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b565366ec99878f9$export$33ddefb5c4ab9e9c() {
    return $b565366ec99878f9$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}


function $eca4c4327ec3ea7c$var$qe() {
    return $eca4c4327ec3ea7c$var$qe = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $eca4c4327ec3ea7c$var$qe.apply(this, arguments);
}
function $eca4c4327ec3ea7c$var$Ce(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var n = 0, t = new Array(r); n < r; n++)t[n] = e[n];
    return t;
}
function $eca4c4327ec3ea7c$var$Ge(e, r) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (n) return (n = n.call(e)).next.bind(n);
    if (Array.isArray(e) || (n = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $eca4c4327ec3ea7c$var$Ce(e, r);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $eca4c4327ec3ea7c$var$Ce(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        n && (e = n);
        var t = 0;
        return function() {
            return t >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[t++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $eca4c4327ec3ea7c$export$8382cb219651957d = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $9ea3dd4fdadefd0a$export$2e2bcd8739ae039),
    accent: (0, $19d018fb519d54fd$export$2e2bcd8739ae039),
    dark2: (0, $7779d20e0fc477c0$export$2e2bcd8739ae039),
    paired: (0, $34fed29c954f6730$export$2e2bcd8739ae039),
    pastel1: (0, $ef3181ffb4185d42$export$2e2bcd8739ae039),
    pastel2: (0, $786f1d0067ffea6a$export$2e2bcd8739ae039),
    set1: (0, $2f85dc235274390a$export$2e2bcd8739ae039),
    set2: (0, $80f74c9d958fa597$export$2e2bcd8739ae039),
    set3: (0, $7958a448ec490cf3$export$2e2bcd8739ae039),
    tableau10: (0, $735985f4e3791a92$export$2e2bcd8739ae039)
}, $eca4c4327ec3ea7c$export$480d437bf98751ba = Object.keys($eca4c4327ec3ea7c$export$8382cb219651957d), $eca4c4327ec3ea7c$export$b42e9133a3bfc0c2 = {
    brown_blueGreen: (0, $4ca4fb75e5a423d5$export$3005042704f95a69),
    purpleRed_green: (0, $690b3d0fd5c4fa3e$export$3005042704f95a69),
    pink_yellowGreen: (0, $916ef83d77ec7e5c$export$3005042704f95a69),
    purple_orange: (0, $c76084b8a3907b15$export$3005042704f95a69),
    red_blue: (0, $9bc47d279cd4b969$export$3005042704f95a69),
    red_grey: (0, $2d70e60074d77a9b$export$3005042704f95a69),
    red_yellow_blue: (0, $cc0d3e6a75793f0c$export$3005042704f95a69),
    red_yellow_green: (0, $fb00ca5476c43131$export$3005042704f95a69),
    spectral: (0, $7f958806be18ac58$export$3005042704f95a69)
}, $eca4c4327ec3ea7c$export$63357c6d2f7b8781 = Object.keys($eca4c4327ec3ea7c$export$b42e9133a3bfc0c2), $eca4c4327ec3ea7c$export$d9c06f2af83aa27b = {
    brown_blueGreen: (0, $4ca4fb75e5a423d5$export$2e2bcd8739ae039),
    purpleRed_green: (0, $690b3d0fd5c4fa3e$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $916ef83d77ec7e5c$export$2e2bcd8739ae039),
    purple_orange: (0, $c76084b8a3907b15$export$2e2bcd8739ae039),
    red_blue: (0, $9bc47d279cd4b969$export$2e2bcd8739ae039),
    red_grey: (0, $2d70e60074d77a9b$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $cc0d3e6a75793f0c$export$2e2bcd8739ae039),
    red_yellow_green: (0, $fb00ca5476c43131$export$2e2bcd8739ae039),
    spectral: (0, $7f958806be18ac58$export$2e2bcd8739ae039)
}, $eca4c4327ec3ea7c$export$db45d8c654873588 = {
    blues: (0, $f7446b8c7cd79059$export$3005042704f95a69),
    greens: (0, $3a66f9057929a79b$export$3005042704f95a69),
    greys: (0, $f64ce98f053d3c1f$export$3005042704f95a69),
    oranges: (0, $b1f714e4e4b5adf6$export$3005042704f95a69),
    purples: (0, $885c97e4dd2e4422$export$3005042704f95a69),
    reds: (0, $cbf39e6a8bf8c1a3$export$3005042704f95a69),
    blue_green: (0, $a2c8e9b842322913$export$3005042704f95a69),
    blue_purple: (0, $d79efb228ae4624f$export$3005042704f95a69),
    green_blue: (0, $40927aa6b8f77f0f$export$3005042704f95a69),
    orange_red: (0, $03b2383dd0bc50f4$export$3005042704f95a69),
    purple_blue_green: (0, $3888a5c20c404764$export$3005042704f95a69),
    purple_blue: (0, $3949a449725c7bcf$export$3005042704f95a69),
    purple_red: (0, $7bd35661446703e9$export$3005042704f95a69),
    red_purple: (0, $cfe4c086b06bdbca$export$3005042704f95a69),
    yellow_green_blue: (0, $bfa6a20338713c31$export$3005042704f95a69),
    yellow_green: (0, $07bef80147eac796$export$3005042704f95a69),
    yellow_orange_brown: (0, $5c0c674af7fafdec$export$3005042704f95a69),
    yellow_orange_red: (0, $de24445d9010aa31$export$3005042704f95a69)
}, $eca4c4327ec3ea7c$export$6c6944263c7cbb3b = Object.keys($eca4c4327ec3ea7c$export$db45d8c654873588), $eca4c4327ec3ea7c$export$21dd087678fc5202 = {
    blues: (0, $f7446b8c7cd79059$export$2e2bcd8739ae039),
    greens: (0, $3a66f9057929a79b$export$2e2bcd8739ae039),
    greys: (0, $f64ce98f053d3c1f$export$2e2bcd8739ae039),
    oranges: (0, $b1f714e4e4b5adf6$export$2e2bcd8739ae039),
    purples: (0, $885c97e4dd2e4422$export$2e2bcd8739ae039),
    reds: (0, $cbf39e6a8bf8c1a3$export$2e2bcd8739ae039),
    turbo: (0, $7e4d486495f0c321$export$2e2bcd8739ae039),
    viridis: (0, $1cfa41501e7d069c$export$2e2bcd8739ae039),
    inferno: (0, $1cfa41501e7d069c$export$ad0c8285c8ea6dbd),
    magma: (0, $1cfa41501e7d069c$export$c41e69203f572e8d),
    plasma: (0, $1cfa41501e7d069c$export$6664860a633d9daf),
    cividis: (0, $b506bc0528406ee2$export$2e2bcd8739ae039),
    warm: (0, $aa1dc4855b4fb73a$export$fc70efcec537be98),
    cool: (0, $aa1dc4855b4fb73a$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $b98f19dff4332012$export$2e2bcd8739ae039),
    blue_green: (0, $a2c8e9b842322913$export$2e2bcd8739ae039),
    blue_purple: (0, $d79efb228ae4624f$export$2e2bcd8739ae039),
    green_blue: (0, $40927aa6b8f77f0f$export$2e2bcd8739ae039),
    orange_red: (0, $03b2383dd0bc50f4$export$2e2bcd8739ae039),
    purple_blue_green: (0, $3888a5c20c404764$export$2e2bcd8739ae039),
    purple_blue: (0, $3949a449725c7bcf$export$2e2bcd8739ae039),
    purple_red: (0, $7bd35661446703e9$export$2e2bcd8739ae039),
    red_purple: (0, $cfe4c086b06bdbca$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $bfa6a20338713c31$export$2e2bcd8739ae039),
    yellow_green: (0, $07bef80147eac796$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $5c0c674af7fafdec$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $de24445d9010aa31$export$2e2bcd8739ae039)
}, $eca4c4327ec3ea7c$export$2ad73d393c16f81c = $eca4c4327ec3ea7c$var$qe({}, $eca4c4327ec3ea7c$export$8382cb219651957d, $eca4c4327ec3ea7c$export$b42e9133a3bfc0c2, $eca4c4327ec3ea7c$export$db45d8c654873588), $eca4c4327ec3ea7c$export$b48661626a811234 = Object.keys($eca4c4327ec3ea7c$export$2ad73d393c16f81c), $eca4c4327ec3ea7c$export$9f49cca6c7d1dda4 = function(e) {
    return $eca4c4327ec3ea7c$export$480d437bf98751ba.includes(e);
}, $eca4c4327ec3ea7c$export$4d028a51ab424d0b = function(e) {
    return $eca4c4327ec3ea7c$export$63357c6d2f7b8781.includes(e);
}, $eca4c4327ec3ea7c$export$166c33132082d11d = function(e) {
    return $eca4c4327ec3ea7c$export$6c6944263c7cbb3b.includes(e);
}, $eca4c4327ec3ea7c$export$66bec3b8446aaf18 = {
    rainbow: (0, $aa1dc4855b4fb73a$export$2e2bcd8739ae039),
    sinebow: (0, $45301daac27a7a0d$export$2e2bcd8739ae039)
}, $eca4c4327ec3ea7c$export$6638ab0298ebe095 = $eca4c4327ec3ea7c$var$qe({}, $eca4c4327ec3ea7c$export$d9c06f2af83aa27b, $eca4c4327ec3ea7c$export$21dd087678fc5202, $eca4c4327ec3ea7c$export$66bec3b8446aaf18), $eca4c4327ec3ea7c$export$277274330ffd2780 = Object.keys($eca4c4327ec3ea7c$export$6638ab0298ebe095), $eca4c4327ec3ea7c$export$acb96d3092c0904 = function(e, r) {
    if ("function" == typeof e) return e;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.theme;
        }(e)) {
            if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
            var n = (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e.theme);
            if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
            return function() {
                return n;
            };
        }
        if (function(e) {
            return void 0 !== e.from;
        }(e)) {
            var t = function(r) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e.from);
            };
            if (Array.isArray(e.modifiers)) {
                for(var o, i = [], u = function() {
                    var e = o.value, r = e[0], n = e[1];
                    if ("brighter" === r) i.push(function(e) {
                        return e.brighter(n);
                    });
                    else if ("darker" === r) i.push(function(e) {
                        return e.darker(n);
                    });
                    else {
                        if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                        i.push(function(e) {
                            return e.opacity = n, e;
                        });
                    }
                }, a = $eca4c4327ec3ea7c$var$Ge(e.modifiers); !(o = a()).done;)u();
                return 0 === i.length ? t : function(e) {
                    return i.reduce(function(e, r) {
                        return r(e);
                    }, (0, $lCLl1.rgb)(t(e))).toString();
                };
            }
            return t;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return e;
    };
}, $eca4c4327ec3ea7c$export$2a9e363116151414 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $eca4c4327ec3ea7c$export$acb96d3092c0904(e, r);
    }, [
        e,
        r
    ]);
}, $eca4c4327ec3ea7c$export$5f5a386483e6fff5 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        from: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array)
    })
]), $eca4c4327ec3ea7c$export$30c0b047d59c1130 = {
    scheme: "turbo"
}, $eca4c4327ec3ea7c$export$3c410d9d0181bae0 = function(e, r) {
    var n = e.minValue, t = e.maxValue, o = void 0 !== n ? n : r.min, i = void 0 !== t ? t : r.max, u = (0, $1e2488e4583916b4$export$2e2bcd8739ae039)().domain([
        o,
        i
    ]).clamp(!0);
    if ("colors" in e) u.range(e.colors);
    else if ("interpolator" in e) u.interpolator(e.interpolator);
    else {
        var a, l = null != (a = e.scheme) ? a : $eca4c4327ec3ea7c$export$30c0b047d59c1130.scheme;
        u.interpolator($eca4c4327ec3ea7c$export$6638ab0298ebe095[l]);
    }
    return u;
}, $eca4c4327ec3ea7c$export$13bad8adfa9d5e5 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $eca4c4327ec3ea7c$export$3c410d9d0181bae0(e, r);
    }, [
        e,
        r
    ]);
}, $eca4c4327ec3ea7c$export$83a83df24724477a = {
    scheme: "red_yellow_blue",
    divergeAt: .5
}, $eca4c4327ec3ea7c$export$d2925809ff5420bc = function(e, r) {
    var n, t = e.minValue, o = e.maxValue, i = void 0 !== t ? t : r.min, u = void 0 !== o ? o : r.max, a = [
        i,
        i + (u - i) / 2,
        u
    ], l = .5 - (null != (n = e.divergeAt) ? n : $eca4c4327ec3ea7c$export$83a83df24724477a.divergeAt), c = (0, $b565366ec99878f9$export$2e2bcd8739ae039)().domain(a).clamp(!0), s = function(e) {
        return String(e);
    };
    if ("colors" in e) s = (0, $b565366ec99878f9$export$2e2bcd8739ae039)().domain(a.map(function(e) {
        return e - l * (u - i);
    })).range(e.colors).interpolator();
    else if ("interpolator" in e) s = e.interpolator;
    else {
        var f, p = null != (f = e.scheme) ? f : $eca4c4327ec3ea7c$export$83a83df24724477a.scheme;
        s = $eca4c4327ec3ea7c$export$6638ab0298ebe095[p];
    }
    return c.interpolator(function(e) {
        return s(e + l);
    });
}, $eca4c4327ec3ea7c$export$92d4d3b6e140b0d1 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $eca4c4327ec3ea7c$export$d2925809ff5420bc(e, r);
    }, [
        e,
        r
    ]);
}, $eca4c4327ec3ea7c$export$19b16327818185cf = {
    scheme: "turbo",
    steps: 7
}, $eca4c4327ec3ea7c$export$8442947f078400fb = function(e, r) {
    var n = (0, $701754d8f18cf864$export$2e2bcd8739ae039)().domain(e.domain || [
        r.min,
        r.max
    ]).nice();
    if ("colors" in e) n.range(e.colors);
    else {
        var t = e.scheme || $eca4c4327ec3ea7c$export$19b16327818185cf.scheme, o = void 0 === e.steps ? $eca4c4327ec3ea7c$export$19b16327818185cf.steps : e.steps, i = $eca4c4327ec3ea7c$export$6638ab0298ebe095[t], u = Array.from({
            length: o
        }).map(function(e, r) {
            return i(r * (1 / (o - 1)));
        });
        n.range(u);
    }
    return n;
}, $eca4c4327ec3ea7c$export$aeb5c6e1cabe7efa = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $eca4c4327ec3ea7c$export$8442947f078400fb(e, r);
    }, [
        e,
        r
    ]);
}, $eca4c4327ec3ea7c$export$351e3420d10d6780 = function(e, r) {
    if (function(e) {
        return "sequential" === e.type;
    }(e)) return $eca4c4327ec3ea7c$export$3c410d9d0181bae0(e, r);
    if (function(e) {
        return "diverging" === e.type;
    }(e)) return $eca4c4327ec3ea7c$export$d2925809ff5420bc(e, r);
    if (function(e) {
        return "quantize" === e.type;
    }(e)) return $eca4c4327ec3ea7c$export$8442947f078400fb(e, r);
    throw new Error("Invalid continuous color scale config");
}, $eca4c4327ec3ea7c$export$4796b471538d60f8 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $eca4c4327ec3ea7c$export$351e3420d10d6780(e, r);
    }, [
        e,
        r
    ]);
}, $eca4c4327ec3ea7c$export$f6ca0f82846310a7 = function(e, r) {
    void 0 === r && (r = 16);
    var n = e.domain();
    if ("thresholds" in e) {
        var t = [], o = (0, $8b8f36a539eb80e5$export$2e2bcd8739ae039)().domain(n).range([
            0,
            1
        ]);
        return e.range().forEach(function(r, n) {
            var i = e.invertExtent(r), u = i[0], a = i[1];
            t.push({
                key: n + ".0",
                offset: o(u),
                stopColor: r
            }), t.push({
                key: n + ".1",
                offset: o(a),
                stopColor: r
            });
        }), t;
    }
    var i = e.copy();
    return 2 === n.length ? i.domain([
        0,
        1
    ]) : 3 === n.length && i.domain([
        0,
        .5,
        1
    ]), i.ticks(r).map(function(e) {
        return {
            key: "" + e,
            offset: e,
            stopColor: "" + i(e)
        };
    });
}, $eca4c4327ec3ea7c$export$c3ea10dbbf6bbab3 = function(e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(e, r);
    };
    if (Array.isArray(e)) {
        var t = (0, $0ae5395125647844$export$2e2bcd8739ae039)(e), o = function(e) {
            return t(n(e));
        };
        return o.scale = t, o;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($46e9524417ce8039$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.datum;
        }(e)) return function(r) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($f7bfd9e73571977c$exports)))(r, e.datum);
        };
        if (function(e) {
            return void 0 !== e.scheme;
        }(e)) {
            if ($eca4c4327ec3ea7c$export$9f49cca6c7d1dda4(e.scheme)) {
                var i = (0, $0ae5395125647844$export$2e2bcd8739ae039)($eca4c4327ec3ea7c$export$2ad73d393c16f81c[e.scheme]), u = function(e) {
                    return i(n(e));
                };
                return u.scale = i, u;
            }
            if ($eca4c4327ec3ea7c$export$4d028a51ab424d0b(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
                var a = (0, $0ae5395125647844$export$2e2bcd8739ae039)($eca4c4327ec3ea7c$export$2ad73d393c16f81c[e.scheme][e.size || 11]), l = function(e) {
                    return a(n(e));
                };
                return l.scale = a, l;
            }
            if ($eca4c4327ec3ea7c$export$166c33132082d11d(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
                var c = (0, $0ae5395125647844$export$2e2bcd8739ae039)($eca4c4327ec3ea7c$export$2ad73d393c16f81c[e.scheme][e.size || 9]), s = function(e) {
                    return c(n(e));
                };
                return s.scale = c, s;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return e;
    };
}, $eca4c4327ec3ea7c$export$47939777be1516f5 = function(e, r) {
    return (0, $7fPBF.useMemo)(function() {
        return $eca4c4327ec3ea7c$export$c3ea10dbbf6bbab3(e, r);
    }, [
        e,
        r
    ]);
};



var $7fPBF = parcelRequire("7fPBF");
var $06815ec2120bfaa3$export$15925baccc9f07fd = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("circle", {
        r: o / 2,
        cx: i + o / 2,
        cy: n + o / 2,
        fill: r,
        opacity: a,
        strokeWidth: d,
        stroke: void 0 === s ? "transparent" : s,
        style: {
            pointerEvents: "none"
        }
    });
}, $06815ec2120bfaa3$export$b7efc3c73c701547 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
            fill: r,
            opacity: a,
            strokeWidth: d,
            stroke: void 0 === s ? "transparent" : s,
            style: {
                pointerEvents: "none"
            }
        })
    });
}, $06815ec2120bfaa3$export$2a536501e4a376d8 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("rect", {
        x: i,
        y: n,
        fill: r,
        opacity: a,
        strokeWidth: d,
        stroke: void 0 === s ? "transparent" : s,
        width: o,
        height: o,
        style: {
            pointerEvents: "none"
        }
    });
}, $06815ec2120bfaa3$export$57cb77afe634ca82 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
            fill: r,
            opacity: a,
            strokeWidth: d,
            stroke: void 0 === s ? "transparent" : s,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
function $06815ec2120bfaa3$var$p() {
    return $06815ec2120bfaa3$var$p = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $06815ec2120bfaa3$var$p.apply(this, arguments);
}
var $06815ec2120bfaa3$export$7dcc0eed76218746 = {
    length: 200,
    thickness: 16,
    direction: "row",
    tickPosition: "after",
    tickSize: 4,
    tickSpacing: 3,
    tickOverlap: !1,
    tickFormat: function(t) {
        return "" + t;
    },
    titleAlign: "start",
    titleOffset: 4
}, $06815ec2120bfaa3$var$k = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $06815ec2120bfaa3$export$158851e184613239 = function(t) {
    var e, i = t.direction, n = t.itemsSpacing, o = t.padding, r = t.itemCount, l = t.itemWidth, a = t.itemHeight;
    if ("number" != typeof o && ("object" != typeof (e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
    } : $06815ec2120bfaa3$var$p({}, $06815ec2120bfaa3$var$k, o), d = c.left + c.right, s = c.top + c.bottom, h = l + d, g = a + s, f = (r - 1) * n;
    return "row" === i ? h = l * r + f + d : "column" === i && (g = a * r + f + s), {
        width: h,
        height: g,
        padding: c
    };
}, $06815ec2120bfaa3$export$d54b250266589d82 = function(t) {
    var e = t.anchor, i = t.translateX, n = t.translateY, o = t.containerWidth, r = t.containerHeight, l = t.width, a = t.height, c = i, d = n;
    switch(e){
        case "top":
            c += (o - l) / 2;
            break;
        case "top-right":
            c += o - l;
            break;
        case "right":
            c += o - l, d += (r - a) / 2;
            break;
        case "bottom-right":
            c += o - l, d += r - a;
            break;
        case "bottom":
            c += (o - l) / 2, d += r - a;
            break;
        case "bottom-left":
            d += r - a;
            break;
        case "left":
            d += (r - a) / 2;
            break;
        case "center":
            c += (o - l) / 2, d += (r - a) / 2;
    }
    return {
        x: c,
        y: d
    };
}, $06815ec2120bfaa3$export$42c02dc685323e86 = function(t) {
    var e, i, n, o, r, l, a = t.direction, c = t.justify, d = t.symbolSize, s = t.symbolSpacing, h = t.width, g = t.height;
    switch(a){
        case "left-to-right":
            e = 0, i = (g - d) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = d + s, r = "start");
            break;
        case "right-to-left":
            e = h - d, i = (g - d) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - d - s, r = "end");
            break;
        case "top-to-bottom":
            e = (h - d) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = d + s, l = "text-before-edge");
            break;
        case "bottom-to-top":
            e = (h - d) / 2, i = g - d, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - d - s, l = "alphabetic");
    }
    return {
        symbolX: e,
        symbolY: i,
        labelX: n,
        labelY: o,
        labelAnchor: r,
        labelAlignment: l
    };
}, $06815ec2120bfaa3$export$92bd5bd2fa4d30f9 = function(t) {
    var e, o = t.scale, r = t.ticks, l = t.length, c = void 0 === l ? $06815ec2120bfaa3$export$7dcc0eed76218746.length : l, d = t.thickness, s = void 0 === d ? $06815ec2120bfaa3$export$7dcc0eed76218746.thickness : d, h = t.direction, g = void 0 === h ? $06815ec2120bfaa3$export$7dcc0eed76218746.direction : h, f = t.tickPosition, m = void 0 === f ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickPosition : f, v = t.tickSize, u = void 0 === v ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickSize : v, p = t.tickSpacing, k = void 0 === p ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickSpacing : p, x = t.tickOverlap, b = void 0 === x ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickOverlap : x, S = t.tickFormat, A = void 0 === S ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickFormat : S, W = t.title, z = t.titleAlign, C = void 0 === z ? $06815ec2120bfaa3$export$7dcc0eed76218746.titleAlign : z, w = t.titleOffset, X = void 0 === w ? $06815ec2120bfaa3$export$7dcc0eed76218746.titleOffset : w, Y = "column" === g ? [].concat(o.domain()).reverse() : o.domain(), O = (0, $8b8f36a539eb80e5$export$2e2bcd8739ae039)().domain(Y);
    2 === Y.length ? O.range([
        0,
        c
    ]) : 3 === Y.length && O.range([
        0,
        c / 2,
        c
    ]), e = "thresholds" in o ? [
        Y[0]
    ].concat(o.thresholds(), [
        Y[1]
    ]) : Array.isArray(r) ? r : o.ticks(r);
    var B, H, E, j, L, M, F = (0, $eca4c4327ec3ea7c$export$f6ca0f82846310a7)(o, 32), T = (0, $ceac9f6897e0c09e$export$f037bf6aad5a4e75)(A), P = [], V = 0, R = 0;
    if ("row" === g) {
        var D, q, G;
        B = c, H = s, R = 1;
        var I;
        L = 0, E = "start" === C ? 0 : "middle" === C ? c / 2 : c, "before" === m ? (D = -u, q = b ? s : 0, G = -u - k, I = "alphabetic", j = s + X, M = "hanging") : (D = b ? 0 : s, G = (q = s + u) + k, I = "hanging", j = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            P.push({
                x1: e,
                y1: D,
                x2: e,
                y2: q,
                text: T(t),
                textX: e,
                textY: G,
                textHorizontalAlign: "middle",
                textVerticalAlign: I
            });
        });
    } else {
        var N, _, J, K;
        B = s, H = c, V = 1;
        L = -90, j = "start" === C ? c : "middle" === C ? c / 2 : 0, "before" === m ? (_ = b ? s : 0, J = (N = -u) - k, K = "end", E = s + X, M = "hanging") : (N = b ? 0 : s, J = (_ = s + u) + k, K = "start", E = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            P.push({
                x1: N,
                y1: e,
                x2: _,
                y2: e,
                text: T(t),
                textX: J,
                textY: e,
                textHorizontalAlign: K,
                textVerticalAlign: "central"
            });
        });
    }
    return {
        width: B,
        height: H,
        gradientX1: 0,
        gradientY1: V,
        gradientX2: R,
        gradientY2: 0,
        colorStops: F,
        ticks: P,
        titleText: W,
        titleX: E,
        titleY: j,
        titleRotation: L,
        titleHorizontalAlign: C,
        titleVerticalAlign: M
    };
}, $06815ec2120bfaa3$export$75a7f8b459abeba9 = function(i) {
    var n = i.scale, r = i.ticks, l = i.length, a = void 0 === l ? $06815ec2120bfaa3$export$7dcc0eed76218746.length : l, c = i.thickness, s = void 0 === c ? $06815ec2120bfaa3$export$7dcc0eed76218746.thickness : c, h = i.direction, g = void 0 === h ? $06815ec2120bfaa3$export$7dcc0eed76218746.direction : h, f = i.tickPosition, m = void 0 === f ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickPosition : f, v = i.tickSize, u = void 0 === v ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickSize : v, k = i.tickSpacing, x = void 0 === k ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickSpacing : k, b = i.tickOverlap, S = void 0 === b ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickOverlap : b, W = i.tickFormat, z = void 0 === W ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickFormat : W, C = i.title, w = i.titleAlign, X = void 0 === w ? $06815ec2120bfaa3$export$7dcc0eed76218746.titleAlign : w, Y = i.titleOffset, O = $06815ec2120bfaa3$export$92bd5bd2fa4d30f9({
        scale: n,
        ticks: r,
        length: a,
        thickness: s,
        direction: g,
        tickPosition: m,
        tickSize: u,
        tickSpacing: x,
        tickOverlap: S,
        tickFormat: z,
        title: C,
        titleAlign: X,
        titleOffset: void 0 === Y ? $06815ec2120bfaa3$export$7dcc0eed76218746.titleOffset : Y
    }), B = O.width, H = O.height, E = O.gradientX1, j = O.gradientY1, L = O.gradientX2, M = O.gradientY2, F = O.ticks, T = O.colorStops, P = O.titleText, V = O.titleX, R = O.titleY, D = O.titleRotation, q = O.titleVerticalAlign, G = O.titleHorizontalAlign, I = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), N = "ContinuousColorsLegendSvgGradient." + g + "." + T.map(function(t) {
        return t.offset;
    }).join("_");
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        children: [
            (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                    id: N,
                    x1: E,
                    y1: j,
                    x2: L,
                    y2: M,
                    children: T.map(function(e) {
                        return (0, $824c049f32d4395d$exports.jsx)("stop", $06815ec2120bfaa3$var$p({}, e));
                    })
                })
            }),
            P && (0, $824c049f32d4395d$exports.jsx)("text", {
                transform: "translate(" + V + ", " + R + ") rotate(" + D + ")",
                textAnchor: G,
                dominantBaseline: q,
                style: I.legends.title.text,
                children: P
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: B,
                height: H,
                fill: "url(#" + N
            }),
            F.map(function(i, n) {
                return (0, $824c049f32d4395d$exports.jsxs)((0, $7fPBF.Fragment), {
                    children: [
                        (0, $824c049f32d4395d$exports.jsx)("line", {
                            x1: i.x1,
                            y1: i.y1,
                            x2: i.x2,
                            y2: i.y2,
                            style: I.legends.ticks.line
                        }),
                        (0, $824c049f32d4395d$exports.jsx)("text", {
                            x: i.textX,
                            y: i.textY,
                            textAnchor: i.textHorizontalAlign,
                            dominantBaseline: i.textVerticalAlign,
                            style: I.legends.ticks.text,
                            children: i.text
                        })
                    ]
                }, n);
            })
        ]
    });
}, $06815ec2120bfaa3$var$z = [
    "containerWidth",
    "containerHeight",
    "anchor",
    "translateX",
    "translateY",
    "length",
    "thickness",
    "direction"
], $06815ec2120bfaa3$export$b3a69bafe074dddd = function(e) {
    var i, n, o = e.containerWidth, r = e.containerHeight, l = e.anchor, a = e.translateX, c = void 0 === a ? 0 : a, d = e.translateY, s = void 0 === d ? 0 : d, h = e.length, g = void 0 === h ? $06815ec2120bfaa3$export$7dcc0eed76218746.length : h, f = e.thickness, m = void 0 === f ? $06815ec2120bfaa3$export$7dcc0eed76218746.thickness : f, v = e.direction, u = void 0 === v ? $06815ec2120bfaa3$export$7dcc0eed76218746.direction : v, k = function(t, e) {
        if (null == t) return {};
        var i, n, o = {}, r = Object.keys(t);
        for(n = 0; n < r.length; n++)i = r[n], e.indexOf(i) >= 0 || (o[i] = t[i]);
        return o;
    }(e, $06815ec2120bfaa3$var$z);
    "row" === u ? (i = g, n = m) : (i = m, n = g);
    var x = $06815ec2120bfaa3$export$d54b250266589d82({
        anchor: l,
        translateX: c,
        translateY: s,
        containerWidth: o,
        containerHeight: r,
        width: i,
        height: n
    }), S = x.x, A = x.y;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + S + ", " + A + ")",
        children: (0, $824c049f32d4395d$exports.jsx)($06815ec2120bfaa3$export$75a7f8b459abeba9, $06815ec2120bfaa3$var$p({
            length: g,
            thickness: m,
            direction: u
        }, k))
    });
}, $06815ec2120bfaa3$var$w = {
    circle: $06815ec2120bfaa3$export$15925baccc9f07fd,
    diamond: $06815ec2120bfaa3$export$b7efc3c73c701547,
    square: $06815ec2120bfaa3$export$2a536501e4a376d8,
    triangle: $06815ec2120bfaa3$export$57cb77afe634ca82
}, $06815ec2120bfaa3$export$cfc3a318dc419256 = function(i) {
    var n, l, a, d, g, f, m, v, u, y, k, x = i.x, b = i.y, A = i.width, W = i.height, z = i.data, C = i.direction, X = void 0 === C ? "left-to-right" : C, Y = i.justify, O = void 0 !== Y && Y, B = i.textColor, H = i.background, E = void 0 === H ? "transparent" : H, j = i.opacity, L = void 0 === j ? 1 : j, M = i.symbolShape, F = void 0 === M ? "square" : M, T = i.symbolSize, P = void 0 === T ? 16 : T, V = i.symbolSpacing, R = void 0 === V ? 8 : V, D = i.symbolBorderWidth, q = void 0 === D ? 0 : D, G = i.symbolBorderColor, I = void 0 === G ? "transparent" : G, N = i.onClick, _ = i.onMouseEnter, J = i.onMouseLeave, K = i.toggleSerie, Q = i.effects, U = (0, $7fPBF.useState)({}), Z = U[0], $ = U[1], tt = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), et = (0, $7fPBF.useCallback)(function(t) {
        if (Q) {
            var e = Q.filter(function(t) {
                return "hover" === t.on;
            }).reduce(function(t, e) {
                return $06815ec2120bfaa3$var$p({}, t, e.style);
            }, {});
            $(e);
        }
        null == _ || _(z, t);
    }, [
        _,
        z,
        Q
    ]), it = (0, $7fPBF.useCallback)(function(t) {
        if (Q) {
            var e = Q.filter(function(t) {
                return "hover" !== t.on;
            }).reduce(function(t, e) {
                return $06815ec2120bfaa3$var$p({}, t, e.style);
            }, {});
            $(e);
        }
        null == J || J(z, t);
    }, [
        J,
        z,
        Q
    ]), nt = $06815ec2120bfaa3$export$42c02dc685323e86({
        direction: X,
        justify: O,
        symbolSize: null != (n = Z.symbolSize) ? n : P,
        symbolSpacing: R,
        width: A,
        height: W
    }), ot = nt.symbolX, rt = nt.symbolY, lt = nt.labelX, at = nt.labelY, ct = nt.labelAnchor, dt = nt.labelAlignment, st = [
        N,
        _,
        J,
        K
    ].some(function(t) {
        return void 0 !== t;
    }), ht = "function" == typeof F ? F : $06815ec2120bfaa3$var$w[F];
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        transform: "translate(" + x + "," + b + ")",
        style: {
            opacity: null != (l = Z.itemOpacity) ? l : L
        },
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: A,
                height: W,
                fill: null != (a = Z.itemBackground) ? a : E,
                style: {
                    cursor: st ? "pointer" : "auto"
                },
                onClick: function(t) {
                    null == N || N(z, t), null == K || K(z.id);
                },
                onMouseEnter: et,
                onMouseLeave: it
            }),
            $7fPBF.createElement(ht, $06815ec2120bfaa3$var$p({
                id: z.id,
                x: ot,
                y: rt,
                size: null != (d = Z.symbolSize) ? d : P,
                fill: null != (g = null != (f = z.fill) ? f : z.color) ? g : "black",
                borderWidth: null != (m = Z.symbolBorderWidth) ? m : q,
                borderColor: null != (v = Z.symbolBorderColor) ? v : I
            }, z.hidden ? tt.legends.hidden.symbol : void 0)),
            (0, $824c049f32d4395d$exports.jsx)("text", {
                textAnchor: ct,
                style: $06815ec2120bfaa3$var$p({}, (0, $ceac9f6897e0c09e$export$c30625df7c8afdb5)(tt.legends.text), {
                    fill: null != (u = null != (y = null != (k = Z.itemTextColor) ? k : B) ? y : tt.legends.text.fill) ? u : "black",
                    dominantBaseline: dt,
                    pointerEvents: "none",
                    userSelect: "none"
                }, z.hidden ? tt.legends.hidden.text : void 0),
                x: lt,
                y: at,
                children: z.label
            })
        ]
    });
}, $06815ec2120bfaa3$export$31ce35324c7aa71 = function(e) {
    var i = e.data, n = e.x, o = e.y, r = e.direction, l = e.padding, a = void 0 === l ? 0 : l, c = e.justify, d = e.effects, s = e.itemWidth, h = e.itemHeight, g = e.itemDirection, f = void 0 === g ? "left-to-right" : g, m = e.itemsSpacing, v = void 0 === m ? 0 : m, u = e.itemTextColor, p = e.itemBackground, y = void 0 === p ? "transparent" : p, k = e.itemOpacity, b = void 0 === k ? 1 : k, S = e.symbolShape, A = e.symbolSize, W = e.symbolSpacing, z = e.symbolBorderWidth, C = e.symbolBorderColor, w = e.onClick, Y = e.onMouseEnter, O = e.onMouseLeave, B = e.toggleSerie, H = $06815ec2120bfaa3$export$158851e184613239({
        itemCount: i.length,
        itemWidth: s,
        itemHeight: h,
        itemsSpacing: v,
        direction: r,
        padding: a
    }).padding, E = "row" === r ? s + v : 0, j = "column" === r ? h + v : 0;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + n + "," + o + ")",
        children: i.map(function(e, i) {
            return (0, $824c049f32d4395d$exports.jsx)($06815ec2120bfaa3$export$cfc3a318dc419256, {
                data: e,
                x: i * E + H.left,
                y: i * j + H.top,
                width: s,
                height: h,
                direction: f,
                justify: c,
                effects: d,
                textColor: u,
                background: y,
                opacity: b,
                symbolShape: S,
                symbolSize: A,
                symbolSpacing: W,
                symbolBorderWidth: z,
                symbolBorderColor: C,
                onClick: w,
                onMouseEnter: Y,
                onMouseLeave: O,
                toggleSerie: B
            }, i);
        })
    });
}, $06815ec2120bfaa3$export$238a2f791d4948f7 = function(e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, d = e.anchor, s = e.direction, h = e.padding, g = void 0 === h ? 0 : h, f = e.justify, m = e.itemsSpacing, v = void 0 === m ? 0 : m, u = e.itemWidth, p = e.itemHeight, y = e.itemDirection, k = e.itemTextColor, S = e.itemBackground, A = e.itemOpacity, W = e.symbolShape, z = e.symbolSize, C = e.symbolSpacing, w = e.symbolBorderWidth, X = e.symbolBorderColor, O = e.onClick, B = e.onMouseEnter, H = e.onMouseLeave, E = e.toggleSerie, j = e.effects, L = $06815ec2120bfaa3$export$158851e184613239({
        itemCount: i.length,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        direction: s,
        padding: g
    }), M = L.width, F = L.height, T = $06815ec2120bfaa3$export$d54b250266589d82({
        anchor: d,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: M,
        height: F
    }), P = T.x, V = T.y;
    return (0, $824c049f32d4395d$exports.jsx)($06815ec2120bfaa3$export$31ce35324c7aa71, {
        data: i,
        x: P,
        y: V,
        direction: s,
        padding: g,
        justify: f,
        effects: j,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        itemDirection: y,
        itemTextColor: k,
        itemBackground: S,
        itemOpacity: A,
        symbolShape: W,
        symbolSize: z,
        symbolSpacing: C,
        symbolBorderWidth: w,
        symbolBorderColor: X,
        onClick: O,
        onMouseEnter: B,
        onMouseLeave: H,
        toggleSerie: "boolean" == typeof E ? void 0 : E
    });
}, $06815ec2120bfaa3$var$B = {
    start: "left",
    middle: "center",
    end: "right"
}, $06815ec2120bfaa3$export$28c0156604402604 = function(t, e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, d = e.anchor, s = e.direction, h = e.padding, g = void 0 === h ? 0 : h, f = e.justify, m = void 0 !== f && f, v = e.itemsSpacing, u = void 0 === v ? 0 : v, p = e.itemWidth, y = e.itemHeight, k = e.itemDirection, A = void 0 === k ? "left-to-right" : k, W = e.itemTextColor, z = e.symbolSize, C = void 0 === z ? 16 : z, w = e.symbolSpacing, X = void 0 === w ? 8 : w, Y = e.theme, O = $06815ec2120bfaa3$export$158851e184613239({
        itemCount: i.length,
        itemWidth: p,
        itemHeight: y,
        itemsSpacing: u,
        direction: s,
        padding: g
    }), H = O.width, E = O.height, j = O.padding, L = $06815ec2120bfaa3$export$d54b250266589d82({
        anchor: d,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: H,
        height: E
    }), M = L.x, F = L.y, T = "row" === s ? p + u : 0, P = "column" === s ? y + u : 0;
    t.save(), t.translate(M, F), t.font = Y.legends.text.fontSize + "px " + (Y.legends.text.fontFamily || "sans-serif"), i.forEach(function(e, i) {
        var n, o, r = i * T + j.left, l = i * P + j.top, a = $06815ec2120bfaa3$export$42c02dc685323e86({
            direction: A,
            justify: m,
            symbolSize: C,
            symbolSpacing: X,
            width: p,
            height: y
        }), c = a.symbolX, d = a.symbolY, s = a.labelX, h = a.labelY, g = a.labelAnchor, f = a.labelAlignment;
        t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(r + c, l + d, C, C), t.textAlign = $06815ec2120bfaa3$var$B[g], "central" === f && (t.textBaseline = "middle"), t.fillStyle = null != (o = null != W ? W : Y.legends.text.fill) ? o : "black", t.fillText(String(e.label), r + s, l + h);
    }), t.restore();
}, $06815ec2120bfaa3$export$d0f8bf7e3d86bbb5 = function(t, e) {
    var i = e.containerWidth, n = e.containerHeight, o = e.anchor, r = e.translateX, a = void 0 === r ? 0 : r, c = e.translateY, d = void 0 === c ? 0 : c, s = e.scale, h = e.length, g = void 0 === h ? $06815ec2120bfaa3$export$7dcc0eed76218746.length : h, f = e.thickness, m = void 0 === f ? $06815ec2120bfaa3$export$7dcc0eed76218746.thickness : f, v = e.direction, u = void 0 === v ? $06815ec2120bfaa3$export$7dcc0eed76218746.direction : v, p = e.ticks, k = e.tickPosition, x = void 0 === k ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickPosition : k, S = e.tickSize, W = void 0 === S ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickSize : S, z = e.tickSpacing, C = void 0 === z ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickSpacing : z, w = e.tickOverlap, X = void 0 === w ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickOverlap : w, Y = e.tickFormat, O = void 0 === Y ? $06815ec2120bfaa3$export$7dcc0eed76218746.tickFormat : Y, B = e.title, H = e.titleAlign, E = void 0 === H ? $06815ec2120bfaa3$export$7dcc0eed76218746.titleAlign : H, j = e.titleOffset, L = void 0 === j ? $06815ec2120bfaa3$export$7dcc0eed76218746.titleOffset : j, M = e.theme, F = $06815ec2120bfaa3$export$92bd5bd2fa4d30f9({
        scale: s,
        ticks: p,
        length: g,
        thickness: m,
        direction: u,
        tickPosition: x,
        tickSize: W,
        tickSpacing: C,
        tickOverlap: X,
        tickFormat: O,
        title: B,
        titleAlign: E,
        titleOffset: L
    }), T = F.width, P = F.height, V = F.gradientX1, R = F.gradientY1, D = F.gradientX2, q = F.gradientY2, G = F.colorStops, I = F.ticks, N = F.titleText, _ = F.titleX, J = F.titleY, K = F.titleRotation, Q = F.titleVerticalAlign, U = F.titleHorizontalAlign, Z = $06815ec2120bfaa3$export$d54b250266589d82({
        anchor: o,
        translateX: a,
        translateY: d,
        containerWidth: i,
        containerHeight: n,
        width: T,
        height: P
    }), $ = Z.x, tt = Z.y, et = {
        font: t.font,
        textAlign: t.textAlign,
        textBaseline: t.textBaseline
    };
    t.save(), t.translate($, tt);
    var it = t.createLinearGradient(V * T, R * P, D * T, q * P);
    G.forEach(function(t) {
        it.addColorStop(t.offset, t.stopColor);
    }), t.fillStyle = it, t.fillRect(0, 0, T, P), t.font = (M.legends.ticks.text.fontWeight ? M.legends.ticks.text.fontWeight + " " : "") + M.legends.ticks.text.fontSize + "px " + M.legends.ticks.text.fontFamily, I.forEach(function(e) {
        var i;
        (null != (i = M.legends.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(M.axis.ticks.line.strokeWidth), M.axis.ticks.line.stroke && (t.strokeStyle = M.axis.ticks.line.stroke), t.lineCap = "square", t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke()), M.legends.ticks.text.fill && (t.fillStyle = M.legends.ticks.text.fill), t.textAlign = "middle" === e.textHorizontalAlign ? "center" : e.textHorizontalAlign, t.textBaseline = "central" === e.textVerticalAlign ? "middle" : e.textVerticalAlign, t.fillText(e.text, e.textX, e.textY);
    }), N && (t.save(), t.translate(_, J), t.rotate((0, $ceac9f6897e0c09e$export$c9fcf1a7df975d78)(K)), t.font = (M.legends.title.text.fontWeight ? M.legends.title.text.fontWeight + " " : "") + M.legends.title.text.fontSize + "px " + M.legends.title.text.fontFamily, M.legends.title.text.fill && (t.fillStyle = M.legends.title.text.fill), t.textAlign = "middle" === U ? "center" : U, t.textBaseline = Q, t.fillText(N, 0, 0), t.restore()), t.restore(), t.font = et.font, t.textAlign = et.textAlign, t.textBaseline = et.textBaseline;
}, $06815ec2120bfaa3$export$419bf2ab46804c4 = function(t) {
    var e = t.scale, i = t.domain, n = t.reverse, o = void 0 !== n && n, r = t.valueFormat, l = void 0 === r ? function(t) {
        return t;
    } : r, a = t.separator, c = void 0 === a ? " - " : a;
    return (0, $7fPBF.useMemo)(function() {
        var t = (null != i ? i : e.range()).map(function(t, i) {
            var n = e.invertExtent(t), o = n[0], r = n[1];
            return {
                id: t,
                index: i,
                extent: [
                    o,
                    r
                ],
                label: "" + l(o) + c + l(r),
                value: e(o),
                color: t
            };
        });
        return o && t.reverse(), t;
    }, [
        i,
        e,
        o,
        c,
        l
    ]);
};





var $d9bd8a78d88a4e6a$export$58adb3bec8346d0f = Array.prototype.slice;
function $d9bd8a78d88a4e6a$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $ba2c413f9fa5c8a0$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}




function $87aacb02ab4f2e23$var$stackValue(d, key) {
    return d[key];
}
function $87aacb02ab4f2e23$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $87aacb02ab4f2e23$export$2e2bcd8739ae039() {
    var keys = (0, $ba2c413f9fa5c8a0$export$2e2bcd8739ae039)([]), order = (0, $fcb8b9669a144823$export$2e2bcd8739ae039), offset = (0, $5e9c35a540f1fc5a$export$2e2bcd8739ae039), value = $87aacb02ab4f2e23$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $87aacb02ab4f2e23$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $d9bd8a78d88a4e6a$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $ba2c413f9fa5c8a0$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ba2c413f9fa5c8a0$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $fcb8b9669a144823$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $ba2c413f9fa5c8a0$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $5e9c35a540f1fc5a$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}



function $6f6e62123bc42f02$var$j() {
    return $6f6e62123bc42f02$var$j = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var a = arguments[t];
            for(var i in a)Object.prototype.hasOwnProperty.call(a, i) && (e[i] = a[i]);
        }
        return e;
    }, $6f6e62123bc42f02$var$j.apply(this, arguments);
}
function $6f6e62123bc42f02$var$q(e, t) {
    if (null == e) return {};
    var a, i, n = {}, l = Object.keys(e);
    for(i = 0; i < l.length; i++)a = l[i], t.indexOf(a) >= 0 || (n[a] = e[a]);
    return n;
}
var $6f6e62123bc42f02$var$K, $6f6e62123bc42f02$var$_ = function(e) {
    var t = e.bars, a = e.annotations, i = (0, $f962d83699f3530e$export$ede9be424e8ef89a)({
        data: t,
        annotations: a,
        getPosition: function(e) {
            return {
                x: e.x + e.width / 2,
                y: e.y + e.height / 2
            };
        },
        getDimensions: function(e) {
            var t = e.height, a = e.width;
            return {
                width: a,
                height: t,
                size: Math.max(a, t)
            };
        }
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: i.map(function(e, t) {
            return (0, $824c049f32d4395d$exports.jsx)((0, $f962d83699f3530e$export$9279461326b8700a), $6f6e62123bc42f02$var$j({}, e), t);
        })
    });
}, $6f6e62123bc42f02$var$J = function(e) {
    var t = e.width, a = e.height, i = e.legends, n = e.toggleSerie;
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: i.map(function(e, i) {
            var l, r = e[0], o = e[1];
            return (0, $824c049f32d4395d$exports.jsx)((0, $06815ec2120bfaa3$export$238a2f791d4948f7), $6f6e62123bc42f02$var$j({}, r, {
                containerWidth: t,
                containerHeight: a,
                data: null != (l = r.data) ? l : o,
                toggleSerie: r.toggleSerie && "keys" === r.dataFrom ? n : void 0
            }), i);
        })
    });
}, $6f6e62123bc42f02$var$Q = [
    "data"
], $6f6e62123bc42f02$export$abe528c32883ca90 = function(e) {
    var t, a = e.bar, i = a.data, l = $6f6e62123bc42f02$var$q(a, $6f6e62123bc42f02$var$Q), r = e.style, o = r.borderColor, d = r.color, u = r.height, c = r.labelColor, s = r.labelOpacity, h = r.labelX, f = r.labelY, b = r.transform, v = r.width, g = e.borderRadius, y = e.borderWidth, w = e.label, L = e.shouldRenderLabel, C = e.isInteractive, V = e.onClick, M = e.onMouseEnter, W = e.onMouseLeave, T = e.tooltip, B = e.isFocusable, I = e.ariaLabel, E = e.ariaLabelledBy, H = e.ariaDescribedBy, P = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), F = (0, $ad81ce180dd1d3ec$export$1c4b08e0eca38426)(), X = F.showTooltipFromEvent, D = F.showTooltipAt, A = F.hideTooltip, G = (0, $7fPBF.useMemo)(function() {
        return function() {
            return (0, $7fPBF.createElement)(T, $6f6e62123bc42f02$var$j({}, l, i));
        };
    }, [
        T,
        l,
        i
    ]), z = (0, $7fPBF.useCallback)(function(e) {
        null == V || V($6f6e62123bc42f02$var$j({
            color: l.color
        }, i), e);
    }, [
        l,
        i,
        V
    ]), N = (0, $7fPBF.useCallback)(function(e) {
        return X(G(), e);
    }, [
        X,
        G
    ]), K = (0, $7fPBF.useCallback)(function(e) {
        null == M || M(i, e), X(G(), e);
    }, [
        i,
        M,
        X,
        G
    ]), _ = (0, $7fPBF.useCallback)(function(e) {
        null == W || W(i, e), A();
    }, [
        i,
        A,
        W
    ]), J = (0, $7fPBF.useCallback)(function() {
        D(G(), [
            l.absX + l.width / 2,
            l.absY
        ]);
    }, [
        D,
        G,
        l
    ]), U = (0, $7fPBF.useCallback)(function() {
        A();
    }, [
        A
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        transform: b,
        children: [
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).rect, {
                width: (0, $27d73b36303119b6$export$2c618a4308a30424)(v, function(e) {
                    return Math.max(e, 0);
                }),
                height: (0, $27d73b36303119b6$export$2c618a4308a30424)(u, function(e) {
                    return Math.max(e, 0);
                }),
                rx: g,
                ry: g,
                fill: null != (t = i.fill) ? t : d,
                strokeWidth: y,
                stroke: o,
                focusable: B,
                tabIndex: B ? 0 : void 0,
                "aria-label": I ? I(i) : void 0,
                "aria-labelledby": E ? E(i) : void 0,
                "aria-describedby": H ? H(i) : void 0,
                onMouseEnter: C ? K : void 0,
                onMouseMove: C ? N : void 0,
                onMouseLeave: C ? _ : void 0,
                onClick: C ? z : void 0,
                onFocus: C && B ? J : void 0,
                onBlur: C && B ? U : void 0
            }),
            L && (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                x: h,
                y: f,
                textAnchor: "middle",
                dominantBaseline: "central",
                fillOpacity: s,
                style: $6f6e62123bc42f02$var$j({}, P.labels.text, {
                    pointerEvents: "none",
                    fill: c
                }),
                children: w
            })
        ]
    });
}, $6f6e62123bc42f02$var$Z = [
    "color",
    "label"
], $6f6e62123bc42f02$export$f509e97905f1d31f = function(e) {
    var t = e.color, a = e.label, i = $6f6e62123bc42f02$var$q(e, $6f6e62123bc42f02$var$Z);
    return (0, $824c049f32d4395d$exports.jsx)((0, $ad81ce180dd1d3ec$export$d5f52d71198e271a), {
        id: a,
        value: i.formattedValue,
        enableChip: !0,
        color: t
    });
}, $6f6e62123bc42f02$export$9c21a3269931e1e6 = {
    indexBy: "id",
    keys: [
        "value"
    ],
    groupMode: "stacked",
    layout: "vertical",
    reverse: !1,
    minValue: "auto",
    maxValue: "auto",
    valueScale: {
        type: "linear"
    },
    indexScale: {
        type: "band",
        round: !0
    },
    padding: .1,
    innerPadding: 0,
    axisBottom: {},
    axisLeft: {},
    enableGridX: !1,
    enableGridY: !0,
    enableLabel: !0,
    label: "formattedValue",
    labelSkipWidth: 0,
    labelSkipHeight: 0,
    labelTextColor: {
        from: "theme",
        theme: "labels.text.fill"
    },
    colorBy: "id",
    colors: {
        scheme: "nivo"
    },
    borderRadius: 0,
    borderWidth: 0,
    borderColor: {
        from: "color"
    },
    isInteractive: !0,
    tooltip: $6f6e62123bc42f02$export$f509e97905f1d31f,
    tooltipLabel: function(e) {
        return e.id + " - " + e.indexValue;
    },
    legends: [],
    initialHiddenIds: [],
    annotations: [],
    markers: [],
    enableTotals: !1,
    totalsOffset: 10
}, $6f6e62123bc42f02$export$82f4948cbf358702 = $6f6e62123bc42f02$var$j({}, $6f6e62123bc42f02$export$9c21a3269931e1e6, {
    layers: [
        "grid",
        "axes",
        "bars",
        "totals",
        "markers",
        "legends",
        "annotations"
    ],
    barComponent: $6f6e62123bc42f02$export$abe528c32883ca90,
    defs: [],
    fill: [],
    animate: !0,
    motionConfig: "default",
    role: "img",
    isFocusable: !1
}), $6f6e62123bc42f02$export$b14a24a807ef5c0b = $6f6e62123bc42f02$var$j({}, $6f6e62123bc42f02$export$9c21a3269931e1e6, {
    layers: [
        "grid",
        "axes",
        "bars",
        "totals",
        "legends",
        "annotations"
    ],
    pixelRatio: "undefined" != typeof window && null != ($6f6e62123bc42f02$var$K = window.devicePixelRatio) ? $6f6e62123bc42f02$var$K : 1
}), $6f6e62123bc42f02$var$ie = function(e, t, a, i, n, l) {
    return (0, $ee31ac98501255d1$export$5268a4c29077d335)(i, {
        all: e.map(t),
        min: 0,
        max: 0
    }, n, l).padding(a);
}, $6f6e62123bc42f02$var$ne = function(e, t) {
    return e.map(function(e) {
        return $6f6e62123bc42f02$var$j({}, t.reduce(function(e, t) {
            return e[t] = null, e;
        }, {}), e);
    });
}, $6f6e62123bc42f02$var$le = function(e) {
    return Object.keys(e).reduce(function(t, a) {
        return e[a] && (t[a] = e[a]), t;
    }, {});
}, $6f6e62123bc42f02$var$re = function(e) {
    return [
        e,
        Number(e)
    ];
}, $6f6e62123bc42f02$var$oe = [
    "layout",
    "minValue",
    "maxValue",
    "reverse",
    "width",
    "height",
    "padding",
    "innerPadding",
    "valueScale",
    "indexScale",
    "hiddenIds"
], $6f6e62123bc42f02$var$de = function(e, t) {
    return e > t;
}, $6f6e62123bc42f02$var$ue = function(e, t) {
    return e < t;
}, $6f6e62123bc42f02$var$ce = function(e, t) {
    return Array.from(" ".repeat(t - e), function(t, a) {
        return e + a;
    });
}, $6f6e62123bc42f02$var$se = function(e) {
    return $6f6e62123bc42f02$var$de(e, 0) ? 0 : e;
}, $6f6e62123bc42f02$var$he = function(e, t, a, i) {
    var n = e.data, l = e.formatValue, r = e.getColor, o = e.getIndex, d = e.getTooltipLabel, u = e.innerPadding, c = void 0 === u ? 0 : u, s = e.keys, h = e.xScale, f = e.yScale, b = e.margin, v = a ? $6f6e62123bc42f02$var$ue : $6f6e62123bc42f02$var$de, g = n.map($6f6e62123bc42f02$var$le), m = [];
    return s.forEach(function(e, a) {
        return $6f6e62123bc42f02$var$ce(0, h.domain().length).forEach(function(u) {
            var s, p, y, x = $6f6e62123bc42f02$var$re(n[u][e]), S = x[0], k = x[1], w = o(n[u]), L = (null != (s = h(w)) ? s : 0) + t * a + c * a, C = v(p = k, 0) ? null != (y = f(p)) ? y : 0 : i, V = function(e, t) {
                var a;
                return v(e, 0) ? i - t : (null != (a = f(e)) ? a : 0) - i;
            }(k, C), M = {
                id: e,
                value: null === S ? S : k,
                formattedValue: l(k),
                hidden: !1,
                index: u,
                indexValue: w,
                data: g[u]
            };
            m.push({
                key: e + "." + M.indexValue,
                index: m.length,
                data: M,
                x: L,
                y: C,
                absX: b.left + L,
                absY: b.top + C,
                width: t,
                height: V,
                color: r(M),
                label: d(M)
            });
        });
    }), m;
}, $6f6e62123bc42f02$var$fe = function(e, t, a, i) {
    var n = e.data, l = e.formatValue, r = e.getIndex, o = e.getColor, d = e.getTooltipLabel, u = e.keys, c = e.innerPadding, s = void 0 === c ? 0 : c, h = e.xScale, f = e.yScale, b = e.margin, v = a ? $6f6e62123bc42f02$var$ue : $6f6e62123bc42f02$var$de, g = n.map($6f6e62123bc42f02$var$le), m = [];
    return u.forEach(function(e, a) {
        return $6f6e62123bc42f02$var$ce(0, f.domain().length).forEach(function(u) {
            var c, p, y, x = $6f6e62123bc42f02$var$re(n[u][e]), S = x[0], k = x[1], w = r(n[u]), L = v(p = k, 0) ? i : null != (y = h(p)) ? y : 0, C = (null != (c = f(w)) ? c : 0) + t * a + s * a, V = function(e, t) {
                var a;
                return v(e, 0) ? (null != (a = h(e)) ? a : 0) - i : i - t;
            }(k, L), M = {
                id: e,
                value: null === S ? S : k,
                formattedValue: l(k),
                hidden: !1,
                index: u,
                indexValue: w,
                data: g[u]
            };
            m.push({
                key: e + "." + M.indexValue,
                index: m.length,
                data: M,
                x: L,
                y: C,
                absX: b.left + L,
                absY: b.top + C,
                width: V,
                height: t,
                color: o(M),
                label: d(M)
            });
        });
    }), m;
}, $6f6e62123bc42f02$var$be = function(e) {
    var t, a, i = e.layout, n = e.minValue, l = e.maxValue, r = e.reverse, o = e.width, d = e.height, u = e.padding, c = void 0 === u ? 0 : u, s = e.innerPadding, h = void 0 === s ? 0 : s, f = e.valueScale, b = e.indexScale, v = e.hiddenIds, g = void 0 === v ? [] : v, m = $6f6e62123bc42f02$var$q(e, $6f6e62123bc42f02$var$oe), p = m.keys.filter(function(e) {
        return !g.includes(e);
    }), y = $6f6e62123bc42f02$var$ne(m.data, p), x = "vertical" === i ? [
        "y",
        "x",
        o
    ] : [
        "x",
        "y",
        d
    ], S = x[0], k = x[1], w = x[2], L = $6f6e62123bc42f02$var$ie(y, m.getIndex, c, b, w, k), C = $6f6e62123bc42f02$var$j({
        max: l,
        min: n,
        reverse: r
    }, f), V = "auto" === C.min ? $6f6e62123bc42f02$var$se : function(e) {
        return e;
    }, M = y.reduce(function(e, t) {
        return [].concat(e, p.map(function(e) {
            return t[e];
        }));
    }, []).filter(Boolean), W = V(Math.min.apply(Math, M)), T = (a = Math.max.apply(Math, M), isFinite(a) ? a : 0), B = (0, $ee31ac98501255d1$export$5268a4c29077d335)(C, {
        all: M,
        min: W,
        max: T
    }, "x" === S ? o : d, S), I = "vertical" === i ? [
        L,
        B
    ] : [
        B,
        L
    ], O = I[0], E = I[1], R = (L.bandwidth() - h * (p.length - 1)) / p.length, H = [
        $6f6e62123bc42f02$var$j({}, m, {
            data: y,
            keys: p,
            innerPadding: h,
            xScale: O,
            yScale: E
        }),
        R,
        C.reverse,
        null != (t = B(0)) ? t : 0
    ];
    return {
        xScale: O,
        yScale: E,
        bars: R > 0 ? "vertical" === i ? $6f6e62123bc42f02$var$he.apply(void 0, H) : $6f6e62123bc42f02$var$fe.apply(void 0, H) : []
    };
}, $6f6e62123bc42f02$var$ve = [
    "data",
    "layout",
    "minValue",
    "maxValue",
    "reverse",
    "width",
    "height",
    "padding",
    "valueScale",
    "indexScale",
    "hiddenIds"
], $6f6e62123bc42f02$var$ge = function e(t) {
    var a;
    return t.some(Array.isArray) ? e((a = []).concat.apply(a, t)) : t;
}, $6f6e62123bc42f02$var$me = function(e, t, a) {
    var i = e.formatValue, n = e.getColor, l = e.getIndex, r = e.getTooltipLabel, o = e.innerPadding, d = e.stackedData, u = e.xScale, c = e.yScale, s = e.margin, h = [];
    return d.forEach(function(e) {
        return u.domain().forEach(function(d, f) {
            var b, v, g = e[f], m = null != (b = u(l(g.data))) ? b : 0, p = (null != (v = function(e) {
                return c(e[a ? 0 : 1]);
            }(g)) ? v : 0) + .5 * o, y = function(e, t) {
                var i;
                return (null != (i = c(e[a ? 1 : 0])) ? i : 0) - t;
            }(g, p) - o, x = $6f6e62123bc42f02$var$re(g.data[e.key]), S = x[0], k = x[1], w = {
                id: e.key,
                value: null === S ? S : k,
                formattedValue: i(k),
                hidden: !1,
                index: f,
                indexValue: d,
                data: $6f6e62123bc42f02$var$le(g.data)
            };
            h.push({
                key: e.key + "." + d,
                index: h.length,
                data: w,
                x: m,
                y: p,
                absX: s.left + m,
                absY: s.top + p,
                width: t,
                height: y,
                color: n(w),
                label: r(w)
            });
        });
    }), h;
}, $6f6e62123bc42f02$var$pe = function(e, t, a) {
    var i = e.formatValue, n = e.getColor, l = e.getIndex, r = e.getTooltipLabel, o = e.innerPadding, d = e.stackedData, u = e.xScale, c = e.yScale, s = e.margin, h = [];
    return d.forEach(function(e) {
        return c.domain().forEach(function(d, f) {
            var b, v, g = e[f], m = null != (b = c(l(g.data))) ? b : 0, p = (null != (v = function(e) {
                return u(e[a ? 1 : 0]);
            }(g)) ? v : 0) + .5 * o, y = function(e, t) {
                var i;
                return (null != (i = u(e[a ? 0 : 1])) ? i : 0) - t;
            }(g, p) - o, x = $6f6e62123bc42f02$var$re(g.data[e.key]), S = x[0], k = x[1], w = {
                id: e.key,
                value: null === S ? S : k,
                formattedValue: i(k),
                hidden: !1,
                index: f,
                indexValue: d,
                data: $6f6e62123bc42f02$var$le(g.data)
            };
            h.push({
                key: e.key + "." + d,
                index: h.length,
                data: w,
                x: p,
                y: m,
                absX: s.left + p,
                absY: s.top + m,
                width: y,
                height: t,
                color: n(w),
                label: r(w)
            });
        });
    }), h;
}, $6f6e62123bc42f02$var$ye = function(e) {
    var t, a = e.data, i = e.layout, n = e.minValue, l = e.maxValue, r = e.reverse, o = e.width, d = e.height, u = e.padding, c = void 0 === u ? 0 : u, s = e.valueScale, h = e.indexScale, f = e.hiddenIds, b = void 0 === f ? [] : f, v = $6f6e62123bc42f02$var$q(e, $6f6e62123bc42f02$var$ve), g = v.keys.filter(function(e) {
        return !b.includes(e);
    }), m = (0, $87aacb02ab4f2e23$export$2e2bcd8739ae039)().keys(g).offset((0, $15ee0fa0ceb6123a$export$2e2bcd8739ae039))($6f6e62123bc42f02$var$ne(a, g)), p = "vertical" === i ? [
        "y",
        "x",
        o
    ] : [
        "x",
        "y",
        d
    ], y = p[0], x = p[1], S = p[2], k = $6f6e62123bc42f02$var$ie(a, v.getIndex, c, h, S, x), w = $6f6e62123bc42f02$var$j({
        max: l,
        min: n,
        reverse: r
    }, s), L = (t = $6f6e62123bc42f02$var$ge(m), "log" === s.type ? t.filter(function(e) {
        return 0 !== e;
    }) : t), C = Math.min.apply(Math, L), V = Math.max.apply(Math, L), M = (0, $ee31ac98501255d1$export$5268a4c29077d335)(w, {
        all: L,
        min: C,
        max: V
    }, "x" === y ? o : d, y), W = "vertical" === i ? [
        k,
        M
    ] : [
        M,
        k
    ], T = W[0], B = W[1], I = v.innerPadding > 0 ? v.innerPadding : 0, O = k.bandwidth(), E = [
        $6f6e62123bc42f02$var$j({}, v, {
            innerPadding: I,
            stackedData: m,
            xScale: T,
            yScale: B
        }),
        O,
        w.reverse
    ];
    return {
        xScale: T,
        yScale: B,
        bars: O > 0 ? "vertical" === i ? $6f6e62123bc42f02$var$me.apply(void 0, E) : $6f6e62123bc42f02$var$pe.apply(void 0, E) : []
    };
}, $6f6e62123bc42f02$var$xe = function(e) {
    var t = e.bars, a = e.direction, i = e.from, n = e.groupMode, r = e.layout, o = e.legendLabel, d = e.reverse, u = (0, $ceac9f6897e0c09e$export$3cc9373c3cf93eff)(null != o ? o : "indexes" === i ? "indexValue" : "id");
    return "indexes" === i ? function(e, t, a) {
        var i = (0, (/*@__PURE__*/$parcel$interopDefault($99c2840ed14736a0$exports)))(e.map(function(e) {
            var t, i;
            return {
                id: null != (t = e.data.indexValue) ? t : "",
                label: a(e.data),
                hidden: e.data.hidden,
                color: null != (i = e.color) ? i : "#000"
            };
        }), function(e) {
            return e.id;
        });
        return "horizontal" === t && i.reverse(), i;
    }(t, r, u) : function(e, t, a, i, n, l) {
        var r = (0, (/*@__PURE__*/$parcel$interopDefault($99c2840ed14736a0$exports)))(e.map(function(e) {
            var t;
            return {
                id: e.data.id,
                label: l(e.data),
                hidden: e.data.hidden,
                color: null != (t = e.color) ? t : "#000"
            };
        }), function(e) {
            return e.id;
        });
        return ("vertical" === t && "stacked" === i && "column" === a && !0 !== n || "horizontal" === t && "stacked" === i && !0 === n) && r.reverse(), r;
    }(t, r, a, n, d, u);
}, $6f6e62123bc42f02$var$Se = function(e, t, a) {
    var i = e.get(t) || 0;
    e.set(t, i + a);
}, $6f6e62123bc42f02$var$ke = function(e, t, a) {
    var i = e.get(t) || 0;
    e.set(t, i + (a > 0 ? a : 0));
}, $6f6e62123bc42f02$var$we = function(e, t, a) {
    var i = e.get(t) || 0;
    e.set(t, Math.max(i, Number(a)));
}, $6f6e62123bc42f02$var$Le = function(e, t) {
    var a = e.get(t) || 0;
    e.set(t, a + 1);
}, $6f6e62123bc42f02$var$Ce = function(e) {
    var t = e.indexBy, a = void 0 === t ? $6f6e62123bc42f02$export$9c21a3269931e1e6.indexBy : t, i = e.keys, l = void 0 === i ? $6f6e62123bc42f02$export$9c21a3269931e1e6.keys : i, d = e.label, u = void 0 === d ? $6f6e62123bc42f02$export$9c21a3269931e1e6.label : d, c = e.tooltipLabel, s = void 0 === c ? $6f6e62123bc42f02$export$9c21a3269931e1e6.tooltipLabel : c, h = e.valueFormat, f = e.colors, b = void 0 === f ? $6f6e62123bc42f02$export$9c21a3269931e1e6.colors : f, v = e.colorBy, g = void 0 === v ? $6f6e62123bc42f02$export$9c21a3269931e1e6.colorBy : v, m = e.borderColor, p = void 0 === m ? $6f6e62123bc42f02$export$9c21a3269931e1e6.borderColor : m, y = e.labelTextColor, S = void 0 === y ? $6f6e62123bc42f02$export$9c21a3269931e1e6.labelTextColor : y, L = e.groupMode, C = void 0 === L ? $6f6e62123bc42f02$export$9c21a3269931e1e6.groupMode : L, V = e.layout, M = void 0 === V ? $6f6e62123bc42f02$export$9c21a3269931e1e6.layout : V, W = e.reverse, T = void 0 === W ? $6f6e62123bc42f02$export$9c21a3269931e1e6.reverse : W, B = e.data, I = e.minValue, O = void 0 === I ? $6f6e62123bc42f02$export$9c21a3269931e1e6.minValue : I, E = e.maxValue, R = void 0 === E ? $6f6e62123bc42f02$export$9c21a3269931e1e6.maxValue : E, H = e.margin, P = e.width, Y = e.height, D = e.padding, A = void 0 === D ? $6f6e62123bc42f02$export$9c21a3269931e1e6.padding : D, G = e.innerPadding, z = void 0 === G ? $6f6e62123bc42f02$export$9c21a3269931e1e6.innerPadding : G, N = e.valueScale, q = void 0 === N ? $6f6e62123bc42f02$export$9c21a3269931e1e6.valueScale : N, K = e.indexScale, _ = void 0 === K ? $6f6e62123bc42f02$export$9c21a3269931e1e6.indexScale : K, J = e.initialHiddenIds, Q = void 0 === J ? $6f6e62123bc42f02$export$9c21a3269931e1e6.initialHiddenIds : J, U = e.enableLabel, Z = void 0 === U ? $6f6e62123bc42f02$export$9c21a3269931e1e6.enableLabel : U, $ = e.labelSkipWidth, te = void 0 === $ ? $6f6e62123bc42f02$export$9c21a3269931e1e6.labelSkipWidth : $, ae = e.labelSkipHeight, ie = void 0 === ae ? $6f6e62123bc42f02$export$9c21a3269931e1e6.labelSkipHeight : ae, ne = e.legends, le = void 0 === ne ? $6f6e62123bc42f02$export$9c21a3269931e1e6.legends : ne, re = e.legendLabel, oe = e.totalsOffset, de = void 0 === oe ? $6f6e62123bc42f02$export$9c21a3269931e1e6.totalsOffset : oe, ue = (0, $7fPBF.useState)(null != Q ? Q : []), ce = ue[0], se = ue[1], he = (0, $7fPBF.useCallback)(function(e) {
        se(function(t) {
            return t.indexOf(e) > -1 ? t.filter(function(t) {
                return t !== e;
            }) : [].concat(t, [
                e
            ]);
        });
    }, []), fe = (0, $ceac9f6897e0c09e$export$2d590546cbb7e3ad)(a), ve = (0, $ceac9f6897e0c09e$export$2d590546cbb7e3ad)(u), ge = (0, $ceac9f6897e0c09e$export$2d590546cbb7e3ad)(s), me = (0, $ceac9f6897e0c09e$export$422f9765e6971fdf)(h), pe = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), Ce = (0, $eca4c4327ec3ea7c$export$47939777be1516f5)(b, g), Ve = (0, $eca4c4327ec3ea7c$export$2a9e363116151414)(p, pe), Me = (0, $eca4c4327ec3ea7c$export$2a9e363116151414)(S, pe), We = ("grouped" === C ? $6f6e62123bc42f02$var$be : $6f6e62123bc42f02$var$ye)({
        layout: M,
        reverse: T,
        data: B,
        getIndex: fe,
        keys: l,
        minValue: O,
        maxValue: R,
        width: P,
        height: Y,
        getColor: Ce,
        padding: A,
        innerPadding: z,
        valueScale: q,
        indexScale: _,
        hiddenIds: ce,
        formatValue: me,
        getTooltipLabel: ge,
        margin: H
    }), Te = We.bars, Be = We.xScale, Ie = We.yScale, Oe = (0, $7fPBF.useMemo)(function() {
        return Te.filter(function(e) {
            return null !== e.data.value;
        }).map(function(e, t) {
            return $6f6e62123bc42f02$var$j({}, e, {
                index: t
            });
        });
    }, [
        Te
    ]), Ee = (0, $7fPBF.useCallback)(function(e) {
        var t = e.width, a = e.height;
        return !!Z && !(te > 0 && t < te) && !(ie > 0 && a < ie);
    }, [
        Z,
        te,
        ie
    ]), Re = (0, $7fPBF.useMemo)(function() {
        return l.map(function(e) {
            var t = Te.find(function(t) {
                return t.data.id === e;
            });
            return $6f6e62123bc42f02$var$j({}, t, {
                data: $6f6e62123bc42f02$var$j({
                    id: e
                }, null == t ? void 0 : t.data, {
                    hidden: ce.includes(e)
                })
            });
        });
    }, [
        ce,
        l,
        Te
    ]), He = (0, $7fPBF.useMemo)(function() {
        return le.map(function(e) {
            return [
                e,
                $6f6e62123bc42f02$var$xe({
                    bars: "keys" === e.dataFrom ? Re : Te,
                    direction: e.direction,
                    from: e.dataFrom,
                    groupMode: C,
                    layout: M,
                    legendLabel: re,
                    reverse: T
                })
            ];
        });
    }, [
        le,
        Re,
        Te,
        C,
        M,
        re,
        T
    ]), Pe = (0, $7fPBF.useMemo)(function() {
        return function(e, t, a, i, n, l, r) {
            void 0 === i && (i = $6f6e62123bc42f02$export$9c21a3269931e1e6.layout), void 0 === n && (n = $6f6e62123bc42f02$export$9c21a3269931e1e6.groupMode);
            var o = [];
            if (0 === e.length) return o;
            var d = new Map, u = e[0].width, c = e[0].height;
            if ("stacked" === n) {
                var s = new Map;
                e.forEach(function(e) {
                    var t = e.data, a = t.indexValue, i = t.value;
                    $6f6e62123bc42f02$var$Se(d, a, Number(i)), $6f6e62123bc42f02$var$ke(s, a, Number(i));
                }), s.forEach(function(e, n) {
                    var s, h, f, b = d.get(n) || 0;
                    "vertical" === i ? (s = t(n), h = a(e), f = a(e / 2)) : (s = t(e), h = a(n), f = t(e / 2)), s += "vertical" === i ? u / 2 : l, h += "vertical" === i ? -l : c / 2, o.push({
                        key: "total_" + n,
                        x: s,
                        y: h,
                        value: b,
                        formattedValue: r(b),
                        animationOffset: f
                    });
                });
            } else if ("grouped" === n) {
                var h = new Map, f = new Map;
                e.forEach(function(e) {
                    var t = e.data, a = t.indexValue, i = t.value;
                    $6f6e62123bc42f02$var$Se(d, a, Number(i)), $6f6e62123bc42f02$var$we(h, a, Number(i)), $6f6e62123bc42f02$var$Le(f, a);
                }), h.forEach(function(e, n) {
                    var s, h, b, v = d.get(n) || 0, g = f.get(n);
                    "vertical" === i ? (s = t(n), h = a(e), b = a(e / 2)) : (s = t(e), h = a(n), b = t(e / 2)), s += "vertical" === i ? g * u / 2 : l, h += "vertical" === i ? -l : g * c / 2, o.push({
                        key: "total_" + n,
                        x: s,
                        y: h,
                        value: v,
                        formattedValue: r(v),
                        animationOffset: b
                    });
                });
            }
            return o;
        }(Te, Be, Ie, M, C, de, me);
    }, [
        Te,
        Be,
        Ie,
        M,
        C,
        de,
        me
    ]);
    return {
        bars: Te,
        barsWithValue: Oe,
        xScale: Be,
        yScale: Ie,
        getIndex: fe,
        getLabel: ve,
        getTooltipLabel: ge,
        formatValue: me,
        getColor: Ce,
        getBorderColor: Ve,
        getLabelColor: Me,
        shouldRenderBarLabel: Ee,
        hiddenIds: ce,
        toggleSerie: he,
        legendsWithData: He,
        barTotals: Pe
    };
}, $6f6e62123bc42f02$export$aae8d1f6490d80ef = function(e) {
    var t = e.data, a = e.springConfig, i = e.animate, l = e.layout, r = void 0 === l ? $6f6e62123bc42f02$export$82f4948cbf358702.layout : l, o = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)();
    return (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(t, {
        keys: function(e) {
            return e.key;
        },
        from: function(e) {
            return {
                x: "vertical" === r ? e.x : e.animationOffset,
                y: "vertical" === r ? e.animationOffset : e.y,
                labelOpacity: 0
            };
        },
        enter: function(e) {
            return {
                x: e.x,
                y: e.y,
                labelOpacity: 1
            };
        },
        update: function(e) {
            return {
                x: e.x,
                y: e.y,
                labelOpacity: 1
            };
        },
        leave: function(e) {
            return {
                x: "vertical" === r ? e.x : e.animationOffset,
                y: "vertical" === r ? e.animationOffset : e.y,
                labelOpacity: 0
            };
        },
        config: a,
        immediate: !i,
        initial: i ? void 0 : null
    })(function(e, t) {
        return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
            x: e.x,
            y: e.y,
            fillOpacity: e.labelOpacity,
            style: $6f6e62123bc42f02$var$j({}, o.labels.text, {
                pointerEvents: "none",
                fill: o.text.fill
            }),
            fontWeight: "bold",
            fontSize: o.labels.text.fontSize,
            fontFamily: o.labels.text.fontFamily,
            textAnchor: "vertical" === r ? "middle" : "start",
            alignmentBaseline: "vertical" === r ? "alphabetic" : "middle",
            children: t.formattedValue
        }, t.key);
    });
}, $6f6e62123bc42f02$var$Me = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $6f6e62123bc42f02$var$We = function(a) {
    var i = a.data, n = a.indexBy, l = a.keys, r = a.margin, o = a.width, d = a.height, b = a.groupMode, v = a.layout, g = a.reverse, m = a.minValue, p = a.maxValue, k = a.valueScale, w = a.indexScale, C = a.padding, V = a.innerPadding, M = a.axisTop, W = a.axisRight, T = a.axisBottom, B = void 0 === T ? $6f6e62123bc42f02$export$82f4948cbf358702.axisBottom : T, I = a.axisLeft, E = void 0 === I ? $6f6e62123bc42f02$export$82f4948cbf358702.axisLeft : I, R = a.enableGridX, H = void 0 === R ? $6f6e62123bc42f02$export$82f4948cbf358702.enableGridX : R, P = a.enableGridY, F = void 0 === P ? $6f6e62123bc42f02$export$82f4948cbf358702.enableGridY : P, X = a.gridXValues, Y = a.gridYValues, D = a.layers, A = void 0 === D ? $6f6e62123bc42f02$export$82f4948cbf358702.layers : D, G = a.barComponent, z = void 0 === G ? $6f6e62123bc42f02$export$82f4948cbf358702.barComponent : G, N = a.enableLabel, q = void 0 === N ? $6f6e62123bc42f02$export$82f4948cbf358702.enableLabel : N, K = a.label, Q = a.labelSkipWidth, U = void 0 === Q ? $6f6e62123bc42f02$export$82f4948cbf358702.labelSkipWidth : Q, Z = a.labelSkipHeight, $ = void 0 === Z ? $6f6e62123bc42f02$export$82f4948cbf358702.labelSkipHeight : Z, ee = a.labelTextColor, ae = a.markers, ie = void 0 === ae ? $6f6e62123bc42f02$export$82f4948cbf358702.markers : ae, ne = a.colorBy, le = a.colors, re = a.defs, oe = void 0 === re ? $6f6e62123bc42f02$export$82f4948cbf358702.defs : re, de = a.fill, ue = void 0 === de ? $6f6e62123bc42f02$export$82f4948cbf358702.fill : de, ce = a.borderRadius, se = void 0 === ce ? $6f6e62123bc42f02$export$82f4948cbf358702.borderRadius : ce, he = a.borderWidth, fe = void 0 === he ? $6f6e62123bc42f02$export$82f4948cbf358702.borderWidth : he, be = a.borderColor, ve = a.annotations, ge = void 0 === ve ? $6f6e62123bc42f02$export$82f4948cbf358702.annotations : ve, me = a.legendLabel, pe = a.tooltipLabel, ye = a.valueFormat, xe = a.isInteractive, Se = void 0 === xe ? $6f6e62123bc42f02$export$82f4948cbf358702.isInteractive : xe, ke = a.tooltip, we = void 0 === ke ? $6f6e62123bc42f02$export$82f4948cbf358702.tooltip : ke, Le = a.onClick, Me = a.onMouseEnter, We = a.onMouseLeave, Te = a.legends, Be = a.role, Ie = void 0 === Be ? $6f6e62123bc42f02$export$82f4948cbf358702.role : Be, Oe = a.ariaLabel, Ee = a.ariaLabelledBy, Re = a.ariaDescribedBy, He = a.isFocusable, Pe = void 0 === He ? $6f6e62123bc42f02$export$82f4948cbf358702.isFocusable : He, Fe = a.barAriaLabel, Xe = a.barAriaLabelledBy, Ye = a.barAriaDescribedBy, De = a.initialHiddenIds, Ae = a.enableTotals, Ge = void 0 === Ae ? $6f6e62123bc42f02$export$82f4948cbf358702.enableTotals : Ae, ze = a.totalsOffset, Ne = void 0 === ze ? $6f6e62123bc42f02$export$82f4948cbf358702.totalsOffset : ze, je = (0, $ceac9f6897e0c09e$export$72acc3dc9629d75d)(), qe = je.animate, Ke = je.config, _e = (0, $ceac9f6897e0c09e$export$d04af0e501fb729f)(o, d, r), Je = _e.outerWidth, Qe = _e.outerHeight, Ue = _e.margin, Ze = _e.innerWidth, $e = _e.innerHeight, et = $6f6e62123bc42f02$var$Ce({
        indexBy: n,
        label: K,
        tooltipLabel: pe,
        valueFormat: ye,
        colors: le,
        colorBy: ne,
        borderColor: be,
        labelTextColor: ee,
        groupMode: b,
        layout: v,
        reverse: g,
        data: i,
        keys: l,
        minValue: m,
        maxValue: p,
        margin: Ue,
        width: Ze,
        height: $e,
        padding: C,
        innerPadding: V,
        valueScale: k,
        indexScale: w,
        enableLabel: q,
        labelSkipWidth: U,
        labelSkipHeight: $,
        legends: Te,
        legendLabel: me,
        initialHiddenIds: De,
        totalsOffset: Ne
    }), tt = et.bars, at = et.barsWithValue, it = et.xScale, nt = et.yScale, lt = et.getLabel, rt = et.getTooltipLabel, ot = et.getBorderColor, dt = et.getLabelColor, ut = et.shouldRenderBarLabel, ct = et.toggleSerie, st = et.legendsWithData, ht = et.barTotals, ft = (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(at, {
        keys: function(e) {
            return e.key;
        },
        from: function(e) {
            return $6f6e62123bc42f02$var$j({
                borderColor: ot(e),
                color: e.color,
                height: 0,
                labelColor: dt(e),
                labelOpacity: 0,
                labelX: e.width / 2,
                labelY: e.height / 2,
                transform: "translate(" + e.x + ", " + (e.y + e.height) + ")",
                width: e.width
            }, "vertical" === v ? {} : {
                height: e.height,
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: 0
            });
        },
        enter: function(e) {
            return {
                borderColor: ot(e),
                color: e.color,
                height: e.height,
                labelColor: dt(e),
                labelOpacity: 1,
                labelX: e.width / 2,
                labelY: e.height / 2,
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: e.width
            };
        },
        update: function(e) {
            return {
                borderColor: ot(e),
                color: e.color,
                height: e.height,
                labelColor: dt(e),
                labelOpacity: 1,
                labelX: e.width / 2,
                labelY: e.height / 2,
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: e.width
            };
        },
        leave: function(e) {
            return $6f6e62123bc42f02$var$j({
                borderColor: ot(e),
                color: e.color,
                height: 0,
                labelColor: dt(e),
                labelOpacity: 0,
                labelX: e.width / 2,
                labelY: 0,
                transform: "translate(" + e.x + ", " + (e.y + e.height) + ")",
                width: e.width
            }, "vertical" === v ? {} : {
                labelX: 0,
                labelY: e.height / 2,
                height: e.height,
                transform: "translate(" + e.x + ", " + e.y + ")",
                width: 0
            });
        },
        config: Ke,
        immediate: !qe,
        initial: qe ? void 0 : null
    }), bt = (0, $7fPBF.useMemo)(function() {
        return {
            borderRadius: se,
            borderWidth: fe,
            enableLabel: q,
            isInteractive: Se,
            labelSkipWidth: U,
            labelSkipHeight: $,
            onClick: Le,
            onMouseEnter: Me,
            onMouseLeave: We,
            getTooltipLabel: rt,
            tooltip: we,
            isFocusable: Pe,
            ariaLabel: Fe,
            ariaLabelledBy: Xe,
            ariaDescribedBy: Ye
        };
    }, [
        se,
        fe,
        q,
        rt,
        Se,
        $,
        U,
        Le,
        Me,
        We,
        we,
        Pe,
        Fe,
        Xe,
        Ye
    ]), vt = (0, $ceac9f6897e0c09e$export$dc35cf769e3afe34)(oe, tt, ue, {
        dataKey: "data",
        targetKey: "data.fill"
    }), gt = {
        annotations: null,
        axes: null,
        bars: null,
        grid: null,
        legends: null,
        markers: null,
        totals: null
    };
    A.includes("annotations") && (gt.annotations = (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$var$_, {
        bars: tt,
        annotations: ge
    }, "annotations")), A.includes("axes") && (gt.axes = (0, $824c049f32d4395d$exports.jsx)((0, $61394014a6be57c7$export$387a78ab20784494), {
        xScale: it,
        yScale: nt,
        width: Ze,
        height: $e,
        top: M,
        right: W,
        bottom: B,
        left: E
    }, "axes")), A.includes("bars") && (gt.bars = (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
        children: ft(function(e, t) {
            return (0, $7fPBF.createElement)(z, $6f6e62123bc42f02$var$j({}, bt, {
                bar: t,
                style: e,
                shouldRenderLabel: ut(t),
                label: lt(t.data)
            }));
        })
    }, "bars")), A.includes("grid") && (gt.grid = (0, $824c049f32d4395d$exports.jsx)((0, $61394014a6be57c7$export$ef2184bd89960b14), {
        width: Ze,
        height: $e,
        xScale: H ? it : null,
        yScale: F ? nt : null,
        xValues: X,
        yValues: Y
    }, "grid")), A.includes("legends") && (gt.legends = (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$var$J, {
        width: Ze,
        height: $e,
        legends: st,
        toggleSerie: ct
    }, "legends")), A.includes("markers") && (gt.markers = (0, $824c049f32d4395d$exports.jsx)((0, $ceac9f6897e0c09e$export$81759e11f9e58ea4), {
        markers: ie,
        width: Ze,
        height: $e,
        xScale: it,
        yScale: nt
    }, "markers")), A.includes("totals") && Ge && (gt.totals = (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$export$aae8d1f6490d80ef, {
        data: ht,
        springConfig: Ke,
        animate: qe,
        layout: v
    }, "totals"));
    var mt = (0, $7fPBF.useMemo)(function() {
        return $6f6e62123bc42f02$var$j({}, bt, {
            margin: Ue,
            width: o,
            height: d,
            innerWidth: Ze,
            innerHeight: $e,
            bars: tt,
            legendData: st,
            enableLabel: q,
            xScale: it,
            yScale: nt,
            tooltip: we,
            getTooltipLabel: rt,
            onClick: Le,
            onMouseEnter: Me,
            onMouseLeave: We
        });
    }, [
        bt,
        Ue,
        o,
        d,
        Ze,
        $e,
        tt,
        st,
        q,
        it,
        nt,
        we,
        rt,
        Le,
        Me,
        We
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $ceac9f6897e0c09e$export$21d9f1931ef75b56), {
        width: Je,
        height: Qe,
        margin: Ue,
        defs: vt,
        role: Ie,
        ariaLabel: Oe,
        ariaLabelledBy: Ee,
        ariaDescribedBy: Re,
        isFocusable: Pe,
        children: A.map(function(e, t) {
            var a;
            return "function" == typeof e ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: (0, $7fPBF.createElement)(e, mt)
            }, t) : null != (a = null == gt ? void 0 : gt[e]) ? a : null;
        })
    });
}, $6f6e62123bc42f02$export$bbc6c6369b38e3d1 = function(e) {
    var t = e.isInteractive, a = void 0 === t ? $6f6e62123bc42f02$export$82f4948cbf358702.isInteractive : t, i = e.animate, n = void 0 === i ? $6f6e62123bc42f02$export$82f4948cbf358702.animate : i, l = e.motionConfig, r = void 0 === l ? $6f6e62123bc42f02$export$82f4948cbf358702.motionConfig : l, o = e.theme, u = e.renderWrapper, c = $6f6e62123bc42f02$var$q(e, $6f6e62123bc42f02$var$Me);
    return (0, $824c049f32d4395d$exports.jsx)((0, $ceac9f6897e0c09e$export$42a852a2b6b56249), {
        animate: n,
        isInteractive: a,
        motionConfig: r,
        renderWrapper: u,
        theme: o,
        children: (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$var$We, $6f6e62123bc42f02$var$j({
            isInteractive: a
        }, c))
    });
}, $6f6e62123bc42f02$var$Be = [
    "isInteractive",
    "renderWrapper",
    "theme"
], $6f6e62123bc42f02$var$Ie = function(e, t, a, i) {
    return e.find(function(e) {
        return (0, $ceac9f6897e0c09e$export$be302859f014f482)(e.x + t.left, e.y + t.top, e.width, e.height, a, i);
    });
};
var $6f6e62123bc42f02$var$Oe = function(e) {
    var t = e.data, l = e.indexBy, r = e.keys, d = e.margin, u = e.width, s = e.height, h = e.groupMode, f = e.layout, v = e.reverse, g = e.minValue, m = e.maxValue, p = e.valueScale, y = e.indexScale, w = e.padding, L = e.innerPadding, C = e.axisTop, T = e.axisRight, E = e.axisBottom, R = void 0 === E ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.axisBottom : E, H = e.axisLeft, F = void 0 === H ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.axisLeft : H, X = e.enableGridX, D = void 0 === X ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.enableGridX : X, A = e.enableGridY, G = void 0 === A ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.enableGridY : A, z = e.gridXValues, N = e.gridYValues, q = e.layers, K = void 0 === q ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.layers : q, _ = e.renderBar, J = void 0 === _ ? function(e, t) {
        var a = t.bar, i = a.color, n = a.height, l = a.width, r = a.x, o = a.y, d = t.borderColor, u = t.borderRadius, c = t.borderWidth, s = t.label, h = t.labelColor, f = t.shouldRenderLabel;
        if (e.fillStyle = i, c > 0 && (e.strokeStyle = d, e.lineWidth = c), e.beginPath(), u > 0) {
            var b = Math.min(u, n);
            e.moveTo(r + b, o), e.lineTo(r + l - b, o), e.quadraticCurveTo(r + l, o, r + l, o + b), e.lineTo(r + l, o + n - b), e.quadraticCurveTo(r + l, o + n, r + l - b, o + n), e.lineTo(r + b, o + n), e.quadraticCurveTo(r, o + n, r, o + n - b), e.lineTo(r, o + b), e.quadraticCurveTo(r, o, r + b, o), e.closePath();
        } else e.rect(r, o, l, n);
        e.fill(), c > 0 && e.stroke(), f && (e.textBaseline = "middle", e.textAlign = "center", e.fillStyle = h, e.fillText(s, r + l / 2, o + n / 2));
    } : _, Q = e.enableLabel, U = void 0 === Q ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.enableLabel : Q, Z = e.label, $ = e.labelSkipWidth, ee = void 0 === $ ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.labelSkipWidth : $, te = e.labelSkipHeight, ie = void 0 === te ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.labelSkipHeight : te, ne = e.labelTextColor, le = e.colorBy, re = e.colors, oe = e.borderRadius, de = void 0 === oe ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.borderRadius : oe, ue = e.borderWidth, ce = void 0 === ue ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.borderWidth : ue, se = e.borderColor, he = e.annotations, fe = void 0 === he ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.annotations : he, be = e.legendLabel, ve = e.tooltipLabel, ge = e.valueFormat, me = e.isInteractive, pe = void 0 === me ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.isInteractive : me, ye = e.tooltip, xe = void 0 === ye ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.tooltip : ye, Se = e.onClick, ke = e.onMouseEnter, we = e.onMouseLeave, Le = e.legends, Ve = e.pixelRatio, Me = void 0 === Ve ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.pixelRatio : Ve, We = e.canvasRef, Te = e.enableTotals, Be = void 0 === Te ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.enableTotals : Te, Oe = e.totalsOffset, Ee = void 0 === Oe ? $6f6e62123bc42f02$export$b14a24a807ef5c0b.totalsOffset : Oe, Re = (0, $7fPBF.useRef)(null), He = (0, $ceac9f6897e0c09e$export$93d4e7f90805808f)(), Pe = (0, $ceac9f6897e0c09e$export$d04af0e501fb729f)(u, s, d), Fe = Pe.margin, Xe = Pe.innerWidth, Ye = Pe.innerHeight, De = Pe.outerWidth, Ae = Pe.outerHeight, Ge = $6f6e62123bc42f02$var$Ce({
        indexBy: l,
        label: Z,
        tooltipLabel: ve,
        valueFormat: ge,
        colors: re,
        colorBy: le,
        borderColor: se,
        labelTextColor: ne,
        groupMode: h,
        layout: f,
        reverse: v,
        data: t,
        keys: r,
        minValue: g,
        maxValue: m,
        margin: Fe,
        width: Xe,
        height: Ye,
        padding: w,
        innerPadding: L,
        valueScale: p,
        indexScale: y,
        enableLabel: U,
        labelSkipWidth: ee,
        labelSkipHeight: ie,
        legends: Le,
        legendLabel: be,
        totalsOffset: Ee
    }), ze = Ge.bars, Ne = Ge.barsWithValue, je = Ge.xScale, qe = Ge.yScale, Ke = Ge.getLabel, _e = Ge.getTooltipLabel, Je = Ge.getBorderColor, Qe = Ge.getLabelColor, Ue = Ge.shouldRenderBarLabel, Ze = Ge.legendsWithData, $e = Ge.barTotals, et = (0, $ad81ce180dd1d3ec$export$1c4b08e0eca38426)(), tt = et.showTooltipFromEvent, at = et.hideTooltip, it = (0, $f962d83699f3530e$export$c11be6015db56468)({
        annotations: (0, $f962d83699f3530e$export$ede9be424e8ef89a)({
            data: ze,
            annotations: fe,
            getPosition: function(e) {
                return {
                    x: e.x,
                    y: e.y
                };
            },
            getDimensions: function(e) {
                var t = e.width, a = e.height;
                return {
                    width: t,
                    height: a,
                    size: Math.max(t, a)
                };
            }
        })
    }), nt = (0, $7fPBF.useMemo)(function() {
        return {
            borderRadius: de,
            borderWidth: ce,
            isInteractive: pe,
            isFocusable: !1,
            labelSkipWidth: ee,
            labelSkipHeight: ie,
            margin: Fe,
            width: u,
            height: s,
            innerWidth: Xe,
            innerHeight: Ye,
            bars: ze,
            legendData: Ze,
            enableLabel: U,
            xScale: je,
            yScale: qe,
            tooltip: xe,
            getTooltipLabel: _e,
            onClick: Se,
            onMouseEnter: ke,
            onMouseLeave: we
        };
    }, [
        de,
        ce,
        pe,
        ee,
        ie,
        Fe,
        u,
        s,
        Xe,
        Ye,
        ze,
        Ze,
        U,
        je,
        qe,
        xe,
        _e,
        Se,
        ke,
        we
    ]), lt = (0, $ceac9f6897e0c09e$export$422f9765e6971fdf)(ge);
    (0, $7fPBF.useEffect)(function() {
        var e, t = null == (e = Re.current) ? void 0 : e.getContext("2d");
        Re.current && t && (Re.current.width = De * Me, Re.current.height = Ae * Me, t.scale(Me, Me), t.fillStyle = He.background, t.fillRect(0, 0, De, Ae), t.translate(Fe.left, Fe.top), K.forEach(function(e) {
            "grid" === e ? "number" == typeof He.grid.line.strokeWidth && He.grid.line.strokeWidth > 0 && (t.lineWidth = He.grid.line.strokeWidth, t.strokeStyle = He.grid.line.stroke, D && (0, $61394014a6be57c7$export$5eea7e798580e5d1)(t, {
                width: Xe,
                height: Ye,
                scale: je,
                axis: "x",
                values: z
            }), G && (0, $61394014a6be57c7$export$5eea7e798580e5d1)(t, {
                width: Xe,
                height: Ye,
                scale: qe,
                axis: "y",
                values: N
            })) : "axes" === e ? (0, $61394014a6be57c7$export$6f12c0e853c1bfff)(t, {
                xScale: je,
                yScale: qe,
                width: Xe,
                height: Ye,
                top: C,
                right: T,
                bottom: R,
                left: F,
                theme: He
            }) : "bars" === e ? Ne.forEach(function(e) {
                J(t, {
                    bar: e,
                    borderColor: Je(e),
                    borderRadius: de,
                    borderWidth: ce,
                    label: Ke(e.data),
                    labelColor: Qe(e),
                    shouldRenderLabel: Ue(e)
                });
            }) : "legends" === e ? Ze.forEach(function(e) {
                var a = e[0], i = e[1];
                (0, $06815ec2120bfaa3$export$28c0156604402604)(t, $6f6e62123bc42f02$var$j({}, a, {
                    data: i,
                    containerWidth: Xe,
                    containerHeight: Ye,
                    theme: He
                }));
            }) : "annotations" === e ? (0, $f962d83699f3530e$export$630dcbe11859bd26)(t, {
                annotations: it,
                theme: He
            }) : "totals" === e && Be ? function(e, t, a, i) {
                void 0 === i && (i = $6f6e62123bc42f02$export$b14a24a807ef5c0b.layout), e.fillStyle = a.text.fill, e.font = "bold " + a.labels.text.fontSize + "px " + a.labels.text.fontFamily, e.textBaseline = "vertical" === i ? "alphabetic" : "middle", e.textAlign = "vertical" === i ? "center" : "start", t.forEach(function(t) {
                    e.fillText(t.formattedValue, t.x, t.y);
                });
            }(t, $e, He, f) : "function" == typeof e && e(t, nt);
        }), t.save());
    }, [
        R,
        F,
        T,
        C,
        Ne,
        de,
        ce,
        it,
        D,
        G,
        Je,
        Ke,
        Qe,
        z,
        N,
        h,
        s,
        Ye,
        Xe,
        nt,
        K,
        f,
        Ze,
        Fe.left,
        Fe.top,
        Ae,
        De,
        Me,
        J,
        je,
        qe,
        v,
        Ue,
        He,
        u,
        $e,
        Be,
        lt
    ]);
    var rt = (0, $7fPBF.useCallback)(function(e) {
        if (ze && Re.current) {
            var t = (0, $ceac9f6897e0c09e$export$2396fb9a7906fd81)(Re.current, e), a = t[0], i = t[1], n = $6f6e62123bc42f02$var$Ie(ze, Fe, a, i);
            void 0 !== n ? (tt((0, $7fPBF.createElement)(xe, $6f6e62123bc42f02$var$j({}, n.data, {
                color: n.color,
                label: n.label,
                value: Number(n.data.value)
            })), e), "mouseenter" === e.type && (null == ke || ke(n.data, e))) : at();
        }
    }, [
        at,
        Fe,
        ke,
        ze,
        tt,
        xe
    ]), ot = (0, $7fPBF.useCallback)(function(e) {
        if (ze && Re.current) {
            at();
            var t = (0, $ceac9f6897e0c09e$export$2396fb9a7906fd81)(Re.current, e), a = t[0], i = t[1], n = $6f6e62123bc42f02$var$Ie(ze, Fe, a, i);
            n && (null == we || we(n.data, e));
        }
    }, [
        at,
        Fe,
        we,
        ze
    ]), dt = (0, $7fPBF.useCallback)(function(e) {
        if (ze && Re.current) {
            var t = (0, $ceac9f6897e0c09e$export$2396fb9a7906fd81)(Re.current, e), a = t[0], i = t[1], n = $6f6e62123bc42f02$var$Ie(ze, Fe, a, i);
            void 0 !== n && (null == Se || Se($6f6e62123bc42f02$var$j({}, n.data, {
                color: n.color
            }), e));
        }
    }, [
        Fe,
        Se,
        ze
    ]);
    return (0, $824c049f32d4395d$exports.jsx)("canvas", {
        ref: function(e) {
            Re.current = e, We && "current" in We && (We.current = e);
        },
        width: De * Me,
        height: Ae * Me,
        style: {
            width: De,
            height: Ae,
            cursor: pe ? "auto" : "normal"
        },
        onMouseEnter: pe ? rt : void 0,
        onMouseMove: pe ? rt : void 0,
        onMouseLeave: pe ? ot : void 0,
        onClick: pe ? dt : void 0
    });
}, $6f6e62123bc42f02$export$2b551fec43592504 = (0, $7fPBF.forwardRef)(function(e, t) {
    var a = e.isInteractive, i = e.renderWrapper, n = e.theme, l = $6f6e62123bc42f02$var$q(e, $6f6e62123bc42f02$var$Be);
    return (0, $824c049f32d4395d$exports.jsx)((0, $ceac9f6897e0c09e$export$42a852a2b6b56249), {
        isInteractive: a,
        renderWrapper: i,
        theme: n,
        animate: !1,
        children: (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$var$Oe, $6f6e62123bc42f02$var$j({}, l, {
            canvasRef: t
        }))
    });
}), $6f6e62123bc42f02$export$5b685d9928bc009b = function(e) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $ceac9f6897e0c09e$export$fa6e408d6a7d6214), {
        children: function(t) {
            var a = t.width, i = t.height;
            return (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$export$bbc6c6369b38e3d1, $6f6e62123bc42f02$var$j({
                width: a,
                height: i
            }, e));
        }
    });
}, $6f6e62123bc42f02$export$7124a4751b3aada7 = (0, $7fPBF.forwardRef)(function(e, t) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $ceac9f6897e0c09e$export$fa6e408d6a7d6214), {
        children: function(a) {
            var i = a.width, n = a.height;
            return (0, $824c049f32d4395d$exports.jsx)($6f6e62123bc42f02$export$2b551fec43592504, $6f6e62123bc42f02$var$j({
                width: i,
                height: n
            }, e, {
                ref: t
            }));
        }
    });
});


const $2271a15ec0eb9832$var$colors = [
    "#1797F2",
    "#92D050",
    "#BB6DCE",
    "#FFD600",
    "#ED1C23",
    "#2E3192"
];
// useTheme somehow didn't work here, so we define a simple tooltip component instead of using CustomTooltip
// TODO this is actually a nice non-intrusive tooltip, we may want to reapply this styling to others
function $2271a15ec0eb9832$var$Tooltip(bar) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "text-gray-700 text-xs bg-white bg-opacity-80 p-0.5",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "font-bold",
                children: bar.id
            }),
            `: ${Number(bar.value).toLocaleString("de", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`
        ]
    });
}
function $2271a15ec0eb9832$var$makeNivoRenderer(traceOptions = {}, layoutOptions = {}, transpose = false) {
    return function NivoRenderer(props) {
        const timer = Date.now();
        // console.log('DEBUG BarChart started with props:', props);
        const pivotData = new (0, $25ed1e0e429105db$exports.PivotData)(props);
        const rowKeys = pivotData.getRowKeys();
        const colKeys = pivotData.getColKeys();
        let fullAggName = props.aggregatorName;
        const numInputs = props.aggregators[fullAggName]([])().numInputs || 0;
        if (numInputs !== 0) fullAggName += ` of ${props.vals.slice(0, numInputs).join(", ")}`;
        console.log("rowKeys", rowKeys); // all the possible combinations of main key category fields [[2015, 'DKB Giro'], [2017, 'Festgeld'],[2019, 'Festgeld'] ...]
        console.log("colKeys", colKeys); // all the possible combinations of the secondary key category fields [['American Express', 'EUR'], ['Arbeitgeber AG', 'EUR'], ['Avis AG', 'EUR']...]
        console.log("pivotData with props", pivotData);
        // rowKeys and colKeys have all the needed combinations of keys already
        // e.g. [[2015, 'EUR'], [2015, 'USD'], [2016, 'EUR'], [2017, 'EUR']]
        // even if there are more than 1 attribute in each group
        // so all that needs to happen is to produce for each object (which is an array) in rowKeys
        // an object with the joinedKey
        const rowNames = pivotData.props.rows; // ["Date (Year)", "accountName"]
        const colNames = pivotData.props.cols; // names of the fields that go to secondary category ["otherParty", "currency"]
        // bar chart input object looks like the following:
        // [ {
        //   main-category-field-name: main-category-key,
        //   secondary-category-key1: secondary-category-value,
        //   secondary-category-key2: secondary-category-value ...
        // }]
        function joinKeys(keys) {
            return Array.isArray(keys) ? keys.join(" - ") : keys;
        }
        const mainCategory = rowNames.join(" ");
        const secondaryCategories = colKeys.map((colName)=>joinKeys(colName)); // used to display the bar's category
        // const secondaryCategories = joinKeys(colNames);
        let data = [];
        // this has all unique values organised by field name, i.e.:
        // { 'Date (Year)': [2015, 2016, 2017, 2018, 2019], 'accountName': ['DKB Giro', 'Festgeld', 'Girokonto', 'Kreditkarte', 'Sparkonto'], ... }
        // the sequence of keys is the hierarchy structure, i.e.: first object goes on top level, then the next object goes as a child of the first object, etc.
        // TODO this has some room for improvement, because this includes all possible combinations of keys, and not only those with data
        // generate the standard data structure
        data = rowKeys.map((rowKey)=>{
            const joinedKey = joinKeys(rowKey);
            const row = {
                [mainCategory]: joinedKey
            };
            colKeys.forEach((colKey)=>{
                const col = joinKeys(colKey);
                row[col] = pivotData.getAggregator(rowKey, colKey).value();
            });
            return row;
        });
        // if there is a lot of data elements, use canvas instead of svg (because the latter takes 10s+ to render)
        const complexity = data.length * secondaryCategories.length;
        const NivoChart = complexity > 1000 ? (0, $6f6e62123bc42f02$export$7124a4751b3aada7) : (0, $6f6e62123bc42f02$export$5b685d9928bc009b);
        let chartProps = (0, $9tqwB._)({
            margin: {
                top: 16,
                right: 60,
                bottom: 24,
                left: 16
            },
            groupMode: "grouped",
            colors: $2271a15ec0eb9832$var$colors,
            theme: {
                fontFamily: "Lato"
            },
            padding: 0.2,
            labelTextColor: "inherit:darker(1.4)",
            labelSkipWidth: 16,
            labelSkipHeight: 16,
            label: false
        }, props.layoutOptions);
        chartProps = (0, $2qxEV._)((0, $9tqwB._)({}, chartProps), {
            data: data,
            indexBy: mainCategory,
            keys: secondaryCategories
        });
        // FIXME: how to keep this a rolling last 12M filter?)
        // if (!props.layoutOptions.mode) {
        // chartProps.width = props.layoutOptions.width || 900;
        // chartProps.height = props.layoutOptions.height || 400;
        // }
        if (layoutOptions.mode === "diverging-stacked") chartProps = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, chartProps), {
            groupMode: "stacked",
            padding: 0.45,
            innerPadding: 2,
            axisLeft: null,
            axisRight: {
                format: (v)=>v.toLocaleString("de", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
            },
            axisBottom: null,
            tooltip: $2271a15ec0eb9832$var$Tooltip
        }), props.layoutOptions);
        // console.log('DEBUG BarChart finished in', Date.now() - timer, 'ms', 'with data', data);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NivoChart, (0, $9tqwB._)({}, chartProps));
    };
}
function $2271a15ec0eb9832$export$2e2bcd8739ae039() {
    return {
        "Bar chart, vertical, grouped": $2271a15ec0eb9832$var$makeNivoRenderer(),
        "Bar chart, vertical, diverging, stacked": $2271a15ec0eb9832$var$makeNivoRenderer(null, {
            mode: "diverging-stacked"
        })
    };
}


/* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ 
var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");



function $9d0376a7d321edca$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $9d0376a7d321edca$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $9d0376a7d321edca$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $9d0376a7d321edca$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $9d0376a7d321edca$var$formatRe(locale_periods), periodLookup = $9d0376a7d321edca$var$formatLookup(locale_periods), weekdayRe = $9d0376a7d321edca$var$formatRe(locale_weekdays), weekdayLookup = $9d0376a7d321edca$var$formatLookup(locale_weekdays), shortWeekdayRe = $9d0376a7d321edca$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $9d0376a7d321edca$var$formatLookup(locale_shortWeekdays), monthRe = $9d0376a7d321edca$var$formatRe(locale_months), monthLookup = $9d0376a7d321edca$var$formatLookup(locale_months), shortMonthRe = $9d0376a7d321edca$var$formatRe(locale_shortMonths), shortMonthLookup = $9d0376a7d321edca$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $9d0376a7d321edca$var$formatDayOfMonth,
        "e": $9d0376a7d321edca$var$formatDayOfMonth,
        "f": $9d0376a7d321edca$var$formatMicroseconds,
        "g": $9d0376a7d321edca$var$formatYearISO,
        "G": $9d0376a7d321edca$var$formatFullYearISO,
        "H": $9d0376a7d321edca$var$formatHour24,
        "I": $9d0376a7d321edca$var$formatHour12,
        "j": $9d0376a7d321edca$var$formatDayOfYear,
        "L": $9d0376a7d321edca$var$formatMilliseconds,
        "m": $9d0376a7d321edca$var$formatMonthNumber,
        "M": $9d0376a7d321edca$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $9d0376a7d321edca$var$formatUnixTimestamp,
        "s": $9d0376a7d321edca$var$formatUnixTimestampSeconds,
        "S": $9d0376a7d321edca$var$formatSeconds,
        "u": $9d0376a7d321edca$var$formatWeekdayNumberMonday,
        "U": $9d0376a7d321edca$var$formatWeekNumberSunday,
        "V": $9d0376a7d321edca$var$formatWeekNumberISO,
        "w": $9d0376a7d321edca$var$formatWeekdayNumberSunday,
        "W": $9d0376a7d321edca$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $9d0376a7d321edca$var$formatYear,
        "Y": $9d0376a7d321edca$var$formatFullYear,
        "Z": $9d0376a7d321edca$var$formatZone,
        "%": $9d0376a7d321edca$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $9d0376a7d321edca$var$formatUTCDayOfMonth,
        "e": $9d0376a7d321edca$var$formatUTCDayOfMonth,
        "f": $9d0376a7d321edca$var$formatUTCMicroseconds,
        "g": $9d0376a7d321edca$var$formatUTCYearISO,
        "G": $9d0376a7d321edca$var$formatUTCFullYearISO,
        "H": $9d0376a7d321edca$var$formatUTCHour24,
        "I": $9d0376a7d321edca$var$formatUTCHour12,
        "j": $9d0376a7d321edca$var$formatUTCDayOfYear,
        "L": $9d0376a7d321edca$var$formatUTCMilliseconds,
        "m": $9d0376a7d321edca$var$formatUTCMonthNumber,
        "M": $9d0376a7d321edca$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $9d0376a7d321edca$var$formatUnixTimestamp,
        "s": $9d0376a7d321edca$var$formatUnixTimestampSeconds,
        "S": $9d0376a7d321edca$var$formatUTCSeconds,
        "u": $9d0376a7d321edca$var$formatUTCWeekdayNumberMonday,
        "U": $9d0376a7d321edca$var$formatUTCWeekNumberSunday,
        "V": $9d0376a7d321edca$var$formatUTCWeekNumberISO,
        "w": $9d0376a7d321edca$var$formatUTCWeekdayNumberSunday,
        "W": $9d0376a7d321edca$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $9d0376a7d321edca$var$formatUTCYear,
        "Y": $9d0376a7d321edca$var$formatUTCFullYear,
        "Z": $9d0376a7d321edca$var$formatUTCZone,
        "%": $9d0376a7d321edca$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $9d0376a7d321edca$var$parseDayOfMonth,
        "e": $9d0376a7d321edca$var$parseDayOfMonth,
        "f": $9d0376a7d321edca$var$parseMicroseconds,
        "g": $9d0376a7d321edca$var$parseYear,
        "G": $9d0376a7d321edca$var$parseFullYear,
        "H": $9d0376a7d321edca$var$parseHour24,
        "I": $9d0376a7d321edca$var$parseHour24,
        "j": $9d0376a7d321edca$var$parseDayOfYear,
        "L": $9d0376a7d321edca$var$parseMilliseconds,
        "m": $9d0376a7d321edca$var$parseMonthNumber,
        "M": $9d0376a7d321edca$var$parseMinutes,
        "p": parsePeriod,
        "q": $9d0376a7d321edca$var$parseQuarter,
        "Q": $9d0376a7d321edca$var$parseUnixTimestamp,
        "s": $9d0376a7d321edca$var$parseUnixTimestampSeconds,
        "S": $9d0376a7d321edca$var$parseSeconds,
        "u": $9d0376a7d321edca$var$parseWeekdayNumberMonday,
        "U": $9d0376a7d321edca$var$parseWeekNumberSunday,
        "V": $9d0376a7d321edca$var$parseWeekNumberISO,
        "w": $9d0376a7d321edca$var$parseWeekdayNumberSunday,
        "W": $9d0376a7d321edca$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $9d0376a7d321edca$var$parseYear,
        "Y": $9d0376a7d321edca$var$parseFullYear,
        "Z": $9d0376a7d321edca$var$parseZone,
        "%": $9d0376a7d321edca$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $9d0376a7d321edca$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $9d0376a7d321edca$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $9d0376a7d321edca$var$utcDate($9d0376a7d321edca$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).ceil(week) : (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)(week);
                    week = (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $9d0376a7d321edca$var$localDate($9d0376a7d321edca$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).ceil(week) : (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8)(week);
                    week = (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $9d0376a7d321edca$var$utcDate($9d0376a7d321edca$var$newDate(d.y, 0, 1)).getUTCDay() : $9d0376a7d321edca$var$localDate($9d0376a7d321edca$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $9d0376a7d321edca$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $9d0376a7d321edca$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $9d0376a7d321edca$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $9d0376a7d321edca$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $9d0376a7d321edca$var$numberRe = /^\s*\d+/, $9d0376a7d321edca$var$percentRe = /^%/, $9d0376a7d321edca$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $9d0376a7d321edca$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $9d0376a7d321edca$var$requote(s) {
    return s.replace($9d0376a7d321edca$var$requoteRe, "\\$&");
}
function $9d0376a7d321edca$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($9d0376a7d321edca$var$requote).join("|") + ")", "i");
}
function $9d0376a7d321edca$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $9d0376a7d321edca$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseWeekNumberSunday(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseWeekNumberISO(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseWeekNumberMonday(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseFullYear(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseYear(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseQuarter(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseMonthNumber(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseDayOfMonth(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseDayOfYear(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseHour24(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseMinutes(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseSeconds(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseMilliseconds(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseMicroseconds(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseLiteralPercent(d, string, i) {
    var n = $9d0376a7d321edca$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $9d0376a7d321edca$var$parseUnixTimestamp(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $9d0376a7d321edca$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $9d0376a7d321edca$var$formatDayOfMonth(d, p) {
    return $9d0376a7d321edca$var$pad(d.getDate(), p, 2);
}
function $9d0376a7d321edca$var$formatHour24(d, p) {
    return $9d0376a7d321edca$var$pad(d.getHours(), p, 2);
}
function $9d0376a7d321edca$var$formatHour12(d, p) {
    return $9d0376a7d321edca$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $9d0376a7d321edca$var$formatDayOfYear(d, p) {
    return $9d0376a7d321edca$var$pad(1 + (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $9d0376a7d321edca$var$formatMilliseconds(d, p) {
    return $9d0376a7d321edca$var$pad(d.getMilliseconds(), p, 3);
}
function $9d0376a7d321edca$var$formatMicroseconds(d, p) {
    return $9d0376a7d321edca$var$formatMilliseconds(d, p) + "000";
}
function $9d0376a7d321edca$var$formatMonthNumber(d, p) {
    return $9d0376a7d321edca$var$pad(d.getMonth() + 1, p, 2);
}
function $9d0376a7d321edca$var$formatMinutes(d, p) {
    return $9d0376a7d321edca$var$pad(d.getMinutes(), p, 2);
}
function $9d0376a7d321edca$var$formatSeconds(d, p) {
    return $9d0376a7d321edca$var$pad(d.getSeconds(), p, 2);
}
function $9d0376a7d321edca$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $9d0376a7d321edca$var$formatWeekNumberSunday(d, p) {
    return $9d0376a7d321edca$var$pad((0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $9d0376a7d321edca$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
}
function $9d0376a7d321edca$var$formatWeekNumberISO(d, p) {
    d = $9d0376a7d321edca$var$dISO(d);
    return $9d0376a7d321edca$var$pad((0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d) + ((0, $c352773cb286f235$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $9d0376a7d321edca$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $9d0376a7d321edca$var$formatWeekNumberMonday(d, p) {
    return $9d0376a7d321edca$var$pad((0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $9d0376a7d321edca$var$formatYear(d, p) {
    return $9d0376a7d321edca$var$pad(d.getFullYear() % 100, p, 2);
}
function $9d0376a7d321edca$var$formatYearISO(d, p) {
    d = $9d0376a7d321edca$var$dISO(d);
    return $9d0376a7d321edca$var$pad(d.getFullYear() % 100, p, 2);
}
function $9d0376a7d321edca$var$formatFullYear(d, p) {
    return $9d0376a7d321edca$var$pad(d.getFullYear() % 10000, p, 4);
}
function $9d0376a7d321edca$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
    return $9d0376a7d321edca$var$pad(d.getFullYear() % 10000, p, 4);
}
function $9d0376a7d321edca$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $9d0376a7d321edca$var$pad(z / 60 | 0, "0", 2) + $9d0376a7d321edca$var$pad(z % 60, "0", 2);
}
function $9d0376a7d321edca$var$formatUTCDayOfMonth(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCDate(), p, 2);
}
function $9d0376a7d321edca$var$formatUTCHour24(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCHours(), p, 2);
}
function $9d0376a7d321edca$var$formatUTCHour12(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $9d0376a7d321edca$var$formatUTCDayOfYear(d, p) {
    return $9d0376a7d321edca$var$pad(1 + (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $9d0376a7d321edca$var$formatUTCMilliseconds(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $9d0376a7d321edca$var$formatUTCMicroseconds(d, p) {
    return $9d0376a7d321edca$var$formatUTCMilliseconds(d, p) + "000";
}
function $9d0376a7d321edca$var$formatUTCMonthNumber(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $9d0376a7d321edca$var$formatUTCMinutes(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCMinutes(), p, 2);
}
function $9d0376a7d321edca$var$formatUTCSeconds(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCSeconds(), p, 2);
}
function $9d0376a7d321edca$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $9d0376a7d321edca$var$formatUTCWeekNumberSunday(d, p) {
    return $9d0376a7d321edca$var$pad((0, $24ffb3b67dc2c085$export$4898b06303a92011).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $9d0376a7d321edca$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
}
function $9d0376a7d321edca$var$formatUTCWeekNumberISO(d, p) {
    d = $9d0376a7d321edca$var$UTCdISO(d);
    return $9d0376a7d321edca$var$pad((0, $24ffb3b67dc2c085$export$1db08111baec2f53).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d) + ((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $9d0376a7d321edca$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $9d0376a7d321edca$var$formatUTCWeekNumberMonday(d, p) {
    return $9d0376a7d321edca$var$pad((0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $9d0376a7d321edca$var$formatUTCYear(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $9d0376a7d321edca$var$formatUTCYearISO(d, p) {
    d = $9d0376a7d321edca$var$UTCdISO(d);
    return $9d0376a7d321edca$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $9d0376a7d321edca$var$formatUTCFullYear(d, p) {
    return $9d0376a7d321edca$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $9d0376a7d321edca$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
    return $9d0376a7d321edca$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $9d0376a7d321edca$var$formatUTCZone() {
    return "+0000";
}
function $9d0376a7d321edca$var$formatLiteralPercent() {
    return "%";
}
function $9d0376a7d321edca$var$formatUnixTimestamp(d) {
    return +d;
}
function $9d0376a7d321edca$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $1e720291e3822a7d$var$locale;
var $1e720291e3822a7d$export$94f4d87fad5dcf9a;
var $1e720291e3822a7d$export$32b9cd16e1b8c8d2;
var $1e720291e3822a7d$export$1a08fe38f63ebbbb;
var $1e720291e3822a7d$export$3edae9cf8e233729;
$1e720291e3822a7d$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $1e720291e3822a7d$export$2e2bcd8739ae039(definition) {
    $1e720291e3822a7d$var$locale = (0, $9d0376a7d321edca$export$2e2bcd8739ae039)(definition);
    $1e720291e3822a7d$export$94f4d87fad5dcf9a = $1e720291e3822a7d$var$locale.format;
    $1e720291e3822a7d$export$32b9cd16e1b8c8d2 = $1e720291e3822a7d$var$locale.parse;
    $1e720291e3822a7d$export$1a08fe38f63ebbbb = $1e720291e3822a7d$var$locale.utcFormat;
    $1e720291e3822a7d$export$3edae9cf8e233729 = $1e720291e3822a7d$var$locale.utcParse;
    return $1e720291e3822a7d$var$locale;
}









function $119c320a1b5d012c$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $119c320a1b5d012c$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $119c320a1b5d012c$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $119c320a1b5d012c$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $119c320a1b5d012c$var$formatRe(locale_periods), periodLookup = $119c320a1b5d012c$var$formatLookup(locale_periods), weekdayRe = $119c320a1b5d012c$var$formatRe(locale_weekdays), weekdayLookup = $119c320a1b5d012c$var$formatLookup(locale_weekdays), shortWeekdayRe = $119c320a1b5d012c$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $119c320a1b5d012c$var$formatLookup(locale_shortWeekdays), monthRe = $119c320a1b5d012c$var$formatRe(locale_months), monthLookup = $119c320a1b5d012c$var$formatLookup(locale_months), shortMonthRe = $119c320a1b5d012c$var$formatRe(locale_shortMonths), shortMonthLookup = $119c320a1b5d012c$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $119c320a1b5d012c$var$formatDayOfMonth,
        "e": $119c320a1b5d012c$var$formatDayOfMonth,
        "f": $119c320a1b5d012c$var$formatMicroseconds,
        "g": $119c320a1b5d012c$var$formatYearISO,
        "G": $119c320a1b5d012c$var$formatFullYearISO,
        "H": $119c320a1b5d012c$var$formatHour24,
        "I": $119c320a1b5d012c$var$formatHour12,
        "j": $119c320a1b5d012c$var$formatDayOfYear,
        "L": $119c320a1b5d012c$var$formatMilliseconds,
        "m": $119c320a1b5d012c$var$formatMonthNumber,
        "M": $119c320a1b5d012c$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $119c320a1b5d012c$var$formatUnixTimestamp,
        "s": $119c320a1b5d012c$var$formatUnixTimestampSeconds,
        "S": $119c320a1b5d012c$var$formatSeconds,
        "u": $119c320a1b5d012c$var$formatWeekdayNumberMonday,
        "U": $119c320a1b5d012c$var$formatWeekNumberSunday,
        "V": $119c320a1b5d012c$var$formatWeekNumberISO,
        "w": $119c320a1b5d012c$var$formatWeekdayNumberSunday,
        "W": $119c320a1b5d012c$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $119c320a1b5d012c$var$formatYear,
        "Y": $119c320a1b5d012c$var$formatFullYear,
        "Z": $119c320a1b5d012c$var$formatZone,
        "%": $119c320a1b5d012c$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $119c320a1b5d012c$var$formatUTCDayOfMonth,
        "e": $119c320a1b5d012c$var$formatUTCDayOfMonth,
        "f": $119c320a1b5d012c$var$formatUTCMicroseconds,
        "g": $119c320a1b5d012c$var$formatUTCYearISO,
        "G": $119c320a1b5d012c$var$formatUTCFullYearISO,
        "H": $119c320a1b5d012c$var$formatUTCHour24,
        "I": $119c320a1b5d012c$var$formatUTCHour12,
        "j": $119c320a1b5d012c$var$formatUTCDayOfYear,
        "L": $119c320a1b5d012c$var$formatUTCMilliseconds,
        "m": $119c320a1b5d012c$var$formatUTCMonthNumber,
        "M": $119c320a1b5d012c$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $119c320a1b5d012c$var$formatUnixTimestamp,
        "s": $119c320a1b5d012c$var$formatUnixTimestampSeconds,
        "S": $119c320a1b5d012c$var$formatUTCSeconds,
        "u": $119c320a1b5d012c$var$formatUTCWeekdayNumberMonday,
        "U": $119c320a1b5d012c$var$formatUTCWeekNumberSunday,
        "V": $119c320a1b5d012c$var$formatUTCWeekNumberISO,
        "w": $119c320a1b5d012c$var$formatUTCWeekdayNumberSunday,
        "W": $119c320a1b5d012c$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $119c320a1b5d012c$var$formatUTCYear,
        "Y": $119c320a1b5d012c$var$formatUTCFullYear,
        "Z": $119c320a1b5d012c$var$formatUTCZone,
        "%": $119c320a1b5d012c$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $119c320a1b5d012c$var$parseDayOfMonth,
        "e": $119c320a1b5d012c$var$parseDayOfMonth,
        "f": $119c320a1b5d012c$var$parseMicroseconds,
        "g": $119c320a1b5d012c$var$parseYear,
        "G": $119c320a1b5d012c$var$parseFullYear,
        "H": $119c320a1b5d012c$var$parseHour24,
        "I": $119c320a1b5d012c$var$parseHour24,
        "j": $119c320a1b5d012c$var$parseDayOfYear,
        "L": $119c320a1b5d012c$var$parseMilliseconds,
        "m": $119c320a1b5d012c$var$parseMonthNumber,
        "M": $119c320a1b5d012c$var$parseMinutes,
        "p": parsePeriod,
        "q": $119c320a1b5d012c$var$parseQuarter,
        "Q": $119c320a1b5d012c$var$parseUnixTimestamp,
        "s": $119c320a1b5d012c$var$parseUnixTimestampSeconds,
        "S": $119c320a1b5d012c$var$parseSeconds,
        "u": $119c320a1b5d012c$var$parseWeekdayNumberMonday,
        "U": $119c320a1b5d012c$var$parseWeekNumberSunday,
        "V": $119c320a1b5d012c$var$parseWeekNumberISO,
        "w": $119c320a1b5d012c$var$parseWeekdayNumberSunday,
        "W": $119c320a1b5d012c$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $119c320a1b5d012c$var$parseYear,
        "Y": $119c320a1b5d012c$var$parseFullYear,
        "Z": $119c320a1b5d012c$var$parseZone,
        "%": $119c320a1b5d012c$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $119c320a1b5d012c$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $119c320a1b5d012c$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $119c320a1b5d012c$var$utcDate($119c320a1b5d012c$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).ceil(week) : (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)(week);
                    week = (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $119c320a1b5d012c$var$localDate($119c320a1b5d012c$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).ceil(week) : (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8)(week);
                    week = (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $119c320a1b5d012c$var$utcDate($119c320a1b5d012c$var$newDate(d.y, 0, 1)).getUTCDay() : $119c320a1b5d012c$var$localDate($119c320a1b5d012c$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $119c320a1b5d012c$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $119c320a1b5d012c$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $119c320a1b5d012c$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $119c320a1b5d012c$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $119c320a1b5d012c$var$numberRe = /^\s*\d+/, $119c320a1b5d012c$var$percentRe = /^%/, $119c320a1b5d012c$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $119c320a1b5d012c$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $119c320a1b5d012c$var$requote(s) {
    return s.replace($119c320a1b5d012c$var$requoteRe, "\\$&");
}
function $119c320a1b5d012c$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($119c320a1b5d012c$var$requote).join("|") + ")", "i");
}
function $119c320a1b5d012c$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $119c320a1b5d012c$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseWeekNumberSunday(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseWeekNumberISO(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseWeekNumberMonday(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseFullYear(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseYear(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseQuarter(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseMonthNumber(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseDayOfMonth(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseDayOfYear(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseHour24(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseMinutes(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseSeconds(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseMilliseconds(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseMicroseconds(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseLiteralPercent(d, string, i) {
    var n = $119c320a1b5d012c$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $119c320a1b5d012c$var$parseUnixTimestamp(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $119c320a1b5d012c$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $119c320a1b5d012c$var$formatDayOfMonth(d, p) {
    return $119c320a1b5d012c$var$pad(d.getDate(), p, 2);
}
function $119c320a1b5d012c$var$formatHour24(d, p) {
    return $119c320a1b5d012c$var$pad(d.getHours(), p, 2);
}
function $119c320a1b5d012c$var$formatHour12(d, p) {
    return $119c320a1b5d012c$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $119c320a1b5d012c$var$formatDayOfYear(d, p) {
    return $119c320a1b5d012c$var$pad(1 + (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $119c320a1b5d012c$var$formatMilliseconds(d, p) {
    return $119c320a1b5d012c$var$pad(d.getMilliseconds(), p, 3);
}
function $119c320a1b5d012c$var$formatMicroseconds(d, p) {
    return $119c320a1b5d012c$var$formatMilliseconds(d, p) + "000";
}
function $119c320a1b5d012c$var$formatMonthNumber(d, p) {
    return $119c320a1b5d012c$var$pad(d.getMonth() + 1, p, 2);
}
function $119c320a1b5d012c$var$formatMinutes(d, p) {
    return $119c320a1b5d012c$var$pad(d.getMinutes(), p, 2);
}
function $119c320a1b5d012c$var$formatSeconds(d, p) {
    return $119c320a1b5d012c$var$pad(d.getSeconds(), p, 2);
}
function $119c320a1b5d012c$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $119c320a1b5d012c$var$formatWeekNumberSunday(d, p) {
    return $119c320a1b5d012c$var$pad((0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $119c320a1b5d012c$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
}
function $119c320a1b5d012c$var$formatWeekNumberISO(d, p) {
    d = $119c320a1b5d012c$var$dISO(d);
    return $119c320a1b5d012c$var$pad((0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d) + ((0, $c352773cb286f235$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $119c320a1b5d012c$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $119c320a1b5d012c$var$formatWeekNumberMonday(d, p) {
    return $119c320a1b5d012c$var$pad((0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $119c320a1b5d012c$var$formatYear(d, p) {
    return $119c320a1b5d012c$var$pad(d.getFullYear() % 100, p, 2);
}
function $119c320a1b5d012c$var$formatYearISO(d, p) {
    d = $119c320a1b5d012c$var$dISO(d);
    return $119c320a1b5d012c$var$pad(d.getFullYear() % 100, p, 2);
}
function $119c320a1b5d012c$var$formatFullYear(d, p) {
    return $119c320a1b5d012c$var$pad(d.getFullYear() % 10000, p, 4);
}
function $119c320a1b5d012c$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
    return $119c320a1b5d012c$var$pad(d.getFullYear() % 10000, p, 4);
}
function $119c320a1b5d012c$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $119c320a1b5d012c$var$pad(z / 60 | 0, "0", 2) + $119c320a1b5d012c$var$pad(z % 60, "0", 2);
}
function $119c320a1b5d012c$var$formatUTCDayOfMonth(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCDate(), p, 2);
}
function $119c320a1b5d012c$var$formatUTCHour24(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCHours(), p, 2);
}
function $119c320a1b5d012c$var$formatUTCHour12(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $119c320a1b5d012c$var$formatUTCDayOfYear(d, p) {
    return $119c320a1b5d012c$var$pad(1 + (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $119c320a1b5d012c$var$formatUTCMilliseconds(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $119c320a1b5d012c$var$formatUTCMicroseconds(d, p) {
    return $119c320a1b5d012c$var$formatUTCMilliseconds(d, p) + "000";
}
function $119c320a1b5d012c$var$formatUTCMonthNumber(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $119c320a1b5d012c$var$formatUTCMinutes(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCMinutes(), p, 2);
}
function $119c320a1b5d012c$var$formatUTCSeconds(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCSeconds(), p, 2);
}
function $119c320a1b5d012c$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $119c320a1b5d012c$var$formatUTCWeekNumberSunday(d, p) {
    return $119c320a1b5d012c$var$pad((0, $24ffb3b67dc2c085$export$4898b06303a92011).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $119c320a1b5d012c$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
}
function $119c320a1b5d012c$var$formatUTCWeekNumberISO(d, p) {
    d = $119c320a1b5d012c$var$UTCdISO(d);
    return $119c320a1b5d012c$var$pad((0, $24ffb3b67dc2c085$export$1db08111baec2f53).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d) + ((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $119c320a1b5d012c$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $119c320a1b5d012c$var$formatUTCWeekNumberMonday(d, p) {
    return $119c320a1b5d012c$var$pad((0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $119c320a1b5d012c$var$formatUTCYear(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $119c320a1b5d012c$var$formatUTCYearISO(d, p) {
    d = $119c320a1b5d012c$var$UTCdISO(d);
    return $119c320a1b5d012c$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $119c320a1b5d012c$var$formatUTCFullYear(d, p) {
    return $119c320a1b5d012c$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $119c320a1b5d012c$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
    return $119c320a1b5d012c$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $119c320a1b5d012c$var$formatUTCZone() {
    return "+0000";
}
function $119c320a1b5d012c$var$formatLiteralPercent() {
    return "%";
}
function $119c320a1b5d012c$var$formatUnixTimestamp(d) {
    return +d;
}
function $119c320a1b5d012c$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $652704e8146ecccd$var$locale;
var $652704e8146ecccd$export$94f4d87fad5dcf9a;
var $652704e8146ecccd$export$32b9cd16e1b8c8d2;
var $652704e8146ecccd$export$1a08fe38f63ebbbb;
var $652704e8146ecccd$export$3edae9cf8e233729;
$652704e8146ecccd$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $652704e8146ecccd$export$2e2bcd8739ae039(definition) {
    $652704e8146ecccd$var$locale = (0, $119c320a1b5d012c$export$2e2bcd8739ae039)(definition);
    $652704e8146ecccd$export$94f4d87fad5dcf9a = $652704e8146ecccd$var$locale.format;
    $652704e8146ecccd$export$32b9cd16e1b8c8d2 = $652704e8146ecccd$var$locale.parse;
    $652704e8146ecccd$export$1a08fe38f63ebbbb = $652704e8146ecccd$var$locale.utcFormat;
    $652704e8146ecccd$export$3edae9cf8e233729 = $652704e8146ecccd$var$locale.utcParse;
    return $652704e8146ecccd$var$locale;
}


function $8be717544f885fe5$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}




function $89f43eb8e9e05b3b$export$2e2bcd8739ae039() {
    var scale = (0, $46022730ab65113e$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $8be717544f885fe5$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $89f43eb8e9e05b3b$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $89f43eb8e9e05b3b$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $89f43eb8e9e05b3b$var$pointish(copy());
    };
    return scale;
}
function $89f43eb8e9e05b3b$export$105684a3041cb6f3() {
    return $89f43eb8e9e05b3b$var$pointish($89f43eb8e9e05b3b$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

var $0dcb5ae7bbb10a4b$var$t0 = new Date, $0dcb5ae7bbb10a4b$var$t1 = new Date;
function $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $0dcb5ae7bbb10a4b$var$t0.setTime(+start), $0dcb5ae7bbb10a4b$var$t1.setTime(+end);
            floori($0dcb5ae7bbb10a4b$var$t0), floori($0dcb5ae7bbb10a4b$var$t1);
            return Math.floor(count($0dcb5ae7bbb10a4b$var$t0, $0dcb5ae7bbb10a4b$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $510249a926846fb4$export$79ef0e34099623dc = 1000;
const $510249a926846fb4$export$683905d551c33fa9 = $510249a926846fb4$export$79ef0e34099623dc * 60;
const $510249a926846fb4$export$4157bf0c8e241659 = $510249a926846fb4$export$683905d551c33fa9 * 60;
const $510249a926846fb4$export$353686095f4fbf45 = $510249a926846fb4$export$4157bf0c8e241659 * 24;
const $510249a926846fb4$export$c241eb88520d5016 = $510249a926846fb4$export$353686095f4fbf45 * 7;
const $510249a926846fb4$export$ab95684df7020b26 = $510249a926846fb4$export$353686095f4fbf45 * 30;
const $510249a926846fb4$export$61f8ee2d834c6959 = $510249a926846fb4$export$353686095f4fbf45 * 365;


var $89021a51a71534b6$var$day = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $510249a926846fb4$export$683905d551c33fa9)) / (0, $510249a926846fb4$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $89021a51a71534b6$export$2e2bcd8739ae039 = $89021a51a71534b6$var$day;
var $89021a51a71534b6$export$3cf5dda4201cc0f2 = $89021a51a71534b6$var$day.range;



var $0a7ba37a2614f10e$var$hour = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $510249a926846fb4$export$79ef0e34099623dc) - date.getMinutes() * (0, $510249a926846fb4$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $510249a926846fb4$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $510249a926846fb4$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $0a7ba37a2614f10e$export$2e2bcd8739ae039 = $0a7ba37a2614f10e$var$hour;
var $0a7ba37a2614f10e$export$8d468796d69cdad1 = $0a7ba37a2614f10e$var$hour.range;



var $a234a9c692002c41$var$minute = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $510249a926846fb4$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $510249a926846fb4$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $510249a926846fb4$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $a234a9c692002c41$export$2e2bcd8739ae039 = $a234a9c692002c41$var$minute;
var $a234a9c692002c41$export$666252b437cce0c7 = $a234a9c692002c41$var$minute.range;


var $b190da7a730ae77f$var$month = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $b190da7a730ae77f$export$2e2bcd8739ae039 = $b190da7a730ae77f$var$month;
var $b190da7a730ae77f$export$16352d1b10c5eb38 = $b190da7a730ae77f$var$month.range;



var $6a6a89859a868b21$var$second = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $510249a926846fb4$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $510249a926846fb4$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $6a6a89859a868b21$export$2e2bcd8739ae039 = $6a6a89859a868b21$var$second;
var $6a6a89859a868b21$export$4792e48abc550fa1 = $6a6a89859a868b21$var$second.range;




var $ed57c85989138cf1$var$millisecond = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$ed57c85989138cf1$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $ed57c85989138cf1$var$millisecond;
    return (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $ed57c85989138cf1$export$2e2bcd8739ae039 = $ed57c85989138cf1$var$millisecond;
var $ed57c85989138cf1$export$9a27fac83d67afd3 = $ed57c85989138cf1$var$millisecond.range;








function $17b611be1bdebe84$var$weekday(i) {
    return (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $510249a926846fb4$export$683905d551c33fa9)) / (0, $510249a926846fb4$export$c241eb88520d5016);
    });
}
var $17b611be1bdebe84$export$fb3ee18ed410cc21 = $17b611be1bdebe84$var$weekday(0);
var $17b611be1bdebe84$export$6416afaab03bc9b8 = $17b611be1bdebe84$var$weekday(1);
var $17b611be1bdebe84$export$cb8f040f5d17ac7b = $17b611be1bdebe84$var$weekday(2);
var $17b611be1bdebe84$export$347581849975dfc8 = $17b611be1bdebe84$var$weekday(3);
var $17b611be1bdebe84$export$2f2b56683a3e5629 = $17b611be1bdebe84$var$weekday(4);
var $17b611be1bdebe84$export$59b8c2ccd931d806 = $17b611be1bdebe84$var$weekday(5);
var $17b611be1bdebe84$export$478ceadebff4d377 = $17b611be1bdebe84$var$weekday(6);
var $17b611be1bdebe84$export$e8daabaa40641211 = $17b611be1bdebe84$export$fb3ee18ed410cc21.range;
var $17b611be1bdebe84$export$74e5b559c235c00e = $17b611be1bdebe84$export$6416afaab03bc9b8.range;
var $17b611be1bdebe84$export$e7d6aa4fb107bc56 = $17b611be1bdebe84$export$cb8f040f5d17ac7b.range;
var $17b611be1bdebe84$export$fcd5880b20bb06a8 = $17b611be1bdebe84$export$347581849975dfc8.range;
var $17b611be1bdebe84$export$682716b7bbe33641 = $17b611be1bdebe84$export$2f2b56683a3e5629.range;
var $17b611be1bdebe84$export$482924968ca86084 = $17b611be1bdebe84$export$59b8c2ccd931d806.range;
var $17b611be1bdebe84$export$7d755172c9cda9d2 = $17b611be1bdebe84$export$478ceadebff4d377.range;




var $0dd4756146bd7e8e$var$year = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$0dd4756146bd7e8e$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $0dd4756146bd7e8e$export$2e2bcd8739ae039 = $0dd4756146bd7e8e$var$year;
var $0dd4756146bd7e8e$export$6fda41c7fb23acf9 = $0dd4756146bd7e8e$var$year.range;




var $e55461176857179e$var$utcMinute = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $510249a926846fb4$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $510249a926846fb4$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $e55461176857179e$export$2e2bcd8739ae039 = $e55461176857179e$var$utcMinute;
var $e55461176857179e$export$cedd563624e8ee50 = $e55461176857179e$var$utcMinute.range;




var $b79f04916ce35562$var$utcHour = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $510249a926846fb4$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $510249a926846fb4$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $b79f04916ce35562$export$2e2bcd8739ae039 = $b79f04916ce35562$var$utcHour;
var $b79f04916ce35562$export$6e7a76cd5f50b719 = $b79f04916ce35562$var$utcHour.range;




var $2bbe3821f77f0d5e$var$utcDay = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $510249a926846fb4$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $2bbe3821f77f0d5e$export$2e2bcd8739ae039 = $2bbe3821f77f0d5e$var$utcDay;
var $2bbe3821f77f0d5e$export$d277e198508549a1 = $2bbe3821f77f0d5e$var$utcDay.range;




function $9e0ab97d8d2c6315$var$utcWeekday(i) {
    return (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $510249a926846fb4$export$c241eb88520d5016);
    });
}
var $9e0ab97d8d2c6315$export$4898b06303a92011 = $9e0ab97d8d2c6315$var$utcWeekday(0);
var $9e0ab97d8d2c6315$export$9cfc53b9cfafd080 = $9e0ab97d8d2c6315$var$utcWeekday(1);
var $9e0ab97d8d2c6315$export$2a6d545f77eceb15 = $9e0ab97d8d2c6315$var$utcWeekday(2);
var $9e0ab97d8d2c6315$export$a5c25d8ed64433c4 = $9e0ab97d8d2c6315$var$utcWeekday(3);
var $9e0ab97d8d2c6315$export$1db08111baec2f53 = $9e0ab97d8d2c6315$var$utcWeekday(4);
var $9e0ab97d8d2c6315$export$29265e34dd5921f7 = $9e0ab97d8d2c6315$var$utcWeekday(5);
var $9e0ab97d8d2c6315$export$85b74dad05049604 = $9e0ab97d8d2c6315$var$utcWeekday(6);
var $9e0ab97d8d2c6315$export$6f3e1c2b0f7d7880 = $9e0ab97d8d2c6315$export$4898b06303a92011.range;
var $9e0ab97d8d2c6315$export$1d2d8b858bb366f9 = $9e0ab97d8d2c6315$export$9cfc53b9cfafd080.range;
var $9e0ab97d8d2c6315$export$1d5f6785fc7f30f8 = $9e0ab97d8d2c6315$export$2a6d545f77eceb15.range;
var $9e0ab97d8d2c6315$export$7a75faf0e37ef4af = $9e0ab97d8d2c6315$export$a5c25d8ed64433c4.range;
var $9e0ab97d8d2c6315$export$417eb959611b2f2f = $9e0ab97d8d2c6315$export$1db08111baec2f53.range;
var $9e0ab97d8d2c6315$export$59d308db7af08c64 = $9e0ab97d8d2c6315$export$29265e34dd5921f7.range;
var $9e0ab97d8d2c6315$export$a124108a0a7f34c8 = $9e0ab97d8d2c6315$export$85b74dad05049604.range;



var $fc95fddcbc10dbcc$var$utcMonth = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $fc95fddcbc10dbcc$export$2e2bcd8739ae039 = $fc95fddcbc10dbcc$var$utcMonth;
var $fc95fddcbc10dbcc$export$49159f585997498 = $fc95fddcbc10dbcc$var$utcMonth.range;



var $4cdb3260b51159fa$var$utcYear = (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$4cdb3260b51159fa$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $0dcb5ae7bbb10a4b$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $4cdb3260b51159fa$export$2e2bcd8739ae039 = $4cdb3260b51159fa$var$utcYear;
var $4cdb3260b51159fa$export$3e24d311e17f5802 = $4cdb3260b51159fa$var$utcYear.range;


function $0661d76e17ce382c$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $6a6a89859a868b21$export$2e2bcd8739ae039),
            1,
            (0, $510249a926846fb4$export$79ef0e34099623dc)
        ],
        [
            (0, $6a6a89859a868b21$export$2e2bcd8739ae039),
            5,
            5 * (0, $510249a926846fb4$export$79ef0e34099623dc)
        ],
        [
            (0, $6a6a89859a868b21$export$2e2bcd8739ae039),
            15,
            15 * (0, $510249a926846fb4$export$79ef0e34099623dc)
        ],
        [
            (0, $6a6a89859a868b21$export$2e2bcd8739ae039),
            30,
            30 * (0, $510249a926846fb4$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $510249a926846fb4$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $510249a926846fb4$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $510249a926846fb4$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $510249a926846fb4$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $510249a926846fb4$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $510249a926846fb4$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $510249a926846fb4$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $510249a926846fb4$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $510249a926846fb4$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $510249a926846fb4$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $510249a926846fb4$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $510249a926846fb4$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $510249a926846fb4$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $510249a926846fb4$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $b954e02a9be0ac41$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $48f1022f08c36146$export$81087d9b915d4ede)(start / (0, $510249a926846fb4$export$61f8ee2d834c6959), stop / (0, $510249a926846fb4$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $ed57c85989138cf1$export$2e2bcd8739ae039).every(Math.max((0, $48f1022f08c36146$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$0661d76e17ce382c$export$826ba5ae907e9767, $0661d76e17ce382c$export$6262d8d056ea44c4] = $0661d76e17ce382c$var$ticker((0, $4cdb3260b51159fa$export$2e2bcd8739ae039), (0, $fc95fddcbc10dbcc$export$2e2bcd8739ae039), (0, $9e0ab97d8d2c6315$export$4898b06303a92011), (0, $2bbe3821f77f0d5e$export$2e2bcd8739ae039), (0, $b79f04916ce35562$export$2e2bcd8739ae039), (0, $e55461176857179e$export$2e2bcd8739ae039));
const [$0661d76e17ce382c$export$60c76498552d28a6, $0661d76e17ce382c$export$69511150134dd174] = $0661d76e17ce382c$var$ticker((0, $0dd4756146bd7e8e$export$2e2bcd8739ae039), (0, $b190da7a730ae77f$export$2e2bcd8739ae039), (0, $17b611be1bdebe84$export$fb3ee18ed410cc21), (0, $89021a51a71534b6$export$2e2bcd8739ae039), (0, $0a7ba37a2614f10e$export$2e2bcd8739ae039), (0, $a234a9c692002c41$export$2e2bcd8739ae039));



function $0aff5833ed39a34e$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $0aff5833ed39a34e$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $0aff5833ed39a34e$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $0aff5833ed39a34e$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $0aff5833ed39a34e$var$formatRe(locale_periods), periodLookup = $0aff5833ed39a34e$var$formatLookup(locale_periods), weekdayRe = $0aff5833ed39a34e$var$formatRe(locale_weekdays), weekdayLookup = $0aff5833ed39a34e$var$formatLookup(locale_weekdays), shortWeekdayRe = $0aff5833ed39a34e$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $0aff5833ed39a34e$var$formatLookup(locale_shortWeekdays), monthRe = $0aff5833ed39a34e$var$formatRe(locale_months), monthLookup = $0aff5833ed39a34e$var$formatLookup(locale_months), shortMonthRe = $0aff5833ed39a34e$var$formatRe(locale_shortMonths), shortMonthLookup = $0aff5833ed39a34e$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $0aff5833ed39a34e$var$formatDayOfMonth,
        "e": $0aff5833ed39a34e$var$formatDayOfMonth,
        "f": $0aff5833ed39a34e$var$formatMicroseconds,
        "g": $0aff5833ed39a34e$var$formatYearISO,
        "G": $0aff5833ed39a34e$var$formatFullYearISO,
        "H": $0aff5833ed39a34e$var$formatHour24,
        "I": $0aff5833ed39a34e$var$formatHour12,
        "j": $0aff5833ed39a34e$var$formatDayOfYear,
        "L": $0aff5833ed39a34e$var$formatMilliseconds,
        "m": $0aff5833ed39a34e$var$formatMonthNumber,
        "M": $0aff5833ed39a34e$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $0aff5833ed39a34e$var$formatUnixTimestamp,
        "s": $0aff5833ed39a34e$var$formatUnixTimestampSeconds,
        "S": $0aff5833ed39a34e$var$formatSeconds,
        "u": $0aff5833ed39a34e$var$formatWeekdayNumberMonday,
        "U": $0aff5833ed39a34e$var$formatWeekNumberSunday,
        "V": $0aff5833ed39a34e$var$formatWeekNumberISO,
        "w": $0aff5833ed39a34e$var$formatWeekdayNumberSunday,
        "W": $0aff5833ed39a34e$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $0aff5833ed39a34e$var$formatYear,
        "Y": $0aff5833ed39a34e$var$formatFullYear,
        "Z": $0aff5833ed39a34e$var$formatZone,
        "%": $0aff5833ed39a34e$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $0aff5833ed39a34e$var$formatUTCDayOfMonth,
        "e": $0aff5833ed39a34e$var$formatUTCDayOfMonth,
        "f": $0aff5833ed39a34e$var$formatUTCMicroseconds,
        "g": $0aff5833ed39a34e$var$formatUTCYearISO,
        "G": $0aff5833ed39a34e$var$formatUTCFullYearISO,
        "H": $0aff5833ed39a34e$var$formatUTCHour24,
        "I": $0aff5833ed39a34e$var$formatUTCHour12,
        "j": $0aff5833ed39a34e$var$formatUTCDayOfYear,
        "L": $0aff5833ed39a34e$var$formatUTCMilliseconds,
        "m": $0aff5833ed39a34e$var$formatUTCMonthNumber,
        "M": $0aff5833ed39a34e$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $0aff5833ed39a34e$var$formatUnixTimestamp,
        "s": $0aff5833ed39a34e$var$formatUnixTimestampSeconds,
        "S": $0aff5833ed39a34e$var$formatUTCSeconds,
        "u": $0aff5833ed39a34e$var$formatUTCWeekdayNumberMonday,
        "U": $0aff5833ed39a34e$var$formatUTCWeekNumberSunday,
        "V": $0aff5833ed39a34e$var$formatUTCWeekNumberISO,
        "w": $0aff5833ed39a34e$var$formatUTCWeekdayNumberSunday,
        "W": $0aff5833ed39a34e$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $0aff5833ed39a34e$var$formatUTCYear,
        "Y": $0aff5833ed39a34e$var$formatUTCFullYear,
        "Z": $0aff5833ed39a34e$var$formatUTCZone,
        "%": $0aff5833ed39a34e$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $0aff5833ed39a34e$var$parseDayOfMonth,
        "e": $0aff5833ed39a34e$var$parseDayOfMonth,
        "f": $0aff5833ed39a34e$var$parseMicroseconds,
        "g": $0aff5833ed39a34e$var$parseYear,
        "G": $0aff5833ed39a34e$var$parseFullYear,
        "H": $0aff5833ed39a34e$var$parseHour24,
        "I": $0aff5833ed39a34e$var$parseHour24,
        "j": $0aff5833ed39a34e$var$parseDayOfYear,
        "L": $0aff5833ed39a34e$var$parseMilliseconds,
        "m": $0aff5833ed39a34e$var$parseMonthNumber,
        "M": $0aff5833ed39a34e$var$parseMinutes,
        "p": parsePeriod,
        "q": $0aff5833ed39a34e$var$parseQuarter,
        "Q": $0aff5833ed39a34e$var$parseUnixTimestamp,
        "s": $0aff5833ed39a34e$var$parseUnixTimestampSeconds,
        "S": $0aff5833ed39a34e$var$parseSeconds,
        "u": $0aff5833ed39a34e$var$parseWeekdayNumberMonday,
        "U": $0aff5833ed39a34e$var$parseWeekNumberSunday,
        "V": $0aff5833ed39a34e$var$parseWeekNumberISO,
        "w": $0aff5833ed39a34e$var$parseWeekdayNumberSunday,
        "W": $0aff5833ed39a34e$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $0aff5833ed39a34e$var$parseYear,
        "Y": $0aff5833ed39a34e$var$parseFullYear,
        "Z": $0aff5833ed39a34e$var$parseZone,
        "%": $0aff5833ed39a34e$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $0aff5833ed39a34e$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $0aff5833ed39a34e$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $0aff5833ed39a34e$var$utcDate($0aff5833ed39a34e$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).ceil(week) : (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)(week);
                    week = (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $0aff5833ed39a34e$var$localDate($0aff5833ed39a34e$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).ceil(week) : (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8)(week);
                    week = (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $0aff5833ed39a34e$var$utcDate($0aff5833ed39a34e$var$newDate(d.y, 0, 1)).getUTCDay() : $0aff5833ed39a34e$var$localDate($0aff5833ed39a34e$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $0aff5833ed39a34e$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $0aff5833ed39a34e$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $0aff5833ed39a34e$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $0aff5833ed39a34e$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $0aff5833ed39a34e$var$numberRe = /^\s*\d+/, $0aff5833ed39a34e$var$percentRe = /^%/, $0aff5833ed39a34e$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $0aff5833ed39a34e$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $0aff5833ed39a34e$var$requote(s) {
    return s.replace($0aff5833ed39a34e$var$requoteRe, "\\$&");
}
function $0aff5833ed39a34e$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($0aff5833ed39a34e$var$requote).join("|") + ")", "i");
}
function $0aff5833ed39a34e$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $0aff5833ed39a34e$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseWeekNumberSunday(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseWeekNumberISO(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseWeekNumberMonday(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseFullYear(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseYear(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseQuarter(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseMonthNumber(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseDayOfMonth(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseDayOfYear(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseHour24(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseMinutes(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseSeconds(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseMilliseconds(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseMicroseconds(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseLiteralPercent(d, string, i) {
    var n = $0aff5833ed39a34e$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $0aff5833ed39a34e$var$parseUnixTimestamp(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $0aff5833ed39a34e$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $0aff5833ed39a34e$var$formatDayOfMonth(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getDate(), p, 2);
}
function $0aff5833ed39a34e$var$formatHour24(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getHours(), p, 2);
}
function $0aff5833ed39a34e$var$formatHour12(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $0aff5833ed39a34e$var$formatDayOfYear(d, p) {
    return $0aff5833ed39a34e$var$pad(1 + (0, $f9bfc74b1f2f6f8a$export$2e2bcd8739ae039).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $0aff5833ed39a34e$var$formatMilliseconds(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getMilliseconds(), p, 3);
}
function $0aff5833ed39a34e$var$formatMicroseconds(d, p) {
    return $0aff5833ed39a34e$var$formatMilliseconds(d, p) + "000";
}
function $0aff5833ed39a34e$var$formatMonthNumber(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getMonth() + 1, p, 2);
}
function $0aff5833ed39a34e$var$formatMinutes(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getMinutes(), p, 2);
}
function $0aff5833ed39a34e$var$formatSeconds(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getSeconds(), p, 2);
}
function $0aff5833ed39a34e$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $0aff5833ed39a34e$var$formatWeekNumberSunday(d, p) {
    return $0aff5833ed39a34e$var$pad((0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $0aff5833ed39a34e$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
}
function $0aff5833ed39a34e$var$formatWeekNumberISO(d, p) {
    d = $0aff5833ed39a34e$var$dISO(d);
    return $0aff5833ed39a34e$var$pad((0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d), d) + ((0, $c352773cb286f235$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $0aff5833ed39a34e$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $0aff5833ed39a34e$var$formatWeekNumberMonday(d, p) {
    return $0aff5833ed39a34e$var$pad((0, $ed25e5cb4307b03a$export$6416afaab03bc9b8).count((0, $c352773cb286f235$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $0aff5833ed39a34e$var$formatYear(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getFullYear() % 100, p, 2);
}
function $0aff5833ed39a34e$var$formatYearISO(d, p) {
    d = $0aff5833ed39a34e$var$dISO(d);
    return $0aff5833ed39a34e$var$pad(d.getFullYear() % 100, p, 2);
}
function $0aff5833ed39a34e$var$formatFullYear(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $0aff5833ed39a34e$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629)(d) : (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629).ceil(d);
    return $0aff5833ed39a34e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $0aff5833ed39a34e$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $0aff5833ed39a34e$var$pad(z / 60 | 0, "0", 2) + $0aff5833ed39a34e$var$pad(z % 60, "0", 2);
}
function $0aff5833ed39a34e$var$formatUTCDayOfMonth(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCDate(), p, 2);
}
function $0aff5833ed39a34e$var$formatUTCHour24(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCHours(), p, 2);
}
function $0aff5833ed39a34e$var$formatUTCHour12(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $0aff5833ed39a34e$var$formatUTCDayOfYear(d, p) {
    return $0aff5833ed39a34e$var$pad(1 + (0, $6c634b9d3e4c05fe$export$2e2bcd8739ae039).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $0aff5833ed39a34e$var$formatUTCMilliseconds(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $0aff5833ed39a34e$var$formatUTCMicroseconds(d, p) {
    return $0aff5833ed39a34e$var$formatUTCMilliseconds(d, p) + "000";
}
function $0aff5833ed39a34e$var$formatUTCMonthNumber(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $0aff5833ed39a34e$var$formatUTCMinutes(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCMinutes(), p, 2);
}
function $0aff5833ed39a34e$var$formatUTCSeconds(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCSeconds(), p, 2);
}
function $0aff5833ed39a34e$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $0aff5833ed39a34e$var$formatUTCWeekNumberSunday(d, p) {
    return $0aff5833ed39a34e$var$pad((0, $24ffb3b67dc2c085$export$4898b06303a92011).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $0aff5833ed39a34e$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
}
function $0aff5833ed39a34e$var$formatUTCWeekNumberISO(d, p) {
    d = $0aff5833ed39a34e$var$UTCdISO(d);
    return $0aff5833ed39a34e$var$pad((0, $24ffb3b67dc2c085$export$1db08111baec2f53).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d), d) + ((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $0aff5833ed39a34e$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $0aff5833ed39a34e$var$formatUTCWeekNumberMonday(d, p) {
    return $0aff5833ed39a34e$var$pad((0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080).count((0, $f493836e09c314f1$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $0aff5833ed39a34e$var$formatUTCYear(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $0aff5833ed39a34e$var$formatUTCYearISO(d, p) {
    d = $0aff5833ed39a34e$var$UTCdISO(d);
    return $0aff5833ed39a34e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $0aff5833ed39a34e$var$formatUTCFullYear(d, p) {
    return $0aff5833ed39a34e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $0aff5833ed39a34e$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $24ffb3b67dc2c085$export$1db08111baec2f53)(d) : (0, $24ffb3b67dc2c085$export$1db08111baec2f53).ceil(d);
    return $0aff5833ed39a34e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $0aff5833ed39a34e$var$formatUTCZone() {
    return "+0000";
}
function $0aff5833ed39a34e$var$formatLiteralPercent() {
    return "%";
}
function $0aff5833ed39a34e$var$formatUnixTimestamp(d) {
    return +d;
}
function $0aff5833ed39a34e$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $f64fe1b79fe3ba59$var$locale;
var $f64fe1b79fe3ba59$export$94f4d87fad5dcf9a;
var $f64fe1b79fe3ba59$export$32b9cd16e1b8c8d2;
var $f64fe1b79fe3ba59$export$1a08fe38f63ebbbb;
var $f64fe1b79fe3ba59$export$3edae9cf8e233729;
$f64fe1b79fe3ba59$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $f64fe1b79fe3ba59$export$2e2bcd8739ae039(definition) {
    $f64fe1b79fe3ba59$var$locale = (0, $0aff5833ed39a34e$export$2e2bcd8739ae039)(definition);
    $f64fe1b79fe3ba59$export$94f4d87fad5dcf9a = $f64fe1b79fe3ba59$var$locale.format;
    $f64fe1b79fe3ba59$export$32b9cd16e1b8c8d2 = $f64fe1b79fe3ba59$var$locale.parse;
    $f64fe1b79fe3ba59$export$1a08fe38f63ebbbb = $f64fe1b79fe3ba59$var$locale.utcFormat;
    $f64fe1b79fe3ba59$export$3edae9cf8e233729 = $f64fe1b79fe3ba59$var$locale.utcParse;
    return $f64fe1b79fe3ba59$var$locale;
}





function $2d6be932e487dfb8$var$date(t) {
    return new Date(t);
}
function $2d6be932e487dfb8$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $2d6be932e487dfb8$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $39cfcf291c7bc8aa$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $2d6be932e487dfb8$var$number)) : domain().map($2d6be932e487dfb8$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $67cb6af6bded2fe6$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $39cfcf291c7bc8aa$export$784d13d8ee351f07)(scale, $2d6be932e487dfb8$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $2d6be932e487dfb8$export$2e2bcd8739ae039() {
    return (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply($2d6be932e487dfb8$export$56bbcdb8aca31149((0, $0661d76e17ce382c$export$60c76498552d28a6), (0, $0661d76e17ce382c$export$69511150134dd174), (0, $0dd4756146bd7e8e$export$2e2bcd8739ae039), (0, $b190da7a730ae77f$export$2e2bcd8739ae039), (0, $17b611be1bdebe84$export$fb3ee18ed410cc21), (0, $89021a51a71534b6$export$2e2bcd8739ae039), (0, $0a7ba37a2614f10e$export$2e2bcd8739ae039), (0, $a234a9c692002c41$export$2e2bcd8739ae039), (0, $6a6a89859a868b21$export$2e2bcd8739ae039), (0, $f64fe1b79fe3ba59$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}





function $6c005fdf4f5ff40c$export$2e2bcd8739ae039() {
    return (0, $a59e96b6fe4cbbe6$export$23c7bb9e6558da2a).apply((0, $2d6be932e487dfb8$export$56bbcdb8aca31149)((0, $0661d76e17ce382c$export$826ba5ae907e9767), (0, $0661d76e17ce382c$export$6262d8d056ea44c4), (0, $4cdb3260b51159fa$export$2e2bcd8739ae039), (0, $fc95fddcbc10dbcc$export$2e2bcd8739ae039), (0, $9e0ab97d8d2c6315$export$4898b06303a92011), (0, $2bbe3821f77f0d5e$export$2e2bcd8739ae039), (0, $b79f04916ce35562$export$2e2bcd8739ae039), (0, $e55461176857179e$export$2e2bcd8739ae039), (0, $6a6a89859a868b21$export$2e2bcd8739ae039), (0, $f64fe1b79fe3ba59$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}



function $06eaf1cc3810e0c0$var$$() {
    return $06eaf1cc3810e0c0$var$$ = Object.assign || function(n) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var e in r)Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
        }
        return n;
    }, $06eaf1cc3810e0c0$var$$.apply(this, arguments);
}
var $06eaf1cc3810e0c0$export$6dcdc1137d8ab211 = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
], $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c = [
    function(n) {
        return n.setMilliseconds(0);
    },
    function(n) {
        return n.setSeconds(0);
    },
    function(n) {
        return n.setMinutes(0);
    },
    function(n) {
        return n.setHours(0);
    },
    function(n) {
        return n.setDate(1);
    },
    function(n) {
        return n.setMonth(0);
    }
], $06eaf1cc3810e0c0$export$43fb64d4d70cf1d2 = {
    millisecond: [],
    second: $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c.slice(0, 1),
    minute: $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c.slice(0, 2),
    hour: $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c.slice(0, 3),
    day: $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c.slice(0, 4),
    month: $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c.slice(0, 5),
    year: $06eaf1cc3810e0c0$export$1dc82d6660f2ea1c.slice(0, 6)
}, $06eaf1cc3810e0c0$export$317f4d4c07f3c42a = function(n) {
    return function(t) {
        return $06eaf1cc3810e0c0$export$43fb64d4d70cf1d2[n].forEach(function(n) {
            n(t);
        }), t;
    };
}, $06eaf1cc3810e0c0$export$daf307d3fe6dfa68 = function(n) {
    var t = n.format, r = void 0 === t ? "native" : t, e = n.precision, a = void 0 === e ? "millisecond" : e, u = n.useUTC, c = void 0 === u || u, f = $06eaf1cc3810e0c0$export$317f4d4c07f3c42a(a);
    return function(n) {
        if (void 0 === n) return n;
        if ("native" === r || n instanceof Date) return f(n);
        var t = c ? (0, $652704e8146ecccd$export$3edae9cf8e233729)(r) : (0, $652704e8146ecccd$export$32b9cd16e1b8c8d2)(r);
        return f(t(n));
    };
}, $06eaf1cc3810e0c0$export$4e095c21b86a0457 = function(n, t, r, e) {
    var a, i, o, c, f = n.min, d = void 0 === f ? 0 : f, s = n.max, l = void 0 === s ? "auto" : s, m = n.stacked, v = void 0 !== m && m, y = n.reverse, p = void 0 !== y && y, h = n.clamp, g = void 0 !== h && h, x = n.nice, k = void 0 !== x && x;
    "auto" === d ? a = !0 === v ? null != (i = t.minStacked) ? i : 0 : t.min : a = d;
    "auto" === l ? o = !0 === v ? null != (c = t.maxStacked) ? c : 0 : t.max : o = l;
    var T = (0, $43657edf9f9313df$export$2e2bcd8739ae039)().rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).domain(p ? [
        o,
        a
    ] : [
        a,
        o
    ]).clamp(g);
    return !0 === k ? T.nice() : "number" == typeof k && T.nice(k), $06eaf1cc3810e0c0$export$4fd02d345bf145e3(T, v);
}, $06eaf1cc3810e0c0$export$4fd02d345bf145e3 = function(n, t) {
    void 0 === t && (t = !1);
    var r = n;
    return r.type = "linear", r.stacked = t, r;
}, $06eaf1cc3810e0c0$export$9abcadf788874abe = function(n, t, r) {
    var e = (0, $89f43eb8e9e05b3b$export$105684a3041cb6f3)().range([
        0,
        r
    ]).domain(t.all);
    return e.type = "point", e;
}, $06eaf1cc3810e0c0$export$a8f33a545c6650d6 = function(n) {
    var t = n;
    return t.type = "point", t;
}, $06eaf1cc3810e0c0$export$e9706c87cd649069 = function(n, t, r, e) {
    var a = n.round, i = void 0 === a || a, o = (0, $89f43eb8e9e05b3b$export$2e2bcd8739ae039)().range("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).domain(t.all).round(i);
    return $06eaf1cc3810e0c0$export$c88e9eb2fbaf2089(o);
}, $06eaf1cc3810e0c0$export$c88e9eb2fbaf2089 = function(n) {
    var t = n;
    return t.type = "band", t;
}, $06eaf1cc3810e0c0$export$27d74465d4d4bf01 = function(n, t, r) {
    var e, a, i = n.format, o = void 0 === i ? "native" : i, u = n.precision, c = void 0 === u ? "millisecond" : u, f = n.min, l = void 0 === f ? "auto" : f, m = n.max, v = void 0 === m ? "auto" : m, y = n.useUTC, p = void 0 === y || y, h = n.nice, g = void 0 !== h && h, x = $06eaf1cc3810e0c0$export$daf307d3fe6dfa68({
        format: o,
        precision: c,
        useUTC: p
    });
    e = "auto" === l ? x(t.min) : "native" !== o ? x(l) : l, a = "auto" === v ? x(t.max) : "native" !== o ? x(v) : v;
    var k = p ? (0, $6c005fdf4f5ff40c$export$2e2bcd8739ae039)() : (0, $2d6be932e487dfb8$export$2e2bcd8739ae039)();
    k.range([
        0,
        r
    ]), e && a && k.domain([
        e,
        a
    ]), !0 === g ? k.nice() : "object" != typeof g && "number" != typeof g || k.nice(g);
    var T = k;
    return T.type = "time", T.useUTC = p, T;
}, $06eaf1cc3810e0c0$export$554cc426a2d37672 = function(n, t, r, e) {
    var a, i = n.base, o = void 0 === i ? 10 : i, u = n.min, c = void 0 === u ? "auto" : u, f = n.max, d = void 0 === f ? "auto" : f;
    if (t.all.some(function(n) {
        return 0 === n;
    })) throw new Error("a log scale domain must not include or cross zero");
    var s, m, v = !1;
    if (t.all.filter(function(n) {
        return null != n;
    }).forEach(function(n) {
        v || (void 0 === a ? a = Math.sign(n) : Math.sign(n) !== a && (v = !0));
    }), v) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
    s = "auto" === c ? t.min : c, m = "auto" === d ? t.max : d;
    var y = (0, $2a0a0e4ba4b52637$export$2e2bcd8739ae039)().domain([
        s,
        m
    ]).rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).base(o).nice();
    return y.type = "log", y;
}, $06eaf1cc3810e0c0$export$8e14d6e8a8fc902c = function(n, t, r, e) {
    var a, i, o = n.constant, u = void 0 === o ? 1 : o, c = n.min, f = void 0 === c ? "auto" : c, d = n.max, s = void 0 === d ? "auto" : d, l = n.reverse, v = void 0 !== l && l;
    a = "auto" === f ? t.min : f, i = "auto" === s ? t.max : s;
    var y = (0, $e73aca1ccf43f2f6$export$2e2bcd8739ae039)().constant(u).rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).nice();
    !0 === v ? y.domain([
        i,
        a
    ]) : y.domain([
        a,
        i
    ]);
    var p = y;
    return p.type = "symlog", p;
}, $06eaf1cc3810e0c0$export$9aa6d07acb85188c = function(n) {
    return "x" === n ? "y" : "x";
}, $06eaf1cc3810e0c0$export$6ab1df3197f7c641 = function(n, t) {
    return n === t;
}, $06eaf1cc3810e0c0$export$562cdc7d09e1fa5a = function(n, t) {
    return n.getTime() === t.getTime();
};
function $06eaf1cc3810e0c0$export$5268a4c29077d335(n, t, r, e) {
    switch(n.type){
        case "linear":
            return $06eaf1cc3810e0c0$export$4e095c21b86a0457(n, t, r, e);
        case "point":
            return $06eaf1cc3810e0c0$export$9abcadf788874abe(0, t, r);
        case "band":
            return $06eaf1cc3810e0c0$export$e9706c87cd649069(n, t, r, e);
        case "time":
            return $06eaf1cc3810e0c0$export$27d74465d4d4bf01(n, t, r);
        case "log":
            return $06eaf1cc3810e0c0$export$554cc426a2d37672(n, t, r, e);
        case "symlog":
            return $06eaf1cc3810e0c0$export$8e14d6e8a8fc902c(n, t, r, e);
        default:
            throw new Error("invalid scale spec");
    }
}
var $06eaf1cc3810e0c0$var$fn = function(n, t, r) {
    var e;
    if ("stacked" in r && r.stacked) {
        var a = n.data["x" === t ? "xStacked" : "yStacked"];
        return null == a ? null : r(a);
    }
    return null != (e = r(n.data[t])) ? e : null;
}, $06eaf1cc3810e0c0$export$4d0b292d246e5304 = function(n, t, r, e, a) {
    var i = n.map(function(n) {
        return function(n) {
            return $06eaf1cc3810e0c0$var$$({}, n, {
                data: n.data.map(function(n) {
                    return {
                        data: $06eaf1cc3810e0c0$var$$({}, n)
                    };
                })
            });
        }(n);
    }), o = $06eaf1cc3810e0c0$export$ebc19db715008482(i, t, r);
    "stacked" in t && !0 === t.stacked && $06eaf1cc3810e0c0$var$vn(o, i), "stacked" in r && !0 === r.stacked && $06eaf1cc3810e0c0$var$yn(o, i);
    var u = $06eaf1cc3810e0c0$export$5268a4c29077d335(t, o.x, e, "x"), c = $06eaf1cc3810e0c0$export$5268a4c29077d335(r, o.y, a, "y"), f = i.map(function(n) {
        return $06eaf1cc3810e0c0$var$$({}, n, {
            data: n.data.map(function(n) {
                return $06eaf1cc3810e0c0$var$$({}, n, {
                    position: {
                        x: $06eaf1cc3810e0c0$var$fn(n, "x", u),
                        y: $06eaf1cc3810e0c0$var$fn(n, "y", c)
                    }
                });
            })
        });
    });
    return $06eaf1cc3810e0c0$var$$({}, o, {
        series: f,
        xScale: u,
        yScale: c
    });
}, $06eaf1cc3810e0c0$export$ebc19db715008482 = function(n, t, r) {
    return {
        x: $06eaf1cc3810e0c0$export$b510e85f598a24fb(n, "x", t),
        y: $06eaf1cc3810e0c0$export$b510e85f598a24fb(n, "y", r)
    };
}, $06eaf1cc3810e0c0$export$b510e85f598a24fb = function(a, i, o, u) {
    var c = void 0 === u ? {} : u, f = c.getValue, d = void 0 === f ? function(n) {
        return n.data[i];
    } : f, s = c.setValue, l = void 0 === s ? function(n, t) {
        n.data[i] = t;
    } : s;
    if ("linear" === o.type) a.forEach(function(n) {
        n.data.forEach(function(n) {
            var t = d(n);
            t && l(n, parseFloat(String(t)));
        });
    });
    else if ("time" === o.type && "native" !== o.format) {
        var m = $06eaf1cc3810e0c0$export$daf307d3fe6dfa68(o);
        a.forEach(function(n) {
            n.data.forEach(function(n) {
                var t = d(n);
                t && l(n, m(t));
            });
        });
    }
    var v = [];
    switch(a.forEach(function(n) {
        n.data.forEach(function(n) {
            v.push(d(n));
        });
    }), o.type){
        case "linear":
            var y = (0, (/*@__PURE__*/$parcel$interopDefault($5cbcadbe316600de$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($51de7ad69d90896e$exports)))(v).filter(function(n) {
                return null !== n;
            }), function(n) {
                return n;
            });
            return {
                all: y,
                min: Math.min.apply(Math, y),
                max: Math.max.apply(Math, y)
            };
        case "time":
            var p = (0, (/*@__PURE__*/$parcel$interopDefault($99c2840ed14736a0$exports)))(v, function(n) {
                return n.getTime();
            }).slice(0).sort(function(n, t) {
                return t.getTime() - n.getTime();
            }).reverse();
            return {
                all: p,
                min: p[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(p)
            };
        default:
            var h = (0, (/*@__PURE__*/$parcel$interopDefault($51de7ad69d90896e$exports)))(v);
            return {
                all: h,
                min: h[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(h)
            };
    }
}, $06eaf1cc3810e0c0$export$c6f16b50cdeeb77c = function(n, t, r) {
    var i = $06eaf1cc3810e0c0$export$9aa6d07acb85188c(n), o = [];
    t[i].all.forEach(function(t) {
        var u = (0, (/*@__PURE__*/$parcel$interopDefault($48be745e7f0b6343$exports)))(t) ? $06eaf1cc3810e0c0$export$562cdc7d09e1fa5a : $06eaf1cc3810e0c0$export$6ab1df3197f7c641, c = [];
        r.forEach(function(r) {
            var a = r.data.find(function(n) {
                return u(n.data[i], t);
            }), f = null, d = null;
            if (void 0 !== a) {
                if (null !== (f = a.data[n])) {
                    var s = (0, (/*@__PURE__*/$parcel$interopDefault($0af9c5bb33cc0648$exports)))(c);
                    void 0 === s ? d = f : null !== s && (d = s + f);
                }
                a.data["x" === n ? "xStacked" : "yStacked"] = d;
            }
            c.push(d), null !== d && o.push(d);
        });
    }), t[n].minStacked = Math.min.apply(Math, o), t[n].maxStacked = Math.max.apply(Math, o);
}, $06eaf1cc3810e0c0$var$vn = function(n, t) {
    return $06eaf1cc3810e0c0$export$c6f16b50cdeeb77c("x", n, t);
}, $06eaf1cc3810e0c0$var$yn = function(n, t) {
    return $06eaf1cc3810e0c0$export$c6f16b50cdeeb77c("y", n, t);
}, $06eaf1cc3810e0c0$export$6eebe39d34e5b9b7 = function(n) {
    var t = n.bandwidth();
    if (0 === t) return n;
    var r = t / 2;
    return n.round() && (r = Math.round(r)), function(t) {
        var e;
        return (null != (e = n(t)) ? e : 0) + r;
    };
}, $06eaf1cc3810e0c0$var$hn = {
    millisecond: [
        (0, $0a4f2ea6a399e57c$export$2e2bcd8739ae039),
        (0, $0a4f2ea6a399e57c$export$2e2bcd8739ae039)
    ],
    second: [
        (0, $a0afe0478049aed0$export$2e2bcd8739ae039),
        (0, $a0afe0478049aed0$export$2e2bcd8739ae039)
    ],
    minute: [
        (0, $e0aa5ec14ef0a46b$export$2e2bcd8739ae039),
        (0, $6aae7f14f39f2299$export$2e2bcd8739ae039)
    ],
    hour: [
        (0, $0ae44b21dbe28022$export$2e2bcd8739ae039),
        (0, $55f91410e648a6d4$export$2e2bcd8739ae039)
    ],
    day: [
        (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(n) {
            return n.setHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setDate(n.getDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        }),
        (0, $f46ddf93f25a113e$export$2e2bcd8739ae039)(function(n) {
            return n.setUTCHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setUTCDate(n.getUTCDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        })
    ],
    week: [
        (0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21),
        (0, $24ffb3b67dc2c085$export$4898b06303a92011)
    ],
    sunday: [
        (0, $ed25e5cb4307b03a$export$fb3ee18ed410cc21),
        (0, $24ffb3b67dc2c085$export$4898b06303a92011)
    ],
    monday: [
        (0, $ed25e5cb4307b03a$export$6416afaab03bc9b8),
        (0, $24ffb3b67dc2c085$export$9cfc53b9cfafd080)
    ],
    tuesday: [
        (0, $ed25e5cb4307b03a$export$cb8f040f5d17ac7b),
        (0, $24ffb3b67dc2c085$export$2a6d545f77eceb15)
    ],
    wednesday: [
        (0, $ed25e5cb4307b03a$export$347581849975dfc8),
        (0, $24ffb3b67dc2c085$export$a5c25d8ed64433c4)
    ],
    thursday: [
        (0, $ed25e5cb4307b03a$export$2f2b56683a3e5629),
        (0, $24ffb3b67dc2c085$export$1db08111baec2f53)
    ],
    friday: [
        (0, $ed25e5cb4307b03a$export$59b8c2ccd931d806),
        (0, $24ffb3b67dc2c085$export$29265e34dd5921f7)
    ],
    saturday: [
        (0, $ed25e5cb4307b03a$export$478ceadebff4d377),
        (0, $24ffb3b67dc2c085$export$85b74dad05049604)
    ],
    month: [
        (0, $336fadb86a1aa786$export$2e2bcd8739ae039),
        (0, $906890fbeeca539b$export$2e2bcd8739ae039)
    ],
    year: [
        (0, $c352773cb286f235$export$2e2bcd8739ae039),
        (0, $f493836e09c314f1$export$2e2bcd8739ae039)
    ]
}, $06eaf1cc3810e0c0$var$gn = Object.keys($06eaf1cc3810e0c0$var$hn), $06eaf1cc3810e0c0$var$xn = new RegExp("^every\\s*(\\d+)?\\s*(" + $06eaf1cc3810e0c0$var$gn.join("|") + ")s?$", "i"), $06eaf1cc3810e0c0$export$6524ae923f6f50f3 = function(n, t) {
    if (Array.isArray(t)) return t;
    if ("string" == typeof t && "useUTC" in n) {
        var r = t.match($06eaf1cc3810e0c0$var$xn);
        if (r) {
            var e = r[1], a = r[2], i = $06eaf1cc3810e0c0$var$hn[a][n.useUTC ? 1 : 0];
            if ("day" === a) {
                var o, u, c = n.domain(), f = c[0], d = c[1], s = new Date(d);
                return s.setDate(s.getDate() + 1), null != (o = null == (u = i.every(Number(null != e ? e : 1))) ? void 0 : u.range(f, s)) ? o : [];
            }
            if (void 0 === e) return n.ticks(i);
            var l = i.every(Number(e));
            if (l) return n.ticks(l);
        }
        throw new Error("Invalid tickValues: " + t);
    }
    if ("ticks" in n) {
        if (void 0 === t) return n.ticks();
        if ("number" == typeof (m = t) && isFinite(m) && Math.floor(m) === m) return n.ticks(t);
    }
    var m;
    return n.domain();
};




var $2oXYc = parcelRequire("2oXYc");
function $45dd2bf200a010e5$var$v() {
    return $45dd2bf200a010e5$var$v = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $45dd2bf200a010e5$var$v.apply(this, arguments);
}
var $45dd2bf200a010e5$var$p = function(t) {
    var e, i = t.axis, n = t.scale, r = t.ticksPosition, a = t.tickValues, o = t.tickSize, s = t.tickPadding, c = t.tickRotation, f = t.engine, x = void 0 === f ? "svg" : f, u = (0, $06eaf1cc3810e0c0$export$6524ae923f6f50f3)(n, a), y = (0, $0332e848e6fa2251$export$1abb91cfca1e2069)[x], g = "bandwidth" in n ? (0, $06eaf1cc3810e0c0$export$6eebe39d34e5b9b7)(n) : n, k = {
        lineX: 0,
        lineY: 0
    }, h = {
        textX: 0,
        textY: 0
    }, p = "object" == typeof document && "rtl" === document.dir, b = y.align.center, P = y.baseline.center;
    return "x" === i ? (e = function(t) {
        var e;
        return {
            x: null != (e = g(t)) ? e : 0,
            y: 0
        };
    }, k.lineY = o * ("after" === r ? 1 : -1), h.textY = (o + s) * ("after" === r ? 1 : -1), P = "after" === r ? y.baseline.top : y.baseline.bottom, 0 === c ? b = y.align.center : "after" === r && c < 0 || "before" === r && c > 0 ? (b = y.align[p ? "left" : "right"], P = y.baseline.center) : ("after" === r && c > 0 || "before" === r && c < 0) && (b = y.align[p ? "right" : "left"], P = y.baseline.center)) : (e = function(t) {
        var e;
        return {
            x: 0,
            y: null != (e = g(t)) ? e : 0
        };
    }, k.lineX = o * ("after" === r ? 1 : -1), h.textX = (o + s) * ("after" === r ? 1 : -1), b = "after" === r ? y.align.left : y.align.right), {
        ticks: u.map(function(t) {
            return $45dd2bf200a010e5$var$v({
                key: t instanceof Date ? "" + t.valueOf() : "" + t,
                value: t
            }, e(t), k, h);
        }),
        textAlign: b,
        textBaseline: P
    };
}, $45dd2bf200a010e5$var$b = function(t, e) {
    if (void 0 === t || "function" == typeof t) return t;
    if ("time" === e.type) {
        var i = (0, $1e720291e3822a7d$export$94f4d87fad5dcf9a)(t);
        return function(t) {
            return i(t instanceof Date ? t : new Date(t));
        };
    }
    return (0, $f979cbd3e1200bf1$export$d9468344d3651243)(t);
}, $45dd2bf200a010e5$var$P = function(t) {
    var e, i = t.width, n = t.height, r = t.scale, a = t.axis, o = t.values, l = (e = o, Array.isArray(e) ? o : void 0) || (0, $06eaf1cc3810e0c0$export$6524ae923f6f50f3)(r, o), s = "bandwidth" in r ? (0, $06eaf1cc3810e0c0$export$6eebe39d34e5b9b7)(r) : r, c = "x" === a ? l.map(function(t) {
        var e, i;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: null != (e = s(t)) ? e : 0,
            x2: null != (i = s(t)) ? i : 0,
            y1: 0,
            y2: n
        };
    }) : l.map(function(t) {
        var e, n;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: 0,
            x2: i,
            y1: null != (e = s(t)) ? e : 0,
            y2: null != (n = s(t)) ? n : 0
        };
    });
    return c;
}, $45dd2bf200a010e5$export$3704f81c1ca961a8 = (0, $7fPBF.memo)(function(t) {
    var e, n = t.value, a = t.format, o = t.lineX, l = t.lineY, c = t.onClick, f = t.textBaseline, x = t.textAnchor, u = t.animatedProps, d = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), m = null != (e = null == a ? void 0 : a(n)) ? e : n, k = (0, $7fPBF.useMemo)(function() {
        var t = {
            opacity: u.opacity
        };
        return c ? {
            style: $45dd2bf200a010e5$var$v({}, t, {
                cursor: "pointer"
            }),
            onClick: function(t) {
                return c(t, m);
            }
        } : {
            style: t
        };
    }, [
        u.opacity,
        c,
        m
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, $45dd2bf200a010e5$var$v({
        transform: u.transform
    }, k, {
        children: [
            (0, $824c049f32d4395d$exports.jsx)("line", {
                x1: 0,
                x2: o,
                y1: 0,
                y2: l,
                style: d.axis.ticks.line
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                dominantBaseline: f,
                textAnchor: x,
                transform: u.textTransform,
                style: d.axis.ticks.text,
                children: m
            })
        ]
    }));
}), $45dd2bf200a010e5$export$d06866a9fb0606da = (0, $7fPBF.memo)(function(e) {
    var n = e.axis, l = e.scale, f = e.x, x = void 0 === f ? 0 : f, u = e.y, d = void 0 === u ? 0 : u, m = e.length, k = e.ticksPosition, h = e.tickValues, P = e.tickSize, T = void 0 === P ? 5 : P, O = e.tickPadding, w = void 0 === O ? 5 : O, A = e.tickRotation, X = void 0 === A ? 0 : A, Y = e.format, W = e.renderTick, B = void 0 === W ? $45dd2bf200a010e5$export$3704f81c1ca961a8 : W, z = e.legend, V = e.legendPosition, C = void 0 === V ? "end" : V, D = e.legendOffset, R = void 0 === D ? 0 : D, j = e.onClick, E = e.ariaHidden, q = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), F = (0, $7fPBF.useMemo)(function() {
        return $45dd2bf200a010e5$var$b(Y, l);
    }, [
        Y,
        l
    ]), H = $45dd2bf200a010e5$var$p({
        axis: n,
        scale: l,
        ticksPosition: k,
        tickValues: h,
        tickSize: T,
        tickPadding: w,
        tickRotation: X
    }), N = H.ticks, I = H.textAlign, G = H.textBaseline, J = null;
    if (void 0 !== z) {
        var K, L = 0, M = 0, Q = 0;
        "y" === n ? (Q = -90, L = R, "start" === C ? (K = "start", M = m) : "middle" === C ? (K = "middle", M = m / 2) : "end" === C && (K = "end")) : (M = R, "start" === C ? K = "start" : "middle" === C ? (K = "middle", L = m / 2) : "end" === C && (K = "end", L = m)), J = (0, $824c049f32d4395d$exports.jsx)("text", {
            transform: "translate(" + L + ", " + M + ") rotate(" + Q + ")",
            textAnchor: K,
            style: $45dd2bf200a010e5$var$v({
                dominantBaseline: "central"
            }, q.axis.legend.text),
            children: z
        });
    }
    var U = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), Z = U.animate, $ = U.config, _ = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        transform: "translate(" + x + "," + d + ")",
        lineX2: "x" === n ? m : 0,
        lineY2: "x" === n ? 0 : m,
        config: $,
        immediate: !Z
    }), tt = (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(N, {
        keys: function(t) {
            return t.key;
        },
        initial: function(t) {
            return {
                opacity: 1,
                transform: "translate(" + t.x + "," + t.y + ")",
                textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
            };
        },
        from: function(t) {
            return {
                opacity: 0,
                transform: "translate(" + t.x + "," + t.y + ")",
                textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
            };
        },
        enter: function(t) {
            return {
                opacity: 1,
                transform: "translate(" + t.x + "," + t.y + ")",
                textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                transform: "translate(" + t.x + "," + t.y + ")",
                textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
            };
        },
        leave: {
            opacity: 0
        },
        config: $,
        immediate: !Z
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).g, {
        transform: _.transform,
        "aria-hidden": E,
        children: [
            tt(function(e, i, n, r) {
                return $7fPBF.createElement(B, $45dd2bf200a010e5$var$v({
                    tickIndex: r,
                    format: F,
                    rotate: X,
                    textBaseline: G,
                    textAnchor: I,
                    animatedProps: e
                }, i, j ? {
                    onClick: j
                } : {}));
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).line, {
                style: q.axis.domain.line,
                x1: 0,
                x2: _.lineX2,
                y1: 0,
                y2: _.lineY2
            }),
            J
        ]
    });
}), $45dd2bf200a010e5$export$e5dd2f622170d212 = {
    ticksPosition: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "before",
        "after"
    ]),
    tickValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    ]),
    tickSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    tickPadding: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    tickRotation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    format: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    ]),
    renderTick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node,
    legendPosition: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    legendOffset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    ariaHidden: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
}, $45dd2bf200a010e5$export$8502d8c4b99a277e = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape($45dd2bf200a010e5$export$e5dd2f622170d212), $45dd2bf200a010e5$export$878041e1e4cd4218 = [
    "top",
    "right",
    "bottom",
    "left"
], $45dd2bf200a010e5$export$387a78ab20784494 = (0, $7fPBF.memo)(function(t) {
    var e = t.xScale, i = t.yScale, n = t.width, r = t.height, a = {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left
    };
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: $45dd2bf200a010e5$export$878041e1e4cd4218.map(function(t) {
            var o = a[t];
            if (!o) return null;
            var l = "top" === t || "bottom" === t;
            return (0, $824c049f32d4395d$exports.jsx)($45dd2bf200a010e5$export$d06866a9fb0606da, $45dd2bf200a010e5$var$v({}, o, {
                axis: l ? "x" : "y",
                x: "right" === t ? n : 0,
                y: "bottom" === t ? r : 0,
                scale: l ? e : i,
                length: l ? n : r,
                ticksPosition: "top" === t || "left" === t ? "before" : "after"
            }), t);
        })
    });
}), $45dd2bf200a010e5$export$cb089865d3c60926 = (0, $7fPBF.memo)(function(t) {
    var e = t.animatedProps, i = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).line, $45dd2bf200a010e5$var$v({}, e, i.grid.line));
}), $45dd2bf200a010e5$export$36506d95c1656a54 = (0, $7fPBF.memo)(function(t) {
    var e = t.lines, i = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), r = i.animate, a = i.config, l = (0, $27d73b36303119b6$export$7b286972b8d8ccbf)(e, {
        keys: function(t) {
            return t.key;
        },
        initial: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        from: function(t) {
            return {
                opacity: 0,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        enter: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        leave: {
            opacity: 0
        },
        config: a,
        immediate: !r
    });
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        children: l(function(t, e) {
            return (0, $7fPBF.createElement)($45dd2bf200a010e5$export$cb089865d3c60926, $45dd2bf200a010e5$var$v({}, e, {
                key: e.key,
                animatedProps: t
            }));
        })
    });
}), $45dd2bf200a010e5$export$ef2184bd89960b14 = (0, $7fPBF.memo)(function(t) {
    var e = t.width, n = t.height, r = t.xScale, a = t.yScale, o = t.xValues, l = t.yValues, s = (0, $7fPBF.useMemo)(function() {
        return !!r && $45dd2bf200a010e5$var$P({
            width: e,
            height: n,
            scale: r,
            axis: "x",
            values: o
        });
    }, [
        r,
        o,
        e,
        n
    ]), c = (0, $7fPBF.useMemo)(function() {
        return !!a && $45dd2bf200a010e5$var$P({
            width: e,
            height: n,
            scale: a,
            axis: "y",
            values: l
        });
    }, [
        n,
        e,
        a,
        l
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            s && (0, $824c049f32d4395d$exports.jsx)($45dd2bf200a010e5$export$36506d95c1656a54, {
                lines: s
            }),
            c && (0, $824c049f32d4395d$exports.jsx)($45dd2bf200a010e5$export$36506d95c1656a54, {
                lines: c
            })
        ]
    });
}), $45dd2bf200a010e5$export$b3252c0e7f5dbc3f = function(t, e) {
    var i, n = e.axis, r = e.scale, a = e.x, o = void 0 === a ? 0 : a, l = e.y, s = void 0 === l ? 0 : l, c = e.length, x = e.ticksPosition, u = e.tickValues, d = e.tickSize, m = void 0 === d ? 5 : d, y = e.tickPadding, g = void 0 === y ? 5 : y, k = e.tickRotation, h = void 0 === k ? 0 : k, v = e.format, b = e.legend, P = e.legendPosition, S = void 0 === P ? "end" : P, T = e.legendOffset, O = void 0 === T ? 0 : T, w = e.theme, A = $45dd2bf200a010e5$var$p({
        axis: n,
        scale: r,
        ticksPosition: x,
        tickValues: u,
        tickSize: m,
        tickPadding: g,
        tickRotation: h,
        engine: "canvas"
    }), X = A.ticks, Y = A.textAlign, W = A.textBaseline;
    t.save(), t.translate(o, s), t.textAlign = Y, t.textBaseline = W, t.font = (w.axis.ticks.text.fontWeight ? w.axis.ticks.text.fontWeight + " " : "") + w.axis.ticks.text.fontSize + "px " + w.axis.ticks.text.fontFamily, (null != (i = w.axis.domain.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(w.axis.domain.line.strokeWidth), t.lineCap = "square", w.axis.domain.line.stroke && (t.strokeStyle = w.axis.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === n ? c : 0, "x" === n ? 0 : c), t.stroke());
    var B = "function" == typeof v ? v : function(t) {
        return "" + t;
    };
    if (X.forEach(function(e) {
        var i;
        (null != (i = w.axis.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(w.axis.ticks.line.strokeWidth), t.lineCap = "square", w.axis.ticks.line.stroke && (t.strokeStyle = w.axis.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
        var n = B(e.value);
        t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(h)), w.axis.ticks.text.fill && (t.fillStyle = w.axis.ticks.text.fill), t.fillText(String(n), 0, 0), t.restore();
    }), void 0 !== b) {
        var z = 0, V = 0, C = 0, D = "center";
        "y" === n ? (C = -90, z = O, "start" === S ? (D = "start", V = c) : "middle" === S ? (D = "center", V = c / 2) : "end" === S && (D = "end")) : (V = O, "start" === S ? D = "start" : "middle" === S ? (D = "center", z = c / 2) : "end" === S && (D = "end", z = c)), t.translate(z, V), t.rotate((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(C)), t.font = (w.axis.legend.text.fontWeight ? w.axis.legend.text.fontWeight + " " : "") + w.axis.legend.text.fontSize + "px " + w.axis.legend.text.fontFamily, w.axis.legend.text.fill && (t.fillStyle = w.axis.legend.text.fill), t.textAlign = D, t.textBaseline = "middle", t.fillText(b, 0, 0);
    }
    t.restore();
}, $45dd2bf200a010e5$export$6f12c0e853c1bfff = function(t, e) {
    var i = e.xScale, n = e.yScale, r = e.width, a = e.height, o = e.top, l = e.right, s = e.bottom, c = e.left, f = e.theme, x = {
        top: o,
        right: l,
        bottom: s,
        left: c
    };
    $45dd2bf200a010e5$export$878041e1e4cd4218.forEach(function(e) {
        var o = x[e];
        if (!o) return null;
        var l = "top" === e || "bottom" === e, s = "top" === e || "left" === e ? "before" : "after", c = l ? i : n, u = $45dd2bf200a010e5$var$b(o.format, c);
        $45dd2bf200a010e5$export$b3252c0e7f5dbc3f(t, $45dd2bf200a010e5$var$v({}, o, {
            axis: l ? "x" : "y",
            x: "right" === e ? r : 0,
            y: "bottom" === e ? a : 0,
            scale: c,
            format: u,
            length: l ? r : a,
            ticksPosition: s,
            theme: f
        }));
    });
}, $45dd2bf200a010e5$export$5eea7e798580e5d1 = function(t, e) {
    var i = e.width, n = e.height, r = e.scale, a = e.axis, o = e.values;
    $45dd2bf200a010e5$var$P({
        width: i,
        height: n,
        scale: r,
        axis: a,
        values: o
    }).forEach(function(e) {
        t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
    });
};







function $6af9e0e3bbe49016$export$2e2bcd8739ae039() {
    var x0 = (0, $30204b10fe7aac69$export$d141bba7fdc215a3), x1 = null, y0 = (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(0), y1 = (0, $30204b10fe7aac69$export$4a5767248b18ef41), defined = (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(true), context = null, curve = (0, $ef8d0d3e260330b4$export$2e2bcd8739ae039), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $dd1da3dd953a1510$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $b88cb4978b49d732$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}








function $f04812e959279ec7$var$z() {
    return $f04812e959279ec7$var$z = Object.assign || function(i) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var o in t)Object.prototype.hasOwnProperty.call(t, o) && (i[o] = t[o]);
        }
        return i;
    }, $f04812e959279ec7$var$z.apply(this, arguments);
}
function $f04812e959279ec7$var$T(i, e) {
    if (null == i) return {};
    var t, o, n = {}, r = Object.keys(i);
    for(o = 0; o < r.length; o++)t = r[o], e.indexOf(t) >= 0 || (n[t] = i[t]);
    return n;
}
var $f04812e959279ec7$var$G = function(i) {
    return (0, $7fPBF.useMemo)(function() {
        return "function" == typeof i ? i : function() {
            return i;
        };
    }, [
        i
    ]);
}, $f04812e959279ec7$export$b33499518986d8c7 = function(o) {
    var n = o.width, a = o.height, d = o.data, c = o.interpolation, l = o.xPadding, s = o.xOuterPadding, v = o.yOuterPadding, u = o.lineWidth, p = o.activeLineWidth, h = o.inactiveLineWidth, m = o.colors, W = o.opacity, O = o.activeOpacity, S = o.inactiveOpacity, M = o.pointSize, I = o.activePointSize, C = o.inactivePointSize, B = o.pointColor, k = o.pointBorderWidth, A = o.activePointBorderWidth, E = o.inactivePointBorderWidth, w = o.pointBorderColor, T = o.isInteractive, F = o.defaultActiveSerieIds, H = (0, $7fPBF.useState)(F), X = H[0], j = H[1], Y = (0, $7fPBF.useMemo)(function() {
        return function(i) {
            var e = i.width, t = i.height, o = i.data, n = i.xPadding, r = i.xOuterPadding, a = i.yOuterPadding, d = new Set, c = new Set;
            o.forEach(function(i) {
                i.data.forEach(function(i) {
                    d.add(i.x), null !== i.y && c.add(i.y);
                });
            });
            var l = Array.from(d), s = (0, $06eaf1cc3810e0c0$export$a8f33a545c6650d6)((0, $89f43eb8e9e05b3b$export$105684a3041cb6f3)().domain(l).range([
                0,
                e
            ]).padding(r)), v = Array.from(c).sort(function(i, e) {
                return i - e;
            }), u = (0, $06eaf1cc3810e0c0$export$a8f33a545c6650d6)((0, $89f43eb8e9e05b3b$export$105684a3041cb6f3)().domain(v).range([
                0,
                t
            ]).padding(a)), p = s.step() * Math.min(.5 * n, .5);
            return {
                series: o.map(function(i) {
                    var t = {
                        id: i.id,
                        data: i,
                        points: [],
                        linePoints: []
                    };
                    return i.data.forEach(function(o, n) {
                        var r = null, a = null;
                        null !== o.y && (r = s(o.x), a = u(o.y));
                        var d = {
                            id: i.id + "." + n,
                            serie: i,
                            data: o,
                            x: r,
                            y: a
                        };
                        t.points.push(d), null !== d.x && (0 === n ? t.linePoints.push([
                            0,
                            d.y
                        ]) : t.linePoints.push([
                            d.x - p,
                            d.y
                        ])), t.linePoints.push([
                            d.x,
                            d.y
                        ]), null !== r && (n === i.data.length - 1 && r ? t.linePoints.push([
                            e,
                            d.y
                        ]) : t.linePoints.push([
                            d.x + p,
                            d.y
                        ])), t.points = t.points.filter(function(i) {
                            return null !== i.x;
                        });
                    }), t;
                }),
                xScale: s,
                yScale: u
            };
        }({
            width: n,
            height: a,
            data: d,
            xPadding: l,
            xOuterPadding: s,
            yOuterPadding: v
        });
    }, [
        n,
        a,
        d,
        l,
        s,
        v
    ]), K = Y.series, R = Y.xScale, q = Y.yScale, D = function(i) {
        return (0, $7fPBF.useMemo)(function() {
            return (0, $b88cb4978b49d732$export$2e2bcd8739ae039)().curve("smooth" === i ? (0, $057edd14d2e89b9f$export$2e2bcd8739ae039) : (0, $ef8d0d3e260330b4$export$2e2bcd8739ae039)).defined(function(i) {
                return null !== i[0] && null !== i[1];
            });
        }, [
            i
        ]);
    }(c), J = (0, $18aed9a2ed048594$export$47939777be1516f5)(m, "id"), N = function(i) {
        var e = i.lineWidth, o = i.activeLineWidth, n = i.inactiveLineWidth, r = i.opacity, a = i.activeOpacity, d = i.inactiveOpacity, c = i.isInteractive, l = i.activeSerieIds, s = $f04812e959279ec7$var$G(e), v = $f04812e959279ec7$var$G(o), u = $f04812e959279ec7$var$G(n), p = $f04812e959279ec7$var$G(r), h = $f04812e959279ec7$var$G(a), f = $f04812e959279ec7$var$G(d), g = (0, $7fPBF.useCallback)(function(i) {
            return {
                opacity: p(i),
                lineWidth: s(i)
            };
        }, [
            s,
            p
        ]), y = (0, $7fPBF.useCallback)(function(i) {
            return {
                opacity: h(i),
                lineWidth: v(i)
            };
        }, [
            v,
            h
        ]), m = (0, $7fPBF.useCallback)(function(i) {
            return {
                opacity: f(i),
                lineWidth: u(i)
            };
        }, [
            u,
            f
        ]);
        return (0, $7fPBF.useCallback)(function(i) {
            return c && 0 !== l.length ? l.includes(i.id) ? y(i) : m(i) : g(i);
        }, [
            g,
            y,
            m,
            c,
            l
        ]);
    }({
        lineWidth: u,
        activeLineWidth: p,
        inactiveLineWidth: h,
        opacity: W,
        activeOpacity: O,
        inactiveOpacity: S,
        isInteractive: T,
        activeSerieIds: X
    }), Q = (0, $7fPBF.useMemo)(function() {
        return K.map(function(i) {
            return $f04812e959279ec7$var$z({}, i, {
                color: J(i.data)
            }, N(i));
        });
    }, [
        K,
        J,
        N
    ]), U = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), V = (0, $18aed9a2ed048594$export$2a9e363116151414)(B, U), Z = (0, $18aed9a2ed048594$export$2a9e363116151414)(w, U), $ = function(i) {
        var e = i.pointSize, o = i.activePointSize, n = i.inactivePointSize, r = i.pointBorderWidth, a = i.activePointBorderWidth, d = i.inactivePointBorderWidth, c = i.isInteractive, l = i.activeSerieIds, s = $f04812e959279ec7$var$G(e), v = $f04812e959279ec7$var$G(o), u = $f04812e959279ec7$var$G(n), p = $f04812e959279ec7$var$G(r), h = $f04812e959279ec7$var$G(a), f = $f04812e959279ec7$var$G(d), g = (0, $7fPBF.useCallback)(function(i) {
            return {
                size: s(i),
                borderWidth: p(i)
            };
        }, [
            s,
            p
        ]), y = (0, $7fPBF.useCallback)(function(i) {
            return {
                size: v(i),
                borderWidth: h(i)
            };
        }, [
            v,
            h
        ]), m = (0, $7fPBF.useCallback)(function(i) {
            return {
                size: u(i),
                borderWidth: f(i)
            };
        }, [
            u,
            f
        ]);
        return (0, $7fPBF.useCallback)(function(i) {
            return c && 0 !== l.length ? l.includes(i.serie.id) ? y(i) : m(i) : g(i);
        }, [
            g,
            y,
            m,
            c,
            l
        ]);
    }({
        pointSize: M,
        activePointSize: I,
        inactivePointSize: C,
        pointBorderWidth: k,
        activePointBorderWidth: A,
        inactivePointBorderWidth: E,
        isInteractive: T,
        activeSerieIds: X
    }), _ = (0, $7fPBF.useMemo)(function() {
        var i = [];
        return Q.forEach(function(e) {
            e.points.forEach(function(t) {
                var o = $f04812e959279ec7$var$z({}, t, {
                    serie: e,
                    isActive: X.includes(e.id),
                    isInactive: X.length > 0 && !X.includes(e.id)
                });
                o.color = V(o), o.borderColor = Z(o), i.push($f04812e959279ec7$var$z({}, o, $(o)));
            });
        }), i;
    }, [
        Q,
        V,
        Z,
        $,
        X
    ]);
    return {
        xScale: R,
        yScale: q,
        series: Q,
        points: _,
        lineGenerator: D,
        activeSerieIds: X,
        setActiveSerieIds: j
    };
}, $f04812e959279ec7$export$20dd5cd732a7aee9 = function(i) {
    var n = i.serie, r = i.isInteractive, a = i.onMouseEnter, d = i.onMouseMove, c = i.onMouseLeave, l = i.onClick, s = i.setActiveSerieIds, v = i.tooltip, u = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), p = u.showTooltipFromEvent, h = u.hideTooltip, f = (0, $7fPBF.useCallback)(function(i) {
        p((0, $7fPBF.createElement)(v, {
            serie: n
        }), i), s([
            n.id
        ]), a && a(n, i);
    }, [
        n,
        a,
        p,
        s,
        v
    ]), g = (0, $7fPBF.useCallback)(function(i) {
        p((0, $7fPBF.createElement)(v, {
            serie: n
        }), i), d && d(n, i);
    }, [
        n,
        d,
        p,
        v
    ]), y = (0, $7fPBF.useCallback)(function(i) {
        h(), s([]), c && c(n, i);
    }, [
        n,
        c,
        h,
        s
    ]), m = (0, $7fPBF.useCallback)(function(i) {
        l && l(n, i);
    }, [
        n,
        l
    ]);
    return (0, $7fPBF.useMemo)(function() {
        return {
            onMouseEnter: r ? f : void 0,
            onMouseMove: r ? g : void 0,
            onMouseLeave: r ? y : void 0,
            onClick: r ? m : void 0
        };
    }, [
        r,
        f,
        g,
        y,
        m
    ]);
}, $f04812e959279ec7$export$45e1dad9a36e3a89 = function(i) {
    var t = i.series, o = i.position, n = i.padding, a = i.color, d = i.getLabel, c = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), l = (0, $18aed9a2ed048594$export$2a9e363116151414)(a, c);
    return (0, $7fPBF.useMemo)(function() {
        var i, e;
        "start" === o ? (i = "end", e = -1 * n) : (i = "start", e = n);
        var r = [];
        return t.forEach(function(t) {
            var n = t.id;
            "function" == typeof d && (n = d(t.data));
            var a = "start" === o ? t.linePoints[0] : t.linePoints[t.linePoints.length - 1];
            null !== a[0] && null !== a[1] && r.push({
                id: t.id,
                label: n,
                x: a[0] + e,
                y: a[1],
                color: l(t),
                opacity: t.opacity,
                serie: t,
                textAnchor: i
            });
        }), r;
    }, [
        t,
        o,
        n,
        l,
        d
    ]);
}, $f04812e959279ec7$var$j = {
    pointerEvents: "none"
}, $f04812e959279ec7$export$33da35f64f37f93b = $f04812e959279ec7$var$z({}, {
    layers: [
        "grid",
        "axes",
        "labels",
        "lines",
        "points"
    ],
    interpolation: "smooth",
    xPadding: .6,
    xOuterPadding: .5,
    yOuterPadding: .5,
    colors: {
        scheme: "nivo"
    },
    lineWidth: 2,
    activeLineWidth: 4,
    inactiveLineWidth: 1,
    opacity: 1,
    activeOpacity: 1,
    inactiveOpacity: .3,
    startLabel: !1,
    startLabelPadding: 16,
    startLabelTextColor: {
        from: "color"
    },
    endLabel: !0,
    endLabelPadding: 16,
    endLabelTextColor: {
        from: "color"
    },
    pointSize: 6,
    activePointSize: 8,
    inactivePointSize: 4,
    pointColor: {
        from: "serie.color"
    },
    pointBorderWidth: 0,
    activePointBorderWidth: 0,
    inactivePointBorderWidth: 0,
    pointBorderColor: {
        from: "serie.color",
        modifiers: [
            [
                "darker",
                1.4
            ]
        ]
    },
    enableGridX: !0,
    enableGridY: !0,
    axisTop: {},
    axisBottom: {},
    axisLeft: {},
    isInteractive: !0,
    defaultActiveSerieIds: [],
    tooltip: function(i) {
        var e = i.serie;
        return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d5f52d71198e271a), {
            "data-testid": "tooltip." + e.data.id,
            id: e.data.id,
            enableChip: !0,
            color: e.color
        });
    },
    role: "img"
}, {
    pointComponent: function(i) {
        var e = i.point, t = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), o = t.animate, n = t.config, r = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
            x: e.x,
            y: e.y,
            radius: e.size / 2,
            color: e.color,
            borderWidth: e.borderWidth,
            config: n,
            immediate: !o
        });
        return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).circle, {
            "data-testid": "point." + e.serie.id + "." + e.data.x,
            cx: r.x,
            cy: r.y,
            r: (0, $27d73b36303119b6$export$2c618a4308a30424)(r.radius, function(i) {
                return Math.max(i, 0);
            }),
            fill: r.color,
            strokeWidth: r.borderWidth,
            stroke: e.borderColor,
            style: $f04812e959279ec7$var$j
        });
    },
    animate: !0,
    motionConfig: "gentle"
}), $f04812e959279ec7$var$K = function(i) {
    var e = i.serie, t = i.lineGenerator, o = i.yStep, n = i.isInteractive, r = i.onMouseEnter, c = i.onMouseMove, l = i.onMouseLeave, s = i.onClick, v = i.setActiveSerieIds, u = i.tooltip, p = $f04812e959279ec7$export$20dd5cd732a7aee9({
        serie: e,
        isInteractive: n,
        onMouseEnter: r,
        onMouseMove: c,
        onMouseLeave: l,
        onClick: s,
        setActiveSerieIds: v,
        tooltip: u
    }), h = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), f = h.animate, g = h.config, y = t(e.linePoints) || "", m = (0, $0332e848e6fa2251$export$6b8391a1442f2172)(y), b = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        color: e.color,
        opacity: e.opacity,
        lineWidth: e.lineWidth,
        config: g,
        immediate: !f
    });
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
                "data-testid": "line." + e.id,
                fill: "none",
                d: m,
                stroke: b.color,
                strokeWidth: b.lineWidth,
                strokeLinecap: "round",
                strokeOpacity: b.opacity,
                style: {
                    pointerEvents: "none"
                }
            }),
            n && (0, $824c049f32d4395d$exports.jsx)("path", {
                "data-testid": "line." + e.id + ".interactive",
                fill: "none",
                stroke: "red",
                strokeOpacity: 0,
                strokeWidth: o,
                d: y,
                strokeLinecap: "butt",
                onMouseEnter: p.onMouseEnter,
                onMouseMove: p.onMouseMove,
                onMouseLeave: p.onMouseLeave,
                onClick: p.onClick
            })
        ]
    });
}, $f04812e959279ec7$var$R = function(i) {
    var e = i.series, t = i.getLabel, o = i.position, n = i.padding, d = i.color, c = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), l = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), s = l.animate, v = l.config, u = $f04812e959279ec7$export$45e1dad9a36e3a89({
        series: e,
        getLabel: t,
        position: o,
        padding: n,
        color: d
    }), p = (0, $27d73b36303119b6$export$15786d483ab9f469)(u.length, u.map(function(i) {
        return {
            x: i.x,
            y: i.y,
            opacity: i.opacity,
            config: v,
            immediate: !s
        };
    }));
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: p.map(function(i, e) {
            var t = u[e];
            return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                "data-testid": "label." + o + "." + t.serie.id,
                x: i.x,
                y: i.y,
                textAnchor: t.textAnchor,
                dominantBaseline: "central",
                opacity: i.opacity,
                style: $f04812e959279ec7$var$z({}, c.labels.text, {
                    fill: t.color
                }),
                children: t.label
            }, t.id);
        })
    });
}, $f04812e959279ec7$var$q = function(i) {
    var e = i.points, t = i.pointComponent;
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: e.map(function(i) {
            return (0, $7fPBF.createElement)(t, {
                key: i.id,
                point: i
            });
        })
    });
}, $f04812e959279ec7$var$D = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $f04812e959279ec7$var$J = function(i) {
    var t = i.data, r = i.width, a = i.height, d = i.margin, c = i.layers, v = void 0 === c ? $f04812e959279ec7$export$33da35f64f37f93b.layers : c, u = i.interpolation, f = void 0 === u ? $f04812e959279ec7$export$33da35f64f37f93b.interpolation : u, g = i.xPadding, y = void 0 === g ? $f04812e959279ec7$export$33da35f64f37f93b.xPadding : g, m = i.xOuterPadding, b = void 0 === m ? $f04812e959279ec7$export$33da35f64f37f93b.xOuterPadding : m, x = i.yOuterPadding, W = void 0 === x ? $f04812e959279ec7$export$33da35f64f37f93b.yOuterPadding : x, O = i.colors, P = void 0 === O ? $f04812e959279ec7$export$33da35f64f37f93b.colors : O, S = i.lineWidth, L = void 0 === S ? $f04812e959279ec7$export$33da35f64f37f93b.lineWidth : S, M = i.activeLineWidth, B = void 0 === M ? $f04812e959279ec7$export$33da35f64f37f93b.activeLineWidth : M, k = i.inactiveLineWidth, A = void 0 === k ? $f04812e959279ec7$export$33da35f64f37f93b.inactiveLineWidth : k, E = i.opacity, w = void 0 === E ? $f04812e959279ec7$export$33da35f64f37f93b.opacity : E, z = i.activeOpacity, T = void 0 === z ? $f04812e959279ec7$export$33da35f64f37f93b.activeOpacity : z, G = i.inactiveOpacity, H = void 0 === G ? $f04812e959279ec7$export$33da35f64f37f93b.inactiveOpacity : G, X = i.startLabel, j = void 0 === X ? $f04812e959279ec7$export$33da35f64f37f93b.startLabel : X, D = i.startLabelPadding, J = void 0 === D ? $f04812e959279ec7$export$33da35f64f37f93b.startLabelPadding : D, N = i.startLabelTextColor, Q = void 0 === N ? $f04812e959279ec7$export$33da35f64f37f93b.startLabelTextColor : N, U = i.endLabel, V = void 0 === U ? $f04812e959279ec7$export$33da35f64f37f93b.endLabel : U, Z = i.endLabelPadding, $ = void 0 === Z ? $f04812e959279ec7$export$33da35f64f37f93b.endLabelPadding : Z, _ = i.endLabelTextColor, ii = void 0 === _ ? $f04812e959279ec7$export$33da35f64f37f93b.endLabelTextColor : _, ei = i.pointComponent, ti = void 0 === ei ? $f04812e959279ec7$export$33da35f64f37f93b.pointComponent : ei, oi = i.pointSize, ni = void 0 === oi ? $f04812e959279ec7$export$33da35f64f37f93b.pointSize : oi, ri = i.activePointSize, ai = void 0 === ri ? $f04812e959279ec7$export$33da35f64f37f93b.activePointSize : ri, di = i.inactivePointSize, ci = void 0 === di ? $f04812e959279ec7$export$33da35f64f37f93b.inactivePointSize : di, li = i.pointColor, si = void 0 === li ? $f04812e959279ec7$export$33da35f64f37f93b.pointColor : li, vi = i.pointBorderWidth, ui = void 0 === vi ? $f04812e959279ec7$export$33da35f64f37f93b.pointBorderWidth : vi, pi = i.activePointBorderWidth, hi = void 0 === pi ? $f04812e959279ec7$export$33da35f64f37f93b.activePointBorderWidth : pi, fi = i.inactivePointBorderWidth, gi = void 0 === fi ? $f04812e959279ec7$export$33da35f64f37f93b.inactivePointBorderWidth : fi, yi = i.pointBorderColor, mi = void 0 === yi ? $f04812e959279ec7$export$33da35f64f37f93b.pointBorderColor : yi, bi = i.enableGridX, xi = void 0 === bi ? $f04812e959279ec7$export$33da35f64f37f93b.enableGridX : bi, Wi = i.enableGridY, Oi = void 0 === Wi ? $f04812e959279ec7$export$33da35f64f37f93b.enableGridY : Wi, Pi = i.axisTop, Si = void 0 === Pi ? $f04812e959279ec7$export$33da35f64f37f93b.axisTop : Pi, Li = i.axisRight, Mi = i.axisBottom, Ii = void 0 === Mi ? $f04812e959279ec7$export$33da35f64f37f93b.axisBottom : Mi, Ci = i.axisLeft, Bi = void 0 === Ci ? $f04812e959279ec7$export$33da35f64f37f93b.axisLeft : Ci, ki = i.isInteractive, Ai = void 0 === ki ? $f04812e959279ec7$export$33da35f64f37f93b.isInteractive : ki, Ei = i.defaultActiveSerieIds, wi = void 0 === Ei ? $f04812e959279ec7$export$33da35f64f37f93b.defaultActiveSerieIds : Ei, zi = i.onMouseEnter, Ti = i.onMouseMove, Gi = i.onMouseLeave, Fi = i.onClick, Hi = i.tooltip, Xi = void 0 === Hi ? $f04812e959279ec7$export$33da35f64f37f93b.tooltip : Hi, ji = i.role, Yi = void 0 === ji ? $f04812e959279ec7$export$33da35f64f37f93b.role : ji, Ki = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(r, a, d), Ri = Ki.margin, qi = Ki.innerWidth, Di = Ki.innerHeight, Ji = Ki.outerWidth, Ni = Ki.outerHeight, Qi = $f04812e959279ec7$export$b33499518986d8c7({
        width: qi,
        height: Di,
        data: t,
        interpolation: f,
        xPadding: y,
        xOuterPadding: b,
        yOuterPadding: W,
        lineWidth: L,
        activeLineWidth: B,
        inactiveLineWidth: A,
        colors: P,
        opacity: w,
        activeOpacity: T,
        inactiveOpacity: H,
        pointSize: ni,
        activePointSize: ai,
        inactivePointSize: ci,
        pointColor: si,
        pointBorderWidth: ui,
        activePointBorderWidth: hi,
        inactivePointBorderWidth: gi,
        pointBorderColor: mi,
        isInteractive: Ai,
        defaultActiveSerieIds: wi
    }), Ui = Qi.series, Vi = Qi.points, Zi = Qi.xScale, $i = Qi.yScale, _i = Qi.lineGenerator, ie = Qi.activeSerieIds, ee = Qi.setActiveSerieIds, te = {
        grid: null,
        axes: null,
        labels: null,
        lines: null,
        points: null
    };
    v.includes("grid") && (te.grid = (0, $824c049f32d4395d$exports.jsx)((0, $45dd2bf200a010e5$export$ef2184bd89960b14), {
        width: qi,
        height: Di,
        xScale: xi ? Zi : null,
        yScale: Oi ? $i : null
    }, "grid")), v.includes("axes") && (te.axes = (0, $824c049f32d4395d$exports.jsx)((0, $45dd2bf200a010e5$export$387a78ab20784494), {
        xScale: Zi,
        yScale: $i,
        width: qi,
        height: Di,
        top: Si,
        right: Li,
        bottom: Ii,
        left: Bi
    }, "axes")), v.includes("lines") && (te.lines = (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
        children: Ui.map(function(i) {
            return (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$K, {
                serie: i,
                setActiveSerieIds: ee,
                lineGenerator: _i,
                yStep: $i.step(),
                isInteractive: Ai,
                onMouseEnter: zi,
                onMouseMove: Ti,
                onMouseLeave: Gi,
                onClick: Fi,
                tooltip: Xi
            }, i.id);
        })
    }, "lines")), v.includes("points") && (te.points = (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$q, {
        pointComponent: ti,
        points: Vi
    }, "points")), v.includes("labels") && (te.labels = (0, $824c049f32d4395d$exports.jsxs)((0, $7fPBF.Fragment), {
        children: [
            !1 !== j && (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$R, {
                series: Ui,
                getLabel: j,
                position: "start",
                padding: J,
                color: Q
            }),
            !1 !== V && (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$R, {
                series: Ui,
                getLabel: V,
                position: "end",
                padding: $,
                color: ii
            })
        ]
    }, "legends"));
    var oe = (0, $7fPBF.useMemo)(function() {
        return {
            innerHeight: Di,
            innerWidth: qi,
            lineGenerator: _i,
            points: Vi,
            series: Ui,
            xScale: Zi,
            yScale: $i,
            activeSerieIds: ie,
            setActiveSerieIds: ee
        };
    }, [
        ie,
        ee,
        Di,
        qi,
        _i,
        Vi,
        Ui,
        Zi,
        $i
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$21d9f1931ef75b56), {
        width: Ji,
        height: Ni,
        margin: Ri,
        role: Yi,
        children: v.map(function(i, e) {
            var t;
            return "function" == typeof i ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: (0, $7fPBF.createElement)(i, oe)
            }, e) : null != (t = null == te ? void 0 : te[i]) ? t : null;
        })
    });
}, $f04812e959279ec7$export$63d395f26621cc98 = function(i) {
    var e = i.isInteractive, t = void 0 === e ? $f04812e959279ec7$export$33da35f64f37f93b.isInteractive : e, o = i.animate, n = void 0 === o ? $f04812e959279ec7$export$33da35f64f37f93b.animate : o, r = i.motionConfig, a = void 0 === r ? $f04812e959279ec7$export$33da35f64f37f93b.motionConfig : r, d = i.theme, l = i.renderWrapper, s = $f04812e959279ec7$var$T(i, $f04812e959279ec7$var$D);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$42a852a2b6b56249), {
        animate: n,
        isInteractive: t,
        motionConfig: a,
        renderWrapper: l,
        theme: d,
        children: (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$J, $f04812e959279ec7$var$z({
            isInteractive: t
        }, s))
    });
}, $f04812e959279ec7$export$a85619df52d568da = function(i) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(e) {
            var t = e.width, o = e.height;
            return (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$export$63d395f26621cc98, $f04812e959279ec7$var$z({
                width: t,
                height: o
            }, i));
        }
    });
}, $f04812e959279ec7$var$U = function(i) {
    var t = i.data, o = i.width, n = i.height, r = i.align, a = i.spacing, d = i.xPadding;
    return (0, $7fPBF.useMemo)(function() {
        return function(i) {
            var e, t, o = i.data, n = i.width, r = i.height, a = i.align, d = i.spacing, c = i.xPadding, l = new Map;
            o.forEach(function(i) {
                i.data.forEach(function(o) {
                    l.has(o.x) || l.set(o.x, {
                        id: o.x,
                        total: 0,
                        values: new Map,
                        x: 0
                    });
                    var n = l.get(o.x), r = n.total + o.y;
                    n.total = r, n.values.set(i.id, {
                        serieId: i.id,
                        value: o.y,
                        position: 0,
                        height: 0,
                        beforeHeight: 0
                    }), (void 0 === e || r > e) && (e = r), (void 0 === t || n.values.size > t) && (t = n.values.size);
                });
            });
            var s = (0, $06eaf1cc3810e0c0$export$a8f33a545c6650d6)((0, $89f43eb8e9e05b3b$export$105684a3041cb6f3)().domain(Array.from(l.keys())).range([
                0,
                n
            ])), v = (0, $06eaf1cc3810e0c0$export$4fd02d345bf145e3)((0, $43657edf9f9313df$export$2e2bcd8739ae039)().domain([
                0,
                e
            ]).range([
                0,
                r - t * d
            ]));
            l.forEach(function(i, e) {
                i.x = s(e);
                var t = v(i.total) + i.values.size * d, o = 0;
                "middle" === a ? o = (r - t) / 2 : "end" === a && (o = r - t), Array.from(i.values.values()).sort(function(i, e) {
                    return e.value - i.value;
                }).forEach(function(e, t, n) {
                    var r = n.filter(function(i, e) {
                        return e < t;
                    }), a = r.reduce(function(i, e) {
                        return i + e.value;
                    }, 0), c = i.values.get(e.serieId);
                    c.position = t, c.height = v(e.value), c.beforeHeight = v(a) + o + d * (r.length + .5);
                });
            });
            var u = s.step() * Math.min(.5 * c, .5), p = o.map(function(i) {
                var e = {
                    id: i.id,
                    data: i,
                    points: [],
                    areaPoints: []
                };
                return i.data.forEach(function(t, o) {
                    var n = l.get(t.x), r = n.values.get(i.id), a = n.x, d = r.beforeHeight, c = r.height, s = d + c / 2, v = d, p = d + c;
                    e.points.push({
                        x: a,
                        y: s,
                        height: c,
                        data: $f04812e959279ec7$var$z({}, t)
                    }), o > 0 && e.areaPoints.push({
                        x: a - u,
                        y0: v,
                        y1: p
                    }), e.areaPoints.push({
                        x: a,
                        y0: v,
                        y1: p
                    }), o < i.data.length - 1 && e.areaPoints.push({
                        x: a + u,
                        y0: v,
                        y1: p
                    });
                }), e;
            });
            return {
                series: p,
                xScale: s,
                heightScale: v
            };
        }({
            data: t,
            width: o,
            height: n,
            align: r,
            spacing: a,
            xPadding: d
        });
    }, [
        t,
        o,
        n,
        r,
        a,
        d
    ]);
}, $f04812e959279ec7$var$V = function(i) {
    return (0, $7fPBF.useMemo)(function() {
        return "function" == typeof i ? i : function() {
            return i;
        };
    }, [
        i
    ]);
}, $f04812e959279ec7$export$c95e1d1f6532443a = function(o) {
    var n = o.data, a = o.width, d = o.height, c = o.align, l = o.spacing, s = o.xPadding, v = o.interpolation, u = o.colors, p = o.fillOpacity, h = o.activeFillOpacity, f = o.inactiveFillOpacity, W = o.borderWidth, O = o.activeBorderWidth, P = o.inactiveBorderWidth, S = o.borderColor, L = o.borderOpacity, M = o.activeBorderOpacity, I = o.inactiveBorderOpacity, C = o.isInteractive, B = o.defaultActiveSerieIds, k = (0, $7fPBF.useState)(B), A = k[0], E = k[1], w = $f04812e959279ec7$var$U({
        data: n,
        width: a,
        height: d,
        align: c,
        spacing: l,
        xPadding: s
    }), T = w.series, G = w.xScale, F = w.heightScale, H = function(i) {
        return (0, $7fPBF.useMemo)(function() {
            return (0, $6af9e0e3bbe49016$export$2e2bcd8739ae039)().x(function(i) {
                return i.x;
            }).y0(function(i) {
                return i.y0;
            }).y1(function(i) {
                return i.y1;
            }).curve("smooth" === i ? (0, $057edd14d2e89b9f$export$2e2bcd8739ae039) : (0, $ef8d0d3e260330b4$export$2e2bcd8739ae039));
        }, [
            i
        ]);
    }(v), X = (0, $18aed9a2ed048594$export$47939777be1516f5)(u, "id"), j = function(i) {
        var e = i.fillOpacity, o = i.activeFillOpacity, n = i.inactiveFillOpacity, a = i.borderWidth, d = i.activeBorderWidth, c = i.inactiveBorderWidth, l = i.borderColor, s = i.borderOpacity, v = i.activeBorderOpacity, u = i.inactiveBorderOpacity, p = i.isInteractive, h = i.activeSerieIds, f = $f04812e959279ec7$var$V(e), g = $f04812e959279ec7$var$V(o), y = $f04812e959279ec7$var$V(n), m = $f04812e959279ec7$var$V(a), b = $f04812e959279ec7$var$V(d), W = $f04812e959279ec7$var$V(c), O = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), P = (0, $18aed9a2ed048594$export$2a9e363116151414)(l, O), S = $f04812e959279ec7$var$V(s), L = $f04812e959279ec7$var$V(v), M = $f04812e959279ec7$var$V(u), I = (0, $7fPBF.useCallback)(function(i) {
            return {
                fillOpacity: f(i),
                borderWidth: m(i),
                borderColor: P(i),
                borderOpacity: S(i)
            };
        }, [
            f,
            m,
            P,
            S
        ]), C = (0, $7fPBF.useCallback)(function(i) {
            return {
                fillOpacity: g(i),
                borderWidth: b(i),
                borderColor: P(i),
                borderOpacity: L(i)
            };
        }, [
            g,
            b,
            P,
            L
        ]), B = (0, $7fPBF.useCallback)(function(i) {
            return {
                fillOpacity: y(i),
                borderWidth: W(i),
                borderColor: P(i),
                borderOpacity: M(i)
            };
        }, [
            y,
            W,
            P,
            M
        ]);
        return (0, $7fPBF.useCallback)(function(i) {
            return p && 0 !== h.length ? h.includes(i.id) ? C(i) : B(i) : I(i);
        }, [
            I,
            C,
            B,
            p,
            h
        ]);
    }({
        fillOpacity: p,
        activeFillOpacity: h,
        inactiveFillOpacity: f,
        borderWidth: W,
        activeBorderWidth: O,
        inactiveBorderWidth: P,
        borderColor: S,
        borderOpacity: L,
        activeBorderOpacity: M,
        inactiveBorderOpacity: I,
        isInteractive: C,
        activeSerieIds: A
    });
    return {
        series: (0, $7fPBF.useMemo)(function() {
            return T.map(function(i) {
                var e = $f04812e959279ec7$var$z({}, i, {
                    color: X(i.data)
                });
                return $f04812e959279ec7$var$z({}, e, j(e));
            });
        }, [
            T,
            X,
            j
        ]),
        xScale: G,
        heightScale: F,
        areaGenerator: H,
        activeSerieIds: A,
        setActiveSerieIds: E
    };
}, $f04812e959279ec7$export$69c5ca5f633c0a8d = function(i) {
    var n = i.serie, r = i.isInteractive, a = i.onMouseEnter, d = i.onMouseMove, c = i.onMouseLeave, l = i.onClick, s = i.setActiveSerieIds, v = i.tooltip, u = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), p = u.showTooltipFromEvent, h = u.hideTooltip, f = (0, $7fPBF.useCallback)(function(i) {
        p((0, $7fPBF.createElement)(v, {
            serie: n
        }), i), s([
            n.id
        ]), a && a(n, i);
    }, [
        n,
        a,
        p,
        s,
        v
    ]), g = (0, $7fPBF.useCallback)(function(i) {
        p((0, $7fPBF.createElement)(v, {
            serie: n
        }), i), d && d(n, i);
    }, [
        n,
        d,
        p,
        v
    ]), y = (0, $7fPBF.useCallback)(function(i) {
        h(), s([]), c && c(n, i);
    }, [
        n,
        c,
        h,
        s
    ]), m = (0, $7fPBF.useCallback)(function(i) {
        l && l(n, i);
    }, [
        n,
        l
    ]);
    return (0, $7fPBF.useMemo)(function() {
        return {
            onMouseEnter: r ? f : void 0,
            onMouseMove: r ? g : void 0,
            onMouseLeave: r ? y : void 0,
            onClick: r ? m : void 0
        };
    }, [
        r,
        f,
        g,
        y,
        m
    ]);
}, $f04812e959279ec7$export$c15dad552ddb2ca4 = function(i) {
    var t = i.series, o = i.position, n = i.padding, a = i.color, d = i.getLabel, c = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), l = (0, $18aed9a2ed048594$export$2a9e363116151414)(a, c);
    return (0, $7fPBF.useMemo)(function() {
        var i, e;
        return "start" === o ? (i = "end", e = -1 * n) : (i = "start", e = n), t.map(function(t) {
            var n = t.id;
            "function" == typeof d && (n = d(t.data));
            var r = "start" === o ? t.points[0] : t.points[t.points.length - 1];
            return {
                id: t.id,
                label: n,
                x: r.x + e,
                y: r.y,
                color: l(t),
                opacity: t.fillOpacity,
                serie: t,
                textAnchor: i
            };
        });
    }, [
        d,
        t,
        o,
        n,
        l
    ]);
}, $f04812e959279ec7$var$ii = function(i) {
    var e = i.serie, t = i.areaGenerator, o = i.blendMode, n = i.isInteractive, r = i.onMouseEnter, c = i.onMouseMove, l = i.onMouseLeave, s = i.onClick, v = i.setActiveSerieIds, u = i.tooltip, p = $f04812e959279ec7$export$69c5ca5f633c0a8d({
        serie: e,
        isInteractive: n,
        onMouseEnter: r,
        onMouseMove: c,
        onMouseLeave: l,
        onClick: s,
        setActiveSerieIds: v,
        tooltip: u
    }), h = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), f = h.animate, g = h.config, y = (0, $0332e848e6fa2251$export$6b8391a1442f2172)(t(e.areaPoints) || ""), m = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        color: e.color,
        fillOpacity: e.fillOpacity,
        stroke: e.borderColor,
        strokeOpacity: e.borderOpacity,
        config: g,
        immediate: !f
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
        "data-testid": "area." + e.id,
        d: y,
        fill: e.fill ? e.fill : m.color,
        fillOpacity: m.fillOpacity,
        stroke: m.stroke,
        strokeWidth: e.borderWidth,
        strokeOpacity: m.strokeOpacity,
        style: {
            mixBlendMode: o
        },
        onMouseEnter: p.onMouseEnter,
        onMouseMove: p.onMouseMove,
        onMouseLeave: p.onMouseLeave,
        onClick: p.onClick
    });
}, $f04812e959279ec7$var$ei = function(i) {
    var e = i.getLabel, t = i.series, o = i.position, n = i.padding, d = i.color, c = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), l = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), s = l.animate, v = l.config, u = $f04812e959279ec7$export$c15dad552ddb2ca4({
        getLabel: e,
        series: t,
        position: o,
        padding: n,
        color: d
    }), p = (0, $27d73b36303119b6$export$15786d483ab9f469)(u.length, u.map(function(i) {
        return {
            x: i.x,
            y: i.y,
            opacity: i.opacity,
            config: v,
            immediate: !s
        };
    }));
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: p.map(function(i, e) {
            var t = u[e];
            return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                "data-testid": "label." + o + "." + t.serie.id,
                x: i.x,
                y: i.y,
                textAnchor: t.textAnchor,
                dominantBaseline: "central",
                opacity: i.opacity,
                style: $f04812e959279ec7$var$z({}, c.labels.text, {
                    fill: t.color
                }),
                children: t.label
            }, t.id);
        })
    });
}, $f04812e959279ec7$export$736eabb3a83c9001 = $f04812e959279ec7$var$z({}, {
    align: "middle",
    layers: [
        "grid",
        "axes",
        "labels",
        "areas"
    ],
    interpolation: "smooth",
    spacing: 0,
    xPadding: .6,
    colors: {
        scheme: "nivo"
    },
    blendMode: "normal",
    fillOpacity: .8,
    activeFillOpacity: 1,
    inactiveFillOpacity: .15,
    borderWidth: 1,
    activeBorderWidth: 1,
    inactiveBorderWidth: 0,
    borderColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                .4
            ]
        ]
    },
    borderOpacity: 1,
    activeBorderOpacity: 1,
    inactiveBorderOpacity: 0,
    startLabel: !1,
    startLabelPadding: 12,
    startLabelTextColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                1
            ]
        ]
    },
    endLabel: !0,
    endLabelPadding: 12,
    endLabelTextColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                1
            ]
        ]
    },
    enableGridX: !0,
    axisTop: {},
    axisBottom: {},
    isInteractive: !0,
    defaultActiveSerieIds: [],
    tooltip: function(i) {
        var e = i.serie;
        return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d5f52d71198e271a), {
            id: e.id,
            enableChip: !0,
            color: e.color
        });
    },
    role: "img"
}, {
    defs: [],
    fill: [],
    animate: !0,
    motionConfig: "gentle"
}), $f04812e959279ec7$var$oi = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $f04812e959279ec7$var$ni = function(i) {
    var t = i.data, r = i.align, a = void 0 === r ? $f04812e959279ec7$export$736eabb3a83c9001.align : r, d = i.width, c = i.height, v = i.margin, f = i.layers, g = void 0 === f ? $f04812e959279ec7$export$736eabb3a83c9001.layers : f, y = i.interpolation, m = void 0 === y ? $f04812e959279ec7$export$736eabb3a83c9001.interpolation : y, b = i.spacing, x = void 0 === b ? $f04812e959279ec7$export$736eabb3a83c9001.spacing : b, W = i.xPadding, O = void 0 === W ? $f04812e959279ec7$export$736eabb3a83c9001.xPadding : W, P = i.colors, S = void 0 === P ? $f04812e959279ec7$export$736eabb3a83c9001.colors : P, L = i.blendMode, M = void 0 === L ? $f04812e959279ec7$export$736eabb3a83c9001.blendMode : L, B = i.fillOpacity, k = void 0 === B ? $f04812e959279ec7$export$736eabb3a83c9001.fillOpacity : B, A = i.activeFillOpacity, E = void 0 === A ? $f04812e959279ec7$export$736eabb3a83c9001.activeFillOpacity : A, w = i.inactiveFillOpacity, z = void 0 === w ? $f04812e959279ec7$export$736eabb3a83c9001.inactiveFillOpacity : w, T = i.defs, G = void 0 === T ? $f04812e959279ec7$export$736eabb3a83c9001.defs : T, F = i.fill, H = void 0 === F ? $f04812e959279ec7$export$736eabb3a83c9001.fill : F, X = i.borderWidth, j = void 0 === X ? $f04812e959279ec7$export$736eabb3a83c9001.borderWidth : X, Y = i.activeBorderWidth, K = void 0 === Y ? $f04812e959279ec7$export$736eabb3a83c9001.activeBorderWidth : Y, R = i.inactiveBorderWidth, q = void 0 === R ? $f04812e959279ec7$export$736eabb3a83c9001.inactiveBorderWidth : R, D = i.borderColor, J = void 0 === D ? $f04812e959279ec7$export$736eabb3a83c9001.borderColor : D, N = i.borderOpacity, Q = void 0 === N ? $f04812e959279ec7$export$736eabb3a83c9001.borderOpacity : N, U = i.activeBorderOpacity, V = void 0 === U ? $f04812e959279ec7$export$736eabb3a83c9001.activeBorderOpacity : U, $ = i.inactiveBorderOpacity, _ = void 0 === $ ? $f04812e959279ec7$export$736eabb3a83c9001.inactiveBorderOpacity : $, oi = i.startLabel, ni = void 0 === oi ? $f04812e959279ec7$export$736eabb3a83c9001.startLabel : oi, ri = i.startLabelPadding, ai = void 0 === ri ? $f04812e959279ec7$export$736eabb3a83c9001.startLabelPadding : ri, di = i.startLabelTextColor, ci = void 0 === di ? $f04812e959279ec7$export$736eabb3a83c9001.startLabelTextColor : di, li = i.endLabel, si = void 0 === li ? $f04812e959279ec7$export$736eabb3a83c9001.endLabel : li, vi = i.endLabelPadding, ui = void 0 === vi ? $f04812e959279ec7$export$736eabb3a83c9001.endLabelPadding : vi, pi = i.endLabelTextColor, hi = void 0 === pi ? $f04812e959279ec7$export$736eabb3a83c9001.endLabelTextColor : pi, fi = i.enableGridX, gi = void 0 === fi ? $f04812e959279ec7$export$736eabb3a83c9001.enableGridX : fi, yi = i.axisTop, mi = void 0 === yi ? $f04812e959279ec7$export$736eabb3a83c9001.axisTop : yi, bi = i.axisBottom, xi = void 0 === bi ? $f04812e959279ec7$export$736eabb3a83c9001.axisBottom : bi, Wi = i.isInteractive, Oi = void 0 === Wi ? $f04812e959279ec7$export$736eabb3a83c9001.isInteractive : Wi, Pi = i.defaultActiveSerieIds, Si = void 0 === Pi ? $f04812e959279ec7$export$736eabb3a83c9001.defaultActiveSerieIds : Pi, Li = i.onMouseEnter, Mi = i.onMouseMove, Ii = i.onMouseLeave, Ci = i.onClick, Bi = i.tooltip, ki = void 0 === Bi ? $f04812e959279ec7$export$736eabb3a83c9001.tooltip : Bi, Ai = i.role, Ei = void 0 === Ai ? $f04812e959279ec7$export$736eabb3a83c9001.role : Ai, wi = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(d, c, v), zi = wi.margin, Ti = wi.innerWidth, Gi = wi.innerHeight, Fi = wi.outerWidth, Hi = wi.outerHeight, Xi = $f04812e959279ec7$export$c95e1d1f6532443a({
        data: t,
        width: Ti,
        height: Gi,
        align: a,
        spacing: x,
        xPadding: O,
        interpolation: m,
        colors: S,
        fillOpacity: k,
        activeFillOpacity: E,
        inactiveFillOpacity: z,
        borderWidth: j,
        activeBorderWidth: K,
        inactiveBorderWidth: q,
        borderColor: J,
        borderOpacity: Q,
        activeBorderOpacity: V,
        inactiveBorderOpacity: _,
        isInteractive: Oi,
        defaultActiveSerieIds: Si
    }), ji = Xi.series, Yi = Xi.xScale, Ki = Xi.heightScale, Ri = Xi.areaGenerator, qi = Xi.setActiveSerieIds, Di = (0, $7fPBF.useMemo)(function() {
        return (0, $0332e848e6fa2251$export$dc35cf769e3afe34)(G, ji, H, {
            targetKey: "fill"
        });
    }, [
        G,
        ji,
        H
    ]), Ji = {
        grid: null,
        axes: null,
        labels: null,
        areas: null
    };
    g.includes("grid") && gi && (Ji.grid = (0, $824c049f32d4395d$exports.jsx)((0, $45dd2bf200a010e5$export$ef2184bd89960b14), {
        width: Ti,
        height: Gi,
        xScale: Yi
    }, "grid")), g.includes("axes") && (Ji.axes = (0, $824c049f32d4395d$exports.jsx)((0, $45dd2bf200a010e5$export$387a78ab20784494), {
        xScale: Yi,
        yScale: Ki,
        width: Ti,
        height: Gi,
        top: mi,
        bottom: xi
    }, "axes")), g.includes("areas") && (Ji.areas = (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
        children: ji.map(function(i) {
            return (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$ii, {
                areaGenerator: Ri,
                serie: i,
                blendMode: M,
                isInteractive: Oi,
                setActiveSerieIds: qi,
                onMouseEnter: Li,
                onMouseMove: Mi,
                onMouseLeave: Ii,
                onClick: Ci,
                tooltip: ki
            }, i.id);
        })
    }, "areas")), g.includes("labels") && (Ji.labels = (0, $824c049f32d4395d$exports.jsxs)((0, $7fPBF.Fragment), {
        children: [
            !1 !== ni && (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$ei, {
                getLabel: ni,
                series: ji,
                position: "start",
                padding: ai,
                color: ci
            }),
            !1 !== si && (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$ei, {
                getLabel: si,
                series: ji,
                position: "end",
                padding: ui,
                color: hi
            })
        ]
    }, "labels"));
    var Ni = (0, $7fPBF.useMemo)(function() {
        return {
            innerWidth: Ti,
            innerHeight: Gi,
            outerWidth: Fi,
            outerHeight: Hi,
            series: ji,
            xScale: Yi,
            areaGenerator: Ri
        };
    }, [
        Ti,
        Gi,
        Fi,
        Hi,
        ji,
        Yi,
        Ri
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$21d9f1931ef75b56), {
        defs: Di,
        width: Fi,
        height: Hi,
        margin: zi,
        role: Ei,
        children: g.map(function(i, e) {
            var t;
            return "function" == typeof i ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: (0, $7fPBF.createElement)(i, Ni)
            }, e) : null != (t = null == Ji ? void 0 : Ji[i]) ? t : null;
        })
    });
}, $f04812e959279ec7$export$3b081d9cc7889359 = function(i) {
    var e = i.isInteractive, t = void 0 === e ? $f04812e959279ec7$export$736eabb3a83c9001.isInteractive : e, o = i.animate, n = void 0 === o ? $f04812e959279ec7$export$736eabb3a83c9001.animate : o, r = i.motionConfig, a = void 0 === r ? $f04812e959279ec7$export$736eabb3a83c9001.motionConfig : r, d = i.theme, l = i.renderWrapper, s = $f04812e959279ec7$var$T(i, $f04812e959279ec7$var$oi);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$42a852a2b6b56249), {
        animate: n,
        isInteractive: t,
        motionConfig: a,
        renderWrapper: l,
        theme: d,
        children: (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$var$ni, $f04812e959279ec7$var$z({
            isInteractive: t
        }, s))
    });
}, $f04812e959279ec7$export$46f2c39c85973818 = function(i) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(e) {
            var t = e.width, o = e.height;
            return (0, $824c049f32d4395d$exports.jsx)($f04812e959279ec7$export$3b081d9cc7889359, $f04812e959279ec7$var$z({
                width: t,
                height: o
            }, i));
        }
    });
};





function $27be5ba4a9e32b50$var$makeNivoRenderer(NivoChart, traceOptions = {}, layoutOptions = {}, transpose = false) {
    return function NivoRenderer(props) {
        if (!props.data || props.data.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
        const pivotData = new (0, $25ed1e0e429105db$exports.PivotData)(props);
        const columnNames = pivotData.getRowKeys();
        const barNames = pivotData.getColKeys();
        const isViewerMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
            var _state_viewer_metadata, _state_viewer;
            return (_state_viewer = state.viewer) === null || _state_viewer === void 0 ? void 0 : (_state_viewer_metadata = _state_viewer.metadata) === null || _state_viewer_metadata === void 0 ? void 0 : _state_viewer_metadata.publishedOn;
        });
        const accounts = isViewerMode ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.accounts) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
        let fullAggName = props.aggregatorName;
        const numInputs = props.aggregators[fullAggName]([])().numInputs || 0;
        if (numInputs !== 0) fullAggName += ` of ${props.vals.slice(0, numInputs).join(", ")}`;
        // console.log('AreaBump: rowKeys', columnNames); // all the possible combinations of main key category fields [[2015, 'DKB Giro'], [2017, 'Festgeld'],[2019, 'Festgeld'] ...]
        // console.log('AreaBump: colKeys', barNames); // all the possible combinations of the secondary key category fields [['American Express', 'EUR'], ['Arbeitgeber AG', 'EUR'], ['Avis AG', 'EUR']...]
        // console.log('AreaBump: pivotData with props', pivotData);
        // rowKeys and colKeys have all the needed combinations of keys already
        // e.g. [[2015, 'EUR'], [2015, 'USD'], [2016, 'EUR'], [2017, 'EUR']]
        // even if there are more than 1 attribute in each group
        // so all that needs to happen is to produce for each object (which is an array) in rowKeys
        // an object with the joinedKey
        const columnFieldNames = pivotData.props.rows; // ["Date (Year)", "accountName"]
        const barFieldNames = pivotData.props.cols; // names of the fields that go to secondary category ["otherParty", "currency"]
        // console.log('AreaBump: rowNames', columnFieldNames);
        // console.log('AreaBump: colNames', barFieldNames);
        function joinKeys(keys) {
            return typeof keys === "object" ? keys.join(String.fromCharCode(0)) : keys;
        }
        const randomColors = [
            "#68BBF7",
            "#B8E08D",
            "#d3a0df",
            "#ffe666",
            "#f26065",
            "#6265ad"
        ];
        // if the accountName is a name of an account, return the color of the account
        // otherwise return a random color from the approved array
        function getAccountColor(accountName) {
            const account = accounts.find((acc)=>acc.name === accountName);
            if (account) return (0, $134ab0040d88b150$export$205e6715f8ffaf7d)[account.category].color.hex;
            return randomColors[Math.floor(Math.random() * randomColors.length)];
        }
        // FIXME this organises data by ACCOUNT NAME; if two accounts happen to have the same name, the data will be merged
        // expects Date (Year) / Date (Month) as main category, account or category as secondary category
        const chartData = barNames.map((colKey)=>{
            const barNamesJoined = joinKeys(colKey); // in case there is more than one per array
            const colData = columnNames.map((rowKey)=>{
                const columnNamesJoined = joinKeys(rowKey);
                // console.log('AreaBump: columnNamesJoined', columnNamesJoined);
                // console.log('AreaBump: barFieldNames[0]:', barFieldNames[0], 'columnNamesJoined', columnNamesJoined, 'barNamesJoined:', barNamesJoined, 'columnFieldNames[0]:', columnFieldNames[0]);
                // console.log(
                //   'AreaBump: pivotData.props.data',
                //   pivotData.props.data.filter((d) => d[barFieldNames[0]] === barNamesJoined && d[columnFieldNames[0]] === columnNamesJoined),
                // );
                // TODO: this is a chart component, so all it should do is display the data provided by parent (no logic!)
                // i.e. for the annual chart this should already receive one object per bar and per column
                const y = pivotData.props.data.filter((d)=>d[barFieldNames[0]] === barNamesJoined && d[columnFieldNames[0]] === columnNamesJoined) // this will return several rows if colKeys are years
                // this filter will return all the rows that match the current columnNamesJoined and barNamesJoined
                .reduce((prev, curr)=>prev + curr.value, 0);
                return {
                    x: columnNamesJoined,
                    y: Math.abs(y)
                };
            });
            return {
                id: barNamesJoined,
                data: colData
            };
        });
        // console.log('AreaBump: chartData (output)', chartData);
        const colors = chartData.map((d)=>getAccountColor(d.id));
        // AreaBump charts require a data array with the following structure:
        // [
        //   {
        //     "id": "DEPOT1",
        //     "data": [
        //       {
        //         "x": 2000,
        //         "y": 14
        //       },
        //       {
        //         "x": 2001,
        //         "y": 20
        //       }, ...
        function getAggregate(parents) {
            return pivotData.props.data.reduce((prev, curr)=>{
                if (curr.formattingLevel !== null) return prev;
                // go through all summary rows, lowest level only
                // only add value when ALL the parent level's conditions from 'parents' are met
                // i.e. if parents is [['category', 'deposits'], ['accountName', 'DKB Giro']]
                // then only add value when both conditions are met
                if (parents.every((parent)=>curr[parent[0]] === parent[1])) return prev + curr.currentValue;
                return prev;
            }, 0);
        }
        const commonProps = (0, $9tqwB._)({
            margin: {
                top: 10,
                right: 130,
                bottom: 36,
                left: 130
            },
            spacing: 8,
            padding: 0.2,
            colors: colors,
            theme: {
                fontFamily: "Lato",
                tooltip: {
                    container: {
                        background: "#333",
                        color: "#fff"
                    }
                }
            },
            id: "name",
            data: chartData,
            startLabel: "id",
            startLabelTextColor: {
                from: "color",
                modifiers: [
                    [
                        "darker",
                        0.4
                    ]
                ]
            },
            endLabel: "id",
            endLabelTextColor: {
                from: "color",
                modifiers: [
                    [
                        "darker",
                        0.4
                    ]
                ]
            }
        }, pivotData.props.layoutOptions);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "relative w-full h-full",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NivoChart, (0, $9tqwB._)({}, commonProps))
        });
    };
}
function $27be5ba4a9e32b50$export$2e2bcd8739ae039() {
    return {
        "Area chart": $27be5ba4a9e32b50$var$makeNivoRenderer((0, $f04812e959279ec7$export$46f2c39c85973818))
    };
}


/* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $1f8b88f2b81b0f2b$export$15925baccc9f07fd = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("circle", {
        r: o / 2,
        cx: i + o / 2,
        cy: n + o / 2,
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        style: {
            pointerEvents: "none"
        }
    });
}, $1f8b88f2b81b0f2b$export$b7efc3c73c701547 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
            fill: r,
            opacity: a,
            strokeWidth: s,
            stroke: void 0 === d ? "transparent" : d,
            style: {
                pointerEvents: "none"
            }
        })
    });
}, $1f8b88f2b81b0f2b$export$2a536501e4a376d8 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("rect", {
        x: i,
        y: n,
        fill: r,
        opacity: a,
        strokeWidth: s,
        stroke: void 0 === d ? "transparent" : d,
        width: o,
        height: o,
        style: {
            pointerEvents: "none"
        }
    });
}, $1f8b88f2b81b0f2b$export$57cb77afe634ca82 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, s = void 0 === c ? 0 : c, d = e.borderColor;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
            fill: r,
            opacity: a,
            strokeWidth: s,
            stroke: void 0 === d ? "transparent" : d,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
function $1f8b88f2b81b0f2b$var$p() {
    return $1f8b88f2b81b0f2b$var$p = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $1f8b88f2b81b0f2b$var$p.apply(this, arguments);
}
var $1f8b88f2b81b0f2b$export$7dcc0eed76218746 = {
    length: 200,
    thickness: 16,
    direction: "row",
    tickPosition: "after",
    tickSize: 4,
    tickSpacing: 3,
    tickOverlap: !1,
    tickFormat: function(t) {
        return "" + t;
    },
    titleAlign: "start",
    titleOffset: 4
}, $1f8b88f2b81b0f2b$var$b = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $1f8b88f2b81b0f2b$export$158851e184613239 = function(t) {
    var e, i = t.direction, n = t.itemsSpacing, o = t.padding, r = t.itemCount, l = t.itemWidth, a = t.itemHeight;
    if ("number" != typeof o && ("object" != typeof (e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
    } : $1f8b88f2b81b0f2b$var$p({}, $1f8b88f2b81b0f2b$var$b, o), s = c.left + c.right, d = c.top + c.bottom, h = l + s, g = a + d, m = (r - 1) * n;
    return "row" === i ? h = l * r + m + s : "column" === i && (g = a * r + m + d), {
        width: h,
        height: g,
        padding: c
    };
}, $1f8b88f2b81b0f2b$export$d54b250266589d82 = function(t) {
    var e = t.anchor, i = t.translateX, n = t.translateY, o = t.containerWidth, r = t.containerHeight, l = t.width, a = t.height, c = i, s = n;
    switch(e){
        case "top":
            c += (o - l) / 2;
            break;
        case "top-right":
            c += o - l;
            break;
        case "right":
            c += o - l, s += (r - a) / 2;
            break;
        case "bottom-right":
            c += o - l, s += r - a;
            break;
        case "bottom":
            c += (o - l) / 2, s += r - a;
            break;
        case "bottom-left":
            s += r - a;
            break;
        case "left":
            s += (r - a) / 2;
            break;
        case "center":
            c += (o - l) / 2, s += (r - a) / 2;
    }
    return {
        x: c,
        y: s
    };
}, $1f8b88f2b81b0f2b$export$42c02dc685323e86 = function(t) {
    var e, i, n, o, r, l, a = t.direction, c = t.justify, s = t.symbolSize, d = t.symbolSpacing, h = t.width, g = t.height;
    switch(a){
        case "left-to-right":
            e = 0, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = s + d, r = "start");
            break;
        case "right-to-left":
            e = h - s, i = (g - s) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - s - d, r = "end");
            break;
        case "top-to-bottom":
            e = (h - s) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = s + d, l = "text-before-edge");
            break;
        case "bottom-to-top":
            e = (h - s) / 2, i = g - s, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - s - d, l = "alphabetic");
    }
    return {
        symbolX: e,
        symbolY: i,
        labelX: n,
        labelY: o,
        labelAnchor: r,
        labelAlignment: l
    };
}, $1f8b88f2b81b0f2b$export$92bd5bd2fa4d30f9 = function(t) {
    var e, o = t.scale, r = t.ticks, a = t.length, c = void 0 === a ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.length : a, s = t.thickness, d = void 0 === s ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.thickness : s, h = t.direction, g = void 0 === h ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.direction : h, m = t.tickPosition, f = void 0 === m ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickPosition : m, u = t.tickSize, v = void 0 === u ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickSize : u, p = t.tickSpacing, b = void 0 === p ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickSpacing : p, k = t.tickOverlap, x = void 0 === k ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickOverlap : k, S = t.tickFormat, A = void 0 === S ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickFormat : S, W = t.title, z = t.titleAlign, C = void 0 === z ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.titleAlign : z, O = t.titleOffset, B = void 0 === O ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.titleOffset : O, w = "column" === g ? [].concat(o.domain()).reverse() : o.domain(), X = (0, $43657edf9f9313df$export$2e2bcd8739ae039)().domain(w);
    2 === w.length ? X.range([
        0,
        c
    ]) : 3 === w.length && X.range([
        0,
        c / 2,
        c
    ]), e = "thresholds" in o ? [
        w[0]
    ].concat(o.thresholds(), [
        w[1]
    ]) : Array.isArray(r) ? r : o.ticks(r);
    var Y, H, E, j, T, L, M = (0, $18aed9a2ed048594$export$f6ca0f82846310a7)(o, 32), F = (0, $0332e848e6fa2251$export$f037bf6aad5a4e75)(A), P = [], R = 0, q = 0;
    if ("row" === g) {
        var V, D, G;
        Y = c, H = d, q = 1;
        var I;
        T = 0, E = "start" === C ? 0 : "middle" === C ? c / 2 : c, "before" === f ? (V = -v, D = x ? d : 0, G = -v - b, I = "alphabetic", j = d + B, L = "hanging") : (V = x ? 0 : d, G = (D = d + v) + b, I = "hanging", j = -B, L = "alphabetic"), e.forEach(function(t) {
            var e = X(t);
            P.push({
                x1: e,
                y1: V,
                x2: e,
                y2: D,
                text: F(t),
                textX: e,
                textY: G,
                textHorizontalAlign: "middle",
                textVerticalAlign: I
            });
        });
    } else {
        var N, _, J, K;
        Y = d, H = c, R = 1;
        T = -90, j = "start" === C ? c : "middle" === C ? c / 2 : 0, "before" === f ? (_ = x ? d : 0, J = (N = -v) - b, K = "end", E = d + B, L = "hanging") : (N = x ? 0 : d, J = (_ = d + v) + b, K = "start", E = -B, L = "alphabetic"), e.forEach(function(t) {
            var e = X(t);
            P.push({
                x1: N,
                y1: e,
                x2: _,
                y2: e,
                text: F(t),
                textX: J,
                textY: e,
                textHorizontalAlign: K,
                textVerticalAlign: "central"
            });
        });
    }
    return {
        width: Y,
        height: H,
        gradientX1: 0,
        gradientY1: R,
        gradientX2: q,
        gradientY2: 0,
        colorStops: M,
        ticks: P,
        titleText: W,
        titleX: E,
        titleY: j,
        titleRotation: T,
        titleHorizontalAlign: C,
        titleVerticalAlign: L
    };
}, $1f8b88f2b81b0f2b$export$75a7f8b459abeba9 = function(i) {
    var n = i.scale, r = i.ticks, l = i.length, a = void 0 === l ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.length : l, s = i.thickness, d = void 0 === s ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.thickness : s, h = i.direction, g = void 0 === h ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.direction : h, m = i.tickPosition, f = void 0 === m ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickPosition : m, u = i.tickSize, v = void 0 === u ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickSize : u, b = i.tickSpacing, k = void 0 === b ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickSpacing : b, x = i.tickOverlap, S = void 0 === x ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickOverlap : x, W = i.tickFormat, z = void 0 === W ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickFormat : W, C = i.title, O = i.titleAlign, B = void 0 === O ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.titleAlign : O, w = i.titleOffset, X = $1f8b88f2b81b0f2b$export$92bd5bd2fa4d30f9({
        scale: n,
        ticks: r,
        length: a,
        thickness: d,
        direction: g,
        tickPosition: f,
        tickSize: v,
        tickSpacing: k,
        tickOverlap: S,
        tickFormat: z,
        title: C,
        titleAlign: B,
        titleOffset: void 0 === w ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.titleOffset : w
    }), Y = X.width, H = X.height, E = X.gradientX1, j = X.gradientY1, T = X.gradientX2, L = X.gradientY2, M = X.ticks, F = X.colorStops, P = X.titleText, R = X.titleX, q = X.titleY, V = X.titleRotation, D = X.titleVerticalAlign, G = X.titleHorizontalAlign, I = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), N = "ContinuousColorsLegendSvgGradient." + g + "." + F.map(function(t) {
        return t.offset;
    }).join("_");
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        children: [
            (0, $824c049f32d4395d$exports.jsx)("defs", {
                children: (0, $824c049f32d4395d$exports.jsx)("linearGradient", {
                    id: N,
                    x1: E,
                    y1: j,
                    x2: T,
                    y2: L,
                    children: F.map(function(e) {
                        return (0, $824c049f32d4395d$exports.jsx)("stop", $1f8b88f2b81b0f2b$var$p({}, e));
                    })
                })
            }),
            P && (0, $824c049f32d4395d$exports.jsx)("text", {
                transform: "translate(" + R + ", " + q + ") rotate(" + V + ")",
                textAnchor: G,
                dominantBaseline: D,
                style: I.legends.title.text,
                children: P
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: Y,
                height: H,
                fill: "url(#" + N
            }),
            M.map(function(i, n) {
                return (0, $824c049f32d4395d$exports.jsxs)((0, $7fPBF.Fragment), {
                    children: [
                        (0, $824c049f32d4395d$exports.jsx)("line", {
                            x1: i.x1,
                            y1: i.y1,
                            x2: i.x2,
                            y2: i.y2,
                            style: I.legends.ticks.line
                        }),
                        (0, $824c049f32d4395d$exports.jsx)("text", {
                            x: i.textX,
                            y: i.textY,
                            textAnchor: i.textHorizontalAlign,
                            dominantBaseline: i.textVerticalAlign,
                            style: I.legends.ticks.text,
                            children: i.text
                        })
                    ]
                }, n);
            })
        ]
    });
}, $1f8b88f2b81b0f2b$var$z = [
    "containerWidth",
    "containerHeight",
    "anchor",
    "translateX",
    "translateY",
    "length",
    "thickness",
    "direction"
], $1f8b88f2b81b0f2b$export$b3a69bafe074dddd = function(e) {
    var i, n, o = e.containerWidth, r = e.containerHeight, l = e.anchor, a = e.translateX, c = void 0 === a ? 0 : a, s = e.translateY, d = void 0 === s ? 0 : s, h = e.length, g = void 0 === h ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.length : h, m = e.thickness, f = void 0 === m ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.thickness : m, u = e.direction, v = void 0 === u ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.direction : u, b = function(t, e) {
        if (null == t) return {};
        var i, n, o = {}, r = Object.keys(t);
        for(n = 0; n < r.length; n++)i = r[n], e.indexOf(i) >= 0 || (o[i] = t[i]);
        return o;
    }(e, $1f8b88f2b81b0f2b$var$z);
    "row" === v ? (i = g, n = f) : (i = f, n = g);
    var k = $1f8b88f2b81b0f2b$export$d54b250266589d82({
        anchor: l,
        translateX: c,
        translateY: d,
        containerWidth: o,
        containerHeight: r,
        width: i,
        height: n
    }), S = k.x, A = k.y;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + S + ", " + A + ")",
        children: (0, $824c049f32d4395d$exports.jsx)($1f8b88f2b81b0f2b$export$75a7f8b459abeba9, $1f8b88f2b81b0f2b$var$p({
            length: g,
            thickness: f,
            direction: v
        }, b))
    });
}, $1f8b88f2b81b0f2b$var$O = {
    circle: $1f8b88f2b81b0f2b$export$15925baccc9f07fd,
    diamond: $1f8b88f2b81b0f2b$export$b7efc3c73c701547,
    square: $1f8b88f2b81b0f2b$export$2a536501e4a376d8,
    triangle: $1f8b88f2b81b0f2b$export$57cb77afe634ca82
}, $1f8b88f2b81b0f2b$export$cfc3a318dc419256 = function(i) {
    var n, r, l, c, h, g, m, f, u, v, y, b = i.x, k = i.y, x = i.width, A = i.height, W = i.data, z = i.direction, C = void 0 === z ? "left-to-right" : z, B = i.justify, w = void 0 !== B && B, X = i.textColor, Y = i.background, H = void 0 === Y ? "transparent" : Y, E = i.opacity, j = void 0 === E ? 1 : E, T = i.symbolShape, L = void 0 === T ? "square" : T, M = i.symbolSize, F = void 0 === M ? 16 : M, P = i.symbolSpacing, R = void 0 === P ? 8 : P, q = i.symbolBorderWidth, V = void 0 === q ? 0 : q, D = i.symbolBorderColor, G = void 0 === D ? "transparent" : D, I = i.onClick, N = i.onMouseEnter, _ = i.onMouseLeave, J = i.toggleSerie, K = i.effects, Q = (0, $7fPBF.useState)({}), U = Q[0], Z = Q[1], $ = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), tt = (0, $7fPBF.useCallback)(function(t) {
        if (K) {
            var e = K.filter(function(t) {
                return "hover" === t.on;
            }).reduce(function(t, e) {
                return $1f8b88f2b81b0f2b$var$p({}, t, e.style);
            }, {});
            Z(e);
        }
        null == N || N(W, t);
    }, [
        N,
        W,
        K
    ]), et = (0, $7fPBF.useCallback)(function(t) {
        if (K) {
            var e = K.filter(function(t) {
                return "hover" !== t.on;
            }).reduce(function(t, e) {
                return $1f8b88f2b81b0f2b$var$p({}, t, e.style);
            }, {});
            Z(e);
        }
        null == _ || _(W, t);
    }, [
        _,
        W,
        K
    ]), it = $1f8b88f2b81b0f2b$export$42c02dc685323e86({
        direction: C,
        justify: w,
        symbolSize: null != (n = U.symbolSize) ? n : F,
        symbolSpacing: R,
        width: x,
        height: A
    }), nt = it.symbolX, ot = it.symbolY, rt = it.labelX, lt = it.labelY, at = it.labelAnchor, ct = it.labelAlignment, st = [
        I,
        N,
        _,
        J
    ].some(function(t) {
        return void 0 !== t;
    }), dt = "function" == typeof L ? L : $1f8b88f2b81b0f2b$var$O[L];
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        transform: "translate(" + b + "," + k + ")",
        style: {
            opacity: null != (r = U.itemOpacity) ? r : j
        },
        children: [
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: x,
                height: A,
                fill: null != (l = U.itemBackground) ? l : H,
                style: {
                    cursor: st ? "pointer" : "auto"
                },
                onClick: function(t) {
                    null == I || I(W, t), null == J || J(W.id);
                },
                onMouseEnter: tt,
                onMouseLeave: et
            }),
            $7fPBF.createElement(dt, $1f8b88f2b81b0f2b$var$p({
                id: W.id,
                x: nt,
                y: ot,
                size: null != (c = U.symbolSize) ? c : F,
                fill: null != (h = null != (g = W.fill) ? g : W.color) ? h : "black",
                borderWidth: null != (m = U.symbolBorderWidth) ? m : V,
                borderColor: null != (f = U.symbolBorderColor) ? f : G
            }, W.hidden ? $.legends.hidden.symbol : void 0)),
            (0, $824c049f32d4395d$exports.jsx)("text", {
                textAnchor: at,
                style: $1f8b88f2b81b0f2b$var$p({}, $.legends.text, {
                    fill: null != (u = null != (v = null != (y = U.itemTextColor) ? y : X) ? v : $.legends.text.fill) ? u : "black",
                    dominantBaseline: ct,
                    pointerEvents: "none",
                    userSelect: "none"
                }, W.hidden ? $.legends.hidden.text : void 0),
                x: rt,
                y: lt,
                children: W.label
            })
        ]
    });
}, $1f8b88f2b81b0f2b$export$31ce35324c7aa71 = function(e) {
    var i = e.data, n = e.x, o = e.y, r = e.direction, l = e.padding, a = void 0 === l ? 0 : l, c = e.justify, s = e.effects, d = e.itemWidth, h = e.itemHeight, g = e.itemDirection, m = void 0 === g ? "left-to-right" : g, f = e.itemsSpacing, u = void 0 === f ? 0 : f, v = e.itemTextColor, p = e.itemBackground, y = void 0 === p ? "transparent" : p, b = e.itemOpacity, x = void 0 === b ? 1 : b, S = e.symbolShape, A = e.symbolSize, W = e.symbolSpacing, z = e.symbolBorderWidth, C = e.symbolBorderColor, O = e.onClick, w = e.onMouseEnter, X = e.onMouseLeave, Y = e.toggleSerie, H = $1f8b88f2b81b0f2b$export$158851e184613239({
        itemCount: i.length,
        itemWidth: d,
        itemHeight: h,
        itemsSpacing: u,
        direction: r,
        padding: a
    }).padding, E = "row" === r ? d + u : 0, j = "column" === r ? h + u : 0;
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        transform: "translate(" + n + "," + o + ")",
        children: i.map(function(e, i) {
            return (0, $824c049f32d4395d$exports.jsx)($1f8b88f2b81b0f2b$export$cfc3a318dc419256, {
                data: e,
                x: i * E + H.left,
                y: i * j + H.top,
                width: d,
                height: h,
                direction: m,
                justify: c,
                effects: s,
                textColor: v,
                background: y,
                opacity: x,
                symbolShape: S,
                symbolSize: A,
                symbolSpacing: W,
                symbolBorderWidth: z,
                symbolBorderColor: C,
                onClick: O,
                onMouseEnter: w,
                onMouseLeave: X,
                toggleSerie: Y
            }, i);
        })
    });
}, $1f8b88f2b81b0f2b$export$238a2f791d4948f7 = function(e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, s = e.anchor, d = e.direction, h = e.padding, g = void 0 === h ? 0 : h, m = e.justify, f = e.itemsSpacing, u = void 0 === f ? 0 : f, v = e.itemWidth, p = e.itemHeight, y = e.itemDirection, b = e.itemTextColor, S = e.itemBackground, A = e.itemOpacity, W = e.symbolShape, z = e.symbolSize, C = e.symbolSpacing, O = e.symbolBorderWidth, B = e.symbolBorderColor, X = e.onClick, Y = e.onMouseEnter, H = e.onMouseLeave, E = e.toggleSerie, j = e.effects, T = $1f8b88f2b81b0f2b$export$158851e184613239({
        itemCount: i.length,
        itemsSpacing: u,
        itemWidth: v,
        itemHeight: p,
        direction: d,
        padding: g
    }), L = T.width, M = T.height, F = $1f8b88f2b81b0f2b$export$d54b250266589d82({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: L,
        height: M
    }), P = F.x, R = F.y;
    return (0, $824c049f32d4395d$exports.jsx)($1f8b88f2b81b0f2b$export$31ce35324c7aa71, {
        data: i,
        x: P,
        y: R,
        direction: d,
        padding: g,
        justify: m,
        effects: j,
        itemsSpacing: u,
        itemWidth: v,
        itemHeight: p,
        itemDirection: y,
        itemTextColor: b,
        itemBackground: S,
        itemOpacity: A,
        symbolShape: W,
        symbolSize: z,
        symbolSpacing: C,
        symbolBorderWidth: O,
        symbolBorderColor: B,
        onClick: X,
        onMouseEnter: Y,
        onMouseLeave: H,
        toggleSerie: "boolean" == typeof E ? void 0 : E
    });
}, $1f8b88f2b81b0f2b$var$Y = {
    start: "left",
    middle: "center",
    end: "right"
}, $1f8b88f2b81b0f2b$export$28c0156604402604 = function(t, e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, s = e.anchor, d = e.direction, h = e.padding, g = void 0 === h ? 0 : h, m = e.justify, f = void 0 !== m && m, u = e.itemsSpacing, v = void 0 === u ? 0 : u, p = e.itemWidth, y = e.itemHeight, b = e.itemDirection, A = void 0 === b ? "left-to-right" : b, W = e.itemTextColor, z = e.symbolSize, C = void 0 === z ? 16 : z, O = e.symbolSpacing, B = void 0 === O ? 8 : O, w = e.theme, X = $1f8b88f2b81b0f2b$export$158851e184613239({
        itemCount: i.length,
        itemWidth: p,
        itemHeight: y,
        itemsSpacing: v,
        direction: d,
        padding: g
    }), H = X.width, E = X.height, j = X.padding, T = $1f8b88f2b81b0f2b$export$d54b250266589d82({
        anchor: s,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: H,
        height: E
    }), L = T.x, M = T.y, F = "row" === d ? p + v : 0, P = "column" === d ? y + v : 0;
    t.save(), t.translate(L, M), t.font = w.legends.text.fontSize + "px " + (w.legends.text.fontFamily || "sans-serif"), i.forEach(function(e, i) {
        var n, o, r = i * F + j.left, l = i * P + j.top, a = $1f8b88f2b81b0f2b$export$42c02dc685323e86({
            direction: A,
            justify: f,
            symbolSize: C,
            symbolSpacing: B,
            width: p,
            height: y
        }), c = a.symbolX, s = a.symbolY, d = a.labelX, h = a.labelY, g = a.labelAnchor, m = a.labelAlignment;
        t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(r + c, l + s, C, C), t.textAlign = $1f8b88f2b81b0f2b$var$Y[g], "central" === m && (t.textBaseline = "middle"), t.fillStyle = null != (o = null != W ? W : w.legends.text.fill) ? o : "black", t.fillText(String(e.label), r + d, l + h);
    }), t.restore();
}, $1f8b88f2b81b0f2b$export$d0f8bf7e3d86bbb5 = function(t, e) {
    var i = e.containerWidth, n = e.containerHeight, o = e.anchor, l = e.translateX, a = void 0 === l ? 0 : l, c = e.translateY, s = void 0 === c ? 0 : c, d = e.scale, h = e.length, g = void 0 === h ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.length : h, m = e.thickness, f = void 0 === m ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.thickness : m, u = e.direction, v = void 0 === u ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.direction : u, p = e.ticks, b = e.tickPosition, k = void 0 === b ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickPosition : b, S = e.tickSize, W = void 0 === S ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickSize : S, z = e.tickSpacing, C = void 0 === z ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickSpacing : z, O = e.tickOverlap, B = void 0 === O ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickOverlap : O, w = e.tickFormat, X = void 0 === w ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.tickFormat : w, Y = e.title, H = e.titleAlign, E = void 0 === H ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.titleAlign : H, j = e.titleOffset, T = void 0 === j ? $1f8b88f2b81b0f2b$export$7dcc0eed76218746.titleOffset : j, L = e.theme, M = $1f8b88f2b81b0f2b$export$92bd5bd2fa4d30f9({
        scale: d,
        ticks: p,
        length: g,
        thickness: f,
        direction: v,
        tickPosition: k,
        tickSize: W,
        tickSpacing: C,
        tickOverlap: B,
        tickFormat: X,
        title: Y,
        titleAlign: E,
        titleOffset: T
    }), F = M.width, P = M.height, R = M.gradientX1, q = M.gradientY1, V = M.gradientX2, D = M.gradientY2, G = M.colorStops, I = M.ticks, N = M.titleText, _ = M.titleX, J = M.titleY, K = M.titleRotation, Q = M.titleVerticalAlign, U = M.titleHorizontalAlign, Z = $1f8b88f2b81b0f2b$export$d54b250266589d82({
        anchor: o,
        translateX: a,
        translateY: s,
        containerWidth: i,
        containerHeight: n,
        width: F,
        height: P
    }), $ = Z.x, tt = Z.y, et = {
        font: t.font,
        textAlign: t.textAlign,
        textBaseline: t.textBaseline
    };
    t.save(), t.translate($, tt);
    var it = t.createLinearGradient(R * F, q * P, V * F, D * P);
    G.forEach(function(t) {
        it.addColorStop(t.offset, t.stopColor);
    }), t.fillStyle = it, t.fillRect(0, 0, F, P), t.font = (L.legends.ticks.text.fontWeight ? L.legends.ticks.text.fontWeight + " " : "") + L.legends.ticks.text.fontSize + "px " + L.legends.ticks.text.fontFamily, I.forEach(function(e) {
        var i;
        (null != (i = L.legends.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(L.axis.ticks.line.strokeWidth), L.axis.ticks.line.stroke && (t.strokeStyle = L.axis.ticks.line.stroke), t.lineCap = "square", t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke()), L.legends.ticks.text.fill && (t.fillStyle = L.legends.ticks.text.fill), t.textAlign = "middle" === e.textHorizontalAlign ? "center" : e.textHorizontalAlign, t.textBaseline = "central" === e.textVerticalAlign ? "middle" : e.textVerticalAlign, t.fillText(e.text, e.textX, e.textY);
    }), N && (t.save(), t.translate(_, J), t.rotate((0, $0332e848e6fa2251$export$c9fcf1a7df975d78)(K)), t.font = (L.legends.title.text.fontWeight ? L.legends.title.text.fontWeight + " " : "") + L.legends.title.text.fontSize + "px " + L.legends.title.text.fontFamily, L.legends.title.text.fill && (t.fillStyle = L.legends.title.text.fill), t.textAlign = "middle" === U ? "center" : U, t.textBaseline = Q, t.fillText(N, 0, 0), t.restore()), t.restore(), t.font = et.font, t.textAlign = et.textAlign, t.textBaseline = et.textBaseline;
}, $1f8b88f2b81b0f2b$export$419bf2ab46804c4 = function(t) {
    var e = t.scale, i = t.domain, n = t.reverse, o = void 0 !== n && n, r = t.valueFormat, l = void 0 === r ? function(t) {
        return t;
    } : r, a = t.separator, c = void 0 === a ? " - " : a;
    return (0, $7fPBF.useMemo)(function() {
        var t = (null != i ? i : e.range()).map(function(t, i) {
            var n = e.invertExtent(t), o = n[0], r = n[1];
            return {
                id: t,
                index: i,
                extent: [
                    o,
                    r
                ],
                label: "" + l(o) + c + l(r),
                value: e(o),
                color: t
            };
        });
        return o && t.reverse(), t;
    }, [
        i,
        e,
        o,
        c,
        l
    ]);
}, $1f8b88f2b81b0f2b$export$b3fa7ef443b640af = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    anchor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left",
        "top-left",
        "center"
    ]).isRequired,
    translateX: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    translateY: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "row",
        "column"
    ]).isRequired,
    itemsSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    itemWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    itemHeight: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    itemDirection: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "left-to-right",
        "right-to-left",
        "top-to-bottom",
        "bottom-to-top"
    ]),
    itemTextColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    itemBackground: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    itemOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    symbolShape: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "circle",
            "diamond",
            "square",
            "triangle"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    ]),
    symbolSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    symbolSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    symbolBorderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    symbolBorderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    effects: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        on: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                "hover"
            ])
        ]).isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            itemTextColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            itemBackground: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            itemOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            symbolSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            symbolBorderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            symbolBorderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
        }).isRequired
    }))
};


function $7302bb3757b15265$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $488ed723870b7c3f$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $488ed723870b7c3f$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $488ed723870b7c3f$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $7302bb3757b15265$export$2e2bcd8739ae039)(f(d), x);
    };
}


var $e0472f61b1652854$var$ascendingBisect = (0, $488ed723870b7c3f$export$2e2bcd8739ae039)((0, $7302bb3757b15265$export$2e2bcd8739ae039));
var $e0472f61b1652854$export$4d945ad3ad5751b0 = $e0472f61b1652854$var$ascendingBisect.right;
var $e0472f61b1652854$export$df7d25c84ebd12a5 = $e0472f61b1652854$var$ascendingBisect.left;
var $e0472f61b1652854$export$2e2bcd8739ae039 = $e0472f61b1652854$export$4d945ad3ad5751b0;




function $691dd6aa4ff701ad$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $691dd6aa4ff701ad$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $691dd6aa4ff701ad$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}


function $052fdd65407ff746$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $691dd6aa4ff701ad$export$a04cb3fe8b81dd);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}


function $716368b81a4447a0$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $82e13214984e40be$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}


function $3c3027380ea03507$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $82e13214984e40be$export$2e2bcd8739ae039)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $82e13214984e40be$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}


function $cef8bfb00a4f63ac$export$2e2bcd8739ae039(array, f) {
    var v = (0, $3c3027380ea03507$export$2e2bcd8739ae039)(array, f);
    return v ? Math.sqrt(v) : v;
}


function $b6a0301b5dc11f1a$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


var $4801f10462714387$var$array = Array.prototype;
var $4801f10462714387$export$58adb3bec8346d0f = $4801f10462714387$var$array.slice;
var $4801f10462714387$export$871de8747c9eaa88 = $4801f10462714387$var$array.map;



function $e8e02166c36f4d5f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $9aa994c4ba1330da$export$2e2bcd8739ae039(x) {
    return x;
}


function $2a5b2a497bb81c38$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


var $afbfd99b7337a94f$var$e10 = Math.sqrt(50), $afbfd99b7337a94f$var$e5 = Math.sqrt(10), $afbfd99b7337a94f$var$e2 = Math.sqrt(2);
function $afbfd99b7337a94f$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $afbfd99b7337a94f$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $afbfd99b7337a94f$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $afbfd99b7337a94f$var$e10 ? 10 : error >= $afbfd99b7337a94f$var$e5 ? 5 : error >= $afbfd99b7337a94f$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $afbfd99b7337a94f$var$e10 ? 10 : error >= $afbfd99b7337a94f$var$e5 ? 5 : error >= $afbfd99b7337a94f$var$e2 ? 2 : 1);
}
function $afbfd99b7337a94f$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $afbfd99b7337a94f$var$e10) step1 *= 10;
    else if (error >= $afbfd99b7337a94f$var$e5) step1 *= 5;
    else if (error >= $afbfd99b7337a94f$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $873ebcd916f738bb$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}


function $92c11d1a920e6efb$export$2e2bcd8739ae039() {
    var value = (0, $9aa994c4ba1330da$export$2e2bcd8739ae039), domain = (0, $b6a0301b5dc11f1a$export$2e2bcd8739ae039), threshold = (0, $873ebcd916f738bb$export$2e2bcd8739ae039);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $afbfd99b7337a94f$export$81087d9b915d4ede)(x0, x1, tz);
            tz = (0, $2a5b2a497bb81c38$export$2e2bcd8739ae039)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $e0472f61b1652854$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $e8e02166c36f4d5f$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $e8e02166c36f4d5f$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $e8e02166c36f4d5f$export$2e2bcd8739ae039)((0, $4801f10462714387$export$58adb3bec8346d0f).call(_)) : (0, $e8e02166c36f4d5f$export$2e2bcd8739ae039)(_), histogram) : threshold;
    };
    return histogram;
}






function $a5a3835603290a26$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $82e13214984e40be$export$2e2bcd8739ae039);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}


function $f8e66b4a80e9b84f$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $4801f10462714387$export$871de8747c9eaa88).call(values, (0, $82e13214984e40be$export$2e2bcd8739ae039)).sort((0, $7302bb3757b15265$export$2e2bcd8739ae039));
    return Math.ceil((max - min) / (2 * ((0, $a5a3835603290a26$export$2e2bcd8739ae039)(values, 0.75) - (0, $a5a3835603290a26$export$2e2bcd8739ae039)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}



function $171ef84ec635256f$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $cef8bfb00a4f63ac$export$2e2bcd8739ae039)(values) * Math.pow(values.length, -1 / 3)));
}



function $2f09d1b0f641028b$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}



function $d6fa244014dcb37c$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $82e13214984e40be$export$2e2bcd8739ae039)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $82e13214984e40be$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}





function $776a8ea7231353bc$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $82e13214984e40be$export$2e2bcd8739ae039)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $82e13214984e40be$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $a5a3835603290a26$export$2e2bcd8739ae039)(numbers.sort((0, $7302bb3757b15265$export$2e2bcd8739ae039)), 0.5);
}


function $e803462a2ac8653e$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}


function $81f3e6b45be7dc56$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}



function $f2b903adedbd9f90$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}





function $7ab0805bbb802493$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $7302bb3757b15265$export$2e2bcd8739ae039);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}


function $8d057a9c41078ae2$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}


function $e7f5f23c60a7f22e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}




function $4aefacb3227e73fb$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $81f3e6b45be7dc56$export$2e2bcd8739ae039)(matrix, $4aefacb3227e73fb$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $4aefacb3227e73fb$var$length(d) {
    return d.length;
}




function $77ca8cd8b6f1602d$export$2e2bcd8739ae039() {
    return (0, $4aefacb3227e73fb$export$2e2bcd8739ae039)(arguments);
}





function $5d2eade1f97cfa5b$var$targetDepth(d) {
    return d.target.depth;
}
function $5d2eade1f97cfa5b$export$eabcd2c8791e7bf4(node) {
    return node.depth;
}
function $5d2eade1f97cfa5b$export$79ffe56a765070d2(node, n) {
    return n - 1 - node.height;
}
function $5d2eade1f97cfa5b$export$720f2a50325b840f(node, n) {
    return node.sourceLinks.length ? node.depth : n - 1;
}
function $5d2eade1f97cfa5b$export$3481c78889e8fbe8(node) {
    return node.targetLinks.length ? node.depth : node.sourceLinks.length ? (0, $81f3e6b45be7dc56$export$2e2bcd8739ae039)(node.sourceLinks, $5d2eade1f97cfa5b$var$targetDepth) - 1 : 0;
}


function $666a99ef181dd8fe$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $df869ed9cb68dd35$var$ascendingSourceBreadth(a, b) {
    return $df869ed9cb68dd35$var$ascendingBreadth(a.source, b.source) || a.index - b.index;
}
function $df869ed9cb68dd35$var$ascendingTargetBreadth(a, b) {
    return $df869ed9cb68dd35$var$ascendingBreadth(a.target, b.target) || a.index - b.index;
}
function $df869ed9cb68dd35$var$ascendingBreadth(a, b) {
    return a.y0 - b.y0;
}
function $df869ed9cb68dd35$var$value(d) {
    return d.value;
}
function $df869ed9cb68dd35$var$defaultId(d) {
    return d.index;
}
function $df869ed9cb68dd35$var$defaultNodes(graph) {
    return graph.nodes;
}
function $df869ed9cb68dd35$var$defaultLinks(graph) {
    return graph.links;
}
function $df869ed9cb68dd35$var$find(nodeById, id) {
    const node = nodeById.get(id);
    if (!node) throw new Error("missing: " + id);
    return node;
}
function $df869ed9cb68dd35$var$computeLinkBreadths({ nodes: nodes }) {
    for (const node of nodes){
        let y0 = node.y0;
        let y1 = y0;
        for (const link of node.sourceLinks){
            link.y0 = y0 + link.width / 2;
            y0 += link.width;
        }
        for (const link of node.targetLinks){
            link.y1 = y1 + link.width / 2;
            y1 += link.width;
        }
    }
}
function $df869ed9cb68dd35$export$2e2bcd8739ae039() {
    let x0 = 0, y0 = 0, x1 = 1, y1 = 1; // extent
    let dx = 24; // nodeWidth
    let dy = 8, py; // nodePadding
    let id = $df869ed9cb68dd35$var$defaultId;
    let align = (0, $5d2eade1f97cfa5b$export$720f2a50325b840f);
    let sort;
    let linkSort;
    let nodes = $df869ed9cb68dd35$var$defaultNodes;
    let links = $df869ed9cb68dd35$var$defaultLinks;
    let iterations = 6;
    function sankey() {
        const graph = {
            nodes: nodes.apply(null, arguments),
            links: links.apply(null, arguments)
        };
        computeNodeLinks(graph);
        computeNodeValues(graph);
        computeNodeDepths(graph);
        computeNodeHeights(graph);
        computeNodeBreadths(graph);
        $df869ed9cb68dd35$var$computeLinkBreadths(graph);
        return graph;
    }
    sankey.update = function(graph) {
        $df869ed9cb68dd35$var$computeLinkBreadths(graph);
        return graph;
    };
    sankey.nodeId = function(_) {
        return arguments.length ? (id = typeof _ === "function" ? _ : (0, $666a99ef181dd8fe$export$2e2bcd8739ae039)(_), sankey) : id;
    };
    sankey.nodeAlign = function(_) {
        return arguments.length ? (align = typeof _ === "function" ? _ : (0, $666a99ef181dd8fe$export$2e2bcd8739ae039)(_), sankey) : align;
    };
    sankey.nodeSort = function(_) {
        return arguments.length ? (sort = _, sankey) : sort;
    };
    sankey.nodeWidth = function(_) {
        return arguments.length ? (dx = +_, sankey) : dx;
    };
    sankey.nodePadding = function(_) {
        return arguments.length ? (dy = py = +_, sankey) : dy;
    };
    sankey.nodes = function(_) {
        return arguments.length ? (nodes = typeof _ === "function" ? _ : (0, $666a99ef181dd8fe$export$2e2bcd8739ae039)(_), sankey) : nodes;
    };
    sankey.links = function(_) {
        return arguments.length ? (links = typeof _ === "function" ? _ : (0, $666a99ef181dd8fe$export$2e2bcd8739ae039)(_), sankey) : links;
    };
    sankey.linkSort = function(_) {
        return arguments.length ? (linkSort = _, sankey) : linkSort;
    };
    sankey.size = function(_) {
        return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [
            x1 - x0,
            y1 - y0
        ];
    };
    sankey.extent = function(_) {
        return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    sankey.iterations = function(_) {
        return arguments.length ? (iterations = +_, sankey) : iterations;
    };
    function computeNodeLinks({ nodes: nodes, links: links }) {
        for (const [i, node] of nodes.entries()){
            node.index = i;
            node.sourceLinks = [];
            node.targetLinks = [];
        }
        const nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ]));
        for (const [i, link] of links.entries()){
            link.index = i;
            let { source: source, target: target } = link;
            if (typeof source !== "object") source = link.source = $df869ed9cb68dd35$var$find(nodeById, source);
            if (typeof target !== "object") target = link.target = $df869ed9cb68dd35$var$find(nodeById, target);
            source.sourceLinks.push(link);
            target.targetLinks.push(link);
        }
        if (linkSort != null) for (const { sourceLinks: sourceLinks, targetLinks: targetLinks } of nodes){
            sourceLinks.sort(linkSort);
            targetLinks.sort(linkSort);
        }
    }
    function computeNodeValues({ nodes: nodes }) {
        for (const node of nodes)node.value = node.fixedValue === undefined ? Math.max((0, $e7f5f23c60a7f22e$export$2e2bcd8739ae039)(node.sourceLinks, $df869ed9cb68dd35$var$value), (0, $e7f5f23c60a7f22e$export$2e2bcd8739ae039)(node.targetLinks, $df869ed9cb68dd35$var$value)) : node.fixedValue;
    }
    function computeNodeDepths({ nodes: nodes }) {
        const n = nodes.length;
        let current = new Set(nodes);
        let next = new Set;
        let x = 0;
        while(current.size){
            for (const node of current){
                node.depth = x;
                for (const { target: target } of node.sourceLinks)next.add(target);
            }
            if (++x > n) throw new Error("circular link");
            current = next;
            next = new Set;
        }
    }
    function computeNodeHeights({ nodes: nodes }) {
        const n = nodes.length;
        let current = new Set(nodes);
        let next = new Set;
        let x = 0;
        while(current.size){
            for (const node of current){
                node.height = x;
                for (const { source: source } of node.targetLinks)next.add(source);
            }
            if (++x > n) throw new Error("circular link");
            current = next;
            next = new Set;
        }
    }
    function computeNodeLayers({ nodes: nodes }) {
        const x = (0, $2f09d1b0f641028b$export$2e2bcd8739ae039)(nodes, (d)=>d.depth) + 1;
        const kx = (x1 - x0 - dx) / (x - 1);
        const columns = new Array(x);
        for (const node of nodes){
            const i = Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x))));
            node.layer = i;
            node.x0 = x0 + i * kx;
            node.x1 = node.x0 + dx;
            if (columns[i]) columns[i].push(node);
            else columns[i] = [
                node
            ];
        }
        if (sort) for (const column of columns)column.sort(sort);
        return columns;
    }
    function initializeNodeBreadths(columns) {
        const ky = (0, $81f3e6b45be7dc56$export$2e2bcd8739ae039)(columns, (c)=>(y1 - y0 - (c.length - 1) * py) / (0, $e7f5f23c60a7f22e$export$2e2bcd8739ae039)(c, $df869ed9cb68dd35$var$value));
        for (const nodes of columns){
            let y = y0;
            for (const node of nodes){
                node.y0 = y;
                node.y1 = y + node.value * ky;
                y = node.y1 + py;
                for (const link of node.sourceLinks)link.width = link.value * ky;
            }
            y = (y1 - y + py) / (nodes.length + 1);
            for(let i = 0; i < nodes.length; ++i){
                const node = nodes[i];
                node.y0 += y * (i + 1);
                node.y1 += y * (i + 1);
            }
            reorderLinks(nodes);
        }
    }
    function computeNodeBreadths(graph) {
        const columns = computeNodeLayers(graph);
        py = Math.min(dy, (y1 - y0) / ((0, $2f09d1b0f641028b$export$2e2bcd8739ae039)(columns, (c)=>c.length) - 1));
        initializeNodeBreadths(columns);
        for(let i = 0; i < iterations; ++i){
            const alpha = Math.pow(0.99, i);
            const beta = Math.max(1 - alpha, (i + 1) / iterations);
            relaxRightToLeft(columns, alpha, beta);
            relaxLeftToRight(columns, alpha, beta);
        }
    }
    // Reposition each node based on its incoming (target) links.
    function relaxLeftToRight(columns, alpha, beta) {
        for(let i = 1, n = columns.length; i < n; ++i){
            const column = columns[i];
            for (const target of column){
                let y = 0;
                let w = 0;
                for (const { source: source, value: value } of target.targetLinks){
                    let v = value * (target.layer - source.layer);
                    y += targetTop(source, target) * v;
                    w += v;
                }
                if (!(w > 0)) continue;
                let dy = (y / w - target.y0) * alpha;
                target.y0 += dy;
                target.y1 += dy;
                reorderNodeLinks(target);
            }
            if (sort === undefined) column.sort($df869ed9cb68dd35$var$ascendingBreadth);
            resolveCollisions(column, beta);
        }
    }
    // Reposition each node based on its outgoing (source) links.
    function relaxRightToLeft(columns, alpha, beta) {
        for(let n = columns.length, i = n - 2; i >= 0; --i){
            const column = columns[i];
            for (const source of column){
                let y = 0;
                let w = 0;
                for (const { target: target, value: value } of source.sourceLinks){
                    let v = value * (target.layer - source.layer);
                    y += sourceTop(source, target) * v;
                    w += v;
                }
                if (!(w > 0)) continue;
                let dy = (y / w - source.y0) * alpha;
                source.y0 += dy;
                source.y1 += dy;
                reorderNodeLinks(source);
            }
            if (sort === undefined) column.sort($df869ed9cb68dd35$var$ascendingBreadth);
            resolveCollisions(column, beta);
        }
    }
    function resolveCollisions(nodes, alpha) {
        const i = nodes.length >> 1;
        const subject = nodes[i];
        resolveCollisionsBottomToTop(nodes, subject.y0 - py, i - 1, alpha);
        resolveCollisionsTopToBottom(nodes, subject.y1 + py, i + 1, alpha);
        resolveCollisionsBottomToTop(nodes, y1, nodes.length - 1, alpha);
        resolveCollisionsTopToBottom(nodes, y0, 0, alpha);
    }
    // Push any overlapping nodes down.
    function resolveCollisionsTopToBottom(nodes, y, i, alpha) {
        for(; i < nodes.length; ++i){
            const node = nodes[i];
            const dy = (y - node.y0) * alpha;
            if (dy > 1e-6) node.y0 += dy, node.y1 += dy;
            y = node.y1 + py;
        }
    }
    // Push any overlapping nodes up.
    function resolveCollisionsBottomToTop(nodes, y, i, alpha) {
        for(; i >= 0; --i){
            const node = nodes[i];
            const dy = (node.y1 - y) * alpha;
            if (dy > 1e-6) node.y0 -= dy, node.y1 -= dy;
            y = node.y0 - py;
        }
    }
    function reorderNodeLinks({ sourceLinks: sourceLinks, targetLinks: targetLinks }) {
        if (linkSort === undefined) {
            for (const { source: { sourceLinks: sourceLinks } } of targetLinks)sourceLinks.sort($df869ed9cb68dd35$var$ascendingTargetBreadth);
            for (const { target: { targetLinks: targetLinks } } of sourceLinks)targetLinks.sort($df869ed9cb68dd35$var$ascendingSourceBreadth);
        }
    }
    function reorderLinks(nodes) {
        if (linkSort === undefined) for (const { sourceLinks: sourceLinks, targetLinks: targetLinks } of nodes){
            sourceLinks.sort($df869ed9cb68dd35$var$ascendingTargetBreadth);
            targetLinks.sort($df869ed9cb68dd35$var$ascendingSourceBreadth);
        }
    }
    // Returns the target.y0 that would produce an ideal link from source to target.
    function targetTop(source, target) {
        let y = source.y0 - (source.sourceLinks.length - 1) * py / 2;
        for (const { target: node, width: width } of source.sourceLinks){
            if (node === target) break;
            y += width + py;
        }
        for (const { source: node, width: width } of target.targetLinks){
            if (node === source) break;
            y -= width;
        }
        return y;
    }
    // Returns the source.y0 that would produce an ideal link from source to target.
    function sourceTop(source, target) {
        let y = target.y0 - (target.targetLinks.length - 1) * py / 2;
        for (const { source: node, width: width } of target.targetLinks){
            if (node === source) break;
            y += width + py;
        }
        for (const { target: node, width: width } of source.sourceLinks){
            if (node === target) break;
            y -= width;
        }
        return y;
    }
    return sankey;
}




var $991095ca4c9fe7f1$export$58adb3bec8346d0f = Array.prototype.slice;




function $301753efe58e7866$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}


function $2c5b2f9591c399b8$var$linkSource(d) {
    return d.source;
}
function $2c5b2f9591c399b8$var$linkTarget(d) {
    return d.target;
}
function $2c5b2f9591c399b8$var$link(curve) {
    var source = $2c5b2f9591c399b8$var$linkSource, target = $2c5b2f9591c399b8$var$linkTarget, x = (0, $30204b10fe7aac69$export$d141bba7fdc215a3), y = (0, $30204b10fe7aac69$export$4a5767248b18ef41), context = null;
    function link() {
        var buffer, argv = (0, $991095ca4c9fe7f1$export$58adb3bec8346d0f).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $dd1da3dd953a1510$export$2e2bcd8739ae039)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $678454dfdfb67fe3$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $2c5b2f9591c399b8$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $2c5b2f9591c399b8$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $2c5b2f9591c399b8$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $301753efe58e7866$export$2e2bcd8739ae039)(x0, y0), p1 = (0, $301753efe58e7866$export$2e2bcd8739ae039)(x0, y0 = (y0 + y1) / 2), p2 = (0, $301753efe58e7866$export$2e2bcd8739ae039)(x1, y0), p3 = (0, $301753efe58e7866$export$2e2bcd8739ae039)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $2c5b2f9591c399b8$export$e7c381889b2cd14d() {
    return $2c5b2f9591c399b8$var$link($2c5b2f9591c399b8$var$curveHorizontal);
}
function $2c5b2f9591c399b8$export$75de4c8c66884e04() {
    return $2c5b2f9591c399b8$var$link($2c5b2f9591c399b8$var$curveVertical);
}
function $2c5b2f9591c399b8$export$7739cfe68d4e0799() {
    var l = $2c5b2f9591c399b8$var$link($2c5b2f9591c399b8$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}


function $fa2762feca1949ba$var$horizontalSource(d) {
    return [
        d.source.x1,
        d.y0
    ];
}
function $fa2762feca1949ba$var$horizontalTarget(d) {
    return [
        d.target.x0,
        d.y1
    ];
}
function $fa2762feca1949ba$export$2e2bcd8739ae039() {
    return (0, $2c5b2f9591c399b8$export$e7c381889b2cd14d)().source($fa2762feca1949ba$var$horizontalSource).target($fa2762feca1949ba$var$horizontalTarget);
}










function $c725e3fc4c01aa11$var$S() {
    return $c725e3fc4c01aa11$var$S = Object.assign || function(e) {
        for(var o = 1; o < arguments.length; o++){
            var n = arguments[o];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $c725e3fc4c01aa11$var$S.apply(this, arguments);
}
var $c725e3fc4c01aa11$var$z = {
    container: {
        display: "flex",
        alignItems: "center"
    },
    sourceChip: {
        marginRight: 7
    },
    targetChip: {
        marginLeft: 7,
        marginRight: 7
    }
}, $c725e3fc4c01aa11$export$6af1fe23b8e48218 = {
    center: (0, $5d2eade1f97cfa5b$export$3481c78889e8fbe8),
    justify: (0, $5d2eade1f97cfa5b$export$720f2a50325b840f),
    start: (0, $5d2eade1f97cfa5b$export$eabcd2c8791e7bf4),
    end: (0, $5d2eade1f97cfa5b$export$79ffe56a765070d2)
}, $c725e3fc4c01aa11$export$a9f195a48243f8a8 = Object.keys($c725e3fc4c01aa11$export$6af1fe23b8e48218), $c725e3fc4c01aa11$export$a1188bce6ce3564 = function(e) {
    return $c725e3fc4c01aa11$export$6af1fe23b8e48218[e];
}, $c725e3fc4c01aa11$export$82f4948cbf358702 = {
    layout: "horizontal",
    align: "center",
    sort: "auto",
    colors: {
        scheme: "nivo"
    },
    nodeOpacity: .75,
    nodeHoverOpacity: 1,
    nodeHoverOthersOpacity: .15,
    nodeThickness: 12,
    nodeSpacing: 12,
    nodeInnerPadding: 0,
    nodeBorderWidth: 1,
    nodeBorderColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                .5
            ]
        ]
    },
    nodeBorderRadius: 0,
    linkOpacity: .25,
    linkHoverOpacity: .6,
    linkHoverOthersOpacity: .15,
    linkContract: 0,
    linkBlendMode: "multiply",
    enableLinkGradient: !1,
    enableLabels: !0,
    label: "id",
    labelPosition: "inside",
    labelPadding: 9,
    labelOrientation: "horizontal",
    labelTextColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                .8
            ]
        ]
    },
    isInteractive: !0,
    nodeTooltip: function(e) {
        var o = e.node;
        return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d5f52d71198e271a), {
            id: o.label,
            enableChip: !0,
            color: o.color
        });
    },
    linkTooltip: function(e) {
        var o = e.link;
        return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d5f52d71198e271a), {
            id: (0, $824c049f32d4395d$exports.jsxs)("span", {
                style: $c725e3fc4c01aa11$var$z.container,
                children: [
                    (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$5a7f9a6004988d01), {
                        color: o.source.color,
                        style: $c725e3fc4c01aa11$var$z.sourceChip
                    }),
                    (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: o.source.label
                    }),
                    " > ",
                    (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: o.target.label
                    }),
                    (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$5a7f9a6004988d01), {
                        color: o.target.color,
                        style: $c725e3fc4c01aa11$var$z.targetChip
                    }),
                    (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: o.formattedValue
                    })
                ]
            })
        });
    },
    legends: [],
    layers: [
        "links",
        "nodes",
        "labels",
        "legends"
    ],
    role: "img",
    animate: !0,
    motionConfig: "gentle"
}, $c725e3fc4c01aa11$var$V = function(e) {
    return e.id;
}, $c725e3fc4c01aa11$var$A = function(e) {
    var t = e.data, i = e.valueFormat, r = e.layout, c = e.width, s = e.height, u = e.sort, h = e.align, v = e.colors, p = e.nodeThickness, g = e.nodeSpacing, f = e.nodeInnerPadding, y = e.nodeBorderColor, m = e.label, k = e.labelTextColor, C = (0, $7fPBF.useState)(null), x = C[0], O = C[1], L = (0, $7fPBF.useState)(null), M = L[0], T = L[1], H = (0, $7fPBF.useMemo)(function() {
        if ("auto" !== u) return "input" === u ? null : "ascending" === u ? function(e, o) {
            return e.value - o.value;
        } : "descending" === u ? function(e, o) {
            return o.value - e.value;
        } : u;
    }, [
        u
    ]), P = "input" === u ? null : void 0, W = (0, $7fPBF.useMemo)(function() {
        return "function" == typeof h ? h : $c725e3fc4c01aa11$export$a1188bce6ce3564(h);
    }, [
        h
    ]), N = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), F = (0, $18aed9a2ed048594$export$47939777be1516f5)(v, "id"), R = (0, $18aed9a2ed048594$export$2a9e363116151414)(y, N), S = (0, $0332e848e6fa2251$export$2d590546cbb7e3ad)(m), z = (0, $18aed9a2ed048594$export$2a9e363116151414)(k, N), E = (0, $0332e848e6fa2251$export$422f9765e6971fdf)(i), G = (0, $7fPBF.useMemo)(function() {
        return function(e) {
            var o = e.data, n = e.formatValue, t = e.layout, i = e.alignFunction, r = e.sortFunction, l = e.linkSortMode, a = e.nodeThickness, d = e.nodeSpacing, c = e.nodeInnerPadding, s = e.width, u = e.height, h = e.getColor, v = e.getLabel, p = (0, $df869ed9cb68dd35$export$2e2bcd8739ae039)().nodeAlign(i).nodeSort(r).linkSort(l).nodeWidth(a).nodePadding(d).size("horizontal" === t ? [
                s,
                u
            ] : [
                u,
                s
            ]).nodeId($c725e3fc4c01aa11$var$V), g = (0, (/*@__PURE__*/$parcel$interopDefault($60d3fa686d955280$exports)))(o);
            return p(g), g.nodes.forEach(function(e) {
                if (e.color = h(e), e.label = v(e), e.formattedValue = n(e.value), "horizontal" === t) e.x = e.x0 + c, e.y = e.y0, e.width = Math.max(e.x1 - e.x0 - 2 * c, 0), e.height = Math.max(e.y1 - e.y0, 0);
                else {
                    e.x = e.y0, e.y = e.x0 + c, e.width = Math.max(e.y1 - e.y0, 0), e.height = Math.max(e.x1 - e.x0 - 2 * c, 0);
                    var o = e.x0, i = e.x1;
                    e.x0 = e.y0, e.x1 = e.y1, e.y0 = o, e.y1 = i;
                }
            }), g.links.forEach(function(e) {
                e.formattedValue = n(e.value), e.color = e.source.color, e.pos0 = e.y0, e.pos1 = e.y1, e.thickness = e.width, delete e.y0, delete e.y1, delete e.width;
            }), g;
        }({
            data: t,
            formatValue: E,
            layout: r,
            alignFunction: W,
            sortFunction: H,
            linkSortMode: P,
            nodeThickness: p,
            nodeSpacing: g,
            nodeInnerPadding: f,
            width: c,
            height: s,
            getColor: F,
            getLabel: S
        });
    }, [
        t,
        E,
        r,
        W,
        H,
        P,
        p,
        g,
        f,
        c,
        s,
        F,
        S
    ]), D = G.nodes, A = G.links, Z = (0, $7fPBF.useMemo)(function() {
        return D.map(function(e) {
            return {
                id: e.id,
                label: e.label,
                color: e.color
            };
        });
    }, [
        D
    ]);
    return {
        nodes: D,
        links: A,
        legendData: Z,
        getNodeBorderColor: R,
        currentNode: x,
        setCurrentNode: O,
        currentLink: M,
        setCurrentLink: T,
        getLabelTextColor: z
    };
}, $c725e3fc4c01aa11$var$Z = function(e) {
    var o = e.node, n = e.x, r = e.y, l = e.width, a = e.height, d = e.color, s = e.opacity, u = e.borderWidth, h = e.borderColor, v = e.borderRadius, p = e.setCurrent, g = e.isInteractive, f = e.onClick, y = e.tooltip, m = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), k = m.animate, b = m.config, C = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        x: n,
        y: r,
        width: l,
        height: a,
        opacity: s,
        color: d,
        config: b,
        immediate: !k
    }), x = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), M = x.showTooltipFromEvent, T = x.hideTooltip, w = (0, $7fPBF.useCallback)(function(e) {
        p(o), M((0, $7fPBF.createElement)(y, {
            node: o
        }), e, "left");
    }, [
        p,
        o,
        M,
        y
    ]), B = (0, $7fPBF.useCallback)(function(e) {
        M((0, $7fPBF.createElement)(y, {
            node: o
        }), e, "left");
    }, [
        M,
        o,
        y
    ]), I = (0, $7fPBF.useCallback)(function() {
        p(null), T();
    }, [
        p,
        T
    ]), W = (0, $7fPBF.useCallback)(function(e) {
        null == f || f(o, e);
    }, [
        f,
        o
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).rect, {
        x: C.x,
        y: C.y,
        rx: v,
        ry: v,
        width: C.width.to(function(e) {
            return Math.max(e, 0);
        }),
        height: C.height.to(function(e) {
            return Math.max(e, 0);
        }),
        fill: C.color,
        fillOpacity: C.opacity,
        strokeWidth: u,
        stroke: h,
        strokeOpacity: s,
        onMouseEnter: g ? w : void 0,
        onMouseMove: g ? B : void 0,
        onMouseLeave: g ? I : void 0,
        onClick: g ? W : void 0
    });
}, $c725e3fc4c01aa11$var$q = function(e) {
    var o = e.nodes, n = e.nodeOpacity, t = e.nodeHoverOpacity, i = e.nodeHoverOthersOpacity, r = e.borderWidth, l = e.getBorderColor, a = e.borderRadius, d = e.setCurrentNode, c = e.currentNode, s = e.currentLink, u = e.isCurrentNode, h = e.isInteractive, v = e.onClick, p = e.tooltip, g = function(e) {
        return c || s ? u(e) ? t : i : n;
    };
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: o.map(function(e) {
            return (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$Z, {
                node: e,
                x: e.x,
                y: e.y,
                width: e.width,
                height: e.height,
                color: e.color,
                opacity: g(e),
                borderWidth: r,
                borderColor: l(e),
                borderRadius: a,
                setCurrent: d,
                isInteractive: h,
                onClick: v,
                tooltip: p
            }, e.id);
        })
    });
}, $c725e3fc4c01aa11$var$U = function(e) {
    var o = e.id, n = e.layout, t = e.startColor, i = e.endColor;
    return (0, $824c049f32d4395d$exports.jsxs)("linearGradient", $c725e3fc4c01aa11$var$S({
        id: o,
        spreadMethod: "pad"
    }, "horizontal" === n ? {
        x1: "0%",
        x2: "100%",
        y1: "0%",
        y2: "0%"
    } : {
        x1: "0%",
        x2: "0%",
        y1: "0%",
        y2: "100%"
    }, {
        children: [
            (0, $824c049f32d4395d$exports.jsx)("stop", {
                offset: "0%",
                stopColor: t
            }),
            (0, $824c049f32d4395d$exports.jsx)("stop", {
                offset: "100%",
                stopColor: i
            })
        ]
    }));
}, $c725e3fc4c01aa11$var$J = function(e) {
    var o = e.link, n = e.layout, r = e.path, l = e.color, a = e.opacity, d = e.blendMode, u = e.enableGradient, h = e.setCurrent, v = e.tooltip, p = e.isInteractive, g = e.onClick, f = o.source.id + "." + o.target.id + "." + o.index, y = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), m = y.animate, k = y.config, b = (0, $0332e848e6fa2251$export$6b8391a1442f2172)(r), C = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        color: l,
        opacity: a,
        config: k,
        immediate: !m
    }), x = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), w = x.showTooltipFromEvent, B = x.hideTooltip, I = (0, $7fPBF.useCallback)(function(e) {
        h(o), w((0, $7fPBF.createElement)(v, {
            link: o
        }), e, "left");
    }, [
        h,
        o,
        w,
        v
    ]), W = (0, $7fPBF.useCallback)(function(e) {
        w((0, $7fPBF.createElement)(v, {
            link: o
        }), e, "left");
    }, [
        w,
        o,
        v
    ]), N = (0, $7fPBF.useCallback)(function() {
        h(null), B();
    }, [
        h,
        B
    ]), F = (0, $7fPBF.useCallback)(function(e) {
        null == g || g(o, e);
    }, [
        g,
        o
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            u && (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$U, {
                id: f,
                layout: n,
                startColor: o.startColor || o.source.color,
                endColor: o.endColor || o.target.color
            }),
            (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
                fill: u ? 'url("#' + encodeURI(f) + '")' : C.color,
                d: b,
                fillOpacity: C.opacity,
                onMouseEnter: p ? I : void 0,
                onMouseMove: p ? W : void 0,
                onMouseLeave: p ? N : void 0,
                onClick: p ? F : void 0,
                style: {
                    mixBlendMode: d
                }
            })
        ]
    });
}, $c725e3fc4c01aa11$var$K = function(e) {
    var o = e.links, t = e.layout, i = e.linkOpacity, r = e.linkHoverOpacity, l = e.linkHoverOthersOpacity, a = e.linkContract, d = e.linkBlendMode, c = e.enableLinkGradient, s = e.setCurrentLink, u = e.currentLink, h = e.currentNode, v = e.isCurrentLink, p = e.isInteractive, g = e.onClick, f = e.tooltip, y = function(e) {
        return h || u ? v(e) ? r : l : i;
    }, m = (0, $7fPBF.useMemo)(function() {
        var e;
        return "horizontal" === t ? (e = (0, $b88cb4978b49d732$export$2e2bcd8739ae039)().curve((0, $52138155fb87d3d5$export$99563b5420dbdc55)), function(o, n) {
            var t = Math.max(1, o.thickness - 2 * n) / 2, i = .12 * (o.target.x0 - o.source.x1), r = [
                [
                    o.source.x1,
                    o.pos0 - t
                ],
                [
                    o.source.x1 + i,
                    o.pos0 - t
                ],
                [
                    o.target.x0 - i,
                    o.pos1 - t
                ],
                [
                    o.target.x0,
                    o.pos1 - t
                ],
                [
                    o.target.x0,
                    o.pos1 + t
                ],
                [
                    o.target.x0 - i,
                    o.pos1 + t
                ],
                [
                    o.source.x1 + i,
                    o.pos0 + t
                ],
                [
                    o.source.x1,
                    o.pos0 + t
                ],
                [
                    o.source.x1,
                    o.pos0 - t
                ]
            ];
            return e(r) + "Z";
        }) : function() {
            var e = (0, $b88cb4978b49d732$export$2e2bcd8739ae039)().curve((0, $52138155fb87d3d5$export$8b5360456d6bdb88));
            return function(o, n) {
                var t = Math.max(1, o.thickness - 2 * n) / 2, i = .12 * (o.target.y0 - o.source.y1), r = [
                    [
                        o.pos0 + t,
                        o.source.y1
                    ],
                    [
                        o.pos0 + t,
                        o.source.y1 + i
                    ],
                    [
                        o.pos1 + t,
                        o.target.y0 - i
                    ],
                    [
                        o.pos1 + t,
                        o.target.y0
                    ],
                    [
                        o.pos1 - t,
                        o.target.y0
                    ],
                    [
                        o.pos1 - t,
                        o.target.y0 - i
                    ],
                    [
                        o.pos0 - t,
                        o.source.y1 + i
                    ],
                    [
                        o.pos0 - t,
                        o.source.y1
                    ],
                    [
                        o.pos0 + t,
                        o.source.y1
                    ]
                ];
                return e(r) + "Z";
            };
        }();
    }, [
        t
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: o.map(function(e) {
            return (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$J, {
                link: e,
                layout: t,
                path: m(e, a),
                color: e.color,
                opacity: y(e),
                blendMode: d,
                enableGradient: c,
                setCurrent: s,
                isInteractive: p,
                onClick: g,
                tooltip: f
            }, e.source.id + "." + e.target.id + "." + e.index);
        })
    });
}, $c725e3fc4c01aa11$var$Q = function(e) {
    var o = e.nodes, n = e.layout, t = e.width, i = e.height, r = e.labelPosition, a = e.labelPadding, d = e.labelOrientation, s = e.getLabelTextColor, u = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), h = "vertical" === d ? -90 : 0, v = o.map(function(e) {
        var o, l, c;
        return "horizontal" === n ? (l = e.y + e.height / 2, e.x < t / 2 ? "inside" === r ? (o = e.x1 + a, c = "vertical" === d ? "middle" : "start") : (o = e.x - a, c = "vertical" === d ? "middle" : "end") : "inside" === r ? (o = e.x - a, c = "vertical" === d ? "middle" : "end") : (o = e.x1 + a, c = "vertical" === d ? "middle" : "start")) : "vertical" === n && (o = e.x + e.width / 2, e.y < i / 2 ? "inside" === r ? (l = e.y1 + a, c = "vertical" === d ? "end" : "middle") : (l = e.y - a, c = "vertical" === d ? "start" : "middle") : "inside" === r ? (l = e.y - a, c = "vertical" === d ? "start" : "middle") : (l = e.y1 + a, c = "vertical" === d ? "end" : "middle")), {
            id: e.id,
            label: e.label,
            x: o,
            y: l,
            textAnchor: c,
            color: s(e)
        };
    }), p = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), g = p.animate, f = p.config, y = (0, $27d73b36303119b6$export$15786d483ab9f469)(v.length, v.map(function(e) {
        return {
            transform: "translate(" + e.x + ", " + e.y + ") rotate(" + h + ")",
            color: e.color,
            config: f,
            immediate: !g
        };
    }));
    return (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: y.map(function(e, o) {
            var n = v[o];
            return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).text, {
                dominantBaseline: "central",
                textAnchor: n.textAnchor,
                transform: e.transform,
                style: $c725e3fc4c01aa11$var$S({}, u.labels.text, {
                    fill: e.color,
                    pointerEvents: "none"
                }),
                children: n.label
            }, n.id);
        })
    });
}, $c725e3fc4c01aa11$var$X = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $c725e3fc4c01aa11$var$Y = function(o) {
    var n = o.data, t = o.valueFormat, l = o.layout, a = void 0 === l ? $c725e3fc4c01aa11$export$82f4948cbf358702.layout : l, d = o.sort, c = void 0 === d ? $c725e3fc4c01aa11$export$82f4948cbf358702.sort : d, s = o.align, u = void 0 === s ? $c725e3fc4c01aa11$export$82f4948cbf358702.align : s, p = o.width, f = o.height, y = o.margin, m = o.colors, k = void 0 === m ? $c725e3fc4c01aa11$export$82f4948cbf358702.colors : m, b = o.nodeThickness, C = void 0 === b ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeThickness : b, x = o.nodeSpacing, O = void 0 === x ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeThickness : x, M = o.nodeInnerPadding, T = void 0 === M ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeInnerPadding : M, w = o.nodeBorderColor, B = void 0 === w ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeBorderColor : w, I = o.nodeOpacity, H = void 0 === I ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeOpacity : I, P = o.nodeHoverOpacity, W = void 0 === P ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeHoverOpacity : P, N = o.nodeHoverOthersOpacity, F = void 0 === N ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeHoverOthersOpacity : N, R = o.nodeBorderWidth, z = void 0 === R ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeBorderWidth : R, E = o.nodeBorderRadius, G = void 0 === E ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeBorderRadius : E, j = o.linkOpacity, V = void 0 === j ? $c725e3fc4c01aa11$export$82f4948cbf358702.linkOpacity : j, Z = o.linkHoverOpacity, U = void 0 === Z ? $c725e3fc4c01aa11$export$82f4948cbf358702.linkHoverOpacity : Z, J = o.linkHoverOthersOpacity, X = void 0 === J ? $c725e3fc4c01aa11$export$82f4948cbf358702.linkHoverOthersOpacity : J, Y = o.linkContract, $ = void 0 === Y ? $c725e3fc4c01aa11$export$82f4948cbf358702.linkContract : Y, _ = o.linkBlendMode, ee = void 0 === _ ? $c725e3fc4c01aa11$export$82f4948cbf358702.linkBlendMode : _, oe = o.enableLinkGradient, ne = void 0 === oe ? $c725e3fc4c01aa11$export$82f4948cbf358702.enableLinkGradient : oe, te = o.enableLabels, ie = void 0 === te ? $c725e3fc4c01aa11$export$82f4948cbf358702.enableLabels : te, re = o.labelPosition, le = void 0 === re ? $c725e3fc4c01aa11$export$82f4948cbf358702.labelPosition : re, ae = o.labelPadding, de = void 0 === ae ? $c725e3fc4c01aa11$export$82f4948cbf358702.labelPadding : ae, ce = o.labelOrientation, se = void 0 === ce ? $c725e3fc4c01aa11$export$82f4948cbf358702.labelOrientation : ce, ue = o.label, he = void 0 === ue ? $c725e3fc4c01aa11$export$82f4948cbf358702.label : ue, ve = o.labelTextColor, pe = void 0 === ve ? $c725e3fc4c01aa11$export$82f4948cbf358702.labelTextColor : ve, ge = o.nodeTooltip, fe = void 0 === ge ? $c725e3fc4c01aa11$export$82f4948cbf358702.nodeTooltip : ge, ye = o.linkTooltip, me = void 0 === ye ? $c725e3fc4c01aa11$export$82f4948cbf358702.linkTooltip : ye, ke = o.isInteractive, be = void 0 === ke ? $c725e3fc4c01aa11$export$82f4948cbf358702.isInteractive : ke, Ce = o.onClick, xe = o.legends, Oe = void 0 === xe ? $c725e3fc4c01aa11$export$82f4948cbf358702.legends : xe, Le = o.layers, Me = void 0 === Le ? $c725e3fc4c01aa11$export$82f4948cbf358702.layers : Le, Te = o.role, we = void 0 === Te ? $c725e3fc4c01aa11$export$82f4948cbf358702.role : Te, Be = o.ariaLabel, Ie = o.ariaLabelledBy, He = o.ariaDescribedBy, Pe = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(p, f, y), We = Pe.margin, Ne = Pe.innerWidth, Fe = Pe.innerHeight, Re = Pe.outerWidth, Se = Pe.outerHeight, ze = $c725e3fc4c01aa11$var$A({
        data: n,
        valueFormat: t,
        layout: a,
        width: Ne,
        height: Fe,
        sort: c,
        align: u,
        colors: k,
        nodeThickness: C,
        nodeSpacing: O,
        nodeInnerPadding: T,
        nodeBorderColor: B,
        label: he,
        labelTextColor: pe
    }), Ee = ze.nodes, Ge = ze.links, je = ze.legendData, De = ze.getNodeBorderColor, Ve = ze.currentNode, Ae = ze.setCurrentNode, Ze = ze.currentLink, qe = ze.setCurrentLink, Ue = ze.getLabelTextColor, Je = function() {
        return !1;
    }, Ke = function() {
        return !1;
    };
    if (Ze && (Je = function(e) {
        var o = e.id;
        return o === Ze.source.id || o === Ze.target.id;
    }, Ke = function(e) {
        var o = e.source, n = e.target;
        return o.id === Ze.source.id && n.id === Ze.target.id;
    }), Ve) {
        var Qe = [
            Ve.id
        ];
        Ge.filter(function(e) {
            var o = e.source, n = e.target;
            return o.id === Ve.id || n.id === Ve.id;
        }).forEach(function(e) {
            var o = e.source, n = e.target;
            Qe.push(o.id), Qe.push(n.id);
        }), Qe = (0, (/*@__PURE__*/$parcel$interopDefault($51de7ad69d90896e$exports)))(Qe), Je = function(e) {
            var o = e.id;
            return Qe.includes(o);
        }, Ke = function(e) {
            var o = e.source, n = e.target;
            return o.id === Ve.id || n.id === Ve.id;
        };
    }
    var Xe = {
        links: Ge,
        nodes: Ee,
        margin: We,
        width: p,
        height: f,
        outerWidth: Re,
        outerHeight: Se
    }, Ye = {
        links: null,
        nodes: null,
        labels: null,
        legends: null
    };
    return Me.includes("links") && (Ye.links = (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$K, {
        links: Ge,
        layout: a,
        linkContract: $,
        linkOpacity: V,
        linkHoverOpacity: U,
        linkHoverOthersOpacity: X,
        linkBlendMode: ee,
        enableLinkGradient: ne,
        setCurrentLink: qe,
        currentNode: Ve,
        currentLink: Ze,
        isCurrentLink: Ke,
        isInteractive: be,
        onClick: Ce,
        tooltip: me
    }, "links")), Me.includes("nodes") && (Ye.nodes = (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$q, {
        nodes: Ee,
        nodeOpacity: H,
        nodeHoverOpacity: W,
        nodeHoverOthersOpacity: F,
        borderWidth: z,
        borderRadius: G,
        getBorderColor: De,
        setCurrentNode: Ae,
        currentNode: Ve,
        currentLink: Ze,
        isCurrentNode: Je,
        isInteractive: be,
        onClick: Ce,
        tooltip: fe
    }, "nodes")), Me.includes("labels") && ie && (Ye.labels = (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$Q, {
        nodes: Ee,
        layout: a,
        width: Ne,
        height: Fe,
        labelPosition: le,
        labelPadding: de,
        labelOrientation: se,
        getLabelTextColor: Ue
    }, "labels")), Me.includes("legends") && (Ye.legends = (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
        children: Oe.map(function(e, o) {
            return (0, $824c049f32d4395d$exports.jsx)((0, $1f8b88f2b81b0f2b$export$238a2f791d4948f7), $c725e3fc4c01aa11$var$S({}, e, {
                containerWidth: Ne,
                containerHeight: Fe,
                data: je
            }), "legend" + o);
        })
    }, "legends")), (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$21d9f1931ef75b56), {
        width: Re,
        height: Se,
        margin: We,
        role: we,
        ariaLabel: Be,
        ariaLabelledBy: Ie,
        ariaDescribedBy: He,
        children: Me.map(function(e, o) {
            var n;
            return "function" == typeof e ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: (0, $7fPBF.createElement)(e, Xe)
            }, o) : null != (n = null == Ye ? void 0 : Ye[e]) ? n : null;
        })
    });
}, $c725e3fc4c01aa11$export$c6543aa9da37a94e = function(e) {
    var o = e.isInteractive, n = void 0 === o ? $c725e3fc4c01aa11$export$82f4948cbf358702.isInteractive : o, t = e.animate, i = void 0 === t ? $c725e3fc4c01aa11$export$82f4948cbf358702.animate : t, r = e.motionConfig, l = void 0 === r ? $c725e3fc4c01aa11$export$82f4948cbf358702.motionConfig : r, a = e.theme, d = e.renderWrapper, c = function(e, o) {
        if (null == e) return {};
        var n, t, i = {}, r = Object.keys(e);
        for(t = 0; t < r.length; t++)n = r[t], o.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
    }(e, $c725e3fc4c01aa11$var$X);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$42a852a2b6b56249), {
        animate: i,
        isInteractive: n,
        motionConfig: l,
        renderWrapper: d,
        theme: a,
        children: (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$var$Y, $c725e3fc4c01aa11$var$S({
            isInteractive: n
        }, c))
    });
}, $c725e3fc4c01aa11$export$d5de51db4b6f0c11 = function(e) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(o) {
            var n = o.width, t = o.height;
            return (0, $824c049f32d4395d$exports.jsx)($c725e3fc4c01aa11$export$c6543aa9da37a94e, $c725e3fc4c01aa11$var$S({
                width: n,
                height: t
            }, e));
        }
    });
};






const $500c165d23a8d4ed$var$colors = [
    "rgba(23, 151, 242, 1)",
    "rgba(146, 208, 80, 1)",
    "rgba(187, 109, 206, 1)",
    "rgba(255, 214, 0, 1)",
    "rgba(237, 28, 35, 1)",
    "rgba(46, 49, 146, 1"
];
const $500c165d23a8d4ed$var$debugFlag = 3;
function $500c165d23a8d4ed$export$4c14db0cde074ad4({ value: value }) {
    $500c165d23a8d4ed$export$4c14db0cde074ad4.propTypes = {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    };
    $500c165d23a8d4ed$export$4c14db0cde074ad4.defaultProps = {
        value: ""
    };
    const theme = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: (0, $9tqwB._)({}, theme.tooltip.container),
        className: "text-sm rounded-md shadow",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            className: "text-white",
            children: `${Number(value).toLocaleString("de", {
                style: "currency",
                currency: baseCurrency || "EUR",
                maximumFractionDigits: 0
            })}`
        })
    });
}
function $500c165d23a8d4ed$var$makeNivoRenderer(NivoChart) {
    return function NivoRenderer(props) {
        const pivotData = new (0, $25ed1e0e429105db$exports.PivotData)(props);
        const rowKeys = pivotData.getRowKeys();
        const colKeys = pivotData.getColKeys();
        const hideFullscreenButton = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>!state.message.fullscreenReport);
        const [chartErrorMessage, setChartErrorMessage] = (0, $7fPBF.useState)(null);
        const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
        const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
        let fullAggName = props.aggregatorName;
        const numInputs = props.aggregators[fullAggName]([])().numInputs || 0;
        if (numInputs !== 0) fullAggName += ` of ${props.vals.slice(0, numInputs).join(", ")}`;
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.log("rowKeys", rowKeys); // all the possible combinations of main key category fields [[2015, 'DKB Giro'], [2017, 'Festgeld'],[2019, 'Festgeld'] ...]
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.log("colKeys", colKeys); // all the possible combinations of the secondary key category fields [['American Express', 'EUR'], ['Arbeitgeber AG', 'EUR'], ['Avis AG', 'EUR']...]
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.log("pivotData with props", pivotData);
        // rowKeys and colKeys have all the needed combinations of keys already
        // e.g. [[2015, 'EUR'], [2015, 'USD'], [2016, 'EUR'], [2017, 'EUR']]
        // even if there are more than 1 attribute in each group
        // so all that needs to happen is to produce for each object (which is an array) in rowKeys
        // an object with the joinedKey
        const rowNames = pivotData.props.rows; // ["Date (Year)", "accountName"]
        const colNames = pivotData.props.cols; // names of the fields that go to secondary category ["otherParty", "currency"]
        let data = [];
        // transform data from PivotTable to hierarchy structure
        const rowKeysByName = rowNames.reduce((prevRowName, currRowName, rowNameIdx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevRowName), {
                [currRowName]: rowKeys.reduce((prevRowKey, currRowKey)=>{
                    if (!prevRowKey.includes(currRowKey[rowNameIdx])) prevRowKey.push(currRowKey[rowNameIdx]);
                    return prevRowKey;
                }, [])
            }), {});
        const colKeysByName = colNames.reduce((prevColName, currColName, colNameIdx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevColName), {
                [currColName]: colKeys.reduce((prevColKey, currColKey)=>{
                    if (!prevColKey.includes(currColKey[colNameIdx])) prevColKey.push(currColKey[colNameIdx]);
                    return prevColKey;
                }, [])
            }), {});
        const keysByName = (0, $9tqwB._)({}, rowKeysByName, colKeysByName);
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.info("keysByName", keysByName);
        const fields = Object.keys(keysByName);
        // to simplify the code below, this contains the names of the fields, e.g. ['Transaction sign', 'label', 'otherParty']
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.info("fields", fields);
        function groupByReduce(dataArray, groupPropertyArray) {
            return Object.values(dataArray.reduce((prev, item)=>{
                const group = JSON.stringify(groupPropertyArray(item));
                prev[group] = prev[group] || fields.reduce((cum, _, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, cum), {
                        [fields[idx]]: JSON.parse(group)[idx]
                    }), {}); // initialise attribute of the group key
                prev[group].value = prev[group].value || 0; // initialise amount attribute if not yet initialised
                prev[group].value += Number(item.amount); // TODO: vals
                return prev;
            }, {}));
        }
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.info("groupByReduce", groupByReduce(pivotData.props.data.map((x)=>({
                "Transaction sign": x["Transaction sign"],
                label: x.label,
                otherParty: x.otherParty,
                amount: x.amount
            })), (item)=>[
                item["Transaction sign"],
                item.label,
                item.otherParty
            ]));
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.info("groupByReduce", groupByReduce(pivotData.props.data.map((x)=>({
                "Transaction sign": x["Transaction sign"],
                label: x.label,
                otherParty: x.otherParty,
                amount: x.amount
            })), (item)=>[
                item["Transaction sign"],
                item.label
            ]));
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.info("groupByReduce", groupByReduce(pivotData.props.data.map((x)=>({
                "Transaction sign": x["Transaction sign"],
                label: x.label,
                otherParty: x.otherParty,
                amount: x.amount
            })), (item)=>[
                item["Transaction sign"]
            ]));
        function generateLinks() {
            // returns links for sankey chart in the format:
            // [  { source: 'A', target: 'B', value: 1 }, ... ]
            const groupedData = [];
            for(let i = 1; i <= fields.length; i += 1)groupedData.push(...groupByReduce(pivotData.props.data, (item)=>fields.slice(0, i).map((field)=>item[field])));
            // this is a more verbatim way of doing this:
            // const groupedData = [
            //   // ...groupByReduce(pivotData.props.data, (item) => [item['Transaction sign'], item.label, item.otherParty]),
            //   // ...groupByReduce(pivotData.props.data, (item) => [item['Transaction sign'], item.label]),
            //   // ...groupByReduce(pivotData.props.data, (item) => [item['Transaction sign']]),
            // ];
            // DESIGN LIMITATION:
            // the general limitation of PivotTableUI is that each field can only be used once in the rows or columns (or ununsedColumns)
            // i.e. it is not possible to design something like: otherParty > label > transaction sign > label > otherParty to reflect this chart properly
            // it would be possible to design one-way flows, but at the moment it feels difficult to lay out a chart that would be useful
            // with that in mind, we assume for now that the fields must support a symmetrical structure with field[0] being the top level node
            // and having only two values
            // transform in the source/target format required by the sankey chart
            return groupedData.map((item)=>{
                // fields is an array containing field names, in a specific order; fields[0] is the top level node; fields[1] is the second level node (on both sides of the top level node), etc.
                // if all fields[x] are undefined except for fields[0], then this is a top level node
                // example: ['Transaction sign', 'label', 'otherParty']
                const topLevelNodeValue0 = keysByName[fields[0]][0] || "empty"; // <-- sankey does not like null values
                const topLevelNodeValue1 = keysByName[fields[0]][1] || "empty";
                // handle top-level node, which goes in the middle of the chart
                if (fields.slice(1).every((field)=>item[field] === undefined)) {
                    // handle left and right side of the chart separately
                    if (item[fields[0]] === topLevelNodeValue1) // if the value of fields[0] is the second sorted element from top-level field, then return source: <first top-level element>, target: <second top-level element>
                    return {
                        source: topLevelNodeValue0,
                        sourceLabel: topLevelNodeValue0,
                        target: topLevelNodeValue1,
                        targetLabel: topLevelNodeValue1,
                        value: Math.abs(item.value)
                    };
                    // we just need one top-level link (above), but this one has to be output somewhere, so here it is
                    return {
                        source: topLevelNodeValue0,
                        sourceLabel: topLevelNodeValue0,
                        target: topLevelNodeValue1,
                        targetLabel: topLevelNodeValue1,
                        value: 0
                    };
                }
                // handle first-level nodes which have links to and from the top-level node
                // as the same nodes will inevitably show up on both sides of the top-level node, we need to differentiate them by addind a prefix depending on the side
                // we are using the values of the top-level node for that
                // first-level nodes will be those which have all fields except for fields[0] and fields[1] undefined
                if (fields.slice(2).every((field)=>item[field] === undefined)) {
                    // handle left and right side of the chart separately
                    if (item[fields[0]] === topLevelNodeValue0) return {
                        source: `${topLevelNodeValue0}__${item[fields[1]] || "empty"}`,
                        sourceLabel: item[fields[1]] || "empty",
                        target: topLevelNodeValue0,
                        targetLabel: item[fields[0]] || "empty",
                        value: Math.abs(item.value)
                    };
                    return {
                        source: topLevelNodeValue1,
                        sourceLabel: topLevelNodeValue1,
                        target: `${topLevelNodeValue1}__${item[fields[1]] || "empty"}`,
                        targetLabel: item[fields[1]] || "empty",
                        value: Math.abs(item.value)
                    };
                }
                // handle second-level nodes and below
                // if we got as far as here, it means that item[field0] and item[field1] are defined
                // so the question is how many other undefineds is there?
                const undefineds = fields.slice(3).filter((field)=>item[field] === undefined).length;
                const itemHierarchyLevel = fields.length - undefineds;
                const parentHierarchyLevel = itemHierarchyLevel - 1;
                const itemNodeValue = item[fields[itemHierarchyLevel]] || "empty";
                const parentNodeValue = item[fields[itemHierarchyLevel - 1]] || "empty";
                // handle left and right side of the chart separately
                // to avoid node names clashing on levels 1 and below ('negative__null' was possible on all levels), keep the separator length __ depende on the level
                if (item[fields[0]] === topLevelNodeValue0) return {
                    source: `${topLevelNodeValue0}${"".padEnd(itemHierarchyLevel, "_")}${parentNodeValue}`,
                    sourceLabel: parentNodeValue,
                    target: `${topLevelNodeValue0}${"".padEnd(parentHierarchyLevel, "_")}${itemNodeValue}`,
                    targetLabel: itemNodeValue,
                    value: Math.abs(item.value)
                };
                return {
                    source: `${topLevelNodeValue1}${"".padEnd(parentHierarchyLevel, "_")}${itemNodeValue}`,
                    sourceLabel: itemNodeValue,
                    target: `${topLevelNodeValue1}${"".padEnd(itemHierarchyLevel, "_")}${parentNodeValue}`,
                    targetLabel: parentNodeValue,
                    value: Math.abs(item.value)
                };
            // }
            // return {}
            });
        }
        console.info("GENERATE LINKS: ", generateLinks());
        // generate hierarchical data structure
        const links = generateLinks();
        data = {
            links: links,
            nodes: Object.values(links.reduce((prev, curr)=>{
                prev[curr.source] = {
                    id: curr.source,
                    label: curr.sourceLabel
                };
                prev[curr.target] = {
                    id: curr.target,
                    label: curr.targetLabel
                };
                return prev;
            }, []))
        };
        console.info("NODES", data.nodes);
        const commonProps = (0, $9tqwB._)({
            width: 900,
            height: 500,
            margin: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
            },
            theme: {
                fontFamily: "Lato",
                tooltip: {
                    container: {
                        background: "#333",
                        fontSize: "12px",
                        color: "#fff"
                    }
                }
            },
            padding: 0.2,
            colors: {
                scheme: "category10"
            },
            linkTooltip: ({ link: link })=>$500c165d23a8d4ed$export$4c14db0cde074ad4({
                    id: link.sourceLabel,
                    value: link.formattedValue,
                    formattedValue: link.formattedValue
                }),
            label: (node)=>node.label === "empty" ? "\u2205" : node.label,
            data: data
        }, pivotData.props.layoutOptions);
        function handleFullscreen() {
            dispatch((0, $3b9398d0f9c152fb$export$d717700e49bea38d)(pivotData.props));
        }
        if ($500c165d23a8d4ed$var$debugFlag > 2) console.log(data);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "absolute z-10 flex gap-1 items-start",
                    children: [
                        hideFullscreenButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "px-2 py-2 border rounded-md text-sm text-gray-500 hover:bg-gray-50",
                            onClick: handleFullscreen,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $796a20745a834567$export$2e2bcd8739ae039), {
                                className: "h-5 w-5"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "text-sm text-brandRed-500 justify-self-end bg-white p-1",
                            children: chartErrorMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex justify-center items-center",
                    children: rowKeys.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NivoChart, (0, $9tqwB._)({}, commonProps))
                })
            ]
        });
    };
}
function $500c165d23a8d4ed$export$2e2bcd8739ae039() {
    return {
        "Sankey chart": $500c165d23a8d4ed$var$makeNivoRenderer((0, $c725e3fc4c01aa11$export$c6543aa9da37a94e))
    };
}


/* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react/destructuring-assignment */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");








var $2oXYc = parcelRequire("2oXYc");



var $7fPBF = parcelRequire("7fPBF");


const $8c9b29e91bb3570d$var$EPSILON = Math.pow(2, -52);
const $8c9b29e91bb3570d$var$EDGE_STACK = new Uint32Array(512);
class $8c9b29e91bb3570d$export$2e2bcd8739ae039 {
    static from(points, getX = $8c9b29e91bb3570d$var$defaultGetX, getY = $8c9b29e91bb3570d$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $8c9b29e91bb3570d$export$2e2bcd8739ae039(coords);
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let minDist = Infinity;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0; i < n; i++){
            const d = $8c9b29e91bb3570d$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        minDist = Infinity;
        // find the point closest to the seed
        for(let i = 0; i < n; i++){
            if (i === i0) continue;
            const d = $8c9b29e91bb3570d$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $8c9b29e91bb3570d$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $8c9b29e91bb3570d$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                if (this._dists[id] > d0) {
                    hull[j++] = id;
                    d0 = this._dists[id];
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ($8c9b29e91bb3570d$var$orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $8c9b29e91bb3570d$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $8c9b29e91bb3570d$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $8c9b29e91bb3570d$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $8c9b29e91bb3570d$var$EPSILON && Math.abs(y - yp) <= $8c9b29e91bb3570d$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], !$8c9b29e91bb3570d$var$orient(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1])){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], $8c9b29e91bb3570d$var$orient(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1])){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], $8c9b29e91bb3570d$var$orient(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1])){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($8c9b29e91bb3570d$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $8c9b29e91bb3570d$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $8c9b29e91bb3570d$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $8c9b29e91bb3570d$var$EDGE_STACK.length) $8c9b29e91bb3570d$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $8c9b29e91bb3570d$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $8c9b29e91bb3570d$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $8c9b29e91bb3570d$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
// return 2d orientation sign if we're confident in it through J. Shewchuk's error bound check
function $8c9b29e91bb3570d$var$orientIfSure(px, py, rx, ry, qx, qy) {
    const l = (ry - py) * (qx - px);
    const r = (rx - px) * (qy - py);
    return Math.abs(l - r) >= 3.3306690738754716e-16 * Math.abs(l + r) ? l - r : 0;
}
// a more robust orientation test that's stable in a given triangle (to fix robustness issues)
function $8c9b29e91bb3570d$var$orient(rx, ry, qx, qy, px, py) {
    const sign = $8c9b29e91bb3570d$var$orientIfSure(px, py, rx, ry, qx, qy) || $8c9b29e91bb3570d$var$orientIfSure(rx, ry, qx, qy, px, py) || $8c9b29e91bb3570d$var$orientIfSure(qx, qy, px, py, rx, ry);
    return sign < 0;
}
function $8c9b29e91bb3570d$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $8c9b29e91bb3570d$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $8c9b29e91bb3570d$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $8c9b29e91bb3570d$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $8c9b29e91bb3570d$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $8c9b29e91bb3570d$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $8c9b29e91bb3570d$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $8c9b29e91bb3570d$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $8c9b29e91bb3570d$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $8c9b29e91bb3570d$var$quicksort(ids, dists, i, right);
            $8c9b29e91bb3570d$var$quicksort(ids, dists, left, j - 1);
        } else {
            $8c9b29e91bb3570d$var$quicksort(ids, dists, left, j - 1);
            $8c9b29e91bb3570d$var$quicksort(ids, dists, i, right);
        }
    }
}
function $8c9b29e91bb3570d$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $8c9b29e91bb3570d$var$defaultGetX(p) {
    return p[0];
}
function $8c9b29e91bb3570d$var$defaultGetY(p) {
    return p[1];
}


const $58fdfefe3055d66d$var$epsilon = 1e-6;
class $58fdfefe3055d66d$export$2e2bcd8739ae039 {
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $58fdfefe3055d66d$var$epsilon || Math.abs(this._y1 - y0) > $58fdfefe3055d66d$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
}


class $d9c5faef3056c877$export$2e2bcd8739ae039 {
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
    constructor(){
        this._ = [];
    }
}




class $07a5d91316532b9f$export$2e2bcd8739ae039 {
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const bl = dx * dx + dy * dy;
            const cl = ex * ex + ey * ey;
            const ab = (dx * ey - dy * ex) * 2;
            if (!ab) {
                // degenerate case (collinear diagram)
                x = (x1 + x3) / 2 - 1e8 * ey;
                y = (y1 + y3) / 2 + 1e8 * ex;
            } else if (Math.abs(ab) < 1e-8) {
                // almost equal points (degenerate triangle)
                x = (x1 + x3) / 2;
                y = (y1 + y3) / 2;
            } else {
                const d = 1 / ab;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $d9c5faef3056c877$export$2e2bcd8739ae039);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] == cj[aj] && ci[ai + 1] == cj[aj + 1] && ci[(ai + 2) % li] == cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] == cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points);
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        while(true){
            if (c0 === 0 && c1 === 0) return [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        if (P.length > 4) for(let i = 0; i < P.length; i += 2){
            const j = (i + 2) % P.length, k = (i + 4) % P.length;
            if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
}


const $b5dbf262727cd247$var$tau = 2 * Math.PI, $b5dbf262727cd247$var$pow = Math.pow;
function $b5dbf262727cd247$var$pointX(p) {
    return p[0];
}
function $b5dbf262727cd247$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $b5dbf262727cd247$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $b5dbf262727cd247$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $b5dbf262727cd247$export$2e2bcd8739ae039 {
    static from(points, fx = $b5dbf262727cd247$var$pointX, fy = $b5dbf262727cd247$var$pointY, that) {
        return new $b5dbf262727cd247$export$2e2bcd8739ae039("length" in points ? $b5dbf262727cd247$var$flatArray(points, fx, fy, that) : Float64Array.from($b5dbf262727cd247$var$flatIterable(points, fx, fy, that)));
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $b5dbf262727cd247$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $b5dbf262727cd247$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $8c9b29e91bb3570d$export$2e2bcd8739ae039)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            this.triangles[1] = hull[1];
            this.triangles[2] = hull[1];
            inedges[hull[0]] = 1;
            if (hull.length === 2) inedges[hull[1]] = 0;
        }
    }
    voronoi(bounds) {
        return new (0, $07a5d91316532b9f$export$2e2bcd8739ae039)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $b5dbf262727cd247$var$pow(x - points[i * 2], 2) + $b5dbf262727cd247$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $b5dbf262727cd247$var$pow(x - points[t * 2], 2) + $b5dbf262727cd247$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($b5dbf262727cd247$var$pow(x - points[e * 2], 2) + $b5dbf262727cd247$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r = 2) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $b5dbf262727cd247$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $d9c5faef3056c877$export$2e2bcd8739ae039);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $58fdfefe3055d66d$export$2e2bcd8739ae039) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $d9c5faef3056c877$export$2e2bcd8739ae039);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
    constructor(points){
        this._delaunator = new (0, $8c9b29e91bb3570d$export$2e2bcd8739ae039)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
}
function $b5dbf262727cd247$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $b5dbf262727cd247$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}



function $68d62eeeddc65ad9$var$m() {
    return $68d62eeeddc65ad9$var$m = Object.assign || function(n) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var o in i)Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
        }
        return n;
    }, $68d62eeeddc65ad9$var$m.apply(this, arguments);
}
var $68d62eeeddc65ad9$export$10439206f18620b6 = {
    xDomain: [
        0,
        1
    ],
    yDomain: [
        0,
        1
    ],
    layers: [
        "links",
        "cells",
        "points",
        "bounds"
    ],
    enableLinks: !1,
    linkLineWidth: 1,
    linkLineColor: "#bbbbbb",
    enableCells: !0,
    cellLineWidth: 2,
    cellLineColor: "#000000",
    enablePoints: !0,
    pointSize: 4,
    pointColor: "#666666",
    role: "img"
}, $68d62eeeddc65ad9$var$g = function(n) {
    return "function" == typeof n ? n : function(e) {
        return e[n];
    };
}, $68d62eeeddc65ad9$export$b1152448cb844ea5 = function(n) {
    var e = n.points, i = n.x, o = void 0 === i ? "x" : i, t = n.y, r = void 0 === t ? "y" : t, l = $68d62eeeddc65ad9$var$g(o), u = $68d62eeeddc65ad9$var$g(r);
    return e.map(function(n) {
        return [
            l(n),
            u(n)
        ];
    });
}, $68d62eeeddc65ad9$export$886e4dd0d89461d3 = function(n) {
    var e = n.points, i = n.width, o = n.height, t = n.debug, r = (0, $b5dbf262727cd247$export$2e2bcd8739ae039).from(e), l = t ? r.voronoi([
        0,
        0,
        i,
        o
    ]) : void 0;
    return {
        delaunay: r,
        voronoi: l
    };
}, $68d62eeeddc65ad9$export$a75177f2ff2023d0 = function(e) {
    var i = e.points, o = e.x, t = e.y, r = e.width, l = e.height, u = e.debug, a = (0, $7fPBF.useMemo)(function() {
        return $68d62eeeddc65ad9$export$b1152448cb844ea5({
            points: i,
            x: o,
            y: t
        });
    }, [
        i,
        o,
        t
    ]);
    return (0, $7fPBF.useMemo)(function() {
        return $68d62eeeddc65ad9$export$886e4dd0d89461d3({
            points: a,
            width: r,
            height: l,
            debug: u
        });
    }, [
        a,
        r,
        l,
        u
    ]);
}, $68d62eeeddc65ad9$export$5c7fece0e156854e = function(e) {
    var i = e.data, o = e.width, t = e.height, r = e.xDomain, l = e.yDomain, u = (0, $7fPBF.useMemo)(function() {
        return (0, $43657edf9f9313df$export$2e2bcd8739ae039)().domain(r).range([
            0,
            o
        ]);
    }, [
        r,
        o
    ]), a = (0, $7fPBF.useMemo)(function() {
        return (0, $43657edf9f9313df$export$2e2bcd8739ae039)().domain(l).range([
            0,
            t
        ]);
    }, [
        l,
        t
    ]), d = (0, $7fPBF.useMemo)(function() {
        return i.map(function(n) {
            return {
                x: u(n.x),
                y: a(n.y),
                data: n
            };
        });
    }, [
        i,
        u,
        a
    ]);
    return (0, $7fPBF.useMemo)(function() {
        var n = (0, $b5dbf262727cd247$export$2e2bcd8739ae039).from(d.map(function(n) {
            return [
                n.x,
                n.y
            ];
        })), e = n.voronoi([
            0,
            0,
            o,
            t
        ]);
        return {
            points: d,
            delaunay: n,
            voronoi: e
        };
    }, [
        d,
        o,
        t
    ]);
}, $68d62eeeddc65ad9$export$365e60801398c8ef = function(e) {
    var i = e.points, o = e.delaunay, t = e.voronoi;
    return (0, $7fPBF.useMemo)(function() {
        return {
            points: i,
            delaunay: o,
            voronoi: t
        };
    }, [
        i,
        o,
        t
    ]);
}, $68d62eeeddc65ad9$var$w = [
    "theme"
], $68d62eeeddc65ad9$var$W = function(n) {
    var o = n.data, t = n.width, r = n.height, l = n.margin, d = n.layers, s = void 0 === d ? $68d62eeeddc65ad9$export$10439206f18620b6.layers : d, c = n.xDomain, h = void 0 === c ? $68d62eeeddc65ad9$export$10439206f18620b6.xDomain : c, v = n.yDomain, p = void 0 === v ? $68d62eeeddc65ad9$export$10439206f18620b6.yDomain : v, m = n.enableLinks, g = void 0 === m ? $68d62eeeddc65ad9$export$10439206f18620b6.enableLinks : m, b = n.linkLineWidth, k = void 0 === b ? $68d62eeeddc65ad9$export$10439206f18620b6.linkLineWidth : b, x = n.linkLineColor, w = void 0 === x ? $68d62eeeddc65ad9$export$10439206f18620b6.linkLineColor : x, W = n.enableCells, D = void 0 === W ? $68d62eeeddc65ad9$export$10439206f18620b6.enableCells : W, M = n.cellLineWidth, P = void 0 === M ? $68d62eeeddc65ad9$export$10439206f18620b6.cellLineWidth : M, O = n.cellLineColor, S = void 0 === O ? $68d62eeeddc65ad9$export$10439206f18620b6.cellLineColor : O, j = n.enablePoints, z = void 0 === j ? $68d62eeeddc65ad9$export$10439206f18620b6.enableCells : j, A = n.pointSize, E = void 0 === A ? $68d62eeeddc65ad9$export$10439206f18620b6.pointSize : A, H = n.pointColor, B = void 0 === H ? $68d62eeeddc65ad9$export$10439206f18620b6.pointColor : H, F = n.role, I = void 0 === F ? $68d62eeeddc65ad9$export$10439206f18620b6.role : F, q = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(t, r, l), G = q.outerWidth, J = q.outerHeight, K = q.margin, N = q.innerWidth, Q = q.innerHeight, R = $68d62eeeddc65ad9$export$5c7fece0e156854e({
        data: o,
        width: N,
        height: Q,
        xDomain: h,
        yDomain: p
    }), T = R.points, U = R.delaunay, V = R.voronoi, X = {
        links: null,
        cells: null,
        points: null,
        bounds: null
    };
    g && s.includes("links") && (X.links = (0, $824c049f32d4395d$exports.jsx)("path", {
        stroke: w,
        strokeWidth: k,
        fill: "none",
        d: U.render()
    }, "links")), D && s.includes("cells") && (X.cells = (0, $824c049f32d4395d$exports.jsx)("path", {
        d: V.render(),
        fill: "none",
        stroke: S,
        strokeWidth: P
    }, "cells")), z && s.includes("points") && (X.points = (0, $824c049f32d4395d$exports.jsx)("path", {
        stroke: "none",
        fill: B,
        d: U.renderPoints(void 0, E / 2)
    }, "points")), s.includes("bounds") && (X.bounds = (0, $824c049f32d4395d$exports.jsx)("path", {
        fill: "none",
        stroke: S,
        strokeWidth: P,
        d: V.renderBounds()
    }, "bounds"));
    var Y = $68d62eeeddc65ad9$export$365e60801398c8ef({
        points: T,
        delaunay: U,
        voronoi: V
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$21d9f1931ef75b56), {
        width: G,
        height: J,
        margin: K,
        role: I,
        children: s.map(function(n, o) {
            return void 0 !== X[n] ? X[n] : "function" == typeof n ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: (0, $7fPBF.createElement)(n, Y)
            }, o) : null;
        })
    });
}, $68d62eeeddc65ad9$export$20f0351992a349 = function(n) {
    var e = n.theme, i = function(n, e) {
        if (null == n) return {};
        var i, o, t = {}, r = Object.keys(n);
        for(o = 0; o < r.length; o++)i = r[o], e.indexOf(i) >= 0 || (t[i] = n[i]);
        return t;
    }(n, $68d62eeeddc65ad9$var$w);
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$42a852a2b6b56249), {
        isInteractive: !1,
        animate: !1,
        theme: e,
        children: (0, $824c049f32d4395d$exports.jsx)($68d62eeeddc65ad9$var$W, $68d62eeeddc65ad9$var$m({}, i))
    });
}, $68d62eeeddc65ad9$export$5298a84d23fda932 = function(n) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(e) {
            var i = e.width, o = e.height;
            return (0, $824c049f32d4395d$exports.jsx)($68d62eeeddc65ad9$export$20f0351992a349, $68d62eeeddc65ad9$var$m({
                width: i,
                height: o
            }, n));
        }
    });
}, $68d62eeeddc65ad9$export$e176487c05830cc5 = function(e) {
    var i = e.nodes, l = e.width, u = e.height, a = e.x, d = e.y, c = e.onMouseEnter, h = e.onMouseMove, m = e.onMouseLeave, y = e.onClick, g = e.debug, b = (0, $7fPBF.useRef)(null), k = (0, $7fPBF.useState)(null), C = k[0], L = k[1], w = $68d62eeeddc65ad9$export$a75177f2ff2023d0({
        points: i,
        x: a,
        y: d,
        width: l,
        height: u,
        debug: g
    }), W = w.delaunay, D = w.voronoi, M = (0, $7fPBF.useMemo)(function() {
        if (g && D) return D.render();
    }, [
        g,
        D
    ]), P = (0, $7fPBF.useCallback)(function(n) {
        if (!b.current) return [
            null,
            null
        ];
        var e = (0, $0332e848e6fa2251$export$2396fb9a7906fd81)(b.current, n), o = e[0], t = e[1], r = W.find(o, t);
        return [
            r,
            void 0 !== r ? i[r] : null
        ];
    }, [
        b,
        W
    ]), O = (0, $7fPBF.useCallback)(function(n) {
        var e = P(n), i = e[0], o = e[1];
        L(i), o && (null == c || c(o, n));
    }, [
        P,
        L,
        c
    ]), S = (0, $7fPBF.useCallback)(function(n) {
        var e = P(n), i = e[0], o = e[1];
        L(i), o && (null == h || h(o, n));
    }, [
        P,
        L,
        h
    ]), j = (0, $7fPBF.useCallback)(function(n) {
        if (L(null), m) {
            var e = void 0;
            null !== C && (e = i[C]), e && m(e, n);
        }
    }, [
        L,
        C,
        m,
        i
    ]), z = (0, $7fPBF.useCallback)(function(n) {
        var e = P(n), i = e[0], o = e[1];
        L(i), o && (null == y || y(o, n));
    }, [
        P,
        L,
        y
    ]);
    return (0, $824c049f32d4395d$exports.jsxs)("g", {
        ref: b,
        children: [
            g && D && (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: M,
                        stroke: "red",
                        strokeWidth: 1,
                        opacity: .75
                    }),
                    null !== C && (0, $824c049f32d4395d$exports.jsx)("path", {
                        fill: "pink",
                        opacity: .35,
                        d: D.renderCell(C)
                    })
                ]
            }),
            (0, $824c049f32d4395d$exports.jsx)("rect", {
                width: l,
                height: u,
                fill: "red",
                opacity: 0,
                style: {
                    cursor: "auto"
                },
                onMouseEnter: O,
                onMouseMove: S,
                onMouseLeave: j,
                onClick: z
            })
        ]
    });
}, $68d62eeeddc65ad9$export$bbd1eaf81b7812e8 = function(n, e) {
    n.save(), n.globalAlpha = .75, n.beginPath(), e.render(n), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
}, $68d62eeeddc65ad9$export$1392694608497cc = function(n, e, i) {
    n.save(), n.globalAlpha = .35, n.beginPath(), e.renderCell(i, n), n.fillStyle = "red", n.fill(), n.restore();
};


function $402be319a2343cfa$var$ie() {
    return $402be319a2343cfa$var$ie = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var i = arguments[r];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
        return e;
    }, $402be319a2343cfa$var$ie.apply(this, arguments);
}
var $402be319a2343cfa$var$ne = function(e) {
    var r = e.point;
    return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$d5f52d71198e271a), {
        id: (0, $824c049f32d4395d$exports.jsxs)("span", {
            children: [
                "x: ",
                (0, $824c049f32d4395d$exports.jsx)("strong", {
                    children: r.data.xFormatted
                }),
                ", y:",
                " ",
                (0, $824c049f32d4395d$exports.jsx)("strong", {
                    children: r.data.yFormatted
                })
            ]
        }),
        enableChip: !0,
        color: r.serieColor
    });
};
$402be319a2343cfa$var$ne.propTypes = {
    point: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
var $402be319a2343cfa$var$te = (0, $7fPBF.memo)($402be319a2343cfa$var$ne), $402be319a2343cfa$var$oe = function(e) {
    var r = e.slice, i = e.axis, n = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), t = "x" === i ? "y" : "x";
    return (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$4b779126465c60ce), {
        rows: r.points.map(function(e) {
            return [
                (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$5a7f9a6004988d01), {
                    color: e.serieColor,
                    style: n.tooltip.chip
                }, "chip"),
                e.serieId,
                (0, $824c049f32d4395d$exports.jsx)("span", {
                    style: n.tooltip.tableCellValue,
                    children: e.data[t + "Formatted"]
                }, "value")
            ];
        })
    });
};
$402be319a2343cfa$var$oe.propTypes = {
    slice: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "x",
        "y"
    ]).isRequired
};
var $402be319a2343cfa$var$ae = (0, $7fPBF.memo)($402be319a2343cfa$var$oe), $402be319a2343cfa$var$se = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
        ]).isRequired,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
            ]),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
            ])
        })).isRequired
    })).isRequired,
    xScale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    xFormat: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    ]),
    yScale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    yFormat: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    ]),
    layers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "grid",
            "markers",
            "axes",
            "areas",
            "crosshair",
            "lines",
            "slices",
            "points",
            "mesh",
            "legends"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    ])).isRequired,
    curve: (0, $0332e848e6fa2251$export$b417d9aa8a99ac1a).isRequired,
    axisTop: (0, $45dd2bf200a010e5$export$8502d8c4b99a277e),
    axisRight: (0, $45dd2bf200a010e5$export$8502d8c4b99a277e),
    axisBottom: (0, $45dd2bf200a010e5$export$8502d8c4b99a277e),
    axisLeft: (0, $45dd2bf200a010e5$export$8502d8c4b99a277e),
    enableGridX: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    enableGridY: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    gridXValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ]))
    ]),
    gridYValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ]))
    ]),
    enablePoints: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    pointSymbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    pointSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    pointColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any.isRequired,
    pointBorderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    pointBorderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any.isRequired,
    enablePointLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    pointLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    ]).isRequired,
    markers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ]).isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    })),
    colors: (0, $18aed9a2ed048594$export$9ef95eaec260ee21).isRequired,
    enableArea: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    areaOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    areaBlendMode: (0, $0332e848e6fa2251$export$6da2372f044c5e36).isRequired,
    areaBaselineValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
    ]).isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    legends: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape((0, $1f8b88f2b81b0f2b$export$b3fa7ef443b640af))).isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    debugMesh: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]).isRequired,
    enableSlices: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "x",
        "y",
        !1
    ]).isRequired,
    debugSlices: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    sliceTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]).isRequired,
    enableCrosshair: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    crosshairType: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
}, $402be319a2343cfa$export$208f32d331641072 = $402be319a2343cfa$var$ie({}, $402be319a2343cfa$var$se, {
    enablePointLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    useMesh: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
}, (0, $0332e848e6fa2251$export$99a092eaa44be1c8), (0, $0332e848e6fa2251$export$395ebfe7dd3d9f57)), $402be319a2343cfa$export$233d529d87f42067 = $402be319a2343cfa$var$ie({
    pixelRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
}, $402be319a2343cfa$var$se), $402be319a2343cfa$var$de = {
    curve: "linear",
    xScale: {
        type: "point"
    },
    yScale: {
        type: "linear",
        min: 0,
        max: "auto"
    },
    layers: [
        "grid",
        "markers",
        "axes",
        "areas",
        "crosshair",
        "lines",
        "points",
        "slices",
        "mesh",
        "legends"
    ],
    axisBottom: {},
    axisLeft: {},
    enableGridX: !0,
    enableGridY: !0,
    enablePoints: !0,
    pointSize: 6,
    pointColor: {
        from: "color"
    },
    pointBorderWidth: 0,
    pointBorderColor: {
        theme: "background"
    },
    enablePointLabel: !1,
    pointLabel: "yFormatted",
    colors: {
        scheme: "nivo"
    },
    enableArea: !1,
    areaBaselineValue: 0,
    areaOpacity: .2,
    areaBlendMode: "normal",
    lineWidth: 2,
    legends: [],
    isInteractive: !0,
    tooltip: $402be319a2343cfa$var$te,
    enableSlices: !1,
    debugSlices: !1,
    sliceTooltip: $402be319a2343cfa$var$ae,
    debugMesh: !1,
    enableCrosshair: !0,
    crosshairType: "bottom-left"
}, $402be319a2343cfa$export$a29ddeccc3bcb4ee = $402be319a2343cfa$var$ie({}, $402be319a2343cfa$var$de, {
    enablePointLabel: !1,
    useMesh: !1,
    animate: !0,
    motionConfig: "gentle",
    defs: [],
    fill: [],
    role: "img"
}), $402be319a2343cfa$export$933fd60b0b46acbc = $402be319a2343cfa$var$ie({}, $402be319a2343cfa$var$de, {
    pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1
}), $402be319a2343cfa$export$f96f914698309372 = function(e) {
    var i = e.curve;
    return (0, $7fPBF.useMemo)(function() {
        return (0, $b88cb4978b49d732$export$2e2bcd8739ae039)().defined(function(e) {
            return null !== e.x && null !== e.y;
        }).x(function(e) {
            return e.x;
        }).y(function(e) {
            return e.y;
        }).curve((0, $0332e848e6fa2251$export$99f526a753d63ebe)(i));
    }, [
        i
    ]);
}, $402be319a2343cfa$export$639abc9ba99bfd30 = function(e) {
    var i = e.curve, n = e.yScale, t = e.areaBaselineValue;
    return (0, $7fPBF.useMemo)(function() {
        return (0, $6af9e0e3bbe49016$export$2e2bcd8739ae039)().defined(function(e) {
            return null !== e.x && null !== e.y;
        }).x(function(e) {
            return e.x;
        }).y1(function(e) {
            return e.y;
        }).curve((0, $0332e848e6fa2251$export$99f526a753d63ebe)(i)).y0(n(t));
    }, [
        i,
        n,
        t
    ]);
}, $402be319a2343cfa$export$f3ade18b642c97b8 = function(e) {
    var i = e.enableSlices, n = e.points, t = e.width, o = e.height;
    return (0, $7fPBF.useMemo)(function() {
        if (!1 === i) return [];
        if ("x" === i) {
            var e = new Map;
            return n.forEach(function(r) {
                null !== r.data.x && null !== r.data.y && (e.has(r.x) ? e.get(r.x).push(r) : e.set(r.x, [
                    r
                ]));
            }), Array.from(e.entries()).sort(function(e, r) {
                return e[0] - r[0];
            }).map(function(e, r, i) {
                var n, a = e[0], s = e[1], l = i[r - 1], u = i[r + 1];
                return {
                    id: a,
                    x0: n = l ? a - (a - l[0]) / 2 : a,
                    x: a,
                    y0: 0,
                    y: 0,
                    width: u ? a - n + (u[0] - a) / 2 : t - n,
                    height: o,
                    points: s.reverse()
                };
            });
        }
        if ("y" === i) {
            var r = new Map;
            return n.forEach(function(e) {
                null !== e.data.x && null !== e.data.y && (r.has(e.y) ? r.get(e.y).push(e) : r.set(e.y, [
                    e
                ]));
            }), Array.from(r.entries()).sort(function(e, r) {
                return e[0] - r[0];
            }).map(function(e, r, i) {
                var n, a, s = e[0], l = e[1], u = i[r - 1], d = i[r + 1];
                return n = u ? s - (s - u[0]) / 2 : s, a = d ? s - n + (d[0] - s) / 2 : o - n, {
                    id: s,
                    x0: 0,
                    x: 0,
                    y0: n,
                    y: s,
                    width: t,
                    height: a,
                    points: l.reverse()
                };
            });
        }
    }, [
        i,
        n
    ]);
}, $402be319a2343cfa$export$223993f5dbe98de0 = function(e) {
    var t = e.data, o = e.xScale, a = void 0 === o ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.xScale : o, s = e.xFormat, l = e.yScale, d = void 0 === l ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.yScale : l, c = e.yFormat, f = e.width, p = e.height, h = e.colors, b = void 0 === h ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.colors : h, g = e.curve, m = void 0 === g ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.curve : g, v = e.areaBaselineValue, x = void 0 === v ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.areaBaselineValue : v, R = e.pointColor, q = void 0 === R ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.pointColor : R, O = e.pointBorderColor, S = void 0 === O ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.pointBorderColor : O, C = e.enableSlices, T = void 0 === C ? $402be319a2343cfa$export$a29ddeccc3bcb4ee.enableSlicesTooltip : C, M = (0, $0332e848e6fa2251$export$422f9765e6971fdf)(s), w = (0, $0332e848e6fa2251$export$422f9765e6971fdf)(c), W = (0, $18aed9a2ed048594$export$47939777be1516f5)(b, "id"), G = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), L = (0, $18aed9a2ed048594$export$2a9e363116151414)(q, G), P = (0, $18aed9a2ed048594$export$2a9e363116151414)(S, G), j = (0, $7fPBF.useState)([]), F = j[0], V = j[1], E = (0, $7fPBF.useMemo)(function() {
        return (0, $06eaf1cc3810e0c0$export$4d0b292d246e5304)(t.filter(function(e) {
            return -1 === F.indexOf(e.id);
        }), a, d, f, p);
    }, [
        t,
        F,
        a,
        d,
        f,
        p
    ]), Y = E.xScale, D = E.yScale, X = E.series, z = (0, $7fPBF.useMemo)(function() {
        var e = t.map(function(e) {
            return {
                id: e.id,
                label: e.id,
                color: W(e)
            };
        }), r = e.map(function(e) {
            return $402be319a2343cfa$var$ie({}, X.find(function(r) {
                return r.id === e.id;
            }), {
                color: e.color
            });
        }).filter(function(e) {
            return Boolean(e.id);
        });
        return {
            legendData: e.map(function(e) {
                return $402be319a2343cfa$var$ie({}, e, {
                    hidden: !r.find(function(r) {
                        return r.id === e.id;
                    })
                });
            }).reverse(),
            series: r
        };
    }, [
        t,
        X,
        W
    ]), A = z.legendData, H = z.series, I = (0, $7fPBF.useCallback)(function(e) {
        V(function(r) {
            return r.indexOf(e) > -1 ? r.filter(function(r) {
                return r !== e;
            }) : [].concat(r, [
                e
            ]);
        });
    }, []), K = function(e) {
        var i = e.series, n = e.getPointColor, t = e.getPointBorderColor, o = e.formatX, a = e.formatY;
        return (0, $7fPBF.useMemo)(function() {
            return i.reduce(function(e, r) {
                return [].concat(e, r.data.filter(function(e) {
                    return null !== e.position.x && null !== e.position.y;
                }).map(function(i, s) {
                    var l = {
                        id: r.id + "." + s,
                        index: e.length + s,
                        serieId: r.id,
                        serieColor: r.color,
                        x: i.position.x,
                        y: i.position.y
                    };
                    return l.color = n(r), l.borderColor = t(l), l.data = $402be319a2343cfa$var$ie({}, i.data, {
                        xFormatted: o(i.data.x),
                        yFormatted: a(i.data.y)
                    }), l;
                }));
            }, []);
        }, [
            i,
            n,
            t,
            o,
            a
        ]);
    }({
        series: H,
        getPointColor: L,
        getPointBorderColor: P,
        formatX: M,
        formatY: w
    }), N = $402be319a2343cfa$export$f3ade18b642c97b8({
        enableSlices: T,
        points: K,
        width: f,
        height: p
    });
    return {
        legendData: A,
        toggleSerie: I,
        lineGenerator: $402be319a2343cfa$export$f96f914698309372({
            curve: m
        }),
        areaGenerator: $402be319a2343cfa$export$639abc9ba99bfd30({
            curve: m,
            yScale: D,
            areaBaselineValue: x
        }),
        getColor: W,
        series: H,
        xScale: Y,
        yScale: D,
        slices: N,
        points: K
    };
}, $402be319a2343cfa$var$ge = function(e) {
    var r = e.areaBlendMode, i = e.areaOpacity, n = e.color, t = e.fill, o = e.path, a = (0, $0332e848e6fa2251$export$72acc3dc9629d75d)(), s = a.animate, l = a.config, u = (0, $0332e848e6fa2251$export$6b8391a1442f2172)(o), d = (0, $27d73b36303119b6$export$c4af9125706c4d30)({
        color: n,
        config: l,
        immediate: !s
    });
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
        d: u,
        fill: t || d.color,
        fillOpacity: i,
        strokeWidth: 0,
        style: {
            mixBlendMode: r
        }
    });
};
$402be319a2343cfa$var$ge.propTypes = {
    areaBlendMode: (0, $0332e848e6fa2251$export$6da2372f044c5e36).isRequired,
    areaOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    fill: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
var $402be319a2343cfa$var$me = function(e) {
    var r = e.areaGenerator, i = e.areaOpacity, n = e.areaBlendMode, t = e.lines.slice(0).reverse();
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        children: t.map(function(e) {
            return (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$ge, $402be319a2343cfa$var$ie({
                path: r(e.data.map(function(e) {
                    return e.position;
                }))
            }, $402be319a2343cfa$var$ie({
                areaOpacity: i,
                areaBlendMode: n
            }, e)), e.id);
        })
    });
};
$402be319a2343cfa$var$me.propTypes = {
    areaGenerator: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    areaOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    areaBlendMode: (0, $0332e848e6fa2251$export$6da2372f044c5e36).isRequired,
    lines: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
var $402be319a2343cfa$var$ve = (0, $7fPBF.memo)($402be319a2343cfa$var$me), $402be319a2343cfa$var$xe = function(e) {
    var i = e.lineGenerator, n = e.points, t = e.color, o = e.thickness, a = (0, $7fPBF.useMemo)(function() {
        return i(n);
    }, [
        i,
        n
    ]), s = (0, $0332e848e6fa2251$export$6b8391a1442f2172)(a);
    return (0, $824c049f32d4395d$exports.jsx)((0, $8b3e789bcbac6fcf$export$407448d2b89b1813).path, {
        d: s,
        fill: "none",
        strokeWidth: o,
        stroke: t
    });
};
$402be319a2343cfa$var$xe.propTypes = {
    points: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
        ]),
        y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
        ])
    })),
    lineGenerator: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    thickness: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
};
var $402be319a2343cfa$var$Re = (0, $7fPBF.memo)($402be319a2343cfa$var$xe), $402be319a2343cfa$var$qe = function(e) {
    var r = e.lines, i = e.lineGenerator, n = e.lineWidth;
    return r.slice(0).reverse().map(function(e) {
        var r = e.id, t = e.data, o = e.color;
        return (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$Re, {
            id: r,
            points: t.map(function(e) {
                return e.position;
            }),
            lineGenerator: i,
            color: o,
            thickness: n
        }, r);
    });
};
$402be319a2343cfa$var$qe.propTypes = {
    lines: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
        ]).isRequired,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
                x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
                    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
                    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
                    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
                ]),
                y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
                    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
                    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
                    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
                ])
            }).isRequired,
            position: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
                x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
                y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
            }).isRequired
        })).isRequired
    })).isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    lineGenerator: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
var $402be319a2343cfa$var$Oe = (0, $7fPBF.memo)($402be319a2343cfa$var$qe), $402be319a2343cfa$var$Se = function(e) {
    var r = e.slice, i = e.axis, o = e.debug, a = e.tooltip, s = e.isCurrent, l = e.setCurrent, u = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), d = u.showTooltipFromEvent, c = u.hideTooltip, f = (0, $7fPBF.useCallback)(function(e) {
        d((0, $7fPBF.createElement)(a, {
            slice: r,
            axis: i
        }), e, "right"), l(r);
    }, [
        d,
        a,
        r
    ]), p = (0, $7fPBF.useCallback)(function(e) {
        d((0, $7fPBF.createElement)(a, {
            slice: r,
            axis: i
        }), e, "right");
    }, [
        d,
        a,
        r
    ]), h = (0, $7fPBF.useCallback)(function() {
        c(), l(null);
    }, [
        c
    ]);
    return (0, $824c049f32d4395d$exports.jsx)("rect", {
        x: r.x0,
        y: r.y0,
        width: r.width,
        height: r.height,
        stroke: "red",
        strokeWidth: o ? 1 : 0,
        strokeOpacity: .75,
        fill: "red",
        fillOpacity: s && o ? .35 : 0,
        onMouseEnter: f,
        onMouseMove: p,
        onMouseLeave: h
    });
};
$402be319a2343cfa$var$Se.propTypes = {
    slice: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "x",
        "y"
    ]).isRequired,
    debug: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    isCurrent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setCurrent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
var $402be319a2343cfa$var$Ce = (0, $7fPBF.memo)($402be319a2343cfa$var$Se), $402be319a2343cfa$var$Te = function(e) {
    var r = e.slices, i = e.axis, n = e.debug, t = e.height, o = e.tooltip, a = e.current, s = e.setCurrent;
    return r.map(function(e) {
        return (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$Ce, {
            slice: e,
            axis: i,
            debug: n,
            height: t,
            tooltip: o,
            setCurrent: s,
            isCurrent: null !== a && a.id === e.id
        }, e.id);
    });
};
$402be319a2343cfa$var$Te.propTypes = {
    slices: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(Date)
        ]).isRequired,
        x: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        y: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        points: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
    })).isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "x",
        "y"
    ]).isRequired,
    debug: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]).isRequired,
    current: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setCurrent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
var $402be319a2343cfa$var$Me = (0, $7fPBF.memo)($402be319a2343cfa$var$Te), $402be319a2343cfa$var$we = function(e) {
    var r = e.points, i = e.symbol, n = e.size, t = e.borderWidth, o = e.enableLabel, a = e.label, s = e.labelYOffset, l = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), d = (0, $0332e848e6fa2251$export$192dc59ac6f86c95)(a), c = r.slice(0).reverse().map(function(e) {
        return {
            id: e.id,
            x: e.x,
            y: e.y,
            datum: e.data,
            fill: e.color,
            stroke: e.borderColor,
            label: o ? d(e.data) : null
        };
    });
    return (0, $824c049f32d4395d$exports.jsx)("g", {
        children: c.map(function(e) {
            return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$ca30f0ad55489a87), {
                x: e.x,
                y: e.y,
                datum: e.datum,
                symbol: i,
                size: n,
                color: e.fill,
                borderWidth: t,
                borderColor: e.stroke,
                label: e.label,
                labelYOffset: s,
                theme: l
            }, e.id);
        })
    });
};
$402be319a2343cfa$var$we.propTypes = {
    points: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    enableLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    ]).isRequired,
    labelYOffset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
};
var $402be319a2343cfa$var$Be = (0, $7fPBF.memo)($402be319a2343cfa$var$we), $402be319a2343cfa$var$ke = function(e) {
    var r = e.points, i = e.width, o = e.height, a = e.margin, s = e.setCurrent, l = e.onMouseEnter, u = e.onMouseMove, d = e.onMouseLeave, c = e.onClick, f = e.tooltip, p = e.debug, h = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), y = h.showTooltipAt, b = h.hideTooltip, g = (0, $7fPBF.useCallback)(function(e, r) {
        y((0, $7fPBF.createElement)(f, {
            point: e
        }), [
            e.x + a.left,
            e.y + a.top
        ], "top"), s(e), l && l(e, r);
    }, [
        s,
        y,
        f,
        l,
        a
    ]), m = (0, $7fPBF.useCallback)(function(e, r) {
        y((0, $7fPBF.createElement)(f, {
            point: e
        }), [
            e.x + a.left,
            e.y + a.top
        ], "top"), s(e), u && u(e, r);
    }, [
        s,
        y,
        f,
        u
    ]), v = (0, $7fPBF.useCallback)(function(e, r) {
        b(), s(null), d && d(e, r);
    }, [
        b,
        s,
        d
    ]), x = (0, $7fPBF.useCallback)(function(e, r) {
        c && c(e, r);
    }, [
        c
    ]);
    return (0, $824c049f32d4395d$exports.jsx)((0, $68d62eeeddc65ad9$export$e176487c05830cc5), {
        nodes: r,
        width: i,
        height: o,
        onMouseEnter: g,
        onMouseMove: m,
        onMouseLeave: v,
        onClick: x,
        debug: p
    });
};
$402be319a2343cfa$var$ke.propTypes = {
    points: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setCurrent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onMouseMove: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]).isRequired,
    debug: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};
var $402be319a2343cfa$var$We = (0, $7fPBF.memo)($402be319a2343cfa$var$ke), $402be319a2343cfa$var$Ge = function(e) {
    var r = e.data, n = e.xScale, t = e.xFormat, a = e.yScale, s = e.yFormat, l = e.layers, d = e.curve, c = e.areaBaselineValue, f = e.colors, p = e.margin, h = e.width, y = e.height, b = e.axisTop, g = e.axisRight, m = e.axisBottom, v = e.axisLeft, x = e.enableGridX, C = e.enableGridY, T = e.gridXValues, M = e.gridYValues, w = e.lineWidth, B = e.enableArea, W = e.areaOpacity, P = e.areaBlendMode, j = e.enablePoints, F = e.pointSymbol, E = e.pointSize, Y = e.pointColor, D = e.pointBorderWidth, X = e.pointBorderColor, z = e.enablePointLabel, H = e.pointLabel, I = e.pointLabelYOffset, J = e.defs, K = e.fill, Q = e.markers, U = e.legends, Z = e.isInteractive, $ = e.useMesh, _ = e.debugMesh, ee = e.onMouseEnter, re = e.onMouseMove, ne = e.onMouseLeave, te = e.onClick, oe = e.tooltip, ae = e.enableSlices, se = e.debugSlices, le = e.sliceTooltip, ue = e.enableCrosshair, de = e.crosshairType, ce = e.role, fe = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(h, y, p), pe = fe.margin, he = fe.innerWidth, ye = fe.innerHeight, ge = fe.outerWidth, me = fe.outerHeight, xe = $402be319a2343cfa$export$223993f5dbe98de0({
        data: r,
        xScale: n,
        xFormat: t,
        yScale: a,
        yFormat: s,
        width: he,
        height: ye,
        colors: f,
        curve: d,
        areaBaselineValue: c,
        pointColor: Y,
        pointBorderColor: X,
        enableSlices: ae
    }), Re = xe.legendData, qe = xe.toggleSerie, Se = xe.lineGenerator, Ce = xe.areaGenerator, Te = xe.series, we = xe.xScale, ke = xe.yScale, Ge = xe.slices, Le = xe.points, Pe = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), je = (0, $18aed9a2ed048594$export$2a9e363116151414)(Y, Pe), Fe = (0, $18aed9a2ed048594$export$2a9e363116151414)(X, Pe), Ve = (0, $7fPBF.useState)(null), Ee = Ve[0], Ye = Ve[1], De = (0, $7fPBF.useState)(null), Xe = De[0], ze = De[1], Ae = {
        grid: (0, $824c049f32d4395d$exports.jsx)((0, $45dd2bf200a010e5$export$ef2184bd89960b14), {
            theme: Pe,
            width: he,
            height: ye,
            xScale: x ? we : null,
            yScale: C ? ke : null,
            xValues: T,
            yValues: M
        }, "grid"),
        markers: (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$81759e11f9e58ea4), {
            markers: Q,
            width: he,
            height: ye,
            xScale: we,
            yScale: ke,
            theme: Pe
        }, "markers"),
        axes: (0, $824c049f32d4395d$exports.jsx)((0, $45dd2bf200a010e5$export$387a78ab20784494), {
            xScale: we,
            yScale: ke,
            width: he,
            height: ye,
            theme: Pe,
            top: b,
            right: g,
            bottom: m,
            left: v
        }, "axes"),
        areas: null,
        lines: (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$Oe, {
            lines: Te,
            lineGenerator: Se,
            lineWidth: w
        }, "lines"),
        slices: null,
        points: null,
        crosshair: null,
        mesh: null,
        legends: U.map(function(e, r) {
            return (0, $824c049f32d4395d$exports.jsx)((0, $1f8b88f2b81b0f2b$export$238a2f791d4948f7), $402be319a2343cfa$var$ie({}, e, {
                containerWidth: he,
                containerHeight: ye,
                data: e.data || Re,
                theme: Pe,
                toggleSerie: e.toggleSerie ? qe : void 0
            }), "legend." + r);
        })
    }, He = (0, $0332e848e6fa2251$export$dc35cf769e3afe34)(J, Te, K);
    return B && (Ae.areas = (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$ve, {
        areaGenerator: Ce,
        areaOpacity: W,
        areaBlendMode: P,
        lines: Te
    }, "areas")), Z && !1 !== ae && (Ae.slices = (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$Me, {
        slices: Ge,
        axis: ae,
        debug: se,
        height: ye,
        tooltip: le,
        current: Xe,
        setCurrent: ze
    }, "slices")), j && (Ae.points = (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$Be, {
        points: Le,
        symbol: F,
        size: E,
        color: je,
        borderWidth: D,
        borderColor: Fe,
        enableLabel: z,
        label: H,
        labelYOffset: I
    }, "points")), Z && ue && (null !== Ee && (Ae.crosshair = (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$2a195a185c8aa9e), {
        width: he,
        height: ye,
        x: Ee.x,
        y: Ee.y,
        type: de
    }, "crosshair")), null !== Xe && (Ae.crosshair = (0, $824c049f32d4395d$exports.jsx)((0, $c39e9a0d065c63c9$export$2a195a185c8aa9e), {
        width: he,
        height: ye,
        x: Xe.x,
        y: Xe.y,
        type: ae
    }, "crosshair"))), Z && $ && !1 === ae && (Ae.mesh = (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$We, {
        points: Le,
        width: he,
        height: ye,
        margin: pe,
        current: Ee,
        setCurrent: Ye,
        onMouseEnter: ee,
        onMouseMove: re,
        onMouseLeave: ne,
        onClick: te,
        tooltip: oe,
        debug: _
    }, "mesh")), (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$21d9f1931ef75b56), {
        defs: He,
        width: ge,
        height: me,
        margin: pe,
        role: ce,
        children: l.map(function(r, i) {
            return "function" == typeof r ? (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Fragment), {
                children: r($402be319a2343cfa$var$ie({}, e, {
                    innerWidth: he,
                    innerHeight: ye,
                    series: Te,
                    slices: Ge,
                    points: Le,
                    xScale: we,
                    yScale: ke,
                    lineGenerator: Se,
                    areaGenerator: Ce,
                    currentPoint: Ee,
                    setCurrentPoint: Ye,
                    currentSlice: Xe,
                    setCurrentSlice: ze
                }))
            }, i) : Ae[r];
        })
    });
};
$402be319a2343cfa$var$Ge.propTypes = $402be319a2343cfa$export$208f32d331641072, $402be319a2343cfa$var$Ge.defaultProps = $402be319a2343cfa$export$a29ddeccc3bcb4ee;
var $402be319a2343cfa$export$17d680238e50603e = (0, $0332e848e6fa2251$export$4cbbe0314aa930ae)($402be319a2343cfa$var$Ge), $402be319a2343cfa$export$a4a9f4982e5c2626 = function(e) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(r) {
            var i = r.width, n = r.height;
            return (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$export$17d680238e50603e, $402be319a2343cfa$var$ie({
                width: i,
                height: n
            }, e));
        }
    });
}, $402be319a2343cfa$var$je = function(e) {
    var r = e.width, o = e.height, a = e.margin, d = e.pixelRatio, c = e.data, f = e.xScale, p = e.xFormat, h = e.yScale, y = e.yFormat, b = e.curve, g = e.layers, m = e.colors, v = e.lineWidth, x = e.enableArea, q = e.areaBaselineValue, O = e.areaOpacity, S = e.enablePoints, C = e.pointSize, w = e.pointColor, B = e.pointBorderWidth, k = e.pointBorderColor, W = e.enableGridX, G = e.gridXValues, L = e.enableGridY, F = e.gridYValues, V = e.axisTop, Y = e.axisRight, D = e.axisBottom, X = e.axisLeft, A = e.legends, H = e.isInteractive, I = e.debugMesh, J = e.onMouseLeave, K = e.onClick, Q = e.tooltip, U = e.canvasRef, Z = (0, $7fPBF.useRef)(null), $ = (0, $0332e848e6fa2251$export$d04af0e501fb729f)(r, o, a), ne = $.margin, te = $.innerWidth, oe = $.innerHeight, ae = $.outerWidth, se = $.outerHeight, le = (0, $0332e848e6fa2251$export$93d4e7f90805808f)(), ue = (0, $7fPBF.useState)(null), de = ue[0], ce = ue[1], fe = $402be319a2343cfa$export$223993f5dbe98de0({
        data: c,
        xScale: f,
        xFormat: p,
        yScale: h,
        yFormat: y,
        width: te,
        height: oe,
        colors: m,
        curve: b,
        areaBaselineValue: q,
        pointColor: w,
        pointBorderColor: k
    }), pe = fe.lineGenerator, he = fe.areaGenerator, ye = fe.series, ge = fe.xScale, me = fe.yScale, ve = fe.points, xe = (0, $68d62eeeddc65ad9$export$a75177f2ff2023d0)({
        points: ve,
        width: te,
        height: oe,
        debug: I
    }), Re = xe.delaunay, qe = xe.voronoi;
    (0, $7fPBF.useEffect)(function() {
        U && (U.current = Z.current), Z.current.width = ae * d, Z.current.height = se * d;
        var e = Z.current.getContext("2d");
        e.scale(d, d), e.fillStyle = le.background, e.fillRect(0, 0, ae, se), e.translate(ne.left, ne.top), g.forEach(function(r) {
            if ("function" == typeof r && r({
                ctx: e,
                innerWidth: te,
                innerHeight: oe,
                series: ye,
                points: ve,
                xScale: ge,
                yScale: me,
                lineWidth: v,
                lineGenerator: pe,
                areaGenerator: he,
                currentPoint: de,
                setCurrentPoint: ce
            }), "grid" === r && le.grid.line.strokeWidth > 0 && (e.lineWidth = le.grid.line.strokeWidth, e.strokeStyle = le.grid.line.stroke, W && (0, $45dd2bf200a010e5$export$5eea7e798580e5d1)(e, {
                width: te,
                height: oe,
                scale: ge,
                axis: "x",
                values: G
            }), L && (0, $45dd2bf200a010e5$export$5eea7e798580e5d1)(e, {
                width: te,
                height: oe,
                scale: me,
                axis: "y",
                values: F
            })), "axes" === r && (0, $45dd2bf200a010e5$export$6f12c0e853c1bfff)(e, {
                xScale: ge,
                yScale: me,
                width: te,
                height: oe,
                top: V,
                right: Y,
                bottom: D,
                left: X,
                theme: le
            }), "areas" === r && !0 === x && (e.save(), e.globalAlpha = O, he.context(e), ye.forEach(function(r) {
                e.fillStyle = r.color, e.beginPath(), he(r.data.map(function(e) {
                    return e.position;
                })), e.fill();
            }), e.restore()), "lines" === r && (pe.context(e), ye.forEach(function(r) {
                e.strokeStyle = r.color, e.lineWidth = v, e.beginPath(), pe(r.data.map(function(e) {
                    return e.position;
                })), e.stroke();
            })), "points" === r && !0 === S && C > 0 && ve.forEach(function(r) {
                e.fillStyle = r.color, e.beginPath(), e.arc(r.x, r.y, C / 2, 0, 2 * Math.PI), e.fill(), B > 0 && (e.strokeStyle = r.borderColor, e.lineWidth = B, e.stroke());
            }), "mesh" === r && !0 === I && ((0, $68d62eeeddc65ad9$export$bbd1eaf81b7812e8)(e, qe), de && (0, $68d62eeeddc65ad9$export$1392694608497cc)(e, qe, de.index)), "legends" === r) {
                var i = ye.map(function(e) {
                    return {
                        id: e.id,
                        label: e.id,
                        color: e.color
                    };
                }).reverse();
                A.forEach(function(r) {
                    (0, $1f8b88f2b81b0f2b$export$28c0156604402604)(e, $402be319a2343cfa$var$ie({}, r, {
                        data: r.data || i,
                        containerWidth: te,
                        containerHeight: oe,
                        theme: le
                    }));
                });
            }
        });
    }, [
        Z,
        ae,
        se,
        g,
        le,
        pe,
        ye,
        ge,
        me,
        W,
        G,
        L,
        F,
        V,
        Y,
        D,
        X,
        A,
        ve,
        S,
        C,
        de
    ]);
    var Oe = (0, $7fPBF.useCallback)(function(e) {
        var r = (0, $0332e848e6fa2251$export$2396fb9a7906fd81)(Z.current, e), i = r[0], n = r[1];
        if (!(0, $0332e848e6fa2251$export$be302859f014f482)(ne.left, ne.top, te, oe, i, n)) return null;
        var t = Re.find(i - ne.left, n - ne.top);
        return ve[t];
    }, [
        Z,
        ne,
        te,
        oe,
        Re
    ]), Se = (0, $c39e9a0d065c63c9$export$1c4b08e0eca38426)(), Ce = Se.showTooltipFromEvent, Te = Se.hideTooltip, Me = (0, $7fPBF.useCallback)(function(e) {
        var r = Oe(e);
        ce(r), r ? Ce((0, $7fPBF.createElement)(Q, {
            point: r
        }), e) : Te();
    }, [
        Oe,
        ce,
        Ce,
        Te,
        Q
    ]), we = (0, $7fPBF.useCallback)(function(e) {
        Te(), ce(null), de && J && J(de, e);
    }, [
        Te,
        ce,
        J
    ]), Be = (0, $7fPBF.useCallback)(function(e) {
        if (K) {
            var r = Oe(e);
            r && K(r, e);
        }
    }, [
        Oe,
        K
    ]);
    return (0, $824c049f32d4395d$exports.jsx)("canvas", {
        ref: Z,
        width: ae * d,
        height: se * d,
        style: {
            width: ae,
            height: se,
            cursor: H ? "auto" : "normal"
        },
        onMouseEnter: H ? Me : void 0,
        onMouseMove: H ? Me : void 0,
        onMouseLeave: H ? we : void 0,
        onClick: H ? Be : void 0
    });
};
$402be319a2343cfa$var$je.propTypes = $402be319a2343cfa$export$233d529d87f42067, $402be319a2343cfa$var$je.defaultProps = $402be319a2343cfa$export$933fd60b0b46acbc;
var $402be319a2343cfa$var$Fe = (0, $0332e848e6fa2251$export$4cbbe0314aa930ae)($402be319a2343cfa$var$je), $402be319a2343cfa$export$b180b12178bebb77 = (0, $7fPBF.forwardRef)(function(e, r) {
    return (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$var$Fe, $402be319a2343cfa$var$ie({}, e, {
        canvasRef: r
    }));
}), $402be319a2343cfa$export$ef8f1d6c5afa72f3 = (0, $7fPBF.forwardRef)(function(e, r) {
    return (0, $824c049f32d4395d$exports.jsx)((0, $0332e848e6fa2251$export$fa6e408d6a7d6214), {
        children: function(i) {
            var n = i.width, t = i.height;
            return (0, $824c049f32d4395d$exports.jsx)($402be319a2343cfa$export$b180b12178bebb77, $402be319a2343cfa$var$ie({
                width: n,
                height: t
            }, e, {
                ref: r
            }));
        }
    });
});



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
const $dfe3741369ec7f49$var$colors = [
    "#1797F2",
    "#92D050",
    "#BB6DCE",
    "#FFD600",
    "#ED1C23",
    "#2E3192"
];
// LineChart can only be used for x-axis with time scale (it makes no sense for other data like accounts or categories)
function $dfe3741369ec7f49$var$makeNivoRenderer(NivoChart, layoutOptions = {}) {
    return function NivoRenderer(props) {
        const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
        const pivotData = new (0, $25ed1e0e429105db$exports.PivotData)(props);
        const rowKeys = pivotData.getRowKeys();
        const colKeys = pivotData.getColKeys();
        // when there are no dates in the data, the chart cannot be rendered
        if (!colKeys.every((x)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(x)).isValid())) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            children: i18n.language === "de" ? "Dieses Diagramm kann nur mit Kalendardaten auf Achse X dargestellt werden." : "This type of chart only supports dates on the X axis."
        });
        let fullAggName = props.aggregatorName;
        const numInputs = props.aggregators[fullAggName]([])().numInputs || 0;
        if (numInputs !== 0) fullAggName += ` of ${props.vals.slice(0, numInputs).join(", ")}`;
        // rowKeys and colKeys have all the needed combinations of keys already
        // e.g. [[2015, 'EUR'], [2015, 'USD'], [2016, 'EUR'], [2017, 'EUR']]
        // even if there are more than 1 attribute in each group
        // so all that needs to happen is to produce for each object (which is an array) in rowKeys
        // an object with the joinedKey
        const rowNames = pivotData.props.rows; // ["Date (Year)", "accountName"]
        const colNames = pivotData.props.cols; // names of the fields that go to secondary category ["otherParty", "currency"]
        console.log("rowNames", rowNames);
        console.log("colNames", colNames);
        function joinKeys(keys) {
            return typeof keys === "object" ? keys.join(String.fromCharCode(0)) : keys;
        }
        const mainCategory = rowNames.join(" ");
        const secondaryCategories = colKeys.map((colName)=>joinKeys(colName));
        let data = [];
        // this ↓↓ has all unique values organised by field name, i.e.:
        // { 'Date (Year)': [2015, 2016, 2017, 2018, 2019],
        //   'accountName': ['DKB Giro', 'Festgeld', 'Girokonto', 'Kreditkarte', 'Sparkonto'], ...
        // }
        // the sequence of keys is the hierarchy structure, i.e.: first object goes on top level, then the next object goes as a child of the first object, etc.
        const rowKeysByName = rowNames.reduce((prevRowName, currRowName, rowNameIdx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevRowName), {
                [currRowName]: rowKeys.reduce((prevRowKey, currRowKey)=>{
                    if (!prevRowKey.includes(currRowKey[rowNameIdx])) prevRowKey.push(currRowKey[rowNameIdx]);
                    return prevRowKey;
                }, [])
            }), {});
        const colKeysByName = colNames.reduce((prevColName, currColName, colNameIdx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevColName), {
                [currColName]: colKeys.reduce((prevColKey, currColKey)=>{
                    if (!prevColKey.includes(currColKey[colNameIdx])) prevColKey.push(currColKey[colNameIdx]);
                    return prevColKey;
                }, [])
            }), {});
        // data comes as a flat array of objects
        // Step 1: generate an array of object with the main category as a key
        const mainArray = rowKeysByName[rowNames[0]].map((rowKey)=>({
                id: rowKey
            }));
        // Step 2: for each object in the main array, generate the data elements
        data = mainArray.map((rowKey)=>(0, $2qxEV._)((0, $9tqwB._)({}, rowKey), {
                data: colKeys.map((x)=>({
                        x: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(joinKeys(x))).format("YYYY-MM-DD"),
                        y: pivotData.getAggregator([
                            rowKey.id
                        ], [
                            joinKeys(x)
                        ]).value()
                    }))
            }));
        // line chart input object looks like that:
        // [ { "id": "japan", "data": [{ "x": "plane", "y": 223 }, { "x": "helicopter", "y": 126 }] },
        // { "id": "france", "data": [{ "x": "plane", "y": 149 }, { "x": "helicopter", "y": 281 }] }, ...]
        // Step 3: take data array and find the highest value from the value prop for each rowKey
        // this is needed to set the y-axis max value
        const maxValue = props.data.reduce((prev, quoteItem)=>{
            if (quoteItem[props.vals[0]] > prev) return quoteItem.quote;
            return prev;
        }, 0);
        const basicUnit = 10 ** (String(maxValue).length - 1) / 2;
        const YValues = [];
        let val = 0;
        while(val <= maxValue + basicUnit){
            YValues.push(val);
            val += basicUnit;
        }
        // TODO implement time scale on x:
        // xScale: {
        //   format: '%Y-%m-%d',
        //   precision: 'month',
        //   type: 'time',
        //   useUTC: true,
        // },
        let chartProps = {
            margin: {
                top: 36,
                right: 16,
                bottom: 36,
                left: 60
            },
            colors: $dfe3741369ec7f49$var$colors,
            enableArea: true,
            areaOpacity: 0.1,
            enablePoints: false,
            // gridXValues: colKeys.length > 15 ? colKeys.filter((x, i) => i % parseInt(colKeys.length / 15, 10) === 0) : colKeys,
            // gridYValues: YValues,
            axisLeft: {
                format: (t)=>t.toLocaleString("de", {
                        maximumFractionDigits: 0
                    })
            },
            // axisBottom: {
            // tickValues: colKeys.length > 15 ? colKeys.filter((x, i) => i % parseInt(colKeys.length / 15, 10) === 0) : colKeys,
            //   format: (t) => (dayjs.utc(Number(t.join(''))).isValid()
            //     ? dayjs
            //       .utc(Number(t.join('')))
            //       .format('MM–YYYY')
            //       .toString()
            //     : t),
            // },
            axisBottom: {
                format: "%Y",
                tickValues: "every 1 year"
            },
            xFormat: "time:%Y-%m-%d",
            xScale: {
                format: "%Y-%m-%d",
                precision: "month",
                type: "time",
                useUTC: true
            },
            enableSlices: "x",
            theme: {
                fontFamily: "Lato"
            },
            padding: 0.2,
            labelTextColor: "inherit:darker(1.4)",
            labelSkipWidth: 16,
            labelSkipHeight: 16
        };
        // deep merge incoming layout options to prevent overwriting nested objects
        chartProps = (0, (/*@__PURE__*/$parcel$interopDefault($357f6a405ce5423a$exports)))(chartProps, props.layoutOptions);
        // DEBUG
        // data = [
        //   {
        //     id: 'test',
        //     data: [
        //       { x: }
        //     ]
        //   }
        // ]
        chartProps = (0, $2qxEV._)((0, $9tqwB._)({}, chartProps), {
            data: data,
            indexBy: mainCategory,
            keys: secondaryCategories
        });
        console.log("chartProps", chartProps);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NivoChart, (0, $9tqwB._)({}, chartProps));
    };
}
function $dfe3741369ec7f49$export$2e2bcd8739ae039() {
    return {
        "Line chart, horizontal": $dfe3741369ec7f49$var$makeNivoRenderer((0, $402be319a2343cfa$export$a4a9f4982e5c2626), {
            mode: "horizontal"
        })
    };
}


const $1d1b0fee492045ec$var$NivoRenderers = (0, $9tqwB._)({}, (0, $cfa42d96aefa350c$export$2e2bcd8739ae039)(), (0, $2271a15ec0eb9832$export$2e2bcd8739ae039)(), (0, $27be5ba4a9e32b50$export$2e2bcd8739ae039)(), (0, $500c165d23a8d4ed$export$2e2bcd8739ae039)(), (0, $dfe3741369ec7f49$export$2e2bcd8739ae039)());
var $1d1b0fee492045ec$export$2e2bcd8739ae039 = $1d1b0fee492045ec$var$NivoRenderers;


/* eslint-disable no-nested-ternary */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/control-has-associated-label */ /* eslint-disable react/no-array-index-key */ /* eslint-disable array-callback-return */ /* eslint-disable no-restricted-syntax */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable prefer-spread */ /* eslint-disable no-plusplus */ /* eslint-disable max-classes-per-file */ 

var $7fPBF = parcelRequire("7fPBF");



// helper function for setting row/col-span in pivotTableRenderer
const $ef846b655465c549$var$spanSize = function spanSize(arr, i, j) {
    let x;
    if (i !== 0) {
        let asc;
        let end;
        let noDraw = true;
        for(x = 0, end = j, asc = end >= 0; asc ? x <= end : x >= end; asc ? x++ : x--)if (arr[i - 1][x] !== arr[i][x]) noDraw = false;
        if (noDraw) return -1;
    }
    let len = 0;
    while(i + len < arr.length){
        let asc1;
        let end1;
        let stop = false;
        for(x = 0, end1 = j, asc1 = end1 >= 0; asc1 ? x <= end1 : x >= end1; asc1 ? x++ : x--)// vv this does not work for NaN === NaN, because that is always false
        if (arr[i][x] !== arr[i + len][x] && !Number.isNaN(arr[i][x]) && !Number.isNaN(arr[i + len][x])) stop = true;
        if (stop) break;
        len++;
    }
    return len;
};
class $ef846b655465c549$var$ListRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).PureComponent {
    render() {
        const pivotData = new (0, $25ed1e0e429105db$exports.PivotData)(this.props);
        const rows = pivotData.getRowKeys(); // array of arrays (rows)
        const columnNames = pivotData.props.rows; // array with column names
        const hiddenCols = this.props.hiddenRows; // because the columns come in "rows" to a 2D list...
        const { t: t } = this.props;
        const grandTotalAggregator = pivotData.getAggregator([], []);
        const getClickHandler = ()=>{};
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
            className: "text-sm text-gray-500 divide-y divide-gray-300 border-collapse table-auto",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                    className: "text-gray-700 sticky top-0 z-10",
                    children: columnNames.length !== 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                        className: "border-b-2 border-gray-300 ",
                        children: columnNames.map((rowAttr, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                className: `${(hiddenCols === null || hiddenCols === void 0 ? void 0 : hiddenCols.includes(idx)) ? "hiddenCol" : ""}
                  sticky table-cell top-0 py-3.5 pl-2 pr-2 text-left text-xs uppercase font-semibold text-gray-900 border-b border-gray-300 bg-gray-50 bg-opacity-75 backdrop-blur backdrop-filter`,
                                children: t(`accountDetails:columns.${rowAttr}`).slice(0, 3) === "key" ? t(`accountDetails:columns.${rowAttr}.label`) : t(`accountDetails:columns.${rowAttr}`)
                            }, `rowAttr${idx}`))
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tbody", {
                    className: "bg-white",
                    children: [
                        rows.map((row, rowIdx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                                className: "border-y border-gray-200",
                                children: row.map((colValue, colIdx)=>{
                                    const z = $ef846b655465c549$var$spanSize(rows, rowIdx, colIdx);
                                    const thisColName = columnNames[colIdx];
                                    if (z === -1) return null;
                                    if (!colValue) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: row.includes("\u03A3") ? "font-bold bg-brandBlue-50" : ""
                                    }, `rowKeyLabel${rowIdx}-${colIdx}`);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: `${(hiddenCols === null || hiddenCols === void 0 ? void 0 : hiddenCols.includes(colIdx)) ? "hiddenCol" : ""} ${row.includes("\u03A3") ? "font-bold bg-brandBlue-50" : ""}
                      py-3 px-2`,
                                        style: typeof colValue === "number" || colValue.includes("%") ? {
                                            textAlign: "right"
                                        } : {},
                                        rowSpan: z,
                                        colSpan: 1,
                                        children: typeof colValue === "number" && !(thisColName.toLowerCase().slice(0, 4) === "date") ? colValue.toLocaleString("de", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) : !colValue ? "" : colValue
                                    }, `rowKeyLabel${rowIdx}-${colIdx}`);
                                })
                            }, `row${rowIdx}`)),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    className: "text-left py-3.5 px-2",
                                    colSpan: columnNames.length - 1 - (hiddenCols || []).length,
                                    children: "Totals"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                    onClick: getClickHandler && getClickHandler(grandTotalAggregator.value(), [
                                        null
                                    ], [
                                        null
                                    ]),
                                    className: "px-2 text-right",
                                    children: grandTotalAggregator.format(grandTotalAggregator.value())
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$ef846b655465c549$var$ListRenderer.defaultProps = (0, $25ed1e0e429105db$exports.PivotData).defaultProps;
$ef846b655465c549$var$ListRenderer.propTypes = (0, $25ed1e0e429105db$exports.PivotData).propTypes;
var $ef846b655465c549$export$2e2bcd8739ae039 = {
    List: (0, $1b9d18dce12af9e0$export$2dcb0053efd21124)()($ef846b655465c549$var$ListRenderer)
};



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




/* eslint-disable react/prop-types */ /* eslint-disable react/no-unstable-nested-components */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function $8d60f2ee7fd1c983$export$71511d61b312f219() {
    $8d60f2ee7fd1c983$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d60f2ee7fd1c983$export$71511d61b312f219.apply(this, arguments);
}


function $7ae6b455e4a352e9$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
const $d72989d8b3846905$var$PUBLISH = 0;
const $d72989d8b3846905$var$SUBSCRIBE = 1;
const $d72989d8b3846905$var$RESET = 2;
const $d72989d8b3846905$var$VALUE = 4;
function $d72989d8b3846905$var$compose(a, b) {
    return (arg)=>a(b(arg));
}
function $d72989d8b3846905$var$thrush(arg, proc) {
    return proc(arg);
}
function $d72989d8b3846905$var$curry2to1(proc, arg1) {
    return (arg2)=>proc(arg1, arg2);
}
function $d72989d8b3846905$var$curry1to0(proc, arg) {
    return ()=>proc(arg);
}
function $d72989d8b3846905$var$tap(arg, proc) {
    proc(arg);
    return arg;
}
function $d72989d8b3846905$var$tup(...args) {
    return args;
}
function $d72989d8b3846905$var$call(proc) {
    proc();
}
function $d72989d8b3846905$var$always(value) {
    return ()=>value;
}
function $d72989d8b3846905$var$joinProc(...procs) {
    return ()=>{
        procs.map($d72989d8b3846905$var$call);
    };
}
function $d72989d8b3846905$var$isDefined(arg) {
    return arg !== void 0;
}
function $d72989d8b3846905$var$noop() {}
function $d72989d8b3846905$var$subscribe(emitter, subscription) {
    return emitter($d72989d8b3846905$var$SUBSCRIBE, subscription);
}
function $d72989d8b3846905$var$publish(publisher, value) {
    publisher($d72989d8b3846905$var$PUBLISH, value);
}
function $d72989d8b3846905$var$reset(emitter) {
    emitter($d72989d8b3846905$var$RESET);
}
function $d72989d8b3846905$var$getValue(depot) {
    return depot($d72989d8b3846905$var$VALUE);
}
function $d72989d8b3846905$var$connect(emitter, publisher) {
    return $d72989d8b3846905$var$subscribe(emitter, $d72989d8b3846905$var$curry2to1(publisher, $d72989d8b3846905$var$PUBLISH));
}
function $d72989d8b3846905$var$handleNext(emitter, subscription) {
    const unsub = emitter($d72989d8b3846905$var$SUBSCRIBE, (value)=>{
        unsub();
        subscription(value);
    });
    return unsub;
}
function $d72989d8b3846905$var$stream() {
    const subscriptions = [];
    return (action, arg)=>{
        switch(action){
            case $d72989d8b3846905$var$RESET:
                subscriptions.splice(0, subscriptions.length);
                return;
            case $d72989d8b3846905$var$SUBSCRIBE:
                subscriptions.push(arg);
                return ()=>{
                    const indexOf = subscriptions.indexOf(arg);
                    if (indexOf > -1) subscriptions.splice(indexOf, 1);
                };
            case $d72989d8b3846905$var$PUBLISH:
                subscriptions.slice().forEach((subscription)=>{
                    subscription(arg);
                });
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $d72989d8b3846905$var$statefulStream(initial) {
    let value = initial;
    const innerSubject = $d72989d8b3846905$var$stream();
    return (action, arg)=>{
        switch(action){
            case $d72989d8b3846905$var$SUBSCRIBE:
                const subscription = arg;
                subscription(value);
                break;
            case $d72989d8b3846905$var$PUBLISH:
                value = arg;
                break;
            case $d72989d8b3846905$var$VALUE:
                return value;
        }
        return innerSubject(action, arg);
    };
}
function $d72989d8b3846905$var$eventHandler(emitter) {
    let unsub;
    let currentSubscription;
    const cleanup = ()=>unsub && unsub();
    return function(action, subscription) {
        switch(action){
            case $d72989d8b3846905$var$SUBSCRIBE:
                if (subscription) {
                    if (currentSubscription === subscription) return;
                    cleanup();
                    currentSubscription = subscription;
                    unsub = $d72989d8b3846905$var$subscribe(emitter, subscription);
                    return unsub;
                } else {
                    cleanup();
                    return $d72989d8b3846905$var$noop;
                }
            case $d72989d8b3846905$var$RESET:
                cleanup();
                currentSubscription = null;
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $d72989d8b3846905$var$streamFromEmitter(emitter) {
    return $d72989d8b3846905$var$tap($d72989d8b3846905$var$stream(), (stream2)=>$d72989d8b3846905$var$connect(emitter, stream2));
}
function $d72989d8b3846905$var$statefulStreamFromEmitter(emitter, initial) {
    return $d72989d8b3846905$var$tap($d72989d8b3846905$var$statefulStream(initial), (stream2)=>$d72989d8b3846905$var$connect(emitter, stream2));
}
function $d72989d8b3846905$var$combineOperators(...operators) {
    return (subscriber)=>{
        return operators.reduceRight($d72989d8b3846905$var$thrush, subscriber);
    };
}
function $d72989d8b3846905$var$pipe(source, ...operators) {
    const project = $d72989d8b3846905$var$combineOperators(...operators);
    return (action, subscription)=>{
        switch(action){
            case $d72989d8b3846905$var$SUBSCRIBE:
                return $d72989d8b3846905$var$subscribe(source, project(subscription));
            case $d72989d8b3846905$var$RESET:
                $d72989d8b3846905$var$reset(source);
                return;
        }
    };
}
function $d72989d8b3846905$var$defaultComparator(previous, next) {
    return previous === next;
}
function $d72989d8b3846905$var$distinctUntilChanged(comparator = $d72989d8b3846905$var$defaultComparator) {
    let current;
    return (done)=>(next)=>{
            if (!comparator(current, next)) {
                current = next;
                done(next);
            }
        };
}
function $d72989d8b3846905$var$filter(predicate) {
    return (done)=>(value)=>{
            predicate(value) && done(value);
        };
}
function $d72989d8b3846905$var$map(project) {
    return (done)=>$d72989d8b3846905$var$compose(done, project);
}
function $d72989d8b3846905$var$mapTo(value) {
    return (done)=>()=>done(value);
}
function $d72989d8b3846905$var$scan(scanner, initial) {
    return (done)=>(value)=>done(initial = scanner(initial, value));
}
function $d72989d8b3846905$var$skip(times) {
    return (done)=>(value)=>{
            times > 0 ? times-- : done(value);
        };
}
function $d72989d8b3846905$var$throttleTime(interval) {
    let currentValue = null;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) return;
            timeout = setTimeout(()=>{
                timeout = void 0;
                done(currentValue);
            }, interval);
        };
}
function $d72989d8b3846905$var$debounceTime(interval) {
    let currentValue;
    let timeout;
    return (done)=>(value)=>{
            currentValue = value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                done(currentValue);
            }, interval);
        };
}
function $d72989d8b3846905$var$withLatestFrom(...sources) {
    const values = new Array(sources.length);
    let called = 0;
    let pendingCall = null;
    const allCalled = Math.pow(2, sources.length) - 1;
    sources.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $d72989d8b3846905$var$subscribe(source, (value)=>{
            const prevCalled = called;
            called = called | bit;
            values[index] = value;
            if (prevCalled !== allCalled && called === allCalled && pendingCall) {
                pendingCall();
                pendingCall = null;
            }
        });
    });
    return (done)=>(value)=>{
            const call2 = ()=>done([
                    value
                ].concat(values));
            if (called === allCalled) call2();
            else pendingCall = call2;
        };
}
function $d72989d8b3846905$var$merge(...sources) {
    return function(action, subscription) {
        switch(action){
            case $d72989d8b3846905$var$SUBSCRIBE:
                return $d72989d8b3846905$var$joinProc(...sources.map((source)=>$d72989d8b3846905$var$subscribe(source, subscription)));
            case $d72989d8b3846905$var$RESET:
                return;
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $d72989d8b3846905$var$duc(source, comparator = $d72989d8b3846905$var$defaultComparator) {
    return $d72989d8b3846905$var$pipe(source, $d72989d8b3846905$var$distinctUntilChanged(comparator));
}
function $d72989d8b3846905$var$combineLatest(...emitters) {
    const innerSubject = $d72989d8b3846905$var$stream();
    const values = new Array(emitters.length);
    let called = 0;
    const allCalled = Math.pow(2, emitters.length) - 1;
    emitters.forEach((source, index)=>{
        const bit = Math.pow(2, index);
        $d72989d8b3846905$var$subscribe(source, (value)=>{
            values[index] = value;
            called = called | bit;
            if (called === allCalled) $d72989d8b3846905$var$publish(innerSubject, values);
        });
    });
    return function(action, subscription) {
        switch(action){
            case $d72989d8b3846905$var$SUBSCRIBE:
                if (called === allCalled) subscription(values);
                return $d72989d8b3846905$var$subscribe(innerSubject, subscription);
            case $d72989d8b3846905$var$RESET:
                return $d72989d8b3846905$var$reset(innerSubject);
            default:
                throw new Error(`unrecognized action ${action}`);
        }
    };
}
function $d72989d8b3846905$var$system(constructor, dependencies = [], { singleton: singleton } = {
    singleton: true
}) {
    return {
        id: $d72989d8b3846905$var$id(),
        constructor: constructor,
        dependencies: dependencies,
        singleton: singleton
    };
}
const $d72989d8b3846905$var$id = ()=>Symbol();
function $d72989d8b3846905$var$init(systemSpec) {
    const singletons = /* @__PURE__ */ new Map();
    const _init = ({ id: id2, constructor: constructor, dependencies: dependencies, singleton: singleton })=>{
        if (singleton && singletons.has(id2)) return singletons.get(id2);
        const system2 = constructor(dependencies.map((e)=>_init(e)));
        if (singleton) singletons.set(id2, system2);
        return system2;
    };
    return _init(systemSpec);
}
function $d72989d8b3846905$var$omit(keys, obj) {
    const result = {};
    const index = {};
    let idx = 0;
    const len = keys.length;
    while(idx < len){
        index[keys[idx]] = 1;
        idx += 1;
    }
    for(const prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
}
const $d72989d8b3846905$var$useIsomorphicLayoutEffect$1 = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect;
function $d72989d8b3846905$var$systemToComponent(systemSpec, map2, Root) {
    const requiredPropNames = Object.keys(map2.required || {});
    const optionalPropNames = Object.keys(map2.optional || {});
    const methodNames = Object.keys(map2.methods || {});
    const eventNames = Object.keys(map2.events || {});
    const Context = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({});
    function applyPropsToSystem(system2, props) {
        if (system2["propsReady"]) $d72989d8b3846905$var$publish(system2["propsReady"], false);
        for (const requiredPropName of requiredPropNames){
            const stream2 = system2[map2.required[requiredPropName]];
            $d72989d8b3846905$var$publish(stream2, props[requiredPropName]);
        }
        for (const optionalPropName of optionalPropNames)if (optionalPropName in props) {
            const stream2 = system2[map2.optional[optionalPropName]];
            $d72989d8b3846905$var$publish(stream2, props[optionalPropName]);
        }
        if (system2["propsReady"]) $d72989d8b3846905$var$publish(system2["propsReady"], true);
    }
    function buildMethods(system2) {
        return methodNames.reduce((acc, methodName)=>{
            acc[methodName] = (value)=>{
                const stream2 = system2[map2.methods[methodName]];
                $d72989d8b3846905$var$publish(stream2, value);
            };
            return acc;
        }, {});
    }
    function buildEventHandlers(system2) {
        return eventNames.reduce((handlers, eventName)=>{
            handlers[eventName] = $d72989d8b3846905$var$eventHandler(system2[map2.events[eventName]]);
            return handlers;
        }, {});
    }
    const Component = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((propsWithChildren, ref)=>{
        const { children: children } = propsWithChildren, props = (0, $bLhVg._)(propsWithChildren, [
            "children"
        ]);
        const [system2] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(()=>{
            return $d72989d8b3846905$var$tap($d72989d8b3846905$var$init(systemSpec), (system22)=>applyPropsToSystem(system22, props));
        });
        const [handlers] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState($d72989d8b3846905$var$curry1to0(buildEventHandlers, system2));
        $d72989d8b3846905$var$useIsomorphicLayoutEffect$1(()=>{
            for (const eventName of eventNames)if (eventName in props) $d72989d8b3846905$var$subscribe(handlers[eventName], props[eventName]);
            return ()=>{
                Object.values(handlers).map($d72989d8b3846905$var$reset);
            };
        }, [
            props,
            handlers,
            system2
        ]);
        $d72989d8b3846905$var$useIsomorphicLayoutEffect$1(()=>{
            applyPropsToSystem(system2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useImperativeHandle(ref, $d72989d8b3846905$var$always(buildMethods(system2)));
        const RootComponent = Root;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Context.Provider, {
            value: system2,
            children: Root ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(RootComponent, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$omit([
                ...requiredPropNames,
                ...optionalPropNames,
                ...eventNames
            ], props)), {
                children: children
            })) : children
        });
    });
    const usePublisher2 = (key)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback($d72989d8b3846905$var$curry2to1($d72989d8b3846905$var$publish, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext(Context)[key]), [
            key
        ]);
    };
    const useEmitterValue18 = (key)=>{
        const system2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext(Context);
        const source = system2[key];
        const cb = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((c)=>{
            return $d72989d8b3846905$var$subscribe(source, c);
        }, [
            source
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useSyncExternalStore(cb, ()=>$d72989d8b3846905$var$getValue(source), ()=>$d72989d8b3846905$var$getValue(source));
    };
    const useEmitterValueLegacy = (key)=>{
        const system2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext(Context);
        const source = system2[key];
        const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState($d72989d8b3846905$var$curry1to0($d72989d8b3846905$var$getValue, source));
        $d72989d8b3846905$var$useIsomorphicLayoutEffect$1(()=>$d72989d8b3846905$var$subscribe(source, (next)=>{
                if (next !== value) setValue($d72989d8b3846905$var$always(next));
            }), [
            source,
            value
        ]);
        return value;
    };
    const useEmitterValue2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).version.startsWith("18") ? useEmitterValue18 : useEmitterValueLegacy;
    const useEmitter2 = (key, callback)=>{
        const context = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext(Context);
        const source = context[key];
        $d72989d8b3846905$var$useIsomorphicLayoutEffect$1(()=>$d72989d8b3846905$var$subscribe(source, callback), [
            callback,
            source
        ]);
    };
    return {
        Component: Component,
        usePublisher: usePublisher2,
        useEmitterValue: useEmitterValue2,
        useEmitter: useEmitter2
    };
}
const $d72989d8b3846905$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect;
var $d72989d8b3846905$export$243e62d78d3b544d = /* @__PURE__ */ ((LogLevel2)=>{
    LogLevel2[LogLevel2["DEBUG"] = 0] = "DEBUG";
    LogLevel2[LogLevel2["INFO"] = 1] = "INFO";
    LogLevel2[LogLevel2["WARN"] = 2] = "WARN";
    LogLevel2[LogLevel2["ERROR"] = 3] = "ERROR";
    return LogLevel2;
})($d72989d8b3846905$export$243e62d78d3b544d || {});
const $d72989d8b3846905$var$CONSOLE_METHOD_MAP = {
    [0]: "debug",
    [1]: "log",
    [2]: "warn",
    [3]: "error"
};
const $d72989d8b3846905$var$getGlobalThis = ()=>typeof globalThis === "undefined" ? window : globalThis;
const $d72989d8b3846905$var$loggerSystem = $d72989d8b3846905$var$system(()=>{
    const logLevel = $d72989d8b3846905$var$statefulStream(3);
    const log = $d72989d8b3846905$var$statefulStream((label, message, level = 1)=>{
        var _a;
        const currentLevel = (_a = $d72989d8b3846905$var$getGlobalThis()["VIRTUOSO_LOG_LEVEL"]) != null ? _a : $d72989d8b3846905$var$getValue(logLevel);
        if (level >= currentLevel) console[$d72989d8b3846905$var$CONSOLE_METHOD_MAP[level]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", label, message);
    });
    return {
        log: log,
        logLevel: logLevel
    };
}, [], {
    singleton: true
});
function $d72989d8b3846905$var$useSizeWithElRef(callback, enabled, skipAnimationFrame) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    let callbackRef = (_el)=>{};
    if (typeof ResizeObserver !== "undefined") {
        const observer = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
            return new ResizeObserver((entries)=>{
                const code = ()=>{
                    const element = entries[0].target;
                    if (element.offsetParent !== null) callback(element);
                };
                skipAnimationFrame ? code() : requestAnimationFrame(code);
            });
        }, [
            callback
        ]);
        callbackRef = (elRef)=>{
            if (elRef && enabled) {
                observer.observe(elRef);
                ref.current = elRef;
            } else {
                if (ref.current) observer.unobserve(ref.current);
                ref.current = null;
            }
        };
    }
    return {
        ref: ref,
        callbackRef: callbackRef
    };
}
function $d72989d8b3846905$var$useSize(callback, enabled, skipAnimationFrame) {
    return $d72989d8b3846905$var$useSizeWithElRef(callback, enabled, skipAnimationFrame).callbackRef;
}
function $d72989d8b3846905$var$useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent, horizontalDirection, skipAnimationFrame) {
    const memoedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((el)=>{
        const ranges = $d72989d8b3846905$var$getChangedChildSizes(el.children, itemSize, horizontalDirection ? "offsetWidth" : "offsetHeight", log);
        let scrollableElement = el.parentElement;
        while(!scrollableElement.dataset["virtuosoScroller"])scrollableElement = scrollableElement.parentElement;
        const windowScrolling = scrollableElement.lastElementChild.dataset["viewportType"] === "window";
        const scrollTop = customScrollParent ? horizontalDirection ? customScrollParent.scrollLeft : customScrollParent.scrollTop : windowScrolling ? horizontalDirection ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : horizontalDirection ? scrollableElement.scrollLeft : scrollableElement.scrollTop;
        const scrollHeight = customScrollParent ? horizontalDirection ? customScrollParent.scrollWidth : customScrollParent.scrollHeight : windowScrolling ? horizontalDirection ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : horizontalDirection ? scrollableElement.scrollWidth : scrollableElement.scrollHeight;
        const viewportHeight = customScrollParent ? horizontalDirection ? customScrollParent.offsetWidth : customScrollParent.offsetHeight : windowScrolling ? horizontalDirection ? window.innerWidth : window.innerHeight : horizontalDirection ? scrollableElement.offsetWidth : scrollableElement.offsetHeight;
        scrollContainerStateCallback({
            scrollTop: Math.max(scrollTop, 0),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        });
        gap == null || gap(horizontalDirection ? $d72989d8b3846905$var$resolveGapValue$1("column-gap", getComputedStyle(el).columnGap, log) : $d72989d8b3846905$var$resolveGapValue$1("row-gap", getComputedStyle(el).rowGap, log));
        if (ranges !== null) callback(ranges);
    }, [
        callback,
        itemSize,
        log,
        gap,
        customScrollParent,
        scrollContainerStateCallback
    ]);
    return $d72989d8b3846905$var$useSizeWithElRef(memoedCallback, enabled, skipAnimationFrame);
}
function $d72989d8b3846905$var$getChangedChildSizes(children, itemSize, field, log) {
    const length = children.length;
    if (length === 0) return null;
    const results = [];
    for(let i = 0; i < length; i++){
        const child = children.item(i);
        if (!child || child.dataset.index === void 0) continue;
        const index = parseInt(child.dataset.index);
        const knownSize = parseFloat(child.dataset.knownSize);
        const size = itemSize(child, field);
        if (size === 0) log("Zero-sized element, this should not happen", {
            child: child
        }, $d72989d8b3846905$export$243e62d78d3b544d.ERROR);
        if (size === knownSize) continue;
        const lastResult = results[results.length - 1];
        if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) results.push({
            startIndex: index,
            endIndex: index,
            size: size
        });
        else results[results.length - 1].endIndex++;
    }
    return results;
}
function $d72989d8b3846905$var$resolveGapValue$1(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $d72989d8b3846905$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
function $d72989d8b3846905$var$correctItemSize(el, dimension) {
    return Math.round(el.getBoundingClientRect()[dimension]);
}
function $d72989d8b3846905$var$approximatelyEqual(num1, num2) {
    return Math.abs(num1 - num2) < 1.01;
}
function $d72989d8b3846905$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, scrollerElement, scrollerRefCallback = $d72989d8b3846905$var$noop, customScrollParent, horizontalDirection) {
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const scrollTopTarget = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const handler = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((ev)=>{
        const el = ev.target;
        const windowScroll = el === window || el === document;
        const scrollTop = horizontalDirection ? windowScroll ? window.pageXOffset || document.documentElement.scrollLeft : el.scrollLeft : windowScroll ? window.pageYOffset || document.documentElement.scrollTop : el.scrollTop;
        const scrollHeight = horizontalDirection ? windowScroll ? document.documentElement.scrollWidth : el.scrollWidth : windowScroll ? document.documentElement.scrollHeight : el.scrollHeight;
        const viewportHeight = horizontalDirection ? windowScroll ? window.innerWidth : el.offsetWidth : windowScroll ? window.innerHeight : el.offsetHeight;
        const call2 = ()=>{
            scrollContainerStateCallback({
                scrollTop: Math.max(scrollTop, 0),
                scrollHeight: scrollHeight,
                viewportHeight: viewportHeight
            });
        };
        if (ev.suppressFlushSync) call2();
        else (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).flushSync(call2);
        if (scrollTopTarget.current !== null) {
            if (scrollTop === scrollTopTarget.current || scrollTop <= 0 || scrollTop === scrollHeight - viewportHeight) {
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            }
        }
    }, [
        scrollContainerStateCallback,
        smoothScrollTargetReached
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const localRef = customScrollParent ? customScrollParent : scrollerRef.current;
        scrollerRefCallback(customScrollParent ? customScrollParent : scrollerRef.current);
        handler({
            target: localRef,
            suppressFlushSync: true
        });
        localRef.addEventListener("scroll", handler, {
            passive: true
        });
        return ()=>{
            scrollerRefCallback(null);
            localRef.removeEventListener("scroll", handler);
        };
    }, [
        scrollerRef,
        handler,
        scrollerElement,
        scrollerRefCallback,
        customScrollParent
    ]);
    function scrollToCallback(location) {
        const scrollerElement2 = scrollerRef.current;
        if (!scrollerElement2 || (horizontalDirection ? "offsetWidth" in scrollerElement2 && scrollerElement2.offsetWidth === 0 : "offsetHeight" in scrollerElement2 && scrollerElement2.offsetHeight === 0)) return;
        const isSmooth = location.behavior === "smooth";
        let offsetHeight;
        let scrollHeight;
        let scrollTop;
        if (scrollerElement2 === window) {
            scrollHeight = Math.max($d72989d8b3846905$var$correctItemSize(document.documentElement, horizontalDirection ? "width" : "height"), horizontalDirection ? document.documentElement.scrollWidth : document.documentElement.scrollHeight);
            offsetHeight = horizontalDirection ? window.innerWidth : window.innerHeight;
            scrollTop = horizontalDirection ? document.documentElement.scrollLeft : document.documentElement.scrollTop;
        } else {
            scrollHeight = scrollerElement2[horizontalDirection ? "scrollWidth" : "scrollHeight"];
            offsetHeight = $d72989d8b3846905$var$correctItemSize(scrollerElement2, horizontalDirection ? "width" : "height");
            scrollTop = scrollerElement2[horizontalDirection ? "scrollLeft" : "scrollTop"];
        }
        const maxScrollTop = scrollHeight - offsetHeight;
        location.top = Math.ceil(Math.max(Math.min(maxScrollTop, location.top), 0));
        if ($d72989d8b3846905$var$approximatelyEqual(offsetHeight, scrollHeight) || location.top === scrollTop) {
            scrollContainerStateCallback({
                scrollTop: scrollTop,
                scrollHeight: scrollHeight,
                viewportHeight: offsetHeight
            });
            if (isSmooth) smoothScrollTargetReached(true);
            return;
        }
        if (isSmooth) {
            scrollTopTarget.current = location.top;
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                timeoutRef.current = null;
                scrollTopTarget.current = null;
                smoothScrollTargetReached(true);
            }, 1e3);
        } else scrollTopTarget.current = null;
        if (horizontalDirection) location = {
            left: location.top,
            behavior: location.behavior
        };
        scrollerElement2.scrollTo(location);
    }
    function scrollByCallback(location) {
        if (horizontalDirection) location = {
            left: location.top,
            behavior: location.behavior
        };
        scrollerRef.current.scrollBy(location);
    }
    return {
        scrollerRef: scrollerRef,
        scrollByCallback: scrollByCallback,
        scrollToCallback: scrollToCallback
    };
}
const $d72989d8b3846905$var$domIOSystem = $d72989d8b3846905$var$system(()=>{
    const scrollContainerState = $d72989d8b3846905$var$stream();
    const scrollTop = $d72989d8b3846905$var$stream();
    const deviation = $d72989d8b3846905$var$statefulStream(0);
    const smoothScrollTargetReached = $d72989d8b3846905$var$stream();
    const statefulScrollTop = $d72989d8b3846905$var$statefulStream(0);
    const viewportHeight = $d72989d8b3846905$var$stream();
    const scrollHeight = $d72989d8b3846905$var$stream();
    const headerHeight = $d72989d8b3846905$var$statefulStream(0);
    const fixedHeaderHeight = $d72989d8b3846905$var$statefulStream(0);
    const fixedFooterHeight = $d72989d8b3846905$var$statefulStream(0);
    const footerHeight = $d72989d8b3846905$var$statefulStream(0);
    const scrollTo = $d72989d8b3846905$var$stream();
    const scrollBy = $d72989d8b3846905$var$stream();
    const scrollingInProgress = $d72989d8b3846905$var$statefulStream(false);
    const horizontalDirection = $d72989d8b3846905$var$statefulStream(false);
    const skipAnimationFrameInResizeObserver = $d72989d8b3846905$var$statefulStream(false);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollContainerState, $d72989d8b3846905$var$map(({ scrollTop: scrollTop2 })=>scrollTop2)), scrollTop);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollContainerState, $d72989d8b3846905$var$map(({ scrollHeight: scrollHeight2 })=>scrollHeight2)), scrollHeight);
    $d72989d8b3846905$var$connect(scrollTop, statefulScrollTop);
    return {
        scrollContainerState: // input
        scrollContainerState,
        scrollTop: scrollTop,
        viewportHeight: viewportHeight,
        headerHeight: headerHeight,
        fixedHeaderHeight: fixedHeaderHeight,
        fixedFooterHeight: fixedFooterHeight,
        footerHeight: footerHeight,
        scrollHeight: scrollHeight,
        smoothScrollTargetReached: smoothScrollTargetReached,
        horizontalDirection: horizontalDirection,
        skipAnimationFrameInResizeObserver: skipAnimationFrameInResizeObserver,
        scrollTo: // signals
        scrollTo,
        scrollBy: scrollBy,
        statefulScrollTop: // state
        statefulScrollTop,
        deviation: deviation,
        scrollingInProgress: scrollingInProgress
    };
}, [], {
    singleton: true
});
const $d72989d8b3846905$var$NIL_NODE = {
    lvl: 0
};
function $d72989d8b3846905$var$newAANode(k, v, lvl, l = $d72989d8b3846905$var$NIL_NODE, r = $d72989d8b3846905$var$NIL_NODE) {
    return {
        k: k,
        v: v,
        lvl: lvl,
        l: l,
        r: r
    };
}
function $d72989d8b3846905$var$empty(node) {
    return node === $d72989d8b3846905$var$NIL_NODE;
}
function $d72989d8b3846905$var$newTree() {
    return $d72989d8b3846905$var$NIL_NODE;
}
function $d72989d8b3846905$var$remove(node, key) {
    if ($d72989d8b3846905$var$empty(node)) return $d72989d8b3846905$var$NIL_NODE;
    const { k: k, l: l, r: r } = node;
    if (key === k) {
        if ($d72989d8b3846905$var$empty(l)) return r;
        else if ($d72989d8b3846905$var$empty(r)) return l;
        else {
            const [lastKey, lastValue] = $d72989d8b3846905$var$last(l);
            return $d72989d8b3846905$var$adjust($d72989d8b3846905$var$clone(node, {
                k: lastKey,
                v: lastValue,
                l: $d72989d8b3846905$var$deleteLast(l)
            }));
        }
    } else if (key < k) return $d72989d8b3846905$var$adjust($d72989d8b3846905$var$clone(node, {
        l: $d72989d8b3846905$var$remove(l, key)
    }));
    else return $d72989d8b3846905$var$adjust($d72989d8b3846905$var$clone(node, {
        r: $d72989d8b3846905$var$remove(r, key)
    }));
}
function $d72989d8b3846905$var$find(node, key) {
    if ($d72989d8b3846905$var$empty(node)) return;
    if (key === node.k) return node.v;
    else if (key < node.k) return $d72989d8b3846905$var$find(node.l, key);
    else return $d72989d8b3846905$var$find(node.r, key);
}
function $d72989d8b3846905$var$findMaxKeyValue(node, value, field = "k") {
    if ($d72989d8b3846905$var$empty(node)) return [
        -Infinity,
        void 0
    ];
    if (Number(node[field]) === value) return [
        node.k,
        node.v
    ];
    if (Number(node[field]) < value) {
        const r = $d72989d8b3846905$var$findMaxKeyValue(node.r, value, field);
        if (r[0] === -Infinity) return [
            node.k,
            node.v
        ];
        else return r;
    }
    return $d72989d8b3846905$var$findMaxKeyValue(node.l, value, field);
}
function $d72989d8b3846905$var$insert(node, k, v) {
    if ($d72989d8b3846905$var$empty(node)) return $d72989d8b3846905$var$newAANode(k, v, 1);
    if (k === node.k) return $d72989d8b3846905$var$clone(node, {
        k: k,
        v: v
    });
    else if (k < node.k) return $d72989d8b3846905$var$rebalance($d72989d8b3846905$var$clone(node, {
        l: $d72989d8b3846905$var$insert(node.l, k, v)
    }));
    else return $d72989d8b3846905$var$rebalance($d72989d8b3846905$var$clone(node, {
        r: $d72989d8b3846905$var$insert(node.r, k, v)
    }));
}
function $d72989d8b3846905$var$walkWithin(node, start, end) {
    if ($d72989d8b3846905$var$empty(node)) return [];
    const { k: k, v: v, l: l, r: r } = node;
    let result = [];
    if (k > start) result = result.concat($d72989d8b3846905$var$walkWithin(l, start, end));
    if (k >= start && k <= end) result.push({
        k: k,
        v: v
    });
    if (k <= end) result = result.concat($d72989d8b3846905$var$walkWithin(r, start, end));
    return result;
}
function $d72989d8b3846905$var$walk(node) {
    if ($d72989d8b3846905$var$empty(node)) return [];
    return [
        ...$d72989d8b3846905$var$walk(node.l),
        {
            k: node.k,
            v: node.v
        },
        ...$d72989d8b3846905$var$walk(node.r)
    ];
}
function $d72989d8b3846905$var$last(node) {
    return $d72989d8b3846905$var$empty(node.r) ? [
        node.k,
        node.v
    ] : $d72989d8b3846905$var$last(node.r);
}
function $d72989d8b3846905$var$deleteLast(node) {
    return $d72989d8b3846905$var$empty(node.r) ? node.l : $d72989d8b3846905$var$adjust($d72989d8b3846905$var$clone(node, {
        r: $d72989d8b3846905$var$deleteLast(node.r)
    }));
}
function $d72989d8b3846905$var$clone(node, args) {
    return $d72989d8b3846905$var$newAANode(args.k !== void 0 ? args.k : node.k, args.v !== void 0 ? args.v : node.v, args.lvl !== void 0 ? args.lvl : node.lvl, args.l !== void 0 ? args.l : node.l, args.r !== void 0 ? args.r : node.r);
}
function $d72989d8b3846905$var$isSingle(node) {
    return $d72989d8b3846905$var$empty(node) || node.lvl > node.r.lvl;
}
function $d72989d8b3846905$var$rebalance(node) {
    return $d72989d8b3846905$var$split($d72989d8b3846905$var$skew(node));
}
function $d72989d8b3846905$var$adjust(node) {
    const { l: l, r: r, lvl: lvl } = node;
    if (r.lvl >= lvl - 1 && l.lvl >= lvl - 1) return node;
    else if (lvl > r.lvl + 1) {
        if ($d72989d8b3846905$var$isSingle(l)) return $d72989d8b3846905$var$skew($d72989d8b3846905$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$d72989d8b3846905$var$empty(l) && !$d72989d8b3846905$var$empty(l.r)) return $d72989d8b3846905$var$clone(l.r, {
                l: $d72989d8b3846905$var$clone(l, {
                    r: l.r.l
                }),
                r: $d72989d8b3846905$var$clone(node, {
                    l: l.r.r,
                    lvl: lvl - 1
                }),
                lvl: lvl
            });
            else throw new Error("Unexpected empty nodes");
        }
    } else {
        if ($d72989d8b3846905$var$isSingle(node)) return $d72989d8b3846905$var$split($d72989d8b3846905$var$clone(node, {
            lvl: lvl - 1
        }));
        else {
            if (!$d72989d8b3846905$var$empty(r) && !$d72989d8b3846905$var$empty(r.l)) {
                const rl = r.l;
                const rlvl = $d72989d8b3846905$var$isSingle(rl) ? r.lvl - 1 : r.lvl;
                return $d72989d8b3846905$var$clone(rl, {
                    l: $d72989d8b3846905$var$clone(node, {
                        r: rl.l,
                        lvl: lvl - 1
                    }),
                    r: $d72989d8b3846905$var$split($d72989d8b3846905$var$clone(r, {
                        l: rl.r,
                        lvl: rlvl
                    })),
                    lvl: rl.lvl + 1
                });
            } else throw new Error("Unexpected empty nodes");
        }
    }
}
function $d72989d8b3846905$var$rangesWithin(node, startIndex, endIndex) {
    if ($d72989d8b3846905$var$empty(node)) return [];
    const adjustedStart = $d72989d8b3846905$var$findMaxKeyValue(node, startIndex)[0];
    return $d72989d8b3846905$var$toRanges($d72989d8b3846905$var$walkWithin(node, adjustedStart, endIndex));
}
function $d72989d8b3846905$var$arrayToRanges(items, parser) {
    const length = items.length;
    if (length === 0) return [];
    let { index: start, value: value } = parser(items[0]);
    const result = [];
    for(let i = 1; i < length; i++){
        const { index: nextIndex, value: nextValue } = parser(items[i]);
        result.push({
            start: start,
            end: nextIndex - 1,
            value: value
        });
        start = nextIndex;
        value = nextValue;
    }
    result.push({
        start: start,
        end: Infinity,
        value: value
    });
    return result;
}
function $d72989d8b3846905$var$toRanges(nodes) {
    return $d72989d8b3846905$var$arrayToRanges(nodes, ({ k: index, v: value })=>({
            index: index,
            value: value
        }));
}
function $d72989d8b3846905$var$split(node) {
    const { r: r, lvl: lvl } = node;
    return !$d72989d8b3846905$var$empty(r) && !$d72989d8b3846905$var$empty(r.r) && r.lvl === lvl && r.r.lvl === lvl ? $d72989d8b3846905$var$clone(r, {
        l: $d72989d8b3846905$var$clone(node, {
            r: r.l
        }),
        lvl: lvl + 1
    }) : node;
}
function $d72989d8b3846905$var$skew(node) {
    const { l: l } = node;
    return !$d72989d8b3846905$var$empty(l) && l.lvl === node.lvl ? $d72989d8b3846905$var$clone(l, {
        r: $d72989d8b3846905$var$clone(node, {
            l: l.r
        })
    }) : node;
}
function $d72989d8b3846905$var$findIndexOfClosestSmallerOrEqual(items, value, comparator, start = 0) {
    let end = items.length - 1;
    while(start <= end){
        const index = Math.floor((start + end) / 2);
        const item = items[index];
        const match = comparator(item, value);
        if (match === 0) return index;
        if (match === -1) {
            if (end - start < 2) return index - 1;
            end = index - 1;
        } else {
            if (end === start) return index;
            start = index + 1;
        }
    }
    throw new Error(`Failed binary finding record in array - ${items.join(",")}, searched for ${value}`);
}
function $d72989d8b3846905$var$findClosestSmallerOrEqual(items, value, comparator) {
    return items[$d72989d8b3846905$var$findIndexOfClosestSmallerOrEqual(items, value, comparator)];
}
function $d72989d8b3846905$var$findRange(items, startValue, endValue, comparator) {
    const startIndex = $d72989d8b3846905$var$findIndexOfClosestSmallerOrEqual(items, startValue, comparator);
    const endIndex = $d72989d8b3846905$var$findIndexOfClosestSmallerOrEqual(items, endValue, comparator, startIndex);
    return items.slice(startIndex, endIndex + 1);
}
const $d72989d8b3846905$var$recalcSystem = $d72989d8b3846905$var$system(()=>{
    const recalcInProgress = $d72989d8b3846905$var$statefulStream(false);
    return {
        recalcInProgress: recalcInProgress
    };
}, [], {
    singleton: true
});
function $d72989d8b3846905$var$rangeIncludes(refRange) {
    const { size: size, startIndex: startIndex, endIndex: endIndex } = refRange;
    return (range)=>{
        return range.start === startIndex && (range.end === endIndex || range.end === Infinity) && range.value === size;
    };
}
function $d72989d8b3846905$var$affectedGroupCount(offset, groupIndices) {
    let recognizedOffsetItems = 0;
    let groupIndex = 0;
    while(recognizedOffsetItems < offset){
        recognizedOffsetItems += groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
        groupIndex++;
    }
    const offsetIsExact = recognizedOffsetItems === offset;
    return groupIndex - (offsetIsExact ? 0 : 1);
}
function $d72989d8b3846905$var$insertRanges(sizeTree, ranges) {
    let syncStart = $d72989d8b3846905$var$empty(sizeTree) ? 0 : Infinity;
    for (const range of ranges){
        const { size: size, startIndex: startIndex, endIndex: endIndex } = range;
        syncStart = Math.min(syncStart, startIndex);
        if ($d72989d8b3846905$var$empty(sizeTree)) {
            sizeTree = $d72989d8b3846905$var$insert(sizeTree, 0, size);
            continue;
        }
        const overlappingRanges = $d72989d8b3846905$var$rangesWithin(sizeTree, startIndex - 1, endIndex + 1);
        if (overlappingRanges.some($d72989d8b3846905$var$rangeIncludes(range))) continue;
        let firstPassDone = false;
        let shouldInsert = false;
        for (const { start: rangeStart, end: rangeEnd, value: rangeValue } of overlappingRanges){
            if (!firstPassDone) {
                shouldInsert = rangeValue !== size;
                firstPassDone = true;
            } else if (endIndex >= rangeStart || size === rangeValue) sizeTree = $d72989d8b3846905$var$remove(sizeTree, rangeStart);
            if (rangeEnd > endIndex && endIndex >= rangeStart) {
                if (rangeValue !== size) sizeTree = $d72989d8b3846905$var$insert(sizeTree, endIndex + 1, rangeValue);
            }
        }
        if (shouldInsert) sizeTree = $d72989d8b3846905$var$insert(sizeTree, startIndex, size);
    }
    return [
        sizeTree,
        syncStart
    ];
}
function $d72989d8b3846905$var$initialSizeState() {
    return {
        offsetTree: [],
        sizeTree: $d72989d8b3846905$var$newTree(),
        groupOffsetTree: $d72989d8b3846905$var$newTree(),
        lastIndex: 0,
        lastOffset: 0,
        lastSize: 0,
        groupIndices: []
    };
}
function $d72989d8b3846905$var$indexComparator({ index: itemIndex }, index) {
    return index === itemIndex ? 0 : index < itemIndex ? -1 : 1;
}
function $d72989d8b3846905$var$offsetComparator({ offset: itemOffset }, offset) {
    return offset === itemOffset ? 0 : offset < itemOffset ? -1 : 1;
}
function $d72989d8b3846905$var$offsetPointParser(point) {
    return {
        index: point.index,
        value: point
    };
}
function $d72989d8b3846905$var$rangesWithinOffsets(tree, startOffset, endOffset, minStartIndex = 0) {
    if (minStartIndex > 0) startOffset = Math.max(startOffset, $d72989d8b3846905$var$findClosestSmallerOrEqual(tree, minStartIndex, $d72989d8b3846905$var$indexComparator).offset);
    return $d72989d8b3846905$var$arrayToRanges($d72989d8b3846905$var$findRange(tree, startOffset, endOffset, $d72989d8b3846905$var$offsetComparator), $d72989d8b3846905$var$offsetPointParser);
}
function $d72989d8b3846905$var$createOffsetTree(prevOffsetTree, syncStart, sizeTree, gap) {
    let offsetTree = prevOffsetTree;
    let prevIndex = 0;
    let prevSize = 0;
    let prevOffset = 0;
    let startIndex = 0;
    if (syncStart !== 0) {
        startIndex = $d72989d8b3846905$var$findIndexOfClosestSmallerOrEqual(offsetTree, syncStart - 1, $d72989d8b3846905$var$indexComparator);
        const offsetInfo = offsetTree[startIndex];
        prevOffset = offsetInfo.offset;
        const kv = $d72989d8b3846905$var$findMaxKeyValue(sizeTree, syncStart - 1);
        prevIndex = kv[0];
        prevSize = kv[1];
        if (offsetTree.length && offsetTree[startIndex].size === $d72989d8b3846905$var$findMaxKeyValue(sizeTree, syncStart)[1]) startIndex -= 1;
        offsetTree = offsetTree.slice(0, startIndex + 1);
    } else offsetTree = [];
    for (const { start: startIndex2, value: value } of $d72989d8b3846905$var$rangesWithin(sizeTree, syncStart, Infinity)){
        const indexOffset = startIndex2 - prevIndex;
        const aOffset = indexOffset * prevSize + prevOffset + indexOffset * gap;
        offsetTree.push({
            offset: aOffset,
            size: value,
            index: startIndex2
        });
        prevIndex = startIndex2;
        prevOffset = aOffset;
        prevSize = value;
    }
    return {
        offsetTree: offsetTree,
        lastIndex: prevIndex,
        lastOffset: prevOffset,
        lastSize: prevSize
    };
}
function $d72989d8b3846905$var$sizeStateReducer(state, [ranges, groupIndices, log, gap]) {
    if (ranges.length > 0) log("received item sizes", ranges, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
    const sizeTree = state.sizeTree;
    let newSizeTree = sizeTree;
    let syncStart = 0;
    if (groupIndices.length > 0 && $d72989d8b3846905$var$empty(sizeTree) && ranges.length === 2) {
        const groupSize = ranges[0].size;
        const itemSize = ranges[1].size;
        newSizeTree = groupIndices.reduce((tree, groupIndex)=>{
            return $d72989d8b3846905$var$insert($d72989d8b3846905$var$insert(tree, groupIndex, groupSize), groupIndex + 1, itemSize);
        }, newSizeTree);
    } else [newSizeTree, syncStart] = $d72989d8b3846905$var$insertRanges(newSizeTree, ranges);
    if (newSizeTree === sizeTree) return state;
    const { offsetTree: newOffsetTree, lastIndex: lastIndex, lastSize: lastSize, lastOffset: lastOffset } = $d72989d8b3846905$var$createOffsetTree(state.offsetTree, syncStart, newSizeTree, gap);
    return {
        sizeTree: newSizeTree,
        offsetTree: newOffsetTree,
        lastIndex: lastIndex,
        lastOffset: lastOffset,
        lastSize: lastSize,
        groupOffsetTree: groupIndices.reduce((tree, index)=>{
            return $d72989d8b3846905$var$insert(tree, index, $d72989d8b3846905$var$offsetOf(index, newOffsetTree, gap));
        }, $d72989d8b3846905$var$newTree()),
        groupIndices: groupIndices
    };
}
function $d72989d8b3846905$var$offsetOf(index, tree, gap) {
    if (tree.length === 0) return 0;
    const { offset: offset, index: startIndex, size: size } = $d72989d8b3846905$var$findClosestSmallerOrEqual(tree, index, $d72989d8b3846905$var$indexComparator);
    const itemCount = index - startIndex;
    const top = size * itemCount + (itemCount - 1) * gap + offset;
    return top > 0 ? top + gap : top;
}
function $d72989d8b3846905$var$isGroupLocation(location) {
    return typeof location.groupIndex !== "undefined";
}
function $d72989d8b3846905$var$originalIndexFromLocation(location, sizes, lastIndex) {
    if ($d72989d8b3846905$var$isGroupLocation(location)) return sizes.groupIndices[location.groupIndex] + 1;
    else {
        const numericIndex = location.index === "LAST" ? lastIndex : location.index;
        let result = $d72989d8b3846905$var$originalIndexFromItemIndex(numericIndex, sizes);
        result = Math.max(0, result, Math.min(lastIndex, result));
        return result;
    }
}
function $d72989d8b3846905$var$originalIndexFromItemIndex(itemIndex, sizes) {
    if (!$d72989d8b3846905$var$hasGroups(sizes)) return itemIndex;
    let groupOffset = 0;
    while(sizes.groupIndices[groupOffset] <= itemIndex + groupOffset)groupOffset++;
    return itemIndex + groupOffset;
}
function $d72989d8b3846905$var$hasGroups(sizes) {
    return !$d72989d8b3846905$var$empty(sizes.groupOffsetTree);
}
function $d72989d8b3846905$var$sizeTreeToRanges(sizeTree) {
    return $d72989d8b3846905$var$walk(sizeTree).map(({ k: startIndex, v: size }, index, sizeArray)=>{
        const nextSize = sizeArray[index + 1];
        const endIndex = nextSize ? nextSize.k - 1 : Infinity;
        return {
            startIndex: startIndex,
            endIndex: endIndex,
            size: size
        };
    });
}
const $d72989d8b3846905$var$SIZE_MAP = {
    offsetHeight: "height",
    offsetWidth: "width"
};
const $d72989d8b3846905$var$sizeSystem = $d72989d8b3846905$var$system(([{ log: log }, { recalcInProgress: recalcInProgress }])=>{
    const sizeRanges = $d72989d8b3846905$var$stream();
    const totalCount = $d72989d8b3846905$var$stream();
    const statefulTotalCount = $d72989d8b3846905$var$statefulStreamFromEmitter(totalCount, 0);
    const unshiftWith = $d72989d8b3846905$var$stream();
    const shiftWith = $d72989d8b3846905$var$stream();
    const firstItemIndex = $d72989d8b3846905$var$statefulStream(0);
    const groupIndices = $d72989d8b3846905$var$statefulStream([]);
    const fixedItemSize = $d72989d8b3846905$var$statefulStream(void 0);
    const defaultItemSize = $d72989d8b3846905$var$statefulStream(void 0);
    const itemSize = $d72989d8b3846905$var$statefulStream((el, field)=>$d72989d8b3846905$var$correctItemSize(el, $d72989d8b3846905$var$SIZE_MAP[field]));
    const data = $d72989d8b3846905$var$statefulStream(void 0);
    const gap = $d72989d8b3846905$var$statefulStream(0);
    const initial = $d72989d8b3846905$var$initialSizeState();
    const sizes = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(sizeRanges, $d72989d8b3846905$var$withLatestFrom(groupIndices, log, gap), $d72989d8b3846905$var$scan($d72989d8b3846905$var$sizeStateReducer, initial), $d72989d8b3846905$var$distinctUntilChanged()), initial);
    const prevGroupIndices = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(groupIndices, $d72989d8b3846905$var$distinctUntilChanged(), $d72989d8b3846905$var$scan((prev, curr)=>({
            prev: prev.current,
            current: curr
        }), {
        prev: [],
        current: []
    }), $d72989d8b3846905$var$map(({ prev: prev })=>prev)), []);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(groupIndices, $d72989d8b3846905$var$filter((indexes)=>indexes.length > 0), $d72989d8b3846905$var$withLatestFrom(sizes, gap), $d72989d8b3846905$var$map(([groupIndices2, sizes2, gap2])=>{
        const groupOffsetTree = groupIndices2.reduce((tree, index, idx)=>{
            return $d72989d8b3846905$var$insert(tree, index, $d72989d8b3846905$var$offsetOf(index, sizes2.offsetTree, gap2) || idx);
        }, $d72989d8b3846905$var$newTree());
        return (0, $2qxEV._)((0, $9tqwB._)({}, sizes2), {
            groupIndices: groupIndices2,
            groupOffsetTree: groupOffsetTree
        });
    })), sizes);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(totalCount, $d72989d8b3846905$var$withLatestFrom(sizes), $d72989d8b3846905$var$filter(([totalCount2, { lastIndex: lastIndex }])=>{
        return totalCount2 < lastIndex;
    }), $d72989d8b3846905$var$map(([totalCount2, { lastIndex: lastIndex, lastSize: lastSize }])=>{
        return [
            {
                startIndex: totalCount2,
                endIndex: lastIndex,
                size: lastSize
            }
        ];
    })), sizeRanges);
    $d72989d8b3846905$var$connect(fixedItemSize, defaultItemSize);
    const trackItemSizes = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(fixedItemSize, $d72989d8b3846905$var$map((size)=>size === void 0)), true);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(defaultItemSize, $d72989d8b3846905$var$filter((value)=>{
        return value !== void 0 && $d72989d8b3846905$var$empty($d72989d8b3846905$var$getValue(sizes).sizeTree);
    }), $d72989d8b3846905$var$map((size)=>[
            {
                startIndex: 0,
                endIndex: 0,
                size: size
            }
        ])), sizeRanges);
    const listRefresh = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(sizeRanges, $d72989d8b3846905$var$withLatestFrom(sizes), $d72989d8b3846905$var$scan(({ sizes: oldSizes }, [_, newSizes])=>{
        return {
            changed: newSizes !== oldSizes,
            sizes: newSizes
        };
    }, {
        changed: false,
        sizes: initial
    }), $d72989d8b3846905$var$map((value)=>value.changed)));
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(firstItemIndex, $d72989d8b3846905$var$scan((prev, next)=>{
        return {
            diff: prev.prev - next,
            prev: next
        };
    }, {
        diff: 0,
        prev: 0
    }), $d72989d8b3846905$var$map((val)=>val.diff)), (offset)=>{
        const { groupIndices: groupIndices2 } = $d72989d8b3846905$var$getValue(sizes);
        if (offset > 0) {
            $d72989d8b3846905$var$publish(recalcInProgress, true);
            $d72989d8b3846905$var$publish(unshiftWith, offset + $d72989d8b3846905$var$affectedGroupCount(offset, groupIndices2));
        } else if (offset < 0) {
            const prevGroupIndicesValue = $d72989d8b3846905$var$getValue(prevGroupIndices);
            if (prevGroupIndicesValue.length > 0) offset -= $d72989d8b3846905$var$affectedGroupCount(-offset, prevGroupIndicesValue);
            $d72989d8b3846905$var$publish(shiftWith, offset);
        }
    });
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(firstItemIndex, $d72989d8b3846905$var$withLatestFrom(log)), ([index, log2])=>{
        if (index < 0) log2("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
            firstItemIndex: firstItemIndex
        }, $d72989d8b3846905$export$243e62d78d3b544d.ERROR);
    });
    const beforeUnshiftWith = $d72989d8b3846905$var$streamFromEmitter(unshiftWith);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(unshiftWith, $d72989d8b3846905$var$withLatestFrom(sizes), $d72989d8b3846905$var$map(([unshiftWith2, sizes2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        const initialRanges = [];
        const defaultSize = sizes2.lastSize;
        if (groupedMode) {
            const firstGroupSize = $d72989d8b3846905$var$find(sizes2.sizeTree, 0);
            let prependedGroupItemsCount = 0;
            let groupIndex = 0;
            while(prependedGroupItemsCount < unshiftWith2){
                const theGroupIndex = sizes2.groupIndices[groupIndex];
                const groupItemCount = sizes2.groupIndices.length === groupIndex + 1 ? Infinity : sizes2.groupIndices[groupIndex + 1] - theGroupIndex - 1;
                initialRanges.push({
                    startIndex: theGroupIndex,
                    endIndex: theGroupIndex,
                    size: firstGroupSize
                });
                initialRanges.push({
                    startIndex: theGroupIndex + 1,
                    endIndex: theGroupIndex + 1 + groupItemCount - 1,
                    size: defaultSize
                });
                groupIndex++;
                prependedGroupItemsCount += groupItemCount + 1;
            }
            const sizeTreeKV = $d72989d8b3846905$var$walk(sizes2.sizeTree);
            const firstGroupIsExpanded = prependedGroupItemsCount !== unshiftWith2;
            if (firstGroupIsExpanded) sizeTreeKV.shift();
            return sizeTreeKV.reduce((acc, { k: index, v: size })=>{
                let ranges = acc.ranges;
                if (acc.prevSize !== 0) ranges = [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ];
                return {
                    ranges: ranges,
                    prevIndex: index + unshiftWith2,
                    prevSize: size
                };
            }, {
                ranges: initialRanges,
                prevIndex: unshiftWith2,
                prevSize: 0
            }).ranges;
        }
        return $d72989d8b3846905$var$walk(sizes2.sizeTree).reduce((acc, { k: index, v: size })=>{
            return {
                ranges: [
                    ...acc.ranges,
                    {
                        startIndex: acc.prevIndex,
                        endIndex: index + unshiftWith2 - 1,
                        size: acc.prevSize
                    }
                ],
                prevIndex: index + unshiftWith2,
                prevSize: size
            };
        }, {
            ranges: [],
            prevIndex: 0,
            prevSize: defaultSize
        }).ranges;
    })), sizeRanges);
    const shiftWithOffset = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(shiftWith, $d72989d8b3846905$var$withLatestFrom(sizes, gap), $d72989d8b3846905$var$map(([shiftWith2, { offsetTree: offsetTree }, gap2])=>{
        const newFirstItemIndex = -shiftWith2;
        return $d72989d8b3846905$var$offsetOf(newFirstItemIndex, offsetTree, gap2);
    })));
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(shiftWith, $d72989d8b3846905$var$withLatestFrom(sizes, gap), $d72989d8b3846905$var$map(([shiftWith2, sizes2, gap2])=>{
        const groupedMode = sizes2.groupIndices.length > 0;
        if (groupedMode) {
            if ($d72989d8b3846905$var$empty(sizes2.sizeTree)) return sizes2;
            let newSizeTree = $d72989d8b3846905$var$newTree();
            const prevGroupIndicesValue = $d72989d8b3846905$var$getValue(prevGroupIndices);
            let removedItemsCount = 0;
            let groupIndex = 0;
            let groupOffset = 0;
            while(removedItemsCount < -shiftWith2){
                groupOffset = prevGroupIndicesValue[groupIndex];
                const groupItemCount = prevGroupIndicesValue[groupIndex + 1] - groupOffset - 1;
                groupIndex++;
                removedItemsCount += groupItemCount + 1;
            }
            newSizeTree = $d72989d8b3846905$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $d72989d8b3846905$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, newSizeTree);
            const aGroupIsShrunk = removedItemsCount !== -shiftWith2;
            if (aGroupIsShrunk) {
                const firstGroupSize = $d72989d8b3846905$var$find(sizes2.sizeTree, groupOffset);
                newSizeTree = $d72989d8b3846905$var$insert(newSizeTree, 0, firstGroupSize);
                const nextItemSize = $d72989d8b3846905$var$findMaxKeyValue(sizes2.sizeTree, -shiftWith2 + 1)[1];
                newSizeTree = $d72989d8b3846905$var$insert(newSizeTree, 1, nextItemSize);
            }
            return (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, sizes2), {
                sizeTree: newSizeTree
            }), $d72989d8b3846905$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2));
        } else {
            const newSizeTree = $d72989d8b3846905$var$walk(sizes2.sizeTree).reduce((acc, { k: k, v: v })=>{
                return $d72989d8b3846905$var$insert(acc, Math.max(0, k + shiftWith2), v);
            }, $d72989d8b3846905$var$newTree());
            return (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, sizes2), {
                sizeTree: newSizeTree
            }), $d72989d8b3846905$var$createOffsetTree(sizes2.offsetTree, 0, newSizeTree, gap2));
        }
    })), sizes);
    return {
        data: // input
        data,
        totalCount: totalCount,
        sizeRanges: sizeRanges,
        groupIndices: groupIndices,
        defaultItemSize: defaultItemSize,
        fixedItemSize: fixedItemSize,
        unshiftWith: unshiftWith,
        shiftWith: shiftWith,
        shiftWithOffset: shiftWithOffset,
        beforeUnshiftWith: beforeUnshiftWith,
        firstItemIndex: firstItemIndex,
        gap: gap,
        sizes: // output
        sizes,
        listRefresh: listRefresh,
        statefulTotalCount: statefulTotalCount,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$loggerSystem, $d72989d8b3846905$var$recalcSystem), {
    singleton: true
});
const $d72989d8b3846905$var$SUPPORTS_SCROLL_TO_OPTIONS = typeof document !== "undefined" && "scrollBehavior" in document.documentElement.style;
function $d72989d8b3846905$var$normalizeIndexLocation(location) {
    const result = typeof location === "number" ? {
        index: location
    } : location;
    if (!result.align) result.align = "start";
    if (!result.behavior || !$d72989d8b3846905$var$SUPPORTS_SCROLL_TO_OPTIONS) result.behavior = "auto";
    if (!result.offset) result.offset = 0;
    return result;
}
const $d72989d8b3846905$var$scrollToIndexSystem = $d72989d8b3846905$var$system(([{ sizes: sizes, totalCount: totalCount, listRefresh: listRefresh, gap: gap }, { scrollingInProgress: scrollingInProgress, viewportHeight: viewportHeight, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, headerHeight: headerHeight, footerHeight: footerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { log: log }])=>{
    const scrollToIndex = $d72989d8b3846905$var$stream();
    const scrollTargetReached = $d72989d8b3846905$var$stream();
    const topListHeight = $d72989d8b3846905$var$statefulStream(0);
    let unsubscribeNextListRefresh = null;
    let cleartTimeoutRef = null;
    let unsubscribeListRefresh = null;
    function cleanup() {
        if (unsubscribeNextListRefresh) {
            unsubscribeNextListRefresh();
            unsubscribeNextListRefresh = null;
        }
        if (unsubscribeListRefresh) {
            unsubscribeListRefresh();
            unsubscribeListRefresh = null;
        }
        if (cleartTimeoutRef) {
            clearTimeout(cleartTimeoutRef);
            cleartTimeoutRef = null;
        }
        $d72989d8b3846905$var$publish(scrollingInProgress, false);
    }
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollToIndex, $d72989d8b3846905$var$withLatestFrom(sizes, viewportHeight, totalCount, topListHeight, headerHeight, footerHeight, log), $d72989d8b3846905$var$withLatestFrom(gap, fixedHeaderHeight, fixedFooterHeight), $d72989d8b3846905$var$map(([[location, sizes2, viewportHeight2, totalCount2, topListHeight2, headerHeight2, footerHeight2, log2], gap2, fixedHeaderHeight2, fixedFooterHeight2])=>{
        const normalLocation = $d72989d8b3846905$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        const lastIndex = totalCount2 - 1;
        const index = $d72989d8b3846905$var$originalIndexFromLocation(normalLocation, sizes2, lastIndex);
        let top = $d72989d8b3846905$var$offsetOf(index, sizes2.offsetTree, gap2) + headerHeight2;
        if (align === "end") {
            top += fixedHeaderHeight2 + $d72989d8b3846905$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2;
            if (index === lastIndex) top += footerHeight2;
        } else if (align === "center") top += (fixedHeaderHeight2 + $d72989d8b3846905$var$findMaxKeyValue(sizes2.sizeTree, index)[1] - viewportHeight2 + fixedFooterHeight2) / 2;
        else top -= topListHeight2;
        if (offset) top += offset;
        const retry = (listChanged)=>{
            cleanup();
            if (listChanged) {
                log2("retrying to scroll to", {
                    location: location
                }, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
                $d72989d8b3846905$var$publish(scrollToIndex, location);
            } else {
                $d72989d8b3846905$var$publish(scrollTargetReached, true);
                log2("list did not change, scroll successful", {}, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
            }
        };
        cleanup();
        if (behavior === "smooth") {
            let listChanged = false;
            unsubscribeListRefresh = $d72989d8b3846905$var$subscribe(listRefresh, (changed)=>{
                listChanged = listChanged || changed;
            });
            unsubscribeNextListRefresh = $d72989d8b3846905$var$handleNext(smoothScrollTargetReached, ()=>{
                retry(listChanged);
            });
        } else unsubscribeNextListRefresh = $d72989d8b3846905$var$handleNext($d72989d8b3846905$var$pipe(listRefresh, $d72989d8b3846905$var$watchChangesFor(150)), retry);
        cleartTimeoutRef = setTimeout(()=>{
            cleanup();
        }, 1200);
        $d72989d8b3846905$var$publish(scrollingInProgress, true);
        log2("scrolling from index to", {
            index: index,
            top: top,
            behavior: behavior
        }, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    return {
        scrollToIndex: scrollToIndex,
        scrollTargetReached: scrollTargetReached,
        topListHeight: topListHeight
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$loggerSystem), {
    singleton: true
});
function $d72989d8b3846905$var$watchChangesFor(limit) {
    return (done)=>{
        const timeoutRef = setTimeout(()=>{
            done(false);
        }, limit);
        return (value)=>{
            if (value) {
                done(true);
                clearTimeout(timeoutRef);
            }
        };
    };
}
const $d72989d8b3846905$var$UP = "up";
const $d72989d8b3846905$var$DOWN = "down";
const $d72989d8b3846905$var$NONE$1 = "none";
const $d72989d8b3846905$var$INITIAL_BOTTOM_STATE = {
    atBottom: false,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
        offsetBottom: 0,
        scrollTop: 0,
        viewportHeight: 0,
        scrollHeight: 0
    }
};
const $d72989d8b3846905$var$DEFAULT_AT_TOP_THRESHOLD = 0;
const $d72989d8b3846905$var$stateFlagsSystem = $d72989d8b3846905$var$system(([{ scrollContainerState: scrollContainerState, scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, footerHeight: footerHeight, scrollBy: scrollBy }])=>{
    const isAtBottom = $d72989d8b3846905$var$statefulStream(false);
    const isAtTop = $d72989d8b3846905$var$statefulStream(true);
    const atBottomStateChange = $d72989d8b3846905$var$stream();
    const atTopStateChange = $d72989d8b3846905$var$stream();
    const atBottomThreshold = $d72989d8b3846905$var$statefulStream(4);
    const atTopThreshold = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$DEFAULT_AT_TOP_THRESHOLD);
    const isScrolling = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$merge($d72989d8b3846905$var$pipe($d72989d8b3846905$var$duc(scrollTop), $d72989d8b3846905$var$skip(1), $d72989d8b3846905$var$mapTo(true)), $d72989d8b3846905$var$pipe($d72989d8b3846905$var$duc(scrollTop), $d72989d8b3846905$var$skip(1), $d72989d8b3846905$var$mapTo(false), $d72989d8b3846905$var$debounceTime(100))), $d72989d8b3846905$var$distinctUntilChanged()), false);
    const isScrollingBy = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$merge($d72989d8b3846905$var$pipe(scrollBy, $d72989d8b3846905$var$mapTo(true)), $d72989d8b3846905$var$pipe(scrollBy, $d72989d8b3846905$var$mapTo(false), $d72989d8b3846905$var$debounceTime(200))), $d72989d8b3846905$var$distinctUntilChanged()), false);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$duc(scrollTop), $d72989d8b3846905$var$duc(atTopThreshold)), $d72989d8b3846905$var$map(([top, atTopThreshold2])=>top <= atTopThreshold2), $d72989d8b3846905$var$distinctUntilChanged()), isAtTop);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(isAtTop, $d72989d8b3846905$var$throttleTime(50)), atTopStateChange);
    const atBottomState = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(scrollContainerState, $d72989d8b3846905$var$duc(viewportHeight), $d72989d8b3846905$var$duc(headerHeight), $d72989d8b3846905$var$duc(footerHeight), $d72989d8b3846905$var$duc(atBottomThreshold)), $d72989d8b3846905$var$scan((current, [{ scrollTop: scrollTop2, scrollHeight: scrollHeight }, viewportHeight2, _headerHeight, _footerHeight, atBottomThreshold2])=>{
        const isAtBottom2 = scrollTop2 + viewportHeight2 - scrollHeight > -atBottomThreshold2;
        const state = {
            viewportHeight: viewportHeight2,
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight
        };
        if (isAtBottom2) {
            let atBottomBecause;
            let scrollTopDelta;
            if (scrollTop2 > current.state.scrollTop) {
                atBottomBecause = "SCROLLED_DOWN";
                scrollTopDelta = current.state.scrollTop - scrollTop2;
            } else {
                atBottomBecause = "SIZE_DECREASED";
                scrollTopDelta = current.state.scrollTop - scrollTop2 || current.scrollTopDelta;
            }
            return {
                atBottom: true,
                state: state,
                atBottomBecause: atBottomBecause,
                scrollTopDelta: scrollTopDelta
            };
        }
        let notAtBottomBecause;
        if (state.scrollHeight > current.state.scrollHeight) notAtBottomBecause = "SIZE_INCREASED";
        else if (viewportHeight2 < current.state.viewportHeight) notAtBottomBecause = "VIEWPORT_HEIGHT_DECREASING";
        else if (scrollTop2 < current.state.scrollTop) notAtBottomBecause = "SCROLLING_UPWARDS";
        else notAtBottomBecause = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM";
        return {
            atBottom: false,
            notAtBottomBecause: notAtBottomBecause,
            state: state
        };
    }, $d72989d8b3846905$var$INITIAL_BOTTOM_STATE), $d72989d8b3846905$var$distinctUntilChanged((prev, next)=>{
        return prev && prev.atBottom === next.atBottom;
    })));
    const lastJumpDueToItemResize = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(scrollContainerState, $d72989d8b3846905$var$scan((current, { scrollTop: scrollTop2, scrollHeight: scrollHeight, viewportHeight: viewportHeight2 })=>{
        if (!$d72989d8b3846905$var$approximatelyEqual(current.scrollHeight, scrollHeight)) {
            const atBottom = scrollHeight - (scrollTop2 + viewportHeight2) < 1;
            if (current.scrollTop !== scrollTop2 && atBottom) return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: current.scrollTop - scrollTop2,
                changed: true
            };
            else return {
                scrollHeight: scrollHeight,
                scrollTop: scrollTop2,
                jump: 0,
                changed: true
            };
        } else return {
            scrollTop: scrollTop2,
            scrollHeight: scrollHeight,
            jump: 0,
            changed: false
        };
    }, {
        scrollHeight: 0,
        jump: 0,
        scrollTop: 0,
        changed: false
    }), $d72989d8b3846905$var$filter((value)=>value.changed), $d72989d8b3846905$var$map((value)=>value.jump)), 0);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(atBottomState, $d72989d8b3846905$var$map((state)=>state.atBottom)), isAtBottom);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(isAtBottom, $d72989d8b3846905$var$throttleTime(50)), atBottomStateChange);
    const scrollDirection = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$DOWN);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollContainerState, $d72989d8b3846905$var$map(({ scrollTop: scrollTop2 })=>scrollTop2), $d72989d8b3846905$var$distinctUntilChanged(), $d72989d8b3846905$var$scan((acc, scrollTop2)=>{
        if ($d72989d8b3846905$var$getValue(isScrollingBy)) return {
            direction: acc.direction,
            prevScrollTop: scrollTop2
        };
        return {
            direction: scrollTop2 < acc.prevScrollTop ? $d72989d8b3846905$var$UP : $d72989d8b3846905$var$DOWN,
            prevScrollTop: scrollTop2
        };
    }, {
        direction: $d72989d8b3846905$var$DOWN,
        prevScrollTop: 0
    }), $d72989d8b3846905$var$map((value)=>value.direction)), scrollDirection);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollContainerState, $d72989d8b3846905$var$throttleTime(50), $d72989d8b3846905$var$mapTo($d72989d8b3846905$var$NONE$1)), scrollDirection);
    const scrollVelocity = $d72989d8b3846905$var$statefulStream(0);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(isScrolling, $d72989d8b3846905$var$filter((value)=>!value), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $d72989d8b3846905$var$mapTo(0)), scrollVelocity);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollTop, $d72989d8b3846905$var$throttleTime(100), $d72989d8b3846905$var$withLatestFrom(isScrolling), $d72989d8b3846905$var$filter(([_, isScrolling2])=>!!isScrolling2), $d72989d8b3846905$var$scan(([_, prev], [next])=>[
            prev,
            next
        ], [
        0,
        0
    ]), $d72989d8b3846905$var$map(([prev, next])=>next - prev)), scrollVelocity);
    return {
        isScrolling: isScrolling,
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        atBottomState: atBottomState,
        atTopStateChange: atTopStateChange,
        atBottomStateChange: atBottomStateChange,
        scrollDirection: scrollDirection,
        atBottomThreshold: atBottomThreshold,
        atTopThreshold: atTopThreshold,
        scrollVelocity: scrollVelocity,
        lastJumpDueToItemResize: lastJumpDueToItemResize
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$domIOSystem));
const $d72989d8b3846905$var$propsReadySystem = $d72989d8b3846905$var$system(([{ log: log }])=>{
    const propsReady = $d72989d8b3846905$var$statefulStream(false);
    const didMount = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(propsReady, $d72989d8b3846905$var$filter((ready)=>ready), $d72989d8b3846905$var$distinctUntilChanged()));
    $d72989d8b3846905$var$subscribe(propsReady, (value)=>{
        value && $d72989d8b3846905$var$getValue(log)("props updated", {}, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
    });
    return {
        propsReady: propsReady,
        didMount: didMount
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$loggerSystem), {
    singleton: true
});
function $d72989d8b3846905$var$skipFrames(frameCount, callback) {
    if (frameCount == 0) callback();
    else requestAnimationFrame(()=>$d72989d8b3846905$var$skipFrames(frameCount - 1, callback));
}
function $d72989d8b3846905$var$getInitialTopMostItemIndexNumber(location, totalCount) {
    const lastIndex = totalCount - 1;
    const index = typeof location === "number" ? location : location.index === "LAST" ? lastIndex : location.index;
    return index;
}
const $d72989d8b3846905$var$initialTopMostItemIndexSystem = $d72989d8b3846905$var$system(([{ sizes: sizes, listRefresh: listRefresh, defaultItemSize: defaultItemSize }, { scrollTop: scrollTop }, { scrollToIndex: scrollToIndex, scrollTargetReached: scrollTargetReached }, { didMount: didMount }])=>{
    const scrolledToInitialItem = $d72989d8b3846905$var$statefulStream(true);
    const initialTopMostItemIndex = $d72989d8b3846905$var$statefulStream(0);
    const initialItemFinalLocationReached = $d72989d8b3846905$var$statefulStream(true);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(initialTopMostItemIndex), $d72989d8b3846905$var$filter(([_, location])=>!!location), $d72989d8b3846905$var$mapTo(false)), scrolledToInitialItem);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(initialTopMostItemIndex), $d72989d8b3846905$var$filter(([_, location])=>!!location), $d72989d8b3846905$var$mapTo(false)), initialItemFinalLocationReached);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(listRefresh, didMount), $d72989d8b3846905$var$withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize, initialItemFinalLocationReached), $d72989d8b3846905$var$filter(([[, didMount2], scrolledToInitialItem2, { sizeTree: sizeTree }, defaultItemSize2, scrollScheduled])=>{
        return didMount2 && (!$d72989d8b3846905$var$empty(sizeTree) || $d72989d8b3846905$var$isDefined(defaultItemSize2)) && !scrolledToInitialItem2 && !scrollScheduled;
    }), $d72989d8b3846905$var$withLatestFrom(initialTopMostItemIndex)), ([, initialTopMostItemIndex2])=>{
        $d72989d8b3846905$var$handleNext(scrollTargetReached, ()=>{
            $d72989d8b3846905$var$publish(initialItemFinalLocationReached, true);
        });
        $d72989d8b3846905$var$skipFrames(4, ()=>{
            $d72989d8b3846905$var$handleNext(scrollTop, ()=>{
                $d72989d8b3846905$var$publish(scrolledToInitialItem, true);
            });
            $d72989d8b3846905$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
    });
    return {
        scrolledToInitialItem: scrolledToInitialItem,
        initialTopMostItemIndex: initialTopMostItemIndex,
        initialItemFinalLocationReached: initialItemFinalLocationReached
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$scrollToIndexSystem, $d72989d8b3846905$var$propsReadySystem), {
    singleton: true
});
function $d72989d8b3846905$var$normalizeFollowOutput(follow) {
    if (!follow) return false;
    return follow === "smooth" ? "smooth" : "auto";
}
const $d72989d8b3846905$var$behaviorFromFollowOutput = (follow, isAtBottom)=>{
    if (typeof follow === "function") return $d72989d8b3846905$var$normalizeFollowOutput(follow(isAtBottom));
    return isAtBottom && $d72989d8b3846905$var$normalizeFollowOutput(follow);
};
const $d72989d8b3846905$var$followOutputSystem = $d72989d8b3846905$var$system(([{ totalCount: totalCount, listRefresh: listRefresh }, { isAtBottom: isAtBottom, atBottomState: atBottomState }, { scrollToIndex: scrollToIndex }, { scrolledToInitialItem: scrolledToInitialItem }, { propsReady: propsReady, didMount: didMount }, { log: log }, { scrollingInProgress: scrollingInProgress }])=>{
    const followOutput = $d72989d8b3846905$var$statefulStream(false);
    const autoscrollToBottom = $d72989d8b3846905$var$stream();
    let pendingScrollHandle = null;
    function scrollToBottom(followOutputBehavior) {
        $d72989d8b3846905$var$publish(scrollToIndex, {
            index: "LAST",
            align: "end",
            behavior: followOutputBehavior
        });
    }
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$pipe($d72989d8b3846905$var$duc(totalCount), $d72989d8b3846905$var$skip(1)), didMount), $d72989d8b3846905$var$withLatestFrom($d72989d8b3846905$var$duc(followOutput), isAtBottom, scrolledToInitialItem, scrollingInProgress), $d72989d8b3846905$var$map(([[totalCount2, didMount2], followOutput2, isAtBottom2, scrolledToInitialItem2, scrollingInProgress2])=>{
        let shouldFollow = didMount2 && scrolledToInitialItem2;
        let followOutputBehavior = "auto";
        if (shouldFollow) {
            followOutputBehavior = $d72989d8b3846905$var$behaviorFromFollowOutput(followOutput2, isAtBottom2 || scrollingInProgress2);
            shouldFollow = shouldFollow && !!followOutputBehavior;
        }
        return {
            totalCount: totalCount2,
            shouldFollow: shouldFollow,
            followOutputBehavior: followOutputBehavior
        };
    }), $d72989d8b3846905$var$filter(({ shouldFollow: shouldFollow })=>shouldFollow)), ({ totalCount: totalCount2, followOutputBehavior: followOutputBehavior })=>{
        if (pendingScrollHandle) {
            pendingScrollHandle();
            pendingScrollHandle = null;
        }
        pendingScrollHandle = $d72989d8b3846905$var$handleNext(listRefresh, ()=>{
            $d72989d8b3846905$var$getValue(log)("following output to ", {
                totalCount: totalCount2
            }, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
            scrollToBottom(followOutputBehavior);
            pendingScrollHandle = null;
        });
    });
    function trapNextSizeIncrease(followOutput2) {
        const cancel = $d72989d8b3846905$var$handleNext(atBottomState, (state)=>{
            if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "SIZE_INCREASED" && !pendingScrollHandle) {
                $d72989d8b3846905$var$getValue(log)("scrolling to bottom due to increased size", {}, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
                scrollToBottom("auto");
            }
        });
        setTimeout(cancel, 100);
    }
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$duc(followOutput), totalCount, propsReady), $d72989d8b3846905$var$filter(([follow, , ready])=>follow && ready), $d72989d8b3846905$var$scan(({ value: value }, [, next])=>{
        return {
            refreshed: value === next,
            value: next
        };
    }, {
        refreshed: false,
        value: 0
    }), $d72989d8b3846905$var$filter(({ refreshed: refreshed })=>refreshed), $d72989d8b3846905$var$withLatestFrom(followOutput, totalCount)), ([, followOutput2])=>{
        if ($d72989d8b3846905$var$getValue(scrolledToInitialItem)) trapNextSizeIncrease(followOutput2 !== false);
    });
    $d72989d8b3846905$var$subscribe(autoscrollToBottom, ()=>{
        trapNextSizeIncrease($d72989d8b3846905$var$getValue(followOutput) !== false);
    });
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$duc(followOutput), atBottomState), ([followOutput2, state])=>{
        if (followOutput2 && !state.atBottom && state.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING") scrollToBottom("auto");
    });
    return {
        followOutput: followOutput,
        autoscrollToBottom: autoscrollToBottom
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$stateFlagsSystem, $d72989d8b3846905$var$scrollToIndexSystem, $d72989d8b3846905$var$initialTopMostItemIndexSystem, $d72989d8b3846905$var$propsReadySystem, $d72989d8b3846905$var$loggerSystem, $d72989d8b3846905$var$domIOSystem));
function $d72989d8b3846905$var$groupCountsToIndicesAndCount(counts) {
    return counts.reduce((acc, groupCount)=>{
        acc.groupIndices.push(acc.totalCount);
        acc.totalCount += groupCount + 1;
        return acc;
    }, {
        totalCount: 0,
        groupIndices: []
    });
}
const $d72989d8b3846905$var$groupedListSystem = $d72989d8b3846905$var$system(([{ totalCount: totalCount, groupIndices: groupIndices, sizes: sizes }, { scrollTop: scrollTop, headerHeight: headerHeight }])=>{
    const groupCounts = $d72989d8b3846905$var$stream();
    const topItemsIndexes = $d72989d8b3846905$var$stream();
    const groupIndicesAndCount = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(groupCounts, $d72989d8b3846905$var$map($d72989d8b3846905$var$groupCountsToIndicesAndCount)));
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(groupIndicesAndCount, $d72989d8b3846905$var$map((value)=>value.totalCount)), totalCount);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(groupIndicesAndCount, $d72989d8b3846905$var$map((value)=>value.groupIndices)), groupIndices);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(scrollTop, sizes, headerHeight), $d72989d8b3846905$var$filter(([_, sizes2])=>$d72989d8b3846905$var$hasGroups(sizes2)), $d72989d8b3846905$var$map(([scrollTop2, state, headerHeight2])=>$d72989d8b3846905$var$findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop2 - headerHeight2, 0), "v")[0]), $d72989d8b3846905$var$distinctUntilChanged(), $d72989d8b3846905$var$map((index)=>[
            index
        ])), topItemsIndexes);
    return {
        groupCounts: groupCounts,
        topItemsIndexes: topItemsIndexes
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$domIOSystem));
function $d72989d8b3846905$var$tupleComparator(prev, current) {
    return !!(prev && prev[0] === current[0] && prev[1] === current[1]);
}
function $d72989d8b3846905$var$rangeComparator(prev, next) {
    return !!(prev && prev.startIndex === next.startIndex && prev.endIndex === next.endIndex);
}
const $d72989d8b3846905$var$TOP = "top";
const $d72989d8b3846905$var$BOTTOM = "bottom";
const $d72989d8b3846905$var$NONE = "none";
function $d72989d8b3846905$var$getOverscan(overscan, end, direction) {
    if (typeof overscan === "number") return direction === $d72989d8b3846905$var$UP && end === $d72989d8b3846905$var$TOP || direction === $d72989d8b3846905$var$DOWN && end === $d72989d8b3846905$var$BOTTOM ? overscan : 0;
    else {
        if (direction === $d72989d8b3846905$var$UP) return end === $d72989d8b3846905$var$TOP ? overscan.main : overscan.reverse;
        else return end === $d72989d8b3846905$var$BOTTOM ? overscan.main : overscan.reverse;
    }
}
function $d72989d8b3846905$var$getViewportIncrease(value, end) {
    return typeof value === "number" ? value : value[end] || 0;
}
const $d72989d8b3846905$var$sizeRangeSystem = $d72989d8b3846905$var$system(([{ scrollTop: scrollTop, viewportHeight: viewportHeight, deviation: deviation, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight }])=>{
    const listBoundary = $d72989d8b3846905$var$stream();
    const topListHeight = $d72989d8b3846905$var$statefulStream(0);
    const increaseViewportBy = $d72989d8b3846905$var$statefulStream(0);
    const overscan = $d72989d8b3846905$var$statefulStream(0);
    const visibleRange = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$duc(scrollTop), $d72989d8b3846905$var$duc(viewportHeight), $d72989d8b3846905$var$duc(headerHeight), $d72989d8b3846905$var$duc(listBoundary, $d72989d8b3846905$var$tupleComparator), $d72989d8b3846905$var$duc(overscan), $d72989d8b3846905$var$duc(topListHeight), $d72989d8b3846905$var$duc(fixedHeaderHeight), $d72989d8b3846905$var$duc(deviation), $d72989d8b3846905$var$duc(increaseViewportBy)), $d72989d8b3846905$var$map(([scrollTop2, viewportHeight2, headerHeight2, [listTop, listBottom], overscan2, topListHeight2, fixedHeaderHeight2, deviation2, increaseViewportBy2])=>{
        const top = scrollTop2 - deviation2;
        const stickyHeaderHeight = topListHeight2 + fixedHeaderHeight2;
        const headerVisible = Math.max(headerHeight2 - top, 0);
        let direction = $d72989d8b3846905$var$NONE;
        const topViewportAddition = $d72989d8b3846905$var$getViewportIncrease(increaseViewportBy2, $d72989d8b3846905$var$TOP);
        const bottomViewportAddition = $d72989d8b3846905$var$getViewportIncrease(increaseViewportBy2, $d72989d8b3846905$var$BOTTOM);
        listTop -= deviation2;
        listTop += headerHeight2 + fixedHeaderHeight2;
        listBottom += headerHeight2 + fixedHeaderHeight2;
        listBottom -= deviation2;
        if (listTop > scrollTop2 + stickyHeaderHeight - topViewportAddition) direction = $d72989d8b3846905$var$UP;
        if (listBottom < scrollTop2 - headerVisible + viewportHeight2 + bottomViewportAddition) direction = $d72989d8b3846905$var$DOWN;
        if (direction !== $d72989d8b3846905$var$NONE) return [
            Math.max(top - headerHeight2 - $d72989d8b3846905$var$getOverscan(overscan2, $d72989d8b3846905$var$TOP, direction) - topViewportAddition, 0),
            top - headerVisible - fixedHeaderHeight2 + viewportHeight2 + $d72989d8b3846905$var$getOverscan(overscan2, $d72989d8b3846905$var$BOTTOM, direction) + bottomViewportAddition
        ];
        return null;
    }), $d72989d8b3846905$var$filter((value)=>value != null), $d72989d8b3846905$var$distinctUntilChanged($d72989d8b3846905$var$tupleComparator)), [
        0,
        0
    ]);
    return {
        listBoundary: // input
        listBoundary,
        overscan: overscan,
        topListHeight: topListHeight,
        increaseViewportBy: increaseViewportBy,
        visibleRange: // output
        visibleRange
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$domIOSystem), {
    singleton: true
});
function $d72989d8b3846905$var$probeItemSet(index, sizes, data) {
    if ($d72989d8b3846905$var$hasGroups(sizes)) {
        const itemIndex = $d72989d8b3846905$var$originalIndexFromItemIndex(index, sizes);
        const groupIndex = $d72989d8b3846905$var$findMaxKeyValue(sizes.groupOffsetTree, itemIndex)[0];
        return [
            {
                index: groupIndex,
                size: 0,
                offset: 0
            },
            {
                index: itemIndex,
                size: 0,
                offset: 0,
                data: data && data[0]
            }
        ];
    }
    return [
        {
            index: index,
            size: 0,
            offset: 0,
            data: data && data[0]
        }
    ];
}
const $d72989d8b3846905$var$EMPTY_LIST_STATE = {
    items: [],
    topItems: [],
    offsetTop: 0,
    offsetBottom: 0,
    top: 0,
    bottom: 0,
    topListHeight: 0,
    totalCount: 0,
    firstItemIndex: 0
};
function $d72989d8b3846905$var$transposeItems(items, sizes, firstItemIndex) {
    if (items.length === 0) return [];
    if (!$d72989d8b3846905$var$hasGroups(sizes)) return items.map((item)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
            index: item.index + firstItemIndex,
            originalIndex: item.index
        }));
    const startIndex = items[0].index;
    const endIndex = items[items.length - 1].index;
    const transposedItems = [];
    const groupRanges = $d72989d8b3846905$var$rangesWithin(sizes.groupOffsetTree, startIndex, endIndex);
    let currentRange = void 0;
    let currentGroupIndex = 0;
    for (const item of items){
        if (!currentRange || currentRange.end < item.index) {
            currentRange = groupRanges.shift();
            currentGroupIndex = sizes.groupIndices.indexOf(currentRange.start);
        }
        let transposedItem;
        if (item.index === currentRange.start) transposedItem = {
            type: "group",
            index: currentGroupIndex
        };
        else transposedItem = {
            index: item.index - (currentGroupIndex + 1) + firstItemIndex,
            groupIndex: currentGroupIndex
        };
        transposedItems.push((0, $2qxEV._)((0, $9tqwB._)({}, transposedItem), {
            size: item.size,
            offset: item.offset,
            originalIndex: item.index,
            data: item.data
        }));
    }
    return transposedItems;
}
function $d72989d8b3846905$var$buildListState(items, topItems, totalCount, gap, sizes, firstItemIndex) {
    const { lastSize: lastSize, lastOffset: lastOffset, lastIndex: lastIndex } = sizes;
    let offsetTop = 0;
    let bottom = 0;
    if (items.length > 0) {
        offsetTop = items[0].offset;
        const lastItem = items[items.length - 1];
        bottom = lastItem.offset + lastItem.size;
    }
    const itemCount = totalCount - lastIndex;
    const total = lastOffset + itemCount * lastSize + (itemCount - 1) * gap;
    const top = offsetTop;
    const offsetBottom = total - bottom;
    return {
        items: $d72989d8b3846905$var$transposeItems(items, sizes, firstItemIndex),
        topItems: $d72989d8b3846905$var$transposeItems(topItems, sizes, firstItemIndex),
        topListHeight: topItems.reduce((height, item)=>item.size + height, 0),
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        top: top,
        bottom: bottom,
        totalCount: totalCount,
        firstItemIndex: firstItemIndex
    };
}
function $d72989d8b3846905$var$buildListStateFromItemCount(itemCount, initialTopMostItemIndex, sizes, firstItemIndex, gap, data) {
    let includedGroupsCount = 0;
    if (sizes.groupIndices.length > 0) for (const index of sizes.groupIndices){
        if (index - includedGroupsCount >= itemCount) break;
        includedGroupsCount++;
    }
    const adjustedCount = itemCount + includedGroupsCount;
    const initialTopMostItemIndexNumber = $d72989d8b3846905$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex, adjustedCount);
    const items = Array.from({
        length: adjustedCount
    }).map((_, index)=>({
            index: index + initialTopMostItemIndexNumber,
            size: 0,
            offset: 0,
            data: data[index + initialTopMostItemIndexNumber]
        }));
    return $d72989d8b3846905$var$buildListState(items, [], adjustedCount, gap, sizes, firstItemIndex);
}
const $d72989d8b3846905$var$listStateSystem = $d72989d8b3846905$var$system(([{ sizes: sizes, totalCount: totalCount, data: data, firstItemIndex: firstItemIndex, gap: gap }, groupedListSystem2, { visibleRange: visibleRange, listBoundary: listBoundary, topListHeight: rangeTopListHeight }, { scrolledToInitialItem: scrolledToInitialItem, initialTopMostItemIndex: initialTopMostItemIndex }, { topListHeight: topListHeight }, stateFlags, { didMount: didMount }, { recalcInProgress: recalcInProgress }])=>{
    const topItemsIndexes = $d72989d8b3846905$var$statefulStream([]);
    const initialItemCount = $d72989d8b3846905$var$statefulStream(0);
    const itemsRendered = $d72989d8b3846905$var$stream();
    $d72989d8b3846905$var$connect(groupedListSystem2.topItemsIndexes, topItemsIndexes);
    const listState = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(didMount, recalcInProgress, $d72989d8b3846905$var$duc(visibleRange, $d72989d8b3846905$var$tupleComparator), $d72989d8b3846905$var$duc(totalCount), $d72989d8b3846905$var$duc(sizes), $d72989d8b3846905$var$duc(initialTopMostItemIndex), scrolledToInitialItem, $d72989d8b3846905$var$duc(topItemsIndexes), $d72989d8b3846905$var$duc(firstItemIndex), $d72989d8b3846905$var$duc(gap), data), $d72989d8b3846905$var$filter(([mount, recalcInProgress2, , totalCount2, , , , , , , data2])=>{
        const dataChangeInProgress = data2 && data2.length !== totalCount2;
        return mount && !recalcInProgress2 && !dataChangeInProgress;
    }), $d72989d8b3846905$var$map(([, , [startOffset, endOffset], totalCount2, sizes2, initialTopMostItemIndex2, scrolledToInitialItem2, topItemsIndexes2, firstItemIndex2, gap2, data2])=>{
        const sizesValue = sizes2;
        const { sizeTree: sizeTree, offsetTree: offsetTree } = sizesValue;
        const initialItemCountValue = $d72989d8b3846905$var$getValue(initialItemCount);
        if (totalCount2 === 0) return (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$EMPTY_LIST_STATE), {
            totalCount: totalCount2
        });
        if (startOffset === 0 && endOffset === 0) {
            if (initialItemCountValue === 0) return (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$EMPTY_LIST_STATE), {
                totalCount: totalCount2
            });
            else return $d72989d8b3846905$var$buildListStateFromItemCount(initialItemCountValue, initialTopMostItemIndex2, sizes2, firstItemIndex2, gap2, data2 || []);
        }
        if ($d72989d8b3846905$var$empty(sizeTree)) {
            if (initialItemCountValue > 0) return null;
            const state = $d72989d8b3846905$var$buildListState($d72989d8b3846905$var$probeItemSet($d72989d8b3846905$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2), sizesValue, data2), [], totalCount2, gap2, sizesValue, firstItemIndex2);
            return state;
        }
        const topItems = [];
        if (topItemsIndexes2.length > 0) {
            const startIndex = topItemsIndexes2[0];
            const endIndex = topItemsIndexes2[topItemsIndexes2.length - 1];
            let offset = 0;
            for (const range of $d72989d8b3846905$var$rangesWithin(sizeTree, startIndex, endIndex)){
                const size = range.value;
                const rangeStartIndex = Math.max(range.start, startIndex);
                const rangeEndIndex = Math.min(range.end, endIndex);
                for(let i = rangeStartIndex; i <= rangeEndIndex; i++){
                    topItems.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size;
                }
            }
        }
        if (!scrolledToInitialItem2) return $d72989d8b3846905$var$buildListState([], topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
        const minStartIndex = topItemsIndexes2.length > 0 ? topItemsIndexes2[topItemsIndexes2.length - 1] + 1 : 0;
        const offsetPointRanges = $d72989d8b3846905$var$rangesWithinOffsets(offsetTree, startOffset, endOffset, minStartIndex);
        if (offsetPointRanges.length === 0) return null;
        const maxIndex = totalCount2 - 1;
        const items = $d72989d8b3846905$var$tap([], (result)=>{
            for (const range of offsetPointRanges){
                const point = range.value;
                let offset = point.offset;
                let rangeStartIndex = range.start;
                const size = point.size;
                if (point.offset < startOffset) {
                    rangeStartIndex += Math.floor((startOffset - point.offset + gap2) / (size + gap2));
                    const itemCount = rangeStartIndex - range.start;
                    offset += itemCount * size + itemCount * gap2;
                }
                if (rangeStartIndex < minStartIndex) {
                    offset += (minStartIndex - rangeStartIndex) * size;
                    rangeStartIndex = minStartIndex;
                }
                const endIndex = Math.min(range.end, maxIndex);
                for(let i = rangeStartIndex; i <= endIndex; i++){
                    if (offset >= endOffset) break;
                    result.push({
                        index: i,
                        size: size,
                        offset: offset,
                        data: data2 && data2[i]
                    });
                    offset += size + gap2;
                }
            }
        });
        return $d72989d8b3846905$var$buildListState(items, topItems, totalCount2, gap2, sizesValue, firstItemIndex2);
    }), //@ts-expect-error filter needs to be fixed
    $d72989d8b3846905$var$filter((value)=>value !== null), $d72989d8b3846905$var$distinctUntilChanged()), $d72989d8b3846905$var$EMPTY_LIST_STATE);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(data, $d72989d8b3846905$var$filter($d72989d8b3846905$var$isDefined), $d72989d8b3846905$var$map((data2)=>data2 == null ? void 0 : data2.length)), totalCount);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$map((value)=>value.topListHeight)), topListHeight);
    $d72989d8b3846905$var$connect(topListHeight, rangeTopListHeight);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$map((state)=>[
            state.top,
            state.bottom
        ])), listBoundary);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$map((state)=>state.items)), itemsRendered);
    const endReached = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$filter(({ items: items })=>items.length > 0), $d72989d8b3846905$var$withLatestFrom(totalCount, data), $d72989d8b3846905$var$filter(([{ items: items }, totalCount2])=>items[items.length - 1].originalIndex === totalCount2 - 1), $d72989d8b3846905$var$map(([, totalCount2, data2])=>[
            totalCount2 - 1,
            data2
        ]), $d72989d8b3846905$var$distinctUntilChanged($d72989d8b3846905$var$tupleComparator), $d72989d8b3846905$var$map(([count])=>count)));
    const startReached = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$throttleTime(200), $d72989d8b3846905$var$filter(({ items: items, topItems: topItems })=>{
        return items.length > 0 && items[0].originalIndex === topItems.length;
    }), $d72989d8b3846905$var$map(({ items: items })=>items[0].index), $d72989d8b3846905$var$distinctUntilChanged()));
    const rangeChanged = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$filter(({ items: items })=>items.length > 0), $d72989d8b3846905$var$map(({ items: items })=>{
        let startIndex = 0;
        let endIndex = items.length - 1;
        while(items[startIndex].type === "group" && startIndex < endIndex)startIndex++;
        while(items[endIndex].type === "group" && endIndex > startIndex)endIndex--;
        return {
            startIndex: items[startIndex].index,
            endIndex: items[endIndex].index
        };
    }), $d72989d8b3846905$var$distinctUntilChanged($d72989d8b3846905$var$rangeComparator)));
    return (0, $9tqwB._)({
        listState: listState,
        topItemsIndexes: topItemsIndexes,
        endReached: endReached,
        startReached: startReached,
        rangeChanged: rangeChanged,
        itemsRendered: itemsRendered,
        initialItemCount: initialItemCount
    }, stateFlags);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$groupedListSystem, $d72989d8b3846905$var$sizeRangeSystem, $d72989d8b3846905$var$initialTopMostItemIndexSystem, $d72989d8b3846905$var$scrollToIndexSystem, $d72989d8b3846905$var$stateFlagsSystem, $d72989d8b3846905$var$propsReadySystem, $d72989d8b3846905$var$recalcSystem), {
    singleton: true
});
const $d72989d8b3846905$var$initialItemCountSystem = $d72989d8b3846905$var$system(([{ sizes: sizes, firstItemIndex: firstItemIndex, data: data, gap: gap }, { initialTopMostItemIndex: initialTopMostItemIndex }, { initialItemCount: initialItemCount, listState: listState }, { didMount: didMount }])=>{
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(initialItemCount), $d72989d8b3846905$var$filter(([, count])=>count !== 0), $d72989d8b3846905$var$withLatestFrom(initialTopMostItemIndex, sizes, firstItemIndex, gap, data), $d72989d8b3846905$var$map(([[, count], initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2 = []])=>{
        return $d72989d8b3846905$var$buildListStateFromItemCount(count, initialTopMostItemIndexValue, sizes2, firstItemIndex2, gap2, data2);
    })), listState);
    return {};
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$initialTopMostItemIndexSystem, $d72989d8b3846905$var$listStateSystem, $d72989d8b3846905$var$propsReadySystem), {
    singleton: true
});
const $d72989d8b3846905$var$scrollSeekSystem = $d72989d8b3846905$var$system(([{ scrollVelocity: scrollVelocity }])=>{
    const isSeeking = $d72989d8b3846905$var$statefulStream(false);
    const rangeChanged = $d72989d8b3846905$var$stream();
    const scrollSeekConfiguration = $d72989d8b3846905$var$statefulStream(false);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollVelocity, $d72989d8b3846905$var$withLatestFrom(scrollSeekConfiguration, isSeeking, rangeChanged), $d72989d8b3846905$var$filter(([_, config])=>!!config), $d72989d8b3846905$var$map(([speed, config, isSeeking2, range])=>{
        const { exit: exit, enter: enter } = config;
        if (isSeeking2) {
            if (exit(speed, range)) return false;
        } else {
            if (enter(speed, range)) return true;
        }
        return isSeeking2;
    }), $d72989d8b3846905$var$distinctUntilChanged()), isSeeking);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(isSeeking, scrollVelocity, rangeChanged), $d72989d8b3846905$var$withLatestFrom(scrollSeekConfiguration)), ([[isSeeking2, velocity, range], config])=>isSeeking2 && config && config.change && config.change(velocity, range));
    return {
        isSeeking: isSeeking,
        scrollSeekConfiguration: scrollSeekConfiguration,
        scrollVelocity: scrollVelocity,
        scrollSeekRangeChanged: rangeChanged
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$stateFlagsSystem), {
    singleton: true
});
const $d72989d8b3846905$var$topItemCountSystem = $d72989d8b3846905$var$system(([{ topItemsIndexes: topItemsIndexes }])=>{
    const topItemCount = $d72989d8b3846905$var$statefulStream(0);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(topItemCount, $d72989d8b3846905$var$filter((length)=>length > 0), $d72989d8b3846905$var$map((length)=>Array.from({
            length: length
        }).map((_, index)=>index))), topItemsIndexes);
    return {
        topItemCount: topItemCount
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$listStateSystem));
const $d72989d8b3846905$var$totalListHeightSystem = $d72989d8b3846905$var$system(([{ footerHeight: footerHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight }, { listState: listState }])=>{
    const totalListHeightChanged = $d72989d8b3846905$var$stream();
    const totalListHeight = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(footerHeight, fixedFooterHeight, headerHeight, fixedHeaderHeight, listState), $d72989d8b3846905$var$map(([footerHeight2, fixedFooterHeight2, headerHeight2, fixedHeaderHeight2, listState2])=>{
        return footerHeight2 + fixedFooterHeight2 + headerHeight2 + fixedHeaderHeight2 + listState2.offsetBottom + listState2.bottom;
    })), 0);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$duc(totalListHeight), totalListHeightChanged);
    return {
        totalListHeight: totalListHeight,
        totalListHeightChanged: totalListHeightChanged
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$listStateSystem), {
    singleton: true
});
function $d72989d8b3846905$var$simpleMemoize(func) {
    let called = false;
    let result;
    return ()=>{
        if (!called) {
            called = true;
            result = func();
        }
        return result;
    };
}
const $d72989d8b3846905$var$isMobileSafari = $d72989d8b3846905$var$simpleMemoize(()=>{
    return /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent);
});
const $d72989d8b3846905$var$upwardScrollFixSystem = $d72989d8b3846905$var$system(([{ scrollBy: scrollBy, scrollTop: scrollTop, deviation: deviation, scrollingInProgress: scrollingInProgress }, { isScrolling: isScrolling, isAtBottom: isAtBottom, scrollDirection: scrollDirection, lastJumpDueToItemResize: lastJumpDueToItemResize }, { listState: listState }, { beforeUnshiftWith: beforeUnshiftWith, shiftWithOffset: shiftWithOffset, sizes: sizes, gap: gap }, { log: log }, { recalcInProgress: recalcInProgress }])=>{
    const deviationOffset = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$withLatestFrom(lastJumpDueToItemResize), $d72989d8b3846905$var$scan(([, prevItems, prevTotalCount, prevTotalHeight], [{ items: items, totalCount: totalCount, bottom: bottom, offsetBottom: offsetBottom }, lastJumpDueToItemResize2])=>{
        const totalHeight = bottom + offsetBottom;
        let newDev = 0;
        if (prevTotalCount === totalCount) {
            if (prevItems.length > 0 && items.length > 0) {
                const atStart = items[0].originalIndex === 0 && prevItems[0].originalIndex === 0;
                if (!atStart) {
                    newDev = totalHeight - prevTotalHeight;
                    if (newDev !== 0) newDev += lastJumpDueToItemResize2;
                }
            }
        }
        return [
            newDev,
            items,
            totalCount,
            totalHeight
        ];
    }, [
        0,
        [],
        0,
        0
    ]), $d72989d8b3846905$var$filter(([amount])=>amount !== 0), $d72989d8b3846905$var$withLatestFrom(scrollTop, scrollDirection, scrollingInProgress, isAtBottom, log, recalcInProgress), $d72989d8b3846905$var$filter(([, scrollTop2, scrollDirection2, scrollingInProgress2, , , recalcInProgress2])=>{
        return !recalcInProgress2 && !scrollingInProgress2 && scrollTop2 !== 0 && scrollDirection2 === $d72989d8b3846905$var$UP;
    }), $d72989d8b3846905$var$map(([[amount], , , , , log2])=>{
        log2("Upward scrolling compensation", {
            amount: amount
        }, $d72989d8b3846905$export$243e62d78d3b544d.DEBUG);
        return amount;
    })));
    function scrollByWith(offset) {
        if (offset > 0) {
            $d72989d8b3846905$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
            $d72989d8b3846905$var$publish(deviation, 0);
        } else {
            $d72989d8b3846905$var$publish(deviation, 0);
            $d72989d8b3846905$var$publish(scrollBy, {
                top: -offset,
                behavior: "auto"
            });
        }
    }
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(deviationOffset, $d72989d8b3846905$var$withLatestFrom(deviation, isScrolling)), ([offset, deviationAmount, isScrolling2])=>{
        if (isScrolling2 && $d72989d8b3846905$var$isMobileSafari()) $d72989d8b3846905$var$publish(deviation, deviationAmount - offset);
        else scrollByWith(-offset);
    });
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$statefulStreamFromEmitter(isScrolling, false), deviation, recalcInProgress), $d72989d8b3846905$var$filter(([is, deviation2, recalc])=>!is && !recalc && deviation2 !== 0), $d72989d8b3846905$var$map(([_, deviation2])=>deviation2), $d72989d8b3846905$var$throttleTime(1)), scrollByWith);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(shiftWithOffset, $d72989d8b3846905$var$map((offset)=>{
        return {
            top: -offset
        };
    })), scrollBy);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(beforeUnshiftWith, $d72989d8b3846905$var$withLatestFrom(sizes, gap), $d72989d8b3846905$var$map(([offset, { lastSize: defaultItemSize, groupIndices: groupIndices, sizeTree: sizeTree }, gap2])=>{
        function getItemOffset(itemCount) {
            return itemCount * (defaultItemSize + gap2);
        }
        if (groupIndices.length === 0) return getItemOffset(offset);
        else {
            let amount = 0;
            const defaultGroupSize = $d72989d8b3846905$var$find(sizeTree, 0);
            let recognizedOffsetItems = 0;
            let groupIndex = 0;
            while(recognizedOffsetItems < offset){
                recognizedOffsetItems++;
                amount += defaultGroupSize;
                let groupItemCount = groupIndices.length === groupIndex + 1 ? Infinity : groupIndices[groupIndex + 1] - groupIndices[groupIndex] - 1;
                if (recognizedOffsetItems + groupItemCount > offset) {
                    amount -= defaultGroupSize;
                    groupItemCount = offset - recognizedOffsetItems + 1;
                }
                recognizedOffsetItems += groupItemCount;
                amount += getItemOffset(groupItemCount);
                groupIndex++;
            }
            return amount;
        }
    })), (offset)=>{
        $d72989d8b3846905$var$publish(deviation, offset);
        requestAnimationFrame(()=>{
            $d72989d8b3846905$var$publish(scrollBy, {
                top: offset
            });
            requestAnimationFrame(()=>{
                $d72989d8b3846905$var$publish(deviation, 0);
                $d72989d8b3846905$var$publish(recalcInProgress, false);
            });
        });
    });
    return {
        deviation: deviation
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$stateFlagsSystem, $d72989d8b3846905$var$listStateSystem, $d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$loggerSystem, $d72989d8b3846905$var$recalcSystem));
const $d72989d8b3846905$var$initialScrollTopSystem = $d72989d8b3846905$var$system(([{ didMount: didMount }, { scrollTo: scrollTo }, { listState: listState }])=>{
    const initialScrollTop = $d72989d8b3846905$var$statefulStream(0);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(initialScrollTop), $d72989d8b3846905$var$filter(([, offset])=>offset !== 0), $d72989d8b3846905$var$map(([, offset])=>({
            top: offset
        }))), (location)=>{
        $d72989d8b3846905$var$handleNext($d72989d8b3846905$var$pipe(listState, $d72989d8b3846905$var$skip(1), $d72989d8b3846905$var$filter((state)=>state.items.length > 1)), ()=>{
            requestAnimationFrame(()=>{
                $d72989d8b3846905$var$publish(scrollTo, location);
            });
        });
    });
    return {
        initialScrollTop: initialScrollTop
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$propsReadySystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$listStateSystem), {
    singleton: true
});
const $d72989d8b3846905$var$alignToBottomSystem = $d72989d8b3846905$var$system(([{ viewportHeight: viewportHeight }, { totalListHeight: totalListHeight }])=>{
    const alignToBottom = $d72989d8b3846905$var$statefulStream(false);
    const paddingTopAddition = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(alignToBottom, viewportHeight, totalListHeight), $d72989d8b3846905$var$filter(([enabled])=>enabled), $d72989d8b3846905$var$map(([, viewportHeight2, totalListHeight2])=>{
        return Math.max(0, viewportHeight2 - totalListHeight2);
    }), $d72989d8b3846905$var$throttleTime(0), $d72989d8b3846905$var$distinctUntilChanged()), 0);
    return {
        alignToBottom: alignToBottom,
        paddingTopAddition: paddingTopAddition
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$totalListHeightSystem), {
    singleton: true
});
const $d72989d8b3846905$var$windowScrollerSystem = $d72989d8b3846905$var$system(([{ scrollTo: scrollTo, scrollContainerState: scrollContainerState }])=>{
    const windowScrollContainerState = $d72989d8b3846905$var$stream();
    const windowViewportRect = $d72989d8b3846905$var$stream();
    const windowScrollTo = $d72989d8b3846905$var$stream();
    const useWindowScroll = $d72989d8b3846905$var$statefulStream(false);
    const customScrollParent = $d72989d8b3846905$var$statefulStream(void 0);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(windowScrollContainerState, windowViewportRect), $d72989d8b3846905$var$map(([{ viewportHeight: viewportHeight, scrollTop: windowScrollTop, scrollHeight: scrollHeight }, { offsetTop: offsetTop }])=>{
        return {
            scrollTop: Math.max(0, windowScrollTop - offsetTop),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight
        };
    })), scrollContainerState);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollTo, $d72989d8b3846905$var$withLatestFrom(windowViewportRect), $d72989d8b3846905$var$map(([scrollTo2, { offsetTop: offsetTop }])=>{
        return (0, $2qxEV._)((0, $9tqwB._)({}, scrollTo2), {
            top: scrollTo2.top + offsetTop
        });
    })), windowScrollTo);
    return {
        useWindowScroll: // config
        useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: // input
        windowScrollContainerState,
        windowViewportRect: windowViewportRect,
        windowScrollTo: // signals
        windowScrollTo
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$domIOSystem));
const $d72989d8b3846905$var$defaultCalculateViewLocation = (_param)=>{
    var { itemTop: itemTop2, itemBottom: itemBottom, viewportTop: viewportTop, viewportBottom: viewportBottom, locationParams: { behavior: behavior, align: align } } = _param, rest = (0, $bLhVg._)(_param.locationParams, [
        "behavior",
        "align"
    ]);
    if (itemTop2 < viewportTop) return (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
        behavior: behavior,
        align: align != null ? align : "start"
    });
    if (itemBottom > viewportBottom) return (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
        behavior: behavior,
        align: align != null ? align : "end"
    });
    return null;
};
const $d72989d8b3846905$var$scrollIntoViewSystem = $d72989d8b3846905$var$system(([{ sizes: sizes, totalCount: totalCount, gap: gap }, { scrollTop: scrollTop, viewportHeight: viewportHeight, headerHeight: headerHeight, fixedHeaderHeight: fixedHeaderHeight, fixedFooterHeight: fixedFooterHeight, scrollingInProgress: scrollingInProgress }, { scrollToIndex: scrollToIndex }])=>{
    const scrollIntoView = $d72989d8b3846905$var$stream();
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollIntoView, $d72989d8b3846905$var$withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), $d72989d8b3846905$var$withLatestFrom(gap), $d72989d8b3846905$var$map(([[viewLocation, sizes2, viewportHeight2, totalCount2, headerHeight2, fixedHeaderHeight2, fixedFooterHeight2, scrollTop2], gap2])=>{
        const { done: done, behavior: behavior, align: align, calculateViewLocation: calculateViewLocation = $d72989d8b3846905$var$defaultCalculateViewLocation } = viewLocation, rest = (0, $bLhVg._)(viewLocation, [
            "done",
            "behavior",
            "align",
            "calculateViewLocation"
        ]);
        const actualIndex = $d72989d8b3846905$var$originalIndexFromLocation(viewLocation, sizes2, totalCount2 - 1);
        const itemTop2 = $d72989d8b3846905$var$offsetOf(actualIndex, sizes2.offsetTree, gap2) + headerHeight2 + fixedHeaderHeight2;
        const itemBottom = itemTop2 + $d72989d8b3846905$var$findMaxKeyValue(sizes2.sizeTree, actualIndex)[1];
        const viewportTop = scrollTop2 + fixedHeaderHeight2;
        const viewportBottom = scrollTop2 + viewportHeight2 - fixedFooterHeight2;
        const location = calculateViewLocation({
            itemTop: itemTop2,
            itemBottom: itemBottom,
            viewportTop: viewportTop,
            viewportBottom: viewportBottom,
            locationParams: (0, $9tqwB._)({
                behavior: behavior,
                align: align
            }, rest)
        });
        if (location) done && $d72989d8b3846905$var$handleNext($d72989d8b3846905$var$pipe(scrollingInProgress, $d72989d8b3846905$var$filter((value)=>value === false), // skips the initial publish of false, and the cleanup call.
        // but if scrollingInProgress is true, we skip the initial publish.
        $d72989d8b3846905$var$skip($d72989d8b3846905$var$getValue(scrollingInProgress) ? 1 : 2)), done);
        else done && done();
        return location;
    }), $d72989d8b3846905$var$filter((value)=>value !== null)), scrollToIndex);
    return {
        scrollIntoView: scrollIntoView
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$scrollToIndexSystem, $d72989d8b3846905$var$listStateSystem, $d72989d8b3846905$var$loggerSystem), {
    singleton: true
});
const $d72989d8b3846905$var$stateLoadSystem = $d72989d8b3846905$var$system(([{ sizes: sizes, sizeRanges: sizeRanges }, { scrollTop: scrollTop, headerHeight: headerHeight }, { initialTopMostItemIndex: initialTopMostItemIndex }, { didMount: didMount }, { useWindowScroll: useWindowScroll, windowScrollContainerState: windowScrollContainerState, windowViewportRect: windowViewportRect }])=>{
    const getState = $d72989d8b3846905$var$stream();
    const restoreStateFrom = $d72989d8b3846905$var$statefulStream(void 0);
    const statefulWindowScrollContainerState = $d72989d8b3846905$var$statefulStream(null);
    const statefulWindowViewportRect = $d72989d8b3846905$var$statefulStream(null);
    $d72989d8b3846905$var$connect(windowScrollContainerState, statefulWindowScrollContainerState);
    $d72989d8b3846905$var$connect(windowViewportRect, statefulWindowViewportRect);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(getState, $d72989d8b3846905$var$withLatestFrom(sizes, scrollTop, useWindowScroll, statefulWindowScrollContainerState, statefulWindowViewportRect, headerHeight)), ([callback, sizes2, scrollTop2, useWindowScroll2, windowScrollContainerState2, windowViewportRect2, headerHeight2])=>{
        const ranges = $d72989d8b3846905$var$sizeTreeToRanges(sizes2.sizeTree);
        if (useWindowScroll2 && windowScrollContainerState2 !== null && windowViewportRect2 !== null) scrollTop2 = windowScrollContainerState2.scrollTop - windowViewportRect2.offsetTop;
        scrollTop2 -= headerHeight2;
        callback({
            ranges: ranges,
            scrollTop: scrollTop2
        });
    });
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(restoreStateFrom, $d72989d8b3846905$var$filter($d72989d8b3846905$var$isDefined), $d72989d8b3846905$var$map($d72989d8b3846905$var$locationFromSnapshot)), initialTopMostItemIndex);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(restoreStateFrom), $d72989d8b3846905$var$filter(([, state])=>state !== void 0), $d72989d8b3846905$var$distinctUntilChanged(), $d72989d8b3846905$var$map(([, snapshot])=>{
        return snapshot.ranges;
    })), sizeRanges);
    return {
        getState: getState,
        restoreStateFrom: restoreStateFrom
    };
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$initialTopMostItemIndexSystem, $d72989d8b3846905$var$propsReadySystem, $d72989d8b3846905$var$windowScrollerSystem));
function $d72989d8b3846905$var$locationFromSnapshot(snapshot) {
    return {
        offset: snapshot.scrollTop,
        index: 0,
        align: "start"
    };
}
const $d72989d8b3846905$var$featureGroup1System = $d72989d8b3846905$var$system(([sizeRange, initialItemCount, propsReady, scrollSeek, totalListHeight, initialScrollTopSystem2, alignToBottom, windowScroller, scrollIntoView, logger])=>{
    return (0, $9tqwB._)({}, sizeRange, initialItemCount, propsReady, scrollSeek, totalListHeight, initialScrollTopSystem2, alignToBottom, windowScroller, scrollIntoView, logger);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeRangeSystem, $d72989d8b3846905$var$initialItemCountSystem, $d72989d8b3846905$var$propsReadySystem, $d72989d8b3846905$var$scrollSeekSystem, $d72989d8b3846905$var$totalListHeightSystem, $d72989d8b3846905$var$initialScrollTopSystem, $d72989d8b3846905$var$alignToBottomSystem, $d72989d8b3846905$var$windowScrollerSystem, $d72989d8b3846905$var$scrollIntoViewSystem, $d72989d8b3846905$var$loggerSystem));
const $d72989d8b3846905$var$listSystem = $d72989d8b3846905$var$system((_param)=>{
    var [{ totalCount: totalCount, sizeRanges: sizeRanges, fixedItemSize: fixedItemSize, defaultItemSize: defaultItemSize, trackItemSizes: trackItemSizes, itemSize: itemSize, data: data, firstItemIndex: firstItemIndex, groupIndices: groupIndices, statefulTotalCount: statefulTotalCount, gap: gap, sizes: sizes }, { initialTopMostItemIndex: initialTopMostItemIndex, scrolledToInitialItem: scrolledToInitialItem, initialItemFinalLocationReached: initialItemFinalLocationReached }, domIO, stateLoad, followOutput, { listState: listState, topItemsIndexes: topItemsIndexes }, { scrollToIndex: scrollToIndex }, _, { topItemCount: topItemCount }, { groupCounts: groupCounts }, featureGroup1] = _param, flags = (0, $bLhVg._)(_param[5], [
        "listState",
        "topItemsIndexes"
    ]);
    $d72989d8b3846905$var$connect(flags.rangeChanged, featureGroup1.scrollSeekRangeChanged);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(featureGroup1.windowViewportRect, $d72989d8b3846905$var$map((value)=>value.visibleHeight)), domIO.viewportHeight);
    return (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({
        totalCount: // input
        totalCount,
        data: data,
        firstItemIndex: firstItemIndex,
        sizeRanges: sizeRanges,
        initialTopMostItemIndex: initialTopMostItemIndex,
        scrolledToInitialItem: scrolledToInitialItem,
        initialItemFinalLocationReached: initialItemFinalLocationReached,
        topItemsIndexes: topItemsIndexes,
        topItemCount: topItemCount,
        groupCounts: groupCounts,
        fixedItemHeight: fixedItemSize,
        defaultItemHeight: defaultItemSize,
        gap: gap
    }, followOutput), {
        statefulTotalCount: // output
        statefulTotalCount,
        listState: listState,
        scrollToIndex: scrollToIndex,
        trackItemSizes: trackItemSizes,
        itemSize: itemSize,
        groupIndices: groupIndices
    }), flags, featureGroup1, domIO), {
        sizes: sizes
    }), stateLoad);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeSystem, $d72989d8b3846905$var$initialTopMostItemIndexSystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$stateLoadSystem, $d72989d8b3846905$var$followOutputSystem, $d72989d8b3846905$var$listStateSystem, $d72989d8b3846905$var$scrollToIndexSystem, $d72989d8b3846905$var$upwardScrollFixSystem, $d72989d8b3846905$var$topItemCountSystem, $d72989d8b3846905$var$groupedListSystem, $d72989d8b3846905$var$featureGroup1System));
const $d72989d8b3846905$var$WEBKIT_STICKY = "-webkit-sticky";
const $d72989d8b3846905$var$STICKY = "sticky";
const $d72989d8b3846905$var$positionStickyCssValue = $d72989d8b3846905$var$simpleMemoize(()=>{
    if (typeof document === "undefined") return $d72989d8b3846905$var$STICKY;
    const node = document.createElement("div");
    node.style.position = $d72989d8b3846905$var$WEBKIT_STICKY;
    return node.style.position === $d72989d8b3846905$var$WEBKIT_STICKY ? $d72989d8b3846905$var$WEBKIT_STICKY : $d72989d8b3846905$var$STICKY;
});
function $d72989d8b3846905$var$useWindowViewportRectRef(callback, customScrollParent, skipAnimationFrame) {
    const viewportInfo = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const calculateInfo = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((element)=>{
        if (element === null || !element.offsetParent) return;
        const rect = element.getBoundingClientRect();
        const visibleWidth = rect.width;
        let visibleHeight, offsetTop;
        if (customScrollParent) {
            const customScrollParentRect = customScrollParent.getBoundingClientRect();
            const deltaTop = rect.top - customScrollParentRect.top;
            visibleHeight = customScrollParentRect.height - Math.max(0, deltaTop);
            offsetTop = deltaTop + customScrollParent.scrollTop;
        } else {
            visibleHeight = window.innerHeight - Math.max(0, rect.top);
            offsetTop = rect.top + window.pageYOffset;
        }
        viewportInfo.current = {
            offsetTop: offsetTop,
            visibleHeight: visibleHeight,
            visibleWidth: visibleWidth
        };
        callback(viewportInfo.current);
    }, [
        callback,
        customScrollParent
    ]);
    const { callbackRef: callbackRef, ref: ref } = $d72989d8b3846905$var$useSizeWithElRef(calculateInfo, true, skipAnimationFrame);
    const scrollAndResizeEventHandler = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>{
        calculateInfo(ref.current);
    }, [
        calculateInfo,
        ref
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (customScrollParent) {
            customScrollParent.addEventListener("scroll", scrollAndResizeEventHandler);
            const observer = new ResizeObserver(()=>{
                requestAnimationFrame(scrollAndResizeEventHandler);
            });
            observer.observe(customScrollParent);
            return ()=>{
                customScrollParent.removeEventListener("scroll", scrollAndResizeEventHandler);
                observer.unobserve(customScrollParent);
            };
        } else {
            window.addEventListener("scroll", scrollAndResizeEventHandler);
            window.addEventListener("resize", scrollAndResizeEventHandler);
            return ()=>{
                window.removeEventListener("scroll", scrollAndResizeEventHandler);
                window.removeEventListener("resize", scrollAndResizeEventHandler);
            };
        }
    }, [
        scrollAndResizeEventHandler,
        customScrollParent
    ]);
    return callbackRef;
}
const $d72989d8b3846905$export$99e9d54e386aea7b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(void 0);
const $d72989d8b3846905$export$81e3217b4b7a890f = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(void 0);
function $d72989d8b3846905$var$identity(value) {
    return value;
}
const $d72989d8b3846905$var$listComponentPropsSystem = /* @__PURE__ */ $d72989d8b3846905$var$system(()=>{
    const itemContent = $d72989d8b3846905$var$statefulStream((index)=>`Item ${index}`);
    const context = $d72989d8b3846905$var$statefulStream(null);
    const groupContent = $d72989d8b3846905$var$statefulStream((index)=>`Group ${index}`);
    const components = $d72989d8b3846905$var$statefulStream({});
    const computeItemKey = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$identity);
    const HeaderFooterTag = $d72989d8b3846905$var$statefulStream("div");
    const scrollerRef = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(components, $d72989d8b3846905$var$map((components2)=>components2[propName]), $d72989d8b3846905$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        groupContent: groupContent,
        components: components,
        computeItemKey: computeItemKey,
        HeaderFooterTag: HeaderFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        TopItemListComponent: distinctProp("TopItemList"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        GroupComponent: distinctProp("Group", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder")
    };
});
const $d72989d8b3846905$var$combinedSystem$2 = /* @__PURE__ */ $d72989d8b3846905$var$system(([listSystem2, propsSystem])=>{
    return (0, $9tqwB._)({}, listSystem2, propsSystem);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$listSystem, $d72989d8b3846905$var$listComponentPropsSystem));
const $d72989d8b3846905$var$DefaultScrollSeekPlaceholder$1 = ({ height: height })=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            height: height
        }
    });
const $d72989d8b3846905$var$GROUP_STYLE = {
    position: $d72989d8b3846905$var$positionStickyCssValue(),
    zIndex: 1,
    overflowAnchor: "none"
};
const $d72989d8b3846905$var$ITEM_STYLE$1 = {
    overflowAnchor: "none"
};
const $d72989d8b3846905$var$HORIZONTAL_ITEM_STYLE = (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$ITEM_STYLE$1), {
    display: "inline-block",
    height: "100%"
});
const $d72989d8b3846905$var$Items$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoItems({ showTopList: showTopList = false }) {
    const listState = $d72989d8b3846905$var$useEmitterValue$2("listState");
    const sizeRanges = $d72989d8b3846905$var$usePublisher$2("sizeRanges");
    const useWindowScroll = $d72989d8b3846905$var$useEmitterValue$2("useWindowScroll");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue$2("customScrollParent");
    const windowScrollContainerStateCallback = $d72989d8b3846905$var$usePublisher$2("windowScrollContainerState");
    const _scrollContainerStateCallback = $d72989d8b3846905$var$usePublisher$2("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $d72989d8b3846905$var$useEmitterValue$2("itemContent");
    const context = $d72989d8b3846905$var$useEmitterValue$2("context");
    const groupContent = $d72989d8b3846905$var$useEmitterValue$2("groupContent");
    const trackItemSizes = $d72989d8b3846905$var$useEmitterValue$2("trackItemSizes");
    const itemSize = $d72989d8b3846905$var$useEmitterValue$2("itemSize");
    const log = $d72989d8b3846905$var$useEmitterValue$2("log");
    const listGap = $d72989d8b3846905$var$usePublisher$2("gap");
    const horizontalDirection = $d72989d8b3846905$var$useEmitterValue$2("horizontalDirection");
    const { callbackRef: callbackRef } = $d72989d8b3846905$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, showTopList ? $d72989d8b3846905$var$noop : scrollContainerStateCallback, log, listGap, customScrollParent, horizontalDirection, $d72989d8b3846905$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(0);
    $d72989d8b3846905$var$useEmitter$2("deviation", (value)=>{
        if (deviation !== value) setDeviation(value);
    });
    const EmptyPlaceholder = $d72989d8b3846905$var$useEmitterValue$2("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $d72989d8b3846905$var$useEmitterValue$2("ScrollSeekPlaceholder") || $d72989d8b3846905$var$DefaultScrollSeekPlaceholder$1;
    const ListComponent = $d72989d8b3846905$var$useEmitterValue$2("ListComponent");
    const ItemComponent = $d72989d8b3846905$var$useEmitterValue$2("ItemComponent");
    const GroupComponent = $d72989d8b3846905$var$useEmitterValue$2("GroupComponent");
    const computeItemKey = $d72989d8b3846905$var$useEmitterValue$2("computeItemKey");
    const isSeeking = $d72989d8b3846905$var$useEmitterValue$2("isSeeking");
    const hasGroups2 = $d72989d8b3846905$var$useEmitterValue$2("groupIndices").length > 0;
    const alignToBottom = $d72989d8b3846905$var$useEmitterValue$2("alignToBottom");
    const initialItemFinalLocationReached = $d72989d8b3846905$var$useEmitterValue$2("initialItemFinalLocationReached");
    const containerStyle = showTopList ? {} : (0, $9tqwB._)({
        boxSizing: "border-box"
    }, horizontalDirection ? {
        whiteSpace: "nowrap",
        display: "inline-block",
        height: "100%",
        paddingLeft: listState.offsetTop,
        paddingRight: listState.offsetBottom,
        marginLeft: deviation !== 0 ? deviation : alignToBottom ? "auto" : 0
    } : {
        marginTop: deviation !== 0 ? deviation : alignToBottom ? "auto" : 0,
        paddingTop: listState.offsetTop,
        paddingBottom: listState.offsetBottom
    }, initialItemFinalLocationReached ? {} : {
        visibility: "hidden"
    });
    if (!showTopList && listState.totalCount === 0 && EmptyPlaceholder) return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(EmptyPlaceholder, (0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(EmptyPlaceholder, context)));
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(ListComponent, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(ListComponent, context)), {
        ref: callbackRef,
        style: containerStyle,
        "data-testid": showTopList ? "virtuoso-top-item-list" : "virtuoso-item-list",
        children: (showTopList ? listState.topItems : listState.items).map((item)=>{
            const index = item.originalIndex;
            const key = computeItemKey(index + listState.firstItemIndex, item.data, context);
            if (isSeeking) return /* @__PURE__ */ (0, $7fPBF.createElement)(ScrollSeekPlaceholder, (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context)), {
                key: key,
                index: item.index,
                height: item.size,
                type: item.type || "item"
            }), item.type === "group" ? {} : {
                groupIndex: item.groupIndex
            }));
            if (item.type === "group") return /* @__PURE__ */ (0, $7fPBF.createElement)(GroupComponent, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(GroupComponent, context)), {
                key: key,
                "data-index": index,
                "data-known-size": item.size,
                "data-item-index": item.index,
                style: $d72989d8b3846905$var$GROUP_STYLE
            }), groupContent(item.index, context));
            else return /* @__PURE__ */ (0, $7fPBF.createElement)(ItemComponent, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(ItemComponent, context), $d72989d8b3846905$var$itemPropIfNotDomElement(ItemComponent, item.data)), {
                key: key,
                "data-index": index,
                "data-known-size": item.size,
                "data-item-index": item.index,
                "data-item-group-index": item.groupIndex,
                style: horizontalDirection ? $d72989d8b3846905$var$HORIZONTAL_ITEM_STYLE : $d72989d8b3846905$var$ITEM_STYLE$1
            }), hasGroups2 ? itemContent(item.index, item.groupIndex, item.data, context) : itemContent(item.index, item.data, context));
        })
    }));
});
const $d72989d8b3846905$var$scrollerStyle = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
};
const $d72989d8b3846905$var$horizontalScrollerStyle = {
    outline: "none",
    overflowX: "auto",
    position: "relative"
};
const $d72989d8b3846905$var$viewportStyle = (alignToBottom)=>(0, $9tqwB._)({
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0
    }, alignToBottom ? {
        display: "flex",
        flexDirection: "column"
    } : {});
const $d72989d8b3846905$var$topItemListStyle = {
    width: "100%",
    position: $d72989d8b3846905$var$positionStickyCssValue(),
    top: 0,
    zIndex: 1
};
function $d72989d8b3846905$var$contextPropIfNotDomElement(element, context) {
    if (typeof element === "string") return void 0;
    return {
        context: context
    };
}
function $d72989d8b3846905$var$itemPropIfNotDomElement(element, item) {
    return {
        item: typeof element === "string" ? void 0 : item
    };
}
const $d72989d8b3846905$var$Header$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoHeader() {
    const Header2 = $d72989d8b3846905$var$useEmitterValue$2("HeaderComponent");
    const headerHeight = $d72989d8b3846905$var$usePublisher$2("headerHeight");
    const HeaderFooterTag = $d72989d8b3846905$var$useEmitterValue$2("HeaderFooterTag");
    const ref = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(el)=>headerHeight($d72989d8b3846905$var$correctItemSize(el, "height")), [
        headerHeight
    ]), true, $d72989d8b3846905$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const context = $d72989d8b3846905$var$useEmitterValue$2("context");
    return Header2 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Header2, (0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(Header2, context)))
    }) : null;
});
const $d72989d8b3846905$var$Footer$1 = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoFooter() {
    const Footer2 = $d72989d8b3846905$var$useEmitterValue$2("FooterComponent");
    const footerHeight = $d72989d8b3846905$var$usePublisher$2("footerHeight");
    const HeaderFooterTag = $d72989d8b3846905$var$useEmitterValue$2("HeaderFooterTag");
    const ref = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(el)=>footerHeight($d72989d8b3846905$var$correctItemSize(el, "height")), [
        footerHeight
    ]), true, $d72989d8b3846905$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const context = $d72989d8b3846905$var$useEmitterValue$2("context");
    return Footer2 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Footer2, (0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(Footer2, context)))
    }) : null;
});
function $d72989d8b3846905$var$buildScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoScroller(_param) {
        var { style: style, children: children } = _param, props = (0, $bLhVg._)(_param, [
            "style",
            "children"
        ]);
        const scrollContainerStateCallback = usePublisher2("scrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const scrollerRefCallback = useEmitterValue2("scrollerRef");
        const context = useEmitterValue2("context");
        const horizontalDirection = useEmitterValue2("horizontalDirection") || false;
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $d72989d8b3846905$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, scrollerRefCallback, void 0, horizontalDirection);
        useEmitter2("scrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        const defaultStyle = horizontalDirection ? $d72989d8b3846905$var$horizontalScrollerStyle : $d72989d8b3846905$var$scrollerStyle;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(ScrollerComponent, (0, $2qxEV._)((0, $9tqwB._)({
            ref: scrollerRef,
            style: (0, $9tqwB._)({}, defaultStyle, style),
            "data-testid": "virtuoso-scroller",
            "data-virtuoso-scroller": true,
            tabIndex: 0
        }, props, $d72989d8b3846905$var$contextPropIfNotDomElement(ScrollerComponent, context)), {
            children: children
        }));
    });
    return Scroller2;
}
function $d72989d8b3846905$var$buildWindowScroller({ usePublisher: usePublisher2, useEmitter: useEmitter2, useEmitterValue: useEmitterValue2 }) {
    const Scroller2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoWindowScroller(_param) {
        var { style: style, children: children } = _param, props = (0, $bLhVg._)(_param, [
            "style",
            "children"
        ]);
        const scrollContainerStateCallback = usePublisher2("windowScrollContainerState");
        const ScrollerComponent = useEmitterValue2("ScrollerComponent");
        const smoothScrollTargetReached = usePublisher2("smoothScrollTargetReached");
        const totalListHeight = useEmitterValue2("totalListHeight");
        const deviation = useEmitterValue2("deviation");
        const customScrollParent = useEmitterValue2("customScrollParent");
        const context = useEmitterValue2("context");
        const { scrollerRef: scrollerRef, scrollByCallback: scrollByCallback, scrollToCallback: scrollToCallback } = $d72989d8b3846905$var$useScrollTop(scrollContainerStateCallback, smoothScrollTargetReached, ScrollerComponent, $d72989d8b3846905$var$noop, customScrollParent);
        $d72989d8b3846905$var$useIsomorphicLayoutEffect(()=>{
            scrollerRef.current = customScrollParent ? customScrollParent : window;
            return ()=>{
                scrollerRef.current = null;
            };
        }, [
            scrollerRef,
            customScrollParent
        ]);
        useEmitter2("windowScrollTo", scrollToCallback);
        useEmitter2("scrollBy", scrollByCallback);
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(ScrollerComponent, (0, $2qxEV._)((0, $9tqwB._)({
            style: (0, $9tqwB._)({
                position: "relative"
            }, style, totalListHeight !== 0 ? {
                height: totalListHeight + deviation
            } : {}),
            "data-virtuoso-scroller": true
        }, props, $d72989d8b3846905$var$contextPropIfNotDomElement(ScrollerComponent, context)), {
            children: children
        }));
    });
    return Scroller2;
}
const $d72989d8b3846905$var$Viewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($d72989d8b3846905$export$99e9d54e386aea7b);
    const viewportHeight = $d72989d8b3846905$var$usePublisher$2("viewportHeight");
    const fixedItemHeight = $d72989d8b3846905$var$usePublisher$2("fixedItemHeight");
    const alignToBottom = $d72989d8b3846905$var$useEmitterValue$2("alignToBottom");
    const horizontalDirection = $d72989d8b3846905$var$useEmitterValue$2("horizontalDirection");
    const viewportSizeCallbackMemo = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$d72989d8b3846905$var$compose(viewportHeight, (el)=>$d72989d8b3846905$var$correctItemSize(el, horizontalDirection ? "width" : "height")), [
        viewportHeight,
        horizontalDirection
    ]);
    const viewportRef = $d72989d8b3846905$var$useSize(viewportSizeCallbackMemo, true, $d72989d8b3846905$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: $d72989d8b3846905$var$viewportStyle(alignToBottom),
        ref: viewportRef,
        "data-viewport-type": "element",
        children: children
    });
};
const $d72989d8b3846905$var$WindowViewport$2 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($d72989d8b3846905$export$99e9d54e386aea7b);
    const windowViewportRect = $d72989d8b3846905$var$usePublisher$2("windowViewportRect");
    const fixedItemHeight = $d72989d8b3846905$var$usePublisher$2("fixedItemHeight");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue$2("customScrollParent");
    const viewportRef = $d72989d8b3846905$var$useWindowViewportRectRef(windowViewportRect, customScrollParent, $d72989d8b3846905$var$useEmitterValue$2("skipAnimationFrameInResizeObserver"));
    const alignToBottom = $d72989d8b3846905$var$useEmitterValue$2("alignToBottom");
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: viewportRef,
        style: $d72989d8b3846905$var$viewportStyle(alignToBottom),
        "data-viewport-type": "window",
        children: children
    });
};
const $d72989d8b3846905$var$TopItemListContainer = ({ children: children })=>{
    const TopItemList = $d72989d8b3846905$var$useEmitterValue$2("TopItemListComponent") || "div";
    const headerHeight = $d72989d8b3846905$var$useEmitterValue$2("headerHeight");
    const style = (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$topItemListStyle), {
        marginTop: `${headerHeight}px`
    });
    const context = $d72989d8b3846905$var$useEmitterValue$2("context");
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(TopItemList, (0, $2qxEV._)((0, $9tqwB._)({
        style: style
    }, $d72989d8b3846905$var$contextPropIfNotDomElement(TopItemList, context)), {
        children: children
    }));
};
const $d72989d8b3846905$var$ListRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoRoot(props) {
    const useWindowScroll = $d72989d8b3846905$var$useEmitterValue$2("useWindowScroll");
    const showTopList = $d72989d8b3846905$var$useEmitterValue$2("topItemsIndexes").length > 0;
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue$2("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $d72989d8b3846905$var$WindowScroller$2 : $d72989d8b3846905$var$Scroller$2;
    const TheViewport = customScrollParent || useWindowScroll ? $d72989d8b3846905$var$WindowViewport$2 : $d72989d8b3846905$var$Viewport$2;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(TheScroller, (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        children: [
            showTopList && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$TopItemListContainer, {
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Items$1, {
                    showTopList: true
                })
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(TheViewport, {
                children: [
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Header$1, {}),
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Items$1, {}),
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Footer$1, {})
                ]
            })
        ]
    }));
});
const { Component: $d72989d8b3846905$var$List, usePublisher: $d72989d8b3846905$var$usePublisher$2, useEmitterValue: $d72989d8b3846905$var$useEmitterValue$2, useEmitter: $d72989d8b3846905$var$useEmitter$2 } = /* @__PURE__ */ $d72989d8b3846905$var$systemToComponent($d72989d8b3846905$var$combinedSystem$2, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        itemContent: "itemContent",
        groupContent: "groupContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        groupCounts: "groupCounts",
        topItemCount: "topItemCount",
        firstItemIndex: "firstItemIndex",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "HeaderFooterTag",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        horizontalDirection: "horizontalDirection",
        skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        autoscrollToBottom: "autoscrollToBottom",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $d72989d8b3846905$var$ListRoot);
const $d72989d8b3846905$var$Scroller$2 = /* @__PURE__ */ $d72989d8b3846905$var$buildScroller({
    usePublisher: $d72989d8b3846905$var$usePublisher$2,
    useEmitterValue: $d72989d8b3846905$var$useEmitterValue$2,
    useEmitter: $d72989d8b3846905$var$useEmitter$2
});
const $d72989d8b3846905$var$WindowScroller$2 = /* @__PURE__ */ $d72989d8b3846905$var$buildWindowScroller({
    usePublisher: $d72989d8b3846905$var$usePublisher$2,
    useEmitterValue: $d72989d8b3846905$var$useEmitterValue$2,
    useEmitter: $d72989d8b3846905$var$useEmitter$2
});
const $d72989d8b3846905$export$ea50ab61e1198ee3 = $d72989d8b3846905$var$List;
const $d72989d8b3846905$export$41737384f976dee3 = $d72989d8b3846905$var$List;
const $d72989d8b3846905$var$INITIAL_GRID_STATE = {
    items: [],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const $d72989d8b3846905$var$PROBE_GRID_STATE = {
    items: [
        {
            index: 0
        }
    ],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
};
const { round: $d72989d8b3846905$var$round, ceil: $d72989d8b3846905$var$ceil, floor: $d72989d8b3846905$var$floor, min: $d72989d8b3846905$var$min, max: $d72989d8b3846905$var$max } = Math;
function $d72989d8b3846905$var$buildProbeGridState(items) {
    return (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$PROBE_GRID_STATE), {
        items: items
    });
}
function $d72989d8b3846905$var$buildItems(startIndex, endIndex, data) {
    return Array.from({
        length: endIndex - startIndex + 1
    }).map((_, i)=>{
        const dataItem = data === null ? null : data[i + startIndex];
        return {
            index: i + startIndex,
            data: dataItem
        };
    });
}
function $d72989d8b3846905$var$gapComparator(prev, next) {
    return prev && prev.column === next.column && prev.row === next.row;
}
function $d72989d8b3846905$var$dimensionComparator(prev, next) {
    return prev && prev.width === next.width && prev.height === next.height;
}
const $d72989d8b3846905$var$gridSystem = /* @__PURE__ */ $d72989d8b3846905$var$system(([{ overscan: overscan, visibleRange: visibleRange, listBoundary: listBoundary }, { scrollTop: scrollTop, viewportHeight: viewportHeight, scrollBy: scrollBy, scrollTo: scrollTo, smoothScrollTargetReached: smoothScrollTargetReached, scrollContainerState: scrollContainerState, footerHeight: footerHeight, headerHeight: headerHeight }, stateFlags, scrollSeek, { propsReady: propsReady, didMount: didMount }, { windowViewportRect: windowViewportRect, useWindowScroll: useWindowScroll, customScrollParent: customScrollParent, windowScrollContainerState: windowScrollContainerState, windowScrollTo: windowScrollTo }, log])=>{
    const totalCount = $d72989d8b3846905$var$statefulStream(0);
    const initialItemCount = $d72989d8b3846905$var$statefulStream(0);
    const gridState = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$INITIAL_GRID_STATE);
    const viewportDimensions = $d72989d8b3846905$var$statefulStream({
        height: 0,
        width: 0
    });
    const itemDimensions = $d72989d8b3846905$var$statefulStream({
        height: 0,
        width: 0
    });
    const scrollToIndex = $d72989d8b3846905$var$stream();
    const scrollHeight = $d72989d8b3846905$var$stream();
    const deviation = $d72989d8b3846905$var$statefulStream(0);
    const data = $d72989d8b3846905$var$statefulStream(null);
    const gap = $d72989d8b3846905$var$statefulStream({
        row: 0,
        column: 0
    });
    const stateChanged = $d72989d8b3846905$var$stream();
    const restoreStateFrom = $d72989d8b3846905$var$stream();
    const stateRestoreInProgress = $d72989d8b3846905$var$statefulStream(false);
    const initialTopMostItemIndex = $d72989d8b3846905$var$statefulStream(0);
    const scrolledToInitialItem = $d72989d8b3846905$var$statefulStream(true);
    const scrollScheduled = $d72989d8b3846905$var$statefulStream(false);
    const horizontalDirection = $d72989d8b3846905$var$statefulStream(false);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(initialTopMostItemIndex), $d72989d8b3846905$var$filter(([_, location])=>!!location)), ()=>{
        $d72989d8b3846905$var$publish(scrolledToInitialItem, false);
    });
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(didMount, scrolledToInitialItem, itemDimensions, viewportDimensions, initialTopMostItemIndex, scrollScheduled), $d72989d8b3846905$var$filter(([didMount2, scrolledToInitialItem2, itemDimensions2, viewportDimensions2, , scrollScheduled2])=>{
        return didMount2 && !scrolledToInitialItem2 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0 && !scrollScheduled2;
    })), ([, , , , initialTopMostItemIndex2])=>{
        $d72989d8b3846905$var$publish(scrollScheduled, true);
        $d72989d8b3846905$var$skipFrames(1, ()=>{
            $d72989d8b3846905$var$publish(scrollToIndex, initialTopMostItemIndex2);
        });
        $d72989d8b3846905$var$handleNext($d72989d8b3846905$var$pipe(scrollTop), ()=>{
            $d72989d8b3846905$var$publish(listBoundary, [
                0,
                0
            ]);
            $d72989d8b3846905$var$publish(scrolledToInitialItem, true);
        });
    });
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(restoreStateFrom, $d72989d8b3846905$var$filter((value)=>value !== void 0 && value !== null && value.scrollTop > 0), $d72989d8b3846905$var$mapTo(0)), initialItemCount);
    $d72989d8b3846905$var$subscribe($d72989d8b3846905$var$pipe(didMount, $d72989d8b3846905$var$withLatestFrom(restoreStateFrom), $d72989d8b3846905$var$filter(([, snapshot])=>snapshot !== void 0 && snapshot !== null)), ([, snapshot])=>{
        if (!snapshot) return;
        $d72989d8b3846905$var$publish(viewportDimensions, snapshot.viewport), $d72989d8b3846905$var$publish(itemDimensions, snapshot == null ? void 0 : snapshot.item);
        $d72989d8b3846905$var$publish(gap, snapshot.gap);
        if (snapshot.scrollTop > 0) {
            $d72989d8b3846905$var$publish(stateRestoreInProgress, true);
            $d72989d8b3846905$var$handleNext($d72989d8b3846905$var$pipe(scrollTop, $d72989d8b3846905$var$skip(1)), (_value)=>{
                $d72989d8b3846905$var$publish(stateRestoreInProgress, false);
            });
            $d72989d8b3846905$var$publish(scrollTo, {
                top: snapshot.scrollTop
            });
        }
    });
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(viewportDimensions, $d72989d8b3846905$var$map(({ height: height })=>height)), viewportHeight);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$duc(viewportDimensions, $d72989d8b3846905$var$dimensionComparator), $d72989d8b3846905$var$duc(itemDimensions, $d72989d8b3846905$var$dimensionComparator), $d72989d8b3846905$var$duc(gap, (prev, next)=>prev && prev.column === next.column && prev.row === next.row), $d72989d8b3846905$var$duc(scrollTop)), $d72989d8b3846905$var$map(([viewport, item, gap2, scrollTop2])=>({
            viewport: viewport,
            item: item,
            gap: gap2,
            scrollTop: scrollTop2
        }))), stateChanged);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest($d72989d8b3846905$var$duc(totalCount), visibleRange, $d72989d8b3846905$var$duc(gap, $d72989d8b3846905$var$gapComparator), $d72989d8b3846905$var$duc(itemDimensions, $d72989d8b3846905$var$dimensionComparator), $d72989d8b3846905$var$duc(viewportDimensions, $d72989d8b3846905$var$dimensionComparator), $d72989d8b3846905$var$duc(data), $d72989d8b3846905$var$duc(initialItemCount), $d72989d8b3846905$var$duc(stateRestoreInProgress), $d72989d8b3846905$var$duc(scrolledToInitialItem), $d72989d8b3846905$var$duc(initialTopMostItemIndex)), $d72989d8b3846905$var$filter(([, , , , , , , stateRestoreInProgress2])=>{
        return !stateRestoreInProgress2;
    }), $d72989d8b3846905$var$map(([totalCount2, [startOffset, endOffset], gap2, item, viewport, data2, initialItemCount2, , scrolledToInitialItem2, initialTopMostItemIndex2])=>{
        const { row: rowGap, column: columnGap } = gap2;
        const { height: itemHeight, width: itemWidth } = item;
        const { width: viewportWidth } = viewport;
        if (initialItemCount2 === 0 && (totalCount2 === 0 || viewportWidth === 0)) return $d72989d8b3846905$var$INITIAL_GRID_STATE;
        if (itemWidth === 0) {
            const startIndex2 = $d72989d8b3846905$var$getInitialTopMostItemIndexNumber(initialTopMostItemIndex2, totalCount2);
            const endIndex2 = Math.max(startIndex2 + initialItemCount2 - 1, 0);
            return $d72989d8b3846905$var$buildProbeGridState($d72989d8b3846905$var$buildItems(startIndex2, endIndex2, data2));
        }
        const perRow = $d72989d8b3846905$var$itemsPerRow(viewportWidth, itemWidth, columnGap);
        let startIndex;
        let endIndex;
        if (!scrolledToInitialItem2) {
            startIndex = 0;
            endIndex = -1;
        } else if (startOffset === 0 && endOffset === 0 && initialItemCount2 > 0) {
            startIndex = 0;
            endIndex = initialItemCount2 - 1;
        } else {
            startIndex = perRow * $d72989d8b3846905$var$floor((startOffset + rowGap) / (itemHeight + rowGap));
            endIndex = perRow * $d72989d8b3846905$var$ceil((endOffset + rowGap) / (itemHeight + rowGap)) - 1;
            endIndex = $d72989d8b3846905$var$min(totalCount2 - 1, $d72989d8b3846905$var$max(endIndex, perRow - 1));
            startIndex = $d72989d8b3846905$var$min(endIndex, $d72989d8b3846905$var$max(0, startIndex));
        }
        const items = $d72989d8b3846905$var$buildItems(startIndex, endIndex, data2);
        const { top: top, bottom: bottom } = $d72989d8b3846905$var$gridLayout(viewport, gap2, item, items);
        const rowCount = $d72989d8b3846905$var$ceil(totalCount2 / perRow);
        const totalHeight = rowCount * itemHeight + (rowCount - 1) * rowGap;
        const offsetBottom = totalHeight - bottom;
        return {
            items: items,
            offsetTop: top,
            offsetBottom: offsetBottom,
            top: top,
            bottom: bottom,
            itemHeight: itemHeight,
            itemWidth: itemWidth
        };
    })), gridState);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(data, $d72989d8b3846905$var$filter((data2)=>data2 !== null), $d72989d8b3846905$var$map((data2)=>data2.length)), totalCount);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe($d72989d8b3846905$var$combineLatest(viewportDimensions, itemDimensions, gridState, gap), $d72989d8b3846905$var$filter(([viewportDimensions2, itemDimensions2, { items: items }])=>{
        return items.length > 0 && itemDimensions2.height !== 0 && viewportDimensions2.height !== 0;
    }), $d72989d8b3846905$var$map(([viewportDimensions2, itemDimensions2, { items: items }, gap2])=>{
        const { top: top, bottom: bottom } = $d72989d8b3846905$var$gridLayout(viewportDimensions2, gap2, itemDimensions2, items);
        return [
            top,
            bottom
        ];
    }), $d72989d8b3846905$var$distinctUntilChanged($d72989d8b3846905$var$tupleComparator)), listBoundary);
    const hasScrolled = $d72989d8b3846905$var$statefulStream(false);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollTop, $d72989d8b3846905$var$withLatestFrom(hasScrolled), $d72989d8b3846905$var$map(([scrollTop2, hasScrolled2])=>{
        return hasScrolled2 || scrollTop2 !== 0;
    })), hasScrolled);
    const endReached = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$duc(gridState), $d72989d8b3846905$var$filter(({ items: items })=>items.length > 0), $d72989d8b3846905$var$withLatestFrom(totalCount, hasScrolled), $d72989d8b3846905$var$filter(([{ items: items }, totalCount2, hasScrolled2])=>hasScrolled2 && items[items.length - 1].index === totalCount2 - 1), $d72989d8b3846905$var$map(([, totalCount2])=>totalCount2 - 1), $d72989d8b3846905$var$distinctUntilChanged()));
    const startReached = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$duc(gridState), $d72989d8b3846905$var$filter(({ items: items })=>{
        return items.length > 0 && items[0].index === 0;
    }), // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    $d72989d8b3846905$var$mapTo(0), $d72989d8b3846905$var$distinctUntilChanged()));
    const rangeChanged = $d72989d8b3846905$var$streamFromEmitter($d72989d8b3846905$var$pipe($d72989d8b3846905$var$duc(gridState), $d72989d8b3846905$var$withLatestFrom(stateRestoreInProgress), $d72989d8b3846905$var$filter(([{ items: items }, stateRestoreInProgress2])=>items.length > 0 && !stateRestoreInProgress2), $d72989d8b3846905$var$map(([{ items: items }])=>{
        return {
            startIndex: items[0].index,
            endIndex: items[items.length - 1].index
        };
    }), $d72989d8b3846905$var$distinctUntilChanged($d72989d8b3846905$var$rangeComparator), $d72989d8b3846905$var$throttleTime(0)));
    $d72989d8b3846905$var$connect(rangeChanged, scrollSeek.scrollSeekRangeChanged);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(scrollToIndex, $d72989d8b3846905$var$withLatestFrom(viewportDimensions, itemDimensions, totalCount, gap), $d72989d8b3846905$var$map(([location, viewportDimensions2, itemDimensions2, totalCount2, gap2])=>{
        const normalLocation = $d72989d8b3846905$var$normalizeIndexLocation(location);
        const { align: align, behavior: behavior, offset: offset } = normalLocation;
        let index = normalLocation.index;
        if (index === "LAST") index = totalCount2 - 1;
        index = $d72989d8b3846905$var$max(0, index, $d72989d8b3846905$var$min(totalCount2 - 1, index));
        let top = $d72989d8b3846905$var$itemTop(viewportDimensions2, gap2, itemDimensions2, index);
        if (align === "end") top = $d72989d8b3846905$var$round(top - viewportDimensions2.height + itemDimensions2.height);
        else if (align === "center") top = $d72989d8b3846905$var$round(top - viewportDimensions2.height / 2 + itemDimensions2.height / 2);
        if (offset) top += offset;
        return {
            top: top,
            behavior: behavior
        };
    })), scrollTo);
    const totalListHeight = $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(gridState, $d72989d8b3846905$var$map((gridState2)=>{
        return gridState2.offsetBottom + gridState2.bottom;
    })), 0);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$pipe(windowViewportRect, $d72989d8b3846905$var$map((viewportInfo)=>({
            width: viewportInfo.visibleWidth,
            height: viewportInfo.visibleHeight
        }))), viewportDimensions);
    return (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({
        data: // input
        data,
        totalCount: totalCount,
        viewportDimensions: viewportDimensions,
        itemDimensions: itemDimensions,
        scrollTop: scrollTop,
        scrollHeight: scrollHeight,
        overscan: overscan,
        scrollBy: scrollBy,
        scrollTo: scrollTo,
        scrollToIndex: scrollToIndex,
        smoothScrollTargetReached: smoothScrollTargetReached,
        windowViewportRect: windowViewportRect,
        windowScrollTo: windowScrollTo,
        useWindowScroll: useWindowScroll,
        customScrollParent: customScrollParent,
        windowScrollContainerState: windowScrollContainerState,
        deviation: deviation,
        scrollContainerState: scrollContainerState,
        footerHeight: footerHeight,
        headerHeight: headerHeight,
        initialItemCount: initialItemCount,
        gap: gap,
        restoreStateFrom: restoreStateFrom
    }, scrollSeek), {
        initialTopMostItemIndex: initialTopMostItemIndex,
        horizontalDirection: horizontalDirection,
        gridState: // output
        gridState,
        totalListHeight: totalListHeight
    }), stateFlags), {
        startReached: startReached,
        endReached: endReached,
        rangeChanged: rangeChanged,
        stateChanged: stateChanged,
        propsReady: propsReady,
        stateRestoreInProgress: stateRestoreInProgress
    }), log);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$sizeRangeSystem, $d72989d8b3846905$var$domIOSystem, $d72989d8b3846905$var$stateFlagsSystem, $d72989d8b3846905$var$scrollSeekSystem, $d72989d8b3846905$var$propsReadySystem, $d72989d8b3846905$var$windowScrollerSystem, $d72989d8b3846905$var$loggerSystem));
function $d72989d8b3846905$var$gridLayout(viewport, gap, item, items) {
    const { height: itemHeight } = item;
    if (itemHeight === void 0 || items.length === 0) return {
        top: 0,
        bottom: 0
    };
    const top = $d72989d8b3846905$var$itemTop(viewport, gap, item, items[0].index);
    const bottom = $d72989d8b3846905$var$itemTop(viewport, gap, item, items[items.length - 1].index) + itemHeight;
    return {
        top: top,
        bottom: bottom
    };
}
function $d72989d8b3846905$var$itemTop(viewport, gap, item, index) {
    const perRow = $d72989d8b3846905$var$itemsPerRow(viewport.width, item.width, gap.column);
    const rowCount = $d72989d8b3846905$var$floor(index / perRow);
    const top = rowCount * item.height + $d72989d8b3846905$var$max(0, rowCount - 1) * gap.row;
    return top > 0 ? top + gap.row : top;
}
function $d72989d8b3846905$var$itemsPerRow(viewportWidth, itemWidth, gap) {
    return $d72989d8b3846905$var$max(1, $d72989d8b3846905$var$floor((viewportWidth + gap) / ($d72989d8b3846905$var$floor(itemWidth) + gap)));
}
const $d72989d8b3846905$var$gridComponentPropsSystem = /* @__PURE__ */ $d72989d8b3846905$var$system(()=>{
    const itemContent = $d72989d8b3846905$var$statefulStream((index)=>`Item ${index}`);
    const components = $d72989d8b3846905$var$statefulStream({});
    const context = $d72989d8b3846905$var$statefulStream(null);
    const itemClassName = $d72989d8b3846905$var$statefulStream("virtuoso-grid-item");
    const listClassName = $d72989d8b3846905$var$statefulStream("virtuoso-grid-list");
    const computeItemKey = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$identity);
    const headerFooterTag = $d72989d8b3846905$var$statefulStream("div");
    const scrollerRef = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(components, $d72989d8b3846905$var$map((components2)=>components2[propName]), $d72989d8b3846905$var$distinctUntilChanged()), defaultValue);
    };
    const readyStateChanged = $d72989d8b3846905$var$statefulStream(false);
    const reportReadyState = $d72989d8b3846905$var$statefulStream(false);
    $d72989d8b3846905$var$connect($d72989d8b3846905$var$duc(reportReadyState), readyStateChanged);
    return {
        readyStateChanged: readyStateChanged,
        reportReadyState: reportReadyState,
        context: context,
        itemContent: itemContent,
        components: components,
        computeItemKey: computeItemKey,
        itemClassName: itemClassName,
        listClassName: listClassName,
        headerFooterTag: headerFooterTag,
        scrollerRef: scrollerRef,
        FooterComponent: distinctProp("Footer"),
        HeaderComponent: distinctProp("Header"),
        ListComponent: distinctProp("List", "div"),
        ItemComponent: distinctProp("Item", "div"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder", "div")
    };
});
const $d72989d8b3846905$var$combinedSystem$1 = /* @__PURE__ */ $d72989d8b3846905$var$system(([gridSystem2, gridComponentPropsSystem2])=>{
    return (0, $9tqwB._)({}, gridSystem2, gridComponentPropsSystem2);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$gridSystem, $d72989d8b3846905$var$gridComponentPropsSystem));
const $d72989d8b3846905$var$GridItems = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function GridItems2() {
    const gridState = $d72989d8b3846905$var$useEmitterValue$1("gridState");
    const listClassName = $d72989d8b3846905$var$useEmitterValue$1("listClassName");
    const itemClassName = $d72989d8b3846905$var$useEmitterValue$1("itemClassName");
    const itemContent = $d72989d8b3846905$var$useEmitterValue$1("itemContent");
    const computeItemKey = $d72989d8b3846905$var$useEmitterValue$1("computeItemKey");
    const isSeeking = $d72989d8b3846905$var$useEmitterValue$1("isSeeking");
    const scrollHeightCallback = $d72989d8b3846905$var$usePublisher$1("scrollHeight");
    const ItemComponent = $d72989d8b3846905$var$useEmitterValue$1("ItemComponent");
    const ListComponent = $d72989d8b3846905$var$useEmitterValue$1("ListComponent");
    const ScrollSeekPlaceholder = $d72989d8b3846905$var$useEmitterValue$1("ScrollSeekPlaceholder");
    const context = $d72989d8b3846905$var$useEmitterValue$1("context");
    const itemDimensions = $d72989d8b3846905$var$usePublisher$1("itemDimensions");
    const gridGap = $d72989d8b3846905$var$usePublisher$1("gap");
    const log = $d72989d8b3846905$var$useEmitterValue$1("log");
    const stateRestoreInProgress = $d72989d8b3846905$var$useEmitterValue$1("stateRestoreInProgress");
    const reportReadyState = $d72989d8b3846905$var$usePublisher$1("reportReadyState");
    const listRef = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(el)=>{
            const scrollHeight = el.parentElement.parentElement.scrollHeight;
            scrollHeightCallback(scrollHeight);
            const firstItem = el.firstChild;
            if (firstItem) {
                const { width: width, height: height } = firstItem.getBoundingClientRect();
                itemDimensions({
                    width: width,
                    height: height
                });
            }
            gridGap({
                row: $d72989d8b3846905$var$resolveGapValue("row-gap", getComputedStyle(el).rowGap, log),
                column: $d72989d8b3846905$var$resolveGapValue("column-gap", getComputedStyle(el).columnGap, log)
            });
        }, [
        scrollHeightCallback,
        itemDimensions,
        gridGap,
        log
    ]), true, false);
    $d72989d8b3846905$var$useIsomorphicLayoutEffect(()=>{
        if (gridState.itemHeight > 0 && gridState.itemWidth > 0) reportReadyState(true);
    }, [
        gridState
    ]);
    if (stateRestoreInProgress) return null;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(ListComponent, (0, $2qxEV._)((0, $9tqwB._)({
        ref: listRef,
        className: listClassName
    }, $d72989d8b3846905$var$contextPropIfNotDomElement(ListComponent, context)), {
        style: {
            paddingTop: gridState.offsetTop,
            paddingBottom: gridState.offsetBottom
        },
        "data-testid": "virtuoso-item-list",
        children: gridState.items.map((item)=>{
            const key = computeItemKey(item.index, item.data, context);
            return isSeeking ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(ScrollSeekPlaceholder, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context)), {
                index: item.index,
                height: gridState.itemHeight,
                width: gridState.itemWidth
            }), key) : /* @__PURE__ */ (0, $7fPBF.createElement)(ItemComponent, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(ItemComponent, context)), {
                className: itemClassName,
                "data-index": item.index,
                key: key
            }), itemContent(item.index, item.data, context));
        })
    }));
});
const $d72989d8b3846905$var$Header = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoHeader2() {
    const Header2 = $d72989d8b3846905$var$useEmitterValue$1("HeaderComponent");
    const headerHeight = $d72989d8b3846905$var$usePublisher$1("headerHeight");
    const HeaderFooterTag = $d72989d8b3846905$var$useEmitterValue$1("headerFooterTag");
    const ref = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(el)=>headerHeight($d72989d8b3846905$var$correctItemSize(el, "height")), [
        headerHeight
    ]), true, false);
    const context = $d72989d8b3846905$var$useEmitterValue$1("context");
    return Header2 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Header2, (0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(Header2, context)))
    }) : null;
});
const $d72989d8b3846905$var$Footer = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoGridFooter() {
    const Footer2 = $d72989d8b3846905$var$useEmitterValue$1("FooterComponent");
    const footerHeight = $d72989d8b3846905$var$usePublisher$1("footerHeight");
    const HeaderFooterTag = $d72989d8b3846905$var$useEmitterValue$1("headerFooterTag");
    const ref = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(el)=>footerHeight($d72989d8b3846905$var$correctItemSize(el, "height")), [
        footerHeight
    ]), true, false);
    const context = $d72989d8b3846905$var$useEmitterValue$1("context");
    return Footer2 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(HeaderFooterTag, {
        ref: ref,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Footer2, (0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(Footer2, context)))
    }) : null;
});
const $d72989d8b3846905$var$Viewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($d72989d8b3846905$export$81e3217b4b7a890f);
    const itemDimensions = $d72989d8b3846905$var$usePublisher$1("itemDimensions");
    const viewportDimensions = $d72989d8b3846905$var$usePublisher$1("viewportDimensions");
    const viewportRef = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(el)=>{
            viewportDimensions(el.getBoundingClientRect());
        }, [
        viewportDimensions
    ]), true, false);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (ctx) {
            viewportDimensions({
                height: ctx.viewportHeight,
                width: ctx.viewportWidth
            });
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
        }
    }, [
        ctx,
        viewportDimensions,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: $d72989d8b3846905$var$viewportStyle(false),
        ref: viewportRef,
        children: children
    });
};
const $d72989d8b3846905$var$WindowViewport$1 = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($d72989d8b3846905$export$81e3217b4b7a890f);
    const windowViewportRect = $d72989d8b3846905$var$usePublisher$1("windowViewportRect");
    const itemDimensions = $d72989d8b3846905$var$usePublisher$1("itemDimensions");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue$1("customScrollParent");
    const viewportRef = $d72989d8b3846905$var$useWindowViewportRectRef(windowViewportRect, customScrollParent, false);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (ctx) {
            itemDimensions({
                height: ctx.itemHeight,
                width: ctx.itemWidth
            });
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: ctx.viewportWidth
            });
        }
    }, [
        ctx,
        windowViewportRect,
        itemDimensions
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: viewportRef,
        style: $d72989d8b3846905$var$viewportStyle(false),
        children: children
    });
};
const $d72989d8b3846905$var$GridRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function GridRoot2(_param) {
    var props = (0, $8d60f2ee7fd1c983$export$71511d61b312f219)({}, (0, $7ae6b455e4a352e9$export$71511d61b312f219)(_param));
    const useWindowScroll = $d72989d8b3846905$var$useEmitterValue$1("useWindowScroll");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue$1("customScrollParent");
    const TheScroller = customScrollParent || useWindowScroll ? $d72989d8b3846905$var$WindowScroller$1 : $d72989d8b3846905$var$Scroller$1;
    const TheViewport = customScrollParent || useWindowScroll ? $d72989d8b3846905$var$WindowViewport$1 : $d72989d8b3846905$var$Viewport$1;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(TheScroller, (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(TheViewport, {
            children: [
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Header, {}),
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$GridItems, {}),
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Footer, {})
            ]
        })
    }));
});
const { Component: $d72989d8b3846905$var$Grid, usePublisher: $d72989d8b3846905$var$usePublisher$1, useEmitterValue: $d72989d8b3846905$var$useEmitterValue$1, useEmitter: $d72989d8b3846905$var$useEmitter$1 } = /* @__PURE__ */ $d72989d8b3846905$var$systemToComponent($d72989d8b3846905$var$combinedSystem$1, {
    optional: {
        context: "context",
        totalCount: "totalCount",
        overscan: "overscan",
        itemContent: "itemContent",
        components: "components",
        computeItemKey: "computeItemKey",
        data: "data",
        initialItemCount: "initialItemCount",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        listClassName: "listClassName",
        itemClassName: "itemClassName",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        restoreStateFrom: "restoreStateFrom",
        initialTopMostItemIndex: "initialTopMostItemIndex"
    },
    methods: {
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        scrollToIndex: "scrollToIndex"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        stateChanged: "stateChanged",
        readyStateChanged: "readyStateChanged"
    }
}, $d72989d8b3846905$var$GridRoot);
const $d72989d8b3846905$var$Scroller$1 = /* @__PURE__ */ $d72989d8b3846905$var$buildScroller({
    usePublisher: $d72989d8b3846905$var$usePublisher$1,
    useEmitterValue: $d72989d8b3846905$var$useEmitterValue$1,
    useEmitter: $d72989d8b3846905$var$useEmitter$1
});
const $d72989d8b3846905$var$WindowScroller$1 = /* @__PURE__ */ $d72989d8b3846905$var$buildWindowScroller({
    usePublisher: $d72989d8b3846905$var$usePublisher$1,
    useEmitterValue: $d72989d8b3846905$var$useEmitterValue$1,
    useEmitter: $d72989d8b3846905$var$useEmitter$1
});
function $d72989d8b3846905$var$resolveGapValue(property, value, log) {
    if (value !== "normal" && !(value == null ? void 0 : value.endsWith("px"))) log(`${property} was not resolved to pixel value correctly`, value, $d72989d8b3846905$export$243e62d78d3b544d.WARN);
    if (value === "normal") return 0;
    return parseInt(value != null ? value : "0", 10);
}
const $d72989d8b3846905$export$eef3fd285144b65e = $d72989d8b3846905$var$Grid;
const $d72989d8b3846905$var$tableComponentPropsSystem = /* @__PURE__ */ $d72989d8b3846905$var$system(()=>{
    const itemContent = $d72989d8b3846905$var$statefulStream((index)=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("td", {
            children: [
                "Item $",
                index
            ]
        }));
    const context = $d72989d8b3846905$var$statefulStream(null);
    const fixedHeaderContent = $d72989d8b3846905$var$statefulStream(null);
    const fixedFooterContent = $d72989d8b3846905$var$statefulStream(null);
    const components = $d72989d8b3846905$var$statefulStream({});
    const computeItemKey = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$identity);
    const scrollerRef = $d72989d8b3846905$var$statefulStream($d72989d8b3846905$var$noop);
    const distinctProp = (propName, defaultValue = null)=>{
        return $d72989d8b3846905$var$statefulStreamFromEmitter($d72989d8b3846905$var$pipe(components, $d72989d8b3846905$var$map((components2)=>components2[propName]), $d72989d8b3846905$var$distinctUntilChanged()), defaultValue);
    };
    return {
        context: context,
        itemContent: itemContent,
        fixedHeaderContent: fixedHeaderContent,
        fixedFooterContent: fixedFooterContent,
        components: components,
        computeItemKey: computeItemKey,
        scrollerRef: scrollerRef,
        TableComponent: distinctProp("Table", "table"),
        TableHeadComponent: distinctProp("TableHead", "thead"),
        TableFooterComponent: distinctProp("TableFoot", "tfoot"),
        TableBodyComponent: distinctProp("TableBody", "tbody"),
        TableRowComponent: distinctProp("TableRow", "tr"),
        ScrollerComponent: distinctProp("Scroller", "div"),
        EmptyPlaceholder: distinctProp("EmptyPlaceholder"),
        ScrollSeekPlaceholder: distinctProp("ScrollSeekPlaceholder"),
        FillerRow: distinctProp("FillerRow")
    };
});
const $d72989d8b3846905$var$combinedSystem = /* @__PURE__ */ $d72989d8b3846905$var$system(([listSystem2, propsSystem])=>{
    return (0, $9tqwB._)({}, listSystem2, propsSystem);
}, $d72989d8b3846905$var$tup($d72989d8b3846905$var$listSystem, $d72989d8b3846905$var$tableComponentPropsSystem));
const $d72989d8b3846905$var$DefaultScrollSeekPlaceholder = ({ height: height })=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("tr", {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("td", {
            style: {
                height: height
            }
        })
    });
const $d72989d8b3846905$var$DefaultFillerRow = ({ height: height })=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("tr", {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("td", {
            style: {
                height: height,
                padding: 0,
                border: 0
            }
        })
    });
const $d72989d8b3846905$var$ITEM_STYLE = {
    overflowAnchor: "none"
};
const $d72989d8b3846905$var$Items = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function VirtuosoItems2() {
    const listState = $d72989d8b3846905$var$useEmitterValue("listState");
    const sizeRanges = $d72989d8b3846905$var$usePublisher("sizeRanges");
    const useWindowScroll = $d72989d8b3846905$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue("customScrollParent");
    const windowScrollContainerStateCallback = $d72989d8b3846905$var$usePublisher("windowScrollContainerState");
    const _scrollContainerStateCallback = $d72989d8b3846905$var$usePublisher("scrollContainerState");
    const scrollContainerStateCallback = customScrollParent || useWindowScroll ? windowScrollContainerStateCallback : _scrollContainerStateCallback;
    const itemContent = $d72989d8b3846905$var$useEmitterValue("itemContent");
    const trackItemSizes = $d72989d8b3846905$var$useEmitterValue("trackItemSizes");
    const itemSize = $d72989d8b3846905$var$useEmitterValue("itemSize");
    const log = $d72989d8b3846905$var$useEmitterValue("log");
    const { callbackRef: callbackRef, ref: ref } = $d72989d8b3846905$var$useChangedListContentsSizes(sizeRanges, itemSize, trackItemSizes, scrollContainerStateCallback, log, void 0, customScrollParent, false, $d72989d8b3846905$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    const [deviation, setDeviation] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(0);
    $d72989d8b3846905$var$useEmitter("deviation", (value)=>{
        if (deviation !== value) {
            ref.current.style.marginTop = `${value}px`;
            setDeviation(value);
        }
    });
    const EmptyPlaceholder = $d72989d8b3846905$var$useEmitterValue("EmptyPlaceholder");
    const ScrollSeekPlaceholder = $d72989d8b3846905$var$useEmitterValue("ScrollSeekPlaceholder") || $d72989d8b3846905$var$DefaultScrollSeekPlaceholder;
    const FillerRow = $d72989d8b3846905$var$useEmitterValue("FillerRow") || $d72989d8b3846905$var$DefaultFillerRow;
    const TableBodyComponent = $d72989d8b3846905$var$useEmitterValue("TableBodyComponent");
    const TableRowComponent = $d72989d8b3846905$var$useEmitterValue("TableRowComponent");
    const computeItemKey = $d72989d8b3846905$var$useEmitterValue("computeItemKey");
    const isSeeking = $d72989d8b3846905$var$useEmitterValue("isSeeking");
    const paddingTopAddition = $d72989d8b3846905$var$useEmitterValue("paddingTopAddition");
    const firstItemIndex = $d72989d8b3846905$var$useEmitterValue("firstItemIndex");
    const statefulTotalCount = $d72989d8b3846905$var$useEmitterValue("statefulTotalCount");
    const context = $d72989d8b3846905$var$useEmitterValue("context");
    if (statefulTotalCount === 0 && EmptyPlaceholder) return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(EmptyPlaceholder, (0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(EmptyPlaceholder, context)));
    const paddingTop = listState.offsetTop + paddingTopAddition + deviation;
    const paddingBottom = listState.offsetBottom;
    const paddingTopEl = paddingTop > 0 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(FillerRow, {
        height: paddingTop,
        context: context
    }, "padding-top") : null;
    const paddingBottomEl = paddingBottom > 0 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(FillerRow, {
        height: paddingBottom,
        context: context
    }, "padding-bottom") : null;
    const items = listState.items.map((item)=>{
        const index = item.originalIndex;
        const key = computeItemKey(index + firstItemIndex, item.data, context);
        if (isSeeking) return /* @__PURE__ */ (0, $7fPBF.createElement)(ScrollSeekPlaceholder, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(ScrollSeekPlaceholder, context)), {
            key: key,
            index: item.index,
            height: item.size,
            type: item.type || "item"
        }));
        return /* @__PURE__ */ (0, $7fPBF.createElement)(TableRowComponent, (0, $2qxEV._)((0, $9tqwB._)({}, $d72989d8b3846905$var$contextPropIfNotDomElement(TableRowComponent, context), $d72989d8b3846905$var$itemPropIfNotDomElement(TableRowComponent, item.data)), {
            key: key,
            "data-index": index,
            "data-known-size": item.size,
            "data-item-index": item.index,
            style: $d72989d8b3846905$var$ITEM_STYLE
        }), itemContent(item.index, item.data, context));
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(TableBodyComponent, (0, $2qxEV._)((0, $9tqwB._)({
        ref: callbackRef,
        "data-testid": "virtuoso-item-list"
    }, $d72989d8b3846905$var$contextPropIfNotDomElement(TableBodyComponent, context)), {
        children: [
            paddingTopEl,
            items,
            paddingBottomEl
        ]
    }));
});
const $d72989d8b3846905$var$Viewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($d72989d8b3846905$export$99e9d54e386aea7b);
    const viewportHeight = $d72989d8b3846905$var$usePublisher("viewportHeight");
    const fixedItemHeight = $d72989d8b3846905$var$usePublisher("fixedItemHeight");
    const viewportRef = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$d72989d8b3846905$var$compose(viewportHeight, (el)=>$d72989d8b3846905$var$correctItemSize(el, "height")), [
        viewportHeight
    ]), true, $d72989d8b3846905$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (ctx) {
            viewportHeight(ctx.viewportHeight);
            fixedItemHeight(ctx.itemHeight);
        }
    }, [
        ctx,
        viewportHeight,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: $d72989d8b3846905$var$viewportStyle(false),
        ref: viewportRef,
        "data-viewport-type": "element",
        children: children
    });
};
const $d72989d8b3846905$var$WindowViewport = ({ children: children })=>{
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($d72989d8b3846905$export$99e9d54e386aea7b);
    const windowViewportRect = $d72989d8b3846905$var$usePublisher("windowViewportRect");
    const fixedItemHeight = $d72989d8b3846905$var$usePublisher("fixedItemHeight");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue("customScrollParent");
    const viewportRef = $d72989d8b3846905$var$useWindowViewportRectRef(windowViewportRect, customScrollParent, $d72989d8b3846905$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (ctx) {
            fixedItemHeight(ctx.itemHeight);
            windowViewportRect({
                offsetTop: 0,
                visibleHeight: ctx.viewportHeight,
                visibleWidth: 100
            });
        }
    }, [
        ctx,
        windowViewportRect,
        fixedItemHeight
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: viewportRef,
        style: $d72989d8b3846905$var$viewportStyle(false),
        "data-viewport-type": "window",
        children: children
    });
};
const $d72989d8b3846905$var$TableRoot = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function TableVirtuosoRoot(props) {
    const useWindowScroll = $d72989d8b3846905$var$useEmitterValue("useWindowScroll");
    const customScrollParent = $d72989d8b3846905$var$useEmitterValue("customScrollParent");
    const fixedHeaderHeight = $d72989d8b3846905$var$usePublisher("fixedHeaderHeight");
    const fixedFooterHeight = $d72989d8b3846905$var$usePublisher("fixedFooterHeight");
    const fixedHeaderContent = $d72989d8b3846905$var$useEmitterValue("fixedHeaderContent");
    const fixedFooterContent = $d72989d8b3846905$var$useEmitterValue("fixedFooterContent");
    const context = $d72989d8b3846905$var$useEmitterValue("context");
    const theadRef = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$d72989d8b3846905$var$compose(fixedHeaderHeight, (el)=>$d72989d8b3846905$var$correctItemSize(el, "height")), [
        fixedHeaderHeight
    ]), true, $d72989d8b3846905$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    const tfootRef = $d72989d8b3846905$var$useSize((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$d72989d8b3846905$var$compose(fixedFooterHeight, (el)=>$d72989d8b3846905$var$correctItemSize(el, "height")), [
        fixedFooterHeight
    ]), true, $d72989d8b3846905$var$useEmitterValue("skipAnimationFrameInResizeObserver"));
    const TheScroller = customScrollParent || useWindowScroll ? $d72989d8b3846905$var$WindowScroller : $d72989d8b3846905$var$Scroller;
    const TheViewport = customScrollParent || useWindowScroll ? $d72989d8b3846905$var$WindowViewport : $d72989d8b3846905$var$Viewport;
    const TheTable = $d72989d8b3846905$var$useEmitterValue("TableComponent");
    const TheTHead = $d72989d8b3846905$var$useEmitterValue("TableHeadComponent");
    const TheTFoot = $d72989d8b3846905$var$useEmitterValue("TableFooterComponent");
    const theHead = fixedHeaderContent ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(TheTHead, (0, $2qxEV._)((0, $9tqwB._)({
        style: {
            zIndex: 2,
            position: "sticky",
            top: 0
        },
        ref: theadRef
    }, $d72989d8b3846905$var$contextPropIfNotDomElement(TheTHead, context)), {
        children: fixedHeaderContent()
    }), "TableHead") : null;
    const theFoot = fixedFooterContent ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(TheTFoot, (0, $2qxEV._)((0, $9tqwB._)({
        style: {
            zIndex: 1,
            position: "sticky",
            bottom: 0
        },
        ref: tfootRef
    }, $d72989d8b3846905$var$contextPropIfNotDomElement(TheTFoot, context)), {
        children: fixedFooterContent()
    }), "TableFoot") : null;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(TheScroller, (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(TheViewport, {
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)(TheTable, (0, $2qxEV._)((0, $9tqwB._)({
                style: {
                    borderSpacing: 0,
                    overflowAnchor: "none"
                }
            }, $d72989d8b3846905$var$contextPropIfNotDomElement(TheTable, context)), {
                children: [
                    theHead,
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d72989d8b3846905$var$Items, {}, "TableBody"),
                    theFoot
                ]
            }))
        })
    }));
});
const { Component: $d72989d8b3846905$var$Table, usePublisher: $d72989d8b3846905$var$usePublisher, useEmitterValue: $d72989d8b3846905$var$useEmitterValue, useEmitter: $d72989d8b3846905$var$useEmitter } = /* @__PURE__ */ $d72989d8b3846905$var$systemToComponent($d72989d8b3846905$var$combinedSystem, {
    required: {},
    optional: {
        restoreStateFrom: "restoreStateFrom",
        context: "context",
        followOutput: "followOutput",
        firstItemIndex: "firstItemIndex",
        itemContent: "itemContent",
        fixedHeaderContent: "fixedHeaderContent",
        fixedFooterContent: "fixedFooterContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        topItemCount: "topItemCount",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        groupCounts: "groupCounts",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        getState: "getState"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, $d72989d8b3846905$var$TableRoot);
const $d72989d8b3846905$var$Scroller = /* @__PURE__ */ $d72989d8b3846905$var$buildScroller({
    usePublisher: $d72989d8b3846905$var$usePublisher,
    useEmitterValue: $d72989d8b3846905$var$useEmitterValue,
    useEmitter: $d72989d8b3846905$var$useEmitter
});
const $d72989d8b3846905$var$WindowScroller = /* @__PURE__ */ $d72989d8b3846905$var$buildWindowScroller({
    usePublisher: $d72989d8b3846905$var$usePublisher,
    useEmitterValue: $d72989d8b3846905$var$useEmitterValue,
    useEmitter: $d72989d8b3846905$var$useEmitter
});
const $d72989d8b3846905$export$3631598018434e6e = $d72989d8b3846905$var$Table;


/* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $c88e3f3391578fdf$var$ChevronUpIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
        clipRule: "evenodd"
    }));
}
const $c88e3f3391578fdf$var$ForwardRef = $7fPBF.forwardRef($c88e3f3391578fdf$var$ChevronUpIcon);
var $c88e3f3391578fdf$export$2e2bcd8739ae039 = $c88e3f3391578fdf$var$ForwardRef;




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function $cb9574c61f730564$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $cb9574c61f730564$var$handleCustomEvent(payload) {
    const event = new CustomEvent("showTooltip", {
        detail: payload
    });
    window.dispatchEvent(event);
}
function $cb9574c61f730564$export$2e2bcd8739ae039({ children: children, info: info, className: className, classNameOwn: classNameOwn }) {
    function handleMouseEnter(e) {
        $cb9574c61f730564$var$handleCustomEvent({
            x: e.clientX,
            y: e.clientY,
            message: info,
            className: className
        });
    }
    function handleMouseLeave() {
        $cb9574c61f730564$var$handleCustomEvent(null);
    }
    (0, $7fPBF.useEffect)(()=>()=>{
            $cb9574c61f730564$var$handleCustomEvent(null);
        }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: $cb9574c61f730564$var$classNames(classNameOwn, "relative group"),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex items-center",
            onPointerEnter: handleMouseEnter,
            onPointerLeave: handleMouseLeave,
            children: children
        })
    });
}
$cb9574c61f730564$export$2e2bcd8739ae039.propTypes = {
    info: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    classNameOwn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$cb9574c61f730564$export$2e2bcd8739ae039.defaultProps = {
    className: "",
    classNameOwn: ""
};


function $0c64dd8df4a61e92$export$2e2bcd8739ae039({ tableLayout: tableLayout, tableState: tableState, setTableState: setTableState, hiddenColumns: hiddenColumns, setHiddenColumns: setHiddenColumns, gridTemplateColumns: gridTemplateColumns, selectMode: selectMode, selectionColumnProps: selectionColumnProps }) {
    var _tableLayout_columns;
    const layoutColumns = (_tableLayout_columns = tableLayout === null || tableLayout === void 0 ? void 0 : tableLayout.columns) !== null && _tableLayout_columns !== void 0 ? _tableLayout_columns : [];
    const headerCheckboxRef = (0, $7fPBF.useRef)(null);
    const headerIndeterminate = selectionColumnProps === null || selectionColumnProps === void 0 ? void 0 : selectionColumnProps.indeterminate;
    const headerChecked = Boolean(selectionColumnProps === null || selectionColumnProps === void 0 ? void 0 : selectionColumnProps.checked);
    const headerDisabled = Boolean(selectionColumnProps === null || selectionColumnProps === void 0 ? void 0 : selectionColumnProps.disabled);
    const headerOnChange = selectionColumnProps === null || selectionColumnProps === void 0 ? void 0 : selectionColumnProps.onChange;
    (0, $7fPBF.useEffect)(()=>{
        if (!headerCheckboxRef.current) return;
        headerCheckboxRef.current.indeterminate = Boolean(selectMode && headerIndeterminate);
    }, [
        selectMode,
        headerIndeterminate
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        role: "rowgroup",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "w-full bg-gray-50 bg-opacity-70 sticky top-0 z-10 border-b border-gray-200 grid gap-3 pl-3 pr-1 lg:pr-3",
            style: gridTemplateColumns ? {
                gridTemplateColumns: gridTemplateColumns
            } : undefined,
            role: "row",
            children: [
                selectMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    role: "columnheader",
                    className: "flex items-center py-3",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        ref: headerCheckboxRef,
                        type: "checkbox",
                        className: "h-4 w-4 text-brandBlue-600 border-gray-300 rounded focus:ring-brandBlue-500",
                        checked: headerChecked,
                        onChange: (event)=>{
                            event.stopPropagation();
                            headerOnChange === null || headerOnChange === void 0 ? void 0 : headerOnChange();
                        },
                        disabled: headerDisabled,
                        "aria-checked": headerIndeterminate ? "mixed" : headerChecked,
                        "aria-label": "Toggle select all rows"
                    })
                }),
                layoutColumns.map((columns, index)=>// each HeaderCell contains between one and usually three columns, depending on how small the page is
                /*#__PURE__*/ {
                    var _columns_, _columns_1, _columns_2;
                    var _columns__id;
                    return (0, $824c049f32d4395d$exports.jsx)($0c64dd8df4a61e92$var$HeaderCell, {
                        columns: columns,
                        tableState: tableState,
                        setTableState: setTableState,
                        setHiddenColumns: setHiddenColumns,
                        firstLayoutColumn: index === 0,
                        hidden: hiddenColumns.includes(columns === null || columns === void 0 ? void 0 : (_columns_ = columns[0]) === null || _columns_ === void 0 ? void 0 : _columns_.id) ? "hidden" : "",
                        classNamesHeader: columns === null || columns === void 0 ? void 0 : (_columns_1 = columns[0]) === null || _columns_1 === void 0 ? void 0 : _columns_1.classNamesHeader
                    }, (_columns__id = columns === null || columns === void 0 ? void 0 : (_columns_2 = columns[0]) === null || _columns_2 === void 0 ? void 0 : _columns_2.id) !== null && _columns__id !== void 0 ? _columns__id : index);
                })
            ]
        })
    });
}
$0c64dd8df4a61e92$export$2e2bcd8739ae039.propTypes = {
    tableLayout: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        columnParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object)).isRequired
    }).isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    hiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    setHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    gridTemplateColumns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    selectMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    selectionColumnProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        checked: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
    })
};
$0c64dd8df4a61e92$export$2e2bcd8739ae039.defaultProps = {
    gridTemplateColumns: "",
    selectMode: false,
    selectionColumnProps: null
};
// generates the contents of a header cell (<th>)
function $0c64dd8df4a61e92$var$HeaderCell({ columns: columns, tableState: tableState, setTableState: setTableState, firstLayoutColumn: firstLayoutColumn, setHiddenColumns: setHiddenColumns, hidden: hidden, classNamesHeader: classNamesHeader }) {
    var _columnsToRender_, _columnsToRender_1;
    // as there is no possibility to check if the bottom-level descendant of an element is visible, we do it based on computed width
    // if the computed width is below 5px (it usually is 2px), we assume the column is empty and hide it
    const trRef = (0, $7fPBF.useRef)();
    const columnsToRender = columns || [];
    const headerCellId = columnsToRender === null || columnsToRender === void 0 ? void 0 : (_columnsToRender_ = columnsToRender[0]) === null || _columnsToRender_ === void 0 ? void 0 : _columnsToRender_.id;
    // TODO if this has to change on window resize, this should also be triggered by a listener on window resize event
    (0, $7fPBF.useLayoutEffect)(()=>{
        const node = trRef.current;
        if (!node) return;
        const allChildrenHidden = Array.from(node.children).every((el)=>getComputedStyle(el).display === "none");
        setHiddenColumns((prev)=>{
            const alreadyHidden = prev.includes(headerCellId);
            if (allChildrenHidden && !alreadyHidden) return [
                ...prev,
                headerCellId
            ];
            if (!allChildrenHidden && alreadyHidden) return prev.filter((id)=>id !== headerCellId);
            return prev;
        });
    }, [
        headerCellId,
        setHiddenColumns
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: trRef,
        role: "columnheader",
        // TODO border-b
        // eslint-disable-next-line max-len
        className: `sticky top-0 pt-3.5 pb-2 text-sm font-semibold text-gray-900 bg-gray-50 bg-opacity-75 backdrop-blur backdrop-filter ${hidden} ${classNamesHeader} ${(columnsToRender === null || columnsToRender === void 0 ? void 0 : (_columnsToRender_1 = columnsToRender[0]) === null || _columnsToRender_1 === void 0 ? void 0 : _columnsToRender_1.textAlign) || "text-left"}`,
        children: columnsToRender.map((column)=>{
            if (column.hideHeaderLabel) return null;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c64dd8df4a61e92$var$HeaderLabel, {
                columnDef: column,
                tableState: tableState,
                setTableState: setTableState,
                firstLayoutColumn: firstLayoutColumn
            }, column.id);
        })
    });
}
$0c64dd8df4a61e92$var$HeaderCell.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    firstLayoutColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    classNamesHeader: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$0c64dd8df4a61e92$var$HeaderCell.defaultProps = {
    classNamesHeader: ""
};
function $0c64dd8df4a61e92$var$HeaderLabel({ columnDef: columnDef, tableState: tableState, setTableState: setTableState, firstLayoutColumn: firstLayoutColumn }) {
    // tooltip = 'Click to sort by this column or reverse the sorting order.'
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const tooltip = t([
        `columns.${columnDef.usesHeader || columnDef.id}.tooltip`,
        "columns.standardTooltip"
    ]);
    const label = t([
        `columns.${columnDef.usesHeader || columnDef.id}.label`,
        `columns.${columnDef.usesHeader || columnDef.id}`,
        `${columnDef.usesHeader}`
    ]);
    if (columnDef.usesHeader === null) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
        className: "mt-4",
        classNameOwn: `${columnDef.classNamesBoth || ""} ${columnDef.classNamesHeader || ""}`,
        info: tooltip,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
            type: "button",
            id: columnDef.id,
            className: "group justify-between w-full flex pb-1",
            onClick: ()=>setTableState((0, $2qxEV._)((0, $9tqwB._)({}, tableState), {
                    sortBy: columnDef.id,
                    sortDirectionAsc: !tableState.sortDirectionAsc
                })),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex align-middle w-full",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-[11px] leading-tight xs:text-xs font-bold text-left uppercase tracking-wide mt-0.5 text-gray-900",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: `${tableState.sortBy === columnDef.id ? "visible" : "invisible"} ml-1 lg:ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible`,
                        children: tableState.sortBy === columnDef.id && tableState.sortDirectionAsc ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c88e3f3391578fdf$export$2e2bcd8739ae039), {
                            className: "h-5 w-5",
                            "aria-hidden": "true"
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01f5965251d69098$export$2e2bcd8739ae039), {
                            className: "h-5 w-5",
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        })
    });
}
$0c64dd8df4a61e92$var$HeaderLabel.propTypes = {
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    columnDef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    firstLayoutColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};
$0c64dd8df4a61e92$var$HeaderLabel.defaultProps = {};


/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $1aa98a901308423c$var$CheckCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
        clipRule: "evenodd"
    }));
}
const $1aa98a901308423c$var$ForwardRef = $7fPBF.forwardRef($1aa98a901308423c$var$CheckCircleIcon);
var $1aa98a901308423c$export$2e2bcd8739ae039 = $1aa98a901308423c$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $718d5639811dbbc7$var$ChevronDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $718d5639811dbbc7$var$ForwardRef = $7fPBF.forwardRef($718d5639811dbbc7$var$ChevronDownIcon);
var $718d5639811dbbc7$export$2e2bcd8739ae039 = $718d5639811dbbc7$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $dc348e8ecf02df23$var$PlusIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"
    }));
}
const $dc348e8ecf02df23$var$ForwardRef = $7fPBF.forwardRef($dc348e8ecf02df23$var$PlusIcon);
var $dc348e8ecf02df23$export$2e2bcd8739ae039 = $dc348e8ecf02df23$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $3480940107a3d218$var$TagIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v3.879a2.5 2.5 0 0 0 .732 1.767l7.5 7.5a2.5 2.5 0 0 0 3.536 0l3.878-3.878a2.5 2.5 0 0 0 0-3.536l-7.5-7.5A2.5 2.5 0 0 0 8.38 2H4.5ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $3480940107a3d218$var$ForwardRef = $7fPBF.forwardRef($3480940107a3d218$var$TagIcon);
var $3480940107a3d218$export$2e2bcd8739ae039 = $3480940107a3d218$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $125f450ca02db1e2$var$XMarkIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
    }));
}
const $125f450ca02db1e2$var$ForwardRef = $7fPBF.forwardRef($125f450ca02db1e2$var$XMarkIcon);
var $125f450ca02db1e2$export$2e2bcd8739ae039 = $125f450ca02db1e2$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $0828707d2c7c0c6c$var$EllipsisVerticalIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
        clipRule: "evenodd"
    }));
}
const $0828707d2c7c0c6c$var$ForwardRef = $7fPBF.forwardRef($0828707d2c7c0c6c$var$EllipsisVerticalIcon);
var $0828707d2c7c0c6c$export$2e2bcd8739ae039 = $0828707d2c7c0c6c$var$ForwardRef;


/* eslint-disable no-nested-ternary */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable no-return-assign */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");


function $b3352202c7c0b918$export$e3d20747ab930783(e, o) {
    let [u, t] = (0, $7fPBF.useState)(e), r = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(e);
    return (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>t(r.current), [
        r,
        t,
        ...o
    ]), u;
}











function $128c1210d720a2c8$var$f(r) {
    throw new Error("Unexpected object: " + r);
}
var $128c1210d720a2c8$export$807a7eae502106e7 = ((e)=>(e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))($128c1210d720a2c8$export$807a7eae502106e7 || {});
function $128c1210d720a2c8$export$c6b4626b54936d5e(r, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let l = n.resolveActiveIndex(), s = l != null ? l : -1, d = (()=>{
        switch(r.focus){
            case 0:
                return t.findIndex((e)=>!n.resolveDisabled(e));
            case 1:
                {
                    let e = t.slice().reverse().findIndex((i, c, u)=>s !== -1 && u.length - c - 1 >= s ? !1 : !n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 2:
                return t.findIndex((e, i)=>i <= s ? !1 : !n.resolveDisabled(e));
            case 3:
                {
                    let e = t.slice().reverse().findIndex((i)=>!n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 4:
                return t.findIndex((e)=>n.resolveId(e) === r.id);
            case 5:
                return null;
            default:
                $128c1210d720a2c8$var$f(r);
        }
    })();
    return d === -1 ? l : d;
}














var $7fPBF = parcelRequire("7fPBF");
function $d895e59b5353ecb4$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d895e59b5353ecb4$export$24ebee078bde85c3() {
    let e = (0, $7fPBF.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d895e59b5353ecb4$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d895e59b5353ecb4$var$t(r);
        }
    };
}


var $6aa23c555810f7a8$var$Fe = ((n)=>(n[n.Open = 0] = "Open", n[n.Closed = 1] = "Closed", n))($6aa23c555810f7a8$var$Fe || {}), $6aa23c555810f7a8$var$_e = ((n)=>(n[n.Single = 0] = "Single", n[n.Multi = 1] = "Multi", n))($6aa23c555810f7a8$var$_e || {}), $6aa23c555810f7a8$var$ke = ((n)=>(n[n.Pointer = 0] = "Pointer", n[n.Other = 1] = "Other", n))($6aa23c555810f7a8$var$ke || {}), $6aa23c555810f7a8$var$we = ((i)=>(i[i.OpenCombobox = 0] = "OpenCombobox", i[i.CloseCombobox = 1] = "CloseCombobox", i[i.GoToOption = 2] = "GoToOption", i[i.RegisterOption = 3] = "RegisterOption", i[i.UnregisterOption = 4] = "UnregisterOption", i[i.RegisterLabel = 5] = "RegisterLabel", i))($6aa23c555810f7a8$var$we || {});
function $6aa23c555810f7a8$var$ne(t, r = (n)=>n) {
    let n = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, o = (0, $14e03ac93c8c8bff$export$20305e96f91bf103)(r(t.options.slice()), (u)=>u.dataRef.current.domRef.current), a = n ? o.indexOf(n) : null;
    return a === -1 && (a = null), {
        options: o,
        activeOptionIndex: a
    };
}
let $6aa23c555810f7a8$var$Be = {
    [1] (t) {
        return t.dataRef.current.disabled || t.comboboxState === 1 ? t : (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            activeOptionIndex: null,
            comboboxState: 1
        });
    },
    [0] (t) {
        if (t.dataRef.current.disabled || t.comboboxState === 0) return t;
        let r = t.activeOptionIndex, { isSelected: n } = t.dataRef.current, o = t.options.findIndex((a)=>n(a.dataRef.current.value));
        return o !== -1 && (r = o), (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            comboboxState: 0,
            activeOptionIndex: r
        });
    },
    [2] (t, r) {
        var a;
        if (t.dataRef.current.disabled || t.dataRef.current.optionsRef.current && !t.dataRef.current.optionsPropsRef.current.static && t.comboboxState === 1) return t;
        let n = $6aa23c555810f7a8$var$ne(t);
        if (n.activeOptionIndex === null) {
            let u = n.options.findIndex((i)=>!i.dataRef.current.disabled);
            u !== -1 && (n.activeOptionIndex = u);
        }
        let o = (0, $128c1210d720a2c8$export$c6b4626b54936d5e)(r, {
            resolveItems: ()=>n.options,
            resolveActiveIndex: ()=>n.activeOptionIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, t, n), {
            activeOptionIndex: o,
            activationTrigger: (a = r.trigger) != null ? a : 1
        });
    },
    [3]: (t, r)=>{
        let n = {
            id: r.id,
            dataRef: r.dataRef
        }, o = $6aa23c555810f7a8$var$ne(t, (u)=>[
                ...u,
                n
            ]);
        t.activeOptionIndex === null && t.dataRef.current.isSelected(r.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(n));
        let a = (0, $2qxEV._)((0, $9tqwB._)({}, t, o), {
            activationTrigger: 1
        });
        return t.dataRef.current.__demoMode && t.dataRef.current.value === void 0 && (a.activeOptionIndex = 0), a;
    },
    [4]: (t, r)=>{
        let n = $6aa23c555810f7a8$var$ne(t, (o)=>{
            let a = o.findIndex((u)=>u.id === r.id);
            return a !== -1 && o.splice(a, 1), o;
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, t, n), {
            activationTrigger: 1
        });
    },
    [5]: (t, r)=>(0, $2qxEV._)((0, $9tqwB._)({}, t), {
            labelId: r.id
        })
}, $6aa23c555810f7a8$var$re = (0, $7fPBF.createContext)(null);
$6aa23c555810f7a8$var$re.displayName = "ComboboxActionsContext";
function $6aa23c555810f7a8$var$Q(t) {
    let r = (0, $7fPBF.useContext)($6aa23c555810f7a8$var$re);
    if (r === null) {
        let n = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $6aa23c555810f7a8$var$Q), n;
    }
    return r;
}
let $6aa23c555810f7a8$var$ae = (0, $7fPBF.createContext)(null);
$6aa23c555810f7a8$var$ae.displayName = "ComboboxDataContext";
function $6aa23c555810f7a8$var$j(t) {
    let r = (0, $7fPBF.useContext)($6aa23c555810f7a8$var$ae);
    if (r === null) {
        let n = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, $6aa23c555810f7a8$var$j), n;
    }
    return r;
}
function $6aa23c555810f7a8$var$Ue(t, r) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(r.type, $6aa23c555810f7a8$var$Be, t, r);
}
let $6aa23c555810f7a8$var$Ge = (0, $7fPBF.Fragment);
function $6aa23c555810f7a8$var$Ne(t, r) {
    let { value: n, defaultValue: o, onChange: a, name: u, by: i = (b, m)=>b === m, disabled: d = !1, __demoMode: c = !1, nullable: e = !1, multiple: p = !1 } = t, P = (0, $bLhVg._)(t, [
        "value",
        "defaultValue",
        "onChange",
        "name",
        "by",
        "disabled",
        "__demoMode",
        "nullable",
        "multiple"
    ]), [s = p ? [] : void 0, y] = (0, $52e65d40f5248976$export$454217e89aea72b)(n, a, o), [T, C] = (0, $7fPBF.useReducer)($6aa23c555810f7a8$var$Ue, {
        dataRef: (0, $7fPBF.createRef)(),
        comboboxState: c ? 0 : 1,
        options: [],
        activeOptionIndex: null,
        activationTrigger: 1,
        labelId: null
    }), g = (0, $7fPBF.useRef)(!1), R = (0, $7fPBF.useRef)({
        static: !1,
        hold: !1
    }), K = (0, $7fPBF.useRef)(null), h = (0, $7fPBF.useRef)(null), w = (0, $7fPBF.useRef)(null), B = (0, $7fPBF.useRef)(null), D = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(typeof i == "string" ? (b, m)=>{
        let A = i;
        return (b == null ? void 0 : b[A]) === (m == null ? void 0 : m[A]);
    } : i), W = (0, $7fPBF.useCallback)((b)=>(0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(f.mode, {
            [1]: ()=>s.some((m)=>D(m, b)),
            [0]: ()=>D(s, b)
        }), [
        s
    ]), f = (0, $7fPBF.useMemo)(()=>(0, $2qxEV._)((0, $9tqwB._)({}, T), {
            optionsPropsRef: R,
            labelRef: K,
            inputRef: h,
            buttonRef: w,
            optionsRef: B,
            value: s,
            defaultValue: o,
            disabled: d,
            mode: p ? 1 : 0,
            get activeOptionIndex () {
                if (g.current && T.activeOptionIndex === null && T.options.length > 0) {
                    let b = T.options.findIndex((m)=>!m.dataRef.current.disabled);
                    if (b !== -1) return b;
                }
                return T.activeOptionIndex;
            },
            compare: D,
            isSelected: W,
            nullable: e,
            __demoMode: c
        }), [
        s,
        o,
        d,
        p,
        e,
        c,
        T
    ]);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        T.dataRef.current = f;
    }, [
        f
    ]), (0, $fa9d8c8ce9154eec$export$71b2224f1ce5e08e)([
        f.buttonRef,
        f.inputRef,
        f.optionsRef
    ], ()=>U.closeCombobox(), f.comboboxState === 0);
    let F = (0, $7fPBF.useMemo)(()=>({
            open: f.comboboxState === 0,
            disabled: d,
            activeIndex: f.activeOptionIndex,
            activeOption: f.activeOptionIndex === null ? null : f.options[f.activeOptionIndex].dataRef.current.value,
            value: s
        }), [
        f,
        d,
        s
    ]), _ = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((b)=>{
        let m = f.options.find((A)=>A.id === b);
        !m || V(m.dataRef.current.value);
    }), O = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        if (f.activeOptionIndex !== null) {
            let { dataRef: b, id: m } = f.options[f.activeOptionIndex];
            V(b.current.value), U.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Specific, m);
        }
    }), l = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        C({
            type: 0
        }), g.current = !0;
    }), L = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        C({
            type: 1
        }), g.current = !1;
    }), E = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((b, m, A)=>(g.current = !1, b === (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific ? C({
            type: 2,
            focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific,
            id: m,
            trigger: A
        }) : C({
            type: 2,
            focus: b,
            trigger: A
        }))), X = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((b, m)=>(C({
            type: 3,
            id: b,
            dataRef: m
        }), ()=>C({
                type: 4,
                id: b
            }))), Y = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((b)=>(C({
            type: 5,
            id: b
        }), ()=>C({
                type: 5,
                id: null
            }))), V = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((b)=>(0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(f.mode, {
            [0] () {
                return y == null ? void 0 : y(b);
            },
            [1] () {
                let m = f.value.slice(), A = m.findIndex(($)=>D($, b));
                return A === -1 ? m.push(b) : m.splice(A, 1), y == null ? void 0 : y(m);
            }
        })), U = (0, $7fPBF.useMemo)(()=>({
            onChange: V,
            registerOption: X,
            registerLabel: Y,
            goToOption: E,
            closeCombobox: L,
            openCombobox: l,
            selectActiveOption: O,
            selectOption: _
        }), []), de = r === null ? {} : {
        ref: r
    }, Z = (0, $7fPBF.useRef)(null), ce = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)();
    return (0, $7fPBF.useEffect)(()=>{
        !Z.current || o !== void 0 && ce.addEventListener(Z.current, "reset", ()=>{
            V(o);
        });
    }, [
        Z,
        V
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6aa23c555810f7a8$var$re.Provider, {
        value: U
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($6aa23c555810f7a8$var$ae.Provider, {
        value: f
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $42e7df3a446fef87$export$2a0ed818b175f558), {
        value: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(f.comboboxState, {
            [0]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open,
            [1]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed
        })
    }, u != null && s != null && (0, $9ee07d5ba8162c4b$export$bc22b3e852574dab)({
        [u]: s
    }).map(([b, m], A)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), (0, $9tqwB._)({
            features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Hidden,
            ref: A === 0 ? ($)=>{
                var le;
                Z.current = (le = $ == null ? void 0 : $.closest("form")) != null ? le : null;
            } : void 0
        }, (0, $72af10e8efa1b073$export$8e16b83750b44988)({
            key: b,
            as: "input",
            type: "hidden",
            hidden: !0,
            readOnly: !0,
            name: b,
            value: m
        })))), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: de,
        theirProps: P,
        slot: F,
        defaultTag: $6aa23c555810f7a8$var$Ge,
        name: "Combobox"
    }))));
}
let $6aa23c555810f7a8$var$He = (0, $72af10e8efa1b073$export$e43f39796049410c)($6aa23c555810f7a8$var$Ne), $6aa23c555810f7a8$var$je = "input", $6aa23c555810f7a8$var$Ke = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, n) {
    var f, F, _, O;
    let o = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-combobox-input-${o}`, onChange: u, displayValue: i, type: d = "text" } = r, c = (0, $bLhVg._)(r, [
        "id",
        "onChange",
        "displayValue",
        "type"
    ]), e = $6aa23c555810f7a8$var$j("Combobox.Input"), p = $6aa23c555810f7a8$var$Q("Combobox.Input"), P = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(e.inputRef, n), s = (0, $7fPBF.useRef)(!1), y = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), T = function() {
        var l;
        return typeof i == "function" && e.value !== void 0 ? (l = i(e.value)) != null ? l : "" : typeof e.value == "string" ? e.value : "";
    }();
    (0, $2d03cf7d30b78b4f$export$3c773aa2b84f29e0)(([l, L], [E, X])=>{
        s.current || !e.inputRef.current || (X === 0 && L === 1 || l !== E) && (e.inputRef.current.value = l);
    }, [
        T,
        e.comboboxState
    ]), (0, $2d03cf7d30b78b4f$export$3c773aa2b84f29e0)(([l], [L])=>{
        if (l === 0 && L === 1) {
            let E = e.inputRef.current;
            if (!E) return;
            let X = E.value, { selectionStart: Y, selectionEnd: V, selectionDirection: U } = E;
            E.value = "", E.value = X, U !== null ? E.setSelectionRange(Y, V, U) : E.setSelectionRange(Y, V);
        }
    }, [
        e.comboboxState
    ]);
    let C = (0, $7fPBF.useRef)(!1), g = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        C.current = !0;
    }), R = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        setTimeout(()=>{
            C.current = !1;
        });
    }), K = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>{
        switch(s.current = !0, l.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Backspace:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Delete:
                if (e.mode !== 0 || !e.nullable) return;
                let L = l.currentTarget;
                y.requestAnimationFrame(()=>{
                    L.value === "" && (p.onChange(null), e.optionsRef.current && (e.optionsRef.current.scrollTop = 0), p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing));
                });
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                if (s.current = !1, e.comboboxState !== 0 || C.current) return;
                if (l.preventDefault(), l.stopPropagation(), e.activeOptionIndex === null) {
                    p.closeCombobox();
                    return;
                }
                p.selectActiveOption(), e.mode === 0 && p.closeCombobox();
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown:
                return s.current = !1, l.preventDefault(), l.stopPropagation(), (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(e.comboboxState, {
                    [0]: ()=>{
                        p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Next);
                    },
                    [1]: ()=>{
                        p.openCombobox();
                    }
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp:
                return s.current = !1, l.preventDefault(), l.stopPropagation(), (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(e.comboboxState, {
                    [0]: ()=>{
                        p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Previous);
                    },
                    [1]: ()=>{
                        p.openCombobox(), y.nextFrame(()=>{
                            e.value || p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Last);
                        });
                    }
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Home:
                if (l.shiftKey) break;
                return s.current = !1, l.preventDefault(), l.stopPropagation(), p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).First);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).PageUp:
                return s.current = !1, l.preventDefault(), l.stopPropagation(), p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).First);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).End:
                if (l.shiftKey) break;
                return s.current = !1, l.preventDefault(), l.stopPropagation(), p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Last);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).PageDown:
                return s.current = !1, l.preventDefault(), l.stopPropagation(), p.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Last);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape:
                return s.current = !1, e.comboboxState !== 0 ? void 0 : (l.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && l.stopPropagation(), p.closeCombobox());
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Tab:
                if (s.current = !1, e.comboboxState !== 0) return;
                e.mode === 0 && p.selectActiveOption(), p.closeCombobox();
                break;
        }
    }), h = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>{
        p.openCombobox(), u == null || u(l);
    }), w = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        s.current = !1;
    }), B = (0, $b3352202c7c0b918$export$e3d20747ab930783)(()=>{
        if (!!e.labelId) return [
            e.labelId
        ].join(" ");
    }, [
        e.labelId
    ]), D = (0, $7fPBF.useMemo)(()=>({
            open: e.comboboxState === 0,
            disabled: e.disabled
        }), [
        e
    ]), W = {
        ref: P,
        id: a,
        role: "combobox",
        type: d,
        "aria-controls": (f = e.optionsRef.current) == null ? void 0 : f.id,
        "aria-expanded": e.disabled ? void 0 : e.comboboxState === 0,
        "aria-activedescendant": e.activeOptionIndex === null || (F = e.options[e.activeOptionIndex]) == null ? void 0 : F.id,
        "aria-multiselectable": e.mode === 1 ? !0 : void 0,
        "aria-labelledby": B,
        "aria-autocomplete": "list",
        defaultValue: (O = (_ = r.defaultValue) != null ? _ : e.defaultValue !== void 0 ? i == null ? void 0 : i(e.defaultValue) : null) != null ? O : e.defaultValue,
        disabled: e.disabled,
        onCompositionStart: g,
        onCompositionEnd: R,
        onKeyDown: K,
        onChange: h,
        onBlur: w
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: W,
        theirProps: c,
        slot: D,
        defaultTag: $6aa23c555810f7a8$var$je,
        name: "Combobox.Input"
    });
}), $6aa23c555810f7a8$var$We = "button", $6aa23c555810f7a8$var$Xe = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, n) {
    var C;
    let o = $6aa23c555810f7a8$var$j("Combobox.Button"), a = $6aa23c555810f7a8$var$Q("Combobox.Button"), u = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(o.buttonRef, n), i = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: d = `headlessui-combobox-button-${i}` } = r, c = (0, $bLhVg._)(r, [
        "id"
    ]), e = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), p = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((g)=>{
        switch(g.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown:
                return g.preventDefault(), g.stopPropagation(), o.comboboxState === 1 && a.openCombobox(), e.nextFrame(()=>{
                    var R;
                    return (R = o.inputRef.current) == null ? void 0 : R.focus({
                        preventScroll: !0
                    });
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp:
                return g.preventDefault(), g.stopPropagation(), o.comboboxState === 1 && (a.openCombobox(), e.nextFrame(()=>{
                    o.value || a.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Last);
                })), e.nextFrame(()=>{
                    var R;
                    return (R = o.inputRef.current) == null ? void 0 : R.focus({
                        preventScroll: !0
                    });
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape:
                return o.comboboxState !== 0 ? void 0 : (g.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && g.stopPropagation(), a.closeCombobox(), e.nextFrame(()=>{
                    var R;
                    return (R = o.inputRef.current) == null ? void 0 : R.focus({
                        preventScroll: !0
                    });
                }));
            default:
                return;
        }
    }), P = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((g)=>{
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(g.currentTarget)) return g.preventDefault();
        o.comboboxState === 0 ? a.closeCombobox() : (g.preventDefault(), a.openCombobox()), e.nextFrame(()=>{
            var R;
            return (R = o.inputRef.current) == null ? void 0 : R.focus({
                preventScroll: !0
            });
        });
    }), s = (0, $b3352202c7c0b918$export$e3d20747ab930783)(()=>{
        if (!!o.labelId) return [
            o.labelId,
            d
        ].join(" ");
    }, [
        o.labelId,
        d
    ]), y = (0, $7fPBF.useMemo)(()=>({
            open: o.comboboxState === 0,
            disabled: o.disabled,
            value: o.value
        }), [
        o
    ]), T = {
        ref: u,
        id: d,
        type: (0, $67467b80232bd14a$export$53652b2b272efe9c)(r, o.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (C = o.optionsRef.current) == null ? void 0 : C.id,
        "aria-expanded": o.disabled ? void 0 : o.comboboxState === 0,
        "aria-labelledby": s,
        disabled: o.disabled,
        onClick: P,
        onKeyDown: p
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: T,
        theirProps: c,
        slot: y,
        defaultTag: $6aa23c555810f7a8$var$We,
        name: "Combobox.Button"
    });
}), $6aa23c555810f7a8$var$$e = "label", $6aa23c555810f7a8$var$Je = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, n) {
    let o = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-combobox-label-${o}` } = r, u = (0, $bLhVg._)(r, [
        "id"
    ]), i = $6aa23c555810f7a8$var$j("Combobox.Label"), d = $6aa23c555810f7a8$var$Q("Combobox.Label"), c = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(i.labelRef, n);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>d.registerLabel(a), [
        a
    ]);
    let e = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        var s;
        return (s = i.inputRef.current) == null ? void 0 : s.focus({
            preventScroll: !0
        });
    }), p = (0, $7fPBF.useMemo)(()=>({
            open: i.comboboxState === 0,
            disabled: i.disabled
        }), [
        i
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: c,
            id: a,
            onClick: e
        },
        theirProps: u,
        slot: p,
        defaultTag: $6aa23c555810f7a8$var$$e,
        name: "Combobox.Label"
    });
}), $6aa23c555810f7a8$var$qe = "ul", $6aa23c555810f7a8$var$Qe = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $6aa23c555810f7a8$var$Ye = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, n) {
    let o = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-combobox-options-${o}`, hold: u = !1 } = r, i = (0, $bLhVg._)(r, [
        "id",
        "hold"
    ]), d = $6aa23c555810f7a8$var$j("Combobox.Options"), c = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(d.optionsRef, n), e = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)(), p = (()=>e !== null ? e === (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open : d.comboboxState === 0)();
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        var T;
        d.optionsPropsRef.current.static = (T = r.static) != null ? T : !1;
    }, [
        d.optionsPropsRef,
        r.static
    ]), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        d.optionsPropsRef.current.hold = u;
    }, [
        d.optionsPropsRef,
        u
    ]), (0, $1c5930309222918e$export$b0abce39eb34b36)({
        container: d.optionsRef.current,
        enabled: d.comboboxState === 0,
        accept (T) {
            return T.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : T.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (T) {
            T.setAttribute("role", "none");
        }
    });
    let P = (0, $b3352202c7c0b918$export$e3d20747ab930783)(()=>{
        var T, C;
        return (C = d.labelId) != null ? C : (T = d.buttonRef.current) == null ? void 0 : T.id;
    }, [
        d.labelId,
        d.buttonRef.current
    ]), s = (0, $7fPBF.useMemo)(()=>({
            open: d.comboboxState === 0
        }), [
        d
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            "aria-labelledby": P,
            role: "listbox",
            id: a,
            ref: c
        },
        theirProps: i,
        slot: s,
        defaultTag: $6aa23c555810f7a8$var$qe,
        features: $6aa23c555810f7a8$var$Qe,
        visible: p,
        name: "Combobox.Options"
    });
}), $6aa23c555810f7a8$var$Ze = "li", $6aa23c555810f7a8$var$ze = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, n) {
    var F, _;
    let o = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-combobox-option-${o}`, disabled: u = !1, value: i } = r, d = (0, $bLhVg._)(r, [
        "id",
        "disabled",
        "value"
    ]), c = $6aa23c555810f7a8$var$j("Combobox.Option"), e = $6aa23c555810f7a8$var$Q("Combobox.Option"), p = c.activeOptionIndex !== null ? c.options[c.activeOptionIndex].id === a : !1, P = c.isSelected(i), s = (0, $7fPBF.useRef)(null), y = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)({
        disabled: u,
        value: i,
        domRef: s,
        textValue: (_ = (F = s.current) == null ? void 0 : F.textContent) == null ? void 0 : _.toLowerCase()
    }), T = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(n, s), C = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>e.selectOption(a));
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>e.registerOption(a, y), [
        y,
        a
    ]);
    let g = (0, $7fPBF.useRef)(!c.__demoMode);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (!c.__demoMode) return;
        let O = (0, $ae5551858911f61c$export$12b26c28a05aa001)();
        return O.requestAnimationFrame(()=>{
            g.current = !0;
        }), O.dispose;
    }, []), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (c.comboboxState !== 0 || !p || !g.current || c.activationTrigger === 0) return;
        let O = (0, $ae5551858911f61c$export$12b26c28a05aa001)();
        return O.requestAnimationFrame(()=>{
            var l, L;
            (L = (l = s.current) == null ? void 0 : l.scrollIntoView) == null || L.call(l, {
                block: "nearest"
            });
        }), O.dispose;
    }, [
        s,
        p,
        c.comboboxState,
        c.activationTrigger,
        c.activeOptionIndex
    ]);
    let R = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((O)=>{
        if (u) return O.preventDefault();
        C(), c.mode === 0 && e.closeCombobox();
    }), K = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        if (u) return e.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing);
        e.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Specific, a);
    }), h = (0, $d895e59b5353ecb4$export$24ebee078bde85c3)(), w = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((O)=>h.update(O)), B = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((O)=>{
        !h.wasMoved(O) || u || p || e.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Specific, a, 0);
    }), D = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((O)=>{
        !h.wasMoved(O) || u || !p || c.optionsPropsRef.current.hold || e.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing);
    }), W = (0, $7fPBF.useMemo)(()=>({
            active: p,
            selected: P,
            disabled: u
        }), [
        p,
        P,
        u
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            id: a,
            ref: T,
            role: "option",
            tabIndex: u === !0 ? void 0 : -1,
            "aria-disabled": u === !0 ? !0 : void 0,
            "aria-selected": P,
            disabled: void 0,
            onClick: R,
            onFocus: K,
            onPointerEnter: w,
            onMouseEnter: w,
            onPointerMove: B,
            onMouseMove: B,
            onPointerLeave: D,
            onMouseLeave: D
        },
        theirProps: d,
        slot: W,
        defaultTag: $6aa23c555810f7a8$var$Ze,
        name: "Combobox.Option"
    });
}), $6aa23c555810f7a8$export$27957ad87354dd7e = Object.assign($6aa23c555810f7a8$var$He, {
    Input: $6aa23c555810f7a8$var$Ke,
    Button: $6aa23c555810f7a8$var$Xe,
    Label: $6aa23c555810f7a8$var$Je,
    Options: $6aa23c555810f7a8$var$Ye,
    Option: $6aa23c555810f7a8$var$ze
});



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $3acafea68ad7ea7a$var$LinkIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z"
    }));
}
const $3acafea68ad7ea7a$var$ForwardRef = $7fPBF.forwardRef($3acafea68ad7ea7a$var$LinkIcon);
var $3acafea68ad7ea7a$export$2e2bcd8739ae039 = $3acafea68ad7ea7a$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ab59295cee9c0c78$var$ScissorsIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M1.469 3.75a3.5 3.5 0 0 0 5.617 4.11l.883.51c.025.092.147.116.21.043.15-.176.318-.338.5-.484.286-.23.3-.709-.018-.892l-.825-.477A3.501 3.501 0 0 0 1.47 3.75Zm2.03 3.482a2 2 0 1 1 2-3.464 2 2 0 0 1-2 3.464ZM9.956 8.322a2.75 2.75 0 0 0-1.588 1.822L7.97 11.63l-.884.51A3.501 3.501 0 0 0 1.47 16.25a3.5 3.5 0 0 0 6.367-2.81l10.68-6.166a.75.75 0 0 0-.182-1.373l-.703-.189a2.75 2.75 0 0 0-1.78.123L9.955 8.322ZM2.768 15.5a2 2 0 1 1 3.464-2 2 2 0 0 1-3.464 2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M12.52 11.89a.5.5 0 0 0 .056.894l3.274 1.381a2.75 2.75 0 0 0 1.78.123l.704-.189a.75.75 0 0 0 .18-1.373l-3.47-2.004a.5.5 0 0 0-.5 0L12.52 11.89Z"
    }));
}
const $ab59295cee9c0c78$var$ForwardRef = $7fPBF.forwardRef($ab59295cee9c0c78$var$ScissorsIcon);
var $ab59295cee9c0c78$export$2e2bcd8739ae039 = $ab59295cee9c0c78$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $0228f44f612826d5$var$DocumentDuplicateIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
    }));
}
const $0228f44f612826d5$var$ForwardRef = $7fPBF.forwardRef($0228f44f612826d5$var$DocumentDuplicateIcon);
var $0228f44f612826d5$export$2e2bcd8739ae039 = $0228f44f612826d5$var$ForwardRef;



/* eslint-disable import/no-extraneous-dependencies */ 
var $9tqwB = parcelRequire("9tqwB");
var $7e321f513a903538$exports = {};
var $63131acb82764e5d$exports = {};
"use strict";
Object.defineProperty($63131acb82764e5d$exports, "__esModule", {
    value: true
});
Object.defineProperty($63131acb82764e5d$exports, "default", {
    enumerable: true,
    get: ()=>$63131acb82764e5d$var$resolveConfig
});

const $63131acb82764e5d$var$_resolveConfig = /*#__PURE__*/ $63131acb82764e5d$var$_interopRequireDefault((parcelRequire("iKPNu")));

const $63131acb82764e5d$var$_getAllConfigs = /*#__PURE__*/ $63131acb82764e5d$var$_interopRequireDefault((parcelRequire("lmC4G")));
function $63131acb82764e5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $63131acb82764e5d$var$resolveConfig(...configs) {
    let [, ...defaultConfigs] = (0, $63131acb82764e5d$var$_getAllConfigs.default)(configs[0]);
    return (0, $63131acb82764e5d$var$_resolveConfig.default)([
        ...configs,
        ...defaultConfigs
    ]);
}


$7e321f513a903538$exports = ($63131acb82764e5d$exports.__esModule ? $63131acb82764e5d$exports : {
    default: $63131acb82764e5d$exports
}).default;


var $3a2e32dccf7fa05b$exports = {};
/* eslint-disable global-require */ /* eslint-disable import/no-extraneous-dependencies */ 
var $cErfA = parcelRequire("cErfA");

var $6oZBh = parcelRequire("6oZBh");




$3a2e32dccf7fa05b$exports = {
    content: [
        "./src/pages/**/*.{html,js,jsx}",
        "./src/elements/**/*.{html,js,jsx}",
        "./public/index.html"
    ],
    theme: {
        fontWeight: {
            hairline: 100,
            extralight: 100,
            light: 300,
            normal: 400,
            medium: 400,
            semibold: 700,
            bold: 700,
            extrabold: 700,
            black: 900
        },
        extend: {
            fontFamily: {
                sans: [
                    "Lato",
                    ...$cErfA.fontFamily.sans
                ]
            },
            colors: {
                gray: $6oZBh.slate,
                brandBlue: {
                    50: "#F0FAFF",
                    100: "#E0F4FF",
                    200: "#C1E9FF",
                    300: "#94D4F7",
                    400: "#60B9F7",
                    500: "#1797F2",
                    600: "#007bd2",
                    700: "#0060b4",
                    800: "#003a87",
                    900: "#002f79"
                },
                brandGreen: {
                    50: "#f1f9ec",
                    100: "#ecf7e6",
                    200: "#ddf0d3",
                    300: "#CAE8BA",
                    400: "#ABDE82",
                    500: "#92D050",
                    600: "#6ba929",
                    700: "#307200",
                    800: "#034f00",
                    900: "#012e00"
                },
                brandViolet: {
                    50: "#f9f2fb",
                    100: "#f4e4f6",
                    200: "#eed7f2",
                    300: "#e2bde9",
                    400: "#ce95dc",
                    500: "#BA6DCE",
                    600: "#8e44a3",
                    700: "#722987",
                    800: "#56096c",
                    900: "#49005e"
                },
                brandYellow: {
                    50: "#FFFAE6",
                    100: "#fff7d9",
                    200: "#fff3c7",
                    300: "#ffeca1",
                    400: "#ffe47a",
                    500: "#FFD600",
                    600: "#ceab00",
                    700: "#9e8200",
                    800: "#725b00",
                    900: "#4d3700"
                },
                brandRed: {
                    50: "#FFF5F4",
                    100: "#ffeae8",
                    200: "#FFC6C2",
                    300: "#FF9696",
                    400: "#f95949",
                    500: "#ED1C24",
                    600: "#cf000e",
                    700: "#b00000",
                    800: "#930000",
                    900: "#780000"
                },
                brandDarkBlue: {
                    50: "#F1F8F8",
                    100: "#DBE7FF",
                    200: "#879DD4",
                    300: "#616EAE",
                    400: "#474E9B",
                    500: "#2E3192",
                    600: "#1d2785",
                    700: "#001873",
                    800: "#000a60",
                    900: "#000055"
                }
            }
        }
    },
    plugins: [
        (parcelRequire("l6Yrh")),
        (parcelRequire("aRkbg")),
        (parcelRequire("lECVJ")),
        (parcelRequire("5LgCT"))
    ]
};


const $29b77351b10ec0da$var$fullConfig = (0, (/*@__PURE__*/$parcel$interopDefault($7e321f513a903538$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3a2e32dccf7fa05b$exports))));
const $29b77351b10ec0da$export$7a7a8c2474f854cd = (0, $9tqwB._)({
    xs: "475px"
}, $29b77351b10ec0da$var$fullConfig.theme.screens); // {xs: '475px', sm: '640px', md: '768px', lg: '1024px', xl: '1280px', 2xl: '1536px'}
const $29b77351b10ec0da$export$d07517a676ce386f = Object.keys($29b77351b10ec0da$export$7a7a8c2474f854cd);
function $29b77351b10ec0da$export$2e2bcd8739ae039() {
    var _window_visualViewport;
    const viewportWidth = typeof window !== "undefined" ? ((_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.width) || window.innerWidth : 0;
    const sortedBreakpointsBelowCurrentWidth = Object.entries($29b77351b10ec0da$export$7a7a8c2474f854cd).map(([key, value])=>[
            key,
            Number(value.replace("px", ""))
        ]).sort(([_, a], [__, b])=>b - a).filter(([_, a])=>viewportWidth >= a);
    if (sortedBreakpointsBelowCurrentWidth.length === 0) return null;
    return sortedBreakpointsBelowCurrentWidth[0][0];
}



/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/require-default-props */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function $a69e89b22df174b9$var$resizeTextarea(textarea) {
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
}
function $a69e89b22df174b9$export$2e2bcd8739ae039({ value: value, onChange: onChange, onFocus: onFocus, onBlur: onBlur, className: className }) {
    const textareaRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        $a69e89b22df174b9$var$resizeTextarea(textareaRef.current);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
        ref: textareaRef,
        rows: 1,
        value: value,
        onChange: (e)=>{
            onChange(e);
            $a69e89b22df174b9$var$resizeTextarea(e.target);
        },
        onFocus: onFocus,
        onBlur: onBlur,
        className: `w-full resize-none overflow-hidden px-1.5 py-2 text-left text-gray-700 leading-5 border-b rounded-md border-gray-300 focus:outline-none focus:border-brandBlue-400 ${className}`
    });
}
$a69e89b22df174b9$export$2e2bcd8739ae039.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$a69e89b22df174b9$export$2e2bcd8739ae039.defaultProps = {
    value: "",
    onChange: ()=>{},
    onFocus: ()=>{},
    onBlur: ()=>{},
    className: ""
};


function $a3e1a9b82249ba51$export$2e2bcd8739ae039({ category: category, transaction: transaction, splitTransactions: splitTransactions = [], signalHandleSubmit: signalHandleSubmit }) {
    $a3e1a9b82249ba51$export$2e2bcd8739ae039.propTypes = {
        category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        splitTransactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        signalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
    };
    $a3e1a9b82249ba51$export$2e2bcd8739ae039.defaultProps = {
        transaction: null,
        splitTransactions: []
    };
    const isEditExistingSplitMode = splitTransactions.length > 0;
    const loanMode = category === "loans";
    // we have to pass transaction to all the TransactionContext subcomponents, because only the two Split... components use splitTransactions
    // some of the code below relies of transaction being undefined when splitTransactions are passed, hence we handle that here
    const localTransaction = isEditExistingSplitMode ? undefined : transaction;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    function sumByField(field) {
        return splitTransactions.reduce((acc, curr)=>acc + curr[field], 0);
    }
    const amountToSplit = isEditExistingSplitMode ? sumByField("quantity") : localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.quantity;
    // ↓ for loans only, which has quantityInterest
    const amountToSplitInterest = isEditExistingSplitMode ? sumByField("quantityInterest") : localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.quantityInterest;
    const [focused, setFocused] = (0, $7fPBF.useState)(null);
    const [splitArray, setSplitArray] = (0, $7fPBF.useState)(isEditExistingSplitMode ? splitTransactions : [
        {
            id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
            quantity: amountToSplit,
            quantityInterest: amountToSplitInterest,
            description: localTransaction.description || localTransaction.displayName
        }
    ]);
    const [errorArray, setErrorArray] = (0, $7fPBF.useState)([]);
    const remainingAmount = amountToSplit - splitArray.reduce((a, b)=>a + b.quantity, 0);
    const remainingAmountInterest = amountToSplitInterest - splitArray.reduce((a, b)=>a + b.quantityInterest, 0);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // subscribe to the signalHandleSubmit and submit the form if it is true
    (0, $7fPBF.useEffect)(()=>{
        if (signalHandleSubmit && remainingAmount === 0 && !(!!remainingAmountInterest || remainingAmountInterest === 0)) {
            var _splitTransactions_;
            let data;
            if (category === "deposits") data = splitArray.map((item, idx)=>{
                var _splitTransactions_;
                return (0, $2qxEV._)((0, $9tqwB._)({}, localTransaction || splitTransactions[0], item), {
                    // id is being given already at append
                    parentId: (localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.id) || ((_splitTransactions_ = splitTransactions[0]) === null || _splitTransactions_ === void 0 ? void 0 : _splitTransactions_.parentId),
                    accountCurrencyAmount: item.quantity,
                    amount: ((localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.amount) || sumByField("amount")) * item.quantity / amountToSplit,
                    importFlag: "post"
                });
            });
            if (category === "stocks" || category === "crypto") // 241213 crypto added to the if statement above without testing
            data = splitArray.map((item)=>{
                var _splitTransactions_;
                return (0, $2qxEV._)((0, $9tqwB._)({}, localTransaction, item), {
                    // id is being given already at append
                    parentId: (localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.id) || ((_splitTransactions_ = splitTransactions[0]) === null || _splitTransactions_ === void 0 ? void 0 : _splitTransactions_.parentId),
                    transactionAmount: item.quantity,
                    rebasedAmount: ((localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.rebasedAmount) || sumByField("rebasedAmount")) * item.quantity / amountToSplit,
                    amount: ((localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.amount) || sumByField("amount")) * item.quantity / amountToSplit,
                    // ↓ 241213 removed transactionAmountSold and rebasedAmountSold from state (search for '241213')
                    // transactionAmountSold: ((localTransaction?.transactionAmountSold || sumByField('transactionAmountSold')) * item.quantity) / amountToSplit,
                    // rebasedAmountSold: ((localTransaction?.quantitySold || sumByField('quantitySold')) * item.quantity) / amountToSplit,
                    importFlag: "post"
                });
            });
            if (category === "loans") data = splitArray.map((item, idx)=>{
                var _splitTransactions_;
                return (0, $2qxEV._)((0, $9tqwB._)({}, localTransaction || splitTransactions[0], item), {
                    // id is being given already at append
                    parentId: (localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.id) || ((_splitTransactions_ = splitTransactions[0]) === null || _splitTransactions_ === void 0 ? void 0 : _splitTransactions_.parentId),
                    quantity: item.quantity,
                    quantityInterest: item.quantityInterest,
                    importFlag: "post"
                });
            });
            // delete the original transaction and its mappings
            // but not when we are in editExistingSplitMode (because that transaction does not exist anymore)
            if (!isEditExistingSplitMode) data.push((0, $2qxEV._)((0, $9tqwB._)({}, localTransaction), {
                importFlag: "delete"
            }));
            dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: data,
                category: category,
                accountId: (localTransaction === null || localTransaction === void 0 ? void 0 : localTransaction.accountId) || ((_splitTransactions_ = splitTransactions[0]) === null || _splitTransactions_ === void 0 ? void 0 : _splitTransactions_.accountId)
            }));
            window.dispatchEvent(new CustomEvent("setDialog", {}));
        }
    }, [
        signalHandleSubmit
    ]);
    function handleDeleteSplit(e, index) {
        if (splitArray.length > 1) setSplitArray(splitArray.filter((_, idx)=>idx !== index));
    }
    // adds a new line to the form (and to splitArray)
    function handleAddSplit(e) {
        // set amountToSplit to the available amountToSplit and description to the description of the original split item
        setSplitArray([
            ...splitArray,
            {
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                quantity: amountToSplit - splitArray.reduce((a, b)=>a + b.quantity, 0),
                description: splitArray[0].description
            }
        ]);
    }
    // updates the form row 'index' and field 'field' represented by item (for convenience) with the new value (e.target.value)
    function handleChangeSplit(e, item, index, field) {
        // check if the account is a number, otherwise display an error
        const arrayCopy = [
            ...splitArray
        ]; // remove the "old" transaction and replace it with t
        arrayCopy.splice(index, 1, (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            [field]: field === "quantity" && !Number.isNaN(Number(e.target.value)) ? Number(e.target.value) : e.target.value
        }));
        setSplitArray(arrayCopy);
    }
    function handleFocus(e, index = null, field = null) {
        // set focus state so that the input field may change the number format to a simpler one
        setFocused({
            index: index,
            field: field
        });
        setTimeout(()=>e.target.select(), 0);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-sm text-gray-500",
                children: t("splitHeader")
            }),
            category === "stocks" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-2 flex items-start",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 mr-1 text-brandBlue-400",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-xs italic text-gray-500",
                        children: t("splitInfo")
                    })
                ]
            }),
            remainingAmount === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
            remainingAmount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-500",
                children: `${t("amountToAllocate")}: ${-remainingAmount}`
            }),
            remainingAmount < 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-500",
                children: `${t("allocatedTooMuch")} ${Math.abs(remainingAmount)}`
            }),
            remainingAmountInterest === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
            remainingAmountInterest > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-500",
                children: `${t("amountToAllocateInterest")}: ${-remainingAmountInterest}`
            }),
            remainingAmountInterest < 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-1 text-sm text-red-500",
                children: `${t("allocatedTooMuchInterest")} ${Math.abs(remainingAmountInterest)}`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: "mt-4 divide divide-gray-100",
                children: [
                    splitArray.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                            className: "grid grid-cols-12 items-start p-2 gap-4 text-sm",
                            id: `row-${index}`,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: `flex items-start ${loanMode ? "col-span-7" : "col-span-8"}`,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a69e89b22df174b9$export$2e2bcd8739ae039), {
                                        className: "flex-1 text-sm",
                                        value: item.description,
                                        onChange: (e)=>handleChangeSplit(e, item, index, "description"),
                                        onFocus: handleFocus,
                                        onBlur: (e)=>{
                                            setFocused(null);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    className: `self-start px-1.5 py-2 text-gray-700 text-right border-b rounded-md border-gray-300 focus:outline-none focus:border-brandBlue-400 ${loanMode ? "col-span-2" : "col-span-3"}`,
                                    value: `${item.quantity}`,
                                    onChange: (e)=>handleChangeSplit(e, item, index, "quantity"),
                                    onFocus: (e)=>handleFocus(e, index, "quantity"),
                                    onBlur: (e)=>{
                                        setFocused(null);
                                    }
                                }),
                                loanMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    className: "self-start px-1.5 py-2 text-gray-700 text-right border-b rounded-md border-gray-300 focus:outline-none focus:border-brandBlue-400 col-span-2",
                                    value: `${item.quantityInterest}`,
                                    onChange: (e)=>handleChangeSplit(e, item, index, "quantityInterest"),
                                    onFocus: (e)=>handleFocus(e, index, "quantityInterest"),
                                    onBlur: (e)=>{
                                        setFocused(null);
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    className: "self-start pt-2",
                                    onClick: (e)=>handleDeleteSplit(e, index),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $125f450ca02db1e2$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 flex-0 mr-2 text-gray-300 hover:text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                }),
                                (errorArray === null || errorArray === void 0 ? void 0 : errorArray.includes(index)) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-red-500 col-span-12 text-sm",
                                    children: t("error")
                                })
                            ]
                        }, item.id)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: "p-2",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: handleAddSplit,
                            // eslint-disable-next-line max-len
                            className: "relative block w-full rounded-lg border border-dashed border-gray-300 p-1.5 text-center group hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-brandBlue-600 focus:ring-offset-2",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc348e8ecf02df23$export$2e2bcd8739ae039), {
                                className: "h-7 w-full text-gray-300 group-hover:text-gray-300",
                                "aria-hidden": "true"
                            })
                        })
                    }),
                    isEditExistingSplitMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center mt-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                className: "h-8 w-8 text-brandBlue-500",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "ml-2 text-sm text-gray-500",
                                children: t("splitExistingDetected")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $a3f0136050f4e79f$export$2e2bcd8739ae039({ transaction: transaction, transactions: transactions, signalHandleSubmit: signalHandleSubmit, setSignalHandleSubmit: setSignalHandleSubmit }) {
    $a3f0136050f4e79f$export$2e2bcd8739ae039.propTypes = {
        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        signalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        setSignalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
    };
    $a3f0136050f4e79f$export$2e2bcd8739ae039.defaultProps = {
        transaction: null,
        transactions: []
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    const projects = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects);
    const targetTransactions = transactions && transactions.length > 0 ? transactions : transaction ? [
        transaction
    ] : [];
    const primaryTransaction = targetTransactions[0];
    const [inProjectId, setInProjectId] = (0, $7fPBF.useState)(projects.find((p)=>p.id === (primaryTransaction === null || primaryTransaction === void 0 ? void 0 : primaryTransaction.projectId)));
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        if (signalHandleSubmit && primaryTransaction && targetTransactions.length > 0) {
            dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: targetTransactions.map((txn)=>(0, $2qxEV._)((0, $9tqwB._)({}, txn), {
                        projectId: (inProjectId === null || inProjectId === void 0 ? void 0 : inProjectId.id) || null,
                        importFlag: "put"
                    })),
                category: primaryTransaction.category,
                accountId: primaryTransaction.accountId
            }));
            window.dispatchEvent(new CustomEvent("setDialog", {}));
        }
    }, [
        signalHandleSubmit
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-sm text-gray-500",
                children: t("showInProjectInfo")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "projectId",
                        className: "flex text-sm font-medium text-gray-700",
                        children: t("pick")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                        id: "projectId",
                        name: "projectId",
                        value: inProjectId === null || inProjectId === void 0 ? void 0 : inProjectId.id,
                        onChange: (e)=>setInProjectId(projects.find((p)=>p.id === e.target.value)),
                        className: "mt-2 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full sm:text-sm border-gray-300 rounded-md",
                        children: [
                            {
                                id: null,
                                name: ""
                            }
                        ].concat(projects).map((p)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: (p === null || p === void 0 ? void 0 : p.id) || null,
                                children: (p === null || p === void 0 ? void 0 : p.name) || ""
                            }))
                    })
                ]
            })
        ]
    });
}


/* eslint-disable no-nested-ternary */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





function $638f9e29e17e4644$export$2e2bcd8739ae039({ transaction: transaction, transactions: transactions, signalHandleSubmit: signalHandleSubmit, setSignalHandleSubmit: setSignalHandleSubmit }) {
    $638f9e29e17e4644$export$2e2bcd8739ae039.propTypes = {
        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        signalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        setSignalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
    };
    $638f9e29e17e4644$export$2e2bcd8739ae039.defaultProps = {
        transaction: null,
        transactions: []
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    const [copyToProjectId, setCopyToProjectId] = (0, $7fPBF.useState)("");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const projects = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects);
    const targetTransactions = transactions && transactions.length > 0 ? transactions : transaction ? [
        transaction
    ] : [];
    const primaryTransaction = targetTransactions[0];
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        async function executeEffect() {
            try {
                setLoading(true);
                await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                    data: targetTransactions.map((txn)=>(0, $2qxEV._)((0, $9tqwB._)({}, txn), {
                            projectId: copyToProjectId === null || copyToProjectId === void 0 ? void 0 : copyToProjectId.id,
                            id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                            importFlag: "post"
                        })),
                    category: primaryTransaction.category,
                    accountId: primaryTransaction.accountId
                }));
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("transactionCreatedSuccess"));
                window.dispatchEvent(new CustomEvent("setDialog", {}));
            } catch (error) {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("transactionCreatedError"));
                setLoading(false);
            }
        }
        if (signalHandleSubmit && primaryTransaction && targetTransactions.length > 0) executeEffect();
    }, [
        signalHandleSubmit
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-sm text-gray-500",
                children: t("copyAsSimulatedInfo")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "projectId",
                        className: "flex text-sm font-medium text-gray-700",
                        children: t("pick")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                        id: "projectId",
                        name: "projectId",
                        value: copyToProjectId === null || copyToProjectId === void 0 ? void 0 : copyToProjectId.id,
                        onChange: (e)=>setCopyToProjectId(projects.find((p)=>p.id === e.target.value)),
                        className: "mt-2 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full sm:text-sm border-gray-300 rounded-md",
                        children: [
                            {
                                id: null,
                                name: ""
                            }
                        ].concat(projects).map((p)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: (p === null || p === void 0 ? void 0 : p.id) || null,
                                children: (p === null || p === void 0 ? void 0 : p.name) || ""
                            }))
                    })
                ]
            })
        ]
    });
}


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







function $360a068b01784d25$export$ede4b2e0172bbdb1(tags) {
    return typeof tags === "string" ? JSON.parse(tags) : tags || {};
}
function $360a068b01784d25$export$3a43b23fd491c014(transaction) {
    const numericValue = [
        transaction === null || transaction === void 0 ? void 0 : transaction.accountCurrencyAmount,
        transaction === null || transaction === void 0 ? void 0 : transaction.quantity,
        transaction === null || transaction === void 0 ? void 0 : transaction.amount
    ].find((value)=>typeof value === "number" && value !== 0);
    return numericValue && numericValue < 0 ? -1 : 1;
}
function $360a068b01784d25$var$sumByField(splitTransactions, field) {
    return splitTransactions.reduce((acc, curr)=>acc + (Number(curr === null || curr === void 0 ? void 0 : curr[field]) || 0), 0);
}
function $360a068b01784d25$export$ab4907c4696bb6c({ currentTransaction: currentTransaction, splitTransactions: splitTransactions = [], isEditExistingSplitMode: isEditExistingSplitMode = false, currentTags: currentTags = {} }) {
    let amountToSplitAbsolute = (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.accountCurrencyAmount) || (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.transactionAmount) || (currentTransaction === null || currentTransaction === void 0 ? void 0 : currentTransaction.quantity) || 0;
    if (isEditExistingSplitMode) amountToSplitAbsolute = $360a068b01784d25$var$sumByField(splitTransactions, "accountCurrencyAmount");
    else if (currentTags === null || currentTags === void 0 ? void 0 : currentTags.loanRepayment) amountToSplitAbsolute = (Number(currentTags.loanRepayment.principal) || 0) + (Number(currentTags.loanRepayment.interest) || 0);
    return Math.abs(amountToSplitAbsolute);
}
function $360a068b01784d25$export$aaf5eae828a965b5({ currentTags: currentTags = {}, splitTransactions: splitTransactions = [], isEditExistingSplitMode: isEditExistingSplitMode = false, amountToSplitAbsolute: amountToSplitAbsolute = 0 }) {
    var _splitTransactions_find, _splitTransactions_find1;
    if (currentTags === null || currentTags === void 0 ? void 0 : currentTags.loanRepayment) return {
        principal: Math.abs(Number(currentTags.loanRepayment.principal) || 0),
        interest: Math.abs(Number(currentTags.loanRepayment.interest) || 0)
    };
    if (isEditExistingSplitMode) return {
        principal: Math.abs(Number((_splitTransactions_find = splitTransactions.find((item)=>item.label === "investment-loanPrincipal")) === null || _splitTransactions_find === void 0 ? void 0 : _splitTransactions_find.accountCurrencyAmount) || 0),
        interest: Math.abs(Number((_splitTransactions_find1 = splitTransactions.find((item)=>item.label === "investment-loanInterest")) === null || _splitTransactions_find1 === void 0 ? void 0 : _splitTransactions_find1.accountCurrencyAmount) || 0)
    };
    return {
        principal: amountToSplitAbsolute,
        interest: 0
    };
}
async function $360a068b01784d25$export$45af83a7cafc4fac(description = "") {
    const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "misc/ai", {
        body: {
            message: description,
            mode: "getInterestAndPrincipal"
        },
        headers: {
            "Content-Type": "application/json"
        }
    });
    const { principal: principal, interest: interest } = (response === null || response === void 0 ? void 0 : response.result) || {};
    const isPrincipalNumber = typeof principal === "number" && Number.isFinite(principal);
    const isInterestNumber = typeof interest === "number" && Number.isFinite(interest);
    if (!isPrincipalNumber || !isInterestNumber) return null;
    return {
        principal: Math.abs(principal),
        interest: Math.abs(interest)
    };
}
function $360a068b01784d25$export$28fc9f77bf170f5c({ selectedLoanAccount: selectedLoanAccount, currentLoanBalance: currentLoanBalance = 0 }) {
    if (!selectedLoanAccount) return null;
    const calculatedObject = (0, $e6392d36b7d388c7$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month").valueOf(), currentLoanBalance, selectedLoanAccount, []);
    const requestedMonth = calculatedObject.schedule.find((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).isSame((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month"), "month"));
    return {
        interest: Math.abs((requestedMonth === null || requestedMonth === void 0 ? void 0 : requestedMonth.currentInterest) || 0),
        principal: Math.abs((requestedMonth === null || requestedMonth === void 0 ? void 0 : requestedMonth.currentPrincipal) || 0)
    };
}
function $360a068b01784d25$export$85cacb999bbb1686(splitTransactions = [], field) {
    return $360a068b01784d25$var$sumByField(splitTransactions, field);
}



function $8b31f36815c115ad$var$buildEligibleLoanAccountsByDepositAccount(allAccounts = []) {
    const map = new Map();
    allAccounts.filter((account)=>account.category === "loans").forEach((loanAccount)=>{
        (loanAccount.connectedDepositAccounts || []).forEach((depositAccountId)=>{
            const list = map.get(depositAccountId) || [];
            list.push(loanAccount);
            map.set(depositAccountId, list);
        });
    });
    return map;
}
function $8b31f36815c115ad$export$2e2bcd8739ae039({ transactions: transactions, category: category, signalHandleSubmit: signalHandleSubmit, setIsActionRunning: setIsActionRunning }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    const [isRunning, setIsRunning] = (0, $7fPBF.useState)(false);
    const loansByDepositAccount = (0, $7fPBF.useMemo)(()=>$8b31f36815c115ad$var$buildEligibleLoanAccountsByDepositAccount(allAccounts), [
        allAccounts
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setIsActionRunning(isRunning);
    }, [
        isRunning,
        setIsActionRunning
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function run() {
            if (!signalHandleSubmit || isRunning || category !== "deposits" || !(transactions === null || transactions === void 0 ? void 0 : transactions.length)) return;
            setIsRunning(true);
            try {
                const successfulUpdates = [];
                let hadFailure = false;
                // Run AI in parallel for better UX on multi-select.
                const splitResults = await Promise.all(transactions.map(async (transaction)=>{
                    try {
                        const split = await (0, $360a068b01784d25$export$45af83a7cafc4fac)((transaction === null || transaction === void 0 ? void 0 : transaction.description) || "");
                        return {
                            transaction: transaction,
                            split: split
                        };
                    } catch (error) {
                        return {
                            transaction: transaction,
                            split: null
                        };
                    }
                }));
                splitResults.forEach(({ transaction: transaction, split: split })=>{
                    var _connectedLoanAccounts_;
                    if (!split) {
                        hadFailure = true;
                        return;
                    }
                    const tags = (0, $360a068b01784d25$export$ede4b2e0172bbdb1)(transaction === null || transaction === void 0 ? void 0 : transaction.tags);
                    const connectedLoanAccounts = loansByDepositAccount.get(transaction.accountId) || [];
                    let resolvedLoanAccountId = (tags === null || tags === void 0 ? void 0 : tags.accountId) || null;
                    const hasResolvedLoan = resolvedLoanAccountId && allAccounts.some((acc)=>acc.id === resolvedLoanAccountId && acc.category === "loans");
                    if (!hasResolvedLoan) resolvedLoanAccountId = ((_connectedLoanAccounts_ = connectedLoanAccounts[0]) === null || _connectedLoanAccounts_ === void 0 ? void 0 : _connectedLoanAccounts_.id) || null;
                    if (!resolvedLoanAccountId) {
                        hadFailure = true;
                        return;
                    }
                    delete tags.assetId;
                    successfulUpdates.push((0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                        label: "investment-loanRepayment",
                        tags: (0, $2qxEV._)((0, $9tqwB._)({}, tags), {
                            accountId: resolvedLoanAccountId,
                            loanRepayment: {
                                principal: Math.abs(split.principal),
                                interest: Math.abs(split.interest)
                            }
                        }),
                        linkedTransactions: (transaction.linkedTransactions || []).filter((linkedTransaction)=>{
                            var _linkedTransaction_tags;
                            return ![
                                "fee-to-transaction",
                                "sale-to-transaction",
                                "transfer"
                            ].includes((_linkedTransaction_tags = linkedTransaction.tags) === null || _linkedTransaction_tags === void 0 ? void 0 : _linkedTransaction_tags.linkType);
                        }),
                        importFlag: "put",
                        parentId: null
                    }));
                });
                if (successfulUpdates.length > 0) {
                    const updatesByAccount = successfulUpdates.reduce((acc, item)=>{
                        const existing = acc[item.accountId] || [];
                        existing.push(item);
                        acc[item.accountId] = existing;
                        return acc;
                    }, {});
                    await Promise.all(Object.entries(updatesByAccount).map(([txnAccountId, data])=>dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                            data: data,
                            category: "deposits",
                            accountId: txnAccountId
                        }))));
                    if (hadFailure) dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("unableToUpdateAllTransactions"));
                    window.dispatchEvent(new CustomEvent("setDialog", {}));
                    return;
                }
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("unableToUpdateAllTransactions"));
            } catch (error) {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("unableToUpdateAllTransactions"));
            } finally{
                setIsRunning(false);
            }
        }
        run();
    }, [
        signalHandleSubmit,
        isRunning,
        category,
        transactions,
        loansByDepositAccount,
        allAccounts,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-sm text-gray-500",
                children: t("aiLabelLoanRepaymentInfo")
            }),
            isRunning && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-2 flex items-start gap-2",
                "data-testid": "ai-loan-repayment-running",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10c3ddecbaea2060$export$42d15847cf9e98e1), {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 600 600"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-sm text-gray-400",
                                children: t("aiLabelLoanRepaymentRunning")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-xs text-gray-400",
                                children: t("aiLabelLoanRepaymentRunningTakesUpTo30s")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$8b31f36815c115ad$export$2e2bcd8739ae039.propTypes = {
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    signalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setIsActionRunning: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$8b31f36815c115ad$export$2e2bcd8739ae039.defaultProps = {
    setIsActionRunning: ()=>{}
};


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $52433d7025bd48d5$export$2e2bcd8739ae039({ transaction: transaction, transactions: transactions, signalHandleSubmit: signalHandleSubmit, setSignalHandleSubmit: setSignalHandleSubmit }) {
    $52433d7025bd48d5$export$2e2bcd8739ae039.propTypes = {
        transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        signalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        setSignalHandleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
    };
    $52433d7025bd48d5$export$2e2bcd8739ae039.defaultProps = {
        transaction: null,
        transactions: []
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const transactionsToDelete = transactions && transactions.length > 0 ? transactions : transaction ? [
        transaction
    ] : [];
    const primaryTransaction = transactionsToDelete[0];
    (0, $7fPBF.useEffect)(()=>{
        if (signalHandleSubmit && primaryTransaction && transactionsToDelete.length > 0) {
            dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: transactionsToDelete.map((txn)=>(0, $2qxEV._)((0, $9tqwB._)({}, txn), {
                        importFlag: "delete"
                    })),
                category: primaryTransaction.category,
                accountId: primaryTransaction.accountId
            }));
            window.dispatchEvent(new CustomEvent("setDialog", {}));
        }
    }, [
        signalHandleSubmit
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mt-2",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
            className: "text-sm text-gray-500",
            children: t("pressSaveToDelete")
        })
    });
}


function $9fcf484b900aa08c$var$isMobileLayout(breakpoint) {
    return breakpoint === "xs" || breakpoint === "sm" || !breakpoint;
}
function $9fcf484b900aa08c$export$2e2bcd8739ae039({ transactionIds: transactionIds }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    const { t: tG } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "general"
    });
    const resolvedTransactionIds = Array.isArray(transactionIds) ? transactionIds : transactionIds ? [
        transactionIds
    ] : [];
    const multipleTransactionsSelected = resolvedTransactionIds.length > 1;
    const selectTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $3679aa7475d9bd44$export$6d68928c2b6ce1a6)(state));
    const transactions = selectTransactions.filter((tx)=>resolvedTransactionIds.includes(tx.id));
    const transaction = transactions[0];
    const category = transaction === null || transaction === void 0 ? void 0 : transaction.category;
    const hasSplitOption = !multipleTransactionsSelected && ![
        "metals",
        "realEstate",
        "unlistedShares"
    ].includes(category);
    const hasAiLoanRepaymentOption = category === "deposits" && resolvedTransactionIds.length > 0;
    const [currentPanel, setCurrentPanel] = (0, $7fPBF.useState)([
        "realEstate",
        "metals"
    ].includes(category) ? "linkToProject" : "split");
    const [signalHandleSubmit, setSignalHandleSubmit] = (0, $7fPBF.useState)(false);
    const [isActionRunning, setIsActionRunning] = (0, $7fPBF.useState)(false);
    const [currentBreakpoint, setCurrentBreakpoint] = (0, $7fPBF.useState)("md"); // stores current breakpoint
    const [panesToShow, setPanesToShow] = (0, $7fPBF.useState)([
        true,
        true
    ]); // [menu, submenu]
    // check if the transaction has been split before (if it has parentId); and if so, find all the split transactions for the same parentId
    let splitTransactions = [];
    if (hasSplitOption && (transaction === null || transaction === void 0 ? void 0 : transaction.parentId)) splitTransactions = selectTransactions.filter((tx)=>tx.parentId === transaction.parentId);
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    function handleCancel(closeDialog = false) {
        if (isActionRunning) return;
        // if we are in the mobile layout, we need to go back from submenu to menu
        if (!closeDialog) setPanesToShow([
            true,
            false
        ]);
        else window.dispatchEvent(new CustomEvent("setDialog", {}));
    }
    const options = [
        {
            id: "linkToProject",
            Icon: (0, $3acafea68ad7ea7a$export$2e2bcd8739ae039),
            name: t("showInProject")
        }
    ];
    if (hasSplitOption) options.push({
        id: "split",
        Icon: (0, $ab59295cee9c0c78$export$2e2bcd8739ae039),
        name: t("split")
    });
    if (hasAiLoanRepaymentOption) options.push({
        id: "aiLabelLoanRepayment",
        Icon: (0, $ab59295cee9c0c78$export$2e2bcd8739ae039),
        name: t("aiLabelLoanRepayment")
    });
    // as last item comes Delete
    options.push({
        id: "copyToProject",
        Icon: (0, $0228f44f612826d5$export$2e2bcd8739ae039),
        name: t("copyAsSimulated")
    }, {
        id: "delete",
        Icon: (0, $125f450ca02db1e2$export$2e2bcd8739ae039),
        name: t("delete")
    });
    (0, $7fPBF.useEffect)(()=>{
        if (currentPanel === "split" && !hasSplitOption || currentPanel === "aiLabelLoanRepayment" && !hasAiLoanRepaymentOption) setCurrentPanel("linkToProject");
    }, [
        currentPanel,
        hasSplitOption,
        hasAiLoanRepaymentOption
    ]);
    let Component;
    switch(currentPanel){
        case "copyToProject":
            Component = (0, $638f9e29e17e4644$export$2e2bcd8739ae039);
            break;
        case "linkToProject":
            Component = (0, $a3f0136050f4e79f$export$2e2bcd8739ae039);
            break;
        case "aiLabelLoanRepayment":
            Component = (0, $8b31f36815c115ad$export$2e2bcd8739ae039);
            break;
        case "delete":
            Component = (0, $52433d7025bd48d5$export$2e2bcd8739ae039);
            break;
        case "split":
        default:
            Component = (0, $a3e1a9b82249ba51$export$2e2bcd8739ae039);
    }
    // INITIALISE COMPONENT
    (0, $7fPBF.useEffect)(()=>{
        // Handle window resize and update breakpoint state
        const handleResize = ()=>{
            const newBreakpoint = (0, $29b77351b10ec0da$export$2e2bcd8739ae039)();
            setCurrentBreakpoint(newBreakpoint);
            return newBreakpoint;
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Set initial breakpoint
        const newBreakpoint = handleResize();
        // set panes depending on breakpoint
        if ($9fcf484b900aa08c$var$isMobileLayout(newBreakpoint)) setPanesToShow([
            true,
            false
        ]); // else use default
        // Remove event listener on cleanup
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    // HANDLE MENU OPTION CHANGE
    function handleMenuOptionChange(option) {
        // if this runs as a result of user changing the option in Combobox, option is the new option
        // if this runs as a result of clicking on the currently selected option, skip setting the state
        if (option) setCurrentPanel(option);
        if (option === "aiLabelLoanRepayment") window.dispatchEvent(new CustomEvent("clearTableSelection"));
        // set panes depending on whether the selected option has a next level or not (and whether we are on mobile)
        if ($9fcf484b900aa08c$var$isMobileLayout(currentBreakpoint)) setPanesToShow([
            false,
            true
        ]);
        else setPanesToShow([
            true,
            true
        ]);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `mx-auto max-w-3xl transform ${$9fcf484b900aa08c$var$isMobileLayout(currentBreakpoint) && "divide-x divide-gray-100"} overflow-hidden rounded-xl bg-white p-4 shadow-2xl ring-1 ring-black ring-opacity-5 transition-all grid ${$9fcf484b900aa08c$var$isMobileLayout(currentBreakpoint) ? "grid-cols-1" : "grid-cols-3 gap-4"}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e), {
                as: "div",
                value: currentPanel,
                onChange: handleMenuOptionChange,
                id: "context-menu-main",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Options, {
                        as: "div",
                        static: true,
                        hold: true,
                        className: "flex divide-x divide-gray-100 col-span-1",
                        children: panesToShow[0] && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: classNames("sm:max-h-[30rem] min-w-0 flex-auto scroll-py-4 overflow-y-auto p-2"),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "-mx-2 text-sm text-gray-700",
                                children: options.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                                        as: "div",
                                        value: item.id,
                                        "data-testid": item.id,
                                        className: classNames("flex cursor-pointer select-none items-center rounded-md p-2", item.id === currentPanel ? "bg-brandBlue-500 hover:bg-brandBlue-600 text-white" : "bg-white hover:bg-gray-100 text-gray-900"),
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.Icon, {
                                                    className: "h-6 w-6 flex-none rounded-full"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "ml-3 flex-auto truncate",
                                                    children: item.name
                                                })
                                            ]
                                        })
                                    }, item.id))
                            })
                        })
                    }),
                    panesToShow[0] && $9fcf484b900aa08c$var$isMobileLayout(currentBreakpoint) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-center mt-2",
                        id: "context-menu-mobile-cancel-button",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            text: tG("cancel"),
                            size: "xl",
                            onClick: handleCancel,
                            enabled: !isActionRunning
                        })
                    })
                ]
            }),
            panesToShow[1] && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: `sm:h-[30rem] flex-col justify-between overflow-y-auto overflow-x-hidden flex ${!$9fcf484b900aa08c$var$isMobileLayout(currentBreakpoint) && "pl-4"} col-span-2`,
                id: "context-menu-subpanel",
                children: [
                    currentPanel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, {
                        category: category,
                        transaction: transaction,
                        transactions: transactions,
                        splitTransactions: splitTransactions,
                        signalHandleSubmit: signalHandleSubmit,
                        setSignalHandleSubmit: setSignalHandleSubmit,
                        setIsActionRunning: setIsActionRunning
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-4 mt-8 mx-1 mb-1",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: tG("cancel"),
                                size: "xl",
                                onClick: $9fcf484b900aa08c$var$isMobileLayout(currentBreakpoint) ? handleCancel : ()=>handleCancel(true),
                                enabled: !isActionRunning
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: currentPanel === "aiLabelLoanRepayment" ? t("run") : tG("save"),
                                size: "xl",
                                withAccent: true,
                                enabled: !isActionRunning,
                                onClick: ()=>{
                                    if (isActionRunning) return;
                                    setSignalHandleSubmit(true);
                                    setTimeout(()=>{
                                        setSignalHandleSubmit(false);
                                    }, 100);
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$9fcf484b900aa08c$export$2e2bcd8739ae039.propTypes = {
    transactionIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string).isRequired
};


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable no-return-assign */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");










var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $0e9fd7f258e6c46b$var$ArchiveBoxArrowDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0-3-3m3 3 3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    }));
}
const $0e9fd7f258e6c46b$var$ForwardRef = $7fPBF.forwardRef($0e9fd7f258e6c46b$var$ArchiveBoxArrowDownIcon);
var $0e9fd7f258e6c46b$export$2e2bcd8739ae039 = $0e9fd7f258e6c46b$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2f6b4a04d7a7435e$var$CurrencyEuroIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $2f6b4a04d7a7435e$var$ForwardRef = $7fPBF.forwardRef($2f6b4a04d7a7435e$var$CurrencyEuroIcon);
var $2f6b4a04d7a7435e$export$2e2bcd8739ae039 = $2f6b4a04d7a7435e$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $dcbdf16bdb83b89e$var$ReceiptPercentIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m9 14.25 6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185ZM9.75 9h.008v.008H9.75V9Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008V13.5Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    }));
}
const $dcbdf16bdb83b89e$var$ForwardRef = $7fPBF.forwardRef($dcbdf16bdb83b89e$var$ReceiptPercentIcon);
var $dcbdf16bdb83b89e$export$2e2bcd8739ae039 = $dcbdf16bdb83b89e$var$ForwardRef;



function $0640c93d741bcc75$export$2e2bcd8739ae039({ category: category, t: t, accountsConnectedToThisOne: accountsConnectedToThisOne, transactions: transactions, loanAccountsForRepaymentTagging: loanAccountsForRepaymentTagging = [] }) {
    const transactionsAmount = transactions.length;
    const options = [];
    const connectedCategories = new Set(accountsConnectedToThisOne.map((acc)=>acc.category));
    if (category === "deposits") {
        options.push({
            id: null,
            Icon: (0, $125f450ca02db1e2$export$2e2bcd8739ae039),
            name: t("labels.noLabel.long"),
            nextLevel: false,
            requiresPositiveAmount: true,
            requiresNegativeAmount: true
        });
        // transfers are linked to a particular transaction, so only show if there is a single transaction selected
        if (transactionsAmount === 1) options.push({
            id: "investment-transfer",
            Icon: (0, $3ea1f91ff88fa2cb$export$83099edae52007d2),
            name: t("labels.investment-transfer.long"),
            nextLevel: true,
            requiresPositiveAmount: true,
            requiresNegativeAmount: true
        });
        if (transactionsAmount === 1 && loanAccountsForRepaymentTagging.length > 0) options.push({
            id: "investment-loanRepayment",
            Icon: (0, $0e9fd7f258e6c46b$export$2e2bcd8739ae039),
            name: t("labels.investment-loanRepayment.long"),
            nextLevel: true,
            requiresNegativeAmount: true
        });
        if (accountsConnectedToThisOne.length > 0) {
            // fees and sale are linked to a particular transaction, so only show if there is a single transaction selected
            if (transactionsAmount === 1) {
                options.push({
                    id: "investment-fees",
                    Icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039),
                    name: t("labels.investment-fees.long"),
                    nextLevel: true,
                    requiresNegativeAmount: true
                });
                options.push({
                    id: "investment-sale",
                    Icon: (0, $3ea1f91ff88fa2cb$export$6c72b8f14a769aaa),
                    name: t("labels.investment-sale.long"),
                    nextLevel: true,
                    requiresPositiveAmount: true
                });
            }
            options.push({
                id: "investment-costs",
                Icon: (0, $2f6b4a04d7a7435e$export$2e2bcd8739ae039),
                name: t("labels.investment-costs.long"),
                nextLevel: true,
                requiresNegativeAmount: true
            });
            if (!connectedCategories.has("loans")) options.push({
                id: "investment-purchase",
                Icon: (0, $3ea1f91ff88fa2cb$export$833dc7fbd6b858f7),
                name: t("labels.investment-purchase.long"),
                nextLevel: false,
                requiresNegativeAmount: true
            });
        }
        if (connectedCategories.has("deposits")) options.push({
            id: "investment-interest",
            Icon: (0, $dcbdf16bdb83b89e$export$2e2bcd8739ae039),
            name: t("labels.investment-interest.long"),
            nextLevel: true,
            requiresPositiveAmount: true
        });
        if (connectedCategories.has("realEstate")) options.push({
            id: "investment-rent",
            Icon: (0, $63a505abc1d6767c$export$2e2bcd8739ae039),
            name: t("labels.investment-rent.long"),
            nextLevel: true,
            requiresPositiveAmount: true
        });
        if (connectedCategories.has("stocks")) options.push({
            id: "investment-dividend",
            Icon: (0, $eeaa4d476c1d806f$export$2e2bcd8739ae039),
            name: t("labels.investment-dividend.long"),
            nextLevel: true,
            requiresPositiveAmount: true
        });
        if (connectedCategories.has("loans")) options.push({
            id: "investment-payout",
            Icon: (0, $0e9fd7f258e6c46b$export$2e2bcd8739ae039),
            name: t("labels.investment-payout.long"),
            nextLevel: false,
            requiresPositiveAmount: true
        });
        if (connectedCategories.has("pension")) {
            options.push({
                id: "investment-contribution",
                Icon: (0, $3ea1f91ff88fa2cb$export$833dc7fbd6b858f7),
                name: t("labels.investment-contribution.long"),
                nextLevel: true,
                requiresNegativeAmount: true
            });
            options.push({
                id: "investment-pension",
                Icon: (0, $dcbdf16bdb83b89e$export$2e2bcd8739ae039),
                name: t("labels.investment-pension.long"),
                nextLevel: true,
                requiresPositiveAmount: true
            });
        }
    }
    return options;
}


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");


var $2oXYc = parcelRequire("2oXYc");
parcelRequire("7fPBF");
/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

function $3b4d597555017c22$export$2e2bcd8739ae039({ accountName: accountName, category: category, styleClasses: styleClasses }) {
    const colorStyle = (0, $134ab0040d88b150$export$205e6715f8ffaf7d)[category] ? `${(0, $134ab0040d88b150$export$205e6715f8ffaf7d)[category].color.bg} ${(0, $134ab0040d88b150$export$205e6715f8ffaf7d)[category].color.text}` : "bg-gray-100 text-gray-500";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        className: `inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium uppercase ${colorStyle} ${styleClasses}`,
        children: accountName || "?"
    });
}
$3b4d597555017c22$export$2e2bcd8739ae039.propTypes = {
    accountName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "deposits",
        "stocks",
        "realEstate",
        "objectsOfValue",
        "pension",
        "metals",
        "loans",
        "unlistedShares",
        "crypto"
    ]).isRequired,
    styleClasses: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$3b4d597555017c22$export$2e2bcd8739ae039.defaultProps = {
    styleClasses: ""
};



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $e3cbc05a952d1319$export$2e2bcd8739ae039({ handleSave: handleSave, handleCancel: handleCancel, loading: loading }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "grid grid-cols-2 gap-2 p-1",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                text: t("cancel.label"),
                onClick: ()=>handleCancel(),
                size: "md"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                text: t("save.label"),
                onClick: handleSave,
                size: "md",
                withAccent: true,
                spinnerOn: loading
            })
        ]
    });
}
$e3cbc05a952d1319$export$2e2bcd8739ae039.propTypes = {
    handleSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};


function $3497453586277ad5$export$2e2bcd8739ae039({ selectedOption: selectedOption, accountId: accountId, handleCloseAfterSave: handleCloseAfterSave, handleCancel: handleCancel, linkedAttribute: linkedAttribute, transactions: transactions }) {
    var _allAccounts_filter;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits"
    });
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [localLinkedAttribute, setLocalLinkedAttribute] = (0, $7fPBF.useState)(linkedAttribute); // intialise to the object from props (should there be an existing linkedAttribute already)
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    const accountIdsConnectedToThis = (_allAccounts_filter = allAccounts.filter((account)=>{
        var _account_connectedDepositAccounts;
        return (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.includes(accountId);
    })) === null || _allAccounts_filter === void 0 ? void 0 : _allAccounts_filter.map((account)=>account.id);
    const accountsFilteredByConnectedAccounts = allAccounts.filter((account)=>accountIdsConnectedToThis ? accountIdsConnectedToThis === null || accountIdsConnectedToThis === void 0 ? void 0 : accountIdsConnectedToThis.includes(account.id) : true).filter((account)=>selectedOption.id === "investment-contribution" ? account.category === "pension" : true) // only show pension accounts for contributions
    .filter((account)=>selectedOption.id === "investment-loanInterest" ? account.category === "loans" : true); // only show loan accounts for interest
    async function handleSave() {
        if (transactions.length === 0) return;
        // check if a transaction is selected
        if (!(localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.accountId)) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("symbolNotSelected"));
            return;
        }
        const updatedTransactions = [];
        try {
            transactions.forEach((transaction)=>{
                const updatedTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                    label: selectedOption.id,
                    // courtesy adjustment of costs (must be a negative number)
                    amount: -Math.abs(transaction.amount),
                    importFlag: "put"
                });
                // save the assetId and accountId to the transaction tags
                updatedTransaction.tags = (0, $2qxEV._)((0, $9tqwB._)({}, typeof updatedTransaction.tags === "string" ? JSON.parse(updatedTransaction.tags) : updatedTransaction.tags), {
                    assetId: localLinkedAttribute.assetId,
                    accountId: localLinkedAttribute.accountId
                });
                updatedTransactions.push(updatedTransaction);
            });
        } catch (e) {
            return; // we already show an error message
        }
        setLoading(true);
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: updatedTransactions,
                category: "deposits",
                accountId: accountId
            }));
        } catch (err) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
        setLoading(false);
        handleCloseAfterSave();
    }
    if (transactions.length === 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col gap-2 overflow-y-auto",
                "data-testid": "blue-transactions-costs",
                children: [
                    accountsFilteredByConnectedAccounts.map((x)=>// ^^ returns an array of account objects
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setLocalLinkedAttribute((0, $2qxEV._)((0, $9tqwB._)({}, localLinkedAttribute), {
                                    accountId: x.id,
                                    assetId: x.id
                                })),
                            // ^^ assetId added to enable mapping of account-level costs onto account also for stocks;
                            // commonAssetView will map the account level costs to an accountId > assetId = accountId
                            "data-testid": "sublist-account",
                            className: `text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
          ${(x === null || x === void 0 ? void 0 : x.id) === (localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.accountId) ? "bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent" : "bg-white text-gray-900 hover:bg-gray-50"}`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                accountName: x === null || x === void 0 ? void 0 : x.name,
                                category: x === null || x === void 0 ? void 0 : x.category
                            })
                        }, x.id)),
                    accountsFilteredByConnectedAccounts.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-sm text-gray-500 self-center mt-2",
                        children: t("noAccounts")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "space-y-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3cbc05a952d1319$export$2e2bcd8739ae039), {
                    handleSave: handleSave,
                    handleCancel: handleCancel,
                    loading: loading
                })
            })
        ]
    });
}
$3497453586277ad5$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    linkedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    handleCloseAfterSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$3497453586277ad5$export$2e2bcd8739ae039.defaultProps = {
    linkedAttribute: {}
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






function $70cf39590e51e56d$export$2e2bcd8739ae039({ selectedOption: selectedOption, accountId: accountId, linkedAttribute: linkedAttribute, handleCloseAfterSave: handleCloseAfterSave, handleCancel: handleCancel, transactions: transactions }) {
    var _Object_keys_flatMap, _Object_keys;
    // for dividends, display a list of all symbols from the connected asset account
    // for DIVIDENDS, show a list of all account-symbol combinations from the connected stock accounts, sorted by symbol
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits"
    });
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [localLinkedAttribute, setLocalLinkedAttribute] = (0, $7fPBF.useState)(linkedAttribute); // intialise to the object from props (should there be an existing linkedAttribute already)
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    if (transactions.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    const { accountId: targetAccountId, assetId: targetAssetId } = localLinkedAttribute;
    async function handleSave() {
        if (transactions.length === 0) return;
        // for saving items which require additional attributes (e.g. fees or dividends)
        const updatedTransactions = transactions.map((transaction)=>(0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                label: selectedOption.id,
                importFlag: "put"
            }));
        // DIVIDEND: check if an asset is selected, add a tag with assetId and accountId
        if (selectedOption.id === "investment-dividend") {
            // if the account / asset is not marked, show message and return
            if (!targetAccountId || !targetAssetId) {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("symbolNotSelected"));
                return;
            }
            updatedTransactions.forEach((updatedTransaction)=>{
                // eslint-disable-next-line no-param-reassign
                updatedTransaction.tags = (0, $2qxEV._)((0, $9tqwB._)({}, typeof updatedTransaction.tags === "string" ? JSON.parse(updatedTransaction.tags) : updatedTransaction.tags), {
                    assetId: targetAssetId,
                    accountId: targetAccountId
                });
            });
        }
        setLoading(true);
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: updatedTransactions,
                category: "deposits",
                accountId: accountId
            }));
            setLoading(false);
            handleCloseAfterSave();
        } catch (err) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
    }
    function getAccountById(a) {
        return allAccounts.find((account)=>account.id === a);
    }
    const connectedStockAccountIds = allAccounts.filter((account)=>{
        var _account_connectedDepositAccounts;
        return (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.includes(accountId);
    }).map((account)=>account.id);
    // so this can be a list of transactions from more than 1 account
    const connectedAccountsTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $cfd21bc923628483$export$9890c99050a7d78e)(state)).filter((tx)=>connectedStockAccountIds === null || connectedStockAccountIds === void 0 ? void 0 : connectedStockAccountIds.includes(tx.accountId));
    const connectedAccountsWithSymbols = connectedAccountsTransactions === null || connectedAccountsTransactions === void 0 ? void 0 : connectedAccountsTransactions.reduce((prev, curr)=>{
        var _prev_curr_accountId;
        return (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
            [curr.accountId]: ((_prev_curr_accountId = prev[curr.accountId]) === null || _prev_curr_accountId === void 0 ? void 0 : _prev_curr_accountId.includes(curr.figi)) ? prev[curr.accountId] : [
                ...prev[curr.accountId] || [],
                curr.figi
            ]
        });
    }, {});
    const connectedAccountSymbolCombinations = (_Object_keys = Object.keys(connectedAccountsWithSymbols)) === null || _Object_keys === void 0 ? void 0 : (_Object_keys_flatMap = _Object_keys.flatMap((a)=>{
        var _connectedAccountsWithSymbols_a;
        return (_connectedAccountsWithSymbols_a = connectedAccountsWithSymbols[a]) === null || _connectedAccountsWithSymbols_a === void 0 ? void 0 : _connectedAccountsWithSymbols_a.map((figi)=>({
                accountId: a,
                figi: figi
            }));
    })) === null || _Object_keys_flatMap === void 0 ? void 0 : _Object_keys_flatMap.sort((a, b)=>{
        var _a_;
        return (_a_ = a[0]) === null || _a_ === void 0 ? void 0 : _a_.figi.localeCompare(b[0].figi);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col gap-2 overflow-y-auto",
                "data-testid": "blue-transactions-dividends",
                children: [
                    connectedAccountSymbolCombinations.map((x)=>{
                        var _getAccountById, _getAccountById1;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setLocalLinkedAttribute((0, $2qxEV._)((0, $9tqwB._)({}, localLinkedAttribute), {
                                    accountId: x.accountId,
                                    assetId: x.figi
                                })),
                            "data-testid": "sublist-asset",
                            className: `text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
            ${(x === null || x === void 0 ? void 0 : x.accountId) === (localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.accountId) && (x === null || x === void 0 ? void 0 : x.figi) === (localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.assetId) ? "bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent" : "bg-white text-gray-900 hover:bg-gray-50"}`,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: x.figi
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                    accountName: (_getAccountById = getAccountById(x.accountId)) === null || _getAccountById === void 0 ? void 0 : _getAccountById.name,
                                    category: (_getAccountById1 = getAccountById(x.accountId)) === null || _getAccountById1 === void 0 ? void 0 : _getAccountById1.category
                                })
                            ]
                        }, x.accountId + x.figi);
                    }),
                    connectedAccountSymbolCombinations.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-sm text-gray-500 self-center mt-2",
                        children: t("noAssets")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3cbc05a952d1319$export$2e2bcd8739ae039), {
                handleSave: handleSave,
                handleCancel: handleCancel,
                loading: loading
            })
        ]
    });
}
$70cf39590e51e56d$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    linkedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCloseAfterSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$70cf39590e51e56d$export$2e2bcd8739ae039.defaultProps = {
    linkedAttribute: {}
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $ef003269179b4323$export$2e2bcd8739ae039({ selectedOption: selectedOption, accountId: accountId, linkedAttribute: linkedAttribute, handleCloseAfterSave: handleCloseAfterSave, handleCancel: handleCancel, transactions: transactions }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits"
    });
    const transaction = transactions === null || transactions === void 0 ? void 0 : transactions[0];
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [localLinkedAttribute, setLocalLinkedAttribute] = (0, $7fPBF.useState)(linkedAttribute); // intialise to the object from props (should there be an existing linkedAttribute already)
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const allTransactionsData = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$6d68928c2b6ce1a6));
    function getAccountById(a) {
        return allAccounts.find((account)=>account.id === a);
    }
    async function handleSave() {
        if (!transaction) return;
        // for saving items which require additional attributes (e.g. fees or dividends)
        const updatedTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
            label: selectedOption.id,
            // courtesy adjustment of fees (must be a negative number)
            amount: selectedOption.id === "investment-fees" ? -Math.abs(transaction.amount) : Math.abs(transaction.amount),
            importFlag: "put"
        });
        // FEES: check if a transaction is selected, add a linkedTransaction of type 'fee-to-transaction'
        if (selectedOption.id === "investment-fees") {
            // if the transaction is not marked, do not save it
            if (!(localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.linkedTransaction)) {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("transactionNotSelected"));
                return;
            }
            updatedTransaction.linkedTransactions = updatedTransaction.linkedTransactions.filter((tx)=>tx.tags.linkType !== "fee-to-transaction").concat(localLinkedAttribute.linkedTransaction);
            // adding tags to the fees transaction as well; it will not be used in the BlueTransactionDialog
            // but it will be used in completeAssetView to easily identify the account of transaction to which the fees belong
            // this should be moved to tags of the linkedTransaction (both here and in completeAccountView)
            updatedTransaction.tags = (0, $2qxEV._)((0, $9tqwB._)({}, typeof updatedTransaction.tags === "string" ? JSON.parse(updatedTransaction.tags) : updatedTransaction.tags), {
                assetId: localLinkedAttribute.assetId,
                accountId: localLinkedAttribute.accountId
            });
            console.log("BlueTransactionsDialog > prep object for fees:", updatedTransaction);
        // SALE: check if a transaction is selected, add a linkedTransaction of type 'sale-to-transaction'
        } else if (selectedOption.id === "investment-sale" || selectedOption.id === "investment-loanPrincipal") {
            // if the transaction is not marked, do not save it
            if (!(localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.linkedTransaction)) {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("transactionNotSelected"));
                return;
            }
            updatedTransaction.linkedTransactions = updatedTransaction.linkedTransactions.filter((tx)=>tx.tags.linkType !== "sale-to-transaction").concat(localLinkedAttribute.linkedTransaction);
        }
        setLoading(true);
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: [
                    updatedTransaction
                ],
                category: "deposits",
                accountId: accountId
            }));
            setLoading(false);
            handleCloseAfterSave();
        } catch (err) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
    }
    const connectedAssetAccountIds = allAccounts.filter((account)=>{
        var _account_connectedDepositAccounts;
        return ((_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.includes(accountId)) && (selectedOption.id === "investment-loanPrincipal" ? account.category === "loans" : true);
    }).map((account)=>account.id);
    // console.log('BlueTransactionsFeesSale > connectedAssetAccountIds:', connectedAssetAccountIds);
    console.log("DEBUG", (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$6d68928c2b6ce1a6)).filter((tx)=>tx.category === "objectsOfValue"));
    // for FEES or SALE display a list of all transactions from those asset accounts, which are connected to current deposit account
    // so this can be a list of transactions from more than 1 account
    const connectedAccountsTransactions = transaction ? allTransactionsData.filter((atxn)=>(connectedAssetAccountIds === null || connectedAssetAccountIds === void 0 ? void 0 : connectedAssetAccountIds.includes(atxn.accountId)) && ![
            "split"
        ].includes(atxn.transactionType) && (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(atxn.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(transaction.date).subtract(3, "month")) && (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(atxn.date).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(transaction.date).add(3, "month"))).filter((atxn)=>selectedOption.id === "investment-sale" ? atxn.quantity < 0 : true) // loan sales can be both ways
    .sort((a, b)=>new Date(a.date) - new Date(b.date)) : [];
    function handleClick(txn) {
        setLocalLinkedAttribute((0, $2qxEV._)((0, $9tqwB._)({}, localLinkedAttribute), {
            linkedTransaction: {
                id: txn.id,
                category: txn.category,
                tags: {
                    linkType: selectedOption.id === "investment-sale" || selectedOption.id === "investment-loanPrincipal" ? "sale-to-transaction" : "fee-to-transaction"
                }
            },
            accountId: txn.accountId,
            assetId: txn.figi || txn.accountId
        }));
    }
    if (!transaction) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                "data-testid": "blue-transactions-fees-sale",
                className: "flex flex-col gap-2 overflow-y-auto",
                children: [
                    connectedAccountsTransactions.map((txn)=>{
                        var _localLinkedAttribute_linkedTransaction, _getAccountById, _getAccountById1;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>handleClick(txn),
                            "data-testid": "sublist-transaction",
                            className: `text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
                        ${(txn === null || txn === void 0 ? void 0 : txn.id) === (localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : (_localLinkedAttribute_linkedTransaction = localLinkedAttribute.linkedTransaction) === null || _localLinkedAttribute_linkedTransaction === void 0 ? void 0 : _localLinkedAttribute_linkedTransaction.id) ? "bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent" : "bg-white text-gray-900 hover:bg-gray-50"}`,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: new Date(txn.date).toLocaleDateString("de", {
                                        year: "2-digit",
                                        month: "2-digit",
                                        day: "2-digit",
                                        timeZone: "UTC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: txn.displayName || txn.assetName || getAccountById(txn.accountId).name
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: (txn.quantity * txn.upbc).toLocaleString("de", {
                                        style: "currency",
                                        currency: baseCurrency,
                                        maximumFractionDigits: 0,
                                        minimumFractionDigits: 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                    accountName: (_getAccountById = getAccountById(txn.accountId)) === null || _getAccountById === void 0 ? void 0 : _getAccountById.name,
                                    category: (_getAccountById1 = getAccountById(txn.accountId)) === null || _getAccountById1 === void 0 ? void 0 : _getAccountById1.category
                                })
                            ]
                        }, txn.id);
                    }),
                    connectedAccountsTransactions.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-sm text-gray-500 self-center mt-2",
                        children: t("noTransactions")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3cbc05a952d1319$export$2e2bcd8739ae039), {
                handleSave: handleSave,
                handleCancel: handleCancel,
                loading: loading
            })
        ]
    });
}
$ef003269179b4323$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    linkedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCloseAfterSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$ef003269179b4323$export$2e2bcd8739ae039.defaultProps = {
    linkedAttribute: {}
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






function $2248c9113d8865a2$export$2e2bcd8739ae039({ selectedOption: selectedOption, accountId: accountId, linkedAttribute: linkedAttribute, handleCloseAfterSale: handleCloseAfterSale, handleCancel: handleCancel, transactions: transactions }) {
    // for INTEREST or RENT, show a list of all accounts which are connected to current deposit account
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits"
    });
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [localLinkedAttribute, setLocalLinkedAttribute] = (0, $7fPBF.useState)(linkedAttribute);
    // ↑ intialise to the object from props (should there be an existing linkedAttribute already) { linkedTransaction, accountId, assetId }
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    let accountsFilteredByConnectedAccounts = [];
    // for interest show all deposit accounts
    if (selectedOption.id === "investment-interest" || selectedOption.id === "investment-loanInterest") accountsFilteredByConnectedAccounts = allAccounts.filter((a)=>a.category === "deposits");
    // for rent show connected real estate accounts only
    if (selectedOption.id === "investment-rent") accountsFilteredByConnectedAccounts = allAccounts.filter((a)=>{
        var _a_connectedDepositAccounts;
        return ((_a_connectedDepositAccounts = a.connectedDepositAccounts) === null || _a_connectedDepositAccounts === void 0 ? void 0 : _a_connectedDepositAccounts.includes(accountId)) && a.category === "realEstate";
    });
    // for rent show connected real estate accounts only
    if (selectedOption.id === "investment-pension") accountsFilteredByConnectedAccounts = allAccounts.filter((a)=>{
        var _a_connectedDepositAccounts;
        return ((_a_connectedDepositAccounts = a.connectedDepositAccounts) === null || _a_connectedDepositAccounts === void 0 ? void 0 : _a_connectedDepositAccounts.includes(accountId)) && a.category === "pension";
    });
    async function handleSave() {
        if (transactions.length === 0) return;
        if (!(localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.accountId)) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("symbolNotSelected"));
            return;
        }
        const updatedTransactions = transactions.map((transaction)=>{
            const tags = typeof transaction.tags === "string" ? JSON.parse(transaction.tags) : transaction.tags;
            return (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                label: selectedOption.id,
                importFlag: "put",
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, tags), {
                    assetId: localLinkedAttribute.assetId,
                    accountId: localLinkedAttribute.accountId
                })
            });
        });
        setLoading(true);
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: updatedTransactions,
                category: "deposits",
                accountId: accountId
            }));
        } catch (err) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            return;
        }
        setLoading(false);
        handleCloseAfterSale();
    }
    const accountsOptionSpecific = (accountsFilteredByConnectedAccounts || []).filter((x)=>{
        switch(selectedOption.id){
            case "investment-interest":
                return x.category === "deposits";
            case "investment-rent":
                return x.category === "realEstate";
            case "investment-loanInterest":
                return x.category === "loans";
            case "investment-pension":
                return x.category === "pension";
            default:
                return false;
        }
    });
    if (transactions.length === 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col gap-2 overflow-y-auto",
                "data-testid": "blue-transactions-interest-rent",
                children: [
                    accountsOptionSpecific.map((x)=>// ^^ returns an array of account objects
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setLocalLinkedAttribute((0, $2qxEV._)((0, $9tqwB._)({}, localLinkedAttribute), {
                                    accountId: x.id,
                                    assetId: x.id
                                })),
                            "data-testid": "sublist-account",
                            className: `text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
          ${(x === null || x === void 0 ? void 0 : x.id) === (localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.accountId) ? "bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent" : "bg-white text-gray-900 hover:bg-gray-50"}`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                accountName: x === null || x === void 0 ? void 0 : x.name,
                                category: x === null || x === void 0 ? void 0 : x.category
                            })
                        }, x.id)),
                    accountsOptionSpecific.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-sm text-gray-500 self-center mt-2",
                        children: t("noAccounts")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "space-y-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3cbc05a952d1319$export$2e2bcd8739ae039), {
                    handleSave: handleSave,
                    handleCancel: handleCancel,
                    loading: loading
                })
            })
        ]
    });
}
$2248c9113d8865a2$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    linkedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCloseAfterSale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$2248c9113d8865a2$export$2e2bcd8739ae039.defaultProps = {
    linkedAttribute: {}
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

function $071105eca597c3d9$export$2e2bcd8739ae039({ small: small }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $344a70c9f2a7e27e$export$2e2bcd8739ae039), {
        className: `text-gray-400 ${small ? "h-4 w-4" : "h-5 w-5"}`
    });
}
$071105eca597c3d9$export$2e2bcd8739ae039.propTypes = {
    small: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$071105eca597c3d9$export$2e2bcd8739ae039.defaultProps = {
    small: false
};







function $20530c7812deb7c1$export$2e2bcd8739ae039({ accountId: accountId, transactions: transactions, handleCloseAfterSave: handleCloseAfterSave, handleCancel: handleCancel, loanAccountsForRepaymentTagging: loanAccountsForRepaymentTagging }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "splitMenu"
    });
    const { t: tLabel } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits.labels"
    });
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [isLoadingPrefill, setIsLoadingPrefill] = (0, $7fPBF.useState)(true);
    const [currentInstallment, setCurrentInstallment] = (0, $7fPBF.useState)(null);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const transaction = (transactions === null || transactions === void 0 ? void 0 : transactions[0]) || null;
    const selectAssetBalances = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$7cd09fd23199c464));
    const currentTags = (0, $7fPBF.useMemo)(()=>(0, $360a068b01784d25$export$ede4b2e0172bbdb1)(transaction === null || transaction === void 0 ? void 0 : transaction.tags), [
        transaction
    ]);
    const currentLoanAccountId = (currentTags === null || currentTags === void 0 ? void 0 : currentTags.accountId) || null;
    const availableLoanAccounts = loanAccountsForRepaymentTagging || [];
    const amountToSplitAbsolute = (0, $7fPBF.useMemo)(()=>(0, $360a068b01784d25$export$ab4907c4696bb6c)({
            currentTransaction: transaction,
            currentTags: currentTags
        }), [
        transaction,
        currentTags
    ]);
    const initialSplit = (0, $7fPBF.useMemo)(()=>(0, $360a068b01784d25$export$aaf5eae828a965b5)({
            currentTags: currentTags,
            amountToSplitAbsolute: amountToSplitAbsolute
        }), [
        currentTags,
        amountToSplitAbsolute
    ]);
    const [principal, setPrincipal] = (0, $7fPBF.useState)(initialSplit.principal);
    const [interest, setInterest] = (0, $7fPBF.useState)(initialSplit.interest);
    const [selectedLoanAccountId, setSelectedLoanAccountId] = (0, $7fPBF.useState)(()=>{
        var _availableLoanAccounts_;
        if (currentLoanAccountId && availableLoanAccounts.some((item)=>item.id === currentLoanAccountId)) return currentLoanAccountId;
        return ((_availableLoanAccounts_ = availableLoanAccounts[0]) === null || _availableLoanAccounts_ === void 0 ? void 0 : _availableLoanAccounts_.id) || null;
    });
    (0, $7fPBF.useEffect)(()=>{
        if (currentLoanAccountId && availableLoanAccounts.some((item)=>item.id === currentLoanAccountId)) {
            setSelectedLoanAccountId(currentLoanAccountId);
            return;
        }
        if (!selectedLoanAccountId && availableLoanAccounts.length > 0) setSelectedLoanAccountId(availableLoanAccounts[0].id);
    }, [
        currentLoanAccountId,
        availableLoanAccounts,
        selectedLoanAccountId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setPrincipal(initialSplit.principal);
        setInterest(initialSplit.interest);
    }, [
        initialSplit
    ]);
    (0, $7fPBF.useEffect)(()=>{
        let isMounted = true;
        async function runPrefill() {
            if ((currentTags === null || currentTags === void 0 ? void 0 : currentTags.loanRepayment) || !transaction) {
                if (isMounted) setIsLoadingPrefill(false);
                return;
            }
            try {
                const split = await (0, $360a068b01784d25$export$45af83a7cafc4fac)(transaction.description || "");
                if (split && isMounted) {
                    setPrincipal(split.principal);
                    setInterest(split.interest);
                }
            } catch (prefillError) {
                console.error("BlueTransactionsLoanRepayment: prefill failed", prefillError);
            } finally{
                if (isMounted) setIsLoadingPrefill(false);
            }
        }
        runPrefill();
        return ()=>{
            isMounted = false;
        };
    }, [
        currentTags === null || currentTags === void 0 ? void 0 : currentTags.loanRepayment,
        transaction
    ]);
    const selectedLoanAccount = availableLoanAccounts.find((item)=>item.id === selectedLoanAccountId) || null;
    const remainingAmount = amountToSplitAbsolute - (principal + interest);
    const amountTolerance = 0.00999;
    async function handleSave() {
        if (!transaction || !selectedLoanAccount) {
            setError(t("selectLoanAccount"));
            return;
        }
        if (Math.abs(remainingAmount) > amountTolerance) {
            setError(remainingAmount > 0 ? `${t("amountToAllocate")} ${remainingAmount.toFixed(2)}` : `${t("allocatedTooMuch")} ${Math.abs(remainingAmount).toFixed(2)}`);
            return;
        }
        setError(null);
        setLoading(true);
        try {
            const tags = (0, $360a068b01784d25$export$ede4b2e0172bbdb1)(transaction.tags);
            delete tags.assetId;
            const totalRepayment = principal + interest;
            const totalSignedAmount = (0, $360a068b01784d25$export$3a43b23fd491c014)(transaction) * totalRepayment;
            const updatedTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                label: "investment-loanRepayment",
                accountCurrencyAmount: totalSignedAmount,
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, tags), {
                    accountId: selectedLoanAccount.id,
                    loanRepayment: {
                        principal: principal,
                        interest: interest
                    }
                }),
                linkedTransactions: (transaction.linkedTransactions || []).filter((linkedTransaction)=>{
                    var _linkedTransaction_tags;
                    return ![
                        "fee-to-transaction",
                        "sale-to-transaction",
                        "transfer"
                    ].includes((_linkedTransaction_tags = linkedTransaction.tags) === null || _linkedTransaction_tags === void 0 ? void 0 : _linkedTransaction_tags.linkType);
                }),
                importFlag: "put",
                parentId: null
            });
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: [
                    updatedTransaction
                ],
                category: "deposits",
                accountId: accountId
            }));
            setLoading(false);
            handleCloseAfterSave();
        } catch (saveError) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
    }
    function handleApplyCalculatedInstallment() {
        if (!selectedLoanAccount) return;
        const loanAccountBalanceObject = selectAssetBalances.find((item)=>item.accountId === selectedLoanAccount.id) || {
            current: {
                quantity: 0
            }
        };
        const calculatedInstallment = (0, $360a068b01784d25$export$28fc9f77bf170f5c)({
            selectedLoanAccount: selectedLoanAccount,
            currentLoanBalance: loanAccountBalanceObject.current.quantity
        });
        if (!calculatedInstallment) return;
        setCurrentInstallment(calculatedInstallment);
        setPrincipal(calculatedInstallment.principal);
        setInterest(calculatedInstallment.interest);
    }
    if (!transaction) return null;
    if (isLoadingPrefill) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "flex w-full h-full items-center justify-center",
        "data-testid": "blue-transactions-loan-repayment-loading",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10c3ddecbaea2060$export$42d15847cf9e98e1), {
            width: "40",
            height: "40",
            viewBox: "0 0 600 600"
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col gap-2 overflow-y-auto",
                "data-testid": "blue-transactions-loan-repayment",
                children: [
                    availableLoanAccounts.map((loanAccount)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                setSelectedLoanAccountId(loanAccount.id);
                                setCurrentInstallment(null);
                            },
                            "data-testid": "sublist-account",
                            className: `text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
              ${loanAccount.id === selectedLoanAccountId ? "bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent" : "bg-white text-gray-900 hover:bg-gray-50"}`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                accountName: loanAccount === null || loanAccount === void 0 ? void 0 : loanAccount.name,
                                category: loanAccount === null || loanAccount === void 0 ? void 0 : loanAccount.category
                            })
                        }, loanAccount.id)),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "mt-2 text-base font-medium text-gray-500",
                        children: t("separateInterestFromPrincipal")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("splitAndLabelLoanInfo2"),
                        classNamesOwn: "flex gap-2 mt-2",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex gap-2 items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-sm text-gray-500",
                                    children: t("splitAndLabelLoanInfo")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $071105eca597c3d9$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "rounded-md border border-gray-200 bg-gray-50 p-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-xs font-medium text-gray-500",
                                children: t("transactionDescriptionLabel")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-1 text-sm text-gray-700 break-words",
                                children: transaction.description || t("transactionDescriptionEmpty")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        className: "mt-2 divide divide-gray-100",
                        children: [
                            {
                                label: "investment-loanPrincipal",
                                value: principal,
                                onChange: setPrincipal
                            },
                            {
                                label: "investment-loanInterest",
                                value: interest,
                                onChange: setInterest
                            }
                        ].map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                className: "grid grid-cols-12 items-center p-2 gap-4 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "col-span-4 inline-flex rounded-lg bg-brandBlue-100 hover:bg-brandBlue-200 px-2.5 py-0.5 text-xs font-medium text-brandBlue-700",
                                        children: tLabel(`${item.label}.short`)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        className: "self-start px-1.5 py-2 text-gray-700 text-right border-b rounded-md border-gray-300 focus:outline-none focus:border-brandBlue-400 col-span-8",
                                        value: item.value,
                                        onChange: (e)=>item.onChange(Number.isNaN(Number(e.target.value)) ? 0 : Math.abs(Number(e.target.value)))
                                    })
                                ]
                            }, item.label))
                    }),
                    remainingAmount > amountTolerance && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-red-500",
                        children: `${t("amountToAllocate")} ${remainingAmount.toFixed(2)}`
                    }),
                    remainingAmount < -amountTolerance && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-red-500",
                        children: `${t("allocatedTooMuch")} ${Math.abs(remainingAmount).toFixed(2)}`
                    }),
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-sm text-red-500",
                        children: error
                    }),
                    currentInstallment ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "text-sm text-gray-500 cursor-pointer underline mt-1",
                        type: "button",
                        onClick: handleApplyCalculatedInstallment,
                        children: `${tLabel("investment-loanPrincipal.short")}: ${currentInstallment.principal.toFixed(2)} | ${tLabel("investment-loanInterest.short")}: ${currentInstallment.interest.toFixed(2)}`
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("calculateExpectedSplitInfo"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            onClick: handleApplyCalculatedInstallment,
                            formatting: "text-brandBlue-500",
                            text: t("calculateExpectedSplit"),
                            size: "sm",
                            noFrame: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3cbc05a952d1319$export$2e2bcd8739ae039), {
                handleSave: handleSave,
                handleCancel: handleCancel,
                loading: loading
            })
        ]
    });
}
$20530c7812deb7c1$export$2e2bcd8739ae039.propTypes = {
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleCloseAfterSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    loanAccountsForRepaymentTagging: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$20530c7812deb7c1$export$2e2bcd8739ae039.defaultProps = {
    loanAccountsForRepaymentTagging: []
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $fcf6df6ba5258999$export$2e2bcd8739ae039({ selectedOption: selectedOption, accountId: accountId, linkedAttribute: linkedAttribute, handleCloseAfterSale: handleCloseAfterSale, handleCancel: handleCancel, transactions: transactions }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits"
    });
    const transaction = transactions === null || transactions === void 0 ? void 0 : transactions[0];
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [localLinkedAttribute, setLocalLinkedAttribute] = (0, $7fPBF.useState)(linkedAttribute); // intialise to the object from props (should there be an existing linkedAttribute already)
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const allTransactionsData = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$6d68928c2b6ce1a6));
    function getAccountById(a) {
        return allAccounts.find((account)=>account.id === a);
    }
    // PREPARE DATA TO BE DISPLAYED
    // prepare list of accounts to look for matching transfer transactions in (connected asset accounts + other deposit accounts)
    const connectedAndDepositAccountIds = allAccounts.filter((account)=>{
        var _account_connectedDepositAccounts;
        return (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.includes(accountId);
    }) // get asset accounts which use this deposit account as connectedDepositAccount
    .concat(allAccounts.filter((account)=>account.category === "deposits")) // add all deposit accounts
    .filter((a)=>a.id !== accountId) // filter out the currently open account
    .map((account)=>account.id);
    // display a list of all transactions from those connected asset accounts
    // so this can be a list of transactions from more than 1 account
    if (transaction) console.log("DEBUG", connectedAndDepositAccountIds, transaction, transaction.quantity, allTransactionsData.filter((txn)=>(connectedAndDepositAccountIds === null || connectedAndDepositAccountIds === void 0 ? void 0 : connectedAndDepositAccountIds.includes(txn.accountId)) && txn.quantity && Math.abs(txn.quantity + (txn.quantityInterest || 0)) > Math.abs(transaction.quantity) * 0.9));
    //
    //  && dayjs.utc(txn.date).isAfter(dayjs.utc(transaction.date).subtract(7, 'day'))
    //  && dayjs.utc(txn.date).isBefore(dayjs.utc(transaction.date).day(7, 'day')));
    const connectedAndDepositAccountsTransactions = transaction ? allTransactionsData.filter((txn)=>(connectedAndDepositAccountIds === null || connectedAndDepositAccountIds === void 0 ? void 0 : connectedAndDepositAccountIds.includes(txn.accountId)) && txn.quantity // to eliminate splits
         && Math.abs(txn.quantity) > Math.abs(transaction.quantity) * 0.9 // only show transactions with a quantity of at least 90% of this one and the opposite sign
         && Math.abs(txn.quantity) < Math.abs(transaction.quantity) * 1.1 // only show transactions with a quantity of at most 110% of this one and the opposite sign
         && (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(txn.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(transaction.date).subtract(7, "day")) // only show transactions on connected account within +/- 7 days of this one (for clarity)
         && (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(txn.date).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(transaction.date).day(7, "day"))) : [];
    // update localLinkedAttribute with the new linkedTransaction which user selected
    function handleClick(txn) {
        setLocalLinkedAttribute((0, $2qxEV._)((0, $9tqwB._)({}, localLinkedAttribute), {
            linkedTransaction: {
                id: txn.id,
                category: txn.category,
                tags: {
                    linkType: "transfer"
                }
            }
        }));
    }
    // SAVE DATA
    async function handleSave() {
        if (!transaction) return;
        // update tranaction label to 'transfer'
        const updatedTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
            label: selectedOption.id,
            importFlag: "put"
        });
        // if the transaction is not marked, do not save it
        if (!(localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : localLinkedAttribute.linkedTransaction)) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("transactionNotSelected"));
            return;
        }
        // add the selected transaction as linkedTransaction (remove any previously added linkedTransactions of type 'transfer')
        updatedTransaction.linkedTransactions = updatedTransaction.linkedTransactions.filter((tx)=>tx.tags.linkType !== "transfer").concat(localLinkedAttribute.linkedTransaction);
        setLoading(true);
        try {
            // update "this" deposit transaction
            const promisePostThisTransaction = dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: [
                    updatedTransaction
                ],
                category: "deposits",
                accountId: accountId
            }));
            // update the "other" transaction that the user has selected
            const otherTransaction = connectedAndDepositAccountsTransactions.find((txn)=>txn.id === localLinkedAttribute.linkedTransaction.id);
            const promisePostOtherTransaction = dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: [
                    (0, $2qxEV._)((0, $9tqwB._)({}, otherTransaction), {
                        label: "investment-transfer",
                        linkedTransactions: otherTransaction.linkedTransactions.filter((tx)=>tx.tags.linkType !== "transfer").concat({
                            id: transaction.id,
                            category: transaction.category,
                            tags: {
                                linkType: "transfer"
                            }
                        })
                    })
                ],
                category: otherTransaction.category,
                accountId: otherTransaction.accountId
            }));
            await Promise.all([
                promisePostThisTransaction,
                promisePostOtherTransaction
            ]);
            setLoading(false);
            handleCloseAfterSale();
        } catch (err) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
    }
    if (!transaction) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                "data-testid": "blue-transactions-transfer",
                className: "flex flex-col gap-2 overflow-y-auto",
                children: [
                    connectedAndDepositAccountsTransactions.filter((txn)=>transaction.quantity >= 0 ? txn.quantity < 0 : txn.quantity >= 0) // reversed sign transactions only
                    .sort((a, b)=>new Date(a.date) - new Date(b.date)).map((txn)=>{
                        var _localLinkedAttribute_linkedTransaction, _getAccountById, _getAccountById1;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>handleClick(txn),
                            "data-testid": "sublist-transaction",
                            className: `text-xs border border-gray-200 shadow-sm rounded-md p-2 flex justify-between gap-2 cursor-pointer
                        ${(txn === null || txn === void 0 ? void 0 : txn.id) === (localLinkedAttribute === null || localLinkedAttribute === void 0 ? void 0 : (_localLinkedAttribute_linkedTransaction = localLinkedAttribute.linkedTransaction) === null || _localLinkedAttribute_linkedTransaction === void 0 ? void 0 : _localLinkedAttribute_linkedTransaction.id) ? "bg-brandBlue-500 text-white hover:bg-brandBlue-600 border-transparent" : "bg-white text-gray-900 hover:bg-gray-50"}`,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: new Date(txn.date).toLocaleDateString("de", {
                                        year: "2-digit",
                                        month: "2-digit",
                                        day: "2-digit",
                                        timeZone: "UTC"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: txn.displayName
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: (txn.quantity * txn.upbc).toLocaleString("de", {
                                        style: "currency",
                                        currency: baseCurrency,
                                        maximumFractionDigits: 0,
                                        minimumFractionDigits: 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                    accountName: (_getAccountById = getAccountById(txn.accountId)) === null || _getAccountById === void 0 ? void 0 : _getAccountById.name,
                                    category: (_getAccountById1 = getAccountById(txn.accountId)) === null || _getAccountById1 === void 0 ? void 0 : _getAccountById1.category
                                })
                            ]
                        }, txn.id);
                    }),
                    connectedAndDepositAccountsTransactions.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-sm text-gray-500 self-center mt-2",
                        children: t("noTransactionsWithin")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e3cbc05a952d1319$export$2e2bcd8739ae039), {
                handleSave: handleSave,
                handleCancel: handleCancel,
                loading: loading
            })
        ]
    });
}
$fcf6df6ba5258999$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    linkedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    handleCloseAfterSale: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};
$fcf6df6ba5258999$export$2e2bcd8739ae039.defaultProps = {
    linkedAttribute: {}
};


function $65c7bc62245b03ec$export$2e2bcd8739ae039({ selectedOption: selectedOption, accountId: accountId, linkedAttribute: linkedAttribute, handleCancel: handleCancel, handleCloseAfterSave: handleCloseAfterSave, transactions: transactions, loanAccountsForRepaymentTagging: loanAccountsForRepaymentTagging }) {
    $65c7bc62245b03ec$export$2e2bcd8739ae039.propTypes = {
        // eslint-disable-next-line react/forbid-prop-types
        selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
        accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        linkedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        handleCloseAfterSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
        loanAccountsForRepaymentTagging: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object)
    };
    $65c7bc62245b03ec$export$2e2bcd8739ae039.defaultProps = {
        linkedAttribute: {},
        loanAccountsForRepaymentTagging: []
    };
    // selectedOption is the option selected in the main list of the blue transaction dialog
    // accountId of the account that is currently open in AccountDetails
    // linkedAttribute holds the state of the blue transaction attributes that we are about to set
    const standardProps = {
        selectedOption: selectedOption,
        accountId: accountId,
        linkedAttribute: linkedAttribute,
        handleCancel: handleCancel,
        handleCloseAfterSave: handleCloseAfterSave,
        // Backward compatibility: some sublist components still expect this prop name.
        handleCloseAfterSale: handleCloseAfterSave,
        transactions: transactions,
        loanAccountsForRepaymentTagging: loanAccountsForRepaymentTagging
    };
    switch(selectedOption.id){
        case "investment-fees":
        case "investment-sale":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef003269179b4323$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps));
        case "investment-dividend":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $70cf39590e51e56d$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps));
        case "investment-interest":
        case "investment-rent":
        case "investment-pension":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2248c9113d8865a2$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps));
        case "investment-costs":
        case "investment-contribution":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3497453586277ad5$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps));
        case "investment-transfer":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fcf6df6ba5258999$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps));
        case "investment-loanRepayment":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $20530c7812deb7c1$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps));
        default:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    }
}


function $b540ea94c6cd5b1d$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $b540ea94c6cd5b1d$var$isMobileLayout(breakpoint) {
    return breakpoint === "xs" || breakpoint === "sm" || !breakpoint;
}
function $b540ea94c6cd5b1d$var$parseIf(str) {
    return typeof str === "string" ? JSON.parse(str) : str;
}
function $b540ea94c6cd5b1d$export$2e2bcd8739ae039({ transactionIds: transactionIds, category: category }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "deposits"
    });
    const { t: tB } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "general"
    });
    // Table view does not have all fields (e.g. linkedTransactions is missing), therefore get the transaction from state
    const selectTransactions = category === "deposits" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$3c400324181e2c4d)) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $9a12762f4ca7889e$export$e59b728dc06f12a7));
    const transactions = selectTransactions.filter((txn)=>transactionIds.includes(txn.id));
    const firstTransaction = transactions[0] || null;
    const accountId = (firstTransaction === null || firstTransaction === void 0 ? void 0 : firstTransaction.accountId) || null;
    const selectAllTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$6d68928c2b6ce1a6));
    const selectAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const firstTransactionTags = $b540ea94c6cd5b1d$var$parseIf(firstTransaction === null || firstTransaction === void 0 ? void 0 : firstTransaction.tags) || {};
    // show me those accounts which have connectedDepositAccounts whose id is the same as the current account
    const accountsConnectedToThisOne = selectAccounts.filter((acc)=>acc.connectedDepositAccounts && accountId && acc.connectedDepositAccounts.includes(accountId));
    const loanAccountsConnectedToThisOne = accountsConnectedToThisOne.filter((acc)=>acc.category === "loans");
    const repaymentLoanAccount = firstTransactionTags.accountId ? selectAccounts.find((acc)=>acc.id === firstTransactionTags.accountId && acc.category === "loans") : null;
    const loanAccountsForRepaymentTagging = repaymentLoanAccount && !loanAccountsConnectedToThisOne.some((acc)=>acc.id === repaymentLoanAccount.id) ? loanAccountsConnectedToThisOne.concat(repaymentLoanAccount) : loanAccountsConnectedToThisOne;
    const options = (0, $7fPBF.useMemo)(()=>(0, $0640c93d741bcc75$export$2e2bcd8739ae039)({
            category: category,
            t: t,
            accountsConnectedToThisOne: accountsConnectedToThisOne,
            transactions: transactions,
            loanAccountsForRepaymentTagging: loanAccountsForRepaymentTagging
        }), [
        accountsConnectedToThisOne,
        category,
        t,
        transactions,
        loanAccountsForRepaymentTagging
    ]);
    const labelsAreTheSame = (0, $7fPBF.useMemo)(()=>Boolean(firstTransaction) && transactions.every((tx)=>tx.label === firstTransaction.label), [
        firstTransaction,
        transactions
    ]);
    const nullOption = (0, $7fPBF.useMemo)(()=>options.find((option)=>option.id === null) || null, [
        options
    ]);
    const [selectedOption, setSelectedOption] = (0, $7fPBF.useState)(nullOption);
    // const [selectedOption, setSelectedOption] = useState(() => {
    //   if (!labelsAreAligned) return nullOption;
    //   return options.find((option) => option.id === firstTransaction?.label) || null;
    // });
    (0, $7fPBF.useEffect)(()=>{
        // Keep the current selection once the user has made one.
        // Only auto-hydrate when current selection is missing or no longer available.
        const selectedStillAvailable = options.some((option)=>option.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id));
        if (selectedStillAvailable) return;
        if (!labelsAreTheSame) {
            setSelectedOption(nullOption || null);
            return;
        }
        const matchedOption = options.find((option)=>option.id === (firstTransaction === null || firstTransaction === void 0 ? void 0 : firstTransaction.label)) || nullOption || null;
        setSelectedOption(matchedOption);
    }, [
        labelsAreTheSame,
        options,
        firstTransaction === null || firstTransaction === void 0 ? void 0 : firstTransaction.label,
        selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id,
        nullOption
    ]);
    // TODO this is always taken from the first transaction
    const linkedAttribute = (0, $7fPBF.useMemo)(()=>{
        var _firstTransaction_linkedTransactions;
        const tags = $b540ea94c6cd5b1d$var$parseIf(firstTransaction === null || firstTransaction === void 0 ? void 0 : firstTransaction.tags) || {};
        return {
            linkedTransaction: (firstTransaction === null || firstTransaction === void 0 ? void 0 : (_firstTransaction_linkedTransactions = firstTransaction.linkedTransactions) === null || _firstTransaction_linkedTransactions === void 0 ? void 0 : _firstTransaction_linkedTransactions.find((lt)=>lt.tags.linkType === "fee-to-transaction" || lt.tags.linkType === "sale-to-transaction" || lt.tags.linkType === "transfer")) || null,
            accountId: tags.accountId || null,
            assetId: tags.assetId || null
        };
    }, [
        firstTransaction
    ]);
    const [currentBreakpoint, setCurrentBreakpoint] = (0, $7fPBF.useState)("md"); // stores current breakpoint
    const [panesToShow, setPanesToShow] = (0, $7fPBF.useState)([
        true,
        true
    ]); // [menu, submenu]
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    function handleCancel(closeDialog = false) {
        if (!closeDialog) setPanesToShow([
            true,
            false
        ]);
        else window.dispatchEvent(new CustomEvent("setDialog", {}));
    }
    // INITIALISE COMPONENT
    (0, $7fPBF.useEffect)(()=>{
        // Handle window resize and update breakpoint state
        const handleResize = ()=>{
            const newBreakpoint = (0, $29b77351b10ec0da$export$2e2bcd8739ae039)();
            setCurrentBreakpoint(newBreakpoint);
            return newBreakpoint;
        };
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Set initial breakpoint
        const newBreakpoint = handleResize();
        // set panes depending on breakpoint
        if ($b540ea94c6cd5b1d$var$isMobileLayout(newBreakpoint)) setPanesToShow([
            true,
            false
        ]); // else use default
        if (!$b540ea94c6cd5b1d$var$isMobileLayout(newBreakpoint) && selectedOption && !selectedOption.nextLevel) setPanesToShow([
            true,
            false
        ]);
        // Remove event listener on cleanup
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    // HANDLE MENU OPTION CHANGE
    function handleMenuOptionChange(option) {
        setSelectedOption(option);
        // set panes depending on whether the selected option has a next level or not (and whether we are on mobile)
        if (option && option.nextLevel) {
            if ($b540ea94c6cd5b1d$var$isMobileLayout(currentBreakpoint)) setPanesToShow([
                false,
                true
            ]);
            else setPanesToShow([
                true,
                true
            ]);
        } else if (option && !option.nextLevel) setPanesToShow([
            true,
            false
        ]);
    }
    // SAVE DATA WITH LABEL ONLY
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    async function handleSaveLabelOnly() {
        // for saving items which do not require any additional attributes (i.e. options where nextLevel = false)
        // all other ones are handled in the List component above (ca. row 220)
        if (!selectedOption || selectedOption.nextLevel) return;
        if (!selectedOption.nextLevel) try {
            // if nothing has changed, do not save transactions but simply close dialog
            // this is the path for no next level options only, so it is enough to check if the label is the same before and after in all transactions
            if (transactions.every((tx)=>tx.label === selectedOption.id)) {
                handleCancel(true);
                return;
            }
            setLoading(true);
            const promises = [
                dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                    data: transactions.map((transaction)=>(0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                            label: selectedOption.id,
                            tags: (0, $2qxEV._)((0, $9tqwB._)({}, $b540ea94c6cd5b1d$var$parseIf(transaction.tags)), {
                                type: null,
                                accountId: null,
                                assetId: null
                            }),
                            linkedTransactions: transaction.linkedTransactions.filter((lt)=>lt.tags.linkType !== "fee-to-transaction" && lt.tags.linkType !== "sale-to-transaction" && lt.tags.linkType !== "transfer"),
                            importFlag: "put"
                        })),
                    category: category,
                    accountId: accountId
                }))
            ];
            // if previously any of these transactions was a transfer, we need to remove the linked transaction and label from the other side as well
            transactions.forEach((transaction)=>{
                const linkedTransferTransactionObject = transaction.linkedTransactions.find((lt)=>lt.tags.linkType === "transfer"); // { id, category, tags }
                // if transaction found (handle fails graciously)
                if (linkedTransferTransactionObject) {
                    const otherTransaction = selectAllTransactions.find((tx)=>tx.id === (linkedTransferTransactionObject === null || linkedTransferTransactionObject === void 0 ? void 0 : linkedTransferTransactionObject.id));
                    promises.push(dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                        data: [
                            (0, $2qxEV._)((0, $9tqwB._)({}, otherTransaction), {
                                label: null,
                                linkedTransactions: otherTransaction.linkedTransactions.filter((lt)=>lt.tags.linkType !== "transfer"),
                                importFlag: "put"
                            })
                        ],
                        category: otherTransaction.category,
                        accountId: otherTransaction.accountId
                    })));
                }
            });
            await Promise.all(promises);
            setLoading(false);
            handleCancel(true);
        } catch (e) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto max-w-3xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e), {
            value: selectedOption,
            onChange: handleMenuOptionChange,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Options, {
                as: "div",
                static: true,
                hold: true,
                className: "flex divide-x divide-gray-100",
                children: [
                    panesToShow[0] && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        id: "blue-transactions-menu",
                        className: $b540ea94c6cd5b1d$var$classNames("max-h-[32rem] min-w-0 flex-auto scroll-py-4 overflow-y-auto px-6 py-4"),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "mt-2 mb-4 text-base font-medium text-gray-500",
                                children: t("markThisTransaction")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "-mx-2 text-sm text-gray-700",
                                children: options.filter((option)=>{
                                    if (!firstTransaction) return true;
                                    return firstTransaction.quantity < 0 ? option.requiresNegativeAmount : option.requiresPositiveAmount;
                                }).map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                                        as: "div",
                                        value: item,
                                        "data-testid": item.id,
                                        className: ({ active: active })=>$b540ea94c6cd5b1d$var$classNames("flex cursor-default select-none items-center rounded-md p-2", item.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) ? "bg-brandBlue-500 hover:bg-brandBlue-600 text-white" : "bg-white hover:bg-gray-100 text-gray-900"),
                                        children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.Icon, {
                                                        className: "h-6 w-6 flex-none rounded-full"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        className: "ml-3 flex-auto truncate",
                                                        children: item.name
                                                    }),
                                                    active && item.nextLevel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28c6eaf86f1a6031$export$2e2bcd8739ae039), {
                                                                className: "hidden sm:inline ml-3 h-5 w-5 flex-none text-gray-400",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $718d5639811dbbc7$export$2e2bcd8739ae039), {
                                                                className: "sm:hidden ml-3 h-5 w-5 flex-none text-gray-400",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                    }, item.id))
                            }),
                            !!selectedOption && !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.nextLevel) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                id: "blue-transactions-signle-level-buttons",
                                className: "grid grid-cols-2 gap-2 mt-4",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "col-start-2 grid grid-cols-2 gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            text: tB("cancel"),
                                            onClick: ()=>handleCancel(true),
                                            size: "lg"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            text: tB("save"),
                                            onClick: handleSaveLabelOnly,
                                            size: "lg",
                                            withAccent: true,
                                            enabled: !loading,
                                            spinnerOn: loading
                                        })
                                    ]
                                })
                            }) : $b540ea94c6cd5b1d$var$isMobileLayout(currentBreakpoint) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                id: "blue-transactions-single-level-buttons",
                                className: "w-full flex justify-center mt-4",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: tB("cancel"),
                                    onClick: ()=>handleCancel(true),
                                    size: "lg"
                                })
                            })
                        ]
                    }),
                    panesToShow[1] && firstTransaction && selectedOption && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        id: "blue-transactions-submenu",
                        className: "h-[32rem] sm:w-1/2 flex-none px-6 py-4 flex-col divide-y divide-gray-100 overflow-y-auto flex",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "mt-2 mb-4 text-base font-medium text-gray-500",
                                children: t("whichItem")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex flex-auto flex-col justify-between overflow-hidden",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65c7bc62245b03ec$export$2e2bcd8739ae039), {
                                    selectedOption: selectedOption,
                                    accountId: accountId,
                                    linkedAttribute: linkedAttribute,
                                    loanAccountsForRepaymentTagging: loanAccountsForRepaymentTagging,
                                    // if it is for save, always close the dialog (regardless of what handleCancel will do)
                                    handleCloseAfterSave: ()=>handleCancel(true),
                                    // if this is a mobile layout, cancel in Sublist must not close the dialog (only go back to the main menu)
                                    handleCancel: $b540ea94c6cd5b1d$var$isMobileLayout(currentBreakpoint) ? ()=>handleCancel(false) : ()=>handleCancel(true),
                                    transactions: transactions
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$b540ea94c6cd5b1d$export$2e2bcd8739ae039.propTypes = {
    transactionIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string).isRequired,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$b540ea94c6cd5b1d$export$2e2bcd8739ae039.defaultProps = {
    category: "deposits"
};


function $83d7be387ca00df4$var$showBlueTransactionsInDialog(transactionIds, category) {
    const resolvedIds = Array.isArray(transactionIds) ? transactionIds : [
        transactionIds
    ];
    // show dialog with passcode prompt, ask for passcode, dispatch the below in callback
    window.dispatchEvent(new CustomEvent("setDialog", {
        detail: {
            Component: (0, $b540ea94c6cd5b1d$export$2e2bcd8739ae039),
            props: {
                visible: true,
                transactionIds: resolvedIds,
                category: category
            }
        }
    }));
}
/**
 * Only displays the label for whitelisted labels.
 *
 * @param {} param0
 * @returns
 */ function $83d7be387ca00df4$var$LabelButton({ transactionId: transactionId, label: label, selectedTransactionIds: selectedTransactionIds }) {
    $83d7be387ca00df4$var$LabelButton.propTypes = {
        transactionId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        selectedTransactionIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)
    };
    $83d7be387ca00df4$var$LabelButton.defaultProps = {
        label: null,
        selectedTransactionIds: []
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const approvedLabel = label === null || label === void 0 ? void 0 : label.includes("investment-");
    const category = "deposits";
    const resolvedSelection = selectedTransactionIds && selectedTransactionIds.length > 0 ? selectedTransactionIds : [
        transactionId
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
        type: "button",
        className: "inline-flex items-center justify-center text-gray-400 cursor-pointer w-auto",
        onClick: ()=>$83d7be387ca00df4$var$showBlueTransactionsInDialog(resolvedSelection, category),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "hidden sm:block",
                children: [
                    approvedLabel && label ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "inline-block rounded-md bg-brandBlue-100 hover:bg-brandBlue-200 px-2 py-0.5 text-xs font-medium text-brandBlue-700",
                        children: t(`accountDetails:${category}.labels.${label}.short`)
                    }) : // eslint-disable-next-line max-len
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "inline-block rounded-md border border-gray-100 bg-white hover:bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-300",
                        children: t("accountDetails:deposits.addTag")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "sr-only",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:hidden",
                children: [
                    approvedLabel && label ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "inline-block items-center justify-center rounded-lg bg-brandBlue-100 hover:bg-brandBlue-200 border border-brandBlue-100 p-2 text-xs font-medium text-brandBlue-400",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3480940107a3d218$export$2e2bcd8739ae039), {
                            className: "w-5 h-5"
                        })
                    }) : // eslint-disable-next-line max-len
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "inline-block items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 p-2 text-xs font-medium text-gray-300",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc348e8ecf02df23$export$2e2bcd8739ae039), {
                            className: "w-5 h-5"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "sr-only",
                        children: label
                    })
                ]
            })
        ]
    });
}
function $83d7be387ca00df4$var$showContextMenuInDialog(transactionIds) {
    const resolvedIds = Array.isArray(transactionIds) ? transactionIds : [
        transactionIds
    ];
    // show dialog with passcode prompt, ask for passcode, dispatch the below in callback
    window.dispatchEvent(new CustomEvent("setDialog", {
        detail: {
            Component: (0, $9fcf484b900aa08c$export$2e2bcd8739ae039),
            props: {
                visible: true,
                transactionIds: resolvedIds
            }
        }
    }));
}
function $83d7be387ca00df4$var$EllipsisButton({ transactionId: transactionId, selectedTransactionIds: selectedTransactionIds }) {
    const resolvedSelection = selectedTransactionIds && selectedTransactionIds.length > 0 ? selectedTransactionIds : [
        transactionId
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        className: "h-full text-gray-400 cursor-pointer border border-gray-200 p-2 sm:p-0 rounded-md sm:border-0",
        onClick: ()=>$83d7be387ca00df4$var$showContextMenuInDialog(resolvedSelection),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0828707d2c7c0c6c$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 sm:h-6 sm:w-6 text-gray-300 sm:text-gray-400 hover:text-gray-500",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "sr-only",
                    children: "Transaction context menu"
                })
            ]
        })
    });
}
$83d7be387ca00df4$var$EllipsisButton.propTypes = {
    transactionId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    selectedTransactionIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)
};
$83d7be387ca00df4$var$EllipsisButton.defaultProps = {
    selectedTransactionIds: []
};
function $83d7be387ca00df4$var$ButtonToggleRowDetail({ value: value, openDetailRows: openDetailRows, toggleDetailRow: toggleDetailRow }) {
    // return a button with chevron icon that toggles the detail row
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        id: "toggle-detail-rows",
        className: "hidden pl-1 xs:pl-0 xs:block xs:mr-2 h-full text-gray-400 cursor-pointer",
        onClick: ()=>toggleDetailRow(value),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            children: [
                openDetailRows.includes(value) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $718d5639811dbbc7$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 sm:h-6 sm:w-6 text-gray-400 hover:text-gray-500",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28c6eaf86f1a6031$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 sm:h-6 sm:w-6 text-gray-400 hover:text-gray-500",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "sr-only",
                    children: openDetailRows.includes(value) ? "Hide details" : "Show details"
                })
            ]
        })
    });
}
$83d7be387ca00df4$var$ButtonToggleRowDetail.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    openDetailRows: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    toggleDetailRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $83d7be387ca00df4$var$GhostSelectButton({ onSelect: onSelect, selectionLabel: selectionLabel }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        // eslint-disable-next-line max-len
        className: "absolute -ml-1 left-2 top-1/2 -translate-y-1/2 inline-flex h-6 w-6 items-center justify-center rounded border border-gray-200 bg-white text-gray-300 opacity-0 pointer-events-none cursor-pointer transition group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto focus-visible:opacity-100 focus-visible:pointer-events-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-200",
        onClick: (event)=>{
            event.stopPropagation();
            onSelect();
        },
        "aria-label": selectionLabel,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "pointer-events-none inline-block h-3.5 w-3.5 rounded-sm border border-gray-300",
            "aria-hidden": "true"
        })
    });
}
$83d7be387ca00df4$var$GhostSelectButton.propTypes = {
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    selectionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
// helper function for formatting strings according to their type
function $83d7be387ca00df4$var$formatString(str, columnType, currency = null, secondaryCurrency = null, dashWhenNull = false) {
    if (str === undefined || str === null) return dashWhenNull ? "-" : "";
    const resolvedCurrency = currency || "EUR";
    const resolvedSecondaryCurrency = secondaryCurrency || resolvedCurrency;
    switch(columnType){
        case "date":
            return new Date(Number(str)).toLocaleDateString("de", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                timeZone: "UTC"
            });
        case "currency0Decimals":
            return str.toLocaleString("de", {
                style: "currency",
                currency: resolvedCurrency,
                maximumFractionDigits: 0
            });
        case "currency":
            return str.toLocaleString("de", {
                style: "currency",
                currency: resolvedCurrency,
                maximumFractionDigits: 2
            });
        case "fxCurrency0Decimals":
            return str.toLocaleString("de", {
                style: "currency",
                currency: resolvedSecondaryCurrency,
                maximumFractionDigits: 0
            });
        case "fxCurrency":
            return str.toLocaleString("de", {
                style: "currency",
                currency: resolvedSecondaryCurrency,
                maximumFractionDigits: 2
            });
        case "number0Decimals":
            return str.toLocaleString("de", {
                maximumFractionDigits: 0
            });
        case "number":
            return str.toLocaleString("de", {
                maximumFractionDigits: 2
            });
        case "percentage":
            return str.toLocaleString("de", {
                style: "percent",
                maximumFractionDigits: 2
            });
        case "boolean":
            return str ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1aa98a901308423c$export$2e2bcd8739ae039), {
                className: "h-5 w-5 inline"
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $125f450ca02db1e2$export$2e2bcd8739ae039), {
                className: "h-5 w-5 inline"
            });
        default:
            return String(str);
    }
}
function $83d7be387ca00df4$export$317b60a6d8939a5f({ columns: columns, rowData: rowData, rowIndex: rowIndex, colIndex: colIndex, hidden: hidden, toggleDetailRow: toggleDetailRow, openDetailRows: openDetailRows, groupByColumn: groupByColumn, selectedTransactionIds: selectedTransactionIds }) {
    const columnsToRender = columns || [];
    const leadingColumn = columnsToRender[0] || {};
    const highlightThisColumn = columnsToRender.some((x)=>(rowData.isSummaryRow || rowData.isTotalRow) && (x.highlight === true || colIndex === 0 && x.highlight !== false));
    var _leadingColumn_id;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $2qxEV._)((0, $9tqwB._)({
        id: `table-row-${rowIndex}-${(_leadingColumn_id = leadingColumn.id) !== null && _leadingColumn_id !== void 0 ? _leadingColumn_id : colIndex}`,
        role: "cell"
    }, highlightThisColumn && {
        // if any of the columns is to be highlighted
        onClick: ()=>{
            if (rowData.isSummaryRow) toggleDetailRow(rowData[groupByColumn]);
        }
    }), {
        className: `${hidden}
                 ${leadingColumn.textAlign ? leadingColumn.textAlign : "text-right"}
                 ${rowData.isSummaryRow || rowData.isTotalRow ? "font-bold" : ""}
                 ${highlightThisColumn ? "cursor-pointer" : ""}`,
        children: columnsToRender// if the column uses isSummaryRowDisplay, filter the column definitions to be displayed in accordance with what the row type is
        .filter((columnDef)=>!(rowData.isSummaryRow && columnDef.ifSummaryRowDisplay === false || !rowData.isSummaryRow && columnDef.ifSummaryRowDisplay === true) || rowData.isTotalRow).map((columnDef, indexItemWithinColumn)=>{
            var _columnDef_displayElement, _columnDef_displayElement1, _columnDef_displayElement2;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: (rowData.isSummaryRow || rowData.isTotalRow) && (columnDef.highlight === true || colIndex === 0 && indexItemWithinColumn === 0 && columnDef.highlight !== false) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex justify-start items-center",
                    children: [
                        !rowData.isTotalRow && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($83d7be387ca00df4$var$ButtonToggleRowDetail, {
                            value: rowData[groupByColumn],
                            openDetailRows: openDetailRows,
                            toggleDetailRow: toggleDetailRow
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: `${columnDef.classNamesBody || ""} text-brandBlue-500`,
                            children: $83d7be387ca00df4$var$formatString(rowData[columnDef.id], columnDef.type, rowData.accountCurrency || rowData.currency, rowData.fxCurrency)
                        })
                    ]
                }, columnDef.id) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    // eslint-disable-next-line max-len
                    className: `${columnDef.classNamesBoth || ""} ${columnDef.classNamesBody || ""} ${rowData.isSummaryRow ? columnDef.ifSummaryRowclassNames : ""}`,
                    children: [
                        ![
                            "label",
                            "ellipsis"
                        ].includes(columnDef.type) && (!((_columnDef_displayElement = columnDef.displayElement) === null || _columnDef_displayElement === void 0 ? void 0 : _columnDef_displayElement.displayInstead) || ((_columnDef_displayElement1 = columnDef.displayElement) === null || _columnDef_displayElement1 === void 0 ? void 0 : _columnDef_displayElement1.displayInstead) && !rowData[(_columnDef_displayElement2 = columnDef.displayElement) === null || _columnDef_displayElement2 === void 0 ? void 0 : _columnDef_displayElement2.displayInsteadWhenField]) && $83d7be387ca00df4$var$formatString(rowData[columnDef.id], columnDef.type, rowData.assetCurrency || rowData.currency, rowData.fxCurrency, columnDef.dashWhenNull),
                        columnDef.displayElement && rowData[columnDef.displayElement.field] && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(columnDef.displayElement.element, {
                            id: columnDef.id,
                            value: rowData[columnDef.displayElement.field],
                            rowData: rowData
                        }),
                        columnDef.type === "label" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($83d7be387ca00df4$var$LabelButton, {
                            transactionId: rowData.id,
                            label: rowData.label,
                            selectedTransactionIds: selectedTransactionIds
                        }),
                        columnDef.type === "ellipsis" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($83d7be387ca00df4$var$EllipsisButton, {
                            transactionId: rowData.id,
                            selectedTransactionIds: selectedTransactionIds
                        })
                    ]
                }, columnDef.id)
            });
        })
    }));
}
$83d7be387ca00df4$export$317b60a6d8939a5f.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    rowData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    rowIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    colIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    toggleDetailRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    openDetailRows: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    groupByColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    selectedTransactionIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)
};
$83d7be387ca00df4$export$317b60a6d8939a5f.defaultProps = {
    selectedTransactionIds: []
};
const $83d7be387ca00df4$export$b05581f4e764e162 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function TableRow({ index: index, rowObject: rowObject, selectMode: selectMode, isSelected: isSelected, selectionLabel: selectionLabel, onRowSelect: onRowSelect, selectedTransactionIds: selectedTransactionIds, context: { tableLayout: tableLayout, hiddenColumns: hiddenColumns, toggleDetailRow: toggleDetailRow, openDetailRows: openDetailRows, groupByColumn: groupByColumn } }) {
    var _tableLayout_columns;
    const layoutColumns = (_tableLayout_columns = tableLayout === null || tableLayout === void 0 ? void 0 : tableLayout.columns) !== null && _tableLayout_columns !== void 0 ? _tableLayout_columns : [];
    const rowSelectable = (rowObject === null || rowObject === void 0 ? void 0 : rowObject.id) !== undefined && (rowObject === null || rowObject === void 0 ? void 0 : rowObject.id) !== null;
    const handleCheckboxChange = (event)=>{
        if (!rowSelectable) return;
        event.stopPropagation();
        onRowSelect(rowObject.id, index, event);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            selectMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                role: "cell",
                className: "py-2 flex items-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    type: "checkbox",
                    className: "h-4 w-4 text-brandBlue-600 border-gray-300 rounded focus:ring-brandBlue-500",
                    onChange: handleCheckboxChange,
                    checked: Boolean(isSelected),
                    disabled: !rowSelectable,
                    "aria-checked": isSelected,
                    "aria-label": selectionLabel
                })
            }),
            layoutColumns.map((columns, colIndex)=>{
                var _columns_;
                return(// each BodyCell contains between one and usually three fields (div elements), depending on how small the page is
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($83d7be387ca00df4$export$317b60a6d8939a5f, {
                    rowIndex: index,
                    columns: columns,
                    rowData: rowObject,
                    colIndex: colIndex,
                    hidden: hiddenColumns.includes(columns === null || columns === void 0 ? void 0 : (_columns_ = columns[0]) === null || _columns_ === void 0 ? void 0 : _columns_.id) ? "hidden" : "",
                    toggleDetailRow: toggleDetailRow,
                    openDetailRows: openDetailRows,
                    groupByColumn: groupByColumn,
                    selectedTransactionIds: selectedTransactionIds
                }, `${index}-${colIndex}`));
            }),
            !selectMode && rowSelectable && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($83d7be387ca00df4$var$GhostSelectButton, {
                onSelect: ()=>onRowSelect(rowObject.id, index, {
                        forceSelect: true
                    }),
                selectionLabel: selectionLabel
            })
        ]
    });
});
$83d7be387ca00df4$export$b05581f4e764e162.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    rowObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    selectMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    selectionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    onRowSelect: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    selectedTransactionIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        tableLayout: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
        hiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
        toggleDetailRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        openDetailRows: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
        groupByColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }).isRequired
};
$83d7be387ca00df4$export$b05581f4e764e162.defaultProps = {
    selectedTransactionIds: []
};


const $ec5b0fbdb8c7bace$var$SELECTION_COLUMN_TEMPLATE = "minmax(2.5rem, 3rem)";
const $ec5b0fbdb8c7bace$var$VirtuosoRowGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        ref: ref,
        role: "rowgroup"
    })));
$ec5b0fbdb8c7bace$var$VirtuosoRowGroup.displayName = "VirtuosoRowGroup";
const $ec5b0fbdb8c7bace$var$normalizeModifierState = (eventOrOptions = {})=>{
    if (!eventOrOptions) return {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        forceSelect: false
    };
    var _eventOrOptions_nativeEvent;
    const nativeEvent = (_eventOrOptions_nativeEvent = eventOrOptions.nativeEvent) !== null && _eventOrOptions_nativeEvent !== void 0 ? _eventOrOptions_nativeEvent : eventOrOptions;
    return {
        shiftKey: Boolean(nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey),
        metaKey: Boolean(nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey),
        ctrlKey: Boolean(nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey),
        forceSelect: Boolean(eventOrOptions.forceSelect)
    };
};
function $ec5b0fbdb8c7bace$export$2e2bcd8739ae039({ data: data, tableLayout: tableLayout, tableState: tableState, setTableState: setTableState, highlightTransactionId: highlightTransactionId, groupByColumn: groupByColumn }) {
    // if header is less wide than 5px, then its contents has been hidden due to current breakpoint and the entire containing column needs to be hidden as well
    // the header which detects that its width is below 5px adds its id to the hiddenColumns state array in this component
    // HeaderCell and BodyColumn components check hiddenColumns if their id is there and if so, they add 'hidden' to their className
    const [hiddenColumns, setHiddenColumns] = (0, $7fPBF.useState)([]);
    const [openDetailRows, setOpenDetailRows] = (0, $7fPBF.useState)([]);
    const [selectMode, setSelectMode] = (0, $7fPBF.useState)(false);
    const [selectedItems, setSelectedItems] = (0, $7fPBF.useState)([]);
    const [lastSelectedIndex, setLastSelectedIndex] = (0, $7fPBF.useState)(null);
    const virtuosoRef = (0, $7fPBF.useRef)(null); // Create ref for Virtuoso (used to handle scroll to view in Layout Effect)
    const highlightedRow = (0, $7fPBF.useRef)(); // used to hightlight the row of highlightTransactionId (which is set by SearchResults)
    const containerRef = (0, $7fPBF.useRef)(null);
    const longPressTimerRef = (0, $7fPBF.useRef)(null);
    const gridTemplate = (tableLayout === null || tableLayout === void 0 ? void 0 : tableLayout.columnParams) || "";
    const [computedGridTemplate, setComputedGridTemplate] = (0, $7fPBF.useState)("");
    const adjustedGridTemplate = (0, $7fPBF.useMemo)(()=>{
        if (!computedGridTemplate) return computedGridTemplate;
        return selectMode ? `${$ec5b0fbdb8c7bace$var$SELECTION_COLUMN_TEMPLATE} ${computedGridTemplate}` : computedGridTemplate;
    }, [
        computedGridTemplate,
        selectMode
    ]);
    const virtuosoComponents = (0, $7fPBF.useMemo)(()=>({
            List: $ec5b0fbdb8c7bace$var$VirtuosoRowGroup
        }), []);
    function toggleDetailRow(value) {
        if (openDetailRows.includes(value)) setOpenDetailRows(openDetailRows.filter((id)=>id !== value));
        else setOpenDetailRows([
            ...openDetailRows,
            value
        ]);
    }
    // Calculate visible rows by filtering out hidden rows
    const visibleRows = (0, $7fPBF.useMemo)(()=>data.filter((rowObject)=>!Object.prototype.hasOwnProperty.call(rowObject, "isSummaryRow") || openDetailRows.includes(rowObject[groupByColumn]) ? true : rowObject.isSummaryRow), [
        data,
        openDetailRows,
        groupByColumn
    ]);
    const selectableRowIds = (0, $7fPBF.useMemo)(()=>visibleRows.map((row)=>row === null || row === void 0 ? void 0 : row.id).filter((id)=>id !== undefined && id !== null), [
        visibleRows
    ]);
    const selectedSet = (0, $7fPBF.useMemo)(()=>new Set(selectedItems), [
        selectedItems
    ]);
    const isAllSelected = selectMode && selectableRowIds.length > 0 && selectableRowIds.every((id)=>selectedSet.has(id));
    const isIndeterminate = selectMode && selectedItems.length > 0 && !isAllSelected;
    const clearSelection = (0, $7fPBF.useCallback)(()=>{
        setSelectedItems([]);
        setSelectMode(false);
        setLastSelectedIndex(null);
    }, []);
    const cancelLongPress = (0, $7fPBF.useCallback)(()=>{
        if (longPressTimerRef.current) {
            window.clearTimeout(longPressTimerRef.current);
            longPressTimerRef.current = null;
        }
    }, []);
    const getRangeIds = (0, $7fPBF.useCallback)((fromIndex, toIndex)=>{
        if (fromIndex === null || fromIndex === undefined || toIndex === null || toIndex === undefined) return [];
        const start = Math.min(fromIndex, toIndex);
        const end = Math.max(fromIndex, toIndex);
        const ids = [];
        for(let idx = start; idx <= end; idx += 1){
            var _visibleRows_idx;
            const rangeId = (_visibleRows_idx = visibleRows[idx]) === null || _visibleRows_idx === void 0 ? void 0 : _visibleRows_idx.id;
            if (rangeId !== undefined && rangeId !== null) ids.push(rangeId);
        }
        return ids;
    }, [
        visibleRows
    ]);
    const handleRowSelection = (0, $7fPBF.useCallback)((rowId, rowIndex, eventOrOptions = {})=>{
        if (rowId === undefined || rowId === null) return;
        const { shiftKey: shiftKey, forceSelect: forceSelect } = $ec5b0fbdb8c7bace$var$normalizeModifierState(eventOrOptions);
        setSelectMode(true);
        setSelectedItems((prev)=>{
            if (shiftKey && lastSelectedIndex !== null && rowIndex !== null && rowIndex !== undefined) {
                const selectionSet = new Set(prev);
                getRangeIds(lastSelectedIndex, rowIndex).forEach((rangeId)=>selectionSet.add(rangeId));
                return Array.from(selectionSet);
            }
            const selectionSet = new Set(prev);
            if (selectionSet.has(rowId) && !forceSelect) selectionSet.delete(rowId);
            else selectionSet.add(rowId);
            return Array.from(selectionSet);
        });
        setLastSelectedIndex(rowIndex);
    }, [
        getRangeIds,
        lastSelectedIndex
    ]);
    const handleHeaderToggle = (0, $7fPBF.useCallback)(()=>{
        if (!selectableRowIds.length) return;
        if (isAllSelected) {
            clearSelection();
            return;
        }
        setSelectMode(true);
        setSelectedItems(selectableRowIds);
        setLastSelectedIndex(null);
    }, [
        clearSelection,
        isAllSelected,
        selectableRowIds
    ]);
    const handleTouchLongPressStart = (0, $7fPBF.useCallback)((event, rowId, rowIndex)=>{
        if (selectMode || !rowId) return;
        const pointerType = event.pointerType || (event.touches ? "touch" : "");
        if (pointerType !== "touch") return;
        cancelLongPress();
        longPressTimerRef.current = window.setTimeout(()=>{
            handleRowSelection(rowId, rowIndex, {
                forceSelect: true
            });
            cancelLongPress();
        }, 450);
    }, [
        cancelLongPress,
        handleRowSelection,
        selectMode
    ]);
    const getSelectionLabel = (0, $7fPBF.useCallback)((row)=>{
        if (!row) return "Select transaction";
        const descriptor = row.description || row.otherParty || row.assetName || row.name || row.id || "transaction";
        const dateValue = row.date;
        let formattedDate = "";
        if (dateValue) {
            let timestamp;
            if (dateValue instanceof Date) timestamp = dateValue.getTime();
            else if (typeof dateValue === "number") timestamp = dateValue;
            else if (typeof dateValue === "string") {
                const numeric = Number(dateValue);
                if (!Number.isNaN(numeric) && dateValue.trim() !== "") timestamp = numeric;
                else {
                    const parsed = Date.parse(dateValue);
                    if (!Number.isNaN(parsed)) timestamp = parsed;
                }
            }
            if (timestamp && !Number.isNaN(timestamp)) formattedDate = ` on ${new Date(timestamp).toLocaleDateString("de", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            })}`;
        }
        return `Select transaction ${descriptor}${formattedDate}`;
    }, []);
    const rowContext = (0, $7fPBF.useMemo)(()=>({
            tableLayout: tableLayout,
            hiddenColumns: hiddenColumns,
            toggleDetailRow: toggleDetailRow,
            openDetailRows: openDetailRows,
            groupByColumn: groupByColumn
        }), [
        tableLayout,
        hiddenColumns,
        toggleDetailRow,
        openDetailRows,
        groupByColumn
    ]);
    // prepare the contents of TableRow to be passed as itemContent to Virtuoso
    const renderRow = (0, $7fPBF.useCallback)((index, item)=>{
        const isHighlighted = item.id === highlightTransactionId;
        const isSelected = selectedSet.has(item.id);
        const paddingClasses = selectMode ? "px-3" : "pl-8 pr-3";
        const hoverClass = !selectMode ? "hover:bg-gray-50" : "";
        const selectionClass = selectMode && isSelected ? "bg-brandBlue-50/60" : "";
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            id: `table-row-${index}`,
            ref: isHighlighted ? highlightedRow : undefined,
            role: "row",
            "aria-selected": selectMode ? isSelected : undefined,
            onPointerDown: (event)=>handleTouchLongPressStart(event, item.id, index),
            onPointerUp: cancelLongPress,
            onPointerLeave: cancelLongPress,
            onPointerCancel: cancelLongPress,
            className: `${paddingClasses} py-2 grid gap-3 items-center relative group ${item.isSimulated ? "bg-brandViolet-50 italic" : ""} ${selectionClass} ${isHighlighted ? "bg-brandYellow-100" : ""} ${item.isSummaryRow ? "font-bold border-b border-gray-200" : "font-medium border-b border-gray-200"} ${hoverClass}`,
            style: adjustedGridTemplate ? {
                gridTemplateColumns: adjustedGridTemplate
            } : undefined,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $83d7be387ca00df4$export$b05581f4e764e162), {
                index: index,
                rowObject: item,
                selectMode: selectMode,
                isSelected: isSelected,
                selectionLabel: getSelectionLabel(item),
                onRowSelect: handleRowSelection,
                selectedTransactionIds: selectedItems,
                context: rowContext
            })
        }, item.id);
    }, [
        adjustedGridTemplate,
        cancelLongPress,
        getSelectionLabel,
        handleRowSelection,
        handleTouchLongPressStart,
        highlightTransactionId,
        rowContext,
        selectMode,
        selectedItems,
        selectedSet
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (selectedItems.length === 0) {
            setSelectMode(false);
            setLastSelectedIndex(null);
        }
    }, [
        selectedItems.length
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!selectMode) return undefined;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") clearSelection();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        selectMode,
        clearSelection
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const handleClearSelectionEvent = ()=>{
            clearSelection();
        };
        window.addEventListener("clearTableSelection", handleClearSelectionEvent);
        return ()=>{
            window.removeEventListener("clearTableSelection", handleClearSelectionEvent);
        };
    }, [
        clearSelection
    ]);
    (0, $7fPBF.useEffect)(()=>()=>{
            cancelLongPress();
        }, [
        cancelLongPress
    ]);
    (0, $7fPBF.useLayoutEffect)(()=>{
        const node = containerRef.current;
        if (!node || typeof window === "undefined") return undefined;
        const updateTemplate = ()=>{
            const appliedTemplate = window.getComputedStyle(node).gridTemplateColumns;
            setComputedGridTemplate(appliedTemplate);
        };
        updateTemplate();
        let resizeObserver;
        if (typeof window.ResizeObserver === "function") {
            resizeObserver = new window.ResizeObserver(updateTemplate);
            resizeObserver.observe(node);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
        window.addEventListener("resize", updateTemplate);
        return ()=>{
            window.removeEventListener("resize", updateTemplate);
        };
    }, [
        gridTemplate
    ]);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (highlightTransactionId && virtuosoRef.current) {
            const indexToScroll = visibleRows.findIndex((row)=>row.id === highlightTransactionId);
            if (indexToScroll !== -1) virtuosoRef.current.scrollToIndex(indexToScroll);
        }
    }, [
        highlightTransactionId,
        visibleRows
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
        // eslint-disable-next-line max-len
        className: "h-full min-h-0 self-stretch flex flex-col overflow-hidden relative overflow-y-hidden overflow-x-hidden",
        "aria-label": "transaction details",
        role: "table",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            ref: containerRef,
            className: `w-full h-full min-h-0 relative flex flex-col ${gridTemplate}`,
            children: [
                selectMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex items-center justify-between px-3 py-2 text-xs text-gray-700 bg-gray-50 border-b border-gray-200",
                    role: "toolbar",
                    "aria-label": "Selection mode actions",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                            className: "font-semibold",
                            children: [
                                selectedItems.length,
                                " ",
                                "selected"
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "text-brandBlue-600 hover:text-brandBlue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-200 rounded px-2 py-1 text-xs font-medium",
                            onClick: clearSelection,
                            children: "Cancel"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c64dd8df4a61e92$export$2e2bcd8739ae039), {
                    tableLayout: tableLayout,
                    tableState: tableState,
                    setTableState: setTableState,
                    hiddenColumns: hiddenColumns,
                    setHiddenColumns: setHiddenColumns,
                    gridTemplateColumns: adjustedGridTemplate,
                    selectMode: selectMode,
                    selectionColumnProps: {
                        checked: isAllSelected,
                        indeterminate: isIndeterminate,
                        onChange: handleHeaderToggle,
                        disabled: selectableRowIds.length === 0
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d72989d8b3846905$export$ea50ab61e1198ee3), {
                    ref: virtuosoRef,
                    style: {
                        height: "100%",
                        overflowX: "hidden"
                    },
                    className: "flex-1 min-h-0 text-gray-500 bg-white text-xs xs:text-sm",
                    data: visibleRows,
                    itemContent: renderRow,
                    components: virtuosoComponents
                })
            ]
        })
    });
}
$ec5b0fbdb8c7bace$export$2e2bcd8739ae039.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    tableLayout: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        columnParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object)).isRequired
    }).isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    highlightTransactionId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    groupByColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$ec5b0fbdb8c7bace$export$2e2bcd8739ae039.defaultProps = {
    highlightTransactionId: null,
    groupByColumn: "assetId"
};


const $c2ddf3c88ec92136$export$5948b786dea4615d = {
    columnParams: "grid-cols-[minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),3rem]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "purchaseValue",
                type: "currency0Decimals",
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "currentValue",
                type: "currency0Decimals",
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "dividendsSincePurchase",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "roi",
                type: "percentage",
                usesHeader: "roiOnly",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "roiAnnual",
                type: "percentage",
                classNamesBody: "text-xs text-gray-400"
            }
        ],
        [
            {
                id: "ellipsis",
                type: "ellipsis",
                usesHeader: "emptyString",
                classNamesBody: "-ml-3"
            }
        ]
    ]
};
const $c2ddf3c88ec92136$export$6a8dcc9d2a5282e3 = {
    columnParams: "grid-cols-[minmax(0,1fr),minmax(0,1fr),minmax(0,1fr)] sm:grid-cols-[minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr)]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            },
            {
                id: "source",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "source",
                type: "string",
                classNamesBoth: "hidden sm:block",
                textAlign: "text-center"
            }
        ],
        [
            {
                id: "quoteBaseCurrency",
                usesHeader: "price",
                type: "currency0Decimals"
            },
            {
                id: "pricePerSquareMetre",
                type: "currency0Decimals",
                classNamesBoth: "sm:hidden",
                classNamesBody: "text-xs"
            }
        ],
        [
            {
                id: "currency",
                type: "string",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "quote",
                usesHeader: "originalPrice",
                type: "number0Decimals"
            },
            {
                id: "originalPricePerSquareMetre",
                type: "number0Decimals",
                classNamesBoth: "sm:hidden",
                classNamesBody: "text-xs"
            },
            {
                id: "currency",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                // pass hide / show classes here, they will be applied to HeaderLabels and BodyColumns
                id: "pricePerSquareMetre",
                type: "currency0Decimals",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "originalPricePerSquareMetre",
                type: "number0Decimals",
                classNamesBoth: "hidden sm:block"
            }
        ]
    ]
};


const $8bcd8f68844c7a45$export$68335a8b2413fe7a = {
    columnParams: "grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            },
            {
                id: "source",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "source",
                type: "string",
                classNamesBoth: "hidden sm:block",
                textAlign: "text-center"
            }
        ],
        [
            {
                id: "quoteBaseCurrency",
                usesHeader: "price",
                type: "currency0Decimals"
            }
        ],
        [
            {
                id: "currency",
                type: "string",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "quote",
                usesHeader: "originalPrice",
                type: "number0Decimals"
            },
            {
                id: "currency",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "note",
                type: "string"
            }
        ]
    ]
};
const $8bcd8f68844c7a45$export$2802f167dacb0091 = {
    columnParams: "grid-cols-[1fr,minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),3rem]",
    columns: [
        [
            {
                ifSummaryRowDisplay: false,
                id: "date",
                type: "date",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm"
            },
            {
                ifSummaryRowDisplay: true,
                id: "displayName",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm",
                ifSummaryRowclassNames: "text-brandBlue-600"
            }
        ],
        [
            {
                id: "purchaseValue",
                type: "currency0Decimals",
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "currentValue",
                type: "currency0Decimals",
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "dividendsSincePurchase",
                usesHeader: "proceeds",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "fees",
                usesHeader: "costs",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "roi",
                type: "percentage",
                usesHeader: "roiOnly",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "roiAnnual",
                type: "percentage",
                classNamesBody: "text-xs text-gray-400"
            }
        ],
        [
            {
                id: "ellipsis",
                type: "ellipsis",
                usesHeader: "emptyString",
                classNamesBody: "-ml-3"
            }
        ]
    ]
};


/* eslint-disable max-len */ /* eslint-disable react/react-in-jsx-scope */ /* eslint-disable react/jsx-filename-extension */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $037bf7a5f2429a57$var$ExclamationTriangleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $037bf7a5f2429a57$var$ForwardRef = $7fPBF.forwardRef($037bf7a5f2429a57$var$ExclamationTriangleIcon);
var $037bf7a5f2429a57$export$2e2bcd8739ae039 = $037bf7a5f2429a57$var$ForwardRef;




function $c289289d8451f44c$export$2dea7e4637c46a0f({ value: value }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
        info: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t(`accountDetails:${value}`),
        classNameOwn: "w-5 -mb-0.5",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $037bf7a5f2429a57$export$2e2bcd8739ae039), {
            className: "w-5 h-5 text-brandYellow-500 cursor-pointer"
        })
    });
}
$c289289d8451f44c$export$2dea7e4637c46a0f.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$c289289d8451f44c$export$2dea7e4637c46a0f.defaultProps = {
    value: ""
};
function $c289289d8451f44c$export$99ae49454becd635({ value: value }) {
    if (typeof value !== "number") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "split-icon",
        className: "inline-block rounded-full bg-gray-300 ml-0.5 align-text-bottom font-bold text-center px-1 text-xs text-white w-4",
        children: "S"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "ml-1 inline-flex items-center gap-1",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: `(${value} `
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                id: "split-icon",
                className: "inline-block rounded-full bg-gray-300 ml-0.5 font-bold text-center px-1 text-xs text-white w-4 h-4",
                children: "S"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                children: ")"
            })
        ]
    });
}
function $c289289d8451f44c$export$e305ce5a457d8767({ value: value }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
        children: ` | ${value}`
    });
}
$c289289d8451f44c$export$e305ce5a457d8767.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ])
};
$c289289d8451f44c$export$e305ce5a457d8767.defaultProps = {
    value: ""
};


const $a4ef4ce00db94738$export$460676c87860306c = {
    columnParams: "grid-cols-[1fr,1fr,1fr,1fr] sm:grid-cols-[1fr,1fr,1fr,minmax(0,1fr),minmax(0,1fr),minmax(0,1fr),3fr]",
    columns: [
        [
            {
                id: "assetName",
                type: "string",
                textAlign: "text-left",
                usesHeader: "assetId"
            }
        ],
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            },
            {
                id: "source",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "source",
                type: "string",
                classNamesBoth: "hidden sm:block",
                textAlign: "text-center"
            }
        ],
        [
            {
                id: "quoteBaseCurrency",
                usesHeader: "price",
                type: "currency0Decimals"
            }
        ],
        [
            {
                id: "currency",
                type: "string",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "quote",
                usesHeader: "originalPrice",
                type: "number0Decimals"
            },
            {
                id: "currency",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "note",
                type: "string",
                classNamesBoth: "hidden sm:block"
            }
        ]
    ]
};
const $a4ef4ce00db94738$export$4efad9798dd0814e = {
    columnParams: "grid-cols-[5rem,1fr,1fr,1fr,3rem] xs:grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr,3rem]",
    columns: [
        [
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "date",
                type: "date",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm flex gap-1 items-align",
                displayElement: {
                    field: "itemHasFlag",
                    element: (0, $c289289d8451f44c$export$2dea7e4637c46a0f)
                }
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs text-gray-400 font-normal",
                classNamesBoth: "xs:hidden",
                hideHeaderLabel: true
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "assetName",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm",
                ifSummaryRowClassNames: "text-brandBlue-600 truncate",
                usesHeader: "displayName"
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs text-gray-400 font-normal",
                classNamesBoth: "xs:hidden",
                hideHeaderLabel: true
            }
        ],
        [
            // prettier-ignore
            {
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden xs:block",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                }
            },
            {
                id: "currentValue",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "xs:hidden"
            },
            {
                id: "purchaseValue",
                usesHeader: "purchaseValueFull",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "xs:hidden"
            }
        ],
        [
            {
                id: "purchaseValue",
                usesHeader: "purchaseValueFull",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden xs:block"
            },
            {
                id: "purchaseQuote",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden xs:block",
                displayElement: {
                    field: "displayPriceTransactionCurrency",
                    element: (0, $c289289d8451f44c$export$e305ce5a457d8767)
                }
            }
        ],
        [
            {
                id: "currentValue",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden xs:block"
            },
            {
                id: "currentQuote",
                usesHeader: "currentPrice",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden xs:block",
                displayElement: {
                    field: "displayQuoteTransactionCurrency",
                    element: (0, $c289289d8451f44c$export$e305ce5a457d8767)
                }
            },
            {
                id: "fees",
                type: "currency",
                usesHeader: "feesSincePurchase",
                hideHeaderLabel: false,
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "xs:hidden"
            }
        ],
        [
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden xs:block"
            }
        ],
        [
            {
                id: "roi",
                type: "percentage",
                usesHeader: "roiOnly",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden xs:block"
            },
            {
                id: "roiAnnual",
                type: "percentage",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden xs:block"
            }
        ],
        [
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "ellipsis",
                type: "ellipsis",
                usesHeader: "emptyString",
                classNamesBody: "-ml-3"
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "bn",
                type: "number0Decimals",
                hideHeaderLabel: true,
                displayElement: {
                    field: "itemHasFlag",
                    element: (0, $c289289d8451f44c$export$2dea7e4637c46a0f)
                }
            }
        ]
    ]
};


/* eslint-disable max-len */ 
const $50aa98c3f6e62211$export$75a798432c918f76 = {
    columnParams: "grid-cols-[1fr,1fr,1fr,1fr] sm:grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr]",
    columns: [
        [
            {
                id: "assetName",
                type: "string",
                textAlign: "text-left",
                usesHeader: "assetId"
            }
        ],
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            },
            {
                id: "source",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "source",
                type: "string",
                classNamesBoth: "hidden sm:block",
                textAlign: "text-center"
            }
        ],
        [
            {
                id: "quoteBaseCurrency",
                usesHeader: "price",
                type: "currency0Decimals"
            }
        ],
        [
            {
                id: "currency",
                type: "string",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "quote",
                usesHeader: "originalPrice",
                type: "number0Decimals"
            },
            {
                id: "currency",
                type: "string",
                classNamesBoth: "sm:hidden"
            }
        ]
    ]
};
const $50aa98c3f6e62211$export$ef749c62f1718a7c = {
    columnParams: "grid-cols-[1fr,1fr,1fr,3rem] sm:grid-cols-[1fr,1fr,1fr,1fr,1fr,1fr,3rem]",
    columns: [
        [
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "date",
                type: "date",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm flex gap-1 items-align",
                displayElement: {
                    field: "itemHasFlag",
                    element: (0, $c289289d8451f44c$export$2dea7e4637c46a0f)
                }
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs text-gray-400 font-normal",
                classNamesBoth: "sm:hidden",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                },
                hideHeaderLabel: true
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "assetName",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm",
                ifSummaryRowClassNames: "text-brandBlue-600 truncate"
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs text-gray-400 font-normal",
                classNamesBoth: "hidden",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                },
                hideHeaderLabel: true
            }
        ],
        [
            // prettier-ignore
            {
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                }
            },
            {
                id: "currentValue",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            },
            {
                id: "purchaseValue",
                usesHeader: "purchaseValueFull",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "purchaseValue",
                usesHeader: "purchaseValueFull",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "purchaseQuote",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden sm:block",
                displayElement: {
                    field: "displayPriceTransactionCurrency",
                    element: (0, $c289289d8451f44c$export$e305ce5a457d8767)
                }
            }
        ],
        [
            {
                id: "currentValue",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "currentQuote",
                usesHeader: "currentPrice",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden sm:block",
                displayElement: {
                    field: "displayQuoteTransactionCurrency",
                    element: (0, $c289289d8451f44c$export$e305ce5a457d8767)
                }
            },
            {
                id: "dividendsSincePurchase",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            },
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "dividendsSincePurchase",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "roi",
                type: "percentage",
                usesHeader: "roiOnly",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "roiAnnual",
                type: "percentage",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "ellipsis",
                type: "ellipsis",
                usesHeader: "emptyString",
                classNamesBody: "-ml-3"
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "bn",
                type: "number0Decimals",
                hideHeaderLabel: true,
                displayElement: {
                    field: "itemHasFlag",
                    element: (0, $c289289d8451f44c$export$2dea7e4637c46a0f)
                }
            }
        ]
    ]
};


/* eslint-disable max-len */ 
const $1010431ada9f7def$export$a9eee3a88aa90b5f = {
    columnParams: "grid-cols-[4fr,2fr,2fr,1fr] sm:grid-cols-[20%,minmax(0,1fr),minmax(0,1fr),minmax(0,2fr),minmax(0,2fr),minmax(0,1fr),minmax(0,1fr)] md:grid-cols-[20%,1fr,4fr,4fr,2fr,2fr,1fr] lg:grid-cols-[30%,2fr,4fr,4fr,2fr,2fr,3rem]",
    columns: [
        [
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "date",
                type: "date",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm flex gap-1 items-align",
                displayElement: {
                    field: "itemHasFlag",
                    element: (0, $c289289d8451f44c$export$2dea7e4637c46a0f)
                }
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs text-gray-400 font-normal",
                classNamesBoth: "sm:hidden",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                },
                hideHeaderLabel: true
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "displayName",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm",
                ifSummaryRowClassNames: "text-brandBlue-600 truncate"
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs text-gray-400 font-normal",
                classNamesBoth: "hidden",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                },
                hideHeaderLabel: true
            }
        ],
        [
            // prettier-ignore
            {
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                }
            },
            {
                id: "currentValueBaseCurrency",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            },
            {
                id: "purchaseValue",
                usesHeader: "purchaseValueFull",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "purchaseValue",
                usesHeader: "purchaseValueFull",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "transactionPrice",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden sm:block",
                displayElement: {
                    field: "displayPriceTransactionCurrency",
                    element: (0, $c289289d8451f44c$export$e305ce5a457d8767)
                }
            }
        ],
        [
            {
                id: "currentValueBaseCurrency",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "currentQuoteBaseCurrency",
                usesHeader: "currentPrice",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden sm:block",
                displayElement: {
                    field: "displayQuoteTransactionCurrency",
                    element: (0, $c289289d8451f44c$export$e305ce5a457d8767)
                }
            },
            {
                id: "dividendsSincePurchase",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            },
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "dividendsSincePurchase",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "roi",
                type: "percentage",
                usesHeader: "roiOnly",
                classNamesBody: "text-xs sm:text-sm",
                classNamesBoth: "hidden sm:block"
            },
            {
                id: "roiAnnual",
                type: "percentage",
                classNamesBody: "text-xs text-gray-400",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            // prettier-ignore
            {
                ifSummaryRowDisplay: false,
                id: "ellipsis",
                type: "ellipsis",
                usesHeader: "emptyString",
                classNamesBody: "-ml-3"
            },
            // prettier-ignore
            {
                ifSummaryRowDisplay: true,
                id: "bn",
                type: "number0Decimals",
                hideHeaderLabel: true,
                displayElement: {
                    field: "itemHasFlag",
                    element: (0, $c289289d8451f44c$export$2dea7e4637c46a0f)
                }
            }
        ]
    ]
};
const $1010431ada9f7def$export$160b4a892474687a = {
    columnParams: "grid-cols-[2fr,1fr,1fr,1fr,1fr,1fr]",
    columns: [
        [
            {
                ifSummaryRowDisplay: false,
                id: "date",
                type: "date",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm"
            },
            // ^^ need this for both types of row
            {
                ifSummaryRowDisplay: false,
                id: "accountName",
                type: "string",
                textAlign: "text-left",
                classNamesHeader: "text-xs sm:text-sm",
                classNamesBody: "text-xs text-gray-400 uppercase"
            },
            {
                ifSummaryRowDisplay: true,
                id: "displayName",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "text-xs sm:text-sm",
                ifSummaryRowclassNames: "text-brandBlue-600"
            }
        ],
        [
            {
                id: "openPositionSize",
                type: "number0Decimals",
                classNamesBody: "text-xs sm:text-sm",
                displayElement: {
                    field: "isPreSplitTransaction",
                    element: (0, $c289289d8451f44c$export$99ae49454becd635)
                }
            }
        ],
        [
            {
                id: "purchaseValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "transactionPrice",
                type: "currency",
                classNamesBody: "text-xs text-gray-400"
            }
        ],
        [
            {
                id: "currentValueBaseCurrency",
                usesHeader: "currentValue",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "currentQuoteBaseCurrency",
                usesHeader: "currentPrice",
                type: "currency",
                classNamesBody: "text-xs text-gray-400",
                hideHeaderLabel: true
            }
        ],
        [
            {
                id: "dividendsSincePurchase",
                type: "currency",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "fees",
                type: "currency",
                hideHeaderLabel: true,
                classNamesBody: "text-xs sm:text-sm"
            }
        ],
        [
            {
                id: "roi",
                type: "percentage",
                usesHeader: "roiOnly",
                classNamesBody: "text-xs sm:text-sm"
            },
            {
                id: "roiAnnual",
                type: "percentage",
                classNamesBody: "text-xs text-gray-400"
            }
        ]
    ]
};
const $1010431ada9f7def$export$8f65ae7600523d58 = {
    // minmax(0,...) to disregard the content width when calculating the column width
    columnParams: "grid-cols-[minmax(0,2fr),minmax(0,2fr),minmax(0,2fr),minmax(0,2fr)] md:grid-cols-[minmax(0,2fr),minmax(0,2fr),minmax(0,2fr),minmax(0,1fr),30%] xl:grid-cols-[2fr,2fr,2fr,1fr,50%]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            }
        ],
        [
            {
                id: "quoteBaseCurrency",
                usesHeader: "price",
                type: "currency"
            }
        ],
        [
            {
                id: "quote",
                usesHeader: "originalPrice",
                type: "number"
            },
            {
                id: "currency",
                type: "string",
                classNamesBoth: "md:hidden"
            }
        ],
        [
            {
                id: "currency",
                type: "string",
                classNamesBoth: "hidden md:inline"
            }
        ],
        [
            {
                id: "note",
                type: "string"
            }
        ]
    ]
};


const $94257761c966a27f$export$a8e40a5a005e4816 = {
    // usage: accepts fixed values like rem, px or %; fr means "free space" - takes all space left after fixed values and distributes it in proportion to Nfr
    // hidden columns drop out of the grid, so do not have to be declared in grid-cols-xxx
    columnParams: "grid-cols-[50%,20%,1fr,1fr] sm:grid-cols-[30%,30%,15%,2fr,1fr] lg:grid-cols-[6rem,1fr,2fr,6rem,5rem,2rem]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            },
            {
                id: "otherParty",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "lg:hidden"
            },
            {
                id: "otherPartyAccount",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "lg:hidden",
                classNamesBody: "text-xs truncate",
                classNamesHeader: "hidden"
            },
            {
                id: "description",
                type: "string",
                textAlign: "text-left",
                classNamesBody: "truncate",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "otherParty",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "hidden lg:block"
            },
            {
                id: "otherPartyAccount",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "hidden lg:block",
                classNamesBody: "text-xs text-gray-400 rtl truncate",
                classNamesHeader: "hidden"
            }
        ],
        [
            {
                id: "description",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "accountCurrencyAmount",
                type: "currency",
                usesHeader: "amount",
                textAlign: "text-right"
            },
            {
                id: "fxAmount",
                type: "fxCurrency",
                classNamesBody: "text-xs text-gray-400"
            }
        ],
        [
            {
                id: "label",
                type: "label",
                // textAlign: 'justify-self-center',
                classNamesBody: "justify-self-center min-w-0",
                usesHeader: "type"
            }
        ],
        [
            {
                id: "ellipsis",
                type: "ellipsis",
                // usesHeader: 'emptyString',
                classNamesBody: "justify-self-center",
                usesHeader: null
            }
        ]
    ]
};
var $94257761c966a27f$export$2e2bcd8739ae039 = true;


const $7ac3a9300d565945$export$b6d2eea1dbcee5d1 = {
    columnParams: "grid-cols-[1fr,1fr,1fr,3rem] sm:grid-cols-[1fr,41.666667%,1fr,1fr,3rem]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            },
            {
                id: "description",
                type: "string",
                textAlign: "text-left",
                classNamesBody: "truncate",
                classNamesBoth: "sm:hidden"
            }
        ],
        [
            {
                id: "description",
                type: "string",
                textAlign: "text-left",
                classNamesBoth: "hidden sm:block"
            }
        ],
        [
            {
                id: "quantity",
                type: "currency",
                usesHeader: "principal",
                textAlign: "text-right"
            }
        ],
        [
            {
                id: "quantityInterest",
                type: "currency",
                usesHeader: "interest",
                textAlign: "text-right"
            }
        ],
        [
            {
                id: "ellipsis",
                type: "ellipsis",
                usesHeader: "emptyString",
                classNamesBody: "-ml-3"
            }
        ]
    ]
};
const $7ac3a9300d565945$var$d = 1;
var $7ac3a9300d565945$export$2e2bcd8739ae039 = $7ac3a9300d565945$var$d;


const $763650402154910f$export$e59b728dc06f12a7 = {
    columnParams: "grid-cols-[1fr,1fr,1fr] sm:grid-cols-[1fr,4fr,8rem]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            }
        ],
        [
            {
                id: "description",
                type: "string",
                textAlign: "text-left"
            }
        ],
        [
            {
                id: "quantity",
                type: "currency",
                usesHeader: "amount",
                textAlign: "text-right"
            }
        ]
    ]
};
const $763650402154910f$export$afe32d8c4b87a47c = {
    columnParams: "grid-cols-[1fr,1fr,1fr,1fr] md:grid-cols-[8rem,1fr,1fr,1fr,1fr,1fr]",
    columns: [
        [
            {
                id: "date",
                type: "date",
                textAlign: "text-left"
            }
        ],
        [
            {
                id: "payoutOnlyContributionsToDate",
                type: "currency",
                dashWhenNull: true
            },
            {
                id: "payoutOnlyContributionsToDateIndexed",
                type: "currency",
                classNamesBoth: "md:hidden",
                dashWhenNull: true
            }
        ],
        [
            {
                id: "payoutOnlyContributionsToDateIndexed",
                type: "currency",
                classNamesBoth: "hidden md:block",
                dashWhenNull: true
            },
            {
                id: "payoutAllPlannedContributions",
                type: "currency",
                classNamesBoth: "md:hidden",
                dashWhenNull: true
            },
            {
                id: "payoutAllPlannedContributionsIndexed",
                type: "currency",
                classNamesBoth: "md:hidden",
                dashWhenNull: true
            }
        ],
        [
            {
                id: "payoutAllPlannedContributions",
                type: "currency",
                classNamesBoth: "hidden md:block",
                dashWhenNull: true
            },
            {
                id: "payoutLumpSumVerrentet",
                type: "currency",
                classNamesBoth: "md:hidden",
                dashWhenNull: true
            }
        ],
        [
            {
                id: "payoutAllPlannedContributionsIndexed",
                type: "currency",
                classNamesBoth: "hidden md:block",
                dashWhenNull: true
            }
        ],
        [
            {
                id: "payoutLumpSumVerrentet",
                type: "currency",
                classNamesBoth: "hidden md:block",
                dashWhenNull: true
            }
        ]
    ]
};
const $763650402154910f$var$d = 1;
var $763650402154910f$export$2e2bcd8739ae039 = $763650402154910f$var$d;




const $ad7a88cad4bc7af4$var$emptyLayout = {
    columnParams: "grid-cols-[1fr]",
    columns: []
};
function $ad7a88cad4bc7af4$export$2e2bcd8739ae039(category, displayedData) {
    if (!category || !displayedData) return $ad7a88cad4bc7af4$var$emptyLayout;
    // handle cashflow mode -- if displayedData === 'cashflow', always return depositsTransactions;
    if (displayedData === "cashflow") return 0, $94257761c966a27f$export$a8e40a5a005e4816;
    if (displayedData === "quotes") switch(category){
        case "realEstate":
            return 0, $c2ddf3c88ec92136$export$6a8dcc9d2a5282e3;
        case "stocks":
        case "crypto":
            return 0, $1010431ada9f7def$export$8f65ae7600523d58;
        case "pension":
            return 0, $763650402154910f$export$afe32d8c4b87a47c;
        case "objectsOfValue":
            return 0, $8bcd8f68844c7a45$export$68335a8b2413fe7a;
        case "metals":
            return 0, $a4ef4ce00db94738$export$460676c87860306c;
        case "unlistedShares":
            return 0, $50aa98c3f6e62211$export$75a798432c918f76;
        default:
            return $ad7a88cad4bc7af4$var$emptyLayout;
    }
    if (displayedData === "holdings") switch(category){
        case "realEstate":
            return 0, $c2ddf3c88ec92136$export$5948b786dea4615d;
        case "stocks":
        case "crypto":
            return 0, $1010431ada9f7def$export$a9eee3a88aa90b5f;
        case "stocksPositionsReport":
            return 0, $1010431ada9f7def$export$160b4a892474687a;
        case "deposits":
            return 0, $94257761c966a27f$export$a8e40a5a005e4816;
        case "loans":
            return 0, $7ac3a9300d565945$export$b6d2eea1dbcee5d1;
        case "pension":
            return 0, $763650402154910f$export$e59b728dc06f12a7;
        case "objectsOfValue":
            return 0, $8bcd8f68844c7a45$export$2802f167dacb0091;
        case "metals":
            return 0, $a4ef4ce00db94738$export$4efad9798dd0814e;
        case "unlistedShares":
            return 0, $50aa98c3f6e62211$export$ef749c62f1718a7c;
        default:
            return $ad7a88cad4bc7af4$var$emptyLayout;
    }
    return $ad7a88cad4bc7af4$var$emptyLayout;
}


var $383b93bc6b490f8f$exports = {};

$parcel$export($383b93bc6b490f8f$exports, "categoryOrderedObject", function () { return $383b93bc6b490f8f$export$3270e954cce20150; });
$parcel$export($383b93bc6b490f8f$exports, "applyCategorySpecificChanges", function () { return $383b93bc6b490f8f$export$c6abce4536815011; });
$parcel$export($383b93bc6b490f8f$exports, "getCustomDropdownSources", function () { return $383b93bc6b490f8f$export$10e67feb6a48460e; });
$parcel$export($383b93bc6b490f8f$exports, "getCustomOnChange", function () { return $383b93bc6b490f8f$export$4d7d49026c1d0e29; });
$parcel$export($383b93bc6b490f8f$exports, "outputTransformCategoryTransactions", function () { return $383b93bc6b490f8f$export$39b64bc498225d58; });
$parcel$export($383b93bc6b490f8f$exports, "additionalValidations", function () { return $383b93bc6b490f8f$export$9f17ee6c2a47ab8b; });
$parcel$export($383b93bc6b490f8f$exports, "postCategoryItems", function () { return $383b93bc6b490f8f$export$37bc17007772d2e3; });
$parcel$export($383b93bc6b490f8f$exports, "handleSync", function () { return $383b93bc6b490f8f$export$3195655de7cb0f02; });
$parcel$export($383b93bc6b490f8f$exports, "getSortingCallback", function () { return $383b93bc6b490f8f$export$5c6817526d88585b; });
/* eslint-disable no-unsafe-optional-chaining */ // CATEGORY MODULE FOR STOCKS / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $383b93bc6b490f8f$var$debugLevel = 0;
function $383b93bc6b490f8f$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function stocksOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            displaySymbol: transaction.displaySymbol,
            displayName: transaction.displayName,
            transactionType: transaction.transactionType,
            split: transaction.splitRatioOld && transaction.splitRatioNew ? `${transaction.splitRatioOld}:${transaction.splitRatioNew}` : "",
            transactionAmount: transaction.transactionAmount || "",
            transactionOriginalPrice: transaction.transactionOriginalPrice || "",
            transactionCurrency: transaction.transactionCurrency || "",
            rebasedOriginalValue: transaction.rebasedOriginalPrice * transaction.transactionAmount || "",
            rebasedValue: transaction.rebasedPrice * transaction.transactionAmount || "",
            rebasedAmount: transaction.rebasedAmount || "",
            rebasedOriginalPrice: transaction.rebasedOriginalPrice || "",
            id: transaction.id,
            assetId: transaction.assetId,
            providerAssetId: transaction.providerAssetId || ""
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
const $383b93bc6b490f8f$var$depositTransactionLabels = (0, $a368196802fe263c$export$c3326d1eadff13bd).map((l)=>l.split("-")[1]);
const $383b93bc6b490f8f$var$depositIncomeTransactionLabels = (0, $a368196802fe263c$export$c58f7ddceaf8469f).map((l)=>l.split("-")[1]);
const $383b93bc6b490f8f$var$depositExpenseTransactionLabels = (0, $a368196802fe263c$export$47220dfe2b0dcc85).map((l)=>l.split("-")[1]);
function $383b93bc6b490f8f$export$c6abce4536815011(transactions, account = null, displayedComponent = "table", quotes = []) {
    var _state_user_profile_settings, _state_user_profile, _state_user;
    // <- receives some parameters and
    // GRID is easy
    if (displayedComponent === "grid") return transactions.map($383b93bc6b490f8f$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const baseCurrency = ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    // if this is a TABLE, we need a more complex transformation
    // 'transactions' for table is a different object: it is the 'stocks.accountId' branch of completeAssetsView
    // described here: https://monestry.atlassian.net/l/cp/t1S1KbTF
    // in other words, an object with keys being accountIds and values being arrays of transactions belonging to that account + all related  deposit transactions sorted ascending by date
    return Object.keys(transactions).filter((assetId)=>assetId !== account.id) // remove the account-level transactions, which don't have any purchase transactions (which are in singleTransactions)
    .reduce((acc, assetId, idx, self1)=>{
        if ($383b93bc6b490f8f$var$debugLevel > 2) console.log("Overall incoming transactions object:", transactions, "self object in reduce:", self1);
        // for each assetId: [{ transactions }]
        // prepare deposit transactions for this assetId
        const depositTransactionsFromCAV = transactions[assetId].filter((x)=>$383b93bc6b490f8f$var$depositTransactionLabels.includes(x.rowType)).map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                payoutOrFeePerPiece: x.amount / x.positionOnDate
            }));
        if ($383b93bc6b490f8f$var$debugLevel > 2) console.log(`Input transaction object for the ${assetId}`, transactions[assetId]);
        // get a list of atomic transactions to show in the table
        const singleTransactions = transactions[assetId]// .filter((item) => item.rowType === 'purchase' && item.rebasedAmount + item.rebasedAmountSold > 0) // leave only purchases which have not been sold yet
        // 250913 ↑↑ this has not been changed on 241213 somehow, but it should be item.quantityOpen > 0 following that change's logic
        .filter((item)=>item.rowType === "purchase" && item.quantityOpen > 0) // leave only purchases which have not been sold yet
        .map((item)=>{
            var _quotes_item_assetId_current, _quotes_item_assetId, _quotes_item_assetId_current1, _quotes_item_assetId1, _item_tags;
            const openPositionSize = item.quantityOpen; // 241213 getting rid of rebasedAmountSold calculated in the backend and using quantityOpen instead (calculated locally)
            // const openPositionSize = item.rebasedAmount + item.rebasedAmountSold;
            const splitRatio = item.quantity / item.transactionAmount; // --> this many new shares for one old one, like 4/1
            const openOriginalPositionSize = item.quantityOpen / splitRatio;
            // const openOriginalPositionSize = item.transactionAmount + item.transactionAmountSold;
            const purchaseValue = openPositionSize * item.rebasedPrice; // rebasedPrice is in base currency
            // this assumes the currency on quote is the same as the currency on the transaction, but we request the quote in the same currency as the transaction
            const currentQuote = (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : (_quotes_item_assetId_current = _quotes_item_assetId.current) === null || _quotes_item_assetId_current === void 0 ? void 0 : _quotes_item_assetId_current.quote;
            const currentQuoteBaseCurrency = (_quotes_item_assetId1 = quotes[item.assetId]) === null || _quotes_item_assetId1 === void 0 ? void 0 : (_quotes_item_assetId_current1 = _quotes_item_assetId1.current) === null || _quotes_item_assetId_current1 === void 0 ? void 0 : _quotes_item_assetId_current1.quoteBaseCurrency;
            const currentValue = openPositionSize * currentQuote;
            const currentValueBaseCurrency = openPositionSize * currentQuoteBaseCurrency;
            const dividendsPerPieceSincePurchase = depositTransactionsFromCAV // this is in base currency
            .filter((x)=>x.date >= item.date && $383b93bc6b490f8f$var$depositIncomeTransactionLabels.includes(x.rowType)).reduce((acc2, curr2)=>acc2 + curr2.payoutOrFeePerPiece, 0);
            const dividendsSincePurchase = openPositionSize * dividendsPerPieceSincePurchase;
            const thisTransactionFees = depositTransactionsFromCAV // this is in base currency
            // has a linkedTransaction which has the same id as the current item
            .filter((x)=>$383b93bc6b490f8f$var$depositExpenseTransactionLabels.includes(x.rowType) && x.linkedTransactions.findIndex((lt)=>lt.id === item.id) > -1).reduce((acc2, curr2)=>acc2 + curr2.amount, 0);
            const accountCostShareSincePurchase = ((transactions[account.id] || [] // account-level cost are not linked to any assetId
            ).filter((x)=>x.date >= item.date && x.rowType === "costs").reduce((acc2, curr2)=>acc2 + curr2.amount, 0) || 0) / Object.keys(transactions).length; // divide equally per assetId within one account
            const fees = thisTransactionFees + accountCostShareSincePurchase;
            return (0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, item), {
                currency: baseCurrency,
                openPositionSize: openPositionSize,
                purchaseValue: purchaseValue,
                currentValue: currentValue,
                currentValueBaseCurrency: currentValueBaseCurrency,
                currentQuote: currentQuote,
                currentQuoteBaseCurrency: currentQuoteBaseCurrency,
                dividendsSincePurchase: dividendsSincePurchase,
                fees: fees
            }), item.rebasedAmount !== item.transactionAmount && {
                isPreSplitTransaction: openOriginalPositionSize
            }, ((_item_tags = item.tags) === null || _item_tags === void 0 ? void 0 : _item_tags.flag) && {
                itemHasFlag: item.tags.flag
            }), {
                roi: (currentValueBaseCurrency + dividendsSincePurchase + fees - purchaseValue) / purchaseValue,
                roiAnnual: ((currentValueBaseCurrency + dividendsSincePurchase + fees) / purchaseValue) ** (1 / ((new Date().valueOf() - item.date) / 31536000000)) - 1,
                isSummaryRow: false,
                // we will display currentQuote using displayElement in tableLayout.js (needs to be preformatted, as displayElement only receives this field's value)
                displayQuoteTransactionCurrency: item.transactionCurrency !== baseCurrency ? currentQuote.toLocaleString("de", {
                    style: "currency",
                    currency: item.transactionCurrency,
                    maximumFractionDigits: 2
                }) : null,
                displayPriceTransactionCurrency: item.transactionCurrency !== baseCurrency ? item.transactionOriginalPrice.toLocaleString("de", {
                    style: "currency",
                    currency: item.transactionCurrency,
                    maximumFractionDigits: 2
                }) : null
            });
        });
        if ($383b93bc6b490f8f$var$debugLevel > 2) console.log("Calculated atomic transactions:", singleTransactions);
        // for each assetId in this account we need to calculate the summary row
        const thisAssetIdTransactions = singleTransactions.filter((st)=>st.assetId === assetId); // list of all summary transactions for this assetId
        if ($383b93bc6b490f8f$var$debugLevel > 2) console.log(`Basis for calculating summary transactions for asset ${assetId}`, thisAssetIdTransactions, singleTransactions);
        let summaryRow = null;
        let singleTransactionsWithParentRow = [];
        if (thisAssetIdTransactions.length > 0) {
            summaryRow = thisAssetIdTransactions.reduce((prev, curr)=>(0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    openPositionSize: (prev.openPositionSize || 0) + (curr.openPositionSize || 0),
                    purchaseValue: (prev.purchaseValue || 0) + curr.purchaseValue,
                    currentValueBaseCurrency: (prev.currentValueBaseCurrency || 0) + curr.currentValueBaseCurrency,
                    dividendsSincePurchase: (prev.dividendsSincePurchase || 0) + curr.dividendsSincePurchase,
                    fees: (prev.fees || 0) + curr.fees,
                    numeratorRoiAnnualWeighted: (prev.numeratorRoiAnnualWeighted || 0) + (curr.roiAnnual || 0) * (curr.quantityOpen || 0),
                    numeratorTransactionPrice: (prev.numeratorTransactionPrice || 0) + (curr.rebasedPrice || 0) * curr.openPositionSize
                }), curr.itemHasFlag && {
                    itemHasFlag: curr.itemHasFlag
                }), {
                date: 1,
                assetId: assetId,
                displaySymbol: thisAssetIdTransactions[0].displaySymbol,
                displayName: thisAssetIdTransactions[0].displayName,
                currentQuoteBaseCurrency: thisAssetIdTransactions[0].currentQuoteBaseCurrency
            });
            if ($383b93bc6b490f8f$var$debugLevel > 2) console.log("summaryRow", summaryRow);
            summaryRow = (0, $2qxEV._)((0, $9tqwB._)({}, summaryRow), {
                currency: baseCurrency,
                transactionPrice: summaryRow.numeratorTransactionPrice / summaryRow.openPositionSize,
                roi: (summaryRow.currentValueBaseCurrency + summaryRow.dividendsSincePurchase + summaryRow.fees - summaryRow.purchaseValue) / summaryRow.purchaseValue,
                roiAnnual: summaryRow.numeratorRoiAnnualWeighted / summaryRow.openPositionSize,
                isSummaryRow: true
            });
            // each atomic row has a reference to the summary row
            // this is needed to sort the table correctly (see getSortingCallback below)
            singleTransactionsWithParentRow = singleTransactions.map((st)=>(0, $2qxEV._)((0, $9tqwB._)({}, st), {
                    parentSummaryRow: summaryRow
                }));
        }
        return [
            ...acc,
            ...singleTransactionsWithParentRow,
            summaryRow
        ].filter((x)=>!!x); // filter out nulls
    }, []);
}
function $383b93bc6b490f8f$export$10e67feb6a48460e() {
    return {
        displaySymbol: Object.entries((0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displayNameByDisplaySymbol).map(([key, value])=>({
                id: key,
                name: value
            }))
    };
}
function $383b93bc6b490f8f$export$4d7d49026c1d0e29() {
    return function getCustomOnChangeInner(instance, cell, x, y, value) {
        // if current column is 'displaySymbol'
        if (instance && instance.jspreadsheet.options.columns[x].name === "displaySymbol") {
            // find a column 'displayName' and get the displayName based on displaySymbol's 'value' from stocksMetadata
            const displayNameColumnIndex = instance.jspreadsheet.options.columns.findIndex((column)=>column.name === "displayName");
            if (displayNameColumnIndex !== -1) {
                const displayName = (0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displayNameByDisplaySymbol[value] || "";
                instance.jspreadsheet.setValueFromCoords(displayNameColumnIndex, y, displayName, false);
            }
        }
    };
}
function $383b93bc6b490f8f$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        var _item_tag, _item_tag_previousVersion, _item_tag1;
        // if the transaction has a tag.flag, compare previousVersion.date to date; if it has changed, remove the tag.flag
        // tag.flag is given in stocks.getData (API) to transactions for which we don't have all the data from provider
        // previousVersion is the input version of this transaction object, appended by the caller of this function
        const tags = item.tags || null;
        if (((_item_tag = item.tag) === null || _item_tag === void 0 ? void 0 : _item_tag.flag) && ((_item_tag1 = item.tag) === null || _item_tag1 === void 0 ? void 0 : (_item_tag_previousVersion = _item_tag1.previousVersion) === null || _item_tag_previousVersion === void 0 ? void 0 : _item_tag_previousVersion.date) !== item.date) delete tags.flag;
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            transactionAmount: item.transactionType === "sale" && item.transactionAmount > 0 ? item.transactionAmount * -1 : item.transactionAmount,
            amount: item.transactionType === "sale" && item.amount > 0 ? item.amount * -1 : item.amount,
            splitRatioOld: item.transactionType === "split" ? item.split.split(":")[0] : null,
            splitRatioNew: item.transactionType === "split" ? item.split.split(":")[1] : null,
            // user enters displaySymbol, so we need to supply providerAssetId and figi
            // (do it always it handle the case when user changes the displaySymbol, so the old providerAssetId and figi must be overwritten, ggf. with a null)
            providerAssetId: (0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).providerAssetIdByDisplaySymbol[item.displaySymbol] || null,
            figi: (0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).assetIdByDisplaySymbol[item.displaySymbol] || null,
            tags: tags
        });
    };
}
function $383b93bc6b490f8f$export$9f17ee6c2a47ab8b(transactions) {
    // make sure we don't sell stocks that we do not have in this account
    // i.e. if
    // make sure we are not selling more than we own
    // take validatedData and calculate cumulative amount of stocks owned
    // sort by date ascending, then by transactionType ascending (so that purchase on the same day comes before sale)
    console.log("additionalValidations", transactions);
    let amountBySymbol = 0;
    let skipToNextSymbol = false;
    const returnErrors = [];
    const dataForStocksValidation = (transactions || []).map((item, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
            originalRowNumber: idx,
            symbol: item.figi || item.displaySymbol
        })) // add original row numbers so that we know where to show an error message if there is one
    // ^^ figi || displaySymbol handles the case where there are two new different symbols, but none of them has a figi yet - they have to be treated as different symbols and their figis are both null
    .sort((a, b)=>{
        // sort by symbol ascending
        if (a.symbol < b.symbol) return -1;
        if (a.symbol > b.symbol) return 1;
        // if symbols are equal, sort by date ascending
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        // if dates are equal, sort by transactionType ascending
        if (a.transactionType < b.transactionType) return -1;
        if (a.transactionType > b.transactionType) return 1;
        // if all fields are equal, return 0
        return 0;
    });
    for(let idx = 0; idx < dataForStocksValidation.length; idx += 1){
        const prev = dataForStocksValidation[idx - 1];
        const curr = dataForStocksValidation[idx];
        // go through the sorted array top to bottom (it's sorted by symbol)
        // if curr has a different symbol than prev, reset amount
        if (idx > 0 && prev.symbol !== curr.symbol) {
            skipToNextSymbol = false;
            amountBySymbol = 0;
        }
        // if previous iteration set this flag to true, it will skip to the next transaction
        // until a new symbol is introduced
        if (skipToNextSymbol === false) {
            // split transaction can be still in the 1:4 format, so we need to use that (also handle errors here)
            if (curr.transactionType === "split") // multiply old split ratio by new one
            amountBySymbol *= curr.splitRatioNew / curr.splitRatioOld;
            // add this iteration's amount to the amount for the current symbol
            amountBySymbol += curr.transactionAmount || 0;
            // if prev becomes negative, signal a validation error and add error to validationErrors
            // cannot break loop, because there will be more symbols (potentially)
            if (amountBySymbol < 0) {
                console.error("The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.");
                returnErrors.push({
                    message: "The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.",
                    path: `[${curr.originalRowNumber}].transactionAmount`
                });
                // we want this to only show up at the first offending transaction
                // to let user sort it out and not confuse them with many errors
                // the checking of remaining transactions for the same symbol is skipped
                skipToNextSymbol = true;
            }
        }
    }
    return returnErrors;
}
function $383b93bc6b490f8f$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "stocks",
        accountId: account.id
    });
}
function $383b93bc6b490f8f$export$3195655de7cb0f02(accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: "stocks",
        accountId: accountId
    }));
}
function $383b93bc6b490f8f$var$compare(a, b, propertyName, asc = true) {
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}
function $383b93bc6b490f8f$export$5c6817526d88585b(tableState) {
    return function sortingCallback(a, b) {
        // reverse sorting order if date is selected a
        // localeCompare compares strings according to rules of the current locale, returns -1, 0, 1
        try {
            // this implements sorting by assetId's properties
            // applyCategorySpecificChanges has added a parentSummaryRow to each transaction
            // first sort by sortBy of the parentSummaryRow (or by itself if it IS a summary row)
            // then, in case the above is equal, sort by assetId (to sort rows into assetId-based groups)
            // then put summary rows first within the group and sort by sortBy within the group
            return $383b93bc6b490f8f$var$compare(a.parentSummaryRow || a, b.parentSummaryRow || b, tableState.sortBy, tableState.sortDirectionAsc) || $383b93bc6b490f8f$var$compare(a.parentSummaryRow || a, b.parentSummaryRow || b, "assetId", tableState.sortDirectionAsc) || !!b.isSummaryRow - !!a.isSummaryRow || $383b93bc6b490f8f$var$compare(a, b, tableState.sortBy, tableState.sortDirectionAsc);
        } catch (e) {
            if ($383b93bc6b490f8f$var$debugLevel > 2) console.log("error in getSortingCallback", e, "tableState", tableState, "a", a, "b", b);
            return 0;
        }
    };
}


function $e3855dc10a8e6ec2$var$TableLayoutStocksWrapper({ isViewer: isViewer }) {
    // this does not do anything, just to maintain compatibility with AccountDetailsTable's way of calling TableLayoutStocks
    const quotes = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.reportData.quotes) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$443f4a6ebd922e0a));
    // console.log('quotes', JSON.stringify(quotes)); // only quotes for today and for the assets in the report are passed
    console.log("quotes", JSON.stringify(quotes, null, 2)); // only quotes for today and for the assets in the report are passed
    // applyCategorySpecificChanges expects completeAssetView as input (completeAssetView[category][accountId]), which is divided up by category and account first
    // to run this report, all positions are moved under a single account
    const selectCompleteAssetViewAllAccounts = (0, $5c22629b42831e80$export$595d22ed68ca2841)((0, $3679aa7475d9bd44$export$70d960c2428e363b), (state)=>{
        var _state_viewer_reportData, _state_viewer;
        return (_state_viewer = state.viewer) === null || _state_viewer === void 0 ? void 0 : (_state_viewer_reportData = _state_viewer.reportData) === null || _state_viewer_reportData === void 0 ? void 0 : _state_viewer_reportData.completeAssetView;
    }, (regularCAV, isViewerCAV)=>{
        // determine which CAV to use (isViewer is only passed if this is rendered as part of SharedReportViewer)
        const cav = isViewer ? isViewerCAV : regularCAV;
        if (!cav.stocks) return []; // do nothing if no stocks found
        const cum = {};
        Object.entries(cav.stocks).forEach(([accountId, accountObject])=>{
            Object.entries(accountObject).forEach(([assetId, assetObject])=>{
                // handle account-level costs
                if (assetId === accountId) {
                    if (!cum.costs) cum.costs = assetObject;
                    else cum.costs = [
                        ...cum.costs,
                        ...assetObject
                    ].sort((a, b)=>a.date - b.date);
                    return;
                }
                if (!cum[assetId]) cum[assetId] = assetObject;
                else cum[assetId] = [
                    ...cum[assetId],
                    ...assetObject
                ].sort((a, b)=>a.date - b.date);
            });
        });
        return cum;
    });
    const stocksAssetViewAllAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)(selectCompleteAssetViewAllAccounts);
    const tableState = {
        sortBy: "date",
        sortDirectionAsc: true,
        colWidths: {
            date: 100,
            otherParty: 150,
            description: 450,
            amount: 100
        },
        tableHeight: 300
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "h-fit",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec5b0fbdb8c7bace$export$2e2bcd8739ae039), {
            // we have moved all account-level costs under 'costs', so now we pretend that 'costs' is an accountId
            // second argument is expected to be the full account object
            // getSortingCallback makes the summary rows appear above the details rows
            data: (0, $383b93bc6b490f8f$export$c6abce4536815011)(stocksAssetViewAllAccounts, {
                id: "costs"
            }, "table", quotes).sort((0, $383b93bc6b490f8f$export$5c6817526d88585b)(tableState)),
            tableLayout: (0, $ad7a88cad4bc7af4$export$2e2bcd8739ae039)("stocksPositionsReport", "transactions"),
            tableState: tableState,
            setTableState: ()=>{}
        })
    });
}
$e3855dc10a8e6ec2$var$TableLayoutStocksWrapper.propTypes = {
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$e3855dc10a8e6ec2$var$TableLayoutStocksWrapper.defaultProps = {
    isViewer: false
};
var $e3855dc10a8e6ec2$export$2e2bcd8739ae039 = {
    "Stock Positions": $e3855dc10a8e6ec2$var$TableLayoutStocksWrapper
};



parcelRequire("7fPBF");
/* eslint-disable no-unsafe-optional-chaining */ /* eslint-disable max-len */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




// dayjs.extend(utc);
const $3ba211f10d10cd91$var$options = {
    style: "currency",
    currency: "EUR"
};
function $3ba211f10d10cd91$var$isOrphanedTransferTransaction(item) {
    var _item_tags;
    if (item.label !== "investment-transfer") return false;
    const linkedTransactions = Array.isArray((_item_tags = item.tags) === null || _item_tags === void 0 ? void 0 : _item_tags.linkedTransactions) ? item.tags.linkedTransactions : [];
    return linkedTransactions.filter((t)=>{
        var _t_tags;
        return (t === null || t === void 0 ? void 0 : (_t_tags = t.tags) === null || _t_tags === void 0 ? void 0 : _t_tags.linkType) === "transfer";
    }).length === 0;
}
function $3ba211f10d10cd91$var$Table({ data: data, footnote: footnote, label: label, selector: selector, showInternalNames: showInternalNames }) {
    // this is a dumb component, it just renders the data into a table
    // first row contains headers
    if (!data) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "col-span-6 text-right",
        children: open ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-2 gap-6 text-right pb-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "justify-self-end",
                            children: label
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setOpen(!open),
                            className: "justify-self-start border rounded-md border-gray-300 py-1.5 px-2.5 bg-white hover:bg-gray-50 text-gray-500 text-sm",
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "shadow ring-1 ring-black ring-opacity-5 md:rounded-lg max-h-96 overflow-auto",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("table", {
                        className: "min-w-full divide-y divide-gray-300",
                        children: data.map((row, idx)=>idx === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                                children: Object.keys(row).map((cell)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6",
                                        children: row[cell] > 999999999999 ? new Date(row[cell]).toLocaleDateString("de", {
                                            timeZone: "UTC"
                                        }) : row[cell]
                                    }, row[cell]))
                            }, row.id || idx) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                                children: Object.keys(row).map((cell)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6",
                                        children: row[cell] > 999999999999 ? new Date(row[cell]).toLocaleDateString("de", {
                                            timeZone: "UTC"
                                        }) : row[cell]
                                    }))
                            }))
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "mt-2 mx-1 text-gray-400 italic text-sm text-left",
                    children: footnote
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "grid grid-cols-2 gap-6 justify-items-end items-center text-right text-gray-500",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: label
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: selector
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    onClick: ()=>setOpen(!open),
                    className: "justify-self-start border rounded-md border-gray-300 py-1.5 px-1.5 bg-white hover:bg-gray-50",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e130f1475b5281eb$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 text-gray-400",
                        "aria-hidden": "true"
                    })
                })
            ]
        })
    });
}
$3ba211f10d10cd91$var$Table.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]).isRequired,
    footnote: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    showInternalNames: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$3ba211f10d10cd91$var$Table.defaultProps = {
    footnote: "",
    label: "",
    selector: "",
    showInternalNames: false
};
function $3ba211f10d10cd91$export$2e2bcd8739ae039({ setKpiReportVisible: setKpiReportVisible }) {
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    // Access the query parameters using the get method
    const showInternalNames = queryParams.get("internalNames");
    const selectGlobalAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$8c577782bb016c47);
    function getAccountNameById(accountId) {
        var _selectGlobalAccounts_find;
        return (_selectGlobalAccounts_find = selectGlobalAccounts.find((account)=>account.id === accountId)) === null || _selectGlobalAccounts_find === void 0 ? void 0 : _selectGlobalAccounts_find.name;
    }
    const dashboardMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    const { baseline: baseline, referenceBaseline: referenceBaseline } = (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce);
    const sliderDate = new Date((0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.baseDate.valueOf()));
    const quotes = (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$443f4a6ebd922e0a);
    function handleButton() {
        if (dashboardMode === "dashboard") dispatch({
            type: "simulation/setDashboardMode",
            payload: {
                dashboardMode: "projects"
            }
        });
        else dispatch({
            type: "simulation/setDashboardMode",
            payload: {
                dashboardMode: "dashboard"
            }
        });
    }
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    function handleClose() {
        navigate("/app/", {
            replace: false
        });
    }
    const formatHeader2 = "text-right font-bold text-2xl";
    const selectAssetBalancesArray = (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464);
    console.log("selectAssetBalancesArray", selectAssetBalancesArray);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white -mt-6 rounded-md max-w-3xl mx-auto px-4 sm:px-6 py-6 lg:max-w-[80rem] xl:h-[85vh] lg:px-8 text-gray-900 overflow-y-scroll",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "mt-4 grid grid-cols-12 gap-6",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                    className: "font-bold text-3xl col-span-8 -mb-4",
                    children: "Key Performance Indicators - Detailed Report"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-12 font-medium text-base",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `Baseline date is: ${new Date(baseline).toLocaleDateString("de")}`
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `Reference baseline date is: ${new Date((0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$80e72cf626efa9e8)).toLocaleDateString("de", {
                                timeZone: "UTC"
                            }, {
                                timeZone: "UTC"
                            })}`
                        }),
                        dashboardMode === "projects" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: `Slider date is ${sliderDate.toLocaleDateString("de", {
                                timeZone: "UTC"
                            }, {
                                timeZone: "UTC"
                            })}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: formatHeader2,
                            children: "Current net worth"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "currentNetWorth2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$611bdd34eb5c8a52).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "text-right font-bold text-2xl",
                            children: "Baseline net worth"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "baselineNetWorth"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "font-bold text-2xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$be3d5997140286cf).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl",
                            children: "Deposits total"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, deposits only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "deposits").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Deposits total"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, deposits only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "deposits").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Account balances",
                    selector: "assetBalancesArray (current, deposits only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "deposits").map((asset)=>({
                            symbol: asset.displayName,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Account balances (at baseline)",
                    selector: "assetBalancesArray (baseline, deposits only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "deposits").map((asset)=>({
                            symbol: asset.displayName,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Labelled deposit transactions ",
                    selector: "depositTransactions (current, with label)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Date",
                            col3: "Label",
                            col4: "Id",
                            col5: "Value"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$3c400324181e2c4d).filter((item)=>item.label && item.date >= baseline).map((item)=>({
                            accountName: getAccountNameById(item.accountId),
                            date: item.date,
                            label: item.label.split("-")[1],
                            id: item.id,
                            value: (item.quantity * item.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Orphaned transfer transactions",
                    selector: "depositTransactions (current, with label)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Date",
                            col3: "Label",
                            col4: "Id",
                            col5: "Value"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$3c400324181e2c4d).filter((item)=>item.label && item.date >= baseline).filter((item)=>$3ba211f10d10cd91$var$isOrphanedTransferTransaction(item)).map((item)=>({
                            accountName: getAccountNameById(item.accountId),
                            date: item.date,
                            label: item.label.split("-")[1],
                            id: item.id,
                            value: (item.quantity * item.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Orphaned transfer transactions",
                    selector: "depositTransactions (baseline, with label)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Date",
                            col3: "Label",
                            col4: "Id",
                            col5: "Value"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$3c400324181e2c4d).filter((item)=>item.label && item.date >= referenceBaseline && item.date < baseline).filter((item)=>$3ba211f10d10cd91$var$isOrphanedTransferTransaction(item)).map((item)=>({
                            accountName: getAccountNameById(item.accountId),
                            date: item.date,
                            label: item.label.split("-")[1],
                            id: item.id,
                            value: (item.quantity * item.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Stocks total"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, stocks only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "stocks").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Stocks total"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, stocks only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "stocks").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Currently held securities",
                    selector: "assetBalancesArray (current, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Symbol",
                            col2: "Quantity",
                            col3: "Unit price (base currency)",
                            col4: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "stocks").map((asset)=>({
                            symbol: asset.assetId,
                            quantity: asset.current.quantity,
                            upbc: asset.current.quoteBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Securities held on baseline date",
                    selector: "assetBalancesArray (baseline, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Symbol",
                            col2: "Quantity",
                            col3: "Unit price (base currency)",
                            col4: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "stocks").map((asset)=>({
                            symbol: asset.assetId,
                            quantity: asset.baseline.quantity,
                            upbc: asset.baseline.quoteBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current securities quotes",
                    selector: "assetBalancesArray (current, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "stocks").map((asset)=>({
                            symbol: asset.assetId,
                            quote: asset.current.quoteBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: asset.current.quoteTransactionCurrency.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Securities quotes on baseline date",
                    selector: "assetBalancesArray (baseline, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "stocks").map((asset)=>({
                            symbol: asset.assetId,
                            quote: asset.baseline.quoteBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: asset.baseline.quoteTransactionCurrency.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Real Estate - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, real estate only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "realEstate").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Real Estate - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, real estate only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "realEstate").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Real Estate value",
                    selector: "assetBalances (current, real estate only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "realEstate").map((asset)=>({
                            symbol: asset.displayName,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Real Estate value on baseline date",
                    selector: "assetBalances (baseline, real estate only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "realEstate").map((asset)=>({
                            symbol: asset.displayName,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Loans - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, loans only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "loans").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Loans - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, loans only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "loans").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Pension - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, pension only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "pension").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Pension - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, pension only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "pension").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Pension value",
                    selector: "assetBalances (current, pension only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "pension").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Pension value on baseline date",
                    selector: "assetBalances (baseline, pension only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Account",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "pension").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Metals - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, metals only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "metals").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Metals - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, metals only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "metals").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Metals value",
                    selector: "assetBalances (current, metals only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "metals").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Metals value on baseline date",
                    selector: "assetBalances (baseline, metals only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "metals").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current metals quotes",
                    selector: "assetBalancesArray (current, metals only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "metals").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.current.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.current.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Metals quotes on baseline date",
                    selector: "assetBalancesArray (baseline, metals only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "metals").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.baseline.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.baseline.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Objects of value - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, objects of value only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "objectsOfValue").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Objects of value - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, objects of value only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "objectsOfValue").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Objects of value",
                    selector: "assetBalances (current, objects of value only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "objectsOfValue").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Objects of value on baseline date",
                    selector: "assetBalances (baseline, objects of value only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "objectsOfValue").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current objects of value quotes",
                    selector: "assetBalancesArray (current, objects of value only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "objectsOfValue").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.current.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.current.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Objects of value quotes on baseline date",
                    selector: "assetBalancesArray (baseline, objects of value only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "objectsOfValue").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.baseline.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.baseline.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Crypto - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, crypto only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "crypto").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Crypto - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, crypto only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "crypto").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Crypto value",
                    selector: "assetBalances (current, crypto only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "crypto").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Crypto value on baseline date",
                    selector: "assetBalances (baseline, crypto only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "crypto").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current crypto quotes",
                    selector: "assetBalancesArray (current, crypto only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "crypto").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.current.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.current.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Crypto quotes on baseline date",
                    selector: "assetBalancesArray (baseline, crypto only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "crypto").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.baseline.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.baseline.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Unlisted shares - current value"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (current, unlisted shares only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "unlistedShares").reduce((acc, curr)=>acc + curr.current.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Unlisted shares - value on baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalancesArray (baseline, unlisted shares only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: selectAssetBalancesArray.filter((x)=>x.category === "unlistedShares").reduce((acc, curr)=>acc + curr.baseline.valueBaseCurrency, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Unlisted shares value",
                    selector: "assetBalances (current, unlisted shares only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "unlistedShares").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.current.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Unlisted shares value on baseline date",
                    selector: "assetBalances (baseline, unlisted shares only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Asset",
                            col2: "Value (base currency)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "unlistedShares").map((asset)=>({
                            symbol: asset.displayName || asset.assetId,
                            value: asset.baseline.valueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current unlisted shares quotes",
                    selector: "assetBalancesArray (current, unlisted shares only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "unlistedShares").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.current.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.current.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Unlisted shares quotes on baseline date",
                    selector: "assetBalancesArray (baseline, unlisted shares only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Symbol",
                            col2: "Quote",
                            col3: "Quote (original)"
                        }
                    ].concat(selectAssetBalancesArray.filter((x)=>x.category === "unlistedShares").map((asset)=>({
                            symbol: asset.displaySymbol || asset.assetId,
                            quote: (asset.baseline.quoteBaseCurrency || 0).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            quoteOriginal: (asset.baseline.quoteTransactionCurrency || 0).toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Deposit inflows"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg",
                            children: "since baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "inflowsCurrent"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$61408e9de6c25330).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Deposit inflows"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg leading-6",
                            children: "between beginning of reference period and baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "inflowsBaseline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$1882d03801ff41ff).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Asset transactions without linked deposit transactions ",
                    selector: "allTransactions (current)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Category",
                            col2: "Account",
                            col3: "Date",
                            col4: "AssetId",
                            col5: "Value"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$1b272b322aef6de0).map((item)=>({
                            category: item.category,
                            accountName: getAccountNameById(item.accountId),
                            // date: dayjs.utc(item.date).format('DD.MM.YYYY'),
                            date: item.date,
                            assetId: item.assetId,
                            value: (item.quantity * item.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "col-span-6"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Deposit outflows"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg",
                            children: "since baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "outflowsCurrent"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$57f29db9c40dbad7).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Deposit outflows"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg leading-6",
                            children: "between beginning of reference period and baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "outflowsBaseline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$43c37cdbf008db07).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Income from capital"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg",
                            children: "since baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "incomeFromCapitalCurrent"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$f63326aa9088648b).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Income from capital"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg leading-6",
                            children: "between beginning of reference period and baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "incomeFromCapitalBaseline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$16297c4826a11a44).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "text-right col-span-3",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl",
                            children: "Interest, dividends, costs and fees"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "incomeFromCapitalPayoutsAndFeesCurrent"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$f19fca8543b3ca7c).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "text-right col-span-3",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl",
                            children: "Interest, dividends, costs and fees"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "incomeFromCapitalPayoutsAndFeesBaseline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$90f1014fd5819cb6).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Interest, dividends, costs and fees",
                    selector: "depositTransactions (current)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Date",
                            col2: "Account",
                            col3: "Label",
                            col4: "Amount"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$a8a56b40f5a06885).filter((curr)=>(0, $a368196802fe263c$export$c3326d1eadff13bd).includes(curr.label) && curr.date >= baseline).map((item)=>({
                            date: item.date,
                            accountName: getAccountNameById(item.accountId),
                            label: item.label,
                            amount: item.quantity
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Interest, dividends, costs and fees",
                    selector: "depositTransactions (baseline)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col1: "Date",
                            col2: "Account",
                            col3: "Label",
                            col4: "Amount"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$a8a56b40f5a06885).filter((curr)=>(0, $a368196802fe263c$export$c3326d1eadff13bd).includes(curr.label) && curr.date >= referenceBaseline && curr.date < baseline).map((item)=>({
                            date: item.date,
                            accountName: getAccountNameById(item.accountId),
                            label: item.label,
                            amount: item.quantity
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "text-right col-span-3",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Income / loss from sold assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "incomeFromCapitalSaleTransactionCurrent"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$8bf37f4689ad817b).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "text-right col-span-3",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Income / loss from sold assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "incomeFromCapitalSaleTransactionsBaseline"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$c6f7c16e7cb3dcee).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Asset sale transactions",
                    selector: "assetBalances (current)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Account",
                            col1: "Date",
                            col2: "Category",
                            col3: "Symbol",
                            col4: "Amount",
                            col5: "Price (base currency)",
                            col6: "Value",
                            col7: "Linked purchase transactions (FIFO)"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$cb9c32c395459b9b).assetSaleTransactions.filter((item)=>item.transactionType === "sale" && item.date >= baseline).map((item)=>({
                            account: getAccountNameById(item.accountId),
                            date: item.date,
                            category: item.category,
                            assetId: item.assetId,
                            quantity: item.quantity,
                            price: item.upbc.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            value: (item.quantity * item.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            linkedTransactions: item.linkedTransactions.filter((t)=>t.tags.type === "purchase").sort((a, b)=>a.tags.date - b.tags.date).map((lt)=>{
                                var _quotes_item_assetId;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        new Date(lt.tags.date).toLocaleDateString("de", {
                                            timeZone: "UTC"
                                        }),
                                        " | ",
                                        lt.tags.quantity,
                                        " | ",
                                        quotes[item.assetId] && (lt.tags.date < baseline ? (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : _quotes_item_assetId.baseline.quoteBaseCurrency : lt.tags.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                                    ]
                                });
                            })
                        }))),
                    footnote: "Baseline is your net worth on a past date. One of its components are the Asset Value Changes which are unrealised gains/losses as of the baseline date. Income from Capital uses the price on baseline date as purchase price, because the price changes before baseline date are already included in those Asset Value Changes. Read more in our blog."
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Asset sale transactions after reference period start until baseline date",
                    selector: "assetBalances (baseline)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Account",
                            col1: "Date",
                            col2: "Category",
                            col3: "Symbol",
                            col4: "Amount",
                            col5: "Price (base currency)",
                            col6: "Value",
                            col7: "Linked purchase transactions (FIFO)"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$cb9c32c395459b9b).assetSaleTransactions.filter((item)=>item.transactionType === "sale" && item.date < baseline && item.date >= referenceBaseline).map((item)=>({
                            account: getAccountNameById(item.accountId),
                            date: item.date,
                            category: item.category,
                            assetId: item.assetId,
                            quantity: item.quantity,
                            price: item.upbc.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            value: (item.quantity * item.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options),
                            linkedTransactions: item.linkedTransactions.filter((t)=>t.tags.type === "purchase").sort((a, b)=>a.tags.date - b.tags.date).map((lt)=>{
                                var _quotes_item_assetId;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        new Date(lt.tags.date).toLocaleDateString("de", {
                                            timeZone: "UTC"
                                        }),
                                        " | ",
                                        lt.tags.quantity,
                                        " | ",
                                        quotes[item.assetId] && (lt.tags.date < referenceBaseline ? (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : _quotes_item_assetId.referenceBaseline.quoteBaseCurrency : lt.tags.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                                    ]
                                });
                            })
                        }))),
                    footnote: "Baseline is your net worth on a past date. One of its components are the Asset Value Changes which are unrealised gains/losses as of the baseline date. Income from Capital uses the price on baseline date as purchase price, because the price changes before baseline date are already included in those Asset Value Changes. Read more in our blog."
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Assets Value Change"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg leading-6",
                            children: "since baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "currentAssetValueChange"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$de4ac74636de1fbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Assets Value Change"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-lg leading-6",
                            children: "between beginning of reference period and baseline date"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "baselineAssetValueChange"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$92fa9e056f78a7f9).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Deposits"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, deposits only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "deposits"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Deposits"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, deposits only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "deposits"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current deposit currency positions by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, deposits only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col: "Account name",
                            col0: "AssetId",
                            col1: "Value in original currency",
                            col2: "Baseline (purchase) value",
                            col3: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "deposits"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            name: asset.displayName,
                            assetId: asset.assetId,
                            currentQuantity: asset.currentQuantity.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }),
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Deposit currency positions at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, deposits only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col: "Account name",
                            col0: "AssetId",
                            col1: "Value in original currency",
                            col2: "Reference (purchase) value",
                            col3: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "deposits"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            displayName: asset.displayName,
                            assetId: asset.assetId,
                            baselineQuantity: asset.baselineQuantity.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }),
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Securities"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, stocks only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "stocks"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Securities"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, stocks only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "stocks"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current stocks positions by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Account",
                            col1: "AssetId",
                            col2: "Current quantity",
                            col3: "Baseline (purchase) value",
                            col4: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "stocks"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            accountName: getAccountNameById(asset.accountId),
                            assetId: asset.assetId,
                            currentQuantity: asset.currentQuantity.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }),
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Stocks owned at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Account",
                            col1: "AssetId",
                            col2: "Baseline quantity",
                            col3: "Reference / purchase value",
                            col4: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "stocks"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            accountName: getAccountNameById(asset.accountId),
                            assetId: asset.assetId,
                            baselineQuantity: asset.baselineQuantity.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }),
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Stocks purchase / sale transactions",
                    selector: "assetBalances (current, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Account",
                            col1: "AssetId",
                            col2: "Quantity",
                            col3: "Date",
                            col4: "Transaction value"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$6d68928c2b6ce1a6).filter((b)=>b.category === "stocks" && b.date >= baseline).map((asset)=>({
                            accountName: getAccountNameById(asset.accountId),
                            assetId: asset.assetId,
                            date: asset.date,
                            quantity: asset.quantity.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }),
                            value: (asset.quantity * asset.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Stocks purchase / sale transactions",
                    selector: "assetBalances (baseline, stocks only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "Account",
                            col1: "AssetId",
                            col2: "Quantity",
                            col3: "Date",
                            col4: "Transaction value"
                        }
                    ].concat((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$6d68928c2b6ce1a6).filter((b)=>b.category === "stocks" && b.date >= referenceBaseline && b.date < baseline).map((asset)=>({
                            accountName: getAccountNameById(asset.accountId),
                            assetId: asset.assetId,
                            date: asset.date,
                            quantity: asset.quantity.toLocaleString("de", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }),
                            value: (asset.quantity * asset.upbc).toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Real estate assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, real estate only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "realEstate"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Real estate assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, real estate only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "realEstate"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current real estate holdings by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, real estate only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "realEstate"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Real estate owned at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, real estate only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "realEstate"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Loan assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, real estate only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "loans"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Loan assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, real estate only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "loans"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current loans by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, loans only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "loans"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Loans at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, loans only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "loans"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Pension assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, pension only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "pension"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Pension assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, pension only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "pension"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current pension by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, pension only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "pension"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Pension at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, pension only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "pension"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Metals assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, metals only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "metals"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Metals assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, metals only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "metals"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current metals holdings by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, metals only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "metals"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Metals at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, metals only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "metals"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Objects of value assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, objects of value only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "objectsOfValue"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Objects of value assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, objects of value only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "objectsOfValue"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current objects of value holdings by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, objects of value only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "objectsOfValue"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Objects of value at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, objects of value only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "objectsOfValue"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Crypto assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, crypto only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "crypto"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Crypto assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, crypto only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "crypto"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current crypto holdings by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, crypto only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "crypto"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Crypto at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, crypto only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "crypto"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl col-span-3",
                            children: "Unlisted shares assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (current, unlisted shares only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$832a0cdfc61d162b((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "unlistedShares"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-right font-medium text-xl  col-span-3",
                            children: "Unlisted shares assets"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetBalances (baseline, unlisted shares only)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "font-medium text-xl col-span-3",
                    children: $3679aa7475d9bd44$export$6ca0a863e30b8cb5((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((a)=>a.category === "unlistedShares"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).toLocaleString("de", $3ba211f10d10cd91$var$options)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Current unlisted shares holdings by assetId in baseline / purchase value vs current value",
                    selector: "assetBalances (current, unlisted shares only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Baseline (purchase) value",
                            col2: "Current value"
                        }
                    ].concat($3679aa7475d9bd44$export$23a65f40928a9521((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "unlistedShares"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            baselineValue: asset.baselineOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            currentValue: asset.currentValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($3ba211f10d10cd91$var$Table, {
                    label: "Unlisted shares at baseline by assetId in reference / purchase value vs baseline value",
                    selector: "assetBalances (baseline, unlisted shares only)",
                    showInternalNames: showInternalNames,
                    data: [
                        {
                            col0: "AssetId",
                            col1: "Reference (purchase) value",
                            col2: "Baseline value"
                        }
                    ].concat($3679aa7475d9bd44$export$182403c6092efd72((0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).filter((b)=>b.category === "unlistedShares"), (0, $51238fa605392ada$export$2105062e25df4afe)($93bb2798871a68d2$export$4bb039911f93bce)).map((asset)=>({
                            assetId: asset.assetId,
                            referenceValue: asset.referenceOrPurchaseValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options),
                            baselineValue: asset.baselineValueBaseCurrency.toLocaleString("de", $3ba211f10d10cd91$var$options)
                        })))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "col-span-6"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-8 col-span-3 text-right",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "font-bold text-2xl",
                            children: "Reference net worth"
                        }),
                        showInternalNames && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "text-sm text-gray-400",
                            children: "assetsBalances (reference)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "mt-8 font-bold text-2xl  col-span-3",
                    children: (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$7cd09fd23199c464).reduce((acc, curr)=>{
                        const { referenceBaseline: obj } = curr;
                        return acc + obj.valueBaseCurrency;
                    }, 0).toLocaleString("de", $3ba211f10d10cd91$var$options)
                })
            ]
        })
    });
}
$3ba211f10d10cd91$export$2e2bcd8739ae039.propTypes = {
    setKpiReportVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};


function $58e7a521217e432a$var$KPIReportRendererUnisel() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "h-fit",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ba211f10d10cd91$export$2e2bcd8739ae039), {})
    });
}
$58e7a521217e432a$var$KPIReportRendererUnisel.propTypes = {};
$58e7a521217e432a$var$KPIReportRendererUnisel.defaultProps = {};
var $58e7a521217e432a$export$2e2bcd8739ae039 = {
    "KPI Report Unisel": $58e7a521217e432a$var$KPIReportRendererUnisel
};


const $5958bfc3d629e828$var$renderers = (0, $9tqwB._)({}, (0, $1d1b0fee492045ec$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($85bd0a75814cec49$exports))), (0, $e3855dc10a8e6ec2$export$2e2bcd8739ae039), (0, $ef846b655465c549$export$2e2bcd8739ae039), (0, $58e7a521217e432a$export$2e2bcd8739ae039));
var $5958bfc3d629e828$export$2e2bcd8739ae039 = $5958bfc3d629e828$var$renderers;
function $5958bfc3d629e828$export$89ed09c46a8b3587(rendererName) {
    const genericSettings = {
        xAxisPrimary: {
            label: "Horizontal axis (X) - top-level categories",
            limit: 2
        },
        xAxisSecondary: {
            label: "Horizontal axis (X) - sub-categories",
            limit: 2
        },
        yAxisPrimary: {
            label: "Vertical axis (Y) - values",
            limit: 1
        }
    };
    if (rendererName === "Pie chart, multi-layers") return {
        xAxisPrimary: {
            label: "Innermost wheel",
            limit: 1
        },
        xAxisSecondary: {
            label: "Outer wheel",
            limit: 1
        },
        yAxisPrimary: {
            label: "Slice size",
            limit: 1
        }
    };
    return genericSettings;
}



// INFO: the responsive components of Nivo require a parent with a defined width and height
// they can be defined as '100%', but that not always work in the layout;
// in other words: the parent of this component must prepare a space for the chart
// and the chart will fill it out
// pass any changes to the default chart props with layoutOptions below
const $c452aa40845053fb$var$debugLevel = 0;
/**
 * Wrapper around the PivotTable component to display charts and reports.
 *
 * @param {string} reportId: string, the id of the report to display
 * @param {function} dataCallback: function, a function that will be applied to the data before displaying it (usually for limiting account and/or time range)
 * @param {function} (deprecated) filterCallback: deprecated, use dataCallback instead (better performance)
 * @param {object} layoutOptions: object, any changes to the default chart props (see below)
 *
 * @returns {React.Component} the chart
 *
 * Logic:
 * - initalise empty, with reportId, filterCallback and layoutOptions as props (props are memoized using memo on the bottom of this file)
 * - use selector to get the reportDef from the store, memoize that value (using createSelector)
 * - get data from selector based on reportDef, memoize that value
 * - display chart
 *
 * It can also be used in viewer mode. In viewer mode all those above do not have to happen, because the data is already in the store
 */ function $c452aa40845053fb$var$ChartWrapper({ reportId: reportId, filterCallback: filterCallback, dataCallback: dataCallback, layoutOptions: layoutOptions, isViewer: isViewer }) {
    var _dataObject_data;
    // const debugLevel = reportId === 'allAssetsSunburstxxxx' ? 0 : 3;
    if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "ChartWrapper rendered with reportId", reportId, "filterCallback", filterCallback, "layoutOptions", layoutOptions);
    const selectReports = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state === null || state === void 0 ? void 0 : state.reports, (r)=>r);
    const reports = (0, $51238fa605392ada$export$2105062e25df4afe)(selectReports, (0, $3b08520b369c7e04$export$2e2bcd8739ae039)); // it kept recalculating without shallowEqual
    const selectedReportDef = reports === null || reports === void 0 ? void 0 : reports.find((rep)=>rep.id === reportId);
    const [displayedReportDef, setDisplayedReportDef] = (0, $7fPBF.useState)(undefined); // which report is displayed in the current view
    const [dataObject, setDataObject] = (0, $7fPBF.useState)(undefined); // data object for the current view
    const [rerenderControl, setRerenderControl] = (0, $7fPBF.useState)(0); // change this to force a rerender (which will force getting the latest value from the selector --> see comments below)
    const isMounted = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "selectedReportDef changed, setting state of displayedReportDef to", selectedReportDef);
        setDisplayedReportDef(selectedReportDef);
        return ()=>{
            if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "cleanup of useEffect on selectedReportDef");
        };
    }, [
        selectedReportDef
    ]);
    // select dataSettings based on the reportDef (so that we only run one selector)
    // use memo will execute the function on initialisation and if dependencies change, and return the value
    const dataObjectSelector = (0, $7fPBF.useMemo)(()=>{
        if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "displayedReportDef changed, calculating dataObjectSelector");
        switch(displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.dataScope){
            case "transactions":
                return $1d60fcd5cdaf946c$export$c374296273e9912a;
            case "assets":
                return $1d60fcd5cdaf946c$export$71ce51cc869e0be6;
            case "quotes":
                return $1d60fcd5cdaf946c$export$15a43e3a08e9cc8d;
            case "snapshots":
                return $1d60fcd5cdaf946c$export$4eb51271a86d155c;
            default:
                return $1d60fcd5cdaf946c$export$71ce51cc869e0be6; // because if there is nothing here, it complains that there is a different amount of selectors now
        }
    }, [
        displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.dataScope
    ]);
    if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "correct selector function set, pointing the useSelector to the calculated selector function");
    const selectedDataObject = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>dataObjectSelector(state, filterCallback), (0, $3b08520b369c7e04$export$2e2bcd8739ae039)); // all these selectors are memoized, so they will only run if the dependencies change
    const standardPivotTableProps = {
        // onChange: (s) => setDisplayedReportDef(s), // was here, but does not seem to be used for anything
        onChange: null,
        renderers: $5958bfc3d629e828$export$2e2bcd8739ae039
    };
    // event listener
    (0, $7fPBF.useEffect)(()=>{
        const handleDebouncingFinished = ()=>{
            // Defer state update so it never runs during render; avoids the React warning seen before.
            setTimeout(()=>{
                if (isMounted.current) setRerenderControl((prevControl)=>prevControl + 1);
            }, 0);
        };
        window.addEventListener("reportingDebouncingFinished", handleDebouncingFinished);
        return ()=>{
            window.removeEventListener("reportingDebouncingFinished", handleDebouncingFinished);
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (displayedReportDef) {
            if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "begin executing the data object selector useEffect");
            // apply filterCallback on data if provided and send them to state, from where they will be used by the chart
            const alteredDataSettings = (0, $9tqwB._)({}, selectedDataObject);
            if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "data retrieved from reporting selector", selectedDataObject);
            if (selectedDataObject && filterCallback) alteredDataSettings.data = (selectedDataObject.data || []).filter((x)=>{
                var _displayedReportDef_dateFilter, _displayedReportDef_dateFilter1;
                return x.date > (((_displayedReportDef_dateFilter = displayedReportDef.dateFilter) === null || _displayedReportDef_dateFilter === void 0 ? void 0 : _displayedReportDef_dateFilter.from) || new Date(1902, 0, 1).valueOf()) && x.date <= (((_displayedReportDef_dateFilter1 = displayedReportDef.dateFilter) === null || _displayedReportDef_dateFilter1 === void 0 ? void 0 : _displayedReportDef_dateFilter1.to) || new Date(2200, 0, 1).valueOf());
            }).filter(filterCallback);
            // if there is dataCallback, use it instead of the reporting selectors
            if (selectedDataObject && dataCallback) alteredDataSettings.data = dataCallback(alteredDataSettings.data);
            if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "local callback applied to data, setting state of data object to", alteredDataSettings);
            setDataObject(alteredDataSettings);
            if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "data object state set");
        }
        // handle evtl. debouncing in input selector
        // when using lodash.debounce, the selector returns stale data (because it returns something while the function is still being debounced)
        // so we have to force a rerender to get the correct data just to be sure
        // this solution was replaced with the "handleDebounceFinished" event listener above, but keeping it here just in case
        // const timeout = setTimeout(() => {
        //   setRerenderControl((prev) => prev + 1);
        //   if (debugLevel > 2) console.log(dayjs().format('mm:ss.SSS'), reportId, 're-rendering the component to get the correct data');
        // }, 1010); // this has to be only slightly longer than the debouncing period length
        return ()=>{
            if ($c452aa40845053fb$var$debugLevel > 2) console.log((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("mm:ss.SSS"), reportId, "cleanup of useEffect on selectDataObject+displayedReportDef");
        // clearTimeout(timeout);
        };
    }, [
        selectedDataObject,
        displayedReportDef
    ]);
    if ((dataObject === null || dataObject === void 0 ? void 0 : (_dataObject_data = dataObject.data) === null || _dataObject_data === void 0 ? void 0 : _dataObject_data.length) === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    return displayedReportDef && dataObject ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "grid w-full h-full",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $2qxEV._)((0, $9tqwB._)({}, standardPivotTableProps, dataObject, displayedReportDef), {
            layoutOptions: layoutOptions
        }))
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: "No report found"
    });
}
$c452aa40845053fb$var$ChartWrapper.propTypes = {
    reportId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    filterCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    dataCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    // eslint-disable-next-line react/forbid-prop-types
    layoutOptions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$c452aa40845053fb$var$ChartWrapper.defaultProps = {
    filterCallback: ()=>true,
    dataCallback: (data)=>data,
    layoutOptions: {},
    isViewer: false
};
const $c452aa40845053fb$export$efd796c232b284d6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($c452aa40845053fb$var$ChartWrapper);
var $c452aa40845053fb$export$2e2bcd8739ae039 = $c452aa40845053fb$export$efd796c232b284d6;


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint object-curly-newline: ["error", { "multiline": true }] */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");


















var $db88f0b86f6249bf$var$pe = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($db88f0b86f6249bf$var$pe || {}), $db88f0b86f6249bf$var$de = ((o)=>(o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))($db88f0b86f6249bf$var$de || {}), $db88f0b86f6249bf$var$me = ((e)=>(e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))($db88f0b86f6249bf$var$me || {});
function $db88f0b86f6249bf$var$U(t, i = (o)=>o) {
    let o = t.activeItemIndex !== null ? t.items[t.activeItemIndex] : null, s = (0, $14e03ac93c8c8bff$export$20305e96f91bf103)(i(t.items.slice()), (u)=>u.dataRef.current.domRef.current), a = o ? s.indexOf(o) : null;
    return a === -1 && (a = null), {
        items: s,
        activeItemIndex: a
    };
}
let $db88f0b86f6249bf$var$fe = {
    [1] (t) {
        return t.menuState === 1 ? t : (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            activeItemIndex: null,
            menuState: 1
        });
    },
    [0] (t) {
        return t.menuState === 0 ? t : (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            menuState: 0
        });
    },
    [2]: (t, i)=>{
        var a;
        let o = $db88f0b86f6249bf$var$U(t), s = (0, $128c1210d720a2c8$export$c6b4626b54936d5e)(i, {
            resolveItems: ()=>o.items,
            resolveActiveIndex: ()=>o.activeItemIndex,
            resolveId: (u)=>u.id,
            resolveDisabled: (u)=>u.dataRef.current.disabled
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, t, o), {
            searchQuery: "",
            activeItemIndex: s,
            activationTrigger: (a = i.trigger) != null ? a : 1
        });
    },
    [3]: (t, i)=>{
        let s = t.searchQuery !== "" ? 0 : 1, a = t.searchQuery + i.value.toLowerCase(), n = (t.activeItemIndex !== null ? t.items.slice(t.activeItemIndex + s).concat(t.items.slice(0, t.activeItemIndex + s)) : t.items).find((d)=>{
            var l;
            return ((l = d.dataRef.current.textValue) == null ? void 0 : l.startsWith(a)) && !d.dataRef.current.disabled;
        }), e = n ? t.items.indexOf(n) : -1;
        return e === -1 || e === t.activeItemIndex ? (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            searchQuery: a
        }) : (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            searchQuery: a,
            activeItemIndex: e,
            activationTrigger: 1
        });
    },
    [4] (t) {
        return t.searchQuery === "" ? t : (0, $2qxEV._)((0, $9tqwB._)({}, t), {
            searchQuery: "",
            searchActiveItemIndex: null
        });
    },
    [5]: (t, i)=>{
        let o = $db88f0b86f6249bf$var$U(t, (s)=>[
                ...s,
                {
                    id: i.id,
                    dataRef: i.dataRef
                }
            ]);
        return (0, $9tqwB._)({}, t, o);
    },
    [6]: (t, i)=>{
        let o = $db88f0b86f6249bf$var$U(t, (s)=>{
            let a = s.findIndex((u)=>u.id === i.id);
            return a !== -1 && s.splice(a, 1), s;
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, t, o), {
            activationTrigger: 1
        });
    }
}, $db88f0b86f6249bf$var$G = (0, $7fPBF.createContext)(null);
$db88f0b86f6249bf$var$G.displayName = "MenuContext";
function $db88f0b86f6249bf$var$O(t) {
    let i = (0, $7fPBF.useContext)($db88f0b86f6249bf$var$G);
    if (i === null) {
        let o = new Error(`<${t} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $db88f0b86f6249bf$var$O), o;
    }
    return i;
}
function $db88f0b86f6249bf$var$Te(t, i) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(i.type, $db88f0b86f6249bf$var$fe, t, i);
}
let $db88f0b86f6249bf$var$ye = (0, $7fPBF.Fragment), $db88f0b86f6249bf$var$Ie = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(i, o) {
    let s = (0, $7fPBF.useReducer)($db88f0b86f6249bf$var$Te, {
        menuState: 1,
        buttonRef: (0, $7fPBF.createRef)(),
        itemsRef: (0, $7fPBF.createRef)(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: a, itemsRef: u, buttonRef: n }, e] = s, d = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(o);
    (0, $fa9d8c8ce9154eec$export$71b2224f1ce5e08e)([
        n,
        u
    ], (R, A)=>{
        var g;
        e({
            type: 1
        }), (0, $14e03ac93c8c8bff$export$ff1ec1c740b3c8d5)(A, (0, $14e03ac93c8c8bff$export$27112a34f2f8402d).Loose) || (R.preventDefault(), (g = n.current) == null || g.focus());
    }, a === 0);
    let l = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        e({
            type: 1
        });
    }), f = (0, $7fPBF.useMemo)(()=>({
            open: a === 0,
            close: l
        }), [
        a,
        l
    ]), M = i, T = {
        ref: d
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($db88f0b86f6249bf$var$G.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $42e7df3a446fef87$export$2a0ed818b175f558), {
        value: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(a, {
            [0]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open,
            [1]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed
        })
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: T,
        theirProps: M,
        slot: f,
        defaultTag: $db88f0b86f6249bf$var$ye,
        name: "Menu"
    })));
}), $db88f0b86f6249bf$var$ge = "button", $db88f0b86f6249bf$var$Me = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(i, o) {
    var g;
    let s = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-menu-button-${s}` } = i, u = (0, $bLhVg._)(i, [
        "id"
    ]), [n, e] = $db88f0b86f6249bf$var$O("Menu.Button"), d = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(n.buttonRef, o), l = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), f = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((c)=>{
        switch(c.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown:
                c.preventDefault(), c.stopPropagation(), e({
                    type: 0
                }), l.nextFrame(()=>e({
                        type: 2,
                        focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).First
                    }));
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp:
                c.preventDefault(), c.stopPropagation(), e({
                    type: 0
                }), l.nextFrame(()=>e({
                        type: 2,
                        focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Last
                    }));
                break;
        }
    }), M = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((c)=>{
        switch(c.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                c.preventDefault();
                break;
        }
    }), T = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((c)=>{
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(c.currentTarget)) return c.preventDefault();
        i.disabled || (n.menuState === 0 ? (e({
            type: 1
        }), l.nextFrame(()=>{
            var b;
            return (b = n.buttonRef.current) == null ? void 0 : b.focus({
                preventScroll: !0
            });
        })) : (c.preventDefault(), e({
            type: 0
        })));
    }), R = (0, $7fPBF.useMemo)(()=>({
            open: n.menuState === 0
        }), [
        n
    ]), A = {
        ref: d,
        id: a,
        type: (0, $67467b80232bd14a$export$53652b2b272efe9c)(i, n.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": (g = n.itemsRef.current) == null ? void 0 : g.id,
        "aria-expanded": i.disabled ? void 0 : n.menuState === 0,
        onKeyDown: f,
        onKeyUp: M,
        onClick: T
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: A,
        theirProps: u,
        slot: R,
        defaultTag: $db88f0b86f6249bf$var$ge,
        name: "Menu.Button"
    });
}), $db88f0b86f6249bf$var$Re = "div", $db88f0b86f6249bf$var$be = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $db88f0b86f6249bf$var$Ae = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(i, o) {
    var b, S;
    let s = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-menu-items-${s}` } = i, u = (0, $bLhVg._)(i, [
        "id"
    ]), [n, e] = $db88f0b86f6249bf$var$O("Menu.Items"), d = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(n.itemsRef, o), l = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(n.itemsRef), f = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), M = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)(), T = (()=>M !== null ? M === (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open : n.menuState === 0)();
    (0, $7fPBF.useEffect)(()=>{
        let r = n.itemsRef.current;
        !r || n.menuState === 0 && r !== (l == null ? void 0 : l.activeElement) && r.focus({
            preventScroll: !0
        });
    }, [
        n.menuState,
        n.itemsRef,
        l
    ]), (0, $1c5930309222918e$export$b0abce39eb34b36)({
        container: n.itemsRef.current,
        enabled: n.menuState === 0,
        accept (r) {
            return r.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : r.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (r) {
            r.setAttribute("role", "none");
        }
    });
    let R = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((r)=>{
        var h, F;
        switch(f.dispose(), r.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                if (n.searchQuery !== "") return r.preventDefault(), r.stopPropagation(), e({
                    type: 3,
                    value: r.key
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                if (r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                }), n.activeItemIndex !== null) {
                    let { dataRef: p } = n.items[n.activeItemIndex];
                    (F = (h = p.current) == null ? void 0 : h.domRef.current) == null || F.click();
                }
                (0, $14e03ac93c8c8bff$export$46388676ec35ab85)(n.buttonRef.current);
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown:
                return r.preventDefault(), r.stopPropagation(), e({
                    type: 2,
                    focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Next
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp:
                return r.preventDefault(), r.stopPropagation(), e({
                    type: 2,
                    focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Previous
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Home:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).PageUp:
                return r.preventDefault(), r.stopPropagation(), e({
                    type: 2,
                    focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).First
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).End:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).PageDown:
                return r.preventDefault(), r.stopPropagation(), e({
                    type: 2,
                    focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Last
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape:
                r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                }), (0, $ae5551858911f61c$export$12b26c28a05aa001)().nextFrame(()=>{
                    var p;
                    return (p = n.buttonRef.current) == null ? void 0 : p.focus({
                        preventScroll: !0
                    });
                });
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Tab:
                r.preventDefault(), r.stopPropagation(), e({
                    type: 1
                }), (0, $ae5551858911f61c$export$12b26c28a05aa001)().nextFrame(()=>{
                    (0, $14e03ac93c8c8bff$export$7fb6c844b485e870)(n.buttonRef.current, r.shiftKey ? (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Previous : (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Next);
                });
                break;
            default:
                r.key.length === 1 && (e({
                    type: 3,
                    value: r.key
                }), f.setTimeout(()=>e({
                        type: 4
                    }), 350));
                break;
        }
    }), A = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((r)=>{
        switch(r.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                r.preventDefault();
                break;
        }
    }), g = (0, $7fPBF.useMemo)(()=>({
            open: n.menuState === 0
        }), [
        n
    ]), c = {
        "aria-activedescendant": n.activeItemIndex === null || (b = n.items[n.activeItemIndex]) == null ? void 0 : b.id,
        "aria-labelledby": (S = n.buttonRef.current) == null ? void 0 : S.id,
        id: a,
        onKeyDown: R,
        onKeyUp: A,
        role: "menu",
        tabIndex: 0,
        ref: d
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: c,
        theirProps: u,
        slot: g,
        defaultTag: $db88f0b86f6249bf$var$Re,
        features: $db88f0b86f6249bf$var$be,
        visible: T,
        name: "Menu.Items"
    });
}), $db88f0b86f6249bf$var$ve = (0, $7fPBF.Fragment), $db88f0b86f6249bf$var$Se = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(i, o) {
    let s = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: a = `headlessui-menu-item-${s}`, disabled: u = !1 } = i, n = (0, $bLhVg._)(i, [
        "id",
        "disabled"
    ]), [e, d] = $db88f0b86f6249bf$var$O("Menu.Item"), l = e.activeItemIndex !== null ? e.items[e.activeItemIndex].id === a : !1, f = (0, $7fPBF.useRef)(null), M = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(o, f);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (e.menuState !== 0 || !l || e.activationTrigger === 0) return;
        let p = (0, $ae5551858911f61c$export$12b26c28a05aa001)();
        return p.requestAnimationFrame(()=>{
            var v, B;
            (B = (v = f.current) == null ? void 0 : v.scrollIntoView) == null || B.call(v, {
                block: "nearest"
            });
        }), p.dispose;
    }, [
        f,
        l,
        e.menuState,
        e.activationTrigger,
        e.activeItemIndex
    ]);
    let T = (0, $7fPBF.useRef)({
        disabled: u,
        domRef: f
    });
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        T.current.disabled = u;
    }, [
        T,
        u
    ]), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        var p, v;
        T.current.textValue = (v = (p = f.current) == null ? void 0 : p.textContent) == null ? void 0 : v.toLowerCase();
    }, [
        T,
        f
    ]), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>(d({
            type: 5,
            id: a,
            dataRef: T
        }), ()=>d({
                type: 6,
                id: a
            })), [
        T,
        a
    ]);
    let R = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        d({
            type: 1
        });
    }), A = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((p)=>{
        if (u) return p.preventDefault();
        d({
            type: 1
        }), (0, $14e03ac93c8c8bff$export$46388676ec35ab85)(e.buttonRef.current);
    }), g = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        if (u) return d({
            type: 2,
            focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing
        });
        d({
            type: 2,
            focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific,
            id: a
        });
    }), c = (0, $d895e59b5353ecb4$export$24ebee078bde85c3)(), b = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((p)=>c.update(p)), S = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((p)=>{
        !c.wasMoved(p) || u || l || d({
            type: 2,
            focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific,
            id: a,
            trigger: 0
        });
    }), r = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((p)=>{
        !c.wasMoved(p) || u || !l || d({
            type: 2,
            focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing
        });
    }), h = (0, $7fPBF.useMemo)(()=>({
            active: l,
            disabled: u,
            close: R
        }), [
        l,
        u,
        R
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            id: a,
            ref: M,
            role: "menuitem",
            tabIndex: u === !0 ? void 0 : -1,
            "aria-disabled": u === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: A,
            onFocus: g,
            onPointerEnter: b,
            onMouseEnter: b,
            onPointerMove: S,
            onMouseMove: S,
            onPointerLeave: r,
            onMouseLeave: r
        },
        theirProps: n,
        slot: h,
        defaultTag: $db88f0b86f6249bf$var$ve,
        name: "Menu.Item"
    });
}), $db88f0b86f6249bf$export$d9b273488cd8ce6f = Object.assign($db88f0b86f6249bf$var$Ie, {
    Button: $db88f0b86f6249bf$var$Me,
    Items: $db88f0b86f6249bf$var$Ae,
    Item: $db88f0b86f6249bf$var$Se
});


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");



















var $5bf2d36640122d06$var$Me = ((p)=>(p[p.Open = 0] = "Open", p[p.Closed = 1] = "Closed", p))($5bf2d36640122d06$var$Me || {}), $5bf2d36640122d06$var$Le = ((t)=>(t[t.TogglePopover = 0] = "TogglePopover", t[t.ClosePopover = 1] = "ClosePopover", t[t.SetButton = 2] = "SetButton", t[t.SetButtonId = 3] = "SetButtonId", t[t.SetPanel = 4] = "SetPanel", t[t.SetPanelId = 5] = "SetPanelId", t))($5bf2d36640122d06$var$Le || {});
let $5bf2d36640122d06$var$Fe = {
    [0]: (n)=>(0, $2qxEV._)((0, $9tqwB._)({}, n), {
            popoverState: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(n.popoverState, {
                [0]: 1,
                [1]: 0
            })
        }),
    [1] (n) {
        return n.popoverState === 1 ? n : (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            popoverState: 1
        });
    },
    [2] (n, r) {
        return n.button === r.button ? n : (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            button: r.button
        });
    },
    [3] (n, r) {
        return n.buttonId === r.buttonId ? n : (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            buttonId: r.buttonId
        });
    },
    [4] (n, r) {
        return n.panel === r.panel ? n : (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            panel: r.panel
        });
    },
    [5] (n, r) {
        return n.panelId === r.panelId ? n : (0, $2qxEV._)((0, $9tqwB._)({}, n), {
            panelId: r.panelId
        });
    }
}, $5bf2d36640122d06$var$le = (0, $7fPBF.createContext)(null);
$5bf2d36640122d06$var$le.displayName = "PopoverContext";
function $5bf2d36640122d06$var$Z(n) {
    let r = (0, $7fPBF.useContext)($5bf2d36640122d06$var$le);
    if (r === null) {
        let p = new Error(`<${n} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(p, $5bf2d36640122d06$var$Z), p;
    }
    return r;
}
let $5bf2d36640122d06$var$ae = (0, $7fPBF.createContext)(null);
$5bf2d36640122d06$var$ae.displayName = "PopoverAPIContext";
function $5bf2d36640122d06$var$ue(n) {
    let r = (0, $7fPBF.useContext)($5bf2d36640122d06$var$ae);
    if (r === null) {
        let p = new Error(`<${n} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(p, $5bf2d36640122d06$var$ue), p;
    }
    return r;
}
let $5bf2d36640122d06$var$se = (0, $7fPBF.createContext)(null);
$5bf2d36640122d06$var$se.displayName = "PopoverGroupContext";
function $5bf2d36640122d06$var$Te() {
    return (0, $7fPBF.useContext)($5bf2d36640122d06$var$se);
}
let $5bf2d36640122d06$var$pe = (0, $7fPBF.createContext)(null);
$5bf2d36640122d06$var$pe.displayName = "PopoverPanelContext";
function $5bf2d36640122d06$var$he() {
    return (0, $7fPBF.useContext)($5bf2d36640122d06$var$pe);
}
function $5bf2d36640122d06$var$Be(n, r) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(r.type, $5bf2d36640122d06$var$Fe, n, r);
}
let $5bf2d36640122d06$var$xe = "div", $5bf2d36640122d06$var$De = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, p) {
    var x;
    let C = (0, $7fPBF.useRef)(null), R = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(p, (0, $c1aa65a6b3c277bc$export$7029785b750eb74)((e)=>{
        C.current = e;
    })), O = (0, $7fPBF.useRef)([]), t = (0, $7fPBF.useReducer)($5bf2d36640122d06$var$Be, {
        popoverState: 1,
        buttons: O,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, $7fPBF.createRef)(),
        afterPanelSentinel: (0, $7fPBF.createRef)()
    }), [{ popoverState: o, button: a, buttonId: v, panel: c, panelId: M, beforePanelSentinel: T, afterPanelSentinel: d }, i] = t, u = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)((x = C.current) != null ? x : a), f = (0, $7fPBF.useMemo)(()=>{
        if (!a || !c) return !1;
        for (let K of document.querySelectorAll("body > *"))if (Number(K == null ? void 0 : K.contains(a)) ^ Number(K == null ? void 0 : K.contains(c))) return !0;
        let e = (0, $14e03ac93c8c8bff$export$433aaa1f216cf32d)(), l = e.indexOf(a), A = (l + e.length - 1) % e.length, b = (l + 1) % e.length, G = e[A], me = e[b];
        return !c.contains(G) && !c.contains(me);
    }, [
        a,
        c
    ]), g = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(v), y = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)(M), L = (0, $7fPBF.useMemo)(()=>({
            buttonId: g,
            panelId: y,
            close: ()=>i({
                    type: 1
                })
        }), [
        g,
        y,
        i
    ]), I = $5bf2d36640122d06$var$Te(), F = I == null ? void 0 : I.registerPopover, j = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        var e;
        return (e = I == null ? void 0 : I.isFocusWithinPopoverGroup()) != null ? e : (u == null ? void 0 : u.activeElement) && ((a == null ? void 0 : a.contains(u.activeElement)) || (c == null ? void 0 : c.contains(u.activeElement)));
    });
    (0, $7fPBF.useEffect)(()=>F == null ? void 0 : F(L), [
        F,
        L
    ]), (0, $9eb63a93d58df968$export$7080b3e976bc91ab)(u == null ? void 0 : u.defaultView, "focus", (e)=>{
        var l, A, b, G;
        o === 0 && (j() || !a || !c || e.target !== window && ((A = (l = T.current) == null ? void 0 : l.contains) != null && A.call(l, e.target) || (G = (b = d.current) == null ? void 0 : b.contains) != null && G.call(b, e.target) || i({
            type: 1
        })));
    }, !0), (0, $fa9d8c8ce9154eec$export$71b2224f1ce5e08e)([
        a,
        c
    ], (e, l)=>{
        i({
            type: 1
        }), (0, $14e03ac93c8c8bff$export$ff1ec1c740b3c8d5)(l, (0, $14e03ac93c8c8bff$export$27112a34f2f8402d).Loose) || (e.preventDefault(), a == null || a.focus());
    }, o === 0);
    let h = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        i({
            type: 1
        });
        let l = (()=>e ? e instanceof HTMLElement ? e : "current" in e && e.current instanceof HTMLElement ? e.current : a : a)();
        l == null || l.focus();
    }), s = (0, $7fPBF.useMemo)(()=>({
            close: h,
            isPortalled: f
        }), [
        h,
        f
    ]), m = (0, $7fPBF.useMemo)(()=>({
            open: o === 0,
            close: h
        }), [
        o,
        h
    ]), E = r, P = {
        ref: R
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5bf2d36640122d06$var$le.Provider, {
        value: t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5bf2d36640122d06$var$ae.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $42e7df3a446fef87$export$2a0ed818b175f558), {
        value: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(o, {
            [0]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open,
            [1]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed
        })
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: P,
        theirProps: E,
        slot: m,
        defaultTag: $5bf2d36640122d06$var$xe,
        name: "Popover"
    }))));
}), $5bf2d36640122d06$var$He = "button", $5bf2d36640122d06$var$ke = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, p) {
    let C = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: R = `headlessui-popover-button-${C}` } = r, O = (0, $bLhVg._)(r, [
        "id"
    ]), [t, o] = $5bf2d36640122d06$var$Z("Popover.Button"), { isPortalled: a } = $5bf2d36640122d06$var$ue("Popover.Button"), v = (0, $7fPBF.useRef)(null), c = `headlessui-focus-sentinel-${(0, $518ef203fb01499a$export$f680877a34711e37)()}`, M = $5bf2d36640122d06$var$Te(), T = M == null ? void 0 : M.closeOthers, i = $5bf2d36640122d06$var$he() !== null;
    (0, $7fPBF.useEffect)(()=>{
        if (!i) return o({
            type: 3,
            buttonId: R
        }), ()=>{
            o({
                type: 3,
                buttonId: null
            });
        };
    }, [
        i,
        R,
        o
    ]);
    let [u] = (0, $7fPBF.useState)(()=>Symbol()), f = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(v, p, i ? null : (e)=>{
        if (e) t.buttons.current.push(u);
        else {
            let l = t.buttons.current.indexOf(u);
            l !== -1 && t.buttons.current.splice(l, 1);
        }
        t.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), e && o({
            type: 2,
            button: e
        });
    }), g = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(v, p), y = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(v), L = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        var l, A, b;
        if (i) {
            if (t.popoverState === 1) return;
            switch(e.key){
                case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                    e.preventDefault(), (A = (l = e.target).click) == null || A.call(l), o({
                        type: 1
                    }), (b = t.button) == null || b.focus();
                    break;
            }
        } else switch(e.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                e.preventDefault(), e.stopPropagation(), t.popoverState === 1 && (T == null || T(t.buttonId)), o({
                    type: 0
                });
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape:
                if (t.popoverState !== 0) return T == null ? void 0 : T(t.buttonId);
                if (!v.current || (y == null ? void 0 : y.activeElement) && !v.current.contains(y.activeElement)) return;
                e.preventDefault(), e.stopPropagation(), o({
                    type: 1
                });
                break;
        }
    }), I = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        i || e.key === (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space && e.preventDefault();
    }), F = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        var l, A;
        (0, $9551cf0370e09058$export$db61f031a278447c)(e.currentTarget) || r.disabled || (i ? (o({
            type: 1
        }), (l = t.button) == null || l.focus()) : (e.preventDefault(), e.stopPropagation(), t.popoverState === 1 && (T == null || T(t.buttonId)), o({
            type: 0
        }), (A = t.button) == null || A.focus()));
    }), j = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((e)=>{
        e.preventDefault(), e.stopPropagation();
    }), h = t.popoverState === 0, s = (0, $7fPBF.useMemo)(()=>({
            open: h
        }), [
        h
    ]), m = (0, $67467b80232bd14a$export$53652b2b272efe9c)(r, v), E = i ? {
        ref: g,
        type: m,
        onKeyDown: L,
        onClick: F
    } : {
        ref: f,
        id: t.buttonId,
        type: m,
        "aria-expanded": r.disabled ? void 0 : t.popoverState === 0,
        "aria-controls": t.panel ? t.panelId : void 0,
        onKeyDown: L,
        onKeyUp: I,
        onClick: F,
        onMouseDown: j
    }, P = (0, $a84ce8905fd34ed3$export$19b797546aece48f)(), x = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        let e = t.panel;
        if (!e) return;
        function l() {
            (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(P.current, {
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Forwards]: ()=>(0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(e, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).First),
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Backwards]: ()=>(0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(e, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Last)
            }) === (0, $14e03ac93c8c8bff$export$abf286375dfa6dbd).Error && (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)((0, $14e03ac93c8c8bff$export$433aaa1f216cf32d)().filter((b)=>b.dataset.headlessuiFocusGuard !== "true"), (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(P.current, {
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Forwards]: (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Next,
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Backwards]: (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Previous
            }), {
                relativeTo: t.button
            });
        }
        l();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: E,
        theirProps: O,
        slot: s,
        defaultTag: $5bf2d36640122d06$var$He,
        name: "Popover.Button"
    }), h && !i && a && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), {
        id: c,
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: x
    }));
}), $5bf2d36640122d06$var$Ge = "div", $5bf2d36640122d06$var$we = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $5bf2d36640122d06$var$_e = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, p) {
    let C = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: R = `headlessui-popover-overlay-${C}` } = r, O = (0, $bLhVg._)(r, [
        "id"
    ]), [{ popoverState: t }, o] = $5bf2d36640122d06$var$Z("Popover.Overlay"), a = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(p), v = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)(), c = (()=>v !== null ? v === (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open : t === 0)(), M = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((i)=>{
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(i.currentTarget)) return i.preventDefault();
        o({
            type: 1
        });
    }), T = (0, $7fPBF.useMemo)(()=>({
            open: t === 0
        }), [
        t
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: a,
            id: R,
            "aria-hidden": !0,
            onClick: M
        },
        theirProps: O,
        slot: T,
        defaultTag: $5bf2d36640122d06$var$Ge,
        features: $5bf2d36640122d06$var$we,
        visible: c,
        name: "Popover.Overlay"
    });
}), $5bf2d36640122d06$var$Ne = "div", $5bf2d36640122d06$var$Ke = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $5bf2d36640122d06$var$Ue = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, p) {
    let C = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: R = `headlessui-popover-panel-${C}`, focus: O = !1 } = r, t = (0, $bLhVg._)(r, [
        "id",
        "focus"
    ]), [o, a] = $5bf2d36640122d06$var$Z("Popover.Panel"), { close: v, isPortalled: c } = $5bf2d36640122d06$var$ue("Popover.Panel"), M = `headlessui-focus-sentinel-before-${(0, $518ef203fb01499a$export$f680877a34711e37)()}`, T = `headlessui-focus-sentinel-after-${(0, $518ef203fb01499a$export$f680877a34711e37)()}`, d = (0, $7fPBF.useRef)(null), i = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(d, p, (s)=>{
        a({
            type: 4,
            panel: s
        });
    }), u = (0, $0b7932f154e874bd$export$dd9fbcea3de0ae36)(d);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>(a({
            type: 5,
            panelId: R
        }), ()=>{
            a({
                type: 5,
                panelId: null
            });
        }), [
        R,
        a
    ]);
    let f = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)(), g = (()=>f !== null ? f === (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open : o.popoverState === 0)(), y = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((s)=>{
        var m;
        switch(s.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape:
                if (o.popoverState !== 0 || !d.current || (u == null ? void 0 : u.activeElement) && !d.current.contains(u.activeElement)) return;
                s.preventDefault(), s.stopPropagation(), a({
                    type: 1
                }), (m = o.button) == null || m.focus();
                break;
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        var s;
        r.static || o.popoverState === 1 && ((s = r.unmount) != null ? s : !0) && a({
            type: 4,
            panel: null
        });
    }, [
        o.popoverState,
        r.unmount,
        r.static,
        a
    ]), (0, $7fPBF.useEffect)(()=>{
        if (!O || o.popoverState !== 0 || !d.current) return;
        let s = u == null ? void 0 : u.activeElement;
        d.current.contains(s) || (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(d.current, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).First);
    }, [
        O,
        d,
        o.popoverState
    ]);
    let L = (0, $7fPBF.useMemo)(()=>({
            open: o.popoverState === 0,
            close: v
        }), [
        o,
        v
    ]), I = {
        ref: i,
        id: R,
        onKeyDown: y,
        onBlur: O && o.popoverState === 0 ? (s)=>{
            var E, P, x, e, l;
            let m = s.relatedTarget;
            !m || !d.current || (E = d.current) != null && E.contains(m) || (a({
                type: 1
            }), (((x = (P = o.beforePanelSentinel.current) == null ? void 0 : P.contains) == null ? void 0 : x.call(P, m)) || ((l = (e = o.afterPanelSentinel.current) == null ? void 0 : e.contains) == null ? void 0 : l.call(e, m))) && m.focus({
                preventScroll: !0
            }));
        } : void 0,
        tabIndex: -1
    }, F = (0, $a84ce8905fd34ed3$export$19b797546aece48f)(), j = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        let s = d.current;
        if (!s) return;
        function m() {
            (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(F.current, {
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var P;
                    (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(s, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).First) === (0, $14e03ac93c8c8bff$export$abf286375dfa6dbd).Error && ((P = o.afterPanelSentinel.current) == null || P.focus());
                },
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var E;
                    (E = o.button) == null || E.focus({
                        preventScroll: !0
                    });
                }
            });
        }
        m();
    }), h = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        let s = d.current;
        if (!s) return;
        function m() {
            (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(F.current, {
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Forwards]: ()=>{
                    var A;
                    if (!o.button) return;
                    let E = (0, $14e03ac93c8c8bff$export$433aaa1f216cf32d)(), P = E.indexOf(o.button), x = E.slice(0, P + 1), l = [
                        ...E.slice(P + 1),
                        ...x
                    ];
                    for (let b of l.slice())if (b.dataset.headlessuiFocusGuard === "true" || ((A = o.panel) == null ? void 0 : A.contains(b))) {
                        let G = l.indexOf(b);
                        G !== -1 && l.splice(G, 1);
                    }
                    (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(l, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).First, {
                        sorted: !1
                    });
                },
                [(0, $a84ce8905fd34ed3$export$cacd6541cfeeb6c1).Backwards]: ()=>{
                    var P;
                    (0, $14e03ac93c8c8bff$export$82e1f4f412218a1d)(s, (0, $14e03ac93c8c8bff$export$807a7eae502106e7).Previous) === (0, $14e03ac93c8c8bff$export$abf286375dfa6dbd).Error && ((P = o.button) == null || P.focus());
                }
            });
        }
        m();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5bf2d36640122d06$var$pe.Provider, {
        value: R
    }, g && c && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), {
        id: M,
        ref: o.beforePanelSentinel,
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: j
    }), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: I,
        theirProps: t,
        slot: L,
        defaultTag: $5bf2d36640122d06$var$Ne,
        features: $5bf2d36640122d06$var$Ke,
        visible: g,
        name: "Popover.Panel"
    }), g && c && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), {
        id: T,
        ref: o.afterPanelSentinel,
        features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Focusable,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: h
    }));
}), $5bf2d36640122d06$var$We = "div", $5bf2d36640122d06$var$je = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, p) {
    let C = (0, $7fPBF.useRef)(null), R = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(C, p), [O, t] = (0, $7fPBF.useState)([]), o = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((u)=>{
        t((f)=>{
            let g = f.indexOf(u);
            if (g !== -1) {
                let y = f.slice();
                return y.splice(g, 1), y;
            }
            return f;
        });
    }), a = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((u)=>(t((f)=>[
                ...f,
                u
            ]), ()=>o(u))), v = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        var g;
        let u = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(C);
        if (!u) return !1;
        let f = u.activeElement;
        return (g = C.current) != null && g.contains(f) ? !0 : O.some((y)=>{
            var L, I;
            return ((L = u.getElementById(y.buttonId.current)) == null ? void 0 : L.contains(f)) || ((I = u.getElementById(y.panelId.current)) == null ? void 0 : I.contains(f));
        });
    }), c = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((u)=>{
        for (let f of O)f.buttonId.current !== u && f.close();
    }), M = (0, $7fPBF.useMemo)(()=>({
            registerPopover: a,
            unregisterPopover: o,
            isFocusWithinPopoverGroup: v,
            closeOthers: c
        }), [
        a,
        o,
        v,
        c
    ]), T = (0, $7fPBF.useMemo)(()=>({}), []), d = r, i = {
        ref: R
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5bf2d36640122d06$var$se.Provider, {
        value: M
    }, (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: i,
        theirProps: d,
        slot: T,
        defaultTag: $5bf2d36640122d06$var$We,
        name: "Popover.Group"
    }));
}), $5bf2d36640122d06$export$5b6b19405a83ff9d = Object.assign($5bf2d36640122d06$var$De, {
    Button: $5bf2d36640122d06$var$ke,
    Overlay: $5bf2d36640122d06$var$_e,
    Panel: $5bf2d36640122d06$var$Ue,
    Group: $5bf2d36640122d06$var$je
});



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $63cabf2e173d0e18$var$Bars3Icon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $63cabf2e173d0e18$var$ForwardRef = $7fPBF.forwardRef($63cabf2e173d0e18$var$Bars3Icon);
var $63cabf2e173d0e18$export$2e2bcd8739ae039 = $63cabf2e173d0e18$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $1147d060e2bfa4d6$var$BellIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
    }));
}
const $1147d060e2bfa4d6$var$ForwardRef = $7fPBF.forwardRef($1147d060e2bfa4d6$var$BellIcon);
var $1147d060e2bfa4d6$export$2e2bcd8739ae039 = $1147d060e2bfa4d6$var$ForwardRef;








function $0a05383fb5bb0535$var$HeaderApp({ mode: mode, openSettings: openSettings, openAccount: openAccount, searchControl: searchControl, setSearchControl: setSearchControl, setRecommendUsVisible: setRecommendUsVisible }) {
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("header");
    const lng = i18n.language;
    function handleLogout(e) {
        dispatch((0, $8bd3fc2d0bca0786$export$a0973bcfe11b05c9)());
        navigate("/");
        setTimeout(()=>window.location.reload(), 300);
    }
    const navigation = [
        {
            id: "dashboard",
            name: "Dashboard",
            href: `/${lng}/app/dashboard`
        },
        {
            id: "projects",
            name: t("projects"),
            href: `/${lng}/app/projects`
        },
        {
            id: "reports",
            name: t("reports"),
            href: `/${lng}/app/reports`
        },
        {
            id: "help",
            name: t("help"),
            href: `/${lng}/blog/${(0, $99f87ace30ad8515$export$25f4d58a6d16a7a5)("guide", lng)}`,
            newWindow: true
        }
    ];
    // { name: t('survey'), href: '/en/survey', current: false },
    // this ↓↓ is NOT USED for the desktop menu (see around row 105)
    // FIXME blocked for initial release (see PRD-1408)
    const mobileMenu = [
        // {
        //   id: 'recommendUs',
        //   name: t('recommendUs'),
        //   callback: () => setRecommendUsVisible(true),
        // },
        {
            id: "profile",
            name: t("profile"),
            callback: openAccount
        },
        {
            id: "settings",
            name: t("settings"),
            callback: openSettings
        }
    ];
    if (!window.mobileApp) mobileMenu.push({
        id: "signOut",
        name: t("signOut"),
        callback: handleLogout
    });
    const [user, setUser] = (0, $7fPBF.useState)({
        name: "user",
        email: "email"
    });
    const messages = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.messages);
    (0, $7fPBF.useEffect)(()=>{
        async function getUser() {
            var _userFromAuth_attributes, _userFromAuth_attributes1, _userFromAuth_attributes2;
            const userFromAuth = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)();
            setUser({
                name: ((_userFromAuth_attributes = userFromAuth.attributes) === null || _userFromAuth_attributes === void 0 ? void 0 : _userFromAuth_attributes.preferred_username) || ((_userFromAuth_attributes1 = userFromAuth.attributes) === null || _userFromAuth_attributes1 === void 0 ? void 0 : _userFromAuth_attributes1.email),
                email: (_userFromAuth_attributes2 = userFromAuth.attributes) === null || _userFromAuth_attributes2 === void 0 ? void 0 : _userFromAuth_attributes2.email
            });
        }
        getUser();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d), {
        as: "header",
        // header (pb property) is longer in projects mode to cover the slider
        // TODO: removed 'z-10' from the className below, check if it breaks anything (without it the overlap
        // between header and dashboard does not work, dashboard must be higher in the stacking context)
        className: `${mode === "dashboard" ? "from-brandDarkBlue-700 to-brandBlue-600 pb-12 lg:pb-20" : ""}
                  ${mode === "projects" ? "from-brandDarkBlue-700 to-brandViolet-700 pb-40 lg:pb-56" : ""}
                  ${mode === "viewer" ? "from-brandDarkBlue-700 to-brandBlue-600 pb-16 lg:pb-20" : ""}
                  ${mode === "reports" ? "from-brandDarkBlue-700 to-brandBlue-600 lg:pb-28" : ""}
      bg-gradient-to-r relative`,
        children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-[100rem] lg:px-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative flex flex-wrap items-center justify-center lg:justify-between",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "absolute left-0 py-5 flex-shrink-0 lg:static",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                                        to: "/",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Workflow"
                                            }),
                                            mode === "viewer" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bd8308d52035eee$export$2e2bcd8739ae039), {
                                                fillstack: "#ffffff",
                                                width: "230",
                                                height: "28",
                                                viewBox: "0 0 860 135",
                                                className: "hidden xs:block h-14"
                                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bd8308d52035eee$export$2e2bcd8739ae039), {
                                                fillstack: "#ffffff",
                                                width: "180",
                                                height: "28",
                                                viewBox: "35 0 831 135",
                                                className: "hidden xs:block h-6"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12b139122e9d7192$export$2e2bcd8739ae039), {
                                                width: "32",
                                                height: "32",
                                                viewBox: "35 0 831 135",
                                                className: "xs:hidden h-8"
                                            })
                                        ]
                                    })
                                }),
                                mode !== "viewer" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "hidden lg:ml-4 lg:flex lg:items-center lg:py-5 lg:pr-0.5",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f), {
                                            as: "div",
                                            className: "ml-4 relative flex-shrink-0",
                                            id: "header-notification-list-desktop",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Button, {
                                                        className: "flex-shrink-0 py-1 px-1 text-brandBlue-200 rounded-full hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white",
                                                        id: "header-notification-button-desktop",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Open notification list"
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1147d060e2bfa4d6$export$2e2bcd8739ae039), {
                                                                className: "h-6 w-6",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                                    as: "div",
                                                    leave: "transition ease-in duration-75",
                                                    leaveFrom: "transform opacity-100 scale-100",
                                                    leaveTo: "transform opacity-0 scale-95",
                                                    children: [
                                                        messages.length > 0 && // this div: overall shape of the notification list + margins
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            id: "header-notification-items-desktop-overflow-parent",
                                                            className: "origin-top-right z-40 absolute -right-2 mt-2 w-96 max-h-96 rounded-md shadow-lg p-3 bg-gray-50 ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "max-h-[22rem] overflow-y-auto scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 hover:scrollbar-thumb-zinc-400",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Items, {
                                                                    id: "header-notification-items-desktop",
                                                                    className: "space-y-2",
                                                                    children: [
                                                                        ...messages
                                                                    ].reverse().map((messageObject)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                                                            as: "div",
                                                                            id: `header-notification-items-desktop-${messageObject.message}`,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee486cb89111f160$export$8d8dc7d5f743331b), {
                                                                                messageObject: messageObject,
                                                                                show: true
                                                                            })
                                                                        }, messageObject.message))
                                                                })
                                                            })
                                                        }),
                                                        messages.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            id: "header-notification-items-desktop-empty",
                                                            children: t("noMessages")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f), {
                                            as: "div",
                                            className: "ml-4 relative flex-shrink-0",
                                            id: "header-menu-desktop",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Button, {
                                                        className: "inline-flex items-center px-3 py-2 shadow-sm text-sm leading-4 font-medium rounded-md text-brandBlue-200 focus:outline-none focus:ring-opacity-100",
                                                        id: "header-menu-button-desktop",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Open user menu"
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63cabf2e173d0e18$export$2e2bcd8739ae039), {
                                                                className: "h-6 w-6 text-brandBlue-200"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                                    as: (0, $7fPBF.Fragment),
                                                    leave: "transition ease-in duration-75",
                                                    leaveFrom: "transform opacity-100 scale-100",
                                                    leaveTo: "transform opacity-0 scale-95",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Items, {
                                                        id: "header-menu-items-desktop",
                                                        className: "origin-top-right z-40 absolute -right-2 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                                                id: "header-menu-items-desktop-recommendus",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: ()=>setRecommendUsVisible(true),
                                                                    className: "hover:bg-gray-100 block w-full text-left px-4 py-2 text-sm text-gray-700",
                                                                    children: t("recommendUs")
                                                                })
                                                            }, "recommendus"),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                                                id: "header-menu-items-desktop-yourprofile",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: openAccount,
                                                                    className: "hover:bg-gray-100 block w-full text-left px-4 py-2 text-sm text-gray-700",
                                                                    children: t("profile")
                                                                })
                                                            }, "yourprofile"),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                                                id: "header-menu-items-desktop-settings",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: openSettings,
                                                                    className: "hover:bg-gray-100 block w-full text-left px-4 py-2 text-sm text-gray-700",
                                                                    children: t("settings")
                                                                })
                                                            }, "settings"),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                                                id: "menu-button-signout",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                    type: "button",
                                                                    onClick: handleLogout,
                                                                    className: "hover:bg-gray-100 block w-full text-left px-4 py-2 text-sm text-gray-700",
                                                                    children: t("signOut")
                                                                })
                                                            }, "signout")
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                mode !== "viewer" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "w-full py-5 lg:border-t lg:border-white lg:border-opacity-20",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "lg:grid lg:grid-cols-3 lg:gap-8 lg:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "hidden lg:block lg:col-span-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                                                    className: "flex space-x-6",
                                                    children: navigation.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), (0, $2qxEV._)((0, $9tqwB._)({
                                                            id: `header-nav-desktop-${item.id}`,
                                                            to: item.href,
                                                            className: `text-sm font-semibold rounded-md bg-white bg-opacity-0 px-3 py-2 hover:bg-opacity-10
                              ${location.pathname === item.href ? "text-white" : "text-brandDarkBlue-200"}`
                                                        }, item.newWindow && {
                                                            target: "_blank",
                                                            rel: "noopener noreferrer"
                                                        }), {
                                                            children: item.name
                                                        }), item.id))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e9d517aec5d290d$export$2e2bcd8739ae039), {
                                                searchControl: searchControl,
                                                setSearchControl: setSearchControl
                                            })
                                        ]
                                    })
                                }),
                                mode !== "viewer" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "absolute right-0 flex-shrink-0 lg:hidden",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d).Button, {
                                        className: "bg-transparent p-2 rounded-md inline-flex items-center justify-center text-cyan-200 hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:ring-2 focus:ring-white",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "sr-only",
                                                children: "Open main menu"
                                            }),
                                            open ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68ecf30d598e901c$export$2e2bcd8739ae039), {
                                                className: "block h-6 w-6",
                                                "aria-hidden": "true"
                                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63cabf2e173d0e18$export$2e2bcd8739ae039), {
                                                className: "block h-6 w-6",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Root, {
                        as: (0, $7fPBF.Fragment),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "lg:hidden",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                                    as: (0, $7fPBF.Fragment),
                                    enter: "duration-150 ease-out",
                                    enterFrom: "opacity-0",
                                    enterTo: "opacity-100",
                                    leave: "duration-150 ease-in",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d).Overlay, {
                                        className: "z-20 fixed inset-0 bg-black bg-opacity-25"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                                    as: (0, $7fPBF.Fragment),
                                    enter: "duration-150 ease-out",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "duration-150 ease-in",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d).Panel, {
                                        focus: true,
                                        className: "z-30 absolute top-0 inset-x-0 max-w-3xl mx-auto w-full p-2 transition transform origin-top",
                                        children: ({ close: close })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y divide-gray-200",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "pt-3 pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "flex items-center justify-between px-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "-ml-2",
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9da0e09cae0be9e$export$2e2bcd8739ae039), {
                                                                            width: "180",
                                                                            height: "28",
                                                                            viewBox: "0 0 831 126",
                                                                            className: "h-6"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "-mr-2",
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d).Button, {
                                                                            className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                    className: "sr-only",
                                                                                    children: "Close menu"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68ecf30d598e901c$export$2e2bcd8739ae039), {
                                                                                    className: "h-6 w-6",
                                                                                    "aria-hidden": "true"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "mt-3 px-2 space-y-1",
                                                                children: navigation.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$b0d92dbee9b5b60d), {
                                                                        to: item.href,
                                                                        onClick: ()=>close(),
                                                                        className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                                                                        rel: "noopener noreferrer",
                                                                        children: item.name
                                                                    }, item.name))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "pt-4 pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                className: "flex items-center px-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: "h-10 w-10 rounded-full py-2 px-3 bg-brandBlue-600 font-bold text-white",
                                                                            children: user.name[0].toUpperCase()
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                        className: "ml-3 min-w-0 flex-1",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                className: "text-base font-medium text-gray-800 truncate",
                                                                                children: user.name
                                                                            }),
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                                className: "text-sm font-medium text-gray-500 truncate",
                                                                                children: user.email
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "ml-auto flex-shrink-0 bg-white p-1 text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                className: "sr-only",
                                                                                children: "View notifications"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1147d060e2bfa4d6$export$2e2bcd8739ae039), {
                                                                                className: "h-6 w-6",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "mt-3 px-2 space-y-1",
                                                                children: mobileMenu.filter((item)=>{
                                                                    if (item.id === "signOut") return !window.mobileApp;
                                                                    return true;
                                                                }) // hide signOut button if in mobile app (see https://monestry.atlassian.net/l/cp/74aYHw8v)
                                                                .map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                        type: "button",
                                                                        onClick: item.callback,
                                                                        target: "_blank",
                                                                        className: "block rounded-md px-3 py-2 text-base text-gray-900 font-medium hover:bg-gray-100 hover:text-gray-800",
                                                                        children: item.name
                                                                    }, item.name))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
    });
}
$0a05383fb5bb0535$var$HeaderApp.propTypes = {
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    openSettings: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    openAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    searchControl: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setSearchControl: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setRecommendUsVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$0a05383fb5bb0535$var$HeaderApp.defaultProps = {
    mode: "dashboard"
};
var $0a05383fb5bb0535$export$2e2bcd8739ae039 = $0a05383fb5bb0535$var$HeaderApp;


/* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/no-array-index-key */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");





/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/prop-types */ /* eslint-disable no-return-assign */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








/* eslint-disable react/forbid-prop-types */ /* eslint-disable no-shadow */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");






















var $cb7e0d651f5bfe47$var$Ue = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($cb7e0d651f5bfe47$var$Ue || {}), $cb7e0d651f5bfe47$var$Be = ((o)=>(o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))($cb7e0d651f5bfe47$var$Be || {}), $cb7e0d651f5bfe47$var$He = ((o)=>(o[o.Pointer = 0] = "Pointer", o[o.Other = 1] = "Other", o))($cb7e0d651f5bfe47$var$He || {}), $cb7e0d651f5bfe47$var$Ge = ((n)=>(n[n.OpenListbox = 0] = "OpenListbox", n[n.CloseListbox = 1] = "CloseListbox", n[n.GoToOption = 2] = "GoToOption", n[n.Search = 3] = "Search", n[n.ClearSearch = 4] = "ClearSearch", n[n.RegisterOption = 5] = "RegisterOption", n[n.UnregisterOption = 6] = "UnregisterOption", n[n.RegisterLabel = 7] = "RegisterLabel", n))($cb7e0d651f5bfe47$var$Ge || {});
function $cb7e0d651f5bfe47$var$q(e, r = (o)=>o) {
    let o = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, p = (0, $14e03ac93c8c8bff$export$20305e96f91bf103)(r(e.options.slice()), (c)=>c.dataRef.current.domRef.current), i = o ? p.indexOf(o) : null;
    return i === -1 && (i = null), {
        options: p,
        activeOptionIndex: i
    };
}
let $cb7e0d651f5bfe47$var$je = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            activeOptionIndex: null,
            listboxState: 1
        });
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        let r = e.activeOptionIndex, { isSelected: o } = e.dataRef.current, p = e.options.findIndex((i)=>o(i.dataRef.current.value));
        return p !== -1 && (r = p), (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            listboxState: 0,
            activeOptionIndex: r
        });
    },
    [2] (e, r) {
        var i;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let o = $cb7e0d651f5bfe47$var$q(e), p = (0, $128c1210d720a2c8$export$c6b4626b54936d5e)(r, {
            resolveItems: ()=>o.options,
            resolveActiveIndex: ()=>o.activeOptionIndex,
            resolveId: (c)=>c.id,
            resolveDisabled: (c)=>c.dataRef.current.disabled
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, e, o), {
            searchQuery: "",
            activeOptionIndex: p,
            activationTrigger: (i = r.trigger) != null ? i : 1
        });
    },
    [3]: (e, r)=>{
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        let p = e.searchQuery !== "" ? 0 : 1, i = e.searchQuery + r.value.toLowerCase(), t = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + p).concat(e.options.slice(0, e.activeOptionIndex + p)) : e.options).find((n)=>{
            var T;
            return !n.dataRef.current.disabled && ((T = n.dataRef.current.textValue) == null ? void 0 : T.startsWith(i));
        }), u = t ? e.options.indexOf(t) : -1;
        return u === -1 || u === e.activeOptionIndex ? (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            searchQuery: i
        }) : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            searchQuery: i,
            activeOptionIndex: u,
            activationTrigger: 1
        });
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
            searchQuery: ""
        });
    },
    [5]: (e, r)=>{
        let o = {
            id: r.id,
            dataRef: r.dataRef
        }, p = $cb7e0d651f5bfe47$var$q(e, (i)=>[
                ...i,
                o
            ]);
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(r.dataRef.current.value) && (p.activeOptionIndex = p.options.indexOf(o)), (0, $9tqwB._)({}, e, p);
    },
    [6]: (e, r)=>{
        let o = $cb7e0d651f5bfe47$var$q(e, (p)=>{
            let i = p.findIndex((c)=>c.id === r.id);
            return i !== -1 && p.splice(i, 1), p;
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, e, o), {
            activationTrigger: 1
        });
    },
    [7]: (e, r)=>(0, $2qxEV._)((0, $9tqwB._)({}, e), {
            labelId: r.id
        })
}, $cb7e0d651f5bfe47$var$X = (0, $7fPBF.createContext)(null);
$cb7e0d651f5bfe47$var$X.displayName = "ListboxActionsContext";
function $cb7e0d651f5bfe47$var$B(e) {
    let r = (0, $7fPBF.useContext)($cb7e0d651f5bfe47$var$X);
    if (r === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $cb7e0d651f5bfe47$var$B), o;
    }
    return r;
}
let $cb7e0d651f5bfe47$var$J = (0, $7fPBF.createContext)(null);
$cb7e0d651f5bfe47$var$J.displayName = "ListboxDataContext";
function $cb7e0d651f5bfe47$var$H(e) {
    let r = (0, $7fPBF.useContext)($cb7e0d651f5bfe47$var$J);
    if (r === null) {
        let o = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $cb7e0d651f5bfe47$var$H), o;
    }
    return r;
}
function $cb7e0d651f5bfe47$var$Ke(e, r) {
    return (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(r.type, $cb7e0d651f5bfe47$var$je, e, r);
}
let $cb7e0d651f5bfe47$var$Ve = (0, $7fPBF.Fragment), $cb7e0d651f5bfe47$var$Ne = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, o) {
    let { value: p, defaultValue: i, name: c, onChange: t, by: u = (l, f)=>l === f, disabled: n = !1, horizontal: T = !1, multiple: g = !1 } = r, A = (0, $bLhVg._)(r, [
        "value",
        "defaultValue",
        "name",
        "onChange",
        "by",
        "disabled",
        "horizontal",
        "multiple"
    ]);
    const m = T ? "horizontal" : "vertical";
    let P = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(o), [y = g ? [] : void 0, S] = (0, $52e65d40f5248976$export$454217e89aea72b)(p, t, i), [h, s] = (0, $7fPBF.useReducer)($cb7e0d651f5bfe47$var$Ke, {
        dataRef: (0, $7fPBF.createRef)(),
        listboxState: 1,
        options: [],
        searchQuery: "",
        labelId: null,
        activeOptionIndex: null,
        activationTrigger: 1
    }), a = (0, $7fPBF.useRef)({
        static: !1,
        hold: !1
    }), x = (0, $7fPBF.useRef)(null), D = (0, $7fPBF.useRef)(null), Q = (0, $7fPBF.useRef)(null), M = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(typeof u == "string" ? (l, f)=>{
        let v = u;
        return (l == null ? void 0 : l[v]) === (f == null ? void 0 : f[v]);
    } : u), L = (0, $7fPBF.useCallback)((l)=>(0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(d.mode, {
            [1]: ()=>y.some((f)=>M(f, l)),
            [0]: ()=>M(y, l)
        }), [
        y
    ]), d = (0, $7fPBF.useMemo)(()=>(0, $2qxEV._)((0, $9tqwB._)({}, h), {
            value: y,
            disabled: n,
            mode: g ? 1 : 0,
            orientation: m,
            compare: M,
            isSelected: L,
            optionsPropsRef: a,
            labelRef: x,
            buttonRef: D,
            optionsRef: Q
        }), [
        y,
        n,
        g,
        h
    ]);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        h.dataRef.current = d;
    }, [
        d
    ]), (0, $fa9d8c8ce9154eec$export$71b2224f1ce5e08e)([
        d.buttonRef,
        d.optionsRef
    ], (l, f)=>{
        var v;
        s({
            type: 1
        }), (0, $14e03ac93c8c8bff$export$ff1ec1c740b3c8d5)(f, (0, $14e03ac93c8c8bff$export$27112a34f2f8402d).Loose) || (l.preventDefault(), (v = d.buttonRef.current) == null || v.focus());
    }, d.listboxState === 0);
    let G = (0, $7fPBF.useMemo)(()=>({
            open: d.listboxState === 0,
            disabled: n,
            value: y
        }), [
        d,
        n,
        y
    ]), ie = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>{
        let f = d.options.find((v)=>v.id === l);
        !f || k(f.dataRef.current.value);
    }), re = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        if (d.activeOptionIndex !== null) {
            let { dataRef: l, id: f } = d.options[d.activeOptionIndex];
            k(l.current.value), s({
                type: 2,
                focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific,
                id: f
            });
        }
    }), ae = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>s({
            type: 0
        })), le = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>s({
            type: 1
        })), se = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l, f, v)=>l === (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific ? s({
            type: 2,
            focus: (0, $128c1210d720a2c8$export$807a7eae502106e7).Specific,
            id: f,
            trigger: v
        }) : s({
            type: 2,
            focus: l,
            trigger: v
        })), ue = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l, f)=>(s({
            type: 5,
            id: l,
            dataRef: f
        }), ()=>s({
                type: 6,
                id: l
            }))), pe = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>(s({
            type: 7,
            id: l
        }), ()=>s({
                type: 7,
                id: null
            }))), k = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>(0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(d.mode, {
            [0] () {
                return S == null ? void 0 : S(l);
            },
            [1] () {
                let f = d.value.slice(), v = f.findIndex((w)=>M(w, l));
                return v === -1 ? f.push(l) : f.splice(v, 1), S == null ? void 0 : S(f);
            }
        })), de = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((l)=>s({
            type: 3,
            value: l
        })), ce = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>s({
            type: 4
        })), fe = (0, $7fPBF.useMemo)(()=>({
            onChange: k,
            registerOption: ue,
            registerLabel: pe,
            goToOption: se,
            closeListbox: le,
            openListbox: ae,
            selectActiveOption: re,
            selectOption: ie,
            search: de,
            clearSearch: ce
        }), []), be = {
        ref: P
    }, j = (0, $7fPBF.useRef)(null), Te = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)();
    return (0, $7fPBF.useEffect)(()=>{
        !j.current || i !== void 0 && Te.addEventListener(j.current, "reset", ()=>{
            k(i);
        });
    }, [
        j,
        k
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($cb7e0d651f5bfe47$var$X.Provider, {
        value: fe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($cb7e0d651f5bfe47$var$J.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $42e7df3a446fef87$export$2a0ed818b175f558), {
        value: (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(d.listboxState, {
            [0]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open,
            [1]: (0, $42e7df3a446fef87$export$7254cc27399e90bd).Closed
        })
    }, c != null && y != null && (0, $9ee07d5ba8162c4b$export$bc22b3e852574dab)({
        [c]: y
    }).map(([l, f], v)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1f8e5f672a110f9e$export$8dc98ba7eadeaa56), (0, $9tqwB._)({
            features: (0, $1f8e5f672a110f9e$export$617d79dae526d2cf).Hidden,
            ref: v === 0 ? (w)=>{
                var Y;
                j.current = (Y = w == null ? void 0 : w.closest("form")) != null ? Y : null;
            } : void 0
        }, (0, $72af10e8efa1b073$export$8e16b83750b44988)({
            key: l,
            as: "input",
            type: "hidden",
            hidden: !0,
            readOnly: !0,
            name: l,
            value: f
        })))), (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: be,
        theirProps: A,
        slot: G,
        defaultTag: $cb7e0d651f5bfe47$var$Ve,
        name: "Listbox"
    }))));
}), $cb7e0d651f5bfe47$var$We = "button", $cb7e0d651f5bfe47$var$Qe = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, o) {
    var h;
    let p = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: i = `headlessui-listbox-button-${p}` } = r, c = (0, $bLhVg._)(r, [
        "id"
    ]), t = $cb7e0d651f5bfe47$var$H("Listbox.Button"), u = $cb7e0d651f5bfe47$var$B("Listbox.Button"), n = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t.buttonRef, o), T = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), g = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((s)=>{
        switch(s.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown:
                s.preventDefault(), u.openListbox(), T.nextFrame(()=>{
                    t.value || u.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).First);
                });
                break;
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp:
                s.preventDefault(), u.openListbox(), T.nextFrame(()=>{
                    t.value || u.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Last);
                });
                break;
        }
    }), A = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((s)=>{
        switch(s.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                s.preventDefault();
                break;
        }
    }), m = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((s)=>{
        if ((0, $9551cf0370e09058$export$db61f031a278447c)(s.currentTarget)) return s.preventDefault();
        t.listboxState === 0 ? (u.closeListbox(), T.nextFrame(()=>{
            var a;
            return (a = t.buttonRef.current) == null ? void 0 : a.focus({
                preventScroll: !0
            });
        })) : (s.preventDefault(), u.openListbox());
    }), P = (0, $b3352202c7c0b918$export$e3d20747ab930783)(()=>{
        if (!!t.labelId) return [
            t.labelId,
            i
        ].join(" ");
    }, [
        t.labelId,
        i
    ]), y = (0, $7fPBF.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled,
            value: t.value
        }), [
        t
    ]), S = {
        ref: n,
        id: i,
        type: (0, $67467b80232bd14a$export$53652b2b272efe9c)(r, t.buttonRef),
        "aria-haspopup": "listbox",
        "aria-controls": (h = t.optionsRef.current) == null ? void 0 : h.id,
        "aria-expanded": t.disabled ? void 0 : t.listboxState === 0,
        "aria-labelledby": P,
        disabled: t.disabled,
        onKeyDown: g,
        onKeyUp: A,
        onClick: m
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: S,
        theirProps: c,
        slot: y,
        defaultTag: $cb7e0d651f5bfe47$var$We,
        name: "Listbox.Button"
    });
}), $cb7e0d651f5bfe47$var$$e = "label", $cb7e0d651f5bfe47$var$ze = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, o) {
    let p = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: i = `headlessui-listbox-label-${p}` } = r, c = (0, $bLhVg._)(r, [
        "id"
    ]), t = $cb7e0d651f5bfe47$var$H("Listbox.Label"), u = $cb7e0d651f5bfe47$var$B("Listbox.Label"), n = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t.labelRef, o);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>u.registerLabel(i), [
        i
    ]);
    let T = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        var m;
        return (m = t.buttonRef.current) == null ? void 0 : m.focus({
            preventScroll: !0
        });
    }), g = (0, $7fPBF.useMemo)(()=>({
            open: t.listboxState === 0,
            disabled: t.disabled
        }), [
        t
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            ref: n,
            id: i,
            onClick: T
        },
        theirProps: c,
        slot: g,
        defaultTag: $cb7e0d651f5bfe47$var$$e,
        name: "Listbox.Label"
    });
}), $cb7e0d651f5bfe47$var$qe = "ul", $cb7e0d651f5bfe47$var$Xe = (0, $72af10e8efa1b073$export$617d79dae526d2cf).RenderStrategy | (0, $72af10e8efa1b073$export$617d79dae526d2cf).Static, $cb7e0d651f5bfe47$var$Je = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, o) {
    var s;
    let p = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: i = `headlessui-listbox-options-${p}` } = r, c = (0, $bLhVg._)(r, [
        "id"
    ]), t = $cb7e0d651f5bfe47$var$H("Listbox.Options"), u = $cb7e0d651f5bfe47$var$B("Listbox.Options"), n = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(t.optionsRef, o), T = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), g = (0, $1c5df13b27362c3d$export$fd183955ff4b45d9)(), A = (0, $42e7df3a446fef87$export$fc6fdf0ecf360e)(), m = (()=>A !== null ? A === (0, $42e7df3a446fef87$export$7254cc27399e90bd).Open : t.listboxState === 0)();
    (0, $7fPBF.useEffect)(()=>{
        var x;
        let a = t.optionsRef.current;
        !a || t.listboxState === 0 && a !== ((x = (0, $7f54eb20f4d7e5f1$export$b204af158042fbac)(a)) == null ? void 0 : x.activeElement) && a.focus({
            preventScroll: !0
        });
    }, [
        t.listboxState,
        t.optionsRef
    ]);
    let P = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((a)=>{
        switch(g.dispose(), a.key){
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Space:
                if (t.searchQuery !== "") return a.preventDefault(), a.stopPropagation(), u.search(a.key);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Enter:
                if (a.preventDefault(), a.stopPropagation(), t.activeOptionIndex !== null) {
                    let { dataRef: x } = t.options[t.activeOptionIndex];
                    u.onChange(x.current.value);
                }
                t.mode === 0 && (u.closeListbox(), (0, $ae5551858911f61c$export$12b26c28a05aa001)().nextFrame(()=>{
                    var x;
                    return (x = t.buttonRef.current) == null ? void 0 : x.focus({
                        preventScroll: !0
                    });
                }));
                break;
            case (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowDown,
                horizontal: (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowRight
            }):
                return a.preventDefault(), a.stopPropagation(), u.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Next);
            case (0, $54a7d1a042a6a79b$export$4659b591c19bdf3d)(t.orientation, {
                vertical: (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowUp,
                horizontal: (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).ArrowLeft
            }):
                return a.preventDefault(), a.stopPropagation(), u.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Previous);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Home:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).PageUp:
                return a.preventDefault(), a.stopPropagation(), u.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).First);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).End:
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).PageDown:
                return a.preventDefault(), a.stopPropagation(), u.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Last);
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Escape:
                return a.preventDefault(), a.stopPropagation(), u.closeListbox(), T.nextFrame(()=>{
                    var x;
                    return (x = t.buttonRef.current) == null ? void 0 : x.focus({
                        preventScroll: !0
                    });
                });
            case (0, $e76e97d8e8b64098$export$4b0075e5ea5e1f26).Tab:
                a.preventDefault(), a.stopPropagation();
                break;
            default:
                a.key.length === 1 && (u.search(a.key), g.setTimeout(()=>u.clearSearch(), 350));
                break;
        }
    }), y = (0, $b3352202c7c0b918$export$e3d20747ab930783)(()=>{
        var a, x, D;
        return (D = (a = t.labelRef.current) == null ? void 0 : a.id) != null ? D : (x = t.buttonRef.current) == null ? void 0 : x.id;
    }, [
        t.labelRef.current,
        t.buttonRef.current
    ]), S = (0, $7fPBF.useMemo)(()=>({
            open: t.listboxState === 0
        }), [
        t
    ]), h = {
        "aria-activedescendant": t.activeOptionIndex === null || (s = t.options[t.activeOptionIndex]) == null ? void 0 : s.id,
        "aria-multiselectable": t.mode === 1 ? !0 : void 0,
        "aria-labelledby": y,
        "aria-orientation": t.orientation,
        id: i,
        onKeyDown: P,
        role: "listbox",
        tabIndex: 0,
        ref: n
    };
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: h,
        theirProps: c,
        slot: S,
        defaultTag: $cb7e0d651f5bfe47$var$qe,
        features: $cb7e0d651f5bfe47$var$Xe,
        visible: m,
        name: "Listbox.Options"
    });
}), $cb7e0d651f5bfe47$var$Ye = "li", $cb7e0d651f5bfe47$var$Ze = (0, $72af10e8efa1b073$export$e43f39796049410c)(function(r, o) {
    let p = (0, $518ef203fb01499a$export$f680877a34711e37)(), { id: i = `headlessui-listbox-option-${p}`, disabled: c = !1, value: t } = r, u = (0, $bLhVg._)(r, [
        "id",
        "disabled",
        "value"
    ]), n = $cb7e0d651f5bfe47$var$H("Listbox.Option"), T = $cb7e0d651f5bfe47$var$B("Listbox.Option"), g = n.activeOptionIndex !== null ? n.options[n.activeOptionIndex].id === i : !1, A = n.isSelected(t), m = (0, $7fPBF.useRef)(null), P = (0, $2b7018cd7a1b1c81$export$86c4283a11f23f95)({
        disabled: c,
        value: t,
        domRef: m,
        get textValue () {
            var L, d;
            return (d = (L = m.current) == null ? void 0 : L.textContent) == null ? void 0 : d.toLowerCase();
        }
    }), y = (0, $c1aa65a6b3c277bc$export$f6a25a78204acc7e)(o, m);
    (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>{
        if (n.listboxState !== 0 || !g || n.activationTrigger === 0) return;
        let L = (0, $ae5551858911f61c$export$12b26c28a05aa001)();
        return L.requestAnimationFrame(()=>{
            var d, G;
            (G = (d = m.current) == null ? void 0 : d.scrollIntoView) == null || G.call(d, {
                block: "nearest"
            });
        }), L.dispose;
    }, [
        m,
        g,
        n.listboxState,
        n.activationTrigger,
        n.activeOptionIndex
    ]), (0, $9adada6c2c57de0b$export$ce5ed857c741fd71)(()=>T.registerOption(i, P), [
        P,
        i
    ]);
    let S = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((L)=>{
        if (c) return L.preventDefault();
        T.onChange(t), n.mode === 0 && (T.closeListbox(), (0, $ae5551858911f61c$export$12b26c28a05aa001)().nextFrame(()=>{
            var d;
            return (d = n.buttonRef.current) == null ? void 0 : d.focus({
                preventScroll: !0
            });
        }));
    }), h = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)(()=>{
        if (c) return T.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing);
        T.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Specific, i);
    }), s = (0, $d895e59b5353ecb4$export$24ebee078bde85c3)(), a = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((L)=>s.update(L)), x = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((L)=>{
        !s.wasMoved(L) || c || g || T.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Specific, i, 0);
    }), D = (0, $7ace9f16f57ff3f5$export$90fc3a17d93f704c)((L)=>{
        !s.wasMoved(L) || c || !g || T.goToOption((0, $128c1210d720a2c8$export$807a7eae502106e7).Nothing);
    }), Q = (0, $7fPBF.useMemo)(()=>({
            active: g,
            selected: A,
            disabled: c
        }), [
        g,
        A,
        c
    ]);
    return (0, $72af10e8efa1b073$export$b3890eb0ae9dca99)({
        ourProps: {
            id: i,
            ref: y,
            role: "option",
            tabIndex: c === !0 ? void 0 : -1,
            "aria-disabled": c === !0 ? !0 : void 0,
            "aria-selected": A,
            disabled: void 0,
            onClick: S,
            onFocus: h,
            onPointerEnter: a,
            onMouseEnter: a,
            onPointerMove: x,
            onMouseMove: x,
            onPointerLeave: D,
            onMouseLeave: D
        },
        theirProps: u,
        slot: Q,
        defaultTag: $cb7e0d651f5bfe47$var$Ye,
        name: "Listbox.Option"
    });
}), $cb7e0d651f5bfe47$export$8bad31ff872c7659 = Object.assign($cb7e0d651f5bfe47$var$Ne, {
    Button: $cb7e0d651f5bfe47$var$Qe,
    Label: $cb7e0d651f5bfe47$var$ze,
    Options: $cb7e0d651f5bfe47$var$Je,
    Option: $cb7e0d651f5bfe47$var$Ze
});



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $debc1b868f0a1333$var$CheckIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
        clipRule: "evenodd"
    }));
}
const $debc1b868f0a1333$var$ForwardRef = $7fPBF.forwardRef($debc1b868f0a1333$var$CheckIcon);
var $debc1b868f0a1333$export$2e2bcd8739ae039 = $debc1b868f0a1333$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $839a335830066041$var$ChevronUpDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $839a335830066041$var$ForwardRef = $7fPBF.forwardRef($839a335830066041$var$ChevronUpDownIcon);
var $839a335830066041$export$2e2bcd8739ae039 = $839a335830066041$var$ForwardRef;



function $b864ec3e3c1aff7d$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $b864ec3e3c1aff7d$export$2e2bcd8739ae039({ list: list, label: label, tooltip: tooltip, disableLabel: disableLabel, value: value, onChange: onChange, onBlur: onBlur, errorMessage: errorMessage, inputRef: inputRef, extraWide: extraWide, keepItShort: keepItShort, sendBackIndex: sendBackIndex, optional: optional, multiple: multiple, enabled: enabled, formatting: formatting }) {
    const { t: tAccountDetails } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const { t: tDashboard } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    function handleDisplayValue(item) {
        // if this is an array, display '[...]'
        if (Array.isArray(item)) return tAccountDetails("multipleSelected");
        // there is no item.name, so assume it's a list of items (does not apply for item === null, which should return Select...)
        if ((item === null || item === void 0 ? void 0 : item.name) === undefined && item !== null) return item;
        // there is item.name = null, so this is the "empty option" which must return null
        if ((item === null || item === void 0 ? void 0 : item.name) === null || item === null) return "Select...";
        // there is item.name, so display it
        if (item === null || item === void 0 ? void 0 : item.name) return item.name;
        return null;
    }
    const selectedValueLocal = sendBackIndex ? list[value] : handleDisplayValue(value);
    // eslint-disable-next-line max-len
    const valueLocal = value === undefined || value === null || Object.entries(value).length === 0 && typeof value !== "number" || Array.isArray(value) && value.length === 0 ? "Select..." : selectedValueLocal;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
        as: "div",
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        ref: inputRef,
        multiple: multiple,
        disabled: !enabled,
        className: formatting,
        children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    !disableLabel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex space-x-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Label, {
                                        className: "block text-xs sm:text-sm font-medium text-gray-700",
                                        children: label
                                    }),
                                    tooltip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                        info: tooltip
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "text-sm text-gray-500",
                                id: "email-optional",
                                children: optional ? "Optional" : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: `relative ${label ? "mt-1" : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                                className: `relative w-full cursor-default rounded-md ${errorMessage.length > 0 ? "border-2 border-red-500" : "border border-gray-300"}
              bg-white py-2 pl-3 pr-10 text-left shadow-sm
              focus:border-brandBlue-500 focus:outline-none focus:ring-1 focus:ring-brandBlue-600 text-sm`,
                                id: "dropdown",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "block truncate",
                                        children: valueLocal.name || valueLocal
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $839a335830066041$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                show: open,
                                as: (0, $7fPBF.Fragment),
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                                    // eslint-disable-next-line max-len
                                    className: `absolute z-20 mt-1 ${extraWide ? "w-80" : "w-full"} ${keepItShort ? "max-h-20" : "max-h-60"} overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`,
                                    children: (list || []).map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                            id: `dropdown-option-${String((item === null || item === void 0 ? void 0 : item.id) || (item === null ? "select" : item))}`,
                                            className: ({ active: active })=>$b864ec3e3c1aff7d$var$classNames(active ? "text-white bg-brandBlue-500" : "text-gray-900", "relative cursor-default select-none py-2 px-3 flex gap-2 items-baseline"),
                                            value: sendBackIndex ? idx : item,
                                            children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: $b864ec3e3c1aff7d$var$classNames(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                            children: handleDisplayValue(item)
                                                        }),
                                                        (item === null || item === void 0 ? void 0 : item.category) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: `text-xs font-light uppercase ${active ? "text-white" : "text-gray-400"}`,
                                                            children: tDashboard(`singleCategory.${item === null || item === void 0 ? void 0 : item.category}`)
                                                        }),
                                                        selected ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: $b864ec3e3c1aff7d$var$classNames(active ? "text-white" : "text-brandBlue-500", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $debc1b868f0a1333$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5",
                                                                "aria-hidden": "true"
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                        }, (item === null || item === void 0 ? void 0 : item.id) || (item === null ? "select" : item)))
                                })
                            })
                        ]
                    })
                ]
            })
    });
}
$b864ec3e3c1aff7d$export$2e2bcd8739ae039.propTypes = {
    list: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    disableLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array
    ]),
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    extraWide: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    keepItShort: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    sendBackIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    multiple: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$b864ec3e3c1aff7d$export$2e2bcd8739ae039.defaultProps = {
    label: "",
    tooltip: null,
    disableLabel: false,
    value: {},
    errorMessage: "",
    onBlur: ()=>{},
    inputRef: {},
    extraWide: false,
    keepItShort: false,
    sendBackIndex: false,
    optional: true,
    multiple: false,
    enabled: true,
    formatting: ""
};


const $3ed9d75bd3010070$var$countryNames = [
    "Germany",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Central African Rep",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Democratic Rep. of Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea North",
    "Korea South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "St Kitts & Nevis",
    "St Lucia",
    "Saint Vincent & the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
];
const $3ed9d75bd3010070$export$7bc41e2d36612b98 = [
    "DE",
    "AF",
    "AL",
    "DZ",
    "AD",
    "AO",
    "AG",
    "AR",
    "AM",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BT",
    "BO",
    "BA",
    "BW",
    "BR",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "CF",
    "TD",
    "CL",
    "CN",
    "CO",
    "KM",
    "CG",
    "CD",
    "CR",
    "HR",
    "CU",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "TL",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FJ",
    "FI",
    "FR",
    "GA",
    "GM",
    "GE",
    "GH",
    "GR",
    "GD",
    "GT",
    "GN",
    "GW",
    "GY",
    "HT",
    "HN",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IL",
    "IT",
    "CI",
    "JM",
    "JP",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "XK",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MR",
    "MU",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NO",
    "OM",
    "PK",
    "PW",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PL",
    "PT",
    "QA",
    "RO",
    "RU",
    "RW",
    "KN",
    "LC",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TG",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UY",
    "UZ",
    "VU",
    "VA",
    "VE",
    "VN",
    "YE",
    "ZM",
    "ZW"
];
function $3ed9d75bd3010070$export$63fb30b9076ed333(countryNameInput) {
    const index = $3ed9d75bd3010070$var$countryNames.findIndex((item)=>item === countryNameInput);
    return $3ed9d75bd3010070$export$7bc41e2d36612b98[index];
}
function $3ed9d75bd3010070$export$9494497b504eb2dc(countryCodeInput) {
    const index = $3ed9d75bd3010070$export$7bc41e2d36612b98.findIndex((item)=>item === countryCodeInput);
    return $3ed9d75bd3010070$var$countryNames[index];
}
var $3ed9d75bd3010070$export$2e2bcd8739ae039 = $3ed9d75bd3010070$var$countryNames;




function $b799bd13ee74234e$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $b799bd13ee74234e$var$getCountryCode(countryNameInput) {
    const index = (0, $3ed9d75bd3010070$export$2e2bcd8739ae039).findIndex((item)=>item === countryNameInput);
    return (0, $3ed9d75bd3010070$export$7bc41e2d36612b98)[index];
}
function $b799bd13ee74234e$var$YourSelection({ item: item }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex items-center cursor-default select-none border shadow-md bg-white rounded-md p-4",
        children: [
            item.logo ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: item.logo,
                alt: "",
                className: "flex h-10 w-10 flex-none items-center justify-center rounded-lg"
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: $b799bd13ee74234e$var$classNames("flex h-10 w-10 flex-none items-center justify-center rounded-lg", "bg-brandBlue-500"),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2ccb7dca0a77963b$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-white",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "ml-4 flex-auto",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: $b799bd13ee74234e$var$classNames("text-lg font-bold text-gray-700"),
                        children: item.providerInstitutionName
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: $b799bd13ee74234e$var$classNames("text-md sm:text-base text-gray-500"),
                        children: `${item.bic ? `BIC: ${item.bic}` : ""}${item.bic && (item.blz || item.city) ? "  |  " : ""}${item.blz ? `BLZ: ${item.blz}` : ""}${item.blz && item.city ? "  |  " : ""}${item.city ? `${item.city}` : ""}`
                    })
                ]
            })
        ]
    });
}
function $b799bd13ee74234e$var$Row({ index: index, style: style, data: data }) {
    const item = data[index];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
        value: item,
        style: style,
        className: ({ active: active })=>$b799bd13ee74234e$var$classNames("flex items-center cursor-default select-none rounded-md py-3", active && "bg-gray-100"),
        children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    item.logo ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: item.logo,
                        alt: "",
                        className: "flex h-10 w-10 flex-none items-center justify-center rounded-lg"
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: $b799bd13ee74234e$var$classNames("flex h-10 w-10 flex-none items-center justify-center rounded-lg", "bg-brandBlue-500"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2ccb7dca0a77963b$export$2e2bcd8739ae039), {
                            className: "h-6 w-6 text-white",
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "ml-4 flex-auto",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: $b799bd13ee74234e$var$classNames("text-sm font-medium truncate", active ? "text-gray-900" : "text-gray-700"),
                                children: item.providerInstitutionName
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: $b799bd13ee74234e$var$classNames("text-xs sm:text-sm", active ? "text-gray-700" : "text-gray-500"),
                                children: `${item.bic ? `BIC: ${item.bic}` : ""}${item.bic && (item.blz || item.city) ? "  |  " : ""}${item.blz ? `BLZ: ${item.blz}` : ""}${item.blz && item.city ? "  |  " : ""}${item.city ? `${item.city}` : ""}`
                            })
                        ]
                    })
                ]
            })
    }, item.id);
}
function $b799bd13ee74234e$var$ManualButton({ selectedInstitution: selectedInstitution, handleManualButton: handleManualButton, category: category }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "D3"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "col-start-2 col-span-2 mt-6 flex flex-col items-center justify-center",
        children: selectedInstitution && selectedInstitution === "manual" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "text-center prose mb-4",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("thisAccountManual")
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("thisAccountManual2", {
                        anInstitutionType: category === "deposits" ? t("aBank") : t("aBroker")
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("thisAccountManual3")
                })
            ]
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
            text: t("addManualAccount", {
                anInstitutionType: category === "deposits" ? t("aBank") : t("aBroker")
            }),
            onClick: handleManualButton,
            disabled: false,
            className: "mt-8"
        })
    });
}
function $b799bd13ee74234e$var$SelectProvider({ userInput: userInput, setUserInput: setUserInput, workflowStepStatus: workflowStepStatus, updateWorkflowStatus: updateWorkflowStatus, index: index, setMessageToShowBeforeNext: setMessageToShowBeforeNext, category: category }) {
    const [query, setQuery] = (0, $7fPBF.useState)("");
    const [comboboxDisabled, setComboboxDisabled] = (0, $7fPBF.useState)(true); // manages combobox disabled state
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [selectedInstitution, setSelectedInstitution] = (0, $7fPBF.useState)(null); // bank selected from the list
    const [list, setList] = (0, $7fPBF.useState)([]);
    const [nothingFound, setNothingFound] = (0, $7fPBF.useState)(null); // 'nothingFound' when no institutions are found, 'noSlots' when there are no more slots for foreign automated accounts (different UI message)
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "D3"
    });
    const { t: tApp } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app");
    function resetFurtherSteps() {
        updateWorkflowStatus(index, undefined); // step D2 reset
        updateWorkflowStatus(index + 1, undefined); // step D3 reset
        updateWorkflowStatus(index + 2, undefined); // step D4 reset
    }
    function handleManualButton() {
        setUserInput((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                syncType: "manual",
                provider: undefined
            }));
        resetFurtherSteps();
        setSelectedInstitution("manual");
        setMessageToShowBeforeNext(null);
        updateWorkflowStatus(index, true);
    }
    // handles changes to the selectedInstitution object (when user clicks an item in the dropdown or the manual bank button)
    (0, $7fPBF.useEffect)(()=>{
        // if selection is set, set userInput to selection; country has alredy been set automatically by the dropdown
        if (selectedInstitution !== "manual" && selectedInstitution !== null) {
            setUserInput((0, $2qxEV._)((0, $9tqwB._)({}, userInput), {
                syncType: "automatic",
                provider: selectedInstitution
            }));
            if (workflowStepStatus[index + 1] || workflowStepStatus[index + 2]) resetFurtherSteps();
             // handles case when user came back from step 4 and changed the bank
            updateWorkflowStatus(index, true);
        }
    }, [
        selectedInstitution
    ]);
    function handleCountryDropdownChange(newCountry) {
        let abortController;
        let abortToken = false;
        async function runGetInstitutions() {
            // if there was already a selected country and the user selected a new one now, reset the form
            if (newCountry && newCountry !== t("selectCountry")) {
                setComboboxDisabled(true);
                setSelectedInstitution(null);
                setLoading(true);
                resetFurtherSteps(); // if this runs
                setUserInput((0, $2qxEV._)((0, $9tqwB._)({}, userInput), {
                    country: newCountry,
                    countryCode: $b799bd13ee74234e$var$getCountryCode(newCountry),
                    syncType: null,
                    provider: undefined
                }));
                // check if there are any slots left for foreign automated accounts
                const user = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
                    forceRefresh: true
                }); // force-refresh the user attributes
                const exDeDepositSlots = JSON.parse(user.attributes["custom:ex_de_deposit_slots"]);
                // if there are no nulls left, set nothingFound to 'noSlots'
                if (newCountry !== "Germany" && exDeDepositSlots.every((i)=>i !== null)) setNothingFound("noSlots");
                else {
                    // prepare apiPromise and get data from API
                    let institutions = {};
                    try {
                        setList([]); // reset list (otherwise old list will be shown while new one is loading
                        setNothingFound(null); // reset nothingFound
                        if (abortToken) return;
                        abortController = new AbortController();
                        institutions = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "deposits/institutions", {
                            body: {
                                country: $b799bd13ee74234e$var$getCountryCode(newCountry),
                                category: category
                            },
                            headers: {
                                "Content-Type": "application/json"
                            },
                            abortController: abortController
                        });
                        if ((institutions || []).length === 0) {
                            setNothingFound("nothingFound"); // displays the UI message
                            handleManualButton(); // if no institutions are found, set the manual account automatically, the user does not have to click the button
                        } else setList((institutions || []).map((_param)=>{
                            var { id: id, name: name } = _param, i = (0, $bLhVg._)(_param, [
                                "id",
                                "name"
                            ]);
                            return (0, $2qxEV._)((0, $9tqwB._)({}, i), {
                                providerInstitutionId: id,
                                providerInstitutionName: name
                            });
                        }));
                    } catch (error) {
                        // Handle the error appropriately
                        console.error("Error fetching institutions:", error);
                        setNothingFound("nothingFound");
                    }
                }
                setLoading(false);
                setComboboxDisabled(false);
            }
        }
        runGetInstitutions();
        return function cleanupGetInstitutions() {
            abortToken = true;
            setLoading(false);
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
        };
    }
    // run handleCountryDropdownChange when the component mounts
    (0, $7fPBF.useEffect)(()=>{
        handleCountryDropdownChange(userInput.country);
    }, []);
    // this is the search filter
    const filteredItems = query === "" ? list.filter((r)=>r.blz !== "DEMO0001" && r.bic !== "HYVEDEMM488") : list.filter((institution)=>{
        const q = query.toLowerCase();
        const name = (institution.providerInstitutionName || "").toLowerCase();
        const city = (institution.city || "").toLowerCase();
        const blz = (institution.blz || "").toLowerCase();
        const bic = (institution.bic || "").toLowerCase();
        return name.includes(q) || city.includes(q) || blz.includes(q) || bic.includes(q);
    });
    const spaceForDropdown = window.innerHeight - 525;
    const selectCountry = t("selectCountry"); // translation to be displayed as the first item in the country dropdown
    const countryList = [
        selectCountry
    ].concat((0, $3ed9d75bd3010070$export$2e2bcd8739ae039).map((item)=>tApp(item)));
    const yourInstitutionType = category === "stocks" ? t("yourBroker") : t("yourBank");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "select-provider-country-header",
                className: "",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: t("accountCountry")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: t("accountCountryBody")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "select-provider-country-dropdown",
                className: "mt-5 md:mt-0 col-span-3 lg:col-span-2 sm:grid sm:grid-cols-2 md:gap-6 relative z-30",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-4 md:mt-0 col-span-3 xl:col-span-2 text-sm md:text-base",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                        list: countryList,
                        label: t("accountCountry"),
                        value: userInput.country || selectCountry,
                        onChange: handleCountryDropdownChange,
                        optional: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "col-start-1 mt-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "mt-2 text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: t("select", {
                            yourInstitutionType: yourInstitutionType
                        })
                    }),
                    userInput.syncType !== "automatic" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-4 text-sm text-gray-500",
                                children: t("findYourBank", {
                                    yourInstitutionType: yourInstitutionType
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-4 text-sm text-gray-500",
                                children: t("cannotFind", {
                                    yourInstitutionType: yourInstitutionType
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: t("intelligentImport")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "z-20 mt-8 col-span-3 xl:col-span-2 relative",
                children: [
                    !loading && !comboboxDisabled && selectedInstitution && selectedInstitution !== "manual" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "absolute inset-x-0 top-16 md:top-20 col-start-2 col-span-2 flex justify-center mt-12",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex flex-col gap-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-lg sm:text-xl font-bold",
                                    children: t("youHaveSelected")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b799bd13ee74234e$var$YourSelection, {
                                    item: selectedInstitution
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "w-full mt-2 md:mt-10"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b799bd13ee74234e$var$ManualButton, {
                                    handleManualButton: handleManualButton,
                                    selection: selectedInstitution,
                                    category: category
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e), {
                        as: "div",
                        value: selectedInstitution,
                        onChange: setSelectedInstitution,
                        className: "transform overflow-hidden rounded-md bg-white shadow-md ring-1 ring-black ring-opacity-5 transition-all min-h-[10rem]",
                        children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "px-2 xs:px-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95165b7ebafa73cf$export$2e2bcd8739ae039), {
                                                className: "pointer-events-none absolute top-3.5 left-2 h-5 w-5 text-gray-400",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Input, {
                                                className: "h-12 w-full border-0 bg-transparent pl-8 pr-4 text-gray-800 placeholder-gray-400 focus:ring-0 sm:text-sm",
                                                placeholder: `${t("search")}...`,
                                                displayValue: (item)=>item && item.providerInstitutionName,
                                                onChange: (event)=>setQuery(event.target.value)
                                            })
                                        ]
                                    }),
                                    (selectedInstitution === null || open) && filteredItems.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Options, {
                                            static: true,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d72989d8b3846905$export$ea50ab61e1198ee3), {
                                                style: {
                                                    height: spaceForDropdown
                                                },
                                                totalCount: filteredItems.length,
                                                // eslint-disable-next-line react/no-unstable-nested-components
                                                itemContent: (idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b799bd13ee74234e$var$Row, {
                                                        index: idx,
                                                        data: filteredItems
                                                    })
                                            })
                                        })
                                    }),
                                    query !== "" && filteredItems.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "border-t border-gray-100 py-14 px-6 text-center text-sm sm:px-14",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "mt-4 font-semibold text-gray-900",
                                                children: t("noResultsFound")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "mt-2 text-gray-500",
                                                children: t("couldNotFindAnything")
                                            })
                                        ]
                                    })
                                ]
                            })
                    }),
                    comboboxDisabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "absolute inset-0 min-h-[12rem] bg-gray-300 text-gray-900 opacity-70 flex justify-center items-center sm:rounded-md",
                        "aria-hidden": "true",
                        children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 animate-spin text-gray-700 mb-4"
                                }),
                                t("retrievingInstitutions")
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                    className: "h-6 w-6 text-brandBlue-600 mr-1.5",
                                    "aria-hidden": "true"
                                }),
                                t("selectCountryFirst")
                            ]
                        })
                    }),
                    !comboboxDisabled && nothingFound === "nothingFound" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "absolute inset-0 bg-gray-300 text-gray-900 opacity-70 p-2 flex justify-center items-center sm:rounded-md",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 text-brandBlue-600 mr-1.5 flex-shrink-0",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "prose text-sm sm:text-base",
                                children: t("nothingFound", {
                                    yourInstitutions: category === "deposits" ? t("banks") : t("brokers")
                                })
                            })
                        ]
                    }),
                    !comboboxDisabled && nothingFound === "noSlots" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "absolute inset-0 bg-gray-300 text-gray-900 opacity-70 p-2 flex justify-center items-center sm:rounded-md",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 text-brandBlue-600 mr-1.5 flex-shrink-0",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "prose text-sm sm:text-base",
                                children: t("noSlots", {
                                    yourInstitutions: category === "deposits" ? t("banks") : t("brokers")
                                })
                            })
                        ]
                    })
                ]
            }),
            !comboboxDisabled && (selectedInstitution === null || selectedInstitution === "manual") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b799bd13ee74234e$var$ManualButton, {
                handleManualButton: handleManualButton,
                selectedInstitution: selectedInstitution,
                category: category
            })
        ]
    });
}
$b799bd13ee74234e$var$SelectProvider.propTypes = {
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    workflowStepStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
};
$b799bd13ee74234e$var$SelectProvider.defaultProps = {
    userInput: {},
    setUserInput: {}
};
var $b799bd13ee74234e$export$2e2bcd8739ae039 = $b799bd13ee74234e$var$SelectProvider;


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







function $a01d16f39a7b54eb$export$2e2bcd8739ae039({ userInput: userInput, setUserInput: setUserInput, index: index, setDisplayedStep: setDisplayedStep, category: category, workflowStepStatus: workflowStepStatus, updateWorkflowStatus: updateWorkflowStatus }) {
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const globalAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    // ----------------------
    // INITIALISE COMPONENT
    // ----------------------
    // when initialised, show spinner and get the provider URL from the backend
    // in parallel get state, zip it and put in localStorage; add random password
    // then redirect to that URL
    (0, $7fPBF.useEffect)(()=>{
        // let abortToken = false;
        // if the user pressed back from step 4, do nothing and let the user go to step 2; if there are changes in step 2, they should reset workflowStepStatuts for steps 3 and 4
        if (workflowStepStatus[index]) {
            setDisplayedStep(index - 1);
            return ()=>{};
        }
        // get the provider URL from the backend
        let abortController;
        async function runGetWebForm() {
            const addAccountState = {
                category: category,
                userInput: userInput,
                workflowStepStatus: workflowStepStatus,
                displayedStep: index
            };
            const providerId = userInput.countryCode === "DE" ? "finapi" : "gocardless";
            try {
                abortController = new AbortController();
                const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "deposits/webform", {
                    body: {
                        country: userInput.countryCode,
                        userLanguage: i18n.language,
                        institutionId: userInput.provider.providerInstitutionId,
                        redirectUrl: `${window.location.origin}/addAccountCallback`,
                        abortUrl: `${window.location.origin}/${i18n.language}/app/dashboard`,
                        category: category
                    },
                    headers: {
                        "Content-Type": "application/json"
                    },
                    abortController: abortController
                });
                console.log("response", response);
                // returns { url, processId } or { url: null, processId: null, bankConnectionId, accounts } in the case handled just below
                // webform will return an url and a processId
                // ----------------------------------
                // PREPARE DATA FOR SUBSEQUENT STEPS
                // ----------------------------------
                // generate a list of existing accounts per provider, which will be used in AccountData to filter out already existing accounts
                const existingAccounts = globalAccounts// leave only those which have the providerId for the country that user is adding an account for and the providerInstitutionId that the user is adding
                .filter((a)=>{
                    var _a_tags_provider, _a_tags;
                    return a.category === category && String((_a_tags = a.tags) === null || _a_tags === void 0 ? void 0 : (_a_tags_provider = _a_tags.provider) === null || _a_tags_provider === void 0 ? void 0 : _a_tags_provider[providerId].providerInstitutionId) === String(userInput.provider.providerInstitutionId);
                });
                // ----------------------------------
                // HANDLE CASE: WEBFORM NEEDED
                // (getWebForm returned an url)
                // ----------------------------------
                // if deposits/webform sent back a url, it means the user needs to go through a webform
                // prepare the state to be saved in localStorage and send the user to the webform
                if (response.url) {
                    // only add existingAccounts when there are any
                    if (existingAccounts.length > 0) addAccountState.userInput.existingAccounts = existingAccounts;
                    console.log("existingAccounts", existingAccounts);
                    addAccountState.userInput.provider.processId = response.processId;
                    // if this is a GC account, once we process the new webform, all the accounts will have new providerAccountIds and there will be a new providerAccessId (requisitionId)
                    // so we need to let the process know that those things need to be replaced in existing accounts once the new values are known
                    if (providerId === "gocardless") addAccountState.userInput.reconcileAccounts = true;
                    // get WebForm from API & zip addAccountState
                    await (0, $e4f4fda4de0cf2ab$export$310b945cb782b1b7)(addAccountState, "addAccountState");
                    window.dispatchEvent(new CustomEvent("setAlert", {
                        detail: {
                            id: "infoRedirectToProvider",
                            caller: "RedirectToProvider",
                            callbackOk: ()=>{
                                console.log("RedirectToProvider - Alert callback: redirecting to:", response.url);
                                window.location.href = response.url;
                            },
                            callbackCancel: ()=>{
                                setDisplayedStep(index - 1);
                            // TODO do we need to setWorkflowStatus as well?
                            }
                        }
                    }));
                } else {
                    // ----------------------------------
                    // HANDLE CASE: WEBFORM NOT NEEDED
                    // (getWebForm returned no url)
                    // ----------------------------------
                    // this can happen only for FinAPI, because GoCardless always requires a new webform
                    // if there is NO url, it means the user has an existing connection with the provider which can be used to find / add any new accounts
                    // in which case we need to update userInput and proceed directly to the next workflow step
                    // we will also receive all (including new) existing accounts from the backend, which we will need to pass via userInput to AccountData, so that it doesn't have to get that later again
                    setUserInput((prev)=>(0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                            provider: (0, $2qxEV._)((0, $9tqwB._)({}, prev.provider), {
                                processId: response.processId
                            }),
                            providerAccessId: response.bankConnectionId
                        }), existingAccounts.length > 0 && {
                            existingAccounts: existingAccounts
                        }, response.accounts && response.accounts.length > 0 && {
                            retrievedProviderAccounts: response.accounts
                        }));
                    // go to next step
                    updateWorkflowStatus(index, true);
                    setDisplayedStep(index + 1);
                }
            } catch (error) {
                console.error("Error fetching WebForm url:", error);
                // go back to previous workflow step by setting its workflows status to false
                if (error.message !== "Abort for runGetWebForm has been issued") {
                    dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("generalError"));
                    setDisplayedStep(index - 1);
                }
            }
        }
        if (userInput.syncType === "automatic") runGetWebForm();
        else {
            // simply go to next step if this is a manual account
            updateWorkflowStatus(index, true);
            setDisplayedStep(index + 1);
        }
        return function cleanupGetWebForm() {
            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "absolute inset-0 flex items-center justify-center",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                className: "w-10 h-10 text-gray-400 animate-spin"
            })
        })
    });
}
$a01d16f39a7b54eb$export$2e2bcd8739ae039.propTypes = {
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    setDisplayedStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    workflowStepStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool).isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");









/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $bc1291ab014b70a2$export$2e2bcd8739ae039({ idx: idx, formState: formState, register: register, getValues: getValues, userInput: userInput, selectDepositAccounts: selectDepositAccounts, refreshUserInputAndWorkflowStatus: refreshUserInputAndWorkflowStatus }) {
    var _formState_errors_accountArray_idx, _formState_errors_accountArray, _formState_errors_accountArray_idx1, _formState_errors_accountArray1;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "D4"
    });
    (0, $7fPBF.useEffect)(()=>{
        refreshUserInputAndWorkflowStatus();
    }, [
        formState
    ]);
    const connectedDepositMode = getValues(`accountArray.${idx}.connectedDepositMode`);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: t("whenIBuy")
                    }),
                    ((_formState_errors_accountArray = formState.errors.accountArray) === null || _formState_errors_accountArray === void 0 ? void 0 : (_formState_errors_accountArray_idx = _formState_errors_accountArray[idx]) === null || _formState_errors_accountArray_idx === void 0 ? void 0 : _formState_errors_accountArray_idx.connectedDepositMode) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-red-600",
                        id: "connectedDepositMode-error",
                        children: (_formState_errors_accountArray1 = formState.errors.accountArray) === null || _formState_errors_accountArray1 === void 0 ? void 0 : (_formState_errors_accountArray_idx1 = _formState_errors_accountArray1[idx]) === null || _formState_errors_accountArray_idx1 === void 0 ? void 0 : _formState_errors_accountArray_idx1.connectedDepositMode.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                id: "existingAccount",
                                name: "existingAccount",
                                type: "radio",
                                value: "existingAccount",
                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                            }, register(`accountArray.${idx}.connectedDepositMode`, {
                                required: {
                                    value: true,
                                    message: t("connectedDepositMode.error")
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "existingAccount",
                                className: "ml-3 block text-sm font-medium text-gray-700",
                                children: t("existingAccount")
                            })
                        ]
                    }),
                    connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "xl:flex xl:items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "connectedDepositAccountObject",
                                className: "flex text-sm font-medium",
                                children: t("existingAccountSelect")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1 ml-2",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                    id: "connectedDepositAccountObject",
                                    name: "connectedDepositAccountObject",
                                    className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                }, register(`accountArray.${idx}.connectedDepositAccountObject`)), {
                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: a.id,
                                            children: a.name
                                        }, a.id))
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center col-start-1",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                id: "createTechnicalAccount",
                                name: "createTechnicalAccount",
                                type: "radio",
                                value: "createTechnicalAccount",
                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                            }, register(`accountArray.${idx}.connectedDepositMode`, {
                                required: {
                                    value: true,
                                    message: t("connectedDepositMode.error")
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "createTechnicalAccount",
                                className: "ml-3 block text-sm font-medium text-gray-700",
                                children: t("createTechnicalAccount")
                            })
                        ]
                    }),
                    connectedDepositMode === "createTechnicalAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "xl:flex xl:items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "currency",
                                className: "flex text-sm font-medium",
                                children: t("createTechnicalAccountCurrency")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1 xl:mt-0 xl:ml-2",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                    id: `${idx}.currency`,
                                    name: `${idx}.currency`,
                                    className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md min-w-[5.25rem]"
                                }, register(`accountArray.${idx}.currency`)), {
                                    children: (0, $796ea4636350e237$export$a01df35ce0858603).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            children: c
                                        }, c))
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center col-start-1",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                id: "createAccountLater",
                                name: "createAccountLater",
                                type: "radio",
                                value: "createAccountLater",
                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                            }, register(`accountArray.${idx}.connectedDepositMode`, {
                                required: {
                                    value: true,
                                    message: t("connectedDepositMode.error")
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "createAccountLater",
                                className: "ml-3 block text-sm font-medium text-gray-700",
                                children: t("createAccountLater")
                            })
                        ]
                    }),
                    connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                className: "h-10 w-10 text-brandBlue-500 self-start",
                                "aria-hidden": "true"
                            }),
                            t("createAccountLaterDescription")
                        ]
                    })
                ]
            })
        ]
    });
}
$bc1291ab014b70a2$export$2e2bcd8739ae039.propTypes = {
    idx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    formState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    getValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    selectDepositAccounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    refreshUserInputAndWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/require-default-props */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $48391eba9165ee71$var$ExclamationCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $48391eba9165ee71$var$ForwardRef = $7fPBF.forwardRef($48391eba9165ee71$var$ExclamationCircleIcon);
var $48391eba9165ee71$export$2e2bcd8739ae039 = $48391eba9165ee71$var$ForwardRef;



function $4f63b78080bad86a$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $4f63b78080bad86a$export$2e2bcd8739ae039({ id: id, myIndex: myIndex, type: type, autoComplete: autoComplete, label: label, toolTip: toolTip, placeholder: placeholder, optional: optional, register: register, errors: errors, setValue: setValue, validationRules: validationRules, formatting: formatting, enabled: enabled }) {
    var _errors_accountArray_myIndex, _errors_accountArray;
    $4f63b78080bad86a$export$2e2bcd8739ae039.propTypes = {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        myIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        toolTip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        validationRules: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
        setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        enabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
    };
    $4f63b78080bad86a$export$2e2bcd8739ae039.defaultProps = {
        optional: false,
        toolTip: "",
        validationRules: {},
        errors: {},
        formatting: "",
        enabled: true
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `col-span-1 ${formatting}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                        htmlFor: "email",
                        className: "text-sm font-medium text-gray-700 flex justify-start",
                        children: [
                            label,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: toolTip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-500",
                        id: "email-optional",
                        children: optional ? "Optional" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-1 relative rounded-md shadow-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                        id: id,
                        type: type,
                        disabled: !enabled,
                        autoComplete: autoComplete,
                        name: id,
                        className: $4f63b78080bad86a$var$classNames(errors[id] ? "border-red-300 text-red-900  placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-500 focus:ring-brandBlue-500 focus:border-brandBlue-500", "block w-full pr-2 focus:outline-none  sm:text-sm rounded-md", enabled ? "text-gray-700" : "text-gray-400"),
                        placeholder: placeholder,
                        defaultValue: "",
                        "aria-invalid": "true",
                        "aria-describedby": "username-error"
                    }, register(`accountArray[${myIndex}].${id}`, validationRules))),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: $4f63b78080bad86a$var$classNames(!errors[id] ? "hidden" : "", "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48391eba9165ee71$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-red-500",
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                id: `${id}-error`,
                children: ((_errors_accountArray = errors.accountArray) === null || _errors_accountArray === void 0 ? void 0 : (_errors_accountArray_myIndex = _errors_accountArray[myIndex]) === null || _errors_accountArray_myIndex === void 0 ? void 0 : _errors_accountArray_myIndex[id]) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: errors.accountArray[myIndex][id].message
                })
            })
        ]
    });
}


/* eslint-disable react/require-default-props */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ 
parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");



function $0b5c76682cc743c6$export$2e2bcd8739ae039({ id: id, label: label, toolTip: toolTip, validationRules: validationRules, errors: errors, optional: optional, control: control, list: list, enabled: enabled, formatting: formatting }) {
    // id comes as "valuationParameters.<fieldName>"
    // if the list from schema does not need translating, pass it here
    // otherwise the component will attempt to get the list from the translation file (schema.RealEstate)
    const { t: tSchema } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app");
    const { t: tAddAccount } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    // the parameter values for dropdown parameters are in account.parameters.<fieldName>
    // this returns an object with key-value pairs of the form { <fieldName>: <label> }
    // eslint-disable-next-line max-len
    const calculatedList = list.length === 0 ? Object.entries(tSchema(`schema.realEstate.account.${id.replace("valuationP", "p")}`, {
        returnObjects: true
    })).map(([key, value])=>({
            id: key,
            name: value
        })) : list;
    const disableLabel = label === "";
    const calculatedLabel = label || tAddAccount(`R1.${id}.label`);
    // if the dropdown's id is nested (accountsArray.0.fieldName), the errors cannot be accessed by calling errors[id], hence the usage of get function
    const errorMessage = (0, $18522b4fc47f45cb$export$3988ae62b71be9a3)(errors, id, {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `col-span-1 ${formatting}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                control: control,
                name: id,
                rules: validationRules,
                render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>{
                    // the component would send back the same item it received, i.e. { id, name } -- the form only needs id
                    function localOnChange(item) {
                        if (item === null || !(item === null || item === void 0 ? void 0 : item.id) && (item === null || item === void 0 ? void 0 : item.id) !== 0) // handle case when id is 0
                        onChange(item);
                        else // if item is not null and has an id, send only the id
                        onChange(item.id);
                    }
                    // that same translation has to happen on value, which is the id and needs to be translated to { id, name }
                    const calculatedValue = calculatedList.find((listItem)=>{
                        if (listItem === null || listItem === 0 || !(listItem === null || listItem === void 0 ? void 0 : listItem.id) && (listItem === null || listItem === void 0 ? void 0 : listItem.id) !== 0) return value === listItem; // handle null or string, handle case when id is 0
                        return value === listItem.id; // handle { id, name }
                    });
                    if (id === "payoutsFrequency") console.log("payout", calculatedValue, value, calculatedList);
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                        id: id,
                        list: calculatedList,
                        disableLabel: disableLabel,
                        label: calculatedLabel,
                        tooltip: toolTip,
                        value: calculatedValue,
                        onChange: localOnChange,
                        onBlur: onBlur,
                        inputRef: ref,
                        optional: optional,
                        enabled: enabled
                    });
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: `${!errors[id] ? "hidden" : ""} absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none`,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48391eba9165ee71$export$2e2bcd8739ae039), {
                    className: "h-5 w-5 text-red-500",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                id: "dropdown-error",
                children: errorMessage.message
            })
        ]
    });
}
$0b5c76682cc743c6$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    list: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    validationRules: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    toolTip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$0b5c76682cc743c6$export$2e2bcd8739ae039.defaultProps = {
    validationRules: ()=>{},
    label: null,
    toolTip: null,
    optional: true,
    list: [],
    enabled: true,
    formatting: ""
};




parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $f052d78aec7029ba$export$2e2bcd8739ae039({ id: id, onChange: onChange, onBlur: onBlur, label: label, tooltip: tooltip, optional: optional, value: value, formatting: formatting, tabIndex: tabIndex, inputRef: inputRef }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    let displayedText;
    switch(value){
        case true:
            displayedText = t("site:general.yes");
            break;
        case false:
            displayedText = t("site:general.no");
            break;
        default:
            displayedText = "?";
    }
    function handleClick() {
        console.log("SwitchComponent handleClick, currentValue is:", value);
        if (value === true) onChange(false);
        if (value === false) onChange(null);
        if (!value && value !== false) onChange(true);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `${formatting} flex flex-col space-y-1`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between text-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: id || "switch-button",
                                className: "font-medium text-gray-700",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: tooltip
                            })
                        ]
                    }),
                    optional && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-500",
                        id: "email-optional",
                        children: "Optional"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex items-center w-full",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex gap-2 items-center w-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: id,
                        // eslint-disable-next-line max-len
                        className: `${optional} rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500`,
                        onClick: handleClick,
                        tabIndex: tabIndex,
                        ref: inputRef,
                        children: displayedText
                    })
                })
            })
        ]
    });
}
$f052d78aec7029ba$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any
        })
    ])
};
$f052d78aec7029ba$export$2e2bcd8739ae039.defaultProps = {
    id: undefined,
    onBlur: ()=>{},
    optional: true,
    formatting: "",
    tabIndex: undefined,
    inputRef: undefined
};


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $1c84e5a08efe7756$var$SwitchComponentGivenTaken({ id: id, idx: idx, onChange: onChange, onBlur: onBlur, label: label, tooltip: tooltip, optional: optional, value: value, errors: errors }) {
    var _errors_accountArray_idx, _errors_accountArray;
    $1c84e5a08efe7756$var$SwitchComponentGivenTaken.propTypes = {
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        idx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array
    };
    $1c84e5a08efe7756$var$SwitchComponentGivenTaken.defaultProps = {
        onBlur: ()=>{},
        optional: true,
        errors: []
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "loans"
    });
    let displayedText;
    switch(value){
        case "granted":
            displayedText = t("given");
            break;
        case "received":
            displayedText = t("taken");
            break;
        default:
            displayedText = "?";
    }
    function handleClick() {
        if (value === "received") onChange("granted");
        if (value === "granted") onChange(undefined);
        if (!value && value !== false) onChange("received");
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "col-span-1",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between text-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "switch-button",
                                className: "text-gray-700 font-medium",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: tooltip
                            })
                        ]
                    }),
                    optional && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-400",
                        id: "email-optional",
                        children: "Optional"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex items-center w-full mt-1",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex gap-2 items-center w-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line max-len
                        className: `${optional} rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500`,
                        onClick: handleClick,
                        children: displayedText
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                id: `${id}-error`,
                children: ((_errors_accountArray = errors.accountArray) === null || _errors_accountArray === void 0 ? void 0 : (_errors_accountArray_idx = _errors_accountArray[idx]) === null || _errors_accountArray_idx === void 0 ? void 0 : _errors_accountArray_idx[id]) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: errors.accountArray[idx][id].message
                })
            })
        ]
    });
}
function $1c84e5a08efe7756$export$2e2bcd8739ae039({ idx: idx, formState: formState, control: control, register: register, watch: watch, getValues: getValues, setValue: setValue, userInput: userInput, selectDepositAccounts: selectDepositAccounts, refreshUserInputAndWorkflowStatus: refreshUserInputAndWorkflowStatus }) {
    var _useSelector, _formState_errors_accountArray_idx, _formState_errors_accountArray, _formState_errors_accountArray_idx1, _formState_errors_accountArray1, _formState_errors_accountArray_idx2, _formState_errors_accountArray2;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "loans"
    });
    const selectedProjects = (_useSelector = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects)) === null || _useSelector === void 0 ? void 0 : _useSelector.map((p)=>({
            id: p.id,
            name: p.name
        }));
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // console.log('DEBUG AccountDataLoanFields', idx, formState, userInput, selectDepositAccounts);
    (0, $7fPBF.useEffect)(()=>{
        refreshUserInputAndWorkflowStatus();
    }, [
        formState
    ]);
    (0, $7fPBF.useEffect)(()=>{
        var _userInput_accountArray_idx, _userInput_accountArray_idx1;
        // if there are no projects, fetch them
        if (selectedProjects.length === 0) dispatch((0, $101425bdfe5b6af9$export$b00a271f69f3d728)());
        // pre-set default values for both checkboxes
        if (userInput.accountArray && ((_userInput_accountArray_idx = userInput.accountArray[idx]) === null || _userInput_accountArray_idx === void 0 ? void 0 : _userInput_accountArray_idx.calculateUntilEnd) === undefined) setValue(`accountArray.${idx}.calculateUntilEnd`, true);
        if (userInput.accountArray && ((_userInput_accountArray_idx1 = userInput.accountArray[idx]) === null || _userInput_accountArray_idx1 === void 0 ? void 0 : _userInput_accountArray_idx1.projectCreateNew) === undefined) setValue(`accountArray.${idx}.projectCreateNew`, true);
    }, []);
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: `accountArray.${idx}.interestRate`,
        control: control
    });
    const watchCalculateUntilEnd = watch(`accountArray.${idx}.calculateUntilEnd`);
    const watchType = watch(`accountArray.${idx}.type`);
    const watchAnnuitySubtype = watch(`accountArray.${idx}.annuitySubtype`);
    const watchFixedPrincipalSubtype = watch(`accountArray.${idx}.fixedPrincipalSubtype`);
    const watchInterestRateSimple = watch(`accountArray.${idx}.interestRateSimple`); // the actual interest rate as number
    const watchInterestRateAdvancedView = watch(`accountArray.${idx}.interestRateAdvancedView`); // whether or not to show the advanced view
    const watchConnectedDepositMode = watch(`accountArray.${idx}.connectedDepositMode`); // whether to use an existing account or create a new one
    const watchProjectCreateNew = watch(`accountArray.${idx}.projectCreateNew`);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("provideSomeParameters")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-2 xl:col-span-3 grid grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                        id: "loanAmount",
                        myIndex: idx,
                        type: "number",
                        autoComplete: "off",
                        label: t("loanAmount.label"),
                        toolTip: t("loanAmount.tooltip"),
                        placeholder: "250000",
                        register: register,
                        setValue: setValue,
                        validationRules: {
                            required: {
                                value: true,
                                message: t("loanAmount.error")
                            }
                        },
                        errors: formState.errors
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: `accountArray.${idx}.direction`,
                        control: control,
                        rules: {
                            required: {
                                value: true,
                                message: t("direction.error")
                            }
                        },
                        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1c84e5a08efe7756$var$SwitchComponentGivenTaken, {
                                id: "direction",
                                idx: idx,
                                onChange: onChange,
                                onBlur: onBlur,
                                value: value,
                                inputRef: ref,
                                label: t("direction.label"),
                                toolTip: t("direction.tooltip"),
                                optional: false,
                                errors: formState.errors
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                        id: `accountArray.${idx}.period`,
                        list: [
                            {
                                id: "month",
                                name: t("period.month")
                            },
                            {
                                id: "quarter",
                                name: t("period.quarter")
                            },
                            {
                                id: "year",
                                name: t("period.year")
                            }
                        ],
                        label: t("period.label"),
                        placeholder: t("period.placeholder"),
                        toolTip: t("period.tooltip"),
                        register: register,
                        validationRules: {
                            required: {
                                value: true,
                                message: t("period.error")
                            }
                        },
                        errors: formState.errors,
                        control: control,
                        optional: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("interestRate.text")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "grid grid-cols-3 gap-2 content-baseline col-span-2 lg:col-span-1 ",
                children: !watchInterestRateAdvancedView ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                            formatting: "col-span-2",
                            id: "interestRateSimple",
                            myIndex: idx,
                            type: "number",
                            autoComplete: "off",
                            label: t("interestRate.label"),
                            toolTip: t("interestRate.tooltip"),
                            placeholder: "4",
                            register: register,
                            setValue: setValue,
                            validationRules: {
                                required: {
                                    value: true,
                                    message: t("interestRate.error")
                                }
                            },
                            errors: formState.errors
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            formatting: "self-start mt-6",
                            text: t("advanced"),
                            size: "xl",
                            onClick: ()=>{
                                append({
                                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().format("YYYY-MM-DD"),
                                    value: watchInterestRateSimple
                                });
                                setValue(`accountArray.${idx}.interestRateAdvancedView`, true);
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "col-span-full grid grid-cols-6 gap-3 text-sm xs:text-base items-start text-gray-700",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "col-span-6",
                            children: t("interestRate.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "ml-1 -mb-1 text-sm text-left col-span-3",
                            children: "Effective from"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "ml-1 -mb-1 text-sm text-left col-span-2",
                            children: "Value"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                        fields.map((item, index)=>{
                            var _formState_errors_interestRate_index, _formState_errors_interestRate, _formState_errors_interestRate_index1, _formState_errors_interestRate1;
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "col-span-3",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                type: "date",
                                                id: `date-${index}`,
                                                name: `date-${index}`,
                                                className: "block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                            }, register(`accountArray.${idx}.interestRate..${index}.date`, {
                                                required: true
                                            }))),
                                            ((_formState_errors_interestRate = formState.errors.interestRate) === null || _formState_errors_interestRate === void 0 ? void 0 : (_formState_errors_interestRate_index = _formState_errors_interestRate[index]) === null || _formState_errors_interestRate_index === void 0 ? void 0 : _formState_errors_interestRate_index.date) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "text-xs text-red-500",
                                                children: t("errorFieldRequired")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                type: "number",
                                                step: 3,
                                                name: `value-${index}`,
                                                id: `value-${index}`,
                                                className: "block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                            }, register(`accountArray.${idx}.interestRate.${index}.value`, {
                                                required: true
                                            }))),
                                            ((_formState_errors_interestRate1 = formState.errors.interestRate) === null || _formState_errors_interestRate1 === void 0 ? void 0 : (_formState_errors_interestRate_index1 = _formState_errors_interestRate1[index]) === null || _formState_errors_interestRate_index1 === void 0 ? void 0 : _formState_errors_interestRate_index1.value) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "text-xs text-red-500",
                                                children: t("errorFieldRequired")
                                            })
                                        ]
                                    }),
                                    index !== 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        Icon: (0, $125f450ca02db1e2$export$2e2bcd8739ae039),
                                        onClick: ()=>remove(index),
                                        size: "lg"
                                    })
                                ]
                            });
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            Icon: (0, $dc348e8ecf02df23$export$2e2bcd8739ae039),
                            onClick: ()=>append(),
                            formatting: "w-full"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("endDate.text")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                id: "endDate",
                myIndex: idx,
                type: "date",
                autoComplete: "off",
                label: t("endDate.label"),
                toolTip: t("endDate.tooltip"),
                placeholder: "1",
                enabled: !watchCalculateUntilEnd,
                optional: true,
                setValue: setValue,
                // calculateUntilEnd must be true and the date is same or after today; otherwise throw error
                validationRules: {
                    validate: (value)=>watchCalculateUntilEnd || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value).isSame((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(), "day") || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))()) || t("endDate.error")
                },
                register: register,
                errors: formState.errors
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex space-x-2 text-gray-700 pt-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                        className: "text-gray-400",
                        type: "checkbox"
                    }, register(`accountArray.${idx}.calculateUntilEnd`))),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: `accountArray.${idx}.calculateUntilEnd`,
                        className: "flex text-sm font-medium",
                        children: t("calculateUntilEnd.label")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("installmentCalc")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-2 xl:col-span-3 grid grid-cols-1 xl:grid-cols-3 gap-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                        id: `accountArray.${idx}.type`,
                        list: [
                            {
                                id: "annuity",
                                name: t("type.annuity")
                            },
                            {
                                id: "fixedPrincipal",
                                name: t("type.fixedPrincipal")
                            },
                            {
                                id: "interestOnly",
                                name: t("type.interestOnly")
                            }
                        ],
                        label: t("type.label"),
                        toolTip: t("type.tooltip"),
                        register: register,
                        validationRules: {
                            required: {
                                value: true,
                                message: t("type.error")
                            }
                        },
                        errors: formState.errors,
                        control: control,
                        optional: false
                    }),
                    watchType === "annuity" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-3 flex flex-col space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "byInstallmentAmount",
                                                name: "byInstallmentAmount",
                                                type: "radio",
                                                value: "byInstallmentAmount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register(`accountArray.${idx}.annuitySubtype`, {
                                                required: {
                                                    value: true,
                                                    message: t("annuitySubtype.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "byInstallmentAmount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("byInstallentAmount")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "byTilgungsrate",
                                                name: "byTilgungsrate",
                                                type: "radio",
                                                value: "byTilgungsrate",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register(`accountArray.${idx}.annuitySubtype`, {
                                                required: {
                                                    value: true,
                                                    message: t("annuitySubtype.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "byTilgungsrate",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("byTilgungsrate")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: ((_formState_errors_accountArray = formState.errors.accountArray) === null || _formState_errors_accountArray === void 0 ? void 0 : (_formState_errors_accountArray_idx = _formState_errors_accountArray[idx]) === null || _formState_errors_accountArray_idx === void 0 ? void 0 : _formState_errors_accountArray_idx.annuitySubtype) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.accountArray[idx].annuitySubtype.message
                                        })
                                    })
                                ]
                            }),
                            watchAnnuitySubtype === "byInstallmentAmount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                                id: "annuitySubtypeAmount",
                                myIndex: idx,
                                type: "number",
                                autoComplete: "off",
                                label: t("annuitySubtypeAmount.label"),
                                toolTip: t("annuitySubtypeAmount.tooltip"),
                                placeholder: "1000",
                                register: register,
                                setValue: setValue,
                                validationRules: {
                                    required: {
                                        value: true,
                                        message: t("annuitySubtypeAmount.error")
                                    }
                                },
                                errors: formState.errors
                            }),
                            watchAnnuitySubtype === "byTilgungsrate" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                                id: "annuitySubtypeTilgung",
                                myIndex: idx,
                                type: "number",
                                autoComplete: "off",
                                label: t("annuitySubtypeTilgung.label"),
                                toolTip: t("annuitySubtypeTilgunginterestRate.tooltip"),
                                placeholder: "2",
                                register: register,
                                setValue: setValue,
                                validationRules: {
                                    required: {
                                        value: true,
                                        message: t("annuitySubtypeAmount.error")
                                    }
                                },
                                errors: formState.errors
                            })
                        ]
                    }),
                    watchType === "fixedPrincipal" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-3 flex flex-col space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "byPrincipalRepaid",
                                                name: "byPrincipalRepaid",
                                                type: "radio",
                                                value: "byPrincipalRepaid",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register(`accountArray.${idx}.fixedPrincipalSubtype`, {
                                                required: {
                                                    value: true,
                                                    message: t("fixedPrincipalSubtype.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "byPrincipalRepaid",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("byPrincipalRepaid")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "byTilgungsrate",
                                                name: "byTilgungsrate",
                                                type: "radio",
                                                value: "byTilgungsrate",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register(`accountArray.${idx}.fixedPrincipalSubtype`, {
                                                required: {
                                                    value: true,
                                                    message: t("fixedPrincipalSubtype.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "byTilgungsrate",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("byTilgungsrate")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-2 text-sm text-red-500",
                                        id: "fixedPrincipalSubtype-error",
                                        children: ((_formState_errors_accountArray1 = formState.errors.accountArray) === null || _formState_errors_accountArray1 === void 0 ? void 0 : (_formState_errors_accountArray_idx1 = _formState_errors_accountArray1[idx]) === null || _formState_errors_accountArray_idx1 === void 0 ? void 0 : _formState_errors_accountArray_idx1.fixedPrincipalSubtype) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.accountArray[idx].fixedPrincipalSubtype.message
                                        })
                                    })
                                ]
                            }),
                            watchFixedPrincipalSubtype === "byPrincipalRepaid" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                                id: "fixedPrincipalSubtypeAmount",
                                myIndex: idx,
                                type: "number",
                                autoComplete: "off",
                                label: t("fixedPrincipalSubtypeAmount.label"),
                                toolTip: t("fixedPrincipalSubtypeAmount.tooltip"),
                                placeholder: "1000",
                                register: register,
                                setValue: setValue,
                                validationRules: {
                                    required: {
                                        value: true,
                                        message: t("fixedPrincipalSubtypeAmount.error")
                                    }
                                },
                                errors: formState.errors
                            }),
                            watchFixedPrincipalSubtype === "byTilgungsrate" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                                id: "fixedPrincipalSubtypeTilgung",
                                myIndex: idx,
                                type: "number",
                                autoComplete: "off",
                                label: t("fixedPrincipalSubtypeTilgung.label"),
                                toolTip: t("fixedPrincipalSubtypeTilgung.tooltip"),
                                placeholder: "2",
                                register: register,
                                setValue: setValue,
                                validationRules: {
                                    required: {
                                        value: true,
                                        message: t("fixedPrincipalSubtypeAmount.error")
                                    }
                                },
                                errors: formState.errors
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("connectedDepositAccount")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-400",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                id: "existingAccount",
                                name: "existingAccount",
                                type: "radio",
                                value: "existingAccount",
                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                            }, register(`accountArray.${idx}.connectedDepositMode`, {
                                required: {
                                    value: true,
                                    message: t("connectedDepositMode.error")
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "existingAccount",
                                className: "ml-3 block text-sm font-medium text-gray-700",
                                children: t("existingAccount")
                            })
                        ]
                    }),
                    watchConnectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "xl:flex xl:items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "connectedDepositAccountObject",
                                className: "flex text-sm font-medium text-gray-700",
                                children: t("existingAccountSelect")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1 ml-2",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                    id: "connectedDepositAccountObject",
                                    name: "connectedDepositAccountObject",
                                    className: "text-gray-500 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                }, register(`accountArray.${idx}.connectedDepositAccountObject`)), {
                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: a.id,
                                            children: a.name
                                        }, a.id))
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center col-start-1",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                id: "createAccountLater",
                                name: "createAccountLater",
                                type: "radio",
                                value: "createAccountLater",
                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                            }, register(`accountArray.${idx}.connectedDepositMode`, {
                                required: {
                                    value: true,
                                    message: t("connectedDepositMode.error")
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "createAccountLater",
                                className: "ml-3 block text-sm font-medium text-gray-700",
                                children: t("createAccountLater")
                            })
                        ]
                    }),
                    watchConnectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 text-brandBlue-500 self-start",
                                "aria-hidden": "true"
                            }),
                            t("createAccountLaterDescription")
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "col-start-1 mt-2 text-sm text-red-500",
                        id: "connectedDepositMode-error",
                        children: ((_formState_errors_accountArray2 = formState.errors.accountArray) === null || _formState_errors_accountArray2 === void 0 ? void 0 : (_formState_errors_accountArray_idx2 = _formState_errors_accountArray2[idx]) === null || _formState_errors_accountArray_idx2 === void 0 ? void 0 : _formState_errors_accountArray_idx2.connectedDepositMode) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: formState.errors.accountArray[idx].connectedDepositMode.message
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("loanProject")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-2 xl:col-span-3 grid grid-cols-2 xl:grid-cols-3 gap-6 items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                        id: `accountArray.${idx}.connectedProjectId`,
                        list: selectedProjects,
                        label: t("connectedProjectId.label"),
                        toolTip: t("connectedProjectId.tooltip"),
                        register: register,
                        errors: formState.errors,
                        control: control,
                        enabled: !watchProjectCreateNew,
                        validationRules: {
                            validate: (value)=>{
                                const projectCreateNew = getValues(`accountArray.${idx}.projectCreateNew`);
                                // if `projectCreateNew` is false, then `connectedProjectId` must be filled out
                                if (!projectCreateNew && !value) return 'This field is required when "Create New Project" is not checked.';
                                return true; // No error
                            }
                        },
                        optional: false
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex space-x-2 mt-4 text-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                className: "text-gray-400",
                                type: "checkbox"
                            }, register(`accountArray.${idx}.projectCreateNew`))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: `accountArray.${idx}.projectCreateNew`,
                                className: "flex text-sm font-medium",
                                children: t("projectCreateNew")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "text-lg font-bold text-gray-700",
                children: t("advanced")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("bereitstellungszinsen.text")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-2 xl:col-span-3 grid grid-cols-2 xl:grid-cols-3 gap-6 items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                        id: "bereitstellungszinsen",
                        myIndex: idx,
                        type: "number",
                        autoComplete: "off",
                        label: t("bereitstellungszinsen.label"),
                        toolTip: t("bereitstellungszinsen.tooltip"),
                        placeholder: "1",
                        optional: true,
                        register: register,
                        setValue: setValue,
                        errors: formState.errors
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                        id: "bereitstellungszinsenSinceDate",
                        myIndex: idx,
                        type: "date",
                        autoComplete: "off",
                        label: t("bereitstellungszinsenSinceDate.label"),
                        toolTip: t("bereitstellungszinsenSinceDate.tooltip"),
                        placeholder: "1",
                        optional: true,
                        register: register,
                        setValue: setValue,
                        errors: formState.errors
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("interestAfterTerm.text")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-2 xl:col-span-3 grid grid-cols-2 xl:grid-cols-3 gap-6 items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                        id: "interestAfterTerm",
                        myIndex: idx,
                        type: "number",
                        autoComplete: "off",
                        label: t("interestAfterTerm.label"),
                        toolTip: t("interestAfterTerm.tooltip"),
                        placeholder: "1",
                        optional: true,
                        register: register,
                        setValue: setValue,
                        errors: formState.errors
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                        id: "interestAfterTermSinceDate",
                        myIndex: idx,
                        type: "date",
                        autoComplete: "off",
                        label: t("interestAfterTermSinceDate.label"),
                        toolTip: t("interestAfterTermSinceDate.tooltip"),
                        placeholder: "1",
                        optional: true,
                        register: register,
                        setValue: setValue,
                        errors: formState.errors
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "md:col-start-1 text-sm font-medium text-gray-400",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t("interestCalculationCutoff")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: `accountArray.${idx}.interestCalcMonthEnd`,
                control: control,
                render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                        id: "interestCalcMonthEnd",
                        idx: idx,
                        onChange: onChange,
                        onBlur: onBlur,
                        value: value,
                        inputRef: ref,
                        label: t("interestCalcMonthEnd.label"),
                        toolTip: t("interestCalcMonthEnd.tooltip"),
                        optional: true,
                        errors: formState.errors
                    })
            })
        ]
    });
}
$1c84e5a08efe7756$export$2e2bcd8739ae039.propTypes = {
    idx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    formState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    getValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    selectDepositAccounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    refreshUserInputAndWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $e3c8313e93d4b2c4$var$getPeriodNum(periodName) {
    let periodNum;
    switch(periodName){
        case "month":
            periodNum = 1;
            break;
        case "quarter":
            periodNum = 3;
            break;
        case "year":
            periodNum = 12;
            break;
        default:
            periodNum = undefined;
    }
    return periodNum;
}
function $e3c8313e93d4b2c4$var$getCurrent(arr, date = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()) {
    return arr.reduce((prev, current)=>prev.effectiveDate > current.effectiveDate && current.effectiveDate < date ? prev : current);
}
// component initialises in loading state (spinner), then calls get
function $e3c8313e93d4b2c4$var$AccountData({ index: index, workflowStepStatus: workflowStepStatus, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, category: category }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "D4"
    });
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [maxAccounts, setMaxAccounts] = (0, $7fPBF.useState)(Infinity);
    const [maxExDeAccounts, setMaxExDeAccounts] = (0, $7fPBF.useState)(Infinity);
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_data;
        return (_state_data = state.data) === null || _state_data === void 0 ? void 0 : _state_data.deposits.accounts;
    });
    const { register: register, reset: reset, control: control, setValue: setValue, getValues: getValues, formState: formState, trigger: trigger, watch: watch } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "all",
        defaultValues: userInput && userInput.accountArray && {
            accountArray: userInput.accountArray
        }
    });
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        control: control,
        name: "accountArray"
    });
    // expects account name and account object retrieved from provider API
    function appendDepositAccount(accountObject, name) {
        console.log("appending deposit account", accountObject, name);
        append({
            name: name,
            currency: accountObject.currency,
            iban: accountObject.iban,
            // ↑↑ very important, when we renew access in GC, we need to match new GC providerAccountIds by IBAN, so this must be copied over from GC object and remain unchanged (implemented separately)
            bic: userInput.provider.bic,
            bankName: userInput.provider.providerInstitutionName,
            isImported: true,
            providerAccountId: accountObject.providerAccountId,
            providerName: accountObject.providerName || accountObject.provider
        });
    }
    // expects account name and account object retrieved from provider API
    function appendStocksAccount(accountObject, name) {
        console.log("appending stock account", accountObject, name);
        append({
            name: name,
            accountNo: accountObject.accountNumber,
            brokerName: userInput.provider.providerInstitutionName,
            isImported: true,
            providerAccountId: accountObject.providerAccountId,
            providerName: accountObject.providerName || accountObject.provider
        });
    }
    function appendLoanAccount(accountObject, name) {
        console.log("appending loan account", accountObject, name);
        append({
            name: name,
            currency: accountObject.currency,
            iban: accountObject.iban,
            bankName: userInput.provider.providerInstitutionName,
            isImported: true,
            providerAccountId: accountObject.providerAccountId,
            providerName: accountObject.providerName || accountObject.provider,
            balance: accountObject.balance,
            // impose default values
            calculateUntilEnd: true,
            projectCreateNew: true,
            direction: "received"
        });
    }
    // ------------------
    // INITIALISE FORM
    // ------------------
    // initialise form and add either an empty array item (manual sync) or trigger getAccountDetails and add them all
    (0, $7fPBF.useEffect)(()=>{
        const cancellationToken = {
            cancelled: false
        };
        // immediatelly-invoked function expression (IIFE) to handle async syntax within useEffect
        (async ()=>{
            // ------------------------------------------------------------------------
            // HANDLE SYNCTYPE 'MANUAL'
            // ------------------------------------------------------------------------
            if (userInput.syncType === "manual") {
                console.log("updating array with manual sync");
                const newAccount = {
                    name: "",
                    currency: "EUR",
                    isImported: true
                };
                // append(newAccount);
                reset({
                    accountArray: [
                        newAccount
                    ]
                });
                // update userInput with the object above
                setUserInput((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        accountArray: newAccount
                    })); // added to userInput for submission through AddAccount
                setLoading(false);
            }
            // ------------------------------------------------------------------------
            // HANDLE SYNCTYPE 'AUTOMATIC'
            // ------------------------------------------------------------------------
            // if the syncType is automatic and there are no accounts from an existing connection
            // get account details (name, iban) from the API and add them to the form
            if (userInput.syncType === "automatic") {
                if (cancellationToken.cancelled) return; // do not continue if the useEffect was cancelled
                // ------------------------------------------------------------------------
                // SET MAXIMUM NUMBER OF ACCOUNTS TO BE ADDED
                // ------------------------------------------------------------------------
                // get current user directly from cognito (to have the latests attributes and not the cached ones)
                if (maxAccounts === Infinity || maxExDeAccounts === Infinity) {
                    const user = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
                        forceRefresh: true
                    });
                    const currentAccountIdsArray = JSON.parse(user.attributes["custom:all_account_slots"]);
                    const exDeAccountIdsArray = JSON.parse(user.attributes["custom:ex_de_deposit_slots"]);
                    console.log("DEBUG: currentAccountIdsArray", currentAccountIdsArray);
                    console.log("DEBUG: exDeAccountIdsArray", exDeAccountIdsArray);
                    // count nulls in each array to determine how many accounts can be added
                    setMaxAccounts(currentAccountIdsArray.filter((a)=>a === null).length);
                    setMaxExDeAccounts(exDeAccountIdsArray.filter((a)=>a === null).length);
                }
                // ------------------------------------------------------------------------
                // GET ACCOUNT DETAILS FROM PROVIDER OR FROM USERINPUT
                // ------------------------------------------------------------------------
                let retrievedProviderAccounts;
                let providerAccessId;
                if (cancellationToken.cancelled) return; // do not continue if the useEffect was cancelled
                // if userInput has retrievedProviderAccounts, we don't need to call the API again
                // newProviderAccounts would be returned by getWebFormUrl if finAPI decided webform is not needed
                if (userInput.retrievedProviderAccounts) {
                    retrievedProviderAccounts = userInput.retrievedProviderAccounts;
                    providerAccessId = userInput.providerAccessId;
                } else {
                    // there was a webform involved, let's fetch account details
                    const response = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `deposits/processids/${userInput.provider.processId}?country=${userInput.countryCode}`, {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                    // returned object is { accounts: [], providerAccessId } // the latter being either bankConnectionId for finapi or requisitionId for gocardless
                    // CAUTION: bankConnectionId does not get returned by the webform, it is retrieved by getAccountDetails API call and returned here for the first time
                    console.log("AccountData: received accounts from provider", response, "under the following providerAccessId", response.providerAccessId);
                    retrievedProviderAccounts = response.accounts;
                    providerAccessId = response.providerAccessId;
                }
                if (cancellationToken.cancelled) return; // do not continue if the useEffect was cancelled
                // if successful, put them to accountArray for the user to decide which one to use
                // structure of accounts is { providerAccountId, providerAccountName, providerAccountType, iban, currency, provider }
                remove(0); // it removes nothing, but somehow helps with setting the form to valid state, so that it can be submitted to userInput
                // update providerAccessId in userInput
                setUserInput((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        providerAccessId: providerAccessId
                    }));
                // -------------------------------------------------------------------------------------
                // PREPARE EXISTING ACCOUNTS FOR UPDATE WITH NEW PROVIDER/ACCOUNT IDS FOR GC ACCOUNTS
                // -------------------------------------------------------------------------------------
                // existingAccounts come from Redux and only contain accounts for the current category, provider and selected providerInstitutionId (done in RedirectToProvider)
                const existingAccountsUpdated = []; // if there is anything here at the end, we will putAccount them in AddAccount's handleSubmit
                const responseAccountsWithExistingAccountsMapped = retrievedProviderAccounts.map((ra)=>(0, $2qxEV._)((0, $9tqwB._)({}, ra), {
                        matchingExistingAccount: (userInput.existingAccounts || []).find((ea)=>ea.iban === ra.iban)
                    }));
                // if this is a GC account in reconcileAccount mode (new requisition must replace old requisition, record the old requisitionId)
                // to be used when submitting in AddAccount > handleSubmit
                if (userInput.reconcileAccounts && userInput.existingAccounts && userInput.existingAccounts.length > 0) setUserInput((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        removedGCRequisitonId: prev.existingAccounts[0].tags.provider.gocardless.providerAccessId
                    }));
                // TODO here we could theoretically also check previous providerAccessId and new providerAccessId and only initiate the below if those are not the same
                // here we expect to see the matchingExistingAccount object for all accounts that are already in Redux (mapping happens a few lines above by comparing ibans)
                console.log("responseAccountsWithExistingAccountsMapped", responseAccountsWithExistingAccountsMapped);
                if (cancellationToken.cancelled) return; // do not continue if the useEffect was cancelled
                responseAccountsWithExistingAccountsMapped.forEach((ram)=>{
                    if (ram.matchingExistingAccount) {
                        // if userInput.reconcileAccounts is true, this is a GC account and we need to update the tags of the EXISTING accounts with the changed providerAccessId and providerAccountId
                        if (userInput.reconcileAccounts) existingAccountsUpdated.push((0, $2qxEV._)((0, $9tqwB._)({}, ram.matchingExistingAccount), {
                            tags: (0, $2qxEV._)((0, $9tqwB._)({}, ram.matchingExistingAccount.tags), {
                                provider: (0, $2qxEV._)((0, $9tqwB._)({}, ram.matchingExistingAccount.tags.provider), {
                                    gocardless: (0, $2qxEV._)((0, $9tqwB._)({}, ram.matchingExistingAccount.tags.provider.gocardless), {
                                        providerAccessId: providerAccessId,
                                        providerAccountId: ram.providerAccountId
                                    })
                                })
                            })
                        }));
                        // remove all accounts from form whose ibans are already in Redux (ibans for syncType 'automatic' are read-only and cannot be altered by user, so we can take them as a reference)
                        return;
                    }
                    // ------------------------------------------------------------------------
                    // ADD REMAINING NEW ACCOUNTS TO FORM
                    // ------------------------------------------------------------------------
                    if (cancellationToken.cancelled) return; // do not continue if the useEffect was cancelled
                    // caution: this output format is also used in useForm as well as in RedirectToProvider - if changed here, change there as well
                    const appendedProviderAccountIds = fields.map((f)=>f.providerAccountId);
                    if (category === "deposits" && ram.depositType !== "stocks" && ram.depositType !== "loans") {
                        if (!appendedProviderAccountIds.includes(ram.providerAccountId)) appendDepositAccount(ram, ram.providerAccountName);
                    }
                    if (category === "stocks" && ram.depositType === "stocks") {
                        if (!appendedProviderAccountIds.includes(ram.providerAccountId)) appendStocksAccount(ram, ram.providerAccountName);
                    }
                    if (category === "loans" && ram.depositType === "loans") {
                        if (!appendedProviderAccountIds.includes(ram.providerAccountId)) appendLoanAccount(ram, ram.providerAccountName);
                    }
                });
                // ----------------------------------------------------------------------------------------
                // UPDATE EXISTING ACCOUNTS WHICH HAVE NOT BEEN RETURNED BY PROVIDER TO SYNCTYPE 'MANUAL'
                // ----------------------------------------------------------------------------------------
                // find out if we have any unmatched existing accounts left (they are already filtered by current category, provider and providerInstitutionId)
                // if we do, that means one or more accounts have been removed from the provider and we need to convert them to manual and inform the user
                // show all existingAccounts which are not in responseAccountsWithExistingAccountsMapped
                const unmatchedExistingAccounts = (userInput.existingAccounts || []).filter((ea)=>!responseAccountsWithExistingAccountsMapped.find((ra)=>ra.iban === ea.iban));
                if (unmatchedExistingAccounts.length > 0) {
                    console.log("unmatched existing accounts", unmatchedExistingAccounts);
                    // set tags.gocardless / tags.finapi to {} in existingAccountsUpdated
                    unmatchedExistingAccounts.forEach((uea)=>{
                        // push to existingAccountsUpdated - they will be processed later in AddAccount
                        existingAccountsUpdated.push((0, $2qxEV._)((0, $9tqwB._)({}, uea), {
                            syncType: "manual",
                            tags: (0, $2qxEV._)((0, $9tqwB._)({}, uea.tags), {
                                [userInput.provider]: {}
                            })
                        }));
                    });
                    // show a dialog to the user that the account has been removed from the provider and has been switched to manual
                    window.dispatchEvent(new CustomEvent("setAlert", {
                        detail: {
                            id: "providerAccountsRemoved",
                            caller: "AccountData",
                            args: {
                                list: unmatchedExistingAccounts.map((uea)=>`${uea.name} (${uea.iban})`).join(", ")
                            }
                        }
                    }));
                }
                setUserInput((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        existingAccountsUpdated: existingAccountsUpdated
                    }));
                await trigger(); // trigger validation for all fields -- this will among others run a validation on the allowed account numbers and ggf. display the error messages
                console.log("AccountData: reached end of useEffect");
                setLoading(false);
            } // end of if block
        })(); // end of IIFE
        return function cleanup() {
            console.log("AccountData: cleanup");
            remove(); // remove all items from the array
            cancellationToken.cancelled = true;
        };
    }, [
        userInput.accountsFromExistingConnection
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // set up a window event receiver to trigger validation when Next button is pressed in AddAccount > NavComponent
        window.addEventListener("triggerValidation", ()=>{
            trigger();
        });
        return function cleanup() {
            window.removeEventListener("triggerValidation", ()=>{
                trigger();
            });
        };
    }, []);
    // account data for loans must be transformed before adding to userInput
    // incoming object is the entire form; we are changing the account objects within accountArray
    function transformLoansData(data) {
        if (data.length === 0) return data;
        const accountArray = data.map((item)=>{
            // reverse sign on loan Amount when taken
            const loanAmount = (item.direction === "received" ? -1 : 1) * Math.abs(Number(item.loanAmount));
            let { interestRate: interestRate } = item;
            // if advanced view is off, overwrite the interestRate array with a single object from simple rate
            if (!item.interestRateAdvancedView) // if interestRateSimple is true, we transform it to the interestRate array with a date from the past
            interestRate = [
                {
                    effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc("1970-01-01").startOf("month").valueOf(),
                    value: item.interestRateSimple
                }
            ];
            else // if advanced view is on, we set all dates to month-start
            interestRate = item.interestRate.map((i)=>(0, $2qxEV._)((0, $9tqwB._)({}, i), {
                    effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(i.date).startOf("month").valueOf()
                }));
            // moving interest from Bereitsstellungszins and interestAfterTerm
            if (item.bereitstellungszinsen && item.bereitstellungszinsenSinceDate && interestRate.filter((i)=>i.effectiveDate === (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.bereitstellungszinsenSinceDate).startOf("month").valueOf()).length === 0) interestRate.push({
                effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.bereitstellungszinsenSinceDate).startOf("month").valueOf(),
                value: item.bereitstellungszinsen
            });
            if (item.interestAfterTerm && item.interestAfterTermSinceDate && interestRate.filter((i)=>i.effectiveDate === (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.interestAfterTermSinceDate).startOf("month").valueOf()).length === 0) interestRate.push({
                effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.interestAfterTermSinceDate).startOf("month").valueOf(),
                value: item.interestAfterTerm
            });
            // moving period and tilgung to the { effectiveDate, value } structure
            const period = [
                {
                    effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc("1970-01-01").startOf("month").valueOf(),
                    value: item.period
                }
            ];
            // calculate tilgung from installment amount and interest rate (by this time we already have a complete interestRate array)
            // we use it for simulation only, so we want to know what is the current interest rate (this month) to simulate all future payments
            // the form gathers information first about "type" (annuity / fixedPrincipal / interestOnly), then in next step depending on the selected "type":
            // - annuity: annuitySubtype (byTilgungsrate / byInstallmentAmount) and annuitySubtypeAmount (4% or 1000€)
            // - fixedPrincipal: fixedPrincipalSubtype (byTilgungsrate / byPrincipalRepaid) and fixedPrincipalSubtypeAmount (4% or 1000€)
            // the user inputs installment / principal amount per period, which is not always a month
            let tilgung;
            if (item.type === "annuity") {
                if (item.annuitySubtype === "byTilgungsrate") tilgung = item.annuitySubtypeTilgung;
                else {
                    // byInstallmentAmount
                    const currentPeriod = $e3c8313e93d4b2c4$var$getCurrent(period).value;
                    const periodNum = $e3c8313e93d4b2c4$var$getPeriodNum(currentPeriod);
                    const currentInterestRate = $e3c8313e93d4b2c4$var$getCurrent(interestRate).value;
                    const tilgungsrateInterest = currentInterestRate / 100 * Math.abs(loanAmount) / (12 / periodNum);
                    const tilgungsratePrincipal = item.annuitySubtypeAmount - tilgungsrateInterest;
                    if (tilgungsratePrincipal < 0) tilgung = 0;
                    else tilgung = tilgungsratePrincipal * (12 / periodNum) / Math.abs(loanAmount) * 100; // in %
                }
            }
            if (item.type === "fixedPrincipal") {
                if (item.fixedPrincipalSubtype === "byTilgungsrate") tilgung = item.fixedPrincipalSubtypeTilgung;
                else {
                    // byPrincipalRepaid (user enteres the amount of principal repaid every period)
                    const currentPeriod = $e3c8313e93d4b2c4$var$getCurrent(period).value;
                    const periodNum = $e3c8313e93d4b2c4$var$getPeriodNum(currentPeriod);
                    tilgung = item.fixedPrincipalSubtypeAmount * (12 / periodNum) / Math.abs(loanAmount) * 100; // in %
                }
            }
            if (item.type === "interestOnly") tilgung = 0;
            const percentRepaidAnnually = [
                {
                    effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc("1970-01-01").startOf("month").valueOf(),
                    value: tilgung
                }
            ];
            // handle end date
            let contractEndDate = null;
            if (!item.calculateUntilEnd) contractEndDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.endDate).startOf("month").valueOf();
            // create connected deposits array
            let connectedDepositAccounts = [];
            if (item.connectedDepositMode === "existingAccount") connectedDepositAccounts = [
                item.connectedDepositAccountObject
            ];
            // setting projectId to null if “create new project” is ticked
            const connectedProjectId = item.projectId === "new" ? null : item.connectedProjectId;
            // remember importFlag, if necessary for loans
            const importFlag = "post";
            console.log("transformed item", (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                loanAmount: loanAmount,
                interestRate: interestRate,
                period: period,
                percentRepaidAnnually: percentRepaidAnnually,
                contractEndDate: contractEndDate,
                connectedProjectId: connectedProjectId,
                connectedDepositAccounts: connectedDepositAccounts,
                importFlag: importFlag
            }));
            return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                loanAmount: loanAmount,
                interestRate: interestRate,
                period: period,
                percentRepaidAnnually: percentRepaidAnnually,
                contractEndDate: contractEndDate,
                connectedProjectId: connectedProjectId,
                connectedDepositAccounts: connectedDepositAccounts,
                importFlag: importFlag
            });
        });
        return accountArray;
    }
    const watchForm = watch(); // subscribe to changes in field content
    // keep the previous value of watchForm to compare with the new one (to avoid infinite loops / update depth errors)
    const prevWatchForm = (0, $7fPBF.useRef)();
    function refreshUserInputAndWorkflowStatus() {
        // only allow those with imported flag set to on and with accountName / currency (WHY?)
        // Trigger validation for all fields (why not use trigger() though?)
        // trigger();
        const formValues = (getValues("accountArray") || []).filter((item)=>item.isImported); // let's just select all "isImported", if they are not valid, this step won't be set to true
        // console.log('refreshUserInputAndWorkflowStatus: formValues', getValues('accountArray'), 'is form valid', formState.isValid);
        if (formState.isValid) {
            // if there is a difference in userInput, update it (it causes a update depth error if we don't do that check)
            if (prevWatchForm.current !== JSON.stringify(formValues)) {
                // run category-specific transformations, if necessary (so far only for loans)
                const formValuesTransformed = category === "loans" ? transformLoansData(formValues) : formValues;
                setUserInput((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        accountArray: formValuesTransformed
                    }));
                prevWatchForm.current = JSON.stringify(formValues); // to be compared for the next time (it has to be the raw form structure, not the formValuesTransformed data!)
            } // added to userInput for submission through AddAccount
            // setUserInput({ ...userInput, accountArray: readyItems }); // added to userInput for submission through AddAccount
            if (!workflowStepStatus[index]) updateWorkflowStatus(index, true); // if there is no 'if' here, it causes update depth error
        } else if (workflowStepStatus[index]) updateWorkflowStatus(index, false);
    }
    (0, $7fPBF.useEffect)(()=>{
        refreshUserInputAndWorkflowStatus();
    }, [
        watchForm
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
        className: "space-y-6",
        children: [
            loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "absolute inset-0 flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl font-bold leading-6 text-gray-500 mb-6",
                        children: t("gettingAdditionalAccountInformation")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                        className: "w-10 h-10 text-gray-400 animate-spin"
                    })
                ]
            }),
            !loading && fields.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute top-24 right-0 left-0 bottom-24 flex flex-col items-center justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    className: "text-xl font-bold leading-6 text-gray-500 mb-6",
                    children: t("providerAllAccountsAdded")
                })
            }),
            !loading && fields.length > 0 && fields.map((item, idx)=>{
                var _formState_errors_accountArray_idx, _formState_errors_accountArray, _formState_errors_accountArray_idx_isImported, _formState_errors_accountArray_idx1, _formState_errors_accountArray1;
                return(// <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 md:gap-6 pb-6 border-b border-gray-300">
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "space-y-4 md:space-y-0 md:grid md:grid-cols-3 xl:grid-cols-4 md:gap-6 pb-6 border-b border-gray-300",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "md:row-span-2",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                                    children: fields.length < 2 ? `${t("accountInfo")}` : `${t("account")} ${idx + 1}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    className: "mt-4 sm:mt-2 text-sm text-gray-500 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: userInput.syncType === "manual" ? t("accountInfoManual") : t("accountInfoAutomatic")
                                        }),
                                        fields.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: userInput.syncType === "manual" ? "" : t("accountInfoAutomatic2")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                            id: "name",
                            myIndex: idx,
                            type: "text",
                            autoComplete: "off",
                            label: t("accountName.label"),
                            toolTip: t("accountName.tooltip"),
                            placeholder: "ABC bank savings account",
                            optional: false,
                            register: register,
                            errors: formState.errors,
                            setValue: setValue,
                            validationRules: {
                                required: {
                                    value: true,
                                    message: t("accountName.error")
                                }
                            }
                        }),
                        [
                            "deposits",
                            "loans"
                        ].includes(category) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                    htmlFor: "currency",
                                    className: "flex text-sm font-medium text-gray-700",
                                    children: [
                                        t("baseCurrency.label"),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                            info: t("baseCurrency.tooltip")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                        id: `${idx}.currency`,
                                        name: `${idx}.currency`,
                                        className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full sm:text-sm border-gray-300 rounded-md"
                                    }, register(`accountArray.${idx}.currency`)), {
                                        children: (0, $796ea4636350e237$export$a01df35ce0858603).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                children: c
                                            }, c))
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                            id: [
                                "deposits",
                                "loans"
                            ].includes(category) ? "bankName" : "brokerName",
                            myIndex: idx,
                            type: "text",
                            autoComplete: "off",
                            label: [
                                "deposits",
                                "loans"
                            ].includes(category) ? t("bankName.label") : t("brokerName.label"),
                            // "mostly for decorative purposes; or to make your account's heading look complete"
                            toolTip: [
                                "deposits",
                                "loans"
                            ].includes(category) ? t("bankName.tooltip") : t("brokerName.tooltip"),
                            placeholder: [
                                "deposits",
                                "loans"
                            ].includes(category) ? t("bankName.placeholder") : t("bankName.placeholder"),
                            optional: true,
                            register: register,
                            errors: formState.errors
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                            id: [
                                "deposits",
                                "loans"
                            ].includes(category) ? "iban" : "accountNo",
                            myIndex: idx,
                            formatting: "md:col-start-2",
                            type: "text",
                            autoComplete: "off",
                            label: [
                                "deposits",
                                "loans"
                            ].includes(category) ? t("iban.label") : t("accountNo.label"),
                            toolTip: [
                                "deposits",
                                "loans"
                            ].includes(category) ? t("iban.tooltip") : t("accountNo.tooltip"),
                            placeholder: [
                                "deposits",
                                "loans"
                            ].includes(category) ? t("iban.placeholder") : t("accountNo.placeholder"),
                            optional: true,
                            register: register,
                            errors: formState.errors
                        }),
                        category === "deposits" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4f63b78080bad86a$export$2e2bcd8739ae039), {
                            id: "bic",
                            myIndex: idx,
                            type: "text",
                            autoComplete: "off",
                            label: t("bic.label"),
                            toolTip: t("bic.tooltip"),
                            placeholder: "ABCDDEFFXXX",
                            optional: true,
                            register: register,
                            errors: formState.errors
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "pt-4 flex items-center gap-2 order-last md:order-none",
                            children: fields.length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: `${idx}.isImported`,
                                                name: `${idx}.isImported`,
                                                className: "w-5 h-5 shadow-sm text-brandBlue-500 focus:ring-brandBlue-400 focus:border-brandBlue-400 border-gray-300 rounded-md",
                                                type: "checkbox"
                                            }, register(`accountArray.${idx}.isImported`, {
                                                validate: (value)=>{
                                                    // only consider maxExDeAccounts if the userInput.country !== 'DE'
                                                    const limit = Math.min(maxAccounts, userInput.countryCode === "DE" ? Infinity : maxExDeAccounts);
                                                    if (getValues("accountArray").filter((f)=>f.isImported).length <= limit) return true;
                                                    // TEST ME if (fields.filter((f) => f.isImported).length <= limit) return true;
                                                    if (limit === 0) return t("isImported.error0");
                                                    if (limit === 1) return t("isImported.error1");
                                                    return t("isImported.error", {
                                                        num: limit
                                                    });
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                htmlFor: `${idx}.isImported`,
                                                className: "flex text-sm font-medium text-gray-700",
                                                children: [
                                                    t("isImported.label"),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                        info: t("isImported.tooltip")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    ((_formState_errors_accountArray = formState.errors.accountArray) === null || _formState_errors_accountArray === void 0 ? void 0 : (_formState_errors_accountArray_idx = _formState_errors_accountArray[idx]) === null || _formState_errors_accountArray_idx === void 0 ? void 0 : _formState_errors_accountArray_idx.isImported) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "text-sm text-red-500 pt-1",
                                        role: "alert",
                                        children: (_formState_errors_accountArray1 = formState.errors.accountArray) === null || _formState_errors_accountArray1 === void 0 ? void 0 : (_formState_errors_accountArray_idx1 = _formState_errors_accountArray1[idx]) === null || _formState_errors_accountArray_idx1 === void 0 ? void 0 : (_formState_errors_accountArray_idx_isImported = _formState_errors_accountArray_idx1.isImported) === null || _formState_errors_accountArray_idx_isImported === void 0 ? void 0 : _formState_errors_accountArray_idx_isImported.message
                                    })
                                ]
                            })
                        }),
                        category === "stocks" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bc1291ab014b70a2$export$2e2bcd8739ae039), {
                            idx: idx,
                            formState: formState,
                            register: register,
                            getValues: getValues,
                            userInput: userInput,
                            selectDepositAccounts: selectDepositAccounts,
                            refreshUserInputAndWorkflowStatus: refreshUserInputAndWorkflowStatus
                        }),
                        category === "loans" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c84e5a08efe7756$export$2e2bcd8739ae039), {
                            idx: idx,
                            formState: formState,
                            register: register,
                            control: control,
                            watch: watch,
                            getValues: getValues,
                            setValue: setValue,
                            userInput: userInput,
                            selectDepositAccounts: selectDepositAccounts,
                            refreshUserInputAndWorkflowStatus: refreshUserInputAndWorkflowStatus
                        })
                    ]
                }));
            })
        ]
    });
}
$e3c8313e93d4b2c4$var$AccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    workflowStepStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    scrollUpToComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
$e3c8313e93d4b2c4$var$AccountData.defaultProps = {
    userInput: {},
    setUserInput: {}
};
// the following code is in place to reduce the circular dependency between AddAccount and AccountData
// this form updates userInput in the parent component which is a prop of this component, so updates to it cause renders
function $e3c8313e93d4b2c4$var$areEqual(prevProps, nextProps) {
    // Deep compare all props
    return (0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(prevProps, nextProps);
}
const $e3c8313e93d4b2c4$export$e52e1cf70b28df73 = /*#__PURE__*/ (0, $7fPBF.memo)($e3c8313e93d4b2c4$var$AccountData, $e3c8313e93d4b2c4$var$areEqual);
var $e3c8313e93d4b2c4$export$2e2bcd8739ae039 = $e3c8313e93d4b2c4$export$e52e1cf70b28df73;


/* eslint-disable no-nested-ternary */ /* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");










/* eslint-disable react/require-default-props */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $8ac26489e86e9865$var$ExclamationCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 10 5Zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $8ac26489e86e9865$var$ForwardRef = $7fPBF.forwardRef($8ac26489e86e9865$var$ExclamationCircleIcon);
var $8ac26489e86e9865$export$2e2bcd8739ae039 = $8ac26489e86e9865$var$ForwardRef;




function $40da1649d64ec77d$export$2e2bcd8739ae039({ id: id, type: type, autoComplete: autoComplete, optional: optional, register: register, errors: errors, validationRules: validationRules, label: label, placeholder: placeholder, toolTip: toolTip, category: category, formatting: formatting, disableLabel: disableLabel, currency: currency }) {
    // it seems to not work if valudationRules is empty
    const registerType = validationRules ? register(id, validationRules) : register(id);
    // handle nested ids (e.g. arrays like quotes.0.date)
    const pathParts = id.split(".");
    const calculatedError = pathParts.reduce((acc, key)=>acc ? acc[key] : undefined, errors);
    let namespace = "addAccount";
    let keyPrefix = "R1";
    if (category === "pension") {
        namespace = "app";
        keyPrefix = "schema.pension.account";
    }
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(namespace, {
        keyPrefix: keyPrefix
    });
    const calculatedLabel = label || t(`${id}.label`);
    const calculatedToolTip = toolTip || t(`${id}.tooltip`);
    const calculatedPlaceholder = placeholder || t(`${id}.placeholder`);
    let calculatedType;
    switch(type){
        case "string":
            calculatedType = "text";
            break;
        default:
            calculatedType = type;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: formatting,
        children: [
            !disableLabel && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                        htmlFor: "email",
                        className: "text-sm font-medium text-gray-700 flex justify-start",
                        children: [
                            calculatedLabel,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: calculatedToolTip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-500",
                        id: "email-optional",
                        children: optional ? "Optional" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-1 relative rounded-md flex items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                        id: id,
                        type: calculatedType,
                        autoComplete: autoComplete,
                        name: id,
                        className: `block w-full ${calculatedError ? "pr-10" : ""} focus:outline-none sm:text-sm rounded-md shadow-sm
            ${calculatedError ? "border-red-300 text-red-300  placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                        placeholder: calculatedPlaceholder,
                        defaultValue: "",
                        "aria-invalid": "true",
                        "aria-describedby": "username-error"
                    }, registerType)),
                    currency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "pl-2 text-gray-500",
                        children: currency
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: `${!calculatedError ? "hidden" : ""} absolute inset-y-0 right-0 ${currency ? "pr-12" : "pr-3"} flex items-center pointer-events-none`,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ac26489e86e9865$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-red-500",
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                id: "email-error",
                children: calculatedError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: calculatedError.message
                })
            })
        ]
    });
}
$40da1649d64ec77d$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    placeholder: (0, $2oXYc.oneOfType)([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    toolTip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    validationRules: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    ])),
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    disableLabel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    currency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$40da1649d64ec77d$export$2e2bcd8739ae039.defaultProps = {
    optional: true,
    validationRules: {},
    label: null,
    placeholder: null,
    toolTip: null,
    autoComplete: "off",
    category: "realEstate",
    formatting: "",
    disableLabel: false,
    currency: null
};



/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable no-nested-ternary */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





function $52608018d73116e8$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $52608018d73116e8$var$MAX_OPTIONS_TO_RENDER = 50;
function $52608018d73116e8$export$2e2bcd8739ae039({ id: id, label: label, toolTip: toolTip, placeholder: placeholder, optional: optional, control: control, errors: errors, validationRules: validationRules, options: options, disabled: disabled, formatting: formatting }) {
    var _fieldState_error, _get;
    const { field: field, fieldState: fieldState } = (0, $18522b4fc47f45cb$export$e8c786024a2b0a79)({
        name: id,
        control: control,
        rules: validationRules
    });
    const { t: tSchema } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app");
    const { t: tAddAccount } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    const errorMessage = (fieldState === null || fieldState === void 0 ? void 0 : (_fieldState_error = fieldState.error) === null || _fieldState_error === void 0 ? void 0 : _fieldState_error.message) || ((_get = (0, $18522b4fc47f45cb$export$3988ae62b71be9a3)(errors, id, {})) === null || _get === void 0 ? void 0 : _get.message) || "";
    const calculatedLabel = label || tSchema(`schema.realEstate.account.valuationParameters.${id.split(".").pop()}.label`);
    const calculatedToolTip = toolTip || tSchema(`schema.realEstate.account.valuationParameters.${id.split(".").pop()}.tooltip`);
    const calculatedPlaceholder = placeholder || tSchema(`schema.realEstate.account.valuationParameters.${id.split(".").pop()}.placeholder`);
    const [query, setQuery] = (0, $7fPBF.useState)("");
    const [internalValue, setInternalValue] = (0, $7fPBF.useState)(field.value || "");
    const [pendingValue, setPendingValue] = (0, $7fPBF.useState)(field.value || "");
    (0, $7fPBF.useEffect)(()=>{
        setInternalValue(field.value || "");
        setPendingValue(field.value || "");
    }, [
        field.value
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const handler = setTimeout(()=>{
            if (pendingValue !== field.value) field.onChange(pendingValue);
        }, 500);
        return ()=>clearTimeout(handler);
    }, [
        field,
        pendingValue
    ]);
    const normalizedOptions = (0, $7fPBF.useMemo)(()=>{
        if (!Array.isArray(options)) return [];
        return options.map((option)=>({
                raw: option,
                lc: option.toLocaleLowerCase("de-DE")
            }));
    }, [
        options
    ]);
    const filteredOptions = (0, $7fPBF.useMemo)(()=>{
        if (normalizedOptions.length === 0) return [];
        const trimmedQuery = query.trim().toLocaleLowerCase("de-DE");
        const source = trimmedQuery ? normalizedOptions.filter((item)=>item.lc.includes(trimmedQuery)) : normalizedOptions;
        return source.slice(0, $52608018d73116e8$var$MAX_OPTIONS_TO_RENDER).map((item)=>item.raw);
    }, [
        normalizedOptions,
        query
    ]);
    const queryLimitedResults = query.trim().length > 0 && filteredOptions.length === $52608018d73116e8$var$MAX_OPTIONS_TO_RENDER;
    function handleInputChange(event) {
        const { value: value } = event.target;
        setQuery(value);
        if (value === "") {
            setInternalValue("");
            setPendingValue("");
        }
    }
    function handleClear() {
        setQuery("");
        setInternalValue("");
        setPendingValue("");
    }
    const selectedValue = internalValue;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `relative ${formatting}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                        htmlFor: id,
                        className: "text-sm font-medium text-gray-700 flex items-center gap-1",
                        children: [
                            calculatedLabel,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: calculatedToolTip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-500",
                        children: optional ? "Optional" : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e), {
                value: selectedValue,
                onChange: (value)=>{
                    setInternalValue(value || "");
                    setPendingValue(value || "");
                    setQuery("");
                },
                disabled: disabled,
                children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Input, {
                                        id: id,
                                        className: $52608018d73116e8$var$classNames("w-full rounded-md border bg-white py-2 pl-3 pr-10 shadow-sm focus:outline-none focus:ring-1 sm:text-sm", errorMessage ? "border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500" : disabled ? "border-gray-200 text-gray-400 placeholder-gray-300 bg-gray-100 cursor-not-allowed" : "border-gray-300 placeholder-gray-400 focus:border-brandBlue-500 focus:ring-brandBlue-600"),
                                        displayValue: (value)=>value || "",
                                        onChange: handleInputChange,
                                        onBlur: field.onBlur,
                                        placeholder: disabled ? "" : calculatedPlaceholder,
                                        disabled: disabled,
                                        autoComplete: "off"
                                    }),
                                    !disabled && selectedValue && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        onClick: handleClear,
                                        className: "absolute inset-y-0 right-7 flex items-center pr-1 text-gray-400 hover:text-gray-600",
                                        "aria-label": `Clear ${calculatedLabel}`,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                                            className: "h-4 w-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Button, {
                                        className: "absolute inset-y-0 right-0 flex items-center pr-2",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $839a335830066041$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: `${!errorMessage ? "hidden" : ""} pointer-events-none absolute inset-y-0 right-0 pr-8 flex items-center`,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $48391eba9165ee71$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-red-500",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                show: open && !disabled && (filteredOptions.length > 0 || query.trim() !== ""),
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                afterLeave: ()=>setQuery(""),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Options, {
                                    className: "absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                                    children: [
                                        filteredOptions.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "cursor-default select-none py-2 px-3 text-gray-500",
                                            children: tAddAccount("R1.noMatches", "No matches found")
                                        }) : filteredOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                                                className: ({ active: active })=>$52608018d73116e8$var$classNames("relative cursor-default select-none py-2 pl-3 pr-9", active ? "bg-brandBlue-500 text-white" : "text-gray-900"),
                                                value: option,
                                                children: ({ selected: selected })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        className: $52608018d73116e8$var$classNames("block truncate", selected ? "font-semibold" : "font-normal"),
                                                        children: option
                                                    })
                                            }, option)),
                                        queryLimitedResults && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "cursor-default select-none py-2 px-3 text-gray-400 text-xs",
                                            children: tAddAccount("R1.locationResultsLimited", "Showing first matches. Keep typing to narrow down.")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                children: errorMessage
            })
        ]
    });
}
$52608018d73116e8$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    toolTip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    validationRules: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$52608018d73116e8$export$2e2bcd8739ae039.defaultProps = {
    label: null,
    toolTip: null,
    placeholder: null,
    optional: true,
    validationRules: undefined,
    options: [],
    disabled: false,
    formatting: ""
};





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $96a84f48caa04ee8$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $96a84f48caa04ee8$export$c2d820eaab724b69(accountsWithValuationSlots, valuationSlots) {
    // what is the next available valuation date? it is the date from valuationSlots which is not used in accountsWithValuationSlots.tags.nextValuationSlot
    // for each accountsWithValuationSlots.tags.nextValuationDate remove ONE corresponding item from valuationSlots
    const assignedSlots = accountsWithValuationSlots.map((x)=>{
        var _x_tags;
        return (_x_tags = x.tags) === null || _x_tags === void 0 ? void 0 : _x_tags.nextValuationDate;
    }).filter((x)=>!!x); // remove undefined from the array (accounts with no nextValuationDate)
    const availableSlots = [
        ...valuationSlots
    ];
    assignedSlots.forEach((assignedSlot)=>{
        const toBeRemoved = availableSlots.indexOf(assignedSlot);
        availableSlots.splice(toBeRemoved, 1);
    });
    const availableSlotsWithNoNull = availableSlots.map((x)=>x || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
    // sort the array by date ascending and get the first element
    const nextValuationDate = availableSlotsWithNoNull.sort((a, b)=>a - b)[0];
    return nextValuationDate;
}
function $96a84f48caa04ee8$var$RealEstateAccountData({ index: index, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, signalNext: signalNext, setSignalNext: setSignalNext, messageToShowBeforeNext: messageToShowBeforeNext, setMessageToShowBeforeNext: setMessageToShowBeforeNext }) {
    // register the hook
    const { register: register, watch: watch, reset: reset, getValues: getValues, control: control, formState: formState, setValue: setValue, trigger: trigger } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: userInput && userInput.data
    });
    const { errors: errors, isValid: isValid, isDirty: isDirty } = formState;
    const [displayUpdateValueSwitch, setDisplayUpdateValueSwitch] = (0, $7fPBF.useState)(false);
    const [valuationSlots, setValuationSlots] = (0, $7fPBF.useState)([]);
    const [subtypeList, setSubtypeList] = (0, $7fPBF.useState)([
        {
            id: null,
            name: null
        }
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    const { t: tp } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.realEstate.account.valuationParameters"
    });
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.realEstate.accounts);
    const accountsWithValuationSlots = accounts.filter((x)=>x.tags.nextValuationDate);
    const estimataCities = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.misc.estimataCities);
    const estimataCitiesStatus = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.misc.estimataCitiesStatus);
    const countryCodeValue = watch("valuationParameters.countryCode");
    // get city dictionary from estimata get_plzen if there aren't any in redux
    (0, $7fPBF.useEffect)(()=>{
        if (!estimataCities && estimataCitiesStatus === "idle") dispatch((0, $c082dd6d1850ff9b$export$37a10b117bbddcb)());
    }, [
        dispatch,
        estimataCities,
        estimataCitiesStatus
    ]);
    const normalizedEstimataCities = (0, $7fPBF.useMemo)(()=>{
        if (!estimataCities) return null;
        const toArray = (value)=>{
            if (!value) return [];
            if (Array.isArray(value)) return value;
            if (typeof value === "object") return Object.values(value);
            return [];
        };
        const normalizeStringList = (collection)=>{
            const seen = new Set();
            const output = [];
            toArray(collection).forEach((item)=>{
                const normalized = item == null ? "" : String(item);
                if (normalized && !seen.has(normalized)) {
                    seen.add(normalized);
                    output.push(normalized);
                }
            });
            return output;
        };
        const normalizeEntries = (collection)=>{
            if (!collection) return [];
            return toArray(collection).map((entry)=>{
                if (Array.isArray(entry)) return entry;
                if (entry && typeof entry === "object") {
                    const { city: city, district: district, zip: zip, name: name } = entry;
                    return [
                        city,
                        district,
                        zip,
                        name
                    ];
                }
                return [];
            }).filter((entry)=>Array.isArray(entry) && entry.length >= 3 && entry.some((value)=>value !== undefined && value !== null && value !== "")).map((entry)=>{
                const [city, district, zip, ...rest] = entry;
                return [
                    city == null ? "" : String(city),
                    district == null ? "" : String(district),
                    zip == null ? "" : String(zip),
                    ...rest
                ];
            });
        };
        const normalizedAllFromObject = normalizeEntries(toArray(estimataCities.all));
        const normalizedAllFromArray = Array.isArray(estimataCities) ? normalizeEntries(estimataCities) : [];
        const normalizedAll = normalizedAllFromObject.length ? normalizedAllFromObject : normalizedAllFromArray;
        var _estimataCities_zip, _ref, _ref1;
        const zipList = normalizeStringList((_ref1 = (_ref = (_estimataCities_zip = estimataCities.zip) !== null && _estimataCities_zip !== void 0 ? _estimataCities_zip : estimataCities.plz) !== null && _ref !== void 0 ? _ref : estimataCities.postcode) !== null && _ref1 !== void 0 ? _ref1 : normalizedAll.length ? normalizedAll.map((entry)=>entry[2]) : []);
        var _estimataCities_city, _ref2, _ref3;
        const cityList = normalizeStringList((_ref3 = (_ref2 = (_estimataCities_city = estimataCities.city) !== null && _estimataCities_city !== void 0 ? _estimataCities_city : estimataCities.kreis) !== null && _ref2 !== void 0 ? _ref2 : estimataCities.stadt) !== null && _ref3 !== void 0 ? _ref3 : normalizedAll.length ? normalizedAll.map((entry)=>entry[0]) : []);
        var _estimataCities_district, _ref4, _ref5;
        const districtList = normalizeStringList((_ref5 = (_ref4 = (_estimataCities_district = estimataCities.district) !== null && _estimataCities_district !== void 0 ? _estimataCities_district : estimataCities.ort) !== null && _ref4 !== void 0 ? _ref4 : estimataCities.districts) !== null && _ref5 !== void 0 ? _ref5 : normalizedAll.length ? normalizedAll.map((entry)=>entry[1]) : []);
        if (!normalizedAll.length && !zipList.length && !cityList.length && !districtList.length) return null;
        return {
            zip: zipList,
            city: cityList,
            district: districtList,
            all: normalizedAll
        };
    }, [
        estimataCities
    ]);
    const isCountrySelected = Boolean(countryCodeValue);
    const isCountryGermany = countryCodeValue === "DE";
    const hasLocationData = Boolean(normalizedEstimataCities);
    const shouldUseLocationCombobox = isCountryGermany && estimataCitiesStatus !== "failed";
    const locationComboboxEnabled = shouldUseLocationCombobox && hasLocationData;
    const selectedZip = watch("valuationParameters.zip");
    const selectedCity = watch("valuationParameters.city");
    const selectedDistrict = watch("valuationParameters.district");
    const locationComboboxOptions = (0, $7fPBF.useMemo)(()=>{
        if (!locationComboboxEnabled || !normalizedEstimataCities) return {
            zip: [],
            city: [],
            district: []
        };
        const baseZipOptions = Array.isArray(normalizedEstimataCities === null || normalizedEstimataCities === void 0 ? void 0 : normalizedEstimataCities.zip) ? normalizedEstimataCities.zip : [];
        const baseCityOptions = Array.isArray(normalizedEstimataCities === null || normalizedEstimataCities === void 0 ? void 0 : normalizedEstimataCities.city) ? normalizedEstimataCities.city : [];
        const baseDistrictOptions = Array.isArray(normalizedEstimataCities === null || normalizedEstimataCities === void 0 ? void 0 : normalizedEstimataCities.district) ? normalizedEstimataCities.district : [];
        const allEntries = Array.isArray(normalizedEstimataCities === null || normalizedEstimataCities === void 0 ? void 0 : normalizedEstimataCities.all) ? normalizedEstimataCities.all : [];
        if (!allEntries.length) return {
            zip: baseZipOptions,
            city: baseCityOptions,
            district: baseDistrictOptions
        };
        const validZip = baseZipOptions.includes(selectedZip) ? selectedZip : undefined;
        const validCity = baseCityOptions.includes(selectedCity) ? selectedCity : undefined;
        const validDistrict = baseDistrictOptions.includes(selectedDistrict) ? selectedDistrict : undefined;
        const uniqueFromEntries = (entries, idx)=>{
            const unique = new Set();
            entries.forEach((entry)=>{
                const value = entry[idx];
                if (value !== undefined && value !== null && value !== "") unique.add(String(value));
            });
            return [
                ...unique
            ];
        };
        const zipEntries = allEntries.filter(([entryCity, entryDistrict])=>{
            if (validCity && entryCity !== validCity) return false;
            if (validDistrict && entryDistrict !== validDistrict) return false;
            return true;
        });
        const cityEntries = allEntries.filter(([, entryDistrict, entryZip])=>{
            if (validDistrict && entryDistrict !== validDistrict) return false;
            if (validZip && entryZip !== validZip) return false;
            return true;
        });
        const districtEntries = allEntries.filter(([entryCity, entryDistrict, entryZip])=>{
            if (validCity && entryCity !== validCity) return false;
            if (validZip && entryZip !== validZip) return false;
            return true;
        });
        const zipOptions = validCity || validDistrict ? uniqueFromEntries(zipEntries, 2) : baseZipOptions;
        const cityOptions = validZip || validDistrict ? uniqueFromEntries(cityEntries, 0) : baseCityOptions;
        const districtOptions = validCity || validZip ? uniqueFromEntries(districtEntries, 1) : baseDistrictOptions;
        return {
            zip: zipOptions,
            city: cityOptions,
            district: districtOptions
        };
    }, [
        locationComboboxEnabled,
        normalizedEstimataCities,
        selectedZip,
        selectedCity,
        selectedDistrict
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!locationComboboxEnabled) return;
        if (selectedZip && locationComboboxOptions.zip.length > 0 && !locationComboboxOptions.zip.includes(selectedZip)) setValue("valuationParameters.zip", "", {
            shouldDirty: true,
            shouldValidate: true
        });
        if (selectedCity && locationComboboxOptions.city.length > 0 && !locationComboboxOptions.city.includes(selectedCity)) setValue("valuationParameters.city", "", {
            shouldDirty: true,
            shouldValidate: true
        });
        if (selectedDistrict && locationComboboxOptions.district.length > 0 && !locationComboboxOptions.district.includes(selectedDistrict)) setValue("valuationParameters.district", "", {
            shouldDirty: true,
            shouldValidate: true
        });
    }, [
        locationComboboxEnabled,
        locationComboboxOptions,
        selectedZip,
        selectedCity,
        selectedDistrict,
        setValue
    ]);
    // get a list of valuationParamteres fields from schema that we want to display
    const valuationParametersSchemaObject = (0, $3a1ecd75ab1ea382$export$934eb6c45067415d).fields.valuationParameters.fields;
    // ↑↑ object of { field1: { type: 'string', _whitelist: ... }, field2: { type: 'number', _whitelist: ... }, ... }
    // _whitelist contains the oneOf members; its a ReferenceSet class instance; size property is the number of members
    const valuationParameters = Object.keys(valuationParametersSchemaObject);
    const prioritizedOrder = [
        "countryCode",
        "zip",
        "city",
        "district",
        "streetAddress",
        "type",
        "subtype",
        "livingArea",
        "completeArea"
    ];
    const prioritizedParameters = prioritizedOrder.filter((param)=>valuationParameters.includes(param));
    const remainingParameters = valuationParameters.filter((param)=>!prioritizedParameters.includes(param));
    const sortedRemainingParameters = [
        ...remainingParameters
    ].sort((a, b)=>{
        if (valuationParametersSchemaObject[a].spec.optional === valuationParametersSchemaObject[b].spec.optional) return 0;
        if (valuationParametersSchemaObject[a].spec.optional === true) return 1;
        return -1;
    });
    const orderedValuationParameters = [
        ...prioritizedParameters,
        ...sortedRemainingParameters
    ];
    //--------------------------------------------------------------------------------
    // synchronise this component's form with the parent component's form state
    //--------------------------------------------------------------------------------
    function syncParentForm() {
        // check if all validations are passed and if so, set component status to true
        if (isDirty && isValid) {
            // console.log('isDirty and isValid both true');
            const input = getValues();
            setUserInput((0, $9tqwB._)({}, userInput, input));
            updateWorkflowStatus(index, true);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, input), {
                keepIsValid: true
            });
        }
        // check if the user invalidated the form and if so, remove the next step
        if (isDirty && !isValid) {
            const input = getValues();
            // CAVEAT: this approach means that the previously entered data is still potentially within the form
            setUserInput((0, $9tqwB._)({}, userInput, input));
            updateWorkflowStatus(index, false);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, input), {
                keepErrors: true
            });
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        // if the form has tags.nextValuationDate, display a dialog asking the user to be sure they provided all the info
        if (isDirty && isValid && getValues("tags.nextValuationDate") && !messageToShowBeforeNext) {
            syncParentForm();
            setMessageToShowBeforeNext("aboutToReceiveRealEstateValuation");
        } else syncParentForm();
    }, [
        formState
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    //--------------------------------------------------------------------------------
    // get valuationSlots from Cognito on initialisation
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
            forceRefresh: true
        }).then((user)=>{
            const result = JSON.parse(user.attributes["custom:valuation_slots"] || "[]");
            // console.log('result', result);
            setValuationSlots(result);
        }).catch((err)=>console.error(err));
    }, []);
    //--------------------------------------------------------------------------------
    // when accounts / valuationSlots update,
    // decide if to show the automatic update switch
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (accountsWithValuationSlots.length < valuationSlots.length) {
            setValue("tags.nextValuationDate", $96a84f48caa04ee8$export$c2d820eaab724b69(accountsWithValuationSlots, valuationSlots));
            setDisplayUpdateValueSwitch(true);
        } else setDisplayUpdateValueSwitch(false);
    }, [
        accounts,
        valuationSlots
    ]);
    const type = watch("valuationParameters.type");
    //--------------------------------------------------------------------------------
    // handle subtype -- when type changes, reset subtype
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        // console.log('useEffect type changed');
        if (getValues("valuationParameters.type") === "building") setSubtypeList(Object.entries(t("app:schema.realEstate.account.parameters.subtype.building", {
            returnObjects: true
        })).map(([key, value])=>({
                id: key,
                name: value
            })));
        if (getValues("valuationParameters.type") === "apartment") setSubtypeList(Object.entries(t("app:schema.realEstate.account.parameters.subtype.apartment", {
            returnObjects: true
        })).map(([key, value])=>({
                id: key,
                name: value
            })));
    }, [
        type
    ]);
    function handleNextValuationDateChange(newFieldValue) {
        // newFieldValue is the new boolean field value
        // when switch is flipped and the argument is TRUE, we need to set the nextValuationDate to the next available date
        if (newFieldValue) setValue("tags.nextValuationDate", $96a84f48caa04ee8$export$c2d820eaab724b69(accountsWithValuationSlots, valuationSlots));
        else setValue("tags.nextValuationDate", undefined);
    }
    //--------------------------------------------------------------------------------
    // render the component
    //--------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: t("R1.accountInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: t("R1.provideInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-sm text-gray-500",
                        children: t("R1.oneAccount")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-8 text-sm text-gray-500 font-bold",
                        children: t("R1.whyDoWeAsk")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: t("R1.whyDoWeAskAnswer")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-8 text-sm text-gray-500 font-bold",
                        children: t("R1.doIHaveToFillThemAllOut")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: t("R1.doIHaveToFillThemAllOutAnswer")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "md:col-span-3 ",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "name",
                                    type: "text",
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: t("R1.name.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "hidden md:col-span-2"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "date",
                                    type: "date",
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "originalPrice",
                                    type: "text",
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        number: {
                                            value: true,
                                            message: t("R1.originalPrice.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "flex space-x-1",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                    htmlFor: "currency",
                                                    className: "block text-sm font-medium text-gray-700",
                                                    children: t("R1.currency.label")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                    info: t("R1.currency.tooltip")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                            id: "currency",
                                            name: "currency",
                                            onBlur: (e)=>{
                                                setUserInput((0, $9tqwB._)({}, userInput, getValues()));
                                            }
                                        }, register("currency")), {
                                            className: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-brandBlue-400 focus:border-brandBlue-400 sm:text-sm rounded-md",
                                            defaultValue: "EUR",
                                            children: (0, $796ea4636350e237$export$a01df35ce0858603).map((curr)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: curr,
                                                    children: curr
                                                }, curr))
                                        }))
                                    ]
                                }),
                                displayUpdateValueSwitch ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                    onChange: handleNextValuationDateChange,
                                    onBlur: (e)=>{
                                        setUserInput((0, $9tqwB._)({}, userInput, getValues()));
                                    },
                                    label: t("R1.automaticUpdate.label"),
                                    tooltip: t("R1.automaticUpdate.tooltip"),
                                    optional: false,
                                    value: watch("tags.nextValuationDate") !== undefined
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-brandBlue-400",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: t("R1.automaticUpdate.disabled")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: orderedValuationParameters.map((param)=>{
                                const schemaDefinition = valuationParametersSchemaObject[param];
                                const isStringOrNumber = [
                                    "number",
                                    "string"
                                ].includes(schemaDefinition.type);
                                const hasOneOf = schemaDefinition._whitelist.size > 0 || param === "subtype";
                                const isOptional = schemaDefinition.spec.optional;
                                if ([
                                    "zip",
                                    "city",
                                    "district"
                                ].includes(param)) {
                                    const fieldActive = locationComboboxEnabled ? true : isCountrySelected;
                                    const locationValidationRules = !isOptional ? {
                                        validate: (value)=>{
                                            if (!fieldActive) return true;
                                            return value ? true : tp(`${param}.error`);
                                        }
                                    } : undefined;
                                    if (locationComboboxEnabled) {
                                        const list = locationComboboxOptions[param] || [];
                                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $52608018d73116e8$export$2e2bcd8739ae039), {
                                            id: `valuationParameters.${param}`,
                                            label: tp(`${param}.label`),
                                            toolTip: tp(`${param}.tooltip`),
                                            placeholder: tp(`${param}.placeholder`),
                                            optional: isOptional,
                                            control: control,
                                            errors: errors,
                                            options: list,
                                            validationRules: locationValidationRules,
                                            disabled: !isCountrySelected
                                        }, param);
                                    }
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        id: `valuationParameters.${param}`,
                                        type: schemaDefinition.type,
                                        label: tp(`${param}.label`),
                                        placeholder: tp(`${param}.placeholder`),
                                        toolTip: tp(`${param}.tooltip`),
                                        register: register,
                                        errors: errors,
                                        optional: isOptional,
                                        validationRules: locationValidationRules,
                                        disabled: !isCountrySelected
                                    }, param);
                                }
                                if (isStringOrNumber && !hasOneOf) {
                                    const validationProps = isOptional ? {} : {
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: tp(`${param}.error`)
                                            }
                                        }
                                    };
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), (0, $9tqwB._)({
                                        id: `valuationParameters.${param}`,
                                        type: schemaDefinition.type,
                                        label: tp(`${param}.label`),
                                        placeholder: tp(`${param}.placeholder`),
                                        toolTip: tp(`${param}.tooltip`),
                                        register: register,
                                        errors: errors,
                                        optional: isOptional
                                    }, validationProps), param);
                                }
                                if (isStringOrNumber && hasOneOf) {
                                    let list = [];
                                    if (param === "energyClass") list = [
                                        ...schemaDefinition._whitelist
                                    ].map((x)=>({
                                            id: x,
                                            name: x
                                        }));
                                    if (param === "countryCode") list = (0, $3ed9d75bd3010070$export$7bc41e2d36612b98).map((x)=>({
                                            id: x,
                                            name: t([
                                                `countryNames.${(0, $3ed9d75bd3010070$export$9494497b504eb2dc)(x)}`,
                                                (0, $3ed9d75bd3010070$export$9494497b504eb2dc)(x)
                                            ])
                                        }));
                                    if (param === "subtype") list = subtypeList;
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                                        id: `valuationParameters.${param}`,
                                        list: list,
                                        type: schemaDefinition.type,
                                        label: tp(`${param}.label`),
                                        placeholder: tp(`${param}.placeholder`),
                                        toolTip: tp(`${param}.tooltip`),
                                        register: register,
                                        errors: errors,
                                        control: control,
                                        optional: isOptional
                                    }, param);
                                }
                                if (schemaDefinition.type === "boolean") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: `valuationParameters.${param}`,
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: `valuationParameters.${param}`,
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tp(`${param}.label`),
                                            toolTip: tp(`${param}.tooltip`),
                                            optional: isOptional
                                        })
                                }, param);
                                return true;
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$96a84f48caa04ee8$var$RealEstateAccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    messageToShowBeforeNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    setMessageToShowBeforeNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$96a84f48caa04ee8$var$RealEstateAccountData.defaultProps = {
    userInput: {},
    setUserInput: {},
    signalNext: undefined,
    setSignalNext: ()=>{},
    messageToShowBeforeNext: "",
    setMessageToShowBeforeNext: ()=>{}
};
var $96a84f48caa04ee8$export$2e2bcd8739ae039 = $96a84f48caa04ee8$var$RealEstateAccountData;





parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $54472657a7d1d19d$export$2e2bcd8739ae039({ children: children, closeCallback: closeCallback }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "general"
    });
    return(// pb-12 in small layouts prevents the card overlapping with the Feedback button
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "overlayCard",
        className: "absolute w-full h-full flex items-start z-50 top-0 left-0 pb-12 md:pb-8 md:p-8 bg-gray-300 bg-opacity-90 space-y-6 overflow-y-auto xs:overflow-none",
        role: "dialog",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "bg-gray-50 shadow h-auto rounded-sm m-auto w-full lg:max-w-4xl",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    onClick: closeCallback,
                    formatting: "absolute top-0 right-0 m-4 hidden sm:inline",
                    Icon: (0, $341a41b70f0b63cc$export$2e2bcd8739ae039),
                    noFrame: true
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    onClick: closeCallback,
                    formatting: "absolute top-0 right-0 m-4 sm:hidden",
                    text: t("close")
                }),
                children
            ]
        })
    }));
}
$54472657a7d1d19d$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    closeCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$54472657a7d1d19d$export$2e2bcd8739ae039.defaultProps = {
    closeCallback: ()=>{}
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable no-nested-ternary */ 

var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ef0832052dc462d9$var$CheckCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
        clipRule: "evenodd"
    }));
}
const $ef0832052dc462d9$var$ForwardRef = $7fPBF.forwardRef($ef0832052dc462d9$var$CheckCircleIcon);
var $ef0832052dc462d9$export$2e2bcd8739ae039 = $ef0832052dc462d9$var$ForwardRef;





function $960126dae36fdf62$export$fb587a27d5a722e7({ steps: steps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
        className: "flex items-center justify-center",
        "aria-label": "Progress",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "hidden md:block text-sm font-medium",
                children: [
                    t("site:general.step"),
                    " ",
                    steps.findIndex((step)=>step.status === "current") + 1,
                    " ",
                    t("site:general.stepOf"),
                    " ",
                    steps.length
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                className: "ml-8 flex items-center space-x-5",
                children: steps.map((step)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: step.status === "complete" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "block h-2.5 w-2.5 rounded-full bg-brandBlue-600 hover:bg-brandBlue-900",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "sr-only",
                                children: step.name
                            })
                        }) : step.status === "current" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative flex items-center justify-center",
                            "aria-current": "step",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "absolute flex h-5 w-5 p-px",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "h-full w-full rounded-full bg-brandBlue-200"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "relative block h-2.5 w-2.5 rounded-full bg-brandBlue-600",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: step.name
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "block h-2.5 w-2.5 rounded-full bg-gray-200 hover:bg-gray-400",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "sr-only",
                                children: step.name
                            })
                        })
                    }, step.name))
            })
        ]
    });
}
$960126dae36fdf62$export$fb587a27d5a722e7.propTypes = {
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired
};
function $960126dae36fdf62$export$98e5dade965b8dcf({ formatting: formatting, setAddModeState: setAddModeState, displayedStep: displayedStep, setDisplayedStep: setDisplayedStep, workflowStepStatus: workflowStepStatus, steps: steps, handleSubmit: handleSubmit, messageToShowBeforeNext: messageToShowBeforeNext, setMessageToShowBeforeNext: setMessageToShowBeforeNext, loading: loading, setSignalNext: setSignalNext }) {
    const [errorMessage, setErrorMessage] = (0, $7fPBF.useState)(null);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function emitTriggerValidationEvent() {
        const event = new Event("triggerValidation");
        window.dispatchEvent(event);
    }
    function handleNext() {
        function executeNext() {
            if (workflowStepStatus[displayedStep]) {
                // workflowStepStatus is an array of the same length as the workflow
                // if this is the last step of the workflow, the user has finished the workflow
                setErrorMessage(null);
                if (displayedStep === workflowStepStatus.length - 1) handleSubmit();
                else {
                    setErrorMessage(null);
                    setDisplayedStep(displayedStep + 1);
                }
            } else {
                setSignalNext(true);
                emitTriggerValidationEvent();
                setErrorMessage(t("errorCompleteStep"));
            }
        }
        // if there is an alert to show before moving on, show it and executeNext() when the user clicks OK; otherwise go straight to executeNext()
        if (messageToShowBeforeNext) {
            dispatch((0, $3b9398d0f9c152fb$export$91020d7983105237)(messageToShowBeforeNext, "AddAccount", executeNext));
            setMessageToShowBeforeNext(null);
        } else executeNext();
    }
    // this gets rid of the overall NavComponent error message once the user has completed the current step
    (0, $7fPBF.useEffect)(()=>{
        if (workflowStepStatus[displayedStep]) setErrorMessage(null);
    }, [
        workflowStepStatus,
        displayedStep
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
        className: `${formatting} w-full border-y border-gray-300 p-8 grid grid-cols-3 items-center`,
        children: [
            displayedStep > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    text: t("back"),
                    onClick: ()=>{
                        setDisplayedStep(Math.max(displayedStep - 1, 0));
                        setErrorMessage(null);
                        setMessageToShowBeforeNext(null);
                    }
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "invisible xs:visible  md:col-start-2 md:flex items-center justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($960126dae36fdf62$export$fb587a27d5a722e7, {
                    steps: steps
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "hidden md:col-start-3 md:flex md:items-center md:justify-center",
                children: [
                    errorMessage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-red-500 text-sm",
                        children: errorMessage
                    }),
                    workflowStepStatus[displayedStep] && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex w-full justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-green-500 text-sm mr-2",
                                children: workflowStepStatus.at(-1) ? t("pressSubmitToFinish") : t("pressNextToContinue")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef0832052dc462d9$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-green-500",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex gap-4 md:col-start-5 justify-self-end",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("cancel"),
                        onClick: ()=>setAddModeState(false)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: workflowStepStatus.at(-1) ? t("submit") : t("next"),
                        disabled: loading,
                        spinnerOn: loading,
                        withAccent: true,
                        onClick: handleNext
                    })
                ]
            })
        ]
    });
}
$960126dae36fdf62$export$98e5dade965b8dcf.propTypes = {
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    setAddModeState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    setDisplayedStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    workflowStepStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    messageToShowBeforeNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    setMessageToShowBeforeNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$960126dae36fdf62$export$98e5dade965b8dcf.defaultProps = {
    formatting: "",
    displayedStep: 0,
    messageToShowBeforeNext: null,
    setMessageToShowBeforeNext: ()=>{}
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable no-nested-ternary */ 

var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");



function $7210fb90eac6c605$export$fb587a27d5a722e7({ steps: steps }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
        className: "flex items-center justify-center",
        "aria-label": "Progress",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "text-sm font-medium",
                children: [
                    t("site:general.step"),
                    " ",
                    steps.findIndex((step)=>step.status === "current") + 1,
                    " ",
                    t("site:general.stepOf"),
                    " ",
                    steps.length
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                className: "ml-8 flex items-center space-x-5",
                children: steps.map((step)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        children: step.status === "complete" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "block h-2.5 w-2.5 rounded-full bg-brandBlue-600 hover:bg-brandBlue-900",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "sr-only",
                                children: step.name
                            })
                        }) : step.status === "current" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative flex items-center justify-center",
                            "aria-current": "step",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "absolute flex h-5 w-5 p-px",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "h-full w-full rounded-full bg-brandBlue-200"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "relative block h-2.5 w-2.5 rounded-full bg-brandBlue-600",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "sr-only",
                                    children: step.name
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "block h-2.5 w-2.5 rounded-full bg-gray-200 hover:bg-gray-400",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "sr-only",
                                children: step.name
                            })
                        })
                    }, step.name))
            })
        ]
    });
}
$7210fb90eac6c605$export$fb587a27d5a722e7.propTypes = {
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired
};
function $7210fb90eac6c605$export$2e2bcd8739ae039({ formatting: formatting, setAddModeState: setAddModeState, displayedStep: displayedStep, setDisplayedStep: setDisplayedStep, workflowStepStatus: workflowStepStatus, steps: steps, handleSubmit: handleSubmit, messageToShowBeforeNext: messageToShowBeforeNext, setMessageToShowBeforeNext: setMessageToShowBeforeNext, loading: loading, setSignalNext: setSignalNext, form: form }) {
    const [errorMessage, setErrorMessage] = (0, $7fPBF.useState)(null);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { formState: formState } = form;
    const { isValid: isValid } = formState;
    function emitTriggerValidationEvent() {
        const event = new Event("triggerValidation");
        window.dispatchEvent(event);
    }
    function handleNext() {
        function executeNext() {
            if (workflowStepStatus[displayedStep]) {
                // workflowStepStatus is an array of the same length as the workflow
                // if this is the last step of the workflow, the user has finished the workflow
                setErrorMessage(null);
                if (displayedStep === workflowStepStatus.length - 1) handleSubmit();
                else {
                    setErrorMessage(null);
                    setDisplayedStep(displayedStep + 1);
                }
            } else {
                setSignalNext(true);
                emitTriggerValidationEvent();
                setErrorMessage(t("errorCompleteStep"));
            }
        }
        // if there is an alert to show before moving on, show it and executeNext() when the user clicks OK; otherwise go straight to executeNext()
        if (messageToShowBeforeNext) {
            dispatch((0, $3b9398d0f9c152fb$export$91020d7983105237)(messageToShowBeforeNext, "AddAccount", executeNext));
            setMessageToShowBeforeNext(null);
        } else executeNext();
    }
    // this gets rid of the overall NavComponent error message once the user has completed the current step
    (0, $7fPBF.useEffect)(()=>{
        if (workflowStepStatus[displayedStep]) setErrorMessage(null);
    }, [
        workflowStepStatus,
        displayedStep
    ]);
    return(// displays 2 cols below sm (back + cancel/next), 4 columns above
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
        className: `${formatting} w-full border-y border-gray-300 p-8`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "sm:hidden w-full flex justify-center align-middle pb-6",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7210fb90eac6c605$export$fb587a27d5a722e7, {
                    steps: steps
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-2 sm:grid-cols-4 items-center",
                children: [
                    displayedStep > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            text: t("back"),
                            onClick: ()=>{
                                setDisplayedStep(Math.max(displayedStep - 1, 0));
                                setErrorMessage(null);
                                setMessageToShowBeforeNext(null);
                            }
                        })
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "hidden sm:block sm:col-span-2 md:flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7210fb90eac6c605$export$fb587a27d5a722e7, {
                            steps: steps
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex gap-4 justify-self-end",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: t("cancel"),
                                onClick: ()=>setAddModeState(false)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: workflowStepStatus.at(-1) && displayedStep === workflowStepStatus.length - 1 ? t("submit") : t("next"),
                                enabled: !(loading || !workflowStepStatus[displayedStep]),
                                spinnerOn: loading,
                                withAccent: true,
                                onClick: handleNext
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
$7210fb90eac6c605$export$2e2bcd8739ae039.propTypes = {
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    setAddModeState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    setDisplayedStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    workflowStepStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    messageToShowBeforeNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    setMessageToShowBeforeNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
$7210fb90eac6c605$export$2e2bcd8739ae039.defaultProps = {
    formatting: "",
    displayedStep: 0,
    messageToShowBeforeNext: null,
    setMessageToShowBeforeNext: ()=>{}
};


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");






async function $d332a6fd4016af7b$export$f51670bfd1254535(fxCode, date) {
    // logic: get data for a 7-day period ENDING with the target date; always get the last date from the array:
    // it will either be the target date or the last value from before the target date
    if (fxCode === "EUR") return 1;
    const startDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(date).subtract(7, "day").format("YYYY-MM-DD");
    const endDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(date).format("YYYY-MM-DD");
    const response = await (0, $747d656b899e6115$export$2e2bcd8739ae039).get(`https://data-api.ecb.europa.eu/service/data/EXR/D.${fxCode}.EUR.SP00.A?startPeriod=${startDate}&endPeriod=${endDate}&format=jsondata`);
    return Object.values(response.data.dataSets[0].series["0:0:0:0:0"].observations).map((value)=>value[0]).filter((value)=>value !== null).reverse()[0];
}
async function $d332a6fd4016af7b$export$dca80e37bfad9c5a(amount, amountFxCode, toFxCode, date) {
    // return error if the date is before 1999-01-04
    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(date).isBefore("1999-01-04")) throw new Error("FX rates before 1999 are not available.");
    return amount * (await $d332a6fd4016af7b$export$f51670bfd1254535(toFxCode, date) / await $d332a6fd4016af7b$export$f51670bfd1254535(amountFxCode, date));
}






/* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $3c04ff5eab7e8c18$export$2e2bcd8739ae039({ id: id, keyPrefix: keyPrefix, control: control, label: label, list: list, optional: optional, initialiseOpen: initialiseOpen = false }) {
    // if need more than one translation, switch id
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: keyPrefix
    });
    const [expanded, setExpanded] = (0, $7fPBF.useState)(initialiseOpen);
    function handleClick() {
        setExpanded(true);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
        name: id,
        control: control,
        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value } })=>{
            // ACTUAL COMPONENT STARTS HERE
            const computedValue = list.find((item)=>item.id === value); // this will be undefined if value is not in list
            function handleSelect(e, item) {
                console.log("handleSelect", JSON.stringify(item, null, 2));
                onChange(item.id);
                setExpanded(false);
            }
            // COLLAPSED STATE (display button with selected option)
            if (!expanded) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                onBlur: onBlur,
                className: "col-span-1 flex flex-col space-y-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-between text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "button-collapsible-component",
                                        className: "font-medium text-gray-700",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                        info: t("tooltip")
                                    })
                                ]
                            }),
                            optional && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "text-sm text-gray-500",
                                id: "email-optional",
                                children: "Optional"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex items-center w-full",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex gap-2 items-center w-full",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "button-collapsible-component",
                                type: "button",
                                // eslint-disable-next-line max-len
                                className: `${optional} rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500`,
                                onClick: handleClick,
                                children: t(`${computedValue === null || computedValue === void 0 ? void 0 : computedValue.id}.name`)
                            })
                        })
                    })
                ]
            });
            // EXPANDED STATE (display list of buttons)
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: list.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        onClick: (e)=>handleSelect(e, item),
                        type: "button",
                        className: "flex flex-col border bg-white border-gray-100 shadow-sm rounded-md p-4 cursor-pointer hover:border-gray-300",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                className: "flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.Icon, {
                                        className: "h-5 w-5 flex-none text-brandBlue-500",
                                        "aria-hidden": "true"
                                    }),
                                    item.name,
                                    item.id === (computedValue === null || computedValue === void 0 ? void 0 : computedValue.id) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "-mb-0.5 inline-flex items-center rounded-md bg-brandBlue-50 px-2 py-1 text-xs font-medium text-brandBlue-700 ring-1 ring-inset ring-brandBlue-600/20",
                                        children: t("selected")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dd", {
                                className: "mt-4 flex flex-auto flex-col text-base leading-7 text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-left flex-auto text-sm",
                                        children: item.description
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-6",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "text-left text-sm font-semibold leading-6 text-brandBlue-500",
                                            children: [
                                                "Select",
                                                " ",
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    children: "\u2192"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }, item.name))
            });
        }
    });
}
$3c04ff5eab7e8c18$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    keyPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    list: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    optional: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    initialiseOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$3c04ff5eab7e8c18$export$2e2bcd8739ae039.defaultProps = {
    optional: false,
    initialiseOpen: false
};




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $f19773a91e60a5d0$var$AdjustmentsHorizontalIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
    }));
}
const $f19773a91e60a5d0$var$ForwardRef = $7fPBF.forwardRef($f19773a91e60a5d0$var$AdjustmentsHorizontalIcon);
var $f19773a91e60a5d0$export$2e2bcd8739ae039 = $f19773a91e60a5d0$var$ForwardRef;


const $ac576c131d4eaa76$var$products = {
    deposits: [
        {
            id: "savings-account-giro",
            type: "savings-account",
            Icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039),
            label: "Girokonto",
            description: "addAccount:D1.products.savings-account-giro",
            link: "https://www.monestry.de/blog/address"
        },
        {
            id: "savings-account-tagesgeld",
            type: "savings-account",
            Icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039),
            label: "Tagesgeldkonto",
            description: "addAccount:D1.products.savings-account-tagesgeld",
            link: "https://www.monestry.de/blog/address"
        },
        {
            id: "time-deposit-festgeld",
            type: "time-deposit",
            Icon: (0, $115cc551859b34d6$export$2e2bcd8739ae039),
            label: "Festgeld",
            description: "addAccount:D1.products.time-deposit-festgeld",
            link: "https://www.monestry.de/blog/address"
        },
        {
            id: "savings-account-generic",
            type: "savings-account",
            Icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039),
            label: "Current account",
            description: "addAccount:D1.products.savings-account-generic",
            link: "https://www.monestry.de/blog/address"
        },
        {
            id: "time-deposit-generic",
            type: "time-deposit",
            Icon: (0, $115cc551859b34d6$export$2e2bcd8739ae039),
            label: "Time deposit",
            description: "addAccount:D1.products.time-deposit-generic",
            link: "https://www.monestry.de/blog/address"
        }
    ],
    stocks: [],
    pension: [
        {
            id: "pension-drv",
            type: "pension-drv",
            Icon: (0, $109c079d14fe89b5$export$2e2bcd8739ae039),
            link: "https://www.monestry.de/blog/address",
            contributionsSelfPaid: false,
            contributionsFrequency: null,
            contributionsDeductible: null,
            payoutsTaxable: true,
            payoutsIndexed: true,
            payoutsFrequency: 1,
            payoutsDuration: 0
        },
        {
            id: "pension-betriebliche",
            type: "pension-betriebliche",
            Icon: (0, $7d738768e6988915$export$2e2bcd8739ae039),
            link: "https://www.monestry.de/blog/address",
            contributionsSelfPaid: false,
            contributionsFrequency: null,
            contributionsDeductible: null,
            payoutsTaxable: true,
            payoutsIndexed: true,
            payoutsFrequency: 1,
            payoutsDuration: 0
        },
        {
            id: "pension-riester",
            type: "pension-riester",
            Icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039),
            link: "https://www.monestry.de/blog/address",
            contributionsSelfPaid: true,
            contributionsFrequency: 1,
            contributionsDeductible: true,
            payoutsTaxable: true,
            payoutsIndexed: false,
            payoutsFrequency: 1,
            payoutsDuration: 0
        },
        {
            id: "pension-ruerup",
            type: "pension-ruerup",
            Icon: (0, $2ccb7dca0a77963b$export$2e2bcd8739ae039),
            link: "https://www.monestry.de/blog/address",
            contributionsSelfPaid: true,
            contributionsFrequency: 1,
            contributionsDeductible: true,
            payoutsTaxable: true,
            payoutsIndexed: false,
            payoutsFrequency: 1,
            payoutsDuration: 0
        },
        {
            id: "custom",
            type: "custom",
            Icon: (0, $f19773a91e60a5d0$export$2e2bcd8739ae039),
            link: "https://www.monestry.de/blog/address"
        }
    ],
    realEstate: [],
    objectsOfValue: [],
    metals: [],
    loans: [],
    unlistedShares: []
};
var $ac576c131d4eaa76$export$2e2bcd8739ae039 = $ac576c131d4eaa76$var$products;


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $1584ca85a4ee8cba$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $1584ca85a4ee8cba$var$Header({ text: text }) {
    $1584ca85a4ee8cba$var$Header.propTypes = {
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "pension"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
        className: "xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900",
        children: tI(text)
    });
}
/**
 * Helper component to create a double quotes input field. Works only for the four specialQuotes types in the pension account.
 */ function $1584ca85a4ee8cba$var$DoubleQuotes({ errors: errors, register: register, watch: watch, accountCurrency: accountCurrency, isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency, baseCurrency: baseCurrency, fieldName: fieldName }) {
    var _errors_payoutsDuration;
    $1584ca85a4ee8cba$var$DoubleQuotes.propTypes = {
        errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
        register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        accountCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        isBaseCurrencySameAsAccountCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        fieldName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    $1584ca85a4ee8cba$var$DoubleQuotes.defaultProps = {
        accountCurrency: ""
    };
    const { t: tD } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "columns"
    });
    const fieldQuote = watch(`${fieldName}Quote`);
    const fieldQuoteBaseCurrency = watch(`${fieldName}QuoteBaseCurrency`);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                        htmlFor: "email",
                        className: "text-sm font-medium text-gray-700",
                        children: [
                            tD(`${fieldName}.label`),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                formatting: "inline-block -mb-1",
                                info: tD(`${fieldName}.tooltip`)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-500",
                        id: "email-optional",
                        children: "Optional"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-1 relative",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-6 gap-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                            id: `${fieldName}Quote`,
                            type: "number",
                            autoComplete: "off",
                            name: `${fieldName}Quote`,
                            className: `block w-full focus:outline-none  sm:text-sm rounded-md col-span-2
                        ${(errors === null || errors === void 0 ? void 0 : errors.payoutsDuration) ? "border-red-300 text-red-900  placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                            placeholder: "250",
                            defaultValue: "",
                            "aria-invalid": "true",
                            "aria-describedby": "username-error"
                        }, register(`${fieldName}Quote`, // if baseCurrency !== accountCurrency: if base currency quote is filled out, but the account currency is not
                        {
                            validate: (value)=>!isBaseCurrencySameAsAccountCurrency && fieldQuoteBaseCurrency && !value ? "This field is required when the base currency field is filled out" : true
                        }))),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "text-xs xs:text-sm",
                            children: accountCurrency || "?"
                        }),
                        !isBaseCurrencySameAsAccountCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    id: `${fieldName}QuoteBaseCurrency`,
                                    type: "number",
                                    autoComplete: "off",
                                    name: `${fieldName}QuoteBaseCurrency`,
                                    className: `block w-full focus:outline-none  sm:text-sm rounded-md col-span-2
                        ${(errors === null || errors === void 0 ? void 0 : errors.payoutsDuration) ? "border-red-300 text-red-900  placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                                    placeholder: "230"
                                }, register(`${fieldName}QuoteBaseCurrency`, {
                                    validate: (value)=>!isBaseCurrencySameAsAccountCurrency && !value ? "This field is required when this account currency is not equal to your base currency" : true
                                }))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-xs xs:text-sm",
                                    children: baseCurrency
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                id: "email-error",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: errors === null || errors === void 0 ? void 0 : (_errors_payoutsDuration = errors.payoutsDuration) === null || _errors_payoutsDuration === void 0 ? void 0 : _errors_payoutsDuration.message
                })
            })
        ]
    });
}
function $1584ca85a4ee8cba$var$PensionAccountData({ index: index, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, signalNext: signalNext, setSignalNext: setSignalNext }) {
    var _errors_payoutsDuration;
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "pension"
    });
    const [fxRate, setFxRate] = (0, $7fPBF.useState)(null);
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    // icon and id are in products, need to add the translations here
    const productList = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.map((p)=>(0, $2qxEV._)((0, $9tqwB._)({}, p), {
            name: tI(`product.${p.id}.name`),
            description: tI(`product.${p.id}.description`)
        }));
    //--------------------------------------------------------------------------------
    // default values for the form state (userInput + some tweaks)
    //--------------------------------------------------------------------------------
    const _products_pension_find = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.find((p)=>p.id === "pension-drv"), { id: _ } = _products_pension_find, defaultProduct = (0, $bLhVg._)(_products_pension_find, [
        "id"
    ]);
    const defaultValues = (0, $9tqwB._)({}, userInput && (0, $9tqwB._)({}, userInput.data), (0, $9tqwB._)({
        product: "pension-drv"
    }, defaultProduct));
    defaultValues.payoutsIndexedByInflation = defaultValues.payoutsIndexedByInflation === undefined ? null : defaultValues.payoutsIndexedByInflation;
    defaultValues.payoutsCustomIndexRate = defaultValues.payoutsCustomIndexRate === undefined ? null : defaultValues.payoutsCustomIndexRate;
    defaultValues.contributionsIndexed = defaultValues.contributionsIndexed === undefined ? false : defaultValues.contributionsIndexed;
    defaultValues.contributionsIndexedByInflation = defaultValues.contributionsIndexedByInflation === undefined ? null : defaultValues.contributionsIndexedByInflation;
    defaultValues.currency = defaultValues.currency === undefined ? baseCurrency : defaultValues.currency;
    // ↓ these will be filled out in processOutputData based on ...UserInput fields
    defaultValues.intialQuotes = undefined;
    defaultValues.connectedDepositAccounts = undefined;
    // register the hook
    const { register: register, watch: watch, reset: reset, getValues: getValues, control: control, formState: formState, setValue: setValue, trigger: trigger } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: defaultValues
    });
    const { errors: errors, isValid: isValid, isDirty: isDirty, dirtyFields: dirtyFields } = formState;
    const accountCurrency = watch("currency");
    const isBaseCurrencySameAsAccountCurrency = accountCurrency === baseCurrency;
    const contributionsSelfPaid = watch("contributionsSelfPaid");
    const contributionsIndexed = watch("contributionsIndexed");
    const contributionsIndexedByInflation = watch("contributionsIndexedByInflation");
    const payoutsIndexed = watch("payoutsIndexed");
    const payoutsIndexedByInflation = watch("payoutsIndexedByInflation");
    //--------------------------------------------------------------------------------
    // synchronise this component's form with the parent component's form state
    //--------------------------------------------------------------------------------
    function processOutputData(formValues) {
        const obj = (0, $9tqwB._)({}, formValues);
        // housekeeping: convert dates to epoch
        obj.productPurchaseDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formValues.productPurchaseDate).valueOf(); // required
        obj.payoutsPhaseStart = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formValues.payoutsPhaseStart).valueOf(); // required
        // convert contributionsAmountsUserInput to an array of { effectiveDate, value }
        obj.contributionsAmounts = [
            {
                effectiveDate: obj.productPurchaseDate,
                value: obj.contributionsAmountsUserInput
            }
        ];
        let customIndexRate = obj.contributionsCustomIndexRate;
        if (customIndexRate === "") customIndexRate = null;
        obj.contributionsCustomIndexRate = customIndexRate !== null && customIndexRate !== undefined ? Number(customIndexRate) : customIndexRate;
        if (!obj.contributionsIndexed) {
            obj.contributionsIndexedByInflation = null;
            obj.contributionsCustomIndexRate = null;
        } else if (obj.contributionsIndexedByInflation) obj.contributionsCustomIndexRate = null;
        let { payoutsCustomIndexRate: payoutsCustomIndexRate } = obj;
        if (payoutsCustomIndexRate === "") payoutsCustomIndexRate = null;
        obj.payoutsCustomIndexRate = payoutsCustomIndexRate !== null && payoutsCustomIndexRate !== undefined ? Number(payoutsCustomIndexRate) : payoutsCustomIndexRate;
        if (!obj.payoutsIndexed) {
            obj.payoutsIndexedByInflation = null;
            obj.payoutsCustomIndexRate = null;
        } else if (obj.payoutsIndexedByInflation) obj.payoutsCustomIndexRate = null;
        // convert payoutsDurationFrequencyUserInput and payoutsDurationUserInput to payoutsDuration
        if (obj.payoutDurationFrequencyUnitUserInput === "indefinite") obj.payoutsDuration = 0;
        else if (obj.payoutDurationFrequencyUnitUserInput === "years") obj.payoutsDuration = 12 * obj.payoutsDurationUserInput;
        else if (obj.payoutDurationFrequencyUnitUserInput === "months") obj.payoutsDuration = obj.payoutsDurationUserInput;
        // move quotes to intialQuotes
        obj.initialQuotes = [];
        if (obj.payoutOnlyContributionsToDateQuote) obj.initialQuotes.push({
            type: "payoutOnlyContributionsToDate",
            quote: obj.payoutOnlyContributionsToDateQuote,
            quoteBaseCurrency: isBaseCurrencySameAsAccountCurrency ? obj.payoutOnlyContributionsToDateQuote : obj.payoutOnlyContributionsToDateQuoteBaseCurrency
        });
        if (obj.payoutOnlyContributionsToDateIndexedQuote) obj.initialQuotes.push({
            type: "payoutOnlyContributionsToDateIndexed",
            quote: obj.payoutOnlyContributionsToDateIndexedQuote,
            quoteBaseCurrency: isBaseCurrencySameAsAccountCurrency ? obj.payoutOnlyContributionsToDateIndexedQuote : obj.payoutOnlyContributionsToDateIndexedQuoteBaseCurrency
        });
        if (obj.payoutAllPlannedContributionsQuote) obj.initialQuotes.push({
            type: "payoutAllPlannedContributions",
            quote: obj.payoutAllPlannedContributionsQuote,
            quoteBaseCurrency: isBaseCurrencySameAsAccountCurrency ? obj.payoutAllPlannedContributionsQuote : obj.payoutAllPlannedContributionsQuoteBaseCurrency
        });
        if (obj.payoutAllPlannedContributionsIndexedQuote) obj.initialQuotes.push({
            type: "payoutAllPlannedContributionsIndexed",
            quote: obj.payoutAllPlannedContributionsIndexedQuote,
            quoteBaseCurrency: isBaseCurrencySameAsAccountCurrency ? obj.payoutAllPlannedContributionsIndexedQuote : obj.payoutAllPlannedContributionsIndexedQuoteBaseCurrency
        });
        // handle connectedDepositIds
        if (obj.connectedDepositMode === "existingAccount") {
            const connectedObject = obj.connectedDepositAccountsObject || {
                id: null
            }; // before the user picks the answer here
            obj.connectedDepositAccounts = [
                connectedObject.id
            ];
        } else obj.connectedDepositAccounts = [];
        return obj;
    }
    (0, $7fPBF.useEffect)(()=>{
        // check if all validations are passed and if so, set component status to true
        if (isDirty && isValid) {
            const output = getValues();
            // console.log('isDirty and isValid both true, getValues:', JSON.stringify(output, null, 2));
            // transform the output data before sending them to caller
            const processedOutput = processOutputData(output);
            // console.log('processed output', processedOutput);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            updateWorkflowStatus(index, true);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepIsValid: true
            });
        }
        // check if the user invalidated the form and if so, remove the next step
        if (isDirty && !isValid) {
            const output = getValues();
            // console.log('isDirty is true and isValid is not, getValues:', JSON.stringify(output, null, 2));
            // CAVEAT: this approach means that the previously entered data is still potentially within the form
            const processedOutput = processOutputData(output);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            // console.log('processed output', processedOutput);
            updateWorkflowStatus(index, false);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepErrors: true
            });
        }
    }, [
        formState
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    //---------------------------------------------------------------------------------------------
    // react to changes in the product field; if user selects a new product
    // apply the changes to other form fields
    //---------------------------------------------------------------------------------------------
    // list of fields which change when user selects a new template
    // eslint-disable-next-line max-len
    const templateFieldNames = [
        "contributionsSelfPaid",
        // 'contributionsAmounts', // FIX why are we watching this? it isn't a part of the template
        "contributionsFrequency",
        "contributionsDeductible",
        "payoutsTaxable",
        "payoutsIndexed",
        "payoutsFrequency",
        "payoutsDuration"
    ];
    const templateFieldsValues = watch(templateFieldNames); // this destructures to an array, i.e. const [value1, value2] = watch(['field1', 'field2'])
    //---------------------------------------------------------------------------------------------
    // if the user selects a new product, apply the product values to the form fields
    //---------------------------------------------------------------------------------------------
    const severalSetValueInProgress = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false); // to avoid the next useEffect to trigger immediatelly after the first setValue
    const product = watch("product");
    (0, $7fPBF.useEffect)(()=>{
        // get products.pension and apply everything except id, type, Icon, link onto form state
        const selectedProduct = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.find((p)=>p.id === product);
        if (selectedProduct && selectedProduct.id !== "custom") {
            const { id: id, type: type, Icon: Icon, link: link } = selectedProduct, rest = (0, $bLhVg._)(selectedProduct, [
                "id",
                "type",
                "Icon",
                "link"
            ]);
            severalSetValueInProgress.current = true;
            Object.entries(rest).forEach(([key, value])=>{
                setValue(key, value);
            });
            // let all the code in the loop run its course and then set the flag to false (1ms delay is not enough, seems to be working ok for 100ms)
            setTimeout(()=>{
                severalSetValueInProgress.current = false;
            }, 100);
        }
    }, [
        product
    ]);
    //---------------------------------------------------------------------------------------------
    // set product to "custom" if the user changes any of the connected fields
    //---------------------------------------------------------------------------------------------
    // if the product is not on "custom" and the user changes any connected form fields, "product" should be reset to "custom"
    (0, $7fPBF.useEffect)(()=>{
        if (product && product !== "custom" && !severalSetValueInProgress.current) {
            // if a defined product is selected, check if all product fields in the state are equal to the template fields
            const selectedProduct = productList.find((p)=>p.id === product);
            // console.log('handler for >custom< is running for product', product, 'selectedProduct', selectedProduct, 'templateFieldsValues', templateFieldsValues, 'getValues', getValues());
            const allFieldsEqual = templateFieldsValues.every((value, idx)=>{
                const fieldName = templateFieldNames[idx];
                // console.log('comparing form state field', fieldName, value, 'with product template field value', selectedProduct[fieldName]);
                return value === selectedProduct[fieldName];
            });
            if (!allFieldsEqual) setValue("product", "custom");
        }
    }, [
        templateFieldsValues
    ]);
    // watch frequencyUnit and clear payoutsDuration to 0 if it is indefinite
    const frequencyUnit = watch("payoutDurationFrequencyUnitUserInput");
    (0, $7fPBF.useEffect)(()=>{
        if (frequencyUnit === "indefinite") setValue("payoutsDuration", 0);
    }, [
        frequencyUnit
    ]);
    const connectedDepositMode = watch("connectedDepositMode");
    (0, $7fPBF.useEffect)(()=>{
        if (!contributionsIndexed) {
            setValue("contributionsIndexedByInflation", null, {
                shouldDirty: false,
                shouldValidate: true
            });
            setValue("contributionsCustomIndexRate", null, {
                shouldDirty: false,
                shouldValidate: true
            });
            return;
        }
        if (contributionsIndexedByInflation === undefined || contributionsIndexedByInflation === null) setValue("contributionsIndexedByInflation", true, {
            shouldDirty: false,
            shouldValidate: true
        });
        if (contributionsIndexedByInflation) setValue("contributionsCustomIndexRate", null, {
            shouldDirty: false,
            shouldValidate: true
        });
    }, [
        contributionsIndexed,
        contributionsIndexedByInflation,
        setValue
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!payoutsIndexed) {
            setValue("payoutsIndexedByInflation", null, {
                shouldDirty: false,
                shouldValidate: true
            });
            setValue("payoutsCustomIndexRate", null, {
                shouldDirty: false,
                shouldValidate: true
            });
            return;
        }
        if (payoutsIndexedByInflation === undefined || payoutsIndexedByInflation === null) setValue("payoutsIndexedByInflation", true, {
            shouldDirty: false,
            shouldValidate: true
        });
        if (payoutsIndexedByInflation) setValue("payoutsCustomIndexRate", null, {
            shouldDirty: false,
            shouldValidate: true
        });
    }, [
        payoutsIndexed,
        payoutsIndexedByInflation,
        setValue
    ]);
    //---------------------------------------------------------------------------------------------
    // if accountCurrency !== baseCurrency, display current fx rate for the user's convenience
    //---------------------------------------------------------------------------------------------
    // when user selects a non-base-currency for the transaction, get the fx rate in the background and display it
    // when updating this code, remember to change the same code in InflowOutflowTransfer.jsx
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (!isBaseCurrencySameAsAccountCurrency) {
                setFxRate("loading");
                let newRate;
                try {
                    newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, accountCurrency, baseCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                    // setValue('exchangeRate', (1 / newRate).toFixed(4), { shouldValidate: true });
                    setFxRate(newRate);
                } catch (err) {
                    setFxRate(null);
                }
            }
        }
        updateFxRate();
    }, [
        accountCurrency
    ]);
    // TODO: translations + fxRate information + (i) button
    // handle the "apply fx rate" button
    function handleFxRateButton() {
        // get a list of dirtyFields and filter them to only leave fieldNames which have payoutAll or payoutOnly and which end in Quote
        // if that list is not empty, apply the fxRate to those fields
        [
            "payoutAllPlannedContributions",
            "payoutAllPlannedContributionsIndexed",
            "payoutOnlyContributionsToDate",
            "payoutOnlyContributionsToDateIndexed"
        ].forEach((fieldName)=>{
            const fieldQuote = getValues(`${fieldName}Quote`);
            if (fieldQuote) setValue(`${fieldName}QuoteBaseCurrency`, Number((fxRate * fieldQuote).toFixed(2)), {
                shouldValidate: true
            });
        });
    }
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("accountInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: tI("provideInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-8 text-sm text-gray-500 font-bold",
                        children: tI("whyDoWeAsk")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: tI("whyDoWeAskAnswer")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-8 text-sm text-gray-500 font-bold",
                        children: tI("doIHaveToFillThemAllOut")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: tI("doIHaveToFillThemAllOutAnswer")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-8 text-sm text-gray-500 font-bold",
                        children: tI("useATemplate")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: tI("useATemplateAnswer")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "md:col-span-3 ",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "name",
                                    category: "pension",
                                    type: "text",
                                    placeholder: tL("name.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("name.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                                    id: "currency",
                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                    label: tL("currency.label"),
                                    placeholder: tL("currency.placeholder"),
                                    toolTip: tL("currency.tooltip"),
                                    register: register,
                                    optional: false,
                                    errors: errors,
                                    control: control,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("currency.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "productPurchaseDate",
                                    category: "pension",
                                    type: "date",
                                    optional: false,
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("productPurchaseDate.error")
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c04ff5eab7e8c18$export$2e2bcd8739ae039), {
                                control: control,
                                id: "product",
                                keyPrefix: "addAccount.pension.product",
                                label: tI("product.label"),
                                list: productList,
                                optional: true
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$Header, {
                                    text: "yourPensionContributions"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "contributionsSelfPaid",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "contributionsSelfPaid",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("contributionsSelfPaid.label"),
                                            tooltip: tL("contributionsSelfPaid.tooltip")
                                        })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "contributionsAmountsUserInput",
                                    label: tL("contributionsAmounts.label"),
                                    toolTip: tL("contributionsAmounts.tooltip"),
                                    category: "pension",
                                    type: "text",
                                    placeholder: tL("contributionsAmounts.placeholder"),
                                    autoComplete: "off",
                                    optional: true,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        validate: (value)=>contributionsSelfPaid === true && !value ? tL("contributionsAmounts.error") : true
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "contributionsDeductible",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "contributionsDeductible",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("contributionsDeductible.label"),
                                            tooltip: tL("contributionsDeductible.tooltip")
                                        })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "contributionsIndexed",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "contributionsIndexed",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("contributionsIndexed.label"),
                                            tooltip: tL("contributionsIndexed.tooltip")
                                        })
                                }),
                                contributionsIndexed && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "contributionsIndexedByInflation",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "contributionsIndexedByInflation",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("contributionsIndexedByInflation.label"),
                                            tooltip: tL("contributionsIndexedByInflation.tooltip")
                                        })
                                }),
                                contributionsIndexed && contributionsIndexedByInflation === false && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "contributionsCustomIndexRate",
                                    category: "pension",
                                    type: "number",
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        validate: (value)=>value !== undefined && value !== null && value !== "" ? true : tL("contributionsCustomIndexRate.error")
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$Header, {
                                    text: "yourPensionPayouts"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "payoutsPhaseStart",
                                    category: "pension",
                                    type: "date",
                                    optional: false,
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("payoutsPhaseStart.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                                    id: "payoutsFrequency",
                                    list: [
                                        null,
                                        {
                                            id: 1,
                                            name: tL("parameters.payoutsFrequency.1")
                                        },
                                        {
                                            id: 3,
                                            name: tL("parameters.payoutsFrequency.3")
                                        },
                                        {
                                            id: 12,
                                            name: tL("parameters.payoutsFrequency.12")
                                        },
                                        {
                                            id: 0,
                                            name: tL("parameters.payoutsFrequency.0")
                                        }
                                    ],
                                    label: tL("payoutsFrequency.label"),
                                    placeholder: tL("payoutsFrequency.placeholder"),
                                    toolTip: tL("payoutsFrequency.tooltip"),
                                    register: register,
                                    errors: errors,
                                    control: control,
                                    optional: false
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex justify-between",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                htmlFor: "email",
                                                className: "text-sm font-medium text-gray-700 flex justify-start",
                                                children: [
                                                    tL("payoutsDuration.label"),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                        info: tL("payoutsDurationUserInput.tooltip")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-1 relative rounded-md shadow-sm",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                        id: "payoutsDurationUserInput",
                                                        type: "number",
                                                        autoComplete: "off",
                                                        disabled: frequencyUnit === "indefinite",
                                                        name: "payoutsDurationUserInput",
                                                        className: `block w-full focus:outline-none  sm:text-sm rounded-md
                      ${(errors === null || errors === void 0 ? void 0 : errors.payoutsDuration) ? "border-red-300 text-red-900  placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                                                        placeholder: "",
                                                        defaultValue: "",
                                                        "aria-invalid": "true",
                                                        "aria-describedby": "username-error"
                                                    }, register("payoutsDurationUserInput"))),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                        id: "payoutDurationFrequencyUnitUserInput",
                                                        name: "payoutDurationFrequencyUnitUserInput",
                                                        className: `block w-full focus:outline-none sm:text-sm rounded-md
                      ${(errors === null || errors === void 0 ? void 0 : errors.payoutsDuration) ? "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                                                        defaultValue: null
                                                    }, register("payoutDurationFrequencyUnitUserInput")), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                                value: null,
                                                                children: "Select..."
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                                value: "months",
                                                                children: tL("parameters.frequencyUnit.1")
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                                value: "years",
                                                                children: tL("parameters.frequencyUnit.12")
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                                value: "indefinite",
                                                                children: tL("parameters.frequencyUnit.0")
                                                            })
                                                        ]
                                                    }))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "mt-2 text-sm text-red-600",
                                            id: "email-error",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: errors === null || errors === void 0 ? void 0 : (_errors_payoutsDuration = errors.payoutsDuration) === null || _errors_payoutsDuration === void 0 ? void 0 : _errors_payoutsDuration.message
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "payoutsTaxable",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "payoutsTaxable",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("payoutsTaxable.label"),
                                            tooltip: tL("payoutsTaxable.tooltip")
                                        })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "payoutsIndexed",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "payoutsIndexed",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("payoutsIndexed.label"),
                                            tooltip: tL("payoutsIndexed.tooltip")
                                        })
                                }),
                                payoutsIndexed && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    name: "payoutsIndexedByInflation",
                                    control: control,
                                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                            id: "payoutsIndexedByInflation",
                                            onChange: onChange,
                                            onBlur: onBlur,
                                            value: value,
                                            inputRef: ref,
                                            label: tL("payoutsIndexedByInflation.label"),
                                            tooltip: tL("payoutsIndexedByInflation.tooltip")
                                        })
                                }),
                                payoutsIndexed && payoutsIndexedByInflation === false && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "payoutsCustomIndexRate",
                                    category: "pension",
                                    type: "number",
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        validate: (value)=>value !== undefined && value !== null && value !== "" ? true : tL("payoutsCustomIndexRate.error")
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "xs:col-span-2 lg:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                            className: "text-base font-bold text-gray-900",
                                            children: tI("whatYouWillReceive")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: tI("whatYouWillReceiveInfo")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-sm text-gray-500",
                                            children: tI("whatYouWillReceiveInfo2")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$DoubleQuotes, {
                                    errors: errors,
                                    register: register,
                                    watch: watch,
                                    accountCurrency: accountCurrency,
                                    isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency,
                                    baseCurrency: baseCurrency,
                                    fieldName: "payoutOnlyContributionsToDate"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$DoubleQuotes, {
                                    errors: errors,
                                    register: register,
                                    watch: watch,
                                    accountCurrency: accountCurrency,
                                    isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency,
                                    baseCurrency: baseCurrency,
                                    fieldName: "payoutOnlyContributionsToDateIndexed"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$DoubleQuotes, {
                                    errors: errors,
                                    register: register,
                                    watch: watch,
                                    accountCurrency: accountCurrency,
                                    isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency,
                                    baseCurrency: baseCurrency,
                                    fieldName: "payoutAllPlannedContributions"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$DoubleQuotes, {
                                    errors: errors,
                                    register: register,
                                    watch: watch,
                                    accountCurrency: accountCurrency,
                                    isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency,
                                    baseCurrency: baseCurrency,
                                    fieldName: "payoutAllPlannedContributionsIndexed"
                                }),
                                Number.isFinite(fxRate) && fxRate !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "text-sm leading-snug flex flex-col text-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                    htmlFor: "switch-button",
                                                    className: "font-medium",
                                                    children: tL("fxRate.label", {
                                                        accountCurrency: accountCurrency,
                                                        baseCurrency: baseCurrency
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                    info: tL("fxRate.tooltip", {
                                                        baseCurrency: baseCurrency
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: fxRate.toFixed(2)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex items-center w-full mt-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex gap-2 items-center w-full",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    // eslint-disable-next-line max-len
                                                    className: "rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500",
                                                    onClick: handleFxRateButton,
                                                    children: tL("fxRate.apply", {
                                                        baseCurrency: baseCurrency
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1584ca85a4ee8cba$var$Header, {
                                        text: "whenIBuy"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "existingAccount",
                                                name: "existingAccount",
                                                type: "radio",
                                                value: "existingAccount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "existingAccount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("existingAccount")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:flex xl:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "connectedDepositAccountObject",
                                                className: "flex text-sm font-medium text-gray-700",
                                                children: tI("existingAccountSelect")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1 ml-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                    id: "connectedDepositAccountObject",
                                                    name: "connectedDepositAccountObject",
                                                    className: "text-gray-500 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                                }, register("connectedDepositAccountObject")), {
                                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: a.id,
                                                            children: a.name
                                                        }, a.id))
                                                }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "createAccountLater",
                                                name: "createAccountLater",
                                                type: "radio",
                                                value: "createAccountLater",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "createAccountLater",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("createAccountLater")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 text-brandBlue-500 self-start",
                                                "aria-hidden": "true"
                                            }),
                                            tI("createAccountLaterDescription")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "col-start-1 mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: formState.errors.connectedDepositMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.connectedDepositMode.message
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$1584ca85a4ee8cba$var$PensionAccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$1584ca85a4ee8cba$var$PensionAccountData.defaultProps = {
    userInput: {},
    setUserInput: {},
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $1584ca85a4ee8cba$export$2e2bcd8739ae039 = $1584ca85a4ee8cba$var$PensionAccountData;


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $ba9fac31fb6dba98$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $ba9fac31fb6dba98$var$Step1AccountName({ index: index, updateWorkflowStatus: updateWorkflowStatus, form: form, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account"
    });
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "addAccount"
    ], {
        keyPrefix: "pension"
    });
    const { register: register, control: control, getValues: getValues, setValue: setValue, trigger: trigger, watch: watch } = form;
    // this allows only to import a slice of the entire form state
    const formState = (0, $18522b4fc47f45cb$export$606f11b2eb45ecc6)({
        control: control,
        name: [
            "name",
            "currency",
            "productPurchaseDate"
        ]
    });
    const { errors: errors, isValid: isValid } = formState;
    //--------------------------------------------------------------------------------
    // prepare empty form
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        const existingCurrency = getValues("currency");
        if (!existingCurrency) setValue("currency", (0, $796ea4636350e237$export$a01df35ce0858603)[0], {
            shouldDirty: false
        });
    }, []);
    //--------------------------------------------------------------------------------
    // update displayErrors and synchronise validation state with parent workflow
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (isValid) updateWorkflowStatus(index, true);
        else updateWorkflowStatus(index, false);
    }, [
        isValid
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    //---------------------------------------------------------------------------------------------
    // if accountCurrency !== baseCurrency, display current fx rate for the user's convenience
    //---------------------------------------------------------------------------------------------
    // when user selects a non-base-currency for the transaction, get the fx rate in the background and put it into the form
    // when updating this code, remember to change the same code in InflowOutflowTransfer.jsx
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const accountCurrency = watch("currency");
    const isBaseCurrencySameAsAccountCurrency = accountCurrency === baseCurrency;
    // update isBaseCurrencySameAsAccountCurrency in form state
    (0, $7fPBF.useEffect)(()=>{
        setValue("isBaseCurrencySameAsAccountCurrency", isBaseCurrencySameAsAccountCurrency);
    }, [
        isBaseCurrencySameAsAccountCurrency
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (!isBaseCurrencySameAsAccountCurrency && accountCurrency && baseCurrency) try {
                const newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, accountCurrency, baseCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                setValue("fxRate", newRate, {
                    shouldDirty: true
                }); // sets the form to dirty to trigger the useEffect depending on formState
            } catch (e) {
                console.error("Error: Step1AccountName: convertCurrency error", e);
                setValue("fxRate", null);
            }
            else setValue("fxRate", null); // clear when base == account
        }
        updateFxRate();
    }, [
        accountCurrency,
        baseCurrency,
        isBaseCurrencySameAsAccountCurrency
    ]);
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
        className: "space-y-6 md:space-y-0 md:grid md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: t("wizardSteps.newAccount.title")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-sm text-gray-500",
                        children: t("wizardSteps.newAccount.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "py-3 lg:pb-4 grid gap-4 xs:gap-6 lg:gap-8 max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                        id: "name",
                        category: "pension",
                        type: "text",
                        placeholder: tL("name.placeholder"),
                        autoComplete: "off",
                        optional: false,
                        register: register,
                        errors: errors,
                        validationRules: {
                            required: {
                                value: true,
                                message: tL("name.error")
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                        id: "currency",
                        list: (0, $796ea4636350e237$export$a01df35ce0858603),
                        label: tL("currency.label"),
                        placeholder: tL("currency.placeholder"),
                        toolTip: tL("currency.tooltip"),
                        register: register,
                        optional: false,
                        errors: errors,
                        control: control,
                        validationRules: {
                            required: {
                                value: true,
                                message: tL("currency.error")
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                        id: "productPurchaseDate",
                        category: "pension",
                        type: "date",
                        optional: false,
                        autoComplete: "off",
                        register: register,
                        errors: errors,
                        validationRules: {
                            required: {
                                value: true,
                                message: tL("productPurchaseDate.error")
                            },
                            validate: {
                                isValidDate: (value)=>{
                                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value, "YYYY-MM-DD", true).isValid()) return tL("productPurchaseDate.errorInvalid");
                                    return true;
                                },
                                notInFuture: (value)=>{
                                    if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(value).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(), "day")) return tL("productPurchaseDate.errorFuture");
                                    return true;
                                }
                            }
                        },
                        transformValue: {
                            setValueAs: (value)=>value ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(value).valueOf() : value
                        }
                    })
                ]
            })
        ]
    });
}
$ba9fac31fb6dba98$var$Step1AccountName.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$ba9fac31fb6dba98$var$Step1AccountName.defaultProps = {
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $ba9fac31fb6dba98$export$2e2bcd8739ae039 = $ba9fac31fb6dba98$var$Step1AccountName;


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");


/**
 * This const exports a list (Array) of pension field names that are set by a pension template.
 */ const $f450a9741087c8e6$var$templateFieldNames = [
    "contributionsSelfPaid",
    "contributionsFrequency",
    "contributionsDeductible",
    "payoutsTaxable",
    "payoutsIndexed",
    "payoutsFrequency",
    "payoutsDuration"
];
var $f450a9741087c8e6$export$2e2bcd8739ae039 = $f450a9741087c8e6$var$templateFieldNames;


function $8fd61e1b0b5b5e2b$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $8fd61e1b0b5b5e2b$var$Step2ProductType({ index: index, updateWorkflowStatus: updateWorkflowStatus, form: form, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "pension"
    });
    const productListRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    // icon and id are in products, need to add the translations here
    const productList = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.map((p)=>(0, $2qxEV._)((0, $9tqwB._)({}, p), {
            name: tI(`product.${p.id}.name`),
            description: tI(`product.${p.id}.description`)
        }));
    const { watch: watch, control: control, setValue: setValue, trigger: trigger } = form;
    const { isValid: isValid } = (0, $18522b4fc47f45cb$export$606f11b2eb45ecc6)({
        control: control,
        name: [
            "product"
        ]
    });
    //--------------------------------------------------------------------------------
    // synchronise form state with parent
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        updateWorkflowStatus(index, isValid);
    }, [
        isValid
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext,
        trigger,
        setSignalNext
    ]);
    //---------------------------------------------------------------------------------------------
    // react to changes in the product field; if user selects a new product
    // apply the changes to other form fields
    //---------------------------------------------------------------------------------------------
    // watch all fields determined by a pension template array members
    const templateFieldsValues = watch((0, $f450a9741087c8e6$export$2e2bcd8739ae039)); // this destructures to an array, i.e. const [value1, value2] = watch(['field1', 'field2'])
    //---------------------------------------------------------------------------------------------
    // if the user selects a new product, apply the product values to the form fields
    //---------------------------------------------------------------------------------------------
    const severalSetValueInProgress = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false); // to avoid the next useEffect to trigger immediatelly after the first setValue
    const product = watch("product"); // this field's value is the product ID
    // When no product is selected, keep keyboard focus within the step so the first tab lands on the first product option.
    (0, $7fPBF.useEffect)(()=>{
        if (!product && productListRef.current) productListRef.current.focus({
            preventScroll: true
        });
    }, [
        product
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // get products.pension and apply everything except id, type, Icon, link onto form state
        const selectedProduct = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.find((p)=>p.id === product);
        if (selectedProduct && selectedProduct.id !== "custom") {
            const { id: id, type: type, Icon: Icon, link: link } = selectedProduct, rest = (0, $bLhVg._)(selectedProduct, [
                "id",
                "type",
                "Icon",
                "link"
            ]);
            severalSetValueInProgress.current = true;
            Object.entries(rest).forEach(([key, value])=>{
                setValue(key, value);
            });
            // let all the code in the loop run its course and then set the flag to false (1ms delay is not enough, seems to be working ok for 100ms)
            setTimeout(()=>{
                severalSetValueInProgress.current = false;
            }, 100);
        }
    }, [
        product
    ]);
    //---------------------------------------------------------------------------------------------
    // set product to "custom" if the user changes any of the connected fields
    //---------------------------------------------------------------------------------------------
    // if the product is not on "custom" and the user changes any connected form fields, "product" should be reset to "custom"
    (0, $7fPBF.useEffect)(()=>{
        if (product && product !== "custom" && !severalSetValueInProgress.current) {
            // if a defined product is selected, check if all product fields in the state are equal to the template fields
            const selectedProduct = productList.find((p)=>p.id === product);
            // console.log('handler for >custom< is running for product', product, 'selectedProduct', selectedProduct, 'templateFieldsValues', templateFieldsValues, 'getValues', getValues());
            const allFieldsEqual = templateFieldsValues.every((value, idx)=>{
                const fieldName = (0, $f450a9741087c8e6$export$2e2bcd8739ae039)[idx];
                // console.log('comparing form state field', fieldName, value, 'with product template field value', selectedProduct[fieldName]);
                return value === selectedProduct[fieldName];
            });
            if (!allFieldsEqual) setValue("product", "custom");
        }
    }, [
        templateFieldsValues
    ]);
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "pt-4 sm:pt-0",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                children: tI("wizardSteps.selectProduct.title")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-1 pb-4 text-sm text-gray-500",
                children: tI("wizardSteps.selectProduct.subtitle")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "py-3 lg:py-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8",
                tabIndex: -1,
                ref: productListRef,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                    name: "product",
                    control: control,
                    render: ({ field: { onChange: onChange, onBlur: onBlur, value: value } })=>{
                        const computedValue = productList.find((item)=>item.id === value); // this will be undefined if value is not in list
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: productList.map((item, count)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    onClick: ()=>onChange(item.id),
                                    tabIndex: count + 1,
                                    type: "button",
                                    className: ` ${item.id === (computedValue === null || computedValue === void 0 ? void 0 : computedValue.id) ? "ring-2 ring-brandBlue-500" : ""} flex flex-col border bg-white border-gray-100 shadow-sm rounded-md p-4 cursor-pointer hover:border-gray-300`,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                            className: "flex items-start gap-x-3 text-base font-semibold leading-7 text-gray-900 min-h-[3rem]",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.Icon, {
                                                    className: "h-5 w-5 flex-none text-brandBlue-500",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "text-left leading-5",
                                                    children: item.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dd", {
                                            className: "mt-2 flex flex-auto flex-col text-base leading-7 text-gray-600",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-left flex-auto text-sm",
                                                    children: item.description
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-6",
                                                    children: product !== item.id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "text-left text-sm font-semibold leading-6 text-brandBlue-500",
                                                        children: [
                                                            "Select",
                                                            " ",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                "aria-hidden": "true",
                                                                children: "\u2192"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, item.name))
                        });
                    }
                })
            })
        ]
    });
}
$8fd61e1b0b5b5e2b$var$Step2ProductType.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$8fd61e1b0b5b5e2b$var$Step2ProductType.defaultProps = {
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $8fd61e1b0b5b5e2b$export$2e2bcd8739ae039 = $8fd61e1b0b5b5e2b$var$Step2ProductType;


/* eslint-disable max-len */ /* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");






/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

function $8571da854b9a5ad9$var$DoubleCurrencyField({ fieldName: fieldName, accountField: accountField, baseField: baseField, label: label, tooltip: tooltip, optionalText: optionalText, placeholderAccount: placeholderAccount, placeholderBase: placeholderBase, errors: errors, register: register, watch: watch, accountCurrency: accountCurrency, isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency, baseCurrency: baseCurrency, accountValidation: accountValidation, baseValidation: baseValidation, className: className, accountTabIndex: accountTabIndex, baseTabIndex: baseTabIndex, labelClassName: labelClassName }) {
    const resolvedAccountField = accountField || (fieldName ? `${fieldName}Quote` : "");
    const resolvedBaseField = baseField || (fieldName ? `${fieldName}QuoteBaseCurrency` : "");
    const displayLabel = label || fieldName || "";
    const accountError = errors === null || errors === void 0 ? void 0 : errors[resolvedAccountField];
    const baseError = errors === null || errors === void 0 ? void 0 : errors[resolvedBaseField];
    const hasError = Boolean(accountError || baseError);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex gap-1 items-start justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                        htmlFor: resolvedAccountField,
                        className: `text-sm font-medium whitespace-pre-line ${labelClassName || "text-gray-700"}`,
                        children: [
                            displayLabel,
                            tooltip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                formatting: "inline-block -mb-1",
                                info: tooltip
                            })
                        ]
                    }),
                    optionalText && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-sm text-gray-500",
                        children: optionalText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-1 relative",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-2 gap-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    id: resolvedAccountField,
                                    type: "number",
                                    autoComplete: "off",
                                    name: resolvedAccountField,
                                    className: `block w-full focus:outline-none sm:text-sm rounded-md bg-white ${hasError ? "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                                    placeholder: placeholderAccount,
                                    tabIndex: accountTabIndex
                                }, register(resolvedAccountField, accountValidation))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-xs xs:text-sm whitespace-nowrap",
                                    children: accountCurrency || "?"
                                })
                            ]
                        }),
                        !isBaseCurrencySameAsAccountCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    id: resolvedBaseField,
                                    type: "number",
                                    autoComplete: "off",
                                    name: resolvedBaseField,
                                    className: `block w-full focus:outline-none sm:text-sm rounded-md bg-white ${hasError ? "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`,
                                    placeholder: placeholderBase || placeholderAccount,
                                    tabIndex: baseTabIndex
                                }, register(resolvedBaseField, baseValidation))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-xs xs:text-sm whitespace-nowrap",
                                    children: baseCurrency
                                })
                            ]
                        })
                    ]
                })
            }),
            (accountError || baseError) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-red-600",
                children: (accountError === null || accountError === void 0 ? void 0 : accountError.message) || (baseError === null || baseError === void 0 ? void 0 : baseError.message)
            })
        ]
    });
}
$8571da854b9a5ad9$var$DoubleCurrencyField.propTypes = {
    fieldName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    accountField: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    baseField: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    optionalText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    placeholderAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    placeholderBase: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    accountCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    isBaseCurrencySameAsAccountCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    accountValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    baseValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    accountTabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    baseTabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    labelClassName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$8571da854b9a5ad9$var$DoubleCurrencyField.defaultProps = {
    fieldName: "",
    tooltip: "",
    optionalText: "Optional",
    placeholderAccount: "250",
    placeholderBase: null,
    accountCurrency: "",
    accountValidation: undefined,
    baseValidation: undefined,
    className: "",
    accountField: "",
    baseField: "",
    label: "",
    accountTabIndex: undefined,
    baseTabIndex: undefined,
    labelClassName: ""
};
var $8571da854b9a5ad9$export$2e2bcd8739ae039 = $8571da854b9a5ad9$var$DoubleCurrencyField;


/* eslint-disable max-len */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

function $2d4ee517e6208b29$var$FxRateApply({ fxRate: fxRate, labelText: labelText, tooltipText: tooltipText, buttonText: buttonText, onApply: onApply, className: className, buttonId: buttonId, tabIndex: tabIndex }) {
    if (!Number.isFinite(fxRate) || fxRate === null) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `text-sm leading-snug flex flex-col text-gray-700 ${className}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: buttonId,
                        className: "font-medium",
                        children: labelText
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: fxRate.toFixed(2)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                        info: tooltipText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex items-center w-full mt-1",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex gap-2 items-center w-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: buttonId,
                        className: "rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500",
                        onClick: onApply,
                        tabIndex: tabIndex,
                        children: buttonText
                    })
                })
            })
        ]
    });
}
$2d4ee517e6208b29$var$FxRateApply.propTypes = {
    fxRate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    tooltipText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    buttonText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    buttonId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
};
$2d4ee517e6208b29$var$FxRateApply.defaultProps = {
    fxRate: null,
    className: "",
    buttonId: "fx-rate-button",
    tabIndex: 0
};
var $2d4ee517e6208b29$export$2e2bcd8739ae039 = $2d4ee517e6208b29$var$FxRateApply;




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $b264a431fde9d7cd$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $b264a431fde9d7cd$var$Step3Contributions({ index: index, updateWorkflowStatus: updateWorkflowStatus, form: form, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "pension"
    });
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const [fxRate, setFxRate] = (0, $7fPBF.useState)(null);
    const { register: register, watch: watch, getValues: getValues, control: control, setValue: setValue, trigger: trigger } = form;
    const { errors: errors, isValid: isValid } = (0, $18522b4fc47f45cb$export$606f11b2eb45ecc6)({
        control: control,
        name: [
            "contributionsSelfPaid",
            "contributionsAmountsUserInput",
            "contributionsAmountsUserInputBaseCurrency",
            "contributionsDeductible",
            "contributionsIndexed",
            "discountRateIsInflation",
            "customDiscountRate"
        ]
    });
    const contributionsSelfPaid = watch("contributionsSelfPaid");
    const contributionsIndexed = watch("contributionsIndexed");
    const discountRateIsInflation = watch("discountRateIsInflation");
    const watchedCurrency = watch("currency");
    const accountCurrency = watchedCurrency || baseCurrency;
    const isBaseCurrencySameAsAccountCurrency = getValues("isBaseCurrencySameAsAccountCurrency"); // set in step 1
    const TAB_STOPS = {
        contributionsSelfPaid: 1,
        contributionsAmountsAccount: 2,
        contributionsAmountsBase: 3,
        contributionsDeductible: 4,
        contributionsIndexed: 5,
        discountRateIsInflation: 6,
        customDiscountRate: 7,
        applyFxRate: 8
    };
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext,
        trigger,
        setSignalNext
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (!accountCurrency || !baseCurrency) return;
            if (isBaseCurrencySameAsAccountCurrency) {
                setFxRate(null);
                return;
            }
            setFxRate("loading");
            try {
                const newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, accountCurrency, baseCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                setFxRate(newRate);
            } catch (err) {
                setFxRate(null);
            }
        }
        updateFxRate();
    }, [
        accountCurrency,
        baseCurrency,
        isBaseCurrencySameAsAccountCurrency
    ]);
    (0, $7fPBF.useEffect)(()=>{
        updateWorkflowStatus(index, isValid);
    }, [
        isValid
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!contributionsIndexed) {
            setValue("discountRateIsInflation", null, {
                shouldDirty: false,
                shouldValidate: true
            });
            setValue("customDiscountRate", null, {
                shouldDirty: false,
                shouldValidate: true
            });
            return;
        }
        if (discountRateIsInflation === undefined || discountRateIsInflation === null) setValue("discountRateIsInflation", true, {
            shouldDirty: false,
            shouldValidate: true
        });
        if (discountRateIsInflation) setValue("customDiscountRate", null, {
            shouldDirty: false,
            shouldValidate: true
        });
    }, [
        contributionsIndexed,
        discountRateIsInflation,
        setValue
    ]);
    //---------------------------------------------------------------------------------------------
    // set product to "custom" if the user changes any of the connected fields
    //---------------------------------------------------------------------------------------------
    // icon and id are in products, need to add the translations here
    const productList = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.map((p)=>(0, $2qxEV._)((0, $9tqwB._)({}, p), {
            name: tI(`product.${p.id}.name`),
            description: tI(`product.${p.id}.description`)
        }));
    const product = watch("product"); // this field's value is the product ID
    const severalSetValueInProgress = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false); // to avoid the next useEffect to trigger immediatelly after the first setValue
    // watch all fields determined by a pension template array members
    const templateFieldsValues = watch((0, $f450a9741087c8e6$export$2e2bcd8739ae039)); // this destructures to an array, i.e. const [value1, value2] = watch(['field1', 'field2'])
    // if the product is not on "custom" and the user changes any connected form fields, "product" should be reset to "custom"
    (0, $7fPBF.useEffect)(()=>{
        if (product && product !== "custom" && !severalSetValueInProgress.current) {
            // if a defined product is selected, check if all product fields in the state are equal to the template fields
            const selectedProduct = productList.find((p)=>p.id === product);
            // console.log('handler for >custom< is running for product', product, 'selectedProduct', selectedProduct, 'templateFieldsValues', templateFieldsValues, 'getValues', getValues());
            const allFieldsEqual = templateFieldsValues.every((value, idx)=>{
                const fieldName = (0, $f450a9741087c8e6$export$2e2bcd8739ae039)[idx];
                // console.log('comparing form state field', fieldName, value, 'with product template field value', selectedProduct[fieldName]);
                return value === selectedProduct[fieldName];
            });
            if (!allFieldsEqual) setValue("product", "custom");
        }
    }, [
        templateFieldsValues
    ]);
    const handleFxRateButton = ()=>{
        if (!Number.isFinite(fxRate) || isBaseCurrencySameAsAccountCurrency) return;
        const amount = Number(getValues("contributionsAmountsUserInput"));
        if (Number.isNaN(amount)) return;
        setValue("contributionsAmountsUserInputBaseCurrency", Number((amount * fxRate).toFixed(2)), {
            shouldDirty: true,
            shouldValidate: true
        });
    };
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "pt-4 sm:pt-0",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                children: tI("wizardSteps.contributions.title")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-1 pb-4 text-sm text-gray-500",
                children: tI("wizardSteps.contributions.subtitle")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "py-3 lg:pb-4 grid grid-cols-1 xs:grid-cols-2 gap-4 xs:gap-6 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "contributionsSelfPaid",
                        control: control,
                        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                id: "contributionsSelfPaid",
                                formatting: "col-span-full xs:col-span-1 xs:col-start-1",
                                onChange: onChange,
                                onBlur: onBlur,
                                value: value,
                                inputRef: ref,
                                tabIndex: TAB_STOPS.contributionsSelfPaid,
                                label: tL("contributionsSelfPaid.label"),
                                tooltip: tL("contributionsSelfPaid.tooltip")
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8571da854b9a5ad9$export$2e2bcd8739ae039), {
                        accountField: "contributionsAmountsUserInput",
                        baseField: "contributionsAmountsUserInputBaseCurrency",
                        label: tL("contributionsAmounts.label"),
                        tooltip: tL("contributionsAmounts.tooltip"),
                        optionalText: contributionsSelfPaid ? "" : "Optional",
                        placeholderAccount: tL("contributionsAmounts.placeholder"),
                        placeholderBase: tL("contributionsAmounts.placeholder"),
                        errors: errors,
                        register: register,
                        watch: watch,
                        accountCurrency: accountCurrency,
                        isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency,
                        baseCurrency: baseCurrency,
                        className: "col-span-full xs:col-span-1 xs:col-start-2",
                        accountTabIndex: TAB_STOPS.contributionsAmountsAccount,
                        baseTabIndex: TAB_STOPS.contributionsAmountsBase,
                        accountValidation: {
                            validate: (value)=>contributionsSelfPaid === true && !value ? tL("contributionsAmounts.error") : true
                        },
                        baseValidation: isBaseCurrencySameAsAccountCurrency ? undefined : {
                            validate: (value)=>contributionsSelfPaid === true && !value ? tL("contributionsAmounts.error") : true
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "contributionsDeductible",
                        control: control,
                        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                id: "contributionsDeductible",
                                formatting: "col-span-full xs:col-span-1 xs:col-start-1",
                                onChange: onChange,
                                onBlur: onBlur,
                                value: value,
                                inputRef: ref,
                                tabIndex: TAB_STOPS.contributionsDeductible,
                                label: tL("contributionsDeductible.label"),
                                tooltip: tL("contributionsDeductible.tooltip")
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "contributionsIndexed",
                        control: control,
                        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                id: "contributionsIndexed",
                                formatting: "col-span-full xs:col-span-1 xs:col-start-1",
                                onChange: onChange,
                                onBlur: onBlur,
                                value: value,
                                inputRef: ref,
                                tabIndex: TAB_STOPS.contributionsIndexed,
                                label: tL("contributionsIndexed.label"),
                                tooltip: tL("contributionsIndexed.tooltip")
                            })
                    }),
                    contributionsIndexed && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "discountRateIsInflation",
                        control: control,
                        render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                                id: "discountRateIsInflation",
                                formatting: "col-span-full xs:col-span-1 xs:col-start-2",
                                onChange: onChange,
                                onBlur: onBlur,
                                value: value,
                                inputRef: ref,
                                tabIndex: TAB_STOPS.contributionsIndexedByInflation,
                                label: tL("discountRateIsInflation.label"),
                                tooltip: tL("discountRateIsInflation.tooltip")
                            })
                    }),
                    contributionsIndexed && discountRateIsInflation === false && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                        id: "customDiscountRate",
                        category: "pension",
                        type: "number",
                        autoComplete: "off",
                        optional: false,
                        register: register,
                        errors: errors,
                        formatting: "col-span-full xs:col-span-1 xs:col-start-1",
                        validationRules: {
                            validate: (value)=>value !== undefined && value !== null && value !== "" ? true : tL("customDiscountRate.error")
                        }
                    }),
                    !isBaseCurrencySameAsAccountCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d4ee517e6208b29$export$2e2bcd8739ae039), {
                        fxRate: Number(fxRate),
                        labelText: tL("fxRate.label", {
                            accountCurrency: accountCurrency,
                            baseCurrency: baseCurrency
                        }),
                        tooltipText: tL("fxRate.tooltip", {
                            baseCurrency: baseCurrency
                        }),
                        buttonText: tL("fxRate.apply", {
                            baseCurrency: baseCurrency
                        }),
                        onApply: handleFxRateButton,
                        className: "col-span-full xs:col-span-1",
                        tabIndex: TAB_STOPS.applyFxRate
                    }),
                    " "
                ]
            })
        ]
    });
}
$b264a431fde9d7cd$var$Step3Contributions.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$b264a431fde9d7cd$var$Step3Contributions.defaultProps = {
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $b264a431fde9d7cd$export$2e2bcd8739ae039 = $b264a431fde9d7cd$var$Step3Contributions;


/* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");







function $dfc72607c0375076$var$Step4Payouts({ index: index, updateWorkflowStatus: updateWorkflowStatus, form: form, signalNext: signalNext, setSignalNext: setSignalNext }) {
    var _errors_payoutsDuration;
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "pension"
    });
    // ---------------------------------
    // process input data
    // ---------------------------------
    const { register: register, watch: watch, getValues: getValues, control: control, setValue: setValue, trigger: trigger } = form;
    const { errors: errors, isValid: isValid } = (0, $18522b4fc47f45cb$export$606f11b2eb45ecc6)({
        control: control,
        name: [
            "payoutsPhaseStart",
            "payoutsFrequency",
            "payoutsDuration",
            "payoutsDurationUserInput",
            "payoutDurationFrequencyUnitUserInput",
            "payoutsTaxable",
            "payoutsIndexed"
        ]
    });
    const durationFrequencyUnit = watch("payoutDurationFrequencyUnitUserInput");
    const durationInput = watch("payoutsDurationUserInput");
    const payoutsIndexed = watch("payoutsIndexed");
    // ---------------------------------
    // internal form logic
    // ---------------------------------
    // initialise
    (0, $7fPBF.useEffect)(()=>{
        const payoutDuration = getValues("payoutDuration"); // from formState
        // set human-readable unit in frequency dialog
        switch(payoutDuration){
            case 3:
                setValue("payoutDurationFrequencyUnitUserInput", "months", {
                    shouldDirty: false
                });
                break;
            case 12:
                setValue("payoutDurationFrequencyUnitUserInput", "years", {
                    shouldDirty: false
                });
                break;
            case 0:
            default:
                setValue("payoutDurationFrequencyUnitUserInput", "indefinite", {
                    shouldDirty: false
                });
        }
        if (payoutDuration === undefined || payoutDuration === 0) setValue("payoutDurationFrequencyUnitUserInput", "indefinite", {
            shouldDirty: false
        });
    }, []);
    // convert form user inputs to form state values
    (0, $7fPBF.useEffect)(()=>{
        // payoutsDurationUserInput + Frequency --> payoutsDuration
        const payoutDurationFrequencyUnitUserInput = getValues("payoutDurationFrequencyUnitUserInput");
        const payoutDurationUserInput = getValues("payoutsDurationUserInput");
        if (payoutDurationFrequencyUnitUserInput === "indefinite") setValue("payoutsDuration", 0);
        else if (payoutDurationUserInput) {
            const numeric = Number(payoutDurationUserInput);
            if (!Number.isNaN(numeric)) {
                const months = durationFrequencyUnit === "years" ? numeric * 12 : numeric;
                setValue("payoutsDuration", months);
            }
        } else setValue("payoutsDuration", null);
    }, [
        durationFrequencyUnit,
        durationInput
    ]);
    // -----------------------------------------------
    // synchronise this form with parent form's state
    // -----------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        updateWorkflowStatus(index, isValid);
    }, [
        isValid
    ]);
    // ---------------------------------
    // receive signal next from nav component
    // ---------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            const fieldsToValidate = [
                "payoutsPhaseStart",
                "payoutsFrequency"
            ];
            trigger(fieldsToValidate);
            setSignalNext(false);
        }
    }, [
        signalNext,
        trigger,
        setSignalNext,
        payoutsIndexed
    ]);
    //---------------------------------------------------------------------------------------------
    // set product to "custom" if the user changes any of the connected fields
    //---------------------------------------------------------------------------------------------
    // icon and id are in products, need to add the translations here
    const productList = (0, $ac576c131d4eaa76$export$2e2bcd8739ae039).pension.map((p)=>(0, $2qxEV._)((0, $9tqwB._)({}, p), {
            name: tI(`product.${p.id}.name`),
            description: tI(`product.${p.id}.description`)
        }));
    const product = watch("product"); // this field's value is the product ID
    // watch all fields determined by a pension template array members
    const templateFieldsValues = watch((0, $f450a9741087c8e6$export$2e2bcd8739ae039)); // this destructures to an array, i.e. const [value1, value2] = watch(['field1', 'field2'])
    // if the product is not on "custom" and the user changes any connected form fields, "product" should be reset to "custom"
    (0, $7fPBF.useEffect)(()=>{
        if (product && product !== "custom") {
            // if a defined product is selected, check if all product fields in the state are equal to the template fields
            const selectedProduct = productList.find((p)=>p.id === product);
            // console.log('handler for >custom< is running for product', product, 'selectedProduct', selectedProduct, 'templateFieldsValues', templateFieldsValues, 'getValues', getValues());
            const allFieldsEqual = templateFieldsValues.every((value, idx)=>{
                const fieldName = (0, $f450a9741087c8e6$export$2e2bcd8739ae039)[idx];
                // console.log('comparing form state field', fieldName, value, 'with product template field value', selectedProduct[fieldName]);
                return value === selectedProduct[fieldName];
            });
            if (!allFieldsEqual) setValue("product", "custom");
        }
    }, [
        templateFieldsValues
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "pt-4 sm:pt-0 grid sm:grid-cols-2 gap-4 sm:gap-x-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("wizardSteps.payouts.title")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 pb-4 text-sm text-gray-500",
                        children: tI("wizardSteps.payouts.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                id: "payoutsPhaseStart",
                category: "pension",
                type: "date",
                optional: false,
                autoComplete: "off",
                register: register,
                errors: errors,
                validationRules: {
                    required: {
                        value: true,
                        message: tL("payoutsPhaseStart.error")
                    }
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                id: "payoutsFrequency",
                list: [
                    null,
                    {
                        id: 1,
                        name: tL("parameters.payoutsFrequency.1")
                    },
                    {
                        id: 3,
                        name: tL("parameters.payoutsFrequency.3")
                    },
                    {
                        id: 12,
                        name: tL("parameters.payoutsFrequency.12")
                    },
                    {
                        id: 0,
                        name: tL("parameters.payoutsFrequency.0")
                    }
                ],
                label: tL("payoutsFrequency.label"),
                placeholder: tL("payoutsFrequency.placeholder"),
                toolTip: tL("payoutsFrequency.tooltip"),
                register: register,
                errors: errors,
                control: control,
                optional: false,
                validationRules: {
                    required: {
                        value: true,
                        message: tL("payoutsFrequency.error")
                    }
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-between",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                            htmlFor: "payoutsDurationUserInput",
                            className: "text-sm font-medium text-gray-700 flex justify-start",
                            children: [
                                tL("payoutsDuration.label"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                    info: tL("payoutsDurationUserInput.tooltip")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-1 relative rounded-md shadow-sm",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "grid grid-cols-2 gap-4",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    id: "payoutsDurationUserInput",
                                    type: "number",
                                    autoComplete: "off",
                                    disabled: durationFrequencyUnit === "indefinite",
                                    className: `block w-full focus:outline-none sm:text-sm rounded-md ${(errors === null || errors === void 0 ? void 0 : errors.payoutsDuration) ? "border-red-300 text-red-900  placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`
                                }, register("payoutsDurationUserInput"))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                    id: "payoutDurationFrequencyUnitUserInput",
                                    className: `block w-full focus:outline-none sm:text-sm rounded-md ${(errors === null || errors === void 0 ? void 0 : errors.payoutsDuration) ? "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500" : "border-gray-300 placeholder-gray-400 focus:ring-brandBlue-500 focus:border-brandBlue-500"}`
                                }, register("payoutDurationFrequencyUnitUserInput")), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "months",
                                            children: tL("parameters.frequencyUnit.1")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "years",
                                            children: tL("parameters.frequencyUnit.12")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "indefinite",
                                            children: tL("parameters.frequencyUnit.0")
                                        })
                                    ]
                                }))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-red-600",
                        children: errors === null || errors === void 0 ? void 0 : (_errors_payoutsDuration = errors.payoutsDuration) === null || _errors_payoutsDuration === void 0 ? void 0 : _errors_payoutsDuration.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "payoutsTaxable",
                control: control,
                render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                        id: "payoutsTaxable",
                        onChange: onChange,
                        onBlur: onBlur,
                        value: value,
                        inputRef: ref,
                        label: tL("payoutsTaxable.label"),
                        tooltip: tL("payoutsTaxable.tooltip")
                    })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "payoutsIndexed",
                control: control,
                render: ({ field: { onChange: onChange, onBlur: onBlur, value: value, ref: ref } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f052d78aec7029ba$export$2e2bcd8739ae039), {
                        id: "payoutsIndexed",
                        onChange: onChange,
                        onBlur: onBlur,
                        value: value,
                        inputRef: ref,
                        label: tL("payoutsIndexed.label"),
                        tooltip: tL("payoutsIndexed.tooltip")
                    })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                type: "hidden"
            }, register("payoutsDuration")))
        ]
    });
}
$dfc72607c0375076$var$Step4Payouts.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$dfc72607c0375076$var$Step4Payouts.defaultProps = {
    signalNext: false,
    setSignalNext: ()=>{}
};
var $dfc72607c0375076$export$2e2bcd8739ae039 = $dfc72607c0375076$var$Step4Payouts;


/* eslint-disable no-nested-ternary */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");





function $857eb878fd7bb7d9$var$Step5PayoutsCurrentPrognosis({ index: index, updateWorkflowStatus: updateWorkflowStatus, form: form, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tT } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.transaction"
    });
    const { t: tA } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "pension"
    });
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const { register: register, watch: watch, getValues: getValues, setValue: setValue, trigger: trigger, setError: setError, clearErrors: clearErrors } = form;
    const { errors: errors } = (0, $18522b4fc47f45cb$export$606f11b2eb45ecc6)({
        control: form.control,
        name: [
            "payoutOnlyContributionsToDateQuote",
            "payoutOnlyContributionsToDateIndexedQuote",
            "payoutAllPlannedContributionsQuote",
            "payoutAllPlannedContributionsIndexedQuote",
            "payoutLumpSumVerrentetQuote",
            "quoteGroup",
            "useSpecialQuote"
        ]
    });
    // register a background field to the form
    (0, $7fPBF.useEffect)(()=>{
        register("useSpecialQuote");
        register("quoteGroup");
    }, [
        register
    ]);
    const watchedCurrency = watch("currency");
    const accountCurrency = watchedCurrency || baseCurrency;
    const isBaseCurrencySameAsAccountCurrency = getValues("isBaseCurrencySameAsAccountCurrency"); // set in step 1
    const useSpecialQuote = watch("useSpecialQuote");
    const quoteFieldsNames = [
        "payoutOnlyContributionsToDate",
        "payoutOnlyContributionsToDateIndexed",
        "payoutAllPlannedContributions",
        "payoutAllPlannedContributionsIndexed",
        "payoutLumpSumVerrentet"
    ];
    const quoteFieldsValues = watch(quoteFieldsNames.map((field)=>`${field}Quote`));
    const quoteFieldsBaseValues = watch(quoteFieldsNames.map((field)=>`${field}QuoteBaseCurrency`));
    //------------------------------------------------------------------------------
    // output logic
    //------------------------------------------------------------------------------
    const buildInitialQuotes = (formValues)=>{
        const quotes = [];
        quoteFieldsNames.forEach((val)=>{
            const quoteValue = formValues[`${val}Quote`];
            if (quoteValue !== undefined && quoteValue !== null && quoteValue !== "") {
                const quote = Number(quoteValue);
                if (Number.isNaN(quote)) return;
                const baseValue = isBaseCurrencySameAsAccountCurrency ? quote : Number(formValues[`${val}QuoteBaseCurrency`]);
                quotes.push({
                    type: val,
                    quote: quote,
                    quoteBaseCurrency: Number.isNaN(baseValue) ? quote : baseValue
                });
            }
        });
        return quotes;
    };
    const processOutputData = (formValues)=>{
        const result = (0, $9tqwB._)({}, formValues);
        result.initialQuotes = buildInitialQuotes(formValues);
        return result;
    };
    const outputsEqual = (a, b)=>JSON.stringify(a) === JSON.stringify(b);
    const prevOutputRef = (0, $7fPBF.useRef)(processOutputData(getValues()));
    //--------------------------------------------------------------------------------
    // logic to require at least one of the values to be filled out
    //--------------------------------------------------------------------------------
    const hasValue = (value)=>value !== undefined && value !== null && value !== "" && value !== 0 && value !== "0";
    const quoteKey = quoteFieldsValues.map((v)=>v !== null && v !== void 0 ? v : "").join("|"); // so that we don't rerun the effect every time there is a render
    const quoteBaseKey = quoteFieldsBaseValues.map((v)=>v !== null && v !== void 0 ? v : "").join("|");
    (0, $7fPBF.useEffect)(()=>{
        const hasAtLeastOneQuote = isBaseCurrencySameAsAccountCurrency ? quoteFieldsValues.some((value)=>hasValue(value)) : quoteFieldsNames.some((_, idx)=>hasValue(quoteFieldsValues[idx]) && hasValue(quoteFieldsBaseValues[idx]));
        const stepIsValid = hasAtLeastOneQuote && Boolean(useSpecialQuote);
        if (!hasAtLeastOneQuote) {
            setError("quoteGroup", {
                type: "manual",
                message: tI("payoutsAmountValidation")
            });
            clearErrors("useSpecialQuote");
        } else {
            clearErrors("quoteGroup");
            if (!useSpecialQuote) setError("useSpecialQuote", {
                type: "manual",
                message: tI("payoutsAmountUseSpecialQuoteValidation")
            });
            else clearErrors("useSpecialQuote");
        }
        const output = processOutputData(getValues());
        if (!outputsEqual(output, prevOutputRef.current)) {
            setValue("initialQuotes", output.initialQuotes, {
                shouldDirty: true,
                shouldValidate: false
            });
            prevOutputRef.current = output;
        }
        updateWorkflowStatus(index, stepIsValid);
    }, [
        quoteKey,
        quoteBaseKey,
        useSpecialQuote,
        isBaseCurrencySameAsAccountCurrency
    ]);
    // auto-select the first quote that is ready
    const hasAutoSelectedSpecialQuote = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (hasAutoSelectedSpecialQuote.current) return;
        if (useSpecialQuote) {
            hasAutoSelectedSpecialQuote.current = true;
            return;
        }
        const firstFilledIndex = quoteFieldsNames.findIndex((_, idx)=>{
            if (isBaseCurrencySameAsAccountCurrency) return hasValue(quoteFieldsValues[idx]);
            return hasValue(quoteFieldsValues[idx]) && hasValue(quoteFieldsBaseValues[idx]);
        });
        if (firstFilledIndex >= 0) {
            const selectedKey = quoteFieldsNames[firstFilledIndex];
            setValue("useSpecialQuote", selectedKey, {
                shouldDirty: true,
                shouldValidate: false
            });
            clearErrors("useSpecialQuote");
            hasAutoSelectedSpecialQuote.current = true;
        }
    }, [
        quoteFieldsBaseValues,
        quoteFieldsNames,
        quoteFieldsValues,
        useSpecialQuote,
        isBaseCurrencySameAsAccountCurrency
    ]);
    // reset useSpecialQuote if the user deletes the value
    (0, $7fPBF.useEffect)(()=>{
        if (!useSpecialQuote) return;
        const activeIndex = quoteFieldsNames.indexOf(useSpecialQuote);
        if (activeIndex === -1) return;
        const accountValue = quoteFieldsValues[activeIndex];
        const baseValue = quoteFieldsBaseValues[activeIndex];
        const hasAccountValue = hasValue(accountValue);
        const hasBaseValue = hasValue(baseValue);
        const isFilled = isBaseCurrencySameAsAccountCurrency ? hasAccountValue : hasAccountValue && hasBaseValue;
        if (!isFilled) setValue("useSpecialQuote", "", {
            shouldDirty: true,
            shouldValidate: false
        });
    }, [
        quoteFieldsValues,
        quoteFieldsBaseValues,
        isBaseCurrencySameAsAccountCurrency
    ]);
    // handle signalNext
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            const fieldsToValidate = [
                ...quoteFieldsNames.map((field)=>`${field}Quote`),
                ...!isBaseCurrencySameAsAccountCurrency ? quoteFieldsNames.map((field)=>`${field}QuoteBaseCurrency`) : [],
                "quoteGroup",
                "useSpecialQuote"
            ];
            trigger(fieldsToValidate);
            setSignalNext(false);
        }
    }, [
        signalNext,
        trigger,
        setSignalNext,
        quoteFieldsNames,
        isBaseCurrencySameAsAccountCurrency
    ]);
    // handle the "apply fx rate" button
    const fxRate = watch("fxRate");
    function handleFxRateButton() {
        // get a list of dirtyFields and filter them to only leave fieldNames which have payoutAll or payoutOnly and which end in Quote
        // if that list is not empty, apply the fxRate to those fields
        if (!Number.isFinite(fxRate)) return;
        quoteFieldsNames.forEach((fieldName)=>{
            const fieldQuote = getValues(`${fieldName}Quote`);
            if (fieldQuote) setValue(`${fieldName}QuoteBaseCurrency`, Number((fxRate * fieldQuote).toFixed(2)), {
                shouldValidate: true
            });
        });
    }
    // renders the appropriate action button
    const rowStateByField = (0, $7fPBF.useMemo)(()=>quoteFieldsNames.map((key, x)=>{
            const accountValue = quoteFieldsValues[x];
            const baseValue = quoteFieldsBaseValues[x];
            const hasAccountValue = hasValue(accountValue);
            const hasBaseValue = hasValue(baseValue);
            const isFilled = isBaseCurrencySameAsAccountCurrency ? hasAccountValue : hasAccountValue && hasBaseValue;
            const isActive = useSpecialQuote === key;
            return {
                key: key,
                isFilled: isFilled,
                isActive: isActive
            };
        }), [
        isBaseCurrencySameAsAccountCurrency,
        quoteFieldsBaseValues,
        quoteFieldsNames,
        quoteFieldsValues,
        useSpecialQuote
    ]);
    function setActiveQuote(fieldName) {
        setValue("useSpecialQuote", fieldName, {
            shouldDirty: true,
            shouldValidate: false
        });
    }
    function renderAction(fieldName, isFilled, isActive, breakpointHidden = false) {
        if (isActive) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "inline-flex items-center gap-2 text-sm font-semibold text-brandBlue-700",
            children: tI("wizardSteps.payoutsAmount.useThisActive")
        });
        if (!isFilled) return null;
        const visibilityClasses = breakpointHidden ? "hidden md:flex" : "flex md:hidden";
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: `${visibilityClasses}`,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                text: tI("wizardSteps.payoutsAmount.useThisCta"),
                onClick: ()=>setActiveQuote(fieldName)
            })
        });
    }
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "pt-4 sm:pt-0",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("wizardSteps.payoutsAmount.title")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 pb-4 text-sm text-gray-500",
                        children: tI("wizardSteps.payoutsAmount.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-full md:w-3/4 lg:w-2/3 bg-white rounded-lg shadow-sm divide-y divide-gray-200",
                children: rowStateByField.map(({ key: key, isFilled: isFilled, isActive: isActive })=>{
                    const rowBase = "group px-4 md:px-5 py-4 md:py-5 transition-colors";
                    const rowClass = isActive ? `${rowBase} bg-brandBlue-50` : `${rowBase} bg-white`;
                    const labelClassName = isActive ? "text-brandBlue-900 font-semibold" : isFilled ? "text-gray-800" : "text-gray-600";
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: rowClass,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_160px] gap-3 md:items-start",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8571da854b9a5ad9$export$2e2bcd8739ae039), {
                                        errors: errors,
                                        register: register,
                                        watch: watch,
                                        accountCurrency: accountCurrency,
                                        isBaseCurrencySameAsAccountCurrency: isBaseCurrencySameAsAccountCurrency,
                                        baseCurrency: baseCurrency,
                                        fieldName: key,
                                        label: tT(`${key}.label`),
                                        tooltip: tT(`${key}.description`),
                                        optionalText: null,
                                        className: "md:col-span-1",
                                        labelClassName: labelClassName
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "hidden md:flex items-start justify-end pt-1",
                                        children: renderAction(key, isFilled, isActive, true)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-3 md:hidden",
                                children: renderAction(key, isFilled, isActive, false)
                            })
                        ]
                    }, key);
                })
            }),
            !isBaseCurrencySameAsAccountCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2d4ee517e6208b29$export$2e2bcd8739ae039), {
                className: "mt-4 xs:w-1/2",
                fxRate: Number(fxRate),
                labelText: tA("fxRate.label", {
                    accountCurrency: accountCurrency,
                    baseCurrency: baseCurrency
                }),
                tooltipText: tA("fxRate.tooltip", {
                    baseCurrency: baseCurrency
                }),
                buttonText: tA("fxRate.apply", {
                    baseCurrency: baseCurrency
                }),
                // eslint-disable-next-line react/jsx-no-bind
                onApply: handleFxRateButton
            })
        ]
    });
}
$857eb878fd7bb7d9$var$Step5PayoutsCurrentPrognosis.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$857eb878fd7bb7d9$var$Step5PayoutsCurrentPrognosis.defaultProps = {
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $857eb878fd7bb7d9$export$2e2bcd8739ae039 = $857eb878fd7bb7d9$var$Step5PayoutsCurrentPrognosis;


/* eslint-disable max-len */ /* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $1205e1ea1e824e93$var$ChevronUpDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
        clipRule: "evenodd"
    }));
}
const $1205e1ea1e824e93$var$ForwardRef = $7fPBF.forwardRef($1205e1ea1e824e93$var$ChevronUpDownIcon);
var $1205e1ea1e824e93$export$2e2bcd8739ae039 = $1205e1ea1e824e93$var$ForwardRef;




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $e629de6f734a4d7a$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $e629de6f734a4d7a$var$ConnectedAccount({ index: index, updateWorkflowStatus: updateWorkflowStatus, form: form, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tS } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account"
    });
    const { t: tA } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts);
    const { register: register, watch: watch, setValue: setValue, trigger: trigger } = form;
    const { errors: errors, isValid: isValid } = (0, $18522b4fc47f45cb$export$606f11b2eb45ecc6)({
        control: form.control,
        name: [
            "connectedDepositMode",
            "connectedDepositAccounts"
        ]
    });
    const connectedDepositMode = watch("connectedDepositMode");
    const connectedDepositAccountsSelection = watch("connectedDepositAccounts") || [];
    (0, $7fPBF.useEffect)(()=>{
        register("connectedDepositAccounts");
    }, [
        register
    ]);
    (0, $7fPBF.useEffect)(()=>{
        updateWorkflowStatus(index, isValid);
    }, [
        isValid
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext,
        trigger,
        setSignalNext
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (connectedDepositMode !== "existingAccount") {
            setValue("connectedDepositAccounts", [], {
                shouldDirty: false
            });
            return;
        }
        if (!connectedDepositAccountsSelection.length && selectDepositAccounts.length) setValue("connectedDepositAccounts", [
            selectDepositAccounts[0].id
        ], {
            shouldDirty: true
        });
    }, [
        connectedDepositMode,
        connectedDepositAccountsSelection,
        selectDepositAccounts,
        setValue
    ]);
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "pt-4 sm:pt-0 grid sm:grid-cols-2 gap-4 sm:gap-x-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:col-span-2 mb-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tA("common.connectedAccounts.title")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 pb-4 text-sm text-gray-500",
                        children: tA("common.connectedAccounts.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                className: "xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900",
                children: tA("common.connectedAccounts.whenIBuy", {
                    categorySingle: tS("product"),
                    buyOrSellText: tA("pension.wizardSteps.connectedAccount.buyOrSellText")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                        id: "existingAccount",
                        name: "existingAccount",
                        type: "radio",
                        value: "existingAccount",
                        className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                    }, register("connectedDepositMode", {
                        required: {
                            value: true,
                            message: tS("connectedDepositMode.error")
                        }
                    }))),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "existingAccount",
                        className: "ml-3 block text-sm font-medium text-gray-700",
                        children: tA("common.connectedAccounts.existingAccount")
                    })
                ]
            }),
            connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "xl:flex xl:items-center w-full sm:max-w-md",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
                            value: connectedDepositAccountsSelection,
                            onChange: (values)=>setValue("connectedDepositAccounts", values, {
                                    shouldDirty: true,
                                    shouldValidate: true
                                }),
                            multiple: true,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                                        className: "relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-brandBlue-400 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 sm:text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "block truncate text-gray-700",
                                                children: connectedDepositAccountsSelection.length ? connectedDepositAccountsSelection.map((id)=>{
                                                    var _selectDepositAccounts_find;
                                                    return (_selectDepositAccounts_find = selectDepositAccounts.find((account)=>account.id === id)) === null || _selectDepositAccounts_find === void 0 ? void 0 : _selectDepositAccounts_find.name;
                                                }).filter(Boolean).join(", ") : tA("common.connectedAccounts.existingAccountSelect")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1205e1ea1e824e93$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5 text-gray-400",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                        as: (0, $7fPBF.Fragment),
                                        leave: "transition ease-in duration-100",
                                        leaveFrom: "opacity-100",
                                        leaveTo: "opacity-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                                            className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                            children: selectDepositAccounts.map((account)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                                    className: ({ active: active })=>$e629de6f734a4d7a$export$ce4ab0c55987d1ff(active ? "bg-brandBlue-500 text-white" : "text-gray-900", "relative cursor-default select-none py-2 pl-3 pr-9"),
                                                    value: account.id,
                                                    children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: $e629de6f734a4d7a$export$ce4ab0c55987d1ff(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                                    children: account.name
                                                                }),
                                                                selected ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: $e629de6f734a4d7a$export$ce4ab0c55987d1ff(active ? "text-white" : "text-brandBlue-500", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $019bed45533ced54$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                }) : null
                                                            ]
                                                        })
                                                }, account.id))
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-1 text-xs text-gray-500",
                            children: tA("common.connectedAccounts.existingAccountSelect")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-center col-start-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                        id: "createAccountLater",
                        name: "createAccountLater",
                        type: "radio",
                        value: "createAccountLater",
                        className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                    }, register("connectedDepositMode", {
                        required: {
                            value: true,
                            message: tS("connectedDepositMode.error")
                        }
                    }))),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "createAccountLater",
                        className: "ml-3 block text-sm font-medium text-gray-700",
                        children: tA("common.connectedAccounts.createAccountLater")
                    })
                ]
            }),
            connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex gap-2 text-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 text-brandBlue-500 self-start",
                        "aria-hidden": "true"
                    }),
                    tA("common.connectedAccounts.createAccountLaterDescription", {
                        categorySingle: tS("product")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "col-start-1 mt-2 text-sm text-red-500",
                id: "connectedDepositMode-error",
                children: errors.connectedDepositMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: errors.connectedDepositMode.message
                })
            })
        ]
    });
}
$e629de6f734a4d7a$var$ConnectedAccount.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$e629de6f734a4d7a$var$ConnectedAccount.defaultProps = {
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $e629de6f734a4d7a$export$2e2bcd8739ae039 = $e629de6f734a4d7a$var$ConnectedAccount;




/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");









(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $699f617a607a6b0b$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $699f617a607a6b0b$var$Header({ text: text }) {
    $699f617a607a6b0b$var$Header.propTypes = {
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "objectsOfValue"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
        className: "xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900",
        children: tI(text)
    });
}
function $699f617a607a6b0b$var$ObjectsOfValueAccountData({ index: index, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.objectsOfValue.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "objectsOfValue"
    });
    const [fxRate, setFxRate] = (0, $7fPBF.useState)(null);
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    //--------------------------------------------------------------------------------
    // default values for the form state (userInput + some tweaks)
    //--------------------------------------------------------------------------------
    const defaultValues = (0, $9tqwB._)({}, userInput && (0, $9tqwB._)({}, userInput.data));
    defaultValues.currency = defaultValues.currency === undefined ? baseCurrency : defaultValues.currency;
    defaultValues.quantity = defaultValues.quantity === undefined ? 1 : defaultValues.quantity;
    // register the hook
    const { register: register, watch: watch, reset: reset, getValues: getValues, control: control, formState: formState, setValue: setValue, trigger: trigger } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: defaultValues
    });
    const { errors: errors, isValid: isValid, isDirty: isDirty, dirtyFields: dirtyFields } = formState;
    const accountCurrency = watch("currency");
    const isBaseCurrencySameAsAccountCurrency = accountCurrency === baseCurrency;
    //--------------------------------------------------------------------------------
    // synchronise this component's form with the parent component's form state
    //--------------------------------------------------------------------------------
    function processOutputData(formValues) {
        const obj = (0, $9tqwB._)({}, formValues);
        // housekeeping: convert dates to epoch
        obj.userInputPurchaseDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formValues.userInputPurchaseDate).valueOf();
        // housekeeping: convert string-numbers to numbers
        obj.userInputPurchaseValueAccountCurrency = Number(formValues.userInputPurchaseValueAccountCurrency);
        obj.userInputPurchaseValueBaseCurrency = accountCurrency === baseCurrency ? Number(formValues.userInputPurchaseValueAccountCurrency) : formValues.userInputPurchaseValueAccountCurrency || null;
        obj.quantity = Number(formValues.quantity);
        // handle connectedDepositIds
        if (obj.connectedDepositMode === "existingAccount") {
            const connectedObject = obj.connectedDepositAccountsObject || {
                id: null,
                name: null
            }; // before the user picks the answer here
            obj.connectedDepositAccounts = [
                connectedObject.id
            ];
        } else obj.connectedDepositAccounts = [];
        return obj;
    }
    (0, $7fPBF.useEffect)(()=>{
        // check if all validations are passed and if so, set component status to true
        if (isDirty && isValid) {
            const output = getValues();
            // console.log('isDirty and isValid both true, getValues:', JSON.stringify(output, null, 2));
            // transform the output data before sending them to caller
            const processedOutput = processOutputData(output);
            // console.log('processed output', processedOutput);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            updateWorkflowStatus(index, true);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepIsValid: true
            });
        }
        // check if the user invalidated the form and if so, remove the next step
        if (isDirty && !isValid) {
            const output = getValues();
            // console.log('isDirty is true and isValid is not, getValues:', JSON.stringify(output, null, 2));
            // CAVEAT: this approach means that the previously entered data is still potentially within the form
            const processedOutput = processOutputData(output);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            // console.log('processed output', processedOutput);
            updateWorkflowStatus(index, false);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepErrors: true
            });
        }
    }, [
        formState
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    const connectedDepositMode = watch("connectedDepositMode");
    //-------------------------------------------------------------------------------------------------------
    // if accountCurrency !== baseCurrency, display userInputPurchaseDate fx rate for the user's convenience
    //-------------------------------------------------------------------------------------------------------
    // when user selects a non-base-currency for the transaction, get the fx rate in the background and display it
    // when updating this code, remember to change the same code in InflowOutflowTransfer.jsx
    const userInputPurchaseDate = watch("userInputPurchaseDate");
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (!isBaseCurrencySameAsAccountCurrency && userInputPurchaseDate) {
                setFxRate("loading");
                let newRate;
                try {
                    newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, accountCurrency, baseCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(userInputPurchaseDate).startOf("day").valueOf());
                    setFxRate(newRate);
                } catch (err) {
                    setFxRate(null);
                }
            }
        }
        updateFxRate();
    }, [
        accountCurrency,
        userInputPurchaseDate
    ]);
    // handle the "apply fx rate" button
    function handleFxRateButton() {
        // get a list of dirtyFields and filter them to only leave fieldNames which have payoutAll or payoutOnly and which end in Quote
        // if that list is not empty, apply the fxRate to those fields
        const fieldQuote = getValues("userInputPurchaseValueAccountCurrency");
        if (fieldQuote) setValue("userInputPurchaseValueBaseCurrency", Number((fxRate * fieldQuote).toFixed(2)), {
            shouldValidate: true
        });
    }
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("accountInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: tI("provideInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-8 text-sm text-gray-500 font-bold",
                        children: tI("whyDoWeAsk")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: tI("whyDoWeAskAnswer")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "md:col-span-3 ",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "name",
                                    category: "objectsOfValue",
                                    type: "text",
                                    placeholder: tL("name.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("name.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                                    id: "currency",
                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                    label: tL("currency.label"),
                                    placeholder: tL("currency.placeholder"),
                                    toolTip: tL("currency.tooltip"),
                                    register: register,
                                    optional: false,
                                    errors: errors,
                                    control: control,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("currency.error")
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "userInputPurchaseDate",
                                    category: "objectsOfValue",
                                    type: "date",
                                    label: tL("userInputPurchaseDate.label"),
                                    optional: false,
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("userInputPurchaseDate.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "quantity",
                                    category: "objectsOfValue",
                                    type: "string",
                                    label: tL("quantity.label"),
                                    placeholder: 1,
                                    optional: false,
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("quantity.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "userInputPurchaseValueAccountCurrency",
                                    category: "objectsOfValue",
                                    type: "text",
                                    label: tL("userInputPurchaseValueAccountCurrency.label", {
                                        currency: accountCurrency
                                    }),
                                    formatting: "col-start-1",
                                    placeholder: 38000,
                                    optional: false,
                                    autoComplete: "off",
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("userInputPurchaseValueAccountCurrency.error")
                                        }
                                    }
                                }),
                                !isBaseCurrencySameAsAccountCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                            id: "userInputPurchaseValueBaseCurrency",
                                            category: "objectsOfValue",
                                            type: "text",
                                            label: tL("userInputPurchaseValueBaseCurrency.label", {
                                                currency: baseCurrency
                                            }),
                                            placeholder: 38000,
                                            optional: false,
                                            autoComplete: "off",
                                            register: register,
                                            errors: errors
                                        }),
                                        Number.isFinite(fxRate) && fxRate !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "text-sm mt-2 leading-snug flex flex-col text-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                            htmlFor: "switch-button",
                                                            className: "font-medium",
                                                            children: `${tL("fxRate.label", {
                                                                accountCurrency: accountCurrency,
                                                                baseCurrency: baseCurrency,
                                                                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(userInputPurchaseDate).format("DD.MM.YYYY")
                                                            })} ${fxRate.toFixed(4)}`
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                            info: tL("fxRate.tooltip", {
                                                                baseCurrency: baseCurrency
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "flex items-center w-full mt-1",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "flex gap-2 items-center w-full",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            type: "button",
                                                            // eslint-disable-next-line max-len
                                                            className: "rounded-md w-full px-4 py-2 text-sm font-bold shadow-sm border border-gray-300 bg-white text-gray-900 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500",
                                                            onClick: handleFxRateButton,
                                                            children: tL("fxRate.apply", {
                                                                baseCurrency: baseCurrency
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($699f617a607a6b0b$var$Header, {
                                        text: "whenIBuy"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "existingAccount",
                                                name: "existingAccount",
                                                type: "radio",
                                                value: "existingAccount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "existingAccount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("existingAccount")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:flex xl:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "connectedDepositAccountObject",
                                                className: "flex text-sm font-medium text-gray-700",
                                                children: tI("existingAccountSelect")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1 ml-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                    id: "connectedDepositAccountObject",
                                                    name: "connectedDepositAccountObject",
                                                    className: "text-gray-500 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                                }, register("connectedDepositAccountObject")), {
                                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: a.id,
                                                            children: a.name
                                                        }, a.id))
                                                }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "createAccountLater",
                                                name: "createAccountLater",
                                                type: "radio",
                                                value: "createAccountLater",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "createAccountLater",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("createAccountLater")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 text-brandBlue-500 self-start",
                                                "aria-hidden": "true"
                                            }),
                                            tI("createAccountLaterDescription")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "col-start-1 mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: formState.errors.connectedDepositMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.connectedDepositMode.message
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$699f617a607a6b0b$var$ObjectsOfValueAccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$699f617a607a6b0b$var$ObjectsOfValueAccountData.defaultProps = {
    userInput: {},
    setUserInput: {},
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $699f617a607a6b0b$export$2e2bcd8739ae039 = $699f617a607a6b0b$var$ObjectsOfValueAccountData;


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $92fa613ade6d7ae9$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $92fa613ade6d7ae9$var$Header({ text: text }) {
    $92fa613ade6d7ae9$var$Header.propTypes = {
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "metals"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
        className: "xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900",
        children: tI(text)
    });
}
function $92fa613ade6d7ae9$var$MetalsAccountData({ index: index, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.metals.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "metals"
    });
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    //--------------------------------------------------------------------------------
    // default values for the form state (userInput + some tweaks)
    //--------------------------------------------------------------------------------
    const defaultValues = (0, $9tqwB._)({}, userInput && (0, $9tqwB._)({}, userInput.data));
    defaultValues.currency = defaultValues.currency === undefined ? baseCurrency : defaultValues.currency;
    defaultValues.tags = {
        spread: 10
    }; // default set here, user may change that in account settings later on, but not in this form (too complex)
    // register the hook
    const { register: register, watch: watch, reset: reset, getValues: getValues, control: control, formState: formState, setValue: setValue, trigger: trigger } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: defaultValues
    });
    const { errors: errors, isValid: isValid, isDirty: isDirty, dirtyFields: dirtyFields } = formState;
    //--------------------------------------------------------------------------------
    // synchronise this component's form with the parent component's form state
    //--------------------------------------------------------------------------------
    function processOutputData(formValues) {
        const obj = (0, $9tqwB._)({}, formValues);
        // housekeeping: convert string-numbers to numbers
        obj.quantity = Number(formValues.quantity);
        // handle connectedDepositIds
        if (obj.connectedDepositMode === "existingAccount") {
            const connectedObject = obj.connectedDepositAccountsObject || {
                id: null,
                name: null
            }; // before the user picks the answer here
            obj.connectedDepositAccounts = [
                connectedObject.id
            ];
        } else obj.connectedDepositAccounts = [];
        return obj;
    }
    (0, $7fPBF.useEffect)(()=>{
        // check if all validations are passed and if so, set component status to true
        if (isDirty && isValid) {
            const output = getValues();
            // console.log('isDirty and isValid both true, getValues:', JSON.stringify(output, null, 2));
            // transform the output data before sending them to caller
            const processedOutput = processOutputData(output);
            // console.log('processed output', processedOutput);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            updateWorkflowStatus(index, true);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepIsValid: true
            });
        }
        // check if the user invalidated the form and if so, remove the next step
        if (isDirty && !isValid) {
            const output = getValues();
            // console.log('isDirty is true and isValid is not, getValues:', JSON.stringify(output, null, 2));
            // CAVEAT: this approach means that the previously entered data is still potentially within the form
            const processedOutput = processOutputData(output);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            // console.log('processed output', processedOutput);
            updateWorkflowStatus(index, false);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepErrors: true
            });
        }
    }, [
        formState
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    const connectedDepositMode = watch("connectedDepositMode");
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("accountInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: tI("provideInfo")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "md:col-span-3 ",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "name",
                                    label: tL("name.label"),
                                    category: "metals",
                                    type: "text",
                                    placeholder: tL("name.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("name.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                                    id: "currency",
                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                    label: tL("currency.label"),
                                    placeholder: tL("currency.placeholder"),
                                    toolTip: tL("currency.tooltip"),
                                    register: register,
                                    optional: false,
                                    errors: errors,
                                    control: control,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("currency.error")
                                        }
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($92fa613ade6d7ae9$var$Header, {
                                        text: "whenIBuy"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "existingAccount",
                                                name: "existingAccount",
                                                type: "radio",
                                                value: "existingAccount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "existingAccount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("existingAccount")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:flex xl:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "connectedDepositAccountObject",
                                                className: "flex text-sm font-medium text-gray-700",
                                                children: tI("existingAccountSelect")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1 ml-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                    id: "connectedDepositAccountObject",
                                                    name: "connectedDepositAccountObject",
                                                    className: "text-gray-500 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                                }, register("connectedDepositAccountObject")), {
                                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: a.id,
                                                            children: a.name
                                                        }, a.id))
                                                }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "createAccountLater",
                                                name: "createAccountLater",
                                                type: "radio",
                                                value: "createAccountLater",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "createAccountLater",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("createAccountLater")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 text-brandBlue-500 self-start",
                                                "aria-hidden": "true"
                                            }),
                                            tI("createAccountLaterDescription")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "col-start-1 mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: formState.errors.connectedDepositMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.connectedDepositMode.message
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$92fa613ade6d7ae9$var$MetalsAccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$92fa613ade6d7ae9$var$MetalsAccountData.defaultProps = {
    userInput: {},
    setUserInput: {},
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $92fa613ade6d7ae9$export$2e2bcd8739ae039 = $92fa613ade6d7ae9$var$MetalsAccountData;


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");











(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $4c814cde55bca358$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $4c814cde55bca358$var$Header({ text: text }) {
    $4c814cde55bca358$var$Header.propTypes = {
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "unlistedShares"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
        className: "xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900",
        children: tI(text)
    });
}
function $4c814cde55bca358$var$UnlistedSharesAccountData({ index: index, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.unlistedShares.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "unlistedShares"
    });
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const [fxRate, setFxRate] = (0, $7fPBF.useState)(null); // holds the fx rate for the base currency if the two currencies are not the same
    //--------------------------------------------------------------------------------
    // default values for the form state (userInput + some tweaks)
    //--------------------------------------------------------------------------------
    const defaultValues = (0, $9tqwB._)({}, userInput && (0, $9tqwB._)({}, userInput.data));
    defaultValues.currency = defaultValues.currency === undefined ? baseCurrency : defaultValues.currency;
    const { register: register, watch: watch, reset: reset, getValues: getValues, control: control, formState: formState, setValue: setValue, trigger: trigger } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: defaultValues
    });
    const { errors: errors, isValid: isValid, isDirty: isDirty, dirtyFields: dirtyFields } = formState;
    const connectedDepositMode = watch("connectedDepositMode");
    const currency = watch("currency");
    const upac = watch("upac");
    const date = watch("date");
    //--------------------------------------------------------------------------------
    // synchronise this component's form with the parent component's form state
    //--------------------------------------------------------------------------------
    function processOutputData(formValues) {
        const obj = (0, $9tqwB._)({}, formValues);
        // housekeeping: convert string-numbers to numbers
        obj.quantity = Number(formValues.quantity);
        if (baseCurrency === currency) obj.upbc = obj.upac; // otherwise there will be a upbc field in the form
        // handle connectedDepositIds
        if (obj.connectedDepositMode === "existingAccount") {
            const connectedObject = obj.connectedDepositAccountsObject || {
                id: null,
                name: null
            }; // before the user picks the answer here
            obj.connectedDepositAccounts = [
                connectedObject.id
            ];
        } else if (obj.connectedDepositMode === "createAccountLater") obj.connectedDepositAccounts = [];
        return obj;
    }
    console.log("component is rendering");
    (0, $7fPBF.useEffect)(()=>{
        console.log("component mounted or updated");
        return ()=>{
            console.log("component unmounted");
        };
    }, []);
    const watchAll = watch(); // see useEffect below
    const prevRenderWatchAll = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null); // see useEffect below
    (0, $7fPBF.useEffect)(()=>{
        // compare current watchAll to its previous version -- only run when something really changes
        // TODO this is a hack, but the problem is that every change of the form seems to trigger a rerender of the component which triggers this useEffect, creating a circular dependency
        // TODO ideally we would try to eliminate the circular dependency whatsoever
        if ((0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports)))(watchAll, prevRenderWatchAll.current)) return;
        prevRenderWatchAll.current = watchAll;
        // check if all validations are passed and if so, set component status to true
        if (isDirty) {
            const output = getValues();
            // transform the output data before sending them to caller
            const processedOutput = processOutputData(output);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
        // we do not check isValid in the same useEffect because it is not updated yet (it is updated after the useEffect, because it is async)
        // so we do it in a separate useEffect, which reacts to isValid only
        }
    }, [
        watchAll
    ]);
    // react to changes in isValid
    (0, $7fPBF.useEffect)(()=>{
        if (isValid) updateWorkflowStatus(index, true);
    }, [
        isValid
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    //---------------------------------------------------------------------------------------------
    // get fx rate for base currency when it is different than account currency
    //---------------------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            setFxRate("loading");
            let newRate;
            try {
                newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(upac, currency, baseCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(date).startOf("day").valueOf());
                newRate = newRate.toFixed(2); // Round to 2 decimal digits
                setFxRate(newRate);
            } catch (err) {
                console.error("UnlistedSharesAccountData > updateFxRate > error:", err);
                setFxRate(null);
            }
        }
        // only run when there is upac and date already
        if (upac && date) updateFxRate();
    }, [
        currency,
        upac
    ]);
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("accountInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: tI("provideInfo")
                    }),
                    String(isValid)
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "md:col-span-3 ",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "name",
                                    label: tL("name.label"),
                                    category: "unlistedShares",
                                    type: "text",
                                    placeholder: tL("name.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("name.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0b5c76682cc743c6$export$2e2bcd8739ae039), {
                                    id: "currency",
                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                    label: tL("currency.label"),
                                    placeholder: tL("currency.placeholder"),
                                    toolTip: tL("currency.tooltip"),
                                    register: register,
                                    optional: false,
                                    errors: errors,
                                    control: control,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("currency.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "date",
                                    label: tL("date.label"),
                                    category: "unlistedShares",
                                    type: "date",
                                    placeholder: tL("date.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("date.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    formatting: "col-start-1",
                                    id: "quantity",
                                    label: tL("quantity.label"),
                                    category: "unlistedShares",
                                    type: "number",
                                    placeholder: tL("quantity.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("quantity.error")
                                        },
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message: tL("quantity.error")
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "upac",
                                    label: tL("upac.label"),
                                    category: "unlistedShares",
                                    type: "number",
                                    placeholder: tL("upac.placeholder"),
                                    autoComplete: "off",
                                    optional: false,
                                    register: register,
                                    errors: errors,
                                    validationRules: {
                                        required: {
                                            value: true,
                                            message: tL("upac.error")
                                        }
                                    }
                                }),
                                baseCurrency !== currency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                            id: "upbc",
                                            label: tL("upbc.label"),
                                            category: "unlistedShares",
                                            type: "number",
                                            placeholder: tL("upbc.placeholder"),
                                            autoComplete: "off",
                                            optional: false,
                                            register: register,
                                            errors: errors,
                                            validationRules: {
                                                required: {
                                                    value: true,
                                                    message: tL("upbc.error")
                                                }
                                            }
                                        }),
                                        fxRate === "loading" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        fxRate !== "loading" && fxRate !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "flex space-x-1 items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-sm",
                                                    children: tI("fxRate", {
                                                        fxRate: Number(fxRate).toLocaleString("de", {
                                                            style: "currency",
                                                            currency: currency
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                    text: tI("apply"),
                                                    noFrameNoArrow: true,
                                                    onClick: ()=>setValue("upbc", fxRate),
                                                    formatting: "self-end justify-self-start"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4c814cde55bca358$var$Header, {
                                        text: "whenIBuy"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "existingAccount",
                                                name: "existingAccount",
                                                type: "radio",
                                                value: "existingAccount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "existingAccount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("existingAccount")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:flex xl:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "connectedDepositAccountObject",
                                                className: "flex text-sm font-medium text-gray-700",
                                                children: tI("existingAccountSelect")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1 ml-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                    id: "connectedDepositAccountObject",
                                                    name: "connectedDepositAccountObject",
                                                    className: "text-gray-500 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                                }, register("connectedDepositAccountObject")), {
                                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: a.id,
                                                            children: a.name
                                                        }, a.id))
                                                }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "createAccountLater",
                                                name: "createAccountLater",
                                                type: "radio",
                                                value: "createAccountLater",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "createAccountLater",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("createAccountLater")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                className: "h-6 w-6 text-brandBlue-500 self-start",
                                                "aria-hidden": "true"
                                            }),
                                            tI("createAccountLaterDescription")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "col-start-1 mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: formState.errors.connectedDepositMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.connectedDepositMode.message
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$4c814cde55bca358$var$UnlistedSharesAccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$4c814cde55bca358$var$UnlistedSharesAccountData.defaultProps = {
    userInput: {},
    setUserInput: {},
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $4c814cde55bca358$export$2e2bcd8739ae039 = $4c814cde55bca358$var$UnlistedSharesAccountData;


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/require-default-props */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $2oXYc = parcelRequire("2oXYc");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $c90f61ccf4f69c8b$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $c90f61ccf4f69c8b$var$Header({ text: text }) {
    $c90f61ccf4f69c8b$var$Header.propTypes = {
        text: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "crypto"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
        className: "xs:col-span-2 lg:col-span-3 text-base font-bold text-gray-900",
        children: tI(text)
    });
}
function $c90f61ccf4f69c8b$var$CryptoAccountData({ index: index, updateWorkflowStatus: updateWorkflowStatus, userInput: userInput, setUserInput: setUserInput, signalNext: signalNext, setSignalNext: setSignalNext }) {
    const { t: tL } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.crypto.account"
    });
    const { t: tI } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount", {
        keyPrefix: "crypto"
    });
    const selectDepositAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    //--------------------------------------------------------------------------------
    // default values for the form state (userInput + some tweaks)
    //--------------------------------------------------------------------------------
    const defaultValues = (0, $9tqwB._)({}, userInput && (0, $9tqwB._)({}, userInput.data));
    defaultValues.currency = defaultValues.currency === undefined ? baseCurrency : defaultValues.currency;
    defaultValues.tags = {
        spread: 10
    }; // default set here, user may change that in account settings later on, but not in this form (too complex)
    // register the hook
    const { register: register, watch: watch, reset: reset, getValues: getValues, control: control, formState: formState, trigger: trigger } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        defaultValues: defaultValues
    });
    const { errors: errors, isValid: isValid, isDirty: isDirty } = formState;
    //--------------------------------------------------------------------------------
    // synchronise this component's form with the parent component's form state
    //--------------------------------------------------------------------------------
    function processOutputData(formValues) {
        const obj = (0, $9tqwB._)({}, formValues);
        // housekeeping: convert string-numbers to numbers
        obj.quantity = Number(formValues.quantity);
        // handle connectedDepositIds
        if (obj.connectedDepositMode === "existingAccount") {
            const connectedObject = obj.connectedDepositAccountsObject || {
                id: null,
                name: null
            }; // before the user picks the answer here
            obj.connectedDepositAccounts = [
                connectedObject.id
            ];
        } else if (obj.connectedDepositMode === "createTechnicalAccount") ;
        else obj.connectedDepositAccounts = [];
        return obj;
    }
    (0, $7fPBF.useEffect)(()=>{
        // check if all validations are passed and if so, set component status to true
        if (isDirty && isValid) {
            const output = getValues();
            // console.log('isDirty and isValid both true, getValues:', JSON.stringify(output, null, 2));
            // transform the output data before sending them to caller
            const processedOutput = processOutputData(output);
            // console.log('processed output', processedOutput);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            updateWorkflowStatus(index, true);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepIsValid: true
            });
        }
        // check if the user invalidated the form and if so, remove the next step
        if (isDirty && !isValid) {
            const output = getValues();
            // console.log('isDirty is true and isValid is not, getValues:', JSON.stringify(output, null, 2));
            // CAVEAT: this approach means that the previously entered data is still potentially within the form
            const processedOutput = processOutputData(output);
            setUserInput((0, $9tqwB._)({}, userInput, processedOutput));
            // console.log('processed output', processedOutput);
            updateWorkflowStatus(index, false);
            // reset isDirty status so that we know if the user touched the form again
            reset((0, $9tqwB._)({}, userInput, output), {
                keepErrors: true
            });
        }
    }, [
        formState
    ]);
    //--------------------------------------------------------------------------------
    // subscribe to signal from parent that the user has clicked the "next" button
    // (and then trigger all validations to show errors)
    //--------------------------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (signalNext) {
            trigger();
            setSignalNext(false);
        }
    }, [
        signalNext
    ]);
    const connectedDepositMode = watch("connectedDepositMode");
    //---------------------------------------------------------------------------------------------
    // render the form
    //---------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-6 md:space-y-0 md:grid md:grid-cols-4 md:gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "md:col-span-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-xl md:text-2xl font-bold leading-6 text-gray-900",
                        children: tI("accountInfo")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-4 text-sm text-gray-500",
                        children: tI("provideInfo")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "md:col-span-3 ",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "divide-y divide-gray-200",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                id: "name",
                                label: tL("name.label"),
                                category: "crypto",
                                type: "text",
                                placeholder: tL("name.placeholder"),
                                autoComplete: "off",
                                optional: false,
                                register: register,
                                errors: errors,
                                validationRules: {
                                    required: {
                                        value: true,
                                        message: tL("name.error")
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "py-3 lg:pb-4 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "brokerName",
                                    label: tL("brokerName.label"),
                                    category: "crypto",
                                    type: "text",
                                    placeholder: tL("brokerName.placeholder"),
                                    autoComplete: "off",
                                    optional: true,
                                    register: register,
                                    errors: errors
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                    id: "accountNo",
                                    label: tL("accountNo.label"),
                                    category: "crypto",
                                    type: "text",
                                    placeholder: tL("accountNo.placeholder"),
                                    autoComplete: "off",
                                    optional: true,
                                    register: register,
                                    errors: errors
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "py-3 lg:py-8 grid xs:grid-cols-2 lg:grid-cols-3 gap-4 xs:gap-6 lg:gap-8",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                className: "md:col-span-2 xl:col-span-3 grid md:grid-cols-2 xl:grid-cols-3 justify-items-start items-center gap-4 text-sm text-gray-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($c90f61ccf4f69c8b$var$Header, {
                                        text: "whenIBuy"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "existingAccount",
                                                name: "existingAccount",
                                                type: "radio",
                                                value: "existingAccount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "existingAccount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("existingAccount")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "existingAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:flex xl:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "connectedDepositAccountObject",
                                                className: "flex text-sm font-medium text-gray-700",
                                                children: tI("existingAccountSelect")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1 ml-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                    id: "connectedDepositAccountObject",
                                                    name: "connectedDepositAccountObject",
                                                    className: "text-gray-500 shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md"
                                                }, register("connectedDepositAccountObject")), {
                                                    children: selectDepositAccounts.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: a.id,
                                                            children: a.name
                                                        }, a.id))
                                                }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "createTechnicalAccount",
                                                name: "createTechnicalAccount",
                                                type: "radio",
                                                value: "createTechnicalAccount",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "createTechnicalAccount",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("createTechnicalAccount")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "createTechnicalAccount" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:flex xl:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                htmlFor: "currency",
                                                className: "flex text-sm text-gray-700",
                                                children: [
                                                    tI("createTechnicalAccountCurrency"),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                        info: tI("createTechnicalAccountTooltip"),
                                                        formatting: "ml-1"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1 xl:mt-0 xl:ml-2",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", (0, $2qxEV._)((0, $9tqwB._)({
                                                    id: "currency",
                                                    name: "currency",
                                                    className: "shadow-sm focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full text-sm border-gray-300 rounded-md min-w-[5.25rem]"
                                                }, register("currency")), {
                                                    children: (0, $796ea4636350e237$export$a01df35ce0858603).map((c)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            children: c
                                                        }, c))
                                                }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center col-start-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "createAccountLater",
                                                name: "createAccountLater",
                                                type: "radio",
                                                value: "createAccountLater",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("connectedDepositMode", {
                                                required: {
                                                    value: true,
                                                    message: tL("connectedDepositMode.error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "createAccountLater",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: tI("createAccountLater")
                                            })
                                        ]
                                    }),
                                    connectedDepositMode === "createAccountLater" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                className: "h-10 w-10 text-brandBlue-500",
                                                "aria-hidden": "true"
                                            }),
                                            tI("createAccountLaterDescription")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "col-start-1 mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: formState.errors.connectedDepositMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.connectedDepositMode.message
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$c90f61ccf4f69c8b$var$CryptoAccountData.propTypes = {
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    updateWorkflowStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setUserInput: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    signalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setSignalNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$c90f61ccf4f69c8b$var$CryptoAccountData.defaultProps = {
    userInput: {},
    setUserInput: {},
    signalNext: undefined,
    setSignalNext: ()=>{}
};
var $c90f61ccf4f69c8b$export$2e2bcd8739ae039 = $c90f61ccf4f69c8b$var$CryptoAccountData;


const $325eda4246b652c5$var$debugLevel = 0;
function $325eda4246b652c5$export$2e2bcd8739ae039({ category: category, addModeState: addModeState, setAddModeState: setAddModeState, addAccountState: addAccountState }) {
    const myRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        myRef.current.scrollIntoView({
            behavior: "instant"
        });
    }, []);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    const [userInput, setUserInput] = (0, $7fPBF.useState)((addAccountState === null || addAccountState === void 0 ? void 0 : addAccountState.userInput) || {}); // being assembled during the workflow from the inputs of different child components
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // true when the user has submitted the form and we are waiting for the backend to respond
    const [displayedStep, setDisplayedStep] = (0, $7fPBF.useState)((addAccountState === null || addAccountState === void 0 ? void 0 : addAccountState.displayedStep) || 0); // the index of the component that is currently displayed
    const [messageToShowBeforeNext, setMessageToShowBeforeNext] = (0, $7fPBF.useState)(null); // if this is not null, show the message in a popup before moving to the next step
    const [signalNext, setSignalNext] = (0, $7fPBF.useState)(false); // passes the event of user clicking NEXT in NAV COMPONENT to the current component
    //------------------------------------------------------------
    // DEFINE ALL WORKFLOWS
    //------------------------------------------------------------
    const workflows = {
        deposits: [
            (0, $b799bd13ee74234e$export$2e2bcd8739ae039),
            (0, $a01d16f39a7b54eb$export$2e2bcd8739ae039),
            (0, $e3c8313e93d4b2c4$export$2e2bcd8739ae039)
        ],
        stocks: [
            (0, $b799bd13ee74234e$export$2e2bcd8739ae039),
            (0, $a01d16f39a7b54eb$export$2e2bcd8739ae039),
            (0, $e3c8313e93d4b2c4$export$2e2bcd8739ae039)
        ],
        realEstate: [
            (0, $96a84f48caa04ee8$export$2e2bcd8739ae039)
        ],
        loans: [
            (0, $b799bd13ee74234e$export$2e2bcd8739ae039),
            (0, $a01d16f39a7b54eb$export$2e2bcd8739ae039),
            (0, $e3c8313e93d4b2c4$export$2e2bcd8739ae039)
        ],
        pension: [
            (0, $ba9fac31fb6dba98$export$2e2bcd8739ae039),
            (0, $8fd61e1b0b5b5e2b$export$2e2bcd8739ae039),
            (0, $b264a431fde9d7cd$export$2e2bcd8739ae039),
            (0, $dfc72607c0375076$export$2e2bcd8739ae039),
            (0, $857eb878fd7bb7d9$export$2e2bcd8739ae039),
            (0, $e629de6f734a4d7a$export$2e2bcd8739ae039)
        ],
        objectsOfValue: [
            (0, $699f617a607a6b0b$export$2e2bcd8739ae039)
        ],
        metals: [
            (0, $92fa613ade6d7ae9$export$2e2bcd8739ae039)
        ],
        unlistedShares: [
            (0, $4c814cde55bca358$export$2e2bcd8739ae039)
        ],
        crypto: [
            (0, $c90f61ccf4f69c8b$export$2e2bcd8739ae039)
        ]
    };
    const currentWorkflow = workflows[category]; // an array that holds the components constituting the workflow in the proper sequence
    //------------------------------------------------------------
    // SET UP THIS WORKFLOW'S STATE
    //------------------------------------------------------------
    // set "workflowStepStatus" to an array of the same amount of items as the workflow calculated in the "workflows" object
    const [workflowStepStatus, setWorkflowStepStatus] = (0, $7fPBF.useState)((addAccountState === null || addAccountState === void 0 ? void 0 : addAccountState.workflowStepStatus) || [
        ...Array(currentWorkflow.length)
    ]);
    // update the status of a single step in the workflow to 'status'; this function will be passed to the child components so that they may update this state
    function updateWorkflowStatus(step, status) {
        if ($325eda4246b652c5$var$debugLevel > 2) console.info(`updateWorkflowStatus: step ${step} status ${status}`);
        const newStatus = [
            ...workflowStepStatus
        ];
        newStatus[step] = status;
        setWorkflowStepStatus(newStatus);
    }
    // workflow is ready (and the Submit button is displayed) when all of its steps are ready
    const formReady = workflowStepStatus.every((step)=>step === true);
    if ($325eda4246b652c5$var$debugLevel > 2) console.info("formReady", formReady, workflowStepStatus);
    //------------------------------------------------------------
    // (REAL ESTATE ONLY) CREATE A TRANSACTION
    //------------------------------------------------------------
    async function createRealEstateTransaction(accountId) {
        const dataArray = [
            (0, $3a1ecd75ab1ea382$export$6ee7acc2fdcedc63).validateSync({
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: accountId,
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(userInput.date).startOf("day"),
                category: "realEstate",
                originalPrice: userInput.originalPrice,
                currency: userInput.currency,
                price: null,
                amount: 1,
                transactionType: "purchase",
                importFlag: "post"
            })
        ];
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: dataArray,
                category: "realEstate",
                accountId: accountId
            }));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("addTransactionManually"));
        }
    }
    //------------------------------------------------------------
    // (OBJECTS OF VALUE ONLY) CREATE A TRANSACTION
    //------------------------------------------------------------
    async function createObjectsOfValueTransaction(_userInput, accountId) {
        let dataArray;
        try {
            // dataArray = [objectsOfValueTransaction.validateSync({
            dataArray = [
                (0, $81cfed1660055fbf$export$4c255d423d7ada4d).cast({
                    id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                    accountId: accountId,
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(_userInput.date).startOf("day").valueOf(),
                    category: "objectsOfValue",
                    quantity: _userInput.quantity,
                    transactionType: "purchase",
                    upac: _userInput.userInputPurchaseValueAccountCurrency / _userInput.quantity,
                    upbc: _userInput.userInputPurchaseValueBaseCurrency / _userInput.quantity,
                    uptc: null,
                    transactionCurrency: null,
                    accountCurrency: _userInput.currency,
                    assetCurrency: _userInput.currency,
                    importFlag: "post",
                    description: "Initial"
                })
            ];
        } catch (err) {
            console.error("createObjectsOfValueTransaction: error", err);
            throw err;
        }
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: dataArray,
                category: "objectsOfValue",
                accountId: accountId
            }));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("addTransactionManually"));
        }
    }
    //------------------------------------------------------------
    // (UNLISTED SHARES ONLY) CREATE A TRANSACTION
    //------------------------------------------------------------
    async function createUnlistedSharesTransaction(_userInput, accountId) {
        let dataArray;
        try {
            // dataArray = [objectsOfValueTransaction.validateSync({
            dataArray = [
                (0, $81cfed1660055fbf$export$4c255d423d7ada4d).cast({
                    id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                    accountId: accountId,
                    assetId: accountId,
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(_userInput.date).startOf("day").valueOf(),
                    category: "unlistedShares",
                    quantity: _userInput.quantity,
                    upac: _userInput.upac / _userInput.quantity,
                    upbc: _userInput.upbc / _userInput.quantity,
                    uptc: null,
                    transactionCurrency: null,
                    accountCurrency: _userInput.currency,
                    assetCurrency: _userInput.currency,
                    importFlag: "post",
                    description: "Initial"
                })
            ];
        } catch (err) {
            console.error("createUnlistedSharesTransaction: error", err);
            throw err;
        }
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: dataArray,
                category: "unlistedShares",
                accountId: accountId
            }));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("addTransactionManually"));
        }
    }
    //------------------------------------------------------------
    // HANDLER: CREATE ACCOUNT
    //------------------------------------------------------------
    // if this is a workflow where several accounts can be created at the same time (when several accounts come from provider, like in deposits and stocks)
    // userInput will only have the common information like countryCode and provider, while accountArray will have all the account-specific information
    // _userInput is one of the accounts from accountArray
    async function dispatchUserInput(_userInput, accountData = null) {
        // "flatten" the object (if there are .provider and .accountArray properties, then move everything from there into the root of the object)
        const flattenedUserInput = (0, $9tqwB._)({}, _userInput, _userInput.provider, accountData); // if .provider and .accountData do not exist, they get ignored
        // if there is a provider, put providerName and providerAccountId stuff into the provider tag
        if (_userInput.provider) flattenedUserInput.tags = (0, $2qxEV._)((0, $9tqwB._)({}, flattenedUserInput.tags), {
            provider: {
                [accountData.providerName]: {
                    providerAccountId: accountData.providerAccountId,
                    providerInstitutionId: userInput.provider.providerInstitutionId,
                    providerAccessId: userInput.providerAccessId
                }
            }
        });
        // if there is a connectedDepositMode === 'existingAccount', put the account id into the right field
        // if (accountData && accountData.connectedDepositMode === 'existingAccount') {
        if (flattenedUserInput.connectedDepositMode === "existingAccount") // 240709 unclear why connectedDEspositAccountObject should come from and not from userInput; adding it as a fallback
        // note: this will always be one id, because this is how the form is built
        flattenedUserInput.connectedDepositAccounts = [
            flattenedUserInput.connectedDepositAccountObject
        ];
        // (STOCKS + CRYPTO ONLY) if there is a connectedDepositMode === 'createTechnicalAccount', create a new deposit account
        let newDepositAccountId;
        if (flattenedUserInput.connectedDepositMode === "createTechnicalAccount") {
            newDepositAccountId = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
            // update stock account payload with the new connected deposit account id
            flattenedUserInput.connectedDepositAccounts = [
                newDepositAccountId
            ];
            // create new deposit account payload
            const depositAccount = {
                id: newDepositAccountId,
                name: flattenedUserInput.name,
                bankName: flattenedUserInput.brokerName,
                currency: flattenedUserInput.currency,
                countryCode: flattenedUserInput.countryCode,
                depositType: "savings-account",
                syncType: "manual",
                tags: {}
            };
            const payloadDeposit = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)("deposits", "account").cast(depositAccount);
            dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                data: payloadDeposit,
                category: "deposits"
            })); // async?
        }
        // console.log('flattenedUserInput', flattenedUserInput); // ma miec providerAccountId
        // cast the object to the right schema
        const accountSchema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(category, "account");
        let payload;
        try {
            const validated = accountSchema.validateSync(flattenedUserInput); // this has better error reporting than yup.cast
            // console.log('validated', validated);
            payload = accountSchema.cast(validated, {
                stripUnknown: true
            }); // this will cast all types and remove unregisteter properties
        // console.log('payload', payload);
        } catch (error) {
            console.error("Error casting accountSchema", error);
            console.error("error.inner", error.inner);
            // spell out errors for yup.cast
            if (error.inner) error.inner.forEach((err)=>{
                console.error(`Field: ${err.path}, Error: ${err.message}`);
            });
            throw new Error("Validation error (add account).");
        }
        // post new account
        try {
            const resultDispatch = await dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                data: payload,
                category: category
            }));
            // console.log('DEBUG result', JSON.stringify(resultDispatch, null, 2));
            if (resultDispatch.error) throw new Error("AddAccount > dispatchUserInput: Dispatch postAccount returned an error");
            // if the following fails, consider the account created, but inform user that transaction must be created manually
            try {
                // this can only work if user provided 'name', 'date' and 'originalPrice' in the realEstate form
                if (resultDispatch.meta.requestStatus === "fulfilled") {
                    if (category === "realEstate" && userInput.name && userInput.date && userInput.originalPrice) // the form has fields for the purchase transaction, post it once account has been created
                    await createRealEstateTransaction(resultDispatch.payload.accounts[0].id);
                    if (category === "objectsOfValue") // the form has fields for the purchase transaction, post it once account has been created
                    await createObjectsOfValueTransaction(flattenedUserInput, resultDispatch.payload.accounts[0].id);
                    if (category === "unlistedShares") // the form has fields for the purchase transaction, post it once account has been created
                    await createUnlistedSharesTransaction(flattenedUserInput, resultDispatch.payload.accounts[0].id);
                }
                // if syncType is automatic, then intiate the sync (asynchronously) to retrieve data
                if (payload.syncType && payload.syncType === "automatic") dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
                    category: category,
                    accountId: resultDispatch.payload.accounts[0].id
                }));
            } catch (error) {
                console.error("Error: AddAccount: createTransaction failed", error);
                setLoading(false);
                window.dispatchEvent(new CustomEvent("setAlert", {
                    detail: {
                        id: "addTransactionManually",
                        caller: resultDispatch.id,
                        callbackOk: ()=>{}
                    }
                }));
            }
            return resultDispatch;
        } catch (error) {
            console.error("Error: AddAccount: postAccount failed", error);
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
            throw error;
        }
    }
    // ↓↓ main SUBMIT handler for the AddAccount workflows
    async function handleSubmit(e) {
        // console.info('handleSubmit: start', 'workflowStepStatus', JSON.stringify(workflowStepStatus, null, 2), 'userInput', JSON.stringify(userInput, null, 2));
        // if the last component in the workflow has been validated, the user has finished the workflow
        if (workflowStepStatus.every((item)=>!!item)) {
            // we can now add the account to the database
            setLoading(true);
            // in case there are several accounts in the payload, split them up and post them one by one (in parallel)
            // accountArray is used for provider-based accounts, for one "AddAccount" workflow we may have several accounts
            let promises = [];
            if (userInput.accountArray) {
                // console.info('handleSubmit: accountArray detected.');
                // in this scenario userInput has .accountArray, which has all the account-relevant fields
                // but userInput still has some overall fields, like countryCode, provider, etc.
                // we need to do putAccounts in sequence, otherwise Cognito slots get updated at the same time and only one account gets updated
                // (see PRD-1610)
                // promises = userInput.accountArray
                //   .filter((accountData) => accountData.isImported) // we only are adding those with isImported
                //   .map((accountData) => dispatchUserInput(userInput, accountData));
                const accountsToSubmit = userInput.accountArray.filter((accountData)=>accountData.isImported);
                promises.push((async ()=>{
                    // eslint-disable-next-line no-restricted-syntax
                    for (const a of accountsToSubmit){
                        // eslint-disable-next-line no-await-in-loop
                        const result = await dispatchUserInput(userInput, a);
                    // console.log(new Date().toISOString(), 'DEBUG result', JSON.stringify(result, null, 2));
                    }
                })());
            } else promises = [
                dispatchUserInput(userInput)
            ];
            // if there is userInput.reconcileAccounts, it means we need to take the new providerAccountId and providerAssetIds and update it to all existing accounts
            // which have been already been updated in userInput.existingAccountsUpdated by RedirectToProvider
            if (userInput.existingAccountsUpdated && userInput.existingAccountsUpdated.length > 0) {
                console.info("AddAccount: detected existing accounts to update", userInput.existingAccountsUpdated);
                promises.push(...userInput.existingAccountsUpdated.map((ea)=>dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
                        data: ea,
                        category: category
                    }))));
            }
            // if this is a GC account (running with useInput.reconcileAccounts) and if there is a previous requisition id, we need to also remove the previous requisition, otherwise it will remain there
            if (userInput.reconcileAccounts && userInput.removedGCRequisitonId) {
                console.info("AddAccount: detected GC account to remove", userInput.removedGCRequisitonId);
                promises.push((0, $bad5f4197326a006$export$d94f928774096e78)("myAPI", `deposits/requisition/${userInput.removedGCRequisitonId}`, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }));
            }
            try {
                const result = await Promise.all(promises);
                // close add account dialog
                setAddModeState({
                    visible: false,
                    category: null,
                    addAccountState: undefined
                });
            } catch (err) {
                console.error("handleSubmit: error", err);
                setLoading(false);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated", "Validation error."));
            }
        }
    }
    //------------------------------------------------------------
    // PREPARE WORKFLOW STATUS INDICATOR
    //------------------------------------------------------------
    const steps = (0, $7fPBF.useMemo)(()=>currentWorkflow.map((item, index)=>({
                name: item.name,
                status: index === displayedStep ? "current" : index < displayedStep ? "complete" : "upcoming"
            })), [
        currentWorkflow,
        displayedStep
    ]);
    function handleClose(e) {
        e.preventDefault();
        setAddModeState((0, $2qxEV._)((0, $9tqwB._)({}, addModeState), {
            visible: false
        }));
    }
    const Component = currentWorkflow[displayedStep];
    const CardToDisplay = category === "pension" ? (0, $54472657a7d1d19d$export$2e2bcd8739ae039) : (0, $25250cd4374f51ac$export$2e2bcd8739ae039); // pension uses OverlayCard for its close button styling
    const NavToDisplay = category === "pension" ? (0, $7210fb90eac6c605$export$2e2bcd8739ae039) : (0, $960126dae36fdf62$export$98e5dade965b8dcf); // pension uses its own NavComponent
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CardToDisplay, {
        closeCallback: handleClose,
        fixedHeight: true,
        noPadding: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("main", {
            className: "flex flex-col h-full",
            ref: myRef,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex-grow px-2 sm:px-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "px-4 py-5 sm:px-8 sm:py-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, {
                            category: category,
                            index: displayedStep,
                            setDisplayedStep: setDisplayedStep,
                            workflowStepStatus: workflowStepStatus,
                            updateWorkflowStatus: updateWorkflowStatus,
                            userInput: userInput,
                            setUserInput: setUserInput,
                            setMessageToShowBeforeNext: setMessageToShowBeforeNext,
                            signalNext: signalNext,
                            setSignalNext: setSignalNext
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(NavToDisplay, {
                    setAddModeState: setAddModeState,
                    displayedStep: displayedStep,
                    setDisplayedStep: setDisplayedStep,
                    workflowStepStatus: workflowStepStatus,
                    steps: steps,
                    loading: loading,
                    messageToShowBeforeNext: messageToShowBeforeNext,
                    setMessageToShowBeforeNext: setMessageToShowBeforeNext,
                    handleSubmit: handleSubmit,
                    setSignalNext: setSignalNext
                })
            ]
        })
    });
}
$325eda4246b652c5$export$2e2bcd8739ae039.propTypes = {
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    addModeState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAddModeState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    addAccountState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
};
$325eda4246b652c5$export$2e2bcd8739ae039.defaultProps = {
    addAccountState: null
};


/* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/no-array-index-key */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");




var $2oXYc = parcelRequire("2oXYc");












var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




async function $1acab730a53899de$export$807b5e4e87e69d58({ category: category, userInput: userInput, dispatch: dispatch, setLoading: setLoading }) {
    const accountSchema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(category, "account");
    let payload;
    try {
        const validated = accountSchema.validateSync(userInput);
        payload = accountSchema.cast(validated, {
            stripUnknown: true
        });
    } catch (error) {
        console.error("Error casting accountSchema", error);
        if (error.inner) error.inner.forEach((err)=>console.error(`Field: ${err.path}, Error: ${err.message}`));
        throw new Error("Validation error (add account).");
    }
    try {
        const resultDispatch = await dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
            data: payload,
            category: category
        }));
        if (resultDispatch.error) throw new Error("AddAccount > dispatchUserInput: Dispatch postAccount returned an error");
        return {
            resultDispatch: resultDispatch,
            payload: payload
        };
    } catch (error) {
        console.error("Error: AddAccount: postAccount failed", error);
        if (setLoading) setLoading(false);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
        throw error;
    }
}
async function $1acab730a53899de$export$9aebc2f6af1651eb(flattenedUserInput, { dispatch: dispatch }) {
    let updatedInput = (0, $9tqwB._)({}, flattenedUserInput);
    if (updatedInput.connectedDepositMode === "existingAccount") updatedInput = (0, $2qxEV._)((0, $9tqwB._)({}, updatedInput), {
        connectedDepositAccounts: [
            updatedInput.connectedDepositAccountObject
        ]
    });
    if (updatedInput.connectedDepositMode === "createTechnicalAccount") {
        const newDepositAccountId = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
        updatedInput = (0, $2qxEV._)((0, $9tqwB._)({}, updatedInput), {
            connectedDepositAccounts: [
                newDepositAccountId
            ]
        });
        const depositAccount = {
            id: newDepositAccountId,
            name: updatedInput.name,
            bankName: updatedInput.brokerName,
            currency: updatedInput.currency,
            countryCode: updatedInput.countryCode,
            depositType: "savings-account",
            syncType: "manual",
            tags: {}
        };
        const payloadDeposit = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)("deposits", "account").cast(depositAccount);
        await dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
            data: payloadDeposit,
            category: "deposits"
        }));
    }
    return updatedInput;
}
async function $1acab730a53899de$export$5c5c46c88f282b0b({ payload: payload, category: category, dispatch: dispatch, accountId: accountId }) {
    if ((payload === null || payload === void 0 ? void 0 : payload.syncType) === "automatic") dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: category,
        accountId: accountId
    }));
}


async function $bca66cc1521c5d3c$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    const { provider: provider, accountArray: accountArray, existingAccountsUpdated: existingAccountsUpdated, reconcileAccounts: reconcileAccounts, removedGCRequisitonId: removedGCRequisitonId } = formValues;
    const accountsToSubmit = accountArray ? accountArray.filter((accountData)=>accountData.isImported) : [
        formValues
    ];
    // Submit accounts (retain async control flow)
    await Promise.all(accountsToSubmit.map(async (accountData)=>{
        var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
        const flattened = (0, $9tqwB._)({}, formValues, provider, accountData);
        if (provider) flattened.tags = (0, $2qxEV._)((0, $9tqwB._)({}, flattened.tags), {
            provider: {
                [accountData.providerName]: {
                    providerAccountId: accountData.providerAccountId,
                    providerInstitutionId: provider.providerInstitutionId,
                    providerAccessId: provider.providerAccessId
                }
            }
        });
        const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
            category: category,
            userInput: flattened,
            dispatch: dispatch,
            setLoading: setLoading
        });
        if (resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
            payload: payload,
            category: category,
            dispatch: dispatch,
            accountId: resultDispatch.payload.accounts[0].id
        });
    }));
    if (existingAccountsUpdated === null || existingAccountsUpdated === void 0 ? void 0 : existingAccountsUpdated.length) await Promise.all(existingAccountsUpdated.map((ea)=>dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
            data: ea,
            category: category
        }))));
    if (reconcileAccounts && removedGCRequisitonId) await (0, $bad5f4197326a006$export$d94f928774096e78)("myAPI", `deposits/requisition/${removedGCRequisitonId}`, {
        headers: {
            "Content-Type": "application/json"
        }
    });
}



var $9tqwB = parcelRequire("9tqwB");

async function $2c4dee4edb276c4b$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    const { provider: provider, accountArray: accountArray } = formValues;
    const accounts = accountArray ? accountArray.filter((a)=>a.isImported) : [
        formValues
    ];
    await Promise.all(accounts.map(async (accountData)=>{
        var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
        const flattened = (0, $9tqwB._)({}, formValues, provider, accountData);
        const withConnected = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)(flattened, {
            dispatch: dispatch
        });
        const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
            category: category,
            userInput: withConnected,
            dispatch: dispatch,
            setLoading: setLoading
        });
        if (resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
            payload: payload,
            category: category,
            dispatch: dispatch,
            accountId: resultDispatch.payload.accounts[0].id
        });
    }));
}



var $9tqwB = parcelRequire("9tqwB");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
async function $e45aa573830dd20c$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
    const flattened = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)((0, $9tqwB._)({}, formValues), {
        dispatch: dispatch
    });
    const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
        category: category,
        userInput: flattened,
        dispatch: dispatch,
        setLoading: setLoading
    });
    const accountId = resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id;
    if (accountId && flattened.name && flattened.date && flattened.originalPrice) {
        const dataArray = [
            (0, $3a1ecd75ab1ea382$export$6ee7acc2fdcedc63).validateSync({
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: accountId,
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(flattened.date).startOf("day"),
                category: "realEstate",
                originalPrice: flattened.originalPrice,
                currency: flattened.currency,
                price: null,
                amount: 1,
                transactionType: "purchase",
                importFlag: "post"
            })
        ];
        try {
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: dataArray,
                category: "realEstate",
                accountId: accountId
            }));
        } catch (error) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("addTransactionManually"));
        }
    }
    if (accountId) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
        payload: payload,
        category: category,
        dispatch: dispatch,
        accountId: accountId
    });
}



var $9tqwB = parcelRequire("9tqwB");

async function $01ee7463bd0691fb$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    const { provider: provider, accountArray: accountArray } = formValues;
    const accounts = accountArray ? accountArray.filter((a)=>a.isImported) : [
        formValues
    ];
    await Promise.all(accounts.map(async (accountData)=>{
        var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
        const flattened = (0, $9tqwB._)({}, formValues, provider, accountData);
        const withConnected = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)(flattened, {
            dispatch: dispatch
        });
        const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
            category: category,
            userInput: withConnected,
            dispatch: dispatch,
            setLoading: setLoading
        });
        const accountId = resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id;
        if (accountId) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
            payload: payload,
            category: category,
            dispatch: dispatch,
            accountId: accountId
        });
    }));
}



var $9tqwB = parcelRequire("9tqwB");



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
async function $cb66450cdcb80d90$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
    const flattened = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)((0, $9tqwB._)({}, formValues), {
        dispatch: dispatch
    });
    // housekeeping: convert dates to epoch
    flattened.productPurchaseDate = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formValues.productPurchaseDate).valueOf(); // required
    flattened.payoutsPhaseStart = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formValues.payoutsPhaseStart).valueOf(); // required
    // convert contributionsAmountsUserInput to an array of { effectiveDate, value }
    flattened.contributionsAmounts = [
        {
            effectiveDate: flattened.productPurchaseDate,
            value: flattened.contributionsAmountsUserInput
        }
    ];
    let payoutsCustomIndexRate = flattened.payoutsCustomIndexRate;
    if (payoutsCustomIndexRate === "") payoutsCustomIndexRate = null;
    flattened.payoutsCustomIndexRate = payoutsCustomIndexRate !== null && payoutsCustomIndexRate !== undefined ? Number(payoutsCustomIndexRate) : payoutsCustomIndexRate;
    if (!flattened.payoutsIndexed) {
        flattened.payoutsIndexedByInflation = null;
        flattened.payoutsCustomIndexRate = null;
    } else if (flattened.payoutsIndexedByInflation) flattened.payoutsCustomIndexRate = null;
    // convert payoutsDurationFrequencyUserInput and payoutsDurationUserInput to payoutsDuration
    if (flattened.payoutDurationFrequencyUnitUserInput === "indefinite") flattened.payoutsDuration = 0;
    else if (flattened.payoutDurationFrequencyUnitUserInput === "years") flattened.payoutsDuration = 12 * flattened.payoutsDurationUserInput;
    else if (flattened.payoutDurationFrequencyUnitUserInput === "months") flattened.payoutsDuration = flattened.payoutsDurationUserInput;
    // move quotes to intialQuotes
    flattened.initialQuotes = [];
    if (flattened.payoutOnlyContributionsToDateQuote) flattened.initialQuotes.push({
        type: "payoutOnlyContributionsToDate",
        quote: flattened.payoutOnlyContributionsToDateQuote,
        quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutOnlyContributionsToDateQuote : flattened.payoutOnlyContributionsToDateQuoteBaseCurrency
    });
    if (flattened.payoutOnlyContributionsToDateIndexedQuote) flattened.initialQuotes.push({
        type: "payoutOnlyContributionsToDateIndexed",
        quote: flattened.payoutOnlyContributionsToDateIndexedQuote,
        quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutOnlyContributionsToDateIndexedQuote : flattened.payoutOnlyContributionsToDateIndexedQuoteBaseCurrency
    });
    if (flattened.payoutAllPlannedContributionsQuote) flattened.initialQuotes.push({
        type: "payoutAllPlannedContributions",
        quote: flattened.payoutAllPlannedContributionsQuote,
        quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutAllPlannedContributionsQuote : flattened.payoutAllPlannedContributionsQuoteBaseCurrency
    });
    if (flattened.payoutAllPlannedContributionsIndexedQuote) flattened.initialQuotes.push({
        type: "payoutAllPlannedContributionsIndexed",
        quote: flattened.payoutAllPlannedContributionsIndexedQuote,
        quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutAllPlannedContributionsIndexedQuote : flattened.payoutAllPlannedContributionsIndexedQuoteBaseCurrency
    });
    if (flattened.payoutLumpSumVerrentetQuote) flattened.initialQuotes.push({
        type: "payoutLumpSumVerrentet",
        quote: flattened.payoutLumpSumVerrentetQuote,
        quoteBaseCurrency: flattened.isBaseCurrencySameAsAccountCurrency ? flattened.payoutLumpSumVerrentetQuote : flattened.payoutLumpSumVerrentetQuoteBaseCurrency
    });
    const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
        category: category,
        userInput: flattened,
        dispatch: dispatch,
        setLoading: setLoading
    });
    const accountId = resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id;
    if (accountId) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
        payload: payload,
        category: category,
        dispatch: dispatch,
        accountId: accountId
    });
}



var $9tqwB = parcelRequire("9tqwB");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
async function $de671b1e3bb22515$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
    const flattened = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)((0, $9tqwB._)({}, formValues), {
        dispatch: dispatch
    });
    const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
        category: category,
        userInput: flattened,
        dispatch: dispatch,
        setLoading: setLoading
    });
    const accountId = resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id;
    if (accountId) {
        try {
            const dataArray = [
                (0, $81cfed1660055fbf$export$4c255d423d7ada4d).cast({
                    id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                    accountId: accountId,
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(flattened.date).startOf("day").valueOf(),
                    category: "objectsOfValue",
                    quantity: flattened.quantity,
                    transactionType: "purchase",
                    upac: flattened.userInputPurchaseValueAccountCurrency / flattened.quantity,
                    upbc: flattened.userInputPurchaseValueBaseCurrency / flattened.quantity,
                    uptc: null,
                    transactionCurrency: null,
                    accountCurrency: flattened.currency,
                    assetCurrency: flattened.currency,
                    importFlag: "post",
                    description: "Initial"
                })
            ];
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: dataArray,
                category: "objectsOfValue",
                accountId: accountId
            }));
        } catch (error) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("addTransactionManually"));
        }
        (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
            payload: payload,
            category: category,
            dispatch: dispatch,
            accountId: accountId
        });
    }
}



var $9tqwB = parcelRequire("9tqwB");

async function $ef34b4287dfce19b$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
    const flattened = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)((0, $9tqwB._)({}, formValues), {
        dispatch: dispatch
    });
    const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
        category: category,
        userInput: flattened,
        dispatch: dispatch,
        setLoading: setLoading
    });
    const accountId = resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id;
    if (accountId) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
        payload: payload,
        category: category,
        dispatch: dispatch,
        accountId: accountId
    });
}



var $9tqwB = parcelRequire("9tqwB");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
async function $5f9c4b9c3579166d$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
    const flattened = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)((0, $9tqwB._)({}, formValues), {
        dispatch: dispatch
    });
    const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
        category: category,
        userInput: flattened,
        dispatch: dispatch,
        setLoading: setLoading
    });
    const accountId = resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id;
    if (accountId) {
        try {
            const dataArray = [
                (0, $81cfed1660055fbf$export$4c255d423d7ada4d).cast({
                    id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                    accountId: accountId,
                    assetId: accountId,
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(flattened.date).startOf("day").valueOf(),
                    category: "unlistedShares",
                    quantity: flattened.quantity,
                    upac: flattened.upac / flattened.quantity,
                    upbc: flattened.upbc / flattened.quantity,
                    uptc: null,
                    transactionCurrency: null,
                    accountCurrency: flattened.currency,
                    assetCurrency: flattened.currency,
                    importFlag: "post",
                    description: "Initial"
                })
            ];
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: dataArray,
                category: "unlistedShares",
                accountId: accountId
            }));
        } catch (error) {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("addTransactionManually"));
        }
        (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
            payload: payload,
            category: category,
            dispatch: dispatch,
            accountId: accountId
        });
    }
}



var $9tqwB = parcelRequire("9tqwB");

async function $269a2f8bbfd0b111$export$2e2bcd8739ae039({ formValues: formValues, dispatch: dispatch, setLoading: setLoading, category: category }) {
    const { provider: provider, accountArray: accountArray } = formValues;
    const accounts = accountArray ? accountArray.filter((a)=>a.isImported) : [
        formValues
    ];
    await Promise.all(accounts.map(async (accountData)=>{
        var _resultDispatch_payload_accounts_, _resultDispatch_payload_accounts, _resultDispatch_payload;
        const flattened = (0, $9tqwB._)({}, formValues, provider, accountData);
        const withConnected = await (0, $1acab730a53899de$export$9aebc2f6af1651eb)(flattened, {
            dispatch: dispatch
        });
        const { resultDispatch: resultDispatch, payload: payload } = await (0, $1acab730a53899de$export$807b5e4e87e69d58)({
            category: category,
            userInput: withConnected,
            dispatch: dispatch,
            setLoading: setLoading
        });
        if (resultDispatch === null || resultDispatch === void 0 ? void 0 : (_resultDispatch_payload = resultDispatch.payload) === null || _resultDispatch_payload === void 0 ? void 0 : (_resultDispatch_payload_accounts = _resultDispatch_payload.accounts) === null || _resultDispatch_payload_accounts === void 0 ? void 0 : (_resultDispatch_payload_accounts_ = _resultDispatch_payload_accounts[0]) === null || _resultDispatch_payload_accounts_ === void 0 ? void 0 : _resultDispatch_payload_accounts_.id) (0, $1acab730a53899de$export$5c5c46c88f282b0b)({
            payload: payload,
            category: category,
            dispatch: dispatch,
            accountId: resultDispatch.payload.accounts[0].id
        });
    }));
}



const $cf33b516e8aac9df$var$handlers = {
    deposits: (0, $bca66cc1521c5d3c$export$2e2bcd8739ae039),
    stocks: (0, $2c4dee4edb276c4b$export$2e2bcd8739ae039),
    realEstate: (0, $e45aa573830dd20c$export$2e2bcd8739ae039),
    loans: (0, $01ee7463bd0691fb$export$2e2bcd8739ae039),
    pension: (0, $cb66450cdcb80d90$export$2e2bcd8739ae039),
    objectsOfValue: (0, $de671b1e3bb22515$export$2e2bcd8739ae039),
    metals: (0, $ef34b4287dfce19b$export$2e2bcd8739ae039),
    unlistedShares: (0, $5f9c4b9c3579166d$export$2e2bcd8739ae039),
    crypto: (0, $269a2f8bbfd0b111$export$2e2bcd8739ae039)
};
async function $cf33b516e8aac9df$export$2e2bcd8739ae039({ category: category, workflowStepStatus: workflowStepStatus, formValues: formValues, dispatch: dispatch, setLoading: setLoading, setAddModeState: setAddModeState, t: t }) {
    if (!workflowStepStatus.every((item)=>!!item)) return;
    setLoading(true);
    const handler = $cf33b516e8aac9df$var$handlers[category];
    if (!handler) {
        console.error(`No submit handler configured for category ${category}`);
        setLoading(false);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
        return;
    }
    try {
        await handler({
            formValues: formValues,
            dispatch: dispatch,
            setLoading: setLoading,
            category: category,
            t: t
        });
        setAddModeState({
            visible: false,
            category: null,
            addAccountState: undefined
        });
    } catch (err) {
        console.error("handleSubmit: error", err);
        setLoading(false);
        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
    }
}


const $8c4bb5f070778851$var$debugLevel = 0;
function $8c4bb5f070778851$export$2e2bcd8739ae039({ category: category, addModeState: addModeState, setAddModeState: setAddModeState, addAccountState: addAccountState }) {
    const myRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        myRef.current.scrollIntoView({
            behavior: "instant"
        });
    }, []);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("addAccount");
    // const [userInput, setUserInput] = useState(addAccountState?.userInput || {}); // being assembled during the workflow from the inputs of different child components
    const form = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onChange",
        shouldUnregister: false,
        defaultValues: (addAccountState === null || addAccountState === void 0 ? void 0 : addAccountState.userInput) || {}
    });
    const { control: control, getValues: getValues } = form;
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // true when the user has submitted the form and we are waiting for the backend to respond
    const [displayedStep, setDisplayedStep] = (0, $7fPBF.useState)((addAccountState === null || addAccountState === void 0 ? void 0 : addAccountState.displayedStep) || 0); // the index of the component that is currently displayed
    const [messageToShowBeforeNext, setMessageToShowBeforeNext] = (0, $7fPBF.useState)(null); // if this is not null, show the message in a popup before moving to the next step
    const [signalNext, setSignalNext] = (0, $7fPBF.useState)(false); // passes the event of user clicking NEXT in NAV COMPONENT to the current component
    // -----------------------------------------------------------
    // ESC handler
    // -----------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        // if user presses esc, go back to dashboard
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") setAddModeState({
                visible: false,
                category: null,
                addAccountState: undefined
            });
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    //------------------------------------------------------------
    // DEFINE ALL WORKFLOWS
    //------------------------------------------------------------
    const workflows = {
        deposits: [
            (0, $b799bd13ee74234e$export$2e2bcd8739ae039),
            (0, $a01d16f39a7b54eb$export$2e2bcd8739ae039),
            (0, $e3c8313e93d4b2c4$export$2e2bcd8739ae039)
        ],
        stocks: [
            (0, $b799bd13ee74234e$export$2e2bcd8739ae039),
            (0, $a01d16f39a7b54eb$export$2e2bcd8739ae039),
            (0, $e3c8313e93d4b2c4$export$2e2bcd8739ae039)
        ],
        realEstate: [
            (0, $96a84f48caa04ee8$export$2e2bcd8739ae039)
        ],
        loans: [
            (0, $b799bd13ee74234e$export$2e2bcd8739ae039),
            (0, $a01d16f39a7b54eb$export$2e2bcd8739ae039),
            (0, $e3c8313e93d4b2c4$export$2e2bcd8739ae039)
        ],
        pension: [
            (0, $ba9fac31fb6dba98$export$2e2bcd8739ae039),
            (0, $8fd61e1b0b5b5e2b$export$2e2bcd8739ae039),
            (0, $b264a431fde9d7cd$export$2e2bcd8739ae039),
            (0, $dfc72607c0375076$export$2e2bcd8739ae039),
            (0, $857eb878fd7bb7d9$export$2e2bcd8739ae039),
            (0, $e629de6f734a4d7a$export$2e2bcd8739ae039)
        ],
        objectsOfValue: [
            (0, $699f617a607a6b0b$export$2e2bcd8739ae039)
        ],
        metals: [
            (0, $92fa613ade6d7ae9$export$2e2bcd8739ae039)
        ],
        unlistedShares: [
            (0, $4c814cde55bca358$export$2e2bcd8739ae039)
        ],
        crypto: [
            (0, $c90f61ccf4f69c8b$export$2e2bcd8739ae039)
        ]
    };
    const currentWorkflow = workflows[category]; // an array that holds the components constituting the workflow in the proper sequence
    //------------------------------------------------------------
    // SET UP THIS WORKFLOW'S STATE
    //------------------------------------------------------------
    // set "workflowStepStatus" to an array of the same amount of items as the workflow calculated in the "workflows" object
    const [workflowStepStatus, setWorkflowStepStatus] = (0, $7fPBF.useState)((addAccountState === null || addAccountState === void 0 ? void 0 : addAccountState.workflowStepStatus) || [
        ...Array(currentWorkflow.length)
    ]);
    // update the status of a single step in the workflow to 'status'; this function will be passed to the child components so that they may update this state
    function updateWorkflowStatus(step, status) {
        if ($8c4bb5f070778851$var$debugLevel > 2) console.info(`updateWorkflowStatus: step ${step} status ${status}`);
        const newStatus = [
            ...workflowStepStatus
        ];
        newStatus[step] = status;
        setWorkflowStepStatus(newStatus);
    }
    // workflow is ready (and the Submit button is displayed) when all of its steps are ready
    const formReady = workflowStepStatus.every((step)=>step === true);
    if ($8c4bb5f070778851$var$debugLevel > 2) console.info("formReady", formReady, workflowStepStatus);
    //------------------------------------------------------------
    // PREPARE WORKFLOW STATUS INDICATOR
    //------------------------------------------------------------
    const steps = (0, $7fPBF.useMemo)(()=>currentWorkflow.map((item, index)=>({
                name: item.name,
                status: index === displayedStep ? "current" : index < displayedStep ? "complete" : "upcoming"
            })), [
        currentWorkflow,
        displayedStep
    ]);
    // ------------------------------------------------------------
    // ↓↓ main SUBMIT handler for the AddAccount workflows
    // ------------------------------------------------------------
    async function handleSubmit(e) {
        const formValues = getValues();
        await (0, $cf33b516e8aac9df$export$2e2bcd8739ae039)({
            category: category,
            workflowStepStatus: workflowStepStatus,
            formValues: formValues,
            dispatch: dispatch,
            setLoading: setLoading,
            setAddModeState: setAddModeState,
            t: t
        });
    }
    function handleClose(e) {
        e.preventDefault();
        setAddModeState((0, $2qxEV._)((0, $9tqwB._)({}, addModeState), {
            visible: false
        }));
    }
    const Component = currentWorkflow[displayedStep];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $54472657a7d1d19d$export$2e2bcd8739ae039), {
        closeCallback: handleClose,
        fixedHeight: true,
        noPadding: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("main", {
            className: "flex flex-col h-full",
            ref: myRef,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex-grow px-2 sm:px-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "px-4 py-5 sm:px-8 sm:py-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, {
                            category: category,
                            index: displayedStep,
                            setDisplayedStep: setDisplayedStep,
                            workflowStepStatus: workflowStepStatus,
                            updateWorkflowStatus: updateWorkflowStatus,
                            setMessageToShowBeforeNext: setMessageToShowBeforeNext,
                            form: form,
                            signalNext: signalNext,
                            setSignalNext: setSignalNext
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7210fb90eac6c605$export$2e2bcd8739ae039), {
                    setAddModeState: setAddModeState,
                    displayedStep: displayedStep,
                    setDisplayedStep: setDisplayedStep,
                    workflowStepStatus: workflowStepStatus,
                    form: form,
                    steps: steps,
                    loading: loading,
                    messageToShowBeforeNext: messageToShowBeforeNext,
                    setMessageToShowBeforeNext: setMessageToShowBeforeNext,
                    handleSubmit: handleSubmit,
                    setSignalNext: setSignalNext
                })
            ]
        })
    });
}
$8c4bb5f070778851$export$2e2bcd8739ae039.propTypes = {
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    addModeState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAddModeState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    addAccountState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
};
$8c4bb5f070778851$export$2e2bcd8739ae039.defaultProps = {
    addAccountState: null
};


/* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");




var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $1bb47cb945e5c730$var$ChevronRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
        clipRule: "evenodd"
    }));
}
const $1bb47cb945e5c730$var$ForwardRef = $7fPBF.forwardRef($1bb47cb945e5c730$var$ChevronRightIcon);
var $1bb47cb945e5c730$export$2e2bcd8739ae039 = $1bb47cb945e5c730$var$ForwardRef;





var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $c67e8e5ff55101a6$var$QuestionMarkCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM8.94 6.94a.75.75 0 1 1-1.061-1.061 3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        clipRule: "evenodd"
    }));
}
const $c67e8e5ff55101a6$var$ForwardRef = $7fPBF.forwardRef($c67e8e5ff55101a6$var$QuestionMarkCircleIcon);
var $c67e8e5ff55101a6$export$2e2bcd8739ae039 = $c67e8e5ff55101a6$var$ForwardRef;




/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable max-len */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2c018e30af99d30e$var$ArrowUpTrayIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
    }));
}
const $2c018e30af99d30e$var$ForwardRef = $7fPBF.forwardRef($2c018e30af99d30e$var$ArrowUpTrayIcon);
var $2c018e30af99d30e$export$2e2bcd8739ae039 = $2c018e30af99d30e$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $4da3a00a55400621$var$FunnelIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
    }));
}
const $4da3a00a55400621$var$ForwardRef = $7fPBF.forwardRef($4da3a00a55400621$var$FunnelIcon);
var $4da3a00a55400621$export$2e2bcd8739ae039 = $4da3a00a55400621$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2f41531232608099$var$ArrowDownOnSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M13.75 7h-3v5.296l1.943-2.048a.75.75 0 0 1 1.114 1.004l-3.25 3.5a.75.75 0 0 1-1.114 0l-3.25-3.5a.75.75 0 1 1 1.114-1.004l1.943 2.048V7h1.5V1.75a.75.75 0 0 0-1.5 0V7h-3A2.25 2.25 0 0 0 4 9.25v7.5A2.25 2.25 0 0 0 6.25 19h7.5A2.25 2.25 0 0 0 16 16.75v-7.5A2.25 2.25 0 0 0 13.75 7Z"
    }));
}
const $2f41531232608099$var$ForwardRef = $7fPBF.forwardRef($2f41531232608099$var$ArrowDownOnSquareIcon);
var $2f41531232608099$export$2e2bcd8739ae039 = $2f41531232608099$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $593bbc998d564df7$var$ArrowsUpDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2.24 6.8a.75.75 0 0 0 1.06-.04l1.95-2.1v8.59a.75.75 0 0 0 1.5 0V4.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L2.2 5.74a.75.75 0 0 0 .04 1.06Zm8 6.4a.75.75 0 0 0-.04 1.06l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75a.75.75 0 0 0-1.5 0v8.59l-1.95-2.1a.75.75 0 0 0-1.06-.04Z",
        clipRule: "evenodd"
    }));
}
const $593bbc998d564df7$var$ForwardRef = $7fPBF.forwardRef($593bbc998d564df7$var$ArrowsUpDownIcon);
var $593bbc998d564df7$export$2e2bcd8739ae039 = $593bbc998d564df7$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ca2c24a2ba9323a4$var$CogIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M13.024 9.25c.47 0 .827-.433.637-.863a4 4 0 0 0-4.094-2.364c-.468.05-.665.576-.43.984l1.08 1.868a.75.75 0 0 0 .649.375h2.158ZM7.84 7.758c-.236-.408-.79-.5-1.068-.12A3.982 3.982 0 0 0 6 10c0 .884.287 1.7.772 2.363.278.38.832.287 1.068-.12l1.078-1.868a.75.75 0 0 0 0-.75L7.839 7.758ZM9.138 12.993c-.235.408-.039.934.43.984a4 4 0 0 0 4.094-2.364c.19-.43-.168-.863-.638-.863h-2.158a.75.75 0 0 0-.65.375l-1.078 1.868Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "m14.13 4.347.644-1.117a.75.75 0 0 0-1.299-.75l-.644 1.116a6.954 6.954 0 0 0-2.081-.556V1.75a.75.75 0 0 0-1.5 0v1.29a6.954 6.954 0 0 0-2.081.556L6.525 2.48a.75.75 0 1 0-1.3.75l.645 1.117A7.04 7.04 0 0 0 4.347 5.87L3.23 5.225a.75.75 0 1 0-.75 1.3l1.116.644A6.954 6.954 0 0 0 3.04 9.25H1.75a.75.75 0 0 0 0 1.5h1.29c.078.733.27 1.433.556 2.081l-1.116.645a.75.75 0 1 0 .75 1.298l1.117-.644a7.04 7.04 0 0 0 1.523 1.523l-.645 1.117a.75.75 0 1 0 1.3.75l.644-1.116a6.954 6.954 0 0 0 2.081.556v1.29a.75.75 0 0 0 1.5 0v-1.29a6.954 6.954 0 0 0 2.081-.556l.645 1.116a.75.75 0 0 0 1.299-.75l-.645-1.117a7.042 7.042 0 0 0 1.523-1.523l1.117.644a.75.75 0 0 0 .75-1.298l-1.116-.645a6.954 6.954 0 0 0 .556-2.081h1.29a.75.75 0 0 0 0-1.5h-1.29a6.954 6.954 0 0 0-.556-2.081l1.116-.644a.75.75 0 0 0-.75-1.3l-1.117.645a7.04 7.04 0 0 0-1.524-1.523ZM10 4.5a5.475 5.475 0 0 0-2.781.754A5.527 5.527 0 0 0 5.22 7.277 5.475 5.475 0 0 0 4.5 10a5.475 5.475 0 0 0 .752 2.777 5.527 5.527 0 0 0 2.028 2.004c.802.458 1.73.719 2.72.719a5.474 5.474 0 0 0 2.78-.753 5.527 5.527 0 0 0 2.001-2.027c.458-.802.719-1.73.719-2.72a5.475 5.475 0 0 0-.753-2.78 5.528 5.528 0 0 0-2.028-2.002A5.475 5.475 0 0 0 10 4.5Z",
        clipRule: "evenodd"
    }));
}
const $ca2c24a2ba9323a4$var$ForwardRef = $7fPBF.forwardRef($ca2c24a2ba9323a4$var$CogIcon);
var $ca2c24a2ba9323a4$export$2e2bcd8739ae039 = $ca2c24a2ba9323a4$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $7349b83ead8864ce$var$TableCellsIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M.99 5.24A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25l.01 9.5A2.25 2.25 0 0 1 16.76 17H3.26A2.267 2.267 0 0 1 1 14.74l-.01-9.5Zm8.26 9.52v-.625a.75.75 0 0 0-.75-.75H3.25a.75.75 0 0 0-.75.75v.615c0 .414.336.75.75.75h5.373a.75.75 0 0 0 .627-.74Zm1.5 0a.75.75 0 0 0 .627.74h5.373a.75.75 0 0 0 .75-.75v-.615a.75.75 0 0 0-.75-.75H11.5a.75.75 0 0 0-.75.75v.625Zm6.75-3.63v-.625a.75.75 0 0 0-.75-.75H11.5a.75.75 0 0 0-.75.75v.625c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75Zm-8.25 0v-.625a.75.75 0 0 0-.75-.75H3.25a.75.75 0 0 0-.75.75v.625c0 .414.336.75.75.75H8.5a.75.75 0 0 0 .75-.75ZM17.5 7.5v-.625a.75.75 0 0 0-.75-.75H11.5a.75.75 0 0 0-.75.75V7.5c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75Zm-8.25 0v-.625a.75.75 0 0 0-.75-.75H3.25a.75.75 0 0 0-.75.75V7.5c0 .414.336.75.75.75H8.5a.75.75 0 0 0 .75-.75Z",
        clipRule: "evenodd"
    }));
}
const $7349b83ead8864ce$var$ForwardRef = $7fPBF.forwardRef($7349b83ead8864ce$var$TableCellsIcon);
var $7349b83ead8864ce$export$2e2bcd8739ae039 = $7349b83ead8864ce$var$ForwardRef;







// if only one button - do not render
function $4d158b048a3c62bc$var$Buttons({ modeObjectsToShow: modeObjectsToShow, currentMode: currentMode, setCurrentMode: setCurrentMode, topLevelFormatting: topLevelFormatting, activeTab: activeTab, actionButtons: actionButtons, handleSave: handleSave, handleSync: handleSync, accountSyncStatus: accountSyncStatus, handlePrevNext: handlePrevNext, handleCancel: handleCancel, transformationParams: transformationParams, setTransformationParams: setTransformationParams, handleUndoTransform: handleUndoTransform, showTableFilters: showTableFilters, activeTableFilterCount: activeTableFilterCount, onOpenTableFilters: onOpenTableFilters, isMobile: isMobile }) {
    $4d158b048a3c62bc$var$Buttons.propTypes = {
        modeObjectsToShow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
        })),
        setCurrentMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        currentMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        topLevelFormatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        activeTab: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        actionButtons: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
        handleSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        handleSync: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        handleCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        accountSyncStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        handlePrevNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        transformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
        setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        handleUndoTransform: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        showTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        activeTableFilterCount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        onOpenTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        isMobile: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
    };
    $4d158b048a3c62bc$var$Buttons.defaultProps = {
        modeObjectsToShow: [
            {
                id: "table"
            },
            {
                id: "grid"
            }
        ],
        currentMode: "table",
        setCurrentMode: ()=>{},
        topLevelFormatting: "",
        actionButtons: [],
        handleSave: ()=>{},
        handlePrevNext: ()=>{},
        handleSync: ()=>{},
        handleCancel: ()=>{},
        transformationParams: [],
        setTransformationParams: ()=>{},
        handleUndoTransform: ()=>{},
        showTableFilters: false,
        activeTableFilterCount: 0,
        onOpenTableFilters: ()=>{},
        isMobile: false
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    const dashboardModeSelect = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    const dashboardMode = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>dashboardModeSelect, [
        dashboardModeSelect
    ]);
    // metals - historical value calculation
    const [getPurchaseValueLoading, setGetPurchaseValueLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false); // controls the loading state of the historical value calculation for metals
    function handleGridGetPurchaseValuesCompleted(event) {
        setGetPurchaseValueLoading(false);
        event.target.removeEventListener("gridGetPurchaseValues", handleGridGetPurchaseValuesCompleted);
    }
    // handle calculation of historical value for metals
    function handleHistoricalValueCalc() {
        setGetPurchaseValueLoading(true);
        window.dispatchEvent(new CustomEvent("gridGetPurchaseValues")); // this event notifies Grid that it should calculate historical values
        // when Grid is done, it sends this event
        window.addEventListener("handleGridGetPurchaseValuesCompleted", handleGridGetPurchaseValuesCompleted);
    }
    const mobileIconButtonClassName = "sm:hidden inline-flex h-11 w-11 min-w-0 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-200 disabled:cursor-not-allowed disabled:opacity-50";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: "rightButtons",
        className: `text-sm ${topLevelFormatting} ${isMobile ? "w-full flex items-start justify-between gap-2" : "flex justify-center items-center space-x-2"}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: `flex items-center gap-2 ${isMobile ? "flex-wrap" : ""}`,
                children: [
                    actionButtons.includes("sync") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("sync.tooltip"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    onClick: handleSync,
                                    className: mobileIconButtonClassName,
                                    disabled: accountSyncStatus,
                                    "aria-label": "Sync",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$59de000b07aa1ecd), {
                                        className: `h-5 w-5 ${accountSyncStatus ? "animate-spin" : ""}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: "Sync",
                                    Icon: (0, $3ea1f91ff88fa2cb$export$59de000b07aa1ecd),
                                    onClick: handleSync,
                                    spinnerOn: accountSyncStatus,
                                    formatting: "hidden sm:flex w-24 justify-center"
                                })
                            ]
                        })
                    }),
                    showTableFilters && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("tableFilters.tooltip"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    type: "button",
                                    onClick: onOpenTableFilters,
                                    className: `${mobileIconButtonClassName} relative ${activeTableFilterCount > 0 ? "bg-brandBlue-50 text-brandBlue-700 border-brandBlue-200" : ""}`,
                                    "aria-label": t("tableFilters.label"),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4da3a00a55400621$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5"
                                        }),
                                        activeTableFilterCount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "absolute -top-1.5 -right-1.5 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-brandBlue-600 px-1 text-[10px] font-bold text-white",
                                            children: activeTableFilterCount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("tableFilters.label"),
                                    onClick: onOpenTableFilters,
                                    Icon: (0, $4da3a00a55400621$export$2e2bcd8739ae039),
                                    withAccent: activeTableFilterCount > 0,
                                    formatting: "hidden sm:flex w-24 justify-center"
                                })
                            ]
                        })
                    }),
                    actionButtons.includes("historicalValueCalc") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("historicalValueCalc.tooltip"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            text: t("historicalValueCalc.label"),
                            onClick: handleHistoricalValueCalc,
                            noFrame: true,
                            formatting: "mt-0.5",
                            spinnerOn: getPurchaseValueLoading
                        })
                    }),
                    actionButtons.includes("decimalChar") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "relative inline-flex",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: t("decimalChar.tooltip"),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "mr-2 ",
                                    children: t("decimalChar.label")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    id: "account-details-grid-decimal-button",
                                    onClick: ()=>{
                                        const newDecimalChar = transformationParams.decimalChar === "," ? "." : ",";
                                        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                                                decimalChar: newDecimalChar
                                            }));
                                    },
                                    className: "rounded-md inline-flex items-center px-1.5 xs:px-4 py-1.5 border font-bold text-sm focus:z-10 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 border-gray-300 bg-white hover:bg-gray-50 text-gray-700",
                                    children: transformationParams.decimalChar
                                })
                            ]
                        })
                    }),
                    actionButtons.includes("headersInRow") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "relative inline-flex",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: t("headersInRow.tooltip"),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "mr-2 ",
                                    children: t("headersInRow.label")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "number",
                                    min: "0",
                                    step: "1",
                                    defaultValue: (transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow) ? transformationParams.headersInRow + 1 : "",
                                    id: "account-details-grid-headersinrow-button",
                                    onChange: (e)=>{
                                        if (Number.isNaN(Number(e.target.value)) || Number(e.target.value) < 0) setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                                                headersInRow: null
                                            }));
                                        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                                                headersInRow: Number(e.target.value) - 1
                                            }));
                                    },
                                    className: "inline-flex items-center w-16 px-1.5 py-1.5 text-center border border-gray-300 bg-white font-medium text-sm rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400"
                                })
                            ]
                        })
                    }),
                    actionButtons.includes("infoSave") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center rounded-md bg-brandBlue-50 px-3 py-1",
                        id: "info-message-save",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-brandBlue-400",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "ml-3 flex-1 md:flex md:justify-between",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-sm text-brandBlue-600",
                                    children: t("editYourFile")
                                })
                            })
                        ]
                    }),
                    actionButtons.includes("infoTransformed") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "rounded-md bg-brandBlue-50 px-3 py-1 flex items-center",
                        id: "info-message-transformed",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-brandBlue-400",
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "ml-3 flex-1 md:flex md:justify-between md:items-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-sm text-brandBlue-600",
                                        children: t("fileTransformed")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        text: t("fileTransformedUndo"),
                                        onClick: handleUndoTransform,
                                        noFrame: true,
                                        size: "xs",
                                        formatting: "ml-2",
                                        textColor: "text-brandBlue-700",
                                        textColorHover: "text-brandBlue-800"
                                    })
                                ]
                            })
                        ]
                    }),
                    dashboardMode === "projects" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("readOnly.tooltip"),
                        classNameOwn: "h-full flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "ml-2 px-1.5 rounded-full bg-brandBlue-300 border-[1px] border-brandBlue-300 text-white text-xs font-bold",
                                children: "i"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "ml-2 text-sm text-gray-500",
                                children: t("readOnly.label")
                            })
                        ]
                    }),
                    (currentMode === "grid" || currentMode === "previewer") && actionButtons.includes("save") && actionButtons.includes("cancel") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex space-x-2 items-center mr-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("save.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("save.label"),
                                    withAccent: true,
                                    onClick: handleSave
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("cancel.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("cancel.label"),
                                    onClick: handleCancel
                                })
                            })
                        ]
                    })
                ]
            }),
            activeTab !== "settings" && (modeObjectsToShow || []).length > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                id: "modeSelectButtons",
                className: `inline-flex items-center gap-1 rounded-full bg-gray-100 px-1 py-1 shadow-xs ring-1 ring-inset ring-gray-200 ${isMobile ? "ml-auto shrink-0" : ""}`,
                children: modeObjectsToShow.map((modeObject)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t(`${modeObject.id}.tooltip`),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setCurrentMode(modeObject.id),
                            className: `${modeObject.id === currentMode ? "bg-white text-gray-900 hover:shadow shadow-sm" : "text-gray-700 hover:text-gray-900 hover:bg-white"} relative inline-flex items-center rounded-full px-3 py-1.5 text-sm font-semibold transition hover:shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-500`,
                            children: t(`${modeObject.id}.label`)
                        }, modeObject.id)
                    }))
            })
        ]
    });
}
function $4d158b048a3c62bc$export$2e2bcd8739ae039({ buttonsToShow: buttonsToShow, displayedData: displayedData, displayedComponent: displayedComponent, handleClick: handleClick, handleSync: handleSync, accountSyncStatus: accountSyncStatus, handleSave: handleSave, handlePrevNext: handlePrevNext, afterCancelGoTo: afterCancelGoTo, transformationParams: transformationParams, setTransformationParams: setTransformationParams, handleUndoTransform: handleUndoTransform, hideBottomBorder: hideBottomBorder, showTableFilters: showTableFilters, activeTableFilterCount: activeTableFilterCount, onOpenTableFilters: onOpenTableFilters }) {
    $4d158b048a3c62bc$export$2e2bcd8739ae039.propTypes = {
        buttonsToShow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string).isRequired,
        displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        handleSync: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        accountSyncStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        handleSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        handlePrevNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        afterCancelGoTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        // eslint-disable-next-line react/forbid-prop-types
        transformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
        setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        handleUndoTransform: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        hideBottomBorder: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        showTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        activeTableFilterCount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        onOpenTableFilters: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    };
    $4d158b048a3c62bc$export$2e2bcd8739ae039.defaultProps = {
        handleSync: ()=>{},
        accountSyncStatus: false,
        handleSave: ()=>{},
        handlePrevNext: ()=>{},
        afterCancelGoTo: "table",
        handleUndoTransform: ()=>{},
        hideBottomBorder: false,
        showTableFilters: false,
        activeTableFilterCount: 0,
        onOpenTableFilters: ()=>{}
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    const dashboardModeSelect = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    // FIXME
    const [getPurchaseValueLoading, setGetPurchaseValueLoading] = (0, $7fPBF.useState)(false); // controls the loading state of the historical value calculation for metals
    // TODO go over old buttons bar, there may be more modes / tabs
    // intialise tabs here (get only names for possible tabs from buttonsToShow + settings)
    const tabs = buttonsToShow.filter((b)=>[
            "holdings",
            "cashflow",
            "quotes",
            "settings"
        ].includes(b));
    // this manages active tab -- initialised to whatever position 'holdings' it (or 0)
    const activeTab = tabs.find((x)=>x === displayedData);
    // console.log('activeTab', activeTab, displayedData, buttonsToShow, tabs);
    // intialise modes here (get only names for possible modes from buttonsToShow)
    const modes = buttonsToShow.filter((b)=>[
            "table",
            "grid",
            "import",
            "wizard"
        ].includes(b));
    // this manages active mode -- intialised to whatever position 'table' is
    const [currentMode, setCurrentMode] = (0, $7fPBF.useState)(modes.find((x)=>x === "table") ? "table" : modes[0]);
    // initialise action buttons
    const actionButtons = buttonsToShow.filter((b)=>[
            "save",
            "cancel",
            "sync",
            "decimalChar",
            "headersInRow",
            "infoSave",
            "infoTransformed",
            "historicalValueCalc"
        ].includes(b));
    // add buttons for specific combinations
    if (displayedComponent === "wizard") actionButtons.push("prevNext");
    const definitions = {
        holdings: {
            icon: (0, $4de34f51288f4739$export$2e2bcd8739ae039)
        },
        cashflows: {
            icon: (0, $593bbc998d564df7$export$2e2bcd8739ae039)
        },
        quotes: {
            icon: (0, $e6e78592b1329b53$export$2e2bcd8739ae039)
        },
        settings: {
            icon: (0, $ca2c24a2ba9323a4$export$2e2bcd8739ae039)
        },
        table: {
            icon: (0, $7349b83ead8864ce$export$2e2bcd8739ae039)
        },
        grid: {
            icon: (0, $7349b83ead8864ce$export$2e2bcd8739ae039)
        },
        import: {
            icon: (0, $2c018e30af99d30e$export$2e2bcd8739ae039)
        },
        save: {
            icon: (0, $c4b83d8f86a0d3ca$export$2e2bcd8739ae039)
        },
        sync: {
            icon: (0, $2f41531232608099$export$2e2bcd8739ae039)
        },
        wizard: {
            icon: (0, $dc348e8ecf02df23$export$2e2bcd8739ae039)
        }
    };
    const tabObjectsToShow = tabs.map((tab)=>(0, $9tqwB._)({
            id: tab,
            icon: (definitions[tab] || {}).icon || (0, $7349b83ead8864ce$export$2e2bcd8739ae039)
        }, definitions[tab]));
    const modeObjectsUnsorted = modes.map((modeItem)=>(0, $9tqwB._)({
            id: modeItem
        }, definitions[modeItem]));
    const modeObjectsSorted = [];
    modeObjectsUnsorted.forEach((modeObj)=>{
        if (modeObj.id === "table") modeObjectsSorted.unshift(modeObj);
        else if (modeObj.id === "grid") modeObjectsSorted.splice(1, 0, modeObj);
        else modeObjectsSorted.push(modeObj);
    });
    // console.log('DEBUG', modeObjectsUnsorted, modeObjectsSorted);
    function handleGridGetPurchaseValuesCompleted(event) {
        setGetPurchaseValueLoading(false);
        event.target.removeEventListener("gridGetPurchaseValues", handleGridGetPurchaseValuesCompleted);
    }
    // FIXME handle calculation of historical value for metals
    function handleHistoricalValueCalc() {
        setGetPurchaseValueLoading(true);
        window.dispatchEvent(new CustomEvent("gridGetPurchaseValues")); // this event notifies Grid that it should calculate historical values
        // when Grid is done, it sends this event
        window.addEventListener("handleGridGetPurchaseValuesCompleted", handleGridGetPurchaseValuesCompleted);
    }
    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }
    function handleCancel() {
        handleClick(afterCancelGoTo || "table"); // TODO not sure if table is a good fallback in all use cases
    }
    // TODO orchestrate button actions as in the previous version
    const buttonsProps = {
        activeTab: activeTab,
        currentMode: displayedComponent,
        modeObjectsToShow: modeObjectsSorted,
        actionButtons: actionButtons,
        setCurrentMode: (mode)=>{
            setCurrentMode(mode);
            handleClick(mode);
        },
        handleSync: handleSync,
        accountSyncStatus: accountSyncStatus,
        handleSave: handleSave,
        handlePrevNext: handlePrevNext,
        handleCancel: handleCancel,
        transformationParams: transformationParams,
        setTransformationParams: setTransformationParams,
        handleUndoTransform: handleUndoTransform,
        showTableFilters: showTableFilters,
        activeTableFilterCount: activeTableFilterCount,
        onOpenTableFilters: onOpenTableFilters
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full mb-4",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-1 sm:hidden items-center",
                id: "tabsMobile",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "col-start-1 row-start-1 relative",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                value: activeTab,
                                "aria-label": "Select a tab",
                                className: "w-full appearance-none rounded-lg bg-white py-2 pr-10 pl-3 text-base text-gray-900 border border-gray-400 shadow-sm focus:border-brandBlue-300 focus:ring-2 focus:ring-brandBlue-100 focus:outline-none",
                                onChange: (event)=>handleClick(event.target.value),
                                children: tabObjectsToShow.map((tab)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                        value: tab.id,
                                        children: t(`${tab.id}.label`)
                                    }, tab.id))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $718d5639811dbbc7$export$2e2bcd8739ae039), {
                                "aria-hidden": "true",
                                className: "pointer-events-none absolute inset-y-0 right-3 my-auto h-4 w-4 fill-gray-500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d158b048a3c62bc$var$Buttons, (0, $9tqwB._)({
                        topLevelFormatting: "pt-4",
                        isMobile: true
                    }, buttonsProps))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "hidden sm:block",
                id: "tabsDesktop",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: `${hideBottomBorder ? "" : "border-b border-gray-200 dark:border-white/10"} flex items-center justify-between`,
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                            "aria-label": "Tabs",
                            className: "-mb-px flex space-x-8",
                            children: tabObjectsToShow.map((tab)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                    info: t(`${tab.id}.tooltip`),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "button",
                                        "aria-current": tab.id === activeTab ? "page" : undefined,
                                        onClick: ()=>{
                                            handleClick(tab.id);
                                        },
                                        className: classNames(tab.id === activeTab ? "border-brandBlue-500 text-brandBlue-600" : "border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-900 ", "group inline-flex items-center border-b-2 px-1 py-4 text-sm font-semibold"),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(tab.icon, {
                                                "aria-hidden": "true",
                                                className: classNames(tab.id === activeTab ? "text-brandBlue-500" : "text-gray-700 group-hover:text-gray-900", "hidden lg:block mr-2 -ml-0.5 h-5")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: t(`${tab.id}.label`)
                                            })
                                        ]
                                    }, tab.id)
                                }))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4d158b048a3c62bc$var$Buttons, (0, $9tqwB._)({
                            topLevelFormatting: "ml-4"
                        }, buttonsProps))
                    ]
                })
            })
        ]
    });
}




/**
 * Builds the ordered list of action button IDs shown in account details.
 *
 * @param {string} category - Account category (for example: `deposits`, `metals`, `stocks`).
 * @param {string} displayedComponent - Currently visible component (for example: `table`, `grid`, `settings`).
 * @param {string|null} [displayedData=null] - Active data tab inside the component (for example: `holdings`, `cashflow`, `quotes`, `settings`).
 * @returns {string[]} Ordered button IDs consumed by `ButtonBar`.
 *
 * Import is enabled for (as of 2026-03-04):
 * - holdings: deposits, stocks, loans, realEstate
 * - quotes: theoretically all categories
 */ function $f808db98154b70a0$export$2e2bcd8739ae039(category, displayedComponent, displayedData = null) {
    if (!category || !displayedComponent) console.error("getButtonsToShow: required argument missing. Called with category, displayedComponent", category, displayedComponent);
    // ButtonBar knows to only display 'save' together with 'grid'
    switch(category){
        // deposits have no quotes
        case "deposits":
            switch(displayedComponent){
                case "grid":
                    return [
                        "holdings",
                        "settings",
                        "save",
                        "cancel",
                        "table",
                        "grid",
                        "import"
                    ];
                case "settings":
                    return [
                        "holdings",
                        "settings"
                    ];
                default:
                    return [
                        "holdings",
                        "settings",
                        "table",
                        "grid",
                        "import",
                        "sync"
                    ];
            }
        case "loans":
            switch(displayedComponent){
                case "settings":
                    return [
                        "holdings",
                        "settings"
                    ];
                default:
                    return [
                        "holdings",
                        "settings",
                        "table"
                    ];
            }
        // metals: import is not enabled for holdings, have 'historicalValueCalc' in grid
        case "metals":
        case "objectsOfValue":
            switch(displayedComponent){
                case "grid":
                    return [
                        "holdings",
                        "quotes",
                        "cashflow",
                        "settings",
                        "save",
                        "cancel",
                        "table",
                        "grid"
                    ].concat(category === "metals" ? "historicalValueCalc" : []);
                case "settings":
                    return [
                        "holdings",
                        "quotes",
                        "cashflow",
                        "settings"
                    ];
                // handle table component
                default:
                    if (displayedData === "cashflow") return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings",
                        "table"
                    ];
                    if (displayedData === "quotes") return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "import"
                    ];
                    return [
                        "holdings",
                        "quotes",
                        "cashflow",
                        "settings",
                        "table",
                        "grid"
                    ];
            }
        // there is a wizard instead of grid
        case "unlistedShares":
            switch(displayedData){
                case "holdings":
                case "quotes":
                    {
                        const buttons = [
                            "holdings",
                            "cashflow",
                            "quotes",
                            "settings",
                            "table",
                            "wizard"
                        ];
                        return displayedComponent === "grid" ? buttons.concat([
                            "save",
                            "cancel"
                        ]) : buttons;
                    }
                default:
                    return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings"
                    ];
            }
        // stocks have import for holdings and quotes
        case "stocks":
            switch(displayedComponent){
                case "grid":
                    return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "import",
                        "save",
                        "cancel"
                    ];
                case "settings":
                    return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings"
                    ];
                // handle table component
                default:
                    if (displayedData === "cashflow") return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings"
                    ];
                    return [
                        "holdings",
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "import"
                    ];
            }
        // no holdings
        case "realEstate":
            switch(displayedData){
                case "settings":
                case "cashflow":
                    return [
                        "cashflow",
                        "quotes",
                        "settings"
                    ];
                default:
                    if (displayedComponent === "grid") return [
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "save",
                        "cancel"
                    ];
                    return [
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "import"
                    ];
            }
        case "pension":
            switch(displayedData){
                case "settings":
                case "cashflow":
                    return [
                        "cashflow",
                        "quotes",
                        "settings"
                    ];
                case "quotes":
                    if (displayedComponent === "grid") return [
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "save",
                        "cancel"
                    ];
                    return [
                        "cashflow",
                        "quotes",
                        "settings",
                        "table",
                        "grid",
                        "import"
                    ];
                default:
                    return [
                        "cashflow",
                        "quotes",
                        "settings",
                        "table"
                    ];
            }
        default:
            return [
                "save"
            ];
    }
}


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



const $1d2560ffc929baec$var$DAY_IN_MS = 86400000;
const $1d2560ffc929baec$export$c2e9f8ed4208cb9e = Object.freeze({
    query: "",
    amountDirection: "all",
    dateRange: "all"
});
const $1d2560ffc929baec$var$SUPPORTED_AMOUNT_DIRECTIONS = new Set([
    "all",
    "inflow",
    "outflow",
    "zero"
]);
const $1d2560ffc929baec$var$SUPPORTED_DATE_RANGES = new Set([
    "all",
    "30d",
    "90d",
    "365d"
]);
const $1d2560ffc929baec$var$AMOUNT_KEYS = [
    "amount",
    "valueAccountCurrency",
    "originalAmount",
    "upac",
    "upbc",
    "uptc",
    "value",
    "quote"
];
const $1d2560ffc929baec$var$GROUP_KEYS = [
    "assetId",
    "accountId",
    "providerAssetId"
];
function $1d2560ffc929baec$var$coerceFiniteNumber(value) {
    if (value === null || value === undefined || value === "") return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
}
function $1d2560ffc929baec$var$normalizeQuery(value) {
    return String(value || "").trim();
}
function $1d2560ffc929baec$var$resolveAmount(row) {
    for(let idx = 0; idx < $1d2560ffc929baec$var$AMOUNT_KEYS.length; idx += 1){
        const key = $1d2560ffc929baec$var$AMOUNT_KEYS[idx];
        const value = $1d2560ffc929baec$var$coerceFiniteNumber(row === null || row === void 0 ? void 0 : row[key]);
        if (value !== null) return value;
    }
    return null;
}
function $1d2560ffc929baec$var$resolveDate(row) {
    const raw = row === null || row === void 0 ? void 0 : row.date;
    if (raw === null || raw === undefined || raw === "") return null;
    const parsed = typeof raw === "number" ? raw : Date.parse(raw);
    if (!Number.isFinite(parsed)) return null;
    return parsed;
}
function $1d2560ffc929baec$var$resolveGroupValue(row) {
    for(let idx = 0; idx < $1d2560ffc929baec$var$GROUP_KEYS.length; idx += 1){
        const key = $1d2560ffc929baec$var$GROUP_KEYS[idx];
        if ((row === null || row === void 0 ? void 0 : row[key]) !== undefined && (row === null || row === void 0 ? void 0 : row[key]) !== null && (row === null || row === void 0 ? void 0 : row[key]) !== "") return String(row[key]);
    }
    return null;
}
function $1d2560ffc929baec$var$matchesQuery(row, query) {
    if (!query) return true;
    const loweredQuery = query.toLowerCase();
    const haystack = Object.values(row || {}).filter((value)=>typeof value === "string").join(" ").toLowerCase();
    return haystack.includes(loweredQuery);
}
function $1d2560ffc929baec$var$matchesAmountDirection(row, amountDirection) {
    if (amountDirection === "all") return true;
    const amount = $1d2560ffc929baec$var$resolveAmount(row);
    if (amount === null) return false;
    if (amountDirection === "inflow") return amount > 0;
    if (amountDirection === "outflow") return amount < 0;
    return amount === 0;
}
function $1d2560ffc929baec$var$matchesDateRange(row, dateRange, nowTimestamp) {
    if (dateRange === "all") return true;
    const dateValue = $1d2560ffc929baec$var$resolveDate(row);
    if (dateValue === null) return false;
    let cutoff;
    switch(dateRange){
        case "30d":
            cutoff = nowTimestamp - 30 * $1d2560ffc929baec$var$DAY_IN_MS;
            break;
        case "90d":
            cutoff = nowTimestamp - 90 * $1d2560ffc929baec$var$DAY_IN_MS;
            break;
        case "365d":
            cutoff = nowTimestamp - 365 * $1d2560ffc929baec$var$DAY_IN_MS;
            break;
        default:
            cutoff = null;
    }
    if (cutoff === null) return true;
    return dateValue >= cutoff;
}
function $1d2560ffc929baec$export$61d8575fdad4f70e(filters = {}) {
    const query = $1d2560ffc929baec$var$normalizeQuery(filters.query);
    const amountDirection = $1d2560ffc929baec$var$SUPPORTED_AMOUNT_DIRECTIONS.has(filters.amountDirection) ? filters.amountDirection : $1d2560ffc929baec$export$c2e9f8ed4208cb9e.amountDirection;
    const dateRange = $1d2560ffc929baec$var$SUPPORTED_DATE_RANGES.has(filters.dateRange) ? filters.dateRange : $1d2560ffc929baec$export$c2e9f8ed4208cb9e.dateRange;
    return {
        query: query,
        amountDirection: amountDirection,
        dateRange: dateRange
    };
}
function $1d2560ffc929baec$export$944fd6b196c5afb0(filters = {}) {
    const normalized = $1d2560ffc929baec$export$61d8575fdad4f70e(filters);
    let count = 0;
    if (normalized.query) count += 1;
    if (normalized.amountDirection !== $1d2560ffc929baec$export$c2e9f8ed4208cb9e.amountDirection) count += 1;
    if (normalized.dateRange !== $1d2560ffc929baec$export$c2e9f8ed4208cb9e.dateRange) count += 1;
    return count;
}
function $1d2560ffc929baec$export$9763c81b018cc922(row, filters = {}, nowTimestamp = Date.now()) {
    const normalized = $1d2560ffc929baec$export$61d8575fdad4f70e(filters);
    return $1d2560ffc929baec$var$matchesQuery(row, normalized.query) && $1d2560ffc929baec$var$matchesAmountDirection(row, normalized.amountDirection) && $1d2560ffc929baec$var$matchesDateRange(row, normalized.dateRange, nowTimestamp);
}
function $1d2560ffc929baec$export$78005e5ce36e8bb8(rows = [], filters = {}, nowTimestamp = Date.now()) {
    const normalized = $1d2560ffc929baec$export$61d8575fdad4f70e(filters);
    if ($1d2560ffc929baec$export$944fd6b196c5afb0(normalized) === 0) return rows;
    const matchedGroups = new Set();
    const matchedDetailRows = new Set();
    rows.forEach((row, index)=>{
        if (!row || row.isSummaryRow || row.isTotalRow) return;
        if (!$1d2560ffc929baec$export$9763c81b018cc922(row, normalized, nowTimestamp)) return;
        matchedDetailRows.add(index);
        const groupValue = $1d2560ffc929baec$var$resolveGroupValue(row);
        if (groupValue) matchedGroups.add(groupValue);
    });
    return rows.filter((row, index)=>{
        if (!row) return false;
        if (row.isTotalRow) return false;
        if (row.isSummaryRow) {
            const summaryGroupValue = $1d2560ffc929baec$var$resolveGroupValue(row);
            return summaryGroupValue ? matchedGroups.has(summaryGroupValue) : false;
        }
        return matchedDetailRows.has(index);
    });
}


function $f03d0ce544ea3a95$var$OptionPill({ active: active, onClick: onClick, children: children }) {
    const optionClassName = [
        "w-full rounded-xl px-3 py-2 text-left text-sm font-medium leading-tight transition",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-200",
        "sm:w-auto sm:whitespace-nowrap sm:text-center",
        active ? "bg-brandBlue-600 text-white shadow-sm" : "bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
    ].join(" ");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: optionClassName,
        children: children
    });
}
$f03d0ce544ea3a95$var$OptionPill.propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired
};
$f03d0ce544ea3a95$var$OptionPill.defaultProps = {
    active: false,
    onClick: ()=>{}
};
function $f03d0ce544ea3a95$export$2e2bcd8739ae039({ open: open, currentFilters: currentFilters, onApply: onApply, onCancel: onCancel }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "tableFiltersDialog"
    });
    const [draftFilters, setDraftFilters] = (0, $7fPBF.useState)((0, $1d2560ffc929baec$export$61d8575fdad4f70e)(currentFilters));
    (0, $7fPBF.useEffect)(()=>{
        if (!open) return;
        setDraftFilters((0, $1d2560ffc929baec$export$61d8575fdad4f70e)(currentFilters));
    }, [
        open,
        currentFilters
    ]);
    const hasChanges = (0, $7fPBF.useMemo)(()=>{
        const normalizedCurrent = (0, $1d2560ffc929baec$export$61d8575fdad4f70e)(currentFilters);
        const normalizedDraft = (0, $1d2560ffc929baec$export$61d8575fdad4f70e)(draftFilters);
        return JSON.stringify(normalizedCurrent) !== JSON.stringify(normalizedDraft);
    }, [
        currentFilters,
        draftFilters
    ]);
    const amountOptions = [
        {
            id: "all",
            label: t("amountAny")
        },
        {
            id: "inflow",
            label: t("amountInflow")
        },
        {
            id: "outflow",
            label: t("amountOutflow")
        },
        {
            id: "zero",
            label: t("amountZero")
        }
    ];
    const dateOptions = [
        {
            id: "all",
            label: t("dateAll")
        },
        {
            id: "30d",
            label: t("date30d")
        },
        {
            id: "90d",
            label: t("date90d")
        },
        {
            id: "365d",
            label: t("date365d")
        }
    ];
    const inputClassName = [
        "mt-2 block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 shadow-sm",
        "placeholder:text-gray-400 focus:border-brandBlue-400 focus:outline-none focus:ring-2 focus:ring-brandBlue-100"
    ].join(" ");
    const panelClassName = [
        "mx-2 w-[calc(100vw-1rem)] max-w-xl transform overflow-x-hidden overflow-y-auto rounded-2xl",
        "bg-white p-4 text-left shadow-xl transition-all max-h-[92dvh]",
        "sm:mx-0 sm:w-full sm:p-6"
    ].join(" ");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $7fPBF.Fragment),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed inset-0 z-[80] overflow-y-auto",
            onClose: onCancel,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "min-h-full",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: (0, $7fPBF.Fragment),
                        enter: "ease-out duration-200",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-150",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500/70 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "relative flex min-h-full items-center justify-center p-2 sm:p-4",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                            as: (0, $7fPBF.Fragment),
                            enter: "ease-out duration-200",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-150",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Panel, {
                                className: panelClassName,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Title, {
                                        className: "text-lg font-semibold text-gray-900",
                                        children: t("title")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-1 text-sm text-gray-500",
                                        children: t("description")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-5 space-y-5",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                        htmlFor: "table-filter-query",
                                                        className: "block text-sm font-semibold text-gray-800",
                                                        children: t("searchLabel")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                        id: "table-filter-query",
                                                        type: "text",
                                                        value: draftFilters.query,
                                                        onChange: (event)=>setDraftFilters((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                                                                    query: event.target.value
                                                                })),
                                                        placeholder: t("searchPlaceholder"),
                                                        className: inputClassName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("legend", {
                                                        className: "block text-sm font-semibold text-gray-800",
                                                        children: t("amountLabel")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "mt-2 grid grid-cols-1 gap-2 sm:flex sm:flex-wrap",
                                                        children: amountOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f03d0ce544ea3a95$var$OptionPill, {
                                                                active: draftFilters.amountDirection === option.id,
                                                                onClick: ()=>setDraftFilters((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                                                                            amountDirection: option.id
                                                                        })),
                                                                children: option.label
                                                            }, option.id))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("legend", {
                                                        className: "block text-sm font-semibold text-gray-800",
                                                        children: t("dateLabel")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "mt-2 grid grid-cols-1 gap-2 sm:flex sm:flex-wrap",
                                                        children: dateOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f03d0ce544ea3a95$var$OptionPill, {
                                                                active: draftFilters.dateRange === option.id,
                                                                onClick: ()=>setDraftFilters((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                                                                            dateRange: option.id
                                                                        })),
                                                                children: option.label
                                                            }, option.id))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("reset"),
                                                size: "md",
                                                onClick: ()=>setDraftFilters((0, $9tqwB._)({}, (0, $1d2560ffc929baec$export$c2e9f8ed4208cb9e)))
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("cancel"),
                                                size: "md",
                                                onClick: onCancel
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("apply"),
                                                size: "md",
                                                withAccent: true,
                                                enabled: hasChanges,
                                                onClick: ()=>onApply(draftFilters)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}
$f03d0ce544ea3a95$export$2e2bcd8739ae039.propTypes = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    currentFilters: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        query: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        amountDirection: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        dateRange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }),
    onApply: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$f03d0ce544ea3a95$export$2e2bcd8739ae039.defaultProps = {
    open: false,
    currentFilters: (0, $1d2560ffc929baec$export$c2e9f8ed4208cb9e),
    onApply: ()=>{},
    onCancel: ()=>{}
};



function $8aa5f62c4a0f8e73$export$2e2bcd8739ae039({ account: account, data: data, tableState: tableState, setTableState: setTableState, displayedData: displayedData, displayedComponent: displayedComponent, handleClick: handleClick, handleSync: handleSync, highlightTransactionId: highlightTransactionId, accountSyncStatus: accountSyncStatus }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "tableFilters"
    });
    const tableLayout = (0, $ad7a88cad4bc7af4$export$2e2bcd8739ae039)(account.category, displayedData);
    const [filterDialogOpen, setFilterDialogOpen] = (0, $7fPBF.useState)(false);
    const currentFilters = (0, $1d2560ffc929baec$export$61d8575fdad4f70e)((tableState === null || tableState === void 0 ? void 0 : tableState.filters) || (0, $1d2560ffc929baec$export$c2e9f8ed4208cb9e));
    const activeFilterCount = (0, $1d2560ffc929baec$export$944fd6b196c5afb0)(currentFilters);
    const sourceData = data || [];
    const filteredData = (0, $7fPBF.useMemo)(()=>(0, $1d2560ffc929baec$export$78005e5ce36e8bb8)(sourceData, currentFilters), [
        sourceData,
        currentFilters
    ]);
    function handleOpenFilterDialog() {
        setFilterDialogOpen(true);
    }
    function handleCloseFilterDialog() {
        setFilterDialogOpen(false);
    }
    function handleApplyFilters(newFilters) {
        setTableState((0, $2qxEV._)((0, $9tqwB._)({}, tableState), {
            filters: (0, $1d2560ffc929baec$export$61d8575fdad4f70e)(newFilters)
        }));
        setFilterDialogOpen(false);
    }
    function handleClearFilters() {
        setTableState((0, $2qxEV._)((0, $9tqwB._)({}, tableState), {
            filters: (0, $9tqwB._)({}, (0, $1d2560ffc929baec$export$c2e9f8ed4208cb9e))
        }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                buttonsToShow: (0, $f808db98154b70a0$export$2e2bcd8739ae039)(account.category, displayedComponent, displayedData),
                displayedComponent: "table",
                displayedData: displayedData,
                handleClick: handleClick,
                handleSync: handleSync,
                userChangesPresent: false,
                accountSyncStatus: accountSyncStatus,
                showTableFilters: sourceData.length > 0,
                activeTableFilterCount: activeFilterCount,
                onOpenTableFilters: handleOpenFilterDialog
            }),
            activeFilterCount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mb-2 flex flex-wrap items-center gap-2 text-xs text-gray-600",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "rounded-full bg-brandBlue-50 px-2.5 py-1 text-brandBlue-700",
                        children: t("results", {
                            shown: filteredData.length,
                            total: sourceData.length
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: handleClearFilters,
                        className: "rounded-full border border-gray-300 bg-white px-2.5 py-1 font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-200",
                        children: t("clearAll")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec5b0fbdb8c7bace$export$2e2bcd8739ae039), {
                data: filteredData,
                tableLayout: tableLayout,
                tableState: tableState,
                setTableState: setTableState,
                highlightTransactionId: highlightTransactionId
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f03d0ce544ea3a95$export$2e2bcd8739ae039), {
                open: filterDialogOpen,
                currentFilters: currentFilters,
                onApply: handleApplyFilters,
                onCancel: handleCloseFilterDialog
            })
        ]
    });
}
$8aa5f62c4a0f8e73$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleSync: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    highlightTransactionId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    accountSyncStatus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$8aa5f62c4a0f8e73$export$2e2bcd8739ae039.defaultProps = {
    handleSync: ()=>{},
    accountSyncStatus: false,
    highlightTransactionId: null
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
/* eslint-disable max-len */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $f6d096c4c719df2a$exports = {};
var $8de3fc43dda686a8$exports = {};

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
(function(global, factory) {
    $8de3fc43dda686a8$exports = factory();
})(undefined, function() {
    var jSuites;
    /******/ (function() {
        /******/ var __webpack_modules__ = {
            /***/ 195: /***/ function(module1) {
                (function(global, factory) {
                    module1.exports = factory();
                })(this, function() {
                    return function(str) {
                        function int64(msint_32, lsint_32) {
                            this.highOrder = msint_32;
                            this.lowOrder = lsint_32;
                        }
                        var H = [
                            new int64(0x6a09e667, 0xf3bcc908),
                            new int64(0xbb67ae85, 0x84caa73b),
                            new int64(0x3c6ef372, 0xfe94f82b),
                            new int64(0xa54ff53a, 0x5f1d36f1),
                            new int64(0x510e527f, 0xade682d1),
                            new int64(0x9b05688c, 0x2b3e6c1f),
                            new int64(0x1f83d9ab, 0xfb41bd6b),
                            new int64(0x5be0cd19, 0x137e2179)
                        ];
                        var K = [
                            new int64(0x428a2f98, 0xd728ae22),
                            new int64(0x71374491, 0x23ef65cd),
                            new int64(0xb5c0fbcf, 0xec4d3b2f),
                            new int64(0xe9b5dba5, 0x8189dbbc),
                            new int64(0x3956c25b, 0xf348b538),
                            new int64(0x59f111f1, 0xb605d019),
                            new int64(0x923f82a4, 0xaf194f9b),
                            new int64(0xab1c5ed5, 0xda6d8118),
                            new int64(0xd807aa98, 0xa3030242),
                            new int64(0x12835b01, 0x45706fbe),
                            new int64(0x243185be, 0x4ee4b28c),
                            new int64(0x550c7dc3, 0xd5ffb4e2),
                            new int64(0x72be5d74, 0xf27b896f),
                            new int64(0x80deb1fe, 0x3b1696b1),
                            new int64(0x9bdc06a7, 0x25c71235),
                            new int64(0xc19bf174, 0xcf692694),
                            new int64(0xe49b69c1, 0x9ef14ad2),
                            new int64(0xefbe4786, 0x384f25e3),
                            new int64(0x0fc19dc6, 0x8b8cd5b5),
                            new int64(0x240ca1cc, 0x77ac9c65),
                            new int64(0x2de92c6f, 0x592b0275),
                            new int64(0x4a7484aa, 0x6ea6e483),
                            new int64(0x5cb0a9dc, 0xbd41fbd4),
                            new int64(0x76f988da, 0x831153b5),
                            new int64(0x983e5152, 0xee66dfab),
                            new int64(0xa831c66d, 0x2db43210),
                            new int64(0xb00327c8, 0x98fb213f),
                            new int64(0xbf597fc7, 0xbeef0ee4),
                            new int64(0xc6e00bf3, 0x3da88fc2),
                            new int64(0xd5a79147, 0x930aa725),
                            new int64(0x06ca6351, 0xe003826f),
                            new int64(0x14292967, 0x0a0e6e70),
                            new int64(0x27b70a85, 0x46d22ffc),
                            new int64(0x2e1b2138, 0x5c26c926),
                            new int64(0x4d2c6dfc, 0x5ac42aed),
                            new int64(0x53380d13, 0x9d95b3df),
                            new int64(0x650a7354, 0x8baf63de),
                            new int64(0x766a0abb, 0x3c77b2a8),
                            new int64(0x81c2c92e, 0x47edaee6),
                            new int64(0x92722c85, 0x1482353b),
                            new int64(0xa2bfe8a1, 0x4cf10364),
                            new int64(0xa81a664b, 0xbc423001),
                            new int64(0xc24b8b70, 0xd0f89791),
                            new int64(0xc76c51a3, 0x0654be30),
                            new int64(0xd192e819, 0xd6ef5218),
                            new int64(0xd6990624, 0x5565a910),
                            new int64(0xf40e3585, 0x5771202a),
                            new int64(0x106aa070, 0x32bbd1b8),
                            new int64(0x19a4c116, 0xb8d2d0c8),
                            new int64(0x1e376c08, 0x5141ab53),
                            new int64(0x2748774c, 0xdf8eeb99),
                            new int64(0x34b0bcb5, 0xe19b48a8),
                            new int64(0x391c0cb3, 0xc5c95a63),
                            new int64(0x4ed8aa4a, 0xe3418acb),
                            new int64(0x5b9cca4f, 0x7763e373),
                            new int64(0x682e6ff3, 0xd6b2b8a3),
                            new int64(0x748f82ee, 0x5defb2fc),
                            new int64(0x78a5636f, 0x43172f60),
                            new int64(0x84c87814, 0xa1f0ab72),
                            new int64(0x8cc70208, 0x1a6439ec),
                            new int64(0x90befffa, 0x23631e28),
                            new int64(0xa4506ceb, 0xde82bde9),
                            new int64(0xbef9a3f7, 0xb2c67915),
                            new int64(0xc67178f2, 0xe372532b),
                            new int64(0xca273ece, 0xea26619c),
                            new int64(0xd186b8c7, 0x21c0c207),
                            new int64(0xeada7dd6, 0xcde0eb1e),
                            new int64(0xf57d4f7f, 0xee6ed178),
                            new int64(0x06f067aa, 0x72176fba),
                            new int64(0x0a637dc5, 0xa2c898a6),
                            new int64(0x113f9804, 0xbef90dae),
                            new int64(0x1b710b35, 0x131c471b),
                            new int64(0x28db77f5, 0x23047d84),
                            new int64(0x32caab7b, 0x40c72493),
                            new int64(0x3c9ebe0a, 0x15c9bebc),
                            new int64(0x431d67c4, 0x9c100d4c),
                            new int64(0x4cc5d4be, 0xcb3e42b6),
                            new int64(0x597f299c, 0xfc657e2a),
                            new int64(0x5fcb6fab, 0x3ad6faec),
                            new int64(0x6c44198c, 0x4a475817)
                        ];
                        var W = new Array(64);
                        var a, b, c, d, e, f, g, h, i, j;
                        var T1, T2;
                        var charsize = 8;
                        function utf8_encode(str) {
                            return unescape(encodeURIComponent(str));
                        }
                        function str2binb(str) {
                            var bin = [];
                            var mask = (1 << charsize) - 1;
                            var len = str.length * charsize;
                            for(var i = 0; i < len; i += charsize)bin[i >> 5] |= (str.charCodeAt(i / charsize) & mask) << 32 - charsize - i % 32;
                            return bin;
                        }
                        function binb2hex(binarray) {
                            var hex_tab = "0123456789abcdef";
                            var str = "";
                            var length = binarray.length * 4;
                            var srcByte;
                            for(var i = 0; i < length; i += 1){
                                srcByte = binarray[i >> 2] >> (3 - i % 4) * 8;
                                str += hex_tab.charAt(srcByte >> 4 & 0xF) + hex_tab.charAt(srcByte & 0xF);
                            }
                            return str;
                        }
                        function safe_add_2(x1, y1) {
                            var lsw, msw, lowOrder, highOrder;
                            lsw = (x1.lowOrder & 0xFFFF) + (y1.lowOrder & 0xFFFF);
                            msw = (x1.lowOrder >>> 16) + (y1.lowOrder >>> 16) + (lsw >>> 16);
                            lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;
                            lsw = (x1.highOrder & 0xFFFF) + (y1.highOrder & 0xFFFF) + (msw >>> 16);
                            msw = (x1.highOrder >>> 16) + (y1.highOrder >>> 16) + (lsw >>> 16);
                            highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;
                            return new int64(highOrder, lowOrder);
                        }
                        function safe_add_4(a, b, c, d) {
                            var lsw, msw, lowOrder, highOrder;
                            lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF);
                            msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (lsw >>> 16);
                            lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;
                            lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (msw >>> 16);
                            msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (lsw >>> 16);
                            highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;
                            return new int64(highOrder, lowOrder);
                        }
                        function safe_add_5(a, b, c, d, e) {
                            var lsw, msw, lowOrder, highOrder;
                            lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF) + (e.lowOrder & 0xFFFF);
                            msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (e.lowOrder >>> 16) + (lsw >>> 16);
                            lowOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;
                            lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (e.highOrder & 0xFFFF) + (msw >>> 16);
                            msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (e.highOrder >>> 16) + (lsw >>> 16);
                            highOrder = (msw & 0xFFFF) << 16 | lsw & 0xFFFF;
                            return new int64(highOrder, lowOrder);
                        }
                        function maj(x1, y1, z) {
                            return new int64(x1.highOrder & y1.highOrder ^ x1.highOrder & z.highOrder ^ y1.highOrder & z.highOrder, x1.lowOrder & y1.lowOrder ^ x1.lowOrder & z.lowOrder ^ y1.lowOrder & z.lowOrder);
                        }
                        function ch(x1, y1, z) {
                            return new int64(x1.highOrder & y1.highOrder ^ ~x1.highOrder & z.highOrder, x1.lowOrder & y1.lowOrder ^ ~x1.lowOrder & z.lowOrder);
                        }
                        function rotr(x1, n) {
                            if (n <= 32) return new int64(x1.highOrder >>> n | x1.lowOrder << 32 - n, x1.lowOrder >>> n | x1.highOrder << 32 - n);
                            else return new int64(x1.lowOrder >>> n | x1.highOrder << 32 - n, x1.highOrder >>> n | x1.lowOrder << 32 - n);
                        }
                        function sigma0(x1) {
                            var rotr28 = rotr(x1, 28);
                            var rotr34 = rotr(x1, 34);
                            var rotr39 = rotr(x1, 39);
                            return new int64(rotr28.highOrder ^ rotr34.highOrder ^ rotr39.highOrder, rotr28.lowOrder ^ rotr34.lowOrder ^ rotr39.lowOrder);
                        }
                        function sigma1(x1) {
                            var rotr14 = rotr(x1, 14);
                            var rotr18 = rotr(x1, 18);
                            var rotr41 = rotr(x1, 41);
                            return new int64(rotr14.highOrder ^ rotr18.highOrder ^ rotr41.highOrder, rotr14.lowOrder ^ rotr18.lowOrder ^ rotr41.lowOrder);
                        }
                        function gamma0(x1) {
                            var rotr1 = rotr(x1, 1), rotr8 = rotr(x1, 8), shr7 = shr(x1, 7);
                            return new int64(rotr1.highOrder ^ rotr8.highOrder ^ shr7.highOrder, rotr1.lowOrder ^ rotr8.lowOrder ^ shr7.lowOrder);
                        }
                        function gamma1(x1) {
                            var rotr19 = rotr(x1, 19);
                            var rotr61 = rotr(x1, 61);
                            var shr6 = shr(x1, 6);
                            return new int64(rotr19.highOrder ^ rotr61.highOrder ^ shr6.highOrder, rotr19.lowOrder ^ rotr61.lowOrder ^ shr6.lowOrder);
                        }
                        function shr(x1, n) {
                            if (n <= 32) return new int64(x1.highOrder >>> n, x1.lowOrder >>> n | x1.highOrder << 32 - n);
                            else return new int64(0, x1.highOrder << 32 - n);
                        }
                        var str = utf8_encode(str);
                        var strlen = str.length * charsize;
                        str = str2binb(str);
                        str[strlen >> 5] |= 0x80 << 24 - strlen % 32;
                        str[(strlen + 128 >> 10 << 5) + 31] = strlen;
                        for(var i = 0; i < str.length; i += 32){
                            a = H[0];
                            b = H[1];
                            c = H[2];
                            d = H[3];
                            e = H[4];
                            f = H[5];
                            g = H[6];
                            h = H[7];
                            for(var j = 0; j < 80; j++){
                                if (j < 16) W[j] = new int64(str[j * 2 + i], str[j * 2 + i + 1]);
                                else W[j] = safe_add_4(gamma1(W[j - 2]), W[j - 7], gamma0(W[j - 15]), W[j - 16]);
                                T1 = safe_add_5(h, sigma1(e), ch(e, f, g), K[j], W[j]);
                                T2 = safe_add_2(sigma0(a), maj(a, b, c));
                                h = g;
                                g = f;
                                f = e;
                                e = safe_add_2(d, T1);
                                d = c;
                                c = b;
                                b = a;
                                a = safe_add_2(T1, T2);
                            }
                            H[0] = safe_add_2(a, H[0]);
                            H[1] = safe_add_2(b, H[1]);
                            H[2] = safe_add_2(c, H[2]);
                            H[3] = safe_add_2(d, H[3]);
                            H[4] = safe_add_2(e, H[4]);
                            H[5] = safe_add_2(f, H[5]);
                            H[6] = safe_add_2(g, H[6]);
                            H[7] = safe_add_2(h, H[7]);
                        }
                        var binarray = [];
                        for(var i = 0; i < H.length; i++){
                            binarray.push(H[i].highOrder);
                            binarray.push(H[i].lowOrder);
                        }
                        return binb2hex(binarray);
                    };
                });
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj1, prop) {
                return Object.prototype.hasOwnProperty.call(obj1, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        !function() {
            "use strict";
            // EXPORTS
            __webpack_require__.d(__webpack_exports__, {
                "default": function() {
                    return /* binding */ jsuites;
                }
            });
            // Update dictionary
            var setDictionary = function(d) {
                if (!document.dictionary) document.dictionary = {};
                // Replace the key into the dictionary and append the new ones
                var t = null;
                var i = null;
                var k = Object.keys(d);
                for(i = 0; i < k.length; i++)document.dictionary[k[i]] = d[k[i]];
            };
            // Translate
            var translate = function(t) {
                if (typeof document !== "undefined" && document.dictionary) return document.dictionary[t] || t;
                else return t;
            };
            /* harmony default export */ var dictionary = {
                setDictionary: setDictionary,
                translate: translate
            };
            const Tracking = function(component, state) {
                if (state === true) {
                    window["jSuitesStateControl"] = window["jSuitesStateControl"].filter(function(v) {
                        return v !== null;
                    });
                    // Start after all events
                    setTimeout(function() {
                        window["jSuitesStateControl"].push(component);
                    }, 0);
                } else {
                    var index = window["jSuitesStateControl"].indexOf(component);
                    if (index >= 0) window["jSuitesStateControl"].splice(index, 1);
                }
            };
            /* harmony default export */ var tracking = Tracking;
            var Helpers = {};
            // Two digits
            Helpers.two = function(value) {
                value = "" + value;
                if (value.length == 1) value = "0" + value;
                return value;
            };
            Helpers.focus = function(el) {
                if (el.textContent.length) {
                    // Handle contenteditable elements
                    const range = document.createRange();
                    const sel = window.getSelection();
                    let node = el;
                    // Go as deep as possible to the last text node
                    while(node.lastChild)node = node.lastChild;
                    // Ensure it's a text node
                    if (node.nodeType === Node.TEXT_NODE) range.setStart(node, node.length);
                    else range.setStart(node, node.childNodes.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                    el.scrollLeft = el.scrollWidth;
                }
            };
            Helpers.isNumeric = function(num) {
                if (typeof num === "string") num = num.trim();
                return !isNaN(num) && num !== null && num !== "";
            };
            Helpers.guid = function() {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
                    return v.toString(16);
                });
            };
            Helpers.getNode = function() {
                var node = document.getSelection().anchorNode;
                if (node) return node.nodeType == 3 ? node.parentNode : node;
                else return null;
            };
            /**
 * Generate hash from a string
 */ Helpers.hash = function(str) {
                var hash = 0, i, chr;
                if (str.length === 0) return hash;
                else for(i = 0; i < str.length; i++){
                    chr = str.charCodeAt(i);
                    if (chr > 32) {
                        hash = (hash << 5) - hash + chr;
                        hash |= 0;
                    }
                }
                return hash;
            };
            /**
 * Generate a random color
 */ Helpers.randomColor = function(h) {
                var lum = -0.25;
                var hex = String("#" + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, "");
                if (hex.length < 6) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                var rgb = [], c, i;
                for(i = 0; i < 3; i++){
                    c = parseInt(hex.substr(i * 2, 2), 16);
                    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
                    rgb.push(("00" + c).substr(c.length));
                }
                // Return hex
                if (h == true) return "#" + Helpers.two(rgb[0].toString(16)) + Helpers.two(rgb[1].toString(16)) + Helpers.two(rgb[2].toString(16));
                return rgb;
            };
            Helpers.getWindowWidth = function() {
                var w = window, d = document, e = d.documentElement, g = d.getElementsByTagName("body")[0], x1 = w.innerWidth || e.clientWidth || g.clientWidth;
                return x1;
            };
            Helpers.getWindowHeight = function() {
                var w = window, d = document, e = d.documentElement, g = d.getElementsByTagName("body")[0], y1 = w.innerHeight || e.clientHeight || g.clientHeight;
                return y1;
            };
            Helpers.getPosition = function(e) {
                if (e.changedTouches && e.changedTouches[0]) {
                    var x1 = e.changedTouches[0].pageX;
                    var y1 = e.changedTouches[0].pageY;
                } else {
                    var x1 = window.Event ? e.pageX : e.clientX + (document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft);
                    var y1 = window.Event ? e.pageY : e.clientY + (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop);
                }
                return [
                    x1,
                    y1
                ];
            };
            Helpers.click = function(el) {
                if (el.click) el.click();
                else {
                    var evt = new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    el.dispatchEvent(evt);
                }
            };
            Helpers.findElement = function(element, condition) {
                var foundElement = false;
                function path(element) {
                    if (element && !foundElement) {
                        if (typeof condition == "function") foundElement = condition(element);
                        else if (typeof condition == "string") {
                            if (element.classList && element.classList.contains(condition)) foundElement = element;
                        }
                    }
                    if (element.parentNode && !foundElement) path(element.parentNode);
                }
                path(element);
                return foundElement;
            };
            /* harmony default export */ var helpers = Helpers;
            const isValidPathObj = function(o) {
                return typeof o === "object" || typeof o === "function";
            };
            function Path(pathString, value, remove) {
                // Ensure the path is a valid, non-empty string
                if (typeof pathString !== "string" || pathString.length === 0) return undefined;
                // Split the path into individual keys and filter out empty keys
                const keys = pathString.split(".");
                if (keys.length === 0) return undefined;
                // Start with the root object
                let currentObject = this;
                // Read mode: retrieve a value
                if (typeof value === "undefined" && typeof remove === "undefined") {
                    // Traverse all keys
                    for(let i = 0; i < keys.length; i++){
                        const key = keys[i];
                        // Check if the current object is valid and has the key
                        if (currentObject != null && isValidPathObj(currentObject) && Object.prototype.hasOwnProperty.call(currentObject, key)) currentObject = currentObject[key];
                        else // Return undefined if the path is invalid or currentObject is null/undefined
                        return undefined;
                    }
                    // Return the final value
                    return currentObject;
                }
                // Write mode: set or delete a value
                // Traverse all keys except the last one
                for(let i = 0; i < keys.length - 1; i++){
                    const key = keys[i];
                    // Check if the current object is invalid (null/undefined or non-object)
                    if (currentObject == null || !isValidPathObj(currentObject)) {
                        console.warn(`Cannot set value: path '${pathString}' blocked by invalid object at '${key}'`);
                        return false;
                    }
                    // If the key exists but is null/undefined or a non-object, replace it with an empty object
                    if (Object.prototype.hasOwnProperty.call(currentObject, key) && (currentObject[key] == null || !isValidPathObj(currentObject[key]))) currentObject[key] = {};
                    else if (!Object.prototype.hasOwnProperty.call(currentObject, key)) // If the key doesn't exist, create an empty object
                    currentObject[key] = {};
                    // Move to the next level
                    currentObject = currentObject[key];
                }
                // Handle the final key
                const finalKey = keys[keys.length - 1];
                // Check if the current object is valid for setting/deleting
                if (currentObject == null || !isValidPathObj(currentObject)) return false;
                // Delete the property if remove is true
                if (remove === true) {
                    if (Object.prototype.hasOwnProperty.call(currentObject, finalKey)) {
                        delete currentObject[finalKey];
                        return true;
                    }
                    return false; // Nothing to delete
                }
                // Set the value
                currentObject[finalKey] = value;
                return true;
            }
            function Sorting(el, options) {
                var obj1 = {};
                obj1.options = {};
                var defaults = {
                    pointer: null,
                    direction: null,
                    ondragstart: null,
                    ondragend: null,
                    ondrop: null
                };
                var dragElement = null;
                // Loop through the initial configuration
                for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                else obj1.options[property] = defaults[property];
                el.classList.add("jsorting");
                el.addEventListener("dragstart", function(e) {
                    let target = e.target;
                    if (target.nodeType === 3) {
                        if (target.parentNode.getAttribute("draggable") === "true") target = target.parentNode;
                        else {
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }
                    }
                    if (target.getAttribute("draggable") === "true") {
                        let position = Array.prototype.indexOf.call(target.parentNode.children, target);
                        dragElement = {
                            element: target,
                            o: position,
                            d: position
                        };
                        target.style.opacity = "0.25";
                        if (typeof obj1.options.ondragstart == "function") obj1.options.ondragstart(el, target, e);
                        e.dataTransfer.setDragImage(target, 0, 0);
                    }
                });
                el.addEventListener("dragover", function(e) {
                    e.preventDefault();
                    if (dragElement) {
                        if (getElement(e.target)) {
                            if (e.target.getAttribute("draggable") == "true" && dragElement.element != e.target) {
                                if (!obj1.options.direction) var condition = e.target.clientHeight / 2 > e.offsetY;
                                else var condition = e.target.clientWidth / 2 > e.offsetX;
                                if (condition) e.target.parentNode.insertBefore(dragElement.element, e.target);
                                else e.target.parentNode.insertBefore(dragElement.element, e.target.nextSibling);
                                dragElement.d = Array.prototype.indexOf.call(e.target.parentNode.children, dragElement.element);
                            }
                        }
                    }
                });
                el.addEventListener("dragleave", function(e) {
                    e.preventDefault();
                });
                el.addEventListener("dragend", function(e) {
                    e.preventDefault();
                    if (dragElement) {
                        if (typeof obj1.options.ondragend == "function") obj1.options.ondragend(el, dragElement.element, e);
                        // Cancelled put element to the original position
                        if (dragElement.o < dragElement.d) e.target.parentNode.insertBefore(dragElement.element, e.target.parentNode.children[dragElement.o]);
                        else e.target.parentNode.insertBefore(dragElement.element, e.target.parentNode.children[dragElement.o].nextSibling);
                        dragElement.element.style.opacity = "";
                        dragElement = null;
                    }
                });
                el.addEventListener("drop", function(e) {
                    e.preventDefault();
                    if (dragElement) {
                        if (dragElement.o !== dragElement.d) {
                            if (typeof obj1.options.ondrop == "function") obj1.options.ondrop(el, dragElement.o, dragElement.d, dragElement.element, e.target, e);
                        }
                        dragElement.element.style.opacity = "";
                        dragElement = null;
                    }
                });
                var getElement = function(element) {
                    var sorting = false;
                    function path(element) {
                        if (element.className) {
                            if (element.classList.contains("jsorting")) sorting = true;
                        }
                        if (!sorting) path(element.parentNode);
                    }
                    path(element);
                    return sorting;
                };
                for(var i = 0; i < el.children.length; i++)if (!el.children[i].hasAttribute("draggable")) el.children[i].setAttribute("draggable", "true");
                el.val = function() {
                    var id = null;
                    var data = [];
                    for(var i = 0; i < el.children.length; i++)if (id = el.children[i].getAttribute("data-id")) data.push(id);
                    return data;
                };
                return el;
            }
            function LazyLoading(el, options) {
                var obj1 = {};
                // Mandatory options
                if (!options.loadUp || typeof options.loadUp != "function") options.loadUp = function() {
                    return false;
                };
                if (!options.loadDown || typeof options.loadDown != "function") options.loadDown = function() {
                    return false;
                };
                // Timer ms
                if (!options.timer) options.timer = 100;
                // Timer
                var timeControlLoading = null;
                // Controls
                var scrollControls = function(e) {
                    if (timeControlLoading == null) {
                        var event = false;
                        var scrollTop = el.scrollTop;
                        if (el.scrollTop + el.clientHeight * 2 >= el.scrollHeight) {
                            if (options.loadDown()) {
                                if (scrollTop == el.scrollTop) el.scrollTop = el.scrollTop - el.clientHeight;
                                event = true;
                            }
                        } else if (el.scrollTop <= el.clientHeight) {
                            if (options.loadUp()) {
                                if (scrollTop == el.scrollTop) el.scrollTop = el.scrollTop + el.clientHeight;
                                event = true;
                            }
                        }
                        timeControlLoading = setTimeout(function() {
                            timeControlLoading = null;
                        }, options.timer);
                        if (event) {
                            if (typeof options.onupdate == "function") options.onupdate();
                        }
                    }
                };
                // Onscroll
                el.onscroll = function(e) {
                    scrollControls(e);
                };
                el.onwheel = function(e) {
                    scrollControls(e);
                };
                return obj1;
            }
            function Ajax() {
                var Component = function(options, complete) {
                    if (Array.isArray(options)) {
                        // Create multiple request controller
                        var multiple = {
                            instance: [],
                            complete: complete
                        };
                        if (options.length > 0) for(var i = 0; i < options.length; i++){
                            options[i].multiple = multiple;
                            multiple.instance.push(Component(options[i]));
                        }
                        return multiple;
                    }
                    if (!options.data) options.data = {};
                    if (options.type) options.method = options.type;
                    // Default method
                    if (!options.method) options.method = "GET";
                    // Default type
                    if (!options.dataType) options.dataType = "json";
                    if (options.data) {
                        // Parse object to variables format
                        var parseData = function(value, key) {
                            var vars = [];
                            if (value) {
                                var keys = Object.keys(value);
                                if (keys.length) for(var i = 0; i < keys.length; i++){
                                    if (key) var k = key + "[" + keys[i] + "]";
                                    else var k = keys[i];
                                    if (value[k] instanceof FileList) vars[k] = value[keys[i]];
                                    else if (value[keys[i]] === null || value[keys[i]] === undefined) vars[k] = "";
                                    else if (typeof value[keys[i]] == "object") {
                                        var r = parseData(value[keys[i]], k);
                                        var o = Object.keys(r);
                                        for(var j = 0; j < o.length; j++)vars[o[j]] = r[o[j]];
                                    } else vars[k] = value[keys[i]];
                                }
                            }
                            return vars;
                        };
                        var d = parseData(options.data);
                        var k = Object.keys(d);
                        // Data form
                        if (options.method == "GET") {
                            if (k.length) {
                                var data = [];
                                for(var i = 0; i < k.length; i++)data.push(k[i] + "=" + encodeURIComponent(d[k[i]]));
                                if (options.url.indexOf("?") < 0) options.url += "?";
                                options.url += data.join("&");
                            }
                        } else {
                            var data = new FormData();
                            for(var i = 0; i < k.length; i++)if (d[k[i]] instanceof FileList) {
                                if (d[k[i]].length) for(var j = 0; j < d[k[i]].length; j++)data.append(k[i], d[k[i]][j], d[k[i]][j].name);
                            } else data.append(k[i], d[k[i]]);
                        }
                    }
                    var httpRequest = new XMLHttpRequest();
                    httpRequest.open(options.method, options.url, true);
                    if (options.requestedWith) httpRequest.setRequestHeader("X-Requested-With", options.requestedWith);
                    else if (options.requestedWith !== false) httpRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                    // Content type
                    if (options.contentType) httpRequest.setRequestHeader("Content-Type", options.contentType);
                    // Headers
                    if (options.method === "POST") httpRequest.setRequestHeader("Accept", "application/json");
                    else {
                        if (options.dataType === "blob") httpRequest.responseType = "blob";
                        else if (!options.contentType) {
                            if (options.dataType === "json") httpRequest.setRequestHeader("Content-Type", "text/json");
                            else if (options.dataType === "html") httpRequest.setRequestHeader("Content-Type", "text/html");
                        }
                    }
                    // No cache
                    if (options.cache !== true) {
                        httpRequest.setRequestHeader("pragma", "no-cache");
                        httpRequest.setRequestHeader("cache-control", "no-cache");
                    }
                    // Authentication
                    if (options.withCredentials === true) httpRequest.withCredentials = true;
                    // Before send
                    if (typeof options.beforeSend == "function") options.beforeSend(httpRequest);
                    // Before send
                    if (typeof Component.beforeSend == "function") Component.beforeSend(httpRequest);
                    if (document.ajax && typeof document.ajax.beforeSend == "function") document.ajax.beforeSend(httpRequest);
                    httpRequest.onerror = function() {
                        if (options.error && typeof options.error == "function") options.error({
                            message: "Network error: Unable to reach the server.",
                            status: 0
                        });
                    };
                    httpRequest.ontimeout = function() {
                        if (options.error && typeof options.error == "function") options.error({
                            message: "Request timed out after " + httpRequest.timeout + "ms.",
                            status: 0
                        });
                    };
                    httpRequest.onload = function() {
                        if (httpRequest.status >= 200 && httpRequest.status < 300) {
                            if (options.dataType === "json") try {
                                var result = JSON.parse(httpRequest.responseText);
                                if (options.success && typeof options.success == "function") options.success(result);
                            } catch (err) {
                                if (options.error && typeof options.error == "function") options.error(err, result);
                            }
                            else {
                                if (options.dataType === "blob") var result = httpRequest.response;
                                else var result = httpRequest.responseText;
                                if (options.success && typeof options.success == "function") options.success(result);
                            }
                        } else if (options.error && typeof options.error == "function") options.error(httpRequest.responseText, httpRequest.status);
                        // Global queue
                        if (Component.queue && Component.queue.length > 0) Component.send(Component.queue.shift());
                        // Global complete method
                        if (Component.requests && Component.requests.length) {
                            // Get index of this request in the container
                            var index = Component.requests.indexOf(httpRequest);
                            // Remove from the ajax requests container
                            Component.requests.splice(index, 1);
                            // Deprecated: Last one?
                            if (!Component.requests.length) // Object event
                            {
                                if (options.complete && typeof options.complete == "function") options.complete(result);
                            }
                            // Group requests
                            if (options.group) {
                                if (Component.oncomplete && typeof Component.oncomplete[options.group] == "function") {
                                    if (!Component.pending(options.group)) {
                                        Component.oncomplete[options.group]();
                                        Component.oncomplete[options.group] = null;
                                    }
                                }
                            }
                            // Multiple requests controller
                            if (options.multiple && options.multiple.instance) {
                                // Get index of this request in the container
                                var index = options.multiple.instance.indexOf(httpRequest);
                                // Remove from the ajax requests container
                                options.multiple.instance.splice(index, 1);
                                // If this is the last one call method complete
                                if (!options.multiple.instance.length) {
                                    if (options.multiple.complete && typeof options.multiple.complete == "function") options.multiple.complete(result);
                                }
                            }
                        }
                    };
                    // Keep the options
                    httpRequest.options = options;
                    // Data
                    httpRequest.data = data;
                    // Queue
                    if (options.queue === true && Component.requests.length > 0) Component.queue.push(httpRequest);
                    else Component.send(httpRequest);
                    return httpRequest;
                };
                Component.send = function(httpRequest) {
                    if (httpRequest.data) {
                        if (Array.isArray(httpRequest.data)) httpRequest.send(httpRequest.data.join("&"));
                        else httpRequest.send(httpRequest.data);
                    } else httpRequest.send();
                    Component.requests.push(httpRequest);
                };
                Component.exists = function(url, __callback) {
                    var http = new XMLHttpRequest();
                    http.open("HEAD", url, false);
                    http.send();
                    if (http.status) __callback(http.status);
                };
                Component.pending = function(group) {
                    var n = 0;
                    var o = Component.requests;
                    if (o && o.length) {
                        for(var i = 0; i < o.length; i++)if (!group || group == o[i].options.group) n++;
                    }
                    return n;
                };
                Component.oncomplete = {};
                Component.requests = [];
                Component.queue = [];
                return Component;
            }
            /* harmony default export */ var ajax = Ajax();
            function Animation() {
                const Component = {
                    loading: {}
                };
                Component.loading.show = function(timeout) {
                    if (!Component.loading.element) {
                        Component.loading.element = document.createElement("div");
                        Component.loading.element.className = "jloading";
                    }
                    document.body.appendChild(Component.loading.element);
                    // Max timeout in seconds
                    if (timeout > 0) setTimeout(function() {
                        Component.loading.hide();
                    }, timeout * 1000);
                };
                Component.loading.hide = function() {
                    if (Component.loading.element && Component.loading.element.parentNode) document.body.removeChild(Component.loading.element);
                };
                Component.slideLeft = function(element, direction, done) {
                    if (direction == true) {
                        element.classList.add("jslide-left-in");
                        setTimeout(function() {
                            element.classList.remove("jslide-left-in");
                            if (typeof done == "function") done();
                        }, 400);
                    } else {
                        element.classList.add("jslide-left-out");
                        setTimeout(function() {
                            element.classList.remove("jslide-left-out");
                            if (typeof done == "function") done();
                        }, 400);
                    }
                };
                Component.slideRight = function(element, direction, done) {
                    if (direction === true) {
                        element.classList.add("jslide-right-in");
                        setTimeout(function() {
                            element.classList.remove("jslide-right-in");
                            if (typeof done == "function") done();
                        }, 400);
                    } else {
                        element.classList.add("jslide-right-out");
                        setTimeout(function() {
                            element.classList.remove("jslide-right-out");
                            if (typeof done == "function") done();
                        }, 400);
                    }
                };
                Component.slideTop = function(element, direction, done) {
                    if (direction === true) {
                        element.classList.add("jslide-top-in");
                        setTimeout(function() {
                            element.classList.remove("jslide-top-in");
                            if (typeof done == "function") done();
                        }, 400);
                    } else {
                        element.classList.add("jslide-top-out");
                        setTimeout(function() {
                            element.classList.remove("jslide-top-out");
                            if (typeof done == "function") done();
                        }, 400);
                    }
                };
                Component.slideBottom = function(element, direction, done) {
                    if (direction === true) {
                        element.classList.add("jslide-bottom-in");
                        setTimeout(function() {
                            element.classList.remove("jslide-bottom-in");
                            if (typeof done == "function") done();
                        }, 400);
                    } else {
                        element.classList.add("jslide-bottom-out");
                        setTimeout(function() {
                            element.classList.remove("jslide-bottom-out");
                            if (typeof done == "function") done();
                        }, 100);
                    }
                };
                Component.fadeIn = function(element, done) {
                    element.style.display = "";
                    element.classList.add("jfade-in");
                    setTimeout(function() {
                        element.classList.remove("jfade-in");
                        if (typeof done == "function") done();
                    }, 2000);
                };
                Component.fadeOut = function(element, done) {
                    element.classList.add("jfade-out");
                    setTimeout(function() {
                        element.style.display = "none";
                        element.classList.remove("jfade-out");
                        if (typeof done == "function") done();
                    }, 1000);
                };
                return Component;
            }
            /* harmony default export */ var animation = Animation();
            function HelpersDate() {
                var Component = {};
                Component.now = function(date, dateOnly) {
                    var y1 = null;
                    var m = null;
                    var d = null;
                    var h = null;
                    var i = null;
                    var s = null;
                    if (Array.isArray(date)) {
                        y1 = date[0];
                        m = date[1];
                        d = date[2];
                        h = date[3];
                        i = date[4];
                        s = date[5];
                    } else {
                        if (!date) date = new Date();
                        y1 = date.getFullYear();
                        m = date.getMonth() + 1;
                        d = date.getDate();
                        h = date.getHours();
                        i = date.getMinutes();
                        s = date.getSeconds();
                    }
                    if (dateOnly == true) return helpers.two(y1) + "-" + helpers.two(m) + "-" + helpers.two(d);
                    else return helpers.two(y1) + "-" + helpers.two(m) + "-" + helpers.two(d) + " " + helpers.two(h) + ":" + helpers.two(i) + ":" + helpers.two(s);
                };
                Component.toArray = function(value) {
                    var date = value.split(value.indexOf("T") !== -1 ? "T" : " ");
                    var time = date[1];
                    var date = date[0].split("-");
                    var y1 = parseInt(date[0]);
                    var m = parseInt(date[1]);
                    var d = parseInt(date[2]);
                    var h = 0;
                    var i = 0;
                    if (time) {
                        time = time.split(":");
                        h = parseInt(time[0]);
                        i = parseInt(time[1]);
                    }
                    return [
                        y1,
                        m,
                        d,
                        h,
                        i,
                        0
                    ];
                };
                var excelInitialTime = Date.UTC(1900, 0, 0);
                var excelLeapYearBug = Date.UTC(1900, 1, 29);
                var millisecondsPerDay = 86400000;
                /**
     * Date to number
     */ Component.dateToNum = function(jsDate) {
                    if (typeof jsDate === "string") jsDate = new Date(jsDate + "  GMT+0");
                    var jsDateInMilliseconds = jsDate.getTime();
                    if (jsDateInMilliseconds >= excelLeapYearBug) jsDateInMilliseconds += millisecondsPerDay;
                    jsDateInMilliseconds -= excelInitialTime;
                    return jsDateInMilliseconds / millisecondsPerDay;
                };
                /**
     * Number to date
     *
     * IMPORTANT: Excel incorrectly considers 1900 to be a leap year
     */ Component.numToDate = function(excelSerialNumber) {
                    var jsDateInMilliseconds = excelInitialTime + excelSerialNumber * millisecondsPerDay;
                    if (jsDateInMilliseconds >= excelLeapYearBug) jsDateInMilliseconds -= millisecondsPerDay;
                    const d = new Date(jsDateInMilliseconds);
                    var date = [
                        d.getUTCFullYear(),
                        d.getUTCMonth() + 1,
                        d.getUTCDate(),
                        d.getUTCHours(),
                        d.getUTCMinutes(),
                        d.getUTCSeconds()
                    ];
                    return Component.now(date);
                };
                let weekdays = [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ];
                let months = [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ];
                Object.defineProperty(Component, "weekdays", {
                    get: function() {
                        return weekdays.map(function(v) {
                            return dictionary.translate(v);
                        });
                    }
                });
                Object.defineProperty(Component, "weekdaysShort", {
                    get: function() {
                        return weekdays.map(function(v) {
                            return dictionary.translate(v).substring(0, 3);
                        });
                    }
                });
                Object.defineProperty(Component, "months", {
                    get: function() {
                        return months.map(function(v) {
                            return dictionary.translate(v);
                        });
                    }
                });
                Object.defineProperty(Component, "monthsShort", {
                    get: function() {
                        return months.map(function(v) {
                            return dictionary.translate(v).substring(0, 3);
                        });
                    }
                });
                return Component;
            }
            /* harmony default export */ var helpers_date = HelpersDate();
            function Mask() {
                // Currency
                var tokens = {
                    // Text
                    text: [
                        "@"
                    ],
                    // Currency tokens
                    currency: [
                        "#(.{1})##0?(.{1}0+)?( ?;(.*)?)?",
                        "#"
                    ],
                    // Scientific
                    scientific: [
                        "0{1}(.{1}0+)?E{1}\\+0+"
                    ],
                    // Percentage
                    percentage: [
                        "0{1}(.{1}0+)?%"
                    ],
                    // Number
                    numeric: [
                        "0{1}(.{1}0+)?"
                    ],
                    // Data tokens
                    datetime: [
                        "YYYY",
                        "YYY",
                        "YY",
                        "MMMMM",
                        "MMMM",
                        "MMM",
                        "MM",
                        "DDDDD",
                        "DDDD",
                        "DDD",
                        "DD",
                        "DY",
                        "DAY",
                        "WD",
                        "D",
                        "Q",
                        "MONTH",
                        "MON",
                        "HH24",
                        "HH12",
                        "HH",
                        "\\[H\\]",
                        "H",
                        "AM/PM",
                        "MI",
                        "SS",
                        "MS",
                        "Y",
                        "M"
                    ],
                    // Other
                    general: [
                        "A",
                        "0",
                        "[0-9a-zA-Z$]+",
                        "."
                    ]
                };
                var getDate = function() {
                    if (this.mask.toLowerCase().indexOf("[h]") !== -1) {
                        var m = 0;
                        if (this.date[4]) m = parseFloat(this.date[4] / 60);
                        var v = parseInt(this.date[3]) + m;
                        v /= 24;
                    } else if (!(this.date[0] && this.date[1] && this.date[2]) && (this.date[3] || this.date[4])) v = helpers.two(this.date[3]) + ":" + helpers.two(this.date[4]) + ":" + helpers.two(this.date[5]);
                    else {
                        if (this.date[0] && this.date[1] && !this.date[2]) this.date[2] = 1;
                        v = helpers.two(this.date[0]) + "-" + helpers.two(this.date[1]) + "-" + helpers.two(this.date[2]);
                        if (this.date[3] || this.date[4] || this.date[5]) v += " " + helpers.two(this.date[3]) + ":" + helpers.two(this.date[4]) + ":" + helpers.two(this.date[5]);
                    }
                    return v;
                };
                var extractDate = function() {
                    var v = "";
                    if (!(this.date[0] && this.date[1] && this.date[2]) && (this.date[3] || this.date[4])) {
                        if (this.mask.toLowerCase().indexOf("[h]") !== -1) v = parseInt(this.date[3]);
                        else {
                            let h = parseInt(this.date[3]);
                            if (h < 13 && this.values.indexOf("PM") !== -1) v = (h + 12) % 24;
                            else v = h % 24;
                        }
                        if (this.date[4]) v += parseFloat(this.date[4] / 60);
                        if (this.date[5]) v += parseFloat(this.date[5] / 3600);
                        v /= 24;
                    } else if (this.date[0] || this.date[1] || this.date[2] || this.date[3] || this.date[4] || this.date[5]) {
                        if (this.date[0] && this.date[1] && !this.date[2]) this.date[2] = 1;
                        var t = helpers_date.now(this.date);
                        v = helpers_date.dateToNum(t);
                    }
                    if (isNaN(v)) v = "";
                    return v;
                };
                var isBlank = function(v) {
                    return v === null || v === "" || v === undefined ? true : false;
                };
                var isFormula = function(value) {
                    var v = ("" + value)[0];
                    return v == "=" ? true : false;
                };
                var isNumeric = function(t) {
                    return t === "currency" || t === "percentage" || t === "scientific" || t === "numeric" ? true : false;
                };
                /**
     * Get the decimal defined in the mask configuration
     */ var getDecimal = function(v) {
                    if (v && Number(v) == v) return ".";
                    else {
                        if (this.options.decimal) return this.options.decimal;
                        else if (this.locale) {
                            var t = Intl.NumberFormat(this.locale).format(1.1);
                            return this.options.decimal = t[1];
                        } else {
                            if (!v) v = this.mask;
                            var e = new RegExp("0{1}(.{1})0+", "ig");
                            var t = e.exec(v);
                            if (t && t[1] && t[1].length == 1) {
                                // Save decimal
                                this.options.decimal = t[1];
                                // Return decimal
                                return t[1];
                            } else {
                                // Did not find any decimal last resort the default
                                var e = new RegExp("#{1}(.{1})#+", "ig");
                                var t = e.exec(v);
                                if (t && t[1] && t[1].length == 1) {
                                    if (t[1] === ",") this.options.decimal = ".";
                                    else this.options.decimal = ",";
                                } else this.options.decimal = "1.1".toLocaleString().substring(1, 2);
                            }
                        }
                    }
                    if (this.options.decimal) return this.options.decimal;
                    else return null;
                };
                var ParseValue = function(v, decimal) {
                    if (v == "") return "";
                    // Get decimal
                    if (!decimal) decimal = getDecimal.call(this);
                    // New value
                    v = ("" + v).split(decimal);
                    // Signal
                    var signal = v[0].match(/[-]+/g);
                    if (signal && signal.length) signal = true;
                    else signal = false;
                    v[0] = v[0].match(/[0-9]+/g);
                    if (v[0]) {
                        if (signal) v[0].unshift("-");
                        v[0] = v[0].join("");
                    } else if (signal) v[0] = "-";
                    if (v[0] || v[1]) {
                        if (v[1] !== undefined) {
                            v[1] = v[1].match(/[0-9]+/g);
                            if (v[1]) v[1] = v[1].join("");
                            else v[1] = "";
                        }
                    } else return "";
                    return v;
                };
                var FormatValue = function(v, event) {
                    if (v === "") return "";
                    // Get decimal
                    var d = getDecimal.call(this);
                    // Convert value
                    var o = this.options;
                    // Parse value
                    v = ParseValue.call(this, v);
                    if (v === "") return "";
                    var t = null;
                    // Temporary value
                    if (v[0]) {
                        if (o.style === "percent") t = parseFloat(v[0]) / 100;
                        else t = parseFloat(v[0] + ".1");
                    }
                    if ((v[0] === "-" || v[0] === "-00") && !v[1] && event && event.inputType == "deleteContentBackward") return "";
                    var n = new Intl.NumberFormat(this.locale, o).format(t);
                    n = n.split(d);
                    if (o.style === "percent") {
                        if (n[0].indexOf("%") !== -1) {
                            n[0] = n[0].replace("%", "");
                            n[2] = "%";
                        }
                    }
                    if (typeof n[1] !== "undefined") {
                        var s = n[1].replace(/[0-9]*/g, "");
                        if (s) n[2] = s;
                    }
                    if (v[1] !== undefined) n[1] = d + v[1];
                    else n[1] = "";
                    return n.join("");
                };
                var Format = function(e, event) {
                    var v = Value.call(e);
                    if (!v) return;
                    // Get decimal
                    var n = FormatValue.call(this, v, event);
                    var t = n.length - v.length;
                    var index = Caret.call(e) + t;
                    // Set value and update caret
                    Value.call(e, n, index, true);
                };
                var Extract = function(v) {
                    // Keep the raw value
                    var current = ParseValue.call(this, v);
                    if (current) {
                        // Negative values
                        if (current[0] === "-") current[0] = "-0";
                        return parseFloat(current.join("."));
                    }
                    return null;
                };
                /**
     * Caret getter and setter methods
     */ var Caret = function(index, adjustNumeric) {
                    if (index === undefined) {
                        if (this.tagName == "DIV") {
                            var pos = 0;
                            var s = window.getSelection();
                            if (s) {
                                if (s.rangeCount !== 0) {
                                    var r = s.getRangeAt(0);
                                    var p = r.cloneRange();
                                    p.selectNodeContents(this);
                                    p.setEnd(r.endContainer, r.endOffset);
                                    pos = p.toString().length;
                                }
                            }
                            return pos;
                        } else return this.selectionStart;
                    } else {
                        // Get the current value
                        var n = Value.call(this);
                        // Review the position
                        if (adjustNumeric) {
                            var p = null;
                            for(var i = 0; i < n.length; i++)if (n[i].match(/[\-0-9]/g) || n[i] === "." || n[i] === ",") p = i;
                            // If the string has no numbers
                            if (p === null) p = n.indexOf(" ");
                            if (index >= p) index = p + 1;
                        }
                        // Do not update caret
                        if (index > n.length) index = n.length;
                        if (index) {
                            // Set caret
                            if (this.tagName == "DIV") {
                                var s = window.getSelection();
                                var r = document.createRange();
                                if (this.childNodes[0]) {
                                    r.setStart(this.childNodes[0], index);
                                    s.removeAllRanges();
                                    s.addRange(r);
                                }
                            } else {
                                this.selectionStart = index;
                                this.selectionEnd = index;
                            }
                        }
                    }
                };
                /**
     * Value getter and setter method
     */ var Value = function(v, updateCaret, adjustNumeric) {
                    if (this.tagName == "DIV") {
                        if (v === undefined) {
                            var v = this.innerText;
                            if (this.value && this.value.length > v.length) v = this.value;
                            return v;
                        } else if (this.innerText !== v) {
                            this.innerText = v;
                            if (updateCaret) Caret.call(this, updateCaret, adjustNumeric);
                        }
                    } else {
                        if (v === undefined) return this.value;
                        else if (this.value !== v) {
                            this.value = v;
                            if (updateCaret) Caret.call(this, updateCaret, adjustNumeric);
                        }
                    }
                };
                // Labels
                var weekDaysFull = helpers_date.weekdays;
                var weekDays = helpers_date.weekdaysShort;
                var monthsFull = helpers_date.months;
                var months = helpers_date.monthsShort;
                var parser = {
                    "YEAR": function(v, s) {
                        var y1 = "" + new Date().getFullYear();
                        if (typeof this.values[this.index] === "undefined") this.values[this.index] = "";
                        if (parseInt(v) >= 0 && parseInt(v) <= 10) {
                            if (this.values[this.index].length < s) this.values[this.index] += v;
                        }
                        if (this.values[this.index].length == s) {
                            if (s == 2) var y1 = y1.substr(0, 2) + this.values[this.index];
                            else if (s == 3) var y1 = y1.substr(0, 1) + this.values[this.index];
                            else if (s == 4) var y1 = this.values[this.index];
                            this.date[0] = y1;
                            this.index++;
                        }
                    },
                    "YYYY": function(v) {
                        parser.YEAR.call(this, v, 4);
                    },
                    "YYY": function(v) {
                        parser.YEAR.call(this, v, 3);
                    },
                    "YY": function(v) {
                        parser.YEAR.call(this, v, 2);
                    },
                    "FIND": function(v, a) {
                        if (isBlank(this.values[this.index])) this.values[this.index] = "";
                        if (this.event && this.event.inputType && this.event.inputType.indexOf("delete") > -1) {
                            this.values[this.index] += v;
                            return;
                        }
                        var pos = 0;
                        var count = 0;
                        var value = (this.values[this.index] + v).toLowerCase();
                        for(var i = 0; i < a.length; i++)if (a[i].toLowerCase().indexOf(value) == 0) {
                            pos = i;
                            count++;
                        }
                        if (count > 1) this.values[this.index] += v;
                        else if (count == 1) {
                            // Jump number of chars
                            var t = a[pos].length - this.values[this.index].length - 1;
                            this.position += t;
                            this.values[this.index] = a[pos];
                            this.index++;
                            return pos;
                        }
                    },
                    "MMM": function(v) {
                        var ret = parser.FIND.call(this, v, months);
                        if (ret !== undefined) this.date[1] = ret + 1;
                    },
                    "MON": function(v) {
                        parser["MMM"].call(this, v);
                    },
                    "MMMM": function(v) {
                        var ret = parser.FIND.call(this, v, monthsFull);
                        if (ret !== undefined) this.date[1] = ret + 1;
                    },
                    "MONTH": function(v) {
                        parser["MMMM"].call(this, v);
                    },
                    "MMMMM": function(v) {
                        if (isBlank(this.values[this.index])) this.values[this.index] = "";
                        var pos = 0;
                        var count = 0;
                        var value = (this.values[this.index] + v).toLowerCase();
                        for(var i = 0; i < monthsFull.length; i++)if (monthsFull[i][0].toLowerCase().indexOf(value) == 0) {
                            this.values[this.index] = monthsFull[i][0];
                            this.date[1] = i + 1;
                            this.index++;
                            break;
                        }
                    },
                    "MM": function(v) {
                        if (isBlank(this.values[this.index])) {
                            if (parseInt(v) > 1 && parseInt(v) < 10) {
                                this.date[1] = this.values[this.index] = "0" + v;
                                this.index++;
                            } else if (parseInt(v) < 2) this.values[this.index] = v;
                        } else {
                            if (this.values[this.index] == 1 && parseInt(v) < 3) {
                                this.date[1] = this.values[this.index] += v;
                                this.index++;
                            } else if (this.values[this.index] == 0 && parseInt(v) > 0 && parseInt(v) < 10) {
                                this.date[1] = this.values[this.index] += v;
                                this.index++;
                            }
                        }
                    },
                    "M": function(v) {
                        var test = false;
                        if (parseInt(v) >= 0 && parseInt(v) < 10) {
                            if (isBlank(this.values[this.index])) {
                                this.values[this.index] = v;
                                if (v > 1) {
                                    this.date[1] = this.values[this.index];
                                    this.index++;
                                }
                            } else {
                                if (this.values[this.index] == 1 && parseInt(v) < 3) {
                                    this.date[1] = this.values[this.index] += v;
                                    this.index++;
                                } else if (this.values[this.index] == 0 && parseInt(v) > 0) {
                                    this.date[1] = this.values[this.index] += v;
                                    this.index++;
                                } else var test = true;
                            }
                        } else var test = true;
                        // Re-test
                        if (test == true) {
                            var t = parseInt(this.values[this.index]);
                            if (t > 0 && t < 12) {
                                this.date[1] = this.values[this.index];
                                this.index++;
                                // Repeat the character
                                this.position--;
                            }
                        }
                    },
                    "D": function(v) {
                        var test = false;
                        if (parseInt(v) >= 0 && parseInt(v) < 10) {
                            if (isBlank(this.values[this.index])) {
                                this.values[this.index] = v;
                                if (parseInt(v) > 3) {
                                    this.date[2] = this.values[this.index];
                                    this.index++;
                                }
                            } else {
                                if (this.values[this.index] == 3 && parseInt(v) < 2) {
                                    this.date[2] = this.values[this.index] += v;
                                    this.index++;
                                } else if (this.values[this.index] == 1 || this.values[this.index] == 2) {
                                    this.date[2] = this.values[this.index] += v;
                                    this.index++;
                                } else if (this.values[this.index] == 0 && parseInt(v) > 0) {
                                    this.date[2] = this.values[this.index] += v;
                                    this.index++;
                                } else var test = true;
                            }
                        } else var test = true;
                        // Re-test
                        if (test == true) {
                            var t = parseInt(this.values[this.index]);
                            if (t > 0 && t < 32) {
                                this.date[2] = this.values[this.index];
                                this.index++;
                                // Repeat the character
                                this.position--;
                            }
                        }
                    },
                    "DD": function(v) {
                        if (isBlank(this.values[this.index])) {
                            if (parseInt(v) > 3 && parseInt(v) < 10) {
                                this.date[2] = this.values[this.index] = "0" + v;
                                this.index++;
                            } else if (parseInt(v) < 10) this.values[this.index] = v;
                        } else {
                            if (this.values[this.index] == 3 && parseInt(v) < 2) {
                                this.date[2] = this.values[this.index] += v;
                                this.index++;
                            } else if ((this.values[this.index] == 1 || this.values[this.index] == 2) && parseInt(v) < 10) {
                                this.date[2] = this.values[this.index] += v;
                                this.index++;
                            } else if (this.values[this.index] == 0 && parseInt(v) > 0 && parseInt(v) < 10) {
                                this.date[2] = this.values[this.index] += v;
                                this.index++;
                            }
                        }
                    },
                    "DDD": function(v) {
                        parser.FIND.call(this, v, weekDays);
                    },
                    "DY": function(v) {
                        parser["DDD"].call(this, v);
                    },
                    "DDDD": function(v) {
                        parser.FIND.call(this, v, weekDaysFull);
                    },
                    "DAY": function(v) {
                        parser["DDDD"].call(this, v);
                    },
                    "HH12": function(v, two) {
                        var test = false;
                        if (parseInt(v) >= 0 && parseInt(v) < 10) {
                            if (isBlank(this.values[this.index])) {
                                if (parseInt(v) > 1 && parseInt(v) < 10) {
                                    if (two) v = 0 + v;
                                    this.date[3] = this.values[this.index] = v;
                                    this.index++;
                                } else if (parseInt(v) < 10) this.values[this.index] = v;
                            } else {
                                if (this.values[this.index] == 1 && parseInt(v) < 3) {
                                    this.date[3] = this.values[this.index] += v;
                                    this.index++;
                                } else if (this.values[this.index] < 1 && parseInt(v) < 10) {
                                    this.date[3] = this.values[this.index] += v;
                                    this.index++;
                                } else var test = true;
                            }
                        } else var test = true;
                        // Re-test
                        if (test == true) {
                            var t = parseInt(this.values[this.index]);
                            if (t >= 0 && t <= 12) {
                                this.date[3] = this.values[this.index];
                                this.index++;
                                // Repeat the character
                                this.position--;
                            }
                        }
                    },
                    "HH24": function(v, two) {
                        var test = false;
                        if (parseInt(v) >= 0 && parseInt(v) < 10) {
                            if (this.values[this.index] == null || this.values[this.index] == "") {
                                if (parseInt(v) > 2 && parseInt(v) < 10) {
                                    if (two) v = 0 + v;
                                    this.date[3] = this.values[this.index] = v;
                                    this.index++;
                                } else if (parseInt(v) < 10) this.values[this.index] = v;
                            } else {
                                if (this.values[this.index] == 2 && parseInt(v) < 4) {
                                    if (!two && this.values[this.index] === "0") this.values[this.index] = "";
                                    this.date[3] = this.values[this.index] += v;
                                    this.index++;
                                } else if (this.values[this.index] < 2 && parseInt(v) < 10) {
                                    if (!two && this.values[this.index] === "0") this.values[this.index] = "";
                                    this.date[3] = this.values[this.index] += v;
                                    this.index++;
                                } else var test = true;
                            }
                        } else var test = true;
                        // Re-test
                        if (test == true) {
                            var t = parseInt(this.values[this.index]);
                            if (t >= 0 && t < 24) {
                                this.date[3] = this.values[this.index];
                                this.index++;
                                // Repeat the character
                                this.position--;
                            }
                        }
                    },
                    "HH": function(v) {
                        parser["HH24"].call(this, v, 1);
                    },
                    "H": function(v) {
                        parser["HH24"].call(this, v, 0);
                    },
                    "\\[H\\]": function(v) {
                        if (this.values[this.index] == undefined) this.values[this.index] = "";
                        if (v.match(/[0-9]/g)) this.date[3] = this.values[this.index] += v;
                        else if (this.values[this.index].match(/[0-9]/g)) {
                            this.date[3] = this.values[this.index];
                            this.index++;
                            // Repeat the character
                            this.position--;
                        }
                    },
                    "N60": function(v, i) {
                        if (this.values[this.index] == null || this.values[this.index] == "") {
                            if (parseInt(v) > 5 && parseInt(v) < 10) {
                                this.date[i] = this.values[this.index] = "0" + v;
                                this.index++;
                            } else if (parseInt(v) < 10) this.values[this.index] = v;
                        } else if (parseInt(v) < 10) {
                            this.date[i] = this.values[this.index] += v;
                            this.index++;
                        }
                    },
                    "MI": function(v) {
                        parser.N60.call(this, v, 4);
                    },
                    "SS": function(v) {
                        parser.N60.call(this, v, 5);
                    },
                    "AM/PM": function(v) {
                        if (typeof this.values[this.index] === "undefined") this.values[this.index] = "";
                        if (this.values[this.index] === "") {
                            if (v.match(/a/i) && this.date[3] < 13) this.values[this.index] += "A";
                            else if (v.match(/p/i)) this.values[this.index] += "P";
                        } else if (this.values[this.index] === "A" || this.values[this.index] === "P") {
                            this.values[this.index] += "M";
                            this.index++;
                        }
                    },
                    "WD": function(v) {
                        if (typeof this.values[this.index] === "undefined") this.values[this.index] = "";
                        if (parseInt(v) >= 0 && parseInt(v) < 7) this.values[this.index] = v;
                        if (this.values[this.index].length == 1) this.index++;
                    },
                    "0{1}(.{1}0+)?": function(v) {
                        // Get decimal
                        var decimal = getDecimal.call(this);
                        // Negative number
                        var neg = false;
                        // Create if is blank
                        if (isBlank(this.values[this.index])) this.values[this.index] = "";
                        else if (this.values[this.index] == "-") neg = true;
                        var current = ParseValue.call(this, this.values[this.index], decimal);
                        if (current) this.values[this.index] = current.join(decimal);
                        // New entry
                        if (parseInt(v) >= 0 && parseInt(v) < 10) {
                            // Replace the zero for a number
                            if (this.values[this.index] == "0" && v > 0) this.values[this.index] = "";
                            else if (this.values[this.index] == "-0" && v > 0) this.values[this.index] = "-";
                            // Don't add up zeros because does not mean anything here
                            if (this.values[this.index] != "0" && this.values[this.index] != "-0" || v == decimal) this.values[this.index] += v;
                        } else if (decimal && v == decimal) {
                            if (this.values[this.index].indexOf(decimal) == -1) {
                                if (!this.values[this.index]) this.values[this.index] = "0";
                                this.values[this.index] += v;
                            }
                        } else if (v == "-") // Negative signed
                        neg = true;
                        if (neg === true && this.values[this.index][0] !== "-") this.values[this.index] = "-" + this.values[this.index];
                    },
                    "0{1}(.{1}0+)?E{1}\\+0+": function(v) {
                        parser["0{1}(.{1}0+)?"].call(this, v);
                    },
                    "0{1}(.{1}0+)?%": function(v) {
                        parser["0{1}(.{1}0+)?"].call(this, v);
                        if (this.values[this.index].match(/[\-0-9]/g)) {
                            if (this.values[this.index] && this.values[this.index].indexOf("%") == -1) this.values[this.index] += "%";
                        } else this.values[this.index] = "";
                    },
                    "#(.{1})##0?(.{1}0+)?( ?;(.*)?)?": function(v) {
                        // Parse number
                        parser["0{1}(.{1}0+)?"].call(this, v);
                        // Get decimal
                        var decimal = getDecimal.call(this);
                        // Get separator
                        var separator = this.tokens[this.index].substr(1, 1);
                        // Negative
                        var negative = this.values[this.index][0] === "-" ? true : false;
                        // Current value
                        var current = ParseValue.call(this, this.values[this.index], decimal);
                        // Get main and decimal parts
                        if (current !== "") {
                            // Format number
                            var n = current[0].match(/[0-9]/g);
                            if (n) {
                                // Format
                                n = n.join("");
                                var t = [];
                                var s = 0;
                                for(var j = n.length - 1; j >= 0; j--){
                                    t.push(n[j]);
                                    s++;
                                    if (!(s % 3)) t.push(separator);
                                }
                                t = t.reverse();
                                current[0] = t.join("");
                                if (current[0].substr(0, 1) == separator) current[0] = current[0].substr(1);
                            } else current[0] = "";
                            // Value
                            this.values[this.index] = current.join(decimal);
                            // Negative
                            if (negative) this.values[this.index] = "-" + this.values[this.index];
                        }
                    },
                    "0": function(v) {
                        if (v.match(/[0-9]/g)) {
                            this.values[this.index] = v;
                            this.index++;
                        }
                    },
                    "[0-9a-zA-Z$]+": function(v) {
                        if (isBlank(this.values[this.index])) this.values[this.index] = "";
                        var t = this.tokens[this.index];
                        var s = this.values[this.index];
                        var i = s.length;
                        if (t[i] == v) {
                            this.values[this.index] += v;
                            if (this.values[this.index] == t) this.index++;
                        } else {
                            this.values[this.index] = t;
                            this.index++;
                            if (v.match(/[\-0-9]/g)) // Repeat the character
                            this.position--;
                        }
                    },
                    "A": function(v) {
                        if (v.match(/[a-zA-Z]/gi)) {
                            this.values[this.index] = v;
                            this.index++;
                        }
                    },
                    ".": function(v) {
                        parser["[0-9a-zA-Z$]+"].call(this, v);
                    },
                    "@": function(v) {
                        if (isBlank(this.values[this.index])) this.values[this.index] = "";
                        this.values[this.index] += v;
                    }
                };
                /**
     * Get the tokens in the mask string
     */ var getTokens = function(str) {
                    if (this.type == "general") var t = [].concat(tokens.general);
                    else var t = [].concat(tokens.currency, tokens.datetime, tokens.percentage, tokens.scientific, tokens.numeric, tokens.text, tokens.general);
                    // Expression to extract all tokens from the string
                    var e = new RegExp(t.join("|"), "gi");
                    // Extract
                    return str.match(e);
                };
                /**
     * Get the method of one given token
     */ var getMethod = function(str) {
                    if (!this.type) var types = Object.keys(tokens);
                    else if (this.type == "text") var types = [
                        "text"
                    ];
                    else if (this.type == "general") var types = [
                        "general"
                    ];
                    else if (this.type == "datetime") var types = [
                        "numeric",
                        "datetime",
                        "general"
                    ];
                    else var types = [
                        "currency",
                        "percentage",
                        "scientific",
                        "numeric",
                        "general"
                    ];
                    // Found
                    for(var i = 0; i < types.length; i++){
                        var type = types[i];
                        for(var j = 0; j < tokens[type].length; j++){
                            var e = new RegExp(tokens[type][j], "gi");
                            var r = str.match(e);
                            if (r) return {
                                type: type,
                                method: tokens[type][j]
                            };
                        }
                    }
                };
                /**
     * Identify each method for each token
     */ var getMethods = function(t) {
                    var result = [];
                    for(var i = 0; i < t.length; i++){
                        var m = getMethod.call(this, t[i]);
                        if (m) result.push(m.method);
                        else result.push(null);
                    }
                    // Compatibility with excel
                    for(var i = 0; i < result.length; i++)if (result[i] == "MM") {
                        // Not a month, correct to minutes
                        if (result[i - 1] && result[i - 1].indexOf("H") >= 0) result[i] = "MI";
                        else if (result[i - 2] && result[i - 2].indexOf("H") >= 0) result[i] = "MI";
                        else if (result[i + 1] && result[i + 1].indexOf("S") >= 0) result[i] = "MI";
                        else if (result[i + 2] && result[i + 2].indexOf("S") >= 0) result[i] = "MI";
                    }
                    return result;
                };
                /**
     * Get the type for one given token
     */ var getType = function(str) {
                    var m = getMethod.call(this, str);
                    if (m) var type = m.type;
                    if (type) {
                        var numeric = 0;
                        // Make sure the correct type
                        var t = getTokens.call(this, str);
                        for(var i = 0; i < t.length; i++){
                            m = getMethod.call(this, t[i]);
                            if (m && isNumeric(m.type)) numeric++;
                        }
                        if (numeric > 1) type = "general";
                    }
                    return type;
                };
                /**
     * Parse character per character using the detected tokens in the mask
     */ var parse = function() {
                    // Parser method for this position
                    if (typeof parser[this.methods[this.index]] == "function") {
                        parser[this.methods[this.index]].call(this, this.value[this.position]);
                        this.position++;
                    } else {
                        this.values[this.index] = this.tokens[this.index];
                        this.index++;
                    }
                };
                var toPlainString = function(num) {
                    return ("" + +num).replace(/(-?)(\d*)\.?(\d*)e([+-]\d+)/, function(a, b, c, d, e) {
                        return e < 0 ? b + "0." + Array(1 - e - c.length).join(0) + c + d : b + c + d + Array(e - d.length + 1).join(0);
                    });
                };
                /**
     * Mask function
     * @param {mixed|string} JS input or a string to be parsed
     * @param {object|string} When the first param is a string, the second is the mask or object with the mask options
     */ var obj1 = function(e, config, returnObject) {
                    // Options
                    var r = null;
                    var t = null;
                    var o = {
                        // Element
                        input: null,
                        // Current value
                        value: null,
                        // Mask options
                        options: {},
                        // New values for each token found
                        values: [],
                        // Token position
                        index: 0,
                        // Character position
                        position: 0,
                        // Date raw values
                        date: [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ],
                        // Raw number for the numeric values
                        number: 0
                    };
                    // This is a JavaScript Event
                    if (typeof e == "object") {
                        // Element
                        o.input = e.target;
                        // Current value
                        o.value = Value.call(e.target);
                        // Current caret position
                        o.caret = Caret.call(e.target);
                        // Mask
                        if (t = e.target.getAttribute("data-mask")) o.mask = t;
                        // Type
                        if (t = e.target.getAttribute("data-type")) o.type = t;
                        // Options
                        if (e.target.mask) {
                            if (e.target.mask.options) o.options = e.target.mask.options;
                            if (e.target.mask.locale) o.locale = e.target.mask.locale;
                        } else // Locale
                        if (t = e.target.getAttribute("data-locale")) {
                            o.locale = t;
                            if (o.mask) o.options.style = o.mask;
                        }
                        // Extra configuration
                        if (e.target.attributes && e.target.attributes.length) for(var i = 0; i < e.target.attributes.length; i++){
                            var k = e.target.attributes[i].name;
                            var v = e.target.attributes[i].value;
                            if (k.substr(0, 4) == "data") o.options[k.substr(5)] = v;
                        }
                    } else {
                        // Options
                        if (typeof config == "string") // Mask
                        o.mask = config;
                        else {
                            // Mask
                            var k = Object.keys(config);
                            for(var i = 0; i < k.length; i++)o[k[i]] = config[k[i]];
                        }
                        if (typeof e === "number") {
                            // Get decimal
                            getDecimal.call(o, o.mask);
                            // Replace to the correct decimal
                            e = ("" + e).replace(".", o.options.decimal);
                        }
                        // Current
                        o.value = e;
                        if (o.input) {
                            // Value
                            Value.call(o.input, e);
                            // Focus
                            helpers.focus(o.input);
                            // Caret
                            o.caret = Caret.call(o.input);
                        }
                    }
                    // Mask detected start the process
                    if (!isFormula(o.value) && (o.mask || o.locale)) {
                        // Compatibility fixes
                        if (o.mask) {
                            // Remove []
                            o.mask = o.mask.replace(new RegExp(/\[h]/), "|h|");
                            o.mask = o.mask.replace(new RegExp(/\[.*?\]/), "");
                            o.mask = o.mask.replace(new RegExp(/\|h\|/), "[h]");
                            if (o.mask.indexOf(";") !== -1) {
                                var t = o.mask.split(";");
                                o.mask = t[0];
                            }
                            // Excel mask TODO: Improve
                            if (o.mask.indexOf("##") !== -1) {
                                var d = o.mask.split(";");
                                if (d[0]) {
                                    if (typeof e == "object") {
                                        d[0] = d[0].replace(new RegExp(/_\)/g), "");
                                        d[0] = d[0].replace(new RegExp(/_\(/g), "");
                                    }
                                    d[0] = d[0].replace("*", "	");
                                    d[0] = d[0].replace(new RegExp(/_-/g), "");
                                    d[0] = d[0].replace(new RegExp(/_/g), "");
                                    d[0] = d[0].replace(new RegExp(/"/g), "");
                                    d[0] = d[0].replace("##0.###", "##0.000");
                                    d[0] = d[0].replace("##0.##", "##0.00");
                                    d[0] = d[0].replace("##0.#", "##0.0");
                                    d[0] = d[0].replace("##0,###", "##0,000");
                                    d[0] = d[0].replace("##0,##", "##0,00");
                                    d[0] = d[0].replace("##0,#", "##0,0");
                                }
                                o.mask = d[0];
                            }
                            // Remove back slashes
                            if (o.mask.indexOf("\\") !== -1) {
                                var d = o.mask.split(";");
                                d[0] = d[0].replace(new RegExp(/\\/g), "");
                                o.mask = d[0];
                            }
                            // Get type
                            if (!o.type) o.type = getType.call(o, o.mask);
                            // Get tokens
                            o.tokens = getTokens.call(o, o.mask);
                        }
                        // On new input
                        if (typeof e !== "object" || !e.inputType || !e.inputType.indexOf("insert") || !e.inputType.indexOf("delete")) {
                            // Start transformation
                            if (o.locale) {
                                if (o.input) Format.call(o, o.input, e);
                                else var newValue = FormatValue.call(o, o.value);
                            } else {
                                // Get tokens
                                o.methods = getMethods.call(o, o.tokens);
                                o.event = e;
                                // Go through all tokes
                                while(o.position < o.value.length && typeof o.tokens[o.index] !== "undefined")// Get the appropriate parser
                                parse.call(o);
                                // New value
                                var newValue = o.values.join("");
                                // Add tokens to the end of string only if string is not empty
                                if (isNumeric(o.type) && newValue !== "") {
                                    // Complement things in the end of the mask
                                    while(typeof o.tokens[o.index] !== "undefined"){
                                        var t = getMethod.call(o, o.tokens[o.index]);
                                        if (t && t.type == "general") o.values[o.index] = o.tokens[o.index];
                                        o.index++;
                                    }
                                    var adjustNumeric = true;
                                } else var adjustNumeric = false;
                                // New value
                                newValue = o.values.join("");
                                // Reset value
                                if (o.input) {
                                    t = newValue.length - o.value.length;
                                    if (t > 0) var caret = o.caret + t;
                                    else var caret = o.caret;
                                    Value.call(o.input, newValue, caret, adjustNumeric);
                                }
                            }
                        }
                        // Update raw data
                        if (o.input) {
                            var label = null;
                            if (isNumeric(o.type)) {
                                let v = Value.call(o.input);
                                // Extract the number
                                o.number = Extract.call(o, v);
                                // Keep the raw data as a property of the tag
                                if (o.type == "percentage" && ("" + v).indexOf("%") !== -1) label = obj1.adjustPrecision(o.number / 100);
                                else label = o.number;
                            } else if (o.type == "datetime") {
                                label = getDate.call(o);
                                if (o.date[0] && o.date[1] && o.date[2]) o.input.setAttribute("data-completed", true);
                            }
                            if (label) o.input.setAttribute("data-value", label);
                        }
                        if (newValue !== undefined) {
                            if (returnObject) return o;
                            else return newValue;
                        }
                    }
                };
                obj1.adjustPrecision = function(num) {
                    if (typeof num === "number" && !Number.isInteger(num)) {
                        const v = num.toString().split(".");
                        if (v[1] && v[1].length > 10) {
                            let t0 = 0;
                            const t1 = v[1][v[1].length - 2];
                            if (t1 == 0 || t1 == 9) {
                                for(let i = v[1].length - 2; i > 0; i--)if (t0 >= 0 && v[1][i] == t1) {
                                    t0++;
                                    if (t0 > 6) break;
                                } else {
                                    t0 = 0;
                                    break;
                                }
                                if (t0) return parseFloat(parseFloat(num).toFixed(v[1].length - 1));
                            }
                        }
                    }
                    return num;
                };
                // Get the type of the mask
                obj1.getType = getType;
                // Extract the tokens from a mask
                obj1.prepare = function(str, o) {
                    if (!o) o = {};
                    return getTokens.call(o, str);
                };
                /**
     * Apply the mask to a element (legacy)
     */ obj1.apply = function(e) {
                    var v = Value.call(e.target);
                    if (e.key.length == 1) v += e.key;
                    Value.call(e.target, obj1(v, e.target.getAttribute("data-mask")));
                };
                /**
     * Legacy support
     */ obj1.run = function(value, mask, decimal) {
                    return obj1(value, {
                        mask: mask,
                        decimal: decimal
                    });
                };
                /**
     * Extract number from masked string
     */ obj1.extract = function(v, options, returnObject) {
                    if (isBlank(v)) return v;
                    if (typeof options != "object") return v;
                    else {
                        options = Object.assign({}, options);
                        if (!options.options) options.options = {};
                    }
                    // Compatibility
                    if (!options.mask && options.format) options.mask = options.format;
                    // Remove []
                    if (options.mask) {
                        if (options.mask.indexOf(";") !== -1) {
                            var t = options.mask.split(";");
                            options.mask = t[0];
                        }
                        options.mask = options.mask.replace(new RegExp(/\[h]/), "|h|");
                        options.mask = options.mask.replace(new RegExp(/\[.*?\]/), "");
                        options.mask = options.mask.replace(new RegExp(/\|h\|/), "[h]");
                    }
                    // Get decimal
                    getDecimal.call(options, options.mask);
                    var type = null;
                    var value = null;
                    if (options.type == "percent" || options.options.style == "percent") type = "percentage";
                    else if (options.mask) type = getType.call(options, options.mask);
                    if (type === "text") {
                        var o = {};
                        value = v;
                    } else if (type === "general") {
                        var o = obj1(v, options, true);
                        value = v;
                    } else if (type === "datetime") {
                        if (v instanceof Date) v = obj1.getDateString(v, options.mask);
                        var o = obj1(v, options, true);
                        if (helpers.isNumeric(v)) value = v;
                        else value = extractDate.call(o);
                    } else if (type === "scientific") {
                        value = v;
                        if (typeof v === "string") value = Number(value);
                        var o = options;
                    } else {
                        value = Extract.call(options, v);
                        // Percentage
                        if (type === "percentage" && ("" + v).indexOf("%") !== -1) value /= 100;
                        var o = options;
                    }
                    o.value = value;
                    if (!o.type && type) o.type = type;
                    if (returnObject) return o;
                    else return value;
                };
                /**
     * Render
     */ obj1.render = function(value, options, fullMask, strict) {
                    if (isBlank(value)) return value;
                    if (typeof options != "object") return value;
                    else {
                        options = Object.assign({}, options);
                        if (!options.options) options.options = {};
                    }
                    // Compatibility
                    if (!options.mask && options.format) options.mask = options.format;
                    // Remove []
                    if (options.mask) {
                        if (options.mask.indexOf(";") !== -1) {
                            var t = options.mask.split(";");
                            if (!fullMask) {
                                t[0] = t[0].replace(new RegExp(/_\)/g), "");
                                t[0] = t[0].replace(new RegExp(/_\(/g), "");
                            }
                            options.mask = t[0];
                        }
                        options.mask = options.mask.replace(new RegExp(/\[h]/), "|h|");
                        options.mask = options.mask.replace(new RegExp(/\[.*?\]/), "");
                        options.mask = options.mask.replace(new RegExp(/\|h\|/), "[h]");
                    }
                    var type = null;
                    if (options.type == "percent" || options.options.style == "percent") type = "percentage";
                    else if (options.mask) type = getType.call(options, options.mask);
                    else if (value instanceof Date) type = "datetime";
                    // Fill with blanks
                    var fillWithBlanks = false;
                    if (type == "datetime" || options.type == "calendar") {
                        var t = obj1.getDateString(value, options.mask);
                        if (t) value = t;
                        if (options.mask && fullMask) fillWithBlanks = true;
                    } else if (type === "text") // Parse number
                    {
                        if (typeof value === "number") value = value.toString();
                    } else {
                        // Parse number
                        if (typeof value === "string" && jSuites.isNumeric(value)) value = Number(value);
                        // Percentage
                        if (type === "percentage") value = obj1.adjustPrecision(value * 100);
                        // Number of decimal places
                        if (typeof value === "number") {
                            var t = null;
                            if (options.mask && fullMask) {
                                var d = getDecimal.call(options, options.mask);
                                if (type === "scientific") {
                                    if (options.mask.indexOf(d) !== -1) {
                                        let exp = options.mask.split("E");
                                        exp = exp[0].split(d);
                                        exp = "" + exp[1].match(/[0-9]+/g);
                                        exp = exp.length;
                                        t = value.toExponential(exp);
                                    } else t = value.toExponential(0);
                                } else {
                                    if (options.mask.indexOf(d) !== -1) {
                                        d = options.mask.split(d);
                                        d = "" + d[1].match(/[0-9]+/g);
                                        d = d.length;
                                        t = value.toFixed(d);
                                        let n = value.toString().split(".");
                                        let fraction = n[1];
                                        if (fraction && fraction.length > d && fraction[fraction.length - 1] === "5") t = parseFloat(n[0] + "." + fraction + "1").toFixed(d);
                                    } else t = value.toFixed(0);
                                    // Handle scientific notation
                                    if (("" + t).indexOf("e") !== -1) t = toPlainString(t);
                                }
                            } else if (options.locale && fullMask) {
                                // Append zeros
                                var d = ("" + value).split(".");
                                if (options.options) {
                                    if (typeof d[1] === "undefined") d[1] = "";
                                    var len = d[1].length;
                                    if (options.options.minimumFractionDigits > len) for(var i = 0; i < options.options.minimumFractionDigits - len; i++)d[1] += "0";
                                }
                                if (!d[1].length) t = d[0];
                                else t = d.join(".");
                                var len = d[1].length;
                                if (options.options && options.options.maximumFractionDigits < len) t = parseFloat(t).toFixed(options.options.maximumFractionDigits);
                            } else t = toPlainString(value);
                            if (t !== null) {
                                value = t;
                                // Get decimal
                                getDecimal.call(options, options.mask);
                                // Replace to the correct decimal
                                if (options.options.decimal) value = value.replace(".", options.options.decimal);
                            }
                        } else if (options.mask && fullMask) fillWithBlanks = true;
                    }
                    if (fillWithBlanks) {
                        var s = options.mask.length - value.length;
                        if (s > 0) for(var i = 0; i < s; i++)value += " ";
                    }
                    if (type === "scientific") {
                        if (!fullMask) value = toPlainString(value);
                        else return value;
                    }
                    if (type === "numeric" && strict === false && typeof value === "string") return value;
                    value = obj1(value, options);
                    // Numeric mask, number of zeros
                    if (fullMask && type === "numeric") {
                        var maskZeros = options.mask.match(new RegExp(/^[0]+$/gm));
                        if (maskZeros && maskZeros.length === 1) {
                            var maskLength = maskZeros[0].length;
                            if (maskLength > 3) {
                                value = "" + value;
                                while(value.length < maskLength)value = "0" + value;
                            }
                        }
                    }
                    return value;
                };
                obj1.set = function(e, m) {
                    if (m) {
                        e.setAttribute("data-mask", m);
                        // Reset the value
                        var event = new Event("input", {
                            bubbles: true,
                            cancelable: true
                        });
                        e.dispatchEvent(event);
                    }
                };
                // Helper to extract date from a string
                obj1.extractDateFromString = function(date, format) {
                    var o = obj1(date, {
                        mask: format
                    }, true);
                    // Check if in format Excel (Need difference with format date or type detected is numeric)
                    if (date > 0 && Number(date) == date && (o.values.join("") !== o.value || o.type == "numeric")) {
                        var d = new Date(Math.round((date - 25569) * 86400000));
                        return d.getFullYear() + "-" + helpers.two(d.getMonth()) + "-" + helpers.two(d.getDate()) + " 00:00:00";
                    }
                    var complete = false;
                    if (o.values && o.values.length === o.tokens.length && o.values[o.values.length - 1].length >= o.tokens[o.tokens.length - 1].length) complete = true;
                    if (o.date[0] && o.date[1] && (o.date[2] || complete)) {
                        if (!o.date[2]) o.date[2] = 1;
                        return o.date[0] + "-" + helpers.two(o.date[1]) + "-" + helpers.two(o.date[2]) + " " + helpers.two(o.date[3]) + ":" + helpers.two(o.date[4]) + ":" + helpers.two(o.date[5]);
                    }
                    return "";
                };
                // Helper to convert date into string
                obj1.getDateString = function(value, options) {
                    if (!options) var options = {};
                    // Labels
                    if (options && typeof options == "object") {
                        if (options.format) var format = options.format;
                        else if (options.mask) var format = options.mask;
                    } else var format = options;
                    if (!format) format = "YYYY-MM-DD";
                    // Convert to number of hours
                    if (format.indexOf("[h]") >= 0) {
                        var result = 0;
                        if (value && helpers.isNumeric(value)) {
                            result = parseFloat(24 * Number(value));
                            if (format.indexOf("mm") >= 0) {
                                var h = ("" + result).split(".");
                                if (h[1]) {
                                    var d = 60 * parseFloat("0." + h[1]);
                                    d = parseFloat(d.toFixed(2));
                                } else var d = 0;
                                result = parseInt(h[0]) + ":" + helpers.two(d);
                            }
                        }
                        return result;
                    }
                    // Date instance
                    if (value instanceof Date) value = helpers_date.now(value);
                    else if (value && helpers.isNumeric(value)) value = helpers_date.numToDate(value);
                    // Tokens
                    var tokens = [
                        "DAY",
                        "WD",
                        "DDDD",
                        "DDD",
                        "DD",
                        "D",
                        "Q",
                        "HH24",
                        "HH12",
                        "HH",
                        "H",
                        "AM/PM",
                        "MI",
                        "SS",
                        "MS",
                        "YYYY",
                        "YYY",
                        "YY",
                        "Y",
                        "MONTH",
                        "MON",
                        "MMMMM",
                        "MMMM",
                        "MMM",
                        "MM",
                        "M",
                        "."
                    ];
                    // Expression to extract all tokens from the string
                    var e = new RegExp(tokens.join("|"), "gi");
                    // Extract
                    var t = format.match(e);
                    // Compatibility with excel
                    for(var i = 0; i < t.length; i++)if (t[i].toUpperCase() == "MM") {
                        // Not a month, correct to minutes
                        if (t[i - 1] && t[i - 1].toUpperCase().indexOf("H") >= 0) t[i] = "mi";
                        else if (t[i - 2] && t[i - 2].toUpperCase().indexOf("H") >= 0) t[i] = "mi";
                        else if (t[i + 1] && t[i + 1].toUpperCase().indexOf("S") >= 0) t[i] = "mi";
                        else if (t[i + 2] && t[i + 2].toUpperCase().indexOf("S") >= 0) t[i] = "mi";
                    }
                    // Object
                    var o = {
                        tokens: t
                    };
                    // Value
                    if (value) {
                        var d = "" + value;
                        var splitStr = d.indexOf("T") !== -1 ? "T" : " ";
                        d = d.split(splitStr);
                        var h = 0;
                        var m = 0;
                        var s = 0;
                        if (d[1]) {
                            h = d[1].split(":");
                            m = h[1] ? h[1] : 0;
                            s = h[2] ? h[2] : 0;
                            h = h[0] ? h[0] : 0;
                        }
                        d = d[0].split("-");
                        let day = new Date(d[0], d[1], 0).getDate();
                        if (d[0] && d[1] && d[2] && d[0] > 0 && d[1] > 0 && d[1] < 13 && d[2] > 0 && d[2] <= day) {
                            // Data
                            o.data = [
                                d[0],
                                d[1],
                                d[2],
                                h,
                                m,
                                s
                            ];
                            // Value
                            o.value = [];
                            // Calendar instance
                            var calendar = new Date(o.data[0], o.data[1] - 1, o.data[2], o.data[3], o.data[4], o.data[5]);
                            // Get method
                            var get = function(i) {
                                // Token
                                var t = this.tokens[i];
                                // Case token
                                var s = t.toUpperCase();
                                var v = null;
                                if (s === "YYYY") v = this.data[0];
                                else if (s === "YYY") v = this.data[0].substring(1, 4);
                                else if (s === "YY") v = this.data[0].substring(2, 4);
                                else if (s === "Y") v = this.data[0].substring(3, 4);
                                else if (t === "MON") v = helpers_date.months[calendar.getMonth()].substr(0, 3).toUpperCase();
                                else if (t === "mon") v = helpers_date.months[calendar.getMonth()].substr(0, 3).toLowerCase();
                                else if (t === "MONTH") v = helpers_date.months[calendar.getMonth()].toUpperCase();
                                else if (t === "month") v = helpers_date.months[calendar.getMonth()].toLowerCase();
                                else if (s === "MMMMM") v = helpers_date.months[calendar.getMonth()].substr(0, 1);
                                else if (s === "MMMM" || t === "Month") v = helpers_date.months[calendar.getMonth()];
                                else if (s === "MMM" || t == "Mon") v = helpers_date.months[calendar.getMonth()].substr(0, 3);
                                else if (s === "MM") v = helpers.two(this.data[1]);
                                else if (s === "M") v = calendar.getMonth() + 1;
                                else if (t === "DAY") v = helpers_date.weekdays[calendar.getDay()].toUpperCase();
                                else if (t === "day") v = helpers_date.weekdays[calendar.getDay()].toLowerCase();
                                else if (s === "DDDD" || t == "Day") v = helpers_date.weekdays[calendar.getDay()];
                                else if (s === "DDD") v = helpers_date.weekdays[calendar.getDay()].substr(0, 3);
                                else if (s === "DD") v = helpers.two(this.data[2]);
                                else if (s === "D") v = parseInt(this.data[2]);
                                else if (s === "Q") v = Math.floor((calendar.getMonth() + 3) / 3);
                                else if (s === "HH24" || s === "HH") {
                                    v = this.data[3];
                                    if (v > 12 && this.tokens.indexOf("am/pm") !== -1) v -= 12;
                                    v = helpers.two(v);
                                } else if (s === "HH12") {
                                    if (this.data[3] > 12) v = helpers.two(this.data[3] - 12);
                                    else v = helpers.two(this.data[3]);
                                } else if (s === "H") {
                                    v = this.data[3];
                                    if (v > 12 && this.tokens.indexOf("am/pm") !== -1) {
                                        v -= 12;
                                        v = helpers.two(v);
                                    }
                                } else if (s === "MI") v = helpers.two(this.data[4]);
                                else if (s === "SS") v = helpers.two(this.data[5]);
                                else if (s === "MS") v = calendar.getMilliseconds();
                                else if (s === "AM/PM") {
                                    if (this.data[3] >= 12) v = "PM";
                                    else v = "AM";
                                } else if (s === "WD") v = helpers_date.weekdays[calendar.getDay()];
                                if (v === null) this.value[i] = this.tokens[i];
                                else this.value[i] = v;
                            };
                            for(var i = 0; i < o.tokens.length; i++)get.call(o, i);
                            // Put pieces together
                            value = o.value.join("");
                        } else value = "";
                    }
                    return value;
                };
                return obj1;
            }
            /* harmony default export */ var mask = Mask();
            function Calendar() {
                var Component = function(el, options) {
                    // Already created, update options
                    if (el.calendar) return el.calendar.setOptions(options, true);
                    // New instance
                    var obj1 = {
                        type: "calendar"
                    };
                    obj1.options = {};
                    // Date
                    obj1.date = null;
                    /**
         * Update options
         */ obj1.setOptions = function(options, reset) {
                        // Default configuration
                        var defaults = {
                            // Render type: [ default | year-month-picker ]
                            type: "default",
                            // Restrictions
                            validRange: null,
                            // Starting weekday - 0 for sunday, 6 for saturday
                            startingDay: null,
                            // Date format
                            format: "DD/MM/YYYY",
                            // Allow keyboard date entry
                            readonly: true,
                            // Today is default
                            today: false,
                            // Show timepicker
                            time: false,
                            // Show the reset button
                            resetButton: true,
                            // Placeholder
                            placeholder: "",
                            // Translations can be done here
                            months: helpers_date.monthsShort,
                            monthsFull: helpers_date.months,
                            weekdays: helpers_date.weekdays,
                            textDone: dictionary.translate("Done"),
                            textReset: dictionary.translate("Reset"),
                            textUpdate: dictionary.translate("Update"),
                            // Value
                            value: null,
                            // Fullscreen (this is automatic set for screensize < 800)
                            fullscreen: false,
                            // Create the calendar closed as default
                            opened: false,
                            // Events
                            onopen: null,
                            onclose: null,
                            onchange: null,
                            onupdate: null,
                            // Internal mode controller
                            mode: null,
                            position: null,
                            // Data type
                            dataType: null,
                            // Controls
                            controls: true,
                            // Auto select
                            autoSelect: true
                        };
                        // Loop through our object
                        for(var property in defaults){
                            if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                            else if (typeof obj1.options[property] == "undefined" || reset === true) obj1.options[property] = defaults[property];
                        }
                        // Reset button
                        if (obj1.options.resetButton == false) calendarReset.style.display = "none";
                        else calendarReset.style.display = "";
                        // Readonly
                        if (obj1.options.readonly) el.setAttribute("readonly", "readonly");
                        else el.removeAttribute("readonly");
                        // Placeholder
                        if (obj1.options.placeholder) el.setAttribute("placeholder", obj1.options.placeholder);
                        else el.removeAttribute("placeholder");
                        if (helpers.isNumeric(obj1.options.value) && obj1.options.value > 0) {
                            obj1.options.value = Component.numToDate(obj1.options.value);
                            // Data type numeric
                            obj1.options.dataType = "numeric";
                        }
                        // Texts
                        calendarReset.innerHTML = obj1.options.textReset;
                        calendarConfirm.innerHTML = obj1.options.textDone;
                        calendarControlsUpdateButton.innerHTML = obj1.options.textUpdate;
                        // Define mask
                        if (obj1.options.format) el.setAttribute("data-mask", obj1.options.format.toLowerCase());
                        // Value
                        if (!obj1.options.value && obj1.options.today) var value = Component.now();
                        else var value = obj1.options.value;
                        // Set internal date
                        if (value) {
                            // Force the update
                            obj1.options.value = null;
                            // New value
                            obj1.setValue(value);
                        }
                        return obj1;
                    };
                    /**
         * Open the calendar
         */ obj1.open = function(value) {
                        if (!calendar.classList.contains("jcalendar-focus")) {
                            if (!calendar.classList.contains("jcalendar-inline")) {
                                // Current
                                Component.current = obj1;
                                // Start tracking
                                tracking(obj1, true);
                                // Create the days
                                obj1.getDays();
                                // Render months
                                if (obj1.options.type == "year-month-picker") obj1.getMonths();
                                // Get time
                                if (obj1.options.time) {
                                    calendarSelectHour.value = obj1.date[3];
                                    calendarSelectMin.value = obj1.date[4];
                                }
                                // Show calendar
                                calendar.classList.add("jcalendar-focus");
                                // Get the position of the corner helper
                                if (helpers.getWindowWidth() < 800 || obj1.options.fullscreen) {
                                    calendar.classList.add("jcalendar-fullsize");
                                    // Animation
                                    animation.slideBottom(calendarContent, 1);
                                } else {
                                    calendar.classList.remove("jcalendar-fullsize");
                                    var rect = el.getBoundingClientRect();
                                    var rectContent = calendarContent.getBoundingClientRect();
                                    if (obj1.options.position) {
                                        calendarContainer.style.position = "fixed";
                                        if (window.innerHeight < rect.bottom + rectContent.height) calendarContainer.style.top = rect.top - (rectContent.height + 2) + "px";
                                        else calendarContainer.style.top = rect.top + rect.height + 2 + "px";
                                        calendarContainer.style.left = rect.left + "px";
                                    } else {
                                        if (window.innerHeight < rect.bottom + rectContent.height) {
                                            var d = -1 * (rect.height + rectContent.height + 2);
                                            if (d + rect.top < 0) d = -1 * (rect.top + rect.height);
                                            calendarContainer.style.top = d + "px";
                                        } else calendarContainer.style.top = "2px";
                                        if (window.innerWidth < rect.left + rectContent.width) {
                                            var d = window.innerWidth - (rect.left + rectContent.width + 20);
                                            calendarContainer.style.left = d + "px";
                                        } else calendarContainer.style.left = "0px";
                                    }
                                }
                                // Events
                                if (typeof obj1.options.onopen == "function") obj1.options.onopen(el);
                            }
                        }
                    };
                    obj1.close = function(ignoreEvents, update) {
                        if (obj1.options.autoSelect !== true && typeof update === "undefined") update = false;
                        if (calendar.classList.contains("jcalendar-focus")) {
                            if (update !== false) {
                                var element = calendar.querySelector(".jcalendar-selected");
                                if (typeof update == "string") var value = update;
                                else if (!element || element.classList.contains("jcalendar-disabled")) var value = obj1.options.value;
                                else var value = obj1.getValue();
                                obj1.setValue(value);
                            } else {
                                let value = obj1.options.value || "";
                                obj1.options.value = null;
                                obj1.setValue(value);
                            }
                            // Events
                            if (!ignoreEvents && typeof obj1.options.onclose == "function") obj1.options.onclose(el);
                            // Hide
                            calendar.classList.remove("jcalendar-focus");
                            // Stop tracking
                            tracking(obj1, false);
                            // Current
                            Component.current = null;
                        }
                        return obj1.options.value;
                    };
                    obj1.prev = function() {
                        // Check if the visualization is the days picker or years picker
                        if (obj1.options.mode == "years") {
                            obj1.date[0] = obj1.date[0] - 12;
                            // Update picker table of days
                            obj1.getYears();
                        } else if (obj1.options.mode == "months") {
                            obj1.date[0] = parseInt(obj1.date[0]) - 1;
                            // Update picker table of months
                            obj1.getMonths();
                        } else {
                            // Go to the previous month
                            if (obj1.date[1] < 2) {
                                obj1.date[0] = obj1.date[0] - 1;
                                obj1.date[1] = 12;
                            } else obj1.date[1] = obj1.date[1] - 1;
                            // Update picker table of days
                            obj1.getDays();
                        }
                    };
                    obj1.next = function() {
                        // Check if the visualization is the days picker or years picker
                        if (obj1.options.mode == "years") {
                            obj1.date[0] = parseInt(obj1.date[0]) + 12;
                            // Update picker table of days
                            obj1.getYears();
                        } else if (obj1.options.mode == "months") {
                            obj1.date[0] = parseInt(obj1.date[0]) + 1;
                            // Update picker table of months
                            obj1.getMonths();
                        } else {
                            // Go to the previous month
                            if (obj1.date[1] > 11) {
                                obj1.date[0] = parseInt(obj1.date[0]) + 1;
                                obj1.date[1] = 1;
                            } else obj1.date[1] = parseInt(obj1.date[1]) + 1;
                            // Update picker table of days
                            obj1.getDays();
                        }
                    };
                    /**
         * Set today
         */ obj1.setToday = function() {
                        // Today
                        var value = new Date().toISOString().substr(0, 10);
                        // Change value
                        obj1.setValue(value);
                        // Value
                        return value;
                    };
                    obj1.setValue = function(val) {
                        if (!val) val = "" + val;
                        // Values
                        var newValue = val;
                        var oldValue = obj1.options.value;
                        if (oldValue != newValue) {
                            // Set label
                            if (!newValue) {
                                obj1.date = null;
                                var val = "";
                                el.classList.remove("jcalendar_warning");
                                el.title = "";
                            } else {
                                var value = obj1.setLabel(newValue, obj1.options);
                                var date = newValue.split(" ");
                                if (!date[1]) date[1] = "00:00:00";
                                var time = date[1].split(":");
                                var date = date[0].split("-");
                                var y1 = parseInt(date[0]);
                                var m = parseInt(date[1]);
                                var d = parseInt(date[2]);
                                var h = parseInt(time[0]);
                                var i = parseInt(time[1]);
                                obj1.date = [
                                    y1,
                                    m,
                                    d,
                                    h,
                                    i,
                                    0
                                ];
                                var val = obj1.setLabel(newValue, obj1.options);
                                // Current selection day
                                var current = Component.now(new Date(y1, m - 1, d), true);
                                // Available ranges
                                if (obj1.options.validRange) {
                                    if (!obj1.options.validRange[0] || current >= obj1.options.validRange[0]) var test1 = true;
                                    else var test1 = false;
                                    if (!obj1.options.validRange[1] || current <= obj1.options.validRange[1]) var test2 = true;
                                    else var test2 = false;
                                    if (!(test1 && test2)) {
                                        el.classList.add("jcalendar_warning");
                                        el.title = dictionary.translate("Date outside the valid range");
                                    } else {
                                        el.classList.remove("jcalendar_warning");
                                        el.title = "";
                                    }
                                } else {
                                    el.classList.remove("jcalendar_warning");
                                    el.title = "";
                                }
                            }
                            // New value
                            obj1.options.value = newValue;
                            if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, newValue, oldValue);
                            // Lemonade JS
                            if (el.value != val) {
                                el.value = val;
                                if (typeof el.oninput == "function") el.oninput({
                                    type: "input",
                                    target: el,
                                    value: el.value
                                });
                            }
                        }
                        if (obj1.date) {
                            obj1.getDays();
                            // Render months
                            if (obj1.options.type == "year-month-picker") obj1.getMonths();
                        }
                    };
                    obj1.getValue = function() {
                        if (obj1.date) {
                            if (obj1.options.time) return helpers.two(obj1.date[0]) + "-" + helpers.two(obj1.date[1]) + "-" + helpers.two(obj1.date[2]) + " " + helpers.two(obj1.date[3]) + ":" + helpers.two(obj1.date[4]) + ":" + helpers.two(0);
                            else return helpers.two(obj1.date[0]) + "-" + helpers.two(obj1.date[1]) + "-" + helpers.two(obj1.date[2]) + " " + helpers.two(0) + ":" + helpers.two(0) + ":" + helpers.two(0);
                        } else return "";
                    };
                    /**
         *  Calendar
         */ obj1.update = function(element, v) {
                        if (element.classList.contains("jcalendar-disabled")) ;
                        else {
                            var elements = calendar.querySelector(".jcalendar-selected");
                            if (elements) elements.classList.remove("jcalendar-selected");
                            element.classList.add("jcalendar-selected");
                            if (element.classList.contains("jcalendar-set-month")) {
                                obj1.date[1] = v;
                                obj1.date[2] = 1; // first day of the month
                            } else obj1.date[2] = element.innerText;
                            if (!obj1.options.time) obj1.close(null, true);
                            else {
                                obj1.date[3] = calendarSelectHour.value;
                                obj1.date[4] = calendarSelectMin.value;
                            }
                        }
                        // Update
                        updateActions();
                    };
                    /**
         * Set to blank
         */ obj1.reset = function() {
                        // Close calendar
                        obj1.setValue("");
                        obj1.date = null;
                        obj1.close(false, false);
                    };
                    /**
         * Get calendar days
         */ obj1.getDays = function() {
                        // Mode
                        obj1.options.mode = "days";
                        // Setting current values in case of NULLs
                        var date = new Date();
                        // Current selection
                        var year = obj1.date && helpers.isNumeric(obj1.date[0]) ? obj1.date[0] : parseInt(date.getFullYear());
                        var month = obj1.date && helpers.isNumeric(obj1.date[1]) ? obj1.date[1] : parseInt(date.getMonth()) + 1;
                        var day = obj1.date && helpers.isNumeric(obj1.date[2]) ? obj1.date[2] : parseInt(date.getDate());
                        var hour = obj1.date && helpers.isNumeric(obj1.date[3]) ? obj1.date[3] : parseInt(date.getHours());
                        var min = obj1.date && helpers.isNumeric(obj1.date[4]) ? obj1.date[4] : parseInt(date.getMinutes());
                        // Selection container
                        obj1.date = [
                            year,
                            month,
                            day,
                            hour,
                            min,
                            0
                        ];
                        // Update title
                        calendarLabelYear.innerHTML = year;
                        calendarLabelMonth.innerHTML = obj1.options.months[month - 1];
                        // Current month and Year
                        var isCurrentMonthAndYear = date.getMonth() == month - 1 && date.getFullYear() == year ? true : false;
                        var currentDay = date.getDate();
                        // Number of days in the month
                        var date = new Date(year, month, 0, 0, 0);
                        var numberOfDays = date.getDate();
                        // First day
                        var date = new Date(year, month - 1, 0, 0, 0);
                        var firstDay = date.getDay() + 1;
                        // Index value
                        var index = obj1.options.startingDay || 0;
                        // First of day relative to the starting calendar weekday
                        firstDay = firstDay - index;
                        // Reset table
                        calendarBody.innerHTML = "";
                        // Weekdays Row
                        var row = document.createElement("tr");
                        row.setAttribute("align", "center");
                        calendarBody.appendChild(row);
                        // Create weekdays row
                        for(var i = 0; i < 7; i++){
                            var cell = document.createElement("td");
                            cell.classList.add("jcalendar-weekday");
                            cell.innerHTML = obj1.options.weekdays[index].substr(0, 1);
                            row.appendChild(cell);
                            // Next week day
                            index++;
                            // Restart index
                            if (index > 6) index = 0;
                        }
                        // Index of days
                        var index = 0;
                        var d = 0;
                        // Calendar table
                        for(var j = 0; j < 6; j++){
                            // Reset cells container
                            var row = document.createElement("tr");
                            row.setAttribute("align", "center");
                            row.style.height = "34px";
                            // Create cells
                            for(var i = 0; i < 7; i++){
                                // Create cell
                                var cell = document.createElement("td");
                                cell.classList.add("jcalendar-set-day");
                                if (index >= firstDay && index < firstDay + numberOfDays) {
                                    // Day cell
                                    d++;
                                    cell.innerHTML = d;
                                    // Selected
                                    if (d == day) cell.classList.add("jcalendar-selected");
                                    // Current selection day is today
                                    if (isCurrentMonthAndYear && currentDay == d) cell.style.fontWeight = "bold";
                                    // Current selection day
                                    var current = Component.now(new Date(year, month - 1, d), true);
                                    // Available ranges
                                    if (obj1.options.validRange) {
                                        if (!obj1.options.validRange[0] || current >= obj1.options.validRange[0]) var test1 = true;
                                        else var test1 = false;
                                        if (!obj1.options.validRange[1] || current <= obj1.options.validRange[1]) var test2 = true;
                                        else var test2 = false;
                                        if (!(test1 && test2)) cell.classList.add("jcalendar-disabled");
                                    }
                                }
                                // Day cell
                                row.appendChild(cell);
                                // Index
                                index++;
                            }
                            // Add cell to the calendar body
                            calendarBody.appendChild(row);
                        }
                        // Show time controls
                        if (obj1.options.time) calendarControlsTime.style.display = "";
                        else calendarControlsTime.style.display = "none";
                        // Update
                        updateActions();
                    };
                    obj1.getMonths = function() {
                        // Mode
                        obj1.options.mode = "months";
                        // Loading month labels
                        var months = obj1.options.months;
                        // Value
                        var value = obj1.options.value;
                        // Current date
                        var date = new Date();
                        var currentYear = parseInt(date.getFullYear());
                        var currentMonth = parseInt(date.getMonth()) + 1;
                        var selectedYear = obj1.date && helpers.isNumeric(obj1.date[0]) ? obj1.date[0] : currentYear;
                        var selectedMonth = obj1.date && helpers.isNumeric(obj1.date[1]) ? obj1.date[1] : currentMonth;
                        // Update title
                        calendarLabelYear.innerHTML = obj1.date[0];
                        calendarLabelMonth.innerHTML = months[selectedMonth - 1];
                        // Table
                        var table = document.createElement("table");
                        table.setAttribute("width", "100%");
                        // Row
                        var row = null;
                        // Calendar table
                        for(var i = 0; i < 12; i++){
                            if (!(i % 4)) {
                                // Reset cells container
                                var row = document.createElement("tr");
                                row.setAttribute("align", "center");
                                table.appendChild(row);
                            }
                            // Create cell
                            var cell = document.createElement("td");
                            cell.classList.add("jcalendar-set-month");
                            cell.setAttribute("data-value", i + 1);
                            cell.innerText = months[i];
                            if (obj1.options.validRange) {
                                var current = selectedYear + "-" + helpers.two(i + 1);
                                if (!obj1.options.validRange[0] || current >= obj1.options.validRange[0].substr(0, 7)) var test1 = true;
                                else var test1 = false;
                                if (!obj1.options.validRange[1] || current <= obj1.options.validRange[1].substr(0, 7)) var test2 = true;
                                else var test2 = false;
                                if (!(test1 && test2)) cell.classList.add("jcalendar-disabled");
                            }
                            if (i + 1 == selectedMonth) cell.classList.add("jcalendar-selected");
                            if (currentYear == selectedYear && i + 1 == currentMonth) cell.style.fontWeight = "bold";
                            row.appendChild(cell);
                        }
                        calendarBody.innerHTML = '<tr><td colspan="7"></td></tr>';
                        calendarBody.children[0].children[0].appendChild(table);
                        // Update
                        updateActions();
                    };
                    obj1.getYears = function() {
                        // Mode
                        obj1.options.mode = "years";
                        // Current date
                        var date = new Date();
                        var currentYear = date.getFullYear();
                        var selectedYear = obj1.date && helpers.isNumeric(obj1.date[0]) ? obj1.date[0] : parseInt(date.getFullYear());
                        // Array of years
                        var y1 = [];
                        for(var i = 0; i < 25; i++)y1[i] = parseInt(obj1.date[0]) + (i - 12);
                        // Assembling the year tables
                        var table = document.createElement("table");
                        table.setAttribute("width", "100%");
                        for(var i = 0; i < 25; i++){
                            if (!(i % 5)) {
                                // Reset cells container
                                var row = document.createElement("tr");
                                row.setAttribute("align", "center");
                                table.appendChild(row);
                            }
                            // Create cell
                            var cell = document.createElement("td");
                            cell.classList.add("jcalendar-set-year");
                            cell.innerText = y1[i];
                            if (selectedYear == y1[i]) cell.classList.add("jcalendar-selected");
                            if (currentYear == y1[i]) cell.style.fontWeight = "bold";
                            row.appendChild(cell);
                        }
                        calendarBody.innerHTML = '<tr><td colspan="7"></td></tr>';
                        calendarBody.firstChild.firstChild.appendChild(table);
                        // Update
                        updateActions();
                    };
                    obj1.setLabel = function(value, mixed) {
                        return Component.getDateString(value, mixed);
                    };
                    obj1.fromFormatted = function(value, format) {
                        return Component.extractDateFromString(value, format);
                    };
                    var mouseUpControls = function(e) {
                        var element = helpers.findElement(e.target, "jcalendar-container");
                        if (element) {
                            var action = e.target.className;
                            // Object id
                            if (action == "jcalendar-prev") obj1.prev();
                            else if (action == "jcalendar-next") obj1.next();
                            else if (action == "jcalendar-month") obj1.getMonths();
                            else if (action == "jcalendar-year") obj1.getYears();
                            else if (action == "jcalendar-set-year") {
                                obj1.date[0] = e.target.innerText;
                                if (obj1.options.type == "year-month-picker") obj1.getMonths();
                                else obj1.getDays();
                            } else if (e.target.classList.contains("jcalendar-set-month")) {
                                var month = parseInt(e.target.getAttribute("data-value"));
                                if (obj1.options.type == "year-month-picker") obj1.update(e.target, month);
                                else {
                                    obj1.date[1] = month;
                                    obj1.getDays();
                                }
                            } else if (action == "jcalendar-confirm" || action == "jcalendar-update" || action == "jcalendar-close") obj1.close(null, true);
                            else if (action == "jcalendar-backdrop") obj1.close(false, false);
                            else if (action == "jcalendar-reset") obj1.reset();
                            else if (e.target.classList.contains("jcalendar-set-day") && e.target.innerText) obj1.update(e.target);
                        } else obj1.close(false, false);
                    };
                    var keyUpControls = function(e) {
                        if (e.target.value && e.target.value.length > 3) {
                            var test = Component.extractDateFromString(e.target.value, obj1.options.format);
                            if (test) obj1.setValue(test);
                        }
                    };
                    // Update actions button
                    var updateActions = function() {
                        var currentDay = calendar.querySelector(".jcalendar-selected");
                        if (currentDay && currentDay.classList.contains("jcalendar-disabled")) {
                            calendarControlsUpdateButton.setAttribute("disabled", "disabled");
                            calendarSelectHour.setAttribute("disabled", "disabled");
                            calendarSelectMin.setAttribute("disabled", "disabled");
                        } else {
                            calendarControlsUpdateButton.removeAttribute("disabled");
                            calendarSelectHour.removeAttribute("disabled");
                            calendarSelectMin.removeAttribute("disabled");
                        }
                        // Event
                        if (typeof obj1.options.onupdate == "function") obj1.options.onupdate(el, obj1.getValue());
                    };
                    var calendar = null;
                    var calendarReset = null;
                    var calendarConfirm = null;
                    var calendarContainer = null;
                    var calendarContent = null;
                    var calendarLabelYear = null;
                    var calendarLabelMonth = null;
                    var calendarTable = null;
                    var calendarBody = null;
                    var calendarControls = null;
                    var calendarControlsTime = null;
                    var calendarControlsUpdate = null;
                    var calendarControlsUpdateButton = null;
                    var calendarSelectHour = null;
                    var calendarSelectMin = null;
                    var init = function() {
                        // Get value from initial element if that is an input
                        if (el.tagName == "INPUT" && el.value) options.value = el.value;
                        // Calendar DOM elements
                        calendarReset = document.createElement("div");
                        calendarReset.className = "jcalendar-reset";
                        calendarConfirm = document.createElement("div");
                        calendarConfirm.className = "jcalendar-confirm";
                        calendarControls = document.createElement("div");
                        calendarControls.className = "jcalendar-controls";
                        calendarControls.style.borderBottom = "1px solid #ddd";
                        calendarControls.appendChild(calendarReset);
                        calendarControls.appendChild(calendarConfirm);
                        calendarContainer = document.createElement("div");
                        calendarContainer.className = "jcalendar-container";
                        calendarContent = document.createElement("div");
                        calendarContent.className = "jcalendar-content";
                        calendarContainer.appendChild(calendarContent);
                        // Main element
                        if (el.tagName == "DIV") {
                            calendar = el;
                            calendar.classList.add("jcalendar-inline");
                        } else {
                            // Add controls to the screen
                            calendarContent.appendChild(calendarControls);
                            calendar = document.createElement("div");
                            calendar.className = "jcalendar";
                        }
                        calendar.classList.add("jcalendar-container");
                        calendar.appendChild(calendarContainer);
                        // Table container
                        var calendarTableContainer = document.createElement("div");
                        calendarTableContainer.className = "jcalendar-table";
                        calendarContent.appendChild(calendarTableContainer);
                        // Previous button
                        var calendarHeaderPrev = document.createElement("td");
                        calendarHeaderPrev.setAttribute("colspan", "2");
                        calendarHeaderPrev.className = "jcalendar-prev";
                        // Header with year and month
                        calendarLabelYear = document.createElement("span");
                        calendarLabelYear.className = "jcalendar-year";
                        calendarLabelMonth = document.createElement("span");
                        calendarLabelMonth.className = "jcalendar-month";
                        var calendarHeaderTitle = document.createElement("td");
                        calendarHeaderTitle.className = "jcalendar-header";
                        calendarHeaderTitle.setAttribute("colspan", "3");
                        calendarHeaderTitle.appendChild(calendarLabelMonth);
                        calendarHeaderTitle.appendChild(calendarLabelYear);
                        var calendarHeaderNext = document.createElement("td");
                        calendarHeaderNext.setAttribute("colspan", "2");
                        calendarHeaderNext.className = "jcalendar-next";
                        var calendarHeader = document.createElement("thead");
                        var calendarHeaderRow = document.createElement("tr");
                        calendarHeaderRow.appendChild(calendarHeaderPrev);
                        calendarHeaderRow.appendChild(calendarHeaderTitle);
                        calendarHeaderRow.appendChild(calendarHeaderNext);
                        calendarHeader.appendChild(calendarHeaderRow);
                        calendarTable = document.createElement("table");
                        calendarBody = document.createElement("tbody");
                        calendarTable.setAttribute("cellpadding", "0");
                        calendarTable.setAttribute("cellspacing", "0");
                        calendarTable.appendChild(calendarHeader);
                        calendarTable.appendChild(calendarBody);
                        calendarTableContainer.appendChild(calendarTable);
                        calendarSelectHour = document.createElement("select");
                        calendarSelectHour.className = "jcalendar-select";
                        calendarSelectHour.onchange = function() {
                            obj1.date[3] = this.value;
                            // Event
                            if (typeof obj1.options.onupdate == "function") obj1.options.onupdate(el, obj1.getValue());
                        };
                        for(var i = 0; i < 24; i++){
                            var element = document.createElement("option");
                            element.value = i;
                            element.innerHTML = helpers.two(i);
                            calendarSelectHour.appendChild(element);
                        }
                        calendarSelectMin = document.createElement("select");
                        calendarSelectMin.className = "jcalendar-select";
                        calendarSelectMin.onchange = function() {
                            obj1.date[4] = this.value;
                            // Event
                            if (typeof obj1.options.onupdate == "function") obj1.options.onupdate(el, obj1.getValue());
                        };
                        for(var i = 0; i < 60; i++){
                            var element = document.createElement("option");
                            element.value = i;
                            element.innerHTML = helpers.two(i);
                            calendarSelectMin.appendChild(element);
                        }
                        // Footer controls
                        var calendarControlsFooter = document.createElement("div");
                        calendarControlsFooter.className = "jcalendar-controls";
                        calendarControlsTime = document.createElement("div");
                        calendarControlsTime.className = "jcalendar-time";
                        calendarControlsTime.style.maxWidth = "140px";
                        calendarControlsTime.appendChild(calendarSelectHour);
                        calendarControlsTime.appendChild(calendarSelectMin);
                        calendarControlsUpdateButton = document.createElement("button");
                        calendarControlsUpdateButton.setAttribute("type", "button");
                        calendarControlsUpdateButton.className = "jcalendar-update";
                        calendarControlsUpdate = document.createElement("div");
                        calendarControlsUpdate.style.flexGrow = "10";
                        calendarControlsUpdate.appendChild(calendarControlsUpdateButton);
                        calendarControlsFooter.appendChild(calendarControlsTime);
                        // Only show the update button for input elements
                        if (el.tagName == "INPUT") calendarControlsFooter.appendChild(calendarControlsUpdate);
                        calendarContent.appendChild(calendarControlsFooter);
                        var calendarBackdrop = document.createElement("div");
                        calendarBackdrop.className = "jcalendar-backdrop";
                        calendar.appendChild(calendarBackdrop);
                        // Handle events
                        el.addEventListener("keyup", keyUpControls);
                        // Add global events
                        calendar.addEventListener("swipeleft", function(e) {
                            animation.slideLeft(calendarTable, 0, function() {
                                obj1.next();
                                animation.slideRight(calendarTable, 1);
                            });
                            e.preventDefault();
                            e.stopPropagation();
                        });
                        calendar.addEventListener("swiperight", function(e) {
                            animation.slideRight(calendarTable, 0, function() {
                                obj1.prev();
                                animation.slideLeft(calendarTable, 1);
                            });
                            e.preventDefault();
                            e.stopPropagation();
                        });
                        if ("ontouchend" in document.documentElement === true) {
                            calendar.addEventListener("touchend", mouseUpControls);
                            el.addEventListener("touchend", obj1.open);
                        } else {
                            calendar.addEventListener("mouseup", mouseUpControls);
                            el.addEventListener("mouseup", obj1.open);
                        }
                        // Global controls
                        if (!Component.hasEvents) {
                            // Execute only one time
                            Component.hasEvents = true;
                            // Enter and Esc
                            document.addEventListener("keydown", Component.keydown);
                        }
                        // Set configuration
                        obj1.setOptions(options);
                        // Append element to the DOM
                        if (el.tagName == "INPUT") {
                            el.parentNode.insertBefore(calendar, el.nextSibling);
                            // Add properties
                            el.setAttribute("autocomplete", "off");
                            // Element
                            el.classList.add("jcalendar-input");
                            // Value
                            el.value = obj1.setLabel(obj1.getValue(), obj1.options);
                        } else {
                            // Get days
                            obj1.getDays();
                            // Hour
                            if (obj1.options.time) {
                                calendarSelectHour.value = obj1.date[3];
                                calendarSelectMin.value = obj1.date[4];
                            }
                        }
                        // Default opened
                        if (obj1.options.opened == true) obj1.open();
                        // Controls
                        if (obj1.options.controls == false) calendarContainer.classList.add("jcalendar-hide-controls");
                        // Change method
                        el.change = obj1.setValue;
                        // Global generic value handler
                        el.val = function(val) {
                            if (val === undefined) return obj1.getValue();
                            else obj1.setValue(val);
                        };
                        // Keep object available from the node
                        el.calendar = calendar.calendar = obj1;
                    };
                    init();
                    return obj1;
                };
                Component.keydown = function(e) {
                    var calendar = null;
                    if (calendar = Component.current) {
                        if (e.which == 13) // ENTER
                        calendar.close(false, true);
                        else if (e.which == 27) // ESC
                        calendar.close(false, false);
                    }
                };
                Component.prettify = function(d, texts) {
                    if (!texts) var texts = {
                        justNow: "Just now",
                        xMinutesAgo: "{0}m ago",
                        xHoursAgo: "{0}h ago",
                        xDaysAgo: "{0}d ago",
                        xWeeksAgo: "{0}w ago",
                        xMonthsAgo: "{0} mon ago",
                        xYearsAgo: "{0}y ago"
                    };
                    if (d.indexOf("GMT") === -1 && d.indexOf("Z") === -1) d += " GMT";
                    var d1 = new Date();
                    var d2 = new Date(d);
                    var total = parseInt((d1 - d2) / 1000 / 60);
                    String.prototype.format = function(o) {
                        return this.replace("{0}", o);
                    };
                    if (total == 0) var text = texts.justNow;
                    else if (total < 90) var text = texts.xMinutesAgo.format(total);
                    else if (total < 1440) var text = texts.xHoursAgo.format(Math.round(total / 60));
                    else if (total < 20160) var text = texts.xDaysAgo.format(Math.round(total / 1440));
                    else if (total < 43200) var text = texts.xWeeksAgo.format(Math.round(total / 10080));
                    else if (total < 1036800) var text = texts.xMonthsAgo.format(Math.round(total / 43200));
                    else var text = texts.xYearsAgo.format(Math.round(total / 525600));
                    return text;
                };
                Component.prettifyAll = function() {
                    var elements = document.querySelectorAll(".prettydate");
                    for(var i = 0; i < elements.length; i++){
                        if (elements[i].getAttribute("data-date")) elements[i].innerHTML = Component.prettify(elements[i].getAttribute("data-date"));
                        else if (elements[i].innerHTML) {
                            elements[i].setAttribute("title", elements[i].innerHTML);
                            elements[i].setAttribute("data-date", elements[i].innerHTML);
                            elements[i].innerHTML = Component.prettify(elements[i].innerHTML);
                        }
                    }
                };
                Component.now = helpers_date.now;
                Component.toArray = helpers_date.toArray;
                Component.dateToNum = helpers_date.dateToNum;
                Component.numToDate = helpers_date.numToDate;
                Component.weekdays = helpers_date.weekdays;
                Component.months = helpers_date.months;
                Component.weekdaysShort = helpers_date.weekdaysShort;
                Component.monthsShort = helpers_date.monthsShort;
                // Legacy shortcut
                Component.extractDateFromString = mask.extractDateFromString;
                Component.getDateString = mask.getDateString;
                return Component;
            }
            /* harmony default export */ var calendar = Calendar();
            // More palettes https://coolors.co/ or https://gka.github.io/palettes/#/10|s|003790,005647,ffffe0|ffffe0,ff005e,93003a|1|1
            function Palette() {
                var palette = {
                    material: [
                        [
                            "#ffebee",
                            "#fce4ec",
                            "#f3e5f5",
                            "#e8eaf6",
                            "#e3f2fd",
                            "#e0f7fa",
                            "#e0f2f1",
                            "#e8f5e9",
                            "#f1f8e9",
                            "#f9fbe7",
                            "#fffde7",
                            "#fff8e1",
                            "#fff3e0",
                            "#fbe9e7",
                            "#efebe9",
                            "#fafafa",
                            "#eceff1"
                        ],
                        [
                            "#ffcdd2",
                            "#f8bbd0",
                            "#e1bee7",
                            "#c5cae9",
                            "#bbdefb",
                            "#b2ebf2",
                            "#b2dfdb",
                            "#c8e6c9",
                            "#dcedc8",
                            "#f0f4c3",
                            "#fff9c4",
                            "#ffecb3",
                            "#ffe0b2",
                            "#ffccbc",
                            "#d7ccc8",
                            "#f5f5f5",
                            "#cfd8dc"
                        ],
                        [
                            "#ef9a9a",
                            "#f48fb1",
                            "#ce93d8",
                            "#9fa8da",
                            "#90caf9",
                            "#80deea",
                            "#80cbc4",
                            "#a5d6a7",
                            "#c5e1a5",
                            "#e6ee9c",
                            "#fff59d",
                            "#ffe082",
                            "#ffcc80",
                            "#ffab91",
                            "#bcaaa4",
                            "#eeeeee",
                            "#b0bec5"
                        ],
                        [
                            "#e57373",
                            "#f06292",
                            "#ba68c8",
                            "#7986cb",
                            "#64b5f6",
                            "#4dd0e1",
                            "#4db6ac",
                            "#81c784",
                            "#aed581",
                            "#dce775",
                            "#fff176",
                            "#ffd54f",
                            "#ffb74d",
                            "#ff8a65",
                            "#a1887f",
                            "#e0e0e0",
                            "#90a4ae"
                        ],
                        [
                            "#ef5350",
                            "#ec407a",
                            "#ab47bc",
                            "#5c6bc0",
                            "#42a5f5",
                            "#26c6da",
                            "#26a69a",
                            "#66bb6a",
                            "#9ccc65",
                            "#d4e157",
                            "#ffee58",
                            "#ffca28",
                            "#ffa726",
                            "#ff7043",
                            "#8d6e63",
                            "#bdbdbd",
                            "#78909c"
                        ],
                        [
                            "#f44336",
                            "#e91e63",
                            "#9c27b0",
                            "#3f51b5",
                            "#2196f3",
                            "#00bcd4",
                            "#009688",
                            "#4caf50",
                            "#8bc34a",
                            "#cddc39",
                            "#ffeb3b",
                            "#ffc107",
                            "#ff9800",
                            "#ff5722",
                            "#795548",
                            "#9e9e9e",
                            "#607d8b"
                        ],
                        [
                            "#e53935",
                            "#d81b60",
                            "#8e24aa",
                            "#3949ab",
                            "#1e88e5",
                            "#00acc1",
                            "#00897b",
                            "#43a047",
                            "#7cb342",
                            "#c0ca33",
                            "#fdd835",
                            "#ffb300",
                            "#fb8c00",
                            "#f4511e",
                            "#6d4c41",
                            "#757575",
                            "#546e7a"
                        ],
                        [
                            "#d32f2f",
                            "#c2185b",
                            "#7b1fa2",
                            "#303f9f",
                            "#1976d2",
                            "#0097a7",
                            "#00796b",
                            "#388e3c",
                            "#689f38",
                            "#afb42b",
                            "#fbc02d",
                            "#ffa000",
                            "#f57c00",
                            "#e64a19",
                            "#5d4037",
                            "#616161",
                            "#455a64"
                        ],
                        [
                            "#c62828",
                            "#ad1457",
                            "#6a1b9a",
                            "#283593",
                            "#1565c0",
                            "#00838f",
                            "#00695c",
                            "#2e7d32",
                            "#558b2f",
                            "#9e9d24",
                            "#f9a825",
                            "#ff8f00",
                            "#ef6c00",
                            "#d84315",
                            "#4e342e",
                            "#424242",
                            "#37474f"
                        ],
                        [
                            "#b71c1c",
                            "#880e4f",
                            "#4a148c",
                            "#1a237e",
                            "#0d47a1",
                            "#006064",
                            "#004d40",
                            "#1b5e20",
                            "#33691e",
                            "#827717",
                            "#f57f17",
                            "#ff6f00",
                            "#e65100",
                            "#bf360c",
                            "#3e2723",
                            "#212121",
                            "#263238"
                        ]
                    ],
                    fire: [
                        [
                            "0b1a6d",
                            "840f38",
                            "b60718",
                            "de030b",
                            "ff0c0c",
                            "fd491c",
                            "fc7521",
                            "faa331",
                            "fbb535",
                            "ffc73a"
                        ],
                        [
                            "071147",
                            "5f0b28",
                            "930513",
                            "be0309",
                            "ef0000",
                            "fa3403",
                            "fb670b",
                            "f9991b",
                            "faad1e",
                            "ffc123"
                        ],
                        [
                            "03071e",
                            "370617",
                            "6a040f",
                            "9d0208",
                            "d00000",
                            "dc2f02",
                            "e85d04",
                            "f48c06",
                            "faa307",
                            "ffba08"
                        ],
                        [
                            "020619",
                            "320615",
                            "61040d",
                            "8c0207",
                            "bc0000",
                            "c82a02",
                            "d05203",
                            "db7f06",
                            "e19405",
                            "efab00"
                        ],
                        [
                            "020515",
                            "2d0513",
                            "58040c",
                            "7f0206",
                            "aa0000",
                            "b62602",
                            "b94903",
                            "c57205",
                            "ca8504",
                            "d89b00"
                        ]
                    ],
                    baby: [
                        [
                            "eddcd2",
                            "fff1e6",
                            "fde2e4",
                            "fad2e1",
                            "c5dedd",
                            "dbe7e4",
                            "f0efeb",
                            "d6e2e9",
                            "bcd4e6",
                            "99c1de"
                        ],
                        [
                            "e1c4b3",
                            "ffd5b5",
                            "fab6ba",
                            "f5a8c4",
                            "aacecd",
                            "bfd5cf",
                            "dbd9d0",
                            "baceda",
                            "9dc0db",
                            "7eb1d5"
                        ],
                        [
                            "daa990",
                            "ffb787",
                            "f88e95",
                            "f282a9",
                            "8fc4c3",
                            "a3c8be",
                            "cec9b3",
                            "9dbcce",
                            "82acd2",
                            "649dcb"
                        ],
                        [
                            "d69070",
                            "ff9c5e",
                            "f66770",
                            "f05f8f",
                            "74bbb9",
                            "87bfae",
                            "c5b993",
                            "83aac3",
                            "699bca",
                            "4d89c2"
                        ],
                        [
                            "c97d5d",
                            "f58443",
                            "eb4d57",
                            "e54a7b",
                            "66a9a7",
                            "78ae9c",
                            "b5a67e",
                            "7599b1",
                            "5c88b7",
                            "4978aa"
                        ]
                    ],
                    chart: [
                        [
                            "#C1D37F",
                            "#4C5454",
                            "#FFD275",
                            "#66586F",
                            "#D05D5B",
                            "#C96480",
                            "#95BF8F",
                            "#6EA240",
                            "#0F0F0E",
                            "#EB8258",
                            "#95A3B3",
                            "#995D81"
                        ]
                    ]
                };
                var Component = function(o) {
                    // Otherwise get palette value
                    if (palette[o]) return palette[o];
                    else return palette.material;
                };
                Component.get = function(o) {
                    // Otherwise get palette value
                    if (palette[o]) return palette[o];
                    else return palette;
                };
                Component.set = function(o, v) {
                    palette[o] = v;
                };
                return Component;
            }
            /* harmony default export */ var palette = Palette();
            function Tabs(el, options) {
                var obj1 = {};
                obj1.options = {};
                // Default configuration
                var defaults = {
                    data: [],
                    position: null,
                    allowCreate: false,
                    allowChangePosition: false,
                    onclick: null,
                    onload: null,
                    onchange: null,
                    oncreate: null,
                    ondelete: null,
                    onbeforecreate: null,
                    onchangeposition: null,
                    animation: false,
                    hideHeaders: false,
                    padding: null,
                    palette: null,
                    maxWidth: null
                };
                // Loop through the initial configuration
                for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                else obj1.options[property] = defaults[property];
                // Class
                el.classList.add("jtabs");
                var prev = null;
                var next = null;
                var border = null;
                // Helpers
                const setBorder = function(index) {
                    if (obj1.options.animation) setTimeout(function() {
                        let rect = obj1.headers.children[index].getBoundingClientRect();
                        if (obj1.options.palette === "modern") {
                            border.style.width = rect.width - 4 + "px";
                            border.style.left = obj1.headers.children[index].offsetLeft + 2 + "px";
                        } else {
                            border.style.width = rect.width + "px";
                            border.style.left = obj1.headers.children[index].offsetLeft + "px";
                        }
                        if (obj1.options.position === "bottom") border.style.top = "0px";
                        else border.style.bottom = "0px";
                    }, 50);
                };
                var updateControls = function(x1) {
                    if (typeof obj1.headers.scrollTo == "function") obj1.headers.scrollTo({
                        left: x1,
                        behavior: "smooth"
                    });
                    else obj1.headers.scrollLeft = x1;
                    if (x1 <= 1) prev.classList.add("disabled");
                    else prev.classList.remove("disabled");
                    if (x1 >= obj1.headers.scrollWidth - obj1.headers.offsetWidth) next.classList.add("disabled");
                    else next.classList.remove("disabled");
                    if (obj1.headers.scrollWidth <= obj1.headers.offsetWidth) {
                        prev.style.display = "none";
                        next.style.display = "none";
                    } else {
                        prev.style.display = "";
                        next.style.display = "";
                    }
                };
                obj1.setBorder = setBorder;
                // Set value
                obj1.open = function(index) {
                    // This is to force safari to update the children
                    const items = Array.from(obj1.content.children);
                    if (!obj1.content.children[index]) return;
                    var previous = null;
                    for(var i = 0; i < obj1.headers.children.length; i++){
                        if (obj1.headers.children[i].classList.contains("jtabs-selected")) // Current one
                        previous = i;
                        // Remote selected
                        obj1.headers.children[i].classList.remove("jtabs-selected");
                        obj1.headers.children[i].removeAttribute("aria-selected");
                        if (obj1.content.children[i]) obj1.content.children[i].classList.remove("jtabs-selected");
                    }
                    obj1.headers.children[index].classList.add("jtabs-selected");
                    obj1.headers.children[index].setAttribute("aria-selected", "true");
                    if (obj1.content.children[index]) obj1.content.children[index].classList.add("jtabs-selected");
                    if (previous != index && typeof obj1.options.onchange == "function") {
                        if (obj1.content.children[index]) obj1.options.onchange(el, obj1, index, obj1.headers.children[index], obj1.content.children[index]);
                    }
                    // Hide
                    if (obj1.options.hideHeaders == true && obj1.headers.children.length < 3 && obj1.options.allowCreate == false) obj1.headers.parentNode.style.display = "none";
                    else {
                        obj1.headers.parentNode.style.display = "";
                        var x1 = obj1.headers.children[index].offsetLeft;
                        var x2 = x1 + obj1.headers.children[index].offsetWidth;
                        var r1 = obj1.headers.scrollLeft;
                        var r2 = r1 + obj1.headers.offsetWidth;
                        if (!(r1 <= x1 && r2 >= x2)) // Out of the viewport
                        updateControls(x1 - 1);
                        // Set border
                        setBorder(index);
                    }
                };
                obj1.selectIndex = function(a) {
                    var index = Array.prototype.indexOf.call(obj1.headers.children, a);
                    if (index >= 0) obj1.open(index);
                    return index;
                };
                obj1.rename = function(i, title) {
                    if (!title) title = prompt("New title", obj1.headers.children[i].innerText);
                    obj1.headers.children[i].innerText = title;
                    setBorder(obj1.getActive());
                };
                obj1.create = function(title, url) {
                    if (typeof obj1.options.onbeforecreate == "function") {
                        var ret = obj1.options.onbeforecreate(el, title);
                        if (ret === false) return false;
                        else title = ret;
                    }
                    var div = obj1.appendElement(title);
                    if (typeof obj1.options.oncreate == "function") obj1.options.oncreate(el, div);
                    setBorder(obj1.getActive());
                    return div;
                };
                obj1.remove = function(index) {
                    return obj1.deleteElement(index);
                };
                obj1.nextNumber = function() {
                    var num = 0;
                    for(var i = 0; i < obj1.headers.children.length; i++){
                        var tmp = obj1.headers.children[i].innerText.match(/[0-9].*/);
                        if (tmp > num) num = parseInt(tmp);
                    }
                    if (!num) num = 1;
                    else num++;
                    return num;
                };
                obj1.deleteElement = function(index) {
                    let current = obj1.getActive();
                    if (!obj1.headers.children[index]) return false;
                    else {
                        obj1.headers.removeChild(obj1.headers.children[index]);
                        obj1.content.removeChild(obj1.content.children[index]);
                    }
                    if (current === index) obj1.open(0);
                    else {
                        let current = obj1.getActive() || 0;
                        setBorder(current);
                    }
                    if (typeof obj1.options.ondelete == "function") obj1.options.ondelete(el, index);
                };
                obj1.appendElement = function(title, cb, openTab, position) {
                    if (!title) var title = prompt("Title?", "");
                    if (title) {
                        let headerId = helpers.guid();
                        let contentId = helpers.guid();
                        // Add content
                        var div = document.createElement("div");
                        div.setAttribute("id", contentId);
                        div.setAttribute("role", "tabpanel");
                        div.setAttribute("aria-labelledby", headerId);
                        // Add headers
                        var h = document.createElement("div");
                        h.setAttribute("id", headerId);
                        h.setAttribute("role", "tab");
                        h.setAttribute("aria-controls", contentId);
                        h.textContent = title;
                        h.content = div;
                        if (typeof position === "undefined") {
                            obj1.content.appendChild(div);
                            obj1.headers.insertBefore(h, obj1.headers.lastChild);
                        } else {
                            let r = obj1.content.children[position];
                            if (r) obj1.content.insertBefore(div, r);
                            else obj1.content.appendChild(div);
                            r = obj1.headers.children[position] || obj1.headers.lastChild;
                            obj1.headers.insertBefore(h, r);
                        }
                        // Sortable
                        if (obj1.options.allowChangePosition) h.setAttribute("draggable", "true");
                        // Open new tab
                        if (openTab !== false) // Open new tab
                        obj1.selectIndex(h);
                        // Callback
                        if (typeof cb == "function") cb(div, h);
                        // Return element
                        return div;
                    }
                };
                obj1.getActive = function() {
                    for(var i = 0; i < obj1.headers.children.length; i++){
                        if (obj1.headers.children[i].classList.contains("jtabs-selected")) return i;
                    }
                    return false;
                };
                obj1.updateContent = function(position, newContent) {
                    if (typeof newContent !== "string") var contentItem = newContent;
                    else {
                        var contentItem = document.createElement("div");
                        contentItem.innerHTML = newContent;
                    }
                    if (obj1.content.children[position].classList.contains("jtabs-selected")) newContent.classList.add("jtabs-selected");
                    obj1.content.replaceChild(newContent, obj1.content.children[position]);
                    setBorder();
                };
                obj1.updatePosition = function(f, t, ignoreEvents, openTab) {
                    // Ondrop update position of content
                    if (f > t) obj1.content.insertBefore(obj1.content.children[f], obj1.content.children[t]);
                    else obj1.content.insertBefore(obj1.content.children[f], obj1.content.children[t].nextSibling);
                    // Open destination tab
                    if (openTab !== false) obj1.open(t);
                    else {
                        const activeIndex = obj1.getActive();
                        if (t < activeIndex) obj1.setBorder(activeIndex);
                    }
                    // Call event
                    if (!ignoreEvents && typeof obj1.options.onchangeposition == "function") obj1.options.onchangeposition(obj1.headers, f, t);
                };
                obj1.move = function(f, t, ignoreEvents, openTab) {
                    if (f > t) obj1.headers.insertBefore(obj1.headers.children[f], obj1.headers.children[t]);
                    else obj1.headers.insertBefore(obj1.headers.children[f], obj1.headers.children[t].nextSibling);
                    obj1.updatePosition(f, t, ignoreEvents, openTab);
                };
                obj1.setBorder = setBorder;
                obj1.init = function() {
                    el.textContent = "";
                    // Make sure the component is blank
                    obj1.headers = document.createElement("div");
                    obj1.content = document.createElement("div");
                    obj1.headers.classList.add("jtabs-headers");
                    obj1.headers.setAttribute("role", "tablist");
                    obj1.content.classList.add("jtabs-content");
                    obj1.content.setAttribute("role", "region");
                    obj1.content.setAttribute("aria-label", "Tab Panels");
                    if (obj1.options.palette) el.classList.add("jtabs-modern");
                    else el.classList.remove("jtabs-modern");
                    // Padding
                    if (obj1.options.padding) obj1.content.style.padding = parseInt(obj1.options.padding) + "px";
                    // Header
                    var header = document.createElement("div");
                    header.className = "jtabs-headers-container";
                    header.appendChild(obj1.headers);
                    if (obj1.options.maxWidth) header.style.maxWidth = parseInt(obj1.options.maxWidth) + "px";
                    // Controls
                    var controls = document.createElement("div");
                    controls.className = "jtabs-controls";
                    controls.setAttribute("draggable", "false");
                    header.appendChild(controls);
                    // Append DOM elements
                    if (obj1.options.position == "bottom") {
                        el.appendChild(obj1.content);
                        el.appendChild(header);
                    } else {
                        el.appendChild(header);
                        el.appendChild(obj1.content);
                    }
                    // New button
                    if (obj1.options.allowCreate == true) {
                        var add = document.createElement("div");
                        add.className = "jtabs-add";
                        add.onclick = function() {
                            obj1.create();
                        };
                        controls.appendChild(add);
                    }
                    prev = document.createElement("div");
                    prev.className = "jtabs-prev";
                    prev.onclick = function() {
                        updateControls(obj1.headers.scrollLeft - obj1.headers.offsetWidth);
                    };
                    controls.appendChild(prev);
                    next = document.createElement("div");
                    next.className = "jtabs-next";
                    next.onclick = function() {
                        updateControls(obj1.headers.scrollLeft + obj1.headers.offsetWidth);
                    };
                    controls.appendChild(next);
                    // Data
                    for(var i = 0; i < obj1.options.data.length; i++){
                        // Title
                        if (obj1.options.data[i].titleElement) var headerItem = obj1.options.data[i].titleElement;
                        else var headerItem = document.createElement("div");
                        // Icon
                        if (obj1.options.data[i].icon) {
                            var iconContainer = document.createElement("div");
                            var icon = document.createElement("i");
                            icon.classList.add("material-icons");
                            icon.textContent = obj1.options.data[i].icon;
                            iconContainer.appendChild(icon);
                            headerItem.appendChild(iconContainer);
                        }
                        // Title
                        if (obj1.options.data[i].title) {
                            var title = document.createTextNode(obj1.options.data[i].title);
                            headerItem.appendChild(title);
                        }
                        // Width
                        if (obj1.options.data[i].width) headerItem.style.width = obj1.options.data[i].width;
                        // Content
                        if (obj1.options.data[i].contentElement) var contentItem = obj1.options.data[i].contentElement;
                        else {
                            var contentItem = document.createElement("div");
                            contentItem.innerHTML = obj1.options.data[i].content;
                        }
                        obj1.headers.appendChild(headerItem);
                        obj1.content.appendChild(contentItem);
                    }
                    // Animation
                    border = document.createElement("div");
                    border.className = "jtabs-border";
                    obj1.headers.appendChild(border);
                    if (obj1.options.animation) el.classList.add("jtabs-animation");
                    // Events
                    obj1.headers.addEventListener("click", function(e) {
                        if (e.target.parentNode.classList.contains("jtabs-headers")) var target = e.target;
                        else if (e.target.tagName == "I") var target = e.target.parentNode.parentNode;
                        else var target = e.target.parentNode;
                        var index = obj1.selectIndex(target);
                        if (typeof obj1.options.onclick == "function") obj1.options.onclick(el, obj1, index, obj1.headers.children[index], obj1.content.children[index]);
                    });
                    obj1.headers.addEventListener("contextmenu", function(e) {
                        obj1.selectIndex(e.target);
                    });
                    if (obj1.headers.children.length) // Open first tab
                    obj1.open(0);
                    // Update controls
                    updateControls(0);
                    if (obj1.options.allowChangePosition == true) Sorting(obj1.headers, {
                        direction: 1,
                        ondrop: function(a, b, c) {
                            obj1.updatePosition(b, c);
                        }
                    });
                    if (typeof obj1.options.onload == "function") obj1.options.onload(el, obj1);
                };
                // Loading existing nodes as the data
                if (el.children[0] && el.children[0].children.length) // Create from existing elements
                for(var i = 0; i < el.children[0].children.length; i++){
                    var item = obj1.options.data && obj1.options.data[i] ? obj1.options.data[i] : {};
                    if (el.children[1] && el.children[1].children[i]) {
                        item.titleElement = el.children[0].children[i];
                        item.contentElement = el.children[1].children[i];
                    } else item.contentElement = el.children[0].children[i];
                    obj1.options.data[i] = item;
                }
                // Remote controller flag
                var loadingRemoteData = false;
                // Create from data
                if (obj1.options.data) {
                    // Append children
                    for(var i = 0; i < obj1.options.data.length; i++)if (obj1.options.data[i].url) {
                        ajax({
                            url: obj1.options.data[i].url,
                            type: "GET",
                            dataType: "text/html",
                            index: i,
                            success: function(result) {
                                obj1.options.data[this.index].content = result;
                            },
                            complete: function() {
                                obj1.init();
                            }
                        });
                        // Flag loading
                        loadingRemoteData = true;
                    }
                }
                if (!loadingRemoteData) obj1.init();
                el.tabs = obj1;
                return obj1;
            }
            function Color(el, options) {
                // Already created, update options
                if (el.color) return el.color.setOptions(options, true);
                // New instance
                var obj1 = {
                    type: "color"
                };
                obj1.options = {};
                var container = null;
                var backdrop = null;
                var content = null;
                var resetButton = null;
                var closeButton = null;
                var tabs = null;
                var jsuitesTabs = null;
                /**
     * Update options
     */ obj1.setOptions = function(options, reset) {
                    /**
         * @typedef {Object} defaults
         * @property {(string|Array)} value - Initial value of the compontent
         * @property {string} placeholder - The default instruction text on the element
         * @property {requestCallback} onchange - Method to be execute after any changes on the element
         * @property {requestCallback} onclose - Method to be execute when the element is closed
         * @property {string} doneLabel - Label for button done
         * @property {string} resetLabel - Label for button reset
         * @property {string} resetValue - Value for button reset
         * @property {Bool} showResetButton - Active or note for button reset - default false
         */ var defaults = {
                        placeholder: "",
                        value: null,
                        onopen: null,
                        onclose: null,
                        onchange: null,
                        closeOnChange: true,
                        palette: null,
                        position: null,
                        doneLabel: "Done",
                        resetLabel: "Reset",
                        fullscreen: false,
                        opened: false
                    };
                    if (!options) options = {};
                    if (options && !options.palette) // Default palette
                    options.palette = palette();
                    // Loop through our object
                    for(var property in defaults){
                        if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                        else if (typeof obj1.options[property] == "undefined" || reset === true) obj1.options[property] = defaults[property];
                    }
                    // Update the text of the controls, if they have already been created
                    if (resetButton) resetButton.innerHTML = obj1.options.resetLabel;
                    if (closeButton) closeButton.innerHTML = obj1.options.doneLabel;
                    // Update the pallete
                    if (obj1.options.palette && jsuitesTabs) jsuitesTabs.updateContent(0, table());
                    // Value
                    if (typeof obj1.options.value === "string") {
                        el.value = obj1.options.value;
                        if (el.tagName === "INPUT") {
                            el.style.color = el.value;
                            el.style.backgroundColor = el.value;
                        }
                    }
                    // Placeholder
                    if (obj1.options.placeholder) el.setAttribute("placeholder", obj1.options.placeholder);
                    else if (el.getAttribute("placeholder")) el.removeAttribute("placeholder");
                    return obj1;
                };
                obj1.select = function(color) {
                    // Remove current selected mark
                    var selected = container.querySelector(".jcolor-selected");
                    if (selected) selected.classList.remove("jcolor-selected");
                    // Mark cell as selected
                    if (obj1.values[color]) obj1.values[color].classList.add("jcolor-selected");
                    obj1.options.value = color;
                };
                /**
     * Open color pallete
     */ obj1.open = function() {
                    if (!container.classList.contains("jcolor-focus")) {
                        // Start tracking
                        tracking(obj1, true);
                        // Show color picker
                        container.classList.add("jcolor-focus");
                        // Select current color
                        if (obj1.options.value) obj1.select(obj1.options.value);
                        // Reset margin
                        content.style.marginTop = "";
                        content.style.marginLeft = "";
                        var rectContent = content.getBoundingClientRect();
                        var availableWidth = helpers.getWindowWidth();
                        var availableHeight = helpers.getWindowHeight();
                        if (availableWidth < 800 || obj1.options.fullscreen == true) {
                            content.classList.add("jcolor-fullscreen");
                            animation.slideBottom(content, 1);
                            backdrop.style.display = "block";
                        } else {
                            if (content.classList.contains("jcolor-fullscreen")) {
                                content.classList.remove("jcolor-fullscreen");
                                backdrop.style.display = "";
                            }
                            if (obj1.options.position) content.style.position = "fixed";
                            else content.style.position = "";
                            if (rectContent.left + rectContent.width > availableWidth) content.style.marginLeft = -1 * (rectContent.left + rectContent.width - (availableWidth - 20)) + "px";
                            if (rectContent.top + rectContent.height > availableHeight) content.style.marginTop = -1 * (rectContent.top + rectContent.height - (availableHeight - 20)) + "px";
                        }
                        if (typeof obj1.options.onopen == "function") obj1.options.onopen(el, obj1);
                        jsuitesTabs.setBorder(jsuitesTabs.getActive());
                        // Update sliders
                        if (obj1.options.value) {
                            var rgb = HexToRgb(obj1.options.value);
                            rgbInputs.forEach(function(rgbInput, index) {
                                rgbInput.value = rgb[index];
                                rgbInput.dispatchEvent(new Event("input"));
                            });
                        }
                    }
                };
                /**
     * Close color pallete
     */ obj1.close = function(ignoreEvents) {
                    if (container.classList.contains("jcolor-focus")) {
                        // Remove focus
                        container.classList.remove("jcolor-focus");
                        // Make sure backdrop is hidden
                        backdrop.style.display = "";
                        // Call related events
                        if (!ignoreEvents && typeof obj1.options.onclose == "function") obj1.options.onclose(el, obj1);
                        // Stop  the object
                        tracking(obj1, false);
                    }
                    return obj1.options.value;
                };
                /**
     * Set value
     */ obj1.setValue = function(color) {
                    if (!color) color = "";
                    if (color != obj1.options.value) {
                        obj1.options.value = color;
                        slidersResult = color;
                        // Remove current selecded mark
                        obj1.select(color);
                        // Onchange
                        if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, color, obj1);
                        // Changes
                        if (el.value != obj1.options.value) {
                            // Set input value
                            el.value = obj1.options.value;
                            if (el.tagName === "INPUT") {
                                el.style.color = el.value;
                                el.style.backgroundColor = el.value;
                            }
                            // Element onchange native
                            if (typeof el.oninput == "function") el.oninput({
                                type: "input",
                                target: el,
                                value: el.value
                            });
                        }
                        if (obj1.options.closeOnChange == true) obj1.close();
                    }
                };
                /**
     * Get value
     */ obj1.getValue = function() {
                    return obj1.options.value;
                };
                var backdropClickControl = false;
                // Converts a number in decimal to hexadecimal
                var decToHex = function(num) {
                    var hex = num.toString(16);
                    return hex.length === 1 ? "0" + hex : hex;
                };
                // Converts a color in rgb to hexadecimal
                var rgbToHex = function(r, g, b) {
                    return "#" + decToHex(r) + decToHex(g) + decToHex(b);
                };
                // Converts a number in hexadecimal to decimal
                var hexToDec = function(hex) {
                    return parseInt("0x" + hex);
                };
                // Converts a color in hexadecimal to rgb
                var HexToRgb = function(hex) {
                    return [
                        hexToDec(hex.substr(1, 2)),
                        hexToDec(hex.substr(3, 2)),
                        hexToDec(hex.substr(5, 2))
                    ];
                };
                var table = function() {
                    // Content of the first tab
                    var tableContainer = document.createElement("div");
                    tableContainer.className = "jcolor-grid";
                    // Cells
                    obj1.values = [];
                    // Table pallete
                    var t = document.createElement("table");
                    t.setAttribute("cellpadding", "7");
                    t.setAttribute("cellspacing", "0");
                    for(var j = 0; j < obj1.options.palette.length; j++){
                        var tr = document.createElement("tr");
                        for(var i = 0; i < obj1.options.palette[j].length; i++){
                            var td = document.createElement("td");
                            var color = obj1.options.palette[j][i];
                            if (color.length < 7 && color.substr(0, 1) !== "#") color = "#" + color;
                            td.style.backgroundColor = color;
                            td.setAttribute("data-value", color);
                            td.innerHTML = "";
                            tr.appendChild(td);
                            // Selected color
                            if (obj1.options.value == color) td.classList.add("jcolor-selected");
                            // Possible values
                            obj1.values[color] = td;
                        }
                        t.appendChild(tr);
                    }
                    // Append to the table
                    tableContainer.appendChild(t);
                    return tableContainer;
                };
                // Canvas where the image will be rendered
                var canvas = document.createElement("canvas");
                canvas.width = 200;
                canvas.height = 160;
                var context = canvas.getContext("2d");
                var resizeCanvas = function() {
                    // Specifications necessary to correctly obtain colors later in certain positions
                    var m = tabs.firstChild.getBoundingClientRect();
                    canvas.width = m.width - 14;
                    gradient();
                };
                var gradient = function() {
                    var g = context.createLinearGradient(0, 0, canvas.width, 0);
                    // Create color gradient
                    g.addColorStop(0, "rgb(255,0,0)");
                    g.addColorStop(0.15, "rgb(255,0,255)");
                    g.addColorStop(0.33, "rgb(0,0,255)");
                    g.addColorStop(0.49, "rgb(0,255,255)");
                    g.addColorStop(0.67, "rgb(0,255,0)");
                    g.addColorStop(0.84, "rgb(255,255,0)");
                    g.addColorStop(1, "rgb(255,0,0)");
                    context.fillStyle = g;
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    g = context.createLinearGradient(0, 0, 0, canvas.height);
                    g.addColorStop(0, "rgba(255,255,255,1)");
                    g.addColorStop(0.5, "rgba(255,255,255,0)");
                    g.addColorStop(0.5, "rgba(0,0,0,0)");
                    g.addColorStop(1, "rgba(0,0,0,1)");
                    context.fillStyle = g;
                    context.fillRect(0, 0, canvas.width, canvas.height);
                };
                var hsl = function() {
                    var element = document.createElement("div");
                    element.className = "jcolor-hsl";
                    var point = document.createElement("div");
                    point.className = "jcolor-point";
                    var div = document.createElement("div");
                    div.appendChild(canvas);
                    div.appendChild(point);
                    element.appendChild(div);
                    // Moves the marquee point to the specified position
                    var update = function(buttons, x1, y1) {
                        if (buttons === 1) {
                            var rect = element.getBoundingClientRect();
                            var left = x1 - rect.left;
                            var top = y1 - rect.top;
                            if (left < 0) left = 0;
                            if (top < 0) top = 0;
                            if (left > rect.width) left = rect.width;
                            if (top > rect.height) top = rect.height;
                            point.style.left = left + "px";
                            point.style.top = top + "px";
                            var pixel = context.getImageData(left, top, 1, 1).data;
                            slidersResult = rgbToHex(pixel[0], pixel[1], pixel[2]);
                        }
                    };
                    // Applies the point's motion function to the div that contains it
                    element.addEventListener("mousedown", function(e) {
                        update(e.buttons, e.clientX, e.clientY);
                    });
                    element.addEventListener("mousemove", function(e) {
                        update(e.buttons, e.clientX, e.clientY);
                    });
                    element.addEventListener("touchmove", function(e) {
                        update(1, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
                    });
                    return element;
                };
                var slidersResult = "";
                var rgbInputs = [];
                var changeInputColors = function() {
                    if (slidersResult !== "") for(var j = 0; j < rgbInputs.length; j++){
                        var currentColor = HexToRgb(slidersResult);
                        currentColor[j] = 0;
                        var newGradient = "linear-gradient(90deg, rgb(";
                        newGradient += currentColor.join(", ");
                        newGradient += "), rgb(";
                        currentColor[j] = 255;
                        newGradient += currentColor.join(", ");
                        newGradient += "))";
                        rgbInputs[j].style.backgroundImage = newGradient;
                    }
                };
                var sliders = function() {
                    // Content of the third tab
                    var slidersElement = document.createElement("div");
                    slidersElement.className = "jcolor-sliders";
                    var slidersBody = document.createElement("div");
                    // Creates a range-type input with the specified name
                    var createSliderInput = function(name) {
                        var inputContainer = document.createElement("div");
                        inputContainer.className = "jcolor-sliders-input-container";
                        var label = document.createElement("label");
                        label.innerText = name;
                        var subContainer = document.createElement("div");
                        subContainer.className = "jcolor-sliders-input-subcontainer";
                        var input = document.createElement("input");
                        input.type = "range";
                        input.min = 0;
                        input.max = 255;
                        input.value = 0;
                        input.setAttribute("aria-label", "Color value");
                        input.setAttribute("aria-valuemin", "0");
                        input.setAttribute("aria-valuemax", "255");
                        input.setAttribute("aria-valuenow", "0");
                        inputContainer.appendChild(label);
                        subContainer.appendChild(input);
                        var value = document.createElement("div");
                        value.innerText = input.value;
                        input.addEventListener("input", function() {
                            value.innerText = input.value;
                        });
                        subContainer.appendChild(value);
                        inputContainer.appendChild(subContainer);
                        slidersBody.appendChild(inputContainer);
                        return input;
                    };
                    // Creates red, green and blue inputs
                    rgbInputs = [
                        createSliderInput("Red"),
                        createSliderInput("Green"),
                        createSliderInput("Blue")
                    ];
                    slidersElement.appendChild(slidersBody);
                    // Element that prints the current color
                    var slidersResultColor = document.createElement("div");
                    slidersResultColor.className = "jcolor-sliders-final-color";
                    var resultElement = document.createElement("div");
                    resultElement.style.visibility = "hidden";
                    resultElement.innerText = "a";
                    slidersResultColor.appendChild(resultElement);
                    // Update the element that prints the current color
                    var updateResult = function() {
                        var resultColor = rgbToHex(parseInt(rgbInputs[0].value), parseInt(rgbInputs[1].value), parseInt(rgbInputs[2].value));
                        resultElement.innerText = resultColor;
                        resultElement.style.color = resultColor;
                        resultElement.style.removeProperty("visibility");
                        slidersResult = resultColor;
                    };
                    // Apply the update function to color inputs
                    rgbInputs.forEach(function(rgbInput) {
                        rgbInput.addEventListener("input", function() {
                            updateResult();
                            changeInputColors();
                        });
                    });
                    slidersElement.appendChild(slidersResultColor);
                    return slidersElement;
                };
                var init = function() {
                    // Initial options
                    obj1.setOptions(options);
                    // Add a proper input tag when the element is an input
                    if (el.tagName == "INPUT") {
                        el.classList.add("jcolor-input");
                        el.readOnly = true;
                    }
                    // Table container
                    container = document.createElement("div");
                    container.className = "jcolor";
                    // Table container
                    backdrop = document.createElement("div");
                    backdrop.className = "jcolor-backdrop";
                    container.appendChild(backdrop);
                    // Content
                    content = document.createElement("div");
                    content.className = "jcolor-content";
                    // Controls
                    var controls = document.createElement("div");
                    controls.className = "jcolor-controls";
                    content.appendChild(controls);
                    // Reset button
                    resetButton = document.createElement("div");
                    resetButton.className = "jcolor-reset";
                    resetButton.innerHTML = obj1.options.resetLabel;
                    controls.appendChild(resetButton);
                    // Close button
                    closeButton = document.createElement("div");
                    closeButton.className = "jcolor-close";
                    closeButton.innerHTML = obj1.options.doneLabel;
                    controls.appendChild(closeButton);
                    // Element that will be used to create the tabs
                    tabs = document.createElement("div");
                    content.appendChild(tabs);
                    // Starts the jSuites tabs component
                    jsuitesTabs = Tabs(tabs, {
                        animation: true,
                        data: [
                            {
                                title: "Grid",
                                contentElement: table()
                            },
                            {
                                title: "Spectrum",
                                contentElement: hsl()
                            },
                            {
                                title: "Sliders",
                                contentElement: sliders()
                            }
                        ],
                        onchange: function(element, instance, index) {
                            if (index === 1) resizeCanvas();
                            else {
                                var color = slidersResult !== "" ? slidersResult : obj1.getValue();
                                if (index === 2 && color) {
                                    var rgb = HexToRgb(color);
                                    rgbInputs.forEach(function(rgbInput, index) {
                                        rgbInput.value = rgb[index];
                                        rgbInput.dispatchEvent(new Event("input"));
                                    });
                                }
                            }
                        },
                        palette: "modern"
                    });
                    container.appendChild(content);
                    // Insert picker after the element
                    if (el.tagName == "INPUT") el.parentNode.insertBefore(container, el.nextSibling);
                    else el.appendChild(container);
                    container.addEventListener("click", function(e) {
                        if (e.target.tagName == "TD") {
                            var value = e.target.getAttribute("data-value");
                            if (value) obj1.setValue(value);
                        } else if (e.target.classList.contains("jcolor-reset")) {
                            obj1.setValue("");
                            obj1.close();
                        } else if (e.target.classList.contains("jcolor-close")) {
                            if (jsuitesTabs.getActive() > 0) obj1.setValue(slidersResult);
                            obj1.close();
                        } else if (e.target.classList.contains("jcolor-backdrop")) obj1.close();
                        else obj1.open();
                    });
                    /**
         * If element is focus open the picker
         */ el.addEventListener("mouseup", function(e) {
                        obj1.open();
                    });
                    // If the picker is open on the spectrum tab, it changes the canvas size when the window size is changed
                    window.addEventListener("resize", function() {
                        if (container.classList.contains("jcolor-focus") && jsuitesTabs.getActive() == 1) resizeCanvas();
                    });
                    // Default opened
                    if (obj1.options.opened == true) obj1.open();
                    // Change
                    el.change = obj1.setValue;
                    // Global generic value handler
                    el.val = function(val) {
                        if (val === undefined) return obj1.getValue();
                        else obj1.setValue(val);
                    };
                    // Keep object available from the node
                    el.color = obj1;
                    // Container shortcut
                    container.color = obj1;
                };
                obj1.toHex = function(rgb) {
                    var hex = function(x1) {
                        return ("0" + parseInt(x1).toString(16)).slice(-2);
                    };
                    if (rgb) {
                        if (/^#[0-9A-F]{6}$/i.test(rgb)) return rgb;
                        else {
                            rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
                            if (rgb && rgb.length) return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
                            else return "";
                        }
                    }
                };
                init();
                return obj1;
            }
            function Contextmenu() {
                var Component = function(el, options) {
                    // New instance
                    var obj1 = {
                        type: "contextmenu"
                    };
                    obj1.options = {};
                    // Default configuration
                    var defaults = {
                        items: null,
                        onclick: null
                    };
                    // Loop through our object
                    for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                    else obj1.options[property] = defaults[property];
                    // Class definition
                    el.classList.add("jcontextmenu");
                    /**
         * Open contextmenu
         */ obj1.open = function(e, items) {
                        if (items) {
                            // Update content
                            obj1.options.items = items;
                            // Create items
                            obj1.create(items);
                        }
                        // Close current contextmenu
                        if (Component.current) Component.current.close();
                        // Add to the opened components monitor
                        tracking(obj1, true);
                        // Show context menu
                        el.classList.add("jcontextmenu-focus");
                        // Current
                        Component.current = obj1;
                        // Coordinates
                        if (obj1.options.items && obj1.options.items.length > 0 || el.children.length) {
                            if (e.target) {
                                if (e.changedTouches && e.changedTouches[0]) {
                                    x1 = e.changedTouches[0].clientX;
                                    y1 = e.changedTouches[0].clientY;
                                } else {
                                    var x1 = e.clientX;
                                    var y1 = e.clientY;
                                }
                            } else {
                                var x1 = e.x;
                                var y1 = e.y;
                            }
                            var rect = el.getBoundingClientRect();
                            if (window.innerHeight < y1 + rect.height) {
                                var h = y1 - rect.height;
                                if (h < 0) h = 0;
                                el.style.top = h + "px";
                            } else el.style.top = y1 + "px";
                            if (window.innerWidth < x1 + rect.width) {
                                if (x1 - rect.width > 0) el.style.left = x1 - rect.width + "px";
                                else el.style.left = "10px";
                            } else el.style.left = x1 + "px";
                        }
                    };
                    obj1.isOpened = function() {
                        return el.classList.contains("jcontextmenu-focus") ? true : false;
                    };
                    /**
         * Close menu
         */ obj1.close = function() {
                        if (el.classList.contains("jcontextmenu-focus")) el.classList.remove("jcontextmenu-focus");
                        tracking(obj1, false);
                    };
                    /**
         * Create items based on the declared objectd
         * @param {object} items - List of object
         */ obj1.create = function(items) {
                        // Update content
                        el.innerHTML = "";
                        // Add header contextmenu
                        var itemHeader = createHeader();
                        el.appendChild(itemHeader);
                        // Append items
                        for(var i = 0; i < items.length; i++){
                            var itemContainer = createItemElement(items[i]);
                            el.appendChild(itemContainer);
                        }
                    };
                    /**
         * createHeader for context menu
         * @private
         * @returns {HTMLElement}
         */ function createHeader() {
                        var header = document.createElement("div");
                        header.classList.add("header");
                        header.addEventListener("click", function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                        });
                        var title = document.createElement("a");
                        title.classList.add("title");
                        title.innerHTML = dictionary.translate("Menu");
                        header.appendChild(title);
                        var closeButton = document.createElement("a");
                        closeButton.classList.add("close");
                        closeButton.innerHTML = dictionary.translate("close");
                        closeButton.addEventListener("click", function(e) {
                            obj1.close();
                        });
                        header.appendChild(closeButton);
                        return header;
                    }
                    /**
         * Private function for create a new Item element
         * @param {type} item
         * @returns {jsuitesL#15.jSuites.contextmenu.createItemElement.itemContainer}
         */ function createItemElement(item) {
                        if (item.type && (item.type == "line" || item.type == "divisor")) var itemContainer = document.createElement("hr");
                        else {
                            var itemContainer = document.createElement("div");
                            var itemText = document.createElement("a");
                            itemText.innerHTML = item.title;
                            if (item.tooltip) itemContainer.setAttribute("title", item.tooltip);
                            if (item.icon) itemContainer.setAttribute("data-icon", item.icon);
                            if (item.id) itemContainer.id = item.id;
                            if (item.disabled) itemContainer.className = "jcontextmenu-disabled";
                            else if (item.onclick) {
                                itemContainer.method = item.onclick;
                                itemContainer.addEventListener("mousedown", function(e) {
                                    e.preventDefault();
                                });
                                itemContainer.addEventListener("mouseup", function(e) {
                                    // Execute method
                                    this.method(this, e);
                                });
                            }
                            itemContainer.appendChild(itemText);
                            if (item.submenu) {
                                var itemIconSubmenu = document.createElement("span");
                                itemIconSubmenu.innerHTML = "&#9658;";
                                itemContainer.appendChild(itemIconSubmenu);
                                itemContainer.classList.add("jcontexthassubmenu");
                                var el_submenu = document.createElement("div");
                                // Class definition
                                el_submenu.classList.add("jcontextmenu");
                                // Focusable
                                el_submenu.setAttribute("tabindex", "900");
                                // Append items
                                var submenu = item.submenu;
                                for(var i = 0; i < submenu.length; i++){
                                    var itemContainerSubMenu = createItemElement(submenu[i]);
                                    el_submenu.appendChild(itemContainerSubMenu);
                                }
                                itemContainer.appendChild(el_submenu);
                                // Submenu positioning logic:
                                // Case 1: Default (enough space to the right) - submenu opens to the right of the parent menu item.
                                // Case 2: Not enough space to the right, but enough to the left - submenu opens to the left of the parent menu item.
                                // Case 3: Not enough space on either side (e.g., very narrow viewport) - submenu opens below the parent menu item.
                                itemContainer.addEventListener("mouseenter", function() {
                                    // Reset to default
                                    el_submenu.style.left = "";
                                    el_submenu.style.right = "";
                                    el_submenu.style.minWidth = itemContainer.offsetWidth + "px";
                                    // Temporarily show submenu to measure
                                    el_submenu.style.display = "block";
                                    el_submenu.style.opacity = "0";
                                    el_submenu.style.pointerEvents = "none";
                                    // Use getBoundingClientRect to determine position
                                    var parentRect = itemContainer.getBoundingClientRect();
                                    var submenuRect = el_submenu.getBoundingClientRect();
                                    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                                    // Calculate the right edge if rendered to the right
                                    var rightEdge = parentRect.right + submenuRect.width;
                                    var leftEdge = parentRect.left - submenuRect.width;
                                    // If rendering to the right would overflow, render to the left
                                    if (rightEdge > viewportWidth && leftEdge >= 0) {
                                        el_submenu.style.left = "auto";
                                        el_submenu.style.right = "99%";
                                    } else if (rightEdge > viewportWidth && leftEdge < 0) {
                                        el_submenu.style.left = "32px";
                                        el_submenu.style.right = "auto";
                                        el_submenu.style.top = "100%";
                                    } else {
                                        el_submenu.style.left = "99%";
                                        el_submenu.style.right = "auto";
                                    }
                                    // Restore visibility
                                    el_submenu.style.opacity = "";
                                    el_submenu.style.pointerEvents = "";
                                    el_submenu.style.display = "";
                                });
                                // Also reset submenu position on mouseleave to avoid stale styles
                                itemContainer.addEventListener("mouseleave", function() {
                                    el_submenu.style.left = "";
                                    el_submenu.style.right = "";
                                    el_submenu.style.minWidth = "";
                                });
                            } else if (item.shortcut) {
                                var itemShortCut = document.createElement("span");
                                itemShortCut.innerHTML = item.shortcut;
                                itemContainer.appendChild(itemShortCut);
                            }
                        }
                        return itemContainer;
                    }
                    if (typeof obj1.options.onclick == "function") el.addEventListener("click", function(e) {
                        obj1.options.onclick(obj1, e);
                    });
                    // Create items
                    if (obj1.options.items) obj1.create(obj1.options.items);
                    window.addEventListener("mousewheel", function() {
                        obj1.close();
                    });
                    el.contextmenu = obj1;
                    return obj1;
                };
                return Component;
            }
            /* harmony default export */ var contextmenu = Contextmenu();
            function Dropdown() {
                var Component = function(el, options) {
                    // Already created, update options
                    if (el.dropdown) return el.dropdown.setOptions(options, true);
                    // New instance
                    var obj1 = {
                        type: "dropdown"
                    };
                    obj1.options = {};
                    // Success
                    var success = function(data, val) {
                        // Set data
                        if (data && data.length) {
                            // Sort
                            if (obj1.options.sortResults !== false) {
                                if (typeof obj1.options.sortResults == "function") data.sort(obj1.options.sortResults);
                                else data.sort(sortData);
                            }
                            obj1.setData(data);
                        }
                        // Onload method
                        if (typeof obj1.options.onload == "function") obj1.options.onload(el, obj1, data, val);
                        // Set value
                        if (val) applyValue(val);
                        // Component value
                        if (val === undefined || val === null) obj1.options.value = "";
                        el.value = obj1.options.value;
                        // Open dropdown
                        if (obj1.options.opened == true) obj1.open();
                    };
                    // Default sort
                    var sortData = function(itemA, itemB) {
                        var testA, testB;
                        if (typeof itemA == "string") testA = itemA;
                        else {
                            if (itemA.text) testA = itemA.text;
                            else if (itemA.name) testA = itemA.name;
                        }
                        if (typeof itemB == "string") testB = itemB;
                        else {
                            if (itemB.text) testB = itemB.text;
                            else if (itemB.name) testB = itemB.name;
                        }
                        if (typeof testA == "string" || typeof testB == "string") {
                            if (typeof testA != "string") testA = "" + testA;
                            if (typeof testB != "string") testB = "" + testB;
                            return testA.localeCompare(testB);
                        } else return testA - testB;
                    };
                    /**
         * Reset the options for the dropdown
         */ var resetValue = function() {
                        // Reset value container
                        obj1.value = {};
                        // Remove selected
                        for(var i = 0; i < obj1.items.length; i++)if (obj1.items[i].selected == true) {
                            if (obj1.items[i].element) obj1.items[i].element.classList.remove("jdropdown-selected");
                            obj1.items[i].selected = null;
                        }
                        // Reset options
                        obj1.options.value = "";
                        // Reset value
                        el.value = "";
                    };
                    /**
         * Apply values to the dropdown
         */ var applyValue = function(values) {
                        // Reset the current values
                        resetValue();
                        // Read values
                        if (values !== null) {
                            if (!values) {
                                if (typeof obj1.value[""] !== "undefined") obj1.value[""] = "";
                            } else {
                                if (!Array.isArray(values)) values = ("" + values).split(";");
                                for(var i = 0; i < values.length; i++)obj1.value[values[i]] = "";
                            }
                        }
                        // Update the DOM
                        for(var i = 0; i < obj1.items.length; i++)if (typeof obj1.value[Value(i)] !== "undefined") {
                            if (obj1.items[i].element) obj1.items[i].element.classList.add("jdropdown-selected");
                            obj1.items[i].selected = true;
                            // Keep label
                            obj1.value[Value(i)] = Text(i);
                        }
                        // Global value
                        obj1.options.value = Object.keys(obj1.value).join(";");
                        // Update labels
                        obj1.header.value = obj1.getText();
                    };
                    // Get the value of one item
                    var Value = function(k, v) {
                        // Legacy purposes
                        if (!obj1.options.format) var property = "value";
                        else var property = "id";
                        if (obj1.items[k]) {
                            if (v !== undefined) return obj1.items[k].data[property] = v;
                            else return obj1.items[k].data[property];
                        }
                        return "";
                    };
                    // Get the label of one item
                    var Text = function(k, v) {
                        // Legacy purposes
                        if (!obj1.options.format) var property = "text";
                        else var property = "name";
                        if (obj1.items[k]) {
                            if (v !== undefined) return obj1.items[k].data[property] = v;
                            else return obj1.items[k].data[property];
                        }
                        return "";
                    };
                    var getValue = function() {
                        return Object.keys(obj1.value);
                    };
                    var getText = function() {
                        var data = [];
                        var k = Object.keys(obj1.value);
                        for(var i = 0; i < k.length; i++)data.push(obj1.value[k[i]]);
                        return data;
                    };
                    obj1.setOptions = function(options, reset) {
                        if (!options) options = {};
                        // Default configuration
                        var defaults = {
                            url: null,
                            data: [],
                            format: 0,
                            multiple: false,
                            autocomplete: false,
                            remoteSearch: false,
                            lazyLoading: false,
                            type: null,
                            width: null,
                            maxWidth: null,
                            opened: false,
                            value: null,
                            placeholder: "",
                            newOptions: false,
                            position: false,
                            onchange: null,
                            onload: null,
                            onopen: null,
                            onclose: null,
                            onfocus: null,
                            onblur: null,
                            oninsert: null,
                            onbeforeinsert: null,
                            onsearch: null,
                            onbeforesearch: null,
                            sortResults: false,
                            autofocus: false,
                            prompt: null,
                            allowEmpty: true
                        };
                        // Loop through our object
                        for(var property in defaults){
                            if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                            else if (typeof obj1.options[property] == "undefined" || reset === true) obj1.options[property] = defaults[property];
                        }
                        // Force autocomplete search
                        if (obj1.options.remoteSearch == true || obj1.options.type === "searchbar") obj1.options.autocomplete = true;
                        // New options
                        if (obj1.options.newOptions == true) obj1.header.classList.add("jdropdown-add");
                        else obj1.header.classList.remove("jdropdown-add");
                        // Autocomplete
                        if (obj1.options.autocomplete == true) obj1.header.removeAttribute("readonly");
                        else obj1.header.setAttribute("readonly", "readonly");
                        // Place holder
                        if (obj1.options.placeholder) obj1.header.setAttribute("placeholder", obj1.options.placeholder);
                        else obj1.header.removeAttribute("placeholder");
                        // Remove specific dropdown typing to add again
                        el.classList.remove("jdropdown-searchbar");
                        el.classList.remove("jdropdown-picker");
                        el.classList.remove("jdropdown-list");
                        if (obj1.options.type == "searchbar") el.classList.add("jdropdown-searchbar");
                        else if (obj1.options.type == "list") el.classList.add("jdropdown-list");
                        else if (obj1.options.type == "picker") el.classList.add("jdropdown-picker");
                        else if (helpers.getWindowWidth() < 800) {
                            if (obj1.options.autocomplete) {
                                el.classList.add("jdropdown-searchbar");
                                obj1.options.type = "searchbar";
                            } else {
                                el.classList.add("jdropdown-picker");
                                obj1.options.type = "picker";
                            }
                        } else {
                            if (obj1.options.width) {
                                el.style.width = obj1.options.width;
                                el.style.minWidth = obj1.options.width;
                            } else {
                                el.style.removeProperty("width");
                                el.style.removeProperty("min-width");
                            }
                            el.classList.add("jdropdown-default");
                            obj1.options.type = "default";
                        }
                        // Close button
                        if (obj1.options.type == "searchbar") containerHeader.appendChild(closeButton);
                        else container.insertBefore(closeButton, container.firstChild);
                        // Load the content
                        if (obj1.options.url && !options.data) ajax({
                            url: obj1.options.url,
                            method: "GET",
                            dataType: "json",
                            success: function(data) {
                                if (data) success(data, obj1.options.value);
                            }
                        });
                        else success(obj1.options.data, obj1.options.value);
                        // Return the instance
                        return obj1;
                    };
                    // Helpers
                    var containerHeader = null;
                    var container = null;
                    var content = null;
                    var closeButton = null;
                    var resetButton = null;
                    var backdrop = null;
                    var keyTimer = null;
                    /**
         * Init dropdown
         */ var init = function() {
                        // Do not accept null
                        if (!options) options = {};
                        // If the element is a SELECT tag, create a configuration object
                        if (el.tagName == "SELECT") {
                            var ret = Component.extractFromDom(el, options);
                            el = ret.el;
                            options = ret.options;
                        }
                        // Place holder
                        if (!options.placeholder && el.getAttribute("placeholder")) options.placeholder = el.getAttribute("placeholder");
                        // Value container
                        obj1.value = {};
                        // Containers
                        obj1.items = [];
                        obj1.groups = [];
                        // Search options
                        obj1.search = "";
                        obj1.results = null;
                        // Create dropdown
                        el.classList.add("jdropdown");
                        // Header container
                        containerHeader = document.createElement("div");
                        containerHeader.className = "jdropdown-container-header";
                        // Header
                        obj1.header = document.createElement("input");
                        obj1.header.className = "jdropdown-header jss_object";
                        obj1.header.type = "text";
                        obj1.header.setAttribute("autocomplete", "off");
                        obj1.header.onfocus = function() {
                            if (typeof obj1.options.onfocus == "function") obj1.options.onfocus(el);
                        };
                        obj1.header.onblur = function() {
                            if (typeof obj1.options.onblur == "function") obj1.options.onblur(el);
                        };
                        obj1.header.onkeyup = function(e) {
                            if (obj1.options.autocomplete == true && !keyTimer) {
                                if (obj1.search != obj1.header.value.trim()) keyTimer = setTimeout(function() {
                                    obj1.find(obj1.header.value.trim());
                                    keyTimer = null;
                                }, 400);
                                if (!el.classList.contains("jdropdown-focus")) obj1.open();
                            } else if (!obj1.options.autocomplete) obj1.next(e.key);
                        };
                        // Global controls
                        if (!Component.hasEvents) {
                            // Execute only one time
                            Component.hasEvents = true;
                            // Enter and Esc
                            document.addEventListener("keydown", Component.keydown);
                        }
                        // Container
                        container = document.createElement("div");
                        container.className = "jdropdown-container";
                        // Dropdown content
                        content = document.createElement("div");
                        content.className = "jdropdown-content";
                        // Close button
                        closeButton = document.createElement("div");
                        closeButton.className = "jdropdown-close";
                        closeButton.textContent = "Done";
                        // Reset button
                        resetButton = document.createElement("div");
                        resetButton.className = "jdropdown-reset";
                        resetButton.textContent = "x";
                        resetButton.onclick = function() {
                            obj1.reset();
                            obj1.close();
                        };
                        // Create backdrop
                        backdrop = document.createElement("div");
                        backdrop.className = "jdropdown-backdrop";
                        // Append elements
                        containerHeader.appendChild(obj1.header);
                        container.appendChild(content);
                        el.appendChild(containerHeader);
                        el.appendChild(container);
                        el.appendChild(backdrop);
                        // Set the otiptions
                        obj1.setOptions(options);
                        if ("ontouchsend" in document.documentElement === true) el.addEventListener("touchsend", Component.mouseup);
                        else el.addEventListener("mouseup", Component.mouseup);
                        // Lazyloading
                        if (obj1.options.lazyLoading == true) LazyLoading(content, {
                            loadUp: obj1.loadUp,
                            loadDown: obj1.loadDown
                        });
                        content.onwheel = function(e) {
                            e.stopPropagation();
                        };
                        // Change method
                        el.change = obj1.setValue;
                        // Global generic value handler
                        el.val = function(val) {
                            if (val === undefined) return obj1.getValue(obj1.options.multiple ? true : false);
                            else obj1.setValue(val);
                        };
                        // Keep object available from the node
                        el.dropdown = obj1;
                    };
                    /**
         * Get the current remote source of data URL
         */ obj1.getUrl = function() {
                        return obj1.options.url;
                    };
                    /**
         * Set the new data from a remote source
         * @param {string} url - url from the remote source
         * @param {function} callback - callback when the data is loaded
         */ obj1.setUrl = function(url, callback) {
                        obj1.options.url = url;
                        ajax({
                            url: obj1.options.url,
                            method: "GET",
                            dataType: "json",
                            success: function(data) {
                                obj1.setData(data);
                                // Callback
                                if (typeof callback == "function") callback(obj1);
                            }
                        });
                    };
                    /**
         * Set ID for one item
         */ obj1.setId = function(item, v) {
                        // Legacy purposes
                        if (!obj1.options.format) var property = "value";
                        else var property = "id";
                        if (typeof item == "object") item[property] = v;
                        else obj1.items[item].data[property] = v;
                    };
                    const add = function(title, id) {
                        if (!title) {
                            let current = obj1.options.autocomplete == true ? obj1.header.value : "";
                            title = prompt(dictionary.translate("Add A New Option"), current);
                            if (!title) return false;
                        }
                        // Id
                        if (!id) id = helpers.guid();
                        // Create new item
                        if (!obj1.options.format) var item = {
                            value: id,
                            text: title
                        };
                        else var item = {
                            id: id,
                            name: title
                        };
                        // Callback
                        if (typeof obj1.options.onbeforeinsert == "function") {
                            let ret = obj1.options.onbeforeinsert(obj1, item);
                            if (ret === false) return false;
                            else if (ret) item = ret;
                        }
                        // Add item to the main list
                        obj1.options.data.push(item);
                        // Create DOM
                        var newItem = obj1.createItem(item);
                        // Append DOM to the list
                        content.appendChild(newItem.element);
                        // Callback
                        if (typeof obj1.options.oninsert == "function") obj1.options.oninsert(obj1, item, newItem);
                        // Show content
                        if (content.style.display == "none") content.style.display = "";
                        // Search?
                        if (obj1.results) obj1.results.push(newItem);
                        return item;
                    };
                    /**
         * Add a new item
         * @param {string} title - title of the new item
         * @param {string} id - value/id of the new item
         */ obj1.add = function(title, id) {
                        if (typeof obj1.options.prompt == "function") return obj1.options.prompt.call(obj1, add);
                        return add(title, id);
                    };
                    /**
         * Create a new item
         */ obj1.createItem = function(data, group, groupName) {
                        // Keep the correct source of data
                        if (!obj1.options.format) {
                            if (!data.value && data.id !== undefined) data.value = data.id;
                            if (!data.text && data.name !== undefined) data.text = data.name;
                        } else {
                            if (!data.id && data.value !== undefined) data.id = data.value;
                            if (!data.name && data.text !== undefined) data.name = data.text;
                        }
                        // Create item
                        var item = {};
                        item.element = document.createElement("div");
                        item.element.className = "jdropdown-item";
                        item.element.indexValue = obj1.items.length;
                        item.data = data;
                        // Groupd DOM
                        if (group) item.group = group;
                        // Id
                        if (data.id) item.element.setAttribute("id", data.id);
                        // Disabled
                        if (data.disabled == true) item.element.setAttribute("data-disabled", true);
                        // Tooltip
                        if (data.tooltip) item.element.setAttribute("title", data.tooltip);
                        // Image
                        if (data.image) {
                            var image = document.createElement("img");
                            image.className = "jdropdown-image";
                            image.src = data.image;
                            if (!data.title) image.classList.add("jdropdown-image-small");
                            item.element.appendChild(image);
                        } else if (data.icon) {
                            var icon = document.createElement("span");
                            icon.className = "jdropdown-icon material-icons";
                            icon.innerText = data.icon;
                            if (!data.title) icon.classList.add("jdropdown-icon-small");
                            if (data.color) icon.style.color = data.color;
                            item.element.appendChild(icon);
                        } else if (data.color) {
                            var color = document.createElement("div");
                            color.className = "jdropdown-color";
                            color.style.backgroundColor = data.color;
                            item.element.appendChild(color);
                        }
                        // Set content
                        if (!obj1.options.format) var text = data.text;
                        else var text = data.name;
                        var node = document.createElement("div");
                        node.className = "jdropdown-description";
                        node.textContent = text || "&nbsp;";
                        // Title
                        if (data.title) {
                            var title = document.createElement("div");
                            title.className = "jdropdown-title";
                            title.innerText = data.title;
                            node.appendChild(title);
                        }
                        // Set content
                        if (!obj1.options.format) var val = data.value;
                        else var val = data.id;
                        // Value
                        if (obj1.value[val]) {
                            item.element.classList.add("jdropdown-selected");
                            item.selected = true;
                        }
                        // Keep DOM accessible
                        obj1.items.push(item);
                        // Add node to item
                        item.element.appendChild(node);
                        return item;
                    };
                    obj1.appendData = function(data) {
                        // Create elements
                        if (data.length) {
                            // Helpers
                            var items = [];
                            var groups = [];
                            // Prepare data
                            for(var i = 0; i < data.length; i++)// Process groups
                            if (data[i].group) {
                                if (!groups[data[i].group]) groups[data[i].group] = [];
                                groups[data[i].group].push(i);
                            } else items.push(i);
                            // Number of items counter
                            var counter = 0;
                            // Groups
                            var groupNames = Object.keys(groups);
                            // Append groups in case exists
                            if (groupNames.length > 0) for(var i = 0; i < groupNames.length; i++){
                                // Group container
                                var group = document.createElement("div");
                                group.className = "jdropdown-group";
                                // Group name
                                var groupName = document.createElement("div");
                                groupName.className = "jdropdown-group-name";
                                groupName.textContent = groupNames[i];
                                // Group arrow
                                var groupArrow = document.createElement("i");
                                groupArrow.className = "jdropdown-group-arrow jdropdown-group-arrow-down";
                                groupName.appendChild(groupArrow);
                                // Group items
                                var groupContent = document.createElement("div");
                                groupContent.className = "jdropdown-group-items";
                                for(var j = 0; j < groups[groupNames[i]].length; j++){
                                    var item = obj1.createItem(data[groups[groupNames[i]][j]], group, groupNames[i]);
                                    if (obj1.options.lazyLoading == false || counter < 200) {
                                        groupContent.appendChild(item.element);
                                        counter++;
                                    }
                                }
                                // Group itens
                                group.appendChild(groupName);
                                group.appendChild(groupContent);
                                // Keep group DOM
                                obj1.groups.push(group);
                                // Only add to the screen if children on the group
                                if (groupContent.children.length > 0) // Add DOM to the content
                                content.appendChild(group);
                            }
                            if (items.length) for(var i = 0; i < items.length; i++){
                                var item = obj1.createItem(data[items[i]]);
                                if (obj1.options.lazyLoading == false || counter < 200) {
                                    content.appendChild(item.element);
                                    counter++;
                                }
                            }
                        }
                    };
                    obj1.setData = function(data) {
                        // Reset current value
                        resetValue();
                        // Make sure the content container is blank
                        content.textContent = "";
                        // Reset
                        obj1.header.value = "";
                        // Reset items and values
                        obj1.items = [];
                        // Prepare data
                        if (data && data.length) {
                            for(var i = 0; i < data.length; i++)// Compatibility
                            if (typeof data[i] != "object") {
                                // Correct format
                                if (!obj1.options.format) data[i] = {
                                    value: data[i],
                                    text: data[i]
                                };
                                else data[i] = {
                                    id: data[i],
                                    name: data[i]
                                };
                            }
                            // Append data
                            obj1.appendData(data);
                            // Update data
                            obj1.options.data = data;
                        } else // Update data
                        obj1.options.data = [];
                        obj1.close();
                    };
                    obj1.getData = function() {
                        return obj1.options.data;
                    };
                    /**
         * Get position of the item
         */ obj1.getPosition = function(val) {
                        for(var i = 0; i < obj1.items.length; i++){
                            if (Value(i) == val) return i;
                        }
                        return false;
                    };
                    /**
         * Get dropdown current text
         */ obj1.getText = function(asArray) {
                        // Get value
                        var v = getText();
                        // Return value
                        if (asArray) return v;
                        else return v.join("; ");
                    };
                    /**
         * Get dropdown current value
         */ obj1.getValue = function(asArray) {
                        // Get value
                        var v = getValue();
                        // Return value
                        if (asArray) return v;
                        else return v.join(";");
                    };
                    /**
         * Change event
         */ var change = function(oldValue) {
                        // Lemonade JS
                        if (el.value != obj1.options.value) {
                            el.value = obj1.options.value;
                            if (typeof el.oninput == "function") el.oninput({
                                type: "input",
                                target: el,
                                value: el.value
                            });
                        }
                        // Events
                        if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, obj1, oldValue, obj1.options.value);
                    };
                    /**
         * Set value
         */ obj1.setValue = function(newValue) {
                        // Current value
                        var oldValue = obj1.getValue();
                        // New value
                        if (Array.isArray(newValue)) newValue = newValue.join(";");
                        if (oldValue !== newValue) {
                            // Set value
                            applyValue(newValue);
                            // Change
                            change(oldValue);
                        }
                    };
                    obj1.resetSelected = function() {
                        obj1.setValue(null);
                    };
                    obj1.selectIndex = function(index, force) {
                        // Make sure is a number
                        var index = parseInt(index);
                        // Only select those existing elements
                        if (obj1.items && obj1.items[index] && (force === true || obj1.items[index].data.disabled !== true)) {
                            // Reset cursor to a new position
                            obj1.setCursor(index, false);
                            // Behaviour
                            if (!obj1.options.multiple) {
                                // Update value
                                if (obj1.items[index].selected) {
                                    if (obj1.options.allowEmpty !== false) obj1.setValue(null);
                                } else obj1.setValue(Value(index));
                                // Close component
                                obj1.close();
                            } else {
                                // Old value
                                var oldValue = obj1.options.value;
                                // Toggle option
                                if (obj1.items[index].selected) {
                                    obj1.items[index].element.classList.remove("jdropdown-selected");
                                    obj1.items[index].selected = false;
                                    delete obj1.value[Value(index)];
                                } else {
                                    // Select element
                                    obj1.items[index].element.classList.add("jdropdown-selected");
                                    obj1.items[index].selected = true;
                                    // Set value
                                    obj1.value[Value(index)] = Text(index);
                                }
                                // Global value
                                obj1.options.value = Object.keys(obj1.value).join(";");
                                // Update labels for multiple dropdown
                                if (obj1.options.autocomplete == false) obj1.header.value = getText().join("; ");
                                // Events
                                change(oldValue);
                            }
                        }
                    };
                    obj1.selectItem = function(item) {
                        obj1.selectIndex(item.indexValue);
                    };
                    var exists = function(k, result) {
                        for(var j = 0; j < result.length; j++)if (!obj1.options.format) {
                            if (result[j].value == k) return true;
                        } else {
                            if (result[j].id == k) return true;
                        }
                        return false;
                    };
                    obj1.find = function(str) {
                        if (obj1.search == str.trim()) return false;
                        // Search term
                        obj1.search = str;
                        // Reset index
                        obj1.setCursor();
                        // Remove nodes from all groups
                        if (obj1.groups.length) for(var i = 0; i < obj1.groups.length; i++)obj1.groups[i].lastChild.textContent = "";
                        // Remove all nodes
                        content.textContent = "";
                        // Remove current items in the remote search
                        if (obj1.options.remoteSearch == true) {
                            // Reset results
                            obj1.results = null;
                            // URL
                            var url = obj1.options.url;
                            // Ajax call
                            let o = {
                                url: url,
                                method: "GET",
                                data: {
                                    q: str
                                },
                                dataType: "json",
                                success: function(result) {
                                    // Reset items
                                    obj1.items = [];
                                    // Add the current selected items to the results in case they are not there
                                    var current = Object.keys(obj1.value);
                                    if (current.length) {
                                        for(var i = 0; i < current.length; i++)if (!exists(current[i], result)) {
                                            if (!obj1.options.format) result.unshift({
                                                value: current[i],
                                                text: obj1.value[current[i]]
                                            });
                                            else result.unshift({
                                                id: current[i],
                                                name: obj1.value[current[i]]
                                            });
                                        }
                                    }
                                    // Append data
                                    obj1.appendData(result);
                                    // Show or hide results
                                    if (!result.length) content.style.display = "none";
                                    else content.style.display = "";
                                    if (typeof obj1.options.onsearch === "function") obj1.options.onsearch(obj1, result);
                                }
                            };
                            if (typeof obj1.options.onbeforesearch === "function") {
                                let ret = obj1.options.onbeforesearch(obj1, o);
                                if (ret === false) return;
                                else if (typeof ret === "object") o = ret;
                            }
                            // Remote search
                            ajax(o);
                        } else {
                            // Search terms
                            str = new RegExp(str, "gi");
                            // Reset search
                            var results = [];
                            // Append options
                            for(var i = 0; i < obj1.items.length; i++){
                                // Item label
                                var label = Text(i);
                                // Item title
                                var title = obj1.items[i].data.title || "";
                                // Group name
                                var groupName = obj1.items[i].data.group || "";
                                // Synonym
                                var synonym = obj1.items[i].data.synonym || "";
                                if (synonym) synonym = synonym.join(" ");
                                if (str == null || obj1.items[i].selected == true || label.toString().match(str) || title.match(str) || groupName.match(str) || synonym.match(str)) results.push(obj1.items[i]);
                            }
                            if (!results.length) {
                                content.style.display = "none";
                                // Results
                                obj1.results = null;
                            } else {
                                content.style.display = "";
                                // Results
                                obj1.results = results;
                                // Show 200 items at once
                                var number = results.length || 0;
                                // Lazyloading
                                if (obj1.options.lazyLoading == true && number > 200) number = 200;
                                for(var i = 0; i < number; i++)if (obj1.results[i].group) {
                                    if (!obj1.results[i].group.parentNode) content.appendChild(obj1.results[i].group);
                                    obj1.results[i].group.lastChild.appendChild(obj1.results[i].element);
                                } else content.appendChild(obj1.results[i].element);
                            }
                        }
                        // Auto focus
                        if (obj1.options.autofocus == true) obj1.first();
                    };
                    obj1.open = function() {
                        // Focus
                        if (!el.classList.contains("jdropdown-focus")) {
                            // Current dropdown
                            Component.current = obj1;
                            // Start tracking
                            tracking(obj1, true);
                            // Add focus
                            el.classList.add("jdropdown-focus");
                            // Animation
                            if (helpers.getWindowWidth() < 800) {
                                if (obj1.options.type == null || obj1.options.type == "picker") animation.slideBottom(container, 1);
                            }
                            // Filter
                            if (obj1.options.autocomplete == true) {
                                obj1.header.value = obj1.search;
                                obj1.header.focus();
                            }
                            // Set cursor for the first or first selected element
                            var k = getValue();
                            if (k[0]) {
                                var cursor = obj1.getPosition(k[0]);
                                if (cursor !== false) obj1.setCursor(cursor);
                            }
                            // Container Size
                            if (!obj1.options.type || obj1.options.type == "default") {
                                var rect = el.getBoundingClientRect();
                                var rectContainer = container.getBoundingClientRect();
                                if (obj1.options.position) {
                                    container.style.position = "fixed";
                                    if (window.innerHeight < rect.bottom + rectContainer.height) {
                                        container.style.top = "";
                                        container.style.bottom = window.innerHeight - rect.top + 1 + "px";
                                    } else {
                                        container.style.top = rect.bottom + "px";
                                        container.style.bottom = "";
                                    }
                                    container.style.left = rect.left + "px";
                                } else if (window.innerHeight < rect.bottom + rectContainer.height) {
                                    container.style.top = "";
                                    container.style.bottom = rect.height + 1 + "px";
                                } else {
                                    container.style.top = "";
                                    container.style.bottom = "";
                                }
                                container.style.minWidth = rect.width + "px";
                                if (obj1.options.maxWidth) container.style.maxWidth = obj1.options.maxWidth;
                                if (!obj1.items.length && obj1.options.autocomplete == true) content.style.display = "none";
                                else content.style.display = "";
                            }
                        }
                        // Events
                        if (typeof obj1.options.onopen == "function") obj1.options.onopen(el);
                    };
                    obj1.close = function(ignoreEvents) {
                        if (el.classList.contains("jdropdown-focus")) {
                            // Update labels
                            obj1.header.value = obj1.getText();
                            // Remove cursor
                            obj1.setCursor();
                            // Events
                            if (!ignoreEvents && typeof obj1.options.onclose == "function") obj1.options.onclose(el);
                            // Blur
                            if (obj1.header.blur) obj1.header.blur();
                            // Remove focus
                            el.classList.remove("jdropdown-focus");
                            // Start tracking
                            tracking(obj1, false);
                            // Current dropdown
                            Component.current = null;
                        }
                        return obj1.getValue();
                    };
                    /**
         * Set cursor
         */ obj1.setCursor = function(index, setPosition) {
                        // Remove current cursor
                        if (obj1.currentIndex != null) // Remove visual cursor
                        {
                            if (obj1.items && obj1.items[obj1.currentIndex]) obj1.items[obj1.currentIndex].element.classList.remove("jdropdown-cursor");
                        }
                        if (index == undefined) obj1.currentIndex = null;
                        else {
                            index = parseInt(index);
                            // Cursor only for visible items
                            if (obj1.items[index].element.parentNode) {
                                obj1.items[index].element.classList.add("jdropdown-cursor");
                                obj1.currentIndex = index;
                                // Update scroll to the cursor element
                                if (setPosition !== false && obj1.items[obj1.currentIndex].element) {
                                    var container = content.scrollTop;
                                    var element = obj1.items[obj1.currentIndex].element;
                                    content.scrollTop = element.offsetTop - element.scrollTop + element.clientTop - 95;
                                }
                            }
                        }
                    };
                    // Compatibility
                    obj1.resetCursor = obj1.setCursor;
                    obj1.updateCursor = obj1.setCursor;
                    /**
         * Reset cursor and selected items
         */ obj1.reset = function() {
                        // Reset cursor
                        obj1.setCursor();
                        // Reset selected
                        obj1.setValue(null);
                    };
                    /**
         * First available item
         */ obj1.first = function() {
                        if (obj1.options.lazyLoading === true) obj1.loadFirst();
                        var items = content.querySelectorAll(".jdropdown-item");
                        if (items.length) {
                            var newIndex = items[0].indexValue;
                            obj1.setCursor(newIndex);
                        }
                    };
                    /**
         * Last available item
         */ obj1.last = function() {
                        if (obj1.options.lazyLoading === true) obj1.loadLast();
                        var items = content.querySelectorAll(".jdropdown-item");
                        if (items.length) {
                            var newIndex = items[items.length - 1].indexValue;
                            obj1.setCursor(newIndex);
                        }
                    };
                    obj1.next = function(letter) {
                        var newIndex = null;
                        if (letter) {
                            if (letter.length == 1) {
                                // Current index
                                var current = obj1.currentIndex || -1;
                                // Letter
                                letter = letter.toLowerCase();
                                var e = null;
                                var l = null;
                                var items = content.querySelectorAll(".jdropdown-item");
                                if (items.length) {
                                    for(var i = 0; i < items.length; i++)if (items[i].indexValue > current) {
                                        if (e = obj1.items[items[i].indexValue]) {
                                            if (l = e.element.innerText[0]) {
                                                l = l.toLowerCase();
                                                if (letter == l) {
                                                    newIndex = items[i].indexValue;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    obj1.setCursor(newIndex);
                                }
                            }
                        } else if (obj1.currentIndex == undefined || obj1.currentIndex == null) obj1.first();
                        else {
                            var element = obj1.items[obj1.currentIndex].element;
                            var next = element.nextElementSibling;
                            if (next) {
                                if (next.classList.contains("jdropdown-group")) next = next.lastChild.firstChild;
                                newIndex = next.indexValue;
                            } else if (element.parentNode.classList.contains("jdropdown-group-items")) {
                                if (next = element.parentNode.parentNode.nextElementSibling) {
                                    if (next.classList.contains("jdropdown-group")) next = next.lastChild.firstChild;
                                    else if (next.classList.contains("jdropdown-item")) newIndex = next.indexValue;
                                    else next = null;
                                }
                                if (next) newIndex = next.indexValue;
                            }
                            if (newIndex !== null) obj1.setCursor(newIndex);
                        }
                    };
                    obj1.prev = function() {
                        var newIndex = null;
                        if (obj1.currentIndex === null) obj1.first();
                        else {
                            var element = obj1.items[obj1.currentIndex].element;
                            var prev = element.previousElementSibling;
                            if (prev) {
                                if (prev.classList.contains("jdropdown-group")) prev = prev.lastChild.lastChild;
                                newIndex = prev.indexValue;
                            } else if (element.parentNode.classList.contains("jdropdown-group-items")) {
                                if (prev = element.parentNode.parentNode.previousElementSibling) {
                                    if (prev.classList.contains("jdropdown-group")) prev = prev.lastChild.lastChild;
                                    else if (prev.classList.contains("jdropdown-item")) newIndex = prev.indexValue;
                                    else prev = null;
                                }
                                if (prev) newIndex = prev.indexValue;
                            }
                        }
                        if (newIndex !== null) obj1.setCursor(newIndex);
                    };
                    obj1.loadFirst = function() {
                        // Search
                        if (obj1.results) var results = obj1.results;
                        else var results = obj1.items;
                        // Show 200 items at once
                        var number = results.length || 0;
                        // Lazyloading
                        if (obj1.options.lazyLoading == true && number > 200) number = 200;
                        // Reset container
                        content.textContent = "";
                        // First 200 items
                        for(var i = 0; i < number; i++)if (results[i].group) {
                            if (!results[i].group.parentNode) content.appendChild(results[i].group);
                            results[i].group.lastChild.appendChild(results[i].element);
                        } else content.appendChild(results[i].element);
                        // Scroll go to the begin
                        content.scrollTop = 0;
                    };
                    obj1.loadLast = function() {
                        // Search
                        if (obj1.results) var results = obj1.results;
                        else var results = obj1.items;
                        // Show first page
                        var number = results.length;
                        // Max 200 items
                        if (number > 200) {
                            number = number - 200;
                            // Reset container
                            content.textContent = "";
                            // First 200 items
                            for(var i = number; i < results.length; i++)if (results[i].group) {
                                if (!results[i].group.parentNode) content.appendChild(results[i].group);
                                results[i].group.lastChild.appendChild(results[i].element);
                            } else content.appendChild(results[i].element);
                            // Scroll go to the begin
                            content.scrollTop = content.scrollHeight;
                        }
                    };
                    obj1.loadUp = function() {
                        var test = false;
                        // Search
                        if (obj1.results) var results = obj1.results;
                        else var results = obj1.items;
                        var items = content.querySelectorAll(".jdropdown-item");
                        var fistItem = items[0].indexValue;
                        fistItem = obj1.items[fistItem];
                        var index = results.indexOf(fistItem) - 1;
                        if (index > 0) {
                            var number = 0;
                            while(index > 0 && results[index] && number < 200){
                                if (results[index].group) {
                                    if (!results[index].group.parentNode) content.insertBefore(results[index].group, content.firstChild);
                                    results[index].group.lastChild.insertBefore(results[index].element, results[index].group.lastChild.firstChild);
                                } else content.insertBefore(results[index].element, content.firstChild);
                                index--;
                                number++;
                            }
                            // New item added
                            test = true;
                        }
                        return test;
                    };
                    obj1.loadDown = function() {
                        var test = false;
                        // Search
                        if (obj1.results) var results = obj1.results;
                        else var results = obj1.items;
                        var items = content.querySelectorAll(".jdropdown-item");
                        var lastItem = items[items.length - 1].indexValue;
                        lastItem = obj1.items[lastItem];
                        var index = results.indexOf(lastItem) + 1;
                        if (index < results.length) {
                            var number = 0;
                            while(index < results.length && results[index] && number < 200){
                                if (results[index].group) {
                                    if (!results[index].group.parentNode) content.appendChild(results[index].group);
                                    results[index].group.lastChild.appendChild(results[index].element);
                                } else content.appendChild(results[index].element);
                                index++;
                                number++;
                            }
                            // New item added
                            test = true;
                        }
                        return test;
                    };
                    init();
                    return obj1;
                };
                Component.keydown = function(e) {
                    var dropdown = null;
                    if (dropdown = Component.current) {
                        if (e.which == 13 || e.which == 9) {
                            if (dropdown.header.value && dropdown.currentIndex == null && dropdown.options.newOptions) // if they typed something in, but it matched nothing, and newOptions are allowed, start that flow
                            dropdown.add();
                            else {
                                // Quick Select/Filter
                                if (dropdown.currentIndex == null && dropdown.options.autocomplete == true && dropdown.header.value != "") dropdown.find(dropdown.header.value);
                                dropdown.selectIndex(dropdown.currentIndex);
                            }
                        } else if (e.which == 38) {
                            if (dropdown.currentIndex == null) dropdown.first();
                            else if (dropdown.currentIndex > 0) dropdown.prev();
                            e.preventDefault();
                        } else if (e.which == 40) {
                            if (dropdown.currentIndex == null) dropdown.first();
                            else if (dropdown.currentIndex + 1 < dropdown.items.length) dropdown.next();
                            e.preventDefault();
                        } else if (e.which == 36) {
                            dropdown.first();
                            if (!e.target.classList.contains("jdropdown-header")) e.preventDefault();
                        } else if (e.which == 35) {
                            dropdown.last();
                            if (!e.target.classList.contains("jdropdown-header")) e.preventDefault();
                        } else if (e.which == 27) dropdown.close();
                        else if (e.which == 33) {
                            if (dropdown.currentIndex == null) dropdown.first();
                            else if (dropdown.currentIndex > 0) for(var i = 0; i < 7; i++)dropdown.prev();
                            e.preventDefault();
                        } else if (e.which == 34) {
                            if (dropdown.currentIndex == null) dropdown.first();
                            else if (dropdown.currentIndex + 1 < dropdown.items.length) for(var i = 0; i < 7; i++)dropdown.next();
                            e.preventDefault();
                        }
                    }
                };
                Component.mouseup = function(e) {
                    var element = helpers.findElement(e.target, "jdropdown");
                    if (element) {
                        var dropdown = element.dropdown;
                        if (e.target.classList.contains("jdropdown-header")) {
                            if (element.classList.contains("jdropdown-focus") && element.classList.contains("jdropdown-default")) {
                                var rect = element.getBoundingClientRect();
                                if (e.changedTouches && e.changedTouches[0]) {
                                    var x1 = e.changedTouches[0].clientX;
                                    var y1 = e.changedTouches[0].clientY;
                                } else {
                                    var x1 = e.clientX;
                                    var y1 = e.clientY;
                                }
                                if (rect.width - (x1 - rect.left) < 30) {
                                    if (e.target.classList.contains("jdropdown-add")) dropdown.add();
                                    else dropdown.close();
                                } else if (dropdown.options.autocomplete == false) dropdown.close();
                            } else dropdown.open();
                        } else if (e.target.classList.contains("jdropdown-group-name")) {
                            var items = e.target.nextSibling.children;
                            if (e.target.nextSibling.style.display != "none") {
                                for(var i = 0; i < items.length; i++)if (items[i].style.display != "none") dropdown.selectItem(items[i]);
                            }
                        } else if (e.target.classList.contains("jdropdown-group-arrow")) {
                            if (e.target.classList.contains("jdropdown-group-arrow-down")) {
                                e.target.classList.remove("jdropdown-group-arrow-down");
                                e.target.classList.add("jdropdown-group-arrow-up");
                                e.target.parentNode.nextSibling.style.display = "none";
                            } else {
                                e.target.classList.remove("jdropdown-group-arrow-up");
                                e.target.classList.add("jdropdown-group-arrow-down");
                                e.target.parentNode.nextSibling.style.display = "";
                            }
                        } else if (e.target.classList.contains("jdropdown-item")) dropdown.selectItem(e.target);
                        else if (e.target.classList.contains("jdropdown-image")) dropdown.selectItem(e.target.parentNode);
                        else if (e.target.classList.contains("jdropdown-description")) dropdown.selectItem(e.target.parentNode);
                        else if (e.target.classList.contains("jdropdown-title")) dropdown.selectItem(e.target.parentNode.parentNode);
                        else if (e.target.classList.contains("jdropdown-close") || e.target.classList.contains("jdropdown-backdrop")) dropdown.close();
                    }
                };
                Component.extractFromDom = function(el, options) {
                    // Keep reference
                    var select = el;
                    if (!options) options = {};
                    // Prepare configuration
                    if (el.getAttribute("multiple") && (!options || options.multiple == undefined)) options.multiple = true;
                    if (el.getAttribute("placeholder") && (!options || options.placeholder == undefined)) options.placeholder = el.getAttribute("placeholder");
                    if (el.getAttribute("data-autocomplete") && (!options || options.autocomplete == undefined)) options.autocomplete = true;
                    if (!options || options.width == undefined) options.width = el.offsetWidth;
                    if (el.value && (!options || options.value == undefined)) options.value = el.value;
                    if (!options || options.data == undefined) {
                        options.data = [];
                        for(var j = 0; j < el.children.length; j++){
                            if (el.children[j].tagName == "OPTGROUP") for(var i = 0; i < el.children[j].children.length; i++)options.data.push({
                                value: el.children[j].children[i].value,
                                text: el.children[j].children[i].textContent,
                                group: el.children[j].getAttribute("label")
                            });
                            else options.data.push({
                                value: el.children[j].value,
                                text: el.children[j].textContent
                            });
                        }
                    }
                    if (!options || options.onchange == undefined) options.onchange = function(a, b, c, d) {
                        if (options.multiple == true) {
                            if (obj.items[b].classList.contains("jdropdown-selected")) select.options[b].setAttribute("selected", "selected");
                            else select.options[b].removeAttribute("selected");
                        } else select.value = d;
                    };
                    // Create DIV
                    var div = document.createElement("div");
                    el.parentNode.insertBefore(div, el);
                    el.style.display = "none";
                    el = div;
                    return {
                        el: el,
                        options: options
                    };
                };
                return Component;
            }
            /* harmony default export */ var dropdown = Dropdown();
            function Picker(el, options) {
                // Already created, update options
                if (el.picker) return el.picker.setOptions(options, true);
                // New instance
                var obj1 = {
                    type: "picker"
                };
                obj1.options = {};
                var dropdownHeader = null;
                var dropdownContent = null;
                /**
     * The element passed is a DOM element
     */ var isDOM = function(o) {
                    return o instanceof Element || o instanceof HTMLDocument;
                };
                /**
     * Create the content options
     */ var createContent = function() {
                    dropdownContent.innerHTML = "";
                    // Create items
                    var keys = Object.keys(obj1.options.data);
                    // Go though all options
                    for(var i = 0; i < keys.length; i++){
                        // Item
                        var dropdownItem = document.createElement("div");
                        dropdownItem.classList.add("jpicker-item");
                        dropdownItem.setAttribute("role", "option");
                        dropdownItem.k = keys[i];
                        dropdownItem.v = obj1.options.data[keys[i]];
                        // Label
                        var item = obj1.getLabel(keys[i], dropdownItem);
                        if (isDOM(item)) dropdownItem.appendChild(item);
                        else dropdownItem.innerHTML = item;
                        // Append
                        dropdownContent.appendChild(dropdownItem);
                    }
                };
                /**
     * Set or reset the options for the picker
     */ obj1.setOptions = function(options, reset) {
                    // Default configuration
                    var defaults = {
                        value: 0,
                        data: null,
                        render: null,
                        onchange: null,
                        onmouseover: null,
                        onselect: null,
                        onopen: null,
                        onclose: null,
                        onload: null,
                        width: null,
                        header: true,
                        right: false,
                        bottom: false,
                        content: false,
                        columns: null,
                        grid: null,
                        height: null
                    };
                    // Legacy purpose only
                    if (options && options.options) options.data = options.options;
                    // Loop through the initial configuration
                    for(var property in defaults){
                        if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                        else if (typeof obj1.options[property] == "undefined" || reset === true) obj1.options[property] = defaults[property];
                    }
                    // Start using the options
                    if (obj1.options.header === false) dropdownHeader.style.display = "none";
                    else dropdownHeader.style.display = "";
                    // Width
                    if (obj1.options.width) dropdownHeader.style.width = parseInt(obj1.options.width) + "px";
                    else dropdownHeader.style.width = "";
                    // Height
                    if (obj1.options.height) {
                        dropdownContent.style.maxHeight = obj1.options.height + "px";
                        dropdownContent.style.overflow = "scroll";
                    } else dropdownContent.style.overflow = "";
                    if (obj1.options.columns > 0) {
                        if (!obj1.options.grid) {
                            dropdownContent.classList.add("jpicker-columns");
                            dropdownContent.style.width = obj1.options.width ? obj1.options.width : 36 * obj1.options.columns + "px";
                        } else {
                            dropdownContent.classList.add("jpicker-grid");
                            dropdownContent.style.gridTemplateColumns = "repeat(" + obj1.options.grid + ", 1fr)";
                        }
                    }
                    if (isNaN(parseInt(obj1.options.value))) obj1.options.value = 0;
                    // Create list from data
                    createContent();
                    // Set value
                    obj1.setValue(obj1.options.value);
                    // Set options all returns the own instance
                    return obj1;
                };
                obj1.getValue = function() {
                    return obj1.options.value;
                };
                obj1.setValue = function(k, e) {
                    // Set label
                    obj1.setLabel(k);
                    // Update value
                    obj1.options.value = String(k);
                    // Lemonade JS
                    if (el.value != obj1.options.value) {
                        el.value = obj1.options.value;
                        if (typeof el.oninput == "function") el.oninput({
                            type: "input",
                            target: el,
                            value: el.value
                        });
                    }
                    if (dropdownContent.children[k] && dropdownContent.children[k].getAttribute("type") !== "generic") obj1.close();
                    // Call method
                    if (e) {
                        if (typeof obj1.options.onchange == "function") {
                            var v = obj1.options.data[k];
                            obj1.options.onchange(el, obj1, v, v, k, e);
                        }
                    }
                };
                obj1.getLabel = function(v, item) {
                    var label = obj1.options.data[v] || null;
                    if (typeof obj1.options.render == "function") label = obj1.options.render(label, item);
                    return label;
                };
                obj1.setLabel = function(v) {
                    var item;
                    if (obj1.options.content) {
                        item = document.createElement("i");
                        item.textContent = obj1.options.content;
                        item.classList.add("material-icons");
                    } else item = obj1.getLabel(v, null);
                    // Label
                    if (isDOM(item)) {
                        dropdownHeader.textContent = "";
                        dropdownHeader.appendChild(item);
                    } else dropdownHeader.innerHTML = item;
                };
                obj1.open = function() {
                    if (!el.classList.contains("jpicker-focus")) {
                        // Start tracking the element
                        tracking(obj1, true);
                        // Open picker
                        el.classList.add("jpicker-focus");
                        el.focus();
                        var top = 0;
                        var left = 0;
                        dropdownContent.style.marginLeft = "";
                        var rectHeader = dropdownHeader.getBoundingClientRect();
                        var rectContent = dropdownContent.getBoundingClientRect();
                        if (window.innerHeight < rectHeader.bottom + rectContent.height || obj1.options.bottom) top = -1 * (rectContent.height + 4);
                        else top = rectHeader.height + 4;
                        if (obj1.options.right === true) left = -1 * rectContent.width + rectHeader.width;
                        if (rectContent.left + left < 0) left = left + rectContent.left + 10;
                        if (rectContent.left + rectContent.width > window.innerWidth) left = -1 * (10 + rectContent.left + rectContent.width - window.innerWidth);
                        dropdownContent.style.marginTop = parseInt(top) + "px";
                        dropdownContent.style.marginLeft = parseInt(left) + "px";
                        //dropdownContent.style.marginTop
                        if (typeof obj1.options.onopen == "function") obj1.options.onopen(el, obj1);
                    }
                };
                obj1.close = function() {
                    if (el.classList.contains("jpicker-focus")) {
                        el.classList.remove("jpicker-focus");
                        // Start tracking the element
                        tracking(obj1, false);
                        if (typeof obj1.options.onclose == "function") obj1.options.onclose(el, obj1);
                    }
                };
                /**
     * Create floating picker
     */ var init = function() {
                    let id = helpers.guid();
                    // Class
                    el.classList.add("jpicker");
                    el.setAttribute("role", "combobox");
                    el.setAttribute("aria-haspopup", "listbox");
                    el.setAttribute("aria-expanded", "false");
                    el.setAttribute("aria-controls", id);
                    el.setAttribute("tabindex", "0");
                    el.onmousedown = function(e) {
                        if (!el.classList.contains("jpicker-focus")) obj1.open();
                    };
                    // Dropdown Header
                    dropdownHeader = document.createElement("div");
                    dropdownHeader.classList.add("jpicker-header");
                    // Dropdown content
                    dropdownContent = document.createElement("div");
                    dropdownContent.setAttribute("id", id);
                    dropdownContent.setAttribute("role", "listbox");
                    dropdownContent.classList.add("jpicker-content");
                    dropdownContent.onclick = function(e) {
                        var item = helpers.findElement(e.target, "jpicker-item");
                        if (item) {
                            if (item.parentNode === dropdownContent) // Update label
                            obj1.setValue(item.k, e);
                        }
                    };
                    // Append content and header
                    el.appendChild(dropdownHeader);
                    el.appendChild(dropdownContent);
                    // Default value
                    el.value = options.value || 0;
                    // Set options
                    obj1.setOptions(options);
                    if (typeof obj1.options.onload == "function") obj1.options.onload(el, obj1);
                    // Change
                    el.change = obj1.setValue;
                    // Global generic value handler
                    el.val = function(val) {
                        if (val === undefined) return obj1.getValue();
                        else obj1.setValue(val);
                    };
                    // Reference
                    el.picker = obj1;
                };
                init();
                return obj1;
            }
            function Toolbar(el, options) {
                // New instance
                var obj1 = {
                    type: "toolbar"
                };
                obj1.options = {};
                // Default configuration
                var defaults = {
                    app: null,
                    container: false,
                    badge: false,
                    title: false,
                    responsive: false,
                    maxWidth: null,
                    bottom: true,
                    items: []
                };
                // Loop through our object
                for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                else obj1.options[property] = defaults[property];
                if (!el && options.app && options.app.el) {
                    el = document.createElement("div");
                    options.app.el.appendChild(el);
                }
                // Arrow
                var toolbarArrow = document.createElement("div");
                toolbarArrow.classList.add("jtoolbar-item");
                toolbarArrow.classList.add("jtoolbar-arrow");
                var toolbarFloating = document.createElement("div");
                toolbarFloating.classList.add("jtoolbar-floating");
                toolbarArrow.appendChild(toolbarFloating);
                obj1.selectItem = function(element) {
                    var elements = toolbarContent.children;
                    for(var i = 0; i < elements.length; i++)if (element != elements[i]) elements[i].classList.remove("jtoolbar-selected");
                    element.classList.add("jtoolbar-selected");
                };
                obj1.hide = function() {
                    animation.slideBottom(el, 0, function() {
                        el.style.display = "none";
                    });
                };
                obj1.show = function() {
                    el.style.display = "";
                    animation.slideBottom(el, 1);
                };
                obj1.get = function() {
                    return el;
                };
                obj1.setBadge = function(index, value) {
                    toolbarContent.children[index].children[1].firstChild.innerHTML = value;
                };
                obj1.destroy = function() {
                    toolbar.remove();
                    el.innerHTML = "";
                };
                obj1.update = function(a, b) {
                    for(var i = 0; i < toolbarContent.children.length; i++){
                        // Toolbar element
                        var toolbarItem = toolbarContent.children[i];
                        // State management
                        if (typeof toolbarItem.updateState == "function") toolbarItem.updateState(el, obj1, toolbarItem, a, b);
                    }
                    for(var i = 0; i < toolbarFloating.children.length; i++){
                        // Toolbar element
                        var toolbarItem = toolbarFloating.children[i];
                        // State management
                        if (typeof toolbarItem.updateState == "function") toolbarItem.updateState(el, obj1, toolbarItem, a, b);
                    }
                };
                obj1.create = function(items) {
                    // Reset anything in the toolbar
                    toolbarContent.innerHTML = "";
                    // Create elements in the toolbar
                    for(var i = 0; i < items.length; i++){
                        var toolbarItem = document.createElement("div");
                        toolbarItem.classList.add("jtoolbar-item");
                        if (items[i].width) toolbarItem.style.width = parseInt(items[i].width) + "px";
                        if (items[i].k) toolbarItem.k = items[i].k;
                        if (items[i].tooltip) {
                            toolbarItem.setAttribute("title", items[i].tooltip);
                            toolbarItem.setAttribute("aria-label", items[i].tooltip);
                        }
                        // Id
                        if (items[i].id) toolbarItem.setAttribute("id", items[i].id);
                        // Selected
                        if (items[i].updateState) toolbarItem.updateState = items[i].updateState;
                        if (items[i].active) toolbarItem.classList.add("jtoolbar-active");
                        if (items[i].disabled) toolbarItem.classList.add("jtoolbar-disabled");
                        if (items[i].type == "select" || items[i].type == "dropdown") Picker(toolbarItem, items[i]);
                        else if (items[i].type == "divisor") toolbarItem.classList.add("jtoolbar-divisor");
                        else if (items[i].type == "label") {
                            toolbarItem.classList.add("jtoolbar-label");
                            toolbarItem.innerHTML = items[i].content;
                        } else {
                            // Material icons
                            var toolbarIcon = document.createElement("i");
                            if (typeof items[i].class === "undefined") toolbarIcon.classList.add("material-icons");
                            else {
                                var c = items[i].class.split(" ");
                                for(var j = 0; j < c.length; j++)toolbarIcon.classList.add(c[j]);
                            }
                            toolbarIcon.innerHTML = items[i].content ? items[i].content : "";
                            toolbarItem.setAttribute("role", "button");
                            toolbarItem.appendChild(toolbarIcon);
                            // Badge options
                            if (obj1.options.badge == true) {
                                var toolbarBadge = document.createElement("div");
                                toolbarBadge.classList.add("jbadge");
                                var toolbarBadgeContent = document.createElement("div");
                                toolbarBadgeContent.innerHTML = items[i].badge ? items[i].badge : "";
                                toolbarBadge.appendChild(toolbarBadgeContent);
                                toolbarItem.appendChild(toolbarBadge);
                            }
                            // Title
                            if (items[i].title) {
                                if (obj1.options.title == true) {
                                    var toolbarTitle = document.createElement("span");
                                    toolbarTitle.innerHTML = items[i].title;
                                    toolbarItem.appendChild(toolbarTitle);
                                } else toolbarItem.setAttribute("title", items[i].title);
                            }
                            if (obj1.options.app && items[i].route) {
                                // Route
                                toolbarItem.route = items[i].route;
                                // Onclick for route
                                toolbarItem.onclick = function() {
                                    obj1.options.app.pages(this.route);
                                };
                                // Create pages
                                obj1.options.app.pages(items[i].route, {
                                    toolbarItem: toolbarItem,
                                    closed: true
                                });
                            }
                            // Render
                            if (typeof items[i].render === "function") items[i].render(toolbarItem, items[i]);
                        }
                        if (items[i].onclick) toolbarItem.onclick = items[i].onclick.bind(items[i], el, obj1, toolbarItem);
                        toolbarContent.appendChild(toolbarItem);
                    }
                    // Fits to the page
                    setTimeout(function() {
                        obj1.refresh();
                    }, 0);
                };
                obj1.open = function() {
                    toolbarArrow.classList.add("jtoolbar-arrow-selected");
                    var rectElement = el.getBoundingClientRect();
                    var rect = toolbarFloating.getBoundingClientRect();
                    if (rect.bottom > window.innerHeight || obj1.options.bottom) toolbarFloating.style.bottom = "0";
                    else toolbarFloating.style.removeProperty("bottom");
                    toolbarFloating.style.right = "0";
                    toolbarArrow.children[0].focus();
                    // Start tracking
                    tracking(obj1, true);
                };
                obj1.close = function() {
                    toolbarArrow.classList.remove("jtoolbar-arrow-selected");
                    // End tracking
                    tracking(obj1, false);
                };
                obj1.refresh = function() {
                    if (obj1.options.responsive == true) {
                        // Width of the c
                        var rect = el.parentNode.getBoundingClientRect();
                        if (!obj1.options.maxWidth) obj1.options.maxWidth = rect.width;
                        // Available parent space
                        var available = parseInt(obj1.options.maxWidth);
                        // Remove arrow
                        if (toolbarArrow.parentNode) toolbarArrow.parentNode.removeChild(toolbarArrow);
                        // Move all items to the toolbar
                        while(toolbarFloating.firstChild)toolbarContent.appendChild(toolbarFloating.firstChild);
                        // Toolbar is larger than the parent, move elements to the floating element
                        if (available < toolbarContent.offsetWidth) {
                            // Give space to the floating element
                            available -= 50;
                            // Move to the floating option
                            while(toolbarContent.lastChild && available < toolbarContent.offsetWidth)toolbarFloating.insertBefore(toolbarContent.lastChild, toolbarFloating.firstChild);
                        }
                        // Show arrow
                        if (toolbarFloating.children.length > 0) toolbarContent.appendChild(toolbarArrow);
                    }
                };
                obj1.setReadonly = function(state) {
                    state = state ? "add" : "remove";
                    el.classList[state]("jtoolbar-disabled");
                };
                el.onclick = function(e) {
                    var element = helpers.findElement(e.target, "jtoolbar-item");
                    if (element) obj1.selectItem(element);
                    if (e.target.classList.contains("jtoolbar-arrow")) obj1.open();
                };
                window.addEventListener("resize", function() {
                    obj1.refresh();
                });
                // Toolbar
                el.classList.add("jtoolbar");
                // Reset content
                el.innerHTML = "";
                // Container
                if (obj1.options.container == true) el.classList.add("jtoolbar-container");
                // Content
                var toolbarContent = document.createElement("div");
                el.appendChild(toolbarContent);
                // Special toolbar for mobile applications
                if (obj1.options.app) el.classList.add("jtoolbar-mobile");
                // Create toolbar
                obj1.create(obj1.options.items);
                // Shortcut
                el.toolbar = obj1;
                return obj1;
            }
            // Valid tags
            const validTags = [
                "html",
                "body",
                "address",
                "span",
                "div",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "p",
                "b",
                "i",
                "blockquote",
                "strong",
                "em",
                "ul",
                "ol",
                "li",
                "a",
                "code",
                "pre",
                "hr",
                "br",
                "img",
                "figure",
                "picture",
                "figcaption",
                "iframe",
                "table",
                "thead",
                "tbody",
                "tfoot",
                "tr",
                "th",
                "td",
                "caption",
                "u",
                "del",
                "ins",
                "sub",
                "sup",
                "small",
                "mark",
                "input",
                "textarea",
                "select",
                "option",
                "button",
                "label",
                "fieldset",
                "legend",
                "audio",
                "video",
                "abbr",
                "cite",
                "kbd",
                "section",
                "article",
                "nav",
                "aside",
                "header",
                "footer",
                "main",
                "details",
                "summary",
                "svg",
                "line",
                "source"
            ];
            // Valid properties
            const validProperty = [
                "width",
                "height",
                "align",
                "border",
                "src",
                "tabindex"
            ];
            // Valid CSS attributes
            const validStyle = [
                "color",
                "font-weight",
                "font-size",
                "background",
                "background-color",
                "margin"
            ];
            const parse = function(element, img) {
                // Remove elements that are not white-listed
                if (element.tagName && validTags.indexOf(element.tagName.toLowerCase()) === -1) {
                    if (element.innerText) element.innerHTML = element.innerText;
                }
                // Remove attributes
                if (element.attributes && element.attributes.length) {
                    let style = null;
                    // Process style attribute
                    let elementStyle = element.getAttribute("style");
                    if (elementStyle) {
                        style = [];
                        let t = elementStyle.split(";");
                        for(let j = 0; j < t.length; j++){
                            let v = t[j].trim().split(":");
                            if (validStyle.indexOf(v[0].trim()) >= 0) {
                                let k = v.shift();
                                v = v.join(":");
                                style.push(k + ":" + v);
                            }
                        }
                    }
                    // Process image
                    if (element.tagName.toUpperCase() === "IMG") {
                        if (!element.src) element.parentNode.removeChild(element);
                        else {
                            // Check if is data
                            element.setAttribute("tabindex", "900");
                            // Check attributes for persistence
                            img.push(element.src);
                        }
                    }
                    // Remove attributes
                    let attr = [];
                    for(let i = 0; i < element.attributes.length; i++)attr.push(element.attributes[i].name);
                    if (attr.length) attr.forEach(function(v) {
                        if (validProperty.indexOf(v) === -1) element.removeAttribute(v);
                        else {
                            // Protection XSS
                            let at = element.getAttribute(v);
                            if (at.indexOf("<") !== -1) element.setAttribute(v, at.replace("<", "&#60;"));
                        }
                    });
                    element.style = "";
                    // Add valid style
                    if (style && style.length) element.setAttribute("style", style.join(";"));
                }
                // Parse children
                if (element.children.length) for(let i = element.children.length; i > 0; i--)parse(element.children[i - 1], img);
            };
            const filter = function(data, img) {
                if (data) data = data.replace(new RegExp("<!--(.*?)-->", "gsi"), "");
                let parser = new DOMParser();
                let d = parser.parseFromString(data, "text/html");
                parse(d, img);
                let div = document.createElement("div");
                div.innerHTML = d.firstChild.innerHTML;
                return div;
            };
            /* harmony default export */ var utils_filter = filter;
            function Editor() {
                var Component = function(el, options) {
                    // New instance
                    var obj1 = {
                        type: "editor"
                    };
                    obj1.options = {};
                    // Default configuration
                    var defaults = {
                        // Load data from a remove location
                        url: null,
                        // Initial HTML content
                        value: "",
                        // Initial snippet
                        snippet: null,
                        // Add toolbar
                        toolbar: true,
                        toolbarOnTop: false,
                        // Website parser is to read websites and images from cross domain
                        remoteParser: null,
                        // Placeholder
                        placeholder: null,
                        // Parse URL
                        filterPaste: true,
                        // Accept drop files
                        dropZone: true,
                        dropAsSnippet: false,
                        acceptImages: true,
                        acceptFiles: false,
                        maxFileSize: 5000000,
                        allowImageResize: true,
                        // Style
                        maxHeight: null,
                        height: null,
                        focus: false,
                        // Events
                        onclick: null,
                        onfocus: null,
                        onblur: null,
                        onload: null,
                        onkeyup: null,
                        onkeydown: null,
                        onchange: null,
                        extensions: null,
                        type: null
                    };
                    // Loop through our object
                    for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                    else obj1.options[property] = defaults[property];
                    // Private controllers
                    var editorTimer = null;
                    var editorAction = null;
                    var files = [];
                    // Keep the reference for the container
                    obj1.el = el;
                    if (typeof obj1.options.onclick == "function") el.onclick = function(e) {
                        obj1.options.onclick(el, obj1, e);
                    };
                    // Prepare container
                    el.classList.add("jeditor-container");
                    // Snippet
                    var snippet = document.createElement("div");
                    snippet.className = "jsnippet";
                    snippet.setAttribute("contenteditable", false);
                    // Toolbar
                    var toolbar1 = document.createElement("div");
                    toolbar1.className = "jeditor-toolbar";
                    obj1.editor = document.createElement("div");
                    obj1.editor.setAttribute("contenteditable", true);
                    obj1.editor.setAttribute("spellcheck", false);
                    obj1.editor.classList.add("jeditor");
                    // Placeholder
                    if (obj1.options.placeholder) obj1.editor.setAttribute("data-placeholder", obj1.options.placeholder);
                    // Max height
                    if (obj1.options.maxHeight || obj1.options.height) {
                        obj1.editor.style.overflowY = "auto";
                        if (obj1.options.maxHeight) obj1.editor.style.maxHeight = obj1.options.maxHeight;
                        if (obj1.options.height) obj1.editor.style.height = obj1.options.height;
                    }
                    // Set editor initial value
                    if (obj1.options.url) ajax({
                        url: obj1.options.url,
                        dataType: "html",
                        success: function(result) {
                            obj1.editor.innerHTML = result;
                            Component.setCursor(obj1.editor, obj1.options.focus == "initial" ? true : false);
                        }
                    });
                    else {
                        if (obj1.options.value) obj1.editor.innerHTML = obj1.options.value;
                        else // Create from existing elements
                        for(var i = 0; i < el.children.length; i++)obj1.editor.appendChild(el.children[i]);
                    }
                    // Make sure element is empty
                    el.innerHTML = "";
                    /**
         * Onchange event controllers
         */ var change = function(e) {
                        if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, obj1, e);
                        // Update value
                        obj1.options.value = obj1.getData();
                        // Lemonade JS
                        if (el.value != obj1.options.value) {
                            el.value = obj1.options.value;
                            if (typeof el.oninput == "function") el.oninput({
                                type: "input",
                                target: el,
                                value: el.value
                            });
                        }
                    };
                    /**
         * Extract images from a HTML string
         */ var extractImageFromHtml = function(html) {
                        let img = [];
                        // Create temp element
                        var div = document.createElement("div");
                        utils_filter(html, img);
                        if (img.length) for(var i = 0; i < img.length; i++)obj1.addImage(img[i]);
                    };
                    /**
         * Insert node at caret
         */ var insertNodeAtCaret = function(newNode) {
                        var sel, range;
                        if (window.getSelection) {
                            sel = window.getSelection();
                            if (sel.rangeCount) {
                                range = sel.getRangeAt(0);
                                var selectedText = range.toString();
                                range.deleteContents();
                                range.insertNode(newNode);
                                // move the cursor after element
                                range.setStartAfter(newNode);
                                range.setEndAfter(newNode);
                                sel.removeAllRanges();
                                sel.addRange(range);
                            }
                        }
                    };
                    var updateTotalImages = function() {
                        var o = null;
                        if (o = snippet.children[0]) {
                            // Make sure is a grid
                            if (!o.classList.contains("jslider-grid")) o.classList.add("jslider-grid");
                            // Quantify of images
                            var number = o.children.length;
                            // Set the configuration of the grid
                            o.setAttribute("data-number", number > 4 ? 4 : number);
                            // Total of images inside the grid
                            if (number > 4) o.setAttribute("data-total", number - 4);
                            else o.removeAttribute("data-total");
                        }
                    };
                    /**
         * Append image to the snippet
         */ var appendImage = function(image) {
                        if (!snippet.innerHTML) obj1.appendSnippet({});
                        snippet.children[0].appendChild(image);
                        updateTotalImages();
                    };
                    /**
         * Append snippet
         * @Param object data
         */ obj1.appendSnippet = function(data) {
                        // Reset snippet
                        snippet.innerHTML = "";
                        // Attributes
                        var a = [
                            "image",
                            "title",
                            "description",
                            "host",
                            "url"
                        ];
                        for(var i = 0; i < a.length; i++){
                            var div = document.createElement("div");
                            div.className = "jsnippet-" + a[i];
                            div.setAttribute("data-k", a[i]);
                            snippet.appendChild(div);
                            if (data[a[i]]) {
                                if (a[i] == "image") {
                                    if (!Array.isArray(data.image)) data.image = [
                                        data.image
                                    ];
                                    for(var j = 0; j < data.image.length; j++){
                                        var img = document.createElement("img");
                                        img.src = data.image[j];
                                        div.appendChild(img);
                                    }
                                } else div.innerHTML = data[a[i]];
                            }
                        }
                        obj1.editor.appendChild(document.createElement("br"));
                        obj1.editor.appendChild(snippet);
                    };
                    /**
         * Set editor value
         */ obj1.setData = function(o) {
                        if (typeof o == "object") obj1.editor.innerHTML = o.content;
                        else obj1.editor.innerHTML = o;
                        if (obj1.options.focus) Component.setCursor(obj1.editor, true);
                        // Reset files container
                        files = [];
                    };
                    obj1.getFiles = function() {
                        var f = obj1.editor.querySelectorAll(".jfile");
                        var d = [];
                        for(var i = 0; i < f.length; i++)if (files[f[i].src]) d.push(files[f[i].src]);
                        return d;
                    };
                    obj1.getText = function() {
                        return obj1.editor.innerText;
                    };
                    /**
         * Get editor data
         */ obj1.getData = function(json) {
                        if (!json) var data = obj1.editor.innerHTML;
                        else {
                            var data = {
                                content: ""
                            };
                            // Get snippet
                            if (snippet.innerHTML) {
                                var index = 0;
                                data.snippet = {};
                                for(var i = 0; i < snippet.children.length; i++){
                                    // Get key from element
                                    var key = snippet.children[i].getAttribute("data-k");
                                    if (key) {
                                        if (key == "image") {
                                            if (!data.snippet.image) data.snippet.image = [];
                                            // Get all images
                                            for(var j = 0; j < snippet.children[i].children.length; j++)data.snippet.image.push(snippet.children[i].children[j].getAttribute("src"));
                                        } else data.snippet[key] = snippet.children[i].innerHTML;
                                    }
                                }
                            }
                            // Get files
                            var f = Object.keys(files);
                            if (f.length) {
                                data.files = [];
                                for(var i = 0; i < f.length; i++)data.files.push(files[f[i]]);
                            }
                            // Get content
                            var d = document.createElement("div");
                            d.innerHTML = obj1.editor.innerHTML;
                            var s = d.querySelector(".jsnippet");
                            if (s) s.remove();
                            var text = d.innerHTML;
                            text = text.replace(/<br>/g, "\n");
                            text = text.replace(/<\/div>/g, "</div>\n");
                            text = text.replace(/<(?:.|\n)*?>/gm, "");
                            data.content = text.trim();
                            // Process extensions
                            processExtensions("getData", data);
                        }
                        return data;
                    };
                    // Reset
                    obj1.reset = function() {
                        obj1.editor.innerHTML = "";
                        snippet.innerHTML = "";
                        files = [];
                    };
                    obj1.addPdf = function(data) {
                        if (data.result.substr(0, 4) != "data") console.error("Invalid source");
                        else {
                            var canvas = document.createElement("canvas");
                            canvas.width = 60;
                            canvas.height = 60;
                            var img = new Image();
                            var ctx = canvas.getContext("2d");
                            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                            canvas.toBlob(function(blob) {
                                var newImage = document.createElement("img");
                                newImage.src = window.URL.createObjectURL(blob);
                                newImage.title = data.name;
                                newImage.className = "jfile pdf";
                                files[newImage.src] = {
                                    file: newImage.src,
                                    extension: "pdf",
                                    content: data.result
                                };
                                //insertNodeAtCaret(newImage);
                                document.execCommand("insertHtml", false, newImage.outerHTML);
                            });
                        }
                    };
                    obj1.addImage = function(src, asSnippet) {
                        if (!obj1.options.acceptImages) return;
                        if (!src) src = "";
                        if (src.substr(0, 4) != "data" && !obj1.options.remoteParser) console.error("remoteParser not defined in your initialization");
                        else {
                            // This is to process cross domain images
                            if (src.substr(0, 4) == "data") {
                                var extension = src.split(";");
                                extension = extension[0].split("/");
                                extension = extension[1];
                            } else {
                                var extension = src.substr(src.lastIndexOf(".") + 1);
                                // Work for cross browsers
                                src = obj1.options.remoteParser + src;
                            }
                            var img = new Image();
                            img.onload = function onload() {
                                var canvas = document.createElement("canvas");
                                canvas.width = img.width;
                                canvas.height = img.height;
                                var ctx = canvas.getContext("2d");
                                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                                canvas.toBlob(function(blob) {
                                    var newImage = document.createElement("img");
                                    newImage.src = window.URL.createObjectURL(blob);
                                    newImage.classList.add("jfile");
                                    newImage.setAttribute("tabindex", "900");
                                    newImage.setAttribute("width", img.width);
                                    newImage.setAttribute("height", img.height);
                                    files[newImage.src] = {
                                        file: newImage.src,
                                        extension: extension,
                                        content: canvas.toDataURL()
                                    };
                                    if (obj1.options.dropAsSnippet || asSnippet) {
                                        appendImage(newImage);
                                        // Just to understand the attachment is part of a snippet
                                        files[newImage.src].snippet = true;
                                    } else //insertNodeAtCaret(newImage);
                                    document.execCommand("insertHtml", false, newImage.outerHTML);
                                    change();
                                });
                            };
                            img.src = src;
                        }
                    };
                    obj1.addFile = function(files) {
                        var reader = [];
                        for(var i = 0; i < files.length; i++)if (files[i].size > obj1.options.maxFileSize) alert("The file is too big");
                        else {
                            // Only PDF or Images
                            var type = files[i].type.split("/");
                            if (type[0] == "image") type = 1;
                            else if (type[1] == "pdf") type = 2;
                            else type = 0;
                            if (type) {
                                // Create file
                                reader[i] = new FileReader();
                                reader[i].index = i;
                                reader[i].type = type;
                                reader[i].name = files[i].name;
                                reader[i].date = files[i].lastModified;
                                reader[i].size = files[i].size;
                                reader[i].addEventListener("load", function(data) {
                                    // Get result
                                    if (data.target.type == 2) {
                                        if (obj1.options.acceptFiles == true) obj1.addPdf(data.target);
                                    } else obj1.addImage(data.target.result);
                                }, false);
                                reader[i].readAsDataURL(files[i]);
                            } else alert("The extension is not allowed");
                        }
                    };
                    // Destroy
                    obj1.destroy = function() {
                        obj1.editor.removeEventListener("mouseup", editorMouseUp);
                        obj1.editor.removeEventListener("mousedown", editorMouseDown);
                        obj1.editor.removeEventListener("mousemove", editorMouseMove);
                        obj1.editor.removeEventListener("keyup", editorKeyUp);
                        obj1.editor.removeEventListener("keydown", editorKeyDown);
                        obj1.editor.removeEventListener("dragstart", editorDragStart);
                        obj1.editor.removeEventListener("dragenter", editorDragEnter);
                        obj1.editor.removeEventListener("dragover", editorDragOver);
                        obj1.editor.removeEventListener("drop", editorDrop);
                        obj1.editor.removeEventListener("paste", editorPaste);
                        obj1.editor.removeEventListener("blur", editorBlur);
                        obj1.editor.removeEventListener("focus", editorFocus);
                        el.editor = null;
                        el.classList.remove("jeditor-container");
                        toolbar1.remove();
                        snippet.remove();
                        obj1.editor.remove();
                    };
                    obj1.upload = function() {
                        helpers.click(obj1.file);
                    };
                    var select = function(e) {
                        var s = window.getSelection();
                        var r = document.createRange();
                        r.selectNode(e);
                        s.addRange(r);
                    };
                    var editorPaste = function(e) {
                        if (obj1.options.filterPaste == true) {
                            if (e.clipboardData || e.originalEvent.clipboardData) {
                                var html = (e.originalEvent || e).clipboardData.getData("text/html");
                                var text = (e.originalEvent || e).clipboardData.getData("text/plain");
                                var file = (e.originalEvent || e).clipboardData.files;
                            } else if (window.clipboardData) {
                                var html = window.clipboardData.getData("Html");
                                var text = window.clipboardData.getData("Text");
                                var file = window.clipboardData.files;
                            }
                            if (file.length) // Paste a image from the clipboard
                            obj1.addFile(file);
                            else if (!html) {
                                html = text.split("\r\n");
                                if (!e.target.innerText) html.map(function(v) {
                                    var d = document.createElement("div");
                                    d.innerText = v;
                                    obj1.editor.appendChild(d);
                                });
                                else {
                                    html = html.map(function(v) {
                                        return "<div>" + v + "</div>";
                                    });
                                    document.execCommand("insertText", false, html.join(""));
                                }
                            } else {
                                let img = [];
                                var d = utils_filter(html, img);
                                if (img.length) for(var i = 0; i < img.length; i++)obj1.addImage(img[i]);
                                // Paste to the editor
                                //insertNodeAtCaret(d);
                                document.execCommand("insertHtml", false, d.innerHTML);
                            }
                            e.preventDefault();
                        }
                    };
                    var editorDragStart = function(e) {
                        if (editorAction && editorAction.e) e.preventDefault();
                    };
                    var editorDragEnter = function(e) {
                        if (editorAction || obj1.options.dropZone == false) ;
                        else {
                            el.classList.add("jeditor-dragging");
                            e.preventDefault();
                        }
                    };
                    var editorDragOver = function(e) {
                        if (editorAction || obj1.options.dropZone == false) ;
                        else {
                            if (editorTimer) clearTimeout(editorTimer);
                            editorTimer = setTimeout(function() {
                                el.classList.remove("jeditor-dragging");
                            }, 100);
                            e.preventDefault();
                        }
                    };
                    var editorDrop = function(e) {
                        if (editorAction || obj1.options.dropZone === false) ;
                        else {
                            // Position caret on the drop
                            let range = null;
                            if (document.caretRangeFromPoint) range = document.caretRangeFromPoint(e.clientX, e.clientY);
                            else if (e.rangeParent) {
                                range = document.createRange();
                                range.setStart(e.rangeParent, e.rangeOffset);
                            }
                            let sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                            sel.anchorNode.parentNode.focus();
                            let html = (e.originalEvent || e).dataTransfer.getData("text/html");
                            let text = (e.originalEvent || e).dataTransfer.getData("text/plain");
                            let file = (e.originalEvent || e).dataTransfer.files;
                            if (file.length) obj1.addFile(file);
                            else if (text) extractImageFromHtml(html);
                            el.classList.remove("jeditor-dragging");
                            e.preventDefault();
                        }
                    };
                    var editorBlur = function(e) {
                        // Process extensions
                        processExtensions("onevent", e);
                        // Apply changes
                        change(e);
                        // Blur
                        if (typeof obj1.options.onblur == "function") obj1.options.onblur(el, obj1, e);
                    };
                    var editorFocus = function(e) {
                        // Focus
                        if (typeof obj1.options.onfocus == "function") obj1.options.onfocus(el, obj1, e);
                    };
                    var editorKeyUp = function(e) {
                        if (!obj1.editor.innerHTML) obj1.editor.innerHTML = "<div><br></div>";
                        if (typeof obj1.options.onkeyup == "function") obj1.options.onkeyup(el, obj1, e);
                    };
                    var editorKeyDown = function(e) {
                        // Process extensions
                        processExtensions("onevent", e);
                        if (e.key == "Delete") {
                            if (e.target.tagName == "IMG") {
                                var parent = e.target.parentNode;
                                select(e.target);
                                if (parent.classList.contains("jsnippet-image")) updateTotalImages();
                            }
                        }
                        if (typeof obj1.options.onkeydown == "function") obj1.options.onkeydown(el, obj1, e);
                    };
                    var editorMouseUp = function(e) {
                        if (editorAction && editorAction.e) {
                            editorAction.e.classList.remove("resizing");
                            if (editorAction.e.changed == true) {
                                var image = editorAction.e.cloneNode();
                                image.width = parseInt(editorAction.e.style.width) || editorAction.e.getAttribute("width");
                                image.height = parseInt(editorAction.e.style.height) || editorAction.e.getAttribute("height");
                                editorAction.e.style.width = "";
                                editorAction.e.style.height = "";
                                select(editorAction.e);
                                document.execCommand("insertHtml", false, image.outerHTML);
                            }
                        }
                        editorAction = false;
                    };
                    var editorMouseDown = function(e) {
                        var close = function(snippet) {
                            var rect = snippet.getBoundingClientRect();
                            if (rect.width - (e.clientX - rect.left) < 40 && e.clientY - rect.top < 40) {
                                snippet.innerHTML = "";
                                snippet.remove();
                            }
                        };
                        if (e.target.tagName == "IMG") {
                            if (e.target.style.cursor) {
                                var rect = e.target.getBoundingClientRect();
                                editorAction = {
                                    e: e.target,
                                    x: e.clientX,
                                    y: e.clientY,
                                    w: rect.width,
                                    h: rect.height,
                                    d: e.target.style.cursor
                                };
                                if (!e.target.getAttribute("width")) e.target.setAttribute("width", rect.width);
                                if (!e.target.getAttribute("height")) e.target.setAttribute("height", rect.height);
                                var s = window.getSelection();
                                if (s.rangeCount) for(var i = 0; i < s.rangeCount; i++)s.removeRange(s.getRangeAt(i));
                                e.target.classList.add("resizing");
                            } else editorAction = true;
                        } else {
                            if (e.target.classList.contains("jsnippet")) close(e.target);
                            else if (e.target.parentNode.classList.contains("jsnippet")) close(e.target.parentNode);
                            editorAction = true;
                        }
                    };
                    var editorMouseMove = function(e) {
                        if (e.target.tagName == "IMG" && !e.target.parentNode.classList.contains("jsnippet-image") && obj1.options.allowImageResize == true) {
                            if (e.target.getAttribute("tabindex")) {
                                var rect = e.target.getBoundingClientRect();
                                if (e.clientY - rect.top < 5) {
                                    if (rect.width - (e.clientX - rect.left) < 5) e.target.style.cursor = "ne-resize";
                                    else if (e.clientX - rect.left < 5) e.target.style.cursor = "nw-resize";
                                    else e.target.style.cursor = "n-resize";
                                } else if (rect.height - (e.clientY - rect.top) < 5) {
                                    if (rect.width - (e.clientX - rect.left) < 5) e.target.style.cursor = "se-resize";
                                    else if (e.clientX - rect.left < 5) e.target.style.cursor = "sw-resize";
                                    else e.target.style.cursor = "s-resize";
                                } else if (rect.width - (e.clientX - rect.left) < 5) e.target.style.cursor = "e-resize";
                                else if (e.clientX - rect.left < 5) e.target.style.cursor = "w-resize";
                                else e.target.style.cursor = "";
                            }
                        }
                        // Move
                        if (e.which == 1 && editorAction && editorAction.d) {
                            if (editorAction.d == "e-resize" || editorAction.d == "ne-resize" || editorAction.d == "se-resize") {
                                editorAction.e.style.width = editorAction.w + (e.clientX - editorAction.x);
                                if (e.shiftKey) {
                                    var newHeight = (e.clientX - editorAction.x) * (editorAction.h / editorAction.w);
                                    editorAction.e.style.height = editorAction.h + newHeight;
                                } else var newHeight = null;
                            }
                            if (!newHeight) {
                                if (editorAction.d == "s-resize" || editorAction.d == "se-resize" || editorAction.d == "sw-resize") {
                                    if (!e.shiftKey) editorAction.e.style.height = editorAction.h + (e.clientY - editorAction.y);
                                }
                            }
                            editorAction.e.changed = true;
                        }
                    };
                    var processExtensions = function(method, data) {
                        if (obj1.options.extensions) {
                            var ext = Object.keys(obj1.options.extensions);
                            if (ext.length) {
                                for(var i = 0; i < ext.length; i++)if (obj1.options.extensions[ext[i]] && typeof obj1.options.extensions[ext[i]][method] == "function") obj1.options.extensions[ext[i]][method].call(obj1, data);
                            }
                        }
                    };
                    var loadExtensions = function() {
                        if (obj1.options.extensions) {
                            var ext = Object.keys(obj1.options.extensions);
                            if (ext.length) {
                                for(var i = 0; i < ext.length; i++)if (obj1.options.extensions[ext[i]] && typeof obj1.options.extensions[ext[i]] == "function") obj1.options.extensions[ext[i]] = obj1.options.extensions[ext[i]](el, obj1);
                            }
                        }
                    };
                    document.addEventListener("mouseup", editorMouseUp);
                    document.addEventListener("mousemove", editorMouseMove);
                    obj1.editor.addEventListener("mousedown", editorMouseDown);
                    obj1.editor.addEventListener("keyup", editorKeyUp);
                    obj1.editor.addEventListener("keydown", editorKeyDown);
                    obj1.editor.addEventListener("dragstart", editorDragStart);
                    obj1.editor.addEventListener("dragenter", editorDragEnter);
                    obj1.editor.addEventListener("dragover", editorDragOver);
                    obj1.editor.addEventListener("drop", editorDrop);
                    obj1.editor.addEventListener("paste", editorPaste);
                    obj1.editor.addEventListener("focus", editorFocus);
                    obj1.editor.addEventListener("blur", editorBlur);
                    // Append editor to the container
                    el.appendChild(obj1.editor);
                    // Snippet
                    if (obj1.options.snippet) obj1.appendSnippet(obj1.options.snippet);
                    // Add toolbar
                    if (obj1.options.toolbar) {
                        // Default toolbar configuration
                        if (Array.isArray(obj1.options.toolbar)) var toolbarOptions = {
                            container: true,
                            responsive: true,
                            items: obj1.options.toolbar
                        };
                        else if (obj1.options.toolbar === true) var toolbarOptions = {
                            container: true,
                            responsive: true,
                            items: []
                        };
                        else var toolbarOptions = obj1.options.toolbar;
                        // Default items
                        if (!(toolbarOptions.items && toolbarOptions.items.length)) toolbarOptions.items = Component.getDefaultToolbar(obj1);
                        if (obj1.options.toolbarOnTop) {
                            // Add class
                            el.classList.add("toolbar-on-top");
                            // Append to the DOM
                            el.insertBefore(toolbar1, el.firstChild);
                        } else {
                            // Add padding to the editor
                            obj1.editor.style.padding = "15px";
                            // Append to the DOM
                            el.appendChild(toolbar1);
                        }
                        // Create toolbar
                        Toolbar(toolbar1, toolbarOptions);
                        toolbar1.addEventListener("click", function() {
                            obj1.editor.focus();
                        });
                    }
                    // Upload file
                    obj1.file = document.createElement("input");
                    obj1.file.style.display = "none";
                    obj1.file.type = "file";
                    obj1.file.setAttribute("accept", "image/*");
                    obj1.file.onchange = function() {
                        obj1.addFile(this.files);
                    };
                    el.appendChild(obj1.file);
                    // Focus to the editor
                    if (obj1.options.focus) Component.setCursor(obj1.editor, obj1.options.focus == "initial" ? true : false);
                    // Change method
                    el.change = obj1.setData;
                    // Global generic value handler
                    el.val = function(val) {
                        if (val === undefined) {
                            // Data type
                            var o = el.getAttribute("data-html") === "true" ? false : true;
                            return obj1.getData(o);
                        } else obj1.setData(val);
                    };
                    loadExtensions();
                    el.editor = obj1;
                    // Onload
                    if (typeof obj1.options.onload == "function") obj1.options.onload(el, obj1, obj1.editor);
                    return obj1;
                };
                Component.setCursor = function(element, first) {
                    element.focus();
                    document.execCommand("selectAll");
                    var sel = window.getSelection();
                    var range = sel.getRangeAt(0);
                    if (first == true) {
                        var node = range.startContainer;
                        var size = 0;
                    } else {
                        var node = range.endContainer;
                        var size = node.length;
                    }
                    range.setStart(node, size);
                    range.setEnd(node, size);
                    sel.removeAllRanges();
                    sel.addRange(range);
                };
                Component.getDefaultToolbar = function(obj1) {
                    var color = function(a, b, c) {
                        if (!c.color) {
                            var t = null;
                            var colorPicker = Color(c, {
                                onchange: function(o, v) {
                                    if (c.k === "color") document.execCommand("foreColor", false, v);
                                    else document.execCommand("backColor", false, v);
                                }
                            });
                            c.color.open();
                        }
                    };
                    var items = [];
                    items.push({
                        content: "undo",
                        onclick: function() {
                            document.execCommand("undo");
                        }
                    });
                    items.push({
                        content: "redo",
                        onclick: function() {
                            document.execCommand("redo");
                        }
                    });
                    items.push({
                        type: "divisor"
                    });
                    if (obj1.options.toolbarOnTop) {
                        items.push({
                            type: "select",
                            width: "140px",
                            options: [
                                "Default",
                                "Verdana",
                                "Arial",
                                "Courier New"
                            ],
                            render: function(e) {
                                return '<span style="font-family:' + e + '">' + e + "</span>";
                            },
                            onchange: function(a, b, c, d, e) {
                                document.execCommand("fontName", false, d);
                            }
                        });
                        items.push({
                            type: "select",
                            content: "format_size",
                            options: [
                                "x-small",
                                "small",
                                "medium",
                                "large",
                                "x-large"
                            ],
                            render: function(e) {
                                return '<span style="font-size:' + e + '">' + e + "</span>";
                            },
                            onchange: function(a, b, c, d, e) {
                                //var html = `<span style="font-size: ${c}">${text}</span>`;
                                //document.execCommand('insertHtml', false, html);
                                document.execCommand("fontSize", false, parseInt(e) + 1);
                            //var f = window.getSelection().anchorNode.parentNode
                            //f.removeAttribute("size");
                            //f.style.fontSize = d;
                            }
                        });
                        items.push({
                            type: "select",
                            options: [
                                "format_align_left",
                                "format_align_center",
                                "format_align_right",
                                "format_align_justify"
                            ],
                            render: function(e) {
                                return '<i class="material-icons">' + e + "</i>";
                            },
                            onchange: function(a, b, c, d, e) {
                                var options = [
                                    "JustifyLeft",
                                    "justifyCenter",
                                    "justifyRight",
                                    "justifyFull"
                                ];
                                document.execCommand(options[e]);
                            }
                        });
                        items.push({
                            type: "divisor"
                        });
                        items.push({
                            content: "format_color_text",
                            k: "color",
                            onclick: color
                        });
                        items.push({
                            content: "format_color_fill",
                            k: "background-color",
                            onclick: color
                        });
                    }
                    items.push({
                        content: "format_bold",
                        onclick: function(a, b, c) {
                            document.execCommand("bold");
                            if (document.queryCommandState("bold")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    items.push({
                        content: "format_italic",
                        onclick: function(a, b, c) {
                            document.execCommand("italic");
                            if (document.queryCommandState("italic")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    items.push({
                        content: "format_underline",
                        onclick: function(a, b, c) {
                            document.execCommand("underline");
                            if (document.queryCommandState("underline")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    items.push({
                        type: "divisor"
                    });
                    items.push({
                        content: "format_list_bulleted",
                        onclick: function(a, b, c) {
                            document.execCommand("insertUnorderedList");
                            if (document.queryCommandState("insertUnorderedList")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    items.push({
                        content: "format_list_numbered",
                        onclick: function(a, b, c) {
                            document.execCommand("insertOrderedList");
                            if (document.queryCommandState("insertOrderedList")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    items.push({
                        content: "format_indent_increase",
                        onclick: function(a, b, c) {
                            document.execCommand("indent", true, null);
                            if (document.queryCommandState("indent")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    items.push({
                        content: "format_indent_decrease",
                        onclick: function(a, b, c) {
                            document.execCommand("outdent");
                            if (document.queryCommandState("outdent")) c.classList.add("selected");
                            else c.classList.remove("selected");
                        }
                    });
                    if (obj1.options.toolbarOnTop) {
                        items.push({
                            type: "divisor"
                        });
                        items.push({
                            content: "photo",
                            onclick: function() {
                                obj1.upload();
                            }
                        });
                        items.push({
                            type: "select",
                            content: "table_view",
                            columns: 8,
                            grid: 8,
                            right: true,
                            options: [
                                "0x0",
                                "1x0",
                                "2x0",
                                "3x0",
                                "4x0",
                                "5x0",
                                "6x0",
                                "7x0",
                                "0x1",
                                "1x1",
                                "2x1",
                                "3x1",
                                "4x1",
                                "5x1",
                                "6x1",
                                "7x1",
                                "0x2",
                                "1x2",
                                "2x2",
                                "3x2",
                                "4x2",
                                "5x2",
                                "6x2",
                                "7x2",
                                "0x3",
                                "1x3",
                                "2x3",
                                "3x3",
                                "4x3",
                                "5x3",
                                "6x3",
                                "7x3",
                                "0x4",
                                "1x4",
                                "2x4",
                                "3x4",
                                "4x4",
                                "5x4",
                                "6x4",
                                "7x4",
                                "0x5",
                                "1x5",
                                "2x5",
                                "3x5",
                                "4x5",
                                "5x5",
                                "6x5",
                                "7x5",
                                "0x6",
                                "1x6",
                                "2x6",
                                "3x6",
                                "4x6",
                                "5x6",
                                "6x6",
                                "7x6",
                                "0x7",
                                "1x7",
                                "2x7",
                                "3x7",
                                "4x7",
                                "5x7",
                                "6x7",
                                "7x7"
                            ],
                            render: function(e, item) {
                                if (item) {
                                    item.onmouseover = this.onmouseover;
                                    e = e.split("x");
                                    item.setAttribute("data-x", e[0]);
                                    item.setAttribute("data-y", e[1]);
                                }
                                var element = document.createElement("div");
                                item.style.margin = "1px";
                                item.style.border = "1px solid #ddd";
                                return element;
                            },
                            onmouseover: function(e) {
                                var x1 = parseInt(e.target.getAttribute("data-x"));
                                var y1 = parseInt(e.target.getAttribute("data-y"));
                                for(var i = 0; i < e.target.parentNode.children.length; i++){
                                    var element = e.target.parentNode.children[i];
                                    var ex = parseInt(element.getAttribute("data-x"));
                                    var ey = parseInt(element.getAttribute("data-y"));
                                    if (ex <= x1 && ey <= y1) {
                                        element.style.backgroundColor = "#cae1fc";
                                        element.style.borderColor = "#2977ff";
                                    } else {
                                        element.style.backgroundColor = "";
                                        element.style.borderColor = "#ddd";
                                    }
                                }
                            },
                            onchange: function(a, b, c) {
                                c = c.split("x");
                                var table = document.createElement("table");
                                var tbody = document.createElement("tbody");
                                for(var y1 = 0; y1 <= c[1]; y1++){
                                    var tr = document.createElement("tr");
                                    for(var x1 = 0; x1 <= c[0]; x1++){
                                        var td = document.createElement("td");
                                        td.innerHTML = "";
                                        tr.appendChild(td);
                                    }
                                    tbody.appendChild(tr);
                                }
                                table.appendChild(tbody);
                                table.setAttribute("width", "100%");
                                table.setAttribute("cellpadding", "6");
                                table.setAttribute("cellspacing", "0");
                                document.execCommand("insertHTML", false, table.outerHTML);
                            }
                        });
                    }
                    return items;
                };
                return Component;
            }
            /* harmony default export */ var editor = Editor();
            function Floating() {
                var Component = function(el, options) {
                    var obj1 = {};
                    obj1.options = {};
                    // Default configuration
                    var defaults = {
                        type: "big",
                        title: "Untitled",
                        width: 510,
                        height: 472
                    };
                    // Loop through our object
                    for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                    else obj1.options[property] = defaults[property];
                    // Private methods
                    var setContent = function() {
                        var temp = document.createElement("div");
                        while(el.children[0])temp.appendChild(el.children[0]);
                        obj1.content = document.createElement("div");
                        obj1.content.className = "jfloating_content";
                        obj1.content.innerHTML = el.innerHTML;
                        while(temp.children[0])obj1.content.appendChild(temp.children[0]);
                        obj1.container = document.createElement("div");
                        obj1.container.className = "jfloating";
                        obj1.container.appendChild(obj1.content);
                        if (obj1.options.title) obj1.container.setAttribute("title", obj1.options.title);
                        else obj1.container.classList.add("no-title");
                        // validate element dimensions
                        if (obj1.options.width) obj1.container.style.width = parseInt(obj1.options.width) + "px";
                        if (obj1.options.height) obj1.container.style.height = parseInt(obj1.options.height) + "px";
                        el.innerHTML = "";
                        el.appendChild(obj1.container);
                    };
                    var setEvents = function() {
                        if (obj1.container) obj1.container.addEventListener("click", function(e) {
                            var rect = e.target.getBoundingClientRect();
                            if (e.target.classList.contains("jfloating")) {
                                if (e.changedTouches && e.changedTouches[0]) {
                                    var x1 = e.changedTouches[0].clientX;
                                    var y1 = e.changedTouches[0].clientY;
                                } else {
                                    var x1 = e.clientX;
                                    var y1 = e.clientY;
                                }
                                if (rect.width - (x1 - rect.left) < 50 && y1 - rect.top < 50) setTimeout(function() {
                                    obj1.close();
                                }, 100);
                                else obj1.setState();
                            }
                        });
                    };
                    var setType = function() {
                        obj1.container.classList.add("jfloating-" + obj1.options.type);
                    };
                    obj1.state = {
                        isMinized: false
                    };
                    obj1.setState = function() {
                        if (obj1.state.isMinized) obj1.container.classList.remove("jfloating-minimized");
                        else obj1.container.classList.add("jfloating-minimized");
                        obj1.state.isMinized = !obj1.state.isMinized;
                    };
                    obj1.close = function() {
                        Components.elements.splice(Component.elements.indexOf(obj1.container), 1);
                        obj1.updatePosition();
                        el.remove();
                    };
                    obj1.updatePosition = function() {
                        for(var i = 0; i < Component.elements.length; i++){
                            var floating = Component.elements[i];
                            var prevFloating = Component.elements[i - 1];
                            floating.style.right = i * (prevFloating ? prevFloating.offsetWidth : floating.offsetWidth) * 1.01 + "px";
                        }
                    };
                    obj1.init = function() {
                        // Set content into root
                        setContent();
                        // Set dialog events
                        setEvents();
                        // Set dialog type
                        setType();
                        // Update floating position
                        Component.elements.push(obj1.container);
                        obj1.updatePosition();
                        el.floating = obj1;
                    };
                    obj1.init();
                    return obj1;
                };
                Component.elements = [];
                return Component;
            }
            /* harmony default export */ var floating = Floating();
            function Validations() {
                /**
     * Options: Object,
     * Properties:
     * Constraint,
     * Reference,
     * Value
     */ const isNumeric = function(num) {
                    return !isNaN(num) && num !== null && (typeof num !== "string" || num.trim() !== "");
                };
                const numberCriterias = {
                    "between": function(value, range) {
                        return value >= range[0] && value <= range[1];
                    },
                    "not between": function(value, range) {
                        return value < range[0] || value > range[1];
                    },
                    "<": function(value, range) {
                        return value < range[0];
                    },
                    "<=": function(value, range) {
                        return value <= range[0];
                    },
                    ">": function(value, range) {
                        return value > range[0];
                    },
                    ">=": function(value, range) {
                        return value >= range[0];
                    },
                    "=": function(value, range) {
                        return value == range[0];
                    },
                    "!=": function(value, range) {
                        return value != range[0];
                    }
                };
                const dateCriterias = {
                    "valid date": function() {
                        return true;
                    },
                    "=": function(value, range) {
                        return value === range[0];
                    },
                    "!=": function(value, range) {
                        return value !== range[0];
                    },
                    "<": function(value, range) {
                        return value < range[0];
                    },
                    "<=": function(value, range) {
                        return value <= range[0];
                    },
                    ">": function(value, range) {
                        return value > range[0];
                    },
                    ">=": function(value, range) {
                        return value >= range[0];
                    },
                    "between": function(value, range) {
                        return value >= range[0] && value <= range[1];
                    },
                    "not between": function(value, range) {
                        return value < range[0] || value > range[1];
                    }
                };
                const textCriterias = {
                    "contains": function(value, range) {
                        return value.includes(range[0]);
                    },
                    "not contains": function(value, range) {
                        return !value.includes(range[0]);
                    },
                    "begins with": function(value, range) {
                        return value.startsWith(range[0]);
                    },
                    "ends with": function(value, range) {
                        return value.endsWith(range[0]);
                    },
                    "=": function(value, range) {
                        return value === range[0];
                    },
                    "!=": function(value, range) {
                        return value !== range[0];
                    },
                    "valid email": function(value) {
                        var pattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
                        return pattern.test(value);
                    },
                    "valid url": function(value) {
                        var pattern = new RegExp(/(((https?:\/\/)|(www\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]+)/ig);
                        return pattern.test(value);
                    }
                };
                // Component router
                const component = function(value, options) {
                    if (typeof component[options.type] === "function") {
                        if (options.allowBlank && (typeof value === "undefined" || value === "" || value === null)) return true;
                        return component[options.type].call(this, value, options);
                    }
                    return null;
                };
                component.url = function(data) {
                    var pattern = new RegExp(/(((https?:\/\/)|(www\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]+)/ig);
                    return pattern.test(data) ? true : false;
                };
                component.email = function(data) {
                    var pattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
                    return data && pattern.test(data) ? true : false;
                };
                component.required = function(data) {
                    return data && data.trim() ? true : false;
                };
                component.empty = function(data) {
                    return typeof data === "undefined" || data === null || typeof data === "string" && !data.toString().trim();
                };
                component["not exist"] = component.empty;
                component.notEmpty = function(data) {
                    return !component.empty(data);
                };
                component.exist = component.notEmpty;
                component.number = function(data, options) {
                    if (!isNumeric(data)) return false;
                    if (!options || !options.criteria) return true;
                    if (!numberCriterias[options.criteria]) return false;
                    let values = options.value.map(function(num) {
                        return parseFloat(num);
                    });
                    return numberCriterias[options.criteria](data, values);
                };
                component.login = function(data) {
                    let pattern = new RegExp(/^[a-zA-Z0-9._-]+$/);
                    return data && pattern.test(data) ? true : false;
                };
                component.list = function(data, options) {
                    let dataType = typeof data;
                    if (dataType !== "string" && dataType !== "number") return false;
                    let list;
                    if (typeof options.value[0] === "string") {
                        if (options.source) list = options.source;
                        else list = options.value[0].split(",");
                    } else list = options.value[0];
                    if (!Array.isArray(list)) return false;
                    else {
                        let validOption = list.findIndex(function(item) {
                            return item == data;
                        });
                        return validOption > -1;
                    }
                };
                const getCurrentDateWithoutTime = function() {
                    let date = new Date();
                    date.setHours(0, 0, 0, 0);
                    return date;
                };
                const relativeDates = {
                    "one year ago": function() {
                        let date = getCurrentDateWithoutTime();
                        date.setFullYear(date.getFullYear() - 1);
                        return date;
                    },
                    "one month ago": function() {
                        let date = getCurrentDateWithoutTime();
                        date.setMonth(date.getMonth() - 1);
                        return date;
                    },
                    "one week ago": function() {
                        let date = getCurrentDateWithoutTime();
                        date.setDate(date.getDate() - 7);
                        return date;
                    },
                    yesterday: function() {
                        let date = getCurrentDateWithoutTime();
                        date.setDate(date.getDate() - 1);
                        return date;
                    },
                    today: getCurrentDateWithoutTime,
                    tomorrow: function() {
                        let date = getCurrentDateWithoutTime();
                        date.setDate(date.getDate() + 1);
                        return date;
                    }
                };
                component.date = function(data, options) {
                    if (isNumeric(data) && data > 0 && data < 1000000) data = helpers_date.numToDate(data);
                    if (new Date(data) == "Invalid Date") return false;
                    if (!options || !options.criteria) return true;
                    if (!dateCriterias[options.criteria]) return false;
                    let values = options.value.map(function(date) {
                        if (typeof date === "string" && relativeDates[date]) return relativeDates[date]().getTime();
                        return new Date(date).getTime();
                    });
                    return dateCriterias[options.criteria](new Date(data).getTime(), values);
                };
                component.text = function(data, options) {
                    if (typeof data === "undefined" || data === null) data = "";
                    else if (typeof data !== "string") return false;
                    if (!options || !options.criteria) return true;
                    if (!textCriterias[options.criteria]) return false;
                    return textCriterias[options.criteria](data, options.value);
                };
                component.textLength = function(data, options) {
                    let textLength;
                    if (typeof data === "string") textLength = data.length;
                    else if (typeof data !== "undefined" && data !== null && typeof data.toString === "function") textLength = data.toString().length;
                    else textLength = 0;
                    return component.number(textLength, options);
                };
                component.time = function(data, options) {
                    if (!isNumeric(data)) return false;
                    if (!options || !options.criteria) return true;
                    if (!numberCriterias[options.criteria]) return false;
                    let values = options.value.map(function(num) {
                        return parseInt(parseFloat(num) * 10 ** 17) / 10 ** 17;
                    });
                    return numberCriterias[options.criteria](parseInt(parseFloat(data) * 10 ** 17) / 10 ** 17, values);
                };
                return component;
            }
            /* harmony default export */ var validations = Validations();
            function Form() {
                var Component = function(el, options) {
                    var obj1 = {};
                    obj1.options = {};
                    // Default configuration
                    var defaults = {
                        url: null,
                        message: "Are you sure? There are unsaved information in your form",
                        ignore: false,
                        currentHash: null,
                        submitButton: null,
                        validations: null,
                        onbeforeload: null,
                        onload: null,
                        onbeforesave: null,
                        onsave: null,
                        onbeforeremove: null,
                        onremove: null,
                        onerror: function(el, message) {
                            alert(message);
                        }
                    };
                    // Loop through our object
                    for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                    else obj1.options[property] = defaults[property];
                    // Validations
                    if (!obj1.options.validations) obj1.options.validations = {};
                    // Submit Button
                    if (!obj1.options.submitButton) obj1.options.submitButton = el.querySelector("input[type=submit]");
                    if (obj1.options.submitButton && obj1.options.url) obj1.options.submitButton.onclick = function() {
                        obj1.save();
                    };
                    if (!obj1.options.validations.email) obj1.options.validations.email = validations.email;
                    if (!obj1.options.validations.length) obj1.options.validations.length = validations.length;
                    if (!obj1.options.validations.required) obj1.options.validations.required = validations.required;
                    obj1.setUrl = function(url) {
                        obj1.options.url = url;
                    };
                    obj1.load = function() {
                        ajax({
                            url: obj1.options.url,
                            method: "GET",
                            dataType: "json",
                            queue: true,
                            success: function(data) {
                                // Overwrite values from the backend
                                if (typeof obj1.options.onbeforeload == "function") {
                                    var ret = obj1.options.onbeforeload(el, data);
                                    if (ret) data = ret;
                                }
                                // Apply values to the form
                                Component.setElements(el, data);
                                // Onload methods
                                if (typeof obj1.options.onload == "function") obj1.options.onload(el, data);
                            }
                        });
                    };
                    obj1.save = function() {
                        var test = obj1.validate();
                        if (test) obj1.options.onerror(el, test);
                        else {
                            var data = Component.getElements(el, true);
                            if (typeof obj1.options.onbeforesave == "function") {
                                var data = obj1.options.onbeforesave(el, data);
                                if (data === false) return;
                            }
                            ajax({
                                url: obj1.options.url,
                                method: "POST",
                                dataType: "json",
                                data: data,
                                success: function(result) {
                                    if (typeof obj1.options.onsave == "function") obj1.options.onsave(el, data, result);
                                }
                            });
                        }
                    };
                    obj1.remove = function() {
                        if (typeof obj1.options.onbeforeremove == "function") {
                            var ret = obj1.options.onbeforeremove(el, obj1);
                            if (ret === false) return false;
                        }
                        ajax({
                            url: obj1.options.url,
                            method: "DELETE",
                            dataType: "json",
                            success: function(result) {
                                if (typeof obj1.options.onremove == "function") obj1.options.onremove(el, obj1, result);
                                obj1.reset();
                            }
                        });
                    };
                    var addError = function(element) {
                        // Add error in the element
                        element.classList.add("error");
                        // Submit button
                        if (obj1.options.submitButton) obj1.options.submitButton.setAttribute("disabled", true);
                        // Return error message
                        var error = element.getAttribute("data-error") || "There is an error in the form";
                        element.setAttribute("title", error);
                        return error;
                    };
                    var delError = function(element) {
                        var error = false;
                        // Remove class from this element
                        element.classList.remove("error");
                        element.removeAttribute("title");
                        // Get elements in the form
                        var elements = el.querySelectorAll("input, select, textarea, div[name]");
                        // Run all elements
                        for(var i = 0; i < elements.length; i++){
                            if (elements[i].getAttribute("data-validation")) {
                                if (elements[i].classList.contains("error")) error = true;
                            }
                        }
                        if (obj1.options.submitButton) {
                            if (error) obj1.options.submitButton.setAttribute("disabled", true);
                            else obj1.options.submitButton.removeAttribute("disabled");
                        }
                    };
                    obj1.validateElement = function(element) {
                        // Test results
                        var test = false;
                        // Value
                        var value = Component.getValue(element);
                        // Validation
                        var validation = element.getAttribute("data-validation");
                        // Parse
                        if (typeof obj1.options.validations[validation] == "function" && !obj1.options.validations[validation](value, element)) // Not passed in the test
                        test = addError(element);
                        else if (element.classList.contains("error")) delError(element);
                        return test;
                    };
                    obj1.reset = function() {
                        // Get elements in the form
                        var name = null;
                        var elements = el.querySelectorAll("input, select, textarea, div[name]");
                        // Run all elements
                        for(var i = 0; i < elements.length; i++)if (name = elements[i].getAttribute("name")) {
                            if (elements[i].type == "checkbox" || elements[i].type == "radio") elements[i].checked = false;
                            else if (typeof elements[i].val == "function") elements[i].val("");
                            else elements[i].value = "";
                        }
                    };
                    // Run form validation
                    obj1.validate = function() {
                        var test = [];
                        // Get elements in the form
                        var elements = el.querySelectorAll("input, select, textarea, div[name]");
                        // Run all elements
                        for(var i = 0; i < elements.length; i++)// Required
                        if (elements[i].getAttribute("data-validation")) {
                            var res = obj1.validateElement(elements[i]);
                            if (res) test.push(res);
                        }
                        if (test.length > 0) return test.join("<br>");
                        else return false;
                    };
                    // Check the form
                    obj1.getError = function() {
                        // Validation
                        return obj1.validation() ? true : false;
                    };
                    // Return the form hash
                    obj1.setHash = function() {
                        return obj1.getHash(Component.getElements(el));
                    };
                    // Get the form hash
                    obj1.getHash = function(str) {
                        var hash = 0, i, chr;
                        if (str.length === 0) return hash;
                        else for(i = 0; i < str.length; i++){
                            chr = str.charCodeAt(i);
                            hash = (hash << 5) - hash + chr;
                            hash |= 0;
                        }
                        return hash;
                    };
                    // Is there any change in the form since start tracking?
                    obj1.isChanged = function() {
                        var hash = obj1.setHash();
                        return obj1.options.currentHash != hash;
                    };
                    // Restart tracking
                    obj1.resetTracker = function() {
                        obj1.options.currentHash = obj1.setHash();
                        obj1.options.ignore = false;
                    };
                    // Ignore flag
                    obj1.setIgnore = function(ignoreFlag) {
                        obj1.options.ignore = ignoreFlag ? true : false;
                    };
                    // Start tracking in one second
                    setTimeout(function() {
                        obj1.options.currentHash = obj1.setHash();
                    }, 1000);
                    // Validations
                    el.addEventListener("keyup", function(e) {
                        if (e.target.getAttribute("data-validation")) obj1.validateElement(e.target);
                    });
                    // Alert
                    if (!Component.hasEvents) {
                        window.addEventListener("beforeunload", function(e) {
                            if (obj1.isChanged() && obj1.options.ignore == false) {
                                var confirmationMessage = obj1.options.message ? obj1.options.message : "o/";
                                if (confirmationMessage) {
                                    if (typeof e == "undefined") e = window.event;
                                    if (e) e.returnValue = confirmationMessage;
                                    return confirmationMessage;
                                } else return void 0;
                            }
                        });
                        Component.hasEvents = true;
                    }
                    el.form = obj1;
                    return obj1;
                };
                // Get value from one element
                Component.getValue = function(element) {
                    var value = null;
                    if (element.type == "checkbox") {
                        if (element.checked == true) value = element.value || true;
                    } else if (element.type == "radio") {
                        if (element.checked == true) value = element.value;
                    } else if (element.type == "file") value = element.files;
                    else if (element.tagName == "select" && element.multiple == true) {
                        value = [];
                        var options = element.querySelectorAll("options[selected]");
                        for(var j = 0; j < options.length; j++)value.push(options[j].value);
                    } else if (typeof element.val == "function") value = element.val();
                    else value = element.value || "";
                    return value;
                };
                // Get form elements
                Component.getElements = function(el, asArray) {
                    var data = {};
                    var name = null;
                    var elements = el.querySelectorAll("input, select, textarea, div[name]");
                    for(var i = 0; i < elements.length; i++)if (name = elements[i].getAttribute("name")) data[name] = Component.getValue(elements[i]) || "";
                    return asArray == true ? data : JSON.stringify(data);
                };
                //Get form elements
                Component.setElements = function(el, data) {
                    var name = null;
                    var value = null;
                    var elements = el.querySelectorAll("input, select, textarea, div[name]");
                    for(var i = 0; i < elements.length; i++){
                        // Attributes
                        var type = elements[i].getAttribute("type");
                        if (name = elements[i].getAttribute("name")) {
                            // Transform variable names in pathname
                            name = name.replace(new RegExp(/\[(.*?)\]/ig), ".$1");
                            value = null;
                            // Seach for the data in the path
                            if (name.match(/\./)) {
                                var tmp = Path.call(data, name) || "";
                                if (typeof tmp !== "undefined") value = tmp;
                            } else if (typeof data[name] !== "undefined") value = data[name];
                            // Set the values
                            if (value !== null) {
                                if (type == "checkbox" || type == "radio") elements[i].checked = value ? true : false;
                                else if (type == "file") ;
                                else if (typeof elements[i].val == "function") elements[i].val(value);
                                else elements[i].value = value;
                            }
                        }
                    }
                };
                return Component;
            }
            /* harmony default export */ var plugins_form = Form();
            function Modal() {
                var Events = function() {
                    //  Position
                    var tracker = null;
                    var keyDown = function(e) {
                        if (e.which == 27) {
                            var modals = document.querySelectorAll(".jmodal");
                            for(var i = 0; i < modals.length; i++)modals[i].parentNode.modal.close();
                        }
                    };
                    var mouseUp = function(e) {
                        let element = e.composedPath();
                        var item = helpers.findElement(element[0], "jmodal");
                        if (item) {
                            // Get target info
                            var rect = item.getBoundingClientRect();
                            if (e.changedTouches && e.changedTouches[0]) {
                                var x1 = e.changedTouches[0].clientX;
                                var y1 = e.changedTouches[0].clientY;
                            } else {
                                var x1 = e.clientX;
                                var y1 = e.clientY;
                            }
                            if (rect.width - (x1 - rect.left) < 50 && y1 - rect.top < 50) item.parentNode.modal.close();
                        }
                        if (tracker) {
                            tracker.element.style.cursor = "auto";
                            tracker = null;
                        }
                    };
                    var mouseDown = function(e) {
                        let element = e.composedPath();
                        var item = helpers.findElement(element[0], "jmodal");
                        if (item) {
                            // Get target info
                            var rect = item.getBoundingClientRect();
                            if (e.changedTouches && e.changedTouches[0]) {
                                var x1 = e.changedTouches[0].clientX;
                                var y1 = e.changedTouches[0].clientY;
                            } else {
                                var x1 = e.clientX;
                                var y1 = e.clientY;
                            }
                            if (rect.width - (x1 - rect.left) < 50 && y1 - rect.top < 50) ;
                            else if (y1 - rect.top < 50) {
                                if (document.selection) document.selection.empty();
                                else if (window.getSelection) window.getSelection().removeAllRanges();
                                tracker = {
                                    left: rect.left,
                                    top: rect.top,
                                    x: e.clientX,
                                    y: e.clientY,
                                    width: rect.width,
                                    height: rect.height,
                                    element: item
                                };
                            }
                        }
                    };
                    var mouseMove = function(e) {
                        if (tracker) {
                            e = e || window.event;
                            if (e.buttons) var mouseButton = e.buttons;
                            else if (e.button) var mouseButton = e.button;
                            else var mouseButton = e.which;
                            if (mouseButton) {
                                tracker.element.style.top = tracker.top + (e.clientY - tracker.y) + tracker.height / 2 + "px";
                                tracker.element.style.left = tracker.left + (e.clientX - tracker.x) + tracker.width / 2 + "px";
                                tracker.element.style.cursor = "move";
                            } else tracker.element.style.cursor = "auto";
                        }
                    };
                    document.addEventListener("keydown", keyDown);
                    document.addEventListener("mouseup", mouseUp);
                    document.addEventListener("mousedown", mouseDown);
                    document.addEventListener("mousemove", mouseMove);
                };
                var Component = function(el, options) {
                    var obj1 = {};
                    obj1.options = {};
                    // Default configuration
                    var defaults = {
                        url: null,
                        onopen: null,
                        onclose: null,
                        onload: null,
                        closed: false,
                        width: null,
                        height: null,
                        title: null,
                        padding: null,
                        backdrop: true,
                        icon: null
                    };
                    // Loop through our object
                    for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                    else obj1.options[property] = defaults[property];
                    // Title
                    if (!obj1.options.title && el.getAttribute("title")) obj1.options.title = el.getAttribute("title");
                    var temp = document.createElement("div");
                    while(el.children[0])temp.appendChild(el.children[0]);
                    obj1.title = document.createElement("div");
                    obj1.title.className = "jmodal_title";
                    if (obj1.options.icon) obj1.title.setAttribute("data-icon", obj1.options.icon);
                    obj1.content = document.createElement("div");
                    obj1.content.className = "jmodal_content";
                    obj1.content.innerHTML = el.innerHTML;
                    while(temp.children[0])obj1.content.appendChild(temp.children[0]);
                    obj1.container = document.createElement("div");
                    obj1.container.className = "jmodal";
                    obj1.container.appendChild(obj1.title);
                    obj1.container.appendChild(obj1.content);
                    if (obj1.options.padding) obj1.content.style.padding = obj1.options.padding;
                    if (obj1.options.width) obj1.container.style.width = obj1.options.width;
                    if (obj1.options.height) obj1.container.style.height = obj1.options.height;
                    if (obj1.options.title) {
                        var title = document.createElement("h4");
                        title.innerText = obj1.options.title;
                        obj1.title.appendChild(title);
                    }
                    el.innerHTML = "";
                    el.style.display = "none";
                    el.appendChild(obj1.container);
                    // Backdrop
                    if (obj1.options.backdrop) {
                        var backdrop = document.createElement("div");
                        backdrop.className = "jmodal_backdrop";
                        backdrop.onclick = function() {
                            obj1.close();
                        };
                        el.appendChild(backdrop);
                    }
                    obj1.open = function() {
                        el.style.display = "block";
                        // Fullscreen
                        var rect = obj1.container.getBoundingClientRect();
                        if (helpers.getWindowWidth() < rect.width) {
                            obj1.container.style.top = "";
                            obj1.container.style.left = "";
                            obj1.container.classList.add("jmodal_fullscreen");
                            animation.slideBottom(obj1.container, 1);
                        } else if (obj1.options.backdrop) backdrop.style.display = "block";
                        // Event
                        if (typeof obj1.options.onopen == "function") obj1.options.onopen(el, obj1);
                    };
                    obj1.resetPosition = function() {
                        obj1.container.style.top = "";
                        obj1.container.style.left = "";
                    };
                    obj1.isOpen = function() {
                        return el.style.display != "none" ? true : false;
                    };
                    obj1.close = function() {
                        if (obj1.isOpen()) {
                            el.style.display = "none";
                            if (obj1.options.backdrop) // Backdrop
                            backdrop.style.display = "";
                            // Remove fullscreen class
                            obj1.container.classList.remove("jmodal_fullscreen");
                            // Event
                            if (typeof obj1.options.onclose == "function") obj1.options.onclose(el, obj1);
                        }
                    };
                    if (obj1.options.url) ajax({
                        url: obj1.options.url,
                        method: "GET",
                        dataType: "text/html",
                        success: function(data) {
                            obj1.content.innerHTML = data;
                            if (!obj1.options.closed) obj1.open();
                            if (typeof obj1.options.onload === "function") obj1.options.onload(obj1);
                        }
                    });
                    else {
                        if (!obj1.options.closed) obj1.open();
                        if (typeof obj1.options.onload === "function") obj1.options.onload(obj1);
                    }
                    // Keep object available from the node
                    el.modal = obj1;
                    // Create events when the first modal is create only
                    Events();
                    // Execute the events only once
                    Events = function() {};
                    return obj1;
                };
                return Component;
            }
            /* harmony default export */ var modal = Modal();
            function Notification() {
                var Component = function(options) {
                    var obj1 = {};
                    obj1.options = {};
                    // Default configuration
                    var defaults = {
                        icon: null,
                        name: "Notification",
                        date: null,
                        error: null,
                        title: null,
                        message: null,
                        timeout: 4000,
                        autoHide: true,
                        closeable: true
                    };
                    // Loop through our object
                    for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                    else obj1.options[property] = defaults[property];
                    var notification = document.createElement("div");
                    notification.className = "jnotification";
                    if (obj1.options.error) notification.classList.add("jnotification-error");
                    var notificationContainer = document.createElement("div");
                    notificationContainer.className = "jnotification-container";
                    notification.appendChild(notificationContainer);
                    var notificationHeader = document.createElement("div");
                    notificationHeader.className = "jnotification-header";
                    notificationContainer.appendChild(notificationHeader);
                    var notificationImage = document.createElement("div");
                    notificationImage.className = "jnotification-image";
                    notificationHeader.appendChild(notificationImage);
                    if (obj1.options.icon) {
                        var notificationIcon = document.createElement("img");
                        notificationIcon.src = obj1.options.icon;
                        notificationImage.appendChild(notificationIcon);
                    }
                    var notificationName = document.createElement("div");
                    notificationName.className = "jnotification-name";
                    notificationName.innerHTML = obj1.options.name;
                    notificationHeader.appendChild(notificationName);
                    if (obj1.options.closeable == true) {
                        var notificationClose = document.createElement("div");
                        notificationClose.className = "jnotification-close";
                        notificationClose.onclick = function() {
                            obj1.hide();
                        };
                        notificationHeader.appendChild(notificationClose);
                    }
                    var notificationDate = document.createElement("div");
                    notificationDate.className = "jnotification-date";
                    notificationHeader.appendChild(notificationDate);
                    var notificationContent = document.createElement("div");
                    notificationContent.className = "jnotification-content";
                    notificationContainer.appendChild(notificationContent);
                    if (obj1.options.title) {
                        var notificationTitle = document.createElement("div");
                        notificationTitle.className = "jnotification-title";
                        notificationTitle.innerHTML = obj1.options.title;
                        notificationContent.appendChild(notificationTitle);
                    }
                    var notificationMessage = document.createElement("div");
                    notificationMessage.className = "jnotification-message";
                    notificationMessage.innerHTML = obj1.options.message;
                    notificationContent.appendChild(notificationMessage);
                    obj1.show = function() {
                        document.body.appendChild(notification);
                        if (helpers.getWindowWidth() > 800) animation.fadeIn(notification);
                        else animation.slideTop(notification, 1);
                    };
                    obj1.hide = function() {
                        if (helpers.getWindowWidth() > 800) animation.fadeOut(notification, function() {
                            if (notification.parentNode) {
                                notification.parentNode.removeChild(notification);
                                if (notificationTimeout) clearTimeout(notificationTimeout);
                            }
                        });
                        else animation.slideTop(notification, 0, function() {
                            if (notification.parentNode) {
                                notification.parentNode.removeChild(notification);
                                if (notificationTimeout) clearTimeout(notificationTimeout);
                            }
                        });
                    };
                    obj1.show();
                    if (obj1.options.autoHide == true) var notificationTimeout = setTimeout(function() {
                        obj1.hide();
                    }, obj1.options.timeout);
                    if (helpers.getWindowWidth() < 800) notification.addEventListener("swipeup", function(e) {
                        obj1.hide();
                        e.preventDefault();
                        e.stopPropagation();
                    });
                    return obj1;
                };
                Component.isVisible = function() {
                    var j = document.querySelector(".jnotification");
                    return j && j.parentNode ? true : false;
                };
                return Component;
            }
            /* harmony default export */ var notification = Notification();
            function Progressbar(el, options) {
                var obj1 = {};
                obj1.options = {};
                // Default configuration
                var defaults = {
                    value: 0,
                    onchange: null,
                    width: null
                };
                // Loop through the initial configuration
                for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                else obj1.options[property] = defaults[property];
                // Class
                el.classList.add("jprogressbar");
                el.setAttribute("tabindex", 1);
                el.setAttribute("data-value", obj1.options.value);
                var bar = document.createElement("div");
                bar.style.width = obj1.options.value + "%";
                bar.style.color = "#fff";
                el.appendChild(bar);
                if (obj1.options.width) el.style.width = obj1.options.width;
                // Set value
                obj1.setValue = function(value) {
                    value = parseInt(value);
                    obj1.options.value = value;
                    bar.style.width = value + "%";
                    el.setAttribute("data-value", value + "%");
                    if (value < 6) el.style.color = "#000";
                    else el.style.color = "#fff";
                    // Update value
                    obj1.options.value = value;
                    if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, value);
                    // Lemonade JS
                    if (el.value != obj1.options.value) {
                        el.value = obj1.options.value;
                        if (typeof el.oninput == "function") el.oninput({
                            type: "input",
                            target: el,
                            value: el.value
                        });
                    }
                };
                obj1.getValue = function() {
                    return obj1.options.value;
                };
                var action = function(e) {
                    if (e.which) {
                        // Get target info
                        var rect = el.getBoundingClientRect();
                        if (e.changedTouches && e.changedTouches[0]) {
                            var x1 = e.changedTouches[0].clientX;
                            var y1 = e.changedTouches[0].clientY;
                        } else {
                            var x1 = e.clientX;
                            var y1 = e.clientY;
                        }
                        obj1.setValue(Math.round((x1 - rect.left) / rect.width * 100));
                    }
                };
                // Events
                if ("touchstart" in document.documentElement === true) {
                    el.addEventListener("touchstart", action);
                    el.addEventListener("touchend", action);
                } else {
                    el.addEventListener("mousedown", action);
                    el.addEventListener("mousemove", action);
                }
                // Change
                el.change = obj1.setValue;
                // Global generic value handler
                el.val = function(val) {
                    if (val === undefined) return obj1.getValue();
                    else obj1.setValue(val);
                };
                // Reference
                el.progressbar = obj1;
                return obj1;
            }
            function Rating(el, options) {
                // Already created, update options
                if (el.rating) return el.rating.setOptions(options, true);
                // New instance
                var obj1 = {};
                obj1.options = {};
                obj1.setOptions = function(options, reset) {
                    // Default configuration
                    var defaults = {
                        number: 5,
                        value: 0,
                        tooltip: [
                            "Very bad",
                            "Bad",
                            "Average",
                            "Good",
                            "Very good"
                        ],
                        onchange: null
                    };
                    // Loop through the initial configuration
                    for(var property in defaults){
                        if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                        else if (typeof obj1.options[property] == "undefined" || reset === true) obj1.options[property] = defaults[property];
                    }
                    // Make sure the container is empty
                    el.innerHTML = "";
                    // Add elements
                    for(var i = 0; i < obj1.options.number; i++){
                        var div = document.createElement("div");
                        div.setAttribute("data-index", i + 1);
                        div.setAttribute("title", obj1.options.tooltip[i]);
                        el.appendChild(div);
                    }
                    // Selected option
                    if (obj1.options.value) {
                        for(var i = 0; i < obj1.options.number; i++)if (i < obj1.options.value) el.children[i].classList.add("jrating-selected");
                    }
                    return obj1;
                };
                // Set value
                obj1.setValue = function(index) {
                    for(var i = 0; i < obj1.options.number; i++)if (i < index) el.children[i].classList.add("jrating-selected");
                    else {
                        el.children[i].classList.remove("jrating-over");
                        el.children[i].classList.remove("jrating-selected");
                    }
                    obj1.options.value = index;
                    if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, index);
                    // Lemonade JS
                    if (el.value != obj1.options.value) {
                        el.value = obj1.options.value;
                        if (typeof el.oninput == "function") el.oninput({
                            type: "input",
                            target: el,
                            value: el.value
                        });
                    }
                };
                obj1.getValue = function() {
                    return obj1.options.value;
                };
                var init = function() {
                    // Start plugin
                    obj1.setOptions(options);
                    // Class
                    el.classList.add("jrating");
                    // Events
                    el.addEventListener("click", function(e) {
                        var index = e.target.getAttribute("data-index");
                        if (index != undefined) {
                            if (index == obj1.options.value) obj1.setValue(0);
                            else obj1.setValue(index);
                        }
                    });
                    el.addEventListener("mouseover", function(e) {
                        var index = e.target.getAttribute("data-index");
                        for(var i = 0; i < obj1.options.number; i++)if (i < index) el.children[i].classList.add("jrating-over");
                        else el.children[i].classList.remove("jrating-over");
                    });
                    el.addEventListener("mouseout", function(e) {
                        for(var i = 0; i < obj1.options.number; i++)el.children[i].classList.remove("jrating-over");
                    });
                    // Change
                    el.change = obj1.setValue;
                    // Global generic value handler
                    el.val = function(val) {
                        if (val === undefined) return obj1.getValue();
                        else obj1.setValue(val);
                    };
                    // Reference
                    el.rating = obj1;
                };
                init();
                return obj1;
            }
            function Search(el, options) {
                if (el.search) return el.search;
                var index = null;
                var select = function(e) {
                    if (e.target.classList.contains("jsearch_item")) var element = e.target;
                    else var element = e.target.parentNode;
                    obj1.selectIndex(element);
                    e.preventDefault();
                };
                var createList = function(data) {
                    if (typeof obj1.options.onsearch == "function") {
                        var ret = obj1.options.onsearch(obj1, data);
                        if (ret) data = ret;
                    }
                    // Reset container
                    container.innerHTML = "";
                    // Print results
                    if (!data.length) // Show container
                    el.style.display = "";
                    else {
                        // Show container
                        el.style.display = "block";
                        // Show items (only 10)
                        var len = data.length < 11 ? data.length : 10;
                        for(var i = 0; i < len; i++){
                            if (typeof data[i] == "string") {
                                var text = data[i];
                                var value = data[i];
                            } else {
                                // Legacy
                                var text = data[i].text;
                                if (!text && data[i].name) text = data[i].name;
                                var value = data[i].value;
                                if (!value && data[i].id) value = data[i].id;
                            }
                            var div = document.createElement("div");
                            div.setAttribute("data-value", value);
                            div.setAttribute("data-text", text);
                            div.className = "jsearch_item";
                            if (data[i].id) div.setAttribute("id", data[i].id);
                            if (obj1.options.forceSelect && i == 0) div.classList.add("selected");
                            var img = document.createElement("img");
                            if (data[i].image) img.src = data[i].image;
                            else img.style.display = "none";
                            div.appendChild(img);
                            var item = document.createElement("div");
                            item.innerHTML = text;
                            div.appendChild(item);
                            // Append item to the container
                            container.appendChild(div);
                        }
                    }
                };
                var execute = function(str) {
                    if (str != obj1.terms) {
                        // New terms
                        obj1.terms = str;
                        // New index
                        if (obj1.options.forceSelect) index = 0;
                        else index = null;
                        // Array or remote search
                        if (Array.isArray(obj1.options.data)) {
                            var test = function(o) {
                                if (typeof o == "string") {
                                    if (("" + o).toLowerCase().search(str.toLowerCase()) >= 0) return true;
                                } else for(var key in o){
                                    var value = o[key];
                                    if (("" + value).toLowerCase().search(str.toLowerCase()) >= 0) return true;
                                }
                                return false;
                            };
                            var results = obj1.options.data.filter(function(item) {
                                return test(item);
                            });
                            // Show items
                            createList(results);
                        } else // Get remove results
                        ajax({
                            url: obj1.options.data + str,
                            method: "GET",
                            dataType: "json",
                            success: function(data) {
                                // Show items
                                createList(data);
                            }
                        });
                    }
                };
                // Search timer
                var timer = null;
                // Search methods
                var obj1 = function(str) {
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(function() {
                        execute(str);
                    }, 500);
                };
                if (options.forceSelect === null) options.forceSelect = true;
                obj1.options = {
                    data: options.data || null,
                    input: options.input || null,
                    searchByNode: options.searchByNode || null,
                    onselect: options.onselect || null,
                    forceSelect: options.forceSelect,
                    onsearch: options.onsearch || null,
                    onbeforesearch: options.onbeforesearch || null
                };
                obj1.selectIndex = function(item) {
                    var id = item.getAttribute("id");
                    var text = item.getAttribute("data-text");
                    var value = item.getAttribute("data-value");
                    var image = item.children[0].src || "";
                    // Onselect
                    if (typeof obj1.options.onselect == "function") obj1.options.onselect(obj1, text, value, id, image);
                    // Close container
                    obj1.close();
                };
                obj1.open = function() {
                    el.style.display = "block";
                };
                obj1.close = function() {
                    if (timer) clearTimeout(timer);
                    // Current terms
                    obj1.terms = "";
                    // Remove results
                    container.innerHTML = "";
                    // Hide
                    el.style.display = "";
                };
                obj1.isOpened = function() {
                    return el.style.display ? true : false;
                };
                obj1.keydown = function(e) {
                    if (obj1.isOpened()) {
                        if (e.key == "Enter") {
                            // Enter
                            if (index !== null && container.children[index]) {
                                obj1.selectIndex(container.children[index]);
                                e.preventDefault();
                            } else obj1.close();
                        } else if (e.key === "ArrowUp") {
                            // Up
                            if (index !== null && container.children[0]) {
                                container.children[index].classList.remove("selected");
                                if (!obj1.options.forceSelect && index === 0) index = null;
                                else {
                                    index = Math.max(0, index - 1);
                                    container.children[index].classList.add("selected");
                                }
                            }
                            e.preventDefault();
                        } else if (e.key === "ArrowDown") {
                            // Down
                            if (index == null) index = -1;
                            else container.children[index].classList.remove("selected");
                            if (index < 9 && container.children[index + 1]) index++;
                            container.children[index].classList.add("selected");
                            e.preventDefault();
                        }
                    }
                };
                obj1.keyup = function(e) {
                    if (!obj1.options.searchByNode && obj1.options.input) {
                        if (obj1.options.input.tagName === "DIV") var terms = obj1.options.input.innerText;
                        else var terms = obj1.options.input.value;
                    } else {
                        // Current node
                        var node = helpers.getNode();
                        if (node) var terms = node.innerText;
                    }
                    if (typeof obj1.options.onbeforesearch == "function") {
                        var ret = obj1.options.onbeforesearch(obj1, terms);
                        if (ret) terms = ret;
                        else {
                            if (ret === false) // Ignore event
                            return;
                        }
                    }
                    obj1(terms);
                };
                obj1.blur = function(e) {
                    obj1.close();
                };
                // Add events
                if (obj1.options.input) {
                    obj1.options.input.addEventListener("keyup", obj1.keyup);
                    obj1.options.input.addEventListener("keydown", obj1.keydown);
                    obj1.options.input.addEventListener("blur", obj1.blur);
                }
                // Append element
                var container = document.createElement("div");
                container.classList.add("jsearch_container");
                container.onmousedown = select;
                el.appendChild(container);
                el.classList.add("jsearch");
                el.search = obj1;
                return obj1;
            }
            function Slider(el, options) {
                var obj1 = {};
                obj1.options = {};
                obj1.currentImage = null;
                if (options) obj1.options = options;
                // Focus
                el.setAttribute("tabindex", "900");
                // Items
                obj1.options.items = [];
                if (!el.classList.contains("jslider")) {
                    el.classList.add("jslider");
                    el.classList.add("unselectable");
                    if (obj1.options.height) el.style.minHeight = parseInt(obj1.options.height) + "px";
                    if (obj1.options.width) el.style.width = parseInt(obj1.options.width) + "px";
                    if (obj1.options.grid) {
                        el.classList.add("jslider-grid");
                        var number = el.children.length;
                        if (number > 4) el.setAttribute("data-total", number - 4);
                        el.setAttribute("data-number", number > 4 ? 4 : number);
                    }
                    // Add slider counter
                    var counter = document.createElement("div");
                    counter.classList.add("jslider-counter");
                    // Move children inside
                    if (el.children.length > 0) // Keep children items
                    for(var i = 0; i < el.children.length; i++){
                        obj1.options.items.push(el.children[i]);
                        // counter click event
                        var item = document.createElement("div");
                        item.onclick = function() {
                            var index = Array.prototype.slice.call(counter.children).indexOf(this);
                            obj1.show(obj1.currentImage = obj1.options.items[index]);
                        };
                        counter.appendChild(item);
                    }
                    // Add caption
                    var caption = document.createElement("div");
                    caption.className = "jslider-caption";
                    // Add close buttom
                    var controls = document.createElement("div");
                    var close = document.createElement("div");
                    close.className = "jslider-close";
                    close.innerHTML = "";
                    close.onclick = function() {
                        obj1.close();
                    };
                    controls.appendChild(caption);
                    controls.appendChild(close);
                }
                obj1.updateCounter = function(index) {
                    for(var i = 0; i < counter.children.length; i++)if (counter.children[i].classList.contains("jslider-counter-focus")) {
                        counter.children[i].classList.remove("jslider-counter-focus");
                        break;
                    }
                    counter.children[index].classList.add("jslider-counter-focus");
                };
                obj1.show = function(target) {
                    if (!target) var target = el.children[0];
                    // Focus element
                    el.classList.add("jslider-focus");
                    el.classList.remove("jslider-grid");
                    el.appendChild(controls);
                    el.appendChild(counter);
                    // Update counter
                    var index = obj1.options.items.indexOf(target);
                    obj1.updateCounter(index);
                    // Remove display
                    for(var i = 0; i < el.children.length; i++)el.children[i].style.display = "";
                    target.style.display = "block";
                    // Is there any previous
                    if (target.previousElementSibling) el.classList.add("jslider-left");
                    else el.classList.remove("jslider-left");
                    // Is there any next
                    if (target.nextElementSibling && target.nextElementSibling.tagName == "IMG") el.classList.add("jslider-right");
                    else el.classList.remove("jslider-right");
                    obj1.currentImage = target;
                    // Vertical image
                    if (obj1.currentImage.offsetHeight > obj1.currentImage.offsetWidth) obj1.currentImage.classList.add("jslider-vertical");
                    controls.children[0].innerText = obj1.currentImage.getAttribute("title");
                };
                obj1.open = function() {
                    obj1.show();
                    // Event
                    if (typeof obj1.options.onopen == "function") obj1.options.onopen(el);
                };
                obj1.close = function() {
                    // Remove control classes
                    el.classList.remove("jslider-focus");
                    el.classList.remove("jslider-left");
                    el.classList.remove("jslider-right");
                    // Show as a grid depending on the configuration
                    if (obj1.options.grid) el.classList.add("jslider-grid");
                    // Remove display
                    for(var i = 0; i < el.children.length; i++)el.children[i].style.display = "";
                    // Remove controls from the component
                    counter.remove();
                    controls.remove();
                    // Current image
                    obj1.currentImage = null;
                    // Event
                    if (typeof obj1.options.onclose == "function") obj1.options.onclose(el);
                };
                obj1.reset = function() {
                    el.innerHTML = "";
                };
                obj1.next = function() {
                    var nextImage = obj1.currentImage.nextElementSibling;
                    if (nextImage && nextImage.tagName === "IMG") obj1.show(obj1.currentImage.nextElementSibling);
                };
                obj1.prev = function() {
                    if (obj1.currentImage.previousElementSibling) obj1.show(obj1.currentImage.previousElementSibling);
                };
                var mouseUp = function(e) {
                    // Open slider
                    if (e.target.tagName == "IMG") obj1.show(e.target);
                    else if (!e.target.classList.contains("jslider-close") && !(e.target.parentNode.classList.contains("jslider-counter") || e.target.classList.contains("jslider-counter"))) {
                        // Arrow controls
                        var offsetX = e.offsetX || e.changedTouches[0].clientX;
                        if (e.target.clientWidth - offsetX < 40) // Show next image
                        obj1.next();
                        else if (offsetX < 40) // Show previous image
                        obj1.prev();
                    }
                };
                if ("ontouchend" in document.documentElement === true) el.addEventListener("touchend", mouseUp);
                else el.addEventListener("mouseup", mouseUp);
                // Add global events
                el.addEventListener("swipeleft", function(e) {
                    obj1.next();
                    e.preventDefault();
                    e.stopPropagation();
                });
                el.addEventListener("swiperight", function(e) {
                    obj1.prev();
                    e.preventDefault();
                    e.stopPropagation();
                });
                el.addEventListener("keydown", function(e) {
                    if (e.which == 27) obj1.close();
                });
                el.slider = obj1;
                return obj1;
            }
            function Tags(el, options) {
                // Redefine configuration
                if (el.tags) return el.tags.setOptions(options, true);
                var obj1 = {
                    type: "tags"
                };
                obj1.options = {};
                // Limit
                var limit = function() {
                    return obj1.options.limit && el.children.length >= obj1.options.limit ? true : false;
                };
                // Search helpers
                var search = null;
                var searchContainer = null;
                obj1.setOptions = function(options, reset) {
                    /**
         * @typedef {Object} defaults
         * @property {(string|Array)} value - Initial value of the compontent
         * @property {number} limit - Max number of tags inside the element
         * @property {string} search - The URL for suggestions
         * @property {string} placeholder - The default instruction text on the element
         * @property {validation} validation - Method to validate the tags
         * @property {requestCallback} onbeforechange - Method to be execute before any changes on the element
         * @property {requestCallback} onchange - Method to be execute after any changes on the element
         * @property {requestCallback} onfocus - Method to be execute when on focus
         * @property {requestCallback} onblur - Method to be execute when on blur
         * @property {requestCallback} onload - Method to be execute when the element is loaded
         */ var defaults = {
                        value: "",
                        limit: null,
                        search: null,
                        placeholder: null,
                        validation: null,
                        onbeforepaste: null,
                        onbeforechange: null,
                        onremoveitem: null,
                        onlimit: null,
                        onchange: null,
                        onfocus: null,
                        onblur: null,
                        onload: null
                    };
                    // Loop through though the default configuration
                    for(var property in defaults){
                        if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                        else if (typeof obj1.options[property] == "undefined" || reset === true) obj1.options[property] = defaults[property];
                    }
                    // Placeholder
                    if (obj1.options.placeholder) el.setAttribute("data-placeholder", obj1.options.placeholder);
                    else el.removeAttribute("data-placeholder");
                    el.placeholder = obj1.options.placeholder;
                    // Update value
                    obj1.setValue(obj1.options.value);
                    // Validate items
                    filter();
                    // Create search box
                    if (obj1.options.search) {
                        if (!searchContainer) {
                            searchContainer = document.createElement("div");
                            el.parentNode.insertBefore(searchContainer, el.nextSibling);
                            // Create container
                            search = Search(searchContainer, {
                                data: obj1.options.search,
                                onselect: function(a, b, c) {
                                    obj1.selectIndex(b, c);
                                }
                            });
                        }
                    } else if (searchContainer) {
                        search = null;
                        searchContainer.remove();
                        searchContainer = null;
                    }
                    return obj1;
                };
                /**
     * Add a new tag to the element
     * @param {(?string|Array)} value - The value of the new element
     */ obj1.add = function(value, focus) {
                    if (typeof obj1.options.onbeforechange == "function") {
                        var ret = obj1.options.onbeforechange(el, obj1, obj1.options.value, value);
                        if (ret === false) return false;
                        else if (ret != null) value = ret;
                    }
                    // Make sure search is closed
                    if (search) search.close();
                    if (limit()) {
                        if (typeof obj1.options.onlimit == "function") obj1.options.onlimit(obj1, obj1.options.limit);
                        else alert(dictionary.translate("You reach the limit number of entries") + " " + obj1.options.limit);
                    } else {
                        // Get node
                        var node = helpers.getNode();
                        if (node && node.parentNode && node.parentNode.classList.contains("jtags") && node.nextSibling && !(node.nextSibling.innerText && node.nextSibling.innerText.trim())) div = node.nextSibling;
                        else {
                            // Remove not used last item
                            if (el.lastChild) {
                                if (!el.lastChild.innerText.trim()) el.removeChild(el.lastChild);
                            }
                            // Mix argument string or array
                            if (!value || typeof value == "string") var div = createElement(value, value, node);
                            else {
                                for(var i = 0; i <= value.length; i++)if (!limit()) {
                                    if (!value[i] || typeof value[i] == "string") {
                                        var t = value[i] || "";
                                        var v = null;
                                    } else {
                                        var t = value[i].text;
                                        var v = value[i].value;
                                    }
                                    // Add element
                                    var div = createElement(t, v);
                                }
                            }
                            // Change
                            change();
                        }
                        // Place caret
                        if (focus) setFocus(div);
                    }
                };
                obj1.setLimit = function(limit) {
                    obj1.options.limit = limit;
                    var n = el.children.length - limit;
                    while(el.children.length > limit)el.removeChild(el.lastChild);
                };
                // Remove a item node
                obj1.remove = function(node) {
                    // Remove node
                    node.parentNode.removeChild(node);
                    // Make sure element is not blank
                    if (!el.children.length) obj1.add("", true);
                    else change();
                    if (typeof obj1.options.onremoveitem == "function") obj1.options.onremoveitem(el, obj1, node);
                };
                /**
     * Get all tags in the element
     * @return {Array} data - All tags as an array
     */ obj1.getData = function() {
                    var data = [];
                    for(var i = 0; i < el.children.length; i++){
                        // Get value
                        var text = el.children[i].innerText.replace("\n", "");
                        // Get id
                        var value = el.children[i].getAttribute("data-value");
                        if (!value) value = text;
                        // Item
                        if (text || value) data.push({
                            text: text,
                            value: value
                        });
                    }
                    return data;
                };
                /**
     * Get the value of one tag. Null for all tags
     * @param {?number} index - Tag index number. Null for all tags.
     * @return {string} value - All tags separated by comma
     */ obj1.getValue = function(index) {
                    var value = null;
                    if (index != null) {
                        // Get one individual value
                        value = el.children[index].getAttribute("data-value");
                        if (!value) value = el.children[index].innerText.replace("\n", "");
                    } else {
                        // Get all
                        var data = [];
                        for(var i = 0; i < el.children.length; i++){
                            value = el.children[i].innerText.replace("\n", "");
                            if (value) data.push(obj1.getValue(i));
                        }
                        value = data.join(",");
                    }
                    return value;
                };
                /**
     * Set the value of the element based on a string separeted by (,|;|\r\n)
     * @param {mixed} value - A string or array object with values
     */ obj1.setValue = function(mixed) {
                    if (!mixed) obj1.reset();
                    else if (el.value != mixed) {
                        if (Array.isArray(mixed)) obj1.add(mixed);
                        else {
                            // Remove whitespaces
                            var text = ("" + mixed).trim();
                            // Tags
                            var data = extractTags(text);
                            // Reset
                            el.innerHTML = "";
                            // Add tags to the element
                            obj1.add(data);
                        }
                    }
                };
                /**
     * Reset the data from the element
     */ obj1.reset = function() {
                    // Empty class
                    el.classList.add("jtags-empty");
                    // Empty element
                    el.innerHTML = "<div></div>";
                    // Execute changes
                    change();
                };
                /**
     * Verify if all tags in the element are valid
     * @return {boolean}
     */ obj1.isValid = function() {
                    var test = 0;
                    for(var i = 0; i < el.children.length; i++)if (el.children[i].classList.contains("jtags_error")) test++;
                    return test == 0 ? true : false;
                };
                /**
     * Add one element from the suggestions to the element
     * @param {object} item - Node element in the suggestions container
     */ obj1.selectIndex = function(text, value) {
                    var node = helpers.getNode();
                    if (node) {
                        // Append text to the caret
                        node.innerText = text;
                        // Set node id
                        if (value) node.setAttribute("data-value", value);
                        // Remove any error
                        node.classList.remove("jtags_error");
                        if (!limit()) // Add new item
                        obj1.add("", true);
                    }
                };
                /**
     * Search for suggestions
     * @param {object} node - Target node for any suggestions
     */ obj1.search = function(node) {
                    // Search for
                    var terms = node.innerText;
                };
                // Destroy tags element
                obj1.destroy = function() {
                    // Bind events
                    el.removeEventListener("mouseup", tagsMouseUp);
                    el.removeEventListener("keydown", tagsKeyDown);
                    el.removeEventListener("keyup", tagsKeyUp);
                    el.removeEventListener("paste", tagsPaste);
                    el.removeEventListener("focus", tagsFocus);
                    el.removeEventListener("blur", tagsBlur);
                    // Remove element
                    el.parentNode.removeChild(el);
                };
                var setFocus = function(node) {
                    if (el.children.length) {
                        var range = document.createRange();
                        var sel = window.getSelection();
                        if (!node) var node = el.childNodes[el.childNodes.length - 1];
                        range.setStart(node, node.length);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        el.scrollLeft = el.scrollWidth;
                    }
                };
                var createElement = function(label, value, node) {
                    var div = document.createElement("div");
                    div.textContent = label ? label : "";
                    if (value) div.setAttribute("data-value", value);
                    if (node && node.parentNode.classList.contains("jtags")) el.insertBefore(div, node.nextSibling);
                    else el.appendChild(div);
                    return div;
                };
                var change = function() {
                    // Value
                    var value = obj1.getValue();
                    if (value != obj1.options.value) {
                        obj1.options.value = value;
                        if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, obj1, obj1.options.value);
                        // Lemonade JS
                        if (el.value != obj1.options.value) {
                            el.value = obj1.options.value;
                            if (typeof el.oninput == "function") el.oninput({
                                type: "input",
                                target: el,
                                value: el.value
                            });
                        }
                    }
                    filter();
                };
                /**
     * Filter tags
     */ var filter = function() {
                    for(var i = 0; i < el.children.length; i++)if (el.children[i].tagName === "DIV") {
                        // Create label design
                        if (!obj1.getValue(i)) el.children[i].classList.remove("jtags_label");
                        else {
                            el.children[i].classList.add("jtags_label");
                            // Validation in place
                            if (typeof obj1.options.validation == "function") {
                                if (obj1.getValue(i)) {
                                    if (!obj1.options.validation(el.children[i], el.children[i].innerText, el.children[i].getAttribute("data-value"))) el.children[i].classList.add("jtags_error");
                                    else el.children[i].classList.remove("jtags_error");
                                } else el.children[i].classList.remove("jtags_error");
                            } else el.children[i].classList.remove("jtags_error");
                        }
                    }
                    isEmpty();
                };
                var isEmpty = function() {
                    // Can't be empty
                    if (!el.innerText.trim()) {
                        if (!el.children.length || el.children[0].tagName === "BR") {
                            el.innerHTML = "";
                            setFocus(createElement());
                        }
                    } else el.classList.remove("jtags-empty");
                };
                /**
     * Extract tags from a string
     * @param {string} text - Raw string
     * @return {Array} data - Array with extracted tags
     */ var extractTags = function(text) {
                    /** @type {Array} */ var data = [];
                    /** @type {string} */ var word = "";
                    // Remove whitespaces
                    text = text.trim();
                    if (text) {
                        for(var i = 0; i < text.length; i++){
                            if (text[i] == "," || text[i] == ";" || text[i] == "\n") {
                                if (word) {
                                    data.push(word.trim());
                                    word = "";
                                }
                            } else word += text[i];
                        }
                        if (word) data.push(word);
                    }
                    return data;
                };
                /** @type {number} */ var anchorOffset = 0;
                /**
     * Processing event keydown on the element
     * @param e {object}
     */ var tagsKeyDown = function(e) {
                    // Anchoroffset
                    anchorOffset = window.getSelection().anchorOffset;
                    // Verify if is empty
                    isEmpty();
                    // Comma
                    if (e.key === "Tab" || e.key === ";" || e.key === ",") {
                        var n = window.getSelection().anchorOffset;
                        if (n > 1) {
                            if (limit()) {
                                if (typeof obj1.options.onlimit == "function") obj1.options.onlimit(obj1, obj1.options.limit);
                            } else obj1.add("", true);
                        }
                        e.preventDefault();
                    } else if (e.key == "Enter") {
                        if (!search || !search.isOpened()) {
                            var n = window.getSelection().anchorOffset;
                            if (n > 1) {
                                if (!limit()) obj1.add("", true);
                            }
                            e.preventDefault();
                        }
                    } else if (e.key == "Backspace") // Back space - do not let last item to be removed
                    {
                        if (el.children.length == 1 && window.getSelection().anchorOffset < 1) e.preventDefault();
                    }
                    // Search events
                    if (search) search.keydown(e);
                    // Verify if is empty
                    isEmpty();
                };
                /**
     * Processing event keyup on the element
     * @param e {object}
     */ var tagsKeyUp = function(e) {
                    if (e.which == 39) {
                        // Right arrow
                        var n = window.getSelection().anchorOffset;
                        if (n > 1 && n == anchorOffset) obj1.add("", true);
                    } else if (e.which == 13 || e.which == 38 || e.which == 40) e.preventDefault();
                    else if (search) search.keyup(e);
                    filter();
                };
                /**
     * Processing event paste on the element
     * @param e {object}
     */ var tagsPaste = function(e) {
                    if (e.clipboardData || e.originalEvent.clipboardData) var text = (e.originalEvent || e).clipboardData.getData("text/plain");
                    else if (window.clipboardData) var text = window.clipboardData.getData("Text");
                    var data = extractTags(text);
                    if (typeof obj1.options.onbeforepaste == "function") {
                        var ret = obj1.options.onbeforepaste(el, obj1, data);
                        if (ret === false) {
                            e.preventDefault();
                            return false;
                        } else if (ret) data = ret;
                    }
                    if (data.length > 1) {
                        obj1.add(data, true);
                        e.preventDefault();
                    } else if (data[0]) {
                        document.execCommand("insertText", false, data[0]);
                        e.preventDefault();
                    }
                };
                /**
     * Processing event mouseup on the element
     * @param e {object}
     */ var tagsMouseUp = function(e) {
                    if (e.target.parentNode && e.target.parentNode.classList.contains("jtags")) {
                        if (e.target.classList.contains("jtags_label") || e.target.classList.contains("jtags_error")) {
                            var rect = e.target.getBoundingClientRect();
                            if (rect.width - (e.clientX - rect.left) < 16) obj1.remove(e.target);
                        }
                    }
                    // Set focus in the last item
                    if (e.target == el) setFocus();
                };
                var tagsFocus = function() {
                    if (!el.classList.contains("jtags-focus")) {
                        if (!el.children.length || obj1.getValue(el.children.length - 1)) {
                            if (!limit()) createElement("");
                        }
                        if (typeof obj1.options.onfocus == "function") obj1.options.onfocus(el, obj1, obj1.getValue());
                        el.classList.add("jtags-focus");
                    }
                };
                var tagsBlur = function() {
                    if (el.classList.contains("jtags-focus")) {
                        if (search) search.close();
                        for(var i = 0; i < el.children.length - 1; i++)// Create label design
                        if (!obj1.getValue(i)) el.removeChild(el.children[i]);
                        change();
                        el.classList.remove("jtags-focus");
                        if (typeof obj1.options.onblur == "function") obj1.options.onblur(el, obj1, obj1.getValue());
                    }
                };
                var init = function() {
                    // Bind events
                    if ("touchend" in document.documentElement === true) el.addEventListener("touchend", tagsMouseUp);
                    else el.addEventListener("mouseup", tagsMouseUp);
                    el.addEventListener("keydown", tagsKeyDown);
                    el.addEventListener("keyup", tagsKeyUp);
                    el.addEventListener("paste", tagsPaste);
                    el.addEventListener("focus", tagsFocus);
                    el.addEventListener("blur", tagsBlur);
                    // Editable
                    el.setAttribute("contenteditable", true);
                    // Prepare container
                    el.classList.add("jtags");
                    // Initial options
                    obj1.setOptions(options);
                    if (typeof obj1.options.onload == "function") obj1.options.onload(el, obj1);
                    // Change methods
                    el.change = obj1.setValue;
                    // Global generic value handler
                    el.val = function(val) {
                        if (val === undefined) return obj1.getValue();
                        else obj1.setValue(val);
                    };
                    el.tags = obj1;
                };
                init();
                return obj1;
            }
            function Upload(el, options) {
                var obj1 = {};
                obj1.options = {};
                // Default configuration
                var defaults = {
                    type: "image",
                    extension: "*",
                    input: false,
                    minWidth: false,
                    maxWidth: null,
                    maxHeight: null,
                    maxJpegSizeBytes: null,
                    onchange: null,
                    multiple: false,
                    remoteParser: null
                };
                // Loop through our object
                for(var property in defaults)if (options && options.hasOwnProperty(property)) obj1.options[property] = options[property];
                else obj1.options[property] = defaults[property];
                // Multiple
                if (obj1.options.multiple == true) el.setAttribute("data-multiple", true);
                // Container
                el.content = [];
                // Upload icon
                el.classList.add("jupload");
                if (obj1.options.input == true) el.classList.add("input");
                obj1.add = function(data) {
                    // Reset container for single files
                    if (obj1.options.multiple == false) {
                        el.content = [];
                        el.innerText = "";
                    }
                    // Append to the element
                    if (obj1.options.type == "image") {
                        var img = document.createElement("img");
                        img.setAttribute("src", data.file);
                        img.setAttribute("tabindex", -1);
                        if (!el.getAttribute("name")) {
                            img.className = "jfile";
                            img.content = data;
                        }
                        el.appendChild(img);
                    } else {
                        if (data.name) var name = data.name;
                        else var name = data.file;
                        var div = document.createElement("div");
                        div.innerText = name || obj1.options.type;
                        div.classList.add("jupload-item");
                        div.setAttribute("tabindex", -1);
                        el.appendChild(div);
                    }
                    if (data.content) data.file = helpers.guid();
                    // Push content
                    el.content.push(data);
                    // Onchange
                    if (typeof obj1.options.onchange == "function") obj1.options.onchange(el, data);
                };
                obj1.addFromFile = function(file) {
                    var type = file.type.split("/");
                    if (type[0] == obj1.options.type) {
                        var readFile = new FileReader();
                        readFile.addEventListener("load", function(v) {
                            var data = {
                                file: v.srcElement.result,
                                extension: file.name.substr(file.name.lastIndexOf(".") + 1),
                                name: file.name,
                                size: file.size,
                                lastmodified: file.lastModified,
                                content: v.srcElement.result
                            };
                            obj1.add(data);
                        });
                        readFile.readAsDataURL(file);
                    } else alert(dictionary.translate("This extension is not allowed"));
                };
                obj1.addFromUrl = function(src) {
                    if (src.substr(0, 4) != "data" && !obj1.options.remoteParser) console.error("remoteParser not defined in your initialization");
                    else // This is to process cross domain images
                    if (src.substr(0, 4) == "data") {
                        var extension = src.split(";");
                        extension = extension[0].split("/");
                        var type = extension[0].replace("data:", "");
                        if (type == obj1.options.type) {
                            var data = {
                                file: src,
                                name: "",
                                extension: extension[1],
                                content: src
                            };
                            obj1.add(data);
                        } else alert(obj1.options.text.extensionNotAllowed);
                    } else {
                        var extension = src.substr(src.lastIndexOf(".") + 1);
                        // Work for cross browsers
                        src = obj1.options.remoteParser + src;
                        // Get remove content
                        ajax({
                            url: src,
                            type: "GET",
                            dataType: "blob",
                            success: function(data) {
                            //add(extension[0].replace('data:',''), data);
                            }
                        });
                    }
                };
                var getDataURL = function(canvas, type) {
                    var compression = 0.92;
                    var lastContentLength = null;
                    var content = canvas.toDataURL(type, compression);
                    while(obj1.options.maxJpegSizeBytes && type === "image/jpeg" && content.length > obj1.options.maxJpegSizeBytes && content.length !== lastContentLength){
                        // Apply the compression
                        compression *= 0.9;
                        lastContentLength = content.length;
                        content = canvas.toDataURL(type, compression);
                    }
                    return content;
                };
                var mime = obj1.options.type + "/" + obj1.options.extension;
                var input = document.createElement("input");
                input.type = "file";
                input.setAttribute("accept", mime);
                input.onchange = function() {
                    for(var i = 0; i < this.files.length; i++)obj1.addFromFile(this.files[i]);
                };
                // Allow multiple files
                if (obj1.options.multiple == true) input.setAttribute("multiple", true);
                var current = null;
                el.addEventListener("click", function(e) {
                    current = null;
                    if (!el.children.length || e.target === el) helpers.click(input);
                    else if (e.target.parentNode == el) current = e.target;
                });
                el.addEventListener("dblclick", function(e) {
                    helpers.click(input);
                });
                el.addEventListener("dragenter", function(e) {
                    el.style.border = "1px dashed #000";
                });
                el.addEventListener("dragleave", function(e) {
                    el.style.border = "1px solid #eee";
                });
                el.addEventListener("dragstop", function(e) {
                    el.style.border = "1px solid #eee";
                });
                el.addEventListener("dragover", function(e) {
                    e.preventDefault();
                });
                el.addEventListener("keydown", function(e) {
                    if (current && e.which == 46) {
                        var index = Array.prototype.indexOf.call(el.children, current);
                        if (index >= 0) {
                            el.content.splice(index, 1);
                            current.remove();
                            current = null;
                        }
                    }
                });
                el.addEventListener("drop", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var html = (e.originalEvent || e).dataTransfer.getData("text/html");
                    var file = (e.originalEvent || e).dataTransfer.files;
                    if (file.length) for(var i = 0; i < e.dataTransfer.files.length; i++)obj1.addFromFile(e.dataTransfer.files[i]);
                    else if (html) {
                        if (obj1.options.multiple == false) el.innerText = "";
                        // Create temp element
                        let img = [];
                        utils_filter(html, img);
                        if (img.length) for(var i = 0; i < img.length; i++)obj1.addFromUrl(img[i]);
                    }
                    el.style.border = "1px solid #eee";
                    return false;
                });
                el.val = function(val) {
                    if (val === undefined) return el.content && el.content.length ? el.content : null;
                    else {
                        // Reset
                        el.innerText = "";
                        el.content = [];
                        if (val) {
                            if (Array.isArray(val)) {
                                for(var i = 0; i < val.length; i++)if (typeof val[i] == "string") obj1.add({
                                    file: val[i]
                                });
                                else obj1.add(val[i]);
                            } else if (typeof val == "string") obj1.add({
                                file: val
                            });
                        }
                    }
                };
                el.upload = el.image = obj1;
                return obj1;
            }
            // EXTERNAL MODULE: ./packages/sha512/sha512.js
            var sha512 = __webpack_require__(195);
            var sha512_default = /*#__PURE__*/ __webpack_require__.n(sha512);
            var jsuites_jSuites = (0, $2qxEV._)((0, $9tqwB._)({}, dictionary, helpers), {
                /** Current version */ version: "5.13.3",
                /** Bind new extensions to Jsuites */ setExtensions: function(o) {
                    if (typeof o == "object") {
                        var k = Object.keys(o);
                        for(var i = 0; i < k.length; i++)jsuites_jSuites[k[i]] = o[k[i]];
                    }
                },
                tracking: tracking,
                path: Path,
                sorting: Sorting,
                lazyLoading: LazyLoading,
                // Plugins
                ajax: ajax,
                animation: animation,
                calendar: calendar,
                color: Color,
                contextmenu: contextmenu,
                dropdown: dropdown,
                editor: editor,
                floating: floating,
                form: plugins_form,
                mask: mask,
                modal: modal,
                notification: notification,
                palette: palette,
                picker: Picker,
                progressbar: Progressbar,
                rating: Rating,
                search: Search,
                slider: Slider,
                tabs: Tabs,
                tags: Tags,
                toolbar: Toolbar,
                upload: Upload,
                validations: validations
            });
            // Legacy
            jsuites_jSuites.image = Upload;
            jsuites_jSuites.image.create = function(data) {
                var img = document.createElement("img");
                img.setAttribute("src", data.file);
                img.className = "jfile";
                img.setAttribute("tabindex", -1);
                img.content = data;
                return img;
            };
            jsuites_jSuites.tracker = plugins_form;
            jsuites_jSuites.loading = animation.loading;
            jsuites_jSuites.sha512 = sha512_default();
            /** Core events */ const Events = function() {
                if (typeof window["jSuitesStateControl"] === "undefined") window["jSuitesStateControl"] = [];
                else // Do nothing
                return;
                const find = function(DOMElement, component) {
                    if (DOMElement[component.type] && DOMElement[component.type] == component) return true;
                    if (DOMElement.component && DOMElement.component == component) return true;
                    if (DOMElement.parentNode) return find(DOMElement.parentNode, component);
                    return false;
                };
                const isOpened = function(e) {
                    let state = window["jSuitesStateControl"];
                    if (state && state.length > 0) {
                        for(let i = 0; i < state.length; i++)if (state[i] && !find(e, state[i])) state[i].close();
                    }
                };
                // Width of the border
                let cornerSize = 15;
                // Current element
                let element = null;
                // Controllers
                let editorAction = false;
                // Event state
                let state = {
                    x: null,
                    y: null
                };
                // Tooltip element
                let tooltip = document.createElement("div");
                tooltip.classList.add("jtooltip");
                const isWebcomponent = function(e) {
                    return e && (e.shadowRoot || e.tagName && e.tagName.includes("-"));
                };
                const getElement = function(e) {
                    let d;
                    let element;
                    // Which component I am clicking
                    let path = e.path || e.composedPath && e.composedPath();
                    // If path available get the first element in the chain
                    if (path) {
                        element = path[0];
                        // Adjustment sales force
                        if (element && isWebcomponent(element) && !element.shadowRoot && e.toElement) element = e.toElement;
                    } else {
                        // Try to guess using the coordinates
                        if (e.target && isWebcomponent(e.target)) d = e.target.shadowRoot;
                        else d = document;
                        // Get the first target element
                        element = d.elementFromPoint(x, y);
                    }
                    return element;
                };
                // Events
                const mouseDown = function(e) {
                    // Verify current components tracking
                    if (e.changedTouches && e.changedTouches[0]) {
                        var x1 = e.changedTouches[0].clientX;
                        var y1 = e.changedTouches[0].clientY;
                    } else {
                        var x1 = e.clientX;
                        var y1 = e.clientY;
                    }
                    let element = getElement(e);
                    // Editable
                    let editable = element && element.tagName === "DIV" && element.getAttribute("contentEditable");
                    // Check if this is the floating
                    let item = jsuites_jSuites.findElement(element, "jpanel");
                    // Jfloating found
                    if (item && !item.classList.contains("readonly") && !editable) {
                        // Keep the tracking information
                        let rect = item.getBoundingClientRect();
                        let angle = 0;
                        if (item.style.rotate) // Extract the angle value from the match and convert it to a number
                        angle = parseFloat(item.style.rotate);
                        let action = "move";
                        if (element.getAttribute("data-action")) action = element.getAttribute("data-action");
                        else if (item.style.cursor) action = "resize";
                        else item.style.cursor = "move";
                        // Action
                        editorAction = {
                            action: action,
                            a: angle,
                            e: item,
                            x: x1,
                            y: y1,
                            l: rect.left,
                            t: rect.top,
                            b: rect.bottom,
                            r: rect.right,
                            w: rect.width,
                            h: rect.height,
                            d: item.style.cursor,
                            actioned: false
                        };
                        // Make sure width and height styling is OK
                        if (!item.style.width) item.style.width = rect.width + "px";
                        if (!item.style.height) item.style.height = rect.height + "px";
                    } else // No floating action found
                    editorAction = false;
                    isOpened(element);
                    focus(e);
                };
                const calculateAngle = function(x1, y1, x2, y2, x3, y3) {
                    // Calculate dx and dy for the first line
                    const dx1 = x2 - x1;
                    const dy1 = y2 - y1;
                    // Calculate dx and dy for the second line
                    const dx2 = x3 - x1;
                    const dy2 = y3 - y1;
                    // Calculate the angle for the first line
                    let angle1 = Math.atan2(dy1, dx1);
                    // Calculate the angle for the second line
                    let angle2 = Math.atan2(dy2, dx2);
                    // Calculate the angle difference in radians
                    let angleDifference = angle2 - angle1;
                    // Convert the angle difference to degrees
                    angleDifference = angleDifference * (180 / Math.PI);
                    // Normalize the angle difference to be within [0, 360) degrees
                    if (angleDifference < 0) angleDifference += 360;
                    return angleDifference;
                };
                const mouseUp = function(e) {
                    if (editorAction && editorAction.e) {
                        if (typeof editorAction.e.refresh == "function" && state.actioned) editorAction.e.refresh();
                        editorAction.e.style.cursor = "";
                    }
                    // Reset
                    state = {
                        x: null,
                        y: null
                    };
                    editorAction = false;
                };
                const mouseMove = function(e) {
                    if (editorAction) {
                        let x1 = e.clientX || e.pageX;
                        let y1 = e.clientY || e.pageY;
                        if (state.x == null && state.y == null) {
                            state.x = x1;
                            state.y = y1;
                        }
                        // Action on going
                        if (editorAction.action === "move") {
                            var dx = x1 - state.x;
                            var dy = y1 - state.y;
                            var top = editorAction.e.offsetTop + dy;
                            var left = editorAction.e.offsetLeft + dx;
                            // Update position
                            editorAction.e.style.top = top + "px";
                            editorAction.e.style.left = left + "px";
                            // Update element
                            if (typeof editorAction.e.refresh == "function") {
                                state.actioned = true;
                                editorAction.e.refresh("position", top, left);
                            }
                        } else if (editorAction.action === "rotate") {
                            let ox = editorAction.l + editorAction.w / 2;
                            let oy = editorAction.t + editorAction.h / 2;
                            let angle = calculateAngle(ox, oy, editorAction.x, editorAction.y, x1, y1);
                            angle = angle + editorAction.a % 360;
                            angle = Math.round(angle / 2) * 2;
                            editorAction.e.style.rotate = `${angle}deg`;
                            // Update element
                            if (typeof editorAction.e.refresh == "function") {
                                state.actioned = true;
                                editorAction.e.refresh("rotate", angle);
                            }
                        } else if (editorAction.action === "resize") {
                            let top = null;
                            let left = null;
                            let width = null;
                            let height = null;
                            if (editorAction.d == "e-resize" || editorAction.d == "ne-resize" || editorAction.d == "se-resize") {
                                width = editorAction.e.offsetWidth + (x1 - state.x);
                                if (e.shiftKey) height = editorAction.e.offsetHeight + (x1 - state.x) * (editorAction.e.offsetHeight / editorAction.e.offsetWidth);
                            } else if (editorAction.d === "w-resize" || editorAction.d == "nw-resize" || editorAction.d == "sw-resize") {
                                left = editorAction.e.offsetLeft + (x1 - state.x);
                                width = editorAction.e.offsetLeft + editorAction.e.offsetWidth - left;
                                if (e.shiftKey) height = editorAction.e.offsetHeight - (x1 - state.x) * (editorAction.e.offsetHeight / editorAction.e.offsetWidth);
                            }
                            if (editorAction.d == "s-resize" || editorAction.d == "se-resize" || editorAction.d == "sw-resize") {
                                if (!height) height = editorAction.e.offsetHeight + (y1 - state.y);
                            } else if (editorAction.d === "n-resize" || editorAction.d == "ne-resize" || editorAction.d == "nw-resize") {
                                top = editorAction.e.offsetTop + (y1 - state.y);
                                height = editorAction.e.offsetTop + editorAction.e.offsetHeight - top;
                            }
                            if (top) editorAction.e.style.top = top + "px";
                            if (left) editorAction.e.style.left = left + "px";
                            if (width) editorAction.e.style.width = width + "px";
                            if (height) editorAction.e.style.height = height + "px";
                            // Update element
                            if (typeof editorAction.e.refresh == "function") {
                                state.actioned = true;
                                editorAction.e.refresh("dimensions", width, height);
                            }
                        }
                        state.x = x1;
                        state.y = y1;
                    } else {
                        let element = getElement(e);
                        // Resize action
                        let item = jsuites_jSuites.findElement(element, "jpanel");
                        // Found eligible component
                        if (item) {
                            // Resizing action
                            let controls = item.classList.contains("jpanel-controls");
                            if (controls) {
                                let position = element.getAttribute("data-position");
                                if (position) item.style.cursor = position;
                                else item.style.cursor = "";
                            } else if (item.getAttribute("tabindex")) {
                                let rect = item.getBoundingClientRect();
                                //console.log(e.clientY - rect.top, rect.width - (e.clientX - rect.left), cornerSize)
                                if (e.clientY - rect.top < cornerSize) {
                                    if (rect.width - (e.clientX - rect.left) < cornerSize) item.style.cursor = "ne-resize";
                                    else if (e.clientX - rect.left < cornerSize) item.style.cursor = "nw-resize";
                                    else item.style.cursor = "n-resize";
                                } else if (rect.height - (e.clientY - rect.top) < cornerSize) {
                                    if (rect.width - (e.clientX - rect.left) < cornerSize) item.style.cursor = "se-resize";
                                    else if (e.clientX - rect.left < cornerSize) item.style.cursor = "sw-resize";
                                    else item.style.cursor = "s-resize";
                                } else if (rect.width - (e.clientX - rect.left) < cornerSize) item.style.cursor = "e-resize";
                                else if (e.clientX - rect.left < cornerSize) item.style.cursor = "w-resize";
                                else item.style.cursor = "";
                            }
                        }
                    }
                };
                let position = [
                    "n",
                    "ne",
                    "e",
                    "se",
                    "s",
                    "sw",
                    "w",
                    "nw",
                    "rotate"
                ];
                position.forEach(function(v, k) {
                    position[k] = document.createElement("div");
                    position[k].classList.add("jpanel-action");
                    if (v === "rotate") position[k].setAttribute("data-action", "rotate");
                    else {
                        position[k].setAttribute("data-action", "resize");
                        position[k].setAttribute("data-position", v + "-resize");
                    }
                });
                let currentElement;
                const focus = function(e) {
                    let element = getElement(e);
                    // Check if this is floating
                    let item = jsuites_jSuites.findElement(element, "jpanel");
                    if (item && !item.classList.contains("readonly") && item.classList.contains("jpanel-controls")) {
                        item.append(...position);
                        if (!item.classList.contains("jpanel-rotate")) position[position.length - 1].remove();
                        currentElement = item;
                    } else blur(e);
                };
                const blur = function(e) {
                    if (currentElement) {
                        position.forEach(function(v) {
                            v.remove();
                        });
                        currentElement = null;
                    }
                };
                const mouseOver = function(e) {
                    let element = getElement(e);
                    var message = element.getAttribute("data-tooltip");
                    if (message) {
                        // Instructions
                        tooltip.innerText = message;
                        // Position
                        if (e.changedTouches && e.changedTouches[0]) {
                            var x1 = e.changedTouches[0].clientX;
                            var y1 = e.changedTouches[0].clientY;
                        } else {
                            var x1 = e.clientX;
                            var y1 = e.clientY;
                        }
                        tooltip.style.top = y1 + "px";
                        tooltip.style.left = x1 + "px";
                        document.body.appendChild(tooltip);
                    } else if (tooltip.innerText) {
                        tooltip.innerText = "";
                        document.body.removeChild(tooltip);
                    }
                };
                const contextMenu = function(e) {
                    var item = document.activeElement;
                    if (item && typeof item.contextmenu == "function") {
                        // Create edition
                        item.contextmenu(e);
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    } else {
                        // Search for possible context menus
                        item = jsuites_jSuites.findElement(e.target, function(o) {
                            return o.tagName && o.getAttribute("aria-contextmenu-id");
                        });
                        if (item) {
                            var o = document.querySelector("#" + item);
                            if (!o) console.error("JSUITES: contextmenu id not found: " + item);
                            else {
                                o.contextmenu.open(e);
                                e.preventDefault();
                                e.stopImmediatePropagation();
                            }
                        }
                    }
                };
                const keyDown = function(e) {
                    let item = document.activeElement;
                    if (item) {
                        if (e.key === "Delete" && typeof item.delete == "function") {
                            item.delete();
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        }
                    }
                    let state = window["jSuitesStateControl"];
                    if (state && state.length > 0) {
                        item = state[state.length - 1];
                        if (item) {
                            if (e.key === "Escape" && typeof item.isOpened == "function" && typeof item.close == "function") {
                                if (item.isOpened()) {
                                    item.close();
                                    e.preventDefault();
                                    e.stopImmediatePropagation();
                                }
                            }
                        }
                    }
                };
                const input = function(e) {
                    if (e.target.getAttribute("data-mask") || e.target.mask) jsuites_jSuites.mask(e);
                };
                document.addEventListener("focusin", focus);
                document.addEventListener("mouseup", mouseUp);
                document.addEventListener("mousedown", mouseDown);
                document.addEventListener("mousemove", mouseMove);
                document.addEventListener("mouseover", mouseOver);
                document.addEventListener("keydown", keyDown);
                document.addEventListener("contextmenu", contextMenu);
                document.addEventListener("input", input);
            };
            if (typeof document !== "undefined") Events();
            /* harmony default export */ var jsuites = jsuites_jSuites;
        }();
        jSuites = __webpack_exports__["default"];
    /******/ })();
    return jSuites;
});


(function(global, factory) {
    $f6d096c4c719df2a$exports = factory();
})($f6d096c4c719df2a$exports, function() {
    var jspreadsheet;
    !function() {
        var e = {
            463: function(e) {
                var t;
                e.exports = (function() {
                    var e = {
                        765: function(e, t) {
                            var n;
                            n = function(e) {
                                e.version = "1.0.2";
                                var t = Math;
                                function n(e, t) {
                                    for(var n = 0, r = 0; n < e.length; ++n)r = t * r + e[n];
                                    return r;
                                }
                                function r(e, t, n, r, o) {
                                    if (0 === t) return n;
                                    if (1 === t) return r;
                                    for(var i = 2 / e, s = r, l = 1; l < t; ++l)s = r * l * i + o * n, n = r, r = s;
                                    return s;
                                }
                                function o(e, t, n, o, i) {
                                    return function(n, s) {
                                        if (o) {
                                            if (0 === n) return 1 == o ? -1 / 0 : 1 / 0;
                                            if (n < 0) return NaN;
                                        }
                                        return 0 === s ? e(n) : 1 === s ? t(n) : s < 0 ? NaN : r(n, s |= 0, e(n), t(n), i);
                                    };
                                }
                                var i, s, l, a, u, c, f, d, p, h, g, m, v, y = function() {
                                    var e = .636619772, o = [
                                        57568490574,
                                        -13362590354,
                                        651619640.7,
                                        -11214424.18,
                                        77392.33017,
                                        -184.9052456
                                    ].reverse(), i = [
                                        57568490411,
                                        1029532985,
                                        9494680.718,
                                        59272.64853,
                                        267.8532712,
                                        1
                                    ].reverse(), s = [
                                        1,
                                        -0.001098628627,
                                        2734510407e-14,
                                        -0.000002073370639,
                                        2.093887211e-7
                                    ].reverse(), l = [
                                        -0.01562499995,
                                        .0001430488765,
                                        -0.000006911147651,
                                        7.621095161e-7,
                                        -0.0000000934935152
                                    ].reverse();
                                    function a(r) {
                                        var a = 0, u = 0, c = 0, f = r * r;
                                        if (r < 8) a = (u = n(o, f)) / (c = n(i, f));
                                        else {
                                            var d = r - .785398164;
                                            u = n(s, f = 64 / f), c = n(l, f), a = t.sqrt(e / r) * (t.cos(d) * u - t.sin(d) * c * 8 / r);
                                        }
                                        return a;
                                    }
                                    var u = [
                                        72362614232,
                                        -7895059235,
                                        242396853.1,
                                        -2972611.439,
                                        15704.4826,
                                        -30.16036606
                                    ].reverse(), c = [
                                        144725228442,
                                        2300535178,
                                        18583304.74,
                                        99447.43394,
                                        376.9991397,
                                        1
                                    ].reverse(), f = [
                                        1,
                                        .00183105,
                                        -0.00003516396496,
                                        2457520174e-15,
                                        -0.000000240337019
                                    ].reverse(), d = [
                                        .04687499995,
                                        -0.0002002690873,
                                        8449199096e-15,
                                        -0.00000088228987,
                                        1.05787412e-7
                                    ].reverse();
                                    function p(r) {
                                        var o = 0, i = 0, s = 0, l = r * r, a = t.abs(r) - 2.356194491;
                                        return Math.abs(r) < 8 ? o = (i = r * n(u, l)) / (s = n(c, l)) : (i = n(f, l = 64 / l), s = n(d, l), o = t.sqrt(e / t.abs(r)) * (t.cos(a) * i - t.sin(a) * s * 8 / t.abs(r)), r < 0 && (o = -o)), o;
                                    }
                                    return function e(n, o) {
                                        if (o = Math.round(o), !isFinite(n)) return isNaN(n) ? n : 0;
                                        if (o < 0) return (o % 2 ? -1 : 1) * e(n, -o);
                                        if (n < 0) return (o % 2 ? -1 : 1) * e(-n, o);
                                        if (0 === o) return a(n);
                                        if (1 === o) return p(n);
                                        if (0 === n) return 0;
                                        var i = 0;
                                        if (n > o) i = r(n, o, a(n), p(n), -1);
                                        else {
                                            for(var s = !1, l = 0, u = 0, c = 1, f = 0, d = 2 / n, h = 2 * t.floor((o + t.floor(t.sqrt(40 * o))) / 2); h > 0; h--)f = h * d * c - l, l = c, c = f, t.abs(c) > 1e10 && (c *= 1e-10, l *= 1e-10, i *= 1e-10, u *= 1e-10), s && (u += c), s = !s, h == o && (i = l);
                                            i /= u = 2 * u - c;
                                        }
                                        return i;
                                    };
                                }(), C = (i = .636619772, s = [
                                    -2957821389,
                                    7062834065,
                                    -512359803.6,
                                    10879881.29,
                                    -86327.92757,
                                    228.4622733
                                ].reverse(), l = [
                                    40076544269,
                                    745249964.8,
                                    7189466.438,
                                    47447.2647,
                                    226.1030244,
                                    1
                                ].reverse(), a = [
                                    1,
                                    -0.001098628627,
                                    2734510407e-14,
                                    -0.000002073370639,
                                    2.093887211e-7
                                ].reverse(), u = [
                                    -0.01562499995,
                                    .0001430488765,
                                    -0.000006911147651,
                                    7.621095161e-7,
                                    -0.0000000934945152
                                ].reverse(), c = [
                                    -4900604943000,
                                    127527439e4,
                                    -51534381390,
                                    734926455.1,
                                    -4237922.726,
                                    8511.937935
                                ].reverse(), f = [
                                    249958057e5,
                                    424441966400,
                                    3733650367,
                                    22459040.02,
                                    102042.605,
                                    354.9632885,
                                    1
                                ].reverse(), d = [
                                    1,
                                    .00183105,
                                    -0.00003516396496,
                                    2457520174e-15,
                                    -0.000000240337019
                                ].reverse(), p = [
                                    .04687499995,
                                    -0.0002002690873,
                                    8449199096e-15,
                                    -0.00000088228987,
                                    1.05787412e-7
                                ].reverse(), o(function(e) {
                                    var r = 0, o = 0, c = 0, f = e * e, d = e - .785398164;
                                    return e < 8 ? r = (o = n(s, f)) / (c = n(l, f)) + i * y(e, 0) * t.log(e) : (o = n(a, f = 64 / f), c = n(u, f), r = t.sqrt(i / e) * (t.sin(d) * o + t.cos(d) * c * 8 / e)), r;
                                }, function(e) {
                                    var r = 0, o = 0, s = 0, l = e * e, a = e - 2.356194491;
                                    return e < 8 ? r = (o = e * n(c, l)) / (s = n(f, l)) + i * (y(e, 1) * t.log(e) - 1 / e) : (o = n(d, l = 64 / l), s = n(p, l), r = t.sqrt(i / e) * (t.sin(a) * o + t.cos(a) * s * 8 / e)), r;
                                }, 0, 1, -1)), w = (h = [
                                    1,
                                    3.5156229,
                                    3.0899424,
                                    1.2067492,
                                    .2659732,
                                    .0360768,
                                    .0045813
                                ].reverse(), g = [
                                    .39894228,
                                    .01328592,
                                    .00225319,
                                    -0.00157565,
                                    .00916281,
                                    -0.02057706,
                                    .02635537,
                                    -0.01647633,
                                    .00392377
                                ].reverse(), m = [
                                    .5,
                                    .87890594,
                                    .51498869,
                                    .15084934,
                                    .02658733,
                                    .00301532,
                                    32411e-8
                                ].reverse(), v = [
                                    .39894228,
                                    -0.03988024,
                                    -0.00362018,
                                    .00163801,
                                    -0.01031555,
                                    .02282967,
                                    -0.02895312,
                                    .01787654,
                                    -0.00420059
                                ].reverse(), function e(r, o) {
                                    if (0 === (o = Math.round(o))) return function(e) {
                                        return e <= 3.75 ? n(h, e * e / 14.0625) : t.exp(t.abs(e)) / t.sqrt(t.abs(e)) * n(g, 3.75 / t.abs(e));
                                    }(r);
                                    if (1 === o) return function(e) {
                                        return e < 3.75 ? e * n(m, e * e / 14.0625) : (e < 0 ? -1 : 1) * t.exp(t.abs(e)) / t.sqrt(t.abs(e)) * n(v, 3.75 / t.abs(e));
                                    }(r);
                                    if (o < 0) return NaN;
                                    if (0 === t.abs(r)) return 0;
                                    if (r == 1 / 0) return 1 / 0;
                                    var i, s = 0, l = 2 / t.abs(r), a = 0, u = 1, c = 0;
                                    for(i = 2 * t.round((o + t.round(t.sqrt(40 * o))) / 2); i > 0; i--)c = i * l * u + a, a = u, u = c, t.abs(u) > 1e10 && (u *= 1e-10, a *= 1e-10, s *= 1e-10), i == o && (s = a);
                                    return s *= e(r, 0) / u, r < 0 && o % 2 ? -s : s;
                                }), b = function() {
                                    var e = [
                                        -0.57721566,
                                        .4227842,
                                        .23069756,
                                        .0348859,
                                        .00262698,
                                        1075e-7,
                                        74e-7
                                    ].reverse(), r = [
                                        1.25331414,
                                        -0.07832358,
                                        .02189568,
                                        -0.01062446,
                                        .00587872,
                                        -0.0025154,
                                        53208e-8
                                    ].reverse(), i = [
                                        1,
                                        .15443144,
                                        -0.67278579,
                                        -0.18156897,
                                        -0.01919402,
                                        -0.00110404,
                                        -0.00004686
                                    ].reverse(), s = [
                                        1.25331414,
                                        .23498619,
                                        -0.0365562,
                                        .01504268,
                                        -0.00780353,
                                        .00325614,
                                        -0.00068245
                                    ].reverse();
                                    return o(function(o) {
                                        return o <= 2 ? -t.log(o / 2) * w(o, 0) + n(e, o * o / 4) : t.exp(-o) / t.sqrt(o) * n(r, 2 / o);
                                    }, function(e) {
                                        return e <= 2 ? t.log(e / 2) * w(e, 1) + 1 / e * n(i, e * e / 4) : t.exp(-e) / t.sqrt(e) * n(s, 2 / e);
                                    }, 0, 2, 1);
                                }();
                                e.besselj = y, e.bessely = C, e.besseli = w, e.besselk = b;
                            }, "undefined" == typeof DO_NOT_EXPORT_BESSEL ? n(t) : n({});
                        },
                        162: function(e) {
                            var t;
                            e.exports = (t = function(e, t) {
                                var n = Array.prototype.concat, r = Array.prototype.slice, o = Object.prototype.toString;
                                function i(t, n) {
                                    var r = t > n ? t : n;
                                    return e.pow(10, 17 - ~~(e.log(r > 0 ? r : -r) * e.LOG10E));
                                }
                                var s = Array.isArray || function(e) {
                                    return "[object Array]" === o.call(e);
                                };
                                function l(e) {
                                    return "[object Function]" === o.call(e);
                                }
                                function a(e) {
                                    return "number" == typeof e && e - e == 0;
                                }
                                function u() {
                                    return new u._init(arguments);
                                }
                                function c() {
                                    return 0;
                                }
                                function f() {
                                    return 1;
                                }
                                function d(e, t) {
                                    return e === t ? 1 : 0;
                                }
                                u.fn = u.prototype, u._init = function(e) {
                                    if (s(e[0])) {
                                        if (s(e[0][0])) {
                                            l(e[1]) && (e[0] = u.map(e[0], e[1]));
                                            for(var t = 0; t < e[0].length; t++)this[t] = e[0][t];
                                            this.length = e[0].length;
                                        } else this[0] = l(e[1]) ? u.map(e[0], e[1]) : e[0], this.length = 1;
                                    } else if (a(e[0])) this[0] = u.seq.apply(null, e), this.length = 1;
                                    else {
                                        if (e[0] instanceof u) return u(e[0].toArray());
                                        this[0] = [], this.length = 1;
                                    }
                                    return this;
                                }, u._init.prototype = u.prototype, u._init.constructor = u, u.utils = {
                                    calcRdx: i,
                                    isArray: s,
                                    isFunction: l,
                                    isNumber: a,
                                    toVector: function(e) {
                                        return n.apply([], e);
                                    }
                                }, u._random_fn = e.random, u.setRandom = function(e) {
                                    if ("function" != typeof e) throw new TypeError("fn is not a function");
                                    u._random_fn = e;
                                }, u.extend = function(e) {
                                    var t, n;
                                    if (1 === arguments.length) {
                                        for(n in e)u[n] = e[n];
                                        return this;
                                    }
                                    for(t = 1; t < arguments.length; t++)for(n in arguments[t])e[n] = arguments[t][n];
                                    return e;
                                }, u.rows = function(e) {
                                    return e.length || 1;
                                }, u.cols = function(e) {
                                    return e[0].length || 1;
                                }, u.dimensions = function(e) {
                                    return {
                                        rows: u.rows(e),
                                        cols: u.cols(e)
                                    };
                                }, u.row = function(e, t) {
                                    return s(t) ? t.map(function(t) {
                                        return u.row(e, t);
                                    }) : e[t];
                                }, u.rowa = function(e, t) {
                                    return u.row(e, t);
                                }, u.col = function(e, t) {
                                    if (s(t)) {
                                        var n = u.arange(e.length).map(function() {
                                            return new Array(t.length);
                                        });
                                        return t.forEach(function(t, r) {
                                            u.arange(e.length).forEach(function(o) {
                                                n[o][r] = e[o][t];
                                            });
                                        }), n;
                                    }
                                    for(var r = new Array(e.length), o = 0; o < e.length; o++)r[o] = [
                                        e[o][t]
                                    ];
                                    return r;
                                }, u.cola = function(e, t) {
                                    return u.col(e, t).map(function(e) {
                                        return e[0];
                                    });
                                }, u.diag = function(e) {
                                    for(var t = u.rows(e), n = new Array(t), r = 0; r < t; r++)n[r] = [
                                        e[r][r]
                                    ];
                                    return n;
                                }, u.antidiag = function(e) {
                                    for(var t = u.rows(e) - 1, n = new Array(t), r = 0; t >= 0; t--, r++)n[r] = [
                                        e[r][t]
                                    ];
                                    return n;
                                }, u.transpose = function(e) {
                                    var t, n, r, o, i, l = [];
                                    for(s(e[0]) || (e = [
                                        e
                                    ]), n = e.length, r = e[0].length, i = 0; i < r; i++){
                                        for(t = new Array(n), o = 0; o < n; o++)t[o] = e[o][i];
                                        l.push(t);
                                    }
                                    return 1 === l.length ? l[0] : l;
                                }, u.map = function(e, t, n) {
                                    var r, o, i, l, a;
                                    for(s(e[0]) || (e = [
                                        e
                                    ]), o = e.length, i = e[0].length, l = n ? e : new Array(o), r = 0; r < o; r++)for(l[r] || (l[r] = new Array(i)), a = 0; a < i; a++)l[r][a] = t(e[r][a], r, a);
                                    return 1 === l.length ? l[0] : l;
                                }, u.cumreduce = function(e, t, n) {
                                    var r, o, i, l, a;
                                    for(s(e[0]) || (e = [
                                        e
                                    ]), o = e.length, i = e[0].length, l = n ? e : new Array(o), r = 0; r < o; r++)for(l[r] || (l[r] = new Array(i)), i > 0 && (l[r][0] = e[r][0]), a = 1; a < i; a++)l[r][a] = t(l[r][a - 1], e[r][a]);
                                    return 1 === l.length ? l[0] : l;
                                }, u.alter = function(e, t) {
                                    return u.map(e, t, !0);
                                }, u.create = function(e, t, n) {
                                    var r, o, i = new Array(e);
                                    for(l(t) && (n = t, t = e), r = 0; r < e; r++)for(i[r] = new Array(t), o = 0; o < t; o++)i[r][o] = n(r, o);
                                    return i;
                                }, u.zeros = function(e, t) {
                                    return a(t) || (t = e), u.create(e, t, c);
                                }, u.ones = function(e, t) {
                                    return a(t) || (t = e), u.create(e, t, f);
                                }, u.rand = function(e, t) {
                                    return a(t) || (t = e), u.create(e, t, u._random_fn);
                                }, u.identity = function(e, t) {
                                    return a(t) || (t = e), u.create(e, t, d);
                                }, u.symmetric = function(e) {
                                    var t, n, r = e.length;
                                    if (e.length !== e[0].length) return !1;
                                    for(t = 0; t < r; t++)for(n = 0; n < r; n++)if (e[n][t] !== e[t][n]) return !1;
                                    return !0;
                                }, u.clear = function(e) {
                                    return u.alter(e, c);
                                }, u.seq = function(e, t, n, r) {
                                    l(r) || (r = !1);
                                    var o, s = [], a = i(e, t), u = (t * a - e * a) / ((n - 1) * a), c = e;
                                    for(o = 0; c <= t && o < n; c = (e * a + u * a * ++o) / a)s.push(r ? r(c, o) : c);
                                    return s;
                                }, u.arange = function(e, n, r) {
                                    var o, i = [];
                                    if (r = r || 1, n === t && (n = e, e = 0), e === n || 0 === r) return [];
                                    if (e < n && r < 0) return [];
                                    if (e > n && r > 0) return [];
                                    if (r > 0) for(o = e; o < n; o += r)i.push(o);
                                    else for(o = e; o > n; o += r)i.push(o);
                                    return i;
                                }, u.slice = function() {
                                    function e(e, n, r, o) {
                                        var i, s = [], l = e.length;
                                        if (n === t && r === t && o === t) return u.copy(e);
                                        if (o = o || 1, (n = (n = n || 0) >= 0 ? n : l + n) === (r = (r = r || e.length) >= 0 ? r : l + r) || 0 === o) return [];
                                        if (n < r && o < 0) return [];
                                        if (n > r && o > 0) return [];
                                        if (o > 0) for(i = n; i < r; i += o)s.push(e[i]);
                                        else for(i = n; i > r; i += o)s.push(e[i]);
                                        return s;
                                    }
                                    return function(t, n) {
                                        var r, o;
                                        return a((n = n || {}).row) ? a(n.col) ? t[n.row][n.col] : e(u.rowa(t, n.row), (r = n.col || {}).start, r.end, r.step) : a(n.col) ? e(u.cola(t, n.col), (o = n.row || {}).start, o.end, o.step) : (o = n.row || {}, r = n.col || {}, e(t, o.start, o.end, o.step).map(function(t) {
                                            return e(t, r.start, r.end, r.step);
                                        }));
                                    };
                                }(), u.sliceAssign = function(n, r, o) {
                                    var i, s;
                                    if (a(r.row)) {
                                        if (a(r.col)) return n[r.row][r.col] = o;
                                        r.col = r.col || {}, r.col.start = r.col.start || 0, r.col.end = r.col.end || n[0].length, r.col.step = r.col.step || 1, i = u.arange(r.col.start, e.min(n.length, r.col.end), r.col.step);
                                        var l = r.row;
                                        return i.forEach(function(e, t) {
                                            n[l][e] = o[t];
                                        }), n;
                                    }
                                    if (a(r.col)) {
                                        r.row = r.row || {}, r.row.start = r.row.start || 0, r.row.end = r.row.end || n.length, r.row.step = r.row.step || 1, s = u.arange(r.row.start, e.min(n[0].length, r.row.end), r.row.step);
                                        var c = r.col;
                                        return s.forEach(function(e, t) {
                                            n[e][c] = o[t];
                                        }), n;
                                    }
                                    return o[0].length === t && (o = [
                                        o
                                    ]), r.row.start = r.row.start || 0, r.row.end = r.row.end || n.length, r.row.step = r.row.step || 1, r.col.start = r.col.start || 0, r.col.end = r.col.end || n[0].length, r.col.step = r.col.step || 1, s = u.arange(r.row.start, e.min(n.length, r.row.end), r.row.step), i = u.arange(r.col.start, e.min(n[0].length, r.col.end), r.col.step), s.forEach(function(e, t) {
                                        i.forEach(function(r, i) {
                                            n[e][r] = o[t][i];
                                        });
                                    }), n;
                                }, u.diagonal = function(e) {
                                    var t = u.zeros(e.length, e.length);
                                    return e.forEach(function(e, n) {
                                        t[n][n] = e;
                                    }), t;
                                }, u.copy = function(e) {
                                    return e.map(function(e) {
                                        return a(e) ? e : e.map(function(e) {
                                            return e;
                                        });
                                    });
                                };
                                var p = u.prototype;
                                return p.length = 0, p.push = Array.prototype.push, p.sort = Array.prototype.sort, p.splice = Array.prototype.splice, p.slice = Array.prototype.slice, p.toArray = function() {
                                    return this.length > 1 ? r.call(this) : r.call(this)[0];
                                }, p.map = function(e, t) {
                                    return u(u.map(this, e, t));
                                }, p.cumreduce = function(e, t) {
                                    return u(u.cumreduce(this, e, t));
                                }, p.alter = function(e) {
                                    return u.alter(this, e), this;
                                }, function(e) {
                                    for(var t = 0; t < e.length; t++)!function(e) {
                                        p[e] = function(t) {
                                            var n, r = this;
                                            return t ? (setTimeout(function() {
                                                t.call(r, p[e].call(r));
                                            }), this) : (n = u[e](this), s(n) ? u(n) : n);
                                        };
                                    }(e[t]);
                                }("transpose clear symmetric rows cols dimensions diag antidiag".split(" ")), function(e) {
                                    for(var t = 0; t < e.length; t++)!function(e) {
                                        p[e] = function(t, n) {
                                            var r = this;
                                            return n ? (setTimeout(function() {
                                                n.call(r, p[e].call(r, t));
                                            }), this) : u(u[e](this, t));
                                        };
                                    }(e[t]);
                                }("row col".split(" ")), function(e) {
                                    for(var t = 0; t < e.length; t++)!function(e) {
                                        p[e] = function() {
                                            return u(u[e].apply(null, arguments));
                                        };
                                    }(e[t]);
                                }("create zeros ones rand identity".split(" ")), u;
                            }(Math), function(e, t) {
                                var n = e.utils.isFunction;
                                function r(e, t) {
                                    return e - t;
                                }
                                function o(e, n, r) {
                                    return t.max(n, t.min(e, r));
                                }
                                e.sum = function(e) {
                                    for(var t = 0, n = e.length; --n >= 0;)t += e[n];
                                    return t;
                                }, e.sumsqrd = function(e) {
                                    for(var t = 0, n = e.length; --n >= 0;)t += e[n] * e[n];
                                    return t;
                                }, e.sumsqerr = function(t) {
                                    for(var n, r = e.mean(t), o = 0, i = t.length; --i >= 0;)o += (n = t[i] - r) * n;
                                    return o;
                                }, e.sumrow = function(e) {
                                    for(var t = 0, n = e.length; --n >= 0;)t += e[n];
                                    return t;
                                }, e.product = function(e) {
                                    for(var t = 1, n = e.length; --n >= 0;)t *= e[n];
                                    return t;
                                }, e.min = function(e) {
                                    for(var t = e[0], n = 0; ++n < e.length;)e[n] < t && (t = e[n]);
                                    return t;
                                }, e.max = function(e) {
                                    for(var t = e[0], n = 0; ++n < e.length;)e[n] > t && (t = e[n]);
                                    return t;
                                }, e.unique = function(e) {
                                    for(var t = {}, n = [], r = 0; r < e.length; r++)t[e[r]] || (t[e[r]] = !0, n.push(e[r]));
                                    return n;
                                }, e.mean = function(t) {
                                    return e.sum(t) / t.length;
                                }, e.meansqerr = function(t) {
                                    return e.sumsqerr(t) / t.length;
                                }, e.geomean = function(n) {
                                    var r = n.map(t.log), o = e.mean(r);
                                    return t.exp(o);
                                }, e.median = function(e) {
                                    var t = e.length, n = e.slice().sort(r);
                                    return 1 & t ? n[t / 2 | 0] : (n[t / 2 - 1] + n[t / 2]) / 2;
                                }, e.cumsum = function(t) {
                                    return e.cumreduce(t, function(e, t) {
                                        return e + t;
                                    });
                                }, e.cumprod = function(t) {
                                    return e.cumreduce(t, function(e, t) {
                                        return e * t;
                                    });
                                }, e.diff = function(e) {
                                    var t, n = [], r = e.length;
                                    for(t = 1; t < r; t++)n.push(e[t] - e[t - 1]);
                                    return n;
                                }, e.rank = function(e) {
                                    var t, n = [], o = {};
                                    for(t = 0; t < e.length; t++)o[a = e[t]] ? o[a]++ : (o[a] = 1, n.push(a));
                                    var i = n.sort(r), s = {}, l = 1;
                                    for(t = 0; t < i.length; t++){
                                        var a, u = o[a = i[t]], c = (l + (l + u - 1)) / 2;
                                        s[a] = c, l += u;
                                    }
                                    return e.map(function(e) {
                                        return s[e];
                                    });
                                }, e.mode = function(e) {
                                    var t, n = e.length, o = e.slice().sort(r), i = 1, s = 0, l = 0, a = [];
                                    for(t = 0; t < n; t++)o[t] === o[t + 1] ? i++ : (i > s ? (a = [
                                        o[t]
                                    ], s = i, l = 0) : i === s && (a.push(o[t]), l++), i = 1);
                                    return 0 === l ? a[0] : a;
                                }, e.range = function(t) {
                                    return e.max(t) - e.min(t);
                                }, e.variance = function(t, n) {
                                    return e.sumsqerr(t) / (t.length - (n ? 1 : 0));
                                }, e.pooledvariance = function(t) {
                                    return t.reduce(function(t, n) {
                                        return t + e.sumsqerr(n);
                                    }, 0) / (t.reduce(function(e, t) {
                                        return e + t.length;
                                    }, 0) - t.length);
                                }, e.deviation = function(t) {
                                    for(var n = e.mean(t), r = t.length, o = new Array(r), i = 0; i < r; i++)o[i] = t[i] - n;
                                    return o;
                                }, e.stdev = function(n, r) {
                                    return t.sqrt(e.variance(n, r));
                                }, e.pooledstdev = function(n) {
                                    return t.sqrt(e.pooledvariance(n));
                                }, e.meandev = function(n) {
                                    for(var r = e.mean(n), o = [], i = n.length - 1; i >= 0; i--)o.push(t.abs(n[i] - r));
                                    return e.mean(o);
                                }, e.meddev = function(n) {
                                    for(var r = e.median(n), o = [], i = n.length - 1; i >= 0; i--)o.push(t.abs(n[i] - r));
                                    return e.median(o);
                                }, e.coeffvar = function(t) {
                                    return e.stdev(t) / e.mean(t);
                                }, e.quartiles = function(e) {
                                    var n = e.length, o = e.slice().sort(r);
                                    return [
                                        o[t.round(n / 4) - 1],
                                        o[t.round(n / 2) - 1],
                                        o[t.round(3 * n / 4) - 1]
                                    ];
                                }, e.quantiles = function(e, n, i, s) {
                                    var l, a, u, c, f, d = e.slice().sort(r), p = [
                                        n.length
                                    ], h = e.length;
                                    for(void 0 === i && (i = 3 / 8), void 0 === s && (s = 3 / 8), l = 0; l < n.length; l++)u = h * (a = n[l]) + (i + a * (1 - i - s)), c = t.floor(o(u, 1, h - 1)), f = o(u - c, 0, 1), p[l] = (1 - f) * d[c - 1] + f * d[c];
                                    return p;
                                }, e.percentile = function(e, t, n) {
                                    var o = e.slice().sort(r), i = t * (o.length + (n ? 1 : -1)) + (n ? 0 : 1), s = parseInt(i), l = i - s;
                                    return s + 1 < o.length ? o[s - 1] + l * (o[s] - o[s - 1]) : o[s - 1];
                                }, e.percentileOfScore = function(e, t, n) {
                                    var r, o, i = 0, s = e.length, l = !1;
                                    for("strict" === n && (l = !0), o = 0; o < s; o++)r = e[o], (l && r < t || !l && r <= t) && i++;
                                    return i / s;
                                }, e.histogram = function(n, r) {
                                    r = r || 4;
                                    var o, i = e.min(n), s = (e.max(n) - i) / r, l = n.length, a = [];
                                    for(o = 0; o < r; o++)a[o] = 0;
                                    for(o = 0; o < l; o++)a[t.min(t.floor((n[o] - i) / s), r - 1)] += 1;
                                    return a;
                                }, e.covariance = function(t, n) {
                                    var r, o = e.mean(t), i = e.mean(n), s = t.length, l = new Array(s);
                                    for(r = 0; r < s; r++)l[r] = (t[r] - o) * (n[r] - i);
                                    return e.sum(l) / (s - 1);
                                }, e.corrcoeff = function(t, n) {
                                    return e.covariance(t, n) / e.stdev(t, 1) / e.stdev(n, 1);
                                }, e.spearmancoeff = function(t, n) {
                                    return t = e.rank(t), n = e.rank(n), e.corrcoeff(t, n);
                                }, e.stanMoment = function(n, r) {
                                    for(var o = e.mean(n), i = e.stdev(n), s = n.length, l = 0, a = 0; a < s; a++)l += t.pow((n[a] - o) / i, r);
                                    return l / n.length;
                                }, e.skewness = function(t) {
                                    return e.stanMoment(t, 3);
                                }, e.kurtosis = function(t) {
                                    return e.stanMoment(t, 4) - 3;
                                };
                                var i = e.prototype;
                                !function(t) {
                                    for(var r = 0; r < t.length; r++)!function(t) {
                                        i[t] = function(r, o) {
                                            var s = [], l = 0, a = this;
                                            if (n(r) && (o = r, r = !1), o) return setTimeout(function() {
                                                o.call(a, i[t].call(a, r));
                                            }), this;
                                            if (this.length > 1) {
                                                for(a = !0 === r ? this : this.transpose(); l < a.length; l++)s[l] = e[t](a[l]);
                                                return s;
                                            }
                                            return e[t](this[0], r);
                                        };
                                    }(t[r]);
                                }("cumsum cumprod".split(" ")), function(t) {
                                    for(var r = 0; r < t.length; r++)!function(t) {
                                        i[t] = function(r, o) {
                                            var s = [], l = 0, a = this;
                                            if (n(r) && (o = r, r = !1), o) return setTimeout(function() {
                                                o.call(a, i[t].call(a, r));
                                            }), this;
                                            if (this.length > 1) {
                                                for("sumrow" !== t && (a = !0 === r ? this : this.transpose()); l < a.length; l++)s[l] = e[t](a[l]);
                                                return !0 === r ? e[t](e.utils.toVector(s)) : s;
                                            }
                                            return e[t](this[0], r);
                                        };
                                    }(t[r]);
                                }("sum sumsqrd sumsqerr sumrow product min max unique mean meansqerr geomean median diff rank mode range variance deviation stdev meandev meddev coeffvar quartiles histogram skewness kurtosis".split(" ")), function(t) {
                                    for(var r = 0; r < t.length; r++)!function(t) {
                                        i[t] = function() {
                                            var r, o = [], s = 0, l = this, a = Array.prototype.slice.call(arguments);
                                            if (n(a[a.length - 1])) {
                                                r = a[a.length - 1];
                                                var u = a.slice(0, a.length - 1);
                                                return setTimeout(function() {
                                                    r.call(l, i[t].apply(l, u));
                                                }), this;
                                            }
                                            r = void 0;
                                            var c = function(n) {
                                                return e[t].apply(l, [
                                                    n
                                                ].concat(a));
                                            };
                                            if (this.length > 1) {
                                                for(l = l.transpose(); s < l.length; s++)o[s] = c(l[s]);
                                                return o;
                                            }
                                            return c(this[0]);
                                        };
                                    }(t[r]);
                                }("quantiles percentileOfScore".split(" "));
                            }(t, Math), function(e, t) {
                                e.gammaln = function(e) {
                                    var n, r, o, i = 0, s = [
                                        76.18009172947146,
                                        -86.50532032941678,
                                        24.01409824083091,
                                        -1.231739572450155,
                                        .001208650973866179,
                                        -0.000005395239384953
                                    ], l = 1.000000000190015;
                                    for(o = (r = n = e) + 5.5, o -= (n + .5) * t.log(o); i < 6; i++)l += s[i] / ++r;
                                    return t.log(2.5066282746310007 * l / n) - o;
                                }, e.loggam = function(e) {
                                    var n, r, o, i, s, l, a, u = [
                                        .08333333333333333,
                                        -0.002777777777777778,
                                        .0007936507936507937,
                                        -0.0005952380952380952,
                                        .0008417508417508418,
                                        -0.001917526917526918,
                                        .00641025641025641,
                                        -0.02955065359477124,
                                        .1796443723688307,
                                        -1.3924322169059
                                    ];
                                    if (n = e, a = 0, 1 == e || 2 == e) return 0;
                                    for(e <= 7 && (n = e + (a = t.floor(7 - e))), r = 1 / (n * n), o = 2 * t.PI, s = u[9], l = 8; l >= 0; l--)s *= r, s += u[l];
                                    if (i = s / n + .5 * t.log(o) + (n - .5) * t.log(n) - n, e <= 7) for(l = 1; l <= a; l++)i -= t.log(n - 1), n -= 1;
                                    return i;
                                }, e.gammafn = function(e) {
                                    var n, r, o, i, s = [
                                        -1.716185138865495,
                                        24.76565080557592,
                                        -379.80425647094563,
                                        629.3311553128184,
                                        866.9662027904133,
                                        -31451.272968848367,
                                        -36144.413418691176,
                                        66456.14382024054
                                    ], l = [
                                        -30.8402300119739,
                                        315.35062697960416,
                                        -1015.1563674902192,
                                        -3107.771671572311,
                                        22538.11842098015,
                                        4755.846277527881,
                                        -134659.9598649693,
                                        -115132.2596755535
                                    ], a = !1, u = 0, c = 0, f = 0, d = e;
                                    if (e > 171.6243769536076) return 1 / 0;
                                    if (d <= 0) {
                                        if (!(i = d % 1 + 36e-17)) return 1 / 0;
                                        a = (1 & d ? -1 : 1) * t.PI / t.sin(t.PI * i), d = 1 - d;
                                    }
                                    for(o = d, r = d < 1 ? d++ : (d -= u = (0 | d) - 1) - 1, n = 0; n < 8; ++n)f = (f + s[n]) * r, c = c * r + l[n];
                                    if (i = f / c + 1, o < d) i /= o;
                                    else if (o > d) for(n = 0; n < u; ++n)i *= d, d++;
                                    return a && (i = a / i), i;
                                }, e.gammap = function(t, n) {
                                    return e.lowRegGamma(t, n) * e.gammafn(t);
                                }, e.lowRegGamma = function(n, r) {
                                    var o, i = e.gammaln(n), s = n, l = 1 / n, a = l, u = r + 1 - n, c = 1 / 1e-30, f = 1 / u, d = f, p = 1, h = -~(8.5 * t.log(n >= 1 ? n : 1 / n) + .4 * n + 17);
                                    if (r < 0 || n <= 0) return NaN;
                                    if (r < n + 1) {
                                        for(; p <= h; p++)l += a *= r / ++s;
                                        return l * t.exp(-r + n * t.log(r) - i);
                                    }
                                    for(; p <= h; p++)d *= (f = 1 / (f = (o = -p * (p - n)) * f + (u += 2))) * (c = u + o / c);
                                    return 1 - d * t.exp(-r + n * t.log(r) - i);
                                }, e.factorialln = function(t) {
                                    return t < 0 ? NaN : e.gammaln(t + 1);
                                }, e.factorial = function(t) {
                                    return t < 0 ? NaN : e.gammafn(t + 1);
                                }, e.combination = function(n, r) {
                                    return n > 170 || r > 170 ? t.exp(e.combinationln(n, r)) : e.factorial(n) / e.factorial(r) / e.factorial(n - r);
                                }, e.combinationln = function(t, n) {
                                    return e.factorialln(t) - e.factorialln(n) - e.factorialln(t - n);
                                }, e.permutation = function(t, n) {
                                    return e.factorial(t) / e.factorial(t - n);
                                }, e.betafn = function(n, r) {
                                    if (!(n <= 0 || r <= 0)) return n + r > 170 ? t.exp(e.betaln(n, r)) : e.gammafn(n) * e.gammafn(r) / e.gammafn(n + r);
                                }, e.betaln = function(t, n) {
                                    return e.gammaln(t) + e.gammaln(n) - e.gammaln(t + n);
                                }, e.betacf = function(e, n, r) {
                                    var o, i, s, l, a = 1e-30, u = 1, c = n + r, f = n + 1, d = n - 1, p = 1, h = 1 - c * e / f;
                                    for(t.abs(h) < a && (h = a), l = h = 1 / h; u <= 100 && (h = 1 + (i = u * (r - u) * e / ((d + (o = 2 * u)) * (n + o))) * h, t.abs(h) < a && (h = a), p = 1 + i / p, t.abs(p) < a && (p = a), l *= (h = 1 / h) * p, h = 1 + (i = -(n + u) * (c + u) * e / ((n + o) * (f + o))) * h, t.abs(h) < a && (h = a), p = 1 + i / p, t.abs(p) < a && (p = a), l *= s = (h = 1 / h) * p, !(t.abs(s - 1) < 3e-7)); u++);
                                    return l;
                                }, e.gammapinv = function(n, r) {
                                    var o, i, s, l, a, u, c = 0, f = r - 1, d = e.gammaln(r);
                                    if (n >= 1) return t.max(100, r + 100 * t.sqrt(r));
                                    if (n <= 0) return 0;
                                    for(r > 1 ? (a = t.log(f), u = t.exp(f * (a - 1) - d), l = n < .5 ? n : 1 - n, o = (2.30753 + .27061 * (i = t.sqrt(-2 * t.log(l)))) / (1 + i * (.99229 + .04481 * i)) - i, n < .5 && (o = -o), o = t.max(.001, r * t.pow(1 - 1 / (9 * r) - o / (3 * t.sqrt(r)), 3))) : o = n < (i = 1 - r * (.253 + .12 * r)) ? t.pow(n / i, 1 / r) : 1 - t.log(1 - (n - i) / (1 - i)); c < 12; c++){
                                        if (o <= 0) return 0;
                                        if ((o -= i = (s = (e.lowRegGamma(r, o) - n) / (i = r > 1 ? u * t.exp(-(o - f) + f * (t.log(o) - a)) : t.exp(-o + f * t.log(o) - d))) / (1 - .5 * t.min(1, s * ((r - 1) / o - 1)))) <= 0 && (o = .5 * (o + i)), t.abs(i) < 1e-8 * o) break;
                                    }
                                    return o;
                                }, e.erf = function(e) {
                                    var n, r, o, i, s = [
                                        -1.3026537197817094,
                                        .6419697923564902,
                                        .019476473204185836,
                                        -0.00956151478680863,
                                        -0.000946595344482036,
                                        .000366839497852761,
                                        42523324806907e-18,
                                        -0.000020278578112534,
                                        -0.000001624290004647,
                                        130365583558e-17,
                                        1.5626441722e-8,
                                        -0.000000085238095915,
                                        6.529054439e-9,
                                        5.059343495e-9,
                                        -0.000000000991364156,
                                        -0.000000000227365122,
                                        96467911e-18,
                                        2394038e-18,
                                        -0.000000000006886027,
                                        894487e-18,
                                        313092e-18,
                                        -0.000000000000112708,
                                        381e-18,
                                        7106e-18,
                                        -0.000000000000001523,
                                        -0.000000000000000094,
                                        121e-18,
                                        -0.000000000000000028
                                    ], l = s.length - 1, a = !1, u = 0, c = 0;
                                    for(e < 0 && (e = -e, a = !0), r = 4 * (n = 2 / (2 + e)) - 2; l > 0; l--)o = u, u = r * u - c + s[l], c = o;
                                    return i = n * t.exp(-e * e + .5 * (s[0] + r * u) - c), a ? i - 1 : 1 - i;
                                }, e.erfc = function(t) {
                                    return 1 - e.erf(t);
                                }, e.erfcinv = function(n) {
                                    var r, o, i, s, l = 0;
                                    if (n >= 2) return -100;
                                    if (n <= 0) return 100;
                                    for(s = n < 1 ? n : 2 - n, r = -0.70711 * ((2.30753 + .27061 * (i = t.sqrt(-2 * t.log(s / 2)))) / (1 + i * (.99229 + .04481 * i)) - i); l < 2; l++)r += (o = e.erfc(r) - s) / (1.1283791670955126 * t.exp(-r * r) - r * o);
                                    return n < 1 ? r : -r;
                                }, e.ibetainv = function(n, r, o) {
                                    var i, s, l, a, u, c, f, d, p, h, g = r - 1, m = o - 1, v = 0;
                                    if (n <= 0) return 0;
                                    if (n >= 1) return 1;
                                    for(r >= 1 && o >= 1 ? (l = n < .5 ? n : 1 - n, c = (2.30753 + .27061 * (a = t.sqrt(-2 * t.log(l)))) / (1 + a * (.99229 + .04481 * a)) - a, n < .5 && (c = -c), f = (c * c - 3) / 6, d = 2 / (1 / (2 * r - 1) + 1 / (2 * o - 1)), p = c * t.sqrt(f + d) / d - (1 / (2 * o - 1) - 1 / (2 * r - 1)) * (f + 5 / 6 - 2 / (3 * d)), c = r / (r + o * t.exp(2 * p))) : (i = t.log(r / (r + o)), s = t.log(o / (r + o)), c = n < (a = t.exp(r * i) / r) / (p = a + (u = t.exp(o * s) / o)) ? t.pow(r * p * n, 1 / r) : 1 - t.pow(o * p * (1 - n), 1 / o)), h = -e.gammaln(r) - e.gammaln(o) + e.gammaln(r + o); v < 10; v++){
                                        if (0 === c || 1 === c) return c;
                                        if ((c -= a = (u = (e.ibeta(c, r, o) - n) / (a = t.exp(g * t.log(c) + m * t.log(1 - c) + h))) / (1 - .5 * t.min(1, u * (g / c - m / (1 - c))))) <= 0 && (c = .5 * (c + a)), c >= 1 && (c = .5 * (c + a + 1)), t.abs(a) < 1e-8 * c && v > 0) break;
                                    }
                                    return c;
                                }, e.ibeta = function(n, r, o) {
                                    var i = 0 === n || 1 === n ? 0 : t.exp(e.gammaln(r + o) - e.gammaln(r) - e.gammaln(o) + r * t.log(n) + o * t.log(1 - n));
                                    return !(n < 0 || n > 1) && (n < (r + 1) / (r + o + 2) ? i * e.betacf(n, r, o) / r : 1 - i * e.betacf(1 - n, o, r) / o);
                                }, e.randn = function(n, r) {
                                    var o, i, s, l, a;
                                    if (r || (r = n), n) return e.create(n, r, function() {
                                        return e.randn();
                                    });
                                    do o = e._random_fn(), i = 1.7156 * (e._random_fn() - .5), a = (s = o - .449871) * s + (l = t.abs(i) + .386595) * (.196 * l - .25472 * s);
                                    while (a > .27597 && (a > .27846 || i * i > -4 * t.log(o) * o * o));
                                    return i / o;
                                }, e.randg = function(n, r, o) {
                                    var i, s, l, a, u, c, f = n;
                                    if (o || (o = r), n || (n = 1), r) return (c = e.zeros(r, o)).alter(function() {
                                        return e.randg(n);
                                    }), c;
                                    n < 1 && (n += 1), i = n - 1 / 3, s = 1 / t.sqrt(9 * i);
                                    do {
                                        do a = 1 + s * (u = e.randn());
                                        while (a <= 0);
                                        a *= a * a, l = e._random_fn();
                                    }while (l > 1 - .331 * t.pow(u, 4) && t.log(l) > .5 * u * u + i * (1 - a + t.log(a)));
                                    if (n == f) return i * a;
                                    do l = e._random_fn();
                                    while (0 === l);
                                    return t.pow(l, 1 / f) * i * a;
                                }, function(t) {
                                    for(var n = 0; n < t.length; n++)!function(t) {
                                        e.fn[t] = function() {
                                            return e(e.map(this, function(n) {
                                                return e[t](n);
                                            }));
                                        };
                                    }(t[n]);
                                }("gammaln gammafn factorial factorialln".split(" ")), function(t) {
                                    for(var n = 0; n < t.length; n++)!function(t) {
                                        e.fn[t] = function() {
                                            return e(e[t].apply(null, arguments));
                                        };
                                    }(t[n]);
                                }("randn".split(" "));
                            }(t, Math), function(e, t) {
                                function n(e, n, r, o) {
                                    for(var i, s = 0, l = 1, a = 1, u = 1, c = 0, f = 0; t.abs((a - f) / a) > o;)f = a, l = u + (i = -(n + c) * (n + r + c) * e / (n + 2 * c) / (n + 2 * c + 1)) * l, a = (s = a + i * s) + (i = (c += 1) * (r - c) * e / (n + 2 * c - 1) / (n + 2 * c)) * a, s /= u = l + i * u, l /= u, a /= u, u = 1;
                                    return a / n;
                                }
                                function r(n, r, o) {
                                    var i = [
                                        .9815606342467192,
                                        .9041172563704749,
                                        .7699026741943047,
                                        .5873179542866175,
                                        .3678314989981802,
                                        .1252334085114689
                                    ], s = [
                                        .04717533638651183,
                                        .10693932599531843,
                                        .16007832854334622,
                                        .20316742672306592,
                                        .2334925365383548,
                                        .24914704581340277
                                    ], l = .5 * n;
                                    if (l >= 8) return 1;
                                    var a, u = 2 * e.normal.cdf(l, 0, 1, 1, 0) - 1;
                                    u = u >= t.exp(-50 / o) ? t.pow(u, o) : 0;
                                    for(var c = l, f = (8 - l) / (a = n > 3 ? 2 : 3), d = c + f, p = 0, h = o - 1, g = 1; g <= a; g++){
                                        for(var m = 0, v = .5 * (d + c), y = .5 * (d - c), C = 1; C <= 12; C++){
                                            var w, b = v + y * (6 < C ? i[(w = 12 - C + 1) - 1] : -i[(w = C) - 1]), A = b * b;
                                            if (A > 60) break;
                                            var E = 2 * e.normal.cdf(b, 0, 1, 1, 0) * .5 - 2 * e.normal.cdf(b, n, 1, 1, 0) * .5;
                                            E >= t.exp(-30 / h) && (m += E = s[w - 1] * t.exp(-0.5 * A) * t.pow(E, h));
                                        }
                                        p += m *= 2 * y * o / t.sqrt(2 * t.PI), c = d, d += f;
                                    }
                                    return (u += p) <= t.exp(-30 / r) ? 0 : (u = t.pow(u, r)) >= 1 ? 1 : u;
                                }
                                !function(t) {
                                    for(var n = 0; n < t.length; n++)!function(t) {
                                        e[t] = function e(t, n, r) {
                                            return this instanceof e ? (this._a = t, this._b = n, this._c = r, this) : new e(t, n, r);
                                        }, e.fn[t] = function(n, r, o) {
                                            var i = e[t](n, r, o);
                                            return i.data = this, i;
                                        }, e[t].prototype.sample = function(n) {
                                            var r = this._a, o = this._b, i = this._c;
                                            return n ? e.alter(n, function() {
                                                return e[t].sample(r, o, i);
                                            }) : e[t].sample(r, o, i);
                                        }, function(n) {
                                            for(var r = 0; r < n.length; r++)!function(n) {
                                                e[t].prototype[n] = function(r) {
                                                    var o = this._a, i = this._b, s = this._c;
                                                    return r || 0 === r || (r = this.data), "number" != typeof r ? e.fn.map.call(r, function(r) {
                                                        return e[t][n](r, o, i, s);
                                                    }) : e[t][n](r, o, i, s);
                                                };
                                            }(n[r]);
                                        }("pdf cdf inv".split(" ")), function(n) {
                                            for(var r = 0; r < n.length; r++)!function(n) {
                                                e[t].prototype[n] = function() {
                                                    return e[t][n](this._a, this._b, this._c);
                                                };
                                            }(n[r]);
                                        }("mean median mode variance".split(" "));
                                    }(t[n]);
                                }("beta centralF cauchy chisquare exponential gamma invgamma kumaraswamy laplace lognormal noncentralt normal pareto studentt weibull uniform binomial negbin hypgeom poisson triangular tukey arcsine".split(" ")), e.extend(e.beta, {
                                    pdf: function(n, r, o) {
                                        return n > 1 || n < 0 ? 0 : 1 == r && 1 == o ? 1 : r < 512 && o < 512 ? t.pow(n, r - 1) * t.pow(1 - n, o - 1) / e.betafn(r, o) : t.exp((r - 1) * t.log(n) + (o - 1) * t.log(1 - n) - e.betaln(r, o));
                                    },
                                    cdf: function(t, n, r) {
                                        return t > 1 || t < 0 ? 1 * (t > 1) : e.ibeta(t, n, r);
                                    },
                                    inv: function(t, n, r) {
                                        return e.ibetainv(t, n, r);
                                    },
                                    mean: function(e, t) {
                                        return e / (e + t);
                                    },
                                    median: function(t, n) {
                                        return e.ibetainv(.5, t, n);
                                    },
                                    mode: function(e, t) {
                                        return (e - 1) / (e + t - 2);
                                    },
                                    sample: function(t, n) {
                                        var r = e.randg(t);
                                        return r / (r + e.randg(n));
                                    },
                                    variance: function(e, n) {
                                        return e * n / (t.pow(e + n, 2) * (e + n + 1));
                                    }
                                }), e.extend(e.centralF, {
                                    pdf: function(n, r, o) {
                                        var i;
                                        return n < 0 ? 0 : r <= 2 ? 0 === n && r < 2 ? 1 / 0 : 0 === n && 2 === r ? 1 : 1 / e.betafn(r / 2, o / 2) * t.pow(r / o, r / 2) * t.pow(n, r / 2 - 1) * t.pow(1 + r / o * n, -(r + o) / 2) : (i = r * n / (o + n * r), r * (o / (o + n * r)) / 2 * e.binomial.pdf((r - 2) / 2, (r + o - 2) / 2, i));
                                    },
                                    cdf: function(t, n, r) {
                                        return t < 0 ? 0 : e.ibeta(n * t / (n * t + r), n / 2, r / 2);
                                    },
                                    inv: function(t, n, r) {
                                        return r / (n * (1 / e.ibetainv(t, n / 2, r / 2) - 1));
                                    },
                                    mean: function(e, t) {
                                        return t > 2 ? t / (t - 2) : void 0;
                                    },
                                    mode: function(e, t) {
                                        return e > 2 ? t * (e - 2) / (e * (t + 2)) : void 0;
                                    },
                                    sample: function(t, n) {
                                        return 2 * e.randg(t / 2) / t / (2 * e.randg(n / 2) / n);
                                    },
                                    variance: function(e, t) {
                                        if (!(t <= 4)) return 2 * t * t * (e + t - 2) / (e * (t - 2) * (t - 2) * (t - 4));
                                    }
                                }), e.extend(e.cauchy, {
                                    pdf: function(e, n, r) {
                                        return r < 0 ? 0 : r / (t.pow(e - n, 2) + t.pow(r, 2)) / t.PI;
                                    },
                                    cdf: function(e, n, r) {
                                        return t.atan((e - n) / r) / t.PI + .5;
                                    },
                                    inv: function(e, n, r) {
                                        return n + r * t.tan(t.PI * (e - .5));
                                    },
                                    median: function(e) {
                                        return e;
                                    },
                                    mode: function(e) {
                                        return e;
                                    },
                                    sample: function(n, r) {
                                        return e.randn() * t.sqrt(1 / (2 * e.randg(.5))) * r + n;
                                    }
                                }), e.extend(e.chisquare, {
                                    pdf: function(n, r) {
                                        return n < 0 ? 0 : 0 === n && 2 === r ? .5 : t.exp((r / 2 - 1) * t.log(n) - n / 2 - r / 2 * t.log(2) - e.gammaln(r / 2));
                                    },
                                    cdf: function(t, n) {
                                        return t < 0 ? 0 : e.lowRegGamma(n / 2, t / 2);
                                    },
                                    inv: function(t, n) {
                                        return 2 * e.gammapinv(t, .5 * n);
                                    },
                                    mean: function(e) {
                                        return e;
                                    },
                                    median: function(e) {
                                        return e * t.pow(1 - 2 / (9 * e), 3);
                                    },
                                    mode: function(e) {
                                        return e - 2 > 0 ? e - 2 : 0;
                                    },
                                    sample: function(t) {
                                        return 2 * e.randg(t / 2);
                                    },
                                    variance: function(e) {
                                        return 2 * e;
                                    }
                                }), e.extend(e.exponential, {
                                    pdf: function(e, n) {
                                        return e < 0 ? 0 : n * t.exp(-n * e);
                                    },
                                    cdf: function(e, n) {
                                        return e < 0 ? 0 : 1 - t.exp(-n * e);
                                    },
                                    inv: function(e, n) {
                                        return -t.log(1 - e) / n;
                                    },
                                    mean: function(e) {
                                        return 1 / e;
                                    },
                                    median: function(e) {
                                        return 1 / e * t.log(2);
                                    },
                                    mode: function() {
                                        return 0;
                                    },
                                    sample: function(n) {
                                        return -1 / n * t.log(e._random_fn());
                                    },
                                    variance: function(e) {
                                        return t.pow(e, -2);
                                    }
                                }), e.extend(e.gamma, {
                                    pdf: function(n, r, o) {
                                        return n < 0 ? 0 : 0 === n && 1 === r ? 1 / o : t.exp((r - 1) * t.log(n) - n / o - e.gammaln(r) - r * t.log(o));
                                    },
                                    cdf: function(t, n, r) {
                                        return t < 0 ? 0 : e.lowRegGamma(n, t / r);
                                    },
                                    inv: function(t, n, r) {
                                        return e.gammapinv(t, n) * r;
                                    },
                                    mean: function(e, t) {
                                        return e * t;
                                    },
                                    mode: function(e, t) {
                                        if (e > 1) return (e - 1) * t;
                                    },
                                    sample: function(t, n) {
                                        return e.randg(t) * n;
                                    },
                                    variance: function(e, t) {
                                        return e * t * t;
                                    }
                                }), e.extend(e.invgamma, {
                                    pdf: function(n, r, o) {
                                        return n <= 0 ? 0 : t.exp(-(r + 1) * t.log(n) - o / n - e.gammaln(r) + r * t.log(o));
                                    },
                                    cdf: function(t, n, r) {
                                        return t <= 0 ? 0 : 1 - e.lowRegGamma(n, r / t);
                                    },
                                    inv: function(t, n, r) {
                                        return r / e.gammapinv(1 - t, n);
                                    },
                                    mean: function(e, t) {
                                        return e > 1 ? t / (e - 1) : void 0;
                                    },
                                    mode: function(e, t) {
                                        return t / (e + 1);
                                    },
                                    sample: function(t, n) {
                                        return n / e.randg(t);
                                    },
                                    variance: function(e, t) {
                                        if (!(e <= 2)) return t * t / ((e - 1) * (e - 1) * (e - 2));
                                    }
                                }), e.extend(e.kumaraswamy, {
                                    pdf: function(e, n, r) {
                                        return 0 === e && 1 === n ? r : 1 === e && 1 === r ? n : t.exp(t.log(n) + t.log(r) + (n - 1) * t.log(e) + (r - 1) * t.log(1 - t.pow(e, n)));
                                    },
                                    cdf: function(e, n, r) {
                                        return e < 0 ? 0 : e > 1 ? 1 : 1 - t.pow(1 - t.pow(e, n), r);
                                    },
                                    inv: function(e, n, r) {
                                        return t.pow(1 - t.pow(1 - e, 1 / r), 1 / n);
                                    },
                                    mean: function(t, n) {
                                        return n * e.gammafn(1 + 1 / t) * e.gammafn(n) / e.gammafn(1 + 1 / t + n);
                                    },
                                    median: function(e, n) {
                                        return t.pow(1 - t.pow(2, -1 / n), 1 / e);
                                    },
                                    mode: function(e, n) {
                                        if (e >= 1 && n >= 1 && 1 !== e && 1 !== n) return t.pow((e - 1) / (e * n - 1), 1 / e);
                                    },
                                    variance: function() {
                                        throw new Error("variance not yet implemented");
                                    }
                                }), e.extend(e.lognormal, {
                                    pdf: function(e, n, r) {
                                        return e <= 0 ? 0 : t.exp(-t.log(e) - .5 * t.log(2 * t.PI) - t.log(r) - t.pow(t.log(e) - n, 2) / (2 * r * r));
                                    },
                                    cdf: function(n, r, o) {
                                        return n < 0 ? 0 : .5 + .5 * e.erf((t.log(n) - r) / t.sqrt(2 * o * o));
                                    },
                                    inv: function(n, r, o) {
                                        return t.exp(-1.4142135623730951 * o * e.erfcinv(2 * n) + r);
                                    },
                                    mean: function(e, n) {
                                        return t.exp(e + n * n / 2);
                                    },
                                    median: function(e) {
                                        return t.exp(e);
                                    },
                                    mode: function(e, n) {
                                        return t.exp(e - n * n);
                                    },
                                    sample: function(n, r) {
                                        return t.exp(e.randn() * r + n);
                                    },
                                    variance: function(e, n) {
                                        return (t.exp(n * n) - 1) * t.exp(2 * e + n * n);
                                    }
                                }), e.extend(e.noncentralt, {
                                    pdf: function(n, r, o) {
                                        return t.abs(o) < 1e-14 ? e.studentt.pdf(n, r) : t.abs(n) < 1e-14 ? t.exp(e.gammaln((r + 1) / 2) - o * o / 2 - .5 * t.log(t.PI * r) - e.gammaln(r / 2)) : r / n * (e.noncentralt.cdf(n * t.sqrt(1 + 2 / r), r + 2, o) - e.noncentralt.cdf(n, r, o));
                                    },
                                    cdf: function(n, r, o) {
                                        var i = 1e-14;
                                        if (t.abs(o) < i) return e.studentt.cdf(n, r);
                                        var s = !1;
                                        n < 0 && (s = !0, o = -o);
                                        for(var l = e.normal.cdf(-o, 0, 1), a = i + 1, u = a, c = n * n / (n * n + r), f = 0, d = t.exp(-o * o / 2), p = t.exp(-o * o / 2 - .5 * t.log(2) - e.gammaln(1.5)) * o; f < 200 || u > i || a > i;)u = a, f > 0 && (d *= o * o / (2 * f), p *= o * o / (2 * (f + .5))), l += .5 * (a = d * e.beta.cdf(c, f + .5, r / 2) + p * e.beta.cdf(c, f + 1, r / 2)), f++;
                                        return s ? 1 - l : l;
                                    }
                                }), e.extend(e.normal, {
                                    pdf: function(e, n, r) {
                                        return t.exp(-0.5 * t.log(2 * t.PI) - t.log(r) - t.pow(e - n, 2) / (2 * r * r));
                                    },
                                    cdf: function(n, r, o) {
                                        return .5 * (1 + e.erf((n - r) / t.sqrt(2 * o * o)));
                                    },
                                    inv: function(t, n, r) {
                                        return -1.4142135623730951 * r * e.erfcinv(2 * t) + n;
                                    },
                                    mean: function(e) {
                                        return e;
                                    },
                                    median: function(e) {
                                        return e;
                                    },
                                    mode: function(e) {
                                        return e;
                                    },
                                    sample: function(t, n) {
                                        return e.randn() * n + t;
                                    },
                                    variance: function(e, t) {
                                        return t * t;
                                    }
                                }), e.extend(e.pareto, {
                                    pdf: function(e, n, r) {
                                        return e < n ? 0 : r * t.pow(n, r) / t.pow(e, r + 1);
                                    },
                                    cdf: function(e, n, r) {
                                        return e < n ? 0 : 1 - t.pow(n / e, r);
                                    },
                                    inv: function(e, n, r) {
                                        return n / t.pow(1 - e, 1 / r);
                                    },
                                    mean: function(e, n) {
                                        if (!(n <= 1)) return n * t.pow(e, n) / (n - 1);
                                    },
                                    median: function(e, n) {
                                        return e * (n * t.SQRT2);
                                    },
                                    mode: function(e) {
                                        return e;
                                    },
                                    variance: function(e, n) {
                                        if (!(n <= 2)) return e * e * n / (t.pow(n - 1, 2) * (n - 2));
                                    }
                                }), e.extend(e.studentt, {
                                    pdf: function(n, r) {
                                        return r = r > 1e100 ? 1e100 : r, 1 / (t.sqrt(r) * e.betafn(.5, r / 2)) * t.pow(1 + n * n / r, -(r + 1) / 2);
                                    },
                                    cdf: function(n, r) {
                                        var o = r / 2;
                                        return e.ibeta((n + t.sqrt(n * n + r)) / (2 * t.sqrt(n * n + r)), o, o);
                                    },
                                    inv: function(n, r) {
                                        var o = e.ibetainv(2 * t.min(n, 1 - n), .5 * r, .5);
                                        return o = t.sqrt(r * (1 - o) / o), n > .5 ? o : -o;
                                    },
                                    mean: function(e) {
                                        return e > 1 ? 0 : void 0;
                                    },
                                    median: function() {
                                        return 0;
                                    },
                                    mode: function() {
                                        return 0;
                                    },
                                    sample: function(n) {
                                        return e.randn() * t.sqrt(n / (2 * e.randg(n / 2)));
                                    },
                                    variance: function(e) {
                                        return e > 2 ? e / (e - 2) : e > 1 ? 1 / 0 : void 0;
                                    }
                                }), e.extend(e.weibull, {
                                    pdf: function(e, n, r) {
                                        return e < 0 || n < 0 || r < 0 ? 0 : r / n * t.pow(e / n, r - 1) * t.exp(-t.pow(e / n, r));
                                    },
                                    cdf: function(e, n, r) {
                                        return e < 0 ? 0 : 1 - t.exp(-t.pow(e / n, r));
                                    },
                                    inv: function(e, n, r) {
                                        return n * t.pow(-t.log(1 - e), 1 / r);
                                    },
                                    mean: function(t, n) {
                                        return t * e.gammafn(1 + 1 / n);
                                    },
                                    median: function(e, n) {
                                        return e * t.pow(t.log(2), 1 / n);
                                    },
                                    mode: function(e, n) {
                                        return n <= 1 ? 0 : e * t.pow((n - 1) / n, 1 / n);
                                    },
                                    sample: function(n, r) {
                                        return n * t.pow(-t.log(e._random_fn()), 1 / r);
                                    },
                                    variance: function(n, r) {
                                        return n * n * e.gammafn(1 + 2 / r) - t.pow(e.weibull.mean(n, r), 2);
                                    }
                                }), e.extend(e.uniform, {
                                    pdf: function(e, t, n) {
                                        return e < t || e > n ? 0 : 1 / (n - t);
                                    },
                                    cdf: function(e, t, n) {
                                        return e < t ? 0 : e < n ? (e - t) / (n - t) : 1;
                                    },
                                    inv: function(e, t, n) {
                                        return t + e * (n - t);
                                    },
                                    mean: function(e, t) {
                                        return .5 * (e + t);
                                    },
                                    median: function(t, n) {
                                        return e.mean(t, n);
                                    },
                                    mode: function() {
                                        throw new Error("mode is not yet implemented");
                                    },
                                    sample: function(t, n) {
                                        return t / 2 + n / 2 + (n / 2 - t / 2) * (2 * e._random_fn() - 1);
                                    },
                                    variance: function(e, n) {
                                        return t.pow(n - e, 2) / 12;
                                    }
                                }), e.extend(e.binomial, {
                                    pdf: function(n, r, o) {
                                        return 0 === o || 1 === o ? r * o === n ? 1 : 0 : e.combination(r, n) * t.pow(o, n) * t.pow(1 - o, r - n);
                                    },
                                    cdf: function(r, o, i) {
                                        var s, l = 1e-10;
                                        if (r < 0) return 0;
                                        if (r >= o) return 1;
                                        if (i < 0 || i > 1 || o <= 0) return NaN;
                                        var a = i, u = (r = t.floor(r)) + 1, c = o - r, f = u + c, d = t.exp(e.gammaln(f) - e.gammaln(c) - e.gammaln(u) + u * t.log(a) + c * t.log(1 - a));
                                        return s = a < (u + 1) / (f + 2) ? d * n(a, u, c, l) : 1 - d * n(1 - a, c, u, l), t.round(1 / l * (1 - s)) / (1 / l);
                                    }
                                }), e.extend(e.negbin, {
                                    pdf: function(n, r, o) {
                                        return n === n >>> 0 && (n < 0 ? 0 : e.combination(n + r - 1, r - 1) * t.pow(1 - o, n) * t.pow(o, r));
                                    },
                                    cdf: function(t, n, r) {
                                        var o = 0, i = 0;
                                        if (t < 0) return 0;
                                        for(; i <= t; i++)o += e.negbin.pdf(i, n, r);
                                        return o;
                                    }
                                }), e.extend(e.hypgeom, {
                                    pdf: function(n, r, o, i) {
                                        if (n != n | 0) return !1;
                                        if (n < 0 || n < o - (r - i)) return 0;
                                        if (n > i || n > o) return 0;
                                        if (2 * o > r) return 2 * i > r ? e.hypgeom.pdf(r - o - i + n, r, r - o, r - i) : e.hypgeom.pdf(i - n, r, r - o, i);
                                        if (2 * i > r) return e.hypgeom.pdf(o - n, r, o, r - i);
                                        if (o < i) return e.hypgeom.pdf(n, r, i, o);
                                        for(var s = 1, l = 0, a = 0; a < n; a++){
                                            for(; s > 1 && l < i;)s *= 1 - o / (r - l), l++;
                                            s *= (i - a) * (o - a) / ((a + 1) * (r - o - i + a + 1));
                                        }
                                        for(; l < i; l++)s *= 1 - o / (r - l);
                                        return t.min(1, t.max(0, s));
                                    },
                                    cdf: function(n, r, o, i) {
                                        if (n < 0 || n < o - (r - i)) return 0;
                                        if (n >= i || n >= o) return 1;
                                        if (2 * o > r) return 2 * i > r ? e.hypgeom.cdf(r - o - i + n, r, r - o, r - i) : 1 - e.hypgeom.cdf(i - n - 1, r, r - o, i);
                                        if (2 * i > r) return 1 - e.hypgeom.cdf(o - n - 1, r, o, r - i);
                                        if (o < i) return e.hypgeom.cdf(n, r, i, o);
                                        for(var s = 1, l = 1, a = 0, u = 0; u < n; u++){
                                            for(; s > 1 && a < i;){
                                                var c = 1 - o / (r - a);
                                                l *= c, s *= c, a++;
                                            }
                                            s += l *= (i - u) * (o - u) / ((u + 1) * (r - o - i + u + 1));
                                        }
                                        for(; a < i; a++)s *= 1 - o / (r - a);
                                        return t.min(1, t.max(0, s));
                                    }
                                }), e.extend(e.poisson, {
                                    pdf: function(n, r) {
                                        return r < 0 || n % 1 != 0 || n < 0 ? 0 : t.pow(r, n) * t.exp(-r) / e.factorial(n);
                                    },
                                    cdf: function(t, n) {
                                        var r = [], o = 0;
                                        if (t < 0) return 0;
                                        for(; o <= t; o++)r.push(e.poisson.pdf(o, n));
                                        return e.sum(r);
                                    },
                                    mean: function(e) {
                                        return e;
                                    },
                                    variance: function(e) {
                                        return e;
                                    },
                                    sampleSmall: function(n) {
                                        var r = 1, o = 0, i = t.exp(-n);
                                        do o++, r *= e._random_fn();
                                        while (r > i);
                                        return o - 1;
                                    },
                                    sampleLarge: function(n) {
                                        var r, o, i, s, l, a, u, c, f, d, p = n;
                                        for(s = t.sqrt(p), l = t.log(p), a = .02483 * (u = .931 + 2.53 * s) - .059, c = 1.1239 + 1.1328 / (u - 3.4), f = .9277 - 3.6224 / (u - 2);;){
                                            if (o = t.random() - .5, i = t.random(), d = .5 - t.abs(o), r = t.floor((2 * a / d + u) * o + p + .43), d >= .07 && i <= f) return r;
                                            if (!(r < 0 || d < .013 && i > d) && t.log(i) + t.log(c) - t.log(a / (d * d) + u) <= r * l - p - e.loggam(r + 1)) return r;
                                        }
                                    },
                                    sample: function(e) {
                                        return e < 10 ? this.sampleSmall(e) : this.sampleLarge(e);
                                    }
                                }), e.extend(e.triangular, {
                                    pdf: function(e, t, n, r) {
                                        return n <= t || r < t || r > n ? NaN : e < t || e > n ? 0 : e < r ? 2 * (e - t) / ((n - t) * (r - t)) : e === r ? 2 / (n - t) : 2 * (n - e) / ((n - t) * (n - r));
                                    },
                                    cdf: function(e, n, r, o) {
                                        return r <= n || o < n || o > r ? NaN : e <= n ? 0 : e >= r ? 1 : e <= o ? t.pow(e - n, 2) / ((r - n) * (o - n)) : 1 - t.pow(r - e, 2) / ((r - n) * (r - o));
                                    },
                                    inv: function(e, n, r, o) {
                                        return r <= n || o < n || o > r ? NaN : e <= (o - n) / (r - n) ? n + (r - n) * t.sqrt(e * ((o - n) / (r - n))) : n + (r - n) * (1 - t.sqrt((1 - e) * (1 - (o - n) / (r - n))));
                                    },
                                    mean: function(e, t, n) {
                                        return (e + t + n) / 3;
                                    },
                                    median: function(e, n, r) {
                                        return r <= (e + n) / 2 ? n - t.sqrt((n - e) * (n - r)) / t.sqrt(2) : r > (e + n) / 2 ? e + t.sqrt((n - e) * (r - e)) / t.sqrt(2) : void 0;
                                    },
                                    mode: function(e, t, n) {
                                        return n;
                                    },
                                    sample: function(n, r, o) {
                                        var i = e._random_fn();
                                        return i < (o - n) / (r - n) ? n + t.sqrt(i * (r - n) * (o - n)) : r - t.sqrt((1 - i) * (r - n) * (r - o));
                                    },
                                    variance: function(e, t, n) {
                                        return (e * e + t * t + n * n - e * t - e * n - t * n) / 18;
                                    }
                                }), e.extend(e.arcsine, {
                                    pdf: function(e, n, r) {
                                        return r <= n ? NaN : e <= n || e >= r ? 0 : 2 / t.PI * t.pow(t.pow(r - n, 2) - t.pow(2 * e - n - r, 2), -0.5);
                                    },
                                    cdf: function(e, n, r) {
                                        return e < n ? 0 : e < r ? 2 / t.PI * t.asin(t.sqrt((e - n) / (r - n))) : 1;
                                    },
                                    inv: function(e, n, r) {
                                        return n + (.5 - .5 * t.cos(t.PI * e)) * (r - n);
                                    },
                                    mean: function(e, t) {
                                        return t <= e ? NaN : (e + t) / 2;
                                    },
                                    median: function(e, t) {
                                        return t <= e ? NaN : (e + t) / 2;
                                    },
                                    mode: function() {
                                        throw new Error("mode is not yet implemented");
                                    },
                                    sample: function(n, r) {
                                        return (n + r) / 2 + (r - n) / 2 * t.sin(2 * t.PI * e.uniform.sample(0, 1));
                                    },
                                    variance: function(e, n) {
                                        return n <= e ? NaN : t.pow(n - e, 2) / 8;
                                    }
                                }), e.extend(e.laplace, {
                                    pdf: function(e, n, r) {
                                        return r <= 0 ? 0 : t.exp(-t.abs(e - n) / r) / (2 * r);
                                    },
                                    cdf: function(e, n, r) {
                                        return r <= 0 ? 0 : e < n ? .5 * t.exp((e - n) / r) : 1 - .5 * t.exp(-(e - n) / r);
                                    },
                                    mean: function(e) {
                                        return e;
                                    },
                                    median: function(e) {
                                        return e;
                                    },
                                    mode: function(e) {
                                        return e;
                                    },
                                    variance: function(e, t) {
                                        return 2 * t * t;
                                    },
                                    sample: function(n, r) {
                                        var o, i = e._random_fn() - .5;
                                        return n - r * ((o = i) / t.abs(o)) * t.log(1 - 2 * t.abs(i));
                                    }
                                }), e.extend(e.tukey, {
                                    cdf: function(n, o, i) {
                                        var s = o, l = [
                                            .9894009349916499,
                                            .9445750230732326,
                                            .8656312023878318,
                                            .755404408355003,
                                            .6178762444026438,
                                            .45801677765722737,
                                            .2816035507792589,
                                            .09501250983763744
                                        ], a = [
                                            .027152459411754096,
                                            .062253523938647894,
                                            .09515851168249279,
                                            .12462897125553388,
                                            .14959598881657674,
                                            .16915651939500254,
                                            .18260341504492358,
                                            .1894506104550685
                                        ];
                                        if (n <= 0) return 0;
                                        if (i < 2 || s < 2) return NaN;
                                        if (!Number.isFinite(n)) return 1;
                                        if (i > 25e3) return r(n, 1, s);
                                        var u, c = .5 * i, f = c * t.log(i) - i * t.log(2) - e.gammaln(c), d = c - 1, p = .25 * i;
                                        u = i <= 100 ? 1 : i <= 800 ? .5 : i <= 5e3 ? .25 : .125, f += t.log(u);
                                        for(var h = 0, g = 1; g <= 50; g++){
                                            for(var m = 0, v = (2 * g - 1) * u, y = 1; y <= 16; y++){
                                                var C, w;
                                                8 < y ? (C = y - 8 - 1, w = f + d * t.log(v + l[C] * u) - (l[C] * u + v) * p) : (C = y - 1, w = f + d * t.log(v - l[C] * u) + (l[C] * u - v) * p), w >= -30 && (m += r(8 < y ? n * t.sqrt(.5 * (l[C] * u + v)) : n * t.sqrt(.5 * (-l[C] * u + v)), 1, s) * a[C] * t.exp(w));
                                            }
                                            if (g * u >= 1 && m <= 1e-14) break;
                                            h += m;
                                        }
                                        if (m > 1e-14) throw new Error("tukey.cdf failed to converge");
                                        return h > 1 && (h = 1), h;
                                    },
                                    inv: function(n, r, o) {
                                        if (o < 2 || r < 2) return NaN;
                                        if (n < 0 || n > 1) return NaN;
                                        if (0 === n) return 0;
                                        if (1 === n) return 1 / 0;
                                        var i, s = function(e, n, r) {
                                            var o = .5 - .5 * e, i = t.sqrt(t.log(1 / (o * o))), s = i + ((((-0.0000453642210148 * i - .204231210125) * i - .342242088547) * i - 1) * i + .322232421088) / ((((.0038560700634 * i + .10353775285) * i + .531103462366) * i + .588581570495) * i + .099348462606);
                                            r < 120 && (s += (s * s * s + s) / r / 4);
                                            var l = .8832 - .2368 * s;
                                            return r < 120 && (l += -1.214 / r + 1.208 * s / r), s * (l * t.log(n - 1) + 1.4142);
                                        }(n, r, o), l = e.tukey.cdf(s, r, o) - n;
                                        i = l > 0 ? t.max(0, s - 1) : s + 1;
                                        for(var a, u = e.tukey.cdf(i, r, o) - n, c = 1; c < 50; c++)if (a = i - u * (i - s) / (u - l), l = u, s = i, a < 0 && (a = 0, u = -n), u = e.tukey.cdf(a, r, o) - n, i = a, t.abs(i - s) < 1e-4) return a;
                                        throw new Error("tukey.inv failed to converge");
                                    }
                                });
                            }(t, Math), function(e, t) {
                                var n, r, o = Array.prototype.push, i = e.utils.isArray;
                                function s(t) {
                                    return i(t) || t instanceof e;
                                }
                                e.extend({
                                    add: function(t, n) {
                                        return s(n) ? (s(n[0]) || (n = [
                                            n
                                        ]), e.map(t, function(e, t, r) {
                                            return e + n[t][r];
                                        })) : e.map(t, function(e) {
                                            return e + n;
                                        });
                                    },
                                    subtract: function(t, n) {
                                        return s(n) ? (s(n[0]) || (n = [
                                            n
                                        ]), e.map(t, function(e, t, r) {
                                            return e - n[t][r] || 0;
                                        })) : e.map(t, function(e) {
                                            return e - n;
                                        });
                                    },
                                    divide: function(t, n) {
                                        return s(n) ? (s(n[0]) || (n = [
                                            n
                                        ]), e.multiply(t, e.inv(n))) : e.map(t, function(e) {
                                            return e / n;
                                        });
                                    },
                                    multiply: function(t, n) {
                                        var r, o, i, l, a, u, c, f;
                                        if (void 0 === t.length && void 0 === n.length) return t * n;
                                        if (a = t.length, u = t[0].length, c = e.zeros(a, i = s(n) ? n[0].length : u), f = 0, s(n)) {
                                            for(; f < i; f++)for(r = 0; r < a; r++){
                                                for(l = 0, o = 0; o < u; o++)l += t[r][o] * n[o][f];
                                                c[r][f] = l;
                                            }
                                            return 1 === a && 1 === f ? c[0][0] : c;
                                        }
                                        return e.map(t, function(e) {
                                            return e * n;
                                        });
                                    },
                                    outer: function(t, n) {
                                        return e.multiply(t.map(function(e) {
                                            return [
                                                e
                                            ];
                                        }), [
                                            n
                                        ]);
                                    },
                                    dot: function(t, n) {
                                        s(t[0]) || (t = [
                                            t
                                        ]), s(n[0]) || (n = [
                                            n
                                        ]);
                                        for(var r, o, i = 1 === t[0].length && 1 !== t.length ? e.transpose(t) : t, l = 1 === n[0].length && 1 !== n.length ? e.transpose(n) : n, a = [], u = 0, c = i.length, f = i[0].length; u < c; u++){
                                            for(a[u] = [], r = 0, o = 0; o < f; o++)r += i[u][o] * l[u][o];
                                            a[u] = r;
                                        }
                                        return 1 === a.length ? a[0] : a;
                                    },
                                    pow: function(n, r) {
                                        return e.map(n, function(e) {
                                            return t.pow(e, r);
                                        });
                                    },
                                    exp: function(n) {
                                        return e.map(n, function(e) {
                                            return t.exp(e);
                                        });
                                    },
                                    log: function(n) {
                                        return e.map(n, function(e) {
                                            return t.log(e);
                                        });
                                    },
                                    abs: function(n) {
                                        return e.map(n, function(e) {
                                            return t.abs(e);
                                        });
                                    },
                                    norm: function(e, n) {
                                        var r = 0, o = 0;
                                        for(isNaN(n) && (n = 2), s(e[0]) && (e = e[0]); o < e.length; o++)r += t.pow(t.abs(e[o]), n);
                                        return t.pow(r, 1 / n);
                                    },
                                    angle: function(n, r) {
                                        return t.acos(e.dot(n, r) / (e.norm(n) * e.norm(r)));
                                    },
                                    aug: function(e, t) {
                                        var n, r = [];
                                        for(n = 0; n < e.length; n++)r.push(e[n].slice());
                                        for(n = 0; n < r.length; n++)o.apply(r[n], t[n]);
                                        return r;
                                    },
                                    inv: function(t) {
                                        for(var n, r = t.length, o = t[0].length, i = e.identity(r, o), s = e.gauss_jordan(t, i), l = [], a = 0; a < r; a++)for(l[a] = [], n = o; n < s[0].length; n++)l[a][n - o] = s[a][n];
                                        return l;
                                    },
                                    det: function e(t) {
                                        if (2 === t.length) return t[0][0] * t[1][1] - t[0][1] * t[1][0];
                                        for(var n = 0, r = 0; r < t.length; r++){
                                            for(var o = [], i = 1; i < t.length; i++){
                                                o[i - 1] = [];
                                                for(var s = 0; s < t.length; s++)s < r ? o[i - 1][s] = t[i][s] : s > r && (o[i - 1][s - 1] = t[i][s]);
                                            }
                                            var l = r % 2 ? -1 : 1;
                                            n += e(o) * t[0][r] * l;
                                        }
                                        return n;
                                    },
                                    gauss_elimination: function(n, r) {
                                        var o, i, s, l, a = 0, u = 0, c = n.length, f = n[0].length, d = 1, p = 0, h = [];
                                        for(o = (n = e.aug(n, r))[0].length, a = 0; a < c; a++){
                                            for(i = n[a][a], u = a, l = a + 1; l < f; l++)i < t.abs(n[l][a]) && (i = n[l][a], u = l);
                                            if (u != a) for(l = 0; l < o; l++)s = n[a][l], n[a][l] = n[u][l], n[u][l] = s;
                                            for(u = a + 1; u < c; u++)for(d = n[u][a] / n[a][a], l = a; l < o; l++)n[u][l] = n[u][l] - d * n[a][l];
                                        }
                                        for(a = c - 1; a >= 0; a--){
                                            for(p = 0, u = a + 1; u <= c - 1; u++)p += h[u] * n[a][u];
                                            h[a] = (n[a][o - 1] - p) / n[a][a];
                                        }
                                        return h;
                                    },
                                    gauss_jordan: function(n, r) {
                                        var o, i, s, l = e.aug(n, r), a = l.length, u = l[0].length, c = 0;
                                        for(i = 0; i < a; i++){
                                            var f = i;
                                            for(s = i + 1; s < a; s++)t.abs(l[s][i]) > t.abs(l[f][i]) && (f = s);
                                            var d = l[i];
                                            for(l[i] = l[f], l[f] = d, s = i + 1; s < a; s++)for(c = l[s][i] / l[i][i], o = i; o < u; o++)l[s][o] -= l[i][o] * c;
                                        }
                                        for(i = a - 1; i >= 0; i--){
                                            for(c = l[i][i], s = 0; s < i; s++)for(o = u - 1; o > i - 1; o--)l[s][o] -= l[i][o] * l[s][i] / c;
                                            for(l[i][i] /= c, o = a; o < u; o++)l[i][o] /= c;
                                        }
                                        return l;
                                    },
                                    triaUpSolve: function(t, n) {
                                        var r, o = t[0].length, i = e.zeros(1, o)[0], s = !1;
                                        return null != n[0].length && (n = n.map(function(e) {
                                            return e[0];
                                        }), s = !0), e.arange(o - 1, -1, -1).forEach(function(s) {
                                            r = e.arange(s + 1, o).map(function(e) {
                                                return i[e] * t[s][e];
                                            }), i[s] = (n[s] - e.sum(r)) / t[s][s];
                                        }), s ? i.map(function(e) {
                                            return [
                                                e
                                            ];
                                        }) : i;
                                    },
                                    triaLowSolve: function(t, n) {
                                        var r, o = t[0].length, i = e.zeros(1, o)[0], s = !1;
                                        return null != n[0].length && (n = n.map(function(e) {
                                            return e[0];
                                        }), s = !0), e.arange(o).forEach(function(o) {
                                            r = e.arange(o).map(function(e) {
                                                return t[o][e] * i[e];
                                            }), i[o] = (n[o] - e.sum(r)) / t[o][o];
                                        }), s ? i.map(function(e) {
                                            return [
                                                e
                                            ];
                                        }) : i;
                                    },
                                    lu: function(t) {
                                        var n, r = t.length, o = e.identity(r), i = e.zeros(t.length, t[0].length);
                                        return e.arange(r).forEach(function(e) {
                                            i[0][e] = t[0][e];
                                        }), e.arange(1, r).forEach(function(s) {
                                            e.arange(s).forEach(function(r) {
                                                n = e.arange(r).map(function(e) {
                                                    return o[s][e] * i[e][r];
                                                }), o[s][r] = (t[s][r] - e.sum(n)) / i[r][r];
                                            }), e.arange(s, r).forEach(function(r) {
                                                n = e.arange(s).map(function(e) {
                                                    return o[s][e] * i[e][r];
                                                }), i[s][r] = t[n.length][r] - e.sum(n);
                                            });
                                        }), [
                                            o,
                                            i
                                        ];
                                    },
                                    cholesky: function(n) {
                                        var r, o = n.length, i = e.zeros(n.length, n[0].length);
                                        return e.arange(o).forEach(function(s) {
                                            r = e.arange(s).map(function(e) {
                                                return t.pow(i[s][e], 2);
                                            }), i[s][s] = t.sqrt(n[s][s] - e.sum(r)), e.arange(s + 1, o).forEach(function(t) {
                                                r = e.arange(s).map(function(e) {
                                                    return i[s][e] * i[t][e];
                                                }), i[t][s] = (n[s][t] - e.sum(r)) / i[s][s];
                                            });
                                        }), i;
                                    },
                                    gauss_jacobi: function(n, r, o, i) {
                                        for(var s, l, a, u, c = 0, f = 0, d = n.length, p = [], h = [], g = []; c < d; c++)for(p[c] = [], h[c] = [], g[c] = [], f = 0; f < d; f++)c > f ? (p[c][f] = n[c][f], h[c][f] = g[c][f] = 0) : c < f ? (h[c][f] = n[c][f], p[c][f] = g[c][f] = 0) : (g[c][f] = n[c][f], p[c][f] = h[c][f] = 0);
                                        for(a = e.multiply(e.multiply(e.inv(g), e.add(p, h)), -1), l = e.multiply(e.inv(g), r), s = o, u = e.add(e.multiply(a, o), l), c = 2; t.abs(e.norm(e.subtract(u, s))) > i;)s = u, u = e.add(e.multiply(a, s), l), c++;
                                        return u;
                                    },
                                    gauss_seidel: function(n, r, o, i) {
                                        for(var s, l, a, u, c, f = 0, d = n.length, p = [], h = [], g = []; f < d; f++)for(p[f] = [], h[f] = [], g[f] = [], s = 0; s < d; s++)f > s ? (p[f][s] = n[f][s], h[f][s] = g[f][s] = 0) : f < s ? (h[f][s] = n[f][s], p[f][s] = g[f][s] = 0) : (g[f][s] = n[f][s], p[f][s] = h[f][s] = 0);
                                        for(u = e.multiply(e.multiply(e.inv(e.add(g, p)), h), -1), a = e.multiply(e.inv(e.add(g, p)), r), l = o, c = e.add(e.multiply(u, o), a), f = 2; t.abs(e.norm(e.subtract(c, l))) > i;)l = c, c = e.add(e.multiply(u, l), a), f += 1;
                                        return c;
                                    },
                                    SOR: function(n, r, o, i, s) {
                                        for(var l, a, u, c, f, d = 0, p = n.length, h = [], g = [], m = []; d < p; d++)for(h[d] = [], g[d] = [], m[d] = [], l = 0; l < p; l++)d > l ? (h[d][l] = n[d][l], g[d][l] = m[d][l] = 0) : d < l ? (g[d][l] = n[d][l], h[d][l] = m[d][l] = 0) : (m[d][l] = n[d][l], h[d][l] = g[d][l] = 0);
                                        for(c = e.multiply(e.inv(e.add(m, e.multiply(h, s))), e.subtract(e.multiply(m, 1 - s), e.multiply(g, s))), u = e.multiply(e.multiply(e.inv(e.add(m, e.multiply(h, s))), r), s), a = o, f = e.add(e.multiply(c, o), u), d = 2; t.abs(e.norm(e.subtract(f, a))) > i;)a = f, f = e.add(e.multiply(c, a), u), d++;
                                        return f;
                                    },
                                    householder: function(n) {
                                        for(var r, o, i, s, l = n.length, a = n[0].length, u = 0, c = [], f = []; u < l - 1; u++){
                                            for(r = 0, s = u + 1; s < a; s++)r += n[s][u] * n[s][u];
                                            for(r = (n[u + 1][u] > 0 ? -1 : 1) * t.sqrt(r), o = t.sqrt((r * r - n[u + 1][u] * r) / 2), (c = e.zeros(l, 1))[u + 1][0] = (n[u + 1][u] - r) / (2 * o), i = u + 2; i < l; i++)c[i][0] = n[i][u] / (2 * o);
                                            f = e.subtract(e.identity(l, a), e.multiply(e.multiply(c, e.transpose(c)), 2)), n = e.multiply(f, e.multiply(n, f));
                                        }
                                        return n;
                                    },
                                    QR: (n = e.sum, r = e.arange, function(o) {
                                        var i, s, l, a = o.length, u = o[0].length, c = e.zeros(u, u);
                                        for(o = e.copy(o), s = 0; s < u; s++){
                                            for(c[s][s] = t.sqrt(n(r(a).map(function(e) {
                                                return o[e][s] * o[e][s];
                                            }))), i = 0; i < a; i++)o[i][s] = o[i][s] / c[s][s];
                                            for(l = s + 1; l < u; l++)for(c[s][l] = n(r(a).map(function(e) {
                                                return o[e][s] * o[e][l];
                                            })), i = 0; i < a; i++)o[i][l] = o[i][l] - o[i][s] * c[s][l];
                                        }
                                        return [
                                            o,
                                            c
                                        ];
                                    }),
                                    lstsq: function(t, n) {
                                        var r = !1;
                                        void 0 === n[0].length && (n = n.map(function(e) {
                                            return [
                                                e
                                            ];
                                        }), r = !0);
                                        var o = e.QR(t), i = o[0], s = o[1], l = t[0].length, a = e.slice(i, {
                                            col: {
                                                end: l
                                            }
                                        }), u = function(t) {
                                            var n = (t = e.copy(t)).length, r = e.identity(n);
                                            return e.arange(n - 1, -1, -1).forEach(function(n) {
                                                e.sliceAssign(r, {
                                                    row: n
                                                }, e.divide(e.slice(r, {
                                                    row: n
                                                }), t[n][n])), e.sliceAssign(t, {
                                                    row: n
                                                }, e.divide(e.slice(t, {
                                                    row: n
                                                }), t[n][n])), e.arange(n).forEach(function(o) {
                                                    var i = e.multiply(t[o][n], -1), s = e.slice(t, {
                                                        row: o
                                                    }), l = e.multiply(e.slice(t, {
                                                        row: n
                                                    }), i);
                                                    e.sliceAssign(t, {
                                                        row: o
                                                    }, e.add(s, l));
                                                    var a = e.slice(r, {
                                                        row: o
                                                    }), u = e.multiply(e.slice(r, {
                                                        row: n
                                                    }), i);
                                                    e.sliceAssign(r, {
                                                        row: o
                                                    }, e.add(a, u));
                                                });
                                            }), r;
                                        }(e.slice(s, {
                                            row: {
                                                end: l
                                            }
                                        })), c = e.transpose(a);
                                        void 0 === c[0].length && (c = [
                                            c
                                        ]);
                                        var f = e.multiply(e.multiply(u, c), n);
                                        return void 0 === f.length && (f = [
                                            [
                                                f
                                            ]
                                        ]), r ? f.map(function(e) {
                                            return e[0];
                                        }) : f;
                                    },
                                    jacobi: function(n) {
                                        for(var r, o, i, s, l, a, u, c = 1, f = n.length, d = e.identity(f, f), p = []; 1 === c;){
                                            for(l = n[0][1], i = 0, s = 1, r = 0; r < f; r++)for(o = 0; o < f; o++)r != o && l < t.abs(n[r][o]) && (l = t.abs(n[r][o]), i = r, s = o);
                                            for(a = n[i][i] === n[s][s] ? n[i][s] > 0 ? t.PI / 4 : -t.PI / 4 : t.atan(2 * n[i][s] / (n[i][i] - n[s][s])) / 2, (u = e.identity(f, f))[i][i] = t.cos(a), u[i][s] = -t.sin(a), u[s][i] = t.sin(a), u[s][s] = t.cos(a), d = e.multiply(d, u), n = e.multiply(e.multiply(e.inv(u), n), u), c = 0, r = 1; r < f; r++)for(o = 1; o < f; o++)r != o && t.abs(n[r][o]) > .001 && (c = 1);
                                        }
                                        for(r = 0; r < f; r++)p.push(n[r][r]);
                                        return [
                                            d,
                                            p
                                        ];
                                    },
                                    rungekutta: function(e, t, n, r, o, i) {
                                        var s, l, a;
                                        if (2 === i) for(; r <= n;)o += ((s = t * e(r, o)) + (l = t * e(r + t, o + s))) / 2, r += t;
                                        if (4 === i) for(; r <= n;)o += ((s = t * e(r, o)) + 2 * (l = t * e(r + t / 2, o + s / 2)) + 2 * (a = t * e(r + t / 2, o + l / 2)) + t * e(r + t, o + a)) / 6, r += t;
                                        return o;
                                    },
                                    romberg: function(e, n, r, o) {
                                        for(var i, s, l, a, u, c = 0, f = (r - n) / 2, d = [], p = [], h = []; c < o / 2;){
                                            for(u = e(n), l = n, a = 0; l <= r; l += f, a++)d[a] = l;
                                            for(i = d.length, l = 1; l < i - 1; l++)u += (l % 2 != 0 ? 4 : 2) * e(d[l]);
                                            u = f / 3 * (u + e(r)), h[c] = u, f /= 2, c++;
                                        }
                                        for(s = h.length, i = 1; 1 !== s;){
                                            for(l = 0; l < s - 1; l++)p[l] = (t.pow(4, i) * h[l + 1] - h[l]) / (t.pow(4, i) - 1);
                                            s = p.length, h = p, p = [], i++;
                                        }
                                        return h;
                                    },
                                    richardson: function(e, n, r, o) {
                                        function i(e, t) {
                                            for(var n, r = 0, o = e.length; r < o; r++)e[r] === t && (n = r);
                                            return n;
                                        }
                                        for(var s, l, a, u, c, f = t.abs(r - e[i(e, r) + 1]), d = 0, p = [], h = []; o >= f;)s = i(e, r + o), l = i(e, r), p[d] = (n[s] - 2 * n[l] + n[2 * l - s]) / (o * o), o /= 2, d++;
                                        for(u = p.length, a = 1; 1 != u;){
                                            for(c = 0; c < u - 1; c++)h[c] = (t.pow(4, a) * p[c + 1] - p[c]) / (t.pow(4, a) - 1);
                                            u = h.length, p = h, h = [], a++;
                                        }
                                        return p;
                                    },
                                    simpson: function(e, t, n, r) {
                                        for(var o, i = (n - t) / r, s = e(t), l = [], a = t, u = 0, c = 1; a <= n; a += i, u++)l[u] = a;
                                        for(o = l.length; c < o - 1; c++)s += (c % 2 != 0 ? 4 : 2) * e(l[c]);
                                        return i / 3 * (s + e(n));
                                    },
                                    hermite: function(e, t, n, r) {
                                        for(var o, i = e.length, s = 0, l = 0, a = [], u = [], c = [], f = []; l < i; l++){
                                            for(a[l] = 1, o = 0; o < i; o++)l != o && (a[l] *= (r - e[o]) / (e[l] - e[o]));
                                            for(u[l] = 0, o = 0; o < i; o++)l != o && (u[l] += 1 / (e[l] - e[o]));
                                            c[l] = (1 - 2 * (r - e[l]) * u[l]) * (a[l] * a[l]), f[l] = (r - e[l]) * (a[l] * a[l]), s += c[l] * t[l] + f[l] * n[l];
                                        }
                                        return s;
                                    },
                                    lagrange: function(e, t, n) {
                                        for(var r, o, i = 0, s = 0, l = e.length; s < l; s++){
                                            for(o = t[s], r = 0; r < l; r++)s != r && (o *= (n - e[r]) / (e[s] - e[r]));
                                            i += o;
                                        }
                                        return i;
                                    },
                                    cubic_spline: function(t, n, r) {
                                        for(var o, i, s = t.length, l = 0, a = [], u = [], c = [], f = [], d = [], p = []; l < s - 1; l++)f[l] = t[l + 1] - t[l];
                                        for(c[0] = 0, l = 1; l < s - 1; l++)c[l] = 3 / f[l] * (n[l + 1] - n[l]) - 3 / f[l - 1] * (n[l] - n[l - 1]);
                                        for(l = 1; l < s - 1; l++)a[l] = [], u[l] = [], a[l][l - 1] = f[l - 1], a[l][l] = 2 * (f[l - 1] + f[l]), a[l][l + 1] = f[l], u[l][0] = c[l];
                                        for(i = e.multiply(e.inv(a), u), o = 0; o < s - 1; o++)d[o] = (n[o + 1] - n[o]) / f[o] - f[o] * (i[o + 1][0] + 2 * i[o][0]) / 3, p[o] = (i[o + 1][0] - i[o][0]) / (3 * f[o]);
                                        for(o = 0; o < s && !(t[o] > r); o++);
                                        return n[o -= 1] + (r - t[o]) * d[o] + e.sq(r - t[o]) * i[o] + (r - t[o]) * e.sq(r - t[o]) * p[o];
                                    },
                                    gauss_quadrature: function() {
                                        throw new Error("gauss_quadrature not yet implemented");
                                    },
                                    PCA: function(t) {
                                        var n, r, o, i, s, l = t.length, a = t[0].length, u = 0, c = [], f = [], d = [], p = [], h = [], g = [], m = [];
                                        for(u = 0; u < l; u++)c[u] = e.sum(t[u]) / a;
                                        for(u = 0; u < a; u++)for(h[u] = [], n = 0; n < l; n++)h[u][n] = t[n][u] - c[n];
                                        for(h = e.transpose(h), u = 0; u < l; u++)for(g[u] = [], n = 0; n < l; n++)g[u][n] = e.dot([
                                            h[u]
                                        ], [
                                            h[n]
                                        ]) / (a - 1);
                                        for(s = (o = e.jacobi(g))[0], f = o[1], m = e.transpose(s), u = 0; u < f.length; u++)for(n = u; n < f.length; n++)f[u] < f[n] && (r = f[u], f[u] = f[n], f[n] = r, d = m[u], m[u] = m[n], m[n] = d);
                                        for(i = e.transpose(h), u = 0; u < l; u++)for(p[u] = [], n = 0; n < i.length; n++)p[u][n] = e.dot([
                                            m[u]
                                        ], [
                                            i[n]
                                        ]);
                                        return [
                                            t,
                                            f,
                                            m,
                                            p
                                        ];
                                    }
                                }), function(t) {
                                    for(var n = 0; n < t.length; n++)!function(t) {
                                        e.fn[t] = function(n, r) {
                                            var o = this;
                                            return r ? (setTimeout(function() {
                                                r.call(o, e.fn[t].call(o, n));
                                            }, 15), this) : "number" == typeof e[t](this, n) ? e[t](this, n) : e(e[t](this, n));
                                        };
                                    }(t[n]);
                                }("add divide multiply subtract dot pow exp log abs norm angle".split(" "));
                            }(t, Math), function(e, t) {
                                var n = [].slice, r = e.utils.isNumber, o = e.utils.isArray;
                                function i(e, n, r, o) {
                                    if (e > 1 || r > 1 || e <= 0 || r <= 0) throw new Error("Proportions should be greater than 0 and less than 1");
                                    var i = (e * n + r * o) / (n + o);
                                    return (e - r) / t.sqrt(i * (1 - i) * (1 / n + 1 / o));
                                }
                                e.extend({
                                    zscore: function() {
                                        var t = n.call(arguments);
                                        return r(t[1]) ? (t[0] - t[1]) / t[2] : (t[0] - e.mean(t[1])) / e.stdev(t[1], t[2]);
                                    },
                                    ztest: function() {
                                        var r, i = n.call(arguments);
                                        return o(i[1]) ? (r = e.zscore(i[0], i[1], i[3]), 1 === i[2] ? e.normal.cdf(-t.abs(r), 0, 1) : 2 * e.normal.cdf(-t.abs(r), 0, 1)) : i.length > 2 ? (r = e.zscore(i[0], i[1], i[2]), 1 === i[3] ? e.normal.cdf(-t.abs(r), 0, 1) : 2 * e.normal.cdf(-t.abs(r), 0, 1)) : (r = i[0], 1 === i[1] ? e.normal.cdf(-t.abs(r), 0, 1) : 2 * e.normal.cdf(-t.abs(r), 0, 1));
                                    }
                                }), e.extend(e.fn, {
                                    zscore: function(e, t) {
                                        return (e - this.mean()) / this.stdev(t);
                                    },
                                    ztest: function(n, r, o) {
                                        var i = t.abs(this.zscore(n, o));
                                        return 1 === r ? e.normal.cdf(-i, 0, 1) : 2 * e.normal.cdf(-i, 0, 1);
                                    }
                                }), e.extend({
                                    tscore: function() {
                                        var r = n.call(arguments);
                                        return 4 === r.length ? (r[0] - r[1]) / (r[2] / t.sqrt(r[3])) : (r[0] - e.mean(r[1])) / (e.stdev(r[1], !0) / t.sqrt(r[1].length));
                                    },
                                    ttest: function() {
                                        var o, i = n.call(arguments);
                                        return 5 === i.length ? (o = t.abs(e.tscore(i[0], i[1], i[2], i[3])), 1 === i[4] ? e.studentt.cdf(-o, i[3] - 1) : 2 * e.studentt.cdf(-o, i[3] - 1)) : r(i[1]) ? (o = t.abs(i[0]), 1 == i[2] ? e.studentt.cdf(-o, i[1] - 1) : 2 * e.studentt.cdf(-o, i[1] - 1)) : (o = t.abs(e.tscore(i[0], i[1])), 1 == i[2] ? e.studentt.cdf(-o, i[1].length - 1) : 2 * e.studentt.cdf(-o, i[1].length - 1));
                                    }
                                }), e.extend(e.fn, {
                                    tscore: function(e) {
                                        return (e - this.mean()) / (this.stdev(!0) / t.sqrt(this.cols()));
                                    },
                                    ttest: function(n, r) {
                                        return 1 === r ? 1 - e.studentt.cdf(t.abs(this.tscore(n)), this.cols() - 1) : 2 * e.studentt.cdf(-t.abs(this.tscore(n)), this.cols() - 1);
                                    }
                                }), e.extend({
                                    anovafscore: function() {
                                        var r, o, i, s, l, a, u, c, f = n.call(arguments);
                                        if (1 === f.length) {
                                            for(l = new Array(f[0].length), u = 0; u < f[0].length; u++)l[u] = f[0][u];
                                            f = l;
                                        }
                                        for(o = new Array, u = 0; u < f.length; u++)o = o.concat(f[u]);
                                        for(i = e.mean(o), r = 0, u = 0; u < f.length; u++)r += f[u].length * t.pow(e.mean(f[u]) - i, 2);
                                        for(r /= f.length - 1, a = 0, u = 0; u < f.length; u++)for(s = e.mean(f[u]), c = 0; c < f[u].length; c++)a += t.pow(f[u][c] - s, 2);
                                        return r / (a / (o.length - f.length));
                                    },
                                    anovaftest: function() {
                                        var t, o, i, s, l = n.call(arguments);
                                        if (r(l[0])) return 1 - e.centralF.cdf(l[0], l[1], l[2]);
                                        var a = e.anovafscore(l);
                                        for(t = l.length - 1, i = 0, s = 0; s < l.length; s++)i += l[s].length;
                                        return o = i - t - 1, 1 - e.centralF.cdf(a, t, o);
                                    },
                                    ftest: function(t, n, r) {
                                        return 1 - e.centralF.cdf(t, n, r);
                                    }
                                }), e.extend(e.fn, {
                                    anovafscore: function() {
                                        return e.anovafscore(this.toArray());
                                    },
                                    anovaftes: function() {
                                        var t, n = 0;
                                        for(t = 0; t < this.length; t++)n += this[t].length;
                                        return e.ftest(this.anovafscore(), this.length - 1, n - this.length);
                                    }
                                }), e.extend({
                                    qscore: function() {
                                        var o, i, s, l, a, u = n.call(arguments);
                                        return r(u[0]) ? (o = u[0], i = u[1], s = u[2], l = u[3], a = u[4]) : (o = e.mean(u[0]), i = e.mean(u[1]), s = u[0].length, l = u[1].length, a = u[2]), t.abs(o - i) / (a * t.sqrt((1 / s + 1 / l) / 2));
                                    },
                                    qtest: function() {
                                        var t, r = n.call(arguments);
                                        3 === r.length ? (t = r[0], r = r.slice(1)) : 7 === r.length ? (t = e.qscore(r[0], r[1], r[2], r[3], r[4]), r = r.slice(5)) : (t = e.qscore(r[0], r[1], r[2]), r = r.slice(3));
                                        var o = r[0], i = r[1];
                                        return 1 - e.tukey.cdf(t, i, o - i);
                                    },
                                    tukeyhsd: function(t) {
                                        for(var n = e.pooledstdev(t), r = t.map(function(t) {
                                            return e.mean(t);
                                        }), o = t.reduce(function(e, t) {
                                            return e + t.length;
                                        }, 0), i = [], s = 0; s < t.length; ++s)for(var l = s + 1; l < t.length; ++l){
                                            var a = e.qtest(r[s], r[l], t[s].length, t[l].length, n, o, t.length);
                                            i.push([
                                                [
                                                    s,
                                                    l
                                                ],
                                                a
                                            ]);
                                        }
                                        return i;
                                    }
                                }), e.extend({
                                    normalci: function() {
                                        var r, o = n.call(arguments), i = new Array(2);
                                        return r = 4 === o.length ? t.abs(e.normal.inv(o[1] / 2, 0, 1) * o[2] / t.sqrt(o[3])) : t.abs(e.normal.inv(o[1] / 2, 0, 1) * e.stdev(o[2]) / t.sqrt(o[2].length)), i[0] = o[0] - r, i[1] = o[0] + r, i;
                                    },
                                    tci: function() {
                                        var r, o = n.call(arguments), i = new Array(2);
                                        return r = 4 === o.length ? t.abs(e.studentt.inv(o[1] / 2, o[3] - 1) * o[2] / t.sqrt(o[3])) : t.abs(e.studentt.inv(o[1] / 2, o[2].length - 1) * e.stdev(o[2], !0) / t.sqrt(o[2].length)), i[0] = o[0] - r, i[1] = o[0] + r, i;
                                    },
                                    significant: function(e, t) {
                                        return e < t;
                                    }
                                }), e.extend(e.fn, {
                                    normalci: function(t, n) {
                                        return e.normalci(t, n, this.toArray());
                                    },
                                    tci: function(t, n) {
                                        return e.tci(t, n, this.toArray());
                                    }
                                }), e.extend(e.fn, {
                                    oneSidedDifferenceOfProportions: function(t, n, r, o) {
                                        var s = i(t, n, r, o);
                                        return e.ztest(s, 1);
                                    },
                                    twoSidedDifferenceOfProportions: function(t, n, r, o) {
                                        var s = i(t, n, r, o);
                                        return e.ztest(s, 2);
                                    }
                                });
                            }(t, Math), t.models = function() {
                                function e(e, n) {
                                    var r = e.length, o = n[0].length - 1, i = r - o - 1, s = t.lstsq(n, e), l = t.multiply(n, s.map(function(e) {
                                        return [
                                            e
                                        ];
                                    })).map(function(e) {
                                        return e[0];
                                    }), a = t.subtract(e, l), u = t.mean(e), c = t.sum(l.map(function(e) {
                                        return Math.pow(e - u, 2);
                                    })), f = t.sum(e.map(function(e, t) {
                                        return Math.pow(e - l[t], 2);
                                    })), d = c + f;
                                    return {
                                        exog: n,
                                        endog: e,
                                        nobs: r,
                                        df_model: o,
                                        df_resid: i,
                                        coef: s,
                                        predict: l,
                                        resid: a,
                                        ybar: u,
                                        SST: d,
                                        SSE: c,
                                        SSR: f,
                                        R2: c / d
                                    };
                                }
                                return {
                                    ols: function(n, r) {
                                        var o = e(n, r), i = function(n) {
                                            var r, o, i = (r = n.exog, o = r[0].length, t.arange(o).map(function(n) {
                                                var i = t.arange(o).filter(function(e) {
                                                    return e !== n;
                                                });
                                                return e(t.col(r, n).map(function(e) {
                                                    return e[0];
                                                }), t.col(r, i));
                                            })), s = Math.sqrt(n.SSR / n.df_resid), l = i.map(function(e) {
                                                var t = e.SST, n = e.R2;
                                                return s / Math.sqrt(t * (1 - n));
                                            }), a = n.coef.map(function(e, t) {
                                                return (e - 0) / l[t];
                                            }), u = a.map(function(e) {
                                                var r = t.studentt.cdf(e, n.df_resid);
                                                return 2 * (r > .5 ? 1 - r : r);
                                            }), c = t.studentt.inv(.975, n.df_resid), f = n.coef.map(function(e, t) {
                                                var n = c * l[t];
                                                return [
                                                    e - n,
                                                    e + n
                                                ];
                                            });
                                            return {
                                                se: l,
                                                t: a,
                                                p: u,
                                                sigmaHat: s,
                                                interval95: f
                                            };
                                        }(o), s = function(e) {
                                            var n, r, o, i = e.R2 / e.df_model / ((1 - e.R2) / e.df_resid);
                                            return {
                                                F_statistic: i,
                                                pvalue: 1 - (n = i, r = e.df_model, o = e.df_resid, t.beta.cdf(n / (o / r + n), r / 2, o / 2))
                                            };
                                        }(o), l = 1 - (1 - o.R2) * ((o.nobs - 1) / o.df_resid);
                                        return o.t = i, o.f = s, o.adjust_R2 = l, o;
                                    }
                                };
                            }(), t.extend({
                                buildxmatrix: function() {
                                    for(var e = new Array(arguments.length), n = 0; n < arguments.length; n++)e[n] = [
                                        1
                                    ].concat(arguments[n]);
                                    return t(e);
                                },
                                builddxmatrix: function() {
                                    for(var e = new Array(arguments[0].length), n = 0; n < arguments[0].length; n++)e[n] = [
                                        1
                                    ].concat(arguments[0][n]);
                                    return t(e);
                                },
                                buildjxmatrix: function(e) {
                                    for(var n = new Array(e.length), r = 0; r < e.length; r++)n[r] = e[r];
                                    return t.builddxmatrix(n);
                                },
                                buildymatrix: function(e) {
                                    return t(e).transpose();
                                },
                                buildjymatrix: function(e) {
                                    return e.transpose();
                                },
                                matrixmult: function(e, n) {
                                    var r, o, i, s, l;
                                    if (e.cols() == n.rows()) {
                                        if (n.rows() > 1) {
                                            for(s = [], r = 0; r < e.rows(); r++)for(s[r] = [], o = 0; o < n.cols(); o++){
                                                for(l = 0, i = 0; i < e.cols(); i++)l += e.toArray()[r][i] * n.toArray()[i][o];
                                                s[r][o] = l;
                                            }
                                            return t(s);
                                        }
                                        for(s = [], r = 0; r < e.rows(); r++)for(s[r] = [], o = 0; o < n.cols(); o++){
                                            for(l = 0, i = 0; i < e.cols(); i++)l += e.toArray()[r][i] * n.toArray()[o];
                                            s[r][o] = l;
                                        }
                                        return t(s);
                                    }
                                },
                                regress: function(e, n) {
                                    var r = t.xtranspxinv(e), o = e.transpose(), i = t.matrixmult(t(r), o);
                                    return t.matrixmult(i, n);
                                },
                                regresst: function(e, n, r) {
                                    var o = t.regress(e, n), i = {
                                        anova: {}
                                    }, s = t.jMatYBar(e, o);
                                    i.yBar = s;
                                    var l = n.mean();
                                    i.anova.residuals = t.residuals(n, s), i.anova.ssr = t.ssr(s, l), i.anova.msr = i.anova.ssr / (e[0].length - 1), i.anova.sse = t.sse(n, s), i.anova.mse = i.anova.sse / (n.length - (e[0].length - 1) - 1), i.anova.sst = t.sst(n, l), i.anova.mst = i.anova.sst / (n.length - 1), i.anova.r2 = 1 - i.anova.sse / i.anova.sst, i.anova.r2 < 0 && (i.anova.r2 = 0), i.anova.fratio = i.anova.msr / i.anova.mse, i.anova.pvalue = t.anovaftest(i.anova.fratio, e[0].length - 1, n.length - (e[0].length - 1) - 1), i.anova.rmse = Math.sqrt(i.anova.mse), i.anova.r2adj = 1 - i.anova.mse / i.anova.mst, i.anova.r2adj < 0 && (i.anova.r2adj = 0), i.stats = new Array(e[0].length);
                                    for(var a, u, c, f = t.xtranspxinv(e), d = 0; d < o.length; d++)a = Math.sqrt(i.anova.mse * Math.abs(f[d][d])), u = Math.abs(o[d] / a), c = t.ttest(u, n.length - e[0].length - 1, r), i.stats[d] = [
                                        o[d],
                                        a,
                                        u,
                                        c
                                    ];
                                    return i.regress = o, i;
                                },
                                xtranspx: function(e) {
                                    return t.matrixmult(e.transpose(), e);
                                },
                                xtranspxinv: function(e) {
                                    var n = t.matrixmult(e.transpose(), e);
                                    return t.inv(n);
                                },
                                jMatYBar: function(e, n) {
                                    var r = t.matrixmult(e, n);
                                    return new t(r);
                                },
                                residuals: function(e, n) {
                                    return t.matrixsubtract(e, n);
                                },
                                ssr: function(e, t) {
                                    for(var n = 0, r = 0; r < e.length; r++)n += Math.pow(e[r] - t, 2);
                                    return n;
                                },
                                sse: function(e, t) {
                                    for(var n = 0, r = 0; r < e.length; r++)n += Math.pow(e[r] - t[r], 2);
                                    return n;
                                },
                                sst: function(e, t) {
                                    for(var n = 0, r = 0; r < e.length; r++)n += Math.pow(e[r] - t, 2);
                                    return n;
                                },
                                matrixsubtract: function(e, n) {
                                    for(var r = new Array(e.length), o = 0; o < e.length; o++){
                                        r[o] = new Array(e[o].length);
                                        for(var i = 0; i < e[o].length; i++)r[o][i] = e[o][i] - n[o][i];
                                    }
                                    return t(r);
                                }
                            }), t.jStat = t, t);
                        },
                        960: function(e, t, n) {
                            const r = n(592);
                            e.exports = function(e) {
                                function t(e, t) {
                                    const n = t.split(".");
                                    let r = e;
                                    for (const e of n){
                                        if (null == r) return;
                                        r = r[e];
                                    }
                                    return r;
                                }
                                for(let n = 0; n < Object.keys(r).length; n++){
                                    let o, i = Object.keys(r)[n], s = [];
                                    if ("object" == typeof r[i]) {
                                        s = Object.keys(r[i]), o = Object.values(r[i]);
                                        for(let e = 0; e < o.length; e++)if ("object" == typeof o[e]) {
                                            let t = s[e];
                                            r[i][t] && (s = [
                                                ...s,
                                                ...Object.keys(r[i][t]).map((e)=>t + "." + e)
                                            ], s.splice(s.indexOf(t), 1));
                                        }
                                    }
                                    if (s.length < 1) e[i] = r[i];
                                    else for(let n = 0; n < s.length; n++)"function" == typeof t(r[i], s[n]) && (e[i] = t(r[i], s[n]));
                                }
                                let n = function(e) {
                                    return "number" == typeof e && (e = parseInt(e)), e;
                                }, o = null, i = null, s = null;
                                e.TABLE = function() {
                                    return s;
                                }, e.COLUMN = e.COL = function() {
                                    return s.tracking && s.tracking.push(u.getColumnNameFromCoords(n(o), n(i))), n(o) + 1;
                                }, e.ROW = function() {
                                    return s.tracking && s.tracking.push(u.getColumnNameFromCoords(n(o), n(i))), n(i) + 1;
                                }, e.CELL = function() {
                                    return u.getColumnNameFromCoords(o, i);
                                }, e.VALUE = function(e, t, r) {
                                    return s.getValueFromCoords(n(e) - 1, n(t) - 1, r);
                                }, e.THISROWCELL = function(e) {
                                    return s.getValueFromCoords(n(e) - 1, n(i));
                                };
                                const l = function(e, t) {
                                    for(let n = 0; n < e.length; n++){
                                        let r = u.getTokensFromRange(e[n]);
                                        t = t.replace(e[n], "[" + r.join(",") + "]");
                                    }
                                    return t;
                                }, a = function(e) {
                                    return "string" == typeof e && (e = e.trim()), !isNaN(e) && null !== e && "" !== e;
                                }, u = function(e, t, n, r, u) {
                                    s = u, o = n, i = r;
                                    let c = "", f = {};
                                    if (t) {
                                        if (t.size) {
                                            let e, n = null;
                                            t.forEach(function(t, n) {
                                                e = n.replace(/!/g, "."), -1 !== e.indexOf(".") && (e = e.split("."), f[e[0]] = !0);
                                            }), e = Object.keys(f);
                                            for(let t = 0; t < e.length; t++)c += "var " + e[t] + " = {};";
                                            t.forEach(function(r, o) {
                                                e = o.replace(/!/g, "."), null === r || a(r) || (n = r.match(/(('.*?'!)|(\w*!))?(\$?[A-Z]+\$?[0-9]*):(\$?[A-Z]+\$?[0-9]*)?/g), n && n.length && (r = updateRanges(n, r))), e.indexOf(".") > 0 ? c += e + " = " + t.get(o) + ";\n" : c += "var " + e + " = " + r + ";\n";
                                            });
                                        } else {
                                            let e = Object.keys(t);
                                            if (e.length) {
                                                let n, r = {};
                                                for(let t = 0; t < e.length; t++)if (n = e[t].replace(/\!/g, "."), n.indexOf(".") > 0) {
                                                    let e = e.split(".");
                                                    r[e[0]] = {};
                                                }
                                                n = Object.keys(r);
                                                for(let e = 0; e < n.length; e++)c += "var " + n[e] + " = {};";
                                                for(let r = 0; r < e.length; r++){
                                                    if (n = e[r].replace(/!/g, "."), null !== t[e[r]] && !a(t[e[r]])) {
                                                        let n = t[e[r]].match(/(('.*?'!)|(\w*!))?(\$?[A-Z]+\$?[0-9]*):(\$?[A-Z]+\$?[0-9]*)?/g);
                                                        n && n.length && (t[e[r]] = l(n, t[e[r]]));
                                                    }
                                                    n.indexOf(".") > 0 ? c += n + " = " + t[e[r]] + ";\n" : c += "var " + n + " = " + t[e[r]] + ";\n";
                                                }
                                            }
                                        }
                                    }
                                    let d = (e = function(e) {
                                        let t = "", n = 0, r = [
                                            "=",
                                            "!",
                                            ">",
                                            "<"
                                        ];
                                        for(let o = 0; o < e.length; o++)'"' === e[o] && (n = 0 === n ? 1 : 0), 1 === n ? t += e[o] : (t += e[o].toUpperCase(), o > 0 && "=" === e[o] && -1 === r.indexOf(e[o - 1]) && -1 === r.indexOf(e[o + 1]) && (t += "="));
                                        return t = t.replace(/\^/g, "**"), t = t.replace(/<>/g, "!="), t = t.replace(/&/g, "+"), t = t.replace(/\$/g, ""), t;
                                    }(e = (e = e.replace(/\$/g, "")).replace(/!/g, "."))).match(/(('.*?'!)|(\w*!))?(\$?[A-Z]+\$?[0-9]*):(\$?[A-Z]+\$?[0-9]*)?/g);
                                    d && d.length && (e = l(d, e));
                                    let p = new Function(c + "; return " + e)();
                                    return null === p && (p = 0), p;
                                };
                                return u.getColumnNameFromCoords = function(e, t) {
                                    var n, r;
                                    return r = "", (n = parseInt(e)) > 701 ? (r += String.fromCharCode(64 + parseInt(n / 676)), r += String.fromCharCode(64 + parseInt(n % 676 / 26))) : n > 25 && (r += String.fromCharCode(64 + parseInt(n / 26))), r + String.fromCharCode(65 + n % 26) + (parseInt(t) + 1);
                                }, u.getCoordsFromColumnName = function(e) {
                                    var t = /^[a-zA-Z]+/.exec(e);
                                    if (t) {
                                        for(var n = 0, r = 0; r < t[0].length; r++)n += parseInt(t[0].charCodeAt(r) - 64) * Math.pow(26, t[0].length - 1 - r);
                                        --n < 0 && (n = 0);
                                        var o = parseInt(/[0-9]+$/.exec(e)) || null;
                                        return o > 0 && o--, [
                                            n,
                                            o
                                        ];
                                    }
                                }, u.getRangeFromTokens = function(e) {
                                    e = e.filter(function(e) {
                                        return "#REF!" != e;
                                    });
                                    for(var t = "", n = "", r = 0; r < e.length; r++)e[r].indexOf(".") >= 0 ? t = "." : e[r].indexOf("!") >= 0 && (t = "!"), t && (n = e[r].split(t), e[r] = n[1], n = n[0] + t);
                                    return e.sort(function(e, t) {
                                        var n = Helpers.getCoordsFromColumnName(e), r = Helpers.getCoordsFromColumnName(t);
                                        return n[1] > r[1] ? 1 : n[1] < r[1] ? -1 : n[0] > r[0] ? 1 : n[0] < r[0] ? -1 : 0;
                                    }), e.length ? n + (e[0] + ":") + e[e.length - 1] : "#REF!";
                                }, u.getTokensFromRange = function(e) {
                                    if (e.indexOf(".") > 0) {
                                        var t = e.split(".");
                                        e = t[1], t = t[0] + ".";
                                    } else e.indexOf("!") > 0 ? (t = e.split("!"), e = t[1], t = t[0] + "!") : t = "";
                                    e = e.split(":");
                                    var n = u.getCoordsFromColumnName(e[0]), r = u.getCoordsFromColumnName(e[1]);
                                    if (n[0] <= r[0]) var o = n[0], i = r[0];
                                    else o = r[0], i = n[0];
                                    if (null === n[1] && null == r[1]) for(var s = null, l = null, a = Object.keys(vars), c = 0; c < a.length; c++){
                                        var f = u.getCoordsFromColumnName(a[c]);
                                        f[0] === n[0] && (null === s || f[1] < s) && (s = f[1]), f[0] === r[0] && (null === l || f[1] > l) && (l = f[1]);
                                    }
                                    else n[1] <= r[1] ? (s = n[1], l = r[1]) : (s = r[1], l = n[1]);
                                    for(var d = [], p = s; p <= l; p++){
                                        var h = [];
                                        for(c = o; c <= i; c++)h.push(t + u.getColumnNameFromCoords(c, p));
                                        d.push(h);
                                    }
                                    return d;
                                }, u.setFormula = function(t) {
                                    let n = Object.keys(t);
                                    for(let r = 0; r < n.length; r++)"function" == typeof t[n[r]] && (e[n[r]] = t[n[r]]);
                                }, u.basic = !0, u;
                            }("undefined" == typeof window ? n.g : window);
                        },
                        592: function(e, t, n) {
                            "use strict";
                            var r = n(162), o = n(765);
                            const i = new Error("#NULL!"), s = new Error("#DIV/0!"), l = new Error("#VALUE!"), a = new Error("#REF!"), u = new Error("#NAME?"), c = new Error("#NUM!"), f = new Error("#N/A"), d = new Error("#ERROR!"), p = new Error("#GETTING_DATA");
                            var h = Object.freeze({
                                __proto__: null,
                                data: p,
                                div0: s,
                                error: d,
                                na: f,
                                name: u,
                                nil: i,
                                num: c,
                                ref: a,
                                value: l
                            });
                            function g(e) {
                                const t = [];
                                return m(e, (e)=>{
                                    t.push(e);
                                }), t;
                            }
                            function m(e, t) {
                                let n = -1;
                                const r = e.length;
                                for(; ++n < r && !1 !== t(e[n], n, e););
                                return e;
                            }
                            function v(e) {
                                let t, n = e.length;
                                for(; n--;)if (t = e[n], "number" != typeof t) {
                                    if (!0 !== t) {
                                        if (!1 !== t) {
                                            if ("string" == typeof t) {
                                                const r = L(t);
                                                e[n] = r instanceof Error ? 0 : r;
                                            }
                                        } else e[n] = 0;
                                    } else e[n] = 1;
                                }
                                return e;
                            }
                            function y(e, t) {
                                if (!e) return l;
                                e.every((e)=>Array.isArray(e)) && 0 !== e.length || (e = [
                                    [
                                        ...e
                                    ]
                                ]), e.map((t, n)=>{
                                    t.map((t, r)=>{
                                        t || (e[n][r] = 0);
                                    });
                                });
                                const n = e.reduce((t, n, r)=>n.length > e[t].length ? r : t, 0), r = e[n].length;
                                return e.map((e)=>[
                                        ...e,
                                        ...Array(r - e.length).fill(t || 0)
                                    ]);
                            }
                            function C() {
                                let e;
                                if (1 === arguments.length) {
                                    const n = arguments[0];
                                    e = null != (t = n) && "number" == typeof t.length && "string" != typeof t ? g.apply(null, arguments) : [
                                        n
                                    ];
                                } else e = Array.from(arguments);
                                for(var t; !b(e);)e = w(e);
                                return e;
                            }
                            function w(e) {
                                return e && e.reduce ? e.reduce((e, t)=>{
                                    const n = Array.isArray(e), r = Array.isArray(t);
                                    return n && r ? e.concat(t) : n ? (e.push(t), e) : r ? [
                                        e
                                    ].concat(t) : [
                                        e,
                                        t
                                    ];
                                }) : [
                                    e
                                ];
                            }
                            function b(e) {
                                if (!e) return !1;
                                for(let t = 0; t < e.length; ++t)if (Array.isArray(e[t])) return !1;
                                return !0;
                            }
                            function A(e, t) {
                                return t = t || 1, e && "function" == typeof e.slice ? e.slice(t) : e;
                            }
                            function E(e) {
                                return e ? e[0].map((t, n)=>e.map((e)=>e[n])) : l;
                            }
                            function M(e, t) {
                                let n = null;
                                return m(e, (e, r)=>{
                                    if (e[0] === t) return n = r, !1;
                                }), null == n ? l : n;
                            }
                            function I() {
                                for(let e = 0; e < arguments.length; e++)if (arguments[e] instanceof Error) return arguments[e];
                            }
                            function N() {
                                let e = arguments.length;
                                for(; e--;)if (arguments[e] instanceof Error) return !0;
                                return !1;
                            }
                            function x(e) {
                                const t = 1e14;
                                return Math.round(e * t) / t;
                            }
                            function S() {
                                return C.apply(null, arguments).filter((e)=>"number" == typeof e);
                            }
                            function D(e) {
                                if ("boolean" == typeof e) return e;
                                if (e instanceof Error) return e;
                                if ("number" == typeof e) return 0 !== e;
                                if ("string" == typeof e) {
                                    const t = e.toUpperCase();
                                    if ("TRUE" === t) return !0;
                                    if ("FALSE" === t) return !1;
                                }
                                return e instanceof Date && !isNaN(e) || l;
                            }
                            function T(e) {
                                if (!isNaN(e)) {
                                    if (e instanceof Date) return new Date(e);
                                    const t = parseFloat(e);
                                    return t < 0 || t >= 2958466 ? c : function(e) {
                                        e < 60 && (e += 1);
                                        const t = Math.floor(e - 25569), n = new Date(86400 * t * 1e3), r = e - Math.floor(e) + 1e-7;
                                        let o = Math.floor(86400 * r);
                                        const i = o % 60;
                                        o -= i;
                                        const s = Math.floor(o / 3600), l = Math.floor(o / 60) % 60;
                                        let a = n.getUTCDate(), u = n.getUTCMonth();
                                        return e >= 60 && e < 61 && (a = 29, u = 1), new Date(n.getUTCFullYear(), u, a, s, l, i);
                                    }(t);
                                }
                                return "string" != typeof e || (e = /(\d{4})-(\d\d?)-(\d\d?)$/.test(e) ? new Date(e + "T00:00:00.000") : new Date(e), isNaN(e)) ? l : e;
                            }
                            function F(e) {
                                let t, n = e.length;
                                for(; n--;){
                                    if (t = T(e[n]), t === l) return t;
                                    e[n] = t;
                                }
                                return e;
                            }
                            function L(e) {
                                return e instanceof Error ? e : null == e ? 0 : ("boolean" == typeof e && (e = +e), isNaN(e) || "" === e ? l : parseFloat(e));
                            }
                            function R(e) {
                                let t, n;
                                if (!e || 0 === (t = e.length)) return l;
                                for(; t--;){
                                    if (e[t] instanceof Error) return e[t];
                                    if (n = L(e[t]), n instanceof Error) return n;
                                    e[t] = n;
                                }
                                return e;
                            }
                            function O(e) {
                                return e instanceof Error ? e : null == e ? "" : e.toString();
                            }
                            function H() {
                                let e = arguments.length;
                                for(; e--;)if ("string" == typeof arguments[e]) return !0;
                                return !1;
                            }
                            function B(e) {
                                return null != e;
                            }
                            const j = "=", k = [
                                ">",
                                ">=",
                                "<",
                                "<=",
                                "=",
                                "<>"
                            ], P = "operator", V = "literal", _ = [
                                P,
                                V
                            ], U = P, q = V;
                            function z(e, t) {
                                if (-1 === _.indexOf(t)) throw new Error("Unsupported token type: " + t);
                                return {
                                    value: e,
                                    type: t
                                };
                            }
                            function Y(e) {
                                return function(e) {
                                    let t = "";
                                    const n = [];
                                    for(let r = 0; r < e.length; r++){
                                        const o = e[r];
                                        0 === r && k.indexOf(o) >= 0 ? n.push(z(o, U)) : t += o;
                                    }
                                    return t.length > 0 && n.push(z(function(e) {
                                        return "string" != typeof e || /^\d+(\.\d+)?$/.test(e) && (e = -1 === e.indexOf(".") ? parseInt(e, 10) : parseFloat(e)), e;
                                    }(t), q)), n.length > 0 && n[0].type !== U && n.unshift(z(j, U)), n;
                                }(function(e) {
                                    const t = e.length, n = [];
                                    let r = 0, o = "", i = "";
                                    for(; r < t;){
                                        const t = e.charAt(r);
                                        switch(t){
                                            case ">":
                                            case "<":
                                            case "=":
                                                i += t, o.length > 0 && (n.push(o), o = "");
                                                break;
                                            default:
                                                i.length > 0 && (n.push(i), i = ""), o += t;
                                        }
                                        r++;
                                    }
                                    return o.length > 0 && n.push(o), i.length > 0 && n.push(i), n;
                                }(e));
                            }
                            const W = function(e) {
                                const t = [];
                                let n;
                                for(let r = 0; r < e.length; r++){
                                    const o = e[r];
                                    switch(o.type){
                                        case U:
                                            n = o.value;
                                            break;
                                        case q:
                                            t.push(o.value);
                                    }
                                }
                                return function(e, t) {
                                    let n = !1;
                                    switch(t){
                                        case ">":
                                            n = e[0] > e[1];
                                            break;
                                        case ">=":
                                            n = e[0] >= e[1];
                                            break;
                                        case "<":
                                            n = e[0] < e[1];
                                            break;
                                        case "<=":
                                            n = e[0] <= e[1];
                                            break;
                                        case "=":
                                            n = e[0] == e[1];
                                            break;
                                        case "<>":
                                            n = e[0] != e[1];
                                    }
                                    return n;
                                }(t, n);
                            }, X = {};
                            function G(e) {
                                return [
                                    l,
                                    a,
                                    s,
                                    c,
                                    u,
                                    i
                                ].indexOf(e) >= 0 || "number" == typeof e && (isNaN(e) || !isFinite(e));
                            }
                            function K(e) {
                                return G(e) || e === f;
                            }
                            function $1(e) {
                                return !0 === e || !1 === e;
                            }
                            function J(e) {
                                return "number" == typeof e && !isNaN(e) && isFinite(e);
                            }
                            function Q(e) {
                                return "string" == typeof e;
                            }
                            function Z() {
                                const e = [];
                                for(let t = 0; t < arguments.length; ++t){
                                    let n = !1;
                                    const r = arguments[t];
                                    for(let t = 0; t < e.length && (n = e[t] === r, !n); ++t);
                                    n || e.push(r);
                                }
                                return e;
                            }
                            function ee(e, t, n, r) {
                                if (!t || !n) return f;
                                r = !(0 === r || !1 === r);
                                let o = f;
                                const i = "number" == typeof e;
                                let s = !1;
                                for(let l = 0; l < t.length; l++){
                                    const u = t[l];
                                    if (u[0] === e) {
                                        o = n < u.length + 1 ? u[n - 1] : a;
                                        break;
                                    }
                                    !s && (i && r && u[0] <= e || r && "string" == typeof u[0] && u[0].localeCompare(e) < 0) && (o = n < u.length + 1 ? u[n - 1] : a), i && u[0] > e && (s = !0);
                                }
                                return o;
                            }
                            function te() {
                                const e = C(arguments).filter(B);
                                if (0 === e.length) return s;
                                const t = I.apply(void 0, e);
                                if (t) return t;
                                const n = S(e), r = n.length;
                                let o, i = 0, l = 0;
                                for(let e = 0; e < r; e++)i += n[e], l += 1;
                                return o = i / l, isNaN(o) && (o = c), o;
                            }
                            function ne() {
                                const e = C(arguments).filter(B);
                                if (0 === e.length) return s;
                                const t = I.apply(void 0, e);
                                if (t) return t;
                                const n = e, r = n.length;
                                let o, i = 0, l = 0;
                                for(let e = 0; e < r; e++){
                                    const t = n[e];
                                    "number" == typeof t && (i += t), !0 === t && i++, null !== t && l++;
                                }
                                return o = i / l, isNaN(o) && (o = c), o;
                            }
                            X.TYPE = (e)=>{
                                switch(e){
                                    case i:
                                        return 1;
                                    case s:
                                        return 2;
                                    case l:
                                        return 3;
                                    case a:
                                        return 4;
                                    case u:
                                        return 5;
                                    case c:
                                        return 6;
                                    case f:
                                        return 7;
                                    case p:
                                        return 8;
                                }
                                return f;
                            };
                            const re = {
                                DIST: function(e, t, n, o, i, s) {
                                    return arguments.length < 4 ? l : (i = void 0 === i ? 0 : i, s = void 0 === s ? 1 : s, N(e = L(e), t = L(t), n = L(n), i = L(i), s = L(s)) ? l : (e = (e - i) / (s - i), o ? r.beta.cdf(e, t, n) : r.beta.pdf(e, t, n)));
                                },
                                INV: (e, t, n, o, i)=>(o = void 0 === o ? 0 : o, i = void 0 === i ? 1 : i, N(e = L(e), t = L(t), n = L(n), o = L(o), i = L(i)) ? l : r.beta.inv(e, t, n) * (i - o) + o)
                            }, oe = {
                                DIST: (e, t, n, o)=>N(e = L(e), t = L(t), n = L(n), o = L(o)) ? l : o ? r.binomial.cdf(e, t, n) : r.binomial.pdf(e, t, n)
                            };
                            oe.DIST.RANGE = (e, t, n, r)=>{
                                if (r = void 0 === r ? n : r, N(e = L(e), t = L(t), n = L(n), r = L(r))) return l;
                                let o = 0;
                                for(let i = n; i <= r; i++)o += Ue(e, i) * Math.pow(t, i) * Math.pow(1 - t, e - i);
                                return o;
                            }, oe.INV = (e, t, n)=>{
                                if (N(e = L(e), t = L(t), n = L(n))) return l;
                                let o = 0;
                                for(; o <= e;){
                                    if (r.binomial.cdf(o, e, t) >= n) return o;
                                    o++;
                                }
                            };
                            const ie = {
                                DIST: (e, t, n)=>N(e = L(e), t = L(t)) ? l : n ? r.chisquare.cdf(e, t) : r.chisquare.pdf(e, t)
                            };
                            ie.DIST.RT = (e, t)=>!e | !t ? f : e < 1 || t > Math.pow(10, 10) ? c : "number" != typeof e || "number" != typeof t ? l : 1 - r.chisquare.cdf(e, t), ie.INV = (e, t)=>N(e = L(e), t = L(t)) ? l : r.chisquare.inv(e, t), ie.INV.RT = (e, t)=>!e | !t ? f : e < 0 || e > 1 || t < 1 || t > Math.pow(10, 10) ? c : "number" != typeof e || "number" != typeof t ? l : r.chisquare.inv(1 - e, t), ie.TEST = function(e, t) {
                                if (2 !== arguments.length) return f;
                                if (!(e instanceof Array && t instanceof Array)) return l;
                                if (e.length !== t.length) return l;
                                if (e[0] && t[0] && e[0].length !== t[0].length) return l;
                                const n = e.length;
                                let r, o, i;
                                for(o = 0; o < n; o++)e[o] instanceof Array || (r = e[o], e[o] = [], e[o].push(r)), t[o] instanceof Array || (r = t[o], t[o] = [], t[o].push(r));
                                const s = e[0].length, a = 1 === s ? n - 1 : (n - 1) * (s - 1);
                                let u = 0;
                                const c = Math.PI;
                                for(o = 0; o < n; o++)for(i = 0; i < s; i++)u += Math.pow(e[o][i] - t[o][i], 2) / t[o][i];
                                return Math.round(1e6 * function(e, t) {
                                    let n = Math.exp(-0.5 * e);
                                    t % 2 == 1 && (n *= Math.sqrt(2 * e / c));
                                    let r = t;
                                    for(; r >= 2;)n = n * e / r, r -= 2;
                                    let o = n, i = t;
                                    for(; o > 1e-10 * n;)i += 2, o = o * e / i, n += o;
                                    return 1 - n;
                                }(u, a)) / 1e6;
                            };
                            const se = {};
                            function le() {
                                return S(C(arguments)).length;
                            }
                            function ae() {
                                const e = C(arguments);
                                return e.length - ue(e);
                            }
                            function ue() {
                                const e = C(arguments);
                                let t, n = 0;
                                for(let r = 0; r < e.length; r++)t = e[r], null != t && "" !== t || n++;
                                return n;
                            }
                            se.NORM = (e, t, n)=>N(e = L(e), t = L(t), n = L(n)) ? l : r.normalci(1, e, t, n)[1] - 1, se.T = (e, t, n)=>N(e = L(e), t = L(t), n = L(n)) ? l : r.tci(1, e, t, n)[1] - 1;
                            const ce = {
                                P: (e, t)=>{
                                    if (N(e = R(C(e)), t = R(C(t)))) return l;
                                    const n = r.mean(e), o = r.mean(t);
                                    let i = 0;
                                    const s = e.length;
                                    for(let r = 0; r < s; r++)i += (e[r] - n) * (t[r] - o);
                                    return i / s;
                                },
                                S: (e, t)=>N(e = R(C(e)), t = R(C(t))) ? l : r.covariance(e, t)
                            }, fe = {
                                DIST: (e, t, n)=>N(e = L(e), t = L(t)) ? l : n ? r.exponential.cdf(e, t) : r.exponential.pdf(e, t)
                            }, de = {};
                            function pe(e, t, n) {
                                if (N(e = L(e), t = R(C(t)), n = R(C(n)))) return l;
                                const o = r.mean(n), i = r.mean(t), s = n.length;
                                let a = 0, u = 0;
                                for(let e = 0; e < s; e++)a += (n[e] - o) * (t[e] - i), u += Math.pow(n[e] - o, 2);
                                const c = a / u;
                                return i - c * o + c * e;
                            }
                            function he(e) {
                                return (e = L(e)) instanceof Error ? e : 0 === e || parseInt(e, 10) === e && e < 0 ? c : r.gammafn(e);
                            }
                            function ge(e) {
                                return (e = L(e)) instanceof Error ? e : r.gammaln(e);
                            }
                            de.DIST = (e, t, n, o)=>N(e = L(e), t = L(t), n = L(n)) ? l : o ? r.centralF.cdf(e, t, n) : r.centralF.pdf(e, t, n), de.DIST.RT = function(e, t, n) {
                                return 3 !== arguments.length ? f : e < 0 || t < 1 || n < 1 ? c : "number" != typeof e || "number" != typeof t || "number" != typeof n ? l : 1 - r.centralF.cdf(e, t, n);
                            }, de.INV = (e, t, n)=>N(e = L(e), t = L(t), n = L(n)) ? l : e <= 0 || e > 1 ? c : r.centralF.inv(e, t, n), de.INV.RT = function(e, t, n) {
                                return 3 !== arguments.length ? f : e < 0 || e > 1 || t < 1 || t > Math.pow(10, 10) || n < 1 || n > Math.pow(10, 10) ? c : "number" != typeof e || "number" != typeof t || "number" != typeof n ? l : r.centralF.inv(1 - e, t, n);
                            }, de.TEST = (e, t)=>{
                                if (!e || !t) return f;
                                if (!(e instanceof Array && t instanceof Array)) return f;
                                if (e.length < 2 || t.length < 2) return s;
                                const n = (e, t)=>{
                                    let n = 0;
                                    for(let r = 0; r < e.length; r++)n += Math.pow(e[r] - t, 2);
                                    return n;
                                }, r = $e(e) / e.length, o = $e(t) / t.length;
                                return n(e, r) / (e.length - 1) / (n(t, o) / (t.length - 1));
                            }, he.DIST = function(e, t, n, o) {
                                return 4 !== arguments.length ? f : e < 0 || t <= 0 || n <= 0 || "number" != typeof e || "number" != typeof t || "number" != typeof n ? l : o ? r.gamma.cdf(e, t, n, !0) : r.gamma.pdf(e, t, n, !1);
                            }, he.INV = function(e, t, n) {
                                return 3 !== arguments.length ? f : e < 0 || e > 1 || t <= 0 || n <= 0 ? c : "number" != typeof e || "number" != typeof t || "number" != typeof n ? l : r.gamma.inv(e, t, n);
                            }, ge.PRECISE = function(e) {
                                return 1 !== arguments.length ? f : e <= 0 ? c : "number" != typeof e ? l : r.gammaln(e);
                            };
                            const me = {};
                            function ve(e, t) {
                                return N(e = R(C(e)), t = L(t)) ? e : t < 0 || e.length < t ? l : e.sort((e, t)=>t - e)[t - 1];
                            }
                            function ye(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                const n = r.mean(e), o = r.mean(t), i = t.length;
                                let s = 0, a = 0;
                                for(let r = 0; r < i; r++)s += (t[r] - o) * (e[r] - n), a += Math.pow(t[r] - o, 2);
                                const u = s / a;
                                return [
                                    u,
                                    n - u * o
                                ];
                            }
                            me.DIST = (e, t, n, r, o)=>{
                                if (N(e = L(e), t = L(t), n = L(n), r = L(r))) return l;
                                function i(e, t, n, r) {
                                    return Ue(n, e) * Ue(r - n, t - e) / Ue(r, t);
                                }
                                return o ? function(e, t, n, r) {
                                    let o = 0;
                                    for(let s = 0; s <= e; s++)o += i(s, t, n, r);
                                    return o;
                                }(e, t, n, r) : i(e, t, n, r);
                            };
                            const Ce = {};
                            function we() {
                                const e = C(arguments), t = I.apply(void 0, e);
                                if (t) return t;
                                const n = S(e);
                                return 0 === n.length ? 0 : Math.max.apply(Math, n);
                            }
                            function be() {
                                const e = C(arguments), t = I.apply(void 0, e);
                                if (t) return t;
                                const n = v(e);
                                let o = r.median(n);
                                return isNaN(o) && (o = c), o;
                            }
                            function Ae() {
                                const e = C(arguments), t = I.apply(void 0, e);
                                if (t) return t;
                                const n = S(e);
                                return 0 === n.length ? 0 : Math.min.apply(Math, n);
                            }
                            Ce.DIST = (e, t, n, o)=>N(e = L(e), t = L(t), n = L(n)) ? l : o ? r.lognormal.cdf(e, t, n) : r.lognormal.pdf(e, t, n), Ce.INV = (e, t, n)=>N(e = L(e), t = L(t), n = L(n)) ? l : r.lognormal.inv(e, t, n);
                            const Ee = {
                                MULT: function() {
                                    const e = R(C(arguments));
                                    if (e instanceof Error) return e;
                                    const t = e.length, n = {};
                                    let r, o = [], i = 0;
                                    for(let s = 0; s < t; s++)r = e[s], n[r] = n[r] ? n[r] + 1 : 1, n[r] > i && (i = n[r], o = []), n[r] === i && (o[o.length] = r);
                                    return o;
                                },
                                SNGL: function() {
                                    const e = R(C(arguments));
                                    return e instanceof Error ? e : Ee.MULT(e).sort((e, t)=>e - t)[0];
                                }
                            }, Me = {
                                DIST: (e, t, n, o)=>N(e = L(e), t = L(t), n = L(n)) ? l : o ? r.negbin.cdf(e, t, n) : r.negbin.pdf(e, t, n)
                            }, Ie = {};
                            function Ne(e, t) {
                                if (N(t = R(C(t)), e = R(C(e)))) return l;
                                const n = r.mean(e), o = r.mean(t), i = e.length;
                                let s = 0, a = 0, u = 0;
                                for(let r = 0; r < i; r++)s += (e[r] - n) * (t[r] - o), a += Math.pow(e[r] - n, 2), u += Math.pow(t[r] - o, 2);
                                return s / Math.sqrt(a * u);
                            }
                            Ie.DIST = (e, t, n, o)=>N(e = L(e), t = L(t), n = L(n)) ? l : n <= 0 ? c : o ? r.normal.cdf(e, t, n) : r.normal.pdf(e, t, n), Ie.INV = (e, t, n)=>N(e = L(e), t = L(t), n = L(n)) ? l : r.normal.inv(e, t, n), Ie.S = {}, Ie.S.DIST = (e, t)=>(e = L(e)) instanceof Error ? l : t ? r.normal.cdf(e, 0, 1) : r.normal.pdf(e, 0, 1), Ie.S.INV = (e)=>(e = L(e)) instanceof Error ? l : r.normal.inv(e, 0, 1);
                            const xe = {
                                EXC: (e, t)=>{
                                    if (N(e = R(C(e)), t = L(t))) return l;
                                    const n = (e = e.sort((e, t)=>e - t)).length;
                                    if (t < 1 / (n + 1) || t > 1 - 1 / (n + 1)) return c;
                                    const r = t * (n + 1) - 1, o = Math.floor(r);
                                    return x(r === o ? e[r] : e[o] + (r - o) * (e[o + 1] - e[o]));
                                },
                                INC: (e, t)=>{
                                    if (N(e = R(C(e)), t = L(t))) return l;
                                    const n = t * ((e = e.sort((e, t)=>e - t)).length - 1), r = Math.floor(n);
                                    return x(n === r ? e[n] : e[r] + (n - r) * (e[r + 1] - e[r]));
                                }
                            }, Se = {
                                EXC: (e, t, n)=>{
                                    if (n = void 0 === n ? 3 : n, N(e = R(C(e)), t = L(t), n = L(n))) return l;
                                    e = e.sort((e, t)=>e - t);
                                    const r = Z.apply(null, e), o = e.length, i = r.length, s = Math.pow(10, n);
                                    let a = 0, u = !1, c = 0;
                                    for(; !u && c < i;)t === r[c] ? (a = (e.indexOf(r[c]) + 1) / (o + 1), u = !0) : t >= r[c] && (t < r[c + 1] || c === i - 1) && (a = (e.indexOf(r[c]) + 1 + (t - r[c]) / (r[c + 1] - r[c])) / (o + 1), u = !0), c++;
                                    return Math.floor(a * s) / s;
                                },
                                INC: (e, t, n)=>{
                                    if (n = void 0 === n ? 3 : n, N(e = R(C(e)), t = L(t), n = L(n))) return l;
                                    e = e.sort((e, t)=>e - t);
                                    const r = Z.apply(null, e), o = e.length, i = r.length, s = Math.pow(10, n);
                                    let a = 0, u = !1, c = 0;
                                    for(; !u && c < i;)t === r[c] ? (a = e.indexOf(r[c]) / (o - 1), u = !0) : t >= r[c] && (t < r[c + 1] || c === i - 1) && (a = (e.indexOf(r[c]) + (t - r[c]) / (r[c + 1] - r[c])) / (o - 1), u = !0), c++;
                                    return Math.floor(a * s) / s;
                                }
                            }, De = {
                                DIST: (e, t, n)=>N(e = L(e), t = L(t)) ? l : n ? r.poisson.cdf(e, t) : r.poisson.pdf(e, t)
                            }, Te = {
                                EXC: (e, t)=>{
                                    if (N(e = R(C(e)), t = L(t))) return l;
                                    switch(t){
                                        case 1:
                                            return xe.EXC(e, .25);
                                        case 2:
                                            return xe.EXC(e, .5);
                                        case 3:
                                            return xe.EXC(e, .75);
                                        default:
                                            return c;
                                    }
                                },
                                INC: (e, t)=>{
                                    if (N(e = R(C(e)), t = L(t))) return l;
                                    switch(t){
                                        case 1:
                                            return xe.INC(e, .25);
                                        case 2:
                                            return xe.INC(e, .5);
                                        case 3:
                                            return xe.INC(e, .75);
                                        default:
                                            return c;
                                    }
                                }
                            }, Fe = {};
                            function Le() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = r.mean(e), n = e.length;
                                let o = 0;
                                for(let r = 0; r < n; r++)o += Math.pow(e[r] - t, 3);
                                return n * o / ((n - 1) * (n - 2) * Math.pow(r.stdev(e, !0), 3));
                            }
                            function Re(e, t) {
                                return N(e = R(C(e)), t = L(t)) ? e : e.sort((e, t)=>e - t)[t - 1];
                            }
                            Fe.AVG = (e, t, n)=>{
                                if (N(e = L(e), t = R(C(t)))) return l;
                                const r = (n = n || !1) ? (e, t)=>e - t : (e, t)=>t - e, o = (t = (t = C(t)).sort(r)).length;
                                let i = 0;
                                for(let n = 0; n < o; n++)t[n] === e && i++;
                                return i > 1 ? (2 * t.indexOf(e) + i + 1) / 2 : t.indexOf(e) + 1;
                            }, Fe.EQ = (e, t, n)=>{
                                if (N(e = L(e), t = R(C(t)))) return l;
                                const r = (n = n || !1) ? (e, t)=>e - t : (e, t)=>t - e;
                                return (t = t.sort(r)).indexOf(e) + 1;
                            }, Le.P = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = r.mean(e), n = e.length;
                                let o = 0, i = 0;
                                for(let r = 0; r < n; r++)i += Math.pow(e[r] - t, 3), o += Math.pow(e[r] - t, 2);
                                return i /= n, o /= n, i / Math.pow(o, 1.5);
                            };
                            const Oe = {
                                P: function() {
                                    const e = Be.P.apply(this, arguments);
                                    let t = Math.sqrt(e);
                                    return isNaN(t) && (t = c), t;
                                },
                                S: function() {
                                    const e = Be.S.apply(this, arguments);
                                    return Math.sqrt(e);
                                }
                            }, He = {
                                DIST: (e, t, n)=>1 !== n && 2 !== n ? c : 1 === n ? He.DIST.RT(e, t) : He.DIST["2T"](e, t)
                            };
                            He.DIST["2T"] = function(e, t) {
                                return 2 !== arguments.length ? f : e < 0 || t < 1 ? c : "number" != typeof e || "number" != typeof t ? l : 2 * (1 - r.studentt.cdf(e, t));
                            }, He.DIST.RT = function(e, t) {
                                return 2 !== arguments.length ? f : e < 0 || t < 1 ? c : "number" != typeof e || "number" != typeof t ? l : 1 - r.studentt.cdf(e, t);
                            }, He.INV = (e, t)=>N(e = L(e), t = L(t)) ? l : r.studentt.inv(e, t), He.INV["2T"] = (e, t)=>(e = L(e), t = L(t), e <= 0 || e > 1 || t < 1 ? c : N(e, t) ? l : Math.abs(r.studentt.inv(e / 2, t))), He.TEST = (e, t)=>{
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                const n = r.mean(e), o = r.mean(t);
                                let i, s = 0, a = 0;
                                for(i = 0; i < e.length; i++)s += Math.pow(e[i] - n, 2);
                                for(i = 0; i < t.length; i++)a += Math.pow(t[i] - o, 2);
                                s /= e.length - 1, a /= t.length - 1;
                                const u = Math.abs(n - o) / Math.sqrt(s / e.length + a / t.length);
                                return He.DIST["2T"](u, e.length + t.length - 2);
                            };
                            const Be = {};
                            function je() {
                                const e = C(arguments), t = e.length;
                                let n = 0, r = 0;
                                const o = ne(e);
                                for(let i = 0; i < t; i++){
                                    const t = e[i];
                                    n += "number" == typeof t ? Math.pow(t - o, 2) : !0 === t ? Math.pow(1 - o, 2) : Math.pow(0 - o, 2), null !== t && r++;
                                }
                                return n / (r - 1);
                            }
                            function ke() {
                                const e = C(arguments), t = e.length;
                                let n = 0, r = 0;
                                const o = ne(e);
                                let i;
                                for(let i = 0; i < t; i++){
                                    const t = e[i];
                                    n += "number" == typeof t ? Math.pow(t - o, 2) : !0 === t ? Math.pow(1 - o, 2) : Math.pow(0 - o, 2), null !== t && r++;
                                }
                                return i = n / r, isNaN(i) && (i = c), i;
                            }
                            Be.P = function() {
                                const e = S(C(arguments)), t = e.length;
                                let n = 0;
                                const r = te(e);
                                let o;
                                for(let o = 0; o < t; o++)n += Math.pow(e[o] - r, 2);
                                return o = n / t, isNaN(o) && (o = c), o;
                            }, Be.S = function() {
                                const e = S(C(arguments)), t = e.length;
                                let n = 0;
                                const r = te(e);
                                for(let o = 0; o < t; o++)n += Math.pow(e[o] - r, 2);
                                return n / (t - 1);
                            };
                            const Pe = {
                                DIST: (e, t, n, r)=>N(e = L(e), t = L(t), n = L(n)) ? l : r ? 1 - Math.exp(-Math.pow(e / n, t)) : Math.pow(e, t - 1) * Math.exp(-Math.pow(e / n, t)) * t / Math.pow(n, t)
                            }, Ve = {};
                            function _e(e, t, n) {
                                const r = I(e = L(e), t = L(t), n = L(n));
                                if (r) return r;
                                if (0 === t) return 0;
                                t = Math.abs(t);
                                const o = -Math.floor(Math.log(t) / Math.log(10));
                                return e >= 0 ? Ke(Math.ceil(e / t) * t, o) : 0 === n ? -Ke(Math.floor(Math.abs(e) / t) * t, o) : -Ke(Math.ceil(Math.abs(e) / t) * t, o);
                            }
                            function Ue(e, t) {
                                return I(e = L(e), t = L(t)) || (e < t ? c : ze(e) / (ze(t) * ze(e - t)));
                            }
                            Ve.TEST = (e, t, n)=>{
                                if (N(e = R(C(e)), t = L(t))) return l;
                                n = n || Oe.S(e);
                                const r = e.length;
                                return 1 - Ie.S.DIST((te(e) - t) / (n / Math.sqrt(r)), !0);
                            }, _e.MATH = _e, _e.PRECISE = _e;
                            const qe = [];
                            function ze(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                const t = Math.floor(e);
                                return 0 === t || 1 === t ? 1 : (qe[t] > 0 || (qe[t] = ze(t - 1) * t), qe[t]);
                            }
                            function Ye(e, t) {
                                const n = I(e = L(e), t = L(t));
                                if (n) return n;
                                if (0 === t) return 0;
                                if (!(e >= 0 && t > 0 || e <= 0 && t < 0)) return c;
                                t = Math.abs(t);
                                const r = -Math.floor(Math.log(t) / Math.log(10));
                                return e >= 0 ? Ke(Math.floor(e / t) * t, r) : -Ke(Math.ceil(Math.abs(e) / t), r);
                            }
                            Ye.MATH = (e, t, n)=>{
                                if (t instanceof Error) return t;
                                t = void 0 === t ? 0 : t;
                                const r = I(e = L(e), t = L(t), n = L(n));
                                if (r) return r;
                                if (0 === t) return 0;
                                t = t ? Math.abs(t) : 1;
                                const o = -Math.floor(Math.log(t) / Math.log(10));
                                return e >= 0 ? Ke(Math.floor(e / t) * t, o) : 0 === n || void 0 === n ? -Ke(Math.ceil(Math.abs(e) / t) * t, o) : -Ke(Math.floor(Math.abs(e) / t) * t, o);
                            }, Ye.PRECISE = Ye.MATH;
                            const We = {
                                CEILING: _e
                            };
                            function Xe(e, t) {
                                const n = I(e = L(e), t = L(t));
                                if (n) return n;
                                if (0 === e && 0 === t) return c;
                                const r = Math.pow(e, t);
                                return isNaN(r) ? c : r;
                            }
                            function Ge() {
                                const e = C(arguments).filter((e)=>null != e);
                                if (0 === e.length) return 0;
                                const t = R(e);
                                if (t instanceof Error) return t;
                                let n = 1;
                                for(let e = 0; e < t.length; e++)n *= t[e];
                                return n;
                            }
                            function Ke(e, t) {
                                return I(e = L(e), t = L(t)) || Number(Math.round(Number(e + "e" + t)) + "e" + -1 * t);
                            }
                            function $e() {
                                let e = 0;
                                return m(g(arguments), (t)=>{
                                    if (e instanceof Error) return !1;
                                    if (t instanceof Error) e = t;
                                    else if ("number" == typeof t) e += t;
                                    else if ("string" == typeof t) {
                                        const n = parseFloat(t);
                                        !isNaN(n) && (e += n);
                                    } else if (Array.isArray(t)) {
                                        const n = $e.apply(null, t);
                                        n instanceof Error ? e = n : e += n;
                                    }
                                }), e;
                            }
                            var Je = Object.freeze({
                                __proto__: null,
                                ADD: function(e, t) {
                                    return 2 !== arguments.length ? f : I(e = L(e), t = L(t)) || e + t;
                                },
                                DIVIDE: function(e, t) {
                                    return 2 !== arguments.length ? f : I(e = L(e), t = L(t)) || (0 === t ? s : e / t);
                                },
                                EQ: function(e, t) {
                                    return 2 !== arguments.length ? f : e instanceof Error ? e : t instanceof Error ? t : (null === e && (e = void 0), null === t && (t = void 0), e === t);
                                },
                                GT: function(e, t) {
                                    return 2 !== arguments.length ? f : e instanceof Error ? e : t instanceof Error ? t : (H(e, t) ? (e = O(e), t = O(t)) : (e = L(e), t = L(t)), I(e, t) || e > t);
                                },
                                GTE: function(e, t) {
                                    return 2 !== arguments.length ? f : (H(e, t) ? (e = O(e), t = O(t)) : (e = L(e), t = L(t)), I(e, t) || e >= t);
                                },
                                LT: function(e, t) {
                                    return 2 !== arguments.length ? f : (H(e, t) ? (e = O(e), t = O(t)) : (e = L(e), t = L(t)), I(e, t) || e < t);
                                },
                                LTE: function(e, t) {
                                    return 2 !== arguments.length ? f : (H(e, t) ? (e = O(e), t = O(t)) : (e = L(e), t = L(t)), I(e, t) || e <= t);
                                },
                                MINUS: function(e, t) {
                                    return 2 !== arguments.length ? f : I(e = L(e), t = L(t)) || e - t;
                                },
                                MULTIPLY: function(e, t) {
                                    return 2 !== arguments.length ? f : I(e = L(e), t = L(t)) || e * t;
                                },
                                NE: function(e, t) {
                                    return 2 !== arguments.length ? f : e instanceof Error ? e : t instanceof Error ? t : (null === e && (e = void 0), null === t && (t = void 0), e !== t);
                                },
                                POW: function(e, t) {
                                    return 2 !== arguments.length ? f : Xe(e, t);
                                }
                            });
                            const Qe = new Date(Date.UTC(1900, 0, 1)), Ze = [
                                void 0,
                                0,
                                1,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                void 0,
                                1,
                                2,
                                3,
                                4,
                                5,
                                6,
                                0
                            ], et = [
                                [],
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7
                                ],
                                [
                                    7,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ],
                                [
                                    6,
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ],
                                [],
                                [],
                                [],
                                [],
                                [],
                                [],
                                [],
                                [
                                    7,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ],
                                [
                                    6,
                                    7,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ],
                                [
                                    5,
                                    6,
                                    7,
                                    1,
                                    2,
                                    3,
                                    4
                                ],
                                [
                                    4,
                                    5,
                                    6,
                                    7,
                                    1,
                                    2,
                                    3
                                ],
                                [
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    1,
                                    2
                                ],
                                [
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    1
                                ],
                                [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7
                                ]
                            ], tt = [
                                [],
                                [
                                    6,
                                    0
                                ],
                                [
                                    0,
                                    1
                                ],
                                [
                                    1,
                                    2
                                ],
                                [
                                    2,
                                    3
                                ],
                                [
                                    3,
                                    4
                                ],
                                [
                                    4,
                                    5
                                ],
                                [
                                    5,
                                    6
                                ],
                                void 0,
                                void 0,
                                void 0,
                                [
                                    0,
                                    0
                                ],
                                [
                                    1,
                                    1
                                ],
                                [
                                    2,
                                    2
                                ],
                                [
                                    3,
                                    3
                                ],
                                [
                                    4,
                                    4
                                ],
                                [
                                    5,
                                    5
                                ],
                                [
                                    6,
                                    6
                                ]
                            ];
                            function nt(e, t, n) {
                                n = n.toUpperCase(), e = T(e), t = T(t);
                                const r = e.getFullYear(), o = e.getMonth(), i = e.getDate(), s = t.getFullYear(), l = t.getMonth(), a = t.getDate();
                                let u;
                                switch(n){
                                    case "Y":
                                        u = Math.floor(ft(e, t));
                                        break;
                                    case "D":
                                        u = ot(t, e);
                                        break;
                                    case "M":
                                        u = l - o + 12 * (s - r), a < i && u--;
                                        break;
                                    case "MD":
                                        i <= a ? u = a - i : (0 === l ? (e.setFullYear(s - 1), e.setMonth(12)) : (e.setFullYear(s), e.setMonth(l - 1)), u = ot(t, e));
                                        break;
                                    case "YM":
                                        u = l - o + 12 * (s - r), a < i && u--, u %= 12;
                                        break;
                                    case "YD":
                                        l > o || l === o && a < i ? e.setFullYear(s) : e.setFullYear(s - 1), u = ot(t, e);
                                }
                                return u;
                            }
                            function rt(e) {
                                const t = new Date(e);
                                return t.setHours(0, 0, 0, 0), t;
                            }
                            function ot(e, t) {
                                return e = T(e), t = T(t), e instanceof Error ? e : t instanceof Error ? t : dt(rt(e)) - dt(rt(t));
                            }
                            function it(e, t, n) {
                                if (n = D(n || "false"), e = T(e), t = T(t), e instanceof Error) return e;
                                if (t instanceof Error) return t;
                                if (n instanceof Error) return n;
                                const r = e.getMonth();
                                let o, i, s = t.getMonth();
                                if (n) o = 31 === e.getDate() ? 30 : e.getDate(), i = 31 === t.getDate() ? 30 : t.getDate();
                                else {
                                    const n = new Date(e.getFullYear(), r + 1, 0).getDate(), l = new Date(t.getFullYear(), s + 1, 0).getDate();
                                    o = e.getDate() === n ? 30 : e.getDate(), t.getDate() === l ? o < 30 ? (s++, i = 1) : i = 30 : i = t.getDate();
                                }
                                return 360 * (t.getFullYear() - e.getFullYear()) + 30 * (s - r) + (i - o);
                            }
                            function st(e) {
                                if ((e = T(e)) instanceof Error) return e;
                                (e = rt(e)).setDate(e.getDate() + 4 - (e.getDay() || 7));
                                const t = new Date(e.getFullYear(), 0, 1);
                                return Math.ceil(((e - t) / 864e5 + 1) / 7);
                            }
                            function lt(e, t, n) {
                                return lt.INTL(e, t, 1, n);
                            }
                            function at(e, t, n) {
                                return at.INTL(e, t, 1, n);
                            }
                            function ut(e) {
                                return 1 === new Date(e, 1, 29).getMonth();
                            }
                            function ct(e, t) {
                                return Math.ceil((t - e) / 1e3 / 60 / 60 / 24);
                            }
                            function ft(e, t, n) {
                                if ((e = T(e)) instanceof Error) return e;
                                if ((t = T(t)) instanceof Error) return t;
                                n = n || 0;
                                let r = e.getDate();
                                const o = e.getMonth() + 1, i = e.getFullYear();
                                let s = t.getDate();
                                const l = t.getMonth() + 1, a = t.getFullYear();
                                switch(n){
                                    case 0:
                                        return 31 === r && 31 === s ? (r = 30, s = 30) : 31 === r ? r = 30 : 30 === r && 31 === s && (s = 30), (s + 30 * l + 360 * a - (r + 30 * o + 360 * i)) / 360;
                                    case 1:
                                        {
                                            const n = (e, t)=>{
                                                const n = e.getFullYear(), r = new Date(n, 2, 1);
                                                if (ut(n) && e < r && t >= r) return !0;
                                                const o = t.getFullYear(), i = new Date(o, 2, 1);
                                                return ut(o) && t >= i && e < i;
                                            };
                                            let u = 365;
                                            if (i === a || i + 1 === a && (o > l || o === l && r >= s)) return (i === a && ut(i) || n(e, t) || 1 === l && 29 === s) && (u = 366), ct(e, t) / u;
                                            const c = a - i + 1, f = (new Date(a + 1, 0, 1) - new Date(i, 0, 1)) / 1e3 / 60 / 60 / 24 / c;
                                            return ct(e, t) / f;
                                        }
                                    case 2:
                                        return ct(e, t) / 360;
                                    case 3:
                                        return ct(e, t) / 365;
                                    case 4:
                                        return (s + 30 * l + 360 * a - (r + 30 * o + 360 * i)) / 360;
                                }
                            }
                            function dt(e) {
                                const t = e > -2203891200000 ? 2 : 1;
                                return Math.ceil((e - Qe) / 864e5) + t;
                            }
                            function pt(e) {
                                return 0 === (e = L(e)) ? l : e instanceof Error ? e : String.fromCharCode(e);
                            }
                            function ht(e) {
                                if (N(e)) return e;
                                let t = (e = e || "").charCodeAt(0);
                                return isNaN(t) && (t = l), t;
                            }
                            function gt() {
                                const e = C(arguments), t = I.apply(void 0, e);
                                if (t) return t;
                                let n = 0;
                                for(; (n = e.indexOf(!0)) > -1;)e[n] = "TRUE";
                                let r = 0;
                                for(; (r = e.indexOf(!1)) > -1;)e[r] = "FALSE";
                                return e.join("");
                            }
                            lt.INTL = (e, t, n, r)=>{
                                if ((e = T(e)) instanceof Error) return e;
                                if ((t = T(t)) instanceof Error) return t;
                                let o = !1;
                                const i = [], s = [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    0
                                ], a = new RegExp("^[0|1]{7}$");
                                if (void 0 === n) n = tt[1];
                                else if ("string" == typeof n && a.test(n)) {
                                    o = !0, n = n.split("");
                                    for(let e = 0; e < n.length; e++)"1" === n[e] && i.push(s[e]);
                                } else n = tt[n];
                                if (!(n instanceof Array)) return l;
                                void 0 === r ? r = [] : r instanceof Array || (r = [
                                    r
                                ]);
                                for(let e = 0; e < r.length; e++){
                                    const t = T(r[e]);
                                    if (t instanceof Error) return t;
                                    r[e] = t;
                                }
                                const u = Math.round((t - e) / 864e5) + 1;
                                let c = u;
                                const f = e;
                                for(let e = 0; e < u; e++){
                                    const e = (new Date).getTimezoneOffset() > 0 ? f.getUTCDay() : f.getDay();
                                    let t = o ? i.includes(e) : e === n[0] || e === n[1];
                                    for(let e = 0; e < r.length; e++){
                                        const n = r[e];
                                        if (n.getDate() === f.getDate() && n.getMonth() === f.getMonth() && n.getFullYear() === f.getFullYear()) {
                                            t = !0;
                                            break;
                                        }
                                    }
                                    t && c--, f.setDate(f.getDate() + 1);
                                }
                                return c;
                            }, at.INTL = (e, t, n, r)=>{
                                if ((e = T(e)) instanceof Error) return e;
                                if ((t = L(t)) instanceof Error) return t;
                                if (t < 0) return c;
                                if (!((n = void 0 === n ? tt[1] : tt[n]) instanceof Array)) return l;
                                void 0 === r ? r = [] : r instanceof Array || (r = [
                                    r
                                ]);
                                for(let e = 0; e < r.length; e++){
                                    const t = T(r[e]);
                                    if (t instanceof Error) return t;
                                    r[e] = t;
                                }
                                let o = 0;
                                for(; o < t;){
                                    e.setDate(e.getDate() + 1);
                                    const t = e.getDay();
                                    if (t !== n[0] && t !== n[1]) {
                                        for(let t = 0; t < r.length; t++){
                                            const n = r[t];
                                            if (n.getDate() === e.getDate() && n.getMonth() === e.getMonth() && n.getFullYear() === e.getFullYear()) {
                                                o--;
                                                break;
                                            }
                                        }
                                        o++;
                                    }
                                }
                                return e;
                            };
                            const mt = gt;
                            function vt(e, t = 2, n = !1) {
                                if (e = L(e), isNaN(e)) return l;
                                if (t = L(t), isNaN(t)) return l;
                                if (t < 0) {
                                    const n = Math.pow(10, -t);
                                    e = Math.round(e / n) * n;
                                } else e = e.toFixed(t);
                                if (n) e = e.toString().replace(/,/g, "");
                                else {
                                    const t = e.toString().split(".");
                                    t[0] = t[0].replace(/\B(?=(\d{3})+$)/g, ","), e = t.join(".");
                                }
                                return e;
                            }
                            function yt(e, t) {
                                return I(e, t) || (e = O(e), (t = L(t)) instanceof Error ? t : new Array(t + 1).join(e));
                            }
                            const Ct = pt, wt = ht;
                            function bt(e) {
                                return /^[01]{1,10}$/.test(e);
                            }
                            function At(e, t, n) {
                                if (N(e = L(e), t = L(t))) return e;
                                if ("i" !== (n = void 0 === n ? "i" : n) && "j" !== n) return l;
                                if (0 === e && 0 === t) return 0;
                                if (0 === e) return 1 === t ? n : t.toString() + n;
                                if (0 === t) return e.toString();
                                {
                                    const r = t > 0 ? "+" : "";
                                    return e.toString() + r + (1 === t ? n : t.toString() + n);
                                }
                            }
                            function Et(e, t) {
                                return t = void 0 === t ? 0 : t, N(e = L(e), t = L(t)) ? l : r.erf(e);
                            }
                            function Mt(e) {
                                return isNaN(e) ? l : r.erfc(e);
                            }
                            function It(e) {
                                const t = Ft(e), n = Nt(e);
                                return N(t, n) ? l : Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2));
                            }
                            function Nt(e) {
                                if (void 0 === e || !0 === e || !1 === e) return l;
                                if (0 === e || "0" === e) return 0;
                                if ([
                                    "i",
                                    "j"
                                ].indexOf(e) >= 0) return 1;
                                let t = (e = (e += "").replace("+i", "+1i").replace("-i", "-1i").replace("+j", "+1j").replace("-j", "-1j")).indexOf("+"), n = e.indexOf("-");
                                0 === t && (t = e.indexOf("+", 1)), 0 === n && (n = e.indexOf("-", 1));
                                const r = e.substring(e.length - 1, e.length), o = "i" === r || "j" === r;
                                return t >= 0 || n >= 0 ? o ? t >= 0 ? isNaN(e.substring(0, t)) || isNaN(e.substring(t + 1, e.length - 1)) ? c : Number(e.substring(t + 1, e.length - 1)) : isNaN(e.substring(0, n)) || isNaN(e.substring(n + 1, e.length - 1)) ? c : -Number(e.substring(n + 1, e.length - 1)) : c : o ? isNaN(e.substring(0, e.length - 1)) ? c : e.substring(0, e.length - 1) : isNaN(e) ? c : 0;
                            }
                            function xt(e) {
                                const t = Ft(e), n = Nt(e);
                                return N(t, n) ? l : 0 === t && 0 === n ? s : 0 === t && n > 0 ? Math.PI / 2 : 0 === t && n < 0 ? -Math.PI / 2 : 0 === n && t > 0 ? 0 : 0 === n && t < 0 ? -Math.PI : t > 0 ? Math.atan(n / t) : t < 0 && n >= 0 ? Math.atan(n / t) + Math.PI : Math.atan(n / t) - Math.PI;
                            }
                            function St(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.cos(t) * (Math.exp(n) + Math.exp(-n)) / 2, -Math.sin(t) * (Math.exp(n) - Math.exp(-n)) / 2, r);
                            }
                            function Dt(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.cos(n) * (Math.exp(t) + Math.exp(-t)) / 2, Math.sin(n) * (Math.exp(t) - Math.exp(-t)) / 2, r);
                            }
                            function Tt(e, t) {
                                const n = Ft(e), r = Nt(e), o = Ft(t), i = Nt(t);
                                if (N(n, r, o, i)) return l;
                                const s = e.substring(e.length - 1), a = t.substring(t.length - 1);
                                let u = "i";
                                if (("j" === s || "j" === a) && (u = "j"), 0 === o && 0 === i) return c;
                                const f = o * o + i * i;
                                return At((n * o + r * i) / f, (r * o - n * i) / f, u);
                            }
                            function Ft(e) {
                                if (void 0 === e || !0 === e || !1 === e) return l;
                                if (0 === e || "0" === e) return 0;
                                if ([
                                    "i",
                                    "+i",
                                    "1i",
                                    "+1i",
                                    "-i",
                                    "-1i",
                                    "j",
                                    "+j",
                                    "1j",
                                    "+1j",
                                    "-j",
                                    "-1j"
                                ].indexOf(e) >= 0) return 0;
                                let t = (e += "").indexOf("+"), n = e.indexOf("-");
                                0 === t && (t = e.indexOf("+", 1)), 0 === n && (n = e.indexOf("-", 1));
                                const r = e.substring(e.length - 1, e.length), o = "i" === r || "j" === r;
                                return t >= 0 || n >= 0 ? o ? t >= 0 ? isNaN(e.substring(0, t)) || isNaN(e.substring(t + 1, e.length - 1)) ? c : Number(e.substring(0, t)) : isNaN(e.substring(0, n)) || isNaN(e.substring(n + 1, e.length - 1)) ? c : Number(e.substring(0, n)) : c : o ? isNaN(e.substring(0, e.length - 1)) ? c : 0 : isNaN(e) ? c : e;
                            }
                            function Lt(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.sin(t) * (Math.exp(n) + Math.exp(-n)) / 2, Math.cos(t) * (Math.exp(n) - Math.exp(-n)) / 2, r);
                            }
                            function Rt(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.cos(n) * (Math.exp(t) - Math.exp(-t)) / 2, Math.sin(n) * (Math.exp(t) + Math.exp(-t)) / 2, r);
                            }
                            Et.PRECISE = ()=>{
                                throw new Error("ERF.PRECISE is not implemented");
                            }, Mt.PRECISE = ()=>{
                                throw new Error("ERFC.PRECISE is not implemented");
                            };
                            const Ot = re.DIST, Ht = re.INV, Bt = oe.DIST, jt = _e.MATH, kt = _e.PRECISE, Pt = ie.DIST, Vt = ie.DIST.RT, _t = ie.INV, Ut = ie.INV.RT, qt = ie.TEST, zt = ce.P, Yt = ce.P, Wt = ce.S, Xt = oe.INV, Gt = Mt.PRECISE, Kt = Et.PRECISE, $t = fe.DIST, Jt = de.DIST, Qt = de.DIST.RT, Zt = de.INV, en = de.INV.RT, tn = Ye.MATH, nn = Ye.PRECISE, rn = de.TEST, on = he.DIST, sn = he.INV, ln = ge.PRECISE, an = me.DIST, un = Ce.INV, cn = Ce.DIST, fn = Ce.INV, dn = Ee.MULT, pn = Ee.SNGL, hn = Me.DIST, gn = lt.INTL, mn = Ie.DIST, vn = Ie.INV, yn = Ie.S.DIST, Cn = Ie.S.INV, wn = xe.EXC, bn = xe.INC, An = Se.EXC, En = Se.INC, Mn = De.DIST, In = Te.EXC, Nn = Te.INC, xn = Fe.AVG, Sn = Fe.EQ, Dn = Le.P, Tn = Oe.P, Fn = Oe.S, Ln = He.DIST, Rn = He.DIST.RT, On = He.INV, Hn = He.TEST, Bn = Be.P, jn = Be.S, kn = Pe.DIST, Pn = at.INTL, Vn = Ve.TEST;
                            function _n(e) {
                                const t = [];
                                return m(e, (e)=>{
                                    e && t.push(e);
                                }), t;
                            }
                            function Un(e, t) {
                                const n = {};
                                for(let t = 1; t < e[0].length; ++t)n[t] = !0;
                                let r = t[0].length;
                                for(let e = 1; e < t.length; ++e)t[e].length > r && (r = t[e].length);
                                for(let o = 1; o < e.length; ++o)for(let i = 1; i < e[o].length; ++i){
                                    let s = !1, l = !1;
                                    for(let n = 0; n < t.length; ++n){
                                        const a = t[n];
                                        if (a.length < r) continue;
                                        const u = a[0];
                                        if (e[o][0] === u) {
                                            l = !0;
                                            for(let t = 1; t < a.length; ++t)if (!s) {
                                                if (void 0 === a[t] || "*" === a[t]) s = !0;
                                                else {
                                                    const n = Y(a[t] + ""), r = [
                                                        z(e[o][i], q)
                                                    ].concat(n);
                                                    s = W(r);
                                                }
                                            }
                                        }
                                    }
                                    l && (n[i] = n[i] && s);
                                }
                                const o = [];
                                for(let t = 0; t < e[0].length; ++t)n[t] && o.push(t - 1);
                                return o;
                            }
                            function qn(e) {
                                return e && e.getTime && !isNaN(e.getTime());
                            }
                            function zn(e) {
                                return e instanceof Date ? e : new Date(e);
                            }
                            function Yn(e, t, n, r, o) {
                                if (r = r || 0, o = o || 0, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o))) return l;
                                let i;
                                if (0 === e) i = r + n * t;
                                else {
                                    const s = Math.pow(1 + e, t);
                                    i = 1 === o ? r * s + n * (1 + e) * (s - 1) / e : r * s + n * (s - 1) / e;
                                }
                                return -i;
                            }
                            function Wn(e, t, n, r, o, i) {
                                if (o = o || 0, i = i || 0, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o), i = L(i))) return l;
                                const s = Gn(e, n, r, o, i);
                                return (1 === t ? 1 === i ? 0 : -r : 1 === i ? Yn(e, t - 2, s, r, 1) - s : Yn(e, t - 1, s, r, 0)) * e;
                            }
                            function Xn() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = e[0];
                                let n = 0;
                                for(let r = 1; r < e.length; r++)n += e[r] / Math.pow(1 + t, r);
                                return n;
                            }
                            function Gn(e, t, n, r, o) {
                                if (r = r || 0, o = o || 0, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o))) return l;
                                let i;
                                if (0 === e) i = (n + r) / t;
                                else {
                                    const s = Math.pow(1 + e, t);
                                    i = 1 === o ? (r * e / (s - 1) + n * e / (1 - 1 / s)) / (1 + e) : r * e / (s - 1) + n * e / (1 - 1 / s);
                                }
                                return -i;
                            }
                            const Kn = {
                                errors: h,
                                symbols: Je
                            };
                            t.ABS = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.abs(e);
                            }, t.ACCRINT = function(e, t, n, r, o, i, s) {
                                return e = zn(e), t = zn(t), n = zn(n), qn(e) && qn(t) && qn(n) ? r <= 0 || o <= 0 || -1 === [
                                    1,
                                    2,
                                    4
                                ].indexOf(i) || -1 === [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4
                                ].indexOf(s) || n <= e ? c : (o = o || 0) * r * ft(e, n, s = s || 0) : l;
                            }, t.ACCRINTM = function() {
                                throw new Error("ACCRINTM is not implemented");
                            }, t.ACOS = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                let t = Math.acos(e);
                                return isNaN(t) && (t = c), t;
                            }, t.ACOSH = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                let t = Math.log(e + Math.sqrt(e * e - 1));
                                return isNaN(t) && (t = c), t;
                            }, t.ACOT = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.atan(1 / e);
                            }, t.ACOTH = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                let t = .5 * Math.log((e + 1) / (e - 1));
                                return isNaN(t) && (t = c), t;
                            }, t.AGGREGATE = function(e, t, n, r) {
                                if (N(e = L(e), L(e))) return l;
                                switch(e){
                                    case 1:
                                        return te(n);
                                    case 2:
                                        return le(n);
                                    case 3:
                                        return ae(n);
                                    case 4:
                                        return we(n);
                                    case 5:
                                        return Ae(n);
                                    case 6:
                                        return Ge(n);
                                    case 7:
                                        return Oe.S(n);
                                    case 8:
                                        return Oe.P(n);
                                    case 9:
                                        return $e(n);
                                    case 10:
                                        return Be.S(n);
                                    case 11:
                                        return Be.P(n);
                                    case 12:
                                        return be(n);
                                    case 13:
                                        return Ee.SNGL(n);
                                    case 14:
                                        return ve(n, r);
                                    case 15:
                                        return Re(n, r);
                                    case 16:
                                        return xe.INC(n, r);
                                    case 17:
                                        return Te.INC(n, r);
                                    case 18:
                                        return xe.EXC(n, r);
                                    case 19:
                                        return Te.EXC(n, r);
                                }
                            }, t.AMORDEGRC = function() {
                                throw new Error("AMORDEGRC is not implemented");
                            }, t.AMORLINC = function() {
                                throw new Error("AMORLINC is not implemented");
                            }, t.AND = function() {
                                const e = C(arguments);
                                let t = l;
                                for(let n = 0; n < e.length; n++){
                                    if (e[n] instanceof Error) return e[n];
                                    void 0 !== e[n] && null !== e[n] && "string" != typeof e[n] && (t === l && (t = !0), e[n] || (t = !1));
                                }
                                return t;
                            }, t.ARABIC = function(e) {
                                if (null == e) return 0;
                                if (e instanceof Error) return e;
                                if (!/^M*(?:D?C{0,3}|C[MD])(?:L?X{0,3}|X[CL])(?:V?I{0,3}|I[XV])$/.test(e)) return l;
                                let t = 0;
                                return e.replace(/[MDLV]|C[MD]?|X[CL]?|I[XV]?/g, (e)=>{
                                    t += ({
                                        M: 1e3,
                                        CM: 900,
                                        D: 500,
                                        CD: 400,
                                        C: 100,
                                        XC: 90,
                                        L: 50,
                                        XL: 40,
                                        X: 10,
                                        IX: 9,
                                        V: 5,
                                        IV: 4,
                                        I: 1
                                    })[e];
                                }), t;
                            }, t.ASC = function() {
                                throw new Error("ASC is not implemented");
                            }, t.ASIN = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                let t = Math.asin(e);
                                return isNaN(t) && (t = c), t;
                            }, t.ASINH = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.log(e + Math.sqrt(e * e + 1));
                            }, t.ATAN = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.atan(e);
                            }, t.ATAN2 = function(e, t) {
                                return I(e = L(e), t = L(t)) || Math.atan2(e, t);
                            }, t.ATANH = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                let t = Math.log((1 + e) / (1 - e)) / 2;
                                return isNaN(t) && (t = c), t;
                            }, t.AVEDEV = function() {
                                const e = C(arguments).filter(B);
                                if (0 === e.length) return c;
                                const t = R(e);
                                return t instanceof Error ? t : r.sum(r(t).subtract(r.mean(t)).abs()[0]) / t.length;
                            }, t.AVERAGE = te, t.AVERAGEA = ne, t.AVERAGEIF = function(e, t, n) {
                                if (arguments.length <= 1) return f;
                                if (n = R(C(n = n || e).filter(B)), e = C(e), n instanceof Error) return n;
                                let r = 0, o = 0;
                                const i = void 0 === t || "*" === t, s = i ? null : Y(t + "");
                                for(let t = 0; t < e.length; t++){
                                    const l = e[t];
                                    if (i) o += n[t], r++;
                                    else {
                                        const e = [
                                            z(l, q)
                                        ].concat(s);
                                        W(e) && (o += n[t], r++);
                                    }
                                }
                                return o / r;
                            }, t.AVERAGEIFS = function() {
                                const e = g(arguments), t = (e.length - 1) / 2, n = C(e[0]);
                                let r = 0, o = 0;
                                for(let i = 0; i < n.length; i++){
                                    let s = !1;
                                    for(let n = 0; n < t; n++){
                                        const t = e[2 * n + 1][i], r = e[2 * n + 2];
                                        let o = !1;
                                        if (void 0 === r || "*" === r) o = !0;
                                        else {
                                            const e = Y(r + ""), n = [
                                                z(t, q)
                                            ].concat(e);
                                            o = W(n);
                                        }
                                        if (!o) {
                                            s = !1;
                                            break;
                                        }
                                        s = !0;
                                    }
                                    s && (o += n[i], r++);
                                }
                                const i = o / r;
                                return isNaN(i) ? 0 : i;
                            }, t.BAHTTEXT = function() {
                                throw new Error("BAHTTEXT is not implemented");
                            }, t.BASE = function(e, t, n) {
                                const r = I(e = L(e), t = L(t), n = L(n));
                                if (r) return r;
                                if (0 === t) return c;
                                const o = e.toString(t);
                                return new Array(Math.max(n + 1 - o.length, 0)).join("0") + o;
                            }, t.BESSELI = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : o.besseli(e, t);
                            }, t.BESSELJ = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : o.besselj(e, t);
                            }, t.BESSELK = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : o.besselk(e, t);
                            }, t.BESSELY = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : o.bessely(e, t);
                            }, t.BETA = re, t.BETADIST = Ot, t.BETAINV = Ht, t.BIN2DEC = function(e) {
                                if (!bt(e)) return c;
                                const t = parseInt(e, 2), n = e.toString();
                                return 10 === n.length && "1" === n.substring(0, 1) ? parseInt(n.substring(1), 2) - 512 : t;
                            }, t.BIN2HEX = function(e, t) {
                                if (!bt(e)) return c;
                                const n = e.toString();
                                if (10 === n.length && "1" === n.substring(0, 1)) return (0xfffffffe00 + parseInt(n.substring(1), 2)).toString(16);
                                const r = parseInt(e, 2).toString(16);
                                return void 0 === t ? r : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= r.length ? yt("0", t - r.length) + r : c;
                            }, t.BIN2OCT = function(e, t) {
                                if (!bt(e)) return c;
                                const n = e.toString();
                                if (10 === n.length && "1" === n.substring(0, 1)) return (1073741312 + parseInt(n.substring(1), 2)).toString(8);
                                const r = parseInt(e, 2).toString(8);
                                return void 0 === t ? r : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= r.length ? yt("0", t - r.length) + r : c;
                            }, t.BINOM = oe, t.BINOMDIST = Bt, t.BITAND = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e < 0 || t < 0 || Math.floor(e) !== e || Math.floor(t) !== t || e > 0xffffffffffff || t > 0xffffffffffff ? c : e & t;
                            }, t.BITLSHIFT = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e < 0 || Math.floor(e) !== e || e > 0xffffffffffff || Math.abs(t) > 53 ? c : t >= 0 ? e << t : e >> -t;
                            }, t.BITOR = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e < 0 || t < 0 || Math.floor(e) !== e || Math.floor(t) !== t || e > 0xffffffffffff || t > 0xffffffffffff ? c : e | t;
                            }, t.BITRSHIFT = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e < 0 || Math.floor(e) !== e || e > 0xffffffffffff || Math.abs(t) > 53 ? c : t >= 0 ? e >> t : e << -t;
                            }, t.BITXOR = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e < 0 || t < 0 || Math.floor(e) !== e || Math.floor(t) !== t || e > 0xffffffffffff || t > 0xffffffffffff ? c : e ^ t;
                            }, t.CEILING = _e, t.CEILINGMATH = jt, t.CEILINGPRECISE = kt, t.CELL = function() {
                                throw new Error("CELL is not implemented");
                            }, t.CHAR = pt, t.CHIDIST = Pt, t.CHIDISTRT = Vt, t.CHIINV = _t, t.CHIINVRT = Ut, t.CHISQ = ie, t.CHITEST = qt, t.CHOOSE = function() {
                                if (arguments.length < 2) return f;
                                const e = arguments[0];
                                return e < 1 || e > 254 || arguments.length < e + 1 ? l : arguments[e];
                            }, t.CLEAN = function(e) {
                                return N(e) ? e : (e = e || "").replace(/[\0-\x1F]/g, "");
                            }, t.CODE = ht, t.COLUMN = function(e, t) {
                                return 2 !== arguments.length ? f : t < 0 ? c : e instanceof Array && "number" == typeof t ? 0 !== e.length ? r.col(e, t) : void 0 : l;
                            }, t.COLUMNS = function(e) {
                                return 1 !== arguments.length ? f : e instanceof Array ? 0 === e.length ? 0 : r.cols(e) : l;
                            }, t.COMBIN = Ue, t.COMBINA = function(e, t) {
                                return I(e = L(e), t = L(t)) || (e < t ? c : 0 === e && 0 === t ? 1 : Ue(e + t - 1, e - 1));
                            }, t.COMPLEX = At, t.CONCAT = mt, t.CONCATENATE = gt, t.CONFIDENCE = se, t.CONVERT = function(e, t, n) {
                                if ((e = L(e)) instanceof Error) return e;
                                const r = [
                                    [
                                        "a.u. of action",
                                        "?",
                                        null,
                                        "action",
                                        !1,
                                        !1,
                                        105457168181818e-48
                                    ],
                                    [
                                        "a.u. of charge",
                                        "e",
                                        null,
                                        "electric_charge",
                                        !1,
                                        !1,
                                        160217653141414e-33
                                    ],
                                    [
                                        "a.u. of energy",
                                        "Eh",
                                        null,
                                        "energy",
                                        !1,
                                        !1,
                                        435974417757576e-32
                                    ],
                                    [
                                        "a.u. of length",
                                        "a?",
                                        null,
                                        "length",
                                        !1,
                                        !1,
                                        529177210818182e-25
                                    ],
                                    [
                                        "a.u. of mass",
                                        "m?",
                                        null,
                                        "mass",
                                        !1,
                                        !1,
                                        910938261616162e-45
                                    ],
                                    [
                                        "a.u. of time",
                                        "?/Eh",
                                        null,
                                        "time",
                                        !1,
                                        !1,
                                        241888432650516e-31
                                    ],
                                    [
                                        "admiralty knot",
                                        "admkn",
                                        null,
                                        "speed",
                                        !1,
                                        !0,
                                        .514773333
                                    ],
                                    [
                                        "ampere",
                                        "A",
                                        null,
                                        "electric_current",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "ampere per meter",
                                        "A/m",
                                        null,
                                        "magnetic_field_intensity",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "\xe5ngstr\xf6m",
                                        "\xc5",
                                        [
                                            "ang"
                                        ],
                                        "length",
                                        !1,
                                        !0,
                                        1e-10
                                    ],
                                    [
                                        "are",
                                        "ar",
                                        null,
                                        "area",
                                        !1,
                                        !0,
                                        100
                                    ],
                                    [
                                        "astronomical unit",
                                        "ua",
                                        null,
                                        "length",
                                        !1,
                                        !1,
                                        149597870691667e-25
                                    ],
                                    [
                                        "bar",
                                        "bar",
                                        null,
                                        "pressure",
                                        !1,
                                        !1,
                                        1e5
                                    ],
                                    [
                                        "barn",
                                        "b",
                                        null,
                                        "area",
                                        !1,
                                        !1,
                                        1e-28
                                    ],
                                    [
                                        "becquerel",
                                        "Bq",
                                        null,
                                        "radioactivity",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "bit",
                                        "bit",
                                        [
                                            "b"
                                        ],
                                        "information",
                                        !1,
                                        !0,
                                        1
                                    ],
                                    [
                                        "btu",
                                        "BTU",
                                        [
                                            "btu"
                                        ],
                                        "energy",
                                        !1,
                                        !0,
                                        1055.05585262
                                    ],
                                    [
                                        "byte",
                                        "byte",
                                        null,
                                        "information",
                                        !1,
                                        !0,
                                        8
                                    ],
                                    [
                                        "candela",
                                        "cd",
                                        null,
                                        "luminous_intensity",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "candela per square metre",
                                        "cd/m?",
                                        null,
                                        "luminance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "coulomb",
                                        "C",
                                        null,
                                        "electric_charge",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "cubic \xe5ngstr\xf6m",
                                        "ang3",
                                        [
                                            "ang^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        1e-30
                                    ],
                                    [
                                        "cubic foot",
                                        "ft3",
                                        [
                                            "ft^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        .028316846592
                                    ],
                                    [
                                        "cubic inch",
                                        "in3",
                                        [
                                            "in^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        16387064e-12
                                    ],
                                    [
                                        "cubic light-year",
                                        "ly3",
                                        [
                                            "ly^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        846786664623715e-61
                                    ],
                                    [
                                        "cubic metre",
                                        "m?",
                                        null,
                                        "volume",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "cubic mile",
                                        "mi3",
                                        [
                                            "mi^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        4168181825.44058
                                    ],
                                    [
                                        "cubic nautical mile",
                                        "Nmi3",
                                        [
                                            "Nmi^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        6352182208
                                    ],
                                    [
                                        "cubic Pica",
                                        "Pica3",
                                        [
                                            "Picapt3",
                                            "Pica^3",
                                            "Picapt^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        7.58660370370369e-8
                                    ],
                                    [
                                        "cubic yard",
                                        "yd3",
                                        [
                                            "yd^3"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        .764554857984
                                    ],
                                    [
                                        "cup",
                                        "cup",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .0002365882365
                                    ],
                                    [
                                        "dalton",
                                        "Da",
                                        [
                                            "u"
                                        ],
                                        "mass",
                                        !1,
                                        !1,
                                        166053886282828e-41
                                    ],
                                    [
                                        "day",
                                        "d",
                                        [
                                            "day"
                                        ],
                                        "time",
                                        !1,
                                        !0,
                                        86400
                                    ],
                                    [
                                        "degree",
                                        "\xb0",
                                        null,
                                        "angle",
                                        !1,
                                        !1,
                                        .0174532925199433
                                    ],
                                    [
                                        "degrees Rankine",
                                        "Rank",
                                        null,
                                        "temperature",
                                        !1,
                                        !0,
                                        .555555555555556
                                    ],
                                    [
                                        "dyne",
                                        "dyn",
                                        [
                                            "dy"
                                        ],
                                        "force",
                                        !1,
                                        !0,
                                        1e-5
                                    ],
                                    [
                                        "electronvolt",
                                        "eV",
                                        [
                                            "ev"
                                        ],
                                        "energy",
                                        !1,
                                        !0,
                                        1.60217656514141
                                    ],
                                    [
                                        "ell",
                                        "ell",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        1.143
                                    ],
                                    [
                                        "erg",
                                        "erg",
                                        [
                                            "e"
                                        ],
                                        "energy",
                                        !1,
                                        !0,
                                        1e-7
                                    ],
                                    [
                                        "farad",
                                        "F",
                                        null,
                                        "electric_capacitance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "fluid ounce",
                                        "oz",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        295735295625e-16
                                    ],
                                    [
                                        "foot",
                                        "ft",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        .3048
                                    ],
                                    [
                                        "foot-pound",
                                        "flb",
                                        null,
                                        "energy",
                                        !1,
                                        !0,
                                        1.3558179483314
                                    ],
                                    [
                                        "gal",
                                        "Gal",
                                        null,
                                        "acceleration",
                                        !1,
                                        !1,
                                        .01
                                    ],
                                    [
                                        "gallon",
                                        "gal",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .003785411784
                                    ],
                                    [
                                        "gauss",
                                        "G",
                                        [
                                            "ga"
                                        ],
                                        "magnetic_flux_density",
                                        !1,
                                        !0,
                                        1
                                    ],
                                    [
                                        "grain",
                                        "grain",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        647989e-10
                                    ],
                                    [
                                        "gram",
                                        "g",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        .001
                                    ],
                                    [
                                        "gray",
                                        "Gy",
                                        null,
                                        "absorbed_dose",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "gross registered ton",
                                        "GRT",
                                        [
                                            "regton"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        2.8316846592
                                    ],
                                    [
                                        "hectare",
                                        "ha",
                                        null,
                                        "area",
                                        !1,
                                        !0,
                                        1e4
                                    ],
                                    [
                                        "henry",
                                        "H",
                                        null,
                                        "inductance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "hertz",
                                        "Hz",
                                        null,
                                        "frequency",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "horsepower",
                                        "HP",
                                        [
                                            "h"
                                        ],
                                        "power",
                                        !1,
                                        !0,
                                        745.69987158227
                                    ],
                                    [
                                        "horsepower-hour",
                                        "HPh",
                                        [
                                            "hh",
                                            "hph"
                                        ],
                                        "energy",
                                        !1,
                                        !0,
                                        2684519.538
                                    ],
                                    [
                                        "hour",
                                        "h",
                                        [
                                            "hr"
                                        ],
                                        "time",
                                        !1,
                                        !0,
                                        3600
                                    ],
                                    [
                                        "imperial gallon (U.K.)",
                                        "uk_gal",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .00454609
                                    ],
                                    [
                                        "imperial hundredweight",
                                        "lcwt",
                                        [
                                            "uk_cwt",
                                            "hweight"
                                        ],
                                        "mass",
                                        !1,
                                        !0,
                                        50.802345
                                    ],
                                    [
                                        "imperial quart (U.K)",
                                        "uk_qt",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .0011365225
                                    ],
                                    [
                                        "imperial ton",
                                        "brton",
                                        [
                                            "uk_ton",
                                            "LTON"
                                        ],
                                        "mass",
                                        !1,
                                        !0,
                                        1016.046909
                                    ],
                                    [
                                        "inch",
                                        "in",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        .0254
                                    ],
                                    [
                                        "international acre",
                                        "uk_acre",
                                        null,
                                        "area",
                                        !1,
                                        !0,
                                        4046.8564224
                                    ],
                                    [
                                        "IT calorie",
                                        "cal",
                                        null,
                                        "energy",
                                        !1,
                                        !0,
                                        4.1868
                                    ],
                                    [
                                        "joule",
                                        "J",
                                        null,
                                        "energy",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "katal",
                                        "kat",
                                        null,
                                        "catalytic_activity",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "kelvin",
                                        "K",
                                        [
                                            "kel"
                                        ],
                                        "temperature",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "kilogram",
                                        "kg",
                                        null,
                                        "mass",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "knot",
                                        "kn",
                                        null,
                                        "speed",
                                        !1,
                                        !0,
                                        .514444444444444
                                    ],
                                    [
                                        "light-year",
                                        "ly",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        9460730472580800
                                    ],
                                    [
                                        "litre",
                                        "L",
                                        [
                                            "l",
                                            "lt"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        .001
                                    ],
                                    [
                                        "lumen",
                                        "lm",
                                        null,
                                        "luminous_flux",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "lux",
                                        "lx",
                                        null,
                                        "illuminance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "maxwell",
                                        "Mx",
                                        null,
                                        "magnetic_flux",
                                        !1,
                                        !1,
                                        1e-18
                                    ],
                                    [
                                        "measurement ton",
                                        "MTON",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        1.13267386368
                                    ],
                                    [
                                        "meter per hour",
                                        "m/h",
                                        [
                                            "m/hr"
                                        ],
                                        "speed",
                                        !1,
                                        !0,
                                        .00027777777777778
                                    ],
                                    [
                                        "meter per second",
                                        "m/s",
                                        [
                                            "m/sec"
                                        ],
                                        "speed",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "meter per second squared",
                                        "m?s??",
                                        null,
                                        "acceleration",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "parsec",
                                        "pc",
                                        [
                                            "parsec"
                                        ],
                                        "length",
                                        !1,
                                        !0,
                                        0x6da012f958ee1c
                                    ],
                                    [
                                        "meter squared per second",
                                        "m?/s",
                                        null,
                                        "kinematic_viscosity",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "metre",
                                        "m",
                                        null,
                                        "length",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "miles per hour",
                                        "mph",
                                        null,
                                        "speed",
                                        !1,
                                        !0,
                                        .44704
                                    ],
                                    [
                                        "millimetre of mercury",
                                        "mmHg",
                                        null,
                                        "pressure",
                                        !1,
                                        !1,
                                        133.322
                                    ],
                                    [
                                        "minute",
                                        "?",
                                        null,
                                        "angle",
                                        !1,
                                        !1,
                                        .000290888208665722
                                    ],
                                    [
                                        "minute",
                                        "min",
                                        [
                                            "mn"
                                        ],
                                        "time",
                                        !1,
                                        !0,
                                        60
                                    ],
                                    [
                                        "modern teaspoon",
                                        "tspm",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        5e-6
                                    ],
                                    [
                                        "mole",
                                        "mol",
                                        null,
                                        "amount_of_substance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "morgen",
                                        "Morgen",
                                        null,
                                        "area",
                                        !1,
                                        !0,
                                        2500
                                    ],
                                    [
                                        "n.u. of action",
                                        "?",
                                        null,
                                        "action",
                                        !1,
                                        !1,
                                        105457168181818e-48
                                    ],
                                    [
                                        "n.u. of mass",
                                        "m?",
                                        null,
                                        "mass",
                                        !1,
                                        !1,
                                        910938261616162e-45
                                    ],
                                    [
                                        "n.u. of speed",
                                        "c?",
                                        null,
                                        "speed",
                                        !1,
                                        !1,
                                        299792458
                                    ],
                                    [
                                        "n.u. of time",
                                        "?/(me?c??)",
                                        null,
                                        "time",
                                        !1,
                                        !1,
                                        128808866778687e-35
                                    ],
                                    [
                                        "nautical mile",
                                        "M",
                                        [
                                            "Nmi"
                                        ],
                                        "length",
                                        !1,
                                        !0,
                                        1852
                                    ],
                                    [
                                        "newton",
                                        "N",
                                        null,
                                        "force",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "\u0153rsted",
                                        "Oe ",
                                        null,
                                        "magnetic_field_intensity",
                                        !1,
                                        !1,
                                        79.5774715459477
                                    ],
                                    [
                                        "ohm",
                                        "\u03A9",
                                        null,
                                        "electric_resistance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "ounce mass",
                                        "ozm",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        .028349523125
                                    ],
                                    [
                                        "pascal",
                                        "Pa",
                                        null,
                                        "pressure",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "pascal second",
                                        "Pa?s",
                                        null,
                                        "dynamic_viscosity",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "pferdest\xe4rke",
                                        "PS",
                                        null,
                                        "power",
                                        !1,
                                        !0,
                                        735.49875
                                    ],
                                    [
                                        "phot",
                                        "ph",
                                        null,
                                        "illuminance",
                                        !1,
                                        !1,
                                        1e-4
                                    ],
                                    [
                                        "pica (1/6 inch)",
                                        "pica",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        .00035277777777778
                                    ],
                                    [
                                        "pica (1/72 inch)",
                                        "Pica",
                                        [
                                            "Picapt"
                                        ],
                                        "length",
                                        !1,
                                        !0,
                                        .00423333333333333
                                    ],
                                    [
                                        "poise",
                                        "P",
                                        null,
                                        "dynamic_viscosity",
                                        !1,
                                        !1,
                                        .1
                                    ],
                                    [
                                        "pond",
                                        "pond",
                                        null,
                                        "force",
                                        !1,
                                        !0,
                                        .00980665
                                    ],
                                    [
                                        "pound force",
                                        "lbf",
                                        null,
                                        "force",
                                        !1,
                                        !0,
                                        4.4482216152605
                                    ],
                                    [
                                        "pound mass",
                                        "lbm",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        .45359237
                                    ],
                                    [
                                        "quart",
                                        "qt",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .000946352946
                                    ],
                                    [
                                        "radian",
                                        "rad",
                                        null,
                                        "angle",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "second",
                                        "?",
                                        null,
                                        "angle",
                                        !1,
                                        !1,
                                        484813681109536e-20
                                    ],
                                    [
                                        "second",
                                        "s",
                                        [
                                            "sec"
                                        ],
                                        "time",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "short hundredweight",
                                        "cwt",
                                        [
                                            "shweight"
                                        ],
                                        "mass",
                                        !1,
                                        !0,
                                        45.359237
                                    ],
                                    [
                                        "siemens",
                                        "S",
                                        null,
                                        "electrical_conductance",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "sievert",
                                        "Sv",
                                        null,
                                        "equivalent_dose",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "slug",
                                        "sg",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        14.59390294
                                    ],
                                    [
                                        "square \xe5ngstr\xf6m",
                                        "ang2",
                                        [
                                            "ang^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        1e-20
                                    ],
                                    [
                                        "square foot",
                                        "ft2",
                                        [
                                            "ft^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        .09290304
                                    ],
                                    [
                                        "square inch",
                                        "in2",
                                        [
                                            "in^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        64516e-8
                                    ],
                                    [
                                        "square light-year",
                                        "ly2",
                                        [
                                            "ly^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        895054210748189e17
                                    ],
                                    [
                                        "square meter",
                                        "m?",
                                        null,
                                        "area",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "square mile",
                                        "mi2",
                                        [
                                            "mi^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        2589988.110336
                                    ],
                                    [
                                        "square nautical mile",
                                        "Nmi2",
                                        [
                                            "Nmi^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        3429904
                                    ],
                                    [
                                        "square Pica",
                                        "Pica2",
                                        [
                                            "Picapt2",
                                            "Pica^2",
                                            "Picapt^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        1792111111111e-17
                                    ],
                                    [
                                        "square yard",
                                        "yd2",
                                        [
                                            "yd^2"
                                        ],
                                        "area",
                                        !1,
                                        !0,
                                        .83612736
                                    ],
                                    [
                                        "statute mile",
                                        "mi",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        1609.344
                                    ],
                                    [
                                        "steradian",
                                        "sr",
                                        null,
                                        "solid_angle",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "stilb",
                                        "sb",
                                        null,
                                        "luminance",
                                        !1,
                                        !1,
                                        1e-4
                                    ],
                                    [
                                        "stokes",
                                        "St",
                                        null,
                                        "kinematic_viscosity",
                                        !1,
                                        !1,
                                        1e-4
                                    ],
                                    [
                                        "stone",
                                        "stone",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        6.35029318
                                    ],
                                    [
                                        "tablespoon",
                                        "tbs",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        147868e-10
                                    ],
                                    [
                                        "teaspoon",
                                        "tsp",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        492892e-11
                                    ],
                                    [
                                        "tesla",
                                        "T",
                                        null,
                                        "magnetic_flux_density",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "thermodynamic calorie",
                                        "c",
                                        null,
                                        "energy",
                                        !1,
                                        !0,
                                        4.184
                                    ],
                                    [
                                        "ton",
                                        "ton",
                                        null,
                                        "mass",
                                        !1,
                                        !0,
                                        907.18474
                                    ],
                                    [
                                        "tonne",
                                        "t",
                                        null,
                                        "mass",
                                        !1,
                                        !1,
                                        1e3
                                    ],
                                    [
                                        "U.K. pint",
                                        "uk_pt",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .00056826125
                                    ],
                                    [
                                        "U.S. bushel",
                                        "bushel",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .03523907
                                    ],
                                    [
                                        "U.S. oil barrel",
                                        "barrel",
                                        null,
                                        "volume",
                                        !1,
                                        !0,
                                        .158987295
                                    ],
                                    [
                                        "U.S. pint",
                                        "pt",
                                        [
                                            "us_pt"
                                        ],
                                        "volume",
                                        !1,
                                        !0,
                                        .000473176473
                                    ],
                                    [
                                        "U.S. survey mile",
                                        "survey_mi",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        1609.347219
                                    ],
                                    [
                                        "U.S. survey/statute acre",
                                        "us_acre",
                                        null,
                                        "area",
                                        !1,
                                        !0,
                                        4046.87261
                                    ],
                                    [
                                        "volt",
                                        "V",
                                        null,
                                        "voltage",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "watt",
                                        "W",
                                        null,
                                        "power",
                                        !0,
                                        !0,
                                        1
                                    ],
                                    [
                                        "watt-hour",
                                        "Wh",
                                        [
                                            "wh"
                                        ],
                                        "energy",
                                        !1,
                                        !0,
                                        3600
                                    ],
                                    [
                                        "weber",
                                        "Wb",
                                        null,
                                        "magnetic_flux",
                                        !0,
                                        !1,
                                        1
                                    ],
                                    [
                                        "yard",
                                        "yd",
                                        null,
                                        "length",
                                        !1,
                                        !0,
                                        .9144
                                    ],
                                    [
                                        "year",
                                        "yr",
                                        null,
                                        "time",
                                        !1,
                                        !0,
                                        31557600
                                    ]
                                ], o = {
                                    Yi: [
                                        "yobi",
                                        80,
                                        12089258196146292e8,
                                        "Yi",
                                        "yotta"
                                    ],
                                    Zi: [
                                        "zebi",
                                        70,
                                        11805916207174113e5,
                                        "Zi",
                                        "zetta"
                                    ],
                                    Ei: [
                                        "exbi",
                                        60,
                                        0x1000000000000000,
                                        "Ei",
                                        "exa"
                                    ],
                                    Pi: [
                                        "pebi",
                                        50,
                                        0x4000000000000,
                                        "Pi",
                                        "peta"
                                    ],
                                    Ti: [
                                        "tebi",
                                        40,
                                        1099511627776,
                                        "Ti",
                                        "tera"
                                    ],
                                    Gi: [
                                        "gibi",
                                        30,
                                        1073741824,
                                        "Gi",
                                        "giga"
                                    ],
                                    Mi: [
                                        "mebi",
                                        20,
                                        1048576,
                                        "Mi",
                                        "mega"
                                    ],
                                    ki: [
                                        "kibi",
                                        10,
                                        1024,
                                        "ki",
                                        "kilo"
                                    ]
                                }, i = {
                                    Y: [
                                        "yotta",
                                        1e24,
                                        "Y"
                                    ],
                                    Z: [
                                        "zetta",
                                        1e21,
                                        "Z"
                                    ],
                                    E: [
                                        "exa",
                                        1e18,
                                        "E"
                                    ],
                                    P: [
                                        "peta",
                                        1e15,
                                        "P"
                                    ],
                                    T: [
                                        "tera",
                                        1e12,
                                        "T"
                                    ],
                                    G: [
                                        "giga",
                                        1e9,
                                        "G"
                                    ],
                                    M: [
                                        "mega",
                                        1e6,
                                        "M"
                                    ],
                                    k: [
                                        "kilo",
                                        1e3,
                                        "k"
                                    ],
                                    h: [
                                        "hecto",
                                        100,
                                        "h"
                                    ],
                                    e: [
                                        "dekao",
                                        10,
                                        "e"
                                    ],
                                    d: [
                                        "deci",
                                        .1,
                                        "d"
                                    ],
                                    c: [
                                        "centi",
                                        .01,
                                        "c"
                                    ],
                                    m: [
                                        "milli",
                                        .001,
                                        "m"
                                    ],
                                    u: [
                                        "micro",
                                        1e-6,
                                        "u"
                                    ],
                                    n: [
                                        "nano",
                                        1e-9,
                                        "n"
                                    ],
                                    p: [
                                        "pico",
                                        1e-12,
                                        "p"
                                    ],
                                    f: [
                                        "femto",
                                        1e-15,
                                        "f"
                                    ],
                                    a: [
                                        "atto",
                                        1e-18,
                                        "a"
                                    ],
                                    z: [
                                        "zepto",
                                        1e-21,
                                        "z"
                                    ],
                                    y: [
                                        "yocto",
                                        1e-24,
                                        "y"
                                    ]
                                };
                                let s, l = null, a = null, u = t, c = n, d = 1, p = 1;
                                for(let e = 0; e < r.length; e++)s = null === r[e][2] ? [] : r[e][2], (r[e][1] === u || s.indexOf(u) >= 0) && (l = r[e]), (r[e][1] === c || s.indexOf(c) >= 0) && (a = r[e]);
                                if (null === l) {
                                    const e = o[t.substring(0, 2)];
                                    let n = i[t.substring(0, 1)];
                                    "da" === t.substring(0, 2) && (n = [
                                        "dekao",
                                        10,
                                        "da"
                                    ]), e ? (d = e[2], u = t.substring(2)) : n && (d = n[1], u = t.substring(n[2].length));
                                    for(let e = 0; e < r.length; e++)s = null === r[e][2] ? [] : r[e][2], (r[e][1] === u || s.indexOf(u) >= 0) && (l = r[e]);
                                }
                                if (null === a) {
                                    const e = o[n.substring(0, 2)];
                                    let t = i[n.substring(0, 1)];
                                    "da" === n.substring(0, 2) && (t = [
                                        "dekao",
                                        10,
                                        "da"
                                    ]), e ? (p = e[2], c = n.substring(2)) : t && (p = t[1], c = n.substring(t[2].length));
                                    for(let e = 0; e < r.length; e++)s = null === r[e][2] ? [] : r[e][2], (r[e][1] === c || s.indexOf(c) >= 0) && (a = r[e]);
                                }
                                return null === l || null === a || l[3] !== a[3] ? f : e * l[6] * d / (a[6] * p);
                            }, t.CORREL = function(e, t) {
                                return N(e = R(C(e)), t = R(C(t))) ? l : r.corrcoeff(e, t);
                            }, t.COS = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.cos(e);
                            }, t.COSH = function(e) {
                                return (e = L(e)) instanceof Error ? e : (Math.exp(e) + Math.exp(-e)) / 2;
                            }, t.COT = function(e) {
                                return (e = L(e)) instanceof Error ? e : 0 === e ? s : 1 / Math.tan(e);
                            }, t.COTH = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                if (0 === e) return s;
                                const t = Math.exp(2 * e);
                                return (t + 1) / (t - 1);
                            }, t.COUNT = le, t.COUNTA = ae, t.COUNTBLANK = ue, t.COUNTIF = function(e, t) {
                                if (e = C(e), void 0 === t || "*" === t) return e.length;
                                let n = 0;
                                const r = Y(t + "");
                                for(let t = 0; t < e.length; t++){
                                    const o = [
                                        z(e[t], q)
                                    ].concat(r);
                                    W(o) && n++;
                                }
                                return n;
                            }, t.COUNTIFS = function() {
                                const e = g(arguments), t = new Array(C(e[0]).length);
                                for(let e = 0; e < t.length; e++)t[e] = !0;
                                for(let n = 0; n < e.length; n += 2){
                                    const r = C(e[n]), o = e[n + 1];
                                    if (void 0 !== o && "*" !== o) {
                                        const e = Y(o + "");
                                        for(let n = 0; n < r.length; n++){
                                            const o = [
                                                z(r[n], q)
                                            ].concat(e);
                                            t[n] = t[n] && W(o);
                                        }
                                    }
                                }
                                let n = 0;
                                for(let e = 0; e < t.length; e++)t[e] && n++;
                                return n;
                            }, t.COUPDAYBS = function() {
                                throw new Error("COUPDAYBS is not implemented");
                            }, t.COUPDAYS = function() {
                                throw new Error("COUPDAYS is not implemented");
                            }, t.COUPDAYSNC = function() {
                                throw new Error("COUPDAYSNC is not implemented");
                            }, t.COUPNCD = function() {
                                throw new Error("COUPNCD is not implemented");
                            }, t.COUPNUM = function() {
                                throw new Error("COUPNUM is not implemented");
                            }, t.COUPPCD = function() {
                                throw new Error("COUPPCD is not implemented");
                            }, t.COVAR = zt, t.COVARIANCE = ce, t.COVARIANCEP = Yt, t.COVARIANCES = Wt, t.CRITBINOM = Xt, t.CSC = function(e) {
                                return (e = L(e)) instanceof Error ? e : 0 === e ? s : 1 / Math.sin(e);
                            }, t.CSCH = function(e) {
                                return (e = L(e)) instanceof Error ? e : 0 === e ? s : 2 / (Math.exp(e) - Math.exp(-e));
                            }, t.CUMIPMT = function(e, t, n, r, o, i) {
                                if (N(e = L(e), t = L(t), n = L(n))) return l;
                                if (e <= 0 || t <= 0 || n <= 0) return c;
                                if (r < 1 || o < 1 || r > o) return c;
                                if (0 !== i && 1 !== i) return c;
                                const s = Gn(e, t, n, 0, i);
                                let a = 0;
                                1 === r && (0 === i && (a = -n), r++);
                                for(let t = r; t <= o; t++)a += 1 === i ? Yn(e, t - 2, s, n, 1) - s : Yn(e, t - 1, s, n, 0);
                                return a *= e, a;
                            }, t.CUMPRINC = function(e, t, n, r, o, i) {
                                if (N(e = L(e), t = L(t), n = L(n))) return l;
                                if (e <= 0 || t <= 0 || n <= 0) return c;
                                if (r < 1 || o < 1 || r > o) return c;
                                if (0 !== i && 1 !== i) return c;
                                const s = Gn(e, t, n, 0, i);
                                let a = 0;
                                1 === r && (a = 0 === i ? s + n * e : s, r++);
                                for(let t = r; t <= o; t++)a += i > 0 ? s - (Yn(e, t - 2, s, n, 1) - s) * e : s - Yn(e, t - 1, s, n, 0) * e;
                                return a;
                            }, t.DATE = function(e, t, n) {
                                let r;
                                return N(e = L(e), t = L(t), n = L(n)) ? r = l : (r = new Date(e, t - 1, n), r.getFullYear() < 0 && (r = c)), r;
                            }, t.DATEDIF = nt, t.DATEVALUE = function(e) {
                                if ("string" != typeof e) return l;
                                const t = Date.parse(e);
                                return isNaN(t) ? l : new Date(e);
                            }, t.DAVERAGE = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                let i = 0;
                                return m(r, (e)=>{
                                    i += o[e];
                                }), 0 === r.length ? s : i / r.length;
                            }, t.DAY = function(e) {
                                const t = T(e);
                                return t instanceof Error ? t : t.getDate();
                            }, t.DAYS = ot, t.DAYS360 = it, t.DB = function(e, t, n, r, o) {
                                if (o = void 0 === o ? 12 : o, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o))) return l;
                                if (e < 0 || t < 0 || n < 0 || r < 0) return c;
                                if (-1 === [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12
                                ].indexOf(o)) return c;
                                if (r > n) return c;
                                if (t >= e) return 0;
                                const i = (1 - Math.pow(t / e, 1 / n)).toFixed(3), s = e * i * o / 12;
                                let a = s, u = 0;
                                const f = r === n ? n - 1 : r;
                                for(let t = 2; t <= f; t++)u = (e - a) * i, a += u;
                                return 1 === r ? s : r === n ? (e - a) * i : u;
                            }, t.DBCS = function() {
                                throw new Error("DBCS is not implemented");
                            }, t.DCOUNT = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                const i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), le(i);
                            }, t.DCOUNTA = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                const i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), ae(i);
                            }, t.DDB = function(e, t, n, r, o) {
                                if (o = void 0 === o ? 2 : o, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o))) return l;
                                if (e < 0 || t < 0 || n < 0 || r < 0 || o <= 0) return c;
                                if (r > n) return c;
                                if (t >= e) return 0;
                                let i = 0, s = 0;
                                for(let l = 1; l <= r; l++)s = Math.min(o / n * (e - i), e - t - i), i += s;
                                return s;
                            }, t.DEC2BIN = function(e, t) {
                                if ((e = L(e)) instanceof Error) return e;
                                if (!/^-?[0-9]{1,3}$/.test(e) || e < -512 || e > 511) return c;
                                if (e < 0) return "1" + yt("0", 9 - (512 + e).toString(2).length) + (512 + e).toString(2);
                                const n = parseInt(e, 10).toString(2);
                                return void 0 === t ? n : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= n.length ? yt("0", t - n.length) + n : c;
                            }, t.DEC2HEX = function(e, t) {
                                if ((e = L(e)) instanceof Error) return e;
                                if (!/^-?[0-9]{1,12}$/.test(e) || e < -549755813888 || e > 549755813887) return c;
                                if (e < 0) return (1099511627776 + e).toString(16);
                                const n = parseInt(e, 10).toString(16);
                                return void 0 === t ? n : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= n.length ? yt("0", t - n.length) + n : c;
                            }, t.DEC2OCT = function(e, t) {
                                if ((e = L(e)) instanceof Error) return e;
                                if (!/^-?[0-9]{1,9}$/.test(e) || e < -536870912 || e > 536870911) return c;
                                if (e < 0) return (1073741824 + e).toString(8);
                                const n = parseInt(e, 10).toString(8);
                                return void 0 === t ? n : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= n.length ? yt("0", t - n.length) + n : c;
                            }, t.DECIMAL = function(e, t) {
                                return arguments.length < 1 ? l : I(e = L(e), t = L(t)) || (0 === t ? c : parseInt(e, t));
                            }, t.DEGREES = function(e) {
                                return (e = L(e)) instanceof Error ? e : 180 * e / Math.PI;
                            }, t.DELTA = function(e, t) {
                                return t = void 0 === t ? 0 : t, N(e = L(e), t = L(t)) ? l : e === t ? 1 : 0;
                            }, t.DEVSQ = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = r.mean(e);
                                let n = 0;
                                for(let r = 0; r < e.length; r++)n += Math.pow(e[r] - t, 2);
                                return n;
                            }, t.DGET = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                return o = A("string" == typeof t ? e[M(e, t)] : e[t]), 0 === r.length ? l : r.length > 1 ? c : o[r[0]];
                            }, t.DISC = function(e, t, n, r, o) {
                                if (N(e = T(e), t = T(t), n = L(n), r = L(r), o = (o = L(o)) || 0)) return l;
                                if (n <= 0 || r <= 0) return c;
                                if (e >= t) return l;
                                let i, s;
                                switch(o){
                                    case 0:
                                        i = 360, s = it(e, t, !1);
                                        break;
                                    case 1:
                                    case 3:
                                        i = 365, s = nt(e, t, "D");
                                        break;
                                    case 2:
                                        i = 360, s = nt(e, t, "D");
                                        break;
                                    case 4:
                                        i = 360, s = it(e, t, !0);
                                        break;
                                    default:
                                        return c;
                                }
                                return (r - n) / r * i / s;
                            }, t.DMAX = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                let i = o[r[0]];
                                return m(r, (e)=>{
                                    i < o[e] && (i = o[e]);
                                }), i;
                            }, t.DMIN = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                let i = o[r[0]];
                                return m(r, (e)=>{
                                    i > o[e] && (i = o[e]);
                                }), i;
                            }, t.DOLLAR = function(e, t = 2) {
                                if (e = L(e), isNaN(e)) return l;
                                const n = {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: t >= 0 ? t : 0,
                                    maximumFractionDigits: t >= 0 ? t : 0
                                }, r = (e = Ke(e, t)).toLocaleString("en-US", n);
                                return e < 0 ? "$(" + r.slice(2) + ")" : r;
                            }, t.DOLLARDE = function(e, t) {
                                if (N(e = L(e), t = L(t))) return l;
                                if (t < 0) return c;
                                if (t >= 0 && t < 1) return s;
                                t = parseInt(t, 10);
                                let n = parseInt(e, 10);
                                n += e % 1 * Math.pow(10, Math.ceil(Math.log(t) / Math.LN10)) / t;
                                const r = Math.pow(10, Math.ceil(Math.log(t) / Math.LN2) + 1);
                                return n = Math.round(n * r) / r, n;
                            }, t.DOLLARFR = function(e, t) {
                                if (N(e = L(e), t = L(t))) return l;
                                if (t < 0) return c;
                                if (t >= 0 && t < 1) return s;
                                t = parseInt(t, 10);
                                let n = parseInt(e, 10);
                                return n += e % 1 * Math.pow(10, -Math.ceil(Math.log(t) / Math.LN10)) * t, n;
                            }, t.DPRODUCT = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                let i = [];
                                m(r, (e)=>{
                                    i.push(o[e]);
                                }), i = _n(i);
                                let s = 1;
                                return m(i, (e)=>{
                                    s *= e;
                                }), s;
                            }, t.DSTDEV = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                let i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), i = _n(i), Oe.S(i);
                            }, t.DSTDEVP = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                let i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), i = _n(i), Oe.P(i);
                            }, t.DSUM = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                const i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), $e(i);
                            }, t.DURATION = function() {
                                throw new Error("DURATION is not implemented");
                            }, t.DVAR = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                const i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), Be.S(i);
                            }, t.DVARP = function(e, t, n) {
                                if (isNaN(t) && "string" != typeof t) return l;
                                const r = Un(e, n);
                                let o = [];
                                if ("string" == typeof t) {
                                    const n = M(e, t);
                                    o = A(e[n]);
                                } else o = A(e[t]);
                                const i = [];
                                return m(r, (e)=>{
                                    i.push(o[e]);
                                }), Be.P(i);
                            }, t.EDATE = function(e, t) {
                                return (e = T(e)) instanceof Error ? e : isNaN(t) ? l : (t = parseInt(t, 10), e.setMonth(e.getMonth() + t), e);
                            }, t.EFFECT = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e <= 0 || t < 1 ? c : (t = parseInt(t, 10), Math.pow(1 + e / t, t) - 1);
                            }, t.EOMONTH = function(e, t) {
                                return (e = T(e)) instanceof Error ? e : isNaN(t) ? l : (t = parseInt(t, 10), new Date(e.getFullYear(), e.getMonth() + t + 1, 0));
                            }, t.ERF = Et, t.ERFC = Mt, t.ERFCPRECISE = Gt, t.ERFPRECISE = Kt, t.ERROR = X, t.EVEN = function(e) {
                                return (e = L(e)) instanceof Error ? e : _e(e, -2, -1);
                            }, t.EXACT = function(e, t) {
                                return 2 !== arguments.length ? f : I(e, t) || (e = O(e)) === O(t);
                            }, t.EXP = function(e) {
                                return arguments.length < 1 ? f : arguments.length > 1 ? d : (e = L(e)) instanceof Error ? e : e = Math.exp(e);
                            }, t.EXPON = fe, t.EXPONDIST = $t, t.F = de, t.FACT = ze, t.FACTDOUBLE = function e(t) {
                                if ((t = L(t)) instanceof Error) return t;
                                const n = Math.floor(t);
                                return n <= 0 ? 1 : n * e(n - 2);
                            }, t.FALSE = function() {
                                return !1;
                            }, t.FDIST = Jt, t.FDISTRT = Qt, t.FIND = function(e, t, n) {
                                if (arguments.length < 2) return f;
                                e = O(e), n = void 0 === n ? 0 : n;
                                const r = (t = O(t)).indexOf(e, n - 1);
                                return -1 === r ? l : r + 1;
                            }, t.FINV = Zt, t.FINVRT = en, t.FISHER = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.log((1 + e) / (1 - e)) / 2;
                            }, t.FISHERINV = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                const t = Math.exp(2 * e);
                                return (t - 1) / (t + 1);
                            }, t.FIXED = vt, t.FLOOR = Ye, t.FLOORMATH = tn, t.FLOORPRECISE = nn, t.FORECAST = pe, t.FREQUENCY = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                const n = e.length, r = t.length, o = [];
                                for(let i = 0; i <= r; i++){
                                    o[i] = 0;
                                    for(let s = 0; s < n; s++)0 === i ? e[s] <= t[0] && (o[0] += 1) : i < r ? e[s] > t[i - 1] && e[s] <= t[i] && (o[i] += 1) : i === r && e[s] > t[r - 1] && (o[r] += 1);
                                }
                                return o;
                            }, t.FTEST = rn, t.FV = Yn, t.FVSCHEDULE = function(e, t) {
                                if (N(e = L(e), t = R(C(t)))) return l;
                                const n = t.length;
                                let r = e;
                                for(let e = 0; e < n; e++)r *= 1 + t[e];
                                return r;
                            }, t.GAMMA = he, t.GAMMADIST = on, t.GAMMAINV = sn, t.GAMMALN = ge, t.GAMMALNPRECISE = ln, t.GAUSS = function(e) {
                                return (e = L(e)) instanceof Error ? e : r.normal.cdf(e, 0, 1) - .5;
                            }, t.GCD = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = e.length, n = e[0];
                                let r = n < 0 ? -n : n;
                                for(let n = 1; n < t; n++){
                                    const t = e[n];
                                    let o = t < 0 ? -t : t;
                                    for(; r && o;)r > o ? r %= o : o %= r;
                                    r += o;
                                }
                                return r;
                            }, t.GEOMEAN = function() {
                                const e = R(C(arguments));
                                return e instanceof Error ? e : r.geomean(e);
                            }, t.GESTEP = function(e, t) {
                                return N(t = t || 0, e = L(e)) ? e : e >= t ? 1 : 0;
                            }, t.GROWTH = function(e, t, n, r) {
                                if ((e = R(e)) instanceof Error) return e;
                                let o;
                                if (void 0 === t) for(t = [], o = 1; o <= e.length; o++)t.push(o);
                                if (void 0 === n) for(n = [], o = 1; o <= e.length; o++)n.push(o);
                                if (N(t = R(t), n = R(n))) return l;
                                void 0 === r && (r = !0);
                                const i = e.length;
                                let s, a, u = 0, c = 0, f = 0, d = 0;
                                for(o = 0; o < i; o++){
                                    const n = t[o], r = Math.log(e[o]);
                                    u += n, c += r, f += n * r, d += n * n;
                                }
                                u /= i, c /= i, f /= i, d /= i, r ? (s = (f - u * c) / (d - u * u), a = c - s * u) : (s = f / d, a = 0);
                                const p = [];
                                for(o = 0; o < n.length; o++)p.push(Math.exp(a + s * n[o]));
                                return p;
                            }, t.HARMEAN = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = e.length;
                                let n = 0;
                                for(let r = 0; r < t; r++)n += 1 / e[r];
                                return t / n;
                            }, t.HEX2BIN = function(e, t) {
                                if (!/^[0-9A-Fa-f]{1,10}$/.test(e)) return c;
                                const n = !(10 !== e.length || "f" !== e.substring(0, 1).toLowerCase()), r = n ? parseInt(e, 16) - 1099511627776 : parseInt(e, 16);
                                if (r < -512 || r > 511) return c;
                                if (n) return "1" + yt("0", 9 - (512 + r).toString(2).length) + (512 + r).toString(2);
                                const o = r.toString(2);
                                return void 0 === t ? o : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= o.length ? yt("0", t - o.length) + o : c;
                            }, t.HEX2DEC = function(e) {
                                if (!/^[0-9A-Fa-f]{1,10}$/.test(e)) return c;
                                const t = parseInt(e, 16);
                                return t >= 549755813888 ? t - 1099511627776 : t;
                            }, t.HEX2OCT = function(e, t) {
                                if (!/^[0-9A-Fa-f]{1,10}$/.test(e)) return c;
                                const n = parseInt(e, 16);
                                if (n > 536870911 && n < 0xffe0000000) return c;
                                if (n >= 0xffe0000000) return (n - 0xffc0000000).toString(8);
                                const r = n.toString(8);
                                return void 0 === t ? r : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= r.length ? yt("0", t - r.length) + r : c;
                            }, t.HLOOKUP = function(e, t, n, r) {
                                return ee(e, E(t), n, r);
                            }, t.HOUR = function(e) {
                                return (e = T(e)) instanceof Error ? e : e.getHours();
                            }, t.HYPGEOM = me, t.HYPGEOMDIST = an, t.IF = function(e, t, n) {
                                return e instanceof Error ? e : (null == (t = !(arguments.length >= 2) || t) && (t = 0), null == (n = 3 === arguments.length && n) && (n = 0), e ? t : n);
                            }, t.IFERROR = function(e, t) {
                                return K(e) ? t : e;
                            }, t.IFNA = function(e, t) {
                                return e === f ? t : e;
                            }, t.IFS = function() {
                                for(let e = 0; e < arguments.length / 2; e++)if (arguments[2 * e]) return arguments[2 * e + 1];
                                return f;
                            }, t.IMABS = It, t.IMAGINARY = Nt, t.IMARGUMENT = xt, t.IMCONJUGATE = function(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", 0 !== n ? At(t, -n, r) : e;
                            }, t.IMCOS = St, t.IMCOSH = Dt, t.IMCOT = function(e) {
                                return N(Ft(e), Nt(e)) ? l : Tt(St(e), Lt(e));
                            }, t.IMCSC = function(e) {
                                return !0 === e || !1 === e ? l : N(Ft(e), Nt(e)) ? c : Tt("1", Lt(e));
                            }, t.IMCSCH = function(e) {
                                return !0 === e || !1 === e ? l : N(Ft(e), Nt(e)) ? c : Tt("1", Rt(e));
                            }, t.IMDIV = Tt, t.IMEXP = function(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                r = "i" === r || "j" === r ? r : "i";
                                const o = Math.exp(t);
                                return At(o * Math.cos(n), o * Math.sin(n), r);
                            }, t.IMLN = function(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.log(Math.sqrt(t * t + n * n)), Math.atan(n / t), r);
                            }, t.IMLOG10 = function(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.log(Math.sqrt(t * t + n * n)) / Math.log(10), Math.atan(n / t) / Math.log(10), r);
                            }, t.IMLOG2 = function(e) {
                                const t = Ft(e), n = Nt(e);
                                if (N(t, n)) return l;
                                let r = e.substring(e.length - 1);
                                return r = "i" === r || "j" === r ? r : "i", At(Math.log(Math.sqrt(t * t + n * n)) / Math.log(2), Math.atan(n / t) / Math.log(2), r);
                            }, t.IMPOWER = function(e, t) {
                                if (N(t = L(t), Ft(e), Nt(e))) return l;
                                let n = e.substring(e.length - 1);
                                n = "i" === n || "j" === n ? n : "i";
                                const r = Math.pow(It(e), t), o = xt(e);
                                return At(r * Math.cos(t * o), r * Math.sin(t * o), n);
                            }, t.IMPRODUCT = function() {
                                let e = arguments[0];
                                if (!arguments.length) return l;
                                for(let t = 1; t < arguments.length; t++){
                                    const n = Ft(e), r = Nt(e), o = Ft(arguments[t]), i = Nt(arguments[t]);
                                    if (N(n, r, o, i)) return l;
                                    e = At(n * o - r * i, n * i + r * o);
                                }
                                return e;
                            }, t.IMREAL = Ft, t.IMSEC = function(e) {
                                return !0 === e || !1 === e || N(Ft(e), Nt(e)) ? l : Tt("1", St(e));
                            }, t.IMSECH = function(e) {
                                return N(Ft(e), Nt(e)) ? l : Tt("1", Dt(e));
                            }, t.IMSIN = Lt, t.IMSINH = Rt, t.IMSQRT = function(e) {
                                if (N(Ft(e), Nt(e))) return l;
                                let t = e.substring(e.length - 1);
                                t = "i" === t || "j" === t ? t : "i";
                                const n = Math.sqrt(It(e)), r = xt(e);
                                return At(n * Math.cos(r / 2), n * Math.sin(r / 2), t);
                            }, t.IMSUB = function(e, t) {
                                const n = Ft(e), r = Nt(e), o = Ft(t), i = Nt(t);
                                if (N(n, r, o, i)) return l;
                                const s = e.substring(e.length - 1), a = t.substring(t.length - 1);
                                let u = "i";
                                return ("j" === s || "j" === a) && (u = "j"), At(n - o, r - i, u);
                            }, t.IMSUM = function() {
                                if (!arguments.length) return l;
                                const e = C(arguments);
                                let t = e[0];
                                for(let n = 1; n < e.length; n++){
                                    const r = Ft(t), o = Nt(t), i = Ft(e[n]), s = Nt(e[n]);
                                    if (N(r, o, i, s)) return l;
                                    t = At(r + i, o + s);
                                }
                                return t;
                            }, t.IMTAN = function(e) {
                                return !0 === e || !1 === e || N(Ft(e), Nt(e)) ? l : Tt(Lt(e), St(e));
                            }, t.INDEX = function(e, t, n) {
                                const r = I(e, t, n);
                                if (r) return r;
                                if (!Array.isArray(e)) return l;
                                const o = e.length > 0 && !Array.isArray(e[0]);
                                return o && !n ? (n = t, t = 1) : (n = n || 1, t = t || 1), n < 0 || t < 0 ? l : o && 1 === t && n <= e.length ? e[n - 1] : t <= e.length && n <= e[t - 1].length ? e[t - 1][n - 1] : a;
                            }, t.INFO = function() {
                                throw new Error("INFO is not implemented");
                            }, t.INT = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.floor(e);
                            }, t.INTERCEPT = function(e, t) {
                                return N(e = R(e), t = R(t)) ? l : e.length !== t.length ? f : pe(0, e, t);
                            }, t.INTRATE = function() {
                                throw new Error("INTRATE is not implemented");
                            }, t.IPMT = Wn, t.IRR = function(e, t) {
                                if (t = t || 0, N(e = R(C(e)), t = L(t))) return l;
                                const n = (e, t, n)=>{
                                    const r = n + 1;
                                    let o = e[0];
                                    for(let n = 1; n < e.length; n++)o += e[n] / Math.pow(r, (t[n] - t[0]) / 365);
                                    return o;
                                }, r = (e, t, n)=>{
                                    const r = n + 1;
                                    let o = 0;
                                    for(let n = 1; n < e.length; n++){
                                        const i = (t[n] - t[0]) / 365;
                                        o -= i * e[n] / Math.pow(r, i + 1);
                                    }
                                    return o;
                                }, o = [];
                                let i = !1, s = !1;
                                for(let t = 0; t < e.length; t++)o[t] = 0 === t ? 0 : o[t - 1] + 365, e[t] > 0 && (i = !0), e[t] < 0 && (s = !0);
                                if (!i || !s) return c;
                                let a, u, f, d = t = void 0 === t ? .1 : t, p = !0;
                                do f = n(e, o, d), a = d - f / r(e, o, d), u = Math.abs(a - d), d = a, p = u > 1e-10 && Math.abs(f) > 1e-10;
                                while (p);
                                return d;
                            }, t.ISBLANK = function(e) {
                                return null === e;
                            }, t.ISERR = G, t.ISERROR = K, t.ISEVEN = function(e) {
                                return !(1 & Math.floor(Math.abs(e)));
                            }, t.ISFORMULA = function() {
                                throw new Error("ISFORMULA is not implemented");
                            }, t.ISLOGICAL = $1, t.ISNA = function(e) {
                                return e === f;
                            }, t.ISNONTEXT = function(e) {
                                return "string" != typeof e;
                            }, t.ISNUMBER = J, t.ISO = We, t.ISODD = function(e) {
                                return !!(1 & Math.floor(Math.abs(e)));
                            }, t.ISOWEEKNUM = st, t.ISPMT = function(e, t, n, r) {
                                return N(e = L(e), t = L(t), n = L(n), r = L(r)) ? l : r * e * (t / n - 1);
                            }, t.ISREF = function() {
                                throw new Error("ISREF is not implemented");
                            }, t.ISTEXT = Q, t.KURT = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                const t = r.mean(e), n = e.length;
                                let o = 0;
                                for(let r = 0; r < n; r++)o += Math.pow(e[r] - t, 4);
                                return o /= Math.pow(r.stdev(e, !0), 4), n * (n + 1) / ((n - 1) * (n - 2) * (n - 3)) * o - 3 * (n - 1) * (n - 1) / ((n - 2) * (n - 3));
                            }, t.LARGE = ve, t.LCM = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                for(var t, n, r, o, i = 1; void 0 !== (r = e.pop());){
                                    if (0 === r) return 0;
                                    for(; r > 1;){
                                        if (r % 2) {
                                            for(t = 3, n = Math.floor(Math.sqrt(r)); t <= n && r % t; t += 2);
                                            o = t <= n ? t : r;
                                        } else o = 2;
                                        for(r /= o, i *= o, t = e.length; t; e[--t] % o == 0 && 1 == (e[t] /= o) && e.splice(t, 1));
                                    }
                                }
                                return i;
                            }, t.LEFT = function(e, t) {
                                return I(e, t) || (e = O(e), (t = L(t = void 0 === t ? 1 : t)) instanceof Error || "string" != typeof e ? l : e.substring(0, t));
                            }, t.LEN = function(e) {
                                return 0 === arguments.length ? d : e instanceof Error ? e : Array.isArray(e) ? l : O(e).length;
                            }, t.LINEST = ye, t.LN = function(e) {
                                return (e = L(e)) instanceof Error ? e : 0 === e ? c : Math.log(e);
                            }, t.LOG = function(e, t) {
                                return I(e = L(e), t = L(t)) || (0 === e || 0 === t ? c : Math.log(e) / Math.log(t));
                            }, t.LOG10 = function(e) {
                                return (e = L(e)) instanceof Error ? e : 0 === e ? c : Math.log(e) / Math.log(10);
                            }, t.LOGEST = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                if (e.length !== t.length) return l;
                                for(let t = 0; t < e.length; t++)e[t] = Math.log(e[t]);
                                const n = ye(e, t);
                                return n[0] = Math.round(1e6 * Math.exp(n[0])) / 1e6, n[1] = Math.round(1e6 * Math.exp(n[1])) / 1e6, n;
                            }, t.LOGINV = un, t.LOGNORM = Ce, t.LOGNORMDIST = cn, t.LOGNORMINV = fn, t.LOOKUP = function(e, t, n) {
                                t = C(t), n = n ? C(n) : t;
                                const r = "number" == typeof e;
                                let o = f;
                                for(let i = 0; i < t.length; i++){
                                    if (t[i] === e) return n[i];
                                    if (r && t[i] <= e || "string" == typeof t[i] && t[i].localeCompare(e) < 0) o = n[i];
                                    else if (r && t[i] > e) return o;
                                }
                                return o;
                            }, t.LOWER = function(e) {
                                return 1 !== arguments.length ? l : N(e = O(e)) ? e : e.toLowerCase();
                            }, t.MATCH = function(e, t, n) {
                                if (!e || !t) return f;
                                if (2 === arguments.length && (n = 1), !((t = C(t)) instanceof Array)) return f;
                                if (-1 !== n && 0 !== n && 1 !== n) return f;
                                let r, o;
                                for(let i = 0; i < t.length; i++)if (1 === n) {
                                    if (t[i] === e) return i + 1;
                                    t[i] < e && (o ? t[i] > o && (r = i + 1, o = t[i]) : (r = i + 1, o = t[i]));
                                } else if (0 === n) {
                                    if ("string" == typeof e && "string" == typeof t[i]) {
                                        const n = e.toLowerCase().replace(/\?/g, ".").replace(/\*/g, ".*").replace(/~/g, "\\");
                                        if (new RegExp("^" + n + "$").test(t[i].toLowerCase())) return i + 1;
                                    } else if (t[i] === e) return i + 1;
                                } else if (-1 === n) {
                                    if (t[i] === e) return i + 1;
                                    t[i] > e && (o ? t[i] < o && (r = i + 1, o = t[i]) : (r = i + 1, o = t[i]));
                                }
                                return r || f;
                            }, t.MAX = we, t.MAXA = function() {
                                const e = C(arguments), t = I.apply(void 0, e);
                                if (t) return t;
                                let n = v(e);
                                return n = n.map((e)=>null == e ? 0 : e), 0 === n.length ? 0 : Math.max.apply(Math, n);
                            }, t.MDURATION = function() {
                                throw new Error("MDURATION is not implemented");
                            }, t.MEDIAN = be, t.MID = function(e, t, n) {
                                if (null == t) return l;
                                if (N(t = L(t), n = L(n)) || "string" != typeof e) return n;
                                const r = t - 1, o = r + n;
                                return e.substring(r, o);
                            }, t.MIN = Ae, t.MINA = function() {
                                const e = C(arguments), t = I.apply(void 0, e);
                                if (t) return t;
                                let n = v(e);
                                return n = n.map((e)=>null == e ? 0 : e), 0 === n.length ? 0 : Math.min.apply(Math, n);
                            }, t.MINUTE = function(e) {
                                return (e = T(e)) instanceof Error ? e : e.getMinutes();
                            }, t.MIRR = function(e, t, n) {
                                if (N(e = R(C(e)), t = L(t), n = L(n))) return l;
                                const r = e.length, o = [], i = [];
                                for(let t = 0; t < r; t++)e[t] < 0 ? o.push(e[t]) : i.push(e[t]);
                                const s = -Xn(n, i) * Math.pow(1 + n, r - 1), a = Xn(t, o) * (1 + t);
                                return Math.pow(s / a, 1 / (r - 1)) - 1;
                            }, t.MMULT = function(e, t) {
                                return !Array.isArray(e) || !Array.isArray(t) || e.some((e)=>!e.length) || t.some((e)=>!e.length) || w(e).some((e)=>"number" != typeof e) || w(t).some((e)=>"number" != typeof e) || e[0].length !== t.length ? l : Array(e.length).fill(0).map(()=>Array(t[0].length).fill(0)).map((n, r)=>n.map((n, o)=>e[r].reduce((e, n, r)=>e + n * t[r][o], 0)));
                            }, t.MOD = function(e, t) {
                                const n = I(e = L(e), t = L(t));
                                if (n) return n;
                                if (0 === t) return s;
                                let r = Math.abs(e % t);
                                return r = e < 0 ? t - r : r, t > 0 ? r : -r;
                            }, t.MODE = Ee, t.MODEMULT = dn, t.MODESNGL = pn, t.MONTH = function(e) {
                                return (e = T(e)) instanceof Error ? e : e.getMonth() + 1;
                            }, t.MROUND = function(e, t) {
                                return I(e = L(e), t = L(t)) || (e * t == 0 ? 0 : e * t < 0 ? c : Math.round(e / t) * t);
                            }, t.MULTINOMIAL = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                let t = 0, n = 1;
                                for(let r = 0; r < e.length; r++)t += e[r], n *= ze(e[r]);
                                return ze(t) / n;
                            }, t.MUNIT = function(e) {
                                return arguments.length > 1 ? f : !(e = parseInt(e)) || e <= 0 ? l : Array(e).fill(0).map(()=>Array(e).fill(0)).map((e, t)=>(e[t] = 1, e));
                            }, t.N = function(e) {
                                return J(e) ? e : e instanceof Date ? e.getTime() : !0 === e ? 1 : !1 === e ? 0 : K(e) ? e : 0;
                            }, t.NA = function() {
                                return f;
                            }, t.NEGBINOM = Me, t.NEGBINOMDIST = hn, t.NETWORKDAYS = lt, t.NETWORKDAYSINTL = gn, t.NOMINAL = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : e <= 0 || t < 1 ? c : (t = parseInt(t, 10), (Math.pow(e + 1, 1 / t) - 1) * t);
                            }, t.NORM = Ie, t.NORMDIST = mn, t.NORMINV = vn, t.NORMSDIST = yn, t.NORMSINV = Cn, t.NOT = function(e) {
                                return "string" == typeof e ? l : e instanceof Error ? e : !e;
                            }, t.NOW = function() {
                                return new Date;
                            }, t.NPER = function(e, t, n, r, o) {
                                if (o = void 0 === o ? 0 : o, r = void 0 === r ? 0 : r, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o))) return l;
                                if (0 === e) return -(n + r) / t;
                                {
                                    const i = t * (1 + e * o) - r * e, s = n * e + t * (1 + e * o);
                                    return Math.log(i / s) / Math.log(1 + e);
                                }
                            }, t.NPV = Xn, t.NUMBERVALUE = function(e, t, n) {
                                return "number" == typeof (e = B(e) ? e : "") ? e : "string" != typeof e ? f : (t = void 0 === t ? "." : t, n = void 0 === n ? "," : n, Number(e.replace(t, ".").replace(n, "")));
                            }, t.OCT2BIN = function(e, t) {
                                if (!/^[0-7]{1,10}$/.test(e)) return c;
                                const n = !(10 !== e.length || "7" !== e.substring(0, 1)), r = n ? parseInt(e, 8) - 1073741824 : parseInt(e, 8);
                                if (r < -512 || r > 511) return c;
                                if (n) return "1" + yt("0", 9 - (512 + r).toString(2).length) + (512 + r).toString(2);
                                const o = r.toString(2);
                                return void 0 === t ? o : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= o.length ? yt("0", t - o.length) + o : c;
                            }, t.OCT2DEC = function(e) {
                                if (!/^[0-7]{1,10}$/.test(e)) return c;
                                const t = parseInt(e, 8);
                                return t >= 536870912 ? t - 1073741824 : t;
                            }, t.OCT2HEX = function(e, t) {
                                if (!/^[0-7]{1,10}$/.test(e)) return c;
                                const n = parseInt(e, 8);
                                if (n >= 536870912) return "ff" + (n + 3221225472).toString(16);
                                const r = n.toString(16);
                                return void 0 === t ? r : isNaN(t) ? l : t < 0 ? c : (t = Math.floor(t)) >= r.length ? yt("0", t - r.length) + r : c;
                            }, t.ODD = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                let t = Math.ceil(Math.abs(e));
                                return t = 1 & t ? t : t + 1, e >= 0 ? t : -t;
                            }, t.ODDFPRICE = function() {
                                throw new Error("ODDFPRICE is not implemented");
                            }, t.ODDFYIELD = function() {
                                throw new Error("ODDFYIELD is not implemented");
                            }, t.ODDLPRICE = function() {
                                throw new Error("ODDLPRICE is not implemented");
                            }, t.ODDLYIELD = function() {
                                throw new Error("ODDLYIELD is not implemented");
                            }, t.OR = function() {
                                const e = C(arguments);
                                let t = l;
                                for(let n = 0; n < e.length; n++){
                                    if (e[n] instanceof Error) return e[n];
                                    void 0 !== e[n] && null !== e[n] && "string" != typeof e[n] && (t === l && (t = !1), e[n] && (t = !0));
                                }
                                return t;
                            }, t.PDURATION = function(e, t, n) {
                                return N(e = L(e), t = L(t), n = L(n)) ? l : e <= 0 ? c : (Math.log(n) - Math.log(t)) / Math.log(1 + e);
                            }, t.PEARSON = Ne, t.PERCENTILE = xe, t.PERCENTILEEXC = wn, t.PERCENTILEINC = bn, t.PERCENTRANK = Se, t.PERCENTRANKEXC = An, t.PERCENTRANKINC = En, t.PERMUT = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : ze(e) / ze(e - t);
                            }, t.PERMUTATIONA = function(e, t) {
                                return N(e = L(e), t = L(t)) ? l : Math.pow(e, t);
                            }, t.PHI = function(e) {
                                return (e = L(e)) instanceof Error ? l : Math.exp(-0.5 * e * e) / 2.5066282746310002;
                            }, t.PI = function() {
                                return Math.PI;
                            }, t.PMT = Gn, t.POISSON = De, t.POISSONDIST = Mn, t.POWER = Xe, t.PPMT = function(e, t, n, r, o, i) {
                                return o = o || 0, i = i || 0, N(e = L(e), n = L(n), r = L(r), o = L(o), i = L(i)) ? l : Gn(e, n, r, o, i) - Wn(e, t, n, r, o, i);
                            }, t.PRICE = function() {
                                throw new Error("PRICE is not implemented");
                            }, t.PRICEDISC = function(e, t, n, r, o) {
                                if (N(e = T(e), t = T(t), n = L(n), r = L(r), o = (o = L(o)) || 0)) return l;
                                if (n <= 0 || r <= 0) return c;
                                if (e >= t) return l;
                                let i, s;
                                switch(o){
                                    case 0:
                                        i = 360, s = it(e, t, !1);
                                        break;
                                    case 1:
                                    case 3:
                                        i = 365, s = nt(e, t, "D");
                                        break;
                                    case 2:
                                        i = 360, s = nt(e, t, "D");
                                        break;
                                    case 4:
                                        i = 360, s = it(e, t, !0);
                                        break;
                                    default:
                                        return c;
                                }
                                return r - n * r * s / i;
                            }, t.PRICEMAT = function() {
                                throw new Error("PRICEMAT is not implemented");
                            }, t.PROB = function(e, t, n, r) {
                                if (void 0 === n) return 0;
                                if (r = void 0 === r ? n : r, N(e = R(C(e)), t = R(C(t)), n = L(n), r = L(r))) return l;
                                if (n === r) return e.indexOf(n) >= 0 ? t[e.indexOf(n)] : 0;
                                const o = e.sort((e, t)=>e - t), i = o.length;
                                let s = 0;
                                for(let l = 0; l < i; l++)o[l] >= n && o[l] <= r && (s += t[e.indexOf(o[l])]);
                                return s;
                            }, t.PRODUCT = Ge, t.PRONETIC = function() {
                                throw new Error("PRONETIC is not implemented");
                            }, t.PROPER = function(e) {
                                return N(e) ? e : isNaN(e) && "number" == typeof e ? l : (e = O(e)).replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.substr(1).toLowerCase());
                            }, t.PV = function(e, t, n, r, o) {
                                return r = r || 0, o = o || 0, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o)) ? l : 0 === e ? -n * t - r : ((1 - Math.pow(1 + e, t)) / e * n * (1 + e * o) - r) / Math.pow(1 + e, t);
                            }, t.QUARTILE = Te, t.QUARTILEEXC = In, t.QUARTILEINC = Nn, t.QUOTIENT = function(e, t) {
                                return I(e = L(e), t = L(t)) || parseInt(e / t, 10);
                            }, t.RADIANS = function(e) {
                                return (e = L(e)) instanceof Error ? e : e * Math.PI / 180;
                            }, t.RAND = function() {
                                return Math.random();
                            }, t.RANDBETWEEN = function(e, t) {
                                return I(e = L(e), t = L(t)) || e + Math.ceil((t - e + 1) * Math.random()) - 1;
                            }, t.RANK = Fe, t.RANKAVG = xn, t.RANKEQ = Sn, t.RATE = function(e, t, n, r, o, i) {
                                if (i = void 0 === i ? .01 : i, r = void 0 === r ? 0 : r, o = void 0 === o ? 0 : o, N(e = L(e), t = L(t), n = L(n), r = L(r), o = L(o), i = L(i))) return l;
                                const s = 1e-10;
                                let a = i;
                                o = o ? 1 : 0;
                                for(let i = 0; i < 20; i++){
                                    if (a <= -1) return c;
                                    let i, l, u;
                                    if (Math.abs(a) < s ? i = n * (1 + e * a) + t * (1 + a * o) * e + r : (l = Math.pow(1 + a, e), i = n * l + t * (1 / a + o) * (l - 1) + r), Math.abs(i) < s) return a;
                                    if (Math.abs(a) < s) u = n * e + t * o * e;
                                    else {
                                        l = Math.pow(1 + a, e);
                                        const r = e * Math.pow(1 + a, e - 1);
                                        u = n * r + t * (1 / a + o) * r + t * (-1 / (a * a)) * (l - 1);
                                    }
                                    a -= i / u;
                                }
                                return a;
                            }, t.RECEIVED = function() {
                                throw new Error("RECEIVED is not implemented");
                            }, t.REPLACE = function(e, t, n, r) {
                                return N(t = L(t), n = L(n)) || "string" != typeof e || "string" != typeof r ? l : e.substr(0, t - 1) + r + e.substr(t - 1 + n);
                            }, t.REPT = yt, t.RIGHT = function(e, t) {
                                return I(e, t) || (e = O(e), (t = L(t = void 0 === t ? 1 : t)) instanceof Error ? t : e.substring(e.length - t));
                            }, t.ROMAN = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                const t = String(e).split(""), n = [
                                    "",
                                    "C",
                                    "CC",
                                    "CCC",
                                    "CD",
                                    "D",
                                    "DC",
                                    "DCC",
                                    "DCCC",
                                    "CM",
                                    "",
                                    "X",
                                    "XX",
                                    "XXX",
                                    "XL",
                                    "L",
                                    "LX",
                                    "LXX",
                                    "LXXX",
                                    "XC",
                                    "",
                                    "I",
                                    "II",
                                    "III",
                                    "IV",
                                    "V",
                                    "VI",
                                    "VII",
                                    "VIII",
                                    "IX"
                                ];
                                let r = "", o = 3;
                                for(; o--;)r = (n[+t.pop() + 10 * o] || "") + r;
                                return new Array(+t.join("") + 1).join("M") + r;
                            }, t.ROUND = Ke, t.ROUNDDOWN = function(e, t) {
                                return I(e = L(e), t = L(t)) || (e > 0 ? 1 : -1) * Math.floor(Math.abs(e) * Math.pow(10, t)) / Math.pow(10, t);
                            }, t.ROUNDUP = function(e, t) {
                                return I(e = L(e), t = L(t)) || (e > 0 ? 1 : -1) * Math.ceil(Math.abs(e) * Math.pow(10, t)) / Math.pow(10, t);
                            }, t.ROW = function(e, t) {
                                return 2 !== arguments.length ? f : t < 0 ? c : e instanceof Array && "number" == typeof t ? 0 !== e.length ? r.row(e, t) : void 0 : l;
                            }, t.ROWS = function(e) {
                                return 1 !== arguments.length ? f : e instanceof Array ? 0 === e.length ? 0 : r.rows(e) : l;
                            }, t.RRI = function(e, t, n) {
                                return N(e = L(e), t = L(t), n = L(n)) ? l : 0 === e || 0 === t ? c : Math.pow(n / t, 1 / e) - 1;
                            }, t.RSQ = function(e, t) {
                                return N(e = R(C(e)), t = R(C(t))) ? l : Math.pow(Ne(e, t), 2);
                            }, t.SEARCH = function(e, t, n) {
                                let r;
                                return "string" != typeof e || "string" != typeof t ? l : (n = void 0 === n ? 0 : n, r = t.toLowerCase().indexOf(e.toLowerCase(), n - 1) + 1, 0 === r ? l : r);
                            }, t.SEC = function(e) {
                                return (e = L(e)) instanceof Error ? e : 1 / Math.cos(e);
                            }, t.SECH = function(e) {
                                return (e = L(e)) instanceof Error ? e : 2 / (Math.exp(e) + Math.exp(-e));
                            }, t.SECOND = function(e) {
                                return (e = T(e)) instanceof Error ? e : e.getSeconds();
                            }, t.SERIESSUM = function(e, t, n, r) {
                                if (N(e = L(e), t = L(t), n = L(n), r = R(r))) return l;
                                let o = r[0] * Math.pow(e, t);
                                for(let i = 1; i < r.length; i++)o += r[i] * Math.pow(e, t + i * n);
                                return o;
                            }, t.SHEET = function() {
                                throw new Error("SHEET is not implemented");
                            }, t.SHEETS = function() {
                                throw new Error("SHEETS is not implemented");
                            }, t.SIGN = function(e) {
                                return (e = L(e)) instanceof Error ? e : e < 0 ? -1 : 0 === e ? 0 : 1;
                            }, t.SIN = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.sin(e);
                            }, t.SINH = function(e) {
                                return (e = L(e)) instanceof Error ? e : (Math.exp(e) - Math.exp(-e)) / 2;
                            }, t.SKEW = Le, t.SKEWP = Dn, t.SLN = function(e, t, n) {
                                return N(e = L(e), t = L(t), n = L(n)) ? l : 0 === n ? c : (e - t) / n;
                            }, t.SLOPE = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                const n = r.mean(t), o = r.mean(e), i = t.length;
                                let s = 0, a = 0;
                                for(let r = 0; r < i; r++)s += (t[r] - n) * (e[r] - o), a += Math.pow(t[r] - n, 2);
                                return s / a;
                            }, t.SMALL = Re, t.SORT = function(e, t = 1, n = 1, r = !1) {
                                if (!e || !Array.isArray(e)) return f;
                                if (0 === e.length) return 0;
                                if (!(t = L(t)) || t < 1) return l;
                                if (1 !== (n = L(n)) && -1 !== n) return l;
                                if ("boolean" != typeof (r = D(r))) return u;
                                const o = (e)=>e.sort((e, r)=>(e = O(e[t - 1]), r = O(r[t - 1]), 1 === n ? e < r ? -1 * n : n : e > r ? n : -1 * n)), i = y(e), s = r ? E(i) : i;
                                return t >= 1 && t <= s[0].length ? r ? E(o(s)) : o(s) : l;
                            }, t.SQRT = function(e) {
                                return (e = L(e)) instanceof Error ? e : e < 0 ? c : Math.sqrt(e);
                            }, t.SQRTPI = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.sqrt(e * Math.PI);
                            }, t.STANDARDIZE = function(e, t, n) {
                                return N(e = L(e), t = L(t), n = L(n)) ? l : (e - t) / n;
                            }, t.STDEV = Oe, t.STDEVA = function() {
                                const e = je.apply(this, arguments);
                                return Math.sqrt(e);
                            }, t.STDEVP = Tn, t.STDEVPA = function() {
                                const e = ke.apply(this, arguments);
                                let t = Math.sqrt(e);
                                return isNaN(t) && (t = c), t;
                            }, t.STDEVS = Fn, t.STEYX = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                const n = r.mean(t), o = r.mean(e), i = t.length;
                                let s = 0, a = 0, u = 0;
                                for(let r = 0; r < i; r++)s += Math.pow(e[r] - o, 2), a += (t[r] - n) * (e[r] - o), u += Math.pow(t[r] - n, 2);
                                return Math.sqrt((s - a * a / u) / (i - 2));
                            }, t.SUBSTITUTE = function(e, t, n, r) {
                                if (arguments.length < 3) return f;
                                if (e && t) {
                                    if (void 0 === r) return e.split(t).join(n);
                                    {
                                        if (r = Math.floor(Number(r)), Number.isNaN(r) || r <= 0) return l;
                                        let o = 0, i = 0;
                                        for(; o > -1 && e.indexOf(t, o) > -1;)if (o = e.indexOf(t, o + 1), i++, o > -1 && i === r) return e.substring(0, o) + n + e.substring(o + t.length);
                                        return e;
                                    }
                                }
                                return e;
                            }, t.SUBTOTAL = function(e, t) {
                                if ((e = L(e)) instanceof Error) return e;
                                switch(e){
                                    case 1:
                                    case 101:
                                        return te(t);
                                    case 2:
                                    case 102:
                                        return le(t);
                                    case 3:
                                    case 103:
                                        return ae(t);
                                    case 4:
                                    case 104:
                                        return we(t);
                                    case 5:
                                    case 105:
                                        return Ae(t);
                                    case 6:
                                    case 106:
                                        return Ge(t);
                                    case 7:
                                    case 107:
                                        return Oe.S(t);
                                    case 8:
                                    case 108:
                                        return Oe.P(t);
                                    case 9:
                                    case 109:
                                        return $e(t);
                                    case 10:
                                    case 110:
                                        return Be.S(t);
                                    case 11:
                                    case 111:
                                        return Be.P(t);
                                }
                            }, t.SUM = $e, t.SUMIF = function(e, t, n) {
                                if (e = C(e), n = n ? C(n) : e, e instanceof Error) return e;
                                if (null == t || t instanceof Error) return 0;
                                let r = 0;
                                const o = "*" === t, i = o ? null : Y(t + "");
                                for(let t = 0; t < e.length; t++){
                                    const s = e[t], l = n[t];
                                    if (o) r += s;
                                    else {
                                        const e = [
                                            z(s, q)
                                        ].concat(i);
                                        r += W(e) ? l : 0;
                                    }
                                }
                                return r;
                            }, t.SUMIFS = function() {
                                const e = g(arguments), t = R(C(e.shift()));
                                if (t instanceof Error) return t;
                                const n = e, r = n.length / 2;
                                for(let e = 0; e < r; e++)n[2 * e] = C(n[2 * e]);
                                let o = 0;
                                for(let e = 0; e < t.length; e++){
                                    let i = !1;
                                    for(let t = 0; t < r; t++){
                                        const r = n[2 * t][e], o = n[2 * t + 1];
                                        let s = !1;
                                        if (void 0 === o || "*" === o) s = !0;
                                        else {
                                            const e = Y(o + ""), t = [
                                                z(r, q)
                                            ].concat(e);
                                            s = W(t);
                                        }
                                        if (!s) {
                                            i = !1;
                                            break;
                                        }
                                        i = !0;
                                    }
                                    i && (o += t[e]);
                                }
                                return o;
                            }, t.SUMPRODUCT = function() {
                                if (!arguments || 0 === arguments.length) return l;
                                const e = arguments.length + 1;
                                let t, n, r, o, i = 0;
                                for(let s = 0; s < arguments[0].length; s++)if (arguments[0][s] instanceof Array) for(let r = 0; r < arguments[0][s].length; r++){
                                    for(t = 1, n = 1; n < e; n++){
                                        const e = arguments[n - 1][s][r];
                                        if (e instanceof Error) return e;
                                        if (o = L(e), o instanceof Error) return o;
                                        t *= o;
                                    }
                                    i += t;
                                }
                                else {
                                    for(t = 1, n = 1; n < e; n++){
                                        const e = arguments[n - 1][s];
                                        if (e instanceof Error) return e;
                                        if (r = L(e), r instanceof Error) return r;
                                        t *= r;
                                    }
                                    i += t;
                                }
                                return i;
                            }, t.SUMSQ = function() {
                                const e = R(C(arguments));
                                if (e instanceof Error) return e;
                                let t = 0;
                                const n = e.length;
                                for(let r = 0; r < n; r++)t += J(e[r]) ? e[r] * e[r] : 0;
                                return t;
                            }, t.SUMX2MY2 = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                let n = 0;
                                for(let r = 0; r < e.length; r++)n += e[r] * e[r] - t[r] * t[r];
                                return n;
                            }, t.SUMX2PY2 = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                let n = 0;
                                e = R(C(e)), t = R(C(t));
                                for(let r = 0; r < e.length; r++)n += e[r] * e[r] + t[r] * t[r];
                                return n;
                            }, t.SUMXMY2 = function(e, t) {
                                if (N(e = R(C(e)), t = R(C(t)))) return l;
                                let n = 0;
                                e = C(e), t = C(t);
                                for(let r = 0; r < e.length; r++)n += Math.pow(e[r] - t[r], 2);
                                return n;
                            }, t.SWITCH = function() {
                                let e;
                                if (arguments.length > 0) {
                                    const t = arguments[0], n = arguments.length - 1, r = Math.floor(n / 2);
                                    let o = !1;
                                    const i = n % 2 != 0, s = n % 2 == 0 ? null : arguments[arguments.length - 1];
                                    if (r) {
                                        for(let n = 0; n < r; n++)if (t === arguments[2 * n + 1]) {
                                            e = arguments[2 * n + 2], o = !0;
                                            break;
                                        }
                                    }
                                    o || (e = i ? s : f);
                                } else e = l;
                                return e;
                            }, t.SYD = function(e, t, n, r) {
                                return N(e = L(e), t = L(t), n = L(n), r = L(r)) ? l : 0 === n || r < 1 || r > n ? c : (e - t) * (n - (r = parseInt(r, 10)) + 1) * 2 / (n * (n + 1));
                            }, t.T = function(e) {
                                return e instanceof Error || "string" == typeof e ? e : "";
                            }, t.TAN = function(e) {
                                return (e = L(e)) instanceof Error ? e : Math.tan(e);
                            }, t.TANH = function(e) {
                                if ((e = L(e)) instanceof Error) return e;
                                const t = Math.exp(2 * e);
                                return (t - 1) / (t + 1);
                            }, t.TBILLEQ = function(e, t, n) {
                                return N(e = T(e), t = T(t), n = L(n)) ? l : n <= 0 || e > t || t - e > 31536e6 ? c : 365 * n / (360 - n * it(e, t, !1));
                            }, t.TBILLPRICE = function(e, t, n) {
                                return N(e = T(e), t = T(t), n = L(n)) ? l : n <= 0 || e > t || t - e > 31536e6 ? c : 100 * (1 - n * it(e, t, !1) / 360);
                            }, t.TBILLYIELD = function(e, t, n) {
                                return N(e = T(e), t = T(t), n = L(n)) ? l : n <= 0 || e > t || t - e > 31536e6 ? c : 360 * (100 - n) / (n * it(e, t, !1));
                            }, t.TDIST = Ln, t.TDISTRT = Rn, t.TEXT = function(e, t) {
                                if (void 0 === e || e instanceof Error || t instanceof Error) return f;
                                if (null == t) return "";
                                if ("number" == typeof t) return String(t);
                                if ("string" != typeof t) return l;
                                const n = t.startsWith("$") ? "$" : "", r = t.endsWith("%");
                                return r && (e *= 100), e = (e = vt(e, (t = t.replace(/%/g, "").replace(/\$/g, "")).split(".")[1].match(/0/g).length, !t.includes(","))).startsWith("-") ? "-" + n + (e = e.replace("-", "")) : n + e, r && (e += "%"), e;
                            }, t.TEXTJOIN = function(e, t, ...n) {
                                if ("boolean" != typeof t && (t = D(t)), arguments.length < 3) return f;
                                e = null != e ? e : "";
                                let r = C(n), o = t ? r.filter((e)=>e) : r;
                                if (Array.isArray(e)) {
                                    e = C(e);
                                    let t = o.map((e)=>[
                                            e
                                        ]), n = 0;
                                    for(let r = 0; r < t.length - 1; r++)t[r].push(e[n]), n++, n === e.length && (n = 0);
                                    return o = C(t), o.join("");
                                }
                                return o.join(e);
                            }, t.TIME = function(e, t, n) {
                                return N(e = L(e), t = L(t), n = L(n)) ? l : e < 0 || t < 0 || n < 0 ? c : (3600 * e + 60 * t + n) / 86400;
                            }, t.TIMEVALUE = function(e) {
                                return (e = T(e)) instanceof Error ? e : (3600 * e.getHours() + 60 * e.getMinutes() + e.getSeconds()) / 86400;
                            }, t.TINV = On, t.TODAY = function() {
                                return rt(new Date);
                            }, t.TRANSPOSE = function(e) {
                                return e ? E(y(e)) : f;
                            }, t.TREND = function(e, t, n) {
                                if (N(e = R(C(e)), t = R(C(t)), n = R(C(n)))) return l;
                                const r = ye(e, t), o = r[0], i = r[1], s = [];
                                return n.forEach((e)=>{
                                    s.push(o * e + i);
                                }), s;
                            }, t.TRIM = function(e) {
                                return (e = O(e)) instanceof Error ? e : e.replace(/\s+/g, " ").trim();
                            }, t.TRIMMEAN = function(e, t) {
                                if (N(e = R(C(e)), t = L(t))) return l;
                                const n = Ye(e.length * t, 2) / 2;
                                var o, i;
                                return r.mean((i = (i = n) || 1, (o = A(e.sort((e, t)=>e - t), n)) && "function" == typeof o.slice ? o.slice(0, o.length - i) : o));
                            }, t.TRUE = function() {
                                return !0;
                            }, t.TRUNC = function(e, t) {
                                return I(e = L(e), t = L(t)) || (e > 0 ? 1 : -1) * Math.floor(Math.abs(e) * Math.pow(10, t)) / Math.pow(10, t);
                            }, t.TTEST = Hn, t.TYPE = function(e) {
                                return J(e) ? 1 : Q(e) ? 2 : $1(e) ? 4 : K(e) ? 16 : Array.isArray(e) ? 64 : void 0;
                            }, t.UNICHAR = Ct, t.UNICODE = wt, t.UNIQUE = Z, t.UPPER = function(e) {
                                return (e = O(e)) instanceof Error ? e : e.toUpperCase();
                            }, t.VALUE = function(e) {
                                const t = I(e);
                                if (t) return t;
                                if ("number" == typeof e) return e;
                                if (B(e) || (e = ""), "string" != typeof e) return l;
                                const n = /(%)$/.test(e) || /^(%)/.test(e);
                                if ("" === (e = (e = (e = e.replace(/^[^0-9-]{0,3}/, "")).replace(/[^0-9]{0,3}$/, "")).replace(/[ ,]/g, ""))) return 0;
                                let r = Number(e);
                                return isNaN(r) ? l : (r = r || 0, n && (r *= .01), r);
                            }, t.VAR = Be, t.VARA = je, t.VARP = Bn, t.VARPA = ke, t.VARS = jn, t.VDB = function() {
                                throw new Error("VDB is not implemented");
                            }, t.VLOOKUP = ee, t.WEEKDAY = function(e, t) {
                                if ((e = T(e)) instanceof Error) return e;
                                void 0 === t && (t = 1);
                                const n = e.getDay();
                                return et[t][n];
                            }, t.WEEKNUM = function(e, t) {
                                if ((e = T(e)) instanceof Error) return e;
                                if (void 0 === t && (t = 1), 21 === t) return st(e);
                                const n = Ze[t];
                                let r = new Date(e.getFullYear(), 0, 1);
                                const o = r.getDay() < n ? 1 : 0;
                                return r -= 24 * Math.abs(r.getDay() - n) * 3600000, Math.floor((e - r) / 864e5 / 7 + 1) + o;
                            }, t.WEIBULL = Pe, t.WEIBULLDIST = kn, t.WORKDAY = at, t.WORKDAYINTL = Pn, t.XIRR = function(e, t, n) {
                                if (N(e = R(C(e)), t = F(C(t)), n = L(n))) return l;
                                const r = (e, t, n)=>{
                                    const r = n + 1;
                                    let o = e[0];
                                    for(let n = 1; n < e.length; n++)o += e[n] / Math.pow(r, ot(t[n], t[0]) / 365);
                                    return o;
                                }, o = (e, t, n)=>{
                                    const r = n + 1;
                                    let o = 0;
                                    for(let n = 1; n < e.length; n++){
                                        const i = ot(t[n], t[0]) / 365;
                                        o -= i * e[n] / Math.pow(r, i + 1);
                                    }
                                    return o;
                                };
                                let i = !1, s = !1;
                                for(let t = 0; t < e.length; t++)e[t] > 0 && (i = !0), e[t] < 0 && (s = !0);
                                if (!i || !s) return c;
                                let a, u, f, d = n = n || .1, p = !0;
                                do f = r(e, t, d), a = d - f / o(e, t, d), u = Math.abs(a - d), d = a, p = u > 1e-10 && Math.abs(f) > 1e-10;
                                while (p);
                                return d;
                            }, t.XNPV = function(e, t, n) {
                                if (N(e = L(e), t = R(C(t)), n = F(C(n)))) return l;
                                let r = 0;
                                for(let o = 0; o < t.length; o++)r += t[o] / Math.pow(1 + e, ot(n[o], n[0]) / 365);
                                return r;
                            }, t.XOR = function() {
                                const e = C(arguments);
                                let t = l;
                                for(let n = 0; n < e.length; n++){
                                    if (e[n] instanceof Error) return e[n];
                                    void 0 !== e[n] && null !== e[n] && "string" != typeof e[n] && (t === l && (t = 0), e[n] && t++);
                                }
                                return t === l ? t : !!(1 & Math.floor(Math.abs(t)));
                            }, t.YEAR = function(e) {
                                return (e = T(e)) instanceof Error ? e : e.getFullYear();
                            }, t.YEARFRAC = ft, t.YIELD = function() {
                                throw new Error("YIELD is not implemented");
                            }, t.YIELDDISC = function() {
                                throw new Error("YIELDDISC is not implemented");
                            }, t.YIELDMAT = function() {
                                throw new Error("YIELDMAT is not implemented");
                            }, t.Z = Ve, t.ZTEST = Vn, t.utils = Kn;
                        }
                    }, n = {};
                    function r(t) {
                        var o = n[t];
                        if (void 0 !== o) return o.exports;
                        var i = n[t] = {
                            exports: {}
                        };
                        return e[t].call(i.exports, i, i.exports, r), i.exports;
                    }
                    r.g = function() {
                        if ("object" == typeof globalThis) return globalThis;
                        try {
                            return this || new Function("return this")();
                        } catch (e) {
                            if ("object" == typeof window) return window;
                        }
                    }();
                    var o = r(960);
                    t = o;
                }(), t);
            },
            44: function(e, t, n) {
                if (!r) var r = n(463);
                e.exports = function() {
                    "use strict";
                    var e, t = (e = {
                        title: "Jspreadsheet",
                        version: "4.15.0",
                        type: "CE",
                        host: "https://bossanova.uk/jspreadsheet",
                        license: "MIT",
                        print: function() {
                            return [
                                this.title + " " + this.type + " " + this.version,
                                this.host,
                                this.license
                            ].join("\r\n");
                        }
                    }, function() {
                        return e;
                    }), n = function(e) {
                        var t = ("" + e)[0];
                        return "=" == t || "#" == t;
                    }, o = function(e) {
                        if (e.format || e.mask || e.locale) {
                            var t = {};
                            return e.mask ? t.mask = e.mask : e.format ? t.mask = e.format : (t.locale = e.locale, t.options = e.options), e.decimal && (t.options || (t.options = {}), t.options = {
                                decimal: e.decimal
                            }), t;
                        }
                        return null;
                    }, i = function(e, r) {
                        var s = {
                            options: {}
                        };
                        if (!(e instanceof Element || e instanceof HTMLDocument)) return console.error("Jspreadsheet: el is not a valid DOM element"), !1;
                        if ("TABLE" == e.tagName) {
                            if (!(r = i.createFromTable(e, r))) return console.error("Jspreadsheet: el is not a valid DOM element"), !1;
                            var l = document.createElement("div");
                            e.parentNode.insertBefore(l, e), e.remove(), e = l;
                        }
                        var a = {
                            url: null,
                            method: "GET",
                            requestVariables: null,
                            data: null,
                            sorting: null,
                            copyCompatibility: !1,
                            root: null,
                            rows: [],
                            columns: [],
                            colHeaders: [],
                            colWidths: [],
                            colAlignments: [],
                            nestedHeaders: null,
                            defaultColWidth: 50,
                            defaultColAlign: "center",
                            defaultRowHeight: null,
                            minSpareRows: 0,
                            minSpareCols: 0,
                            minDimensions: [
                                0,
                                0
                            ],
                            allowExport: !0,
                            includeHeadersOnDownload: !1,
                            includeHeadersOnCopy: !1,
                            columnSorting: !0,
                            columnDrag: !1,
                            columnResize: !0,
                            rowResize: !1,
                            rowDrag: !0,
                            editable: !0,
                            allowInsertRow: !0,
                            allowManualInsertRow: !0,
                            allowInsertColumn: !0,
                            allowManualInsertColumn: !0,
                            allowDeleteRow: !0,
                            allowDeletingAllRows: !1,
                            allowDeleteColumn: !0,
                            allowRenameColumn: !0,
                            allowComments: !1,
                            wordWrap: !1,
                            imageOptions: null,
                            csv: null,
                            csvFileName: "jspreadsheet",
                            csvHeaders: !0,
                            csvDelimiter: ",",
                            parseTableFirstRowAsHeader: !1,
                            parseTableAutoCellType: !1,
                            selectionCopy: !0,
                            mergeCells: {},
                            toolbar: null,
                            search: !1,
                            pagination: !1,
                            paginationOptions: null,
                            fullscreen: !1,
                            lazyLoading: !1,
                            loadingSpin: !1,
                            tableOverflow: !1,
                            tableHeight: "300px",
                            tableWidth: null,
                            textOverflow: !1,
                            meta: null,
                            style: null,
                            classes: null,
                            parseFormulas: !0,
                            autoIncrement: !0,
                            autoCasting: !0,
                            secureFormulas: !0,
                            stripHTML: !0,
                            stripHTMLOnCopy: !1,
                            filters: !1,
                            footers: null,
                            onundo: null,
                            onredo: null,
                            onload: null,
                            onchange: null,
                            oncomments: null,
                            onbeforechange: null,
                            onafterchanges: null,
                            onbeforeinsertrow: null,
                            oninsertrow: null,
                            onbeforeinsertcolumn: null,
                            oninsertcolumn: null,
                            onbeforedeleterow: null,
                            ondeleterow: null,
                            onbeforedeletecolumn: null,
                            ondeletecolumn: null,
                            onmoverow: null,
                            onmovecolumn: null,
                            onresizerow: null,
                            onresizecolumn: null,
                            onsort: null,
                            onselection: null,
                            oncopy: null,
                            onpaste: null,
                            onbeforepaste: null,
                            onmerge: null,
                            onfocus: null,
                            onblur: null,
                            onchangeheader: null,
                            oncreateeditor: null,
                            oneditionstart: null,
                            oneditionend: null,
                            onchangestyle: null,
                            onchangemeta: null,
                            onchangepage: null,
                            onbeforesave: null,
                            onsave: null,
                            onevent: null,
                            persistance: !1,
                            updateTable: null,
                            detachForUpdates: !1,
                            freezeColumns: null,
                            text: {
                                noRecordsFound: "No records found",
                                showingPage: "Showing page {0} of {1} entries",
                                show: "Show ",
                                search: "Search",
                                entries: " entries",
                                columnName: "Column name",
                                insertANewColumnBefore: "Insert a new column before",
                                insertANewColumnAfter: "Insert a new column after",
                                deleteSelectedColumns: "Delete selected columns",
                                renameThisColumn: "Rename this column",
                                orderAscending: "Order ascending",
                                orderDescending: "Order descending",
                                insertANewRowBefore: "Insert a new row before",
                                insertANewRowAfter: "Insert a new row after",
                                deleteSelectedRows: "Delete selected rows",
                                editComments: "Edit comments",
                                addComments: "Add comments",
                                comments: "Comments",
                                clearComments: "Clear comments",
                                copy: "Copy...",
                                paste: "Paste...",
                                saveAs: "Save as...",
                                about: "About",
                                areYouSureToDeleteTheSelectedRows: "Are you sure to delete the selected rows?",
                                areYouSureToDeleteTheSelectedColumns: "Are you sure to delete the selected columns?",
                                thisActionWillDestroyAnyExistingMergedCellsAreYouSure: "This action will destroy any existing merged cells. Are you sure?",
                                thisActionWillClearYourSearchResultsAreYouSure: "This action will clear your search results. Are you sure?",
                                thereIsAConflictWithAnotherMergedCell: "There is a conflict with another merged cell",
                                invalidMergeProperties: "Invalid merged properties",
                                cellAlreadyMerged: "Cell already merged",
                                noCellsSelected: "No cells selected"
                            },
                            about: !0
                        };
                        for(var u in a)if (r && r.hasOwnProperty(u)) {
                            if ("text" === u) for(var c in s.options[u] = a[u], r[u])r[u].hasOwnProperty(c) && (s.options[u][c] = r[u][c]);
                            else s.options[u] = r[u];
                        } else s.options[u] = a[u];
                        s.el = e, s.corner = null, s.contextMenu = null, s.textarea = null, s.ads = null, s.content = null, s.table = null, s.thead = null, s.tbody = null, s.rows = [], s.results = null, s.searchInput = null, s.toolbar = null, s.pagination = null, s.pageNumber = null, s.headerContainer = null, s.colgroupContainer = null, s.headers = [], s.records = [], s.history = [], s.formula = [], s.colgroup = [], s.selection = [], s.highlighted = [], s.selectedCell = null, s.selectedContainer = null, s.style = [], s.data = null, s.filter = null, s.filters = [], s.cursor = null, s.historyIndex = -1, s.ignoreEvents = !1, s.ignoreHistory = !1, s.edition = null, s.hashString = null, s.resizing = null, s.dragging = null, 1 == s.options.lazyLoading && 0 == s.options.tableOverflow && 0 == s.options.fullscreen && (console.error("Jspreadsheet: The lazyloading only works when tableOverflow = yes or fullscreen = yes"), s.options.lazyLoading = !1), s.fullscreen = function(t) {
                            null == t && (t = !s.options.fullscreen), s.options.fullscreen != t && (s.options.fullscreen = t, 1 == t ? e.classList.add("fullscreen") : e.classList.remove("fullscreen"));
                        }, s.dispatch = function(e) {
                            if (!s.ignoreEvents) {
                                if ("function" == typeof s.options.onevent) var t = s.options.onevent.apply(this, arguments);
                                "function" == typeof s.options[e] && (t = s.options[e].apply(this, Array.prototype.slice.call(arguments, 1)));
                            }
                            if ("onafterchanges" == e && s.options.persistance) {
                                var n = 1 == s.options.persistance ? s.options.url : s.options.persistance, r = s.prepareJson(arguments[2]);
                                s.save(n, r);
                            }
                            return t;
                        }, s.prepareTable = function() {
                            var e = s.options.columns.length;
                            if (s.options.data && void 0 !== s.options.data[0]) {
                                var t = Object.keys(s.options.data[0]);
                                t.length > e && (e = t.length);
                            }
                            s.options.minDimensions[0] > e && (e = s.options.minDimensions[0]);
                            for(var n = [], r = 0; r < e; r++)s.options.colHeaders[r] || (s.options.colHeaders[r] = ""), s.options.colWidths[r] || (s.options.colWidths[r] = s.options.defaultColWidth), s.options.colAlignments[r] || (s.options.colAlignments[r] = s.options.defaultColAlign), s.options.columns[r] ? s.options.columns[r].type || (s.options.columns[r].type = "text") : s.options.columns[r] = {
                                type: "text"
                            }, s.options.columns[r].name || (s.options.columns[r].name = t && t[r] ? t[r] : r), s.options.columns[r].source || (s.options.columns[r].source = []), s.options.columns[r].options || (s.options.columns[r].options = []), s.options.columns[r].editor || (s.options.columns[r].editor = null), s.options.columns[r].allowEmpty || (s.options.columns[r].allowEmpty = !1), s.options.columns[r].title || (s.options.columns[r].title = s.options.colHeaders[r] ? s.options.colHeaders[r] : ""), s.options.columns[r].width || (s.options.columns[r].width = s.options.colWidths[r] ? s.options.colWidths[r] : s.options.defaultColWidth), s.options.columns[r].align || (s.options.columns[r].align = s.options.colAlignments[r] ? s.options.colAlignments[r] : "center"), "autocomplete" == s.options.columns[r].type || "dropdown" == s.options.columns[r].type ? s.options.columns[r].url && n.push({
                                url: s.options.columns[r].url,
                                index: r,
                                method: "GET",
                                dataType: "json",
                                success: function(e) {
                                    for(var t = 0; t < e.length; t++)s.options.columns[this.index].source.push(e[t]);
                                }
                            }) : "calendar" == s.options.columns[r].type && (s.options.columns[r].options.format || (s.options.columns[r].options.format = "DD/MM/YYYY"));
                            n.length ? $8de3fc43dda686a8$exports.ajax(n, function() {
                                s.createTable();
                            }) : s.createTable();
                        }, s.createTable = function() {
                            s.table = document.createElement("table"), s.thead = document.createElement("thead"), s.tbody = document.createElement("tbody"), s.headers = [], s.colgroup = [], s.content = document.createElement("div"), s.content.classList.add("jexcel_content"), s.content.onscroll = function(e) {
                                s.scrollControls(e);
                            }, s.content.onwheel = function(e) {
                                s.wheelControls(e);
                            }, s.toolbar = document.createElement("div"), s.toolbar.classList.add("jexcel_toolbar");
                            var t = document.createElement("div"), n = document.createTextNode(s.options.text.search + ": ");
                            s.searchInput = document.createElement("input"), s.searchInput.classList.add("jexcel_search"), t.appendChild(n), t.appendChild(s.searchInput), s.searchInput.onfocus = function() {
                                s.resetSelection();
                            };
                            var r = document.createElement("div");
                            if (s.options.pagination > 0 && s.options.paginationOptions && s.options.paginationOptions.length > 0) {
                                s.paginationDropdown = document.createElement("select"), s.paginationDropdown.classList.add("jexcel_pagination_dropdown"), s.paginationDropdown.onchange = function() {
                                    s.options.pagination = parseInt(this.value), s.page(0);
                                };
                                for(var o = 0; o < s.options.paginationOptions.length; o++){
                                    var l = document.createElement("option");
                                    l.value = s.options.paginationOptions[o], l.innerHTML = s.options.paginationOptions[o], s.paginationDropdown.appendChild(l);
                                }
                                s.paginationDropdown.value = s.options.pagination, r.appendChild(document.createTextNode(s.options.text.show)), r.appendChild(s.paginationDropdown), r.appendChild(document.createTextNode(s.options.text.entries));
                            }
                            var a, u = document.createElement("div");
                            if (u.classList.add("jexcel_filter"), u.appendChild(r), u.appendChild(t), s.colgroupContainer = document.createElement("colgroup"), (a = document.createElement("col")).setAttribute("width", "50"), s.colgroupContainer.appendChild(a), s.options.nestedHeaders && s.options.nestedHeaders.length > 0) {
                                if (s.options.nestedHeaders[0] && s.options.nestedHeaders[0][0]) for(var c = 0; c < s.options.nestedHeaders.length; c++)s.thead.appendChild(s.createNestedHeader(s.options.nestedHeaders[c]));
                                else s.thead.appendChild(s.createNestedHeader(s.options.nestedHeaders));
                            }
                            for(s.headerContainer = document.createElement("tr"), (a = document.createElement("td")).classList.add("jexcel_selectall"), s.headerContainer.appendChild(a), o = 0; o < s.options.columns.length; o++)s.createCellHeader(o), s.headerContainer.appendChild(s.headers[o]), s.colgroupContainer.appendChild(s.colgroup[o]);
                            if (s.thead.appendChild(s.headerContainer), 1 == s.options.filters) {
                                s.filter = document.createElement("tr");
                                var f = document.createElement("td");
                                for(s.filter.appendChild(f), o = 0; o < s.options.columns.length; o++)(f = document.createElement("td")).innerHTML = "&nbsp;", f.setAttribute("data-x", o), f.className = "jexcel_column_filter", "hidden" == s.options.columns[o].type && (f.style.display = "none"), s.filter.appendChild(f);
                                s.thead.appendChild(s.filter);
                            }
                            s.table = document.createElement("table"), s.table.classList.add("jexcel"), s.table.setAttribute("cellpadding", "0"), s.table.setAttribute("cellspacing", "0"), s.table.setAttribute("unselectable", "yes"), s.table.appendChild(s.colgroupContainer), s.table.appendChild(s.thead), s.table.appendChild(s.tbody), s.options.textOverflow || s.table.classList.add("jexcel_overflow"), s.corner = document.createElement("div"), s.corner.className = "jexcel_corner", s.corner.setAttribute("unselectable", "on"), s.corner.setAttribute("onselectstart", "return false"), 0 == s.options.selectionCopy && (s.corner.style.display = "none"), s.textarea = document.createElement("textarea"), s.textarea.className = "jexcel_textarea", s.textarea.id = "jexcel_textarea", s.textarea.tabIndex = "-1", s.contextMenu = document.createElement("div"), s.contextMenu.className = "jexcel_contextmenu", $8de3fc43dda686a8$exports.contextmenu(s.contextMenu, {
                                onclick: function() {
                                    s.contextMenu.contextmenu.close(!1);
                                }
                            });
                            var d = document.createElement("a");
                            d.setAttribute("href", "https://bossanova.uk/jspreadsheet/"), s.ads = document.createElement("div"), s.ads.className = "jexcel_about";
                            var p = document.createElement("span");
                            p.innerHTML = "Jspreadsheet CE", d.appendChild(p), s.ads.appendChild(d), document.createElement("div").classList.add("jexcel_table"), s.pagination = document.createElement("div"), s.pagination.classList.add("jexcel_pagination");
                            var h = document.createElement("div"), g = document.createElement("div");
                            if (s.pagination.appendChild(h), s.pagination.appendChild(g), s.options.pagination || (s.pagination.style.display = "none"), 1 == s.options.search && e.appendChild(u), s.content.appendChild(s.table), s.content.appendChild(s.corner), s.content.appendChild(s.textarea), e.appendChild(s.toolbar), e.appendChild(s.content), e.appendChild(s.pagination), e.appendChild(s.contextMenu), e.appendChild(s.ads), e.classList.add("jexcel_container"), s.options.toolbar && s.options.toolbar.length && s.createToolbar(), 1 == s.options.fullscreen ? e.classList.add("fullscreen") : 1 == s.options.tableOverflow && (s.options.tableHeight && (s.content.style["overflow-y"] = "auto", s.content.style["box-shadow"] = "rgb(221 221 221) 2px 2px 5px 0.1px", s.content.style.maxHeight = s.options.tableHeight), s.options.tableWidth && (s.content.style["overflow-x"] = "auto", s.content.style.width = s.options.tableWidth)), 1 != s.options.tableOverflow && s.options.toolbar && e.classList.add("with-toolbar"), 1 == s.options.columnDrag && s.thead.classList.add("draggable"), 1 == s.options.columnResize && s.thead.classList.add("resizable"), 1 == s.options.rowDrag && s.tbody.classList.add("draggable"), 1 == s.options.rowResize && s.tbody.classList.add("resizable"), s.setData(), s.options.style && s.setStyle(s.options.style, null, null, 1, 1), s.options.classes) {
                                var m = Object.keys(s.options.classes);
                                for(o = 0; o < m.length; o++){
                                    var v = i.getIdFromColumnName(m[o], !0);
                                    s.records[v[1]][v[0]].classList.add(s.options.classes[m[o]]);
                                }
                            }
                        }, s.refresh = function() {
                            s.options.url ? (1 == s.options.loadingSpin && $8de3fc43dda686a8$exports.loading.show(), $8de3fc43dda686a8$exports.ajax({
                                url: s.options.url,
                                method: s.options.method,
                                data: s.options.requestVariables,
                                dataType: "json",
                                success: function(e) {
                                    s.options.data = e.data ? e.data : e, s.setData(), 1 == s.options.loadingSpin && $8de3fc43dda686a8$exports.loading.hide();
                                }
                            })) : s.setData();
                        }, s.setData = function(t) {
                            if (t && ("string" == typeof t && (t = JSON.parse(t)), s.options.data = t), s.options.data || (s.options.data = []), s.options.data && s.options.data[0] && !Array.isArray(s.options.data[0])) {
                                t = [];
                                for(var n = 0; n < s.options.data.length; n++){
                                    for(var r = [], o = 0; o < s.options.columns.length; o++)r[o] = s.options.data[n][s.options.columns[o].name];
                                    t.push(r);
                                }
                                s.options.data = t;
                            }
                            n = 0, o = 0;
                            var i = s.options.columns.length, l = s.options.data.length, a = s.options.minDimensions[0], u = s.options.minDimensions[1], c = a > i ? a : i, f = u > l ? u : l;
                            for(n = 0; n < f; n++)for(o = 0; o < c; o++)null == s.options.data[n] && (s.options.data[n] = []), null == s.options.data[n][o] && (s.options.data[n][o] = "");
                            if (s.rows = [], s.results = null, s.records = [], s.history = [], s.historyIndex = -1, s.tbody.innerHTML = "", 1 == s.options.lazyLoading) {
                                var d = 0, p = s.options.data.length < 100 ? s.options.data.length : 100;
                                s.options.pagination && (s.options.pagination = !1, console.error("Jspreadsheet: Pagination will be disable due the lazyLoading"));
                            } else s.options.pagination ? (s.pageNumber || (s.pageNumber = 0), s.options.pagination, d = s.options.pagination * s.pageNumber, p = s.options.pagination * s.pageNumber + s.options.pagination, s.options.data.length < p && (p = s.options.data.length)) : (d = 0, p = s.options.data.length);
                            for(n = 0; n < s.options.data.length; n++){
                                var h = s.createRow(n, s.options.data[n]);
                                n >= d && n < p && s.tbody.appendChild(h);
                            }
                            if (1 == s.options.lazyLoading || s.options.pagination && s.updatePagination(), s.options.mergeCells) {
                                var g = Object.keys(s.options.mergeCells);
                                for(o = 0; o < g.length; o++){
                                    var m = s.options.mergeCells[g[o]];
                                    s.setMerge(g[o], m[0], m[1], 1);
                                }
                            }
                            s.updateTable(), s.dispatch("onload", e, s);
                        }, s.getData = function(e, t) {
                            var n = [], r = 0, o = 0, i = 1 == t || 0 == s.options.copyCompatibility;
                            console.log("DEBUG jspreadsheets dataType", i, "dataOnly arg", t, "options.copyCompatibility", s.options.copyCompatibility);
                            for(var l = s.options.columns.length, a = s.options.data.length, u = 0; u < a; u++){
                                r = 0;
                                for(var c = 0; c < l; c++)e && !s.records[u][c].classList.contains("highlight") || (n[o] || (n[o] = []), n[o][r] = i ? s.options.data[u][c] : s.records[u][c].innerHTML, r++);
                                r > 0 && o++;
                            }
                            return n;
                        }, s.getJsonRow = function(e) {
                            for(var t = s.options.data[e], n = s.options.columns.length, r = {}, o = 0; o < n; o++)s.options.columns[o].name || (s.options.columns[o].name = o), r[s.options.columns[o].name] = t[o];
                            return r;
                        }, s.getJson = function(e) {
                            for(var t = [], n = s.options.columns.length, r = s.options.data.length, o = 0; o < r; o++){
                                for(var i = null, l = 0; l < n; l++)e && !s.records[o][l].classList.contains("highlight") || (null == i && (i = {}), s.options.columns[l].name || (s.options.columns[l].name = l), i[s.options.columns[l].name] = s.options.data[o][l]);
                                null != i && t.push(i);
                            }
                            return t;
                        }, s.prepareJson = function(e) {
                            for(var t = [], n = 0; n < e.length; n++){
                                var r = e[n].x, o = e[n].y, i = s.options.columns[r].name ? s.options.columns[r].name : r;
                                t[o] || (t[o] = {
                                    row: o,
                                    data: {}
                                }), t[o].data[i] = e[n].newValue;
                            }
                            return t.filter(function(e) {
                                return null != e;
                            });
                        }, s.save = function(t, n) {
                            var r = s.dispatch("onbeforesave", e, s, n);
                            if (r) n = r;
                            else if (!1 === r) return !1;
                            $8de3fc43dda686a8$exports.ajax({
                                url: t,
                                method: "POST",
                                dataType: "json",
                                data: {
                                    data: JSON.stringify(n)
                                },
                                success: function(t) {
                                    s.dispatch("onsave", e, s, n);
                                }
                            });
                        }, s.getRowData = function(e) {
                            return s.options.data[e];
                        }, s.setRowData = function(e, t) {
                            for(var n = 0; n < s.headers.length; n++){
                                var r = i.getColumnNameFromId([
                                    n,
                                    e
                                ]);
                                null != t[n] && s.setValue(r, t[n]);
                            }
                        }, s.getColumnData = function(e) {
                            for(var t = [], n = 0; n < s.options.data.length; n++)t.push(s.options.data[n][e]);
                            return t;
                        }, s.setColumnData = function(e, t) {
                            for(var n = 0; n < s.rows.length; n++){
                                var r = i.getColumnNameFromId([
                                    e,
                                    n
                                ]);
                                null != t[n] && s.setValue(r, t[n]);
                            }
                        }, s.createRow = function(e, t) {
                            s.records[e] || (s.records[e] = []), t || (t = s.options.data[e]), s.rows[e] = document.createElement("tr"), s.rows[e].setAttribute("data-y", e);
                            var n = null;
                            s.options.defaultRowHeight && (s.rows[e].style.height = s.options.defaultRowHeight + "px"), s.options.rows[e] && (s.options.rows[e].height && (s.rows[e].style.height = s.options.rows[e].height), s.options.rows[e].title && (n = s.options.rows[e].title)), n || (n = parseInt(e + 1));
                            var r = document.createElement("td");
                            r.innerHTML = n, r.setAttribute("data-y", e), r.className = "jexcel_row", s.rows[e].appendChild(r);
                            for(var o = 0; o < s.options.columns.length; o++)s.records[e][o] = s.createCell(o, e, t[o]), s.rows[e].appendChild(s.records[e][o]);
                            return s.rows[e];
                        }, s.parseValue = function(e, t, r, i) {
                            "=" == ("" + r).substr(0, 1) && 1 == s.options.parseFormulas && (r = s.executeFormula(r, e, t));
                            var l = s.options.columns[e];
                            if (l && !n(r)) {
                                var a = null;
                                if (a = o(l)) {
                                    r && r == Number(r) && (r = Number(r));
                                    var u = $8de3fc43dda686a8$exports.mask.render(r, a, !0);
                                    if (i && a.mask) {
                                        var c = a.mask.split(";");
                                        c[1] && (c[1].match(new RegExp("\\[Red\\]", "gi")) && (r < 0 ? i.classList.add("red") : i.classList.remove("red")), c[1].match(new RegExp("\\(", "gi")) && r < 0 && (u = "(" + u + ")"));
                                    }
                                    u && (r = u);
                                }
                            }
                            return r;
                        };
                        var f = function(e) {
                            return "-" == (e = "" + e).substr(4, 1) && "-" == e.substr(7, 1) || 4 == (e = e.split("-"))[0].length && e[0] == Number(e[0]) && 2 == e[1].length && e[1] == Number(e[1]);
                        };
                        s.createCell = function(e, t, n) {
                            var r = document.createElement("td");
                            if (r.setAttribute("data-x", e), r.setAttribute("data-y", t), "=" == ("" + n).substr(0, 1) && 1 == s.options.secureFormulas) {
                                var o = h(n);
                                o != n && (n = o);
                            }
                            if (s.options.columns[e].editor) !1 === s.options.stripHTML || !1 === s.options.columns[e].stripHTML ? r.innerHTML = n : r.textContent = n, "function" == typeof s.options.columns[e].editor.createCell && (r = s.options.columns[e].editor.createCell(r));
                            else if ("hidden" == s.options.columns[e].type) r.style.display = "none", r.textContent = n;
                            else if ("checkbox" == s.options.columns[e].type || "radio" == s.options.columns[e].type) {
                                var i = document.createElement("input");
                                i.type = s.options.columns[e].type, i.name = "c" + e, i.checked = 1 == n || 1 == n || "true" == n, i.onclick = function() {
                                    s.setValue(r, this.checked);
                                }, 1 != s.options.columns[e].readOnly && 0 != s.options.editable || i.setAttribute("disabled", "disabled"), r.appendChild(i), s.options.data[t][e] = i.checked;
                            } else if ("calendar" == s.options.columns[e].type) {
                                var l = null;
                                if (!f(n)) {
                                    var a = $8de3fc43dda686a8$exports.calendar.extractDateFromString(n, s.options.columns[e].options.format);
                                    a && (l = a);
                                }
                                r.textContent = $8de3fc43dda686a8$exports.calendar.getDateString(l || n, s.options.columns[e].options.format);
                            } else if ("dropdown" == s.options.columns[e].type || "autocomplete" == s.options.columns[e].type) r.classList.add("jexcel_dropdown"), r.textContent = s.getDropDownValue(e, n);
                            else if ("color" == s.options.columns[e].type) {
                                if ("square" == s.options.columns[e].render) {
                                    var u = document.createElement("div");
                                    u.className = "color", u.style.backgroundColor = n, r.appendChild(u);
                                } else r.style.color = n, r.textContent = n;
                            } else if ("image" == s.options.columns[e].type) {
                                if (n && "data:image" == n.substr(0, 10)) {
                                    var c = document.createElement("img");
                                    c.src = n, r.appendChild(c);
                                }
                            } else "html" == s.options.columns[e].type || !1 === s.options.stripHTML || !1 === s.options.columns[e].stripHTML ? r.innerHTML = d(s.parseValue(e, t, n, r)) : r.textContent = s.parseValue(e, t, n, r);
                            1 == s.options.columns[e].readOnly && (r.className = "readonly");
                            var p = s.options.columns[e].align ? s.options.columns[e].align : "center";
                            return r.style.textAlign = p, 0 != s.options.columns[e].wordWrap && (1 == s.options.wordWrap || 1 == s.options.columns[e].wordWrap || r.innerHTML.length > 200) && (r.style.whiteSpace = "pre-wrap"), e > 0 && 1 == this.options.textOverflow && (n || r.innerHTML ? s.records[t][e - 1].style.overflow = "hidden" : e == s.options.columns.length - 1 && (r.style.overflow = "hidden")), r;
                        }, s.createCellHeader = function(e) {
                            var t = s.options.columns[e].width ? s.options.columns[e].width : s.options.defaultColWidth, n = s.options.columns[e].align ? s.options.columns[e].align : s.options.defaultColAlign;
                            s.headers[e] = document.createElement("td"), s.options.stripHTML ? s.headers[e].textContent = s.options.columns[e].title ? s.options.columns[e].title : i.getColumnName(e) : s.headers[e].innerHTML = s.options.columns[e].title ? s.options.columns[e].title : i.getColumnName(e), s.headers[e].setAttribute("data-x", e), s.headers[e].style.textAlign = n, s.options.columns[e].title && s.headers[e].setAttribute("title", s.headers[e].innerText), s.options.columns[e].id && s.headers[e].setAttribute("id", s.options.columns[e].id), s.colgroup[e] = document.createElement("col"), s.colgroup[e].setAttribute("width", t), "hidden" == s.options.columns[e].type && (s.headers[e].style.display = "none", s.colgroup[e].style.display = "none");
                        }, s.updateNestedHeader = function(e, t, n) {
                            s.options.nestedHeaders[t][e].title && (s.options.nestedHeaders[t][e].title = n, s.options.nestedHeaders[t].element.children[e + 1].textContent = n);
                        }, s.createNestedHeader = function(e) {
                            var t = document.createElement("tr");
                            t.classList.add("jexcel_nested");
                            var n = document.createElement("td");
                            t.appendChild(n), e.element = t;
                            for(var r = 0, o = 0; o < e.length; o++){
                                e[o].colspan || (e[o].colspan = 1), e[o].align || (e[o].align = "center"), e[o].title || (e[o].title = ""), e[o].id || (e[o].id = "");
                                for(var i = e[o].colspan, l = [], a = 0; a < i; a++)s.options.columns[r] && "hidden" == s.options.columns[r].type && i++, l.push(r), r++;
                                (n = document.createElement("td")).setAttribute("data-column", l.join(",")), n.setAttribute("colspan", e[o].colspan), n.setAttribute("align", e[o].align), n.setAttribute("id", e[o].id), n.textContent = e[o].title, t.appendChild(n);
                            }
                            return t;
                        }, s.createToolbar = function(t) {
                            t ? s.options.toolbar = t : t = s.options.toolbar;
                            for(var n = 0; n < t.length; n++)if ("i" == t[n].type) (l = document.createElement("i")).classList.add("jexcel_toolbar_item"), l.classList.add("material-icons"), l.setAttribute("data-k", t[n].k), l.setAttribute("data-v", t[n].v), l.setAttribute("id", t[n].id), t[n].tooltip && l.setAttribute("title", t[n].tooltip), t[n].onclick && (t[n].onclick, 1) ? l.onclick = function(n) {
                                var r = n;
                                return function() {
                                    t[r].onclick(e, s, this);
                                };
                            }(n) : l.onclick = function() {
                                var e = this.getAttribute("data-k"), t = this.getAttribute("data-v");
                                s.setStyle(s.highlighted, e, t);
                            }, l.textContent = t[n].content, s.toolbar.appendChild(l);
                            else if ("select" == t[n].type) {
                                var r = !1;
                                (l = document.createElement("select")).classList.add("jexcel_toolbar_item"), l.setAttribute("data-k", t[n].k), t[n].tooltip && l.setAttribute("title", t[n].tooltip), t[n].onchange && (t[n].onchange, 1) ? (l.onchange = t[n].onchange, r = !0) : l.onchange = function() {
                                    var e = this.getAttribute("data-k");
                                    s.setStyle(s.highlighted, e, this.value);
                                };
                                for(var o = 0; o < t[n].v.length; o++){
                                    var i = document.createElement("option");
                                    i.value = t[n].v[o], i.textContent = t[n].v[o], t[n].selectedValue && i.value === t[n].selectedValue && (i.selected = !0), l.appendChild(i);
                                }
                                r && l.dispatchEvent(new Event("change")), s.toolbar.appendChild(l);
                            } else if ("color" == t[n].type) {
                                var l;
                                (l = document.createElement("i")).classList.add("jexcel_toolbar_item"), l.classList.add("material-icons"), l.setAttribute("data-k", t[n].k), l.setAttribute("data-v", ""), t[n].tooltip && l.setAttribute("title", t[n].tooltip), s.toolbar.appendChild(l), l.textContent = t[n].content, $8de3fc43dda686a8$exports.color(l, {
                                    onchange: function(e, t) {
                                        var n = e.getAttribute("data-k");
                                        s.setStyle(s.highlighted, n, t);
                                    }
                                });
                            }
                        }, s.setMerge = function(t, n, r, o) {
                            var l = !1;
                            if (!t) {
                                if (!s.highlighted.length) return alert(s.options.text.noCellsSelected), null;
                                var a = parseInt(s.highlighted[0].getAttribute("data-x")), u = parseInt(s.highlighted[0].getAttribute("data-y")), c = parseInt(s.highlighted[s.highlighted.length - 1].getAttribute("data-x")), f = parseInt(s.highlighted[s.highlighted.length - 1].getAttribute("data-y"));
                                t = i.getColumnNameFromId([
                                    a,
                                    u
                                ]), n = c - a + 1, r = f - u + 1;
                            }
                            var d = i.getIdFromColumnName(t, !0);
                            if (s.options.mergeCells[t]) s.records[d[1]][d[0]].getAttribute("data-merged") && (l = s.options.text.cellAlreadyMerged);
                            else if ((!n || n < 2) && (!r || r < 2)) l = s.options.text.invalidMergeProperties;
                            else for(var p = d[1]; p < d[1] + r; p++)for(var h = d[0]; h < d[0] + n; h++)i.getColumnNameFromId([
                                h,
                                p
                            ]), s.records[p][h].getAttribute("data-merged") && (l = s.options.text.thereIsAConflictWithAnotherMergedCell);
                            if (l) alert(l);
                            else {
                                n > 1 ? s.records[d[1]][d[0]].setAttribute("colspan", n) : n = 1, r > 1 ? s.records[d[1]][d[0]].setAttribute("rowspan", r) : r = 1, s.options.mergeCells[t] = [
                                    n,
                                    r,
                                    []
                                ], s.records[d[1]][d[0]].setAttribute("data-merged", "true"), s.records[d[1]][d[0]].style.overflow = "hidden";
                                for(var g = [], m = d[1]; m < d[1] + r; m++)for(var v = d[0]; v < d[0] + n; v++)d[0] == v && d[1] == m || (g.push(s.options.data[m][v]), s.updateCell(v, m, "", !0), s.options.mergeCells[t][2].push(s.records[m][v]), s.records[m][v].style.display = "none", s.records[m][v] = s.records[d[1]][d[0]]);
                                s.updateSelection(s.records[d[1]][d[0]]), o || (s.setHistory({
                                    action: "setMerge",
                                    column: t,
                                    colspan: n,
                                    rowspan: r,
                                    data: g
                                }), s.dispatch("onmerge", e, t, n, r));
                            }
                        }, s.getMerge = function(e) {
                            var t = {};
                            if (e) t = s.options.mergeCells[e] ? [
                                s.options.mergeCells[e][0],
                                s.options.mergeCells[e][1]
                            ] : null;
                            else if (s.options.mergeCells) {
                                s.options.mergeCells;
                                for(var n = Object.keys(s.options.mergeCells), r = 0; r < n.length; r++)t[n[r]] = [
                                    s.options.mergeCells[n[r]][0],
                                    s.options.mergeCells[n[r]][1]
                                ];
                            }
                            return t;
                        }, s.removeMerge = function(e, t, n) {
                            if (s.options.mergeCells[e]) {
                                var r = i.getIdFromColumnName(e, !0);
                                s.records[r[1]][r[0]].removeAttribute("colspan"), s.records[r[1]][r[0]].removeAttribute("rowspan"), s.records[r[1]][r[0]].removeAttribute("data-merged");
                                for(var o = s.options.mergeCells[e], l = 0, a = 0; a < o[1]; a++)for(var u = 0; u < o[0]; u++)(a > 0 || u > 0) && (s.records[r[1] + a][r[0] + u] = o[2][l], s.records[r[1] + a][r[0] + u].style.display = "", t && t[l] && s.updateCell(r[0] + u, r[1] + a, t[l]), l++);
                                s.updateSelection(s.records[r[1]][r[0]], s.records[r[1] + a - 1][r[0] + u - 1]), n || delete s.options.mergeCells[e];
                            }
                        }, s.destroyMerged = function(e) {
                            if (s.options.mergeCells) {
                                s.options.mergeCells;
                                for(var t = Object.keys(s.options.mergeCells), n = 0; n < t.length; n++)s.removeMerge(t[n], null, e);
                            }
                        }, s.isColMerged = function(e, t) {
                            var n = [];
                            if (s.options.mergeCells) for(var r = Object.keys(s.options.mergeCells), o = 0; o < r.length; o++){
                                var l = i.getIdFromColumnName(r[o], !0), a = s.options.mergeCells[r[o]][0], u = l[0], c = l[0] + (a > 1 ? a - 1 : 0);
                                null == t ? u <= e && c >= e && n.push(r[o]) : t ? u < e && c >= e && n.push(r[o]) : u <= e && c > e && n.push(r[o]);
                            }
                            return n;
                        }, s.isRowMerged = function(e, t) {
                            var n = [];
                            if (s.options.mergeCells) for(var r = Object.keys(s.options.mergeCells), o = 0; o < r.length; o++){
                                var l = i.getIdFromColumnName(r[o], !0), a = s.options.mergeCells[r[o]][1], u = l[1], c = l[1] + (a > 1 ? a - 1 : 0);
                                null == t ? u <= e && c >= e && n.push(r[o]) : t ? u < e && c >= e && n.push(r[o]) : u <= e && c > e && n.push(r[o]);
                            }
                            return n;
                        }, s.openFilter = function(e) {
                            if (s.options.filters) {
                                e = parseInt(e), s.resetSelection();
                                var t = [];
                                if ("checkbox" == s.options.columns[e].type) t.push({
                                    id: "true",
                                    name: "True"
                                }), t.push({
                                    id: "false",
                                    name: "False"
                                });
                                else {
                                    for(var n = [], r = !1, o = 0; o < s.options.data.length; o++){
                                        var i = s.options.data[o][e], l = s.records[o][e].innerHTML;
                                        i && l ? n[i] = l : r = !0;
                                    }
                                    var a = Object.keys(n);
                                    for(t = [], o = 0; o < a.length; o++)t.push({
                                        id: a[o],
                                        name: n[a[o]]
                                    });
                                    r && t.push({
                                        value: "",
                                        id: "",
                                        name: "(Blanks)"
                                    });
                                }
                                var u = document.createElement("div");
                                s.filter.children[e + 1].innerHTML = "", s.filter.children[e + 1].appendChild(u), s.filter.children[e + 1].style.paddingLeft = "0px", s.filter.children[e + 1].style.paddingRight = "0px", s.filter.children[e + 1].style.overflow = "initial";
                                var c = {
                                    data: t,
                                    multiple: !0,
                                    autocomplete: !0,
                                    opened: !0,
                                    value: void 0 !== s.filters[e] ? s.filters[e] : null,
                                    width: "100%",
                                    position: 1 == s.options.tableOverflow || 1 == s.options.fullscreen,
                                    onclose: function(t) {
                                        s.resetFilters(), s.filters[e] = t.dropdown.getValue(!0), s.filter.children[e + 1].innerHTML = t.dropdown.getText(), s.filter.children[e + 1].style.paddingLeft = "", s.filter.children[e + 1].style.paddingRight = "", s.filter.children[e + 1].style.overflow = "", s.closeFilter(e), s.refreshSelection();
                                    }
                                };
                                $8de3fc43dda686a8$exports.dropdown(u, c);
                            } else console.log("Jspreadsheet: filters not enabled.");
                        }, s.resetFilters = function() {
                            if (s.options.filters) for(var e = 0; e < s.filter.children.length; e++)s.filter.children[e].innerHTML = "&nbsp;", s.filters[e] = null;
                            s.results = null, s.updateResult();
                        }, s.closeFilter = function(e) {
                            if (!e) for(var t = 0; t < s.filter.children.length; t++)s.filters[t] && (e = t);
                            var n = function(e, t, n) {
                                for(var r = 0; r < e.length; r++){
                                    var o = "" + s.options.data[n][t], i = "" + s.records[n][t].innerHTML;
                                    if (e[r] == o || e[r] == i) return !0;
                                }
                                return !1;
                            }, r = s.filters[e];
                            s.results = [];
                            for(var o = 0; o < s.options.data.length; o++)n(r, e, o) && s.results.push(o);
                            s.results.length || (s.results = null), s.updateResult();
                        }, s.openEditor = function(t, r, i) {
                            var l = t.getAttribute("data-y"), a = t.getAttribute("data-x");
                            s.dispatch("oneditionstart", e, t, a, l), a > 0 && (s.records[l][a - 1].style.overflow = "hidden");
                            var u = function(n) {
                                var r = t.getBoundingClientRect(), o = document.createElement(n);
                                return o.style.width = r.width + "px", o.style.height = r.height - 2 + "px", o.style.minHeight = r.height - 2 + "px", t.classList.add("editor"), t.innerHTML = "", t.appendChild(o), s.dispatch("oncreateeditor", e, t, a, l, o), o;
                            };
                            if (1 == t.classList.contains("readonly")) ;
                            else if (s.edition = [
                                s.records[l][a],
                                s.records[l][a].innerHTML,
                                a,
                                l
                            ], s.options.columns[a].editor) s.options.columns[a].editor.openEditor(t, e, r, i);
                            else if ("hidden" == s.options.columns[a].type) ;
                            else if ("checkbox" == s.options.columns[a].type || "radio" == s.options.columns[a].type) {
                                var c = !t.children[0].checked;
                                s.setValue(t, c), s.edition = null;
                            } else if ("dropdown" == s.options.columns[a].type || "autocomplete" == s.options.columns[a].type) {
                                if (c = s.options.data[l][a], s.options.columns[a].multiple && !Array.isArray(c) && (c = c.split(";")), "function" == typeof s.options.columns[a].filter) var f = s.options.columns[a].filter(e, t, a, l, s.options.columns[a].source);
                                else f = s.options.columns[a].source;
                                for(var d = [], p = 0; p < f.length; p++)d.push(f[p]);
                                var h = u("div"), g = {
                                    data: d,
                                    multiple: !!s.options.columns[a].multiple,
                                    autocomplete: !(!s.options.columns[a].autocomplete && "autocomplete" != s.options.columns[a].type),
                                    opened: !0,
                                    value: c,
                                    width: "100%",
                                    height: h.style.minHeight,
                                    position: 1 == s.options.tableOverflow || 1 == s.options.fullscreen,
                                    onclose: function() {
                                        s.closeEditor(t, !0);
                                    }
                                };
                                s.options.columns[a].options && s.options.columns[a].options.type && (g.type = s.options.columns[a].options.type), $8de3fc43dda686a8$exports.dropdown(h, g);
                            } else if ("calendar" == s.options.columns[a].type || "color" == s.options.columns[a].type) c = s.options.data[l][a], (h = u("input")).value = c, 1 != s.options.tableOverflow && 1 != s.options.fullscreen || (s.options.columns[a].options.position = !0), s.options.columns[a].options.value = s.options.data[l][a], s.options.columns[a].options.opened = !0, s.options.columns[a].options.onclose = function(e, n) {
                                s.closeEditor(t, !0);
                            }, "color" == s.options.columns[a].type ? $8de3fc43dda686a8$exports.color(h, s.options.columns[a].options) : $8de3fc43dda686a8$exports.calendar(h, s.options.columns[a].options), h.focus();
                            else if ("html" == s.options.columns[a].type) {
                                c = s.options.data[l][a], (h = u("div")).style.position = "relative", (y = document.createElement("div")).classList.add("jexcel_richtext"), h.appendChild(y), $8de3fc43dda686a8$exports.editor(y, {
                                    focus: !0,
                                    value: c
                                });
                                var m = t.getBoundingClientRect(), v = y.getBoundingClientRect();
                                window.innerHeight < m.bottom + v.height ? y.style.top = m.top - (v.height + 2) + "px" : y.style.top = m.top + "px";
                            } else if ("image" == s.options.columns[a].type) {
                                var y, C = t.children[0];
                                (h = u("div")).style.position = "relative", (y = document.createElement("div")).classList.add("jclose"), C && C.src && y.appendChild(C), h.appendChild(y), $8de3fc43dda686a8$exports.image(y, s.options.imageOptions), m = t.getBoundingClientRect(), v = y.getBoundingClientRect(), window.innerHeight < m.bottom + v.height ? y.style.top = m.top - (v.height + 2) + "px" : y.style.top = m.top + "px";
                            } else {
                                if (c = 1 == r ? "" : s.options.data[l][a], 0 == s.options.columns[a].wordWrap || 1 != s.options.wordWrap && 1 != s.options.columns[a].wordWrap) h = u("input");
                                else h = u("textarea");
                                h.focus(), h.value = c, g = s.options.columns[a];
                                var w = null;
                                if (!n(c) && (w = o(g))) {
                                    if (!g.disabledMaskOnEdition) {
                                        if (g.mask) {
                                            var b = g.mask.split(";");
                                            h.setAttribute("data-mask", b[0]);
                                        } else g.locale && h.setAttribute("data-locale", g.locale);
                                    }
                                    w.input = h, h.mask = w, $8de3fc43dda686a8$exports.mask.render(c, w, !1);
                                }
                                h.onblur = function() {
                                    s.closeEditor(t, !0);
                                }, h.scrollLeft = h.scrollWidth;
                            }
                        }, s.closeEditor = function(t, r) {
                            var i = parseInt(t.getAttribute("data-x")), l = parseInt(t.getAttribute("data-y"));
                            if (1 == r) {
                                if (s.options.columns[i].editor) var a = s.options.columns[i].editor.closeEditor(t, r);
                                else if ("checkbox" == s.options.columns[i].type || "radio" == s.options.columns[i].type || "hidden" == s.options.columns[i].type) ;
                                else if ("dropdown" == s.options.columns[i].type || "autocomplete" == s.options.columns[i].type) a = t.children[0].dropdown.close(!0);
                                else if ("calendar" == s.options.columns[i].type) a = t.children[0].calendar.close(!0);
                                else if ("color" == s.options.columns[i].type) a = t.children[0].color.close(!0);
                                else if ("html" == s.options.columns[i].type) a = t.children[0].children[0].editor.getData();
                                else if ("image" == s.options.columns[i].type) {
                                    var u = t.children[0].children[0].children[0];
                                    a = u && "IMG" == u.tagName ? u.src : "";
                                } else if ("numeric" == s.options.columns[i].type) "=" != ("" + (a = t.children[0].value)).substr(0, 1) && "" == a && (a = s.options.columns[i].allowEmpty ? "" : 0), t.children[0].onblur = null;
                                else {
                                    a = t.children[0].value, t.children[0].onblur = null;
                                    var c, f = s.options.columns[i];
                                    if ((c = o(f)) && "" !== a && !n(a) && "number" != typeof a) {
                                        var d = $8de3fc43dda686a8$exports.mask.extract(a, c, !0);
                                        d && "" !== d.value && (a = d.value);
                                    }
                                }
                                s.options.data[l][i] === a ? t.innerHTML = s.edition[1] : s.setValue(t, a);
                            } else s.options.columns[i].editor ? s.options.columns[i].editor.closeEditor(t, r) : "dropdown" == s.options.columns[i].type || "autocomplete" == s.options.columns[i].type ? t.children[0].dropdown.close(!0) : "calendar" == s.options.columns[i].type ? t.children[0].calendar.close(!0) : "color" == s.options.columns[i].type ? t.children[0].color.close(!0) : t.children[0].onblur = null, t.innerHTML = s.edition && s.edition[1] ? s.edition[1] : "";
                            s.dispatch("oneditionend", e, t, i, l, a, r), t.classList.remove("editor"), s.edition = null;
                        }, s.getCell = function(e) {
                            var t = (e = i.getIdFromColumnName(e, !0))[0], n = e[1];
                            return s.records[n][t];
                        }, s.getColumnOptions = function(e, t) {
                            var n = s.options.columns[e];
                            return n || (n = {
                                type: "text"
                            }), n;
                        }, s.getCellFromCoords = function(e, t) {
                            return s.records[t][e];
                        }, s.getLabel = function(e) {
                            var t = (e = i.getIdFromColumnName(e, !0))[0], n = e[1];
                            return s.records[n][t].innerHTML;
                        }, s.getLabelFromCoords = function(e, t) {
                            return s.records[t][e].innerHTML;
                        }, s.getValue = function(e, t) {
                            if ("object" == typeof e) var n = e.getAttribute("data-x"), r = e.getAttribute("data-y");
                            else n = (e = i.getIdFromColumnName(e, !0))[0], r = e[1];
                            var o = null;
                            return null != n && null != r && (s.records[r] && s.records[r][n] && (t || 1 == s.options.copyCompatibility) ? o = s.records[r][n].innerHTML : s.options.data[r] && "undefined" != s.options.data[r][n] && (o = s.options.data[r][n])), o;
                        }, s.getValueFromCoords = function(e, t, n) {
                            var r = null;
                            return null != e && null != t && (s.records[t] && s.records[t][e] && n || 1 == s.options.copyCompatibility ? r = s.records[t][e].innerHTML : s.options.data[t] && "undefined" != s.options.data[t][e] && (r = s.options.data[t][e])), r;
                        }, s.setValue = function(t, n, r) {
                            var o = [];
                            if ("string" == typeof t) {
                                var l = (f = i.getIdFromColumnName(t, !0))[0], a = f[1];
                                o.push(s.updateCell(l, a, n, r)), s.updateFormulaChain(l, a, o);
                            } else if (l = null, a = null, t && t.getAttribute && (l = t.getAttribute("data-x"), a = t.getAttribute("data-y")), null != l && null != a) o.push(s.updateCell(l, a, n, r)), s.updateFormulaChain(l, a, o);
                            else {
                                var u = Object.keys(t);
                                if (u.length > 0) for(var c = 0; c < u.length; c++){
                                    var f;
                                    "string" == typeof t[c] ? (l = (f = i.getIdFromColumnName(t[c], !0))[0], a = f[1]) : null != t[c].x && null != t[c].y ? (l = t[c].x, a = t[c].y, null != t[c].newValue ? n = t[c].newValue : null != t[c].value && (n = t[c].value)) : (l = t[c].getAttribute("data-x"), a = t[c].getAttribute("data-y")), null != l && null != a && (o.push(s.updateCell(l, a, n, r)), s.updateFormulaChain(l, a, o));
                                }
                            }
                            s.setHistory({
                                action: "setValue",
                                records: o,
                                selection: s.selectedCell
                            }), s.updateTable(), s.onafterchanges(e, o);
                        }, s.setValueFromCoords = function(t, n, r, o) {
                            var i = [];
                            i.push(s.updateCell(t, n, r, o)), s.updateFormulaChain(t, n, i), s.setHistory({
                                action: "setValue",
                                records: i,
                                selection: s.selectedCell
                            }), s.updateTable(), s.onafterchanges(e, i);
                        }, s.setCheckRadioValue = function() {
                            for(var t = [], n = Object.keys(s.highlighted), r = 0; r < n.length; r++){
                                var o = s.highlighted[r].getAttribute("data-x"), i = s.highlighted[r].getAttribute("data-y");
                                "checkbox" != s.options.columns[o].type && "radio" != s.options.columns[o].type || t.push(s.updateCell(o, i, !s.options.data[i][o]));
                            }
                            t.length && (s.setHistory({
                                action: "setValue",
                                records: t,
                                selection: s.selectedCell
                            }), s.onafterchanges(e, t));
                        };
                        var d = function(e) {
                            var t = new Option;
                            t.innerHTML = e;
                            var n = null;
                            for(e = t.getElementsByTagName("script"); n = e[0];)n.parentNode.removeChild(n);
                            return t.innerHTML;
                        };
                        s.updateCell = function(t, n, r, o) {
                            if (1 != s.records[n][t].classList.contains("readonly") || o) {
                                var i;
                                "=" == ("" + r).substr(0, 1) && 1 == s.options.secureFormulas && (i = h(r)) != r && (r = i), null != (i = s.dispatch("onbeforechange", e, s.records[n][t], t, n, r)) && (r = i), s.options.columns[t].editor && "function" == typeof s.options.columns[t].editor.updateCell && (r = s.options.columns[t].editor.updateCell(s.records[n][t], r, o)), g = {
                                    x: t,
                                    y: n,
                                    col: t,
                                    row: n,
                                    newValue: r,
                                    oldValue: s.options.data[n][t]
                                };
                                let m = s.options.columns[t].editor;
                                if (m) s.options.data[n][t] = r, "function" == typeof m.setValue && m.setValue(s.records[n][t], r);
                                else if ("checkbox" == s.options.columns[t].type || "radio" == s.options.columns[t].type) {
                                    if ("radio" == s.options.columns[t].type) for(var l = 0; l < s.options.data.length; l++)s.options.data[l][t] = !1;
                                    s.records[n][t].children[0].checked = 1 == r || 1 == r || "true" == r || "TRUE" == r, s.options.data[n][t] = s.records[n][t].children[0].checked;
                                } else if ("dropdown" == s.options.columns[t].type || "autocomplete" == s.options.columns[t].type) s.options.data[n][t] = r, s.records[n][t].textContent = s.getDropDownValue(t, r);
                                else if ("calendar" == s.options.columns[t].type) {
                                    var a = null;
                                    if (!f(r)) {
                                        var u = $8de3fc43dda686a8$exports.calendar.extractDateFromString(r, s.options.columns[t].options.format);
                                        u && (a = u);
                                    }
                                    s.options.data[n][t] = r, s.records[n][t].textContent = $8de3fc43dda686a8$exports.calendar.getDateString(a || r, s.options.columns[t].options.format);
                                } else if ("color" == s.options.columns[t].type) {
                                    if (s.options.data[n][t] = r, "square" == s.options.columns[t].render) {
                                        var c = document.createElement("div");
                                        c.className = "color", c.style.backgroundColor = r, s.records[n][t].textContent = "", s.records[n][t].appendChild(c);
                                    } else s.records[n][t].style.color = r, s.records[n][t].textContent = r;
                                } else if ("image" == s.options.columns[t].type) {
                                    if (r = "" + r, s.options.data[n][t] = r, s.records[n][t].innerHTML = "", r && "data:image" == r.substr(0, 10)) {
                                        var p = document.createElement("img");
                                        p.src = r, s.records[n][t].appendChild(p);
                                    }
                                } else s.options.data[n][t] = r, "html" == s.options.columns[t].type ? s.records[n][t].innerHTML = d(s.parseValue(t, n, r)) : !1 === s.options.stripHTML || !1 === s.options.columns[t].stripHTML ? s.records[n][t].innerHTML = d(s.parseValue(t, n, r, s.records[n][t])) : s.records[n][t].textContent = s.parseValue(t, n, r, s.records[n][t]), 0 != s.options.columns[t].wordWrap && (1 == s.options.wordWrap || 1 == s.options.columns[t].wordWrap || s.records[n][t].innerHTML.length > 200) ? s.records[n][t].style.whiteSpace = "pre-wrap" : s.records[n][t].style.whiteSpace = "";
                                t > 0 && (s.records[n][t - 1].style.overflow = r ? "hidden" : ""), s.dispatch("onchange", e, s.records[n] && s.records[n][t] ? s.records[n][t] : null, t, n, r, g.oldValue);
                            } else var g = {
                                x: t,
                                y: n,
                                col: t,
                                row: n
                            };
                            return g;
                        }, s.copyData = function(t, n) {
                            var r = s.getData(!0, !0), o = s.selectedContainer, l = parseInt(t.getAttribute("data-x")), a = parseInt(t.getAttribute("data-y")), u = parseInt(n.getAttribute("data-x")), c = parseInt(n.getAttribute("data-y")), f = [], d = !1;
                            if (o[0] == l) {
                                if (a < o[1]) var p = a - o[1];
                                else p = 1;
                                var h = 0;
                            } else h = l < o[0] ? l - o[0] : 1, p = 0;
                            for(var g = 0, m = 0, v = a; v <= c; v++)if (!s.rows[v] || "none" != s.rows[v].style.display) {
                                null == r[m] && (m = 0), g = 0, o[0] != l && (h = l < o[0] ? l - o[0] : 1);
                                for(var y = l; y <= u; y++){
                                    if (s.records[v][y] && !s.records[v][y].classList.contains("readonly") && "none" != s.records[v][y].style.display && 0 == d) {
                                        if (!s.selection.length && "" != s.options.data[v][y]) {
                                            d = !0;
                                            continue;
                                        }
                                        (null == r[m] || null == r[m][g]) && (g = 0);
                                        var C = r[m][g];
                                        if (C && !r[1] && 1 == s.options.autoIncrement) {
                                            if ("text" == s.options.columns[y].type || "number" == s.options.columns[y].type) {
                                                if ("=" == ("" + C).substr(0, 1)) {
                                                    var w = C.match(/([A-Z]+[0-9]+)/g);
                                                    if (w) {
                                                        for(var b = [], A = 0; A < w.length; A++){
                                                            var E = i.getIdFromColumnName(w[A], 1);
                                                            E[0] += h, E[1] += p, E[1] < 0 && (E[1] = 0);
                                                            var M = i.getColumnNameFromId([
                                                                E[0],
                                                                E[1]
                                                            ]);
                                                            M != w[A] && (b[w[A]] = M);
                                                        }
                                                        b && (C = s.updateFormula(C, b));
                                                    }
                                                } else C == Number(C) && (C = Number(C) + p);
                                            } else if ("calendar" == s.options.columns[y].type) {
                                                var I = new Date(C);
                                                I.setDate(I.getDate() + p), C = I.getFullYear() + "-" + i.doubleDigitFormat(parseInt(I.getMonth() + 1)) + "-" + i.doubleDigitFormat(I.getDate()) + " 00:00:00";
                                            }
                                        }
                                        f.push(s.updateCell(y, v, C)), s.updateFormulaChain(y, v, f);
                                    }
                                    g++, o[0] != l && h++;
                                }
                                m++, p++;
                            }
                            s.setHistory({
                                action: "setValue",
                                records: f,
                                selection: s.selectedCell
                            }), s.updateTable(), s.onafterchanges(e, f);
                        }, s.refreshSelection = function() {
                            s.selectedCell && s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]);
                        }, s.conditionalSelectionUpdate = function(e, t, n) {
                            if (1 == e) {
                                if (s.selectedCell && (t >= s.selectedCell[1] && t <= s.selectedCell[3] || n >= s.selectedCell[1] && n <= s.selectedCell[3])) return void s.resetSelection();
                            } else if (s.selectedCell && (t >= s.selectedCell[0] && t <= s.selectedCell[2] || n >= s.selectedCell[0] && n <= s.selectedCell[2])) return void s.resetSelection();
                        }, s.resetSelection = function(t) {
                            if (s.highlighted.length) {
                                f = 1;
                                for(var n = 0; n < s.highlighted.length; n++){
                                    s.highlighted[n].classList.remove("highlight"), s.highlighted[n].classList.remove("highlight-left"), s.highlighted[n].classList.remove("highlight-right"), s.highlighted[n].classList.remove("highlight-top"), s.highlighted[n].classList.remove("highlight-bottom"), s.highlighted[n].classList.remove("highlight-selected");
                                    var r = parseInt(s.highlighted[n].getAttribute("data-x")), o = parseInt(s.highlighted[n].getAttribute("data-y"));
                                    if (s.highlighted[n].getAttribute("data-merged")) var i = parseInt(s.highlighted[n].getAttribute("colspan")), l = parseInt(s.highlighted[n].getAttribute("rowspan")), a = i > 0 ? r + (i - 1) : r, u = l > 0 ? o + (l - 1) : o;
                                    else a = r, u = o;
                                    for(var c = r; c <= a; c++)s.headers[c] && s.headers[c].classList.remove("selected");
                                    for(c = o; c <= u; c++)s.rows[c] && s.rows[c].classList.remove("selected");
                                }
                            } else var f = 0;
                            return s.highlighted = [], s.selectedCell = null, s.corner.style.top = "-2000px", s.corner.style.left = "-2000px", 1 == t && 1 == f && s.dispatch("onblur", e), f;
                        }, s.updateSelection = function(e, t, n) {
                            var r = e.getAttribute("data-x"), o = e.getAttribute("data-y");
                            if (t) var i = t.getAttribute("data-x"), l = t.getAttribute("data-y");
                            else i = r, l = o;
                            s.updateSelectionFromCoords(r, o, i, l, n);
                        }, s.updateSelectionFromCoords = function(t, n, r, o, i) {
                            var l = s.resetSelection();
                            if (null == n && (n = 0, o = s.rows.length - 1), null == r && (r = t), null == o && (o = n), t >= s.headers.length && (t = s.headers.length - 1), n >= s.rows.length && (n = s.rows.length - 1), r >= s.headers.length && (r = s.headers.length - 1), o >= s.rows.length && (o = s.rows.length - 1), s.selectedCell = [
                                t,
                                n,
                                r,
                                o
                            ], null != t) {
                                if (s.records[n][t] && s.records[n][t].classList.add("highlight-selected"), parseInt(t) < parseInt(r)) var a = parseInt(t), u = parseInt(r);
                                else a = parseInt(r), u = parseInt(t);
                                if (parseInt(n) < parseInt(o)) var c = parseInt(n), f = parseInt(o);
                                else c = parseInt(o), f = parseInt(n);
                                for(var d = a; d <= u; d++)for(var p = c; p <= f; p++)if (s.records[p][d] && s.records[p][d].getAttribute("data-merged")) {
                                    var h = parseInt(s.records[p][d].getAttribute("data-x")), g = parseInt(s.records[p][d].getAttribute("data-y")), m = parseInt(s.records[p][d].getAttribute("colspan")), v = parseInt(s.records[p][d].getAttribute("rowspan"));
                                    m > 1 && (h < a && (a = h), h + m > u && (u = h + m - 1)), v && (g < c && (c = g), g + v > f && (f = g + v - 1));
                                }
                                var y = null, C = null, w = null, b = null;
                                for(p = c; p <= f; p++)"none" != s.rows[p].style.display && (null == w && (w = p), b = p);
                                for(d = a; d <= u; d++){
                                    for(p = c; p <= f; p++)"none" != s.rows[p].style.display && "none" != s.records[p][d].style.display && (s.records[p][d].classList.add("highlight"), s.highlighted.push(s.records[p][d]));
                                    "hidden" != s.options.columns[d].type && (null == y && (y = d), C = d);
                                }
                                for(y || (y = 0), C || (C = 0), d = y; d <= C; d++)"hidden" != s.options.columns[d].type && s.colgroup[d].style && "none" != s.colgroup[d].style.display && (s.records[w] && s.records[w][d] && s.records[w][d].classList.add("highlight-top"), s.records[b] && s.records[b][d] && s.records[b][d].classList.add("highlight-bottom"), s.headers[d].classList.add("selected"));
                                for(p = w; p <= b; p++)s.rows[p] && "none" != s.rows[p].style.display && (s.records[p][y].classList.add("highlight-left"), s.records[p][C].classList.add("highlight-right"), s.rows[p].classList.add("selected"));
                                s.selectedContainer = [
                                    y,
                                    w,
                                    C,
                                    b
                                ];
                            }
                            0 == l && (s.dispatch("onfocus", e), s.removeCopyingSelection()), s.dispatch("onselection", e, y, w, C, b, i), s.updateCornerPosition();
                        }, s.removeCopySelection = function() {
                            for(var e = 0; e < s.selection.length; e++)s.selection[e].classList.remove("selection"), s.selection[e].classList.remove("selection-left"), s.selection[e].classList.remove("selection-right"), s.selection[e].classList.remove("selection-top"), s.selection[e].classList.remove("selection-bottom");
                            s.selection = [];
                        }, s.updateCopySelection = function(e, t) {
                            s.removeCopySelection();
                            var n = s.selectedContainer[0], r = s.selectedContainer[1], o = s.selectedContainer[2], i = s.selectedContainer[3];
                            if (null != e && null != t) {
                                if (e - o > 0) var l = parseInt(o) + 1, a = parseInt(e);
                                else l = parseInt(e), a = parseInt(n) - 1;
                                if (t - i > 0) var u = parseInt(i) + 1, c = parseInt(t);
                                else u = parseInt(t), c = parseInt(r) - 1;
                                a - l <= c - u ? (l = parseInt(n), a = parseInt(o)) : (u = parseInt(r), c = parseInt(i));
                                for(var f = u; f <= c; f++)for(var d = l; d <= a; d++)s.records[f][d] && "none" != s.rows[f].style.display && "none" != s.records[f][d].style.display && (s.records[f][d].classList.add("selection"), s.records[u][d].classList.add("selection-top"), s.records[c][d].classList.add("selection-bottom"), s.records[f][l].classList.add("selection-left"), s.records[f][a].classList.add("selection-right"), s.selection.push(s.records[f][d]));
                            }
                        }, s.updateCornerPosition = function() {
                            if (s.highlighted.length) {
                                var e = s.highlighted[s.highlighted.length - 1], t = e.getAttribute("data-x"), n = s.content.getBoundingClientRect(), r = n.left, o = n.top, i = e.getBoundingClientRect(), l = i.left, a = i.top, u = i.width, c = i.height, f = l - r + s.content.scrollLeft + u - 4, d = a - o + s.content.scrollTop + c - 4;
                                if (s.corner.style.top = d + "px", s.corner.style.left = f + "px", s.options.freezeColumns) {
                                    var p = s.getFreezeWidth();
                                    t > s.options.freezeColumns - 1 && l - r + u < p ? s.corner.style.display = "none" : 1 == s.options.selectionCopy && (s.corner.style.display = "");
                                } else 1 == s.options.selectionCopy && (s.corner.style.display = "");
                            } else s.corner.style.top = "-2000px", s.corner.style.left = "-2000px";
                        }, s.updateScroll = function(e) {
                            var t = s.content.getBoundingClientRect(), n = t.left, r = t.top, o = t.width, i = t.height, l = s.records[s.selectedCell[3]][s.selectedCell[2]].getBoundingClientRect(), a = l.left, u = l.top, c = l.width, f = l.height;
                            if (0 == e || 1 == e) var d = a - n + s.content.scrollLeft, p = u - r + s.content.scrollTop - 2;
                            else d = a - n + s.content.scrollLeft + c, p = u - r + s.content.scrollTop + f;
                            p > s.content.scrollTop + 30 && p < s.content.scrollTop + i || (p < s.content.scrollTop + 30 ? s.content.scrollTop = p - f : s.content.scrollTop = p - (i - 2));
                            var h = s.getFreezeWidth();
                            d > s.content.scrollLeft + h && d < s.content.scrollLeft + o || (d < s.content.scrollLeft + 30 ? (s.content.scrollLeft = d, s.content.scrollLeft < 50 && (s.content.scrollLeft = 0)) : d < s.content.scrollLeft + h ? s.content.scrollLeft = d - h - 1 : s.content.scrollLeft = d - (o - 20));
                        }, s.getWidth = function(e) {
                            if (void 0 === e) for(var t = [], n = 0; n < s.headers.length; n++)t.push(s.options.columns[n].width);
                            else "object" == typeof e && (e = e.getAttribute("data-x")), t = s.colgroup[e].getAttribute("width");
                            return t;
                        }, s.setWidth = function(t, n, r) {
                            if (n) {
                                if (Array.isArray(t)) {
                                    r || (r = []);
                                    for(var o = 0; o < t.length; o++){
                                        r[o] || (r[o] = s.colgroup[t[o]].getAttribute("width"));
                                        var i = Array.isArray(n) && n[o] ? n[o] : n;
                                        s.colgroup[t[o]].setAttribute("width", i), s.options.columns[t[o]].width = i;
                                    }
                                } else r || (r = s.colgroup[t].getAttribute("width")), s.colgroup[t].setAttribute("width", n), s.options.columns[t].width = n;
                                s.setHistory({
                                    action: "setWidth",
                                    column: t,
                                    oldValue: r,
                                    newValue: n
                                }), s.dispatch("onresizecolumn", e, t, n, r), s.updateCornerPosition();
                            }
                        }, s.setHeight = function(t, n, r) {
                            n > 0 && ("object" == typeof t && (t = t.getAttribute("data-y")), r || (r = s.rows[t].getAttribute("height")) || (r = s.rows[t].getBoundingClientRect().height), n = parseInt(n), s.rows[t].style.height = n + "px", s.options.rows[t] || (s.options.rows[t] = {}), s.options.rows[t].height = n, s.setHistory({
                                action: "setHeight",
                                row: t,
                                oldValue: r,
                                newValue: n
                            }), s.dispatch("onresizerow", e, t, n, r), s.updateCornerPosition());
                        }, s.getHeight = function(e) {
                            if (void 0 === e) for(var t = [], n = 0; n < s.rows.length; n++){
                                var r = s.rows[n].style.height;
                                r && (t[n] = r);
                            }
                            else "object" == typeof e && (e = $(e).getAttribute("data-y")), t = s.rows[e].style.height;
                            return t;
                        }, s.setFooter = function(e) {
                            if (e && (s.options.footers = e), s.options.footers) {
                                s.tfoot || (s.tfoot = document.createElement("tfoot"), s.table.appendChild(s.tfoot));
                                for(var t = 0; t < s.options.footers.length; t++){
                                    if (s.tfoot.children[t]) var n = s.tfoot.children[t];
                                    else {
                                        n = document.createElement("tr");
                                        var r = document.createElement("td");
                                        n.appendChild(r), s.tfoot.appendChild(n);
                                    }
                                    for(var o = 0; o < s.headers.length; o++){
                                        if (s.options.footers[t][o] || (s.options.footers[t][o] = ""), s.tfoot.children[t].children[o + 1]) r = s.tfoot.children[t].children[o + 1];
                                        else {
                                            r = document.createElement("td"), n.appendChild(r);
                                            var i = s.options.columns[o].align ? s.options.columns[o].align : "center";
                                            r.style.textAlign = i;
                                        }
                                        r.textContent = s.parseValue(+s.records.length + o, t, s.options.footers[t][o]), r.style.display = s.colgroup[o].style.display;
                                    }
                                }
                            }
                        }, s.getHeader = function(e) {
                            return s.headers[e].textContent;
                        }, s.setHeader = function(t, n) {
                            if (s.headers[t]) {
                                var r = s.headers[t].textContent;
                                n || (n = prompt(s.options.text.columnName, r)), n && (s.headers[t].textContent = n, s.headers[t].setAttribute("title", n), s.options.columns[t].title = n), s.setHistory({
                                    action: "setHeader",
                                    column: t,
                                    oldValue: r,
                                    newValue: n
                                }), s.dispatch("onchangeheader", e, t, r, n);
                            }
                        }, s.getHeaders = function(e) {
                            for(var t = [], n = 0; n < s.headers.length; n++)t.push(s.getHeader(n));
                            return e ? t : t.join(s.options.csvDelimiter);
                        }, s.getMeta = function(e, t) {
                            return e ? t ? s.options.meta[e] && s.options.meta[e][t] ? s.options.meta[e][t] : null : s.options.meta[e] ? s.options.meta[e] : null : s.options.meta;
                        }, s.setMeta = function(t, n, r) {
                            if (s.options.meta || (s.options.meta = {}), n && r) s.options.meta[t] || (s.options.meta[t] = {}), s.options.meta[t][n] = r;
                            else for(var o = Object.keys(t), i = 0; i < o.length; i++){
                                s.options.meta[o[i]] || (s.options.meta[o[i]] = {});
                                for(var l = Object.keys(t[o[i]]), a = 0; a < l.length; a++)s.options.meta[o[i]][l[a]] = t[o[i]][l[a]];
                            }
                            s.dispatch("onchangemeta", e, t, n, r);
                        }, s.updateMeta = function(e) {
                            if (s.options.meta) {
                                for(var t = {}, n = Object.keys(s.options.meta), r = 0; r < n.length; r++)e[n[r]] ? t[e[n[r]]] = s.options.meta[n[r]] : t[n[r]] = s.options.meta[n[r]];
                                s.options.meta = t;
                            }
                        }, s.getStyle = function(e, t) {
                            if (e) return e = i.getIdFromColumnName(e, !0), t ? s.records[e[1]][e[0]].style[t] : s.records[e[1]][e[0]].getAttribute("style");
                            for(var n = {}, r = s.options.data[0].length, o = s.options.data.length, l = 0; l < o; l++)for(var a = 0; a < r; a++){
                                var u = t ? s.records[l][a].style[t] : s.records[l][a].getAttribute("style");
                                u && (n[i.getColumnNameFromId([
                                    a,
                                    l
                                ])] = u);
                            }
                            return n;
                        }, s.resetStyle = function(e, t) {
                            for(var n = Object.keys(e), r = 0; r < n.length; r++){
                                var o = i.getIdFromColumnName(n[r], !0);
                                s.records[o[1]] && s.records[o[1]][o[0]] && s.records[o[1]][o[0]].setAttribute("style", "");
                            }
                            s.setStyle(e, null, null, null, t);
                        }, s.setStyle = function(t, n, r, o, l) {
                            var a = {}, u = {}, c = function(e, t, n) {
                                var r = i.getIdFromColumnName(e, !0);
                                if (s.records[r[1]] && s.records[r[1]][r[0]] && (0 == s.records[r[1]][r[0]].classList.contains("readonly") || o)) {
                                    var l = s.records[r[1]][r[0]].style[t];
                                    l != n || o ? s.records[r[1]][r[0]].style[t] = n : (n = "", s.records[r[1]][r[0]].style[t] = ""), u[e] || (u[e] = []), a[e] || (a[e] = []), u[e].push([
                                        t + ":" + l
                                    ]), a[e].push([
                                        t + ":" + n
                                    ]);
                                }
                            };
                            if (n && r) {
                                if ("string" == typeof t) c(t, n, r);
                                else for(var f = [], d = 0; d < t.length; d++){
                                    var p = t[d].getAttribute("data-x"), h = t[d].getAttribute("data-y"), g = i.getColumnNameFromId([
                                        p,
                                        h
                                    ]);
                                    f[g] || (c(g, n, r), f[g] = !0);
                                }
                            } else {
                                var m = Object.keys(t);
                                for(d = 0; d < m.length; d++){
                                    var v = t[m[d]];
                                    "string" == typeof v && (v = v.split(";"));
                                    for(var y = 0; y < v.length; y++)"string" == typeof v[y] && (v[y] = v[y].split(":")), v[y][0].trim() && c(m[d], v[y][0].trim(), v[y][1]);
                                }
                            }
                            for(m = Object.keys(u), d = 0; d < m.length; d++)u[m[d]] = u[m[d]].join(";");
                            for(m = Object.keys(a), d = 0; d < m.length; d++)a[m[d]] = a[m[d]].join(";");
                            l || s.setHistory({
                                action: "setStyle",
                                oldValue: u,
                                newValue: a
                            }), s.dispatch("onchangestyle", e, t, n, r);
                        }, s.getComments = function(e, t) {
                            if (e) return "string" == typeof e && (e = i.getIdFromColumnName(e, !0)), t ? [
                                s.records[e[1]][e[0]].getAttribute("title"),
                                s.records[e[1]][e[0]].getAttribute("author")
                            ] : s.records[e[1]][e[0]].getAttribute("title") || "";
                            for(var n = {}, r = 0; r < s.options.data.length; r++)for(var o = 0; o < s.options.columns.length; o++){
                                var l = s.records[r][o].getAttribute("title");
                                l && (n[e = i.getColumnNameFromId([
                                    o,
                                    r
                                ])] = l);
                            }
                            return n;
                        }, s.setComments = function(t, n, r) {
                            if ("string" == typeof t) var o = i.getIdFromColumnName(t, !0);
                            else o = t;
                            var l = s.records[o[1]][o[0]].getAttribute("title"), a = [
                                l,
                                r = s.records[o[1]][o[0]].getAttribute("data-author")
                            ];
                            s.records[o[1]][o[0]].setAttribute("title", n || ""), s.records[o[1]][o[0]].setAttribute("data-author", r || ""), n ? s.records[o[1]][o[0]].classList.add("jexcel_comments") : s.records[o[1]][o[0]].classList.remove("jexcel_comments"), s.setHistory({
                                action: "setComments",
                                column: t,
                                newValue: [
                                    n,
                                    r
                                ],
                                oldValue: a
                            }), s.dispatch("oncomments", e, n, l, o, o[0], o[1]);
                        }, s.getConfig = function() {
                            var e = s.options;
                            return e.style = s.getStyle(), e.mergeCells = s.getMerge(), e.comments = s.getComments(), e;
                        }, s.orderBy = function(t, n) {
                            if (t >= 0) {
                                if (Object.keys(s.options.mergeCells).length > 0) {
                                    if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                    s.destroyMerged();
                                }
                                n = null == n ? s.headers[t].classList.contains("arrow-down") ? 1 : 0 : n ? 1 : 0;
                                var r = [];
                                if ("number" == s.options.columns[t].type || "numeric" == s.options.columns[t].type || "percentage" == s.options.columns[t].type || "autonumber" == s.options.columns[t].type || "color" == s.options.columns[t].type) for(var o = 0; o < s.options.data.length; o++)r[o] = [
                                    o,
                                    Number(s.options.data[o][t])
                                ];
                                else if ("calendar" == s.options.columns[t].type || "checkbox" == s.options.columns[t].type || "radio" == s.options.columns[t].type) for(o = 0; o < s.options.data.length; o++)r[o] = [
                                    o,
                                    s.options.data[o][t]
                                ];
                                else for(o = 0; o < s.options.data.length; o++)r[o] = [
                                    o,
                                    s.records[o][t].textContent.toLowerCase()
                                ];
                                "function" != typeof s.options.sorting && (s.options.sorting = function(e) {
                                    return function(t, n) {
                                        var r = t[1], o = n[1];
                                        return e ? "" === r && "" !== o ? 1 : "" !== r && "" === o || r > o ? -1 : r < o ? 1 : 0 : "" === r && "" !== o ? 1 : "" !== r && "" === o ? -1 : r > o ? 1 : r < o ? -1 : 0;
                                    };
                                }), r = r.sort(s.options.sorting(n));
                                var i = [];
                                for(o = 0; o < r.length; o++)i[o] = r[o][0];
                                return s.setHistory({
                                    action: "orderBy",
                                    rows: i,
                                    column: t,
                                    order: n
                                }), s.updateOrderArrow(t, n), s.updateOrder(i), s.dispatch("onsort", e, t, n), !0;
                            }
                        }, s.updateOrderArrow = function(e, t) {
                            for(var n = 0; n < s.headers.length; n++)s.headers[n].classList.remove("arrow-up"), s.headers[n].classList.remove("arrow-down");
                            t ? s.headers[e].classList.add("arrow-up") : s.headers[e].classList.add("arrow-down");
                        }, s.updateOrder = function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t[n] = s.options.data[e[n]];
                            for(s.options.data = t, t = [], n = 0; n < e.length; n++)t[n] = s.records[e[n]];
                            for(s.records = t, t = [], n = 0; n < e.length; n++)t[n] = s.rows[e[n]];
                            if (s.rows = t, s.updateTableReferences(), s.results && s.results.length) s.searchInput.value ? s.search(s.searchInput.value) : s.closeFilter();
                            else if (s.results = null, s.pageNumber = 0, s.options.pagination > 0) s.page(0);
                            else if (1 == s.options.lazyLoading) s.loadPage(0);
                            else for(n = 0; n < s.rows.length; n++)s.tbody.appendChild(s.rows[n]);
                        }, s.moveRow = function(t, n, r) {
                            if (Object.keys(s.options.mergeCells).length > 0) {
                                if (t > n) var o = 1;
                                else o = 0;
                                if (s.isRowMerged(t).length || s.isRowMerged(n, o).length) {
                                    if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                    s.destroyMerged();
                                }
                            }
                            if (1 == s.options.search) {
                                if (s.results && s.results.length != s.rows.length) {
                                    if (!confirm(s.options.text.thisActionWillClearYourSearchResultsAreYouSure)) return !1;
                                    s.resetSearch();
                                }
                                s.results = null;
                            }
                            r || (Array.prototype.indexOf.call(s.tbody.children, s.rows[n]) >= 0 ? t > n ? s.tbody.insertBefore(s.rows[t], s.rows[n]) : s.tbody.insertBefore(s.rows[t], s.rows[n].nextSibling) : s.tbody.removeChild(s.rows[t])), s.rows.splice(n, 0, s.rows.splice(t, 1)[0]), s.records.splice(n, 0, s.records.splice(t, 1)[0]), s.options.data.splice(n, 0, s.options.data.splice(t, 1)[0]), s.options.pagination > 0 && s.tbody.children.length != s.options.pagination && s.page(s.pageNumber), s.setHistory({
                                action: "moveRow",
                                oldValue: t,
                                newValue: n
                            }), s.updateTableReferences(), s.dispatch("onmoverow", e, t, n);
                        }, s.insertRow = function(t, n, r) {
                            if (1 == s.options.allowInsertRow) {
                                var o = [];
                                if (t > 0) var i = t;
                                else i = 1, t && (o = t);
                                r = !!r;
                                var l = s.options.data.length - 1;
                                if ((null == n || n >= parseInt(l) || n < 0) && (n = l), !1 === s.dispatch("onbeforeinsertrow", e, n, i, r)) return !1;
                                if (Object.keys(s.options.mergeCells).length > 0 && s.isRowMerged(n, r).length) {
                                    if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                    s.destroyMerged();
                                }
                                if (1 == s.options.search) {
                                    if (s.results && s.results.length != s.rows.length) {
                                        if (!confirm(s.options.text.thisActionWillClearYourSearchResultsAreYouSure)) return !1;
                                        s.resetSearch();
                                    }
                                    s.results = null;
                                }
                                for(var a = r ? n : n + 1, u = s.records.splice(a), c = s.options.data.splice(a), f = s.rows.splice(a), d = [], p = [], h = [], g = a; g < i + a; g++){
                                    s.options.data[g] = [];
                                    for(var m = 0; m < s.options.columns.length; m++)s.options.data[g][m] = o[m] ? o[m] : "";
                                    var v = s.createRow(g, s.options.data[g]);
                                    f[0] ? Array.prototype.indexOf.call(s.tbody.children, f[0]) >= 0 && s.tbody.insertBefore(v, f[0]) : Array.prototype.indexOf.call(s.tbody.children, s.rows[n]) >= 0 && s.tbody.appendChild(v), d.push(s.records[g]), p.push(s.options.data[g]), h.push(v);
                                }
                                Array.prototype.push.apply(s.records, u), Array.prototype.push.apply(s.options.data, c), Array.prototype.push.apply(s.rows, f), s.options.pagination > 0 && s.page(s.pageNumber), s.setHistory({
                                    action: "insertRow",
                                    rowNumber: n,
                                    numOfRows: i,
                                    insertBefore: r,
                                    rowRecords: d,
                                    rowData: p,
                                    rowNode: h
                                }), s.updateTableReferences(), s.dispatch("oninsertrow", e, n, i, d, r);
                            }
                        }, s.deleteRow = function(t, n) {
                            if (1 == s.options.allowDeleteRow) {
                                if (1 == s.options.allowDeletingAllRows || s.options.data.length > 1) {
                                    if (null == t) {
                                        var r = s.getSelectedRows();
                                        r[0] ? (t = parseInt(r[0].getAttribute("data-y")), n = r.length) : (t = s.options.data.length - 1, n = 1);
                                    }
                                    var o = s.options.data.length - 1;
                                    if ((null == t || t > o || t < 0) && (t = o), n || (n = 1), t + n >= s.options.data.length && (n = s.options.data.length - t), !1 === s.dispatch("onbeforedeleterow", e, t, n)) return !1;
                                    if (parseInt(t) > -1) {
                                        var i = !1;
                                        if (Object.keys(s.options.mergeCells).length > 0) for(var l = t; l < t + n; l++)s.isRowMerged(l, !1).length && (i = !0);
                                        if (i) {
                                            if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                            s.destroyMerged();
                                        }
                                        if (1 == s.options.search) {
                                            if (s.results && s.results.length != s.rows.length) {
                                                if (!confirm(s.options.text.thisActionWillClearYourSearchResultsAreYouSure)) return !1;
                                                s.resetSearch();
                                            }
                                            s.results = null;
                                        }
                                        for(0 == s.options.allowDeletingAllRows && o + 1 === n && (n--, console.error("Jspreadsheet: It is not possible to delete the last row")), l = t; l < t + n; l++)Array.prototype.indexOf.call(s.tbody.children, s.rows[l]) >= 0 && (s.rows[l].className = "", s.rows[l].parentNode.removeChild(s.rows[l]));
                                        var a = s.records.splice(t, n), u = s.options.data.splice(t, n), c = s.rows.splice(t, n);
                                        s.options.pagination > 0 && s.tbody.children.length != s.options.pagination && s.page(s.pageNumber), s.conditionalSelectionUpdate(1, t, t + n - 1), s.setHistory({
                                            action: "deleteRow",
                                            rowNumber: t,
                                            numOfRows: n,
                                            insertBefore: 1,
                                            rowRecords: a,
                                            rowData: u,
                                            rowNode: c
                                        }), s.updateTableReferences(), s.dispatch("ondeleterow", e, t, n, a);
                                    }
                                } else console.error("Jspreadsheet: It is not possible to delete the last row");
                            }
                        }, s.moveColumn = function(t, n) {
                            if (Object.keys(s.options.mergeCells).length > 0) {
                                if (t > n) var r = 1;
                                else r = 0;
                                if (s.isColMerged(t).length || s.isColMerged(n, r).length) {
                                    if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                    s.destroyMerged();
                                }
                            }
                            if ((t = parseInt(t)) > (n = parseInt(n))) {
                                s.headerContainer.insertBefore(s.headers[t], s.headers[n]), s.colgroupContainer.insertBefore(s.colgroup[t], s.colgroup[n]);
                                for(var o = 0; o < s.rows.length; o++)s.rows[o].insertBefore(s.records[o][t], s.records[o][n]);
                            } else for(s.headerContainer.insertBefore(s.headers[t], s.headers[n].nextSibling), s.colgroupContainer.insertBefore(s.colgroup[t], s.colgroup[n].nextSibling), o = 0; o < s.rows.length; o++)s.rows[o].insertBefore(s.records[o][t], s.records[o][n].nextSibling);
                            for(s.options.columns.splice(n, 0, s.options.columns.splice(t, 1)[0]), s.headers.splice(n, 0, s.headers.splice(t, 1)[0]), s.colgroup.splice(n, 0, s.colgroup.splice(t, 1)[0]), o = 0; o < s.rows.length; o++)s.options.data[o].splice(n, 0, s.options.data[o].splice(t, 1)[0]), s.records[o].splice(n, 0, s.records[o].splice(t, 1)[0]);
                            if (s.options.footers) for(o = 0; o < s.options.footers.length; o++)s.options.footers[o].splice(n, 0, s.options.footers[o].splice(t, 1)[0]);
                            s.setHistory({
                                action: "moveColumn",
                                oldValue: t,
                                newValue: n
                            }), s.updateTableReferences(), s.dispatch("onmovecolumn", e, t, n);
                        }, s.insertColumn = function(t, n, r, o) {
                            if (1 == s.options.allowInsertColumn) {
                                var l = [];
                                if (t > 0) var a = t;
                                else a = 1, t && (l = t);
                                r = !!r;
                                var u = s.options.columns.length - 1;
                                if ((null == n || n >= parseInt(u) || n < 0) && (n = u), !1 === s.dispatch("onbeforeinsertcolumn", e, n, a, r)) return !1;
                                if (Object.keys(s.options.mergeCells).length > 0 && s.isColMerged(n, r).length) {
                                    if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                    s.destroyMerged();
                                }
                                o || (o = []);
                                for(var c = 0; c < a; c++)o[c] || (o[c] = {
                                    type: "text",
                                    source: [],
                                    options: [],
                                    width: s.options.defaultColWidth,
                                    align: s.options.defaultColAlign
                                });
                                var f = r ? n : n + 1;
                                s.options.columns = i.injectArray(s.options.columns, f, o);
                                for(var d = s.headers.splice(f), p = s.colgroup.splice(f), h = [], g = [], m = [], v = [], y = [], C = f; C < a + f; C++)s.createCellHeader(C), s.headerContainer.insertBefore(s.headers[C], s.headerContainer.children[C + 1]), s.colgroupContainer.insertBefore(s.colgroup[C], s.colgroupContainer.children[C + 1]), h.push(s.headers[C]), g.push(s.colgroup[C]);
                                if (s.options.footers) for(var w = 0; w < s.options.footers.length; w++){
                                    for(y[w] = [], c = 0; c < a; c++)y[w].push("");
                                    s.options.footers[w].splice(f, 0, y[w]);
                                }
                                for(var b = 0; b < s.options.data.length; b++){
                                    var A = s.options.data[b].splice(f), E = s.records[b].splice(f);
                                    for(v[b] = [], m[b] = [], C = f; C < a + f; C++){
                                        var M = l[b] ? l[b] : "";
                                        s.options.data[b][C] = M;
                                        var I = s.createCell(C, b, s.options.data[b][C]);
                                        s.records[b][C] = I, s.rows[b] && s.rows[b].insertBefore(I, s.rows[b].children[C + 1]), v[b].push(M), m[b].push(I);
                                    }
                                    Array.prototype.push.apply(s.options.data[b], A), Array.prototype.push.apply(s.records[b], E);
                                }
                                if (Array.prototype.push.apply(s.headers, d), Array.prototype.push.apply(s.colgroup, p), s.options.nestedHeaders && s.options.nestedHeaders.length > 0) {
                                    if (s.options.nestedHeaders[0] && s.options.nestedHeaders[0][0]) for(w = 0; w < s.options.nestedHeaders.length; w++){
                                        var N = parseInt(s.options.nestedHeaders[w][s.options.nestedHeaders[w].length - 1].colspan) + a;
                                        s.options.nestedHeaders[w][s.options.nestedHeaders[w].length - 1].colspan = N, s.thead.children[w].children[s.thead.children[w].children.length - 1].setAttribute("colspan", N);
                                        var x = s.thead.children[w].children[s.thead.children[w].children.length - 1].getAttribute("data-column");
                                        for(x = x.split(","), C = f; C < a + f; C++)x.push(C);
                                        s.thead.children[w].children[s.thead.children[w].children.length - 1].setAttribute("data-column", x);
                                    }
                                    else N = parseInt(s.options.nestedHeaders[0].colspan) + a, s.options.nestedHeaders[0].colspan = N, s.thead.children[0].children[s.thead.children[0].children.length - 1].setAttribute("colspan", N);
                                }
                                s.setHistory({
                                    action: "insertColumn",
                                    columnNumber: n,
                                    numOfColumns: a,
                                    insertBefore: r,
                                    columns: o,
                                    headers: h,
                                    colgroup: g,
                                    records: m,
                                    footers: y,
                                    data: v
                                }), s.updateTableReferences(), s.dispatch("oninsertcolumn", e, n, a, m, r);
                            }
                        }, s.deleteColumn = function(t, n) {
                            if (1 == s.options.allowDeleteColumn) {
                                if (s.headers.length > 1) {
                                    if (null == t) {
                                        var r = s.getSelectedColumns(!0);
                                        r.length ? (t = parseInt(r[0]), n = parseInt(r.length)) : (t = s.headers.length - 1, n = 1);
                                    }
                                    var o = s.options.data[0].length - 1;
                                    if ((null == t || t > o || t < 0) && (t = o), n || (n = 1), n > s.options.data[0].length - t && (n = s.options.data[0].length - t), !1 === s.dispatch("onbeforedeletecolumn", e, t, n)) return !1;
                                    if (parseInt(t) > -1) {
                                        var i = !1;
                                        if (Object.keys(s.options.mergeCells).length > 0) for(var l = t; l < t + n; l++)s.isColMerged(l, !1).length && (i = !0);
                                        if (i) {
                                            if (!confirm(s.options.text.thisActionWillDestroyAnyExistingMergedCellsAreYouSure)) return !1;
                                            s.destroyMerged();
                                        }
                                        var a = s.options.columns.splice(t, n);
                                        for(l = t; l < t + n; l++)s.colgroup[l].className = "", s.headers[l].className = "", s.colgroup[l].parentNode.removeChild(s.colgroup[l]), s.headers[l].parentNode.removeChild(s.headers[l]);
                                        for(var u = s.headers.splice(t, n), c = s.colgroup.splice(t, n), f = [], d = [], p = [], h = 0; h < s.options.data.length; h++)for(l = t; l < t + n; l++)s.records[h][l].className = "", s.records[h][l].parentNode.removeChild(s.records[h][l]);
                                        for(h = 0; h < s.options.data.length; h++)d[h] = s.options.data[h].splice(t, n), f[h] = s.records[h].splice(t, n);
                                        if (s.options.footers) for(h = 0; h < s.options.footers.length; h++)p[h] = s.options.footers[h].splice(t, n);
                                        if (s.conditionalSelectionUpdate(0, t, t + n - 1), s.options.nestedHeaders && s.options.nestedHeaders.length > 0) {
                                            if (s.options.nestedHeaders[0] && s.options.nestedHeaders[0][0]) for(var g = 0; g < s.options.nestedHeaders.length; g++){
                                                var m = parseInt(s.options.nestedHeaders[g][s.options.nestedHeaders[g].length - 1].colspan) - n;
                                                s.options.nestedHeaders[g][s.options.nestedHeaders[g].length - 1].colspan = m, s.thead.children[g].children[s.thead.children[g].children.length - 1].setAttribute("colspan", m);
                                            }
                                            else m = parseInt(s.options.nestedHeaders[0].colspan) - n, s.options.nestedHeaders[0].colspan = m, s.thead.children[0].children[s.thead.children[0].children.length - 1].setAttribute("colspan", m);
                                        }
                                        s.setHistory({
                                            action: "deleteColumn",
                                            columnNumber: t,
                                            numOfColumns: n,
                                            insertBefore: 1,
                                            columns: a,
                                            headers: u,
                                            colgroup: c,
                                            records: f,
                                            footers: p,
                                            data: d
                                        }), s.updateTableReferences(), s.dispatch("ondeletecolumn", e, t, n, f);
                                    }
                                } else console.error("Jspreadsheet: It is not possible to delete the last column");
                            }
                        }, s.getSelectedRows = function(e) {
                            for(var t = [], n = 0; n < s.rows.length; n++)s.rows[n].classList.contains("selected") && (e ? t.push(n) : t.push(s.rows[n]));
                            return t;
                        }, s.getSelectedColumns = function() {
                            for(var e = [], t = 0; t < s.headers.length; t++)s.headers[t].classList.contains("selected") && e.push(t);
                            return e;
                        }, s.getHighlighted = function() {
                            return s.highlighted;
                        }, s.updateTableReferences = function() {
                            for(var e = 0; e < s.headers.length; e++)(l = s.headers[e].getAttribute("data-x")) != e && (s.headers[e].setAttribute("data-x", e), s.headers[e].getAttribute("title") || (s.headers[e].innerHTML = i.getColumnName(e)));
                            for(var t = 0; t < s.rows.length; t++)s.rows[t] && (a = s.rows[t].getAttribute("data-y")) != t && (s.rows[t].setAttribute("data-y", t), s.rows[t].children[0].setAttribute("data-y", t), s.rows[t].children[0].innerHTML = t + 1);
                            var n = [], r = [], o = function(e, t, r, o) {
                                if (e != r && s.records[o][r].setAttribute("data-x", r), t != o && s.records[o][r].setAttribute("data-y", o), e != r || t != o) {
                                    var l = i.getColumnNameFromId([
                                        e,
                                        t
                                    ]), a = i.getColumnNameFromId([
                                        r,
                                        o
                                    ]);
                                    n[l] = a;
                                }
                            };
                            for(t = 0; t < s.records.length; t++)for(e = 0; e < s.records[0].length; e++)if (s.records[t][e]) {
                                var l = s.records[t][e].getAttribute("data-x"), a = s.records[t][e].getAttribute("data-y");
                                if (s.records[t][e].getAttribute("data-merged")) {
                                    var u = i.getColumnNameFromId([
                                        l,
                                        a
                                    ]), c = i.getColumnNameFromId([
                                        e,
                                        t
                                    ]);
                                    if (null == r[u]) {
                                        if (u == c) r[u] = !1;
                                        else {
                                            var f = parseInt(e - l), d = parseInt(t - a);
                                            r[u] = [
                                                c,
                                                f,
                                                d
                                            ];
                                        }
                                    }
                                } else o(l, a, e, t);
                            }
                            var p = Object.keys(r);
                            if (p.length) {
                                for(e = 0; e < p.length; e++)if (r[p[e]]) {
                                    var h = i.getIdFromColumnName(p[e], !0);
                                    for(o(l = h[0], a = h[1], l + r[p[e]][1], a + r[p[e]][2]), u = p[e], c = r[p[e]][0], t = 0; t < s.options.mergeCells[u][2].length; t++)l = parseInt(s.options.mergeCells[u][2][t].getAttribute("data-x")), a = parseInt(s.options.mergeCells[u][2][t].getAttribute("data-y")), s.options.mergeCells[u][2][t].setAttribute("data-x", l + r[p[e]][1]), s.options.mergeCells[u][2][t].setAttribute("data-y", a + r[p[e]][2]);
                                    s.options.mergeCells[c] = s.options.mergeCells[u], delete s.options.mergeCells[u];
                                }
                            }
                            s.updateFormulas(n), s.updateMeta(n), s.refreshSelection(), s.updateTable();
                        }, s.updateTable = function() {
                            if (s.options.minSpareRows > 0) {
                                for(var t = 0, n = s.rows.length - 1; n >= 0; n--){
                                    for(var r = !1, o = 0; o < s.headers.length; o++)s.options.data[n][o] && (r = !0);
                                    if (r) break;
                                    t++;
                                }
                                s.options.minSpareRows - t > 0 && s.insertRow(s.options.minSpareRows - t);
                            }
                            if (s.options.minSpareCols > 0) {
                                var l = 0;
                                for(o = s.headers.length - 1; o >= 0; o--){
                                    for(r = !1, n = 0; n < s.rows.length; n++)s.options.data[n][o] && (r = !0);
                                    if (r) break;
                                    l++;
                                }
                                s.options.minSpareCols - l > 0 && s.insertColumn(s.options.minSpareCols - l);
                            }
                            if ("function" == typeof s.options.updateTable) {
                                for(s.options.detachForUpdates && e.removeChild(s.content), n = 0; n < s.rows.length; n++)for(o = 0; o < s.headers.length; o++)s.options.updateTable(e, s.records[n][o], o, n, s.options.data[n][o], s.records[n][o].textContent, i.getColumnNameFromId([
                                    o,
                                    n
                                ]));
                                s.options.detachForUpdates && e.insertBefore(s.content, s.pagination);
                            }
                            s.options.footers && s.setFooter(), setTimeout(function() {
                                s.updateCornerPosition();
                            }, 0);
                        }, s.isReadOnly = function(e) {
                            if (e = s.getCell(e)) return !!e.classList.contains("readonly");
                        }, s.setReadOnly = function(e, t) {
                            (e = s.getCell(e)) && (t ? e.classList.add("readonly") : e.classList.remove("readonly"));
                        }, s.showRow = function(e) {
                            s.rows[e].style.display = "";
                        }, s.hideRow = function(e) {
                            s.rows[e].style.display = "none";
                        }, s.showColumn = function(e) {
                            s.headers[e].style.display = "", s.colgroup[e].style.display = "", s.filter && s.filter.children.length > e + 1 && (s.filter.children[e + 1].style.display = "");
                            for(var t = 0; t < s.options.data.length; t++)s.records[t][e].style.display = "";
                            s.options.footers && s.setFooter(), s.resetSelection();
                        }, s.hideColumn = function(e) {
                            s.headers[e].style.display = "none", s.colgroup[e].style.display = "none", s.filter && s.filter.children.length > e + 1 && (s.filter.children[e + 1].style.display = "none");
                            for(var t = 0; t < s.options.data.length; t++)s.records[t][e].style.display = "none";
                            s.options.footers && s.setFooter(), s.resetSelection();
                        }, s.showIndex = function() {
                            s.table.classList.remove("jexcel_hidden_index");
                        }, s.hideIndex = function() {
                            s.table.classList.add("jexcel_hidden_index");
                        };
                        var p = [];
                        s.updateFormulaChain = function(e, t, n) {
                            var r = i.getColumnNameFromId([
                                e,
                                t
                            ]);
                            if (s.formula[r] && s.formula[r].length > 0) {
                                if (p[r]) s.records[t][e].innerHTML = "#ERROR", s.formula[r] = "";
                                else {
                                    p[r] = !0;
                                    for(var o = 0; o < s.formula[r].length; o++){
                                        var l = i.getIdFromColumnName(s.formula[r][o], !0), a = "" + s.options.data[l[1]][l[0]];
                                        "=" == a.substr(0, 1) ? n.push(s.updateCell(l[0], l[1], a, !0)) : Object.keys(s.formula)[o] = null, s.updateFormulaChain(l[0], l[1], n);
                                    }
                                }
                            }
                            p = [];
                        }, s.updateFormulas = function(e) {
                            for(var t = 0; t < s.options.data.length; t++)for(var n = 0; n < s.options.data[0].length; n++)if ("=" == (a = "" + s.options.data[t][n]).substr(0, 1)) {
                                var r = s.updateFormula(a, e);
                                r != a && (s.options.data[t][n] = r);
                            }
                            var o = [], i = Object.keys(s.formula);
                            for(t = 0; t < i.length; t++){
                                var l = i[t], a = s.formula[l];
                                for(e[l] && (l = e[l]), o[l] = [], n = 0; n < a.length; n++){
                                    var u = a[n];
                                    e[u] && (u = e[u]), o[l].push(u);
                                }
                            }
                            s.formula = o;
                        }, s.updateFormula = function(e, t) {
                            for(var n = /[A-Z]/, r = /[0-9]/, o = "", i = null, s = null, l = "", a = 0; a < e.length; a++)n.exec(e[a]) ? (i = 1, s = 0, l += e[a]) : r.exec(e[a]) ? (s = i ? 1 : 0, l += e[a]) : (i && s && (l = t[l] ? t[l] : l), o += l, o += e[a], i = 0, s = 0, l = "");
                            return l && (i && s && (l = t[l] ? t[l] : l), o += l), o;
                        };
                        var h = function(e) {
                            for(var t = "", n = 0, r = 0; r < e.length; r++)'"' == e[r] && (n = 0 == n ? 1 : 0), t += 1 == n ? e[r] : e[r].toUpperCase();
                            return t;
                        };
                        s.executeFormula = function(e, t, n) {
                            var r = [], o = [], l = function(e, t, n) {
                                var a = i.getColumnNameFromId([
                                    t,
                                    n
                                ]);
                                if (o[a]) return console.error("Reference loop detected"), "#ERROR";
                                o[a] = !0;
                                var u;
                                if ((u = (e = e.replace(/\$?([A-Z]+)\$?([0-9]+)/g, "$1$2")).match(/([A-Z]+[0-9]+)\:([A-Z]+[0-9]+)/g)) && u.length && function(t) {
                                    for(var n = 0; n < t.length; n++){
                                        var r = [], o = t[n].split(":"), s = i.getIdFromColumnName(o[0], !0), l = i.getIdFromColumnName(o[1], !0);
                                        if (s[0] <= l[0]) var a = s[0], u = l[0];
                                        else a = l[0], u = s[0];
                                        if (s[1] <= l[1]) var c = s[1], f = l[1];
                                        else c = l[1], f = s[1];
                                        for(var d = c; d <= f; d++)for(var p = a; p <= u; p++)r.push(i.getColumnNameFromId([
                                            p,
                                            d
                                        ]));
                                        e = e.replace(t[n], r.join(","));
                                    }
                                }(u), (u = e.match(/([A-Z]+[0-9]+)/g)) && u.indexOf(a) > -1) return console.error("Self Reference detected"), "#ERROR";
                                var c = {};
                                if (u) {
                                    for(var f = 0; f < u.length; f++)if (s.formula[u[f]] || (s.formula[u[f]] = []), s.formula[u[f]].indexOf(a) < 0 && s.formula[u[f]].push(a), !(u[f] in window)) {
                                        var d = i.getIdFromColumnName(u[f], 1);
                                        if (void 0 !== s.options.data[d[1]] && void 0 !== s.options.data[d[1]][d[0]]) var p = s.options.data[d[1]][d[0]];
                                        else p = "";
                                        if ("=" == ("" + p).substr(0, 1) && (void 0 !== r[u[f]] ? p = r[u[f]] : (p = l(p, d[0], d[1]), r[u[f]] = p)), "" == ("" + p).trim()) c[u[f]] = null;
                                        else if (p == Number(p) && 1 == s.options.autoCasting) c[u[f]] = Number(p);
                                        else {
                                            var h = s.parseNumber(p, d[0]);
                                            1 == s.options.autoCasting && h ? c[u[f]] = h : c[u[f]] = '"' + p + '"';
                                        }
                                    }
                                }
                                try {
                                    var g = i.formula(e.substr(1), c, t, n, s);
                                } catch (e) {
                                    g = "#ERROR", console.log(e);
                                }
                                return g;
                            };
                            return l(e, t, n);
                        }, s.parseNumber = function(e, t) {
                            var n = t && s.options.columns[t].decimal ? s.options.columns[t].decimal : ".", r = "" + e;
                            if ((r = r.split(n))[0] = r[0].match(/[+-]?[0-9]/g), r[0] && (r[0] = r[0].join("")), r[1] && (r[1] = r[1].match(/[0-9]*/g).join("")), r[0] && Number.isInteger(Number(r[0]))) {
                                if (r[1]) e = Number(r[0] + "." + r[1]);
                                else e = Number(r[0] + ".00");
                            } else e = null;
                            return e;
                        }, s.row = function(e) {}, s.col = function(e) {}, s.up = function(e, t) {
                            if (e ? s.selectedCell[3] > 0 && s.up.visible(1, t ? 0 : 1) : (s.selectedCell[1] > 0 && s.up.visible(0, t ? 0 : 1), s.selectedCell[2] = s.selectedCell[0], s.selectedCell[3] = s.selectedCell[1]), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]), 1 == s.options.lazyLoading) {
                                if (0 == s.selectedCell[1] || 0 == s.selectedCell[3]) s.loadPage(0), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]);
                                else if (s.loadValidation()) s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]);
                                else {
                                    var n = parseInt(s.tbody.firstChild.getAttribute("data-y"));
                                    s.selectedCell[1] - n < 30 && (s.loadUp(), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]));
                                }
                            } else if (s.options.pagination > 0) {
                                var r = s.whichPage(s.selectedCell[3]);
                                r != s.pageNumber && s.page(r);
                            }
                            s.updateScroll(1);
                        }, s.up.visible = function(e, t) {
                            if (0 == e) var n = parseInt(s.selectedCell[0]), r = parseInt(s.selectedCell[1]);
                            else n = parseInt(s.selectedCell[2]), r = parseInt(s.selectedCell[3]);
                            if (0 == t) {
                                for(var o = 0; o < r; o++)if ("none" != s.records[o][n].style.display && "none" != s.rows[o].style.display) {
                                    r = o;
                                    break;
                                }
                            } else r = s.up.get(n, r);
                            0 == e ? (s.selectedCell[0] = n, s.selectedCell[1] = r) : (s.selectedCell[2] = n, s.selectedCell[3] = r);
                        }, s.up.get = function(e, t) {
                            e = parseInt(e);
                            for(var n = (t = parseInt(t)) - 1; n >= 0; n--)if ("none" != s.records[n][e].style.display && "none" != s.rows[n].style.display) {
                                if (s.records[n][e].getAttribute("data-merged") && s.records[n][e] == s.records[t][e]) continue;
                                t = n;
                                break;
                            }
                            return t;
                        }, s.down = function(e, t) {
                            if (e ? s.selectedCell[3] < s.records.length - 1 && s.down.visible(1, t ? 0 : 1) : (s.selectedCell[1] < s.records.length - 1 && s.down.visible(0, t ? 0 : 1), s.selectedCell[2] = s.selectedCell[0], s.selectedCell[3] = s.selectedCell[1]), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]), 1 == s.options.lazyLoading) s.selectedCell[1] == s.records.length - 1 || s.selectedCell[3] == s.records.length - 1 ? (s.loadPage(-1), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3])) : s.loadValidation() ? s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]) : parseInt(s.tbody.lastChild.getAttribute("data-y")) - s.selectedCell[3] < 30 && (s.loadDown(), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]));
                            else if (s.options.pagination > 0) {
                                var n = s.whichPage(s.selectedCell[3]);
                                n != s.pageNumber && s.page(n);
                            }
                            s.updateScroll(3);
                        }, s.down.visible = function(e, t) {
                            if (0 == e) var n = parseInt(s.selectedCell[0]), r = parseInt(s.selectedCell[1]);
                            else n = parseInt(s.selectedCell[2]), r = parseInt(s.selectedCell[3]);
                            if (0 == t) {
                                for(var o = s.rows.length - 1; o > r; o--)if ("none" != s.records[o][n].style.display && "none" != s.rows[o].style.display) {
                                    r = o;
                                    break;
                                }
                            } else r = s.down.get(n, r);
                            0 == e ? (s.selectedCell[0] = n, s.selectedCell[1] = r) : (s.selectedCell[2] = n, s.selectedCell[3] = r);
                        }, s.down.get = function(e, t) {
                            e = parseInt(e);
                            for(var n = (t = parseInt(t)) + 1; n < s.rows.length; n++)if ("none" != s.records[n][e].style.display && "none" != s.rows[n].style.display) {
                                if (s.records[n][e].getAttribute("data-merged") && s.records[n][e] == s.records[t][e]) continue;
                                t = n;
                                break;
                            }
                            return t;
                        }, s.right = function(e, t) {
                            e ? s.selectedCell[2] < s.headers.length - 1 && s.right.visible(1, t ? 0 : 1) : (s.selectedCell[0] < s.headers.length - 1 && s.right.visible(0, t ? 0 : 1), s.selectedCell[2] = s.selectedCell[0], s.selectedCell[3] = s.selectedCell[1]), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]), s.updateScroll(2);
                        }, s.right.visible = function(e, t) {
                            if (0 == e) var n = parseInt(s.selectedCell[0]), r = parseInt(s.selectedCell[1]);
                            else n = parseInt(s.selectedCell[2]), r = parseInt(s.selectedCell[3]);
                            if (0 == t) {
                                for(var o = s.headers.length - 1; o > n; o--)if ("none" != s.records[r][o].style.display) {
                                    n = o;
                                    break;
                                }
                            } else n = s.right.get(n, r);
                            0 == e ? (s.selectedCell[0] = n, s.selectedCell[1] = r) : (s.selectedCell[2] = n, s.selectedCell[3] = r);
                        }, s.right.get = function(e, t) {
                            e = parseInt(e), t = parseInt(t);
                            for(var n = e + 1; n < s.headers.length; n++)if ("none" != s.records[t][n].style.display) {
                                if (s.records[t][n].getAttribute("data-merged") && s.records[t][n] == s.records[t][e]) continue;
                                e = n;
                                break;
                            }
                            return e;
                        }, s.left = function(e, t) {
                            e ? s.selectedCell[2] > 0 && s.left.visible(1, t ? 0 : 1) : (s.selectedCell[0] > 0 && s.left.visible(0, t ? 0 : 1), s.selectedCell[2] = s.selectedCell[0], s.selectedCell[3] = s.selectedCell[1]), s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]), s.updateScroll(0);
                        }, s.left.visible = function(e, t) {
                            if (0 == e) var n = parseInt(s.selectedCell[0]), r = parseInt(s.selectedCell[1]);
                            else n = parseInt(s.selectedCell[2]), r = parseInt(s.selectedCell[3]);
                            if (0 == t) {
                                for(var o = 0; o < n; o++)if ("none" != s.records[r][o].style.display) {
                                    n = o;
                                    break;
                                }
                            } else n = s.left.get(n, r);
                            0 == e ? (s.selectedCell[0] = n, s.selectedCell[1] = r) : (s.selectedCell[2] = n, s.selectedCell[3] = r);
                        }, s.left.get = function(e, t) {
                            e = parseInt(e), t = parseInt(t);
                            for(var n = e - 1; n >= 0; n--)if ("none" != s.records[t][n].style.display) {
                                if (s.records[t][n].getAttribute("data-merged") && s.records[t][n] == s.records[t][e]) continue;
                                e = n;
                                break;
                            }
                            return e;
                        }, s.first = function(e, t) {
                            if (e ? t ? s.selectedCell[3] = 0 : s.left.visible(1, 0) : (t ? s.selectedCell[1] = 0 : s.left.visible(0, 0), s.selectedCell[2] = s.selectedCell[0], s.selectedCell[3] = s.selectedCell[1]), 1 != s.options.lazyLoading || 0 != s.selectedCell[1] && 0 != s.selectedCell[3]) {
                                if (s.options.pagination > 0) {
                                    var n = s.whichPage(s.selectedCell[3]);
                                    n != s.pageNumber && s.page(n);
                                }
                            } else s.loadPage(0);
                            s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]), s.updateScroll(1);
                        }, s.last = function(e, t) {
                            if (e ? t ? s.selectedCell[3] = s.records.length - 1 : s.right.visible(1, 0) : (t ? s.selectedCell[1] = s.records.length - 1 : s.right.visible(0, 0), s.selectedCell[2] = s.selectedCell[0], s.selectedCell[3] = s.selectedCell[1]), 1 != s.options.lazyLoading || s.selectedCell[1] != s.records.length - 1 && s.selectedCell[3] != s.records.length - 1) {
                                if (s.options.pagination > 0) {
                                    var n = s.whichPage(s.selectedCell[3]);
                                    n != s.pageNumber && s.page(n);
                                }
                            } else s.loadPage(-1);
                            s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]), s.updateScroll(3);
                        }, s.selectAll = function() {
                            s.selectedCell || (s.selectedCell = []), s.selectedCell[0] = 0, s.selectedCell[1] = 0, s.selectedCell[2] = s.headers.length - 1, s.selectedCell[3] = s.records.length - 1, s.updateSelectionFromCoords(s.selectedCell[0], s.selectedCell[1], s.selectedCell[2], s.selectedCell[3]);
                        }, s.loadPage = function(e) {
                            if (1 != s.options.search && 1 != s.options.filters || !s.results) t = s.rows;
                            else var t = s.results;
                            var n = 100;
                            null != e && -1 != e || (e = Math.ceil(t.length / n) - 1);
                            var r = e * n, o = e * n + n;
                            o > t.length && (o = t.length), (r = o - 100) < 0 && (r = 0);
                            for(var i = r; i < o; i++)1 != s.options.search && 1 != s.options.filters || !s.results ? s.tbody.appendChild(s.rows[i]) : s.tbody.appendChild(s.rows[t[i]]), s.tbody.children.length > n && s.tbody.removeChild(s.tbody.firstChild);
                        }, s.loadUp = function() {
                            if (1 != s.options.search && 1 != s.options.filters || !s.results) e = s.rows;
                            else var e = s.results;
                            var t = 0;
                            if (e.length > 100) {
                                var n = parseInt(s.tbody.firstChild.getAttribute("data-y"));
                                if (1 != s.options.search && 1 != s.options.filters || !s.results || (n = e.indexOf(n)), n > 0) for(var r = 0; r < 30; r++)(n -= 1) > -1 && (1 != s.options.search && 1 != s.options.filters || !s.results ? s.tbody.insertBefore(s.rows[n], s.tbody.firstChild) : s.tbody.insertBefore(s.rows[e[n]], s.tbody.firstChild), s.tbody.children.length > 100 && (s.tbody.removeChild(s.tbody.lastChild), t = 1));
                            }
                            return t;
                        }, s.loadDown = function() {
                            if (1 != s.options.search && 1 != s.options.filters || !s.results) e = s.rows;
                            else var e = s.results;
                            var t = 0;
                            if (e.length > 100) {
                                var n = parseInt(s.tbody.lastChild.getAttribute("data-y"));
                                if (1 != s.options.search && 1 != s.options.filters || !s.results || (n = e.indexOf(n)), n < s.rows.length - 1) for(var r = 0; r <= 30; r++)n < e.length && (1 != s.options.search && 1 != s.options.filters || !s.results ? s.tbody.appendChild(s.rows[n]) : s.tbody.appendChild(s.rows[e[n]]), s.tbody.children.length > 100 && (s.tbody.removeChild(s.tbody.firstChild), t = 1)), n += 1;
                            }
                            return t;
                        }, s.loadValidation = function() {
                            if (s.selectedCell) {
                                var e = parseInt(s.tbody.firstChild.getAttribute("data-y")) / 100, t = parseInt(s.selectedCell[3] / 100), n = parseInt(s.rows.length / 100);
                                if (e != t && t <= n && !Array.prototype.indexOf.call(s.tbody.children, s.rows[s.selectedCell[3]])) return s.loadPage(t), !0;
                            }
                            return !1;
                        }, s.resetSearch = function() {
                            s.searchInput.value = "", s.search(""), s.results = null;
                        }, s.search = function(e) {
                            if (s.options.filters && s.resetFilters(), s.resetSelection(), s.pageNumber = 0, s.results = [], e) {
                                var t = function(e) {
                                    -1 == s.results.indexOf(e) && s.results.push(e);
                                }, n = e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                                n = new RegExp(n, "i"), s.options.data.forEach(function(e, r) {
                                    if (function(e, t, n) {
                                        for(var r = 0; r < e.length; r++)if (("" + e[r]).toLowerCase().search(t) >= 0 || ("" + s.records[n][r].innerHTML).toLowerCase().search(t) >= 0) return !0;
                                        return !1;
                                    }(e, n, r)) {
                                        var o = s.isRowMerged(r);
                                        if (o.length) for(var l = 0; l < o.length; l++)for(var a = i.getIdFromColumnName(o[l], !0), u = 0; u < s.options.mergeCells[o[l]][1]; u++)t(a[1] + u);
                                        else t(r);
                                    }
                                });
                            } else s.results = null;
                            return s.updateResult();
                        }, s.updateResult = function() {
                            var e, t = 0;
                            for(e = 1 == s.options.lazyLoading ? 100 : s.options.pagination > 0 ? s.options.pagination : s.results ? s.results.length : s.rows.length; s.tbody.firstChild;)s.tbody.removeChild(s.tbody.firstChild);
                            for(var n = 0; n < s.rows.length; n++)!s.results || s.results.indexOf(n) > -1 ? (t < e && (s.tbody.appendChild(s.rows[n]), t++), s.rows[n].style.display = "") : s.rows[n].style.display = "none";
                            return s.options.pagination > 0 && s.updatePagination(), s.updateCornerPosition(), e;
                        }, s.whichPage = function(e) {
                            return 1 != s.options.search && 1 != s.options.filters || !s.results || (e = s.results.indexOf(e)), Math.ceil((parseInt(e) + 1) / parseInt(s.options.pagination)) - 1;
                        }, s.page = function(t) {
                            var n = s.pageNumber;
                            if (1 != s.options.search && 1 != s.options.filters || !s.results) r = s.rows;
                            else var r = s.results;
                            var o = parseInt(s.options.pagination);
                            null != t && -1 != t || (t = Math.ceil(r.length / o) - 1), s.pageNumber = t;
                            var i = t * o, l = t * o + o;
                            for(l > r.length && (l = r.length), i < 0 && (i = 0); s.tbody.firstChild;)s.tbody.removeChild(s.tbody.firstChild);
                            for(var a = i; a < l; a++)1 != s.options.search && 1 != s.options.filters || !s.results ? s.tbody.appendChild(s.rows[a]) : s.tbody.appendChild(s.rows[r[a]]);
                            s.options.pagination > 0 && s.updatePagination(), s.updateCornerPosition(), s.dispatch("onchangepage", e, t, n);
                        }, s.updatePagination = function() {
                            if (s.pagination.children[0].innerHTML = "", s.pagination.children[1].innerHTML = "", s.options.pagination) {
                                if (1 != s.options.search && 1 != s.options.filters || !s.results) e = s.rows.length;
                                else var e = s.results.length;
                                if (e) {
                                    var t = Math.ceil(e / s.options.pagination);
                                    if (s.pageNumber < 6) var n = 1, r = t < 10 ? t : 10;
                                    else t - s.pageNumber < 5 ? (r = t, (n = t - 9) < 1 && (n = 1)) : (n = s.pageNumber - 4, r = s.pageNumber + 5);
                                    n > 1 && ((i = document.createElement("div")).className = "jexcel_page", i.innerHTML = "<", i.title = 1, s.pagination.children[1].appendChild(i));
                                    for(var o = n; o <= r; o++){
                                        var i;
                                        (i = document.createElement("div")).className = "jexcel_page", i.innerHTML = o, s.pagination.children[1].appendChild(i), s.pageNumber == o - 1 && i.classList.add("jexcel_page_selected");
                                    }
                                    r < t && ((i = document.createElement("div")).className = "jexcel_page", i.innerHTML = ">", i.title = t, s.pagination.children[1].appendChild(i));
                                    s.pagination.children[0].innerHTML = function(e) {
                                        var t = Array.prototype.slice.call(arguments, 1);
                                        return e.replace(/{(\d+)}/g, function(e, n) {
                                            return void 0 !== t[n] ? t[n] : e;
                                        });
                                    }(s.options.text.showingPage, s.pageNumber + 1, t);
                                } else s.pagination.children[0].innerHTML = s.options.text.noRecordsFound;
                            }
                        }, s.download = function(e) {
                            if (0 == s.options.allowExport) console.error("Export not allowed");
                            else {
                                var t = "";
                                t += s.copy(!1, s.options.csvDelimiter, !0, e, !0);
                                var n = new Blob([
                                    "\uFEFF" + t
                                ], {
                                    type: "text/csv;charset=utf-8;"
                                });
                                if (window.navigator && window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(n, s.options.csvFileName + ".csv");
                                else {
                                    var r = document.createElement("a"), o = URL.createObjectURL(n);
                                    r.href = o, r.setAttribute("download", s.options.csvFileName + ".csv"), document.body.appendChild(r), r.click(), r.parentNode.removeChild(r);
                                }
                            }
                        }, s.setHistory = function(e) {
                            if (1 != s.ignoreHistory) {
                                var t = ++s.historyIndex;
                                s.history = s.history = s.history.slice(0, t + 1), s.history[t] = e;
                            }
                        }, s.copy = function(t, n, r, o, i) {
                            n || (n = "	");
                            for(var l = new RegExp(n, "ig"), a = [], u = [], c = [], f = [], d = [], p = s.options.data[0].length, h = s.options.data.length, g = "", m = !1, v = "", y = "", C = 0, w = 0, b = 0, A = 0, E = !0, M = 0; M < h; M++)for(var I = 0; I < p; I++)t && !s.records[M][I].classList.contains("highlight") || (b <= I && (b = I), A <= M && (A = M));
                            if (p === b + 1 && h === A + 1 && (E = !1), i && 1 == s.options.includeHeadersOnDownload || !i && 1 == s.options.includeHeadersOnCopy && !E || o) {
                                if (s.options.nestedHeaders && s.options.nestedHeaders.length > 0) for(g = s.options.nestedHeaders[0] && s.options.nestedHeaders[0][0] ? s.options.nestedHeaders : [
                                    s.options.nestedHeaders
                                ], M = 0; M < g.length; M++){
                                    var N = [];
                                    for(I = 0; I < g[M].length; I++){
                                        var x = parseInt(g[M][I].colspan);
                                        N.push(g[M][I].title);
                                        for(var S = 0; S < x - 1; S++)N.push("");
                                    }
                                    y += N.join(n) + "\r\n";
                                }
                                m = !0;
                            }
                            for(s.style = [], M = 0; M < h; M++){
                                for(u = [], c = [], I = 0; I < p; I++)if (!t || s.records[M][I].classList.contains("highlight")) {
                                    1 == m && a.push(s.headers[I].textContent);
                                    var D = s.options.data[M][I];
                                    if (D.match && (D.match(l) || D.match(/,/g) || D.match(/\n/) || D.match(/\"/)) && (D = '"' + (D = D.replace(new RegExp('"', "g"), '""')) + '"'), u.push(D), "checkbox" == s.options.columns[I].type || "radio" == s.options.columns[I].type) var T = D;
                                    else (T = 1 == s.options.stripHTMLOnCopy ? s.records[M][I].textContent : s.records[M][I].innerHTML).match && (T.match(l) || T.match(/,/g) || T.match(/\n/) || T.match(/\"/)) && (T = '"' + (T = T.replace(new RegExp('"', "g"), '""')) + '"');
                                    c.push(T), g = (g = s.records[M][I].getAttribute("style")).replace("display: none;", ""), s.style.push(g || "");
                                }
                                u.length && (m && (C = u.length, f.push(a.join(n))), f.push(u.join(n))), c.length && (w++, m && (d.push(a.join(n)), m = !1), d.push(c.join(n)));
                            }
                            p == C && h == w && (v = y);
                            var F = v + f.join("\r\n"), L = v + d.join("\r\n");
                            if (r || (1 == s.options.copyCompatibility ? s.textarea.value = L : s.textarea.value = F, s.textarea.select(), document.execCommand("copy")), 1 == s.options.copyCompatibility ? s.data = L : s.data = F, s.hashString = s.hash(s.data), !r) {
                                if (s.removeCopyingSelection(), s.highlighted) for(I = 0; I < s.highlighted.length; I++)s.highlighted[I].classList.add("copying"), s.highlighted[I].classList.contains("highlight-left") && s.highlighted[I].classList.add("copying-left"), s.highlighted[I].classList.contains("highlight-right") && s.highlighted[I].classList.add("copying-right"), s.highlighted[I].classList.contains("highlight-top") && s.highlighted[I].classList.add("copying-top"), s.highlighted[I].classList.contains("highlight-bottom") && s.highlighted[I].classList.add("copying-bottom");
                                s.dispatch("oncopy", e, 1 == s.options.copyCompatibility ? d : f, s.hashString);
                            }
                            return s.data;
                        }, s.paste = function(t, n, r) {
                            var o = parseInt(t), l = parseInt(n), a = parseInt(s.selectedCell[2]), u = parseInt(s.selectedCell[3]), c = a - o + 1, f = u - l + 1;
                            a < o && (t = a.toString(), c = o - a + 1), u < l && (n = u.toString(), f = l - u + 1);
                            var d = s.dispatch("onbeforepaste", e, r, t, n);
                            if (!1 === d) return !1;
                            d && (r = d);
                            var p = s.hash(r), h = p == s.hashString ? s.style : null;
                            if (1 == s.options.copyCompatibility && p == s.hashString && (r = s.data), r = s.parseCSV(r, "	"), c > 1 & Number.isInteger(c / r[0].length)) {
                                h = null, m = c / r[0].length;
                                var g = r.map(function(e, t) {
                                    var n = Array.apply(null, {
                                        length: m * e.length
                                    }).map(function(t, n) {
                                        return e[n % e.length];
                                    });
                                    return n;
                                });
                                r = g;
                            }
                            if (f > 1 & Number.isInteger(f / r.length)) {
                                h = null;
                                var m = f / r.length;
                                g = Array.apply(null, {
                                    length: m * r.length
                                }).map(function(e, t) {
                                    return r[t % r.length];
                                }), r = g;
                            }
                            if (null != t && null != n && r) {
                                for(var v = 0, y = 0, C = [], w = {}, b = {}, A = 0, E = parseInt(t), M = parseInt(n), I = null; I = r[y];){
                                    for(v = 0, E = parseInt(t); null != I[v];){
                                        var N = s.updateCell(E, M, I[v]);
                                        if (C.push(N), s.updateFormulaChain(E, M, C), h && h[A]) {
                                            var x = i.getColumnNameFromId([
                                                E,
                                                M
                                            ]);
                                            w[x] = h[A], b[x] = s.getStyle(x), s.records[M][E].setAttribute("style", h[A]), A++;
                                        }
                                        if (null != I[++v]) {
                                            if (E >= s.headers.length - 1) {
                                                if (1 != s.options.allowInsertColumn) break;
                                                s.insertColumn();
                                            }
                                            E = s.right.get(E, M);
                                        }
                                    }
                                    if (y++, r[y]) {
                                        if (M >= s.rows.length - 1) {
                                            if (1 != s.options.allowInsertRow) break;
                                            s.insertRow();
                                        }
                                        M = s.down.get(t, M);
                                    }
                                }
                                s.updateSelectionFromCoords(t, n, E, M), s.setHistory({
                                    action: "setValue",
                                    records: C,
                                    selection: s.selectedCell,
                                    newStyle: w,
                                    oldStyle: b
                                }), s.updateTable(), s.dispatch("onpaste", e, r), s.onafterchanges(e, C);
                            }
                            s.removeCopyingSelection();
                        }, s.removeCopyingSelection = function() {
                            for(var e = document.querySelectorAll(".jexcel .copying"), t = 0; t < e.length; t++)e[t].classList.remove("copying"), e[t].classList.remove("copying-left"), e[t].classList.remove("copying-right"), e[t].classList.remove("copying-top"), e[t].classList.remove("copying-bottom");
                        }, s.historyProcessRow = function(e, t) {
                            var n = t.insertBefore ? +t.rowNumber : t.rowNumber + 1;
                            if (1 == s.options.search && s.results && s.results.length != s.rows.length && s.resetSearch(), 1 == e) {
                                for(var r = t.numOfRows, o = n; o < r + n; o++)s.rows[o].parentNode.removeChild(s.rows[o]);
                                s.records.splice(n, r), s.options.data.splice(n, r), s.rows.splice(n, r), s.conditionalSelectionUpdate(1, n, r + n - 1);
                            } else {
                                s.records = i.injectArray(s.records, n, t.rowRecords), s.options.data = i.injectArray(s.options.data, n, t.rowData), s.rows = i.injectArray(s.rows, n, t.rowNode);
                                var l = 0;
                                for(o = n; o < t.numOfRows + n; o++)s.tbody.insertBefore(t.rowNode[l], s.tbody.children[o]), l++;
                            }
                            s.options.pagination > 0 && s.page(s.pageNumber), s.updateTableReferences();
                        }, s.historyProcessColumn = function(e, t) {
                            var n = t.insertBefore ? t.columnNumber : t.columnNumber + 1;
                            if (1 == e) {
                                var r = t.numOfColumns;
                                s.options.columns.splice(n, r);
                                for(var o = n; o < r + n; o++)s.headers[o].parentNode.removeChild(s.headers[o]), s.colgroup[o].parentNode.removeChild(s.colgroup[o]);
                                s.headers.splice(n, r), s.colgroup.splice(n, r);
                                for(var l = 0; l < t.data.length; l++){
                                    for(o = n; o < r + n; o++)s.records[l][o].parentNode.removeChild(s.records[l][o]);
                                    s.records[l].splice(n, r), s.options.data[l].splice(n, r);
                                }
                                if (s.options.footers) for(l = 0; l < s.options.footers.length; l++)s.options.footers[l].splice(n, r);
                            } else {
                                s.options.columns = i.injectArray(s.options.columns, n, t.columns), s.headers = i.injectArray(s.headers, n, t.headers), s.colgroup = i.injectArray(s.colgroup, n, t.colgroup);
                                var a = 0;
                                for(o = n; o < t.numOfColumns + n; o++)s.headerContainer.insertBefore(t.headers[a], s.headerContainer.children[o + 1]), s.colgroupContainer.insertBefore(t.colgroup[a], s.colgroupContainer.children[o + 1]), a++;
                                for(l = 0; l < t.data.length; l++)for(s.options.data[l] = i.injectArray(s.options.data[l], n, t.data[l]), s.records[l] = i.injectArray(s.records[l], n, t.records[l]), a = 0, o = n; o < t.numOfColumns + n; o++)s.rows[l].insertBefore(t.records[l][a], s.rows[l].children[o + 1]), a++;
                                if (s.options.footers) for(l = 0; l < s.options.footers.length; l++)s.options.footers[l] = i.injectArray(s.options.footers[l], n, t.footers[l]);
                            }
                            if (s.options.nestedHeaders && s.options.nestedHeaders.length > 0) {
                                if (s.options.nestedHeaders[0] && s.options.nestedHeaders[0][0]) for(l = 0; l < s.options.nestedHeaders.length; l++){
                                    if (1 == e) var u = parseInt(s.options.nestedHeaders[l][s.options.nestedHeaders[l].length - 1].colspan) - t.numOfColumns;
                                    else u = parseInt(s.options.nestedHeaders[l][s.options.nestedHeaders[l].length - 1].colspan) + t.numOfColumns;
                                    s.options.nestedHeaders[l][s.options.nestedHeaders[l].length - 1].colspan = u, s.thead.children[l].children[s.thead.children[l].children.length - 1].setAttribute("colspan", u);
                                }
                                else u = 1 == e ? parseInt(s.options.nestedHeaders[0].colspan) - t.numOfColumns : parseInt(s.options.nestedHeaders[0].colspan) + t.numOfColumns, s.options.nestedHeaders[0].colspan = u, s.thead.children[0].children[s.thead.children[0].children.length - 1].setAttribute("colspan", u);
                            }
                            s.updateTableReferences();
                        }, s.undo = function() {
                            var t = !!s.ignoreEvents, n = !!s.ignoreHistory;
                            s.ignoreEvents = !0, s.ignoreHistory = !0;
                            var r = [];
                            if (s.historyIndex >= 0) {
                                var o = s.history[s.historyIndex--];
                                if ("insertRow" == o.action) s.historyProcessRow(1, o);
                                else if ("deleteRow" == o.action) s.historyProcessRow(0, o);
                                else if ("insertColumn" == o.action) s.historyProcessColumn(1, o);
                                else if ("deleteColumn" == o.action) s.historyProcessColumn(0, o);
                                else if ("moveRow" == o.action) s.moveRow(o.newValue, o.oldValue);
                                else if ("moveColumn" == o.action) s.moveColumn(o.newValue, o.oldValue);
                                else if ("setMerge" == o.action) s.removeMerge(o.column, o.data);
                                else if ("setStyle" == o.action) s.setStyle(o.oldValue, null, null, 1);
                                else if ("setWidth" == o.action) s.setWidth(o.column, o.oldValue);
                                else if ("setHeight" == o.action) s.setHeight(o.row, o.oldValue);
                                else if ("setHeader" == o.action) s.setHeader(o.column, o.oldValue);
                                else if ("setComments" == o.action) s.setComments(o.column, o.oldValue[0], o.oldValue[1]);
                                else if ("orderBy" == o.action) {
                                    for(var i = [], l = 0; l < o.rows.length; l++)i[o.rows[l]] = l;
                                    s.updateOrderArrow(o.column, o.order ? 0 : 1), s.updateOrder(i);
                                } else if ("setValue" == o.action) {
                                    for(var a = 0; a < o.records.length; a++)r.push({
                                        x: o.records[a].x,
                                        y: o.records[a].y,
                                        newValue: o.records[a].oldValue
                                    }), o.oldStyle && s.resetStyle(o.oldStyle);
                                    s.setValue(r), o.selection && s.updateSelectionFromCoords(o.selection[0], o.selection[1], o.selection[2], o.selection[3]);
                                }
                            }
                            s.ignoreEvents = t, s.ignoreHistory = n, s.dispatch("onundo", e, o);
                        }, s.redo = function() {
                            var t = !!s.ignoreEvents, n = !!s.ignoreHistory;
                            if (s.ignoreEvents = !0, s.ignoreHistory = !0, s.historyIndex < s.history.length - 1) {
                                var r = s.history[++s.historyIndex];
                                if ("insertRow" == r.action) s.historyProcessRow(0, r);
                                else if ("deleteRow" == r.action) s.historyProcessRow(1, r);
                                else if ("insertColumn" == r.action) s.historyProcessColumn(0, r);
                                else if ("deleteColumn" == r.action) s.historyProcessColumn(1, r);
                                else if ("moveRow" == r.action) s.moveRow(r.oldValue, r.newValue);
                                else if ("moveColumn" == r.action) s.moveColumn(r.oldValue, r.newValue);
                                else if ("setMerge" == r.action) s.setMerge(r.column, r.colspan, r.rowspan, 1);
                                else if ("setStyle" == r.action) s.setStyle(r.newValue, null, null, 1);
                                else if ("setWidth" == r.action) s.setWidth(r.column, r.newValue);
                                else if ("setHeight" == r.action) s.setHeight(r.row, r.newValue);
                                else if ("setHeader" == r.action) s.setHeader(r.column, r.newValue);
                                else if ("setComments" == r.action) s.setComments(r.column, r.newValue[0], r.newValue[1]);
                                else if ("orderBy" == r.action) s.updateOrderArrow(r.column, r.order), s.updateOrder(r.rows);
                                else if ("setValue" == r.action) {
                                    s.setValue(r.records);
                                    for(var o = 0; o < r.records.length; o++)r.oldStyle && s.resetStyle(r.newStyle);
                                    r.selection && s.updateSelectionFromCoords(r.selection[0], r.selection[1], r.selection[2], r.selection[3]);
                                }
                            }
                            s.ignoreEvents = t, s.ignoreHistory = n, s.dispatch("onredo", e, r);
                        }, s.getDropDownValue = function(e, t) {
                            var n = [];
                            if (s.options.columns[e] && s.options.columns[e].source) {
                                for(var r = [], o = s.options.columns[e].source, i = 0; i < o.length; i++)"object" == typeof o[i] ? r[o[i].id] = o[i].name : r[o[i]] = o[i];
                                var l = Array.isArray(t) ? t : ("" + t).split(";");
                                for(i = 0; i < l.length; i++)"object" == typeof l[i] ? n.push(r[l[i].id]) : r[l[i]] && n.push(r[l[i]]);
                            } else console.error("Invalid column");
                            return n.length > 0 ? n.join("; ") : "";
                        }, s.parseCSV = function(e, t) {
                            9 == (e = e.replace(/\r?\n$|\r$|\n$/g, "")).charCodeAt(e.length - 1) && (e += "\x00"), t = t || ",";
                            for(var n = [], r = !1, o = 0, i = 0, s = 0; s < e.length; s++){
                                var l = e[s], a = e[s + 1];
                                n[o] = n[o] || [], n[o][i] = n[o][i] || "", '"' == l && r && '"' == a ? (n[o][i] += l, ++s) : '"' != l ? l != t || r ? "\r" != l || "\n" != a || r ? "\n" == l && !r || "\r" == l && !r ? (++o, i = 0) : n[o][i] += l : (++o, i = 0, ++s) : ++i : r = !r;
                            }
                            return n;
                        }, s.hash = function(e) {
                            var t, n = 0;
                            if (0 === e.length) return n;
                            for(t = 0; t < e.length; t++)n = (n << 5) - n + e.charCodeAt(t), n |= 0;
                            return n;
                        }, s.onafterchanges = function(e, t) {
                            s.dispatch("onafterchanges", e, t);
                        }, s.destroy = function() {
                            i.destroy(e);
                        }, s.init = function() {
                            i.current = s, "function" == typeof i.build && (s.options.root ? i.build(s.options.root) : (i.build(document), i.build = null)), e.setAttribute("tabindex", 1), e.addEventListener("focus", function(e) {
                                i.current && !s.selectedCell && (s.updateSelectionFromCoords(0, 0, 0, 0), s.left());
                            }), s.options.csv ? (1 == s.options.loadingSpin && $8de3fc43dda686a8$exports.loading.show(), $8de3fc43dda686a8$exports.ajax({
                                url: s.options.csv,
                                method: s.options.method,
                                data: s.options.requestVariables,
                                dataType: "text",
                                success: function(e) {
                                    var t = s.parseCSV(e, s.options.csvDelimiter);
                                    if (1 == s.options.csvHeaders && t.length > 0) for(var n = t.shift(), r = 0; r < n.length; r++)s.options.columns[r] || (s.options.columns[r] = {
                                        type: "text",
                                        align: s.options.defaultColAlign,
                                        width: s.options.defaultColWidth
                                    }), void 0 === s.options.columns[r].title && (s.options.columns[r].title = n[r]);
                                    s.options.data = t, s.prepareTable(), 1 == s.options.loadingSpin && $8de3fc43dda686a8$exports.loading.hide();
                                }
                            })) : s.options.url ? (1 == s.options.loadingSpin && $8de3fc43dda686a8$exports.loading.show(), $8de3fc43dda686a8$exports.ajax({
                                url: s.options.url,
                                method: s.options.method,
                                data: s.options.requestVariables,
                                dataType: "json",
                                success: function(e) {
                                    s.options.data = e.data ? e.data : e, s.prepareTable(), 1 == s.options.loadingSpin && $8de3fc43dda686a8$exports.loading.hide();
                                }
                            })) : s.prepareTable();
                        }, r && null != r.contextMenu ? s.options.contextMenu = r.contextMenu : s.options.contextMenu = function(e, n, r, o) {
                            var l = [];
                            if (null == r) 1 == s.options.allowInsertColumn && l.push({
                                title: s.options.text.insertANewColumnBefore,
                                onclick: function() {
                                    s.insertColumn(1, parseInt(n), 1);
                                }
                            }), 1 == s.options.allowInsertColumn && l.push({
                                title: s.options.text.insertANewColumnAfter,
                                onclick: function() {
                                    s.insertColumn(1, parseInt(n), 0);
                                }
                            }), 1 == s.options.allowDeleteColumn && l.push({
                                title: s.options.text.deleteSelectedColumns,
                                onclick: function() {
                                    s.deleteColumn(s.getSelectedColumns().length ? void 0 : parseInt(n));
                                }
                            }), 1 == s.options.allowRenameColumn && l.push({
                                title: s.options.text.renameThisColumn,
                                onclick: function() {
                                    s.setHeader(n);
                                }
                            }), 1 == s.options.columnSorting && (l.push({
                                type: "line"
                            }), l.push({
                                title: s.options.text.orderAscending,
                                onclick: function() {
                                    s.orderBy(n, 0);
                                }
                            }), l.push({
                                title: s.options.text.orderDescending,
                                onclick: function() {
                                    s.orderBy(n, 1);
                                }
                            }));
                            else if (1 == s.options.allowInsertRow && (l.push({
                                title: s.options.text.insertANewRowBefore,
                                onclick: function() {
                                    s.insertRow(1, parseInt(r), 1);
                                }
                            }), l.push({
                                title: s.options.text.insertANewRowAfter,
                                onclick: function() {
                                    s.insertRow(1, parseInt(r));
                                }
                            })), 1 == s.options.allowDeleteRow && l.push({
                                title: s.options.text.deleteSelectedRows,
                                onclick: function() {
                                    s.deleteRow(s.getSelectedRows().length ? void 0 : parseInt(r));
                                }
                            }), n && 1 == s.options.allowComments) {
                                l.push({
                                    type: "line"
                                });
                                var a = s.records[r][n].getAttribute("title") || "";
                                l.push({
                                    title: a ? s.options.text.editComments : s.options.text.addComments,
                                    onclick: function() {
                                        var e = prompt(s.options.text.comments, a);
                                        e && s.setComments([
                                            n,
                                            r
                                        ], e);
                                    }
                                }), a && l.push({
                                    title: s.options.text.clearComments,
                                    onclick: function() {
                                        s.setComments([
                                            n,
                                            r
                                        ], "");
                                    }
                                });
                            }
                            return l.push({
                                type: "line"
                            }), l.push({
                                title: s.options.text.copy,
                                shortcut: "Ctrl + C",
                                onclick: function() {
                                    s.copy(!0);
                                }
                            }), navigator && navigator.clipboard && l.push({
                                title: s.options.text.paste,
                                shortcut: "Ctrl + V",
                                onclick: function() {
                                    s.selectedCell && navigator.clipboard.readText().then(function(e) {
                                        e && i.current.paste(s.selectedCell[0], s.selectedCell[1], e);
                                    });
                                }
                            }), s.options.allowExport && l.push({
                                title: s.options.text.saveAs,
                                shortcut: "Ctrl + S",
                                onclick: function() {
                                    s.download();
                                }
                            }), s.options.about && l.push({
                                title: s.options.text.about,
                                onclick: function() {
                                    !0 === s.options.about ? alert(t().print()) : alert(s.options.about);
                                }
                            }), l;
                        }, s.scrollControls = function(e) {
                            s.wheelControls(), s.options.freezeColumns > 0 && s.content.scrollLeft != g && s.updateFreezePosition(), 1 != s.options.lazyLoading && 1 != s.options.tableOverflow || s.edition && "jdropdown" != e.target.className.substr(0, 9) && s.closeEditor(s.edition[0], !0);
                        }, s.wheelControls = function(e) {
                            1 == s.options.lazyLoading && null == i.timeControlLoading && (i.timeControlLoading = setTimeout(function() {
                                s.content.scrollTop + s.content.clientHeight >= s.content.scrollHeight - 10 ? s.loadDown() && (s.content.scrollTop + s.content.clientHeight > s.content.scrollHeight - 10 && (s.content.scrollTop = s.content.scrollTop - s.content.clientHeight), s.updateCornerPosition()) : s.content.scrollTop <= s.content.clientHeight && s.loadUp() && (s.content.scrollTop < 10 && (s.content.scrollTop = s.content.scrollTop + s.content.clientHeight), s.updateCornerPosition()), i.timeControlLoading = null;
                            }, 100));
                        }, s.getFreezeWidth = function() {
                            var e = 0;
                            if (s.options.freezeColumns > 0) for(var t = 0; t < s.options.freezeColumns; t++)e += parseInt(s.options.columns[t].width);
                            return e;
                        };
                        var g = 0;
                        return s.updateFreezePosition = function() {
                            var e = 0;
                            if ((g = s.content.scrollLeft) > 50) for(var t = 0; t < s.options.freezeColumns; t++){
                                t > 0 && "hidden" !== s.options.columns[t - 1].type && (e += parseInt(s.options.columns[t - 1].width)), s.headers[t].classList.add("jexcel_freezed"), s.headers[t].style.left = e + "px";
                                for(var n = 0; n < s.rows.length; n++)if (s.rows[n] && s.records[n][t]) {
                                    var r = g + (t > 0 ? s.records[n][t - 1].style.width : 0) - 51 + "px";
                                    s.records[n][t].classList.add("jexcel_freezed"), s.records[n][t].style.left = r;
                                }
                            }
                            else for(t = 0; t < s.options.freezeColumns; t++)for(s.headers[t].classList.remove("jexcel_freezed"), s.headers[t].style.left = "", n = 0; n < s.rows.length; n++)s.records[n][t] && (s.records[n][t].classList.remove("jexcel_freezed"), s.records[n][t].style.left = "");
                            s.updateCornerPosition();
                        }, e.addEventListener("DOMMouseScroll", s.wheelControls), e.addEventListener("mousewheel", s.wheelControls), e.jexcel = s, e.jspreadsheet = s, s.init(), s;
                    };
                    i.setDictionary = function(e) {
                        $8de3fc43dda686a8$exports.setDictionary(e);
                    }, i.setExtensions = function(e) {
                        for(var t = Object.keys(e), n = 0; n < t.length; n++)"function" == typeof e[t[n]] && (i[t[n]] = e[t[n]], i.license && "function" == typeof e[t[n]].license && e[t[n]].license(i.license));
                    }, void 0 !== r && (i.formula = r), i.version = t, i.current = null, i.timeControl = null, i.timeControlLoading = null;
                    const s = function(e) {
                        e.removeEventListener("mouseup", i.mouseUpControls), e.removeEventListener("mousedown", i.mouseDownControls), e.removeEventListener("mousemove", i.mouseMoveControls), e.removeEventListener("mouseover", i.mouseOverControls), e.removeEventListener("dblclick", i.doubleClickControls), e.removeEventListener("paste", i.pasteControls), e.removeEventListener("contextmenu", i.contextMenuControls), e.removeEventListener("touchstart", i.touchStartControls), e.removeEventListener("touchend", i.touchEndControls), e.removeEventListener("touchcancel", i.touchEndControls), document.removeEventListener("keydown", i.keyDownControls);
                    };
                    var l;
                    return i.destroy = function(e, t) {
                        if (e.jexcel) {
                            var n = e.jexcel.options.root ? e.jexcel.options.root : document;
                            e.removeEventListener("DOMMouseScroll", e.jexcel.scrollControls), e.removeEventListener("mousewheel", e.jexcel.scrollControls), e.jexcel = null, e.innerHTML = "", t && (s(n), i = null);
                        }
                    }, i.build = function(e) {
                        s(e), e.addEventListener("mouseup", i.mouseUpControls), e.addEventListener("mousedown", i.mouseDownControls), e.addEventListener("mousemove", i.mouseMoveControls), e.addEventListener("mouseover", i.mouseOverControls), e.addEventListener("dblclick", i.doubleClickControls), e.addEventListener("paste", i.pasteControls), e.addEventListener("contextmenu", i.contextMenuControls), e.addEventListener("touchstart", i.touchStartControls), e.addEventListener("touchend", i.touchEndControls), e.addEventListener("touchcancel", i.touchEndControls), e.addEventListener("touchmove", i.touchEndControls), document.addEventListener("keydown", i.keyDownControls);
                    }, i.keyDownControls = function(e) {
                        if (i.current) {
                            if (i.current.edition) {
                                if (27 == e.which) i.current.edition && i.current.closeEditor(i.current.edition[0], !1), e.preventDefault();
                                else if (13 == e.which) {
                                    if ("calendar" == i.current.options.columns[i.current.edition[2]].type) i.current.closeEditor(i.current.edition[0], !0);
                                    else if ("dropdown" == i.current.options.columns[i.current.edition[2]].type || "autocomplete" == i.current.options.columns[i.current.edition[2]].type) ;
                                    else if ((1 == i.current.options.wordWrap || 1 == i.current.options.columns[i.current.edition[2]].wordWrap || i.current.options.data[i.current.edition[3]][i.current.edition[2]].length > 200) && e.altKey) {
                                        var t = i.current.edition[0].children[0], n = i.current.edition[0].children[0].value, r = t.selectionStart;
                                        n = n.slice(0, r) + "\n" + n.slice(r), t.value = n, t.focus(), t.selectionStart = r + 1, t.selectionEnd = r + 1;
                                    } else i.current.edition[0].children[0].blur();
                                } else 9 == e.which && ([
                                    "calendar",
                                    "html"
                                ].includes(i.current.options.columns[i.current.edition[2]].type) ? i.current.closeEditor(i.current.edition[0], !0) : i.current.edition[0].children[0].blur());
                            }
                            if (!i.current.edition && i.current.selectedCell) {
                                if (37 == e.which) i.current.left(e.shiftKey, e.ctrlKey), e.preventDefault();
                                else if (39 == e.which) i.current.right(e.shiftKey, e.ctrlKey), e.preventDefault();
                                else if (38 == e.which) i.current.up(e.shiftKey, e.ctrlKey), e.preventDefault();
                                else if (40 == e.which) i.current.down(e.shiftKey, e.ctrlKey), e.preventDefault();
                                else if (36 == e.which) i.current.first(e.shiftKey, e.ctrlKey), e.preventDefault();
                                else if (35 == e.which) i.current.last(e.shiftKey, e.ctrlKey), e.preventDefault();
                                else if (46 == e.which || 8 == e.which) 1 == i.current.options.editable && (i.current.selectedRow ? 1 == i.current.options.allowDeleteRow && confirm(i.current.options.text.areYouSureToDeleteTheSelectedRows) && i.current.deleteRow() : i.current.selectedHeader ? 1 == i.current.options.allowDeleteColumn && confirm(i.current.options.text.areYouSureToDeleteTheSelectedColumns) && i.current.deleteColumn() : i.current.setValue(i.current.highlighted, ""));
                                else if (13 == e.which) e.shiftKey ? i.current.up() : (1 == i.current.options.allowInsertRow && 1 == i.current.options.allowManualInsertRow && i.current.selectedCell[1] == i.current.options.data.length - 1 && i.current.insertRow(), i.current.down()), e.preventDefault();
                                else if (9 == e.which) e.shiftKey ? i.current.left() : (1 == i.current.options.allowInsertColumn && 1 == i.current.options.allowManualInsertColumn && i.current.selectedCell[0] == i.current.options.data[0].length - 1 && i.current.insertColumn(), i.current.right()), e.preventDefault();
                                else if (!e.ctrlKey && !e.metaKey || e.shiftKey) {
                                    if (i.current.selectedCell && 1 == i.current.options.editable) {
                                        var o = i.current.selectedCell[1], s = i.current.selectedCell[0];
                                        "readonly" != i.current.options.columns[s].type && (32 == e.keyCode ? (e.preventDefault(), "checkbox" == i.current.options.columns[s].type || "radio" == i.current.options.columns[s].type ? i.current.setCheckRadioValue() : i.current.openEditor(i.current.records[o][s], !0)) : 113 == e.keyCode ? i.current.openEditor(i.current.records[o][s], !1) : (8 == e.keyCode || e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 111 || e.keyCode >= 187 && e.keyCode <= 190 || (String.fromCharCode(e.keyCode) == e.key || String.fromCharCode(e.keyCode).toLowerCase() == e.key.toLowerCase()) && i.validLetter(String.fromCharCode(e.keyCode))) && (i.current.openEditor(i.current.records[o][s], !0), "calendar" == i.current.options.columns[s].type && e.preventDefault()));
                                    }
                                } else 65 == e.which ? (i.current.selectAll(), e.preventDefault()) : 83 == e.which ? (i.current.download(), e.preventDefault()) : 89 == e.which ? (i.current.redo(), e.preventDefault()) : 90 == e.which ? (i.current.undo(), e.preventDefault()) : 67 == e.which ? (i.current.copy(!0), e.preventDefault()) : 88 == e.which ? (1 == i.current.options.editable ? i.cutControls() : i.copyControls(), e.preventDefault()) : 86 == e.which && i.pasteControls();
                            } else e.target.classList.contains("jexcel_search") && (i.timeControl && clearTimeout(i.timeControl), i.timeControl = setTimeout(function() {
                                i.current.search(e.target.value);
                            }, 200));
                        }
                    }, i.isMouseAction = !1, i.mouseDownControls = function(e) {
                        if ((e = e || window.event).buttons) var t = e.buttons;
                        else t = e.button ? e.button : e.which;
                        var n = i.getElement(e.target);
                        if (n[0] ? i.current != n[0].jexcel && (i.current && (i.current.edition && i.current.closeEditor(i.current.edition[0], !0), i.current.resetSelection()), i.current = n[0].jexcel) : i.current && (i.current.edition && i.current.closeEditor(i.current.edition[0], !0), i.current.resetSelection(!0), i.current = null), i.current && 1 == t) {
                            if (e.target.classList.contains("jexcel_selectall")) i.current && i.current.selectAll();
                            else if (e.target.classList.contains("jexcel_corner")) 1 == i.current.options.editable && (i.current.selectedCorner = !0);
                            else {
                                if (1 == n[1]) {
                                    if (h = e.target.getAttribute("data-x")) {
                                        var r = e.target.getBoundingClientRect();
                                        if (1 == i.current.options.columnResize && r.width - e.offsetX < 6) {
                                            i.current.resizing = {
                                                mousePosition: e.pageX,
                                                column: h,
                                                width: r.width
                                            }, i.current.headers[h].classList.add("resizing");
                                            for(var o = 0; o < i.current.records.length; o++)i.current.records[o][h] && i.current.records[o][h].classList.add("resizing");
                                        } else if (1 == i.current.options.columnDrag && r.height - e.offsetY < 6) {
                                            if (i.current.isColMerged(h).length) console.error("Jspreadsheet: This column is part of a merged cell.");
                                            else for(i.current.resetSelection(), i.current.dragging = {
                                                element: e.target,
                                                column: h,
                                                destination: h
                                            }, i.current.headers[h].classList.add("dragging"), o = 0; o < i.current.records.length; o++)i.current.records[o][h] && i.current.records[o][h].classList.add("dragging");
                                        } else {
                                            if (i.current.selectedHeader && (e.shiftKey || e.ctrlKey)) var s = i.current.selectedHeader, l = h;
                                            else i.current.selectedHeader == h && 1 == i.current.options.allowRenameColumn && (i.timeControl = setTimeout(function() {
                                                i.current.setHeader(h);
                                            }, 800)), i.current.selectedHeader = h, s = h, l = h;
                                            i.current.updateSelectionFromCoords(s, 0, l, i.current.options.data.length - 1);
                                        }
                                    } else if (e.target.parentNode.classList.contains("jexcel_nested")) {
                                        if (e.target.getAttribute("data-column")) var a = e.target.getAttribute("data-column").split(","), u = parseInt(a[0]), c = parseInt(a[a.length - 1]);
                                        else u = 0, c = i.current.options.columns.length - 1;
                                        i.current.updateSelectionFromCoords(u, 0, c, i.current.options.data.length - 1);
                                    }
                                } else i.current.selectedHeader = !1;
                                if (2 == n[1]) {
                                    var f = e.target.getAttribute("data-y");
                                    if (e.target.classList.contains("jexcel_row")) r = e.target.getBoundingClientRect(), 1 == i.current.options.rowResize && r.height - e.offsetY < 6 ? (i.current.resizing = {
                                        element: e.target.parentNode,
                                        mousePosition: e.pageY,
                                        row: f,
                                        height: r.height
                                    }, e.target.parentNode.classList.add("resizing")) : 1 == i.current.options.rowDrag && r.width - e.offsetX < 6 ? i.current.isRowMerged(f).length ? console.error("Jspreadsheet: This row is part of a merged cell") : 1 == i.current.options.search && i.current.results ? console.error("Jspreadsheet: Please clear your search before perform this action") : (i.current.resetSelection(), i.current.dragging = {
                                        element: e.target.parentNode,
                                        row: f,
                                        destination: f
                                    }, e.target.parentNode.classList.add("dragging")) : (i.current.selectedRow && (e.shiftKey || e.ctrlKey) ? (s = i.current.selectedRow, l = f) : (i.current.selectedRow = f, s = f, l = f), i.current.updateSelectionFromCoords(0, s, i.current.options.data[0].length - 1, l));
                                    else if (e.target.classList.contains("jclose") && e.target.clientWidth - e.offsetX < 50 && e.offsetY < 50) i.current.closeEditor(i.current.edition[0], !0);
                                    else {
                                        var d = function(e) {
                                            var t = e.getAttribute("data-x"), n = e.getAttribute("data-y");
                                            return t && n ? [
                                                t,
                                                n
                                            ] : e.parentNode ? d(e.parentNode) : void 0;
                                        }, p = d(e.target);
                                        if (p) {
                                            var h = p[0];
                                            f = p[1], i.current.edition && (i.current.edition[2] == h && i.current.edition[3] == f || i.current.closeEditor(i.current.edition[0], !0)), i.current.edition || (e.shiftKey ? i.current.updateSelectionFromCoords(i.current.selectedCell[0], i.current.selectedCell[1], h, f) : i.current.updateSelectionFromCoords(h, f)), i.current.selectedHeader = null, i.current.selectedRow = null;
                                        }
                                    }
                                } else i.current.selectedRow = !1;
                                e.target.classList.contains("jexcel_page") && ("<" == e.target.textContent ? i.current.page(0) : ">" == e.target.textContent ? i.current.page(e.target.getAttribute("title") - 1) : i.current.page(e.target.textContent - 1));
                            }
                            i.current.edition ? i.isMouseAction = !1 : i.isMouseAction = !0;
                        } else i.isMouseAction = !1;
                    }, i.mouseUpControls = function(e) {
                        if (i.current) {
                            if (i.current.resizing) {
                                if (i.current.resizing.column) {
                                    var t = i.current.colgroup[i.current.resizing.column].getAttribute("width"), n = i.current.getSelectedColumns();
                                    if (n.length > 1) {
                                        for(var r = [], o = 0; o < n.length; o++)r.push(parseInt(i.current.colgroup[n[o]].getAttribute("width")));
                                        r[n.indexOf(parseInt(i.current.resizing.column))] = i.current.resizing.width, i.current.setWidth(n, t, r);
                                    } else i.current.setWidth(i.current.resizing.column, t, i.current.resizing.width);
                                    i.current.headers[i.current.resizing.column].classList.remove("resizing");
                                    for(var s = 0; s < i.current.records.length; s++)i.current.records[s][i.current.resizing.column] && i.current.records[s][i.current.resizing.column].classList.remove("resizing");
                                } else {
                                    i.current.rows[i.current.resizing.row].children[0].classList.remove("resizing");
                                    var l = i.current.rows[i.current.resizing.row].getAttribute("height");
                                    i.current.setHeight(i.current.resizing.row, l, i.current.resizing.height), i.current.resizing.element.classList.remove("resizing");
                                }
                                i.current.resizing = null;
                            } else if (i.current.dragging) {
                                if (i.current.dragging) {
                                    if (i.current.dragging.column) {
                                        var a = e.target.getAttribute("data-x");
                                        for(i.current.headers[i.current.dragging.column].classList.remove("dragging"), s = 0; s < i.current.rows.length; s++)i.current.records[s][i.current.dragging.column] && i.current.records[s][i.current.dragging.column].classList.remove("dragging");
                                        for(o = 0; o < i.current.headers.length; o++)i.current.headers[o].classList.remove("dragging-left"), i.current.headers[o].classList.remove("dragging-right");
                                        a && i.current.dragging.column != i.current.dragging.destination && i.current.moveColumn(i.current.dragging.column, i.current.dragging.destination);
                                    } else {
                                        if (i.current.dragging.element.nextSibling) {
                                            var u = parseInt(i.current.dragging.element.nextSibling.getAttribute("data-y"));
                                            i.current.dragging.row < u && (u -= 1);
                                        } else u = parseInt(i.current.dragging.element.previousSibling.getAttribute("data-y"));
                                        i.current.dragging.row != i.current.dragging.destination && i.current.moveRow(i.current.dragging.row, u, !0), i.current.dragging.element.classList.remove("dragging");
                                    }
                                    i.current.dragging = null;
                                }
                            } else i.current.selectedCorner && (i.current.selectedCorner = !1, i.current.selection.length > 0 && (i.current.copyData(i.current.selection[0], i.current.selection[i.current.selection.length - 1]), i.current.removeCopySelection()));
                        }
                        i.timeControl && (clearTimeout(i.timeControl), i.timeControl = null), i.isMouseAction = !1;
                    }, i.mouseMoveControls = function(e) {
                        if ((e = e || window.event).buttons) var t = e.buttons;
                        else t = e.button ? e.button : e.which;
                        if (t || (i.isMouseAction = !1), i.current) {
                            if (1 == i.isMouseAction) {
                                if (i.current.resizing) {
                                    if (i.current.resizing.column) {
                                        var n = e.pageX - i.current.resizing.mousePosition;
                                        if (i.current.resizing.width + n > 0) {
                                            var r = i.current.resizing.width + n;
                                            i.current.colgroup[i.current.resizing.column].setAttribute("width", r), i.current.updateCornerPosition();
                                        }
                                    } else {
                                        var o = e.pageY - i.current.resizing.mousePosition;
                                        if (i.current.resizing.height + o > 0) {
                                            var s = i.current.resizing.height + o;
                                            i.current.rows[i.current.resizing.row].setAttribute("height", s), i.current.updateCornerPosition();
                                        }
                                    }
                                } else if (i.current.dragging) {
                                    if (i.current.dragging.column) {
                                        var l = e.target.getAttribute("data-x");
                                        if (l) {
                                            if (i.current.isColMerged(l).length) console.error("Jspreadsheet: This column is part of a merged cell.");
                                            else {
                                                for(var a = 0; a < i.current.headers.length; a++)i.current.headers[a].classList.remove("dragging-left"), i.current.headers[a].classList.remove("dragging-right");
                                                i.current.dragging.column == l ? i.current.dragging.destination = parseInt(l) : e.target.clientWidth / 2 > e.offsetX ? (i.current.dragging.column < l ? i.current.dragging.destination = parseInt(l) - 1 : i.current.dragging.destination = parseInt(l), i.current.headers[l].classList.add("dragging-left")) : (i.current.dragging.column < l ? i.current.dragging.destination = parseInt(l) : i.current.dragging.destination = parseInt(l) + 1, i.current.headers[l].classList.add("dragging-right"));
                                            }
                                        }
                                    } else {
                                        var u = e.target.getAttribute("data-y");
                                        if (u) {
                                            if (i.current.isRowMerged(u).length) console.error("Jspreadsheet: This row is part of a merged cell.");
                                            else {
                                                var c = e.target.clientHeight / 2 > e.offsetY ? e.target.parentNode.nextSibling : e.target.parentNode;
                                                i.current.dragging.element != c && (e.target.parentNode.parentNode.insertBefore(i.current.dragging.element, c), i.current.dragging.destination = Array.prototype.indexOf.call(i.current.dragging.element.parentNode.children, i.current.dragging.element));
                                            }
                                        }
                                    }
                                }
                            } else {
                                var f = e.target.getAttribute("data-x"), d = e.target.getAttribute("data-y"), p = e.target.getBoundingClientRect();
                                i.current.cursor && (i.current.cursor.style.cursor = "", i.current.cursor = null), e.target.parentNode.parentNode && e.target.parentNode.parentNode.className && (e.target.parentNode.parentNode.classList.contains("resizable") && (e.target && f && !d && p.width - (e.clientX - p.left) < 6 ? (i.current.cursor = e.target, i.current.cursor.style.cursor = "col-resize") : e.target && !f && d && p.height - (e.clientY - p.top) < 6 && (i.current.cursor = e.target, i.current.cursor.style.cursor = "row-resize")), e.target.parentNode.parentNode.classList.contains("draggable") && (e.target && !f && d && p.width - (e.clientX - p.left) < 6 || e.target && f && !d && p.height - (e.clientY - p.top) < 6) && (i.current.cursor = e.target, i.current.cursor.style.cursor = "move"));
                            }
                        }
                    }, i.mouseOverControls = function(e) {
                        if ((e = e || window.event).buttons) var t = e.buttons;
                        else t = e.button ? e.button : e.which;
                        if (t || (i.isMouseAction = !1), i.current && 1 == i.isMouseAction) {
                            var n = i.getElement(e.target);
                            if (n[0]) {
                                if (i.current != n[0].jexcel && i.current) return !1;
                                var r = e.target.getAttribute("data-x"), o = e.target.getAttribute("data-y");
                                if (i.current.resizing || i.current.dragging) ;
                                else {
                                    if (1 == n[1] && i.current.selectedHeader) {
                                        r = e.target.getAttribute("data-x");
                                        var s = i.current.selectedHeader, l = r;
                                        i.current.updateSelectionFromCoords(s, 0, l, i.current.options.data.length - 1);
                                    }
                                    2 == n[1] && (e.target.classList.contains("jexcel_row") ? i.current.selectedRow && (s = i.current.selectedRow, l = o, i.current.updateSelectionFromCoords(0, s, i.current.options.data[0].length - 1, l)) : i.current.edition || r && o && (i.current.selectedCorner ? i.current.updateCopySelection(r, o) : i.current.selectedCell && i.current.updateSelectionFromCoords(i.current.selectedCell[0], i.current.selectedCell[1], r, o)));
                                }
                            }
                        }
                        i.timeControl && (clearTimeout(i.timeControl), i.timeControl = null);
                    }, i.doubleClickControls = function(e) {
                        if (i.current) {
                            if (e.target.classList.contains("jexcel_corner")) {
                                if (i.current.highlighted.length > 0) {
                                    var t = i.current.highlighted[0].getAttribute("data-x"), n = parseInt(i.current.highlighted[i.current.highlighted.length - 1].getAttribute("data-y")) + 1, r = i.current.highlighted[i.current.highlighted.length - 1].getAttribute("data-x"), o = i.current.records.length - 1;
                                    i.current.copyData(i.current.records[n][t], i.current.records[o][r]);
                                }
                            } else if (e.target.classList.contains("jexcel_column_filter")) {
                                var s = e.target.getAttribute("data-x");
                                i.current.openFilter(s);
                            } else {
                                var l = i.getElement(e.target);
                                if (1 == l[1] && 1 == i.current.options.columnSorting && (s = e.target.getAttribute("data-x")) && i.current.orderBy(s), 2 == l[1] && 1 == i.current.options.editable && !i.current.edition) {
                                    var a = function(e) {
                                        if (e.parentNode) {
                                            var t = e.getAttribute("data-x"), n = e.getAttribute("data-y");
                                            return t && n ? e : a(e.parentNode);
                                        }
                                    }, u = a(e.target);
                                    u && u.classList.contains("highlight") && i.current.openEditor(u);
                                }
                            }
                        }
                    }, i.copyControls = function(e) {
                        i.current && i.copyControls.enabled && (i.current.edition || i.current.copy(!0));
                    }, i.cutControls = function(e) {
                        i.current && (i.current.edition || (i.current.copy(!0), 1 == i.current.options.editable && i.current.setValue(i.current.highlighted, "")));
                    }, i.pasteControls = function(e) {
                        i.current && i.current.selectedCell && (i.current.edition || 1 == i.current.options.editable && (e && e.clipboardData ? (i.current.paste(i.current.selectedCell[0], i.current.selectedCell[1], e.clipboardData.getData("text")), e.preventDefault()) : window.clipboardData && i.current.paste(i.current.selectedCell[0], i.current.selectedCell[1], window.clipboardData.getData("text"))));
                    }, i.contextMenuControls = function(e) {
                        if (e = e || window.event, console.log("DEBUG running contextMenuControls"), "buttons" in e ? e.buttons : e.which || e.button, i.current) {
                            if (i.current.edition) e.preventDefault();
                            else if (i.current.options.contextMenu && (i.current.contextMenu.contextmenu.close(), i.current)) {
                                var t = e.target.getAttribute("data-x"), n = e.target.getAttribute("data-y");
                                const [o, s, l, a] = i.current.selectedCell;
                                if (t || n) {
                                    (t < Math.min(o, l) || t > Math.max(o, l) || n < Math.min(s, a) || n > Math.max(s, a)) && i.current.updateSelectionFromCoords(t, n, t, n);
                                    var r = i.current.options.contextMenu(i.current, t, n, e);
                                    i.current.contextMenu.contextmenu.open(e, r), e.preventDefault();
                                }
                            }
                        }
                    }, i.touchStartControls = function(e) {
                        var t = i.getElement(e.target);
                        if (t[0] ? i.current != t[0].jexcel && (i.current && i.current.resetSelection(), i.current = t[0].jexcel) : i.current && (i.current.resetSelection(), i.current = null), i.current && !i.current.edition) {
                            var n = e.target.getAttribute("data-x"), r = e.target.getAttribute("data-y");
                            n && r && (i.current.updateSelectionFromCoords(n, r), i.timeControl = setTimeout(function() {
                                "color" == i.current.options.columns[n].type ? i.tmpElement = null : i.tmpElement = e.target, i.current.openEditor(e.target, !1, e);
                            }, 500));
                        }
                    }, i.touchEndControls = function(e) {
                        i.timeControl && (clearTimeout(i.timeControl), i.timeControl = null, i.tmpElement && "INPUT" == i.tmpElement.children[0].tagName && i.tmpElement.children[0].focus(), i.tmpElement = null);
                    }, i.tabs = function(e, t) {
                        var n = [];
                        if (e.classList.contains("jexcel_tabs")) o = e.children[0], s = e.children[1];
                        else {
                            e.innerHTML = "", e.classList.add("jexcel_tabs"), e.jexcel = [];
                            var r = document.createElement("div"), o = e.appendChild(r), s = (r = document.createElement("div"), e.appendChild(r));
                        }
                        for(var l = [], a = [], u = 0; u < t.length; u++){
                            l[u] = document.createElement("div"), l[u].classList.add("jexcel_tab");
                            var c = i(l[u], t[u]);
                            s.appendChild(l[u]), n[u] = e.jexcel.push(c), a[u] = document.createElement("div"), a[u].classList.add("jexcel_tab_link"), a[u].setAttribute("data-spreadsheet", e.jexcel.length - 1), a[u].innerHTML = t[u].sheetName, a[u].onclick = function() {
                                for(var e = 0; e < o.children.length; e++)o.children[e].classList.remove("selected"), s.children[e].style.display = "none";
                                var t = this.getAttribute("data-spreadsheet");
                                s.children[t].style.display = "block", o.children[t].classList.add("selected");
                            }, o.appendChild(a[u]);
                        }
                        for(var f = 0; f < o.children.length; f++)o.children[f].classList.remove("selected"), s.children[f].style.display = "none";
                        return o.children[o.children.length - 1].classList.add("selected"), s.children[o.children.length - 1].style.display = "block", n;
                    }, i.createTabs = i.tabs, i.fromSpreadsheet = function(e, t) {
                        var n, r = function(e) {
                            var t = [];
                            return e.SheetNames.forEach(function(n) {
                                var r = {
                                    rows: [],
                                    columns: [],
                                    data: [],
                                    style: {}
                                };
                                if (r.sheetName = n, (p = e.Sheets[n]["!cols"]) && p.length) for(var o = 0; o < p.length; o++)r.columns[o] = {}, p[o] && p[o].wpx && (r.columns[o].width = p[o].wpx + "px");
                                if ((p = e.Sheets[n]["!rows"]) && p.length) for(o = 0; o < p.length; o++)p[o] && p[o].hpx && (r.rows[o] = {}, r.rows[o].height = p[o].hpx + "px");
                                if ((p = e.Sheets[n]["!merges"]) && p.length > 0) for(r.mergeCells = [], o = 0; o < p.length; o++){
                                    var s = p[o].s.c, l = p[o].s.r, a = p[o].e.c, u = p[o].e.r, c = i.getColumnNameFromId([
                                        s,
                                        l
                                    ]);
                                    r.mergeCells[c] = [
                                        a - s + 1,
                                        u - l + 1
                                    ];
                                }
                                var f = 0, d = 0, p = Object.keys(e.Sheets[n]);
                                for(o = 0; o < p.length; o++)if ("!" != p[o].substr(0, 1)) {
                                    var h = e.Sheets[n][p[o]], g = i.getIdFromColumnName(p[o], !0);
                                    r.data[g[1]] || (r.data[g[1]] = []), r.data[g[1]][g[0]] = h.f ? "=" + h.f : h.w, f < g[0] && (f = g[0]), d < g[1] && (d = g[1]), h.style && Object.keys(h.style).length > 0 && (r.style[p[o]] = h.style), h.s && h.s.fgColor && (r.style[p[o]] && (r.style[p[o]] += ";"), r.style[p[o]] += "background-color:#" + h.s.fgColor.rgb);
                                }
                                for(var m = r.columns, v = 0; v <= d; v++)for(o = 0; o <= f; o++)r.data[v] || (r.data[v] = []), r.data[v][o] || m < o && (r.data[v][o] = "");
                                t.push(r);
                            }), t;
                        };
                        (n = new XMLHttpRequest).open("GET", e, !0), "undefined" != typeof Uint8Array ? (n.responseType = "arraybuffer", n.onload = function(e) {
                            var o = n.response, i = new Uint8Array(o), s = XLSX.read(i, {
                                type: "array",
                                cellFormula: !0,
                                cellStyles: !0
                            });
                            t(r(s));
                        }) : (n.setRequestHeader("Accept-Charset", "x-user-defined"), n.onreadystatechange = function() {
                            if (4 == n.readyState && 200 == n.status) {
                                var e = convertResponseBodyToText(n.responseBody), o = XLSX.read(e, {
                                    type: "binary",
                                    cellFormula: !0,
                                    cellStyles: !0
                                });
                                t(r(o));
                            }
                        }), n.send();
                    }, i.validLetter = function(e) {
                        return e.match(/([\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC-\u0400-\u04FF']+)/g) ? 1 : 0;
                    }, i.injectArray = function(e, t, n) {
                        return e.slice(0, t).concat(n).concat(e.slice(t));
                    }, i.getColumnName = function(e) {
                        return i.helpers.getColumnName(e);
                    }, i.getIdFromColumnName = function(e, t) {
                        var n = /^[a-zA-Z]+/.exec(e);
                        if (n) {
                            for(var r = 0, o = 0; o < n[0].length; o++)r += parseInt(n[0].charCodeAt(o) - 64) * Math.pow(26, n[0].length - 1 - o);
                            --r < 0 && (r = 0);
                            var i = parseInt(/[0-9]+$/.exec(e));
                            i > 0 && i--, e = 1 == t ? [
                                r,
                                i
                            ] : r + "-" + i;
                        }
                        return e;
                    }, i.getColumnNameFromId = function(e) {
                        return Array.isArray(e) || (e = e.split("-")), i.getColumnName(parseInt(e[0])) + (parseInt(e[1]) + 1);
                    }, i.getElement = function(e) {
                        var t = 0, n = 0;
                        return function e(r) {
                            r.className && r.classList.contains("jexcel_container") && (n = r), "THEAD" == r.tagName ? t = 1 : "TBODY" == r.tagName && (t = 2), r.parentNode && (n || e(r.parentNode));
                        }(e), [
                            n,
                            t
                        ];
                    }, i.doubleDigitFormat = function(e) {
                        return 1 == (e = "" + e).length && (e = "0" + e), e;
                    }, i.createFromTable = function(e, t) {
                        if ("TABLE" == e.tagName) {
                            t || (t = {}), t.columns = [], t.data = [];
                            var n = e.querySelectorAll("colgroup > col");
                            if (n.length) for(var r = 0; r < n.length; r++){
                                if (!(o = n[r].style.width)) var o = n[r].getAttribute("width");
                                o && (t.columns[r] || (t.columns[r] = {}), t.columns[r].width = o);
                            }
                            var s = function(e) {
                                var n = e.getBoundingClientRect(), o = n.width > 50 ? n.width : 50;
                                t.columns[r] || (t.columns[r] = {}), e.getAttribute("data-celltype") ? t.columns[r].type = e.getAttribute("data-celltype") : t.columns[r].type = "text", t.columns[r].width = o + "px", t.columns[r].title = e.innerHTML, t.columns[r].align = e.style.textAlign || "center", (n = e.getAttribute("name")) && (t.columns[r].name = n), (n = e.getAttribute("id")) && (t.columns[r].id = n), (n = e.getAttribute("data-mask")) && (t.columns[r].mask = n);
                            }, l = [], a = e.querySelectorAll(":scope > thead > tr");
                            if (a.length) {
                                for(var u = 0; u < a.length - 1; u++){
                                    var c = [];
                                    for(r = 0; r < a[u].children.length; r++){
                                        var f = {
                                            title: a[u].children[r].textContent,
                                            colspan: a[u].children[r].getAttribute("colspan") || 1
                                        };
                                        c.push(f);
                                    }
                                    l.push(c);
                                }
                                for(a = a[a.length - 1].children, r = 0; r < a.length; r++)s(a[r]);
                            }
                            var d = 0, p = {}, h = {}, g = {}, m = {}, v = e.querySelectorAll(":scope > tr, :scope > tbody > tr");
                            for(u = 0; u < v.length; u++)if (t.data[d] = [], 1 != t.parseTableFirstRowAsHeader || a.length || 0 != u) {
                                for(r = 0; r < v[u].children.length; r++){
                                    if (y = v[u].children[r].getAttribute("data-formula")) "=" != y.substr(0, 1) && (y = "=" + y);
                                    else var y = v[u].children[r].innerHTML;
                                    t.data[d].push(y);
                                    var C = i.getColumnNameFromId([
                                        r,
                                        u
                                    ]), w = v[u].children[r].getAttribute("class");
                                    w && (m[C] = w);
                                    var b = parseInt(v[u].children[r].getAttribute("colspan")) || 0, A = parseInt(v[u].children[r].getAttribute("rowspan")) || 0;
                                    (b || A) && (p[C] = [
                                        b || 1,
                                        A || 1
                                    ]), v[u].children[r].style && "none" == v[u].children[r].style.display && (v[u].children[r].style.display = "");
                                    var E = v[u].children[r].getAttribute("style");
                                    E && (g[C] = E), v[u].children[r].classList.contains("styleBold") && (g[C] ? g[C] += "; font-weight:bold;" : g[C] = "font-weight:bold;");
                                }
                                v[u].style && v[u].style.height && (h[u] = {
                                    height: v[u].style.height
                                }), d++;
                            } else for(r = 0; r < v[u].children.length; r++)s(v[u].children[r]);
                            if (Object.keys(l).length > 0 && (t.nestedHeaders = l), Object.keys(g).length > 0 && (t.style = g), Object.keys(p).length > 0 && (t.mergeCells = p), Object.keys(h).length > 0 && (t.rows = h), Object.keys(m).length > 0 && (t.classes = m), (v = e.querySelectorAll("tfoot tr")).length) {
                                var M = [];
                                for(u = 0; u < v.length; u++){
                                    var I = [];
                                    for(r = 0; r < v[u].children.length; r++)I.push(v[u].children[r].textContent);
                                    M.push(I);
                                }
                                Object.keys(M).length > 0 && (t.footers = M);
                            }
                            if (1 == t.parseTableAutoCellType) {
                                var N = [];
                                for(r = 0; r < t.columns.length; r++){
                                    var x = !0, S = !0;
                                    for(N[r] = [], u = 0; u < t.data.length; u++)y = t.data[u][r], N[r][y] || (N[r][y] = 0), N[r][y]++, y.length > 25 && (x = !1), 10 == y.length && "-" == y.substr(4, 1) && "-" == y.substr(7, 1) || (S = !1);
                                    var D = Object.keys(N[r]).length;
                                    S ? t.columns[r].type = "calendar" : 1 == x && D > 1 && D <= parseInt(.1 * t.data.length) && (t.columns[r].type = "dropdown", t.columns[r].source = Object.keys(N[r]));
                                }
                            }
                            return t;
                        }
                        console.log("Element is not a table");
                    }, i.helpers = l = {
                        getCaretIndex: function(e) {
                            if (this.config.root) var t = this.config.root;
                            else t = window;
                            var n = 0, r = t.getSelection();
                            if (r && 0 !== r.rangeCount) {
                                var o = r.getRangeAt(0), i = o.cloneRange();
                                i.selectNodeContents(e), i.setEnd(o.endContainer, o.endOffset), n = i.toString().length;
                            }
                            return n;
                        },
                        invert: function(e) {
                            for(var t = [], n = Object.keys(e), r = 0; r < n.length; r++)t[e[n[r]]] = n[r];
                            return t;
                        },
                        getColumnName: function(e) {
                            let t, n = e + 1, r = "";
                            for(; n > 0;)t = (n - 1) % 26, r = String.fromCharCode(65 + t).toString() + r, n = parseInt((n - t) / 26);
                            return r;
                        },
                        getColumnNameFromCoords: function(e, t) {
                            return l.getColumnName(parseInt(e)) + (parseInt(t) + 1);
                        },
                        getCoordsFromColumnName: function(e) {
                            var t = /^[a-zA-Z]+/.exec(e);
                            if (t) {
                                for(var n = 0, r = 0; r < t[0].length; r++)n += parseInt(t[0].charCodeAt(r) - 64) * Math.pow(26, t[0].length - 1 - r);
                                --n < 0 && (n = 0);
                                var o = parseInt(/[0-9]+$/.exec(e)) || null;
                                return o > 0 && o--, [
                                    n,
                                    o
                                ];
                            }
                        },
                        createFromTable: function() {},
                        injectArray: function(e, t, n) {
                            return e.slice(0, t).concat(n).concat(e.slice(t));
                        },
                        parseCSV: function(e, t) {
                            t = t || ",";
                            for(var n = 0, r = 0, o = [
                                []
                            ], i = 0, s = null, l = !1, a = !1, u = 0; u < e.length; u++)if (o[r] || (o[r] = []), o[r][n] || (o[r][n] = ""), "\r" != e[u]) {
                                if ("\n" != e[u] && e[u] != t || 0 != l && 1 != a && s) {
                                    if ('"' == e[u] && (l = !l), null === s) {
                                        if (1 == (s = l)) continue;
                                    } else if (!0 === s && !a && '"' == e[u]) {
                                        '"' == e[u + 1] ? (l = !0, o[r][n] += e[u], u++) : a = !0;
                                        continue;
                                    }
                                    o[r][n] += e[u];
                                } else {
                                    if (s = null, l = !1, a = !1, '"' == o[r][n][0]) {
                                        var c = o[r][n].trim();
                                        '"' == c[c.length - 1] && (o[r][n] = c.substr(1, c.length - 2));
                                    }
                                    "\n" == e[u] ? (n = 0, r++) : ++n > i && (i = n);
                                }
                            }
                            for(var f = 0; f < o.length; f++)for(u = 0; u <= i; u++)void 0 === o[f][u] && (o[f][u] = "");
                            return o;
                        }
                    }, "undefined" != typeof jQuery && function(e) {
                        e.fn.jspreadsheet = e.fn.jexcel = function(t) {
                            var n = e(this).get(0);
                            return n.jexcel ? Array.isArray(n.jexcel) ? n.jexcel[t][arguments[1]].apply(this, Array.prototype.slice.call(arguments, 2)) : n.jexcel[t].apply(this, Array.prototype.slice.call(arguments, 1)) : i(e(this).get(0), arguments[0]);
                        };
                    }(jQuery), i;
                }();
            }
        }, t = {}, n = function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.exports;
        }(44);
        jspreadsheet = n;
    }();
    return jspreadsheet;
});




function $16a142e8b73d05d4$export$69aeb3260f4121e0(val, decimalChar = ",") {
    if (!val) return val;
    const theOtherChar = decimalChar === "," ? "." : ",";
    if (typeof val === "string") // remove the other character if it exists, then replace decimalChar with '.'
    return Number(val.replace(/[^\d,.+-]/g, "") // only leave digits, periods and commas
    .replace(theOtherChar, "").replace(decimalChar, "."));
    return Number(val);
}
function $16a142e8b73d05d4$export$2e2bcd8739ae039(data, filterState, parsingMasks = {}, headersInRow = 0) {
    return data.map((row, rowIndex)=>[
            ...row,
            rowIndex
        ]) // add rowIndex as last column (it cannot be the first column, because it messes up the column order for further code)
    .filter((row, rowIndex)=>{
        if (rowIndex < headersInRow) return false;
        if (rowIndex === headersInRow) return true; // First row after headers, always include
        return filterState.every((filters, index)=>{
            if (!filters || filters.length === 0) return true; // No filters for this column, accept all rows
            return filters.every((filter)=>{
                const { verb: verb, arg: arg, val: val } = filter;
                const cellValueRaw = row[index];
                // console.log('DEBUG filter', verb, arg, 'val', val, 'cellValueRaw', cellValueRaw);
                if (verb === "is" || verb === "isNot") {
                    // Replace decimal character if specified, then parse as Number
                    const decimalChar = (parsingMasks === null || parsingMasks === void 0 ? void 0 : parsingMasks.decimalChar) || ",";
                    const cellValue = $16a142e8b73d05d4$export$69aeb3260f4121e0(cellValueRaw, decimalChar);
                    const numericValue = Number(val);
                    // console.log('DEBUG filter parsing', val, '->', numericValue, 'cellValue', cellValue);
                    // If either cellValue or value is not a valid number, remove from filter
                    if (Number.isNaN(cellValue) || Number.isNaN(numericValue)) return false; // Skip this row for the current filter
                    let conditionMet = false;
                    switch(arg){
                        case "greaterThan":
                            conditionMet = cellValue > numericValue;
                            break;
                        case "greaterThanOrEqual":
                            conditionMet = cellValue >= numericValue;
                            break;
                        case "lessThan":
                            conditionMet = cellValue < numericValue;
                            break;
                        case "lessThanOrEqual":
                            conditionMet = cellValue <= numericValue;
                            break;
                        case "equalTo":
                            conditionMet = cellValue === numericValue;
                            break;
                        case "blank":
                            conditionMet = cellValue === null || cellValue === undefined || cellValue === "";
                            break;
                        default:
                            return true;
                    }
                    return verb === "is" ? conditionMet : !conditionMet;
                }
                // For other verbs, ignore `arg` and apply directly
                // Parse cellValue and value as String
                const cellValueString = String(cellValueRaw);
                const stringValue = String(val);
                switch(verb){
                    case "contains":
                        return cellValueString.includes(stringValue);
                    case "doesNotContain":
                        return !cellValueString.includes(stringValue);
                    case "startsWith":
                        return cellValueString.startsWith(stringValue);
                    case "doesNotStartWith":
                        return !cellValueString.startsWith(stringValue);
                    case "endsWith":
                        return cellValueString.endsWith(stringValue);
                    case "doesNotEndWith":
                        return !cellValueString.endsWith(stringValue);
                    default:
                        return true;
                }
            });
        });
    }).map((row)=>row[row.length - 1]); // only return rowIndex added before the filter
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");
const $ddc3e461ba9aa601$export$38d4c0c2b432c6e6 = {
    dataModelFieldName: "date",
    type: "calendar",
    width: 100,
    align: "left",
    options: {
        format: "dd.mm.yyyy",
        placeholder: "dd.mm.yyyy",
        readonly: false,
        today: false,
        startingDay: 1,
        textDone: "OK",
        validRange: [
            "1500-01-01",
            "9999-12-31"
        ]
    }
};
const $ddc3e461ba9aa601$var$dottedDateRegex = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
const $ddc3e461ba9aa601$var$isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?(?:Z)?$/;
function $ddc3e461ba9aa601$var$isValidDateParts(year, month, day) {
    const parsedDate = new Date(Date.UTC(year, month - 1, day));
    return parsedDate.getUTCFullYear() === year && parsedDate.getUTCMonth() === month - 1 && parsedDate.getUTCDate() === day;
}
function $ddc3e461ba9aa601$export$dd663cd24858fc26(value, format = "dd.mm.yyyy") {
    if (typeof value !== "string") return value;
    const trimmedValue = value.trim();
    if (!trimmedValue) return value;
    const isoMatch = trimmedValue.match($ddc3e461ba9aa601$var$isoDateRegex);
    if (isoMatch) {
        const [, year, month, day, hour = "00", minute = "00", second = "00"] = isoMatch;
        if ($ddc3e461ba9aa601$var$isValidDateParts(Number(year), Number(month), Number(day))) return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        return value;
    }
    if ((format === null || format === void 0 ? void 0 : format.toLowerCase()) !== "dd.mm.yyyy") return value;
    const dottedDateMatch = trimmedValue.match($ddc3e461ba9aa601$var$dottedDateRegex);
    if (!dottedDateMatch) return value;
    const [, day, month, year] = dottedDateMatch;
    if (!$ddc3e461ba9aa601$var$isValidDateParts(Number(year), Number(month), Number(day))) return value;
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")} 00:00:00`;
}
function $ddc3e461ba9aa601$export$43f55aa75a69732e(today = new Date()) {
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day} 00:00:00`;
}
function $ddc3e461ba9aa601$export$51eb53eb187db579(value, format = "dd.mm.yyyy") {
    if (typeof value !== "string") return false;
    const trimmedValue = value.trim();
    if (!trimmedValue) return false;
    const normalizedValue = $ddc3e461ba9aa601$export$dd663cd24858fc26(trimmedValue, format);
    const isoMatch = normalizedValue.match($ddc3e461ba9aa601$var$isoDateRegex);
    if (!isoMatch) return false;
    const [, year, month, day] = isoMatch;
    return $ddc3e461ba9aa601$var$isValidDateParts(Number(year), Number(month), Number(day));
}
function $ddc3e461ba9aa601$export$b6b8aaf0d87aee08(value, format = "dd.mm.yyyy", fallbackDate = new Date()) {
    if ($ddc3e461ba9aa601$export$51eb53eb187db579(value, format)) return $ddc3e461ba9aa601$export$dd663cd24858fc26(value, format);
    return $ddc3e461ba9aa601$export$43f55aa75a69732e(fallbackDate);
}
function $ddc3e461ba9aa601$export$e59e0d0b478485d3(value, format = "dd.mm.yyyy") {
    const normalizedValue = $ddc3e461ba9aa601$export$dd663cd24858fc26(value, format);
    const isoMatch = typeof normalizedValue === "string" ? normalizedValue.match($ddc3e461ba9aa601$var$isoDateRegex) : null;
    if (!isoMatch) return value;
    const [, year, month, day] = isoMatch;
    if ((format === null || format === void 0 ? void 0 : format.toLowerCase()) === "dd.mm.yyyy") return `${day}.${month}.${year}`;
    return `${year}-${month}-${day}`;
}
function $ddc3e461ba9aa601$export$c69e18e4beece94f(date) {
    if (!date) return date;
    // if date contains space, assume this is the following string '2015-04-01 00:00:00'
    const localDate = date.indexOf(" ") > -1 ? `${date.replace(" ", "T")}Z` : date;
    // if date was picked from the calendar widget, it will be in the ISO8601 format
    if (localDate.includes("Z")) return new Date(`${date.split("Z")[0]}Z`).setUTCHours(0, 0, 0, 0);
    // if user pasted the date, we assume it is in the same format as displayed in the table (DD.MM.YYYY)
    // user-pased date is interpreted as a CET date (midnight), so when we convert it to UTC, it will be the previous day 10 or 11 pm
    let pastedDate = new Date(date.split(".")[2], Number(date.split(".")[1]) - 1, date.split(".")[0]);
    pastedDate = pastedDate.setTime(pastedDate.getTime() - pastedDate.getTimezoneOffset() * 60000);
    return pastedDate;
}
const $ddc3e461ba9aa601$var$convertableTypes = [
    "currency",
    "currency0Decimals",
    "currency2Decimals",
    "currency4Decimals",
    "secondaryCurrency0Decimals",
    "secondaryCurrency2Decimals",
    "secondaryCurrency",
    "number",
    "number0Decimals",
    "number2Decimals",
    "number4Decimals"
];
function $ddc3e461ba9aa601$export$3962e06959b24991(transactionArray, gridLayout) {
    // this regex removes all non-numerical characters from a string
    const amountRegex = /[^0-9.}-]+/g;
    return transactionArray.map((transaction)=>{
        const newTransaction = (0, $9tqwB._)({}, transaction);
        Object.keys(newTransaction).forEach((key, index)=>{
            var _gridLayout_index, _gridLayout_index1;
            // replace '' with nulls
            if (String(newTransaction[key]).length === 0) newTransaction[key] = null; // numbers don't have .length, so String()
            // convert ISO dates to epoch
            if (((_gridLayout_index = gridLayout[index]) === null || _gridLayout_index === void 0 ? void 0 : _gridLayout_index.type) === "date") newTransaction[key] = $ddc3e461ba9aa601$export$c69e18e4beece94f(newTransaction[key]);
            // convert amounts to numbers (for predetermined column types)
            // console.log('DEBUG removeGridFormatting', key, gridLayout[index]);
            if ($ddc3e461ba9aa601$var$convertableTypes.includes((_gridLayout_index1 = gridLayout[index]) === null || _gridLayout_index1 === void 0 ? void 0 : _gridLayout_index1.type)) // console.log('DEBUG removeGridFormatting', key, newTransaction[key]);
            newTransaction[key] = Number(String(newTransaction[key]).replace(amountRegex, ""));
        });
        return newTransaction;
    });
}
function $ddc3e461ba9aa601$export$398604a469f7de9a(a, b, propertyName, asc = true) {
    // console.log('DEBUG compare', a, b, propertyName, asc);
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}


/* eslint-disable no-underscore-dangle */ /* eslint-disable no-param-reassign */ /* eslint-disable react/jsx-filename-extension */ 
parcelRequire("7fPBF");

/* eslint-disable no-shadow */ /* eslint-disable react/jsx-no-bind */ 

var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");


function $d69cee845c1d8523$export$2e2bcd8739ae039({ initialValue: initialValue, onSave: onSave, source: source }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const initialId = (0, $7fPBF.useMemo)(()=>typeof initialValue === "string" ? initialValue : (initialValue === null || initialValue === void 0 ? void 0 : initialValue.id) || "", [
        initialValue
    ]);
    const [selectedId, setSelectedId] = (0, $7fPBF.useState)(initialId);
    const [query, setQuery] = (0, $7fPBF.useState)("");
    (0, $7fPBF.useEffect)(()=>{
        setSelectedId(initialId);
    }, [
        initialId
    ]);
    const options = source;
    const optionLabelMap = (0, $7fPBF.useMemo)(()=>options.reduce((acc, option)=>{
            acc[option.id] = option.name || option.id;
            return acc;
        }, {}), [
        options
    ]);
    const filteredOptions = (0, $7fPBF.useMemo)(()=>{
        if (!query) return options;
        const lowered = query.toLowerCase();
        return options.filter((option)=>{
            const label = option.name || option.id;
            return label.toLowerCase().includes(lowered) || option.id.toLowerCase().includes(lowered);
        });
    }, [
        options,
        query
    ]);
    function handleInput(e) {
        setQuery(e.target.value);
    }
    // after initialisation immediately set focus to the input component to emulate the behaviour of the jspreadsheet
    const myIdRef = (0, $7fPBF.useRef)((0, $8136d14ed46fb244$export$62e99e5c9f473d7f)("qwertzuioplkjhgfdsayxcvbnmQWERTZUIOPLKJHGFDSAYXCVBNM", 3)());
    (0, $7fPBF.useEffect)(()=>{
        document.querySelector(`#${myIdRef.current}`).focus();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e), {
            value: selectedId,
            onChange: (value)=>{
                if (value == null) return;
                const nextValue = typeof value === "string" ? value : value.id;
                setSelectedId(nextValue);
                onSave(nextValue);
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Input, {
                    id: myIdRef.current,
                    displayValue: (value)=>optionLabelMap[value] || value || "",
                    className: "w-full p-0 text-sm text-gray-700 bg-white border-0 appearance-none focus:outline-none focus:shadow-outline",
                    onChange: handleInput
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Options, {
                    static: true,
                    className: "absolute z-[999] mt-2 overflow-auto text-xs bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                    children: [
                        query !== "" && !source.map((item)=>item.id).includes(query) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                            value: query,
                            children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: `cursor-default select-none relative py-1 px-2 ${active ? "text-white bg-blue-600" : "text-gray-900"}`,
                                    children: `${t("create")} ${query}`
                                }, "custom")
                        }),
                        filteredOptions.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                                value: option.id,
                                className: ({ active: active })=>`cursor-default select-none relative py-1 px-2 ${active ? "text-white bg-blue-600" : "text-gray-900"}`,
                                children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: `block truncate ${selected ? "font-medium" : "font-normal"}`,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: option.name || option.id || option
                                        })
                                    })
                            }, option.id))
                    ]
                })
            ]
        })
    });
}
$d69cee845c1d8523$export$2e2bcd8739ae039.propTypes = {
    initialValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
            name: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
        })
    ]),
    onSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    })).isRequired
};
$d69cee845c1d8523$export$2e2bcd8739ae039.defaultProps = {
    initialValue: ""
};


// Helper to read the column definition for the current cell and return its source list
const $e50554c54ed873de$var$getSourceForCell = (cell)=>{
    var _cell_dataset, _jspInstance_options_columns, _jspInstance_options;
    if (!cell) return [];
    const table = cell.closest(".jexcel");
    const jspInstance = table && table.jspreadsheet;
    if (!jspInstance) return [];
    const columnIndex = Number((_cell_dataset = cell.dataset) === null || _cell_dataset === void 0 ? void 0 : _cell_dataset.x);
    const columnDefinition = ((_jspInstance_options = jspInstance.options) === null || _jspInstance_options === void 0 ? void 0 : (_jspInstance_options_columns = _jspInstance_options.columns) === null || _jspInstance_options_columns === void 0 ? void 0 : _jspInstance_options_columns[columnIndex]) || {};
    return columnDefinition.source || [];
};
const $e50554c54ed873de$var$customColumn = {
    openEditor (cell, instance) {
        var _instance_jspreadsheet_options_data_rowIndex, _instance_jspreadsheet_options_data, _instance_jspreadsheet_options, _instance_jspreadsheet;
        // Cleanup previous contents including React components
        while(cell.firstChild)cell.removeChild(cell.firstChild);
        // get source for this column from options.customDropdownSources by checking column name first and referencing it there
        // get column id from options.columns
        const { columns: columns } = instance.jspreadsheet.options;
        const thisColumn = columns[cell.dataset.x];
        // get source values for this column from column definition
        const source = thisColumn.source || []; // expects [{ id, name }, ...]
        const rowIndex = Number(cell.dataset.y);
        const columnIndex = Number(cell.dataset.x);
        var _cell_dataset_value;
        // Prefer the staged dataset value, fallback to the persisted spreadsheet value
        const currentValue = (_cell_dataset_value = cell.dataset.value) !== null && _cell_dataset_value !== void 0 ? _cell_dataset_value : (instance === null || instance === void 0 ? void 0 : (_instance_jspreadsheet = instance.jspreadsheet) === null || _instance_jspreadsheet === void 0 ? void 0 : (_instance_jspreadsheet_options = _instance_jspreadsheet.options) === null || _instance_jspreadsheet_options === void 0 ? void 0 : (_instance_jspreadsheet_options_data = _instance_jspreadsheet_options.data) === null || _instance_jspreadsheet_options_data === void 0 ? void 0 : (_instance_jspreadsheet_options_data_rowIndex = _instance_jspreadsheet_options_data[rowIndex]) === null || _instance_jspreadsheet_options_data_rowIndex === void 0 ? void 0 : _instance_jspreadsheet_options_data_rowIndex[columnIndex]) != null ? String(instance.jspreadsheet.options.data[rowIndex][columnIndex]) : "";
        // Create a container for the React component
        const container = document.createElement("div");
        cell.appendChild(container);
        // Create a root container if it doesn't already exist
        const root = (0, $f11ec298ebcca059$export$882461b6382ed46c)(container); // createRoot instead of render
        cell._rootContainer = root; // Store the root on the cell for later unmounting
        // Render the React component
        root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d69cee845c1d8523$export$2e2bcd8739ae039), {
            initialValue: currentValue,
            source: source,
            onSave: (newValue)=>{
                const nextValue = newValue != null ? String(newValue) : "";
                instance.jspreadsheet.setValue(cell, nextValue, true); // Persist the selected id immediately
                instance.jspreadsheet.closeEditor(cell, true);
            }
        }));
    },
    closeEditor (cell, save) {
        var _source_find;
        if (cell.firstChild) cell.firstChild.onblur = null;
        if (cell._rootContainer) try {
            cell._rootContainer.unmount(); // Unmount using the root
            cell.removeChild(cell.firstChild); // Cleanup the React container
        } catch (err) {
            console.log("Error unmounting React component:", err);
        }
        // Replace the cell contents with the matching display label after React unmounts
        const source = $e50554c54ed873de$var$getSourceForCell(cell);
        const displayValue = ((_source_find = source.find((option)=>option.id === cell.dataset.value)) === null || _source_find === void 0 ? void 0 : _source_find.name) || cell.dataset.value || "";
        console.log("DEBUG", displayValue, source, cell.dataset.value);
        cell.innerHTML = displayValue; // Display friendly label
        if (save && cell.dataset.value) return cell.dataset.value; // save id in jspreadsheet state
        return null;
    },
    getValue (cell) {
        return cell.dataset.value || ""; // Retrieve the value from data attribute
    },
    // this sets the visible value
    setValue (cell, value) {
        var _source_find;
        const source = $e50554c54ed873de$var$getSourceForCell(cell);
        const stringValue = value != null ? String(value) : "";
        cell.dataset.value = stringValue; // Store the new value in a data attribute
        cell.innerHTML = ((_source_find = source.find((option)=>option.id === stringValue)) === null || _source_find === void 0 ? void 0 : _source_find.name) || stringValue; // Display friendly label
    }
};
var $e50554c54ed873de$export$2e2bcd8739ae039 = $e50554c54ed873de$var$customColumn;


// this function attempts to automatically create spreadsheet (formatting) masks based on
// the output of toLocaleString for a given locale / currency parameter
// this may not work for exotic formats, has been confirmed to work with EN and DE only
// locale should match the country, not the language
function $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(locale = "de", currency = "EUR", returnMode = "currency") {
    // other returnModes: 'decimalPoint' || 'number2Decimals' || 'number0Decimals' || 'number4Decimals'
    const testValue = 1234.567;
    const testString = testValue.toLocaleString(locale, {
        style: "currency",
        currency: currency
    });
    // if there is anything before first number, this is the currency
    // just put all that on the begining of the mask
    // include the space -- examples: kr 1 234,57 €1,234.57
    const firstInt = testString.search(/\d/);
    let maskPrefix = "";
    let maskSuffix = "";
    // if the first sign is a number, just get all the non-numbers from the end
    // of the string and assume this is the currency code
    // include the space
    if (firstInt !== 0) maskPrefix = testString.substring(0, firstInt);
    else maskSuffix = testString.substring(testString.search(/(\d)(?!.*\d)/) + 1);
    // if there is a space or character between 1 and 2, this is the thousands separator
    // can be a space
    const thousandSeparator = testString.substring(testString.indexOf("1") + 1, testString.indexOf("1") + 2);
    // there can only be a comma or a point between 4 and 5
    const decimalSeparator = testString.substring(testString.indexOf("4") + 1, testString.indexOf("4") + 2);
    // let's put it all together
    const mask = `${maskPrefix}#${thousandSeparator}##0${decimalSeparator}00${maskSuffix}`;
    const maskNumber = `#${thousandSeparator}##0${decimalSeparator}`;
    if (returnMode === "decimalPoint") return decimalSeparator;
    if (returnMode === "number0Decimals") return maskNumber.slice(0, -1);
    if (returnMode === "number2Decimals") return `${maskNumber}00`;
    if (returnMode === "number4Decimals") return `${maskNumber}0000`;
    if (returnMode === "currency0Decimals") return `${maskPrefix}#${thousandSeparator}##0${maskSuffix}`;
    return mask;
}
function $71a316c7cafc3797$export$2e2bcd8739ae039(gridLayout, customDropdownSources, tableState, baseCurrency, i18n, t, secondaryCurrency = null) {
    if (!gridLayout) return null; // for import > Previewer (user sees input file), we don't have any columns data
    return gridLayout.map((col)=>{
        var _tableState_colWidths;
        var _col_usesHeader;
        // if usesHeader is defined, use it, otherwise use the default column id
        const colLabel = (_col_usesHeader = col.usesHeader) !== null && _col_usesHeader !== void 0 ? _col_usesHeader : col.id;
        var _ref;
        // add standard properties to each column
        const standardProperties = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({
            title: `${t([
                `columns.${colLabel}.label`,
                `columns.${colLabel}`
            ])}${col.readOnly ? `\n${t("columns.readOnly")}` : ""}`,
            name: col.id
        }, i18n.exists(`accountDetails:columns.${colLabel}.tooltip`) && {
            tooltip: t(`columns.${colLabel}.tooltip`)
        }), {
            width: (_ref = col.width || ((_tableState_colWidths = tableState.colWidths) === null || _tableState_colWidths === void 0 ? void 0 : _tableState_colWidths[col.id])) !== null && _ref !== void 0 ? _ref : 100
        }), col.readOnly && {
            readOnly: true
        });
        // add specific properties to each column by its .type
        // CAUTION: there is a list of types in common.js for which the save process will try to remove formatting and convert them to a number
        switch(col.type){
            case "date":
                return (0, $9tqwB._)({}, standardProperties, $ddc3e461ba9aa601$export$38d4c0c2b432c6e6);
            case "string":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "text",
                    wordWrap: true,
                    wrap: true,
                    align: "left"
                });
            case "currency0Decimals":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "currency0Decimals"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "decimalPoint")
                });
            case "currency":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "currency"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "decimalPoint")
                });
            case "secondaryCurrency0Decimals":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, secondaryCurrency, "currency0Decimals"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, secondaryCurrency, "decimalPoint")
                });
            case "secondaryCurrency":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, secondaryCurrency, "currency"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, secondaryCurrency, "decimalPoint")
                });
            case "dropdown":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "dropdown",
                    align: "center",
                    source: col.source,
                    autocomplete: true
                });
            // same as 'dropdowm', but we add source when we render Grid and not when we start the app
            case "dropdownDynamic":
                {
                    const source = customDropdownSources[col.id];
                    if (!source || source.length === 0) console.warn("Grid > addFormattingToColumns: no source found for dynamic dropdown column", col.id, "in customDropdownSources", customDropdownSources);
                    return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                        type: "dropdown",
                        align: "center",
                        source: source,
                        autocomplete: true
                    });
                }
            case "customDropdown":
                {
                    // get the right source list from customDropdownSources
                    const source = customDropdownSources[col.id];
                    if (!source || source.length === 0) console.warn("Grid > addFormattingToColumns: no source found for custom dropdown column", col.id, "in customDropdownSources", customDropdownSources);
                    return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                        type: "text",
                        align: "left",
                        editor: (0, $e50554c54ed873de$export$2e2bcd8739ae039),
                        source: source
                    });
                }
            case "number0Decimals":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "number0Decimals"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "decimalPoint")
                });
            case "number":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "number2Decimals"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "decimalPoint")
                });
            case "number4Decimals":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "numeric",
                    align: "right",
                    mask: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "number4Decimals"),
                    decimal: $71a316c7cafc3797$var$generateSpreadsheetMaskFromLocale(i18n.language, baseCurrency, "decimalPoint")
                });
            case "checkbox":
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "checkbox",
                    align: "center"
                });
            case "hidden":
            default:
                if (col.type !== "hidden") console.warn("Grid > addFormattingToColumns: unknown column type", col.type);
                return (0, $2qxEV._)((0, $9tqwB._)({}, standardProperties), {
                    type: "hidden"
                });
        }
    });
}





var $7fPBF = parcelRequire("7fPBF");


// Copyright (c) 2012 The Chromium Authors, Vladimirs. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
/**
 * focus-outline-manager
 *
 * Watch users keyboard input and manage the focus outline visibility
 */ /**
 * The class name to set on the document element.
 * @const
 */ var $99d836a5fdb7c64f$var$CLASS_NAME = "focus-outline-hidden";
/**
 * This class sets a CSS class name on the HTML element when a user presses the
 * tab key. It removes the class name when the user clicks anywhere.
 *
 * This allows you to write CSS like this:
 *
 * html.focus-outline-hidden *:focus {
 *     outline: none;
 * }
 *
 * And the outline will only be shown if the user uses the keyboard to get to it.
 *
 * @constructor
 */ function $99d836a5fdb7c64f$var$FocusOutlineManager() {
    var that = this;
    document.addEventListener("keydown", function(e) {
        that.focusByKeyboard = true;
    }, true);
    document.addEventListener("mousedown", function(e) {
        that.focusByKeyboard = false;
    }, true);
    document.addEventListener("focus", function(event) {
        // Update visibility only when focus is actually changed.
        that.updateVisibility();
    }, true);
    document.addEventListener("focusout", function(event) {
        window.setTimeout(function() {
            if (!document.hasFocus()) {
                that.focusByKeyboard = true;
                that.updateVisibility();
            }
        }, 0);
    });
    this.updateVisibility();
}
$99d836a5fdb7c64f$var$FocusOutlineManager.prototype = {
    /**
     * Whether focus change is triggered by TAB key.
     * @type {boolean}
     * @private
     */ focusByKeyboard: true,
    updateVisibility: function() {
        this.hidden = !this.focusByKeyboard;
    },
    /**
     * Whether the focus outline should be hidden.
     * @type {boolean}
     */ set hidden (hidden){
        document.documentElement.classList.toggle($99d836a5fdb7c64f$var$CLASS_NAME, hidden);
    },
    get hidden () {
        return document.documentElement.classList.contains($99d836a5fdb7c64f$var$CLASS_NAME);
    }
};
new $99d836a5fdb7c64f$var$FocusOutlineManager();



var $7fPBF = parcelRequire("7fPBF");
var $039fe4ac9c9107fb$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $039fe4ac9c9107fb$exports) {
        classNames.default = classNames;
        $039fe4ac9c9107fb$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $11f191705a16f43e$exports = {};
"use strict";
Object.defineProperty($11f191705a16f43e$exports, "__esModule", {
    value: true
});
var $7df5496a2c0fec8f$exports = {};
"use strict";
Object.defineProperty($7df5496a2c0fec8f$exports, "__esModule", {
    value: true
});
var $7df5496a2c0fec8f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $7963874f7252f9b7$exports = {};
"use strict";
Object.defineProperty($7963874f7252f9b7$exports, "__esModule", {
    value: true
});
var $7963874f7252f9b7$var$easeFunctions = $7963874f7252f9b7$exports.easeFunctions = {
    linear: function linear(t) {
        return t;
    },
    easeInQuad: function easeInQuad(t) {
        return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
        return t * (2 - t);
    },
    easeInOutQuad: function easeInOutQuad(t) {
        return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function easeInCubic(t) {
        return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
        return --t * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
        return 1 - --t * t * t * t;
    },
    easeInOutQuart: function easeInOutQuart(t) {
        return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
        return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function easeInOutQuint(t) {
        return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
};
var $7963874f7252f9b7$var$isNumeric = $7963874f7252f9b7$exports.isNumeric = function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};
var $7963874f7252f9b7$var$setPosition = $7963874f7252f9b7$exports.setPosition = function setPosition(begin, end, elapsed, duration) {
    var ease = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "easeInOutCubic";
    return elapsed > duration ? end : begin + (end - begin) * $7963874f7252f9b7$var$easeFunctions[ease](elapsed / duration);
};
var $7963874f7252f9b7$var$calcEndPoint = $7963874f7252f9b7$exports.calcEndPoint = function calcEndPoint(target) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if ($7963874f7252f9b7$var$isNumeric(target)) return parseInt(target) + offset;
    var y = context === window || context === document.documentElement ? window.pageYOffset : context.scrollTop - context.getBoundingClientRect().top;
    var distance = target.nodeName.toLowerCase() === "html" ? -y : target.getBoundingClientRect().top + y;
    return distance + offset;
};


$7df5496a2c0fec8f$exports.default = function(target) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$duration = _ref.duration, duration = _ref$duration === undefined ? 500 : _ref$duration, _ref$context = _ref.context, context = _ref$context === undefined ? window : _ref$context, _ref$offset = _ref.offset, offset = _ref$offset === undefined ? 0 : _ref$offset, _ref$ease = _ref.ease, ease = _ref$ease === undefined ? "easeInOutCubic" : _ref$ease, callback = _ref.callback;
    if ((typeof window === "undefined" ? "undefined" : $7df5496a2c0fec8f$var$_typeof(window)) !== "object") return;
    var start = context.scrollTop !== null && context.scrollTop !== undefined ? context.scrollTop : window.pageYOffset;
    var end = (0, $7963874f7252f9b7$exports.calcEndPoint)(target, context, offset);
    var clock = performance.now();
    var rAF = window.requestAnimationFrame;
    var tick = function tick() {
        var elapsed = performance.now() - clock;
        var pos = (0, $7963874f7252f9b7$exports.setPosition)(start, end, elapsed, duration, ease);
        if (context !== window) context.scrollTop = pos;
        else window.scroll(0, pos);
        if (elapsed > duration) typeof callback === "function" && callback(target);
        else rAF(tick);
    };
    tick();
};
$7df5496a2c0fec8f$exports = $7df5496a2c0fec8f$exports["default"];


var $11f191705a16f43e$var$_scrollSmooth2 = $11f191705a16f43e$var$_interopRequireDefault($7df5496a2c0fec8f$exports);

var $f7bd4f1ec833c575$exports = {};
"use strict";
Object.defineProperty($f7bd4f1ec833c575$exports, "__esModule", {
    value: true
});
var $f7bd4f1ec833c575$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $f7bd4f1ec833c575$var$_scrollSmooth2 = $f7bd4f1ec833c575$var$_interopRequireDefault($7df5496a2c0fec8f$exports);
function $f7bd4f1ec833c575$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$f7bd4f1ec833c575$exports.default = function() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$query = _ref.query, query = _ref$query === undefined ? '[href^="#"]:not([href="#"]' : _ref$query, _ref$match = _ref.match, match = _ref$match === undefined ? function(target) {
        return document.getElementById(target.hash.substring(1));
    } : _ref$match, _ref$hashChange = _ref.hashChange, hashChange = _ref$hashChange === undefined ? true : _ref$hashChange, scrollSmoothConfig = _ref.scrollSmoothConfig;
    var links = document.querySelectorAll(query);
    var handler = function handler(e) {
        e.preventDefault();
        var dest = match(e.target);
        if (!dest) return;
        if (hashChange) history.replaceState(null, null, "#" + dest.id);
        (0, $f7bd4f1ec833c575$var$_scrollSmooth2.default)(dest, $f7bd4f1ec833c575$var$_extends({}, scrollSmoothConfig));
    };
    Array.from(links).map(function(link) {
        link.addEventListener("click", handler, false);
    });
};
$f7bd4f1ec833c575$exports = $f7bd4f1ec833c575$exports["default"];


var $11f191705a16f43e$var$_anchorScroll2 = $11f191705a16f43e$var$_interopRequireDefault($f7bd4f1ec833c575$exports);
var $2448ca0a5eb935af$exports = {};
"use strict";
Object.defineProperty($2448ca0a5eb935af$exports, "__esModule", {
    value: true
});
function $2448ca0a5eb935af$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
$2448ca0a5eb935af$exports.default = function() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$activeClass = _ref.activeClass, activeClass = _ref$activeClass === undefined ? "active" : _ref$activeClass, _ref$query = _ref.query, query = _ref$query === undefined ? '[href^="#"]:not([href="#"]):not([href="#0"])' : _ref$query, _ref$threshold = _ref.threshold, threshold = _ref$threshold === undefined ? [
        0.25,
        0.5,
        0.75
    ] : _ref$threshold, _ref$detectType = _ref.detectType, detectType = _ref$detectType === undefined ? "max" : _ref$detectType;
    var options = {
        threshold: threshold
    };
    var removeClass = function removeClass(node) {
        return node.classList.remove(activeClass);
    };
    var addClass = function addClass(node) {
        return node.classList.add(activeClass);
    };
    var unsetAllActives = function unsetAllActives() {
        document.querySelectorAll("." + activeClass).forEach(removeClass);
    };
    var setActive = function setActive(activeNode) {
        unsetAllActives();
        addClass(document.querySelector('a[href="#' + activeNode.id + '"]'));
    };
    var callback = function callback(entries) {
        entries.forEach(function(entry) {
            if (entry.intersectionRatio >= Math[detectType].apply(Math, $2448ca0a5eb935af$var$_toConsumableArray(threshold))) setActive(entry.target);
        });
    };
    var links = document.querySelectorAll(query);
    var observer = new IntersectionObserver(callback, options);
    var observeTarget = function observeTarget(link) {
        var target = document.querySelector("#" + link.hash.slice(1));
        observer.observe(target);
    };
    links.forEach(observeTarget);
};
$2448ca0a5eb935af$exports = $2448ca0a5eb935af$exports["default"];


var $11f191705a16f43e$var$_observe2 = $11f191705a16f43e$var$_interopRequireDefault($2448ca0a5eb935af$exports);
function $11f191705a16f43e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$11f191705a16f43e$exports.default = {
    to: $11f191705a16f43e$var$_scrollSmooth2.default,
    calcEndPoint: $7963874f7252f9b7$exports.calcEndPoint,
    anchorScroll: $11f191705a16f43e$var$_anchorScroll2.default,
    observe: $11f191705a16f43e$var$_observe2.default
};
$11f191705a16f43e$exports = $11f191705a16f43e$exports["default"];


var $ea859a61a0a4fe3d$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, $ea859a61a0a4fe3d$exports) $ea859a61a0a4fe3d$exports = factory();
    else root.Scrollparent = factory();
})($ea859a61a0a4fe3d$exports, function() {
    var regex = /(auto|scroll)/;
    var parents = function(node, ps) {
        if (node.parentNode === null) return ps;
        return parents(node.parentNode, ps.concat([
            node
        ]));
    };
    var style = function(node, prop) {
        return getComputedStyle(node, null).getPropertyValue(prop);
    };
    var overflow = function(node) {
        return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
    };
    var scroll = function(node) {
        return regex.test(overflow(node));
    };
    var scrollParent = function(node) {
        if (!(node instanceof HTMLElement || node instanceof SVGElement)) return;
        var ps = parents(node.parentNode, []);
        for(var i = 0; i < ps.length; i += 1){
            if (scroll(ps[i])) return ps[i];
        }
        return document.scrollingElement || document.documentElement;
    };
    return scrollParent;
});


var $82551d4318ed8ff3$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $82551d4318ed8ff3$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $82551d4318ed8ff3$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $82551d4318ed8ff3$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $82551d4318ed8ff3$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $82551d4318ed8ff3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $82551d4318ed8ff3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $82551d4318ed8ff3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $82551d4318ed8ff3$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $82551d4318ed8ff3$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $82551d4318ed8ff3$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $82551d4318ed8ff3$var$root = $82551d4318ed8ff3$var$freeGlobal || $82551d4318ed8ff3$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $82551d4318ed8ff3$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $82551d4318ed8ff3$var$objectToString = $82551d4318ed8ff3$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $82551d4318ed8ff3$var$nativeMax = Math.max, $82551d4318ed8ff3$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $82551d4318ed8ff3$var$now = function() {
    return $82551d4318ed8ff3$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $82551d4318ed8ff3$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($82551d4318ed8ff3$var$FUNC_ERROR_TEXT);
    wait = $82551d4318ed8ff3$var$toNumber(wait) || 0;
    if ($82551d4318ed8ff3$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $82551d4318ed8ff3$var$nativeMax($82551d4318ed8ff3$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $82551d4318ed8ff3$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $82551d4318ed8ff3$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($82551d4318ed8ff3$var$now());
    }
    function debounced() {
        var time = $82551d4318ed8ff3$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $82551d4318ed8ff3$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $82551d4318ed8ff3$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $82551d4318ed8ff3$var$isSymbol(value) {
    return typeof value == "symbol" || $82551d4318ed8ff3$var$isObjectLike(value) && $82551d4318ed8ff3$var$objectToString.call(value) == $82551d4318ed8ff3$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $82551d4318ed8ff3$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($82551d4318ed8ff3$var$isSymbol(value)) return $82551d4318ed8ff3$var$NAN;
    if ($82551d4318ed8ff3$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $82551d4318ed8ff3$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($82551d4318ed8ff3$var$reTrim, "");
    var isBinary = $82551d4318ed8ff3$var$reIsBinary.test(value);
    return isBinary || $82551d4318ed8ff3$var$reIsOctal.test(value) ? $82551d4318ed8ff3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $82551d4318ed8ff3$var$reIsBadHex.test(value) ? $82551d4318ed8ff3$var$NAN : +value;
}
$82551d4318ed8ff3$exports = $82551d4318ed8ff3$var$debounce;





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $fa189bd1dd0951d2$export$4f9a06cb7441a087 = "data-focus-lock";
var $fa189bd1dd0951d2$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $fa189bd1dd0951d2$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $fa189bd1dd0951d2$export$70e9b4a1820af101 = "data-autofocus-inside";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b92e63d00f44a32a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
function $9852bc1860f56139$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $7fPBF.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $3aa02bc85fadbfb9$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $9852bc1860f56139$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $f38eebd6dad36293$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $f38eebd6dad36293$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f38eebd6dad36293$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $7fPBF.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $f38eebd6dad36293$export$b8c7b07253306600
    }));
};
$f38eebd6dad36293$var$InFocusGuard.propTypes = {};
$f38eebd6dad36293$var$InFocusGuard.defaultProps = {
    children: null
};
var $f38eebd6dad36293$export$2e2bcd8739ae039 = $f38eebd6dad36293$var$InFocusGuard;



function $efceb32ecd78f18d$var$ItoI(a) {
    return a;
}
function $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $efceb32ecd78f18d$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    return $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware);
}
function $efceb32ecd78f18d$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $efceb32ecd78f18d$var$innerCreateMedium(null);
    medium.options = (0, $1e2082910c54650f$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4b5bcfe03091b424$export$5733e022b1d538cb = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $4b5bcfe03091b424$export$b3e9a9312f73723c = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)();
var $4b5bcfe03091b424$export$3a1d52767cbc07b8 = (0, $efceb32ecd78f18d$export$9ffbfcaf067b02c6)();
var $4b5bcfe03091b424$export$892cbf28e5518020 = (0, $efceb32ecd78f18d$export$e13ec7dd7a14088d)({
    async: true
});


var $e17e6ac998763caf$var$emptyArray = [];
var $e17e6ac998763caf$var$FocusLock = /*#__PURE__*/ $7fPBF.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $7fPBF.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $7fPBF.useRef();
    var isActive = $7fPBF.useRef(false);
    var originalFocusedElement = $7fPBF.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, _props$shards = props.shards, shards = _props$shards === void 0 ? $e17e6ac998763caf$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $7fPBF.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $7fPBF.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $7fPBF.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $7fPBF.useCallback(function(allowDefer) {
        var current = originalFocusedElement.current;
        if (Boolean(shouldReturnFocus) && current && current.focus) {
            var focusOptions = typeof shouldReturnFocus === "object" ? shouldReturnFocus : undefined;
            originalFocusedElement.current = null;
            if (allowDefer) // React might return focus after update
            // it's safer to defer the action
            Promise.resolve().then(function() {
                return current.focus(focusOptions);
            });
            else current.focus(focusOptions);
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $7fPBF.useCallback(function(event) {
        if (isActive.current) (0, $4b5bcfe03091b424$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $4b5bcfe03091b424$export$b3e9a9312f73723c).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $7fPBF.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$fa189bd1dd0951d2$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[$fa189bd1dd0951d2$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $3aa02bc85fadbfb9$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $7fPBF.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
        }),
        /*#__PURE__*/ // nearest focus guard
        $7fPBF.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
        }) // first tabbed element guard
    ], !disabled && /*#__PURE__*/ $7fPBF.createElement(SideCar, {
        id: id,
        sideCar: (0, $4b5bcfe03091b424$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus
    }), /*#__PURE__*/ $7fPBF.createElement(Container, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $7fPBF.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $f38eebd6dad36293$export$b8c7b07253306600)
    }));
});
$e17e6ac998763caf$var$FocusLock.propTypes = {};
$e17e6ac998763caf$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $e17e6ac998763caf$export$2e2bcd8739ae039 = $e17e6ac998763caf$var$FocusLock;



var $7fPBF = parcelRequire("7fPBF");

function $da27c96857818bcc$export$2e2bcd8739ae039(o, p) {
    $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da27c96857818bcc$export$2e2bcd8739ae039(o, p);
}


function $146ee816144a450d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}




var $7fPBF = parcelRequire("7fPBF");
function $a2ab6f3d408e39f4$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $146ee816144a450d$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $7fPBF.PureComponent));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $a2ab6f3d408e39f4$export$2e2bcd8739ae039 = $a2ab6f3d408e39f4$var$withSideEffect;




var $64c6313292c996c0$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $64c6313292c996c0$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};


var $a60e58db6a2c2b86$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
var $a60e58db6a2c2b86$var$getTopParent = function(node) {
    return node.parentNode ? $a60e58db6a2c2b86$var$getTopParent(node.parentNode) : node;
};
var $a60e58db6a2c2b86$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $64c6313292c996c0$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $fa189bd1dd0951d2$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $a60e58db6a2c2b86$var$filterNested((0, $64c6313292c996c0$export$45b10814cc054894)($a60e58db6a2c2b86$var$getTopParent(currentNode).querySelectorAll("[" + (0, $fa189bd1dd0951d2$export$4f9a06cb7441a087) + '="' + group + '"]:not([' + (0, $fa189bd1dd0951d2$export$aeda8252e54b50f7) + '="disabled"])'))) : [
            currentNode
        ]);
        return acc;
    }, []);
};



var $547637f472749193$var$isElementHidden = function(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $547637f472749193$var$isVisibleUncached = function(node, checkParent) {
    return !node || node === document || node && node.nodeType === Node.DOCUMENT_NODE || !$547637f472749193$var$isElementHidden(node) && checkParent(node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode);
};
var $547637f472749193$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $547637f472749193$var$isVisibleUncached(node, $547637f472749193$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $547637f472749193$export$8197b0ea56b3b055 = function(node) {
    return !((node.tagName === "INPUT" || node.tagName === "BUTTON") && (node.type === "hidden" || node.disabled));
};
var $547637f472749193$export$d94b8b58ec2f30eb = function(node) {
    return Boolean(node && node.dataset && node.dataset.focusGuard);
};
var $547637f472749193$export$602e5a0d338d7750 = function(node) {
    return !$547637f472749193$export$d94b8b58ec2f30eb(node);
};
var $547637f472749193$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $abeb253dfaf92653$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $abeb253dfaf92653$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($abeb253dfaf92653$export$350ee6c095d98996);
};




var $af200ddb1312cc2b$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $25f7971b265ebd60$var$queryTabbables = (0, $af200ddb1312cc2b$export$8555f4622e95784).join(",");
var $25f7971b265ebd60$var$queryGuardTabbables = $25f7971b265ebd60$var$queryTabbables + ", [data-focus-guard]";
var $25f7971b265ebd60$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        return acc.concat((0, $64c6313292c996c0$export$45b10814cc054894)(parent.querySelectorAll(withGuards ? $25f7971b265ebd60$var$queryGuardTabbables : $25f7971b265ebd60$var$queryTabbables)), parent.parentNode ? (0, $64c6313292c996c0$export$45b10814cc054894)(parent.parentNode.querySelectorAll($25f7971b265ebd60$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $25f7971b265ebd60$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[" + (0, $fa189bd1dd0951d2$export$70e9b4a1820af101) + "]");
    return (0, $64c6313292c996c0$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $25f7971b265ebd60$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $47993c2562b99895$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $64c6313292c996c0$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $547637f472749193$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $547637f472749193$export$8197b0ea56b3b055)(node);
    });
};
var $47993c2562b99895$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $abeb253dfaf92653$export$cb40ee071f0d5226)($47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $47993c2562b99895$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $abeb253dfaf92653$export$cb40ee071f0d5226)($47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $47993c2562b99895$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $47993c2562b99895$export$6266a5cd5915dc33((0, $25f7971b265ebd60$export$853fa94d922e78b9)(topNode), visibilityCache);
};





var $588912932a813bc4$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $588912932a813bc4$var$getParents(node.parentNode, parents);
    return parents;
};
var $588912932a813bc4$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $588912932a813bc4$var$getParents(nodeA);
    var parentsB = $588912932a813bc4$var$getParents(nodeB);
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $588912932a813bc4$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $64c6313292c996c0$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $64c6313292c996c0$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $588912932a813bc4$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $588912932a813bc4$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || common.contains(topCommon)) topCommon = common;
                else topCommon = $588912932a813bc4$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    return topCommon;
};
var $588912932a813bc4$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $47993c2562b99895$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};


var $253f6a637ee87d7a$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).filter((0, $547637f472749193$export$602e5a0d338d7750));
    var commonParent = (0, $588912932a813bc4$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $47993c2562b99895$export$3738e313571e2ad2)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $47993c2562b99895$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $547637f472749193$export$602e5a0d338d7750)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $547637f472749193$export$d94b8b58ec2f30eb)(node)
        };
    });
};




var $d07a703fa09abac5$var$focusInFrame = function(frame) {
    return frame === document.activeElement;
};
var $d07a703fa09abac5$var$focusInsideIframe = function(topNode) {
    return Boolean((0, $64c6313292c996c0$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $d07a703fa09abac5$var$focusInFrame(node);
    }));
};
var $d07a703fa09abac5$export$20115f8da7baa6fa = function(topNode) {
    var activeElement = document && document.activeElement;
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).reduce(function(result, node) {
        return result || node.contains(activeElement) || $d07a703fa09abac5$var$focusInsideIframe(node);
    }, false);
};




var $a97e568617aa70ca$export$be6b21806d3fd485 = function() {
    return document && (0, $64c6313292c996c0$export$45b10814cc054894)(document.querySelectorAll("[" + (0, $fa189bd1dd0951d2$export$54ecf528c58f9ef6) + "]")).some(function(node) {
        return node.contains(document.activeElement);
    });
};



var $bd831ddde50e963f$var$isRadio = function(node) {
    return node.tagName === "INPUT" && node.type === "radio";
};
var $bd831ddde50e963f$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter($bd831ddde50e963f$var$isRadio).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $bd831ddde50e963f$export$5261662167ad7ced = function(node, nodes) {
    if ($bd831ddde50e963f$var$isRadio(node) && node.name) return $bd831ddde50e963f$var$findSelectedRadio(node, nodes);
    return node;
};
var $bd831ddde50e963f$export$4a5a72a7124e45f9 = function(nodes) {
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($bd831ddde50e963f$export$5261662167ad7ced(node, nodes));
    });
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $8b19cf57210745e9$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $bd831ddde50e963f$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $8b19cf57210745e9$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $bd831ddde50e963f$export$5261662167ad7ced)(nodes[index], nodes));
    return index;
};



var $3ebc112684578f24$export$85710b12cf912438 = "NEW_FOCUS";
var $3ebc112684578f24$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $547637f472749193$export$d94b8b58ec2f30eb)(activeElement);
    if (innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = outerNodes.indexOf(activeElement);
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $bd831ddde50e963f$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndexDiff = correctedNodes.indexOf(activeElement) - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $8b19cf57210745e9$export$e06728ee87c96122)(innerNodes, 0);
    var returnLastNode = (0, $8b19cf57210745e9$export$e06728ee87c96122)(innerNodes, cnt - 1);
    if (activeIndex === -1 || lastNodeInside === -1) return $3ebc112684578f24$export$85710b12cf912438;
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    return undefined;
};







var $4c99e62f4dd36d6e$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        return node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
    };
};
var $4c99e62f4dd36d6e$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $547637f472749193$export$4e62c701997796c1));
};
var $4c99e62f4dd36d6e$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = document && document.activeElement;
    var entries = (0, $a60e58db6a2c2b86$export$7e87c4720b9b279b)(topNode).filter((0, $547637f472749193$export$602e5a0d338d7750));
    var commonParent = (0, $588912932a813bc4$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $47993c2562b99895$export$23c79be8286a3b0c)(entries, visibilityCache);
    var innerElements = (0, $47993c2562b99895$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $547637f472749193$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $47993c2562b99895$export$23c79be8286a3b0c)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $4c99e62f4dd36d6e$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $3ebc112684578f24$export$65842178e9bb4205)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $3ebc112684578f24$export$85710b12cf912438)) {
        var autoFocusable = anyFocusable.map(function(_a) {
            var node = _a.node;
            return node;
        }).filter($4c99e62f4dd36d6e$var$findAutoFocused((0, $588912932a813bc4$export$8f99714c70a37db1)(entries, visibilityCache)));
        return {
            node: autoFocusable && autoFocusable.length ? (0, $8b19cf57210745e9$export$f4e86cfa0679b9cc)(autoFocusable) : (0, $8b19cf57210745e9$export$f4e86cfa0679b9cc)(innerNodes)
        };
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $17cc3edfb7306c87$export$c12b3da842c43a8 = function(target) {
    target.focus();
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};
var $17cc3edfb7306c87$var$guardCount = 0;
var $17cc3edfb7306c87$var$lockDisabled = false;
var $17cc3edfb7306c87$export$f06c444b0336b5d5 = function(topNode, lastNode) {
    var focusable = (0, $4c99e62f4dd36d6e$export$82d3f62e3f171d1d)(topNode, lastNode);
    if ($17cc3edfb7306c87$var$lockDisabled) return;
    if (focusable) {
        if ($17cc3edfb7306c87$var$guardCount > 2) {
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $17cc3edfb7306c87$var$lockDisabled = true;
            setTimeout(function() {
                $17cc3edfb7306c87$var$lockDisabled = false;
            }, 1);
            return;
        }
        $17cc3edfb7306c87$var$guardCount++;
        $17cc3edfb7306c87$export$c12b3da842c43a8(focusable.node);
        $17cc3edfb7306c87$var$guardCount--;
    }
};





var $60b760cce460b4f8$export$2e2bcd8739ae039 = (0, $17cc3edfb7306c87$export$f06c444b0336b5d5);


function $2d6186134c60e3e5$export$6523025722806278(action) {
    // Hidding setImmediate from Webpack to avoid inserting polyfill
    var _window = window, setImmediate = _window.setImmediate;
    if (typeof setImmediate !== "undefined") setImmediate(action);
    else setTimeout(action, 1);
}
var $2d6186134c60e3e5$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};



var $aaf28cf1dce384e3$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $aaf28cf1dce384e3$var$isFreeFocus = function isFreeFocus() {
    return $aaf28cf1dce384e3$var$focusOnBody() || (0, $a97e568617aa70ca$export$be6b21806d3fd485)();
};
var $aaf28cf1dce384e3$var$lastActiveTrap = null;
var $aaf28cf1dce384e3$var$lastActiveFocus = null;
var $aaf28cf1dce384e3$var$lastPortaledElement = null;
var $aaf28cf1dce384e3$var$focusWasOutsideWindow = false;
var $aaf28cf1dce384e3$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $aaf28cf1dce384e3$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($aaf28cf1dce384e3$var$lastActiveTrap.whiteList || $aaf28cf1dce384e3$var$defaultWhitelist)(activeElement);
};
var $aaf28cf1dce384e3$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $aaf28cf1dce384e3$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $aaf28cf1dce384e3$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $aaf28cf1dce384e3$var$lastPortaledElement && $aaf28cf1dce384e3$var$lastPortaledElement.portaledElement === element;
};
function $aaf28cf1dce384e3$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $aaf28cf1dce384e3$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $aaf28cf1dce384e3$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($aaf28cf1dce384e3$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $aaf28cf1dce384e3$var$focusWasOutsideWindow === "meanwhile";
};
var $aaf28cf1dce384e3$var$activateTrap = function activateTrap() {
    var result = false;
    if ($aaf28cf1dce384e3$var$lastActiveTrap) {
        var _lastActiveTrap = $aaf28cf1dce384e3$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame;
        var workingNode = observed || $aaf28cf1dce384e3$var$lastPortaledElement && $aaf28cf1dce384e3$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($aaf28cf1dce384e3$var$extractRef).filter(Boolean));
            if (!activeElement || $aaf28cf1dce384e3$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $aaf28cf1dce384e3$var$focusWasOutside(crossFrame) || !$aaf28cf1dce384e3$var$isFreeFocus() || !$aaf28cf1dce384e3$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $d07a703fa09abac5$export$20115f8da7baa6fa)(workingArea) || $aaf28cf1dce384e3$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$aaf28cf1dce384e3$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $60b760cce460b4f8$export$2e2bcd8739ae039)(workingArea, $aaf28cf1dce384e3$var$lastActiveFocus);
                            $aaf28cf1dce384e3$var$lastPortaledElement = {};
                        }
                    }
                    $aaf28cf1dce384e3$var$focusWasOutsideWindow = false;
                    $aaf28cf1dce384e3$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $253f6a637ee87d7a$export$30d9c643899a8835)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $aaf28cf1dce384e3$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $aaf28cf1dce384e3$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $aaf28cf1dce384e3$var$onTrap = function onTrap(event) {
    if ($aaf28cf1dce384e3$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $aaf28cf1dce384e3$var$onBlur = function onBlur() {
    return (0, $2d6186134c60e3e5$export$6523025722806278)($aaf28cf1dce384e3$var$activateTrap);
};
var $aaf28cf1dce384e3$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $aaf28cf1dce384e3$var$recordPortal(currentNode, source);
};
var $aaf28cf1dce384e3$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $aaf28cf1dce384e3$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        onBlur: $aaf28cf1dce384e3$var$onBlur,
        onFocus: $aaf28cf1dce384e3$var$onFocus
    }, children);
};
$aaf28cf1dce384e3$var$FocusTrap.propTypes = {};
var $aaf28cf1dce384e3$var$onWindowBlur = function onWindowBlur() {
    $aaf28cf1dce384e3$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    setTimeout(function() {
        $aaf28cf1dce384e3$var$focusWasOutsideWindow = "meanwhile";
    }, 0);
};
var $aaf28cf1dce384e3$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $aaf28cf1dce384e3$var$onTrap, true);
    document.addEventListener("focusout", $aaf28cf1dce384e3$var$onBlur);
    window.addEventListener("blur", $aaf28cf1dce384e3$var$onWindowBlur);
};
var $aaf28cf1dce384e3$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $aaf28cf1dce384e3$var$onTrap, true);
    document.removeEventListener("focusout", $aaf28cf1dce384e3$var$onBlur);
    window.removeEventListener("blur", $aaf28cf1dce384e3$var$onWindowBlur);
};
function $aaf28cf1dce384e3$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $aaf28cf1dce384e3$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$aaf28cf1dce384e3$var$lastActiveTrap) $aaf28cf1dce384e3$var$attachHandler();
    var lastTrap = $aaf28cf1dce384e3$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $aaf28cf1dce384e3$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $aaf28cf1dce384e3$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $aaf28cf1dce384e3$var$activateTrap(true);
        (0, $2d6186134c60e3e5$export$6523025722806278)($aaf28cf1dce384e3$var$activateTrap);
    } else {
        $aaf28cf1dce384e3$var$detachHandler();
        $aaf28cf1dce384e3$var$lastActiveFocus = null;
    }
} // bind medium
(0, $4b5bcfe03091b424$export$5733e022b1d538cb).assignSyncMedium($aaf28cf1dce384e3$var$onFocus);
(0, $4b5bcfe03091b424$export$b3e9a9312f73723c).assignMedium($aaf28cf1dce384e3$var$onBlur);
(0, $4b5bcfe03091b424$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $60b760cce460b4f8$export$2e2bcd8739ae039),
        focusInside: (0, $d07a703fa09abac5$export$20115f8da7baa6fa)
    });
});
var $aaf28cf1dce384e3$export$2e2bcd8739ae039 = (0, $a2ab6f3d408e39f4$export$2e2bcd8739ae039)($aaf28cf1dce384e3$var$reducePropsToState, $aaf28cf1dce384e3$var$handleStateChangeOnClient)($aaf28cf1dce384e3$var$FocusWatcher);


/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $b301888438efb0fe$var$FocusLockCombination = /*#__PURE__*/ $7fPBF.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $7fPBF.createElement((0, $e17e6ac998763caf$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        sideCar: (0, $aaf28cf1dce384e3$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $b301888438efb0fe$var$_ref = (0, $e17e6ac998763caf$export$2e2bcd8739ae039).propTypes || {}, $b301888438efb0fe$var$sideCar = $b301888438efb0fe$var$_ref.sideCar, $b301888438efb0fe$var$propTypes = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)($b301888438efb0fe$var$_ref, [
    "sideCar"
]);
$b301888438efb0fe$var$FocusLockCombination.propTypes = {};
var $b301888438efb0fe$export$2e2bcd8739ae039 = $b301888438efb0fe$var$FocusLockCombination;



var $2cb7353992a884b7$export$2e2bcd8739ae039 = (0, $b301888438efb0fe$export$2e2bcd8739ae039);




var $7fPBF = parcelRequire("7fPBF");
var $4a0bf7bd570986e8$exports = {};
//
$4a0bf7bd570986e8$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $f7f5929647577760$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $f7f5929647577760$export$2e2bcd8739ae039 = $f7f5929647577760$var$stylis_min;


var $20406c49883954d0$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $20406c49883954d0$export$2e2bcd8739ae039 = $20406c49883954d0$var$unitlessKeys;


function $3587f7e2ed7416b3$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $3587f7e2ed7416b3$export$2e2bcd8739ae039 = $3587f7e2ed7416b3$var$memoize;


var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$var$isPropValid = /* #__PURE__ */ (0, $3587f7e2ed7416b3$export$2e2bcd8739ae039)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $742aea85e4e67b26$export$2e2bcd8739ae039 = $742aea85e4e67b26$var$isPropValid;




var $4ZL0H = parcelRequire("4ZL0H");
function $4920bb85ed07bfd6$var$v() {
    return ($4920bb85ed07bfd6$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $4920bb85ed07bfd6$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $4920bb85ed07bfd6$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $dddaf6f84c717660$exports.typeOf)(t);
}, $4920bb85ed07bfd6$var$w = Object.freeze([]), $4920bb85ed07bfd6$var$E = Object.freeze({});
function $4920bb85ed07bfd6$var$b(e) {
    return "function" == typeof e;
}
function $4920bb85ed07bfd6$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $4920bb85ed07bfd6$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $4920bb85ed07bfd6$var$A = ("undefined" != typeof $4ZL0H && undefined, "data-styled"), $4920bb85ed07bfd6$export$83d89fbfd8236492 = "5.3.6", $4920bb85ed07bfd6$var$I = "undefined" != typeof window && "HTMLElement" in window, $4920bb85ed07bfd6$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $4ZL0H, typeof $4ZL0H, false)), $4920bb85ed07bfd6$var$O = {}, $4920bb85ed07bfd6$var$R = {};
function $4920bb85ed07bfd6$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $4920bb85ed07bfd6$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $4920bb85ed07bfd6$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $4920bb85ed07bfd6$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $4920bb85ed07bfd6$var$x = new Map, $4920bb85ed07bfd6$var$k = new Map, $4920bb85ed07bfd6$var$V = 1, $4920bb85ed07bfd6$var$B = function(e) {
    if ($4920bb85ed07bfd6$var$x.has(e)) return $4920bb85ed07bfd6$var$x.get(e);
    for(; $4920bb85ed07bfd6$var$k.has($4920bb85ed07bfd6$var$V);)$4920bb85ed07bfd6$var$V++;
    var t = $4920bb85ed07bfd6$var$V++;
    return $4920bb85ed07bfd6$var$x.set(e, t), $4920bb85ed07bfd6$var$k.set(t, e), t;
}, $4920bb85ed07bfd6$var$z = function(e) {
    return $4920bb85ed07bfd6$var$k.get(e);
}, $4920bb85ed07bfd6$var$M = function(e, t) {
    t >= $4920bb85ed07bfd6$var$V && ($4920bb85ed07bfd6$var$V = t + 1), $4920bb85ed07bfd6$var$x.set(e, t), $4920bb85ed07bfd6$var$k.set(t, e);
}, $4920bb85ed07bfd6$var$G = "style[" + $4920bb85ed07bfd6$var$A + '][data-styled-version="5.3.6"]', $4920bb85ed07bfd6$var$L = new RegExp("^" + $4920bb85ed07bfd6$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $4920bb85ed07bfd6$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $4920bb85ed07bfd6$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($4920bb85ed07bfd6$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($4920bb85ed07bfd6$var$M(u, c), $4920bb85ed07bfd6$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $4920bb85ed07bfd6$var$q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $4920bb85ed07bfd6$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($4920bb85ed07bfd6$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($4920bb85ed07bfd6$var$A, "active"), r.setAttribute("data-styled-version", "5.3.6");
    var i = $4920bb85ed07bfd6$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $4920bb85ed07bfd6$var$$ = function() {
    function e(e) {
        var t = this.element = $4920bb85ed07bfd6$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $4920bb85ed07bfd6$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $4920bb85ed07bfd6$var$W = function() {
    function e(e) {
        var t = this.element = $4920bb85ed07bfd6$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $4920bb85ed07bfd6$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $4920bb85ed07bfd6$var$J = $4920bb85ed07bfd6$var$I, $4920bb85ed07bfd6$var$X = {
    isServer: !$4920bb85ed07bfd6$var$I,
    useCSSOMInjection: !$4920bb85ed07bfd6$var$P
}, $4920bb85ed07bfd6$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $4920bb85ed07bfd6$var$E), void 0 === t && (t = {}), this.options = $4920bb85ed07bfd6$var$v({}, $4920bb85ed07bfd6$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $4920bb85ed07bfd6$var$I && $4920bb85ed07bfd6$var$J && ($4920bb85ed07bfd6$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($4920bb85ed07bfd6$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($4920bb85ed07bfd6$var$A) && ($4920bb85ed07bfd6$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $4920bb85ed07bfd6$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($4920bb85ed07bfd6$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $4920bb85ed07bfd6$var$U(o) : r ? new $4920bb85ed07bfd6$var$$(o) : new $4920bb85ed07bfd6$var$W(o), new $4920bb85ed07bfd6$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($4920bb85ed07bfd6$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($4920bb85ed07bfd6$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($4920bb85ed07bfd6$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $4920bb85ed07bfd6$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $4920bb85ed07bfd6$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $4920bb85ed07bfd6$var$K = /(a)(d)/gi, $4920bb85ed07bfd6$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $4920bb85ed07bfd6$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $4920bb85ed07bfd6$var$Q(t % 52) + n;
    return ($4920bb85ed07bfd6$var$Q(t % 52) + n).replace($4920bb85ed07bfd6$var$K, "$1-$2");
}
var $4920bb85ed07bfd6$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $4920bb85ed07bfd6$var$ne = function(e) {
    return $4920bb85ed07bfd6$var$te(5381, e);
};
function $4920bb85ed07bfd6$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($4920bb85ed07bfd6$var$b(n) && !$4920bb85ed07bfd6$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $4920bb85ed07bfd6$var$oe = $4920bb85ed07bfd6$var$ne("5.3.6"), $4920bb85ed07bfd6$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $4920bb85ed07bfd6$var$re(e), this.componentId = t, this.baseHash = $4920bb85ed07bfd6$var$te($4920bb85ed07bfd6$var$oe, t), this.baseStyle = n, $4920bb85ed07bfd6$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $4920bb85ed07bfd6$var$Ne(this.rules, e, t, n).join(""), i = $4920bb85ed07bfd6$var$ee($4920bb85ed07bfd6$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $4920bb85ed07bfd6$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $4920bb85ed07bfd6$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $4920bb85ed07bfd6$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $4920bb85ed07bfd6$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $4920bb85ed07bfd6$var$ie = /^\s*\/\/.*$/gm, $4920bb85ed07bfd6$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $4920bb85ed07bfd6$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $4920bb85ed07bfd6$var$E : e, i = s.options, a = void 0 === i ? $4920bb85ed07bfd6$var$E : i, c = s.plugins, u = void 0 === c ? $4920bb85ed07bfd6$var$w : c, l = new (0, $f7f5929647577760$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $4920bb85ed07bfd6$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($4920bb85ed07bfd6$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $4920bb85ed07bfd6$var$j(15), $4920bb85ed07bfd6$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $4920bb85ed07bfd6$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(), $4920bb85ed07bfd6$export$91317688fc694efa = $4920bb85ed07bfd6$export$8c190ef828af4c86.Consumer, $4920bb85ed07bfd6$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(), $4920bb85ed07bfd6$var$he = ($4920bb85ed07bfd6$var$de.Consumer, new $4920bb85ed07bfd6$var$Z), $4920bb85ed07bfd6$var$pe = $4920bb85ed07bfd6$var$ce();
function $4920bb85ed07bfd6$var$fe() {
    return (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$8c190ef828af4c86) || $4920bb85ed07bfd6$var$he;
}
function $4920bb85ed07bfd6$var$me() {
    return (0, $7fPBF.useContext)($4920bb85ed07bfd6$var$de) || $4920bb85ed07bfd6$var$pe;
}
function $4920bb85ed07bfd6$export$a473771da2f0ff7c(e) {
    var t = (0, $7fPBF.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $4920bb85ed07bfd6$var$fe(), u = (0, $7fPBF.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $7fPBF.useMemo)(function() {
        return $4920bb85ed07bfd6$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $7fPBF.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4a0bf7bd570986e8$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $4920bb85ed07bfd6$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $4920bb85ed07bfd6$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $4920bb85ed07bfd6$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $4920bb85ed07bfd6$var$pe), this.name + e.hash;
    }, e;
}(), $4920bb85ed07bfd6$var$ge = /([A-Z])/, $4920bb85ed07bfd6$var$Se = /([A-Z])/g, $4920bb85ed07bfd6$var$we = /^ms-/, $4920bb85ed07bfd6$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $4920bb85ed07bfd6$var$be(e) {
    return $4920bb85ed07bfd6$var$ge.test(e) ? e.replace($4920bb85ed07bfd6$var$Se, $4920bb85ed07bfd6$var$Ee).replace($4920bb85ed07bfd6$var$we, "-ms-") : e;
}
var $4920bb85ed07bfd6$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $4920bb85ed07bfd6$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $4920bb85ed07bfd6$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($4920bb85ed07bfd6$var$_e(e)) return "";
    if ($4920bb85ed07bfd6$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($4920bb85ed07bfd6$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $4920bb85ed07bfd6$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $4920bb85ed07bfd6$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $4920bb85ed07bfd6$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$4920bb85ed07bfd6$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $4920bb85ed07bfd6$var$b(t[i]) ? s.push($4920bb85ed07bfd6$var$be(i) + ":", t[i], ";") : $4920bb85ed07bfd6$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($4920bb85ed07bfd6$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $20406c49883954d0$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $4920bb85ed07bfd6$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $4920bb85ed07bfd6$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $4920bb85ed07bfd6$var$b(e) || $4920bb85ed07bfd6$var$S(e) ? $4920bb85ed07bfd6$var$Ae($4920bb85ed07bfd6$var$Ne($4920bb85ed07bfd6$var$g($4920bb85ed07bfd6$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $4920bb85ed07bfd6$var$Ae($4920bb85ed07bfd6$var$Ne($4920bb85ed07bfd6$var$g(e, n)));
}
var $4920bb85ed07bfd6$var$Ie = /invalid hook call/i, $4920bb85ed07bfd6$var$Pe = new Set, $4920bb85ed07bfd6$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $4920bb85ed07bfd6$var$Re = function(e, t, n) {
    return void 0 === n && (n = $4920bb85ed07bfd6$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $4920bb85ed07bfd6$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $4920bb85ed07bfd6$var$je = /(^-|-$)/g;
function $4920bb85ed07bfd6$var$Te(e) {
    return e.replace($4920bb85ed07bfd6$var$De, "-").replace($4920bb85ed07bfd6$var$je, "");
}
var $4920bb85ed07bfd6$var$xe = function(e) {
    return $4920bb85ed07bfd6$var$ee($4920bb85ed07bfd6$var$ne(e) >>> 0);
};
function $4920bb85ed07bfd6$var$ke(e) {
    return "string" == typeof e && true;
}
var $4920bb85ed07bfd6$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $4920bb85ed07bfd6$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $4920bb85ed07bfd6$var$ze(e, t, n) {
    var r = e[n];
    $4920bb85ed07bfd6$var$Ve(t) && $4920bb85ed07bfd6$var$Ve(r) ? $4920bb85ed07bfd6$var$Me(r, t) : e[n] = t;
}
function $4920bb85ed07bfd6$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($4920bb85ed07bfd6$var$Ve(i)) for(var a in i)$4920bb85ed07bfd6$var$Be(a) && $4920bb85ed07bfd6$var$ze(e, i[a], a);
    }
    return e;
}
var $4920bb85ed07bfd6$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(), $4920bb85ed07bfd6$export$b631efc24e9d5e2f = $4920bb85ed07bfd6$export$2c657da244d00bd6.Consumer;
function $4920bb85ed07bfd6$export$d8964aec282183a3(e) {
    var t = (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6), n = (0, $7fPBF.useMemo)(function() {
        return function(e, t) {
            if (!e) return $4920bb85ed07bfd6$var$j(14);
            if ($4920bb85ed07bfd6$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $4920bb85ed07bfd6$var$j(8) : t ? $4920bb85ed07bfd6$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $4920bb85ed07bfd6$var$Ye = {};
function $4920bb85ed07bfd6$var$qe(e, t, n) {
    var o = $4920bb85ed07bfd6$export$7ba318d8d2f06c76(e), i = !$4920bb85ed07bfd6$var$ke(e), a = t.attrs, c = void 0 === a ? $4920bb85ed07bfd6$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $4920bb85ed07bfd6$var$Te(e);
        $4920bb85ed07bfd6$var$Ye[n] = ($4920bb85ed07bfd6$var$Ye[n] || 0) + 1;
        var r = n + "-" + $4920bb85ed07bfd6$var$xe("5.3.6" + n + $4920bb85ed07bfd6$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $4920bb85ed07bfd6$var$ke(e) ? "styled." + e : "Styled(" + $4920bb85ed07bfd6$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $4920bb85ed07bfd6$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $4920bb85ed07bfd6$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $4920bb85ed07bfd6$var$E);
                var r = $4920bb85ed07bfd6$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $4920bb85ed07bfd6$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($4920bb85ed07bfd6$var$Re(t, (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6), a) || $4920bb85ed07bfd6$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $4920bb85ed07bfd6$var$fe(), s = $4920bb85ed07bfd6$var$me(), i = t ? e.generateAndInjectStyles($4920bb85ed07bfd6$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $4920bb85ed07bfd6$var$ke(_), A = g !== t ? $4920bb85ed07bfd6$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $742aea85e4e67b26$export$2e2bcd8739ae039), _) : !N || (0, $742aea85e4e67b26$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $4920bb85ed07bfd6$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $7fPBF.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $4920bb85ed07bfd6$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($4920bb85ed07bfd6$var$ke(e) ? e : $4920bb85ed07bfd6$var$Te($4920bb85ed07bfd6$var$_(e)));
        return $4920bb85ed07bfd6$var$qe(e, $4920bb85ed07bfd6$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $4920bb85ed07bfd6$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $4920bb85ed07bfd6$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $4920bb85ed07bfd6$var$E), !(0, $dddaf6f84c717660$exports.isValidElementType)(r)) return $4920bb85ed07bfd6$var$j(1, String(r));
        var s = function() {
            return t(r, o, $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $4920bb85ed07bfd6$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $4920bb85ed07bfd6$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($4920bb85ed07bfd6$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $4920bb85ed07bfd6$var$He[e] = $4920bb85ed07bfd6$var$He(e);
});
var $4920bb85ed07bfd6$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $4920bb85ed07bfd6$var$re(e), $4920bb85ed07bfd6$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($4920bb85ed07bfd6$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $4920bb85ed07bfd6$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $4920bb85ed07bfd6$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $4920bb85ed07bfd6$var$xe(JSON.stringify(i)), u = new $4920bb85ed07bfd6$var$$e(i, a);
    function l(e) {
        var t = $4920bb85ed07bfd6$var$fe(), n = $4920bb85ed07bfd6$var$me(), o = (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6), l = (0, $7fPBF.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $7fPBF.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $4920bb85ed07bfd6$var$O, n, o);
        else {
            var s = $4920bb85ed07bfd6$var$v({}, t, {
                theme: $4920bb85ed07bfd6$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(l);
}
function $4920bb85ed07bfd6$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $4920bb85ed07bfd6$var$xe(o);
    return new $4920bb85ed07bfd6$var$ve(s, o);
}
var $4920bb85ed07bfd6$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $4920bb85ed07bfd6$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $4920bb85ed07bfd6$var$A + '="true"',
                'data-styled-version="5.3.6"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $4920bb85ed07bfd6$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $4920bb85ed07bfd6$var$j(2);
            var n = ((t = {})[$4920bb85ed07bfd6$var$A] = "", t["data-styled-version"] = "5.3.6", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $4920bb85ed07bfd6$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("style", $4920bb85ed07bfd6$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $4920bb85ed07bfd6$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $4920bb85ed07bfd6$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $4920bb85ed07bfd6$var$j(3);
    }, e;
}(), $4920bb85ed07bfd6$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(t, n) {
        var o = (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6), i = e.defaultProps, a = $4920bb85ed07bfd6$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(e, $4920bb85ed07bfd6$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($63fc9407ef8fcdfe$exports)))(t, e), t.displayName = "WithTheme(" + $4920bb85ed07bfd6$var$_(e) + ")", t;
}, $4920bb85ed07bfd6$export$93d4e7f90805808f = function() {
    return (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6);
}, $4920bb85ed07bfd6$export$5c87cfe6c475f500 = {
    StyleSheet: $4920bb85ed07bfd6$var$Z,
    masterSheet: $4920bb85ed07bfd6$var$he
};
var $4920bb85ed07bfd6$export$2e2bcd8739ae039 = $4920bb85ed07bfd6$var$He;


var $70daf9c9500718dd$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $70daf9c9500718dd$var$ReactIs, $70daf9c9500718dd$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$70daf9c9500718dd$exports = (parcelRequire("izvh2"))();



var $fw0lo = parcelRequire("fw0lo");
function $98b83f3f51b76254$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $98b83f3f51b76254$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $98b83f3f51b76254$var$ownKeys(Object(source), true).forEach(function(key) {
            $98b83f3f51b76254$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $98b83f3f51b76254$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $98b83f3f51b76254$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $98b83f3f51b76254$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $98b83f3f51b76254$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $98b83f3f51b76254$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $98b83f3f51b76254$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $98b83f3f51b76254$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $98b83f3f51b76254$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $98b83f3f51b76254$var$_setPrototypeOf(subClass, superClass);
}
function $98b83f3f51b76254$var$_getPrototypeOf(o) {
    $98b83f3f51b76254$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $98b83f3f51b76254$var$_getPrototypeOf(o);
}
function $98b83f3f51b76254$var$_setPrototypeOf(o, p) {
    $98b83f3f51b76254$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $98b83f3f51b76254$var$_setPrototypeOf(o, p);
}
function $98b83f3f51b76254$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $98b83f3f51b76254$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $98b83f3f51b76254$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $98b83f3f51b76254$var$_assertThisInitialized(self);
}
function $98b83f3f51b76254$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $98b83f3f51b76254$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $98b83f3f51b76254$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $98b83f3f51b76254$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $98b83f3f51b76254$var$_possibleConstructorReturn(this, result);
    };
}
function $98b83f3f51b76254$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function $98b83f3f51b76254$var$_slicedToArray(arr, i) {
    return $98b83f3f51b76254$var$_arrayWithHoles(arr) || $98b83f3f51b76254$var$_iterableToArrayLimit(arr, i) || $98b83f3f51b76254$var$_unsupportedIterableToArray(arr, i) || $98b83f3f51b76254$var$_nonIterableRest();
}
function $98b83f3f51b76254$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $98b83f3f51b76254$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $98b83f3f51b76254$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $98b83f3f51b76254$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $98b83f3f51b76254$var$_arrayLikeToArray(o, minLen);
}
function $98b83f3f51b76254$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $98b83f3f51b76254$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $98b83f3f51b76254$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $98b83f3f51b76254$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $98b83f3f51b76254$var$_templateObject$9;
var $98b83f3f51b76254$var$GlobalStyle = (0, $4920bb85ed07bfd6$export$f0f03736edb61697)($98b83f3f51b76254$var$_templateObject$9 || ($98b83f3f51b76254$var$_templateObject$9 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  .focus-outline-hidden :focus {\n      outline: none;\n  }\n"
])));
var $98b83f3f51b76254$var$_templateObject$8;
var $98b83f3f51b76254$var$SvgButton = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).button($98b83f3f51b76254$var$_templateObject$8 || ($98b83f3f51b76254$var$_templateObject$8 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  display: block;\n  padding: 0;\n  border: 0;\n  background: none;\n  font-size: 0;\n  cursor: ",
    ";\n"
])), function(props) {
    return props.disabled ? "not-allowed" : "pointer";
});
var $98b83f3f51b76254$var$_templateObject$7, $98b83f3f51b76254$var$_templateObject2;
var $98b83f3f51b76254$var$Label = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).span($98b83f3f51b76254$var$_templateObject$7 || ($98b83f3f51b76254$var$_templateObject$7 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  font-size: 12px;\n  line-height: 1;\n"
])));
function $98b83f3f51b76254$var$Arrow(_ref) {
    var className = _ref.className, onClick = _ref.onClick, inverted = _ref.inverted, label = _ref.label, disabled = _ref.disabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$SvgButton, {
        className: className,
        onClick: onClick,
        "data-tour-elem": "".concat(inverted ? "right" : "left", "-arrow"),
        disabled: disabled
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$Label, null, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 18.4 14.4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: inverted ? "M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" : "M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeMiterlimit: "10"
    })));
}
$98b83f3f51b76254$var$Arrow.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func.isRequired,
    inverted: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).node,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool
};
var $98b83f3f51b76254$export$21b07c8f274aebd5 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)($98b83f3f51b76254$var$Arrow)($98b83f3f51b76254$var$_templateObject2 || ($98b83f3f51b76254$var$_templateObject2 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  color: ",
    ";\n\n  ",
    ";\n  ",
    ";\n\n  &:hover {\n    color: ",
    ";\n  }\n"
])), function(props) {
    return props.disabled ? "#caccce" : "#646464";
}, function(props) {
    return props.inverted ? "margin-left: 24px;" : "margin-right: 24px;";
}, function(props) {
    return !props.label && "\n    width: 16px;\n    height: 12px;\n    flex: 0 0 16px;\n  ";
}, function(props) {
    return props.disabled ? "#caccce" : "#000";
});
var $98b83f3f51b76254$var$_templateObject$6;
function $98b83f3f51b76254$var$Close(_ref) {
    var className = _ref.className, onClick = _ref.onClick, ariaLabel = _ref.ariaLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$SvgButton, {
        className: className,
        onClick: onClick,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        viewBox: "0 0 9.1 9.1",
        "aria-hidden": true,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: "currentColor",
        d: "M5.9 4.5l2.8-2.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L4.5 3.1 1.7.3C1.3-.1.7-.1.3.3c-.4.4-.4 1 0 1.4l2.8 2.8L.3 7.4c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3L4.5 6l2.8 2.8c.3.2.5.3.8.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L5.9 4.5z"
    })));
}
$98b83f3f51b76254$var$Close.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func.isRequired,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string
};
var $98b83f3f51b76254$export$f39c2d165cd861fe = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039)($98b83f3f51b76254$var$Close)($98b83f3f51b76254$var$_templateObject$6 || ($98b83f3f51b76254$var$_templateObject$6 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  position: absolute;\n  top: 22px;\n  right: 22px;\n  width: 9px;\n  height: 9px;\n  color: #5e5e5e;\n  &:hover {\n    color: #000;\n  }\n"
])));
function $98b83f3f51b76254$var$getNodeRect(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), top = _node$getBoundingClie.top, right = _node$getBoundingClie.right, bottom = _node$getBoundingClie.bottom, left = _node$getBoundingClie.left, width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height
    };
}
function $98b83f3f51b76254$var$getHighlightedRect(node, step) {
    if (!step.highlightedSelectors) return $98b83f3f51b76254$var$getNodeRect(node);
    var attrs = $98b83f3f51b76254$var$getNodeRect(node);
    var _iterator = $98b83f3f51b76254$var$_createForOfIteratorHelper(step.highlightedSelectors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var selector = _step.value;
            var element = document.querySelector(selector);
            if (!element || element.style.display === "none" || element.style.visibility === "hidden") continue;
            var rect = $98b83f3f51b76254$var$getNodeRect(element);
            if (rect.top < attrs.top) attrs.top = rect.top;
            if (rect.right > attrs.right) attrs.right = rect.right;
            if (rect.bottom > attrs.bottom) attrs.bottom = rect.bottom;
            if (rect.left < attrs.left) attrs.left = rect.left;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    attrs.width = attrs.right - attrs.left;
    attrs.height = attrs.bottom - attrs.top;
    return attrs;
}
function $98b83f3f51b76254$var$inView(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left, w = _ref.w, h = _ref.h, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? 0 : _ref$threshold;
    return top >= 0 + threshold && left >= 0 + threshold && bottom <= h - threshold && right <= w - threshold;
}
function $98b83f3f51b76254$var$isBody(node) {
    return node === document.querySelector("body") || node === document.querySelector("html");
}
var $98b83f3f51b76254$var$isHoriz = function isHoriz(pos) {
    return /(left|right)/.test(pos);
};
var $98b83f3f51b76254$var$isOutsideX = function isOutsideX(val, windowWidth) {
    return val > windowWidth;
};
var $98b83f3f51b76254$var$isOutsideY = function isOutsideY(val, windowHeight) {
    return val > windowHeight;
};
var $98b83f3f51b76254$var$safe = function safe(sum) {
    return sum < 0 ? 0 : sum;
};
function $98b83f3f51b76254$var$bestPositionOf(positions) {
    return Object.keys(positions).map(function(p) {
        return {
            position: p,
            value: positions[p]
        };
    }).sort(function(a, b) {
        return b.value - a.value;
    }).map(function(p) {
        return p.position;
    });
}
var $98b83f3f51b76254$var$_templateObject$5;
var $98b83f3f51b76254$var$Guide = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($98b83f3f51b76254$var$_templateObject$5 || ($98b83f3f51b76254$var$_templateObject$5 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  --reactour-accent: ",
    ";\n  ",
    "\n  position: fixed;\n  transition: transform 0.3s;\n  top: 0;\n  left: 0;\n  z-index: 1000000;\n\n  transform: ",
    ";\n"
])), function(props) {
    return props.accentColor;
}, function(props) {
    return props.defaultStyles ? "\n  max-width: 331px;\n  min-width: 150px;\n  padding-right: 40px;\n  border-radius: ".concat(props.rounded, "px;\n  background-color: #fff;\n  padding: 24px 30px;\n  box-shadow: 0 0.5em 3em rgba(0, 0, 0, 0.3);\n  color: inherit;\n  ") : "";
}, function(props) {
    var targetTop = props.targetTop, targetRight = props.targetRight, targetBottom = props.targetBottom, targetLeft = props.targetLeft, windowWidth = props.windowWidth, windowHeight = props.windowHeight, helperWidth = props.helperWidth, helperHeight = props.helperHeight, helperPosition = props.helperPosition, padding = props.padding;
    var available = {
        left: targetLeft,
        right: windowWidth - targetRight,
        top: targetTop,
        bottom: windowHeight - targetBottom
    };
    var couldPositionAt = function couldPositionAt(position) {
        return available[position] > ($98b83f3f51b76254$var$isHoriz(position) ? helperWidth + padding * 2 : helperHeight + padding * 2);
    };
    var autoPosition = function autoPosition(coords) {
        var positionsOrder = $98b83f3f51b76254$var$bestPositionOf(available);
        for(var j = 0; j < positionsOrder.length; j++){
            if (couldPositionAt(positionsOrder[j])) return coords[positionsOrder[j]];
        }
        return coords.center;
    };
    var pos = function pos(helperPosition) {
        if (Array.isArray(helperPosition)) {
            var isOutX = $98b83f3f51b76254$var$isOutsideX(helperPosition[0], windowWidth);
            var isOutY = $98b83f3f51b76254$var$isOutsideY(helperPosition[1], windowHeight);
            var warn = function warn(axis, num) {
                console.warn("".concat(axis, ":").concat(num, " is outside window, falling back to center"));
            };
            if (isOutX) warn("x", helperPosition[0]);
            if (isOutY) warn("y", helperPosition[1]);
            return [
                isOutX ? windowWidth / 2 - helperWidth / 2 : helperPosition[0],
                isOutY ? windowHeight / 2 - helperHeight / 2 : helperPosition[1]
            ];
        }
        var hX = $98b83f3f51b76254$var$isOutsideX(targetLeft + helperWidth, windowWidth) ? $98b83f3f51b76254$var$isOutsideX(targetRight + padding, windowWidth) ? targetRight - helperWidth : targetRight - helperWidth + padding : targetLeft - padding;
        var x = hX > padding ? hX : padding;
        var hY = $98b83f3f51b76254$var$isOutsideY(targetTop + helperHeight, windowHeight) ? $98b83f3f51b76254$var$isOutsideY(targetBottom + padding, windowHeight) ? targetBottom - helperHeight : targetBottom - helperHeight + padding : targetTop - padding;
        var y = hY > padding ? hY : padding;
        var coords = {
            top: [
                x,
                targetTop - helperHeight - padding * 2
            ],
            right: [
                targetRight + padding * 2,
                y
            ],
            bottom: [
                x,
                targetBottom + padding * 2
            ],
            left: [
                targetLeft - helperWidth - padding * 2,
                y
            ],
            center: [
                windowWidth / 2 - helperWidth / 2,
                windowHeight / 2 - helperHeight / 2
            ]
        };
        if (helperPosition === "center" || couldPositionAt(helperPosition)) return coords[helperPosition];
        return autoPosition(coords);
    };
    var p = pos(helperPosition);
    return "translate(".concat(Math.round(p[0]), "px, ").concat(Math.round(p[1]), "px)");
});
var $98b83f3f51b76254$var$_templateObject$4;
var $98b83f3f51b76254$export$37acb3580601e69a = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).span($98b83f3f51b76254$var$_templateObject$4 || ($98b83f3f51b76254$var$_templateObject$4 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  position: absolute;\n  font-family: monospace;\n  background: var(--reactour-accent);\n  background: ",
    ";\n  height: 1.875em;\n  line-height: 2;\n  padding-left: 0.8125em;\n  padding-right: 0.8125em;\n  font-size: 1em;\n  border-radius: 1.625em;\n  color: white;\n  text-align: center;\n  box-shadow: 0 0.25em 0.5em rgba(0, 0, 0, 0.3);\n  top: -0.8125em;\n  left: -0.8125em;\n"
])), function(props) {
    return props.accentColor;
});
var $98b83f3f51b76254$var$_templateObject$3;
var $98b83f3f51b76254$export$c7c44baae9d9f25f = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($98b83f3f51b76254$var$_templateObject$3 || ($98b83f3f51b76254$var$_templateObject$3 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  margin-top: 24px;\n  align-items: center;\n  justify-content: center;\n"
])));
var $98b83f3f51b76254$var$_templateObject$2;
var $98b83f3f51b76254$export$b8a61e5c71402559 = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).nav($98b83f3f51b76254$var$_templateObject$2 || ($98b83f3f51b76254$var$_templateObject$2 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  counter-reset: dot;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n"
])));
var $98b83f3f51b76254$var$_templateObject$1;
var $98b83f3f51b76254$export$d046b3c4a416f60d = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).button($98b83f3f51b76254$var$_templateObject$1 || ($98b83f3f51b76254$var$_templateObject$1 = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  counter-increment: dot;\n  width: 8px;\n  height: 8px;\n  border: ",
    ";\n\n  border-radius: 100%;\n  padding: 0;\n  display: block;\n  margin: 4px;\n  transition: opacity 0.3s, transform 0.3s;\n  cursor: ",
    ";\n  transform: scale(",
    ");\n\n  color: ",
    ";\n  background: ",
    ";\n\n  color: ",
    ";\n  background: ",
    ";\n\n  &:before {\n    content: counter(dot);\n    position: absolute;\n    bottom: calc(100% + 0.25em);\n    left: 50%;\n    opacity: 0;\n    transform: translate(-50%, 1em);\n    transition: 0.3s;\n    display: ",
    ";\n  }\n\n  &:hover {\n    background-color: currentColor;\n\n    &:before {\n      opacity: 0.5;\n      transform: translate(-50%, -2px);\n    }\n  }\n"
])), function(props) {
    return props.current === props.index ? "0" : "1px solid #caccce";
}, function(props) {
    return props.disabled ? "not-allowed" : "pointer";
}, function(props) {
    return props.current === props.index ? 1.25 : 1;
}, function(props) {
    return props.current === props.index ? "var(--reactour-accent)" : "#caccce";
}, function(props) {
    return props.current === props.index ? "var(--reactour-accent)" : "none";
}, function(props) {
    return props.current === props.index ? props.accentColor : "#caccce";
}, function(props) {
    return props.current === props.index ? props.accentColor : "none";
}, function(props) {
    return props.showNumber ? "block" : "none";
});
var $98b83f3f51b76254$var$_templateObject;
var $98b83f3f51b76254$var$SvgMaskWrapper = (0, $4920bb85ed07bfd6$export$2e2bcd8739ae039).div($98b83f3f51b76254$var$_templateObject || ($98b83f3f51b76254$var$_templateObject = $98b83f3f51b76254$var$_taggedTemplateLiteral([
    "\n  opacity: ",
    ";\n  color: ",
    ";\n  width: 100%;\n  left: 0;\n  top: 0;\n  height: 100%;\n  position: fixed;\n  z-index: 99999;\n  pointer-events: none;\n"
])), function(props) {
    return !props.maskClassName && 0.7;
}, function(props) {
    return !props.maskClassName && "#000";
});
function $98b83f3f51b76254$var$SvgMask(_ref) {
    var windowWidth = _ref.windowWidth, windowHeight = _ref.windowHeight, targetWidth = _ref.targetWidth, targetHeight = _ref.targetHeight, targetTop = _ref.targetTop, targetLeft = _ref.targetLeft, padding = _ref.padding, rounded = _ref.rounded, roundedStep = _ref.roundedStep, disableInteraction = _ref.disableInteraction, disableInteractionClassName = _ref.disableInteractionClassName, className = _ref.className, onClick = _ref.onClick, highlightedBorder = _ref.highlightedBorder;
    var width = $98b83f3f51b76254$var$safe(targetWidth + padding * 2);
    var height = $98b83f3f51b76254$var$safe(targetHeight + padding * 2);
    var top = $98b83f3f51b76254$var$safe(targetTop - padding);
    var left = $98b83f3f51b76254$var$safe(targetLeft - padding);
    var roundedRadius = roundedStep ? Math.min(width / 2, height / 2) : rounded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$SvgMaskWrapper, {
        onClick: onClick,
        maskClassName: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: windowWidth,
        height: windowHeight,
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("mask", {
        id: "mask-main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: 0,
        y: 0,
        width: windowWidth,
        height: windowHeight,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height,
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: left - 1,
        y: top - 1,
        width: roundedRadius,
        height: roundedRadius,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: left + roundedRadius,
        cy: top + roundedRadius,
        r: roundedRadius,
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: left + width - roundedRadius + 1,
        y: top - 1,
        width: roundedRadius,
        height: roundedRadius,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: left + width - roundedRadius,
        cy: top + roundedRadius,
        r: roundedRadius,
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: left - 1,
        y: top + height - roundedRadius + 1,
        width: roundedRadius,
        height: roundedRadius,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: left + roundedRadius,
        cy: top + height - roundedRadius,
        r: roundedRadius,
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: left + width - roundedRadius + 1,
        y: top + height - roundedRadius + 1,
        width: roundedRadius,
        height: roundedRadius,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: left + width - roundedRadius,
        cy: top + height - roundedRadius,
        r: roundedRadius,
        fill: "black "
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("clipPath", {
        id: "clip-path"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: 0,
        y: 0,
        width: windowWidth,
        height: top
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: 0,
        y: top,
        width: left,
        height: height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: targetLeft + targetWidth + padding,
        y: top,
        width: $98b83f3f51b76254$var$safe(windowWidth - targetWidth - left),
        height: height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: 0,
        y: targetTop + targetHeight + padding,
        width: windowWidth,
        height: $98b83f3f51b76254$var$safe(windowHeight - targetHeight - top)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: 0,
        y: 0,
        width: windowWidth,
        height: windowHeight,
        fill: "currentColor",
        mask: "url(#mask-main)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: 0,
        y: 0,
        width: windowWidth,
        height: windowHeight,
        fill: "currentColor",
        clipPath: "url(#clip-path)",
        pointerEvents: "auto"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height,
        pointerEvents: "auto",
        fill: "transparent",
        display: disableInteraction ? "block" : "none",
        className: disableInteractionClassName
    }), highlightedBorder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: $98b83f3f51b76254$var$safe(left + highlightedBorder.width / 2.0),
        y: $98b83f3f51b76254$var$safe(top + highlightedBorder.width / 2.0),
        width: $98b83f3f51b76254$var$safe(width - highlightedBorder.width),
        height: $98b83f3f51b76254$var$safe(height - highlightedBorder.width),
        pointerEvents: "auto",
        fill: "none",
        strokeWidth: highlightedBorder.width,
        stroke: highlightedBorder.color,
        rx: roundedRadius - 2
    })));
}
$98b83f3f51b76254$var$SvgMask.propTypes = {
    windowWidth: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    windowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    targetWidth: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    targetHeight: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    targetTop: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    targetLeft: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    rounded: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired,
    roundedStep: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    disableInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool.isRequired,
    disableInteractionClassName: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string.isRequired,
    highlightedBorder: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).shape({
        color: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string.isRequired,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired
    })
};
var $98b83f3f51b76254$var$ReactourResizeObserver = function(_ref) {
    var step = _ref.step, refresh = _ref.refresh;
    var _useState = (0, $7fPBF.useState)(0), _useState2 = $98b83f3f51b76254$var$_slicedToArray(_useState, 2), mutationsCounter = _useState2[0], setMutationsCounter = _useState2[1]; // only use to notify main logic below
    // that a resizeObservable has been added to DOM (or removed from it)
    (0, $7fPBF.useEffect)(function() {
        if (!step.resizeObservables) return;
        var incrementMutationsCounterIfObservable = function incrementMutationsCounterIfObservable(nodes) {
            var _iterator = $98b83f3f51b76254$var$_createForOfIteratorHelper(nodes), _step;
            try {
                var _loop = function _loop() {
                    var node = _step.value;
                    if (!node.attributes) return "continue";
                    var found = step.resizeObservables.find(function(observable) {
                        return node.matches(observable) || node.querySelector(observable) != null;
                    });
                    if (found) setMutationsCounter(mutationsCounter + 1);
                };
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var _ret = _loop();
                    if (_ret === "continue") continue;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        };
        var mutationObserver = new MutationObserver(function(mutationsList) {
            var _iterator2 = $98b83f3f51b76254$var$_createForOfIteratorHelper(mutationsList), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var mutation = _step2.value;
                    if (0 !== mutation.addedNodes.length) incrementMutationsCounterIfObservable(mutation.addedNodes);
                    if (0 !== mutation.removedNodes.length) incrementMutationsCounterIfObservable(mutation.removedNodes);
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        var observable = document.documentElement || document.body;
        var config = {
            childList: true,
            subtree: true
        };
        mutationObserver.observe(observable, config);
        return function() {
            mutationObserver.disconnect();
        };
    }, [
        step,
        mutationsCounter
    ]); // the main logic is here
    (0, $7fPBF.useEffect)(function() {
        if (!step.resizeObservables) return;
        var resizeObserver = new ResizeObserver(function(entries) {
            refresh();
        });
        var _iterator3 = $98b83f3f51b76254$var$_createForOfIteratorHelper(step.resizeObservables), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var observable = _step3.value;
                var element = document.querySelector(observable);
                if (element) resizeObserver.observe(element);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        step,
        mutationsCounter
    ]);
    return null;
};
var $98b83f3f51b76254$var$ReactourMutationObserver = function(_ref) {
    var step = _ref.step, refresh = _ref.refresh;
    (0, $7fPBF.useEffect)(function() {
        if (!step.mutationObservables) return;
        var refreshHighlightedRegionIfObservable = function refreshHighlightedRegionIfObservable(nodes) {
            var _iterator = $98b83f3f51b76254$var$_createForOfIteratorHelper(nodes), _step;
            try {
                var _loop = function _loop() {
                    var node = _step.value;
                    if (!node.attributes) return "continue";
                    var found = step.mutationObservables.find(function(observable) {
                        return node.matches(observable) || node.querySelector(observable) != null;
                    });
                    if (found) refresh();
                };
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var _ret = _loop();
                    if (_ret === "continue") continue;
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        };
        var mutationObserver = new MutationObserver(function(mutationsList) {
            var _iterator2 = $98b83f3f51b76254$var$_createForOfIteratorHelper(mutationsList), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var mutation = _step2.value;
                    if (0 !== mutation.addedNodes.length) refreshHighlightedRegionIfObservable(mutation.addedNodes);
                    if (0 !== mutation.removedNodes.length) refreshHighlightedRegionIfObservable(mutation.removedNodes);
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        var observable = document.documentElement || document.body;
        var config = {
            childList: true,
            subtree: true
        };
        mutationObserver.observe(observable, config);
        return function() {
            mutationObserver.disconnect();
        };
    }, [
        step
    ]);
    return null;
};
function $98b83f3f51b76254$var$Portal(_ref) {
    var children = _ref.children;
    var ref = (0, $7fPBF.useRef)(null);
    if (ref.current === null) {
        ref.current = document.createElement("div");
        ref.current.setAttribute("id", "___reactour");
    }
    (0, $7fPBF.useEffect)(function() {
        document.body.appendChild(ref.current);
        return function() {
            document.body.removeChild(ref.current);
        };
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $fw0lo.createPortal)(children, ref.current);
}
var $98b83f3f51b76254$var$propTypes = {
    disableFocusLock: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    badgeContent: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    highlightedMaskClassName: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).element
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
    closeButtonAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
    closeWithMask: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    inViewThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool.isRequired,
    lastStepNextButton: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).node,
    maskClassName: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
    maskSpace: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).node,
    onAfterOpen: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    onBeforeClose: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    onRequestClose: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    prevButton: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).node,
    scrollDuration: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    scrollOffset: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    showButtons: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    showCloseButton: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    showNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    showNavigationNumber: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    showNumber: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    startAt: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    goToStep: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    getCurrentStep: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    nextStep: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    prevStep: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).shape({
        selector: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
        content: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).node,
            (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func
        ]).isRequired,
        position: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number),
            (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).oneOf([
                "top",
                "right",
                "bottom",
                "left",
                "center"
            ])
        ]),
        action: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).func,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).object,
        stepInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
        navDotAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
        roundedStep: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool
    })),
    update: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
    updateDelay: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    disableInteraction: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    disableDotsNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool,
    disableKeyboardNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).oneOf([
            "esc",
            "right",
            "left"
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).bool
    ]),
    rounded: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number,
    accentColor: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string,
    highlightedBorder: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).shape({
        color: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).string.isRequired,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($70daf9c9500718dd$exports))).number.isRequired
    })
};
var $98b83f3f51b76254$var$defaultProps = {
    disableFocusLock: false,
    showNavigation: true,
    showNavigationNumber: true,
    showButtons: true,
    showCloseButton: true,
    closeButtonAriaLabel: "Close",
    showNumber: true,
    scrollDuration: 1,
    maskSpace: 10,
    updateDelay: 1,
    disableInteraction: false,
    rounded: 0,
    accentColor: "#007aff",
    closeWithMask: true
};
var $98b83f3f51b76254$var$CN = {
    mask: {
        base: "reactour__mask",
        isOpen: "reactour__mask--is-open",
        disableInteraction: "reactour__mask--disable-interaction"
    },
    helper: {
        base: "reactour__helper",
        isOpen: "reactour__helper--is-open"
    },
    dot: {
        base: "reactour__dot",
        active: "reactour__dot--is-active"
    }
};
var $98b83f3f51b76254$var$Tour = /*#__PURE__*/ function(_Component) {
    $98b83f3f51b76254$var$_inherits(Tour, _Component);
    var _super = $98b83f3f51b76254$var$_createSuper(Tour);
    function Tour() {
        var _this;
        $98b83f3f51b76254$var$_classCallCheck(this, Tour);
        _this = _super.call(this);
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "unlockFocus", function(callback) {
            _this.setState({
                focusUnlocked: true
            }, callback());
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "showStep", function() {
            if (!_this.helper || !_this.helper.current) return;
            var steps = _this.props.steps;
            var _this$state = _this.state, current = _this$state.current, focusUnlocked = _this$state.focusUnlocked;
            if (focusUnlocked) _this.setState({
                focusUnlocked: false
            });
            var step = steps[current];
            var node = step.selector ? document.querySelector(step.selector) : null;
            var stepCallback = function stepCallback(o) {
                if (step.action && typeof step.action === "function") _this.unlockFocus(function() {
                    return step.action(o);
                });
            };
            if (step.observe) {
                var target = document.querySelector(step.observe);
                var config = {
                    attributes: true,
                    childList: true,
                    characterData: true
                };
                _this.setState(function(prevState) {
                    if (prevState.observer) setTimeout(function() {
                        prevState.observer.disconnect();
                    }, 0);
                    return {
                        observer: new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
                                    var cb = function cb() {
                                        return stepCallback(mutation.addedNodes[0]);
                                    };
                                    setTimeout(function() {
                                        return _this.calculateNode(mutation.addedNodes[0], step, cb);
                                    }, 100);
                                } else if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
                                    var _cb = function _cb() {
                                        return stepCallback(node);
                                    };
                                    _this.calculateNode(node, step, _cb);
                                }
                            });
                        })
                    };
                }, function() {
                    return _this.state.observer.observe(target, config);
                });
            } else if (_this.state.observer) {
                _this.state.observer.disconnect();
                _this.setState({
                    observer: null
                });
            }
            if (node) {
                var cb = function cb() {
                    return stepCallback(node);
                };
                _this.calculateNode(node, step, cb);
            } else {
                _this.setState($98b83f3f51b76254$var$setNodeState(null, step, _this.helper.current), stepCallback);
                step.selector && console.warn("Doesn't find a DOM node '".concat(step.selector, "'. Please check the 'steps' Tour prop Array at position ").concat(current, "."));
            }
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "calculateNode", function(node, step, cb) {
            var _this$props = _this.props, scrollDuration = _this$props.scrollDuration, inViewThreshold = _this$props.inViewThreshold, scrollOffset = _this$props.scrollOffset;
            var attrs = $98b83f3f51b76254$var$getHighlightedRect(node, step);
            var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            if (!$98b83f3f51b76254$var$inView($98b83f3f51b76254$var$_objectSpread2($98b83f3f51b76254$var$_objectSpread2({}, attrs), {}, {
                w: w,
                h: h,
                threshold: inViewThreshold
            }))) {
                var parentScroll = (0, (/*@__PURE__*/$parcel$interopDefault($ea859a61a0a4fe3d$exports)))(node);
                var offset = scrollOffset ? scrollOffset : attrs.height > h ? -25 : -(h / 2) + attrs.height / 2;
                (0, (/*@__PURE__*/$parcel$interopDefault($11f191705a16f43e$exports))).to(node, {
                    context: $98b83f3f51b76254$var$isBody(parentScroll) ? window : parentScroll,
                    duration: scrollDuration,
                    offset: offset,
                    callback: function callback(nd) {
                        _this.setState($98b83f3f51b76254$var$setNodeState(nd, step, _this.helper.current), cb);
                    }
                });
            } else _this.setState($98b83f3f51b76254$var$setNodeState(node, step, _this.helper.current), cb);
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "recalculateNode", function(step) {
            var node = document.querySelector(step.selector);
            var stepCallback = function stepCallback(o) {
                if (step.action && typeof step.action === "function") _this.unlockFocus(function() {
                    return step.action(o);
                });
            };
            _this.calculateNode(node, step, function() {
                return stepCallback(node);
            });
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "maskClickHandler", function(e) {
            var _this$props2 = _this.props, closeWithMask = _this$props2.closeWithMask, onRequestClose = _this$props2.onRequestClose;
            if (closeWithMask && !e.target.classList.contains($98b83f3f51b76254$var$CN.mask.disableInteraction)) onRequestClose(e);
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "nextStep", function() {
            var _this$props3 = _this.props, steps = _this$props3.steps, getCurrentStep = _this$props3.getCurrentStep;
            _this.setState(function(prevState) {
                var nextStep = prevState.current < steps.length - 1 ? prevState.current + 1 : prevState.current;
                if (typeof getCurrentStep === "function") getCurrentStep(nextStep);
                return {
                    current: nextStep
                };
            }, _this.showStep);
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "prevStep", function() {
            var getCurrentStep = _this.props.getCurrentStep;
            _this.setState(function(prevState) {
                var nextStep = prevState.current > 0 ? prevState.current - 1 : prevState.current;
                if (typeof getCurrentStep === "function") getCurrentStep(nextStep);
                return {
                    current: nextStep
                };
            }, _this.showStep);
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "gotoStep", function(n) {
            var _this$props4 = _this.props, steps = _this$props4.steps, getCurrentStep = _this$props4.getCurrentStep;
            _this.setState(function(prevState) {
                var nextStep = steps[n] ? n : prevState.current;
                if (typeof getCurrentStep === "function") getCurrentStep(nextStep);
                return {
                    current: nextStep
                };
            }, _this.showStep);
        });
        $98b83f3f51b76254$var$_defineProperty($98b83f3f51b76254$var$_assertThisInitialized(_this), "keyDownHandler", function(e) {
            var _this$props5 = _this.props, onRequestClose = _this$props5.onRequestClose, nextStep = _this$props5.nextStep, prevStep = _this$props5.prevStep, disableKeyboardNavigation = _this$props5.disableKeyboardNavigation;
            e.stopPropagation();
            if (disableKeyboardNavigation === true) return;
            var isEscDisabled, isRightDisabled, isLeftDisabled;
            if (disableKeyboardNavigation) {
                isEscDisabled = disableKeyboardNavigation.includes("esc");
                isRightDisabled = disableKeyboardNavigation.includes("right");
                isLeftDisabled = disableKeyboardNavigation.includes("left");
            }
            if (e.keyCode === 27 && !isEscDisabled) {
                // esc
                e.preventDefault();
                onRequestClose();
            }
            if (e.keyCode === 39 && !isRightDisabled) {
                // right
                e.preventDefault();
                typeof nextStep === "function" ? nextStep() : _this.nextStep();
            }
            if (e.keyCode === 37 && !isLeftDisabled) {
                // left
                e.preventDefault();
                typeof prevStep === "function" ? prevStep() : _this.prevStep();
            }
        });
        _this.state = {
            isOpen: false,
            current: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0,
            w: 0,
            h: 0,
            inDOM: false,
            observer: null,
            focusUnlocked: false
        };
        _this.helper = /*#__PURE__*/ (0, $7fPBF.createRef)();
        _this.helperElement = null;
        _this.debouncedShowStep = (0, (/*@__PURE__*/$parcel$interopDefault($82551d4318ed8ff3$exports)))(_this.showStep, 70);
        return _this;
    }
    $98b83f3f51b76254$var$_createClass(Tour, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props6 = this.props, isOpen = _this$props6.isOpen, startAt = _this$props6.startAt;
                if (isOpen) this.open(startAt);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this$props7 = this.props, isOpen = _this$props7.isOpen, update = _this$props7.update, updateDelay = _this$props7.updateDelay;
                if (!isOpen && nextProps.isOpen) this.open(nextProps.startAt);
                else if (isOpen && !nextProps.isOpen) this.close();
                if (isOpen && update !== nextProps.update) {
                    if (nextProps.steps[this.state.current]) setTimeout(this.showStep, updateDelay);
                    else this.props.onRequestClose();
                }
                if (isOpen && nextProps.isOpen && this.state.current !== nextProps.goToStep) this.gotoStep(nextProps.goToStep);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var isOpen = this.props.isOpen;
                if (isOpen) this.close();
                if (this.state.observer) this.state.observer.disconnect();
            }
        },
        {
            key: "open",
            value: function open(startAt) {
                var _this2 = this;
                var onAfterOpen = this.props.onAfterOpen;
                this.setState(function(prevState) {
                    return {
                        isOpen: true,
                        current: startAt !== undefined ? startAt : prevState.current
                    };
                }, function() {
                    setTimeout(_this2.showStep, 1);
                    _this2.helperElement = _this2.helper.current;
                    if (!_this2.props.disableFocusLock) _this2.helper.current.focus();
                    if (onAfterOpen) onAfterOpen(_this2.helperElement);
                });
                window.addEventListener("resize", this.debouncedShowStep, false);
                window.addEventListener("keydown", this.keyDownHandler, false);
            }
        },
        {
            key: "close",
            value: function close() {
                this.setState(function(prevState) {
                    if (prevState.observer) prevState.observer.disconnect();
                    return {
                        isOpen: false,
                        observer: null
                    };
                }, this.onBeforeClose);
                window.removeEventListener("resize", this.debouncedShowStep);
                window.removeEventListener("keydown", this.keyDownHandler);
            }
        },
        {
            key: "onBeforeClose",
            value: function onBeforeClose() {
                var onBeforeClose = this.props.onBeforeClose;
                if (onBeforeClose) onBeforeClose(this.helperElement);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props8 = this.props, className = _this$props8.className, steps = _this$props8.steps, maskClassName = _this$props8.maskClassName, showButtons = _this$props8.showButtons, showCloseButton = _this$props8.showCloseButton, closeButtonAriaLabel = _this$props8.closeButtonAriaLabel, showNavigation = _this$props8.showNavigation, showNavigationNumber = _this$props8.showNavigationNumber, showNumber = _this$props8.showNumber, onRequestClose = _this$props8.onRequestClose, maskSpace = _this$props8.maskSpace, lastStepNextButton = _this$props8.lastStepNextButton, nextButton = _this$props8.nextButton, prevButton = _this$props8.prevButton, badgeContent = _this$props8.badgeContent, highlightedMaskClassName = _this$props8.highlightedMaskClassName, disableInteraction = _this$props8.disableInteraction, disableDotsNavigation = _this$props8.disableDotsNavigation, nextStep = _this$props8.nextStep, prevStep = _this$props8.prevStep, rounded = _this$props8.rounded, accentColor = _this$props8.accentColor, CustomHelper = _this$props8.CustomHelper, disableFocusLock = _this$props8.disableFocusLock, highlightedBorder = _this$props8.highlightedBorder;
                var _this$state2 = this.state, isOpen = _this$state2.isOpen, current = _this$state2.current, inDOM = _this$state2.inDOM, targetTop = _this$state2.top, targetRight = _this$state2.right, targetBottom = _this$state2.bottom, targetLeft = _this$state2.left, targetWidth = _this$state2.width, targetHeight = _this$state2.height, windowWidth = _this$state2.w, windowHeight = _this$state2.h, helperWidth = _this$state2.helperWidth, helperHeight = _this$state2.helperHeight, helperPosition = _this$state2.helperPosition;
                if (isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$Portal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$GlobalStyle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$ReactourResizeObserver, {
                    step: steps[current],
                    refresh: function refresh() {
                        return _this3.recalculateNode(steps[current]);
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$ReactourMutationObserver, {
                    step: steps[current],
                    refresh: function refresh() {
                        return _this3.recalculateNode(steps[current]);
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$SvgMask, {
                    onClick: this.maskClickHandler,
                    forwardRef: function forwardRef(c) {
                        return _this3.mask = c;
                    },
                    windowWidth: windowWidth,
                    windowHeight: windowHeight,
                    targetWidth: targetWidth,
                    targetHeight: targetHeight,
                    targetTop: targetTop,
                    targetLeft: targetLeft,
                    padding: maskSpace,
                    rounded: rounded,
                    roundedStep: steps[current].roundedStep,
                    className: maskClassName,
                    disableInteraction: steps[current].stepInteraction === false || disableInteraction ? !steps[current].stepInteraction : disableInteraction,
                    disableInteractionClassName: "".concat($98b83f3f51b76254$var$CN.mask.disableInteraction, " ").concat(highlightedMaskClassName),
                    highlightedBorder: highlightedBorder
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $2cb7353992a884b7$export$2e2bcd8739ae039), {
                    disabled: disableFocusLock,
                    autoFocus: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$var$Guide, {
                    ref: this.helper,
                    targetHeight: targetHeight,
                    targetWidth: targetWidth,
                    targetTop: targetTop,
                    targetRight: targetRight,
                    targetBottom: targetBottom,
                    targetLeft: targetLeft,
                    windowWidth: windowWidth,
                    windowHeight: windowHeight,
                    helperWidth: helperWidth,
                    helperHeight: helperHeight,
                    helperPosition: helperPosition,
                    padding: maskSpace,
                    tabIndex: -1,
                    current: current,
                    style: steps[current].style ? steps[current].style : {},
                    rounded: rounded,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))($98b83f3f51b76254$var$CN.helper.base, className, $98b83f3f51b76254$var$_defineProperty({}, $98b83f3f51b76254$var$CN.helper.isOpen, isOpen)),
                    accentColor: accentColor,
                    defaultStyles: !CustomHelper,
                    role: "dialog"
                }, CustomHelper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CustomHelper, {
                    current: current,
                    totalSteps: steps.length,
                    gotoStep: this.gotoStep,
                    close: onRequestClose,
                    content: steps[current] && (typeof steps[current].content === "function" ? steps[current].content({
                        close: onRequestClose,
                        goTo: this.gotoStep,
                        inDOM: inDOM,
                        step: current + 1
                    }) : steps[current].content)
                }, this.props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, this.props.children, steps[current] && (typeof steps[current].content === "function" ? steps[current].content({
                    close: onRequestClose,
                    goTo: this.gotoStep,
                    inDOM: inDOM,
                    step: current + 1
                }) : steps[current].content), showNumber && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$37acb3580601e69a, {
                    "data-tour-elem": "badge",
                    accentColor: accentColor
                }, typeof badgeContent === "function" ? badgeContent(current + 1, steps.length) : current + 1), (showButtons || showNavigation) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$c7c44baae9d9f25f, {
                    "data-tour-elem": "controls"
                }, showButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$21b07c8f274aebd5, {
                    onClick: typeof prevStep === "function" ? prevStep : this.prevStep,
                    disabled: current === 0,
                    label: prevButton ? prevButton : null
                }), showNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$b8a61e5c71402559, {
                    "data-tour-elem": "navigation"
                }, steps.map(function(s, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$d046b3c4a416f60d, {
                        key: "".concat(s.selector ? s.selector : "undef", "_").concat(i),
                        onClick: function onClick() {
                            return _this3.gotoStep(i);
                        },
                        current: current,
                        index: i,
                        accentColor: accentColor,
                        disabled: current === i || disableDotsNavigation,
                        showNumber: showNavigationNumber,
                        "data-tour-elem": "dot",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))($98b83f3f51b76254$var$CN.dot.base, $98b83f3f51b76254$var$_defineProperty({}, $98b83f3f51b76254$var$CN.dot.active, current === i)),
                        "aria-label": s.navDotAriaLabel
                    });
                })), showButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$21b07c8f274aebd5, {
                    onClick: current === steps.length - 1 ? lastStepNextButton ? onRequestClose : function() {} : typeof nextStep === "function" ? nextStep : this.nextStep,
                    disabled: !lastStepNextButton && current === steps.length - 1,
                    inverted: true,
                    label: lastStepNextButton && current === steps.length - 1 ? lastStepNextButton : nextButton ? nextButton : null
                })), showCloseButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($98b83f3f51b76254$export$f39c2d165cd861fe, {
                    onClick: onRequestClose,
                    className: "reactour__close",
                    ariaLabel: closeButtonAriaLabel
                })))));
                return null;
            }
        }
    ]);
    return Tour;
}((0, $7fPBF.Component));
var $98b83f3f51b76254$var$setNodeState = function setNodeState(node, step, helper) {
    if (!helper) return;
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    var _hx$getNodeRect = $98b83f3f51b76254$var$getNodeRect(helper), helperWidth = _hx$getNodeRect.width, helperHeight = _hx$getNodeRect.height;
    var attrs = {
        top: h + 10,
        right: w / 2 + 9,
        bottom: h / 2 + 9,
        left: w / 2 - helperWidth / 2,
        width: 0,
        height: 0,
        w: w,
        h: h,
        helperPosition: "center"
    };
    if (node) attrs = $98b83f3f51b76254$var$getHighlightedRect(node, step);
    return function update() {
        return $98b83f3f51b76254$var$_objectSpread2($98b83f3f51b76254$var$_objectSpread2({
            w: w,
            h: h,
            helperWidth: helperWidth,
            helperHeight: helperHeight,
            helperPosition: step.position
        }, attrs), {}, {
            inDOM: node ? true : false
        });
    };
};
$98b83f3f51b76254$var$Tour.propTypes = $98b83f3f51b76254$var$propTypes;
$98b83f3f51b76254$var$Tour.defaultProps = $98b83f3f51b76254$var$defaultProps;
var $98b83f3f51b76254$export$2e2bcd8739ae039 = $98b83f3f51b76254$var$Tour;



var $2oXYc = parcelRequire("2oXYc");


parcelRequire("7fPBF");
const $4d0be4fab819820f$var$steps = [
    {
        type: "intro",
        id: "GR-intro",
        steps: [
            {
                selector: "#account-details-grid-save-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Always press",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Save"
                            }),
                            " ",
                            "after you are through making changes."
                        ]
                    })
            },
            {
                selector: "#account-details-grid-spreadsheet",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-2",
                                children: [
                                    "Add and change your data just like in a",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "regular spreadsheet"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Right mouse button displays a useful",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "context menu"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
            }
        ]
    }
];
var $4d0be4fab819820f$export$2e2bcd8739ae039 = $4d0be4fab819820f$var$steps;



parcelRequire("7fPBF");
const $947ec944053652c5$var$steps = [
    {
        type: "intro",
        id: "AD-intro",
        steps: [
            {
                selector: "#account-details-table-buttons",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Use these buttons to",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "sync"
                            }),
                            " ",
                            "transactions,",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "import"
                            }),
                            " ",
                            "files and access account",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "settings"
                            }),
                            "."
                        ]
                    })
            },
            {
                selector: "#acccount-details-table-edit-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Edit button"
                            }),
                            " ",
                            "lets you switch to spreadsheet mode where you can",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "add and edit data"
                            }),
                            "."
                        ]
                    })
            }
        ]
    }
];
var $947ec944053652c5$export$2e2bcd8739ae039 = $947ec944053652c5$var$steps;



parcelRequire("7fPBF");
const $1d44dcab4da50d44$var$steps = [
    {
        type: "intro",
        id: "ADT-intro-2",
        steps: [
            {
                position: "center",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "For real estate we need to keep track of two kinds of information:",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "purchase & sale transactions"
                            }),
                            " ",
                            "and",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "changes in the property value"
                            }),
                            "."
                        ]
                    })
            },
            {
                selector: "#button-group-two-views",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Use",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "these buttons"
                            }),
                            " ",
                            "to switch back and forth between the two modes. There is a different spreadsheet view for each mode."
                        ]
                    })
            }
        ]
    }
];
var $1d44dcab4da50d44$export$2e2bcd8739ae039 = $1d44dcab4da50d44$var$steps;



parcelRequire("7fPBF");
const $486611ef54786380$var$dashboard = [
    {
        type: "intro",
        id: "DA-intro",
        steps: [
            {
                selector: "#net-worth-kpis",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-4",
                                children: [
                                    "Welcome to your",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: " Dashboard "
                                    }),
                                    "-- all your assets at a glance."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "To the left -- your key financial indicators and their current and past values."
                            })
                        ]
                    })
            },
            {
                selector: "#kpi-previousValue",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-4",
                                children: [
                                    "You can compare your current wealth with the past. We call that past situation",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Baseline."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "You can set the Baseline date by clicking on the bottom handle."
                            })
                        ]
                    })
            },
            {
                selector: "#edit-mode",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Use",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Edit Mode"
                            }),
                            " ",
                            "to add and delete accounts."
                        ]
                    })
            },
            {
                selector: "#sync-all-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Sync"
                            }),
                            " ",
                            "buttons help to retrieve the most recent transactions."
                        ]
                    })
            },
            {
                selector: "#your-assets",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Your accounts"
                            }),
                            " ",
                            "will show up below. Hover your mouse the account tile to see recent transactions and click for more."
                        ]
                    })
            },
            {
                selector: "#add-new-deposits-button",
                content: "Let us get started! We have added some demo data for you to play around with."
            }
        ]
    }
];
var $486611ef54786380$export$2e2bcd8739ae039 = $486611ef54786380$var$dashboard;


/* eslint-disable react/jsx-filename-extension */ 
parcelRequire("7fPBF");
const $e3454232ff87812b$var$tours = [
    {
        type: "intro",
        id: "PR-intro",
        steps: [
            {
                selector: "#projectDetailsParent",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-4",
                                children: [
                                    "Welcome to the",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Project Details"
                                    }),
                                    " ",
                                    "screen."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Use it to simulate",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "future"
                                    }),
                                    " ",
                                    "money in- and outflows, asset purchases and value growth."
                                ]
                            })
                        ]
                    })
            },
            {
                selector: "#projectSlider",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "pb-4",
                                children: "Use this slider to see project asset changes over time."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "The date you select is the",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Slider Date"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
            },
            {
                selector: "#project-transactions-list",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Your future",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "transactions"
                            }),
                            " ",
                            "and asset",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "value changes"
                            }),
                            " ",
                            "appear here."
                        ]
                    })
            },
            {
                selector: "#projectButtonBar :nth-child(2)",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Add"
                            }),
                            " ",
                            "new future",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "transactions"
                            }),
                            " ",
                            "here..."
                        ]
                    })
            },
            {
                selector: "#projectButtonBar :nth-child(3)",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "and future",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "asset value changes"
                            }),
                            " ",
                            "here."
                        ]
                    })
            },
            {
                selector: "#project-assets",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Here are all",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "accounts"
                                    }),
                                    " ",
                                    "and",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "assets"
                                    }),
                                    " ",
                                    "used in the projects."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pt-2",
                                children: [
                                    "The amounts displayed are their",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "future values"
                                    }),
                                    " ",
                                    "on Slider Date."
                                ]
                            })
                        ]
                    })
            },
            {
                selector: "#projectSum",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "This is the",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "net value total"
                            }),
                            " ",
                            "of all project assets as of Slider Date."
                        ]
                    })
            },
            {
                selector: "#project-details-add-goal-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "You can set",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "goals"
                            }),
                            " ",
                            "for your project here."
                        ]
                    })
            },
            {
                selector: "#project-details-apply-template-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "To help you get started you can import",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "sample transactions"
                                    }),
                                    " ",
                                    "from a pre-defined project template."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "pt-2 italic",
                                children: "For example: import a template for purchasing real estate for rent."
                            })
                        ]
                    })
            },
            {
                selector: "#projectIsolated",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "By default (",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "italic",
                                        children: '"yes"'
                                    }),
                                    ") project transactions and future value changes",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "show up"
                                    }),
                                    " ",
                                    "in Account Details and are reflected in your overall KPIs and Reports."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pt-2",
                                children: [
                                    "You can change that behaviour by setting this to",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "italic",
                                        children: '"no"'
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
            }
        ]
    }
];
var $e3454232ff87812b$export$2e2bcd8739ae039 = $e3454232ff87812b$var$tours;



parcelRequire("7fPBF");
const $64c339d16508f0ab$var$steps = [
    {
        type: "intro",
        id: "GR-intro",
        steps: [
            {
                selector: "#account-details-grid-save-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Denke daran die \xc4nderungen mit",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Speichern"
                            }),
                            " ",
                            "zu best\xe4tigen."
                        ]
                    })
            },
            {
                selector: "#account-details-grid-spreadsheet",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-2",
                                children: [
                                    "Daten k\xf6nnen wie in einem gew\xf6hnlichen",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Spreadsheet"
                                    }),
                                    "angepasst und erg\xe4nzt werden."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Rechter Maus-Knopf f\xfcr das n\xfctzliche",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Kontextmen\xfc"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
            }
        ]
    }
];
var $64c339d16508f0ab$export$2e2bcd8739ae039 = $64c339d16508f0ab$var$steps;



parcelRequire("7fPBF");
const $5edf818dac152f22$var$steps = [
    {
        type: "intro",
        id: "AD-intro",
        steps: [
            {
                selector: "#account-details-table-buttons",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Mit diesen Buttons kannst du deine Daten",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "synchronisieren"
                            }),
                            ",",
                            " ",
                            "Dateien",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "importieren"
                            }),
                            " ",
                            "und auf Konto-",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Einstellungen"
                            }),
                            "zugreifen."
                        ]
                    })
            },
            {
                selector: "#acccount-details-table-edit-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Edit"
                            }),
                            " ",
                            "wechselt in das Bearbeitungsmodus, um Daten zu",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "erg\xe4nzen und bearbeiten."
                            }),
                            "."
                        ]
                    })
            }
        ]
    }
];
var $5edf818dac152f22$export$2e2bcd8739ae039 = $5edf818dac152f22$var$steps;



parcelRequire("7fPBF");
const $ef3e98d09ec7c76e$var$steps = [
    {
        type: "intro",
        id: "ADT-intro-2",
        steps: [
            {
                position: "center",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Bei Immobilien sind zwei Arten von Informationen wichtig:",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Kauf- & Verkaufstransaktionen"
                            }),
                            " ",
                            "sowie",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Wert\xe4nderungen."
                            }),
                            "."
                        ]
                    })
            },
            {
                selector: "#button-group-two-views",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Verwende",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "diese Buttons"
                            }),
                            " ",
                            "um sich zwischen den beiden Ansichten zu bewegen. Es gibt eine unterschiedliche Spreadsheets f\xfcr jede Ansicht."
                        ]
                    })
            }
        ]
    }
];
var $ef3e98d09ec7c76e$export$2e2bcd8739ae039 = $ef3e98d09ec7c76e$var$steps;



parcelRequire("7fPBF");
const $ff8176e437eec829$var$dashboard = [
    {
        type: "intro",
        id: "DA-intro",
        steps: [
            {
                selector: "#net-worth-kpis",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-4",
                                children: [
                                    "Willkomen auf deinem",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: " Dashboard "
                                    }),
                                    "-- alle Anlagen auf einen Blick!"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Ganz links -- die wichtigsten Kennzahlen deiner Finanzen, sowie ihre gegenw\xe4rtige und historiche Werte."
                            })
                        ]
                    })
            },
            {
                selector: "#kpi-previousValue",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-4",
                                children: [
                                    "Vergleiche den Ist-Zustand mit der Vergangenheit. Wir nennen diesen vergangenen Zeitpunkt",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "die Baseline."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Durch Ausklappen diese Feldes nach unten l\xe4sst sich das genaue Datum einstellen."
                            })
                        ]
                    })
            },
            {
                selector: "#edit-mode",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Nutze",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Edit-Modus"
                            }),
                            " ",
                            "um Konten hinzuf\xfcgen und zu l\xf6schen."
                        ]
                    })
            },
            {
                selector: "#sync-all-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Sync-Button"
                            }),
                            " ",
                            "holt die neusten Ums\xe4tze und Preise."
                        ]
                    })
            },
            {
                selector: "#your-assets",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Alle Konten"
                            }),
                            " ",
                            "werden hier unten angezeigt. Bewege die Maus \xfcber ein Kachel um die letzten Transaktionen zu sehen und klicke f\xfcr Details."
                        ]
                    })
            },
            {
                selector: "#add-new-deposits-button",
                content: "Lass uns starten! Wir haben Demo-Daten vorbereitet, um dir den Einstieg zu erleichtern."
            }
        ]
    }
];
var $ff8176e437eec829$export$2e2bcd8739ae039 = $ff8176e437eec829$var$dashboard;


/* eslint-disable react/jsx-filename-extension */ 
parcelRequire("7fPBF");
const $664b31e3867aa128$var$tours = [
    {
        type: "intro",
        id: "PR-intro",
        steps: [
            {
                selector: "#projectDetailsParent",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pb-4",
                                children: [
                                    "Willkomen bei",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Projektdetails"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Damit kannst du die",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Zukunft"
                                    }),
                                    " ",
                                    "simulieren: Ein- und Ausgaben, Anlagentransaktionen und Wertzuwachs."
                                ]
                            })
                        ]
                    })
            },
            {
                selector: "#projectSlider",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "pb-4",
                                children: "Mit diesem Regler bewegst du dich hin und her durch die Zeit."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Das gew\xe4hlte Datum hei\xdft",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Regler-Datum"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
            },
            {
                selector: "#project-transactions-list",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Deine zuk\xfcnftige",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Transaktionen"
                            }),
                            " ",
                            "sowie",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Wert\xe4nderungen"
                            }),
                            " ",
                            "der Anlagen erscheinen hier."
                        ]
                    })
            },
            {
                selector: "#projectButtonBar :nth-child(2)",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "F\xfcge"
                            }),
                            " ",
                            "neue zuk\xfcnftige",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Transkationen"
                            }),
                            " ",
                            "hiermit..."
                        ]
                    })
            },
            {
                selector: "#projectButtonBar :nth-child(3)",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "und zuk\xfcnftige",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Wert\xe4nderungen der Anlagen"
                            }),
                            " ",
                            "hiermit."
                        ]
                    })
            },
            {
                selector: "#project-assets",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Hier erscheinen alle",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Konten"
                                    }),
                                    " ",
                                    "und",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Anlagen"
                                    }),
                                    " ",
                                    "verwendet in diesem Projekt."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pt-2",
                                children: [
                                    "Die hier sichtbaren Betr\xe4ge sind die",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Zukunftswerte"
                                    }),
                                    " ",
                                    "am Regler-Datum."
                                ]
                            })
                        ]
                    })
            },
            {
                selector: "#projectSum",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Das ist der",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Gesamtwert"
                            }),
                            " ",
                            "aller Projektanlagen am Regler-Datum."
                        ]
                    })
            },
            {
                selector: "#project-details-add-goal-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Setze",
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Ziele"
                            }),
                            " ",
                            "f\xfcr dein Projekt hier."
                        ]
                    })
            },
            {
                selector: "#project-details-apply-template-button",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Als Starthilfe kannst du",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Musterprojekte"
                                    }),
                                    " ",
                                    "mit Beispieltransaktionen importieren und entfernen."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "pt-2 italic",
                                children: "Beispiel: Kauf einer Mietimmobilie."
                            })
                        ]
                    })
            },
            {
                selector: "#projectIsolated",
                content: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    "Normalerweise (",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "italic",
                                        children: '"ja"'
                                    }),
                                    ") sind die Projekttransaktionen und Wert\xe4nderungen",
                                    " ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "sichtbar"
                                    }),
                                    " ",
                                    "in au\xdferhalb dieser Maske (in Kontodetails sowie in allen Kerndaten und Reports)."
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "pt-2",
                                children: [
                                    "Dies kann verhindert werden, indem du hier",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "italic",
                                        children: '"nein"'
                                    }),
                                    "w\xe4hlst."
                                ]
                            })
                        ]
                    })
            }
        ]
    }
];
var $664b31e3867aa128$export$2e2bcd8739ae039 = $664b31e3867aa128$var$tours;



function $79638df9a862308c$export$2e2bcd8739ae039(module) {
    const lng = (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).language;
    if (lng === "en") switch(module){
        case "accountDetailsGrid":
            return 0, $4d0be4fab819820f$export$2e2bcd8739ae039;
        case "accountDetailsTable":
            return 0, $947ec944053652c5$export$2e2bcd8739ae039;
        case "tableLayoutRealEstate":
            return 0, $1d44dcab4da50d44$export$2e2bcd8739ae039;
        case "dashboard":
            return 0, $486611ef54786380$export$2e2bcd8739ae039;
        case "projectDetails":
            return 0, $e3454232ff87812b$export$2e2bcd8739ae039;
        default:
            return [];
    }
    if (lng === "de") switch(module){
        case "accountDetailsGrid":
            return 0, $64c339d16508f0ab$export$2e2bcd8739ae039;
        case "accountDetailsTable":
            return 0, $5edf818dac152f22$export$2e2bcd8739ae039;
        case "tableLayoutRealEstate":
            return 0, $ef3e98d09ec7c76e$export$2e2bcd8739ae039;
        case "dashboard":
            return 0, $ff8176e437eec829$export$2e2bcd8739ae039;
        case "projectDetails":
            return 0, $664b31e3867aa128$export$2e2bcd8739ae039;
        default:
            return [];
    }
    return null;
}



function $75977f0ca8247e66$export$2e2bcd8739ae039({ componentName: componentName, devModeShowTour: devModeShowTour }) {
    if (!componentName) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    const componentTours = (0, $79638df9a862308c$export$2e2bcd8739ae039)(componentName); // localTours: tour object is { id, steps[] }
    if (!componentTours) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    const [displayedTour, setTourState] = (0, $7fPBF.useState)(null); // stores tour object { id, steps[] }
    const [user, setUser] = (0, $7fPBF.useState)(null);
    // we want the user to see one tour at a time; that tour should be displayed only once (even in dev mode when it gets rendered two times)
    // tour lock does not have to be in state, can be local
    // using ref, because changing ref does not trigger re-render
    const tourLock = (0, $7fPBF.useRef)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // get the toursSeen from the user's profile in Amplify Auth store
    (0, $7fPBF.useEffect)(()=>{
        (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
            forceRefresh: true
        }).then((userData)=>setUser(userData)).catch((error)=>console.error(error));
    }, []);
    // run this once we have the user
    (0, $7fPBF.useEffect)(()=>{
        async function execLogic() {
            const toursSeen = user.attributes["custom:tours_seen"] ? JSON.parse(user.attributes["custom:tours_seen"]) : null;
            // handle what tour to display
            let toursToDisplay;
            if (typeof devModeShowTour === "number") // if the devModeShowTour parameters is set, display selected tour regardless what is in user's profile
            toursToDisplay = componentTours;
            else // remove all tours from localTours whose ids are in toursSeen
            toursToDisplay = componentTours.filter((tour)=>!toursSeen || !toursSeen.includes(tour.id));
            // if we have tours to display and if there is no tour being displayed already, display the first one
            if (toursToDisplay.length > 0 && !tourLock.current) {
                // update the ref to indicate that the tour is being shown already (to handle double-invoke and other strict mode toys in DEV mode)
                tourLock.current = true;
                // get the first tour from list and display it
                setTourState(toursToDisplay[typeof devModeShowTour === "number" ? devModeShowTour : 0]);
            }
        }
        if (user && !tourLock.current) execLogic();
    }, [
        user
    ]);
    if (!displayedTour) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    return(// eslint-disable-next-line react/no-unstable-nested-components
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bf18c8a9090be1b$exports.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98b83f3f51b76254$export$2e2bcd8739ae039), {
            steps: displayedTour === null || displayedTour === void 0 ? void 0 : displayedTour.steps,
            isOpen: !!displayedTour,
            rounded: 4,
            accentColor: "#1797f2",
            disableInteraction: true,
            onRequestClose: ()=>{
                dispatch((0, $8bd3fc2d0bca0786$export$cc7ed8db712151cc)(displayedTour === null || displayedTour === void 0 ? void 0 : displayedTour.id));
                setTourState(null);
            // tourLock.current = false; // this is imho not necessary, because we want this component to not to show any further tours this time
            }
        })
    }));
}
$75977f0ca8247e66$export$2e2bcd8739ae039.propTypes = {
    componentName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    devModeShowTour: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
};
$75977f0ca8247e66$export$2e2bcd8739ae039.defaultProps = {
    componentName: null,
    devModeShowTour: null
};


/* eslint-disable eqeqeq */ /* eslint-disable no-param-reassign */ /* eslint-disable no-redeclare */ /* eslint-disable block-scoped-var */ /* eslint-disable no-var */ /* eslint-disable vars-on-top */ /* eslint-disable no-plusplus */ /* eslint-disable no-shadow */ 
var $3ffd6794bf825759$exports = {};
// this is a patch for jspreadsheet to add formula support without using eval() or new Function()
/* eslint-disable no-redeclare */ /* eslint-disable block-scoped-var */ /* eslint-disable no-var */ /* eslint-disable vars-on-top */ /* eslint-disable no-undef */ /* eslint-disable prefer-destructuring */ /* eslint-disable eqeqeq */ /* eslint-disable consistent-return */ /* eslint-disable func-names */ /* eslint-disable no-useless-escape */ /* eslint-disable no-restricted-globals */ /* eslint-disable no-use-before-define */ /* eslint-disable no-multi-assign */ /* eslint-disable radix */ /* eslint-disable no-shadow */ /* eslint-disable no-plusplus */ /* eslint-disable no-restricted-syntax */ /* eslint-disable no-param-reassign */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-unused-expressions */ // eslint-disable-next-line import/no-unresolved
var $d551340dd0bc6b22$exports = {};

$parcel$export($d551340dd0bc6b22$exports, "CELL", function () { return $d551340dd0bc6b22$export$66778154bf9d2f9c; });
$parcel$export($d551340dd0bc6b22$exports, "ERROR", function () { return $d551340dd0bc6b22$export$103bedf43ba882db; });
$parcel$export($d551340dd0bc6b22$exports, "INFO", function () { return $d551340dd0bc6b22$export$7ecad81ba40c4d73; });
$parcel$export($d551340dd0bc6b22$exports, "ISBLANK", function () { return $d551340dd0bc6b22$export$80fb9c324a872d3a; });
$parcel$export($d551340dd0bc6b22$exports, "ISERR", function () { return $d551340dd0bc6b22$export$45ec665ab9d90642; });
$parcel$export($d551340dd0bc6b22$exports, "ISERROR", function () { return $d551340dd0bc6b22$export$e3e8e7d5009c248; });
$parcel$export($d551340dd0bc6b22$exports, "ISEVEN", function () { return $d551340dd0bc6b22$export$f283142d6b8155bb; });
$parcel$export($d551340dd0bc6b22$exports, "ISFORMULA", function () { return $d551340dd0bc6b22$export$3a419249afa83e2; });
$parcel$export($d551340dd0bc6b22$exports, "ISLOGICAL", function () { return $d551340dd0bc6b22$export$235f36d2366dd402; });
$parcel$export($d551340dd0bc6b22$exports, "ISNA", function () { return $d551340dd0bc6b22$export$13f9cd87e4e832b4; });
$parcel$export($d551340dd0bc6b22$exports, "ISNONTEXT", function () { return $d551340dd0bc6b22$export$1675d355bf07a3f5; });
$parcel$export($d551340dd0bc6b22$exports, "ISNUMBER", function () { return $d551340dd0bc6b22$export$95ae71f78f3360a1; });
$parcel$export($d551340dd0bc6b22$exports, "ISODD", function () { return $d551340dd0bc6b22$export$7b7108d0921615c7; });
$parcel$export($d551340dd0bc6b22$exports, "ISREF", function () { return $d551340dd0bc6b22$export$ec5b11b75de23687; });
$parcel$export($d551340dd0bc6b22$exports, "ISTEXT", function () { return $d551340dd0bc6b22$export$60e9017a500ec91a; });
$parcel$export($d551340dd0bc6b22$exports, "N", function () { return $d551340dd0bc6b22$export$a07804094c3ecf2d; });
$parcel$export($d551340dd0bc6b22$exports, "NA", function () { return $d551340dd0bc6b22$export$dbd1925f4fe9ec65; });
$parcel$export($d551340dd0bc6b22$exports, "SHEET", function () { return $d551340dd0bc6b22$export$dd169a3e78f796a9; });
$parcel$export($d551340dd0bc6b22$exports, "SHEETS", function () { return $d551340dd0bc6b22$export$38fac4657e6be5eb; });
$parcel$export($d551340dd0bc6b22$exports, "TYPE", function () { return $d551340dd0bc6b22$export$b87f371cbc396fcf; });
$parcel$export($d551340dd0bc6b22$exports, "CHOOSE", function () { return $d551340dd0bc6b22$export$ea573e2c4c6f4f41; });
$parcel$export($d551340dd0bc6b22$exports, "COLUMN", function () { return $d551340dd0bc6b22$export$7f092194d45e1f0d; });
$parcel$export($d551340dd0bc6b22$exports, "COLUMNS", function () { return $d551340dd0bc6b22$export$6a6dcc7e725abed4; });
$parcel$export($d551340dd0bc6b22$exports, "HLOOKUP", function () { return $d551340dd0bc6b22$export$db509988dd6e393e; });
$parcel$export($d551340dd0bc6b22$exports, "VLOOKUP", function () { return $d551340dd0bc6b22$export$9e83f203451c83e2; });
$parcel$export($d551340dd0bc6b22$exports, "INDEX", function () { return $d551340dd0bc6b22$export$e3852490c78bdb2d; });
$parcel$export($d551340dd0bc6b22$exports, "LOOKUP", function () { return $d551340dd0bc6b22$export$9336f49f4401ba30; });
$parcel$export($d551340dd0bc6b22$exports, "MATCH", function () { return $d551340dd0bc6b22$export$5a1a83be8f503735; });
$parcel$export($d551340dd0bc6b22$exports, "ROWS", function () { return $d551340dd0bc6b22$export$9ecce7f637e2cef2; });
$parcel$export($d551340dd0bc6b22$exports, "SORT", function () { return $d551340dd0bc6b22$export$1e652a44bda81b79; });
$parcel$export($d551340dd0bc6b22$exports, "TRANSPOSE", function () { return $d551340dd0bc6b22$export$ae60ab9b4739fc3d; });
$parcel$export($d551340dd0bc6b22$exports, "UNIQUE", function () { return $d551340dd0bc6b22$export$97ef0433caf1f815; });
$parcel$export($d551340dd0bc6b22$exports, "AVEDEV", function () { return $d551340dd0bc6b22$export$e3d5dbeb79a4a98f; });
$parcel$export($d551340dd0bc6b22$exports, "AVERAGE", function () { return $d551340dd0bc6b22$export$d3bfe4097a2a8542; });
$parcel$export($d551340dd0bc6b22$exports, "AVERAGEA", function () { return $d551340dd0bc6b22$export$c7a6518a193e8c0d; });
$parcel$export($d551340dd0bc6b22$exports, "AVERAGEIF", function () { return $d551340dd0bc6b22$export$276cb9f26ac5719f; });
$parcel$export($d551340dd0bc6b22$exports, "AVERAGEIFS", function () { return $d551340dd0bc6b22$export$227daf04fd9df71e; });
$parcel$export($d551340dd0bc6b22$exports, "BETA", function () { return $d551340dd0bc6b22$export$d8fe69043b6df2f0; });
$parcel$export($d551340dd0bc6b22$exports, "BINOM", function () { return $d551340dd0bc6b22$export$b4ccfb6e589ca4c3; });
$parcel$export($d551340dd0bc6b22$exports, "COMBIN", function () { return $d551340dd0bc6b22$export$4b98dc7b8f648ca3; });
$parcel$export($d551340dd0bc6b22$exports, "CHISQ", function () { return $d551340dd0bc6b22$export$bb2c792e07d3cb0d; });
$parcel$export($d551340dd0bc6b22$exports, "CONFIDENCE", function () { return $d551340dd0bc6b22$export$1252dc9d6995e45d; });
$parcel$export($d551340dd0bc6b22$exports, "CORREL", function () { return $d551340dd0bc6b22$export$fae51e0b17961c08; });
$parcel$export($d551340dd0bc6b22$exports, "COUNT", function () { return $d551340dd0bc6b22$export$d61684373eacdf61; });
$parcel$export($d551340dd0bc6b22$exports, "COUNTA", function () { return $d551340dd0bc6b22$export$e2041fbf69361bdc; });
$parcel$export($d551340dd0bc6b22$exports, "COUNTBLANK", function () { return $d551340dd0bc6b22$export$79c5ccd5516ec50d; });
$parcel$export($d551340dd0bc6b22$exports, "COUNTIF", function () { return $d551340dd0bc6b22$export$56486fbe6da8d677; });
$parcel$export($d551340dd0bc6b22$exports, "COUNTIFS", function () { return $d551340dd0bc6b22$export$4e3788eb19a40c70; });
$parcel$export($d551340dd0bc6b22$exports, "COVARIANCE", function () { return $d551340dd0bc6b22$export$fe38092c9c5592c1; });
$parcel$export($d551340dd0bc6b22$exports, "DEVSQ", function () { return $d551340dd0bc6b22$export$f29d068e704fbf; });
$parcel$export($d551340dd0bc6b22$exports, "EXPON", function () { return $d551340dd0bc6b22$export$f5c508346c29966; });
$parcel$export($d551340dd0bc6b22$exports, "F", function () { return $d551340dd0bc6b22$export$d66501df72047452; });
$parcel$export($d551340dd0bc6b22$exports, "SUM", function () { return $d551340dd0bc6b22$export$49f482aefa6f8a2d; });
$parcel$export($d551340dd0bc6b22$exports, "FISHER", function () { return $d551340dd0bc6b22$export$102c5fad6d1d3d0f; });
$parcel$export($d551340dd0bc6b22$exports, "FISHERINV", function () { return $d551340dd0bc6b22$export$7e8d9099faaf76a7; });
$parcel$export($d551340dd0bc6b22$exports, "FORECAST", function () { return $d551340dd0bc6b22$export$74e2e04859ad1fb3; });
$parcel$export($d551340dd0bc6b22$exports, "FREQUENCY", function () { return $d551340dd0bc6b22$export$6aad80bcad85ea25; });
$parcel$export($d551340dd0bc6b22$exports, "GAMMA", function () { return $d551340dd0bc6b22$export$3149bf0fa771f486; });
$parcel$export($d551340dd0bc6b22$exports, "GAMMALN", function () { return $d551340dd0bc6b22$export$bc57bccc987a6235; });
$parcel$export($d551340dd0bc6b22$exports, "GAUSS", function () { return $d551340dd0bc6b22$export$e8fb82826dafa111; });
$parcel$export($d551340dd0bc6b22$exports, "GEOMEAN", function () { return $d551340dd0bc6b22$export$c974ccf6ee53b9d2; });
$parcel$export($d551340dd0bc6b22$exports, "GROWTH", function () { return $d551340dd0bc6b22$export$2478e36aa95cfb; });
$parcel$export($d551340dd0bc6b22$exports, "HARMEAN", function () { return $d551340dd0bc6b22$export$385744d3d40f10b3; });
$parcel$export($d551340dd0bc6b22$exports, "HYPGEOM", function () { return $d551340dd0bc6b22$export$4f2126ef1718652a; });
$parcel$export($d551340dd0bc6b22$exports, "INTERCEPT", function () { return $d551340dd0bc6b22$export$12639d051cc8cc1f; });
$parcel$export($d551340dd0bc6b22$exports, "KURT", function () { return $d551340dd0bc6b22$export$6e24870f8faf8e81; });
$parcel$export($d551340dd0bc6b22$exports, "LARGE", function () { return $d551340dd0bc6b22$export$7b93a10c0fefe3e3; });
$parcel$export($d551340dd0bc6b22$exports, "LINEST", function () { return $d551340dd0bc6b22$export$7ae85b03504b01ef; });
$parcel$export($d551340dd0bc6b22$exports, "LOGEST", function () { return $d551340dd0bc6b22$export$8640ab3af9cd810f; });
$parcel$export($d551340dd0bc6b22$exports, "LOGNORM", function () { return $d551340dd0bc6b22$export$53b1f20e80f267f3; });
$parcel$export($d551340dd0bc6b22$exports, "MAX", function () { return $d551340dd0bc6b22$export$b8767e9c28ff5faa; });
$parcel$export($d551340dd0bc6b22$exports, "MAXA", function () { return $d551340dd0bc6b22$export$ef0ff395d2bca167; });
$parcel$export($d551340dd0bc6b22$exports, "MEDIAN", function () { return $d551340dd0bc6b22$export$3b342059645d214a; });
$parcel$export($d551340dd0bc6b22$exports, "MIN", function () { return $d551340dd0bc6b22$export$85fbf3b9d951b785; });
$parcel$export($d551340dd0bc6b22$exports, "MINA", function () { return $d551340dd0bc6b22$export$99ffffb58d927f18; });
$parcel$export($d551340dd0bc6b22$exports, "MODE", function () { return $d551340dd0bc6b22$export$e48589d9e4824227; });
$parcel$export($d551340dd0bc6b22$exports, "NEGBINOM", function () { return $d551340dd0bc6b22$export$7d27d6c799ee5741; });
$parcel$export($d551340dd0bc6b22$exports, "NORM", function () { return $d551340dd0bc6b22$export$954e4c4b76579057; });
$parcel$export($d551340dd0bc6b22$exports, "PEARSON", function () { return $d551340dd0bc6b22$export$52136d9297595966; });
$parcel$export($d551340dd0bc6b22$exports, "PERCENTILE", function () { return $d551340dd0bc6b22$export$96cfb1bd783d195e; });
$parcel$export($d551340dd0bc6b22$exports, "PERCENTRANK", function () { return $d551340dd0bc6b22$export$483d99bb48a73bb9; });
$parcel$export($d551340dd0bc6b22$exports, "PERMUT", function () { return $d551340dd0bc6b22$export$ea710945dea02842; });
$parcel$export($d551340dd0bc6b22$exports, "FACT", function () { return $d551340dd0bc6b22$export$1bc9a132a62c6e03; });
$parcel$export($d551340dd0bc6b22$exports, "PERMUTATIONA", function () { return $d551340dd0bc6b22$export$c2415ce19509f698; });
$parcel$export($d551340dd0bc6b22$exports, "PHI", function () { return $d551340dd0bc6b22$export$ed904dc4011d96f7; });
$parcel$export($d551340dd0bc6b22$exports, "POISSON", function () { return $d551340dd0bc6b22$export$211723024797c6fd; });
$parcel$export($d551340dd0bc6b22$exports, "PROB", function () { return $d551340dd0bc6b22$export$7d87bd18ca5227de; });
$parcel$export($d551340dd0bc6b22$exports, "QUARTILE", function () { return $d551340dd0bc6b22$export$71cc92a67a8a2333; });
$parcel$export($d551340dd0bc6b22$exports, "RANK", function () { return $d551340dd0bc6b22$export$c3d7e0f1e63de60e; });
$parcel$export($d551340dd0bc6b22$exports, "ROW", function () { return $d551340dd0bc6b22$export$7d8b172d5f206b6c; });
$parcel$export($d551340dd0bc6b22$exports, "RSQ", function () { return $d551340dd0bc6b22$export$c49b46aab5b1bfa2; });
$parcel$export($d551340dd0bc6b22$exports, "SKEW", function () { return $d551340dd0bc6b22$export$30bba9af0267eaf4; });
$parcel$export($d551340dd0bc6b22$exports, "SLOPE", function () { return $d551340dd0bc6b22$export$96a3e1966949ddef; });
$parcel$export($d551340dd0bc6b22$exports, "SMALL", function () { return $d551340dd0bc6b22$export$71dd4c8ecd45e95f; });
$parcel$export($d551340dd0bc6b22$exports, "STANDARDIZE", function () { return $d551340dd0bc6b22$export$c20cef9c655bc59f; });
$parcel$export($d551340dd0bc6b22$exports, "STDEV", function () { return $d551340dd0bc6b22$export$934ea05709cb9cb8; });
$parcel$export($d551340dd0bc6b22$exports, "VAR", function () { return $d551340dd0bc6b22$export$c5b2d92d160f058; });
$parcel$export($d551340dd0bc6b22$exports, "STDEVA", function () { return $d551340dd0bc6b22$export$1ab610f9bfdb0c50; });
$parcel$export($d551340dd0bc6b22$exports, "VARA", function () { return $d551340dd0bc6b22$export$452638418686aa3e; });
$parcel$export($d551340dd0bc6b22$exports, "STDEVPA", function () { return $d551340dd0bc6b22$export$b98b3e7b6cfdbde8; });
$parcel$export($d551340dd0bc6b22$exports, "VARPA", function () { return $d551340dd0bc6b22$export$aa74bea6dd13056; });
$parcel$export($d551340dd0bc6b22$exports, "STEYX", function () { return $d551340dd0bc6b22$export$49c1f763fe0ea02b; });
$parcel$export($d551340dd0bc6b22$exports, "TREND", function () { return $d551340dd0bc6b22$export$4c516a8fc940158d; });
$parcel$export($d551340dd0bc6b22$exports, "TRIMMEAN", function () { return $d551340dd0bc6b22$export$961bf5c84a206df; });
$parcel$export($d551340dd0bc6b22$exports, "FLOOR", function () { return $d551340dd0bc6b22$export$a474b8effcd46ae5; });
$parcel$export($d551340dd0bc6b22$exports, "WEIBULL", function () { return $d551340dd0bc6b22$export$dd03fb262934220c; });
$parcel$export($d551340dd0bc6b22$exports, "Z", function () { return $d551340dd0bc6b22$export$dc98b0b04f4c7758; });
$parcel$export($d551340dd0bc6b22$exports, "ABS", function () { return $d551340dd0bc6b22$export$3f020f6dcff67a1b; });
$parcel$export($d551340dd0bc6b22$exports, "ACOS", function () { return $d551340dd0bc6b22$export$93d59d9ca8b49d; });
$parcel$export($d551340dd0bc6b22$exports, "ACOSH", function () { return $d551340dd0bc6b22$export$9c6f25a6fbdc0137; });
$parcel$export($d551340dd0bc6b22$exports, "ACOT", function () { return $d551340dd0bc6b22$export$898b40668e39499; });
$parcel$export($d551340dd0bc6b22$exports, "ACOTH", function () { return $d551340dd0bc6b22$export$fffb17a6bfaf1e53; });
$parcel$export($d551340dd0bc6b22$exports, "AGGREGATE", function () { return $d551340dd0bc6b22$export$92eda5ac44f0cd25; });
$parcel$export($d551340dd0bc6b22$exports, "PRODUCT", function () { return $d551340dd0bc6b22$export$e36553b0ff5db35a; });
$parcel$export($d551340dd0bc6b22$exports, "ARABIC", function () { return $d551340dd0bc6b22$export$f3f28ddebdd00a5; });
$parcel$export($d551340dd0bc6b22$exports, "ASIN", function () { return $d551340dd0bc6b22$export$6ec7c51a17f0c352; });
$parcel$export($d551340dd0bc6b22$exports, "ASINH", function () { return $d551340dd0bc6b22$export$86687249c3867981; });
$parcel$export($d551340dd0bc6b22$exports, "ATAN", function () { return $d551340dd0bc6b22$export$da70a3627b33824a; });
$parcel$export($d551340dd0bc6b22$exports, "ATAN2", function () { return $d551340dd0bc6b22$export$163b6b6ca8674499; });
$parcel$export($d551340dd0bc6b22$exports, "ATANH", function () { return $d551340dd0bc6b22$export$53b7683f7726544f; });
$parcel$export($d551340dd0bc6b22$exports, "BASE", function () { return $d551340dd0bc6b22$export$9e15ff8aa6bc996f; });
$parcel$export($d551340dd0bc6b22$exports, "CEILING", function () { return $d551340dd0bc6b22$export$f0c8b50ab8f753d1; });
$parcel$export($d551340dd0bc6b22$exports, "ROUND", function () { return $d551340dd0bc6b22$export$58785fc667c0c50b; });
$parcel$export($d551340dd0bc6b22$exports, "COMBINA", function () { return $d551340dd0bc6b22$export$87cc6829bc3933bb; });
$parcel$export($d551340dd0bc6b22$exports, "COS", function () { return $d551340dd0bc6b22$export$ad87d6418ee1b6f7; });
$parcel$export($d551340dd0bc6b22$exports, "COSH", function () { return $d551340dd0bc6b22$export$c482f097bea0ab1d; });
$parcel$export($d551340dd0bc6b22$exports, "COT", function () { return $d551340dd0bc6b22$export$970618f14b664447; });
$parcel$export($d551340dd0bc6b22$exports, "COTH", function () { return $d551340dd0bc6b22$export$c104510763bb4a9a; });
$parcel$export($d551340dd0bc6b22$exports, "CSC", function () { return $d551340dd0bc6b22$export$c7e023080adf60d0; });
$parcel$export($d551340dd0bc6b22$exports, "CSCH", function () { return $d551340dd0bc6b22$export$365ce9c46b484c73; });
$parcel$export($d551340dd0bc6b22$exports, "DECIMAL", function () { return $d551340dd0bc6b22$export$43447b36f1d78ee1; });
$parcel$export($d551340dd0bc6b22$exports, "DEGREES", function () { return $d551340dd0bc6b22$export$e035ae0f6b8ef5d; });
$parcel$export($d551340dd0bc6b22$exports, "EVEN", function () { return $d551340dd0bc6b22$export$e683606104f15b5e; });
$parcel$export($d551340dd0bc6b22$exports, "EXP", function () { return $d551340dd0bc6b22$export$e17bfbab9ca97165; });
$parcel$export($d551340dd0bc6b22$exports, "FACTDOUBLE", function () { return $d551340dd0bc6b22$export$b61d90bab1b87d62; });
$parcel$export($d551340dd0bc6b22$exports, "GCD", function () { return $d551340dd0bc6b22$export$49dcb9cac7f2209f; });
$parcel$export($d551340dd0bc6b22$exports, "INT", function () { return $d551340dd0bc6b22$export$160e8bdd97bfce3a; });
$parcel$export($d551340dd0bc6b22$exports, "ISO", function () { return $d551340dd0bc6b22$export$7568b915c40af082; });
$parcel$export($d551340dd0bc6b22$exports, "LCM", function () { return $d551340dd0bc6b22$export$a49d82dd4e9bea7e; });
$parcel$export($d551340dd0bc6b22$exports, "LN", function () { return $d551340dd0bc6b22$export$cd68b0482cce1c64; });
$parcel$export($d551340dd0bc6b22$exports, "LOG", function () { return $d551340dd0bc6b22$export$5bfbc7f735892ffd; });
$parcel$export($d551340dd0bc6b22$exports, "LOG10", function () { return $d551340dd0bc6b22$export$477e99aa3321d32f; });
$parcel$export($d551340dd0bc6b22$exports, "MMULT", function () { return $d551340dd0bc6b22$export$ed61442476b2a1c5; });
$parcel$export($d551340dd0bc6b22$exports, "MOD", function () { return $d551340dd0bc6b22$export$4c64c06afd02bfd3; });
$parcel$export($d551340dd0bc6b22$exports, "MROUND", function () { return $d551340dd0bc6b22$export$a74ae6b3fefc2d0a; });
$parcel$export($d551340dd0bc6b22$exports, "MULTINOMIAL", function () { return $d551340dd0bc6b22$export$89db55406475366f; });
$parcel$export($d551340dd0bc6b22$exports, "MUNIT", function () { return $d551340dd0bc6b22$export$1cdcc8208c58b690; });
$parcel$export($d551340dd0bc6b22$exports, "ODD", function () { return $d551340dd0bc6b22$export$9254a0c7a34901b; });
$parcel$export($d551340dd0bc6b22$exports, "PI", function () { return $d551340dd0bc6b22$export$6b5c1ceb16d01dc3; });
$parcel$export($d551340dd0bc6b22$exports, "POWER", function () { return $d551340dd0bc6b22$export$be706c8e2fc01f1e; });
$parcel$export($d551340dd0bc6b22$exports, "QUOTIENT", function () { return $d551340dd0bc6b22$export$ec8b5e8af73ad056; });
$parcel$export($d551340dd0bc6b22$exports, "RADIANS", function () { return $d551340dd0bc6b22$export$fd1bf64c4a4ea04a; });
$parcel$export($d551340dd0bc6b22$exports, "RAND", function () { return $d551340dd0bc6b22$export$4e7c67dedeed1227; });
$parcel$export($d551340dd0bc6b22$exports, "RANDBETWEEN", function () { return $d551340dd0bc6b22$export$61958e7e9517fa35; });
$parcel$export($d551340dd0bc6b22$exports, "ROMAN", function () { return $d551340dd0bc6b22$export$7baddb2e10b0df81; });
$parcel$export($d551340dd0bc6b22$exports, "ROUNDDOWN", function () { return $d551340dd0bc6b22$export$6a650594f8ffefb4; });
$parcel$export($d551340dd0bc6b22$exports, "ROUNDUP", function () { return $d551340dd0bc6b22$export$b7446e455e0657e; });
$parcel$export($d551340dd0bc6b22$exports, "SEC", function () { return $d551340dd0bc6b22$export$ee4fb2f71ac0a6f3; });
$parcel$export($d551340dd0bc6b22$exports, "SECH", function () { return $d551340dd0bc6b22$export$28c0f049ac3db384; });
$parcel$export($d551340dd0bc6b22$exports, "SERIESSUM", function () { return $d551340dd0bc6b22$export$ce8517f205412e66; });
$parcel$export($d551340dd0bc6b22$exports, "SIGN", function () { return $d551340dd0bc6b22$export$df2ead8b55b621ca; });
$parcel$export($d551340dd0bc6b22$exports, "SIN", function () { return $d551340dd0bc6b22$export$f7b80159cec397e9; });
$parcel$export($d551340dd0bc6b22$exports, "SINH", function () { return $d551340dd0bc6b22$export$521907ef58177e6d; });
$parcel$export($d551340dd0bc6b22$exports, "SQRT", function () { return $d551340dd0bc6b22$export$e70e87d56a2384f6; });
$parcel$export($d551340dd0bc6b22$exports, "SQRTPI", function () { return $d551340dd0bc6b22$export$8dee1226a39c0df9; });
$parcel$export($d551340dd0bc6b22$exports, "SUBTOTAL", function () { return $d551340dd0bc6b22$export$cf76db510f91e229; });
$parcel$export($d551340dd0bc6b22$exports, "SUMIF", function () { return $d551340dd0bc6b22$export$1cbee7f6af20ac15; });
$parcel$export($d551340dd0bc6b22$exports, "SUMIFS", function () { return $d551340dd0bc6b22$export$a73d3a96cd302f2d; });
$parcel$export($d551340dd0bc6b22$exports, "SUMPRODUCT", function () { return $d551340dd0bc6b22$export$2c36d5634aed7202; });
$parcel$export($d551340dd0bc6b22$exports, "SUMSQ", function () { return $d551340dd0bc6b22$export$34759eda0f9d3329; });
$parcel$export($d551340dd0bc6b22$exports, "SUMX2MY2", function () { return $d551340dd0bc6b22$export$459320e8dc6bab36; });
$parcel$export($d551340dd0bc6b22$exports, "SUMX2PY2", function () { return $d551340dd0bc6b22$export$a6269694a00b927c; });
$parcel$export($d551340dd0bc6b22$exports, "SUMXMY2", function () { return $d551340dd0bc6b22$export$3d335ca4359cd239; });
$parcel$export($d551340dd0bc6b22$exports, "TAN", function () { return $d551340dd0bc6b22$export$1f10d7019617b9d9; });
$parcel$export($d551340dd0bc6b22$exports, "TANH", function () { return $d551340dd0bc6b22$export$243800e3aac0e175; });
$parcel$export($d551340dd0bc6b22$exports, "TRUNC", function () { return $d551340dd0bc6b22$export$144f89cfbad1b927; });
$parcel$export($d551340dd0bc6b22$exports, "DATE", function () { return $d551340dd0bc6b22$export$501a7fac1df67a49; });
$parcel$export($d551340dd0bc6b22$exports, "DATEDIF", function () { return $d551340dd0bc6b22$export$6f5ad06e6a29fbac; });
$parcel$export($d551340dd0bc6b22$exports, "YEARFRAC", function () { return $d551340dd0bc6b22$export$469c0023d0dca9cc; });
$parcel$export($d551340dd0bc6b22$exports, "DAYS", function () { return $d551340dd0bc6b22$export$b387b66963374517; });
$parcel$export($d551340dd0bc6b22$exports, "DATEVALUE", function () { return $d551340dd0bc6b22$export$e3f09fa020f269c7; });
$parcel$export($d551340dd0bc6b22$exports, "DAY", function () { return $d551340dd0bc6b22$export$1a58b8d7f494dd72; });
$parcel$export($d551340dd0bc6b22$exports, "DAYS360", function () { return $d551340dd0bc6b22$export$4c238f3198b1a02b; });
$parcel$export($d551340dd0bc6b22$exports, "EDATE", function () { return $d551340dd0bc6b22$export$52383d62d4929c09; });
$parcel$export($d551340dd0bc6b22$exports, "EOMONTH", function () { return $d551340dd0bc6b22$export$22e9b578c796b59c; });
$parcel$export($d551340dd0bc6b22$exports, "HOUR", function () { return $d551340dd0bc6b22$export$1bf939ebcf31ef0e; });
$parcel$export($d551340dd0bc6b22$exports, "ISOWEEKNUM", function () { return $d551340dd0bc6b22$export$c265b26ff2341555; });
$parcel$export($d551340dd0bc6b22$exports, "MINUTE", function () { return $d551340dd0bc6b22$export$f4aba04677f37907; });
$parcel$export($d551340dd0bc6b22$exports, "MONTH", function () { return $d551340dd0bc6b22$export$fa5253a4540f3e3a; });
$parcel$export($d551340dd0bc6b22$exports, "NETWORKDAYS", function () { return $d551340dd0bc6b22$export$b029795fd7335958; });
$parcel$export($d551340dd0bc6b22$exports, "NOW", function () { return $d551340dd0bc6b22$export$ecb408e1f47ed474; });
$parcel$export($d551340dd0bc6b22$exports, "SECOND", function () { return $d551340dd0bc6b22$export$6879ea1c217f4705; });
$parcel$export($d551340dd0bc6b22$exports, "TIME", function () { return $d551340dd0bc6b22$export$a9905336c0111a3a; });
$parcel$export($d551340dd0bc6b22$exports, "TIMEVALUE", function () { return $d551340dd0bc6b22$export$9119f65cecd8ea41; });
$parcel$export($d551340dd0bc6b22$exports, "TODAY", function () { return $d551340dd0bc6b22$export$ee6bbe0a973ca0e8; });
$parcel$export($d551340dd0bc6b22$exports, "WEEKDAY", function () { return $d551340dd0bc6b22$export$7fe5411a648bea7f; });
$parcel$export($d551340dd0bc6b22$exports, "WEEKNUM", function () { return $d551340dd0bc6b22$export$c53a71708078a608; });
$parcel$export($d551340dd0bc6b22$exports, "WORKDAY", function () { return $d551340dd0bc6b22$export$4ddd5a796076b49d; });
$parcel$export($d551340dd0bc6b22$exports, "YEAR", function () { return $d551340dd0bc6b22$export$90b88dc425a06a95; });
$parcel$export($d551340dd0bc6b22$exports, "ASC", function () { return $d551340dd0bc6b22$export$1dee026a19752d6b; });
$parcel$export($d551340dd0bc6b22$exports, "BAHTTEXT", function () { return $d551340dd0bc6b22$export$e7679198a05bddc; });
$parcel$export($d551340dd0bc6b22$exports, "CHAR", function () { return $d551340dd0bc6b22$export$9e88d7b6f62f62d8; });
$parcel$export($d551340dd0bc6b22$exports, "CLEAN", function () { return $d551340dd0bc6b22$export$1a70fabcf70df0f5; });
$parcel$export($d551340dd0bc6b22$exports, "CODE", function () { return $d551340dd0bc6b22$export$ec5856072852bd7f; });
$parcel$export($d551340dd0bc6b22$exports, "CONCATENATE", function () { return $d551340dd0bc6b22$export$2d2ef0054f30ceed; });
$parcel$export($d551340dd0bc6b22$exports, "CONCAT", function () { return $d551340dd0bc6b22$export$fe5af3d848732bd3; });
$parcel$export($d551340dd0bc6b22$exports, "DBCS", function () { return $d551340dd0bc6b22$export$1cb53a9941f23c6a; });
$parcel$export($d551340dd0bc6b22$exports, "DOLLAR", function () { return $d551340dd0bc6b22$export$563e3b645087c0be; });
$parcel$export($d551340dd0bc6b22$exports, "EXACT", function () { return $d551340dd0bc6b22$export$19f02e163da4b67e; });
$parcel$export($d551340dd0bc6b22$exports, "FIND", function () { return $d551340dd0bc6b22$export$9b025dd6d5ee90f5; });
$parcel$export($d551340dd0bc6b22$exports, "FIXED", function () { return $d551340dd0bc6b22$export$91f67f1eeaea8c1e; });
$parcel$export($d551340dd0bc6b22$exports, "LEFT", function () { return $d551340dd0bc6b22$export$f981f70d61d1405a; });
$parcel$export($d551340dd0bc6b22$exports, "LEN", function () { return $d551340dd0bc6b22$export$bae2ad8fd7fda845; });
$parcel$export($d551340dd0bc6b22$exports, "LOWER", function () { return $d551340dd0bc6b22$export$d4cd28f22384990c; });
$parcel$export($d551340dd0bc6b22$exports, "MID", function () { return $d551340dd0bc6b22$export$4f043a3416231551; });
$parcel$export($d551340dd0bc6b22$exports, "NUMBERVALUE", function () { return $d551340dd0bc6b22$export$9c0adca74e57bd47; });
$parcel$export($d551340dd0bc6b22$exports, "PRONETIC", function () { return $d551340dd0bc6b22$export$49f3cee18396bf51; });
$parcel$export($d551340dd0bc6b22$exports, "PROPER", function () { return $d551340dd0bc6b22$export$5bdbd7463cc56933; });
$parcel$export($d551340dd0bc6b22$exports, "REPLACE", function () { return $d551340dd0bc6b22$export$412b24539e92ced; });
$parcel$export($d551340dd0bc6b22$exports, "REPT", function () { return $d551340dd0bc6b22$export$7f0fdfd63ecad857; });
$parcel$export($d551340dd0bc6b22$exports, "RIGHT", function () { return $d551340dd0bc6b22$export$1cac5500365a4eb4; });
$parcel$export($d551340dd0bc6b22$exports, "SEARCH", function () { return $d551340dd0bc6b22$export$a6b9aaee40d49fd0; });
$parcel$export($d551340dd0bc6b22$exports, "SUBSTITUTE", function () { return $d551340dd0bc6b22$export$1b6a91b61efa0da2; });
$parcel$export($d551340dd0bc6b22$exports, "T", function () { return $d551340dd0bc6b22$export$971d5caa766a69d7; });
$parcel$export($d551340dd0bc6b22$exports, "TEXT", function () { return $d551340dd0bc6b22$export$d597759d33be802e; });
$parcel$export($d551340dd0bc6b22$exports, "TEXTJOIN", function () { return $d551340dd0bc6b22$export$cfce14253d26f795; });
$parcel$export($d551340dd0bc6b22$exports, "TRIM", function () { return $d551340dd0bc6b22$export$577d861f98808551; });
$parcel$export($d551340dd0bc6b22$exports, "UNICHAR", function () { return $d551340dd0bc6b22$export$e8c7bfe2ce3f8def; });
$parcel$export($d551340dd0bc6b22$exports, "UNICODE", function () { return $d551340dd0bc6b22$export$d81a7ed8ee682bb4; });
$parcel$export($d551340dd0bc6b22$exports, "UPPER", function () { return $d551340dd0bc6b22$export$ad7946da0f0f129b; });
$parcel$export($d551340dd0bc6b22$exports, "VALUE", function () { return $d551340dd0bc6b22$export$764bd63f4c2043a2; });
$parcel$export($d551340dd0bc6b22$exports, "BESSELI", function () { return $d551340dd0bc6b22$export$32c238d501396c40; });
$parcel$export($d551340dd0bc6b22$exports, "BESSELJ", function () { return $d551340dd0bc6b22$export$f9aa6cf5fbe104e; });
$parcel$export($d551340dd0bc6b22$exports, "BESSELK", function () { return $d551340dd0bc6b22$export$d97c5c2b0f3bb088; });
$parcel$export($d551340dd0bc6b22$exports, "BESSELY", function () { return $d551340dd0bc6b22$export$f612c0749d033368; });
$parcel$export($d551340dd0bc6b22$exports, "BIN2DEC", function () { return $d551340dd0bc6b22$export$4fd785b90b90f38f; });
$parcel$export($d551340dd0bc6b22$exports, "BIN2HEX", function () { return $d551340dd0bc6b22$export$d23b80a3eff10ba2; });
$parcel$export($d551340dd0bc6b22$exports, "BIN2OCT", function () { return $d551340dd0bc6b22$export$a47924ed132a6df6; });
$parcel$export($d551340dd0bc6b22$exports, "BITAND", function () { return $d551340dd0bc6b22$export$38b1d3aa5bd1a856; });
$parcel$export($d551340dd0bc6b22$exports, "BITLSHIFT", function () { return $d551340dd0bc6b22$export$b72eadc462d1b657; });
$parcel$export($d551340dd0bc6b22$exports, "BITOR", function () { return $d551340dd0bc6b22$export$2426f753a06b3eb6; });
$parcel$export($d551340dd0bc6b22$exports, "BITRSHIFT", function () { return $d551340dd0bc6b22$export$277323301bcccbfe; });
$parcel$export($d551340dd0bc6b22$exports, "BITXOR", function () { return $d551340dd0bc6b22$export$eb46b678d25dff75; });
$parcel$export($d551340dd0bc6b22$exports, "COMPLEX", function () { return $d551340dd0bc6b22$export$82ec7cdb62c32775; });
$parcel$export($d551340dd0bc6b22$exports, "CONVERT", function () { return $d551340dd0bc6b22$export$10aee17dc6459cc7; });
$parcel$export($d551340dd0bc6b22$exports, "DEC2BIN", function () { return $d551340dd0bc6b22$export$34b329599307d22e; });
$parcel$export($d551340dd0bc6b22$exports, "DEC2HEX", function () { return $d551340dd0bc6b22$export$ad5283b633ba7d15; });
$parcel$export($d551340dd0bc6b22$exports, "DEC2OCT", function () { return $d551340dd0bc6b22$export$444a31d8dc139219; });
$parcel$export($d551340dd0bc6b22$exports, "DELTA", function () { return $d551340dd0bc6b22$export$d971781c6009eb20; });
$parcel$export($d551340dd0bc6b22$exports, "ERF", function () { return $d551340dd0bc6b22$export$7efc564e3fb93878; });
$parcel$export($d551340dd0bc6b22$exports, "ERFC", function () { return $d551340dd0bc6b22$export$65027249abea691b; });
$parcel$export($d551340dd0bc6b22$exports, "GESTEP", function () { return $d551340dd0bc6b22$export$d65f525a890a7184; });
$parcel$export($d551340dd0bc6b22$exports, "HEX2BIN", function () { return $d551340dd0bc6b22$export$ed0ea43d3ab85380; });
$parcel$export($d551340dd0bc6b22$exports, "HEX2DEC", function () { return $d551340dd0bc6b22$export$5e19714337bdbf85; });
$parcel$export($d551340dd0bc6b22$exports, "HEX2OCT", function () { return $d551340dd0bc6b22$export$d6808101a3ffb321; });
$parcel$export($d551340dd0bc6b22$exports, "IMABS", function () { return $d551340dd0bc6b22$export$46094a6772749520; });
$parcel$export($d551340dd0bc6b22$exports, "IMREAL", function () { return $d551340dd0bc6b22$export$1497846afdf2dfce; });
$parcel$export($d551340dd0bc6b22$exports, "IMAGINARY", function () { return $d551340dd0bc6b22$export$69436ce25fb43214; });
$parcel$export($d551340dd0bc6b22$exports, "IMARGUMENT", function () { return $d551340dd0bc6b22$export$4889e74d25ccf5e8; });
$parcel$export($d551340dd0bc6b22$exports, "IMCONJUGATE", function () { return $d551340dd0bc6b22$export$10b559c86b2f1b43; });
$parcel$export($d551340dd0bc6b22$exports, "IMCOS", function () { return $d551340dd0bc6b22$export$e502d9f25230b2e3; });
$parcel$export($d551340dd0bc6b22$exports, "IMCOSH", function () { return $d551340dd0bc6b22$export$750ed5a2dc1052d; });
$parcel$export($d551340dd0bc6b22$exports, "IMCOT", function () { return $d551340dd0bc6b22$export$e0422ec6c6d9f787; });
$parcel$export($d551340dd0bc6b22$exports, "IMDIV", function () { return $d551340dd0bc6b22$export$47b7f15481cf756b; });
$parcel$export($d551340dd0bc6b22$exports, "IMSIN", function () { return $d551340dd0bc6b22$export$976939413ef99c10; });
$parcel$export($d551340dd0bc6b22$exports, "IMEXP", function () { return $d551340dd0bc6b22$export$55a99da07f2fd182; });
$parcel$export($d551340dd0bc6b22$exports, "IMLN", function () { return $d551340dd0bc6b22$export$73698fc10b803367; });
$parcel$export($d551340dd0bc6b22$exports, "IMLOG10", function () { return $d551340dd0bc6b22$export$5b1db36f97d127fc; });
$parcel$export($d551340dd0bc6b22$exports, "IMLOG2", function () { return $d551340dd0bc6b22$export$cd7439d59b97f73c; });
$parcel$export($d551340dd0bc6b22$exports, "IMPOWER", function () { return $d551340dd0bc6b22$export$5b1acd18296d98d6; });
$parcel$export($d551340dd0bc6b22$exports, "IMPRODUCT", function () { return $d551340dd0bc6b22$export$be29ef149efc3154; });
$parcel$export($d551340dd0bc6b22$exports, "IMSEC", function () { return $d551340dd0bc6b22$export$d9061b1ff96022c; });
$parcel$export($d551340dd0bc6b22$exports, "IMSECH", function () { return $d551340dd0bc6b22$export$1f1ebe8d7f0b1968; });
$parcel$export($d551340dd0bc6b22$exports, "IMSINH", function () { return $d551340dd0bc6b22$export$228d15200a0f74ed; });
$parcel$export($d551340dd0bc6b22$exports, "IMSQRT", function () { return $d551340dd0bc6b22$export$103927f37ad91a63; });
$parcel$export($d551340dd0bc6b22$exports, "IMCSC", function () { return $d551340dd0bc6b22$export$e24402469d27f293; });
$parcel$export($d551340dd0bc6b22$exports, "IMCSCH", function () { return $d551340dd0bc6b22$export$444df6e620af4abe; });
$parcel$export($d551340dd0bc6b22$exports, "IMSUB", function () { return $d551340dd0bc6b22$export$fc795640df08b0be; });
$parcel$export($d551340dd0bc6b22$exports, "IMSUM", function () { return $d551340dd0bc6b22$export$94a473d1e2755616; });
$parcel$export($d551340dd0bc6b22$exports, "IMTAN", function () { return $d551340dd0bc6b22$export$dbd871e5c2755c62; });
$parcel$export($d551340dd0bc6b22$exports, "OCT2BIN", function () { return $d551340dd0bc6b22$export$169408818577a3c8; });
$parcel$export($d551340dd0bc6b22$exports, "OCT2DEC", function () { return $d551340dd0bc6b22$export$3224fb9ba404646c; });
$parcel$export($d551340dd0bc6b22$exports, "OCT2HEX", function () { return $d551340dd0bc6b22$export$5e4216ebcfc52aa; });
$parcel$export($d551340dd0bc6b22$exports, "BETADIST", function () { return $d551340dd0bc6b22$export$d4ac9ee68493c89c; });
$parcel$export($d551340dd0bc6b22$exports, "BETAINV", function () { return $d551340dd0bc6b22$export$d86b9741d4fe4fec; });
$parcel$export($d551340dd0bc6b22$exports, "BINOMDIST", function () { return $d551340dd0bc6b22$export$9239a21337c314d3; });
$parcel$export($d551340dd0bc6b22$exports, "CEILINGMATH", function () { return $d551340dd0bc6b22$export$4d27e1668cf17046; });
$parcel$export($d551340dd0bc6b22$exports, "CEILINGPRECISE", function () { return $d551340dd0bc6b22$export$4f1222c9afcbe154; });
$parcel$export($d551340dd0bc6b22$exports, "CHIDIST", function () { return $d551340dd0bc6b22$export$690eab5e52df1fdb; });
$parcel$export($d551340dd0bc6b22$exports, "CHIDISTRT", function () { return $d551340dd0bc6b22$export$32dcc72743997920; });
$parcel$export($d551340dd0bc6b22$exports, "CHIINV", function () { return $d551340dd0bc6b22$export$b30f43e36b9fc9a1; });
$parcel$export($d551340dd0bc6b22$exports, "CHIINVRT", function () { return $d551340dd0bc6b22$export$1b11f4ce87b7bbb0; });
$parcel$export($d551340dd0bc6b22$exports, "CHITEST", function () { return $d551340dd0bc6b22$export$21edc5a30754955f; });
$parcel$export($d551340dd0bc6b22$exports, "COVAR", function () { return $d551340dd0bc6b22$export$69f92ab90865d0ab; });
$parcel$export($d551340dd0bc6b22$exports, "COVARIANCEP", function () { return $d551340dd0bc6b22$export$7de8fad2fc88c622; });
$parcel$export($d551340dd0bc6b22$exports, "COVARIANCES", function () { return $d551340dd0bc6b22$export$f3cb1a1d646702d6; });
$parcel$export($d551340dd0bc6b22$exports, "CRITBINOM", function () { return $d551340dd0bc6b22$export$a47ba45c7497167e; });
$parcel$export($d551340dd0bc6b22$exports, "ERFCPRECISE", function () { return $d551340dd0bc6b22$export$dd18499c5cc4dc7b; });
$parcel$export($d551340dd0bc6b22$exports, "ERFPRECISE", function () { return $d551340dd0bc6b22$export$1d284e71bcb3239; });
$parcel$export($d551340dd0bc6b22$exports, "EXPONDIST", function () { return $d551340dd0bc6b22$export$2033dd314723e012; });
$parcel$export($d551340dd0bc6b22$exports, "FDIST", function () { return $d551340dd0bc6b22$export$73da131f922a0338; });
$parcel$export($d551340dd0bc6b22$exports, "FDISTRT", function () { return $d551340dd0bc6b22$export$ed51eb5fc6622e2d; });
$parcel$export($d551340dd0bc6b22$exports, "FINV", function () { return $d551340dd0bc6b22$export$5d2008c3383ab31a; });
$parcel$export($d551340dd0bc6b22$exports, "FINVRT", function () { return $d551340dd0bc6b22$export$dca1b2844c849f53; });
$parcel$export($d551340dd0bc6b22$exports, "FLOORMATH", function () { return $d551340dd0bc6b22$export$1f59f7ca7282ea05; });
$parcel$export($d551340dd0bc6b22$exports, "FLOORPRECISE", function () { return $d551340dd0bc6b22$export$99cd9e9a19272622; });
$parcel$export($d551340dd0bc6b22$exports, "FTEST", function () { return $d551340dd0bc6b22$export$c9f64cb70b4b4e2; });
$parcel$export($d551340dd0bc6b22$exports, "GAMMADIST", function () { return $d551340dd0bc6b22$export$ac4a283eaf23cdaa; });
$parcel$export($d551340dd0bc6b22$exports, "GAMMAINV", function () { return $d551340dd0bc6b22$export$f4455427964a26b4; });
$parcel$export($d551340dd0bc6b22$exports, "GAMMALNPRECISE", function () { return $d551340dd0bc6b22$export$3d84d30c7d8e5c42; });
$parcel$export($d551340dd0bc6b22$exports, "HYPGEOMDIST", function () { return $d551340dd0bc6b22$export$6a1eee4def8e90dc; });
$parcel$export($d551340dd0bc6b22$exports, "LOGINV", function () { return $d551340dd0bc6b22$export$8dd792b577fd1b72; });
$parcel$export($d551340dd0bc6b22$exports, "LOGNORMDIST", function () { return $d551340dd0bc6b22$export$53f9173e13edd594; });
$parcel$export($d551340dd0bc6b22$exports, "LOGNORMINV", function () { return $d551340dd0bc6b22$export$cddcc957df522a15; });
$parcel$export($d551340dd0bc6b22$exports, "MODEMULT", function () { return $d551340dd0bc6b22$export$d7c514b3ba758b6b; });
$parcel$export($d551340dd0bc6b22$exports, "MODESNGL", function () { return $d551340dd0bc6b22$export$ea54d65381d43aa7; });
$parcel$export($d551340dd0bc6b22$exports, "NEGBINOMDIST", function () { return $d551340dd0bc6b22$export$8f32d9c47fe2ec07; });
$parcel$export($d551340dd0bc6b22$exports, "NETWORKDAYSINTL", function () { return $d551340dd0bc6b22$export$18b3fc7b025dd104; });
$parcel$export($d551340dd0bc6b22$exports, "NORMDIST", function () { return $d551340dd0bc6b22$export$e0574f50c8901a84; });
$parcel$export($d551340dd0bc6b22$exports, "NORMINV", function () { return $d551340dd0bc6b22$export$7c93be9e749c620; });
$parcel$export($d551340dd0bc6b22$exports, "NORMSDIST", function () { return $d551340dd0bc6b22$export$30ceafc4b83b31a4; });
$parcel$export($d551340dd0bc6b22$exports, "NORMSINV", function () { return $d551340dd0bc6b22$export$f3ecde47f59a3b64; });
$parcel$export($d551340dd0bc6b22$exports, "PERCENTILEEXC", function () { return $d551340dd0bc6b22$export$b55ba8f69cc9f516; });
$parcel$export($d551340dd0bc6b22$exports, "PERCENTILEINC", function () { return $d551340dd0bc6b22$export$1592141639af97f1; });
$parcel$export($d551340dd0bc6b22$exports, "PERCENTRANKEXC", function () { return $d551340dd0bc6b22$export$2bf564ce8b23fa9a; });
$parcel$export($d551340dd0bc6b22$exports, "PERCENTRANKINC", function () { return $d551340dd0bc6b22$export$f26623bf98c5e3c7; });
$parcel$export($d551340dd0bc6b22$exports, "POISSONDIST", function () { return $d551340dd0bc6b22$export$ff681e70694f77c1; });
$parcel$export($d551340dd0bc6b22$exports, "QUARTILEEXC", function () { return $d551340dd0bc6b22$export$a3b4eb133190e86b; });
$parcel$export($d551340dd0bc6b22$exports, "QUARTILEINC", function () { return $d551340dd0bc6b22$export$125d6e72c865321e; });
$parcel$export($d551340dd0bc6b22$exports, "RANKAVG", function () { return $d551340dd0bc6b22$export$e8b59b79583b383e; });
$parcel$export($d551340dd0bc6b22$exports, "RANKEQ", function () { return $d551340dd0bc6b22$export$91bd632c18040d44; });
$parcel$export($d551340dd0bc6b22$exports, "SKEWP", function () { return $d551340dd0bc6b22$export$3a3b13bf0ec488ed; });
$parcel$export($d551340dd0bc6b22$exports, "STDEVP", function () { return $d551340dd0bc6b22$export$d9175827c5fa2860; });
$parcel$export($d551340dd0bc6b22$exports, "STDEVS", function () { return $d551340dd0bc6b22$export$aead0ff8af4d0dfa; });
$parcel$export($d551340dd0bc6b22$exports, "TDIST", function () { return $d551340dd0bc6b22$export$d870d5cac49d8b39; });
$parcel$export($d551340dd0bc6b22$exports, "TDISTRT", function () { return $d551340dd0bc6b22$export$f91567e2e14d67e9; });
$parcel$export($d551340dd0bc6b22$exports, "TINV", function () { return $d551340dd0bc6b22$export$eeb575485553b731; });
$parcel$export($d551340dd0bc6b22$exports, "TTEST", function () { return $d551340dd0bc6b22$export$8f5449ee65d97746; });
$parcel$export($d551340dd0bc6b22$exports, "VARP", function () { return $d551340dd0bc6b22$export$e835efc374b5a160; });
$parcel$export($d551340dd0bc6b22$exports, "VARS", function () { return $d551340dd0bc6b22$export$f67c1b44058594d9; });
$parcel$export($d551340dd0bc6b22$exports, "WEIBULLDIST", function () { return $d551340dd0bc6b22$export$3dd65333304d65a8; });
$parcel$export($d551340dd0bc6b22$exports, "WORKDAYINTL", function () { return $d551340dd0bc6b22$export$bb79704139cf29ff; });
$parcel$export($d551340dd0bc6b22$exports, "ZTEST", function () { return $d551340dd0bc6b22$export$bf6d693c61cfba35; });
$parcel$export($d551340dd0bc6b22$exports, "DAVERAGE", function () { return $d551340dd0bc6b22$export$1463f71cd602dfb; });
$parcel$export($d551340dd0bc6b22$exports, "DCOUNT", function () { return $d551340dd0bc6b22$export$3154afef99a63970; });
$parcel$export($d551340dd0bc6b22$exports, "DCOUNTA", function () { return $d551340dd0bc6b22$export$7ee07dc007db1e39; });
$parcel$export($d551340dd0bc6b22$exports, "DGET", function () { return $d551340dd0bc6b22$export$36583ac9c31082d4; });
$parcel$export($d551340dd0bc6b22$exports, "DMAX", function () { return $d551340dd0bc6b22$export$ea609bd07d926c66; });
$parcel$export($d551340dd0bc6b22$exports, "DMIN", function () { return $d551340dd0bc6b22$export$479c3f1fc47f92d8; });
$parcel$export($d551340dd0bc6b22$exports, "DPRODUCT", function () { return $d551340dd0bc6b22$export$dd442e8079864287; });
$parcel$export($d551340dd0bc6b22$exports, "DSTDEV", function () { return $d551340dd0bc6b22$export$2e503a91546be57d; });
$parcel$export($d551340dd0bc6b22$exports, "DSTDEVP", function () { return $d551340dd0bc6b22$export$dffdef20b30f90d1; });
$parcel$export($d551340dd0bc6b22$exports, "DSUM", function () { return $d551340dd0bc6b22$export$84e0dddd1df6335b; });
$parcel$export($d551340dd0bc6b22$exports, "DVAR", function () { return $d551340dd0bc6b22$export$2030e95dd39ffacb; });
$parcel$export($d551340dd0bc6b22$exports, "DVARP", function () { return $d551340dd0bc6b22$export$2298d0401fb7648b; });
$parcel$export($d551340dd0bc6b22$exports, "ACCRINT", function () { return $d551340dd0bc6b22$export$634ab1efaea5e0b2; });
$parcel$export($d551340dd0bc6b22$exports, "ACCRINTM", function () { return $d551340dd0bc6b22$export$75fe1147d890b300; });
$parcel$export($d551340dd0bc6b22$exports, "AMORDEGRC", function () { return $d551340dd0bc6b22$export$94769a7973bbb40a; });
$parcel$export($d551340dd0bc6b22$exports, "AMORLINC", function () { return $d551340dd0bc6b22$export$45667e95c57f4885; });
$parcel$export($d551340dd0bc6b22$exports, "COUPDAYBS", function () { return $d551340dd0bc6b22$export$8ec3d98fa4852ac4; });
$parcel$export($d551340dd0bc6b22$exports, "COUPDAYS", function () { return $d551340dd0bc6b22$export$956a8a3476ed51d; });
$parcel$export($d551340dd0bc6b22$exports, "COUPDAYSNC", function () { return $d551340dd0bc6b22$export$b11738792f1f9329; });
$parcel$export($d551340dd0bc6b22$exports, "COUPNCD", function () { return $d551340dd0bc6b22$export$476ab0cdf7812c3e; });
$parcel$export($d551340dd0bc6b22$exports, "COUPNUM", function () { return $d551340dd0bc6b22$export$139b9615dc97d378; });
$parcel$export($d551340dd0bc6b22$exports, "COUPPCD", function () { return $d551340dd0bc6b22$export$eaa53d7b6cede71f; });
$parcel$export($d551340dd0bc6b22$exports, "CUMIPMT", function () { return $d551340dd0bc6b22$export$467217ed336d38e6; });
$parcel$export($d551340dd0bc6b22$exports, "PMT", function () { return $d551340dd0bc6b22$export$57281459c9c05a49; });
$parcel$export($d551340dd0bc6b22$exports, "FV", function () { return $d551340dd0bc6b22$export$5969d82d45b8b86c; });
$parcel$export($d551340dd0bc6b22$exports, "CUMPRINC", function () { return $d551340dd0bc6b22$export$7f3e1b7b222ac0a7; });
$parcel$export($d551340dd0bc6b22$exports, "DB", function () { return $d551340dd0bc6b22$export$c71782fb18623f93; });
$parcel$export($d551340dd0bc6b22$exports, "DDB", function () { return $d551340dd0bc6b22$export$749a741759bf1ee1; });
$parcel$export($d551340dd0bc6b22$exports, "DISC", function () { return $d551340dd0bc6b22$export$174c38d98ccdc6e4; });
$parcel$export($d551340dd0bc6b22$exports, "DOLLARDE", function () { return $d551340dd0bc6b22$export$12e495d28a93a9d9; });
$parcel$export($d551340dd0bc6b22$exports, "DOLLARFR", function () { return $d551340dd0bc6b22$export$3c144424bf648375; });
$parcel$export($d551340dd0bc6b22$exports, "DURATION", function () { return $d551340dd0bc6b22$export$bacc88974c736870; });
$parcel$export($d551340dd0bc6b22$exports, "EFFECT", function () { return $d551340dd0bc6b22$export$4afca9a08097ec4f; });
$parcel$export($d551340dd0bc6b22$exports, "FVSCHEDULE", function () { return $d551340dd0bc6b22$export$94c83dfbae052f4b; });
$parcel$export($d551340dd0bc6b22$exports, "INTRATE", function () { return $d551340dd0bc6b22$export$f66352698c434da6; });
$parcel$export($d551340dd0bc6b22$exports, "IPMT", function () { return $d551340dd0bc6b22$export$60d0f5ab72a44b8b; });
$parcel$export($d551340dd0bc6b22$exports, "IRR", function () { return $d551340dd0bc6b22$export$687b78831fd2914a; });
$parcel$export($d551340dd0bc6b22$exports, "ISPMT", function () { return $d551340dd0bc6b22$export$fb43bbe87ae38cf5; });
$parcel$export($d551340dd0bc6b22$exports, "MDURATION", function () { return $d551340dd0bc6b22$export$28a3b9016cb38ab7; });
$parcel$export($d551340dd0bc6b22$exports, "MIRR", function () { return $d551340dd0bc6b22$export$8fb6ec0c845ae070; });
$parcel$export($d551340dd0bc6b22$exports, "NPV", function () { return $d551340dd0bc6b22$export$39ba90e9124b524f; });
$parcel$export($d551340dd0bc6b22$exports, "NOMINAL", function () { return $d551340dd0bc6b22$export$afc8e5e6aacf465b; });
$parcel$export($d551340dd0bc6b22$exports, "NPER", function () { return $d551340dd0bc6b22$export$58685c02fadb4371; });
$parcel$export($d551340dd0bc6b22$exports, "ODDFPRICE", function () { return $d551340dd0bc6b22$export$3681729390d233b7; });
$parcel$export($d551340dd0bc6b22$exports, "ODDFYIELD", function () { return $d551340dd0bc6b22$export$37e7b13394d43765; });
$parcel$export($d551340dd0bc6b22$exports, "ODDLPRICE", function () { return $d551340dd0bc6b22$export$c769cc4381ca7dcb; });
$parcel$export($d551340dd0bc6b22$exports, "ODDLYIELD", function () { return $d551340dd0bc6b22$export$99d22f8c2a60177c; });
$parcel$export($d551340dd0bc6b22$exports, "PDURATION", function () { return $d551340dd0bc6b22$export$be647f34ee179222; });
$parcel$export($d551340dd0bc6b22$exports, "PPMT", function () { return $d551340dd0bc6b22$export$738ea20bb0da5e5e; });
$parcel$export($d551340dd0bc6b22$exports, "PRICE", function () { return $d551340dd0bc6b22$export$9ae64641f60b8192; });
$parcel$export($d551340dd0bc6b22$exports, "PRICEDISC", function () { return $d551340dd0bc6b22$export$ec3956fa37eba432; });
$parcel$export($d551340dd0bc6b22$exports, "PRICEMAT", function () { return $d551340dd0bc6b22$export$27bacd2b7c9baee1; });
$parcel$export($d551340dd0bc6b22$exports, "PV", function () { return $d551340dd0bc6b22$export$28696ec05f36becc; });
$parcel$export($d551340dd0bc6b22$exports, "RATE", function () { return $d551340dd0bc6b22$export$9bed8ce5eac631df; });
$parcel$export($d551340dd0bc6b22$exports, "RECEIVED", function () { return $d551340dd0bc6b22$export$67d3fe90edbf2534; });
$parcel$export($d551340dd0bc6b22$exports, "RRI", function () { return $d551340dd0bc6b22$export$aabc2a21320198eb; });
$parcel$export($d551340dd0bc6b22$exports, "SLN", function () { return $d551340dd0bc6b22$export$4fcd0eda4cbba23; });
$parcel$export($d551340dd0bc6b22$exports, "SYD", function () { return $d551340dd0bc6b22$export$16db5d1d1061102f; });
$parcel$export($d551340dd0bc6b22$exports, "TBILLEQ", function () { return $d551340dd0bc6b22$export$4456e4a8edf0d90f; });
$parcel$export($d551340dd0bc6b22$exports, "TBILLPRICE", function () { return $d551340dd0bc6b22$export$b743c1bda609b4a9; });
$parcel$export($d551340dd0bc6b22$exports, "TBILLYIELD", function () { return $d551340dd0bc6b22$export$eb29a9ff23ca2e16; });
$parcel$export($d551340dd0bc6b22$exports, "VDB", function () { return $d551340dd0bc6b22$export$3560c8e5f2ddae5e; });
$parcel$export($d551340dd0bc6b22$exports, "XIRR", function () { return $d551340dd0bc6b22$export$e1abef9a5d16b70d; });
$parcel$export($d551340dd0bc6b22$exports, "XNPV", function () { return $d551340dd0bc6b22$export$931e6356776c4bb; });
$parcel$export($d551340dd0bc6b22$exports, "YIELD", function () { return $d551340dd0bc6b22$export$517303f73652ea8c; });
$parcel$export($d551340dd0bc6b22$exports, "YIELDDISC", function () { return $d551340dd0bc6b22$export$912ca7f764dee059; });
$parcel$export($d551340dd0bc6b22$exports, "YIELDMAT", function () { return $d551340dd0bc6b22$export$289f491c280c7a1c; });
$parcel$export($d551340dd0bc6b22$exports, "AND", function () { return $d551340dd0bc6b22$export$327bc6c39753a713; });
$parcel$export($d551340dd0bc6b22$exports, "FALSE", function () { return $d551340dd0bc6b22$export$8f11cee4bdc7e668; });
$parcel$export($d551340dd0bc6b22$exports, "IF", function () { return $d551340dd0bc6b22$export$5749f35ae68e5477; });
$parcel$export($d551340dd0bc6b22$exports, "IFS", function () { return $d551340dd0bc6b22$export$351547f5c835becb; });
$parcel$export($d551340dd0bc6b22$exports, "IFERROR", function () { return $d551340dd0bc6b22$export$b2bc018eb0c46c7b; });
$parcel$export($d551340dd0bc6b22$exports, "IFNA", function () { return $d551340dd0bc6b22$export$ed4e98f3e064db68; });
$parcel$export($d551340dd0bc6b22$exports, "NOT", function () { return $d551340dd0bc6b22$export$9cbadbd232c00d79; });
$parcel$export($d551340dd0bc6b22$exports, "OR", function () { return $d551340dd0bc6b22$export$1e4611b5e967c90; });
$parcel$export($d551340dd0bc6b22$exports, "TRUE", function () { return $d551340dd0bc6b22$export$22e23a2304399231; });
$parcel$export($d551340dd0bc6b22$exports, "XOR", function () { return $d551340dd0bc6b22$export$3ac756b6844bf082; });
$parcel$export($d551340dd0bc6b22$exports, "SWITCH", function () { return $d551340dd0bc6b22$export$d19595eff304150b; });
$parcel$export($d551340dd0bc6b22$exports, "utils", function () { return $d551340dd0bc6b22$export$eab97d15b1788b8d; });
var $252df761458e1f74$exports = {};
(function(window, factory) {
    $252df761458e1f74$exports = factory();
})($252df761458e1f74$exports, function() {
    var jStat = function(Math1, undefined1) {
        // For quick reference.
        var concat = Array.prototype.concat;
        var slice = Array.prototype.slice;
        var toString = Object.prototype.toString;
        // Calculate correction for IEEE error
        // TODO: This calculation can be improved.
        function calcRdx(n, m) {
            var val = n > m ? n : m;
            return Math1.pow(10, 17 - ~~(Math1.log(val > 0 ? val : -val) * Math1.LOG10E));
        }
        var isArray = Array.isArray || function isArray(arg) {
            return toString.call(arg) === "[object Array]";
        };
        function isFunction(arg) {
            return toString.call(arg) === "[object Function]";
        }
        function isNumber(num) {
            return typeof num === "number" ? num - num === 0 : false;
        }
        // Converts the jStat matrix to vector.
        function toVector(arr) {
            return concat.apply([], arr);
        }
        // The one and only jStat constructor.
        function jStat() {
            return new jStat._init(arguments);
        }
        // TODO: Remove after all references in src files have been removed.
        jStat.fn = jStat.prototype;
        // By separating the initializer from the constructor it's easier to handle
        // always returning a new instance whether "new" was used or not.
        jStat._init = function _init(args) {
            // If first argument is an array, must be vector or matrix.
            if (isArray(args[0])) {
                // Check if matrix.
                if (isArray(args[0][0])) {
                    // See if a mapping function was also passed.
                    if (isFunction(args[1])) args[0] = jStat.map(args[0], args[1]);
                    // Iterate over each is faster than this.push.apply(this, args[0].
                    for(var i = 0; i < args[0].length; i++)this[i] = args[0][i];
                    this.length = args[0].length;
                // Otherwise must be a vector.
                } else {
                    this[0] = isFunction(args[1]) ? jStat.map(args[0], args[1]) : args[0];
                    this.length = 1;
                }
            } else if (isNumber(args[0])) {
                this[0] = jStat.seq.apply(null, args);
                this.length = 1;
            // Handle case when jStat object is passed to jStat.
            } else if (args[0] instanceof jStat) // Duplicate the object and pass it back.
            return jStat(args[0].toArray());
            else {
                this[0] = [];
                this.length = 1;
            }
            return this;
        };
        jStat._init.prototype = jStat.prototype;
        jStat._init.constructor = jStat;
        // Utility functions.
        // TODO: for internal use only?
        jStat.utils = {
            calcRdx: calcRdx,
            isArray: isArray,
            isFunction: isFunction,
            isNumber: isNumber,
            toVector: toVector
        };
        jStat._random_fn = Math1.random;
        jStat.setRandom = function setRandom(fn) {
            if (typeof fn !== "function") throw new TypeError("fn is not a function");
            jStat._random_fn = fn;
        };
        // Easily extend the jStat object.
        // TODO: is this seriously necessary?
        jStat.extend = function extend(obj) {
            var i, j;
            if (arguments.length === 1) {
                for(j in obj)jStat[j] = obj[j];
                return this;
            }
            for(i = 1; i < arguments.length; i++)for(j in arguments[i])obj[j] = arguments[i][j];
            return obj;
        };
        // Returns the number of rows in the matrix.
        jStat.rows = function rows(arr) {
            return arr.length || 1;
        };
        // Returns the number of columns in the matrix.
        jStat.cols = function cols(arr) {
            return arr[0].length || 1;
        };
        // Returns the dimensions of the object { rows: i, cols: j }
        jStat.dimensions = function dimensions(arr) {
            return {
                rows: jStat.rows(arr),
                cols: jStat.cols(arr)
            };
        };
        // Returns a specified row as a vector or return a sub matrix by pick some rows
        jStat.row = function row(arr, index) {
            if (isArray(index)) return index.map(function(i) {
                return jStat.row(arr, i);
            });
            return arr[index];
        };
        // return row as array
        // rowa([[1,2],[3,4]],0) -> [1,2]
        jStat.rowa = function rowa(arr, i) {
            return jStat.row(arr, i);
        };
        // Returns the specified column as a vector or return a sub matrix by pick some
        // columns
        jStat.col = function col(arr, index) {
            if (isArray(index)) {
                var submat = jStat.arange(arr.length).map(function() {
                    return new Array(index.length);
                });
                index.forEach(function(ind, i) {
                    jStat.arange(arr.length).forEach(function(j) {
                        submat[j][i] = arr[j][ind];
                    });
                });
                return submat;
            }
            var column = new Array(arr.length);
            for(var i = 0; i < arr.length; i++)column[i] = [
                arr[i][index]
            ];
            return column;
        };
        // return column as array
        // cola([[1,2],[3,4]],0) -> [1,3]
        jStat.cola = function cola(arr, i) {
            return jStat.col(arr, i).map(function(a) {
                return a[0];
            });
        };
        // Returns the diagonal of the matrix
        jStat.diag = function diag(arr) {
            var nrow = jStat.rows(arr);
            var res = new Array(nrow);
            for(var row = 0; row < nrow; row++)res[row] = [
                arr[row][row]
            ];
            return res;
        };
        // Returns the anti-diagonal of the matrix
        jStat.antidiag = function antidiag(arr) {
            var nrow = jStat.rows(arr) - 1;
            var res = new Array(nrow);
            for(var i = 0; nrow >= 0; nrow--, i++)res[i] = [
                arr[i][nrow]
            ];
            return res;
        };
        // Transpose a matrix or array.
        jStat.transpose = function transpose(arr) {
            var obj = [];
            var objArr, rows, cols, j, i;
            // Make sure arr is in matrix format.
            if (!isArray(arr[0])) arr = [
                arr
            ];
            rows = arr.length;
            cols = arr[0].length;
            for(i = 0; i < cols; i++){
                objArr = new Array(rows);
                for(j = 0; j < rows; j++)objArr[j] = arr[j][i];
                obj.push(objArr);
            }
            // If obj is vector, return only single array.
            return obj.length === 1 ? obj[0] : obj;
        };
        // Map a function to an array or array of arrays.
        // "toAlter" is an internal variable.
        jStat.map = function map(arr, func, toAlter) {
            var row, nrow, ncol, res, col;
            if (!isArray(arr[0])) arr = [
                arr
            ];
            nrow = arr.length;
            ncol = arr[0].length;
            res = toAlter ? arr : new Array(nrow);
            for(row = 0; row < nrow; row++){
                // if the row doesn't exist, create it
                if (!res[row]) res[row] = new Array(ncol);
                for(col = 0; col < ncol; col++)res[row][col] = func(arr[row][col], row, col);
            }
            return res.length === 1 ? res[0] : res;
        };
        // Cumulatively combine the elements of an array or array of arrays using a function.
        jStat.cumreduce = function cumreduce(arr, func, toAlter) {
            var row, nrow, ncol, res, col;
            if (!isArray(arr[0])) arr = [
                arr
            ];
            nrow = arr.length;
            ncol = arr[0].length;
            res = toAlter ? arr : new Array(nrow);
            for(row = 0; row < nrow; row++){
                // if the row doesn't exist, create it
                if (!res[row]) res[row] = new Array(ncol);
                if (ncol > 0) res[row][0] = arr[row][0];
                for(col = 1; col < ncol; col++)res[row][col] = func(res[row][col - 1], arr[row][col]);
            }
            return res.length === 1 ? res[0] : res;
        };
        // Destructively alter an array.
        jStat.alter = function alter(arr, func) {
            return jStat.map(arr, func, true);
        };
        // Generate a rows x cols matrix according to the supplied function.
        jStat.create = function create(rows, cols, func) {
            var res = new Array(rows);
            var i, j;
            if (isFunction(cols)) {
                func = cols;
                cols = rows;
            }
            for(i = 0; i < rows; i++){
                res[i] = new Array(cols);
                for(j = 0; j < cols; j++)res[i][j] = func(i, j);
            }
            return res;
        };
        function retZero() {
            return 0;
        }
        // Generate a rows x cols matrix of zeros.
        jStat.zeros = function zeros(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, retZero);
        };
        function retOne() {
            return 1;
        }
        // Generate a rows x cols matrix of ones.
        jStat.ones = function ones(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, retOne);
        };
        // Generate a rows x cols matrix of uniformly random numbers.
        jStat.rand = function rand(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, jStat._random_fn);
        };
        function retIdent(i, j) {
            return i === j ? 1 : 0;
        }
        // Generate an identity matrix of size row x cols.
        jStat.identity = function identity(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, retIdent);
        };
        // Tests whether a matrix is symmetric
        jStat.symmetric = function symmetric(arr) {
            var size = arr.length;
            var row, col;
            if (arr.length !== arr[0].length) return false;
            for(row = 0; row < size; row++){
                for(col = 0; col < size; col++)if (arr[col][row] !== arr[row][col]) return false;
            }
            return true;
        };
        // Set all values to zero.
        jStat.clear = function clear(arr) {
            return jStat.alter(arr, retZero);
        };
        // Generate sequence.
        jStat.seq = function seq(min, max, length, func) {
            if (!isFunction(func)) func = false;
            var arr = [];
            var hival = calcRdx(min, max);
            var step = (max * hival - min * hival) / ((length - 1) * hival);
            var current = min;
            var cnt;
            // Current is assigned using a technique to compensate for IEEE error.
            // TODO: Needs better implementation.
            for(cnt = 0; current <= max && cnt < length; cnt++, current = (min * hival + step * hival * cnt) / hival)arr.push(func ? func(current, cnt) : current);
            return arr;
        };
        // arange(5) -> [0,1,2,3,4]
        // arange(1,5) -> [1,2,3,4]
        // arange(5,1,-1) -> [5,4,3,2]
        jStat.arange = function arange(start, end, step) {
            var rl = [];
            var i;
            step = step || 1;
            if (end === undefined1) {
                end = start;
                start = 0;
            }
            if (start === end || step === 0) return [];
            if (start < end && step < 0) return [];
            if (start > end && step > 0) return [];
            if (step > 0) for(i = start; i < end; i += step)rl.push(i);
            else for(i = start; i > end; i += step)rl.push(i);
            return rl;
        };
        // A=[[1,2,3],[4,5,6],[7,8,9]]
        // slice(A,{row:{end:2},col:{start:1}}) -> [[2,3],[5,6]]
        // slice(A,1,{start:1}) -> [5,6]
        // as numpy code A[:2,1:]
        jStat.slice = function() {
            function _slice(list, start, end, step) {
                // note it's not equal to range.map mode it's a bug
                var i;
                var rl = [];
                var length = list.length;
                if (start === undefined1 && end === undefined1 && step === undefined1) return jStat.copy(list);
                start = start || 0;
                end = end || list.length;
                start = start >= 0 ? start : length + start;
                end = end >= 0 ? end : length + end;
                step = step || 1;
                if (start === end || step === 0) return [];
                if (start < end && step < 0) return [];
                if (start > end && step > 0) return [];
                if (step > 0) for(i = start; i < end; i += step)rl.push(list[i]);
                else for(i = start; i > end; i += step)rl.push(list[i]);
                return rl;
            }
            function slice(list, rcSlice) {
                var colSlice, rowSlice;
                rcSlice = rcSlice || {};
                if (isNumber(rcSlice.row)) {
                    if (isNumber(rcSlice.col)) return list[rcSlice.row][rcSlice.col];
                    var row = jStat.rowa(list, rcSlice.row);
                    colSlice = rcSlice.col || {};
                    return _slice(row, colSlice.start, colSlice.end, colSlice.step);
                }
                if (isNumber(rcSlice.col)) {
                    var col = jStat.cola(list, rcSlice.col);
                    rowSlice = rcSlice.row || {};
                    return _slice(col, rowSlice.start, rowSlice.end, rowSlice.step);
                }
                rowSlice = rcSlice.row || {};
                colSlice = rcSlice.col || {};
                var rows = _slice(list, rowSlice.start, rowSlice.end, rowSlice.step);
                return rows.map(function(row) {
                    return _slice(row, colSlice.start, colSlice.end, colSlice.step);
                });
            }
            return slice;
        }();
        // A=[[1,2,3],[4,5,6],[7,8,9]]
        // sliceAssign(A,{row:{start:1},col:{start:1}},[[0,0],[0,0]])
        // A=[[1,2,3],[4,0,0],[7,0,0]]
        jStat.sliceAssign = function sliceAssign(A, rcSlice, B) {
            var nl, ml;
            if (isNumber(rcSlice.row)) {
                if (isNumber(rcSlice.col)) return A[rcSlice.row][rcSlice.col] = B;
                rcSlice.col = rcSlice.col || {};
                rcSlice.col.start = rcSlice.col.start || 0;
                rcSlice.col.end = rcSlice.col.end || A[0].length;
                rcSlice.col.step = rcSlice.col.step || 1;
                nl = jStat.arange(rcSlice.col.start, Math1.min(A.length, rcSlice.col.end), rcSlice.col.step);
                var m = rcSlice.row;
                nl.forEach(function(n, i) {
                    A[m][n] = B[i];
                });
                return A;
            }
            if (isNumber(rcSlice.col)) {
                rcSlice.row = rcSlice.row || {};
                rcSlice.row.start = rcSlice.row.start || 0;
                rcSlice.row.end = rcSlice.row.end || A.length;
                rcSlice.row.step = rcSlice.row.step || 1;
                ml = jStat.arange(rcSlice.row.start, Math1.min(A[0].length, rcSlice.row.end), rcSlice.row.step);
                var n = rcSlice.col;
                ml.forEach(function(m, j) {
                    A[m][n] = B[j];
                });
                return A;
            }
            if (B[0].length === undefined1) B = [
                B
            ];
            rcSlice.row.start = rcSlice.row.start || 0;
            rcSlice.row.end = rcSlice.row.end || A.length;
            rcSlice.row.step = rcSlice.row.step || 1;
            rcSlice.col.start = rcSlice.col.start || 0;
            rcSlice.col.end = rcSlice.col.end || A[0].length;
            rcSlice.col.step = rcSlice.col.step || 1;
            ml = jStat.arange(rcSlice.row.start, Math1.min(A.length, rcSlice.row.end), rcSlice.row.step);
            nl = jStat.arange(rcSlice.col.start, Math1.min(A[0].length, rcSlice.col.end), rcSlice.col.step);
            ml.forEach(function(m, i) {
                nl.forEach(function(n, j) {
                    A[m][n] = B[i][j];
                });
            });
            return A;
        };
        // [1,2,3] ->
        // [[1,0,0],[0,2,0],[0,0,3]]
        jStat.diagonal = function diagonal(diagArray) {
            var mat = jStat.zeros(diagArray.length, diagArray.length);
            diagArray.forEach(function(t, i) {
                mat[i][i] = t;
            });
            return mat;
        };
        // return copy of A
        jStat.copy = function copy(A) {
            return A.map(function(row) {
                if (isNumber(row)) return row;
                return row.map(function(t) {
                    return t;
                });
            });
        };
        // TODO: Go over this entire implementation. Seems a tragic waste of resources
        // doing all this work. Instead, and while ugly, use new Function() to generate
        // a custom function for each static method.
        // Quick reference.
        var jProto = jStat.prototype;
        // Default length.
        jProto.length = 0;
        // For internal use only.
        // TODO: Check if they're actually used, and if they are then rename them
        // to _*
        jProto.push = Array.prototype.push;
        jProto.sort = Array.prototype.sort;
        jProto.splice = Array.prototype.splice;
        jProto.slice = Array.prototype.slice;
        // Return a clean array.
        jProto.toArray = function toArray() {
            return this.length > 1 ? slice.call(this) : slice.call(this)[0];
        };
        // Map a function to a matrix or vector.
        jProto.map = function map(func, toAlter) {
            return jStat(jStat.map(this, func, toAlter));
        };
        // Cumulatively combine the elements of a matrix or vector using a function.
        jProto.cumreduce = function cumreduce(func, toAlter) {
            return jStat(jStat.cumreduce(this, func, toAlter));
        };
        // Destructively alter an array.
        jProto.alter = function alter(func) {
            jStat.alter(this, func);
            return this;
        };
        // Extend prototype with methods that have no argument.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function(func) {
                    var self = this, results;
                    // Check for callback.
                    if (func) {
                        setTimeout(function() {
                            func.call(self, jProto[passfunc].call(self));
                        });
                        return this;
                    }
                    results = jStat[passfunc](this);
                    return isArray(results) ? jStat(results) : results;
                };
            })(funcs[i]);
        })("transpose clear symmetric rows cols dimensions diag antidiag".split(" "));
        // Extend prototype with methods that have one argument.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function(index, func) {
                    var self = this;
                    // check for callback
                    if (func) {
                        setTimeout(function() {
                            func.call(self, jProto[passfunc].call(self, index));
                        });
                        return this;
                    }
                    return jStat(jStat[passfunc](this, index));
                };
            })(funcs[i]);
        })("row col".split(" "));
        // Extend prototype with simple shortcut methods.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function() {
                    return jStat(jStat[passfunc].apply(null, arguments));
                };
            })(funcs[i]);
        })("create zeros ones rand identity".split(" "));
        // Exposing jStat.
        return jStat;
    }(Math);
    (function(jStat, Math1) {
        var isFunction = jStat.utils.isFunction;
        // Ascending functions for sort
        function ascNum(a, b) {
            return a - b;
        }
        function clip(arg, min, max) {
            return Math1.max(min, Math1.min(arg, max));
        }
        // sum of an array
        jStat.sum = function sum(arr) {
            var sum = 0;
            var i = arr.length;
            while(--i >= 0)sum += arr[i];
            return sum;
        };
        // sum squared
        jStat.sumsqrd = function sumsqrd(arr) {
            var sum = 0;
            var i = arr.length;
            while(--i >= 0)sum += arr[i] * arr[i];
            return sum;
        };
        // sum of squared errors of prediction (SSE)
        jStat.sumsqerr = function sumsqerr(arr) {
            var mean = jStat.mean(arr);
            var sum = 0;
            var i = arr.length;
            var tmp;
            while(--i >= 0){
                tmp = arr[i] - mean;
                sum += tmp * tmp;
            }
            return sum;
        };
        // sum of an array in each row
        jStat.sumrow = function sumrow(arr) {
            var sum = 0;
            var i = arr.length;
            while(--i >= 0)sum += arr[i];
            return sum;
        };
        // product of an array
        jStat.product = function product(arr) {
            var prod = 1;
            var i = arr.length;
            while(--i >= 0)prod *= arr[i];
            return prod;
        };
        // minimum value of an array
        jStat.min = function min(arr) {
            var low = arr[0];
            var i = 0;
            while(++i < arr.length)if (arr[i] < low) low = arr[i];
            return low;
        };
        // maximum value of an array
        jStat.max = function max(arr) {
            var high = arr[0];
            var i = 0;
            while(++i < arr.length)if (arr[i] > high) high = arr[i];
            return high;
        };
        // unique values of an array
        jStat.unique = function unique(arr) {
            var hash = {}, _arr = [];
            for(var i = 0; i < arr.length; i++)if (!hash[arr[i]]) {
                hash[arr[i]] = true;
                _arr.push(arr[i]);
            }
            return _arr;
        };
        // mean value of an array
        jStat.mean = function mean(arr) {
            return jStat.sum(arr) / arr.length;
        };
        // mean squared error (MSE)
        jStat.meansqerr = function meansqerr(arr) {
            return jStat.sumsqerr(arr) / arr.length;
        };
        // geometric mean of an array
        jStat.geomean = function geomean(arr) {
            var logs = arr.map(Math1.log);
            var meanOfLogs = jStat.mean(logs);
            return Math1.exp(meanOfLogs);
        };
        // median of an array
        jStat.median = function median(arr) {
            var arrlen = arr.length;
            var _arr = arr.slice().sort(ascNum);
            // check if array is even or odd, then return the appropriate
            return !(arrlen & 1) ? (_arr[arrlen / 2 - 1] + _arr[arrlen / 2]) / 2 : _arr[arrlen / 2 | 0];
        };
        // cumulative sum of an array
        jStat.cumsum = function cumsum(arr) {
            return jStat.cumreduce(arr, function(a, b) {
                return a + b;
            });
        };
        // cumulative product of an array
        jStat.cumprod = function cumprod(arr) {
            return jStat.cumreduce(arr, function(a, b) {
                return a * b;
            });
        };
        // successive differences of a sequence
        jStat.diff = function diff(arr) {
            var diffs = [];
            var arrLen = arr.length;
            var i;
            for(i = 1; i < arrLen; i++)diffs.push(arr[i] - arr[i - 1]);
            return diffs;
        };
        // ranks of an array
        jStat.rank = function(arr) {
            var i;
            var distinctNumbers = [];
            var numberCounts = {};
            for(i = 0; i < arr.length; i++){
                var number = arr[i];
                if (numberCounts[number]) numberCounts[number]++;
                else {
                    numberCounts[number] = 1;
                    distinctNumbers.push(number);
                }
            }
            var sortedDistinctNumbers = distinctNumbers.sort(ascNum);
            var numberRanks = {};
            var currentRank = 1;
            for(i = 0; i < sortedDistinctNumbers.length; i++){
                var number = sortedDistinctNumbers[i];
                var count = numberCounts[number];
                var first = currentRank;
                var last = currentRank + count - 1;
                var rank = (first + last) / 2;
                numberRanks[number] = rank;
                currentRank += count;
            }
            return arr.map(function(number) {
                return numberRanks[number];
            });
        };
        // mode of an array
        // if there are multiple modes of an array, return all of them
        // is this the appropriate way of handling it?
        jStat.mode = function mode(arr) {
            var arrLen = arr.length;
            var _arr = arr.slice().sort(ascNum);
            var count = 1;
            var maxCount = 0;
            var numMaxCount = 0;
            var mode_arr = [];
            var i;
            for(i = 0; i < arrLen; i++)if (_arr[i] === _arr[i + 1]) count++;
            else {
                if (count > maxCount) {
                    mode_arr = [
                        _arr[i]
                    ];
                    maxCount = count;
                    numMaxCount = 0;
                } else if (count === maxCount) {
                    mode_arr.push(_arr[i]);
                    numMaxCount++;
                }
                // resetting count for new value in array
                count = 1;
            }
            return numMaxCount === 0 ? mode_arr[0] : mode_arr;
        };
        // range of an array
        jStat.range = function range(arr) {
            return jStat.max(arr) - jStat.min(arr);
        };
        // variance of an array
        // flag = true indicates sample instead of population
        jStat.variance = function variance(arr, flag) {
            return jStat.sumsqerr(arr) / (arr.length - (flag ? 1 : 0));
        };
        // pooled variance of an array of arrays
        jStat.pooledvariance = function pooledvariance(arr) {
            var sumsqerr = arr.reduce(function(a, samples) {
                return a + jStat.sumsqerr(samples);
            }, 0);
            var count = arr.reduce(function(a, samples) {
                return a + samples.length;
            }, 0);
            return sumsqerr / (count - arr.length);
        };
        // deviation of an array
        jStat.deviation = function(arr) {
            var mean = jStat.mean(arr);
            var arrlen = arr.length;
            var dev = new Array(arrlen);
            for(var i = 0; i < arrlen; i++)dev[i] = arr[i] - mean;
            return dev;
        };
        // standard deviation of an array
        // flag = true indicates sample instead of population
        jStat.stdev = function stdev(arr, flag) {
            return Math1.sqrt(jStat.variance(arr, flag));
        };
        // pooled standard deviation of an array of arrays
        jStat.pooledstdev = function pooledstdev(arr) {
            return Math1.sqrt(jStat.pooledvariance(arr));
        };
        // mean deviation (mean absolute deviation) of an array
        jStat.meandev = function meandev(arr) {
            var mean = jStat.mean(arr);
            var a = [];
            for(var i = arr.length - 1; i >= 0; i--)a.push(Math1.abs(arr[i] - mean));
            return jStat.mean(a);
        };
        // median deviation (median absolute deviation) of an array
        jStat.meddev = function meddev(arr) {
            var median = jStat.median(arr);
            var a = [];
            for(var i = arr.length - 1; i >= 0; i--)a.push(Math1.abs(arr[i] - median));
            return jStat.median(a);
        };
        // coefficient of variation
        jStat.coeffvar = function coeffvar(arr) {
            return jStat.stdev(arr) / jStat.mean(arr);
        };
        // quartiles of an array
        jStat.quartiles = function quartiles(arr) {
            var arrlen = arr.length;
            var _arr = arr.slice().sort(ascNum);
            return [
                _arr[Math1.round(arrlen / 4) - 1],
                _arr[Math1.round(arrlen / 2) - 1],
                _arr[Math1.round(arrlen * 3 / 4) - 1]
            ];
        };
        // Arbitary quantiles of an array. Direct port of the scipy.stats
        // implementation by Pierre GF Gerard-Marchant.
        jStat.quantiles = function quantiles(arr, quantilesArray, alphap, betap) {
            var sortedArray = arr.slice().sort(ascNum);
            var quantileVals = [
                quantilesArray.length
            ];
            var n = arr.length;
            var i, p, m, aleph, k, gamma;
            if (typeof alphap === "undefined") alphap = 3 / 8;
            if (typeof betap === "undefined") betap = 3 / 8;
            for(i = 0; i < quantilesArray.length; i++){
                p = quantilesArray[i];
                m = alphap + p * (1 - alphap - betap);
                aleph = n * p + m;
                k = Math1.floor(clip(aleph, 1, n - 1));
                gamma = clip(aleph - k, 0, 1);
                quantileVals[i] = (1 - gamma) * sortedArray[k - 1] + gamma * sortedArray[k];
            }
            return quantileVals;
        };
        // Return the k-th percentile of values in a range, where k is in the range 0..1, inclusive.
        // Passing true for the exclusive parameter excludes both endpoints of the range.
        jStat.percentile = function percentile(arr, k, exclusive) {
            var _arr = arr.slice().sort(ascNum);
            var realIndex = k * (_arr.length + (exclusive ? 1 : -1)) + (exclusive ? 0 : 1);
            var index = parseInt(realIndex);
            var frac = realIndex - index;
            if (index + 1 < _arr.length) return _arr[index - 1] + frac * (_arr[index] - _arr[index - 1]);
            else return _arr[index - 1];
        };
        // The percentile rank of score in a given array. Returns the percentage
        // of all values in the input array that are less than (kind='strict') or
        // less or equal than (kind='weak') score. Default is weak.
        jStat.percentileOfScore = function percentileOfScore(arr, score, kind) {
            var counter = 0;
            var len = arr.length;
            var strict = false;
            var value, i;
            if (kind === "strict") strict = true;
            for(i = 0; i < len; i++){
                value = arr[i];
                if (strict && value < score || !strict && value <= score) counter++;
            }
            return counter / len;
        };
        // Histogram (bin count) data
        jStat.histogram = function histogram(arr, binCnt) {
            binCnt = binCnt || 4;
            var first = jStat.min(arr);
            var binWidth = (jStat.max(arr) - first) / binCnt;
            var len = arr.length;
            var bins = [];
            var i;
            for(i = 0; i < binCnt; i++)bins[i] = 0;
            for(i = 0; i < len; i++)bins[Math1.min(Math1.floor((arr[i] - first) / binWidth), binCnt - 1)] += 1;
            return bins;
        };
        // covariance of two arrays
        jStat.covariance = function covariance(arr1, arr2) {
            var u = jStat.mean(arr1);
            var v = jStat.mean(arr2);
            var arr1Len = arr1.length;
            var sq_dev = new Array(arr1Len);
            var i;
            for(i = 0; i < arr1Len; i++)sq_dev[i] = (arr1[i] - u) * (arr2[i] - v);
            return jStat.sum(sq_dev) / (arr1Len - 1);
        };
        // (pearson's) population correlation coefficient, rho
        jStat.corrcoeff = function corrcoeff(arr1, arr2) {
            return jStat.covariance(arr1, arr2) / jStat.stdev(arr1, 1) / jStat.stdev(arr2, 1);
        };
        // (spearman's) rank correlation coefficient, sp
        jStat.spearmancoeff = function(arr1, arr2) {
            arr1 = jStat.rank(arr1);
            arr2 = jStat.rank(arr2);
            //return pearson's correlation of the ranks:
            return jStat.corrcoeff(arr1, arr2);
        };
        // statistical standardized moments (general form of skew/kurt)
        jStat.stanMoment = function stanMoment(arr, n) {
            var mu = jStat.mean(arr);
            var sigma = jStat.stdev(arr);
            var len = arr.length;
            var skewSum = 0;
            for(var i = 0; i < len; i++)skewSum += Math1.pow((arr[i] - mu) / sigma, n);
            return skewSum / arr.length;
        };
        // (pearson's) moment coefficient of skewness
        jStat.skewness = function skewness(arr) {
            return jStat.stanMoment(arr, 3);
        };
        // (pearson's) (excess) kurtosis
        jStat.kurtosis = function kurtosis(arr) {
            return jStat.stanMoment(arr, 4) - 3;
        };
        var jProto = jStat.prototype;
        // Extend jProto with method for calculating cumulative sums and products.
        // This differs from the similar extension below as cumsum and cumprod should
        // not be run again in the case fullbool === true.
        // If a matrix is passed, automatically assume operation should be done on the
        // columns.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                // If a matrix is passed, automatically assume operation should be done on
                // the columns.
                jProto[passfunc] = function(fullbool, func) {
                    var arr = [];
                    var i = 0;
                    var tmpthis = this;
                    // Assignment reassignation depending on how parameters were passed in.
                    if (isFunction(fullbool)) {
                        func = fullbool;
                        fullbool = false;
                    }
                    // Check if a callback was passed with the function.
                    if (func) {
                        setTimeout(function() {
                            func.call(tmpthis, jProto[passfunc].call(tmpthis, fullbool));
                        });
                        return this;
                    }
                    // Check if matrix and run calculations.
                    if (this.length > 1) {
                        tmpthis = fullbool === true ? this : this.transpose();
                        for(; i < tmpthis.length; i++)arr[i] = jStat[passfunc](tmpthis[i]);
                        return arr;
                    }
                    // Pass fullbool if only vector, not a matrix. for variance and stdev.
                    return jStat[passfunc](this[0], fullbool);
                };
            })(funcs[i]);
        })("cumsum cumprod".split(" "));
        // Extend jProto with methods which don't require arguments and work on columns.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                // If a matrix is passed, automatically assume operation should be done on
                // the columns.
                jProto[passfunc] = function(fullbool, func) {
                    var arr = [];
                    var i = 0;
                    var tmpthis = this;
                    // Assignment reassignation depending on how parameters were passed in.
                    if (isFunction(fullbool)) {
                        func = fullbool;
                        fullbool = false;
                    }
                    // Check if a callback was passed with the function.
                    if (func) {
                        setTimeout(function() {
                            func.call(tmpthis, jProto[passfunc].call(tmpthis, fullbool));
                        });
                        return this;
                    }
                    // Check if matrix and run calculations.
                    if (this.length > 1) {
                        if (passfunc !== "sumrow") tmpthis = fullbool === true ? this : this.transpose();
                        for(; i < tmpthis.length; i++)arr[i] = jStat[passfunc](tmpthis[i]);
                        return fullbool === true ? jStat[passfunc](jStat.utils.toVector(arr)) : arr;
                    }
                    // Pass fullbool if only vector, not a matrix. for variance and stdev.
                    return jStat[passfunc](this[0], fullbool);
                };
            })(funcs[i]);
        })("sum sumsqrd sumsqerr sumrow product min max unique mean meansqerr geomean median diff rank mode range variance deviation stdev meandev meddev coeffvar quartiles histogram skewness kurtosis".split(" "));
        // Extend jProto with functions that take arguments. Operations on matrices are
        // done on columns.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function() {
                    var arr = [];
                    var i = 0;
                    var tmpthis = this;
                    var args = Array.prototype.slice.call(arguments);
                    var callbackFunction;
                    // If the last argument is a function, we assume it's a callback; we
                    // strip the callback out and call the function again.
                    if (isFunction(args[args.length - 1])) {
                        callbackFunction = args[args.length - 1];
                        var argsToPass = args.slice(0, args.length - 1);
                        setTimeout(function() {
                            callbackFunction.call(tmpthis, jProto[passfunc].apply(tmpthis, argsToPass));
                        });
                        return this;
                    // Otherwise we curry the function args and call normally.
                    } else {
                        callbackFunction = undefined;
                        var curriedFunction = function curriedFunction(vector) {
                            return jStat[passfunc].apply(tmpthis, [
                                vector
                            ].concat(args));
                        };
                    }
                    // If this is a matrix, run column-by-column.
                    if (this.length > 1) {
                        tmpthis = tmpthis.transpose();
                        for(; i < tmpthis.length; i++)arr[i] = curriedFunction(tmpthis[i]);
                        return arr;
                    }
                    // Otherwise run on the vector.
                    return curriedFunction(this[0]);
                };
            })(funcs[i]);
        })("quantiles percentileOfScore".split(" "));
    })(jStat, Math);
    // Special functions //
    (function(jStat, Math1) {
        // Log-gamma function
        jStat.gammaln = function gammaln(x) {
            var j = 0;
            var cof = [
                76.18009172947146,
                -86.50532032941678,
                24.01409824083091,
                -1.231739572450155,
                0.1208650973866179e-2,
                -0.000005395239384953
            ];
            var ser = 1.000000000190015;
            var xx, y, tmp;
            tmp = (y = xx = x) + 5.5;
            tmp -= (xx + 0.5) * Math1.log(tmp);
            for(; j < 6; j++)ser += cof[j] / ++y;
            return Math1.log(2.5066282746310005 * ser / xx) - tmp;
        };
        /*
 * log-gamma function to support poisson distribution sampling. The
 * algorithm comes from SPECFUN by Shanjie Zhang and Jianming Jin and their
 * book "Computation of Special Functions", 1996, John Wiley & Sons, Inc.
 */ jStat.loggam = function loggam(x) {
            var x0, x2, xp, gl, gl0;
            var k, n;
            var a = [
                8.333333333333333e-02,
                -0.002777777777777778,
                7.936507936507937e-04,
                -0.0005952380952380952,
                8.417508417508418e-04,
                -0.001917526917526918,
                6.410256410256410e-03,
                -0.02955065359477124,
                1.796443723688307e-01,
                -1.3924322169059
            ];
            x0 = x;
            n = 0;
            if (x == 1.0 || x == 2.0) return 0.0;
            if (x <= 7.0) {
                n = Math1.floor(7 - x);
                x0 = x + n;
            }
            x2 = 1.0 / (x0 * x0);
            xp = 2 * Math1.PI;
            gl0 = a[9];
            for(k = 8; k >= 0; k--){
                gl0 *= x2;
                gl0 += a[k];
            }
            gl = gl0 / x0 + 0.5 * Math1.log(xp) + (x0 - 0.5) * Math1.log(x0) - x0;
            if (x <= 7.0) for(k = 1; k <= n; k++){
                gl -= Math1.log(x0 - 1.0);
                x0 -= 1.0;
            }
            return gl;
        };
        // gamma of x
        jStat.gammafn = function gammafn(x) {
            var p = [
                -1.716185138865495,
                24.76565080557592,
                -379.80425647094563,
                629.3311553128184,
                866.9662027904133,
                -31451.272968848367,
                -36144.413418691176,
                66456.14382024054
            ];
            var q = [
                -30.8402300119739,
                315.35062697960416,
                -1015.1563674902192,
                -3107.771671572311,
                22538.118420980151,
                4755.8462775278811,
                -134659.9598649693,
                -115132.2596755535
            ];
            var fact = false;
            var n = 0;
            var xden = 0;
            var xnum = 0;
            var y = x;
            var i, z, yi, res;
            if (x > 171.6243769536076) return Infinity;
            if (y <= 0) {
                res = y % 1 + 3.6e-16;
                if (res) {
                    fact = (!(y & 1) ? 1 : -1) * Math1.PI / Math1.sin(Math1.PI * res);
                    y = 1 - y;
                } else return Infinity;
            }
            yi = y;
            if (y < 1) z = y++;
            else z = (y -= n = (y | 0) - 1) - 1;
            for(i = 0; i < 8; ++i){
                xnum = (xnum + p[i]) * z;
                xden = xden * z + q[i];
            }
            res = xnum / xden + 1;
            if (yi < y) res /= yi;
            else if (yi > y) for(i = 0; i < n; ++i){
                res *= y;
                y++;
            }
            if (fact) res = fact / res;
            return res;
        };
        // lower incomplete gamma function, which is usually typeset with a
        // lower-case greek gamma as the function symbol
        jStat.gammap = function gammap(a, x) {
            return jStat.lowRegGamma(a, x) * jStat.gammafn(a);
        };
        // The lower regularized incomplete gamma function, usually written P(a,x)
        jStat.lowRegGamma = function lowRegGamma(a, x) {
            var aln = jStat.gammaln(a);
            var ap = a;
            var sum = 1 / a;
            var del = sum;
            var b = x + 1 - a;
            var c = 1 / 1.0e-30;
            var d = 1 / b;
            var h = d;
            var i = 1;
            // calculate maximum number of itterations required for a
            var ITMAX = -~(Math1.log(a >= 1 ? a : 1 / a) * 8.5 + a * 0.4 + 17);
            var an;
            if (x < 0 || a <= 0) return NaN;
            else if (x < a + 1) {
                for(; i <= ITMAX; i++)sum += del *= x / ++ap;
                return sum * Math1.exp(-x + a * Math1.log(x) - aln);
            }
            for(; i <= ITMAX; i++){
                an = -i * (i - a);
                b += 2;
                d = an * d + b;
                c = b + an / c;
                d = 1 / d;
                h *= d * c;
            }
            return 1 - h * Math1.exp(-x + a * Math1.log(x) - aln);
        };
        // natural log factorial of n
        jStat.factorialln = function factorialln(n) {
            return n < 0 ? NaN : jStat.gammaln(n + 1);
        };
        // factorial of n
        jStat.factorial = function factorial(n) {
            return n < 0 ? NaN : jStat.gammafn(n + 1);
        };
        // combinations of n, m
        jStat.combination = function combination(n, m) {
            // make sure n or m don't exceed the upper limit of usable values
            return n > 170 || m > 170 ? Math1.exp(jStat.combinationln(n, m)) : jStat.factorial(n) / jStat.factorial(m) / jStat.factorial(n - m);
        };
        jStat.combinationln = function combinationln(n, m) {
            return jStat.factorialln(n) - jStat.factorialln(m) - jStat.factorialln(n - m);
        };
        // permutations of n, m
        jStat.permutation = function permutation(n, m) {
            return jStat.factorial(n) / jStat.factorial(n - m);
        };
        // beta function
        jStat.betafn = function betafn(x, y) {
            // ensure arguments are positive
            if (x <= 0 || y <= 0) return undefined;
            // make sure x + y doesn't exceed the upper limit of usable values
            return x + y > 170 ? Math1.exp(jStat.betaln(x, y)) : jStat.gammafn(x) * jStat.gammafn(y) / jStat.gammafn(x + y);
        };
        // natural logarithm of beta function
        jStat.betaln = function betaln(x, y) {
            return jStat.gammaln(x) + jStat.gammaln(y) - jStat.gammaln(x + y);
        };
        // Evaluates the continued fraction for incomplete beta function by modified
        // Lentz's method.
        jStat.betacf = function betacf(x, a, b) {
            var fpmin = 1e-30;
            var m = 1;
            var qab = a + b;
            var qap = a + 1;
            var qam = a - 1;
            var c = 1;
            var d = 1 - qab * x / qap;
            var m2, aa, del, h;
            // These q's will be used in factors that occur in the coefficients
            if (Math1.abs(d) < fpmin) d = fpmin;
            d = 1 / d;
            h = d;
            for(; m <= 100; m++){
                m2 = 2 * m;
                aa = m * (b - m) * x / ((qam + m2) * (a + m2));
                // One step (the even one) of the recurrence
                d = 1 + aa * d;
                if (Math1.abs(d) < fpmin) d = fpmin;
                c = 1 + aa / c;
                if (Math1.abs(c) < fpmin) c = fpmin;
                d = 1 / d;
                h *= d * c;
                aa = -(a + m) * (qab + m) * x / ((a + m2) * (qap + m2));
                // Next step of the recurrence (the odd one)
                d = 1 + aa * d;
                if (Math1.abs(d) < fpmin) d = fpmin;
                c = 1 + aa / c;
                if (Math1.abs(c) < fpmin) c = fpmin;
                d = 1 / d;
                del = d * c;
                h *= del;
                if (Math1.abs(del - 1.0) < 3e-7) break;
            }
            return h;
        };
        // Returns the inverse of the lower regularized inomplete gamma function
        jStat.gammapinv = function gammapinv(p, a) {
            var j = 0;
            var a1 = a - 1;
            var EPS = 1e-8;
            var gln = jStat.gammaln(a);
            var x, err, t, u, pp, lna1, afac;
            if (p >= 1) return Math1.max(100, a + 100 * Math1.sqrt(a));
            if (p <= 0) return 0;
            if (a > 1) {
                lna1 = Math1.log(a1);
                afac = Math1.exp(a1 * (lna1 - 1) - gln);
                pp = p < 0.5 ? p : 1 - p;
                t = Math1.sqrt(-2 * Math1.log(pp));
                x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
                if (p < 0.5) x = -x;
                x = Math1.max(1e-3, a * Math1.pow(1 - 1 / (9 * a) - x / (3 * Math1.sqrt(a)), 3));
            } else {
                t = 1 - a * (0.253 + a * 0.12);
                if (p < t) x = Math1.pow(p / t, 1 / a);
                else x = 1 - Math1.log(1 - (p - t) / (1 - t));
            }
            for(; j < 12; j++){
                if (x <= 0) return 0;
                err = jStat.lowRegGamma(a, x) - p;
                if (a > 1) t = afac * Math1.exp(-(x - a1) + a1 * (Math1.log(x) - lna1));
                else t = Math1.exp(-x + a1 * Math1.log(x) - gln);
                u = err / t;
                x -= t = u / (1 - 0.5 * Math1.min(1, u * ((a - 1) / x - 1)));
                if (x <= 0) x = 0.5 * (x + t);
                if (Math1.abs(t) < EPS * x) break;
            }
            return x;
        };
        // Returns the error function erf(x)
        jStat.erf = function erf(x) {
            var cof = [
                -1.3026537197817094,
                6.4196979235649026e-1,
                1.9476473204185836e-2,
                -0.00956151478680863,
                -0.000946595344482036,
                3.66839497852761e-4,
                4.2523324806907e-5,
                -0.000020278578112534,
                -0.000001624290004647,
                1.303655835580e-6,
                1.5626441722e-8,
                -0.000000085238095915,
                6.529054439e-9,
                5.059343495e-9,
                -0.000000000991364156,
                -0.000000000227365122,
                9.6467911e-11,
                2.394038e-12,
                -0.000000000006886027,
                8.94487e-13,
                3.13092e-13,
                -0.000000000000112708,
                3.81e-16,
                7.106e-15,
                -0.000000000000001523,
                -0.000000000000000094,
                1.21e-16,
                -0.000000000000000028
            ];
            var j = cof.length - 1;
            var isneg = false;
            var d = 0;
            var dd = 0;
            var t, ty, tmp, res;
            if (x < 0) {
                x = -x;
                isneg = true;
            }
            t = 2 / (2 + x);
            ty = 4 * t - 2;
            for(; j > 0; j--){
                tmp = d;
                d = ty * d - dd + cof[j];
                dd = tmp;
            }
            res = t * Math1.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
            return isneg ? res - 1 : 1 - res;
        };
        // Returns the complmentary error function erfc(x)
        jStat.erfc = function erfc(x) {
            return 1 - jStat.erf(x);
        };
        // Returns the inverse of the complementary error function
        jStat.erfcinv = function erfcinv(p) {
            var j = 0;
            var x, err, t, pp;
            if (p >= 2) return -100;
            if (p <= 0) return 100;
            pp = p < 1 ? p : 2 - p;
            t = Math1.sqrt(-2 * Math1.log(pp / 2));
            x = -0.70711 * ((2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t);
            for(; j < 2; j++){
                err = jStat.erfc(x) - pp;
                x += err / (1.12837916709551257 * Math1.exp(-x * x) - x * err);
            }
            return p < 1 ? x : -x;
        };
        // Returns the inverse of the incomplete beta function
        jStat.ibetainv = function ibetainv(p, a, b) {
            var EPS = 1e-8;
            var a1 = a - 1;
            var b1 = b - 1;
            var j = 0;
            var lna, lnb, pp, t, u, err, x, al, h, w, afac;
            if (p <= 0) return 0;
            if (p >= 1) return 1;
            if (a >= 1 && b >= 1) {
                pp = p < 0.5 ? p : 1 - p;
                t = Math1.sqrt(-2 * Math1.log(pp));
                x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
                if (p < 0.5) x = -x;
                al = (x * x - 3) / 6;
                h = 2 / (1 / (2 * a - 1) + 1 / (2 * b - 1));
                w = x * Math1.sqrt(al + h) / h - (1 / (2 * b - 1) - 1 / (2 * a - 1)) * (al + 5 / 6 - 2 / (3 * h));
                x = a / (a + b * Math1.exp(2 * w));
            } else {
                lna = Math1.log(a / (a + b));
                lnb = Math1.log(b / (a + b));
                t = Math1.exp(a * lna) / a;
                u = Math1.exp(b * lnb) / b;
                w = t + u;
                if (p < t / w) x = Math1.pow(a * w * p, 1 / a);
                else x = 1 - Math1.pow(b * w * (1 - p), 1 / b);
            }
            afac = -jStat.gammaln(a) - jStat.gammaln(b) + jStat.gammaln(a + b);
            for(; j < 10; j++){
                if (x === 0 || x === 1) return x;
                err = jStat.ibeta(x, a, b) - p;
                t = Math1.exp(a1 * Math1.log(x) + b1 * Math1.log(1 - x) + afac);
                u = err / t;
                x -= t = u / (1 - 0.5 * Math1.min(1, u * (a1 / x - b1 / (1 - x))));
                if (x <= 0) x = 0.5 * (x + t);
                if (x >= 1) x = 0.5 * (x + t + 1);
                if (Math1.abs(t) < EPS * x && j > 0) break;
            }
            return x;
        };
        // Returns the incomplete beta function I_x(a,b)
        jStat.ibeta = function ibeta(x, a, b) {
            // Factors in front of the continued fraction.
            var bt = x === 0 || x === 1 ? 0 : Math1.exp(jStat.gammaln(a + b) - jStat.gammaln(a) - jStat.gammaln(b) + a * Math1.log(x) + b * Math1.log(1 - x));
            if (x < 0 || x > 1) return false;
            if (x < (a + 1) / (a + b + 2)) // Use continued fraction directly.
            return bt * jStat.betacf(x, a, b) / a;
            // else use continued fraction after making the symmetry transformation.
            return 1 - bt * jStat.betacf(1 - x, b, a) / b;
        };
        // Returns a normal deviate (mu=0, sigma=1).
        // If n and m are specified it returns a object of normal deviates.
        jStat.randn = function randn(n, m) {
            var u, v, x, y, q;
            if (!m) m = n;
            if (n) return jStat.create(n, m, function() {
                return jStat.randn();
            });
            do {
                u = jStat._random_fn();
                v = 1.7156 * (jStat._random_fn() - 0.5);
                x = u - 0.449871;
                y = Math1.abs(v) + 0.386595;
                q = x * x + y * (0.19600 * y - 0.25472 * x);
            }while (q > 0.27597 && (q > 0.27846 || v * v > -4 * Math1.log(u) * u * u));
            return v / u;
        };
        // Returns a gamma deviate by the method of Marsaglia and Tsang.
        jStat.randg = function randg(shape, n, m) {
            var oalph = shape;
            var a1, a2, u, v, x, mat;
            if (!m) m = n;
            if (!shape) shape = 1;
            if (n) {
                mat = jStat.zeros(n, m);
                mat.alter(function() {
                    return jStat.randg(shape);
                });
                return mat;
            }
            if (shape < 1) shape += 1;
            a1 = shape - 1 / 3;
            a2 = 1 / Math1.sqrt(9 * a1);
            do {
                do {
                    x = jStat.randn();
                    v = 1 + a2 * x;
                }while (v <= 0);
                v = v * v * v;
                u = jStat._random_fn();
            }while (u > 1 - 0.331 * Math1.pow(x, 4) && Math1.log(u) > 0.5 * x * x + a1 * (1 - v + Math1.log(v)));
            // alpha > 1
            if (shape == oalph) return a1 * v;
            // alpha < 1
            do u = jStat._random_fn();
            while (u === 0);
            return Math1.pow(u, 1 / oalph) * a1 * v;
        };
        // making use of static methods on the instance
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jStat.fn[passfunc] = function() {
                    return jStat(jStat.map(this, function(value) {
                        return jStat[passfunc](value);
                    }));
                };
            })(funcs[i]);
        })("gammaln gammafn factorial factorialln".split(" "));
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jStat.fn[passfunc] = function() {
                    return jStat(jStat[passfunc].apply(null, arguments));
                };
            })(funcs[i]);
        })("randn".split(" "));
    })(jStat, Math);
    (function(jStat, Math1) {
        // generate all distribution instance methods
        (function(list) {
            for(var i = 0; i < list.length; i++)(function(func) {
                // distribution instance method
                jStat[func] = function f(a, b, c) {
                    if (!(this instanceof f)) return new f(a, b, c);
                    this._a = a;
                    this._b = b;
                    this._c = c;
                    return this;
                };
                // distribution method to be used on a jStat instance
                jStat.fn[func] = function(a, b, c) {
                    var newthis = jStat[func](a, b, c);
                    newthis.data = this;
                    return newthis;
                };
                // sample instance method
                jStat[func].prototype.sample = function(arr) {
                    var a = this._a;
                    var b = this._b;
                    var c = this._c;
                    if (arr) return jStat.alter(arr, function() {
                        return jStat[func].sample(a, b, c);
                    });
                    else return jStat[func].sample(a, b, c);
                };
                // generate the pdf, cdf and inv instance methods
                (function(vals) {
                    for(var i = 0; i < vals.length; i++)(function(fnfunc) {
                        jStat[func].prototype[fnfunc] = function(x) {
                            var a = this._a;
                            var b = this._b;
                            var c = this._c;
                            if (!x && x !== 0) x = this.data;
                            if (typeof x !== "number") return jStat.fn.map.call(x, function(x) {
                                return jStat[func][fnfunc](x, a, b, c);
                            });
                            return jStat[func][fnfunc](x, a, b, c);
                        };
                    })(vals[i]);
                })("pdf cdf inv".split(" "));
                // generate the mean, median, mode and variance instance methods
                (function(vals) {
                    for(var i = 0; i < vals.length; i++)(function(fnfunc) {
                        jStat[func].prototype[fnfunc] = function() {
                            return jStat[func][fnfunc](this._a, this._b, this._c);
                        };
                    })(vals[i]);
                })("mean median mode variance".split(" "));
            })(list[i]);
        })("beta centralF cauchy chisquare exponential gamma invgamma kumaraswamy laplace lognormal noncentralt normal pareto studentt weibull uniform binomial negbin hypgeom poisson triangular tukey arcsine".split(" "));
        // extend beta function with static methods
        jStat.extend(jStat.beta, {
            pdf: function pdf(x, alpha, beta) {
                // PDF is zero outside the support
                if (x > 1 || x < 0) return 0;
                // PDF is one for the uniform case
                if (alpha == 1 && beta == 1) return 1;
                if (alpha < 512 && beta < 512) return Math1.pow(x, alpha - 1) * Math1.pow(1 - x, beta - 1) / jStat.betafn(alpha, beta);
                else return Math1.exp((alpha - 1) * Math1.log(x) + (beta - 1) * Math1.log(1 - x) - jStat.betaln(alpha, beta));
            },
            cdf: function cdf(x, alpha, beta) {
                return x > 1 || x < 0 ? (x > 1) * 1 : jStat.ibeta(x, alpha, beta);
            },
            inv: function inv(x, alpha, beta) {
                return jStat.ibetainv(x, alpha, beta);
            },
            mean: function mean(alpha, beta) {
                return alpha / (alpha + beta);
            },
            median: function median(alpha, beta) {
                return jStat.ibetainv(0.5, alpha, beta);
            },
            mode: function mode(alpha, beta) {
                return (alpha - 1) / (alpha + beta - 2);
            },
            // return a random sample
            sample: function sample(alpha, beta) {
                var u = jStat.randg(alpha);
                return u / (u + jStat.randg(beta));
            },
            variance: function variance(alpha, beta) {
                return alpha * beta / (Math1.pow(alpha + beta, 2) * (alpha + beta + 1));
            }
        });
        // extend F function with static methods
        jStat.extend(jStat.centralF, {
            // This implementation of the pdf function avoids float overflow
            // See the way that R calculates this value:
            // https://svn.r-project.org/R/trunk/src/nmath/df.c
            pdf: function pdf(x, df1, df2) {
                var p, q, f;
                if (x < 0) return 0;
                if (df1 <= 2) {
                    if (x === 0 && df1 < 2) return Infinity;
                    if (x === 0 && df1 === 2) return 1;
                    return 1 / jStat.betafn(df1 / 2, df2 / 2) * Math1.pow(df1 / df2, df1 / 2) * Math1.pow(x, df1 / 2 - 1) * Math1.pow(1 + df1 / df2 * x, -(df1 + df2) / 2);
                }
                p = df1 * x / (df2 + x * df1);
                q = df2 / (df2 + x * df1);
                f = df1 * q / 2.0;
                return f * jStat.binomial.pdf((df1 - 2) / 2, (df1 + df2 - 2) / 2, p);
            },
            cdf: function cdf(x, df1, df2) {
                if (x < 0) return 0;
                return jStat.ibeta(df1 * x / (df1 * x + df2), df1 / 2, df2 / 2);
            },
            inv: function inv(x, df1, df2) {
                return df2 / (df1 * (1 / jStat.ibetainv(x, df1 / 2, df2 / 2) - 1));
            },
            mean: function mean(df1, df2) {
                return df2 > 2 ? df2 / (df2 - 2) : undefined;
            },
            mode: function mode(df1, df2) {
                return df1 > 2 ? df2 * (df1 - 2) / (df1 * (df2 + 2)) : undefined;
            },
            // return a random sample
            sample: function sample(df1, df2) {
                var x1 = jStat.randg(df1 / 2) * 2;
                var x2 = jStat.randg(df2 / 2) * 2;
                return x1 / df1 / (x2 / df2);
            },
            variance: function variance(df1, df2) {
                if (df2 <= 4) return undefined;
                return 2 * df2 * df2 * (df1 + df2 - 2) / (df1 * (df2 - 2) * (df2 - 2) * (df2 - 4));
            }
        });
        // extend cauchy function with static methods
        jStat.extend(jStat.cauchy, {
            pdf: function pdf(x, local, scale) {
                if (scale < 0) return 0;
                return scale / (Math1.pow(x - local, 2) + Math1.pow(scale, 2)) / Math1.PI;
            },
            cdf: function cdf(x, local, scale) {
                return Math1.atan((x - local) / scale) / Math1.PI + 0.5;
            },
            inv: function(p, local, scale) {
                return local + scale * Math1.tan(Math1.PI * (p - 0.5));
            },
            median: function median(local /*, scale*/ ) {
                return local;
            },
            mode: function mode(local /*, scale*/ ) {
                return local;
            },
            sample: function sample(local, scale) {
                return jStat.randn() * Math1.sqrt(1 / (2 * jStat.randg(0.5))) * scale + local;
            }
        });
        // extend chisquare function with static methods
        jStat.extend(jStat.chisquare, {
            pdf: function pdf(x, dof) {
                if (x < 0) return 0;
                return x === 0 && dof === 2 ? 0.5 : Math1.exp((dof / 2 - 1) * Math1.log(x) - x / 2 - dof / 2 * Math1.log(2) - jStat.gammaln(dof / 2));
            },
            cdf: function cdf(x, dof) {
                if (x < 0) return 0;
                return jStat.lowRegGamma(dof / 2, x / 2);
            },
            inv: function(p, dof) {
                return 2 * jStat.gammapinv(p, 0.5 * dof);
            },
            mean: function(dof) {
                return dof;
            },
            // TODO: this is an approximation (is there a better way?)
            median: function median(dof) {
                return dof * Math1.pow(1 - 2 / (9 * dof), 3);
            },
            mode: function mode(dof) {
                return dof - 2 > 0 ? dof - 2 : 0;
            },
            sample: function sample(dof) {
                return jStat.randg(dof / 2) * 2;
            },
            variance: function variance(dof) {
                return 2 * dof;
            }
        });
        // extend exponential function with static methods
        jStat.extend(jStat.exponential, {
            pdf: function pdf(x, rate) {
                return x < 0 ? 0 : rate * Math1.exp(-rate * x);
            },
            cdf: function cdf(x, rate) {
                return x < 0 ? 0 : 1 - Math1.exp(-rate * x);
            },
            inv: function(p, rate) {
                return -Math1.log(1 - p) / rate;
            },
            mean: function(rate) {
                return 1 / rate;
            },
            median: function(rate) {
                return 1 / rate * Math1.log(2);
            },
            mode: function mode() {
                return 0;
            },
            sample: function sample(rate) {
                return -1 / rate * Math1.log(jStat._random_fn());
            },
            variance: function(rate) {
                return Math1.pow(rate, -2);
            }
        });
        // extend gamma function with static methods
        jStat.extend(jStat.gamma, {
            pdf: function pdf(x, shape, scale) {
                if (x < 0) return 0;
                return x === 0 && shape === 1 ? 1 / scale : Math1.exp((shape - 1) * Math1.log(x) - x / scale - jStat.gammaln(shape) - shape * Math1.log(scale));
            },
            cdf: function cdf(x, shape, scale) {
                if (x < 0) return 0;
                return jStat.lowRegGamma(shape, x / scale);
            },
            inv: function(p, shape, scale) {
                return jStat.gammapinv(p, shape) * scale;
            },
            mean: function(shape, scale) {
                return shape * scale;
            },
            mode: function mode(shape, scale) {
                if (shape > 1) return (shape - 1) * scale;
                return undefined;
            },
            sample: function sample(shape, scale) {
                return jStat.randg(shape) * scale;
            },
            variance: function variance(shape, scale) {
                return shape * scale * scale;
            }
        });
        // extend inverse gamma function with static methods
        jStat.extend(jStat.invgamma, {
            pdf: function pdf(x, shape, scale) {
                if (x <= 0) return 0;
                return Math1.exp(-(shape + 1) * Math1.log(x) - scale / x - jStat.gammaln(shape) + shape * Math1.log(scale));
            },
            cdf: function cdf(x, shape, scale) {
                if (x <= 0) return 0;
                return 1 - jStat.lowRegGamma(shape, scale / x);
            },
            inv: function(p, shape, scale) {
                return scale / jStat.gammapinv(1 - p, shape);
            },
            mean: function(shape, scale) {
                return shape > 1 ? scale / (shape - 1) : undefined;
            },
            mode: function mode(shape, scale) {
                return scale / (shape + 1);
            },
            sample: function sample(shape, scale) {
                return scale / jStat.randg(shape);
            },
            variance: function variance(shape, scale) {
                if (shape <= 2) return undefined;
                return scale * scale / ((shape - 1) * (shape - 1) * (shape - 2));
            }
        });
        // extend kumaraswamy function with static methods
        jStat.extend(jStat.kumaraswamy, {
            pdf: function pdf(x, alpha, beta) {
                if (x === 0 && alpha === 1) return beta;
                else if (x === 1 && beta === 1) return alpha;
                return Math1.exp(Math1.log(alpha) + Math1.log(beta) + (alpha - 1) * Math1.log(x) + (beta - 1) * Math1.log(1 - Math1.pow(x, alpha)));
            },
            cdf: function cdf(x, alpha, beta) {
                if (x < 0) return 0;
                else if (x > 1) return 1;
                return 1 - Math1.pow(1 - Math1.pow(x, alpha), beta);
            },
            inv: function inv(p, alpha, beta) {
                return Math1.pow(1 - Math1.pow(1 - p, 1 / beta), 1 / alpha);
            },
            mean: function(alpha, beta) {
                return beta * jStat.gammafn(1 + 1 / alpha) * jStat.gammafn(beta) / jStat.gammafn(1 + 1 / alpha + beta);
            },
            median: function median(alpha, beta) {
                return Math1.pow(1 - Math1.pow(2, -1 / beta), 1 / alpha);
            },
            mode: function mode(alpha, beta) {
                if (!(alpha >= 1 && beta >= 1 && alpha !== 1 && beta !== 1)) return undefined;
                return Math1.pow((alpha - 1) / (alpha * beta - 1), 1 / alpha);
            },
            variance: function variance() {
                throw new Error("variance not yet implemented");
            // TODO: complete this
            }
        });
        // extend lognormal function with static methods
        jStat.extend(jStat.lognormal, {
            pdf: function pdf(x, mu, sigma) {
                if (x <= 0) return 0;
                return Math1.exp(-Math1.log(x) - 0.5 * Math1.log(2 * Math1.PI) - Math1.log(sigma) - Math1.pow(Math1.log(x) - mu, 2) / (2 * sigma * sigma));
            },
            cdf: function cdf(x, mu, sigma) {
                if (x < 0) return 0;
                return 0.5 + 0.5 * jStat.erf((Math1.log(x) - mu) / Math1.sqrt(2 * sigma * sigma));
            },
            inv: function(p, mu, sigma) {
                return Math1.exp(-1.4142135623730951 * sigma * jStat.erfcinv(2 * p) + mu);
            },
            mean: function mean(mu, sigma) {
                return Math1.exp(mu + sigma * sigma / 2);
            },
            median: function median(mu /*, sigma*/ ) {
                return Math1.exp(mu);
            },
            mode: function mode(mu, sigma) {
                return Math1.exp(mu - sigma * sigma);
            },
            sample: function sample(mu, sigma) {
                return Math1.exp(jStat.randn() * sigma + mu);
            },
            variance: function variance(mu, sigma) {
                return (Math1.exp(sigma * sigma) - 1) * Math1.exp(2 * mu + sigma * sigma);
            }
        });
        // extend noncentralt function with static methods
        jStat.extend(jStat.noncentralt, {
            pdf: function pdf(x, dof, ncp) {
                var tol = 1e-14;
                if (Math1.abs(ncp) < tol) return jStat.studentt.pdf(x, dof);
                if (Math1.abs(x) < tol) return Math1.exp(jStat.gammaln((dof + 1) / 2) - ncp * ncp / 2 - 0.5 * Math1.log(Math1.PI * dof) - jStat.gammaln(dof / 2));
                // formula for x != 0
                return dof / x * (jStat.noncentralt.cdf(x * Math1.sqrt(1 + 2 / dof), dof + 2, ncp) - jStat.noncentralt.cdf(x, dof, ncp));
            },
            cdf: function cdf(x, dof, ncp) {
                var tol = 1e-14;
                var min_iterations = 200;
                if (Math1.abs(ncp) < tol) return jStat.studentt.cdf(x, dof);
                // turn negative x into positive and flip result afterwards
                var flip = false;
                if (x < 0) {
                    flip = true;
                    ncp = -ncp;
                }
                var prob = jStat.normal.cdf(-ncp, 0, 1);
                var value = tol + 1;
                // use value at last two steps to determine convergence
                var lastvalue = value;
                var y = x * x / (x * x + dof);
                var j = 0;
                var p = Math1.exp(-ncp * ncp / 2);
                var q = Math1.exp(-ncp * ncp / 2 - 0.5 * Math1.log(2) - jStat.gammaln(1.5)) * ncp;
                while(j < min_iterations || lastvalue > tol || value > tol){
                    lastvalue = value;
                    if (j > 0) {
                        p *= ncp * ncp / (2 * j);
                        q *= ncp * ncp / (2 * (j + 0.5));
                    }
                    value = p * jStat.beta.cdf(y, j + 0.5, dof / 2) + q * jStat.beta.cdf(y, j + 1, dof / 2);
                    prob += 0.5 * value;
                    j++;
                }
                return flip ? 1 - prob : prob;
            }
        });
        // extend normal function with static methods
        jStat.extend(jStat.normal, {
            pdf: function pdf(x, mean, std) {
                return Math1.exp(-0.5 * Math1.log(2 * Math1.PI) - Math1.log(std) - Math1.pow(x - mean, 2) / (2 * std * std));
            },
            cdf: function cdf(x, mean, std) {
                return 0.5 * (1 + jStat.erf((x - mean) / Math1.sqrt(2 * std * std)));
            },
            inv: function(p, mean, std) {
                return -1.4142135623730951 * std * jStat.erfcinv(2 * p) + mean;
            },
            mean: function(mean /*, std*/ ) {
                return mean;
            },
            median: function median(mean /*, std*/ ) {
                return mean;
            },
            mode: function(mean /*, std*/ ) {
                return mean;
            },
            sample: function sample(mean, std) {
                return jStat.randn() * std + mean;
            },
            variance: function(mean, std) {
                return std * std;
            }
        });
        // extend pareto function with static methods
        jStat.extend(jStat.pareto, {
            pdf: function pdf(x, scale, shape) {
                if (x < scale) return 0;
                return shape * Math1.pow(scale, shape) / Math1.pow(x, shape + 1);
            },
            cdf: function cdf(x, scale, shape) {
                if (x < scale) return 0;
                return 1 - Math1.pow(scale / x, shape);
            },
            inv: function inv(p, scale, shape) {
                return scale / Math1.pow(1 - p, 1 / shape);
            },
            mean: function mean(scale, shape) {
                if (shape <= 1) return undefined;
                return shape * Math1.pow(scale, shape) / (shape - 1);
            },
            median: function median(scale, shape) {
                return scale * (shape * Math1.SQRT2);
            },
            mode: function mode(scale /*, shape*/ ) {
                return scale;
            },
            variance: function(scale, shape) {
                if (shape <= 2) return undefined;
                return scale * scale * shape / (Math1.pow(shape - 1, 2) * (shape - 2));
            }
        });
        // extend studentt function with static methods
        jStat.extend(jStat.studentt, {
            pdf: function pdf(x, dof) {
                dof = dof > 1e100 ? 1e100 : dof;
                return 1 / (Math1.sqrt(dof) * jStat.betafn(0.5, dof / 2)) * Math1.pow(1 + x * x / dof, -((dof + 1) / 2));
            },
            cdf: function cdf(x, dof) {
                var dof2 = dof / 2;
                return jStat.ibeta((x + Math1.sqrt(x * x + dof)) / (2 * Math1.sqrt(x * x + dof)), dof2, dof2);
            },
            inv: function(p, dof) {
                var x = jStat.ibetainv(2 * Math1.min(p, 1 - p), 0.5 * dof, 0.5);
                x = Math1.sqrt(dof * (1 - x) / x);
                return p > 0.5 ? x : -x;
            },
            mean: function mean(dof) {
                return dof > 1 ? 0 : undefined;
            },
            median: function median() {
                return 0;
            },
            mode: function mode() {
                return 0;
            },
            sample: function sample(dof) {
                return jStat.randn() * Math1.sqrt(dof / (2 * jStat.randg(dof / 2)));
            },
            variance: function variance(dof) {
                return dof > 2 ? dof / (dof - 2) : dof > 1 ? Infinity : undefined;
            }
        });
        // extend weibull function with static methods
        jStat.extend(jStat.weibull, {
            pdf: function pdf(x, scale, shape) {
                if (x < 0 || scale < 0 || shape < 0) return 0;
                return shape / scale * Math1.pow(x / scale, shape - 1) * Math1.exp(-Math1.pow(x / scale, shape));
            },
            cdf: function cdf(x, scale, shape) {
                return x < 0 ? 0 : 1 - Math1.exp(-Math1.pow(x / scale, shape));
            },
            inv: function(p, scale, shape) {
                return scale * Math1.pow(-Math1.log(1 - p), 1 / shape);
            },
            mean: function(scale, shape) {
                return scale * jStat.gammafn(1 + 1 / shape);
            },
            median: function median(scale, shape) {
                return scale * Math1.pow(Math1.log(2), 1 / shape);
            },
            mode: function mode(scale, shape) {
                if (shape <= 1) return 0;
                return scale * Math1.pow((shape - 1) / shape, 1 / shape);
            },
            sample: function sample(scale, shape) {
                return scale * Math1.pow(-Math1.log(jStat._random_fn()), 1 / shape);
            },
            variance: function variance(scale, shape) {
                return scale * scale * jStat.gammafn(1 + 2 / shape) - Math1.pow(jStat.weibull.mean(scale, shape), 2);
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.uniform, {
            pdf: function pdf(x, a, b) {
                return x < a || x > b ? 0 : 1 / (b - a);
            },
            cdf: function cdf(x, a, b) {
                if (x < a) return 0;
                else if (x < b) return (x - a) / (b - a);
                return 1;
            },
            inv: function(p, a, b) {
                return a + p * (b - a);
            },
            mean: function mean(a, b) {
                return 0.5 * (a + b);
            },
            median: function median(a, b) {
                return jStat.mean(a, b);
            },
            mode: function mode() {
                throw new Error("mode is not yet implemented");
            },
            sample: function sample(a, b) {
                return a / 2 + b / 2 + (b / 2 - a / 2) * (2 * jStat._random_fn() - 1);
            },
            variance: function variance(a, b) {
                return Math1.pow(b - a, 2) / 12;
            }
        });
        // Got this from http://www.math.ucla.edu/~tom/distributions/binomial.html
        function betinc(x, a, b, eps) {
            var a0 = 0;
            var b0 = 1;
            var a1 = 1;
            var b1 = 1;
            var m9 = 0;
            var a2 = 0;
            var c9;
            while(Math1.abs((a1 - a2) / a1) > eps){
                a2 = a1;
                c9 = -(a + m9) * (a + b + m9) * x / (a + 2 * m9) / (a + 2 * m9 + 1);
                a0 = a1 + c9 * a0;
                b0 = b1 + c9 * b0;
                m9 = m9 + 1;
                c9 = m9 * (b - m9) * x / (a + 2 * m9 - 1) / (a + 2 * m9);
                a1 = a0 + c9 * a1;
                b1 = b0 + c9 * b1;
                a0 = a0 / b1;
                b0 = b0 / b1;
                a1 = a1 / b1;
                b1 = 1;
            }
            return a1 / a;
        }
        // extend uniform function with static methods
        jStat.extend(jStat.binomial, {
            pdf: function pdf(k, n, p) {
                return p === 0 || p === 1 ? n * p === k ? 1 : 0 : jStat.combination(n, k) * Math1.pow(p, k) * Math1.pow(1 - p, n - k);
            },
            cdf: function cdf(x, n, p) {
                var betacdf;
                var eps = 1e-10;
                if (x < 0) return 0;
                if (x >= n) return 1;
                if (p < 0 || p > 1 || n <= 0) return NaN;
                x = Math1.floor(x);
                var z = p;
                var a = x + 1;
                var b = n - x;
                var s = a + b;
                var bt = Math1.exp(jStat.gammaln(s) - jStat.gammaln(b) - jStat.gammaln(a) + a * Math1.log(z) + b * Math1.log(1 - z));
                if (z < (a + 1) / (s + 2)) betacdf = bt * betinc(z, a, b, eps);
                else betacdf = 1 - bt * betinc(1 - z, b, a, eps);
                return Math1.round((1 - betacdf) * (1 / eps)) / (1 / eps);
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.negbin, {
            pdf: function pdf(k, r, p) {
                if (k !== k >>> 0) return false;
                if (k < 0) return 0;
                return jStat.combination(k + r - 1, r - 1) * Math1.pow(1 - p, k) * Math1.pow(p, r);
            },
            cdf: function cdf(x, r, p) {
                var sum = 0, k = 0;
                if (x < 0) return 0;
                for(; k <= x; k++)sum += jStat.negbin.pdf(k, r, p);
                return sum;
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.hypgeom, {
            pdf: function pdf(k, N, m, n) {
                // Hypergeometric PDF.
                // A simplification of the CDF algorithm below.
                // k = number of successes drawn
                // N = population size
                // m = number of successes in population
                // n = number of items drawn from population
                if (k !== k | 0) return false;
                else if (k < 0 || k < m - (N - n)) // It's impossible to have this few successes drawn.
                return 0;
                else if (k > n || k > m) // It's impossible to have this many successes drawn.
                return 0;
                else if (m * 2 > N) {
                    // More than half the population is successes.
                    if (n * 2 > N) // More than half the population is sampled.
                    return jStat.hypgeom.pdf(N - m - n + k, N, N - m, N - n);
                    else // Half or less of the population is sampled.
                    return jStat.hypgeom.pdf(n - k, N, N - m, n);
                } else if (n * 2 > N) // Half or less is successes.
                return jStat.hypgeom.pdf(m - k, N, m, N - n);
                else if (m < n) // We want to have the number of things sampled to be less than the
                // successes available. So swap the definitions of successful and sampled.
                return jStat.hypgeom.pdf(k, N, n, m);
                else {
                    // If we get here, half or less of the population was sampled, half or
                    // less of it was successes, and we had fewer sampled things than
                    // successes. Now we can do this complicated iterative algorithm in an
                    // efficient way.
                    // The basic premise of the algorithm is that we partially normalize our
                    // intermediate product to keep it in a numerically good region, and then
                    // finish the normalization at the end.
                    // This variable holds the scaled probability of the current number of
                    // successes.
                    var scaledPDF = 1;
                    // This keeps track of how much we have normalized.
                    var samplesDone = 0;
                    for(var i = 0; i < k; i++){
                        // For every possible number of successes up to that observed...
                        while(scaledPDF > 1 && samplesDone < n){
                            // Intermediate result is growing too big. Apply some of the
                            // normalization to shrink everything.
                            scaledPDF *= 1 - m / (N - samplesDone);
                            // Say we've normalized by this sample already.
                            samplesDone++;
                        }
                        // Work out the partially-normalized hypergeometric PDF for the next
                        // number of successes
                        scaledPDF *= (n - i) * (m - i) / ((i + 1) * (N - m - n + i + 1));
                    }
                    for(; samplesDone < n; samplesDone++)// Apply all the rest of the normalization
                    scaledPDF *= 1 - m / (N - samplesDone);
                    // Bound answer sanely before returning.
                    return Math1.min(1, Math1.max(0, scaledPDF));
                }
            },
            cdf: function cdf(x, N, m, n) {
                // Hypergeometric CDF.
                // This algorithm is due to Prof. Thomas S. Ferguson, <tom@math.ucla.edu>,
                // and comes from his hypergeometric test calculator at
                // <http://www.math.ucla.edu/~tom/distributions/Hypergeometric.html>.
                // x = number of successes drawn
                // N = population size
                // m = number of successes in population
                // n = number of items drawn from population
                if (x < 0 || x < m - (N - n)) // It's impossible to have this few successes drawn or fewer.
                return 0;
                else if (x >= n || x >= m) // We will always have this many successes or fewer.
                return 1;
                else if (m * 2 > N) {
                    // More than half the population is successes.
                    if (n * 2 > N) // More than half the population is sampled.
                    return jStat.hypgeom.cdf(N - m - n + x, N, N - m, N - n);
                    else // Half or less of the population is sampled.
                    return 1 - jStat.hypgeom.cdf(n - x - 1, N, N - m, n);
                } else if (n * 2 > N) // Half or less is successes.
                return 1 - jStat.hypgeom.cdf(m - x - 1, N, m, N - n);
                else if (m < n) // We want to have the number of things sampled to be less than the
                // successes available. So swap the definitions of successful and sampled.
                return jStat.hypgeom.cdf(x, N, n, m);
                else {
                    // If we get here, half or less of the population was sampled, half or
                    // less of it was successes, and we had fewer sampled things than
                    // successes. Now we can do this complicated iterative algorithm in an
                    // efficient way.
                    // The basic premise of the algorithm is that we partially normalize our
                    // intermediate sum to keep it in a numerically good region, and then
                    // finish the normalization at the end.
                    // Holds the intermediate, scaled total CDF.
                    var scaledCDF = 1;
                    // This variable holds the scaled probability of the current number of
                    // successes.
                    var scaledPDF = 1;
                    // This keeps track of how much we have normalized.
                    var samplesDone = 0;
                    for(var i = 0; i < x; i++){
                        // For every possible number of successes up to that observed...
                        while(scaledCDF > 1 && samplesDone < n){
                            // Intermediate result is growing too big. Apply some of the
                            // normalization to shrink everything.
                            var factor = 1 - m / (N - samplesDone);
                            scaledPDF *= factor;
                            scaledCDF *= factor;
                            // Say we've normalized by this sample already.
                            samplesDone++;
                        }
                        // Work out the partially-normalized hypergeometric PDF for the next
                        // number of successes
                        scaledPDF *= (n - i) * (m - i) / ((i + 1) * (N - m - n + i + 1));
                        // Add to the CDF answer.
                        scaledCDF += scaledPDF;
                    }
                    for(; samplesDone < n; samplesDone++)// Apply all the rest of the normalization
                    scaledCDF *= 1 - m / (N - samplesDone);
                    // Bound answer sanely before returning.
                    return Math1.min(1, Math1.max(0, scaledCDF));
                }
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.poisson, {
            pdf: function pdf(k, l) {
                if (l < 0 || k % 1 !== 0 || k < 0) return 0;
                return Math1.pow(l, k) * Math1.exp(-l) / jStat.factorial(k);
            },
            cdf: function cdf(x, l) {
                var sumarr = [], k = 0;
                if (x < 0) return 0;
                for(; k <= x; k++)sumarr.push(jStat.poisson.pdf(k, l));
                return jStat.sum(sumarr);
            },
            mean: function(l) {
                return l;
            },
            variance: function(l) {
                return l;
            },
            sampleSmall: function sampleSmall(l) {
                var p = 1, k = 0, L = Math1.exp(-l);
                do {
                    k++;
                    p *= jStat._random_fn();
                }while (p > L);
                return k - 1;
            },
            sampleLarge: function sampleLarge(l) {
                var lam = l;
                var k;
                var U, V, slam, loglam, a, b, invalpha, vr, us;
                slam = Math1.sqrt(lam);
                loglam = Math1.log(lam);
                b = 0.931 + 2.53 * slam;
                a = -0.059 + 0.02483 * b;
                invalpha = 1.1239 + 1.1328 / (b - 3.4);
                vr = 0.9277 - 3.6224 / (b - 2);
                while(true){
                    U = Math1.random() - 0.5;
                    V = Math1.random();
                    us = 0.5 - Math1.abs(U);
                    k = Math1.floor((2 * a / us + b) * U + lam + 0.43);
                    if (us >= 0.07 && V <= vr) return k;
                    if (k < 0 || us < 0.013 && V > us) continue;
                    /* log(V) == log(0.0) ok here */ /* if U==0.0 so that us==0.0, log is ok since always returns */ if (Math1.log(V) + Math1.log(invalpha) - Math1.log(a / (us * us) + b) <= -lam + k * loglam - jStat.loggam(k + 1)) return k;
                }
            },
            sample: function sample(l) {
                if (l < 10) return this.sampleSmall(l);
                else return this.sampleLarge(l);
            }
        });
        // extend triangular function with static methods
        jStat.extend(jStat.triangular, {
            pdf: function pdf(x, a, b, c) {
                if (b <= a || c < a || c > b) return NaN;
                else {
                    if (x < a || x > b) return 0;
                    else if (x < c) return 2 * (x - a) / ((b - a) * (c - a));
                    else if (x === c) return 2 / (b - a);
                    else return 2 * (b - x) / ((b - a) * (b - c));
                }
            },
            cdf: function cdf(x, a, b, c) {
                if (b <= a || c < a || c > b) return NaN;
                if (x <= a) return 0;
                else if (x >= b) return 1;
                if (x <= c) return Math1.pow(x - a, 2) / ((b - a) * (c - a));
                else return 1 - Math1.pow(b - x, 2) / ((b - a) * (b - c));
            },
            inv: function inv(p, a, b, c) {
                if (b <= a || c < a || c > b) return NaN;
                else {
                    if (p <= (c - a) / (b - a)) return a + (b - a) * Math1.sqrt(p * ((c - a) / (b - a)));
                    else return a + (b - a) * (1 - Math1.sqrt((1 - p) * (1 - (c - a) / (b - a))));
                }
            },
            mean: function mean(a, b, c) {
                return (a + b + c) / 3;
            },
            median: function median(a, b, c) {
                if (c <= (a + b) / 2) return b - Math1.sqrt((b - a) * (b - c)) / Math1.sqrt(2);
                else if (c > (a + b) / 2) return a + Math1.sqrt((b - a) * (c - a)) / Math1.sqrt(2);
            },
            mode: function mode(a, b, c) {
                return c;
            },
            sample: function sample(a, b, c) {
                var u = jStat._random_fn();
                if (u < (c - a) / (b - a)) return a + Math1.sqrt(u * (b - a) * (c - a));
                return b - Math1.sqrt((1 - u) * (b - a) * (b - c));
            },
            variance: function variance(a, b, c) {
                return (a * a + b * b + c * c - a * b - a * c - b * c) / 18;
            }
        });
        // extend arcsine function with static methods
        jStat.extend(jStat.arcsine, {
            pdf: function pdf(x, a, b) {
                if (b <= a) return NaN;
                return x <= a || x >= b ? 0 : 2 / Math1.PI * Math1.pow(Math1.pow(b - a, 2) - Math1.pow(2 * x - a - b, 2), -0.5);
            },
            cdf: function cdf(x, a, b) {
                if (x < a) return 0;
                else if (x < b) return 2 / Math1.PI * Math1.asin(Math1.sqrt((x - a) / (b - a)));
                return 1;
            },
            inv: function(p, a, b) {
                return a + (0.5 - 0.5 * Math1.cos(Math1.PI * p)) * (b - a);
            },
            mean: function mean(a, b) {
                if (b <= a) return NaN;
                return (a + b) / 2;
            },
            median: function median(a, b) {
                if (b <= a) return NaN;
                return (a + b) / 2;
            },
            mode: function mode() {
                throw new Error("mode is not yet implemented");
            },
            sample: function sample(a, b) {
                return (a + b) / 2 + (b - a) / 2 * Math1.sin(2 * Math1.PI * jStat.uniform.sample(0, 1));
            },
            variance: function variance(a, b) {
                if (b <= a) return NaN;
                return Math1.pow(b - a, 2) / 8;
            }
        });
        function laplaceSign(x) {
            return x / Math1.abs(x);
        }
        jStat.extend(jStat.laplace, {
            pdf: function pdf(x, mu, b) {
                return b <= 0 ? 0 : Math1.exp(-Math1.abs(x - mu) / b) / (2 * b);
            },
            cdf: function cdf(x, mu, b) {
                if (b <= 0) return 0;
                if (x < mu) return 0.5 * Math1.exp((x - mu) / b);
                else return 1 - 0.5 * Math1.exp(-(x - mu) / b);
            },
            mean: function(mu /*, b*/ ) {
                return mu;
            },
            median: function(mu /*, b*/ ) {
                return mu;
            },
            mode: function(mu /*, b*/ ) {
                return mu;
            },
            variance: function(mu, b) {
                return 2 * b * b;
            },
            sample: function sample(mu, b) {
                var u = jStat._random_fn() - 0.5;
                return mu - b * laplaceSign(u) * Math1.log(1 - 2 * Math1.abs(u));
            }
        });
        function tukeyWprob(w, rr, cc) {
            var nleg = 12;
            var ihalf = 6;
            var C1 = -30;
            var C2 = -50;
            var C3 = 60;
            var bb = 8;
            var wlar = 3;
            var wincr1 = 2;
            var wincr2 = 3;
            var xleg = [
                0.981560634246719250690549090149,
                0.904117256370474856678465866119,
                0.769902674194304687036893833213,
                0.587317954286617447296702418941,
                0.367831498998180193752691536644,
                0.125233408511468915472441369464
            ];
            var aleg = [
                0.047175336386511827194615961485,
                0.106939325995318430960254718194,
                0.160078328543346226334652529543,
                0.203167426723065921749064455810,
                0.233492536538354808760849898925,
                0.249147045813402785000562436043
            ];
            var qsqz = w * 0.5;
            // if w >= 16 then the integral lower bound (occurs for c=20)
            // is 0.99999999999995 so return a value of 1.
            if (qsqz >= bb) return 1.0;
            // find (f(w/2) - 1) ^ cc
            // (first term in integral of hartley's form).
            var pr_w = 2 * jStat.normal.cdf(qsqz, 0, 1, 1, 0) - 1; // erf(qsqz / M_SQRT2)
            // if pr_w ^ cc < 2e-22 then set pr_w = 0
            if (pr_w >= Math1.exp(C2 / cc)) pr_w = Math1.pow(pr_w, cc);
            else pr_w = 0.0;
            // if w is large then the second component of the
            // integral is small, so fewer intervals are needed.
            var wincr;
            if (w > wlar) wincr = wincr1;
            else wincr = wincr2;
            // find the integral of second term of hartley's form
            // for the integral of the range for equal-length
            // intervals using legendre quadrature.  limits of
            // integration are from (w/2, 8).  two or three
            // equal-length intervals are used.
            // blb and bub are lower and upper limits of integration.
            var blb = qsqz;
            var binc = (bb - qsqz) / wincr;
            var bub = blb + binc;
            var einsum = 0.0;
            // integrate over each interval
            var cc1 = cc - 1.0;
            for(var wi = 1; wi <= wincr; wi++){
                var elsum = 0.0;
                var a = 0.5 * (bub + blb);
                // legendre quadrature with order = nleg
                var b = 0.5 * (bub - blb);
                for(var jj = 1; jj <= nleg; jj++){
                    var j, xx;
                    if (ihalf < jj) {
                        j = nleg - jj + 1;
                        xx = xleg[j - 1];
                    } else {
                        j = jj;
                        xx = -xleg[j - 1];
                    }
                    var c = b * xx;
                    var ac = a + c;
                    // if exp(-qexpo/2) < 9e-14,
                    // then doesn't contribute to integral
                    var qexpo = ac * ac;
                    if (qexpo > C3) break;
                    var pplus = 2 * jStat.normal.cdf(ac, 0, 1, 1, 0);
                    var pminus = 2 * jStat.normal.cdf(ac, w, 1, 1, 0);
                    // if rinsum ^ (cc-1) < 9e-14,
                    // then doesn't contribute to integral
                    var rinsum = pplus * 0.5 - pminus * 0.5;
                    if (rinsum >= Math1.exp(C1 / cc1)) {
                        rinsum = aleg[j - 1] * Math1.exp(-(0.5 * qexpo)) * Math1.pow(rinsum, cc1);
                        elsum += rinsum;
                    }
                }
                elsum *= 2.0 * b * cc / Math1.sqrt(2 * Math1.PI);
                einsum += elsum;
                blb = bub;
                bub += binc;
            }
            // if pr_w ^ rr < 9e-14, then return 0
            pr_w += einsum;
            if (pr_w <= Math1.exp(C1 / rr)) return 0;
            pr_w = Math1.pow(pr_w, rr);
            if (pr_w >= 1) return 1;
            return pr_w;
        }
        function tukeyQinv(p, c, v) {
            var p0 = 0.322232421088;
            var q0 = 0.993484626060e-01;
            var p1 = -1;
            var q1 = 0.588581570495;
            var p2 = -0.342242088547;
            var q2 = 0.531103462366;
            var p3 = -0.204231210125;
            var q3 = 0.103537752850;
            var p4 = -0.0000453642210148;
            var q4 = 0.38560700634e-02;
            var c1 = 0.8832;
            var c2 = 0.2368;
            var c3 = 1.214;
            var c4 = 1.208;
            var c5 = 1.4142;
            var vmax = 120.0;
            var ps = 0.5 - 0.5 * p;
            var yi = Math1.sqrt(Math1.log(1.0 / (ps * ps)));
            var t = yi + ((((yi * p4 + p3) * yi + p2) * yi + p1) * yi + p0) / ((((yi * q4 + q3) * yi + q2) * yi + q1) * yi + q0);
            if (v < vmax) t += (t * t * t + t) / v / 4.0;
            var q = c1 - c2 * t;
            if (v < vmax) q += -c3 / v + c4 * t / v;
            return t * (q * Math1.log(c - 1.0) + c5);
        }
        jStat.extend(jStat.tukey, {
            cdf: function cdf(q, nmeans, df) {
                // Identical implementation as the R ptukey() function as of commit 68947
                var rr = 1;
                var cc = nmeans;
                var nlegq = 16;
                var ihalfq = 8;
                var eps1 = -30;
                var eps2 = 1.0e-14;
                var dhaf = 100.0;
                var dquar = 800.0;
                var deigh = 5000.0;
                var dlarg = 25000.0;
                var ulen1 = 1.0;
                var ulen2 = 0.5;
                var ulen3 = 0.25;
                var ulen4 = 0.125;
                var xlegq = [
                    0.989400934991649932596154173450,
                    0.944575023073232576077988415535,
                    0.865631202387831743880467897712,
                    0.755404408355003033895101194847,
                    0.617876244402643748446671764049,
                    0.458016777657227386342419442984,
                    0.281603550779258913230460501460,
                    0.950125098376374401853193354250e-1
                ];
                var alegq = [
                    0.271524594117540948517805724560e-1,
                    0.622535239386478928628438369944e-1,
                    0.951585116824927848099251076022e-1,
                    0.124628971255533872052476282192,
                    0.149595988816576732081501730547,
                    0.169156519395002538189312079030,
                    0.182603415044923588866763667969,
                    0.189450610455068496285396723208
                ];
                if (q <= 0) return 0;
                // df must be > 1
                // there must be at least two values
                if (df < 2 || rr < 1 || cc < 2) return NaN;
                if (!Number.isFinite(q)) return 1;
                if (df > dlarg) return tukeyWprob(q, rr, cc);
                // calculate leading constant
                var f2 = df * 0.5;
                var f2lf = f2 * Math1.log(df) - df * Math1.log(2) - jStat.gammaln(f2);
                var f21 = f2 - 1.0;
                // integral is divided into unit, half-unit, quarter-unit, or
                // eighth-unit length intervals depending on the value of the
                // degrees of freedom.
                var ff4 = df * 0.25;
                var ulen;
                if (df <= dhaf) ulen = ulen1;
                else if (df <= dquar) ulen = ulen2;
                else if (df <= deigh) ulen = ulen3;
                else ulen = ulen4;
                f2lf += Math1.log(ulen);
                // integrate over each subinterval
                var ans = 0.0;
                for(var i = 1; i <= 50; i++){
                    var otsum = 0.0;
                    // legendre quadrature with order = nlegq
                    // nodes (stored in xlegq) are symmetric around zero.
                    var twa1 = (2 * i - 1) * ulen;
                    for(var jj = 1; jj <= nlegq; jj++){
                        var j, t1;
                        if (ihalfq < jj) {
                            j = jj - ihalfq - 1;
                            t1 = f2lf + f21 * Math1.log(twa1 + xlegq[j] * ulen) - (xlegq[j] * ulen + twa1) * ff4;
                        } else {
                            j = jj - 1;
                            t1 = f2lf + f21 * Math1.log(twa1 - xlegq[j] * ulen) + (xlegq[j] * ulen - twa1) * ff4;
                        }
                        // if exp(t1) < 9e-14, then doesn't contribute to integral
                        var qsqz;
                        if (t1 >= eps1) {
                            if (ihalfq < jj) qsqz = q * Math1.sqrt((xlegq[j] * ulen + twa1) * 0.5);
                            else qsqz = q * Math1.sqrt((-(xlegq[j] * ulen) + twa1) * 0.5);
                            // call wprob to find integral of range portion
                            var wprb = tukeyWprob(qsqz, rr, cc);
                            var rotsum = wprb * alegq[j] * Math1.exp(t1);
                            otsum += rotsum;
                        }
                    // end legendre integral for interval i
                    // L200:
                    }
                    // if integral for interval i < 1e-14, then stop.
                    // However, in order to avoid small area under left tail,
                    // at least  1 / ulen  intervals are calculated.
                    if (i * ulen >= 1.0 && otsum <= eps2) break;
                    // end of interval i
                    // L330:
                    ans += otsum;
                }
                if (otsum > eps2) throw new Error("tukey.cdf failed to converge");
                if (ans > 1) ans = 1;
                return ans;
            },
            inv: function(p, nmeans, df) {
                // Identical implementation as the R qtukey() function as of commit 68947
                var rr = 1;
                var cc = nmeans;
                var eps = 0.0001;
                var maxiter = 50;
                // df must be > 1 ; there must be at least two values
                if (df < 2 || rr < 1 || cc < 2) return NaN;
                if (p < 0 || p > 1) return NaN;
                if (p === 0) return 0;
                if (p === 1) return Infinity;
                // Initial value
                var x0 = tukeyQinv(p, cc, df);
                // Find prob(value < x0)
                var valx0 = jStat.tukey.cdf(x0, nmeans, df) - p;
                // Find the second iterate and prob(value < x1).
                // If the first iterate has probability value
                // exceeding p then second iterate is 1 less than
                // first iterate; otherwise it is 1 greater.
                var x1;
                if (valx0 > 0.0) x1 = Math1.max(0.0, x0 - 1.0);
                else x1 = x0 + 1.0;
                var valx1 = jStat.tukey.cdf(x1, nmeans, df) - p;
                // Find new iterate
                var ans;
                for(var iter = 1; iter < maxiter; iter++){
                    ans = x1 - valx1 * (x1 - x0) / (valx1 - valx0);
                    valx0 = valx1;
                    // New iterate must be >= 0
                    x0 = x1;
                    if (ans < 0.0) {
                        ans = 0.0;
                        valx1 = -p;
                    }
                    // Find prob(value < new iterate)
                    valx1 = jStat.tukey.cdf(ans, nmeans, df) - p;
                    x1 = ans;
                    // If the difference between two successive
                    // iterates is less than eps, stop
                    var xabs = Math1.abs(x1 - x0);
                    if (xabs < eps) return ans;
                }
                throw new Error("tukey.inv failed to converge");
            }
        });
    })(jStat, Math);
    /* Provides functions for the solution of linear system of equations, integration, extrapolation,
 * interpolation, eigenvalue problems, differential equations and PCA analysis. */ (function(jStat, Math1) {
        var push = Array.prototype.push;
        var isArray = jStat.utils.isArray;
        function isUsable(arg) {
            return isArray(arg) || arg instanceof jStat;
        }
        jStat.extend({
            // add a vector/matrix to a vector/matrix or scalar
            add: function add(arr, arg) {
                // check if arg is a vector or scalar
                if (isUsable(arg)) {
                    if (!isUsable(arg[0])) arg = [
                        arg
                    ];
                    return jStat.map(arr, function(value, row, col) {
                        return value + arg[row][col];
                    });
                }
                return jStat.map(arr, function(value) {
                    return value + arg;
                });
            },
            // subtract a vector or scalar from the vector
            subtract: function subtract(arr, arg) {
                // check if arg is a vector or scalar
                if (isUsable(arg)) {
                    if (!isUsable(arg[0])) arg = [
                        arg
                    ];
                    return jStat.map(arr, function(value, row, col) {
                        return value - arg[row][col] || 0;
                    });
                }
                return jStat.map(arr, function(value) {
                    return value - arg;
                });
            },
            // matrix division
            divide: function divide(arr, arg) {
                if (isUsable(arg)) {
                    if (!isUsable(arg[0])) arg = [
                        arg
                    ];
                    return jStat.multiply(arr, jStat.inv(arg));
                }
                return jStat.map(arr, function(value) {
                    return value / arg;
                });
            },
            // matrix multiplication
            multiply: function multiply(arr, arg) {
                var row, col, nrescols, sum, nrow, ncol, res, rescols;
                // eg: arr = 2 arg = 3 -> 6 for res[0][0] statement closure
                if (arr.length === undefined && arg.length === undefined) return arr * arg;
                nrow = arr.length, ncol = arr[0].length, res = jStat.zeros(nrow, nrescols = isUsable(arg) ? arg[0].length : ncol), rescols = 0;
                if (isUsable(arg)) {
                    for(; rescols < nrescols; rescols++)for(row = 0; row < nrow; row++){
                        sum = 0;
                        for(col = 0; col < ncol; col++)sum += arr[row][col] * arg[col][rescols];
                        res[row][rescols] = sum;
                    }
                    return nrow === 1 && rescols === 1 ? res[0][0] : res;
                }
                return jStat.map(arr, function(value) {
                    return value * arg;
                });
            },
            // outer([1,2,3],[4,5,6])
            // ===
            // [[1],[2],[3]] times [[4,5,6]]
            // ->
            // [[4,5,6],[8,10,12],[12,15,18]]
            outer: function outer(A, B) {
                return jStat.multiply(A.map(function(t) {
                    return [
                        t
                    ];
                }), [
                    B
                ]);
            },
            // Returns the dot product of two matricies
            dot: function dot(arr, arg) {
                if (!isUsable(arr[0])) arr = [
                    arr
                ];
                if (!isUsable(arg[0])) arg = [
                    arg
                ];
                // convert column to row vector
                var left = arr[0].length === 1 && arr.length !== 1 ? jStat.transpose(arr) : arr, right = arg[0].length === 1 && arg.length !== 1 ? jStat.transpose(arg) : arg, res = [], row = 0, nrow = left.length, ncol = left[0].length, sum, col;
                for(; row < nrow; row++){
                    res[row] = [];
                    sum = 0;
                    for(col = 0; col < ncol; col++)sum += left[row][col] * right[row][col];
                    res[row] = sum;
                }
                return res.length === 1 ? res[0] : res;
            },
            // raise every element by a scalar
            pow: function pow(arr, arg) {
                return jStat.map(arr, function(value) {
                    return Math1.pow(value, arg);
                });
            },
            // exponentiate every element
            exp: function exp(arr) {
                return jStat.map(arr, function(value) {
                    return Math1.exp(value);
                });
            },
            // generate the natural log of every element
            log: function exp(arr) {
                return jStat.map(arr, function(value) {
                    return Math1.log(value);
                });
            },
            // generate the absolute values of the vector
            abs: function abs(arr) {
                return jStat.map(arr, function(value) {
                    return Math1.abs(value);
                });
            },
            // computes the p-norm of the vector
            // In the case that a matrix is passed, uses the first row as the vector
            norm: function norm(arr, p) {
                var nnorm = 0, i = 0;
                // check the p-value of the norm, and set for most common case
                if (isNaN(p)) p = 2;
                // check if multi-dimensional array, and make vector correction
                if (isUsable(arr[0])) arr = arr[0];
                // vector norm
                for(; i < arr.length; i++)nnorm += Math1.pow(Math1.abs(arr[i]), p);
                return Math1.pow(nnorm, 1 / p);
            },
            // computes the angle between two vectors in rads
            // In case a matrix is passed, this uses the first row as the vector
            angle: function angle(arr, arg) {
                return Math1.acos(jStat.dot(arr, arg) / (jStat.norm(arr) * jStat.norm(arg)));
            },
            // augment one matrix by another
            // Note: this function returns a matrix, not a jStat object
            aug: function aug(a, b) {
                var newarr = [];
                var i;
                for(i = 0; i < a.length; i++)newarr.push(a[i].slice());
                for(i = 0; i < newarr.length; i++)push.apply(newarr[i], b[i]);
                return newarr;
            },
            // The inv() function calculates the inverse of a matrix
            // Create the inverse by augmenting the matrix by the identity matrix of the
            // appropriate size, and then use G-J elimination on the augmented matrix.
            inv: function inv(a) {
                var rows = a.length;
                var cols = a[0].length;
                var b = jStat.identity(rows, cols);
                var c = jStat.gauss_jordan(a, b);
                var result = [];
                var i = 0;
                var j;
                //We need to copy the inverse portion to a new matrix to rid G-J artifacts
                for(; i < rows; i++){
                    result[i] = [];
                    for(j = cols; j < c[0].length; j++)result[i][j - cols] = c[i][j];
                }
                return result;
            },
            // calculate the determinant of a matrix
            det: function det(a) {
                if (a.length === 2) return a[0][0] * a[1][1] - a[0][1] * a[1][0];
                var determinant = 0;
                for(var i = 0; i < a.length; i++){
                    // build a sub matrix without column `i`
                    var submatrix = [];
                    for(var row = 1; row < a.length; row++){
                        submatrix[row - 1] = [];
                        for(var col = 0; col < a.length; col++){
                            if (col < i) submatrix[row - 1][col] = a[row][col];
                            else if (col > i) submatrix[row - 1][col - 1] = a[row][col];
                        }
                    }
                    // alternate between + and - between determinants
                    var sign = i % 2 ? -1 : 1;
                    determinant += det(submatrix) * a[0][i] * sign;
                }
                return determinant;
            },
            gauss_elimination: function gauss_elimination(a, b) {
                var i = 0, j = 0, n = a.length, m = a[0].length, factor = 1, sum = 0, x = [], maug, pivot, temp, k;
                a = jStat.aug(a, b);
                maug = a[0].length;
                for(i = 0; i < n; i++){
                    pivot = a[i][i];
                    j = i;
                    for(k = i + 1; k < m; k++)if (pivot < Math1.abs(a[k][i])) {
                        pivot = a[k][i];
                        j = k;
                    }
                    if (j != i) for(k = 0; k < maug; k++){
                        temp = a[i][k];
                        a[i][k] = a[j][k];
                        a[j][k] = temp;
                    }
                    for(j = i + 1; j < n; j++){
                        factor = a[j][i] / a[i][i];
                        for(k = i; k < maug; k++)a[j][k] = a[j][k] - factor * a[i][k];
                    }
                }
                for(i = n - 1; i >= 0; i--){
                    sum = 0;
                    for(j = i + 1; j <= n - 1; j++)sum = sum + x[j] * a[i][j];
                    x[i] = (a[i][maug - 1] - sum) / a[i][i];
                }
                return x;
            },
            gauss_jordan: function gauss_jordan(a, b) {
                var m = jStat.aug(a, b);
                var h = m.length;
                var w = m[0].length;
                var c = 0;
                var x, y, y2;
                // find max pivot
                for(y = 0; y < h; y++){
                    var maxrow = y;
                    for(y2 = y + 1; y2 < h; y2++)if (Math1.abs(m[y2][y]) > Math1.abs(m[maxrow][y])) maxrow = y2;
                    var tmp = m[y];
                    m[y] = m[maxrow];
                    m[maxrow] = tmp;
                    for(y2 = y + 1; y2 < h; y2++){
                        c = m[y2][y] / m[y][y];
                        for(x = y; x < w; x++)m[y2][x] -= m[y][x] * c;
                    }
                }
                // backsubstitute
                for(y = h - 1; y >= 0; y--){
                    c = m[y][y];
                    for(y2 = 0; y2 < y; y2++)for(x = w - 1; x > y - 1; x--)m[y2][x] -= m[y][x] * m[y2][y] / c;
                    m[y][y] /= c;
                    for(x = h; x < w; x++)m[y][x] /= c;
                }
                return m;
            },
            // solve equation
            // Ax=b
            // A is upper triangular matrix
            // A=[[1,2,3],[0,4,5],[0,6,7]]
            // b=[1,2,3]
            // triaUpSolve(A,b) // -> [2.666,0.1666,1.666]
            // if you use matrix style
            // A=[[1,2,3],[0,4,5],[0,6,7]]
            // b=[[1],[2],[3]]
            // will return [[2.666],[0.1666],[1.666]]
            triaUpSolve: function triaUpSolve(A, b) {
                var size = A[0].length;
                var x = jStat.zeros(1, size)[0];
                var parts;
                var matrix_mode = false;
                if (b[0].length != undefined) {
                    b = b.map(function(i) {
                        return i[0];
                    });
                    matrix_mode = true;
                }
                jStat.arange(size - 1, -1, -1).forEach(function(i) {
                    parts = jStat.arange(i + 1, size).map(function(j) {
                        return x[j] * A[i][j];
                    });
                    x[i] = (b[i] - jStat.sum(parts)) / A[i][i];
                });
                if (matrix_mode) return x.map(function(i) {
                    return [
                        i
                    ];
                });
                return x;
            },
            triaLowSolve: function triaLowSolve(A, b) {
                // like to triaUpSolve but A is lower triangular matrix
                var size = A[0].length;
                var x = jStat.zeros(1, size)[0];
                var parts;
                var matrix_mode = false;
                if (b[0].length != undefined) {
                    b = b.map(function(i) {
                        return i[0];
                    });
                    matrix_mode = true;
                }
                jStat.arange(size).forEach(function(i) {
                    parts = jStat.arange(i).map(function(j) {
                        return A[i][j] * x[j];
                    });
                    x[i] = (b[i] - jStat.sum(parts)) / A[i][i];
                });
                if (matrix_mode) return x.map(function(i) {
                    return [
                        i
                    ];
                });
                return x;
            },
            // A -> [L,U]
            // A=LU
            // L is lower triangular matrix
            // U is upper triangular matrix
            lu: function lu(A) {
                var size = A.length;
                //var L=jStat.diagonal(jStat.ones(1,size)[0]);
                var L = jStat.identity(size);
                var R = jStat.zeros(A.length, A[0].length);
                var parts;
                jStat.arange(size).forEach(function(t) {
                    R[0][t] = A[0][t];
                });
                jStat.arange(1, size).forEach(function(l) {
                    jStat.arange(l).forEach(function(i) {
                        parts = jStat.arange(i).map(function(jj) {
                            return L[l][jj] * R[jj][i];
                        });
                        L[l][i] = (A[l][i] - jStat.sum(parts)) / R[i][i];
                    });
                    jStat.arange(l, size).forEach(function(j) {
                        parts = jStat.arange(l).map(function(jj) {
                            return L[l][jj] * R[jj][j];
                        });
                        R[l][j] = A[parts.length][j] - jStat.sum(parts);
                    });
                });
                return [
                    L,
                    R
                ];
            },
            // A -> T
            // A=TT'
            // T is lower triangular matrix
            cholesky: function cholesky(A) {
                var size = A.length;
                var T = jStat.zeros(A.length, A[0].length);
                var parts;
                jStat.arange(size).forEach(function(i) {
                    parts = jStat.arange(i).map(function(t) {
                        return Math1.pow(T[i][t], 2);
                    });
                    T[i][i] = Math1.sqrt(A[i][i] - jStat.sum(parts));
                    jStat.arange(i + 1, size).forEach(function(j) {
                        parts = jStat.arange(i).map(function(t) {
                            return T[i][t] * T[j][t];
                        });
                        T[j][i] = (A[i][j] - jStat.sum(parts)) / T[i][i];
                    });
                });
                return T;
            },
            gauss_jacobi: function gauss_jacobi(a, b, x, r) {
                var i = 0;
                var j = 0;
                var n = a.length;
                var l = [];
                var u = [];
                var d = [];
                var xv, c, h, xk;
                for(; i < n; i++){
                    l[i] = [];
                    u[i] = [];
                    d[i] = [];
                    for(j = 0; j < n; j++){
                        if (i > j) {
                            l[i][j] = a[i][j];
                            u[i][j] = d[i][j] = 0;
                        } else if (i < j) {
                            u[i][j] = a[i][j];
                            l[i][j] = d[i][j] = 0;
                        } else {
                            d[i][j] = a[i][j];
                            l[i][j] = u[i][j] = 0;
                        }
                    }
                }
                h = jStat.multiply(jStat.multiply(jStat.inv(d), jStat.add(l, u)), -1);
                c = jStat.multiply(jStat.inv(d), b);
                xv = x;
                xk = jStat.add(jStat.multiply(h, x), c);
                i = 2;
                while(Math1.abs(jStat.norm(jStat.subtract(xk, xv))) > r){
                    xv = xk;
                    xk = jStat.add(jStat.multiply(h, xv), c);
                    i++;
                }
                return xk;
            },
            gauss_seidel: function gauss_seidel(a, b, x, r) {
                var i = 0;
                var n = a.length;
                var l = [];
                var u = [];
                var d = [];
                var j, xv, c, h, xk;
                for(; i < n; i++){
                    l[i] = [];
                    u[i] = [];
                    d[i] = [];
                    for(j = 0; j < n; j++){
                        if (i > j) {
                            l[i][j] = a[i][j];
                            u[i][j] = d[i][j] = 0;
                        } else if (i < j) {
                            u[i][j] = a[i][j];
                            l[i][j] = d[i][j] = 0;
                        } else {
                            d[i][j] = a[i][j];
                            l[i][j] = u[i][j] = 0;
                        }
                    }
                }
                h = jStat.multiply(jStat.multiply(jStat.inv(jStat.add(d, l)), u), -1);
                c = jStat.multiply(jStat.inv(jStat.add(d, l)), b);
                xv = x;
                xk = jStat.add(jStat.multiply(h, x), c);
                i = 2;
                while(Math1.abs(jStat.norm(jStat.subtract(xk, xv))) > r){
                    xv = xk;
                    xk = jStat.add(jStat.multiply(h, xv), c);
                    i = i + 1;
                }
                return xk;
            },
            SOR: function SOR(a, b, x, r, w) {
                var i = 0;
                var n = a.length;
                var l = [];
                var u = [];
                var d = [];
                var j, xv, c, h, xk;
                for(; i < n; i++){
                    l[i] = [];
                    u[i] = [];
                    d[i] = [];
                    for(j = 0; j < n; j++){
                        if (i > j) {
                            l[i][j] = a[i][j];
                            u[i][j] = d[i][j] = 0;
                        } else if (i < j) {
                            u[i][j] = a[i][j];
                            l[i][j] = d[i][j] = 0;
                        } else {
                            d[i][j] = a[i][j];
                            l[i][j] = u[i][j] = 0;
                        }
                    }
                }
                h = jStat.multiply(jStat.inv(jStat.add(d, jStat.multiply(l, w))), jStat.subtract(jStat.multiply(d, 1 - w), jStat.multiply(u, w)));
                c = jStat.multiply(jStat.multiply(jStat.inv(jStat.add(d, jStat.multiply(l, w))), b), w);
                xv = x;
                xk = jStat.add(jStat.multiply(h, x), c);
                i = 2;
                while(Math1.abs(jStat.norm(jStat.subtract(xk, xv))) > r){
                    xv = xk;
                    xk = jStat.add(jStat.multiply(h, xv), c);
                    i++;
                }
                return xk;
            },
            householder: function householder(a) {
                var m = a.length;
                var n = a[0].length;
                var i = 0;
                var w = [];
                var p = [];
                var alpha, r, k, j, factor;
                for(; i < m - 1; i++){
                    alpha = 0;
                    for(j = i + 1; j < n; j++)alpha += a[j][i] * a[j][i];
                    factor = a[i + 1][i] > 0 ? -1 : 1;
                    alpha = factor * Math1.sqrt(alpha);
                    r = Math1.sqrt((alpha * alpha - a[i + 1][i] * alpha) / 2);
                    w = jStat.zeros(m, 1);
                    w[i + 1][0] = (a[i + 1][i] - alpha) / (2 * r);
                    for(k = i + 2; k < m; k++)w[k][0] = a[k][i] / (2 * r);
                    p = jStat.subtract(jStat.identity(m, n), jStat.multiply(jStat.multiply(w, jStat.transpose(w)), 2));
                    a = jStat.multiply(p, jStat.multiply(a, p));
                }
                return a;
            },
            // A -> [Q,R]
            // Q is orthogonal matrix
            // R is upper triangular
            QR: function() {
                // x -> Q
                // find a orthogonal matrix Q st.
                // Qx=y
                // y is [||x||,0,0,...]
                // quick ref
                var sum = jStat.sum;
                var range = jStat.arange;
                function qr2(x) {
                    // quick impletation
                    // https://www.stat.wisc.edu/~larget/math496/qr.html
                    var n = x.length;
                    var p = x[0].length;
                    var r = jStat.zeros(p, p);
                    x = jStat.copy(x);
                    var i, j, k;
                    for(j = 0; j < p; j++){
                        r[j][j] = Math1.sqrt(sum(range(n).map(function(i) {
                            return x[i][j] * x[i][j];
                        })));
                        for(i = 0; i < n; i++)x[i][j] = x[i][j] / r[j][j];
                        for(k = j + 1; k < p; k++){
                            r[j][k] = sum(range(n).map(function(i) {
                                return x[i][j] * x[i][k];
                            }));
                            for(i = 0; i < n; i++)x[i][k] = x[i][k] - x[i][j] * r[j][k];
                        }
                    }
                    return [
                        x,
                        r
                    ];
                }
                return qr2;
            }(),
            lstsq: function() {
                // solve least squard problem for Ax=b as QR decomposition way if b is
                // [[b1],[b2],[b3]] form will return [[x1],[x2],[x3]] array form solution
                // else b is [b1,b2,b3] form will return [x1,x2,x3] array form solution
                function R_I(A) {
                    A = jStat.copy(A);
                    var size = A.length;
                    var I = jStat.identity(size);
                    jStat.arange(size - 1, -1, -1).forEach(function(i) {
                        jStat.sliceAssign(I, {
                            row: i
                        }, jStat.divide(jStat.slice(I, {
                            row: i
                        }), A[i][i]));
                        jStat.sliceAssign(A, {
                            row: i
                        }, jStat.divide(jStat.slice(A, {
                            row: i
                        }), A[i][i]));
                        jStat.arange(i).forEach(function(j) {
                            var c = jStat.multiply(A[j][i], -1);
                            var Aj = jStat.slice(A, {
                                row: j
                            });
                            var cAi = jStat.multiply(jStat.slice(A, {
                                row: i
                            }), c);
                            jStat.sliceAssign(A, {
                                row: j
                            }, jStat.add(Aj, cAi));
                            var Ij = jStat.slice(I, {
                                row: j
                            });
                            var cIi = jStat.multiply(jStat.slice(I, {
                                row: i
                            }), c);
                            jStat.sliceAssign(I, {
                                row: j
                            }, jStat.add(Ij, cIi));
                        });
                    });
                    return I;
                }
                function qr_solve(A, b) {
                    var array_mode = false;
                    if (b[0].length === undefined) {
                        // [c1,c2,c3] mode
                        b = b.map(function(x) {
                            return [
                                x
                            ];
                        });
                        array_mode = true;
                    }
                    var QR = jStat.QR(A);
                    var Q = QR[0];
                    var R = QR[1];
                    var attrs = A[0].length;
                    var Q1 = jStat.slice(Q, {
                        col: {
                            end: attrs
                        }
                    });
                    var R1 = jStat.slice(R, {
                        row: {
                            end: attrs
                        }
                    });
                    var RI = R_I(R1);
                    var Q2 = jStat.transpose(Q1);
                    if (Q2[0].length === undefined) Q2 = [
                        Q2
                    ]; // The confusing jStat.multifly implementation threat nature process again.
                    var x = jStat.multiply(jStat.multiply(RI, Q2), b);
                    if (x.length === undefined) x = [
                        [
                            x
                        ]
                    ]; // The confusing jStat.multifly implementation threat nature process again.
                    if (array_mode) return x.map(function(i) {
                        return i[0];
                    });
                    return x;
                }
                return qr_solve;
            }(),
            jacobi: function jacobi(a) {
                var condition = 1;
                var n = a.length;
                var e = jStat.identity(n, n);
                var ev = [];
                var b, i, j, p, q, maxim, theta, s;
                // condition === 1 only if tolerance is not reached
                while(condition === 1){
                    maxim = a[0][1];
                    p = 0;
                    q = 1;
                    for(i = 0; i < n; i++)for(j = 0; j < n; j++){
                        if (i != j) {
                            if (maxim < Math1.abs(a[i][j])) {
                                maxim = Math1.abs(a[i][j]);
                                p = i;
                                q = j;
                            }
                        }
                    }
                    if (a[p][p] === a[q][q]) theta = a[p][q] > 0 ? Math1.PI / 4 : -Math1.PI / 4;
                    else theta = Math1.atan(2 * a[p][q] / (a[p][p] - a[q][q])) / 2;
                    s = jStat.identity(n, n);
                    s[p][p] = Math1.cos(theta);
                    s[p][q] = -Math1.sin(theta);
                    s[q][p] = Math1.sin(theta);
                    s[q][q] = Math1.cos(theta);
                    // eigen vector matrix
                    e = jStat.multiply(e, s);
                    b = jStat.multiply(jStat.multiply(jStat.inv(s), a), s);
                    a = b;
                    condition = 0;
                    for(i = 1; i < n; i++){
                        for(j = 1; j < n; j++)if (i != j && Math1.abs(a[i][j]) > 0.001) condition = 1;
                    }
                }
                for(i = 0; i < n; i++)ev.push(a[i][i]);
                //returns both the eigenvalue and eigenmatrix
                return [
                    e,
                    ev
                ];
            },
            rungekutta: function rungekutta(f, h, p, t_j, u_j, order) {
                var k1, k2, u_j1, k3, k4;
                if (order === 2) while(t_j <= p){
                    k1 = h * f(t_j, u_j);
                    k2 = h * f(t_j + h, u_j + k1);
                    u_j1 = u_j + (k1 + k2) / 2;
                    u_j = u_j1;
                    t_j = t_j + h;
                }
                if (order === 4) while(t_j <= p){
                    k1 = h * f(t_j, u_j);
                    k2 = h * f(t_j + h / 2, u_j + k1 / 2);
                    k3 = h * f(t_j + h / 2, u_j + k2 / 2);
                    k4 = h * f(t_j + h, u_j + k3);
                    u_j1 = u_j + (k1 + 2 * k2 + 2 * k3 + k4) / 6;
                    u_j = u_j1;
                    t_j = t_j + h;
                }
                return u_j;
            },
            romberg: function romberg(f, a, b, order) {
                var i = 0;
                var h = (b - a) / 2;
                var x = [];
                var h1 = [];
                var g = [];
                var m, a1, j, k, I;
                while(i < order / 2){
                    I = f(a);
                    for(j = a, k = 0; j <= b; j = j + h, k++)x[k] = j;
                    m = x.length;
                    for(j = 1; j < m - 1; j++)I += (j % 2 !== 0 ? 4 : 2) * f(x[j]);
                    I = h / 3 * (I + f(b));
                    g[i] = I;
                    h /= 2;
                    i++;
                }
                a1 = g.length;
                m = 1;
                while(a1 !== 1){
                    for(j = 0; j < a1 - 1; j++)h1[j] = (Math1.pow(4, m) * g[j + 1] - g[j]) / (Math1.pow(4, m) - 1);
                    a1 = h1.length;
                    g = h1;
                    h1 = [];
                    m++;
                }
                return g;
            },
            richardson: function richardson(X, f, x, h) {
                function pos(X, x) {
                    var i = 0;
                    var n = X.length;
                    var p;
                    for(; i < n; i++)if (X[i] === x) p = i;
                    return p;
                }
                var h_min = Math1.abs(x - X[pos(X, x) + 1]);
                var i = 0;
                var g = [];
                var h1 = [];
                var y1, y2, m, a, j;
                while(h >= h_min){
                    y1 = pos(X, x + h);
                    y2 = pos(X, x);
                    g[i] = (f[y1] - 2 * f[y2] + f[2 * y2 - y1]) / (h * h);
                    h /= 2;
                    i++;
                }
                a = g.length;
                m = 1;
                while(a != 1){
                    for(j = 0; j < a - 1; j++)h1[j] = (Math1.pow(4, m) * g[j + 1] - g[j]) / (Math1.pow(4, m) - 1);
                    a = h1.length;
                    g = h1;
                    h1 = [];
                    m++;
                }
                return g;
            },
            simpson: function simpson(f, a, b, n) {
                var h = (b - a) / n;
                var I = f(a);
                var x = [];
                var j = a;
                var k = 0;
                var i = 1;
                var m;
                for(; j <= b; j = j + h, k++)x[k] = j;
                m = x.length;
                for(; i < m - 1; i++)I += (i % 2 !== 0 ? 4 : 2) * f(x[i]);
                return h / 3 * (I + f(b));
            },
            hermite: function hermite(X, F, dF, value) {
                var n = X.length;
                var p = 0;
                var i = 0;
                var l = [];
                var dl = [];
                var A = [];
                var B = [];
                var j;
                for(; i < n; i++){
                    l[i] = 1;
                    for(j = 0; j < n; j++)if (i != j) l[i] *= (value - X[j]) / (X[i] - X[j]);
                    dl[i] = 0;
                    for(j = 0; j < n; j++)if (i != j) dl[i] += 1 / (X[i] - X[j]);
                    A[i] = (1 - 2 * (value - X[i]) * dl[i]) * (l[i] * l[i]);
                    B[i] = (value - X[i]) * (l[i] * l[i]);
                    p += A[i] * F[i] + B[i] * dF[i];
                }
                return p;
            },
            lagrange: function lagrange(X, F, value) {
                var p = 0;
                var i = 0;
                var j, l;
                var n = X.length;
                for(; i < n; i++){
                    l = F[i];
                    for(j = 0; j < n; j++)// calculating the lagrange polynomial L_i
                    if (i != j) l *= (value - X[j]) / (X[i] - X[j]);
                    // adding the lagrange polynomials found above
                    p += l;
                }
                return p;
            },
            cubic_spline: function cubic_spline(X, F, value) {
                var n = X.length;
                var i = 0, j;
                var A = [];
                var B = [];
                var alpha = [];
                var c = [];
                var h = [];
                var b = [];
                var d = [];
                for(; i < n - 1; i++)h[i] = X[i + 1] - X[i];
                alpha[0] = 0;
                for(i = 1; i < n - 1; i++)alpha[i] = 3 / h[i] * (F[i + 1] - F[i]) - 3 / h[i - 1] * (F[i] - F[i - 1]);
                for(i = 1; i < n - 1; i++){
                    A[i] = [];
                    B[i] = [];
                    A[i][i - 1] = h[i - 1];
                    A[i][i] = 2 * (h[i - 1] + h[i]);
                    A[i][i + 1] = h[i];
                    B[i][0] = alpha[i];
                }
                c = jStat.multiply(jStat.inv(A), B);
                for(j = 0; j < n - 1; j++){
                    b[j] = (F[j + 1] - F[j]) / h[j] - h[j] * (c[j + 1][0] + 2 * c[j][0]) / 3;
                    d[j] = (c[j + 1][0] - c[j][0]) / (3 * h[j]);
                }
                for(j = 0; j < n; j++){
                    if (X[j] > value) break;
                }
                j -= 1;
                return F[j] + (value - X[j]) * b[j] + jStat.sq(value - X[j]) * c[j] + (value - X[j]) * jStat.sq(value - X[j]) * d[j];
            },
            gauss_quadrature: function gauss_quadrature() {
                throw new Error("gauss_quadrature not yet implemented");
            },
            PCA: function PCA(X) {
                var m = X.length;
                var n = X[0].length;
                var i = 0;
                var j, temp1;
                var u = [];
                var D = [];
                var result = [];
                var temp2 = [];
                var Y = [];
                var Bt = [];
                var B = [];
                var C = [];
                var V = [];
                var Vt = [];
                for(i = 0; i < m; i++)u[i] = jStat.sum(X[i]) / n;
                for(i = 0; i < n; i++){
                    B[i] = [];
                    for(j = 0; j < m; j++)B[i][j] = X[j][i] - u[j];
                }
                B = jStat.transpose(B);
                for(i = 0; i < m; i++){
                    C[i] = [];
                    for(j = 0; j < m; j++)C[i][j] = jStat.dot([
                        B[i]
                    ], [
                        B[j]
                    ]) / (n - 1);
                }
                result = jStat.jacobi(C);
                V = result[0];
                D = result[1];
                Vt = jStat.transpose(V);
                for(i = 0; i < D.length; i++){
                    for(j = i; j < D.length; j++)if (D[i] < D[j]) {
                        temp1 = D[i];
                        D[i] = D[j];
                        D[j] = temp1;
                        temp2 = Vt[i];
                        Vt[i] = Vt[j];
                        Vt[j] = temp2;
                    }
                }
                Bt = jStat.transpose(B);
                for(i = 0; i < m; i++){
                    Y[i] = [];
                    for(j = 0; j < Bt.length; j++)Y[i][j] = jStat.dot([
                        Vt[i]
                    ], [
                        Bt[j]
                    ]);
                }
                return [
                    X,
                    D,
                    Vt,
                    Y
                ];
            }
        });
        // extend jStat.fn with methods that require one argument
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jStat.fn[passfunc] = function(arg, func) {
                    var tmpthis = this;
                    // check for callback
                    if (func) {
                        setTimeout(function() {
                            func.call(tmpthis, jStat.fn[passfunc].call(tmpthis, arg));
                        }, 15);
                        return this;
                    }
                    if (typeof jStat[passfunc](this, arg) === "number") return jStat[passfunc](this, arg);
                    else return jStat(jStat[passfunc](this, arg));
                };
            })(funcs[i]);
        })("add divide multiply subtract dot pow exp log abs norm angle".split(" "));
    })(jStat, Math);
    (function(jStat, Math1) {
        var slice = [].slice;
        var isNumber = jStat.utils.isNumber;
        var isArray = jStat.utils.isArray;
        // flag==true denotes use of sample standard deviation
        // Z Statistics
        jStat.extend({
            // 2 different parameter lists:
            // (value, mean, sd)
            // (value, array, flag)
            zscore: function zscore() {
                var args = slice.call(arguments);
                if (isNumber(args[1])) return (args[0] - args[1]) / args[2];
                return (args[0] - jStat.mean(args[1])) / jStat.stdev(args[1], args[2]);
            },
            // 3 different paramter lists:
            // (value, mean, sd, sides)
            // (zscore, sides)
            // (value, array, sides, flag)
            ztest: function ztest() {
                var args = slice.call(arguments);
                var z;
                if (isArray(args[1])) {
                    // (value, array, sides, flag)
                    z = jStat.zscore(args[0], args[1], args[3]);
                    return args[2] === 1 ? jStat.normal.cdf(-Math1.abs(z), 0, 1) : jStat.normal.cdf(-Math1.abs(z), 0, 1) * 2;
                } else if (args.length > 2) {
                    // (value, mean, sd, sides)
                    z = jStat.zscore(args[0], args[1], args[2]);
                    return args[3] === 1 ? jStat.normal.cdf(-Math1.abs(z), 0, 1) : jStat.normal.cdf(-Math1.abs(z), 0, 1) * 2;
                } else {
                    // (zscore, sides)
                    z = args[0];
                    return args[1] === 1 ? jStat.normal.cdf(-Math1.abs(z), 0, 1) : jStat.normal.cdf(-Math1.abs(z), 0, 1) * 2;
                }
            }
        });
        jStat.extend(jStat.fn, {
            zscore: function zscore(value, flag) {
                return (value - this.mean()) / this.stdev(flag);
            },
            ztest: function ztest(value, sides, flag) {
                var zscore = Math1.abs(this.zscore(value, flag));
                return sides === 1 ? jStat.normal.cdf(-zscore, 0, 1) : jStat.normal.cdf(-zscore, 0, 1) * 2;
            }
        });
        // T Statistics
        jStat.extend({
            // 2 parameter lists
            // (value, mean, sd, n)
            // (value, array)
            tscore: function tscore() {
                var args = slice.call(arguments);
                return args.length === 4 ? (args[0] - args[1]) / (args[2] / Math1.sqrt(args[3])) : (args[0] - jStat.mean(args[1])) / (jStat.stdev(args[1], true) / Math1.sqrt(args[1].length));
            },
            // 3 different paramter lists:
            // (value, mean, sd, n, sides)
            // (tscore, n, sides)
            // (value, array, sides)
            ttest: function ttest() {
                var args = slice.call(arguments);
                var tscore;
                if (args.length === 5) {
                    tscore = Math1.abs(jStat.tscore(args[0], args[1], args[2], args[3]));
                    return args[4] === 1 ? jStat.studentt.cdf(-tscore, args[3] - 1) : jStat.studentt.cdf(-tscore, args[3] - 1) * 2;
                }
                if (isNumber(args[1])) {
                    tscore = Math1.abs(args[0]);
                    return args[2] == 1 ? jStat.studentt.cdf(-tscore, args[1] - 1) : jStat.studentt.cdf(-tscore, args[1] - 1) * 2;
                }
                tscore = Math1.abs(jStat.tscore(args[0], args[1]));
                return args[2] == 1 ? jStat.studentt.cdf(-tscore, args[1].length - 1) : jStat.studentt.cdf(-tscore, args[1].length - 1) * 2;
            }
        });
        jStat.extend(jStat.fn, {
            tscore: function tscore(value) {
                return (value - this.mean()) / (this.stdev(true) / Math1.sqrt(this.cols()));
            },
            ttest: function ttest(value, sides) {
                return sides === 1 ? 1 - jStat.studentt.cdf(Math1.abs(this.tscore(value)), this.cols() - 1) : jStat.studentt.cdf(-Math1.abs(this.tscore(value)), this.cols() - 1) * 2;
            }
        });
        // F Statistics
        jStat.extend({
            // Paramter list is as follows:
            // (array1, array2, array3, ...)
            // or it is an array of arrays
            // array of arrays conversion
            anovafscore: function anovafscore() {
                var args = slice.call(arguments), expVar, sample, sampMean, sampSampMean, tmpargs, unexpVar, i, j;
                if (args.length === 1) {
                    tmpargs = new Array(args[0].length);
                    for(i = 0; i < args[0].length; i++)tmpargs[i] = args[0][i];
                    args = tmpargs;
                }
                // Builds sample array
                sample = new Array();
                for(i = 0; i < args.length; i++)sample = sample.concat(args[i]);
                sampMean = jStat.mean(sample);
                // Computes the explained variance
                expVar = 0;
                for(i = 0; i < args.length; i++)expVar = expVar + args[i].length * Math1.pow(jStat.mean(args[i]) - sampMean, 2);
                expVar /= args.length - 1;
                // Computes unexplained variance
                unexpVar = 0;
                for(i = 0; i < args.length; i++){
                    sampSampMean = jStat.mean(args[i]);
                    for(j = 0; j < args[i].length; j++)unexpVar += Math1.pow(args[i][j] - sampSampMean, 2);
                }
                unexpVar /= sample.length - args.length;
                return expVar / unexpVar;
            },
            // 2 different paramter setups
            // (array1, array2, array3, ...)
            // (anovafscore, df1, df2)
            anovaftest: function anovaftest() {
                var args = slice.call(arguments), df1, df2, n, i;
                if (isNumber(args[0])) return 1 - jStat.centralF.cdf(args[0], args[1], args[2]);
                var anovafscore = jStat.anovafscore(args);
                df1 = args.length - 1;
                n = 0;
                for(i = 0; i < args.length; i++)n = n + args[i].length;
                df2 = n - df1 - 1;
                return 1 - jStat.centralF.cdf(anovafscore, df1, df2);
            },
            ftest: function ftest(fscore, df1, df2) {
                return 1 - jStat.centralF.cdf(fscore, df1, df2);
            }
        });
        jStat.extend(jStat.fn, {
            anovafscore: function anovafscore() {
                return jStat.anovafscore(this.toArray());
            },
            anovaftes: function anovaftes() {
                var n = 0;
                var i;
                for(i = 0; i < this.length; i++)n = n + this[i].length;
                return jStat.ftest(this.anovafscore(), this.length - 1, n - this.length);
            }
        });
        // Tukey's range test
        jStat.extend({
            // 2 parameter lists
            // (mean1, mean2, n1, n2, sd)
            // (array1, array2, sd)
            qscore: function qscore() {
                var args = slice.call(arguments);
                var mean1, mean2, n1, n2, sd;
                if (isNumber(args[0])) {
                    mean1 = args[0];
                    mean2 = args[1];
                    n1 = args[2];
                    n2 = args[3];
                    sd = args[4];
                } else {
                    mean1 = jStat.mean(args[0]);
                    mean2 = jStat.mean(args[1]);
                    n1 = args[0].length;
                    n2 = args[1].length;
                    sd = args[2];
                }
                return Math1.abs(mean1 - mean2) / (sd * Math1.sqrt((1 / n1 + 1 / n2) / 2));
            },
            // 3 different parameter lists:
            // (qscore, n, k)
            // (mean1, mean2, n1, n2, sd, n, k)
            // (array1, array2, sd, n, k)
            qtest: function qtest() {
                var args = slice.call(arguments);
                var qscore;
                if (args.length === 3) {
                    qscore = args[0];
                    args = args.slice(1);
                } else if (args.length === 7) {
                    qscore = jStat.qscore(args[0], args[1], args[2], args[3], args[4]);
                    args = args.slice(5);
                } else {
                    qscore = jStat.qscore(args[0], args[1], args[2]);
                    args = args.slice(3);
                }
                var n = args[0];
                var k = args[1];
                return 1 - jStat.tukey.cdf(qscore, k, n - k);
            },
            tukeyhsd: function tukeyhsd(arrays) {
                var sd = jStat.pooledstdev(arrays);
                var means = arrays.map(function(arr) {
                    return jStat.mean(arr);
                });
                var n = arrays.reduce(function(n, arr) {
                    return n + arr.length;
                }, 0);
                var results = [];
                for(var i = 0; i < arrays.length; ++i)for(var j = i + 1; j < arrays.length; ++j){
                    var p = jStat.qtest(means[i], means[j], arrays[i].length, arrays[j].length, sd, n, arrays.length);
                    results.push([
                        [
                            i,
                            j
                        ],
                        p
                    ]);
                }
                return results;
            }
        });
        // Error Bounds
        jStat.extend({
            // 2 different parameter setups
            // (value, alpha, sd, n)
            // (value, alpha, array)
            normalci: function normalci() {
                var args = slice.call(arguments), ans = new Array(2), change;
                if (args.length === 4) change = Math1.abs(jStat.normal.inv(args[1] / 2, 0, 1) * args[2] / Math1.sqrt(args[3]));
                else change = Math1.abs(jStat.normal.inv(args[1] / 2, 0, 1) * jStat.stdev(args[2]) / Math1.sqrt(args[2].length));
                ans[0] = args[0] - change;
                ans[1] = args[0] + change;
                return ans;
            },
            // 2 different parameter setups
            // (value, alpha, sd, n)
            // (value, alpha, array)
            tci: function tci() {
                var args = slice.call(arguments), ans = new Array(2), change;
                if (args.length === 4) change = Math1.abs(jStat.studentt.inv(args[1] / 2, args[3] - 1) * args[2] / Math1.sqrt(args[3]));
                else change = Math1.abs(jStat.studentt.inv(args[1] / 2, args[2].length - 1) * jStat.stdev(args[2], true) / Math1.sqrt(args[2].length));
                ans[0] = args[0] - change;
                ans[1] = args[0] + change;
                return ans;
            },
            significant: function significant(pvalue, alpha) {
                return pvalue < alpha;
            }
        });
        jStat.extend(jStat.fn, {
            normalci: function normalci(value, alpha) {
                return jStat.normalci(value, alpha, this.toArray());
            },
            tci: function tci(value, alpha) {
                return jStat.tci(value, alpha, this.toArray());
            }
        });
        // internal method for calculating the z-score for a difference of proportions test
        function differenceOfProportions(p1, n1, p2, n2) {
            if (p1 > 1 || p2 > 1 || p1 <= 0 || p2 <= 0) throw new Error("Proportions should be greater than 0 and less than 1");
            var pooled = (p1 * n1 + p2 * n2) / (n1 + n2);
            var se = Math1.sqrt(pooled * (1 - pooled) * (1 / n1 + 1 / n2));
            return (p1 - p2) / se;
        }
        // Difference of Proportions
        jStat.extend(jStat.fn, {
            oneSidedDifferenceOfProportions: function oneSidedDifferenceOfProportions(p1, n1, p2, n2) {
                var z = differenceOfProportions(p1, n1, p2, n2);
                return jStat.ztest(z, 1);
            },
            twoSidedDifferenceOfProportions: function twoSidedDifferenceOfProportions(p1, n1, p2, n2) {
                var z = differenceOfProportions(p1, n1, p2, n2);
                return jStat.ztest(z, 2);
            }
        });
    })(jStat, Math);
    jStat.models = function() {
        function sub_regress(exog) {
            var var_count = exog[0].length;
            var modelList = jStat.arange(var_count).map(function(endog_index) {
                var exog_index = jStat.arange(var_count).filter(function(i) {
                    return i !== endog_index;
                });
                return ols(jStat.col(exog, endog_index).map(function(x) {
                    return x[0];
                }), jStat.col(exog, exog_index));
            });
            return modelList;
        }
        // do OLS model regress
        // exog have include const columns ,it will not generate it .In fact, exog is
        // "design matrix" look at
        //https://en.wikipedia.org/wiki/Design_matrix
        function ols(endog, exog) {
            var nobs = endog.length;
            var df_model = exog[0].length - 1;
            var df_resid = nobs - df_model - 1;
            var coef = jStat.lstsq(exog, endog);
            var predict = jStat.multiply(exog, coef.map(function(x) {
                return [
                    x
                ];
            })).map(function(p) {
                return p[0];
            });
            var resid = jStat.subtract(endog, predict);
            var ybar = jStat.mean(endog);
            // constant cause problem
            // var SST = jStat.sum(endog.map(function(y) {
            //   return Math.pow(y-ybar,2);
            // }));
            var SSE = jStat.sum(predict.map(function(f) {
                return Math.pow(f - ybar, 2);
            }));
            var SSR = jStat.sum(endog.map(function(y, i) {
                return Math.pow(y - predict[i], 2);
            }));
            var SST = SSE + SSR;
            var R2 = SSE / SST;
            return {
                exog: exog,
                endog: endog,
                nobs: nobs,
                df_model: df_model,
                df_resid: df_resid,
                coef: coef,
                predict: predict,
                resid: resid,
                ybar: ybar,
                SST: SST,
                SSE: SSE,
                SSR: SSR,
                R2: R2
            };
        }
        // H0: b_I=0
        // H1: b_I!=0
        function t_test(model) {
            var subModelList = sub_regress(model.exog);
            //var sigmaHat=jStat.stdev(model.resid);
            var sigmaHat = Math.sqrt(model.SSR / model.df_resid);
            var seBetaHat = subModelList.map(function(mod) {
                var SST = mod.SST;
                var R2 = mod.R2;
                return sigmaHat / Math.sqrt(SST * (1 - R2));
            });
            var tStatistic = model.coef.map(function(coef, i) {
                return (coef - 0) / seBetaHat[i];
            });
            var pValue = tStatistic.map(function(t) {
                var leftppf = jStat.studentt.cdf(t, model.df_resid);
                return (leftppf > 0.5 ? 1 - leftppf : leftppf) * 2;
            });
            var c = jStat.studentt.inv(0.975, model.df_resid);
            var interval95 = model.coef.map(function(coef, i) {
                var d = c * seBetaHat[i];
                return [
                    coef - d,
                    coef + d
                ];
            });
            return {
                se: seBetaHat,
                t: tStatistic,
                p: pValue,
                sigmaHat: sigmaHat,
                interval95: interval95
            };
        }
        function F_test(model) {
            var F_statistic = model.R2 / model.df_model / ((1 - model.R2) / model.df_resid);
            var fcdf = function(x, n1, n2) {
                return jStat.beta.cdf(x / (n2 / n1 + x), n1 / 2, n2 / 2);
            };
            var pvalue = 1 - fcdf(F_statistic, model.df_model, model.df_resid);
            return {
                F_statistic: F_statistic,
                pvalue: pvalue
            };
        }
        function ols_wrap(endog, exog) {
            var model = ols(endog, exog);
            var ttest = t_test(model);
            var ftest = F_test(model);
            // Provide the Wherry / Ezekiel / McNemar / Cohen Adjusted R^2
            // Which matches the 'adjusted R^2' provided by R's lm package
            var adjust_R2 = 1 - (1 - model.R2) * ((model.nobs - 1) / model.df_resid);
            model.t = ttest;
            model.f = ftest;
            model.adjust_R2 = adjust_R2;
            return model;
        }
        return {
            ols: ols_wrap
        };
    }();
    //To regress, simply build X matrix
    //(append column of 1's) using
    //buildxmatrix and build the Y
    //matrix using buildymatrix
    //(simply the transpose)
    //and run regress.
    //Regressions
    jStat.extend({
        buildxmatrix: function buildxmatrix() {
            //Parameters will be passed in as such
            //(array1,array2,array3,...)
            //as (x1,x2,x3,...)
            //needs to be (1,x1,x2,x3,...)
            var matrixRows = new Array(arguments.length);
            for(var i = 0; i < arguments.length; i++){
                var array = [
                    1
                ];
                matrixRows[i] = array.concat(arguments[i]);
            }
            return jStat(matrixRows);
        },
        builddxmatrix: function builddxmatrix() {
            //Paramters will be passed in as such
            //([array1,array2,...]
            var matrixRows = new Array(arguments[0].length);
            for(var i = 0; i < arguments[0].length; i++){
                var array = [
                    1
                ];
                matrixRows[i] = array.concat(arguments[0][i]);
            }
            return jStat(matrixRows);
        },
        buildjxmatrix: function buildjxmatrix(jMat) {
            //Builds from jStat Matrix
            var pass = new Array(jMat.length);
            for(var i = 0; i < jMat.length; i++)pass[i] = jMat[i];
            return jStat.builddxmatrix(pass);
        },
        buildymatrix: function buildymatrix(array) {
            return jStat(array).transpose();
        },
        buildjymatrix: function buildjymatrix(jMat) {
            return jMat.transpose();
        },
        matrixmult: function matrixmult(A, B) {
            var i, j, k, result, sum;
            if (A.cols() == B.rows()) {
                if (B.rows() > 1) {
                    result = [];
                    for(i = 0; i < A.rows(); i++){
                        result[i] = [];
                        for(j = 0; j < B.cols(); j++){
                            sum = 0;
                            for(k = 0; k < A.cols(); k++)sum += A.toArray()[i][k] * B.toArray()[k][j];
                            result[i][j] = sum;
                        }
                    }
                    return jStat(result);
                }
                result = [];
                for(i = 0; i < A.rows(); i++){
                    result[i] = [];
                    for(j = 0; j < B.cols(); j++){
                        sum = 0;
                        for(k = 0; k < A.cols(); k++)sum += A.toArray()[i][k] * B.toArray()[j];
                        result[i][j] = sum;
                    }
                }
                return jStat(result);
            }
        },
        //regress and regresst to be fixed
        regress: function regress(jMatX, jMatY) {
            //print("regressin!");
            //print(jMatX.toArray());
            var innerinv = jStat.xtranspxinv(jMatX);
            //print(innerinv);
            var xtransp = jMatX.transpose();
            var next = jStat.matrixmult(jStat(innerinv), xtransp);
            return jStat.matrixmult(next, jMatY);
        },
        regresst: function regresst(jMatX, jMatY, sides) {
            var beta = jStat.regress(jMatX, jMatY);
            var compile = {};
            compile.anova = {};
            var jMatYBar = jStat.jMatYBar(jMatX, beta);
            compile.yBar = jMatYBar;
            var yAverage = jMatY.mean();
            compile.anova.residuals = jStat.residuals(jMatY, jMatYBar);
            compile.anova.ssr = jStat.ssr(jMatYBar, yAverage);
            compile.anova.msr = compile.anova.ssr / (jMatX[0].length - 1);
            compile.anova.sse = jStat.sse(jMatY, jMatYBar);
            compile.anova.mse = compile.anova.sse / (jMatY.length - (jMatX[0].length - 1) - 1);
            compile.anova.sst = jStat.sst(jMatY, yAverage);
            compile.anova.mst = compile.anova.sst / (jMatY.length - 1);
            compile.anova.r2 = 1 - compile.anova.sse / compile.anova.sst;
            if (compile.anova.r2 < 0) compile.anova.r2 = 0;
            compile.anova.fratio = compile.anova.msr / compile.anova.mse;
            compile.anova.pvalue = jStat.anovaftest(compile.anova.fratio, jMatX[0].length - 1, jMatY.length - (jMatX[0].length - 1) - 1);
            compile.anova.rmse = Math.sqrt(compile.anova.mse);
            compile.anova.r2adj = 1 - compile.anova.mse / compile.anova.mst;
            if (compile.anova.r2adj < 0) compile.anova.r2adj = 0;
            compile.stats = new Array(jMatX[0].length);
            var covar = jStat.xtranspxinv(jMatX);
            var sds, ts, ps;
            for(var i = 0; i < beta.length; i++){
                sds = Math.sqrt(compile.anova.mse * Math.abs(covar[i][i]));
                ts = Math.abs(beta[i] / sds);
                ps = jStat.ttest(ts, jMatY.length - jMatX[0].length - 1, sides);
                compile.stats[i] = [
                    beta[i],
                    sds,
                    ts,
                    ps
                ];
            }
            compile.regress = beta;
            return compile;
        },
        xtranspx: function xtranspx(jMatX) {
            return jStat.matrixmult(jMatX.transpose(), jMatX);
        },
        xtranspxinv: function xtranspxinv(jMatX) {
            var inner = jStat.matrixmult(jMatX.transpose(), jMatX);
            var innerinv = jStat.inv(inner);
            return innerinv;
        },
        jMatYBar: function jMatYBar(jMatX, beta) {
            var yBar = jStat.matrixmult(jMatX, beta);
            return new jStat(yBar);
        },
        residuals: function residuals(jMatY, jMatYBar) {
            return jStat.matrixsubtract(jMatY, jMatYBar);
        },
        ssr: function ssr(jMatYBar, yAverage) {
            var ssr = 0;
            for(var i = 0; i < jMatYBar.length; i++)ssr += Math.pow(jMatYBar[i] - yAverage, 2);
            return ssr;
        },
        sse: function sse(jMatY, jMatYBar) {
            var sse = 0;
            for(var i = 0; i < jMatY.length; i++)sse += Math.pow(jMatY[i] - jMatYBar[i], 2);
            return sse;
        },
        sst: function sst(jMatY, yAverage) {
            var sst = 0;
            for(var i = 0; i < jMatY.length; i++)sst += Math.pow(jMatY[i] - yAverage, 2);
            return sst;
        },
        matrixsubtract: function matrixsubtract(A, B) {
            var ans = new Array(A.length);
            for(var i = 0; i < A.length; i++){
                ans[i] = new Array(A[i].length);
                for(var j = 0; j < A[i].length; j++)ans[i][j] = A[i][j] - B[i][j];
            }
            return jStat(ans);
        }
    });
    // Make it compatible with previous version.
    jStat.jStat = jStat;
    return jStat;
});


var $72976088a75d37a8$exports = {};
/* bessel.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported BESSEL */ var $72976088a75d37a8$var$BESSEL;
(function(factory) {
    /*jshint ignore:start */ if (typeof DO_NOT_EXPORT_BESSEL === "undefined") factory($72976088a75d37a8$exports);
    else factory($72976088a75d37a8$var$BESSEL = {});
/*jshint ignore:end */ })(function(BESSEL) {
    BESSEL.version = "1.0.2";
    var M = Math;
    function _horner(arr, v) {
        for(var i = 0, z = 0; i < arr.length; ++i)z = v * z + arr[i];
        return z;
    }
    function _bessel_iter(x, n, f0, f1, sign) {
        if (n === 0) return f0;
        if (n === 1) return f1;
        var tdx = 2 / x, f2 = f1;
        for(var o = 1; o < n; ++o){
            f2 = f1 * o * tdx + sign * f0;
            f0 = f1;
            f1 = f2;
        }
        return f2;
    }
    function _bessel_wrap(bessel0, bessel1, name, nonzero, sign) {
        return function bessel(x, n) {
            if (nonzero) {
                if (x === 0) return nonzero == 1 ? -Infinity : Infinity;
                else if (x < 0) return NaN;
            }
            if (n === 0) return bessel0(x);
            if (n === 1) return bessel1(x);
            if (n < 0) return NaN;
            n |= 0;
            var b0 = bessel0(x), b1 = bessel1(x);
            return _bessel_iter(x, n, b0, b1, sign);
        };
    }
    var besselj = function() {
        var W = 0.636619772; // 2 / Math.PI
        var b0_a1a = [
            57568490574.0,
            -13362590354,
            651619640.7,
            -11214424.18,
            77392.33017,
            -184.9052456
        ].reverse();
        var b0_a2a = [
            57568490411.0,
            1029532985.0,
            9494680.718,
            59272.64853,
            267.8532712,
            1.0
        ].reverse();
        var b0_a1b = [
            1.0,
            -0.001098628627,
            0.2734510407e-4,
            -0.000002073370639,
            0.2093887211e-6
        ].reverse();
        var b0_a2b = [
            -0.01562499995,
            0.1430488765e-3,
            -0.000006911147651,
            0.7621095161e-6,
            -0.0000000934935152
        ].reverse();
        function bessel0(x) {
            var a = 0, a1 = 0, a2 = 0, y = x * x;
            if (x < 8) {
                a1 = _horner(b0_a1a, y);
                a2 = _horner(b0_a2a, y);
                a = a1 / a2;
            } else {
                var xx = x - 0.785398164;
                y = 64 / y;
                a1 = _horner(b0_a1b, y);
                a2 = _horner(b0_a2b, y);
                a = M.sqrt(W / x) * (M.cos(xx) * a1 - M.sin(xx) * a2 * 8 / x);
            }
            return a;
        }
        var b1_a1a = [
            72362614232.0,
            -7895059235,
            242396853.1,
            -2972611.439,
            15704.48260,
            -30.16036606
        ].reverse();
        var b1_a2a = [
            144725228442.0,
            2300535178.0,
            18583304.74,
            99447.43394,
            376.9991397,
            1.0
        ].reverse();
        var b1_a1b = [
            1.0,
            0.183105e-2,
            -0.00003516396496,
            0.2457520174e-5,
            -0.000000240337019
        ].reverse();
        var b1_a2b = [
            0.04687499995,
            -0.0002002690873,
            0.8449199096e-5,
            -0.00000088228987,
            0.105787412e-6
        ].reverse();
        function bessel1(x) {
            var a = 0, a1 = 0, a2 = 0, y = x * x, xx = M.abs(x) - 2.356194491;
            if (Math.abs(x) < 8) {
                a1 = x * _horner(b1_a1a, y);
                a2 = _horner(b1_a2a, y);
                a = a1 / a2;
            } else {
                y = 64 / y;
                a1 = _horner(b1_a1b, y);
                a2 = _horner(b1_a2b, y);
                a = M.sqrt(W / M.abs(x)) * (M.cos(xx) * a1 - M.sin(xx) * a2 * 8 / M.abs(x));
                if (x < 0) a = -a;
            }
            return a;
        }
        return function besselj(x, n) {
            n = Math.round(n);
            if (!isFinite(x)) return isNaN(x) ? x : 0;
            if (n < 0) return (n % 2 ? -1 : 1) * besselj(x, -n);
            if (x < 0) return (n % 2 ? -1 : 1) * besselj(-x, n);
            if (n === 0) return bessel0(x);
            if (n === 1) return bessel1(x);
            if (x === 0) return 0;
            var ret = 0.0;
            if (x > n) ret = _bessel_iter(x, n, bessel0(x), bessel1(x), -1);
            else {
                var m = 2 * M.floor((n + M.floor(M.sqrt(40 * n))) / 2);
                var jsum = false;
                var bjp = 0.0, sum = 0.0;
                var bj = 1.0, bjm = 0.0;
                var tox = 2 / x;
                for(var j = m; j > 0; j--){
                    bjm = j * tox * bj - bjp;
                    bjp = bj;
                    bj = bjm;
                    if (M.abs(bj) > 1E10) {
                        bj *= 1E-10;
                        bjp *= 1E-10;
                        ret *= 1E-10;
                        sum *= 1E-10;
                    }
                    if (jsum) sum += bj;
                    jsum = !jsum;
                    if (j == n) ret = bjp;
                }
                sum = 2.0 * sum - bj;
                ret /= sum;
            }
            return ret;
        };
    }();
    var bessely = function() {
        var W = 0.636619772;
        var b0_a1a = [
            -2957821389,
            7062834065.0,
            -512359803.6,
            10879881.29,
            -86327.92757,
            228.4622733
        ].reverse();
        var b0_a2a = [
            40076544269.0,
            745249964.8,
            7189466.438,
            47447.26470,
            226.1030244,
            1.0
        ].reverse();
        var b0_a1b = [
            1.0,
            -0.001098628627,
            0.2734510407e-4,
            -0.000002073370639,
            0.2093887211e-6
        ].reverse();
        var b0_a2b = [
            -0.01562499995,
            0.1430488765e-3,
            -0.000006911147651,
            0.7621095161e-6,
            -0.0000000934945152
        ].reverse();
        function bessel0(x) {
            var a = 0, a1 = 0, a2 = 0, y = x * x, xx = x - 0.785398164;
            if (x < 8) {
                a1 = _horner(b0_a1a, y);
                a2 = _horner(b0_a2a, y);
                a = a1 / a2 + W * besselj(x, 0) * M.log(x);
            } else {
                y = 64 / y;
                a1 = _horner(b0_a1b, y);
                a2 = _horner(b0_a2b, y);
                a = M.sqrt(W / x) * (M.sin(xx) * a1 + M.cos(xx) * a2 * 8 / x);
            }
            return a;
        }
        var b1_a1a = [
            -4900604943000,
            0.1275274390e13,
            -51534381390,
            0.7349264551e9,
            -4237922.726,
            0.8511937935e4
        ].reverse();
        var b1_a2a = [
            0.2499580570e14,
            0.4244419664e12,
            0.3733650367e10,
            0.2245904002e8,
            0.1020426050e6,
            0.3549632885e3,
            1
        ].reverse();
        var b1_a1b = [
            1.0,
            0.183105e-2,
            -0.00003516396496,
            0.2457520174e-5,
            -0.000000240337019
        ].reverse();
        var b1_a2b = [
            0.04687499995,
            -0.0002002690873,
            0.8449199096e-5,
            -0.00000088228987,
            0.105787412e-6
        ].reverse();
        function bessel1(x) {
            var a = 0, a1 = 0, a2 = 0, y = x * x, xx = x - 2.356194491;
            if (x < 8) {
                a1 = x * _horner(b1_a1a, y);
                a2 = _horner(b1_a2a, y);
                a = a1 / a2 + W * (besselj(x, 1) * M.log(x) - 1 / x);
            } else {
                y = 64 / y;
                a1 = _horner(b1_a1b, y);
                a2 = _horner(b1_a2b, y);
                a = M.sqrt(W / x) * (M.sin(xx) * a1 + M.cos(xx) * a2 * 8 / x);
            }
            return a;
        }
        return _bessel_wrap(bessel0, bessel1, "BESSELY", 1, -1);
    }();
    var besseli = function() {
        var b0_a = [
            1.0,
            3.5156229,
            3.0899424,
            1.2067492,
            0.2659732,
            0.360768e-1,
            0.45813e-2
        ].reverse();
        var b0_b = [
            0.39894228,
            0.1328592e-1,
            0.225319e-2,
            -0.00157565,
            0.916281e-2,
            -0.02057706,
            0.2635537e-1,
            -0.01647633,
            0.392377e-2
        ].reverse();
        function bessel0(x) {
            if (x <= 3.75) return _horner(b0_a, x * x / 14.0625);
            return M.exp(M.abs(x)) / M.sqrt(M.abs(x)) * _horner(b0_b, 3.75 / M.abs(x));
        }
        var b1_a = [
            0.5,
            0.87890594,
            0.51498869,
            0.15084934,
            0.2658733e-1,
            0.301532e-2,
            0.32411e-3
        ].reverse();
        var b1_b = [
            0.39894228,
            -0.03988024,
            -0.00362018,
            0.163801e-2,
            -0.01031555,
            0.2282967e-1,
            -0.02895312,
            0.1787654e-1,
            -0.00420059
        ].reverse();
        function bessel1(x) {
            if (x < 3.75) return x * _horner(b1_a, x * x / 14.0625);
            return (x < 0 ? -1 : 1) * M.exp(M.abs(x)) / M.sqrt(M.abs(x)) * _horner(b1_b, 3.75 / M.abs(x));
        }
        return function besseli(x, n) {
            n = Math.round(n);
            if (n === 0) return bessel0(x);
            if (n === 1) return bessel1(x);
            if (n < 0) return NaN;
            if (M.abs(x) === 0) return 0;
            if (x == Infinity) return Infinity;
            var ret = 0.0, j, tox = 2 / M.abs(x), bip = 0.0, bi = 1.0, bim = 0.0;
            var m = 2 * M.round((n + M.round(M.sqrt(40 * n))) / 2);
            for(j = m; j > 0; j--){
                bim = j * tox * bi + bip;
                bip = bi;
                bi = bim;
                if (M.abs(bi) > 1E10) {
                    bi *= 1E-10;
                    bip *= 1E-10;
                    ret *= 1E-10;
                }
                if (j == n) ret = bip;
            }
            ret *= besseli(x, 0) / bi;
            return x < 0 && n % 2 ? -ret : ret;
        };
    }();
    var besselk = function() {
        var b0_a = [
            -0.57721566,
            0.42278420,
            0.23069756,
            0.3488590e-1,
            0.262698e-2,
            0.10750e-3,
            0.74e-5
        ].reverse();
        var b0_b = [
            1.25331414,
            -0.07832358,
            0.2189568e-1,
            -0.01062446,
            0.587872e-2,
            -0.0025154,
            0.53208e-3
        ].reverse();
        function bessel0(x) {
            if (x <= 2) return -M.log(x / 2) * besseli(x, 0) + _horner(b0_a, x * x / 4);
            return M.exp(-x) / M.sqrt(x) * _horner(b0_b, 2 / x);
        }
        var b1_a = [
            1.0,
            0.15443144,
            -0.67278579,
            -0.18156897,
            -0.01919402,
            -0.00110404,
            -0.00004686
        ].reverse();
        var b1_b = [
            1.25331414,
            0.23498619,
            -0.0365562,
            0.1504268e-1,
            -0.00780353,
            0.325614e-2,
            -0.00068245
        ].reverse();
        function bessel1(x) {
            if (x <= 2) return M.log(x / 2) * besseli(x, 1) + 1 / x * _horner(b1_a, x * x / 4);
            return M.exp(-x) / M.sqrt(x) * _horner(b1_b, 2 / x);
        }
        return _bessel_wrap(bessel0, bessel1, "BESSELK", 2, 1);
    }();
    BESSEL.besselj = besselj;
    BESSEL.bessely = bessely;
    BESSEL.besseli = besseli;
    BESSEL.besselk = besselk;
});


const $d551340dd0bc6b22$var$nil = new Error("#NULL!");
const $d551340dd0bc6b22$var$div0 = new Error("#DIV/0!");
const $d551340dd0bc6b22$var$value = new Error("#VALUE!");
const $d551340dd0bc6b22$var$ref = new Error("#REF!");
const $d551340dd0bc6b22$var$name = new Error("#NAME?");
const $d551340dd0bc6b22$var$num = new Error("#NUM!");
const $d551340dd0bc6b22$var$na = new Error("#N/A");
const $d551340dd0bc6b22$var$error = new Error("#ERROR!");
const $d551340dd0bc6b22$var$data = new Error("#GETTING_DATA");
var $d551340dd0bc6b22$var$errors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    data: $d551340dd0bc6b22$var$data,
    div0: $d551340dd0bc6b22$var$div0,
    error: $d551340dd0bc6b22$var$error,
    na: $d551340dd0bc6b22$var$na,
    name: $d551340dd0bc6b22$var$name,
    nil: $d551340dd0bc6b22$var$nil,
    num: $d551340dd0bc6b22$var$num,
    ref: $d551340dd0bc6b22$var$ref,
    value: $d551340dd0bc6b22$var$value
});
// Arrays
function $d551340dd0bc6b22$var$argsToArray(args) {
    const result = [];
    $d551340dd0bc6b22$var$arrayEach(args, (value)=>{
        result.push(value);
    });
    return result;
}
function $d551340dd0bc6b22$var$arrayEach(array, iteratee) {
    let index = -1;
    const length = array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
function $d551340dd0bc6b22$var$arrayValuesToNumbers(arr) {
    let n = arr.length;
    let el;
    while(n--){
        el = arr[n];
        if (typeof el === "number") continue;
        if (el === true) {
            arr[n] = 1;
            continue;
        }
        if (el === false) {
            arr[n] = 0;
            continue;
        }
        if (typeof el === "string") {
            const number = $d551340dd0bc6b22$var$parseNumber(el);
            arr[n] = number instanceof Error ? 0 : number;
        }
    }
    return arr;
}
function $d551340dd0bc6b22$var$fillMatrix(matrix, fill_value) {
    if (!matrix) return $d551340dd0bc6b22$var$value;
    if (!matrix.every((el)=>Array.isArray(el)) || matrix.length === 0) matrix = [
        [
            ...matrix
        ]
    ];
    matrix.map((arr, i)=>{
        arr.map((a, j)=>{
            if (!a) matrix[i][j] = 0;
        });
    });
    const longestArrayIndex = matrix.reduce((acc, arr, i)=>arr.length > matrix[acc].length ? i : acc, 0);
    const longestArrayLength = matrix[longestArrayIndex].length;
    return matrix.map((el)=>[
            ...el,
            ...Array(longestArrayLength - el.length).fill(fill_value ? fill_value : 0)
        ]);
}
function $d551340dd0bc6b22$var$flatten() {
    let result;
    if (arguments.length === 1) {
        const argument = arguments[0];
        result = $d551340dd0bc6b22$var$isArrayLike(argument) ? $d551340dd0bc6b22$var$argsToArray.apply(null, arguments) : [
            argument
        ];
    } else result = Array.from(arguments);
    while(!$d551340dd0bc6b22$var$isFlat(result))result = $d551340dd0bc6b22$var$flattenShallow(result);
    return result;
}
function $d551340dd0bc6b22$var$flattenShallow(array) {
    if (!array || !array.reduce) return [
        array
    ];
    return array.reduce((a, b)=>{
        const aIsArray = Array.isArray(a);
        const bIsArray = Array.isArray(b);
        if (aIsArray && bIsArray) return a.concat(b);
        if (aIsArray) {
            a.push(b);
            return a;
        }
        if (bIsArray) return [
            a
        ].concat(b);
        return [
            a,
            b
        ];
    });
}
function $d551340dd0bc6b22$var$initial(array, idx) {
    idx = idx || 1;
    if (!array || typeof array.slice !== "function") return array;
    return array.slice(0, array.length - idx);
}
function $d551340dd0bc6b22$var$isArrayLike(a) {
    return a != null && typeof a.length === "number" && typeof a !== "string";
}
function $d551340dd0bc6b22$var$isFlat(array) {
    if (!array) return false;
    for(let i = 0; i < array.length; ++i){
        if (Array.isArray(array[i])) return false;
    }
    return true;
}
function $d551340dd0bc6b22$var$rest(array, idx) {
    idx = idx || 1;
    if (!array || typeof array.slice !== "function") return array;
    return array.slice(idx);
}
function $d551340dd0bc6b22$var$transpose(matrix) {
    if (!matrix) return $d551340dd0bc6b22$var$value;
    return matrix[0].map((col, i)=>matrix.map((row)=>row[i]));
}
// Databases
function $d551340dd0bc6b22$var$findField(database, title) {
    let index = null;
    $d551340dd0bc6b22$var$arrayEach(database, (value, i)=>{
        if (value[0] === title) {
            index = i;
            return false;
        }
    });
    // Return error if the input field title is incorrect
    if (index == null) return $d551340dd0bc6b22$var$value;
    return index;
}
// Errors
function $d551340dd0bc6b22$var$anyError() {
    for(let n = 0; n < arguments.length; n++){
        if (arguments[n] instanceof Error) return arguments[n];
    }
    return undefined;
}
function $d551340dd0bc6b22$var$anyIsError() {
    let n = arguments.length;
    while(n--){
        if (arguments[n] instanceof Error) return true;
    }
    return false;
}
// Numbers
function $d551340dd0bc6b22$var$cleanFloat(number) {
    const power = 1e14;
    return Math.round(number * power) / power;
}
function $d551340dd0bc6b22$var$numbers() {
    const possibleNumbers = $d551340dd0bc6b22$var$flatten.apply(null, arguments);
    return possibleNumbers.filter((el)=>typeof el === "number");
}
function $d551340dd0bc6b22$var$serialNumberToDate(serial) {
    if (serial < 60) serial += 1;
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    const fractional_day = serial - Math.floor(serial) + 0.0000001;
    let total_seconds = Math.floor(86400 * fractional_day);
    const seconds = total_seconds % 60;
    total_seconds -= seconds;
    const hours = Math.floor(total_seconds / 3600);
    const minutes = Math.floor(total_seconds / 60) % 60;
    let days = date_info.getUTCDate();
    let month = date_info.getUTCMonth();
    if (serial >= 60 && serial < 61) {
        days = 29;
        month = 1;
    }
    return new Date(date_info.getUTCFullYear(), month, days, hours, minutes, seconds);
}
// Parsers
function $d551340dd0bc6b22$var$parseBool(bool) {
    if (typeof bool === "boolean") return bool;
    if (bool instanceof Error) return bool;
    if (typeof bool === "number") return bool !== 0;
    if (typeof bool === "string") {
        const up = bool.toUpperCase();
        if (up === "TRUE") return true;
        if (up === "FALSE") return false;
    }
    if (bool instanceof Date && !isNaN(bool)) return true;
    return $d551340dd0bc6b22$var$value;
}
function $d551340dd0bc6b22$var$parseDate(date) {
    if (!isNaN(date)) {
        if (date instanceof Date) return new Date(date);
        const d = parseFloat(date);
        if (d < 0 || d >= 2958466) return $d551340dd0bc6b22$var$num;
        return $d551340dd0bc6b22$var$serialNumberToDate(d);
    }
    if (typeof date === "string") {
        date = /(\d{4})-(\d\d?)-(\d\d?)$/.test(date) ? new Date(date + "T00:00:00.000") : new Date(date);
        if (!isNaN(date)) return date;
    }
    return $d551340dd0bc6b22$var$value;
}
function $d551340dd0bc6b22$var$parseDateArray(arr) {
    let len = arr.length;
    let parsed;
    while(len--){
        parsed = $d551340dd0bc6b22$var$parseDate(arr[len]);
        if (parsed === $d551340dd0bc6b22$var$value) return parsed;
        arr[len] = parsed;
    }
    return arr;
}
function $d551340dd0bc6b22$var$parseNumber(string) {
    if (string instanceof Error) return string;
    if (string === undefined || string === null) return 0;
    if (typeof string === "boolean") string = +string;
    if (!isNaN(string) && string !== "") return parseFloat(string);
    return $d551340dd0bc6b22$var$value;
}
function $d551340dd0bc6b22$var$parseNumberArray(arr) {
    let len;
    if (!arr || (len = arr.length) === 0) return $d551340dd0bc6b22$var$value;
    let parsed;
    while(len--){
        if (arr[len] instanceof Error) return arr[len];
        parsed = $d551340dd0bc6b22$var$parseNumber(arr[len]);
        if (parsed instanceof Error) return parsed;
        arr[len] = parsed;
    }
    return arr;
}
function $d551340dd0bc6b22$var$parseString(string) {
    if (string instanceof Error) return string;
    if (string === undefined || string === null) return "";
    return string.toString();
}
// Strings
function $d551340dd0bc6b22$var$anyIsString() {
    let n = arguments.length;
    while(n--){
        if (typeof arguments[n] === "string") return true;
    }
    return false;
}
// Misc
function $d551340dd0bc6b22$var$isDefined(arg) {
    return arg !== undefined && arg !== null;
}
const $d551340dd0bc6b22$var$defaultOperator = "=";
const $d551340dd0bc6b22$var$validSymbols = [
    ">",
    ">=",
    "<",
    "<=",
    "=",
    "<>"
];
const $d551340dd0bc6b22$var$_TOKEN_TYPE_OPERATOR = "operator";
const $d551340dd0bc6b22$var$_TOKEN_TYPE_LITERAL = "literal";
const $d551340dd0bc6b22$var$SUPPORTED_TOKENS = [
    $d551340dd0bc6b22$var$_TOKEN_TYPE_OPERATOR,
    $d551340dd0bc6b22$var$_TOKEN_TYPE_LITERAL
];
const $d551340dd0bc6b22$var$TOKEN_TYPE_OPERATOR = $d551340dd0bc6b22$var$_TOKEN_TYPE_OPERATOR;
const $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL = $d551340dd0bc6b22$var$_TOKEN_TYPE_LITERAL;
/**
 * Create token which describe passed symbol/value.
 *
 * @param {String} value Value/Symbol to describe.
 * @param {String} type Type of the token 'operator' or 'literal'.
 * @return {Object}
 */ function $d551340dd0bc6b22$var$createToken(value, type) {
    if ($d551340dd0bc6b22$var$SUPPORTED_TOKENS.indexOf(type) === -1) throw new Error("Unsupported token type: " + type);
    return {
        value: value,
        type: type
    };
}
/**
 * Tries to cast numeric values to their type passed as a string.
 *
 * @param {*} value
 * @return {*}
 */ function $d551340dd0bc6b22$var$castValueToCorrectType(value) {
    if (typeof value !== "string") return value;
    if (/^\d+(\.\d+)?$/.test(value)) value = value.indexOf(".") === -1 ? parseInt(value, 10) : parseFloat(value);
    return value;
}
/**
 * Generate stream of tokens from passed expression.
 *
 * @param {String} expression
 * @return {String[]}
 */ function $d551340dd0bc6b22$var$tokenizeExpression(expression) {
    const expressionLength = expression.length;
    const tokens = [];
    let cursorIndex = 0;
    let processedValue = "";
    let processedSymbol = "";
    while(cursorIndex < expressionLength){
        const char = expression.charAt(cursorIndex);
        switch(char){
            case ">":
            case "<":
            case "=":
                processedSymbol = processedSymbol + char;
                if (processedValue.length > 0) {
                    tokens.push(processedValue);
                    processedValue = "";
                }
                break;
            default:
                if (processedSymbol.length > 0) {
                    tokens.push(processedSymbol);
                    processedSymbol = "";
                }
                processedValue = processedValue + char;
                break;
        }
        cursorIndex++;
    }
    if (processedValue.length > 0) tokens.push(processedValue);
    if (processedSymbol.length > 0) tokens.push(processedSymbol);
    return tokens;
}
/**
 * Analyze and convert tokens to an object which describes their meaning.
 *
 * @param {String[]} tokens
 * @return {Object[]}
 */ function $d551340dd0bc6b22$var$analyzeTokens(tokens) {
    let literalValue = "";
    const analyzedTokens = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (i === 0 && $d551340dd0bc6b22$var$validSymbols.indexOf(token) >= 0) analyzedTokens.push($d551340dd0bc6b22$var$createToken(token, $d551340dd0bc6b22$var$TOKEN_TYPE_OPERATOR));
        else literalValue += token;
    }
    if (literalValue.length > 0) analyzedTokens.push($d551340dd0bc6b22$var$createToken($d551340dd0bc6b22$var$castValueToCorrectType(literalValue), $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL));
    if (analyzedTokens.length > 0 && analyzedTokens[0].type !== $d551340dd0bc6b22$var$TOKEN_TYPE_OPERATOR) analyzedTokens.unshift($d551340dd0bc6b22$var$createToken($d551340dd0bc6b22$var$defaultOperator, $d551340dd0bc6b22$var$TOKEN_TYPE_OPERATOR));
    return analyzedTokens;
}
/**
 * Compute/Evaluate an expression passed as an array of tokens.
 *
 * @param {Object[]} tokens
 * @return {Boolean}
 */ function $d551340dd0bc6b22$var$computeExpression(tokens) {
    const values = [];
    let operator;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        switch(token.type){
            case $d551340dd0bc6b22$var$TOKEN_TYPE_OPERATOR:
                operator = token.value;
                break;
            case $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL:
                values.push(token.value);
                break;
        }
    }
    return $d551340dd0bc6b22$var$evaluate(values, operator);
}
/**
 * Evaluate values based on passed math operator.
 *
 * @param {*} values
 * @param {String} operator
 * @return {Boolean}
 */ function $d551340dd0bc6b22$var$evaluate(values, operator) {
    let result = false;
    switch(operator){
        case ">":
            result = values[0] > values[1];
            break;
        case ">=":
            result = values[0] >= values[1];
            break;
        case "<":
            result = values[0] < values[1];
            break;
        case "<=":
            result = values[0] <= values[1];
            break;
        case "=":
            result = values[0] == values[1];
            break;
        case "<>":
            result = values[0] != values[1];
            break;
    }
    return result;
}
function $d551340dd0bc6b22$var$parse(expression) {
    return $d551340dd0bc6b22$var$analyzeTokens($d551340dd0bc6b22$var$tokenizeExpression(expression));
}
const $d551340dd0bc6b22$var$compute = $d551340dd0bc6b22$var$computeExpression;
// TODO
/**
 * -- Not implemented --
 *
 * Returns information about the formatting, location, or contents of a value.
 *
 * Category: Information
 *
 * @returns
 */ function $d551340dd0bc6b22$export$66778154bf9d2f9c() {
    throw new Error("CELL is not implemented");
}
const $d551340dd0bc6b22$export$103bedf43ba882db = {};
$d551340dd0bc6b22$export$103bedf43ba882db.TYPE = (error_val)=>{
    switch(error_val){
        case $d551340dd0bc6b22$var$nil:
            return 1;
        case $d551340dd0bc6b22$var$div0:
            return 2;
        case $d551340dd0bc6b22$var$value:
            return 3;
        case $d551340dd0bc6b22$var$ref:
            return 4;
        case $d551340dd0bc6b22$var$name:
            return 5;
        case $d551340dd0bc6b22$var$num:
            return 6;
        case $d551340dd0bc6b22$var$na:
            return 7;
        case $d551340dd0bc6b22$var$data:
            return 8;
    }
    return $d551340dd0bc6b22$var$na;
};
// TODO
/**
 * -- Not implemented --
 *
 * Returns information about the current operating environment.
 *
 * Category: Information
 *
 * @returns
 */ function $d551340dd0bc6b22$export$7ecad81ba40c4d73() {
    throw new Error("INFO is not implemented");
}
/**
 * Returns TRUE if the value is blank.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$80fb9c324a872d3a(value) {
    return value === null;
}
/**
 * Returns TRUE if the value is any error value except #N/A.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$45ec665ab9d90642(value$1) {
    return [
        $d551340dd0bc6b22$var$value,
        $d551340dd0bc6b22$var$ref,
        $d551340dd0bc6b22$var$div0,
        $d551340dd0bc6b22$var$num,
        $d551340dd0bc6b22$var$name,
        $d551340dd0bc6b22$var$nil
    ].indexOf(value$1) >= 0 || typeof value$1 === "number" && (isNaN(value$1) || !isFinite(value$1));
}
/**
 * Returns TRUE if the value is any error value.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$e3e8e7d5009c248(value) {
    return $d551340dd0bc6b22$export$45ec665ab9d90642(value) || value === $d551340dd0bc6b22$var$na;
}
/**
 * Returns TRUE if the number is even.
 *
 * Category: Information
 *
 * @param {*} number The value to test. If number is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$f283142d6b8155bb(number) {
    return !(Math.floor(Math.abs(number)) & 1);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns TRUE if there is a reference to a value that contains a formula.
 *
 * Category: Information
 *
 * @param {*} reference Reference is a reference to the value you want to test. Reference can be a value reference, a formula, or a name that refers to a value.
 * @returns
 */ function $d551340dd0bc6b22$export$3a419249afa83e2() {
    throw new Error("ISFORMULA is not implemented");
}
/**
 * Returns TRUE if the value is a logical value.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$235f36d2366dd402(value) {
    return value === true || value === false;
}
/**
 * Returns TRUE if the value is the #N/A error value.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$13f9cd87e4e832b4(value) {
    return value === $d551340dd0bc6b22$var$na;
}
/**
 * Returns TRUE if the value is not text.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$1675d355bf07a3f5(value) {
    return typeof value !== "string";
}
/**
 * Returns TRUE if the value is a number.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$95ae71f78f3360a1(value) {
    return typeof value === "number" && !isNaN(value) && isFinite(value);
}
/**
 * Returns TRUE if the number is odd.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$7b7108d0921615c7(value) {
    return !!(Math.floor(Math.abs(value)) & 1);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns TRUE if the value is a reference.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$ec5b11b75de23687() {
    throw new Error("ISREF is not implemented");
}
/**
 * Returns TRUE if the value is text.
 *
 * Category: Information
 *
 * @param {*} value The value that you want tested. The value argument can be a blank (empty value), error, logical value, text, number, or reference value, or a name referring to any of these.
 * @returns
 */ function $d551340dd0bc6b22$export$60e9017a500ec91a(value) {
    return typeof value === "string";
}
/**
 * Returns a value converted to a number.
 *
 * Category: Information
 *
 * @param {*} value The value you want converted. N converts values listed in the following table.
 * @returns
 */ function $d551340dd0bc6b22$export$a07804094c3ecf2d(value) {
    if ($d551340dd0bc6b22$export$95ae71f78f3360a1(value)) return value;
    if (value instanceof Date) return value.getTime();
    if (value === true) return 1;
    if (value === false) return 0;
    if ($d551340dd0bc6b22$export$e3e8e7d5009c248(value)) return value;
    return 0;
}
/**
 * Returns the error value #N/A.
 *
 * Category: Information
 *
 * @returns
 */ function $d551340dd0bc6b22$export$dbd1925f4fe9ec65() {
    return $d551340dd0bc6b22$var$na;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the sheet number of the referenced sheet.
 *
 * Category: Information
 *
 * @param {*} value Optional. Value is the name of a sheet or a reference for which you want the sheet number. If value is omitted, SHEET returns the number of the sheet that contains the function.
 * @returns
 */ function $d551340dd0bc6b22$export$dd169a3e78f796a9() {
    throw new Error("SHEET is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the number of sheets in a reference.
 *
 * Category: Information
 *
 * @param {*} reference Optional. Reference is a reference for which you want to know the number of sheets it contains. If Reference is omitted, SHEETS returns the number of sheets in the workbook that contains the function.
 * @returns
 */ function $d551340dd0bc6b22$export$38fac4657e6be5eb() {
    throw new Error("SHEETS is not implemented");
}
/**
 * Returns a number indicating the data type of a value.
 *
 * Category: Information
 *
 * @param {*} value Can be any Microsoft Excel value, such as a number, text, logical value, and so on.
 * @returns
 */ function $d551340dd0bc6b22$export$b87f371cbc396fcf(value) {
    if ($d551340dd0bc6b22$export$95ae71f78f3360a1(value)) return 1;
    if ($d551340dd0bc6b22$export$60e9017a500ec91a(value)) return 2;
    if ($d551340dd0bc6b22$export$235f36d2366dd402(value)) return 4;
    if ($d551340dd0bc6b22$export$e3e8e7d5009c248(value)) return 16;
    if (Array.isArray(value)) return 64;
}
/**
 * Chooses a value from a list of values.
 *
 * Category: Lookup and reference
 *
 * @param {*} index_num Specifies which value argument is selected. Index_num must be a number between 1 and 254, or a formula or reference to a value containing a number between 1 and 254. If index_num is 1, CHOOSE returns value1; if it is 2, CHOOSE returns value2; and so on. If index_num is less than 1 or greater than the number of the last value in the list, CHOOSE returns the #VALUE! error value. If index_num is a fraction, it is truncated to the lowest integer before being used.
 - If index_num is 1, CHOOSE returns value1; if it is 2, CHOOSE returns value2; and so on.
 - If index_num is less than 1 or greater than the number of the last value in the list, CHOOSE returns the #VALUE! error value.
 - If index_num is a fraction, it is truncated to the lowest integer before being used.
 * @param {*} args value1, value2, ... Value 1 is required, subsequent values are optional. 1 to 254 value arguments from which CHOOSE selects a value or an action to perform based on index_num. The arguments can be numbers, value references, defined names, formulas, functions, or text.
 * @returns
 */ function $d551340dd0bc6b22$export$ea573e2c4c6f4f41() {
    if (arguments.length < 2) return $d551340dd0bc6b22$var$na;
    const index = arguments[0];
    if (index < 1 || index > 254) return $d551340dd0bc6b22$var$value;
    if (arguments.length < index + 1) return $d551340dd0bc6b22$var$value;
    return arguments[index];
}
/**
 * Returns the column number of a reference.
 *
 * Category: Lookup and reference
 *
 * @param {*} reference the value or range of values for which you want to return the column number.
 * @param {*} index
 * @returns
 */ function $d551340dd0bc6b22$export$7f092194d45e1f0d(reference, index) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (index < 0) return $d551340dd0bc6b22$var$num;
    if (!(reference instanceof Array) || typeof index !== "number") return $d551340dd0bc6b22$var$value;
    if (reference.length === 0) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).col(reference, index);
}
/**
 * Returns the number of columns in a reference.
 *
 * Category: Lookup and reference
 *
 * @param {*} array An array or array formula, or a reference to a range of values for which you want the number of columns.
 * @returns
 */ function $d551340dd0bc6b22$export$6a6dcc7e725abed4(array) {
    if (arguments.length !== 1) return $d551340dd0bc6b22$var$na;
    if (!(array instanceof Array)) return $d551340dd0bc6b22$var$value;
    if (array.length === 0) return 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).cols(array);
}
/**
 * Looks in the top row of an array and returns the value of the indicated value.
 *
 * Category: Lookup and reference
 *
 * @param {*} lookup_value The value to be found in the first row of the table. Lookup_value can be a value, a reference, or a text string.
 * @param {*} table_array A table of information in which data is looked up. Use a reference to a range or a range name.
 * @param {*} row_index_num The row number in table_array from which the matching value will be returned. A row_index_num of 1 returns the first row value in table_array, a row_index_num of 2 returns the second row value in table_array, and so on. If row_index_num is less than 1, HLOOKUP returns the #VALUE! error value; if row_index_num is greater than the number of rows on table_array, HLOOKUP returns the #REF! error value.
 * @param {*} range_lookup Optional. A logical value that specifies whether you want HLOOKUP to find an exact match or an approximate match. If TRUE or omitted, an approximate match is returned. In other words, if an exact match is not found, the next largest value that is less than lookup_value is returned. If FALSE, HLOOKUP will find an exact match. If one is not found, the error value #N/A is returned.
 * @returns
 */ function $d551340dd0bc6b22$export$db509988dd6e393e(lookup_value, table_array, row_index_num, range_lookup) {
    return $d551340dd0bc6b22$export$9e83f203451c83e2(lookup_value, $d551340dd0bc6b22$var$transpose(table_array), row_index_num, range_lookup);
}
/**
 * Uses an index to choose a value from a reference or array.
 *
 * Category: Lookup and reference
 *
 * @param {*} array A range of values or an array constant.
 - If array contains only one row or column, the corresponding row_num or column_num argument is optional.
 - If array has more than one row and more than one column, and only row_num or column_num is used, INDEX returns an array of the entire row or column in array.
 * @param {*} row_num Required, unless column_num is present. Selects the row in array from which to return a value. If row_num is omitted, column_num is required.
 * @param {*} column_num Optional. Selects the column in array from which to return a value. If column_num is omitted, row_num is required.
 * @returns
 */ function $d551340dd0bc6b22$export$e3852490c78bdb2d(array, row_num, column_num) {
    const someError = $d551340dd0bc6b22$var$anyError(array, row_num, column_num);
    if (someError) return someError;
    if (!Array.isArray(array)) return $d551340dd0bc6b22$var$value;
    const isOneDimensionRange = array.length > 0 && !Array.isArray(array[0]);
    if (isOneDimensionRange && !column_num) {
        column_num = row_num;
        row_num = 1;
    } else {
        column_num = column_num || 1;
        row_num = row_num || 1;
    }
    if (column_num < 0 || row_num < 0) return $d551340dd0bc6b22$var$value;
    if (isOneDimensionRange && row_num === 1 && column_num <= array.length) return array[column_num - 1];
    else if (row_num <= array.length && column_num <= array[row_num - 1].length) return array[row_num - 1][column_num - 1];
    return $d551340dd0bc6b22$var$ref;
}
/**
 * Looks up values in a vector or array.
 *
 * Category: Lookup and reference
 *
 * @param {*} lookup_value A value that LOOKUP searches for in an array. The lookup_value argument can be a number, text, a logical value, or a name or reference that refers to a value.
 - If LOOKUP can't find the value of lookup_value, it uses the largest value in the array that is less than or equal to lookup_value.
 - If the value of lookup_value is smaller than the smallest value in the first row or column (depending on the array dimensions), LOOKUP returns the #N/A error value.
 * @param {*} array A range of values that contains text, numbers, or logical values that you want to compare with lookup_value. The array form of LOOKUP is very similar to the HLOOKUP and VLOOKUP functions. The difference is that HLOOKUP searches for the value of lookup_value in the first row, VLOOKUP searches in the first column, and LOOKUP searches according to the dimensions of array.
* @param {*} result_array Optional. A range that contains only one row or column. The result_array argument must be the same size as lookup_value. It has to be the same size.
 * @returns
 */ function $d551340dd0bc6b22$export$9336f49f4401ba30(lookup_value, array, result_array) {
    array = $d551340dd0bc6b22$var$flatten(array);
    result_array = result_array ? $d551340dd0bc6b22$var$flatten(result_array) : array;
    const isNumberLookup = typeof lookup_value === "number";
    let result = $d551340dd0bc6b22$var$na;
    for(let i = 0; i < array.length; i++){
        if (array[i] === lookup_value) return result_array[i];
        else if (isNumberLookup && array[i] <= lookup_value || typeof array[i] === "string" && array[i].localeCompare(lookup_value) < 0) result = result_array[i];
        else if (isNumberLookup && array[i] > lookup_value) return result;
    }
    return result;
}
/**
 * Looks up values in a reference or array.
 *
 * Category: Lookup and reference
 *
 * @param {*} lookup_value The value that you want to match in lookup_array. For example, when you look up someone's number in a telephone book, you are using the person's name as the lookup value, but the telephone number is the value you want.The lookup_value argument can be a value (number, text, or logical value) or a value reference to a number, text, or logical value.
 * @param {*} lookup_array The range of values being searched.
 * @param {*} match_type Optional. The number -1, 0, or 1. The match_type argument specifies how Excel matches lookup_value with values in lookup_array. The default value for this argument is 1.
 * @returns
 */ function $d551340dd0bc6b22$export$5a1a83be8f503735(lookup_value, lookup_array, match_type) {
    if (!lookup_value || !lookup_array) return $d551340dd0bc6b22$var$na;
    if (arguments.length === 2) match_type = 1;
    lookup_array = $d551340dd0bc6b22$var$flatten(lookup_array);
    if (!(lookup_array instanceof Array)) return $d551340dd0bc6b22$var$na;
    if (match_type !== -1 && match_type !== 0 && match_type !== 1) return $d551340dd0bc6b22$var$na;
    let index;
    let indexValue;
    for(let idx = 0; idx < lookup_array.length; idx++){
        if (match_type === 1) {
            if (lookup_array[idx] === lookup_value) return idx + 1;
            else if (lookup_array[idx] < lookup_value) {
                if (!indexValue) {
                    index = idx + 1;
                    indexValue = lookup_array[idx];
                } else if (lookup_array[idx] > indexValue) {
                    index = idx + 1;
                    indexValue = lookup_array[idx];
                }
            }
        } else if (match_type === 0) {
            if (typeof lookup_value === "string" && typeof lookup_array[idx] === "string") {
                const lookupValueStr = lookup_value.toLowerCase().replace(/\?/g, ".").replace(/\*/g, ".*").replace(/~/g, "\\").replace(/\+/g, "\\+").replace(/\(/g, "\\(").replace(/\)/g, "\\)").replace(/\[/g, "\\[").replace(/\]/g, "\\]");
                const regex = new RegExp("^" + lookupValueStr + "$");
                if (regex.test(lookup_array[idx].toLowerCase())) return idx + 1;
            } else {
                if (lookup_array[idx] === lookup_value) return idx + 1;
            }
        } else if (match_type === -1) {
            if (lookup_array[idx] === lookup_value) return idx + 1;
            else if (lookup_array[idx] > lookup_value) {
                if (!indexValue) {
                    index = idx + 1;
                    indexValue = lookup_array[idx];
                } else if (lookup_array[idx] < indexValue) {
                    index = idx + 1;
                    indexValue = lookup_array[idx];
                }
            }
        }
    }
    return index || $d551340dd0bc6b22$var$na;
}
/**
 * Returns the number of rows in a reference.
 *
 * Category: Lookup and reference
 *
 * @param {*} array An array, an array formula, or a reference to a range of values for which you want the number of rows.
 * @returns
 */ function $d551340dd0bc6b22$export$9ecce7f637e2cef2(array) {
    if (arguments.length !== 1) return $d551340dd0bc6b22$var$na;
    if (!(array instanceof Array)) return $d551340dd0bc6b22$var$value;
    if (array.length === 0) return 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).rows(array);
}
/**
 * Returns a sorted array of the elements in an array. The returned array is the same shape as the provided array argument.
 *
 * Category: Lookup and reference
 *
 * @param {*} array Array to sort
 * @param {*} sort_index Optional. A number indicating the row or column to sort by
 * @param {*} sort_order Optional. A number indicating the desired sort order; 1 for ascending order (default), -1 for descending order
 * @param {*} by_col Optional. A logical value indicating the desired sort direction; FALSE to sort by row (default), TRUE to sort by column
 * @returns
 */ function $d551340dd0bc6b22$export$1e652a44bda81b79(array, sort_index = 1, sort_order = 1, by_col = false) {
    if (!array || !Array.isArray(array)) return $d551340dd0bc6b22$var$na;
    if (array.length === 0) return 0;
    sort_index = $d551340dd0bc6b22$var$parseNumber(sort_index);
    if (!sort_index || sort_index < 1) return $d551340dd0bc6b22$var$value;
    sort_order = $d551340dd0bc6b22$var$parseNumber(sort_order);
    if (sort_order !== 1 && sort_order !== -1) return $d551340dd0bc6b22$var$value;
    by_col = $d551340dd0bc6b22$var$parseBool(by_col);
    if (typeof by_col !== "boolean") return $d551340dd0bc6b22$var$name;
    const sortArray = (arr)=>arr.sort((a, b)=>{
            a = $d551340dd0bc6b22$var$parseString(a[sort_index - 1]);
            b = $d551340dd0bc6b22$var$parseString(b[sort_index - 1]);
            return sort_order === 1 ? a < b ? sort_order * -1 : sort_order : a > b ? sort_order : sort_order * -1;
        });
    const matrix = $d551340dd0bc6b22$var$fillMatrix(array);
    const result = by_col ? $d551340dd0bc6b22$var$transpose(matrix) : matrix;
    return sort_index >= 1 && sort_index <= result[0].length ? by_col ? $d551340dd0bc6b22$var$transpose(sortArray(result)) : sortArray(result) : $d551340dd0bc6b22$var$value;
}
/**
 * Returns the transpose of an array.
 *
 * Category: Lookup and reference
 *
 * @param {*} array An array or range of values on a worksheet that you want to transpose. The transpose of an array is created by using the first row of the array as the first column of the new array, the second row of the array as the second column of the new array, and so on. If you're not sure of how to enter an array formula, see Create an array formula.
 * @returns
 */ function $d551340dd0bc6b22$export$ae60ab9b4739fc3d(array) {
    if (!array) return $d551340dd0bc6b22$var$na;
    const matrix = $d551340dd0bc6b22$var$fillMatrix(array);
    return $d551340dd0bc6b22$var$transpose(matrix);
}
/**
 * Returns a list of unique values in a list or range.
 *
 * Category: Lookup and reference
 *
 * @returns
 */ function $d551340dd0bc6b22$export$97ef0433caf1f815() {
    const result = [];
    for(let i = 0; i < arguments.length; ++i){
        let hasElement = false;
        const element = arguments[i];
        // Check if we've already seen this element.
        for(let j = 0; j < result.length; ++j){
            hasElement = result[j] === element;
            if (hasElement) break;
        }
        // If we did not find it, add it to the result.
        if (!hasElement) result.push(element);
    }
    return result;
}
/**
 * Looks in the first column of an array and moves across the row to return the value of a value.
 *
 * Category: Lookup and reference
 *
 * @param {*} lookup_value The value to be found in the first row of the table. Lookup_value can be a value, a reference, or a text string.
 * @param {*} table_array A table of information in which data is looked up. Use a reference to a range or a range name.
 * @param {*} col_index_num The row number in table_array from which the matching value will be returned. A row_index_num of 1 returns the first row value in table_array, a row_index_num of 2 returns the second row value in table_array, and so on. If row_index_num is less than 1, HLOOKUP returns the #VALUE! error value; if row_index_num is greater than the number of rows on table_array, HLOOKUP returns the #REF! error value.
 * @param {*} range_lookup Optional. A logical value that specifies whether you want HLOOKUP to find an exact match or an approximate match. If TRUE or omitted, an approximate match is returned. In other words, if an exact match is not found, the next largest value that is less than lookup_value is returned. If FALSE, HLOOKUP will find an exact match. If one is not found, the error value #N/A is returned.
 * @returns
 */ function $d551340dd0bc6b22$export$9e83f203451c83e2(lookup_value, table_array, col_index_num, range_lookup) {
    if (!table_array || !col_index_num) return $d551340dd0bc6b22$var$na;
    range_lookup = !(range_lookup === 0 || range_lookup === false);
    let result = $d551340dd0bc6b22$var$na;
    const isNumberLookup = typeof lookup_value === "number";
    let exactMatchOnly = false;
    for(let i = 0; i < table_array.length; i++){
        const row = table_array[i];
        if (row[0] === lookup_value) {
            result = col_index_num < row.length + 1 ? row[col_index_num - 1] : $d551340dd0bc6b22$var$ref;
            break;
        } else if (!exactMatchOnly && (isNumberLookup && range_lookup && row[0] <= lookup_value || range_lookup && typeof row[0] === "string" && row[0].localeCompare(lookup_value) < 0)) result = col_index_num < row.length + 1 ? row[col_index_num - 1] : $d551340dd0bc6b22$var$ref;
        if (isNumberLookup && row[0] > lookup_value) exactMatchOnly = true;
    }
    return result;
}
const $d551340dd0bc6b22$var$SQRT2PI = 2.5066282746310002;
/**
 * Returns the average of the absolute deviations of data points from their mean.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want the average of the absolute deviations. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$e3d5dbeb79a4a98f() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const flatArgumentsDefined = flatArguments.filter($d551340dd0bc6b22$var$isDefined);
    if (flatArgumentsDefined.length === 0) return $d551340dd0bc6b22$var$num;
    const range = $d551340dd0bc6b22$var$parseNumberArray(flatArgumentsDefined);
    if (range instanceof Error) return range;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).sum((0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports)))(range).subtract((0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(range)).abs()[0]) / range.length;
}
/**
 * Returns the average of its arguments.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ...Numbers, value references or ranges for which you want the average.
 * @returns
 */ function $d551340dd0bc6b22$export$d3bfe4097a2a8542() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const flatArgumentsDefined = flatArguments.filter($d551340dd0bc6b22$var$isDefined);
    if (flatArgumentsDefined.length === 0) return $d551340dd0bc6b22$var$div0;
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArgumentsDefined);
    if (someError) return someError;
    const range = $d551340dd0bc6b22$var$numbers(flatArgumentsDefined);
    const n = range.length;
    let sum = 0;
    let count = 0;
    let result;
    for(let i = 0; i < n; i++){
        sum += range[i];
        count += 1;
    }
    result = sum / count;
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the average of its arguments, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 255 values, ranges of values, or values for which you want the average.
 * @returns
 */ function $d551340dd0bc6b22$export$c7a6518a193e8c0d() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const flatArgumentsDefined = flatArguments.filter($d551340dd0bc6b22$var$isDefined);
    if (flatArgumentsDefined.length === 0) return $d551340dd0bc6b22$var$div0;
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArgumentsDefined);
    if (someError) return someError;
    const range = flatArgumentsDefined;
    const n = range.length;
    let sum = 0;
    let count = 0;
    let result;
    for(let i = 0; i < n; i++){
        const el = range[i];
        if (typeof el === "number") sum += el;
        if (el === true) sum++;
        if (el !== null) count++;
    }
    result = sum / count;
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the average (arithmetic mean) of all the values in a range that meet a given criteria.
 *
 * Category: Statistical
 *
 * @param {*} range One or more values to average, including numbers or names, arrays, or references that contain numbers.
 * @param {*} criteria The criteria in the form of a number, expression, value reference, or text that defines which values are averaged.
 * @param {*} average_range Optional. The actual set of values to average. If omitted, range is used.
 * @returns
 */ function $d551340dd0bc6b22$export$276cb9f26ac5719f(range, criteria, average_range) {
    if (arguments.length <= 1) return $d551340dd0bc6b22$var$na;
    average_range = average_range || range;
    const flatAverageRange = $d551340dd0bc6b22$var$flatten(average_range);
    const flatAverageRangeDefined = flatAverageRange.filter($d551340dd0bc6b22$var$isDefined);
    average_range = $d551340dd0bc6b22$var$parseNumberArray(flatAverageRangeDefined);
    range = $d551340dd0bc6b22$var$flatten(range);
    if (average_range instanceof Error) return average_range;
    let average_count = 0;
    let result = 0;
    const isWildcard = criteria === void 0 || criteria === "*";
    const tokenizedCriteria = isWildcard ? null : $d551340dd0bc6b22$var$parse(criteria + "");
    for(let i = 0; i < range.length; i++){
        const value = range[i];
        if (isWildcard) {
            result += average_range[i];
            average_count++;
        } else {
            const tokens = [
                $d551340dd0bc6b22$var$createToken(value, $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
            ].concat(tokenizedCriteria);
            if ($d551340dd0bc6b22$var$compute(tokens)) {
                result += average_range[i];
                average_count++;
            }
        }
    }
    return result / average_count;
}
/**
 * Returns the average (arithmetic mean) of all values that meet multiple criteria.
 *
 * Category: Statistical
 *
 * @param {*} args One or more values to average, including numbers or names, arrays, or references that contain numbers.
 * @returns
 */ function $d551340dd0bc6b22$export$227daf04fd9df71e() {
    // Does not work with multi dimensional ranges yet!
    // http://office.microsoft.com/en-001/excel-help/averageifs-function-HA010047493.aspx
    const args = $d551340dd0bc6b22$var$argsToArray(arguments);
    const criteriaLength = (args.length - 1) / 2;
    const range = $d551340dd0bc6b22$var$flatten(args[0]);
    let count = 0;
    let result = 0;
    for(let i = 0; i < range.length; i++){
        let isMeetCondition = false;
        for(let j = 0; j < criteriaLength; j++){
            const value = args[2 * j + 1][i];
            const criteria = args[2 * j + 2];
            const isWildcard = criteria === void 0 || criteria === "*";
            let computedResult = false;
            if (isWildcard) computedResult = true;
            else {
                const tokenizedCriteria = $d551340dd0bc6b22$var$parse(criteria + "");
                const tokens = [
                    $d551340dd0bc6b22$var$createToken(value, $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
                ].concat(tokenizedCriteria);
                computedResult = $d551340dd0bc6b22$var$compute(tokens);
            }
            // Criterias are calculated as AND so any `false` breakes the loop as unmeet condition
            if (!computedResult) {
                isMeetCondition = false;
                break;
            }
            isMeetCondition = true;
        }
        if (isMeetCondition) {
            result += range[i];
            count++;
        }
    }
    const average = result / count;
    return isNaN(average) ? 0 : average;
}
const $d551340dd0bc6b22$export$d8fe69043b6df2f0 = {};
/**
 * Returns the beta cumulative distribution function.
 *
 * Category: Statistical
 *
 * @param {*} x The value between A and B at which to evaluate the function
 * @param {*} alpha A parameter of the distribution.
 * @param {*} beta A parameter of the distribution.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, BETA.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @param {*} a Optional. A lower bound to the interval of x.
 * @param {*} b Optional. An upper bound to the interval of x.
 * @returns
 */ $d551340dd0bc6b22$export$d8fe69043b6df2f0.DIST = function(x, alpha, beta, cumulative, a, b) {
    if (arguments.length < 4) return $d551340dd0bc6b22$var$value;
    a = a === undefined ? 0 : a;
    b = b === undefined ? 1 : b;
    x = $d551340dd0bc6b22$var$parseNumber(x);
    alpha = $d551340dd0bc6b22$var$parseNumber(alpha);
    beta = $d551340dd0bc6b22$var$parseNumber(beta);
    a = $d551340dd0bc6b22$var$parseNumber(a);
    b = $d551340dd0bc6b22$var$parseNumber(b);
    if ($d551340dd0bc6b22$var$anyIsError(x, alpha, beta, a, b)) return $d551340dd0bc6b22$var$value;
    x = (x - a) / (b - a);
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).beta.cdf(x, alpha, beta) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).beta.pdf(x, alpha, beta);
};
/**
 * Returns the inverse of the cumulative distribution function for a specified beta distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability associated with the beta distribution.
 * @param {*} alpha A parameter of the distribution.
 * @param {*} beta A parameter the distribution.
 * @param {*} a Optional. A lower bound to the interval of x.
 * @param {*} b Optional. An upper bound to the interval of x.
 * @returns
 */ $d551340dd0bc6b22$export$d8fe69043b6df2f0.INV = (probability, alpha, beta, a, b)=>{
    a = a === undefined ? 0 : a;
    b = b === undefined ? 1 : b;
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    alpha = $d551340dd0bc6b22$var$parseNumber(alpha);
    beta = $d551340dd0bc6b22$var$parseNumber(beta);
    a = $d551340dd0bc6b22$var$parseNumber(a);
    b = $d551340dd0bc6b22$var$parseNumber(b);
    if ($d551340dd0bc6b22$var$anyIsError(probability, alpha, beta, a, b)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).beta.inv(probability, alpha, beta) * (b - a) + a;
};
const $d551340dd0bc6b22$export$b4ccfb6e589ca4c3 = {};
/**
 * Returns the individual term binomial distribution probability.
 *
 * Category: Statistical
 *
 * @param {*} number_s The number of successes in trials.
 * @param {*} trials The number of independent trials.
 * @param {*} probability_s The probability of success on each trial.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, then BINOM.DIST returns the cumulative distribution function, which is the probability that there are at most number_s successes; if FALSE, it returns the probability mass function, which is the probability that there are number_s successes.
 * @returns
 */ $d551340dd0bc6b22$export$b4ccfb6e589ca4c3.DIST = (number_s, trials, probability_s, cumulative)=>{
    number_s = $d551340dd0bc6b22$var$parseNumber(number_s);
    trials = $d551340dd0bc6b22$var$parseNumber(trials);
    probability_s = $d551340dd0bc6b22$var$parseNumber(probability_s);
    cumulative = $d551340dd0bc6b22$var$parseNumber(cumulative);
    if ($d551340dd0bc6b22$var$anyIsError(number_s, trials, probability_s, cumulative)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).binomial.cdf(number_s, trials, probability_s) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).binomial.pdf(number_s, trials, probability_s);
};
/**
 * Returns the probability of a trial result using a binomial distribution.
 *
 * Category: Statistical
 *
 * @param {*} trials The number of independent trials. Must be greater than or equal to 0.
 * @param {*} probability_s The probability of success in each trial. Must be greater than or equal to 0 and less than or equal to 1.
 * @param {*} number_s The number of successes in trials. Must be greater than or equal to 0 and less than or equal to Trials.
 * @param {*} number_s2 Optional. If provided, returns the probability that the number of successful trials will fall between Number_s and number_s2. Must be greater than or equal to Number_s and less than or equal to Trials.
 * @returns
 */ $d551340dd0bc6b22$export$b4ccfb6e589ca4c3.DIST.RANGE = (trials, probability_s, number_s, number_s2)=>{
    number_s2 = number_s2 === undefined ? number_s : number_s2;
    trials = $d551340dd0bc6b22$var$parseNumber(trials);
    probability_s = $d551340dd0bc6b22$var$parseNumber(probability_s);
    number_s = $d551340dd0bc6b22$var$parseNumber(number_s);
    number_s2 = $d551340dd0bc6b22$var$parseNumber(number_s2);
    if ($d551340dd0bc6b22$var$anyIsError(trials, probability_s, number_s, number_s2)) return $d551340dd0bc6b22$var$value;
    let result = 0;
    for(let i = number_s; i <= number_s2; i++)result += $d551340dd0bc6b22$export$4b98dc7b8f648ca3(trials, i) * Math.pow(probability_s, i) * Math.pow(1 - probability_s, trials - i);
    return result;
};
/**
 * Returns the smallest value for which the cumulative binomial distribution is less than or equal to a criterion value.
 *
 * Category: Statistical
 *
 * @param {*} trials The number of Bernoulli trials.
 * @param {*} probability_s The probability of a success on each trial.
 * @param {*} alpha The criterion value.
 * @returns
 */ $d551340dd0bc6b22$export$b4ccfb6e589ca4c3.INV = (trials, probability_s, alpha)=>{
    trials = $d551340dd0bc6b22$var$parseNumber(trials);
    probability_s = $d551340dd0bc6b22$var$parseNumber(probability_s);
    alpha = $d551340dd0bc6b22$var$parseNumber(alpha);
    if ($d551340dd0bc6b22$var$anyIsError(trials, probability_s, alpha)) return $d551340dd0bc6b22$var$value;
    let x = 0;
    while(x <= trials){
        if ((0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).binomial.cdf(x, trials, probability_s) >= alpha) return x;
        x++;
    }
};
const $d551340dd0bc6b22$export$bb2c792e07d3cb0d = {};
/**
 * Returns the cumulative beta probability density function.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which you want to evaluate the distribution.
 * @param {*} deg_freedom The number of degrees of freedom.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, CHISQ.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$bb2c792e07d3cb0d.DIST = (x, deg_freedom, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    deg_freedom = $d551340dd0bc6b22$var$parseNumber(deg_freedom);
    if ($d551340dd0bc6b22$var$anyIsError(x, deg_freedom)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).chisquare.cdf(x, deg_freedom) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).chisquare.pdf(x, deg_freedom);
};
/**
 * Returns the one-tailed probability of the chi-squared distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which you want to evaluate the distribution.
 * @param {*} deg_freedom The number of degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$export$bb2c792e07d3cb0d.DIST.RT = (x, deg_freedom)=>{
    if (!x | !deg_freedom) return $d551340dd0bc6b22$var$na;
    if (x < 1 || deg_freedom > Math.pow(10, 10)) return $d551340dd0bc6b22$var$num;
    if (typeof x !== "number" || typeof deg_freedom !== "number") return $d551340dd0bc6b22$var$value;
    return 1 - (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).chisquare.cdf(x, deg_freedom);
};
/**
 * Returns the cumulative beta probability density function.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability associated with the chi-squared distribution.
 * @param {*} deg_freedom The number of degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$export$bb2c792e07d3cb0d.INV = (probability, deg_freedom)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    deg_freedom = $d551340dd0bc6b22$var$parseNumber(deg_freedom);
    if ($d551340dd0bc6b22$var$anyIsError(probability, deg_freedom)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).chisquare.inv(probability, deg_freedom);
};
/**
 * Returns the inverse of the one-tailed probability of the chi-squared distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability associated with the chi-squared distribution.
 * @param {*} deg_freedom The number of degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$export$bb2c792e07d3cb0d.INV.RT = (probability, deg_freedom)=>{
    if (!probability | !deg_freedom) return $d551340dd0bc6b22$var$na;
    if (probability < 0 || probability > 1 || deg_freedom < 1 || deg_freedom > Math.pow(10, 10)) return $d551340dd0bc6b22$var$num;
    if (typeof probability !== "number" || typeof deg_freedom !== "number") return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).chisquare.inv(1.0 - probability, deg_freedom);
};
/**
 * Returns the test for independence.
 *
 * Category: Statistical
 *
 * @param {*} actual_range The range of data that contains observations to test against expected values.
 * @param {*} expected_range The range of data that contains the ratio of the product of row totals and column totals to the grand total.
 * @returns
 */ $d551340dd0bc6b22$export$bb2c792e07d3cb0d.TEST = function(actual_range, expected_range) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (!(actual_range instanceof Array) || !(expected_range instanceof Array)) return $d551340dd0bc6b22$var$value;
    if (actual_range.length !== expected_range.length) return $d551340dd0bc6b22$var$value;
    if (actual_range[0] && expected_range[0] && actual_range[0].length !== expected_range[0].length) return $d551340dd0bc6b22$var$value;
    const row = actual_range.length;
    let tmp, i, j;
    // Convert single-dimension array into two-dimension array
    for(i = 0; i < row; i++){
        if (!(actual_range[i] instanceof Array)) {
            tmp = actual_range[i];
            actual_range[i] = [];
            actual_range[i].push(tmp);
        }
        if (!(expected_range[i] instanceof Array)) {
            tmp = expected_range[i];
            expected_range[i] = [];
            expected_range[i].push(tmp);
        }
    }
    const col = actual_range[0].length;
    const dof = col === 1 ? row - 1 : (row - 1) * (col - 1);
    let xsqr = 0;
    const Pi = Math.PI;
    for(i = 0; i < row; i++)for(j = 0; j < col; j++)xsqr += Math.pow(actual_range[i][j] - expected_range[i][j], 2) / expected_range[i][j];
    // Get independency by X square and its degree of freedom
    function ChiSq(xsqr, dof) {
        let p = Math.exp(-0.5 * xsqr);
        if (dof % 2 === 1) p = p * Math.sqrt(2 * xsqr / Pi);
        let k = dof;
        while(k >= 2){
            p = p * xsqr / k;
            k = k - 2;
        }
        let t = p;
        let a = dof;
        while(t > 0.0000000001 * p){
            a = a + 2;
            t = t * xsqr / a;
            p = p + t;
        }
        return 1 - p;
    }
    return Math.round(ChiSq(xsqr, dof) * 1000000) / 1000000;
};
const $d551340dd0bc6b22$export$1252dc9d6995e45d = {};
/**
 * Returns the confidence interval for a population mean.
 *
 * Category: Statistical
 *
 * @param {*} alpha The significance level used to compute the confidence level. The confidence level equals 100*(1 - alpha)%, or in other words, an alpha of 0.05 indicates a 95 percent confidence level.
 * @param {*} standard_dev The population standard deviation for the data range and is assumed to be known.
 * @param {*} size The sample size.
 * @returns
 */ $d551340dd0bc6b22$export$1252dc9d6995e45d.NORM = (alpha, standard_dev, size)=>{
    alpha = $d551340dd0bc6b22$var$parseNumber(alpha);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    size = $d551340dd0bc6b22$var$parseNumber(size);
    if ($d551340dd0bc6b22$var$anyIsError(alpha, standard_dev, size)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normalci(1, alpha, standard_dev, size)[1] - 1;
};
/**
 * Returns the confidence interval for a population mean, using a Student's t distribution.
 *
 * Category: Statistical
 *
 * @param {*} alpha The significance level used to compute the confidence level. The confidence level equals 100*(1 - alpha)%, or in other words, an alpha of 0.05 indicates a 95 percent confidence level.
 * @param {*} standard_dev The population standard deviation for the data range and is assumed to be known.
 * @param {*} size The sample size.
 * @returns
 */ $d551340dd0bc6b22$export$1252dc9d6995e45d.T = (alpha, standard_dev, size)=>{
    alpha = $d551340dd0bc6b22$var$parseNumber(alpha);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    size = $d551340dd0bc6b22$var$parseNumber(size);
    if ($d551340dd0bc6b22$var$anyIsError(alpha, standard_dev, size)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).tci(1, alpha, standard_dev, size)[1] - 1;
};
/**
 * Returns the correlation coefficient between two data sets.
 *
 * Category: Statistical
 *
 * @param {*} array1 A range of value values.
 * @param {*} array2 A second range of value values.
 * @returns
 */ function $d551340dd0bc6b22$export$fae51e0b17961c08(array1, array2) {
    array1 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array1));
    array2 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array2));
    if ($d551340dd0bc6b22$var$anyIsError(array1, array2)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).corrcoeff(array1, array2);
}
/**
 * Counts how many numbers are in the list of arguments.
 *
 * Category: Statistical
 *
 * @param {*} args Cell reference, or range within which you want to count numbers.count numbers.
 * @returns
 */ function $d551340dd0bc6b22$export$d61684373eacdf61() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    return $d551340dd0bc6b22$var$numbers(flatArguments).length;
}
/**
 * Counts how many values are in the list of arguments.
 *
 * Category: Statistical
 *
 * @param {*} args Arguments representing the values that you want to count.
 * @returns
 */ function $d551340dd0bc6b22$export$e2041fbf69361bdc() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    return flatArguments.length - $d551340dd0bc6b22$export$79c5ccd5516ec50d(flatArguments);
}
/**
 * Counts the number of blank values within a range.
 *
 * Category: Statistical
 *
 * @param {*} args The range from which you want to count the blank values.
 * @returns
 */ function $d551340dd0bc6b22$export$79c5ccd5516ec50d() {
    const range = $d551340dd0bc6b22$var$flatten(arguments);
    let blanks = 0;
    let element;
    for(let i = 0; i < range.length; i++){
        element = range[i];
        if (element === undefined || element === null || element === "") blanks++;
    }
    return blanks;
}
/**
 * Counts the number of values within a range that meet the given criteria.
 *
 * Category: Statistical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$56486fbe6da8d677(range, criteria) {
    range = $d551340dd0bc6b22$var$flatten(range);
    const isWildcard = criteria === void 0 || criteria === "*";
    if (isWildcard) return range.length;
    let matches = 0;
    const tokenizedCriteria = $d551340dd0bc6b22$var$parse(criteria + "");
    for(let i = 0; i < range.length; i++){
        const value = range[i];
        const tokens = [
            $d551340dd0bc6b22$var$createToken(value, $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
        ].concat(tokenizedCriteria);
        if ($d551340dd0bc6b22$var$compute(tokens)) matches++;
    }
    return matches;
}
/**
 * Counts the number of values within a range that meet multiple criteria.
 *
 * Category: Statistical
 *
 * @param {*} args Range in which to evaluate the associated criteria.
 * @returns
 */ function $d551340dd0bc6b22$export$4e3788eb19a40c70() {
    const args = $d551340dd0bc6b22$var$argsToArray(arguments);
    const results = new Array($d551340dd0bc6b22$var$flatten(args[0]).length);
    for(let i = 0; i < results.length; i++)results[i] = true;
    for(let i = 0; i < args.length; i += 2){
        const range = $d551340dd0bc6b22$var$flatten(args[i]);
        const criteria = args[i + 1];
        const isWildcard = criteria === void 0 || criteria === "*";
        if (!isWildcard) {
            const tokenizedCriteria = $d551340dd0bc6b22$var$parse(criteria + "");
            for(let j = 0; j < range.length; j++){
                const value = range[j];
                const tokens = [
                    $d551340dd0bc6b22$var$createToken(value, $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
                ].concat(tokenizedCriteria);
                results[j] = results[j] && $d551340dd0bc6b22$var$compute(tokens);
            }
        }
    }
    let result = 0;
    for(let i = 0; i < results.length; i++)if (results[i]) result++;
    return result;
}
const $d551340dd0bc6b22$export$fe38092c9c5592c1 = {};
/**
 * Returns covariance, the average of the products of paired deviations.
 *
 * Category: Statistical
 *
 * @param {*} array1 The first value range of integers.
 * @param {*} array2 The second value range of integers.
 * @returns
 */ $d551340dd0bc6b22$export$fe38092c9c5592c1.P = (array1, array2)=>{
    array1 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array1));
    array2 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array2));
    if ($d551340dd0bc6b22$var$anyIsError(array1, array2)) return $d551340dd0bc6b22$var$value;
    const mean1 = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(array1);
    const mean2 = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(array2);
    let result = 0;
    const n = array1.length;
    for(let i = 0; i < n; i++)result += (array1[i] - mean1) * (array2[i] - mean2);
    return result / n;
};
/**
 * Returns the sample covariance, the average of the products deviations for each data point pair in two data sets.
 *
 * Category: Statistical
 *
 * @param {*} array1 The first value range of integers.
 * @param {*} array2 The second value range of integers.
 * @returns
 */ $d551340dd0bc6b22$export$fe38092c9c5592c1.S = (array1, array2)=>{
    array1 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array1));
    array2 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array2));
    if ($d551340dd0bc6b22$var$anyIsError(array1, array2)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).covariance(array1, array2);
};
/**
 * Returns the sum of squares of deviations.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want to calculate the sum of squared deviations. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$f29d068e704fbf() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const mean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(range);
    let result = 0;
    for(let i = 0; i < range.length; i++)result += Math.pow(range[i] - mean, 2);
    return result;
}
const $d551340dd0bc6b22$export$f5c508346c29966 = {};
/**
 * Returns the exponential distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value of the function.
 * @param {*} lambda The parameter value.
 * @param {*} cumulative A logical value that indicates which form of the exponential function to provide. If cumulative is TRUE, EXPON.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$f5c508346c29966.DIST = (x, lambda, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    lambda = $d551340dd0bc6b22$var$parseNumber(lambda);
    if ($d551340dd0bc6b22$var$anyIsError(x, lambda)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).exponential.cdf(x, lambda) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).exponential.pdf(x, lambda);
};
const $d551340dd0bc6b22$export$d66501df72047452 = {};
/**
 * Returns the F probability distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} deg_freedom1 The numerator degrees of freedom.
 * @param {*} deg_freedom2 The denominator degrees of freedom.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, F.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$d66501df72047452.DIST = (x, deg_freedom1, deg_freedom2, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    deg_freedom1 = $d551340dd0bc6b22$var$parseNumber(deg_freedom1);
    deg_freedom2 = $d551340dd0bc6b22$var$parseNumber(deg_freedom2);
    if ($d551340dd0bc6b22$var$anyIsError(x, deg_freedom1, deg_freedom2)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).centralF.cdf(x, deg_freedom1, deg_freedom2) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).centralF.pdf(x, deg_freedom1, deg_freedom2);
};
/**
 * Returns the F probability distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} deg_freedom1 The numerator degrees of freedom.
 * @param {*} deg_freedom2 The denominator degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$export$d66501df72047452.DIST.RT = function(x, deg_freedom1, deg_freedom2) {
    if (arguments.length !== 3) return $d551340dd0bc6b22$var$na;
    if (x < 0 || deg_freedom1 < 1 || deg_freedom2 < 1) return $d551340dd0bc6b22$var$num;
    if (typeof x !== "number" || typeof deg_freedom1 !== "number" || typeof deg_freedom2 !== "number") return $d551340dd0bc6b22$var$value;
    return 1 - (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).centralF.cdf(x, deg_freedom1, deg_freedom2);
};
/**
 * Returns the inverse of the F probability distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability associated with the F cumulative distribution.
 * @param {*} deg_freedom1 The numerator degrees of freedom.
 * @param {*} deg_freedom2 The denominator degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$export$d66501df72047452.INV = (probability, deg_freedom1, deg_freedom2)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    deg_freedom1 = $d551340dd0bc6b22$var$parseNumber(deg_freedom1);
    deg_freedom2 = $d551340dd0bc6b22$var$parseNumber(deg_freedom2);
    if ($d551340dd0bc6b22$var$anyIsError(probability, deg_freedom1, deg_freedom2)) return $d551340dd0bc6b22$var$value;
    if (probability <= 0.0 || probability > 1.0) return $d551340dd0bc6b22$var$num;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).centralF.inv(probability, deg_freedom1, deg_freedom2);
};
/**
 * Returns the inverse of the F probability distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability associated with the F cumulative distribution.
 * @param {*} deg_freedom1 The numerator degrees of freedom.
 * @param {*} deg_freedom2 The denominator degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$export$d66501df72047452.INV.RT = function(probability, deg_freedom1, deg_freedom2) {
    if (arguments.length !== 3) return $d551340dd0bc6b22$var$na;
    if (probability < 0 || probability > 1 || deg_freedom1 < 1 || deg_freedom1 > Math.pow(10, 10) || deg_freedom2 < 1 || deg_freedom2 > Math.pow(10, 10)) return $d551340dd0bc6b22$var$num;
    if (typeof probability !== "number" || typeof deg_freedom1 !== "number" || typeof deg_freedom2 !== "number") return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).centralF.inv(1.0 - probability, deg_freedom1, deg_freedom2);
};
/**
 * Returns the result of an F-test.
 *
 * Category: Statistical
 *
 * @param {*} array1 The first array or range of data.
 * @param {*} array2 The second array or range of data.
 * @returns
 */ $d551340dd0bc6b22$export$d66501df72047452.TEST = (array1, array2)=>{
    if (!array1 || !array2) return $d551340dd0bc6b22$var$na;
    if (!(array1 instanceof Array) || !(array2 instanceof Array)) return $d551340dd0bc6b22$var$na;
    if (array1.length < 2 || array2.length < 2) return $d551340dd0bc6b22$var$div0;
    const sumOfSquares = (values, x1)=>{
        let sum = 0;
        for(let i = 0; i < values.length; i++)sum += Math.pow(values[i] - x1, 2);
        return sum;
    };
    const x1 = $d551340dd0bc6b22$export$49f482aefa6f8a2d(array1) / array1.length;
    const x2 = $d551340dd0bc6b22$export$49f482aefa6f8a2d(array2) / array2.length;
    const sum1 = sumOfSquares(array1, x1) / (array1.length - 1);
    const sum2 = sumOfSquares(array2, x2) / (array2.length - 1);
    return sum1 / sum2;
};
/**
 * Returns the Fisher transformation.
 *
 * Category: Statistical
 *
 * @param {*} x A numeric value for which you want the transformation.
 * @returns
 */ function $d551340dd0bc6b22$export$102c5fad6d1d3d0f(x) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    if (x instanceof Error) return x;
    return Math.log((1 + x) / (1 - x)) / 2;
}
/**
 * Returns the inverse of the Fisher transformation.
 *
 * Category: Statistical
 *
 * @param {*} y The value for which you want to perform the inverse of the transformation.
 * @returns
 */ function $d551340dd0bc6b22$export$7e8d9099faaf76a7(y) {
    y = $d551340dd0bc6b22$var$parseNumber(y);
    if (y instanceof Error) return y;
    const e2y = Math.exp(2 * y);
    return (e2y - 1) / (e2y + 1);
}
/**
 * Returns a value along a linear trend.
 *
 * Category: Statistical
 *
 * @param {*} x The data point for which you want to predict a value.
 * @param {*} known_ys The dependent array or range of data.
 * @param {*} known_xs The independent array or range of data.
 * @returns
 */ function $d551340dd0bc6b22$export$74e2e04859ad1fb3(x, known_ys, known_xs) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    known_ys = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_ys));
    known_xs = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_xs));
    if ($d551340dd0bc6b22$var$anyIsError(x, known_ys, known_xs)) return $d551340dd0bc6b22$var$value;
    const xmean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_xs);
    const ymean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_ys);
    const n = known_xs.length;
    let num = 0;
    let den = 0;
    for(let i = 0; i < n; i++){
        num += (known_xs[i] - xmean) * (known_ys[i] - ymean);
        den += Math.pow(known_xs[i] - xmean, 2);
    }
    const b = num / den;
    const a = ymean - b * xmean;
    return a + b * x;
}
/**
 * Returns a frequency distribution as a vertical array.
 *
 * Category: Statistical
 *
 * @param {*} data_array An array of or reference to a set of values for which you want to count frequencies. If data_array contains no values, FREQUENCY returns an array of zeros.
 * @param {*} bins_array An array of or reference to intervals into which you want to group the values in data_array. If bins_array contains no values, FREQUENCY returns the number of elements in data_array.
 * @returns
 */ function $d551340dd0bc6b22$export$6aad80bcad85ea25(data_array, bins_array) {
    data_array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(data_array));
    bins_array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(bins_array));
    if ($d551340dd0bc6b22$var$anyIsError(data_array, bins_array)) return $d551340dd0bc6b22$var$value;
    const n = data_array.length;
    const b = bins_array.length;
    const r = [];
    for(let i = 0; i <= b; i++){
        r[i] = 0;
        for(let j = 0; j < n; j++){
            if (i === 0) {
                if (data_array[j] <= bins_array[0]) r[0] += 1;
            } else if (i < b) {
                if (data_array[j] > bins_array[i - 1] && data_array[j] <= bins_array[i]) r[i] += 1;
            } else if (i === b) {
                if (data_array[j] > bins_array[b - 1]) r[b] += 1;
            }
        }
    }
    return r;
}
/**
 * Returns the Gamma function value.
 *
 * Category: Statistical
 *
 * @param {*} number Returns a number.
 * @returns
 */ function $d551340dd0bc6b22$export$3149bf0fa771f486(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$num;
    if (parseInt(number, 10) === number && number < 0) return $d551340dd0bc6b22$var$num;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).gammafn(number);
}
/**
 * Returns the gamma distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which you want to evaluate the distribution.
 * @param {*} alpha A parameter to the distribution.
 * @param {*} beta A parameter to the distribution. If beta = 1, GAMMA.DIST returns the standard gamma distribution.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, GAMMA.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$3149bf0fa771f486.DIST = function(value$1, alpha, beta, cumulative) {
    if (arguments.length !== 4) return $d551340dd0bc6b22$var$na;
    if (value$1 < 0 || alpha <= 0 || beta <= 0) return $d551340dd0bc6b22$var$value;
    if (typeof value$1 !== "number" || typeof alpha !== "number" || typeof beta !== "number") return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).gamma.cdf(value$1, alpha, beta, true) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).gamma.pdf(value$1, alpha, beta, false);
};
/**
 * Returns the inverse of the gamma cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability The probability associated with the gamma distribution.
 * @param {*} alpha A parameter to the distribution.
 * @param {*} beta A parameter to the distribution. If beta = 1, GAMMA.INV returns the standard gamma distribution.
 * @returns
 */ $d551340dd0bc6b22$export$3149bf0fa771f486.INV = function(probability, alpha, beta) {
    if (arguments.length !== 3) return $d551340dd0bc6b22$var$na;
    if (probability < 0 || probability > 1 || alpha <= 0 || beta <= 0) return $d551340dd0bc6b22$var$num;
    if (typeof probability !== "number" || typeof alpha !== "number" || typeof beta !== "number") return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).gamma.inv(probability, alpha, beta);
};
/**
 * Returns the natural logarithm of the gamma function, Γ(x).
 *
 * Category: Statistical
 *
 * @param {*} x The value for which you want to calculate GAMMALN.
 * @returns
 */ function $d551340dd0bc6b22$export$bc57bccc987a6235(x) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    if (x instanceof Error) return x;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).gammaln(x);
}
/**
 * Returns the natural logarithm of the gamma function, Γ(x).
 *
 * Category: Statistical
 *
 * @param {*} x The value for which you want to calculate GAMMALN.PRECISE.
 * @returns
 */ $d551340dd0bc6b22$export$bc57bccc987a6235.PRECISE = function(x) {
    if (arguments.length !== 1) return $d551340dd0bc6b22$var$na;
    if (x <= 0) return $d551340dd0bc6b22$var$num;
    if (typeof x !== "number") return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).gammaln(x);
};
/**
 * Returns 0.5 less than the standard normal cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} z Returns a number.
 * @returns
 */ function $d551340dd0bc6b22$export$e8fb82826dafa111(z) {
    z = $d551340dd0bc6b22$var$parseNumber(z);
    if (z instanceof Error) return z;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.cdf(z, 0, 1) - 0.5;
}
/**
 * Returns the geometric mean.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want to calculate the mean. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$c974ccf6ee53b9d2() {
    const args = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (args instanceof Error) return args;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).geomean(args);
}
/**
 * Returns values along an exponential trend.
 *
 * Category: Statistical
 *
 * @param {*} known_y The set of y-values you already know in the relationship y = b*m^x.
 - If the array known_y's is in a single column, then each column of known_x's is interpreted as a separate variable.
 - If the array known_y's is in a single row, then each row of known_x's is interpreted as a separate variable.
 - If any of the numbers in known_y's is 0 or negative, GROWTH returns the #NUM! error value.
 * @param {*} known_x Optional. An optional set of x-values that you may already know in the relationship y = b*m^x.
 - The array known_x's can include one or more sets of variables. If only one variable is used, known_y's and known_x's can be ranges of any shape, as long as they have equal dimensions. If more than one variable is used, known_y's must be a vector (that is, a range with a height of one row or a width of one column).
 - If known_x's is omitted, it is assumed to be the array {1,2,3,...} that is the same size as known_y's.
 * @param {*} new_x Optional. Are new x-values for which you want GROWTH to return corresponding y-values.
 - new_x's must include a column (or row) for each independent variable, just as known_x's does. So, if known_y's is in a single column, known_x's and new_x's must have the same number of columns. If known_y's is in a single row, known_x's and new_x's must have the same number of rows.
 - If new_x's is omitted, it is assumed to be the same as known_x's.
 - If both known_x's and new_x's are omitted, they are assumed to be the array {1,2,3,...} that is the same size as known_y's.
 * @param {*} use_const Optional. A logical value specifying whether to force the constant b to equal 1. If const is TRUE or omitted, b is calculated normally. If const is FALSE, b is set equal to 1 and the m-values are adjusted so that y = m^x.
 - If const is TRUE or omitted, b is calculated normally.
 - If const is FALSE, b is set equal to 1 and the m-values are adjusted so that y = m^x.
 * @returns
 */ function $d551340dd0bc6b22$export$2478e36aa95cfb(known_y, known_x, new_x, use_const) {
    // Credits: Ilmari Karonen (http://stackoverflow.com/questions/14161990/how-to-implement-growth-function-in-javascript)
    known_y = $d551340dd0bc6b22$var$parseNumberArray(known_y);
    if (known_y instanceof Error) return known_y;
    // Default values for optional parameters:
    let i;
    if (known_x === undefined) {
        known_x = [];
        for(i = 1; i <= known_y.length; i++)known_x.push(i);
    }
    if (new_x === undefined) {
        new_x = [];
        for(i = 1; i <= known_y.length; i++)new_x.push(i);
    }
    known_x = $d551340dd0bc6b22$var$parseNumberArray(known_x);
    new_x = $d551340dd0bc6b22$var$parseNumberArray(new_x);
    if ($d551340dd0bc6b22$var$anyIsError(known_x, new_x)) return $d551340dd0bc6b22$var$value;
    if (use_const === undefined) use_const = true;
    // Calculate sums over the data:
    const n = known_y.length;
    let avg_x = 0;
    let avg_y = 0;
    let avg_xy = 0;
    let avg_xx = 0;
    for(i = 0; i < n; i++){
        const x = known_x[i];
        const y = Math.log(known_y[i]);
        avg_x += x;
        avg_y += y;
        avg_xy += x * y;
        avg_xx += x * x;
    }
    avg_x /= n;
    avg_y /= n;
    avg_xy /= n;
    avg_xx /= n;
    // Compute linear regression coefficients:
    let beta;
    let alpha;
    if (use_const) {
        beta = (avg_xy - avg_x * avg_y) / (avg_xx - avg_x * avg_x);
        alpha = avg_y - beta * avg_x;
    } else {
        beta = avg_xy / avg_xx;
        alpha = 0;
    }
    // Compute and return result array:
    const new_y = [];
    for(i = 0; i < new_x.length; i++)new_y.push(Math.exp(alpha + beta * new_x[i]));
    return new_y;
}
/**
 * Returns the harmonic mean.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want to calculate the mean. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$385744d3d40f10b3() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const n = range.length;
    let den = 0;
    for(let i = 0; i < n; i++)den += 1 / range[i];
    return n / den;
}
const $d551340dd0bc6b22$export$4f2126ef1718652a = {};
/**
 * Returns the hypergeometric distribution.
 *
 * Category: Statistical
 *
 * @param {*} sample_s The number of successes in the sample.
 * @param {*} number_sample The size of the sample.
 * @param {*} population_s The number of successes in the population.
 * @param {*} number_pop The population size.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, then HYPGEOM.DIST returns the cumulative distribution function; if FALSE, it returns the probability mass function.
 * @returns
 */ $d551340dd0bc6b22$export$4f2126ef1718652a.DIST = (sample_s, number_sample, population_s, number_pop, cumulative)=>{
    sample_s = $d551340dd0bc6b22$var$parseNumber(sample_s);
    number_sample = $d551340dd0bc6b22$var$parseNumber(number_sample);
    population_s = $d551340dd0bc6b22$var$parseNumber(population_s);
    number_pop = $d551340dd0bc6b22$var$parseNumber(number_pop);
    if ($d551340dd0bc6b22$var$anyIsError(sample_s, number_sample, population_s, number_pop)) return $d551340dd0bc6b22$var$value;
    function pdf(x, n, M, N) {
        return $d551340dd0bc6b22$export$4b98dc7b8f648ca3(M, x) * $d551340dd0bc6b22$export$4b98dc7b8f648ca3(N - M, n - x) / $d551340dd0bc6b22$export$4b98dc7b8f648ca3(N, n);
    }
    function cdf(x, n, M, N) {
        let result = 0;
        for(let i = 0; i <= x; i++)result += pdf(i, n, M, N);
        return result;
    }
    return cumulative ? cdf(sample_s, number_sample, population_s, number_pop) : pdf(sample_s, number_sample, population_s, number_pop);
};
/**
 * Returns the intercept of the linear regression line.
 *
 * Category: Statistical
 *
 * @param {*} known_y The dependent set of observations or data.
 * @param {*} known_x The independent set of observations or data.
 * @returns
 */ function $d551340dd0bc6b22$export$12639d051cc8cc1f(known_y, known_x) {
    known_y = $d551340dd0bc6b22$var$parseNumberArray(known_y);
    known_x = $d551340dd0bc6b22$var$parseNumberArray(known_x);
    if ($d551340dd0bc6b22$var$anyIsError(known_y, known_x)) return $d551340dd0bc6b22$var$value;
    if (known_y.length !== known_x.length) return $d551340dd0bc6b22$var$na;
    return $d551340dd0bc6b22$export$74e2e04859ad1fb3(0, known_y, known_x);
}
/**
 * Returns the kurtosis of a data set.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want to calculate kurtosis. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$6e24870f8faf8e81() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const mean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(range);
    const n = range.length;
    let sigma = 0;
    for(let i = 0; i < n; i++)sigma += Math.pow(range[i] - mean, 4);
    sigma = sigma / Math.pow((0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).stdev(range, true), 4);
    return n * (n + 1) / ((n - 1) * (n - 2) * (n - 3)) * sigma - 3 * (n - 1) * (n - 1) / ((n - 2) * (n - 3));
}
/**
 * Returns the k-th largest value in a data set.
 *
 * Category: Statistical
 *
 * @param {*} array The array or range of data for which you want to determine the k-th largest value.
 * @param {*} k The position (from the largest) in the array or value range of data to return.
 * @returns
 */ function $d551340dd0bc6b22$export$7b93a10c0fefe3e3(array, k) {
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    k = $d551340dd0bc6b22$var$parseNumber(k);
    if ($d551340dd0bc6b22$var$anyIsError(array, k)) return array;
    if (k < 0 || array.length < k) return $d551340dd0bc6b22$var$value;
    return array.sort((a, b)=>b - a)[k - 1];
}
/**
 * Returns the parameters of a linear trend.
 *
 * Category: Statistical
 *
 * @param {*} known_y The set of y-values that you already know in the relationship y = mx + b.
 - If the range of known_y's is in a single column, each column of known_x's is interpreted as a separate variable.
 - If the range of known_y's is contained in a single row, each row of known_x's is interpreted as a separate variable.
 * @param {*} known_x Optional. A set of x-values that you may already know in the relationship y = mx + b.
 - The range of known_x's can include one or more sets of variables. If only one variable is used, known_y's and known_x's can be ranges of any shape, as long as they have equal dimensions. If more than one variable is used, known_y's must be a vector (that is, a range with a height of one row or a width of one column).
 - If known_x's is omitted, it is assumed to be the array {1,2,3,...} that is the same size as known_y's.
 * @returns
 */ function $d551340dd0bc6b22$export$7ae85b03504b01ef(known_y, known_x) {
    known_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_y));
    known_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_x));
    if ($d551340dd0bc6b22$var$anyIsError(known_y, known_x)) return $d551340dd0bc6b22$var$value;
    const ymean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_y);
    const xmean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_x);
    const n = known_x.length;
    let num = 0;
    let den = 0;
    for(let i = 0; i < n; i++){
        num += (known_x[i] - xmean) * (known_y[i] - ymean);
        den += Math.pow(known_x[i] - xmean, 2);
    }
    const m = num / den;
    const b = ymean - m * xmean;
    return [
        m,
        b
    ];
}
// According to Microsoft:
// http://office.microsoft.com/en-us/starter-help/logest-function-HP010342665.aspx
// LOGEST returns are based on the following linear model:
// ln y = x1 ln m1 + ... + xn ln mn + ln b
/**
 * Returns the parameters of an exponential trend.
 *
 * Category: Statistical
 *
 * @param {*} known_y The set of y-values you already know in the relationship y = b*m^x.
 - If the array known_y's is in a single column, then each column of known_x's is interpreted as a separate variable.
 - If the array known_y's is in a single row, then each row of known_x's is interpreted as a separate variable.
 * @param {*} known_x Optional. An optional set of x-values that you may already know in the relationship y = b*m^x.
 - The array known_x's can include one or more sets of variables. If only one variable is used, known_y's and known_x's can be ranges of any shape, as long as they have equal dimensions. If more than one variable is used, known_y's must be a range of values with a height of one row or a width of one column (which is also known as a vector).
 - If known_x's is omitted, it is assumed to be the array {1,2,3,...} that is the same size as known_y's.
 * @returns
 */ function $d551340dd0bc6b22$export$8640ab3af9cd810f(known_y, known_x) {
    known_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_y));
    known_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_x));
    if ($d551340dd0bc6b22$var$anyIsError(known_y, known_x)) return $d551340dd0bc6b22$var$value;
    if (known_y.length !== known_x.length) return $d551340dd0bc6b22$var$value;
    for(let i = 0; i < known_y.length; i++)known_y[i] = Math.log(known_y[i]);
    const result = $d551340dd0bc6b22$export$7ae85b03504b01ef(known_y, known_x);
    result[0] = Math.round(Math.exp(result[0]) * 1000000) / 1000000;
    result[1] = Math.round(Math.exp(result[1]) * 1000000) / 1000000;
    return result;
}
const $d551340dd0bc6b22$export$53b1f20e80f267f3 = {};
/**
 * Returns the cumulative lognormal distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} mean The mean of ln(x).
 * @param {*} standard_dev The standard deviation of ln(x).
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, LOGNORM.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$53b1f20e80f267f3.DIST = (x, mean, standard_dev, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    mean = $d551340dd0bc6b22$var$parseNumber(mean);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    if ($d551340dd0bc6b22$var$anyIsError(x, mean, standard_dev)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).lognormal.cdf(x, mean, standard_dev) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).lognormal.pdf(x, mean, standard_dev);
};
/**
 * Returns the inverse of the lognormal cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability associated with the lognormal distribution.
 * @param {*} mean The mean of ln(x).
 * @param {*} standard_dev The standard deviation of ln(x).
 * @returns
 */ $d551340dd0bc6b22$export$53b1f20e80f267f3.INV = (probability, mean, standard_dev)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    mean = $d551340dd0bc6b22$var$parseNumber(mean);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    if ($d551340dd0bc6b22$var$anyIsError(probability, mean, standard_dev)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).lognormal.inv(probability, mean, standard_dev);
};
/**
 * Returns the maximum value in a list of arguments.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 numbers for which you want to find the maximum value.
 * @returns
 */ function $d551340dd0bc6b22$export$b8767e9c28ff5faa() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArguments);
    if (someError) return someError;
    const range = $d551340dd0bc6b22$var$numbers(flatArguments);
    return range.length === 0 ? 0 : Math.max.apply(Math, range);
}
/**
 * Returns the maximum value in a list of arguments, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2,... Number arguments 2 to 255 for which you want to find the largest value.
 * @returns
 */ function $d551340dd0bc6b22$export$ef0ff395d2bca167() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArguments);
    if (someError) return someError;
    let range = $d551340dd0bc6b22$var$arrayValuesToNumbers(flatArguments);
    range = range.map((value)=>value === undefined || value === null ? 0 : value);
    return range.length === 0 ? 0 : Math.max.apply(Math, range);
}
/**
 * Returns the median of the given numbers.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 numbers for which you want the median.
 * @returns
 */ function $d551340dd0bc6b22$export$3b342059645d214a() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArguments);
    if (someError) return someError;
    const range = $d551340dd0bc6b22$var$arrayValuesToNumbers(flatArguments);
    let result = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).median(range);
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the minimum value in a list of arguments.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is optional, subsequent numbers are optional. 1 to 255 numbers for which you want to find the minimum value.
 * @returns
 */ function $d551340dd0bc6b22$export$85fbf3b9d951b785() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArguments);
    if (someError) return someError;
    const range = $d551340dd0bc6b22$var$numbers(flatArguments);
    return range.length === 0 ? 0 : Math.min.apply(Math, range);
}
/**
 * Returns the smallest value in a list of arguments, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 255 values for which you want to find the smallest value.
 * @returns
 */ function $d551340dd0bc6b22$export$99ffffb58d927f18() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, flatArguments);
    if (someError) return someError;
    let range = $d551340dd0bc6b22$var$arrayValuesToNumbers(flatArguments);
    range = range.map((value)=>value === undefined || value === null ? 0 : value);
    return range.length === 0 ? 0 : Math.min.apply(Math, range);
}
const $d551340dd0bc6b22$export$e48589d9e4824227 = {};
/**
 * Returns a vertical array of the most frequently occurring, or repetitive values in an array or range of data.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number arguments 2 to 254 for which you want to calculate the mode. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ $d551340dd0bc6b22$export$e48589d9e4824227.MULT = function() {
    // Credits: Roönaän
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const n = range.length;
    const count = {};
    let maxItems = [];
    let max = 0;
    let currentItem;
    for(let i = 0; i < n; i++){
        currentItem = range[i];
        count[currentItem] = count[currentItem] ? count[currentItem] + 1 : 1;
        if (count[currentItem] > max) {
            max = count[currentItem];
            maxItems = [];
        }
        if (count[currentItem] === max) maxItems[maxItems.length] = currentItem;
    }
    return maxItems;
};
/**
 * Returns the most common value in a data set.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Arguments 2 to 254 for which you want to calculate the mode. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ $d551340dd0bc6b22$export$e48589d9e4824227.SNGL = function() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    return $d551340dd0bc6b22$export$e48589d9e4824227.MULT(range).sort((a, b)=>a - b)[0];
};
const $d551340dd0bc6b22$export$7d27d6c799ee5741 = {};
/**
 * Returns the negative binomial distribution.
 *
 * Category: Statistical
 *
 * @param {*} number_f The number of failures.
 * @param {*} number_s The threshold number of successes.
 * @param {*} probability_s The probability of a success.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, NEGBINOM.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$7d27d6c799ee5741.DIST = (number_f, number_s, probability_s, cumulative)=>{
    number_f = $d551340dd0bc6b22$var$parseNumber(number_f);
    number_s = $d551340dd0bc6b22$var$parseNumber(number_s);
    probability_s = $d551340dd0bc6b22$var$parseNumber(probability_s);
    if ($d551340dd0bc6b22$var$anyIsError(number_f, number_s, probability_s)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).negbin.cdf(number_f, number_s, probability_s) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).negbin.pdf(number_f, number_s, probability_s);
};
const $d551340dd0bc6b22$export$954e4c4b76579057 = {};
/**
 * Returns the normal cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value for which you want the distribution.
 * @param {*} mean The arithmetic mean of the distribution.
 * @param {*} standard_dev The standard deviation of the distribution.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, NORM.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$export$954e4c4b76579057.DIST = (x, mean, standard_dev, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    mean = $d551340dd0bc6b22$var$parseNumber(mean);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    if ($d551340dd0bc6b22$var$anyIsError(x, mean, standard_dev)) return $d551340dd0bc6b22$var$value;
    if (standard_dev <= 0) return $d551340dd0bc6b22$var$num;
    // Return normal distribution computed by jStat [http://jstat.org]
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.cdf(x, mean, standard_dev) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.pdf(x, mean, standard_dev);
};
/**
 * Returns the inverse of the normal cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability corresponding to the normal distribution.
 * @param {*} mean The arithmetic mean of the distribution.
 * @param {*} standard_dev The standard deviation of the distribution.
 * @returns
 */ $d551340dd0bc6b22$export$954e4c4b76579057.INV = (probability, mean, standard_dev)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    mean = $d551340dd0bc6b22$var$parseNumber(mean);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    if ($d551340dd0bc6b22$var$anyIsError(probability, mean, standard_dev)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.inv(probability, mean, standard_dev);
};
$d551340dd0bc6b22$export$954e4c4b76579057.S = {};
/**
 * Returns the standard normal cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} z The value for which you want the distribution.
 * @param {*} cumulative Cumulative is a logical value that determines the form of the function. If cumulative is TRUE, NORMS.DIST returns the cumulative distribution function; if FALSE, it returns the probability mass function.
 * @returns
 */ $d551340dd0bc6b22$export$954e4c4b76579057.S.DIST = (z, cumulative)=>{
    z = $d551340dd0bc6b22$var$parseNumber(z);
    if (z instanceof Error) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.cdf(z, 0, 1) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.pdf(z, 0, 1);
};
/**
 * Returns the inverse of the standard normal cumulative distribution.
 *
 * Category: Statistical
 *
 * @param {*} probability A probability corresponding to the normal distribution.
 * @returns
 */ $d551340dd0bc6b22$export$954e4c4b76579057.S.INV = (probability)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    if (probability instanceof Error) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).normal.inv(probability, 0, 1);
};
/**
 * Returns the Pearson product moment correlation coefficient.
 *
 * Category: Statistical
 *
 * @param {*} array1 A set of independent values.
 * @param {*} array2 A set of dependent values.
 * @returns
 */ function $d551340dd0bc6b22$export$52136d9297595966(array1, array2) {
    array2 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array2));
    array1 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array1));
    if ($d551340dd0bc6b22$var$anyIsError(array2, array1)) return $d551340dd0bc6b22$var$value;
    const xmean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(array1);
    const ymean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(array2);
    const n = array1.length;
    let num = 0;
    let den1 = 0;
    let den2 = 0;
    for(let i = 0; i < n; i++){
        num += (array1[i] - xmean) * (array2[i] - ymean);
        den1 += Math.pow(array1[i] - xmean, 2);
        den2 += Math.pow(array2[i] - ymean, 2);
    }
    return num / Math.sqrt(den1 * den2);
}
const $d551340dd0bc6b22$export$96cfb1bd783d195e = {};
/**
 * Returns the k-th percentile of values in a range, where k is in the range 0..1, exclusive.
 *
 * Category: Statistical
 *
 * @returns
 */ $d551340dd0bc6b22$export$96cfb1bd783d195e.EXC = (array, k)=>{
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    k = $d551340dd0bc6b22$var$parseNumber(k);
    if ($d551340dd0bc6b22$var$anyIsError(array, k)) return $d551340dd0bc6b22$var$value;
    array = array.sort((a, b)=>a - b);
    const n = array.length;
    if (k < 1 / (n + 1) || k > 1 - 1 / (n + 1)) return $d551340dd0bc6b22$var$num;
    const l = k * (n + 1) - 1;
    const fl = Math.floor(l);
    return $d551340dd0bc6b22$var$cleanFloat(l === fl ? array[l] : array[fl] + (l - fl) * (array[fl + 1] - array[fl]));
};
/**
 * Returns the k-th percentile of values in a range.
 *
 * Category: Statistical
 *
 * @param {*} array The array or range of data that defines relative standing.
 * @param {*} k The percentile value in the range 0..1, inclusive.
 * @returns
 */ $d551340dd0bc6b22$export$96cfb1bd783d195e.INC = (array, k)=>{
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    k = $d551340dd0bc6b22$var$parseNumber(k);
    if ($d551340dd0bc6b22$var$anyIsError(array, k)) return $d551340dd0bc6b22$var$value;
    array = array.sort((a, b)=>a - b);
    const n = array.length;
    const l = k * (n - 1);
    const fl = Math.floor(l);
    return $d551340dd0bc6b22$var$cleanFloat(l === fl ? array[l] : array[fl] + (l - fl) * (array[fl + 1] - array[fl]));
};
const $d551340dd0bc6b22$export$483d99bb48a73bb9 = {};
/**
 * Returns the rank of a value in a data set as a percentage (0..1, exclusive) of the data set.
 *
 * Category: Statistical
 *
 * @param {*} array The array or range of data with numeric values that defines relative standing
 * @param {*} x The value for which you want to know the rank.
 * @param {*} significance Optional. A value that identifies the number of significant digits for the returned percentage value. If omitted, PERCENTRANK.EXC uses three digits (0.xxx).
 * @returns
 */ $d551340dd0bc6b22$export$483d99bb48a73bb9.EXC = (array, x, significance)=>{
    significance = significance === undefined ? 3 : significance;
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    x = $d551340dd0bc6b22$var$parseNumber(x);
    significance = $d551340dd0bc6b22$var$parseNumber(significance);
    if ($d551340dd0bc6b22$var$anyIsError(array, x, significance)) return $d551340dd0bc6b22$var$value;
    array = array.sort((a, b)=>a - b);
    const uniques = $d551340dd0bc6b22$export$97ef0433caf1f815.apply(null, array);
    const n = array.length;
    const m = uniques.length;
    const power = Math.pow(10, significance);
    let result = 0;
    let match = false;
    let i = 0;
    while(!match && i < m){
        if (x === uniques[i]) {
            result = (array.indexOf(uniques[i]) + 1) / (n + 1);
            match = true;
        } else if (x >= uniques[i] && (x < uniques[i + 1] || i === m - 1)) {
            result = (array.indexOf(uniques[i]) + 1 + (x - uniques[i]) / (uniques[i + 1] - uniques[i])) / (n + 1);
            match = true;
        }
        i++;
    }
    return Math.floor(result * power) / power;
};
/**
 * Returns the percentage rank of a value in a data set.
 *
 * Category: Statistical
 *
 * @param {*} array The array or range of data with numeric values that defines relative standing.
 * @param {*} x The value for which you want to know the rank.
 * @param {*} significance Optional. A value that identifies the number of significant digits for the returned percentage value. If omitted, PERCENTRANK.INC uses three digits (0.xxx).
 * @returns
 */ $d551340dd0bc6b22$export$483d99bb48a73bb9.INC = (array, x, significance)=>{
    significance = significance === undefined ? 3 : significance;
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    x = $d551340dd0bc6b22$var$parseNumber(x);
    significance = $d551340dd0bc6b22$var$parseNumber(significance);
    if ($d551340dd0bc6b22$var$anyIsError(array, x, significance)) return $d551340dd0bc6b22$var$value;
    array = array.sort((a, b)=>a - b);
    const uniques = $d551340dd0bc6b22$export$97ef0433caf1f815.apply(null, array);
    const n = array.length;
    const m = uniques.length;
    const power = Math.pow(10, significance);
    let result = 0;
    let match = false;
    let i = 0;
    while(!match && i < m){
        if (x === uniques[i]) {
            result = array.indexOf(uniques[i]) / (n - 1);
            match = true;
        } else if (x >= uniques[i] && (x < uniques[i + 1] || i === m - 1)) {
            result = (array.indexOf(uniques[i]) + (x - uniques[i]) / (uniques[i + 1] - uniques[i])) / (n - 1);
            match = true;
        }
        i++;
    }
    return Math.floor(result * power) / power;
};
/**
 * Returns the number of permutations for a given number of objects.
 *
 * Category: Statistical
 *
 * @param {*} number An integer that describes the number of objects.
 * @param {*} number_chosen An integer that describes the number of objects in each permutation.
 * @returns
 */ function $d551340dd0bc6b22$export$ea710945dea02842(number, number_chosen) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    number_chosen = $d551340dd0bc6b22$var$parseNumber(number_chosen);
    if ($d551340dd0bc6b22$var$anyIsError(number, number_chosen)) return $d551340dd0bc6b22$var$value;
    return $d551340dd0bc6b22$export$1bc9a132a62c6e03(number) / $d551340dd0bc6b22$export$1bc9a132a62c6e03(number - number_chosen);
}
/**
 * Returns the number of permutations for a given number of objects (with repetitions) that can be selected from the total objects.
 *
 * Category: Statistical
 *
 * @param {*} number An integer that describes the total number of objects.
 * @param {*} number_chosen An integer that describes the number of objects in each permutation.
 * @returns
 */ function $d551340dd0bc6b22$export$c2415ce19509f698(number, number_chosen) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    number_chosen = $d551340dd0bc6b22$var$parseNumber(number_chosen);
    if ($d551340dd0bc6b22$var$anyIsError(number, number_chosen)) return $d551340dd0bc6b22$var$value;
    return Math.pow(number, number_chosen);
}
/**
 * Returns the value of the density function for a standard normal distribution.
 *
 * Category: Statistical
 *
 * @param {*} x X is the number for which you want the density of the standard normal distribution.
 * @returns
 */ function $d551340dd0bc6b22$export$ed904dc4011d96f7(x) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    if (x instanceof Error) return $d551340dd0bc6b22$var$value;
    return Math.exp(-0.5 * x * x) / $d551340dd0bc6b22$var$SQRT2PI;
}
const $d551340dd0bc6b22$export$211723024797c6fd = {};
/**
 * Returns the Poisson distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The number of events.
 * @param {*} mean The expected numeric value.
 * @param {*} cumulative A logical value that determines the form of the probability distribution returned. If cumulative is TRUE, POISSON.DIST returns the cumulative Poisson probability that the number of random events occurring will be between zero and x inclusive; if FALSE, it returns the Poisson probability mass function that the number of events occurring will be exactly x.
 * @returns
 */ $d551340dd0bc6b22$export$211723024797c6fd.DIST = (x, mean, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    mean = $d551340dd0bc6b22$var$parseNumber(mean);
    if ($d551340dd0bc6b22$var$anyIsError(x, mean)) return $d551340dd0bc6b22$var$value;
    return cumulative ? (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).poisson.cdf(x, mean) : (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).poisson.pdf(x, mean);
};
/**
 * Returns the probability that values in a range are between two limits.
 *
 * Category: Statistical
 *
 * @param {*} x_range The range of numeric values of x with which there are associated probabilities.
 * @param {*} prob_range A set of probabilities associated with values in x_range.
 * @param {*} lower_limit Optional. The lower bound on the value for which you want a probability.
 * @param {*} upper_limit Optional. The optional upper bound on the value for which you want a probability.
 * @returns
 */ function $d551340dd0bc6b22$export$7d87bd18ca5227de(x_range, prob_range, lower_limit, upper_limit) {
    if (lower_limit === undefined) return 0;
    upper_limit = upper_limit === undefined ? lower_limit : upper_limit;
    x_range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(x_range));
    prob_range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(prob_range));
    lower_limit = $d551340dd0bc6b22$var$parseNumber(lower_limit);
    upper_limit = $d551340dd0bc6b22$var$parseNumber(upper_limit);
    if ($d551340dd0bc6b22$var$anyIsError(x_range, prob_range, lower_limit, upper_limit)) return $d551340dd0bc6b22$var$value;
    if (lower_limit === upper_limit) return x_range.indexOf(lower_limit) >= 0 ? prob_range[x_range.indexOf(lower_limit)] : 0;
    const sorted = x_range.sort((a, b)=>a - b);
    const n = sorted.length;
    let result = 0;
    for(let i = 0; i < n; i++)if (sorted[i] >= lower_limit && sorted[i] <= upper_limit) result += prob_range[x_range.indexOf(sorted[i])];
    return result;
}
const $d551340dd0bc6b22$export$71cc92a67a8a2333 = {};
/**
 * Returns the quartile of the data set, based on percentile values from 0..1, exclusive.
 *
 * Category: Statistical
 *
 * @param {*} array The array or value range of numeric values for which you want the quartile value.
 * @param {*} quart Indicates which value to return.
 * @returns
 */ $d551340dd0bc6b22$export$71cc92a67a8a2333.EXC = (range, quart)=>{
    range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(range));
    quart = $d551340dd0bc6b22$var$parseNumber(quart);
    if ($d551340dd0bc6b22$var$anyIsError(range, quart)) return $d551340dd0bc6b22$var$value;
    switch(quart){
        case 1:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.EXC(range, 0.25);
        case 2:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.EXC(range, 0.5);
        case 3:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.EXC(range, 0.75);
        default:
            return $d551340dd0bc6b22$var$num;
    }
};
/**
 * Returns the quartile of a data set.
 *
 * Category: Statistical
 *
 * @param {*} array The array or value range of numeric values for which you want the quartile value.
 * @param {*} quart Indicates which value to return.
 * @returns
 */ $d551340dd0bc6b22$export$71cc92a67a8a2333.INC = (range, quart)=>{
    range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(range));
    quart = $d551340dd0bc6b22$var$parseNumber(quart);
    if ($d551340dd0bc6b22$var$anyIsError(range, quart)) return $d551340dd0bc6b22$var$value;
    switch(quart){
        case 1:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.INC(range, 0.25);
        case 2:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.INC(range, 0.5);
        case 3:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.INC(range, 0.75);
        default:
            return $d551340dd0bc6b22$var$num;
    }
};
const $d551340dd0bc6b22$export$c3d7e0f1e63de60e = {};
/**
 * Returns the rank of a number in a list of numbers.
 *
 * Category: Statistical
 *
 * @param {*} number The number whose rank you want to find.
 * @param {*} ref An array of, or a reference to, a list of numbers. Nonnumeric values in Ref are ignored.
 * @param {*} order Optional. A number specifying how to rank number.
 * @returns
 */ $d551340dd0bc6b22$export$c3d7e0f1e63de60e.AVG = (number, ref, order)=>{
    number = $d551340dd0bc6b22$var$parseNumber(number);
    ref = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(ref));
    if ($d551340dd0bc6b22$var$anyIsError(number, ref)) return $d551340dd0bc6b22$var$value;
    ref = $d551340dd0bc6b22$var$flatten(ref);
    order = order || false;
    const sort = order ? (a, b)=>a - b : (a, b)=>b - a;
    ref = ref.sort(sort);
    const length = ref.length;
    let count = 0;
    for(let i = 0; i < length; i++)if (ref[i] === number) count++;
    return count > 1 ? (2 * ref.indexOf(number) + count + 1) / 2 : ref.indexOf(number) + 1;
};
/**
 * Returns the rank of a number in a list of numbers.
 *
 * Category: Statistical
 *
 * @param {*} number The number whose rank you want to find.
 * @param {*} ref An array of, or a reference to, a list of numbers. Non-numeric values in Ref are ignored.
 * @param {*} order Optional. A number specifying how to rank number.
 * @returns
 */ $d551340dd0bc6b22$export$c3d7e0f1e63de60e.EQ = (number, ref, order)=>{
    number = $d551340dd0bc6b22$var$parseNumber(number);
    ref = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(ref));
    if ($d551340dd0bc6b22$var$anyIsError(number, ref)) return $d551340dd0bc6b22$var$value;
    order = order || false;
    const sort = order ? (a, b)=>a - b : (a, b)=>b - a;
    ref = ref.sort(sort);
    return ref.indexOf(number) + 1;
};
/**
 * Returns the row number of a reference.
 *
 * Category: Lookup and reference
 *
 * @param {*} reference the value or range of values for which you want the row number.
 * @param {*} index
 * @returns
 */ function $d551340dd0bc6b22$export$7d8b172d5f206b6c(reference, index) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (index < 0) return $d551340dd0bc6b22$var$num;
    if (!(reference instanceof Array) || typeof index !== "number") return $d551340dd0bc6b22$var$value;
    if (reference.length === 0) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).row(reference, index);
}
/**
 * Returns the square of the Pearson product moment correlation coefficient.
 *
 * Category: Statistical
 *
 * @param {*} known_y An array or range of data points.
 * @param {*} known_x An array or range of data points.
 * @returns
 */ function $d551340dd0bc6b22$export$c49b46aab5b1bfa2(known_y, known_x) {
    // no need to flatten here, PEARSON will take care of that
    known_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_y));
    known_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_x));
    if ($d551340dd0bc6b22$var$anyIsError(known_y, known_x)) return $d551340dd0bc6b22$var$value;
    return Math.pow($d551340dd0bc6b22$export$52136d9297595966(known_y, known_x), 2);
}
/**
 * Returns the skewness of a distribution.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want to calculate skewness. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$30bba9af0267eaf4() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const mean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(range);
    const n = range.length;
    let sigma = 0;
    for(let i = 0; i < n; i++)sigma += Math.pow(range[i] - mean, 3);
    return n * sigma / ((n - 1) * (n - 2) * Math.pow((0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).stdev(range, true), 3));
}
/**
 * Returns the skewness of a distribution based on a population.
 *
 * Category: Statistical
 *
 * @returns
 */ $d551340dd0bc6b22$export$30bba9af0267eaf4.P = function() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const mean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(range);
    const n = range.length;
    let m2 = 0;
    let m3 = 0;
    for(let i = 0; i < n; i++){
        m3 += Math.pow(range[i] - mean, 3);
        m2 += Math.pow(range[i] - mean, 2);
    }
    m3 = m3 / n;
    m2 = m2 / n;
    return m3 / Math.pow(m2, 1.5);
};
/**
 * Returns the slope of the linear regression line.
 *
 * Category: Statistical
 *
 * @param {*} known_y An array or value range of numeric dependent data points.
 * @param {*} known_x The set of independent data points.
 * @returns
 */ function $d551340dd0bc6b22$export$96a3e1966949ddef(known_y, known_x) {
    known_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_y));
    known_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_x));
    if ($d551340dd0bc6b22$var$anyIsError(known_y, known_x)) return $d551340dd0bc6b22$var$value;
    const xmean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_x);
    const ymean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_y);
    const n = known_x.length;
    let num = 0;
    let den = 0;
    for(let i = 0; i < n; i++){
        num += (known_x[i] - xmean) * (known_y[i] - ymean);
        den += Math.pow(known_x[i] - xmean, 2);
    }
    return num / den;
}
/**
 * Returns the k-th smallest value in a data set.
 *
 * Category: Statistical
 *
 * @param {*} array An array or range of numerical data for which you want to determine the k-th smallest value.
 * @param {*} k The position (from the smallest) in the array or range of data to return.
 * @returns
 */ function $d551340dd0bc6b22$export$71dd4c8ecd45e95f(array, k) {
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    k = $d551340dd0bc6b22$var$parseNumber(k);
    if ($d551340dd0bc6b22$var$anyIsError(array, k)) return array;
    return array.sort((a, b)=>a - b)[k - 1];
}
/**
 * Returns a normalized value.
 *
 * Category: Statistical
 *
 * @param {*} x The value you want to normalize.
 * @param {*} mean The arithmetic mean of the distribution.
 * @param {*} standard_dev The standard deviation of the distribution.
 * @returns
 */ function $d551340dd0bc6b22$export$c20cef9c655bc59f(x, mean, standard_dev) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    mean = $d551340dd0bc6b22$var$parseNumber(mean);
    standard_dev = $d551340dd0bc6b22$var$parseNumber(standard_dev);
    if ($d551340dd0bc6b22$var$anyIsError(x, mean, standard_dev)) return $d551340dd0bc6b22$var$value;
    return (x - mean) / standard_dev;
}
const $d551340dd0bc6b22$export$934ea05709cb9cb8 = {};
/**
 * Calculates standard deviation based on the entire population.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number arguments 2 to 254 corresponding to a population. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ $d551340dd0bc6b22$export$934ea05709cb9cb8.P = function() {
    const v = $d551340dd0bc6b22$export$c5b2d92d160f058.P.apply(this, arguments);
    let result = Math.sqrt(v);
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
};
/**
 * Estimates standard deviation based on a sample.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number arguments 2 to 254 corresponding to a sample of a population. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ $d551340dd0bc6b22$export$934ea05709cb9cb8.S = function() {
    const v = $d551340dd0bc6b22$export$c5b2d92d160f058.S.apply(this, arguments);
    const result = Math.sqrt(v);
    return result;
};
/**
 * Estimates standard deviation based on a sample, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 255 values corresponding to a sample of a population. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$1ab610f9bfdb0c50() {
    const v = $d551340dd0bc6b22$export$452638418686aa3e.apply(this, arguments);
    const result = Math.sqrt(v);
    return result;
}
/**
 * Calculates standard deviation based on the entire population, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 255 values corresponding to a population. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$b98b3e7b6cfdbde8() {
    const v = $d551340dd0bc6b22$export$aa74bea6dd13056.apply(this, arguments);
    let result = Math.sqrt(v);
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the standard error of the predicted y-value for each x in the regression.
 *
 * Category: Statistical
 *
 * @param {*} known_y An array or range of dependent data points.
 * @param {*} known_x An array or range of independent data points.
 * @returns
 */ function $d551340dd0bc6b22$export$49c1f763fe0ea02b(known_y, known_x) {
    known_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_y));
    known_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_x));
    if ($d551340dd0bc6b22$var$anyIsError(known_y, known_x)) return $d551340dd0bc6b22$var$value;
    const xmean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_x);
    const ymean = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(known_y);
    const n = known_x.length;
    let lft = 0;
    let num = 0;
    let den = 0;
    for(let i = 0; i < n; i++){
        lft += Math.pow(known_y[i] - ymean, 2);
        num += (known_x[i] - xmean) * (known_y[i] - ymean);
        den += Math.pow(known_x[i] - xmean, 2);
    }
    return Math.sqrt((lft - num * num / den) / (n - 2));
}
const $d551340dd0bc6b22$var$T$1 = {};
/**
 * Returns the Percentage Points (probability) for the Student t-distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The numeric value at which to evaluate the distribution
 * @param {*} deg_freedom An integer indicating the number of degrees of freedom.
 * @param {*} cumulative A logical value that determines the form of the function. If cumulative is TRUE, T.DIST returns the cumulative distribution function; if FALSE, it returns the probability density function.
 * @returns
 */ $d551340dd0bc6b22$var$T$1.DIST = (x, deg_freedom, cumulative)=>{
    if (cumulative !== 1 && cumulative !== 2) return $d551340dd0bc6b22$var$num;
    return cumulative === 1 ? $d551340dd0bc6b22$var$T$1.DIST.RT(x, deg_freedom) : $d551340dd0bc6b22$var$T$1.DIST["2T"](x, deg_freedom);
};
/**
 * Returns the Percentage Points (probability) for the Student t-distribution
 *
 * Category: Statistical
 *
 * @param {*} x The numeric value at which to evaluate the distribution.
 * @param {*} deg_freedom An integer indicating the number of degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$var$T$1.DIST["2T"] = function(x, deg_freedom) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (x < 0 || deg_freedom < 1) return $d551340dd0bc6b22$var$num;
    if (typeof x !== "number" || typeof deg_freedom !== "number") return $d551340dd0bc6b22$var$value;
    return (1 - (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).studentt.cdf(x, deg_freedom)) * 2;
};
/**
 * Returns the Student's t-distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The numeric value at which to evaluate the distribution.
 * @param {*} deg_freedom An integer indicating the number of degrees of freedom.
 * @returns
 */ $d551340dd0bc6b22$var$T$1.DIST.RT = function(x, deg_freedom) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (x < 0 || deg_freedom < 1) return $d551340dd0bc6b22$var$num;
    if (typeof x !== "number" || typeof deg_freedom !== "number") return $d551340dd0bc6b22$var$value;
    return 1 - (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).studentt.cdf(x, deg_freedom);
};
/**
 * Returns the t-value of the Student's t-distribution as a function of the probability and the degrees of freedom.
 *
 * Category: Statistical
 *
 * @param {*} probability The probability associated with the Student's t-distribution.
 * @param {*} deg_freedom The number of degrees of freedom with which to characterize the distribution.
 * @returns
 */ $d551340dd0bc6b22$var$T$1.INV = (probability, deg_freedom)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    deg_freedom = $d551340dd0bc6b22$var$parseNumber(deg_freedom);
    if ($d551340dd0bc6b22$var$anyIsError(probability, deg_freedom)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).studentt.inv(probability, deg_freedom);
};
/**
 * Returns the inverse of the Student's t-distribution
 *
 * Category: Statistical
 *
 * @param {*} probability The probability associated with the Student's t-distribution.
 * @param {*} deg_freedom The number of degrees of freedom with which to characterize the distribution.
 * @returns
 */ $d551340dd0bc6b22$var$T$1.INV["2T"] = (probability, deg_freedom)=>{
    probability = $d551340dd0bc6b22$var$parseNumber(probability);
    deg_freedom = $d551340dd0bc6b22$var$parseNumber(deg_freedom);
    if (probability <= 0 || probability > 1 || deg_freedom < 1) return $d551340dd0bc6b22$var$num;
    if ($d551340dd0bc6b22$var$anyIsError(probability, deg_freedom)) return $d551340dd0bc6b22$var$value;
    return Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).studentt.inv(probability / 2, deg_freedom));
};
// The algorithm can be found here:
// http://www.chem.uoa.gr/applets/AppletTtest/Appl_Ttest2.html
/**
 * Returns the probability associated with a Student's t-test.
 *
 * Category: Statistical
 *
 * @param {*} array1 The first data set.
 * @param {*} array2 The second data set.
 * @returns
 */ $d551340dd0bc6b22$var$T$1.TEST = (array1, array2)=>{
    array1 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array1));
    array2 = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array2));
    if ($d551340dd0bc6b22$var$anyIsError(array1, array2)) return $d551340dd0bc6b22$var$value;
    const mean_x = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(array1);
    const mean_y = (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean(array2);
    let s_x = 0;
    let s_y = 0;
    let i;
    for(i = 0; i < array1.length; i++)s_x += Math.pow(array1[i] - mean_x, 2);
    for(i = 0; i < array2.length; i++)s_y += Math.pow(array2[i] - mean_y, 2);
    s_x = s_x / (array1.length - 1);
    s_y = s_y / (array2.length - 1);
    const t = Math.abs(mean_x - mean_y) / Math.sqrt(s_x / array1.length + s_y / array2.length);
    return $d551340dd0bc6b22$var$T$1.DIST["2T"](t, array1.length + array2.length - 2);
};
/**
 * Returns values along a linear trend.
 *
 * Category: Statistical
 *
 * @param {*} known_ys The set of y-values you already know in the relationship y = mx + b
 * @param {*} known_xs An optional set of x-values that you may already know in the relationship y = mx + b
 * @param {*} new_xs Optional. New x-values for which you want TREND to return corresponding y-values.
 * @returns
 */ function $d551340dd0bc6b22$export$4c516a8fc940158d(known_ys, known_xs, new_xs) {
    known_ys = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_ys));
    known_xs = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(known_xs));
    new_xs = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(new_xs));
    if ($d551340dd0bc6b22$var$anyIsError(known_ys, known_xs, new_xs)) return $d551340dd0bc6b22$var$value;
    const linest = $d551340dd0bc6b22$export$7ae85b03504b01ef(known_ys, known_xs);
    const m = linest[0];
    const b = linest[1];
    const result = [];
    new_xs.forEach((x)=>{
        result.push(m * x + b);
    });
    return result;
}
/**
 * Returns the mean of the interior of a data set.
 *
 * Category: Statistical
 *
 * @param {*} array The array or range of values to trim and average.
 * @param {*} percent The fractional number of data points to exclude from the calculation. For example, if percent = 0.2, 4 points are trimmed from a data set of 20 points (20 x 0.2): 2 from the top and 2 from the bottom of the set.
 * @returns
 */ function $d551340dd0bc6b22$export$961bf5c84a206df(range, percent) {
    range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(range));
    percent = $d551340dd0bc6b22$var$parseNumber(percent);
    if ($d551340dd0bc6b22$var$anyIsError(range, percent)) return $d551340dd0bc6b22$var$value;
    const trim = $d551340dd0bc6b22$export$a474b8effcd46ae5(range.length * percent, 2) / 2;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).mean($d551340dd0bc6b22$var$initial($d551340dd0bc6b22$var$rest(range.sort((a, b)=>a - b), trim), trim));
}
const $d551340dd0bc6b22$export$c5b2d92d160f058 = {};
/**
 * Calculates variance based on the entire population.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number arguments 2 to 254 corresponding to a population.
 * @returns
 */ $d551340dd0bc6b22$export$c5b2d92d160f058.P = function() {
    const range = $d551340dd0bc6b22$var$numbers($d551340dd0bc6b22$var$flatten(arguments));
    const n = range.length;
    let sigma = 0;
    const mean = $d551340dd0bc6b22$export$d3bfe4097a2a8542(range);
    let result;
    for(let i = 0; i < n; i++)sigma += Math.pow(range[i] - mean, 2);
    result = sigma / n;
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
};
/**
 * Estimates variance based on a sample.
 *
 * Category: Statistical
 *
 * @param {*} args number1, number2, ... Number arguments 2 to 254 corresponding to a sample of a population.
 * @returns
 */ $d551340dd0bc6b22$export$c5b2d92d160f058.S = function() {
    const range = $d551340dd0bc6b22$var$numbers($d551340dd0bc6b22$var$flatten(arguments));
    const n = range.length;
    let sigma = 0;
    const mean = $d551340dd0bc6b22$export$d3bfe4097a2a8542(range);
    for(let i = 0; i < n; i++)sigma += Math.pow(range[i] - mean, 2);
    return sigma / (n - 1);
};
/**
 * Estimates variance based on a sample, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 255 value arguments corresponding to a sample of a population.
 * @returns
 */ function $d551340dd0bc6b22$export$452638418686aa3e() {
    const range = $d551340dd0bc6b22$var$flatten(arguments);
    const n = range.length;
    let sigma = 0;
    let count = 0;
    const mean = $d551340dd0bc6b22$export$c7a6518a193e8c0d(range);
    for(let i = 0; i < n; i++){
        const el = range[i];
        if (typeof el === "number") sigma += Math.pow(el - mean, 2);
        else if (el === true) sigma += Math.pow(1 - mean, 2);
        else sigma += Math.pow(0 - mean, 2);
        if (el !== null) count++;
    }
    return sigma / (count - 1);
}
/**
 * Calculates variance based on the entire population, including numbers, text, and logical values.
 *
 * Category: Statistical
 *
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 255 value arguments corresponding to a population.
 * @returns
 */ function $d551340dd0bc6b22$export$aa74bea6dd13056() {
    const range = $d551340dd0bc6b22$var$flatten(arguments);
    const n = range.length;
    let sigma = 0;
    let count = 0;
    const mean = $d551340dd0bc6b22$export$c7a6518a193e8c0d(range);
    let result;
    for(let i = 0; i < n; i++){
        const el = range[i];
        if (typeof el === "number") sigma += Math.pow(el - mean, 2);
        else if (el === true) sigma += Math.pow(1 - mean, 2);
        else sigma += Math.pow(0 - mean, 2);
        if (el !== null) count++;
    }
    result = sigma / count;
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
const $d551340dd0bc6b22$export$dd03fb262934220c = {};
/**
 * Returns the Weibull distribution.
 *
 * Category: Statistical
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} alpha A parameter to the distribution.
 * @param {*} beta A parameter to the distribution.
 * @param {*} cumulative Determines the form of the function.
 * @returns
 */ $d551340dd0bc6b22$export$dd03fb262934220c.DIST = (x, alpha, beta, cumulative)=>{
    x = $d551340dd0bc6b22$var$parseNumber(x);
    alpha = $d551340dd0bc6b22$var$parseNumber(alpha);
    beta = $d551340dd0bc6b22$var$parseNumber(beta);
    if ($d551340dd0bc6b22$var$anyIsError(x, alpha, beta)) return $d551340dd0bc6b22$var$value;
    return cumulative ? 1 - Math.exp(-Math.pow(x / beta, alpha)) : Math.pow(x, alpha - 1) * Math.exp(-Math.pow(x / beta, alpha)) * alpha / Math.pow(beta, alpha);
};
const $d551340dd0bc6b22$export$dc98b0b04f4c7758 = {};
/**
 * Returns the one-tailed probability-value of a z-test.
 *
 * Category: Statistical
 *
 * @param {*} array The array or range of data against which to test x.
 * @param {*} x The value to test.
 * @param {*} sigma Optional. The population (known) standard deviation. If omitted, the sample standard deviation is used.
 * @returns
 */ $d551340dd0bc6b22$export$dc98b0b04f4c7758.TEST = (array, x, sigma)=>{
    array = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array));
    x = $d551340dd0bc6b22$var$parseNumber(x);
    if ($d551340dd0bc6b22$var$anyIsError(array, x)) return $d551340dd0bc6b22$var$value;
    sigma = sigma || $d551340dd0bc6b22$export$934ea05709cb9cb8.S(array);
    const n = array.length;
    return 1 - $d551340dd0bc6b22$export$954e4c4b76579057.S.DIST(($d551340dd0bc6b22$export$d3bfe4097a2a8542(array) - x) / (sigma / Math.sqrt(n)), true);
};
/**
 * Returns the absolute value of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The real number of which you want the absolute value.
 * @returns
 */ function $d551340dd0bc6b22$export$3f020f6dcff67a1b(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    const result = Math.abs(number);
    return result;
}
/**
 * Returns the arccosine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The cosine of the angle you want and must be from -1 to 1.
 * @returns
 */ function $d551340dd0bc6b22$export$93d59d9ca8b49d(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    let result = Math.acos(number);
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the inverse hyperbolic cosine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number equal to or greater than 1.
 * @returns
 */ function $d551340dd0bc6b22$export$9c6f25a6fbdc0137(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    let result = Math.log(number + Math.sqrt(number * number - 1));
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the arccotangent of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Number is the cotangent of the angle you want. This must be a real number.
 * @returns
 */ function $d551340dd0bc6b22$export$898b40668e39499(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    const result = Math.atan(1 / number);
    return result;
}
/**
 * Returns the hyperbolic arccotangent of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The absolute value of Number must be greater than 1.
 * @returns
 */ function $d551340dd0bc6b22$export$fffb17a6bfaf1e53(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    let result = 0.5 * Math.log((number + 1) / (number - 1));
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
// TODO: use options
/**
 * Returns an aggregate in a list or database.
 *
 * Category: Math and trigonometry
 *
 * @param {*} function_num A number 1 to 19 that specifies which function to use.
 * @param {*} options A numerical value that determines which values to ignore in the evaluation range for the function. Note: The function will not ignore hidden rows, nested subtotals or nested aggregates if the array argument includes a calculation, for example: =AGGREGATE(14,3,A1:A100*(A1:A100>0),1)
 * @param {*} ref1 The first numeric argument for functions that take multiple numeric arguments for which you want the aggregate value.
 * @param {*} ref2 Optional. Numeric arguments 2 to 253 for which you want the aggregate value. For functions that take an array, ref1 is an array, an array formula, or a reference to a range of values for which you want the aggregate value. Ref2 is a second argument that is required for certain functions.
 * @returns
 */ function $d551340dd0bc6b22$export$92eda5ac44f0cd25(function_num, options, ref1, ref2) {
    function_num = $d551340dd0bc6b22$var$parseNumber(function_num);
    options = $d551340dd0bc6b22$var$parseNumber(function_num);
    if ($d551340dd0bc6b22$var$anyIsError(function_num, options)) return $d551340dd0bc6b22$var$value;
    switch(function_num){
        case 1:
            return $d551340dd0bc6b22$export$d3bfe4097a2a8542(ref1);
        case 2:
            return $d551340dd0bc6b22$export$d61684373eacdf61(ref1);
        case 3:
            return $d551340dd0bc6b22$export$e2041fbf69361bdc(ref1);
        case 4:
            return $d551340dd0bc6b22$export$b8767e9c28ff5faa(ref1);
        case 5:
            return $d551340dd0bc6b22$export$85fbf3b9d951b785(ref1);
        case 6:
            return $d551340dd0bc6b22$export$e36553b0ff5db35a(ref1);
        case 7:
            return $d551340dd0bc6b22$export$934ea05709cb9cb8.S(ref1);
        case 8:
            return $d551340dd0bc6b22$export$934ea05709cb9cb8.P(ref1);
        case 9:
            return $d551340dd0bc6b22$export$49f482aefa6f8a2d(ref1);
        case 10:
            return $d551340dd0bc6b22$export$c5b2d92d160f058.S(ref1);
        case 11:
            return $d551340dd0bc6b22$export$c5b2d92d160f058.P(ref1);
        case 12:
            return $d551340dd0bc6b22$export$3b342059645d214a(ref1);
        case 13:
            return $d551340dd0bc6b22$export$e48589d9e4824227.SNGL(ref1);
        case 14:
            return $d551340dd0bc6b22$export$7b93a10c0fefe3e3(ref1, ref2);
        case 15:
            return $d551340dd0bc6b22$export$71dd4c8ecd45e95f(ref1, ref2);
        case 16:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.INC(ref1, ref2);
        case 17:
            return $d551340dd0bc6b22$export$71cc92a67a8a2333.INC(ref1, ref2);
        case 18:
            return $d551340dd0bc6b22$export$96cfb1bd783d195e.EXC(ref1, ref2);
        case 19:
            return $d551340dd0bc6b22$export$71cc92a67a8a2333.EXC(ref1, ref2);
    }
}
/**
 * Converts a Roman number to Arabic, as a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} text A string enclosed in quotation marks, an empty string (""), or a reference to a value containing text.
 * @returns
 */ function $d551340dd0bc6b22$export$f3f28ddebdd00a5(text) {
    if (text === undefined || text === null) return 0;
    if (text instanceof Error) return text;
    // Credits: Rafa? Kukawski
    if (!/^M*(?:D?C{0,3}|C[MD])(?:L?X{0,3}|X[CL])(?:V?I{0,3}|I[XV])$/.test(text)) return $d551340dd0bc6b22$var$value;
    let r = 0;
    text.replace(/[MDLV]|C[MD]?|X[CL]?|I[XV]?/g, (i)=>{
        r += ({
            M: 1000,
            CM: 900,
            D: 500,
            CD: 400,
            C: 100,
            XC: 90,
            L: 50,
            XL: 40,
            X: 10,
            IX: 9,
            V: 5,
            IV: 4,
            I: 1
        })[i];
    });
    return r;
}
/**
 * Returns the arcsine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The sine of the angle you want and must be from -1 to 1.
 * @returns
 */ function $d551340dd0bc6b22$export$6ec7c51a17f0c352(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    let result = Math.asin(number);
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Returns the inverse hyperbolic sine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number.
 * @returns
 */ function $d551340dd0bc6b22$export$86687249c3867981(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.log(number + Math.sqrt(number * number + 1));
}
/**
 * Returns the arctangent of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The tangent of the angle you want.
 * @returns
 */ function $d551340dd0bc6b22$export$da70a3627b33824a(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.atan(number);
}
/**
 * Returns the arctangent from x- and y-coordinates.
 *
 * Category: Math and trigonometry
 *
 * @param {*} x_num The x-coordinate of the point.
 * @param {*} y_num The y-coordinate of the point.
 * @returns
 */ function $d551340dd0bc6b22$export$163b6b6ca8674499(x_num, y_num) {
    x_num = $d551340dd0bc6b22$var$parseNumber(x_num);
    y_num = $d551340dd0bc6b22$var$parseNumber(y_num);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(x_num, y_num);
    if (anyError$1) return anyError$1;
    return Math.atan2(x_num, y_num);
}
/**
 * Returns the inverse hyperbolic tangent of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number between 1 and -1.
 * @returns
 */ function $d551340dd0bc6b22$export$53b7683f7726544f(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    let result = Math.log((1 + number) / (1 - number)) / 2;
    if (isNaN(result)) result = $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Converts a number into a text representation with the given radix (base).
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number that you want to convert. Must be an integer greater than or equal to 0 and less than 2^53.
 * @param {*} radix The base radix that you want to convert the number into. Must be an integer greater than or equal to 2 and less than or equal to 36.
 * @param {*} min_length Optional. The minimum length of the returned string. Must be an integer greater than or equal to 0.
 * @returns
 */ function $d551340dd0bc6b22$export$9e15ff8aa6bc996f(number, radix, min_length) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    radix = $d551340dd0bc6b22$var$parseNumber(radix);
    min_length = $d551340dd0bc6b22$var$parseNumber(min_length);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, radix, min_length);
    if (anyError$1) return anyError$1;
    if (radix === 0) return $d551340dd0bc6b22$var$num;
    const result = number.toString(radix);
    return new Array(Math.max(min_length + 1 - result.length, 0)).join("0") + result;
}
/**
 * Rounds a number to the nearest integer or to the nearest multiple of significance.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The value you want to round.
 * @param {*} significance The multiple to which you want to round.
 * @param {*} mode Optional. For negative numbers, controls whether Number is rounded toward or away from zero.
 * @returns
 */ function $d551340dd0bc6b22$export$f0c8b50ab8f753d1(number, significance, mode) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    significance = $d551340dd0bc6b22$var$parseNumber(significance);
    mode = $d551340dd0bc6b22$var$parseNumber(mode);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, significance, mode);
    if (anyError$1) return anyError$1;
    if (significance === 0) return 0;
    significance = Math.abs(significance);
    const precision = -Math.floor(Math.log(significance) / Math.log(10));
    if (number >= 0) return $d551340dd0bc6b22$export$58785fc667c0c50b(Math.ceil(number / significance) * significance, precision);
    else {
        if (mode === 0) return -$d551340dd0bc6b22$export$58785fc667c0c50b(Math.floor(Math.abs(number) / significance) * significance, precision);
        else return -$d551340dd0bc6b22$export$58785fc667c0c50b(Math.ceil(Math.abs(number) / significance) * significance, precision);
    }
}
$d551340dd0bc6b22$export$f0c8b50ab8f753d1.MATH = $d551340dd0bc6b22$export$f0c8b50ab8f753d1;
$d551340dd0bc6b22$export$f0c8b50ab8f753d1.PRECISE = $d551340dd0bc6b22$export$f0c8b50ab8f753d1;
/**
 * Returns the number of combinations for a given number of objects.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number of items.
 * @param {*} number_chosen The number of items in each combination.
 * @returns
 */ function $d551340dd0bc6b22$export$4b98dc7b8f648ca3(number, number_chosen) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    number_chosen = $d551340dd0bc6b22$var$parseNumber(number_chosen);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, number_chosen);
    if (anyError$1) return anyError$1;
    if (number < number_chosen) return $d551340dd0bc6b22$var$num;
    return $d551340dd0bc6b22$export$1bc9a132a62c6e03(number) / ($d551340dd0bc6b22$export$1bc9a132a62c6e03(number_chosen) * $d551340dd0bc6b22$export$1bc9a132a62c6e03(number - number_chosen));
}
/**
 * Returns the number of combinations with repetitions for a given number of items.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Must be greater than or equal to 0, and greater than or equal to Number_chosen. Non-integer values are truncated.
 * @param {*} number_chosen Must be greater than or equal to 0. Non-integer values are truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$87cc6829bc3933bb(number, number_chosen) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    number_chosen = $d551340dd0bc6b22$var$parseNumber(number_chosen);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, number_chosen);
    if (anyError$1) return anyError$1;
    if (number < number_chosen) return $d551340dd0bc6b22$var$num;
    return number === 0 && number_chosen === 0 ? 1 : $d551340dd0bc6b22$export$4b98dc7b8f648ca3(number + number_chosen - 1, number - 1);
}
/**
 * Returns the cosine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The angle in radians for which you want the cosine.
 * @returns
 */ function $d551340dd0bc6b22$export$ad87d6418ee1b6f7(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.cos(number);
}
/**
 * Returns the hyperbolic cosine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number for which you want to find the hyperbolic cosine.
 * @returns
 */ function $d551340dd0bc6b22$export$c482f097bea0ab1d(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return (Math.exp(number) + Math.exp(-number)) / 2;
}
/**
 * Returns the hyperbolic cosine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The angle in radians for which you want the cotangent.
 * @returns
 */ function $d551340dd0bc6b22$export$970618f14b664447(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$div0;
    return 1 / Math.tan(number);
}
/**
 * Returns the cotangent of an angle.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number
 * @returns
 */ function $d551340dd0bc6b22$export$c104510763bb4a9a(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$div0;
    const e2 = Math.exp(2 * number);
    return (e2 + 1) / (e2 - 1);
}
/**
 * Returns the cosecant of an angle.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number
 * @returns
 */ function $d551340dd0bc6b22$export$c7e023080adf60d0(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$div0;
    return 1 / Math.sin(number);
}
/**
 * Returns the hyperbolic cosecant of an angle.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number
 * @returns
 */ function $d551340dd0bc6b22$export$365ce9c46b484c73(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$div0;
    return 2 / (Math.exp(number) - Math.exp(-number));
}
/**
 * Converts a text representation of a number in a given base into a decimal number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} text
 * @param {*} radix Radix must be an integer.
 * @returns
 */ function $d551340dd0bc6b22$export$43447b36f1d78ee1(text, radix) {
    if (arguments.length < 1) return $d551340dd0bc6b22$var$value;
    text = $d551340dd0bc6b22$var$parseNumber(text);
    radix = $d551340dd0bc6b22$var$parseNumber(radix);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(text, radix);
    if (anyError$1) return anyError$1;
    if (radix === 0) return $d551340dd0bc6b22$var$num;
    return parseInt(text, radix);
}
/**
 * Converts radians to degrees.
 *
 * Category: Math and trigonometry
 *
 * @param {*} angle The angle in radians that you want to convert.
 * @returns
 */ function $d551340dd0bc6b22$export$e035ae0f6b8ef5d(angle) {
    angle = $d551340dd0bc6b22$var$parseNumber(angle);
    if (angle instanceof Error) return angle;
    return angle * 180 / Math.PI;
}
/**
 * Rounds a number up to the nearest even integer.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The value to round.
 * @returns
 */ function $d551340dd0bc6b22$export$e683606104f15b5e(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return $d551340dd0bc6b22$export$f0c8b50ab8f753d1(number, -2, -1);
}
/**
 * Returns e raised to the power of a given number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The exponent applied to the base e.
 * @returns
 */ function $d551340dd0bc6b22$export$e17bfbab9ca97165(number) {
    if (arguments.length < 1) return $d551340dd0bc6b22$var$na;
    if (arguments.length > 1) return $d551340dd0bc6b22$var$error;
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    number = Math.exp(number);
    return number;
}
const $d551340dd0bc6b22$var$MEMOIZED_FACT = [];
/**
 * Returns the factorial of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The nonnegative number for which you want the factorial. If number is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$1bc9a132a62c6e03(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    const n = Math.floor(number);
    if (n === 0 || n === 1) return 1;
    else if ($d551340dd0bc6b22$var$MEMOIZED_FACT[n] > 0) return $d551340dd0bc6b22$var$MEMOIZED_FACT[n];
    else {
        $d551340dd0bc6b22$var$MEMOIZED_FACT[n] = $d551340dd0bc6b22$export$1bc9a132a62c6e03(n - 1) * n;
        return $d551340dd0bc6b22$var$MEMOIZED_FACT[n];
    }
}
/**
 * Returns the double factorial of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The value for which to return the double factorial. If number is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$b61d90bab1b87d62(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    const n = Math.floor(number);
    return n <= 0 ? 1 : n * $d551340dd0bc6b22$export$b61d90bab1b87d62(n - 2);
}
/**
 * Rounds a number down, toward zero.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The numeric value you want to round.
 * @param {*} significance The multiple to which you want to round.
 * @returns
 */ function $d551340dd0bc6b22$export$a474b8effcd46ae5(number, significance) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    significance = $d551340dd0bc6b22$var$parseNumber(significance);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, significance);
    if (anyError$1) return anyError$1;
    if (significance === 0) return 0;
    if (!(number >= 0 && significance > 0) && !(number <= 0 && significance < 0)) return $d551340dd0bc6b22$var$num;
    significance = Math.abs(significance);
    const precision = -Math.floor(Math.log(significance) / Math.log(10));
    return number >= 0 ? $d551340dd0bc6b22$export$58785fc667c0c50b(Math.floor(number / significance) * significance, precision) : -$d551340dd0bc6b22$export$58785fc667c0c50b(Math.ceil(Math.abs(number) / significance), precision);
}
// TODO: Verify
/**
 * Rounds a number down, to the nearest integer or to the nearest multiple of significance.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number to be rounded down.
 * @param {*} significance Optional. The multiple to which you want to round.
 * @param {*} mode Optional. The direction (toward or away from 0) to round negative numbers.
 * @returns
 */ $d551340dd0bc6b22$export$a474b8effcd46ae5.MATH = (number, significance, mode)=>{
    if (significance instanceof Error) return significance;
    significance = significance === undefined ? 0 : significance;
    number = $d551340dd0bc6b22$var$parseNumber(number);
    significance = $d551340dd0bc6b22$var$parseNumber(significance);
    mode = $d551340dd0bc6b22$var$parseNumber(mode);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, significance, mode);
    if (anyError$1) return anyError$1;
    if (significance === 0) return 0;
    significance = significance ? Math.abs(significance) : 1;
    const precision = -Math.floor(Math.log(significance) / Math.log(10));
    if (number >= 0) return $d551340dd0bc6b22$export$58785fc667c0c50b(Math.floor(number / significance) * significance, precision);
    else if (mode === 0 || mode === undefined) return -$d551340dd0bc6b22$export$58785fc667c0c50b(Math.ceil(Math.abs(number) / significance) * significance, precision);
    return -$d551340dd0bc6b22$export$58785fc667c0c50b(Math.floor(Math.abs(number) / significance) * significance, precision);
};
// Deprecated
/**
 * Rounds a number the nearest integer or to the nearest multiple of significance. Regardless of the sign of the number, the number is rounded up.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The value to be rounded.
 * @param {*} significance Optional. The multiple to which number is to be rounded. If significance is omitted, its default value is 1.
 * @returns
 */ $d551340dd0bc6b22$export$a474b8effcd46ae5.PRECISE = $d551340dd0bc6b22$export$a474b8effcd46ae5["MATH"];
// adapted http://rosettacode.org/wiki/Greatest_common_divisor#JavaScript
/**
 * Returns the greatest common divisor.
 *
 * Category: Math and trigonometry
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 values. If any value is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$49dcb9cac7f2209f() {
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (range instanceof Error) return range;
    const n = range.length;
    const r0 = range[0];
    let x = r0 < 0 ? -r0 : r0;
    for(let i = 1; i < n; i++){
        const ri = range[i];
        let y = ri < 0 ? -ri : ri;
        while(x && y)if (x > y) x %= y;
        else y %= x;
        x += y;
    }
    return x;
}
/**
 * Rounds a number down to the nearest integer.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The real number you want to round down to an integer.
 * @returns
 */ function $d551340dd0bc6b22$export$160e8bdd97bfce3a(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.floor(number);
}
// TODO: verify
const $d551340dd0bc6b22$export$7568b915c40af082 = {
    CEILING: $d551340dd0bc6b22$export$f0c8b50ab8f753d1
};
/**
 * Returns the least common multiple.
 *
 * Category: Math and trigonometry
 *
 * @param {*} args number1, number2,... Number1 is required, subsequent numbers are optional. 1 to 255 values for which you want the least common multiple. If value is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$a49d82dd4e9bea7e() {
    // Credits: Jonas Raoni Soares Silva
    const o = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (o instanceof Error) return o;
    for(var i, j, n, d, r = 1; (n = o.pop()) !== undefined;){
        if (n === 0) return 0;
        while(n > 1){
            if (n % 2) {
                for(i = 3, j = Math.floor(Math.sqrt(n)); i <= j && n % i; i += 2);
                d = i <= j ? i : n;
            } else d = 2;
            for(n /= d, r *= d, i = o.length; i; o[--i] % d === 0 && (o[i] /= d) === 1 && o.splice(i, 1));
        }
    }
    return r;
}
/**
 * Returns the natural logarithm of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The positive real number for which you want the natural logarithm.
 * @returns
 */ function $d551340dd0bc6b22$export$cd68b0482cce1c64(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$num;
    return Math.log(number);
}
/**
 * Returns the logarithm of a number to a specified base.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The positive real number for which you want the logarithm.
 * @param {*} base Optional. The base of the logarithm. If base is omitted, it is assumed to be 10.
 * @returns
 */ function $d551340dd0bc6b22$export$5bfbc7f735892ffd(number, base) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    base = $d551340dd0bc6b22$var$parseNumber(base);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, base);
    if (anyError$1) return anyError$1;
    if (number === 0 || base === 0) return $d551340dd0bc6b22$var$num;
    return Math.log(number) / Math.log(base);
}
/**
 * Returns the base-10 logarithm of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The positive real number for which you want the base-10 logarithm.
 * @returns
 */ function $d551340dd0bc6b22$export$477e99aa3321d32f(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number === 0) return $d551340dd0bc6b22$var$num;
    return Math.log(number) / Math.log(10);
}
/**
 * Returns the matrix product of two arrays. The result is an array with the same number of rows as array1 and the same number of columns as array2.
 *
 * Category: Math and trigonometry
 *
 * @param {*} array1 Required. 1st array you want to multiply.
 * @param {*} array2 Required. 2nd array you want to multiply.
 * @returns
 */ function $d551340dd0bc6b22$export$ed61442476b2a1c5(array1, array2) {
    if (//Arguments are not arrays
    !Array.isArray(array1) || !Array.isArray(array2) || // There are empty arrays
    array1.some((el)=>!el.length) || array2.some((el)=>!el.length) || // Not all array elements are numbers
    $d551340dd0bc6b22$var$flattenShallow(array1).some((el)=>typeof el !== "number") || $d551340dd0bc6b22$var$flattenShallow(array2).some((el)=>typeof el !== "number") || // Number of columns in array1 is different from the number of rows in array2
    array1[0].length !== array2.length) return $d551340dd0bc6b22$var$value;
    const matrix = Array(array1.length).fill(0).map(()=>Array(array2[0].length).fill(0));
    return matrix.map((row, i)=>row.map((_, j)=>array1[i].reduce((sum, el, k)=>sum + el * array2[k][j], 0)));
}
/**
 * Returns the remainder from division.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number for which you want to find the remainder.
 * @param {*} divisor The number by which you want to divide number.
 * @returns
 */ function $d551340dd0bc6b22$export$4c64c06afd02bfd3(number, divisor) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    divisor = $d551340dd0bc6b22$var$parseNumber(divisor);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, divisor);
    if (anyError$1) return anyError$1;
    if (divisor === 0) return $d551340dd0bc6b22$var$div0;
    let modulus = Math.abs(number % divisor);
    modulus = number < 0 ? divisor - modulus : modulus;
    return divisor > 0 ? modulus : -modulus;
}
/**
 * Returns a number rounded to the desired multiple.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The value to round.
 * @param {*} multiple The multiple to which you want to round number.
 * @returns
 */ function $d551340dd0bc6b22$export$a74ae6b3fefc2d0a(number, multiple) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    multiple = $d551340dd0bc6b22$var$parseNumber(multiple);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, multiple);
    if (anyError$1) return anyError$1;
    if (number * multiple === 0) return 0;
    if (number * multiple < 0) return $d551340dd0bc6b22$var$num;
    return Math.round(number / multiple) * multiple;
}
/**
 * Returns the multinomial of a set of numbers.
 *
 * Category: Math and trigonometry
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 values for which you want the multinomial.
 * @returns
 */ function $d551340dd0bc6b22$export$89db55406475366f() {
    const args = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (args instanceof Error) return args;
    let sum = 0;
    let divisor = 1;
    for(let i = 0; i < args.length; i++){
        sum += args[i];
        divisor *= $d551340dd0bc6b22$export$1bc9a132a62c6e03(args[i]);
    }
    return $d551340dd0bc6b22$export$1bc9a132a62c6e03(sum) / divisor;
}
/**
 * Returns the unit matrix for the specified dimension.
 *
 * Category: Math and trigonometry
 *
 * @param {*} dimension Required. Dimension is an integer specifying the dimension of the unit matrix that you want to return. It returns an array. The dimension has to be greater than zero.
 * @returns
 */ function $d551340dd0bc6b22$export$1cdcc8208c58b690(dimension) {
    if (arguments.length > 1) return $d551340dd0bc6b22$var$na;
    dimension = parseInt(dimension);
    if (!dimension || dimension <= 0) return $d551340dd0bc6b22$var$value;
    return Array(dimension).fill(0).map(()=>Array(dimension).fill(0)).map((el, i)=>{
        el[i] = 1;
        return el;
    });
}
/**
 * Rounds a number up to the nearest odd integer.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number: The value to round.
 * @returns
 */ function $d551340dd0bc6b22$export$9254a0c7a34901b(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    let temp = Math.ceil(Math.abs(number));
    temp = temp & 1 ? temp : temp + 1;
    return number >= 0 ? temp : -temp;
}
/**
 * Returns the value of pi.
 *
 * Category: Math and trigonometry
 *
 * @returns
 */ function $d551340dd0bc6b22$export$6b5c1ceb16d01dc3() {
    return Math.PI;
}
/**
 * Returns the result of a number raised to a power.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The base number. It can be any real number.
 * @param {*} power The exponent to which the base number is raised.
 * @returns
 */ function $d551340dd0bc6b22$export$be706c8e2fc01f1e(number, power) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    power = $d551340dd0bc6b22$var$parseNumber(power);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, power);
    if (anyError$1) return anyError$1;
    if (number === 0 && power === 0) return $d551340dd0bc6b22$var$num;
    const result = Math.pow(number, power);
    if (isNaN(result)) return $d551340dd0bc6b22$var$num;
    return result;
}
/**
 * Multiplies its arguments.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number1 The first number or range that you want to multiply.
 * @param {*} args number2, ... Optional. Additional numbers or ranges that you want to multiply, up to a maximum of 255 arguments.
 * @returns
 */ function $d551340dd0bc6b22$export$e36553b0ff5db35a() {
    const flatArguments = $d551340dd0bc6b22$var$flatten(arguments);
    const flatArgumentsDefined = flatArguments.filter((arg)=>arg !== undefined && arg !== null);
    if (flatArgumentsDefined.length === 0) return 0;
    const args = $d551340dd0bc6b22$var$parseNumberArray(flatArgumentsDefined);
    if (args instanceof Error) return args;
    let result = 1;
    for(let i = 0; i < args.length; i++)result *= args[i];
    return result;
}
/**
 * Returns the integer portion of a division.
 *
 * Category: Math and trigonometry
 *
 * @param {*} numerator The dividend.
 * @param {*} denominator The divisor.
 * @returns
 */ function $d551340dd0bc6b22$export$ec8b5e8af73ad056(numerator, denominator) {
    numerator = $d551340dd0bc6b22$var$parseNumber(numerator);
    denominator = $d551340dd0bc6b22$var$parseNumber(denominator);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(numerator, denominator);
    if (anyError$1) return anyError$1;
    return parseInt(numerator / denominator, 10);
}
/**
 * Converts degrees to radians.
 *
 * Category: Math and trigonometry
 *
 * @param {*} angle An angle in degrees that you want to convert.
 * @returns
 */ function $d551340dd0bc6b22$export$fd1bf64c4a4ea04a(angle) {
    angle = $d551340dd0bc6b22$var$parseNumber(angle);
    if (angle instanceof Error) return angle;
    return angle * Math.PI / 180;
}
/**
 * Returns a random number between 0 and 1.
 *
 * Category: Math and trigonometry
 *
 * @returns
 */ function $d551340dd0bc6b22$export$4e7c67dedeed1227() {
    return Math.random();
}
/**
 * Returns a random number between the numbers you specify.
 *
 * Category: Math and trigonometry
 *
 * @param {*} bottom The smallest integer RANDBETWEEN will return.
 * @param {*} top The largest integer RANDBETWEEN will return.
 * @returns
 */ function $d551340dd0bc6b22$export$61958e7e9517fa35(bottom, top) {
    bottom = $d551340dd0bc6b22$var$parseNumber(bottom);
    top = $d551340dd0bc6b22$var$parseNumber(top);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(bottom, top);
    if (anyError$1) return anyError$1;
    // Creative Commons Attribution 3.0 License
    // Copyright (c) 2012 eqcode
    return bottom + Math.ceil((top - bottom + 1) * Math.random()) - 1;
}
// TODO
/**
 * Converts an arabic numeral to roman, as text.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The Arabic numeral you want converted.
 * @returns
 */ function $d551340dd0bc6b22$export$7baddb2e10b0df81(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    // The MIT License
    // Copyright (c) 2008 Steven Levithan
    const digits = String(number).split("");
    const key = [
        "",
        "C",
        "CC",
        "CCC",
        "CD",
        "D",
        "DC",
        "DCC",
        "DCCC",
        "CM",
        "",
        "X",
        "XX",
        "XXX",
        "XL",
        "L",
        "LX",
        "LXX",
        "LXXX",
        "XC",
        "",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX"
    ];
    let roman = "";
    let i = 3;
    while(i--)roman = (key[+digits.pop() + i * 10] || "") + roman;
    return new Array(+digits.join("") + 1).join("M") + roman;
}
/**
 * Rounds a number to a specified number of digits.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number that you want to round.
 * @param {*} num_digits The number of digits to which you want to round the number argument.
 * @returns
 */ function $d551340dd0bc6b22$export$58785fc667c0c50b(number, num_digits) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    num_digits = $d551340dd0bc6b22$var$parseNumber(num_digits);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, num_digits);
    if (anyError$1) return anyError$1;
    return Number(Math.round(Number(number + "e" + num_digits)) + "e" + num_digits * -1);
}
/**
 * Rounds a number down, toward zero.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number that you want rounded down.
 * @param {*} num_digits The number of digits to which you want to round number.
 * @returns
 */ function $d551340dd0bc6b22$export$6a650594f8ffefb4(number, num_digits) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    num_digits = $d551340dd0bc6b22$var$parseNumber(num_digits);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, num_digits);
    if (anyError$1) return anyError$1;
    const sign = number > 0 ? 1 : -1;
    return sign * Math.floor(Math.abs(number) * Math.pow(10, num_digits)) / Math.pow(10, num_digits);
}
/**
 * Rounds a number up, away from zero.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number that you want rounded up.
 * @param {*} num_digits The number of digits to which you want to round number.
 * @returns
 */ function $d551340dd0bc6b22$export$b7446e455e0657e(number, num_digits) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    num_digits = $d551340dd0bc6b22$var$parseNumber(num_digits);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, num_digits);
    if (anyError$1) return anyError$1;
    const sign = number > 0 ? 1 : -1;
    return sign * Math.ceil(Math.abs(number) * Math.pow(10, num_digits)) / Math.pow(10, num_digits);
}
/**
 * Returns the secant of an angle.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The angle in radians for which you want the secant.
 * @returns
 */ function $d551340dd0bc6b22$export$ee4fb2f71ac0a6f3(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return 1 / Math.cos(number);
}
/**
 * Returns the hyperbolic secant of an angle.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The angle in radians for which you want the hyperbolic secant.
 * @returns
 */ function $d551340dd0bc6b22$export$28c0f049ac3db384(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return 2 / (Math.exp(number) + Math.exp(-number));
}
/**
 * Returns the sum of a power series based on the formula.
 *
 * Category: Math and trigonometry
 *
 * @param {*} x The input value to the power series.
 * @param {*} n The initial power to which you want to raise x.
 * @param {*} m The step by which to increase n for each term in the series.
 * @param {*} coefficients A set of coefficients by which each successive power of x is multiplied. The number of values in coefficients determines the number of terms in the power series. For example, if there are three values in coefficients, then there will be three terms in the power series.
 * @returns
 */ function $d551340dd0bc6b22$export$ce8517f205412e66(x, n, m, coefficients) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    n = $d551340dd0bc6b22$var$parseNumber(n);
    m = $d551340dd0bc6b22$var$parseNumber(m);
    coefficients = $d551340dd0bc6b22$var$parseNumberArray(coefficients);
    if ($d551340dd0bc6b22$var$anyIsError(x, n, m, coefficients)) return $d551340dd0bc6b22$var$value;
    let result = coefficients[0] * Math.pow(x, n);
    for(let i = 1; i < coefficients.length; i++)result += coefficients[i] * Math.pow(x, n + i * m);
    return result;
}
/**
 * Returns the sign of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number.
 * @returns
 */ function $d551340dd0bc6b22$export$df2ead8b55b621ca(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number < 0) return -1;
    else if (number === 0) return 0;
    else return 1;
}
/**
 * Returns the sine of the given angle.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The angle in radians for which you want the sine.
 * @returns
 */ function $d551340dd0bc6b22$export$f7b80159cec397e9(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.sin(number);
}
/**
 * Returns the hyperbolic sine of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number.
 * @returns
 */ function $d551340dd0bc6b22$export$521907ef58177e6d(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return (Math.exp(number) - Math.exp(-number)) / 2;
}
/**
 * Returns a positive square root.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number for which you want the square root.
 * @returns
 */ function $d551340dd0bc6b22$export$e70e87d56a2384f6(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    if (number < 0) return $d551340dd0bc6b22$var$num;
    return Math.sqrt(number);
}
/**
 * Returns the square root of (number * pi).
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number by which pi is multiplied.
 * @returns
 */ function $d551340dd0bc6b22$export$8dee1226a39c0df9(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.sqrt(number * Math.PI);
}
/**
 * Returns a subtotal in a list or database.
 *
 * Category: Math and trigonometry
 *
 * @param {*} function_num The number 1-11 or 101-111 that specifies the function to use for the subtotal. 1-11 includes manually-hidden rows, while 101-111 excludes them; filtered-out values are always excluded.
 * @param {*} ref1 The first named range or reference for which you want the subtotal.
 * @returns
 */ function $d551340dd0bc6b22$export$cf76db510f91e229(function_num, ref1) {
    function_num = $d551340dd0bc6b22$var$parseNumber(function_num);
    if (function_num instanceof Error) return function_num;
    switch(function_num){
        case 1:
            return $d551340dd0bc6b22$export$d3bfe4097a2a8542(ref1);
        case 2:
            return $d551340dd0bc6b22$export$d61684373eacdf61(ref1);
        case 3:
            return $d551340dd0bc6b22$export$e2041fbf69361bdc(ref1);
        case 4:
            return $d551340dd0bc6b22$export$b8767e9c28ff5faa(ref1);
        case 5:
            return $d551340dd0bc6b22$export$85fbf3b9d951b785(ref1);
        case 6:
            return $d551340dd0bc6b22$export$e36553b0ff5db35a(ref1);
        case 7:
            return $d551340dd0bc6b22$export$934ea05709cb9cb8.S(ref1);
        case 8:
            return $d551340dd0bc6b22$export$934ea05709cb9cb8.P(ref1);
        case 9:
            return $d551340dd0bc6b22$export$49f482aefa6f8a2d(ref1);
        case 10:
            return $d551340dd0bc6b22$export$c5b2d92d160f058.S(ref1);
        case 11:
            return $d551340dd0bc6b22$export$c5b2d92d160f058.P(ref1);
        // no hidden values for us
        case 101:
            return $d551340dd0bc6b22$export$d3bfe4097a2a8542(ref1);
        case 102:
            return $d551340dd0bc6b22$export$d61684373eacdf61(ref1);
        case 103:
            return $d551340dd0bc6b22$export$e2041fbf69361bdc(ref1);
        case 104:
            return $d551340dd0bc6b22$export$b8767e9c28ff5faa(ref1);
        case 105:
            return $d551340dd0bc6b22$export$85fbf3b9d951b785(ref1);
        case 106:
            return $d551340dd0bc6b22$export$e36553b0ff5db35a(ref1);
        case 107:
            return $d551340dd0bc6b22$export$934ea05709cb9cb8.S(ref1);
        case 108:
            return $d551340dd0bc6b22$export$934ea05709cb9cb8.P(ref1);
        case 109:
            return $d551340dd0bc6b22$export$49f482aefa6f8a2d(ref1);
        case 110:
            return $d551340dd0bc6b22$export$c5b2d92d160f058.S(ref1);
        case 111:
            return $d551340dd0bc6b22$export$c5b2d92d160f058.P(ref1);
    }
}
/**
 * Adds its arguments.
 *
 * Category: Math and trigonometry
 *
 * @returns
 */ function $d551340dd0bc6b22$export$49f482aefa6f8a2d() {
    let result = 0;
    $d551340dd0bc6b22$var$arrayEach($d551340dd0bc6b22$var$argsToArray(arguments), (value)=>{
        if (result instanceof Error) return false;
        else if (value instanceof Error) result = value;
        else if (typeof value === "number") result += value;
        else if (typeof value === "string") {
            const parsed = parseFloat(value);
            !isNaN(parsed) && (result += parsed);
        } else if (Array.isArray(value)) {
            const inner_result = $d551340dd0bc6b22$export$49f482aefa6f8a2d.apply(null, value);
            if (inner_result instanceof Error) result = inner_result;
            else result += inner_result;
        }
    });
    return result;
}
/**
 * Adds the values specified by a given criteria.
 *
 * Category: Math and trigonometry
 *
 * @param {*} range The range of values that you want evaluated by criteria. Cells in each range must be numbers or names, arrays, or references that contain numbers. Blank and text values are ignored.
 * @param {*} criteria The criteria in the form of a number, expression, a value reference, text, or a function that defines which values will be added.
 * @param {*} sum_range Optional. The actual values to add, if you want to add values other than those specified in the range argument. If the sum_range argument is omitted, Excel adds the values that are specified in the range argument (the same values to which the criteria is applied). Sum_range should be the same size and shape as range. If it isn't, performance may suffer, and the formula will sum a range of values that starts with the first value in sum_range but has the same dimensions as range.
 * @returns
 */ function $d551340dd0bc6b22$export$1cbee7f6af20ac15(range, criteria, sum_range) {
    range = $d551340dd0bc6b22$var$flatten(range);
    sum_range = sum_range ? $d551340dd0bc6b22$var$flatten(sum_range) : range;
    if (range instanceof Error) return range;
    if (criteria === undefined || criteria === null || criteria instanceof Error) return 0;
    let result = 0;
    const isWildcard = criteria === "*";
    const tokenizedCriteria = isWildcard ? null : $d551340dd0bc6b22$var$parse(criteria + "");
    for(let i = 0; i < range.length; i++){
        const value = range[i];
        const sumValue = sum_range[i];
        if (isWildcard) result += value;
        else {
            const tokens = [
                $d551340dd0bc6b22$var$createToken(value, $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
            ].concat(tokenizedCriteria);
            result += $d551340dd0bc6b22$var$compute(tokens) ? sumValue : 0;
        }
    }
    return result;
}
/**
 * Adds the values in a range that meet multiple criteria.
 *
 * Category: Math and trigonometry
 *
 * @returns
 */ function $d551340dd0bc6b22$export$a73d3a96cd302f2d() {
    const args = $d551340dd0bc6b22$var$argsToArray(arguments);
    const range = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(args.shift()));
    if (range instanceof Error) return range;
    const criterias = args;
    const criteriaLength = criterias.length / 2;
    for(let i = 0; i < criteriaLength; i++)criterias[i * 2] = $d551340dd0bc6b22$var$flatten(criterias[i * 2]);
    let result = 0;
    for(let i = 0; i < range.length; i++){
        let isMeetCondition = false;
        for(let j = 0; j < criteriaLength; j++){
            const valueToTest = criterias[j * 2][i];
            const criteria = criterias[j * 2 + 1];
            const isWildcard = criteria === void 0 || criteria === "*";
            let computedResult = false;
            if (isWildcard) computedResult = true;
            else {
                const tokenizedCriteria = $d551340dd0bc6b22$var$parse(criteria + "");
                const tokens = [
                    $d551340dd0bc6b22$var$createToken(valueToTest, $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
                ].concat(tokenizedCriteria);
                computedResult = $d551340dd0bc6b22$var$compute(tokens);
            }
            // Criterias are calculated as AND so any `false` breakes the loop as unmeet condition
            if (!computedResult) {
                isMeetCondition = false;
                break;
            }
            isMeetCondition = true;
        }
        if (isMeetCondition) result += range[i];
    }
    return result;
}
/**
 * Returns the sum of the products of corresponding array components.
 *
 * Category: Math and trigonometry
 *
 * @returns
 */ function $d551340dd0bc6b22$export$2c36d5634aed7202() {
    if (!arguments || arguments.length === 0) return $d551340dd0bc6b22$var$value;
    const arrays = arguments.length + 1;
    let result = 0;
    let product;
    let k;
    let _i;
    let _ij;
    for(let i = 0; i < arguments[0].length; i++){
        if (!(arguments[0][i] instanceof Array)) {
            product = 1;
            for(k = 1; k < arrays; k++){
                const _i_arg = arguments[k - 1][i];
                if (_i_arg instanceof Error) return _i_arg;
                _i = $d551340dd0bc6b22$var$parseNumber(_i_arg);
                if (_i instanceof Error) return _i;
                product *= _i;
            }
            result += product;
        } else for(let j = 0; j < arguments[0][i].length; j++){
            product = 1;
            for(k = 1; k < arrays; k++){
                const _ij_arg = arguments[k - 1][i][j];
                if (_ij_arg instanceof Error) return _ij_arg;
                _ij = $d551340dd0bc6b22$var$parseNumber(_ij_arg);
                if (_ij instanceof Error) return _ij;
                product *= _ij;
            }
            result += product;
        }
    }
    return result;
}
/**
 * Returns the sum of the squares of the arguments.
 *
 * Category: Math and trigonometry
 *
 * @param {*} args number1, number2, ... Number1 is required, subsequent numbers are optional. 1 to 255 arguments for which you want the sum of the squares. You can also use a single array or a reference to an array instead of arguments separated by commas.
 * @returns
 */ function $d551340dd0bc6b22$export$34759eda0f9d3329() {
    const numbers = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (numbers instanceof Error) return numbers;
    let result = 0;
    const length = numbers.length;
    for(let i = 0; i < length; i++)result += $d551340dd0bc6b22$export$95ae71f78f3360a1(numbers[i]) ? numbers[i] * numbers[i] : 0;
    return result;
}
/**
 * Returns the sum of the difference of squares of corresponding values in two arrays.
 *
 * Category: Math and trigonometry
 *
 * @param {*} array_x The first array or range of values.
 * @param {*} array_y The second array or range of values.
 * @returns
 */ function $d551340dd0bc6b22$export$459320e8dc6bab36(array_x, array_y) {
    array_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_x));
    array_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_y));
    if ($d551340dd0bc6b22$var$anyIsError(array_x, array_y)) return $d551340dd0bc6b22$var$value;
    let result = 0;
    for(let i = 0; i < array_x.length; i++)result += array_x[i] * array_x[i] - array_y[i] * array_y[i];
    return result;
}
/**
 * Returns the sum of the sum of squares of corresponding values in two arrays.
 *
 * Category: Math and trigonometry
 *
 * @param {*} array_x The first array or range of values.
 * @param {*} array_y The second array or range of values.
 * @returns
 */ function $d551340dd0bc6b22$export$a6269694a00b927c(array_x, array_y) {
    array_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_x));
    array_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_y));
    if ($d551340dd0bc6b22$var$anyIsError(array_x, array_y)) return $d551340dd0bc6b22$var$value;
    let result = 0;
    array_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_x));
    array_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_y));
    for(let i = 0; i < array_x.length; i++)result += array_x[i] * array_x[i] + array_y[i] * array_y[i];
    return result;
}
/**
 * Returns the sum of squares of differences of corresponding values in two arrays.
 *
 * Category: Math and trigonometry
 *
 * @param {*} array_x The first array or range of values.
 * @param {*} array_y The second array or range of values.
 * @returns
 */ function $d551340dd0bc6b22$export$3d335ca4359cd239(array_x, array_y) {
    array_x = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_x));
    array_y = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(array_y));
    if ($d551340dd0bc6b22$var$anyIsError(array_x, array_y)) return $d551340dd0bc6b22$var$value;
    let result = 0;
    array_x = $d551340dd0bc6b22$var$flatten(array_x);
    array_y = $d551340dd0bc6b22$var$flatten(array_y);
    for(let i = 0; i < array_x.length; i++)result += Math.pow(array_x[i] - array_y[i], 2);
    return result;
}
/**
 * Returns the tangent of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The angle in radians for which you want the tangent.
 * @returns
 */ function $d551340dd0bc6b22$export$1f10d7019617b9d9(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    return Math.tan(number);
}
/**
 * Returns the hyperbolic tangent of a number.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number Any real number.
 * @returns
 */ function $d551340dd0bc6b22$export$243800e3aac0e175(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    const e2 = Math.exp(2 * number);
    return (e2 - 1) / (e2 + 1);
}
/**
 * Truncates a number to an integer.
 *
 * Category: Math and trigonometry
 *
 * @param {*} number The number you want to truncate.
 * @param {*} num_digits Optional. A number specifying the precision of the truncation. The default value for num_digits is 0 (zero).
 * @returns
 */ function $d551340dd0bc6b22$export$144f89cfbad1b927(number, num_digits) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    num_digits = $d551340dd0bc6b22$var$parseNumber(num_digits);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(number, num_digits);
    if (anyError$1) return anyError$1;
    const sign = number > 0 ? 1 : -1;
    return sign * Math.floor(Math.abs(number) * Math.pow(10, num_digits)) / Math.pow(10, num_digits);
}
/**
 * Following functions are part of Formula.js only and not found in Excel.
 * Purpose of these functions is to implement an Excel like behaviour for fundamental math symbols such as +, -, /, *, etc.
 */ /**
 * Formula.js only.
 *
 * @param {*} num1
 * @param {*} num2
 * @returns
 */ function $d551340dd0bc6b22$var$ADD(num1, num2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    num1 = $d551340dd0bc6b22$var$parseNumber(num1);
    num2 = $d551340dd0bc6b22$var$parseNumber(num2);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(num1, num2);
    if (anyError$1) return anyError$1;
    return num1 + num2;
}
/**
 * Formula.js only
 *
 * @param {*} dividend
 * @param {*} divisor
 * @returns
 */ function $d551340dd0bc6b22$var$DIVIDE(dividend, divisor) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    dividend = $d551340dd0bc6b22$var$parseNumber(dividend);
    divisor = $d551340dd0bc6b22$var$parseNumber(divisor);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(dividend, divisor);
    if (anyError$1) return anyError$1;
    if (divisor === 0) return $d551340dd0bc6b22$var$div0;
    return dividend / divisor;
}
/**
 * Formula.js only
 *
 * @param {*} value1
 * @param {*} value2
 * @returns
 */ function $d551340dd0bc6b22$var$EQ(value1, value2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (value1 instanceof Error) return value1;
    if (value2 instanceof Error) return value2;
    if (value1 === null) value1 = undefined;
    if (value2 === null) value2 = undefined;
    return value1 === value2;
}
/**
 * Formula.js only
 *
 * @param {*} num1
 * @param {*} num2
 * @returns
 */ function $d551340dd0bc6b22$var$GT(num1, num2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (num1 instanceof Error) return num1;
    if (num2 instanceof Error) return num2;
    if ($d551340dd0bc6b22$var$anyIsString(num1, num2)) {
        num1 = $d551340dd0bc6b22$var$parseString(num1);
        num2 = $d551340dd0bc6b22$var$parseString(num2);
    } else {
        num1 = $d551340dd0bc6b22$var$parseNumber(num1);
        num2 = $d551340dd0bc6b22$var$parseNumber(num2);
    }
    const anyError$1 = $d551340dd0bc6b22$var$anyError(num1, num2);
    if (anyError$1) return anyError$1;
    return num1 > num2;
}
/**
 * Formula.js only
 *
 * @param {*} num1
 * @param {*} num2
 * @returns
 */ function $d551340dd0bc6b22$var$GTE(num1, num2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if ($d551340dd0bc6b22$var$anyIsString(num1, num2)) {
        num1 = $d551340dd0bc6b22$var$parseString(num1);
        num2 = $d551340dd0bc6b22$var$parseString(num2);
    } else {
        num1 = $d551340dd0bc6b22$var$parseNumber(num1);
        num2 = $d551340dd0bc6b22$var$parseNumber(num2);
    }
    const anyError$1 = $d551340dd0bc6b22$var$anyError(num1, num2);
    if (anyError$1) return anyError$1;
    return num1 >= num2;
}
/**
 * Formula.js only
 *
 * @param {*} num1
 * @param {*} num2
 * @returns
 */ function $d551340dd0bc6b22$var$LT(num1, num2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if ($d551340dd0bc6b22$var$anyIsString(num1, num2)) {
        num1 = $d551340dd0bc6b22$var$parseString(num1);
        num2 = $d551340dd0bc6b22$var$parseString(num2);
    } else {
        num1 = $d551340dd0bc6b22$var$parseNumber(num1);
        num2 = $d551340dd0bc6b22$var$parseNumber(num2);
    }
    const anyError$1 = $d551340dd0bc6b22$var$anyError(num1, num2);
    if (anyError$1) return anyError$1;
    return num1 < num2;
}
/**
 * Formula.js only
 *
 * @param {*} num1
 * @param {*} num2
 * @returns
 */ function $d551340dd0bc6b22$var$LTE(num1, num2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if ($d551340dd0bc6b22$var$anyIsString(num1, num2)) {
        num1 = $d551340dd0bc6b22$var$parseString(num1);
        num2 = $d551340dd0bc6b22$var$parseString(num2);
    } else {
        num1 = $d551340dd0bc6b22$var$parseNumber(num1);
        num2 = $d551340dd0bc6b22$var$parseNumber(num2);
    }
    const anyError$1 = $d551340dd0bc6b22$var$anyError(num1, num2);
    if (anyError$1) return anyError$1;
    return num1 <= num2;
}
/**
 * Formula.js only
 *
 * @param {*} num1
 * @param {*} num2
 * @returns
 */ function $d551340dd0bc6b22$var$MINUS(num1, num2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    num1 = $d551340dd0bc6b22$var$parseNumber(num1);
    num2 = $d551340dd0bc6b22$var$parseNumber(num2);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(num1, num2);
    if (anyError$1) return anyError$1;
    return num1 - num2;
}
/**
 * Formula.js only
 *
 * @param {*} factor1
 * @param {*} factor2
 * @returns
 */ function $d551340dd0bc6b22$var$MULTIPLY(factor1, factor2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    factor1 = $d551340dd0bc6b22$var$parseNumber(factor1);
    factor2 = $d551340dd0bc6b22$var$parseNumber(factor2);
    const anyError$1 = $d551340dd0bc6b22$var$anyError(factor1, factor2);
    if (anyError$1) return anyError$1;
    return factor1 * factor2;
}
/**
 * Formula.js only
 *
 * @param {*} value1
 * @param {*} value2
 * @returns
 */ function $d551340dd0bc6b22$var$NE(value1, value2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    if (value1 instanceof Error) return value1;
    if (value2 instanceof Error) return value2;
    if (value1 === null) value1 = undefined;
    if (value2 === null) value2 = undefined;
    return value1 !== value2;
}
/**
 * Formula.js only
 *
 * @param {*} base
 * @param {*} exponent
 * @returns
 */ function $d551340dd0bc6b22$var$POW(base, exponent) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    return $d551340dd0bc6b22$export$be706c8e2fc01f1e(base, exponent);
}
var $d551340dd0bc6b22$var$symbols = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ADD: $d551340dd0bc6b22$var$ADD,
    DIVIDE: $d551340dd0bc6b22$var$DIVIDE,
    EQ: $d551340dd0bc6b22$var$EQ,
    GT: $d551340dd0bc6b22$var$GT,
    GTE: $d551340dd0bc6b22$var$GTE,
    LT: $d551340dd0bc6b22$var$LT,
    LTE: $d551340dd0bc6b22$var$LTE,
    MINUS: $d551340dd0bc6b22$var$MINUS,
    MULTIPLY: $d551340dd0bc6b22$var$MULTIPLY,
    NE: $d551340dd0bc6b22$var$NE,
    POW: $d551340dd0bc6b22$var$POW
});
const $d551340dd0bc6b22$var$d1900 = new Date(Date.UTC(1900, 0, 1));
const $d551340dd0bc6b22$var$WEEK_STARTS = [
    undefined,
    0,
    1,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    1,
    2,
    3,
    4,
    5,
    6,
    0
];
const $d551340dd0bc6b22$var$WEEK_TYPES = [
    [],
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ],
    [
        7,
        1,
        2,
        3,
        4,
        5,
        6
    ],
    [
        6,
        0,
        1,
        2,
        3,
        4,
        5
    ],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [
        7,
        1,
        2,
        3,
        4,
        5,
        6
    ],
    [
        6,
        7,
        1,
        2,
        3,
        4,
        5
    ],
    [
        5,
        6,
        7,
        1,
        2,
        3,
        4
    ],
    [
        4,
        5,
        6,
        7,
        1,
        2,
        3
    ],
    [
        3,
        4,
        5,
        6,
        7,
        1,
        2
    ],
    [
        2,
        3,
        4,
        5,
        6,
        7,
        1
    ],
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ]
];
const $d551340dd0bc6b22$var$WEEKEND_TYPES = [
    [],
    [
        6,
        0
    ],
    [
        0,
        1
    ],
    [
        1,
        2
    ],
    [
        2,
        3
    ],
    [
        3,
        4
    ],
    [
        4,
        5
    ],
    [
        5,
        6
    ],
    undefined,
    undefined,
    undefined,
    [
        0,
        0
    ],
    [
        1,
        1
    ],
    [
        2,
        2
    ],
    [
        3,
        3
    ],
    [
        4,
        4
    ],
    [
        5,
        5
    ],
    [
        6,
        6
    ]
];
/**
 * Returns the serial number of a particular date.
 *
 * Category: Date and time
 *
 * @param {*} year Year
 * @param {*} month Month
 * @param {*} day Day
 * @returns
 */ function $d551340dd0bc6b22$export$501a7fac1df67a49(year, month, day) {
    let result;
    year = $d551340dd0bc6b22$var$parseNumber(year);
    month = $d551340dd0bc6b22$var$parseNumber(month);
    day = $d551340dd0bc6b22$var$parseNumber(day);
    if ($d551340dd0bc6b22$var$anyIsError(year, month, day)) result = $d551340dd0bc6b22$var$value;
    else {
        result = new Date(year, month - 1, day);
        if (result.getFullYear() < 0) result = $d551340dd0bc6b22$var$num;
    }
    return result;
}
/**
 * Calculates the number of days, months, or years between two dates. This function is useful in formulas where you need to calculate an age.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the first, or starting date of a given period.
 * @param {*} end_date A date that represents the last, or ending, date of the period.
 * @param {*} unit The type of information that you want returned, where:
 - "Y": The number of complete years in the period.
 - "M": The number of complete months in the period.
 - "D": The number of days in the period.
 - "MD": The difference between the days in start_date and end_date. The months and years of the dates are ignored.
 - "YM": The difference between the months in start_date and end_date. The days and years of the dates are ignored
 - "YD": The difference between the days of start_date and end_date. The years of the dates are ignored.
 * @returns
 */ function $d551340dd0bc6b22$export$6f5ad06e6a29fbac(start_date, end_date, unit) {
    unit = unit.toUpperCase();
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    end_date = $d551340dd0bc6b22$var$parseDate(end_date);
    const start_date_year = start_date.getFullYear();
    const start_date_month = start_date.getMonth();
    const start_date_day = start_date.getDate();
    const end_date_year = end_date.getFullYear();
    const end_date_month = end_date.getMonth();
    const end_date_day = end_date.getDate();
    let result;
    switch(unit){
        case "Y":
            result = Math.floor($d551340dd0bc6b22$export$469c0023d0dca9cc(start_date, end_date));
            break;
        case "D":
            result = $d551340dd0bc6b22$export$b387b66963374517(end_date, start_date);
            break;
        case "M":
            result = end_date_month - start_date_month + 12 * (end_date_year - start_date_year);
            if (end_date_day < start_date_day) result--;
            break;
        case "MD":
            if (start_date_day <= end_date_day) result = end_date_day - start_date_day;
            else {
                if (end_date_month === 0) {
                    start_date.setFullYear(end_date_year - 1);
                    start_date.setMonth(12);
                } else {
                    start_date.setFullYear(end_date_year);
                    start_date.setMonth(end_date_month - 1);
                }
                result = $d551340dd0bc6b22$export$b387b66963374517(end_date, start_date);
            }
            break;
        case "YM":
            result = end_date_month - start_date_month + 12 * (end_date_year - start_date_year);
            if (end_date_day < start_date_day) result--;
            result = result % 12;
            break;
        case "YD":
            if (end_date_month > start_date_month || end_date_month === start_date_month && end_date_day < start_date_day) start_date.setFullYear(end_date_year);
            else start_date.setFullYear(end_date_year - 1);
            result = $d551340dd0bc6b22$export$b387b66963374517(end_date, start_date);
            break;
    }
    return result;
}
/**
 * Converts a date in the form of text to a serial number.
 *
 * Category: Date and time
 *
 * @param {*} date_text Text that represents a date in an Excel date format, or a reference to a value that contains text that represents a date in an Excel date format.
 * @returns
 */ function $d551340dd0bc6b22$export$e3f09fa020f269c7(date_text) {
    if (typeof date_text !== "string") return $d551340dd0bc6b22$var$value;
    const date = Date.parse(date_text);
    if (isNaN(date)) return $d551340dd0bc6b22$var$value;
    return new Date(date_text);
}
/**
 * Converts a serial number to a day of the month.
 *
 * Category: Date and time
 *
 * @param {*} serial_number The date of the day you are trying to find.
 * @returns
 */ function $d551340dd0bc6b22$export$1a58b8d7f494dd72(serial_number) {
    const date = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (date instanceof Error) return date;
    return date.getDate();
}
function $d551340dd0bc6b22$var$startOfDay(date) {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
}
/**
 * Returns the number of days between two dates.
 *
 * Category: Date and time
 *
 * @param {*} end_date Start_date and End_date are the two dates between which you want to know the number of days.
 * @param {*} start_date Start_date and End_date are the two dates between which you want to know the number of days.
 * @returns
 */ function $d551340dd0bc6b22$export$b387b66963374517(end_date, start_date) {
    end_date = $d551340dd0bc6b22$var$parseDate(end_date);
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    if (end_date instanceof Error) return end_date;
    if (start_date instanceof Error) return start_date;
    return $d551340dd0bc6b22$var$serial($d551340dd0bc6b22$var$startOfDay(end_date)) - $d551340dd0bc6b22$var$serial($d551340dd0bc6b22$var$startOfDay(start_date));
}
/**
 * Calculates the number of days between two dates based on a 360-day year.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the start date. If start_date occurs after end_date, the DAYS360 function returns a negative number.
 * @param {*} end_date A date that represents the end date.
 * @param {*} method Optional. A logical value that specifies whether to use the U.S. or European method in the calculation.
 * @returns
 */ function $d551340dd0bc6b22$export$4c238f3198b1a02b(start_date, end_date, method) {
    method = $d551340dd0bc6b22$var$parseBool(method || "false");
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    end_date = $d551340dd0bc6b22$var$parseDate(end_date);
    if (start_date instanceof Error) return start_date;
    if (end_date instanceof Error) return end_date;
    if (method instanceof Error) return method;
    const sm = start_date.getMonth();
    let em = end_date.getMonth();
    let sd, ed;
    if (method) {
        sd = start_date.getDate() === 31 ? 30 : start_date.getDate();
        ed = end_date.getDate() === 31 ? 30 : end_date.getDate();
    } else {
        const smd = new Date(start_date.getFullYear(), sm + 1, 0).getDate();
        const emd = new Date(end_date.getFullYear(), em + 1, 0).getDate();
        sd = start_date.getDate() === smd ? 30 : start_date.getDate();
        if (end_date.getDate() === emd) {
            if (sd < 30) {
                em++;
                ed = 1;
            } else ed = 30;
        } else ed = end_date.getDate();
    }
    return 360 * (end_date.getFullYear() - start_date.getFullYear()) + 30 * (em - sm) + (ed - sd);
}
/**
 * Returns the serial number of the date that is the indicated number of months before or after the start date.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the start date.
 * @param {*} months The number of months before or after start_date. A positive value for months yields a future date; a negative value yields a past date.
 * @returns
 */ function $d551340dd0bc6b22$export$52383d62d4929c09(start_date, months) {
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    if (start_date instanceof Error) return start_date;
    if (isNaN(months)) return $d551340dd0bc6b22$var$value;
    months = parseInt(months, 10);
    start_date.setMonth(start_date.getMonth() + months);
    return start_date;
}
/**
 * Returns the serial number of the last day of the month before or after a specified number of months.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the starting date.
 * @param {*} months The number of months before or after start_date. A positive value for months yields a future date; a negative value yields a past date.
 * @returns
 */ function $d551340dd0bc6b22$export$22e9b578c796b59c(start_date, months) {
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    if (start_date instanceof Error) return start_date;
    if (isNaN(months)) return $d551340dd0bc6b22$var$value;
    months = parseInt(months, 10);
    return new Date(start_date.getFullYear(), start_date.getMonth() + months + 1, 0);
}
/**
 * Converts a serial number to an hour.
 *
 * Category: Date and time
 *
 * @param {*} serial_number The time that contains the hour you want to find. Times may be entered as text strings within quotation marks (for example, "6:45 PM"), as decimal numbers (for example, 0.78125, which represents 6:45 PM), or as results of other formulas or functions (for example, TIMEVALUE("6:45 PM")).
 * @returns
 */ function $d551340dd0bc6b22$export$1bf939ebcf31ef0e(serial_number) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    return serial_number.getHours();
}
/**
 * Returns the number of the ISO week number of the year for a given date.
 *
 * Category: Date and time
 *
 * @param {*} date Date is the date-time code used by Excel for date and time calculation.
 * @returns
 */ function $d551340dd0bc6b22$export$c265b26ff2341555(date) {
    date = $d551340dd0bc6b22$var$parseDate(date);
    if (date instanceof Error) return date;
    date = $d551340dd0bc6b22$var$startOfDay(date);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const yearStart = new Date(date.getFullYear(), 0, 1);
    return Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
}
/**
 * Converts a serial number to a minute.
 *
 * Category: Date and time
 *
 * @param {*} serial_number The time that contains the minute you want to find. Times may be entered as text strings within quotation marks (for example, "6:45 PM"), as decimal numbers (for example, 0.78125, which represents 6:45 PM), or as results of other formulas or functions (for example, TIMEVALUE("6:45 PM")).
 * @returns
 */ function $d551340dd0bc6b22$export$f4aba04677f37907(serial_number) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    return serial_number.getMinutes();
}
/**
 * Converts a serial number to a month.
 *
 * Category: Date and time
 *
 * @param {*} serial_number The date of the month you are trying to find.
 * @returns
 */ function $d551340dd0bc6b22$export$fa5253a4540f3e3a(serial_number) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    return serial_number.getMonth() + 1;
}
/**
 * Returns the number of whole workdays between two dates.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the start date.
 * @param {*} end_date A date that represents the end date.
 * @param {*} holidays Optional. An optional range of one or more dates to exclude from the working calendar, such as state and federal holidays and floating holidays. The list can be either a range of values that contains the dates or an array constant of the serial numbers that represent the dates.
 * @returns
 */ function $d551340dd0bc6b22$export$b029795fd7335958(start_date, end_date, holidays) {
    return $d551340dd0bc6b22$export$b029795fd7335958.INTL(start_date, end_date, 1, holidays);
}
/**
 * Returns the number of whole workdays between two dates using parameters to indicate which and how many days are weekend days.
 *
 * Category: Date and time
 *
 * @param {*} start_date The date for from which the difference is to be computed. The start_date can be earlier than, the same as, or later than the end_date.
 * @param {*} end_date The date for to which the difference is to be computed.
 * @param {*} weekend Optional. Indicates the days of the week that are weekend days and are not included in the number of whole working days between start_date and end_date. Weekend is a weekend number or string that specifies when weekends occur. Weekend number values indicate the following weekend days:
 * @param {*} holidays Optional. An optional set of one or more dates that are to be excluded from the working day calendar. holidays shall be a range of values that contain the dates, or an array constant of the serial values that represent those dates. The ordering of dates or serial values in holidays can be arbitrary.
 * @returns
 */ $d551340dd0bc6b22$export$b029795fd7335958.INTL = (start_date, end_date, weekend, holidays)=>{
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    if (start_date instanceof Error) return start_date;
    end_date = $d551340dd0bc6b22$var$parseDate(end_date);
    if (end_date instanceof Error) return end_date;
    let isMask = false;
    const maskDays = [];
    const maskIndex = [
        1,
        2,
        3,
        4,
        5,
        6,
        0
    ];
    const maskRegex = new RegExp("^[0|1]{7}$");
    if (weekend === undefined) weekend = $d551340dd0bc6b22$var$WEEKEND_TYPES[1];
    else if (typeof weekend === "string" && maskRegex.test(weekend)) {
        isMask = true;
        weekend = weekend.split("");
        for(let i = 0; i < weekend.length; i++)if (weekend[i] === "1") maskDays.push(maskIndex[i]);
    } else weekend = $d551340dd0bc6b22$var$WEEKEND_TYPES[weekend];
    if (!(weekend instanceof Array)) return $d551340dd0bc6b22$var$value;
    if (holidays === undefined) holidays = [];
    else if (!(holidays instanceof Array)) holidays = [
        holidays
    ];
    for(let i = 0; i < holidays.length; i++){
        const h = $d551340dd0bc6b22$var$parseDate(holidays[i]);
        if (h instanceof Error) return h;
        holidays[i] = h;
    }
    const days = Math.round((end_date - start_date) / 86400000) + 1;
    let total = days;
    const day = start_date;
    for(let i = 0; i < days; i++){
        const d = new Date().getTimezoneOffset() > 0 ? day.getUTCDay() : day.getDay();
        let dec = isMask ? maskDays.includes(d) : d === weekend[0] || d === weekend[1];
        for(let j = 0; j < holidays.length; j++){
            const holiday = holidays[j];
            if (holiday.getDate() === day.getDate() && holiday.getMonth() === day.getMonth() && holiday.getFullYear() === day.getFullYear()) {
                dec = true;
                break;
            }
        }
        if (dec) total--;
        day.setDate(day.getDate() + 1);
    }
    return total;
};
/**
 * Returns the serial number of the current date and time.
 *
 * Category: Date and time
 *
 * @returns
 */ function $d551340dd0bc6b22$export$ecb408e1f47ed474() {
    return new Date();
}
/**
 * Converts a serial number to a second.
 *
 * Category: Date and time
 *
 * @param {*} serial_number The time that contains the seconds you want to find. Times may be entered as text strings within quotation marks (for example, "6:45 PM"), as decimal numbers (for example, 0.78125, which represents 6:45 PM), or as results of other formulas or functions (for example, TIMEVALUE("6:45 PM")).
 * @returns
 */ function $d551340dd0bc6b22$export$6879ea1c217f4705(serial_number) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    return serial_number.getSeconds();
}
/**
 * Returns the serial number of a particular time.
 *
 * Category: Date and time
 *
 * @param {*} hour A number from 0 (zero) to 32767 representing the hour. Any value greater than 23 will be divided by 24 and the remainder will be treated as the hour value. For example, TIME(27,0,0) = TIME(3,0,0) = .125 or 3:00 AM.
 * @param {*} minute A number from 0 to 32767 representing the minute. Any value greater than 59 will be converted to hours and minutes. For example, TIME(0,750,0) = TIME(12,30,0) = .520833 or 12:30 PM.
 * @param {*} second A number from 0 to 32767 representing the second. Any value greater than 59 will be converted to hours, minutes, and seconds. For example, TIME(0,0,2000) = TIME(0,33,22) = .023148 or 12:33:20 AM
 * @returns
 */ function $d551340dd0bc6b22$export$a9905336c0111a3a(hour, minute, second) {
    hour = $d551340dd0bc6b22$var$parseNumber(hour);
    minute = $d551340dd0bc6b22$var$parseNumber(minute);
    second = $d551340dd0bc6b22$var$parseNumber(second);
    if ($d551340dd0bc6b22$var$anyIsError(hour, minute, second)) return $d551340dd0bc6b22$var$value;
    if (hour < 0 || minute < 0 || second < 0) return $d551340dd0bc6b22$var$num;
    return (3600 * hour + 60 * minute + second) / 86400;
}
/**
 * Converts a time in the form of text to a serial number.
 *
 * Category: Date and time
 *
 * @param {*} time_text A text string that represents a time in any one of the Microsoft Excel time formats; for example, "6:45 PM" and "18:45" text strings within quotation marks that represent time.
 * @returns
 */ function $d551340dd0bc6b22$export$9119f65cecd8ea41(time_text) {
    time_text = $d551340dd0bc6b22$var$parseDate(time_text);
    if (time_text instanceof Error) return time_text;
    return (3600 * time_text.getHours() + 60 * time_text.getMinutes() + time_text.getSeconds()) / 86400;
}
/**
 * Returns the serial number of today's date.
 *
 * Category: Date and time
 *
 * @returns
 */ function $d551340dd0bc6b22$export$ee6bbe0a973ca0e8() {
    return $d551340dd0bc6b22$var$startOfDay(new Date());
}
/**
 * Converts a serial number to a day of the week.
 *
 * Category: Date and time
 *
 * @param {*} serial_number A sequential number that represents the date of the day you are trying to find.
 * @param {*} return_type Optional. A number that determines the type of return value.
 * @returns
 */ function $d551340dd0bc6b22$export$7fe5411a648bea7f(serial_number, return_type) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    if (return_type === undefined) return_type = 1;
    const day = serial_number.getDay();
    return $d551340dd0bc6b22$var$WEEK_TYPES[return_type][day];
}
/**
 * Converts a serial number to a number representing where the week falls numerically with a year.
 *
 * Category: Date and time
 *
 * @param {*} serial_number A date within the week.
 * @param {*} return_type Optional. A number that determines on which day the week begins. The default is 1.
 * @returns
 */ function $d551340dd0bc6b22$export$c53a71708078a608(serial_number, return_type) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    if (return_type === undefined) return_type = 1;
    if (return_type === 21) return $d551340dd0bc6b22$export$c265b26ff2341555(serial_number);
    const week_start = $d551340dd0bc6b22$var$WEEK_STARTS[return_type];
    let jan = new Date(serial_number.getFullYear(), 0, 1);
    const inc = jan.getDay() < week_start ? 1 : 0;
    jan -= Math.abs(jan.getDay() - week_start) * 86400000;
    return Math.floor((serial_number - jan) / 86400000 / 7 + 1) + inc;
}
/**
 * Returns the serial number of the date before or after a specified number of workdays.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the start date.
 * @param {*} days The number of nonweekend and nonholiday days before or after start_date. A positive value for days yields a future date; a negative value yields a past date.
 * @param {*} holidays Optional. An optional list of one or more dates to exclude from the working calendar, such as state and federal holidays and floating holidays. The list can be either a range of values that contain the dates or an array constant of the serial numbers that represent the dates.
 * @returns
 */ function $d551340dd0bc6b22$export$4ddd5a796076b49d(start_date, days, holidays) {
    return $d551340dd0bc6b22$export$4ddd5a796076b49d.INTL(start_date, days, 1, holidays);
}
/**
 * Returns the serial number of the date before or after a specified number of workdays using parameters to indicate which and how many days are weekend days.
 *
 * Category: Date and time
 *
 * @param {*} start_date The start date, truncated to integer.
 * @param {*} days The number of workdays before or after the start_date. A positive value yields a future date; a negative value yields a past date; a zero value yields the start_date. Day-offset is truncated to an integer.
 * @param {*} weekend Optional. Indicates the days of the week that are weekend days and are not considered working days. Weekend is a weekend number or string that specifies when weekends occur. Weekend number values indicate the following weekend days:
 * @param {*} holidays Optional. An optional set of one or more dates that are to be excluded from the working day calendar. Holidays shall be a range of values that contain the dates, or an array constant of the serial values that represent those dates. The ordering of dates or serial values in holidays can be arbitrary.
 * @returns
 */ $d551340dd0bc6b22$export$4ddd5a796076b49d.INTL = (start_date, days, weekend, holidays)=>{
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    if (start_date instanceof Error) return start_date;
    days = $d551340dd0bc6b22$var$parseNumber(days);
    if (days instanceof Error) return days;
    if (weekend === undefined) weekend = $d551340dd0bc6b22$var$WEEKEND_TYPES[1];
    else weekend = $d551340dd0bc6b22$var$WEEKEND_TYPES[weekend];
    if (!(weekend instanceof Array)) return $d551340dd0bc6b22$var$value;
    if (holidays === undefined) holidays = [];
    else if (!(holidays instanceof Array)) holidays = [
        holidays
    ];
    for(let i = 0; i < holidays.length; i++){
        const h = $d551340dd0bc6b22$var$parseDate(holidays[i]);
        if (h instanceof Error) return h;
        holidays[i] = h;
    }
    let d = 0;
    const sign = Math.sign(days);
    while(d < days * sign){
        start_date.setDate(start_date.getDate() + sign);
        const day = start_date.getDay();
        if (day === weekend[0] || day === weekend[1]) continue;
        for(let j = 0; j < holidays.length; j++){
            const holiday = holidays[j];
            if (holiday.getDate() === start_date.getDate() && holiday.getMonth() === start_date.getMonth() && holiday.getFullYear() === start_date.getFullYear()) {
                d--;
                break;
            }
        }
        d++;
    }
    // EXCEL does not recognize dates before 1900.
    if (start_date.getFullYear() < 1900) return $d551340dd0bc6b22$var$value;
    return start_date;
};
/**
 * Converts a serial number to a year.
 *
 * Category: Date and time
 *
 * @param {*} serial_number The date of the year you want to find.
 * @returns
 */ function $d551340dd0bc6b22$export$90b88dc425a06a95(serial_number) {
    serial_number = $d551340dd0bc6b22$var$parseDate(serial_number);
    if (serial_number instanceof Error) return serial_number;
    return serial_number.getFullYear();
}
function $d551340dd0bc6b22$var$isLeapYear(year) {
    return new Date(year, 1, 29).getMonth() === 1;
}
// TODO : Use DAYS ?
function $d551340dd0bc6b22$var$daysBetween(start_date, end_date) {
    return Math.ceil((end_date - start_date) / 1000 / 60 / 60 / 24);
}
/**
 * Returns the year fraction representing the number of whole days between start_date and end_date.
 *
 * Category: Date and time
 *
 * @param {*} start_date A date that represents the start date.
 * @param {*} end_date A date that represents the end date.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$469c0023d0dca9cc(start_date, end_date, basis) {
    start_date = $d551340dd0bc6b22$var$parseDate(start_date);
    if (start_date instanceof Error) return start_date;
    end_date = $d551340dd0bc6b22$var$parseDate(end_date);
    if (end_date instanceof Error) return end_date;
    basis = basis || 0;
    let sd = start_date.getDate();
    const sm = start_date.getMonth() + 1;
    const sy = start_date.getFullYear();
    let ed = end_date.getDate();
    const em = end_date.getMonth() + 1;
    const ey = end_date.getFullYear();
    switch(basis){
        case 0:
            // US (NASD) 30/360
            if (sd === 31 && ed === 31) {
                sd = 30;
                ed = 30;
            } else if (sd === 31) sd = 30;
            else if (sd === 30 && ed === 31) ed = 30;
            return (ed + em * 30 + ey * 360 - (sd + sm * 30 + sy * 360)) / 360;
        case 1:
            {
                // Actual/actual
                const feb29Between = (date1, date2)=>{
                    const year1 = date1.getFullYear();
                    const mar1year1 = new Date(year1, 2, 1);
                    if ($d551340dd0bc6b22$var$isLeapYear(year1) && date1 < mar1year1 && date2 >= mar1year1) return true;
                    const year2 = date2.getFullYear();
                    const mar1year2 = new Date(year2, 2, 1);
                    return $d551340dd0bc6b22$var$isLeapYear(year2) && date2 >= mar1year2 && date1 < mar1year2;
                };
                let ylength = 365;
                if (sy === ey || sy + 1 === ey && (sm > em || sm === em && sd >= ed)) {
                    if (sy === ey && $d551340dd0bc6b22$var$isLeapYear(sy) || feb29Between(start_date, end_date) || em === 1 && ed === 29) ylength = 366;
                    return $d551340dd0bc6b22$var$daysBetween(start_date, end_date) / ylength;
                }
                const years = ey - sy + 1;
                const days = (new Date(ey + 1, 0, 1) - new Date(sy, 0, 1)) / 1000 / 60 / 60 / 24;
                const average = days / years;
                return $d551340dd0bc6b22$var$daysBetween(start_date, end_date) / average;
            }
        case 2:
            // Actual/360
            return $d551340dd0bc6b22$var$daysBetween(start_date, end_date) / 360;
        case 3:
            // Actual/365
            return $d551340dd0bc6b22$var$daysBetween(start_date, end_date) / 365;
        case 4:
            // European 30/360
            return (ed + em * 30 + ey * 360 - (sd + sm * 30 + sy * 360)) / 360;
    }
}
function $d551340dd0bc6b22$var$serial(date) {
    const addOn = date > -2203891200000 ? 2 : 1;
    return Math.ceil((date - $d551340dd0bc6b22$var$d1900) / 86400000) + addOn;
}
// TODO
/**
 * -- Not implemented --
 *
 * Changes full-width (double-byte) English letters or katakana within a character string to half-width (single-byte) characters.
 *
 * Category: Text
 *
 * @param {*} text The text or a reference to a value that contains the text you want to change. If text does not contain any full-width letters, text is not changed.
 * @returns
 */ function $d551340dd0bc6b22$export$1dee026a19752d6b() {
    throw new Error("ASC is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Converts a number to text, using the ß (baht) currency format.
 *
 * Category: Text
 *
 * @param {*} number A number you want to convert to text, or a reference to a value containing a number, or a formula that evaluates to a number.
 * @returns
 */ function $d551340dd0bc6b22$export$e7679198a05bddc() {
    throw new Error("BAHTTEXT is not implemented");
}
/**
 * Returns the character specified by the code number.
 *
 * Category: Text
 *
 * @param {*} number A number between 1 and 255 specifying which character you want. The character is from the character set used by your computer. Note: Excel for the web supports only CHAR(9), CHAR(10), CHAR(13), and CHAR(32) and above.
 * @returns
 */ function $d551340dd0bc6b22$export$9e88d7b6f62f62d8(number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number === 0) return $d551340dd0bc6b22$var$value;
    if (number instanceof Error) return number;
    return String.fromCharCode(number);
}
/**
 * Removes all nonprintable characters from text.
 *
 * Category: Text
 *
 * @param {*} text Any worksheet information from which you want to remove nonprintable characters.
 * @returns
 */ function $d551340dd0bc6b22$export$1a70fabcf70df0f5(text) {
    if ($d551340dd0bc6b22$var$anyIsError(text)) return text;
    text = text || "";
    const re = /[\0-\x1F]/g;
    return text.replace(re, "");
}
/**
 * Returns a numeric code for the first character in a text string.
 *
 * Category: Text
 *
 * @param {*} text The text for which you want the code of the first character.
 * @returns
 */ function $d551340dd0bc6b22$export$ec5856072852bd7f(text) {
    if ($d551340dd0bc6b22$var$anyIsError(text)) return text;
    text = text || "";
    let result = text.charCodeAt(0);
    if (isNaN(result)) result = $d551340dd0bc6b22$var$value;
    return result;
}
/**
 * Joins several text items into one text item.
 *
 * Category: Text
 *
 * @returns
 */ function $d551340dd0bc6b22$export$2d2ef0054f30ceed() {
    const args = $d551340dd0bc6b22$var$flatten(arguments);
    const someError = $d551340dd0bc6b22$var$anyError.apply(undefined, args);
    if (someError) return someError;
    let trueFound = 0;
    while((trueFound = args.indexOf(true)) > -1)args[trueFound] = "TRUE";
    let falseFound = 0;
    while((falseFound = args.indexOf(false)) > -1)args[falseFound] = "FALSE";
    return args.join("");
}
const $d551340dd0bc6b22$export$fe5af3d848732bd3 = $d551340dd0bc6b22$export$2d2ef0054f30ceed;
// TODO
/**
 * -- Not implemented --
 *
 * Changes half-width (single-byte) English letters or katakana within a character string to full-width (double-byte) characters.
 *
 * Category: Text
 *
 * @param {*} text The text or a reference to a value that contains the text you want to change. If text does not contain any half-width English letters or katakana, text is not changed.
 * @returns
 */ function $d551340dd0bc6b22$export$1cb53a9941f23c6a() {
    throw new Error("DBCS is not implemented");
}
/**
 * Converts a number to text, using the $ (dollar) currency format.
 *
 * Category: Text
 *
 * @param {*} number A number, a reference to a value containing a number, or a formula that evaluates to a number.
 * @param {*} decimals Optional. The number of digits to the right of the decimal point. If this is negative, the number is rounded to the left of the decimal point. If you omit decimals, it is assumed to be 2.
 * @returns
 */ function $d551340dd0bc6b22$export$563e3b645087c0be(number, decimals = 2) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (isNaN(number)) return $d551340dd0bc6b22$var$value;
    number = $d551340dd0bc6b22$export$58785fc667c0c50b(number, decimals);
    const options = {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: decimals >= 0 ? decimals : 0,
        maximumFractionDigits: decimals >= 0 ? decimals : 0
    };
    const formattedNumber = number.toLocaleString("en-US", options);
    if (number < 0) return "$(" + formattedNumber.slice(2) + ")";
    return formattedNumber;
}
/**
 * Checks to see if two text values are identical.
 *
 * Category: Text
 *
 * @param {*} text1 The first text string.
 * @param {*} text2 The second text string.
 * @returns
 */ function $d551340dd0bc6b22$export$19f02e163da4b67e(text1, text2) {
    if (arguments.length !== 2) return $d551340dd0bc6b22$var$na;
    const someError = $d551340dd0bc6b22$var$anyError(text1, text2);
    if (someError) return someError;
    text1 = $d551340dd0bc6b22$var$parseString(text1);
    text2 = $d551340dd0bc6b22$var$parseString(text2);
    return text1 === text2;
}
/**
 * Locate one text string within a second text string, and return the number of the starting position of the first text string from the first character of the second text string.
 *
 * Category: Text
 *
 * @param {*} find_text The text you want to find.
 * @param {*} within_text The text containing the text you want to find.
 * @param {*} start_num Optional. Specifies the character at which to start the search. The first character in within_text is character number 1. If you omit start_num, it is assumed to be 1.
 * @returns
 */ function $d551340dd0bc6b22$export$9b025dd6d5ee90f5(find_text, within_text, start_num) {
    if (arguments.length < 2) return $d551340dd0bc6b22$var$na;
    find_text = $d551340dd0bc6b22$var$parseString(find_text);
    within_text = $d551340dd0bc6b22$var$parseString(within_text);
    start_num = start_num === undefined ? 0 : start_num;
    const found_index = within_text.indexOf(find_text, start_num - 1);
    if (found_index === -1) return $d551340dd0bc6b22$var$value;
    return found_index + 1;
}
/**
 * Formats a number as text with a fixed number of decimals.
 *
 * Category: Text
 *
 * @param {*} number The number you want to round and convert to text.
 * @param {*} decimals Optional. The number of digits to the right of the decimal point.
 * @param {*} no_commas Optional. A logical value that, if TRUE, prevents FIXED from including commas in the returned text.
 * @returns
 */ function $d551340dd0bc6b22$export$91f67f1eeaea8c1e(number, decimals = 2, no_commas = false) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (isNaN(number)) return $d551340dd0bc6b22$var$value;
    decimals = $d551340dd0bc6b22$var$parseNumber(decimals);
    if (isNaN(decimals)) return $d551340dd0bc6b22$var$value;
    if (decimals < 0) {
        const factor = Math.pow(10, -decimals);
        number = Math.round(number / factor) * factor;
    } else number = number.toFixed(decimals);
    if (no_commas) number = number.toString().replace(/,/g, "");
    else {
        const parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+$)/g, ",");
        number = parts.join(".");
    }
    return number;
}
/**
 * Returns the leftmost characters from a text value.
 *
 * Category: Text
 *
 * @param {*} text The text string that contains the characters you want to extract.
 * @param {*} num_chars Optional. Specifies the number of characters you want LEFT to extract.
 * @returns
 */ function $d551340dd0bc6b22$export$f981f70d61d1405a(text, num_chars) {
    const someError = $d551340dd0bc6b22$var$anyError(text, num_chars);
    if (someError) return someError;
    text = $d551340dd0bc6b22$var$parseString(text);
    num_chars = num_chars === undefined ? 1 : num_chars;
    num_chars = $d551340dd0bc6b22$var$parseNumber(num_chars);
    if (num_chars instanceof Error || typeof text !== "string") return $d551340dd0bc6b22$var$value;
    return text.substring(0, num_chars);
}
/**
 * Returns the number of characters in a text string
 *
 * Category: Text
 *
 * @param {*} text The text whose length you want to find. Spaces count as characters.
 * @returns
 */ function $d551340dd0bc6b22$export$bae2ad8fd7fda845(text) {
    if (arguments.length === 0) return $d551340dd0bc6b22$var$error;
    if (text instanceof Error) return text;
    if (Array.isArray(text)) return $d551340dd0bc6b22$var$value;
    const textAsString = $d551340dd0bc6b22$var$parseString(text);
    return textAsString.length;
}
/**
 * Converts text to lowercase.
 *
 * Category: Text
 *
 * @param {*} text The text you want to convert to lowercase. LOWER does not change characters in text that are not letters.
 * @returns
 */ function $d551340dd0bc6b22$export$d4cd28f22384990c(text) {
    if (arguments.length !== 1) return $d551340dd0bc6b22$var$value;
    text = $d551340dd0bc6b22$var$parseString(text);
    if ($d551340dd0bc6b22$var$anyIsError(text)) return text;
    return text.toLowerCase();
}
/**
 * Returns a specific number of characters from a text string starting at the position you specify
 *
 * Category: Text
 *
 * @param {*} text The text string containing the characters you want to extract.
 * @param {*} start_num The position of the first character you want to extract in text. The first character in text has start_num 1, and so on.
 * @param {*} num_chars Specifies the number of characters you want MID to return from text.
 * @returns
 */ function $d551340dd0bc6b22$export$4f043a3416231551(text, start_num, num_chars) {
    if (start_num === undefined || start_num === null) return $d551340dd0bc6b22$var$value;
    start_num = $d551340dd0bc6b22$var$parseNumber(start_num);
    num_chars = $d551340dd0bc6b22$var$parseNumber(num_chars);
    if ($d551340dd0bc6b22$var$anyIsError(start_num, num_chars) || typeof text !== "string") return num_chars;
    const begin = start_num - 1;
    const end = begin + num_chars;
    return text.substring(begin, end);
}
// TODO
/**
 * Converts text to number in a locale-independent manner.
 *
 * Category: Text
 *
 * @param {*} text The text to convert to a number.
 * @param {*} decimal_separator Optional. The character used to separate the integer and fractional part of the result.
 * @param {*} group_separator Optional. The character used to separate groupings of numbers, such as thousands from hundreds and millions from thousands.
 * @returns
 */ function $d551340dd0bc6b22$export$9c0adca74e57bd47(text, decimal_separator, group_separator) {
    text = $d551340dd0bc6b22$var$isDefined(text) ? text : "";
    if (typeof text === "number") return text;
    if (typeof text !== "string") return $d551340dd0bc6b22$var$na;
    decimal_separator = typeof decimal_separator === "undefined" ? "." : decimal_separator;
    group_separator = typeof group_separator === "undefined" ? "," : group_separator;
    return Number(text.replace(decimal_separator, ".").replace(group_separator, ""));
}
// TODO
/**
 * -- Not implemented --
 */ function $d551340dd0bc6b22$export$49f3cee18396bf51() {
    throw new Error("PRONETIC is not implemented");
}
/**
 * Capitalizes the first letter in each word of a text value.
 *
 * Category: Text
 *
 * @param {*} text Text enclosed in quotation marks, a formula that returns text, or a reference to a value containing the text you want to partially capitalize.
 * @returns
 */ function $d551340dd0bc6b22$export$5bdbd7463cc56933(text) {
    if ($d551340dd0bc6b22$var$anyIsError(text)) return text;
    if (isNaN(text) && typeof text === "number") return $d551340dd0bc6b22$var$value;
    text = $d551340dd0bc6b22$var$parseString(text);
    return text.replace(/\w\S*/g, (txt)=>txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}
/**
 * Replaces characters within text
 *
 * Category: Text
 *
 * @param {*} old_text Text in which you want to replace some characters.
 * @param {*} num_chars The number of characters in old_text that you want REPLACE to replace with new_text.
 * @param {*} length he number of characters in old_text that you want REPLACEB to replace with new_text.
 * @param {*} new_text he text that will replace characters in old_text.
 * @returns
 */ function $d551340dd0bc6b22$export$412b24539e92ced(old_text, num_chars, length, new_text) {
    num_chars = $d551340dd0bc6b22$var$parseNumber(num_chars);
    length = $d551340dd0bc6b22$var$parseNumber(length);
    if ($d551340dd0bc6b22$var$anyIsError(num_chars, length) || typeof old_text !== "string" || typeof new_text !== "string") return $d551340dd0bc6b22$var$value;
    return old_text.substr(0, num_chars - 1) + new_text + old_text.substr(num_chars - 1 + length);
}
/**
 * Repeats text a given number of times.
 *
 * Category: Text
 *
 * @param {*} text The text you want to repeat.
 * @param {*} number_times A positive number specifying the number of times to repeat text.
 * @returns
 */ function $d551340dd0bc6b22$export$7f0fdfd63ecad857(text, number_times) {
    const someError = $d551340dd0bc6b22$var$anyError(text, number_times);
    if (someError) return someError;
    text = $d551340dd0bc6b22$var$parseString(text);
    number_times = $d551340dd0bc6b22$var$parseNumber(number_times);
    if (number_times instanceof Error) return number_times;
    return new Array(number_times + 1).join(text);
}
/**
 * Returns the rightmost characters from a text value
 *
 * Category: Text
 *
 * @param {*} text The text string containing the characters you want to extract.
 * @param {*} num_chars Optional. Specifies the number of characters you want RIGHT to extract.
 * @returns
 */ function $d551340dd0bc6b22$export$1cac5500365a4eb4(text, num_chars) {
    const someError = $d551340dd0bc6b22$var$anyError(text, num_chars);
    if (someError) return someError;
    text = $d551340dd0bc6b22$var$parseString(text);
    num_chars = num_chars === undefined ? 1 : num_chars;
    num_chars = $d551340dd0bc6b22$var$parseNumber(num_chars);
    if (num_chars instanceof Error) return num_chars;
    return text.substring(text.length - num_chars);
}
/**
 * Finds one text value within another (not case-sensitive)
 *
 * Category: Text
 *
 * @param {*} find_text The text that you want to find.
 * @param {*} within_text The text in which you want to search for the value of the find_text argument.
 * @param {*} start_num Optional. The character number in the within_text argument at which you want to start searching.
 * @returns
 */ function $d551340dd0bc6b22$export$a6b9aaee40d49fd0(find_text, within_text, start_num) {
    let foundAt;
    if (typeof find_text !== "string" || typeof within_text !== "string") return $d551340dd0bc6b22$var$value;
    start_num = start_num === undefined ? 0 : start_num;
    foundAt = within_text.toLowerCase().indexOf(find_text.toLowerCase(), start_num - 1) + 1;
    return foundAt === 0 ? $d551340dd0bc6b22$var$value : foundAt;
}
/**
 * Substitutes new text for old text in a text string.
 *
 * Category: Text
 *
 * @param {*} text The text or the reference to a value containing text for which you want to substitute characters.
 * @param {*} old_text The text you want to replace.
 * @param {*} new_text The text you want to replace old_text with.
 * @param {*} instance_num Optional. Specifies which occurrence of old_text you want to replace with new_text. If you specify instance_num, only that instance of old_text is replaced. Otherwise, every occurrence of old_text in text is changed to new_text.
 * @returns
 */ function $d551340dd0bc6b22$export$1b6a91b61efa0da2(text, old_text, new_text, instance_num) {
    if (arguments.length < 3) return $d551340dd0bc6b22$var$na;
    if (!text || !old_text) return text;
    else if (instance_num === undefined) return text.split(old_text).join(new_text);
    else {
        instance_num = Math.floor(Number(instance_num));
        if (Number.isNaN(instance_num) || instance_num <= 0) return $d551340dd0bc6b22$var$value;
        let index = 0;
        let i = 0;
        while(index > -1 && text.indexOf(old_text, index) > -1){
            index = text.indexOf(old_text, index + 1);
            i++;
            if (index > -1 && i === instance_num) return text.substring(0, index) + new_text + text.substring(index + old_text.length);
        }
        return text;
    }
}
/**
 * Converts its arguments to text.
 *
 * Category: Text
 *
 * @param {*} value The value you want to test.
 * @returns
 */ function $d551340dd0bc6b22$export$971d5caa766a69d7(value) {
    if (value instanceof Error) return value;
    return typeof value === "string" ? value : "";
}
/**
 * Formats a number and converts it to text.
 *
 * Category: Text
 *
 * @param {*} value A numeric value that you want to be converted into text.
 * @param {*} format_text A text string that defines the formatting that you want to be applied to the supplied value.
 * @returns
 */ function $d551340dd0bc6b22$export$d597759d33be802e(value$1, format_text) {
    if (value$1 === undefined || value$1 instanceof Error || format_text instanceof Error) return $d551340dd0bc6b22$var$na;
    if (format_text === undefined || format_text === null) return "";
    if (typeof format_text === "number") return String(format_text);
    if (typeof format_text !== "string") return $d551340dd0bc6b22$var$value;
    const currencySymbol = format_text.startsWith("$") ? "$" : "";
    const isPercent = format_text.endsWith("%");
    format_text = format_text.replace(/%/g, "").replace(/\$/g, "");
    // count all 0s after the decimal point
    const decimalPlaces = format_text.split(".")[1].match(/0/g).length;
    const noCommas = !format_text.includes(",");
    if (isPercent) value$1 = value$1 * 100;
    value$1 = $d551340dd0bc6b22$export$91f67f1eeaea8c1e(value$1, decimalPlaces, noCommas);
    if (value$1.startsWith("-")) {
        value$1 = value$1.replace("-", "");
        value$1 = "-" + currencySymbol + value$1;
    } else value$1 = currencySymbol + value$1;
    if (isPercent) value$1 = value$1 + "%";
    return value$1;
}
/**
 * Combines the text from multiple ranges and/or strings.
 *
 * Category: Text
 * @param {*} delimiter A text string, either empty, or one or more characters enclosed by double quotes, or a reference to a valid text string. If a number is supplied, it will be treated as text.
 * @param {*} ignore_empty If TRUE, ignores empty values.
 * @param {*} args Text item to be joined. A text string, or array of strings, such as a range of values.
 * @returns
 */ function $d551340dd0bc6b22$export$cfce14253d26f795(delimiter, ignore_empty, ...args) {
    if (typeof ignore_empty !== "boolean") ignore_empty = $d551340dd0bc6b22$var$parseBool(ignore_empty);
    if (arguments.length < 3) return $d551340dd0bc6b22$var$na;
    delimiter = delimiter !== null && delimiter !== undefined ? delimiter : "";
    let flatArgs = $d551340dd0bc6b22$var$flatten(args);
    let textToJoin = ignore_empty ? flatArgs.filter((text)=>text) : flatArgs;
    if (Array.isArray(delimiter)) {
        delimiter = $d551340dd0bc6b22$var$flatten(delimiter);
        let chunks = textToJoin.map((item)=>[
                item
            ]);
        let index = 0;
        for(let i = 0; i < chunks.length - 1; i++){
            chunks[i].push(delimiter[index]);
            index++;
            if (index === delimiter.length) index = 0;
        }
        textToJoin = $d551340dd0bc6b22$var$flatten(chunks);
        return textToJoin.join("");
    }
    return textToJoin.join(delimiter);
}
/**
 * Removes spaces from text.
 *
 * Category: Text
 *
 * @param {*} text The text from which you want spaces removed.
 * @returns
 */ function $d551340dd0bc6b22$export$577d861f98808551(text) {
    text = $d551340dd0bc6b22$var$parseString(text);
    if (text instanceof Error) return text;
    return text.replace(/\s+/g, " ").trim();
}
const $d551340dd0bc6b22$export$e8c7bfe2ce3f8def = $d551340dd0bc6b22$export$9e88d7b6f62f62d8;
const $d551340dd0bc6b22$export$d81a7ed8ee682bb4 = $d551340dd0bc6b22$export$ec5856072852bd7f;
/**
 * Converts text to uppercase.
 *
 * Category: Text
 *
 * @param {*} text The text you want converted to uppercase. Text can be a reference or text string.
 * @returns
 */ function $d551340dd0bc6b22$export$ad7946da0f0f129b(text) {
    text = $d551340dd0bc6b22$var$parseString(text);
    if (text instanceof Error) return text;
    return text.toUpperCase();
}
/**
 * Converts a text argument to a number.
 *
 * Category: Text
 *
 * @param {*} text The text enclosed in quotation marks or a reference to a value containing the text you want to convert.
 * @returns
 */ function $d551340dd0bc6b22$export$764bd63f4c2043a2(text) {
    const anyError$1 = $d551340dd0bc6b22$var$anyError(text);
    if (anyError$1) return anyError$1;
    if (typeof text === "number") return text;
    if (!$d551340dd0bc6b22$var$isDefined(text)) text = "";
    if (typeof text !== "string") return $d551340dd0bc6b22$var$value;
    const isPercent = /(%)$/.test(text) || /^(%)/.test(text);
    text = text.replace(/^[^0-9-]{0,3}/, "");
    text = text.replace(/[^0-9]{0,3}$/, "");
    text = text.replace(/[ ,]/g, "");
    if (text === "") return 0;
    let output = Number(text);
    if (isNaN(output)) return $d551340dd0bc6b22$var$value;
    output = output || 0;
    if (isPercent) output = output * 0.01;
    return output;
}
function $d551340dd0bc6b22$var$isValidBinaryNumber(number) {
    return /^[01]{1,10}$/.test(number);
}
/**
 * Returns the modified Bessel function In(x).
 *
 * Category: Engineering
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} n The order of the Bessel function. If n is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$32c238d501396c40(x, n) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    n = $d551340dd0bc6b22$var$parseNumber(n);
    if ($d551340dd0bc6b22$var$anyIsError(x, n)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($72976088a75d37a8$exports))).besseli(x, n);
}
/**
 * Returns the Bessel function Jn(x).
 *
 * Category: Engineering
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} n The order of the Bessel function. If n is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$f9aa6cf5fbe104e(x, n) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    n = $d551340dd0bc6b22$var$parseNumber(n);
    if ($d551340dd0bc6b22$var$anyIsError(x, n)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($72976088a75d37a8$exports))).besselj(x, n);
}
/**
 * Returns the modified Bessel function Kn(x).
 *
 * Category: Engineering
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} n The order of the function. If n is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$d97c5c2b0f3bb088(x, n) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    n = $d551340dd0bc6b22$var$parseNumber(n);
    if ($d551340dd0bc6b22$var$anyIsError(x, n)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($72976088a75d37a8$exports))).besselk(x, n);
}
/**
 * Returns the Bessel function Yn(x).
 *
 * Category: Engineering
 *
 * @param {*} x The value at which to evaluate the function.
 * @param {*} n The order of the function. If n is not an integer, it is truncated.
 * @returns
 */ function $d551340dd0bc6b22$export$f612c0749d033368(x, n) {
    x = $d551340dd0bc6b22$var$parseNumber(x);
    n = $d551340dd0bc6b22$var$parseNumber(n);
    if ($d551340dd0bc6b22$var$anyIsError(x, n)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($72976088a75d37a8$exports))).bessely(x, n);
}
/**
 * Converts a binary number to decimal.
 *
 * Category: Engineering
 *
 * @param {*} number The binary number you want to convert. Number cannot contain more than 10 characters (10 bits). The most significant bit of number is the sign bit. The remaining 9 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @returns
 */ function $d551340dd0bc6b22$export$4fd785b90b90f38f(number) {
    // Return error if number is not binary or contains more than 10 characters (10 digits)
    if (!$d551340dd0bc6b22$var$isValidBinaryNumber(number)) return $d551340dd0bc6b22$var$num;
    // Convert binary number to decimal
    const result = parseInt(number, 2);
    // Handle negative numbers
    const stringified = number.toString();
    if (stringified.length === 10 && stringified.substring(0, 1) === "1") return parseInt(stringified.substring(1), 2) - 512;
    else return result;
}
/**
 * Converts a binary number to hexadecimal.
 *
 * Category: Engineering
 *
 * @param {*} number The binary number you want to convert. Number cannot contain more than 10 characters (10 bits). The most significant bit of number is the sign bit. The remaining 9 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, BIN2HEX uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$d23b80a3eff10ba2(number, places) {
    // Return error if number is not binary or contains more than 10 characters (10 digits)
    if (!$d551340dd0bc6b22$var$isValidBinaryNumber(number)) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character hexadecimal number if number is negative
    const stringified = number.toString();
    if (stringified.length === 10 && stringified.substring(0, 1) === "1") return (1099511627264 + parseInt(stringified.substring(1), 2)).toString(16);
    // Convert binary number to hexadecimal
    const result = parseInt(number, 2).toString(16);
    // Return hexadecimal number using the minimum number of characters necessary if places is undefined
    if (places === undefined) return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Converts a binary number to octal.
 *
 * Category: Engineering
 *
 * @param {*} number The binary number you want to convert. Number cannot contain more than 10 characters (10 bits). The most significant bit of number is the sign bit. The remaining 9 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, BIN2OCT uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$a47924ed132a6df6(number, places) {
    // Return error if number is not binary or contains more than 10 characters (10 digits)
    if (!$d551340dd0bc6b22$var$isValidBinaryNumber(number)) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character octal number if number is negative
    const stringified = number.toString();
    if (stringified.length === 10 && stringified.substring(0, 1) === "1") return (1073741312 + parseInt(stringified.substring(1), 2)).toString(8);
    // Convert binary number to octal
    const result = parseInt(number, 2).toString(8);
    // Return octal number using the minimum number of characters necessary if places is undefined
    if (places === undefined) return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Returns a 'Bitwise And' of two numbers.
 *
 * Category: Engineering
 *
 * @param {*} number1 Must be in decimal form and greater than or equal to 0.
 * @param {*} number2 Must be in decimal form and greater than or equal to 0.
 * @returns
 */ function $d551340dd0bc6b22$export$38b1d3aa5bd1a856(number1, number2) {
    // Return error if either number is a non-numeric value
    number1 = $d551340dd0bc6b22$var$parseNumber(number1);
    number2 = $d551340dd0bc6b22$var$parseNumber(number2);
    if ($d551340dd0bc6b22$var$anyIsError(number1, number2)) return $d551340dd0bc6b22$var$value;
    // Return error if either number is less than 0
    if (number1 < 0 || number2 < 0) return $d551340dd0bc6b22$var$num;
    // Return error if either number is a non-integer
    if (Math.floor(number1) !== number1 || Math.floor(number2) !== number2) return $d551340dd0bc6b22$var$num;
    // Return error if either number is greater than (2^48)-1
    if (number1 > 281474976710655 || number2 > 281474976710655) return $d551340dd0bc6b22$var$num;
    // Return bitwise AND of two numbers
    return number1 & number2;
}
/**
 * Returns a value number shifted left by shift_amount bits.
 *
 * Category: Engineering
 *
 * @param {*} number Number must be an integer greater than or equal to 0.
 * @param {*} shift_amount Shift_amount must be an integer.
 * @returns
 */ function $d551340dd0bc6b22$export$b72eadc462d1b657(number, shift_amount) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    shift_amount = $d551340dd0bc6b22$var$parseNumber(shift_amount);
    if ($d551340dd0bc6b22$var$anyIsError(number, shift_amount)) return $d551340dd0bc6b22$var$value;
    // Return error if number is less than 0
    if (number < 0) return $d551340dd0bc6b22$var$num;
    // Return error if number is a non-integer
    if (Math.floor(number) !== number) return $d551340dd0bc6b22$var$num;
    // Return error if number is greater than (2^48)-1
    if (number > 281474976710655) return $d551340dd0bc6b22$var$num;
    // Return error if the absolute value of shift is greater than 53
    if (Math.abs(shift_amount) > 53) return $d551340dd0bc6b22$var$num;
    // Return number shifted by shift bits to the left or to the right if shift is negative
    return shift_amount >= 0 ? number << shift_amount : number >> -shift_amount;
}
/**
 * Returns a bitwise OR of 2 numbers.
 *
 * Category: Engineering
 *
 * @param {*} number1 Must be in decimal form and greater than or equal to 0.
 * @param {*} number2 Must be in decimal form and greater than or equal to 0.
 * @returns
 */ function $d551340dd0bc6b22$export$2426f753a06b3eb6(number1, number2) {
    number1 = $d551340dd0bc6b22$var$parseNumber(number1);
    number2 = $d551340dd0bc6b22$var$parseNumber(number2);
    if ($d551340dd0bc6b22$var$anyIsError(number1, number2)) return $d551340dd0bc6b22$var$value;
    // Return error if either number is less than 0
    if (number1 < 0 || number2 < 0) return $d551340dd0bc6b22$var$num;
    // Return error if either number is a non-integer
    if (Math.floor(number1) !== number1 || Math.floor(number2) !== number2) return $d551340dd0bc6b22$var$num;
    // Return error if either number is greater than (2^48)-1
    if (number1 > 281474976710655 || number2 > 281474976710655) return $d551340dd0bc6b22$var$num;
    // Return bitwise OR of two numbers
    return number1 | number2;
}
/**
 * Returns a value number shifted right by shift_amount bits.
 *
 * Category: Engineering
 *
 * @param {*} number Must be an integer greater than or equal to 0.
 * @param {*} shift_amount Must be an integer.
 * @returns
 */ function $d551340dd0bc6b22$export$277323301bcccbfe(number, shift_amount) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    shift_amount = $d551340dd0bc6b22$var$parseNumber(shift_amount);
    if ($d551340dd0bc6b22$var$anyIsError(number, shift_amount)) return $d551340dd0bc6b22$var$value;
    // Return error if number is less than 0
    if (number < 0) return $d551340dd0bc6b22$var$num;
    // Return error if number is a non-integer
    if (Math.floor(number) !== number) return $d551340dd0bc6b22$var$num;
    // Return error if number is greater than (2^48)-1
    if (number > 281474976710655) return $d551340dd0bc6b22$var$num;
    // Return error if the absolute value of shift is greater than 53
    if (Math.abs(shift_amount) > 53) return $d551340dd0bc6b22$var$num;
    // Return number shifted by shift bits to the right or to the left if shift is negative
    return shift_amount >= 0 ? number >> shift_amount : number << -shift_amount;
}
/**
 * Returns a bitwise 'Exclusive Or' of two numbers.
 *
 * Category: Engineering
 *
 * @param {*} number1 Must be greater than or equal to 0.
 * @param {*} number2 Must be greater than or equal to 0.
 * @returns
 */ function $d551340dd0bc6b22$export$eb46b678d25dff75(number1, number2) {
    number1 = $d551340dd0bc6b22$var$parseNumber(number1);
    number2 = $d551340dd0bc6b22$var$parseNumber(number2);
    if ($d551340dd0bc6b22$var$anyIsError(number1, number2)) return $d551340dd0bc6b22$var$value;
    // Return error if either number is less than 0
    if (number1 < 0 || number2 < 0) return $d551340dd0bc6b22$var$num;
    // Return error if either number is a non-integer
    if (Math.floor(number1) !== number1 || Math.floor(number2) !== number2) return $d551340dd0bc6b22$var$num;
    // Return error if either number is greater than (2^48)-1
    if (number1 > 281474976710655 || number2 > 281474976710655) return $d551340dd0bc6b22$var$num;
    // Return bitwise XOR of two numbers
    return number1 ^ number2;
}
/**
 * Converts real and imaginary coefficients into a complex number.
 *
 * Category: Engineering
 *
 * @param {*} real_num The real coefficient of the complex number.
 * @param {*} i_num The imaginary coefficient of the complex number.
 * @param {*} suffix Optional. The suffix for the imaginary component of the complex number. If omitted, suffix is assumed to be "i".
 * @returns
 */ function $d551340dd0bc6b22$export$82ec7cdb62c32775(real_num, i_num, suffix) {
    real_num = $d551340dd0bc6b22$var$parseNumber(real_num);
    i_num = $d551340dd0bc6b22$var$parseNumber(i_num);
    if ($d551340dd0bc6b22$var$anyIsError(real_num, i_num)) return real_num;
    // Set suffix
    suffix = suffix === undefined ? "i" : suffix;
    // Return error if suffix is neither "i" nor "j"
    if (suffix !== "i" && suffix !== "j") return $d551340dd0bc6b22$var$value;
    // Return complex number
    if (real_num === 0 && i_num === 0) return 0;
    else if (real_num === 0) return i_num === 1 ? suffix : i_num.toString() + suffix;
    else if (i_num === 0) return real_num.toString();
    else {
        const sign = i_num > 0 ? "+" : "";
        return real_num.toString() + sign + (i_num === 1 ? suffix : i_num.toString() + suffix);
    }
}
/**
 * Converts a number from one measurement system to another.
 *
 * Category: Engineering
 *
 * @param {*} number is the value in from_units to convert.
 * @param {*} from_unit is the units for number.
 * @param {*} to_unit is the units for the result. CONVERT accepts the following text values (in quotation marks) for from_unit and to_unit.
 * @returns
 */ function $d551340dd0bc6b22$export$10aee17dc6459cc7(number, from_unit, to_unit) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    // List of units supported by CONVERT and units defined by the International System of Units
    // [Name, Symbol, Alternate symbols, Quantity, ISU, CONVERT, Conversion ratio]
    const units = [
        [
            "a.u. of action",
            "?",
            null,
            "action",
            false,
            false,
            1.05457168181818e-34
        ],
        [
            "a.u. of charge",
            "e",
            null,
            "electric_charge",
            false,
            false,
            1.60217653141414e-19
        ],
        [
            "a.u. of energy",
            "Eh",
            null,
            "energy",
            false,
            false,
            4.35974417757576e-18
        ],
        [
            "a.u. of length",
            "a?",
            null,
            "length",
            false,
            false,
            5.29177210818182e-11
        ],
        [
            "a.u. of mass",
            "m?",
            null,
            "mass",
            false,
            false,
            9.10938261616162e-31
        ],
        [
            "a.u. of time",
            "?/Eh",
            null,
            "time",
            false,
            false,
            2.41888432650516e-17
        ],
        [
            "admiralty knot",
            "admkn",
            null,
            "speed",
            false,
            true,
            0.514773333
        ],
        [
            "ampere",
            "A",
            null,
            "electric_current",
            true,
            false,
            1
        ],
        [
            "ampere per meter",
            "A/m",
            null,
            "magnetic_field_intensity",
            true,
            false,
            1
        ],
        [
            "\xe5ngstr\xf6m",
            "\xc5",
            [
                "ang"
            ],
            "length",
            false,
            true,
            1e-10
        ],
        [
            "are",
            "ar",
            null,
            "area",
            false,
            true,
            100
        ],
        [
            "astronomical unit",
            "ua",
            null,
            "length",
            false,
            false,
            1.49597870691667e-11
        ],
        [
            "bar",
            "bar",
            null,
            "pressure",
            false,
            false,
            100000
        ],
        [
            "barn",
            "b",
            null,
            "area",
            false,
            false,
            1e-28
        ],
        [
            "becquerel",
            "Bq",
            null,
            "radioactivity",
            true,
            false,
            1
        ],
        [
            "bit",
            "bit",
            [
                "b"
            ],
            "information",
            false,
            true,
            1
        ],
        [
            "btu",
            "BTU",
            [
                "btu"
            ],
            "energy",
            false,
            true,
            1055.05585262
        ],
        [
            "byte",
            "byte",
            null,
            "information",
            false,
            true,
            8
        ],
        [
            "candela",
            "cd",
            null,
            "luminous_intensity",
            true,
            false,
            1
        ],
        [
            "candela per square metre",
            "cd/m?",
            null,
            "luminance",
            true,
            false,
            1
        ],
        [
            "coulomb",
            "C",
            null,
            "electric_charge",
            true,
            false,
            1
        ],
        [
            "cubic \xe5ngstr\xf6m",
            "ang3",
            [
                "ang^3"
            ],
            "volume",
            false,
            true,
            1e-30
        ],
        [
            "cubic foot",
            "ft3",
            [
                "ft^3"
            ],
            "volume",
            false,
            true,
            0.028316846592
        ],
        [
            "cubic inch",
            "in3",
            [
                "in^3"
            ],
            "volume",
            false,
            true,
            0.000016387064
        ],
        [
            "cubic light-year",
            "ly3",
            [
                "ly^3"
            ],
            "volume",
            false,
            true,
            8.46786664623715e-47
        ],
        [
            "cubic metre",
            "m?",
            null,
            "volume",
            true,
            true,
            1
        ],
        [
            "cubic mile",
            "mi3",
            [
                "mi^3"
            ],
            "volume",
            false,
            true,
            4168181825.44058
        ],
        [
            "cubic nautical mile",
            "Nmi3",
            [
                "Nmi^3"
            ],
            "volume",
            false,
            true,
            6352182208
        ],
        [
            "cubic Pica",
            "Pica3",
            [
                "Picapt3",
                "Pica^3",
                "Picapt^3"
            ],
            "volume",
            false,
            true,
            7.58660370370369e-8
        ],
        [
            "cubic yard",
            "yd3",
            [
                "yd^3"
            ],
            "volume",
            false,
            true,
            0.764554857984
        ],
        [
            "cup",
            "cup",
            null,
            "volume",
            false,
            true,
            0.0002365882365
        ],
        [
            "dalton",
            "Da",
            [
                "u"
            ],
            "mass",
            false,
            false,
            1.66053886282828e-27
        ],
        [
            "day",
            "d",
            [
                "day"
            ],
            "time",
            false,
            true,
            86400
        ],
        [
            "degree",
            "\xb0",
            null,
            "angle",
            false,
            false,
            0.0174532925199433
        ],
        [
            "degrees Rankine",
            "Rank",
            null,
            "temperature",
            false,
            true,
            0.555555555555556
        ],
        [
            "dyne",
            "dyn",
            [
                "dy"
            ],
            "force",
            false,
            true,
            0.00001
        ],
        [
            "electronvolt",
            "eV",
            [
                "ev"
            ],
            "energy",
            false,
            true,
            1.60217656514141
        ],
        [
            "ell",
            "ell",
            null,
            "length",
            false,
            true,
            1.143
        ],
        [
            "erg",
            "erg",
            [
                "e"
            ],
            "energy",
            false,
            true,
            1e-7
        ],
        [
            "farad",
            "F",
            null,
            "electric_capacitance",
            true,
            false,
            1
        ],
        [
            "fluid ounce",
            "oz",
            null,
            "volume",
            false,
            true,
            0.0000295735295625
        ],
        [
            "foot",
            "ft",
            null,
            "length",
            false,
            true,
            0.3048
        ],
        [
            "foot-pound",
            "flb",
            null,
            "energy",
            false,
            true,
            1.3558179483314
        ],
        [
            "gal",
            "Gal",
            null,
            "acceleration",
            false,
            false,
            0.01
        ],
        [
            "gallon",
            "gal",
            null,
            "volume",
            false,
            true,
            0.003785411784
        ],
        [
            "gauss",
            "G",
            [
                "ga"
            ],
            "magnetic_flux_density",
            false,
            true,
            1
        ],
        [
            "grain",
            "grain",
            null,
            "mass",
            false,
            true,
            0.0000647989
        ],
        [
            "gram",
            "g",
            null,
            "mass",
            false,
            true,
            0.001
        ],
        [
            "gray",
            "Gy",
            null,
            "absorbed_dose",
            true,
            false,
            1
        ],
        [
            "gross registered ton",
            "GRT",
            [
                "regton"
            ],
            "volume",
            false,
            true,
            2.8316846592
        ],
        [
            "hectare",
            "ha",
            null,
            "area",
            false,
            true,
            10000
        ],
        [
            "henry",
            "H",
            null,
            "inductance",
            true,
            false,
            1
        ],
        [
            "hertz",
            "Hz",
            null,
            "frequency",
            true,
            false,
            1
        ],
        [
            "horsepower",
            "HP",
            [
                "h"
            ],
            "power",
            false,
            true,
            745.69987158227
        ],
        [
            "horsepower-hour",
            "HPh",
            [
                "hh",
                "hph"
            ],
            "energy",
            false,
            true,
            2684519.538
        ],
        [
            "hour",
            "h",
            [
                "hr"
            ],
            "time",
            false,
            true,
            3600
        ],
        [
            "imperial gallon (U.K.)",
            "uk_gal",
            null,
            "volume",
            false,
            true,
            0.00454609
        ],
        [
            "imperial hundredweight",
            "lcwt",
            [
                "uk_cwt",
                "hweight"
            ],
            "mass",
            false,
            true,
            50.802345
        ],
        [
            "imperial quart (U.K)",
            "uk_qt",
            null,
            "volume",
            false,
            true,
            0.0011365225
        ],
        [
            "imperial ton",
            "brton",
            [
                "uk_ton",
                "LTON"
            ],
            "mass",
            false,
            true,
            1016.046909
        ],
        [
            "inch",
            "in",
            null,
            "length",
            false,
            true,
            0.0254
        ],
        [
            "international acre",
            "uk_acre",
            null,
            "area",
            false,
            true,
            4046.8564224
        ],
        [
            "IT calorie",
            "cal",
            null,
            "energy",
            false,
            true,
            4.1868
        ],
        [
            "joule",
            "J",
            null,
            "energy",
            true,
            true,
            1
        ],
        [
            "katal",
            "kat",
            null,
            "catalytic_activity",
            true,
            false,
            1
        ],
        [
            "kelvin",
            "K",
            [
                "kel"
            ],
            "temperature",
            true,
            true,
            1
        ],
        [
            "kilogram",
            "kg",
            null,
            "mass",
            true,
            true,
            1
        ],
        [
            "knot",
            "kn",
            null,
            "speed",
            false,
            true,
            0.514444444444444
        ],
        [
            "light-year",
            "ly",
            null,
            "length",
            false,
            true,
            9460730472580800
        ],
        [
            "litre",
            "L",
            [
                "l",
                "lt"
            ],
            "volume",
            false,
            true,
            0.001
        ],
        [
            "lumen",
            "lm",
            null,
            "luminous_flux",
            true,
            false,
            1
        ],
        [
            "lux",
            "lx",
            null,
            "illuminance",
            true,
            false,
            1
        ],
        [
            "maxwell",
            "Mx",
            null,
            "magnetic_flux",
            false,
            false,
            1e-18
        ],
        [
            "measurement ton",
            "MTON",
            null,
            "volume",
            false,
            true,
            1.13267386368
        ],
        [
            "meter per hour",
            "m/h",
            [
                "m/hr"
            ],
            "speed",
            false,
            true,
            0.00027777777777778
        ],
        [
            "meter per second",
            "m/s",
            [
                "m/sec"
            ],
            "speed",
            true,
            true,
            1
        ],
        [
            "meter per second squared",
            "m?s??",
            null,
            "acceleration",
            true,
            false,
            1
        ],
        [
            "parsec",
            "pc",
            [
                "parsec"
            ],
            "length",
            false,
            true,
            30856775814671900
        ],
        [
            "meter squared per second",
            "m?/s",
            null,
            "kinematic_viscosity",
            true,
            false,
            1
        ],
        [
            "metre",
            "m",
            null,
            "length",
            true,
            true,
            1
        ],
        [
            "miles per hour",
            "mph",
            null,
            "speed",
            false,
            true,
            0.44704
        ],
        [
            "millimetre of mercury",
            "mmHg",
            null,
            "pressure",
            false,
            false,
            133.322
        ],
        [
            "minute",
            "?",
            null,
            "angle",
            false,
            false,
            0.000290888208665722
        ],
        [
            "minute",
            "min",
            [
                "mn"
            ],
            "time",
            false,
            true,
            60
        ],
        [
            "modern teaspoon",
            "tspm",
            null,
            "volume",
            false,
            true,
            0.000005
        ],
        [
            "mole",
            "mol",
            null,
            "amount_of_substance",
            true,
            false,
            1
        ],
        [
            "morgen",
            "Morgen",
            null,
            "area",
            false,
            true,
            2500
        ],
        [
            "n.u. of action",
            "?",
            null,
            "action",
            false,
            false,
            1.05457168181818e-34
        ],
        [
            "n.u. of mass",
            "m?",
            null,
            "mass",
            false,
            false,
            9.10938261616162e-31
        ],
        [
            "n.u. of speed",
            "c?",
            null,
            "speed",
            false,
            false,
            299792458
        ],
        [
            "n.u. of time",
            "?/(me?c??)",
            null,
            "time",
            false,
            false,
            1.28808866778687e-21
        ],
        [
            "nautical mile",
            "M",
            [
                "Nmi"
            ],
            "length",
            false,
            true,
            1852
        ],
        [
            "newton",
            "N",
            null,
            "force",
            true,
            true,
            1
        ],
        [
            "\u0153rsted",
            "Oe ",
            null,
            "magnetic_field_intensity",
            false,
            false,
            79.5774715459477
        ],
        [
            "ohm",
            "\u03A9",
            null,
            "electric_resistance",
            true,
            false,
            1
        ],
        [
            "ounce mass",
            "ozm",
            null,
            "mass",
            false,
            true,
            0.028349523125
        ],
        [
            "pascal",
            "Pa",
            null,
            "pressure",
            true,
            false,
            1
        ],
        [
            "pascal second",
            "Pa?s",
            null,
            "dynamic_viscosity",
            true,
            false,
            1
        ],
        [
            "pferdest\xe4rke",
            "PS",
            null,
            "power",
            false,
            true,
            735.49875
        ],
        [
            "phot",
            "ph",
            null,
            "illuminance",
            false,
            false,
            0.0001
        ],
        [
            "pica (1/6 inch)",
            "pica",
            null,
            "length",
            false,
            true,
            0.00035277777777778
        ],
        [
            "pica (1/72 inch)",
            "Pica",
            [
                "Picapt"
            ],
            "length",
            false,
            true,
            0.00423333333333333
        ],
        [
            "poise",
            "P",
            null,
            "dynamic_viscosity",
            false,
            false,
            0.1
        ],
        [
            "pond",
            "pond",
            null,
            "force",
            false,
            true,
            0.00980665
        ],
        [
            "pound force",
            "lbf",
            null,
            "force",
            false,
            true,
            4.4482216152605
        ],
        [
            "pound mass",
            "lbm",
            null,
            "mass",
            false,
            true,
            0.45359237
        ],
        [
            "quart",
            "qt",
            null,
            "volume",
            false,
            true,
            0.000946352946
        ],
        [
            "radian",
            "rad",
            null,
            "angle",
            true,
            false,
            1
        ],
        [
            "second",
            "?",
            null,
            "angle",
            false,
            false,
            0.00000484813681109536
        ],
        [
            "second",
            "s",
            [
                "sec"
            ],
            "time",
            true,
            true,
            1
        ],
        [
            "short hundredweight",
            "cwt",
            [
                "shweight"
            ],
            "mass",
            false,
            true,
            45.359237
        ],
        [
            "siemens",
            "S",
            null,
            "electrical_conductance",
            true,
            false,
            1
        ],
        [
            "sievert",
            "Sv",
            null,
            "equivalent_dose",
            true,
            false,
            1
        ],
        [
            "slug",
            "sg",
            null,
            "mass",
            false,
            true,
            14.59390294
        ],
        [
            "square \xe5ngstr\xf6m",
            "ang2",
            [
                "ang^2"
            ],
            "area",
            false,
            true,
            1e-20
        ],
        [
            "square foot",
            "ft2",
            [
                "ft^2"
            ],
            "area",
            false,
            true,
            0.09290304
        ],
        [
            "square inch",
            "in2",
            [
                "in^2"
            ],
            "area",
            false,
            true,
            0.00064516
        ],
        [
            "square light-year",
            "ly2",
            [
                "ly^2"
            ],
            "area",
            false,
            true,
            8.95054210748189e31
        ],
        [
            "square meter",
            "m?",
            null,
            "area",
            true,
            true,
            1
        ],
        [
            "square mile",
            "mi2",
            [
                "mi^2"
            ],
            "area",
            false,
            true,
            2589988.110336
        ],
        [
            "square nautical mile",
            "Nmi2",
            [
                "Nmi^2"
            ],
            "area",
            false,
            true,
            3429904
        ],
        [
            "square Pica",
            "Pica2",
            [
                "Picapt2",
                "Pica^2",
                "Picapt^2"
            ],
            "area",
            false,
            true,
            0.00001792111111111
        ],
        [
            "square yard",
            "yd2",
            [
                "yd^2"
            ],
            "area",
            false,
            true,
            0.83612736
        ],
        [
            "statute mile",
            "mi",
            null,
            "length",
            false,
            true,
            1609.344
        ],
        [
            "steradian",
            "sr",
            null,
            "solid_angle",
            true,
            false,
            1
        ],
        [
            "stilb",
            "sb",
            null,
            "luminance",
            false,
            false,
            0.0001
        ],
        [
            "stokes",
            "St",
            null,
            "kinematic_viscosity",
            false,
            false,
            0.0001
        ],
        [
            "stone",
            "stone",
            null,
            "mass",
            false,
            true,
            6.35029318
        ],
        [
            "tablespoon",
            "tbs",
            null,
            "volume",
            false,
            true,
            0.0000147868
        ],
        [
            "teaspoon",
            "tsp",
            null,
            "volume",
            false,
            true,
            0.00000492892
        ],
        [
            "tesla",
            "T",
            null,
            "magnetic_flux_density",
            true,
            true,
            1
        ],
        [
            "thermodynamic calorie",
            "c",
            null,
            "energy",
            false,
            true,
            4.184
        ],
        [
            "ton",
            "ton",
            null,
            "mass",
            false,
            true,
            907.18474
        ],
        [
            "tonne",
            "t",
            null,
            "mass",
            false,
            false,
            1000
        ],
        [
            "U.K. pint",
            "uk_pt",
            null,
            "volume",
            false,
            true,
            0.00056826125
        ],
        [
            "U.S. bushel",
            "bushel",
            null,
            "volume",
            false,
            true,
            0.03523907
        ],
        [
            "U.S. oil barrel",
            "barrel",
            null,
            "volume",
            false,
            true,
            0.158987295
        ],
        [
            "U.S. pint",
            "pt",
            [
                "us_pt"
            ],
            "volume",
            false,
            true,
            0.000473176473
        ],
        [
            "U.S. survey mile",
            "survey_mi",
            null,
            "length",
            false,
            true,
            1609.347219
        ],
        [
            "U.S. survey/statute acre",
            "us_acre",
            null,
            "area",
            false,
            true,
            4046.87261
        ],
        [
            "volt",
            "V",
            null,
            "voltage",
            true,
            false,
            1
        ],
        [
            "watt",
            "W",
            null,
            "power",
            true,
            true,
            1
        ],
        [
            "watt-hour",
            "Wh",
            [
                "wh"
            ],
            "energy",
            false,
            true,
            3600
        ],
        [
            "weber",
            "Wb",
            null,
            "magnetic_flux",
            true,
            false,
            1
        ],
        [
            "yard",
            "yd",
            null,
            "length",
            false,
            true,
            0.9144
        ],
        [
            "year",
            "yr",
            null,
            "time",
            false,
            true,
            31557600
        ]
    ];
    // Binary prefixes
    // [Name, Prefix power of 2 value, Previx value, Abbreviation, Derived from]
    const binary_prefixes = {
        Yi: [
            "yobi",
            80,
            1208925819614629174706176,
            "Yi",
            "yotta"
        ],
        Zi: [
            "zebi",
            70,
            1180591620717411303424,
            "Zi",
            "zetta"
        ],
        Ei: [
            "exbi",
            60,
            1152921504606846976,
            "Ei",
            "exa"
        ],
        Pi: [
            "pebi",
            50,
            1125899906842624,
            "Pi",
            "peta"
        ],
        Ti: [
            "tebi",
            40,
            1099511627776,
            "Ti",
            "tera"
        ],
        Gi: [
            "gibi",
            30,
            1073741824,
            "Gi",
            "giga"
        ],
        Mi: [
            "mebi",
            20,
            1048576,
            "Mi",
            "mega"
        ],
        ki: [
            "kibi",
            10,
            1024,
            "ki",
            "kilo"
        ]
    };
    // Unit prefixes
    // [Name, Multiplier, Abbreviation]
    const unit_prefixes = {
        Y: [
            "yotta",
            1e24,
            "Y"
        ],
        Z: [
            "zetta",
            1e21,
            "Z"
        ],
        E: [
            "exa",
            1e18,
            "E"
        ],
        P: [
            "peta",
            1e15,
            "P"
        ],
        T: [
            "tera",
            1e12,
            "T"
        ],
        G: [
            "giga",
            1e9,
            "G"
        ],
        M: [
            "mega",
            1e6,
            "M"
        ],
        k: [
            "kilo",
            1e3,
            "k"
        ],
        h: [
            "hecto",
            1e2,
            "h"
        ],
        e: [
            "dekao",
            1e1,
            "e"
        ],
        d: [
            "deci",
            1e-1,
            "d"
        ],
        c: [
            "centi",
            1e-2,
            "c"
        ],
        m: [
            "milli",
            1e-3,
            "m"
        ],
        u: [
            "micro",
            1e-6,
            "u"
        ],
        n: [
            "nano",
            1e-9,
            "n"
        ],
        p: [
            "pico",
            1e-12,
            "p"
        ],
        f: [
            "femto",
            1e-15,
            "f"
        ],
        a: [
            "atto",
            1e-18,
            "a"
        ],
        z: [
            "zepto",
            1e-21,
            "z"
        ],
        y: [
            "yocto",
            1e-24,
            "y"
        ]
    };
    // Initialize units and multipliers
    let from = null;
    let to = null;
    let base_from_unit = from_unit;
    let base_to_unit = to_unit;
    let from_multiplier = 1;
    let to_multiplier = 1;
    let alt;
    // Lookup from and to units
    for(let i = 0; i < units.length; i++){
        alt = units[i][2] === null ? [] : units[i][2];
        if (units[i][1] === base_from_unit || alt.indexOf(base_from_unit) >= 0) from = units[i];
        if (units[i][1] === base_to_unit || alt.indexOf(base_to_unit) >= 0) to = units[i];
    }
    // Lookup from prefix
    if (from === null) {
        const from_binary_prefix = binary_prefixes[from_unit.substring(0, 2)];
        let from_unit_prefix = unit_prefixes[from_unit.substring(0, 1)];
        // Handle dekao unit prefix (only unit prefix with two characters)
        if (from_unit.substring(0, 2) === "da") from_unit_prefix = [
            "dekao",
            1e1,
            "da"
        ];
        // Handle binary prefixes first (so that 'Yi' is processed before 'Y')
        if (from_binary_prefix) {
            from_multiplier = from_binary_prefix[2];
            base_from_unit = from_unit.substring(2);
        } else if (from_unit_prefix) {
            from_multiplier = from_unit_prefix[1];
            base_from_unit = from_unit.substring(from_unit_prefix[2].length);
        }
        // Lookup from unit
        for(let j = 0; j < units.length; j++){
            alt = units[j][2] === null ? [] : units[j][2];
            if (units[j][1] === base_from_unit || alt.indexOf(base_from_unit) >= 0) from = units[j];
        }
    }
    // Lookup to prefix
    if (to === null) {
        const to_binary_prefix = binary_prefixes[to_unit.substring(0, 2)];
        let to_unit_prefix = unit_prefixes[to_unit.substring(0, 1)];
        // Handle dekao unit prefix (only unit prefix with two characters)
        if (to_unit.substring(0, 2) === "da") to_unit_prefix = [
            "dekao",
            1e1,
            "da"
        ];
        // Handle binary prefixes first (so that 'Yi' is processed before 'Y')
        if (to_binary_prefix) {
            to_multiplier = to_binary_prefix[2];
            base_to_unit = to_unit.substring(2);
        } else if (to_unit_prefix) {
            to_multiplier = to_unit_prefix[1];
            base_to_unit = to_unit.substring(to_unit_prefix[2].length);
        }
        // Lookup to unit
        for(let k = 0; k < units.length; k++){
            alt = units[k][2] === null ? [] : units[k][2];
            if (units[k][1] === base_to_unit || alt.indexOf(base_to_unit) >= 0) to = units[k];
        }
    }
    // Return error if a unit does not exist
    if (from === null || to === null) return $d551340dd0bc6b22$var$na;
    // Return error if units represent different quantities
    if (from[3] !== to[3]) return $d551340dd0bc6b22$var$na;
    // Return converted number
    return number * from[6] * from_multiplier / (to[6] * to_multiplier);
}
/**
 * Converts a decimal number to binary.
 *
 * Category: Engineering
 *
 * @param {*} number The decimal integer you want to convert. If number is negative, valid place values are ignored and DEC2BIN returns a 10-character (10-bit) binary number in which the most significant bit is the sign bit. The remaining 9 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, DEC2BIN uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$34b329599307d22e(number, places) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    // Return error if number is not decimal, is lower than -512, or is greater than 511
    if (!/^-?[0-9]{1,3}$/.test(number) || number < -512 || number > 511) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character binary number if number is negative
    if (number < 0) return "1" + $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", 9 - (512 + number).toString(2).length) + (512 + number).toString(2);
    // Convert decimal number to binary
    const result = parseInt(number, 10).toString(2);
    // Return binary number using the minimum number of characters necessary if places is undefined
    if (typeof places === "undefined") return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Converts a decimal number to hexadecimal.
 *
 * Category: Engineering
 *
 * @param {*} number The decimal integer you want to convert. If number is negative, places is ignored and DEC2HEX returns a 10-character (40-bit) hexadecimal number in which the most significant bit is the sign bit. The remaining 39 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, DEC2HEX uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$ad5283b633ba7d15(number, places) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    // Return error if number is not decimal, is lower than -549755813888, or is greater than 549755813887
    if (!/^-?[0-9]{1,12}$/.test(number) || number < -549755813888 || number > 549755813887) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character hexadecimal number if number is negative
    if (number < 0) return (1099511627776 + number).toString(16);
    // Convert decimal number to hexadecimal
    const result = parseInt(number, 10).toString(16);
    // Return hexadecimal number using the minimum number of characters necessary if places is undefined
    if (typeof places === "undefined") return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Converts a decimal number to octal.
 *
 * Category: Engineering
 *
 * @param {*} number The decimal integer you want to convert. If number is negative, places is ignored and DEC2OCT returns a 10-character (30-bit) octal number in which the most significant bit is the sign bit. The remaining 29 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, DEC2OCT uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$444a31d8dc139219(number, places) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if (number instanceof Error) return number;
    // Return error if number is not decimal, is lower than -549755813888, or is greater than 549755813887
    if (!/^-?[0-9]{1,9}$/.test(number) || number < -536870912 || number > 536870911) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character octal number if number is negative
    if (number < 0) return (1073741824 + number).toString(8);
    // Convert decimal number to octal
    const result = parseInt(number, 10).toString(8);
    // Return octal number using the minimum number of characters necessary if places is undefined
    if (typeof places === "undefined") return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Tests whether two values are equal.
 *
 * Category: Engineering
 *
 * @param {*} number1 The first number.
 * @param {*} number2 Optional. The second number. If omitted, number2 is assumed to be zero.
 * @returns
 */ function $d551340dd0bc6b22$export$d971781c6009eb20(number1, number2) {
    // Set number2 to zero if undefined
    number2 = number2 === undefined ? 0 : number2;
    number1 = $d551340dd0bc6b22$var$parseNumber(number1);
    number2 = $d551340dd0bc6b22$var$parseNumber(number2);
    if ($d551340dd0bc6b22$var$anyIsError(number1, number2)) return $d551340dd0bc6b22$var$value;
    // Return delta
    return number1 === number2 ? 1 : 0;
}
// TODO: why is upper_bound not used ? The excel documentation has no examples with upper_bound
/**
 * Returns the error function.
 *
 * Category: Engineering
 *
 * @param {*} lower_limit The lower bound for integrating ERF.
 * @param {*} upper_limit Optional. The upper bound for integrating ERF. If omitted, ERF integrates between zero and lower_limit.
 * @returns
 */ function $d551340dd0bc6b22$export$7efc564e3fb93878(lower_limit, upper_limit) {
    // Set number2 to zero if undefined
    upper_limit = upper_limit === undefined ? 0 : upper_limit;
    lower_limit = $d551340dd0bc6b22$var$parseNumber(lower_limit);
    upper_limit = $d551340dd0bc6b22$var$parseNumber(upper_limit);
    if ($d551340dd0bc6b22$var$anyIsError(lower_limit, upper_limit)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).erf(lower_limit);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the error function.
 *
 * Category: Engineering
 *
 * @param {*} x The lower bound for integrating ERF.PRECISE.
 * @returns
 */ $d551340dd0bc6b22$export$7efc564e3fb93878.PRECISE = ()=>{
    throw new Error("ERF.PRECISE is not implemented");
};
/**
 * Returns the complementary error function.
 *
 * Category: Engineering
 *
 * @param {*} x The lower bound for integrating ERFC.
 * @returns
 */ function $d551340dd0bc6b22$export$65027249abea691b(x) {
    // Return error if x is not a number
    if (isNaN(x)) return $d551340dd0bc6b22$var$value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($252df761458e1f74$exports))).erfc(x);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the complementary ERF function integrated between x and infinity.
 *
 * Category: Engineering
 *
 * @param {*} x The lower bound for integrating ERFC.PRECISE.
 * @returns
 */ $d551340dd0bc6b22$export$65027249abea691b.PRECISE = ()=>{
    throw new Error("ERFC.PRECISE is not implemented");
};
/**
 * Tests whether a number is greater than a threshold value.
 *
 * Category: Engineering
 *
 * @param {*} number The value to test against step.
 * @param {*} step Optional. The threshold value. If you omit a value for step, GESTEP uses zero.
 * @returns
 */ function $d551340dd0bc6b22$export$d65f525a890a7184(number, step) {
    step = step || 0;
    number = $d551340dd0bc6b22$var$parseNumber(number);
    if ($d551340dd0bc6b22$var$anyIsError(step, number)) return number;
    // Return delta
    return number >= step ? 1 : 0;
}
/**
 * Converts a hexadecimal number to binary.
 *
 * Category: Engineering
 *
 * @param {*} number The hexadecimal number you want to convert. Number cannot contain more than 10 characters. The most significant bit of number is the sign bit (40th bit from the right). The remaining 9 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, HEX2BIN uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$ed0ea43d3ab85380(number, places) {
    // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
    if (!/^[0-9A-Fa-f]{1,10}$/.test(number)) return $d551340dd0bc6b22$var$num;
    // Check if number is negative
    const negative = !!(number.length === 10 && number.substring(0, 1).toLowerCase() === "f");
    // Convert hexadecimal number to decimal
    const decimal = negative ? parseInt(number, 16) - 1099511627776 : parseInt(number, 16);
    // Return error if number is lower than -512 or greater than 511
    if (decimal < -512 || decimal > 511) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character binary number if number is negative
    if (negative) return "1" + $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", 9 - (512 + decimal).toString(2).length) + (512 + decimal).toString(2);
    // Convert decimal number to binary
    const result = decimal.toString(2);
    // Return binary number using the minimum number of characters necessary if places is undefined
    if (places === undefined) return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Converts a hexadecimal number to decimal.
 *
 * Category: Engineering
 *
 * @param {*} number The hexadecimal number you want to convert. Number cannot contain more than 10 characters (40 bits). The most significant bit of number is the sign bit. The remaining 39 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @returns
 */ function $d551340dd0bc6b22$export$5e19714337bdbf85(number) {
    // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
    if (!/^[0-9A-Fa-f]{1,10}$/.test(number)) return $d551340dd0bc6b22$var$num;
    // Convert hexadecimal number to decimal
    const decimal = parseInt(number, 16);
    // Return decimal number
    return decimal >= 549755813888 ? decimal - 1099511627776 : decimal;
}
/**
 * Converts a hexadecimal number to octal.
 *
 * Category: Engineering
 *
 * @param {*} number The hexadecimal number you want to convert. Number cannot contain more than 10 characters. The most significant bit of number is the sign bit. The remaining 39 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, HEX2OCT uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$d6808101a3ffb321(number, places) {
    // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
    if (!/^[0-9A-Fa-f]{1,10}$/.test(number)) return $d551340dd0bc6b22$var$num;
    // Convert hexadecimal number to decimal
    const decimal = parseInt(number, 16);
    // Return error if number is positive and greater than 0x1fffffff (536870911)
    if (decimal > 536870911 && decimal < 1098974756864) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character octal number if number is negative
    if (decimal >= 1098974756864) return (decimal - 1098437885952).toString(8);
    // Convert decimal number to octal
    const result = decimal.toString(8);
    // Return octal number using the minimum number of characters necessary if places is undefined
    if (places === undefined) return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Returns the absolute value (modulus) of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the absolute value.
 * @returns
 */ function $d551340dd0bc6b22$export$46094a6772749520(inumber) {
    // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    // Return error if either coefficient is not a number
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Return absolute value of complex number
    return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
}
/**
 * Returns the imaginary coefficient of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the imaginary coefficient.
 * @returns
 */ function $d551340dd0bc6b22$export$69436ce25fb43214(inumber) {
    if (inumber === undefined || inumber === true || inumber === false) return $d551340dd0bc6b22$var$value;
    // Return 0 if inumber is equal to 0
    if (inumber === 0 || inumber === "0") return 0;
    // Handle special cases
    if ([
        "i",
        "j"
    ].indexOf(inumber) >= 0) return 1;
    // Force string type
    inumber = inumber + "";
    // Normalize imaginary coefficient
    inumber = inumber.replace("+i", "+1i").replace("-i", "-1i").replace("+j", "+1j").replace("-j", "-1j");
    // Lookup sign
    let plus = inumber.indexOf("+");
    let minus = inumber.indexOf("-");
    if (plus === 0) plus = inumber.indexOf("+", 1);
    if (minus === 0) minus = inumber.indexOf("-", 1);
    // Lookup imaginary unit
    const last = inumber.substring(inumber.length - 1, inumber.length);
    const unit = last === "i" || last === "j";
    if (plus >= 0 || minus >= 0) {
        // Return error if imaginary unit is neither i nor j
        if (!unit) return $d551340dd0bc6b22$var$num;
        // Return imaginary coefficient of complex number
        if (plus >= 0) return isNaN(inumber.substring(0, plus)) || isNaN(inumber.substring(plus + 1, inumber.length - 1)) ? $d551340dd0bc6b22$var$num : Number(inumber.substring(plus + 1, inumber.length - 1));
        else return isNaN(inumber.substring(0, minus)) || isNaN(inumber.substring(minus + 1, inumber.length - 1)) ? $d551340dd0bc6b22$var$num : -Number(inumber.substring(minus + 1, inumber.length - 1));
    } else {
        if (unit) return isNaN(inumber.substring(0, inumber.length - 1)) ? $d551340dd0bc6b22$var$num : inumber.substring(0, inumber.length - 1);
        else return isNaN(inumber) ? $d551340dd0bc6b22$var$num : 0;
    }
}
/**
 * Returns the argument theta, an angle expressed in radians.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the argument .
 * @returns
 */ function $d551340dd0bc6b22$export$4889e74d25ccf5e8(inumber) {
    // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    // Return error if either coefficient is not a number
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Return error if inumber is equal to zero
    if (x === 0 && y === 0) return $d551340dd0bc6b22$var$div0;
    // Return PI/2 if x is equal to zero and y is positive
    if (x === 0 && y > 0) return Math.PI / 2;
    // Return -PI/2 if x is equal to zero and y is negative
    if (x === 0 && y < 0) return -Math.PI / 2;
    // Return zero if x is negative and y is equal to zero
    if (y === 0 && x > 0) return 0;
    // Return zero if x is negative and y is equal to zero
    if (y === 0 && x < 0) return -Math.PI;
    // Return argument of complex number
    if (x > 0) return Math.atan(y / x);
    else if (x < 0 && y >= 0) return Math.atan(y / x) + Math.PI;
    else return Math.atan(y / x) - Math.PI;
}
/**
 * Returns the complex conjugate of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the conjugate.
 * @returns
 */ function $d551340dd0bc6b22$export$10b559c86b2f1b43(inumber) {
    // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return conjugate of complex number
    return y !== 0 ? $d551340dd0bc6b22$export$82ec7cdb62c32775(x, -y, unit) : inumber;
}
/**
 * Returns the cosine of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the cosine.
 * @returns
 */ function $d551340dd0bc6b22$export$e502d9f25230b2e3(inumber) {
    // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return cosine of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.cos(x) * (Math.exp(y) + Math.exp(-y)) / 2, -Math.sin(x) * (Math.exp(y) - Math.exp(-y)) / 2, unit);
}
/**
 * Returns the hyperbolic cosine of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the hyperbolic cosine.
 * @returns
 */ function $d551340dd0bc6b22$export$750ed5a2dc1052d(inumber) {
    // Lookup real and imaginary coefficients using exports.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return hyperbolic cosine of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.cos(y) * (Math.exp(x) + Math.exp(-x)) / 2, Math.sin(y) * (Math.exp(x) - Math.exp(-x)) / 2, unit);
}
/**
 * Returns the cotangent of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the cotangent.
 * @returns
 */ function $d551340dd0bc6b22$export$e0422ec6c6d9f787(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Return cotangent of complex number
    return $d551340dd0bc6b22$export$47b7f15481cf756b($d551340dd0bc6b22$export$e502d9f25230b2e3(inumber), $d551340dd0bc6b22$export$976939413ef99c10(inumber));
}
/**
 * Returns the quotient of two complex numbers.
 *
 * Category: Engineering
 *
 * @param {*} inumber1 The complex numerator or dividend.
 * @param {*} inumber2 The complex denominator or divisor.
 * @returns
 */ function $d551340dd0bc6b22$export$47b7f15481cf756b(inumber1, inumber2) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const a = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber1);
    const b = $d551340dd0bc6b22$export$69436ce25fb43214(inumber1);
    const c = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber2);
    const d = $d551340dd0bc6b22$export$69436ce25fb43214(inumber2);
    if ($d551340dd0bc6b22$var$anyIsError(a, b, c, d)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    const unit1 = inumber1.substring(inumber1.length - 1);
    const unit2 = inumber2.substring(inumber2.length - 1);
    let unit = "i";
    if (unit1 === "j") unit = "j";
    else if (unit2 === "j") unit = "j";
    // Return error if inumber2 is null
    if (c === 0 && d === 0) return $d551340dd0bc6b22$var$num;
    // Return exponential of complex number
    const den = c * c + d * d;
    return $d551340dd0bc6b22$export$82ec7cdb62c32775((a * c + b * d) / den, (b * c - a * d) / den, unit);
}
/**
 * Returns the exponential of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the exponential.
 * @returns
 */ function $d551340dd0bc6b22$export$55a99da07f2fd182(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return exponential of complex number
    const e = Math.exp(x);
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(e * Math.cos(y), e * Math.sin(y), unit);
}
/**
 * Returns the natural logarithm of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the natural logarithm.
 * @returns
 */ function $d551340dd0bc6b22$export$73698fc10b803367(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return exponential of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.log(Math.sqrt(x * x + y * y)), Math.atan(y / x), unit);
}
/**
 * Returns the base-10 logarithm of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the common logarithm.
 * @returns
 */ function $d551340dd0bc6b22$export$5b1db36f97d127fc(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return exponential of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.log(Math.sqrt(x * x + y * y)) / Math.log(10), Math.atan(y / x) / Math.log(10), unit);
}
/**
 * Returns the base-2 logarithm of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the base-2 logarithm.
 * @returns
 */ function $d551340dd0bc6b22$export$cd7439d59b97f73c(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return exponential of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.log(Math.sqrt(x * x + y * y)) / Math.log(2), Math.atan(y / x) / Math.log(2), unit);
}
/**
 * Returns a complex number raised to an integer power.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number you want to raise to a power.
 * @param {*} number The power to which you want to raise the complex number.
 * @returns
 */ function $d551340dd0bc6b22$export$5b1acd18296d98d6(inumber, number) {
    number = $d551340dd0bc6b22$var$parseNumber(number);
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(number, x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Calculate power of modulus
    const p = Math.pow($d551340dd0bc6b22$export$46094a6772749520(inumber), number);
    // Calculate argument
    const t = $d551340dd0bc6b22$export$4889e74d25ccf5e8(inumber);
    // Return exponential of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(p * Math.cos(number * t), p * Math.sin(number * t), unit);
}
/**
 * Returns the product of complex numbers.
 *
 * Category: Engineering
 *
 * @param {*} args inumber1, [inumber2], … Inumber1 is required, subsequent inumbers are not. 1 to 255 complex numbers to multiply.
 * @returns
 */ function $d551340dd0bc6b22$export$be29ef149efc3154() {
    // Initialize result
    let result = arguments[0];
    if (!arguments.length) return $d551340dd0bc6b22$var$value;
    // Loop on all numbers
    for(let i = 1; i < arguments.length; i++){
        // Lookup coefficients of two complex numbers
        const a = $d551340dd0bc6b22$export$1497846afdf2dfce(result);
        const b = $d551340dd0bc6b22$export$69436ce25fb43214(result);
        const c = $d551340dd0bc6b22$export$1497846afdf2dfce(arguments[i]);
        const d = $d551340dd0bc6b22$export$69436ce25fb43214(arguments[i]);
        if ($d551340dd0bc6b22$var$anyIsError(a, b, c, d)) return $d551340dd0bc6b22$var$value;
        // Complute product of two complex numbers
        result = $d551340dd0bc6b22$export$82ec7cdb62c32775(a * c - b * d, a * d + b * c);
    }
    // Return product of complex numbers
    return result;
}
/**
 * Returns the real coefficient of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the real coefficient.
 * @returns
 */ function $d551340dd0bc6b22$export$1497846afdf2dfce(inumber) {
    if (inumber === undefined || inumber === true || inumber === false) return $d551340dd0bc6b22$var$value;
    // Return 0 if inumber is equal to 0
    if (inumber === 0 || inumber === "0") return 0;
    // Handle special cases
    if ([
        "i",
        "+i",
        "1i",
        "+1i",
        "-i",
        "-1i",
        "j",
        "+j",
        "1j",
        "+1j",
        "-j",
        "-1j"
    ].indexOf(inumber) >= 0) return 0;
    // Force String type
    inumber = inumber + "";
    // Lookup sign
    let plus = inumber.indexOf("+");
    let minus = inumber.indexOf("-");
    if (plus === 0) plus = inumber.indexOf("+", 1);
    if (minus === 0) minus = inumber.indexOf("-", 1);
    // Lookup imaginary unit
    const last = inumber.substring(inumber.length - 1, inumber.length);
    const unit = last === "i" || last === "j";
    if (plus >= 0 || minus >= 0) {
        // Return error if imaginary unit is neither i nor j
        if (!unit) return $d551340dd0bc6b22$var$num;
        // Return real coefficient of complex number
        if (plus >= 0) return isNaN(inumber.substring(0, plus)) || isNaN(inumber.substring(plus + 1, inumber.length - 1)) ? $d551340dd0bc6b22$var$num : Number(inumber.substring(0, plus));
        else return isNaN(inumber.substring(0, minus)) || isNaN(inumber.substring(minus + 1, inumber.length - 1)) ? $d551340dd0bc6b22$var$num : Number(inumber.substring(0, minus));
    } else {
        if (unit) return isNaN(inumber.substring(0, inumber.length - 1)) ? $d551340dd0bc6b22$var$num : 0;
        else return isNaN(inumber) ? $d551340dd0bc6b22$var$num : inumber;
    }
}
/**
 * Returns the secant of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the secant.
 * @returns
 */ function $d551340dd0bc6b22$export$d9061b1ff96022c(inumber) {
    // Return error if inumber is a logical value
    if (inumber === true || inumber === false) return $d551340dd0bc6b22$var$value;
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Return secant of complex number
    return $d551340dd0bc6b22$export$47b7f15481cf756b("1", $d551340dd0bc6b22$export$e502d9f25230b2e3(inumber));
}
/**
 * Returns the hyperbolic secant of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the hyperbolic secant.
 * @returns
 */ function $d551340dd0bc6b22$export$1f1ebe8d7f0b1968(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Return hyperbolic secant of complex number
    return $d551340dd0bc6b22$export$47b7f15481cf756b("1", $d551340dd0bc6b22$export$750ed5a2dc1052d(inumber));
}
/**
 * Returns the sine of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the sine.
 * @returns
 */ function $d551340dd0bc6b22$export$976939413ef99c10(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return sine of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.sin(x) * (Math.exp(y) + Math.exp(-y)) / 2, Math.cos(x) * (Math.exp(y) - Math.exp(-y)) / 2, unit);
}
/**
 * Returns the hyperbolic sine of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the hyperbolic sine.
 * @returns
 */ function $d551340dd0bc6b22$export$228d15200a0f74ed(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Return hyperbolic sine of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(Math.cos(y) * (Math.exp(x) - Math.exp(-x)) / 2, Math.sin(y) * (Math.exp(x) + Math.exp(-x)) / 2, unit);
}
/**
 * Returns the square root of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the square root.
 * @returns
 */ function $d551340dd0bc6b22$export$103927f37ad91a63(inumber) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    let unit = inumber.substring(inumber.length - 1);
    unit = unit === "i" || unit === "j" ? unit : "i";
    // Calculate power of modulus
    const s = Math.sqrt($d551340dd0bc6b22$export$46094a6772749520(inumber));
    // Calculate argument
    const t = $d551340dd0bc6b22$export$4889e74d25ccf5e8(inumber);
    // Return exponential of complex number
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(s * Math.cos(t / 2), s * Math.sin(t / 2), unit);
}
/**
 * Returns the cosecant of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the cosecant.
 * @returns
 */ function $d551340dd0bc6b22$export$e24402469d27f293(inumber) {
    // Return error if inumber is a logical value
    if (inumber === true || inumber === false) return $d551340dd0bc6b22$var$value;
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    // Return error if either coefficient is not a number
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$num;
    // Return cosecant of complex number
    return $d551340dd0bc6b22$export$47b7f15481cf756b("1", $d551340dd0bc6b22$export$976939413ef99c10(inumber));
}
/**
 * Returns the hyperbolic cosecant of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the hyperbolic cosecant.
 * @returns
 */ function $d551340dd0bc6b22$export$444df6e620af4abe(inumber) {
    // Return error if inumber is a logical value
    if (inumber === true || inumber === false) return $d551340dd0bc6b22$var$value;
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    // Return error if either coefficient is not a number
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$num;
    // Return hyperbolic cosecant of complex number
    return $d551340dd0bc6b22$export$47b7f15481cf756b("1", $d551340dd0bc6b22$export$228d15200a0f74ed(inumber));
}
/**
 * Returns the difference between two complex numbers.
 *
 * Category: Engineering
 *
 * @param {*} inumber1 The complex number from which to subtract inumber2.
 * @param {*} inumber2 The complex number to subtract from inumber1.
 * @returns
 */ function $d551340dd0bc6b22$export$fc795640df08b0be(inumber1, inumber2) {
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const a = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber1);
    const b = $d551340dd0bc6b22$export$69436ce25fb43214(inumber1);
    const c = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber2);
    const d = $d551340dd0bc6b22$export$69436ce25fb43214(inumber2);
    if ($d551340dd0bc6b22$var$anyIsError(a, b, c, d)) return $d551340dd0bc6b22$var$value;
    // Lookup imaginary unit
    const unit1 = inumber1.substring(inumber1.length - 1);
    const unit2 = inumber2.substring(inumber2.length - 1);
    let unit = "i";
    if (unit1 === "j") unit = "j";
    else if (unit2 === "j") unit = "j";
    // Return _ of two complex numbers
    return $d551340dd0bc6b22$export$82ec7cdb62c32775(a - c, b - d, unit);
}
/**
 * Returns the sum of complex numbers.
 *
 * Category: Engineering
 *
 * @param {*} args inumber1, [inumber2], ... Inumber1 is required, subsequent numbers are not. 1 to 255 complex numbers to add.
 * @returns
 */ function $d551340dd0bc6b22$export$94a473d1e2755616() {
    if (!arguments.length) return $d551340dd0bc6b22$var$value;
    const args = $d551340dd0bc6b22$var$flatten(arguments);
    // Initialize result
    let result = args[0];
    // Loop on all numbers
    for(let i = 1; i < args.length; i++){
        // Lookup coefficients of two complex numbers
        const a = $d551340dd0bc6b22$export$1497846afdf2dfce(result);
        const b = $d551340dd0bc6b22$export$69436ce25fb43214(result);
        const c = $d551340dd0bc6b22$export$1497846afdf2dfce(args[i]);
        const d = $d551340dd0bc6b22$export$69436ce25fb43214(args[i]);
        if ($d551340dd0bc6b22$var$anyIsError(a, b, c, d)) return $d551340dd0bc6b22$var$value;
        // Complute product of two complex numbers
        result = $d551340dd0bc6b22$export$82ec7cdb62c32775(a + c, b + d);
    }
    // Return sum of complex numbers
    return result;
}
/**
 * Returns the tangent of a complex number.
 *
 * Category: Engineering
 *
 * @param {*} inumber A complex number for which you want the tangent.
 * @returns
 */ function $d551340dd0bc6b22$export$dbd871e5c2755c62(inumber) {
    // Return error if inumber is a logical value
    if (inumber === true || inumber === false) return $d551340dd0bc6b22$var$value;
    // Lookup real and imaginary coefficients using Formula.js [http://formulajs.org]
    const x = $d551340dd0bc6b22$export$1497846afdf2dfce(inumber);
    const y = $d551340dd0bc6b22$export$69436ce25fb43214(inumber);
    if ($d551340dd0bc6b22$var$anyIsError(x, y)) return $d551340dd0bc6b22$var$value;
    // Return tangent of complex number
    return $d551340dd0bc6b22$export$47b7f15481cf756b($d551340dd0bc6b22$export$976939413ef99c10(inumber), $d551340dd0bc6b22$export$e502d9f25230b2e3(inumber));
}
/**
 * Converts an octal number to binary.
 *
 * Category: Engineering
 *
 * @param {*} number The octal number you want to convert. Number may not contain more than 10 characters. The most significant bit of number is the sign bit. The remaining 29 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, OCT2BIN uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$169408818577a3c8(number, places) {
    // Return error if number is not hexadecimal or contains more than ten characters (10 digits)
    if (!/^[0-7]{1,10}$/.test(number)) return $d551340dd0bc6b22$var$num;
    // Check if number is negative
    const negative = !!(number.length === 10 && number.substring(0, 1) === "7");
    // Convert octal number to decimal
    const decimal = negative ? parseInt(number, 8) - 1073741824 : parseInt(number, 8);
    // Return error if number is lower than -512 or greater than 511
    if (decimal < -512 || decimal > 511) return $d551340dd0bc6b22$var$num;
    // Ignore places and return a 10-character binary number if number is negative
    if (negative) return "1" + $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", 9 - (512 + decimal).toString(2).length) + (512 + decimal).toString(2);
    // Convert decimal number to binary
    const result = decimal.toString(2);
    // Return binary number using the minimum number of characters necessary if places is undefined
    if (typeof places === "undefined") return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
/**
 * Converts an octal number to decimal.
 *
 * Category: Engineering
 *
 * @param {*} number The octal number you want to convert. Number may not contain more than 10 octal characters (30 bits). The most significant bit of number is the sign bit. The remaining 29 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @returns
 */ function $d551340dd0bc6b22$export$3224fb9ba404646c(number) {
    // Return error if number is not octal or contains more than ten characters (10 digits)
    if (!/^[0-7]{1,10}$/.test(number)) return $d551340dd0bc6b22$var$num;
    // Convert octal number to decimal
    const decimal = parseInt(number, 8);
    // Return decimal number
    return decimal >= 536870912 ? decimal - 1073741824 : decimal;
}
/**
 * Converts an octal number to hexadecimal.
 *
 * Category: Engineering
 *
 * @param {*} number The octal number you want to convert. Number may not contain more than 10 octal characters (30 bits). The most significant bit of number is the sign bit. The remaining 29 bits are magnitude bits. Negative numbers are represented using two's-complement notation.
 * @param {*} places Optional. The number of characters to use. If places is omitted, OCT2HEX uses the minimum number of characters necessary. Places is useful for padding the return value with leading 0s (zeros).
 * @returns
 */ function $d551340dd0bc6b22$export$5e4216ebcfc52aa(number, places) {
    // Return error if number is not octal or contains more than ten characters (10 digits)
    if (!/^[0-7]{1,10}$/.test(number)) return $d551340dd0bc6b22$var$num;
    // Convert octal number to decimal
    const decimal = parseInt(number, 8);
    // Ignore places and return a 10-character octal number if number is negative
    if (decimal >= 536870912) return "ff" + (decimal + 3221225472).toString(16);
    // Convert decimal number to hexadecimal
    const result = decimal.toString(16);
    // Return hexadecimal number using the minimum number of characters necessary if places is undefined
    if (places === undefined) return result;
    else {
        // Return error if places is nonnumeric
        if (isNaN(places)) return $d551340dd0bc6b22$var$value;
        // Return error if places is negative
        if (places < 0) return $d551340dd0bc6b22$var$num;
        // Truncate places in case it is not an integer
        places = Math.floor(places);
        // Pad return value with leading 0s (zeros) if necessary (using Underscore.string)
        return places >= result.length ? $d551340dd0bc6b22$export$7f0fdfd63ecad857("0", places - result.length) + result : $d551340dd0bc6b22$var$num;
    }
}
const $d551340dd0bc6b22$export$d4ac9ee68493c89c = $d551340dd0bc6b22$export$d8fe69043b6df2f0.DIST;
const $d551340dd0bc6b22$export$d86b9741d4fe4fec = $d551340dd0bc6b22$export$d8fe69043b6df2f0.INV;
const $d551340dd0bc6b22$export$9239a21337c314d3 = $d551340dd0bc6b22$export$b4ccfb6e589ca4c3.DIST;
const $d551340dd0bc6b22$export$4d27e1668cf17046 = $d551340dd0bc6b22$export$f0c8b50ab8f753d1.MATH;
const $d551340dd0bc6b22$export$4f1222c9afcbe154 = $d551340dd0bc6b22$export$f0c8b50ab8f753d1.PRECISE;
const $d551340dd0bc6b22$export$690eab5e52df1fdb = $d551340dd0bc6b22$export$bb2c792e07d3cb0d.DIST;
const $d551340dd0bc6b22$export$32dcc72743997920 = $d551340dd0bc6b22$export$bb2c792e07d3cb0d.DIST.RT;
const $d551340dd0bc6b22$export$b30f43e36b9fc9a1 = $d551340dd0bc6b22$export$bb2c792e07d3cb0d.INV;
const $d551340dd0bc6b22$export$1b11f4ce87b7bbb0 = $d551340dd0bc6b22$export$bb2c792e07d3cb0d.INV.RT;
const $d551340dd0bc6b22$export$21edc5a30754955f = $d551340dd0bc6b22$export$bb2c792e07d3cb0d.TEST;
const $d551340dd0bc6b22$export$69f92ab90865d0ab = $d551340dd0bc6b22$export$fe38092c9c5592c1.P;
const $d551340dd0bc6b22$export$7de8fad2fc88c622 = $d551340dd0bc6b22$export$fe38092c9c5592c1.P;
const $d551340dd0bc6b22$export$f3cb1a1d646702d6 = $d551340dd0bc6b22$export$fe38092c9c5592c1.S;
const $d551340dd0bc6b22$export$a47ba45c7497167e = $d551340dd0bc6b22$export$b4ccfb6e589ca4c3.INV;
const $d551340dd0bc6b22$export$dd18499c5cc4dc7b = $d551340dd0bc6b22$export$65027249abea691b.PRECISE;
const $d551340dd0bc6b22$export$1d284e71bcb3239 = $d551340dd0bc6b22$export$7efc564e3fb93878.PRECISE;
const $d551340dd0bc6b22$export$2033dd314723e012 = $d551340dd0bc6b22$export$f5c508346c29966.DIST;
const $d551340dd0bc6b22$export$73da131f922a0338 = $d551340dd0bc6b22$export$d66501df72047452.DIST;
const $d551340dd0bc6b22$export$ed51eb5fc6622e2d = $d551340dd0bc6b22$export$d66501df72047452.DIST.RT;
const $d551340dd0bc6b22$export$5d2008c3383ab31a = $d551340dd0bc6b22$export$d66501df72047452.INV;
const $d551340dd0bc6b22$export$dca1b2844c849f53 = $d551340dd0bc6b22$export$d66501df72047452.INV.RT;
const $d551340dd0bc6b22$export$1f59f7ca7282ea05 = $d551340dd0bc6b22$export$a474b8effcd46ae5.MATH;
const $d551340dd0bc6b22$export$99cd9e9a19272622 = $d551340dd0bc6b22$export$a474b8effcd46ae5.PRECISE;
const $d551340dd0bc6b22$export$c9f64cb70b4b4e2 = $d551340dd0bc6b22$export$d66501df72047452.TEST;
const $d551340dd0bc6b22$export$ac4a283eaf23cdaa = $d551340dd0bc6b22$export$3149bf0fa771f486.DIST;
const $d551340dd0bc6b22$export$f4455427964a26b4 = $d551340dd0bc6b22$export$3149bf0fa771f486.INV;
const $d551340dd0bc6b22$export$3d84d30c7d8e5c42 = $d551340dd0bc6b22$export$bc57bccc987a6235.PRECISE;
const $d551340dd0bc6b22$export$6a1eee4def8e90dc = $d551340dd0bc6b22$export$4f2126ef1718652a.DIST;
const $d551340dd0bc6b22$export$8dd792b577fd1b72 = $d551340dd0bc6b22$export$53b1f20e80f267f3.INV;
const $d551340dd0bc6b22$export$53f9173e13edd594 = $d551340dd0bc6b22$export$53b1f20e80f267f3.DIST;
const $d551340dd0bc6b22$export$cddcc957df522a15 = $d551340dd0bc6b22$export$53b1f20e80f267f3.INV;
const $d551340dd0bc6b22$export$d7c514b3ba758b6b = $d551340dd0bc6b22$export$e48589d9e4824227.MULT;
const $d551340dd0bc6b22$export$ea54d65381d43aa7 = $d551340dd0bc6b22$export$e48589d9e4824227.SNGL;
const $d551340dd0bc6b22$export$8f32d9c47fe2ec07 = $d551340dd0bc6b22$export$7d27d6c799ee5741.DIST;
const $d551340dd0bc6b22$export$18b3fc7b025dd104 = $d551340dd0bc6b22$export$b029795fd7335958.INTL;
const $d551340dd0bc6b22$export$e0574f50c8901a84 = $d551340dd0bc6b22$export$954e4c4b76579057.DIST;
const $d551340dd0bc6b22$export$7c93be9e749c620 = $d551340dd0bc6b22$export$954e4c4b76579057.INV;
const $d551340dd0bc6b22$export$30ceafc4b83b31a4 = $d551340dd0bc6b22$export$954e4c4b76579057.S.DIST;
const $d551340dd0bc6b22$export$f3ecde47f59a3b64 = $d551340dd0bc6b22$export$954e4c4b76579057.S.INV;
const $d551340dd0bc6b22$export$b55ba8f69cc9f516 = $d551340dd0bc6b22$export$96cfb1bd783d195e.EXC;
const $d551340dd0bc6b22$export$1592141639af97f1 = $d551340dd0bc6b22$export$96cfb1bd783d195e.INC;
const $d551340dd0bc6b22$export$2bf564ce8b23fa9a = $d551340dd0bc6b22$export$483d99bb48a73bb9.EXC;
const $d551340dd0bc6b22$export$f26623bf98c5e3c7 = $d551340dd0bc6b22$export$483d99bb48a73bb9.INC;
const $d551340dd0bc6b22$export$ff681e70694f77c1 = $d551340dd0bc6b22$export$211723024797c6fd.DIST;
const $d551340dd0bc6b22$export$a3b4eb133190e86b = $d551340dd0bc6b22$export$71cc92a67a8a2333.EXC;
const $d551340dd0bc6b22$export$125d6e72c865321e = $d551340dd0bc6b22$export$71cc92a67a8a2333.INC;
const $d551340dd0bc6b22$export$e8b59b79583b383e = $d551340dd0bc6b22$export$c3d7e0f1e63de60e.AVG;
const $d551340dd0bc6b22$export$91bd632c18040d44 = $d551340dd0bc6b22$export$c3d7e0f1e63de60e.EQ;
const $d551340dd0bc6b22$export$3a3b13bf0ec488ed = $d551340dd0bc6b22$export$30bba9af0267eaf4.P;
const $d551340dd0bc6b22$export$d9175827c5fa2860 = $d551340dd0bc6b22$export$934ea05709cb9cb8.P;
const $d551340dd0bc6b22$export$aead0ff8af4d0dfa = $d551340dd0bc6b22$export$934ea05709cb9cb8.S;
const $d551340dd0bc6b22$export$d870d5cac49d8b39 = $d551340dd0bc6b22$var$T$1.DIST;
const $d551340dd0bc6b22$export$f91567e2e14d67e9 = $d551340dd0bc6b22$var$T$1.DIST.RT;
const $d551340dd0bc6b22$export$eeb575485553b731 = $d551340dd0bc6b22$var$T$1.INV;
const $d551340dd0bc6b22$export$8f5449ee65d97746 = $d551340dd0bc6b22$var$T$1.TEST;
const $d551340dd0bc6b22$export$e835efc374b5a160 = $d551340dd0bc6b22$export$c5b2d92d160f058.P;
const $d551340dd0bc6b22$export$f67c1b44058594d9 = $d551340dd0bc6b22$export$c5b2d92d160f058.S;
const $d551340dd0bc6b22$export$3dd65333304d65a8 = $d551340dd0bc6b22$export$dd03fb262934220c.DIST;
const $d551340dd0bc6b22$export$bb79704139cf29ff = $d551340dd0bc6b22$export$4ddd5a796076b49d.INTL;
const $d551340dd0bc6b22$export$bf6d693c61cfba35 = $d551340dd0bc6b22$export$dc98b0b04f4c7758.TEST;
function $d551340dd0bc6b22$var$compact(array) {
    const result = [];
    $d551340dd0bc6b22$var$arrayEach(array, (value)=>{
        if (value) result.push(value);
    });
    return result;
}
function $d551340dd0bc6b22$var$findResultIndex(database, criterias) {
    const matches = {};
    for(let i = 1; i < database[0].length; ++i)matches[i] = true;
    let maxCriteriaLength = criterias[0].length;
    for(let i = 1; i < criterias.length; ++i)if (criterias[i].length > maxCriteriaLength) maxCriteriaLength = criterias[i].length;
    for(let k = 1; k < database.length; ++k)for(let l = 1; l < database[k].length; ++l){
        let currentCriteriaResult = false;
        let hasMatchingCriteria = false;
        for(let j = 0; j < criterias.length; ++j){
            const criteria = criterias[j];
            if (criteria.length < maxCriteriaLength) continue;
            const criteriaField = criteria[0];
            if (database[k][0] !== criteriaField) continue;
            hasMatchingCriteria = true;
            for(let p = 1; p < criteria.length; ++p)if (!currentCriteriaResult) {
                const isWildcard = criteria[p] === void 0 || criteria[p] === "*";
                if (isWildcard) currentCriteriaResult = true;
                else {
                    const tokenizedCriteria = $d551340dd0bc6b22$var$parse(criteria[p] + "");
                    const tokens = [
                        $d551340dd0bc6b22$var$createToken(database[k][l], $d551340dd0bc6b22$var$TOKEN_TYPE_LITERAL)
                    ].concat(tokenizedCriteria);
                    currentCriteriaResult = $d551340dd0bc6b22$var$compute(tokens);
                }
            }
        }
        if (hasMatchingCriteria) matches[l] = matches[l] && currentCriteriaResult;
    }
    const result = [];
    for(let n = 0; n < database[0].length; ++n)if (matches[n]) result.push(n - 1);
    return result;
}
// Database functions
/**
 * Returns the average of selected database entries.
 *
 * Category: Database
 *
 * @param {*} database Range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria Range of values that contains the conditions you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$1463f71cd602dfb(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    let sum = 0;
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        sum += targetFields[value];
    });
    return resultIndexes.length === 0 ? $d551340dd0bc6b22$var$div0 : sum / resultIndexes.length;
}
/**
 * Counts the values that contain numbers in a database.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as the argument includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$3154afef99a63970(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    const targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    return $d551340dd0bc6b22$export$d61684373eacdf61(targetValues);
}
/**
 * Counts nonblank values in a database.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Optional. Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$7ee07dc007db1e39(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    const targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    return $d551340dd0bc6b22$export$e2041fbf69361bdc(targetValues);
}
/**
 * Extracts from a database a single record that matches the specified criteria.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$36583ac9c31082d4(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    // Return error if no record meets the criteria
    if (resultIndexes.length === 0) return $d551340dd0bc6b22$var$value;
    // Returns the #NUM! error value because more than one record meets the
    // criteria
    if (resultIndexes.length > 1) return $d551340dd0bc6b22$var$num;
    return targetFields[resultIndexes[0]];
}
/**
 * Returns the maximum value from selected database entries.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$ea609bd07d926c66(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    let maxValue = targetFields[resultIndexes[0]];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        if (maxValue < targetFields[value]) maxValue = targetFields[value];
    });
    return maxValue;
}
/**
 * Returns the minimum value from selected database entries.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$479c3f1fc47f92d8(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    let minValue = targetFields[resultIndexes[0]];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        if (minValue > targetFields[value]) minValue = targetFields[value];
    });
    return minValue;
}
/**
 * Multiplies the values in a particular field of records that match the criteria in a database.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$dd442e8079864287(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    let targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    targetValues = $d551340dd0bc6b22$var$compact(targetValues);
    let result = 1;
    $d551340dd0bc6b22$var$arrayEach(targetValues, (value)=>{
        result *= value;
    });
    return result;
}
/**
 * Estimates the standard deviation based on a sample of selected database entries.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$2e503a91546be57d(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    let targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    targetValues = $d551340dd0bc6b22$var$compact(targetValues);
    return $d551340dd0bc6b22$export$934ea05709cb9cb8.S(targetValues);
}
/**
 * Calculates the standard deviation based on the entire population of selected database entries.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$dffdef20b30f90d1(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    let targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    targetValues = $d551340dd0bc6b22$var$compact(targetValues);
    return $d551340dd0bc6b22$export$934ea05709cb9cb8.P(targetValues);
}
/**
 * Adds the numbers in the field column of records in the database that match the criteria.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria Is the range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$84e0dddd1df6335b(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    const targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    return $d551340dd0bc6b22$export$49f482aefa6f8a2d(targetValues);
}
/**
 * Estimates variance based on a sample from selected database entries.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$2030e95dd39ffacb(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    const targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    return $d551340dd0bc6b22$export$c5b2d92d160f058.S(targetValues);
}
/**
 * Calculates variance based on the entire population of selected database entries.
 *
 * Category: Database
 *
 * @param {*} database The range of values that makes up the list or database. A database is a list of related data in which rows of related information are records, and columns of data are fields. The first row of the list contains labels for each column.
 * @param {*} field Indicates which column is used in the function. Enter the column label enclosed between double quotation marks, such as "Age" or "Yield," or a number (without quotation marks) that represents the position of the column within the list: 1 for the first column, 2 for the second column, and so on.
 * @param {*} criteria The range of values that contains the conditions that you specify. You can use any range for the criteria argument, as long as it includes at least one column label and at least one value below the column label in which you specify a condition for the column.
 * @returns
 */ function $d551340dd0bc6b22$export$2298d0401fb7648b(database, field, criteria) {
    // Return error if field is not a number and not a string
    if (isNaN(field) && typeof field !== "string") return $d551340dd0bc6b22$var$value;
    const resultIndexes = $d551340dd0bc6b22$var$findResultIndex(database, criteria);
    let targetFields = [];
    if (typeof field === "string") {
        const index = $d551340dd0bc6b22$var$findField(database, field);
        targetFields = $d551340dd0bc6b22$var$rest(database[index]);
    } else targetFields = $d551340dd0bc6b22$var$rest(database[field]);
    const targetValues = [];
    $d551340dd0bc6b22$var$arrayEach(resultIndexes, (value)=>{
        targetValues.push(targetFields[value]);
    });
    return $d551340dd0bc6b22$export$c5b2d92d160f058.P(targetValues);
}
function $d551340dd0bc6b22$var$validDate(d) {
    return d && d.getTime && !isNaN(d.getTime());
}
function $d551340dd0bc6b22$var$ensureDate(d) {
    return d instanceof Date ? d : new Date(d);
}
/**
 * Returns the accrued interest for a security that pays periodic interest.
 *
 * Category: Financial
 *
 * @param {*} issue The security's issue date.
 * @param {*} first_interest The security's first interest date.
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} rate The security's annual coupon rate.
 * @param {*} par The security's par value. If you omit par, ACCRINT uses $1,000.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @param {*} calc_method Optional. Not implemented in formulajs. A logical value that specifies the way to calculate the total accrued interest when the date of settlement is later than the date of first_interest. A value of TRUE (1) returns the total accrued interest from issue to settlement. A value of FALSE (0) returns the accrued interest from first_interest to settlement. If you do not enter the argument, it defaults to TRUE.
 * @returns
 */ function $d551340dd0bc6b22$export$634ab1efaea5e0b2(issue, first_interest, settlement, rate, par, frequency, basis) {
    // Return error if either date is invalid
    issue = $d551340dd0bc6b22$var$ensureDate(issue);
    first_interest = $d551340dd0bc6b22$var$ensureDate(first_interest);
    settlement = $d551340dd0bc6b22$var$ensureDate(settlement);
    if (!$d551340dd0bc6b22$var$validDate(issue) || !$d551340dd0bc6b22$var$validDate(first_interest) || !$d551340dd0bc6b22$var$validDate(settlement)) return $d551340dd0bc6b22$var$value;
    // Return error if either rate or par are lower than or equal to zero
    if (rate <= 0 || par <= 0) return $d551340dd0bc6b22$var$num;
    // Return error if frequency is neither 1, 2, or 4
    if ([
        1,
        2,
        4
    ].indexOf(frequency) === -1) return $d551340dd0bc6b22$var$num;
    // Return error if basis is neither 0, 1, 2, 3, or 4
    if ([
        0,
        1,
        2,
        3,
        4
    ].indexOf(basis) === -1) return $d551340dd0bc6b22$var$num;
    // Return error if settlement is before or equal to issue
    if (settlement <= issue) return $d551340dd0bc6b22$var$num;
    // Set default values
    par = par || 0;
    basis = basis || 0;
    // Compute accrued interest
    return par * rate * $d551340dd0bc6b22$export$469c0023d0dca9cc(issue, settlement, basis);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the accrued interest for a security that pays interest at maturity.
 *
 * Category: Financial
 *
 * @param {*} issue The security's issue date.
 * @param {*} settlement The security's maturity date.
 * @param {*} rate The security's annual coupon rate.
 * @param {*} par The security's par value. If you omit par, ACCRINTM uses $1,000.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$75fe1147d890b300() {
    throw new Error("ACCRINTM is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the depreciation for each accounting period by using a depreciation coefficient.
 *
 * Category: Financial
 *
 * @param {*} cost The cost of the asset.
 * @param {*} date_purchased The date of the purchase of the asset.
 * @param {*} first_period The date of the end of the first period.
 * @param {*} salvage The salvage value at the end of the life of the asset.
 * @param {*} period The period.
 * @param {*} rate The rate of depreciation.
 * @param {*} basis Optional. The year basis to be used.
 * @returns
 */ function $d551340dd0bc6b22$export$94769a7973bbb40a() {
    throw new Error("AMORDEGRC is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the depreciation for each accounting period.
 *
 * Category: Financial
 *
 * @param {*} cost The cost of the asset.
 * @param {*} date_purchased The date of the purchase of the asset.
 * @param {*} first_period The date of the end of the first period.
 * @param {*} salvage The salvage value at the end of the life of the asset.
 * @param {*} period The period.
 * @param {*} rate The rate of depreciation.
 * @param {*} basis Optional. The year basis to be used.
 * @returns
 */ function $d551340dd0bc6b22$export$45667e95c57f4885() {
    throw new Error("AMORLINC is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the number of days from the beginning of the coupon period to the settlement date.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$8ec3d98fa4852ac4() {
    throw new Error("COUPDAYBS is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the number of days in the coupon period that contains the settlement date.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$956a8a3476ed51d() {
    throw new Error("COUPDAYS is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the number of days from the settlement date to the next coupon date.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$b11738792f1f9329() {
    throw new Error("COUPDAYSNC is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the next coupon date after the settlement date.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$476ab0cdf7812c3e() {
    throw new Error("COUPNCD is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the number of coupons payable between the settlement date and maturity date.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$139b9615dc97d378() {
    throw new Error("COUPNUM is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the previous coupon date before the settlement date.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$eaa53d7b6cede71f() {
    throw new Error("COUPPCD is not implemented");
}
/**
 * Returns the cumulative interest paid between two periods.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate.
 * @param {*} nper The total number of payment periods.
 * @param {*} pv The present value.
 * @param {*} start_period The first period in the calculation. Payment periods are numbered beginning with 1.
 * @param {*} end_period The last period in the calculation.
 * @param {*} type The timing of the payment.
 * @returns
 */ function $d551340dd0bc6b22$export$467217ed336d38e6(rate, nper, pv, start_period, end_period, type) {
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    if ($d551340dd0bc6b22$var$anyIsError(rate, nper, pv)) return $d551340dd0bc6b22$var$value;
    if (rate <= 0 || nper <= 0 || pv <= 0) return $d551340dd0bc6b22$var$num;
    if (start_period < 1 || end_period < 1 || start_period > end_period) return $d551340dd0bc6b22$var$num;
    if (type !== 0 && type !== 1) return $d551340dd0bc6b22$var$num;
    const payment = $d551340dd0bc6b22$export$57281459c9c05a49(rate, nper, pv, 0, type);
    let interest = 0;
    if (start_period === 1) {
        if (type === 0) interest = -pv;
        start_period++;
    }
    for(let i = start_period; i <= end_period; i++)interest += type === 1 ? $d551340dd0bc6b22$export$5969d82d45b8b86c(rate, i - 2, payment, pv, 1) - payment : $d551340dd0bc6b22$export$5969d82d45b8b86c(rate, i - 1, payment, pv, 0);
    interest *= rate;
    return interest;
}
/**
 * Returns the cumulative principal paid on a loan between two periods.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate.
 * @param {*} nper The total number of payment periods.
 * @param {*} pv The present value.
 * @param {*} start_period The first period in the calculation. Payment periods are numbered beginning with 1.
 * @param {*} end_period The last period in the calculation.
 * @param {*} type The timing of the payment.
 * @returns
 */ function $d551340dd0bc6b22$export$7f3e1b7b222ac0a7(rate, nper, pv, start_period, end, type) {
    // Credits: algorithm inspired by Apache OpenOffice
    // Credits: Hannes Stiebitzhofer for the translations of function and variable names
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    if ($d551340dd0bc6b22$var$anyIsError(rate, nper, pv)) return $d551340dd0bc6b22$var$value;
    // Return error if either rate, nper, or value are lower than or equal to zero
    if (rate <= 0 || nper <= 0 || pv <= 0) return $d551340dd0bc6b22$var$num;
    // Return error if start < 1, end < 1, or start > end
    if (start_period < 1 || end < 1 || start_period > end) return $d551340dd0bc6b22$var$num;
    // Return error if type is neither 0 nor 1
    if (type !== 0 && type !== 1) return $d551340dd0bc6b22$var$num;
    // Compute cumulative principal
    const payment = $d551340dd0bc6b22$export$57281459c9c05a49(rate, nper, pv, 0, type);
    let principal = 0;
    if (start_period === 1) {
        principal = type === 0 ? payment + pv * rate : payment;
        start_period++;
    }
    for(let i = start_period; i <= end; i++)principal += type > 0 ? payment - ($d551340dd0bc6b22$export$5969d82d45b8b86c(rate, i - 2, payment, pv, 1) - payment) * rate : payment - $d551340dd0bc6b22$export$5969d82d45b8b86c(rate, i - 1, payment, pv, 0) * rate;
    // Return cumulative principal
    return principal;
}
/**
 * Returns the depreciation of an asset for a specified period by using the fixed-declining balance method.
 *
 * Category: Financial
 *
 * @param {*} cost The initial cost of the asset.
 * @param {*} salvage The value at the end of the depreciation (sometimes called the salvage value of the asset).
 * @param {*} life The number of periods over which the asset is being depreciated (sometimes called the useful life of the asset).
 * @param {*} period The period for which you want to calculate the depreciation. Period must use the same units as life.
 * @param {*} month Optional. The number of months in the first year. If month is omitted, it is assumed to be 12.
 * @returns
 */ function $d551340dd0bc6b22$export$c71782fb18623f93(cost, salvage, life, period, month) {
    // Initialize month
    month = month === undefined ? 12 : month;
    cost = $d551340dd0bc6b22$var$parseNumber(cost);
    salvage = $d551340dd0bc6b22$var$parseNumber(salvage);
    life = $d551340dd0bc6b22$var$parseNumber(life);
    period = $d551340dd0bc6b22$var$parseNumber(period);
    month = $d551340dd0bc6b22$var$parseNumber(month);
    if ($d551340dd0bc6b22$var$anyIsError(cost, salvage, life, period, month)) return $d551340dd0bc6b22$var$value;
    // Return error if any of the parameters is negative
    if (cost < 0 || salvage < 0 || life < 0 || period < 0) return $d551340dd0bc6b22$var$num;
    // Return error if month is not an integer between 1 and 12
    if ([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ].indexOf(month) === -1) return $d551340dd0bc6b22$var$num;
    // Return error if period is greater than life
    if (period > life) return $d551340dd0bc6b22$var$num;
    // Return 0 (zero) if salvage is greater than or equal to cost
    if (salvage >= cost) return 0;
    // Rate is rounded to three decimals places
    const rate = (1 - Math.pow(salvage / cost, 1 / life)).toFixed(3);
    // Compute initial depreciation
    const initial = cost * rate * month / 12;
    // Compute total depreciation
    let total = initial;
    let current = 0;
    const ceiling = period === life ? life - 1 : period;
    for(let i = 2; i <= ceiling; i++){
        current = (cost - total) * rate;
        total += current;
    }
    // Depreciation for the first and last periods are special cases
    if (period === 1) // First period
    return initial;
    else if (period === life) // Last period
    return (cost - total) * rate;
    else return current;
}
/**
 * Returns the depreciation of an asset for a specified period by using the double-declining balance method or some other method that you specify.
 *
 * Category: Financial
 *
 * @param {*} cost The initial cost of the asset.
 * @param {*} salvage The value at the end of the depreciation (sometimes called the salvage value of the asset). This value can be 0.
 * @param {*} life The number of periods over which the asset is being depreciated (sometimes called the useful life of the asset).
 * @param {*} period The period for which you want to calculate the depreciation. Period must use the same units as life.
 * @param {*} factor Optional. The rate at which the balance declines. If factor is omitted, it is assumed to be 2 (the double-declining balance method).
 * @returns
 */ function $d551340dd0bc6b22$export$749a741759bf1ee1(cost, salvage, life, period, factor) {
    // Initialize factor
    factor = factor === undefined ? 2 : factor;
    cost = $d551340dd0bc6b22$var$parseNumber(cost);
    salvage = $d551340dd0bc6b22$var$parseNumber(salvage);
    life = $d551340dd0bc6b22$var$parseNumber(life);
    period = $d551340dd0bc6b22$var$parseNumber(period);
    factor = $d551340dd0bc6b22$var$parseNumber(factor);
    if ($d551340dd0bc6b22$var$anyIsError(cost, salvage, life, period, factor)) return $d551340dd0bc6b22$var$value;
    // Return error if any of the parameters is negative or if factor is null
    if (cost < 0 || salvage < 0 || life < 0 || period < 0 || factor <= 0) return $d551340dd0bc6b22$var$num;
    // Return error if period is greater than life
    if (period > life) return $d551340dd0bc6b22$var$num;
    // Return 0 (zero) if salvage is greater than or equal to cost
    if (salvage >= cost) return 0;
    // Compute depreciation
    let total = 0;
    let current = 0;
    for(let i = 1; i <= period; i++){
        current = Math.min((cost - total) * (factor / life), cost - salvage - total);
        total += current;
    }
    // Return depreciation
    return current;
}
/**
 * Returns the discount rate for a security.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} pr The security's price per $100 face value.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$174c38d98ccdc6e4(settlement, maturity, pr, redemption, basis) {
    settlement = $d551340dd0bc6b22$var$parseDate(settlement);
    maturity = $d551340dd0bc6b22$var$parseDate(maturity);
    pr = $d551340dd0bc6b22$var$parseNumber(pr);
    redemption = $d551340dd0bc6b22$var$parseNumber(redemption);
    basis = $d551340dd0bc6b22$var$parseNumber(basis);
    basis = basis || 0;
    if ($d551340dd0bc6b22$var$anyIsError(settlement, maturity, pr, redemption, basis)) return $d551340dd0bc6b22$var$value;
    if (pr <= 0 || redemption <= 0) return $d551340dd0bc6b22$var$num;
    if (settlement >= maturity) return $d551340dd0bc6b22$var$value;
    let basisVal, diff;
    switch(basis){
        case 0:
            basisVal = 360;
            diff = $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, false);
            break;
        case 1:
            basisVal = 365;
            diff = $d551340dd0bc6b22$export$6f5ad06e6a29fbac(settlement, maturity, "D");
            break;
        case 2:
            basisVal = 360;
            diff = $d551340dd0bc6b22$export$6f5ad06e6a29fbac(settlement, maturity, "D");
            break;
        case 3:
            basisVal = 365;
            diff = $d551340dd0bc6b22$export$6f5ad06e6a29fbac(settlement, maturity, "D");
            break;
        case 4:
            basisVal = 360;
            diff = $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, true);
            break;
        default:
            return $d551340dd0bc6b22$var$num;
    }
    return (redemption - pr) / redemption * basisVal / diff;
}
/**
 * Converts a dollar price, expressed as a fraction, into a dollar price, expressed as a decimal number.
 *
 * Category: Financial
 *
 * @param {*} fractional_dollar A number expressed as an integer part and a fraction part, separated by a decimal symbol.
 * @param {*} fraction The integer to use in the denominator of the fraction.
 * @returns
 */ function $d551340dd0bc6b22$export$12e495d28a93a9d9(fractional_dollar, fraction) {
    // Credits: algorithm inspired by Apache OpenOffice
    fractional_dollar = $d551340dd0bc6b22$var$parseNumber(fractional_dollar);
    fraction = $d551340dd0bc6b22$var$parseNumber(fraction);
    if ($d551340dd0bc6b22$var$anyIsError(fractional_dollar, fraction)) return $d551340dd0bc6b22$var$value;
    // Return error if fraction is negative
    if (fraction < 0) return $d551340dd0bc6b22$var$num;
    // Return error if fraction is greater than or equal to 0 and less than 1
    if (fraction >= 0 && fraction < 1) return $d551340dd0bc6b22$var$div0;
    // Truncate fraction if it is not an integer
    fraction = parseInt(fraction, 10);
    // Compute integer part
    let result = parseInt(fractional_dollar, 10);
    // Add decimal part
    result += fractional_dollar % 1 * Math.pow(10, Math.ceil(Math.log(fraction) / Math.LN10)) / fraction;
    // Round result
    const power = Math.pow(10, Math.ceil(Math.log(fraction) / Math.LN2) + 1);
    result = Math.round(result * power) / power;
    // Return converted dollar price
    return result;
}
/**
 * Converts a dollar price, expressed as a decimal number, into a dollar price, expressed as a fraction.
 *
 * Category: Financial
 *
 * @param {*} decimal_dollar A decimal number.
 * @param {*} fraction The integer to use in the denominator of a fraction.
 * @returns
 */ function $d551340dd0bc6b22$export$3c144424bf648375(decimal_dollar, fraction) {
    // Credits: algorithm inspired by Apache OpenOffice
    decimal_dollar = $d551340dd0bc6b22$var$parseNumber(decimal_dollar);
    fraction = $d551340dd0bc6b22$var$parseNumber(fraction);
    if ($d551340dd0bc6b22$var$anyIsError(decimal_dollar, fraction)) return $d551340dd0bc6b22$var$value;
    // Return error if fraction is negative
    if (fraction < 0) return $d551340dd0bc6b22$var$num;
    // Return error if fraction is greater than or equal to 0 and less than 1
    if (fraction >= 0 && fraction < 1) return $d551340dd0bc6b22$var$div0;
    // Truncate fraction if it is not an integer
    fraction = parseInt(fraction, 10);
    // Compute integer part
    let result = parseInt(decimal_dollar, 10);
    // Add decimal part
    result += decimal_dollar % 1 * Math.pow(10, -Math.ceil(Math.log(fraction) / Math.LN10)) * fraction;
    // Return converted dollar price
    return result;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the annual duration of a security with periodic interest payments.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} coupon The security's annual coupon rate.
 * @param {*} yld The security's annual yield.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$bacc88974c736870() {
    throw new Error("DURATION is not implemented");
}
/**
 * Returns the effective annual interest rate.
 *
 * Category: Financial
 *
 * @param {*} nominal_rate The nominal interest rate.
 * @param {*} npery The number of compounding periods per year.
 * @returns
 */ function $d551340dd0bc6b22$export$4afca9a08097ec4f(nominal_rate, npery) {
    nominal_rate = $d551340dd0bc6b22$var$parseNumber(nominal_rate);
    npery = $d551340dd0bc6b22$var$parseNumber(npery);
    if ($d551340dd0bc6b22$var$anyIsError(nominal_rate, npery)) return $d551340dd0bc6b22$var$value;
    // Return error if rate <=0 or periods < 1
    if (nominal_rate <= 0 || npery < 1) return $d551340dd0bc6b22$var$num;
    // Truncate periods if it is not an integer
    npery = parseInt(npery, 10);
    // Return effective annual interest rate
    return Math.pow(1 + nominal_rate / npery, npery) - 1;
}
/**
 * Returns the future value of an investment.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate per period.
 * @param {*} nper The total number of payment periods in an annuity.
 * @param {*} pmt The payment made each period; it cannot change over the life of the annuity. Typically, pmt contains principal and interest but no other fees or taxes. If pmt is omitted, you must include the pv argument.
 * @param {*} pv Optional. The present value, or the lump-sum amount that a series of future payments is worth right now. If pv is omitted, it is assumed to be 0 (zero), and you must include the pmt argument.
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due. If type is omitted, it is assumed to be 0.
 * @returns
 */ function $d551340dd0bc6b22$export$5969d82d45b8b86c(rate, nper, payment, value$1, type) {
    // Credits: algorithm inspired by Apache OpenOffice
    value$1 = value$1 || 0;
    type = type || 0;
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    payment = $d551340dd0bc6b22$var$parseNumber(payment);
    value$1 = $d551340dd0bc6b22$var$parseNumber(value$1);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    if ($d551340dd0bc6b22$var$anyIsError(rate, nper, payment, value$1, type)) return $d551340dd0bc6b22$var$value;
    // Return future value
    let result;
    if (rate === 0) result = value$1 + payment * nper;
    else {
        const term = Math.pow(1 + rate, nper);
        result = type === 1 ? value$1 * term + payment * (1 + rate) * (term - 1) / rate : value$1 * term + payment * (term - 1) / rate;
    }
    return -result;
}
/**
 * Returns the future value of an initial principal after applying a series of compound interest rates.
 *
 * Category: Financial
 *
 * @param {*} principal The present value.
 * @param {*} schedule An array of interest rates to apply.
 * @returns
 */ function $d551340dd0bc6b22$export$94c83dfbae052f4b(principal, schedule) {
    principal = $d551340dd0bc6b22$var$parseNumber(principal);
    schedule = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(schedule));
    if ($d551340dd0bc6b22$var$anyIsError(principal, schedule)) return $d551340dd0bc6b22$var$value;
    const n = schedule.length;
    let future = principal;
    // Apply all interests in schedule
    for(let i = 0; i < n; i++)// Apply scheduled interest
    future *= 1 + schedule[i];
    // Return future value
    return future;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the interest rate for a fully invested security.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} investment The amount invested in the security.
 * @param {*} redemption The amount to be received at maturity.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$f66352698c434da6() {
    throw new Error("INTRATE is not implemented");
}
/**
 * Returns the interest payment for an investment for a given period.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate per period.
 * @param {*} per The period for which you want to find the interest and must be in the range 1 to nper.
 * @param {*} nper The total number of payment periods in an annuity.
 * @param {*} pv The present value, or the lump-sum amount that a series of future payments is worth right now.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (the future value of a loan, for example, is 0).
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due. If type is omitted, it is assumed to be 0.
 * @returns
 */ function $d551340dd0bc6b22$export$60d0f5ab72a44b8b(rate, per, nper, pv, fv, type) {
    // Credits: algorithm inspired by Apache OpenOffice
    fv = fv || 0;
    type = type || 0;
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    per = $d551340dd0bc6b22$var$parseNumber(per);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    if ($d551340dd0bc6b22$var$anyIsError(rate, per, nper, pv, fv, type)) return $d551340dd0bc6b22$var$value;
    // Compute payment
    const payment = $d551340dd0bc6b22$export$57281459c9c05a49(rate, nper, pv, fv, type);
    // Compute interest
    let interest = per === 1 ? type === 1 ? 0 : -pv : type === 1 ? $d551340dd0bc6b22$export$5969d82d45b8b86c(rate, per - 2, payment, pv, 1) - payment : $d551340dd0bc6b22$export$5969d82d45b8b86c(rate, per - 1, payment, pv, 0);
    // Return interest
    return interest * rate;
}
/**
 * Returns the internal rate of return for a series of cash flows.
 *
 * Category: Financial
 *
 * @param {*} values An array or a reference to values that contain numbers for which you want to calculate the internal rate of return.
 - Values must contain at least one positive value and one negative value to calculate the internal rate of return.
 - IRR uses the order of values to interpret the order of cash flows. Be sure to enter your payment and income values in the sequence you want.
 - If an array or reference argument contains text, logical values, or empty values, those values are ignored.
 * @param {*} guess Optional. A number that you guess is close to the result of IRR.
 - Microsoft Excel uses an iterative technique for calculating IRR. Starting with guess, IRR cycles through the calculation until the result is accurate within 0.00001 percent. If IRR can't find a result that works after 20 tries, the #NUM! error value is returned.
 - In most cases you do not need to provide guess for the IRR calculation. If guess is omitted, it is assumed to be 0.1 (10 percent).
 - If IRR gives the #NUM! error value, or if the result is not close to what you expected, try again with a different value for guess.
 * @returns
 */ function $d551340dd0bc6b22$export$687b78831fd2914a(values, guess) {
    // Credits: algorithm inspired by Apache OpenOffice
    guess = guess || 0;
    values = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(values));
    guess = $d551340dd0bc6b22$var$parseNumber(guess);
    if ($d551340dd0bc6b22$var$anyIsError(values, guess)) return $d551340dd0bc6b22$var$value;
    // Calculates the resulting amount
    const irrResult = (values, dates, rate)=>{
        const r = rate + 1;
        let result = values[0];
        for(let i = 1; i < values.length; i++)result += values[i] / Math.pow(r, (dates[i] - dates[0]) / 365);
        return result;
    };
    // Calculates the first derivation
    const irrResultDeriv = (values, dates, rate)=>{
        const r = rate + 1;
        let result = 0;
        for(let i = 1; i < values.length; i++){
            const frac = (dates[i] - dates[0]) / 365;
            result -= frac * values[i] / Math.pow(r, frac + 1);
        }
        return result;
    };
    // Initialize dates and check that values contains at least one positive value and one negative value
    const dates = [];
    let positive = false;
    let negative = false;
    for(let i = 0; i < values.length; i++){
        dates[i] = i === 0 ? 0 : dates[i - 1] + 365;
        if (values[i] > 0) positive = true;
        if (values[i] < 0) negative = true;
    }
    // Return error if values does not contain at least one positive value and one negative value
    if (!positive || !negative) return $d551340dd0bc6b22$var$num;
    // Initialize guess and resultRate
    guess = guess === undefined ? 0.1 : guess;
    let resultRate = guess;
    // Set maximum epsilon for end of iteration
    const epsMax = 1e-10;
    // Implement Newton's method
    let newRate, epsRate, resultValue;
    let contLoop = true;
    do {
        resultValue = irrResult(values, dates, resultRate);
        newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate);
        epsRate = Math.abs(newRate - resultRate);
        resultRate = newRate;
        contLoop = epsRate > epsMax && Math.abs(resultValue) > epsMax;
    }while (contLoop);
    // Return internal rate of return
    return resultRate;
}
/**
 * Calculates the interest paid during a specific period of an investment.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate for the investment.
 * @param {*} per The period for which you want to find the interest, and must be between 1 and Nper.
 * @param {*} nper The total number of payment periods for the investment.
 * @param {*} pv The present value of the investment. For a loan, Pv is the loan amount.
 *
 * @returns
 */ function $d551340dd0bc6b22$export$fb43bbe87ae38cf5(rate, per, nper, pv) {
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    per = $d551340dd0bc6b22$var$parseNumber(per);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    if ($d551340dd0bc6b22$var$anyIsError(rate, per, nper, pv)) return $d551340dd0bc6b22$var$value;
    // Return interest
    return pv * rate * (per / nper - 1);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the Macauley modified duration for a security with an assumed par value of $100.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} coupon The security's annual coupon rate.
 * @param {*} yld The security's annual yield.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$28a3b9016cb38ab7() {
    throw new Error("MDURATION is not implemented");
}
/**
 * Returns the internal rate of return where positive and negative cash flows are financed at different rates.
 *
 * Category: Financial
 *
 * @param {*} values An array or a reference to values that contain numbers. These numbers represent a series of payments (negative values) and income (positive values) occurring at regular periods.
 - Values must contain at least one positive value and one negative value to calculate the modified internal rate of return. Otherwise, MIRR returns the #DIV/0! error value.
 - If an array or reference argument contains text, logical values, or empty values, those values are ignored; however, values with the value zero are included.
 * @param {*} finance_rate The interest rate you pay on the money used in the cash flows.
 * @param {*} reinvest_rate The interest rate you receive on the cash flows as you reinvest them.
 * @returns
 */ function $d551340dd0bc6b22$export$8fb6ec0c845ae070(values, finance_rate, reinvest_rate) {
    values = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(values));
    finance_rate = $d551340dd0bc6b22$var$parseNumber(finance_rate);
    reinvest_rate = $d551340dd0bc6b22$var$parseNumber(reinvest_rate);
    if ($d551340dd0bc6b22$var$anyIsError(values, finance_rate, reinvest_rate)) return $d551340dd0bc6b22$var$value;
    // Initialize number of values
    const n = values.length;
    // Lookup payments (negative values) and incomes (positive values)
    const payments = [];
    const incomes = [];
    for(let i = 0; i < n; i++)if (values[i] < 0) payments.push(values[i]);
    else incomes.push(values[i]);
    // Return modified internal rate of return
    const num = -$d551340dd0bc6b22$export$39ba90e9124b524f(reinvest_rate, incomes) * Math.pow(1 + reinvest_rate, n - 1);
    const den = $d551340dd0bc6b22$export$39ba90e9124b524f(finance_rate, payments) * (1 + finance_rate);
    return Math.pow(num / den, 1 / (n - 1)) - 1;
}
/**
 * Returns the annual nominal interest rate.
 *
 * Category: Financial
 *
 * @param {*} effect_rate The effective interest rate.
 * @param {*} npery The number of compounding periods per year.
 * @returns
 */ function $d551340dd0bc6b22$export$afc8e5e6aacf465b(effect_rate, npery) {
    effect_rate = $d551340dd0bc6b22$var$parseNumber(effect_rate);
    npery = $d551340dd0bc6b22$var$parseNumber(npery);
    if ($d551340dd0bc6b22$var$anyIsError(effect_rate, npery)) return $d551340dd0bc6b22$var$value;
    // Return error if rate <=0 or periods < 1
    if (effect_rate <= 0 || npery < 1) return $d551340dd0bc6b22$var$num;
    // Truncate periods if it is not an integer
    npery = parseInt(npery, 10);
    // Return nominal annual interest rate
    return (Math.pow(effect_rate + 1, 1 / npery) - 1) * npery;
}
/**
 * Returns the number of periods for an investment.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate per period.
 * @param {*} pmt The payment made each period; it cannot change over the life of the annuity. Typically, pmt contains principal and interest but no other fees or taxes.
 * @param {*} pv The present value, or the lump-sum amount that a series of future payments is worth right now.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (the future value of a loan, for example, is 0).
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due.
 * @returns
 */ function $d551340dd0bc6b22$export$58685c02fadb4371(rate, pmt, pv, fv, type) {
    type = type === undefined ? 0 : type;
    fv = fv === undefined ? 0 : fv;
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    pmt = $d551340dd0bc6b22$var$parseNumber(pmt);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    if ($d551340dd0bc6b22$var$anyIsError(rate, pmt, pv, fv, type)) return $d551340dd0bc6b22$var$value;
    if (rate === 0) return -(pv + fv) / pmt;
    else {
        const num = pmt * (1 + rate * type) - fv * rate;
        const den = pv * rate + pmt * (1 + rate * type);
        return Math.log(num / den) / Math.log(1 + rate);
    }
}
/**
 * Returns the net present value of an investment based on a series of periodic cash flows and a discount rate.
 *
 * Category: Financial
 *
 * @param {*} rate The rate of discount over the length of one period.
 * @param {*} args value1, value2, ... Value1 is required, subsequent values are optional. 1 to 254 arguments representing the payments and income.
 - value1, value2, ... must be equally spaced in time and occur at the end of each period.
 - NPV uses the order of value1, value2, ... to interpret the order of cash flows. Be sure to enter your payment and income values in the correct sequence.
 - Arguments that are empty values, logical values, or text representations of numbers, error values, or text that cannot be translated into numbers are ignored.
 - If an argument is an array or reference, only numbers in that array or reference are counted. Empty values, logical values, text, or error values in the array or reference are ignored.
 * @returns
 */ function $d551340dd0bc6b22$export$39ba90e9124b524f() {
    const args = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(arguments));
    if (args instanceof Error) return args;
    // Lookup rate
    const rate = args[0];
    // Initialize net present value
    let value = 0;
    // Loop on all values
    for(let j = 1; j < args.length; j++)value += args[j] / Math.pow(1 + rate, j);
    // Return net present value
    return value;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the price per $100 face value of a security with an odd first period.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} issue The security's issue date.
 * @param {*} first_coupon The security's first coupon date.
 * @param {*} rate The security's interest rate.
 * @param {*} yld The security's annual yield.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$3681729390d233b7() {
    throw new Error("ODDFPRICE is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the yield of a security with an odd first period.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} issue The security's issue date.
 * @param {*} first_coupon The security's first coupon date.
 * @param {*} rate The security's interest rate.
 * @param {*} pr The security's price.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$37e7b13394d43765() {
    throw new Error("ODDFYIELD is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the price per $100 face value of a security with an odd last period.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} last_interest The security's last coupon date.
 * @param {*} rate The security's interest rate.
 * @param {*} yld The security's annual yield.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$c769cc4381ca7dcb() {
    throw new Error("ODDLPRICE is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the yield of a security with an odd last period.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} last_interest The security's last coupon date.
 * @param {*} rate The security's interest rate
 * @param {*} pr The security's price.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$99d22f8c2a60177c() {
    throw new Error("ODDLYIELD is not implemented");
}
/**
 * Returns the number of periods required by an investment to reach a specified value.
 *
 * Category: Financial
 *
 * @param {*} rate Rate is the interest rate per period.
 * @param {*} pv Pv is the present value of the investment.
 * @param {*} fv Fv is the desired future value of the investment.
 * @returns
 */ function $d551340dd0bc6b22$export$be647f34ee179222(rate, pv, fv) {
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    if ($d551340dd0bc6b22$var$anyIsError(rate, pv, fv)) return $d551340dd0bc6b22$var$value;
    // Return error if rate <=0
    if (rate <= 0) return $d551340dd0bc6b22$var$num;
    // Return number of periods
    return (Math.log(fv) - Math.log(pv)) / Math.log(1 + rate);
}
/**
 * Returns the periodic payment for an annuity.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate for the loan.
 * @param {*} nper The total number of payments for the loan.
 * @param {*} pv The present value, or the total amount that a series of future payments is worth now; also known as the principal.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (zero), that is, the future value of a loan is 0.
 * @param {*} type Optional. The number 0 (zero) or 1 and indicates when payments are due.
 * @returns
 */ function $d551340dd0bc6b22$export$57281459c9c05a49(rate, nper, pv, fv, type) {
    // Credits: algorithm inspired by Apache OpenOffice
    fv = fv || 0;
    type = type || 0;
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    if ($d551340dd0bc6b22$var$anyIsError(rate, nper, pv, fv, type)) return $d551340dd0bc6b22$var$value;
    // Return payment
    let result;
    if (rate === 0) result = (pv + fv) / nper;
    else {
        const term = Math.pow(1 + rate, nper);
        result = type === 1 ? (fv * rate / (term - 1) + pv * rate / (1 - 1 / term)) / (1 + rate) : fv * rate / (term - 1) + pv * rate / (1 - 1 / term);
    }
    return -result;
}
/**
 * Returns the payment on the principal for an investment for a given period.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate per period.
 * @param {*} per Specifies the period and must be in the range 1 to nper.
 * @param {*} nper The total number of payment periods in an annuity.
 * @param {*} pv The present value — the total amount that a series of future payments is worth now.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (zero), that is, the future value of a loan is 0.
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due.
 * @returns
 */ function $d551340dd0bc6b22$export$738ea20bb0da5e5e(rate, per, nper, pv, fv, type) {
    fv = fv || 0;
    type = type || 0;
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    if ($d551340dd0bc6b22$var$anyIsError(rate, nper, pv, fv, type)) return $d551340dd0bc6b22$var$value;
    return $d551340dd0bc6b22$export$57281459c9c05a49(rate, nper, pv, fv, type) - $d551340dd0bc6b22$export$60d0f5ab72a44b8b(rate, per, nper, pv, fv, type);
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the price per $100 face value of a security that pays periodic interest.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} rate The security's annual coupon rate.
 * @param {*} yld The security's annual yield.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$9ae64641f60b8192() {
    throw new Error("PRICE is not implemented");
}
/**
 * Returns the price per $100 face value of a discounted security.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} discount The security's discount rate.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$ec3956fa37eba432(settlement, maturity, discount, redemption, basis) {
    settlement = $d551340dd0bc6b22$var$parseDate(settlement);
    maturity = $d551340dd0bc6b22$var$parseDate(maturity);
    discount = $d551340dd0bc6b22$var$parseNumber(discount);
    redemption = $d551340dd0bc6b22$var$parseNumber(redemption);
    basis = $d551340dd0bc6b22$var$parseNumber(basis);
    basis = basis || 0;
    if ($d551340dd0bc6b22$var$anyIsError(settlement, maturity, discount, redemption, basis)) return $d551340dd0bc6b22$var$value;
    if (discount <= 0 || redemption <= 0) return $d551340dd0bc6b22$var$num;
    if (settlement >= maturity) return $d551340dd0bc6b22$var$value;
    let basisVal, diff;
    switch(basis){
        case 0:
            basisVal = 360;
            diff = $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, false);
            break;
        case 1:
            basisVal = 365;
            diff = $d551340dd0bc6b22$export$6f5ad06e6a29fbac(settlement, maturity, "D");
            break;
        case 2:
            basisVal = 360;
            diff = $d551340dd0bc6b22$export$6f5ad06e6a29fbac(settlement, maturity, "D");
            break;
        case 3:
            basisVal = 365;
            diff = $d551340dd0bc6b22$export$6f5ad06e6a29fbac(settlement, maturity, "D");
            break;
        case 4:
            basisVal = 360;
            diff = $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, true);
            break;
        default:
            return $d551340dd0bc6b22$var$num;
    }
    return redemption - discount * redemption * diff / basisVal;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the price per $100 face value of a security that pays interest at maturity.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} issue The security's issue date, expressed as a serial date number.
 * @param {*} rate The security's interest rate at date of issue.
 * @param {*} yld The security's annual yield.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$27bacd2b7c9baee1() {
    throw new Error("PRICEMAT is not implemented");
}
/**
 * Returns the present value of an investment.
 *
 * Category: Financial
 *
 * @param {*} rate The interest rate per period. For example, if you obtain an automobile loan at a 10 percent annual interest rate and make monthly payments, your interest rate per month is 10%/12, or 0.83%. You would enter 10%/12, or 0.83%, or 0.0083, into the formula as the rate.
 * @param {*} nper The total number of payment periods in an annuity. For example, if you get a four-year car loan and make monthly payments, your loan has 4*12 (or 48) periods. You would enter 48 into the formula for nper.
 * @param {*} pmt The payment made each period and cannot change over the life of the annuity. Typically, pmt includes principal and interest but no other fees or taxes. For example, the monthly payments on a $10,000, four-year car loan at 12 percent are $263.33. You would enter -263.33 into the formula as the pmt. If pmt is omitted, you must include the fv argument.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (the future value of a loan, for example, is 0). For example, if you want to save $50,000 to pay for a special project in 18 years, then $50,000 is the future value. You could then make a conservative guess at an interest rate and determine how much you must save each month. If fv is omitted, you must include the pmt argument.
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due.
 * @returns
 */ function $d551340dd0bc6b22$export$28696ec05f36becc(rate, per, pmt, fv, type) {
    fv = fv || 0;
    type = type || 0;
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    per = $d551340dd0bc6b22$var$parseNumber(per);
    pmt = $d551340dd0bc6b22$var$parseNumber(pmt);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    if ($d551340dd0bc6b22$var$anyIsError(rate, per, pmt, fv, type)) return $d551340dd0bc6b22$var$value;
    // Return present value
    return rate === 0 ? -pmt * per - fv : ((1 - Math.pow(1 + rate, per)) / rate * pmt * (1 + rate * type) - fv) / Math.pow(1 + rate, per);
}
/**
 * Returns the interest rate per period of an annuity.
 *
 * Category: Financial
 *
 * @param {*} nper The total number of payment periods in an annuity.
 * @param {*} pmt The payment made each period and cannot change over the life of the annuity. Typically, pmt includes principal and interest but no other fees or taxes. If pmt is omitted, you must include the fv argument.
 * @param {*} pv The present value — the total amount that a series of future payments is worth now.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (the future value of a loan, for example, is 0). If fv is omitted, you must include the pmt argument.
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due.
 * @param {*} guess Optional. Your guess for what the rate will be. If you omit guess, it is assumed to be 10 percent. If RATE does not converge, try different values for guess. RATE usually converges if guess is between 0 and 1.
 - If you omit guess, it is assumed to be 10 percent.
 - If RATE does not converge, try different values for guess. RATE usually converges if guess is between 0 and 1.
 * @returns
 */ function $d551340dd0bc6b22$export$9bed8ce5eac631df(nper, pmt, pv, fv, type, guess) {
    guess = guess === undefined ? 0.01 : guess;
    fv = fv === undefined ? 0 : fv;
    type = type === undefined ? 0 : type;
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pmt = $d551340dd0bc6b22$var$parseNumber(pmt);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    type = $d551340dd0bc6b22$var$parseNumber(type);
    guess = $d551340dd0bc6b22$var$parseNumber(guess);
    if ($d551340dd0bc6b22$var$anyIsError(nper, pmt, pv, fv, type, guess)) return $d551340dd0bc6b22$var$value;
    const epsMax = 1e-10;
    const iterMax = 20;
    let rate = guess;
    type = type ? 1 : 0;
    for(let i = 0; i < iterMax; i++){
        if (rate <= -1) return $d551340dd0bc6b22$var$num;
        let y, f;
        if (Math.abs(rate) < epsMax) y = pv * (1 + nper * rate) + pmt * (1 + rate * type) * nper + fv;
        else {
            f = Math.pow(1 + rate, nper);
            y = pv * f + pmt * (1 / rate + type) * (f - 1) + fv;
        }
        if (Math.abs(y) < epsMax) return rate;
        let dy;
        if (Math.abs(rate) < epsMax) dy = pv * nper + pmt * type * nper;
        else {
            f = Math.pow(1 + rate, nper);
            const df = nper * Math.pow(1 + rate, nper - 1);
            dy = pv * df + pmt * (1 / rate + type) * df + pmt * (-1 / (rate * rate)) * (f - 1);
        }
        rate -= y / dy;
    }
    return rate;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the amount received at maturity for a fully invested security.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} investment The amount invested in the security.
 * @param {*} discount The security's discount rate.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$67d3fe90edbf2534() {
    throw new Error("RECEIVED is not implemented");
}
/**
 * Returns an equivalent interest rate for the growth of an investment.
 *
 * Category: Financial
 *
 * @param {*} nper Nper is the number of periods for the investment.
 * @param {*} pv Pv is the present value of the investment.
 * @param {*} fv Fv is the future value of the investment.
 * @returns
 */ function $d551340dd0bc6b22$export$aabc2a21320198eb(nper, pv, fv) {
    nper = $d551340dd0bc6b22$var$parseNumber(nper);
    pv = $d551340dd0bc6b22$var$parseNumber(pv);
    fv = $d551340dd0bc6b22$var$parseNumber(fv);
    if ($d551340dd0bc6b22$var$anyIsError(nper, pv, fv)) return $d551340dd0bc6b22$var$value;
    // Return error if nper or present is equal to 0 (zero)
    if (nper === 0 || pv === 0) return $d551340dd0bc6b22$var$num;
    // Return equivalent interest rate
    return Math.pow(fv / pv, 1 / nper) - 1;
}
/**
 * Returns the straight-line depreciation of an asset for one period.
 *
 * Category: Financial
 *
 * @param {*} cost The initial cost of the asset.
 * @param {*} salvage The value at the end of the depreciation (sometimes called the salvage value of the asset).
 * @param {*} life The number of periods over which the asset is depreciated (sometimes called the useful life of the asset).
 * @returns
 */ function $d551340dd0bc6b22$export$4fcd0eda4cbba23(cost, salvage, life) {
    cost = $d551340dd0bc6b22$var$parseNumber(cost);
    salvage = $d551340dd0bc6b22$var$parseNumber(salvage);
    life = $d551340dd0bc6b22$var$parseNumber(life);
    if ($d551340dd0bc6b22$var$anyIsError(cost, salvage, life)) return $d551340dd0bc6b22$var$value;
    // Return error if life equal to 0 (zero)
    if (life === 0) return $d551340dd0bc6b22$var$num;
    // Return straight-line depreciation
    return (cost - salvage) / life;
}
/**
 * Returns the sum-of-years' digits depreciation of an asset for a specified period.
 *
 * Category: Financial
 *
 * @param {*} cost The initial cost of the asset.
 * @param {*} salvage The value at the end of the depreciation (sometimes called the salvage value of the asset).
 * @param {*} life The number of periods over which the asset is depreciated (sometimes called the useful life of the asset).
 * @param {*} per The period and must use the same units as life.
 * @returns
 */ function $d551340dd0bc6b22$export$16db5d1d1061102f(cost, salvage, life, per) {
    // Return error if any of the parameters is not a number
    cost = $d551340dd0bc6b22$var$parseNumber(cost);
    salvage = $d551340dd0bc6b22$var$parseNumber(salvage);
    life = $d551340dd0bc6b22$var$parseNumber(life);
    per = $d551340dd0bc6b22$var$parseNumber(per);
    if ($d551340dd0bc6b22$var$anyIsError(cost, salvage, life, per)) return $d551340dd0bc6b22$var$value;
    // Return error if life equal to 0 (zero)
    if (life === 0) return $d551340dd0bc6b22$var$num;
    // Return error if period is lower than 1 or greater than life
    if (per < 1 || per > life) return $d551340dd0bc6b22$var$num;
    // Truncate period if it is not an integer
    per = parseInt(per, 10);
    // Return straight-line depreciation
    return (cost - salvage) * (life - per + 1) * 2 / (life * (life + 1));
}
/**
 * Returns the bond-equivalent yield for a Treasury bill.
 *
 * Category: Financial
 *
 * @param {*} settlement The Treasury bill's settlement date. The security settlement date is the date after the issue date when the Treasury bill is traded to the buyer.
 * @param {*} maturity The Treasury bill's maturity date. The maturity date is the date when the Treasury bill expires.
 * @param {*} discount The Treasury bill's discount rate.
 * @returns
 */ function $d551340dd0bc6b22$export$4456e4a8edf0d90f(settlement, maturity, discount) {
    settlement = $d551340dd0bc6b22$var$parseDate(settlement);
    maturity = $d551340dd0bc6b22$var$parseDate(maturity);
    discount = $d551340dd0bc6b22$var$parseNumber(discount);
    if ($d551340dd0bc6b22$var$anyIsError(settlement, maturity, discount)) return $d551340dd0bc6b22$var$value;
    // Return error if discount is lower than or equal to zero
    if (discount <= 0) return $d551340dd0bc6b22$var$num;
    // Return error if settlement is greater than maturity
    if (settlement > maturity) return $d551340dd0bc6b22$var$num;
    // Return error if maturity is more than one year after settlement
    if (maturity - settlement > 31536000000) return $d551340dd0bc6b22$var$num;
    // Return bond-equivalent yield
    return 365 * discount / (360 - discount * $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, false));
}
/**
 * Returns the price per $100 face value for a Treasury bill.
 *
 * Category: Financial
 *
 * @param {*} settlement The Treasury bill's settlement date. The security settlement date is the date after the issue date when the Treasury bill is traded to the buyer.
 * @param {*} maturity The Treasury bill's maturity date. The maturity date is the date when the Treasury bill expires.
 * @param {*} discount The Treasury bill's discount rate.
 * @returns
 */ function $d551340dd0bc6b22$export$b743c1bda609b4a9(settlement, maturity, discount) {
    settlement = $d551340dd0bc6b22$var$parseDate(settlement);
    maturity = $d551340dd0bc6b22$var$parseDate(maturity);
    discount = $d551340dd0bc6b22$var$parseNumber(discount);
    if ($d551340dd0bc6b22$var$anyIsError(settlement, maturity, discount)) return $d551340dd0bc6b22$var$value;
    // Return error if discount is lower than or equal to zero
    if (discount <= 0) return $d551340dd0bc6b22$var$num;
    // Return error if settlement is greater than maturity
    if (settlement > maturity) return $d551340dd0bc6b22$var$num;
    // Return error if maturity is more than one year after settlement
    if (maturity - settlement > 31536000000) return $d551340dd0bc6b22$var$num;
    // Return bond-equivalent yield
    return 100 * (1 - discount * $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, false) / 360);
}
/**
 * Returns the yield for a Treasury bill.
 *
 * Category: Financial
 *
 * @param {*} settlement The Treasury bill's settlement date. The security settlement date is the date after the issue date when the Treasury bill is traded to the buyer.
 * @param {*} maturity The Treasury bill's maturity date. The maturity date is the date when the Treasury bill expires.
 * @param {*} pr The Treasury bill's price per $100 face value.
 * @returns
 */ function $d551340dd0bc6b22$export$eb29a9ff23ca2e16(settlement, maturity, pr) {
    settlement = $d551340dd0bc6b22$var$parseDate(settlement);
    maturity = $d551340dd0bc6b22$var$parseDate(maturity);
    pr = $d551340dd0bc6b22$var$parseNumber(pr);
    if ($d551340dd0bc6b22$var$anyIsError(settlement, maturity, pr)) return $d551340dd0bc6b22$var$value;
    // Return error if price is lower than or equal to zero
    if (pr <= 0) return $d551340dd0bc6b22$var$num;
    // Return error if settlement is greater than maturity
    if (settlement > maturity) return $d551340dd0bc6b22$var$num;
    // Return error if maturity is more than one year after settlement
    if (maturity - settlement > 31536000000) return $d551340dd0bc6b22$var$num;
    // Return bond-equivalent yield
    return (100 - pr) * 360 / (pr * $d551340dd0bc6b22$export$4c238f3198b1a02b(settlement, maturity, false));
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the depreciation of an asset for a specified or partial period by using a declining balance method.
 *
 * Category: Financial
 *
 * @param {*} cost The initial cost of the asset.
 * @param {*} salvage The value at the end of the depreciation (sometimes called the salvage value of the asset). This value can be 0.
 * @param {*} life The number of periods over which the asset is depreciated (sometimes called the useful life of the asset).
 * @param {*} start_period The starting period for which you want to calculate the depreciation. Start_period must use the same units as life.
 * @param {*} end_period The ending period for which you want to calculate the depreciation. End_period must use the same units as life.
 * @param {*} factor Optional. The rate at which the balance declines. If factor is omitted, it is assumed to be 2 (the double-declining balance method). Change factor if you do not want to use the double-declining balance method. For a description of the double-declining balance method, see DDB.
 * @param {*} no_switch Optional. A logical value specifying whether to switch to straight-line depreciation when depreciation is greater than the declining balance calculation.
 - If no_switch is TRUE, Microsoft Excel does not switch to straight-line depreciation even when the depreciation is greater than the declining balance calculation.
 - If no_switch is FALSE or omitted, Excel switches to straight-line depreciation when depreciation is greater than the declining balance calculation.
 * @returns
 */ function $d551340dd0bc6b22$export$3560c8e5f2ddae5e() {
    throw new Error("VDB is not implemented");
}
/**
 * Returns the internal rate of return for a schedule of cash flows that is not necessarily periodic.
 *
 * Category: Financial
 *
 * @param {*} values A series of cash flows that corresponds to a schedule of payments in dates. The first payment is optional and corresponds to a cost or payment that occurs at the beginning of the investment. If the first value is a cost or payment, it must be a negative value. All succeeding payments are discounted based on a 365-day year. The series of values must contain at least one positive and one negative value.
 * @param {*} dates A schedule of payment dates that corresponds to the cash flow payments. Dates may occur in any order. Dates should be entered by using the DATE function, or as results of other formulas or functions. For example, use DATE(2008,5,23) for the 23rd day of May, 2008. Problems can occur if dates are entered as text. .
 * @param {*} guess Optional. A number that you guess is close to the result of XIRR.
 * @returns
 */ function $d551340dd0bc6b22$export$e1abef9a5d16b70d(values, dates, guess) {
    // Credits: algorithm inspired by Apache OpenOffice
    values = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(values));
    dates = $d551340dd0bc6b22$var$parseDateArray($d551340dd0bc6b22$var$flatten(dates));
    guess = $d551340dd0bc6b22$var$parseNumber(guess);
    if ($d551340dd0bc6b22$var$anyIsError(values, dates, guess)) return $d551340dd0bc6b22$var$value;
    // Calculates the resulting amount
    const irrResult = (values, dates, rate)=>{
        const r = rate + 1;
        let result = values[0];
        for(let i = 1; i < values.length; i++)result += values[i] / Math.pow(r, $d551340dd0bc6b22$export$b387b66963374517(dates[i], dates[0]) / 365);
        return result;
    };
    // Calculates the first derivation
    const irrResultDeriv = (values, dates, rate)=>{
        const r = rate + 1;
        let result = 0;
        for(let i = 1; i < values.length; i++){
            const frac = $d551340dd0bc6b22$export$b387b66963374517(dates[i], dates[0]) / 365;
            result -= frac * values[i] / Math.pow(r, frac + 1);
        }
        return result;
    };
    // Check that values contains at least one positive value and one negative value
    let positive = false;
    let negative = false;
    for(let i = 0; i < values.length; i++){
        if (values[i] > 0) positive = true;
        if (values[i] < 0) negative = true;
    }
    // Return error if values does not contain at least one positive value and one negative value
    if (!positive || !negative) return $d551340dd0bc6b22$var$num;
    // Initialize guess and resultRate
    guess = guess || 0.1;
    let resultRate = guess;
    // Set maximum epsilon for end of iteration
    const epsMax = 1e-10;
    // Implement Newton's method
    let newRate, epsRate, resultValue;
    let contLoop = true;
    do {
        resultValue = irrResult(values, dates, resultRate);
        newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate);
        epsRate = Math.abs(newRate - resultRate);
        resultRate = newRate;
        contLoop = epsRate > epsMax && Math.abs(resultValue) > epsMax;
    }while (contLoop);
    // Return internal rate of return
    return resultRate;
}
/**
 * Returns the net present value for a schedule of cash flows that is not necessarily periodic.
 *
 * Category: Financial
 *
 * @param {*} rate The discount rate to apply to the cash flows.
 * @param {*} values A series of cash flows that corresponds to a schedule of payments in dates. The first payment is optional and corresponds to a cost or payment that occurs at the beginning of the investment. If the first value is a cost or payment, it must be a negative value. All succeeding payments are discounted based on a 365-day year. The series of values must contain at least one positive value and one negative value.
 * @param {*} dates A schedule of payment dates that corresponds to the cash flow payments. The first payment date indicates the beginning of the schedule of payments. All other dates must be later than this date, but they may occur in any order.
 * @returns
 */ function $d551340dd0bc6b22$export$931e6356776c4bb(rate, values, dates) {
    rate = $d551340dd0bc6b22$var$parseNumber(rate);
    values = $d551340dd0bc6b22$var$parseNumberArray($d551340dd0bc6b22$var$flatten(values));
    dates = $d551340dd0bc6b22$var$parseDateArray($d551340dd0bc6b22$var$flatten(dates));
    if ($d551340dd0bc6b22$var$anyIsError(rate, values, dates)) return $d551340dd0bc6b22$var$value;
    let result = 0;
    for(let i = 0; i < values.length; i++)result += values[i] / Math.pow(1 + rate, $d551340dd0bc6b22$export$b387b66963374517(dates[i], dates[0]) / 365);
    return result;
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the yield on a security that pays periodic interest.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} rate The security's annual coupon rate.
 * @param {*} pr The security's price per $100 face value.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} frequency The number of coupon payments per year. For annual payments, frequency = 1; for semiannual, frequency = 2; for quarterly, frequency = 4.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$517303f73652ea8c() {
    throw new Error("YIELD is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the annual yield for a discounted security; for example, a Treasury bill.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} pr The security's price per $100 face value.
 * @param {*} redemption The security's redemption value per $100 face value.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$912ca7f764dee059() {
    throw new Error("YIELDDISC is not implemented");
}
// TODO
/**
 * -- Not implemented --
 *
 * Returns the annual yield of a security that pays interest at maturity.
 *
 * Category: Financial
 *
 * @param {*} settlement The security's settlement date. The security settlement date is the date after the issue date when the security is traded to the buyer.
 * @param {*} maturity The security's maturity date. The maturity date is the date when the security expires.
 * @param {*} issue The security's issue date, expressed as a serial date number.
 * @param {*} rate The security's interest rate at date of issue.
 * @param {*} pr The security's price per $100 face value.
 * @param {*} basis Optional. The type of day count basis to use.
 * @returns
 */ function $d551340dd0bc6b22$export$289f491c280c7a1c() {
    throw new Error("YIELDMAT is not implemented");
}
/**
 * Returns TRUE if all of its arguments are TRUE.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$327bc6c39753a713() {
    const args = $d551340dd0bc6b22$var$flatten(arguments);
    let result = $d551340dd0bc6b22$var$value;
    for(let i = 0; i < args.length; i++){
        if (args[i] instanceof Error) return args[i];
        if (args[i] === undefined || args[i] === null || typeof args[i] === "string") continue;
        if (result === $d551340dd0bc6b22$var$value) result = true;
        if (!args[i]) result = false;
    }
    return result;
}
/**
 * Returns the logical value FALSE.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$8f11cee4bdc7e668() {
    return false;
}
/**
 * Specifies a logical test to perform.
 *
 * Category: Logical
 *
 * @param {*} logical_test
 * @param {*} value_if_true
 * @param {*} value_if_false
 *
 * @returns
 */ function $d551340dd0bc6b22$export$5749f35ae68e5477(logical_test, value_if_true, value_if_false) {
    if (logical_test instanceof Error) return logical_test;
    value_if_true = arguments.length >= 2 ? value_if_true : true;
    if (value_if_true === undefined || value_if_true === null) value_if_true = 0;
    value_if_false = arguments.length === 3 ? value_if_false : false;
    if (value_if_false === undefined || value_if_false === null) value_if_false = 0;
    return logical_test ? value_if_true : value_if_false;
}
/**
 * Checks whether one or more conditions are met and returns a value that corresponds to the first TRUE condition.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$351547f5c835becb() {
    for(let i = 0; i < arguments.length / 2; i++){
        if (arguments[i * 2]) return arguments[i * 2 + 1];
    }
    return $d551340dd0bc6b22$var$na;
}
/**
 * Returns a value you specify if a formula evaluates to an error; otherwise, returns the result of the formula.
 *
 * Category: Logical
 *
 * @param {*} value The argument that is checked for an error.
 * @param {*} value_if_error The value to return if the formula evaluates to an error. The following error types are evaluated: #N/A, #VALUE!, #REF!, #DIV/0!, #NUM!, #NAME?, or #NULL!.
 * @returns
 */ function $d551340dd0bc6b22$export$b2bc018eb0c46c7b(value, value_if_error) {
    if ($d551340dd0bc6b22$export$e3e8e7d5009c248(value)) return value_if_error;
    return value;
}
/**
 * Returns the value you specify if the expression resolves to #N/A, otherwise returns the result of the expression.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$ed4e98f3e064db68(value, value_if_na) {
    return value === $d551340dd0bc6b22$var$na ? value_if_na : value;
}
/**
 * Reverses the logic of its argument.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$9cbadbd232c00d79(logical) {
    if (typeof logical === "string") return $d551340dd0bc6b22$var$value;
    if (logical instanceof Error) return logical;
    return !logical;
}
/**
 * Returns TRUE if any argument is TRUE.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$1e4611b5e967c90() {
    const args = $d551340dd0bc6b22$var$flatten(arguments);
    let result = $d551340dd0bc6b22$var$value;
    for(let i = 0; i < args.length; i++){
        if (args[i] instanceof Error) return args[i];
        if (args[i] === undefined || args[i] === null || typeof args[i] === "string") continue;
        if (result === $d551340dd0bc6b22$var$value) result = false;
        if (args[i]) result = true;
    }
    return result;
}
/**
 * Returns the logical value TRUE.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$22e23a2304399231() {
    return true;
}
/**
 * Returns a logical exclusive OR of all arguments.
 *
 * Category: Logical
 *
 * @param {*} args logical1, logical2,… Logical 1 is required, subsequent logical values are optional. 1 to 254 conditions you want to test that can be either TRUE or FALSE, and can be logical values, arrays, or references.
 * @returns
 */ function $d551340dd0bc6b22$export$3ac756b6844bf082() {
    const args = $d551340dd0bc6b22$var$flatten(arguments);
    let result = $d551340dd0bc6b22$var$value;
    for(let i = 0; i < args.length; i++){
        if (args[i] instanceof Error) return args[i];
        if (args[i] === undefined || args[i] === null || typeof args[i] === "string") continue;
        if (result === $d551340dd0bc6b22$var$value) result = 0;
        if (args[i]) result++;
    }
    if (result === $d551340dd0bc6b22$var$value) return result;
    return !!(Math.floor(Math.abs(result)) & 1);
}
/**
 * Evaluates an expression against a list of values and returns the result corresponding to the first matching value. If there is no match, an optional default value may be returned.
 *
 * Category: Logical
 *
 * @returns
 */ function $d551340dd0bc6b22$export$d19595eff304150b() {
    let result;
    if (arguments.length > 0) {
        const targetValue = arguments[0];
        const argc = arguments.length - 1;
        const switchCount = Math.floor(argc / 2);
        let switchSatisfied = false;
        const hasDefaultClause = argc % 2 !== 0;
        const defaultClause = argc % 2 === 0 ? null : arguments[arguments.length - 1];
        if (switchCount) {
            for(let index = 0; index < switchCount; index++)if (targetValue === arguments[index * 2 + 1]) {
                result = arguments[index * 2 + 2];
                switchSatisfied = true;
                break;
            }
        }
        if (!switchSatisfied) result = hasDefaultClause ? defaultClause : $d551340dd0bc6b22$var$na;
    } else result = $d551340dd0bc6b22$var$value;
    return result;
}
const $d551340dd0bc6b22$export$eab97d15b1788b8d = {
    errors: $d551340dd0bc6b22$var$errors,
    symbols: $d551340dd0bc6b22$var$symbols
};


/* eslint-disable no-loop-func */ /** This package is a wrapper around @jspreadsheet/formula package, which - due to its usage of eval()
 *  poses a security risk.
 */ // eslint-disable-next-line import/no-unresolved

function $23b6655120dc4dac$export$b4dd51674f25c746(expression) {
    if (!expression || Object.keys(expression).length === 0) return null;
    // Remove spaces for consistency
    // expression = expression.replace(/\s+/g, '');
    // First, split the expression into tokens (numbers and operators)
    // Note: We use a regex pattern that respects the ** operator
    const tokens = expression.match(RegExp("(?<!\\d)-?\\d+(\\.\\d+)?|(\\*\\*)|[+*/-]", "g")).filter(Boolean);
    // Step 1: Handle ** (exponentiation)
    let i = 0;
    while(i < tokens.length)if (tokens[i] === "**") {
        const base = parseFloat(tokens[i - 1]);
        const exponent = parseFloat(tokens[i + 1]);
        // Perform exponentiation
        const result = base ** exponent;
        // Replace base, operator, and exponent with the result
        tokens.splice(i - 1, 3, result.toString());
        // Move index back since we reduced the array size
        i -= 1;
    } else i += 1;
    // Step 2: Handle * and /
    i = 0;
    while(i < tokens.length)if (tokens[i] === "*" || tokens[i] === "/") {
        const operator = tokens[i];
        const prevNumber = parseFloat(tokens[i - 1]);
        const nextNumber = parseFloat(tokens[i + 1]);
        // Perform multiplication or division
        const result = operator === "*" ? prevNumber * nextNumber : prevNumber / nextNumber;
        // Replace previous number, operator, and next number with the result
        tokens.splice(i - 1, 3, result.toString());
        // Move index back since we reduced the array size
        i -= 1;
    } else i += 1;
    // Step 3: Handle + and -
    i = 0;
    while(i < tokens.length)if (tokens[i] === "+" || tokens[i] === "-") {
        const operator = tokens[i];
        const prevNumber = parseFloat(tokens[i - 1]);
        const nextNumber = parseFloat(tokens[i + 1]);
        // Perform addition or subtraction
        const result = operator === "+" ? prevNumber + nextNumber : prevNumber - nextNumber;
        // Replace previous number, operator, and next number with the result
        tokens.splice(i - 1, 3, result.toString());
        // Move index back since we reduced the array size
        i -= 1;
    } else i += 1;
    // The final result will be the only remaining item in the tokens array
    return parseFloat(tokens[0]);
}
function $23b6655120dc4dac$export$552e796384b4dc4d(functionName, bracketContent) {
    // parse the arguments
    // run it through resolveExpression in case this isn't a number, but an expression
    const args = bracketContent.split(",").map((arg)=>$23b6655120dc4dac$export$b4dd51674f25c746(arg));
    try {
        return $d551340dd0bc6b22$exports[functionName.toUpperCase()](...args);
    } catch (error) {
        throw new Error(`resolveFunction: Function ${functionName} not found in formulajs`);
    }
}
function $23b6655120dc4dac$export$3191fa0ae67b450c(expression, variables = {}) {
    // console.log('evaluateExpression started with', expression, variables);
    // Step 1: Check for balanced parentheses
    const openBrackets = (String(expression).match(/\(/g) || []).length;
    const closeBrackets = (String(expression).match(/\)/g) || []).length;
    if (openBrackets !== closeBrackets) throw new Error("jspreadsheetFormulaEvaluator > evaluateExpression: Error: Unbalanced parentheses in expression");
    // replace all cell references with their values
    const expressionNoCellRefs = expression.replace(/[A-Za-z]{1,2}\d{1,3}/g, (cellAddress)=>{
        // if the cell address is not in the variables, return the cell address
        if (!variables[cellAddress]) throw new Error(`evaluateFunction: Cell reference ${cellAddress} not found in variables`);
        return variables[cellAddress];
    });
    // Step 2: Copy expression to workingExpression
    let workingExpression = expressionNoCellRefs;
    // Step 3: Start loop
    // enter / continue the loop if expression isn't a number or NaN (which is also a kind of number)
    while(typeof workingExpression !== "number" && !Number.isNaN(workingExpression)){
        const innermostBrackets = [];
        // Step 4: Find innermost bracket sets
        // const regex = /\(([^()]+)\)/g; // Regex to find the innermost brackets
        const regex = /([A-Za-z]+\w*)?\(([^()]+)\)/g;
        const matchAllNestedBrackets = workingExpression.matchAll(regex);
        // matchAll returns a special kind of object, which needs to be mapped to an array before using
        const matchAllNestedBracketsArray = Array.from(matchAllNestedBrackets).map((match)=>({
                expression: match[0],
                capturedGroup: match[1],
                index: match.index
            }));
        // Iterate over the results
        matchAllNestedBracketsArray.forEach((match)=>{
            const startPos = match.index;
            const endPos = startPos + match.expression.length;
            // if there is a function ABC(...), then match.capturedGroup will be ABC)
            // otherwise it will be undefined
            const excelFunction = match.capturedGroup;
            // Store in innermostBrackets as { bracket, excelFunction, position, length }
            innermostBrackets.push({
                match: match,
                expression: match.expression,
                bracketContents: match.expression.match(/\(([^()]+)\)/)[1],
                excelFunction: excelFunction,
                position: startPos,
                length: endPos - startPos
            });
        });
        // if we detected no brackets and (since workingExpression was not a number in the beginning of this loop), this must be an expression
        if (innermostBrackets.length === 0) return $23b6655120dc4dac$export$b4dd51674f25c746(workingExpression);
        // Step 5: Pop and resolve innermost brackets
        while(innermostBrackets.length > 0){
            const { excelFunction: excelFunction, bracketContents: bracketContents, position: position, length: length } = innermostBrackets.pop(); // Pop the last innermost bracket set
            // Resolve the expression or function
            let resolvedValue;
            if (excelFunction) resolvedValue = $23b6655120dc4dac$export$552e796384b4dc4d(excelFunction, bracketContents, {});
            else resolvedValue = $23b6655120dc4dac$export$b4dd51674f25c746(bracketContents);
            // Replace the substring with the resolved value
            workingExpression = workingExpression.slice(0, position) + resolvedValue.toString() + workingExpression.slice(position + length);
        }
    }
    // Return the final resolved value
    return parseFloat(workingExpression);
}


(function(global1, factory) {
    $3ffd6794bf825759$exports = factory();
})($3ffd6794bf825759$exports, ()=>{
    const Formula = function(scope) {
        function getValue(obj, path) {
            const keys = path.split(".");
            let current = obj;
            for (const key of keys){
                if (current === undefined || current === null) return undefined;
                current = current[key];
            }
            return current;
        }
        for(let i = 0; i < Object.keys($d551340dd0bc6b22$exports).length; i++){
            const method = Object.keys($d551340dd0bc6b22$exports)[i];
            let keys = [];
            let values;
            if (typeof $d551340dd0bc6b22$exports[method] === "object") {
                keys = Object.keys($d551340dd0bc6b22$exports[method]);
                values = Object.values($d551340dd0bc6b22$exports[method]);
                for(let a = 0; a < values.length; a++)if (typeof values[a] === "object") {
                    const subMethod = keys[a];
                    if ($d551340dd0bc6b22$exports[method][subMethod]) {
                        keys = [
                            ...keys,
                            ...Object.keys($d551340dd0bc6b22$exports[method][subMethod]).map((a)=>`${subMethod}.${a}`)
                        ]; // Line too heavy, need refactor
                        keys.splice(keys.indexOf(subMethod), 1);
                    }
                }
            }
            if (keys.length < 1) scope[method] = $d551340dd0bc6b22$exports[method];
            else {
                for(let j = 0; j < keys.length; j++)if (typeof getValue($d551340dd0bc6b22$exports[method], keys[j]) === "function") scope[method] = getValue($d551340dd0bc6b22$exports[method], keys[j]);
            }
        }
        const parseNumber = function(number) {
            if (typeof number === "number") number = parseInt(number);
            return number;
        };
        /**
     * Instance execution helpers
     */ let x = null;
        let y = null;
        let instance = null;
        scope.TABLE = function() {
            return instance;
        };
        scope.COLUMN = scope.COL = function() {
            if (instance.tracking) instance.tracking.push(F.getColumnNameFromCoords(parseNumber(x), parseNumber(y)));
            return parseNumber(x) + 1;
        };
        scope.ROW = function() {
            if (instance.tracking) instance.tracking.push(F.getColumnNameFromCoords(parseNumber(x), parseNumber(y)));
            return parseNumber(y) + 1;
        };
        scope.CELL = function() {
            return F.getColumnNameFromCoords(x, y);
        };
        scope.VALUE = function(col, row, processed) {
            return instance.getValueFromCoords(parseNumber(col) - 1, parseNumber(row) - 1, processed);
        };
        scope.THISROWCELL = function(col) {
            return instance.getValueFromCoords(parseNumber(col) - 1, parseNumber(y));
        };
        // Secure formula
        const secureFormula = function(oldValue, runtime) {
            let newValue = "";
            let inside = 0;
            const special = [
                "=",
                "!",
                ">",
                "<"
            ];
            for(let i = 0; i < oldValue.length; i++){
                if (oldValue[i] === '"') {
                    if (inside === 0) inside = 1;
                    else inside = 0;
                }
                if (inside === 1) newValue += oldValue[i];
                else {
                    newValue += oldValue[i].toUpperCase();
                    if (runtime === true) {
                        if (i > 0 && oldValue[i] === "=" && special.indexOf(oldValue[i - 1]) === -1 && special.indexOf(oldValue[i + 1]) === -1) newValue += "=";
                    }
                }
            }
            // Adapt to JS
            newValue = newValue.replace(/\^/g, "**");
            newValue = newValue.replace(/<>/g, "!=");
            newValue = newValue.replace(/&/g, "+");
            newValue = newValue.replace(/\$/g, "");
            return newValue;
        };
        // Convert range tokens
        const tokensUpdate = function(tokens, e) {
            for(let index = 0; index < tokens.length; index++){
                const f = F.getTokensFromRange(tokens[index]);
                e = e.replace(tokens[index], `[${f.join(",")}]`);
            }
            return e;
        };
        const isNumeric = function(num) {
            if (typeof num === "string") num = num.trim();
            return !isNaN(num) && num !== null && num !== "";
        };
        /**
     * This function runs when a formula is entered in a cell.
     *
     * @param {string} expression: string entered after "=", e.g. E3+E4
     * @param {map} variables: map of variables in the formula e.g. {E3: 1, E4: 2}
     * @param {number} i: x coordinate of the cell
     * @param {number} j: y coordinate of the cell
     * @param {object} obj: jspreadsheet instance
     * @returns {number} result of the formula
     *
     */ const F = function(expression, variables, i, j, obj) {
            // console.log('F called', expression, variables, i, j, obj);
            // Global helpers
            instance = obj;
            x = i;
            y = j;
            // String
            let s = "";
            const parent = {};
            if (variables) {
                if (variables.size) {
                    let tokens = null;
                    let t;
                    variables.forEach((v, k)=>{
                        // Replace ! per dot
                        t = k.replace(/!/g, ".");
                        // Exists parent
                        if (t.indexOf(".") !== -1) {
                            t = t.split(".");
                            parent[t[0]] = true;
                        }
                    });
                    t = Object.keys(parent);
                    for(let i = 0; i < t.length; i++)s += `var ${t[i]} = {};`;
                    variables.forEach((v, k)=>{
                        // Replace ! per dot
                        t = k.replace(/!/g, ".");
                        if (v !== null && !isNumeric(v)) {
                            tokens = v.match(/(('.*?'!)|(\w*!))?(\$?[A-Z]+\$?[0-9]*):(\$?[A-Z]+\$?[0-9]*)?/g);
                            if (tokens && tokens.length) // eslint-disable-next-line no-undef
                            v = updateRanges(tokens, v);
                        }
                        if (t.indexOf(".") > 0) s += `${t} = ${variables.get(k)};\n`;
                        else s += `var ${t} = ${v};\n`;
                    });
                } else {
                    const keys = Object.keys(variables);
                    if (keys.length) {
                        const parent = {};
                        let t;
                        for(let i = 0; i < keys.length; i++){
                            // Replace ! per dot
                            t = keys[i].replace(/\!/g, ".");
                            // Exists parent
                            if (t.indexOf(".") > 0) {
                                const t = t.split(".");
                                parent[t[0]] = {};
                            }
                        }
                        t = Object.keys(parent);
                        for(let i = 0; i < t.length; i++)s += `var ${t[i]} = {};`;
                        for(let i = 0; i < keys.length; i++){
                            // Replace ! per dot
                            t = keys[i].replace(/!/g, ".");
                            // Update range
                            if (variables[keys[i]] !== null && !isNumeric(variables[keys[i]])) {
                                const tokens = variables[keys[i]].match(/(('.*?'!)|(\w*!))?(\$?[A-Z]+\$?[0-9]*):(\$?[A-Z]+\$?[0-9]*)?/g);
                                if (tokens && tokens.length) variables[keys[i]] = tokensUpdate(tokens, variables[keys[i]]);
                            }
                            if (t.indexOf(".") > 0) s += `${t} = ${variables[keys[i]]};\n`;
                            else s += `var ${t} = ${variables[keys[i]]};\n`;
                        }
                    }
                }
            }
            // Remove $
            expression = expression.replace(/\$/g, "");
            // Replace ! per dot
            expression = expression.replace(/!/g, ".");
            // Adapt to JS
            expression = secureFormula(expression, true);
            // Update range
            const tokens = expression.match(/(('.*?'!)|(\w*!))?(\$?[A-Z]+\$?[0-9]*):(\$?[A-Z]+\$?[0-9]*)?/g);
            if (tokens && tokens.length) expression = tokensUpdate(tokens, expression);
            // Calculate
            // ↓↓ the patch is replacing this line with createFunction below
            // let result = new Function(`${s}; return ${expression}`)();
            // this would return a function defined as { var E13 = 2345; var E14 = 234; return E13 + E14; }
            // s splits the used cells into variables (one variable per cell) 'var E13 = 2345; var E14 = 234;'
            // expression is the string 'E13 + E14'
            function resolveFunction(s, expression) {
                const variables = {};
                s.split(";").filter(Boolean).forEach((item)=>{
                    const [name, value] = item.trim().replace("var ", "").split(" = ");
                    variables[name] = Number(value);
                });
                // variables is a map { E13: 2345, E14: 234 }
                // 240907 PL: this is the previous version of the patch, which is not used anymore
                //   const [fn, args] = expression.split('('); // !!! this assumes that 'expression' always has one and only one '('
                //   const fnArgs = args
                //     .replace(')', '')
                //     .split(',')
                //     .map((a) => variables[a]);
                //   const functionMap = { SUM, AVERAGE };
                return function() {
                    return $23b6655120dc4dac$export$3191fa0ae67b450c(expression, variables);
                // previous version:
                //     return functionMap[fn](...fnArgs);
                };
            }
            const result = resolveFunction(s, expression)();
            return result;
        };
        /**
     * Get letter based on a number
     * @param {number} i
     * @return {string}
     */ const getColumnName = function(i) {
            let letter = "";
            if (i > 701) {
                letter += String.fromCharCode(64 + parseInt(i / 676));
                letter += String.fromCharCode(64 + parseInt(i % 676 / 26));
            } else if (i > 25) letter += String.fromCharCode(64 + parseInt(i / 26));
            letter += String.fromCharCode(65 + i % 26);
            return letter;
        };
        /**
     * Get column name from coords
     */ F.getColumnNameFromCoords = function(x, y) {
            return getColumnName(parseInt(x)) + (parseInt(y) + 1);
        };
        F.getCoordsFromColumnName = function(columnName) {
            // Get the letters
            const t = /^[a-zA-Z]+/.exec(columnName);
            if (t) {
                // Base 26 calculation
                let code = 0;
                for(let i = 0; i < t[0].length; i++)code += parseInt(t[0].charCodeAt(i) - 64) * 26 ** (t[0].length - 1 - i);
                code--;
                // Make sure jspreadsheet starts on zero
                if (code < 0) code = 0;
                // Number
                let number = parseInt(/[0-9]+$/.exec(columnName)) || null;
                if (number > 0) number--;
                return [
                    code,
                    number
                ];
            }
        };
        F.getRangeFromTokens = function(tokens) {
            tokens = tokens.filter((v)=>v != "#REF!");
            let d = "";
            let t = "";
            for(let i = 0; i < tokens.length; i++){
                if (tokens[i].indexOf(".") >= 0) d = ".";
                else if (tokens[i].indexOf("!") >= 0) d = "!";
                if (d) {
                    t = tokens[i].split(d);
                    tokens[i] = t[1];
                    t = t[0] + d;
                }
            }
            tokens.sort((a, b)=>{
                const t1 = Helpers.getCoordsFromColumnName(a);
                const t2 = Helpers.getCoordsFromColumnName(b);
                if (t1[1] > t2[1]) return 1;
                if (t1[1] < t2[1]) return -1;
                if (t1[0] > t2[0]) return 1;
                if (t1[0] < t2[0]) return -1;
                return 0;
            });
            if (!tokens.length) return "#REF!";
            return `${t}${tokens[0]}:${tokens[tokens.length - 1]}`;
        };
        F.getTokensFromRange = function(range) {
            if (range.indexOf(".") > 0) {
                var t = range.split(".");
                range = t[1];
                t = `${t[0]}.`;
            } else if (range.indexOf("!") > 0) {
                var t = range.split("!");
                range = t[1];
                t = `${t[0]}!`;
            } else var t = "";
            var range = range.split(":");
            const e1 = F.getCoordsFromColumnName(range[0]);
            const e2 = F.getCoordsFromColumnName(range[1]);
            if (e1[0] <= e2[0]) {
                var x1 = e1[0];
                var x2 = e2[0];
            } else {
                var x1 = e2[0];
                var x2 = e1[0];
            }
            if (e1[1] === null && e2[1] == null) {
                var y1 = null;
                var y2 = null;
                const k = Object.keys(vars);
                for(var i = 0; i < k.length; i++){
                    const tmp = F.getCoordsFromColumnName(k[i]);
                    if (tmp[0] === e1[0]) {
                        if (y1 === null || tmp[1] < y1) y1 = tmp[1];
                    }
                    if (tmp[0] === e2[0]) {
                        if (y2 === null || tmp[1] > y2) y2 = tmp[1];
                    }
                }
            } else if (e1[1] <= e2[1]) {
                var y1 = e1[1];
                var y2 = e2[1];
            } else {
                var y1 = e2[1];
                var y2 = e1[1];
            }
            const f = [];
            for(let j = y1; j <= y2; j++){
                const line = [];
                for(var i = x1; i <= x2; i++)line.push(t + F.getColumnNameFromCoords(i, j));
                f.push(line);
            }
            return f;
        };
        F.setFormula = function(o) {
            const k = Object.keys(o);
            for(let i = 0; i < k.length; i++)if (typeof o[k[i]] === "function") scope[k[i]] = o[k[i]];
        };
        F.basic = true;
        return F;
    };
    return Formula(typeof window === "undefined" ? $parcel$global : window);
});


function $09194143fe1e2820$export$2e2bcd8739ae039(expression, x, y, obj) {
    const jexcel = obj;
    const formulaResults = [];
    const formulaLoopProtection = [];
    // Execute formula with loop protection
    const execute = function execute(expression, x, y, jexcel) {
        // Parent column identification
        const parentId = jexcel.getColumnNameFromId([
            x,
            y
        ]);
        // Code protection
        if (formulaLoopProtection[parentId]) {
            console.error("Reference loop detected");
            return "#ERROR";
        }
        formulaLoopProtection[parentId] = true;
        // Convert range tokens
        const tokensUpdate = function tokensUpdate(tokens) {
            for(let index = 0; index < tokens.length; index++){
                const f = [];
                const token = tokens[index].split(":");
                const e1 = jexcel.getIdFromColumnName(token[0], true);
                const e2 = jexcel.getIdFromColumnName(token[1], true);
                if (e1[0] <= e2[0]) {
                    var x1 = e1[0];
                    var x2 = e2[0];
                } else {
                    var x1 = e2[0];
                    var x2 = e1[0];
                }
                if (e1[1] <= e2[1]) {
                    var y1 = e1[1];
                    var y2 = e2[1];
                } else {
                    var y1 = e2[1];
                    var y2 = e1[1];
                }
                for(let j = y1; j <= y2; j++)for(let i = x1; i <= x2; i++)f.push(jexcel.getColumnNameFromId([
                    i,
                    j
                ]));
                expression = expression.replace(tokens[index], f.join(","));
            }
        };
        // Range with $ remove $
        expression = expression.replace(/\$?([A-Z]+)\$?([0-9]+)/g, "$1$2");
        // eslint-disable-next-line no-useless-escape
        var tokens = expression.match(/([A-Z]+[0-9]+)\:([A-Z]+[0-9]+)/g);
        if (tokens && tokens.length) tokensUpdate(tokens);
        // Get tokens
        var tokens = expression.match(/([A-Z]+[0-9]+)/g);
        // Direct self-reference protection
        if (tokens && tokens.indexOf(parentId) > -1) {
            console.error("Self Reference detected");
            return "#ERROR";
        }
        // Expressions to be used in the parsing
        const formulaExpressions = {};
        if (tokens) for(let i = 0; i < tokens.length; i++){
            // Keep chain
            if (!obj.formula[tokens[i]]) obj.formula[tokens[i]] = [];
            // Is already in the register
            if (obj.formula[tokens[i]].indexOf(parentId) < 0) obj.formula[tokens[i]].push(parentId);
            // Do not calculate again
            // if (eval(`typeof(${tokens[i]}) == "undefined"`)) {
            if (!(tokens[i] in window)) {
                // Coords
                const position = jexcel.getIdFromColumnName(tokens[i], 1);
                // Get value
                if (typeof obj.options.data[position[1]] !== "undefined" && typeof obj.options.data[position[1]][position[0]] !== "undefined") var value = obj.options.data[position[1]][position[0]];
                else var value = "";
                // Get column data
                if (`${value}`.substr(0, 1) == "=") {
                    if (formulaResults[tokens[i]]) value = formulaResults[tokens[i]];
                    else {
                        value = execute(value, position[0], position[1]);
                        formulaResults[tokens[i]] = value;
                    }
                }
                // Type!
                if (`${value}`.trim() == "") // Null
                formulaExpressions[tokens[i]] = null;
                else if (value == Number(value) && obj.options.autoCasting == true) // Number
                formulaExpressions[tokens[i]] = Number(value);
                else {
                    // Trying any formatted number
                    const number = obj.parseNumber(value, position[0]);
                    if (obj.options.autoCasting == true && number) formulaExpressions[tokens[i]] = number;
                    else formulaExpressions[tokens[i]] = `"${value}"`;
                }
            }
        }
        // Convert formula to javascript
        try {
            // var res = jexcel.formula(expression.substr(1), formulaExpressions, x, y, obj);
            var res = $3ffd6794bf825759$exports(expression.substr(1), formulaExpressions, x, y, obj);
        } catch (e) {
            var res = "#ERROR";
            console.log(e);
        }
        return res;
    };
    return execute(expression, x, y, (0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))));
}


/* eslint-disable react/jsx-no-bind */ /* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





function $1ba1d905d07d5148$export$2e2bcd8739ae039({ currentRules: currentRules, callback: callback, callbackCancel: callbackCancel }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "filterDialog"
    });
    const { register: register, control: control, watch: watch, handleSubmit: handleSubmit, formState: { errors: errors } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: {
            rules: currentRules
        }
    });
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        control: control,
        name: "rules"
    });
    const rules = watch("rules");
    const args = [
        "greaterThan",
        "greaterThanOrEqual",
        "lessThan",
        "lessThanOrEqual",
        "equalTo",
        "blank"
    ];
    const verbs = [
        "is",
        "isNot",
        "contains",
        "doesNotContain",
        "startsWith",
        "doesNotStartWith",
        "endsWith",
        "doesNotEndWith"
    ];
    function handleSave(e) {
        handleSubmit((data)=>callback(data))();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative mx-auto rounded-lg px-4 text-left sm:my-8 align-bottom  sm:align-middle sm:p-6 bg-white shadow-xl sm:max-w-2xl",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-3 text-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Title, {
                            as: "h3",
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: t("filter")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-2 text-sm text-gray-500",
                            children: t("prompt")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mx-4 mt-6 space-y-2",
                children: [
                    fields.map((item, index)=>{
                        var _rules_index, _rules_index1, _errors_rules_index_val, _errors_rules_index, _errors_rules, _errors_rules_index_val1, _errors_rules_index1, _errors_rules1;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "grid grid-cols-[30%,30%,30%,10%] justify-items-stretch space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    control: control,
                                    name: `rules.${index}.verb`,
                                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
                                            as: "div",
                                            value: value,
                                            onChange: onChange,
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                                                    className: "w-full space-x-2 px-2.5 py-2 rounded-md border border-gray-300 hover:bg-gray-50 shadow-sm text-sm uppercase text-center",
                                                    children: ({ disabled: disabled })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: `block truncate ${disabled ? "text-gray-300" : ""}`,
                                                                    children: t(value)
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1205e1ea1e824e93$export$2e2bcd8739ae039), {
                                                                        "aria-hidden": "true",
                                                                        className: "h-5 w-5 text-gray-400"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                                                    className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg sm:text-sm",
                                                    children: verbs.map((verb)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                                            value: verb,
                                                            as: (0, $7fPBF.Fragment),
                                                            children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                                                    className: `group relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? "bg-brandBlue-500 text-white" : "text-gray-900"}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: `block truncate ${selected ? "font-semibold" : "font-normal"}`,
                                                                            children: t(verb)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: `absolute inset-y-0 right-0 flex items-center pr-4  ${selected ? active ? "block text-white" : "block text-brandBlue-500" : "hidden"}`,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $019bed45533ced54$export$2e2bcd8739ae039), {
                                                                                "aria-hidden": "true",
                                                                                className: "h-5 w-5"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        }, verb))
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                    control: control,
                                    name: `rules.${index}.arg`,
                                    render: ({ field: { onChange: onChange, value: value } })=>{
                                        var _rules_index;
                                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
                                            as: "div",
                                            value: value,
                                            onChange: onChange,
                                            disabled: ![
                                                "is",
                                                "isNot"
                                            ].includes((_rules_index = rules[index]) === null || _rules_index === void 0 ? void 0 : _rules_index.verb),
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                                                    className: "w-full space-x-2 px-2.5 py-2 rounded-md border border-gray-300 hover:bg-gray-50 shadow-sm text-sm uppercase text-center",
                                                    children: ({ disabled: disabled })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: `block truncate ${disabled ? "text-gray-300" : ""}`,
                                                                    children: t(value)
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1205e1ea1e824e93$export$2e2bcd8739ae039), {
                                                                        "aria-hidden": "true",
                                                                        className: "h-5 w-5 text-gray-400"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                                                    className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg sm:text-sm",
                                                    children: args.map((arg)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                                            value: arg,
                                                            as: (0, $7fPBF.Fragment),
                                                            children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                                                    className: `group relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? "bg-brandBlue-500 text-white" : "text-gray-900"}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: `block truncate ${selected ? "font-semibold" : "font-normal"}`,
                                                                            children: t(arg)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: `absolute inset-y-0 right-0 flex items-center pr-4  ${selected ? active ? "block text-white" : "block text-brandBlue-500" : "hidden"}`,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $019bed45533ced54$export$2e2bcd8739ae039), {
                                                                                "aria-hidden": "true",
                                                                                className: "h-5 w-5"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                        }, arg))
                                                })
                                            ]
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    disabled: [
                                        "blank"
                                    ].includes((_rules_index = rules[index]) === null || _rules_index === void 0 ? void 0 : _rules_index.arg),
                                    type: "text",
                                    autoComplete: "off",
                                    className: `border rounded-md text-sm text-right text-gray-700 ${[
                                        "blank"
                                    ].includes((_rules_index1 = rules[index]) === null || _rules_index1 === void 0 ? void 0 : _rules_index1.arg) ? "bg-gray-50 border-gray-200" : "border-gray-300"}`
                                }, register(`rules.${index}.val`, {
                                    validate: (value)=>{
                                        const { verb: verb, arg: arg } = rules[index];
                                        // Validation for numbers if verb is 'is' or 'isNot' and arg is not 'blank'
                                        if ((verb === "is" || verb === "isNot") && arg !== "blank") return /^\d+$/.test(value) || "rulesErrorNumber";
                                        // Validation for strings with max 200 characters in other cases
                                        return value.length <= 200 || "rulesErrorLength";
                                    }
                                }))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    onClick: ()=>remove(index),
                                    size: "md",
                                    Icon: (0, $125f450ca02db1e2$export$2e2bcd8739ae039)
                                }),
                                ((_errors_rules = errors.rules) === null || _errors_rules === void 0 ? void 0 : (_errors_rules_index = _errors_rules[index]) === null || _errors_rules_index === void 0 ? void 0 : (_errors_rules_index_val = _errors_rules_index.val) === null || _errors_rules_index_val === void 0 ? void 0 : _errors_rules_index_val.type) === "validate" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "pt-1 text-red-500 text-xs",
                                    children: t((_errors_rules1 = errors.rules) === null || _errors_rules1 === void 0 ? void 0 : (_errors_rules_index1 = _errors_rules1[index]) === null || _errors_rules_index1 === void 0 ? void 0 : (_errors_rules_index_val1 = _errors_rules_index1.val) === null || _errors_rules_index_val1 === void 0 ? void 0 : _errors_rules_index_val1.message)
                                })
                            ]
                        }, item.id);
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("addMore"),
                        onClick: ()=>append({
                                verb: verbs[0],
                                arg: args[0],
                                val: ""
                            }),
                        Icon: (0, $dc348e8ecf02df23$export$2e2bcd8739ae039),
                        size: "md",
                        formatting: "mt-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-7 sm:mt-8 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("cancel"),
                        onClick: callbackCancel,
                        id: "dialog-form-cancel-button",
                        name: "dialog-cancel-button"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: "OK",
                        withAccent: true,
                        onClick: handleSave,
                        id: "dialog-form-save-button",
                        name: "dialog-save-button"
                    })
                ]
            })
        ]
    });
}
$1ba1d905d07d5148$export$2e2bcd8739ae039.propTypes = {
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    currentRules: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    callbackCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$1ba1d905d07d5148$export$2e2bcd8739ae039.defaultProps = {
    currentRules: []
};






(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
async function $9488160328ac2ffe$export$2e2bcd8739ae039(jRef, gridLayout, account, dispatch) {
    function getColIdxFromLayout(columnId) {
        if (!gridLayout) return null;
        return gridLayout.findIndex((item)=>item.id === columnId);
    }
    try {
        // get data from spreadsheet (getData, returns array of array)
        const jData = jRef.current.jspreadsheet.getData();
        // convert data to object
        const columnNames = gridLayout.map((column)=>column.id);
        const jDataObj = jData.map((row)=>{
            const newRow = {};
            row.forEach((value, index)=>{
                const columnName = columnNames[index];
                newRow[columnName] = value;
            });
            return newRow;
        });
        // identify which rows have all data (date, assetWeight, assetPurity, evtl. assetAdditionalValue || 0) and no price yet
        const quotesToGet = {
            assets: [],
            dates: []
        };
        jDataObj.forEach((row, index)=>{
            const { date: date, assetMetal: assetMetal, assetPurity: assetPurity, assetWeight: assetWeight, assetAdditionalValue: assetAdditionalValue, upac: upac, transactionValue: transactionValue, uptc: uptc, transactionCurrencyValue: transactionCurrencyValue } = row;
            if (date && assetMetal && assetPurity && assetWeight && !upac && !transactionValue && !uptc && !transactionCurrencyValue) {
                // criteria fulfilled, let us get the quote
                // TODO assetId index is all right?
                quotesToGet.assets.push({
                    assetId: `row${index}`,
                    providerAssetId: {
                        assetMetal: assetMetal,
                        assetMetalWeight: assetWeight * (assetPurity / 1000),
                        assetAdditionalValue: assetAdditionalValue
                    },
                    currency: account.currency
                });
                quotesToGet.dates.push((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(date).startOf("day").valueOf());
            }
        });
        // get quotes for that data (can be via direct api call, so that we bypass redux)
        let result;
        if (quotesToGet.assets.length > 0) {
            result = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/get", {
                body: quotesToGet,
                headers: {
                    "Content-Type": "application/json"
                }
            }); // getQuotes API expects { assets: [{ assetId, providerAssetId }], dates: [dates]}
            // run setValue for the rows above
            result.quotes.forEach((quote, index)=>{
                if (quote.quote) {
                    const rowIndex = quote.assetId.split("row")[1];
                    jRef.current.jexcel.setValueFromCoords(getColIdxFromLayout("upac"), rowIndex, quote.quote * ((account.spread || 0) / 100 + 1)); // purchase price, so with spread on top
                    jRef.current.jexcel.setValueFromCoords(getColIdxFromLayout("uptc"), rowIndex, quote.quote * ((account.spread || 0) / 100 + 1));
                    jRef.current.jexcel.setValueFromCoords(getColIdxFromLayout("transactionCurrency"), rowIndex, quote.currency);
                }
            });
        } else dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("gridGetPurchaseValuesNoRows"));
        // if all rows had data and were updated
        window.dispatchEvent(new CustomEvent("handleGridGetPurchaseValuesCompleted", {
            outcome: (result.quotes || []).length > jData.length ? "allRowsUpdated" : "someRowsUpdated"
        }));
    } catch (error) {
        console.error("Grid > getPurchaseValue error", error);
        window.dispatchEvent(new CustomEvent("handleGridGetPurchaseValuesCompleted", {
            outcome: "error"
        }));
    }
}


/**
 * When it detects a formula which is present in most of the rows below the headers (90%), it returns a formula with offset-style arguments to command history,
 * so that it may be reapplied by ColumnMatcher in the import process (as pretransformation).
 * The formula is taken from the middle row of the column (to make sure we don't use an edge case from the first or last row), and references are replaced with relative offsets.
 * At present this does not check if the formulas are the same (by design), as this is meant to re-apply the formula to the column as a whole during pretransformation.
 * If the formulas are different, there is nothing we can do automatically.
 *
 * Note: this function operates on what is displayed to user in Grid, i.e. row 0 is already the header row. It also assumes there are no hidden columns, because this is edititng ingested files.
 *
 * If this function returns a string, then it should be added to the commands array in the importFileMappings object.
 * If it returns null, it means no valid formula was found or the 90% condition was not met.
 *
 * @param {obj} instance
 * @param {number} x - 0-based column index
 * @returns {string|null} - formula with offset-style arguments (e.g. ""=SUM(§#§[-2,0]§#§,§#§[-1,0]§#§)"), or null if no valid formula is found or 90% condition is not met
 */ function $f1b2e6af69cb0c80$export$2e2bcd8739ae039(instance, x) {
    const totalRows = instance.getData().filter((row)=>row.join("").length > 0).length; // Get total number of rows with data
    let formulaCount = 0;
    // Iterate through the rows to check for formulas in the current column (start with the one below headers)
    for(let i = 0; i < totalRows; i += 1){
        const cellValue = instance.options.data[i][x];
        // const cellValue = instance.getValueFromCoords(x, i);
        if (cellValue && cellValue.startsWith("=")) formulaCount += 1;
    }
    // Check if 75% of cells in the column have formulas
    const threshold = Math.floor(totalRows * 0.75);
    if (formulaCount >= threshold) {
        const middleRow = Math.floor(totalRows / 2); // Get middle row number
        const middleFormula = instance.options.data[middleRow][x];
        if (middleFormula.startsWith("=")) {
            // Parse and replace references with relative offsets
            const replacedFormula = middleFormula.replace(/([A-Z]+)([0-9]+)/g, (match, col, row)=>{
                const colOffset = col.charCodeAt(0) - "A".charCodeAt(0) - x; // Calculate column offset
                const rowOffset = parseInt(row, 10) - (middleRow + 1); // Calculate row offset
                const colReference = colOffset === 0 ? "0" : `${colOffset > 0 ? "+" : ""}${colOffset}`;
                const rowReference = rowOffset === 0 ? "0" : `${rowOffset > 0 ? "+" : ""}${rowOffset}`;
                return `\xa7#\xa7[${colReference},${rowReference}]\xa7#\xa7`;
            });
            console.log("DEBUG: replacedFormula", replacedFormula, "adding to history");
            return replacedFormula;
        }
    }
    console.log("DEBUG: no valid formula found or 75% condition not met");
    return null; // If no valid formula is found or 75% condition is not met
}




/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $6baf7af443672e2c$var$ArrowDownOnSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M9 12l3 3m0 0 3-3m-3 3V2.25"
    }));
}
const $6baf7af443672e2c$var$ForwardRef = $7fPBF.forwardRef($6baf7af443672e2c$var$ArrowDownOnSquareIcon);
var $6baf7af443672e2c$export$2e2bcd8739ae039 = $6baf7af443672e2c$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $248d073b111f7aef$var$ClipboardIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
    }));
}
const $248d073b111f7aef$var$ForwardRef = $7fPBF.forwardRef($248d073b111f7aef$var$ClipboardIcon);
var $248d073b111f7aef$export$2e2bcd8739ae039 = $248d073b111f7aef$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $a39e35de3a5869e1$var$ScissorsIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m7.848 8.25 1.536.887M7.848 8.25a3 3 0 1 1-5.196-3 3 3 0 0 1 5.196 3Zm1.536.887a2.165 2.165 0 0 1 1.083 1.839c.005.351.054.695.14 1.024M9.384 9.137l2.077 1.199M7.848 15.75l1.536-.887m-1.536.887a3 3 0 1 1-5.196 3 3 3 0 0 1 5.196-3Zm1.536-.887a2.165 2.165 0 0 0 1.083-1.838c.005-.352.054-.695.14-1.025m-1.223 2.863 2.077-1.199m0-3.328a4.323 4.323 0 0 1 2.068-1.379l5.325-1.628a4.5 4.5 0 0 1 2.48-.044l.803.215-7.794 4.5m-2.882-1.664A4.33 4.33 0 0 0 10.607 12m3.736 0 7.794 4.5-.802.215a4.5 4.5 0 0 1-2.48-.043l-5.326-1.629a4.324 4.324 0 0 1-2.068-1.379M14.343 12l-2.882 1.664"
    }));
}
const $a39e35de3a5869e1$var$ForwardRef = $7fPBF.forwardRef($a39e35de3a5869e1$var$ScissorsIcon);
var $a39e35de3a5869e1$export$2e2bcd8739ae039 = $a39e35de3a5869e1$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $e752f72be521adcc$var$ArrowDownOnSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M12 1.5a.75.75 0 0 1 .75.75V7.5h-1.5V2.25A.75.75 0 0 1 12 1.5ZM11.25 7.5v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V7.5h3.75a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.75Z"
    }));
}
const $e752f72be521adcc$var$ForwardRef = $7fPBF.forwardRef($e752f72be521adcc$var$ArrowDownOnSquareIcon);
var $e752f72be521adcc$export$2e2bcd8739ae039 = $e752f72be521adcc$var$ForwardRef;




function $6918d96ab260285d$var$DuplicateIcon(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({
        xmlns: "http://www.w3.org/2000/svg",
        className: "h-6 w-6",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        strokeWidth: 2
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
        })
    }));
}
function $6918d96ab260285d$export$2e2bcd8739ae039({ obj: obj, jRef: jRef, contextMenu: contextMenu, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent, gridLayout: gridLayout, accountName: accountName, enableAddDeleteColumns: enableAddDeleteColumns, setTransformationParams: setTransformationParams }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "contextMenu"
    });
    function calculateCsvSeparator() {
        const list = [
            "a",
            "b"
        ];
        const s = list.toLocaleString();
        const sep = s[1];
        return sep;
    }
    // adds the command to transformationParams.commands
    // this function is duplicated in Grid
    function addCommandToHistory(command, args) {
        setTransformationParams((prev)=>{
            const newCommands = [
                ...prev.commands,
                {
                    command: command,
                    args: args
                }
            ];
            return (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                commands: newCommands
            });
        });
    }
    function handleInsertRows(e, before) {
        // if there is more than one row, insert all rows before the first or after the last selected row, depending on the value of before
        const sel = obj.getSelectedRows(true);
        for(let i = sel.length; i > 0; i -= 1)if (obj) obj.insertRow(1, before ? Math.min(...sel) : Math.max(...sel), before);
    }
    function handleInsertColumns(e, before) {
        // if there is more than one column, insert all columns before the first or after the last selected column, depending on the value of before
        const sel = obj.getSelectedColumns(true); // returns the indices of the selected columns in an array
        if (obj) {
            obj.insertColumn(sel.length, before ? Math.min(...sel) : Math.max(...sel), before, {
                type: "text"
            });
            addCommandToHistory("insertColumn", [
                sel.length,
                before ? Math.min(...sel) : Math.max(...sel),
                before
            ]);
        }
    }
    function handleDeleteRows(e) {
        // for each currently selected row issue a deleteRow command
        const sel = obj.getSelectedRows(true);
        for(let i = sel.length; i > 0; i -= 1){
            jRef.current.jexcel.deleteRow(sel[i - 1], 1);
            addCommandToHistory("deleteRow", [
                sel[i - 1]
            ]);
        }
        if (!userChangesPresent) setUserChangesPresent(true);
    }
    function handleDeleteColumn(e) {
        // for each currently selected column issue a deleteColumn command
        const sel = obj.getSelectedColumns(true);
        console.log("DEBUG context menu > handleDelCol", e);
        for(let i = sel.length; i > 0; i -= 1){
            jRef.current.jexcel.deleteColumn(sel[i - 1], 1);
            addCommandToHistory("deleteColumn", [
                sel[i - 1]
            ]);
        }
        if (!userChangesPresent) setUserChangesPresent(true);
    }
    function handlePasteViaMenu(e) {
        // when paste command is triggered via context menu
        if (navigator && navigator.clipboard) {
            // if browser has the clipboard API
            const x = Math.min(...jRef.current.jexcel.getSelectedColumns(true)); // get top left corner of selection
            const y = Math.min(...jRef.current.jexcel.getSelectedRows(true));
            if (obj.selectedCell) navigator.clipboard.readText().then((text)=>{
                if (text) jRef.current.jexcel.paste(x, y, text);
            });
        }
    }
    function handleDuplicateRows(e) {
        // copy selected rows
        jRef.current.jexcel.copy(true); // true means copy the selection only
        // insert selected rows
        handleInsertRows(e, true, obj);
        // paste selected rows
        handlePasteViaMenu(e);
    }
    function handleDuplicateColumns(e) {
        // copy selected columns
        jRef.current.jexcel.copy(true); // true means copy the selection only
        // insert selected columns
        handleInsertColumns(e, true, obj);
        // paste selected rows
        handlePasteViaMenu(e);
    }
    function handleExport(e, selectionOnly = false) {
        let data;
        if (!gridLayout) throw new Error("GridContextMenu: gridLayout is not defined");
        if (selectionOnly) data = jRef.current.jexcel.getData(true); // hidden columns are not included when only getting selection
        else data = jRef.current.jexcel.getData() // hidden columns are included when getting all data, so we need to filter them out
        // remove id column (based on gridLayout)
        .map((row)=>row.filter((_, i)=>gridLayout[i].id !== "id"));
        const xlsxObj = (0, $a1a91b25d7598376$export$eab97d15b1788b8d).aoa_to_sheet(data);
        const workbook = (0, $a1a91b25d7598376$export$eab97d15b1788b8d).book_new();
        (0, $a1a91b25d7598376$export$eab97d15b1788b8d).book_append_sheet(workbook, xlsxObj, "Sheet1");
        (0, $a1a91b25d7598376$export$552bfb764b5cd2b4)(workbook, `${accountName} export.xlsx`, {
            bookType: "xlsx",
            type: "binary"
        });
    }
    const menuItemFormat = "hover:bg-gray-100 hover:text-gray-900 text-gray-700 group flex w-full items-center text-left px-4 py-2 text-sm";
    const iconFormat = "mr-4 h-4 w-4 text-gray-400 group-hover:text-gray-500";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
        show: contextMenu.visible,
        as: (0, $7fPBF.Fragment),
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0 scale-95",
        enterTo: "transform opacity-100 scale-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100 scale-100",
        leaveTo: "transform opacity-0 scale-95",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            // eslint-disable-next-line react/style-prop-object
            style: {
                top: `${contextMenu.y}px`,
                left: `${contextMenu.x}px`
            },
            onMouseDown: (e)=>{
                e.preventDefault(); // the default behaviour of jspreadsheet was that this reset the selection within spreadsheet on mousedown
                e.stopPropagation(); // (before the copy command could have been executed)
            },
            className: "origin-top-right fixed z-50 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "py-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: (e)=>handleInsertRows(e, true),
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$cbfdf0bb1adba85d), {
                                        className: iconFormat,
                                        "aria-hidden": "true"
                                    }),
                                    t("addEmptyRowAbove")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: (e)=>handleInsertRows(e, false),
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$269b5f63de8a029f), {
                                        className: iconFormat,
                                        "aria-hidden": "true"
                                    }),
                                    t("addEmptyRowBelow")
                                ]
                            })
                        }),
                        enableAddDeleteColumns && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: (e)=>handleInsertColumns(e, false),
                                        className: menuItemFormat,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$b9214c7e3489d8a), {
                                                className: iconFormat,
                                                "aria-hidden": "true"
                                            }),
                                            t("addEmptyColumnAbove")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "button",
                                        onClick: (e)=>handleInsertColumns(e, true),
                                        className: menuItemFormat,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$aefafe49c6c6aa), {
                                                className: iconFormat,
                                                "aria-hidden": "true"
                                            }),
                                            t("addEmptyColumnBelow")
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "py-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: handleDuplicateRows,
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$91d38263da9ba43b), {
                                        className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("duplicateRow")
                                ]
                            })
                        }),
                        enableAddDeleteColumns && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: handleDuplicateColumns,
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$c462085fb1373290), {
                                        className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("duplicateColumn")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                id: "deleteRow",
                                onClick: handleDeleteRows,
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$32d59a8186448c4f), {
                                        className: "mr-4 h-4 w-4 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("deleteRow")
                                ]
                            })
                        }),
                        enableAddDeleteColumns && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                id: "deleteColumn",
                                onClick: handleDeleteColumn,
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$ad76ec2c15e9c66f), {
                                        className: "mr-4 h-4 w-4 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("deleteColumn")
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "py-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: (e)=>{
                                    jRef.current.jexcel.copy(true); // true means copy the selection only
                                    jRef.current.jexcel.getSelectedColumns(true).forEach((col)=>{
                                        jRef.current.jexcel.getSelectedRows(true).forEach((row)=>{
                                            jRef.current.jexcel.setValueFromCoords(col, row, "");
                                        });
                                    });
                                    jRef.current.jexcel.removeCopyingSelection();
                                },
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a39e35de3a5869e1$export$2e2bcd8739ae039), {
                                        className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("cut")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: (e)=>{
                                    jRef.current.jexcel.copy(true); // true means copy the selection only
                                    jRef.current.jexcel.removeCopyingSelection();
                                },
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6918d96ab260285d$var$DuplicateIcon, {
                                        className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("copy")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                onClick: handlePasteViaMenu,
                                type: "button",
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $248d073b111f7aef$export$2e2bcd8739ae039), {
                                        className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("paste")
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "py-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: (e)=>{
                                    handleExport(e, false);
                                },
                                className: menuItemFormat,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6baf7af443672e2c$export$2e2bcd8739ae039), {
                                        className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                        "aria-hidden": "true"
                                    }),
                                    t("download")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            onClick: (e)=>{
                                handleExport(e, true);
                            },
                            className: menuItemFormat,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e752f72be521adcc$export$2e2bcd8739ae039), {
                                    className: "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                                    "aria-hidden": "true"
                                }),
                                t("downloadSelected")
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
$6918d96ab260285d$export$2e2bcd8739ae039.propTypes = {
    contextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    obj: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    jRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    gridLayout: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    accountName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    enableAddDeleteColumns: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$6918d96ab260285d$export$2e2bcd8739ae039.defaultProps = {
    obj: {},
    gridLayout: [],
    enableAddDeleteColumns: false,
    setTransformationParams: ()=>{}
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
// const debugLevel = process.env.MDEBUG || 3;
const $aa56e6ca1b280614$var$debugLevel = 3;
function $aa56e6ca1b280614$export$2e2bcd8739ae039({ data: data, gridLayout: gridLayout, prepAndValidateOutputData: prepAndValidateOutputData, postCategoryItems: postCategoryItems, tableState: tableState, account: account, setAccount: setAccount, displayedComponent: displayedComponent, handleClick: handleClick, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent, runSave: runSave, setRunSave: setRunSave, customDropdownSources: customDropdownSources, customOnChange: customOnChange, saveDialogPromiseCallback: saveDialogPromiseCallback, scrollToRow: scrollToRow, setScrollToRow: setScrollToRow, afterCancelGoTo: afterCancelGoTo, customFilter: customFilter, transformationParams: transformationParams, setTransformationParams: // headersInRow will be passed to the GridFilterDialog and used to add headers to filtered dataset
setTransformationParams }) {
    function getColIdxFromLayout(columnId) {
        if (!gridLayout) return null;
        return gridLayout.findIndex((item)=>item.id === columnId);
    }
    // adds the command to transformationParams.commands
    // this function is duplicated in GridContextMenu
    function addCommandToHistory(command, args) {
        setTransformationParams((prev)=>{
            // if there is already a formula command for a given column, remove it before adding a new one
            // formula's arguments are [columnIndex, parsedFormula]
            const newCommands = [
                ...prev.commands.filter((c)=>!(c.command === "formula" && c.args[0] === args[0])),
                {
                    command: command,
                    args: args
                }
            ];
            return (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                commands: newCommands
            });
        });
    }
    // ---------------------------------------------------
    // SELECTORS + STATE
    // ---------------------------------------------------
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const dashboardMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const [dirtyRows, setDirtyRows] = (0, $7fPBF.useState)(new Set()); // holds the list of rows that have been changed by the user
    const filterState = (0, $7fPBF.useRef)((transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.filters) || []); // holds the filter state for each column of the data (changes need to be accessible from jspreadsheet)
    // holds the state of the context menu
    const [contextMenu, setContextMenu] = (0, $7fPBF.useState)({
        visible: false,
        x: 20,
        y: 20,
        clickedRow: 1,
        clickedCol: 1
    }); // (x,y) are coordinates of the cursor when the right click was triggered (relative to the jSpreadsheet component!)
    const [displaySpinner, setDisplaySpinner] = (0, $7fPBF.useState)(false); // shows the spinner when user is committing changes
    // set up refs (used to anchor and exchange information with the jspreadsheet component)
    const jRef = (0, $7fPBF.useRef)(null); // holds the jspreadsheet component
    const rootElement = (0, $7fPBF.useRef)(null);
    const contextMenuRef = (0, $7fPBF.useRef)(); // it cannot access the current state and keeps using the initial value
    contextMenuRef.current = contextMenu; // make sure the ref stays equal to the updated state
    const dirtyRowsRef = (0, $7fPBF.useRef)(); // it cannot access the current state and keeps using the initial value
    dirtyRowsRef.current = dirtyRows; // make sure the ref stays equal to the updated state
    // because the jSpreadsheet component is activated directly in DOM and not through React
    // ---------------------------------------------------
    // EVENT HANDLERS FOR EVENTS OUT OF JSPREADSHEET
    // ---------------------------------------------------
    function handleContextMenu(obj, x, y, e, items, section) {
        // context menu is defined in React (not in jSpreadsheet)
        // the following jSpreadsheet functionality updates contextMenu state object with the coordinates of the context menu
        // and displays it
        // if clientY + 350 is greater than the height of the window, the context menu will be displayed above the cursor
        // if clientY - 350 is less than 0, the context menu will be displayed below the cursor
        const windowHeight = window.innerHeight;
        const yCoordinate = e.clientY > windowHeight - 350 ? e.clientY - 350 : e.clientY;
        setContextMenu((0, $2qxEV._)((0, $9tqwB._)({}, contextMenuRef.current), {
            visible: true,
            x: e.clientX + 4,
            y: yCoordinate + 4,
            clickedRow: y,
            clickedCol: x
        }));
        return false;
    }
    const obj = jRef.current && jRef.current.jspreadsheet;
    const options = (obj === null || obj === void 0 ? void 0 : obj.options) || {};
    function handleOnSelection(element, x, y) {
        if (x === undefined || y === undefined) return;
        if (jRef.current) {
            var _jRef_current_jspreadsheet_options_columns_x;
            setContextMenu((0, $2qxEV._)((0, $9tqwB._)({}, contextMenuRef.current), {
                selectedColumns: jRef.current.jexcel.getSelectedColumns(true),
                selectionHTML: Array.from(document.getElementsByClassName("highlight")).map((el)=>el.innerHTML)
            }));
            // if cell is in a dropdown column and if the cell is empty, then automatically open editor
            const columnName = (0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).getColumnNameFromId([
                x,
                y
            ]);
            // eslint-disable-next-line no-use-before-define
            if (jRef.current.jspreadsheet.options.columns && ((_jRef_current_jspreadsheet_options_columns_x = jRef.current.jspreadsheet.options.columns[x]) === null || _jRef_current_jspreadsheet_options_columns_x === void 0 ? void 0 : _jRef_current_jspreadsheet_options_columns_x.type) === "dropdown" && jRef.current.jexcel.getValue(columnName) === "") {
                const cell = jRef.current.jexcel.getCell(columnName);
                // mouseup event after the dropdown is opened cancels the dropdown
                // so delay the opening of the editor by 125ms to allow that event to pass
                setTimeout(()=>jRef.current.jexcel.openEditor(cell), 125);
            }
        }
    }
    // does not run on insert / remove column / row, just value changes
    function handleChange(instance, cell, x, y, value) {
        // cell returns outerHTML of the cell, value returns new value
        const cellName = (0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).getColumnNameFromId([
            x,
            y
        ]);
        jRef.current.jspreadsheet.setStyle(cellName, "background-color", "white"); // if it is just "set yellow", it switches yellow on and off
        jRef.current.jspreadsheet.setStyle(cellName, "background-color", "rgb(254 249 195 / var(--tw-bg-opacity))");
        setUserChangesPresent(true);
        const updatedDirtyRows = new Set(dirtyRowsRef.current);
        updatedDirtyRows.add(y);
        setDirtyRows(updatedDirtyRows);
        // execute any custom onChange function passed from Wrapper parent components
        if (customOnChange) customOnChange(instance, cell, x, y, value);
        // if there are transformationParams and if this is a formula, run the addFormula function to check if we need to add the formula
        if (Object.keys(transformationParams).length > 0 && value.startsWith("=")) {
            // console.log('DEBUG handleChange > formula detected', value);
            const formula = (0, $f1b2e6af69cb0c80$export$2e2bcd8739ae039)(jRef.current.jspreadsheet, x, transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow);
            // ↑↑ this will only return a string if the formula is present in 90% of the rows below the headers
            if (formula) // console.log('DEBUG handleChange > formula added to commands', formula);
            addCommandToHistory("formula", [
                x,
                formula
            ]);
        }
    }
    // in all fairnes, this isn't as much as handleLoad as it is handleSetData (it runs on every setData)
    // CAUTION: if an action is to happen only once during intialisation, put it in the useEffect where jspreadsheet is initialised
    // display incoming errors: if property errorId is truthy, the comment on the corresponding cell in jRef is set to the translated error message
    function handleSetData() {
        // console.log('DEBUG handleLoad is running');
        // if errorId is truthy (not undefined, '' or null) takes errorIds from column  of the dataset,
        // translates them and puts them into the cell comments of the second column (first may be date / calendar)
        data.forEach((item, row)=>{
            if (item.errorId) jRef.current.jexcel.setComments((0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).helpers.getColumnNameFromCoords(1, row));
             // this goes into column 2 only!
        });
    }
    function handleDeleteRow(_obj, rowNo, numberOfRows, elements, deletedData) {
        // handle following bug through workaround:
        // right-click a cell in any row (which is not the bottom row) and select delete row from context menu
        // immediatelly right-click the same cell again (new row is there already) to see context menu -- does not work
        // workaround: click anywhere else in spreadsheet after delete
        if (!userChangesPresent) setUserChangesPresent(true); // this capturest the deletion of a row by using Delete key instead of context menu
        jRef.current.jexcel.updateSelectionFromCoords(0, rowNo - 1 < 0 ? 0 : rowNo - 1);
    }
    function handlePaste(object, pastedData) {
        // on every paste command (via context menu or keyboard shortcut)
        const updatedDirtyRows = new Set(dirtyRowsRef.current);
        jRef.current.jexcel.getSelectedColumns(true).forEach((col)=>{
            jRef.current.jexcel.getSelectedRows(true).forEach((row)=>{
                const cellName = (0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).helpers.getColumnNameFromCoords(col, row);
                jRef.current.jexcel.setStyle(cellName, "background-color", "white"); // if it is just "set yellow", it switches yellow on and off
                jRef.current.jexcel.setStyle(cellName, "background-color", "rgb(254 249 195 / var(--tw-bg-opacity))");
                if (!userChangesPresent) setUserChangesPresent(true);
                updatedDirtyRows.add(row);
            });
        });
        setDirtyRows(updatedDirtyRows);
    }
    function handleBeforeChange(instance, cell, x, y, value) {
        var _instance_options_columns, _instance_options, _column_options;
        const column = instance === null || instance === void 0 ? void 0 : (_instance_options = instance.options) === null || _instance_options === void 0 ? void 0 : (_instance_options_columns = _instance_options.columns) === null || _instance_options_columns === void 0 ? void 0 : _instance_options_columns[x];
        if ((column === null || column === void 0 ? void 0 : column.type) !== "calendar") return value;
        return (0, $ddc3e461ba9aa601$export$dd663cd24858fc26)(value, (_column_options = column.options) === null || _column_options === void 0 ? void 0 : _column_options.format);
    }
    // -----------------------------------------------------------------------
    // ESCAPE KEY HANDLER
    // -----------------------------------------------------------------------
    // close context menu when Esc is pressed anywhere in the document
    const handleEscPress = (0, $7fPBF.useCallback)((event)=>{
        if (contextMenuRef.current.visible && event.key === "Escape") {
            event.stopImmediatePropagation();
            setContextMenu((0, $2qxEV._)((0, $9tqwB._)({}, contextMenuRef.current), {
                visible: false
            }));
        }
    }, []);
    // intialise: add event listener for Esc key; reset userChangesPresent; remove the default alert function (because it got triggered when deleting a row using Del)
    (0, $7fPBF.useEffect)(()=>{
        window.confirm = ()=>true;
        // normally window.confirm displays an OK / Cancel dialog and is used in jSpreadsheet to display among others "are you sure you want to delete this row", which we don't really want
        // this has been overridden here to return true immediatelly; handleDeleteRow will then set userChangesPresent to true
        document.addEventListener("keydown", handleEscPress, false);
        setUserChangesPresent(false);
        return ()=>{
            document.removeEventListener("keydown", handleEscPress, false);
        };
    }, []);
    // -----------------------------------------------------------------------
    // HANDLE REFRESH DATA EVENT
    // -----------------------------------------------------------------------
    // in Previewer pretransformations are applied automatically, but the user can undo them
    // to do that they press a button in ButtonBar which runs a function in Previewer (passed via props)
    // that function needs to trigger a refresh of the data in Grid by sending event 'gridReloadData' and the ingested data as payload
    // this sets up the event listener + cleanup
    (0, $7fPBF.useEffect)(()=>{
        const handleReloadData = (e)=>{
            if (jRef.current && jRef.current.jexcel) jRef.current.jexcel.setData(e.detail);
        };
        window.addEventListener("gridReloadData", handleReloadData);
        return ()=>{
            window.removeEventListener("gridReloadData", handleReloadData);
        };
    }, []);
    // -----------------------------------------------------------------------
    // ADD / REMOVE FILTERS TO / FROM COLUMNS
    // -----------------------------------------------------------------------
    function handleOnDeleteColumn(el, colIdx, numberCols) {
        // remove column from filterState
        filterState.current.splice(colIdx, numberCols);
    }
    // function runs when user finishes the filter dialog below and makes changes to filters
    function updateFilterState(tdColumnIndex, filterValue) {
        // update filterState in the ref
        filterState.current[tdColumnIndex - 1] = filterValue; // this is an array of filter objects
        // adjust appearance of the filter button in the header
        const headerCells = jRef.current.querySelectorAll("thead td");
        headerCells.forEach((td, index)=>{
            if (index === tdColumnIndex) {
                const svg = td.querySelector(".grid-filter-icon");
                if (svg) svg.setAttribute("fill", filterValue.length > 0 ? "rgb(148,163,184)" : "none");
            }
        });
        // update data to be displayed in the spreadsheet
        if (jRef.current && jRef.current.jexcel) {
            const unfilteredRowIndices = (0, $16a142e8b73d05d4$export$2e2bcd8739ae039)(jRef.current.jexcel.getData(), filterState.current, {
                decimalChar: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.decimalChar,
                dateFormat: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.dateFormat
            }, transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow);
            // console.log('DEBUG updateFilterState > unfilteredRowIndices', unfilteredRowIndices);
            // go through all rows and reset / reapply filters
            jRef.current.jexcel.rows.forEach((row, rowIndex)=>{
                if (!unfilteredRowIndices.includes(rowIndex)) jRef.current.jexcel.rows[rowIndex].style.display = "none";
                else jRef.current.jexcel.rows[rowIndex].style.display = "";
            });
            // update filters in transformation params for saving
            setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    filters: filterState.current
                }));
        }
    }
    // update spreadsheet data when transformation parameters change
    (0, $7fPBF.useEffect)(()=>{
        if (jRef.current && jRef.current.jexcel) {
            const unfilteredRowIndices = (0, $16a142e8b73d05d4$export$2e2bcd8739ae039)(jRef.current.jexcel.getData(), filterState.current, {
                decimalChar: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.decimalChar,
                dateFormat: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.dateFormat
            }, transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow);
            // go through all rows and reset / reapply filters
            // console.log('DEBUG useEffect > unfilteredRowIndices', unfilteredRowIndices);
            jRef.current.jexcel.rows.forEach((row, rowIndex)=>{
                if (!unfilteredRowIndices.includes(rowIndex)) jRef.current.jexcel.rows[rowIndex].style.display = "none";
                else jRef.current.jexcel.rows[rowIndex].style.display = "";
            });
        }
    }, [
        transformationParams
    ]);
    // function is attached to each filter button in the column header and will open a dialog to set the filter
    function handleFilterButton(e) {
        // let's figure out which column is this
        // get the parent element of the button parent of the svg
        const grandparent = e.target.closest("button").parentElement;
        // Find the index of the grandparent element among its siblings
        let tdIndex = 0;
        let sibling = grandparent;
        // eslint-disable-next-line no-cond-assign
        while((sibling = sibling.previousElementSibling) != null)tdIndex += 1;
        // attention: index is the index of column (td element) under thead --> row number column is 0, first data column is 1
        // filterState has columns from data, first data column is 0
        // now that we have the correct index, let us bring up the dialog and update the state
        window.dispatchEvent(new CustomEvent("setDialog", {
            detail: {
                Component: (0, $1ba1d905d07d5148$export$2e2bcd8739ae039),
                props: {
                    currentRules: filterState.current[tdIndex - 1],
                    callback: (value)=>{
                        updateFilterState(tdIndex, value.rules);
                        window.dispatchEvent(new CustomEvent("setDialog", {}));
                    },
                    callbackCancel: ()=>window.dispatchEvent(new CustomEvent("setDialog", {}))
                }
            }
        }));
    }
    // this function adds the filter button to the column headers and turns it on if there is a filter set for that column index
    // headerCells need to be HTML elements (typically the td elements of the thead, one or many)
    function addFilterButtonToHeaderCells(headerCells) {
        if (!headerCells) return;
        headerCells.forEach((td, index)=>{
            const color = filterState.current[index] ? "rgb(148, 163, 184)" : "none"; // if there is a filter set for this column, set the filter button on
            if (index === 0) return; // skip the first column (id)
            let button = td.querySelector(".grid-filter-button");
            if (!button) {
                // Create the button and SVG using insertAdjacentHTML
                const buttonHTML = `
          <button class="grid-filter-button" style="position: absolute; top: 11px; right: 7px; background: transparent; border: none; padding: 0; cursor: pointer;">
            <svg class="grid-filter-icon" fill="${color}" viewBox="0 0 24 24" stroke-width="1.5" stroke="rgb(148, 163, 184)" style="width: 15px; height: 15px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"/>
            </svg>
          </button>`;
                // Insert the button with the SVG into the <td>
                td.insertAdjacentHTML("beforeend", buttonHTML);
                // Attach the onClick handler to the newly added button
                button = td.querySelector(".grid-filter-button");
                button.onclick = handleFilterButton;
            } else {
                // Update the color of the SVG if the button already exists
                const svg = button.querySelector(".grid-filter-icon");
                if (svg) svg.setAttribute("fill", color);
            }
        });
    }
    function handleOnInsertColumn(el, colIdx, numberCols) {
        // console.log('handleOnInsertColumn', el, colIdx, numberCols);
        // Add small div to the newly inserted column's header
        const headerCells = jRef.current.querySelectorAll(`thead td:nth-child(${colIdx + 1})`);
        addFilterButtonToHeaderCells(headerCells);
        // insert a new column into the filterState
        filterState.current.splice(colIdx, 0, null);
    }
    // -----------------------------------------------------------------------
    // INITIALISE JSPREADSHEET
    // -----------------------------------------------------------------------
    const serializedData = (0, $7fPBF.useMemo)(()=>JSON.stringify(data || []), [
        data
    ]);
    // initialise jspreadsheet at the jRef ref
    (0, $7fPBF.useEffect)(()=>{
        var _jRef_current_jspreadsheet_openEditor, _account_tags;
        // standard set of options to be partially overwritten by whatever is needed for different categories (params)
        const columnDefinitionsFromGridLayout = (0, $71a316c7cafc3797$export$2e2bcd8739ae039)(gridLayout, customDropdownSources, tableState, baseCurrency, i18n, t, account === null || account === void 0 ? void 0 : account.currency);
        // get the anount of columns from gridLayout / addFormattingToColumns; if there is no gridLayout / addFormattingToColumns, get the amount of columns from the data
        const columnCount = columnDefinitionsFromGridLayout ? columnDefinitionsFromGridLayout.length : data.reduce((acc, row)=>Math.max(acc, Object.keys(row).length), 0);
        const prepOptions = {
            data: data,
            copyCompatibility: true,
            editable: dashboardMode !== "projects",
            minDimensions: [
                displayedComponent === "previewer" ? columnCount + 2 : columnCount,
                20
            ],
            minSpareRows: 1,
            tableHeight: "100%",
            tableWidth: "100%",
            tableOverflow: true,
            columnDrag: displayedComponent === "previewer",
            autoIncrement: true,
            allowInsertColumn: displayedComponent === "previewer",
            allowManualInsertColumn: displayedComponent === "previewer",
            allowDeleteColumn: displayedComponent === "previewer",
            allowRenameColumn: false,
            contextMenu: handleContextMenu,
            onselection: handleOnSelection,
            onchange: handleChange,
            onbeforechange: handleBeforeChange,
            onload: handleSetData,
            onpaste: handlePaste,
            ondeleterow: handleDeleteRow,
            oninsertcolumn: handleOnInsertColumn,
            ondeletecolumn: handleOnDeleteColumn
        };
        if (columnDefinitionsFromGridLayout) prepOptions.columns = columnDefinitionsFromGridLayout;
        // add column type number and a decimal point to all columns in an attempt to make parsing automatic
        // (only if there is no gridLayout, at the moment it applies to previewer)
        if (!columnDefinitionsFromGridLayout) prepOptions.columns = Array.from({
            length: columnCount
        }, ()=>({
                type: "number",
                decimal: (transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.decimalChar) || ","
            }));
        // in project mode calculate which rows are simulated and format them violet
        // expected format [ { A1: 'background-color: orange; ' }, ... ]
        const letters = [];
        let cursor = 0;
        if (prepOptions.columns) {
            while(cursor < prepOptions.columns.length){
                if (prepOptions.columns[cursor].type !== "hidden") letters.push(String.fromCharCode(65 + cursor)); // generates an array of capital letters starting with ASCII code 65 (A)
                cursor += 1;
            }
            const style = (data || []).reduce(// eslint-disable-next-line max-len
            (acc, row, index)=>row.isSimulated ? (0, $9tqwB._)({}, acc, letters.reduce((prev, curr)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        [`${curr}${index + 1}`]: "background-color: rgb(248 240 250); font-style: italic; "
                    }), {})) : (0, $9tqwB._)({}, acc), {});
            prepOptions.style = style;
        }
        // if (!jRef.current.jspreadsheet && prepOptions.data) {
        // ---------------------------------------------------
        // INITIALISE THE SPREADSHEET
        // ---------------------------------------------------
        // if there are fomulas in the data (e.g. in Previewer), we need to initialise the spreadsheet AND APPLY THE PATCH before importing data (otherwise formulas won't work)
        const { data: withheldData } = prepOptions, stageOneOptions = (0, $bLhVg._)(prepOptions, [
            "data"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports)))(jRef.current, stageOneOptions);
        const originalOpenEditor = (_jRef_current_jspreadsheet_openEditor = jRef.current.jspreadsheet.openEditor) === null || _jRef_current_jspreadsheet_openEditor === void 0 ? void 0 : _jRef_current_jspreadsheet_openEditor.bind(jRef.current.jspreadsheet);
        if (originalOpenEditor) {
            const patchedOpenEditor = (cell, ...args)=>{
                var _cell_getAttribute, _cell_getAttribute1, _jRef_current_jspreadsheet_options_columns, _jRef_current_jspreadsheet_options, _jRef_current_jspreadsheet, _jRef_current;
                const colIdx = Number(cell === null || cell === void 0 ? void 0 : (_cell_getAttribute = cell.getAttribute) === null || _cell_getAttribute === void 0 ? void 0 : _cell_getAttribute.call(cell, "data-x"));
                const rowIdx = Number(cell === null || cell === void 0 ? void 0 : (_cell_getAttribute1 = cell.getAttribute) === null || _cell_getAttribute1 === void 0 ? void 0 : _cell_getAttribute1.call(cell, "data-y"));
                const column = (_jRef_current = jRef.current) === null || _jRef_current === void 0 ? void 0 : (_jRef_current_jspreadsheet = _jRef_current.jspreadsheet) === null || _jRef_current_jspreadsheet === void 0 ? void 0 : (_jRef_current_jspreadsheet_options = _jRef_current_jspreadsheet.options) === null || _jRef_current_jspreadsheet_options === void 0 ? void 0 : (_jRef_current_jspreadsheet_options_columns = _jRef_current_jspreadsheet_options.columns) === null || _jRef_current_jspreadsheet_options_columns === void 0 ? void 0 : _jRef_current_jspreadsheet_options_columns[colIdx];
                if ((column === null || column === void 0 ? void 0 : column.type) === "calendar" && Number.isInteger(colIdx) && Number.isInteger(rowIdx)) {
                    var _column_options, _jRef_current_jspreadsheet_options_data_rowIdx, _jRef_current_jspreadsheet_options_data, _jRef_current_jspreadsheet_options_data1;
                    const format = (_column_options = column.options) === null || _column_options === void 0 ? void 0 : _column_options.format;
                    const currentValue = (_jRef_current_jspreadsheet_options_data = jRef.current.jspreadsheet.options.data) === null || _jRef_current_jspreadsheet_options_data === void 0 ? void 0 : (_jRef_current_jspreadsheet_options_data_rowIdx = _jRef_current_jspreadsheet_options_data[rowIdx]) === null || _jRef_current_jspreadsheet_options_data_rowIdx === void 0 ? void 0 : _jRef_current_jspreadsheet_options_data_rowIdx[colIdx];
                    const editorValue = (0, $ddc3e461ba9aa601$export$b6b8aaf0d87aee08)(currentValue, format);
                    const displayValue = (0, $ddc3e461ba9aa601$export$e59e0d0b478485d3)(editorValue, format);
                    if ((_jRef_current_jspreadsheet_options_data1 = jRef.current.jspreadsheet.options.data) === null || _jRef_current_jspreadsheet_options_data1 === void 0 ? void 0 : _jRef_current_jspreadsheet_options_data1[rowIdx]) jRef.current.jspreadsheet.options.data[rowIdx][colIdx] = editorValue;
                    if (typeof displayValue === "string") cell.textContent = displayValue;
                }
                return originalOpenEditor(cell, ...args);
            };
            jRef.current.jspreadsheet.openEditor = patchedOpenEditor;
            if (jRef.current.jexcel) jRef.current.jexcel.openEditor = patchedOpenEditor;
        }
        // executeFormula uses eval -- copied that function locally and patched it unitl there is a permanent fix
        // @monestry-dev/jspreadsheet-ce@4.2.2 has a partial fix (fixes the usage of eval in executeFormula), but the problem still persists
        // (see jspreadsheetFormulaPatch to get you started)
        jRef.current.jspreadsheet.executeFormula = function customExecuteFormula(arg1, arg2, arg3) {
            return (0, $09194143fe1e2820$export$2e2bcd8739ae039)(arg1, arg2, arg3, jRef.current.jspreadsheet);
        };
        jRef.current.jspreadsheet.setData(withheldData);
        const activeSpreadsheetContainer = jRef.current.querySelector(".jexcel_container");
        // ---------------------------------------------------
        // PERFORM ADDITIONAL ACTIONS AFTER INITIALISATION
        // ---------------------------------------------------
        // if custom filter is enabled, we need to initalise it (from saved data or empty)
        if (customFilter) {
            // Add small divs to each <td> under <thead> at initialization
            const headerCells = jRef.current.querySelectorAll("thead td");
            addFilterButtonToHeaderCells(headerCells);
            // initialise filterState
            if (!filterState.current) filterState.current = new Array(columnCount).fill(null);
            else if (filterState.current.length < columnCount) // check if we have enough columns in filterState and add if necessary
            filterState.current = filterState.current.concat(new Array(columnCount - filterState.current.length).fill(null));
            // apply filters to the data
            const unfilteredRowIndices = (0, $16a142e8b73d05d4$export$2e2bcd8739ae039)(data, filterState.current, {
                decimalChar: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.decimalChar,
                dateFormat: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.dateFormat
            }, transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow);
            // console.log('DEBUG init > unfilteredRowIndices', unfilteredRowIndices);
            // go through all rows and reset / reapply filters
            jRef.current.jexcel.rows.forEach((row, rowIndex)=>{
                if (!unfilteredRowIndices.includes(rowIndex)) jRef.current.jexcel.rows[rowIndex].style.display = "none";
                else jRef.current.jexcel.rows[rowIndex].style.display = "";
            });
        }
        // add tooltips to the headers
        // it has the title property (set to column name), so we will just overwrite it with the tooltip
        const headers = jRef.current.querySelectorAll(".jexcel thead tr td");
        // console.log('DEBUG headers', headers);
        // const tooltips = ['Tip for A', 'Tip for B', 'Tip for C'];
        headers.forEach((header, index)=>{
            var _prepOptions_columns_;
            // index starts at 0, which is the row number column, so we need to skip it
            if (index === 0) return;
            // check if there is a tooltip; if there isn't, don't change anything
            if (prepOptions.columns && ((_prepOptions_columns_ = prepOptions.columns[index - 1]) === null || _prepOptions_columns_ === void 0 ? void 0 : _prepOptions_columns_.tooltip)) header.setAttribute("title", prepOptions.columns[index - 1].tooltip);
        });
        // inherit sorting order from table (do not do that when there is no gridLayout, i.e. when we are displaying raw data e.g. for import)
        if (gridLayout) jRef.current.jexcel.orderBy(getColIdxFromLayout(tableState.sortBy), Number(!tableState.sortDirectionAsc)); // true (1) means descending in this function
        // check if grid col widths are saved in account.tags.gridColWidths and apply them
        if (gridLayout && ((_account_tags = account.tags) === null || _account_tags === void 0 ? void 0 : _account_tags.gridColWidths)) jRef.current.jspreadsheet.options.columns.forEach((def, index)=>{
            if (account.tags.gridColWidths[index]) jRef.current.jspreadsheet.setWidth(index, account.tags.gridColWidths[index]);
        });
        // if we are in raw data mode, set col width to 100
        if (!gridLayout) for(let i = 0; i < jRef.current.jspreadsheet.options.minDimensions[0]; i += 1)jRef.current.jspreadsheet.setWidth(i, 100); // Set the width for each column
        // additionally add an event listener for jexcel_container because the keydown event originates from the jexcel_container
        // so it will be triggered BEFORE the document-level JSuites element which prevents other events from being triggered
        activeSpreadsheetContainer === null || activeSpreadsheetContainer === void 0 ? void 0 : activeSpreadsheetContainer.addEventListener("keydown", handleEscPress, false);
        // }
        // eslint-disable-next-line consistent-return
        return ()=>{
            var _jRef_current_jspreadsheet_destroy, _jRef_current_jspreadsheet, _jRef_current;
            activeSpreadsheetContainer === null || activeSpreadsheetContainer === void 0 ? void 0 : activeSpreadsheetContainer.removeEventListener("keydown", handleEscPress, false);
            (_jRef_current = jRef.current) === null || _jRef_current === void 0 ? void 0 : (_jRef_current_jspreadsheet = _jRef_current.jspreadsheet) === null || _jRef_current_jspreadsheet === void 0 ? void 0 : (_jRef_current_jspreadsheet_destroy = _jRef_current_jspreadsheet.destroy) === null || _jRef_current_jspreadsheet_destroy === void 0 ? void 0 : _jRef_current_jspreadsheet_destroy.call(_jRef_current_jspreadsheet);
            if (jRef.current) {
                jRef.current.innerHTML = "";
                delete jRef.current.jspreadsheet;
                delete jRef.current.jexcel;
            }
        };
    }, [
        serializedData
    ]);
    // -----------------------------------------------------------------------
    // HANDLE SAVE
    // -----------------------------------------------------------------------
    // gets widths of all displayed columns and saves them in the tableState
    function saveColWidths() {
        const rows = jRef.current.jexcel.getRowData(0); // this assumes that jspreadsheet makes all rows are the same length
        const gridColWidths = [];
        rows.forEach((row, idx)=>{
            const width = jRef.current.jexcel.getWidth(idx);
            gridColWidths.push(Number(width));
        });
        dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
            data: (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, account.tags), {
                    gridColWidths: gridColWidths
                })
            }),
            category: account.category
        }));
    }
    // does some internal validation and then calls handleSubmit
    // if there is responseDialog, it means that the user was asked to provide some additional data (like asset mapping for Cryptos)
    // responseDialog is an array containing the same number of items (rows) as the outputData, but only a subset of fields,
    // for example only { assetId, displaySymbol, providerAssetId } for Cryptos, so it needs to be spread over the outputData
    function prepAndValidateOutputDataWrapper(responseDialog) {
        // get data from the spreadsheet object and send them on their merry way
        // apply filters if existing
        const unfilteredRowIndices = (0, $16a142e8b73d05d4$export$2e2bcd8739ae039)(jRef.current.jspreadsheet.getData(false, true), filterState.current, {
            decimalChar: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.decimalChar,
            dateFormat: transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.dateFormat
        }, transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow);
        // apply filters to output data
        const outputData = jRef.current.jspreadsheet.getData(false, true).filter((row, index)=>unfilteredRowIndices.includes(index));
        // console.log('Grid > prepAndValidateOutputDataWrapper: outputData', outputData);
        // now run the prepAndValidateOutputData function from CategoryWrapper
        // (it will run general transformations and category-specific ones from accountDetails/transactions or /quotes)
        // send gridLayout back to CategoryWrapper, because it is it's determined in its child, so CategoryWrapper doesn't know about it
        const prepAndValidateResult = prepAndValidateOutputData(outputData, gridLayout, dirtyRows, responseDialog);
        if ($aa56e6ca1b280614$var$debugLevel > 2) console.log("Grid > prepAndValidateOutputDataWrapper: prepAndValidateResult", prepAndValidateResult);
        if (prepAndValidateResult.status === "error") {
            setRunSave(false);
            const validationErrors = prepAndValidateResult.errors;
            // clear all old errors (comments)
            // TODO if previous data had more rows, the comments will not get cleaned
            try {
                outputData.forEach((row, rowIdx)=>{
                    row.forEach((cell, colIdx)=>{
                        // clear all comments
                        jRef.current.jexcel.setComments((0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).helpers.getColumnNameFromCoords(colIdx, rowIdx), "");
                    });
                });
                // for each error get row and column and put error in comments
                // the thrown error is error message from yup and path to error like [row].fieldName (e.g. This is an error, [0].otherParty)
                // console.log('validationErrors', validationErrors);
                validationErrors.forEach((err)=>{
                    var _options_columns_columnNo;
                    console.error("Validation error:", err.message);
                    const rowNo = err.path.split(".")[0].replace(/\D+/g, "") || 0;
                    const columnNo = getColIdxFromLayout(err.path.split(".")[1]);
                    // console.log('rowNo', rowNo, 'columnNo', columnNo);
                    // console.info('Row causing the error:', prepAndValidateResult[rowNo]);
                    // if column has been found in Grid (is a number and is greater or equal 0) and that column is visible, then set the comment there
                    // otherwise set it in the first visible column
                    if ((!!columnNo || columnNo === 0) && columnNo >= 0 && ((_options_columns_columnNo = options.columns[columnNo]) === null || _options_columns_columnNo === void 0 ? void 0 : _options_columns_columnNo.type) !== "hidden") jRef.current.jexcel.setComments((0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).helpers.getColumnNameFromCoords(columnNo, rowNo), err.message);
                    else {
                        console.info("Column for the above error is not displayed in Grid");
                        // find first column which is not hidden
                        const firstNotHiddenColumnNo = options.columns.findIndex((c)=>c.type !== "hidden");
                        jRef.current.jexcel.setComments((0, (/*@__PURE__*/$parcel$interopDefault($f6d096c4c719df2a$exports))).helpers.getColumnNameFromCoords(firstNotHiddenColumnNo, rowNo), err.message);
                    }
                });
                // throw new Error('localValidationFailed');
                // show message to user
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("checkYourData"));
                setDisplaySpinner(false);
            } catch (err) {
                throw new Error(`Grid > prepAndValidateOutputDataWrapper: unhandled error ${err.message}`, err);
            }
        }
        if (prepAndValidateResult.status === "success") return prepAndValidateResult; // { status, data }
        return {
            status: "error"
        };
    }
    // this gets called a little later, read on...
    async function handleSubmit(validatedData) {
        // console.log('Grid > starting handleSubmit for data', validatedData);
        try {
            var _response_meta;
            setDisplaySpinner(true);
            // with the exception of Previewer, which is returning data to ImportFile state, all other use cases require sending data to backend
            // Previewer has a simple function that sets the state and does not use redux
            const response = displayedComponent !== "previewer" ? await dispatch(postCategoryItems(validatedData, account)) : postCategoryItems(validatedData);
            // save user column widths if we are not in Previewer (we save them to account.tags.gridColWidths and they will apply next time we open the Grid)
            // for Previewer we don't do that for now, we want imports to run more or less automatically
            if (displayedComponent !== "previewer") saveColWidths();
            setDisplaySpinner(false);
            // console.log('Grid: postData response', response);
            // response.meta.requestStatus is used in quotes, it is the "redux-toolkit" way of doing things
            if ((response === null || response === void 0 ? void 0 : response.status) === "success" || (response === null || response === void 0 ? void 0 : (_response_meta = response.meta) === null || _response_meta === void 0 ? void 0 : _response_meta.requestStatus) === "fulfilled") {
                setUserChangesPresent(false);
                handleClick(afterCancelGoTo, {
                    skipUnsavedChanges: true
                });
                return;
            }
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateProblems")); // if we got here, it means that was not a 'success' response
            console.error("Grid: handleSubmit ran aground.");
        } catch (err) {
            console.error("Grid: error in dispatch", err);
            setDisplaySpinner(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateProblems"));
        }
    }
    // passes jRef and gridLayout to the dialog promise callback
    function createDialogPromise() {
        return new Promise((resolve, reject)=>{
            saveDialogPromiseCallback(resolve, reject, jRef, gridLayout);
        });
    }
    // ---------------------------------------------------
    // SUBSCRIBE TO runSave EVENT FROM BUTTON_BAR
    // ---------------------------------------------------
    // ButtonBar will set the runSave flag to true when the user clicks Save
    (0, $7fPBF.useEffect)(()=>{
        if ($aa56e6ca1b280614$var$debugLevel > 2) console.log("Grid > runSave signal received", runSave, "userChangesPreset", userChangesPresent, "displayedComponent", displayedComponent);
        // if the user has not made any changes, save and close (exception: for displayedComponent: 'duplicate', we accept also no changes here)
        if (runSave === true && !userChangesPresent && ![
            "duplicate",
            "previewer"
        ].includes(displayedComponent)) {
            setRunSave(false); // reset the signal
            handleClick("table");
        }
        if (runSave === true && (userChangesPresent || [
            "duplicate",
            "previewer"
        ].includes(displayedComponent))) // if we need to ask user something before validating and saving data, this is where it happens
        // this promise shows a dialog and sends back updated data when user clicks ok
        // if there is no saveDialogPromiseCallback, the default function from propTypes will resolve to null (responseDialog will be null)
        createDialogPromise().then((responseDialog)=>{
            // if dialog is not necessary for this workflow, responseDialog will be null;
            // otherwise it will be an array of the same length as the grid data with objects { assetId, displaySymbol, providerAssetId }
            // because responseDialog is just a subset of the data, so we will pass it to prepAndValidate...
            // to be spread over the converted all data object
            // get data from the spreadsheet object, transform back to their original structure and validate them
            // if prepAndValidate... receives an non-empty argument, it knows it has to spread it over the data
            const resultsPrepAndValidate = responseDialog ? prepAndValidateOutputDataWrapper(responseDialog) : prepAndValidateOutputDataWrapper();
            if ($aa56e6ca1b280614$var$debugLevel > 2) console.log("Grid > runSave: resultsPrepAndValidate", resultsPrepAndValidate);
            setRunSave(false); // reset the signal
            if ((resultsPrepAndValidate === null || resultsPrepAndValidate === void 0 ? void 0 : resultsPrepAndValidate.status) === "error") dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("checkYourData"));
            if ((resultsPrepAndValidate === null || resultsPrepAndValidate === void 0 ? void 0 : resultsPrepAndValidate.status) === "success") dispatch((0, $3b9398d0f9c152fb$export$91020d7983105237)("aboutToSave", account.id, ()=>handleSubmit(resultsPrepAndValidate.data))); // if the user presses OK, it will start handleSubmit
        }, // handle error from waiting for the dialog
        (errorDialog)=>{
            console.error("Grid > runSave: error in dialog promise", errorDialog);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("checkYourData"));
            setRunSave(false);
        });
    }, [
        runSave
    ]);
    // ---------------------------------------------------
    // (METALS ONLY) HANDLE GET PURCHASE VALUE
    // ---------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (account.category === "metals") window.addEventListener("gridGetPurchaseValues", (0, $9488160328ac2ffe$export$2e2bcd8739ae039));
        return ()=>{
            if (account.category === "metals") window.removeEventListener("gridGetPurchaseValues", (0, $9488160328ac2ffe$export$2e2bcd8739ae039));
        };
    }, [
        data
    ]);
    // ---------------------------------------------------
    // HANDLE SCROLL TO ROW
    // ---------------------------------------------------
    // DEBUG: this displays current state of all jexcel attributes (current data state is in options.data)
    (0, $7fPBF.useEffect)(()=>{
        if (jRef.current && scrollToRow) {
            const cell1 = jRef.current.jexcel.getCell(`A${scrollToRow + 1}`);
            if (cell1) {
                cell1.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                jRef.current.jexcel.updateSelection(cell1, cell1, true);
            }
            setScrollToRow(null);
        }
    }, [
        scrollToRow
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: "pt-2 grow flex flex-col overflow-hidden w-full relative",
                "aria-label": "context menu",
                id: "contextmenu",
                children: [
                    displaySpinner && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "absolute bg-gray-50/50 transition duration-700 w-full h-full z-30",
                        id: "synchronisingspinner",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex h-full items-center justify-center",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                // eslint-disable-next-line max-len
                                className: "-mt-2 inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-400 transition ease-in-out duration-150 cursor-not-allowed",
                                type: "button",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                        className: "animate-spin -ml-1 mr-3 h-5 w-5 text-white text-base",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                                className: "opacity-25",
                                                cx: "12",
                                                cy: "12",
                                                r: "10",
                                                stroke: "currentColor",
                                                strokeWidth: "4"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                className: "opacity-75",
                                                fill: "currentColor",
                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            })
                                        ]
                                    }),
                                    t("synchronisingChanges")
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "z-20 h-full relative inline-block text-left",
                        onClick: ()=>{
                            if (contextMenu.visible === true) setContextMenu((0, $2qxEV._)((0, $9tqwB._)({}, contextMenuRef.current), {
                                visible: false
                            }));
                        },
                        ref: rootElement,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "h-full",
                                id: "account-details-grid-spreadsheet",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "h-full w-full",
                                        ref: jRef
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6918d96ab260285d$export$2e2bcd8739ae039), {
                                obj: obj,
                                jRef: jRef,
                                contextMenu: contextMenu,
                                setContextMenu: setContextMenu,
                                userChangesPresent: userChangesPresent,
                                setUserChangesPresent: setUserChangesPresent,
                                gridLayout: gridLayout,
                                accountName: account.name,
                                enableAddDeleteColumns: displayedComponent === "previewer",
                                setTransformationParams: setTransformationParams
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75977f0ca8247e66$export$2e2bcd8739ae039), {
                componentName: "accountDetailsGrid"
            })
        ]
    });
}
$aa56e6ca1b280614$export$2e2bcd8739ae039.propTypes = {
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    gridLayout: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    prepAndValidateOutputData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    postCategoryItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    runSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setRunSave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    customDropdownSources: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)),
    customOnChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    saveDialogPromiseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    scrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    setScrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    afterCancelGoTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    customFilter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    transformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$aa56e6ca1b280614$export$2e2bcd8739ae039.defaultProps = {
    gridLayout: null,
    customDropdownSources: {},
    customOnChange: ()=>{},
    saveDialogPromiseCallback: (resolve)=>resolve(null),
    scrollToRow: undefined,
    setScrollToRow: ()=>{},
    afterCancelGoTo: "table",
    customFilter: false,
    transformationParams: {},
    setTransformationParams: ()=>{}
};


/* eslint-disable max-len */ // RULES:
// - hidden columns come last
// - dropdown column requires a source parameter containing the array of options
// IMPLEMENTATION:
// - for stocks, split shall be editable and must enforce n:n format by using mask or a custom function: https://bossanova.uk/jspreadsheet/v2/examples/currency-and-masking-numbers
// CAUTION: adding / removing a new column requires adding / removing from account.tags.gridColWidths (array of number, which needs to correspond to actual number of columns)


const $b19957485b14a8c8$var$transactionTypes = (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("app:schema.transactionTypes", {
    returnObjects: true
}); // returns { purchase: 'Purchase', sale: 'Sale', split: 'Split' }
const $b19957485b14a8c8$var$transactionTypesSource = Object.entries($b19957485b14a8c8$var$transactionTypes).map(([id, name])=>({
        id: id,
        name: name
    }));
const $b19957485b14a8c8$var$depositsTransactions = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "otherParty",
        type: "string"
    },
    {
        id: "otherPartyAccount",
        type: "string"
    },
    {
        id: "description",
        type: "string"
    },
    {
        id: "accountCurrencyAmount",
        usesHeader: "amount",
        type: "secondaryCurrency"
    },
    {
        id: "fxCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "fxAmount",
        type: "number"
    },
    {
        id: "fxRate",
        type: "number4Decimals",
        readOnly: true
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "currency",
        type: "hidden"
    },
    {
        id: "label",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$depositsDuplicates = [
    {
        id: "keepFlag",
        type: "checkbox"
    },
    {
        id: "source",
        type: "string",
        readOnly: true
    },
    {
        id: "date",
        type: "date",
        readOnly: true
    },
    {
        id: "otherParty",
        type: "string",
        readOnly: true
    },
    {
        id: "otherPartyAccount",
        type: "string",
        readOnly: true
    },
    {
        id: "description",
        type: "string",
        readOnly: true
    },
    {
        id: "accountCurrencyAmount",
        usesHeader: "amount",
        type: "secondaryCurrency",
        readOnly: true
    },
    {
        id: "fxCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603),
        readOnly: true
    },
    {
        id: "fxAmount",
        type: "number",
        readOnly: true
    },
    {
        id: "fxRate",
        type: "number4Decimals",
        readOnly: true
    },
    {
        id: "id",
        type: "hidden",
        readOnly: true
    },
    {
        id: "currency",
        type: "hidden",
        readOnly: true
    },
    {
        id: "label",
        type: "hidden",
        readOnly: true
    }
];
// CAUTION: adding / removing a new column requires adding / removing from account.tags.gridColWidths (array of number, which needs to correspond to actual number of columns)
// CAUTION: there is a customOnChange function for stocks which derives the "displayName" field from the dropdown of "displaySymbol"
// as they work based on column indices, update them in accountDetails/transactions/stocks when changing the sequence of this object
const $b19957485b14a8c8$var$stocksTransactions = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "displaySymbol",
        type: "customDropdown",
        usesHeader: "symbol",
        width: 150
    },
    {
        id: "displayName",
        type: "string"
    },
    {
        id: "transactionType",
        type: "dropdown",
        source: $b19957485b14a8c8$var$transactionTypesSource,
        width: 150
    },
    {
        id: "split",
        type: "string"
    },
    {
        id: "transactionAmount",
        type: "number0Decimals"
    },
    {
        id: "transactionOriginalPrice",
        type: "number",
        usesHeader: "transactionPrice"
    },
    {
        id: "transactionCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "rebasedOriginalValue",
        type: "number",
        readOnly: true
    },
    {
        id: "rebasedValue",
        type: "currency",
        readOnly: true
    },
    {
        id: "rebasedAmount",
        type: "number0Decimals",
        readOnly: true
    },
    {
        id: "rebasedOriginalPrice",
        type: "number",
        readOnly: true
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "assetId",
        type: "hidden"
    },
    {
        id: "providerAssetId",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$stocksDuplicates = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "displaySymbol",
        type: "string",
        usesHeader: "symbol"
    },
    {
        id: "displayName",
        type: "string",
        usesHeader: "description"
    },
    {
        id: "transactionAmount",
        type: "number0Decimals"
    },
    {
        id: "transactionOriginalPrice",
        type: "number",
        usesHeader: "transactionPrice"
    },
    {
        id: "transactionCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "assetId",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$realEstateTransactions = [
    {
        id: "date",
        type: "date"
    },
    // { id: 'transactionType', type: 'dropdown', source: ['purchase', 'sale'] },
    {
        id: "transactionType",
        type: "dropdown",
        source: $b19957485b14a8c8$var$transactionTypesSource.filter((x)=>x.id !== "split")
    },
    {
        id: "price",
        type: "currency0Decimals"
    },
    {
        id: "currency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "originalPrice",
        type: "currency0Decimals"
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "amount",
        type: "hidden"
    },
    {
        id: "assetId",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$objectsOfValueTransactions = [
    {
        id: "date",
        type: "date"
    },
    // { id: 'transactionType', type: 'dropdown', source: ['purchase', 'sale'] },
    {
        id: "transactionType",
        type: "dropdown",
        source: $b19957485b14a8c8$var$transactionTypesSource.filter((x)=>x.id !== "split"),
        width: 150
    },
    {
        id: "description",
        type: "string",
        width: 200
    },
    {
        id: "quantity",
        type: "number",
        usesHeader: "amount"
    },
    {
        id: "valueTransactionCurrency",
        type: "currency",
        width: 200
    },
    {
        id: "transactionCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "valueAccountCurrency",
        type: "currency"
    },
    {
        id: "valueBaseCurrency",
        type: "currency",
        width: 200
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "assetId",
        type: "hidden"
    }
];
// CAUTION: adding / removing a new column requires adding / removing from account.tags.gridColWidths (array of number, which needs to correspond to actual number of columns)
const $b19957485b14a8c8$var$loansTransactions = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "otherPartyIban",
        type: "string",
        usesHeader: "iban"
    },
    {
        id: "description",
        type: "string"
    },
    {
        id: "quantity",
        type: "currency",
        usesHeader: "principal"
    },
    {
        id: "quantityInterest",
        type: "currency",
        usesHeader: "interest"
    },
    {
        id: "fxCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "fxAmount",
        type: "number"
    },
    {
        id: "fxAmountInterest",
        type: "number"
    },
    {
        id: "fxRate",
        type: "number4Decimals",
        readOnly: true
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "accountCurrency",
        type: "hidden"
    },
    {
        id: "label",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$pensionTransactions = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "description",
        type: "string",
        width: 500
    },
    {
        id: "quantity",
        usesHeader: "amount",
        type: "currency"
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "currency",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$metalsList = Object.entries((0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("app:schema.metals.transaction.parameters.assetMetal", {
    returnObjects: true
})) // returns { gold: 'Gold', silver: 'Silver'...}
.map(([id, name])=>({
        id: id,
        name: name
    }));
// CAUTION: there is a customOnChange function for stocks which derives the "displayName" field from the dropdown of "displaySymbol"
// as they work based on column indices, update them in accountDetails/transactions/stocks when changing the sequence of this object
const $b19957485b14a8c8$var$metalsTransactions = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "assetName",
        type: "customDropdown",
        width: 150
    },
    {
        id: "assetMetal",
        type: "dropdown",
        source: $b19957485b14a8c8$var$metalsList
    },
    {
        id: "assetWeight",
        type: "number"
    },
    {
        id: "assetPurity",
        type: "number0Decimals"
    },
    {
        id: "assetAdditionalValue",
        type: "number"
    },
    {
        id: "quantity",
        type: "number0Decimals"
    },
    {
        id: "uptc",
        type: "number",
        usesHeader: "transactionPrice"
    },
    {
        id: "transactionCurrency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "transactionCurrencyValue",
        type: "number"
    },
    {
        id: "upac",
        type: "number",
        usesHeader: "transactionPrice"
    },
    {
        id: "transactionValue",
        type: "number"
    },
    {
        id: "id",
        type: "hidden"
    },
    {
        id: "accountCurrency",
        type: "hidden"
    },
    {
        id: "assetId",
        type: "hidden"
    }
];
// CAUTION: adding / removing a new column requires adding / removing from account.tags.gridColWidths (array of number, which needs to correspond to actual number of columns)
const $b19957485b14a8c8$var$stocksQuotes = [
    // { id: 'displaySymbol', type: 'string', usesHeader: 'assetId' },
    // dropdownDynamic is a native jspreadsheet dropdown which is populated at render time (to avoid problem with data not being refreshed)
    // dropdownDynamic requires the same format of column source as customDropdown
    {
        id: "displaySymbol",
        type: "dropdownDynamic",
        usesHeader: "symbol",
        width: 175
    },
    {
        id: "date",
        type: "date"
    },
    {
        id: "source",
        type: "string",
        readOnly: true
    },
    {
        id: "quoteBaseCurrency",
        usesHeader: "price",
        type: "currency"
    },
    {
        id: "currency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "quote",
        usesHeader: "originalPrice",
        type: "number"
    }
];
const $b19957485b14a8c8$var$realEstateQuotes = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "source",
        type: "string",
        readOnly: true
    },
    {
        id: "quoteBaseCurrency",
        usesHeader: "price",
        type: "currency0Decimals"
    },
    {
        id: "currency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "quote",
        usesHeader: "originalPrice",
        type: "number0Decimals"
    },
    {
        id: "pricePerSquareMetre",
        type: "currency0Decimals",
        readOnly: true
    },
    {
        id: "originalPricePerSquareMetre",
        type: "number0Decimals",
        readOnly: true
    },
    {
        id: "assetId",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$objectsOfValueQuotes = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "source",
        type: "string",
        readOnly: true
    },
    {
        id: "quote",
        usesHeader: "originalPrice",
        type: "number0Decimals"
    },
    {
        id: "currency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603),
        readOnly: true
    },
    {
        id: "quoteBaseCurrency",
        usesHeader: "price",
        type: "currency0Decimals"
    },
    {
        id: "note",
        type: "string",
        width: 300
    },
    {
        id: "assetId",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$pensionQuotes = [
    {
        id: "date",
        type: "date"
    },
    {
        id: "payoutOnlyContributionsToDate",
        type: "currency",
        width: 300
    },
    {
        id: "payoutOnlyContributionsToDateIndexed",
        type: "currency",
        width: 350
    },
    {
        id: "payoutAllPlannedContributions",
        type: "currency",
        width: 300
    },
    {
        id: "payoutAllPlannedContributionsIndexed",
        type: "currency",
        width: 350
    },
    {
        id: "payoutLumpSumVerrentet",
        type: "currency",
        width: 300
    },
    {
        id: "currency",
        type: "hidden"
    }
];
const $b19957485b14a8c8$var$metalsQuotes = [
    {
        id: "assetName",
        type: "dropdownDynamic",
        usesHeader: "assetId",
        width: 200
    },
    {
        id: "date",
        type: "date"
    },
    {
        id: "source",
        type: "string",
        readOnly: true
    },
    {
        id: "quoteBaseCurrency",
        usesHeader: "price",
        type: "currency"
    },
    {
        id: "currency",
        type: "dropdown",
        source: (0, $796ea4636350e237$export$a01df35ce0858603)
    },
    {
        id: "quote",
        usesHeader: "originalPrice",
        type: "number"
    },
    {
        id: "note",
        type: "string"
    }
];
function $b19957485b14a8c8$export$2e2bcd8739ae039(category, mode, displayedComponent = "grid") {
    if (!category || !mode) return [];
    if ([
        "grid",
        "table"
    ].includes(displayedComponent) && mode === "quotes") switch(category){
        case "realEstate":
            return $b19957485b14a8c8$var$realEstateQuotes;
        case "stocks":
        case "crypto":
            return $b19957485b14a8c8$var$stocksQuotes;
        case "pension":
            return $b19957485b14a8c8$var$pensionQuotes;
        case "objectsOfValue":
            return $b19957485b14a8c8$var$objectsOfValueQuotes;
        case "metals":
            return $b19957485b14a8c8$var$metalsQuotes;
        default:
            return [];
    }
    if ([
        "grid",
        "table"
    ].includes(displayedComponent) && mode === "holdings") switch(category){
        case "deposits":
            return $b19957485b14a8c8$var$depositsTransactions;
        case "stocks":
        case "crypto":
            return $b19957485b14a8c8$var$stocksTransactions;
        case "realEstate":
            return $b19957485b14a8c8$var$realEstateTransactions;
        case "loans":
            return $b19957485b14a8c8$var$loansTransactions;
        case "pension":
            return $b19957485b14a8c8$var$pensionTransactions;
        case "objectsOfValue":
            return $b19957485b14a8c8$var$objectsOfValueTransactions;
        case "metals":
            return $b19957485b14a8c8$var$metalsTransactions;
        default:
            return [];
    }
    if (displayedComponent === "duplicate") {
        if (category === "deposits") return $b19957485b14a8c8$var$depositsDuplicates;
        if (category === "stocks" && mode === "holdings") return $b19957485b14a8c8$var$stocksDuplicates;
        if (category === "stocks" && mode === "quotes") return $b19957485b14a8c8$var$stocksQuotes;
    }
    return [];
}




function $9d0664c3634384b7$export$2e2bcd8739ae039({ account: account, setAccount: setAccount, data: data, tableState: tableState, mode: mode, prepAndValidateOutputData: prepAndValidateOutputData, postCategoryItems: postCategoryItems, displayedComponent: displayedComponent, displayedData: displayedData, handleClick: handleClick, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent, customDropdownSources: customDropdownSources, customOnChange: customOnChange, saveDialogPromiseCallback: saveDialogPromiseCallback }) {
    // expecting data to be an array of objects
    // each object should have exactly the same keys as there are columns in the grid + an id AS THE LAST COLUMN
    const [runSave, setRunSave] = (0, $7fPBF.useState)(false); // if this turns to true, the Grid component will execute handleSaveWrapper
    // we are using state to manage that becuase handleSaveWrapper must run in the context of Grid, not here
    const gridLayout = (0, $b19957485b14a8c8$export$2e2bcd8739ae039)(account.category, mode);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                buttonsToShow: (0, $f808db98154b70a0$export$2e2bcd8739ae039)(account.category, displayedComponent, displayedData),
                displayedComponent: displayedComponent,
                displayedData: displayedData,
                handleClick: handleClick,
                handleSave: ()=>setRunSave(true),
                userChangesPresent: userChangesPresent
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa56e6ca1b280614$export$2e2bcd8739ae039), {
                account: account,
                setAccount: setAccount,
                data: data,
                gridLayout: gridLayout,
                prepAndValidateOutputData: prepAndValidateOutputData,
                postCategoryItems: postCategoryItems,
                tableState: tableState,
                displayedComponent: displayedComponent,
                handleClick: handleClick,
                userChangesPresent: userChangesPresent,
                setUserChangesPresent: setUserChangesPresent,
                runSave: runSave,
                setRunSave: setRunSave,
                customDropdownSources: customDropdownSources,
                customOnChange: customOnChange,
                saveDialogPromiseCallback: saveDialogPromiseCallback
            })
        ]
    });
}
$9d0664c3634384b7$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    prepAndValidateOutputData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    postCategoryItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    customDropdownSources: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)),
    customOnChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    saveDialogPromiseCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$9d0664c3634384b7$export$2e2bcd8739ae039.defaultProps = {
    customDropdownSources: {},
    customOnChange: ()=>{},
    saveDialogPromiseCallback: (resolve)=>resolve(null)
};



/* eslint-disable react/forbid-prop-types */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2cbb4f2e2e11bd18$var$ArrowPathIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z",
        clipRule: "evenodd"
    }));
}
const $2cbb4f2e2e11bd18$var$ForwardRef = $7fPBF.forwardRef($2cbb4f2e2e11bd18$var$ArrowPathIcon);
var $2cbb4f2e2e11bd18$export$2e2bcd8739ae039 = $2cbb4f2e2e11bd18$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $67c359ee2ca35a0c$var$CloudArrowUpIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M5.5 17a4.5 4.5 0 0 1-1.44-8.765 4.5 4.5 0 0 1 8.302-3.046 3.5 3.5 0 0 1 4.504 4.272A4 4 0 0 1 15 17H5.5Zm3.75-2.75a.75.75 0 0 0 1.5 0V9.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0l-3.25 3.5a.75.75 0 1 0 1.1 1.02l1.95-2.1v4.59Z",
        clipRule: "evenodd"
    }));
}
const $67c359ee2ca35a0c$var$ForwardRef = $7fPBF.forwardRef($67c359ee2ca35a0c$var$CloudArrowUpIcon);
var $67c359ee2ca35a0c$export$2e2bcd8739ae039 = $67c359ee2ca35a0c$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $81d773ef7a32fb70$var$LockClosedIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
        clipRule: "evenodd"
    }));
}
const $81d773ef7a32fb70$var$ForwardRef = $7fPBF.forwardRef($81d773ef7a32fb70$var$LockClosedIcon);
var $81d773ef7a32fb70$export$2e2bcd8739ae039 = $81d773ef7a32fb70$var$ForwardRef;



function $111ad0445d705e89$export$2e2bcd8739ae039({ displayedData: displayedData, showSync: showSync, showImport: showImport, category: category, connectedAccounts: connectedAccounts, handleNavigateToAccount: handleNavigateToAccount }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "gettingStarted"
    });
    const { heading: heading, subheading: subheading, intro: intro, features: features } = (()=>{
        if (displayedData === "cashflow") return {
            heading: t("cashflow.heading"),
            subheading: t("cashflow.subheading"),
            intro: t("cashflow.intro"),
            features: []
        };
        if (displayedData === "values") return {
            heading: t("values.heading"),
            subheading: t("values.subheading"),
            intro: t("values.intro"),
            features: [
                {
                    name: t("values.features.0.name"),
                    description: t("values.features.0.description"),
                    icon: (0, $81d773ef7a32fb70$export$2e2bcd8739ae039)
                },
                {
                    name: t("values.features.1.name"),
                    description: t("values.features.1.description"),
                    icon: (0, $67c359ee2ca35a0c$export$2e2bcd8739ae039)
                }
            ]
        };
        const holdingsFeatures = [
            {
                name: t("features.0.name"),
                description: t("features.0.description"),
                icon: (0, $67c359ee2ca35a0c$export$2e2bcd8739ae039)
            }
        ];
        if (showImport) holdingsFeatures.push({
            name: t("features.1.name"),
            description: t("features.1.description"),
            icon: (0, $81d773ef7a32fb70$export$2e2bcd8739ae039)
        });
        if (showSync) holdingsFeatures.push({
            name: t("features.2.name"),
            description: t("features.2.description"),
            icon: (0, $2cbb4f2e2e11bd18$export$2e2bcd8739ae039)
        });
        return {
            heading: t("heading"),
            subheading: t("subheading"),
            intro: t("intro"),
            features: holdingsFeatures
        };
    })();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white py-8 w-full",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mx-auto max-w-3xl lg:text-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "text-base font-semibold leading-8 tracking-wide text-brandBlue-500 uppercase",
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: `mt-2 ${displayedData === "cashflow" ? "text-2xl sm:text-3xl font-semibold" : "text-3xl sm:text-4xl font-bold"} text-gray-900`,
                            children: subheading
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-4 text-base leading-7 text-gray-600",
                            children: intro
                        }),
                        displayedData === "cashflow" && ((connectedAccounts === null || connectedAccounts === void 0 ? void 0 : connectedAccounts.length) || 0) > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "mt-4 space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-base leading-6 text-gray-700",
                                    children: t("cashflow.navigateIntro")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "flex flex-wrap gap-2 justify-center pt-6",
                                    children: connectedAccounts.map((acc)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            text: acc.name,
                                            withAccent: true,
                                            size: "xl",
                                            onClick: ()=>handleNavigateToAccount && handleNavigateToAccount(acc.id),
                                            formatting: "!min-w-0"
                                        }, acc.id))
                                })
                            ]
                        })
                    ]
                }),
                features.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mx-auto mt-8 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                        className: "grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3",
                        children: features.map((feature, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    features.length === 2 && idx === 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                                className: "flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(feature.icon, {
                                                        className: "h-5 w-5 flex-none text-brandBlue-500",
                                                        "aria-hidden": "true"
                                                    }),
                                                    feature.name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                                className: "mt-4 flex flex-auto flex-col text-base leading-6 text-gray-600",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "flex-auto",
                                                    children: feature.description
                                                })
                                            })
                                        ]
                                    }, feature.name)
                                ]
                            }))
                    })
                })
            ]
        })
    });
}
$111ad0445d705e89$export$2e2bcd8739ae039.propTypes = {
    showSync: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    showImport: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "holdings",
        "cashflow",
        "quotes",
        "values"
    ]),
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    connectedAccounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    handleNavigateToAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$111ad0445d705e89$export$2e2bcd8739ae039.defaultProps = {
    showSync: false,
    showImport: false,
    displayedData: "holdings",
    category: null,
    connectedAccounts: [],
    handleNavigateToAccount: null
};




var $0033f1d46ad308e0$exports = {};

$parcel$export($0033f1d46ad308e0$exports, "categoryOrderedObject", function () { return $0033f1d46ad308e0$export$3270e954cce20150; });
$parcel$export($0033f1d46ad308e0$exports, "applyCategorySpecificChanges", function () { return $0033f1d46ad308e0$export$c6abce4536815011; });
$parcel$export($0033f1d46ad308e0$exports, "outputTransformCategoryTransactions", function () { return $0033f1d46ad308e0$export$39b64bc498225d58; });
$parcel$export($0033f1d46ad308e0$exports, "postCategoryItems", function () { return $0033f1d46ad308e0$export$37bc17007772d2e3; });
$parcel$export($0033f1d46ad308e0$exports, "handleSync", function () { return $0033f1d46ad308e0$export$3195655de7cb0f02; });
$parcel$export($0033f1d46ad308e0$exports, "getSortingCallback", function () { return $0033f1d46ad308e0$export$5c6817526d88585b; });
// CATEGORY MODULE FOR REAL ESTATE / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $0033f1d46ad308e0$var$debugLevel = 0;
function $0033f1d46ad308e0$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function realEstateOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            transactionType: transaction.transactionType,
            price: transaction.price || "",
            currency: transaction.currency || "",
            originalPrice: transaction.originalPrice || "",
            id: transaction.id,
            amount: Number(transaction.amount) || "",
            assetId: transaction.assetId
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
const $0033f1d46ad308e0$var$depositTransactionLabels = (0, $a368196802fe263c$export$c3326d1eadff13bd).map((l)=>l.split("-")[1]);
const $0033f1d46ad308e0$var$depositIncomeTransactionLabels = (0, $a368196802fe263c$export$c58f7ddceaf8469f).map((l)=>l.split("-")[1]);
const $0033f1d46ad308e0$var$depositExpenseTransactionLabels = (0, $a368196802fe263c$export$47220dfe2b0dcc85).map((l)=>l.split("-")[1]);
function $0033f1d46ad308e0$export$c6abce4536815011(transactions, account = null, displayedComponent = "table", quotes = []) {
    var _state_user_profile_settings, _state_user_profile, _state_user;
    // <- receives some parameters and
    if (displayedComponent === "grid") return transactions.map($0033f1d46ad308e0$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const baseCurrency = ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    // if this is a TABLE, we need a more complex transformation
    // 'transactions' for table is a different object: it is the 'stocks.accountId' branch of completeAssetsView
    // described here: https://monestry.atlassian.net/l/cp/t1S1KbTF
    // in other words, an object with keys being accountIds and values being arrays of transactions belonging to that account + all related  deposit transactions sorted ascending by date
    // this is essentially the same code as in stocks (minus the summary row), but as long as field names are not synchronised among asset categories, it needs to be slightly different
    return Object.keys(transactions).reduce((acc, assetId)=>{
        // for each assetId: { object }
        const depositTransactions = transactions[assetId].filter((x)=>$0033f1d46ad308e0$var$depositTransactionLabels.includes(x.rowType)).map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                payoutOrFeePerPiece: x.amount / x.positionOnDate
            }));
        // let's sort out transactions first
        const singleTransactions = transactions[assetId].filter((item)=>item.rowType === "purchase") // leave only purchases which have not been sold yet
        .map((item)=>{
            var _quotes_item_assetId_current, _quotes_item_assetId;
            const openPositionSize = item.amount;
            const purchaseValue = item.price;
            const currentQuote = (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : (_quotes_item_assetId_current = _quotes_item_assetId.current) === null || _quotes_item_assetId_current === void 0 ? void 0 : _quotes_item_assetId_current.quote;
            const currentValue = currentQuote;
            const dividendsPerPieceSincePurchase = depositTransactions.filter((x)=>x.date >= item.date && $0033f1d46ad308e0$var$depositIncomeTransactionLabels.includes(x.rowType)).reduce((acc2, curr2)=>acc2 + curr2.payoutOrFeePerPiece, 0);
            const dividendsSincePurchase = openPositionSize * dividendsPerPieceSincePurchase;
            const thisTransactionFees = depositTransactions// has a linkedTransaction which has the same id as the current item
            .filter((x)=>$0033f1d46ad308e0$var$depositExpenseTransactionLabels.includes(x.rowType) && x.linkedTransactions.findIndex((lt)=>lt.id === item.id) > -1).reduce((acc2, curr2)=>acc2 + curr2.amount, 0);
            const accountCostShareSincePurchase = transactions[account.id] // account-level cost are not linked to any assetId
            .filter((x)=>x.date >= item.date && x.rowType === "costs").reduce((acc2, curr2)=>acc2 + curr2.amount, 0) / Object.keys(transactions).length; // divide equally per assetId within one account
            const fees = thisTransactionFees + accountCostShareSincePurchase;
            return (0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, item), {
                currency: baseCurrency,
                openPositionSize: openPositionSize,
                purchaseValue: purchaseValue,
                currentValue: currentValue,
                currentQuote: currentQuote,
                dividendsSincePurchase: dividendsSincePurchase,
                fees: fees
            }), item.rebasedAmount !== item.transactionAmount && {
                isPreSplitTransaction: true
            }), {
                roi: (currentValue + dividendsSincePurchase + fees - purchaseValue) / purchaseValue,
                roiAnnual: ((currentValue + dividendsSincePurchase + fees) / purchaseValue) ** (1 / ((new Date().valueOf() - item.date) / 31536000000)) - 1
            });
        });
        if ($0033f1d46ad308e0$var$debugLevel > 2) console.log("singleTransactions", singleTransactions);
        // summary row is not necessary for real estate
        return [
            ...acc,
            ...singleTransactions
        ];
    }, []);
}
function $0033f1d46ad308e0$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            amount: item.transactionType === "purchase" ? 1 : -1
        });
    };
}
function $0033f1d46ad308e0$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        accountId: account.id,
        category: "realEstate"
    });
}
function $0033f1d46ad308e0$export$3195655de7cb0f02(accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dfb022681f1048bc)({
        category: "realEstate"
    }));
}
function $0033f1d46ad308e0$var$compare(a, b, propertyName, asc = true) {
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}
function $0033f1d46ad308e0$export$5c6817526d88585b(tableState) {
    return function sortingCallback(a, b) {
        // reverse sorting order if date is selected a
        // localeCompare compares strings according to rules of the current locale, returns -1, 0, 1
        let compareFigi = a.assetId.localeCompare(b.assetId);
        if (tableState.sortBy === "date" && !tableState.sortDirectionAsc) compareFigi = -a.assetId.localeCompare(b.assetId);
        // sort by symbol, then sort the total row first and then sort the rest by the column
        return compareFigi || !!b.isSummaryRow - !!a.isSummaryRow || $0033f1d46ad308e0$var$compare(a, b, tableState.sortBy, tableState.sortDirectionAsc);
    };
}



var $c877821ee984759a$exports = {};

$parcel$export($c877821ee984759a$exports, "categoryOrderedObject", function () { return $c877821ee984759a$export$3270e954cce20150; });
$parcel$export($c877821ee984759a$exports, "applyCategorySpecificChanges", function () { return $c877821ee984759a$export$c6abce4536815011; });
$parcel$export($c877821ee984759a$exports, "outputTransformCategoryTransactions", function () { return $c877821ee984759a$export$39b64bc498225d58; });
$parcel$export($c877821ee984759a$exports, "postCategoryItems", function () { return $c877821ee984759a$export$37bc17007772d2e3; });
$parcel$export($c877821ee984759a$exports, "handleSync", function () { return $c877821ee984759a$export$3195655de7cb0f02; });
// CATEGORY MODULE FOR DEPOSITS / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $c877821ee984759a$export$3270e954cce20150(account = null, displayedComponent = "table") {
    return function depositsOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            otherParty: transaction.otherParty,
            otherPartyAccount: transaction.otherPartyAccount,
            description: transaction.description,
            accountCurrencyAmount: transaction.accountCurrencyAmount,
            fxCurrency: transaction.fxCurrency,
            fxAmount: transaction.fxAmount,
            fxRate: transaction.fxAmount ? transaction.accountCurrencyAmount / (transaction.fxAmount || 1) : "",
            id: transaction.id,
            currency: transaction.currency,
            label: transaction.label
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
function $c877821ee984759a$export$c6abce4536815011(transactions, account = null, displayedComponent = "table") {
    return transactions.map($c877821ee984759a$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
}
function $c877821ee984759a$export$39b64bc498225d58(account = null) {
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return item;
    };
}
function $c877821ee984759a$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "deposits",
        accountId: account.id
    });
}
function $c877821ee984759a$export$3195655de7cb0f02(category, accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: category,
        accountId: accountId
    }));
}


var $8d692f3847e85ce3$exports = {};

$parcel$export($8d692f3847e85ce3$exports, "categoryOrderedObject", function () { return $8d692f3847e85ce3$export$3270e954cce20150; });
$parcel$export($8d692f3847e85ce3$exports, "applyCategorySpecificChanges", function () { return $8d692f3847e85ce3$export$c6abce4536815011; });
$parcel$export($8d692f3847e85ce3$exports, "outputTransformCategoryTransactions", function () { return $8d692f3847e85ce3$export$39b64bc498225d58; });
$parcel$export($8d692f3847e85ce3$exports, "postCategoryItems", function () { return $8d692f3847e85ce3$export$37bc17007772d2e3; });
$parcel$export($8d692f3847e85ce3$exports, "handleSync", function () { return $8d692f3847e85ce3$export$3195655de7cb0f02; });
// CATEGORY MODULE FOR LOANS / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $8d692f3847e85ce3$export$3270e954cce20150(account = null, displayedComponent = "table") {
    return function depositsOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            otherPartyIban: transaction.otherPartyIban,
            description: transaction.description,
            quantity: transaction.quantity,
            quantityInterest: transaction.quantityInterest,
            fxCurrency: transaction.transactionCurrency && transaction.uptc ? transaction.transactionCurrency : null,
            fxAmount: transaction.transactionCurrency && transaction.uptc ? transaction.quantity * transaction.uptc : null,
            fxAmountInterest: transaction.transactionCurrency && transaction.uptc ? transaction.quantityInterest * transaction.uptc : null,
            fxRate: transaction.transactionCurrency && transaction.uptc ? transaction.uptc : null,
            id: transaction.id,
            accountCurrency: transaction.accountCurrency
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
function $8d692f3847e85ce3$export$c6abce4536815011(transactions, account = null, displayedComponent = "table") {
    return transactions.map($8d692f3847e85ce3$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
}
function $8d692f3847e85ce3$export$39b64bc498225d58(account = null) {
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        // the complexity of getting an async currency from provider is significant
        // let us assume for the moment that we do not allow transactions without quantity (in account currency)
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            upac: 1,
            upbc: null,
            uptc: item.quantity !== 0 ? Number(item.fxAmount / item.quantity) : null,
            quantityInterest: !item.quantityInterest ? 0 : Number(item.quantityInterest),
            transactionCurrency: item.fxCurrency,
            accountCurrency: account.currency,
            assetCurrency: account.currency,
            projectId: account.connectedProjectId || null
        });
    };
}
function $8d692f3847e85ce3$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "loans",
        accountId: account.id
    });
}
function $8d692f3847e85ce3$export$3195655de7cb0f02(category, accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: category,
        accountId: accountId
    }));
}


var $e39b94827b3f8eb9$exports = {};

$parcel$export($e39b94827b3f8eb9$exports, "categoryOrderedObject", function () { return $e39b94827b3f8eb9$export$3270e954cce20150; });
$parcel$export($e39b94827b3f8eb9$exports, "applyCategorySpecificChanges", function () { return $e39b94827b3f8eb9$export$c6abce4536815011; });
$parcel$export($e39b94827b3f8eb9$exports, "outputTransformCategoryTransactions", function () { return $e39b94827b3f8eb9$export$39b64bc498225d58; });
$parcel$export($e39b94827b3f8eb9$exports, "postCategoryItems", function () { return $e39b94827b3f8eb9$export$37bc17007772d2e3; });
$parcel$export($e39b94827b3f8eb9$exports, "handleSync", function () { return $e39b94827b3f8eb9$export$3195655de7cb0f02; });
// CATEGORY MODULE FOR PENSION / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $e39b94827b3f8eb9$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function depositsOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(""),
            description: transaction.description,
            quantity: transaction.quantity,
            label: transaction.label,
            id: transaction.id,
            accountCurrency: transaction.accountCurrency
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
function $e39b94827b3f8eb9$export$c6abce4536815011(transactions, account = null, displayedComponent = "table") {
    // <- receives some parameters and
    return transactions.map($e39b94827b3f8eb9$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
}
function $e39b94827b3f8eb9$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            upac: 1,
            upbc: null,
            uptc: null,
            transactionCurrency: null,
            accountCurrency: account.currency,
            assetCurrency: account.currency,
            projectId: account.connectedProjectId || null
        });
    };
}
function $e39b94827b3f8eb9$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "pension",
        accountId: account.id
    });
}
function $e39b94827b3f8eb9$export$3195655de7cb0f02(category, accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: category,
        accountId: accountId
    }));
}


var $8d8bfc7b432dafaf$exports = {};

$parcel$export($8d8bfc7b432dafaf$exports, "categoryOrderedObject", function () { return $8d8bfc7b432dafaf$export$3270e954cce20150; });
$parcel$export($8d8bfc7b432dafaf$exports, "applyCategorySpecificChanges", function () { return $8d8bfc7b432dafaf$export$c6abce4536815011; });
$parcel$export($8d8bfc7b432dafaf$exports, "outputTransformCategoryTransactions", function () { return $8d8bfc7b432dafaf$export$39b64bc498225d58; });
$parcel$export($8d8bfc7b432dafaf$exports, "postCategoryItems", function () { return $8d8bfc7b432dafaf$export$37bc17007772d2e3; });
$parcel$export($8d8bfc7b432dafaf$exports, "handleSync", function () { return $8d8bfc7b432dafaf$export$3195655de7cb0f02; });
$parcel$export($8d8bfc7b432dafaf$exports, "getSortingCallback", function () { return $8d8bfc7b432dafaf$export$5c6817526d88585b; });
// CATEGORY MODULE FOR REAL ESTATE / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");




(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $8d8bfc7b432dafaf$var$debugLevel = 3;
function $8d8bfc7b432dafaf$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function objectsOfValueOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            transactionType: transaction.transactionType,
            description: transaction.description,
            quantity: transaction.quantity || "",
            valueTransactionCurrency: transaction.uptc * transaction.quantity || "",
            transactionCurrency: transaction.transactionCurrency || "",
            valueAccountCurrency: transaction.quantity * transaction.upac || "",
            valueBaseCurrency: transaction.quantity * transaction.upbc || "",
            id: transaction.id,
            assetId: transaction.assetId
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
const $8d8bfc7b432dafaf$var$depositTransactionLabels = (0, $a368196802fe263c$export$c3326d1eadff13bd).map((l)=>l.split("-")[1]);
const $8d8bfc7b432dafaf$var$depositIncomeTransactionLabels = (0, $a368196802fe263c$export$c58f7ddceaf8469f).map((l)=>l.split("-")[1]);
const $8d8bfc7b432dafaf$var$depositExpenseTransactionLabels = (0, $a368196802fe263c$export$47220dfe2b0dcc85).map((l)=>l.split("-")[1]);
function $8d8bfc7b432dafaf$export$c6abce4536815011(transactions, account = null, displayedComponent = "table", quotes = []) {
    var _state_user_profile_settings, _state_user_profile, _state_user;
    // GRID
    if (displayedComponent === "grid") return transactions.map($8d8bfc7b432dafaf$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
    // TABLE
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const baseCurrency = ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    // if this is a TABLE, we need a more complex transformation
    // 'transactions' for table is a different object: it is the 'stocks.accountId' branch of completeAssetsView
    // described here: https://monestry.atlassian.net/l/cp/t1S1KbTF
    // in other words, an object with keys being accountIds and values being arrays of transactions belonging to that account + all related  deposit transactions sorted ascending by date
    // this is essentially the same code as in stocks (minus the summary row), but as long as field names are not synchronised among asset categories, it needs to be slightly different
    return Object.keys(transactions).reduce((acc, assetId)=>{
        // for each assetId: { object }
        const depositTransactionsThisAsset = transactions[assetId].filter((x)=>$8d8bfc7b432dafaf$var$depositTransactionLabels.includes(x.rowType)).map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                payoutOrFeePerPiece: x.quantity / x.positionOnDate
            }));
        // let's sort out transactions first
        const singleTransactions = transactions[assetId].filter((item)=>item.rowType === "purchase") // leave only purchases which have not been sold yet
        .map((item)=>{
            var _quotes_item_assetId_current, _quotes_item_assetId;
            const openPositionSize = item.quantity;
            const purchaseValue = item.quantity * item.upac;
            const currentQuote = (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : (_quotes_item_assetId_current = _quotes_item_assetId.current) === null || _quotes_item_assetId_current === void 0 ? void 0 : _quotes_item_assetId_current.quote;
            const currentValue = item.quantity * currentQuote;
            const dividendsPerPieceSincePurchase = depositTransactionsThisAsset.filter((x)=>x.date >= item.date && $8d8bfc7b432dafaf$var$depositIncomeTransactionLabels.includes(x.rowType)).reduce((acc2, curr2)=>acc2 + curr2.payoutOrFeePerPiece, 0);
            const dividendsSincePurchase = openPositionSize * dividendsPerPieceSincePurchase;
            const thisTransactionFees = depositTransactionsThisAsset// has a linkedTransaction which has the same id as the current item
            .filter((x)=>$8d8bfc7b432dafaf$var$depositExpenseTransactionLabels.includes(x.rowType) && x.linkedTransactions.findIndex((lt)=>lt.id === item.id) > -1).reduce((acc2, curr2)=>acc2 + curr2.quantity, 0);
            const accountCostShareSincePurchase = transactions[account.id] // account-level cost are not linked to any assetId
            .filter((x)=>x.date >= item.date && x.rowType === "costs").reduce((acc2, curr2)=>acc2 + curr2.quantity, 0) / Object.keys(transactions).length; // divide equally per assetId within one account
            const fees = thisTransactionFees + accountCostShareSincePurchase;
            return (0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, item), {
                currency: baseCurrency,
                openPositionSize: openPositionSize,
                purchaseValue: purchaseValue,
                currentValue: currentValue,
                currentQuote: currentQuote,
                dividendsSincePurchase: dividendsSincePurchase,
                fees: fees
            }), item.rebasedAmount !== item.transactionAmount && {
                isPreSplitTransaction: true
            }), {
                roi: (currentValue + dividendsSincePurchase + fees - purchaseValue) / purchaseValue,
                roiAnnual: ((currentValue + dividendsSincePurchase + fees) / purchaseValue) ** (1 / ((new Date().valueOf() - item.date) / 31536000000)) - 1,
                isSummaryRow: false
            });
        });
        if ($8d8bfc7b432dafaf$var$debugLevel > 2) console.log("singleTransactions", singleTransactions);
        // for each assetId in this account we need to calculate the summary row
        let summaryRow = null;
        let singleTransactionsWithParentRow = [];
        if (singleTransactions.length > 0) {
            summaryRow = singleTransactions.reduce((prev, curr)=>(0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    openPositionSize: (prev.openPositionSize || 0) + (curr.openPositionSize || 0),
                    purchaseValue: (prev.purchaseValue || 0) + curr.purchaseValue,
                    currentValue: (prev.currentValue || 0) + curr.currentValue,
                    dividendsSincePurchase: (prev.dividendsSincePurchase || 0) + curr.dividendsSincePurchase,
                    fees: (prev.fees || 0) + curr.fees,
                    numeratorRoiAnnualWeighted: (prev.numeratorRoiAnnualWeighted || 0) + (curr.roiAnnual || 0) * curr.quantityOpen,
                    numeratorTransactionPrice: (prev.numeratorTransactionPrice || 0) + (curr.quantity || 0) * curr.openPositionSize
                }), curr.itemHasFlag && {
                    itemHasFlag: curr.itemHasFlag
                }), {
                date: 1,
                assetId: assetId,
                displayName: account.name,
                currentQuoteBaseCurrency: singleTransactions[0].currentQuoteBaseCurrency
            });
            if ($8d8bfc7b432dafaf$var$debugLevel > 2) console.log("summaryRow", summaryRow);
            summaryRow = (0, $2qxEV._)((0, $9tqwB._)({}, summaryRow), {
                currency: baseCurrency,
                transactionPrice: summaryRow.numeratorTransactionPrice / summaryRow.openPositionSize,
                roi: (summaryRow.currentValue + summaryRow.dividendsSincePurchase + summaryRow.fees - summaryRow.purchaseValue) / summaryRow.purchaseValue,
                roiAnnual: summaryRow.numeratorRoiAnnualWeighted / summaryRow.openPositionSize,
                isSummaryRow: true
            });
            // each atomic row has a reference to the summary row
            // this is needed to sort the table correctly (see getSortingCallback below)
            singleTransactionsWithParentRow = singleTransactions.map((st)=>(0, $2qxEV._)((0, $9tqwB._)({}, st), {
                    parentSummaryRow: summaryRow
                }));
        }
        return [
            ...acc,
            ...singleTransactionsWithParentRow,
            ...summaryRow ? [
                summaryRow
            ] : []
        ];
    }, []);
}
function $8d8bfc7b432dafaf$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            upac: item.valueAccountCurrency || item.valueAccountCurrency === 0 ? item.valueAccountCurrency / item.quantity : null,
            upbc: item.valueBaseCurrency || item.valueBaseCurrency === 0 ? item.valueBaseCurrency / item.quantity : null,
            uptc: item.valueTransactionCurrency || item.valueTransactionCurrency === 0 ? item.valueTransactionCurrency / item.quantity : null,
            transactionCurrency: item.valueTransactionCurrency || item.valueTransactionCurrency === 0 ? item.transactionCurrency : null,
            accountCurrency: item.currency,
            assetCurrency: item.currency
        });
    };
}
function $8d8bfc7b432dafaf$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        accountId: account.id,
        category: "objectsOfValue"
    });
}
function $8d8bfc7b432dafaf$export$3195655de7cb0f02(accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dfb022681f1048bc)({
        category: "objectsOfValue"
    }));
}
function $8d8bfc7b432dafaf$var$compare(a, b, propertyName, asc = true) {
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}
function $8d8bfc7b432dafaf$export$5c6817526d88585b(tableState) {
    return function sortingCallback(a, b) {
        // reverse sorting order if date is selected a
        // localeCompare compares strings according to rules of the current locale, returns -1, 0, 1
        try {
            let compareFigi = a.assetId.localeCompare(b.assetId);
            if (tableState.sortBy === "date" && !tableState.sortDirectionAsc) compareFigi = -a.assetId.localeCompare(b.assetId);
            // this implements sorting by assetId's properties
            // applyCategorySpecificChanges has added a parentSummaryRow to each transaction
            // first sort by sortBy of the parentSummaryRow (or by itself if it IS a summary row)
            // then put summary rows first within the group and sort by sortBy within the group
            return $8d8bfc7b432dafaf$var$compare(a.parentSummaryRow || a, b.parentSummaryRow || b, tableState.sortBy, tableState.sortDirectionAsc) || !!b.isSummaryRow - !!a.isSummaryRow || $8d8bfc7b432dafaf$var$compare(a, b, tableState.sortBy, tableState.sortDirectionAsc);
        } catch (e) {
            if ($8d8bfc7b432dafaf$var$debugLevel > 2) console.log("error in getSortingCallback", e, "tableState", tableState, "a", a, "b", b);
            return 0;
        }
    };
}


var $aabe6e90eded8123$exports = {};

$parcel$export($aabe6e90eded8123$exports, "categoryOrderedObject", function () { return $aabe6e90eded8123$export$3270e954cce20150; });
$parcel$export($aabe6e90eded8123$exports, "applyCategorySpecificChanges", function () { return $aabe6e90eded8123$export$c6abce4536815011; });
$parcel$export($aabe6e90eded8123$exports, "getCustomDropdownSources", function () { return $aabe6e90eded8123$export$10e67feb6a48460e; });
$parcel$export($aabe6e90eded8123$exports, "getCustomOnChange", function () { return $aabe6e90eded8123$export$4d7d49026c1d0e29; });
$parcel$export($aabe6e90eded8123$exports, "outputTransformCategoryTransactions", function () { return $aabe6e90eded8123$export$39b64bc498225d58; });
$parcel$export($aabe6e90eded8123$exports, "additionalValidations", function () { return $aabe6e90eded8123$export$9f17ee6c2a47ab8b; });
$parcel$export($aabe6e90eded8123$exports, "postCategoryItems", function () { return $aabe6e90eded8123$export$37bc17007772d2e3; });
$parcel$export($aabe6e90eded8123$exports, "handleSync", function () { return $aabe6e90eded8123$export$3195655de7cb0f02; });
$parcel$export($aabe6e90eded8123$exports, "getSortingCallback", function () { return $aabe6e90eded8123$export$5c6817526d88585b; });
/* eslint-disable no-unsafe-optional-chaining */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $aabe6e90eded8123$var$debugLevel = 0;
function $aabe6e90eded8123$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function metalOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        const { assetName: assetName, assetMetal: assetMetal, assetWeight: assetWeight, assetPurity: assetPurity, assetAdditionalValue: assetAdditionalValue, quantity: quantity, uptc: uptc, transactionCurrency: transactionCurrency, upac: upac, accountCurrency: accountCurrency, assetId: assetId, id: id } = transaction;
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            assetName: assetName,
            assetMetal: assetMetal,
            assetWeight: assetWeight,
            assetPurity: assetPurity,
            assetAdditionalValue: assetAdditionalValue,
            quantity: quantity,
            uptc: uptc,
            transactionCurrency: transactionCurrency,
            transactionCurrencyValue: quantity * uptc || 0,
            upac: upac,
            transactionValue: quantity * upac || 0,
            id: transaction.id,
            accountCurrency: accountCurrency,
            assetId: transaction.assetId
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
const $aabe6e90eded8123$var$depositTransactionLabels = (0, $a368196802fe263c$export$c3326d1eadff13bd).map((l)=>l.split("-")[1]);
const $aabe6e90eded8123$var$depositIncomeTransactionLabels = (0, $a368196802fe263c$export$c58f7ddceaf8469f).map((l)=>l.split("-")[1]);
const $aabe6e90eded8123$var$depositExpenseTransactionLabels = (0, $a368196802fe263c$export$47220dfe2b0dcc85).map((l)=>l.split("-")[1]);
function $aabe6e90eded8123$export$c6abce4536815011(transactions, account = null, displayedComponent = "table", quotes = []) {
    var _state_user_profile_settings, _state_user_profile, _state_user;
    // <- receives some parameters and
    // GRID is easy
    if (displayedComponent === "grid") return transactions.map($aabe6e90eded8123$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const baseCurrency = ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    // if this is a TABLE, we need a more complex transformation
    // 'transactions' for table is a different object: it is the 'metals.accountId' branch of completeAssetsView
    // described here: https://monestry.atlassian.net/l/cp/t1S1KbTF
    // in other words, an object with keys being accountIds and values being arrays of transactions belonging to that account + all related  deposit transactions sorted ascending by date
    // this is essentially the same code as in stocks (minus the summary row), but as long as field names are not synchronised among asset categories, it needs to be slightly different
    console.log("DEBUG: applyCategorySpecificChanges", transactions);
    return Object.keys(transactions).reduce((acc, assetId)=>{
        // for each assetId: { object }
        const depositTransactionsThisAsset = transactions[assetId].filter((x)=>$aabe6e90eded8123$var$depositTransactionLabels.includes(x.rowType)).map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                payoutOrFeePerPiece: x.quantity / x.positionOnDate
            }));
        // let's sort out transactions first
        const singleTransactions = transactions[assetId].filter((item)=>item.rowType === "purchase") // leave only purchases which have not been sold yet
        .map((item)=>{
            var _quotes_item_assetId_current, _quotes_item_assetId;
            const openPositionSize = item.quantity;
            const purchaseValue = item.quantity * item.upac;
            const currentQuote = (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : (_quotes_item_assetId_current = _quotes_item_assetId.current) === null || _quotes_item_assetId_current === void 0 ? void 0 : _quotes_item_assetId_current.quote;
            const currentValue = item.quantity * currentQuote;
            const thisTransactionFees = depositTransactionsThisAsset// has a linkedTransaction which has the same id as the current item
            .filter((x)=>$aabe6e90eded8123$var$depositExpenseTransactionLabels.includes(x.rowType) && x.linkedTransactions.findIndex((lt)=>lt.id === item.id) > -1).reduce((acc2, curr2)=>acc2 + curr2.quantity, 0);
            const accountCostShareSincePurchase = (transactions[account.id] || [] // account-level cost are not linked to any assetId ([] handle case of no cost transactions)
            ).filter((x)=>x.date >= item.date && x.rowType === "costs").reduce((acc2, curr2)=>acc2 + curr2.quantity, 0) / Object.keys(transactions).length; // divide equally per assetId within one account
            const fees = thisTransactionFees + accountCostShareSincePurchase;
            return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                currency: baseCurrency,
                openPositionSize: openPositionSize,
                purchaseValue: purchaseValue,
                purchaseQuote: item.upac,
                currentValue: currentValue,
                currentQuote: currentQuote,
                fees: fees,
                roi: (currentValue + fees - purchaseValue) / purchaseValue,
                roiAnnual: ((currentValue + fees) / purchaseValue) ** (1 / ((new Date().valueOf() - item.date) / 31536000000)) - 1,
                isSummaryRow: false
            });
        });
        if ($aabe6e90eded8123$var$debugLevel > 2) console.log("singleTransactions", singleTransactions);
        // for each assetId in this account we need to calculate the summary row
        let summaryRow = null;
        let singleTransactionsWithParentRow = [];
        if (singleTransactions.length > 0) {
            summaryRow = singleTransactions.reduce((prev, curr)=>(0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    openPositionSize: (prev.openPositionSize || 0) + (curr.openPositionSize || 0),
                    purchaseValue: (prev.purchaseValue || 0) + curr.purchaseValue,
                    currentValue: (prev.currentValue || 0) + curr.currentValue,
                    fees: (prev.fees || 0) + curr.fees,
                    numeratorRoiAnnualWeighted: (prev.numeratorRoiAnnualWeighted || 0) + (curr.roiAnnual || 0) * curr.quantityOpen,
                    numeratorTransactionPrice: (prev.numeratorTransactionPrice || 0) + (curr.quantity || 0) * curr.openPositionSize
                }), curr.itemHasFlag && {
                    itemHasFlag: curr.itemHasFlag
                }), {
                date: 1,
                assetId: assetId,
                assetName: singleTransactions[0].assetName,
                currentQuoteBaseCurrency: singleTransactions[0].currentQuoteBaseCurrency
            });
            if ($aabe6e90eded8123$var$debugLevel > 2) console.log("summaryRow", summaryRow);
            summaryRow = (0, $2qxEV._)((0, $9tqwB._)({}, summaryRow), {
                currency: baseCurrency,
                transactionPrice: summaryRow.numeratorTransactionPrice / summaryRow.openPositionSize,
                roi: (summaryRow.currentValue + summaryRow.fees - summaryRow.purchaseValue) / summaryRow.purchaseValue,
                roiAnnual: summaryRow.numeratorRoiAnnualWeighted / summaryRow.openPositionSize,
                isSummaryRow: true
            });
            // each atomic row has a reference to the summary row
            // this is needed to sort the table correctly (see getSortingCallback below)
            singleTransactionsWithParentRow = singleTransactions.map((st)=>(0, $2qxEV._)((0, $9tqwB._)({}, st), {
                    parentSummaryRow: summaryRow
                }));
        }
        return [
            ...acc,
            ...singleTransactionsWithParentRow,
            ...summaryRow ? [
                summaryRow
            ] : []
        ];
    }, []);
}
function $aabe6e90eded8123$export$10e67feb6a48460e() {
    return {
        assetName: (0, $4678812afdc6b9f3$export$7a3c3d42e4d75513)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).map((ma)=>({
                id: ma.assetName,
                name: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t(`app:schema.metals.transactions.parameters.assetMetal.${ma.assetMetal}`)} - ${ma.assetWeight}g - .${ma.assetPurity} - +${ma.assetAdditionalValue}%`
            }))
    };
}
function $aabe6e90eded8123$export$4d7d49026c1d0e29() {
    return function getCustomOnChangeInner(instance, cell, x, y, value) {
        // if current column is 'assetName'
        if (instance && instance.jspreadsheet.options.columns[x].name === "assetName") {
            // find columns 'assetMetal', 'assetWeight', 'assetPurity', 'assetAdditionalValue' and get their values based on assetName's 'value' from metalsAssets
            const asset = (0, $4678812afdc6b9f3$export$7a3c3d42e4d75513)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).find((ma)=>ma.assetName === value); // this finds the FIRST ONE of that name
            const assetWeightColumnIndex = instance.jspreadsheet.options.columns.findIndex((column)=>column.name === "assetWeight");
            if (assetWeightColumnIndex !== -1) instance.jspreadsheet.setValueFromCoords(assetWeightColumnIndex, y, asset.assetWeight, false);
            const assetPurityColumnIndex = instance.jspreadsheet.options.columns.findIndex((column)=>column.name === "assetPurity");
            if (assetPurityColumnIndex !== -1) instance.jspreadsheet.setValueFromCoords(assetPurityColumnIndex, y, asset.assetPurity, false);
            const assetMetalColumnIndex = instance.jspreadsheet.options.columns.findIndex((column)=>column.name === "assetMetal");
            if (assetMetalColumnIndex !== -1) instance.jspreadsheet.setValueFromCoords(assetMetalColumnIndex, y, asset.assetMetal, false);
            const assetAVColumnIndex = instance.jspreadsheet.options.columns.findIndex((column)=>column.name === "assetAdditionalValue");
            if (assetAVColumnIndex !== -1) instance.jspreadsheet.setValueFromCoords(assetAVColumnIndex, y, asset.assetAdditionalValue, false);
        }
    };
}
function $aabe6e90eded8123$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        // if transactionValue / transactionCurrencyValue is provided, calculate upac / uptc
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            upac: item.upac || (item.transactionValue && item.quantity ? item.transactionValue / item.quantity : null),
            uptc: item.uptc || (item.transactionCurrencyValue && item.quantity ? item.transactionCurrencyValue / item.quantity : null),
            transactionCurrency: item.transactionCurrency || null,
            accountCurrency: account.currency,
            assetCurrency: account.currency,
            assetId: item.assetName.replace(/[^a-zA-Z0-9]/g, "")
        });
    };
}
function $aabe6e90eded8123$export$9f17ee6c2a47ab8b(transactions) {
    // make sure we don't sell items that we do not have in this account
    // i.e. if
    // make sure we are not selling more than we own
    // take validatedData and calculate cumulative amount of metal owned
    // sort by date ascending, then by transactionType ascending (so that purchase on the same day comes before sale)
    console.log("additionalValidations", transactions);
    let quantityBySymbol = 0;
    let skipToNextSymbol = false;
    const returnErrors = [];
    const dataForMetalsValidation = (transactions || []).map((item, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
            originalRowNumber: idx
        })) // add original row numbers so that we know where to show an error message if there is one
    .sort((a, b)=>{
        // sort by symbol ascending
        if (a.assetId < b.assetId) return -1;
        if (a.assetId > b.assetId) return 1;
        // if symbols are equal, sort by date ascending
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        // if dates are equal, sort positive before negative
        return b.quantity - a.quantity;
    });
    for(let idx = 0; idx < dataForMetalsValidation.length; idx += 1){
        const prev = dataForMetalsValidation[idx - 1];
        const curr = dataForMetalsValidation[idx];
        // go through the sorted array top to bottom (it's sorted by symbol)
        // if curr has a different symbol than prev, reset amount
        if (idx > 0 && prev.symbol !== curr.symbol) {
            skipToNextSymbol = false;
            quantityBySymbol = 0;
        }
        // if previous iteration set this flag to true, it will skip to the next transaction
        // until a new symbol is introduced
        if (skipToNextSymbol === false) {
            // add this iteration's amount to the amount for the current symbol
            quantityBySymbol += curr.quantity || 0;
            // if prev becomes negative, signal a validation error and add error to validationErrors
            // cannot break loop, because there will be more symbols (potentially)
            if (quantityBySymbol < 0) {
                console.error("The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.");
                returnErrors.push({
                    message: "The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.",
                    path: `[${curr.originalRowNumber}].quantity`
                });
                // we want this to only show up at the first offending transaction
                // to let user sort it out and not confuse them with many errors
                // the checking of remaining transactions for the same symbol is skipped
                skipToNextSymbol = true;
            }
        }
    }
    return returnErrors;
}
function $aabe6e90eded8123$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "metals",
        accountId: account.id
    });
}
function $aabe6e90eded8123$export$3195655de7cb0f02(accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: "metals",
        accountId: accountId
    }));
}
function $aabe6e90eded8123$var$compare(a, b, propertyName, asc = true) {
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}
function $aabe6e90eded8123$export$5c6817526d88585b(tableState) {
    return function sortingCallback(a, b) {
        // reverse sorting order if date is selected a
        // localeCompare compares strings according to rules of the current locale, returns -1, 0, 1
        try {
            let compareFigi = a.assetId.localeCompare(b.assetId);
            if (tableState.sortBy === "date" && !tableState.sortDirectionAsc) compareFigi = -a.assetId.localeCompare(b.assetId);
            // this implements sorting by assetId's properties
            // applyCategorySpecificChanges has added a parentSummaryRow to each transaction
            // first sort by sortBy of the parentSummaryRow (or by itself if it IS a summary row)
            // then put summary rows first within the group and sort by sortBy within the group
            return $aabe6e90eded8123$var$compare(a.parentSummaryRow || a, b.parentSummaryRow || b, tableState.sortBy, tableState.sortDirectionAsc) || !!b.isSummaryRow - !!a.isSummaryRow || $aabe6e90eded8123$var$compare(a, b, tableState.sortBy, tableState.sortDirectionAsc);
        } catch (e) {
            if ($aabe6e90eded8123$var$debugLevel > 2) console.log("error in getSortingCallback", e, "tableState", tableState, "a", a, "b", b);
            return 0;
        }
    };
}


var $519b49a44c19fffc$exports = {};

$parcel$export($519b49a44c19fffc$exports, "categoryOrderedObject", function () { return $519b49a44c19fffc$export$3270e954cce20150; });
$parcel$export($519b49a44c19fffc$exports, "applyCategorySpecificChanges", function () { return $519b49a44c19fffc$export$c6abce4536815011; });
$parcel$export($519b49a44c19fffc$exports, "outputTransformCategoryTransactions", function () { return $519b49a44c19fffc$export$39b64bc498225d58; });
$parcel$export($519b49a44c19fffc$exports, "additionalValidations", function () { return $519b49a44c19fffc$export$9f17ee6c2a47ab8b; });
$parcel$export($519b49a44c19fffc$exports, "postCategoryItems", function () { return $519b49a44c19fffc$export$37bc17007772d2e3; });
$parcel$export($519b49a44c19fffc$exports, "handleSync", function () { return $519b49a44c19fffc$export$3195655de7cb0f02; });
$parcel$export($519b49a44c19fffc$exports, "getSortingCallback", function () { return $519b49a44c19fffc$export$5c6817526d88585b; });
/* eslint-disable no-unsafe-optional-chaining */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $519b49a44c19fffc$var$debugLevel = 3;
function $519b49a44c19fffc$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function unlistedSharesOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        const { quantity: quantity, uptc: uptc, transactionCurrency: transactionCurrency, upac: upac, accountCurrency: accountCurrency, assetId: assetId, id: id } = transaction;
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            quantity: quantity,
            uptc: uptc,
            transactionCurrency: transactionCurrency,
            transactionCurrencyValue: quantity * uptc || 0,
            upac: upac,
            transactionValue: quantity * upac || 0,
            id: transaction.id,
            accountCurrency: accountCurrency,
            assetId: transaction.assetId
        }, displayedComponent === "table" && {
            assetName: transaction.assetName
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
const $519b49a44c19fffc$var$depositTransactionLabels = (0, $a368196802fe263c$export$c3326d1eadff13bd).map((l)=>l.split("-")[1]);
const $519b49a44c19fffc$var$depositIncomeTransactionLabels = (0, $a368196802fe263c$export$c58f7ddceaf8469f).map((l)=>l.split("-")[1]);
const $519b49a44c19fffc$var$depositExpenseTransactionLabels = (0, $a368196802fe263c$export$47220dfe2b0dcc85).map((l)=>l.split("-")[1]);
function $519b49a44c19fffc$export$c6abce4536815011(transactions, account = null, displayedComponent = "table", quotes = []) {
    var _state_user_profile_settings, _state_user_profile, _state_user;
    // <- receives some parameters and
    // GRID is easy
    if (displayedComponent === "grid") return transactions.map($519b49a44c19fffc$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const baseCurrency = ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    // if this is a TABLE, we need a more complex transformation
    // 'transactions' for table is a different object: it is the 'unlistedShares.accountId' branch of completeAssetsView
    // described here: https://monestry.atlassian.net/l/cp/t1S1KbTF
    // in other words, an object with keys being accountIds and values being arrays of transactions belonging to that account + all related  deposit transactions sorted ascending by date
    // this is essentially the same code as in stocks (minus the summary row), but as long as field names are not synchronised among asset categories, it needs to be slightly different
    console.log("DEBUG: applyCategorySpecificChanges transactions", transactions, "quotes", quotes);
    return Object.keys(transactions).reduce((acc, assetId)=>{
        // for each assetId: { object }
        const depositTransactionsThisAsset = transactions[assetId].filter((x)=>$519b49a44c19fffc$var$depositTransactionLabels.includes(x.rowType)).map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                payoutOrFeePerPiece: x.quantity / x.positionOnDate
            }));
        // let's sort out transactions first
        const singleTransactions = transactions[assetId].filter((item)=>item.rowType === "purchase") // leave only purchases which have not been sold yet
        .map((item)=>{
            var _quotes_item_assetId_current, _quotes_item_assetId;
            const openPositionSize = item.quantity;
            const purchaseValue = item.quantity * item.upac;
            const currentQuote = (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : (_quotes_item_assetId_current = _quotes_item_assetId.current) === null || _quotes_item_assetId_current === void 0 ? void 0 : _quotes_item_assetId_current.quote;
            const currentValue = item.quantity * currentQuote;
            const dividendsPerPieceSincePurchase = depositTransactionsThisAsset // this is in base currency
            .filter((x)=>x.date >= item.date && $519b49a44c19fffc$var$depositIncomeTransactionLabels.includes(x.rowType)).reduce((acc2, curr2)=>acc2 + curr2.payoutOrFeePerPiece, 0);
            const dividendsSincePurchase = openPositionSize * dividendsPerPieceSincePurchase;
            const thisTransactionFees = depositTransactionsThisAsset// has a linkedTransaction which has the same id as the current item
            .filter((x)=>$519b49a44c19fffc$var$depositExpenseTransactionLabels.includes(x.rowType) && x.linkedTransactions.findIndex((lt)=>lt.id === item.id) > -1).reduce((acc2, curr2)=>acc2 + curr2.quantity, 0);
            const accountCostShareSincePurchase = (transactions[account.id] || [] // account-level cost are not linked to any assetId ([] handle case of no cost transactions)
            ).filter((x)=>x.date >= item.date && x.rowType === "costs").reduce((acc2, curr2)=>acc2 + curr2.quantity, 0) / Object.keys(transactions).length; // divide equally per assetId within one account
            const fees = thisTransactionFees + accountCostShareSincePurchase;
            return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                currency: baseCurrency,
                openPositionSize: openPositionSize,
                purchaseValue: purchaseValue,
                purchaseQuote: item.upac,
                currentValue: currentValue,
                currentQuote: currentQuote,
                fees: fees,
                dividendsSincePurchase: dividendsSincePurchase,
                roi: (currentValue + dividendsSincePurchase + fees - purchaseValue) / purchaseValue,
                roiAnnual: ((currentValue + dividendsSincePurchase + fees) / purchaseValue) ** (1 / ((new Date().valueOf() - item.date) / 31536000000)) - 1,
                isSummaryRow: false
            });
        });
        if ($519b49a44c19fffc$var$debugLevel > 2) console.log("singleTransactions", singleTransactions);
        // for each assetId in this account we need to calculate the summary row
        let summaryRow = null;
        if (singleTransactions.length > 0) {
            summaryRow = singleTransactions.reduce((prev, curr)=>(0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    openPositionSize: (prev.openPositionSize || 0) + (curr.openPositionSize || 0),
                    purchaseValue: (prev.purchaseValue || 0) + curr.purchaseValue,
                    currentValue: (prev.currentValue || 0) + curr.currentValue,
                    dividendsSincePurchase: (prev.dividendsSincePurchase || 0) + curr.dividendsSincePurchase,
                    fees: (prev.fees || 0) + curr.fees,
                    numeratorRoiAnnualWeighted: (prev.numeratorRoiAnnualWeighted || 0) + (curr.roiAnnual || 0) * curr.quantityOpen,
                    numeratorTransactionPrice: (prev.numeratorTransactionPrice || 0) + (curr.purchaseValue || 0)
                }), curr.itemHasFlag && {
                    itemHasFlag: curr.itemHasFlag
                }), {
                date: 1,
                assetId: assetId,
                assetName: singleTransactions[0].assetName,
                currentQuote: singleTransactions[0].currentQuote
            });
            if ($519b49a44c19fffc$var$debugLevel > 2) console.log("summaryRow", summaryRow);
            summaryRow = (0, $2qxEV._)((0, $9tqwB._)({}, summaryRow), {
                currency: baseCurrency,
                purchaseQuote: summaryRow.numeratorTransactionPrice / summaryRow.openPositionSize,
                roi: (summaryRow.currentValue + summaryRow.fees - summaryRow.purchaseValue) / summaryRow.purchaseValue,
                roiAnnual: summaryRow.numeratorRoiAnnualWeighted / summaryRow.openPositionSize,
                isSummaryRow: true
            });
        }
        return [
            ...acc,
            ...singleTransactions,
            ...summaryRow ? [
                summaryRow
            ] : []
        ];
    }, []);
}
function $519b49a44c19fffc$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        // if transactionValue / transactionCurrencyValue is provided, calculate upac / uptc
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            upac: item.upac || (item.transactionValue && item.quantity ? item.transactionValue / item.quantity : null),
            uptc: item.uptc || (item.transactionCurrencyValue && item.quantity ? item.transactionCurrencyValue / item.quantity : null),
            transactionCurrency: item.transactionCurrency || null,
            accountCurrency: account.currency,
            assetCurrency: account.currency,
            assetId: item.assetName.replace(/[^a-zA-Z0-9]/g, "")
        });
    };
}
function $519b49a44c19fffc$export$9f17ee6c2a47ab8b(transactions) {
    // make sure we don't sell items that we do not have in this account
    // i.e. if
    // make sure we are not selling more than we own
    // take validatedData and calculate cumulative amount of unlistedShares owned
    // sort by date ascending, then by transactionType ascending (so that purchase on the same day comes before sale)
    console.log("additionalValidations", transactions);
    let quantityBySymbol = 0;
    let skipToNextSymbol = false;
    const returnErrors = [];
    const dataForMetalsValidation = (transactions || []).map((item, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
            originalRowNumber: idx
        })) // add original row numbers so that we know where to show an error message if there is one
    .sort((a, b)=>{
        // sort by symbol ascending
        if (a.assetId < b.assetId) return -1;
        if (a.assetId > b.assetId) return 1;
        // if symbols are equal, sort by date ascending
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        // if dates are equal, sort positive before negative
        return b.quantity - a.quantity;
    });
    for(let idx = 0; idx < dataForMetalsValidation.length; idx += 1){
        const prev = dataForMetalsValidation[idx - 1];
        const curr = dataForMetalsValidation[idx];
        // go through the sorted array top to bottom (it's sorted by symbol)
        // if curr has a different symbol than prev, reset amount
        if (idx > 0 && prev.symbol !== curr.symbol) {
            skipToNextSymbol = false;
            quantityBySymbol = 0;
        }
        // if previous iteration set this flag to true, it will skip to the next transaction
        // until a new symbol is introduced
        if (skipToNextSymbol === false) {
            // add this iteration's amount to the amount for the current symbol
            quantityBySymbol += curr.quantity || 0;
            // if prev becomes negative, signal a validation error and add error to validationErrors
            // cannot break loop, because there will be more symbols (potentially)
            if (quantityBySymbol < 0) {
                console.error("The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.");
                returnErrors.push({
                    message: "The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.",
                    path: `[${curr.originalRowNumber}].quantity`
                });
                // we want this to only show up at the first offending transaction
                // to let user sort it out and not confuse them with many errors
                // the checking of remaining transactions for the same symbol is skipped
                skipToNextSymbol = true;
            }
        }
    }
    return returnErrors;
}
function $519b49a44c19fffc$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "unlistedShares",
        accountId: account.id
    });
}
function $519b49a44c19fffc$export$3195655de7cb0f02(accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: "unlistedShares",
        accountId: accountId
    }));
}
function $519b49a44c19fffc$var$compare(a, b, propertyName, asc = true) {
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}
function $519b49a44c19fffc$export$5c6817526d88585b(tableState) {
    return function sortingCallback(a, b) {
        // reverse sorting order if date is selected a
        // localeCompare compares strings according to rules of the current locale, returns -1, 0, 1
        try {
            let compareFigi = a.assetId.localeCompare(b.assetId);
            if (tableState.sortBy === "date" && !tableState.sortDirectionAsc) compareFigi = -a.assetId.localeCompare(b.assetId);
            // sort by symbol, then sort the total row first and then sort the rest by the column
            return compareFigi || !!b.isSummaryRow - !!a.isSummaryRow || $519b49a44c19fffc$var$compare(a, b, tableState.sortBy, tableState.sortDirectionAsc);
        } catch (e) {
            if ($519b49a44c19fffc$var$debugLevel > 2) console.log("error in getSortingCallback", e, "tableState", tableState, "a", a, "b", b);
            return 0;
        }
    };
}


var $87a994f344b9b971$exports = {};

$parcel$export($87a994f344b9b971$exports, "categoryOrderedObject", function () { return $87a994f344b9b971$export$3270e954cce20150; });
$parcel$export($87a994f344b9b971$exports, "applyCategorySpecificChanges", function () { return $87a994f344b9b971$export$c6abce4536815011; });
$parcel$export($87a994f344b9b971$exports, "getCustomDropdownSources", function () { return $87a994f344b9b971$export$10e67feb6a48460e; });
$parcel$export($87a994f344b9b971$exports, "getCustomOnChange", function () { return $87a994f344b9b971$export$4d7d49026c1d0e29; });
$parcel$export($87a994f344b9b971$exports, "outputTransformCategoryTransactions", function () { return $87a994f344b9b971$export$39b64bc498225d58; });
$parcel$export($87a994f344b9b971$exports, "additionalValidations", function () { return $87a994f344b9b971$export$9f17ee6c2a47ab8b; });
$parcel$export($87a994f344b9b971$exports, "postCategoryItems", function () { return $87a994f344b9b971$export$37bc17007772d2e3; });
$parcel$export($87a994f344b9b971$exports, "handleSync", function () { return $87a994f344b9b971$export$3195655de7cb0f02; });
$parcel$export($87a994f344b9b971$exports, "getSortingCallback", function () { return $87a994f344b9b971$export$5c6817526d88585b; });
$parcel$export($87a994f344b9b971$exports, "saveDialogPromiseCallback", function () { return $87a994f344b9b971$export$786ba3d545d307f5; });
/* eslint-disable no-unsafe-optional-chaining */ // CATEGORY MODULE FOR CRYPTO / TRANSACTIONS

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $91420ff1f0fec24c$var$PencilIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
    }));
}
const $91420ff1f0fec24c$var$ForwardRef = $7fPBF.forwardRef($91420ff1f0fec24c$var$PencilIcon);
var $91420ff1f0fec24c$export$2e2bcd8739ae039 = $91420ff1f0fec24c$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $dfb65f8118a674bb$var$ArrowLongLeftIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a.75.75 0 0 1-.75.75H4.66l2.1 1.95a.75.75 0 1 1-1.02 1.1l-3.5-3.25a.75.75 0 0 1 0-1.1l3.5-3.25a.75.75 0 1 1 1.02 1.1l-2.1 1.95h12.59A.75.75 0 0 1 18 10Z",
        clipRule: "evenodd"
    }));
}
const $dfb65f8118a674bb$var$ForwardRef = $7fPBF.forwardRef($dfb65f8118a674bb$var$ArrowLongLeftIcon);
var $dfb65f8118a674bb$export$2e2bcd8739ae039 = $dfb65f8118a674bb$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ac0450114a96feeb$var$ArrowLongRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2 10a.75.75 0 0 1 .75-.75h12.59l-2.1-1.95a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.1-1.95H2.75A.75.75 0 0 1 2 10Z",
        clipRule: "evenodd"
    }));
}
const $ac0450114a96feeb$var$ForwardRef = $7fPBF.forwardRef($ac0450114a96feeb$var$ArrowLongRightIcon);
var $ac0450114a96feeb$export$2e2bcd8739ae039 = $ac0450114a96feeb$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $839c83ce560e6adf$var$MagnifyingGlassIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
        clipRule: "evenodd"
    }));
}
const $839c83ce560e6adf$var$ForwardRef = $7fPBF.forwardRef($839c83ce560e6adf$var$MagnifyingGlassIcon);
var $839c83ce560e6adf$export$2e2bcd8739ae039 = $839c83ce560e6adf$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $08a2ee17ea30150a$var$MinusCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
        clipRule: "evenodd"
    }));
}
const $08a2ee17ea30150a$var$ForwardRef = $7fPBF.forwardRef($08a2ee17ea30150a$var$MinusCircleIcon);
var $08a2ee17ea30150a$export$2e2bcd8739ae039 = $08a2ee17ea30150a$var$ForwardRef;






(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
const $06159ee855cfc078$var$toM = (number)=>{
    if (number === null || number === undefined) return "";
    let decimals = 0;
    if (number <= 10000000) decimals = 2;
    if (number > 10000000 && number <= 100000000) decimals = 1;
    const formattedNumber = number / 1000000;
    return `${new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(formattedNumber)} M`;
};
// TODO return data to caller
function $06159ee855cfc078$var$AssetDetails({ assetDetails: assetDetails, setAssetDetails: setAssetDetails, setUpdater: setUpdater }) {
    $06159ee855cfc078$var$AssetDetails.propTypes = {
        assetDetails: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
        setAssetDetails: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        setUpdater: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "cryptoAssetMappingDialog"
    });
    const [selectedRow, setSelectedRow] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [searchResults, setSearchResults] = (0, $7fPBF.useState)([]);
    const [currentPage, setCurrentPage] = (0, $7fPBF.useState)(0);
    const itemsPerPage = 5;
    const pagesTotal = Math.ceil(searchResults.length / itemsPerPage);
    // get search results from API
    async function getSearchResults(searchString) {
        if (!searchString || searchString.length === 0) return;
        setLoading(true);
        try {
            const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "stocks/search/crypto", {
                body: {
                    searchString: searchString
                },
                headers: {
                    "Content-Type": "application/json"
                }
            });
            // there is a database limit on providerAssetId length of 255 characters, so let us not show those with longer names (it's just a handful of niche cryptos)
            setSearchResults(response.filter((item)=>item.name.length < 255).sort());
        } catch (error) {
            console.error("Error in getSearchResults:", error);
            setSearchResults([]);
        }
        setLoading(false);
    }
    // initialise form by running a search
    (0, $7fPBF.useEffect)(()=>{
        getSearchResults(assetDetails.displaySymbol);
        // if we have a assetId, we need to try select it (assetId is the numerical id from Mobula)
        if (assetDetails.assetId) {
            const idx = searchResults.findIndex((item)=>item.id === assetDetails.assetId);
            if (idx > -1) setSelectedRow(idx);
        }
    }, []);
    // handle running a search initiated by user (search button)
    async function handleSearch(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        // Access the form data
        const searchString = formData.get("asset-details-input");
        await getSearchResults(searchString);
    }
    function handleClick(idx) {
        if (idx === selectedRow) setSelectedRow(null);
        else setSelectedRow(idx);
    }
    function handleSubmit() {
        if (selectedRow !== null) {
            const selectedAsset = searchResults[selectedRow];
            const updatedAsset = (0, $2qxEV._)((0, $9tqwB._)({}, assetDetails), {
                providerAssetId: selectedAsset.name,
                assetId: selectedAsset.id
            });
            setUpdater(updatedAsset);
            setAssetDetails(undefined);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-3 text-center sm:mt-5",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-lg leading-6 font-bold text-gray-900",
                children: `${t("headerAssetDetails")} ${assetDetails.displaySymbol}`
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-2 text-sm text-gray-500",
                children: t("promptAssetDetails")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                className: "mt-4 pb-4 flex space-x-2 items-center text-sm mx-auto w-full md:w-3/4",
                onSubmit: handleSearch,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-left text-sm text-gray-500 flex-shrink-0",
                        children: t("search")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        id: "asset-details-input",
                        name: "asset-details-input",
                        autoComplete: "off",
                        // eslint-disable-next-line max-len
                        className: "text-gray-700 p-1.5 rounded-md border border-gray-300 placeholder-gray-300 focus:ring-brandBlue-500 focus:border-brandBlue-500 block w-full focus:outline-none sm:text-sm",
                        defaultValue: assetDetails.displaySymbol
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        Icon: (0, $839c83ce560e6adf$export$2e2bcd8739ae039),
                        size: "md",
                        type: "submit",
                        textColor: "text-gray-400",
                        textColorHover: "text-gray-500",
                        enabled: !loading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-4 pb-4 block md:hidden text-sm mx-auto w-3/4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "w-full grid grid-cols-2 gap-4 items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "uppercase tracking-wide pb-4 text-left text-xs font-bold border-b border-gray-300",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: t("symbol")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: t("name")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "uppercase tracking-wide pb-4 text-left text-xs font-bold border-b border-gray-300",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "",
                                        children: `${t("price")} ($)`
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "",
                                        children: `${t("marketCap")} ($)`
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "",
                                        children: `${t("liquidity")} ($)`
                                    })
                                ]
                            })
                        ]
                    }),
                    searchResults.map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            className: `p-1 mt-1 w-full grid grid-cols-2 gap-4 items-stretch text-sm text-gray-700 rounded-sm
              ${selectedRow === idx ? "bg-brandBlue-600 text-white" : "bg-white text-gray-500"}`,
                            onClick: (e)=>handleClick(idx),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "text-left",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "truncate",
                                            children: item.symbol
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "truncate",
                                            children: item.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-right",
                                            children: item.price.toFixed(2)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-right",
                                            children: $06159ee855cfc078$var$toM(item.marketCap)
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-right",
                                            children: $06159ee855cfc078$var$toM(item.liquidity)
                                        })
                                    ]
                                })
                            ]
                        }))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-4 pb-4 hidden md:block space-y-1",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "grid grid-cols-5 gap-4 mx-auto pb-4 w-full items-stretch uppercase font-bold tracking-wide text-left text-xs border-b border-gray-300",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "",
                                children: t("symbol")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "",
                                children: t("name")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "",
                                children: `${t("price")} ($)`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "",
                                children: `${t("marketCap")} ($)`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "",
                                children: `${t("liquidity")} ($)`
                            })
                        ]
                    }),
                    loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "w-full h-full py-8 flex justify-center items-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-400 animate-spin"
                        })
                    }),
                    !loading && searchResults.length > 0 && searchResults.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage).map((item, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            className: `px-1 py-1.5 grid grid-cols-5 gap-4 text-sm mx-auto w-full items-stretch text-left rounded-sm
              ${selectedRow === currentPage * itemsPerPage + idx ? "bg-brandBlue-600 text-white hover:bg-brandBlue-500" : "bg-white text-gray-500 hover:bg-gray-100"}`,
                            type: "button",
                            // here we need the index of the item in the entire array, not just on this page
                            onClick: (e)=>handleClick(currentPage * itemsPerPage + idx),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "truncate",
                                    children: item.symbol
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                    info: item.name,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "truncate",
                                        children: item.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-right",
                                    children: item.price.toFixed(2)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-right",
                                    children: $06159ee855cfc078$var$toM(item.marketCap)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-right",
                                    children: $06159ee855cfc078$var$toM(item.liquidity)
                                })
                            ]
                        }, item.id)),
                    !loading && searchResults.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-center text-gray-500 text-sm py-8",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: t("noResults")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
                        className: "flex items-center justify-between mt-4 border-t border-gray-200 px-4 sm:px-0",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "-mt-px flex w-0 flex-1",
                                children: currentPage > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    type: "button",
                                    className: "inline-flex items-center pr-1 pt-4 text-sm  text-gray-500 hover:text-gray-700",
                                    onClick: ()=>setCurrentPage(currentPage - 1),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dfb65f8118a674bb$export$2e2bcd8739ae039), {
                                            className: "mr-3 h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        }),
                                        t("previous")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "-mt-px px-4 pt-4 text-gray-500 text-sm",
                                children: searchResults.length > 0 ? `${t("page")} ${currentPage + 1} ${t("pageOf")} ${pagesTotal}` : ""
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "-mt-px flex w-0 flex-1 justify-end",
                                children: currentPage < pagesTotal - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    type: "button",
                                    className: "inline-flex items-center pl-1 pt-4 text-sm font-medium text-gray-500 hover:text-gray-700",
                                    onClick: ()=>setCurrentPage(currentPage + 1),
                                    children: [
                                        t("next"),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac0450114a96feeb$export$2e2bcd8739ae039), {
                                            className: "ml-3 h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid mx-auto w-2/3 grid-cols-2 mt-4 space-x-3",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: "OK",
                        type: "submit",
                        size: "lg",
                        withAccent: true,
                        onClick: handleSubmit,
                        enabled: !loading
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: "Back",
                        size: "lg",
                        onClick: ()=>setAssetDetails(undefined)
                    })
                ]
            })
        ]
    });
}
// TODO
const $06159ee855cfc078$var$data = [
    {
        displaySymbol: "BTC",
        providerAssetId: "Bitcoin",
        assetId: 100001656
    },
    {
        displaySymbol: "ETH",
        providerAssetId: "ethereum",
        assetId: 100004304
    },
    {
        displaySymbol: "USDT",
        providerAssetId: undefined,
        assetId: undefined
    }
];
function $06159ee855cfc078$export$2e2bcd8739ae039({ incomingData: incomingData, callback: callback }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "cryptoAssetMappingDialog"
    });
    const [localData, setLocalData] = (0, $7fPBF.useState)([
        ...incomingData
    ]); // copy of incomingData; we will modify it in place and send it back to caller via callback
    const [assetDetails, setAssetDetails] = (0, $7fPBF.useState)(undefined); // to show the individual asset details dialog when has the asset object { providerAssetId, assetId ... }
    const [updater, setUpdater] = (0, $7fPBF.useState)(null); // AssetDetails sets it to the asset object with updated providerAssetId and assetId when user clicks OK there (the rest handled by an useEffect later)
    // responds to changes done by AssetDetails (the component will use setUpdated to passed changes back to this component)
    // when updater has changed, we need to update the localData and reset updater
    (0, $7fPBF.useEffect)(()=>{
        if (updater) {
            // there may be more than one row with the same asset, so we need to update all rows
            const copy = [
                ...localData
            ].map((item)=>{
                if (item.displaySymbol === updater.displaySymbol) return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
                    providerAssetId: updater.providerAssetId,
                    assetId: updater.assetId
                });
                return item;
            });
            // update local data state
            setLocalData(copy);
            // reset updater
            setUpdater(null);
        }
    }, [
        updater
    ]);
    function onClose() {
        window.dispatchEvent(new CustomEvent("setDialog"));
    }
    function onSubmit() {
        try {
            // we need to return the initial object with changes to caller
            callback(localData);
            onClose();
        } catch (error) {
            console.error("GetAssetMappingDialog onSubmit error:", error);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto max-w-md md:max-w-lg transform overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all p-6",
        children: assetDetails ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($06159ee855cfc078$var$AssetDetails, {
            assetDetails: assetDetails,
            setAssetDetails: setAssetDetails,
            setUpdater: setUpdater
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-brandBlue-100",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91420ff1f0fec24c$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 text-brandBlue-500",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-3 text-center sm:mt-5",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: t("headerAssetDetails")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-2 text-sm text-gray-500",
                            children: t("promptAssetDetails")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "mt-4 pb-4 grid grid-cols-2 gap-4 text-sm items-center mx-auto w-3/4",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "uppercase tracking-wide ml-1 pb-4 text-left text-xs font-bold  border-b border-gray-300",
                                    children: t("asset")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "uppercase tracking-wide ml-1 pb-4 text-left text-xs font-bold  border-b border-gray-300",
                                    children: t("status")
                                }),
                                localData.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "ml-1 text-left truncate",
                                                children: item.displaySymbol
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                Icon: item.providerAssetId ? (0, $1aa98a901308423c$export$2e2bcd8739ae039) : (0, $08a2ee17ea30150a$export$2e2bcd8739ae039),
                                                size: "sm",
                                                onClick: ()=>setAssetDetails(item),
                                                text: item.displaySymbol,
                                                textColor: item.providerAssetId ? "text-brandGreen-300" : "text-brandRed-300",
                                                textColorHover: item.providerAssetId ? "text-brandGreen-400" : "text-brandRed-400",
                                                formatting: ""
                                            })
                                        ]
                                    }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex justify-center mt-4 space-x-3",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: "Save",
                                    type: "submit",
                                    size: "lg",
                                    withAccent: true,
                                    onClick: onSubmit
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: "Cancel",
                                    size: "lg",
                                    onClick: onClose
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
$06159ee855cfc078$export$2e2bcd8739ae039.propTypes = {
    incomingData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/**
 * Logic:
 * - add column: dirty / not dirty to every row array based on dirtyRows
 * - remove completely empty rows (i.e. which have absolutely no contents)
 * - add isDirty column to gridLayout as the last column
 * - convert array of arrays to array of objects
 * - add original row number, so that errors can be displayed in the correct row
 * - if there is spreadExtraData, it means we need to spread its contents over each row (it has the same length as gridData with no 0 rows)
 */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $3865bcfae318d264$export$2e2bcd8739ae039(gridData, gridLayout, dirtyRows, spreadExtraData) {
    // array of indices of all visible and editable columns e.g. [2, 3, 4, 5]
    const visibleColumnIdxs = gridLayout.reduce((acc, curr, idx)=>curr.type === "hidden" || curr.readOnly ? acc : [
            ...acc,
            idx
        ], []);
    return gridData// add dirty / not dirty column to every row array based on dirtyRows (but only to rows which are not empty, because they won't be removed in the next step of the chain)
    .map((row, idx)=>row.join("").length > 0 ? [
            ...row,
            dirtyRows.has(idx)
        ] : row)// // remove completely empty rows
    // .filter((row) => row.join('').length > 0)
    // 241024 FIX: we actually need to remove those rows, whose VISIBLE COLUMNS are empty (not all columns)
    // for all indices in visibleColumnIdxs, check if there is a non-empty value in the row; if there is, keep the row; othwerwise, remove it (return false)
    .filter((row)=>visibleColumnIdxs.reduce((acc, curr)=>acc || String(row[curr]).length > 0, false))// add isDirty column to gridLayout as the last column
    .map((row)=>gridLayout.concat({
            id: "isDirty",
            type: "boolean"
        }).reduce((prev, curr, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                [curr.id]: row[idx]
            }), {})) // convert array of arrays to array of objects
    // add original row number, so that errors can be displayed in the correct row
    .map((row, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, row), {
            rowNumber: idx
        }))// if there is spreadExtraData, it means we need to spread its contents over each row (it has the same length as gridData with no 0 rows)
    .map((row, idx)=>spreadExtraData ? (0, $9tqwB._)({}, row, spreadExtraData[idx]) : row);
}



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $87a994f344b9b971$var$debugLevel = 0;
function $87a994f344b9b971$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function cryptoOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return (0, $9tqwB._)({
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            displaySymbol: transaction.displaySymbol,
            displayName: transaction.displayName,
            transactionType: transaction.transactionType,
            split: transaction.splitRatioOld && transaction.splitRatioNew ? `${transaction.splitRatioOld}:${transaction.splitRatioNew}` : "",
            transactionAmount: transaction.transactionAmount || "",
            transactionOriginalPrice: transaction.transactionOriginalPrice || "",
            transactionCurrency: transaction.transactionCurrency || "",
            rebasedOriginalValue: transaction.rebasedOriginalPrice * transaction.transactionAmount || "",
            rebasedValue: transaction.rebasedPrice * transaction.transactionAmount || "",
            rebasedAmount: transaction.rebasedAmount || "",
            rebasedOriginalPrice: transaction.rebasedOriginalPrice || "",
            id: transaction.id,
            assetId: transaction.assetId,
            providerAssetId: transaction.providerAssetId || ""
        }, displayedComponent === "table" && {
            isSimulated: transaction.isSimulated
        });
    };
}
const $87a994f344b9b971$var$depositTransactionLabels = (0, $a368196802fe263c$export$c3326d1eadff13bd).map((l)=>l.split("-")[1]);
const $87a994f344b9b971$var$depositIncomeTransactionLabels = (0, $a368196802fe263c$export$c58f7ddceaf8469f).map((l)=>l.split("-")[1]);
const $87a994f344b9b971$var$depositExpenseTransactionLabels = (0, $a368196802fe263c$export$47220dfe2b0dcc85).map((l)=>l.split("-")[1]);
function $87a994f344b9b971$export$c6abce4536815011(transactions, account = null, displayedComponent = "table", quotes = []) {
    var _state_user_profile_settings, _state_user_profile, _state_user;
    // <- receives some parameters and
    // GRID is easy
    if (displayedComponent === "grid") return transactions.map($87a994f344b9b971$export$3270e954cce20150(account, displayedComponent)); // <- returns an array of objects
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const baseCurrency = ((_state_user = state.user) === null || _state_user === void 0 ? void 0 : (_state_user_profile = _state_user.profile) === null || _state_user_profile === void 0 ? void 0 : (_state_user_profile_settings = _state_user_profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    // if this is a TABLE, we need a more complex transformation
    // 'transactions' for table is a different object: it is the 'stocks.accountId' branch of completeAssetsView
    // described here: https://monestry.atlassian.net/l/cp/t1S1KbTF
    // in other words, an object with keys being accountIds and values being arrays of transactions belonging to that account + all related  deposit transactions sorted ascending by date
    return Object.keys(transactions).filter((assetId)=>assetId !== account.id) // remove the account-level transactions, which don't have any purchase transactions (which are in singleTransactions)
    .reduce((acc, assetId, idx, self1)=>{
        if ($87a994f344b9b971$var$debugLevel > 2) console.log("Overall incoming transactions object:", transactions, "self object in reduce:", self1);
        // for each assetId: [{ transactions }]
        // prepare deposit transactions for this assetId
        const depositTransactionsFromCAV = transactions[assetId].filter((x)=>$87a994f344b9b971$var$depositTransactionLabels.includes(x.rowType)).map((x)=>(0, $2qxEV._)((0, $9tqwB._)({}, x), {
                payoutOrFeePerPiece: x.amount / x.positionOnDate
            }));
        if ($87a994f344b9b971$var$debugLevel > 2) console.log(`Input transaction object for the ${assetId}`, transactions[assetId]);
        // get a list of atomic transactions to show in the table
        const singleTransactions = transactions[assetId]// .filter((item) => item.rowType === 'purchase' && item.rebasedAmount + item.rebasedAmountSold > 0) // leave only purchases which have not been sold yet
        // 250913 ↑↑ this has not been changed on 241213 somehow, but it should be item.quantityOpen > 0 following that change's logic
        .filter((item)=>item.rowType === "purchase" && item.quantityOpen > 0) // leave only purchases which have not been sold yet
        .map((item)=>{
            var _quotes_item_assetId_current, _quotes_item_assetId, _quotes_item_assetId_current1, _quotes_item_assetId1, _item_tags;
            const openPositionSize = item.quantityOpen; // 241213 getting rid of rebasedAmountSold calculated in the backend and using quantityOpen instead (calculated locally)
            // const openPositionSize = item.rebasedAmount + item.rebasedAmountSold;
            const splitRatio = item.quantity / item.transactionAmount; // --> this many new shares for one old one, like 4/1
            const openOriginalPositionSize = item.quantityOpen / splitRatio;
            // const openOriginalPositionSize = item.transactionAmount + item.transactionAmountSold;
            const purchaseValue = openPositionSize * item.rebasedPrice; // rebasedPrice is in base currency
            // this assumes the currency on quote is the same as the currency on the transaction, but we request the quote in the same currency as the transaction
            const currentQuote = (_quotes_item_assetId = quotes[item.assetId]) === null || _quotes_item_assetId === void 0 ? void 0 : (_quotes_item_assetId_current = _quotes_item_assetId.current) === null || _quotes_item_assetId_current === void 0 ? void 0 : _quotes_item_assetId_current.quote;
            const currentQuoteBaseCurrency = (_quotes_item_assetId1 = quotes[item.assetId]) === null || _quotes_item_assetId1 === void 0 ? void 0 : (_quotes_item_assetId_current1 = _quotes_item_assetId1.current) === null || _quotes_item_assetId_current1 === void 0 ? void 0 : _quotes_item_assetId_current1.quoteBaseCurrency;
            const currentValue = openPositionSize * currentQuote;
            const currentValueBaseCurrency = openPositionSize * currentQuoteBaseCurrency;
            const dividendsPerPieceSincePurchase = depositTransactionsFromCAV // this is in base currency
            .filter((x)=>x.date >= item.date && $87a994f344b9b971$var$depositIncomeTransactionLabels.includes(x.rowType)).reduce((acc2, curr2)=>acc2 + curr2.payoutOrFeePerPiece, 0);
            const dividendsSincePurchase = openPositionSize * dividendsPerPieceSincePurchase;
            const thisTransactionFees = depositTransactionsFromCAV // this is in base currency
            // has a linkedTransaction which has the same id as the current item
            .filter((x)=>$87a994f344b9b971$var$depositExpenseTransactionLabels.includes(x.rowType) && x.linkedTransactions.findIndex((lt)=>lt.id === item.id) > -1).reduce((acc2, curr2)=>acc2 + curr2.amount, 0);
            const accountCostShareSincePurchase = ((transactions[account.id] || [] // account-level cost are not linked to any assetId
            ).filter((x)=>x.date >= item.date && x.rowType === "costs").reduce((acc2, curr2)=>acc2 + curr2.amount, 0) || 0) / Object.keys(transactions).length; // divide equally per assetId within one account
            const fees = thisTransactionFees + accountCostShareSincePurchase;
            return (0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, item), {
                currency: baseCurrency,
                openPositionSize: openPositionSize,
                purchaseValue: purchaseValue,
                currentValue: currentValue,
                currentValueBaseCurrency: currentValueBaseCurrency,
                currentQuote: currentQuote,
                currentQuoteBaseCurrency: currentQuoteBaseCurrency,
                dividendsSincePurchase: dividendsSincePurchase,
                fees: fees
            }), item.rebasedAmount !== item.transactionAmount && {
                isPreSplitTransaction: openOriginalPositionSize
            }, ((_item_tags = item.tags) === null || _item_tags === void 0 ? void 0 : _item_tags.flag) && {
                itemHasFlag: item.tags.flag
            }), {
                roi: (currentValueBaseCurrency + dividendsSincePurchase + fees - purchaseValue) / purchaseValue,
                roiAnnual: ((currentValueBaseCurrency + dividendsSincePurchase + fees) / purchaseValue) ** (1 / ((new Date().valueOf() - item.date) / 31536000000)) - 1,
                isSummaryRow: false,
                // we will display currentQuote using displayElement in tableLayout.js (needs to be preformatted, as displayElement only receives this field's value)
                displayQuoteTransactionCurrency: item.transactionCurrency !== baseCurrency ? currentQuote.toLocaleString("de", {
                    style: "currency",
                    currency: item.transactionCurrency,
                    maximumFractionDigits: 2
                }) : null,
                displayPriceTransactionCurrency: item.transactionCurrency !== baseCurrency ? item.transactionOriginalPrice.toLocaleString("de", {
                    style: "currency",
                    currency: item.transactionCurrency,
                    maximumFractionDigits: 2
                }) : null
            });
        });
        if ($87a994f344b9b971$var$debugLevel > 2) console.log("Calculated atomic transactions:", singleTransactions);
        // for each assetId in this account we need to calculate the summary row
        const thisAssetIdTransactions = singleTransactions.filter((st)=>st.assetId === assetId); // list of all summary transactions for this assetId
        if ($87a994f344b9b971$var$debugLevel > 2) console.log(`Basis for calculating summary transactions for asset ${assetId}`, thisAssetIdTransactions, singleTransactions);
        let summaryRow = null;
        let singleTransactionsWithParentRow = [];
        if (thisAssetIdTransactions.length > 0) {
            summaryRow = thisAssetIdTransactions.reduce((prev, curr)=>(0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    openPositionSize: (prev.openPositionSize || 0) + (curr.openPositionSize || 0),
                    purchaseValue: (prev.purchaseValue || 0) + curr.purchaseValue,
                    currentValueBaseCurrency: (prev.currentValueBaseCurrency || 0) + curr.currentValueBaseCurrency,
                    dividendsSincePurchase: (prev.dividendsSincePurchase || 0) + curr.dividendsSincePurchase,
                    fees: (prev.fees || 0) + curr.fees,
                    numeratorRoiAnnualWeighted: (prev.numeratorRoiAnnualWeighted || 0) + (curr.roiAnnual || 0) * (curr.quantityOpen || 0),
                    numeratorTransactionPrice: (prev.numeratorTransactionPrice || 0) + (curr.rebasedPrice || 0) * curr.openPositionSize
                }), curr.itemHasFlag && {
                    itemHasFlag: curr.itemHasFlag
                }), {
                date: 1,
                assetId: assetId,
                displaySymbol: thisAssetIdTransactions[0].displaySymbol,
                displayName: thisAssetIdTransactions[0].displayName,
                currentQuoteBaseCurrency: thisAssetIdTransactions[0].currentQuoteBaseCurrency
            });
            if ($87a994f344b9b971$var$debugLevel > 2) console.log("summaryRow", summaryRow);
            summaryRow = (0, $2qxEV._)((0, $9tqwB._)({}, summaryRow), {
                currency: baseCurrency,
                transactionPrice: summaryRow.numeratorTransactionPrice / summaryRow.openPositionSize,
                roi: (summaryRow.currentValueBaseCurrency + summaryRow.dividendsSincePurchase + summaryRow.fees - summaryRow.purchaseValue) / summaryRow.purchaseValue,
                roiAnnual: summaryRow.numeratorRoiAnnualWeighted / summaryRow.openPositionSize,
                isSummaryRow: true
            });
            // each atomic row has a reference to the summary row
            // this is needed to sort the table correctly (see getSortingCallback below)
            singleTransactionsWithParentRow = singleTransactions.map((st)=>(0, $2qxEV._)((0, $9tqwB._)({}, st), {
                    parentSummaryRow: summaryRow
                }));
        }
        return [
            ...acc,
            ...singleTransactionsWithParentRow,
            summaryRow
        ].filter((x)=>!!x); // filter out nulls
    }, []);
}
function $87a994f344b9b971$export$10e67feb6a48460e() {
    return {
        displaySymbol: Object.entries((0, $e815710920e23f12$export$f339a7f853313e14)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displayNameByDisplaySymbol).map(([key, value])=>({
                id: key,
                name: value
            }))
    };
}
function $87a994f344b9b971$export$4d7d49026c1d0e29() {
    return function getCustomOnChangeInner(instance, cell, x, y, value) {
        // if current column is 'displaySymbol'
        if (instance && instance.jspreadsheet.options.columns[x].name === "displaySymbol") {
            // find a column 'displayName' and get the displayName based on displaySymbol's 'value' from cryptoMetadata
            const displayNameColumnIndex = instance.jspreadsheet.options.columns.findIndex((column)=>column.name === "displayName");
            if (displayNameColumnIndex !== -1) {
                const displayName = (0, $e815710920e23f12$export$f339a7f853313e14)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displayNameByDisplaySymbol[value] || "";
                instance.jspreadsheet.setValueFromCoords(displayNameColumnIndex, y, displayName, false);
            }
        }
    };
}
function $87a994f344b9b971$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        var _item_tag, _item_tag_previousVersion, _item_tag1;
        // if the transaction has a tag.flag, compare previousVersion.date to date; if it has changed, remove the tag.flag
        // tag.flag is given in stocks.getData (API) to transactions for which we don't have all the data from provider
        // previousVersion is the input version of this transaction object, appended by the caller of this function
        const tags = item.tags || null;
        if (((_item_tag = item.tag) === null || _item_tag === void 0 ? void 0 : _item_tag.flag) && ((_item_tag1 = item.tag) === null || _item_tag1 === void 0 ? void 0 : (_item_tag_previousVersion = _item_tag1.previousVersion) === null || _item_tag_previousVersion === void 0 ? void 0 : _item_tag_previousVersion.date) !== item.date) delete tags.flag;
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            transactionAmount: item.transactionType === "sale" && item.transactionAmount > 0 ? item.transactionAmount * -1 : item.transactionAmount,
            amount: item.transactionType === "sale" && item.amount > 0 ? item.amount * -1 : item.amount,
            splitRatioOld: item.transactionType === "split" ? item.split.split(":")[0] : null,
            splitRatioNew: item.transactionType === "split" ? item.split.split(":")[1] : null,
            // (crypto only) the idea is for the user to manually select which assetId to use for this transaction in a dialog
            figi: item.assetId || null,
            tags: tags
        });
    };
}
function $87a994f344b9b971$export$9f17ee6c2a47ab8b(transactions) {
    // make sure we don't sell assets that we do not have in this account
    // i.e. if
    // make sure we are not selling more than we own
    // take validatedData and calculate cumulative amount of assets owned
    // sort by date ascending, then by transactionType ascending (so that purchase on the same day comes before sale)
    console.log("additionalValidations", transactions);
    let amountBySymbol = 0;
    let skipToNextSymbol = false;
    const returnErrors = [];
    const dataForStocksValidation = (transactions || []).map((item, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
            originalRowNumber: idx,
            symbol: item.figi || item.displaySymbol
        })) // add original row numbers so that we know where to show an error message if there is one
    // ^^ figi || displaySymbol handles the case where there are two new different symbols, but none of them has a figi yet - they have to be treated as different symbols and their figis are both null
    .sort((a, b)=>{
        // sort by symbol ascending
        if (a.symbol < b.symbol) return -1;
        if (a.symbol > b.symbol) return 1;
        // if symbols are equal, sort by date ascending
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        // if dates are equal, sort by transactionType ascending
        if (a.transactionType < b.transactionType) return -1;
        if (a.transactionType > b.transactionType) return 1;
        // if all fields are equal, return 0
        return 0;
    });
    for(let idx = 0; idx < dataForStocksValidation.length; idx += 1){
        const prev = dataForStocksValidation[idx - 1];
        const curr = dataForStocksValidation[idx];
        // go through the sorted array top to bottom (it's sorted by symbol)
        // if curr has a different symbol than prev, reset amount
        if (idx > 0 && prev.symbol !== curr.symbol) {
            skipToNextSymbol = false;
            amountBySymbol = 0;
        }
        // if previous iteration set this flag to true, it will skip to the next transaction
        // until a new symbol is introduced
        if (skipToNextSymbol === false) {
            // split transaction can be still in the 1:4 format, so we need to use that (also handle errors here)
            if (curr.transactionType === "split") // multiply old split ratio by new one
            amountBySymbol *= curr.splitRatioNew / curr.splitRatioOld;
            // add this iteration's amount to the amount for the current symbol
            amountBySymbol += curr.transactionAmount || 0;
            // if prev becomes negative, signal a validation error and add error to validationErrors
            // cannot break loop, because there will be more symbols (potentially)
            if (amountBySymbol < 0) {
                console.error("The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.");
                returnErrors.push({
                    message: "The amount of securities has turned negative. You cannot own negative securities. See blog on how to deal with short transactions.",
                    path: `[${curr.originalRowNumber}].transactionAmount`
                });
                // we want this to only show up at the first offending transaction
                // to let user sort it out and not confuse them with many errors
                // the checking of remaining transactions for the same symbol is skipped
                skipToNextSymbol = true;
            }
        }
    }
    return returnErrors;
}
function $87a994f344b9b971$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$4e87299c28e9a838)({
        data: data,
        category: "crypto",
        accountId: account.id
    });
}
function $87a994f344b9b971$export$3195655de7cb0f02(accountId, dispatch) {
    dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
        category: "crypto",
        accountId: accountId
    }));
}
function $87a994f344b9b971$var$compare(a, b, propertyName, asc = true) {
    const multiplier = asc ? 1 : -1;
    // so that it doesn't sort capital letters separately from lowercase
    const elementA = typeof a[propertyName] === "number" ? a[propertyName] : a[propertyName].toLowerCase();
    const elementB = typeof b[propertyName] === "number" ? b[propertyName] : b[propertyName].toLowerCase();
    if (elementA < elementB) return -1 * multiplier;
    if (elementA > elementB) return 1 * multiplier;
    return 0;
}
function $87a994f344b9b971$export$5c6817526d88585b(tableState) {
    return function sortingCallback(a, b) {
        // reverse sorting order if date is selected a
        // localeCompare compares strings according to rules of the current locale, returns -1, 0, 1
        try {
            // this implements sorting by assetId's properties
            // applyCategorySpecificChanges has added a parentSummaryRow to each transaction
            // first sort by sortBy of the parentSummaryRow (or by itself if it IS a summary row)
            // then, in case the above is equal, sort by assetId (to sort rows into assetId-based groups)
            // then put summary rows first within the group and sort by sortBy within the group
            return $87a994f344b9b971$var$compare(a.parentSummaryRow || a, b.parentSummaryRow || b, tableState.sortBy, tableState.sortDirectionAsc) || $87a994f344b9b971$var$compare(a.parentSummaryRow || a, b.parentSummaryRow || b, "assetId", tableState.sortDirectionAsc) || !!b.isSummaryRow - !!a.isSummaryRow || $87a994f344b9b971$var$compare(a, b, tableState.sortBy, tableState.sortDirectionAsc);
        } catch (e) {
            if ($87a994f344b9b971$var$debugLevel > 2) console.log("error in getSortingCallback", e, "tableState", tableState, "a", a, "b", b);
            return 0;
        }
    };
}
function $87a994f344b9b971$export$786ba3d545d307f5(resolve, reject, jRef, gridLayout) {
    // this part ↓↓ may be moved to the dialog itself to handle different use case, but for now we only have one case to handle
    // gridConvert... filters out empty rows, but so does prepAndValidate... so the number of rows should be the same
    const incomingData = (0, $3865bcfae318d264$export$2e2bcd8739ae039)(jRef.current.jspreadsheet.getData(), gridLayout, new Set([])).map((row)=>({
            displaySymbol: row.displaySymbol,
            providerAssetId: row.providerAssetId,
            assetId: row.assetId
        }));
    // dispatch alert via event and wait for resolve after user clicks OK
    const props = {
        incomingData: incomingData,
        callback: resolve
    };
    // this opens a dialog which takes resolve() via props as a callback; when user is ready with mapping,
    // the dialog will resolve the promise and send output to the .then() block below, so that the below code may proceed
    window.dispatchEvent(new CustomEvent("setDialog", {
        detail: {
            Component: (0, $06159ee855cfc078$export$2e2bcd8739ae039),
            props: props
        }
    }));
}




const $29230ffbadd17265$var$debugLevel = 0; // FIXME this doesn't seem to work at runtime somehow
function $29230ffbadd17265$export$2e2bcd8739ae039({ account: account, setAccount: setAccount, tableState: tableState, setTableState: setTableState, displayedComponent: displayedComponent, displayedData: displayedData, handleClick: handleClick, connectedAccounts: connectedAccounts, handleNavigateToAccount: handleNavigateToAccount, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent, highlightTransactionId: highlightTransactionId, filter: filter }) {
    let categoryModule;
    let existingTransactions;
    let categoryArraySchema;
    const [syncStatus, setSyncStatus] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // console.log('DEBUG cav', useSelector(completeAssetView));
    const quotes = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $93bb2798871a68d2$export$443f4a6ebd922e0a)(state));
    // console.log('DEBUG gqv', quotes);
    const dashboardMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    // if filter is not null, then it means that we are rendering cashflow and not holdings (transactions)
    // use the passed filter to show transactions that are connected to the account held by AccountDetails
    const filterAccount = (item)=>item.accountId === account.id;
    // if filter is not null, then it means that we are rendering cashflow and not holdings (transactions) --> need to produce deposits with filterAccount
    // completeAssetView returns an object with all stocks assetIds > transactions and pre-calculates certain measures to be shown in the table (ROI, fees etc.)
    switch(filter ? "deposits" : account.category){
        case "deposits":
            // special case with deposits: table / grid opened with cashflow data always needs deposits data regardless of which category is the account in AccountDetails
            // if filter is passed, then it means we are in cashflow mode and need to return filtered deposit data
            categoryModule = $c877821ee984759a$exports;
            existingTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$3c400324181e2c4d)).filter(typeof filter === "function" ? filter : (item)=>item.accountId === account.id);
            categoryArraySchema = $2119005918cddc33$export$3c400324181e2c4d;
            break;
        case "realEstate":
            var _useSelector_realEstate, _useSelector;
            categoryModule = $0033f1d46ad308e0$exports;
            // eslint-disable-next-line max-len
            existingTransactions = displayedComponent === "grid" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $5b51de6ffad59fa2$export$5948b786dea4615d)).filter(filterAccount) : (_useSelector = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b))) === null || _useSelector === void 0 ? void 0 : (_useSelector_realEstate = _useSelector.realEstate) === null || _useSelector_realEstate === void 0 ? void 0 : _useSelector_realEstate[account.id];
            categoryArraySchema = $3a1ecd75ab1ea382$export$5948b786dea4615d;
            break;
        case "stocks":
            var _useSelector_stocks, _useSelector1;
            categoryModule = $383b93bc6b490f8f$exports;
            existingTransactions = displayedComponent === "grid" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $cfd21bc923628483$export$9890c99050a7d78e)).filter(filterAccount) : (_useSelector1 = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b))) === null || _useSelector1 === void 0 ? void 0 : (_useSelector_stocks = _useSelector1.stocks) === null || _useSelector_stocks === void 0 ? void 0 : _useSelector_stocks[account.id];
            categoryArraySchema = $258697da394e7920$export$9890c99050a7d78e;
            break;
        case "crypto":
            var _useSelector_crypto, _useSelector2;
            categoryModule = $87a994f344b9b971$exports;
            existingTransactions = displayedComponent === "grid" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $e815710920e23f12$export$82f53777bf39b5c0)).filter(filterAccount) : (_useSelector2 = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b))) === null || _useSelector2 === void 0 ? void 0 : (_useSelector_crypto = _useSelector2.crypto) === null || _useSelector_crypto === void 0 ? void 0 : _useSelector_crypto[account.id];
            categoryArraySchema = $1a8d54f71278e6b1$export$82f53777bf39b5c0;
            break;
        case "loans":
            categoryModule = $8d692f3847e85ce3$exports;
            existingTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $2da686298e0b71ed$export$a856f17095d848d7)).filter(filterAccount);
            categoryArraySchema = $5c401a4958c7a09c$export$a856f17095d848d7;
            break;
        case "pension":
            categoryModule = $e39b94827b3f8eb9$exports;
            existingTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $9a12762f4ca7889e$export$e59b728dc06f12a7)).filter(filterAccount);
            categoryArraySchema = $5ee4f29aaf60da17$export$e59b728dc06f12a7;
            break;
        case "objectsOfValue":
            var _useSelector_objectsOfValue, _useSelector3;
            categoryModule = $8d8bfc7b432dafaf$exports;
            // eslint-disable-next-line max-len
            existingTransactions = displayedComponent === "grid" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $1b6cd2b52ee96621$export$2802f167dacb0091)).filter(filterAccount) : (_useSelector3 = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b))) === null || _useSelector3 === void 0 ? void 0 : (_useSelector_objectsOfValue = _useSelector3.objectsOfValue) === null || _useSelector_objectsOfValue === void 0 ? void 0 : _useSelector_objectsOfValue[account.id];
            categoryArraySchema = $81cfed1660055fbf$export$2802f167dacb0091;
            break;
        case "metals":
            var _useSelector_metals, _useSelector4;
            categoryModule = $aabe6e90eded8123$exports;
            existingTransactions = displayedComponent === "grid" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $4678812afdc6b9f3$export$4efad9798dd0814e)).filter(filterAccount) : (_useSelector4 = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b))) === null || _useSelector4 === void 0 ? void 0 : (_useSelector_metals = _useSelector4.metals) === null || _useSelector_metals === void 0 ? void 0 : _useSelector_metals[account.id];
            categoryArraySchema = $e6c81a32d5e10529$export$4efad9798dd0814e;
            break;
        case "unlistedShares":
            var _useSelector_unlistedShares, _useSelector5;
            categoryModule = $519b49a44c19fffc$exports;
            // eslint-disable-next-line max-len
            existingTransactions = displayedComponent === "grid" ? (0, $51238fa605392ada$export$2105062e25df4afe)((0, $84bd2b1e91f81d86$export$ef749c62f1718a7c)).filter(filterAccount) : (_useSelector5 = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b))) === null || _useSelector5 === void 0 ? void 0 : (_useSelector_unlistedShares = _useSelector5.unlistedShares) === null || _useSelector_unlistedShares === void 0 ? void 0 : _useSelector_unlistedShares[account.id];
            categoryArraySchema = $f2b6f6a77877e6cd$export$ef749c62f1718a7c;
            break;
        default:
            categoryModule = {};
    }
    async function handleSync() {
        if ($29230ffbadd17265$var$debugLevel > 2) console.log("executing handleSync");
        setSyncStatus(true);
        await dispatch((0, $f1c3fa004749592f$export$dd5fff820f0946a1)({
            category: account.category,
            accountId: account.id
        }));
        setSyncStatus(false);
    }
    // if it is undefined, return empty
    if (!existingTransactions && displayedComponent === "table") {
        const buttonsToShow = (0, $f808db98154b70a0$export$2e2bcd8739ae039)(account.category, displayedComponent, displayedData);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                    buttonsToShow: buttonsToShow,
                    displayedComponent: displayedComponent,
                    displayedData: displayedData,
                    handleClick: handleClick,
                    userChangesPresent: userChangesPresent
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $111ad0445d705e89$export$2e2bcd8739ae039), {
                    showSync: buttonsToShow.includes("sync"),
                    showImport: buttonsToShow.includes("import"),
                    category: account.category,
                    displayedData: displayedData,
                    connectedAccounts: connectedAccounts,
                    handleNavigateToAccount: handleNavigateToAccount
                })
            ]
        });
    }
    // ------------------------------------------------------------
    // INPUT
    // ------------------------------------------------------------
    // add category-specific data to the transactions and sort
    const defaultSortingCallback = (a, b)=>$ddc3e461ba9aa601$export$398604a469f7de9a(a, b, tableState.sortBy, tableState.sortDirectionAsc);
    const sortingCallback = typeof categoryModule.getSortingCallback === "function" ? categoryModule.getSortingCallback(tableState) : defaultSortingCallback;
    // customDropdownSources is an object with keys as column names and values as arrays of strings
    // if there is a customDropdown type of column in the grid layout for this category, it will try to find dropdown source values in this object
    // { columnName: [<array of string>] }
    const customDropdownSources = typeof categoryModule.getCustomDropdownSources === "function" ? categoryModule.getCustomDropdownSources() : {};
    // customOnChange is executed after every value change in Grid
    // it receives (instance, cell, x, y, value);
    const customOnChange = typeof categoryModule.getCustomOnChange === "function" ? categoryModule.getCustomOnChange() : ()=>{};
    const transactionsWithCategoryData = categoryModule.applyCategorySpecificChanges(existingTransactions, account, displayedComponent, quotes).sort(sortingCallback); // final sort as per tableState;
    // console.log('CategoryWrapperTransactions > transaction array: ', transactionsWithCategoryData, existingTransactions);
    // if it is empty, return empty (only here, because in pension the purchase transactions are filtered out only in the previous step)
    if (transactionsWithCategoryData.length === 0 && displayedComponent === "table") {
        const buttonsToShow = (0, $f808db98154b70a0$export$2e2bcd8739ae039)(account.category, displayedComponent, displayedData);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                    buttonsToShow: buttonsToShow,
                    displayedComponent: displayedComponent,
                    displayedData: displayedData,
                    handleClick: handleClick,
                    userChangesPresent: userChangesPresent
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $111ad0445d705e89$export$2e2bcd8739ae039), {
                    showSync: buttonsToShow.includes("syncImport"),
                    showImport: [
                        "syncImport",
                        "import"
                    ].some((a)=>buttonsToShow.includes(a)),
                    category: account.category,
                    displayedData: displayedData,
                    connectedAccounts: connectedAccounts,
                    handleNavigateToAccount: handleNavigateToAccount
                })
            ]
        });
    }
    function identifyDeletedTransactions(inputData, outputData) {
        // console.log('input data', inputData, 'output data', outputData);
        // deleted transactions are those whose id is in inputData, but not in outputData
        const outputStack = [
            ...outputData
        ]; // all POST / PUT transactions are here already
        // DELETE: show me those entries from inputData, which have an id which does not exist in outputData
        const deletedItems = inputData.filter((inputObject)=>!outputData.some((outputObject)=>outputObject.id === inputObject.id))// removeGridFormatting, the following transformation, uses the order of properties in the object, so the deleted object must be structured the same way as the objects coming from Grid
        .map(categoryModule.categoryOrderedObject(account, displayedComponent)).map((item)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
                importFlag: "delete"
            }));
        if ($29230ffbadd17265$var$debugLevel > 2) console.log("deleted items", deletedItems, displayedComponent);
        return outputStack.concat(deletedItems);
    }
    // ------------------------------------------------------------
    // OUTPUT
    // ------------------------------------------------------------
    // receives data from Grid (.getData()), in the displayed order and unchanged
    // gridLayout is an array of objects with properties id, type, label, and other properties
    // dirtyRows is a Set of row indices which have been changed by the user
    // spreadExtraData (optional) is an object with additional data which needs to be spread to each row
    //   e.g. { providerAssetId, assetId } from manual mapping in Crypto
    function prepAndValidateOutputData(data, gridLayout, dirtyRows, spreadExtraData = null) {
        // ------------------------------------------------------------
        // STEP 1: transform data from Grid to the "canonical" format
        // ------------------------------------------------------------
        // 'data' is an array of arrays
        const newTransactionsTransformed = (0, $3865bcfae318d264$export$2e2bcd8739ae039)(data, gridLayout, dirtyRows, spreadExtraData);
        // console.log('transformed data', newTransactionsTransformed);
        // ------------------------------------------------------------
        // STEP 2: add deleted items back into the array
        // ------------------------------------------------------------
        // put deleted transactions back into the array with 'delete' importFlag
        // caution: if validation fails for the 'delete' rows later, it will be displayed as errors in Grid in an empty row (because these rows have been added and do not exist in Grid)
        const newTransactionsWithDeletes = identifyDeletedTransactions(existingTransactions, newTransactionsTransformed);
        // ------------------------------------------------------------
        // STEP 3: remove grid formatting
        // ------------------------------------------------------------
        const newTransactionsAfterReformatting = $ddc3e461ba9aa601$export$3962e06959b24991(newTransactionsWithDeletes, gridLayout);
        // ------------------------------------------------------------
        // STEP 4: apply category-specific transformations
        // ------------------------------------------------------------
        // re-add all properties not used by Grid from store to each preexisting transaction
        // perform category-specific transformations, add importFlag
        const newTransactionsAfterCategorySpecificTransformations = newTransactionsAfterReformatting.map((item)=>{
            const inputTransaction = existingTransactions.find((transaction)=>transaction.id === item.id);
            let importFlag;
            if (item.importFlag === "delete") importFlag = "delete"; // keep 'delete' flag
            else if (item.id && item.isDirty === true) importFlag = "put"; // if there is an id and the row has been changed, set importFlag to 'put'
            else if (!item.id) importFlag = "post"; // if there is no id, use 'post';
            else importFlag = null; // if there is an id and the row has not been changed, set importFlag to null
            return (0, $2qxEV._)((0, $9tqwB._)({}, inputTransaction, item), {
                previousVersion: inputTransaction,
                accountId: account.id,
                currency: account.currency,
                importFlag: importFlag,
                id: item.id || (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)()
            });
        })// .filter((item) => item.importFlag !== null) // remove rows which have not been changed --> 230805 REMOVED because custom validation in stocks requires the entire data set of the account
        .map(categoryModule.outputTransformCategoryTransactions(account));
        if ($29230ffbadd17265$var$debugLevel > 2) console.log("dataAfterCategorySpeficicTransformations", newTransactionsAfterCategorySpecificTransformations);
        // ------------------------------------------------------------
        // STEP 5: validate data
        // ------------------------------------------------------------
        // if validation is passed, return the "canonical" object, otherwise throw an error (with the validation errors)
        // and show the errors to user
        // REMEMBER: for performance reasons, dataAfterCategorySpeficicTransformations only contains rows which have been changed (including deleted rows)
        // the original Grid row index is in the rowNumber property
        let newTransactionsValidated;
        // error handler is complicated, so will take it out of the try-catch block and treat it as separate function
        // expects error objects in the format { path: 'rowNumber.columnName', message: 'error message' }
        let validationErrors = []; // clear all errors
        // general validation: if dashboardMode is 'dashboard', then all dates must be <= today utc; otherwise push error to validationErrors (PRD-1215)
        newTransactionsAfterCategorySpecificTransformations.forEach((item)=>{
            if (dashboardMode === "dashboard" && item.date > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf()) validationErrors.push({
                path: `${item.rowNumber}.date`,
                message: "Future-dated transactions can only be added in Project mode"
            });
            if (dashboardMode === "projects" && item.date <= (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf()) validationErrors.push({
                path: `${item.rowNumber}.date`,
                message: "Actual (past) transactions can only be added in Dashboard mode"
            });
        });
        // return errors without waiting for validation if found
        if (validationErrors.length > 0) {
            if ($29230ffbadd17265$var$debugLevel > 2) console.log("validationErrors after future date check", validationErrors);
            // return a list of errors back to caller (Grid) which can show it in the UI
            return {
                status: "error",
                errors: validationErrors
            };
        }
        // then run schema validations
        try {
            // cast should remove unknown properties and not fail on the first error
            newTransactionsValidated = categoryArraySchema.validateSync(newTransactionsAfterCategorySpecificTransformations, {
                abortEarly: false,
                stripUnknown: true
            });
        } catch (err) {
            // console.log('DEBUG ERROR after validation', err.message);
            // TODO find a way to catch the error and show it to the user
            // if there is err.inner, it means there is at least one validation error from yup validateSync
            // err.inner is an array of { name, value, path: 'rowNumber.columnName', errors: ['error message'] }; out of which we only use path and message (?)
            const isThisCustomError = String(err.message).includes("At least one of the prices");
            // first try to get stuff out of err.inner, regardless if there is a custom error or not
            if (err.inner) {
                validationErrors = err.inner.map((error)=>{
                    console.error("error item", JSON.stringify(error));
                    if ($29230ffbadd17265$var$debugLevel > 2) console.error("error item", error.path, Number(error.path.split(".")[0].slice(1, -1)));
                    return {
                        // take the last part of error.patch, which is the column name, and get the original row number from the item by indexing it in dataAfterCatgorySpecificTransformations
                        // path comes as [10].columnName, so need to remove [] as well
                        path: `${newTransactionsAfterCategorySpecificTransformations[Number(error.path.split(".")[0].slice(1, -1))].rowNumber}.${error.path.split(".")[1]}`,
                        message: error.errors[0]
                    };
                });
                // if there is a custom error, add it to the validationErrors
                if (isThisCustomError) {
                    // find the first row without any value column and flag it as error
                    // (we do not get path on this custom error)
                    const suspectedTransaction = newTransactionsAfterCategorySpecificTransformations.find((item)=>!item.upac && !item.upbc && !item.uptc);
                    if (suspectedTransaction) validationErrors.push({
                        path: `${suspectedTransaction.rowNumber}.valueAccountCurrency`,
                        message: err.message
                    });
                }
            // console.log('DEBUG validationErrors', validationErrors);
            } else // console.log('DEBUG about to throw an unhandled error');
            throw new Error(err);
        }
        // -------------------------------------------------------------------------------------
        // STEP 6: perform category-specific validation and inject errors into validationErrors
        // -------------------------------------------------------------------------------------
        // requires the entire account data set, not just the changed rows (!)
        // if there is a function 'additionalValidations', then call it -- it will return an array of errors (if any)
        if (typeof categoryModule.additionalValidations === "function") {
            const getAdditionalErrors = categoryModule.additionalValidations(newTransactionsValidated);
            if (getAdditionalErrors.length > 0) validationErrors.push(...getAdditionalErrors);
        }
        // handles validation errors
        if (validationErrors.length > 0) // return a list of errors back to caller (Grid) which can show it in the UI
        return {
            status: "error",
            errors: validationErrors
        };
        const returnedData = (newTransactionsValidated || []).filter((item)=>item.importFlag !== null);
        if ($29230ffbadd17265$var$debugLevel > 2) console.log("validated data", returnedData);
        return {
            status: "success",
            data: returnedData
        };
    }
    const commonProps = {
        account: account,
        data: transactionsWithCategoryData,
        mode: "holdings",
        tableState: tableState,
        setTableState: setTableState,
        displayedComponent: displayedComponent,
        displayedData: displayedData,
        handleClick: handleClick
    };
    if (displayedComponent === "grid") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d0664c3634384b7$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        prepAndValidateOutputData: prepAndValidateOutputData,
        postCategoryItems: categoryModule.postCategoryItems,
        userChangesPresent: userChangesPresent,
        setUserChangesPresent: setUserChangesPresent,
        setAccount: setAccount,
        customDropdownSources: customDropdownSources,
        customOnChange: customOnChange,
        saveDialogPromiseCallback: categoryModule.saveDialogPromiseCallback
    }));
    if (displayedComponent === "table") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8aa5f62c4a0f8e73$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        handleSync: handleSync,
        accountSyncStatus: syncStatus,
        highlightTransactionId: highlightTransactionId
    }));
    return null;
}
$29230ffbadd17265$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    connectedAccounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    handleNavigateToAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    highlightTransactionId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    filter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$29230ffbadd17265$export$2e2bcd8739ae039.defaultProps = {
    highlightTransactionId: null,
    filter: null,
    connectedAccounts: [],
    handleNavigateToAccount: null
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $a3c750946445b1c4$export$81a21056c0172805({ displayedComponent: displayedComponent, account: account, setAccount: setAccount, tableState: tableState, setTableState: setTableState, displayedData: displayedData, handleClick: handleClick, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent, highlightTransactionId: highlightTransactionId, filter: filter, connectedAccounts: connectedAccounts, handleNavigateToAccount: handleNavigateToAccount }) {
    const commonProps = {
        account: account,
        setAccount: setAccount,
        tableState: tableState,
        setTableState: setTableState,
        displayedData: displayedData,
        handleClick: handleClick,
        userChangesPresent: userChangesPresent,
        setUserChangesPresent: setUserChangesPresent,
        connectedAccounts: connectedAccounts,
        handleNavigateToAccount: handleNavigateToAccount
    };
    if (displayedComponent === "table") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $29230ffbadd17265$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        displayedComponent: "table",
        highlightTransactionId: highlightTransactionId,
        filter: filter
    }));
    if (displayedComponent === "grid") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $29230ffbadd17265$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        displayedComponent: "grid"
    }));
    return null;
}
$a3c750946445b1c4$export$81a21056c0172805.propTypes = {
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    highlightTransactionId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    filter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    connectedAccounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    handleNavigateToAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$a3c750946445b1c4$export$81a21056c0172805.defaultProps = {
    highlightTransactionId: null,
    filter: null,
    connectedAccounts: [],
    handleNavigateToAccount: null
};
const $a3c750946445b1c4$export$b1cca2d87a99b78 = /*#__PURE__*/ (0, $7fPBF.memo)($a3c750946445b1c4$export$81a21056c0172805, (0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports))));
var $a3c750946445b1c4$export$2e2bcd8739ae039 = $a3c750946445b1c4$export$b1cca2d87a99b78;


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");




/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







var $97ae8a0ec25a66a0$exports = {};

$parcel$export($97ae8a0ec25a66a0$exports, "categoryOrderedObject", function () { return $97ae8a0ec25a66a0$export$3270e954cce20150; });
$parcel$export($97ae8a0ec25a66a0$exports, "applyCategorySpecificChanges", function () { return $97ae8a0ec25a66a0$export$c6abce4536815011; });
$parcel$export($97ae8a0ec25a66a0$exports, "outputTransformCategoryQuotes", function () { return $97ae8a0ec25a66a0$export$4b180cb889f37f7d; });
// INPUT transformations
// used to put quote object attributes in the exact order expected by table and grid layouts

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $97ae8a0ec25a66a0$export$3270e954cce20150(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function realEstateOrdereObjectInnerFunc(quote) {
        var _account_valuationParameters, _account_valuationParameters1, _account_valuationParameters2, _account_valuationParameters3;
        // this has to exactly follow the column order laid out by gridLayout
        return {
            date: quote.date,
            source: quote.source,
            quoteBaseCurrency: quote.quoteBaseCurrency,
            currency: quote.currency,
            quote: quote.quote,
            pricePerSquareMetre: (account === null || account === void 0 ? void 0 : (_account_valuationParameters = account.valuationParameters) === null || _account_valuationParameters === void 0 ? void 0 : _account_valuationParameters.livingArea) ? quote.quoteBaseCurrency / Number(account === null || account === void 0 ? void 0 : (_account_valuationParameters1 = account.valuationParameters) === null || _account_valuationParameters1 === void 0 ? void 0 : _account_valuationParameters1.livingArea) : null,
            originalPricePerSquareMetre: (account === null || account === void 0 ? void 0 : (_account_valuationParameters2 = account.valuationParameters) === null || _account_valuationParameters2 === void 0 ? void 0 : _account_valuationParameters2.livingArea) ? quote.quote / Number(account === null || account === void 0 ? void 0 : (_account_valuationParameters3 = account.valuationParameters) === null || _account_valuationParameters3 === void 0 ? void 0 : _account_valuationParameters3.livingArea) : null,
            assetId: quote.assetId
        };
    };
}
function $97ae8a0ec25a66a0$export$c6abce4536815011(_quotes, account = null) {
    return _quotes.map($97ae8a0ec25a66a0$export$3270e954cce20150(account));
}
function $97ae8a0ec25a66a0$export$4b180cb889f37f7d(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryQuotesInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            assetId: item.assetId || account.id,
            source: item.source || "manual",
            importFlag: item.importFlag || "put"
        });
    };
}


var $2e3421fc81e6bb84$exports = {};

$parcel$export($2e3421fc81e6bb84$exports, "categoryOrderedObject", function () { return $2e3421fc81e6bb84$export$3270e954cce20150; });
$parcel$export($2e3421fc81e6bb84$exports, "applyCategorySpecificChanges", function () { return $2e3421fc81e6bb84$export$c6abce4536815011; });
$parcel$export($2e3421fc81e6bb84$exports, "getCustomDropdownSources", function () { return $2e3421fc81e6bb84$export$10e67feb6a48460e; });
$parcel$export($2e3421fc81e6bb84$exports, "outputTransformCategoryQuotes", function () { return $2e3421fc81e6bb84$export$4b180cb889f37f7d; });
$parcel$export($2e3421fc81e6bb84$exports, "EmptyStateMessage", function () { return $2e3421fc81e6bb84$export$11e5ba4f4669e663; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $7fPBF = parcelRequire("7fPBF");




function $2e3421fc81e6bb84$export$3270e954cce20150(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function stocksOrderedObjectInnerFunc(quote) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            displaySymbol: (0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displaySymbolByAssetId[quote.assetId],
            date: quote.date,
            source: quote.source,
            quoteBaseCurrency: quote.quoteBaseCurrency,
            currency: quote.currency,
            quote: quote.quote
        };
    };
}
function $2e3421fc81e6bb84$export$c6abce4536815011(_quotes, account = null) {
    return _quotes.map($2e3421fc81e6bb84$export$3270e954cce20150());
}
function $2e3421fc81e6bb84$export$10e67feb6a48460e() {
    // return { displaySymbol: Object.entries(stocksMetadata(store.getState()).displayNameByDisplaySymbol).map(([key, value]) => ({ id: key, name: value })) };
    return {
        displaySymbol: Object.keys((0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displayNameByDisplaySymbol)
    };
}
function $2e3421fc81e6bb84$export$4b180cb889f37f7d(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformStockQuotesInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            source: item.source || "manual",
            importFlag: item.importFlag || "put",
            assetId: (0, $cfd21bc923628483$export$ffbf01f805bb8c9b)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).assetIdByDisplaySymbol[item.displaySymbol]
        });
    };
}
function $2e3421fc81e6bb84$export$11e5ba4f4669e663() {
    const h = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement;
    return h("div", {
        className: "bg-white py-8 w-full self-start"
    }, h("div", {
        className: "mx-auto max-w-7xl px-6 lg:px-8"
    }, h("div", {
        className: "mx-auto max-w-3xl lg:text-center"
    }, h("h2", {
        className: "text-base font-semibold leading-8 tracking-wide text-brandBlue-500 uppercase"
    }, (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("accountDetails:quotesEmptyStocks.heading")), h("p", {
        className: "mt-2 text-3xl sm:text-4xl font-bold text-gray-900"
    }, (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("accountDetails:quotesEmptyStocks.subheading")), h("p", {
        className: "mt-4 text-base leading-7 text-gray-600"
    }, (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("accountDetails:quotesEmptyStocks.intro"))), h("div", {
        className: "mx-auto mt-8 max-w-2xl sm:mt-20"
    }, h("div", {
        className: "rounded-2xl border border-gray-200 bg-gray-50 p-6 sm:p-8"
    }, h("div", {
        className: "flex items-start gap-x-3"
    }, h((0, $81d773ef7a32fb70$export$2e2bcd8739ae039), {
        className: "h-5 w-5 flex-none text-brandBlue-500 mt-0.5",
        "aria-hidden": "true"
    }), h("div", null, h("p", {
        className: "text-base font-semibold leading-7 text-gray-900"
    }, (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("accountDetails:quotesEmptyStocks.featureTitle")), h("p", {
        className: "mt-2 text-base leading-6 text-gray-600"
    }, (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("accountDetails:quotesEmptyStocksManualOnly"))))))));
}


var $2fd8c0b61bb4ec6d$exports = {};

$parcel$export($2fd8c0b61bb4ec6d$exports, "categoryOrderedObject", function () { return $2fd8c0b61bb4ec6d$export$3270e954cce20150; });
$parcel$export($2fd8c0b61bb4ec6d$exports, "applyCategorySpecificChanges", function () { return $2fd8c0b61bb4ec6d$export$c6abce4536815011; });
$parcel$export($2fd8c0b61bb4ec6d$exports, "outputTransformCategoryQuotes", function () { return $2fd8c0b61bb4ec6d$export$4b180cb889f37f7d; });
// figure out how this should look like
// date | currency | price1 | price2 | price3 | price4 (all account currency)
// the handleSave function must take this and pack it into specialQuotes before sending it on its merry way

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $2fd8c0b61bb4ec6d$export$3270e954cce20150(displayedComponent, account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function pensionOrderedObjectInnerFunc(quote) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            date: quote.date,
            payoutOnlyContributionsToDate: (quote.specialQuotes.find((sq)=>sq.type === "payoutOnlyContributionsToDate") || {
                quote: null
            }).quote,
            payoutOnlyContributionsToDateIndexed: (quote.specialQuotes.find((sq)=>sq.type === "payoutOnlyContributionsToDateIndexed") || {
                quote: null
            }).quote,
            payoutAllPlannedContributions: (quote.specialQuotes.find((sq)=>sq.type === "payoutAllPlannedContributions") || {
                quote: null
            }).quote,
            payoutAllPlannedContributionsIndexed: (quote.specialQuotes.find((sq)=>sq.type === "payoutAllPlannedContributionsIndexed") || {
                quote: null
            }).quote,
            payoutLumpSumVerrentet: (quote.specialQuotes.find((sq)=>sq.type === "payoutLumpSumVerrentet") || {
                quote: null
            }).quote,
            currency: quote.currency
        };
    };
}
function $2fd8c0b61bb4ec6d$export$c6abce4536815011(_quotes, displayedComponent, account = null) {
    return _quotes.map($2fd8c0b61bb4ec6d$export$3270e954cce20150(displayedComponent, account));
}
function $2fd8c0b61bb4ec6d$export$4b180cb889f37f7d(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryQuotesInnerFunc(item) {
        const specialQuotes = [];
        if (item.payoutOnlyContributionsToDate) specialQuotes.push({
            type: "payoutOnlyContributionsToDate",
            quote: item.payoutOnlyContributionsToDate
        });
        if (item.payoutOnlyContributionsToDateIndexed) specialQuotes.push({
            type: "payoutOnlyContributionsToDateIndexed",
            quote: item.payoutOnlyContributionsToDateIndexed
        });
        if (item.payoutAllPlannedContributions) specialQuotes.push({
            type: "payoutAllPlannedContributions",
            quote: item.payoutAllPlannedContributions
        });
        if (item.payoutAllPlannedContributionsIndexed) specialQuotes.push({
            type: "payoutAllPlannedContributionsIndexed",
            quote: item.payoutAllPlannedContributionsIndexed
        });
        if (item.payoutLumpSumVerrentet) specialQuotes.push({
            type: "payoutLumpSumVerrentet",
            quote: item.payoutLumpSumVerrentet
        });
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            currency: account.currency,
            assetId: item.assetId || account.id,
            source: item.source || "manual",
            importFlag: item.importFlag || "put",
            projectId: null,
            quote: 0,
            quoteBaseCurrency: 0,
            specialQuotes: specialQuotes
        });
    };
}


var $0c623b17f45624f0$exports = {};

$parcel$export($0c623b17f45624f0$exports, "categoryOrderedObject", function () { return $0c623b17f45624f0$export$3270e954cce20150; });
$parcel$export($0c623b17f45624f0$exports, "applyCategorySpecificChanges", function () { return $0c623b17f45624f0$export$c6abce4536815011; });
$parcel$export($0c623b17f45624f0$exports, "outputTransformCategoryQuotes", function () { return $0c623b17f45624f0$export$4b180cb889f37f7d; });
// INPUT transformations
// used to put quote object attributes in the exact order expected by table and grid layouts

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
function $0c623b17f45624f0$export$3270e954cce20150(account = null) {
    return function realEstateOrdereObjectInnerFunc(quote) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            date: quote.date,
            source: quote.source,
            quote: quote.quote,
            currency: quote.currency,
            quoteBaseCurrency: quote.quoteBaseCurrency,
            note: quote.note,
            assetId: quote.assetId
        };
    };
}
function $0c623b17f45624f0$export$c6abce4536815011(_quotes, account = null) {
    return _quotes.map($0c623b17f45624f0$export$3270e954cce20150(account));
}
function $0c623b17f45624f0$export$4b180cb889f37f7d(account = null) {
    return function outputTransformCategoryQuotesInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            assetId: item.assetId || account.id,
            source: item.source || "manual",
            importFlag: item.importFlag || "put"
        });
    };
}


var $0712db68cc1c9729$exports = {};

$parcel$export($0712db68cc1c9729$exports, "categoryOrderedObject", function () { return $0712db68cc1c9729$export$3270e954cce20150; });
$parcel$export($0712db68cc1c9729$exports, "applyCategorySpecificChanges", function () { return $0712db68cc1c9729$export$c6abce4536815011; });
$parcel$export($0712db68cc1c9729$exports, "getCustomDropdownSources", function () { return $0712db68cc1c9729$export$10e67feb6a48460e; });
$parcel$export($0712db68cc1c9729$exports, "outputTransformCategoryQuotes", function () { return $0712db68cc1c9729$export$4b180cb889f37f7d; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


function $0712db68cc1c9729$export$3270e954cce20150(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function metalsOrderedObjectInnerFunc(quote) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            assetName: (0, $4678812afdc6b9f3$export$7a3c3d42e4d75513)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).find((a)=>a.assetId === quote.assetId).assetName,
            date: quote.date,
            source: quote.source,
            quoteBaseCurrency: quote.quoteBaseCurrency,
            currency: quote.currency,
            quote: quote.quote,
            note: quote.note
        };
    };
}
function $0712db68cc1c9729$export$c6abce4536815011(_quotes, account = null) {
    return _quotes.map($0712db68cc1c9729$export$3270e954cce20150());
}
function $0712db68cc1c9729$export$10e67feb6a48460e() {
    return {
        assetName: (0, $4678812afdc6b9f3$export$7a3c3d42e4d75513)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).map((ma)=>ma.assetName)
    };
}
function $0712db68cc1c9729$export$4b180cb889f37f7d(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformMetalsQuotesInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            source: item.source || "manual",
            importFlag: item.importFlag || "put",
            assetId: item.assetName.replace(/[^a-zA-Z0-9]/g, "")
        });
    };
}


var $3aeab827e97552fa$exports = {};

$parcel$export($3aeab827e97552fa$exports, "categoryOrderedObject", function () { return $3aeab827e97552fa$export$3270e954cce20150; });
$parcel$export($3aeab827e97552fa$exports, "applyCategorySpecificChanges", function () { return $3aeab827e97552fa$export$c6abce4536815011; });
$parcel$export($3aeab827e97552fa$exports, "outputTransformCategoryQuotes", function () { return $3aeab827e97552fa$export$4b180cb889f37f7d; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

function $3aeab827e97552fa$export$3270e954cce20150(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function metalsOrderedObjectInnerFunc(quote) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            assetName: (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState().data.unlistedShares.accounts.find((a)=>a.id === quote.assetId).name,
            date: quote.date,
            source: quote.source,
            quoteBaseCurrency: quote.quoteBaseCurrency,
            currency: quote.currency,
            quote: quote.quote,
            note: quote.note
        };
    };
}
function $3aeab827e97552fa$export$c6abce4536815011(_quotes, account = null) {
    return _quotes.map($3aeab827e97552fa$export$3270e954cce20150());
}
function $3aeab827e97552fa$export$4b180cb889f37f7d(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformMetalsQuotesInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            source: item.source || "manual",
            importFlag: item.importFlag || "put"
        });
    };
}


var $41ca110601449e09$exports = {};

$parcel$export($41ca110601449e09$exports, "categoryOrderedObject", function () { return $41ca110601449e09$export$3270e954cce20150; });
$parcel$export($41ca110601449e09$exports, "applyCategorySpecificChanges", function () { return $41ca110601449e09$export$c6abce4536815011; });
$parcel$export($41ca110601449e09$exports, "outputTransformCategoryQuotes", function () { return $41ca110601449e09$export$4b180cb889f37f7d; });

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


function $41ca110601449e09$export$3270e954cce20150(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function cryptoOrderedObjectInnerFunc(quote) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            displaySymbol: (0, $e815710920e23f12$export$f339a7f853313e14)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).displaySymbolByAssetId[quote.assetId],
            date: quote.date,
            source: quote.source,
            quoteBaseCurrency: quote.quoteBaseCurrency,
            currency: quote.currency,
            quote: quote.quote
        };
    };
}
function $41ca110601449e09$export$c6abce4536815011(_quotes, account = null) {
    return _quotes.map($41ca110601449e09$export$3270e954cce20150());
}
function $41ca110601449e09$export$4b180cb889f37f7d(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformStockQuotesInnerFunc(item) {
        return (0, $2qxEV._)((0, $9tqwB._)({}, item), {
            source: item.source || "manual",
            importFlag: item.importFlag || "put",
            assetId: (0, $e815710920e23f12$export$f339a7f853313e14)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState()).assetIdByDisplaySymbol[item.displaySymbol]
        });
    };
}




function $3e39b0c301b1df6e$export$2e2bcd8739ae039({ account: account, setAccount: setAccount, quotes: quotes, tableState: tableState, setTableState: setTableState, displayedComponent: displayedComponent, displayedData: displayedData, handleClick: handleClick, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent }) {
    let funcs;
    switch(account.category){
        case "realEstate":
            funcs = $97ae8a0ec25a66a0$exports;
            break;
        case "crypto":
            funcs = $41ca110601449e09$exports;
            break;
        case "stocks":
            funcs = $2e3421fc81e6bb84$exports;
            break;
        case "pension":
            funcs = $2fd8c0b61bb4ec6d$exports;
            break;
        case "objectsOfValue":
            funcs = $0c623b17f45624f0$exports;
            break;
        case "metals":
            funcs = $0712db68cc1c9729$exports;
            break;
        case "unlistedShares":
            funcs = $3aeab827e97552fa$exports;
            break;
        default:
            funcs = {};
    }
    // TRANSFORM INPUT DATA
    // add category-specific data to the transactions and sort
    const sortingCallback = (0, $7fPBF.useCallback)((a, b)=>$ddc3e461ba9aa601$export$398604a469f7de9a(a, b, tableState.sortBy, tableState.sortDirectionAsc), [
        tableState.sortBy,
        tableState.sortDirectionAsc
    ]);
    // imported from transactions to make sorting consistent between transactions and quotes, but seems to have no application here, so commenting it out for now
    // const sortingCallback = typeof categoryModule.getSortingCallback === 'function' ? categoryModule.getSortingCallback(tableState) : defaultSortingCallback;
    // customDropdownSources is an object with keys as column names and values as arrays of strings
    // if there is a customDropdown type of column in the grid layout for this category, it will try to find dropdown source values in this object
    // { columnName: [<array of string>] }
    const customDropdownSources = typeof funcs.getCustomDropdownSources === "function" ? funcs.getCustomDropdownSources() : {};
    // customOnChange is executed after every value change in Grid
    // it receives (instance, cell, x, y, value);
    const customOnChange = typeof funcs.getCustomOnChange === "function" ? funcs.getCustomOnChange() : ()=>{};
    const quotesWithCategoryData = (0, $7fPBF.useMemo)(()=>{
        // add category-specific data to the quotes
        const data = funcs.applyCategorySpecificChanges(quotes, displayedComponent, account);
        const sortedData = [
            ...data
        ].sort(sortingCallback);
        // console.log('DEBUG in CategoryWrapperQuotes, incoming:', quotes, 'after applySpecificChanges', data, 'after sorting', sortedData);
        return sortedData;
    }, [
        account.category,
        account.livingArea,
        quotes,
        displayedComponent,
        sortingCallback
    ]);
    // PREPARE OUTPUT DATA
    function identifyDeletedQuotes(inputData, outputData) {
        // quotes is partitioned by date
        const outputStack = [
            ...outputData
        ]; // all PUT quotes are here already
        // DELETE: show me those entries from inputData, which have a date which does not exist in outputData
        const deletedItems = inputData.filter((inputObject)=>!outputData.some((outputObject)=>outputObject.date === inputObject.date))// removeGridFormatting, the following transformation, uses the order of properties in the object, so the deleted object must be structured the same way as the objects coming from Grid
        .map(funcs.categoryOrderedObject(account)).map((item)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
                importFlag: "delete"
            }));
        return outputStack.concat(deletedItems);
    }
    function prepAndValidateOutputData(data, gridLayout, dirtyRows) {
        //
        // STEP 1: transform data from Grid to the "canonical" format
        //
        const transformedData = (0, $3865bcfae318d264$export$2e2bcd8739ae039)(data, gridLayout, dirtyRows);
        // const transformedData = data
        //   // add dirty / not dirty column to every row array based on dirtyRows (but only to rows which are not empty, because they won't be removed in the next step of the chain)
        //   .map((row, idx) => (row.join('').length > 0 ? [...row, dirtyRows.has(String(idx))] : row))
        //   // remove completely empty rows
        //   .filter((row) => row.join('').length > 0)
        //   // convert array of arrays to array of objects
        //   .map((row) => gridLayout.concat({ id: 'isDirty', type: 'boolean' }).reduce((prev, curr, idx) => ({ ...prev, [curr.id]: row[idx] }), {}));
        //
        // STEP 2: add deleted items back into the array
        //
        // put deleted quotes back into the array with 'delete' importFlag
        // caution: if validation fails for the 'delete' rows later, it will be displayed as errors in Grid in an empty row (because these rows have been added and do not exist in Grid)
        const dataWithDeletes = identifyDeletedQuotes(quotes, transformedData);
        //
        // STEP 3: remove grid formatting
        //
        const dataAfterReformatting = $ddc3e461ba9aa601$export$3962e06959b24991(dataWithDeletes, gridLayout);
        //
        // STEP 4: apply category-specific transformations
        //
        // perform category-specific transformations, add importFlag
        const dataAfterCategorySpeficicTransformations = dataAfterReformatting.map(funcs.outputTransformCategoryQuotes(account));
        //
        // STEP 5: validate data against schema
        //
        // if validation is passed, return the "canonical" object, otherwise throw an error (with the validation errors)
        // and show the errors to user
        let validatedData;
        // error handler is complicated, so will take it out of the try-catch block and treat it as separate function
        let validationErrors = []; // clear all errors
        try {
            // cast should remove unknown properties and not fail on the first error
            validatedData = $fd6541cb8870bfa3$export$afe84a81194592dd.validateSync(dataAfterCategorySpeficicTransformations, {
                abortEarly: false,
                stripUnknown: true
            });
        // console.table('validatedData', validatedData);
        } catch (err) {
            // if there is err.inner, it means there is at least one validation error from yup validateSync
            // since this is too complex to handle here, set validationError and handle in the next block
            // otherwise this is a regular error and can be thrown here
            console.error("CategoryWrapperQuotes > validation error:", err);
            console.info("CategoryWrapperQuotes > data being validated:", dataAfterCategorySpeficicTransformations);
            if (err.inner) validationErrors = err.inner;
            else throw new Error(err);
        }
        // handles validation errors
        if (validationErrors.length > 0) // return a list of errors back to caller (Grid) which can show it in the UI
        return {
            status: "error",
            errors: validationErrors
        };
        return {
            status: "success",
            data: validatedData
        };
    }
    function postCategoryItems(data, _account) {
        return (0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
            arrayOfQuotes: data,
            category: _account.category,
            accountId: _account.id
        });
    }
    const commonProps = {
        account: account,
        data: quotesWithCategoryData,
        mode: "quotes",
        tableState: tableState,
        setTableState: setTableState,
        displayedComponent: displayedComponent,
        displayedData: displayedData,
        handleClick: handleClick
    };
    // if it is empty, return empty (only in table mode)
    if (quotes.length === 0 && displayedComponent === "table") {
        const CustomEmptyStateMessage = funcs.EmptyStateMessage;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                    buttonsToShow: (0, $f808db98154b70a0$export$2e2bcd8739ae039)(account.category, "quotes"),
                    displayedComponent: displayedComponent,
                    displayedData: displayedData,
                    handleClick: handleClick,
                    userChangesPresent: userChangesPresent
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "flex w-full h-full justify-center items-center",
                    children: typeof CustomEmptyStateMessage === "function" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(CustomEmptyStateMessage, {
                        account: account,
                        displayedData: displayedData
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-xl font-bold",
                        children: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("accountDetails:quotesEmptyGeneric")
                    })
                })
            ]
        });
    }
    if (displayedComponent === "grid") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9d0664c3634384b7$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        prepAndValidateOutputData: prepAndValidateOutputData,
        postCategoryItems: postCategoryItems,
        userChangesPresent: userChangesPresent,
        setUserChangesPresent: setUserChangesPresent,
        setAccount: setAccount,
        customDropdownSources: customDropdownSources,
        customOnChange: customOnChange
    }));
    if (displayedComponent === "table") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8aa5f62c4a0f8e73$export$2e2bcd8739ae039), (0, $9tqwB._)({}, commonProps));
    return null;
}
$3e39b0c301b1df6e$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    quotes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $c0769444465afefa$var$debugLevel = 0;
function $c0769444465afefa$export$77a9bc2e04b0a4fd({ displayedComponent: displayedComponent, account: account, setAccount: setAccount, tableState: tableState, setTableState: setTableState, displayedData: displayedData, handleClick: handleClick, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent }) {
    const selectQuotes = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$443f4a6ebd922e0a));
    const dashboardMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    const selectTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $3679aa7475d9bd44$export$9c38a21154823fe6)(state, account.category).filter((transaction)=>transaction.accountId === account.id));
    // get only quotes for the assetIds which are in the account
    const assetIds = selectTransactions.reduce((prev, curr)=>{
        if (!prev.assetId) prev.push(curr.assetId);
        return prev;
    }, []);
    if ($c0769444465afefa$var$debugLevel > 2) console.log("QuotesWrapper > selector input", selectQuotes, "assetIds", assetIds);
    const quotesForAccountAssetIds = Object.entries(selectQuotes).reduce((prev, [assetId, assetObj])=>assetIds.includes(assetId) ? (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
            [assetId]: assetObj
        }) : prev, {});
    if ($c0769444465afefa$var$debugLevel > 2) console.log("QuotesWrapper > quotesForAccountAssetIds", quotesForAccountAssetIds);
    // produce a flat array of all quotes for this account's assets;
    const filteredQuotes = (0, $3e6d58b7292c657b$export$a537c627e243cb6e)(quotesForAccountAssetIds, [
        "assetId",
        "date"
    ]).filter((quote)=>[
            "manual",
            "simulated"
        ].includes(quote.source) && (!!quote.quote || !!quote.specialQuotes // quote must exist (it makes no sense to display it when it is null or 0)
        ) && Number(quote.date) === Number(quote.quoteDate));
    // removed by PRD-1215: in "dashboard" show only past manual quotes; in "projects" show all manual quotes
    // && (dashboardMode === 'projects' ? true : Number(quote.date) === Number(quote.quoteDate))); // removed by PRD-1215
    // we are expecting to receive all manual quotes on top of the requested dates for all submitted assetIds
    const quotes = filteredQuotes.filter((quote)=>(dashboardMode === "projects" ? true : quote.date <= (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().valueOf()) && ![
            "current"
        ].includes(quote.date)) // filter out quotes from the future
    // FIX 240517 sorting will happen in TableLayout / GridLayout, as there can be fields added between here and those components
    // FIX 240517 those fields (column headers) when clicked are then not available here to change the sorting order
    // FIX 240517 .sort((a, b) => compare(a, b, tableState.sortBy, tableState.sortDirectionAsc)) // final sort as per tableState
    // convert date if this is a grid; replace quoteDate with date to show the user the date they actually entered
    .map((quote)=>(0, $2qxEV._)((0, $9tqwB._)({}, quote), {
            date: displayedComponent === "table" ? Number(quote.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(quote.date)).format("DD.MM.YYYY")
        }));
    // console.log('DEBUG in QuotesWrapper > filteredQuotes', quotes, displayedComponent);
    if ($c0769444465afefa$var$debugLevel > 2) console.log("QuotesWrapper > quotesForAccountAssetIds", quotesForAccountAssetIds);
    if ($c0769444465afefa$var$debugLevel > 2) console.log("QuotesWrapper > filteredQuotes", filteredQuotes);
    if ($c0769444465afefa$var$debugLevel > 2) console.log("QuotesWrapper > quotes", quotes);
    const commonProps = {
        account: account,
        setAccount: setAccount,
        quotes: quotes,
        tableState: tableState,
        setTableState: setTableState,
        displayedData: displayedData,
        handleClick: handleClick,
        userChangesPresent: userChangesPresent,
        setUserChangesPresent: setUserChangesPresent
    };
    if (displayedComponent === "table") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e39b0c301b1df6e$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        displayedComponent: "table"
    }));
    if (displayedComponent === "grid") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3e39b0c301b1df6e$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, commonProps), {
        displayedComponent: "grid"
    }));
    return null;
}
$c0769444465afefa$export$77a9bc2e04b0a4fd.propTypes = {
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
const $c0769444465afefa$export$7d8c596bc75be1a9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($c0769444465afefa$export$77a9bc2e04b0a4fd, (0, (/*@__PURE__*/$parcel$interopDefault($034d80e6a88ef527$exports))));
var $c0769444465afefa$export$2e2bcd8739ae039 = $c0769444465afefa$export$7d8c596bc75be1a9;


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
/* eslint-disable no-await-in-loop */ /* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $21da20d2fc3ca230$require$Buffer = $bdjQ6.Buffer;
const $21da20d2fc3ca230$export$83d89fbfd8236492 = "3.7.5";
/**
 * @deprecated use lowercase `version`.
 */ const $21da20d2fc3ca230$export$a4ad2735b021c132 = $21da20d2fc3ca230$export$83d89fbfd8236492;
const $21da20d2fc3ca230$var$_hasatob = typeof atob === "function";
const $21da20d2fc3ca230$var$_hasbtoa = typeof btoa === "function";
const $21da20d2fc3ca230$var$_hasBuffer = typeof $21da20d2fc3ca230$require$Buffer === "function";
const $21da20d2fc3ca230$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $21da20d2fc3ca230$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $21da20d2fc3ca230$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $21da20d2fc3ca230$var$b64chs = Array.prototype.slice.call($21da20d2fc3ca230$var$b64ch);
const $21da20d2fc3ca230$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($21da20d2fc3ca230$var$b64chs);
const $21da20d2fc3ca230$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $21da20d2fc3ca230$var$_fromCC = String.fromCharCode.bind(String);
const $21da20d2fc3ca230$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $21da20d2fc3ca230$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $21da20d2fc3ca230$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $21da20d2fc3ca230$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $21da20d2fc3ca230$var$b64chs[u32 >> 18 & 63] + $21da20d2fc3ca230$var$b64chs[u32 >> 12 & 63] + $21da20d2fc3ca230$var$b64chs[u32 >> 6 & 63] + $21da20d2fc3ca230$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $21da20d2fc3ca230$export$a32219e24f8d1e2 = $21da20d2fc3ca230$var$_hasbtoa ? (bin)=>btoa(bin) : $21da20d2fc3ca230$var$_hasBuffer ? (bin)=>$21da20d2fc3ca230$require$Buffer.from(bin, "binary").toString("base64") : $21da20d2fc3ca230$export$ec0fb543302ee251;
const $21da20d2fc3ca230$var$_fromUint8Array = $21da20d2fc3ca230$var$_hasBuffer ? (u8a)=>$21da20d2fc3ca230$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($21da20d2fc3ca230$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $21da20d2fc3ca230$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $21da20d2fc3ca230$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $21da20d2fc3ca230$var$_mkUriSafe($21da20d2fc3ca230$var$_fromUint8Array(u8a)) : $21da20d2fc3ca230$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $21da20d2fc3ca230$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $21da20d2fc3ca230$var$_fromCC(0xc0 | cc >>> 6) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc & 0x3f) : $21da20d2fc3ca230$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $21da20d2fc3ca230$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $21da20d2fc3ca230$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $21da20d2fc3ca230$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $21da20d2fc3ca230$export$10d4b9bd20a66b0 = (u)=>u.replace($21da20d2fc3ca230$var$re_utob, $21da20d2fc3ca230$var$cb_utob);
//
const $21da20d2fc3ca230$var$_encode = $21da20d2fc3ca230$var$_hasBuffer ? (s)=>$21da20d2fc3ca230$require$Buffer.from(s, "utf8").toString("base64") : $21da20d2fc3ca230$var$_TE ? (s)=>$21da20d2fc3ca230$var$_fromUint8Array($21da20d2fc3ca230$var$_TE.encode(s)) : (s)=>$21da20d2fc3ca230$export$a32219e24f8d1e2($21da20d2fc3ca230$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $21da20d2fc3ca230$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $21da20d2fc3ca230$var$_mkUriSafe($21da20d2fc3ca230$var$_encode(src)) : $21da20d2fc3ca230$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $21da20d2fc3ca230$export$90c31d5baa78df44 = (src)=>$21da20d2fc3ca230$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $21da20d2fc3ca230$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $21da20d2fc3ca230$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $21da20d2fc3ca230$var$_fromCC((offset >>> 10) + 0xD800) + $21da20d2fc3ca230$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $21da20d2fc3ca230$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $21da20d2fc3ca230$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $21da20d2fc3ca230$export$67e9defdeac3dd95 = (b)=>b.replace($21da20d2fc3ca230$var$re_btou, $21da20d2fc3ca230$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $21da20d2fc3ca230$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$21da20d2fc3ca230$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)] << 18 | $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $21da20d2fc3ca230$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $21da20d2fc3ca230$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $21da20d2fc3ca230$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $21da20d2fc3ca230$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $21da20d2fc3ca230$export$1406ac7a6dfd7b7a = $21da20d2fc3ca230$var$_hasatob ? (asc)=>atob($21da20d2fc3ca230$var$_tidyB64(asc)) : $21da20d2fc3ca230$var$_hasBuffer ? (asc)=>$21da20d2fc3ca230$require$Buffer.from(asc, "base64").toString("binary") : $21da20d2fc3ca230$export$7f16d8e674ddec24;
//
const $21da20d2fc3ca230$var$_toUint8Array = $21da20d2fc3ca230$var$_hasBuffer ? (a)=>$21da20d2fc3ca230$var$_U8Afrom($21da20d2fc3ca230$require$Buffer.from(a, "base64")) : (a)=>$21da20d2fc3ca230$var$_U8Afrom($21da20d2fc3ca230$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $21da20d2fc3ca230$export$73470fd2221e6aef = (a)=>$21da20d2fc3ca230$var$_toUint8Array($21da20d2fc3ca230$var$_unURI(a));
//
const $21da20d2fc3ca230$var$_decode = $21da20d2fc3ca230$var$_hasBuffer ? (a)=>$21da20d2fc3ca230$require$Buffer.from(a, "base64").toString("utf8") : $21da20d2fc3ca230$var$_TD ? (a)=>$21da20d2fc3ca230$var$_TD.decode($21da20d2fc3ca230$var$_toUint8Array(a)) : (a)=>$21da20d2fc3ca230$export$67e9defdeac3dd95($21da20d2fc3ca230$export$1406ac7a6dfd7b7a(a));
const $21da20d2fc3ca230$var$_unURI = (a)=>$21da20d2fc3ca230$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $21da20d2fc3ca230$export$c537b38001c583b7 = (src)=>$21da20d2fc3ca230$var$_decode($21da20d2fc3ca230$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $21da20d2fc3ca230$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $21da20d2fc3ca230$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $21da20d2fc3ca230$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $21da20d2fc3ca230$var$_noEnum(body));
    _add("fromBase64", function() {
        return $21da20d2fc3ca230$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $21da20d2fc3ca230$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $21da20d2fc3ca230$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $21da20d2fc3ca230$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $21da20d2fc3ca230$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $21da20d2fc3ca230$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $21da20d2fc3ca230$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $21da20d2fc3ca230$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $21da20d2fc3ca230$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $21da20d2fc3ca230$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $21da20d2fc3ca230$export$1abf1fe5ebfd5245 = ()=>{
    $21da20d2fc3ca230$export$4678ebf2295c49b();
    $21da20d2fc3ca230$export$a105d6a15258bd2();
};
const $21da20d2fc3ca230$export$f436b0c2107cbd35 = {
    version: $21da20d2fc3ca230$export$83d89fbfd8236492,
    VERSION: $21da20d2fc3ca230$export$a4ad2735b021c132,
    atob: $21da20d2fc3ca230$export$1406ac7a6dfd7b7a,
    atobPolyfill: $21da20d2fc3ca230$export$7f16d8e674ddec24,
    btoa: $21da20d2fc3ca230$export$a32219e24f8d1e2,
    btoaPolyfill: $21da20d2fc3ca230$export$ec0fb543302ee251,
    fromBase64: $21da20d2fc3ca230$export$c537b38001c583b7,
    toBase64: $21da20d2fc3ca230$export$37cc283d8fbd3462,
    encode: $21da20d2fc3ca230$export$37cc283d8fbd3462,
    encodeURI: $21da20d2fc3ca230$export$90c31d5baa78df44,
    encodeURL: $21da20d2fc3ca230$export$90c31d5baa78df44,
    utob: $21da20d2fc3ca230$export$10d4b9bd20a66b0,
    btou: $21da20d2fc3ca230$export$67e9defdeac3dd95,
    decode: $21da20d2fc3ca230$export$c537b38001c583b7,
    isValid: $21da20d2fc3ca230$export$1ea939691cdc45b8,
    fromUint8Array: $21da20d2fc3ca230$export$27bbb4e040978768,
    toUint8Array: $21da20d2fc3ca230$export$73470fd2221e6aef,
    extendString: $21da20d2fc3ca230$export$4678ebf2295c49b,
    extendUint8Array: $21da20d2fc3ca230$export$a105d6a15258bd2,
    extendBuiltins: $21da20d2fc3ca230$export$1abf1fe5ebfd5245
};









var $1b04cee8673a582a$require$read = $a1a91b25d7598376$export$aafa59e2e03f2942;
var $1b04cee8673a582a$require$utils = $a1a91b25d7598376$export$eab97d15b1788b8d;
// set_cptable(cptable);
const $1b04cee8673a582a$var$PDF = "application/pdf";
const $1b04cee8673a582a$var$XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const $1b04cee8673a582a$var$XLS = "application/vnd.ms-excel";
const $1b04cee8673a582a$var$CSV = "text/csv";
const $1b04cee8673a582a$var$JPEG = "image/jpeg";
const $1b04cee8673a582a$var$JPG = "image/jpg";
const $1b04cee8673a582a$var$PNG = "image/png";
function $1b04cee8673a582a$var$processCsvXlsxFile(arrayBufferObject) {
    const fileRead = $1b04cee8673a582a$require$read(arrayBufferObject, {
        raw: true,
        cellText: false,
        cellDates: true,
        codepage: 65001,
        dateNF: "dd/mm/yyyy"
    });
    if (fileRead && fileRead.Sheets && fileRead.Sheets[fileRead.SheetNames[0]] && Object.keys(fileRead.Sheets[fileRead.SheetNames[0]]).length > 0) return $1b04cee8673a582a$require$utils.sheet_to_json(fileRead.Sheets[fileRead.SheetNames[0]], {
        header: 1,
        raw: false
    });
    return null;
}
function $1b04cee8673a582a$var$getTypeForFileName(fileName) {
    if (fileName.match(/\.csv$/i)) return $1b04cee8673a582a$var$CSV;
    if (fileName.match(/\.xlsx$/i)) return $1b04cee8673a582a$var$XLSX;
    if (fileName.match(/\.xls$/i)) return $1b04cee8673a582a$var$XLS;
    if (fileName.match(/\.pdf$/i)) return $1b04cee8673a582a$var$PDF;
    if (fileName.match(/\.jpg$/i)) return $1b04cee8673a582a$var$JPG;
    if (fileName.match(/\.jpeg$/i)) return $1b04cee8673a582a$var$JPEG;
    if (fileName.match(/\.png$/i)) return $1b04cee8673a582a$var$PNG;
    return null;
}
function $1b04cee8673a582a$export$46216d9ebc0ee201({ fileData: fileData, fileName: fileName }) {
    // browser version
    if (typeof window !== "undefined" && typeof window.atob === "function") {
        // In a browser environment
        const binaryString = window.atob(fileData);
        const byteNumbers = new Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i += 1)byteNumbers[i] = binaryString.charCodeAt(i);
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([
            byteArray
        ], {
            type: $1b04cee8673a582a$var$getTypeForFileName(fileName)
        });
        const file = new File([
            fileBlob
        ], fileName, {
            type: $1b04cee8673a582a$var$getTypeForFileName(fileName)
        });
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        return dataTransfer.files;
    }
    throw new Error("Unable to decode base64 string");
}
function $1b04cee8673a582a$export$2e2bcd8739ae039({ account: account, handleClick: handleClick, fileReceived: fileReceived, setIngested: setIngested, setFileNames: setFileNames }) {
    var _fileReceived_fileData;
    const [fileList, setFileList] = (0, $7fPBF.useState)(undefined);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [emptyFiles, setEmptyFiles] = (0, $7fPBF.useState)([]);
    const [timestamp, setTimestamp] = (0, $7fPBF.useState)(undefined);
    const [delayInfo, setDelayInfo] = (0, $7fPBF.useState)(undefined);
    const debugLevel = 3;
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    console.log("rendering DialogSelectFile, fileName is", fileReceived.fileName, "fileData.length is", (_fileReceived_fileData = fileReceived.fileData) === null || _fileReceived_fileData === void 0 ? void 0 : _fileReceived_fileData.length);
    // handles PDF + image files
    async function processBinaryFile(arrayBufferObject) {
        var _tokens_idToken, _tokens;
        // FIXME
        if (window.mobileApp) window.mobileApp.postMessage(`processBinaryFile: processing object ${JSON.stringify(arrayBufferObject)}`);
        // Convert ArrayBuffer to base64
        if (window.mobileApp) window.mobileApp.postMessage("processBinaryFile: about to start btoa");
        let base64String;
        try {
            // base64String = btoa(String.fromCharCode(...new Uint8Array(arrayBufferObject))); // THIS WORKED FOR ANDROID AND THREW RANGE ERROR FOR iOS
            base64String = (0, $21da20d2fc3ca230$export$f436b0c2107cbd35).fromUint8Array(new Uint8Array(arrayBufferObject));
        } catch (error) {
            console.error("DialogSelectFile > processBinaryFile: btoa failed", error);
            if (window.mobileApp) window.mobileApp.postMessage(`processBinaryFile: btoa failed ${error}`);
            throw new Error("Unable to convert file to base64 string");
        }
        if (window.mobileApp) window.mobileApp.postMessage(`processBinaryFile: base64String ${base64String}`);
        const idToken = (_tokens = (await (0, $10933498be24bbfd$export$e2edee8830cb9593)()).tokens) === null || _tokens === void 0 ? void 0 : (_tokens_idToken = _tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.toString();
        if (window.mobileApp) window.mobileApp.postMessage(`processBinaryFile: idToken ${idToken}`);
        // Send the base64-encoded string
        const jobId = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "customer/processDocument", {
            body: base64String,
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (window.mobileApp) window.mobileApp.postMessage(`processBinaryFile: jobId ${jobId}`);
        // Function to wait for a specified time
        // eslint-disable-next-line no-promise-executor-return
        const wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
        // Check the status
        let response;
        do {
            await wait(5000); // Wait for 5 seconds
            response = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", `customer/processDocument/${jobId}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            // this returns a 202 status code if the job is still processing, but Amplify thinks it is not an error
            if (!(typeof response === "object") && response.match(/Document analysis not ready yet/)) {
                await wait(1000); // Wait for 1 second if status is > 200
                if ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().diff(timestamp, "second") > 10) setDelayInfo(true);
            }
        }while (!(typeof response === "object") && response.match(/Document analysis not ready yet/));
        // this function is designed to return an array of tables, so we need to let the caller know how many tables there are
        // Return the array provided by the backend when status code is 200
        return {
            numberOfTables: response.length,
            data: response
        };
    }
    // clear import files from state when entering this component
    (0, $7fPBF.useEffect)(()=>{
        setIngested([]);
    }, []);
    // handle file passed from mobile device via dashboard (postFile)
    (0, $7fPBF.useEffect)(()=>{
        // initialise loading process
        if (fileReceived) {
            console.log("DialogSelectFile: initialising fileReceived");
            setLoading(true);
            setTimestamp((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))());
            setFileList($1b04cee8673a582a$export$46216d9ebc0ee201(fileReceived)); // this will trigger the processFileList function below
        }
    }, [
        fileReceived
    ]);
    // process files
    // it is possible to move this to backend if it adds value
    (0, $7fPBF.useEffect)(()=>{
        async function processFileList() {
            if (fileList !== undefined) {
                if (debugLevel > 2) console.log("DialogSelectFile > processFileList started for fileList length: ", Array.from(fileList).length);
                try {
                    // accept multiple files and convert them to ArrayBuffer
                    if (Array.from(fileList || []).length > 0) {
                        const promises = Array.from(fileList).map((file)=>{
                            if (file.size < 5000000) return file.arrayBuffer();
                            // if you got past the if, it means the file is too big
                            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileTooLarge"));
                            return null;
                        });
                        const arrayBufferListPromises = await Promise.allSettled(promises);
                        // if any of the files got rejected, display error message
                        if (arrayBufferListPromises.some((item)=>item.status === "rejected")) {
                            console.error(arrayBufferListPromises.filter((item)=>item.status === "rejected"));
                            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadError"));
                            // eslint-disable-next-line max-len
                            if (window.mobileApp) window.mobileApp.postMessage(`fileUploadError: ArrayBufferListPromises rejected ${JSON.stringify(arrayBufferListPromises.filter((item)=>item.status === "rejected"))}`);
                            return;
                        }
                        const arrayBufferList = arrayBufferListPromises.filter((item)=>item.status !== "rejected").map((item)=>item.value);
                        if (arrayBufferList.length === 0) {
                            setLoading(false);
                            return;
                        }
                        // parse them with XLSX or run them through Textract
                        const promises2 = arrayBufferList.map((item, idx)=>{
                            const { type: type } = Array.from(fileList || [])[idx];
                            console.log("DialogSelectFile > processFileList: type", type);
                            if (window.mobileApp) window.mobileApp.postMessage(`DialogSelectFile > processFileList: type ${type}`); // FIXME
                            // if it's a CSV or XLSX file
                            if (item && item.byteLength > 0 && (type === $1b04cee8673a582a$var$XLSX || type === $1b04cee8673a582a$var$CSV)) return $1b04cee8673a582a$var$processCsvXlsxFile(item);
                            // if it's a PDF or image file
                            if (item && item.byteLength > 0 && (type === $1b04cee8673a582a$var$PDF || type === $1b04cee8673a582a$var$JPEG || type === $1b04cee8673a582a$var$JPG || type === $1b04cee8673a582a$var$PNG)) return processBinaryFile(item); // this may return more than one table, so it returns { numberOfTables, data } and needs to process before moving on
                            // if it's not any of the above, return null
                            return null;
                        });
                        const extractedFilesListPromises = await Promise.allSettled(promises2);
                        if (extractedFilesListPromises.some((item)=>item.status === "rejected")) {
                            console.error(extractedFilesListPromises.filter((item)=>item.status === "rejected"));
                            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadError"));
                            // eslint-disable-next-line max-len
                            if (window.mobileApp) window.mobileApp.postMessage(`fileUploadError: extractedFilesListPromises rejected ${JSON.stringify(extractedFilesListPromises.filter((item)=>item.status === "rejected"))}`);
                        }
                        const extractedFilesList = extractedFilesListPromises.filter((item)=>item.status !== "rejected").map((item)=>item.value);
                        if (extractedFilesList.length === 0) {
                            setLoading(false);
                            return;
                        }
                        // binary files return an array of tables, so in some cases there will be several tables for one file
                        const tableFileNames = [];
                        const extractedTablesList = [];
                        // handle multiple tables from processBinaryFiles
                        extractedFilesList.forEach((item, fileIdx)=>{
                            // handle binary files
                            if (item && item.numberOfTables) for(let tableIdx = 0; tableIdx < item.numberOfTables; tableIdx += 1){
                                tableFileNames.push(item.numberOfTables === 1 ? `${fileList[fileIdx].name}` : `${fileList[fileIdx].name} (${tableIdx}/${item.numberOfTables})`);
                                extractedTablesList.push(item.data[tableIdx]);
                            }
                            else {
                                // handle CSV/XLSX files
                                tableFileNames.push(fileList[fileIdx].name);
                                extractedTablesList.push(item);
                            }
                        });
                        // return results to parent's state for further processing
                        extractedTablesList.forEach((fileRead, index)=>{
                            if (fileRead) {
                                setFileNames((prev)=>[
                                        ...prev,
                                        tableFileNames[index]
                                    ]);
                                setIngested((prev)=>[
                                        ...prev,
                                        fileRead
                                    ]);
                            } else setEmptyFiles((prev)=>[
                                    ...prev,
                                    fileList[index].name
                                ]);
                        });
                        // if at least one file had data, go to column matcher
                        if (emptyFiles.length < fileList.length) handleClick("column");
                        else {
                            setLoading(false);
                            setDelayInfo(undefined);
                            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("allFilesWereEmpty"));
                        }
                    } else {
                        dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadFailed"));
                        if (window.mobileApp) window.mobileApp.postMessage("fileUploadFailed: FileArray is empty");
                        console.error("DialogSelectFile > processFileList: no files found in fileList");
                        setDelayInfo(undefined);
                        setLoading(false);
                    }
                } catch (error) {
                    dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadFailed"));
                    if (window.mobileApp) window.mobileApp.postMessage(`fileUploadFailed: ${error}`);
                    setDelayInfo(undefined);
                    setLoading(false);
                }
            }
        }
        processFileList();
    }, [
        fileList
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: "ml-1 flex flex-rows items-center gap-2 sm:gap-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: "Go back to table view.",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            text: t("cancelFileUpload.label"),
                            Icon: (0, $68ecf30d598e901c$export$2e2bcd8739ae039),
                            onClick: ()=>handleClick("table"),
                            size: "lg",
                            formatting: "mb-4"
                        })
                    }),
                    loading && delayInfo && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "rounded-md bg-brandBlue-50 px-3 py-2",
                        id: "info-message",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-brandBlue-400",
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "ml-3 flex-1 md:flex md:justify-between",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-sm text-brandBlue-600",
                                        children: t("loadingTakesLong")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "w-full md:w-2/3",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "w-full p-6 border-2 border-gray-300 border-dashed rounded-md h-48",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "w-full h-full flex justify-center items-center space-x-2",
                        children: !loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "space-y-2 flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                    className: "h-12 w-12 text-gray-400",
                                    stroke: "currentColor",
                                    fill: "none",
                                    viewBox: "0 0 48 48",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                        // eslint-disable-next-line max-len
                                        d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                                        strokeWidth: 2,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "flex text-sm text-gray-600",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                        htmlFor: "file-upload",
                                        className: "relative cursor-pointer rounded-md py-1.5 px-2.5 text-white bg-brandBlue-500 hover:bg-brandBlue-600",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "font-semibold text-sm md:text-base",
                                                children: t("uploadFiles.label")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                id: "file-upload",
                                                name: "file-upload",
                                                type: "file",
                                                accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/jpeg, image/jpg, application/pdf, image/png",
                                                multiple: true,
                                                className: "sr-only",
                                                onChange: (e)=>{
                                                    if (e.target.files) {
                                                        console.log("DialogSelectFile > onChange: e.target.files", e.target.files);
                                                        setLoading(true);
                                                        setTimestamp((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))());
                                                        setFileList(e.target.files);
                                                    }
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "pt-1 text-xs text-gray-500 pb-4",
                                    children: "XLSX / CSV / PDF / JPEG / PNG (max. 5MB)"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 animate-spin text-gray-400"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-gray-500",
                                    children: t("loading")
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
$1b04cee8673a582a$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    fileReceived: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        fileName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        // eslint-disable-next-line react/forbid-prop-types
        fileData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any
    }),
    setIngested: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setFileNames: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$1b04cee8673a582a$export$2e2bcd8739ae039.defaultProps = {
    fileReceived: null
};


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable max-len */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/no-array-index-key */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $9tqwB = parcelRequire("9tqwB");

var $7fPBF = parcelRequire("7fPBF");
function $c17f54be8a1e9ddb$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $c17f54be8a1e9ddb$export$71594e8a50f746f4 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $c17f54be8a1e9ddb$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
function $c17f54be8a1e9ddb$export$8ee0fc9ee280b4ee(node) {
    return "nodeType" in node;
}
function $c17f54be8a1e9ddb$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($c17f54be8a1e9ddb$export$5a096129d439f843(target)) return target;
    if (!$c17f54be8a1e9ddb$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $c17f54be8a1e9ddb$export$62858bae88b53fd0(node) {
    const { Document: Document } = $c17f54be8a1e9ddb$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $c17f54be8a1e9ddb$export$1b3bfaa9684536aa(node) {
    if ($c17f54be8a1e9ddb$export$5a096129d439f843(node)) return false;
    return node instanceof $c17f54be8a1e9ddb$export$38b2d434cce3ea22(node).HTMLElement;
}
function $c17f54be8a1e9ddb$export$17eda790a720ec57(node) {
    return node instanceof $c17f54be8a1e9ddb$export$38b2d434cce3ea22(node).SVGElement;
}
function $c17f54be8a1e9ddb$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($c17f54be8a1e9ddb$export$5a096129d439f843(target)) return target.document;
    if (!$c17f54be8a1e9ddb$export$8ee0fc9ee280b4ee(target)) return document;
    if ($c17f54be8a1e9ddb$export$62858bae88b53fd0(target)) return target;
    if ($c17f54be8a1e9ddb$export$1b3bfaa9684536aa(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $c17f54be8a1e9ddb$export$700979bc83e7db82 = $c17f54be8a1e9ddb$export$71594e8a50f746f4 ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $c17f54be8a1e9ddb$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $7fPBF.useRef)(handler);
    $c17f54be8a1e9ddb$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $7fPBF.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $c17f54be8a1e9ddb$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $7fPBF.useRef)(null);
    const set = (0, $7fPBF.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $7fPBF.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $c17f54be8a1e9ddb$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $7fPBF.useRef)(value);
    $c17f54be8a1e9ddb$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $c17f54be8a1e9ddb$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $7fPBF.useRef)();
    return (0, $7fPBF.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $c17f54be8a1e9ddb$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $c17f54be8a1e9ddb$export$90fc3a17d93f704c(onChange);
    const node = (0, $7fPBF.useRef)(null);
    const setNodeRef = (0, $7fPBF.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $c17f54be8a1e9ddb$export$5cae361ad82dce8b(value) {
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $c17f54be8a1e9ddb$var$ids = {};
function $c17f54be8a1e9ddb$export$c485849f2e393253(prefix, value) {
    return (0, $7fPBF.useMemo)(()=>{
        if (value) return value;
        const id = $c17f54be8a1e9ddb$var$ids[prefix] == null ? 0 : $c17f54be8a1e9ddb$var$ids[prefix] + 1;
        $c17f54be8a1e9ddb$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $c17f54be8a1e9ddb$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, (0, $9tqwB._)({}, object));
    };
}
const $c17f54be8a1e9ddb$export$e16d8520af44a096 = /*#__PURE__*/ $c17f54be8a1e9ddb$var$createAdjustmentFn(1);
const $c17f54be8a1e9ddb$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $c17f54be8a1e9ddb$var$createAdjustmentFn(-1);
function $c17f54be8a1e9ddb$export$d0e71af79cd586c6(event) {
    return "clientX" in event && "clientY" in event;
}
function $c17f54be8a1e9ddb$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $c17f54be8a1e9ddb$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $c17f54be8a1e9ddb$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $c17f54be8a1e9ddb$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $c17f54be8a1e9ddb$export$36195c8aa1517e04(event) {
    if ($c17f54be8a1e9ddb$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($c17f54be8a1e9ddb$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $c17f54be8a1e9ddb$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $c17f54be8a1e9ddb$export$c4ffa16951855e28.Translate.toString(transform),
                $c17f54be8a1e9ddb$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(" ");
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $c17f54be8a1e9ddb$var$SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function $c17f54be8a1e9ddb$export$44f71d798fd0a62b(element) {
    if (element.matches($c17f54be8a1e9ddb$var$SELECTOR)) return element;
    return element.querySelector($c17f54be8a1e9ddb$var$SELECTOR);
}



var $7fPBF = parcelRequire("7fPBF");
const $eceb84cdc2b532ec$var$hiddenStyles = {
    display: "none"
};
function $eceb84cdc2b532ec$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id,
        style: $eceb84cdc2b532ec$var$hiddenStyles
    }, value);
}
const $eceb84cdc2b532ec$var$visuallyHidden = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
};
function $eceb84cdc2b532ec$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id,
        style: $eceb84cdc2b532ec$var$visuallyHidden,
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": true
    }, announcement);
}
function $eceb84cdc2b532ec$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $7fPBF.useState)("");
    const announce = (0, $7fPBF.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $ecddad0aaeff3d51$var$DndMonitorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
function $ecddad0aaeff3d51$export$1182af90218a7b81(listener) {
    const registerListener = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$DndMonitorContext);
    (0, $7fPBF.useEffect)(()=>{
        if (!registerListener) throw new Error("useDndMonitor must be used within a children of <DndContext>");
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $ecddad0aaeff3d51$var$useDndMonitorProvider() {
    const [listeners] = (0, $7fPBF.useState)(()=>new Set());
    const registerListener = (0, $7fPBF.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $7fPBF.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $ecddad0aaeff3d51$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $ecddad0aaeff3d51$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $ecddad0aaeff3d51$var$Accessibility(_ref) {
    let { announcements: announcements = $ecddad0aaeff3d51$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $ecddad0aaeff3d51$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $eceb84cdc2b532ec$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $c17f54be8a1e9ddb$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setMounted(true);
    }, []);
    $ecddad0aaeff3d51$export$1182af90218a7b81((0, $7fPBF.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eceb84cdc2b532ec$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eceb84cdc2b532ec$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $fw0lo.createPortal)(markup, container) : markup;
}
var $ecddad0aaeff3d51$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($ecddad0aaeff3d51$var$Action || ($ecddad0aaeff3d51$var$Action = {}));
function $ecddad0aaeff3d51$var$noop() {}
function $ecddad0aaeff3d51$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $7fPBF.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $ecddad0aaeff3d51$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $ecddad0aaeff3d51$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $ecddad0aaeff3d51$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $ecddad0aaeff3d51$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $c17f54be8a1e9ddb$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return "0 0";
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $ecddad0aaeff3d51$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $ecddad0aaeff3d51$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $ecddad0aaeff3d51$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $ecddad0aaeff3d51$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $ecddad0aaeff3d51$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $ecddad0aaeff3d51$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $ecddad0aaeff3d51$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $ecddad0aaeff3d51$var$distanceBetween($ecddad0aaeff3d51$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $ecddad0aaeff3d51$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $ecddad0aaeff3d51$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $ecddad0aaeff3d51$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $ecddad0aaeff3d51$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $ecddad0aaeff3d51$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $ecddad0aaeff3d51$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $ecddad0aaeff3d51$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $ecddad0aaeff3d51$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $ecddad0aaeff3d51$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $ecddad0aaeff3d51$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $ecddad0aaeff3d51$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $ecddad0aaeff3d51$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
function $ecddad0aaeff3d51$var$adjustScale(transform, rect1, rect2) {
    return (0, $2qxEV._)((0, $9tqwB._)({}, transform), {
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    });
}
function $ecddad0aaeff3d51$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
}
function $ecddad0aaeff3d51$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), (0, $9tqwB._)({}, rect));
    };
}
const $ecddad0aaeff3d51$var$getAdjustedRect = /*#__PURE__*/ $ecddad0aaeff3d51$var$createRectAdjustmentFn(1);
function $ecddad0aaeff3d51$var$parseTransform(transform) {
    if (transform.startsWith("matrix3d(")) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith("matrix(")) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $ecddad0aaeff3d51$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $ecddad0aaeff3d51$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(" ") + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $ecddad0aaeff3d51$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $ecddad0aaeff3d51$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $ecddad0aaeff3d51$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { getComputedStyle: getComputedStyle } = (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(element);
        const { transform: transform, transformOrigin: transformOrigin } = getComputedStyle(element);
        if (transform) rect = $ecddad0aaeff3d51$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $ecddad0aaeff3d51$var$getTransformAgnosticClientRect(element) {
    return $ecddad0aaeff3d51$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $ecddad0aaeff3d51$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $ecddad0aaeff3d51$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === "fixed";
}
function $ecddad0aaeff3d51$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        "overflow",
        "overflowX",
        "overflowY"
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === "string" ? overflowRegex.test(value) : false;
    });
}
function $ecddad0aaeff3d51$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $c17f54be8a1e9ddb$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $c17f54be8a1e9ddb$export$1b3bfaa9684536aa)(node) || (0, $c17f54be8a1e9ddb$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const { getComputedStyle: getComputedStyle } = (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(node);
        const computedStyle = getComputedStyle(node);
        if (node !== element) {
            if ($ecddad0aaeff3d51$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($ecddad0aaeff3d51$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $ecddad0aaeff3d51$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $ecddad0aaeff3d51$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $ecddad0aaeff3d51$var$getScrollableElement(element) {
    if (!(0, $c17f54be8a1e9ddb$export$71594e8a50f746f4) || !element) return null;
    if ((0, $c17f54be8a1e9ddb$export$5a096129d439f843)(element)) return element;
    if (!(0, $c17f54be8a1e9ddb$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $c17f54be8a1e9ddb$export$62858bae88b53fd0)(element) || element === (0, $c17f54be8a1e9ddb$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $c17f54be8a1e9ddb$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $ecddad0aaeff3d51$var$getScrollXCoordinate(element) {
    if ((0, $c17f54be8a1e9ddb$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $ecddad0aaeff3d51$var$getScrollYCoordinate(element) {
    if ((0, $c17f54be8a1e9ddb$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $ecddad0aaeff3d51$var$getScrollCoordinates(element) {
    return {
        x: $ecddad0aaeff3d51$var$getScrollXCoordinate(element),
        y: $ecddad0aaeff3d51$var$getScrollYCoordinate(element)
    };
}
var $ecddad0aaeff3d51$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($ecddad0aaeff3d51$var$Direction || ($ecddad0aaeff3d51$var$Direction = {}));
function $ecddad0aaeff3d51$var$isDocumentScrollingElement(element) {
    if (!(0, $c17f54be8a1e9ddb$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $ecddad0aaeff3d51$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $ecddad0aaeff3d51$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $ecddad0aaeff3d51$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $ecddad0aaeff3d51$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $ecddad0aaeff3d51$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $ecddad0aaeff3d51$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $ecddad0aaeff3d51$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $ecddad0aaeff3d51$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $ecddad0aaeff3d51$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $ecddad0aaeff3d51$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $ecddad0aaeff3d51$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $ecddad0aaeff3d51$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $c17f54be8a1e9ddb$export$e16d8520af44a096)(acc, $ecddad0aaeff3d51$var$getScrollCoordinates(node));
    }, $ecddad0aaeff3d51$export$597cbd7bbd10deb4);
}
function $ecddad0aaeff3d51$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $ecddad0aaeff3d51$var$getScrollXCoordinate(node);
    }, 0);
}
function $ecddad0aaeff3d51$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $ecddad0aaeff3d51$var$getScrollYCoordinate(node);
    }, 0);
}
function $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $ecddad0aaeff3d51$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: "center",
        inline: "center"
    });
}
const $ecddad0aaeff3d51$var$properties = [
    [
        "x",
        [
            "left",
            "right"
        ],
        $ecddad0aaeff3d51$var$getScrollXOffset
    ],
    [
        "y",
        [
            "top",
            "bottom"
        ],
        $ecddad0aaeff3d51$var$getScrollYOffset
    ]
];
class $ecddad0aaeff3d51$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $ecddad0aaeff3d51$export$e4864aa91b5ed091(element);
        const scrollOffsets = $ecddad0aaeff3d51$var$getScrollOffsets(scrollableAncestors);
        this.rect = (0, $9tqwB._)({}, rect);
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $ecddad0aaeff3d51$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, "rect", {
            enumerable: false
        });
    }
}
class $ecddad0aaeff3d51$var$Listeners {
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
}
function $ecddad0aaeff3d51$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $c17f54be8a1e9ddb$export$b204af158042fbac)(target);
}
function $ecddad0aaeff3d51$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === "number") return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ("x" in measurement && "y" in measurement) return dx > measurement.x && dy > measurement.y;
    if ("x" in measurement) return dx > measurement.x;
    if ("y" in measurement) return dy > measurement.y;
    return false;
}
var $ecddad0aaeff3d51$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($ecddad0aaeff3d51$var$EventName || ($ecddad0aaeff3d51$var$EventName = {}));
function $ecddad0aaeff3d51$var$preventDefault(event) {
    event.preventDefault();
}
function $ecddad0aaeff3d51$var$stopPropagation(event) {
    event.stopPropagation();
}
var $ecddad0aaeff3d51$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
})($ecddad0aaeff3d51$export$a8b1916dba3ae88b || ($ecddad0aaeff3d51$export$a8b1916dba3ae88b = {}));
const $ecddad0aaeff3d51$var$defaultKeyboardCodes = {
    start: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Space,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Space,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Enter
    ]
};
const $ecddad0aaeff3d51$var$defaultKeyboardCoordinateGetter = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right:
            return (0, $2qxEV._)((0, $9tqwB._)({}, currentCoordinates), {
                x: currentCoordinates.x + 25
            });
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left:
            return (0, $2qxEV._)((0, $9tqwB._)({}, currentCoordinates), {
                x: currentCoordinates.x - 25
            });
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down:
            return (0, $2qxEV._)((0, $9tqwB._)({}, currentCoordinates), {
                y: currentCoordinates.y + 25
            });
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up:
            return (0, $2qxEV._)((0, $9tqwB._)({}, currentCoordinates), {
                y: currentCoordinates.y - 25
            });
    }
    return undefined;
};
class $ecddad0aaeff3d51$export$44d67f2a438aeba9 {
    attach() {
        this.handleStart();
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($ecddad0aaeff3d51$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(node);
        onStart($ecddad0aaeff3d51$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $c17f54be8a1e9ddb$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $ecddad0aaeff3d51$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $ecddad0aaeff3d51$var$defaultKeyboardCoordinateGetter, scrollBehavior: scrollBehavior = "smooth" } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $c17f54be8a1e9ddb$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $ecddad0aaeff3d51$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $ecddad0aaeff3d51$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right && !isRight || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down && !isBottom || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $c17f54be8a1e9ddb$export$e16d8520af44a096)((0, $c17f54be8a1e9ddb$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $ecddad0aaeff3d51$var$Listeners((0, $c17f54be8a1e9ddb$export$b204af158042fbac)(target));
        this.windowListeners = new $ecddad0aaeff3d51$var$Listeners((0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
}
$ecddad0aaeff3d51$export$44d67f2a438aeba9.activators = [
    {
        eventName: "onKeyDown",
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $ecddad0aaeff3d51$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $ecddad0aaeff3d51$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && "distance" in constraint);
}
function $ecddad0aaeff3d51$var$isDelayConstraint(constraint) {
    return Boolean(constraint && "delay" in constraint);
}
class $ecddad0aaeff3d51$var$AbstractPointerSensor {
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.DragStart, $ecddad0aaeff3d51$var$preventDefault);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.ContextMenu, $ecddad0aaeff3d51$var$preventDefault);
        this.documentListeners.add($ecddad0aaeff3d51$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if ($ecddad0aaeff3d51$var$isDistanceConstraint(activationConstraint)) return;
            if ($ecddad0aaeff3d51$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($ecddad0aaeff3d51$var$EventName.Click, $ecddad0aaeff3d51$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($ecddad0aaeff3d51$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $c17f54be8a1e9ddb$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        const delta = (0, $c17f54be8a1e9ddb$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates);
        if (!activated && activationConstraint) {
            // Constraint validation
            if ($ecddad0aaeff3d51$var$isDelayConstraint(activationConstraint)) {
                if ($ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                return;
            }
            if ($ecddad0aaeff3d51$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
                return;
            }
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onEnd: onEnd } = this.props;
        this.detach();
        onEnd();
    }
    handleCancel() {
        const { onCancel: onCancel } = this.props;
        this.detach();
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $ecddad0aaeff3d51$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $c17f54be8a1e9ddb$export$b204af158042fbac)(target);
        this.documentListeners = new $ecddad0aaeff3d51$var$Listeners(this.document);
        this.listeners = new $ecddad0aaeff3d51$var$Listeners(listenerTarget);
        this.windowListeners = new $ecddad0aaeff3d51$var$Listeners((0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $c17f54be8a1e9ddb$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
}
const $ecddad0aaeff3d51$var$events = {
    move: {
        name: "pointermove"
    },
    end: {
        name: "pointerup"
    }
};
class $ecddad0aaeff3d51$export$b26af955418d6638 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $c17f54be8a1e9ddb$export$b204af158042fbac)(event.target);
        super(props, $ecddad0aaeff3d51$var$events, listenerTarget);
    }
}
$ecddad0aaeff3d51$export$b26af955418d6638.activators = [
    {
        eventName: "onPointerDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $ecddad0aaeff3d51$var$events$1 = {
    move: {
        name: "mousemove"
    },
    end: {
        name: "mouseup"
    }
};
var $ecddad0aaeff3d51$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($ecddad0aaeff3d51$var$MouseButton || ($ecddad0aaeff3d51$var$MouseButton = {}));
class $ecddad0aaeff3d51$export$b28554b50bf7f273 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        super(props, $ecddad0aaeff3d51$var$events$1, (0, $c17f54be8a1e9ddb$export$b204af158042fbac)(props.event.target));
    }
}
$ecddad0aaeff3d51$export$b28554b50bf7f273.activators = [
    {
        eventName: "onMouseDown",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $ecddad0aaeff3d51$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $ecddad0aaeff3d51$var$events$2 = {
    move: {
        name: "touchmove"
    },
    end: {
        name: "touchend"
    }
};
class $ecddad0aaeff3d51$export$19b41baf2e1bcdc0 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($ecddad0aaeff3d51$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($ecddad0aaeff3d51$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
    constructor(props){
        super(props, $ecddad0aaeff3d51$var$events$2);
    }
}
$ecddad0aaeff3d51$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: "onTouchStart",
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $ecddad0aaeff3d51$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($ecddad0aaeff3d51$export$eefe60e26f04c318 || ($ecddad0aaeff3d51$export$eefe60e26f04c318 = {}));
var $ecddad0aaeff3d51$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($ecddad0aaeff3d51$export$f93aa492a37e1b0e || ($ecddad0aaeff3d51$export$f93aa492a37e1b0e = {}));
function $ecddad0aaeff3d51$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $ecddad0aaeff3d51$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $ecddad0aaeff3d51$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $ecddad0aaeff3d51$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $c17f54be8a1e9ddb$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $7fPBF.useMemo)(()=>{
        switch(activator){
            case $ecddad0aaeff3d51$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $ecddad0aaeff3d51$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $7fPBF.useRef)(null);
    const autoScroll = (0, $7fPBF.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $7fPBF.useMemo)(()=>order === $ecddad0aaeff3d51$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $ecddad0aaeff3d51$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                "x",
                "y"
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $ecddad0aaeff3d51$var$defaultScrollIntent = {
    x: {
        [$ecddad0aaeff3d51$var$Direction.Backward]: false,
        [$ecddad0aaeff3d51$var$Direction.Forward]: false
    },
    y: {
        [$ecddad0aaeff3d51$var$Direction.Backward]: false,
        [$ecddad0aaeff3d51$var$Direction.Forward]: false
    }
};
function $ecddad0aaeff3d51$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $c17f54be8a1e9ddb$export$5cae361ad82dce8b)(delta);
    return (0, $c17f54be8a1e9ddb$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $ecddad0aaeff3d51$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$ecddad0aaeff3d51$var$Direction.Backward]: previousIntent.x[$ecddad0aaeff3d51$var$Direction.Backward] || direction.x === -1,
                [$ecddad0aaeff3d51$var$Direction.Forward]: previousIntent.x[$ecddad0aaeff3d51$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$ecddad0aaeff3d51$var$Direction.Backward]: previousIntent.y[$ecddad0aaeff3d51$var$Direction.Backward] || direction.y === -1,
                [$ecddad0aaeff3d51$var$Direction.Forward]: previousIntent.y[$ecddad0aaeff3d51$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $ecddad0aaeff3d51$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id !== null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $c17f54be8a1e9ddb$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id === null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $ecddad0aaeff3d51$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $7fPBF.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $ecddad0aaeff3d51$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($ecddad0aaeff3d51$export$571c10ffffe014ab || ($ecddad0aaeff3d51$export$571c10ffffe014ab = {}));
var $ecddad0aaeff3d51$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($ecddad0aaeff3d51$export$8e062c3160beefd5 || ($ecddad0aaeff3d51$export$8e062c3160beefd5 = {}));
const $ecddad0aaeff3d51$var$defaultValue = /*#__PURE__*/ new Map();
function $ecddad0aaeff3d51$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $7fPBF.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $7fPBF.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $c17f54be8a1e9ddb$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $7fPBF.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $7fPBF.useRef)(null);
    const droppableRects = (0, $c17f54be8a1e9ddb$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $ecddad0aaeff3d51$var$defaultValue;
        if (!previousValue || previousValue === $ecddad0aaeff3d51$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $ecddad0aaeff3d51$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $7fPBF.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled || typeof frequency !== "number" || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $ecddad0aaeff3d51$export$571c10ffffe014ab.Always:
                return false;
            case $ecddad0aaeff3d51$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $ecddad0aaeff3d51$var$useInitialValue(value, computeFn) {
    return (0, $c17f54be8a1e9ddb$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === "function" ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $ecddad0aaeff3d51$var$useInitialRect(node, measure) {
    return $ecddad0aaeff3d51$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $ecddad0aaeff3d51$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $c17f54be8a1e9ddb$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $7fPBF.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.MutationObserver === "undefined") return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $ecddad0aaeff3d51$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $c17f54be8a1e9ddb$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $7fPBF.useMemo)(()=>{
        if (disabled || typeof window === "undefined" || typeof window.ResizeObserver === "undefined") return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $ecddad0aaeff3d51$var$defaultMeasure(element) {
    return new $ecddad0aaeff3d51$var$Rect($ecddad0aaeff3d51$export$b6aa1f30c53d7454(element), element);
}
function $ecddad0aaeff3d51$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$var$defaultMeasure;
    const [rect, measureRect] = (0, $7fPBF.useReducer)(reducer, null);
    const mutationObserver = $ecddad0aaeff3d51$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === "childList" && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: measureRect
    });
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
    function reducer(currentRect) {
        if (!element) return null;
        if (element.isConnected === false) {
            var _ref;
            // Fall back to last rect we measured if the element is
            // no longer connected to the DOM.
            return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
        }
        const newRect = measure(element);
        if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
        return newRect;
    }
}
function $ecddad0aaeff3d51$var$useRectDelta(rect) {
    const initialRect = $ecddad0aaeff3d51$var$useInitialValue(rect);
    return $ecddad0aaeff3d51$var$getRectDelta(rect, initialRect);
}
const $ecddad0aaeff3d51$var$defaultValue$1 = [];
function $ecddad0aaeff3d51$var$useScrollableAncestors(node) {
    const previousNode = (0, $7fPBF.useRef)(node);
    const ancestors = (0, $c17f54be8a1e9ddb$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $ecddad0aaeff3d51$var$defaultValue$1;
        if (previousValue && previousValue !== $ecddad0aaeff3d51$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $ecddad0aaeff3d51$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $7fPBF.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $ecddad0aaeff3d51$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $7fPBF.useState)(null);
    const prevElements = (0, $7fPBF.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $7fPBF.useCallback)((event)=>{
        const scrollingElement = $ecddad0aaeff3d51$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $ecddad0aaeff3d51$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $ecddad0aaeff3d51$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener("scroll", handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $ecddad0aaeff3d51$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $ecddad0aaeff3d51$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener("scroll", handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $7fPBF.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $c17f54be8a1e9ddb$export$e16d8520af44a096)(acc, coordinates), $ecddad0aaeff3d51$export$597cbd7bbd10deb4) : $ecddad0aaeff3d51$var$getScrollOffsets(elements);
        return $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $7fPBF.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $c17f54be8a1e9ddb$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
}
function $ecddad0aaeff3d51$var$useSensorSetup(sensors) {
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $c17f54be8a1e9ddb$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $ecddad0aaeff3d51$var$useSyntheticListeners(listeners, id) {
    return (0, $7fPBF.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $ecddad0aaeff3d51$var$useWindowRect(element) {
    return (0, $7fPBF.useMemo)(()=>element ? $ecddad0aaeff3d51$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $ecddad0aaeff3d51$var$defaultValue$2 = [];
function $ecddad0aaeff3d51$var$useRects(elements, measure) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $ecddad0aaeff3d51$var$useWindowRect(firstElement ? (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, measureRects] = (0, $7fPBF.useReducer)(reducer, $ecddad0aaeff3d51$var$defaultValue$2);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: measureRects
    });
    if (elements.length > 0 && rects === $ecddad0aaeff3d51$var$defaultValue$2) measureRects();
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        if (elements.length) elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
        else {
            resizeObserver == null || resizeObserver.disconnect();
            measureRects();
        }
    }, [
        elements
    ]);
    return rects;
    function reducer() {
        if (!elements.length) return $ecddad0aaeff3d51$var$defaultValue$2;
        return elements.map((element)=>$ecddad0aaeff3d51$var$isDocumentScrollingElement(element) ? windowRect : new $ecddad0aaeff3d51$var$Rect(measure(element), element));
    }
}
function $ecddad0aaeff3d51$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $c17f54be8a1e9ddb$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $ecddad0aaeff3d51$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $7fPBF.useState)(null);
    const handleResize = (0, $7fPBF.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $c17f54be8a1e9ddb$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? (0, $2qxEV._)((0, $9tqwB._)({}, rect), {
                    width: newRect.width,
                    height: newRect.height
                }) : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $7fPBF.useCallback)((element)=>{
        const node = $ecddad0aaeff3d51$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $c17f54be8a1e9ddb$export$bc23c270f170c912)(handleNodeChange);
    return (0, $7fPBF.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $ecddad0aaeff3d51$var$defaultSensors = [
    {
        sensor: $ecddad0aaeff3d51$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $ecddad0aaeff3d51$export$44d67f2a438aeba9,
        options: {}
    }
];
const $ecddad0aaeff3d51$var$defaultData = {
    current: {}
};
const $ecddad0aaeff3d51$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $ecddad0aaeff3d51$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $ecddad0aaeff3d51$var$getTransformAgnosticClientRect,
        strategy: $ecddad0aaeff3d51$export$571c10ffffe014ab.WhileDragging,
        frequency: $ecddad0aaeff3d51$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $ecddad0aaeff3d51$export$b6aa1f30c53d7454
    }
};
class $ecddad0aaeff3d51$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $ecddad0aaeff3d51$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $ecddad0aaeff3d51$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $ecddad0aaeff3d51$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $ecddad0aaeff3d51$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $ecddad0aaeff3d51$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $ecddad0aaeff3d51$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ""
    },
    dispatch: $ecddad0aaeff3d51$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $ecddad0aaeff3d51$var$noop
};
const $ecddad0aaeff3d51$var$InternalContext = /*#__PURE__*/ (0, $7fPBF.createContext)($ecddad0aaeff3d51$var$defaultInternalContext);
const $ecddad0aaeff3d51$var$PublicContext = /*#__PURE__*/ (0, $7fPBF.createContext)($ecddad0aaeff3d51$var$defaultPublicContext);
function $ecddad0aaeff3d51$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $ecddad0aaeff3d51$var$DroppableContainersMap()
        }
    };
}
function $ecddad0aaeff3d51$var$reducer(state, action) {
    switch(action.type){
        case $ecddad0aaeff3d51$var$Action.DragStart:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                draggable: (0, $2qxEV._)((0, $9tqwB._)({}, state.draggable), {
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                })
            });
        case $ecddad0aaeff3d51$var$Action.DragMove:
            if (!state.draggable.active) return state;
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                draggable: (0, $2qxEV._)((0, $9tqwB._)({}, state.draggable), {
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                })
            });
        case $ecddad0aaeff3d51$var$Action.DragEnd:
        case $ecddad0aaeff3d51$var$Action.DragCancel:
            return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                draggable: (0, $2qxEV._)((0, $9tqwB._)({}, state.draggable), {
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                })
            });
        case $ecddad0aaeff3d51$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                    droppable: (0, $2qxEV._)((0, $9tqwB._)({}, state.droppable), {
                        containers: containers
                    })
                });
            }
        case $ecddad0aaeff3d51$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, (0, $2qxEV._)((0, $9tqwB._)({}, element), {
                    disabled: disabled
                }));
                return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                    droppable: (0, $2qxEV._)((0, $9tqwB._)({}, state.droppable), {
                        containers: containers
                    })
                });
            }
        case $ecddad0aaeff3d51$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return (0, $2qxEV._)((0, $9tqwB._)({}, state), {
                    droppable: (0, $2qxEV._)((0, $9tqwB._)({}, state.droppable), {
                        containers: containers
                    })
                });
            }
        default:
            return state;
    }
}
function $ecddad0aaeff3d51$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const previousActivatorEvent = (0, $c17f54be8a1e9ddb$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $c17f54be8a1e9ddb$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $7fPBF.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $c17f54be8a1e9ddb$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $c17f54be8a1e9ddb$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform } = _ref, args = (0, $bLhVg._)(_ref, [
        "transform"
    ]);
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier((0, $9tqwB._)({
            transform: accumulator
        }, args));
    }, transform) : transform;
}
function $ecddad0aaeff3d51$var$useMeasuringConfiguration(config) {
    return (0, $7fPBF.useMemo)(()=>({
            draggable: (0, $9tqwB._)({}, $ecddad0aaeff3d51$var$defaultMeasuringConfiguration.draggable, config == null ? void 0 : config.draggable),
            droppable: (0, $9tqwB._)({}, $ecddad0aaeff3d51$var$defaultMeasuringConfiguration.droppable, config == null ? void 0 : config.droppable),
            dragOverlay: (0, $9tqwB._)({}, $ecddad0aaeff3d51$var$defaultMeasuringConfiguration.dragOverlay, config == null ? void 0 : config.dragOverlay)
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $ecddad0aaeff3d51$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $7fPBF.useRef)(false);
    const { x: x, y: y } = typeof config === "boolean" ? {
        x: config,
        y: config
    } : config;
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $ecddad0aaeff3d51$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $ecddad0aaeff3d51$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $ecddad0aaeff3d51$var$ActiveDraggableContext = /*#__PURE__*/ (0, $7fPBF.createContext)((0, $2qxEV._)((0, $9tqwB._)({}, $ecddad0aaeff3d51$export$597cbd7bbd10deb4), {
    scaleX: 1,
    scaleY: 1
}));
var $ecddad0aaeff3d51$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($ecddad0aaeff3d51$var$Status || ($ecddad0aaeff3d51$var$Status = {}));
const $ecddad0aaeff3d51$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $7fPBF.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $ecddad0aaeff3d51$var$defaultSensors, collisionDetection: collisionDetection = $ecddad0aaeff3d51$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers } = _ref, props = (0, $bLhVg._)(_ref, [
        "id",
        "accessibility",
        "autoScroll",
        "children",
        "sensors",
        "collisionDetection",
        "measuring",
        "modifiers"
    ]);
    const store = (0, $7fPBF.useReducer)($ecddad0aaeff3d51$var$reducer, undefined, $ecddad0aaeff3d51$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $ecddad0aaeff3d51$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $7fPBF.useState)($ecddad0aaeff3d51$var$Status.Uninitialized);
    const isInitialized = status === $ecddad0aaeff3d51$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $7fPBF.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $7fPBF.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $ecddad0aaeff3d51$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $7fPBF.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $7fPBF.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $7fPBF.useState)(null);
    const latestProps = (0, $c17f54be8a1e9ddb$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $c17f54be8a1e9ddb$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $7fPBF.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $ecddad0aaeff3d51$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $ecddad0aaeff3d51$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $ecddad0aaeff3d51$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $7fPBF.useMemo)(()=>activatorEvent ? (0, $c17f54be8a1e9ddb$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $ecddad0aaeff3d51$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $ecddad0aaeff3d51$var$useLayoutShiftScrollCompensation({
        activeNode: activeId ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $ecddad0aaeff3d51$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $ecddad0aaeff3d51$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $7fPBF.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $ecddad0aaeff3d51$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $ecddad0aaeff3d51$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $ecddad0aaeff3d51$var$useWindowRect(draggingNode ? (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $ecddad0aaeff3d51$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $ecddad0aaeff3d51$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $c17f54be8a1e9ddb$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $ecddad0aaeff3d51$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $c17f54be8a1e9ddb$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $ecddad0aaeff3d51$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $ecddad0aaeff3d51$export$ef1beab6d7287295(collisions, "id");
    const [over, setOver] = (0, $7fPBF.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $c17f54be8a1e9ddb$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $ecddad0aaeff3d51$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const instantiateSensor = (0, $7fPBF.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $fw0lo.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($ecddad0aaeff3d51$var$Status.Initializing);
                    dispatch({
                        type: $ecddad0aaeff3d51$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: "onDragStart",
                        event: event
                    });
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $ecddad0aaeff3d51$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($ecddad0aaeff3d51$var$Action.DragEnd),
            onCancel: createHandler($ecddad0aaeff3d51$var$Action.DragCancel)
        });
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            setActiveSensor(sensorInstance);
            setActivatorEvent(event.nativeEvent);
        });
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $ecddad0aaeff3d51$var$Action.DragEnd && typeof cancelDrop === "function") {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $ecddad0aaeff3d51$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $fw0lo.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($ecddad0aaeff3d51$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    const eventName = type === $ecddad0aaeff3d51$var$Action.DragEnd ? "onDragEnd" : "onDragCancel";
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $7fPBF.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $ecddad0aaeff3d51$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $ecddad0aaeff3d51$var$useSensorSetup(sensors);
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $ecddad0aaeff3d51$var$Status.Initializing) setStatus($ecddad0aaeff3d51$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: "onDragMove",
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: "onDragOver",
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $ecddad0aaeff3d51$var$useAutoScroller((0, $2qxEV._)((0, $9tqwB._)({}, autoScrollOptions), {
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    }));
    const publicContext = (0, $7fPBF.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $7fPBF.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$Accessibility, (0, $2qxEV._)((0, $9tqwB._)({}, accessibility), {
        hiddenTextDescribedById: draggableDescribedById
    })));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === "object" ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === "object") return (0, $2qxEV._)((0, $9tqwB._)({}, autoScroll), {
            enabled: enabled
        });
        return {
            enabled: enabled
        };
    }
});
const $ecddad0aaeff3d51$var$NullContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $ecddad0aaeff3d51$var$defaultRole = "button";
const $ecddad0aaeff3d51$var$ID_PREFIX = "Droppable";
function $ecddad0aaeff3d51$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $c17f54be8a1e9ddb$export$c485849f2e393253)($ecddad0aaeff3d51$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const { role: role = $ecddad0aaeff3d51$var$defaultRole, roleDescription: roleDescription = "draggable", tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $7fPBF.useContext)(isDragging ? $ecddad0aaeff3d51$var$ActiveDraggableContext : $ecddad0aaeff3d51$var$NullContext);
    const [node, setNodeRef] = (0, $c17f54be8a1e9ddb$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $c17f54be8a1e9ddb$export$bc23c270f170c912)();
    const listeners = $ecddad0aaeff3d51$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $c17f54be8a1e9ddb$export$86c4283a11f23f95)(data);
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $7fPBF.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            "aria-disabled": disabled,
            "aria-pressed": isDragging && role === $ecddad0aaeff3d51$var$defaultRole ? true : undefined,
            "aria-roledescription": roleDescription,
            "aria-describedby": ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $ecddad0aaeff3d51$export$4930f6bf413be70e() {
    return (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$PublicContext);
}
const $ecddad0aaeff3d51$var$ID_PREFIX$1 = "Droppable";
const $ecddad0aaeff3d51$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $ecddad0aaeff3d51$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $c17f54be8a1e9ddb$export$c485849f2e393253)($ecddad0aaeff3d51$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const previous = (0, $7fPBF.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $7fPBF.useRef)(false);
    const rect = (0, $7fPBF.useRef)(null);
    const callbackId = (0, $7fPBF.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = (0, $9tqwB._)({}, $ecddad0aaeff3d51$var$defaultResizeObserverConfig, resizeObserverConfig);
    const ids = (0, $c17f54be8a1e9ddb$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $7fPBF.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $7fPBF.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $c17f54be8a1e9ddb$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $c17f54be8a1e9ddb$export$86c4283a11f23f95)(data);
    (0, $7fPBF.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        dispatch({
            type: $ecddad0aaeff3d51$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $ecddad0aaeff3d51$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $ecddad0aaeff3d51$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $ecddad0aaeff3d51$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $7fPBF.useState)(null);
    const [element, setElement] = (0, $7fPBF.useState)(null);
    const previousChildren = (0, $c17f54be8a1e9ddb$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $c17f54be8a1e9ddb$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children, clonedChildren ? (0, $7fPBF.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $ecddad0aaeff3d51$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $ecddad0aaeff3d51$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$InternalContext.Provider, {
        value: $ecddad0aaeff3d51$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$ActiveDraggableContext.Provider, {
        value: $ecddad0aaeff3d51$var$defaultTransform
    }, children));
}
const $ecddad0aaeff3d51$var$baseStyles = {
    position: "fixed",
    touchAction: "none"
};
const $ecddad0aaeff3d51$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $c17f54be8a1e9ddb$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? "transform 250ms ease" : undefined;
};
const $ecddad0aaeff3d51$var$PositionedOverlay = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $ecddad0aaeff3d51$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : (0, $2qxEV._)((0, $9tqwB._)({}, transform), {
        scaleX: 1,
        scaleY: 1
    });
    const styles = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, $ecddad0aaeff3d51$var$baseStyles), {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $c17f54be8a1e9ddb$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $ecddad0aaeff3d51$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === "function" ? transition(activatorEvent) : transition
    }), style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $ecddad0aaeff3d51$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $ecddad0aaeff3d51$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $c17f54be8a1e9ddb$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $c17f54be8a1e9ddb$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $ecddad0aaeff3d51$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: "ease",
    keyframes: $ecddad0aaeff3d51$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $ecddad0aaeff3d51$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: "0"
            }
        }
    })
};
function $ecddad0aaeff3d51$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $c17f54be8a1e9ddb$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $ecddad0aaeff3d51$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $c17f54be8a1e9ddb$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $ecddad0aaeff3d51$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === "function" ? config : $ecddad0aaeff3d51$var$createDefaultDropAnimation(config);
        $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $ecddad0aaeff3d51$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = (0, $9tqwB._)({}, $ecddad0aaeff3d51$export$10f7ab1c653bb60e, options);
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform } = _ref4, rest = (0, $bLhVg._)(_ref4, [
            "active",
            "dragOverlay",
            "transform"
        ]);
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = (0, $9tqwB._)({
            x: transform.x - delta.x,
            y: transform.y - delta.y
        }, scale);
        const animationKeyframes = keyframes((0, $2qxEV._)((0, $9tqwB._)({}, rest), {
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        }));
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects((0, $9tqwB._)({
            active: active,
            dragOverlay: dragOverlay
        }, rest));
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: "forwards"
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $ecddad0aaeff3d51$var$key = 0;
function $ecddad0aaeff3d51$var$useKey(id) {
    return (0, $7fPBF.useMemo)(()=>{
        if (id == null) return;
        $ecddad0aaeff3d51$var$key++;
        return $ecddad0aaeff3d51$var$key;
    }, [
        id
    ]);
}
const $ecddad0aaeff3d51$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = "div", className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $ecddad0aaeff3d51$export$4930f6bf413be70e();
    const transform = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$ActiveDraggableContext);
    const key = $ecddad0aaeff3d51$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $ecddad0aaeff3d51$var$useInitialValue(activeNodeRect);
    const dropAnimation = $ecddad0aaeff3d51$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: (0, $9tqwB._)({
            zIndex: zIndex
        }, style),
        transform: modifiedTransform
    }, children) : null));
});



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $c4382dbe971fd630$var$DocumentArrowDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    }));
}
const $c4382dbe971fd630$var$ForwardRef = $7fPBF.forwardRef($c4382dbe971fd630$var$DocumentArrowDownIcon);
var $c4382dbe971fd630$export$2e2bcd8739ae039 = $c4382dbe971fd630$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $302127f8ab9e3c0b$var$ForwardIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061A1.125 1.125 0 0 1 3 16.811V8.69ZM12.75 8.689c0-.864.933-1.406 1.683-.977l7.108 4.061a1.125 1.125 0 0 1 0 1.954l-7.108 4.061a1.125 1.125 0 0 1-1.683-.977V8.69Z"
    }));
}
const $302127f8ab9e3c0b$var$ForwardRef = $7fPBF.forwardRef($302127f8ab9e3c0b$var$ForwardIcon);
var $302127f8ab9e3c0b$export$2e2bcd8739ae039 = $302127f8ab9e3c0b$var$ForwardRef;







var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $a4653f19041d4d80$var$QuestionMarkCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $a4653f19041d4d80$var$ForwardRef = $7fPBF.forwardRef($a4653f19041d4d80$var$QuestionMarkCircleIcon);
var $a4653f19041d4d80$export$2e2bcd8739ae039 = $a4653f19041d4d80$var$ForwardRef;



/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $ea08b9bea77a1bd1$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $ea08b9bea77a1bd1$export$2e2bcd8739ae039({ validationErrorArray: validationErrorArray, setScrollToRow: setScrollToRow, handleOpenPreviewer: handleOpenPreviewer }) {
    // expects the inner array from the validation error object
    // returns [ { message: 'error message', rows: [1, 2, 3] }, { message: 'error message', rows: [1, 2, 3] } ]
    function prepareMessages(arr) {
        const groupedErrorMessages = arr.reduce((prev, curr)=>{
            const { path: path } = curr;
            let { message: message } = curr;
            const row = path.split(".")[0].substring(1, path.split(".")[0].length - 1);
            // some error messages include the row number first in the message ([2].otherParty ...), so we need to remove it
            message = /\[\d+\]\./.test(message) ? message.slice(message.indexOf(".") + 1) : message;
            if (Object.keys(prev).includes(message)) prev[message].push(Number(row) + 1);
            else return (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                [message]: [
                    Number(row) + 1
                ]
            });
            return prev;
        }, {});
        return Object.keys(groupedErrorMessages).map((key)=>({
                message: key,
                rows: groupedErrorMessages[key]
            }));
    }
    const [messages, setMessages] = (0, $7fPBF.useState)([]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    (0, $7fPBF.useEffect)(()=>{
        setMessages(prepareMessages(validationErrorArray));
    }, [
        validationErrorArray
    ]);
    // when user clicks an error, they should be taken to Previewer which should preselect the row
    function handleClickError(scrollToRow) {
        setScrollToRow(scrollToRow);
        // save mappings and go to  Grid
        handleOpenPreviewer();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d), {
        className: "relative",
        id: "error-popover",
        children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d).Button, {
                        className: $ea08b9bea77a1bd1$var$classNames(open ? "text-brandRed-800" : "text-brandRed-500", `group px-3 py-2 inline-flex items-center rounded-md
             bg-brandRed-50 text-sm font-medium hover:text-brandRed-800 focus:outline-none focus:ring-2 focus:ring-brandBlue-500 focus:ring-offset-2`),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ac26489e86e9865$export$2e2bcd8739ae039), {
                                className: "text-brandRed-400 group-hover:text-brandRed-500 mr-2 h-5 w-5",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "Errors"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $718d5639811dbbc7$export$2e2bcd8739ae039), {
                                className: $ea08b9bea77a1bd1$var$classNames(open ? "text-brandRed-600" : "text-brandRed-400", "ml-2 h-5 w-5 group-hover:text-brandRed-500"),
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                        as: (0, $7fPBF.Fragment),
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-1",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5bf2d36640122d06$export$5b6b19405a83ff9d).Panel, {
                            className: "absolute left-1/2 z-10 mt-3 w-screen max-w-md -translate-x-1/2 transform px-2 sm:px-0",
                            id: "error-popover-content",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8",
                                    children: messages.map((item, idx)=>{
                                        const scrollToRow = Math.min(...item.rows);
                                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            onClick: (e)=>handleClickError(scrollToRow),
                                            className: "-m-3 block rounded-md p-3 transition duration-150 ease-in-out hover:bg-gray-50 text-left",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-base font-medium text-gray-900",
                                                    id: `error-popover-message-${idx}`,
                                                    children: item.message
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-1 text-sm text-gray-500 prose",
                                                    id: `error-popover-rows-${idx}`,
                                                    children: `${t("occursInRows")}: ${item.rows.map((r)=>r + 1).join(", ")}`
                                                })
                                            ]
                                        }, item.message);
                                    })
                                })
                            })
                        })
                    })
                ]
            })
    });
}
$ea08b9bea77a1bd1$export$2e2bcd8739ae039.propTypes = {
    validationErrorArray: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    setScrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleOpenPreviewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable no-param-reassign */ // Delete rows from the data array
function $fe589b11915a1b72$var$deleteRows(data, rowNumber, numOfRows = 1) {
    for(let i = 0; i < numOfRows; i += 1){
        const rowIndex = rowNumber + i;
        if (rowIndex >= 0 && rowIndex < data.length) data.splice(rowIndex, 1); // Remove the row at the specified index
    }
    return data;
}
// Insert a new column in the data array
function $fe589b11915a1b72$var$insertColumn(data, numOrData, columnNumber, insertBefore, properties) {
    const numOfColumns = typeof numOrData === "number" ? numOrData : 1; // Check if it’s a number or single column data
    data.forEach((row)=>{
        for(let i = 0; i < numOfColumns; i += 1){
            const index = insertBefore ? columnNumber : columnNumber + 1;
            row.splice(index, 0, typeof numOrData === "string" ? numOrData : null); // Insert data or empty column
        }
    });
    return data;
}
// Delete a column from the data array
function $fe589b11915a1b72$var$deleteColumn(data, columnNumber, numOfColumns = 1) {
    data.forEach((row)=>{
        for(let i = 0; i < numOfColumns; i += 1)if (columnNumber >= 0 && columnNumber < row.length) row.splice(columnNumber, 1); // Remove the column at the specified index
    });
    return data;
}
// Insert a formula into a column, beginning on the row below headersInRow + marginTop number of rows
// formula comes with arguments that will be replaced with the current row index
// formula comes as string "=SUM(§#§[-2,0]§#§,§#§[-1,0]§#§)", [<column_offset>, <row_offset> vs current column]
// Note: this function operates on actual data i.e. also with rows above the header row
function $fe589b11915a1b72$var$formula(data, columnNumber, formulaString, headersInRow) {
    // Start from the row after headersInRow, or from row 0 if headersInRow is not provided
    const totalRows = data.length;
    // Iterate through the rows where the formula should be inserted
    // start at the row after headersInRow
    for(let row = 1 + headersInRow; row < totalRows; row += 1){
        // Replace relative references with absolute references
        const absoluteFormula = formulaString.replace(/§#§\[(.*?)\]§#§/g, (match, offsets)=>{
            const [colOffset, rowOffset] = offsets.split(",").map(Number); // Split offsets into column and row
            const colIndex = columnNumber + colOffset; // Adjust column by offset
            const rowIndex = row + rowOffset; // Adjust row by offset
            // Convert colIndex to column letter (A, B, C, etc.)
            const colLetter = String.fromCharCode("A".charCodeAt(0) + colIndex);
            // Return the absolute cell reference
            return `${colLetter}${rowIndex + 1}`; // data is 0-based and grid is 1-based
        });
        // Insert the computed absolute formula into the data array (caveat: this needs to start BELOW header row, which is still there, invisible to user)
        data[row][columnNumber] = absoluteFormula;
    }
    return data; // Return the updated data array
}
function $fe589b11915a1b72$export$2e2bcd8739ae039(data, commands, headersInRow = 0) {
    console.log("DEBUG: applyCommands started with args", data, commands, headersInRow);
    // Create a copy of the data array
    let newData = JSON.parse(JSON.stringify(data));
    // Process each command in the array
    commands.forEach(({ command: command, args: args })=>{
        switch(command){
            case "deleteRow":
                newData = $fe589b11915a1b72$var$deleteRows(newData, ...args);
                break;
            case "insertColumn":
                newData = $fe589b11915a1b72$var$insertColumn(newData, ...args);
                break;
            case "deleteColumn":
                newData = $fe589b11915a1b72$var$deleteColumn(newData, ...args);
                break;
            case "formula":
                newData = $fe589b11915a1b72$var$formula(newData, args[0], args[1], headersInRow); // args have here [columnNumber, formulaString]
                break;
            default:
                console.error(`Unknown command: ${command}`);
        }
    });
    console.log("DEBUG: applyCommands finished with result", newData);
    return newData;
}







parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $33911fdb51874d60$export$2e2bcd8739ae039({ col: col, idx: idx, children: children, lastInRow: lastInRow, category: category }) {
    var _children__props_obj, _children__props;
    const { isOver: isOver, setNodeRef: setNodeRef } = (0, $ecddad0aaeff3d51$export$d74e5d67dc2b3176)({
        id: col
    });
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app");
    let bgColor;
    if (children[0]) {
        if ((_children__props = children[0].props) === null || _children__props === void 0 ? void 0 : (_children__props_obj = _children__props.obj) === null || _children__props_obj === void 0 ? void 0 : _children__props_obj.bgColour) bgColor = children[0].props.obj.bgColour.replace(/\d00/, "100");
    } else bgColor = isOver ? "bg-gray-100" : "bg-white";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: `dataModel-column-${col}`,
        className: `
        ${idx === 0 ? "rounded-tl-lg rounded-tr-lg sm:rounded-tr-none" : ""}
        ${lastInRow ? "rounded-tl-lg rounded-tr-lg sm:rounded-tl-none" : ""}
        ${bgColor} text-gray-500 p-4 shrink-0 grow-0 basis-52 flex flex-col justify-between transition-colors duration-200`,
        // eslint-disable-next-line no-return-assign
        ref: setNodeRef,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "pb-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-lg font-bold leading-none pb-2",
                        children: t(`app:schema.${category}.transaction.${col}.label`)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-xs text-gray-400 leading-snug",
                        children: t(`app:schema.${category}.transaction.${col}.description`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "hidden",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-brandGreen-100"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-brandRed-100"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-brandYellow-100"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-brandViolet-100"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-brandBlue-100"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "bg-brandDarkBlue-100"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "",
                children: children
            })
        ]
    });
}
$33911fdb51874d60$export$2e2bcd8739ae039.propTypes = {
    col: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    idx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node,
    lastInRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    category: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
$33911fdb51874d60$export$2e2bcd8739ae039.defaultProps = {
    children: null,
    lastInRow: false
};


/* eslint-disable max-len */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ed5c76ff3f0a3b52$var$ViewColumnsIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
    }));
}
const $ed5c76ff3f0a3b52$var$ForwardRef = $7fPBF.forwardRef($ed5c76ff3f0a3b52$var$ViewColumnsIcon);
var $ed5c76ff3f0a3b52$export$2e2bcd8739ae039 = $ed5c76ff3f0a3b52$var$ForwardRef;


function $1c3295dfd83d3a19$export$2e2bcd8739ae039({ obj: obj, previewState: previewState, setPreviewState: setPreviewState }) {
    // hook for drag-and-drop
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform } = (0, $ecddad0aaeff3d51$export$df30c81f5aa01ff7)({
        id: `${obj.id}`
    });
    // this is for drag-and-drop
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`
    } : undefined;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", (0, $2qxEV._)((0, $9tqwB._)({
        type: "button",
        ref: setNodeRef,
        style: style
    }, listeners, attributes), {
        className: "group",
        id: `file-${obj.id}`,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "relative flex shadow rounded-md",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: `${obj.bgColour} shrink-0 basis-2 rounded-l-md`,
                    children: " "
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex items-center justify-between border-t border-r border-b border-gray-200 hover:border-gray-400 bg-white rounded-r-md",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "px-4 py-2 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "text-gray-900 font-medium whitespace-nowrap",
                                    children: obj.label
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-gray-500 text-xs whitespace-nowrap",
                                    children: obj.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "pr-2 pt-1",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                id: obj.id,
                                // eslint-disable-next-line max-len
                                className: "bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                                onPointerEnter: (e)=>{
                                    setPreviewState({
                                        clickX: e.clientX,
                                        clickY: e.clientY,
                                        targetId: obj.id
                                    });
                                },
                                onPointerLeave: (e)=>{
                                    setPreviewState(null);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "sr-only",
                                        children: "File preview"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed5c76ff3f0a3b52$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        }, obj.id)
    })));
}
$1c3295dfd83d3a19$export$2e2bcd8739ae039.propTypes = {
    obj: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        description: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        bgColour: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    }).isRequired,
    setPreviewState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    previewState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        clickX: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        clickY: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        targetId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    })
};
$1c3295dfd83d3a19$export$2e2bcd8739ae039.defaultProps = {
    previewState: null
};


/* eslint-disable react/no-array-index-key */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $5a89e09b5a73101a$export$2e2bcd8739ae039({ bgColour: bgColour, previewState: previewState, setPreviewState: setPreviewState, fileObject: fileObject }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    // display on right if previewState clickX is more than half the width of the screen
    const showOnRight = previewState.clickX < window.innerWidth / 2;
    const showOnTop = previewState.clickY > window.innerHeight / 2;
    const isNarrowDisplay = window.innerWidth < 1024;
    // to find the index of headerId property, map the .headerId property of all objects in fileObject.headers into a new array and run indexOf on that
    // targetId is set there by handleMouseEnter based on the id of the button that is hovered over
    const currentColumnId = fileObject.headers.map((obj)=>obj.id).indexOf(previewState.targetId);
    // if there are more than 7 columns in fileObject, only show 3 to the left of the current column and 3 to the right of the current column
    const headers = fileObject.headers.length > 7 ? fileObject.headers.slice(Math.max(0, currentColumnId - 3), currentColumnId + 4) : fileObject.headers;
    // determine rows to be displayed
    // if there are more than 7 rows in fileObject, only show 3 to the top of the current row and 3 to the bottom of the current row
    const displayedRows = fileObject.rows.length > 7 ? fileObject.rows.slice(0, 4).concat([
        new Array(fileObject.rows[3].length).fill("...")
    ]).concat(fileObject.rows.slice(-4)) // display 4 rows from the top and 4 rows from the bottom, separated by ellipses
     : fileObject.rows;
    const trimmedRows = displayedRows// remove the same columns from each row that were removed from the headers
    .map((row)=>fileObject.headers.length > 7 ? row.slice(Math.max(0, currentColumnId - (isNarrowDisplay ? 0 : 3)), currentColumnId + (isNarrowDisplay ? 1 : 4)) : row).map((row)=>Array.from(row).map((col)=>col || " "));
    // Array.from(row) will replace holes in array with undefined, otherwise map will not include them
    // replace empty array items with ' ' (otherwise the table will not render properly)
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `absolute m-0 sm:m-4 py-1.5 sm:py-3 px-1 sm:px-2 bg-white border shadow rounded-md max-w-fit z-[999] ${showOnRight ? "right-0" : "left-0"} ${showOnTop ? "top-0" : "bottom-0"}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex",
                children: [
                    currentColumnId > 3 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "pl-1 pr-2 self-center",
                        children: "\u2026"
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                        className: "font-mono tracking-tighter text-xs sm:text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                                    children: headers.map((col, idx2)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                            className: `${(col.id === previewState.targetId && bgColour, "px-3")}`,
                                            children: col.label
                                        }, col.id))
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                                children: trimmedRows.map((row, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tr", {
                                        className: "",
                                        children: row.map((col, idxMap)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                className: `px-3 truncate ${idxMap === Math.min(3, currentColumnId) ? bgColour : ""}`,
                                                children: col
                                            }, idxMap))
                                    }, idx))
                            })
                        ]
                    }),
                    currentColumnId < fileObject.headers.length - 4 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "pl-2 pr-1 self-center",
                        children: "\u2026"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                text: t("accountDetails.buttons.close.label"),
                onClick: ()=>setPreviewState(null),
                size: "sm",
                formatting: "m-2"
            })
        ]
    });
}
$5a89e09b5a73101a$export$2e2bcd8739ae039.propTypes = {
    bgColour: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    previewState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        clickX: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        clickY: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        marginTop: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        marginLeft: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        marginRight: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        targetId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }).isRequired,
    setPreviewState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    // eslint-disable-next-line react/forbid-prop-types
    fileObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
$5a89e09b5a73101a$export$2e2bcd8739ae039.defaultProps = {
    bgColour: "bg-gray-100",
    setPreviewState: undefined
};





var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $f0584fb82a334c8c$export$2e2bcd8739ae039({ inputFileObject: inputFileObject, callback: callback }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "pension.import"
    });
    const [selection, setSelection] = (0, $7fPBF.useState)(null);
    function handleIgnore() {
        window.dispatchEvent(new CustomEvent("setDialog", {}));
    }
    function handleOK() {
        if (!selection) return;
        callback(selection.row);
        handleIgnore();
    }
    const options = inputFileObject.slice(1).map((row, index)=>({
            row: index + 1,
            name: row[10],
            accountNumber: row[11],
            productType: row[12],
            productSubtype: row[13]
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto max-w-3xl p-4 overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4653f19041d4d80$export$2e2bcd8739ae039), {
                        className: "mx-auto flex items-center justify-center h-12 w-12 text-brandBlue-500",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-3 text-center sm:mt-5",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-lg leading-6 font-bold text-gray-900",
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-center mx-auto mt-2 text-sm text-gray-500 prose",
                                children: t("prompt")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25), {
                                value: selection,
                                by: "row",
                                onChange: setSelection,
                                className: "mt-4 p-2 gap-4 flex content-stretch overflow-x-auto",
                                children: options.map((o)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25).Option, {
                                        value: o,
                                        children: ({ checked: checked })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                className: `border border-gray-100 shadow p-2 w-60 rounded-md text-left h-full space-y-1 hover:bg-gray-50 cursor-pointer ${checked ? "ring ring-brandBlue-500 ring-offset-1" : ""}`,
                                                type: "button",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "font-semibold leading-tight",
                                                        children: o.name
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "text-sm",
                                                        children: `${o.productType} ${o.productSubype || ""}`
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "text-sm",
                                                        children: o.accountNumber
                                                    })
                                                ]
                                            })
                                    }, o.row))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-7 sm:mt-8 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        name: "dialog-cancel-button",
                        id: "dialog-form-cancel-button",
                        // eslint-disable-next-line max-len
                        className: "inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-500 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 sm:text-sm",
                        onClick: handleIgnore,
                        children: t("ignore")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        name: "dialog-save-button",
                        id: "dialog-form-save-button",
                        // eslint-disable-next-line max-len
                        className: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-brandBlue-500 text-base font-medium text-white hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 sm:text-sm",
                        onClick: handleOK,
                        children: "OK"
                    })
                ]
            })
        ]
    });
}
$f0584fb82a334c8c$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    inputFileObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $48620be3acb03fcf$export$2e2bcd8739ae039({ specialQuotes: specialQuotes, accountCurrency: accountCurrency, baseCurrency: baseCurrency, callback: callback, reject: reject }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const [selection, setSelection] = (0, $7fPBF.useState)(null);
    const [fxRate, setFxRate] = (0, $7fPBF.useState)(null);
    // prepare initialisation values
    const { register: register, setValue: setValue, handleSubmit: handleSubmit, errors: errors } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)();
    // when the component intialises, get today's fx rate
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            setFxRate("loading");
            let newRate;
            try {
                newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, accountCurrency, baseCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                setFxRate(newRate);
            } catch (err) {
                setFxRate(null);
            }
        }
        updateFxRate();
    }, [
        accountCurrency
    ]);
    function handleIgnore() {
        reject();
    }
    function handleOK(userInput) {
        callback(userInput.fxRate);
        window.dispatchEvent(new CustomEvent("setDialog", {}));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto max-w-full md:max-w-xl p-4 overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4653f19041d4d80$export$2e2bcd8739ae039), {
                        className: "mx-auto flex items-center justify-center h-12 w-12 text-brandBlue-500",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-3 text-center sm:mt-5",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-lg leading-6 font-bold text-gray-900",
                                children: t("pension.import.baseCurrencyDialog.title")
                            }),
                            fxRate === "loading" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                className: "mx-auto mt-2 h-5 w-5"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-center mx-auto mt-2 text-sm text-gray-500 prose",
                                children: `${t("pension.import.baseCurrencyDialog.prompt")}`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-4 mx-4 grid grid-cols-2 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "text-gray-500 text-left",
                                                children: t("pension.import.baseCurrencyDialog.fxRate")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                                type: "number",
                                                step: "0.04",
                                                name: "fxRate",
                                                id: "fxRate"
                                            }, register("fxRate", {
                                                valueAsNumber: true,
                                                required: true
                                            })), {
                                                className: "mt-0.5 w-full flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block min-w-0 rounded-md sm:text-sm border-gray-300"
                                            })),
                                            (errors === null || errors === void 0 ? void 0 : errors.fxRate) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors === null || errors === void 0 ? void 0 : errors.fxRate.message
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                        text: `\u{2190} ${t("pension.import.baseCurrencyDialog.apply")} ${(fxRate && fxRate !== "loading" ? fxRate : 0).toFixed(4)}`,
                                        noFrameNoArrow: true,
                                        onClick: ()=>{
                                            setValue("fxRate", fxRate);
                                        },
                                        formatting: "self-end justify-self-start",
                                        size: "xl"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "grid grid-cols-4 gap-2 mt-4 mx-4 text-xs md:text-sm text-gray-400",
                                children: specialQuotes.slice(0, 3).map((quote)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "col-span-2 text-left",
                                                children: t(`columns.${quote.type}.label`)
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "text-right",
                                                children: quote.quote.toLocaleString("de", {
                                                    style: "currency",
                                                    currency: accountCurrency,
                                                    maximumFractionDigits: 2
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "text-right",
                                                children: (quote.quote * (fxRate || 0)).toLocaleString("de", {
                                                    style: "currency",
                                                    currency: baseCurrency,
                                                    maximumFractionDigits: 2
                                                })
                                            })
                                        ]
                                    }))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-7 sm:mt-8 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("pension.import.cancel"),
                        name: "dialog-cancel-button",
                        id: "dialog-form-cancel-button",
                        onClick: handleIgnore
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        withAccent: true,
                        text: "OK",
                        name: "dialog-save-button",
                        id: "dialog-form-save-button",
                        onClick: handleSubmit(handleOK)
                    })
                ]
            })
        ]
    });
}
$48620be3acb03fcf$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    specialQuotes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    accountCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    reject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($f31b2d9172e2fa32$exports))));
const $e76bacd9538b4138$var$debugLevel = 0;
const $e76bacd9538b4138$var$colours = [
    "bg-brandGreen-500",
    "bg-brandBlue-500",
    "bg-brandRed-500",
    "bg-brandDarkBlue-500",
    "bg-brandViolet-500",
    "bg-brandYellow-500"
];
function $e76bacd9538b4138$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $e76bacd9538b4138$var$ColumnMatcherInner({ currentFileIngested: currentFileIngested, currentFileName: currentFileName, updateCurrentFileTransformed: updateCurrentFileTransformed, currentFilePretransformed: currentFilePretransformed, updateCurrentFilePretransformed: updateCurrentFilePretransformed, transformationParams: transformationParams, setTransformationParams: setTransformationParams, showSkipFileButton: showSkipFileButton, skipToNextFile: skipToNextFile, handleClick: handleClick, displayedData: displayedData, alert: alert, setAlert: setAlert, account: account, pretransformationApplied: pretransformationApplied, setPretransformationApplied: setPretransformationApplied, setScrollToRow: setScrollToRow }) {
    if ($e76bacd9538b4138$var$debugLevel > 2) console.log("ColumnMatcherInner", currentFilePretransformed);
    // the draggable FileColumn components are either shown in the "pool" on the bottom,
    // or at their target spots among the columns on top
    // dropState has key-value pairs which tell us which FileColumn objects are located in the columns
    // if the FileColumn id is not in the dropState object, it is not dropped anywhere and should be shown at the bottom
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    let arraySchema;
    let objectSchema;
    if (displayedData === "holdings") {
        arraySchema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(account.category, "transaction", true);
        objectSchema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(account.category, "transaction", false);
    } else if (displayedData === "quotes") {
        arraySchema = (0, $fd6541cb8870bfa3$export$afe84a81194592dd);
        objectSchema = (0, $fd6541cb8870bfa3$export$ee7a15c61bfdeb11);
    }
    if (!currentFileIngested || currentFileIngested.length === 0) return true;
    // -----------------------------------
    // HELPER FUNCTIONS
    // -----------------------------------
    // returns the index of the column where the headers should be based on the file input data
    // only runs once during initialisation
    function detectHeaders(parsedArray, fileColumnStats, _expectedDateFormats) {
        // get the maximum number of columns in the file as column count
        // try to detect headers: try to find a row with the same amount of columns as the last row and all strings
        let j = 0;
        let suggestedHeaderRow; // undefined
        while(j < parsedArray.length && suggestedHeaderRow === undefined){
            // if it is not true, that the row has at least one number or one date
            if (parsedArray[j].length === fileColumnStats.maxCols && !parsedArray[j].some((item)=>/[0-9]*[,.][0-9]*$/.test(item) || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item, _expectedDateFormats, true).isValid())) suggestedHeaderRow = j;
            j += 1;
        }
        return suggestedHeaderRow;
    }
    const decimalRef = (0, $7fPBF.useRef)(null); // used to store the decimal symbol in the state
    function convertStringToNumber(inputString, entireColumn) {
        if ($e76bacd9538b4138$var$debugLevel > 2) console.log("DEBUG convertStringToNumber", inputString, entireColumn);
        try {
            // if entire column has been passed and if the decimal symbol has not been set locally, try to detect it and set in state
            if (entireColumn && !decimalRef.current) {
                // if entireColumn is set, check the entire column for the most common non-digit character
                const nonDigits = entireColumn.map((item)=>item.replace(/[^.,]/g, "").trim()); // replace everything that isn't a dot or comma
                const decimalsObject = nonDigits.reduce((acc, cur)=>{
                    const decimal = cur.slice(-1);
                    if (decimal) {
                        if (!acc[decimal]) acc[decimal] = 1;
                        else acc[decimal] += 1;
                    }
                    return acc;
                }, {});
                const decimal = Object.keys(decimalsObject).reduce((a, b)=>decimalsObject[a] > decimalsObject[b] ? a : b, ".");
                decimalRef.current = decimal;
                // fix the current inputString (leaving it duplicated in case decimal symbol is delayed in state)
                const theOtherSymbol = decimalRef.current === "." ? "," : ".";
                const num = Number(inputString.replace(/[^\d-.,]/g, "").trim().replace(theOtherSymbol, "").replace(decimalRef.current, "."));
                return num;
            }
            if (decimalRef.current) {
                // if the decimal symbol has been set, use it to convert the string to a number
                const theOtherSymbol = decimalRef.current === "." ? "," : ".";
                const num = Number(inputString.replace(/[^\d-.,]/g, "").trim().replace(theOtherSymbol, "").replace(decimalRef.current, "."));
                return num;
            }
            // if we are somehow here, try it the old way
            if ($e76bacd9538b4138$var$debugLevel > 2) console.info("ColumnMatcher.jsx: convertStringToNumber: we are trying the old way, which should not have happened");
            let num = Number(inputString.replace(/[^0-9.,-]/g, "").trim());
            // Check if the initial conversion is successful
            if (!Number.isNaN(num)) return num;
            // Replace dots with nothing and commas with dots
            const modifiedString = inputString.replace(/\./g, "").replace(/,/g, ".");
            // Try to convert the modified string to a number
            num = Number(modifiedString);
            if (!Number.isNaN(num)) return num;
        } catch (error) {
            if ($e76bacd9538b4138$var$debugLevel > 2) console.error("ColumnMatcher.jsx: convertStringToNumber: error", error);
        }
        // if everything fails, return null
        return null;
    }
    // converts the current file (in state) into an object with headers and rows
    // returns fileObject { headers: [], rows: [] }
    function transformInputObject(inputArray, suggestedHeaderRow, fileColumnStats) {
        // input is an array of arrays, each array is a row
        // prepare output: { headers: { id ('column1'), label ('name from file or default'),
        // description (default "column 1 of your file"), bgColour }, rows: [[val1, val2, ... valN], [val1, val2, ... valN],...]}
        const output = {
            headers: [],
            rows: []
        };
        // if there is a header row, use it to create the headers; if there is no header row, create default headers based on the detected column numbers
        const headerArray = inputArray[suggestedHeaderRow === null || suggestedHeaderRow === undefined ? fileColumnStats.maxColsRow : suggestedHeaderRow];
        const longestRowLength = fileColumnStats.maxCols;
        for(let i = 0; i < headerArray.length; i += 1)output.headers.push({
            id: `column${i + 1}`,
            label: suggestedHeaderRow === undefined ? `column${i + 1}` : headerArray[i] || "empty",
            description: `Column ${i + 1} of your file`,
            bgColour: $e76bacd9538b4138$var$colours[i % $e76bacd9538b4138$var$colours.length]
        });
        // if there is a header row, start at the next row, otherwise start at the first row
        for(let i = suggestedHeaderRow === undefined ? 0 : suggestedHeaderRow + 1; i < inputArray.length; i += 1)if (inputArray[i].length < longestRowLength) {
            // if the row is shorter than the longest row, fill it up with nulls
            const updatedRow = new Array(longestRowLength - inputArray[i].length).fill(null);
            output.rows.push(inputArray[i].concat(updatedRow));
        } else output.rows.push(inputArray[i]);
        return output;
    }
    // -----------------------------------
    // SELECTORS + STATE
    // -----------------------------------
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const selectDateFormats = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.expectedDateFormats); // contains a parsed array of formats, user can change defaults in Settings > Preferences
    const expectedDateFormats = [
        ...selectDateFormats
    ]; // copy the array to avoid mutation
    // finds a row with the most number of columns and stores its index as maxColsRow and the number of columns as maxCols
    const [fileColumnStats, setFileColumnStats] = (0, $7fPBF.useState)(()=>{
        const initialState = currentFilePretransformed.reduce((acc, cur, idx)=>cur.length > acc.maxCols ? {
                maxCols: cur.length,
                maxColsRow: idx
            } : acc, {
            maxCols: 0,
            maxColsRow: 0
        });
        return initialState;
    });
    const [currentFileObject, setCurrentFileObject] = (0, $7fPBF.useState)({
        headers: [],
        rows: []
    }); // changes are handled in useEffect to handle custom columns
    const [activeFileColumn, setActiveFileColumn] = (0, $7fPBF.useState)(null); // handles appearance of the DragOverlay component
    const [allFieldsAssigned, setAllFieldsAssigned] = (0, $7fPBF.useState)(false); // true if all mandatory fields are assigned (there can be validation errors)
    const [formReadyToSubmit, setFormReadyToSubmit] = (0, $7fPBF.useState)(false); // true if all mandatory fields are filled out and there are no validation errors
    // contains mappings, initialise empty; fill out with values from the mapping in redux / in category service in useEffect, once custom columns are added
    const [dropState, setDropState] = (0, $7fPBF.useState)(transformationParams.mappings || {});
    // in which columns are filecolumns by id: { fileCol2: 'col2', fileCol3: 'col4', fileCol5: null ...}
    // should be: { dataModelCol1: fileCol1, dataModelCol2: fileCol2, ...}
    const [previewState, setPreviewState] = (0, $7fPBF.useState)(null); // used to show the preview of the file column in the column
    const [validationErrors, setValidationErrors] = (0, $7fPBF.useState)([]); // contains errors from the validation of the form (after each drop)
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // loading state for the submit button
    const [useOnlyThisRow, setUseOnlyThisRow] = (0, $7fPBF.useState)(undefined); // for pensions users may want to import their RV app file which contains data for several accounts (not just this one)
    const componentRef = (0, $7fPBF.useRef)();
    // ------------------------
    // HANDLE RV APP IMPORT
    // ------------------------
    function callback(row) {
        setUseOnlyThisRow(row);
        // the file columns will be numbered through (column01, column02, ... column99), so - in case the number of columns in the file has changed - we need to find them by name and get their index
        setDropState({
            date: `column${(currentFilePretransformed[0].findIndex((col)=>col === "Stichtag Wertangaben") + 1).toString().padStart(2, "0")}`,
            payoutOnlyContributionsToDate: `column${(currentFilePretransformed[0].findIndex((col)=>col === "Garantiert erreichte Rente") + 1).toString().padStart(2, "0")}`,
            payoutOnlyContributionsToDateIndexed: `column${(currentFilePretransformed[0].findIndex((col)=>col === "Prognostiziert erreichte Rente") + 1).toString().padStart(2, "0")}`,
            payoutAllPlannedContributions: `column${(currentFilePretransformed[0].findIndex((col)=>col === "Garantiert erreichbare Rente") + 1).toString().padStart(2, "0")}`,
            payoutAllPlannedContributionsIndexed: `column${(currentFilePretransformed[0].findIndex((col)=>col === "Prognostiziert erreichbare Rente") + 1).toString().padStart(2, "0")}`
        });
    }
    (0, $7fPBF.useEffect)(()=>{
        if (useOnlyThisRow === undefined) {
            // we try to detect the file type based on the first 7 rows
            const targetFirstRows = [
                "Kontakt-Stra\xdfe",
                "Kontakt-Hausnummer",
                "Kontakt-Ort",
                "Kontakt-PLZ",
                "Kontakt-Postfach",
                "Kontakt-Staat",
                "Kontakt-URL"
            ];
            // if there is more than one pension product in the input file (+ header)
            if (targetFirstRows.every((target, index)=>currentFilePretransformed[0][index] === target)) {
                if (currentFilePretransformed.length > 2) window.dispatchEvent(new CustomEvent("setDialog", {
                    detail: {
                        Component: (0, $f0584fb82a334c8c$export$2e2bcd8739ae039),
                        props: {
                            visible: true,
                            inputFileObject: currentFilePretransformed,
                            callback: callback
                        }
                    }
                }));
                else if (currentFilePretransformed.length === 2) setUseOnlyThisRow(1);
            }
        }
    }, []);
    // --------------------------------------------------
    // INITIALISE COMPONENT
    // --------------------------------------------------
    // add custom columns from importFileMappings to the schema when importFiles or account object change
    // every time importFiles or account object changes, the entire fileObject is recalculated from scratch (to handle custom column changes)
    (0, $7fPBF.useEffect)(()=>{
        // check if there is any header row in transformationParams, if not - attempt to locate it
        if (transformationParams.headersInRow === undefined || transformationParams.headersInRow === null) {
            const detectedHeaderRow = detectHeaders(currentFilePretransformed, fileColumnStats);
            if (detectedHeaderRow !== undefined) setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    headersInRow: detectedHeaderRow
                }));
        }
        // move current file to state
        const fileObject = transformInputObject(currentFilePretransformed, transformationParams === null || transformationParams === void 0 ? void 0 : transformationParams.headersInRow, fileColumnStats);
        setCurrentFileObject(fileObject);
        // once custom columns have been added, set dropState to the mappings from the account object
        // (if dropState is still empty - otherwise let it be, because that means it is not the first run)
        setDropState((prev)=>{
            if (Object.keys(prev).length === 0) {
                var _account_importFileMappings, _account_importFileMappings1;
                const mappings = ((_account_importFileMappings = account.importFileMappings) === null || _account_importFileMappings === void 0 ? void 0 : _account_importFileMappings.mappings) || {};
                // skip this check if there are no mappings
                if (Object.keys(mappings).length > 0) {
                    // check if all data model columns are still there (in case there has been a change in the data model)
                    const missingColumns = Object.keys(mappings).filter((key)=>!Object.keys(objectSchema.describe().fields).includes(key));
                    if (missingColumns.length > 0) {
                        // if there are missing columns, remove them from the mappings
                        const newMappings = Object.entries(mappings).filter(([key, value])=>!missingColumns.includes(key));
                        return Object.fromEntries(newMappings);
                    }
                    // check if imported mappings use any columns with indices exceeding the current highest column index (because user had imported a different file before)
                    const highestIndex = Math.max(...Object.values(mappings).map((value)=>Number(value.split("column")[1])));
                    if (highestIndex > currentFileObject.headers.length) {
                        // if yes, remove them from the mappings
                        const newMappings = Object.entries(mappings).filter(([key, value])=>Number(value.split("column")[1]) <= currentFileObject.headers.length);
                        return Object.fromEntries(newMappings);
                    }
                }
                return ((_account_importFileMappings1 = account.importFileMappings) === null || _account_importFileMappings1 === void 0 ? void 0 : _account_importFileMappings1.mappings) || {};
            }
            return prev;
        });
    }, [
        currentFilePretransformed,
        account
    ]);
    // -------------------------------
    // GET TARGET COLUMNS FROM SCHEMA
    // -------------------------------
    // handle pensions, which need to display special quotes instead of quote | quoteBaseCurrency
    // for all other categories, return unaltered schema object
    function getSchemaEntries(category) {
        const originalSchema = Object.entries(objectSchema.describe().fields); // originalSchema returns an array of arrays [ fieldName, fieldObject ]
        // for all categories except pension, return the original schema without "specialQuotes", which have no relevance there
        if (category !== "pension") return originalSchema.filter(([fieldName, fieldObject])=>![
                "specialQuotes"
            ].includes(fieldName));
        return originalSchema.filter(([fieldName, fieldObject])=>![
                "currency",
                "quote",
                "quoteBaseCurrency",
                "specialQuotes"
            ].includes(fieldName)).concat((0, $5ee4f29aaf60da17$export$c65bfcd13f0761e8).map((x)=>[
                x,
                {
                    meta: {
                        importOptional: true
                    }
                }
            ]));
    }
    // .describe() returns .fields: { id: { name, type, label, meta, ...}, date: { ... }, ... };
    // fields in schema can have a hideFromImport meta-property, which is used to hide columns from the import process
    // 'columns' needs to be [{ id, optional }, ...]
    const columns = getSchemaEntries(account.category).filter(([key, value])=>{
        var _value_meta;
        return !((_value_meta = value.meta) === null || _value_meta === void 0 ? void 0 : _value_meta.hideFromImport);
    }).map(([key, value])=>{
        var _value_meta;
        return {
            id: key,
            optional: ((_value_meta = value.meta) === null || _value_meta === void 0 ? void 0 : _value_meta.importOptional) || value.nullable
        };
    });
    // -------------------------------
    // PREPARE OUTPUT / HANDLE SAVE
    // -------------------------------
    // used to test if the form is ready as well as before submitting
    // fileObject is the object with headers and rows (transformed input file + custom columns)
    // this takes rows from fileObject and maps them to the data model columns according to what is in dropState
    // FIXME this needs to be adjusted to handle the special case in pension
    // get rid of special quotes that have not been provided by user or in the file
    async function transformAndValidateOutput(fileObject, alertOnError = true) {
        // clear validation errors state
        setValidationErrors([]);
        // for each row in fileObject get only the columns of the indices present in dropState
        // (so the columns that the user mapped to the data model columns)
        // and form a transaction object
        const output = fileObject.rows.filter((row, index)=>useOnlyThisRow === undefined || index === useOnlyThisRow - 1) // if useOnlyThisRow is defined, only use that row
        .map((row)=>{
            const entity = {};
            Object.entries(dropState).forEach(([key, value])=>{
                const index = value.split("column")[1] - 1;
                if ($e76bacd9538b4138$var$debugLevel > 2) console.log("DEBUG entity before", key, value, "in row", row, "current index", index, row[index]);
                var _row_index;
                if ([
                    "quantity",
                    "accountCurrencyAmount",
                    "fxAmount",
                    "transactionAmount"
                ].includes(key)) {
                    if (!decimalRef.current) entity[key] = convertStringToNumber(row[index], fileObject.rows.map((r)=>r[index]));
                    else entity[key] = convertStringToNumber(row[index]);
                } else entity[key] = (_row_index = row[index]) !== null && _row_index !== void 0 ? _row_index : null;
            });
            entity.date = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(entity.date, expectedDateFormats || [
                "DD.MM.YYYY",
                "YYYY-MM-DD"
            ]).utc(true).valueOf(); // default in case somehow the expectedDateFormats are not set
            if (displayedData === "holdings") {
                if ($e76bacd9538b4138$var$debugLevel > 2) console.log("DEBUG ColumnMatcher: entity", entity);
                // add id
                entity.id = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
                // add attributes derived from account
                if (account.category === "deposits" && !entity.currency) entity.currency = account.currency; // realEstate only allows quotes
                if (account.category === "stocks") entity.transactionType = entity.transactionAmount >= 0 ? "purchase" : "sale"; // FIXME this assumes there will never be 'split' transactions etc.
                if (account.category !== "realEstate") entity.accountId = account.id; // realEstate only allows quotes, and quotes do not need account
            }
            if (displayedData === "quotes") {
                entity.source = "manual";
                if (!entity.currency) entity.currency = account.currency; // realEstate only allows quotes
                entity.assetId = account.id;
                entity.projectId = null;
                entity.importFlag = "post"; // was 'put', not sure why?
                // special routine for pension category quotes
                if (account.category === "pension") {
                    entity.quoteBaseCurrency = 0;
                    entity.quote = 0;
                    entity.currency = account.currency;
                    entity.assetId = account.id;
                    entity.source = "manual";
                    entity.specialQuotes = [];
                    if (entity.payoutOnlyContributionsToDate) entity.specialQuotes.push({
                        type: "payoutOnlyContributionsToDate",
                        quote: convertStringToNumber(entity.payoutOnlyContributionsToDate)
                    });
                    if (entity.payoutOnlyContributionsToDateIndexed) entity.specialQuotes.push({
                        type: "payoutOnlyContributionsToDateIndexed",
                        quote: convertStringToNumber(entity.payoutOnlyContributionsToDateIndexed)
                    });
                    if (entity.payoutAllPlannedContributions) entity.specialQuotes.push({
                        type: "payoutAllPlannedContributions",
                        quote: convertStringToNumber(entity.payoutAllPlannedContributions)
                    });
                    if (entity.payoutAllPlannedContributionsIndexed) entity.specialQuotes.push({
                        type: "payoutAllPlannedContributionsIndexed",
                        quote: convertStringToNumber(entity.payoutAllPlannedContributionsIndexed)
                    });
                    if (account.currency === baseCurrency) entity.specialQuotes.forEach((q)=>{
                        // eslint-disable-next-line no-param-reassign
                        q.quoteBaseCurrency = q.quote;
                    });
                // the case where account.currency is NOT base currency is handled in handleSave, because this runs every time anything changes in the form
                }
            }
            return entity;
        });
        if ($e76bacd9538b4138$var$debugLevel > 2) console.log("transformed output", output, arraySchema);
        // validation by casting the file data through yum.cast
        let validatedOutput = false;
        try {
            validatedOutput = arraySchema.validateSync(output, {
                stripUnknown: true,
                abortEarly: false
            });
        } catch (err) {
            if ($e76bacd9538b4138$var$debugLevel > 2) console.error("validation error", err.message, err.inner);
            setValidationErrors(err.inner);
            if (alertOnError) setAlert({
                visible: true,
                id: "errorsDetected",
                type: "error"
            });
        }
        return validatedOutput;
    }
    async function handleSave() {
        const validatedOutput = await transformAndValidateOutput(currentFileObject);
        // PENSION QUOTES ONLY:
        // in pensions we need to check if all specialQuotes have quoteBaseCurrency; if they don't, we need to ask the user to provide them
        if (displayedData === "quotes" && account.category === "pension" && account.currency !== baseCurrency) {
            const missingQuoteBaseCurrency = validatedOutput.some((Q)=>Q.specialQuotes.length > 0 && Q.specialQuotes.some((q)=>q.quoteBaseCurrency === 0));
            if (missingQuoteBaseCurrency) try {
                const fxRate = await new Promise((resolve, reject)=>{
                    window.dispatchEvent(new CustomEvent("setDialog", {
                        detail: {
                            Component: (0, $48620be3acb03fcf$export$2e2bcd8739ae039),
                            props: {
                                visible: true,
                                specialQuotes: validatedOutput.filter((Q)=>Q.specialQuotes.length > 0).map((Q)=>Q.specialQuotes)[0],
                                accountCurrency: account.currency,
                                baseCurrency: baseCurrency,
                                callback: (_fxRate)=>{
                                    resolve(_fxRate);
                                },
                                reject: reject
                            }
                        }
                    }));
                });
                // apply fxRate to generate quoteBaseCurrency in all specialQuotes for all rows of validatedOutput
                validatedOutput.forEach((Q)=>{
                    Q.specialQuotes.forEach((q)=>{
                        // eslint-disable-next-line no-param-reassign
                        q.quoteBaseCurrency = q.quote * fxRate;
                    });
                });
            } catch (err) {
                // if the user cancels, do nothing
                return;
            }
        }
        if (validatedOutput) {
            setLoading(true);
            // wait for dispatches to return something
            Promise.all([
                // send mappings to backend (update Account object) -- this will set a signal { [depositsPostAccount]: true }
                dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
                    data: (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                        importFileMappings: (0, $2qxEV._)((0, $9tqwB._)({}, account.importFileMappings, transformationParams), {
                            mappings: dropState
                        })
                    }),
                    category: account.category
                })),
                // update transformed in parent state
                updateCurrentFileTransformed(validatedOutput)
            ]).then(()=>{
                handleClick("duplicate");
            }, (err)=>{
                // negative case
                if ($e76bacd9538b4138$var$debugLevel > 2) console.error("error", err);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadFailed"));
            });
        }
    }
    // FIXME
    // react to the button pressed by the user in response to aboutToSave modal triggered above in handleSaveGrid
    (0, $7fPBF.useEffect)(()=>{
        if (alert.id === "abandonUpload") {
            if (alert.buttonClicked === "ok") {
                // if the user pressed ok, go back to table screen
                setAlert({
                    visible: false
                }); // reset the alert modal
                handleClick("table");
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadAbortedSuccessfully")); // shows a toast message confirming that file upload cancelled
            }
        }
    }, [
        alert.buttonClicked
    ]);
    // -------------------------------
    // ONGOING VALIDATION
    // -------------------------------
    // after every mapping change this validates existing state of mappings; enables the submit button if there are no errors
    // validation must react to dropState change, because doing it in handleDrop is too early (dropState is not updated yet)
    (0, $7fPBF.useEffect)(()=>{
        async function ongoingValidation() {
            // validate the form and - if it passes - set the formReadyCondition to true
            let validationResult;
            try {
                validationResult = await transformAndValidateOutput(currentFileObject, false); // no alert on error; this updates validationErrors
                // if no errors, set validationErrors to empty
                // setValidationErrors([]);
                if ($e76bacd9538b4138$var$debugLevel > 2) console.info("validation result", validationResult);
                setFormReadyToSubmit(validationResult);
            } catch (err) {
            // do nothing, we are just checking if it is ready to unblock the button
            }
            // determine if all the required fields are filled out
            if ($e76bacd9538b4138$var$debugLevel > 2) console.log("columns", columns, "dropState", dropState, columns.filter((column)=>!column.optional).every((column)=>Object.keys(dropState).includes(column.id)));
            setAllFieldsAssigned(columns.filter((column)=>!column.optional).every((column)=>Object.keys(dropState).includes(column.id)));
        }
        ongoingValidation();
    }, [
        dropState
    ]);
    // -------------------------------
    // HANDLE DRAG + DROP
    // -------------------------------
    function handleDragStart(e) {
        // the FileColumn component needs an entire object a prop, so we need to retrieve it
        setActiveFileColumn(currentFileObject.headers.find((header)=>header.id === e.active.id));
    }
    function handleDrop(e) {
        // disable DropOverlay
        setActiveFileColumn(null);
        // when dropped on a droppable element:
        // - e.over.id --> which droppable column id are we over (null if none)
        // - e.active.id --> id of the component being dragged
        // check if trying to drop inside an already occupied column
        // if e.over.id exists in dropState, it means this column is occupied
        // if (e.over && !Object.entries(dropState).some(([key, value]) => value === e.over.id)) {
        if (e.over && !Object.keys(dropState).includes(e.over.id)) // remove the dragged element from any previously occupied data model column, if it is there
        setDropState((prevDropState)=>{
            const dropStateNoPrevColumn = Object.entries(prevDropState).filter(([key, value])=>value !== e.active.id) // leave only those key-value pairs whose value is not the dragged element
            .reduce((acc, [key, value])=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                    [key]: value
                }), {}); // bring it back to an object
            return (0, $2qxEV._)((0, $9tqwB._)({}, dropStateNoPrevColumn), {
                [e.over.id]: e.active.id
            }); // add the dragged element to the new column
        });
        // if dropped outside a droppable element (e.over.id is null), go through dropState and remove the dropped element
        if (!e.over) // if (debugLevel > 2) console.log('dropped outside', e.active.id, 'dropState', dropState);
        setDropState(Object.entries(dropState).filter(([key, value])=>value !== e.active.id).reduce((acc, [key, value])=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                [key]: value
            }), {}));
    }
    function handleHeaderRowChange(newValue) {
        if (newValue < 1) setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                headersInRow: 0
            }));
        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                headersInRow: Number(newValue) - 1
            }));
        // recalculate headers + rows
        setCurrentFileObject(transformInputObject(currentFilePretransformed, Number(newValue) - 1, fileColumnStats));
    }
    function handleOpenPreviewer(e) {
        // save matchings made by user to transformationParams, so that they are still here when the user is done editing data
        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                mappings: dropState
            }));
        // go to previewer
        handleClick("previewer");
    }
    // CAUTION: a similar function is used in Previewer (check if update necessary there as well)
    // copy back ingested to pretransformed and reset status + reset previously saved commands
    function handleUndoTransform() {
        if ($e76bacd9538b4138$var$debugLevel > 2) console.log("DEBUG undoing transformation");
        updateCurrentFilePretransformed(JSON.parse(JSON.stringify(currentFileIngested))); // copy ingested to pretransforme
        // reset commands
        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                commands: []
            }));
        setPretransformationApplied(false);
    }
    // if (debugLevel > 2) console.log('ColumnMatcher fileObject', currentFileObject);
    // if (debugLevel > 2) console.log('ColumnMatcher dropState', dropState);
    // -------------------------------
    // RENDER THE COMPONENT
    // -------------------------------
    return(// eslint-disable-next-line react/jsx-no-bind
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                className: "space-y-2 xl:flex xl:space-x-4 xl:items-center mt-2 md:mt-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-2 sm:mt-0 rounded-md bg-white px-4 py-2 flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c4382dbe971fd630$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 text-gray-500",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-xl md:text-2xl font-bold text-gray-700 break-all",
                                children: currentFileName
                            })
                        ]
                    }),
                    Object.keys(dropState).length === 0 && // first upload message
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "rounded-md bg-brandBlue-50 px-3 py-2",
                        id: "info-message",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "flex-shrink-0",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 text-brandBlue-400",
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "ml-3 flex-1 md:flex md:justify-between",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-sm text-brandBlue-600",
                                        children: t("firstUpload")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: "ml-1 mb-3 mt-1 flex flex-rows gap-2 sm:gap-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("cancelFileUpload.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("cancelFileUpload.label"),
                                    Icon: (0, $68ecf30d598e901c$export$2e2bcd8739ae039),
                                    onClick: ()=>{
                                        setAlert({
                                            visible: true,
                                            id: "abandonUpload",
                                            buttons: [
                                                "ok",
                                                "cancel"
                                            ]
                                        });
                                    // do not send out a cleanup action to category service, because a process to clean up stuck files must be existing anyway
                                    // for the case that the user closes the app before the upload process is finished
                                    },
                                    size: "lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("resetColumns.tooltip"),
                                classNameOwn: "hidden xs:block",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("resetColumns.label"),
                                    Icon: (0, $3ea1f91ff88fa2cb$export$fcc683c36751f67a),
                                    onClick: ()=>{
                                        setDropState({});
                                    },
                                    size: "lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("editLoadedFile.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("editLoadedFile.label"),
                                    Icon: (0, $91420ff1f0fec24c$export$2e2bcd8739ae039),
                                    onClick: handleOpenPreviewer,
                                    size: "lg"
                                })
                            }),
                            showSkipFileButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("skipThisFile.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("skipThisFile.label"),
                                    Icon: (0, $302127f8ab9e3c0b$export$2e2bcd8739ae039),
                                    onClick: ()=>skipToNextFile(),
                                    size: "lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("confirmAndContinue.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: t("confirmAndContinue.label"),
                                    Icon: (0, $cf0ef6f622ac72ef$export$2e2bcd8739ae039),
                                    onClick: handleSave,
                                    spinnerOn: loading,
                                    enabled: formReadyToSubmit,
                                    withAccent: true,
                                    size: "lg"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "hidden lg:inline-flex gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "headerRow",
                                        className: "block text-sm font-medium text-gray-700",
                                        children: t("headersInRow.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "number",
                                        name: "headerRow",
                                        id: "headerRow",
                                        className: "block w-14 rounded-md border-gray-300 pr-2 focus:border-brandBlue-500 focus:ring-brandBlue-500 sm:text-sm",
                                        value: transformationParams.headersInRow + 1 || 1,
                                        onChange: (e)=>handleHeaderRowChange(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                        info: t("headersInRow.tooltip"),
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4653f19041d4d80$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-gray-300",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            allFieldsAssigned && validationErrors.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ea08b9bea77a1bd1$export$2e2bcd8739ae039), {
                                validationErrorArray: validationErrors,
                                setScrollToRow: setScrollToRow,
                                handleOpenPreviewer: handleOpenPreviewer
                            }),
                            pretransformationApplied && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "rounded-md bg-brandBlue-50 px-3 py-1 flex items-center",
                                id: "info-message-transformed",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-brandBlue-400",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "ml-3 flex-1 md:flex md:justify-between md:items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "text-sm text-brandBlue-600",
                                                children: t("fileTransformed")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("fileTransformedUndo"),
                                                onClick: handleUndoTransform,
                                                noFrame: true,
                                                size: "xs",
                                                formatting: "ml-2",
                                                textColor: "text-brandBlue-700",
                                                textColorHover: "text-brandBlue-800"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "inline-flex lg:hidden gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "headerRow",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("headersInRow.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "number",
                                name: "headerRow",
                                id: "headerRow",
                                className: "block w-14 rounded-md border-gray-300 pr-2 focus:border-brandBlue-500 focus:ring-brandBlue-500 sm:text-sm",
                                value: transformationParams.headersInRow + 1 || 1,
                                onChange: (e)=>handleHeaderRowChange(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("headersInRow.tooltip"),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4653f19041d4d80$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-gray-300",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$2d5c5ceac203fc1e), {
                        onDragStart: handleDragStart,
                        onDragEnd: handleDrop,
                        id: "dnd-area",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative w-full h-full",
                            ref: componentRef,
                            children: [
                                previewState && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a89e09b5a73101a$export$2e2bcd8739ae039), {
                                    previewState: previewState,
                                    setPreviewState: setPreviewState,
                                    fileObject: currentFileObject
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "bg-gray-50 w-full h-full flex flex-col justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "w-full bg-gray-50",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex gap-px divide-x divide-gray-200 overflow-x-auto",
                                                id: "data-model-columns-container",
                                                children: columns.map((col, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $33911fdb51874d60$export$2e2bcd8739ae039), {
                                                        col: col.id,
                                                        idx: idx,
                                                        lastInRow: idx === columns.length - 1,
                                                        category: account.category,
                                                        optional: col.optional,
                                                        children: Object.entries(dropState).filter(([key, value])=>key === col.id).map(([key, value])=>{
                                                            const obj = currentFileObject.headers.find((item)=>item.id === value);
                                                            if (!obj) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
                                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c3295dfd83d3a19$export$2e2bcd8739ae039), {
                                                                obj: currentFileObject.headers.find((item)=>item.id === value),
                                                                previewState: previewState,
                                                                setPreviewState: setPreviewState
                                                            }, value);
                                                        })
                                                    }, col.id))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mx-auto text-center text-xs text-gray-500 py-8",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-lg font-bold pb-1",
                                                    children: t("columnMatcherHeader")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "prose text-center text-xs text-gray-400 mx-auto",
                                                    children: t("columnMatcherInfo")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "overflow-x-scroll",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "shadow-sm rounded-lg inset-x-0 bottom-8 mx-auto bg-white overflow-x-scroll",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-3 px-6 py-3 flex gap-5",
                                                    id: "file-columns-container",
                                                    children: (currentFileObject.headers || [])// show only those fileColumns, for which there are no keys in the dropState object or for which the value has been set to null before
                                                    .filter((x)=>!Object.values(dropState).includes(x.id)).map((obj, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c3295dfd83d3a19$export$2e2bcd8739ae039), {
                                                            obj: obj,
                                                            setPreviewState: setPreviewState
                                                        }, idx))
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$aca73479aa40659d), {
                                    children: activeFileColumn ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1c3295dfd83d3a19$export$2e2bcd8739ae039), {
                                        obj: activeFileColumn,
                                        previewState: previewState,
                                        setPreviewState: setPreviewState
                                    }) : null
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
}
$e76bacd9538b4138$var$ColumnMatcherInner.propTypes = {
    currentFileIngested: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    currentFileName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    transformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    updateCurrentFileTransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    currentFilePretransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    updateCurrentFilePretransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    showSkipFileButton: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    skipToNextFile: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    alert: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAlert: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    pretransformationApplied: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setPretransformationApplied: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setScrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $e76bacd9538b4138$export$2e2bcd8739ae039(props) {
    const { account: account, transformationParams: transformationParams, currentFileIngested: currentFileIngested, currentFilePretransformed: currentFilePretransformed, updateCurrentFilePretransformed: updateCurrentFilePretransformed, setPretransformationApplied: setPretransformationApplied } = props;
    // -----------------------------------
    // APPLY SAVED PRETRANSFORMATIONS
    // -----------------------------------
    // we are doing that very early in the component initialisation process, so that we can use those data later on
    (0, $7fPBF.useEffect)(()=>{
        var _account_tags;
        // if currentFilePretransformed is missing, apply the transformations on ingested file (if any) and copy it over to pretransformed
        if (!currentFilePretransformed && ((_account_tags = account.tags) === null || _account_tags === void 0 ? void 0 : _account_tags.applyImportTransformationsAutomatically) !== false && transformationParams.commands && transformationParams.commands.length > 0) {
            // TODO check why this does not work
            const transformedData = (0, $fe589b11915a1b72$export$2e2bcd8739ae039)(currentFileIngested, transformationParams.commands, transformationParams.headersInRow);
            // then set the pretransformed data in the state
            updateCurrentFilePretransformed(JSON.parse(JSON.stringify(transformedData)));
            setPretransformationApplied(true);
        } else if (!currentFilePretransformed) {
            // just set the pretransformed data in the state as a copy of the ingested data
            updateCurrentFilePretransformed(JSON.parse(JSON.stringify(currentFileIngested)));
            setPretransformationApplied(false);
        }
    }, []);
    if (!currentFilePretransformed) return true;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e76bacd9538b4138$var$ColumnMatcherInner, (0, $9tqwB._)({}, props));
}
$e76bacd9538b4138$export$2e2bcd8739ae039.propTypes = {
    currentFileIngested: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    currentFileName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    transformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    updateCurrentFileTransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    currentFilePretransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    updateCurrentFilePretransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    showSkipFileButton: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    skipToNextFile: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    alert: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAlert: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setPretransformationApplied: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    pretransformationApplied: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setScrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







var $765dee1348d7f1ad$exports = {};

$parcel$export($765dee1348d7f1ad$exports, "categoryOrderedObject", function () { return $765dee1348d7f1ad$export$3270e954cce20150; });
$parcel$export($765dee1348d7f1ad$exports, "outputTransformCategoryTransactions", function () { return $765dee1348d7f1ad$export$39b64bc498225d58; });
$parcel$export($765dee1348d7f1ad$exports, "postCategoryItems", function () { return $765dee1348d7f1ad$export$37bc17007772d2e3; });
$parcel$export($765dee1348d7f1ad$exports, "checkIfDuplicate", function () { return $765dee1348d7f1ad$export$2b59d6e48433719f; });
// CATEGORY MODULE FOR DEPOSITS / TRANSACTIONS



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $765dee1348d7f1ad$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function depositsOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            keepFlag: transaction.keepFlag || null,
            source: transaction.source,
            date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            otherParty: transaction.otherParty,
            otherPartyAccount: transaction.otherPartyAccount,
            description: transaction.description,
            accountCurrencyAmount: transaction.accountCurrencyAmount,
            fxCurrency: transaction.fxCurrency,
            fxAmount: transaction.fxAmount,
            fxRate: transaction.fxAmount ? transaction.accountCurrencyAmount / (transaction.fxAmount || 1) : "",
            id: transaction.id,
            currency: transaction.currency,
            label: transaction.label
        };
    };
}
function $765dee1348d7f1ad$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return item;
    };
}
function $765dee1348d7f1ad$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$7da7ab8978d9e8f4)({
        data: data,
        category: "deposits",
        accountId: account.id
    });
}
function $765dee1348d7f1ad$export$2b59d6e48433719f(transaction1, transaction2) {
    return transaction1.source !== transaction2.source // we are checking if imported transactions are already present in the account, we allow duplicates within one source ('app' or 'import')
     && transaction1.date === transaction2.date && transaction1.accountCurrencyAmount === transaction2.accountCurrencyAmount && transaction1.otherPartyAccount === transaction2.otherPartyAccount;
}


var $fe58dc1d48f91c77$exports = {};

$parcel$export($fe58dc1d48f91c77$exports, "categoryOrderedObject", function () { return $fe58dc1d48f91c77$export$3270e954cce20150; });
$parcel$export($fe58dc1d48f91c77$exports, "outputTransformCategoryTransactions", function () { return $fe58dc1d48f91c77$export$39b64bc498225d58; });
$parcel$export($fe58dc1d48f91c77$exports, "postCategoryItems", function () { return $fe58dc1d48f91c77$export$37bc17007772d2e3; });
$parcel$export($fe58dc1d48f91c77$exports, "checkIfDuplicate", function () { return $fe58dc1d48f91c77$export$2b59d6e48433719f; });
// CATEGORY MODULE FOR DEPOSITS / TRANSACTIONS



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $fe58dc1d48f91c77$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function depositsOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            displaySymbol: transaction.displaySymbol,
            displayName: transaction.displayName,
            transactionAmount: transaction.transactionAmount || "",
            transactionOriginalPrice: transaction.transactionOriginalPrice || "",
            transactionCurrency: transaction.transactionCurrency || "",
            id: transaction.id,
            assetId: transaction.assetId
        };
    };
}
function $fe58dc1d48f91c77$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return item;
    };
}
function $fe58dc1d48f91c77$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$7da7ab8978d9e8f4)({
        data: data,
        category: "stocks",
        accountId: account.id
    });
}
function $fe58dc1d48f91c77$export$2b59d6e48433719f(transaction1, transaction2) {
    return transaction1.date === transaction2.date && transaction1.transactionAmount === transaction2.transactionAmount && transaction1.transationOriginalPrice === transaction2.transationOriginalPrice;
}


var $f075cde2b8480bd4$exports = {};

$parcel$export($f075cde2b8480bd4$exports, "categoryOrderedObject", function () { return $f075cde2b8480bd4$export$3270e954cce20150; });
$parcel$export($f075cde2b8480bd4$exports, "outputTransformCategoryTransactions", function () { return $f075cde2b8480bd4$export$39b64bc498225d58; });
$parcel$export($f075cde2b8480bd4$exports, "postCategoryItems", function () { return $f075cde2b8480bd4$export$37bc17007772d2e3; });
$parcel$export($f075cde2b8480bd4$exports, "checkIfDuplicate", function () { return $f075cde2b8480bd4$export$2b59d6e48433719f; });
// CATEGORY MODULE FOR REAL ESTATE QUOTES IMPORT



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $f075cde2b8480bd4$export$3270e954cce20150(account = null, displayedComponent = "table") {
    return function depositsOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            displaySymbol: transaction.displaySymbol,
            displayName: transaction.displayName,
            transactionAmount: transaction.transactionAmount || "",
            transactionOriginalPrice: transaction.transactionOriginalPrice || "",
            transactionCurrency: transaction.transactionCurrency || "",
            id: transaction.id,
            assetId: transaction.assetId
        };
    };
}
function $f075cde2b8480bd4$export$39b64bc498225d58(account = null) {
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return item;
    };
}
function $f075cde2b8480bd4$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$7da7ab8978d9e8f4)({
        data: data,
        category: "realEstate",
        accountId: account.id
    });
}
function $f075cde2b8480bd4$export$2b59d6e48433719f(transaction1, transaction2) {
    return transaction1.date === transaction2.date && transaction1.transactionAmount === transaction2.transactionAmount && transaction1.transationOriginalPrice === transaction2.transationOriginalPrice;
}


var $44178ec8bb711bae$exports = {};

$parcel$export($44178ec8bb711bae$exports, "categoryOrderedObject", function () { return $44178ec8bb711bae$export$3270e954cce20150; });
$parcel$export($44178ec8bb711bae$exports, "outputTransformCategoryTransactions", function () { return $44178ec8bb711bae$export$39b64bc498225d58; });
$parcel$export($44178ec8bb711bae$exports, "postCategoryItems", function () { return $44178ec8bb711bae$export$37bc17007772d2e3; });
$parcel$export($44178ec8bb711bae$exports, "checkIfDuplicate", function () { return $44178ec8bb711bae$export$2b59d6e48433719f; });
// CATEGORY MODULE FOR LOANS / TRANSACTIONS / IMPORT



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $44178ec8bb711bae$export$3270e954cce20150(account = null, displayedComponent = "table") {
    //  outer function takes parameters and returns a CALLBACK function for .map with parameters already in
    return function loansOrdereObjectInnerFunc(transaction) {
        // this has to exactly follow the column order laid out by gridLayout
        return {
            keepFlag: transaction.keepFlag || null,
            source: transaction.source,
            date: displayedComponent === "table" ? Number(transaction.date) : (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(Number(transaction.date)).format(),
            otherPartyIban: transaction.otherPartyIban,
            description: transaction.description,
            quantity: transaction.quantity,
            quantityInterest: transaction.quantityInterest,
            fxCurrency: transaction.transactionCurrency && transaction.uptc ? transaction.transactionCurrency : null,
            fxAmount: transaction.transactionCurrency && transaction.uptc ? transaction.quantity * transaction.uptc : null,
            fxAmountInterest: transaction.transactionCurrency && transaction.uptc ? transaction.quantityInterest * transaction.uptc : null,
            fxRate: transaction.transactionCurrency && transaction.uptc ? transaction.uptc : null,
            id: transaction.id,
            accountCurrency: transaction.accountCurrency
        };
    };
}
function $44178ec8bb711bae$export$39b64bc498225d58(account = null) {
    //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
    return function outputTransformCategoryTransactionsInnerFunc(item) {
        return item;
    };
}
function $44178ec8bb711bae$export$37bc17007772d2e3(data, account) {
    return (0, $f1c3fa004749592f$export$7da7ab8978d9e8f4)({
        data: data,
        category: "loans",
        accountId: account.id
    });
}
function $44178ec8bb711bae$export$2b59d6e48433719f(transaction1, transaction2) {
    return transaction1.source !== transaction2.source // we are checking if imported transactions are already present in the account, we allow duplicates within one source ('app' or 'import')
     && transaction1.date === transaction2.date && transaction1.quantity === transaction2.quantity && transaction1.quantityInterest === transaction2.quantityInterest;
}






function $1022f5d75e2f1a16$var$sortArrayByDateAndSource(a, b) {
    // First sort by descending date
    if (a.date > b.date) return -1;
    if (a.date < b.date) return 1;
    // If dates are the same, sort by ascending source
    if (a.source < b.source) return -1;
    if (a.source > b.source) return 1;
    return 0;
}
function $1022f5d75e2f1a16$var$markDuplicateTransactions(transactions, categoryModule) {
    for(let i = 0; i < transactions.length; i += 1){
        const transaction1 = transactions[i];
        for(let j = i + 1; j < transactions.length; j += 1){
            const transaction2 = transactions[j];
            if (categoryModule.checkIfDuplicate(transaction1, transaction2)) {
                transaction1.isDuplicate = true;
                transaction2.isDuplicate = true;
            }
        }
    }
    return transactions;
}
function $1022f5d75e2f1a16$export$2e2bcd8739ae039({ account: account, displayedComponent: displayedComponent, displayedData: displayedData, handleClick: handleClick, currentFileIngested: currentFileIngested, currentFilePretransformed: currentFilePretransformed, updateCurrentFilePretransformed: updateCurrentFilePretransformed, currentFileTransformed: currentFileTransformed, currentFileName: currentFileName, transformationParams: transformationParams, setTransformationParams: setTransformationParams, fileProcessingComplete: fileProcessingComplete, userChangesPresent: userChangesPresent, setUserChangesPresent: setUserChangesPresent, tableState: tableState, setAccount: setAccount, pretransformationApplied: pretransformationApplied, setPretransformationApplied: setPretransformationApplied, scrollToRow: scrollToRow, setScrollToRow: setScrollToRow }) {
    // expects a concatenated, single array of all transactions from all input files
    // runs the duplicate check; if duplicates found, they are displayed in a Grid for use to take action on
    // if no duplicates found, the data are posted
    let categoryModule;
    switch(account.category){
        case "realEstate":
            categoryModule = $f075cde2b8480bd4$exports;
            break;
        case "stocks":
            categoryModule = $fe58dc1d48f91c77$exports;
            break;
        case "deposits":
            categoryModule = $765dee1348d7f1ad$exports;
            break;
        case "loans":
            categoryModule = $44178ec8bb711bae$exports;
            break;
        default:
            categoryModule = {};
    }
    const [gridData, setGridData] = (0, $7fPBF.useState)([]);
    const [runSave, setRunSave] = (0, $7fPBF.useState)(false); // if this turns to true, the Grid component will execute handleSaveWrapper
    // we are using state to manage that becuase handleSaveWrapper must run in the context of Grid, not here
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const existingTransactionsSelector = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data[account.category].transactions, ($transactions)=>{
        if (displayedComponent === "previewer") return []; // save compute time
        return $transactions.filter((tt)=>tt.accountId === account.id)// (deposits only) handle case when someone already split an imported transaction
        .reduce((prev, curr)=>{
            // this applies only to deposit transactions, so if this is not a deposit transaction, just return it
            if (curr.category !== "deposits") return [
                ...prev,
                curr
            ];
            // first filter out transactions which do not have a parentId
            if (!curr.parentId) return [
                ...prev,
                curr
            ];
            // is the parent transaction already in prev?
            const parentTransactionIndex = prev.findIndex((tt)=>tt.parentId === curr.parentId);
            // if there is none, this transaction is the first one to belong to that parentId supertransaction
            if (parentTransactionIndex === -1) return [
                ...prev,
                curr
            ];
            // otherwise add amount to the already existing parentId supertransaction
            prev.push((0, $2qxEV._)((0, $9tqwB._)({}, prev[parentTransactionIndex]), {
                accountCurrencyAmount: prev[parentTransactionIndex].accountCurrencyAmount + curr.accountCurrencyAmount
            }));
            // date, accountCurrencyAmount and otherPartyAccount are relevant for duplicate check, so we need to update them
            return prev;
        }, []).map((tt)=>(0, $2qxEV._)((0, $9tqwB._)({}, tt), {
                source: "app"
            }));
    }, {
        memoizeOptions: {
            resultEqualityCheck: (0, $7fPBF.shallowEqual)
        }
    });
    const selectExistingTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)(existingTransactionsSelector);
    const selectTransformedData = currentFileTransformed;
    const dataForDuplicateCheck = [
        ...currentFileTransformed.map((tt)=>(0, $2qxEV._)((0, $9tqwB._)({}, tt), {
                keepFlag: true,
                source: "import"
            })),
        ...selectExistingTransactions
    ];
    const gridLayout = displayedComponent === "previewer" ? undefined : (0, $b19957485b14a8c8$export$2e2bcd8739ae039)(account.category, displayedData, "duplicate");
    // -------------------------------
    // PREPARE DATA FOR POST (helper)
    // -------------------------------
    // prepare data for post (used in initialisation when there are no duplicates or after the user does something in Grid)
    // only used in "duplicate" mode
    function prepareTransactionForPost(dataIn) {
        return dataIn// handle transactions that were marked as duplicates (coming from Grid) only
        .map((item)=>{
            const inputTransaction = selectTransformedData.find((transaction)=>transaction.id === item.id);
            const importFlag = "post"; // all imported transactions are new
            return (0, $2qxEV._)((0, $9tqwB._)({}, inputTransaction, item, displayedData === "holdings" && {
                accountId: account.id
            }, account.category === "deposits" && {
                currency: account.currency
            }), {
                importFlag: importFlag
            });
        })// add all transactions that were not duplicates (they should be complete)
        .concat($1022f5d75e2f1a16$var$markDuplicateTransactions(dataForDuplicateCheck, categoryModule).filter((transaction)=>!transaction.isDuplicate)).map(categoryModule.outputTransformCategoryTransactions(account)); // this is here for compatibility with the existing code, but it's not needed for deposits (it does nothing)
    }
    // ----------------------------
    // COMPONENT INITIALISATION
    // ----------------------------
    // duplicates logic: if there are no duplicates, post the data | if there are, setGridData to display them in Grid for the user to take action
    // previewer logic: just take the raw data from state and display them in Grid
    const myRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createRef(false);
    (0, $7fPBF.useEffect)(()=>{
        if (!myRef.current) {
            // quotes bypass duplicate check and head straight to dispatch
            if (displayedComponent === "duplicate" && displayedData === "quotes") {
                myRef.current = true; // set myRef to prevent another run in strict mode
                dispatch((0, $5fdae6729b4c77e7$export$c6fa390c7be98ae9)({
                    body: selectTransformedData,
                    category: account.category,
                    accountId: account.id
                })).then(()=>{
                    fileProcessingComplete(); // in parent component
                });
            } else if (displayedComponent === "duplicate" && selectTransformedData.length > 0) {
                // when this is run the first time after component renders, it already has the data in both selects
                // we can assume the incoming file is not empty (it's checked in DialogSelectFile)
                // run duplicate check
                myRef.current = true; // set myRef to prevent another run in strict mode
                const transactionsWithDuplicateFlag = $1022f5d75e2f1a16$var$markDuplicateTransactions(dataForDuplicateCheck, categoryModule);
                // if duplicates found, display them in a Grid for user to take action on
                // if no duplicates found, post the data
                if (transactionsWithDuplicateFlag.some((transaction)=>transaction.isDuplicate)) {
                    const prepDataForGrid = transactionsWithDuplicateFlag.filter((transaction)=>transaction.isDuplicate).map((_param)=>{
                        var { isDuplicate: isDuplicate } = _param, rest = (0, $bLhVg._)(_param, [
                            "isDuplicate"
                        ]);
                        return rest;
                    }).map(categoryModule.categoryOrderedObject(account, displayedComponent)).sort($1022f5d75e2f1a16$var$sortArrayByDateAndSource);
                    setGridData(prepDataForGrid);
                } else // console.log('Previewer: no duplicates found');
                // post the data
                // isDuplicate, keepFlag and source will be removed by the action creator; filter by keepFlag and source will also be applied there
                // run general transformations from prepAndValidateOutputData (it is also run in Grid for duplicated data, but we need to run it here as well)
                // prepareDataForPost already gets all the non-duplicate transactions from the app and adds them to the data to be posted
                // eslint-disable-next-line no-lonely-if
                if (displayedData === "holdings") {
                    console.log("Previewer: posting data (transaction mode)");
                    dispatch((0, $f1c3fa004749592f$export$7da7ab8978d9e8f4)({
                        data: prepareTransactionForPost([]),
                        category: account.category,
                        accountId: account.id
                    })).then(()=>{
                        console.log("Previewer: file processing complete is about to run");
                        fileProcessingComplete(); // in parent component
                    });
                }
            } else if (displayedComponent === "previewer") {
                myRef.current = true; // set myRef to prevent another run in strict mode
                // currentFileIngested is an array of array, which is acceptable for Grid
                setGridData(currentFilePretransformed);
            }
        }
    }, []);
    // ------------------
    // TRANSFORM OUTPUT
    // ------------------
    // in "previewer" mode we will need to see array of array as output; in "duplocate" mode we need array of objects with proper formatting (for subsequent posting to backend)
    // (needed by Grid, needs gridLayout from context)
    function prepAndValidateOutputData(data) {
        // transform data from Grid to the "canonical" format in duplicate mode, but leave them be in previewer mode
        if (displayedComponent === "duplicate") {
            const transformedData = data.filter((row)=>row.join("").length > 0) // remove completely empty rows
            .map((row)=>gridLayout.reduce((prev, curr, idx)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                        [curr.id]: row[idx]
                    }), {})); // convert array of arrays to array of objects
            // remove grid formatting
            const dataAfterReformatting = $ddc3e461ba9aa601$export$3962e06959b24991(transformedData, gridLayout);
            // perform category-specific transformations, add importFlag
            const dataAfterCategorySpeficicTransformations = prepareTransactionForPost(dataAfterReformatting);
            return {
                status: "success",
                data: dataAfterCategorySpeficicTransformations
            };
        }
        if (displayedComponent === "previewer") {
            const transformedData = data.filter((row)=>row.join("").length > 0); // remove completely empty rows
            return {
                status: "success",
                data: transformedData
            };
        }
        return {
            status: "error",
            data: []
        };
    }
    // ------------------------------------------------
    // SEND ACTION HISTORY RECORDED BY GRID TO PARENT
    // ------------------------------------------------
    function postActionHistory(data) {
        // Grid will send it back here before saving
        // format is [{ command: 'deleteRows', args: [[1,2,3], true, false] }, ...]
        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                mappingSteps: data
            }));
    }
    // ----------------------------
    // PREPARE GRID SAVE FUNCTION
    // ----------------------------
    // in "duplicate" mode we can use the regular process with postCategoryItems function being imported from state through the categoryModule and passed to Grid
    // in "previewer" mode we need to return data to state of the parent component, which is category-independent, so let's just do it here for now
    let customPostCategoryItems;
    switch(displayedComponent){
        case "duplicate":
            customPostCategoryItems = categoryModule.postCategoryItems;
            break;
        case "previewer":
            // update the state of the parent component (ImportFile) with Grid's output
            customPostCategoryItems = (data)=>{
                // reattach rows above headers (we want to keep headersInRows for pretransformation next time user uploads the file)
                // deep copy handled in the function
                updateCurrentFilePretransformed(gridData.slice(0, transformationParams.headersInRow || 0).concat(data));
                return {
                    status: "success"
                }; // for compatibility with dispatch in Grid
            };
            break;
        default:
            customPostCategoryItems = ()=>{};
    }
    // -------------------------------
    // HANDLE UNDO PRETRANSFORMATION
    // -------------------------------
    // copy back ingested to pretransformed
    // CAUTION: similar function is in ColumnMatcher, consider reflecting updates there as well
    function handleUndoTransform() {
        updateCurrentFilePretransformed(JSON.parse(JSON.stringify(currentFileIngested))); // copy ingested to pretransformed
        setGridData(JSON.parse(JSON.stringify(currentFileIngested))); // update Grid data (try to create a deep copy)
        // reset commands
        setTransformationParams((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                commands: []
            }));
        setPretransformationApplied(false);
        window.dispatchEvent(new CustomEvent("gridReloadData", {
            detail: currentFileIngested
        })); // pass memory reference with event (tried passing gridData via props, but it is too slow)
    }
    // ------------------
    // RENDER COMPONENT
    // ------------------
    if (gridData.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "w-full h-full grid grid-cols-1 place-items-center gap-2",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
            className: "text-gray-500 mx-auto h-5 w-5 animate-spin"
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-2 sm:mt-0 rounded-md bg-white px-4 py-2 flex items-center space-x-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c4382dbe971fd630$export$2e2bcd8739ae039), {
                        className: "h-6 w-6 text-gray-500",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "text-xl md:text-2xl font-bold text-gray-700 break-all",
                        children: currentFileName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                buttonsToShow: [
                    "grid",
                    "save",
                    "cancel"
                ].concat(displayedComponent === "previewer" ? [
                    "decimalChar",
                    "headersInRow",
                    pretransformationApplied ? "infoTransformed" : "infoSave"
                ] : [
                    "infoDuplicate"
                ]),
                displayedComponent: displayedComponent,
                displayedData: displayedData,
                handleClick: handleClick,
                handleSave: ()=>setRunSave(true),
                userChangesPresent: userChangesPresent,
                afterCancelGoTo: displayedComponent === "duplicate" ? "table" : "column",
                setTransformationParams: setTransformationParams,
                transformationParams: transformationParams,
                handleUndoTransform: handleUndoTransform,
                hideBottomBorder: true
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aa56e6ca1b280614$export$2e2bcd8739ae039), {
                account: account,
                setAccount: setAccount,
                data: gridData,
                gridLayout: gridLayout,
                prepAndValidateOutputData: prepAndValidateOutputData,
                postCategoryItems: customPostCategoryItems,
                tableState: tableState,
                displayedComponent: displayedComponent,
                handleClick: handleClick,
                userChangesPresent: userChangesPresent,
                setUserChangesPresent: setUserChangesPresent,
                runSave: runSave,
                setRunSave: setRunSave,
                afterCancelGoTo: displayedComponent === "duplicate" ? "table" : "column",
                postActionHistory: displayedComponent === "duplicate" ? null : postActionHistory,
                customFilter: displayedComponent === "duplicate" ? null : true,
                transformationParams: transformationParams,
                setTransformationParams: setTransformationParams,
                scrollToRow: scrollToRow,
                setScrollToRow: setScrollToRow
            })
        ]
    });
}
$1022f5d75e2f1a16$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    displayedData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    currentFileIngested: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    currentFilePretransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    updateCurrentFilePretransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    currentFileTransformed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    currentFileName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setTransformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    transformationParams: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    fileProcessingComplete: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    userChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setUserChangesPresent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    tableState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    pretransformationApplied: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    setPretransformationApplied: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    scrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    setScrollToRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$1022f5d75e2f1a16$export$2e2bcd8739ae039.defaultProps = {
    currentFileIngested: [],
    currentFilePretransformed: [],
    updateCurrentFilePretransformed: ()=>{},
    currentFileTransformed: [],
    setTransformationParams: ()=>{},
    transformationParams: {},
    pretransformationApplied: null,
    setPretransformationApplied: ()=>{},
    scrollToRow: null,
    setScrollToRow: ()=>{}
};


function $b716af4138d41e40$export$2e2bcd8739ae039(props) {
    var _account_importFileMappings, _account_importFileMappings1, _account_importFileMappings2, _account_importFileMappings3, _account_importFileMappings4, _account_importFileMappings5;
    const { displayedComponent: displayedComponent, account: account } = props;
    const defaultTransformationParams = (0, $2qxEV._)((0, $9tqwB._)({}, account.importFileMappings), {
        mappings: ((_account_importFileMappings = account.importFileMappings) === null || _account_importFileMappings === void 0 ? void 0 : _account_importFileMappings.mappings) || {},
        headersInRow: ((_account_importFileMappings1 = account.importFileMappings) === null || _account_importFileMappings1 === void 0 ? void 0 : _account_importFileMappings1.headersInRow) || null,
        decimalChar: ((_account_importFileMappings2 = account.importFileMappings) === null || _account_importFileMappings2 === void 0 ? void 0 : _account_importFileMappings2.decimalChar) || ",",
        dateFormat: ((_account_importFileMappings3 = account.importFileMappings) === null || _account_importFileMappings3 === void 0 ? void 0 : _account_importFileMappings3.dateFormat) || "YYYY-MM-DD",
        commands: ((_account_importFileMappings4 = account.importFileMappings) === null || _account_importFileMappings4 === void 0 ? void 0 : _account_importFileMappings4.commands) || [],
        filters: ((_account_importFileMappings5 = account.importFileMappings) === null || _account_importFileMappings5 === void 0 ? void 0 : _account_importFileMappings5.filters) || []
    });
    const [fileNames, setFileNames] = (0, $7fPBF.useState)([]); // array - for each file -- array of string
    const [currentFileIdx, setCurrentFileIdx] = (0, $7fPBF.useState)(0); // number - index of the current file being processed
    const [ingested, setIngested] = (0, $7fPBF.useState)(null); // array - for each file -- array (rows) of arrays (fields of a row)
    const [pretransformed, setPretransformed] = (0, $7fPBF.useState)(null); // array - for each file -- array (rows) of arrays (fields of a row)
    const [transformed, setTransformed] = (0, $7fPBF.useState)(null); // array - for each file -- array (rows) of objects (fields of a row)
    const [transformationParams, setTransformationParams] = (0, $7fPBF.useState)(defaultTransformationParams); // object - for account -- object of transformation params
    const [scrollToRow, setScrollToRow] = (0, $7fPBF.useState)(null); // number - index of the row to scroll to on opening Previewer
    // ↑↑ used to take user from ColumnMatch > errors directly to where the error can be fixed
    const [pretransformationApplied, setPretransformationApplied] = (0, $7fPBF.useState)(null); // boolean - whether the pretransformation has been applied (applied by ColumnMatcher on init)
    const currentFileIngested = ingested === null || ingested === void 0 ? void 0 : ingested[currentFileIdx];
    const currentFilePretransformed = pretransformed === null || pretransformed === void 0 ? void 0 : pretransformed[currentFileIdx];
    const currentFileTransformed = transformed === null || transformed === void 0 ? void 0 : transformed[currentFileIdx];
    const currentFileName = fileNames === null || fileNames === void 0 ? void 0 : fileNames[currentFileIdx];
    function updateCurrentFileTransformed(payload) {
        const newTransformed = JSON.parse(JSON.stringify(transformed)) || [];
        newTransformed[currentFileIdx] = JSON.parse(JSON.stringify(payload));
        setTransformed(newTransformed);
    }
    function updateCurrentFilePretransformed(payload) {
        const newPretransformed = JSON.parse(JSON.stringify(pretransformed)) || [];
        newPretransformed[currentFileIdx] = JSON.parse(JSON.stringify(payload)); // FIXME where do we do the copy?
        setPretransformed(newPretransformed);
    }
    function nextFile() {
        if (ingested && currentFileIdx + 1 < ingested.length) {
            // reset file-related state
            setCurrentFileIdx(currentFileIdx + 1); // not using (prev) => to handle strict mode double execution in dev
            // eslint-disable-next-line react/destructuring-assignment
            props.handleClick("column");
        }
    }
    function fileProcessingComplete() {
        // if this is not the last file, move to the next file
        if (ingested && currentFileIdx + 1 < ingested.length) nextFile();
        else // eslint-disable-next-line react/destructuring-assignment
        props.handleClick("table");
    }
    // show the skip file button if there is more than one file and the current file is not the last one
    // if the user wants to skip the last one, they can cancel
    const showSkipFileButton = ingested && ingested.length > 1 && currentFileIdx + 1 < ingested.length;
    switch(displayedComponent){
        case "import":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1b04cee8673a582a$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                setIngested: setIngested,
                setFileNames: setFileNames
            }));
        case "column":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e76bacd9538b4138$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                currentFileIngested: currentFileIngested,
                currentFileName: currentFileName,
                currentFilePretransformed: currentFilePretransformed,
                updateCurrentFilePretransformed: updateCurrentFilePretransformed,
                transformationParams: transformationParams,
                setTransformationParams: setTransformationParams,
                updateCurrentFileTransformed: updateCurrentFileTransformed,
                showSkipFileButton: showSkipFileButton,
                skipToNextFile: nextFile,
                setPretransformationApplied: setPretransformationApplied,
                setScrollToRow: setScrollToRow,
                pretransformationApplied: pretransformationApplied
            }));
        case "duplicate":
            // prettier-ignore
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1022f5d75e2f1a16$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                currentFileName: currentFileName,
                currentFileTransformed: currentFileTransformed,
                updateCurrentFileTransformed: updateCurrentFileTransformed,
                fileProcessingComplete: fileProcessingComplete
            }));
        case "previewer":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1022f5d75e2f1a16$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                currentFileName: currentFileName,
                currentFilePretransformed: currentFilePretransformed,
                currentFileIngested: currentFileIngested,
                updateCurrentFilePretransformed: updateCurrentFilePretransformed,
                transformationParams: transformationParams,
                setTransformationParams: setTransformationParams,
                scrollToRow: scrollToRow,
                setScrollToRow: setScrollToRow,
                pretransformationApplied: pretransformationApplied,
                setPretransformationApplied: setPretransformationApplied
            }));
        default:
            return true;
    }
}
$b716af4138d41e40$export$2e2bcd8739ae039.propTypes = {
    displayedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


/* eslint-disable max-len */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/control-has-associated-label */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");




/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







function $857542ca8a716c50$export$2e2bcd8739ae039({ propAccount: propAccount }) {
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // need to get account information from redux store, as the prop is not updated in Tile when the account object changes in store
    const account = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data[propAccount.category].accounts).filter((a)=>a.id === propAccount.id)[0];
    const tags = typeof account.tags === "string" ? JSON.parse(account.tags) : account.tags;
    const growthRate = tags === null || tags === void 0 ? void 0 : tags.growthRate;
    const { register: register, handleSubmit: handleSubmit, formState: { touchedFields: touchedFields } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            growthRate: growthRate
        }
    });
    async function onSubmit(data) {
        setLoading(true);
        const response = await dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
            data: (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                importFlag: "put",
                tags: (0, $9tqwB._)({}, tags, data)
            }),
            category: account.category
        }));
        if (response.meta.requestStatus === "fulfilled") {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountUpdatedSuccessfully", account.id));
        } else {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated", account.id));
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-4 grid grid-cols-6 gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "col-span-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "mt-1 text-xs xs:text-sm text-gray-500",
                    children: t("accountDetails:settings.simulatedAccountGrowth.description")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "col-span-4 sm:col-span-2 sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "first-name",
                        className: "block text-sm font-medium text-gray-700",
                        children: t("accountDetails:settings.simulatedAccountGrowth.fieldLabel")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-baseline space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                type: "number",
                                name: "growthRate",
                                id: "growthRate",
                                placeholder: 1.25,
                                step: 0.01,
                                // eslint-disable-next-line max-len
                                className: "mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 text-sm placeholder:text-gray-200 placeholder:italic"
                            }, register("growthRate", {
                                required: {
                                    value: true,
                                    message: "Please specify a growth rate."
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "%"
                            })
                        ]
                    }),
                    touchedFields.growthRate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("accountDetails:buttons.save.label"),
                        onClick: handleSubmit(onSubmit),
                        spinnerOn: loading,
                        withAccent: true,
                        formatting: "mt-4"
                    })
                ]
            })
        ]
    });
}
$857542ca8a716c50$export$2e2bcd8739ae039.propTypes = {
    propAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







function $0a68a576c9b836df$var$AccountComponent({ accountName: accountName, index: index, selected: selected, handleClick: handleClick }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                className: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3",
                children: accountName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                className: "whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    type: "checkbox",
                    className: "text-brandBlue-500",
                    checked: selected,
                    onChange: (e)=>handleClick(index)
                })
            })
        ]
    });
}
$0a68a576c9b836df$var$AccountComponent.propTypes = {
    accountName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$0a68a576c9b836df$var$AccountComponent.defaultProps = {
    selected: false
};
function $0a68a576c9b836df$export$2e2bcd8739ae039({ account: account }) {
    const [valuationSlots, setValuationSlots] = (0, $7fPBF.useState)([]);
    const [tickboxes, setTickboxes] = (0, $7fPBF.useState)([]);
    const [touched, setTouched] = (0, $7fPBF.useState)(false);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.realEstate.accounts);
    const accountsWithValuationSlots = accounts.filter((a)=>{
        var _a_tags;
        return (_a_tags = a.tags) === null || _a_tags === void 0 ? void 0 : _a_tags.nextValuationDate;
    });
    // get valuationSlots from Cognito on initialisation
    (0, $7fPBF.useEffect)(()=>{
        (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
            forceRefresh: true
        }).then((user)=>{
            const result = JSON.parse(user.attributes["custom:valuation_slots"] || "[]");
            setValuationSlots(result);
        }).catch((err)=>console.error(err));
    }, []);
    // initialise tickboxes
    (0, $7fPBF.useEffect)(()=>{
        setTickboxes(accounts.map((a)=>{
            var _a_tags;
            return (_a_tags = a.tags) === null || _a_tags === void 0 ? void 0 : _a_tags.nextValuationDate;
        }));
    }, [
        accounts
    ]);
    const unusedValuations = valuationSlots.length - tickboxes.filter((tickbox)=>tickbox).length;
    const tooManySelections = tickboxes.filter((tickbox)=>tickbox).length > valuationSlots.length;
    function handleClick(index) {
        setTouched(true);
        // set the indexth element of tickboxes to the opposite of what it is now
        const newTickboxes = [
            ...tickboxes
        ];
        newTickboxes[index] = !newTickboxes[index];
        setTickboxes(newTickboxes);
    }
    async function onSubmit() {
        // we submit only if tooManySelections is false
        if (!tooManySelections) {
            setLoading(true);
            // tickboxes:
            // - false --> user clicked on it --> remove nextValuationDate from tags
            // - true --> user selected it for updates --> add nextValuationDate to tags
            // - undefined --> no valuation date and no change (skip)
            const category = "realEstate";
            const promises = tickboxes.map((tickbox, index)=>{
                if (tickbox === true) {
                    const accountToUpdate = accounts[index];
                    const tags = accountToUpdate.tags || {};
                    // eslint-disable-next-line max-len
                    return dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                        category: category,
                        data: (0, $2qxEV._)((0, $9tqwB._)({}, accountToUpdate), {
                            importFlag: "put",
                            tags: (0, $2qxEV._)((0, $9tqwB._)({}, tags), {
                                nextValuationDate: (0, $96a84f48caa04ee8$export$c2d820eaab724b69)(accountsWithValuationSlots, valuationSlots)
                            })
                        })
                    }));
                }
                if (tickbox === false) {
                    const accountToUpdate = accounts[index];
                    const tags = (0, $9tqwB._)({}, accountToUpdate.tags);
                    delete tags.nextValuationDate;
                    return dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                        category: category,
                        data: (0, $2qxEV._)((0, $9tqwB._)({}, accountToUpdate), {
                            importFlag: "put",
                            tags: tags
                        })
                    }));
                }
                return null;
            });
            const responses = await Promise.allSettled(promises);
            console.log(JSON.stringify(responses, null, 2));
            if (responses.every((response)=>response.status === "fulfilled")) {
                setLoading(false);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountUpdatedSuccessfully", account.id));
            } else {
                setLoading(false);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated", account.id));
            }
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "col-span-4 md:col-span-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "pb-4 text-sm text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: `You can update ${valuationSlots.length} account(s) automatically.`
                    }),
                    tooManySelections ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: `${tooManySelections ? "text-red-500" : ""}`,
                        children: "Too many accounts are selected."
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: `Unused valuations: ${unusedValuations}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                className: "divide-y divide-gray-300",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3",
                                    children: "Account"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
                                    children: "Updated automatically"
                                })
                            ]
                        })
                    }),
                    accounts.map((a, index)=>$0a68a576c9b836df$var$AccountComponent({
                            accountName: a === null || a === void 0 ? void 0 : a.name,
                            index: index,
                            selected: tickboxes[index],
                            handleClick: handleClick
                        }))
                ]
            }),
            touched && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                onClick: onSubmit,
                // eslint-disable-next-line max-len
                className: "mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                children: !loading ? t("accountDetails.buttons.save.label") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                    className: "w-5 h-5 animate-spin"
                })
            })
        ]
    });
}
$0a68a576c9b836df$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






function $b6cfba8959af2d53$export$2e2bcd8739ae039({ propAccount: propAccount }) {
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // need to get account information from redux store, as the prop is not updated in Tile when the account object changes in store
    const account = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data[propAccount.category].accounts).filter((a)=>a.id === propAccount.id)[0];
    const tags = typeof account.tags === "string" ? JSON.parse(account.tags) : account.tags;
    const growthRate = tags === null || tags === void 0 ? void 0 : tags.growthRate;
    const { register: register, handleSubmit: handleSubmit, formState: { touchedFields: touchedFields } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            growthRate: growthRate
        }
    });
    async function onSubmit(data) {
        setLoading(true);
        const response = await dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
            data: (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                importFlag: "put",
                tags: (0, $9tqwB._)({}, tags, data)
            }),
            category: account.category
        }));
        if (response.meta.requestStatus === "fulfilled") {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountUpdatedSuccessfully", account.id));
        } else {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated", account.id));
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-4 grid grid-cols-6 gap-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "col-span-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "mt-1 text-xs xs:text-sm text-gray-500",
                    children: t("accountDetails:settings.spread.description")
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "col-span-4 sm:col-span-2 sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "first-name",
                        className: "block text-sm font-medium text-gray-700",
                        children: t("accountDetails:settings.spread.label")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-baseline space-x-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                type: "number",
                                name: "spread",
                                id: "spread",
                                placeholder: 10,
                                step: 0.01,
                                // eslint-disable-next-line max-len
                                className: "mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 text-sm placeholder:text-gray-200 placeholder:italic"
                            }, register("spread", {
                                required: {
                                    value: true,
                                    message: "Please specify a spread."
                                }
                            }))),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: "%"
                            })
                        ]
                    }),
                    touchedFields.growthRate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: handleSubmit(onSubmit),
                        // eslint-disable-next-line max-len
                        className: "mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                        children: !loading ? t("accountDetails:buttons.save.label") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 animate-spin"
                        })
                    })
                ]
            })
        ]
    });
}
$b6cfba8959af2d53$export$2e2bcd8739ae039.propTypes = {
    propAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






/* eslint-disable max-len */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");











function $923e87fa9ab4eff2$export$5390abe531a4aa4a({ register: register, fields: fields, append: append, remove: remove, control: control, touchedFields: touchedFields, handleSubmit: handleSubmit, reset: reset, account: account }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // get a list of all assetIds in the transactions (also simulated in the future) to show in the dropdown
    // also get whatever friendly name user used for the symbol
    const uniqueFigis = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $3679aa7475d9bd44$export$7cd09fd23199c464)(state)).filter((item)=>item.category === "stocks").reduce((acc, curr)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [curr.assetId]: curr.displayName
        }), {});
    async function onSubmit(data) {
        // on submit of the form, update the account details
        setLoading(true);
        const response = await dispatch((0, $f1c3fa004749592f$export$64ebf73f0218161c)({
            data: {
                dividendYield: data.dividendYield,
                dividendYieldRates: data.dividendYieldRates,
                dividendYieldAdvancedMode: data.dividendYieldAdvancedMode
            },
            category: "stocks"
        }));
        if (response.meta.requestStatus === "fulfilled") {
            reset();
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountUpdatedSuccessfully", account.id));
        } else {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated", account.id));
        }
    // console.log('AccountSettings > response dispatch', response);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-2 space-x-4 text-xs xs:text-sm text-gray-700",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: t("settings.symbol")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("simulatedAccountGrowth.dividendTooltip"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t("settings.dividend")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "ml-2 px-1.5 rounded-full bg-white border-[1px] border-gray-300 text-gray-300 text-xs font-bold",
                                    children: "i"
                                })
                            ]
                        })
                    })
                ]
            }),
            fields.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-2 space-x-4 text-sm xs:text-base",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            name: `dividendYieldRates.${index}.symbol`,
                            control: control,
                            render: ({ field: field, ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: "",
                                    value: field.value.name,
                                    list: Object.keys(uniqueFigis).map((figi)=>({
                                            id: figi,
                                            name: uniqueFigis[figi] || figi
                                        })),
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    inputRef: ref,
                                    optional: false
                                })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex space-x-3 items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    name: `value${index}`,
                                    id: `value${index}`,
                                    placeholder: 1.25,
                                    step: 0.01,
                                    className: "mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                }, register(`dividendYieldRates.${index}.value`))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    className: "inline-flex items-center px-1 py-1 mt-1 border border-gray-300 text-xs font-medium rounded-md shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900",
                                    onClick: ()=>remove(index),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        })
                    ]
                }, item.symbol)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex space-x-2",
                children: [
                    fields.length < Object.keys(uniqueFigis).length && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        className: "mt-4 inline-flex text-gray-400 items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900",
                        onClick: ()=>append({
                                symbol: "",
                                value: 0.15
                            }),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc348e8ecf02df23$export$2e2bcd8739ae039), {
                                className: "h-4 w-4",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: t("settings.add")
                            })
                        ]
                    }),
                    (touchedFields === null || touchedFields === void 0 ? void 0 : touchedFields.dividendYieldRates) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: handleSubmit(onSubmit),
                        className: "mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                        children: !loading ? t("buttons.save.label") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 animate-spin"
                        })
                    })
                ]
            })
        ]
    });
}
$923e87fa9ab4eff2$export$5390abe531a4aa4a.propTypes = {
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    fields: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    append: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    remove: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    reset: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    touchedFields: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
function $923e87fa9ab4eff2$export$2e2bcd8739ae039({ propAccount: propAccount }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const selectBaseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const baseCurrency = (0, $7fPBF.useMemo)(()=>selectBaseCurrency, [
        selectBaseCurrency
    ]);
    // need to get account information from redux store, as the prop is not updated in Tile when the account object changes in store
    const account = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data[propAccount.category].accounts).filter((a)=>a.id === propAccount.id)[0];
    const tags = typeof account.tags === "string" ? JSON.parse(account.tags) : account.tags;
    // stock settings for dividendYieldRates are stored centrally for all accounts in stocks.settings
    // growthRate is an account-level setting and is stored as account tag (also for stocks)
    let dividendYieldRates;
    let dividendYield;
    let dividendYieldAdvancedMode;
    // let growthRate; // 240625 FIX: removing growthRate from this component, as it is not used for categories with assets (stocks, crypto) --> only category- and asset-level settings are used
    if (account.category === "stocks") {
        dividendYieldRates = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
            var _state_data_stocks_settings;
            return (_state_data_stocks_settings = state.data.stocks.settings) === null || _state_data_stocks_settings === void 0 ? void 0 : _state_data_stocks_settings.dividendYieldRates;
        });
        dividendYield = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
            var _state_data_stocks_settings;
            return (_state_data_stocks_settings = state.data.stocks.settings) === null || _state_data_stocks_settings === void 0 ? void 0 : _state_data_stocks_settings.dividendYield;
        });
        dividendYieldAdvancedMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
            var _state_data_stocks_settings;
            return (_state_data_stocks_settings = state.data.stocks.settings) === null || _state_data_stocks_settings === void 0 ? void 0 : _state_data_stocks_settings.dividendYieldAdvancedMode;
        });
    // growthRate = tags?.growthRate;
    }
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitted: isSubmitted, touchedFields: touchedFields }, control: control, watch: watch, reset: reset } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            dividendYieldRates: // growthRate,
            dividendYieldRates,
            dividendYield: dividendYield,
            dividendYieldAdvancedMode: dividendYieldAdvancedMode
        }
    });
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "dividendYieldRates",
        control: control
    });
    async function onSubmit(data) {
        // on submit of the form, update the account details
        setLoading(true);
        const response = await dispatch(// putStocksSettings will spread the new values over the entire existing object
        (0, $f1c3fa004749592f$export$64ebf73f0218161c)({
            data: {
                dividendYield: data.dividendYield,
                dividendYieldRates: data.dividendYieldRates,
                dividendYieldAdvancedMode: data.dividendYieldAdvancedMode
            },
            category: "stocks"
        }));
        if (response.meta.requestStatus === "fulfilled") {
            reset();
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountUpdatedSuccessfully", account.id));
        } else {
            setLoading(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated", account.id));
        }
    // console.log('AccountSettings > response dispatch', response);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:max-w-sm col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        control: control,
                        name: "dividendYieldAdvancedMode",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                as: "div",
                                className: "flex items-center justify-start w-full",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                        as: "span",
                                        className: "mr-3",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: "Simple"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), (0, $2qxEV._)((0, $9tqwB._)({}, field), {
                                        checked: field.value,
                                        onChange: field.onChange,
                                        className: `${field.value ? "bg-brandBlue-500" : "bg-gray-200"} relative inline-flex flex-shrink-0 h-6 w-11 border-2
                      border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: `${field.value ? "translate-x-5" : "translate-x-0"}
                          pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`
                                        })
                                    })),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                        as: "span",
                                        className: "ml-3",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: "Advanced"
                                        })
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-4 text-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-700 text-sm",
                                children: t("accountDetails:settings.dividend")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex space-x-2 items-center pt-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                        type: "number",
                                        step: "0.01",
                                        name: "dividendYield",
                                        id: "dividendYield"
                                    }, register("dividendYield", {
                                        valueAsNumber: true
                                    })), {
                                        className: "mt-0.5 flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 placeholder:text-gray-200 placeholder:italic"
                                    })),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: "%"
                                    })
                                ]
                            }),
                            errors.dividendYield && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: errors.dividendYield.message
                                })
                            }),
                            (touchedFields === null || touchedFields === void 0 ? void 0 : touchedFields.dividendYield) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                onClick: handleSubmit(onSubmit),
                                className: "mt-4 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brandBlue-500 hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400",
                                children: !loading ? t("accountDetails:buttons.save.label") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 animate-spin"
                                })
                            })
                        ]
                    })
                ]
            }),
            watch("dividendYieldAdvancedMode") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "sm:col-span-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($923e87fa9ab4eff2$export$5390abe531a4aa4a, {
                    fields: fields,
                    append: append,
                    remove: remove,
                    register: register,
                    control: control,
                    touchedFields: touchedFields,
                    handleSubmit: handleSubmit,
                    onSubmit: onSubmit,
                    reset: reset,
                    account: account
                })
            })
        ]
    });
}
$923e87fa9ab4eff2$export$2e2bcd8739ae039.propTypes = {
    propAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};






(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $590084312c25d5d6$export$2e2bcd8739ae039({ setIsDirty: setIsDirty }) {
    const [updating, setUpdating] = (0, $7fPBF.useState)(false);
    const selectStockSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.stocks.settings);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "simulations"
    });
    // default settings updated in getSettings (centrally)
    const { register: register, control: control, watch: watch, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isDirty: isDirty } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: (0, $9tqwB._)({}, (0, $6bea581af4ee4124$export$568554344c31bfb8), selectStockSettings)
    }); // intialised after useEffect fetches data from Amplify store
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "dividendYieldRates",
        control: control
    });
    // keep parent's isDirty state in sync with the form's isDirty state, so that a warning can be shown when the user tries to navigate away without saving
    (0, $7fPBF.useEffect)(()=>{
        setIsDirty(isDirty);
    }, [
        isDirty
    ]);
    async function onSubmit(data) {
        // if the form is dirty, update the entire object (as it would have otherwise been added by redux)
        if (isDirty) {
            setUpdating(true);
            try {
                await dispatch((0, $f1c3fa004749592f$export$64ebf73f0218161c)({
                    data: data,
                    category: "stocks"
                }));
                reset(data);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            } catch (error) {
                console.error(error);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            }
            setUpdating(false);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-3 sm:grid sm:grid-cols-6 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: t("stockDividends")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("stockDividendsDescription")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("stockDividendsDescription2")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("dividendYield")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        control: control,
                        name: "dividendYieldAdvancedMode",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                as: "div",
                                className: "flex items-center justify-start w-full",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                        as: "span",
                                        className: "mr-3",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: t("simple")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), (0, $2qxEV._)((0, $9tqwB._)({}, field), {
                                        checked: field.value,
                                        onChange: field.onChange,
                                        className: `${field.value ? "bg-brandBlue-500" : "bg-gray-200"} relative inline-flex flex-shrink-0 h-6 w-11 border-2
                      border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-600`,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: `${field.value ? "translate-x-5" : "translate-x-0"}
                          pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`
                                        })
                                    })),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                        as: "span",
                                        className: "ml-3",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: t("advanced")
                                        })
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-500",
                                children: t("dividendYield")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                type: "number",
                                step: "0.01",
                                name: "dividendYield",
                                id: "dividendYield"
                            }, register("dividendYield", {
                                valueAsNumber: true
                            })), {
                                className: "mt-0.5 flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                            })),
                            errors.dividendYield && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: errors.dividendYield.message
                                })
                            })
                        ]
                    })
                ]
            }),
            watch("dividendYieldAdvancedMode") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "sm:col-span-3",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $923e87fa9ab4eff2$export$5390abe531a4aa4a), {
                    fields: fields,
                    append: append,
                    remove: remove,
                    register: register,
                    control: control
                })
            }),
            isDirty && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-end space-x-2 sm:col-start-3 mt-4",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    type: "button",
                    onClick: handleSubmit(onSubmit),
                    text: t("save"),
                    spinnerOn: updating,
                    id: "settings-planning-save",
                    withAccent: true,
                    size: "lg"
                })
            })
        ]
    });
}
$590084312c25d5d6$export$2e2bcd8739ae039.propTypes = {
    setIsDirty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");









function $8cc41af0e88c481d$export$2e2bcd8739ae039({ register: register, fields: fields, append: append, remove: remove, control: control, assetList: assetList, namePrefix: namePrefix }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "settings"
    });
    // get a list of all figis in the transactions (also simulated in the future) to show in the dropdown
    // also get whatever friendly name user used for the symbol
    // NOTE: this used to be globalTransactionViewNoTimeLimit 2
    const dropdownSource = assetList.length > 0 ? assetList.reduce((acc, curr)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [curr.assetId]: curr.displayName
        }), {}) : (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $3679aa7475d9bd44$export$cff1b0a315c5dec8)(state)).filter((transaction)=>transaction.category === (namePrefix ? "crypto" : "stocks")).reduce((acc, curr)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
            [curr.assetId]: curr.displayName
        }), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "col-span-2 grid grid-cols-1",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-2 space-x-4 text-sm text-gray-700",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "mb-1",
                        children: t("symbol")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("simulatedAccountGrowth.dividendTooltip"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t("growthRate")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "ml-2 px-1.5 rounded-full bg-white border-[1px] border-gray-300 text-gray-300 text-xs font-bold",
                                    children: "i"
                                })
                            ]
                        })
                    })
                ]
            }),
            fields.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-2 space-x-4 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            name: `${namePrefix}growthRates.${index}.symbol`,
                            control: control,
                            render: ({ field: field, ref: ref })=>{
                                var _field_value;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: "",
                                    value: (_field_value = field.value) === null || _field_value === void 0 ? void 0 : _field_value.name,
                                    list: Object.keys(dropdownSource).filter((obj)=>!fields.map((f)=>f.symbol).includes(obj)) // remove those already in the array
                                    .map((obj)=>({
                                            id: obj,
                                            name: dropdownSource[obj] || obj
                                        })),
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    inputRef: ref,
                                    optional: false
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex space-x-3 items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    name: `${namePrefix}value${index}`,
                                    id: `${namePrefix}value${index}`,
                                    placeholder: 5.5,
                                    step: 0.01,
                                    className: "block max-w-xs rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                }, register(`${namePrefix}growthRates.${index}.value`))),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    type: "button",
                                    onClick: ()=>remove(index),
                                    size: "sm",
                                    Icon: (0, $341a41b70f0b63cc$export$2e2bcd8739ae039),
                                    textColor: "text-gray-400",
                                    textColorHover: "text-gray-500"
                                })
                            ]
                        })
                    ]
                }, item.symbol)),
            fields.length < Object.keys(dropdownSource).length && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                formatting: "mt-3 inline w-20",
                type: "button",
                onClick: ()=>append({
                        symbol: "",
                        value: 0.15
                    }),
                size: "sm",
                Icon: (0, $dc348e8ecf02df23$export$2e2bcd8739ae039),
                text: t("add"),
                textColor: "text-gray-400",
                textColorHover: "text-gray-500"
            })
        ]
    });
}
$8cc41af0e88c481d$export$2e2bcd8739ae039.propTypes = {
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    fields: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    })).isRequired,
    append: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    remove: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
        })
    }).isRequired,
    assetList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    namePrefix: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "",
        "crypto."
    ])
};
$8cc41af0e88c481d$export$2e2bcd8739ae039.defaultProps = {
    assetList: [],
    namePrefix: ""
};


function $dfdc37dc6f1dff1b$export$2e2bcd8739ae039({ register: register, control: control, errors: errors, watch: watch, fieldsGrowthRates: fieldsGrowthRates, appendGrowthRates: appendGrowthRates, removeGrowthRates: removeGrowthRates, namePrefix: namePrefix, header: header }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "simulations"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "sm:grid sm:grid-cols-4 sm:gap-4",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    header && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-base font-bold text-gray-500 mb-2",
                        children: header
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:max-w-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                control: control,
                                name: `${namePrefix}growthRateAdvancedMode`,
                                render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                        as: "div",
                                        className: "flex items-center justify-start w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                as: "span",
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "text-sm font-medium text-gray-500",
                                                    children: t("simple")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), (0, $2qxEV._)((0, $9tqwB._)({}, field), {
                                                checked: field.value,
                                                onChange: field.onChange,
                                                className: `${field.value ? "bg-brandBlue-500" : "bg-gray-200"} relative inline-flex flex-shrink-0 h-6 w-11 border-2
          border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    className: `${field.value ? "translate-x-5" : "translate-x-0"}
              pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`
                                                })
                                            })),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                as: "span",
                                                className: "ml-3",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "text-sm font-medium text-gray-500",
                                                    children: t("advanced")
                                                })
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "growthRate",
                                        className: "block text-sm font-medium text-gray-500 mb-1",
                                        children: t("growthRate")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                        type: "number",
                                        step: "0.01",
                                        name: `${namePrefix}growthRate`,
                                        id: `${namePrefix}growthRate`
                                    }, register(`${namePrefix}growthRate`, {
                                        valueAsNumber: true
                                    })), {
                                        className: "mt-0.5 flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                                    })),
                                    errors.growthRate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: namePrefix ? errors[namePrefix.split(".")[0]].growthRate.message : errors.growthRate.message
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            watch(`${namePrefix}growthRateAdvancedMode`) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "sm:col-span-3 sm:mt-1",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8cc41af0e88c481d$export$2e2bcd8739ae039), {
                    fields: fieldsGrowthRates,
                    append: appendGrowthRates,
                    remove: removeGrowthRates,
                    register: register,
                    control: control,
                    namePrefix: namePrefix
                })
            })
        ]
    });
}
$dfdc37dc6f1dff1b$export$2e2bcd8739ae039.propTypes = {
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
        })
    }).isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    assetList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    fieldsGrowthRates: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        symbol: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    })).isRequired,
    appendGrowthRates: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    removeGrowthRates: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    namePrefix: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$dfdc37dc6f1dff1b$export$2e2bcd8739ae039.defaultProps = {
    assetList: [],
    namePrefix: "",
    header: ""
};





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $057667e0d4d4e50c$export$2e2bcd8739ae039({ setIsDirty: setIsDirty, displayOnly: displayOnly }) {
    const [updating, setUpdating] = (0, $7fPBF.useState)(false); // controls the spinner on the Save button
    const selectStockSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.stocks.settings);
    const selectCryptoSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.crypto.settings);
    // console.log('DEBUG selectStockSettings', selectStockSettings);
    // console.log('DEBUG selectCryptoSettings', selectCryptoSettings);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "simulations"
    });
    // default settings updated in getSettings (centrally)
    const { register: register, control: control, watch: watch, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isDirty: isDirty } } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: (0, $2qxEV._)((0, $9tqwB._)({}, (0, $6bea581af4ee4124$export$568554344c31bfb8), selectStockSettings), {
            crypto: selectCryptoSettings
        })
    }); // intialised after useEffect fetches data from Amplify store
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "growthRates",
        control: control
    });
    const { fields: fieldsC, append: appendC, remove: removeC } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "crypto.growthRates",
        control: control
    });
    // keep parent's isDirty state in sync with the form's isDirty state, so that a warning can be shown when the user tries to navigate away without saving
    (0, $7fPBF.useEffect)(()=>{
        setIsDirty(isDirty);
    }, [
        isDirty
    ]);
    async function onSubmit(data) {
        // if the form is dirty, update the entire object (as it would have otherwise been added by redux)
        if (isDirty) {
            setUpdating(true);
            try {
                await dispatch((0, $f1c3fa004749592f$export$64ebf73f0218161c)({
                    data: data,
                    category: null
                }));
                reset(data);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            } catch (error) {
                console.error(error);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            }
            setUpdating(false);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "sm:grid sm:grid-cols-6 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: t("stockMarketGrowthRate")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("simpleMode")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("simpleMode2")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-xs text-gray-400",
                        children: t("advancedMode")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("advancedMode2")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:col-span-4 sm:space-y-8",
                children: [
                    displayOnly !== "crypto" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dfdc37dc6f1dff1b$export$2e2bcd8739ae039), {
                        register: register,
                        control: control,
                        watch: watch,
                        errors: errors,
                        fieldsGrowthRates: fields,
                        appendGrowthRates: append,
                        removeGrowthRates: remove,
                        header: "Stocks"
                    }),
                    displayOnly !== "stocks" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dfdc37dc6f1dff1b$export$2e2bcd8739ae039), {
                        register: register,
                        control: control,
                        watch: watch,
                        errors: errors,
                        fieldsGrowthRates: fieldsC,
                        appendGrowthRates: appendC,
                        removeGrowthRates: removeC,
                        namePrefix: "crypto.",
                        header: "Cryptocurrencies"
                    })
                ]
            }),
            isDirty && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-end space-x-2 sm:col-start-3 mt-4",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    type: "button",
                    onClick: handleSubmit(onSubmit),
                    text: t("save"),
                    spinnerOn: updating,
                    id: "settings-planning-save",
                    withAccent: true,
                    size: "lg"
                })
            })
        ]
    });
}
$057667e0d4d4e50c$export$2e2bcd8739ae039.propTypes = {
    setIsDirty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    displayOnly: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$057667e0d4d4e50c$export$2e2bcd8739ae039.defaultProps = {
    setIsDirty: ()=>{},
    displayOnly: null
};






function $89d72962615748a4$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $89d72962615748a4$export$2e2bcd8739ae039({ account: propAccount, handleClick: handleClick, displayedData: displayedData, handleSync: handleSync, accountSyncStatus: accountSyncStatus }) {
    var _account_tags;
    // need to get account information from redux store, as the prop is not updated in Tile when the account object changes in store
    const account = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data[propAccount.category].accounts).filter((a)=>a.id === propAccount.id)[0];
    const applyImportTransformationsAutomatically = (account === null || account === void 0 ? void 0 : (_account_tags = account.tags) === null || _account_tags === void 0 ? void 0 : _account_tags.applyImportTransformationsAutomatically) !== false;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const alert = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.alert);
    const [autoImportPretransformation, setAutoImportPretransformation] = (0, $7fPBF.useState)(applyImportTransformationsAutomatically);
    const [autoImportPretransformationDirty, setAutoImportPretransformationDirty] = (0, $7fPBF.useState)(false);
    const [autoImportPretransformationLoading, setAutoImportPretransformationLoading] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setAutoImportPretransformation(applyImportTransformationsAutomatically);
        setAutoImportPretransformationDirty(false);
    }, [
        account === null || account === void 0 ? void 0 : account.id,
        applyImportTransformationsAutomatically
    ]);
    function handleSaveAutoImportPretransformation() {
        setAutoImportPretransformationLoading(true);
        dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
            data: (0, $2qxEV._)((0, $9tqwB._)({}, account), {
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, account.tags), {
                    applyImportTransformationsAutomatically: autoImportPretransformation
                })
            }),
            category: account.category
        })).then(()=>{
            // handle ok
            setAutoImportPretransformationLoading(false);
            setAutoImportPretransformationDirty(false);
        }, ()=>{
            // handle error
            setAutoImportPretransformationLoading(false);
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), {
                buttonsToShow: (0, $f808db98154b70a0$export$2e2bcd8739ae039)(account.category, "settings", displayedData),
                displayedComponent: "settings",
                displayedData: displayedData,
                handleClick: handleClick,
                handleSync: handleSync,
                userChangesPresent: false,
                accountSyncStatus: accountSyncStatus
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                className: "space-y-8 w-full overflow-y-auto scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 hover:scrollbar-thumb-zinc-400",
                id: "account-details-settings",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                    "aria-labelledby": "settings",
                    className: "h-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "shadow w-full sm:rounded-md bg-white",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "py-6 px-4 sm:p-6 space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                            id: "payment-details-heading",
                                            className: "text-lg font-medium leading-6 text-gray-900",
                                            children: t("accountDetails:settings.simulatedAccountGrowth.heading")
                                        })
                                    }),
                                    [
                                        "stocks",
                                        "crypto"
                                    ].includes(account.category) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $057667e0d4d4e50c$export$2e2bcd8739ae039), {
                                                setIsDirty: ()=>{},
                                                displayOnly: account.category
                                            }),
                                            account.category === "stocks" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $590084312c25d5d6$export$2e2bcd8739ae039), {
                                                setIsDirty: ()=>{}
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $857542ca8a716c50$export$2e2bcd8739ae039), {
                                        propAccount: propAccount
                                    }),
                                    account.category === "realEstate" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    id: "payment-details-heading",
                                                    className: "text-lg font-medium leading-6 text-gray-900",
                                                    children: t("accountDetails:settings.realEstateValuations.heading")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "mt-4 grid grid-cols-6 gap-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "col-span-2",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "mt-1 mb-4 text-xs xs:text-sm text-gray-500",
                                                            children: t("accountDetails:settings.realEstateValuations.label")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a68a576c9b836df$export$2e2bcd8739ae039), {
                                                        account: account
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    account.category === "metals" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6cfba8959af2d53$export$2e2bcd8739ae039), {
                                        propAccount: propAccount
                                    })
                                ]
                            }),
                            [
                                "deposits",
                                "stocks",
                                "realEstate",
                                "pension",
                                "loans"
                            ].includes(account.category) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "py-6 px-4 sm:p-6 space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        id: "auto-import-pretransformation-heading",
                                        className: "text-lg font-medium leading-6 text-gray-900",
                                        children: t("accountDetails:settings.autoImportPretransformation.heading")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "grid grid-cols-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "prose mt-4 text-xs xs:text-sm text-gray-500 col-span-2",
                                                children: t("accountDetails:settings.autoImportPretransformation.body")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                                as: "div",
                                                className: "flex items-center col-span-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), {
                                                        checked: autoImportPretransformation,
                                                        onChange: ()=>{
                                                            setAutoImportPretransformation(!autoImportPretransformation);
                                                            setAutoImportPretransformationDirty(true);
                                                        },
                                                        className: $89d72962615748a4$var$classNames(autoImportPretransformation ? "bg-brandBlue-500" : "bg-gray-200", "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-600"),
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            "aria-hidden": "true",
                                                            className: $89d72962615748a4$var$classNames(autoImportPretransformation ? "translate-x-5" : "translate-x-0", "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                                        as: "span",
                                                        className: "ml-3",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "text-sm font-medium text-gray-900",
                                                            children: t("accountDetails:settings.autoImportPretransformation.label")
                                                        })
                                                    })
                                                ]
                                            }),
                                            autoImportPretransformationDirty && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("app:general.save"),
                                                withAccent: true,
                                                onClick: handleSaveAutoImportPretransformation,
                                                spinnerOn: autoImportPretransformationLoading,
                                                size: "md",
                                                formatting: "mt-4 col-start-3 w-min h-8"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/* eslint-disable react/jsx-no-bind */ /* eslint-disable max-len */ /* This example requires Tailwind CSS v2.0+ */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




function $7ec5014f9e38c963$var$IconSuccess() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf0ef6f622ac72ef$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-green-500",
            "aria-hidden": "true"
        })
    });
}
function $7ec5014f9e38c963$var$IconWarning() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $086a7dd8f9408309$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-yellow-400",
            "aria-hidden": "true"
        })
    });
}
function $7ec5014f9e38c963$var$IconError() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-brandRed-100",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6513e2ba1b6537f6$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-brandRed-500",
            "aria-hidden": "true"
        })
    });
}
function $7ec5014f9e38c963$export$2e2bcd8739ae039({ alertId: alertId, alertResetFunction: alertResetFunction = null, resetCallbackObject: resetCallbackObject = null, buttons: buttons = null, visible: visible = true, callbackOk: callbackOk }) {
    // alertId corresponds to the property of the app.json translation file
    // alertResetFunction is the callback FUNCTION to be set to false in the parent component
    // if the above function doesn't simply set alert to false, but is supposed to update an object,
    // this object needs to be passed as resetCallbackObject AND you need to still specify the function
    // AlertModal will then call the callback function with the object as argument and set 'resetCallbackObject.visible' to false
    // buttons supports 2 buttons; buttons[0] is the default action button, buttons[1] is the secondary action button
    // button internal id is taken from props.buttons, whereas button labels come directly from i18n
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("alerts");
    const alert = t(alertId, {
        returnObjects: true
    });
    function handleClick(e) {
        // handle visibility of the alert modal here as well, as this component has no own state
        // TESTBETRIEB
        callbackOk();
        if (alertResetFunction && !resetCallbackObject) alertResetFunction(false);
        if (alertResetFunction && resetCallbackObject && !buttons) alertResetFunction((0, $2qxEV._)((0, $9tqwB._)({}, resetCallbackObject), {
            visible: false
        }));
        if (alertResetFunction && resetCallbackObject && buttons) alertResetFunction((0, $2qxEV._)((0, $9tqwB._)({}, resetCallbackObject), {
            visible: false,
            buttonClicked: e.target.id
        }));
    }
    let Icon = $7ec5014f9e38c963$var$IconSuccess;
    if (alert.type === "error") Icon = $7ec5014f9e38c963$var$IconError;
    if (alert.type === "warning") Icon = $7ec5014f9e38c963$var$IconWarning;
    return(// <Transition.Root show={open} as={Fragment}>
    //   <Dialog as="div" className="fixed z-50 inset-0 overflow-y-auto" onClose={setOpen}>
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Root, {
        show: visible,
        as: (0, $7fPBF.Fragment),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153), {
            as: "div",
            className: "fixed z-50 inset-0 overflow-y-auto",
            onClose: ()=>{},
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "alertModal",
                className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: (0, $7fPBF.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: (0, $7fPBF.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {}),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-3 text-center sm:mt-5",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Title, {
                                                    as: "h3",
                                                    className: "text-lg leading-6 font-bold text-gray-900",
                                                    children: alert.header
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-2",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: alert.body
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                buttons ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-5 sm:mt-6 grid grid-cols-2 gap-3 grid-flow-row-dense font-bold",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            id: buttons[0],
                                            // ^^ this comes from the caller via props
                                            className: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-brandBlue-500 text-base text-white hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 sm:col-start-2 sm:text-sm",
                                            onClick: handleClick,
                                            children: alert.button
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            id: buttons[1],
                                            className: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                                            onClick: handleClick,
                                            children: alert.button2
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-5 sm:mt-6",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        className: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-brandBlue-500 text-base text-white hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 sm:text-sm",
                                        onClick: handleClick,
                                        children: alert.button
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
}
$7ec5014f9e38c963$export$2e2bcd8739ae039.propTypes = {
    alertId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    alertResetFunction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    // eslint-disable-next-line react/forbid-prop-types
    resetCallbackObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    buttons: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string),
    visible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    callbackOk: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$7ec5014f9e38c963$export$2e2bcd8739ae039.defaultProps = {
    alertId: "pressOkToContinue",
    alertResetFunction: null,
    resetCallbackObject: null,
    buttons: null,
    visible: true,
    callbackOk: ()=>{}
};




/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/destructuring-assignment */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");










var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $ef8619896b4579e0$export$bc0492f2e501d7d4 = [
    {
        id: "berkus",
        appliesTo: [
            "idea",
            "prototype"
        ],
        questions: [
            "ideaStrength",
            "prototypeProgress",
            "teamCapability",
            "marketingRelationships",
            "marketTraction",
            "competitiveAdvantage"
        ]
    },
    {
        id: "scorecard",
        appliesTo: [
            "idea",
            "prototype"
        ],
        questions: [
            "similarStartupValuationsArray",
            "prototypeProgress",
            "technologyRisk",
            "ipStrength",
            "teamCapability",
            "marketingRelationships",
            "marketTraction",
            "totalAdressableMarketSize",
            "marketGrowthRate",
            "marketEntryBarriers",
            "competitiveAdvantage",
            "needForMoreInvestment"
        ]
    },
    {
        id: "riskFactor",
        appliesTo: [
            "idea",
            "prototype"
        ],
        questions: [
            "similarStartupValuationsArray",
            "prototypeProgress",
            "technologyRisk",
            "teamCapability",
            "marketTraction",
            "competitiveAdvantage",
            "needForMoreInvestment",
            "legalRisk",
            "internationalRisk"
        ]
    },
    {
        id: "valuationByStage",
        appliesTo: [
            "idea",
            "prototype",
            "mvp",
            "expansion"
        ],
        questions: [
            "similarStartupValuationsArray",
            "ideaStrength",
            "prototypeProgress",
            "technologyRisk",
            "ipStrength",
            "teamCapability",
            "marketingRelationships",
            "marketTraction",
            "totalAdressableMarketSize",
            "marketGrowthRate",
            "marketRisk",
            "marketEntryBarriers",
            "competitiveAdvantage",
            "financialPerformance",
            "needForMoreInvestment",
            "legalRisk"
        ]
    },
    {
        id: "replacementCost",
        appliesTo: [
            "idea",
            "prototype",
            "mvp",
            "expansion",
            "market"
        ],
        questions: [
            "assetsArray",
            "intangiblesArray"
        ]
    },
    {
        id: "bookValue",
        appliesTo: [
            "idea",
            "prototype",
            "mvp",
            "expansion",
            "market"
        ],
        questions: [
            "assetsArray",
            "liabilitiesArray"
        ]
    },
    {
        id: "fiveTimesYourRise",
        appliesTo: [
            "idea",
            "prototype",
            "mvp",
            "expansion",
            "market"
        ],
        questions: [
            "targetRaisedCapital"
        ]
    },
    {
        id: "dcf",
        appliesTo: [
            "mvp",
            "expansion",
            "market"
        ],
        questions: [
            "cashFlowArray",
            "discountRate",
            "longTermGrowthRate"
        ]
    }
];
const $ef8619896b4579e0$export$2deac3956661e672 = [
    {
        id: "ideaStrength",
        type: "score"
    },
    {
        id: "prototypeProgress",
        type: "score"
    },
    {
        id: "teamCapability",
        type: "score"
    },
    {
        id: "marketingRelationships",
        type: "score"
    },
    {
        id: "marketTraction",
        type: "score"
    },
    {
        id: "competitiveAdvantage",
        type: "score"
    },
    {
        id: "similarStartupValuationsArray",
        type: "array"
    },
    {
        id: "technologyRisk",
        type: "score"
    },
    {
        id: "ipStrength",
        type: "score"
    },
    {
        id: "totalAdressableMarketSize",
        type: "score"
    },
    {
        id: "marketGrowthRate",
        type: "score"
    },
    {
        id: "marketEntryBarriers",
        type: "score"
    },
    {
        id: "needForMoreInvestment",
        type: "score"
    },
    {
        id: "legalRisk",
        type: "score"
    },
    {
        id: "internationalRisk",
        type: "score"
    },
    {
        id: "marketRisk",
        type: "score"
    },
    {
        id: "financialPerformance",
        type: "score"
    },
    {
        id: "assetsArray",
        type: "array"
    },
    {
        id: "intangiblesArray",
        type: "array"
    },
    {
        id: "liabilitiesArray",
        type: "array"
    },
    {
        id: "targetRaisedCapital",
        type: "number"
    },
    {
        id: "cashFlowArray",
        type: "array"
    },
    {
        id: "discountRate",
        type: "number"
    },
    {
        id: "longTermGrowthRate",
        type: "number"
    }
];
function $ef8619896b4579e0$var$n(score) {
    return (score + 2) / 4;
}
function $ef8619896b4579e0$var$calculateBerkus(company) {
    const ideaScore = ($ef8619896b4579e0$var$n(company.ideaStrength) || 0) * 500000;
    const prototypeProgressScore = ($ef8619896b4579e0$var$n(company.prototypeProgress) || 0) * 500000;
    const teamCapabilityScore = ($ef8619896b4579e0$var$n(company.teamCapability) || 0) * 500000;
    const relationshipsScore = ($ef8619896b4579e0$var$n(company.marketingRelationships) || 0) * 500000;
    const marketTractionScore = ($ef8619896b4579e0$var$n(company.marketTraction) || 0) * 500000;
    return ideaScore + prototypeProgressScore + teamCapabilityScore + relationshipsScore + marketTractionScore;
}
function $ef8619896b4579e0$var$calculateReplacementCost(company) {
    // Needs additional logic to handle replacementCostAssets array
    if (!company.assetsArray || !company.assetsArray.length) return null; // No assets provided
    const totalReplacementCost = company.assetsArray.reduce((acc, asset)=>acc + ((asset === null || asset === void 0 ? void 0 : asset.value) || 0), 0);
    return totalReplacementCost;
}
function $ef8619896b4579e0$var$calculateValuationByStageMethod(company) {
    const { stage: stage } = company;
    const stageRanges = {
        idea: {
            min: 250000,
            max: 500000
        },
        prototype: {
            min: 500000,
            max: 1000000
        },
        mvp: {
            min: 1000000,
            max: 2000000
        },
        expansion: {
            min: 2000000,
            max: 5000000
        }
    };
    if (!stageRanges[stage]) return null; // Invalid stage provided
    // Exclude similarStartupValuationsArray from the questions
    const relevantQuestions = $ef8619896b4579e0$export$bc0492f2e501d7d4.find((method)=>method.id === "valuationByStage").questions.filter((q)=>q !== "similarStartupValuationsArray");
    const avgScore = relevantQuestions.reduce((acc, questionId)=>{
        const score = company[questionId] || 0;
        return acc + score;
    }, 0) / relevantQuestions.length;
    if (avgScore === -2) return stageRanges[stage].min;
    if (avgScore === 2) return stageRanges[stage].max;
    // return the middle of the range with adjustment for avgScore, rounded to 4 digits
    const adjustedValue = stageRanges[stage].min + avgScore * (stageRanges[stage].max - stageRanges[stage].min) / 2;
    return Math.round(adjustedValue * 10000) / 10000;
}
function $ef8619896b4579e0$var$calculateScorecardMethod(company) {
    const factors = [
        {
            id: "teamCapability",
            weight: 0.3
        },
        {
            id: "marketTraction",
            weight: 0.1
        },
        {
            id: "totalAdressableMarketSize",
            weight: 0.1
        },
        {
            id: "marketGrowthRate",
            weight: 0.05
        },
        {
            id: "prototypeProgress",
            weight: 0.1
        },
        {
            id: "technologyRisk",
            weight: 0.05
        },
        {
            id: "marketEntryBarriers",
            weight: 0.05
        },
        {
            id: "competitiveAdvantage",
            weight: 0.05
        },
        {
            id: "marketingRelationships",
            weight: 0.1
        },
        {
            id: "needForMoreInvestment",
            weight: 0.05
        },
        {
            id: "ipStrength",
            weight: 0.05
        }
    ];
    // add score to factors based on user input
    const factorScores = factors.map((factor)=>(0, $2qxEV._)((0, $9tqwB._)({}, factor), {
            score: company[factor.id] || 0
        }));
    // calculate weighted score
    const weightedScore = factorScores.reduce((acc, factorScore)=>acc + factorScore.score * factors.find((f)=>f.name === factorScore.name).weight, 0);
    // calculate average pre-money valuation from similar startups
    const { similarStartupValuationsArray: similarStartupValuationsArray } = company;
    if (!similarStartupValuationsArray || !similarStartupValuationsArray.length) return NaN;
    const averagePreMoneyValuation = similarStartupValuationsArray.reduce((acc, startup)=>acc + ((startup === null || startup === void 0 ? void 0 : startup.value) || 0), 0) / similarStartupValuationsArray.length;
    // apply adjustments based on weighted score
    const minPercentage = 0.25;
    const maxPercentage = 1.75;
    // Normalize weighted score to a range of 0 to 1, where -2 maps to 0 and 2 maps to 1
    const normalizedScore = (weightedScore + 2) / 4;
    // Interpolate to find the valuation percentage
    const valuationPercentage = minPercentage + normalizedScore * (maxPercentage - minPercentage);
    // Calculate the final valuation
    const finalValuation = averagePreMoneyValuation * valuationPercentage;
    return finalValuation;
}
function $ef8619896b4579e0$var$calculateRiskFactor(company) {
    const riskFactors = $ef8619896b4579e0$export$bc0492f2e501d7d4.find((method)=>method.id === "riskFactor").questions.filter((q)=>q !== "similarStartupValuationsArray");
    // Calculate risk score for each factor
    const riskScores = riskFactors.map((factor)=>company[factor] || 0);
    // Calculate average risk score
    const totalRiskScore = riskScores.reduce((acc, score)=>acc + score, 0);
    const averageRiskScore = totalRiskScore / riskFactors.length;
    // Get average pre-money valuation from similar startups
    const { similarStartupValuationsArray: similarStartupValuationsArray } = company;
    if (!similarStartupValuationsArray || !similarStartupValuationsArray.length) return NaN;
    const averagePreMoneyValuation = similarStartupValuationsArray.reduce((acc, startup)=>acc + ((startup === null || startup === void 0 ? void 0 : startup.value) || 0), 0) / similarStartupValuationsArray.length;
    // Normalize average risk score to range of -2 to 2
    const normalizedRiskScore = Math.max(-2, Math.min(2, averageRiskScore));
    // Define the range for valuation adjustment
    const minPercentage = 0.25;
    const maxPercentage = 1.75;
    // Normalize average score to a range of 0 to 1, where -2 maps to 0 and 2 maps to 1
    const normalizedScore = (normalizedRiskScore + 2) / 4;
    // Interpolate to find the valuation percentage
    const valuationPercentage = minPercentage + normalizedScore * (maxPercentage - minPercentage);
    // Calculate the final valuation
    const finalValuation = averagePreMoneyValuation * valuationPercentage;
    return finalValuation;
}
function $ef8619896b4579e0$var$calculateFiveTimes(company) {
    const { targetRaisedCapital: targetRaisedCapital } = company;
    if (!targetRaisedCapital) return NaN;
    return targetRaisedCapital * 5;
}
function $ef8619896b4579e0$var$calculateBookValue(company) {
    const { assetsArray: assetsArray, liabilitiesArray: liabilitiesArray } = company;
    if (!assetsArray || !assetsArray.length) return NaN;
    if (!liabilitiesArray || !liabilitiesArray.length) return NaN;
    const totalAssets = assetsArray.reduce((acc, asset)=>acc + ((asset === null || asset === void 0 ? void 0 : asset.value) || 0), 0);
    const totalLiabilities = liabilitiesArray.reduce((acc, liability)=>acc + ((liability === null || liability === void 0 ? void 0 : liability.value) || 0), 0);
    return totalAssets - totalLiabilities;
}
function $ef8619896b4579e0$var$calculateDCF(company) {
    const { cashFlowArray: cashFlowArray, discountRate: discountRate, longTermGrowthRate: longTermGrowthRate } = company;
    if (!cashFlowArray || !cashFlowArray.length) return NaN;
    if (!discountRate) return NaN;
    if (!longTermGrowthRate) return NaN; // Ensure the long-term growth rate is provided
    if (longTermGrowthRate >= discountRate) return NaN; // Ensure the long-term growth rate is less than the discount rate
    // Convert percentage rates to fractions
    const discountRateFraction = discountRate / 100;
    const longTermGrowthRateFraction = longTermGrowthRate / 100;
    // Sort cashFlowArray by name in ascending order
    const sortedCashFlowArray = [
        ...cashFlowArray
    ].sort((a, b)=>a.name.localeCompare(b.name));
    // Calculate Present Value of each cash flow
    const discountedCashFlows = sortedCashFlowArray.map((cashFlow, year)=>((cashFlow === null || cashFlow === void 0 ? void 0 : cashFlow.value) || 0) / (1 + discountRateFraction) ** (year + 1));
    // Calculate Terminal Value using Perpetuity Growth Model with long-term growth rate
    const lastYearCashFlow = sortedCashFlowArray[sortedCashFlowArray.length - 1].value;
    const terminalValue = lastYearCashFlow * (1 + longTermGrowthRateFraction) / (discountRateFraction - longTermGrowthRateFraction);
    const terminalValueDiscounted = terminalValue / (1 + discountRateFraction) ** sortedCashFlowArray.length;
    // Sum the Present Values of projected cash flows and the discounted terminal value
    const totalValuation = discountedCashFlows.reduce((acc, discountedCashFlow)=>acc + discountedCashFlow, 0) + terminalValueDiscounted;
    return totalValuation;
}
function $ef8619896b4579e0$export$c87e0f149a1d31a9(methodId, fieldValues) {
    // Find the valuation method with the given id
    const method = $ef8619896b4579e0$export$bc0492f2e501d7d4.find((m)=>m.id === methodId);
    if (!method) console.error(`No valuation method found with id: ${methodId}`);
    switch(methodId){
        case "berkus":
            return $ef8619896b4579e0$var$calculateBerkus(fieldValues);
        case "replacementCost":
            return $ef8619896b4579e0$var$calculateReplacementCost(fieldValues);
        case "valuationByStage":
            return $ef8619896b4579e0$var$calculateValuationByStageMethod(fieldValues);
        case "scorecard":
            return $ef8619896b4579e0$var$calculateScorecardMethod(fieldValues);
        case "riskFactor":
            return $ef8619896b4579e0$var$calculateRiskFactor(fieldValues);
        case "bookValue":
            return $ef8619896b4579e0$var$calculateBookValue(fieldValues);
        case "fiveTimesYourRise":
            return $ef8619896b4579e0$var$calculateFiveTimes(fieldValues);
        case "dcf":
            return $ef8619896b4579e0$var$calculateDCF(fieldValues);
        default:
            return NaN;
    }
}
function $ef8619896b4579e0$export$34c8d98e36ee1fa9(methodId, fieldValues) {
    const method = $ef8619896b4579e0$export$bc0492f2e501d7d4.find((m)=>m.id === methodId);
    if (!method) console.error(`No valuation method found with id: ${methodId}`);
    // leave only questions which have null / undefined / '' or length === 0 or all values are empty (when adding a line it first adds undefined to array as an item, that must be captured)
    const missingFields = method.questions.filter((q)=>fieldValues[q] === null || fieldValues[q] === undefined || fieldValues[q] === "" || Array.isArray(fieldValues[q]) && fieldValues[q].length === 0 || Array.isArray(fieldValues[q]) && fieldValues[q].every((x)=>!x || !x.value));
    return missingFields;
}




/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $08121eaf4e3ac23c$var$Bars2Icon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M2 6.75A.75.75 0 0 1 2.75 6h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 6.75Zm0 6.5a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
        clipRule: "evenodd"
    }));
}
const $08121eaf4e3ac23c$var$ForwardRef = $7fPBF.forwardRef($08121eaf4e3ac23c$var$Bars2Icon);
var $08121eaf4e3ac23c$export$2e2bcd8739ae039 = $08121eaf4e3ac23c$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $6b815979231182fe$var$ChevronDoubleDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M9.47 15.28a.75.75 0 0 0 1.06 0l4.25-4.25a.75.75 0 1 0-1.06-1.06L10 13.69 6.28 9.97a.75.75 0 0 0-1.06 1.06l4.25 4.25ZM5.22 6.03l4.25 4.25a.75.75 0 0 0 1.06 0l4.25-4.25a.75.75 0 0 0-1.06-1.06L10 8.69 6.28 4.97a.75.75 0 0 0-1.06 1.06Z",
        clipRule: "evenodd"
    }));
}
const $6b815979231182fe$var$ForwardRef = $7fPBF.forwardRef($6b815979231182fe$var$ChevronDoubleDownIcon);
var $6b815979231182fe$export$2e2bcd8739ae039 = $6b815979231182fe$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $7903ea75ce37f667$var$ChevronDoubleUpIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M9.47 4.72a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 6.31l-3.72 3.72a.75.75 0 1 1-1.06-1.06l4.25-4.25Zm-4.25 9.25 4.25-4.25a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 11.31l-3.72 3.72a.75.75 0 0 1-1.06-1.06Z",
        clipRule: "evenodd"
    }));
}
const $7903ea75ce37f667$var$ForwardRef = $7fPBF.forwardRef($7903ea75ce37f667$var$ChevronDoubleUpIcon);
var $7903ea75ce37f667$export$2e2bcd8739ae039 = $7903ea75ce37f667$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $a93467887e89dcc8$var$ChevronUpIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z",
        clipRule: "evenodd"
    }));
}
const $a93467887e89dcc8$var$ForwardRef = $7fPBF.forwardRef($a93467887e89dcc8$var$ChevronUpIcon);
var $a93467887e89dcc8$export$2e2bcd8739ae039 = $a93467887e89dcc8$var$ForwardRef;




function $89040638ce453994$export$2e2bcd8739ae039({ id: id, label: label, tooltip: tooltip, control: control, overrideOptions: overrideOptions, fullWidth: fullWidth, forceFlex: forceFlex }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "unlistedShares.wizard.valuation.score"
    });
    // take the provided options or use default
    const options = overrideOptions || [
        {
            id: -2,
            name: t("-2.label"),
            Icon: (0, $6b815979231182fe$export$2e2bcd8739ae039)
        },
        {
            id: -1,
            name: t("-1.label"),
            Icon: (0, $718d5639811dbbc7$export$2e2bcd8739ae039)
        },
        {
            id: 0,
            name: t("0.label"),
            Icon: (0, $08121eaf4e3ac23c$export$2e2bcd8739ae039)
        },
        {
            id: 1,
            name: t("1.label"),
            Icon: (0, $a93467887e89dcc8$export$2e2bcd8739ae039)
        },
        {
            id: 2,
            name: t("2.label"),
            Icon: (0, $7903ea75ce37f667$export$2e2bcd8739ae039)
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), (0, $2qxEV._)((0, $9tqwB._)({
        control: control,
        name: id
    }, id !== "stage" && {
        defaultValue: 0
    }), {
        render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                "aria-label": label,
                id: `option-buttons-${id}`,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-sm font-medium leading-6 text-gray-900",
                                children: label
                            }),
                            tooltip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: tooltip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25), {
                        value: field.value,
                        onChange: field.onChange,
                        className: `mt-2 ${forceFlex ? "flex flex-wrap" : "grid grid-cols-5"} gap-3 ${fullWidth ? "lg:w-full" : "lg:w-3/5"}`,
                        children: options.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: option.name,
                                classNameOwn: `${forceFlex ? "flex-shrink-0" : "w-full"}`,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a18a86addc0f3bc$export$a98f0dcb43a68a25).Option, {
                                    value: option.id,
                                    className: ({ focus: focus, checked: checked })=>`cursor-pointer focus:outline-none flex items-center justify-center rounded-md py-3 px-3 text-sm font-semibold uppercase sm:flex-1
                    ${forceFlex ? "flex-shrink-0" : "w-full"}
                    ${focus ? "ring-2 ring-brandBlue-600 ring-offset-2" : ""}
                    ${checked ? "bg-brandBlue-500 text-white hover:bg-brandBlue-400" : "ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50"}`,
                                    children: option.Icon ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(option.Icon, {
                                        className: "h-5 w-5",
                                        "aria-hidden": "true"
                                    }) : option.name
                                })
                            }, option.id))
                    })
                ]
            })
    }));
}
$89040638ce453994$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    overrideOptions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    forceFlex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$89040638ce453994$export$2e2bcd8739ae039.defaultProps = {
    tooltip: null,
    overrideOptions: null,
    fullWidth: false,
    forceFlex: false
};


/* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




const $349e550f5b4bb582$var$nsPrefixes = new Set([
    "accountDetails",
    "addAccount",
    "projects",
    "settings",
    "dashboard",
    "charts",
    "reporting",
    "rebalancing",
    "alerts",
    "messages",
    "header",
    "invitation"
]);
function $349e550f5b4bb582$var$OptionButtonsMultipleCore({ value: value, onChange: onChange, tPrefix: tPrefix }) {
    $349e550f5b4bb582$var$OptionButtonsMultipleCore.propTypes = {
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            selected: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        })).isRequired,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        tPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
    };
    const [ns, keyPrefix] = (()=>{
        const [maybeNamespace, ...rest] = tPrefix.split(".");
        if ($349e550f5b4bb582$var$nsPrefixes.has(maybeNamespace)) return [
            maybeNamespace,
            rest.join(".")
        ];
        return [
            "app",
            tPrefix
        ];
    })();
    const translationOptions = keyPrefix ? {
        keyPrefix: keyPrefix
    } : undefined;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, translationOptions);
    const [fieldValue, setFieldValue] = (0, $7fPBF.useState)(value || []);
    // expects field value to be an array of { id, selected }
    // if value changes, update local state
    (0, $7fPBF.useEffect)(()=>{
        setFieldValue(value);
    }, [
        value
    ]);
    function handleClick(e) {
        // update component state based on e.target.id
        const newFieldValue = fieldValue.map((item)=>({
                id: item.id,
                selected: item.id === e.target.id ? !item.selected : item.selected
            }));
        setFieldValue(newFieldValue);
        // synchronise local state with parent form state
        onChange(newFieldValue);
    }
    if (!fieldValue || fieldValue.length === 0) return true;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "mt-2 flex flex-wrap gap-3 lg:w-full",
        children: fieldValue.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                info: option.name,
                classNameOwn: "flex-shrink-0",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    id: option.id,
                    type: "button",
                    onClick: handleClick,
                    className: `cursor-pointer focus:outline-none flex items-center justify-center rounded-md py-3 px-3 text-sm font-semibold uppercase sm:flex-1 flex-shrink-0
                        focus:ring-2 focus:ring-brandBlue-600 focus:ring-offset-2
                        ${fieldValue.find((item)=>item.id === option.id).selected ? "bg-brandBlue-500 text-white hover:bg-brandBlue-400" : "ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50"}`,
                    children: t(`${option.id}.label`)
                })
            }, option.id))
    });
}
function $349e550f5b4bb582$export$2e2bcd8739ae039({ id: id, label: label, tooltip: tooltip, control: control, tPrefix: tPrefix }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
        control: control,
        name: id,
        render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
                "aria-label": label,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-sm font-medium leading-6 text-gray-900",
                                children: label
                            }),
                            tooltip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                info: tooltip
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($349e550f5b4bb582$var$OptionButtonsMultipleCore, {
                        value: field.value,
                        onChange: field.onChange,
                        tPrefix: tPrefix
                    })
                ]
            })
    });
}
$349e550f5b4bb582$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    tPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
$349e550f5b4bb582$export$2e2bcd8739ae039.defaultProps = {
    tooltip: null
};


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable max-len */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $f3384b82e6537d5a$export$2e2bcd8739ae039({ label: label, tooltip: tooltip, currency: currency, control: control, name: name, namePlaceholder: namePlaceholder, formObject: formObject }) {
    const { register: register, unregister: unregister } = formObject;
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        control: control,
        name: name
    });
    (0, $7fPBF.useEffect)(()=>()=>console.log("unmounting", name), []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("fieldset", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("legend", {
                className: "flex text-sm font-medium leading-6 text-gray-900",
                children: [
                    label,
                    tooltip && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                        info: tooltip
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mt-2 -space-y-px rounded-md shadow-sm",
                children: fields.map((row, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative flex -space-x-px items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "w-1/2 min-w-0 flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: `${name}.${index}.name`,
                                        className: "sr-only",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                        type: "text",
                                        className: `relative block w-full rounded-none border-0 bg-transparent py-1.5 bg-white text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-brandBlue-600 sm:text-sm sm:leading-6
                ${index === 0 ? "rounded-tl-md" : ""} ${index === fields.length - 1 ? "rounded-bl-md" : ""} `,
                                        placeholder: namePlaceholder || "Name"
                                    }, register(`${name}.${index}.name`, {
                                        defaultValue: "asset"
                                    })))
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "min-w-0 flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: `${name}.${index}.value`,
                                        className: "sr-only",
                                        children: "Value"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                        type: "text",
                                        className: `relative block w-full rounded-none border-0 bg-transparent py-1.5 pr-6 bg-white  text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-brandBlue-600 sm:text-sm sm:leading-6
                ${index === 0 ? "rounded-tr-md" : ""} ${index === fields.length - 1 ? "rounded-br-md" : ""} `,
                                        placeholder: "10000"
                                    }, register(`${name}.${index}.value`, {
                                        defaultValue: 10000,
                                        valueAsNumber: true,
                                        min: 0
                                    })))
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    className: "z-10 ml-2 inline-flex items-center px-3 py-1.5 border border-gray-200 text-xs leading-4 font-medium rounded-md text-gray-300 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                                    onClick: ()=>remove(index),
                                    children: "X"
                                })
                            }),
                            currency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "absolute right-0 pr-12 text-gray-400 text-sm",
                                children: currency
                            })
                        ]
                    }, (row.name || "").replace(/[^a-zA-Z0-9]/g, "")))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: "mt-2 ml-1 inline-flex items-center px-2 py-1.5 border border-gray-200 text-xs leading-4 font-medium rounded-md text-gray-300 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-500",
                    onClick: ()=>append(),
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc348e8ecf02df23$export$2e2bcd8739ae039), {
                        className: "h-4 w-4",
                        "aria-hidden": "true"
                    })
                })
            })
        ]
    });
}
$f3384b82e6537d5a$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    namePlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    formObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    currency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$f3384b82e6537d5a$export$2e2bcd8739ae039.defaultProps = {
    tooltip: null,
    currency: null,
    namePlaceholder: null
};





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $3c3d6783faa7f601$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "unlistedShares.wizard.valuation"
    });
    const { t: tMethods } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "unlistedShares.wizard.valuation.methods"
    });
    const { t: tButtons } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    const selectQuotes = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$32058f168ca0310f));
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    // all quotes are manual in unlisted; quotes API returns all manual quotes "which change something",
    // i.e. which were the one actually entered by users (as opposed to those generated from a past quote for a requested date)
    // so we want to see only them (they are the ones with date === quoteDate)
    const existingQuotes = (0, $7fPBF.useMemo)(()=>(selectQuotes.filter((q)=>q.assetId === props.account.id && q.date === q.quoteDate) || []).sort((a, b)=>a.date - b.date), [
        selectQuotes,
        props.account.id
    ]);
    const noteFieldNames = (0, $7fPBF.useMemo)(()=>[
            "stage",
            "valuationMethods",
            "percentOwned",
            ...(0, $ef8619896b4579e0$export$2deac3956661e672).map((q)=>q.id)
        ], []);
    function parseNoteObject(note) {
        if (!note) return {};
        if (typeof note === "string") try {
            return JSON.parse(note);
        } catch (err) {
            console.error(err);
            return {};
        }
        if (typeof note === "object") return note;
        return {};
    }
    function quoteToFormState(quoteObject = {}) {
        const noteObject = parseNoteObject(quoteObject.note);
        const noteValues = noteFieldNames.reduce((acc, fieldName)=>{
            acc[fieldName] = typeof noteObject[fieldName] === "undefined" ? null : noteObject[fieldName];
            return acc;
        }, {});
        var _quoteObject_quote, _quoteObject_quoteBaseCurrency;
        return (0, $9tqwB._)({
            assetId: quoteObject.assetId || props.account.id,
            projectId: quoteObject.projectId || null,
            source: quoteObject.source || "manual",
            date: quoteObject.date ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(quoteObject.date).format("YYYY-MM-DD") : null,
            quote: (_quoteObject_quote = quoteObject.quote) !== null && _quoteObject_quote !== void 0 ? _quoteObject_quote : null,
            quoteBaseCurrency: (_quoteObject_quoteBaseCurrency = quoteObject.quoteBaseCurrency) !== null && _quoteObject_quoteBaseCurrency !== void 0 ? _quoteObject_quoteBaseCurrency : null
        }, noteValues);
    }
    const defaultQuotes = (0, $7fPBF.useMemo)(()=>existingQuotes.map((q)=>quoteToFormState(q)).concat([
            quoteToFormState({
                assetId: props.account.id
            })
        ]), [
        existingQuotes,
        props.account.id
    ]);
    // determines which quote from quotes array do we currently see (initialise on the last position, which is the empty object for a new quote)
    const [selectedQuoteIndex, setSelectedQuoteIdIndex] = (0, $7fPBF.useState)(defaultQuotes.length ? defaultQuotes.length - 1 : 0); // initialise with the new quote
    // const [newQuoteDraft, setNewQuoteDraft] = useState({});
    // const unlistedQuoteIndex = useMemo(() => {
    //   if (!selectedQuoteIndex) return quotes.length - 1;
    //   const foundIndex = quotes.findIndex((q) => q.id === selectedQuoteIndex);
    //   return foundIndex >= 0 ? foundIndex : quotes.length - 1;
    // }, [selectedQuoteIndex, quotes]);
    const formObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: {
            quotes: defaultQuotes
        }
    });
    const { register: register, reset: reset, resetField: resetField, watch: watch, formState: formState, setValue: setValue, handleSubmit: handleSubmit, control: control, getFieldState: getFieldState } = formObject;
    const { replace: replace } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        control: control,
        name: "quotes"
    });
    const watchAllQuotes = watch("quotes");
    const currentQuote = (watchAllQuotes === null || watchAllQuotes === void 0 ? void 0 : watchAllQuotes[selectedQuoteIndex]) || {};
    const { stage: stage, valuationMethods: valuationMethods } = currentQuote;
    const quotePath = `quotes.${selectedQuoteIndex}`;
    const totalQuotes = (watchAllQuotes || defaultQuotes).length || 1;
    const fieldSetState = getFieldState(`quotes.${selectedQuoteIndex}`, formState); // get state of a single fieldset in field array
    const [displayedQuestions, setDisplayedQuestions] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [deleting, setDeleting] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        replace(defaultQuotes);
        reset({
            quotes: defaultQuotes
        });
        setSelectedQuoteIdIndex(defaultQuotes.length ? defaultQuotes.length - 1 : 0);
    }, [
        defaultQuotes,
        replace,
        reset
    ]);
    // -----------------------------
    // HANDLE PREV / NEXT BUTTONS
    // -----------------------------
    // const isNewQuote = unlistedQuoteIndex === quotes.length - 1 || !quotes[unlistedQuoteIndex]?.id;
    // helper: reset the form and updated the index in one function
    function resetAndSetIndex(newIndex) {
        const boundedIndex = Math.min(Math.max(newIndex, 0), totalQuotes - 1);
        setSelectedQuoteIdIndex(boundedIndex);
    }
    function handlePrevNext(direction) {
        const newIndex = direction === "next" ? selectedQuoteIndex + 1 : selectedQuoteIndex - 1;
        // Ensure the new index is within bounds
        resetAndSetIndex(newIndex);
    }
    // -----------------------------
    // HANDLE SUBMIT
    // -----------------------------
    // submit button is enabled only when the form is VALID and DIRTY
    async function onSubmit(formValues) {
        var _formValues_quotes;
        const inputQuote = (formValues === null || formValues === void 0 ? void 0 : (_formValues_quotes = formValues.quotes) === null || _formValues_quotes === void 0 ? void 0 : _formValues_quotes[selectedQuoteIndex]) || {};
        setLoading(true);
        // remember to move everything exept quote and date under note and stringify it
        let transformedQuote;
        try {
            transformedQuote = (0, $fd6541cb8870bfa3$export$ee7a15c61bfdeb11).cast({
                // apply quotes in proportion to the percent owned indicated by user; if there is no percent owned, assume 100% (i.e. intial quote for the account)
                quote: Number(inputQuote.quote) * (Number(inputQuote.percentOwned) / 100 || 1),
                assetId: props.account.id,
                quoteDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(inputQuote.date).valueOf(),
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(inputQuote.date).valueOf(),
                quoteBaseCurrency: Number(inputQuote.quoteBaseCurrency) * (Number(inputQuote.percentOwned) / 100 || 1),
                currency: props.account.currency,
                source: "manual",
                projectId: null
            }, {
                stripUnknown: true
            });
        } catch (err) {
            console.error(err);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("validationError"));
            setLoading(false);
            return;
        }
        // get every property except date/quote/quoteBaseCurrency and put it in note as stringified JSON
        try {
            const noteExcluded = new Set([
                "date",
                "quote",
                "quoteBaseCurrency",
                "quoteId"
            ]);
            const note = JSON.stringify(Object.entries(inputQuote).filter(([key])=>!noteExcluded.has(key)).reduce((acc, [key, value])=>{
                acc[key] = value;
                return acc;
            }, {}));
            await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                arrayOfQuotes: [
                    (0, $2qxEV._)((0, $9tqwB._)({}, transformedQuote), {
                        note: note
                    })
                ],
                accountId: props.account.id
            }));
        } catch (err) {
            console.error(err);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("validationError"));
        }
        setLoading(false);
        props.handleClick("table");
    }
    // -----------------------------
    // HANDLE DELETE
    // -----------------------------
    function handleResetNewQuote() {
        const emptyQuote = quoteToFormState({
            assetId: props.account.id
        });
        resetField(quotePath, {
            defaultValue: emptyQuote
        });
        setValue(quotePath, emptyQuote, {
            shouldDirty: false
        });
        setDisplayedQuestions([]);
    }
    function handleDelete() {
        setDeleting(true);
        // if this is a "previous" quote (i.e. not the last item of the array), ask confirmation and send a delete to backend
        // if this is a "new" quote and it is dirty, reset the form (ask confirmation first)
        // if this is a "new" quote and it is NOT dirty, do nothing (disabled delete button should not allow this to be executed)
        const thisIsTheLastQuote = selectedQuoteIndex === totalQuotes - 1;
        // first check if the form is dirty, and if it is, display warning
        if (thisIsTheLastQuote && formState.isDirty || !thisIsTheLastQuote) {
            // before navigating away from the form, display array
            const event = new CustomEvent("setAlert", {
                detail: {
                    id: "youAreAboutToDeleteValuation",
                    caller: "UnlistedAddValuationWizard",
                    callbackOk: async ()=>{
                        try {
                            // if this is an existing quote (i.e. not the last item of the array), send a delete to backend
                            if (!thisIsTheLastQuote) {
                                await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                                    arrayOfQuotes: [
                                        (0, $2qxEV._)((0, $9tqwB._)({}, existingQuotes[selectedQuoteIndex]), {
                                            importFlag: "delete"
                                        })
                                    ],
                                    accountId: props.account.id
                                }));
                                props.handleClick("table");
                            } else // if this is a "new" quote, reset the form
                            handleResetNewQuote();
                            setDeleting(false);
                        } catch (err) {
                            console.error(err);
                            setDeleting(false);
                        }
                    }
                }
            });
            window.dispatchEvent(event);
        }
        setDeleting(false);
    }
    // -----------------------------
    // HANDLE FORM MECHANICS
    // -----------------------------
    const stageButtons = [
        {
            id: "idea",
            name: t("stage.idea.label")
        },
        {
            id: "prototype",
            name: t("stage.prototype.label")
        },
        {
            id: "mvp",
            name: t("stage.mvp.label")
        },
        {
            id: "expansion",
            name: t("stage.expansion.label")
        },
        {
            id: "market",
            name: t("stage.market.label")
        }
    ];
    const allMethods = [
        {
            id: "berkus",
            name: t("methods.berkus.label"),
            tooltip: t("methods.berkus.tooltip")
        },
        {
            id: "scorecard",
            name: t("methods.scorecard.label"),
            tooltip: t("methods.scorecard.tooltip")
        },
        {
            id: "riskFactor",
            name: t("methods.riskFactor.label"),
            tooltip: t("methods.riskFactor.tooltip")
        },
        {
            id: "valuationByStage",
            name: t("methods.valuationByStage.label"),
            tooltip: t("methods.valuationByStage.tooltip")
        },
        {
            id: "replacementCost",
            name: t("methods.replacementCost.label"),
            tooltip: t("methods.replacementCost.tooltip")
        },
        {
            id: "bookValue",
            name: t("methods.bookValue.label"),
            tooltip: t("methods.bookValue.tooltip")
        },
        {
            id: "fiveTimesYourRise",
            name: t("methods.fiveTimesYourRise.label"),
            tooltip: t("methods.fiveTimesYourRise.tooltip")
        },
        {
            id: "dcf",
            name: t("methods.dcf.label"),
            tooltip: t("methods.dcf.tooltip")
        }
    ];
    // when user selects a stage, show only the methods that apply to that stage (part of the valuation business object, so update it there)
    (0, $7fPBF.useEffect)(()=>{
        if (stage) {
            const methodsPerStage = (0, $ef8619896b4579e0$export$bc0492f2e501d7d4).filter((method)=>method.appliesTo.includes(stage));
            const allMethodsToShow = allMethods.filter((method)=>methodsPerStage.map((m)=>m.id).includes(method.id));
            if (!valuationMethods || valuationMethods.length === 0) setValue(`${quotePath}.valuationMethods`, allMethodsToShow.map((method)=>({
                    id: method.id,
                    selected: true
                })), {
                shouldDirty: false
            });
        }
    }, [
        stage,
        selectedQuoteIndex,
        valuationMethods,
        setValue,
        quotePath
    ]);
    // generate a list of questions to be displayed in reaction to changes of method selection
    (0, $7fPBF.useEffect)(()=>{
        const questionIds = new Set();
        if (valuationMethods) {
            // get a list of unique questionIds for all currently selected methods using a Set
            valuationMethods.filter((method)=>method.selected).forEach((selectedMethod)=>{
                const methodObject = (0, $ef8619896b4579e0$export$bc0492f2e501d7d4).find((method)=>method.id === selectedMethod.id);
                methodObject.questions.forEach((question)=>questionIds.add(question));
            });
            // update the component state (question components will self-register in form state)
            setDisplayedQuestions(Array.from(questionIds));
        } else // if there are no valuationMethods (like for example when we go back from previous to new quote), show no questions
        setDisplayedQuestions([]);
    }, [
        stage,
        valuationMethods,
        selectedQuoteIndex
    ]);
    // -----------------------------
    // RENDER COMPONENT
    // -----------------------------
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full h-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                buttonsToShow: (0, $f808db98154b70a0$export$2e2bcd8739ae039)("unlistedShares", "wizard", "quotes"),
                handlePrevNext: handlePrevNext
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                className: "w-full h-full grid lg:grid-cols-2 xl:grid-cols-3 py-0 px-2 overflow-y-auto",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        id: "unlisted-add-valuation-col-1",
                        className: "space-y-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: "text-lg font-bold",
                                        children: t("title")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-sm mt-2",
                                        children: t("description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $89040638ce453994$export$2e2bcd8739ae039), {
                                control: control,
                                id: `${quotePath}.stage`,
                                label: t("stage.label"),
                                tooltip: t("stage.tooltip"),
                                forceFlex: true,
                                fullWidth: true,
                                overrideOptions: stageButtons
                            }, `stage-${quotePath}`),
                            stage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $349e550f5b4bb582$export$2e2bcd8739ae039), {
                                control: control,
                                id: `${quotePath}.valuationMethods`,
                                label: t("valuationMethod.label"),
                                tooltip: t("valuationMethod.tooltip"),
                                tPrefix: "accountDetails.unlistedShares.wizard.valuation.methods"
                            }, `valuationMethods-${quotePath}`)
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                        className: "space-y-8 overflow-y-auto mb-8",
                        id: "unlisted-add-valuation-col-2",
                        children: displayedQuestions.map((question)=>{
                            const questionObject = (0, $ef8619896b4579e0$export$2deac3956661e672).find((q)=>q.id === question);
                            if (questionObject.type === "score") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $89040638ce453994$export$2e2bcd8739ae039), {
                                control: control,
                                id: `${quotePath}.${question}`,
                                label: t(`${question}.label`),
                                tooltip: t(`${question}.tooltip`),
                                tPrefix: "accountDetails.unlistedShares.wizard.valuation"
                            }, `${question}-${selectedQuoteIndex}`);
                            if (questionObject.type === "array") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f3384b82e6537d5a$export$2e2bcd8739ae039), (0, $9tqwB._)({
                                formObject: formObject,
                                control: control,
                                currency: props.account.currency,
                                name: `${quotePath}.${question}`,
                                label: t(`${question}.label`),
                                tooltip: t(`${question}.tooltip`)
                            }, questionObject.id === "cashFlowArray" && {
                                namePlaceholder: t("cashFlowArray.namePlaceholder")
                            }), `${question}-${selectedQuoteIndex}`);
                            if (questionObject.type === "number") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), (0, $9tqwB._)({
                                id: `${quotePath}.${question}`,
                                type: "text",
                                register: register,
                                errors: formState.errors,
                                // rate fields have a placeholder which looks like a percentage; the rest are amounts, so they have a placeholder that looks like an amount
                                placeholder: [
                                    "discountRate",
                                    "longTermGrowthRate"
                                ].includes(questionObject.id) ? "8" : "100000",
                                label: t(`${question}.label`),
                                toolTip: t(`${question}.tooltip`),
                                category: "accountDetails.unlistedShares.wizard.valuation",
                                formatting: "w-1/2",
                                optional: false
                            }, questionObject.id === "longTermGrowthRate" && {
                                validationRules: {
                                    validate: (value)=>parseFloat(value) <= currentQuote.discountRate || "Value must be greater than discount rate."
                                }
                            }), `${question}-${selectedQuoteIndex}`);
                            return null;
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: "space-y-8 p-4",
                        id: "unlisted-add-valuation-col-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "border border-gray-100 bg-white round-lg p-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "text-sm font-bold uppercase",
                                        children: t("finalQuote.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-1 mb-2 text-sm",
                                        children: t("finalQuote.description")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        id: `${quotePath}.date`,
                                        type: "date",
                                        register: register,
                                        errors: formState.errors,
                                        placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("YYYY-MM-DD"),
                                        disableLabel: true,
                                        toolTip: t("finalQuote.tooltip"),
                                        category: "accountDetails.unlistedShares.wizard.valuation",
                                        formatting: "w-1/2",
                                        optional: false,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("finalQuote.validation.required")
                                            }
                                        }
                                    }, `date-${quotePath}`),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        id: `${quotePath}.quote`,
                                        type: "text",
                                        register: register,
                                        errors: formState.errors,
                                        placeholder: "100000",
                                        disableLabel: true,
                                        toolTip: t("finalQuote.tooltip"),
                                        category: "accountDetails.unlistedShares.wizard.valuation",
                                        formatting: "w-1/2",
                                        optional: false,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("finalQuote.validation.required")
                                            }
                                        },
                                        currency: props.account.currency
                                    }, `quote-${quotePath}`),
                                    props.account.currency !== baseCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        id: `${quotePath}.quoteBaseCurrency`,
                                        type: "text",
                                        register: register,
                                        errors: formState.errors,
                                        placeholder: "100000",
                                        disableLabel: true,
                                        toolTip: t("finalQuote.tooltip"),
                                        category: "accountDetails.unlistedShares.wizard.valuation",
                                        formatting: "w-1/2",
                                        optional: false,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("finalQuote.validation.required")
                                            }
                                        },
                                        currency: baseCurrency
                                    }, `quoteBaseCurrency-${quotePath}`),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        id: `${quotePath}.percentOwned`,
                                        type: "text",
                                        label: t("percentOwned.label"),
                                        register: register,
                                        errors: formState.errors,
                                        placeholder: "100",
                                        toolTip: t("percentOwned.tooltip"),
                                        category: "accountDetails.unlistedShares.wizard.valuation",
                                        formatting: "w-1/2",
                                        optional: false,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("finalQuote.validation.required")
                                            }
                                        },
                                        currency: "%"
                                    }, `percentOwned-${quotePath}`),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex mt-4 space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: tButtons("previous.label"),
                                                enabled: selectedQuoteIndex !== 0 && !loading,
                                                onClick: ()=>handlePrevNext("previous"),
                                                toolTip: tButtons("previous.tooltip"),
                                                id: "button-previous"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                type: "submit",
                                                text: t("finalQuote.save"),
                                                withAccent: true,
                                                className: "mt-2",
                                                enabled: !fieldSetState.invalid && fieldSetState.isDirty && !deleting,
                                                size: "xl",
                                                spinnerOn: loading
                                            }),
                                            selectedQuoteIndex === totalQuotes - 1 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                type: "button",
                                                text: t("finalQuote.resetThisQuote"),
                                                className: "mt-2",
                                                size: "xl",
                                                onClick: handleResetNewQuote,
                                                enabled: !loading
                                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                type: "button",
                                                text: t("finalQuote.deleteThisQuote"),
                                                className: "mt-2",
                                                size: "xl",
                                                onClick: handleDelete,
                                                enabled: !loading,
                                                spinnerOn: deleting
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: tButtons("next.label"),
                                                enabled: selectedQuoteIndex < totalQuotes - 1 && !loading,
                                                onClick: ()=>handlePrevNext("next"),
                                                toolTip: tButtons("next.tooltip"),
                                                id: "button-next"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (valuationMethods || []).filter((o)=>o.selected).map((methodObject)=>{
                                const value = (0, $ef8619896b4579e0$export$c87e0f149a1d31a9)(methodObject.id, currentQuote);
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                            className: "text-sm font-bold uppercase",
                                            children: tMethods(`${methodObject.id}.label`)
                                        }),
                                        value ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "mt-1 text-xl font-bold",
                                            children: (value || "").toLocaleString("de", {
                                                style: "currency",
                                                currency: props.account.currency,
                                                maximumFractionDigits: 0
                                            })
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "flex space-x-0.5 items-baseline",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-1 text-sm italic text-gray-400",
                                                    children: t("insufficientData")
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                                    formatting: "-mb-1",
                                                    info: t("insufficientDataTooltip", {
                                                        fields: (0, $ef8619896b4579e0$export$34c8d98e36ee1fa9)(methodObject.id, currentQuote).map((x)=>t(`${x}.label`)).join(", ")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, methodObject.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$3c3d6783faa7f601$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        currency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }).isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    unlistedQuoteIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
















(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $d981a2ede56df856$export$2e2bcd8739ae039(props) {
    var _accountTransactions_transactionIndex;
    const { account: account, setAccount: setAccount, handleClick: handleClick } = props;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "unlistedShares.wizard.transactions"
    });
    const { t: tButtons } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    const { register: register, watch: watch, formState: formState, handleSubmit: handleSubmit, reset: reset, getValues: getValues } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: {},
        mode: "onChange"
    });
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [loadingGoToAccount, setLoadingloadingGoToAccount] = (0, $7fPBF.useState)(false);
    const [deleting, setDeleting] = (0, $7fPBF.useState)(false);
    const [newTransactionDraft, setNewTransactionDraft] = (0, $7fPBF.useState)({});
    const selectAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const connectedDepositAccountObjects = selectAccounts.filter((a)=>{
        var _account_connectedDepositAccounts;
        return account === null || account === void 0 ? void 0 : (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.includes(a.id);
    });
    // account disappears when we execute goToAccount, so we need to capture that
    const selectTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_data_unlistedShares, _state_data;
        return ((_state_data = state.data) === null || _state_data === void 0 ? void 0 : (_state_data_unlistedShares = _state_data.unlistedShares) === null || _state_data_unlistedShares === void 0 ? void 0 : _state_data_unlistedShares.transactions) || [];
    });
    const accountTransactions = (0, $7fPBF.useMemo)(()=>(selectTransactions || []).filter((txn)=>txn.accountId === account.id).filter((txn)=>!txn.isSimulated).sort((a, b)=>a.date - b.date).concat([
            {}
        ]), [
        selectTransactions,
        account.id
    ]);
    // null means "new transaction" placeholder (last item)
    const [selectedTransactionId, setSelectedTransactionId] = (0, $7fPBF.useState)(null);
    const transactionIndex = (0, $7fPBF.useMemo)(()=>{
        if (!selectedTransactionId) return accountTransactions.length - 1;
        const foundIndex = accountTransactions.findIndex((txn)=>txn.id === selectedTransactionId);
        return foundIndex >= 0 ? foundIndex : accountTransactions.length - 1;
    }, [
        selectedTransactionId,
        accountTransactions
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const watchTransactionType = watch("transactionType");
    const isNewTransaction = transactionIndex === accountTransactions.length - 1 || !((_accountTransactions_transactionIndex = accountTransactions[transactionIndex]) === null || _accountTransactions_transactionIndex === void 0 ? void 0 : _accountTransactions_transactionIndex.id);
    function resetAndSetIndex(newIndex) {
        const txn = accountTransactions[newIndex];
        setSelectedTransactionId((txn === null || txn === void 0 ? void 0 : txn.id) || null);
        if (!(txn === null || txn === void 0 ? void 0 : txn.id)) {
            reset(newTransactionDraft || {});
            return;
        }
        let txnTransactionType;
        if (txn.quantity === null || txn.quantity === undefined) txnTransactionType = undefined;
        else if (Number(txn.quantity) < 0) txnTransactionType = "sharesSale";
        else txnTransactionType = "moreShares";
        var _txn_upac, _ref, _ref1;
        const txnUpac = (_ref1 = (_ref = (_txn_upac = txn.upac) !== null && _txn_upac !== void 0 ? _txn_upac : txn.uptc) !== null && _ref !== void 0 ? _ref : txn.upbc) !== null && _ref1 !== void 0 ? _ref1 : undefined;
        reset({
            transactionType: txnTransactionType,
            dateUserInput: txn.date ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(txn.date).format("YYYY-MM-DD") : undefined,
            quantity: txn.quantity === null || txn.quantity === undefined ? undefined : Math.abs(Number(txn.quantity)),
            upac: txnUpac === null || txnUpac === undefined ? undefined : Number(txnUpac)
        });
    }
    function handlePrevNext(direction) {
        const newIndex = direction === "next" ? transactionIndex + 1 : transactionIndex - 1;
        if (newIndex < 0 || newIndex >= accountTransactions.length) return;
        if (formState.isDirty) {
            window.dispatchEvent(new CustomEvent("setAlert", {
                detail: {
                    id: "aboutToLoseData",
                    caller: "UnlistedCapitalTransactionWizard",
                    callbackOk: ()=>resetAndSetIndex(newIndex)
                }
            }));
            return;
        }
        if (isNewTransaction) setNewTransactionDraft(getValues());
        resetAndSetIndex(newIndex);
    }
    // If the selected transaction disappears (e.g., deleted elsewhere), fall back to "new" placeholder.
    (0, $7fPBF.useEffect)(()=>{
        if (selectedTransactionId && !accountTransactions.some((txn)=>txn.id === selectedTransactionId)) {
            setSelectedTransactionId(null);
            reset({});
        }
    }, [
        accountTransactions,
        selectedTransactionId,
        reset
    ]);
    function goToAccount(e, a) {
        setLoadingloadingGoToAccount(a.id);
        setAccount(a); // setAccount requires the entire account object
        handleClick("table");
        handleClick("holdings");
    }
    async function onSubmit(data) {
        setLoading(true);
        try {
            // moreCapital and capitalDisbursement require a deposit transaction (the user has been redirected there)
            // for moreShares and sharesSale, create a unlistedShares transaction
            const { transactionType: transactionType, dateUserInput: dateUserInput, upac: upac, quantity: quantity } = data;
            const currentTxn = accountTransactions[transactionIndex];
            const base = !isNewTransaction && (currentTxn === null || currentTxn === void 0 ? void 0 : currentTxn.id) ? currentTxn : (0, $f2b6f6a77877e6cd$export$8eb3d3642b459f58);
            const transaction = (0, $2qxEV._)((0, $9tqwB._)({}, base), {
                id: !isNewTransaction && (currentTxn === null || currentTxn === void 0 ? void 0 : currentTxn.id) ? currentTxn.id : (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: account.id,
                assetId: account.id,
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(dateUserInput).valueOf(),
                quantity: transactionType === "moreShares" ? Number(quantity) : -Number(quantity),
                upac: Number(upac),
                accountCurrency: account.currency,
                assetCurrency: account.currency,
                upbc: null,
                uptc: null,
                transactionCurrency: null,
                isSimulated: false,
                importFlag: isNewTransaction ? "post" : "put"
            });
            await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                data: [
                    (0, $9tqwB._)({}, transaction)
                ],
                category: "unlistedShares",
                accountId: account.id
            }));
            // go back to table
            handleClick("table");
        } catch (error) {
            // handle errors
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
        setLoading(false);
    }
    function handleDelete() {
        if (deleting) return;
        setDeleting(true);
        // If this is a saved transaction, delete it; if this is the "new" entry, clear it when dirty.
        if (!isNewTransaction || formState.isDirty) {
            window.dispatchEvent(new CustomEvent("setAlert", {
                detail: {
                    id: "youAreAboutToDeleteTransaction",
                    caller: "UnlistedCapitalTransactionWizard",
                    callbackOk: async ()=>{
                        try {
                            if (!isNewTransaction) {
                                const txn = accountTransactions[transactionIndex];
                                await dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                                    data: [
                                        (0, $2qxEV._)((0, $9tqwB._)({}, txn), {
                                            importFlag: "delete"
                                        })
                                    ],
                                    category: "unlistedShares",
                                    accountId: account.id
                                }));
                                handleClick("table");
                            } else {
                                setNewTransactionDraft({});
                                resetAndSetIndex(accountTransactions.length - 1);
                            }
                        } catch (err) {
                            console.error(err);
                        } finally{
                            setDeleting(false);
                        }
                    },
                    callbackCancel: ()=>setDeleting(false)
                }
            }));
            return;
        }
        setDeleting(false);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full h-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d158b048a3c62bc$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                buttonsToShow: (0, $f808db98154b70a0$export$2e2bcd8739ae039)("unlistedShares", "wizard", "holdings"),
                handlePrevNext: handlePrevNext
            })),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                className: "w-full h-full grid lg:grid-cols-2 2xl:grid-cols-3 py-8 px-2",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-8",
                        name: "account-details-unlisted-capital-option",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "font-bold text-base sm:text-lg",
                                children: t("header")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "moreShares",
                                                name: "moreShares",
                                                type: "radio",
                                                value: "moreShares",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("transactionType", {
                                                required: {
                                                    value: true,
                                                    message: t("error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "moreShares",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("moreShares")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "moreCapital",
                                                name: "moreCapital",
                                                type: "radio",
                                                value: "moreCapital",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("transactionType", {
                                                required: {
                                                    value: true,
                                                    message: t("error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "moreCapital",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("moreCapital")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "capitalDisbursement",
                                                name: "capitalDisbursement",
                                                type: "radio",
                                                value: "capitalDisbursement",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("transactionType", {
                                                required: {
                                                    value: true,
                                                    message: t("error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "capitalDisbursement",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("capitalDisbursement")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                id: "sharesSale",
                                                name: "sharesSale",
                                                type: "radio",
                                                value: "sharesSale",
                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                            }, register("transactionType", {
                                                required: {
                                                    value: true,
                                                    message: t("error")
                                                }
                                            }))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "sharesSale",
                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                children: t("sharesSale")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-2 text-sm text-red-500",
                                        id: "connectedDepositMode-error",
                                        children: formState.errors.transactionType && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: formState.errors.transactionType.message
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    watchTransactionType ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-8 flex flex-col",
                        name: "account-details-unlisted-capital-form",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "font-bold text-base sm:text-lg",
                                children: t("formHeader")
                            }),
                            (watchTransactionType === "moreShares" || watchTransactionType === "sharesSale") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        formatting: "w-1/2",
                                        id: "dateUserInput",
                                        type: "date",
                                        autoComplete: "off",
                                        label: t("dateUserInput.label"),
                                        toolTip: t("dateUserInput.tooltip"),
                                        placeholder: "2",
                                        register: register,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("dateUserInput.error")
                                            }
                                        },
                                        errors: formState.errors,
                                        optional: false
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        formatting: "w-1/2",
                                        id: "quantity",
                                        type: "number",
                                        autoComplete: "off",
                                        label: t("quantity.label"),
                                        toolTip: t("quantity.tooltip"),
                                        placeholder: "2",
                                        register: register,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("quantity.error")
                                            }
                                        },
                                        errors: formState.errors,
                                        optional: false
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $40da1649d64ec77d$export$2e2bcd8739ae039), {
                                        formatting: "w-1/2",
                                        id: "upac",
                                        type: "number",
                                        autoComplete: "off",
                                        label: t("upac.label"),
                                        toolTip: t("upac.tooltip"),
                                        placeholder: "2",
                                        register: register,
                                        validationRules: {
                                            required: {
                                                value: true,
                                                message: t("upac.error")
                                            }
                                        },
                                        errors: formState.errors,
                                        currency: account.currency,
                                        optional: false
                                    })
                                ]
                            }),
                            watchTransactionType === "moreCapital" || watchTransactionType === "capitalDisbursement" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "col-span-3 prose text-sm text-gray-500",
                                        children: t("clickToOpenDeposit")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-4 mt-8",
                                        children: [
                                            connectedDepositAccountObjects.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-brandBlue-300"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-gray-500 italic text-sm",
                                                        children: t("noConnectedDeposit")
                                                    })
                                                ]
                                            }),
                                            connectedDepositAccountObjects.map((a)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: "p-4 bg-white border border-gray-300 rounded-lg shadow-sm text-center hover:bg-gray-50",
                                                    type: "button",
                                                    onClick: (e)=>goToAccount(e, a),
                                                    children: loadingGoToAccount === a.id ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                        className: "w-5 h-5 text-gray-400 animate-spin"
                                                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-gray-500 font-bold text-sm truncate uppercase",
                                                        children: a.name
                                                    })
                                                }, a.id))
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        id: "wizard-nav-bar",
                        className: "col-start-1 lg:col-span-2",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex space-x-8 justify-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: tButtons("previous.label"),
                                    enabled: transactionIndex !== 0,
                                    onClick: ()=>handlePrevNext("previous"),
                                    toolTip: tButtons("previous.tooltip"),
                                    id: "button-previous"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            formatting: "col-start-3",
                                            text: t("submit"),
                                            type: "submit",
                                            withAccent: true,
                                            size: "lg",
                                            spinnerOn: loading,
                                            enabled: formState.isValid && formState.isDirty && !deleting
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            text: t("deleteThisTransaction"),
                                            type: "button",
                                            size: "lg",
                                            onClick: handleDelete,
                                            enabled: !loading && (formState.isDirty || !isNewTransaction),
                                            spinnerOn: deleting
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                    text: tButtons("next.label"),
                                    enabled: transactionIndex < accountTransactions.length - 1,
                                    onClick: ()=>handlePrevNext("next"),
                                    toolTip: tButtons("next.tooltip"),
                                    id: "button-next"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$d981a2ede56df856$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    handleClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


var $c9019d03acfc5b8b$exports = {};

$parcel$export($c9019d03acfc5b8b$exports, "schemaArray", function () { return $c9019d03acfc5b8b$export$b523cf4afaecec08; });
$parcel$export($c9019d03acfc5b8b$exports, "schemaTransaction", function () { return $c9019d03acfc5b8b$export$2e643d9c6d47e82; });
$parcel$export($c9019d03acfc5b8b$exports, "classNames", function () { return $c9019d03acfc5b8b$export$ce4ab0c55987d1ff; });
$parcel$export($c9019d03acfc5b8b$exports, "colWidths", function () { return $c9019d03acfc5b8b$export$65de1097d86bfc68; });
$parcel$export($c9019d03acfc5b8b$exports, "attrs", function () { return $c9019d03acfc5b8b$export$50f64d880cf4cd06; });

const $c9019d03acfc5b8b$export$b523cf4afaecec08 = (0, $2119005918cddc33$export$3c400324181e2c4d);
const $c9019d03acfc5b8b$export$2e643d9c6d47e82 = (0, $2119005918cddc33$export$d0605de541b472d8);
function $c9019d03acfc5b8b$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $c9019d03acfc5b8b$export$65de1097d86bfc68 = {
    date: 100,
    otherParty: 150,
    description: 450,
    amount: 100
};
const $c9019d03acfc5b8b$export$50f64d880cf4cd06 = {
    name: "accountName"
};


var $fa5ca380be305463$exports = {};

$parcel$export($fa5ca380be305463$exports, "schemaArray", function () { return $fa5ca380be305463$export$b523cf4afaecec08; });
$parcel$export($fa5ca380be305463$exports, "schemaTransaction", function () { return $fa5ca380be305463$export$2e643d9c6d47e82; });
$parcel$export($fa5ca380be305463$exports, "colWidths", function () { return $fa5ca380be305463$export$65de1097d86bfc68; });
$parcel$export($fa5ca380be305463$exports, "attrs", function () { return $fa5ca380be305463$export$50f64d880cf4cd06; });
/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-filename-extension */ 
const $fa5ca380be305463$export$b523cf4afaecec08 = (0, $258697da394e7920$export$9890c99050a7d78e);
const $fa5ca380be305463$export$2e643d9c6d47e82 = (0, $258697da394e7920$export$4f051dd78ba8e887);
const $fa5ca380be305463$export$65de1097d86bfc68 = {
    date: 100,
    otherParty: 150,
    description: 450,
    amount: 100
};
const $fa5ca380be305463$export$50f64d880cf4cd06 = {
    name: "accountName"
};


var $33d0958eb68159ed$exports = {};

$parcel$export($33d0958eb68159ed$exports, "colWidths", function () { return $33d0958eb68159ed$export$65de1097d86bfc68; });
$parcel$export($33d0958eb68159ed$exports, "attrs", function () { return $33d0958eb68159ed$export$50f64d880cf4cd06; });
$parcel$export($33d0958eb68159ed$exports, "realEstateTotal", function () { return $33d0958eb68159ed$export$349c2656c834c72c; });
// ACCOUNTDETAILS ----------------------------------------------------------------------------------------------------

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $33d0958eb68159ed$export$65de1097d86bfc68 = {
    date: 100,
    otherParty: 150,
    description: 450,
    amount: 100
};
const $33d0958eb68159ed$export$50f64d880cf4cd06 = {
    name: "accountName"
};
function $33d0958eb68159ed$export$349c2656c834c72c(transactionArray, valuationArray, maxDate) {
    function getMostRecentValuation(accountId) {
        return (valuationArray.filter((item)=>item.assetId === accountId && item.date <= maxDate).sort((a, b)=>b.date - a.date)[0] || [] // sort by date descending, take first element
        ).quoteBaseCurrency;
    }
    // group transactions by account and sum up the amounts
    const amountByAccountId = transactionArray === null || transactionArray === void 0 ? void 0 : transactionArray.reduce((prev, curr)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
            [curr.accountId]: (prev[curr.accountId] || 0) + curr.amount
        }), {});
    // result is: { accountId1: 1, accountId2: 0, accountId3: 1, ... }
    // for each resulting account, multiply the sum of amount by the latest valuation for that amount
    // sum up all the resulting amounts
    // 'curr' is the key of amountByAccountId, which is the accountId
    return Object.keys(amountByAccountId || []).reduce((prev, curr)=>prev + amountByAccountId[curr] * getMostRecentValuation(curr), 0);
}


var $a7b27088d0ccbcf9$exports = {};

$parcel$export($a7b27088d0ccbcf9$exports, "schemaArray", function () { return $a7b27088d0ccbcf9$export$b523cf4afaecec08; });
$parcel$export($a7b27088d0ccbcf9$exports, "schemaTransaction", function () { return $a7b27088d0ccbcf9$export$2e643d9c6d47e82; });
$parcel$export($a7b27088d0ccbcf9$exports, "classNames", function () { return $a7b27088d0ccbcf9$export$ce4ab0c55987d1ff; });
$parcel$export($a7b27088d0ccbcf9$exports, "colWidths", function () { return $a7b27088d0ccbcf9$export$65de1097d86bfc68; });
$parcel$export($a7b27088d0ccbcf9$exports, "attrs", function () { return $a7b27088d0ccbcf9$export$50f64d880cf4cd06; });

const $a7b27088d0ccbcf9$export$b523cf4afaecec08 = (0, $5c401a4958c7a09c$export$a856f17095d848d7);
const $a7b27088d0ccbcf9$export$2e643d9c6d47e82 = (0, $5c401a4958c7a09c$export$95eff6423824c31b);
function $a7b27088d0ccbcf9$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
const $a7b27088d0ccbcf9$export$65de1097d86bfc68 = {
    date: 100,
    otherPartyIban: 150,
    description: 450
};
const $a7b27088d0ccbcf9$export$50f64d880cf4cd06 = {
    name: "accountName"
};


function $ea57824afe1bf3f3$export$2e2bcd8739ae039(category) {
    switch(category){
        case "deposits":
            return $c9019d03acfc5b8b$exports;
        case "stocks":
            return $fa5ca380be305463$exports;
        case "realEstate":
            return $33d0958eb68159ed$exports;
        case "loans":
            return $a7b27088d0ccbcf9$exports;
        default:
            return {};
    }
}




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $09a3181ea7eaeecc$var$XCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
        clipRule: "evenodd"
    }));
}
const $09a3181ea7eaeecc$var$ForwardRef = $7fPBF.forwardRef($09a3181ea7eaeecc$var$XCircleIcon);
var $09a3181ea7eaeecc$export$2e2bcd8739ae039 = $09a3181ea7eaeecc$var$ForwardRef;



function $8e0c1e291bc90f03$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $8e0c1e291bc90f03$export$2e2bcd8739ae039({ parentValue: parentValue, stub: stub, formatting: formatting, callback: callback, propertyName: propertyName, showButtons: showButtons }) {
    // formatting needs a string
    // value (String) - current value of the input field as registered in the parent component
    // stub is the label displayed if 'attr' property of account is null (should come translated)
    // callback is an async function which is executed once user clicks OK or presses Enter;
    // it should return the result of dispatch (which is a promise in RTK mode); callback({ propertyName, newValue })
    // propertyName (String) - used in id of the input field (`${propertyName}-input`)
    // showButtons declares if the OK and X buttons are to be shown
    const [initialValue, setInitialValue] = (0, $7fPBF.useState)(parentValue);
    const [currentValue, setCurrentValue] = (0, $7fPBF.useState)(parentValue);
    const [editMode, setEditMode] = (0, $7fPBF.useState)(false);
    const [isUpdating, setUpdating] = (0, $7fPBF.useState)(false);
    const [widthState, setWidthState] = (0, $7fPBF.useState)(null); // width directive will be omitted by renderer until it is properly set
    const [spanVisible, setSpanVisible] = (0, $7fPBF.useState)(false); // turns on and off the span component for a fraction of a sec, trick to measure / resize input field
    // ^^  turn this true for debug if there are any issues with length of the field
    const measurer = (0, $7fPBF.useRef)(null);
    const myInputField = (0, $7fPBF.useRef)(null);
    // routines for resizing the input field
    (0, $7fPBF.useEffect)(()=>{
        // toggles the visibility of span and activates useLayoutEffect
        setSpanVisible(true);
    }, [
        currentValue,
        isUpdating
    ]);
    (0, $7fPBF.useLayoutEffect)(()=>{
        // measures the span size and updates the state, switches span visibility to false
        if (spanVisible && (measurer === null || measurer === void 0 ? void 0 : measurer.current)) {
            const rect = measurer.current.getBoundingClientRect();
            if (showButtons) setWidthState(rect.width + 24 /* account for padding */  + 72 /* account for yes / no icons */ );
            else setWidthState(rect.width + (isUpdating ? 24 : 0));
            setSpanVisible(false); // triggers the measurement
        }
    }, [
        spanVisible,
        isUpdating
    ]);
    // end of routines for resizing input field
    // if the focus is lost, and we are not updating the field to a new value, restore the old value
    (0, $7fPBF.useEffect)(()=>{
        if (!isUpdating) setCurrentValue(initialValue);
    }, [
        editMode
    ]);
    // if value passed from parent changes, update the state
    (0, $7fPBF.useEffect)(()=>{
        setInitialValue(parentValue);
        setCurrentValue(parentValue);
    }, [
        parentValue
    ]);
    function handleFieldCancel(e) {
        setEditMode(false);
    // myInputField.current.blur();
    // setVisible(true); // just take a measurement of the span
    }
    async function handleFieldOk(e, mode) {
        if (mode === "key" && e.key !== "Enter") return;
        setEditMode(false);
        setUpdating(true);
        if ((mode === "key" && e.key === "Enter" || mode === "button") && currentValue !== initialValue) try {
            const result = await callback({
                propertyName: propertyName,
                newValue: currentValue
            }); // callback should perform the put operation and return the promise from dispatch
            setUpdating(false); // name should be updated via useEffect above (when 'value' prop changes)
            setEditMode(false);
            myInputField.current.blur();
        } catch (err) {
            setUpdating(false); // callback should take care of displaying the error message, as we are just a dumb component
        }
    }
    const permanentFormatting = $8e0c1e291bc90f03$export$ce4ab0c55987d1ff(isUpdating ? "opacity-50 " : "", "bg-gray-50 border-none rounded pl-0 sm:pl-1.5", formatting, "hover:underline hover:cursor-pointer truncate focus:cursor-text focus:ring-1 focus:ring-offset-0 focus:outline-none focus:ring-brandBlue-400");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
        htmlFor: `${propertyName}-input`,
        className: "relative h-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: $8e0c1e291bc90f03$export$ce4ab0c55987d1ff(formatting, permanentFormatting),
                ref: measurer,
                children: spanVisible && (currentValue || stub)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                className: permanentFormatting,
                style: {
                    width: widthState
                },
                id: `${propertyName}-input`,
                ref: myInputField,
                disabled: isUpdating,
                hidden: spanVisible,
                placeholder: stub,
                value: currentValue,
                onChange: (e)=>setCurrentValue(e.target.value),
                onKeyPress: (e)=>handleFieldOk(e, "key"),
                onFocus: ()=>setEditMode(true),
                onBlur: (e)=>{
                    // a short timeout to delay the blur event until the onclick event of the buttons have been processed
                    setTimeout(()=>handleFieldCancel(e), 150);
                },
                type: "text"
            }),
            isUpdating && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute flex top-0 right-0 h-full space-x-2 pr-2 z-10",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                    className: $8e0c1e291bc90f03$export$ce4ab0c55987d1ff(showButtons ? "h-5 w-5 -mt-1 ml-2 mr-3" : "h-3 w-3 -ml-2 mt-1", "animate-spin text-gray-500 text-sm")
                })
            }),
            editMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "absolute flex right-0 top-0 h-full space-x-2 pr-2 z-10",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: (e)=>handleFieldOk(e, "button"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef0832052dc462d9$export$2e2bcd8739ae039), {
                            className: $8e0c1e291bc90f03$export$ce4ab0c55987d1ff(showButtons ? "h-6 w-6" : "hidden", "text-gray-300 hover:text-gray-400 hover:cursor-pointer")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: (e)=>{
                            // a short timeout to delay the blur event until the onclick event of the buttons have been processed
                            setTimeout(()=>{
                                handleFieldCancel(e);
                            }, 150);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09a3181ea7eaeecc$export$2e2bcd8739ae039), {
                            className: $8e0c1e291bc90f03$export$ce4ab0c55987d1ff(showButtons ? "h-6 w-6" : "hidden", "text-gray-300 hover:text-gray-400 hover:cursor-pointer")
                        })
                    })
                ]
            })
        ]
    });
}
$8e0c1e291bc90f03$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    stub: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    parentValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    propertyName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    showButtons: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$8e0c1e291bc90f03$export$2e2bcd8739ae039.defaultProps = {
    showButtons: true
};


/* eslint-disable no-underscore-dangle */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $0a2a89f0f88dbf41$var$EllipsisVerticalIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11.5 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
    }));
}
const $0a2a89f0f88dbf41$var$ForwardRef = $7fPBF.forwardRef($0a2a89f0f88dbf41$var$EllipsisVerticalIcon);
var $0a2a89f0f88dbf41$export$2e2bcd8739ae039 = $0a2a89f0f88dbf41$var$ForwardRef;









/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $ffe9b39b7aac6d84$export$2e2bcd8739ae039({ formValues: formValues, header: header, prompt: prompt, callback: callback, valueDropdown: valueDropdown = [
    1,
    3,
    12
] }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const { register: register, control: control, handleSubmit: handleSubmit, formState: { errors: errors }, setError: setError, clearErrors: clearErrors } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: {
            table: formValues.map((item)=>({
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.effectiveDate).format("YYYY-MM-DD"),
                    value: item.value
                }))
        }
    });
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "table",
        control: control
    });
    // TODO get user a picklist for period with human-readable values
    async function onSubmit(data) {
        setLoading(true);
        try {
            // we need to make sure there is at least 1 row in 'table'
            if (data.table.length < 1) setError("table", {
                type: "custom",
                message: t("errorOneRowRequired")
            });
            else clearErrors("table");
            // we need to return the initial object to caller
            if (data.table.length > 0) {
                const result = data.table.map((item)=>({
                        effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.date).valueOf(),
                        value: item.value
                    }));
                await callback(result);
            }
            setLoading(false);
            window.dispatchEvent(new CustomEvent("setDialog"));
        } catch (error) {
            setLoading(false);
            console.error("AttributeArrayOfObjectsForm error:", error);
        }
    }
    function onCancel() {
        window.dispatchEvent(new CustomEvent("setDialog"));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto max-w-md transform overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all p-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-brandBlue-100",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91420ff1f0fec24c$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-brandBlue-500",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-3 text-center sm:mt-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-lg leading-6 font-bold text-gray-900",
                        children: header
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: prompt
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-4 grid grid-cols-[auto,auto,50px] gap-3 text-sm xs:text-base items-start",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "ml-1 -mb-1 text-sm text-left",
                                children: t("effectiveDate")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "ml-1 -mb-1 text-sm text-left",
                                children: t("value")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                            fields.map((item, index)=>{
                                var _errors_table_index, _errors_table, _errors_table_index1, _errors_table1;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "date",
                                                    id: `date-${index}`,
                                                    name: `date-${index}`,
                                                    className: "block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                                }, register(`table.${index}.date`, {
                                                    required: true
                                                }))),
                                                ((_errors_table = errors.table) === null || _errors_table === void 0 ? void 0 : (_errors_table_index = _errors_table[index]) === null || _errors_table_index === void 0 ? void 0 : _errors_table_index.date) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "text-xs text-red-500",
                                                    children: t("errorFieldRequired")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                valueDropdown ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                    name: `table.${index}.value`,
                                                    control: control,
                                                    render: ({ field: field, ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                            label: "",
                                                            value: field.value,
                                                            list: valueDropdown,
                                                            onChange: field.onChange,
                                                            onBlur: field.onBlur,
                                                            inputRef: ref,
                                                            optional: false
                                                        })
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "number",
                                                    step: 3,
                                                    name: `value-${index}`,
                                                    id: `value-${index}`,
                                                    className: "block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                                }, register(`table.${index}.value`, {
                                                    required: true
                                                }))),
                                                ((_errors_table1 = errors.table) === null || _errors_table1 === void 0 ? void 0 : (_errors_table_index1 = _errors_table1[index]) === null || _errors_table_index1 === void 0 ? void 0 : _errors_table_index1.value) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "text-xs text-red-500",
                                                    children: t("errorFieldRequired")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            Icon: (0, $125f450ca02db1e2$export$2e2bcd8739ae039),
                                            onClick: ()=>remove(index),
                                            size: "lg"
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                Icon: (0, $dc348e8ecf02df23$export$2e2bcd8739ae039),
                                onClick: ()=>append(),
                                formatting: "w-12"
                            })
                        ]
                    }),
                    errors.table && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "text-xs text-red-500",
                        children: t("errorOneRowRequired")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-center mt-4 space-x-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: "Save",
                                type: "submit",
                                size: "lg",
                                withAccent: true,
                                onClick: handleSubmit(onSubmit),
                                spinnerOn: loading
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                size: "lg",
                                onClick: onCancel
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$ffe9b39b7aac6d84$export$2e2bcd8739ae039.propTypes = {
    formValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    prompt: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    valueDropdown: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array
};
$ffe9b39b7aac6d84$export$2e2bcd8739ae039.defaultProps = {
    valueDropdown: null
};


/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");









(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $e9942f42daec66e7$export$2e2bcd8739ae039({ formValues: formValues, header: header, prompt: prompt, callback: callback }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const { t: tSchema } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema.pension.account.parameters"
    });
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const { register: register, control: control, handleSubmit: handleSubmit, formState: { errors: errors }, setError: setError, clearErrors: clearErrors } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: {
            table: formValues
        }
    });
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "table",
        control: control
    });
    // TODO convert quote and quoteBaseCurrency from text to number before submitting
    async function onSubmit(data) {
        setLoading(true);
        try {
            // if there are data in form state or there were data as input (handle delete)
            if (data.table.length > 0 || formValues.length > 0) {
                const result = data.table.map((item)=>({
                        type: item.type.id,
                        quote: Number(item.quote),
                        quoteBaseCurrency: Number(item.quoteBaseCurrency)
                    }));
                await callback(result);
            }
            setLoading(false);
            window.dispatchEvent(new CustomEvent("setDialog"));
        } catch (error) {
            setLoading(false);
            console.error("AttributeArrayOfObjectsForm error:", error);
        }
    }
    function onCancel() {
        window.dispatchEvent(new CustomEvent("setDialog"));
    }
    const types = tSchema("useSpecialQuote", {
        returnObjects: true
    });
    const valueDropdown = Object.entries(types).map(([key, value])=>({
            id: key,
            name: value
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mx-auto max-w-xl transform overflow-hidden rounded-lg bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all p-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-brandBlue-100",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91420ff1f0fec24c$export$2e2bcd8739ae039), {
                    className: "h-6 w-6 text-brandBlue-500",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-3 text-center sm:mt-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "text-lg leading-6 font-bold text-gray-900",
                        children: header
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-2 text-sm text-gray-500",
                        children: prompt
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-4 grid grid-cols-12 gap-3 text-sm xs:text-base items-start",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "col-span-7 ml-1 -mb-1 text-sm text-left",
                                children: t("estimateType")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "col-span-2 ml-1 -mb-1 text-sm text-left",
                                children: t("quote")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "col-span-2 ml-1 -mb-1 text-sm text-left",
                                children: t("quoteInCurrency", {
                                    currency: baseCurrency
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                            fields.map((item, index)=>{
                                var _errors_table_index, _errors_table, _errors_table_index_quote, _errors_table_index1, _errors_table1, _errors_table_index2, _errors_table2, _errors_table_index_quote1, _errors_table_index3, _errors_table3, _errors_table_index4, _errors_table4, _errors_table_index_quote2, _errors_table_index5, _errors_table5, _errors_table_index6, _errors_table6, _errors_table_index_quoteBaseCurrency, _errors_table_index7, _errors_table7, _errors_table_index8, _errors_table8, _errors_table_index_quoteBaseCurrency1, _errors_table_index9, _errors_table9, _errors_table_index10, _errors_table10, _errors_table_index_quoteBaseCurrency2, _errors_table_index11, _errors_table11;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "col-span-7",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                name: `table.${index}.type`,
                                                control: control,
                                                rules: {
                                                    required: true
                                                },
                                                render: ({ field: field, ref: ref })=>{
                                                    var _errors_table_index_type, _errors_table_index, _errors_table;
                                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                        label: "",
                                                        value: field.value,
                                                        list: valueDropdown,
                                                        onChange: field.onChange,
                                                        onBlur: field.onBlur,
                                                        inputRef: ref,
                                                        optional: false,
                                                        extraWide: true,
                                                        keepItShort: true,
                                                        errorMessage: ((_errors_table = errors.table) === null || _errors_table === void 0 ? void 0 : (_errors_table_index = _errors_table[index]) === null || _errors_table_index === void 0 ? void 0 : (_errors_table_index_type = _errors_table_index.type) === null || _errors_table_index_type === void 0 ? void 0 : _errors_table_index_type.type) === "required" ? t("errorFieldRequired") : ""
                                                    });
                                                }
                                            })
                                        }, item.type),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "text",
                                                    name: `value-${index}`,
                                                    id: `value-${index}`,
                                                    autoComplete: "off",
                                                    className: "block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                                }, register(`table.${index}.quote`, {
                                                    required: true,
                                                    min: 0,
                                                    pattern: /^[0-9]+$/
                                                }))),
                                                ((_errors_table = errors.table) === null || _errors_table === void 0 ? void 0 : (_errors_table_index = _errors_table[index]) === null || _errors_table_index === void 0 ? void 0 : _errors_table_index.quote) && ((_errors_table1 = errors.table) === null || _errors_table1 === void 0 ? void 0 : (_errors_table_index1 = _errors_table1[index]) === null || _errors_table_index1 === void 0 ? void 0 : (_errors_table_index_quote = _errors_table_index1.quote) === null || _errors_table_index_quote === void 0 ? void 0 : _errors_table_index_quote.type) === "pattern" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xs text-red-500 mt-1",
                                                    children: t("errorMustBeNumber")
                                                }),
                                                ((_errors_table2 = errors.table) === null || _errors_table2 === void 0 ? void 0 : (_errors_table_index2 = _errors_table2[index]) === null || _errors_table_index2 === void 0 ? void 0 : _errors_table_index2.quote) && ((_errors_table3 = errors.table) === null || _errors_table3 === void 0 ? void 0 : (_errors_table_index3 = _errors_table3[index]) === null || _errors_table_index3 === void 0 ? void 0 : (_errors_table_index_quote1 = _errors_table_index3.quote) === null || _errors_table_index_quote1 === void 0 ? void 0 : _errors_table_index_quote1.type) === "required" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xs text-red-500 mt-1",
                                                    children: t("errorFieldRequired")
                                                }),
                                                ((_errors_table4 = errors.table) === null || _errors_table4 === void 0 ? void 0 : (_errors_table_index4 = _errors_table4[index]) === null || _errors_table_index4 === void 0 ? void 0 : _errors_table_index4.quote) && ((_errors_table5 = errors.table) === null || _errors_table5 === void 0 ? void 0 : (_errors_table_index5 = _errors_table5[index]) === null || _errors_table_index5 === void 0 ? void 0 : (_errors_table_index_quote2 = _errors_table_index5.quote) === null || _errors_table_index_quote2 === void 0 ? void 0 : _errors_table_index_quote2.type) === "min" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xs text-red-500 mt-1",
                                                    children: t("errorMustBePositive")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "col-span-2",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "text",
                                                    name: `value-${index}`,
                                                    id: `value-${index}`,
                                                    autoComplete: "off",
                                                    className: "col-span-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-gray-900 focus:outline-none focus:ring-gray-900 sm:text-sm"
                                                }, register(`table.${index}.quoteBaseCurrency`, {
                                                    required: true,
                                                    min: 0,
                                                    pattern: /^[0-9]+$/
                                                }))),
                                                ((_errors_table6 = errors.table) === null || _errors_table6 === void 0 ? void 0 : (_errors_table_index6 = _errors_table6[index]) === null || _errors_table_index6 === void 0 ? void 0 : _errors_table_index6.quoteBaseCurrency) && ((_errors_table7 = errors.table) === null || _errors_table7 === void 0 ? void 0 : (_errors_table_index7 = _errors_table7[index]) === null || _errors_table_index7 === void 0 ? void 0 : (_errors_table_index_quoteBaseCurrency = _errors_table_index7.quoteBaseCurrency) === null || _errors_table_index_quoteBaseCurrency === void 0 ? void 0 : _errors_table_index_quoteBaseCurrency.type) === "pattern" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xs text-red-500 mt-1",
                                                    children: t("errorMustBeNumber")
                                                }),
                                                ((_errors_table8 = errors.table) === null || _errors_table8 === void 0 ? void 0 : (_errors_table_index8 = _errors_table8[index]) === null || _errors_table_index8 === void 0 ? void 0 : _errors_table_index8.quoteBaseCurrency) && ((_errors_table9 = errors.table) === null || _errors_table9 === void 0 ? void 0 : (_errors_table_index9 = _errors_table9[index]) === null || _errors_table_index9 === void 0 ? void 0 : (_errors_table_index_quoteBaseCurrency1 = _errors_table_index9.quoteBaseCurrency) === null || _errors_table_index_quoteBaseCurrency1 === void 0 ? void 0 : _errors_table_index_quoteBaseCurrency1.type) === "required" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xs text-red-500 mt-1",
                                                    children: t("errorFieldRequired")
                                                }),
                                                ((_errors_table10 = errors.table) === null || _errors_table10 === void 0 ? void 0 : (_errors_table_index10 = _errors_table10[index]) === null || _errors_table_index10 === void 0 ? void 0 : _errors_table_index10.quoteBaseCurrency) && ((_errors_table11 = errors.table) === null || _errors_table11 === void 0 ? void 0 : (_errors_table_index11 = _errors_table11[index]) === null || _errors_table_index11 === void 0 ? void 0 : (_errors_table_index_quoteBaseCurrency2 = _errors_table_index11.quoteBaseCurrency) === null || _errors_table_index_quoteBaseCurrency2 === void 0 ? void 0 : _errors_table_index_quoteBaseCurrency2.type) === "min" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "text-xs text-red-500 mt-1",
                                                    children: t("errorMustBePositive")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            Icon: (0, $125f450ca02db1e2$export$2e2bcd8739ae039),
                                            onClick: ()=>remove(index),
                                            size: "lg",
                                            formatting: "self-stretch pl-0 pr-0"
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                Icon: (0, $dc348e8ecf02df23$export$2e2bcd8739ae039),
                                onClick: ()=>append(),
                                formatting: "w-12"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-center mt-4 space-x-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: "Save",
                                type: "submit",
                                size: "lg",
                                withAccent: true,
                                onClick: handleSubmit(onSubmit),
                                spinnerOn: loading
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                size: "lg",
                                onClick: onCancel
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$e9942f42daec66e7$export$2e2bcd8739ae039.propTypes = {
    formValues: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    prompt: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $95460cc8ecb951e0$var$parseIf(exp) {
    return typeof exp === "string" ? JSON.parse(exp) : exp;
}
function $95460cc8ecb951e0$var$LabelPair({ label: label, value: value, menuMode: menuMode }) {
    $95460cc8ecb951e0$var$LabelPair.propTypes = {
        label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
                null
            ])
        ]).isRequired,
        menuMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
    };
    $95460cc8ecb951e0$var$LabelPair.defaultProps = {
        menuMode: false
    };
    let calculatedValue = value;
    if (typeof value === "number") {
        // round to 2 decimal places
        const stringValue = value.toFixed(2);
        // eliminate all decimal 0s, then eliminate trailing decimal point
        calculatedValue = Number(stringValue.replace(/\.0+$/, "").replace(/\.$/, ""));
    }
    if (value === true || value === false) calculatedValue = value ? "\u2714\uFE0F" : "\u2716\uFE0F";
    if (value === null || value === "") calculatedValue = "\u2014";
    if (Array.isArray(value)) {
        const arrayLength = value.length;
        // if (arrayLength > 0) calculatedValue = `[${value.length}]`;
        if (arrayLength > 0) calculatedValue = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "px-2 rounded-sm bg-gray-300 text-white font-bold text-xs",
            children: value.length
        });
        else calculatedValue = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ac26489e86e9865$export$2e2bcd8739ae039), {
            className: "w-4 h-4 text-brandRed-400"
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "text-gray-400",
                id: "link-attribute-label",
                children: label
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: `pl-1.5 text-gray-700 ${value === true || value === false ? "text-xs" : ""}`,
                id: "link-attribute-value",
                children: calculatedValue
            })
        ]
    });
}
function $95460cc8ecb951e0$export$2e2bcd8739ae039({ account: account }) {
    const [barIsVisible, setBarIsVisible] = (0, $7fPBF.useState)(true);
    const containerRef = (0, $7fPBF.useRef)(null);
    const overflowButtonRef = (0, $7fPBF.useRef)(null);
    const labelPairsRefs = (0, $7fPBF.useRef)([]); // holds an array of refs for each labelpair
    const [subtypeList, setSubtypeList] = (0, $7fPBF.useState)([]);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: `schema.${account.category}.account`
    });
    const { t: tG } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema"
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const depositAccounts = accounts.filter((x)=>x.category === "deposits");
    const projects = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects);
    const quotes = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$443f4a6ebd922e0a));
    // get a list of account fields from schema that we want to display to access lists for dropdowns as well as verify boolean values
    const schema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(account.category, "account");
    // handle accounts for categories that have valuationParameters (rE) and those without (d, s)
    const accountSchemaObject = account.valuationParameters ? schema.describe().fields.valuationParameters.fields : schema.describe().fields;
    // ↑↑ object of { field1: { type: 'string', _whitelist: ... }, field2: { type: 'number', _whitelist: ... }, ... }
    // _whitelist contains the oneOf members; its a ReferenceSet class instance; size property is the number of members
    // list of non-editable fields which should not be shown to user
    // INFO: this can also be stored in all the schemas (.meta), but for now it seems it is easier to maintain it here
    // (to maintain it in schema see how it is done, look up hideFromImport)
    // eslint-disable-next-line max-len
    const nonEditableFields = [
        "id",
        "name",
        "userId",
        "tags",
        "status",
        "syncType",
        "category",
        "currency",
        "statusTimestamp",
        "lastMarketPriceRetrieved",
        "importFileMappings",
        "lastAutomaticUpdate",
        "importFlag",
        "schedulingExceptions",
        "selfValuations",
        "subcategory",
        "accountId",
        "highlightTransactionId",
        "credential"
    ];
    // crypto accounts have slightly less attributes, so do not show them
    if (account.category === "crypto") nonEditableFields.push("countryCode", "ownCurrentAccount", "credential", "username");
    // incoming editable attributes mapped to an array of { key, value }
    // this is the source of all attributes for the bar
    const accountAttributes = Object.entries(account)// remove non-editable attributes from account object
    .filter(([key, value])=>!nonEditableFields.includes(key)).flatMap(([key, value])=>{
        if ([
            "string",
            "number",
            "boolean"
        ].includes(typeof value)) return {
            key: key,
            value: value
        };
        if (!value) return {
            key: key,
            value: value
        };
        if (key === "valuationParameters") // handle nested attributes
        return Object.entries(value).map(([nestedKey, nestedValue])=>({
                key: `valuationParameters.${nestedKey}`,
                value: nestedValue
            }));
        return {
            key: key,
            value: value
        };
    });
    const type = (accountAttributes.find((attr)=>attr.key === "valuationParameters.type") || {
        value: null
    }).value;
    const [visibleCount, setVisibleCount] = (0, $7fPBF.useState)(0);
    // prepare data for subtype attribute in realEstate -- when type changes, reset subtype
    (0, $7fPBF.useEffect)(()=>{
        if (account.category === "realEstate") {
            if (!type) setSubtypeList([]);
            if (type === "building") setSubtypeList(Object.entries(t("parameters.subtype.building", {
                returnObjects: true
            })).map(([key, value])=>({
                    id: key,
                    name: value
                })));
            if (type === "apartment") setSubtypeList(Object.entries(t("parameters.subtype.apartment", {
                returnObjects: true
            })).map(([key, value])=>({
                    id: key,
                    name: value
                })));
        }
    }, [
        type
    ]);
    // helper to store refs per item
    const setItemRef = (index)=>(el)=>{
            labelPairsRefs.current[index] = el;
        };
    (0, $7fPBF.useEffect)(()=>{
        labelPairsRefs.current = labelPairsRefs.current.slice(0, accountAttributes.length);
        setVisibleCount((current)=>Math.min(current, accountAttributes.length));
    }, [
        accountAttributes.length
    ]);
    // measure → split → render
    function recalcVisible() {
        var _containerRef_current, _overflowButtonRef_current;
        const containerWidth = ((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.offsetWidth) || 0;
        if (!containerWidth) return;
        // if container is narrow (sm breakpoint ≈607px), collapse to menu button only
        const currentBreakpoint = (0, $29b77351b10ec0da$export$2e2bcd8739ae039)();
        if ([
            null,
            "xs"
        ].includes(currentBreakpoint)) {
            setVisibleCount(0);
            return;
        }
        // calculate the length of all label pairs
        const widths = labelPairsRefs.current.map((node)=>(node === null || node === void 0 ? void 0 : node.offsetWidth) || 0);
        if (!widths.length) return;
        // calculate the length of the overflow button
        const overflowButtonWidth = ((_overflowButtonRef_current = overflowButtonRef.current) === null || _overflowButtonRef_current === void 0 ? void 0 : _overflowButtonRef_current.offsetWidth) || 40;
        let used = 0;
        let lastVisible = -1;
        let idx = 0;
        while(idx < widths.length){
            const w = widths[idx];
            const remainingItems = widths.length - (idx + 1);
            const reserve = remainingItems > 0 ? overflowButtonWidth : 0;
            if (used + w + reserve <= containerWidth) {
                used += w;
                lastVisible = idx;
                idx += 1;
            } else break;
        }
        setVisibleCount(lastVisible + 1);
    }
    (0, $7fPBF.useLayoutEffect)(()=>{
        setBarIsVisible(false);
        const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(()=>recalcVisible()) : null;
        if (observer && containerRef.current) observer.observe(containerRef.current);
        if (!observer) window.addEventListener("resize", recalcVisible);
        // initial measure after refs mount
        requestAnimationFrame(()=>{
            recalcVisible();
            setBarIsVisible(true);
        });
        return ()=>{
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            if (!observer) window.removeEventListener("resize", recalcVisible);
        };
    // accountAttributes length affects itemRefs content
    }, [
        accountAttributes.length
    ]);
    // re-measure when attributes change value/content (not just length)
    (0, $7fPBF.useEffect)(()=>{
        requestAnimationFrame(()=>recalcVisible());
    }, [
        accountAttributes
    ]);
    /**
   * @param {string} attrKey - name of the attribute property
   * @returns attribute type (for DialogForm to know what to display)
   *
   * This function will check yup meta dialogFormType property and if it exists, it will be returned.
   * If the above property does not exist, it will apply the logic to determine the type.
   */ function getAttributeType(attrKey) {
        var _schema_describe_fields_attrKey, _yupAttrObject_meta;
        const yupAttrObject = accountSchemaObject[attrKey];
        let attrType = yupAttrObject === null || yupAttrObject === void 0 ? void 0 : yupAttrObject.type; // this looks up valuationParameters, so it won't work for connectedDepositAccounts in RealEstate
        if (attrType === undefined) attrType = (_schema_describe_fields_attrKey = schema.describe().fields[attrKey]) === null || _schema_describe_fields_attrKey === void 0 ? void 0 : _schema_describe_fields_attrKey.type; // this looks up the root of account object to handle the case above
        // if the yup attribute definition has meta.dialogFormType, return it immediatelly
        if (yupAttrObject === null || yupAttrObject === void 0 ? void 0 : (_yupAttrObject_meta = yupAttrObject.meta) === null || _yupAttrObject_meta === void 0 ? void 0 : _yupAttrObject_meta.dialogFormType) return yupAttrObject.meta.dialogFormType;
        const isStringOrNumber = [
            "number",
            "string"
        ].includes(attrType);
        const hasOneOf = ((yupAttrObject === null || yupAttrObject === void 0 ? void 0 : yupAttrObject.oneOf.length) || -1) > 0; // checks if the schema definition for this attr has oneOf (i.e. a whitelist)
        if (isStringOrNumber && hasOneOf) return "dropdown";
        if (account.category === "realEstate" && attrKey === "subtype") return "dropdown";
        if (account.category === "loans" && attrKey === "connectedProjectId") return "dropdown"; // special case for loans
        if (attrType === "boolean") return "boolean";
        if (isStringOrNumber && !hasOneOf) return "text";
        if (attrType === "array") {
            var _yupAttrObject_innerType;
            if ((yupAttrObject === null || yupAttrObject === void 0 ? void 0 : (_yupAttrObject_innerType = yupAttrObject.innerType) === null || _yupAttrObject_innerType === void 0 ? void 0 : _yupAttrObject_innerType.type) === "object") return "arrayOfObjects"; // used for arrays that carry objects in loans (e.g. interest rate which has { value, effectiveDate })
            return "array"; // this will show a dropdown with multiple selection allowed (connectedDepositAccounts is an array of objects)
        }
        return undefined;
    }
    // attrKey without valuationParameters
    async function putAttribute(attrKey, value) {
        const data = JSON.parse(JSON.stringify(account));
        // if there are valuationParameters, add the attribute to them; otherwise to the root of account object (with the exception of connectedDepositAccounts which is always in the root)
        if (account.valuationParameters && attrKey !== "connectedDepositAccounts") {
            data.valuationParameters[attrKey] = value;
            // for 'realEstate' type changes, we must reset subtype when type changes
            if (account.category === "realEstate" && attrKey === "type") data.valuationParameters.subtype = null;
        } else data[attrKey] = value;
        await dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
            data: data,
            category: account.category
        }));
    }
    // this function handles translations for attribute values
    // get a different part of i18n for this (tCountries instead of t)
    const { t: tRoot } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app");
    // checks if attr.key has a value list and if so, it returns the translated value
    function getTranslatedValue(attr) {
        var _projects_find;
        if (attr.value === null) return null;
        const attrKey = attr.key.replace("valuationParameters.", "");
        // handle special cases
        // country (has a different source of translations)
        if (attrKey === "countryCode") return tRoot([
            `countryNames.${(0, $3ed9d75bd3010070$export$9494497b504eb2dc)(attr.value)}`,
            (0, $3ed9d75bd3010070$export$9494497b504eb2dc)(attr.value)
        ]);
        // 'subtype' for realEstate (different logic)
        if (attrKey === "subtype" && account.category === "realEstate") return t(`parameters.subtype.${type}.${attr.value}`);
        // connectedProjectId for loans
        if (attrKey === "connectedProjectId" && account.category === "loans") return (_projects_find = projects.find((x)=>x.id === attr.value)) === null || _projects_find === void 0 ? void 0 : _projects_find.name;
        const attrType = getAttributeType(attrKey);
        // date
        if (attrType === "date") return (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(attr.value).format("DD.MM.YYYY");
        // handle standard case
        if (attrType === "dropdown" && attrKey !== "energyClass") // energyClass are letters, so no translation
        return t(`parameters.${attrKey}.${attr.value}`);
        return attr.value;
    }
    function handleClick(attr) {
        // accountSchemaObject automatically goes to the valuationParameters object if it exists (i.e. accountSchemaObject.type and not accountSchemaObject.valuationParameters.type)
        // also, when we look up translations for values in i18n, they are under account.parameters.<key>.<value> (and not parameters.valuatuionParameters.<key>.<value>)
        const attrKey = attr.key.replace("valuationParameters.", "");
        // check if we must provide a list for dropdown
        const attrValueType = getAttributeType(attrKey);
        // if yes, prepare the list
        let dropdownList = [];
        if (attrValueType === "dropdown") {
            // handle special case subtype, which has no whitelist, because it depends on the type attribute
            if (account.category === "realEstate" && attrKey === "subtype") dropdownList = subtypeList;
            else if (attrKey === "countryCode") dropdownList = [
                ...accountSchemaObject[attrKey].oneOf
            ].map((item)=>({
                    id: item,
                    name: item === null ? null : tRoot([
                        `countryNames.${(0, $3ed9d75bd3010070$export$9494497b504eb2dc)(item)}`,
                        (0, $3ed9d75bd3010070$export$9494497b504eb2dc)(item)
                    ])
                }));
            else if (account.category === "loans" && attrKey === "connectedProjectId") dropdownList = projects.map((x)=>({
                    id: x.id,
                    name: x.name
                }));
            else if (account.category === "pension" && attrKey === "useSpecialQuote") {
                var _quotes_account_id;
                // only allow those special quote types for which are actual quotes for this asset (with pensions asset === account)
                const uniqueQuoteTypes = [
                    ...new Set(Object.values((_quotes_account_id = quotes === null || quotes === void 0 ? void 0 : quotes[account.id]) !== null && _quotes_account_id !== void 0 ? _quotes_account_id : {}).flatMap(({ specialQuotes: specialQuotes = [] })=>specialQuotes.map((specialQuote)=>specialQuote.type)))
                ];
                dropdownList = uniqueQuoteTypes.map((item)=>({
                        id: item,
                        name: item === null ? null : t(`parameters.${attrKey}.${item}`)
                    }));
            } else dropdownList = [
                ...accountSchemaObject[attrKey].oneOf
            ].map((item)=>({
                    id: item,
                    name: item === null ? null : t(`parameters.${attrKey}.${item}`)
                }));
        }
        // attrType === 'array' -- there is only connectedDepositAccounts for now, so handling it via attrKey
        if (attrKey === "connectedDepositAccounts") dropdownList = depositAccounts.map((x)=>({
                id: x.id,
                name: x.name
            }));
        // DialogForm will only provide the value to the callback, so we will send there this wrapper
        async function dialogCallback(value) {
            let calculatedValue;
            // for connected deposit account we have { id, name } in the dropdown, but we need only id
            if (attrKey === "connectedDepositAccounts") calculatedValue = value.map((item)=>item.id);
            else calculatedValue = (value === null || value === void 0 ? void 0 : value.id) === undefined ? value : value.id; // dropdown's value in DialogForm state is { id, name }
            await putAttribute(attrKey, calculatedValue);
        }
        async function dialogCallbackForArrayOfObjectsEffectiveDate(formValues) {
            // "de-transform" values in the shape of { effectiveDate, value: { id, name } } to { effectiveDate, value: id }
            const calculatedValue = formValues.map((item)=>({
                    effectiveDate: item.effectiveDate,
                    value: item.value.id || item.value
                }));
            await putAttribute(attrKey, calculatedValue);
        }
        async function dialogCallbackForArrayOfObjectsQuote(formValues) {
            await putAttribute(attrKey, formValues);
        }
        let calculatedValue = attr.value;
        if (attrValueType === "dropdown") calculatedValue = dropdownList.find((x)=>x.id === attr.value);
        // handle array
        // need to provide memory references to the objects in the list, so we can compare them to the values in the array
        // attr.value is an array of ids, so we must convert it to an array of objects
        // caveat: this can be an array of items (currency) or an array of objects (connectedDepositAccounts)
        if (attrValueType === "array") calculatedValue = dropdownList.filter((x)=>attr.value.includes(x.id));
        // value should be an item or an object --> we need to get object to item
        // then convert dropdownList to an array of ids and compare it to the value
        // handle array of objects - like interestRate in loans (array of { value, effectiveDate })
        if (attrValueType === "arrayOfObjects") {
            var _accountSchemaObject_attrKey_innerType;
            let formValues = $95460cc8ecb951e0$var$parseIf(attr.value); // array of { effectiveDate, value } or array of { type, quote, quoteBaseCurrency }
            // other kinds of array are not implemented yet
            const fieldsInObject = Object.keys((_accountSchemaObject_attrKey_innerType = accountSchemaObject[attrKey].innerType) === null || _accountSchemaObject_attrKey_innerType === void 0 ? void 0 : _accountSchemaObject_attrKey_innerType.fields);
            if (!fieldsInObject.includes("effectiveDate") && !fieldsInObject.includes("quote")) throw new Error("AttributeBar: unsupported arrayOfObjects type");
            let mode;
            if (fieldsInObject.includes("effectiveDate")) mode = "effectiveDate";
            if (fieldsInObject.includes("quote")) mode = "quote";
            // if this is an array field which is an array of { effectiveDate, value } and the value is a oneOf list
            // take the list from yup and convert it to { id, name } format to be displayed in Dropdown
            // only pass values, the child component will look for transaction keys for them
            let valueDropdown;
            if (mode === "effectiveDate") {
                var _accountSchemaObject_attrKey_innerType_fields_value, _accountSchemaObject_attrKey_innerType_fields, _accountSchemaObject_attrKey_innerType1;
                // handle { effectiveDate, value } array of objects
                // check if this is an array of { ..., value }
                const valueOneOf = (_accountSchemaObject_attrKey_innerType1 = accountSchemaObject[attrKey].innerType) === null || _accountSchemaObject_attrKey_innerType1 === void 0 ? void 0 : (_accountSchemaObject_attrKey_innerType_fields = _accountSchemaObject_attrKey_innerType1.fields) === null || _accountSchemaObject_attrKey_innerType_fields === void 0 ? void 0 : (_accountSchemaObject_attrKey_innerType_fields_value = _accountSchemaObject_attrKey_innerType_fields.value) === null || _accountSchemaObject_attrKey_innerType_fields_value === void 0 ? void 0 : _accountSchemaObject_attrKey_innerType_fields_value.oneOf;
                // if the value field is a list, we must provide a list of translated values to the component (valueDropdown)
                if (valueOneOf && valueOneOf.length > 0) {
                    // convert all values to { id, name } format suitable to be displayed in Dropdown
                    valueDropdown = [
                        ...valueOneOf
                    ].map((item)=>({
                            id: item,
                            name: t(`parameters.${attrKey}.${item}`)
                        }));
                    // also convert existing values
                    formValues = formValues.map((row)=>({
                            effectiveDate: row.effectiveDate,
                            value: valueDropdown.find((x)=>x.id === row.value)
                        }));
                }
                const props = {
                    formValues: formValues,
                    header: t(`${attr.key}.label`),
                    prompt: t(`${attr.key}.tooltip`).includes(".tooltip") ? tG("pleaseEnterValue") : t(`${attr.key}.tooltip`),
                    callback: dialogCallbackForArrayOfObjectsEffectiveDate,
                    valueDropdown: valueDropdown
                };
                window.dispatchEvent(new CustomEvent("setDialog", {
                    detail: {
                        Component: (0, $ffe9b39b7aac6d84$export$2e2bcd8739ae039),
                        props: props
                    }
                }));
            }
            if (mode === "quote") {
                const props = {
                    formValues: formValues,
                    header: t(`${attr.key}.label`),
                    prompt: t(`${attr.key}.tooltip`).includes(".tooltip") ? tG("pleaseEnterValue") : t(`${attr.key}.tooltip`),
                    callback: dialogCallbackForArrayOfObjectsQuote
                };
                window.dispatchEvent(new CustomEvent("setDialog", {
                    detail: {
                        Component: (0, $e9942f42daec66e7$export$2e2bcd8739ae039),
                        props: props
                    }
                }));
            }
        } else // event for all other cases
        window.dispatchEvent(new CustomEvent("setDialog", {
            detail: (0, $9tqwB._)({
                header: t(`${attr.key}.label`),
                prompt: t(`${attr.key}.tooltip`).includes(".tooltip") ? tG("pleaseEnterValue") : t(`${attr.key}.tooltip`),
                value: calculatedValue,
                callback: dialogCallback
            }, attrValueType === "date" && {
                date: true
            }, attrValueType === "dropdown" && {
                dropdown: dropdownList
            }, attrValueType === "array" && {
                array: dropdownList
            }, attrValueType === "boolean" && {
                boolean: true
            })
        }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: "attribute-bar",
        ref: containerRef,
        className: `${barIsVisible ? "" : "invisible"} relative h-full flex flex-nowrap justify-between items-center gap-x-6 text-gray-500 text-sm`,
        style: {
            width: "inherit"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute left-0 top-0 -z-10 flex flex-nowrap opacity-0 pointer-events-none",
                "aria-hidden": true,
                children: accountAttributes.map((attr, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        ref: setItemRef(index),
                        className: "attribute-item flex items-center justify-between pr-8 py-2 rounded-md whitespace-nowrap",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($95460cc8ecb951e0$var$LabelPair, {
                            label: t(`${attr.key}.label`),
                            value: getTranslatedValue(attr)
                        })
                    }, `measure-${attr.key}`))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex flex-nowrap items-center",
                children: accountAttributes.filter((attr, index)=>index < visibleCount).map((attr)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "attribute-item flex items-center justify-between pr-8 py-2 rounded-md hover:underline transition-colors duration-150 ease-in-out whitespace-nowrap",
                        id: `attribute-item-${attr.key.replace("valuationParameters.", "")}`,
                        // handle special case: iban is not editable for automatic syncType
                        // (see warning in https://monestry.atlassian.net/wiki/spaces/TECH/pages/383516690/Open+banking+API#Provide-current-transactions-%2F-saldos)
                        disabled: account.category === "deposits" && attr.key === "iban" && account.syncType === "automatic",
                        onClick: (e)=>handleClick(attr),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($95460cc8ecb951e0$var$LabelPair, {
                            label: t(`${attr.key}.label`),
                            value: getTranslatedValue(attr)
                        })
                    }, attr.key))
            }),
            accountAttributes.filter((attr, index)=>index >= visibleCount).length > 0 && // below XS it should overlap with the Table component below, otherwise we would have to embed it in all five versions of that component
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f), {
                as: "div",
                className: "right-4 xs:right-auto pt-0 flex-shrink-0 relative",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Button, {
                        ref: overflowButtonRef,
                        // eslint-disable-next-line max-len
                        className: "flex items-center justify-center w-8 h-8 rounded-md bg-white xs:bg-inherit border border-gray-300 xs:border-none group hover:bg-gray-100 transition-colors duration-150 ease-in-out",
                        type: "button",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a2a89f0f88dbf41$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 text-gray-500"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                        as: (0, $7fPBF.Fragment),
                        enter: "transition ease-out duration-200",
                        enterFrom: "opacity-0 translate-y-1",
                        enterTo: "opacity-100 translate-y-0",
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100 translate-y-0",
                        leaveTo: "opacity-0 translate-y-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Items, {
                            as: "div",
                            id: "attributes-menu-panel",
                            className: "absolute left-0 mt-5 -translate-x-3/4 flex w-screen max-w-min px-4 z-[100]",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "w-72 flex flex-col items-start shrink rounded-xl bg-white p-2 text-sm text-left leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5",
                                children: accountAttributes.filter((attr, index)=>index >= visibleCount).map((attr)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                        as: "button",
                                        type: "button",
                                        // eslint-disable-next-line max-len
                                        className: "px-4 py-2 whitespace-nowrap truncate max-w-[100%] text-gray-700 hover:bg-gray-50 transition-colors duration-150 ease-in-out ui-active:bg-brandBlue-500 ui-active:font-semibold",
                                        onClick: (e)=>handleClick(attr),
                                        // handle special case: iban is not editable for automatic syncType
                                        // (see warning in https://monestry.atlassian.net/wiki/spaces/TECH/pages/383516690/Open+banking+API#Provide-current-transactions-%2F-saldos)
                                        disabled: account.category === "deposits" && attr.key === "iban" && account.syncType === "automatic",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($95460cc8ecb951e0$var$LabelPair, {
                                            label: t(`${attr.key}.label`),
                                            value: getTranslatedValue(attr),
                                            menuMode: true
                                        })
                                    }, JSON.stringify(attr.id || attr)))
                            })
                        })
                    })
                ]
            })
        ]
    });
}
$95460cc8ecb951e0$export$2e2bcd8739ae039.propTypes = {
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};




/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





/* eslint-disable react/forbid-prop-types */ /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $464649a15b638704$export$2e2bcd8739ae039({ id: id, value: value, formattedValue: formattedValue }) {
    var _theme_tooltip;
    const theme = (0, $0332e848e6fa2251$export$93d4e7f90805808f)();
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const tooltipContainerStyle = (theme === null || theme === void 0 ? void 0 : (_theme_tooltip = theme.tooltip) === null || _theme_tooltip === void 0 ? void 0 : _theme_tooltip.container) || {};
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("charts");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: (0, $9tqwB._)({}, tooltipContainerStyle),
        className: "text-sm rounded-md shadow",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
            className: "text-gray-700",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "font-bold",
                    children: t(id)
                }),
                `: ${value.toLocaleString("de", {
                    style: "currency",
                    currency: baseCurrency || "EUR",
                    maximumFractionDigits: 0
                })}`
            ]
        })
    });
}
$464649a15b638704$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    formattedValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$464649a15b638704$export$2e2bcd8739ae039.defaultProps = {
    id: "",
    value: 0,
    formattedValue: ""
};


(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $759032f00db56ad9$var$convertDataBarChart(inputData, colors, col, rows) {
    const result = {
        data: [],
        indexBy: col,
        keys: rows,
        colors: colors
    };
    // Aggregate data - returns an object:
    // { col1: { row1: 234, row2: 100, row3: 0 }, col2: { row1: 0, row2: 0, row3: 0}... }
    const aggregatedData = {};
    inputData.forEach((item)=>{
        const indexValue = item[col];
        // Initialize the year object if it doesn't exist
        if (!aggregatedData[indexValue]) {
            aggregatedData[indexValue] = {
                [col]: indexValue
            };
            rows.forEach((row)=>{
                aggregatedData[indexValue][row] = 0; // Initialize row values
            });
        }
        // Sum the values for each row
        rows.forEach((row)=>{
            if (item[row] !== undefined) aggregatedData[indexValue][row] += item[row];
        });
    });
    // Convert to required format and assign colors
    for(const key in aggregatedData){
        const entry = aggregatedData[key];
        rows.forEach((row)=>{
            entry[`${row}Color`] = colors[rows.indexOf(row)];
        });
        result.data.push(entry);
    }
    return result;
}
function $759032f00db56ad9$export$2e2bcd8739ae039({ chartType: chartType, data: data, colsField: colsField, rows: rows, colorsForRows: colorsForRows }) {
    if (chartType === "barStacked") {
        const dataKeysIndexOf = $759032f00db56ad9$var$convertDataBarChart(data, colorsForRows, colsField, rows);
        const chartProps = (0, $2qxEV._)((0, $9tqwB._)({}, dataKeysIndexOf), {
            animate: true,
            margin: {
                top: 40,
                right: 60,
                bottom: 24,
                left: 16
            },
            theme: {
                fontFamily: "Lato"
            },
            labelTextColor: "inherit:darker(1.4)",
            labelSkipWidth: 16,
            labelSkipHeight: 16,
            label: false,
            groupMode: "stacked",
            padding: 0.7,
            innerPadding: 2,
            axisLeft: null,
            axisRight: {
                format: (v)=>`${v.toLocaleString("de")}`,
                tickValues: 4
            },
            tooltip: (0, $464649a15b638704$export$2e2bcd8739ae039)
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6f6e62123bc42f02$export$5b685d9928bc009b), (0, $9tqwB._)({}, chartProps));
    }
    if (chartType === "line") {
        const convertedData = data.map((item)=>({
                x: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.date).format("YYYY-MM-DD"),
                y: item.quote
            }));
        const dataKeysIndexOf = {
            data: [
                {
                    id: "value",
                    color: "#2E3192",
                    data: [
                        {
                            x: "2020-01-01",
                            y: 50
                        },
                        {
                            x: "2020-02-01",
                            y: 52
                        },
                        {
                            x: "2020-03-01",
                            y: 54
                        },
                        {
                            x: "2021-01-01",
                            y: 70
                        },
                        {
                            x: "2022-01-01",
                            y: 60
                        },
                        {
                            x: "2023-01-01",
                            y: 90
                        }
                    ]
                }
            ]
        };
        const chartProps = (0, $2qxEV._)((0, $9tqwB._)({}, dataKeysIndexOf), {
            animate: true,
            curve: "monotoneX",
            margin: {
                top: 40,
                right: 40,
                bottom: 60,
                left: 40
            },
            axisBottom: {
                format: (v)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(v).format("YYYY-MM"),
                tickRotation: -90
            },
            theme: {
                fontFamily: "Lato"
            },
            enableArea: true,
            areaBaselineValue: 0,
            areaOpacity: 0.1,
            colors: {
                datum: "color"
            },
            tooltip: (0, $464649a15b638704$export$2e2bcd8739ae039),
            xScale: {
                format: "%Y-%m-%d",
                precision: "month",
                type: "time",
                useUTC: true
            }
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $402be319a2343cfa$export$a4a9f4982e5c2626), (0, $9tqwB._)({}, chartProps));
    }
    // ADD MORE CHART TYPES HERE
    // get common chartProps out
    console.warn("ChartWrapperNoPivotTable: unknown chartType", chartType);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
}
$759032f00db56ad9$export$2e2bcd8739ae039.propTypes = {
    chartType: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    colsField: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    colorsForRows: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
// remaining principal and interest:
const $dc7c2897530a981f$var$progressColour = "bg-brandBlue-500";
const $dc7c2897530a981f$var$backgroundColour = "bg-gray-200";
function $dc7c2897530a981f$var$PercentDone({ loanAmount: loanAmount, sumPrincipal: sumPrincipal }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "loanIndicators"
    });
    const marker = loanAmount ? Math.abs(sumPrincipal / loanAmount * 100) : 0;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "p-2 sm:p-4 w-full border border-gray-300 rounded-lg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                className: "font-bold text-base sm:text-lg mb-1 sm:mb-2 flex",
                children: [
                    t("loanRepaid"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                        info: t("loanRepaidTooltip")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "space-y-1 px-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            marginLeft: "-8px",
                            paddingLeft: `${marker}%`
                        },
                        className: "w-fit text-xs tracking-tighter",
                        children: `${Number(marker || 0).toFixed(0)} %`
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "relative w-full",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: `${$dc7c2897530a981f$var$backgroundColour} relative h-2 w-full rounded-sm`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: `${$dc7c2897530a981f$var$progressColour} absolute h-2 rounded-sm`,
                                style: {
                                    width: `${marker}%`
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            marginLeft: "-8px",
                            paddingLeft: `${marker}%`
                        },
                        className: "w-fit",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "-rotate-90 w-fit",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                fill: "currentColor",
                                className: "w-4 h-4",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z",
                                    clipRule: "evenodd"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
$dc7c2897530a981f$var$PercentDone.propTypes = {
    loanAmount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    sumPrincipal: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
};
function $dc7c2897530a981f$var$InterestPaid({ sumInterest: sumInterest, sumPrincipal: sumPrincipal, accountCurrency: accountCurrency }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "loanIndicators"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "p-2 sm:p-4 w-full border border-gray-300 rounded-lg grid grid-cols-1 gap-2 xs:gap-0 xs:grid-cols-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                className: "font-bold text-base sm:text-lg mb-1 sm:mb-2 xs:col-span-2 flex",
                children: [
                    t("interest"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                        info: t("interestTooltip")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-xs xs:text-sm",
                        children: t("interestPaid")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl",
                        children: sumInterest.toLocaleString("de", {
                            style: "currency",
                            currency: accountCurrency
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-xs xs:text-sm",
                        children: t("interestPaidToPrincipalPaid")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl",
                        children: (-sumInterest / sumPrincipal).toLocaleString("de", {
                            style: "percent",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })
                    })
                ]
            })
        ]
    });
}
$dc7c2897530a981f$var$InterestPaid.propTypes = {
    sumInterest: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    sumPrincipal: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    accountCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
function $dc7c2897530a981f$var$ToBePaid({ thisAccount: thisAccount, sumPrincipal: sumPastPrincipal }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "loanIndicators"
    });
    const accountCurrency = thisAccount.currency;
    const allFutureTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $2da686298e0b71ed$export$7180e5e29ddd79ea));
    const sumFutureInterest = allFutureTransactions.reduce((acc, tx)=>tx.isSimulated && tx.accountId === thisAccount.id ? acc + tx.quantityInterest : acc, 0);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "p-2 sm:p-4 w-full border border-gray-300 rounded-lg col-span-2 grid grid-cols-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                className: "font-bold text-base sm:text-lg mb-1 sm:mb-2 col-span-3 flex",
                children: [
                    t("balance"),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                        info: t("balanceTooltip")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-xs xs:text-sm",
                        children: t("principalRemaining")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl",
                        children: Math.abs(thisAccount.loanAmount + sumPastPrincipal).toLocaleString("de", {
                            style: "currency",
                            currency: accountCurrency
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-xs xs:text-sm",
                        children: t("interestRemaining")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl",
                        children: sumFutureInterest.toLocaleString("de", {
                            style: "currency",
                            currency: accountCurrency
                        })
                    })
                ]
            })
        ]
    });
}
$dc7c2897530a981f$var$ToBePaid.propTypes = {
    thisAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    sumPrincipal: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
};
function $dc7c2897530a981f$export$2e2bcd8739ae039({ accountId: accountId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "loanIndicators"
    });
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.loans.accounts);
    const thisAccount = accounts.find((a)=>a.id === accountId);
    const transactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $2da686298e0b71ed$export$a856f17095d848d7));
    const thisAccountTransactions = transactions.filter((tx)=>tx.accountId === accountId);
    const sumPrincipal = thisAccountTransactions// without payout transactions
    .filter((tx)=>thisAccount.direction === "received" ? tx.quantity > 0 : tx.quantity < 0).reduce((acc, tx)=>acc + tx.quantity, 0);
    const sumInterest = thisAccountTransactions.reduce((acc, tx)=>acc + tx.quantityInterest, 0);
    const accountCurrency = thisAccount.currency;
    // prepare data for chart
    const adjustedTransactions = transactions// without payout transactions
    .filter((tx)=>thisAccount.direction === "received" ? tx.quantity > 0 : tx.quantity < 0).map((tx)=>{
        const year = (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(tx.date).format("YYYY");
        const principal = tx.quantity;
        const interest = tx.quantityInterest;
        return (0, $2qxEV._)((0, $9tqwB._)({}, tx), {
            year: year,
            principal: principal,
            interest: interest
        });
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full gap-2 grid grid-cols-2",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative p-2 sm:p-4 w-full h-48 border border-gray-300 rounded-lg col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "absolute font-bold text-base sm:text-lg mb-1 sm:mb-2 col-span-3",
                        children: t("history")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $759032f00db56ad9$export$2e2bcd8739ae039), {
                        data: adjustedTransactions,
                        chartType: "barStacked",
                        colsField: "year",
                        rows: [
                            "principal",
                            "interest"
                        ],
                        colorsForRows: [
                            "#92D050",
                            "#ED1C23"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dc7c2897530a981f$var$PercentDone, {
                loanAmount: thisAccount.loanAmount,
                sumPrincipal: sumPrincipal
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dc7c2897530a981f$var$InterestPaid, {
                sumPrincipal: sumPrincipal,
                sumInterest: sumInterest,
                accountCurrency: accountCurrency
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($dc7c2897530a981f$var$ToBePaid, {
                thisAccount: thisAccount,
                sumPrincipal: sumPrincipal
            })
        ]
    });
}
$dc7c2897530a981f$export$2e2bcd8739ae039.propTypes = {
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





function $d01fb60aa7caec0c$export$2e2bcd8739ae039({ accountId: accountId }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "pensionIndicators"
    });
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.pension.accounts);
    const thisAccount = accounts.find((a)=>a.id === accountId);
    const transactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $9a12762f4ca7889e$export$b2cccdcd27192b));
    const thisAccountTransactions = transactions.filter((tx)=>{
        var _tx_tags, _tx_tags1;
        return ((_tx_tags = tx.tags) === null || _tx_tags === void 0 ? void 0 : _tx_tags.accountId) === accountId || ((_tx_tags1 = tx.tags) === null || _tx_tags1 === void 0 ? void 0 : _tx_tags1.assetId) === accountId;
    });
    const sumContributions = thisAccountTransactions.filter((tx)=>tx.label === "investment-contribution").reduce((acc, tx)=>acc + tx.quantity, 0);
    const quotes = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$443f4a6ebd922e0a));
    console.info("DEBUG this account quotes", quotes[accountId]);
    const presentValue = quotes[accountId].current.quoteBaseCurrency * 1; // FIX 251206 see PRD-1759 / Pensions 2.0
    const percentPVToContributions = sumContributions ? presentValue / -sumContributions : 0; // contributions are negative (done so automatically by Grid)
    const accountCurrency = thisAccount.currency;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full gap-2 grid",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative p-2 sm:p-4 w-full border border-gray-300 rounded-lg col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "font-bold text-base sm:text-lg mb-1 sm:mb-2 col-span-3",
                        children: t("presentValueChanges")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                        reportId: "quotesByAssetIdxxxxxx",
                        filterCallback: (item)=>item.assetId === accountId,
                        layoutOptions: {
                            axisBottom: {
                                tickRotation: -90
                            },
                            margin: {
                                top: 60
                            }
                        }
                    })
                ]
            }),
            presentValue && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "p-2 sm:p-4 w-full border border-gray-300 rounded-lg col-span-2 grid grid-cols-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        className: "font-bold text-base sm:text-lg mb-1 sm:mb-2 col-span-3",
                        children: t("roi")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-xs xs:text-sm flex",
                                children: [
                                    t("sumContributions"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                        info: t("sumContributionsTooltip")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl",
                                children: Math.abs(sumContributions).toLocaleString("de", {
                                    style: "currency",
                                    currency: accountCurrency
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-xs xs:text-sm flex",
                                children: [
                                    t("presentValue"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c1f757725b2e8369$export$2e2bcd8739ae039), {
                                        info: t("presentValueTooltip")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-xl",
                                children: [
                                    presentValue.toLocaleString("de", {
                                        style: "currency",
                                        currency: accountCurrency
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: `${percentPVToContributions >= 1 ? "text-green-500" : "text-brandRed-500"} flex items-baseline text-xs sm:text-sm font-semibold`,
                                        children: percentPVToContributions.toLocaleString("de", {
                                            style: "percent",
                                            maximumFractionDigits: 1
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$d01fb60aa7caec0c$export$2e2bcd8739ae039.propTypes = {
    accountId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};




function $a29e09d640495533$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $a29e09d640495533$export$2e2bcd8739ae039({ account: incomingAccount, setAccount: setAccount, fileReceived: fileReceived, setFileReceived: setFileReceived }) {
    // on mobile layouts, when dashboard is scrolled to the bottom, this component is rendered "above" the visible screen
    // as scrolling is disabled, the user cannot scroll to the top of the page -- so we have to do it for him
    // scroll to the top of the page (somehow it got rendered in the middle)
    const myRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        myRef.current.scrollIntoView({
            behavior: "instant"
        });
    }, []);
    // if anything changes in store.data, this component does not seem to receive the new data of the account object
    // keep the component initialised already with the account object and at the same time to receive all the updates
    // we will overwrite the account object with the store object for the given account.id
    const selectorAccount = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data[incomingAccount.category].accounts, (accounts)=>accounts.find((item)=>item.id === incomingAccount.id), {
        memoizeOptions: {
            // equalityCheck: (a, b) => a === b,
            // maxSize: 10,
            resultEqualityCheck: (0, $7fPBF.shallowEqual)
        }
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const selectAccount = (0, $51238fa605392ada$export$2105062e25df4afe)(selectorAccount);
    if (!selectAccount) return true;
    const account = (0, $9tqwB._)({}, incomingAccount, selectAccount);
    const { category: category, id: id } = account;
    const quoteAssetIds = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>![
            "stocks",
            "metals",
            "unlistedShares",
            "crypto"
        ].includes(category) ? [] : [
            ...new Set((0, $3679aa7475d9bd44$export$9c38a21154823fe6)(state, category).filter((transaction)=>transaction.accountId === id).map((transaction)=>transaction.assetId))
        ], (0, $7fPBF.shallowEqual));
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const allAccounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47)) || [];
    const connectedAccounts = (allAccounts || []).filter((acc)=>{
        var _account_connectedDepositAccounts;
        return (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.includes(acc.id);
    });
    const { t: tAccountDetails, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const { t: tDashboard } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    // set table state | colWidths can be defined for Grid here
    const params = (0, $ea57824afe1bf3f3$export$2e2bcd8739ae039)(category);
    const [tableState, setTableState] = (0, $7fPBF.useState)({
        sortBy: "date",
        sortDirectionAsc: category !== "deposits",
        colWidths: params.colWidths,
        tableHeight: 300,
        filters: (0, $9tqwB._)({}, (0, $1d2560ffc929baec$export$c2e9f8ed4208cb9e))
    });
    // used in Grid -- indicates that at least 1 change has been done by the user
    // including delete, which does not have a yellow background
    // TODO needed here for the X overlay close button
    const [userChangesPresent, setUserChangesPresent] = (0, $7fPBF.useState)(false);
    // if you see fileReceived, go directly to import; otherwise initialise to table
    const [displayedComponent, setDisplayedComponent] = (0, $7fPBF.useState)(fileReceived ? "import" : "table");
    const [displayedData, setDisplayedDataMode] = (0, $7fPBF.useState)((0, $f808db98154b70a0$export$2e2bcd8739ae039)(category, "table", null)[0]); // other modes: 'quotes', 'settings', 'cashflow', pension & real estate do not have holdings,
    const [alert, setAlert] = (0, $7fPBF.useState)({
        visible: false
    });
    // handle user input from alert modal
    (0, $7fPBF.useEffect)(()=>{
        if (alert.id === "aboutToLoseData") {
            if (alert.buttonClicked === "ok") {
                setUserChangesPresent(false);
                if (typeof alert.onOk === "function") alert.onOk();
                else setAccount(null);
            }
        }
    }, [
        alert.buttonClicked
    ]);
    function handleClose(e) {
        if (displayedComponent !== "table" && userChangesPresent) setAlert({
            visible: true,
            id: "aboutToLoseData",
            buttons: [
                "ok",
                "cancel"
            ],
            onOk: ()=>setAccount(null)
        });
        else setAccount(null);
    }
    // create an event listener which calls setAlert when the user hits Esc when there are changes in the Grid view
    // DO NOT attempt to move it to the Redux alert, it won't work, as hooks cannot be used in listeners
    (0, $7fPBF.useEffect)(()=>{
        function handleEsc(e) {
            if (e.key === "Escape") {
                if (displayedComponent !== "table" && userChangesPresent) setAlert((prevState)=>(0, $2qxEV._)((0, $9tqwB._)({}, prevState), {
                        visible: true,
                        id: "aboutToLoseData",
                        buttons: [
                            "ok",
                            "cancel"
                        ]
                    }));
                else setAccount(null);
            }
        }
        // if (displayedComponent === 'grid' || displayedComponent === 'table') {
        document.addEventListener("keydown", handleEsc, false);
        // }
        return ()=>{
            document.removeEventListener("keydown", handleEsc, false);
        };
    }, [
        {
            userChangesPresent: userChangesPresent,
            displayedComponent: displayedComponent
        }
    ]); // it needs to be one object; if it is more, it creates several listeners
    async function inputFieldCallback({ propertyName: propertyName, newValue: newValue }) {
        const accountObject = (0, $2qxEV._)((0, $9tqwB._)({}, account), {
            [propertyName]: newValue
        });
        let result;
        try {
            var _result_meta;
            result = await dispatch((0, $f1c3fa004749592f$export$60a9c54e51ee3879)({
                data: accountObject,
                category: category
            }));
            if ((result === null || result === void 0 ? void 0 : (_result_meta = result.meta) === null || _result_meta === void 0 ? void 0 : _result_meta.requestStatus) === "rejected") throw new Error("accountCouldNotBeUpdated");
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountUpdatedSuccessfully"));
        } catch (err) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated"));
            throw new Error("accountCouldNotBeUpdated"); // the error is caught in the InputComponent
        }
        return result; // handled in InputComponent
    }
    function setNewState(arg) {
        switch(arg){
            case "holdings":
            case "cashflow":
            case "quotes":
            case "settings":
                // some components are not available for certain data modes
                if (arg === "cashflow") setDisplayedComponent("table"); // table is the only choice for cashlfow and holdings
                // settings only have the settings component
                if (arg === "settings") setDisplayedComponent("settings");
                // holdings and quotes only have table and grid
                if ([
                    "holdings",
                    "quotes"
                ].includes(arg) && ![
                    "table",
                    "grid"
                ].includes(displayedComponent)) setDisplayedComponent("table");
                setDisplayedDataMode(arg);
                break;
            default:
                setDisplayedComponent(arg);
        }
    }
    // click handler for ButtonBar
    function handleClick(arg, options = {}) {
        if (userChangesPresent && !options.skipUnsavedChanges) setAlert({
            visible: true,
            id: "aboutToLoseData",
            buttons: [
                "ok",
                "cancel"
            ],
            onOk: ()=>setNewState(arg)
        });
        else setNewState(arg);
    }
    // handles "go to deposits account" button on assets accounts (when cashflow component is empty)
    function handleNavigateToAccount(accountId) {
        const targetAccount = allAccounts.find((acc)=>acc.id === accountId);
        if (targetAccount) {
            setAccount(targetAccount);
            setDisplayedComponent("table");
            setDisplayedDataMode("holdings");
        }
    }
    // used for cashflow data (filter all transactions to display only those linked to this account)
    function getCashflowFilter(accountId) {
        return (transaction)=>{
            var _transaction_tags, _transaction_tags1;
            return ((_transaction_tags = transaction.tags) === null || _transaction_tags === void 0 ? void 0 : _transaction_tags.assetId) === accountId || ((_transaction_tags1 = transaction.tags) === null || _transaction_tags1 === void 0 ? void 0 : _transaction_tags1.accountId) === accountId;
        };
    }
    const standardProps = {
        account: account,
        setAccount: setAccount,
        displayedComponent: displayedComponent,
        displayedData: displayedData,
        handleClick: handleClick,
        connectedAccounts: connectedAccounts,
        handleNavigateToAccount: handleNavigateToAccount
    };
    const wrapperProps = {
        tableState: tableState,
        setTableState: setTableState,
        userChangesPresent: userChangesPresent,
        setUserChangesPresent: setUserChangesPresent,
        highlightTransactionId: account.highlightTransactionId
    };
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: "accountDetailsParent",
        ref: myRef,
        className: "absolute w-full h-auto min-h-full z-50 top-0 left-0 md:p-16 bg-gray-300 bg-opacity-90 space-y-6",
        role: "dialog",
        children: [
            alert.visible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ec5014f9e38c963$export$2e2bcd8739ae039), {
                alertId: alert.id,
                alertResetFunction: setAlert,
                resetCallbackObject: alert,
                buttons: alert.buttons || null,
                visible: alert.visible
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative bg-gray-50 shadow xl:max-h-full 2xl:h-[90vh] px-4 py-5 sm:rounded-lg sm:px-8 sm:py-8 flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        id: "account-details-close-button",
                        type: "button",
                        className: "absolute top-0 right-0 m-4 mb-6 cursor-pointer z-[70]",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-400 hover:text-gray-500",
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        id: "account-details-help-button",
                        href: `/${i18n.language}/blog/${(0, $99f87ace30ad8515$export$ed2efc2636e0089e)("account-details", i18n.language)}`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "absolute top-0 right-0 m-4 mb-6 mr-12 cursor-pointer z-[70]",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: tAccountDetails("help"),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c67e8e5ff55101a6$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-brandBlue-400 hover:text-brandBlue-500",
                                onClick: ()=>{}
                            })
                        })
                    }),
                    ![
                        "column",
                        "previewer",
                        "duplicate"
                    ].includes(displayedComponent) && // this element overlaps with the Table setion below XS (this is sorted out in AttributeBar), so it has to be kept above it (it has z-50), so that it can be clicked
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        "aria-label": "account header",
                        className: "z-[60] mt-2 sm:mt-0",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                                    className: "hidden sm:flex",
                                    "aria-label": "Breadcrumb",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ol", {
                                        className: "flex items-center space-x-4",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "flex",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-sm font-medium text-gray-400 hover:text-gray-500",
                                                        children: tDashboard(`categories.${category}`)
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb47cb945e5c730$export$2e2bcd8739ae039), {
                                                            className: "flex-shrink-0 h-5 w-5 text-gray-400",
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            "aria-current": "page",
                                                            className: "ml-4 text-sm font-medium text-gray-700 hover:text-gray-800",
                                                            children: tAccountDetails("accountDetails")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex items-center justify-between pt-4 sm:pt-0",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex-1 min-w-0 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e0c1e291bc90f03$export$2e2bcd8739ae039), {
                                                parentValue: account.name,
                                                stub: "Account name?",
                                                propertyName: "name",
                                                formatting: "sm:-ml-[0.4rem] font-bold text-gray-900 text-2xl xs:text-2xl sm:text-3xl leading-tight",
                                                callback: inputFieldCallback,
                                                showButtons: true
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "sm:hidden w-full flex items-center",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95460cc8ecb951e0$export$2e2bcd8739ae039), {
                                                    account: account
                                                })
                                            })
                                        ]
                                    }),
                                    displayedComponent === "table" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "flex-shrink-0 flex items-center md:mt-0 md:ml-4 z-10",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "font-bold leading-tight text-gray-900 text-2xl xs:text-2xl sm:text-3xl",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $778f4e3e2e2497ea$export$2e2bcd8739ae039), {
                                                account: account,
                                                category: category,
                                                currencyCodeFormat: "text-lg xs:text-lg sm:text-xl",
                                                // for deposits, if the account is not in baseCurrency, we show the sum in accountCurrency in AccountDetails (and in baseCurrency on Tile)
                                                showInBaseCurrency: !(category === "deposits" && account.currency !== baseCurrency)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "hidden sm:block",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95460cc8ecb951e0$export$2e2bcd8739ae039), {
                                    account: account
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "grid grid-cols-1 2xl:grid-cols-3 gap-8 h-full max-h-full lg:overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: `${displayedComponent === "table" ? "xl:col-span-2" : "xl:col-span-3"} ${displayedComponent === "column" ? "xl:h-[80vh]" : "xl:h-[70vh]"} pt-2 flex flex-col items-start lg:overflow-hidden w-full`,
                                children: [
                                    [
                                        "table",
                                        "grid"
                                    ].includes(displayedComponent) && displayedData === "holdings" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3c750946445b1c4$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps, wrapperProps)),
                                    [
                                        "table",
                                        "grid"
                                    ].includes(displayedComponent) && displayedData === "cashflow" && // special case: cashflow are always deposit transactions, so we need to pass "deposits" as category;
                                    // passing "filter" means to CategoryWrapperTransactions that it should filter by tags.accountId/assetId
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a3c750946445b1c4$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, standardProps, wrapperProps), {
                                        category: "deposits",
                                        filter: getCashflowFilter(id)
                                    })),
                                    [
                                        "table",
                                        "grid"
                                    ].includes(displayedComponent) && displayedData === "quotes" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0769444465afefa$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps, wrapperProps)),
                                    displayedData === "settings" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $89d72962615748a4$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps)) : null,
                                    [
                                        "import",
                                        "column",
                                        "duplicate",
                                        "previewer"
                                    ].includes(displayedComponent) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b716af4138d41e40$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, standardProps, wrapperProps), {
                                        fileReceived: fileReceived,
                                        setFileReceived: setFileReceived,
                                        displayedData: displayedData,
                                        alert: alert,
                                        setAlert: setAlert
                                    })),
                                    displayedComponent === "wizard" && displayedData === "quotes" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3c3d6783faa7f601$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps, wrapperProps)),
                                    displayedComponent === "wizard" && displayedData === "holdings" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d981a2ede56df856$export$2e2bcd8739ae039), (0, $9tqwB._)({}, standardProps, wrapperProps))
                                ]
                            }),
                            displayedComponent === "table" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                "aria-labelledby": "chart",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "rounded-md bg-white xl:overflow-hidden shadow sm:mt-4",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "p-6 pt-4",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                                                className: "text-base font-semibold text-gray-900",
                                                id: "chart-title",
                                                children: [
                                                    [
                                                        "realEstate",
                                                        "objectsOfValue"
                                                    ].includes(category) ? tAccountDetails("last10years") : null,
                                                    [
                                                        "deposits",
                                                        "stocks",
                                                        "metals",
                                                        "unlistedShares"
                                                    ].includes(category) ? tAccountDetails("last12months") : null,
                                                    [
                                                        "loans",
                                                        "pension"
                                                    ].includes(category) ? tAccountDetails("stats") : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: `mt-6 flex justify-center ${[
                                                    "loans",
                                                    "pension"
                                                ].includes(category) ? "min-h-[24rem]" : "h-96"}`,
                                                children: [
                                                    category === "deposits" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                        reportId: "transactionsByMonthxx",
                                                        dataCallback: (data)=>{
                                                            const thisAccountData = data.filter((item)=>item.accountId === account.id);
                                                            const months = [
                                                                ...new Set(thisAccountData.map((tr)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(tr.date).format("YYYY-MM")))
                                                            ].sort().reverse().slice(0, 12);
                                                            return thisAccountData.filter((item)=>months.includes((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(item.date).format("YYYY-MM")));
                                                        }
                                                    }),
                                                    [
                                                        "stocks",
                                                        "metals",
                                                        "unlistedShares",
                                                        "crypto"
                                                    ].includes(category) && displayedData === "quotes" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                        reportId: "quoteByYearLinexxxxxx",
                                                        dataCallback: (data = [])=>data.filter(// eslint-disable-next-line max-len
                                                            (item)=>quoteAssetIds.includes(item.assetId) && item.source === "manual" && item.date > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(category === "stocks" ? 10 : 12, category === "stocks" ? "years" : "months").valueOf() && Number(item.date) === Number(item.quoteDate)).map((item)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
                                                                    displayName: item.symbol || item.displayName || item.assetId
                                                                })),
                                                        layoutOptions: {
                                                            axisBottom: {
                                                                tickRotation: -90
                                                            },
                                                            margin: {
                                                                bottom: 60
                                                            }
                                                        }
                                                    }),
                                                    category === "stocks" && displayedData !== "quotes" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                        reportId: "snapshotsByMonthxxxxx",
                                                        filterCallback: (item)=>item.date > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(12, "months").valueOf() && item.accountId === account.id,
                                                        layoutOptions: {
                                                            startLabel: false,
                                                            endLabel: false,
                                                            margin: {
                                                                left: 10,
                                                                right: 60,
                                                                bottom: 60,
                                                                top: 30
                                                            },
                                                            axisBottom: {
                                                                format: (v)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(v).format("MM-YYYY"),
                                                                tickRotation: -90
                                                            }
                                                        }
                                                    }),
                                                    (category === "realEstate" || category === "objectsOfValue") && displayedData === "quotes" && // displays value of the object over time
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                        reportId: "quoteByYearLinexxxxxx",
                                                        filterCallback: (item)=>item.assetId === account.id && item.date > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(10, "years").valueOf(),
                                                        layoutOptions: {
                                                            axisBottom: {
                                                                tickRotation: -90
                                                            },
                                                            margin: {
                                                                bottom: 60
                                                            }
                                                        }
                                                    }),
                                                    category === "objectsOfValue" && displayedData === "holdings" && // displays holdings over time
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                        reportId: "realEstateByMonthxxxx",
                                                        filterCallback: (item)=>item.assetId === account.id && item.date > (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(10, "years").valueOf(),
                                                        layoutOptions: {
                                                            axisBottom: {
                                                                tickRotation: -90
                                                            },
                                                            margin: {
                                                                bottom: 60,
                                                                right: 10,
                                                                left: 60,
                                                                top: 30
                                                            }
                                                        }
                                                    }),
                                                    category === "loans" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc7c2897530a981f$export$2e2bcd8739ae039), {
                                                        accountId: account.id
                                                    }),
                                                    category === "pension" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d01fb60aa7caec0c$export$2e2bcd8739ae039), {
                                                        accountId: account.id
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-6",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                                    to: `/${i18n.language}/app/reports`,
                                                    className: "w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50",
                                                    children: tAccountDetails("goToReports")
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
$a29e09d640495533$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    fileReceived: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            fileName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
            // eslint-disable-next-line react/forbid-prop-types
            fileData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any
        }),
        null
    ]),
    setFileReceived: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$a29e09d640495533$export$2e2bcd8739ae039.defaultProps = {
    fileReceived: null,
    setFileReceived: null
};


/* eslint-disable max-len */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $36bc87590b707b9b$var$ClipboardDocumentListIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M7.502 6h7.128A3.375 3.375 0 0 1 18 9.375v9.375a3 3 0 0 0 3-3V6.108c0-1.505-1.125-2.811-2.664-2.94a48.972 48.972 0 0 0-.673-.05A3 3 0 0 0 15 1.5h-1.5a3 3 0 0 0-2.663 1.618c-.225.015-.45.032-.673.05C8.662 3.295 7.554 4.542 7.502 6ZM13.5 3A1.5 1.5 0 0 0 12 4.5h4.5A1.5 1.5 0 0 0 15 3h-1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M3 9.375C3 8.339 3.84 7.5 4.875 7.5h9.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V9.375ZM6 12a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V12Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 15a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V15Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 18a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1-.75-.75V18Zm2.25 0a.75.75 0 0 1 .75-.75h3.75a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z",
        clipRule: "evenodd"
    }));
}
const $36bc87590b707b9b$var$ForwardRef = $7fPBF.forwardRef($36bc87590b707b9b$var$ClipboardDocumentListIcon);
var $36bc87590b707b9b$export$2e2bcd8739ae039 = $36bc87590b707b9b$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $5fe3802f808215e9$var$PlusIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
        clipRule: "evenodd"
    }));
}
const $5fe3802f808215e9$var$ForwardRef = $7fPBF.forwardRef($5fe3802f808215e9$var$PlusIcon);
var $5fe3802f808215e9$export$2e2bcd8739ae039 = $5fe3802f808215e9$var$ForwardRef;




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $aabf4df1bf2eda9b$var$ChartBarIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M15.5 2A1.5 1.5 0 0 0 14 3.5v13a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 16.5 2h-1ZM9.5 6A1.5 1.5 0 0 0 8 7.5v9A1.5 1.5 0 0 0 9.5 18h1a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 10.5 6h-1ZM3.5 10A1.5 1.5 0 0 0 2 11.5v5A1.5 1.5 0 0 0 3.5 18h1A1.5 1.5 0 0 0 6 16.5v-5A1.5 1.5 0 0 0 4.5 10h-1Z"
    }));
}
const $aabf4df1bf2eda9b$var$ForwardRef = $7fPBF.forwardRef($aabf4df1bf2eda9b$var$ChartBarIcon);
var $aabf4df1bf2eda9b$export$2e2bcd8739ae039 = $aabf4df1bf2eda9b$var$ForwardRef;


/* eslint-disable react/no-unstable-nested-components */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/destructuring-assignment */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");




var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $7fPBF = parcelRequire("7fPBF");


var $9tqwB = parcelRequire("9tqwB");

var $7fPBF = parcelRequire("7fPBF");
function $0fcec64c9b7e118d$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0fcec64c9b7e118d$export$71594e8a50f746f4 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $0fcec64c9b7e118d$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === "[object Window]" || // In Electron context the Window object serializes to [object global]
    elementString === "[object global]";
}
function $0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(node) {
    return "nodeType" in node;
}
function $0fcec64c9b7e118d$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0fcec64c9b7e118d$export$5a096129d439f843(target)) return target;
    if (!$0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0fcec64c9b7e118d$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0fcec64c9b7e118d$export$1b3bfaa9684536aa(node) {
    if ($0fcec64c9b7e118d$export$5a096129d439f843(node)) return false;
    return node instanceof $0fcec64c9b7e118d$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0fcec64c9b7e118d$export$17eda790a720ec57(node) {
    return node instanceof $0fcec64c9b7e118d$export$38b2d434cce3ea22(node).SVGElement;
}
function $0fcec64c9b7e118d$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0fcec64c9b7e118d$export$5a096129d439f843(target)) return target.document;
    if (!$0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0fcec64c9b7e118d$export$62858bae88b53fd0(target)) return target;
    if ($0fcec64c9b7e118d$export$1b3bfaa9684536aa(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0fcec64c9b7e118d$export$700979bc83e7db82 = $0fcec64c9b7e118d$export$71594e8a50f746f4 ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $0fcec64c9b7e118d$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $7fPBF.useRef)(handler);
    $0fcec64c9b7e118d$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $7fPBF.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0fcec64c9b7e118d$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $7fPBF.useRef)(null);
    const set = (0, $7fPBF.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $7fPBF.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0fcec64c9b7e118d$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $7fPBF.useRef)(value);
    $0fcec64c9b7e118d$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $7fPBF.useRef)();
    return (0, $7fPBF.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0fcec64c9b7e118d$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0fcec64c9b7e118d$export$90fc3a17d93f704c(onChange);
    const node = (0, $7fPBF.useRef)(null);
    const setNodeRef = (0, $7fPBF.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0fcec64c9b7e118d$export$5cae361ad82dce8b(value) {
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0fcec64c9b7e118d$var$ids = {};
function $0fcec64c9b7e118d$export$c485849f2e393253(prefix, value) {
    return (0, $7fPBF.useMemo)(()=>{
        if (value) return value;
        const id = $0fcec64c9b7e118d$var$ids[prefix] == null ? 0 : $0fcec64c9b7e118d$var$ids[prefix] + 1;
        $0fcec64c9b7e118d$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0fcec64c9b7e118d$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, (0, $9tqwB._)({}, object));
    };
}
const $0fcec64c9b7e118d$export$e16d8520af44a096 = /*#__PURE__*/ $0fcec64c9b7e118d$var$createAdjustmentFn(1);
const $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0fcec64c9b7e118d$var$createAdjustmentFn(-1);
function $0fcec64c9b7e118d$export$d0e71af79cd586c6(event) {
    return "clientX" in event && "clientY" in event;
}
function $0fcec64c9b7e118d$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0fcec64c9b7e118d$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0fcec64c9b7e118d$export$36195c8aa1517e04(event) {
    if ($0fcec64c9b7e118d$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0fcec64c9b7e118d$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0fcec64c9b7e118d$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0fcec64c9b7e118d$export$c4ffa16951855e28.Translate.toString(transform),
                $0fcec64c9b7e118d$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(" ");
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0fcec64c9b7e118d$var$SELECTOR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function $0fcec64c9b7e118d$export$44f71d798fd0a62b(element) {
    if (element.matches($0fcec64c9b7e118d$var$SELECTOR)) return element;
    return element.querySelector($0fcec64c9b7e118d$var$SELECTOR);
}


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $a14476affb27f7d7$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $a14476affb27f7d7$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $a14476affb27f7d7$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $a14476affb27f7d7$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $a14476affb27f7d7$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $a14476affb27f7d7$var$normalizeDisabled(disabled) {
    if (typeof disabled === "boolean") return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $a14476affb27f7d7$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $a14476affb27f7d7$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $a14476affb27f7d7$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return (0, $9tqwB._)({
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0
        }, $a14476affb27f7d7$var$defaultScale);
    }
    if (index > activeIndex && index <= overIndex) return (0, $9tqwB._)({
        x: -activeNodeRect.width - itemGap,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale);
    if (index < activeIndex && index >= overIndex) return (0, $9tqwB._)({
        x: activeNodeRect.width + itemGap,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale);
    return (0, $9tqwB._)({
        x: 0,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale);
};
function $a14476affb27f7d7$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $a14476affb27f7d7$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $a14476affb27f7d7$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $a14476affb27f7d7$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $a14476affb27f7d7$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $a14476affb27f7d7$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return (0, $9tqwB._)({
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top
        }, $a14476affb27f7d7$var$defaultScale$1);
    }
    const itemGap = $a14476affb27f7d7$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return (0, $9tqwB._)({
        x: 0,
        y: -activeNodeRect.height - itemGap
    }, $a14476affb27f7d7$var$defaultScale$1);
    if (index < activeIndex && index >= overIndex) return (0, $9tqwB._)({
        x: 0,
        y: activeNodeRect.height + itemGap
    }, $a14476affb27f7d7$var$defaultScale$1);
    return (0, $9tqwB._)({
        x: 0,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale$1);
};
function $a14476affb27f7d7$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $a14476affb27f7d7$var$ID_PREFIX = "Sortable";
const $a14476affb27f7d7$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    activeIndex: -1,
    containerId: $a14476affb27f7d7$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $a14476affb27f7d7$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $a14476affb27f7d7$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $a14476affb27f7d7$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $ecddad0aaeff3d51$export$4930f6bf413be70e)();
    const containerId = (0, $0fcec64c9b7e118d$export$c485849f2e393253)($a14476affb27f7d7$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $7fPBF.useMemo)(()=>userDefinedItems.map((item)=>typeof item === "object" && "id" in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $7fPBF.useRef)(items);
    const itemsHaveChanged = !$a14476affb27f7d7$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $a14476affb27f7d7$var$normalizeDisabled(disabledProp);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $a14476affb27f7d7$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a14476affb27f7d7$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $a14476affb27f7d7$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $a14476affb27f7d7$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $a14476affb27f7d7$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $a14476affb27f7d7$var$defaultTransition = {
    duration: 200,
    easing: "ease"
};
const $a14476affb27f7d7$var$transitionProperty = "transform";
const $a14476affb27f7d7$var$disabledTransition = /*#__PURE__*/ (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transition.toString({
    property: $a14476affb27f7d7$var$transitionProperty,
    duration: 0,
    easing: "linear"
});
const $a14476affb27f7d7$var$defaultAttributes = {
    roleDescription: "sortable"
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $a14476affb27f7d7$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $7fPBF.useState)(null);
    const previousIndex = (0, $7fPBF.useRef)(index);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $ecddad0aaeff3d51$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $a14476affb27f7d7$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $a14476affb27f7d7$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $a14476affb27f7d7$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $a14476affb27f7d7$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $7fPBF.useContext)($a14476affb27f7d7$var$Context);
    const disabled = $a14476affb27f7d7$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $7fPBF.useMemo)(()=>(0, $9tqwB._)({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            }
        }, customData), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $7fPBF.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $ecddad0aaeff3d51$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: (0, $9tqwB._)({
            updateMeasurementsFor: itemsAfterCurrentSortable
        }, resizeObserverConfig)
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $ecddad0aaeff3d51$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: (0, $9tqwB._)({}, $a14476affb27f7d7$var$defaultAttributes, userDefinedAttributes),
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $0fcec64c9b7e118d$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $a14476affb27f7d7$var$isValidIndex(activeIndex) && $a14476affb27f7d7$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $a14476affb27f7d7$var$isValidIndex(activeIndex) && $a14476affb27f7d7$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $7fPBF.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $a14476affb27f7d7$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $7fPBF.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId && !previous.current.activeId) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $a14476affb27f7d7$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $0fcec64c9b7e118d$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transition.toString((0, $2qxEV._)((0, $9tqwB._)({}, transition), {
            property: $a14476affb27f7d7$var$transitionProperty
        }));
        return undefined;
    }
}
function $a14476affb27f7d7$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === "boolean") return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $a14476affb27f7d7$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && "sortable" in data && typeof data.sortable === "object" && "containerId" in data.sortable && "items" in data.sortable && "index" in data.sortable) return true;
    return false;
}
const $a14476affb27f7d7$var$directions = [
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Down,
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Right,
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Up,
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Left
];
const $a14476affb27f7d7$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($a14476affb27f7d7$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $ecddad0aaeff3d51$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $ecddad0aaeff3d51$export$ef1beab6d7287295)(collisions, "id");
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $ecddad0aaeff3d51$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $a14476affb27f7d7$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $a14476affb27f7d7$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $a14476affb27f7d7$var$isSameContainer(a, b) {
    if (!$a14476affb27f7d7$export$6424ec8a0d450b09(a) || !$a14476affb27f7d7$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $a14476affb27f7d7$var$isAfter(a, b) {
    if (!$a14476affb27f7d7$export$6424ec8a0d450b09(a) || !$a14476affb27f7d7$export$6424ec8a0d450b09(b)) return false;
    if (!$a14476affb27f7d7$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}





/* eslint-disable react/jsx-no-bind */ /* eslint-disable max-len */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $1559a4f4dda4795e$var$TrashIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
        clipRule: "evenodd"
    }));
}
const $1559a4f4dda4795e$var$ForwardRef = $7fPBF.forwardRef($1559a4f4dda4795e$var$TrashIcon);
var $1559a4f4dda4795e$export$2e2bcd8739ae039 = $1559a4f4dda4795e$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $a4e64754a73d3e35$var$CalculatorIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V13.5Zm0 2.25h.008v.008H8.25v-.008Zm0 2.25h.008v.008H8.25V18Zm2.498-6.75h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V13.5Zm0 2.25h.007v.008h-.007v-.008Zm0 2.25h.007v.008h-.007V18Zm2.504-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5Zm0 2.25h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V18Zm2.498-6.75h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V13.5ZM8.25 6h7.5v2.25h-7.5V6ZM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
    }));
}
const $a4e64754a73d3e35$var$ForwardRef = $7fPBF.forwardRef($a4e64754a73d3e35$var$CalculatorIcon);
var $a4e64754a73d3e35$export$2e2bcd8739ae039 = $a4e64754a73d3e35$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $c0142f9c37ea9bd9$var$ClipboardDocumentListIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
    }));
}
const $c0142f9c37ea9bd9$var$ForwardRef = $7fPBF.forwardRef($c0142f9c37ea9bd9$var$ClipboardDocumentListIcon);
var $c0142f9c37ea9bd9$export$2e2bcd8739ae039 = $c0142f9c37ea9bd9$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ba8ba01374a4920e$var$ExclamationTriangleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    }));
}
const $ba8ba01374a4920e$var$ForwardRef = $7fPBF.forwardRef($ba8ba01374a4920e$var$ExclamationTriangleIcon);
var $ba8ba01374a4920e$export$2e2bcd8739ae039 = $ba8ba01374a4920e$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $a8eb369c12c351c2$var$QuestionMarkCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
    }));
}
const $a8eb369c12c351c2$var$ForwardRef = $7fPBF.forwardRef($a8eb369c12c351c2$var$QuestionMarkCircleIcon);
var $a8eb369c12c351c2$export$2e2bcd8739ae039 = $a8eb369c12c351c2$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $0437d10e72efcfd6$var$ArrowRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z",
        clipRule: "evenodd"
    }));
}
const $0437d10e72efcfd6$var$ForwardRef = $7fPBF.forwardRef($0437d10e72efcfd6$var$ArrowRightIcon);
var $0437d10e72efcfd6$export$2e2bcd8739ae039 = $0437d10e72efcfd6$var$ForwardRef;




/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $35b8473afe5c480b$var$MinusIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
        clipRule: "evenodd"
    }));
}
const $35b8473afe5c480b$var$ForwardRef = $7fPBF.forwardRef($35b8473afe5c480b$var$MinusIcon);
var $35b8473afe5c480b$export$2e2bcd8739ae039 = $35b8473afe5c480b$var$ForwardRef;








/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/forbid-prop-types */ // this must return a different component depending on the transaction type selected

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");










var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");











(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $5827969e1a243993$export$2e2bcd8739ae039({ baseCurrency: baseCurrency, setSignalNewAccount: setSignalNewAccount, accountFieldName: accountFieldName }) {
    const { t: tProjects } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const { t: tDashboard } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    // list of enabled categories is kept centrally in enabledCategories.js
    const categories = (0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e)// filter loans and pensions require more input attributes, so they are not included for now (PRD-1526)
    .filter((category)=>category !== "loans" && category !== "pension").map((category)=>({
            id: category,
            name: tDashboard(`singleCategory.${category}`)
        }));
    // this would be easier in assetBalances, but it has no project mode?
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const depositAccountsDropdown = accounts.filter((account)=>account.category === "deposits").map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
    async function createAccount(connectedDepositAccountIdName, category) {
        console.log("DEBUG", connectedDepositAccountIdName);
        // cast to schema
        const schema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(category, "account");
        const newAccountId = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
        const newAccount = schema.cast({
            id: newAccountId,
            name: `${tProjects("newAccount.description")} ${(0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(6)}`,
            currency: baseCurrency,
            connectedDepositAccounts: [
                connectedDepositAccountIdName.id
            ]
        });
        try {
            const response = await dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                data: newAccount,
                category: category
            }));
            // the above somehow does not throw an error when being rejected
            if (response.meta.requestStatus === "rejected") dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeCreated"));
            else {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCreatedSuccessfully"));
                setSignalNewAccount({
                    accountFieldName: accountFieldName,
                    newAccountId: newAccountId
                }); // returns an object
            }
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }
    async function onClick(_, category) {
        setLoading(true);
        // ask in a dialog which deposit account to connect this one to
        window.dispatchEvent(new CustomEvent("setDialog", {
            detail: {
                header: tProjects("selectDepositAccount.header"),
                prompt: tProjects("selectDepositAccount.prompt"),
                dropdown: depositAccountsDropdown,
                value: depositAccountsDropdown[0],
                callback: (selectedValue)=>createAccount(selectedValue, category)
            }
        }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f), {
        as: "div",
        className: "relative self-end",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Button, {
                id: "project-details-add-transaction-new-account",
                type: "button",
                disabled: loading,
                className: "block w-full h-10 rounded-md border border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 hover:bg-gray-50 sm:text-sm text-gray-700",
                children: tProjects("newAccount.label")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                enter: "transition duration-100 ease-out",
                enterFrom: "transform scale-95 opacity-0",
                enterTo: "transform scale-100 opacity-100",
                leave: "transition duration-75 ease-out",
                leaveFrom: "transform scale-100 opacity-100",
                leaveTo: "transform scale-95 opacity-0",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Items, {
                    className: "absolute z-50 mt-3 -translate-x-4 px-4 bg-white text-sm w-64",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex flex-col space-y-1 shrink rounded-md bg-white p-3 text-sm font-normal leading-6 text-gray-900 shadow-lg ring-1 ring-gray-900/5",
                        children: categories.map((category)=>/* Use the `active` state to conditionally style the active item. */ /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        onClick: (e)=>onClick(e, category.id),
                                        className: `${active ? "bg-brandBlue-500 text-white" : "bg-white"} text-left px-2 py-1`,
                                        children: category.name
                                    })
                            }, category.id))
                    })
                })
            })
        ]
    });
}
$5827969e1a243993$export$2e2bcd8739ae039.propTypes = {
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setSignalNewAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    accountFieldName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "account",
        "accountTo",
        "assetAccount"
    ]).isRequired
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $0548dbd4ee9612b7$export$2e2bcd8739ae039({ accountList: accountList, control: control, register: register, mode: mode, errors: errors, watch: watch, setValue: setValue, unregister: unregister }) {
    var _errors_amount, _errors_description;
    const account = watch("account");
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const selectBaseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const baseCurrency = (0, $7fPBF.useMemo)(()=>selectBaseCurrency, [
        selectBaseCurrency
    ]);
    const [showFxRate, setShowFxRate] = (0, $7fPBF.useState)(true);
    const [fxRateLoading, setFxRateLoading] = (0, $7fPBF.useState)(false);
    const currency = watch("currency");
    const amount = watch("amount");
    const exchangeRate = watch("exchangeRate");
    const baseCurrencyAmount = watch("baseCurrencyAmount");
    const depositAccounts = (0, $7fPBF.useMemo)(()=>accountList.filter((a)=>a.category === "deposits"), [
        accountList
    ]);
    const accountToCandidates = (0, $7fPBF.useMemo)(()=>depositAccounts.filter((a)=>a.id !== (account === null || account === void 0 ? void 0 : account.id)), [
        depositAccounts,
        account
    ]);
    // BuySell has a very similar function, remember to change it there as well if changing here
    function handleFxRateFieldSwitch(e) {
        if (showFxRate === true) setValue("baseCurrencyAmount", (Number(amount) * Number(exchangeRate)).toFixed(2), {
            shouldValidate: true,
            shouldTouch: true,
            shouldDirty: true
        });
        if (showFxRate === false) setValue("exchangeRate", (Number(baseCurrencyAmount) / Number(amount)).toFixed(4), {
            shouldValidate: true,
            shouldTouch: true,
            shouldDirty: true
        });
        setShowFxRate(!showFxRate);
    // recalculate FX rate or assetUnitPriceBaseCurrency based on which field was changed
    // if showFxRate is true, then fxRate is being changed to assetUnitPriceBaseCurrency
    }
    const [signalNewAccount, setSignalNewAccount] = (0, $7fPBF.useState)(undefined); // will be set to an object of { accountFieldName, accountId } by NewAccountButton when a new account is created
    // this is done with useEffect instead of a direct callback function, because callback function does not receive updates in accountListFiltered
    (0, $7fPBF.useEffect)(()=>{
        if (signalNewAccount) {
            const newAccount = accountList.find((a)=>a.id === signalNewAccount.newAccountId);
            if (newAccount) setValue(signalNewAccount.accountFieldName, newAccount);
        }
        setSignalNewAccount(undefined);
    }, [
        signalNewAccount
    ]);
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (currency !== baseCurrency) {
                setFxRateLoading(true);
                let newRate;
                try {
                    newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, baseCurrency, currency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                    setValue("exchangeRate", (1 / newRate).toFixed(4), {
                        shouldValidate: true
                    });
                    setFxRateLoading(false);
                } catch (err) {
                    setFxRateLoading(false);
                }
            }
        }
        updateFxRate();
    }, [
        currency
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-3 gap-3",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "email",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("amount.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    name: "amount",
                                    id: "amount",
                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                                    placeholder: mode === "outlfow" ? -500 : 2000
                                }, register("amount", {
                                    validate: (value)=>{
                                        if (mode === "inflow" && value < 0) return t("amount.inflowsCanOnlyBePositive");
                                        if (mode === "outflow" && value > 0) return t("amount.outflowsCanOnlyBeNegative");
                                        if (mode === "transfer" && value < 0) return t("amount.transfersCanOnlyBePositive");
                                        return true;
                                    }
                                })))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "z-[70]",
                        id: "project-details-add-transaction-currency",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            name: "currency",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: t("currency"),
                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                    value: field.value,
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    optional: false
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: showFxRate === true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "exchangeRate",
                                    className: `block text-sm font-medium ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                    children: `${t("exchangeRate.label")} ${baseCurrency}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-1 relative",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                            type: "number",
                                            step: "any",
                                            name: "exchangeRate",
                                            id: "exchangeRate",
                                            disabled: currency === baseCurrency,
                                            // eslint-disable-next-line max-len
                                            className: `block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                            placeholder: 1
                                        }, register("exchangeRate", {
                                            validate: (value)=>{
                                                if (value <= 0) return t("exchangeRate.mustBeGreaterThanZero");
                                                return true;
                                            }
                                        }))),
                                        fxRateLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "absolute inset-y-0 right-0 flex items-center pr-3",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 animate-spin text-gray-600"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    className: `${currency !== baseCurrency ? "" : "hidden"} text-xs underline text-gray-400 hover:text-brandBlue-400`,
                                    onClick: handleFxRateFieldSwitch,
                                    type: "button",
                                    id: "project-details-add-transaction-switch-fx-rate",
                                    children: showFxRate ? `${t("switchToAmount")}` : `${t("switchToFxRate")}`
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "baseCurrencyAmount",
                                    className: `block text-sm font-medium ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                    children: `${t("baseCurrencyAmount.label")} ${baseCurrency}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                        type: "number",
                                        name: "baseCurrencyAmount",
                                        id: "baseCurrencyAmount",
                                        disabled: currency === baseCurrency,
                                        // eslint-disable-next-line max-len
                                        className: `block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                        placeholder: 2000
                                    }, register("baseCurrencyAmount", {
                                        validate: (value)=>{
                                            if (value <= 0) return t("baseCurrencyAmount.mustBeGreaterThanZero");
                                            return true;
                                        }
                                    })))
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    className: `${currency !== baseCurrency ? "" : "hidden"} text-xs underline text-gray-400 hover:text-brandBlue-400`,
                                    onClick: handleFxRateFieldSwitch,
                                    type: "button",
                                    id: "project-details-add-transaction-switch-fx-rate",
                                    children: showFxRate ? `${t("switchToAmount")}` : `${t("switchToFxRate")}`
                                })
                            ]
                        })
                    }),
                    errors.amount && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-3 pt-2 sm:text-sm text-brandRed-500 max-w-xs",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: (_errors_amount = errors.amount) === null || _errors_amount === void 0 ? void 0 : _errors_amount.message
                        })
                    })
                ]
            }),
            mode !== "inflow" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "project-details-add-transaction-account",
                className: "z-50 grid grid-cols-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-3",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            name: "account",
                            id: "account",
                            control: control,
                            defaultValue: depositAccounts[0],
                            render: ({ field: field, ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: t("account.label"),
                                    list: depositAccounts,
                                    value: field.value,
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    inputRef: ref,
                                    extraWide: true,
                                    optional: false
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5827969e1a243993$export$2e2bcd8739ae039), {
                        baseCurrency: baseCurrency,
                        setSignalNewAccount: setSignalNewAccount,
                        accountFieldName: "account"
                    })
                ]
            }),
            mode !== "outflow" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "project-details-add-transaction-accountTo",
                className: "z-50 grid grid-cols-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-3",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            id: "accountTo",
                            name: "accountTo",
                            control: control,
                            defaultValue: depositAccounts[1] || depositAccounts[0],
                            render: ({ field: field, ref: ref })=>{
                                var _errors_accountTo;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: t("accountTo.label"),
                                    list: accountToCandidates,
                                    value: field.value,
                                    onBlur: field.onBlur,
                                    onChange: field.onChange,
                                    inputRef: ref,
                                    errorMessage: (_errors_accountTo = errors.accountTo) === null || _errors_accountTo === void 0 ? void 0 : _errors_accountTo.message,
                                    extraWide: true,
                                    optional: false
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5827969e1a243993$export$2e2bcd8739ae039), {
                        baseCurrency: baseCurrency,
                        setSignalNewAccount: setSignalNewAccount,
                        accountFieldName: "accountTo"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "description",
                        className: "block text-sm font-medium text-gray-700",
                        children: t("transactionDescription.label")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                            type: "text",
                            name: "description",
                            id: "description",
                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm placeholder:italic",
                            placeholder: t("transactionDescription.placeholder")
                        }, register("description", {
                            required: t("transactionDescription.required"),
                            minLength: {
                                value: 2,
                                message: t("transactionDescription.length")
                            }
                        })))
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "pt-2 sm:text-sm text-brandRed-500",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: (_errors_description = errors.description) === null || _errors_description === void 0 ? void 0 : _errors_description.message
                        })
                    })
                ]
            })
        ]
    });
}
$0548dbd4ee9612b7$export$2e2bcd8739ae039.propTypes = {
    accountList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    unregister: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");
var $5132a42f68e309b8$exports = {};
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ const { AbortController: $5132a42f68e309b8$var$AbortController, AbortSignal: $5132a42f68e309b8$var$AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ $5132a42f68e309b8$exports = $5132a42f68e309b8$var$AbortController;
$5132a42f68e309b8$exports.AbortSignal = $5132a42f68e309b8$var$AbortSignal;
$5132a42f68e309b8$exports.default = $5132a42f68e309b8$var$AbortController;



var $2oXYc = parcelRequire("2oXYc");










/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $138d0f7d1549fb32$export$2e2bcd8739ae039({ control: control, accountCategory: accountCategory, t: t, errors: errors }) {
    const [assetNameQuery, setAssetNameQuery] = (0, $7fPBF.useState)("");
    const selectAssets = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$7cd09fd23199c464)) // does not include simulated transactions beyound sliderDate
    .concat((0, $3679aa7475d9bd44$export$bab31b68289bf34b)) // includes the above with some duplicates of the above, but this is not a problem, because we just need a list of unique ids / symbols
    .filter((item)=>item.category === accountCategory);
    const assetSymbols = [
        ...new Set(selectAssets.map((txn)=>`${txn.displaySymbol}##${txn.displayName}`))
    ].map((txn)=>{
        const [displaySymbol, displayName] = txn.split("##");
        return {
            displaySymbol: displaySymbol,
            displayName: displayName
        };
    });
    console.log("assetSymbols", assetSymbols);
    const filteredSymbols = assetNameQuery === "" ? assetSymbols : assetSymbols.filter((s)=>s.displayName.toLowerCase().includes(assetNameQuery.toLowerCase()) || s.displaySymbol.toLowerCase().includes(assetNameQuery.toLowerCase())).slice(0, 6);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
        name: "displaySymbol",
        control: control,
        defaultValue: "",
        render: ({ field: field, ref: ref })=>{
            var _assetSymbols_find, _assetSymbols_find1, _errors_displayName;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e), {
                as: "div",
                className: accountCategory === "metals" ? "col-span-2" : "",
                // show the correct record from assetSymbol, if not found then user input, if not found, show '' to prevent this component to throw a warning uncontrolled > controlled
                value: ((_assetSymbols_find = assetSymbols.find((s)=>s.displaySymbol === field.value)) === null || _assetSymbols_find === void 0 ? void 0 : _assetSymbols_find.displaySymbol) || field.value || "",
                onChange: field.onChange,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Label, {
                        className: "block text-sm font-medium text-gray-700 mb-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            className: "text-black border-gray-400 shadow bg-brandYellow-50",
                            info: accountCategory === "stocks" ? t("assetSymbol.tooltip") : t("assetName.tooltip"),
                            children: [
                                accountCategory === "stocks" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t("assetSymbol.label")
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t("assetName.label")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "ml-2 px-1.5 rounded-full bg-white border-[1px] border-gray-300 text-gray-300 text-xs font-bold",
                                    children: "i"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Input, {
                        id: "project-details-asset-name-input",
                        className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                        onChange: (event)=>setAssetNameQuery(event.target.value),
                        // the field has displaySymbol, but the user is to see displayName
                        displayValue: ((_assetSymbols_find1 = assetSymbols.find((s)=>s.displaySymbol === field.value)) === null || _assetSymbols_find1 === void 0 ? void 0 : _assetSymbols_find1.displaySymbol) || field.value || ""
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Options, {
                        className: "absolute mt-2 p-2 bg-white block rounded-md border border-gray-300 shadow-md sm:text-sm",
                        children: [
                            assetNameQuery.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                                value: assetNameQuery,
                                id: "project-details-asset-name-input-custom-option",
                                className: "ui-active:text-white ui-active:bg-brandBlue-600 text-gray-900 cursor-default select-none relative py-1 pl-3 pr-9",
                                children: `[NEW] ${assetNameQuery}`
                            }, "custom-option"),
                            (filteredSymbols.slice(0, 10) || []).map((symbol)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aa23c555810f7a8$export$27957ad87354dd7e).Option, {
                                    value: symbol.displaySymbol,
                                    id: `project-details-asset-name-input-option-${symbol.displaySymbol}`,
                                    className: "ui-active:text-white ui-active:bg-brandBlue-600 text-gray-900 cursor-default select-none relative py-1 pl-3 pr-9",
                                    children: `${symbol.displayName} | ${symbol.displaySymbol}`
                                }, `${symbol.displaySymbol}-${symbol.displayName}`))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "pt-2 sm:text-sm text-brandRed-500",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: (_errors_displayName = errors.displayName) === null || _errors_displayName === void 0 ? void 0 : _errors_displayName.message
                        })
                    })
                ]
            });
        }
    });
}
$138d0f7d1549fb32$export$2e2bcd8739ae039.propTypes = {
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    accountCategory: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    t: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $ddde1af3baf48bd0$export$2e2bcd8739ae039({ control: control, account: account, t: t, errors: errors, assetIds: assetIds }) {
    var _errors_displayName;
    // assetIds is an array with { assetId, displaySymbol, displayName }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                name: "displaySymbol",
                control: control,
                defaultValue: "",
                render: ({ field: field, ref: ref })=>{
                    // if there is no field.value, set it to assetIds[0]
                    if (!field.value) field.onChange(assetIds[0]);
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
                        as: "div",
                        value: field.value,
                        onChange: field.onChange,
                        ref: ref,
                        children: ({ open: open })=>{
                            var _errors_displaySymbol;
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Label, {
                                        className: "block text-sm font-medium text-gray-700 mb-0.5",
                                        htmlFor: "dropdown",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                            className: "text-black border-gray-400 shadow bg-brandYellow-50",
                                            info: t("assetName.tooltip"),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: `${t("assetName.label")} ${t("assetName.orISIN")}`
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "ml-2 px-1.5 rounded-full bg-white border-[1px] border-gray-300 text-gray-300 text-xs font-bold",
                                                    children: "i"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "relative mt-1",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                                                className: `relative w-full cursor-default rounded-md ${((_errors_displaySymbol = errors.displaySymbol) === null || _errors_displaySymbol === void 0 ? void 0 : _errors_displaySymbol.length) > 0 ? "border-2 border-red-500" : "border border-gray-300"}
              bg-white py-2 pl-3 pr-10 text-left shadow-sm
              focus:border-brandBlue-500 focus:outline-none focus:ring-1 focus:ring-brandBlue-600 sm:text-sm`,
                                                id: "dropdown",
                                                "data-testid": "assetName",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        className: "block truncate",
                                                        children: field.value.displayName
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $839a335830066041$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                                show: open,
                                                as: (0, $7fPBF.Fragment),
                                                leave: "transition ease-in duration-100",
                                                leaveFrom: "opacity-100",
                                                leaveTo: "opacity-0",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                                                    className: "absolute z-20 mt-2 p-2 bg-white block rounded-md border border-gray-300 shadow-md sm:text-sm",
                                                    children: assetIds.map((asset)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                                            value: asset,
                                                            className: ({ active: active })=>`${active ? "text-white bg-brandBlue-500" : "text-gray-900"} cursor-default select-none relative py-2 pl-3 pr-9 flex items-baseline`,
                                                            children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: `${selected ? "font-semibold" : "font-normal"} block truncate`,
                                                                            children: `${asset.displayName} ${asset.displaySymbol ? ` | ${asset.displaySymbol}` : ""}`
                                                                        }),
                                                                        selected ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                            className: `${active ? "text-white" : "text-brandBlue-500"} absolute inset-y-0 right-0 flex items-center pr-4`,
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $debc1b868f0a1333$export$2e2bcd8739ae039), {
                                                                                className: "h-5 w-5",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        }) : null
                                                                    ]
                                                                })
                                                        }, asset.assetId))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    });
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "pt-2 sm:text-sm text-brandRed-500",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    children: (_errors_displayName = errors.displayName) === null || _errors_displayName === void 0 ? void 0 : _errors_displayName.message
                })
            })
        ]
    });
}
$ddde1af3baf48bd0$export$2e2bcd8739ae039.propTypes = {
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    assetIds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    t: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
$ddde1af3baf48bd0$export$2e2bcd8739ae039.defaultProps = {
    account: null
};






(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $cfcc22c8f587d3a3$export$2e2bcd8739ae039({ accountList: accountList, control: control, register: register, mode: mode, errors: errors, watch: watch, unregister: unregister, setValue: setValue, stocksAssets: stocksAssets }) {
    var _errors_assetAccount, _account_connectedDepositAccounts, _errors_assetAmount, _errors_assetUnitPrice;
    const account = watch("assetAccount");
    const accountCategory = account === null || account === void 0 ? void 0 : account.category;
    const connectedDepositAccountsList = (0, $7fPBF.useMemo)(()=>{
        var _account_connectedDepositAccounts;
        return account === null || account === void 0 ? void 0 : (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.map((a)=>accountList === null || accountList === void 0 ? void 0 : accountList.find((b)=>b.id === a));
    }, [
        account,
        accountList
    ]); // populate connectedDepositAccountsList with the actual account objects
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const { t: tS } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "schema"
    });
    const selectBaseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const baseCurrency = (0, $7fPBF.useMemo)(()=>selectBaseCurrency, [
        selectBaseCurrency
    ]);
    const selectStocksMetadata = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $cfd21bc923628483$export$ffbf01f805bb8c9b));
    const selectMetalAssets = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $4678812afdc6b9f3$export$7a3c3d42e4d75513));
    const [showFxRate, setShowFxRate] = (0, $7fPBF.useState)(true);
    const [fxRateLoading, setFxRateLoading] = (0, $7fPBF.useState)(false);
    const [abortController, setAbortController] = (0, $7fPBF.useState)(null);
    const [currentPriceInfo, setCurrentPriceInfo] = (0, $7fPBF.useState)(null);
    const [chartLink, setChartLink] = (0, $7fPBF.useState)(null);
    const exchangeRate = watch("exchangeRate");
    const assetUnitPriceBaseCurrency = watch("assetUnitPriceBaseCurrency");
    const assetAmount = watch("assetAmount");
    const transactionCurrency = watch("transactionCurrency");
    const displaySymbol = watch("displaySymbol");
    // initialise fxRate -- if this is an existing transaction, it will have assetUnitPriceBaseCurrency, but no exchangeRate (set fxRate to false)
    (0, $7fPBF.useEffect)(()=>{
        if (!exchangeRate && !!assetUnitPriceBaseCurrency) setShowFxRate(false);
    }, []);
    // unregister designatedConnectedDepositAccountIndex when it is not needed
    (0, $7fPBF.useEffect)(()=>{
        var _account_connectedDepositAccounts;
        if ((account === null || account === void 0 ? void 0 : (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.length) <= 1 || !(account === null || account === void 0 ? void 0 : account.connectedDepositAccounts)) {
            setValue("designatedConnectedDepositAccountIndex", undefined);
            unregister("designatedConnectedDepositAccountIndex", {
                keepValue: false
            });
        }
    }, [
        account
    ]);
    // when user selects a non-base-currency for the transaction, get the fx rate in the background and display it
    // when updating this code, remember to change the same code in InflowOutflowTransfer.jsx
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (transactionCurrency !== baseCurrency) {
                setFxRateLoading(true);
                let newRate;
                try {
                    newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, baseCurrency, transactionCurrency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                    setValue("exchangeRate", (1 / newRate).toFixed(4), {
                        shouldValidate: true
                    });
                    setFxRateLoading(false);
                } catch (err) {
                    setFxRateLoading(false);
                }
            }
        }
        updateFxRate();
    }, [
        transactionCurrency
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (account) setValue("transactionCurrency", account.currency);
    }, [
        account
    ]);
    // receive stocksAssets with assetId and openAmount
    // caveat: we show a list of assetIds in this project; we do not check if there is enough at the time of the transaction (a warning will show up in TransactionComponent if this is the case)
    const assetIdsArray = (0, $7fPBF.useMemo)(()=>stocksAssets.map(({ assetId: assetId, displayName: displayName, _displaySymbol: _displaySymbol })=>({
                assetId: assetId,
                displayName: displayName,
                displaySymbol: _displaySymbol
            })), [
        stocksAssets
    ]);
    // InflowOutflowTransfer and AddProjectQuote have a very similar function, remember to change it there as well if changing here
    function handleFxRateFieldSwitch(e) {
        if (showFxRate) {
            register("assetUnitPriceBaseCurrency");
            setValue("assetUnitPriceBaseCurrency", (Number(assetAmount) * Number(exchangeRate)).toFixed(2), {
                shouldValidate: true
            });
            unregister("exchangeRate"); // this is done so that prepDataForPost knows if it should use exchangeRate or assetUnitPriceBaseCurrency (so we only keep one of them in the form)
        } else {
            register("exchangeRate");
            setValue("exchangeRate", (Number(assetUnitPriceBaseCurrency) / Number(assetAmount)).toFixed(4), {
                shouldValidate: true
            });
            unregister("assetUnitPriceBaseCurrency"); // this is done so that prepDataForPost knows if it should use exchangeRate or assetUnitPriceBaseCurrency (so we only keep one of them in the form)
        }
        setShowFxRate(!showFxRate);
    // recalculate FX rate or assetUnitPriceBaseCurrency based on which field was changed
    // if showFxRate is true, then fxRate is being changed to assetUnitPriceBaseCurrency
    }
    // AddProjectTransaction adds a 'notAvailableForBuy' flag to rE accounts if they already have transactions in them (you can't add more transactions to account, it's one per property)
    // also do not show any pension accounts in Sell, as it is not possible to sell pension assets at present
    const accountListFiltered = (0, $7fPBF.useMemo)(()=>mode === "buy" ? accountList.filter((a)=>!a.notAvailableForBuy) : accountList.filter((a)=>a.category !== "pension"), [
        mode,
        accountList
    ]);
    // metal list for metals
    const metals = (0, $7fPBF.useMemo)(()=>accountCategory === "metals" ? Object.entries(tS("metals.transaction.parameters.assetMetal", {
            returnObjects: true
        })).map(([id, name])=>({
                id: id,
                name: name
            })) : [], [
        accountCategory,
        tS
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // set metal to default gold if not set already
        if (accountCategory === "metals" && !watch("assetMetalUserInput")) setValue("assetMetalUserInput", metals[0]);
    }, [
        accountCategory
    ]);
    const [signalNewAccount, setSignalNewAccount] = (0, $7fPBF.useState)(undefined); // will be set to an object of { accountFieldName, accountId } by NewAccountButton when a new account is created
    // this is done with useEffect instead of a direct callback function, because callback function does not receive updates in accountListFiltered
    (0, $7fPBF.useEffect)(()=>{
        if (signalNewAccount) {
            const newAccount = accountListFiltered.find((a)=>a.id === signalNewAccount.newAccountId);
            if (newAccount) setValue(signalNewAccount.accountFieldName, newAccount);
        }
        setSignalNewAccount(undefined);
    }, [
        signalNewAccount
    ]);
    // gets call parameters from closure
    // returns { displaySymbol, figi, providerAssetId, ... }
    async function getFigi() {
        const controller = new (0, (/*@__PURE__*/$parcel$interopDefault($5132a42f68e309b8$exports)))();
        setAbortController(controller);
        try {
            const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "stocks/assetids", {
                body: {
                    currency: transactionCurrency,
                    symbol: displaySymbol
                },
                headers: {
                    "Content-Type": "application/json"
                },
                abortController: controller
            });
            return response;
        // Handle the fetched data as required...
        } catch (error) {
            // no error message, as this is a courtesy service
            console.error("error API call to getAssetIds", error);
        }
        return null;
    }
    // gets call parameters from closure
    // returns { displaySymbol, figi, providerAssetId, ... }
    async function getQuote(assetId, providerAssetId, currency = null) {
        const controller = new (0, (/*@__PURE__*/$parcel$interopDefault($5132a42f68e309b8$exports)))();
        setAbortController(controller);
        const assets = [
            {
                assetId: assetId,
                providerAssetId: providerAssetId
            }
        ];
        if (currency) assets[0].currency = currency;
        try {
            const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "quotes/get", {
                body: {
                    dates: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf()
                    ],
                    assets: assets
                },
                headers: {
                    "Content-Type": "application/json"
                },
                abortController: controller
            });
            return response;
        // Handle the fetched data as required...
        } catch (error) {
            // no error message, as this is a courtesy service
            console.error("error API call to get quotes", error);
        }
        return null;
    }
    // when displaySymbol changes, fetch the figi and the current quote, and display it to user
    // i.e. the user may actually enter a new (previously unknown) ISIN, for which we need to derive providerAssetId (that is done in getFigi), so that we can get the quote
    // TODO when i enter data in displaySymbol, I want to be able to press arrow down to go to the picklist and select the asset
    // eslint-disable-next-line consistent-return
    (0, $7fPBF.useEffect)(()=>{
        setCurrentPriceInfo(null);
        setChartLink(null);
        let timeout;
        let providerAssetId;
        let assetId;
        let displayName;
        if (displaySymbol) {
            if (accountCategory === "stocks") {
                if (abortController) abortController.abort();
                // Debounce the new fetch request using setTimeout (make sure it is not called too frequently).
                timeout = setTimeout(async ()=>{
                    var _responseQuotes_quotes;
                    if (!selectStocksMetadata.providerAssetIdByDisplaySymbol[displaySymbol]) {
                        const response = await getFigi({
                            currency: transactionCurrency,
                            symbol: displaySymbol
                        }); // Call your async API data fetch function.
                        providerAssetId = response === null || response === void 0 ? void 0 : response.providerAssetId;
                        assetId = response === null || response === void 0 ? void 0 : response.figi;
                        displayName = response === null || response === void 0 ? void 0 : response.displayName;
                    } else {
                        providerAssetId = selectStocksMetadata.providerAssetIdByDisplaySymbol[displaySymbol]; // get providerAssetId for newly entered symbols
                        assetId = selectStocksMetadata.assetIdByDisplaySymbol[displaySymbol];
                        displayName = selectStocksMetadata.displayNameByDisplaySymbol[displaySymbol];
                    }
                    // get the actual quote
                    const responseQuotes = await getQuote(assetId, providerAssetId); // returns { quotes: [], status }
                    if ((responseQuotes === null || responseQuotes === void 0 ? void 0 : (_responseQuotes_quotes = responseQuotes.quotes) === null || _responseQuotes_quotes === void 0 ? void 0 : _responseQuotes_quotes.length) > 0) {
                        var _responseQuotes_quotes_, _responseQuotes_quotes__quote, _responseQuotes_quotes_1;
                        setCurrentPriceInfo(`${t("todaysPrice", {
                            displayName: displayName
                        })} ${responseQuotes === null || responseQuotes === void 0 ? void 0 : (_responseQuotes_quotes_1 = responseQuotes.quotes[0]) === null || _responseQuotes_quotes_1 === void 0 ? void 0 : (_responseQuotes_quotes__quote = _responseQuotes_quotes_1.quote) === null || _responseQuotes_quotes__quote === void 0 ? void 0 : _responseQuotes_quotes__quote.toLocaleString("de", {
                            style: "currency",
                            currency: responseQuotes === null || responseQuotes === void 0 ? void 0 : (_responseQuotes_quotes_ = responseQuotes.quotes[0]) === null || _responseQuotes_quotes_ === void 0 ? void 0 : _responseQuotes_quotes_.currency
                        })}`);
                        setChartLink(`https://finance.yahoo.com/quote/${providerAssetId}`);
                    }
                }, 2000);
            } else if (accountCategory === "metals") {
                // update other asset fields
                // check if the asset exists in metalAssets; when user enters a new asset manually, the text they enter appears in displaySymbol; if they pick one, it's assetId
                // displaySymbol displays assetName for metals, but its form state is assetId
                const metal = selectMetalAssets.find((m)=>m.assetId === displaySymbol);
                if (metal) {
                    setValue("assetId", displaySymbol);
                    setValue("assetName", metal.assetName);
                    setValue("assetMetal", metal.assetMetal);
                    setValue("assetWeight", metal.assetWeight);
                    setValue("assetPurity", metal.assetPurity);
                    setValue("assetAdditionalValue", metal.assetAdditionalValue);
                } else {
                    // this is a new asset, so we only have the displaySymbol (assetName)
                    setValue("assetName", displaySymbol);
                    setValue("assetId", displaySymbol.replace(/[^a-zA-Z0-9]/g, "")); // only leave letters and numbers, strip and trim everything else
                }
            // get quotes will be handled separately, because it needs to react to changes in all the asset fields (not only displaySymbol)
            }
            return ()=>clearTimeout(timeout); // Clear the timeout if the component unmounts or if 'displaySymbol' changes again.
        }
    }, [
        displaySymbol
    ]);
    // react to changes in metals asset fields; if they are complete, get a quote
    const assetId = watch("assetId");
    const assetName = watch("assetName");
    const assetMetalUserInput = watch("assetMetalUserInput"); // this has the output of Dropdown: { id, name }
    const assetWeight = watch("assetWeight");
    const assetPurity = watch("assetPurity");
    const assetAdditionalValue = watch("assetAdditionalValue");
    (0, $7fPBF.useEffect)(()=>{
        // if this anyway runs every time assetMetal changes, use it to convert assetMetalUserInput to assetMetal
        if (assetMetalUserInput) setValue("assetMetal", assetMetalUserInput.id);
        // get current quote
        if (accountCategory === "metals" && assetMetalUserInput && assetWeight && assetPurity && assetAdditionalValue) {
            const timeout = setTimeout(async ()=>{
                var _responseQuotes_quotes, _responseQuotes_quotes_, _responseQuotes_quotes__quote, _responseQuotes_quotes_1;
                // get the quote (displaySymbol is assetId for metals, from the AssetNameDropdown (it displays assetName, but binds assetId))
                // returns { quotes: [], status }
                const responseQuotes = await getQuote(assetId, {
                    assetMetal: assetMetalUserInput.id,
                    assetMetalWeight: assetWeight * (assetPurity / 1000),
                    assetAdditionalValue: assetAdditionalValue
                }, transactionCurrency);
                if ((responseQuotes === null || responseQuotes === void 0 ? void 0 : (_responseQuotes_quotes = responseQuotes.quotes) === null || _responseQuotes_quotes === void 0 ? void 0 : _responseQuotes_quotes.length) > 0) setCurrentPriceInfo(`${t("todaysPrice", {
                    displayName: assetName
                })} ${responseQuotes === null || responseQuotes === void 0 ? void 0 : (_responseQuotes_quotes_1 = responseQuotes.quotes[0]) === null || _responseQuotes_quotes_1 === void 0 ? void 0 : (_responseQuotes_quotes__quote = _responseQuotes_quotes_1.quote) === null || _responseQuotes_quotes__quote === void 0 ? void 0 : _responseQuotes_quotes__quote.toLocaleString("de", {
                    style: "currency",
                    currency: responseQuotes === null || responseQuotes === void 0 ? void 0 : (_responseQuotes_quotes_ = responseQuotes.quotes[0]) === null || _responseQuotes_quotes_ === void 0 ? void 0 : _responseQuotes_quotes_.currency
                })}`);
            }, 2000);
        }
    }, [
        displaySymbol,
        assetName,
        assetMetalUserInput,
        assetWeight,
        assetPurity,
        assetAdditionalValue
    ]);
    // when the user changes the account, reset the displaySymbol field
    // this doesn't work as useEffect on account, because the form gets rendered a few times on initialisation and there is no way of knowing if this is intialisation or not
    // (during initialisation we need to pass the original transaction's displaySymbol to form to show it)
    function handleOnChangeAccount(e, onChange) {
        setValue("displaySymbol", "");
        onChange(e);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "space-y-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "project-details-add-transaction-accountTo",
                className: "relative z-50 grid grid-cols-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "col-span-3",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            name: "assetAccount",
                            control: control,
                            defaultValue: accountListFiltered[0],
                            rules: {
                                validate: (value)=>{
                                    var _value_connectedDepositAccounts;
                                    // throw an error if the selected account does not have a connected deposit account
                                    // (a deposit transaction is created on the connected account to match asset purchase and sale)
                                    console.info("BuySell > assetAccount > validate: value", value);
                                    if (((_value_connectedDepositAccounts = value.connectedDepositAccounts) === null || _value_connectedDepositAccounts === void 0 ? void 0 : _value_connectedDepositAccounts.length) === 0) return t("assetAccount.error");
                                    return true;
                                }
                            },
                            render: ({ field: field, ref: ref })=>{
                                var _errors_assetAccount;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: accountCategory !== "pension" ? t("assetAccount.label") : t("assetContributionLabel.label"),
                                    list: accountListFiltered,
                                    value: field.value,
                                    onChange: (e)=>handleOnChangeAccount(e, field.onChange),
                                    onBlur: field.onBlur,
                                    inputRef: ref,
                                    errorMessage: (_errors_assetAccount = errors.assetAccount) === null || _errors_assetAccount === void 0 ? void 0 : _errors_assetAccount.message,
                                    extraWide: true,
                                    optional: false
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5827969e1a243993$export$2e2bcd8739ae039), {
                        baseCurrency: baseCurrency,
                        setSignalNewAccount: setSignalNewAccount,
                        accountFieldName: "assetAccount"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "pt-2 sm:text-sm text-brandRed-500 col-span-4",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: (_errors_assetAccount = errors.assetAccount) === null || _errors_assetAccount === void 0 ? void 0 : _errors_assetAccount.message
                        })
                    })
                ]
            }),
            [
                "stocks",
                "crypto"
            ].includes(accountCategory) && mode === "buy" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "project-details-add-transaction-asset-name",
                className: "relative z-40",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $138d0f7d1549fb32$export$2e2bcd8739ae039), {
                    control: control,
                    accountCategory: accountCategory,
                    t: t,
                    errors: errors
                })
            }),
            [
                "metals"
            ].includes(accountCategory) && mode === "buy" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "project-details-add-transaction-asset-name",
                className: "relative z-40 grid grid-cols-4 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $138d0f7d1549fb32$export$2e2bcd8739ae039), {
                        control: control,
                        accountCategory: accountCategory,
                        t: t,
                        errors: errors
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "assetMetalUserInput",
                        control: control,
                        render: ({ field: field, ref: ref })=>{
                            var _errors_assetMetal;
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                formatting: "col-span-2",
                                label: t("assetMetal.label"),
                                list: metals,
                                value: field.value,
                                onChange: field.onChange,
                                onBlur: field.onBlur,
                                inputRef: ref,
                                errorMessage: (_errors_assetMetal = errors.assetMetal) === null || _errors_assetMetal === void 0 ? void 0 : _errors_assetMetal.message,
                                extraWide: true,
                                optional: false
                            });
                        }
                    })
                ]
            }),
            [
                "stocks",
                "crypto",
                "metals"
            ].includes(accountCategory) && mode === "sell" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "project-details-add-transaction-asset-name",
                className: "relative z-50",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddde1af3baf48bd0$export$2e2bcd8739ae039 // displaySymbol
                ), {
                    control: control,
                    account: account,
                    assetIds: assetIdsArray,
                    t: t,
                    errors: errors
                })
            }),
            [
                "metals"
            ].includes(accountCategory) && mode === "buy" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                id: "project-details-add-transaction-metal-supplemental",
                className: "grid grid-cols-3 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "assetWeight",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("assetWeight.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    name: "assetWeight",
                                    id: "assetWeight",
                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                                    placeholder: 10
                                }, register("assetWeight")))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "assetPurity",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("assetPurity.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    name: "assetPurity",
                                    id: "assetPurity",
                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                                    placeholder: 999
                                }, register("assetPurity")))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "assetAdditionalValue",
                                className: "block text-sm font-medium text-gray-700",
                                children: t("assetAdditionalValue.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    name: "assetAdditionalValue",
                                    id: "assetAdditionalValue",
                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                                    placeholder: 0
                                }, register("assetAdditionalValue")))
                            })
                        ]
                    })
                ]
            }),
            (account === null || account === void 0 ? void 0 : (_account_connectedDepositAccounts = account.connectedDepositAccounts) === null || _account_connectedDepositAccounts === void 0 ? void 0 : _account_connectedDepositAccounts.length) > 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "project-details-add-transaction-designate-account",
                className: "z-50 grid grid-cols-4 gap-2",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "col-span-4",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        name: "designatedConnectedDepositAccountIndex",
                        control: control,
                        defaultValue: 0,
                        render: ({ field: field, ref: ref })=>{
                            var _errors_designatedConnectedDepositAccountIndex;
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                label: t("designatedConnectedDepositAccountIndex.label"),
                                list: connectedDepositAccountsList,
                                value: field.value,
                                onChange: field.onChange,
                                onBlur: field.onBlur,
                                inputRef: ref,
                                errorMessage: (_errors_designatedConnectedDepositAccountIndex = errors.designatedConnectedDepositAccountIndex) === null || _errors_designatedConnectedDepositAccountIndex === void 0 ? void 0 : _errors_designatedConnectedDepositAccountIndex.message,
                                extraWide: true,
                                sendBackIndex: true
                            });
                        }
                    })
                })
            }),
            [
                "stocks",
                "metals",
                "crypto",
                "unlistedShares"
            ].includes(accountCategory) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "assetAmount",
                        className: "block text-sm font-medium text-gray-700",
                        children: `${t("assetAmount.label")} ${mode === "buy" ? t("assetAmount.buy") : t("assetAmount.sell")}?`
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                            type: "number",
                            name: "assetAmount",
                            id: "assetAmount",
                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                            placeholder: 100
                        }, register("assetAmount")))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-3 gap-3",
                id: "project-details-add-transaction-amount",
                children: [
                    accountCategory === "deposits" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "assetAmount",
                                className: "block text-sm font-medium text-gray-700",
                                children: accountCategory === "deposits" ? t("depositAmount.label") : t("assetAmount.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    step: "0.01",
                                    name: "assetAmount",
                                    id: "assetAmount",
                                    placeholder: 35.49,
                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                }, register("assetAmount", {
                                    min: {
                                        value: 0,
                                        message: t("assetAmount.error")
                                    }
                                })))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: (_errors_assetAmount = errors.assetAmount) === null || _errors_assetAmount === void 0 ? void 0 : _errors_assetAmount.message
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "assetUnitPrice",
                                className: "block text-sm font-medium text-gray-700",
                                children: accountCategory === "pension" ? t("assetContribution.label") : t("assetUnitPrice.label")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                    type: "number",
                                    step: "0.01",
                                    name: "assetUnitPrice",
                                    id: "assetUnitPrice",
                                    placeholder: 35.49,
                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                }, register("assetUnitPrice", {
                                    min: {
                                        value: 0,
                                        message: t("assetUnitPrice.error")
                                    }
                                })))
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: (_errors_assetUnitPrice = errors.assetUnitPrice) === null || _errors_assetUnitPrice === void 0 ? void 0 : _errors_assetUnitPrice.message
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "z-10",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                            name: "transactionCurrency",
                            control: control,
                            render: ({ field: field, ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    label: t("currency"),
                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                    value: field.value,
                                    onChange: field.onChange,
                                    onBlur: field.onBlur,
                                    inputRef: ref,
                                    optional: false
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: showFxRate ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "exchangeRate",
                                    className: `block text-sm font-medium ${transactionCurrency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                    children: `${t("exchangeRate.label")} ${baseCurrency}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-1 relative",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                            type: "number",
                                            step: "any",
                                            name: "exchangeRate",
                                            id: "exchangeRate",
                                            disabled: transactionCurrency === baseCurrency,
                                            // eslint-disable-next-line max-len
                                            className: `block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm ${transactionCurrency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                            placeholder: 1
                                        }, register("exchangeRate", {
                                            validate: (value)=>{
                                                if (value <= 0) return t("exchangeRate.mustBeGreaterThanZero");
                                                return true;
                                            }
                                        }))),
                                        fxRateLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "absolute inset-y-0 right-0 flex items-center pr-3",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "h-4 w-4 animate-spin text-gray-600"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    className: `${transactionCurrency !== baseCurrency ? "" : "hidden"} text-xs underline text-gray-400 hover:text-brandBlue-400`,
                                    onClick: handleFxRateFieldSwitch,
                                    type: "button",
                                    children: showFxRate ? t("switchToAmount") : `${t("switchToFxRate")} ${baseCurrency}`
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "assetUnitPriceBaseCurrency",
                                    className: `block text-sm font-medium ${transactionCurrency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                    children: `${t("assetUnitPriceBaseCurrency.label")} ${baseCurrency}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-1",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                        type: "number",
                                        name: "assetUnitPriceBaseCurrency",
                                        id: "assetUnitPriceBaseCurrency",
                                        disabled: transactionCurrency === baseCurrency,
                                        className: `block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm ${transactionCurrency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                        placeholder: 2000
                                    }, register("assetUnitPriceBaseCurrency", {
                                        validate: (value)=>{
                                            if (value <= 0) return t("assetUnitPriceBaseCurrency.mustBeGreaterThanZero");
                                            return true;
                                        }
                                    })))
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    className: `${transactionCurrency !== baseCurrency ? "" : "hidden"} text-xs underline text-gray-400 hover:text-brandBlue-400`,
                                    onClick: handleFxRateFieldSwitch,
                                    type: "button",
                                    children: showFxRate ? `${t("switchToAmount")}` : t("switchToFxRate")
                                })
                            ]
                        })
                    }),
                    currentPriceInfo && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "col-span-3 transition ease-in flex space-x-1 items-center bg-brandBlue-50 px-2 py-2 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecc4fe7bc6f465a6$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-brandBlue-700"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-brandBlue-700 text-sm ",
                                children: currentPriceInfo
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                href: chartLink,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "text-xs underline text-gray-400 hover:text-gray-500",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9af79d6ecc5b05c1$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// eslint-disable-next-line max-len
$cfcc22c8f587d3a3$export$2e2bcd8739ae039.propTypes = {
    accountList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    unregister: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    getFieldState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    stocksAssets: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array
};
$cfcc22c8f587d3a3$export$2e2bcd8739ae039.defaultProps = {
    stocksAssets: []
};


function $cafa6a3cc1d10837$export$2e2bcd8739ae039({ transactionType: transactionType, accountList: accountList, control: control, register: register, errors: errors, watch: watch, unregister: unregister, setValue: setValue, getFieldState: getFieldState, stocksAssets: stocksAssets }) {
    const standardProps = {
        accountList: accountList,
        control: control,
        register: register,
        errors: errors,
        watch: watch,
        unregister: unregister,
        setValue: setValue,
        getFieldState: getFieldState
    };
    switch(transactionType){
        case "inflow":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0548dbd4ee9612b7$export$2e2bcd8739ae039), (0, $9tqwB._)({
                mode: "inflow"
            }, standardProps));
        case "outflow":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0548dbd4ee9612b7$export$2e2bcd8739ae039), (0, $9tqwB._)({
                mode: "outflow"
            }, standardProps));
        case "transfer":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0548dbd4ee9612b7$export$2e2bcd8739ae039), (0, $9tqwB._)({
                mode: "transfer"
            }, standardProps));
        case "buy":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfcc22c8f587d3a3$export$2e2bcd8739ae039), (0, $9tqwB._)({
                mode: "buy"
            }, standardProps));
        case "sell":
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfcc22c8f587d3a3$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({
                mode: "sell"
            }, standardProps), {
                stocksAssets: stocksAssets
            }));
        default:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
    }
}
$cafa6a3cc1d10837$export$2e2bcd8739ae039.propTypes = {
    transactionType: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    accountList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    control: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    register: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    unregister: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    errors: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    watch: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    getFieldState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    stocksAssets: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired
};






var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");







const $558e4a05c7aecdc8$var$debugLevel = 3;
// creates a deposit transaction based on user input
// provide depositAccount for deposit transactions, assetAccount for buy / sell transactions (see below for logic)
// 'currency' is the currency of the transaction, i.e. it will be mapped to fxCurrency (see below)
async function $558e4a05c7aecdc8$var$createDepositTransaction({ transaction: transaction, depositAccount: depositAccount, assetAccount: assetAccount, amount: amount, fxCurrency: fxCurrency, description: description = "", linkedTransactionId: linkedTransactionId = null, linkedTransactionCategory: linkedTransactionCategory = null, linkedDepositAccount: linkedDepositAccount = null, designatedConnectedDepositAccountIndex: designatedConnectedDepositAccountIndex = 0 }) {
    // creates a deposit transaction based on user input
    // account will be treated as assetAccount if transaction type is buy or sell; otherwise as depositsAccount
    // amount is in the currency indicated by user (transactionCurrency for buy / sell)
    // eslint-disable-next-line max-len
    if ($558e4a05c7aecdc8$var$debugLevel > 2) console.log("createDepositTransaction started with args", transaction, depositAccount, assetAccount, amount, fxCurrency, description, linkedTransactionId, linkedTransactionCategory, linkedDepositAccount, designatedConnectedDepositAccountIndex);
    const tt = transaction.transactionType;
    const accountId = (depositAccount === null || depositAccount === void 0 ? void 0 : depositAccount.id) || (assetAccount === null || assetAccount === void 0 ? void 0 : assetAccount.connectedDepositAccounts[designatedConnectedDepositAccountIndex]);
    // get currency for deposit account transactions is the asset account currency
    // we do it by looking it up on the target account
    // we provide currency, fxCurrency and fxAmount to the API, it will sort the transaction out (will remove it from fx... fields if it's not a fx transaction)
    let depositAccountCurrency;
    if (assetAccount) {
        const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
        const accounts = (0, $93bb2798871a68d2$export$8c577782bb016c47)(state);
        try {
            depositAccountCurrency = accounts.find((a)=>a.id === accountId).currency;
            console.log("DEBUG from props deposit acc:", depositAccount, "asset acc:", assetAccount, "calculated", accounts.find((a)=>a.id === accountId));
        } catch (err) {
            console.error("prepareDataForPosT: error while looking up deposit account currency", err);
            console.debug("accounts:", accounts, "accountId:", accountId);
            throw new Error("Error while looking up deposit account currency");
        }
    }
    // calculate the label for deposit transaction based on the incoming transaction
    function getLabel(_transaction) {
        const { transactionType: transactionType, category: category } = _transaction;
        const sourceCategory = category || (assetAccount === null || assetAccount === void 0 ? void 0 : assetAccount.category);
        switch(transactionType){
            case "buy":
                switch(sourceCategory){
                    case "pension":
                        return "investment-contribution";
                    case "loans":
                        return "investment-payout";
                    default:
                        return "investment-purchase";
                }
            case "sell":
                // we assume that for loans this can only be an out-of-schedule repayment because interest is calculated automatically
                return sourceCategory === "loans" ? "investment-loanRepayment" : "investment-sale";
            case "transfer":
                return "investment-transfer";
            default:
                return "";
        }
    }
    const depositTransaction = (0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
        accountId: accountId,
        category: "deposits",
        otherParty: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated"),
        otherPartyAccount: tt === "transfer" ? linkedDepositAccount.id : null,
        description: description,
        currency: depositAccountCurrency,
        fxCurrency: fxCurrency || assetAccount.currency,
        fxAmount: amount,
        label: getLabel(transaction)
    }), (assetAccount === null || assetAccount === void 0 ? void 0 : assetAccount.category) === "loans" && tt === "sell" && {
        tags: (0, $2qxEV._)((0, $9tqwB._)({}, transaction.tags || {}), {
            accountId: assetAccount.id,
            loanRepayment: {
                principal: Math.abs(amount),
                interest: 0
            }
        })
    }, (assetAccount === null || assetAccount === void 0 ? void 0 : assetAccount.category) === "loans" && tt === "buy" && {
        tags: (0, $2qxEV._)((0, $9tqwB._)({}, transaction.tags || {}), {
            accountId: assetAccount.id
        })
    }, (assetAccount === null || assetAccount === void 0 ? void 0 : assetAccount.category) === "pension" && tt === "buy" && {
        tags: (0, $2qxEV._)((0, $9tqwB._)({}, transaction.tags || {}), {
            accountId: assetAccount.id,
            assetId: assetAccount.id
        })
    }, !!linkedTransactionId && {
        // only if this is not inflow or outflow
        linkedTransactions: [
            // in case this is an existng transaction with additional LTs, filter out the one that we are about to replace
            ...(transaction.linkedTransactions || []).filter((lt)=>lt.id !== linkedTransactionId),
            // insert link to the linked transaction (asset or deposits for transfer)
            {
                id: linkedTransactionId,
                category: linkedTransactionCategory,
                tags: {
                    type: tt,
                    linkType: `${tt === "buy" ? "purchase-to-transaction" : ""}${tt === "sell" ? "sale-to-transaction" : ""}${tt === "transfer" ? "transfer" : ""}`
                }
            }
        ]
    });
    // put data into schema
    // validateSchema is a wrapper which expects { category: <category-name>, transaction: <transaction-object> } as payload
    // returns { category: 'deposits', transaction: {transaction-object}, validation: true / false }
    let castDepositTransaction;
    try {
        castDepositTransaction = depositTransaction && (0, $f2037232653a5c1d$export$4741711f07dbb8e7)({
            category: "deposits",
            transaction: depositTransaction
        });
        if ($558e4a05c7aecdc8$var$debugLevel > 2) console.log("castDepositTransaction", castDepositTransaction);
    } catch (e) {
        // handle errors coming from schema (display error message and handle user interaction)
        if ($558e4a05c7aecdc8$var$debugLevel > 2) console.info("deposit transaction:", depositTransaction);
        console.error(e.errors || e);
        (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateErrorContents"));
        throw new Error("Error while validating object schema (deposit transaction)"); // to stop executing subsequent code
    }
    return castDepositTransaction.transaction;
}
function $558e4a05c7aecdc8$var$createAssetTransaction({ transaction: transaction, assetAccount: assetAccount, assetAmount: assetAmount, assetId: assetId, transactionOriginalPrice: transactionOriginalPrice = 0, transactionPrice: transactionPrice = 0, linkedTransactionId: linkedTransactionId, formInput: formInput }) {
    // creates an asset transaction based on user input
    if ($558e4a05c7aecdc8$var$debugLevel > 2) console.log("createAssetTransaction started with args", transaction, assetAccount, assetAmount, assetId, transactionOriginalPrice, transactionPrice, linkedTransactionId);
    // abbreviate transactionType for readibility
    const tt = transaction.transactionType;
    // for buy and sell, the transactionDialog is the asset transaction (not the linked deposit transaction)
    const assetTransaction = (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
        accountId: assetAccount.id,
        displayName: assetId,
        displaySymbol: assetId,
        errorId: null,
        category: assetAccount.category,
        transactionType: tt === "buy" ? "purchase" : "sale",
        // displayName: will only be picked up from the form by Stocks API, for real estate that information is supposed to be in account name
        linkedTransactions: [
            // in case this is an existng transaction with additional LTs, filter out the one that we are about to replace
            ...((transaction === null || transaction === void 0 ? void 0 : transaction.linkedTransactions) || []).filter((lt)=>lt.id !== linkedTransactionId),
            // insert link to the linked transaction (asset or deposits for transfer)
            {
                id: linkedTransactionId,
                category: "deposits",
                tags: {
                    type: tt,
                    linkType: `${tt === "buy" ? "purchase-to-transaction" : ""}${tt === "sell" ? "sale-to-transaction" : ""}${tt === "transfer" ? "transfer" : ""}`
                }
            }
        ]
    });
    if (assetAccount.category === "stocks" || assetAccount.category === "crypto") {
        assetTransaction.transactionAmount = tt === "buy" ? assetAmount : -assetAmount;
        assetTransaction.transactionOriginalPrice = transactionOriginalPrice;
        assetTransaction.transactionCurrency = transaction.currency;
    }
    if (assetAccount.category === "realEstate") {
        assetTransaction.amount = tt === "buy" ? 1 : -1;
        assetTransaction.price = transactionOriginalPrice;
    }
    if (assetAccount.category === "objectsOfValue") {
        assetTransaction.description = tt === "buy" ? (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:purchase") : (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:sale");
        assetTransaction.quantity = tt === "buy" ? assetAmount : -assetAmount;
        assetTransaction.uptc = transactionPrice;
        assetTransaction.transactionCurrency = transaction.currency;
    }
    if (assetAccount.category === "metals") {
        assetTransaction.assetId = assetId;
        assetTransaction.assetName = formInput.assetName;
        assetTransaction.quantity = tt === "buy" ? assetAmount : -assetAmount;
        assetTransaction.uptc = transactionPrice;
        assetTransaction.transactionCurrency = transaction.currency;
        assetTransaction.assetMetal = formInput.assetMetal;
        assetTransaction.assetPurity = formInput.assetPurity;
        assetTransaction.assetWeight = formInput.assetWeight;
        assetTransaction.assetAdditionalValue = formInput.assetAdditionalValue;
    }
    if (assetAccount.category === "unlistedShares") {
        assetTransaction.assetId = assetAccount.id;
        assetTransaction.quantity = tt === "buy" ? assetAmount : -assetAmount;
        assetTransaction.uptc = transactionPrice;
        assetTransaction.transactionCurrency = transaction.currency;
        assetTransaction.upac = null; // get it from uptc + transactionCurrency + evtl. fx conversion in API
        assetTransaction.upbc = null; // get it from uptc + transactionCurrency + evtl. fx conversion in API
    }
    // put data into schema
    // validateSchema is a wrapper which expects { category: <category-name>, transaction: <transaction-object> } as payload
    // returns { category: 'deposits', transaction: {transaction-object}, validation: true / false }
    let castAssetTransaction;
    try {
        castAssetTransaction = assetTransaction && (0, $f2037232653a5c1d$export$4741711f07dbb8e7)({
            category: assetAccount.category,
            transaction: assetTransaction
        });
        if ($558e4a05c7aecdc8$var$debugLevel > 2) console.log("castAssetTransaction", castAssetTransaction);
    } catch (e) {
        // handle errors coming from schema (display error message and handle user interaction)
        if ($558e4a05c7aecdc8$var$debugLevel > 2) console.info("asset transaction:", assetTransaction);
        console.error(e.errors || e);
        (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateErrorContents"));
        throw new Error("Error while validating object schema (asset transaction)"); // to stop executing subsequent code
    }
    return castAssetTransaction.transaction;
}
async function $558e4a05c7aecdc8$export$2e2bcd8739ae039({ formInput: formInput, originalTransaction: originalTransaction, projectId: projectId, category: category }) {
    var _originalTransaction_hiddenTransaction, _originalTransaction_hiddenTransaction1;
    const { transactionType: transactionType } = formInput;
    console.log("prepareDataForPost", formInput, originalTransaction, projectId, category);
    // create transaction template objects with all common fields
    const transactionTemplate = {
        date: new Date(formInput.date).valueOf(),
        projectId: projectId,
        importFlag: originalTransaction.id ? "put" : "post",
        transactionType: transactionType,
        isSimulated: true,
        description: formInput.description || formInput.displayName,
        currency: formInput.currency || formInput.transactionCurrency
    };
    const recurringTemplate = (0, $2qxEV._)((0, $9tqwB._)({}, formInput.recurring), {
        periodType: (0, $9tqwB._)({}, formInput.recurring.periodType),
        endAfterDate: new Date(formInput.recurring.endAfterDate).valueOf()
    });
    const indexingTemplate = (0, $9tqwB._)({}, formInput.indexed); // just copy it over
    // amount, accountCurrencyAmount, account, accountTo, tags, linkedTransactions
    // perform general transformations
    // spreading formInput over all that seems the wrong approach, as most of the values will need to be custom-written depending on transaction type
    // if there is an id from originalTransaction, it means it's an update, so we need to use put instead of post
    // we need to assign ids here already, because they are BOTH needed in EACH transaction object
    const mainTransactionId = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const hiddenTransactionId = (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)();
    const mainTransaction = (0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, originalTransaction), {
        id: (originalTransaction === null || originalTransaction === void 0 ? void 0 : originalTransaction.id) ? originalTransaction === null || originalTransaction === void 0 ? void 0 : originalTransaction.id : mainTransactionId
    }), transactionTemplate), {
        tags: (0, $2qxEV._)((0, $9tqwB._)({}, originalTransaction.tags), {
            type: transactionType,
            recurring: (0, $9tqwB._)({}, recurringTemplate),
            indexing: (0, $9tqwB._)({}, indexingTemplate)
        })
    });
    const hiddenTransaction = (0, $2qxEV._)((0, $9tqwB._)((0, $2qxEV._)((0, $9tqwB._)({}, originalTransaction.hiddenTransaction), {
        id: (originalTransaction === null || originalTransaction === void 0 ? void 0 : (_originalTransaction_hiddenTransaction = originalTransaction.hiddenTransaction) === null || _originalTransaction_hiddenTransaction === void 0 ? void 0 : _originalTransaction_hiddenTransaction.id) ? originalTransaction === null || originalTransaction === void 0 ? void 0 : (_originalTransaction_hiddenTransaction1 = originalTransaction.hiddenTransaction) === null || _originalTransaction_hiddenTransaction1 === void 0 ? void 0 : _originalTransaction_hiddenTransaction1.id : hiddenTransactionId
    }), transactionTemplate), {
        tags: (0, $2qxEV._)((0, $9tqwB._)({}, originalTransaction.tags), {
            type: transactionType,
            recurring: (0, $9tqwB._)({}, recurringTemplate),
            indexing: (0, $9tqwB._)({}, indexingTemplate)
        })
    });
    // incoming buy / sell transaction will _either_ have exchangeRate _or_ assetUnitPriceBaseCurrency
    // deposit transactions for buy / sell should be created in the same currency as the asset transaction
    let result;
    // "normal" asset buy / sell transaction
    if ([
        "buy",
        "sell"
    ].includes(transactionType) && formInput.assetAccount.category !== "deposits") {
        // handle error when account has no linked deposit account
        const { assetAccount: assetAccount } = formInput;
        if (!assetAccount.connectedDepositAccounts || assetAccount.connectedDepositAccounts.length === 0) {
            (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("noLinkedAccount"));
            return false;
        }
        const designatedConnectedDepositAccountIndex = formInput.designatedConnectedDepositAccountIndex === undefined ? 0 : formInput.designatedConnectedDepositAccountIndex;
        if (assetAccount.category === "pension") result = await Promise.all([
            $558e4a05c7aecdc8$var$createDepositTransaction({
                transaction: hiddenTransaction,
                assetAccount: assetAccount,
                amount: (transactionType === "buy" ? -1 : 1) * formInput.assetAmount * formInput.assetUnitPrice,
                description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated")} ${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:purchase")} ${formInput.displaySymbol}`,
                fxCurrency: formInput.transactionCurrency || formInput.currency,
                designatedConnectedDepositAccountIndex: // vv check if the field is 'undefined' (this field can return 0 and 0 is a valid value, so be careful about tests!)
                designatedConnectedDepositAccountIndex,
                formInput: formInput
            })
        ]);
        else result = await Promise.all([
            $558e4a05c7aecdc8$var$createAssetTransaction({
                transaction: mainTransaction,
                assetAccount: assetAccount,
                assetAmount: formInput.assetAmount,
                assetId: formInput.displaySymbol,
                transactionOriginalPrice: formInput.assetUnitPrice,
                transactionPrice: formInput.assetUnitPriceBaseCurrency || formInput.exchangeRate * formInput.assetUnitPrice,
                linkedTransactionId: hiddenTransaction.id,
                formInput: formInput
            }),
            $558e4a05c7aecdc8$var$createDepositTransaction({
                transaction: hiddenTransaction,
                assetAccount: assetAccount,
                amount: (transactionType === "buy" ? -1 : 1) * formInput.assetAmount * formInput.assetUnitPrice,
                description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated")} ${transactionType === "buy" ? (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:purchase") : (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:sale")} ${formInput.displaySymbol}`,
                fxCurrency: formInput.transactionCurrency || formInput.currency,
                linkedTransactionId: mainTransaction.id,
                linkedTransactionCategory: category,
                designatedConnectedDepositAccountIndex: // vv check if the field is 'undefined' (this field can return 0 and 0 is a valid value, so be careful about tests!)
                designatedConnectedDepositAccountIndex,
                formInput: formInput
            })
        ]);
    // as the buy / sell button very sadly also includes deposits, this is the case for deposits (which is identical to transfers)
    } else if ([
        "buy",
        "sell"
    ].includes(transactionType) && formInput.assetAccount.category === "deposits") result = Promise.all([
        $558e4a05c7aecdc8$var$createDepositTransaction({
            transaction: mainTransaction,
            depositAccount: formInput.assetAccount,
            fxCurrency: formInput.currency,
            amount: formInput.assetAmount,
            description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated")} ${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:deposit")}`,
            linkedTransactionId: hiddenTransaction.id,
            linkedTransactionCategory: "deposits",
            linkedDepositAccount: formInput.account,
            formInput: formInput
        }),
        $558e4a05c7aecdc8$var$createDepositTransaction({
            transaction: hiddenTransaction,
            depositAccount: formInput.assetAccount,
            fxCurrency: formInput.currency,
            amount: -formInput.assetAmount,
            description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated")} ${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:deposit")}`,
            linkedTransactionId: mainTransaction.id,
            linkedTransactionCategory: "deposits",
            linkedDepositAccount: formInput.accountTo,
            formInput: formInput
        })
    ]);
    else if (transactionType === "transfer") result = Promise.all([
        $558e4a05c7aecdc8$var$createDepositTransaction({
            transaction: mainTransaction,
            depositAccount: formInput.accountTo,
            fxCurrency: formInput.currency,
            amount: formInput.amount,
            description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated")} ${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:transfer.label")}`,
            linkedTransactionId: hiddenTransaction.id,
            linkedTransactionCategory: "deposits",
            linkedDepositAccount: formInput.account,
            formInput: formInput
        }),
        $558e4a05c7aecdc8$var$createDepositTransaction({
            transaction: hiddenTransaction,
            depositAccount: formInput.account,
            fxCurrency: formInput.currency,
            amount: -formInput.amount,
            description: `${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:simulated")} ${(0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:transfer.label")}`,
            linkedTransactionId: mainTransaction.id,
            linkedTransactionCategory: "deposits",
            linkedDepositAccount: formInput.accountTo,
            formInput: formInput
        })
    ]);
    else if ([
        "inflow",
        "outflow"
    ].includes(transactionType)) result = Promise.all([
        $558e4a05c7aecdc8$var$createDepositTransaction({
            transaction: mainTransaction,
            depositAccount: transactionType === "inflow" ? formInput.accountTo : formInput.account,
            description: `${transactionType === "inflow" ? (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:inflow.labelTop") : (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:outflow.labelTop")}`,
            fxCurrency: formInput.currency,
            amount: formInput.amount,
            formInput: formInput
        })
    ]);
    else throw new Error("Transaction type not supported");
    // Promise.all will throw if one of the promises is rejected
    return result;
}



const $af3f7d478ae08c2a$var$debugLevel = 0;
function $af3f7d478ae08c2a$var$TransactionType({ type: type, labelTop: labelTop, labelBottom: labelBottom, Icon: Icon, colour: colour, value: value, setValue: setValue }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
        type: "button",
        id: String(labelTop).toLowerCase(),
        onClick: (e)=>setValue(type),
        className: `rounded-md grid grid-cols-3 items-center bg-white hover:bg-gray-50
      ${String(value).toLowerCase() === String(type).toLowerCase() ? "border-brandBlue-500 border-2" : "border"}`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: `col-span-1 rounded-full w-10 h-10 m-3 inline-flex items-center justify-center text-white ${colour}`,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {
                    className: "w-6 h-6"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "col-span-2 gap-2 text-left",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "text-base font-bold",
                        children: labelTop
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-sm text-gray-500",
                        children: labelBottom
                    })
                ]
            })
        ]
    });
}
$af3f7d478ae08c2a$var$TransactionType.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    labelTop: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    labelBottom: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    ]).isRequired,
    colour: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
const $af3f7d478ae08c2a$export$db80787c7101f1d8 = [
    {
        id: "inflow",
        labelTop: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:inflow.labelTop"),
        labelBottom: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:inflow.labelBottom"),
        icon: (0, $3ea1f91ff88fa2cb$export$1195ef320508ce77),
        colour: "bg-brandDarkBlue-400"
    },
    {
        id: "outflow",
        labelTop: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:outflow.labelTop"),
        labelBottom: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:outflow.labelBottom"),
        icon: (0, $3ea1f91ff88fa2cb$export$17baa5989b7e45c7),
        colour: "bg-brandDarkBlue-400"
    },
    {
        id: "transfer",
        labelTop: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:transfer.labelTop"),
        labelBottom: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:transfer.labelBottom"),
        icon: (0, $3ea1f91ff88fa2cb$export$83099edae52007d2),
        colour: "bg-brandDarkBlue-400"
    },
    {
        id: "buy",
        labelTop: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:buy.labelTop"),
        labelBottom: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:buy.labelBottom"),
        icon: (0, $5fe3802f808215e9$export$2e2bcd8739ae039),
        colour: "bg-brandGreen-500"
    },
    {
        id: "sell",
        labelTop: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:sell.labelTop"),
        labelBottom: (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t("projects:sell.labelBottom"),
        icon: (0, $35b8473afe5c480b$export$2e2bcd8739ae039),
        colour: "bg-brandGreen-500"
    }
];
function $af3f7d478ae08c2a$var$TransactionTypesComponent({ value: value, onChange: onChange }) {
    const arg = "hidden";
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "flex gap-4",
        children: $af3f7d478ae08c2a$export$db80787c7101f1d8.map((transactionType)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af3f7d478ae08c2a$var$TransactionType, {
                type: transactionType.id,
                labelTop: transactionType.labelTop,
                labelBottom: transactionType.labelBottom,
                Icon: transactionType.icon,
                colour: transactionType.colour,
                value: value,
                setValue: onChange
            }, transactionType.id))
    });
}
$af3f7d478ae08c2a$var$TransactionTypesComponent.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $af3f7d478ae08c2a$export$2e2bcd8739ae039({ transactionDialog: transactionDialog, setTransactionDialog: setTransactionDialog, projectId: projectId, stocksAssets: stocksAssets }) {
    var _errors_date, _errors_indexed_customRateInput, _errors_indexed, _errors_recurring_endAfterOccurrences, _errors_recurring;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const selectTransactionFormAccounts = (0, $7fPBF.useMemo)((0, $3679aa7475d9bd44$export$eab475e3b4ddc367), []);
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)(selectTransactionFormAccounts);
    const accountsById = (0, $7fPBF.useMemo)(()=>accounts.reduce((acc, item)=>(0, $2qxEV._)((0, $9tqwB._)({}, acc), {
                [item.id]: item
            }), {}), [
        accounts
    ]);
    const account = accountsById[transactionDialog === null || transactionDialog === void 0 ? void 0 : transactionDialog.accountId]; // this only works for existing transactions, not for new transactions
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    // WARNING: these objects may also have to be updated in TemplateParametersForm (apply template to project also creates project transactions)
    const defaultRecurringObject = (0, $7fPBF.useMemo)(()=>({
            activated: false,
            numberOfPeriods: 1,
            periodType: {
                id: "month",
                name: t("repeating.month")
            },
            end: "recurringNever",
            endAfterOccurrences: 10,
            endAfterDate: new Date()
        }), [
        t
    ]);
    const defaultIndexedObject = (0, $7fPBF.useMemo)(()=>({
            activated: false,
            mode: "indexedByInflation",
            customRateInput: null
        }), []);
    const defaultValuesEmptyForm = (0, $7fPBF.useMemo)(()=>({
            transactionType: "inflow",
            amount: 2000,
            assetAmount: 1,
            currency: "EUR",
            exchangeRate: 1,
            baseCurrencyAmount: 2000,
            transactionCurrency: "EUR",
            // first day of current month; toISOString returns UTC time (which is 1 day behind in Berlin), so using Swedish format which the same timezone as Berlin
            date: new Date(new Date().getFullYear() + 1, new Date().getMonth(), 1).toLocaleString("sv", {
                timeZoneName: "short"
            }).split(" ")[0],
            recurring: defaultRecurringObject,
            indexed: defaultIndexedObject
        }), [
        defaultRecurringObject,
        defaultIndexedObject
    ]);
    const tags = (0, $7fPBF.useMemo)(()=>typeof (transactionDialog === null || transactionDialog === void 0 ? void 0 : transactionDialog.tags) === "string" ? JSON.parse(transactionDialog.tags) : transactionDialog === null || transactionDialog === void 0 ? void 0 : transactionDialog.tags, [
        transactionDialog
    ]);
    // transfer, buy and sell transactions are represented by 2 transactions each in the data model
    // to make it easier for users, we represend each of those pairs with one transaction in this screen
    // transfer --> only show the positive transaction (the negative transaction is filtered out by ProjectTransactionList)
    // buy / sell --> only show the Asset transaction (the Deposit transaction is filtered out by ProjectTransactionList)
    const initialiseFormObject = (0, $7fPBF.useMemo)(()=>{
        var _output_hiddenTransaction;
        if (transactionDialog === true || !transactionDialog) return defaultValuesEmptyForm;
        const output = (0, $2qxEV._)((0, $9tqwB._)({}, transactionDialog), {
            tags: tags || {},
            transactionType: tags === null || tags === void 0 ? void 0 : tags.type,
            recurring: (tags === null || tags === void 0 ? void 0 : tags.recurring) || defaultRecurringObject,
            indexed: (tags === null || tags === void 0 ? void 0 : tags.indexed) || defaultIndexedObject,
            date: new Date(transactionDialog.date).toLocaleString("sv", {
                timeZoneName: "short"
            }).split(" ")[0]
        });
        if ((tags === null || tags === void 0 ? void 0 : tags.type) === "inflow" || (tags === null || tags === void 0 ? void 0 : tags.type) === "transfer") output.accountTo = account;
        if ((tags === null || tags === void 0 ? void 0 : tags.type) === "outflow") output.account = account;
        if ((tags === null || tags === void 0 ? void 0 : tags.type) === "transfer") output.account = accountsById[output === null || output === void 0 ? void 0 : (_output_hiddenTransaction = output.hiddenTransaction) === null || _output_hiddenTransaction === void 0 ? void 0 : _output_hiddenTransaction.accountId];
        if ((tags === null || tags === void 0 ? void 0 : tags.type) === "buy" || (tags === null || tags === void 0 ? void 0 : tags.type) === "sell") {
            output.assetAccount = account;
            output.assetAmount = ((tags === null || tags === void 0 ? void 0 : tags.type) === "sell" ? -transactionDialog.transactionAmount : transactionDialog.transactionAmount) || 1;
            output.assetUnitPrice = transactionDialog.transactionOriginalPrice || transactionDialog.uptc;
            output.assetUnitPriceBaseCurrency = transactionDialog.transactionPrice || transactionDialog.upbc;
            output.assetName = transactionDialog.assetName || "";
            output.assetId = transactionDialog.assetId || "";
            output.displaySymbol = transactionDialog.displaySymbol || transactionDialog.assetId || "";
        }
        return output;
    }, [
        transactionDialog,
        tags,
        defaultValuesEmptyForm,
        defaultRecurringObject,
        defaultIndexedObject,
        account,
        accountsById
    ]);
    console.log("initialiseFormObject.displaySymbol", initialiseFormObject.displaySymbol);
    const formObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: initialiseFormObject
    });
    const { handleSubmit: handleSubmit, register: register, unregister: unregister, watch: watch, setValue: setValue, formState: { errors: errors }, control: control, trigger: trigger, getFieldState: getFieldState } = formObject;
    function normalizeDateToStartOfMonth(value) {
        if (!value) return null;
        const parsedDate = new Date(`${value}T00:00:00Z`);
        if (Number.isNaN(parsedDate.getTime())) return null;
        parsedDate.setUTCDate(1);
        return parsedDate.toISOString().split("T")[0];
    }
    // subscribe to changes in form values
    const transactionType = (0, $18522b4fc47f45cb$export$3c773aa2b84f29e0)({
        control: control,
        name: "transactionType"
    });
    const recurring = (0, $18522b4fc47f45cb$export$3c773aa2b84f29e0)({
        control: control,
        name: "recurring.activated"
    });
    const indexed = (0, $18522b4fc47f45cb$export$3c773aa2b84f29e0)({
        control: control,
        name: "indexed.activated"
    });
    const indexedMode = (0, $18522b4fc47f45cb$export$3c773aa2b84f29e0)({
        control: control,
        name: "indexed.mode"
    });
    const recurringEnd = (0, $18522b4fc47f45cb$export$3c773aa2b84f29e0)({
        control: control,
        name: "recurring.end"
    });
    const assetAccount = (0, $18522b4fc47f45cb$export$3c773aa2b84f29e0)({
        control: control,
        name: "assetAccount"
    });
    // if transaction type changes, trigger amount validations
    (0, $7fPBF.useEffect)(()=>{
        async function asyncWrapper() {
            await trigger("amount");
        }
        asyncWrapper();
    }, [
        transactionType
    ]);
    function getCategoryByAccountId(accountId) {
        var _accountsById_accountId;
        console.log("getCategoryByAccountId", accountId);
        if (!accountId) return null;
        return ((_accountsById_accountId = accountsById[accountId]) === null || _accountsById_accountId === void 0 ? void 0 : _accountsById_accountId.category) || null;
    }
    // -----------------------------------
    // SUBMIT FORM
    // -----------------------------------
    async function onSubmit(incomingData) {
        // call module function
        // it will return an array with two transactions which need to be posted
        console.log("form fields", incomingData);
        let result;
        try {
            result = await (0, $558e4a05c7aecdc8$export$2e2bcd8739ae039)({
                formInput: incomingData,
                originalTransaction: transactionDialog,
                projectId: projectId,
                category: [
                    "buy",
                    "sell"
                ].includes(incomingData.transactionType) ? getCategoryByAccountId(incomingData.assetAccount.id) : getCategoryByAccountId(incomingData.accountTo.accountId)
            });
            if ($af3f7d478ae08c2a$var$debugLevel > 2) console.log("result from prepareDataForPost", result);
        } catch (e) {
            console.error("AddProjectTransaction > onSubmit caught an error:", e);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("transactionCreatedError"));
            return;
        }
        // TODO when an error is caught above, AddTransaction MUST NOT CLOSE
        // handle prepareDataForPost noLinkedAccount case (result is an array of 1 or 2 transactions, but one of them would be null)
        // result is false if prepareDataForPost fails
        console.log("result", result);
        if (!result || result.some((txn)=>!txn)) return;
        // if no errors, then send data to backend via the correct postData function
        // payload is [ { ...transaction-object, category: 'category-name' } ]
        // prepareDataForPost returns an array of 2 transactions, they have the category attribute already
        try {
            if (result) {
                setLoading(true);
                await dispatch((0, $f1c3fa004749592f$export$942e92bd9e040eb)({
                    payload: result
                }));
                setTransactionDialog(null);
            }
        } catch (e) {
            // handle errors from posting to backend (display error message and handle user interaction)
            setLoading(false);
            console.error(e);
            throw new Error("Error while submitting to database"); // to stop executing subsequent code
        }
        // put the slider where it needs to be to see this transaction (one month after the transaction date)
        const newDate = new Date(incomingData.date);
        newDate.setMonth(newDate.getMonth() + 1);
        await dispatch((0, $47d2e16a1696e57a$export$284f9e3210b39fb4)({
            newDate: newDate.valueOf()
        }));
        setLoading(false);
        setTransactionDialog(false);
    }
    // const message = useSelector((state) => state.message.message);
    // useEffect(() => {
    //   if (message === 'dataUpdatedSuccessfully' || message === 'dataUpdatedWithErrors' || message === 'dataUpdateProblems') {
    //     setLoading(false);
    //     setTransactionDialog(false);
    //   }
    // }, [message]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-opacity-90 bg-gray-300 absolute top-0 left-0 w-full h-full z-[100] p-4",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex flex-col items-center justify-center h-screen",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                autoComplete: "off",
                onSubmit: handleSubmit(onSubmit),
                className: "relative bg-white rounded-md shadow-lg p-8 space-y-8 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: "project-details-add-transaction-close",
                        onClick: (e)=>{
                            setTransactionDialog(false);
                        },
                        className: "absolute top-4 right-4 cursor-pointer",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-500 hover:text-gray-600"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "inline text-2xl font-bold text-gray-900",
                        children: t("addTransaction")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-xl font-bold text-gray-900",
                                children: t("transactionTypes")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                name: "transactionType",
                                control: control,
                                render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af3f7d478ae08c2a$var$TransactionTypesComponent, {
                                        value: field.value,
                                        onChange: field.onChange
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "grid grid-cols-3 gap-12",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 pb-4",
                                        children: t("transactionDetails")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cafa6a3cc1d10837$export$2e2bcd8739ae039), {
                                        transactionType: transactionType || "inflow",
                                        accountList: accounts,
                                        control: control,
                                        register: register,
                                        unregister: unregister,
                                        errors: errors,
                                        trigger: trigger,
                                        watch: watch,
                                        setValue: setValue,
                                        getFieldState: getFieldState,
                                        stocksAssets: stocksAssets
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 pb-4",
                                        children: t("date")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "pb-8 -mt-[1px]",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "date",
                                                className: "block text-sm font-medium text-gray-700",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                    className: "text-black border-gray-400 shadow bg-brandYellow-50",
                                                    info: t("transactionDate.tooltip"),
                                                    children: [
                                                        t("transactionDate.label"),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $071105eca597c3d9$export$2e2bcd8739ae039), {})
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "date",
                                                    name: "date",
                                                    id: "date",
                                                    // onChange
                                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                                }, register("date", {
                                                    // normalize only once user leaves the field to avoid blocking manual typing.
                                                    onBlur: (e)=>{
                                                        const normalizedDate = normalizeDateToStartOfMonth(e.target.value);
                                                        if (normalizedDate) setValue("date", normalizedDate, {
                                                            shouldDirty: true,
                                                            shouldValidate: true
                                                        });
                                                    },
                                                    validate: (value)=>{
                                                        if (new Date(value) > new Date()) return true;
                                                        return t("transactionDate.error");
                                                    }
                                                })))
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: (_errors_date = errors.date) === null || _errors_date === void 0 ? void 0 : _errors_date.message
                                                })
                                            })
                                        ]
                                    }),
                                    !([
                                        "buy",
                                        "sell"
                                    ].includes(transactionType) && (assetAccount === null || assetAccount === void 0 ? void 0 : assetAccount.category) === "realEstate") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "recurring",
                                                className: "block text-sm font-medium text-gray-700 pb-1",
                                                children: t("recurringTransaction.label")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                name: "recurring.activated",
                                                control: control,
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), {
                                                        checked: field.value,
                                                        id: "project-add-transaction-recurring",
                                                        onChange: field.onChange,
                                                        className: `relative inline-flex h-5 w-10 items-center rounded-full ${field.value ? "bg-brandBlue-500 hover:bg-brandBlue-600" : "bg-gray-300 hover:bg-gray-400"}`,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: `${field.value ? "translate-x-6" : "translate-x-1"} inline-block h-3 w-3 transform rounded-full bg-white transition`
                                                        })
                                                    })
                                            })
                                        ]
                                    }),
                                    recurring && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "indexed",
                                                className: "block text-sm font-medium text-gray-700 pb-1",
                                                children: t("indexed.label")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                name: "indexed.activated",
                                                control: control,
                                                render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), {
                                                        id: "project-add-transaction-indexed",
                                                        checked: field.value,
                                                        onChange: field.onChange,
                                                        className: `relative inline-flex h-5 w-10 items-center rounded-full ${field.value ? "bg-brandBlue-500 hover:bg-brandBlue-600" : "bg-gray-300 hover:bg-gray-400"}`,
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: `${field.value ? "translate-x-6" : "translate-x-1"} inline-block h-3 w-3 transform rounded-full bg-white transition`
                                                        })
                                                    })
                                            })
                                        ]
                                    }),
                                    indexed && recurring && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pl-2",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("fieldset", {
                                            className: "mt-8 pl-4",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "flex items-center pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                id: "indexedByInflation",
                                                                name: "indexedMode",
                                                                type: "radio",
                                                                value: "indexedByInflation",
                                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                                            }, register("indexed.mode"))),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                htmlFor: "indexedByInflation",
                                                                className: "ml-3 block text-sm font-medium text-gray-700",
                                                                children: t("indexed.byInflation")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                id: "indexedByCustomRate",
                                                                name: "indexedMode",
                                                                type: "radio",
                                                                value: "indexedByCustomRate",
                                                                className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                                            }, register("indexed.mode"))),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                                htmlFor: "indexedByCustomRate",
                                                                className: "ml-3 text-sm font-medium text-gray-700 flex items-center gap-2",
                                                                children: [
                                                                    t("indexed.increaseBy"),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                        id: "indexedByCustomRateInput",
                                                                        name: "indexedByCustomRateInput",
                                                                        type: "number",
                                                                        disabled: indexedMode !== "indexedByCustomRate",
                                                                        className: "rounded-md w-16 border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                                                    }, register("indexed.customRateInput", {
                                                                        max: {
                                                                            value: 10000,
                                                                            message: "Maximum increase is 10000%."
                                                                        }
                                                                    }))),
                                                                    "%"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            children: (_errors_indexed = errors.indexed) === null || _errors_indexed === void 0 ? void 0 : (_errors_indexed_customRateInput = _errors_indexed.customRateInput) === null || _errors_indexed_customRateInput === void 0 ? void 0 : _errors_indexed_customRateInput.message
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            recurring && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                        className: "text-lg font-bold text-gray-900 pb-4",
                                        children: t("repeating.label")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "pb-8 -mt-0.5 grid grid-cols-6 justify-items-stretch",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "col-span-2 pr-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                        htmlFor: "recurringNumberOfPeriods",
                                                        className: "block text-sm font-medium text-gray-700",
                                                        children: t("repeating.every")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "mt-1",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                            type: "number",
                                                            name: "recurringNumberOfPeriods",
                                                            id: "recurringNumberOfPeriods",
                                                            // if left with no width restriction, it makes the entire Add transaction form take up the full screen width
                                                            className: "block max-w-[6rem] text-center rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm",
                                                            placeholder: new Date().toLocaleDateString("de", {
                                                                timeZone: "UTC"
                                                            }).split("T")[0]
                                                        }, register("recurring.numberOfPeriods")))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "col-span-4 pt-5",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                                    name: "recurring.periodType",
                                                    control: control,
                                                    render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                            label: "",
                                                            list: [
                                                                {
                                                                    id: "month",
                                                                    name: t("repeating.month")
                                                                },
                                                                {
                                                                    id: "year",
                                                                    name: t("repeating.year")
                                                                }
                                                            ],
                                                            value: field.value,
                                                            onChange: field.onChange,
                                                            optional: false
                                                        })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "pb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                className: "text-sm font-medium text-gray-900",
                                                children: t("repeating.endBy")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("fieldset", {
                                                className: "mt-4",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "flex items-center pb-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                    id: "recurringNever",
                                                                    name: "recurringEnd",
                                                                    type: "radio",
                                                                    value: "recurringNever",
                                                                    className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                                                }, register("recurring.end"))),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                                    htmlFor: "recurringNever",
                                                                    className: "ml-3 block text-sm font-medium text-gray-700",
                                                                    children: t("repeating.never")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                    id: "recurringByOccurrence",
                                                                    name: "recurringEnd",
                                                                    type: "radio",
                                                                    value: "recurringByOccurrence",
                                                                    className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                                                }, register("recurring.end"))),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                                    htmlFor: "recurringByOccurrence",
                                                                    className: "ml-3 text-sm font-medium text-gray-700 flex items-center gap-2",
                                                                    children: [
                                                                        t("repeating.after"),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                            id: "recurringEndAfterOccurrences",
                                                                            name: "recurringEndAfterOccurrences",
                                                                            type: "number",
                                                                            disabled: recurringEnd !== "recurringByOccurrence",
                                                                            className: "rounded-md w-16 border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                                                        }, register("recurring.endAfterOccurrences", {
                                                                            max: {
                                                                                value: 999,
                                                                                message: t("repeating.afterError")
                                                                            }
                                                                        }))),
                                                                        t("repeating.occurrences")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "sm:text-sm text-brandRed-500 max-w-fit",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                children: (_errors_recurring = errors.recurring) === null || _errors_recurring === void 0 ? void 0 : (_errors_recurring_endAfterOccurrences = _errors_recurring.endAfterOccurrences) === null || _errors_recurring_endAfterOccurrences === void 0 ? void 0 : _errors_recurring_endAfterOccurrences.message
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                    id: "recurringByDate",
                                                                    name: "recurringEnd",
                                                                    type: "radio",
                                                                    value: "recurringByDate",
                                                                    className: "h-4 w-4 border-gray-300 text-brandBlue-500 focus:ring-brandBlue-400"
                                                                }, register("recurring.end"))),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                                    htmlFor: "recurringByDate",
                                                                    className: "ml-3 text-sm font-medium text-gray-700 flex items-center",
                                                                    children: [
                                                                        t("repeating.on"),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                                            id: "recurringEndAfterDate",
                                                                            name: "recurringEndAfterDate",
                                                                            type: "date",
                                                                            disabled: recurringEnd !== "recurringByDate",
                                                                            className: "ml-2 rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                                                        }, register("recurring.endAfterDate")))
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-start gap-4 pt-6",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                id: "project-add-transaction-save",
                                type: "submit",
                                text: t("save"),
                                withAccent: true,
                                spinnerOn: loading
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                id: "project-add-transaction-cancel",
                                text: t("cancel"),
                                onClick: ()=>{
                                    setTransactionDialog(false);
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$af3f7d478ae08c2a$export$2e2bcd8739ae039.propTypes = {
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactionDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    setTransactionDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    projectId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    stocksAssets: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired
};
$af3f7d478ae08c2a$export$2e2bcd8739ae039.defaultProps = {
    transactionDialog: null
};





function $6f72144921f9f9ac$var$AccountBanner({ transactionType: transactionType, getSecondAccount: getSecondAccount, transaction: transaction, getAccountNameFromId: getAccountNameFromId, accounts: accounts, getAccountCategoryFromId: getAccountCategoryFromId, formatting: formatting }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: `gap-1 sm:gap-2 lg:gap-4 ${formatting} items-center`,
        children: [
            transactionType === "buy" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                        accountName: getSecondAccount(transaction).accountName,
                        category: getSecondAccount(transaction).accountCategory
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0437d10e72efcfd6$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 lg:w-5 lg:h-5 text-gray-400"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                accountName: getAccountNameFromId(transaction.accountId, accounts),
                category: getAccountCategoryFromId(transaction.accountId, accounts)
            }),
            (transactionType === "transfer" || transactionType === "sell") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0437d10e72efcfd6$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 lg:w-5 lg:h-5 text-gray-400"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                        accountName: getSecondAccount(transaction).accountName,
                        category: getSecondAccount(transaction).accountCategory
                    })
                ]
            })
        ]
    });
}
$6f72144921f9f9ac$var$AccountBanner.propTypes = {
    transactionType: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    getSecondAccount: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    getAccountNameFromId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    accounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    getAccountCategoryFromId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$6f72144921f9f9ac$var$AccountBanner.defaultProps = {
    formatting: "flex"
};
function $6f72144921f9f9ac$export$718d309b10019100({ transaction: transaction, project: project, setTransactionDialog: setTransactionDialog, visibleRecurringTransactions: visibleRecurringTransactions, setVisibleRecurringTransactions: setVisibleRecurringTransactions, setAssetTileHover: setAssetTileHover, clearAssetTileHover: clearAssetTileHover, accounts: accounts, ibans: ibans, cav: cav }) {
    var _transaction_hiddenTransaction, _tags_recurring;
    function purify(str) {
        return str === null || str === void 0 ? void 0 : str.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    }
    // non-simulated (actual) transactions don't have a tag.type, which is used to display an icon and to display the two accounts for transfer / buy / sell
    // handle that here
    function determineTransactionType(localTransaction) {
        // if it isn't deposit, then it is a sale or a purchase, depending on the amount
        if (transaction.category !== "deposits") {
            // FIX 240429 take advantage of the new generic field structure
            // if (transaction.amount > 0 || transaction.rebasedAmount > 0 || transaction.quantity > 0) {
            if (transaction.quantity > 0) return "sell";
            return "buy";
        }
        // if otherPartyAccount is one of user's own ibans, then it is a transfer
        // eventually there will be a positive and a negative transaction for the same amount, one will have been filtered out previously
        if (ibans.includes(purify(transaction.otherPartyAccount))) return "transfer";
        // the remaining cases are inflows and outflows
        // FIX 240429 take advantage of the new generic field structure
        // if (transaction.amount > 0 || transaction.quantity > 0) return 'inflow';
        if (transaction.quantity > 0) return "inflow";
        return "outflow";
    }
    const tags = typeof transaction.tags === "string" ? JSON.parse(transaction.tags) : transaction.tags;
    const transactionType = (tags === null || tags === void 0 ? void 0 : tags.type) || determineTransactionType(transaction); // if tags.type not provided, use the logic above
    const initialBalanceExceeded = [
        "sale",
        "inflow"
    ].includes(transactionType) ? false : undefined;
    const [balanceExceeded, setBalanceExceeded] = (0, $7fPBF.useState)(initialBalanceExceeded);
    const account = transaction.accountId;
    const hiddenAccount = (_transaction_hiddenTransaction = transaction.hiddenTransaction) === null || _transaction_hiddenTransaction === void 0 ? void 0 : _transaction_hiddenTransaction.accountId;
    const depositAccountId = [
        "transfer",
        "purchase"
    ].includes(transaction.transactionType) ? hiddenAccount : account;
    // try not to load selector on unnecessary transaction types
    // go to the right account and get the saldo; this will have one and only one assetId (because assetId is accountCurrency)
    // transactions are sorted by date, so find will find the first transaction fulfilling the condition (get transaction by date)
    let thisTransactionDepositSaldo = Infinity; // fallback (don't show warning if there is no saldo to compare to)
    try {
        const thisTransactionDepositSide = Object.values(cav.deposits[depositAccountId])[0].find((t)=>t.date <= transaction.date);
        thisTransactionDepositSaldo = thisTransactionDepositSide.positionOnDate * thisTransactionDepositSide.upbc;
    } catch (error) {
        var _cav_deposits;
        console.info("ERROR TransactionComponent > thisTransactionDepositSaldo failed for parameters: depositAccountId:", depositAccountId, "CAV branch:", cav === null || cav === void 0 ? void 0 : (_cav_deposits = cav.deposits) === null || _cav_deposits === void 0 ? void 0 : _cav_deposits[depositAccountId], "transaction:", transaction, "error message:", error.message);
    }
    // this useEffect handles "lazy loading" of the transaction OK indicator (state starts as undefined and displays spinner; then the selector is calculated and returns true or false)
    // logic:
    // - for outflow, purchase and transfer, determine what is the available saldo on the source deposit account and display warning if this transaction exceeds it
    // - outflow is a deposit transaction (check saldo of its account)
    // - purchase is an asset transaction (check saldo of hiddenAccount)
    // - transfer: this is the receiving side of transfer, so check hiddenAccount
    (0, $7fPBF.useEffect)(()=>{
        if ([
            "buy",
            "outflow",
            "transfer"
        ].includes(transactionType) && thisTransactionDepositSaldo) {
            // FIX 240429 take advantage of the new generic field structure
            // const freeDepositBalance = thisTransactionDepositSaldo + (transaction.accountCurrencyAmount || -transaction.rebasedAmount * transaction.rebasedPrice || -transaction.amount * transaction.price);
            // TODO I'm assuming accountCurrencyAmount is here to handle deposits in projects, but come back to it later
            const freeDepositBalance = thisTransactionDepositSaldo + (transaction.accountCurrencyAmount || -transaction.quantity * transaction.upbc);
            setBalanceExceeded(freeDepositBalance < 0);
        }
    }, [
        transaction
    ]);
    // after 15 seconds from initialisation, check if balanceExceeded is either true or false
    // if it is not, set it to 'timeout'
    (0, $7fPBF.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            if (balanceExceeded === undefined) setBalanceExceeded("timeout");
        }, 15000);
        return ()=>clearTimeout(timeout);
    }, []);
    const colour = transactionType && (0, $af3f7d478ae08c2a$export$db80787c7101f1d8).filter((item)=>item.id === transactionType)[0].colour;
    const Icon = transactionType && (0, $af3f7d478ae08c2a$export$db80787c7101f1d8).filter((item)=>item.id === transactionType)[0].icon;
    const sliderDate = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.baseDate);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function getAccountNameFromId(accountId, _accounts) {
        const a = _accounts.find((acc)=>acc.id === accountId);
        return a ? a.name : "";
    }
    function getAccountCategoryFromId(accountId, _accounts) {
        const a = _accounts.find((acc)=>acc.id === accountId);
        return a ? a.category : "";
    }
    function getSecondAccount(_transaction) {
        var _transaction_hiddenTransaction;
        // console.info('getSecondAccount', _transaction, 'transactions view', transactions);
        // 240322 FIX PL: we seem to have hiddenTransactions in the _transaction object which already contains the one that was matched to the _transaction
        //                so why bother deriving it again?
        // const secondTransaction = _transaction.linkedTransactions?.find((t) => t.tags.type === transactionType);
        // const secondTransactionId = secondTransaction?.id;
        // get accountId for the second transaction
        // let secondAccountId = transactions.find((t) => t.id === secondTransactionId)?.accountId;
        // if (!secondAccountId) {
        //   // try to get the account from tags
        //   secondAccountId = _transaction.tags?.accountId;
        //   if (!secondAccountId) {
        //     console.error('getSecondAccount: matching account could not be found for parameters:', _transaction, 'secondTransactionId:', secondTransactionId);
        //   }
        // }
        const secondAccountId = (_transaction_hiddenTransaction = _transaction.hiddenTransaction) === null || _transaction_hiddenTransaction === void 0 ? void 0 : _transaction_hiddenTransaction.accountId;
        if (!secondAccountId) console.info("ERROR getSecondAccount: matching account could not be found for this transaction:", _transaction);
        return {
            accountName: getAccountNameFromId(secondAccountId, accounts),
            accountCategory: getAccountCategoryFromId(secondAccountId, accounts)
        };
    }
    const message = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.message) || {};
    const [deleting, setDeleting] = (0, $7fPBF.useState)(false);
    // handle delete spinner when postData returns an error
    // if action is successful, then the component will be unmounted, so no need to handle that
    (0, $7fPBF.useEffect)(()=>{
        if (message === "dataUpdatedWithErrors" || message === "dataUpdateProblems") setDeleting(false);
    }, [
        message
    ]);
    async function deleteOKCallback() {
        dispatch((0, $3b9398d0f9c152fb$export$e5a625708957e77)());
        console.log("running callback");
        setDeleting(true);
        try {
            const payload = [
                (0, $2qxEV._)((0, $9tqwB._)({}, transaction), {
                    importFlag: "delete"
                })
            ];
            if (transaction.hiddenTransaction) payload.push((0, $2qxEV._)((0, $9tqwB._)({}, transaction.hiddenTransaction), {
                importFlag: "delete"
            }));
            // FIX 240429 replacing this with hiddenTransaction
            // if (transaction.linkedTransactions.length > 0) {
            //   payload.push({
            //     id: transaction.linkedTransactions.find((lt) => ['purchase-to-transaction', 'sale-to-transaction', 'transfer'].includes(lt.tags?.type)).id,
            //     isSimulated: true,
            //     importFlag: 'delete',
            //     category: transaction.linkedTransactions.find((lt) => ['purchase-to-transaction', 'sale-to-transaction', 'transfer'].includes(lt.tags?.type)).category,
            //   });
            // }
            await dispatch((0, $f1c3fa004749592f$export$942e92bd9e040eb)({
                payload: payload
            }));
            setDeleting(false);
        } catch (err) {
            (0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError");
            console.error("error", err);
            setDeleting(false);
        }
    }
    function handleDelete(e) {
        e.stopPropagation();
        dispatch((0, $3b9398d0f9c152fb$export$91020d7983105237)("youAreAboutToDeleteTransaction", transaction.id, deleteOKCallback));
    }
    function handleRecurringChildrenVisibleSwitch(e) {
        e.stopPropagation();
        // if transaction.id is in the array, remove it and if it is not - add it
        if (visibleRecurringTransactions.includes(transaction.id)) setVisibleRecurringTransactions((prevState)=>prevState.filter((id)=>id !== transaction.id) || []);
        else setVisibleRecurringTransactions((prevState)=>[
                ...prevState,
                transaction.id
            ]);
    }
    // define globally here if a transaction is not clickable
    // if transaction has nonEditable flag (generated automatically to account for account growth) or it has a recurringParentId (it's a recurring child), don't make it clickable
    const nonClickable = transaction.recurringParentId || (tags === null || tags === void 0 ? void 0 : tags.nonEditable);
    // calculate price to be displayed (in baseCurrency)
    function calculateDisplayedPrice(txn) {
        // FIX 240429 take advantage of the new generic field structure
        // let displayedPrice;
        // switch (txn.category) {
        //   case 'deposits':
        //     displayedPrice = txn.amount;
        //     break;
        //   case 'stocks':
        //     displayedPrice = txn.rebasedPrice * txn.rebasedAmount;
        //     break;
        //   case 'realEstate':
        //     displayedPrice = txn.originalPrice;
        //     break;
        //   case 'loans':
        //     displayedPrice = txn.quantity * txn.upbc;
        //     break;
        //   default:
        //     displayedPrice = txn.unitPriceBaseCurrency * txn.quantity;
        // }
        const displayedPrice = txn.quantity * txn.upbc;
        return displayedPrice.toLocaleString("de", {
            maximumFractionDigits: 0,
            style: "currency",
            currency: project.projectCurrency || "EUR"
        });
    }
    function getDescription(txn) {
        try {
            if (txn.category === "stocks") // FIX 240429 take advantage of the new generic field structure
            // return `${transaction.displayName}  |  ${transaction.amount} x ${transaction.transactionOriginalPrice} ${transaction.transactionCurrency}`;
            return `${transaction.displayName}  |  ${transaction.quantity} x ${transaction.uptc} ${transaction.transactionCurrency}`;
            return txn.description || "";
        } catch (err) {
            console.error("TransactionComponent > getDescription failed for parameters:", JSON.stringify(txn), err);
            return "";
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "w-full pb-1",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            onKeyPress: (e)=>{},
            role: "button",
            tabIndex: 0,
            // this corresponds to the lg breakpoint
            onClick: ()=>!nonClickable && window.matchMedia("(min-width: 1024px)").matches && setTransactionDialog(transaction),
            onMouseOver: ()=>setAssetTileHover(transaction.accountId),
            onMouseOut: clearAssetTileHover,
            onFocus: ()=>setAssetTileHover(transaction.accountId),
            onBlur: clearAssetTileHover,
            className: `w-full px-3 py-2 flex justify-between bg-white border border-gray-300 rounded-lg shadow-sm overflow-x-hidden
                  ${nonClickable ? "border-dashed border- border cursor-default" : "hover:bg-brandBlue-50 group cursor-pointer"}
                  ${Number(transaction.date.valueOf()) < Number(sliderDate) ? "opacity-60" : ""}`,
            name: "project-transaction",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex items-center gap-2 lg:gap-12",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: `mt-1 lg:mt-0 inline-flex h-8 w-8 items-center justify-center rounded-full ${colour || "bg-gray-400"} text-white`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Icon, {
                                className: "w-5 h-5"
                            }) || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: `text-gray-400 text-xs lg:text-sm font-medium ${transaction.isSimulated && "italic"}`,
                                    children: calculateDisplayedPrice(transaction)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: `ml-2 lg:hidden text-gray-400 text-xs truncate ${transaction.isSimulated && "italic"}`,
                                    children: `| ${getDescription(transaction).toUpperCase()}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6f72144921f9f9ac$var$AccountBanner, {
                                    formatting: "flex lg:hidden",
                                    transactionType: transactionType,
                                    getSecondAccount: getSecondAccount,
                                    transaction: transaction,
                                    getAccountNameFromId: getAccountNameFromId,
                                    accounts: accounts,
                                    getAccountCategoryFromId: getAccountCategoryFromId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6f72144921f9f9ac$var$AccountBanner, {
                            formatting: "hidden lg:flex",
                            transactionType: transactionType,
                            getSecondAccount: getSecondAccount,
                            transaction: transaction,
                            getAccountNameFromId: getAccountNameFromId,
                            accounts: accounts,
                            getAccountCategoryFromId: getAccountCategoryFromId
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: `hidden lg:block text-gray-400 text-sm truncate ${transaction.isSimulated && "italic"}`,
                            children: getDescription(transaction)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex items-center gap-4",
                    children: [
                        !deleting && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "hidden group-hover:inline-flex items-center justify-center rounded-full w-8 h-8 bg-gray-300 z-10",
                            onClick: handleDelete,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1559a4f4dda4795e$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-white"
                            })
                        }),
                        deleting && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "inline-flex items-center justify-center rounded-full w-8 h-8 bg-gray-300 z-10",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-white animate-spin"
                            })
                        }),
                        (tags === null || tags === void 0 ? void 0 : tags.partOfProjectTemplate) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: "This transaction is part of a project template.",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c0142f9c37ea9bd9$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-400",
                                name: "project-template-icon"
                            })
                        }),
                        (tags === null || tags === void 0 ? void 0 : tags.interestPayment) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: "This is a simulated interest or dividend payment. It has been added automatically based on Account settings.",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a4e64754a73d3e35$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-400"
                            })
                        }),
                        (tags === null || tags === void 0 ? void 0 : (_tags_recurring = tags.recurring) === null || _tags_recurring === void 0 ? void 0 : _tags_recurring.activated) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            id: "project-transaction-recurring-button",
                            onClick: handleRecurringChildrenVisibleSwitch,
                            className: `p-2 rounded-md
              ${visibleRecurringTransactions.includes(transaction.id) ? "bg-gray-400 text-white hover:bg-gray-500 shadow-inner border border-transparent" : "bg-white hover:bg-gray-50 border border-gray-300 text-gray-500 "}`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                width: "18px",
                                height: "18px",
                                version: "1.1",
                                viewBox: "0 0 1200 1200",
                                xmlns: "http://www.w3.org/2000/svg",
                                stroke: "currentColor",
                                fill: "currentColor",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    strokeWidth: "45px",
                                    d: "m600 72c-291.32 0-528 236.68-528 528 0 291.32 236.68 528 528 528s528-236.68 528-528c0.089844-6.4258-2.3984-12.617-6.9062-17.191-4.5117-4.5742-10.668-7.1484-17.094-7.1484s-12.582 2.5742-17.094 7.1484c-4.5078 4.5742-6.9961 10.766-6.9062 17.191 0 265.38-214.62 480-480 480s-480-214.62-480-480c0-265.38 214.62-480 480-480 147.13 0 280.3 64.652 368.62 168h-123.75c-6.4258-0.089844-12.617 2.3984-17.191 6.9062-4.5742 4.5117-7.1523 10.668-7.1523 17.094s2.5781 12.582 7.1523 17.094c4.5742 4.5078 10.766 6.9961 17.191 6.9062h167.25c8.125 2.1797 16.797-0.054688 22.859-5.8867s8.6289-14.41 6.7656-22.613v-168.38c0.16406-6.9844-2.7266-13.695-7.9102-18.379-5.1875-4.6797-12.156-6.8711-19.09-5.9961-5.8984 0.74219-11.309 3.6445-15.188 8.1484-3.8789 4.5039-5.9531 10.285-5.8125 16.227v104.62c-97.254-106.3-238.82-171.75-393.75-171.75zm-17.25 249.38c-5.8984 0.74219-11.309 3.6445-15.188 8.1484-3.8789 4.5039-5.9531 10.285-5.8125 16.227v282.75c-0.14844 6.4219 2.2812 12.637 6.75 17.25l149.25 148.88c4.2734 5.3047 10.602 8.543 17.406 8.9062 6.8008 0.36719 13.438-2.1758 18.254-6.9961 4.8203-4.8164 7.3633-11.453 6.9961-18.254-0.36328-6.8047-3.6016-13.133-8.9062-17.406l-141.75-142.12v-273c0.16406-6.9844-2.7266-13.695-7.9102-18.379-5.1875-4.6797-12.156-6.8711-19.09-5.9961z"
                                })
                            })
                        }),
                        transaction.recurringParentId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "text-gray-300",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                width: "18px",
                                height: "18px",
                                version: "1.1",
                                viewBox: "0 0 1200 1200",
                                xmlns: "http://www.w3.org/2000/svg",
                                stroke: "currentColor",
                                fill: "currentColor",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                    strokeWidth: "45px",
                                    d: "m600 72c-291.32 0-528 236.68-528 528 0 291.32 236.68 528 528 528s528-236.68 528-528c0.089844-6.4258-2.3984-12.617-6.9062-17.191-4.5117-4.5742-10.668-7.1484-17.094-7.1484s-12.582 2.5742-17.094 7.1484c-4.5078 4.5742-6.9961 10.766-6.9062 17.191 0 265.38-214.62 480-480 480s-480-214.62-480-480c0-265.38 214.62-480 480-480 147.13 0 280.3 64.652 368.62 168h-123.75c-6.4258-0.089844-12.617 2.3984-17.191 6.9062-4.5742 4.5117-7.1523 10.668-7.1523 17.094s2.5781 12.582 7.1523 17.094c4.5742 4.5078 10.766 6.9961 17.191 6.9062h167.25c8.125 2.1797 16.797-0.054688 22.859-5.8867s8.6289-14.41 6.7656-22.613v-168.38c0.16406-6.9844-2.7266-13.695-7.9102-18.379-5.1875-4.6797-12.156-6.8711-19.09-5.9961-5.8984 0.74219-11.309 3.6445-15.188 8.1484-3.8789 4.5039-5.9531 10.285-5.8125 16.227v104.62c-97.254-106.3-238.82-171.75-393.75-171.75zm-17.25 249.38c-5.8984 0.74219-11.309 3.6445-15.188 8.1484-3.8789 4.5039-5.9531 10.285-5.8125 16.227v282.75c-0.14844 6.4219 2.2812 12.637 6.75 17.25l149.25 148.88c4.2734 5.3047 10.602 8.543 17.406 8.9062 6.8008 0.36719 13.438-2.1758 18.254-6.9961 4.8203-4.8164 7.3633-11.453 6.9961-18.254-0.36328-6.8047-3.6016-13.133-8.9062-17.406l-141.75-142.12v-273c0.16406-6.9844-2.7266-13.695-7.9102-18.379-5.1875-4.6797-12.156-6.8711-19.09-5.9961z"
                                })
                            })
                        }),
                        balanceExceeded === undefined && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                            id: "balance-exceeded-pending",
                            className: "w-5 h-5 text-gray-300 animate-spin"
                        }),
                        balanceExceeded === true && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: "Warning: this transaction will not be possible. At this moment in the future there are not enough funds on the account of this transaction.",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba8ba01374a4920e$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-brandYellow-500",
                                id: "balance-exceeded-warning"
                            })
                        }),
                        balanceExceeded === false && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: "Status OK. Transaction will be possible.",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ba764ef5f1eed305$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-green-500",
                                id: "balance-exceeded-ok"
                            })
                        }),
                        balanceExceeded === "timeout" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: "Unable to determine transaction status.",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a8eb369c12c351c2$export$2e2bcd8739ae039), {
                                className: "w-5 h-5 text-gray-400",
                                id: "balance-exceeded-ok"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
$6f72144921f9f9ac$export$718d309b10019100.propTypes = {
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setTransactionDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    visibleRecurringTransactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    setVisibleRecurringTransactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setAssetTileHover: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    clearAssetTileHover: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    accounts: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    ibans: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string).isRequired,
    cav: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
function $6f72144921f9f9ac$export$3e042c74ad7d42ae() {
    return null;
}



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $b1801649fd9ece8b$var$XMarkIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
    }));
}
const $b1801649fd9ece8b$var$ForwardRef = $7fPBF.forwardRef($b1801649fd9ece8b$var$XMarkIcon);
var $b1801649fd9ece8b$export$2e2bcd8739ae039 = $b1801649fd9ece8b$var$ForwardRef;



function $ac35959ccf047067$export$2e2bcd8739ae039({ quote: quote, setQuoteDialog: setQuoteDialog, projectAssets: projectAssets }) {
    var _projectAssets_find;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
        type: "button",
        onClick: (e)=>setQuoteDialog(quote),
        // eslint-disable-next-line max-len
        className: "relative border border-gray-200 bg-white hover:bg-gray-50 shadow-sm rounded-md px-0.5 py-0.5 text-xs lg:text-sm font-light text-gray-400 flex items-center cursor-pointer",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "mr-2",
                children: (_projectAssets_find = projectAssets.find((a)=>a.assetId === quote.assetId || a.accountId === quote.assetId)) === null || _projectAssets_find === void 0 ? void 0 : _projectAssets_find.displayName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$816a14cbf50fa259), {
                className: "h-4 w-4 text-gray-400"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "mx-2",
                children: quote.quote.toLocaleString("de-DE", {
                    style: "currency",
                    currency: quote.currency
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b1801649fd9ece8b$export$2e2bcd8739ae039), {
                className: "h-5 w-5 text-gray-400 cursor-pointer hover:text-gray-500"
            })
        ]
    });
}
$ac35959ccf047067$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    quote: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setQuoteDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    projectAssets: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
};
$ac35959ccf047067$export$2e2bcd8739ae039.defaultProps = {
    projectAssets: []
};


/* eslint-disable react/forbid-prop-types */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $59ef139bd3cd0765$var$FlagIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M3.5 2.75a.75.75 0 0 0-1.5 0v14.5a.75.75 0 0 0 1.5 0v-4.392l1.657-.348a6.449 6.449 0 0 1 4.271.572 7.948 7.948 0 0 0 5.965.524l2.078-.64A.75.75 0 0 0 18 12.25v-8.5a.75.75 0 0 0-.904-.734l-2.38.501a7.25 7.25 0 0 1-4.186-.363l-.502-.2a8.75 8.75 0 0 0-5.053-.439l-1.475.31V2.75Z"
    }));
}
const $59ef139bd3cd0765$var$ForwardRef = $7fPBF.forwardRef($59ef139bd3cd0765$var$FlagIcon);
var $59ef139bd3cd0765$export$2e2bcd8739ae039 = $59ef139bd3cd0765$var$ForwardRef;



function $bd2f611e5d0861c5$export$2e2bcd8739ae039({ goal: goal, setGoalDialog: setGoalDialog, projectSumAtDate: projectSumAtDate }) {
    // set this is this is an isolated project
    const sliderDate = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.baseDate);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const options = {
        style: "currency",
        currency: baseCurrency,
        maximumFractionDigits: 0
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        className: "w-full pb-1",
        type: "button",
        onClick: (e)=>setGoalDialog(goal),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            role: "button",
            tabIndex: 0,
            className: `w-full px-3 py-2.5 flex justify-between bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-brandBlue-50 group cursor-pointer
                  ${Number(goal.date.valueOf()) < Number(sliderDate) ? "opacity-60" : ""}`,
            name: "project-goal",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-center gap-12",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-900 text-white",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $59ef139bd3cd0765$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 text-white"
                        }) || /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center justify-between gap-8 text-md font-medium text-gray-700",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: goal.name.toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: `Target: ${goal.amount.toLocaleString("de", options)}`
                            }),
                            typeof projectSumAtDate === "number" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                children: `Forecast: ${projectSumAtDate.toLocaleString("de", options)}`
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                className: "w-4 h-4 animate-spin text-gray-400"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$bd2f611e5d0861c5$export$2e2bcd8739ae039.propTypes = {
    goal: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setGoalDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    projectSumAtDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
};
$bd2f611e5d0861c5$export$2e2bcd8739ae039.defaultProps = {
    projectSumAtDate: 0
};



var $7fPBF = parcelRequire("7fPBF");
let $f1298db2f868236d$var$hoveredAccountId = null;
const $f1298db2f868236d$var$listeners = new Set();
function $f1298db2f868236d$var$emit() {
    $f1298db2f868236d$var$listeners.forEach((listener)=>listener());
}
function $f1298db2f868236d$export$1f281df8d13fdcb3(accountId) {
    $f1298db2f868236d$var$hoveredAccountId = accountId;
    $f1298db2f868236d$var$emit();
}
function $f1298db2f868236d$export$f977d29bae9e77f5() {
    $f1298db2f868236d$var$hoveredAccountId = null;
    $f1298db2f868236d$var$emit();
}
function $f1298db2f868236d$var$subscribe(listener) {
    $f1298db2f868236d$var$listeners.add(listener);
    return ()=>$f1298db2f868236d$var$listeners.delete(listener);
}
function $f1298db2f868236d$var$getSnapshot() {
    return $f1298db2f868236d$var$hoveredAccountId;
}
function $f1298db2f868236d$export$7f967c66b7fa486d() {
    return (0, $7fPBF.useSyncExternalStore)($f1298db2f868236d$var$subscribe, $f1298db2f868236d$var$getSnapshot, $f1298db2f868236d$var$getSnapshot);
}
function $f1298db2f868236d$export$ceb059a92eb5412d(accountId) {
    const currentHoveredAccountId = $f1298db2f868236d$export$7f967c66b7fa486d();
    return currentHoveredAccountId === accountId;
}


function $ccf80cc55d780012$var$DateSeparator({ dateArg: dateArg }) {
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: `project-transaction-list-date-separator-${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().format("YY-MM")}`,
        className: "relative pb-1.5 flex items-center w-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mx-4 flex-grow border-t border-gray-300"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "px-8 uppercase tracking-widest text-sm text-gray-400",
                children: new Date(dateArg).toLocaleDateString(i18n.language, {
                    month: "short",
                    year: "numeric",
                    timeZone: "UTC"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "mx-4 flex-grow border-t border-gray-300"
            })
        ]
    });
}
$ccf80cc55d780012$var$DateSeparator.propTypes = {
    dateArg: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
};
function $ccf80cc55d780012$var$DraggableTransaction(props) {
    const Element = props.element || "div";
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition } = (0, $a14476affb27f7d7$export$4ebcb6201122185a)({
        id: props.transaction.id
    });
    const style = {
        transform: (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition,
        touchAction: "none"
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Element, (0, $2qxEV._)((0, $9tqwB._)({
        ref: setNodeRef,
        style: style
    }, listeners, attributes), {
        className: "w-full",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bf18c8a9090be1b$exports.ErrorBoundary), {
            FallbackComponent: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6f72144921f9f9ac$export$718d309b10019100), (0, $9tqwB._)({}, props))
        })
    }));
}
$ccf80cc55d780012$var$DraggableTransaction.propTypes = {
    element: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    transaction: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
$ccf80cc55d780012$var$DraggableTransaction.defaultProps = {
    element: "div"
};
function $ccf80cc55d780012$export$2e2bcd8739ae039({ project: project, setTransactionDialog: setTransactionDialog, setQuoteDialog: setQuoteDialog, setGoalDialog: setGoalDialog, projectAssets: projectAssets, filteredItems: filteredItems }) {
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [items, setItems] = (0, $7fPBF.useState)({});
    const [breaker, setBreaker] = (0, $7fPBF.useState)(false);
    const [_, setActiveTransaction] = (0, $7fPBF.useState)();
    const [visibleRecurringTransactions, setVisibleRecurringTransactions] = (0, $7fPBF.useState)([]);
    const selectProjectTimelineItems = (0, $7fPBF.useMemo)((0, $3679aa7475d9bd44$export$a942db4885b6ea2), []);
    const selectProjectSumById = (0, $7fPBF.useMemo)((0, $3679aa7475d9bd44$export$700958e167898c8a), []);
    const projectTimeline = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _project_settings;
        return selectProjectTimelineItems(state, project.id, filteredItems, !!(project === null || project === void 0 ? void 0 : (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated));
    });
    const projectSumAtDate = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>selectProjectSumById(state, project.id));
    const cav = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$70d960c2428e363b));
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const ibans = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.deposits.accounts.map((account)=>account.iban));
    (0, $7fPBF.useEffect)(()=>{
        setVisibleRecurringTransactions((projectTimeline === null || projectTimeline === void 0 ? void 0 : projectTimeline.recurringDefaultVisible) || []);
    }, [
        projectTimeline === null || projectTimeline === void 0 ? void 0 : projectTimeline.recurringDefaultVisible
    ]);
    (0, $7fPBF.useEffect)(()=>()=>(0, $f1298db2f868236d$export$f977d29bae9e77f5)(), []);
    const derivedItems = (0, $7fPBF.useMemo)(()=>{
        const byMonth = (projectTimeline === null || projectTimeline === void 0 ? void 0 : projectTimeline.itemsByMonth) || {};
        const output = {};
        Object.keys(byMonth).forEach((monthKey)=>{
            const monthItems = byMonth[monthKey] || [];
            const filteredMonthItems = monthItems.filter((item)=>!item.recurringParentId || visibleRecurringTransactions.includes(item.recurringParentId));
            if (filteredMonthItems.length > 0) output[monthKey] = filteredMonthItems;
        });
        return output;
    }, [
        projectTimeline === null || projectTimeline === void 0 ? void 0 : projectTimeline.itemsByMonth,
        visibleRecurringTransactions
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!breaker) setItems(derivedItems);
    }, [
        derivedItems,
        breaker
    ]);
    const sensors = (0, $ecddad0aaeff3d51$export$19012f58216d597f)((0, $ecddad0aaeff3d51$export$cc72dd71f4ec69eb)((0, $ecddad0aaeff3d51$export$b26af955418d6638), {
        activationConstraint: {
            distance: 10
        }
    }), (0, $ecddad0aaeff3d51$export$cc72dd71f4ec69eb)((0, $ecddad0aaeff3d51$export$44d67f2a438aeba9), {
        coordinateGetter: (0, $a14476affb27f7d7$export$a6f27ecf02eb3a67)
    }));
    function findContainer(id) {
        if (id in items) return id;
        return Object.keys(items).find((key)=>items[key].findIndex((item)=>item.id === id) > -1);
    }
    function handleDragStart(event) {
        const { active: active } = event;
        const { id: id } = active;
        setBreaker(true);
        setActiveTransaction(items[findContainer(id)].find((item)=>item.id === id));
    }
    function handleDragOver(event) {
        const { active: active, over: over } = event;
        if (!over) return;
        const { id: id } = active;
        const { id: overId } = over;
        const activeContainer = findContainer(id);
        const overContainer = findContainer(overId);
        if (!activeContainer || !overContainer || activeContainer === overContainer) return;
        setItems((prev)=>{
            const activeItems = prev[activeContainer];
            const overItems = prev[overContainer];
            const activeIndex = activeItems.findIndex((item)=>item.id === id);
            const overIndex = overItems.findIndex((item)=>item.id === overId);
            let newIndex;
            if (overId in prev) newIndex = overItems.length + 1;
            else {
                const isBelowLastItem = over && overIndex === overItems.length - 1;
                const modifier = isBelowLastItem ? 1 : 0;
                newIndex = overIndex >= 0 ? overIndex + modifier : overItems.length + 1;
            }
            return (0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                [activeContainer]: [
                    ...prev[activeContainer].filter((item)=>item.id !== active.id)
                ],
                [overContainer]: [
                    ...prev[overContainer].slice(0, newIndex),
                    prev[activeContainer][activeIndex],
                    ...prev[overContainer].slice(newIndex, prev[overContainer].length)
                ]
            });
        });
    }
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        if (!over || !active) return;
        const { id: id } = active;
        const { id: overId } = over;
        const activeContainer = findContainer(id);
        const overContainer = findContainer(overId);
        if (!activeContainer || !overContainer || activeContainer !== overContainer) return;
        const activeIndex = items[activeContainer].findIndex((item)=>item.id === active.id);
        const overIndex = items[overContainer].findIndex((item)=>item.id === overId);
        if (activeIndex !== overIndex) {
            const nextItems = (0, $a14476affb27f7d7$export$5d49d615ad5ea2b0)(items[overContainer], activeIndex, overIndex);
            setItems((prev)=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                    [overContainer]: nextItems
                }));
            const toBeDispatched = nextItems.map((item, index)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
                    sortingOrderWithinMonth: index
                }));
            dispatch((0, $f1c3fa004749592f$export$942e92bd9e040eb)({
                payload: toBeDispatched
            }));
            setTimeout(()=>setBreaker(false), 5000);
        } else setBreaker(false);
        setActiveTransaction(null);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "project-transactions-list",
        className: "w-full lg:pr-2 flex flex-col gap-4 items-start",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$2d5c5ceac203fc1e), {
            sensors: sensors,
            collisionDetection: (0, $ecddad0aaeff3d51$export$c8e785ae6b74bab8),
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragEnd: handleDragEnd,
            children: Object.keys(items || []).sort((a, b)=>Number(a) > Number(b) ? 1 : -1).filter((item)=>items[item].length > 0).map((month)=>{
                const monthItems = items[month];
                const quoteItems = monthItems.filter((transaction)=>"quote" in transaction);
                const goalItems = monthItems.filter((transaction)=>transaction.name);
                const transactionItems = monthItems.filter((transaction)=>!("quote" in transaction) && !("name" in transaction));
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ccf80cc55d780012$var$DateSeparator, {
                            dateArg: Number(month)
                        }),
                        quoteItems.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "w-full flex flex-row justify-center items-center -mt-2 space-x-2",
                            children: quoteItems.map((q)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac35959ccf047067$export$2e2bcd8739ae039), {
                                    quote: q,
                                    setQuoteDialog: setQuoteDialog,
                                    projectAssets: projectAssets
                                }, `${q.assetId}-${q.date}-${q.quote}`))
                        }),
                        goalItems.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "w-full flex flex-row justify-center items-center -mt-2",
                            children: goalItems.map((g)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd2f611e5d0861c5$export$2e2bcd8739ae039), {
                                    goal: g,
                                    setGoalDialog: setGoalDialog,
                                    projectSumAtDate: projectSumAtDate
                                }, `${g.date}`))
                        }),
                        transactionItems.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a14476affb27f7d7$export$86155fde54f06e6a), {
                            id: month,
                            items: monthItems,
                            children: transactionItems.map((transaction)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ccf80cc55d780012$var$DraggableTransaction, {
                                    id: `project-transactions-item-${month}-${transaction.id}`,
                                    transaction: transaction,
                                    project: project,
                                    setTransactionDialog: setTransactionDialog,
                                    visibleRecurringTransactions: visibleRecurringTransactions,
                                    setVisibleRecurringTransactions: setVisibleRecurringTransactions,
                                    setAssetTileHover: (0, $f1298db2f868236d$export$1f281df8d13fdcb3),
                                    clearAssetTileHover: (0, $f1298db2f868236d$export$f977d29bae9e77f5),
                                    accounts: accounts,
                                    ibans: ibans,
                                    cav: cav
                                }, transaction.id))
                        })
                    ]
                }, Number(month));
            })
        })
    });
}
$ccf80cc55d780012$export$2e2bcd8739ae039.propTypes = {
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    setTransactionDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setQuoteDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setGoalDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    projectAssets: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    filteredItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
$ccf80cc55d780012$export$2e2bcd8739ae039.defaultProps = {
    projectAssets: []
};



/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





function $c3e47298c918b9dc$export$2e2bcd8739ae039({ project: project }) {
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [user, setUser] = (0, $7fPBF.useState)(null);
    const [commentField, setCommentField] = (0, $7fPBF.useState)("");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const comments = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects.find((p)=>p.id === project.id).comments);
    (0, $7fPBF.useEffect)(()=>{
        async function getUser() {
            var _returnObject_attributes, _returnObject_attributes1;
            const returnObject = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)();
            setUser(returnObject && (((_returnObject_attributes = returnObject.attributes) === null || _returnObject_attributes === void 0 ? void 0 : _returnObject_attributes.preferred_username) || ((_returnObject_attributes1 = returnObject.attributes) === null || _returnObject_attributes1 === void 0 ? void 0 : _returnObject_attributes1.email)));
        }
        getUser();
    }, []);
    function handleCommentSubmit(e, text) {
        e.preventDefault();
        dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
            comments: [
                ...comments,
                {
                    author: user,
                    text: text,
                    date: new Date(new Date().toUTCString()).valueOf()
                }
            ]
        })));
        setCommentField("");
    }
    function handleCommentDelete(e, commentIndex) {
        e.preventDefault();
        dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
            comments: comments.filter((c, i)=>i !== commentIndex)
        })));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
        "aria-labelledby": "notes-title",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "bg-white shadow sm:overflow-hidden sm:rounded-lg",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "divide-y divide-gray-200",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "sm:px-6",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                            className: "space-y-8",
                            children: comments.map((item)=>{
                                var _item_author;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                    className: "first:pt-6 last:pb-6",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex space-x-3",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "flex-shrink-0",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-brandDarkBlue-500",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        className: "text-sm font-medium leading-none text-white",
                                                        children: (_item_author = item.author) === null || _item_author === void 0 ? void 0 : _item_author.substring(0, 1).toUpperCase()
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-sm",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                            href: "/",
                                                            className: "font-medium text-gray-900",
                                                            children: item.author
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "mt-1 text-sm text-gray-700",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            children: item.text
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "mt-2 space-x-2 text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                className: "font-medium text-gray-500",
                                                                children: new Date(item.date).toLocaleDateString("de", {
                                                                    timeZone: "UTC"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                className: "font-medium text-gray-500",
                                                                children: "\xb7"
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                type: "button",
                                                                text: "Delete",
                                                                onClick: (e)=>handleCommentDelete(e, comments.indexOf(item))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, item.date);
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "bg-gray-50 px-4 py-6 sm:px-6",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex space-x-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-brandDarkBlue-500",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "text-sm font-medium leading-none text-white",
                                        children: (user || "").substring(0, 1).toUpperCase()
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "min-w-0 flex-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                                    onSubmit: (e)=>handleCommentSubmit(e, e.target.comment.value),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                    htmlFor: "comment",
                                                    className: "sr-only",
                                                    children: "About"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                                    id: "comment",
                                                    name: "comment",
                                                    value: commentField,
                                                    onChange: (e)=>setCommentField(e.target.value),
                                                    rows: "3",
                                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-500 sm:text-sm",
                                                    placeholder: "Add a note"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-3 flex items-center justify-right",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                type: "submit",
                                                text: "Save",
                                                withAccent: true
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
$c3e47298c918b9dc$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




const $ecaa4797207ab7c3$var$debugLevel = 0;
function $ecaa4797207ab7c3$export$7e4d5a5bfa133149({ project: project }) {
    const { id: projectId } = project;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const createSelectorWithDebug = (0, $5c22629b42831e80$export$5943f4447f6ef248)((0, $58b9680bf8a527fb$export$281bff7f05488aa2), // eslint-disable-next-line arrow-body-style
    (a, b)=>{
        console.log("Comparing:", a, b); // Log the values being compared
        return a === b; // Use the default equality check
    });
    // project value / invested amount: only up to the sliderDate
    // invested amount = asset purchases + external costs (outflows) - calculated in projectBalances
    const currentInvestedAmount = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$bab31b68289bf34b)).reduce((acc, curr)=>curr.projectId === projectId ? curr.current.investedAmount + acc : acc, 0); // purchases and outflows are both negative
    const currentValue = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$bab31b68289bf34b)).reduce((acc, curr)=>curr.projectId === projectId ? curr.current.valueBaseCurrency + acc : acc, 0);
    // project value / invested amount at next goal
    // invested amount = asset purchases + external costs (outflows) - calculated in projectBalances
    const projectNextGoalInvestedAmount = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$bab31b68289bf34b)).reduce((acc, curr)=>curr.projectId === projectId ? curr.nextGoalDate.investedAmount + acc : acc, 0); // purchases and outflows are both negative
    const projectSumAtNextGoal = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$bab31b68289bf34b)).reduce((acc, curr)=>curr.projectId === projectId ? curr.nextGoalDate.valueBaseCurrency + acc : acc, 0);
    const currentRoi = currentValue + currentInvestedAmount;
    const currentRoiPercent = currentInvestedAmount ? currentRoi / -currentInvestedAmount : 0;
    const projectNextGoalRoi = projectSumAtNextGoal + projectNextGoalInvestedAmount;
    const projectNextGoalRoiPercent = projectNextGoalInvestedAmount ? projectNextGoalRoi / -projectNextGoalInvestedAmount : 0;
    if ($ecaa4797207ab7c3$var$debugLevel > 2) console.log("ProgressRoi", "currentValue", currentValue, "currentInvestedAmount", currentInvestedAmount);
    if ($ecaa4797207ab7c3$var$debugLevel > 2) console.log("ProgressRoi", "projectSumAtEnd", projectSumAtNextGoal, "projectEndInvestedAmount", projectNextGoalInvestedAmount);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "sm:px-2 lg:px-0 xl:px-2 w-full grid grid-cols-2 gap-4 text-xs sm:text-sm text-gray-500",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "font-base",
                        children: t("roiSliderDate")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-lg",
                        children: [
                            currentInvestedAmount < 0 ? currentRoi.toLocaleString("de", {
                                style: "currency",
                                currency: "EUR",
                                maximumSignificantDigits: 4
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "text-lg font-normal",
                                children: t("noInvestment")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: `${currentRoiPercent >= 0 ? "text-green-500" : "text-brandRed-500"} flex items-baseline text-xs sm:text-sm font-semibold`,
                                children: currentInvestedAmount < 0 && currentRoiPercent.toLocaleString("de", {
                                    style: "percent",
                                    maximumFractionDigits: 1
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "font-base",
                        children: t("roiNextGoal")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1 xl:text-lg",
                        children: [
                            projectNextGoalInvestedAmount < 0 ? projectNextGoalRoi.toLocaleString("de", {
                                style: "currency",
                                currency: "EUR",
                                maximumSignificantDigits: 4
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "text-lg font-normal",
                                children: t("noInvestment")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: `${projectNextGoalRoiPercent >= 0 ? "text-green-500" : "text-brandRed-500"} flex items-baseline text-xs sm:text-sm font-semibold`,
                                children: projectNextGoalInvestedAmount < 0 && projectNextGoalRoiPercent.toLocaleString("de", {
                                    style: "percent",
                                    maximumFractionDigits: 1
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$ecaa4797207ab7c3$export$7e4d5a5bfa133149.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
const $ecaa4797207ab7c3$var$ProgressRoi = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($ecaa4797207ab7c3$export$7e4d5a5bfa133149);
var $ecaa4797207ab7c3$export$2e2bcd8739ae039 = $ecaa4797207ab7c3$var$ProgressRoi;



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


function $32655ef1093ac6e9$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $32655ef1093ac6e9$export$2e2bcd8739ae039({ projectId: projectId, progressColour: progressColour, backgroundColour: backgroundColour }) {
    const dateRangesByProjectId = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$fc2b2be653f13fa1));
    const thisProjectRange = dateRangesByProjectId === null || dateRangesByProjectId === void 0 ? void 0 : dateRangesByProjectId[projectId];
    let marker = 0;
    if ((thisProjectRange === null || thisProjectRange === void 0 ? void 0 : thisProjectRange.maxDate) > (thisProjectRange === null || thisProjectRange === void 0 ? void 0 : thisProjectRange.minDate)) {
        const elapsed = Math.max(0, Date.now() - thisProjectRange.minDate);
        marker = elapsed / (thisProjectRange.maxDate - thisProjectRange.minDate) * 100;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "sm:px-2 lg:px-0 xl:px-2 w-full",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "space-y-1",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        marginLeft: "-8px",
                        paddingLeft: `${marker}%`
                    },
                    className: "w-fit",
                    children: `${Number(marker || 0).toFixed(0)} %`
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "relative w-full",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: $32655ef1093ac6e9$var$classNames(backgroundColour, "relative h-2 w-full rounded-sm"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: $32655ef1093ac6e9$var$classNames(progressColour, "absolute h-2 rounded-sm"),
                            style: {
                                width: `${marker}%`
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        marginLeft: "-8px",
                        paddingLeft: `${marker}%`
                    },
                    className: "w-fit",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "-rotate-90 w-fit",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            className: "w-4 h-4",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z",
                                clipRule: "evenodd"
                            })
                        })
                    })
                })
            ]
        })
    });
}
$32655ef1093ac6e9$export$2e2bcd8739ae039.propTypes = {
    projectId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    progressColour: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    backgroundColour: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$32655ef1093ac6e9$export$2e2bcd8739ae039.defaultProps = {
    progressColour: "bg-brandBlue-500",
    backgroundColour: "bg-gray-200"
};




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


const $be1ff2970a62d1fa$var$debugLevel = 0;
function $be1ff2970a62d1fa$export$44a155902c71bc91({ project: project }) {
    const { goals: goals } = project;
    const nextUpcomingGoal = !goals || goals.length === 0 ? {
        amount: 0
    } : project.goals.sort((a, b)=>a.date - b.date)[0]; // get the next upcoming goal (in case there are multiople goals)
    // get project sum at next goal date
    const projectForecast = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$bab31b68289bf34b)).reduce((acc, curr)=>acc + (curr.projectId === project.id ? curr.nextGoalDate.valueBaseCurrency : 0), 0);
    const goalVsForecast = (projectForecast - nextUpcomingGoal.amount) / nextUpcomingGoal.amount;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "sm:px-2 lg:px-0 xl:px-2 w-full grid grid-cols-2 gap-4 text-xs sm:text-sm text-gray-500",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "font-base pb-1",
                        children: "Goal"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 sm:text-lg font-bold text-gray-900 flex items-baseline gap-1",
                        children: Number(nextUpcomingGoal.amount).toLocaleString("de", {
                            style: "currency",
                            currency: "EUR",
                            maximumFractionDigits: 0
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "font-base pb-1",
                        children: "Forecast"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 sm:text-lg font-bold text-gray-900 sm:flex sm:items-baseline lg:block xl:flex gap-1",
                        children: [
                            projectForecast.toLocaleString("de", {
                                style: "currency",
                                currency: "EUR",
                                maximumFractionDigits: 0
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: `${goalVsForecast >= 0 ? "text-green-500" : "text-brandRed-500"} flex items-baseline text-xs sm:text-sm font-light sm:font-semibold`,
                                children: goalVsForecast.toLocaleString("de", {
                                    style: "percent",
                                    maximumFractionDigits: 1
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$be1ff2970a62d1fa$export$44a155902c71bc91.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
const $be1ff2970a62d1fa$var$ProgressGoal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($be1ff2970a62d1fa$export$44a155902c71bc91);
var $be1ff2970a62d1fa$export$2e2bcd8739ae039 = $be1ff2970a62d1fa$var$ProgressGoal;



/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

















const $65b501ec2ba9b271$var$debugLevel = 0;

(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $65b501ec2ba9b271$export$2e2bcd8739ae039({ quoteDialog: quoteDialog, setQuoteDialog: setQuoteDialog, assetsList: assetsList, project: project }) {
    var _project_settings, _errors_date, _errors_quote;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const selectBaseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const baseCurrency = (0, $7fPBF.useMemo)(()=>selectBaseCurrency, [
        selectBaseCurrency
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // save button was clicked
    const [deleting, setDeleting] = (0, $7fPBF.useState)(false); // delete button was clicked
    const [showFxRate, setShowFxRate] = (0, $7fPBF.useState)(true); // currency section
    const [fxRateLoading, setFxRateLoading] = (0, $7fPBF.useState)(false); // currency section
    const [existingQuoteError, setExistingQuoteError] = (0, $7fPBF.useState)(false); // quote already exists
    // receive a list of asset tiles from ProjectDetails with assetId and openAmount
    // caveat: we show a list of assetIds in this project; we do not check if there is enough at the time of the transaction (a warning will show up in TransactionComponent if this is the case)
    function mapToAssetListCallback(asset) {
        return {
            assetId: asset.assetId || asset.accountId,
            displayName: asset.displayName,
            displaySymbol: asset.displaySymbol
        };
    }
    const assetIdsArray = assetsList.map(mapToAssetListCallback);
    const defaultValuesEmptyForm = {
        assetId: null,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(12, "months").startOf("month").format("YYYY-MM-DD"),
        // first day of current month; toISOString returns UTC time (which is 1 day behind in Berlin), so using Swedish format which the same timezone as Berlin
        quote: 100,
        currency: "EUR",
        quoteBaseCurrency: 100,
        source: "manual"
    };
    // initialise the form with values from an existing object or default values
    const formObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: quoteDialog === true ? defaultValuesEmptyForm : (0, $2qxEV._)((0, $9tqwB._)({}, quoteDialog), {
            date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(quoteDialog.date).format("YYYY-MM-DD"),
            // intialise the asset picklist with the correct object from assetIdsArray (which is used as a source there);
            // "displaySymbol" is hardcoded in the AssetNamePicklist component, hence the strange name, but this contains the asset object
            displaySymbol: mapToAssetListCallback(assetsList.find((a)=>a.assetId === quoteDialog.assetId || a.assetId === quoteDialog.accountId))
        })
    });
    const { handleSubmit: handleSubmit, register: register, unregister: unregister, watch: watch, setValue: setValue, formState: { errors: errors }, control: control, trigger: trigger, getFieldState: getFieldState } = formObject;
    const currency = watch("currency");
    const quote = watch("quote");
    const quoteBaseCurrency = watch("quoteBaseCurrency");
    const exchangeRate = watch("exchangeRate");
    const displaySymbol = watch("displaySymbol"); // this is {assetId, displayName, displaySymbol}
    const date = watch("date");
    const assetId = (displaySymbol === null || displaySymbol === void 0 ? void 0 : displaySymbol.assetId) || null;
    const isolatedProjectId = ((_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated) ? project.id : undefined;
    // similar code is in use in ProjectTransactionList (to display quotes there)
    const selectQuotes = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $93bb2798871a68d2$export$32058f168ca0310f)(state, isolatedProjectId));
    // deprecated: figi should no longer appear in quotes
    // const quotes = selectQuotes.filter((item) => item.source === 'manual' && typeof item.date === 'number' && (assetId === item.accountId || assetId === item.figi || assetId === item.assetId));
    // only get quotes for assets of this projects (defined in assetIds), by comparing figi, assetId and accountId (we could do it by category, but trying to stay robust)
    const quotes = selectQuotes.filter((item)=>item.source === "manual" && typeof item.date === "number" && (assetId === item.accountId || assetId === item.assetId));
    // keep checking if the quote already exists
    (0, $7fPBF.useEffect)(()=>{
        console.log("runnign useEffect", displaySymbol, date, quotes);
        if (displaySymbol && date) {
            if (quotes.some((q)=>q.date === (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(date).startOf("day").valueOf() && q.assetId === displaySymbol.assetId)) setExistingQuoteError(true);
            else setExistingQuoteError(false);
        }
    }, [
        displaySymbol,
        date
    ]);
    // submits the form object to backend
    async function onSubmit(incomingData) {
        // logic for quotes:
        // - if quoteDialog is a 'true', then this is a clear case of posting a new transaction
        // - if quoteDialog is an object, then this is an edit of an existing transaction,
        //   so we need to first delete the old quote and then post the new one (to save ourselves the trouble of figuring out if it can be edited or not)
        // run it through schema before submitting
        try {
            setLoading(true);
            if (quoteDialog === true) {
                const quoteObject = (0, $2qxEV._)((0, $9tqwB._)({}, incomingData), {
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(incomingData.date).startOf("day").valueOf(),
                    assetId: incomingData.displaySymbol.assetId,
                    projectId: project.id,
                    importFlag: "post"
                });
                if (currency === baseCurrency) quoteObject.quoteBaseCurrency = quoteObject.quote;
                // if currency is not the baseCurrency and if quoteBaseCurrency is not set, use exhangeRate to calculate it
                // user has the option of providing quoteBaseCurrency directly, in which case we don't need to calculate it
                if (currency !== baseCurrency && !quoteObject.quoteBaseCurrency) quoteObject.quoteBaseCurrency = quoteObject.quote * quoteObject.exchangeRate;
                const validatedQuoteObject = await (0, $fd6541cb8870bfa3$export$ee7a15c61bfdeb11).validate(quoteObject);
                delete validatedQuoteObject.displaySymbol;
                delete validatedQuoteObject.exchangeRate;
                await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                    arrayOfQuotes: [
                        validatedQuoteObject
                    ]
                }));
            }
            if (typeof quoteDialog === "object") {
                const quoteObject = (0, $2qxEV._)((0, $9tqwB._)({}, incomingData), {
                    date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(incomingData.date).startOf("date").valueOf(),
                    assetId: incomingData.displaySymbol.assetId,
                    projectId: project.id,
                    source: "manual"
                });
                if (currency === baseCurrency) quoteObject.quoteBaseCurrency = quoteObject.quote;
                // if currency is not the baseCurrency and if quoteBaseCurrency is not set, use exhangeRate to calculate it
                // user has the option of providing quoteBaseCurrency directly, in which case we don't need to calculate it
                if (currency !== baseCurrency && !quoteObject.quoteBaseCurrency) quoteObject.quoteBaseCurrency = quoteObject.quote * quoteObject.exchangeRate;
                const validatedQuoteObject = await (0, $fd6541cb8870bfa3$export$ee7a15c61bfdeb11).validate(quoteObject);
                delete validatedQuoteObject.displaySymbol;
                delete validatedQuoteObject.exchangeRate;
                await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                    arrayOfQuotes: [
                        (0, $2qxEV._)((0, $9tqwB._)({}, validatedQuoteObject), {
                            importFlag: "delete"
                        })
                    ]
                }));
                await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                    arrayOfQuotes: [
                        (0, $2qxEV._)((0, $9tqwB._)({}, validatedQuoteObject), {
                            importFlag: "put"
                        })
                    ]
                }));
            }
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            setLoading(false);
            setQuoteDialog(false);
        } catch (e) {
            console.error(e);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            setLoading(false);
        }
    }
    async function onDelete(e) {
        // delete button only shows up when editing an existing transaction, so no need to check that
        e.preventDefault();
        setDeleting(true);
        try {
            const incomingData = formObject.getValues();
            const quoteObject = (0, $2qxEV._)((0, $9tqwB._)({}, incomingData), {
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(incomingData.date).startOf("date").valueOf(),
                assetId: incomingData.displaySymbol.assetId,
                projectId: project.id,
                source: "manual"
            });
            const validatedQuoteObject = await (0, $fd6541cb8870bfa3$export$ee7a15c61bfdeb11).validate(quoteObject);
            await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                arrayOfQuotes: [
                    (0, $2qxEV._)((0, $9tqwB._)({}, validatedQuoteObject), {
                        importFlag: "delete"
                    })
                ]
            }));
            setDeleting(false);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            setQuoteDialog(false);
        } catch (err) {
            console.error(err);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            setDeleting(false);
        }
    }
    // when user selects a non-base-currency for the transaction, get the fx rate in the background and display it
    // when updating this code, remember to change the same code in InflowOutflowTransfer.jsx
    (0, $7fPBF.useEffect)(()=>{
        async function updateFxRate() {
            if (currency !== baseCurrency) {
                setFxRateLoading(true);
                let newRate;
                try {
                    newRate = await (0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, baseCurrency, currency, (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("day").valueOf());
                    setValue("exchangeRate", (1 / newRate).toFixed(4), {
                        shouldValidate: true
                    });
                    setFxRateLoading(false);
                } catch (err) {
                    setFxRateLoading(false);
                }
            }
        }
        updateFxRate();
    }, [
        currency
    ]);
    // InflowOutflowTransfer has a very similar function, remember to change it there as well if changing here
    function handleFxRateFieldSwitch(e) {
        if (showFxRate) {
            register("quoteBaseCurrency");
            setValue("quoteBaseCurrency", (Number(quote) * Number(exchangeRate)).toFixed(2), {
                shouldValidate: true
            });
            unregister("exchangeRate"); // this is done so that prepDataForPost knows if it should use exchangeRate or quoteBaseCurrency (so we only keep one of them in the form)
        } else {
            register("exchangeRate");
            setValue("exchangeRate", (Number(quoteBaseCurrency) / Number(quote)).toFixed(4), {
                shouldValidate: true
            });
            unregister("quoteBaseCurrency"); // this is done so that prepDataForPost knows if it should use exchangeRate or quoteBaseCurrency (so we only keep one of them in the form)
        }
        setShowFxRate(!showFxRate);
    // recalculate FX rate or quoteBaseCurrency based on which field was changed
    // if showFxRate is true, then fxRate is being changed to quoteBaseCurrency
    }
    const myRef = (0, $7fPBF.useRef)(null);
    // scroll all the way up when the dialog opens
    (0, $7fPBF.useEffect)(()=>{
        var _myRef_current;
        if (quoteDialog) (_myRef_current = myRef.current) === null || _myRef_current === void 0 ? void 0 : _myRef_current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
        });
    }, [
        quoteDialog
    ]);
    return(// <div id="add-project-quote" data-testid="add-project-quote" className="bg-opacity-90 bg-gray-300 absolute top-0 left-0 w-full h-full z-[100] p-4" ref={(el) => { myRef.current = el; }}>
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "add-project-quote",
        "data-testid": "add-project-quote",
        className: "bg-opacity-90 bg-gray-300 absolute top-0 left-0 w-full h-full z-[100] p-4",
        ref: myRef,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex flex-col items-center justify-center h-full",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                autoComplete: "off",
                onSubmit: handleSubmit(onSubmit),
                className: "relative bg-white rounded-md shadow-lg p-8 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: "project-details-add-transaction-close",
                        onClick: (e)=>{
                            setQuoteDialog(false);
                        },
                        className: "absolute top-4 right-4 cursor-pointer",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-500 hover:text-gray-600"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mb-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "inline text-2xl font-bold text-gray-900",
                                children: t("addQuote")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-lg font-normal text-gray-900",
                                children: t("addQuoteDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 gap-12",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                id: "project-details-add-transaction-asset-name",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddde1af3baf48bd0$export$2e2bcd8739ae039 // displaySymbol
                                ), {
                                    control: control,
                                    assetIds: assetIdsArray,
                                    t: t,
                                    errors: errors
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "pb-8",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "date",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                className: "text-black border-gray-400 shadow bg-brandYellow-50",
                                                info: t("date.tooltip"),
                                                children: [
                                                    t("date"),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $071105eca597c3d9$export$2e2bcd8739ae039), {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                type: "date",
                                                name: "date",
                                                id: "date",
                                                step: "month",
                                                // onChange
                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                            }, register("date", {
                                                // round down to first day of month
                                                onChange: (e)=>{
                                                    const dateEpoch = new Date(e.target.value);
                                                    dateEpoch.setDate(1);
                                                    let value;
                                                    try {
                                                        [value] = dateEpoch.toISOString().split("T");
                                                    } catch (err) {
                                                    // when user uses arrow to change day by one lower and comes to an incorrect date as an effect (e.g. 31-02-2021)
                                                    // the field sends an empty string as e.target.value and we reset it to the previous value (from form state)
                                                    // value = transactionDate;  // FIXME
                                                    }
                                                    setValue("date", value);
                                                },
                                                validate: (value)=>{
                                                    if (new Date(value) > new Date()) return true;
                                                    return t("date.error");
                                                }
                                            })))
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: (_errors_date = errors.date) === null || _errors_date === void 0 ? void 0 : _errors_date.message
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "grid grid-cols-3 gap-3",
                                id: "project-details-add-transaction-amount",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                htmlFor: "quote",
                                                className: "block text-sm font-medium text-gray-700",
                                                children: t("quote.label")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "mt-1",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "number",
                                                    step: "0.01",
                                                    name: "quote",
                                                    id: "quote",
                                                    placeholder: 35.49,
                                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                                }, register("quote", {
                                                    min: {
                                                        value: 0,
                                                        message: t("quote.error")
                                                    }
                                                })))
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: (_errors_quote = errors.quote) === null || _errors_quote === void 0 ? void 0 : _errors_quote.message
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "z-10",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                                            name: "currency",
                                            control: control,
                                            render: ({ field: field, ref: ref })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                    label: t("currency"),
                                                    list: (0, $796ea4636350e237$export$a01df35ce0858603),
                                                    value: field.value,
                                                    onChange: field.onChange,
                                                    onBlur: field.onBlur,
                                                    inputRef: ref
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        children: showFxRate ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                    htmlFor: "exchangeRate",
                                                    className: `block text-sm font-medium ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                                    children: `${t("exchangeRate.label")} ${baseCurrency}`
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "mt-1 relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                            type: "number",
                                                            step: "any",
                                                            name: "exchangeRate",
                                                            id: "exchangeRate",
                                                            disabled: currency === baseCurrency,
                                                            // eslint-disable-next-line max-len
                                                            className: `block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                                            placeholder: 1
                                                        }, register("exchangeRate", {
                                                            validate: (value)=>{
                                                                if (value <= 0) return t("exchangeRate.mustBeGreaterThanZero");
                                                                return true;
                                                            }
                                                        }))),
                                                        fxRateLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: "absolute inset-y-0 right-0 flex items-center pr-3",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                                className: "h-4 w-4 animate-spin text-gray-600"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: `${currency !== baseCurrency ? "" : "hidden"} text-xs underline text-gray-400 hover:text-brandBlue-400`,
                                                    onClick: handleFxRateFieldSwitch,
                                                    type: "button",
                                                    children: showFxRate ? t("switchToAmount") : `${t("switchToFxRate")} ${baseCurrency}`
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                    htmlFor: "quoteBaseCurrency",
                                                    className: `block text-sm font-medium ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                                    children: `${t("quoteBaseCurrency.label")} ${baseCurrency}`
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "mt-1",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                        type: "number",
                                                        name: "quoteBaseCurrency",
                                                        id: "quoteBaseCurrency",
                                                        disabled: currency === baseCurrency,
                                                        // eslint-disable-next-line max-len
                                                        className: `block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm ${currency === baseCurrency ? "text-gray-300" : "text-gray-700"}`,
                                                        placeholder: 2000
                                                    }, register("quoteBaseCurrency", {
                                                        validate: (value)=>{
                                                            if (value <= 0) return t("quoteBaseCurrency.mustBeGreaterThanZero");
                                                            return true;
                                                        }
                                                    })))
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: `${currency !== baseCurrency ? "" : "hidden"} text-xs underline text-gray-400 hover:text-brandBlue-400`,
                                                    onClick: handleFxRateFieldSwitch,
                                                    type: "button",
                                                    children: showFxRate ? `${t("switchToAmount")}` : t("switchToFxRate")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-start items-center gap-4 pt-6",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-quote-save",
                                "data-testid": "project-add-quote-save",
                                type: "submit",
                                // eslint-disable-next-line max-len
                                className: "inline-flex items-center rounded-md border border-transparent bg-brandBlue-500 hover:bg-brandBlue-600 px-4 py-2 text-sm font-medium leading-4 text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                children: loading === false ? t("save") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    id: "project-add-quote-spinner",
                                    className: "px-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 text-white animate-spin"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-quote-delete",
                                type: "button",
                                onClick: onDelete,
                                disabled: quoteDialog === true,
                                // eslint-disable-next-line max-len
                                className: `inline-flex items-center rounded-md border px-4 py-2 text-sm font-medium leading-4 ${quoteDialog === true ? "hidden" : "text-gray-700 border-gray-300 bg-white"} shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2`,
                                children: deleting === false ? t("deleteQuote") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    id: "project-delete-quote-spinner",
                                    className: "px-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 text-gray-400 animate-spin"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-quote-cancel",
                                type: "button",
                                onClick: (e)=>{
                                    setQuoteDialog(false);
                                },
                                // eslint-disable-next-line max-len
                                className: "inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                children: t("cancel")
                            }),
                            existingQuoteError && !quoteDialog.quote && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-sm text-brandBlue-500",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $344a70c9f2a7e27e$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 -mt-1 mr-1 inline-block text-brandBlue-500"
                                    }),
                                    t("quoteAlreadyExists")
                                ]
                            }),
                            quoteDialog.projectId !== project.id && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "text-sm text-brandBlue-500",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $344a70c9f2a7e27e$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 -mt-1 mr-1 inline-block text-brandBlue-500"
                                    }),
                                    t("quoteProjectWillBeChanged")
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
}
$65b501ec2ba9b271$export$2e2bcd8739ae039.propTypes = {
    quoteDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    setQuoteDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    assetsList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
$65b501ec2ba9b271$export$2e2bcd8739ae039.defaultProps = {
    quoteDialog: null
};




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

function $05d872696dcd3541$var$t(key) {
    return (0, $0f5516e4ff7e5463$export$2e2bcd8739ae039).t(`projects:templates.${key}`);
}
function $05d872696dcd3541$export$2e2bcd8739ae039() {
    return [
        {
            id: "investToRent",
            name: $05d872696dcd3541$var$t("investToRent.name"),
            description: $05d872696dcd3541$var$t("investToRent.description"),
            accounts: [
                {
                    category: "deposits",
                    role: $05d872696dcd3541$var$t("investToRent.role1")
                }
            ],
            parameters: [
                {
                    key: "value"
                }
            ],
            transactions: [
                {
                    category: "deposits",
                    accountIndex: 0,
                    accountCurrencyAmount: 529,
                    currency: "EUR",
                    daysToAdd: 180,
                    type: "inflow",
                    description: $05d872696dcd3541$var$t("investToRent.transaction1"),
                    otherParty: "Arbeitgeber GmbH"
                },
                {
                    category: "deposits",
                    accountIndex: 0,
                    accountCurrencyAmount: 531,
                    currency: "EUR",
                    daysToAdd: 240,
                    type: "inflow",
                    description: $05d872696dcd3541$var$t("investToRent.transaction2"),
                    otherParty: "Arbeitgeber GmbH"
                }
            ]
        }
    ];
}


function $b9547158dd99c6fb$export$2e2bcd8739ae039({ setSelectedTemplate: setSelectedTemplate }) {
    const tiles = (0, $7fPBF.useMemo)(()=>(0, $05d872696dcd3541$export$2e2bcd8739ae039)(), []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
        className: "grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
        children: tiles.map((tile)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                id: `project-details-select-template-${tile.id}`,
                className: "col-span-1 flex flex-col divide-y divide-gray-200 border rounded-lg bg-white text-center shadow group hover:shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex flex-1 flex-col p-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "mt-6 mb-6 text-md tracking-wider uppercase font-bold text-gray-900",
                                children: tile.name
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dl", {
                                className: "mt-1 flex flex-grow flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dt", {
                                        className: "sr-only",
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                        className: "text-sm text-gray-500",
                                        children: tile.description
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dt", {
                                        className: "sr-only",
                                        children: "Role"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "-mt-px flex divide-x divide-gray-200",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex w-0 flex-1",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setSelectedTemplate(tile);
                                    },
                                    className: "relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-b-lg border border-transparent py-4 text-base text-white font-normal bg-brandBlue-500 group-hover:bg-brandBlue-600",
                                    children: "Select"
                                })
                            })
                        })
                    })
                ]
            }, tile.id))
    });
}
$b9547158dd99c6fb$export$2e2bcd8739ae039.propTypes = {
    setSelectedTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $2507d117e7230fd1$exports = {};

var $1557215ae053272d$exports = {};
var $51dea4a2e2631317$exports = {};
var $b67ec3577fd2cfcf$exports = {};

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $b67ec3577fd2cfcf$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $0372dacbc03388e3$exports(array, start, end);
}
$b67ec3577fd2cfcf$exports = $b67ec3577fd2cfcf$var$castSlice;


var $1545ad01d99df16b$exports = {};
/** Used to compose unicode character classes. */ var $1545ad01d99df16b$var$rsAstralRange = "\ud800-\udfff", $1545ad01d99df16b$var$rsComboMarksRange = "\\u0300-\\u036f", $1545ad01d99df16b$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $1545ad01d99df16b$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $1545ad01d99df16b$var$rsComboRange = $1545ad01d99df16b$var$rsComboMarksRange + $1545ad01d99df16b$var$reComboHalfMarksRange + $1545ad01d99df16b$var$rsComboSymbolsRange, $1545ad01d99df16b$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $1545ad01d99df16b$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $1545ad01d99df16b$var$reHasUnicode = RegExp("[" + $1545ad01d99df16b$var$rsZWJ + $1545ad01d99df16b$var$rsAstralRange + $1545ad01d99df16b$var$rsComboRange + $1545ad01d99df16b$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $1545ad01d99df16b$var$hasUnicode(string) {
    return $1545ad01d99df16b$var$reHasUnicode.test(string);
}
$1545ad01d99df16b$exports = $1545ad01d99df16b$var$hasUnicode;


var $3feda1c248532a44$exports = {};
var $0a377f169d30a6ad$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0a377f169d30a6ad$var$asciiToArray(string) {
    return string.split("");
}
$0a377f169d30a6ad$exports = $0a377f169d30a6ad$var$asciiToArray;



var $5d7e2db9b917571b$exports = {};
/** Used to compose unicode character classes. */ var $5d7e2db9b917571b$var$rsAstralRange = "\ud800-\udfff", $5d7e2db9b917571b$var$rsComboMarksRange = "\\u0300-\\u036f", $5d7e2db9b917571b$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $5d7e2db9b917571b$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $5d7e2db9b917571b$var$rsComboRange = $5d7e2db9b917571b$var$rsComboMarksRange + $5d7e2db9b917571b$var$reComboHalfMarksRange + $5d7e2db9b917571b$var$rsComboSymbolsRange, $5d7e2db9b917571b$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $5d7e2db9b917571b$var$rsAstral = "[" + $5d7e2db9b917571b$var$rsAstralRange + "]", $5d7e2db9b917571b$var$rsCombo = "[" + $5d7e2db9b917571b$var$rsComboRange + "]", $5d7e2db9b917571b$var$rsFitz = "\ud83c[\udffb-\udfff]", $5d7e2db9b917571b$var$rsModifier = "(?:" + $5d7e2db9b917571b$var$rsCombo + "|" + $5d7e2db9b917571b$var$rsFitz + ")", $5d7e2db9b917571b$var$rsNonAstral = "[^" + $5d7e2db9b917571b$var$rsAstralRange + "]", $5d7e2db9b917571b$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $5d7e2db9b917571b$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $5d7e2db9b917571b$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $5d7e2db9b917571b$var$reOptMod = $5d7e2db9b917571b$var$rsModifier + "?", $5d7e2db9b917571b$var$rsOptVar = "[" + $5d7e2db9b917571b$var$rsVarRange + "]?", $5d7e2db9b917571b$var$rsOptJoin = "(?:" + $5d7e2db9b917571b$var$rsZWJ + "(?:" + [
    $5d7e2db9b917571b$var$rsNonAstral,
    $5d7e2db9b917571b$var$rsRegional,
    $5d7e2db9b917571b$var$rsSurrPair
].join("|") + ")" + $5d7e2db9b917571b$var$rsOptVar + $5d7e2db9b917571b$var$reOptMod + ")*", $5d7e2db9b917571b$var$rsSeq = $5d7e2db9b917571b$var$rsOptVar + $5d7e2db9b917571b$var$reOptMod + $5d7e2db9b917571b$var$rsOptJoin, $5d7e2db9b917571b$var$rsSymbol = "(?:" + [
    $5d7e2db9b917571b$var$rsNonAstral + $5d7e2db9b917571b$var$rsCombo + "?",
    $5d7e2db9b917571b$var$rsCombo,
    $5d7e2db9b917571b$var$rsRegional,
    $5d7e2db9b917571b$var$rsSurrPair,
    $5d7e2db9b917571b$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $5d7e2db9b917571b$var$reUnicode = RegExp($5d7e2db9b917571b$var$rsFitz + "(?=" + $5d7e2db9b917571b$var$rsFitz + ")|" + $5d7e2db9b917571b$var$rsSymbol + $5d7e2db9b917571b$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $5d7e2db9b917571b$var$unicodeToArray(string) {
    return string.match($5d7e2db9b917571b$var$reUnicode) || [];
}
$5d7e2db9b917571b$exports = $5d7e2db9b917571b$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3feda1c248532a44$var$stringToArray(string) {
    return $1545ad01d99df16b$exports(string) ? $5d7e2db9b917571b$exports(string) : $0a377f169d30a6ad$exports(string);
}
$3feda1c248532a44$exports = $3feda1c248532a44$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $51dea4a2e2631317$var$createCaseFirst(methodName) {
    return function(string) {
        string = $78eb02cd4ef313ef$exports(string);
        var strSymbols = $1545ad01d99df16b$exports(string) ? $3feda1c248532a44$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $b67ec3577fd2cfcf$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$51dea4a2e2631317$exports = $51dea4a2e2631317$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $1557215ae053272d$var$upperFirst = $51dea4a2e2631317$exports("toUpperCase");
$1557215ae053272d$exports = $1557215ae053272d$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $2507d117e7230fd1$var$capitalize(string) {
    return $1557215ae053272d$exports($78eb02cd4ef313ef$exports(string).toLowerCase());
}
$2507d117e7230fd1$exports = $2507d117e7230fd1$var$capitalize;



var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $9c75dddb9ddf6b72$export$2e2bcd8739ae039({ selectedTemplate: selectedTemplate, setTemplateDialog: setTemplateDialog, project: project }) {
    const [accountValues, setAccountValues] = (0, $7fPBF.useState)(selectedTemplate.accounts.map((account)=>(0, $2qxEV._)((0, $9tqwB._)({}, account), {
            value: "selectAnOption",
            newAccountId: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)()
        })));
    // ^^ use index of input accounts array to reference accountValues
    // initialise with the rump account objects from the template
    // when user selects an account, replace the rump object with the full account object or with 'createNewAccount'
    // newAccountId only in case user wants to create a new account
    const [formError, setFormError] = (0, $7fPBF.useState)(false);
    const [formIsDirty, setFormIsDirty] = (0, $7fPBF.useState)(false);
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // for loading spinner
    const { t: tProjects } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const { t: tDashboard } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const selectBaseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const baseCurrency = (0, $7fPBF.useMemo)(()=>selectBaseCurrency, [
        selectBaseCurrency
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    // validate template and throw errors if any
    (0, $7fPBF.useEffect)(()=>{
        // check if all transactions have .category and .accountIndex
        if (selectedTemplate && selectedTemplate.transactions.some((transaction)=>!transaction.category || !(transaction.accountIndex > -1))) {
            // because if it is just !transaction.accountIndex, it interprets 0 as false
            console.error("Template transactions are missing category and / or accountIndex");
            setFormError(tProjects("templateInitialisationError"));
        }
    }, [
        selectedTemplate
    ]);
    async function handleSubmit(e) {
        if (accountValues.some((account)=>account.value === "selectAnOption")) {
            setFormError(tProjects("errorNotAllFields"));
            return;
        }
        setLoading(true);
        // create accounts if any of the fields are set to "create account" (await completion)
        // create payload
        if (accountValues.some((account)=>account.createNewAccount)) {
            // for each account dispatch and wait for result using Promise.all
            // if any of the promises fail, show toast to user and return
            const promises = [];
            accountValues.forEach((account)=>{
                if (account.createNewAccount) {
                    // cast to schema
                    const schema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(account.category, "account");
                    const newAccount = schema.cast({
                        id: account.newAccountId,
                        name: (0, (/*@__PURE__*/$parcel$interopDefault($2507d117e7230fd1$exports)))(tDashboard(`singleCategory.${account.category}`)),
                        currency: baseCurrency
                    });
                    // add promise to promises array
                    promises.push(dispatch((0, $f1c3fa004749592f$export$391c5b9a9263706a)({
                        data: [
                            newAccount
                        ],
                        category: account.category
                    })));
                }
            });
            await Promise.all(promises);
        }
        const defaultRecurringObject = {
            activated: false,
            numberOfPeriods: 1,
            periodType: {
                id: "month",
                name: tProjects("repeating.month")
            },
            end: "recurringNever",
            endAfterOccurrences: 10,
            endAfterDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(1, "year").valueOf()
        };
        const defaultIndexedObject = {
            activated: false,
            mode: "indexedByInflation",
            customRateInput: null
        };
        const defaultProjectTagValues = {
            recurring: defaultRecurringObject,
            indexed: defaultIndexedObject
        };
        // create transactions as per template (await completion)
        const transactionsByCategory = {};
        selectedTemplate.transactions.forEach((transaction)=>{
            const transactionSchema = (0, $56814ae52a40ecc8$export$38fcb27197d44cf6)(transaction.category, "transaction", false);
            const accountId = accountValues[transaction.accountIndex].id || accountValues[transaction.accountIndex].newAccountId;
            console.log("schema: ", transactionSchema, transaction.category);
            const newTransaction = transactionSchema.cast((0, $9tqwB._)({
                id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
                accountId: accountId,
                date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(transaction.daysToAdd || 100, "day").valueOf(),
                isSimulated: true,
                projectId: project.id,
                tags: (0, $2qxEV._)((0, $9tqwB._)({}, transaction.tags, defaultProjectTagValues), {
                    partOfProjectTemplate: true
                })
            }, transaction));
            // group transactions to optimise posting
            if (transactionsByCategory[transaction.category]) transactionsByCategory[transaction.category].push(newTransaction);
            else transactionsByCategory[transaction.category] = [
                newTransaction
            ];
        });
        try {
            // post transactions by category
            const transactionPromises = [];
            Object.keys(transactionsByCategory).forEach((category)=>{
                transactionPromises.push(dispatch((0, $f1c3fa004749592f$export$4e87299c28e9a838)({
                    data: transactionsByCategory[category],
                    category: category
                })));
            });
            await Promise.all(transactionPromises);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("applyProjectTemplateSuccess"));
            setTemplateDialog(null);
        } catch (error) {
            setLoading(false);
            console.error(error);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("applyProjectTemplateError"));
        }
    }
    (0, $7fPBF.useEffect)(()=>{
        // if any of the accounts has 'selectAnOption' as value, toggle error state
        if (formIsDirty && accountValues.some((account)=>account.value === "selectAnOption")) setFormError(tProjects("errorNotAllFields"));
        else setFormError(false);
    }, [
        accountValues
    ]);
    const handleAccountSelect = (event, index)=>{
        setFormIsDirty(true);
        // check if error is shown and remove it if conditions met
        if (event.target.value === "selectAnOption") return;
        const accountsValuesCopy = [
            ...accountValues
        ];
        if (event.target.value === "createNewAccount") accountsValuesCopy[index] = (0, $2qxEV._)((0, $9tqwB._)({}, accountsValuesCopy[index]), {
            createNewAccount: true
        });
        else {
            accountsValuesCopy[index] = JSON.parse(event.target.value); // writes the account object to accountsValues
            setAccountValues(accountsValuesCopy);
        }
    };
    const getOptions = (category)=>accounts.filter((a)=>a.category === category).map((account)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                value: JSON.stringify(account),
                children: account.name
            }, account.id));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "text-brandRed-500",
                id: "loginIncorrectError",
                children: formError
            }),
            selectedTemplate && selectedTemplate.accounts.map((account, index)=>// for each placeholder account from the template, render a dropdown
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "grid grid-cols-1 gap-x-8 border-b border-gray-900/10 py-5 md:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                    className: "text-base font-semibold leading-7 text-gray-900",
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($2507d117e7230fd1$exports)))(tDashboard(`singleCategory.${account.category}`))
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-1 text-sm leading-6 text-gray-600",
                                    children: account.role
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "sm:col-span-3",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "mt-8",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        id: "accountSelectionDropdown",
                                        value: JSON.stringify(accountValues[index]) || "selectAnOption",
                                        onChange: (event)=>handleAccountSelect(event, index),
                                        // eslint-disable-next-line max-len
                                        className: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "selectAnOption",
                                                children: tProjects("selectAnOption")
                                            }, "selectAnOption"),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "createNewAccount",
                                                children: `* ${tProjects("createNewAccount")}`
                                            }, "createNewAccount"),
                                            getOptions(account.category)
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }, index)),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "w-1/2 mt-8 grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        id: "project-details-apply-template-parameters-save",
                        onClick: handleSubmit,
                        // eslint-disable-next-line max-len
                        className: `inline-flex items-center justify-center w-full rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
          ${formError ? "bg-gray-300 cursor-not-allowed" : "bg-brandBlue-500 hover:bg-brandBlue-600"}}`,
                        children: [
                            "Save",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                className: `ml-3 h-5 w-4 animate-spin ${loading ? "inline-block" : "hidden"}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setTemplateDialog(undefined);
                        },
                        // eslint-disable-next-line max-len
                        className: "inline-flex items-center justify-center w-full rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-400 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}
$9c75dddb9ddf6b72$export$2e2bcd8739ae039.propTypes = {
    selectedTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    setTemplateDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


function $9dfba0c8f5fda393$export$2e2bcd8739ae039({ setTemplateDialog: setTemplateDialog, project: project }) {
    const [selectedTemplate, setSelectedTemplate] = (0, $7fPBF.useState)(undefined);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "absolute bg-opacity-90 bg-gray-300 z-[100] p-4 h-full w-full top-0 left-0",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            onSubmit: ()=>{},
            className: "bg-white rounded-md shadow-lg p-8 relative flex flex-col items-center justify-start h-[85vh]",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    onClick: (e)=>{
                        setTemplateDialog(false);
                    },
                    className: "absolute top-4 right-4 cursor-pointer z-10",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                        className: "w-6 h-6 text-gray-500 hover:text-gray-600"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "inline self-start",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            className: "text-3xl font-bold text-gray-900",
                            children: t("applyTemplate")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-2 text-base font-normal text-gray-500",
                            children: t("applyTemplateDescription")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-8 pr-4 overflow-y-auto scrollbar-thin scrollbar-track-rounded scrollbar-thumb-rounded scrollbar-track-gray-200 scrollbar-thumb-gray-400",
                    children: !selectedTemplate ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b9547158dd99c6fb$export$2e2bcd8739ae039), {
                        setSelectedTemplate: setSelectedTemplate
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9c75dddb9ddf6b72$export$2e2bcd8739ae039), {
                        selectedTemplate: selectedTemplate,
                        setTemplateDialog: setTemplateDialog,
                        project: project
                    })
                })
            ]
        })
    });
}
$9dfba0c8f5fda393$export$2e2bcd8739ae039.propTypes = {
    setTemplateDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $7c6fb07c9e265150$export$2e2bcd8739ae039({ collisions: collisions, setCollisionDialog: setCollisionDialog, project: project }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    console.info("collisions", collisions);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $7fPBF.useState)(null);
    const readyToSubmit = collisions.every((c)=>c.selected !== null);
    // receives the index of row to be updated
    function updateSelected(e, idx, updateIsolated) {
        // get collisions array, make a copy of it and update selected property of the row with index idx to true
        const updatedCollisions = [
            ...collisions
        ];
        updatedCollisions[idx].selected = updateIsolated ? "isolated" : "global";
        setCollisionDialog(updatedCollisions);
    }
    async function handleSubmit(e) {
        setErrorMessage(null);
        if (!readyToSubmit) setErrorMessage(t("allCollisionsMustBeResolved"));
        else {
            setLoading(true);
            // changing the project status first, as putQuotes will automatically remove all existing quotes which belong to the global scope if there is a new one for the same date-assetId combination
            await dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
                settings: (0, $2qxEV._)((0, $9tqwB._)({}, project.settings), {
                    isIsolated: false
                })
            })));
            const quotesToChange = collisions.map((item)=>item.selected === "isolated" ? item.isolatedQuote : item.globalQuote);
            await dispatch((0, $5fdae6729b4c77e7$export$94d4ced2a464cebd)({
                arrayOfQuotes: quotesToChange
            }));
            setLoading(false);
            setCollisionDialog(null);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "absolute bg-opacity-90 bg-gray-300 z-[100] p-4 h-full w-full top-0 left-0",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "p-4 flex flex-col items-center justify-center h-full",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "bg-white rounded-md shadow-lg p-8 space-y-8 relative",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "inline text-2xl font-bold text-gray-900",
                                children: t("collisions")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-500 prose mt-2 leading-snug",
                                children: t("collisionsDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "grid grid-cols-4 gap-4 text-left items-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-xs uppercase font-bold",
                                children: t("date")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-xs uppercase font-bold",
                                children: t("asset")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-xs uppercase font-bold",
                                children: t("thisProjectQuote")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-xs uppercase font-bold",
                                children: t("globalQuote")
                            }),
                            collisions.map((c, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(c.isolatedQuote.date).format("DD.MM.YYYY")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            children: c.isolatedQuote.assetId
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            onClick: (e)=>updateSelected(e, idx, true),
                                            className: `border border-gray-300 ${c.selected === "isolated" ? "bg-gray-100 font-bold" : "bg-white hover:bg-gray-50"} hover:bg-gray-50 rounded-md px-3 py-2`,
                                            children: c.isolatedQuote.quote.toLocaleString("de", {
                                                style: "currency",
                                                currency: c.isolatedQuote.currency
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            onClick: (e)=>updateSelected(e, idx, false),
                                            className: `border border-gray-300 ${c.selected === "global" ? "bg-gray-100 font-bold" : "bg-white hover:bg-gray-50"} hover:bg-gray-50 rounded-md px-3 py-2`,
                                            children: c.globalQuote.quote.toLocaleString("de", {
                                                style: "currency",
                                                currency: c.globalQuote.currency
                                            })
                                        })
                                    ]
                                }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            errorMessage && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-red-500 my-2",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex justify-start items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        id: "project-resolve-colisions-submit",
                                        "data-testid": "project-resolve-colisions-submit",
                                        type: "button",
                                        onClick: handleSubmit,
                                        className: "inline-flex items-center rounded-md border border-transparent bg-brandBlue-500 hover:bg-brandBlue-600 px-4 py-2 text-sm font-medium leading-4 text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                        children: loading === false ? t("save") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            id: "project-add-quote-spinner",
                                            className: "px-2",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "w-4 h-4 text-white animate-spin"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        id: "project-add-quote-cancel",
                                        type: "button",
                                        disabled: loading || !readyToSubmit,
                                        onClick: (e)=>{
                                            setCollisionDialog(null);
                                        },
                                        className: "inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                        children: t("cancel")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$7c6fb07c9e265150$export$2e2bcd8739ae039.propTypes = {
    collisions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    setCollisionDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $97d92bccde190f7f$export$2e2bcd8739ae039({ filteredItems: filteredItems, setFilteredItems: setFilteredItems, filterList: filterList }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "ml-auto",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
            as: "div",
            className: "space-y-1 relative",
            value: filteredItems,
            onChange: setFilteredItems,
            multiple: true,
            children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                            className: "inline-flex items-center rounded-md border border-gray-300 bg-white -mt-0.5 px-3 py-2 text-sm font-medium leading-4 text-gray-500 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4da3a00a55400621$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 inline-block text-gray-700"
                            })
                        }),
                        open && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                            static: true,
                            className: "absolute right-0 top-full inline-block z-10 mt-1 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            children: filterList.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                    value: item,
                                    className: ({ active: active })=>`${active ? "text-white bg-brandBlue-500" : "text-gray-900"} cursor-default select-none relative py-2 pl-10 pr-4`,
                                    children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: `${filteredItems.includes(item) ? "font-semibold" : "font-normal"} block truncate`,
                                                    children: t(item)
                                                }),
                                                selected && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: `${selected ? "font-semibold" : "font-normal"} ${active ? "text-white" : "text-brandBlue-500"} absolute inset-y-0 left-0 flex items-center pl-3`,
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                        className: "h-5 w-5",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                            clipRule: "evenodd"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                }, item))
                        })
                    ]
                })
        })
    });
}
$97d92bccde190f7f$export$2e2bcd8739ae039.propTypes = {
    filteredItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string).isRequired,
    setFilteredItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    filterList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string).isRequired
};


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ /* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");


function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $ca91ad18e54285de$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(arr);
}


function $130341d5473c4bb5$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
}


function $796c3d48dfd34a55$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $91ec1961173e898a$export$2e2bcd8739ae039(arr) {
    return (0, $ca91ad18e54285de$export$2e2bcd8739ae039)(arr) || (0, $130341d5473c4bb5$export$2e2bcd8739ae039)(arr) || (0, $4ca7aef5b7b26ccf$export$2e2bcd8739ae039)(arr) || (0, $796c3d48dfd34a55$export$2e2bcd8739ae039)();
}


function $74e249f0a1430824$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $e9005c7c032e54f6$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}



function $8927cf96e9e7e6b4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $1a6fc27d69850fe4$export$2e2bcd8739ae039(arr, i) {
    return (0, $74e249f0a1430824$export$2e2bcd8739ae039)(arr) || (0, $e9005c7c032e54f6$export$2e2bcd8739ae039)(arr, i) || (0, $4ca7aef5b7b26ccf$export$2e2bcd8739ae039)(arr, i) || (0, $8927cf96e9e7e6b4$export$2e2bcd8739ae039)();
}




var $7fPBF = parcelRequire("7fPBF");

function $fd0bde0711c2e412$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $fd0bde0711c2e412$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fd0bde0711c2e412$export$2e2bcd8739ae039(obj);
}


/* eslint-disable no-console */ var $779f0c3f24aead48$var$warned = {};
function $779f0c3f24aead48$export$491112666e282270(valid, message) {}
function $779f0c3f24aead48$export$a92e4c44d367d0af(valid, message) {}
function $779f0c3f24aead48$export$60eef1277fe463e4() {
    $779f0c3f24aead48$var$warned = {};
}
function $779f0c3f24aead48$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$779f0c3f24aead48$var$warned[message]) {
        method(false, message);
        $779f0c3f24aead48$var$warned[message] = true;
    }
}
function $779f0c3f24aead48$export$82934adf09101657(valid, message) {
    $779f0c3f24aead48$export$848feb93d8f32b9b($779f0c3f24aead48$export$491112666e282270, valid, message);
}
function $779f0c3f24aead48$export$89ff31684837bbbf(valid, message) {
    $779f0c3f24aead48$export$848feb93d8f32b9b($779f0c3f24aead48$export$a92e4c44d367d0af, valid, message);
}
var $779f0c3f24aead48$export$2e2bcd8739ae039 /* eslint-enable */  = $779f0c3f24aead48$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $ace43a6fe4ebbfd3$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $779f0c3f24aead48$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $fd0bde0711c2e412$export$2e2bcd8739ae039)(a) === "object" && (0, $fd0bde0711c2e412$export$2e2bcd8739ae039)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $ace43a6fe4ebbfd3$export$2e2bcd8739ae039 = $ace43a6fe4ebbfd3$var$isEqual;


function $0bf5ee07e14cb58f$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $9f9a7f1edb953259$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $93f9dfb9e9e4f6f2$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $69b08852c8c15dc8$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $93f9dfb9e9e4f6f2$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $93f9dfb9e9e4f6f2$export$2e2bcd8739ae039)(o, minLen);
}


function $ed5be3c219390e16$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $8434cea0ae8ff552$export$2e2bcd8739ae039(arr, i) {
    return (0, $0bf5ee07e14cb58f$export$2e2bcd8739ae039)(arr) || (0, $9f9a7f1edb953259$export$2e2bcd8739ae039)(arr, i) || (0, $69b08852c8c15dc8$export$2e2bcd8739ae039)(arr, i) || (0, $ed5be3c219390e16$export$2e2bcd8739ae039)();
}



var $7fPBF = parcelRequire("7fPBF");
function $9e68ab2147a8b124$export$2e2bcd8739ae039(callback) {
    var fnRef = $7fPBF.useRef();
    fnRef.current = callback;
    var memoFn = $7fPBF.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}



var $7fPBF = parcelRequire("7fPBF");
function $34a94f32b2fe8722$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $0bb5924a6075ae31$var$useLayoutEffect = (0, $34a94f32b2fe8722$export$2e2bcd8739ae039)() ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $0bb5924a6075ae31$export$2e2bcd8739ae039 = $0bb5924a6075ae31$var$useLayoutEffect;
var $0bb5924a6075ae31$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    var firstMountRef = $7fPBF.useRef(true);
    $0bb5924a6075ae31$var$useLayoutEffect(function() {
        if (!firstMountRef.current) return callback();
    }, deps);
    // We tell react that first mount has passed
    $0bb5924a6075ae31$var$useLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};




var $7fPBF = parcelRequire("7fPBF");
function $818b7cea22a07a68$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $7fPBF.useRef(false);
    var _React$useState = $7fPBF.useState(defaultValue), _React$useState2 = (0, $8434cea0ae8ff552$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $7fPBF.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $20b2e019ad0cb8c7$var$hasValue(value) {
    return value !== undefined;
}
function $20b2e019ad0cb8c7$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $818b7cea22a07a68$export$2e2bcd8739ae039)(function() {
        if ($20b2e019ad0cb8c7$var$hasValue(value)) return value;
        else if ($20b2e019ad0cb8c7$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $8434cea0ae8ff552$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $9e68ab2147a8b124$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $818b7cea22a07a68$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $8434cea0ae8ff552$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $0bb5924a6075ae31$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $0bb5924a6075ae31$export$9283e56bae2f7b0f)(function() {
        if (!$20b2e019ad0cb8c7$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $9e68ab2147a8b124$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}




function $f779b8b0ef990dda$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $cac6135e2032e075$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $cac6135e2032e075$var$KeyCode.F1 && keyCode <= $cac6135e2032e075$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $cac6135e2032e075$var$KeyCode.ALT:
            case $cac6135e2032e075$var$KeyCode.CAPS_LOCK:
            case $cac6135e2032e075$var$KeyCode.CONTEXT_MENU:
            case $cac6135e2032e075$var$KeyCode.CTRL:
            case $cac6135e2032e075$var$KeyCode.DOWN:
            case $cac6135e2032e075$var$KeyCode.END:
            case $cac6135e2032e075$var$KeyCode.ESC:
            case $cac6135e2032e075$var$KeyCode.HOME:
            case $cac6135e2032e075$var$KeyCode.INSERT:
            case $cac6135e2032e075$var$KeyCode.LEFT:
            case $cac6135e2032e075$var$KeyCode.MAC_FF_META:
            case $cac6135e2032e075$var$KeyCode.META:
            case $cac6135e2032e075$var$KeyCode.NUMLOCK:
            case $cac6135e2032e075$var$KeyCode.NUM_CENTER:
            case $cac6135e2032e075$var$KeyCode.PAGE_DOWN:
            case $cac6135e2032e075$var$KeyCode.PAGE_UP:
            case $cac6135e2032e075$var$KeyCode.PAUSE:
            case $cac6135e2032e075$var$KeyCode.PRINT_SCREEN:
            case $cac6135e2032e075$var$KeyCode.RIGHT:
            case $cac6135e2032e075$var$KeyCode.SHIFT:
            case $cac6135e2032e075$var$KeyCode.UP:
            case $cac6135e2032e075$var$KeyCode.WIN_KEY:
            case $cac6135e2032e075$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $cac6135e2032e075$var$KeyCode.ZERO && keyCode <= $cac6135e2032e075$var$KeyCode.NINE) return true;
        if (keyCode >= $cac6135e2032e075$var$KeyCode.NUM_ZERO && keyCode <= $cac6135e2032e075$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $cac6135e2032e075$var$KeyCode.A && keyCode <= $cac6135e2032e075$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $cac6135e2032e075$var$KeyCode.SPACE:
            case $cac6135e2032e075$var$KeyCode.QUESTION_MARK:
            case $cac6135e2032e075$var$KeyCode.NUM_PLUS:
            case $cac6135e2032e075$var$KeyCode.NUM_MINUS:
            case $cac6135e2032e075$var$KeyCode.NUM_PERIOD:
            case $cac6135e2032e075$var$KeyCode.NUM_DIVISION:
            case $cac6135e2032e075$var$KeyCode.SEMICOLON:
            case $cac6135e2032e075$var$KeyCode.DASH:
            case $cac6135e2032e075$var$KeyCode.EQUALS:
            case $cac6135e2032e075$var$KeyCode.COMMA:
            case $cac6135e2032e075$var$KeyCode.PERIOD:
            case $cac6135e2032e075$var$KeyCode.SLASH:
            case $cac6135e2032e075$var$KeyCode.APOSTROPHE:
            case $cac6135e2032e075$var$KeyCode.SINGLE_QUOTE:
            case $cac6135e2032e075$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $cac6135e2032e075$var$KeyCode.BACKSLASH:
            case $cac6135e2032e075$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $cac6135e2032e075$export$2e2bcd8739ae039 = $cac6135e2032e075$var$KeyCode;



var $7fPBF = parcelRequire("7fPBF");
var $001e3b1c7d4b600a$var$SliderContext = /*#__PURE__*/ $7fPBF.createContext({
    min: 0,
    max: 0,
    direction: "ltr",
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true
});
var $001e3b1c7d4b600a$export$2e2bcd8739ae039 = $001e3b1c7d4b600a$var$SliderContext;


function $2e99600404b4519e$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $2e99600404b4519e$export$a41628415415e6e(direction, value, min, max) {
    var offset = $2e99600404b4519e$export$622cea445a1c5b7d(value, min, max);
    var positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = "".concat(offset * 100, "%");
            positionStyle.transform = "translateX(50%)";
            break;
        case "btt":
            positionStyle.bottom = "".concat(offset * 100, "%");
            positionStyle.transform = "translateY(50%)";
            break;
        case "ttb":
            positionStyle.top = "".concat(offset * 100, "%");
            positionStyle.transform = "translateY(-50%)";
            break;
        default:
            positionStyle.left = "".concat(offset * 100, "%");
            positionStyle.transform = "translateX(-50%)";
            break;
    }
    return positionStyle;
}
function $2e99600404b4519e$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}


var $4eb078a39c2dd604$var$_excluded = [
    "prefixCls",
    "value",
    "valueIndex",
    "onStartMove",
    "style",
    "render",
    "dragging",
    "onOffsetChange"
];
var $4eb078a39c2dd604$var$Handle = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
    var _classNames, _getIndex;
    var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, style = props.style, render = props.render, dragging = props.dragging, onOffsetChange = props.onOffsetChange, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(props, $4eb078a39c2dd604$var$_excluded);
    var _React$useContext = $7fPBF.useContext((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, keyboard = _React$useContext.keyboard, range = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle;
    var handlePrefixCls = "".concat(prefixCls, "-handle");
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled) onStartMove(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    var onKeyDown = function onKeyDown(e) {
        if (!disabled && keyboard) {
            var offset = null;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).LEFT:
                    offset = direction === "ltr" || direction === "btt" ? -1 : 1;
                    break;
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === "ltr" || direction === "btt" ? 1 : -1;
                    break;
                // Up is plus
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).UP:
                    offset = direction !== "ttb" ? 1 : -1;
                    break;
                // Down is minus
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== "ttb" ? -1 : 1;
                    break;
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).HOME:
                    offset = "min";
                    break;
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).END:
                    offset = "max";
                    break;
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $cac6135e2032e075$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    // ============================ Offset ============================
    var positionStyle = (0, $2e99600404b4519e$export$a41628415415e6e)(direction, value, min, max);
    // ============================ Render ============================
    var handleNode = /*#__PURE__*/ $7fPBF.createElement("div", (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(handlePrefixCls, (_classNames = {}, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), range), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, "".concat(handlePrefixCls, "-dragging"), dragging), _classNames)),
        style: (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onKeyDown: onKeyDown,
        tabIndex: disabled ? null : (0, $2e99600404b4519e$export$ddfa24987dade61b)(tabIndex, valueIndex),
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": disabled,
        "aria-label": (0, $2e99600404b4519e$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
        "aria-labelledby": (0, $2e99600404b4519e$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
        "aria-valuetext": (_getIndex = (0, $2e99600404b4519e$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value)
    }, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging
    });
    return handleNode;
});
var $4eb078a39c2dd604$export$2e2bcd8739ae039 = $4eb078a39c2dd604$var$Handle;



var $81ece9d03e20917d$var$_excluded = [
    "prefixCls",
    "style",
    "onStartMove",
    "onOffsetChange",
    "values",
    "handleRender",
    "draggingIndex"
];
var $81ece9d03e20917d$var$Handles = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, draggingIndex = props.draggingIndex, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(props, $81ece9d03e20917d$var$_excluded);
    var handlesRef = $7fPBF.useRef({});
    $7fPBF.useImperativeHandle(ref, function() {
        return {
            focus: function focus(index) {
                var _handlesRef$current$i;
                (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
            }
        };
    });
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, values.map(function(value, index) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $4eb078a39c2dd604$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            ref: function ref(node) {
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: draggingIndex === index,
            prefixCls: prefixCls,
            style: (0, $2e99600404b4519e$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index,
            onStartMove: onStartMove,
            onOffsetChange: onOffsetChange,
            render: handleRender
        }, restProps));
    }));
});
var $81ece9d03e20917d$export$2e2bcd8739ae039 = $81ece9d03e20917d$var$Handles;





var $7fPBF = parcelRequire("7fPBF");
function $8967264a9a7115d1$var$getPosition(e) {
    var obj = "touches" in e ? e.touches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $8967264a9a7115d1$export$2e2bcd8739ae039(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues) {
    var _React$useState = $7fPBF.useState(null), _React$useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
    var _React$useState3 = $7fPBF.useState(-1), _React$useState4 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
    var _React$useState5 = $7fPBF.useState(rawValues), _React$useState6 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_React$useState5, 2), cacheValues = _React$useState6[0], setCacheValues = _React$useState6[1];
    var _React$useState7 = $7fPBF.useState(rawValues), _React$useState8 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_React$useState7, 2), originValues = _React$useState8[0], setOriginValues = _React$useState8[1];
    var mouseMoveEventRef = $7fPBF.useRef(null);
    var mouseUpEventRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(function() {
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    $7fPBF.useEffect(function() {
        return function() {
            document.removeEventListener("mousemove", mouseMoveEventRef.current);
            document.removeEventListener("mouseup", mouseUpEventRef.current);
            document.removeEventListener("touchmove", mouseMoveEventRef.current);
            document.removeEventListener("touchend", mouseUpEventRef.current);
        };
    }, []);
    var flushValues = function flushValues(nextValues, nextValue) {
        // Perf: Only update state when value changed
        if (cacheValues.some(function(val, i) {
            return val !== nextValues[i];
        })) {
            if (nextValue !== undefined) setDraggingValue(nextValue);
            setCacheValues(nextValues);
            triggerChange(nextValues);
        }
    };
    var updateCacheValue = function updateCacheValue(valueIndex, offsetPercent) {
        // Basic point offset
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            var startValue = originValues[0];
            var endValue = originValues[originValues.length - 1];
            var maxStartOffset = min - startValue;
            var maxEndOffset = max - endValue;
            // Get valid offset
            var offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            var formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            var cloneCacheValues = originValues.map(function(val) {
                return val + offset;
            });
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            var offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            var cloneValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(cacheValues);
            cloneValues[valueIndex] = originValues[valueIndex];
            var next = offsetValues(cloneValues, offsetDist, valueIndex, "dist");
            flushValues(next.values, next.value);
        }
    };
    // Resolve closure
    var updateCacheValueRef = $7fPBF.useRef(updateCacheValue);
    updateCacheValueRef.current = updateCacheValue;
    var onStartMove = function onStartMove(e, valueIndex) {
        e.stopPropagation();
        var originValue = rawValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(rawValues);
        var _getPosition = $8967264a9a7115d1$var$getPosition(e), startX = _getPosition.pageX, startY = _getPosition.pageY;
        // Moving
        var onMouseMove = function onMouseMove(event) {
            event.preventDefault();
            var _getPosition2 = $8967264a9a7115d1$var$getPosition(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
            var offsetX = moveX - startX;
            var offsetY = moveY - startY;
            var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
            var offSetPercent;
            switch(direction){
                case "btt":
                    offSetPercent = -offsetY / height;
                    break;
                case "ttb":
                    offSetPercent = offsetY / height;
                    break;
                case "rtl":
                    offSetPercent = -offsetX / width;
                    break;
                default:
                    offSetPercent = offsetX / width;
            }
            updateCacheValueRef.current(valueIndex, offSetPercent);
        };
        // End
        var onMouseUp = function onMouseUp(event) {
            event.preventDefault();
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("touchend", onMouseUp);
            document.removeEventListener("touchmove", onMouseMove);
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            setDraggingIndex(-1);
            finishChange();
        };
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("touchend", onMouseUp);
        document.addEventListener("touchmove", onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
    };
    // Only return cache value when it mapping with rawValues
    var returnValues = $7fPBF.useMemo(function() {
        var sourceValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(rawValues).sort(function(a, b) {
            return a - b;
        });
        var targetValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(cacheValues).sort(function(a, b) {
            return a - b;
        });
        return sourceValues.every(function(val, index) {
            return val === targetValues[index];
        }) ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues
    ]);
    return [
        draggingIndex,
        draggingValue,
        returnValues,
        onStartMove
    ];
}




var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



function $79cb1db47feea53b$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, start = props.start, end = props.end, index = props.index, onStartMove = props.onStartMove;
    var _React$useContext = $7fPBF.useContext((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039)), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range = _React$useContext.range;
    var trackPrefixCls = "".concat(prefixCls, "-track");
    var offsetStart = (0, $2e99600404b4519e$export$622cea445a1c5b7d)(start, min, max);
    var offsetEnd = (0, $2e99600404b4519e$export$622cea445a1c5b7d)(end, min, max);
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    var positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case "btt":
            positionStyle.bottom = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case "ttb":
            positionStyle.top = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        default:
            positionStyle.left = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
    }
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(trackPrefixCls, range && "".concat(trackPrefixCls, "-").concat(index + 1)),
        style: (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
}



function $1174be114593d334$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
    var _React$useContext = $7fPBF.useContext((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039)), included = _React$useContext.included, range = _React$useContext.range, min = _React$useContext.min;
    var trackList = $7fPBF.useMemo(function() {
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
            var endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        var list = [];
        for(var i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    return included ? trackList.map(function(_ref, index) {
        var start = _ref.start, end = _ref.end;
        return /*#__PURE__*/ $7fPBF.createElement((0, $79cb1db47feea53b$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: (0, $2e99600404b4519e$export$ddfa24987dade61b)(style, index),
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        });
    }) : null;
}



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");



function $6552798fb3e0a812$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, style = props.style, children = props.children, value = props.value, _onClick = props.onClick;
    var _React$useContext = $7fPBF.useContext((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
    var textCls = "".concat(prefixCls, "-text");
    // ============================ Offset ============================
    var positionStyle = (0, $2e99600404b4519e$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(textCls, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
        style: (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
        },
        onClick: function onClick() {
            _onClick(value);
        }
    }, children);
}


function $10e4e63d19b67403$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
    var markPrefixCls = "".concat(prefixCls, "-mark");
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: markPrefixCls
    }, marks.map(function(_ref) {
        var value = _ref.value, style = _ref.style, label = _ref.label;
        return /*#__PURE__*/ $7fPBF.createElement((0, $6552798fb3e0a812$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label);
    }));
}



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");



function $6bf657cd839c2de2$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, value = props.value, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $7fPBF.useContext((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
    var dotClassName = "".concat(prefixCls, "-dot");
    var active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    var mergedStyle = (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, (0, $2e99600404b4519e$export$a41628415415e6e)(direction, value, min, max)), typeof style === "function" ? style(value) : style);
    if (active) mergedStyle = (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, mergedStyle), typeof activeStyle === "function" ? activeStyle(value) : activeStyle);
    return /*#__PURE__*/ $7fPBF.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(dotClassName, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)({}, "".concat(dotClassName, "-active"), active)),
        style: mergedStyle
    });
}


function $e9e459b4b8498216$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $7fPBF.useContext((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
    var stepDots = $7fPBF.useMemo(function() {
        var dotSet = new Set();
        // Add marks
        marks.forEach(function(mark) {
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            var current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, stepDots.map(function(dotValue) {
        return /*#__PURE__*/ $7fPBF.createElement((0, $6bf657cd839c2de2$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        });
    }));
}




var $7fPBF = parcelRequire("7fPBF");
function $2ab03ea9fc8a2a47$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable) {
    var formatRangeValue = $7fPBF.useCallback(function(val) {
        var formatNextValue = isFinite(val) ? val : min;
        formatNextValue = Math.min(max, val);
        formatNextValue = Math.max(min, formatNextValue);
        return formatNextValue;
    }, [
        min,
        max
    ]);
    var formatStepValue = $7fPBF.useCallback(function(val) {
        if (step !== null) {
            var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            var getDecimal = function getDecimal(num) {
                return (String(num).split(".")[1] || "").length;
            };
            var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            var fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    var formatValue = $7fPBF.useCallback(function(val) {
        var formatNextValue = formatRangeValue(val);
        // List align values
        var alignValues = markList.map(function(mark) {
            return mark.value;
        });
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        var closeValue = alignValues[0];
        var closeDist = max - min;
        alignValues.forEach(function(alignValue) {
            var dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    var offsetValue = function offsetValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        if (typeof offset === "number") {
            var nextValue;
            var originValue = values[valueIndex];
            // Only used for `dist` mode
            var targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            var potentialValues = [];
            markList.forEach(function(mark) {
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            var sign = offset > 0 ? 1 : -1;
            if (mode === "unit") potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter(function(val) {
                return val !== null;
            })// Remove reverse value
            .filter(function(val) {
                return offset < 0 ? val <= originValue : val >= originValue;
            });
            if (mode === "unit") // `unit` mode can not contain itself
            potentialValues = potentialValues.filter(function(val) {
                return val !== originValue;
            });
            var compareValue = mode === "unit" ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            var valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach(function(potentialValue) {
                var dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === "dist") return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                var cloneValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(values);
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === "min") return min;
        else if (offset === "max") return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        var originValue = values[valueIndex];
        var nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    var needPush = function needPush(dist) {
        return pushable === null && dist === 0 || typeof pushable === "number" && dist < pushable;
    };
    // Values
    var offsetValues = function offsetValues(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        var nextValues = values.map(formatValue);
        var originValue = nextValues[valueIndex];
        var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            var pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === "number" || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(var i = valueIndex + 1; i < nextValues.length; i += 1){
                var changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed){
                    var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
                    nextValues[i] = _offsetChangedValue.value;
                    changed = _offsetChangedValue.changed;
                }
            }
            // Start values
            for(var _i = valueIndex; _i > 0; _i -= 1){
                var _changed = true;
                while(needPush(nextValues[_i] - nextValues[_i - 1]) && _changed){
                    var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
                    nextValues[_i - 1] = _offsetChangedValue2.value;
                    _changed = _offsetChangedValue2.changed;
                }
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1){
                var _changed2 = true;
                while(needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2){
                    var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
                    nextValues[_i2 - 1] = _offsetChangedValue3.value;
                    _changed2 = _offsetChangedValue3.changed;
                }
            }
            // Start to End
            for(var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1){
                var _changed3 = true;
                while(needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3){
                    var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
                    nextValues[_i3 + 1] = _offsetChangedValue4.value;
                    _changed3 = _offsetChangedValue4.changed;
                }
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}



var $91a1ab424e1574b8$var$Slider = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-slider" : _props$prefixCls, className = props.className, style = props.style, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue = props.defaultValue, range = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, draggableTrack = props.draggableTrack, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
    var handlesRef = $7fPBF.useRef();
    var containerRef = $7fPBF.useRef();
    var direction = $7fPBF.useMemo(function() {
        if (vertical) return reverse ? "ttb" : "btt";
        return reverse ? "rtl" : "ltr";
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    var mergedMin = $7fPBF.useMemo(function() {
        return isFinite(min) ? min : 0;
    }, [
        min
    ]);
    var mergedMax = $7fPBF.useMemo(function() {
        return isFinite(max) ? max : 100;
    }, [
        max
    ]);
    // ============================= Step =============================
    var mergedStep = $7fPBF.useMemo(function() {
        return step !== null && step <= 0 ? 1 : step;
    }, [
        step
    ]);
    // ============================= Push =============================
    var mergedPush = $7fPBF.useMemo(function() {
        if (pushable === true) return mergedStep;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    var markList = $7fPBF.useMemo(function() {
        var keys = Object.keys(marks || {});
        return keys.map(function(key) {
            var mark = marks[key];
            var markObj = {
                value: Number(key)
            };
            if (mark && (0, $505ebcb184373782$export$2e2bcd8739ae039)(mark) === "object" && !/*#__PURE__*/ $7fPBF.isValidElement(mark) && ("label" in mark || "style" in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(function(_ref) {
            var label = _ref.label;
            return label || typeof label === "number";
        }).sort(function(a, b) {
            return a.value - b.value;
        });
    }, [
        marks
    ]);
    // ============================ Format ============================
    var _useOffset = (0, $2ab03ea9fc8a2a47$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useOffset, 2), formatValue = _useOffset2[0], offsetValues = _useOffset2[1];
    // ============================ Values ============================
    var _useMergedState = (0, $20b2e019ad0cb8c7$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var rawValues = $7fPBF.useMemo(function() {
        var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        var _valueList = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
        var returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (range) {
            returnValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(valueList);
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                var pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount){
                    var _returnValues;
                    returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
                }
            }
            returnValues.sort(function(a, b) {
                return a - b;
            });
        }
        // Align in range
        returnValues.forEach(function(val, index) {
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        range,
        mergedMin,
        count,
        formatValue
    ]);
    // =========================== onChange ===========================
    var rawValuesRef = $7fPBF.useRef(rawValues);
    rawValuesRef.current = rawValues;
    var getTriggerValue = function getTriggerValue(triggerValues) {
        return range ? triggerValues : triggerValues[0];
    };
    var triggerChange = function triggerChange(nextValues) {
        // Order first
        var cloneNextValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(nextValues).sort(function(a, b) {
            return a - b;
        });
        // Trigger event if needed
        if (onChange && !(0, $ace43a6fe4ebbfd3$export$2e2bcd8739ae039)(cloneNextValues, rawValuesRef.current, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    };
    var changeToCloseValue = function changeToCloseValue(newValue) {
        if (!disabled) {
            var valueIndex = 0;
            var valueDist = mergedMax - mergedMin;
            rawValues.forEach(function(val, index) {
                var dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
            });
            // Create new values
            var cloneNextValues = (0, $91ec1961173e898a$export$2e2bcd8739ae039)(rawValues);
            cloneNextValues[valueIndex] = newValue;
            // Fill value to match default 2
            if (range && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
            triggerChange(cloneNextValues);
            onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(cloneNextValues));
        }
    };
    // ============================ Click =============================
    var onSliderMouseDown = function onSliderMouseDown(e) {
        e.preventDefault();
        var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right = _containerRef$current.right;
        var clientX = e.clientX, clientY = e.clientY;
        var percent;
        switch(direction){
            case "btt":
                percent = (bottom - clientY) / height;
                break;
            case "ttb":
                percent = (clientY - top) / height;
                break;
            case "rtl":
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        var nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue));
    };
    // =========================== Keyboard ===========================
    var _React$useState = $7fPBF.useState(null), _React$useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
    var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
        if (!disabled) {
            var next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
            triggerChange(next.values);
            onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(next.values));
            setKeyboardValue(next.value);
        }
    };
    $7fPBF.useEffect(function() {
        if (keyboardValue !== null) {
            var valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    var mergedDraggableTrack = $7fPBF.useMemo(function() {
        if (draggableTrack && mergedStep === null) return false;
        return draggableTrack;
    }, [
        draggableTrack,
        mergedStep
    ]);
    var finishChange = function finishChange() {
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(getTriggerValue(rawValuesRef.current));
    };
    var _useDrag = (0, $8967264a9a7115d1$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues), _useDrag2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useDrag, 4), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], cacheValues = _useDrag2[2], onStartDrag = _useDrag2[3];
    var onStartMove = function onStartMove(e, valueIndex) {
        onStartDrag(e, valueIndex);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValuesRef.current));
    };
    // Auto focus for updated handle
    var dragging = draggingIndex !== -1;
    $7fPBF.useEffect(function() {
        if (!dragging) {
            var valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    var sortedCacheValues = $7fPBF.useMemo(function() {
        return (0, $91ec1961173e898a$export$2e2bcd8739ae039)(cacheValues).sort(function(a, b) {
            return a - b;
        });
    }, [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    var _React$useMemo = $7fPBF.useMemo(function() {
        if (!range) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        range,
        mergedMin
    ]), _React$useMemo2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1];
    // ============================= Refs =============================
    $7fPBF.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                handlesRef.current.focus(0);
            },
            blur: function blur() {
                var _document = document, activeElement = _document.activeElement;
                if (containerRef.current.contains(activeElement)) activeElement === null || activeElement === void 0 || activeElement.blur();
            }
        };
    });
    // ========================== Auto Focus ==========================
    $7fPBF.useEffect(function() {
        if (autoFocus) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    var context = $7fPBF.useMemo(function() {
        return {
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: range,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle
        };
    }, [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        range,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaValueTextFormatterForHandle
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $7fPBF.createElement((0, $001e3b1c7d4b600a$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(prefixCls, className, (_classNames = {}, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-horizontal"), !vertical), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), markList.length), _classNames)),
        style: style,
        onMouseDown: onSliderMouseDown
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: "".concat(prefixCls, "-rail"),
        style: railStyle
    }), /*#__PURE__*/ $7fPBF.createElement((0, $1174be114593d334$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: sortedCacheValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : null
    }), /*#__PURE__*/ $7fPBF.createElement((0, $e9e459b4b8498216$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $7fPBF.createElement((0, $81ece9d03e20917d$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender
    }), /*#__PURE__*/ $7fPBF.createElement((0, $10e4e63d19b67403$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
var $91a1ab424e1574b8$export$2e2bcd8739ae039 = $91a1ab424e1574b8$var$Slider;


var $3475369afda2fcc5$export$2e2bcd8739ae039 = (0, $91a1ab424e1574b8$export$2e2bcd8739ae039);


var $cdb391a262b13a19$exports = {};
"use strict";
Object.defineProperty($cdb391a262b13a19$exports, "__esModule", {
    value: true
});
$cdb391a262b13a19$exports.default = void 0;
var $cdb391a262b13a19$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $cdb391a262b13a19$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $cdb391a262b13a19$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $cdb391a262b13a19$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $cdb391a262b13a19$var$rafUUID = 0;
var $cdb391a262b13a19$var$rafIds = new Map();
function $cdb391a262b13a19$var$cleanup(id) {
    $cdb391a262b13a19$var$rafIds.delete(id);
}
var $cdb391a262b13a19$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $cdb391a262b13a19$var$rafUUID += 1;
    var id = $cdb391a262b13a19$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $cdb391a262b13a19$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $cdb391a262b13a19$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $cdb391a262b13a19$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$cdb391a262b13a19$var$wrapperRaf.cancel = function(id) {
    var realId = $cdb391a262b13a19$var$rafIds.get(id);
    $cdb391a262b13a19$var$cleanup(realId);
    return $cdb391a262b13a19$var$caf(realId);
};
var $cdb391a262b13a19$var$_default = $cdb391a262b13a19$var$wrapperRaf;
$cdb391a262b13a19$exports.default = $cdb391a262b13a19$var$_default;





function $5ddc7f73b371f88e$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $5ddc7f73b371f88e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5ddc7f73b371f88e$export$2e2bcd8739ae039(obj);
}



function $a87a33b93501d06e$export$2e2bcd8739ae039(input, hint) {
    if ((0, $5ddc7f73b371f88e$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $5ddc7f73b371f88e$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $1b0acc56ba64b186$export$2e2bcd8739ae039(arg) {
    var key = (0, $a87a33b93501d06e$export$2e2bcd8739ae039)(arg, "string");
    return (0, $5ddc7f73b371f88e$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $3e9e2d9c49f18f14$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $1b0acc56ba64b186$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a74bac22062f3ee5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a74bac22062f3ee5$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a74bac22062f3ee5$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $3e9e2d9c49f18f14$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a74bac22062f3ee5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function $1f1b0417ccb845ec$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $324afd419f345a3b$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $7a75cf7da574b553$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $ee45a5db0b7a5691$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7a75cf7da574b553$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7a75cf7da574b553$export$2e2bcd8739ae039)(o, minLen);
}


function $5b5abbc7e0d0b39d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $acfd2f96473b3e3e$export$2e2bcd8739ae039(arr, i) {
    return (0, $1f1b0417ccb845ec$export$2e2bcd8739ae039)(arr) || (0, $324afd419f345a3b$export$2e2bcd8739ae039)(arr, i) || (0, $ee45a5db0b7a5691$export$2e2bcd8739ae039)(arr, i) || (0, $5b5abbc7e0d0b39d$export$2e2bcd8739ae039)();
}


function $689346849297c7a4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $04ac828d8ca8a401$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $689346849297c7a4$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


function $e9cda18d9c827bbf$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $07c5b14b52004c08$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $bad39dc53054b072$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d32af01906a358f8$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $bad39dc53054b072$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $bad39dc53054b072$export$2e2bcd8739ae039)(o, minLen);
}


function $377a1dc61d3130cd$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $ed4661b4eeb32793$export$2e2bcd8739ae039(arr, i) {
    return (0, $e9cda18d9c827bbf$export$2e2bcd8739ae039)(arr) || (0, $07c5b14b52004c08$export$2e2bcd8739ae039)(arr, i) || (0, $d32af01906a358f8$export$2e2bcd8739ae039)(arr, i) || (0, $377a1dc61d3130cd$export$2e2bcd8739ae039)();
}



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $bcfb5d584f112df7$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


function $4338e3a4aae73766$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $4338e3a4aae73766$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4338e3a4aae73766$export$2e2bcd8739ae039(obj);
}




var $7fPBF = parcelRequire("7fPBF");
function $fa1894a6db70eafa$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $7fPBF.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


function $5a959b2e5cf00c5d$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $4338e3a4aae73766$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $5a959b2e5cf00c5d$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5a959b2e5cf00c5d$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $5a959b2e5cf00c5d$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $fa1894a6db70eafa$export$2e2bcd8739ae039)(function() {
        return $5a959b2e5cf00c5d$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length === next.length && prev.every(function(ref, i) {
            return ref === next[i];
        });
    });
}
function $5a959b2e5cf00c5d$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $dddaf6f84c717660$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
} /* eslint-enable */ 



var $7fPBF = parcelRequire("7fPBF");
var $63e5affd70ab9fca$var$OrderContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $63e5affd70ab9fca$export$2e2bcd8739ae039 = $63e5affd70ab9fca$var$OrderContext;



function $46cb3198801a9f6d$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $bad39dc53054b072$export$2e2bcd8739ae039)(arr);
}


function $00e356080d9a169b$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $534734f93ee0dde6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $53d2e14e0ce5c7e9$export$2e2bcd8739ae039(arr) {
    return (0, $46cb3198801a9f6d$export$2e2bcd8739ae039)(arr) || (0, $00e356080d9a169b$export$2e2bcd8739ae039)(arr) || (0, $d32af01906a358f8$export$2e2bcd8739ae039)(arr) || (0, $534734f93ee0dde6$export$2e2bcd8739ae039)();
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $8b730e5e20e35f24$var$useLayoutEffect = (0, $bcfb5d584f112df7$export$2e2bcd8739ae039)() ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $8b730e5e20e35f24$export$2e2bcd8739ae039 = $8b730e5e20e35f24$var$useLayoutEffect;
var $8b730e5e20e35f24$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    var firstMountRef = $7fPBF.useRef(true);
    $8b730e5e20e35f24$var$useLayoutEffect(function() {
        if (!firstMountRef.current) return callback();
    }, deps);
    // We tell react that first mount has passed
    $8b730e5e20e35f24$var$useLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};




var $f8c4fded8c9617d0$var$EMPTY_LIST = [];
function $f8c4fded8c9617d0$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $7fPBF.useState(function() {
        if (!(0, $bcfb5d584f112df7$export$2e2bcd8739ae039)()) return null;
        var defaultEle = document.createElement("div");
        return defaultEle;
    }), _React$useState2 = (0, $ed4661b4eeb32793$export$2e2bcd8739ae039)(_React$useState, 1), ele = _React$useState2[0]; // ========================== Order ==========================
    var appendedRef = $7fPBF.useRef(false);
    var queueCreate = $7fPBF.useContext((0, $63e5affd70ab9fca$export$2e2bcd8739ae039));
    var _React$useState3 = $7fPBF.useState($f8c4fded8c9617d0$var$EMPTY_LIST), _React$useState4 = (0, $ed4661b4eeb32793$export$2e2bcd8739ae039)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $53d2e14e0ce5c7e9$export$2e2bcd8739ae039)(origin));
            return newQueue;
        });
    }); // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $8b730e5e20e35f24$export$2e2bcd8739ae039)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $8b730e5e20e35f24$export$2e2bcd8739ae039)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($f8c4fded8c9617d0$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}




var $7fPBF = parcelRequire("7fPBF");

function $1ebe01b89442c4c4$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $c63bb1198f28656b$var$APPEND_ORDER = "data-rc-order";
var $c63bb1198f28656b$var$MARK_KEY = "rc-util-key";
var $c63bb1198f28656b$var$containerCache = new Map();
function $c63bb1198f28656b$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith("data-") ? mark : "data-".concat(mark);
    return $c63bb1198f28656b$var$MARK_KEY;
}
function $c63bb1198f28656b$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector("head");
    return head || document.body;
}
function $c63bb1198f28656b$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $c63bb1198f28656b$var$findStyles(container) {
    return Array.from(($c63bb1198f28656b$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === "STYLE";
    });
}
function $c63bb1198f28656b$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $bcfb5d584f112df7$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend;
    var styleNode = document.createElement("style");
    styleNode.setAttribute($c63bb1198f28656b$var$APPEND_ORDER, $c63bb1198f28656b$var$getOrder(prepend));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $c63bb1198f28656b$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (prepend === "queue") {
            var existStyle = $c63bb1198f28656b$var$findStyles(container).filter(function(node) {
                return [
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($c63bb1198f28656b$var$APPEND_ORDER));
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $c63bb1198f28656b$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $c63bb1198f28656b$var$getContainer(option);
    return $c63bb1198f28656b$var$findStyles(container).find(function(node) {
        return node.getAttribute($c63bb1198f28656b$var$getMark(option)) === key;
    });
}
function $c63bb1198f28656b$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $c63bb1198f28656b$var$findExistNode(key, option);
    if (existNode) {
        var container = $c63bb1198f28656b$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $c63bb1198f28656b$var$syncRealContainer(container, option) {
    var cachedRealContainer = $c63bb1198f28656b$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $1ebe01b89442c4c4$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $c63bb1198f28656b$export$1ab5838465dbd10a("", option);
        var parentNode = placeholderStyle.parentNode;
        $c63bb1198f28656b$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $c63bb1198f28656b$export$f80df667f2f5a272() {
    $c63bb1198f28656b$var$containerCache.clear();
}
function $c63bb1198f28656b$export$4d99a2890bb989f0(css, key) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $c63bb1198f28656b$var$getContainer(option);
    // Sync real parent
    $c63bb1198f28656b$var$syncRealContainer(container, option);
    var existNode = $c63bb1198f28656b$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $c63bb1198f28656b$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($c63bb1198f28656b$var$getMark(option), key);
    return newNode;
}



/* eslint-disable no-param-reassign */ var $2957a84ef0f77aca$var$cached;
function $2957a84ef0f77aca$export$2e2bcd8739ae039(fresh) {
    if (typeof document === "undefined") return 0;
    if (fresh || $2957a84ef0f77aca$var$cached === undefined) {
        var inner = document.createElement("div");
        inner.style.width = "100%";
        inner.style.height = "200px";
        var outer = document.createElement("div");
        var outerStyle = outer.style;
        outerStyle.position = "absolute";
        outerStyle.top = "0";
        outerStyle.left = "0";
        outerStyle.pointerEvents = "none";
        outerStyle.visibility = "hidden";
        outerStyle.width = "200px";
        outerStyle.height = "150px";
        outerStyle.overflow = "hidden";
        outer.appendChild(inner);
        document.body.appendChild(outer);
        var widthContained = inner.offsetWidth;
        outer.style.overflow = "scroll";
        var widthScroll = inner.offsetWidth;
        if (widthContained === widthScroll) widthScroll = outer.clientWidth;
        document.body.removeChild(outer);
        $2957a84ef0f77aca$var$cached = widthContained - widthScroll;
    }
    return $2957a84ef0f77aca$var$cached;
}
function $2957a84ef0f77aca$var$ensureSize(str) {
    var match = str.match(/^(.*)px$/);
    var value = Number(match === null || match === void 0 ? void 0 : match[1]);
    return Number.isNaN(value) ? $2957a84ef0f77aca$export$2e2bcd8739ae039() : value;
}
function $2957a84ef0f77aca$export$4f3ef2310365b56a(target) {
    if (typeof document === "undefined" || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    var _getComputedStyle = getComputedStyle(target, "::-webkit-scrollbar"), width = _getComputedStyle.width, height = _getComputedStyle.height;
    return {
        width: $2957a84ef0f77aca$var$ensureSize(width),
        height: $2957a84ef0f77aca$var$ensureSize(height)
    };
}


/**
 * Test usage export. Do not use in your production
 */ function $f7e7afc30a0ff026$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $6b84ecfed14f1730$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $6b84ecfed14f1730$var$uuid = 0;
function $6b84ecfed14f1730$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $7fPBF.useState(function() {
        $6b84ecfed14f1730$var$uuid += 1;
        return "".concat($6b84ecfed14f1730$var$UNIQUE_ID, "_").concat($6b84ecfed14f1730$var$uuid);
    }), _React$useState2 = (0, $ed4661b4eeb32793$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    (0, $8b730e5e20e35f24$export$2e2bcd8739ae039)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $2957a84ef0f77aca$export$2e2bcd8739ae039)();
            var isOverflow = (0, $f7e7afc30a0ff026$export$31b5c8f1131a3a52)();
            (0, $c63bb1198f28656b$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
        } else (0, $c63bb1198f28656b$export$2232e336aecaa80a)(id);
        return function() {
            (0, $c63bb1198f28656b$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $71f3f4221de90dc4$export$18c8ad048e32c7d5 = false;
function $71f3f4221de90dc4$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === "boolean") $71f3f4221de90dc4$export$18c8ad048e32c7d5 = nextInline;
    return $71f3f4221de90dc4$export$18c8ad048e32c7d5;
}


var $224c5d95f6e528f6$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $bcfb5d584f112df7$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === "string") return document.querySelector(getContainer);
    if (typeof getContainer === "function") return getContainer();
    return getContainer;
};
var $224c5d95f6e528f6$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $7fPBF.useState(open), _React$useState2 = (0, $ed4661b4eeb32793$export$2e2bcd8739ae039)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open; // ====================== Should Render ======================
    $7fPBF.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]); // ======================== Container ========================
    var _React$useState3 = $7fPBF.useState(function() {
        return $224c5d95f6e528f6$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $ed4661b4eeb32793$export$2e2bcd8739ae039)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $7fPBF.useEffect(function() {
        var customizeContainer = $224c5d95f6e528f6$var$getPortalContainer(getContainer); // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $f8c4fded8c9617d0$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $ed4661b4eeb32793$export$2e2bcd8739ae039)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer; // ========================= Locker ==========================
    (0, $6b84ecfed14f1730$export$2e2bcd8739ae039)(autoLock && open && (0, $bcfb5d584f112df7$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body)); // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $5a959b2e5cf00c5d$export$c1cec34af06bcf7)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $5a959b2e5cf00c5d$export$1d1c999670a1285d)(childRef, ref); // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $bcfb5d584f112df7$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
     // Render inline
    var renderInline = mergedContainer === false || (0, $71f3f4221de90dc4$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $7fPBF.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $7fPBF.createElement((0, $63e5affd70ab9fca$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $fw0lo.createPortal)(reffedChildren, mergedContainer));
});
var $224c5d95f6e528f6$export$2e2bcd8739ae039 = $224c5d95f6e528f6$var$Portal;



var $92a36ca56e167eae$export$2e2bcd8739ae039 = (0, $224c5d95f6e528f6$export$2e2bcd8739ae039);


var $ef9a2ae8e46177c5$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $ef9a2ae8e46177c5$exports) {
        classNames.default = classNames;
        $ef9a2ae8e46177c5$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


function $016a6d95971f5ff5$export$2e2bcd8739ae039() {
    $016a6d95971f5ff5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $016a6d95971f5ff5$export$2e2bcd8739ae039.apply(this, arguments);
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $0b734515a1985ae4$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($0b734515a1985ae4$export$2e2bcd8739ae039(child));
        else if ((0, $dddaf6f84c717660$exports.isFragment)(child) && child.props) ret = ret.concat($0b734515a1985ae4$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


/* eslint-disable no-console */ var $35ea55d96b95b899$var$warned = {};
function $35ea55d96b95b899$export$491112666e282270(valid, message) {}
function $35ea55d96b95b899$export$a92e4c44d367d0af(valid, message) {}
function $35ea55d96b95b899$export$60eef1277fe463e4() {
    $35ea55d96b95b899$var$warned = {};
}
function $35ea55d96b95b899$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$35ea55d96b95b899$var$warned[message]) {
        method(false, message);
        $35ea55d96b95b899$var$warned[message] = true;
    }
}
function $35ea55d96b95b899$export$82934adf09101657(valid, message) {
    $35ea55d96b95b899$export$848feb93d8f32b9b($35ea55d96b95b899$export$491112666e282270, valid, message);
}
function $35ea55d96b95b899$export$89ff31684837bbbf(valid, message) {
    $35ea55d96b95b899$export$848feb93d8f32b9b($35ea55d96b95b899$export$a92e4c44d367d0af, valid, message);
}
var $35ea55d96b95b899$export$2e2bcd8739ae039 /* eslint-enable */  = $35ea55d96b95b899$export$82934adf09101657;


function $e47965c19bb77a76$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $e47965c19bb77a76$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e47965c19bb77a76$export$2e2bcd8739ae039(obj);
}



function $a3ffb6b357264b72$export$2e2bcd8739ae039(input, hint) {
    if ((0, $e47965c19bb77a76$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $e47965c19bb77a76$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $bbcd189e2fccf5ee$export$2e2bcd8739ae039(arg) {
    var key = (0, $a3ffb6b357264b72$export$2e2bcd8739ae039)(arg, "string");
    return (0, $e47965c19bb77a76$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $fb5608db9919b893$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $bbcd189e2fccf5ee$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $26b893623e0cc8fb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $26b893623e0cc8fb$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $26b893623e0cc8fb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $fb5608db9919b893$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $26b893623e0cc8fb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var $7fPBF = parcelRequire("7fPBF");
function $79b58a58ac6893d3$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $7fPBF.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


function $785d99e76551183b$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $e47965c19bb77a76$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $785d99e76551183b$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $785d99e76551183b$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $785d99e76551183b$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $79b58a58ac6893d3$export$2e2bcd8739ae039)(function() {
        return $785d99e76551183b$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length === next.length && prev.every(function(ref, i) {
            return ref === next[i];
        });
    });
}
function $785d99e76551183b$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $dddaf6f84c717660$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
} /* eslint-enable */ 



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $f8df11644fc49db6$export$2e2bcd8739ae039(node) {
    if (node instanceof HTMLElement) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(node);
    return null;
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $19ed5ac92d0c9dbe$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $19ed5ac92d0c9dbe$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $19ed5ac92d0c9dbe$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $19ed5ac92d0c9dbe$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($19ed5ac92d0c9dbe$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $19ed5ac92d0c9dbe$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $19ed5ac92d0c9dbe$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $19ed5ac92d0c9dbe$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $19ed5ac92d0c9dbe$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $19ed5ac92d0c9dbe$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $19ed5ac92d0c9dbe$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $19ed5ac92d0c9dbe$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $19ed5ac92d0c9dbe$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $19ed5ac92d0c9dbe$var$throttle(this.refresh.bind(this), $19ed5ac92d0c9dbe$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$19ed5ac92d0c9dbe$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($19ed5ac92d0c9dbe$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$19ed5ac92d0c9dbe$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $19ed5ac92d0c9dbe$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $19ed5ac92d0c9dbe$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $19ed5ac92d0c9dbe$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $19ed5ac92d0c9dbe$var$global$1;
};
// Placeholder of an empty content rectangle.
var $19ed5ac92d0c9dbe$var$emptyRect = $19ed5ac92d0c9dbe$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $19ed5ac92d0c9dbe$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $19ed5ac92d0c9dbe$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $19ed5ac92d0c9dbe$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $19ed5ac92d0c9dbe$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $19ed5ac92d0c9dbe$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $19ed5ac92d0c9dbe$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $19ed5ac92d0c9dbe$var$emptyRect;
    var styles = $19ed5ac92d0c9dbe$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $19ed5ac92d0c9dbe$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $19ed5ac92d0c9dbe$var$toFloat(styles.width), height = $19ed5ac92d0c9dbe$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $19ed5ac92d0c9dbe$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $19ed5ac92d0c9dbe$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$19ed5ac92d0c9dbe$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $19ed5ac92d0c9dbe$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $19ed5ac92d0c9dbe$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $19ed5ac92d0c9dbe$var$isDocumentElement(target) {
    return target === $19ed5ac92d0c9dbe$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getContentRect(target) {
    if (!$19ed5ac92d0c9dbe$var$isBrowser) return $19ed5ac92d0c9dbe$var$emptyRect;
    if ($19ed5ac92d0c9dbe$var$isSVGGraphicsElement(target)) return $19ed5ac92d0c9dbe$var$getSVGContentRect(target);
    return $19ed5ac92d0c9dbe$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $19ed5ac92d0c9dbe$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $19ed5ac92d0c9dbe$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $19ed5ac92d0c9dbe$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $19ed5ac92d0c9dbe$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $19ed5ac92d0c9dbe$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $19ed5ac92d0c9dbe$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $19ed5ac92d0c9dbe$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $19ed5ac92d0c9dbe$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $19ed5ac92d0c9dbe$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $19ed5ac92d0c9dbe$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $19ed5ac92d0c9dbe$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $19ed5ac92d0c9dbe$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $19ed5ac92d0c9dbe$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $19ed5ac92d0c9dbe$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $19ed5ac92d0c9dbe$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $19ed5ac92d0c9dbe$var$ResizeObserverController.getInstance();
        var observer = new $19ed5ac92d0c9dbe$var$ResizeObserverSPI(callback, controller, this);
        $19ed5ac92d0c9dbe$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $19ed5ac92d0c9dbe$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $19ed5ac92d0c9dbe$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $19ed5ac92d0c9dbe$var$index = function() {
    // Export existing implementation if available.
    if (typeof $19ed5ac92d0c9dbe$var$global$1.ResizeObserver !== "undefined") return $19ed5ac92d0c9dbe$var$global$1.ResizeObserver;
    return $19ed5ac92d0c9dbe$var$ResizeObserver;
}();
var $19ed5ac92d0c9dbe$export$2e2bcd8739ae039 = $19ed5ac92d0c9dbe$var$index;


// =============================== Const ===============================
var $b380bd36c3356dce$var$elementListeners = new Map();
function $b380bd36c3356dce$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $b380bd36c3356dce$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $b380bd36c3356dce$var$resizeObserver = new (0, $19ed5ac92d0c9dbe$export$2e2bcd8739ae039)($b380bd36c3356dce$var$onResize);
var $b380bd36c3356dce$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $b380bd36c3356dce$export$524f0fd3b47831a = null; // eslint-disable-line
function $b380bd36c3356dce$export$d1203567a167490e(element, callback) {
    if (!$b380bd36c3356dce$var$elementListeners.has(element)) {
        $b380bd36c3356dce$var$elementListeners.set(element, new Set());
        $b380bd36c3356dce$var$resizeObserver.observe(element);
    }
    $b380bd36c3356dce$var$elementListeners.get(element).add(callback);
}
function $b380bd36c3356dce$export$23a2283368c55ea2(element, callback) {
    if ($b380bd36c3356dce$var$elementListeners.has(element)) {
        $b380bd36c3356dce$var$elementListeners.get(element).delete(callback);
        if (!$b380bd36c3356dce$var$elementListeners.get(element).size) {
            $b380bd36c3356dce$var$resizeObserver.unobserve(element);
            $b380bd36c3356dce$var$elementListeners.delete(element);
        }
    }
}


function $1b828f3858047626$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $23075d0307c5f7dd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $bbcd189e2fccf5ee$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $23075d0307c5f7dd$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $23075d0307c5f7dd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $23075d0307c5f7dd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $97be2c1c3403d136$export$2e2bcd8739ae039(o, p) {
    $97be2c1c3403d136$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $97be2c1c3403d136$export$2e2bcd8739ae039(o, p);
}


function $c5823590131aba6b$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $97be2c1c3403d136$export$2e2bcd8739ae039)(subClass, superClass);
}


function $a52f47cde0ab1120$export$2e2bcd8739ae039(o) {
    $a52f47cde0ab1120$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a52f47cde0ab1120$export$2e2bcd8739ae039(o);
}


function $6e56c936881ff823$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $002976c215147f4d$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $f5b4d12942a00234$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $e47965c19bb77a76$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $002976c215147f4d$export$2e2bcd8739ae039)(self);
}


function $29982519c747527b$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $6e56c936881ff823$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $a52f47cde0ab1120$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $a52f47cde0ab1120$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $f5b4d12942a00234$export$2e2bcd8739ae039)(this, result);
    };
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $ff0e1650d9dee595$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $c5823590131aba6b$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $29982519c747527b$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $1b828f3858047626$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $23075d0307c5f7dd$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($7fPBF.Component);



var $7fPBF = parcelRequire("7fPBF");
var $c5f5d120c8ea1002$export$db36075d98ba73d3 = /*#__PURE__*/ $7fPBF.createContext(null);
function $c5f5d120c8ea1002$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $7fPBF.useRef(0);
    var resizeInfosRef = $7fPBF.useRef([]);
    var onCollectionResize = $7fPBF.useContext($c5f5d120c8ea1002$export$db36075d98ba73d3);
    var onResize = $7fPBF.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($c5f5d120c8ea1002$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


function $d23159324142cbd5$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $7fPBF.useRef(null);
    var wrapperRef = $7fPBF.useRef(null);
    var onCollectionResize = $7fPBF.useContext((0, $c5f5d120c8ea1002$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === "function";
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $7fPBF.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $7fPBF.isValidElement(mergedChildren) && (0, $785d99e76551183b$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = $7fPBF.useMemo(function() {
        return (0, $785d99e76551183b$export$ab452c34e8e05029)(originRef, elementRef);
    }, [
        originRef,
        elementRef
    ]);
    var getDom = function getDom() {
        return (0, $f8df11644fc49db6$export$2e2bcd8739ae039)(elementRef.current) || (0, $f8df11644fc49db6$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $7fPBF.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $7fPBF.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $7fPBF.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $26b893623e0cc8fb$export$2e2bcd8739ae039)((0, $26b893623e0cc8fb$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $7fPBF.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $b380bd36c3356dce$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $b380bd36c3356dce$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $7fPBF.createElement((0, $ff0e1650d9dee595$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $7fPBF.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $d23159324142cbd5$var$RefSingleObserver = /*#__PURE__*/ $7fPBF.forwardRef($d23159324142cbd5$var$SingleObserver);
var $d23159324142cbd5$export$2e2bcd8739ae039 = $d23159324142cbd5$var$RefSingleObserver;




var $4305910f3c9e389d$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $4305910f3c9e389d$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === "function" ? [
        children
    ] : (0, $0b734515a1985ae4$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($4305910f3c9e389d$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $7fPBF.createElement((0, $d23159324142cbd5$export$2e2bcd8739ae039), (0, $016a6d95971f5ff5$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $4305910f3c9e389d$var$RefResizeObserver = /*#__PURE__*/ $7fPBF.forwardRef($4305910f3c9e389d$var$ResizeObserver);
$4305910f3c9e389d$var$RefResizeObserver.Collection = (0, $c5f5d120c8ea1002$export$fb8073518f34e6ec);
var $4305910f3c9e389d$export$2e2bcd8739ae039 = $4305910f3c9e389d$var$RefResizeObserver;



var $7fPBF = parcelRequire("7fPBF");
function $b115e465aa05ed56$export$2e2bcd8739ae039(callback) {
    var fnRef = $7fPBF.useRef();
    fnRef.current = callback;
    var memoFn = $7fPBF.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $7fPBF = parcelRequire("7fPBF");
function $461ad016ae0b6863$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $a74bac22062f3ee5$export$2e2bcd8739ae039)({}, $7fPBF);
    return fullClone.useId;
}
var $461ad016ae0b6863$var$uuid = 0;
function $461ad016ae0b6863$export$2f0435a662835942() {}
function $461ad016ae0b6863$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $7fPBF.useState("ssr-id"), _React$useState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    var useOriginId = $461ad016ae0b6863$var$getUseId();
    var reactNativeId = useOriginId === null || useOriginId === void 0 ? void 0 : useOriginId();
    $7fPBF.useEffect(function() {
        if (!useOriginId) {
            var nextId = $461ad016ae0b6863$var$uuid;
            $461ad016ae0b6863$var$uuid += 1;
            setInnerId("rc_unique_".concat(nextId));
        }
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return reactNativeId || innerId;
}



var $7fPBF = parcelRequire("7fPBF");
function $dc2b9d24c2bc5dc5$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $5d79fbb9049de92b$var$useLayoutEffect = (0, $dc2b9d24c2bc5dc5$export$2e2bcd8739ae039)() ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $5d79fbb9049de92b$export$2e2bcd8739ae039 = $5d79fbb9049de92b$var$useLayoutEffect;
var $5d79fbb9049de92b$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    var firstMountRef = $7fPBF.useRef(true);
    $5d79fbb9049de92b$var$useLayoutEffect(function() {
        if (!firstMountRef.current) return callback();
    }, deps);
    // We tell react that first mount has passed
    $5d79fbb9049de92b$var$useLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};







var $7fPBF = parcelRequire("7fPBF");
function $061b1d39171edc69$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $7fPBF.useRef(false);
    var _React$useState = $7fPBF.useState(defaultValue), _React$useState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $7fPBF.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $226dafa12d203b08$var$hasValue(value) {
    return value !== undefined;
}
function $226dafa12d203b08$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $061b1d39171edc69$export$2e2bcd8739ae039)(function() {
        if ($226dafa12d203b08$var$hasValue(value)) return value;
        else if ($226dafa12d203b08$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $b115e465aa05ed56$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $061b1d39171edc69$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $5d79fbb9049de92b$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $5d79fbb9049de92b$export$9283e56bae2f7b0f)(function() {
        if (!$226dafa12d203b08$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $b115e465aa05ed56$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $ceba36143c836fe0$var$TriggerContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $ceba36143c836fe0$export$2e2bcd8739ae039 = $ceba36143c836fe0$var$TriggerContext;


function $903945768538374f$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $903945768538374f$export$2e2bcd8739ae039(action, showAction, hideAction) {
    var mergedShowAction = $903945768538374f$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
    var mergedHideAction = $903945768538374f$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
    return [
        new Set(mergedShowAction),
        new Set(mergedHideAction)
    ];
}







var $7fPBF = parcelRequire("7fPBF");
function $b1797b08a5839070$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $b1797b08a5839070$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($b1797b08a5839070$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}
function $b1797b08a5839070$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $b1797b08a5839070$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $b1797b08a5839070$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        "hidden",
        "scroll",
        "auto"
    ];
    while(current){
        var _getWin$getComputedSt = $b1797b08a5839070$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY;
        if (scrollStyle.includes(overflowX) || scrollStyle.includes(overflowY)) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}


function $584f42315d757812$var$toNum(num) {
    return Number.isNaN(num) ? 1 : num;
}
function $584f42315d757812$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        points[0],
        points[1]
    ];
}
function $584f42315d757812$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === "t") y = rect.y;
    else if (topBottom === "b") y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === "l") x = rect.x;
    else if (leftRight === "r") x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $584f42315d757812$var$reversePoints(points, index) {
    var reverseMap = {
        t: "b",
        b: "t",
        l: "r",
        r: "l"
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || "c";
        return point;
    }).join("");
}
function $584f42315d757812$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $7fPBF.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $7fPBF.useRef(0);
    var scrollerList = $7fPBF.useMemo(function() {
        if (!popupEle) return [];
        return (0, $b1797b08a5839070$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Align =========================
    var onAlign = (0, $b115e465aa05ed56$export$2e2bcd8739ae039)(function() {
        if (popupEle && target && open) {
            var popupElement = popupEle;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var doc = popupElement.ownerDocument;
            var win = (0, $b1797b08a5839070$export$9c0584a7cc24d9e)(popupElement);
            // Reset first
            popupElement.style.left = "0";
            popupElement.style.top = "0";
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height;
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            // Get bounding of visible area
            var visibleArea = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            (scrollerList || []).forEach(function(ele) {
                var eleRect = ele.getBoundingClientRect();
                var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
                var scaleX = $584f42315d757812$var$toNum(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
                var scaleY = $584f42315d757812$var$toNum(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
                var scrollWidth = (eleOutWidth - eleInnerWidth) * scaleX;
                var scrollHeight = (eleOutHeight - eleInnerHeight) * scaleY;
                var eleRight = eleRect.x + eleRect.width - scrollWidth;
                var eleBottom = eleRect.y + eleRect.height - scrollHeight;
                visibleArea.left = Math.max(visibleArea.left, eleRect.left);
                visibleArea.top = Math.max(visibleArea.top, eleRect.top);
                visibleArea.right = Math.min(visibleArea.right, eleRight);
                visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
            });
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            // Calculate scale
            var _scaleX = $584f42315d757812$var$toNum(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = $584f42315d757812$var$toNum(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // Placement
            var placementInfo = builtinPlacements[placement] || popupAlign || {};
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _ref = offset || [], _ref2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_ref, 2), _ref2$ = _ref2[0], popupOffsetX = _ref2$ === void 0 ? 0 : _ref2$, _ref2$2 = _ref2[1], popupOffsetY = _ref2$2 === void 0 ? 0 : _ref2$2;
            var _ref3 = targetOffset || [], _ref4 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_ref3, 2), _ref4$ = _ref4[0], targetOffsetX = _ref4$ === void 0 ? 0 : _ref4$, _ref4$2 = _ref4[1], targetOffsetY = _ref4$2 === void 0 ? 0 : _ref4$2;
            targetRect.x += targetOffsetX;
            targetRect.y += targetOffsetY;
            // Points
            var _ref5 = placementInfo.points || [], _ref6 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_ref5, 2), popupPoint = _ref6[0], targetPoint = _ref6[1];
            var targetPoints = $584f42315d757812$var$splitPoints(targetPoint);
            var popupPoints = $584f42315d757812$var$splitPoints(popupPoint);
            var targetAlignPoint = $584f42315d757812$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $584f42315d757812$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $a74bac22062f3ee5$export$2e2bcd8739ae039)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ================ Overflow =================
            var targetAlignPointTL = $584f42315d757812$var$getAlignPoint(targetRect, [
                "t",
                "l"
            ]);
            var popupAlignPointTL = $584f42315d757812$var$getAlignPoint(popupRect, [
                "t",
                "l"
            ]);
            var targetAlignPointBR = $584f42315d757812$var$getAlignPoint(targetRect, [
                "b",
                "r"
            ]);
            var popupAlignPointBR = $584f42315d757812$var$getAlignPoint(popupRect, [
                "b",
                "r"
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === "boolean") return val;
                return val >= 0;
            };
            // >>>>>>>>>> Top & Bottom
            var nextPopupY = popupRect.y + nextOffsetY;
            var nextPopupBottom = nextPopupY + popupHeight;
            var needAdjustY = supportAdjust(adjustY);
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === "t" && nextPopupBottom > visibleArea.bottom) {
                nextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                nextAlignInfo.points = [
                    $584f42315d757812$var$reversePoints(popupPoints, 0),
                    $584f42315d757812$var$reversePoints(targetPoints, 0)
                ];
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === "b" && nextPopupY < visibleArea.top) {
                nextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                nextAlignInfo.points = [
                    $584f42315d757812$var$reversePoints(popupPoints, 0),
                    $584f42315d757812$var$reversePoints(targetPoints, 0)
                ];
            }
            // >>>>>>>>>> Left & Right
            var nextPopupX = popupRect.x + nextOffsetX;
            var nextPopupRight = nextPopupX + popupWidth;
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            // Right to Left
            if (needAdjustX && popupPoints[1] === "l" && nextPopupRight > visibleArea.right) {
                nextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                nextAlignInfo.points = [
                    $584f42315d757812$var$reversePoints(popupPoints, 1),
                    $584f42315d757812$var$reversePoints(targetPoints, 1)
                ];
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === "r" && nextPopupX < visibleArea.left) {
                nextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                nextAlignInfo.points = [
                    $584f42315d757812$var$reversePoints(popupPoints, 1),
                    $584f42315d757812$var$reversePoints(targetPoints, 1)
                ];
            }
            // >>>>> Shift
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === "number") {
                // Left
                if (nextPopupX < visibleArea.left) {
                    nextOffsetX -= nextPopupX - visibleArea.left;
                    if (targetRect.x + targetRect.width < visibleArea.left + numShiftX) nextOffsetX += targetRect.x - visibleArea.left + targetRect.width - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleArea.right) {
                    nextOffsetX -= nextPopupRight - visibleArea.right;
                    if (targetRect.x > visibleArea.right - numShiftX) nextOffsetX += targetRect.x - visibleArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === "number") {
                // Top
                if (nextPopupY < visibleArea.top) {
                    nextOffsetY -= nextPopupY - visibleArea.top;
                    if (targetRect.y + targetRect.height < visibleArea.top + numShiftY) nextOffsetY += targetRect.y - visibleArea.top + targetRect.height - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleArea.bottom;
                    if (targetRect.y > visibleArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleArea.bottom + numShiftY;
                }
            }
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetRect.width;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetRect.height;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            setOffsetInfo({
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            });
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $a74bac22062f3ee5$export$2e2bcd8739ae039)((0, $a74bac22062f3ee5$export$2e2bcd8739ae039)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}



function $9d303213ec1d817b$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7a75cf7da574b553$export$2e2bcd8739ae039)(arr);
}


function $d4ed7d2200f99f48$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $d38138a85d874050$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $066ff2a0baa1755e$export$2e2bcd8739ae039(arr) {
    return (0, $9d303213ec1d817b$export$2e2bcd8739ae039)(arr) || (0, $d4ed7d2200f99f48$export$2e2bcd8739ae039)(arr) || (0, $ee45a5db0b7a5691$export$2e2bcd8739ae039)(arr) || (0, $d38138a85d874050$export$2e2bcd8739ae039)();
}




function $b9928d0f5e83e67e$export$2e2bcd8739ae039(open, target, popup, onAlign) {
    (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $b1797b08a5839070$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $b1797b08a5839070$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $b1797b08a5839070$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $066ff2a0baa1755e$export$2e2bcd8739ae039)(targetScrollList), (0, $066ff2a0baa1755e$export$2e2bcd8739ae039)(popupScrollList)));
            function notifyScroll() {
                onAlign();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener("scroll", notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener("resize", notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener("scroll", notifyScroll);
                    win.removeEventListener("resize", notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}


function $b7961a264fffc9ff$export$2e2bcd8739ae039() {
    $b7961a264fffc9ff$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b7961a264fffc9ff$export$2e2bcd8739ae039.apply(this, arguments);
}










var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $a7212d64a8283986$export$2e2bcd8739ae039(node) {
    if (node instanceof HTMLElement) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(node);
    return null;
}


function $df869e3270df791a$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $df869e3270df791a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $df869e3270df791a$export$2e2bcd8739ae039(obj);
}




var $7fPBF = parcelRequire("7fPBF");
function $d3966080fd5bf7db$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $7fPBF.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


function $5e43d0aef52789a4$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $df869e3270df791a$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $5e43d0aef52789a4$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5e43d0aef52789a4$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $5e43d0aef52789a4$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $d3966080fd5bf7db$export$2e2bcd8739ae039)(function() {
        return $5e43d0aef52789a4$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length === next.length && prev.every(function(ref, i) {
            return ref === next[i];
        });
    });
}
function $5e43d0aef52789a4$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $dddaf6f84c717660$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
} /* eslint-enable */ 




function $4c3c2e2b4b088f86$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


// ================= Transition =================
// Event wrapper. Copy from react source code
function $2e7b0cf6e6403917$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $2e7b0cf6e6403917$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $2e7b0cf6e6403917$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $2e7b0cf6e6403917$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $2e7b0cf6e6403917$var$vendorPrefixes = $2e7b0cf6e6403917$export$6e8b350b1a8958a0((0, $4c3c2e2b4b088f86$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
var $2e7b0cf6e6403917$var$style = {};
if ((0, $4c3c2e2b4b088f86$export$2e2bcd8739ae039)()) {
    var $2e7b0cf6e6403917$var$_document$createEleme = document.createElement("div");
    $2e7b0cf6e6403917$var$style = $2e7b0cf6e6403917$var$_document$createEleme.style;
}
var $2e7b0cf6e6403917$var$prefixedEventNames = {};
function $2e7b0cf6e6403917$export$a032e4f39350c1d8(eventName) {
    if ($2e7b0cf6e6403917$var$prefixedEventNames[eventName]) return $2e7b0cf6e6403917$var$prefixedEventNames[eventName];
    var prefixMap = $2e7b0cf6e6403917$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $2e7b0cf6e6403917$var$style) {
                $2e7b0cf6e6403917$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $2e7b0cf6e6403917$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $2e7b0cf6e6403917$var$internalAnimationEndName = $2e7b0cf6e6403917$export$a032e4f39350c1d8("animationend");
var $2e7b0cf6e6403917$var$internalTransitionEndName = $2e7b0cf6e6403917$export$a032e4f39350c1d8("transitionend");
var $2e7b0cf6e6403917$export$d28133ed3ad06c8b = !!($2e7b0cf6e6403917$var$internalAnimationEndName && $2e7b0cf6e6403917$var$internalTransitionEndName);
var $2e7b0cf6e6403917$export$760cc9769c51b738 = $2e7b0cf6e6403917$var$internalAnimationEndName || "animationend";
var $2e7b0cf6e6403917$export$44baea64b8602e3c = $2e7b0cf6e6403917$var$internalTransitionEndName || "transitionend";
function $2e7b0cf6e6403917$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $cf6907bb6fc440cc$export$de71442bbf2143da = "none";
var $cf6907bb6fc440cc$export$4fc3521687bcacd2 = "appear";
var $cf6907bb6fc440cc$export$5d6af549241fe2e8 = "enter";
var $cf6907bb6fc440cc$export$59b1c493d29f68e4 = "leave";
var $cf6907bb6fc440cc$export$40b34dd77d5522bf = "none";
var $cf6907bb6fc440cc$export$1b792916a5fac4fc = "prepare";
var $cf6907bb6fc440cc$export$9563153dd25a3ce8 = "start";
var $cf6907bb6fc440cc$export$e205886172277ec6 = "active";
var $cf6907bb6fc440cc$export$3a846c3d2fac10b8 = "end";






var $7fPBF = parcelRequire("7fPBF");
function $26c6968a51d9016f$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $4c3f215261749e4a$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}


function $0cf40cee584fc5bb$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $6ae1a7c7744a236c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $0cf40cee584fc5bb$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $0cf40cee584fc5bb$export$2e2bcd8739ae039)(o, minLen);
}


function $f70d3f4045566e1c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $ff252489b036470f$export$2e2bcd8739ae039(arr, i) {
    return (0, $26c6968a51d9016f$export$2e2bcd8739ae039)(arr) || (0, $4c3f215261749e4a$export$2e2bcd8739ae039)(arr, i) || (0, $6ae1a7c7744a236c$export$2e2bcd8739ae039)(arr, i) || (0, $f70d3f4045566e1c$export$2e2bcd8739ae039)();
}



var $7fPBF = parcelRequire("7fPBF");
function $4a0a68ee79ae5265$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $7fPBF.useRef(false);
    var _React$useState = $7fPBF.useState(defaultValue), _React$useState2 = (0, $ff252489b036470f$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $7fPBF.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}





var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $e5101a2ebd18da2f$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $e5101a2ebd18da2f$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $e5101a2ebd18da2f$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $e5101a2ebd18da2f$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $e5101a2ebd18da2f$var$rafUUID = 0;
var $e5101a2ebd18da2f$var$rafIds = new Map();
function $e5101a2ebd18da2f$var$cleanup(id) {
    $e5101a2ebd18da2f$var$rafIds.delete(id);
}
var $e5101a2ebd18da2f$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $e5101a2ebd18da2f$var$rafUUID += 1;
    var id = $e5101a2ebd18da2f$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $e5101a2ebd18da2f$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $e5101a2ebd18da2f$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $e5101a2ebd18da2f$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$e5101a2ebd18da2f$var$wrapperRaf.cancel = function(id) {
    var realId = $e5101a2ebd18da2f$var$rafIds.get(id);
    $e5101a2ebd18da2f$var$cleanup(realId);
    return $e5101a2ebd18da2f$var$caf(realId);
};
var $e5101a2ebd18da2f$export$2e2bcd8739ae039 = $e5101a2ebd18da2f$var$wrapperRaf;


var $e18ba5459e1463ef$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $7fPBF.useRef(null);
    function cancelNextFrame() {
        (0, $e5101a2ebd18da2f$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $e5101a2ebd18da2f$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $7fPBF.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};



var $7fPBF = parcelRequire("7fPBF");

var $aecc24bb219e19fb$var$useIsomorphicLayoutEffect = (0, $4c3c2e2b4b088f86$export$2e2bcd8739ae039)() ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
var $aecc24bb219e19fb$export$2e2bcd8739ae039 = $aecc24bb219e19fb$var$useIsomorphicLayoutEffect;


var $649c87ef36164e16$var$STEP_QUEUE = [
    (0, $cf6907bb6fc440cc$export$1b792916a5fac4fc),
    (0, $cf6907bb6fc440cc$export$9563153dd25a3ce8),
    (0, $cf6907bb6fc440cc$export$e205886172277ec6),
    (0, $cf6907bb6fc440cc$export$3a846c3d2fac10b8)
];
var $649c87ef36164e16$export$c2029bf6cfdbc28a = false;
var $649c87ef36164e16$export$dbee1e282e8c4830 = true;
function $649c87ef36164e16$export$39e04e72f972b885(step) {
    return step === (0, $cf6907bb6fc440cc$export$e205886172277ec6) || step === (0, $cf6907bb6fc440cc$export$3a846c3d2fac10b8);
}
var $649c87ef36164e16$export$2e2bcd8739ae039 = function(status, callback) {
    var _useState = (0, $4a0a68ee79ae5265$export$2e2bcd8739ae039)((0, $cf6907bb6fc440cc$export$40b34dd77d5522bf)), _useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $e18ba5459e1463ef$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $cf6907bb6fc440cc$export$1b792916a5fac4fc), true);
    }
    (0, $aecc24bb219e19fb$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $cf6907bb6fc440cc$export$40b34dd77d5522bf) && step !== (0, $cf6907bb6fc440cc$export$3a846c3d2fac10b8)) {
            var index = $649c87ef36164e16$var$STEP_QUEUE.indexOf(step);
            var nextStep = $649c87ef36164e16$var$STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $649c87ef36164e16$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $7fPBF.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};



var $7fPBF = parcelRequire("7fPBF");

var $32ab225bb0039d28$export$2e2bcd8739ae039 = function(callback) {
    var cacheElementRef = (0, $7fPBF.useRef)(); // Cache callback
    var callbackRef = (0, $7fPBF.useRef)(callback);
    callbackRef.current = callback; // Internal motion event handler
    var onInternalMotionEnd = $7fPBF.useCallback(function(event) {
        callbackRef.current(event);
    }, []); // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $2e7b0cf6e6403917$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $2e7b0cf6e6403917$export$760cc9769c51b738), onInternalMotionEnd);
        }
    } // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $2e7b0cf6e6403917$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $2e7b0cf6e6403917$export$760cc9769c51b738), onInternalMotionEnd); // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    } // Clean up when removed
    $7fPBF.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};



function $973dc2d3caac3322$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $4a0a68ee79ae5265$export$2e2bcd8739ae039)(), _useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useState3 = (0, $4a0a68ee79ae5265$export$2e2bcd8739ae039)((0, $cf6907bb6fc440cc$export$de71442bbf2143da)), _useState4 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    var _useState5 = (0, $4a0a68ee79ae5265$export$2e2bcd8739ae039)(null), _useState6 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState5, 2), style = _useState6[0], setStyle = _useState6[1];
    var mountedRef = (0, $7fPBF.useRef)(false);
    var deadlineRef = (0, $7fPBF.useRef)(null); // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    } // ========================== Motion End ==========================
    var activeRef = (0, $7fPBF.useRef)(false);
    function onInternalMotionEnd(event) {
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $cf6907bb6fc440cc$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $cf6907bb6fc440cc$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $cf6907bb6fc440cc$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
         // Only update status when `canEnd` and not destroyed
        if (status !== (0, $cf6907bb6fc440cc$export$de71442bbf2143da) && currentActive && canEnd !== false) {
            setStatus((0, $cf6907bb6fc440cc$export$de71442bbf2143da), true);
            setStyle(null, true);
        }
    }
    var _useDomMotionEvents = (0, $32ab225bb0039d28$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0]; // ============================= Step =============================
    var eventHandlers = $7fPBF.useMemo(function() {
        var _ref2, _ref3, _ref4;
        switch(status){
            case 0, $cf6907bb6fc440cc$export$4fc3521687bcacd2:
                return _ref2 = {}, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref2, (0, $cf6907bb6fc440cc$export$1b792916a5fac4fc), onAppearPrepare), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref2, (0, $cf6907bb6fc440cc$export$9563153dd25a3ce8), onAppearStart), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref2, (0, $cf6907bb6fc440cc$export$e205886172277ec6), onAppearActive), _ref2;
            case 0, $cf6907bb6fc440cc$export$5d6af549241fe2e8:
                return _ref3 = {}, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref3, (0, $cf6907bb6fc440cc$export$1b792916a5fac4fc), onEnterPrepare), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref3, (0, $cf6907bb6fc440cc$export$9563153dd25a3ce8), onEnterStart), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref3, (0, $cf6907bb6fc440cc$export$e205886172277ec6), onEnterActive), _ref3;
            case 0, $cf6907bb6fc440cc$export$59b1c493d29f68e4:
                return _ref4 = {}, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref4, (0, $cf6907bb6fc440cc$export$1b792916a5fac4fc), onLeavePrepare), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref4, (0, $cf6907bb6fc440cc$export$9563153dd25a3ce8), onLeaveStart), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_ref4, (0, $cf6907bb6fc440cc$export$e205886172277ec6), onLeaveActive), _ref4;
            default:
                return {};
        }
    }, [
        status
    ]);
    var _useStepQueue = (0, $649c87ef36164e16$export$2e2bcd8739ae039)(status, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $cf6907bb6fc440cc$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $cf6907bb6fc440cc$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $649c87ef36164e16$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        } // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $cf6907bb6fc440cc$export$e205886172277ec6)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        return 0, $649c87ef36164e16$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $649c87ef36164e16$export$39e04e72f972b885)(step);
    activeRef.current = active; // ============================ Status ============================
    // Update with new status
    (0, $aecc24bb219e19fb$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        if (!supportMotion) return;
        var nextStatus; // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $cf6907bb6fc440cc$export$4fc3521687bcacd2);
         // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $cf6907bb6fc440cc$export$5d6af549241fe2e8);
         // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $cf6907bb6fc440cc$export$59b1c493d29f68e4);
         // Update to next status
        if (nextStatus) {
            setStatus(nextStatus);
            startStep();
        }
    }, [
        visible
    ]); // ============================ Effect ============================
    // Reset when motion changed
    (0, $7fPBF.useEffect)(function() {
        if (status === (0, $cf6907bb6fc440cc$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        status === (0, $cf6907bb6fc440cc$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        status === (0, $cf6907bb6fc440cc$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $cf6907bb6fc440cc$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $7fPBF.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []); // Trigger `onVisibleChanged`
    var firstMountChangeRef = $7fPBF.useRef(false);
    (0, $7fPBF.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && status === (0, $cf6907bb6fc440cc$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        status
    ]); // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $cf6907bb6fc440cc$export$1b792916a5fac4fc] && step === (0, $cf6907bb6fc440cc$export$9563153dd25a3ce8)) mergedStyle = (0, $8273a87573256c54$export$2e2bcd8739ae039)({
        transition: "none"
    }, mergedStyle);
    return [
        status,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}


function $009b183922525d46$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $381be8fad7784fe9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $381be8fad7784fe9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $381be8fad7784fe9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



function $5236ac5195402c05$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $da27c96857818bcc$export$2e2bcd8739ae039)(subClass, superClass);
}


function $b48febf76cf3d138$export$2e2bcd8739ae039(o) {
    $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b48febf76cf3d138$export$2e2bcd8739ae039(o);
}


function $cb0780e1471bbfb2$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $298ff58efa174465$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $690e545d5a200a90$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $505ebcb184373782$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $298ff58efa174465$export$2e2bcd8739ae039)(self);
}


function $c2ec9395872a8e53$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $cb0780e1471bbfb2$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, result);
    };
}



var $7fPBF = parcelRequire("7fPBF");
var $733976b50ea22997$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($7fPBF.Component);
var $733976b50ea22997$export$2e2bcd8739ae039 = $733976b50ea22997$var$DomWrapper;



function $acf468ea6d8d37b1$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props) {
        return !!(props.motionName && transitionSupport);
    }
    var CSSMotion = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var supportMotion = isSupportTransition(props); // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $7fPBF.useRef)(); // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $7fPBF.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $a7212d64a8283986$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $973dc2d3caac3322$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3]; // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $7fPBF.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
         // ====================== Refs ======================
        var setNodeRef = $7fPBF.useCallback(function(node) {
            nodeRef.current = node;
            (0, $5e43d0aef52789a4$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]); // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $cf6907bb6fc440cc$export$de71442bbf2143da) || !isSupportTransition(props)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            var _classNames;
            // In motion
            var statusSuffix;
            if (statusStep === (0, $cf6907bb6fc440cc$export$1b792916a5fac4fc)) statusSuffix = "prepare";
            else if ((0, $649c87ef36164e16$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $cf6907bb6fc440cc$export$9563153dd25a3ce8)) statusSuffix = "start";
            motionChildren = children((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $2e7b0cf6e6403917$export$27c72201b1d09951)(motionName, status), (_classNames = {}, (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, (0, $2e7b0cf6e6403917$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(_classNames, motionName, typeof motionName === "string"), _classNames)),
                style: statusStyle
            }), setNodeRef);
        } // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $7fPBF.isValidElement(motionChildren) && (0, $5e43d0aef52789a4$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $7fPBF.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $7fPBF.createElement((0, $733976b50ea22997$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $acf468ea6d8d37b1$export$2e2bcd8739ae039 = $acf468ea6d8d37b1$export$e265d52a86a9f199((0, $2e7b0cf6e6403917$export$d28133ed3ad06c8b));












var $7fPBF = parcelRequire("7fPBF");




var $4d35f75bb180652d$export$3904baa009bc026e = "add";
var $4d35f75bb180652d$export$851162f0adad2cbc = "keep";
var $4d35f75bb180652d$export$c8b3fb08b68cfc85 = "remove";
var $4d35f75bb180652d$export$2ac1bd1808d2e43a = "removed";
function $4d35f75bb180652d$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $505ebcb184373782$export$2e2bcd8739ae039)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $4d35f75bb180652d$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($4d35f75bb180652d$export$c47fd798e598c85c);
}
function $4d35f75bb180652d$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $4d35f75bb180652d$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $4d35f75bb180652d$export$84bd7bd42ccc0f72(currentKeys); // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $4d35f75bb180652d$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $4d35f75bb180652d$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        } // If not hit, it means key is removed
        if (!hit) list.push((0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $4d35f75bb180652d$export$c8b3fb08b68cfc85
        }));
    }); // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $4d35f75bb180652d$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $4d35f75bb180652d$export$c8b3fb08b68cfc85;
        }); // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $4d35f75bb180652d$export$851162f0adad2cbc;
        });
    });
    return list;
}


var $29836dc900b3fdaf$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $29836dc900b3fdaf$var$_excluded2 = [
    "status"
];
var $29836dc900b3fdaf$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $29836dc900b3fdaf$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $acf468ea6d8d37b1$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $5236ac5195402c05$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $009b183922525d46$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $8273a87573256c54$export$2e2bcd8739ae039)((0, $8273a87573256c54$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $4d35f75bb180652d$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $4d35f75bb180652d$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_this$props, $29836dc900b3fdaf$var$_excluded);
                    var Component = component || $7fPBF.Fragment;
                    var motionProps = {};
                    $29836dc900b3fdaf$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $7fPBF.createElement(Component, restProps, keyEntities.map(function(_ref2) {
                        var status = _ref2.status, eventProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref2, $29836dc900b3fdaf$var$_excluded2);
                        var visible = status === (0, $4d35f75bb180652d$export$3904baa009bc026e) || status === (0, $4d35f75bb180652d$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $7fPBF.createElement(CSSMotion, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), children);
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $4d35f75bb180652d$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $4d35f75bb180652d$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            }); // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $4d35f75bb180652d$export$2ac1bd1808d2e43a) && entity.status === (0, $4d35f75bb180652d$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                } // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            }
        ]);
        return CSSMotionList;
    }($7fPBF.Component);
    (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $29836dc900b3fdaf$export$2e2bcd8739ae039 = $29836dc900b3fdaf$export$fcfc62c1d33d5e2e((0, $2e7b0cf6e6403917$export$d28133ed3ad06c8b));


var $44c3d1cb6571ef78$export$2e2bcd8739ae039 = (0, $acf468ea6d8d37b1$export$2e2bcd8739ae039);





var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
function $fce84d7fb32a9ca4$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, _props$arrowX = props.arrowX, arrowX = _props$arrowX === void 0 ? 0 : _props$arrowX, _props$arrowY = props.arrowY, arrowY = _props$arrowY === void 0 ? 0 : _props$arrowY;
    var arrowRef = $7fPBF.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: "absolute"
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            "t",
            "b"
        ].includes(popupTB)) alignStyle.top = arrowY;
        else if (popupTB === "t") alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            "l",
            "r"
        ].includes(popupLR)) alignStyle.left = arrowX;
        else if (popupLR === "l") alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        ref: arrowRef,
        className: "".concat(prefixCls, "-arrow"),
        style: alignStyle
    });
}





function $c500a53f470dfda8$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ React.createElement((0, $44c3d1cb6571ef78$export$2e2bcd8739ae039), (0, $b7961a264fffc9ff$export$2e2bcd8739ae039)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef9a2ae8e46177c5$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}


var $6994ab2683a1c6c9$var$Popup = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, onClick = props.onClick, mask = props.mask, arrow = props.arrow, align = props.align, arrowX = props.arrowX, arrowY = props.arrowY, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === "function" ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $7fPBF.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var offsetStyle = ready || !open ? {
        left: offsetX,
        top: offsetY
    } : {
        left: "-1000vw",
        top: "-1000vh"
    };
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes("height") && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes("minHeight") && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes("width") && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes("minWidth") && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = "none";
    return /*#__PURE__*/ $7fPBF.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $7fPBF.createElement((0, $c500a53f470dfda8$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $7fPBF.createElement((0, $4305910f3c9e389d$export$2e2bcd8739ae039), {
        onResize: onAlign,
        disabled: !open
    }, /*#__PURE__*/ $7fPBF.createElement((0, $44c3d1cb6571ef78$export$2e2bcd8739ae039), (0, $b7961a264fffc9ff$export$2e2bcd8739ae039)({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        forceRender: forceRender,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        visible: open,
        onVisibleChanged: function onVisibleChanged(nextVisible) {
            var _motion$onVisibleChan;
            motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
            _onVisibleChanged(nextVisible);
        }
    }), function(_ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($ef9a2ae8e46177c5$exports)))(prefixCls, motionClassName, className);
        return /*#__PURE__*/ $7fPBF.createElement("div", {
            ref: ref,
            className: cls,
            style: (0, $a74bac22062f3ee5$export$2e2bcd8739ae039)((0, $a74bac22062f3ee5$export$2e2bcd8739ae039)((0, $a74bac22062f3ee5$export$2e2bcd8739ae039)((0, $a74bac22062f3ee5$export$2e2bcd8739ae039)({}, offsetStyle), miscStyle), motionStyle), {}, {
                boxSizing: "border-box",
                zIndex: zIndex
            }, style),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick
        }, arrow && /*#__PURE__*/ $7fPBF.createElement((0, $fce84d7fb32a9ca4$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            align: align,
            arrowX: arrowX,
            arrowY: arrowY
        }), childNode);
    })));
});
var $6994ab2683a1c6c9$export$2e2bcd8739ae039 = $6994ab2683a1c6c9$var$Popup;





var $7fPBF = parcelRequire("7fPBF");
function $c0654782ed73fafc$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $7fPBF.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


function $7f538134a4cf6160$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $5ddc7f73b371f88e$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $7f538134a4cf6160$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $7f538134a4cf6160$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $7f538134a4cf6160$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $c0654782ed73fafc$export$2e2bcd8739ae039)(function() {
        return $7f538134a4cf6160$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length === next.length && prev.every(function(ref, i) {
            return ref === next[i];
        });
    });
}
function $7f538134a4cf6160$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $dddaf6f84c717660$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
} /* eslint-enable */ 



var $7fPBF = parcelRequire("7fPBF");
var $b6f9085b7e0818dd$var$TriggerWrapper = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $7f538134a4cf6160$export$c1cec34af06bcf7)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $7fPBF.useCallback(function(node) {
        (0, $7f538134a4cf6160$export$f17fd18fa51dcb5b)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $7f538134a4cf6160$export$1d1c999670a1285d)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $7fPBF.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $b6f9085b7e0818dd$export$2e2bcd8739ae039 = $b6f9085b7e0818dd$var$TriggerWrapper;



var $77083a3acb5fe2c8$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $77083a3acb5fe2c8$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $92a36ca56e167eae$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $7fPBF.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $04ac828d8ca8a401$export$2e2bcd8739ae039)(props, $77083a3acb5fe2c8$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // ========================== Context ===========================
        var subPopupElements = $7fPBF.useRef({});
        var parentContext = $7fPBF.useContext((0, $ceba36143c836fe0$export$2e2bcd8739ae039));
        var context = $7fPBF.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $461ad016ae0b6863$export$2e2bcd8739ae039)();
        var _React$useState = $7fPBF.useState(null), _React$useState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState, 2), popupEle = _React$useState2[0], setPopupEle = _React$useState2[1];
        var setPopupRef = $7fPBF.useCallback(function(node) {
            if (node instanceof HTMLElement) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        }, []);
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState3 = $7fPBF.useState(null), _React$useState4 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState3, 2), targetEle = _React$useState4[0], setTargetEle = _React$useState4[1];
        var setTargetRef = $7fPBF.useCallback(function(node) {
            if (node instanceof HTMLElement) setTargetEle(node);
        }, []);
        // ========================== Children ==========================
        var child = $7fPBF.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $b115e465aa05ed56$export$2e2bcd8739ae039)(function(ele) {
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return subPopupEle.contains(ele) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $b1797b08a5839070$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $b1797b08a5839070$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _useMergedState = (0, $226dafa12d203b08$export$2e2bcd8739ae039)(defaultPopupVisible || false, {
            value: popupVisible
        }), _useMergedState2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_useMergedState, 2), mergedOpen = _useMergedState2[0], setMergedOpen = _useMergedState2[1];
        var openRef = $7fPBF.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var internalTriggerOpen = (0, $b115e465aa05ed56$export$2e2bcd8739ae039)(function(nextOpen) {
            if (mergedOpen !== nextOpen) {
                setMergedOpen(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $7fPBF.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $7fPBF.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState5 = $7fPBF.useState(false), _React$useState6 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState5, 2), inMotion = _React$useState6[0], setInMotion = _React$useState6[1];
        (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(function() {
            setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState7 = $7fPBF.useState(null), _React$useState8 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState7, 2), motionPrepareResolve = _React$useState8[0], setMotionPrepareResolve = _React$useState8[1];
        // =========================== Align ============================
        var _React$useState9 = $7fPBF.useState([
            0,
            0
        ]), _React$useState10 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState9, 2), mousePos = _React$useState10[0], setMousePos = _React$useState10[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $584f42315d757812$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_useAlign, 9), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], arrowX = _useAlign2[3], arrowY = _useAlign2[4], scaleX = _useAlign2[5], scaleY = _useAlign2[6], alignInfo = _useAlign2[7], onAlign = _useAlign2[8];
        var triggerAlign = (0, $b115e465aa05ed56$export$2e2bcd8739ae039)(function() {
            if (!inMotion) onAlign();
        });
        (0, $b9928d0f5e83e67e$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign);
        (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(function() {
            triggerAlign();
        }, [
            mousePos
        ]);
        var alignedClassName = $7fPBF.useMemo(function() {
            var baseClassName = (0, $b1797b08a5839070$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($ef9a2ae8e46177c5$exports)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        $7fPBF.useImperativeHandle(ref, function() {
            return {
                forceAlign: triggerAlign
            };
        });
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $5d79fbb9049de92b$export$2e2bcd8739ae039)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // ========================== Stretch ===========================
        var _React$useState11 = $7fPBF.useState(0), _React$useState12 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState11, 2), targetWidth = _React$useState12[0], setTargetWidth = _React$useState12[1];
        var _React$useState13 = $7fPBF.useState(0), _React$useState14 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_React$useState13, 2), targetHeight = _React$useState14[0], setTargetHeight = _React$useState14[1];
        var onTargetResize = function onTargetResize(_, ele) {
            triggerAlign();
            if (stretch) {
                var rect = ele.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        // =========================== Action ===========================
        var _useAction = (0, $903945768538374f$export$2e2bcd8739ae039)(action, showAction, hideAction), _useAction2 = (0, $acfd2f96473b3e3e$export$2e2bcd8739ae039)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        // Util wrapper for trigger action
        var wrapperAction = function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        };
        // ======================= Action: Click ========================
        var clickToShow = showActions.has("click");
        var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        $7fPBF.useEffect(function() {
            if (clickToHide && popupEle && (!mask || maskClosable)) {
                var onWindowClick = function onWindowClick(_ref) {
                    var target = _ref.target;
                    if (openRef.current && !inPopupOrChild(target)) triggerOpen(false);
                };
                var win = (0, $b1797b08a5839070$export$9c0584a7cc24d9e)(popupEle);
                win.addEventListener("click", onWindowClick);
                return function() {
                    win.removeEventListener("click", onWindowClick);
                };
            }
        }, [
            clickToHide,
            popupEle,
            mask,
            maskClosable
        ]);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has("hover");
        var hoverToHide = hideActions.has("hover");
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter() {
                triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction("onMouseLeave", false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has("focus")) wrapperAction("onFocus", true, focusDelay);
        if (hideActions.has("focus")) wrapperAction("onBlur", false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has("contextMenu")) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            setMousePosByEvent(event);
            triggerOpen(true);
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($ef9a2ae8e46177c5$exports)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $a74bac22062f3ee5$export$2e2bcd8739ae039)((0, $a74bac22062f3ee5$export$2e2bcd8739ae039)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            "onContextMenu",
            "onClick",
            "onMouseDown",
            "onTouchStart",
            "onMouseEnter",
            "onMouseLeave",
            "onFocus",
            "onBlur"
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $7fPBF.cloneElement(child, (0, $a74bac22062f3ee5$export$2e2bcd8739ae039)((0, $a74bac22062f3ee5$export$2e2bcd8739ae039)({}, mergedChildrenProps), passedProps));
        // Render
        return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $ceba36143c836fe0$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $7fPBF.createElement((0, $6994ab2683a1c6c9$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef9a2ae8e46177c5$exports)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: arrow,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            arrowX: arrowX,
            arrowY: arrowY,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })), /*#__PURE__*/ $7fPBF.createElement((0, $4305910f3c9e389d$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $7fPBF.createElement((0, $b6f9085b7e0818dd$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)));
    });
    return Trigger;
}
var $77083a3acb5fe2c8$export$2e2bcd8739ae039 = $77083a3acb5fe2c8$export$55e99723d7f71b47((0, $92a36ca56e167eae$export$2e2bcd8739ae039));



var $7fPBF = parcelRequire("7fPBF");
var $ba1585ba38011074$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $ba1585ba38011074$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $ba1585ba38011074$var$targetOffset = [
    0,
    0
];
var $ba1585ba38011074$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $ba1585ba38011074$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $ba1585ba38011074$var$targetOffset
    }
};
var $ba1585ba38011074$export$2e2bcd8739ae039 = $ba1585ba38011074$export$803cd8101b6c182b;




var $7fPBF = parcelRequire("7fPBF");
function $16c69cc12596049f$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $7fPBF.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $7fPBF.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}


var $ad395143f96b71e1$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $ad395143f96b71e1$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(props, $ad395143f96b71e1$var$_excluded);
    var triggerRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $8273a87573256c54$export$2e2bcd8739ae039)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $7fPBF.createElement((0, $16c69cc12596049f$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    return /*#__PURE__*/ $7fPBF.createElement((0, $77083a3acb5fe2c8$export$2e2bcd8739ae039), (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $ba1585ba38011074$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), children);
};
var $ad395143f96b71e1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $7fPBF.forwardRef)($ad395143f96b71e1$var$Tooltip);



var $7f30d1247af47f5e$export$2e2bcd8739ae039 = (0, $ad395143f96b71e1$export$2e2bcd8739ae039);


function $1315fed79c3e5f35$var$TooltipWrapper(props) {
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const { value: value, valuesArray: valuesArray, children: children, visible: visible, tipFormatter: tipFormatter = (val)=>`${new Date(props.valuesArray[val]).toLocaleDateString("de", {
            month: "short",
            timeZone: "UTC"
        }).substring(0, 3)}
    ${new Date(props.valuesArray[val]).toLocaleDateString("de", {
            year: "numeric",
            timeZone: "UTC"
        })}` } = props, restProps = (0, $bLhVg._)(props, [
        "value",
        "valuesArray",
        "children",
        "visible",
        "tipFormatter"
    ]);
    const tooltipRef = $7fPBF.useRef();
    const rafRef = $7fPBF.useRef(null);
    function keepAlign() {
        rafRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($cdb391a262b13a19$exports)))(()=>{
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.forceAlign();
        });
    }
    function cancelKeepAlign() {
        (0, (/*@__PURE__*/$parcel$interopDefault($cdb391a262b13a19$exports))).cancel(rafRef.current);
    }
    $7fPBF.useEffect(()=>{
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        value,
        visible
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f30d1247af47f5e$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({
        placement: "top",
        overlay: tipFormatter(value),
        overlayInnerStyle: {
            minHeight: "auto"
        },
        ref: tooltipRef,
        visible: visible
    }, restProps), {
        children: children
    }));
}
const $1315fed79c3e5f35$export$5bf564cde944194f = (node, props)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1315fed79c3e5f35$var$TooltipWrapper, {
        value: props.value,
        visible: props.dragging,
        children: node
    });
function $1315fed79c3e5f35$var$TooltipSlider(_param) {
    var { tipFormatter: tipFormatter, tipProps: tipProps, valuesArray: valuesArray } = _param, props = (0, $bLhVg._)(_param, [
        "tipFormatter",
        "tipProps",
        "valuesArray"
    ]);
    const tipHandleRender = (node, handleProps)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1315fed79c3e5f35$var$TooltipWrapper, (0, $2qxEV._)((0, $9tqwB._)({
            value: handleProps.value,
            visible: handleProps.dragging,
            tipFormatter: tipFormatter,
            valuesArray: valuesArray
        }, tipProps), {
            children: node
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "sr-only",
                id: "slider-label-value-hidden",
                children: new Date(valuesArray === null || valuesArray === void 0 ? void 0 : valuesArray[props === null || props === void 0 ? void 0 : props.value]).toLocaleDateString("de", {
                    year: "numeric",
                    month: "2-digit",
                    timeZone: "UTC"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3475369afda2fcc5$export$2e2bcd8739ae039), (0, $2qxEV._)((0, $9tqwB._)({}, props), {
                handleRender: tipHandleRender
            }))
        ]
    });
}
var $1315fed79c3e5f35$export$2e2bcd8739ae039 = $1315fed79c3e5f35$var$TooltipSlider;





(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $18cd6c5722416c98$export$2e2bcd8739ae039({ theme: theme }) {
    // 'light' (to be displayed on blue background in Projects) or 'dark' (in Project Details on light background)
    const baseDate = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.baseDate);
    const sliderPreferences = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings);
    // sliderState.baseDate is the date to which the slider is set (in epoch milliseconds UTC)
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const currentBreakpoint = (0, $29b77351b10ec0da$export$2e2bcd8739ae039)();
    const date = new Date(sliderPreferences.sliderStartDate || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().subtract(10, "year").startOf("month")); // beginning date
    const maxDate = new Date(sliderPreferences.sliderEndDate || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(10, "year").startOf("month")); // ending date
    date.setUTCMonth(0); // set to January
    date.setUTCDate(1); // set to 1st
    date.setUTCHours(0, 0, 0, 0); // set to midnight
    function getAxisLabelDistance() {
        if (currentBreakpoint === null) return 48;
        if ([
            "sm",
            "md",
            "lg"
        ].includes(currentBreakpoint)) return 24;
        return 12;
    }
    // takes store contents as input and converts it into a list of steps for the slider
    const stepsArray = [];
    let marksObject = {};
    const axisLabelDistance = getAxisLabelDistance();
    while(date <= maxDate){
        if (date.getUTCDate() === 1 && date.getUTCMonth() === 0 && stepsArray.length % axisLabelDistance === 0) marksObject = (0, $2qxEV._)((0, $9tqwB._)({}, marksObject), {
            [Number(stepsArray.length)]: String(date.getUTCFullYear())
        });
        stepsArray.push(date.valueOf());
        date.setUTCMonth(date.getUTCMonth() + 1);
    }
    // need to store it locally to faciliate a slight delay before calculating the entire dataload
    // find index of baseDate in stepsArray and set sliderIndex to it
    const [sliderIndex, setSliderIndex] = (0, $7fPBF.useState)(stepsArray.indexOf(baseDate.valueOf()));
    // TODO: turn slider holder into spinner when loading data
    function onSliderChange(value) {
        setSliderIndex(value); // update screen, but don't update store yet
    // triggers useEffect below which handles the timeout
    }
    const previousSliderIndex = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    const isFirstRender = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(true);
    // handle store updates
    (0, $7fPBF.useEffect)(()=>{
        // don't run on first render (only)
        if (isFirstRender.current) {
            isFirstRender.current = false;
            previousSliderIndex.current = sliderIndex; // set index to the initialised value so that we know if it changes for the code below
            return ()=>{};
        }
        if (previousSliderIndex.current === sliderIndex) return ()=>{};
        previousSliderIndex.current = sliderIndex;
        const timeoutId = setTimeout(()=>{
            // dispatch(setSimulationBaseDate({ newDate: new Date(stepsArray[sliderIndex]) }));
            dispatch((0, $47d2e16a1696e57a$export$284f9e3210b39fb4)({
                newDate: new Date(stepsArray[sliderIndex]).valueOf()
            }));
        }, 600);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        sliderIndex
    ]);
    // react to selector change
    (0, $7fPBF.useEffect)(()=>{
        const incomingSliderIndex = stepsArray.indexOf(baseDate.valueOf());
        if (sliderIndex !== incomingSliderIndex) setSliderIndex(incomingSliderIndex);
    }, [
        baseDate
    ]);
    // step depends on the screen size
    function calculateSteps() {
        if (currentBreakpoint === "xs" || currentBreakpoint === null) return 24;
        if (currentBreakpoint === "sm") return 12;
        if (currentBreakpoint === "md") return 3;
        return 1;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "projects-slider-parent",
        className: "px-4 text-xs",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1315fed79c3e5f35$export$2e2bcd8739ae039), {
            value: sliderIndex,
            valuesArray: stepsArray,
            min: 0,
            max: stepsArray.length,
            step: calculateSteps(),
            className: theme,
            tipProps: {
                overlayClassName: theme
            },
            dots: false,
            marks: marksObject,
            onChange: onSliderChange
        })
    });
}
$18cd6c5722416c98$export$2e2bcd8739ae039.propTypes = {
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "light",
        "dark"
    ])
};
$18cd6c5722416c98$export$2e2bcd8739ae039.defaultProps = {
    theme: "light"
};











function $dcbc916054f26600$export$2e2bcd8739ae039(isolatedProjectId) {
    const state = (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039).getState();
    const isolatedQuotes = (0, $93bb2798871a68d2$export$32058f168ca0310f)(state, isolatedProjectId);
    const globalQuotes = (0, $93bb2798871a68d2$export$32058f168ca0310f)(state, undefined);
    const collisions = [];
    // globalQuotesView has also extrapolated / simulated quotes, so filter them out first; there may also be "null" quotes created for dates where other assets have quotes, so filter them out too
    isolatedQuotes.filter((q)=>q.quote && q.date === q.quoteDate).forEach((isolatedQuote)=>{
        globalQuotes.filter((q)=>q.quote && q.date === q.quoteDate).forEach((globalQuote)=>{
            if (isolatedQuote.date === globalQuote.date && isolatedQuote.assetId === globalQuote.assetId) collisions.push({
                isolatedQuote: isolatedQuote,
                globalQuote: globalQuote,
                selected: null
            });
        });
    });
    // put them into state as an collidingQuotes array [ { isolatedQuote, globalQuote, selected: isolated | global | null  } ]
    return collisions;
}




/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








const $0bbe7f8c8994b1a6$var$debugLevel = 0;

(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $0bbe7f8c8994b1a6$export$2e2bcd8739ae039({ goalDialog: goalDialog, setGoalDialog: setGoalDialog, project: project }) {
    var _errors_name, _errors_date, _errors_amount;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // save button was clicked
    const [deleting, setDeleting] = (0, $7fPBF.useState)(false); // delete button was clicked
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const defaultValuesEmptyForm = {
        name: null,
        date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().add(10, "years").startOf("month").format("YYYY-MM-DD"),
        // first day of current month; toISOString returns UTC time (which is 1 day behind in Berlin), so using Swedish format which the same timezone as Berlin
        amount: 100000
    };
    // initialise the form with values from an existing object or default values
    const formObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: goalDialog === true ? defaultValuesEmptyForm : (0, $2qxEV._)((0, $9tqwB._)({}, goalDialog), {
            date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(goalDialog.date).format("YYYY-MM-DD")
        })
    });
    const { handleSubmit: handleSubmit, register: register, setValue: setValue, formState: { errors: errors } } = formObject;
    async function onGoalChange(e, mode = "put") {
        e.preventDefault();
        if (mode === "delete") setDeleting(true);
        else setLoading(true);
        const formDataRaw = formObject.getValues();
        const formData = (0, $2qxEV._)((0, $9tqwB._)({}, formDataRaw), {
            date: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formDataRaw.date).valueOf()
        });
        const newProjectObject = (0, $2qxEV._)((0, $9tqwB._)({}, project), {
            goals: (project.goals || []).filter((g)=>g.date !== (goalDialog === null || goalDialog === void 0 ? void 0 : goalDialog.date))
        });
        if (mode !== "delete") newProjectObject.goals.push(formData); // if this is add or change, add the new goal
        try {
            await dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)(newProjectObject));
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            setGoalDialog(false);
        } catch (error) {
            console.error("AddProjectGoal error", error);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
        }
        setLoading(false);
        setDeleting(false);
    }
    const myRef = (0, $7fPBF.useRef)(null);
    // scroll all the way up when the dialog opens
    (0, $7fPBF.useEffect)(()=>{
        var _myRef_current;
        if (goalDialog) (_myRef_current = myRef.current) === null || _myRef_current === void 0 ? void 0 : _myRef_current.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start"
        });
    }, [
        goalDialog
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "add-project-goal",
        "data-testid": "add-project-goal",
        className: "bg-opacity-90 bg-gray-300 absolute top-0 left-0 w-full h-full z-[100] p-4",
        ref: myRef,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex flex-col items-center justify-center h-full",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                autoComplete: "off",
                onSubmit: (e)=>handleSubmit(onGoalChange(e, "put")),
                className: "relative bg-white rounded-md shadow-lg p-8 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: "project-details-add-transaction-close",
                        onClick: (e)=>{
                            setGoalDialog(false);
                        },
                        className: "absolute top-4 right-4 cursor-pointer",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-500 hover:text-gray-600"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mb-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "inline text-2xl font-bold text-gray-900",
                                children: t("addGoal")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-lg font-normal text-gray-900",
                                children: t("addGoalDescription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 gap-12",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "pb-8",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "name",
                                        className: "block text-sm font-medium text-gray-700",
                                        children: t("name")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-1",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                            type: "text",
                                            name: "name",
                                            id: "name",
                                            // onChange
                                            className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                        }, register("name", {
                                            required: t("required")
                                        })))
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: (_errors_name = errors.name) === null || _errors_name === void 0 ? void 0 : _errors_name.message
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "pb-8",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "date",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: t("date")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-1",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                type: "date",
                                                name: "date",
                                                id: "date",
                                                step: "month",
                                                // onChange
                                                className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                            }, register("date", {
                                                // round down to first day of month
                                                onChange: (e)=>{
                                                    const dateEpoch = new Date(e.target.value);
                                                    dateEpoch.setDate(1);
                                                    let value;
                                                    try {
                                                        [value] = dateEpoch.toISOString().split("T");
                                                    } catch (err) {
                                                    // when user uses arrow to change day by one lower and comes to an incorrect date as an effect (e.g. 31-02-2021)
                                                    // the field sends an empty string as e.target.value and we reset it to the previous value (from form state)
                                                    // value = transactionDate;  // FIXME
                                                    }
                                                    setValue("date", value);
                                                },
                                                validate: (value)=>{
                                                    if (new Date(value) > new Date()) return true;
                                                    return t("date.error");
                                                }
                                            })))
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: (_errors_date = errors.date) === null || _errors_date === void 0 ? void 0 : _errors_date.message
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "grid grid-cols-2 gap-3",
                                id: "project-details-add-goal-amount",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "amount",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: t("amount.label")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-1 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                    type: "number",
                                                    step: 1,
                                                    name: "amount",
                                                    id: "amount",
                                                    placeholder: 100000,
                                                    className: "block w-full rounded-md border-gray-300 shadow-sm focus:border-brandBlue-500 focus:ring-brandBlue-600 sm:text-sm"
                                                }, register("amount", {
                                                    min: {
                                                        value: 0,
                                                        message: t("amount.error")
                                                    }
                                                }))),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "ml-1 text-sm",
                                                    children: baseCurrency
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: (_errors_amount = errors.amount) === null || _errors_amount === void 0 ? void 0 : _errors_amount.message
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-start items-center gap-4 pt-6",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-goal-save",
                                "data-testid": "project-add-goal-save",
                                type: "submit",
                                // eslint-disable-next-line max-len
                                className: "inline-flex items-center rounded-md border border-transparent bg-brandBlue-500 hover:bg-brandBlue-600 px-4 py-2 text-sm font-medium leading-4 text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                children: loading === false ? t("save") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    id: "project-add-goal-spinner",
                                    className: "px-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 text-white animate-spin"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-goal-delete",
                                type: "button",
                                onClick: (e)=>onGoalChange(e, "delete"),
                                disabled: goalDialog === true,
                                // eslint-disable-next-line max-len
                                className: `inline-flex items-center rounded-md border px-4 py-2 text-sm font-medium leading-4 ${goalDialog === true ? "hidden" : "text-gray-700 border-gray-300 bg-white"} shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2`,
                                children: deleting === false ? t("deleteGoal") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    id: "project-delete-goal-spinner",
                                    className: "px-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 text-gray-400 animate-spin"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-goal-cancel",
                                type: "button",
                                onClick: (e)=>{
                                    setGoalDialog(false);
                                },
                                // eslint-disable-next-line max-len
                                className: "inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                children: t("cancel")
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$0bbe7f8c8994b1a6$export$2e2bcd8739ae039.propTypes = {
    goalDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    setGoalDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired
};
$0bbe7f8c8994b1a6$export$2e2bcd8739ae039.defaultProps = {
    goalDialog: null
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");





function $11c191ccac7bef2e$export$2e2bcd8739ae039({ project: project }) {
    var _project_settings;
    const selectedType = project === null || project === void 0 ? void 0 : (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.progressIndicator;
    const [query, setQuery] = (0, $7fPBF.useState)("");
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const widgetTypes = [
        {
            type: "roi",
            label: t("roi")
        },
        {
            type: "duration",
            label: t("duration")
        },
        {
            type: "goal",
            label: t("goal")
        }
    ];
    const filteredValues = query === "" ? widgetTypes : widgetTypes.filter((x)=>x.label.toUpperCase().includes(query.toUpperCase()));
    const selectedWidget = widgetTypes.find((x)=>x.type === selectedType) || widgetTypes[0];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
        as: "div",
        value: selectedType,
        onChange: (e)=>{
            if (!(project === null || project === void 0 ? void 0 : project.id)) return;
            dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
                settings: (0, $2qxEV._)((0, $9tqwB._)({}, project.settings), {
                    progressIndicator: e.type
                })
            })));
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Label, {
                className: "block text-sm font-medium text-gray-700",
                children: t("progressIndicator")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative mt-1.5 w-24",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                        className: "w-24 text-left rounded-md border border-gray-300 bg-white py-1 pl-2 pr-5 shadow-sm focus:border-brandBlue-400 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 sm:text-xs",
                        onChange: (event)=>setQuery(event.target.value),
                        children: [
                            selectedWidget === null || selectedWidget === void 0 ? void 0 : selectedWidget.label,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01f5965251d69098$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    filteredValues.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                        className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xs",
                        children: filteredValues.map((x)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                value: x,
                                className: ({ active: active })=>`relative cursor-default select-none py-2 pl-2 pr-4 ${active ? "bg-brandBlue-600 text-white" : "text-gray-900"}`,
                                children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: `block truncate ${selected && "font-semibold"}`,
                                                children: x.label
                                            }),
                                            selected && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: `absolute inset-y-0 left-0 flex items-center pl-1.5 ${active ? "text-white" : "text-brandBlue-600"}`,
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $debc1b868f0a1333$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            })
                                        ]
                                    })
                            }, x))
                    })
                ]
            })
        ]
    });
}
$11c191ccac7bef2e$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
};
$11c191ccac7bef2e$export$2e2bcd8739ae039.defaultProps = {
    project: null
};


/* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");











const $ced8fade668c1ecc$var$debugLevel = 0;

(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $ced8fade668c1ecc$export$2e2bcd8739ae039({ setAssetGrowthDialog: setAssetGrowthDialog, project: project, assetsList: assetsList }) {
    var _project_settings;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false); // save button was clicked
    const isIsolated = ((_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated) || false;
    const initialValue = isIsolated ? project.settings || [] : (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.data.stocks.settings) || [];
    // initialise the form with values from an existing object or default values
    const { register: register, control: control, handleSubmit: handleSubmit, formState: { errors: errors }, watch: watch } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: initialValue
    }); // intialised after useEffect fetches data from Amplify store
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        name: "growthRates",
        control: control
    });
    // submits the form object to backend
    async function onSubmit({ growthRates: growthRates }) {
        // if this is an isolated project, save growthRates to project
        // otherwise send them to the store (to be saved in the stocks settings)
        try {
            setLoading(true);
            if (isIsolated) await dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
                settings: (0, $2qxEV._)((0, $9tqwB._)({}, project.settings), {
                    growthRates: growthRates
                })
            })));
            else // TODO stock settings have more settings, i.e. advanced vs normal mode, if normal, then overall setting, if advanced, then per asset
            // TODO besides, both here and in the Settings > Simulation it should be possible to set growth rates for all the asset classes, not only stocks - in preparation for the future
            await dispatch((0, $f1c3fa004749592f$export$64ebf73f0218161c)({
                data: {
                    growthRates: growthRates
                },
                category: "stocks"
            }));
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            setLoading(false);
            setAssetGrowthDialog(false);
        } catch (e) {
            console.error(e);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            setLoading(false);
        }
    }
    const assetList = assetsList;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "project-details-growth-rates",
        "data-testid": "project-details-growth-rates",
        className: "bg-opacity-90 bg-gray-300 absolute top-0 left-0 w-full h-full z-[100] p-4",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "flex flex-col items-center justify-center h-full",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                autoComplete: "off",
                onSubmit: handleSubmit(onSubmit),
                className: "relative bg-white rounded-md shadow-lg p-8 max-w-6xl",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: "project-details-growth-rates-close",
                        onClick: (e)=>{
                            setAssetGrowthDialog(false);
                        },
                        className: "absolute top-4 right-4 cursor-pointer",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-500 hover:text-gray-600"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mb-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "inline text-2xl font-bold text-gray-900",
                                children: t("growthRates")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                className: "text-lg font-normal text-gray-900",
                                children: isIsolated ? t("growthRatesDescription") : t("growthRatesNonIsolated")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "sm:grid sm:grid-cols-3 gap-12",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dfdc37dc6f1dff1b$export$2e2bcd8739ae039), (0, $9tqwB._)({
                            register: register,
                            fields: fields,
                            append: append,
                            remove: remove,
                            control: control,
                            errors: errors,
                            watch: watch,
                            fieldsGrowthRates: fields,
                            appendGrowthRates: append,
                            removeGrowthRates: remove
                        }, isIsolated && assetList))
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-start items-center gap-4 pt-6",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-quote-save",
                                "data-testid": "project-add-quote-save",
                                type: "submit",
                                // eslint-disable-next-line max-len
                                className: "inline-flex items-center rounded-md border border-transparent bg-brandBlue-500 hover:bg-brandBlue-600 px-4 py-2 text-sm font-medium leading-4 text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                children: loading === false ? t("save") : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    id: "project-add-quote-spinner",
                                    className: "px-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 text-white animate-spin"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                id: "project-add-quote-cancel",
                                type: "button",
                                onClick: (e)=>{
                                    setAssetGrowthDialog(false);
                                },
                                // eslint-disable-next-line max-len
                                className: "inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                                children: t("cancel")
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$ced8fade668c1ecc$export$2e2bcd8739ae039.propTypes = {
    setAssetGrowthDialog: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    assetsList: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
};
$ced8fade668c1ecc$export$2e2bcd8739ae039.defaultProps = {
    assetsList: []
};




function $04a7d16a2460515d$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $04a7d16a2460515d$var$CloseIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
        className: "h-6 w-6"
    });
}
function $04a7d16a2460515d$var$AddTransactionIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fe3802f808215e9$export$2e2bcd8739ae039), {
        className: "-ml-0.5 mr-2 h-4 w-4 text-white",
        "aria-hidden": "true"
    });
}
function $04a7d16a2460515d$var$AddQuoteIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5fe3802f808215e9$export$2e2bcd8739ae039), {
        className: "-ml-0.5 mr-2 h-4 w-4 text-gray-600",
        "aria-hidden": "true"
    });
}
function $04a7d16a2460515d$var$GrowthRatesIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aabf4df1bf2eda9b$export$2e2bcd8739ae039), {
        className: "-ml-0.5 mr-2 h-4 w-4 text-gray-400",
        "aria-hidden": "true"
    });
}
function $04a7d16a2460515d$var$ApplyTemplateIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $36bc87590b707b9b$export$2e2bcd8739ae039), {
        className: "-ml-0.5 mr-2 h-4 w-4 text-gray-400",
        "aria-hidden": "true"
    });
}
const $04a7d16a2460515d$var$ProjectAssetTile = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function ProjectAssetTile({ header: header, sum: sum, account: account, baseCurrency: baseCurrency }) {
    const isHovered = (0, $f1298db2f868236d$export$ceb059a92eb5412d)(account === null || account === void 0 ? void 0 : account.id);
    if (!account) {
        console.error("ProjectAssetTile: account is missing", header, sum);
        return null;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: `project-asset-tile-${(account === null || account === void 0 ? void 0 : account.id) || "none"}`,
        className: `p-4 ${isHovered ? "bg-brandBlue-50" : "bg-white"} border border-gray-300 rounded-lg shadow-sm`,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "text-gray-500 font-bold text-sm truncate uppercase",
                children: header
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "text-gray-900 text-xl font-bold",
                    children: sum.toLocaleString("de", {
                        maximumFractionDigits: 0,
                        style: "currency",
                        currency: baseCurrency || "EUR"
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                accountName: account.name,
                category: account.category
            })
        ]
    });
});
$04a7d16a2460515d$var$ProjectAssetTile.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    sum: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
    account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$04a7d16a2460515d$var$ProjectAssetTile.defaultProps = {
    baseCurrency: "EUR"
};
function $04a7d16a2460515d$export$2e2bcd8739ae039({ projectId: projectId, setProjectId: setProjectId, setCalendarState: setCalendarState }) {
    var _project_settings, _project_settings1, _project_settings2, _project_settings3, _project_settings4, _project_settings5;
    // on mobile layouts, when dashboard is scrolled to the bottom, this component is rendered "above" the visible screen
    // as scrolling is disabled, the user cannot scroll to the top of the page -- so we have to do it for him
    // scroll to the top of the page (somehow it got rendered in the middle)
    const myRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        myRef.current.scrollIntoView({
            behavior: "instant"
        });
    }, []);
    const { t: tProjects, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const { t: tAccountDetails } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails");
    const [transactionDialog, setTransactionDialog] = (0, $7fPBF.useState)(null); // null is invisible, any value means visible (true or transaction object)
    const refTransactionDialog = (0, $7fPBF.useRef)(undefined);
    refTransactionDialog.current = transactionDialog; // used in a listener below
    const [quoteDialog, setQuoteDialog] = (0, $7fPBF.useState)(false);
    const refQuoteDialog = (0, $7fPBF.useRef)(undefined);
    refQuoteDialog.current = quoteDialog; // used in a listener below
    const [assetGrowthDialog, setAssetGrowthDialog] = (0, $7fPBF.useState)(false);
    const refAssetGrowthDialog = (0, $7fPBF.useRef)(undefined);
    refAssetGrowthDialog.current = assetGrowthDialog; // used in a listener below
    const [goalDialog, setGoalDialog] = (0, $7fPBF.useState)(false);
    const refGoalDialog = (0, $7fPBF.useRef)(undefined);
    refGoalDialog.current = goalDialog; // used in a listener below
    const [templateDialog, setTemplateDialog] = (0, $7fPBF.useState)(false);
    const [removeSubmitted, setRemoveSubmitted] = (0, $7fPBF.useState)(false); // displays spinner when remove template button clicked
    const [collisionsDialog, setCollisionsDialog] = (0, $7fPBF.useState)(false);
    const filterList = [
        "recurring",
        "simulatedDividends",
        "simulatedInterest",
        "simulatedQuotes",
        "simulatedPension"
    ];
    // option source for the dropdown in FilterListbox
    // used at two places in ProjectTransactionList to filter transactions accordingly (in useEffect for recurring and in filterCallback for labels)
    const [filteredItems, setFilteredItems] = (0, $7fPBF.useState)([
        "simulatedDividends",
        "simulatedInterest",
        "simulatedQuotes",
        "simulatedPension"
    ]); // used to filter transactions by account; we do not want to expand all recurring txns in the beginning
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const project = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects.find((item)=>item.id === projectId));
    const selectProjectTransactions = (0, $7fPBF.useMemo)((0, $3679aa7475d9bd44$export$67bceb1b22c62e05), []);
    const selectProjectAssetsSummary = (0, $7fPBF.useMemo)((0, $3679aa7475d9bd44$export$5c7c369f7ca49fb9), []);
    const transactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>selectProjectTransactions(state, projectId)); // filter out those which belong to the current project
    const projectAssetsSummary = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>selectProjectAssetsSummary(state, projectId));
    const currentProjectId = projectId;
    // set to true if there is any transaction in transactions which has a tag of partOfProjectTemplate of any value
    const templateDetected = transactions === null || transactions === void 0 ? void 0 : transactions.some((txn)=>{
        var _txn_tags;
        return txn.projectId === projectId && ((_txn_tags = txn.tags) === null || _txn_tags === void 0 ? void 0 : _txn_tags.partOfProjectTemplate);
    });
    const alert = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.alert);
    // handle user input from alert modal when closing the entire form
    (0, $7fPBF.useEffect)(()=>{
        if ((alert === null || alert === void 0 ? void 0 : alert.id) === "aboutToLoseData") {
            if ((alert === null || alert === void 0 ? void 0 : alert.response) === "ok") setProjectId(null);
        }
    }, [
        alert === null || alert === void 0 ? void 0 : alert.response
    ]);
    function handleClose(e) {
        setProjectId(null);
    }
    // if there is a dialog window open, listen for Esc key and close the dialog if it is pressed
    // otherwise close the entire form
    (0, $7fPBF.useEffect)(()=>{
        function handleEsc(e) {
            if (e.key === "Escape") {
                if (refTransactionDialog.current) setTransactionDialog(false);
                else if (refQuoteDialog.current) setQuoteDialog(false);
                else if (refAssetGrowthDialog.current) setAssetGrowthDialog(false);
                else if (refGoalDialog.current) setGoalDialog(false);
                else setProjectId(null);
            }
        }
        document.addEventListener("keydown", handleEsc, false);
        return ()=>{
            document.removeEventListener("keydown", handleEsc, false);
        };
    }, []); // it needs to be one object; if it is more, it creates several listeners
    async function deleteProjectCallback() {
        if (!(project === null || project === void 0 ? void 0 : project.id)) return;
        await dispatch((0, $101425bdfe5b6af9$export$d7ff2361273ba2c2)(project));
        setProjectId(null);
    }
    function handleDeleteProject() {
        if (!(project === null || project === void 0 ? void 0 : project.id)) return;
        window.dispatchEvent(new CustomEvent("setAlert", {
            detail: {
                id: "youAreAboutToDeleteProject",
                caller: project.id,
                callbackOk: deleteProjectCallback
            }
        }));
    }
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_user_profile_settings;
        return ((_state_user_profile_settings = state.user.profile.settings) === null || _state_user_profile_settings === void 0 ? void 0 : _state_user_profile_settings.baseCurrency) || "EUR";
    });
    const projectSum = (projectAssetsSummary === null || projectAssetsSummary === void 0 ? void 0 : projectAssetsSummary.projectSum) || 0;
    const projectAssets = (projectAssetsSummary === null || projectAssetsSummary === void 0 ? void 0 : projectAssetsSummary.projectAssets) || [];
    const assetsList = (projectAssetsSummary === null || projectAssetsSummary === void 0 ? void 0 : projectAssetsSummary.assetsList) || [];
    async function deleteTemplateTransactions() {
        if (!currentProjectId) return;
        setRemoveSubmitted(true);
        const transactionsToBeDeleted = transactions === null || transactions === void 0 ? void 0 : transactions.filter((item)=>item.projectId === currentProjectId && item.tags.partOfProjectTemplate).map((item)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
                importFlag: "delete"
            }));
        await dispatch((0, $f1c3fa004749592f$export$942e92bd9e040eb)({
            payload: transactionsToBeDeleted
        }));
        setRemoveSubmitted(false);
    }
    function handleTemplateButton(e) {
        if (!templateDetected) setTemplateDialog(true);
        else {
            if (!currentProjectId) return;
            window.dispatchEvent(new CustomEvent("setAlert", {
                detail: {
                    id: "youAreAboutToDeleteTemplateTransactions",
                    caller: currentProjectId,
                    callbackOk: deleteTemplateTransactions
                }
            }));
        }
    }
    function handleIsolatedFlagChange(e) {
        var _project_settings;
        if (!(project === null || project === void 0 ? void 0 : project.id)) return;
        // if the project is currently isolated, we need to check if there are conflicts between isolated project quotes of this project and global quotes
        if ((_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.isIsolated) {
            // get a list of collisions (stockQuotes has the quotes for this isolated project; the function needs to run global quotes again with no parameter)
            const collisions = (0, $dcbc916054f26600$export$2e2bcd8739ae039)(project.id);
            // if the list is not empty, display dialog (dialog to handle conflicts and runs the dispatch below)
            if (collisions.length > 0) setCollisionsDialog(collisions);
            else dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
                settings: (0, $2qxEV._)((0, $9tqwB._)({}, project.settings), {
                    isIsolated: false
                })
            })));
        } else dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)((0, $2qxEV._)((0, $9tqwB._)({}, project), {
            settings: (0, $2qxEV._)((0, $9tqwB._)({}, project.settings), {
                isIsolated: true
            })
        })));
    }
    async function inputFieldCallback({ propertyName: propertyName, newValue: newValue }) {
        const projectObject = (0, $2qxEV._)((0, $9tqwB._)({}, project), {
            [propertyName]: newValue
        });
        let result;
        try {
            result = await dispatch((0, $101425bdfe5b6af9$export$e71a6698fc19e7be)(projectObject));
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
        } catch (err) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedWithErrors"));
            throw new Error("accountCouldNotBeUpdated"); // the error is caught in the InputComponent
        }
        return result; // handled in InputComponent
    }
    // NOTE: '(project) &&' as well as 'project?.' is used to prevent errors after project has been deleted and the form isn't off yet (for a split second, but it happens)
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: "projectDetailsParent",
        ref: myRef,
        className: "absolute w-full h-auto min-h-full z-50 top-0 left-0 md:p-16 bg-gray-300 bg-opacity-90 space-y-6",
        role: "dialog",
        children: [
            transactionDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af3f7d478ae08c2a$export$2e2bcd8739ae039), {
                setCalendarState: setCalendarState,
                transactionDialog: transactionDialog,
                setTransactionDialog: setTransactionDialog,
                projectId: projectId,
                stocksAssets: assetsList
            }),
            quoteDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $65b501ec2ba9b271$export$2e2bcd8739ae039), {
                quoteDialog: quoteDialog,
                // ^^ values are: null, true (if user clicked New and this is empty) or a quote object (if user clicked on a quote)
                setQuoteDialog: setQuoteDialog,
                assetsList: assetsList,
                project: project
            }),
            assetGrowthDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ced8fade668c1ecc$export$2e2bcd8739ae039), {
                setAssetGrowthDialog: setAssetGrowthDialog,
                assetsList: assetsList,
                project: project
            }),
            goalDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bbe7f8c8994b1a6$export$2e2bcd8739ae039), {
                goalDialog: goalDialog,
                // ^^ values are: null, true (if user clicked New and this is empty) or a goal object (if user clicked on a goal)
                setGoalDialog: setGoalDialog,
                project: project
            }),
            templateDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9dfba0c8f5fda393$export$2e2bcd8739ae039), {
                templateDialog: templateDialog,
                setTemplateDialog: setTemplateDialog,
                project: project
            }),
            collisionsDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c6fb07c9e265150$export$2e2bcd8739ae039), {
                collisions: collisionsDialog,
                setCollisionDialog: setCollisionsDialog,
                project: project
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "projectSlider",
                className: "lg:rounded-md lg:-mt-8 px-4 py-6 bg-white",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18cd6c5722416c98$export$2e2bcd8739ae039), {
                    theme: "dark"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: `relative bg-gray-50 shadow xl:h-[85vh] sm:rounded-lg
        overflow-y-scroll scrollbar-thin scrollbar-track-rounded scrollbar-thumb-rounded scrollbar-track-gray-200 scrollbar-thumb-gray-400`,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        id: "project-details-close-button",
                        className: "hidden lg:inline-block fixed top-4 right-2 m-4 cursor-pointer",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                            className: "w-6 h-6 text-gray-500 hover:text-gray-600",
                            onClick: handleClose
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        id: "account-details-help-button",
                        href: `/${i18n.language}/blog/${(0, $99f87ace30ad8515$export$ed2efc2636e0089e)("financial-simulations-with-monestry-how-does-my-wealth-grow", i18n.language)}`,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "hidden lg:inline fixed top-12 right-2 m-4 cursor-pointer",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                            info: tAccountDetails("help"),
                            className: "-translate-x-20",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c67e8e5ff55101a6$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-brandBlue-400 hover:text-brandBlue-500",
                                onClick: ()=>{}
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative px-4 py-5 sm:pl-8 sm:pr-10 sm:py-8 flex flex-col gap-4 sm:gap-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                id: "project-details-close-button",
                                className: "lg:hidden absolute top-1 right-1 m-4 cursor-pointer",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                                    className: "w-6 h-6 text-gray-500 hover:text-gray-600",
                                    onClick: handleClose
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                id: "account-details-help-button",
                                className: "lg:hidden absolute top-1 right-9 m-4 cursor-pointer",
                                href: `/${i18n.language}/blog/${(0, $99f87ace30ad8515$export$ed2efc2636e0089e)("financial-simulations-with-monestry-how-does-my-wealth-grow", i18n.language)}`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                    info: tAccountDetails("help"),
                                    className: "-translate-x-20",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c67e8e5ff55101a6$export$2e2bcd8739ae039), {
                                        className: "w-6 h-6 text-brandBlue-400 hover:text-brandBlue-500",
                                        onClick: ()=>{}
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                "aria-label": "project header",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex items-center justify-between pt-4 sm:pt-0",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: project && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8e0c1e291bc90f03$export$2e2bcd8739ae039), {
                                                callback: inputFieldCallback,
                                                parentValue: project.name,
                                                formatting: "sm:-ml-[0.4rem] text-2xl sm:text-3xl font-bold text-gray-900",
                                                attr: "name",
                                                stub: "Project name?",
                                                showButtons: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            id: "projectSum",
                                            className: "flex-shrink-0 flex md:mt-0 md:ml-4 z-10",
                                            children: project && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate",
                                                children: projectSum.toLocaleString("de", {
                                                    style: "currency",
                                                    currency: baseCurrency || "EUR",
                                                    maximumFractionDigits: 0
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                                "aria-label": "project settings",
                                className: "flex gap-8 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "w-full lg:w-80 border rounded bg-white p-2 flex-shrink-0",
                                        children: [
                                            (project === null || project === void 0 ? void 0 : (_project_settings = project.settings) === null || _project_settings === void 0 ? void 0 : _project_settings.progressIndicator) === "roi" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecaa4797207ab7c3$export$2e2bcd8739ae039), {
                                                project: project
                                            }),
                                            (project === null || project === void 0 ? void 0 : (_project_settings1 = project.settings) === null || _project_settings1 === void 0 ? void 0 : _project_settings1.progressIndicator) === "duration" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32655ef1093ac6e9$export$2e2bcd8739ae039), {
                                                projectId: project === null || project === void 0 ? void 0 : project.id
                                            }),
                                            (project === null || project === void 0 ? void 0 : (_project_settings2 = project.settings) === null || _project_settings2 === void 0 ? void 0 : _project_settings2.progressIndicator) === "goal" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $be1ff2970a62d1fa$export$2e2bcd8739ae039), {
                                                project: project
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        id: "projectProgressIndicator",
                                        className: "hidden lg:block space-y-2 text-sm text-gray-900",
                                        children: project && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $11c191ccac7bef2e$export$2e2bcd8739ae039), {
                                            project: project
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        id: "projectIsolated",
                                        className: "hidden lg:block space-y-2 text-sm text-gray-900",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "font-medium",
                                                children: tProjects("visible")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex flex-nowrap items-center gap-2 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-gray-500",
                                                        children: tProjects("yes")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), {
                                                        checked: project === null || project === void 0 ? void 0 : (_project_settings3 = project.settings) === null || _project_settings3 === void 0 ? void 0 : _project_settings3.isIsolated,
                                                        onChange: handleIsolatedFlagChange,
                                                        className: "bg-gray-300 hover:bg-gray-400 relative inline-flex h-5 w-10 items-center rounded-full",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: `${(project === null || project === void 0 ? void 0 : (_project_settings4 = project.settings) === null || _project_settings4 === void 0 ? void 0 : _project_settings4.isIsolated) ? "translate-x-6" : "translate-x-1"} inline-block h-3 w-3 transform rounded-full bg-white transition`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "text-gray-500",
                                                        children: tProjects("noDraftMode")
                                                    }),
                                                    (project === null || project === void 0 ? void 0 : (_project_settings5 = project.settings) === null || _project_settings5 === void 0 ? void 0 : _project_settings5.isIsolated) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                        info: tProjects("isolatedWarning"),
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $037bf7a5f2429a57$export$2e2bcd8739ae039), {
                                                            className: "w-5 h-5 text-brandYellow-500"
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "hidden lg:block space-y-1 text-sm text-gray-900",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            type: "button",
                                            id: "project-details-add-goal-button",
                                            text: tProjects("addGoal"),
                                            onClick: ()=>{
                                                setGoalDialog(true);
                                            },
                                            size: "lg"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "hidden lg:block space-y-1 text-sm text-gray-900",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                            type: "button",
                                            id: "project-details-delete-transaction-button",
                                            text: tProjects("delete"),
                                            onClick: handleDeleteProject,
                                            size: "lg"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "grid grid-cols-1 xl:grid-cols-12 gap-8 h-full max-h-full",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "xl:col-span-7 w-full h-full max-h-full",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                                                "aria-label": "project-transactions",
                                                className: "pt-2 w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                        className: "lg:hidden pb-4 text-xl font-bold",
                                                        children: tProjects("transactions")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        id: "projectButtonBar",
                                                        className: "hidden lg:flex gap-4 pb-4 items-stretch",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                className: "text-xl font-bold",
                                                                children: tProjects("transactions")
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                info: tProjects("add"),
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                    type: "button",
                                                                    id: "project-details-add-transaction-button",
                                                                    text: tProjects("add"),
                                                                    Icon: $04a7d16a2460515d$var$AddTransactionIcon,
                                                                    onClick: ()=>{
                                                                        setTransactionDialog(true);
                                                                    },
                                                                    withAccent: true,
                                                                    size: "lg"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                info: assetsList.length === 0 ? tProjects("addQuoteButtonDisabled") : tProjects("addQuoteButtonEnabled"),
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                    type: "button",
                                                                    enabled: assetsList.length > 0,
                                                                    id: "project-details-add-transaction-button",
                                                                    text: tProjects("addQuote"),
                                                                    Icon: $04a7d16a2460515d$var$AddQuoteIcon,
                                                                    onClick: ()=>{
                                                                        setQuoteDialog(true);
                                                                    },
                                                                    size: "lg",
                                                                    textColor: "text-gray-500"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                info: tProjects("growthRatesDescription"),
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                    type: "button",
                                                                    enabled: assetsList.length > 0,
                                                                    id: "project-details-add-transaction-button",
                                                                    text: tProjects("growthRates"),
                                                                    Icon: $04a7d16a2460515d$var$GrowthRatesIcon,
                                                                    onClick: ()=>{
                                                                        setAssetGrowthDialog(true);
                                                                    },
                                                                    size: "lg",
                                                                    textColor: "text-gray-500"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                info: tProjects("applyTemplateDescription"),
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                    type: "button",
                                                                    id: "project-details-apply-template-button",
                                                                    text: templateDetected ? tProjects("removeTemplate") : tProjects("applyTemplate"),
                                                                    Icon: $04a7d16a2460515d$var$ApplyTemplateIcon,
                                                                    onClick: handleTemplateButton,
                                                                    spinnerOn: removeSubmitted,
                                                                    size: "lg",
                                                                    textColor: "text-gray-500"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97d92bccde190f7f$export$2e2bcd8739ae039), {
                                                                filteredItems: filteredItems,
                                                                setFilteredItems: setFilteredItems,
                                                                filterList: filterList
                                                            })
                                                        ]
                                                    }),
                                                    project && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ccf80cc55d780012$export$2e2bcd8739ae039), {
                                                        project: project,
                                                        setTransactionDialog: setTransactionDialog,
                                                        setGoalDialog: setGoalDialog,
                                                        setQuoteDialog: setQuoteDialog,
                                                        projectAssets: assetsList,
                                                        filteredItems: filteredItems
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                className: "text-xl font-bold mt-8 mb-4",
                                                children: "Notes"
                                            }),
                                            project && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c3e47298c918b9dc$export$2e2bcd8739ae039), {
                                                project: project
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                                        "aria-label": "project-assets",
                                        id: "project-assets",
                                        className: "xl:col-span-5",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                info: tProjects("assets.tooltip"),
                                                classNameOwn: "mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                        className: "text-xl font-bold mr-1",
                                                        children: tProjects("assets.label")
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $071105eca597c3d9$export$2e2bcd8739ae039), {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "grid grid-cols-2 gap-2 lg:grid-cols-3 lg:gap-4 sticky",
                                                children: projectAssets && projectAssets.map((asset)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($04a7d16a2460515d$var$ProjectAssetTile, {
                                                        header: asset.header,
                                                        sum: asset.sum,
                                                        account: asset.account,
                                                        baseCurrency: baseCurrency
                                                    }, asset.header + asset.accountId))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75977f0ca8247e66$export$2e2bcd8739ae039), {
                componentName: "projectDetails"
            })
        ]
    }));
}
$04a7d16a2460515d$export$2e2bcd8739ae039.propTypes = {
    projectId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setProjectId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");







var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");



var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");





const $007c634679518524$var$debugLevel = 0;
function $007c634679518524$export$2e2bcd8739ae039({ calendarState: calendarState, setCalendarState: setCalendarState, isViewer: isViewer }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    let baselineDate;
    try {
        baselineDate = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.baselineDate) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$4bb039911f93bce)).baseline;
    } catch (e) {
        baselineDate = (0, $35849f14f39a3bea$export$2e2bcd8739ae039).sameTimeLastYear;
    }
    const baselineTimePeriods = (0, $2qxEV._)((0, $9tqwB._)({
        emptyRow: -1
    }, (0, $35849f14f39a3bea$export$2e2bcd8739ae039)), {
        custom: baselineDate
    });
    const [baselineState, setBaselineState] = (0, $7fPBF.useState)("sameTimeLastYear");
    function findNameOfBaselineDate(_baselineDate) {
        const index = Object.values(baselineTimePeriods).indexOf((item)=>Number(item) === Number(_baselineDate));
        return index === -1 ? "custom" : Object.keys(baselineTimePeriods)[index];
    }
    // this useEffect sets dropdown state to a named baseline if the baselineDate in Redux matches one of the predefined dates
    // check if any of the predefined dates matches the currently set baseline in Redux and if so, set the component state to reflect that
    (0, $7fPBF.useEffect)(()=>{
        if (baselineDate) {
            if ($007c634679518524$var$debugLevel > 2) console.log("baselineDate", (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(baselineDate).format("YYYY-MM-DD HH:mm:ss"));
            const matchedBaseline = Object.entries(baselineTimePeriods).find(([key, value])=>Number(value) === Number(baselineDate)); // returns [key, value]
            if ($007c634679518524$var$debugLevel > 2) console.log(matchedBaseline);
            if (matchedBaseline.length > 0) setBaselineState(matchedBaseline[0]);
            else setBaselineState("custom");
        }
        // if baselineDate is not set (e.g. user logs on for the first time), set it to a default value
        if (!baselineDate) dispatch((0, $8bd3fc2d0bca0786$export$5e7b30d2bf9a315f)({
            baselineDate: baselineTimePeriods.sameTimeLastYear,
            namedBaseline: "sameTimeLastYear"
        }));
    }, [
        baselineDate
    ]); // this changes and sets baselineState (which is used to populate the dropdown) only when the Redux selector changes
    function dispatchNewBaseline(date, namedBaseline = null) {
        const newBaseline = Number(date.valueOf());
        // save this in Cognito and then replicate in Redux
        dispatch((0, $8bd3fc2d0bca0786$export$5e7b30d2bf9a315f)({
            baselineDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(newBaseline).startOf("day").valueOf(),
            namedBaseline: namedBaseline
        }));
        setBaselineState(newBaseline);
    }
    function handleCustomBaselineChange(e) {
        e.preventDefault();
        if (isViewer) return; // do nothing if this is a viewer
        // if this is a custom baseline, open calendar widget and give it a callback on the way
        // otherwise set the new date in redux directly
        if (e.target.value === "custom") setCalendarState((0, $2qxEV._)((0, $9tqwB._)({}, calendarState), {
            visible: true,
            callback: dispatchNewBaseline
        }));
        else dispatchNewBaseline(baselineTimePeriods[e.target.value], e.target.value);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "pt-1 pb-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                htmlFor: "location",
                className: "block text-xs sm:text-sm font-medium text-gray-500",
                children: t("sumtile.previousValue.selectBaseline")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                id: "baseline",
                disabled: isViewer,
                name: "baseline",
                className: "block w-full mt-1 pr-10 pb-2 text-gray-900 text-sm border border-gray-300 focus:outline-none focus:ring-brandBlue-500 rounded-md",
                // defaultValue="same time last year"
                value: baselineState,
                onChange: handleCustomBaselineChange,
                onFocus: (e)=>{
                    if (isViewer) return; // do nothing if this is a viewer
                    setBaselineState(undefined);
                },
                onBlur: (e)=>{
                    if (isViewer) return; // do nothing if this is a viewer
                    if (Number(e.target.value) === -1) setBaselineState(findNameOfBaselineDate(baselineDate));
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                        className: "text-xs sm:text-sm",
                        value: "emptyRow",
                        children: " "
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                        className: "text-xs sm:text-sm",
                        value: "sameTimeLastYear",
                        children: t("sumtile.previousValue.sameTimeLastYear")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                        className: "text-xs sm:text-sm",
                        value: "currentYearBegin",
                        children: t("sumtile.previousValue.beginning")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                        className: "text-xs sm:text-sm",
                        value: "previousYearBegin",
                        children: t("sumtile.previousValue.beginningLastYear")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                        className: "text-xs sm:text-sm",
                        value: "custom",
                        children: `${t("sumtile.previousValue.custom")} (${new Date(baselineDate).toLocaleString("de", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "2-digit"
                        })})`
                    })
                ]
            })
        ]
    });
}
$007c634679518524$export$2e2bcd8739ae039.propTypes = {
    calendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        visible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }).isRequired,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$007c634679518524$export$2e2bcd8739ae039.defaultProps = {
    isViewer: false
};




function $980c152193a2e58e$export$2e2bcd8739ae039({ calendarState: calendarState, setCalendarState: setCalendarState }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "preferences"
    });
    const { t: tG } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "general"
    });
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const expectedDateFormats = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.expectedDateFormats); // should be a parsed array
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { control: control, register: register, handleSubmit: handleSubmit, setValue: setValue, formState: formState, reset: reset } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        defaultValues: {
            expectedDateFormats: expectedDateFormats.map((item)=>({
                    value: item
                })) || [
                {
                    value: "DD.MM.YYYY"
                },
                {
                    value: "YYYY-MM-DD"
                }
            ]
        }
    });
    const { fields: fields, append: append, remove: remove } = (0, $18522b4fc47f45cb$export$310131896651d559)({
        control: control,
        name: "expectedDateFormats"
    });
    function handleRearrange(index, direction) {
        const newFields = [
            ...fields
        ];
        if (direction === "up" && index > 0) {
            const itemToMove = newFields.splice(index, 1)[0];
            newFields.splice(index - 1, 0, itemToMove);
        } else if (direction === "down" && index < newFields.length - 1) {
            const itemToMove = newFields.splice(index, 1)[0];
            newFields.splice(index + 1, 0, itemToMove);
        }
        setValue("expectedDateFormats", newFields);
    }
    function handleSubmitDateFormats(data) {
        dispatch((0, $8bd3fc2d0bca0786$export$5e7b30d2bf9a315f)({
            expectedDateFormats: data.expectedDateFormats.map((item)=>item.value.toUpperCase())
        })); // will be parsed in action creator
        reset((0, $2qxEV._)((0, $9tqwB._)({}, data), {
            expectedDateFormats: data.expectedDateFormats.map((item)=>({
                    value: item.value.toUpperCase()
                }))
        })); // reset form to remove dirty state
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "space-y-8 divide-y divide-gray-200 sm:space-y-5 text-gray-700 font-normal",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "space-y-6 sm:space-y-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "space-y-6 sm:space-y-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-sm pb-2 sm:pb-0",
                                children: t("baseCurrency")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-500",
                                children: baseCurrency
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("preferredLanguage")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "sm:max-w-xs",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $913cec825392fdc0$export$f397a346e9b493ee), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "about",
                                className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                children: t("baselineDate")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "mt-3 sm:col-span-2 sm:mt-0 sm:max-w-xs",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $007c634679518524$export$2e2bcd8739ae039), {
                                    calendarState: calendarState,
                                    setCalendarState: setCalendarState
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                htmlFor: "about",
                                className: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2",
                                children: [
                                    t("expectedDateFormats"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "mt-2 text-xs text-gray-500",
                                        children: t("expectedDateFormatsInfo")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: "mt-2 text-xs text-gray-500",
                                        children: [
                                            t("expectedDateFormatsAllowed"),
                                            " ",
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                href: "https://day.js.org/docs/en/parse/string-format#list-of-all-available-parsing-tokens",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: "text-brandBlue-500",
                                                children: [
                                                    t("expectedDateFormatsAllowedLink"),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60f58cdd0c2aa415$export$2e2bcd8739ae039), {
                                                        className: "pl-1 h-4 w-4 inline-block text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
                                onSubmit: handleSubmit(handleSubmitDateFormats),
                                className: "mt-3 sm:col-span-2 sm:mt-0 sm:max-w-xs",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                                    className: "",
                                    children: [
                                        fields.map((field, index)=>{
                                            var _formState_errors_expectedDateFormats, _formState_errors;
                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                                className: "grid grid-cols-[20px,auto,25px] py-2 gap-2 align-middle",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "flex flex-col justify-center items-center",
                                                        children: [
                                                            index > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>handleRearrange(index, "up"),
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a93467887e89dcc8$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-gray-400 hover:text-gray-500",
                                                                    "aria-hidden": "true"
                                                                })
                                                            }),
                                                            index < fields.length - 1 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>handleRearrange(index, "down"),
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $718d5639811dbbc7$export$2e2bcd8739ae039), {
                                                                    className: "h-5 w-5 text-gray-400 hover:text-gray-500",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "block w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                                                type: "text",
                                                                autoComplete: "off",
                                                                className: "block w-full pr-2 pb-2 text-gray-900 text-sm border border-gray-300 focus:outline-none focus:ring-brandBlue-500 rounded-md"
                                                            }, register(`expectedDateFormats.${index}.value`, {
                                                                required: true,
                                                                validate: (val)=>val.toUpperCase().match(/[^DMYZX\-.]/g)
                                                            })), {
                                                                defaultValue: field.value
                                                            })),
                                                            ((_formState_errors = formState.errors) === null || _formState_errors === void 0 ? void 0 : (_formState_errors_expectedDateFormats = _formState_errors.expectedDateFormats) === null || _formState_errors_expectedDateFormats === void 0 ? void 0 : _formState_errors_expectedDateFormats[index]) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                                className: "mt-1 ml-1 text-xs text-red-500",
                                                                children: t("expectedDateFormatsError")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>remove(index),
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $125f450ca02db1e2$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-400 hover:text-gray-500",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                ]
                                            }, field.id);
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                            className: "grid grid-cols-[20px,auto,25px] py-2 gap-2 align-middle",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "col-start-2 grid grid-cols-2 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        className: "py-1 px-1.5 hover:bg-gray-100 rounded-md",
                                                        type: "button",
                                                        onClick: ()=>append(""),
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dc348e8ecf02df23$export$2e2bcd8739ae039), {
                                                            className: "h-5 w-5 text-gray-400",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    formState.isDirty && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                        type: "submit",
                                                        size: "md",
                                                        withAccent: true,
                                                        text: tG("save")
                                                    })
                                                ]
                                            })
                                        }, "addnewitem")
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$980c152193a2e58e$export$2e2bcd8739ae039.propTypes = {
    calendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        year: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    }).isRequired,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-props-no-spreading */ 
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");










(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $514c56f1419d1d95$export$2e2bcd8739ae039({ setIsDirty: setIsDirty }) {
    const [updating, setUpdating] = (0, $7fPBF.useState)(false);
    const selectUserSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "simulations"
    });
    // default settings updated in getSettings (centrally)
    const { register: register, control: control, watch: watch, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isDirty: isDirty }, getFieldState: getFieldState } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            inflation: selectUserSettings.inflation,
            inflationRate: selectUserSettings.inflationRate
        }
    }); // intialised after useEffect fetches data from Amplify store
    // keep isDirty state in sync with parent
    (0, $7fPBF.useEffect)(()=>{
        setIsDirty(isDirty);
    }, [
        isDirty
    ]);
    async function onSubmit(data) {
        // update global settings in cognito
        if (isDirty) {
            setUpdating(true);
            try {
                await dispatch((0, $8bd3fc2d0bca0786$export$5e7b30d2bf9a315f)((0, $9tqwB._)({}, getFieldState("inflation").isDirty && {
                    inflation: data.inflation
                }, getFieldState("inflationRate").isDirty && {
                    inflationRate: Number(data.inflationRate)
                })));
                reset(data);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            } catch (error) {
                console.error("Error updating cognito settings", error);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            }
            setUpdating(false);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "text-sm space-y-3 sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: t("inflation")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("inflationEnabledDescription")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "sm:max-w-sm",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
                        control: control,
                        name: "inflation",
                        render: ({ field: field })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Group, {
                                as: "div",
                                className: "flex items-center justify-start w-full",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                        as: "span",
                                        className: "mr-3",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: t("disabled")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262), (0, $2qxEV._)((0, $9tqwB._)({}, field), {
                                        checked: field.value,
                                        id: "settings-planning-inflation-switch",
                                        onChange: field.onChange,
                                        className: `${field.value ? "bg-brandBlue-500" : "bg-gray-200"} relative inline-flex flex-shrink-0 h-6 w-11 border-2
                      border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-600`,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: `${field.value ? "translate-x-5" : "translate-x-0"}
                          pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`
                                        })
                                    })),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f18565a07c992db3$export$b5d5cf8927ab7262).Label, {
                                        as: "span",
                                        className: "ml-3",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "text-sm font-medium text-gray-500",
                                            children: t("enabled")
                                        })
                                    })
                                ]
                            })
                    }),
                    watch("inflation") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "mt-4 space-y-3",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-700",
                                children: t("simulatedInflationRate")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                type: "number",
                                step: "0.01",
                                name: "inflationRate",
                                id: "inflationRate"
                            }, register("inflationRate", {
                                valueAsNumber: true
                            })), {
                                className: "mt-0.5 flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                            })),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                className: "mt-1 text-gray-400 text-xs",
                                children: [
                                    t("averageInflation"),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                        href: "https://www.macrotrends.net/countries/WLD/world/inflation-rate-cpi",
                                        className: "text-gray-400 text-xs underline",
                                        children: [
                                            ` ${t("source")}`,
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee0d8d9d593dfbcf$export$2e2bcd8739ae039), {
                                                className: "h-3 w-3 inline"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            errors.inflationRate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: errors.inflationRate.message
                                })
                            })
                        ]
                    })
                ]
            }),
            isDirty && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-end space-x-2 sm:col-start-2 mt-4",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    type: "button",
                    onClick: handleSubmit(onSubmit),
                    text: t("save"),
                    spinnerOn: updating,
                    id: "settings-planning-save",
                    withAccent: true,
                    size: "lg"
                })
            })
        ]
    });
}
$514c56f1419d1d95$export$2e2bcd8739ae039.propTypes = {
    setIsDirty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $93ae3adbba5a7fe1$export$2e2bcd8739ae039({ setIsDirty: setIsDirty }) {
    const [updating, setUpdating] = (0, $7fPBF.useState)(false);
    const selectUserSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "simulations"
    });
    // default settings updated in getSettings (centrally)
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isDirty: isDirty }, getFieldState: getFieldState } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {
            sliderStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(selectUserSettings.sliderStartDate).format("YYYY-MM"),
            sliderEndDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(selectUserSettings.sliderEndDate).format("YYYY-MM")
        }
    }); // intialised after useEffect fetches data from Amplify store
    // keep isDirty state in sync with parent
    (0, $7fPBF.useEffect)(()=>{
        setIsDirty(isDirty);
    }, [
        isDirty
    ]);
    async function onSubmit(data) {
        // update global settings in cognito
        if (isDirty) {
            setUpdating(true);
            try {
                await dispatch((0, $8bd3fc2d0bca0786$export$5e7b30d2bf9a315f)((0, $9tqwB._)({}, getFieldState("sliderStartDate").isDirty && {
                    sliderStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(data.sliderStartDate).startOf("month").valueOf()
                }, getFieldState("sliderEndDate").isDirty && {
                    sliderEndDate: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(data.sliderEndDate).startOf("month").valueOf()
                })));
                reset(data);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdatedSuccessfully"));
            } catch (error) {
                console.error("Error updating cognito settings", error);
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("dataUpdateError"));
            }
            setUpdating(false);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "text-sm space-y-3 sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: t("slider")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-1 text-xs text-gray-400",
                        children: t("setDates")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "grid grid-cols-2 space-x-2 sm:flex",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-500",
                                children: t("startDate")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                type: "month",
                                name: "sliderStartDate",
                                id: "sliderStartDate"
                            }, register("sliderStartDate")), {
                                className: "mt-0.5 flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                            })),
                            errors.sliderStartDate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: errors.sliderStartDate.message
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "text-gray-500",
                                children: t("endDate")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                type: "month",
                                name: "sliderEndDate",
                                id: "sliderEndDate"
                            }, register("sliderEndDate")), {
                                className: "mt-0.5 flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                            })),
                            errors.sliderEndDate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: errors.sliderEndDate.message
                                })
                            })
                        ]
                    })
                ]
            }),
            isDirty && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-end space-x-2 sm:col-start-2 mt-4",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                    type: "button",
                    onClick: handleSubmit(onSubmit),
                    text: t("save"),
                    spinnerOn: updating,
                    id: "settings-planning-save",
                    withAccent: true,
                    size: "lg"
                })
            })
        ]
    });
}
$93ae3adbba5a7fe1$export$2e2bcd8739ae039.propTypes = {
    setIsDirty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $400369c1bf687eae$export$2e2bcd8739ae039({ setIsDirty: setIsDirty }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "simulations"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "space-y-8 divide-y divide-gray-200 sm:space-y-5 text-gray-700 font-normal",
        id: "settings-planning-pane",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "space-y-6 sm:space-y-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "space-y-6 sm:space-y-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-1 text-sm text-gray-500",
                            children: t("info")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $93ae3adbba5a7fe1$export$2e2bcd8739ae039), {
                        setIsDirty: setIsDirty
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $514c56f1419d1d95$export$2e2bcd8739ae039), {
                        setIsDirty: setIsDirty
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $057667e0d4d4e50c$export$2e2bcd8739ae039), {
                        setIsDirty: setIsDirty
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $590084312c25d5d6$export$2e2bcd8739ae039), {
                        setIsDirty: setIsDirty
                    })
                ]
            })
        })
    });
}
$400369c1bf687eae$export$2e2bcd8739ae039.propTypes = {
    setIsDirty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-props-no-spreading */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
var $e0fb7d1a17cf6117$var$__defProp = Object.defineProperty;
var $e0fb7d1a17cf6117$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e0fb7d1a17cf6117$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e0fb7d1a17cf6117$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e0fb7d1a17cf6117$var$__defNormalProp = (obj, key, value)=>key in obj ? $e0fb7d1a17cf6117$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e0fb7d1a17cf6117$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e0fb7d1a17cf6117$var$__hasOwnProp.call(b, prop)) $e0fb7d1a17cf6117$var$__defNormalProp(a, prop, b[prop]);
    if ($e0fb7d1a17cf6117$var$__getOwnPropSymbols) {
        for (var prop of $e0fb7d1a17cf6117$var$__getOwnPropSymbols(b))if ($e0fb7d1a17cf6117$var$__propIsEnum.call(b, prop)) $e0fb7d1a17cf6117$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e0fb7d1a17cf6117$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e0fb7d1a17cf6117$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e0fb7d1a17cf6117$var$__getOwnPropSymbols) {
        for (var prop of $e0fb7d1a17cf6117$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e0fb7d1a17cf6117$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $e0fb7d1a17cf6117$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class {
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        getModules() {
            return this.modules;
        }
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.modules = [];
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
    };
    let QrCode = _QrCode;
    QrCode.MIN_VERSION = 1;
    QrCode.MAX_VERSION = 40;
    QrCode.PENALTY_N1 = 3;
    QrCode.PENALTY_N2 = 3;
    QrCode.PENALTY_N3 = 40;
    QrCode.PENALTY_N4 = 10;
    QrCode.ECC_CODEWORDS_PER_BLOCK = [
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    qrcodegen2.QrCode = QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class {
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        getData() {
            return this.bitData.slice();
        }
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substr(i + 1, 2), 16));
                i += 2;
            }
            return result;
        }
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
    };
    let QrSegment = _QrSegment;
    QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    qrcodegen2.QrSegment = QrSegment;
})($e0fb7d1a17cf6117$var$qrcodegen || ($e0fb7d1a17cf6117$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class {
            constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        let Ecc = _Ecc;
        Ecc.LOW = new _Ecc(0, 1);
        Ecc.MEDIUM = new _Ecc(1, 0);
        Ecc.QUARTILE = new _Ecc(2, 3);
        Ecc.HIGH = new _Ecc(3, 2);
        QrCode2.Ecc = Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($e0fb7d1a17cf6117$var$qrcodegen || ($e0fb7d1a17cf6117$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class {
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
            constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
        };
        let Mode = _Mode;
        Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        QrSegment2.Mode = Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($e0fb7d1a17cf6117$var$qrcodegen || ($e0fb7d1a17cf6117$var$qrcodegen = {}));
var $e0fb7d1a17cf6117$var$qrcodegen_default = $e0fb7d1a17cf6117$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $e0fb7d1a17cf6117$var$ERROR_LEVEL_MAP = {
    L: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $e0fb7d1a17cf6117$var$DEFAULT_SIZE = 128;
var $e0fb7d1a17cf6117$var$DEFAULT_LEVEL = "L";
var $e0fb7d1a17cf6117$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $e0fb7d1a17cf6117$var$DEFAULT_FGCOLOR = "#000000";
var $e0fb7d1a17cf6117$var$DEFAULT_INCLUDEMARGIN = false;
var $e0fb7d1a17cf6117$var$MARGIN_SIZE = 4;
var $e0fb7d1a17cf6117$var$DEFAULT_IMG_SCALE = 0.1;
function $e0fb7d1a17cf6117$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $e0fb7d1a17cf6117$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $e0fb7d1a17cf6117$var$getImageSettings(cells, size, includeMargin, imageSettings) {
    if (imageSettings == null) return null;
    const margin = includeMargin ? $e0fb7d1a17cf6117$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $e0fb7d1a17cf6117$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
}
var $e0fb7d1a17cf6117$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
function $e0fb7d1a17cf6117$export$7e3713cf0c0fe9d0(props) {
    const _a = props, { value: value, size: size = $e0fb7d1a17cf6117$var$DEFAULT_SIZE, level: level = $e0fb7d1a17cf6117$var$DEFAULT_LEVEL, bgColor: bgColor = $e0fb7d1a17cf6117$var$DEFAULT_BGCOLOR, fgColor: fgColor = $e0fb7d1a17cf6117$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $e0fb7d1a17cf6117$var$DEFAULT_INCLUDEMARGIN, style: style, imageSettings: imageSettings } = _a, otherProps = $e0fb7d1a17cf6117$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "style",
        "imageSettings"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, $7fPBF.useRef)(null);
    const _image = (0, $7fPBF.useRef)(null);
    const [isImgLoaded, setIsImageLoaded] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cells = $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.encodeText(value, $e0fb7d1a17cf6117$var$ERROR_LEVEL_MAP[level]).getModules();
            const margin = includeMargin ? $e0fb7d1a17cf6117$var$MARGIN_SIZE : 0;
            const numCells = cells.length + margin * 2;
            const calculatedImageSettings = $e0fb7d1a17cf6117$var$getImageSettings(cells, size, includeMargin, imageSettings);
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cells = $e0fb7d1a17cf6117$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($e0fb7d1a17cf6117$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($e0fb7d1a17cf6117$var$generatePath(cells, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $e0fb7d1a17cf6117$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("canvas", $e0fb7d1a17cf6117$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: _canvas
    }, otherProps)), img);
}
function $e0fb7d1a17cf6117$export$10307208e61210e9(props) {
    const _a = props, { value: value, size: size = $e0fb7d1a17cf6117$var$DEFAULT_SIZE, level: level = $e0fb7d1a17cf6117$var$DEFAULT_LEVEL, bgColor: bgColor = $e0fb7d1a17cf6117$var$DEFAULT_BGCOLOR, fgColor: fgColor = $e0fb7d1a17cf6117$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $e0fb7d1a17cf6117$var$DEFAULT_INCLUDEMARGIN, imageSettings: imageSettings } = _a, otherProps = $e0fb7d1a17cf6117$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "imageSettings"
    ]);
    let cells = $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.encodeText(value, $e0fb7d1a17cf6117$var$ERROR_LEVEL_MAP[level]).getModules();
    const margin = includeMargin ? $e0fb7d1a17cf6117$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const calculatedImageSettings = $e0fb7d1a17cf6117$var$getImageSettings(cells, size, includeMargin, imageSettings);
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cells = $e0fb7d1a17cf6117$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("image", {
            xlinkHref: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none"
        });
    }
    const fgPath = $e0fb7d1a17cf6117$var$generatePath(cells, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $e0fb7d1a17cf6117$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`
    }, otherProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
}
var $e0fb7d1a17cf6117$export$2e2bcd8739ae039 = (props)=>{
    const _a = props, { renderAs: renderAs } = _a, otherProps = $e0fb7d1a17cf6117$var$__objRest(_a, [
        "renderAs"
    ]);
    if (renderAs === "svg") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e0fb7d1a17cf6117$export$10307208e61210e9, $e0fb7d1a17cf6117$var$__spreadValues({}, otherProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e0fb7d1a17cf6117$export$7e3713cf0c0fe9d0, $e0fb7d1a17cf6117$var$__spreadValues({}, otherProps));
};



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $d1a2c62c2f2b9149$var$ArrowTopRightOnSquareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z",
        clipRule: "evenodd"
    }));
}
const $d1a2c62c2f2b9149$var$ForwardRef = $7fPBF.forwardRef($d1a2c62c2f2b9149$var$ArrowTopRightOnSquareIcon);
var $d1a2c62c2f2b9149$export$2e2bcd8739ae039 = $d1a2c62c2f2b9149$var$ForwardRef;



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $34633adac56b2223$var$EnvelopeIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M3 4a2 2 0 0 0-2 2v1.161l8.441 4.221a1.25 1.25 0 0 0 1.118 0L19 7.162V6a2 2 0 0 0-2-2H3Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "m19 8.839-7.77 3.885a2.75 2.75 0 0 1-2.46 0L1 8.839V14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.839Z"
    }));
}
const $34633adac56b2223$var$ForwardRef = $7fPBF.forwardRef($34633adac56b2223$var$EnvelopeIcon);
var $34633adac56b2223$export$2e2bcd8739ae039 = $34633adac56b2223$var$ForwardRef;

















var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $199fa85bad12a0b8$export$76361ce6f84050b5 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("VerifyUserAttribute"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a user attribute with the confirmation code.
 *
 * @param input -  The ConfirmUserAttributeInput object
 * @throws  -{@link AuthValidationErrorCode } -
 * Thrown when `confirmationCode` is not defined.
 * @throws  -{@link VerifyUserAttributeException } - Thrown due to an invalid confirmation code or attribute.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $3e6483b014230b67$export$db3262544786991c(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { confirmationCode: confirmationCode, userAttributeKey: userAttributeKey } = input;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!confirmationCode, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode);
    const { tokens: tokens } = await (0, $427208a1215859a8$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    const verifyUserAttribute = (0, $199fa85bad12a0b8$export$76361ce6f84050b5)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await verifyUserAttribute({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).ConfirmUserAttribute)
    }, {
        AccessToken: tokens.accessToken.toString(),
        AttributeName: userAttributeKey,
        Code: confirmationCode
    });
}

















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Sets up TOTP for the user.
 *
 * @returns SetUpTOTPOutput
 * @throws -{@link AssociateSoftwareTokenException}
 * Thrown if a service occurs while setting up TOTP.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function $5dca851d84edbd0d$export$a74c4504d860e989() {
    var _Amplify_getConfig_Auth, _tokens_idToken;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $427208a1215859a8$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    var _tokens_idToken_payload_cognitousername;
    const username = (_tokens_idToken_payload_cognitousername = (_tokens_idToken = tokens.idToken) === null || _tokens_idToken === void 0 ? void 0 : _tokens_idToken.payload["cognito:username"]) !== null && _tokens_idToken_payload_cognitousername !== void 0 ? _tokens_idToken_payload_cognitousername : "";
    const associateSoftwareToken = (0, $539fedaf8e7a5889$export$6bff32634453de2a)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    const { SecretCode: SecretCode } = await associateSoftwareToken({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).SetUpTOTP)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    if (!SecretCode) // This should never happen.
    throw new (0, $e7e74a7b684b93e5$export$145273558d58e0ac)({
        name: (0, $c50e9c939b7b9954$export$ecd3eb1722b48d26),
        message: "Failed to set up TOTP."
    });
    return (0, $d8f1cd2c50629c95$export$b105c3e8e4f5ce91)(SecretCode, JSON.stringify(username));
}














var $9tqwB = parcelRequire("9tqwB");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a5f40eade8885075$export$26d717ca9dc87c19 = (config)=>(0, $ba93afffa4c7aaee$export$880429a8ae983d4d)((0, $095d718f318a1d01$export$10f11e95d7a96f7b), (0, $f30d53cc42dcd5e7$export$1113413e6e842bef)("SetUserMFAPreference"), (0, $8d396b19990d0ed2$export$8159795418a3e796)(), (0, $9tqwB._)({}, (0, $529584b3e3a83558$export$22a3716e7860147a), config));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates the MFA preference of the user.
 *
 * @param input - The UpdateMFAPreferenceInput object.
 * @throws -{@link SetUserMFAPreferenceException } - Service error thrown when the MFA preference cannot be updated.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $275ffc947b69fea6$export$2bb4d389b36196a8(input) {
    var _Amplify_getConfig_Auth;
    const { sms: sms, totp: totp, email: email } = input;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { tokens: tokens } = await (0, $427208a1215859a8$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    const setUserMFAPreference = (0, $a5f40eade8885075$export$26d717ca9dc87c19)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await setUserMFAPreference({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).UpdateMFAPreference)
    }, {
        AccessToken: tokens.accessToken.toString(),
        SMSMfaSettings: $275ffc947b69fea6$export$94ebd2f142650410(sms),
        SoftwareTokenMfaSettings: $275ffc947b69fea6$export$94ebd2f142650410(totp),
        EmailMfaSettings: $275ffc947b69fea6$export$94ebd2f142650410(email)
    });
}
function $275ffc947b69fea6$export$94ebd2f142650410(mfaPreference) {
    if (mfaPreference === "DISABLED") return {
        Enabled: false
    };
    else if (mfaPreference === "PREFERRED") return {
        Enabled: true,
        PreferredMfa: true
    };
    else if (mfaPreference === "ENABLED") return {
        Enabled: true
    };
    else if (mfaPreference === "NOT_PREFERRED") return {
        Enabled: true,
        PreferredMfa: false
    };
}
















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Verifies an OTP code retrieved from an associated authentication app.
 *
 * @param input - The VerifyTOTPSetupInput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `code` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $6d5512ffe82550d0$export$8ec6532fe96e5b4c(input) {
    var _Amplify_getConfig_Auth;
    const authConfig = (_Amplify_getConfig_Auth = (0, $f4c06b47af4364f4$export$a3858a9a153cffc7).getConfig().Auth) === null || _Amplify_getConfig_Auth === void 0 ? void 0 : _Amplify_getConfig_Auth.Cognito;
    (0, $00406059b8b03c2e$export$80c92581e59ed502)(authConfig);
    const { userPoolEndpoint: userPoolEndpoint, userPoolId: userPoolId } = authConfig;
    const { code: code, options: options } = input;
    (0, $4b4afbe5c9cb9f15$export$45936001d12f9b53)(!!code, (0, $07233456440bc422$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode);
    const { tokens: tokens } = await (0, $427208a1215859a8$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $2cc7ae0cece9bbf8$export$77712ea5882cac9f)(tokens);
    const verifySoftwareToken = (0, $67c783f15dbab9a2$export$cf5dd9429415aa98)({
        endpointResolver: (0, $de38942cd6e4d1e5$export$9fc8f7dceefe00a6)({
            endpointOverride: userPoolEndpoint
        })
    });
    await verifySoftwareToken({
        region: (0, $8a019f9f7f66e79b$export$5f7eb9761ac2d0d9)(userPoolId),
        userAgentValue: (0, $b7859b3867cd5e7c$export$d6cd780379f37dae)((0, $4729d49089f76d33$export$900b1436d7e65f4).VerifyTOTPSetup)
    }, {
        AccessToken: tokens.accessToken.toString(),
        UserCode: code,
        FriendlyDeviceName: options === null || options === void 0 ? void 0 : options.friendlyDeviceName
    });
}








function $763ec06928b32549$export$2e2bcd8739ae039() {
    var _user_attributes, _user_attributes1, _user_attributes2;
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const [updating, setUpdating] = (0, $7fPBF.useState)(null); // expects a field name as string
    const [passwordChange, setPasswordChange] = (0, $7fPBF.useState)(false);
    const [showPasswordTip, setShowPasswordTip] = (0, $7fPBF.useState)(false);
    const [user, setUser] = (0, $7fPBF.useState)(null);
    const [showTwoFactorAuth, setShowTwoFactorAuth] = (0, $7fPBF.useState)(false);
    const [MFASetUpCode, setMFASetUpCode] = (0, $7fPBF.useState)(false);
    const [confirmationCodeReady, setConfirmationCodeReady] = (0, $7fPBF.useState)(false);
    const [showEmailConfirmationCode, setShowEmailConfirmationCode] = (0, $7fPBF.useState)(false);
    const [totpSetupDetails, setTotpSetupDetails] = (0, $7fPBF.useState)(null);
    const useFormObject = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        mode: "onBlur",
        defaultValues: {}
    }); // intialised after useEffect fetches data from Amplify store
    const { register: register, reset: reset, watch: watch, getFieldState: getFieldState, formState: formState, formState: { errors: errors, dirtyFields: dirtyFields } } = useFormObject;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings", {
        keyPrefix: "account"
    });
    (0, $7fPBF.useEffect)(()=>{
        const fieldState = getFieldState("confirmationCode");
        if (fieldState.isDirty && !fieldState.error && watch("confirmationCode").length === 6) setConfirmationCodeReady(true);
        else setConfirmationCodeReady(false);
    }, [
        formState
    ]);
    const password = (0, $7fPBF.useRef)({});
    password.current = watch("password", "");
    const repeatPassword = (0, $7fPBF.useRef)({});
    repeatPassword.current = watch("repeatPassword", "");
    // initialise user object
    (0, $7fPBF.useEffect)(()=>{
        (0, $10933498be24bbfd$export$2a5e1266bf611db7)().then((u)=>{
            setUser(u);
            reset({
                username: u.attributes.preferred_username,
                email: u.attributes.email
            });
        }).catch((err)=>{
            console.error("settings/account: unable to load user", err);
        });
    }, []);
    function handleUpdateAttribute(event, fieldId, fieldValue) {
        // set spinner on button, the button should disappear once we reset the form with new values
        setUpdating(fieldId);
        dispatch((0, $8bd3fc2d0bca0786$export$3c0556baabe4d535)(fieldId === "username" ? "preferred_username" : fieldId, fieldValue)).then(()=>{
            setUpdating(null);
            (0, $10933498be24bbfd$export$2a5e1266bf611db7)().then((u)=>{
                setUser(u);
                reset({
                    username: u.attributes.preferred_username,
                    email: u.attributes.email
                });
                if (fieldId === "email") setShowEmailConfirmationCode(true);
            }).catch((err)=>{
                console.error("settings/account: unable to refresh user after attribute update", err);
            });
        }, ()=>{
            setUpdating(null);
        });
    }
    // FIXME: this needs to change in the field / formObject once the new addreess is updated
    function onSubmitNewPassword() {
        // if all three password fields are valid, then we can change the password
        if (!getFieldState("currentPassword").invalid && !getFieldState("password").invalid && !getFieldState("repeatPassword").invalid) {
            setUpdating("password");
            dispatch((0, $8bd3fc2d0bca0786$export$99d837dc30eb1ef7)(watch("currentPassword"), watch("password"))).then(()=>{
                setUpdating(null);
                setPasswordChange(false);
            }, ()=>{
                setUpdating(null);
            });
        }
    }
    async function handleEnable2FA(e) {
        e.preventDefault();
        try {
            const setupResult = await (0, $5dca851d84edbd0d$export$a74c4504d860e989)();
            var _setupResult_sharedSecret;
            const secret = (_setupResult_sharedSecret = setupResult === null || setupResult === void 0 ? void 0 : setupResult.sharedSecret) !== null && _setupResult_sharedSecret !== void 0 ? _setupResult_sharedSecret : setupResult;
            setTotpSetupDetails(setupResult);
            setShowTwoFactorAuth(true);
            setMFASetUpCode(secret);
        } catch (err) {
            console.error("settings/account: unable to set up TOTP", err);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileCouldNotBeUpdated"
            });
        }
    }
    const QRString = (totpSetupDetails === null || totpSetupDetails === void 0 ? void 0 : totpSetupDetails.getSetupUri) ? totpSetupDetails.getSetupUri("Monestry", (user === null || user === void 0 ? void 0 : (_user_attributes = user.attributes) === null || _user_attributes === void 0 ? void 0 : _user_attributes.preferred_username) || (user === null || user === void 0 ? void 0 : (_user_attributes1 = user.attributes) === null || _user_attributes1 === void 0 ? void 0 : _user_attributes1.email) || "") : `otpauth://totp/username:${user === null || user === void 0 ? void 0 : (_user_attributes2 = user.attributes) === null || _user_attributes2 === void 0 ? void 0 : _user_attributes2.preferred_username}?secret=${MFASetUpCode}&issuer=Monestry`;
    async function handleSubmitMfaConfirmationCode(e) {
        e.preventDefault();
        setUpdating("confirmationCode");
        try {
            await (0, $6d5512ffe82550d0$export$8ec6532fe96e5b4c)({
                code: watch("confirmationCode")
            });
            await (0, $275ffc947b69fea6$export$2bb4d389b36196a8)({
                totp: "PREFERRED"
            });
            const userObject = await (0, $10933498be24bbfd$export$2a5e1266bf611db7)({
                forceRefresh: true
            });
            setUser(userObject);
            setShowTwoFactorAuth(false);
        } catch (err) {
            console.error("settings/account: verifyTotpToken failed", err);
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileCouldNotBeUpdated"
            });
        } finally{
            setUpdating(null);
        }
    }
    async function handleEmailConfirmationCode(e) {
        e.preventDefault();
        try {
            setUpdating("emailConfirmationCode");
            const emailConfirmationCode = watch("emailConfirmationCode");
            // confirm email change in Cognito
            await (0, $3e6483b014230b67$export$db3262544786991c)({
                userAttributeKey: "email",
                confirmationCode: emailConfirmationCode
            });
            // update email in Stripe
            const apiPayload = {
                body: {
                    email: watch("email")
                },
                headers: {
                    "Content-Type": "application/json"
                }
            };
            try {
                await (0, $bad5f4197326a006$export$8de8f9d6a7611c85)("myAPI", "customer/attribute", apiPayload);
            } catch (error) {
                throw new Error("stripeError");
            }
            dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileUpdatedSuccessfully"
            });
            setUpdating(null);
            setShowEmailConfirmationCode(false);
        } catch (err) {
            setUpdating(null);
            if (err.message === "stripeError") dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "errorUpdatingStripe"
            });
            else dispatch({
                type: (0, $0840a3787500c813$export$f56c21b951c55d75),
                payload: "profileCouldNotBeUpdated"
            });
        }
    }
    return(// Password + change
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "space-y-8 divide-y divide-gray-200 sm:space-y-5 text-gray-700 font-normal",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "space-y-6 sm:space-y-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "space-y-6 sm:space-y-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-3 sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t("Email address")
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "sm:max-w-sm sm:justify-self-stretch",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$497a6aaf7dad75ee, {
                                        useFormObject: useFormObject
                                    }),
                                    Object.keys(dirtyFields || []).includes("email") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex space-x-2 items-center ml-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $34633adac56b2223$export$2e2bcd8739ae039), {
                                                        className: "inline w-8 h-8 text-gray-300 -mb-1",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "pt-2 text-xs font-light tracking-wide text-gray-400",
                                                        children: t("emailInfo")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500",
                                                children: errors.email && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors.email.message
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                disabled: !Object.keys(dirtyFields || []).includes("email") || showEmailConfirmationCode,
                                onClick: (e)=>handleUpdateAttribute(e, "email", watch("email")),
                                // -ml-24 is meant to eliminate a large gap between field and button that appears in 2xl
                                className: `sm:ml-3 2xl:-ml-24 inline-flex justify-center rounded-md border py-2 px-4
                text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                ${Object.keys(dirtyFields || []).includes("email") ? "bg-brandBlue-500 hover:bg-brandBlue-600  text-white border-transparent" : "bg-white text-gray-300 hover:bg-gray-50 border-gray-200"}`,
                                children: [
                                    t("saveChanges"),
                                    updating === "email" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "h-3 w-3 ml-2 mt-1 animate-spin text-white text-sm"
                                    })
                                ]
                            }),
                            showEmailConfirmationCode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "sm:max-w-sm sm:justify-self-stretch col-start-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $9tqwB._)({
                                                type: "number",
                                                step: "1",
                                                name: "emailConfirmationCode",
                                                id: "emailConfirmationCode",
                                                autoComplete: "false",
                                                className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
                                            }, useFormObject.register("emailConfirmationCode"))),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex items-baseline ml-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                        className: "animate-pulse inline-flex h-3 w-3 shadow-sm rounded-full bg-brandYellow-500 opacity-75"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                        className: "pl-2 pt-2 text-sm text-gray-700",
                                                        children: t("pleaseEnterCode")
                                                    })
                                                ]
                                            }),
                                            Object.keys(dirtyFields || []).includes("emailConfirmationCode") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500",
                                                children: errors.emailConfirmationCode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors.emailConfirmationCode.message
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "button",
                                        disabled: !Object.keys(dirtyFields || []).includes("emailConfirmationCode"),
                                        onClick: handleEmailConfirmationCode,
                                        // -ml-24 is meant to eliminate a large gap between field and button that appears in 2xl
                                        className: `sm:ml-3 2xl:-ml-24 inline-flex justify-center rounded-md border py-2 px-4
                  text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                  ${Object.keys(dirtyFields || []).includes("emailConfirmationCode") ? "bg-brandBlue-500 hover:bg-brandBlue-600  text-white border-transparent" : "bg-white text-gray-300 hover:bg-gray-50 border-gray-200"}`,
                                        children: [
                                            t("Submit"),
                                            updating === "emailConfirmationCode" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "h-3 w-3 ml-2 mt-1 animate-spin text-white text-sm"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-3 sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("Username")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "sm:max-w-sm sm:justify-self-stretch",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$964522096592cdaa, {
                                        register: register
                                    }),
                                    Object.keys(dirtyFields || []).includes("username") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "pt-2 sm:text-sm text-brandRed-500",
                                        children: errors.username && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            children: errors.username.message
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                disabled: !Object.keys(dirtyFields || []).includes("username"),
                                onClick: (e)=>handleUpdateAttribute(e, "username", watch("username")),
                                className: `sm:ml-3 2xl:-ml-24 inline-flex justify-center rounded-md border py-2 px-4
                text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                ${Object.keys(dirtyFields || []).includes("username") ? "bg-brandBlue-500 hover:bg-brandBlue-600  text-white border-transparent" : "bg-white text-gray-300 hover:bg-gray-50 border-gray-200"}`,
                                children: [
                                    t("saveChanges"),
                                    updating === "username" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "h-3 w-3 ml-2 mt-1 animate-spin text-white text-sm"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-3 sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("Password")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setPasswordChange(!passwordChange),
                                className: `inline-flex justify-center rounded-md border py-2 px-4 mb-4 sm:col-span-2
                text-sm font-medium focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                ${!passwordChange ? "shadow-sm bg-white hover:bg-gray-50  text-brandBlue-500 border-brandBlue-400" : "inset bg-gray-200 text-gray-400 hover:bg-gray-300 border-gray-200"}`,
                                children: t("changePassword")
                            }),
                            passwordChange && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: t("Enter your current password")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "sm:max-w-sm sm:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                                type: "password",
                                                name: "currentPassword",
                                                id: "currentPassword"
                                            }, register("currentPassword", {
                                                required: {
                                                    value: true,
                                                    message: t("Please enter your current password.")
                                                },
                                                validate: (value)=>value !== password.current && value !== repeatPassword.current || t("The new password cannot be the same as the current password.")
                                            })), {
                                                className: "flex-1 font-base text-gray-700 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md border border-gray-300 "
                                            })),
                                            errors.currentPassword && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors.currentPassword.message
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: t("Enter new password")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "sm:max-w-sm sm:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$d5bd4e5caf3cfbf9, {
                                                useFormObject: useFormObject,
                                                setShowPasswordTip: setShowPasswordTip,
                                                repeatPassword: repeatPassword
                                            }),
                                            Object.keys(dirtyFields || []).includes("password") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: errors.password && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors.password.message
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "",
                                        children: t("Repeat new password")
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "sm:max-w-sm sm:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($25222a2cc67561a6$export$acef94ee3140d901, {
                                                useFormObject: useFormObject,
                                                setShowPasswordTip: setShowPasswordTip,
                                                password: password
                                            }),
                                            Object.keys(dirtyFields || []).includes("repeatPassword") && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: errors.repeatPassword && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors.repeatPassword.message
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "submit" // this is the only button that is a submit button
                                        ,
                                        onClick: onSubmitNewPassword,
                                        className: `sm:col-start-2 inline-flex justify-center rounded-md border py-2 px-4
                text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                ${!getFieldState("password").invalid && !getFieldState("repeatPassword").invalid ? "bg-brandBlue-500 hover:bg-brandBlue-600  text-white border-transparent" : "bg-white text-gray-300 hover:bg-gray-50 border-gray-200"}`,
                                        children: [
                                            t("saveChanges"),
                                            updating === "password" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "h-3 w-3 ml-2 mt-1 animate-spin text-white text-sm"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "space-y-3 sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("2fa")
                            }),
                            (user === null || user === void 0 ? void 0 : user.preferredMFA) === "NOMFA" && !showTwoFactorAuth && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                onClick: handleEnable2FA,
                                className: `inline-flex justify-center rounded-md border py-2 px-4 mb-4 sm:col-span-2
                text-sm font-medium focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                ${!showTwoFactorAuth ? "shadow-sm bg-white hover:bg-gray-50  text-brandBlue-500 border-brandBlue-400" : "inset bg-gray-200 text-gray-400 hover:bg-gray-300 border-gray-200"}`,
                                children: t("Enable")
                            }),
                            (user === null || user === void 0 ? void 0 : user.preferredMFA) === "SOFTWARE_TOKEN_MFA" && // MFA IS ENABLED
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex gap-2 items-center justify-start",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef0832052dc462d9$export$2e2bcd8739ae039), {
                                        className: "h-5 w-5 mr-1 text-green-500"
                                    }),
                                    t("Enabled")
                                ]
                            }),
                            showTwoFactorAuth && // HANDLE ENABLE MFA PROCESS
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "col-start-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                                className: "text-sm text-gray-500 mb-4",
                                                children: [
                                                    t("qrCode1"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                        href: "https://support.google.com/accounts/answer/1066447?hl=en&co=GENIE.Platform%3DAndroid",
                                                        target: "_blank",
                                                        className: "hover:underline group",
                                                        rel: "noreferrer",
                                                        children: [
                                                            "Google Authenticator",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                                                className: "inline h-4 w-4 ml-1 text-gray-400 group-hover:text-gray-500"
                                                            })
                                                        ]
                                                    }),
                                                    " ",
                                                    t("qrCode2"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                                        href: "https://support.apple.com/guide/iphone/automatically-fill-in-verification-codes-ipha6173c19f/ios",
                                                        target: "_blank",
                                                        className: "hover:underline group",
                                                        rel: "noreferrer",
                                                        children: [
                                                            "Apple Passwords",
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                                                className: "inline h-4 w-4 ml-1 text-gray-400 group-hover:text-gray-500"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e0fb7d1a17cf6117$export$10307208e61210e9), {
                                                value: QRString
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 leading-5",
                                                children: t("manualEntry")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "text-base text-gray-900 mt-2",
                                                style: {
                                                    overflowWrap: "anywhere",
                                                    fontFamily: "monospace"
                                                },
                                                children: MFASetUpCode
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "col-start-2 col-span-2 flex flex-col space-y-2 text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: t("enterAuthCode")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "flex-1 w-full flex justify-left items-center space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", (0, $2qxEV._)((0, $9tqwB._)({
                                                        name: "confirmationCode",
                                                        type: "number",
                                                        id: "confirmationCode"
                                                    }, register("confirmationCode", {
                                                        maxLength: 6,
                                                        minLength: 6
                                                    })), {
                                                        className: "p-2 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-1/3 min-w-0 rounded-md sm:text-sm border border-gray-300"
                                                    })),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                        type: "button",
                                                        disabled: !confirmationCodeReady,
                                                        onClick: handleSubmitMfaConfirmationCode,
                                                        className: `inline-flex justify-center rounded-md border py-2 px-4 max-w-md
                text-sm font-medium focus:outline-none focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2
                ${confirmationCodeReady ? "shadow-sm bg-white hover:bg-gray-50  text-brandBlue-500 border-brandBlue-400" : "inset bg-gray-200 text-gray-400 hover:bg-gray-300 border-gray-200"}`,
                                                        children: [
                                                            t("Confirm"),
                                                            updating === "confirmationCode" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                                className: "h-3 w-3 ml-2 mt-1 animate-spin text-white text-sm"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            errors.confirmationCode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "pt-2 sm:text-sm text-brandRed-500 max-w-fit",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    children: errors.confirmationCode.message
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
}




var $7fPBF = parcelRequire("7fPBF");






function $6f0a36026e6a105e$export$2e2bcd8739ae039() {
    const [portalSessionURL, setPortalSessionURL] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings");
    const { t: tGeneral } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("app", {
        keyPrefix: "general"
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    async function handleOpen() {
        if (portalSessionURL) {
            window.open(portalSessionURL, "_blank", "noopener,noreferrer");
            return;
        }
        try {
            setLoading(true);
            const response = await (0, $bad5f4197326a006$export$29243fdc58d23ee6)("myAPI", "customer/getStripePortalURL", {
                body: {
                    returnURL: `https://monestry.de/${i18n.language}/app`
                },
                headers: {
                    "Content-Type": "application/json"
                }
            });
            setPortalSessionURL(response.url);
            window.open(response.url, "_blank", "noopener,noreferrer");
        } catch (error) {
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("generalError"));
        } finally{
            setLoading(false);
        }
    }
    const buttonFormatting = "text-brandBlue-400 border px-3 py-2 border-brandBlue-400 hover:bg-gray-50 rounded-md font-bold sm:text-sm flex gap-1.5";
    const buttonText = tGeneral("open");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "space-y-8 divide-y divide-gray-200 sm:space-y-5 text-gray-700 font-normal",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "space-y-6 sm:space-y-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "space-y-6 sm:space-y-5",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-1 text-sm text-gray-500",
                                children: t("billing.leadingText1")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-1 text-sm text-gray-500",
                                children: t("billing.leadingText2")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("billing.currentSubscription")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: buttonFormatting,
                                onClick: handleOpen,
                                disabled: loading,
                                children: [
                                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 animate-spin text-gray-300"
                                    }) : buttonText,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                        className: "text-gray-400 h-4 w-4 mt-0.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("billing.upgradePlan")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: buttonFormatting,
                                onClick: handleOpen,
                                disabled: loading,
                                children: [
                                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 animate-spin text-gray-300"
                                    }) : buttonText,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                        className: "text-gray-400 h-4 w-4 mt-0.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("billing.paymentMethod")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: buttonFormatting,
                                onClick: handleOpen,
                                disabled: loading,
                                children: [
                                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 animate-spin text-gray-300"
                                    }) : buttonText,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                        className: "text-gray-400 h-4 w-4 mt-0.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("billing.downloadInvoices")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: buttonFormatting,
                                onClick: handleOpen,
                                disabled: loading,
                                children: [
                                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 animate-spin text-gray-300"
                                    }) : buttonText,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                        className: "text-gray-400 h-4 w-4 mt-0.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "sm:grid sm:grid-cols-3 sm:items-start sm:justify-items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t("billing.cancelSubscription")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: buttonFormatting,
                                onClick: handleOpen,
                                disabled: loading,
                                children: [
                                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                        className: "w-4 h-4 animate-spin text-gray-300"
                                    }) : buttonText,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1a2c62c2f2b9149$export$2e2bcd8739ae039), {
                                        className: "text-gray-400 h-4 w-4 mt-0.5"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}


function $c7015f341e5714ae$export$2e2bcd8739ae039({ closeCallback: closeCallback, openOnTab: openOnTab, calendarState: calendarState, setCalendarState: setCalendarState, setSettings: setSettings }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("settings");
    const tabs = [
        {
            id: "preferences",
            name: t("preferences.header"),
            Component: (0, $980c152193a2e58e$export$2e2bcd8739ae039)
        },
        {
            id: "planning",
            name: t("simulations.header"),
            Component: (0, $400369c1bf687eae$export$2e2bcd8739ae039)
        },
        {
            id: "account",
            name: t("account.header"),
            Component: (0, $763ec06928b32549$export$2e2bcd8739ae039)
        }
    ];
    // add subscription tab only if this is not a mobile app
    if (!window.mobileApp) tabs.push({
        id: "subscription",
        name: t("billing.header"),
        Component: (0, $6f0a36026e6a105e$export$2e2bcd8739ae039)
    });
    // open tab whose id is passed via openOnTab prop; if nothing found, open first tab
    const [selectedTab, setSelectedTab] = (0, $7fPBF.useState)(tabs.find((tab)=>tab.id === openOnTab) || tabs[0]);
    // holds the entire settings object
    const [settingsData, setSettingsData] = (0, $7fPBF.useState)(null);
    // used to indicate to users that their settings have not been saved
    const [isDirty, setIsDirty] = (0, $7fPBF.useState)(false);
    function updateSettingsData(updatedData) {
        setSettingsData((0, $9tqwB._)({}, settingsData, updatedData));
    }
    function handleCloseSettings(arg) {
        if (!arg && isDirty) window.dispatchEvent(new CustomEvent("setAlert", {
            detail: {
                id: "aboutToLoseData",
                caller: "Planning",
                callbackOk: ()=>{
                    setSettings(false);
                }
            }
        }));
        else if (!arg) setSettings(false);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25250cd4374f51ac$export$2e2bcd8739ae039), {
        fixedHeight: true,
        closeCallback: ()=>handleCloseSettings(false),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            id: "settings-window",
            className: "p-4 sm:px-0 sm:py-8",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mb-8 flex flex-col-reverse sm:flex-row sm:justify-between sm:items-end",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: "mt-6 sm:mt-0 text-2xl sm:text-4xl font-bold text-gray-900",
                        children: t("Settings")
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "lg:hidden",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            htmlFor: "selected-tab",
                            className: "sr-only",
                            children: t("Select a tab")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                            id: "selected-tab",
                            name: "selected-tab",
                            className: "mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm",
                            defaultValue: tabs.find((tab)=>tab.id === selectedTab.id).name,
                            onChange: (e)=>setSelectedTab(tabs.find((tab)=>tab.name === e.target.value)),
                            children: tabs.map((tab)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                    children: tab.name
                                }, tab.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "hidden lg:block",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "border-b border-gray-300",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                            className: "-mb-px flex space-x-8",
                            children: tabs.map((tab)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    id: `settings-tab-${tab.id}`,
                                    type: "button",
                                    onClick: ()=>setSelectedTab(tab),
                                    className: `
                    ${tab.id === selectedTab.id ? "border-brandBlue-500 text-brandBlue-600" : "border-transparent text-gray-500 hover:border-gray-400 hover:text-gray-700"}
                    'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm',
                  `,
                                    children: tab.name
                                }, tab.id))
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "pt-8",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(selectedTab.Component, {
                        updateSettingsData: updateSettingsData,
                        calendarState: calendarState,
                        setCalendarState: setCalendarState,
                        setSettings: handleCloseSettings,
                        setIsDirty: setIsDirty
                    })
                })
            ]
        })
    });
}
$c7015f341e5714ae$export$2e2bcd8739ae039.propTypes = {
    closeCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    openOnTab: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    calendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        visible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
        callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }),
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    setSettings: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$c7015f341e5714ae$export$2e2bcd8739ae039.defaultProps = {
    closeCallback: ()=>{},
    openOnTab: "Preferences",
    calendarState: {},
    setCalendarState: ()=>{}
};




var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $e951391b5370d281$var$ArrowDownCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v4.59L7.3 9.24a.75.75 0 0 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75Z",
        clipRule: "evenodd"
    }));
}
const $e951391b5370d281$var$ForwardRef = $7fPBF.forwardRef($e951391b5370d281$var$ArrowDownCircleIcon);
var $e951391b5370d281$export$2e2bcd8739ae039 = $e951391b5370d281$var$ForwardRef;



var $3433a3b89d1ad09b$exports = {};
"use strict";
Object.defineProperty($3433a3b89d1ad09b$exports, "__esModule", {
    value: true
});
function $3433a3b89d1ad09b$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $7fPBF = parcelRequire("7fPBF");
var $3433a3b89d1ad09b$var$React__default = $3433a3b89d1ad09b$var$_interopDefault($7fPBF);

var $gDLrq = parcelRequire("gDLrq");
var $3433a3b89d1ad09b$var$ClientUAInstance = new $gDLrq();
var $3433a3b89d1ad09b$var$browser = $3433a3b89d1ad09b$var$ClientUAInstance.getBrowser();
var $3433a3b89d1ad09b$var$cpu = $3433a3b89d1ad09b$var$ClientUAInstance.getCPU();
var $3433a3b89d1ad09b$var$device = $3433a3b89d1ad09b$var$ClientUAInstance.getDevice();
var $3433a3b89d1ad09b$var$engine = $3433a3b89d1ad09b$var$ClientUAInstance.getEngine();
var $3433a3b89d1ad09b$var$os = $3433a3b89d1ad09b$var$ClientUAInstance.getOS();
var $3433a3b89d1ad09b$var$ua = $3433a3b89d1ad09b$var$ClientUAInstance.getUA();
var $3433a3b89d1ad09b$var$setUa = function setUa(userAgentString) {
    return $3433a3b89d1ad09b$var$ClientUAInstance.setUA(userAgentString);
};
var $3433a3b89d1ad09b$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $gDLrq(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $3433a3b89d1ad09b$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $3433a3b89d1ad09b$var$ClientUAInstance,
    browser: $3433a3b89d1ad09b$var$browser,
    cpu: $3433a3b89d1ad09b$var$cpu,
    device: $3433a3b89d1ad09b$var$device,
    engine: $3433a3b89d1ad09b$var$engine,
    os: $3433a3b89d1ad09b$var$os,
    ua: $3433a3b89d1ad09b$var$ua,
    setUa: $3433a3b89d1ad09b$var$setUa,
    parseUserAgent: $3433a3b89d1ad09b$var$parseUserAgent
});
function $3433a3b89d1ad09b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3433a3b89d1ad09b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3433a3b89d1ad09b$var$ownKeys(Object(source), true).forEach(function(key) {
            $3433a3b89d1ad09b$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3433a3b89d1ad09b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3433a3b89d1ad09b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3433a3b89d1ad09b$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $3433a3b89d1ad09b$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3433a3b89d1ad09b$var$_typeof(obj);
}
function $3433a3b89d1ad09b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3433a3b89d1ad09b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3433a3b89d1ad09b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3433a3b89d1ad09b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3433a3b89d1ad09b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3433a3b89d1ad09b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3433a3b89d1ad09b$var$_extends() {
    $3433a3b89d1ad09b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3433a3b89d1ad09b$var$_extends.apply(this, arguments);
}
function $3433a3b89d1ad09b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3433a3b89d1ad09b$var$_setPrototypeOf(subClass, superClass);
}
function $3433a3b89d1ad09b$var$_getPrototypeOf(o) {
    $3433a3b89d1ad09b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3433a3b89d1ad09b$var$_getPrototypeOf(o);
}
function $3433a3b89d1ad09b$var$_setPrototypeOf(o, p) {
    $3433a3b89d1ad09b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3433a3b89d1ad09b$var$_setPrototypeOf(o, p);
}
function $3433a3b89d1ad09b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3433a3b89d1ad09b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3433a3b89d1ad09b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3433a3b89d1ad09b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3433a3b89d1ad09b$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3433a3b89d1ad09b$var$_assertThisInitialized(self);
}
function $3433a3b89d1ad09b$var$_slicedToArray(arr, i) {
    return $3433a3b89d1ad09b$var$_arrayWithHoles(arr) || $3433a3b89d1ad09b$var$_iterableToArrayLimit(arr, i) || $3433a3b89d1ad09b$var$_unsupportedIterableToArray(arr, i) || $3433a3b89d1ad09b$var$_nonIterableRest();
}
function $3433a3b89d1ad09b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3433a3b89d1ad09b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3433a3b89d1ad09b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3433a3b89d1ad09b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3433a3b89d1ad09b$var$_arrayLikeToArray(o, minLen);
}
function $3433a3b89d1ad09b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3433a3b89d1ad09b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $3433a3b89d1ad09b$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $3433a3b89d1ad09b$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $3433a3b89d1ad09b$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $3433a3b89d1ad09b$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $3433a3b89d1ad09b$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $3433a3b89d1ad09b$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $3433a3b89d1ad09b$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $3433a3b89d1ad09b$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $3433a3b89d1ad09b$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $3433a3b89d1ad09b$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $3433a3b89d1ad09b$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $3433a3b89d1ad09b$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $3433a3b89d1ad09b$var$InitialDeviceTypes;
    }
};
var $3433a3b89d1ad09b$var$setUserAgent = function setUserAgent(userAgent) {
    return $3433a3b89d1ad09b$var$setUa(userAgent);
};
var $3433a3b89d1ad09b$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $3433a3b89d1ad09b$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $3433a3b89d1ad09b$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $3433a3b89d1ad09b$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $3433a3b89d1ad09b$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $3433a3b89d1ad09b$var$setDefaults(browser.major),
        browserFullVersion: $3433a3b89d1ad09b$var$setDefaults(browser.version),
        browserName: $3433a3b89d1ad09b$var$setDefaults(browser.name),
        engineName: $3433a3b89d1ad09b$var$setDefaults(engine.name),
        engineVersion: $3433a3b89d1ad09b$var$setDefaults(engine.version),
        osName: $3433a3b89d1ad09b$var$setDefaults(os.name),
        osVersion: $3433a3b89d1ad09b$var$setDefaults(os.version),
        userAgent: $3433a3b89d1ad09b$var$setDefaults(ua)
    };
};
var $3433a3b89d1ad09b$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $3433a3b89d1ad09b$var$_objectSpread2({}, type, {
        vendor: $3433a3b89d1ad09b$var$setDefaults(device.vendor),
        model: $3433a3b89d1ad09b$var$setDefaults(device.model),
        os: $3433a3b89d1ad09b$var$setDefaults(os.name),
        osVersion: $3433a3b89d1ad09b$var$setDefaults(os.version),
        ua: $3433a3b89d1ad09b$var$setDefaults(ua)
    });
};
var $3433a3b89d1ad09b$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $3433a3b89d1ad09b$var$setDefaults(engine.name),
        engineVersion: $3433a3b89d1ad09b$var$setDefaults(engine.version),
        osName: $3433a3b89d1ad09b$var$setDefaults(os.name),
        osVersion: $3433a3b89d1ad09b$var$setDefaults(os.version),
        userAgent: $3433a3b89d1ad09b$var$setDefaults(ua)
    };
};
var $3433a3b89d1ad09b$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $3433a3b89d1ad09b$var$setDefaults(engine.name),
        engineVersion: $3433a3b89d1ad09b$var$setDefaults(engine.version),
        osName: $3433a3b89d1ad09b$var$setDefaults(os.name),
        osVersion: $3433a3b89d1ad09b$var$setDefaults(os.version),
        userAgent: $3433a3b89d1ad09b$var$setDefaults(ua)
    };
};
var $3433a3b89d1ad09b$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $3433a3b89d1ad09b$var$setDefaults(engine.name),
        engineVersion: $3433a3b89d1ad09b$var$setDefaults(engine.version),
        osName: $3433a3b89d1ad09b$var$setDefaults(os.name),
        osVersion: $3433a3b89d1ad09b$var$setDefaults(os.version),
        userAgent: $3433a3b89d1ad09b$var$setDefaults(ua)
    };
};
var $3433a3b89d1ad09b$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $3433a3b89d1ad09b$var$setDefaults(device.vendor),
        model: $3433a3b89d1ad09b$var$setDefaults(device.model),
        engineName: $3433a3b89d1ad09b$var$setDefaults(engine.name),
        engineVersion: $3433a3b89d1ad09b$var$setDefaults(engine.version),
        osName: $3433a3b89d1ad09b$var$setDefaults(os.name),
        osVersion: $3433a3b89d1ad09b$var$setDefaults(os.version),
        userAgent: $3433a3b89d1ad09b$var$setDefaults(ua)
    };
};
function $3433a3b89d1ad09b$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $3433a3b89d1ad09b$var$parseUserAgent(userAgent) : $3433a3b89d1ad09b$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $3433a3b89d1ad09b$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $3433a3b89d1ad09b$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $3433a3b89d1ad09b$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $3433a3b89d1ad09b$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $3433a3b89d1ad09b$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $3433a3b89d1ad09b$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $3433a3b89d1ad09b$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $3433a3b89d1ad09b$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $3433a3b89d1ad09b$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Mobile;
};
var $3433a3b89d1ad09b$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Tablet;
};
var $3433a3b89d1ad09b$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Mobile || type === $3433a3b89d1ad09b$var$DeviceTypes.Tablet;
};
var $3433a3b89d1ad09b$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.SmartTv;
};
var $3433a3b89d1ad09b$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Browser;
};
var $3433a3b89d1ad09b$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Wearable;
};
var $3433a3b89d1ad09b$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Console;
};
var $3433a3b89d1ad09b$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $3433a3b89d1ad09b$var$DeviceTypes.Embedded;
};
var $3433a3b89d1ad09b$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $3433a3b89d1ad09b$var$setDefaults(vendor);
};
var $3433a3b89d1ad09b$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $3433a3b89d1ad09b$var$setDefaults(model);
};
var $3433a3b89d1ad09b$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $3433a3b89d1ad09b$var$setDefaults(type, "browser");
}; // os types
var $3433a3b89d1ad09b$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $3433a3b89d1ad09b$var$OsTypes.Android;
};
var $3433a3b89d1ad09b$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $3433a3b89d1ad09b$var$OsTypes.Windows;
};
var $3433a3b89d1ad09b$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $3433a3b89d1ad09b$var$OsTypes.MAC_OS;
};
var $3433a3b89d1ad09b$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $3433a3b89d1ad09b$var$OsTypes.WindowsPhone;
};
var $3433a3b89d1ad09b$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $3433a3b89d1ad09b$var$OsTypes.IOS;
};
var $3433a3b89d1ad09b$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $3433a3b89d1ad09b$var$setDefaults(version);
};
var $3433a3b89d1ad09b$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $3433a3b89d1ad09b$var$setDefaults(name);
}; // browser types
var $3433a3b89d1ad09b$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Chrome;
};
var $3433a3b89d1ad09b$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Firefox;
};
var $3433a3b89d1ad09b$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Chromium;
};
var $3433a3b89d1ad09b$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Edge;
};
var $3433a3b89d1ad09b$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Yandex;
};
var $3433a3b89d1ad09b$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Safari || name === $3433a3b89d1ad09b$var$BrowserTypes.MobileSafari;
};
var $3433a3b89d1ad09b$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.MobileSafari;
};
var $3433a3b89d1ad09b$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.Opera;
};
var $3433a3b89d1ad09b$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.InternetExplorer || name === $3433a3b89d1ad09b$var$BrowserTypes.Ie;
};
var $3433a3b89d1ad09b$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.MIUI;
};
var $3433a3b89d1ad09b$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $3433a3b89d1ad09b$var$BrowserTypes.SamsungBrowser;
};
var $3433a3b89d1ad09b$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $3433a3b89d1ad09b$var$setDefaults(version);
};
var $3433a3b89d1ad09b$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $3433a3b89d1ad09b$var$setDefaults(major);
};
var $3433a3b89d1ad09b$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $3433a3b89d1ad09b$var$setDefaults(name);
}; // engine types
var $3433a3b89d1ad09b$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $3433a3b89d1ad09b$var$setDefaults(name);
};
var $3433a3b89d1ad09b$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $3433a3b89d1ad09b$var$setDefaults(version);
};
var $3433a3b89d1ad09b$var$isElectronType = function isElectronType() {
    var nav = $3433a3b89d1ad09b$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $3433a3b89d1ad09b$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $3433a3b89d1ad09b$var$getIOS13 = function getIOS13() {
    var nav = $3433a3b89d1ad09b$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $3433a3b89d1ad09b$var$getIPad13 = function getIPad13() {
    return $3433a3b89d1ad09b$var$isIOS13Check("iPad");
};
var $3433a3b89d1ad09b$var$getIphone13 = function getIphone13() {
    return $3433a3b89d1ad09b$var$isIOS13Check("iPhone");
};
var $3433a3b89d1ad09b$var$getIPod13 = function getIPod13() {
    return $3433a3b89d1ad09b$var$isIOS13Check("iPod");
};
var $3433a3b89d1ad09b$var$getUseragent = function getUseragent(userAg) {
    return $3433a3b89d1ad09b$var$setDefaults(userAg);
};
function $3433a3b89d1ad09b$var$buildSelectorsObject(options) {
    var _ref = options ? options : $3433a3b89d1ad09b$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $3433a3b89d1ad09b$var$isSmartTVType(device),
        isConsole: $3433a3b89d1ad09b$var$isConsoleType(device),
        isWearable: $3433a3b89d1ad09b$var$isWearableType(device),
        isEmbedded: $3433a3b89d1ad09b$var$isEmbeddedType(device),
        isMobileSafari: $3433a3b89d1ad09b$var$isMobileSafariType(browser) || $3433a3b89d1ad09b$var$getIPad13(),
        isChromium: $3433a3b89d1ad09b$var$isChromiumType(browser),
        isMobile: $3433a3b89d1ad09b$var$isMobileAndTabletType(device) || $3433a3b89d1ad09b$var$getIPad13(),
        isMobileOnly: $3433a3b89d1ad09b$var$isMobileType(device),
        isTablet: $3433a3b89d1ad09b$var$isTabletType(device) || $3433a3b89d1ad09b$var$getIPad13(),
        isBrowser: $3433a3b89d1ad09b$var$isBrowserType(device),
        isDesktop: $3433a3b89d1ad09b$var$isBrowserType(device),
        isAndroid: $3433a3b89d1ad09b$var$isAndroidType(os),
        isWinPhone: $3433a3b89d1ad09b$var$isWinPhoneType(os),
        isIOS: $3433a3b89d1ad09b$var$isIOSType(os) || $3433a3b89d1ad09b$var$getIPad13(),
        isChrome: $3433a3b89d1ad09b$var$isChromeType(browser),
        isFirefox: $3433a3b89d1ad09b$var$isFirefoxType(browser),
        isSafari: $3433a3b89d1ad09b$var$isSafariType(browser),
        isOpera: $3433a3b89d1ad09b$var$isOperaType(browser),
        isIE: $3433a3b89d1ad09b$var$isIEType(browser),
        osVersion: $3433a3b89d1ad09b$var$getOsVersion(os),
        osName: $3433a3b89d1ad09b$var$getOsName(os),
        fullBrowserVersion: $3433a3b89d1ad09b$var$getBrowserFullVersion(browser),
        browserVersion: $3433a3b89d1ad09b$var$getBrowserVersion(browser),
        browserName: $3433a3b89d1ad09b$var$getBrowserName(browser),
        mobileVendor: $3433a3b89d1ad09b$var$getMobileVendor(device),
        mobileModel: $3433a3b89d1ad09b$var$getMobileModel(device),
        engineName: $3433a3b89d1ad09b$var$getEngineName(engine),
        engineVersion: $3433a3b89d1ad09b$var$getEngineVersion(engine),
        getUA: $3433a3b89d1ad09b$var$getUseragent(ua),
        isEdge: $3433a3b89d1ad09b$var$isEdgeType(browser) || $3433a3b89d1ad09b$var$isEdgeChromiumType(ua),
        isYandex: $3433a3b89d1ad09b$var$isYandexType(browser),
        deviceType: $3433a3b89d1ad09b$var$getDeviceType(device),
        isIOS13: $3433a3b89d1ad09b$var$getIOS13(),
        isIPad13: $3433a3b89d1ad09b$var$getIPad13(),
        isIPhone13: $3433a3b89d1ad09b$var$getIphone13(),
        isIPod13: $3433a3b89d1ad09b$var$getIPod13(),
        isElectron: $3433a3b89d1ad09b$var$isElectronType(),
        isEdgeChromium: $3433a3b89d1ad09b$var$isEdgeChromiumType(ua),
        isLegacyEdge: $3433a3b89d1ad09b$var$isEdgeType(browser) && !$3433a3b89d1ad09b$var$isEdgeChromiumType(ua),
        isWindows: $3433a3b89d1ad09b$var$isWindowsType(os),
        isMacOs: $3433a3b89d1ad09b$var$isMacOsType(os),
        isMIUI: $3433a3b89d1ad09b$var$isMIUIType(browser),
        isSamsungBrowser: $3433a3b89d1ad09b$var$isSamsungBrowserType(browser)
    };
}
var $3433a3b89d1ad09b$var$isSmartTV = $3433a3b89d1ad09b$var$isSmartTVType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isConsole = $3433a3b89d1ad09b$var$isConsoleType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isWearable = $3433a3b89d1ad09b$var$isWearableType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isEmbedded = $3433a3b89d1ad09b$var$isEmbeddedType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isMobileSafari = $3433a3b89d1ad09b$var$isMobileSafariType($3433a3b89d1ad09b$var$browser) || $3433a3b89d1ad09b$var$getIPad13();
var $3433a3b89d1ad09b$var$isChromium = $3433a3b89d1ad09b$var$isChromiumType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$isMobile = $3433a3b89d1ad09b$var$isMobileAndTabletType($3433a3b89d1ad09b$var$device) || $3433a3b89d1ad09b$var$getIPad13();
var $3433a3b89d1ad09b$var$isMobileOnly = $3433a3b89d1ad09b$var$isMobileType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isTablet = $3433a3b89d1ad09b$var$isTabletType($3433a3b89d1ad09b$var$device) || $3433a3b89d1ad09b$var$getIPad13();
var $3433a3b89d1ad09b$var$isBrowser = $3433a3b89d1ad09b$var$isBrowserType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isDesktop = $3433a3b89d1ad09b$var$isBrowserType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isAndroid = $3433a3b89d1ad09b$var$isAndroidType($3433a3b89d1ad09b$var$os);
var $3433a3b89d1ad09b$var$isWinPhone = $3433a3b89d1ad09b$var$isWinPhoneType($3433a3b89d1ad09b$var$os);
var $3433a3b89d1ad09b$var$isIOS = $3433a3b89d1ad09b$var$isIOSType($3433a3b89d1ad09b$var$os) || $3433a3b89d1ad09b$var$getIPad13();
var $3433a3b89d1ad09b$var$isChrome = $3433a3b89d1ad09b$var$isChromeType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$isFirefox = $3433a3b89d1ad09b$var$isFirefoxType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$isSafari = $3433a3b89d1ad09b$var$isSafariType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$isOpera = $3433a3b89d1ad09b$var$isOperaType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$isIE = $3433a3b89d1ad09b$var$isIEType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$osVersion = $3433a3b89d1ad09b$var$getOsVersion($3433a3b89d1ad09b$var$os);
var $3433a3b89d1ad09b$var$osName = $3433a3b89d1ad09b$var$getOsName($3433a3b89d1ad09b$var$os);
var $3433a3b89d1ad09b$var$fullBrowserVersion = $3433a3b89d1ad09b$var$getBrowserFullVersion($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$browserVersion = $3433a3b89d1ad09b$var$getBrowserVersion($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$browserName = $3433a3b89d1ad09b$var$getBrowserName($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$mobileVendor = $3433a3b89d1ad09b$var$getMobileVendor($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$mobileModel = $3433a3b89d1ad09b$var$getMobileModel($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$engineName = $3433a3b89d1ad09b$var$getEngineName($3433a3b89d1ad09b$var$engine);
var $3433a3b89d1ad09b$var$engineVersion = $3433a3b89d1ad09b$var$getEngineVersion($3433a3b89d1ad09b$var$engine);
var $3433a3b89d1ad09b$var$getUA = $3433a3b89d1ad09b$var$getUseragent($3433a3b89d1ad09b$var$ua);
var $3433a3b89d1ad09b$var$isEdge = $3433a3b89d1ad09b$var$isEdgeType($3433a3b89d1ad09b$var$browser) || $3433a3b89d1ad09b$var$isEdgeChromiumType($3433a3b89d1ad09b$var$ua);
var $3433a3b89d1ad09b$var$isYandex = $3433a3b89d1ad09b$var$isYandexType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$deviceType = $3433a3b89d1ad09b$var$getDeviceType($3433a3b89d1ad09b$var$device);
var $3433a3b89d1ad09b$var$isIOS13 = $3433a3b89d1ad09b$var$getIOS13();
var $3433a3b89d1ad09b$var$isIPad13 = $3433a3b89d1ad09b$var$getIPad13();
var $3433a3b89d1ad09b$var$isIPhone13 = $3433a3b89d1ad09b$var$getIphone13();
var $3433a3b89d1ad09b$var$isIPod13 = $3433a3b89d1ad09b$var$getIPod13();
var $3433a3b89d1ad09b$var$isElectron = $3433a3b89d1ad09b$var$isElectronType();
var $3433a3b89d1ad09b$var$isEdgeChromium = $3433a3b89d1ad09b$var$isEdgeChromiumType($3433a3b89d1ad09b$var$ua);
var $3433a3b89d1ad09b$var$isLegacyEdge = $3433a3b89d1ad09b$var$isEdgeType($3433a3b89d1ad09b$var$browser) && !$3433a3b89d1ad09b$var$isEdgeChromiumType($3433a3b89d1ad09b$var$ua);
var $3433a3b89d1ad09b$var$isWindows = $3433a3b89d1ad09b$var$isWindowsType($3433a3b89d1ad09b$var$os);
var $3433a3b89d1ad09b$var$isMacOs = $3433a3b89d1ad09b$var$isMacOsType($3433a3b89d1ad09b$var$os);
var $3433a3b89d1ad09b$var$isMIUI = $3433a3b89d1ad09b$var$isMIUIType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$isSamsungBrowser = $3433a3b89d1ad09b$var$isSamsungBrowserType($3433a3b89d1ad09b$var$browser);
var $3433a3b89d1ad09b$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $3433a3b89d1ad09b$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $3433a3b89d1ad09b$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $3433a3b89d1ad09b$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isAndroid ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isBrowser ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isIE ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isIOS ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isMobile ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isTablet ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isWinPhone ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $3433a3b89d1ad09b$var$isMobileOnly ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isSmartTV ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isConsole ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $3433a3b89d1ad09b$var$isWearable ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
var $3433a3b89d1ad09b$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $3433a3b89d1ad09b$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $3433a3b89d1ad09b$var$React__default.createElement($7fPBF.Fragment, null, children) : $3433a3b89d1ad09b$var$React__default.createElement("div", props, children) : null;
};
function $3433a3b89d1ad09b$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $3433a3b89d1ad09b$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $3433a3b89d1ad09b$var$_classCallCheck(this, _class);
            _this = $3433a3b89d1ad09b$var$_possibleConstructorReturn(this, $3433a3b89d1ad09b$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($3433a3b89d1ad09b$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($3433a3b89d1ad09b$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($3433a3b89d1ad09b$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $3433a3b89d1ad09b$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $3433a3b89d1ad09b$var$_typeof(window)) !== undefined && $3433a3b89d1ad09b$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $3433a3b89d1ad09b$var$React__default.createElement(WrappedComponent, $3433a3b89d1ad09b$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($3433a3b89d1ad09b$var$React__default.Component);
}
function $3433a3b89d1ad09b$var$useMobileOrientation() {
    var _useState = $7fPBF.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $3433a3b89d1ad09b$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $7fPBF.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $7fPBF.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $3433a3b89d1ad09b$var$_typeof(window)) !== undefined && $3433a3b89d1ad09b$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $3433a3b89d1ad09b$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $3433a3b89d1ad09b$var$parseUserAgent(hookUserAgent);
}
function $3433a3b89d1ad09b$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $3433a3b89d1ad09b$var$useDeviceData(hookUserAgent);
    var selectors = $3433a3b89d1ad09b$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$3433a3b89d1ad09b$exports.AndroidView = $3433a3b89d1ad09b$var$AndroidView;
$3433a3b89d1ad09b$exports.BrowserTypes = $3433a3b89d1ad09b$var$BrowserTypes;
$3433a3b89d1ad09b$exports.BrowserView = $3433a3b89d1ad09b$var$BrowserView;
$3433a3b89d1ad09b$exports.ConsoleView = $3433a3b89d1ad09b$var$ConsoleView;
$3433a3b89d1ad09b$exports.CustomView = $3433a3b89d1ad09b$var$CustomView;
$3433a3b89d1ad09b$exports.IEView = $3433a3b89d1ad09b$var$IEView;
$3433a3b89d1ad09b$exports.IOSView = $3433a3b89d1ad09b$var$IOSView;
$3433a3b89d1ad09b$exports.MobileOnlyView = $3433a3b89d1ad09b$var$MobileOnlyView;
$3433a3b89d1ad09b$exports.MobileView = $3433a3b89d1ad09b$var$MobileView;
$3433a3b89d1ad09b$exports.OsTypes = $3433a3b89d1ad09b$var$OsTypes;
$3433a3b89d1ad09b$exports.SmartTVView = $3433a3b89d1ad09b$var$SmartTVView;
$3433a3b89d1ad09b$exports.TabletView = $3433a3b89d1ad09b$var$TabletView;
$3433a3b89d1ad09b$exports.WearableView = $3433a3b89d1ad09b$var$WearableView;
$3433a3b89d1ad09b$exports.WinPhoneView = $3433a3b89d1ad09b$var$WinPhoneView;
$3433a3b89d1ad09b$exports.browserName = $3433a3b89d1ad09b$var$browserName;
$3433a3b89d1ad09b$exports.browserVersion = $3433a3b89d1ad09b$var$browserVersion;
$3433a3b89d1ad09b$exports.deviceDetect = $3433a3b89d1ad09b$var$deviceDetect;
$3433a3b89d1ad09b$exports.deviceType = $3433a3b89d1ad09b$var$deviceType;
$3433a3b89d1ad09b$exports.engineName = $3433a3b89d1ad09b$var$engineName;
$3433a3b89d1ad09b$exports.engineVersion = $3433a3b89d1ad09b$var$engineVersion;
$3433a3b89d1ad09b$exports.fullBrowserVersion = $3433a3b89d1ad09b$var$fullBrowserVersion;
$3433a3b89d1ad09b$exports.getSelectorsByUserAgent = $3433a3b89d1ad09b$var$getSelectorsByUserAgent;
$3433a3b89d1ad09b$exports.getUA = $3433a3b89d1ad09b$var$getUA;
$3433a3b89d1ad09b$exports.isAndroid = $3433a3b89d1ad09b$var$isAndroid;
$3433a3b89d1ad09b$exports.isBrowser = $3433a3b89d1ad09b$var$isBrowser;
$3433a3b89d1ad09b$exports.isChrome = $3433a3b89d1ad09b$var$isChrome;
$3433a3b89d1ad09b$exports.isChromium = $3433a3b89d1ad09b$var$isChromium;
$3433a3b89d1ad09b$exports.isConsole = $3433a3b89d1ad09b$var$isConsole;
$3433a3b89d1ad09b$exports.isDesktop = $3433a3b89d1ad09b$var$isDesktop;
$3433a3b89d1ad09b$exports.isEdge = $3433a3b89d1ad09b$var$isEdge;
$3433a3b89d1ad09b$exports.isEdgeChromium = $3433a3b89d1ad09b$var$isEdgeChromium;
$3433a3b89d1ad09b$exports.isElectron = $3433a3b89d1ad09b$var$isElectron;
$3433a3b89d1ad09b$exports.isEmbedded = $3433a3b89d1ad09b$var$isEmbedded;
$3433a3b89d1ad09b$exports.isFirefox = $3433a3b89d1ad09b$var$isFirefox;
$3433a3b89d1ad09b$exports.isIE = $3433a3b89d1ad09b$var$isIE;
$3433a3b89d1ad09b$exports.isIOS = $3433a3b89d1ad09b$var$isIOS;
$3433a3b89d1ad09b$exports.isIOS13 = $3433a3b89d1ad09b$var$isIOS13;
$3433a3b89d1ad09b$exports.isIPad13 = $3433a3b89d1ad09b$var$isIPad13;
$3433a3b89d1ad09b$exports.isIPhone13 = $3433a3b89d1ad09b$var$isIPhone13;
$3433a3b89d1ad09b$exports.isIPod13 = $3433a3b89d1ad09b$var$isIPod13;
$3433a3b89d1ad09b$exports.isLegacyEdge = $3433a3b89d1ad09b$var$isLegacyEdge;
$3433a3b89d1ad09b$exports.isMIUI = $3433a3b89d1ad09b$var$isMIUI;
$3433a3b89d1ad09b$exports.isMacOs = $3433a3b89d1ad09b$var$isMacOs;
$3433a3b89d1ad09b$exports.isMobile = $3433a3b89d1ad09b$var$isMobile;
$3433a3b89d1ad09b$exports.isMobileOnly = $3433a3b89d1ad09b$var$isMobileOnly;
$3433a3b89d1ad09b$exports.isMobileSafari = $3433a3b89d1ad09b$var$isMobileSafari;
$3433a3b89d1ad09b$exports.isOpera = $3433a3b89d1ad09b$var$isOpera;
$3433a3b89d1ad09b$exports.isSafari = $3433a3b89d1ad09b$var$isSafari;
$3433a3b89d1ad09b$exports.isSamsungBrowser = $3433a3b89d1ad09b$var$isSamsungBrowser;
$3433a3b89d1ad09b$exports.isSmartTV = $3433a3b89d1ad09b$var$isSmartTV;
$3433a3b89d1ad09b$exports.isTablet = $3433a3b89d1ad09b$var$isTablet;
$3433a3b89d1ad09b$exports.isWearable = $3433a3b89d1ad09b$var$isWearable;
$3433a3b89d1ad09b$exports.isWinPhone = $3433a3b89d1ad09b$var$isWinPhone;
$3433a3b89d1ad09b$exports.isWindows = $3433a3b89d1ad09b$var$isWindows;
$3433a3b89d1ad09b$exports.isYandex = $3433a3b89d1ad09b$var$isYandex;
$3433a3b89d1ad09b$exports.mobileModel = $3433a3b89d1ad09b$var$mobileModel;
$3433a3b89d1ad09b$exports.mobileVendor = $3433a3b89d1ad09b$var$mobileVendor;
$3433a3b89d1ad09b$exports.osName = $3433a3b89d1ad09b$var$osName;
$3433a3b89d1ad09b$exports.osVersion = $3433a3b89d1ad09b$var$osVersion;
$3433a3b89d1ad09b$exports.parseUserAgent = $3433a3b89d1ad09b$var$parseUserAgent;
$3433a3b89d1ad09b$exports.setUserAgent = $3433a3b89d1ad09b$var$setUserAgent;
$3433a3b89d1ad09b$exports.useDeviceData = $3433a3b89d1ad09b$var$useDeviceData;
$3433a3b89d1ad09b$exports.useDeviceSelectors = $3433a3b89d1ad09b$var$useDeviceSelectors;
$3433a3b89d1ad09b$exports.useMobileOrientation = $3433a3b89d1ad09b$var$useMobileOrientation;
$3433a3b89d1ad09b$exports.withOrientationChange = $3433a3b89d1ad09b$var$withOrientationChange;





const $1efa4a2a7158b1cd$var$paragraphs = [
    {
        name: "paragraphs.0.name",
        description: "paragraphs.0.description",
        icon: (0, $c67e8e5ff55101a6$export$2e2bcd8739ae039)
    },
    {
        name: "paragraphs.1.name",
        description: "paragraphs.1.description",
        icon: (0, $8ac26489e86e9865$export$2e2bcd8739ae039)
    },
    {
        name: "paragraphs.2.name",
        description: "paragraphs.2.description",
        descriptionShare: "paragraphs.2.descriptionShare",
        icon: (0, $e951391b5370d281$export$2e2bcd8739ae039)
    }
];
function $1efa4a2a7158b1cd$export$2e2bcd8739ae039({ setRecommendUsVisible: setRecommendUsVisible }) {
    const [copied, setCopied] = (0, $7fPBF.useState)(false);
    const [gettingCode, setGettingCode] = (0, $7fPBF.useState)(true);
    const [code, setCode] = (0, $7fPBF.useState)(undefined);
    const { share: share } = navigator;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("invitation");
    const shareText = `${t("invitationText0")}
  ${t("invitationText1")}
  ${t("invitationText2", {
        code: code
    })}`;
    // get code from API
    (0, $7fPBF.useEffect)(()=>{
        async function getCodeFromAPI() {
            const result = await (0, $bad5f4197326a006$export$f9b80e5c5f37b582)("myAPI", "customer/registrationCodes");
            setCode(result);
            setGettingCode(false);
        }
        getCodeFromAPI(); // after PRD-1214 implemented (1.1+) this can return #ERROR if the user is not allowed to recommend yet, needs to be handled
    }, []);
    async function onClick() {
        // check if share is supported and if the browser is a mobile one ('share' is also supported on desktop, and Windows makes a total mess out of it)
        if (share && (0, $3433a3b89d1ad09b$exports.isMobile)) try {
            await navigator.share({
                title: t("title"),
                text: shareText,
                url: "https://www.monestry.de/features"
            });
            console.log("Successfully shared");
        } catch (error) {
            console.error("Error sharing:", error);
        }
        else {
            // copy invitationText to clipboard and set copied to true
            navigator.clipboard.writeText(shareText);
            setCopied(true);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25250cd4374f51ac$export$2e2bcd8739ae039), {
        fixedHeight: true,
        noPadding: true,
        closeCallback: ()=>setRecommendUsVisible(false),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "md:grid md:grid-cols-12 md:h-full overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "md:col-span-7 my-auto px-12",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-sm font-semibold tracking-wider uppercase leading-7 text-brandBlue-500",
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                            className: "mt-2 text-3xl font-black text-gray-900 sm:text-5xl",
                            children: [
                                t("subtitle.top"),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("br", {}),
                                t("subtitle.bottom")
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "mt-8 text-lg leading-7 text-gray-600",
                            children: t("description")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
                            className: "mt-10 max-w-xl space-y-8 text-base leading-6 text-gray-600 lg:max-w-none prose",
                            children: $1efa4a2a7158b1cd$var$paragraphs.map((paragraph)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "relative pl-9",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dt", {
                                            className: "inline font-semibold text-gray-900",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(paragraph.icon, {
                                                    className: "absolute left-1 top-1 h-5 w-5 text-brandBlue-500",
                                                    "aria-hidden": "true"
                                                }),
                                                t(paragraph.name)
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                                            className: "inline",
                                            children: t(paragraph.description)
                                        })
                                    ]
                                }, paragraph.name))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "mt-10 border border-gray-200 shadow-sm prose mx-auto text-sm rounded-md p-4 italic",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t("invitationText0")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t("invitationText1")
                                }),
                                gettingCode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5 animate-spin text-gray-400"
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t("invitationText2", {
                                        code: code
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "my-5 flex justify-center gap-x-6",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: onClick,
                                disabled: gettingCode,
                                className: `rounded-md ${gettingCode ? "bg-gray-200" : "bg-brandBlue-500"} px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brandBlue-400
              focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brandBlue-400`,
                                children: [
                                    share && (0, $3433a3b89d1ad09b$exports.isMobile) ? "Share" : "Copy",
                                    copied && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef0832052dc462d9$export$2e2bcd8739ae039), {
                                        className: "inline h-5 w-5 ml-2 -mt-1 text-white",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "overflow-hidden bg-gray-100 md:col-span-5 max-h-[93vh]",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "object-cover object-center h-full w-full",
                        src: "https://images.unsplash.com/photo-1619560820102-31f5b04c049a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzMDUyOTN8MHwxfGFsbHx8fHx8fHx8fDE2ODY5OTI5ODN8&ixlib=rb-4.0.3&q=80&w=1080",
                        alt: "post stamps"
                    })
                })
            ]
        })
    });
}
$1efa4a2a7158b1cd$export$2e2bcd8739ae039.propTypes = {
    setRecommendUsVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/prop-types */ /* eslint-disable object-curly-newline */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");








var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $5fb3c4274d9dfed0$var$debugLevel = 0;
function $5fb3c4274d9dfed0$export$2e2bcd8739ae039(currentAllocationFiltered, targetAllocationFiltered) {
    // get names of all  categories which exist from currentAllocation
    const categories = [
        ...new Set(currentAllocationFiltered.map((entry)=>entry.category))
    ];
    const portfolioLevelAllocation = targetAllocationFiltered.filter((e)=>!e.assetClass && !e.currency);
    if ($5fb3c4274d9dfed0$var$debugLevel > 2) console.info("calculatePortfolioAllocation: received the following portfolio-level target allocation rows:", JSON.stringify(portfolioLevelAllocation, null, 2));
    // if there are no portfolio-level allocations at all, return null value for each category
    if (portfolioLevelAllocation.length === 0 || portfolioLevelAllocation.every((e)=>e.value === undefined || e.value === null)) return categories.map((c)=>({
            category: c,
            assetClass: null,
            currency: null,
            value: null
        }));
     // return null value for each category
    const sumOfAllocation = portfolioLevelAllocation.reduce((sum, e)=>sum + Number(e.value), 0);
    if ($5fb3c4274d9dfed0$var$debugLevel > 2) console.info("calculatePortfolioAllocation: allocation of received rows is", sumOfAllocation);
    const remainingAllocation = 100 - sumOfAllocation;
    // there is one allocation per each category and allocation is complete - returning input allocation
    if (portfolioLevelAllocation.lentgh === categories.length && remainingAllocation === 0) return portfolioLevelAllocation;
    const lockedCategoriesAllocation = portfolioLevelAllocation.filter((e)=>e.locked).reduce((acc, e)=>acc + Number(e.value), 0);
    if ($5fb3c4274d9dfed0$var$debugLevel > 2) console.info("calculatePortfolioAllocation: locked categories allocation is", lockedCategoriesAllocation);
    // handle the case where all categories are there, but there is not 100% allocation
    if (portfolioLevelAllocation.length === categories.length && remainingAllocation !== 0) {
        if ($5fb3c4274d9dfed0$var$debugLevel > 2) console.info("calculatePortfolioAllocation: all categories present in targetAllocation, but do not sum up to 100", portfolioLevelAllocation);
        const multiplier = (100 - lockedCategoriesAllocation) / (sumOfAllocation - lockedCategoriesAllocation || 1); // portfolioLevelAllocation.filter((e) => !e.locked).length;
        return portfolioLevelAllocation.map((e)=>e.locked ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
                value: (e.value || 1) * multiplier
            }));
    }
    // handle the case where some categories are missing in targetAllocation and there is at least one other category with a value
    // find out which ones, add them and spread the remaining allocation equally (considering the locked categories)
    const missingCategories = categories.filter((c)=>!portfolioLevelAllocation.find((e)=>e.category === c));
    const categoryFactor = remainingAllocation / missingCategories.length;
    return [
        ...portfolioLevelAllocation,
        ...missingCategories.map((c)=>({
                category: c,
                assetClass: null,
                currency: null,
                value: Math.round(categoryFactor)
            }))
    ];
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $3aff36210e2443a5$var$debugLevel = 0;
function $3aff36210e2443a5$export$7932e48679f368e0(category, currentAllocation, targetAllocation, currencies) {
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- calculating category allocation for currencies", currencies);
    const currentCategoryAllocation = currentAllocation.filter((e)=>e.category === category);
    const sumOfCurrentCategory = currentCategoryAllocation.reduce((sum, e)=>sum + Number(e.current.valueBaseCurrency), 0);
    const currentCategoryTargetAllocation = targetAllocation.filter((e)=>e.category === category && !e.assetClass && e.currency); // category-level allocation (have currency, but no asset class)
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- received these current holdings", currentCategoryAllocation);
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- received these category-level target allocations", currentCategoryTargetAllocation);
    if (currentCategoryTargetAllocation.length === 0 || currentCategoryTargetAllocation.every((e)=>e.value === null || e.value === undefined)) {
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- there are no target allocations -- returning null value for each currency");
        return currencies.map((c)=>{
            const sumCurrentCurrency = currentCategoryAllocation.filter((e)=>e.assetCurrency === c).reduce((sum, e)=>sum + Number(e.current.valueBaseCurrency), 0);
            return {
                category: category,
                currency: c,
                assetClass: null,
                // value: null, // shouldn't this be current allocation? otherwise rebalancing won't work, because it will be trying to multiply by null
                // return current allocation if exists; otherwise null
                value: sumOfCurrentCategory === 0 ? null : sumCurrentCurrency / sumOfCurrentCategory * 100
            };
        });
    } // return null value for each category
    const sumOfTargetAllocations = currentCategoryTargetAllocation.reduce((sum, e)=>sum + Number(e.value), 0);
    const remainingAllocation = 100 - sumOfTargetAllocations;
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- this category has allocation of", sumOfTargetAllocations, ", so remainingAllocation is", remainingAllocation);
    if (currentCategoryTargetAllocation.lentgh === currencies.length && remainingAllocation === 0) return currentCategoryTargetAllocation;
    // there is nothing to do, there is one allocation per each category and allocation is complete
    const lockedCategoriesAllocation = currentCategoryTargetAllocation.filter((e)=>e.locked).reduce((acc, e)=>acc + Number(e.value), 0);
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- locked categories allocation is", lockedCategoriesAllocation);
    // handle the case where all categories are there, but there is not 100% allocation
    if (currentCategoryTargetAllocation.length === currencies.length && remainingAllocation !== 0) {
        // eslint-disable-next-line max-len
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- all currencies for this category are present in targetAllocation, but do not sum up to 100", JSON.stringify(currentCategoryTargetAllocation, null, 2));
        const multiplier = (100 - lockedCategoriesAllocation) / (sumOfTargetAllocations - lockedCategoriesAllocation);
        // if there are locked items (that cannot be changed), we need to adjust both sides of the division (instead of 10 + 20 (locked) + 30 --> 100,  we are only doing 10 + 30 --> 80)
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- multiplier is", multiplier);
        return currentCategoryTargetAllocation.map((e)=>e.locked ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
                assetClass: null,
                value: Number((e.value * multiplier).toFixed(2))
            }));
    }
    // which currencies are missing in categoryLevelAllocation?
    const missingCurrencies = currencies.filter((c)=>!currentCategoryTargetAllocation.find((e)=>e.currency === c));
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- following currencies do not have target allocation:", missingCurrencies);
    const categoryFactor = missingCurrencies.length === 0 ? 0 : remainingAllocation / missingCurrencies.length;
    // eslint-disable-next-line max-len
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "- remaining allocation is", remainingAllocation, "so each new target row for each of the missing currencies has a value of", categoryFactor);
    return [
        ...currentCategoryTargetAllocation,
        ...missingCurrencies.map((c)=>({
                category: category,
                assetClass: null,
                currency: c,
                value: Math.round(categoryFactor)
            }))
    ];
}
function $3aff36210e2443a5$export$571c351d1708e65(category, assetClass, currentAllocation, targetAllocation, currencies) {
    const currentAssetClassTargetAllocation = targetAllocation.filter((e)=>e.category === category && e.assetClass === assetClass);
    const parentAllocation = targetAllocation.filter((e)=>e.category === category && !e.assetClass);
    const parentIsEmpty = parentAllocation.every((e)=>e.value === null || e.value === undefined); // parent is empty when all its members have null value
    // if there are no allocations, copy those of the parent (category) or return null value for each currency if there is no parent allocation
    if (currentAssetClassTargetAllocation.length === 0 || currentAssetClassTargetAllocation.every((e)=>e.value === null)) {
        if (!parentIsEmpty) // if there is parentAllocation (it should be complete, as calculateCategoryAllocation was called before)
        return parentAllocation.map((e)=>(0, $2qxEV._)((0, $9tqwB._)({}, e), {
                assetClass: assetClass
            }));
        return currencies.map((c)=>({
                category: // return null value for each category
                category,
                currency: c,
                assetClass: assetClass,
                value: null
            }));
    }
    const sumOfAllocation = currentAssetClassTargetAllocation.reduce((sum, e)=>sum + Number(e.value), 0);
    const remainingAllocation = 100 - sumOfAllocation;
    // if we have all the allocations (i.e. there is one allocation for this asset class for each currency and they sum up to 100), return them as-is
    // eslint-disable-next-line max-len
    if (currentAssetClassTargetAllocation.lentgh === currencies.length && remainingAllocation === 0) return currentAssetClassTargetAllocation; // there is nothing to do, there is one allocation per each category and allocation is complete
    const lockedAssetClassesAllocation = currentAssetClassTargetAllocation.filter((e)=>e.locked).reduce((acc, e)=>acc + Number(e.value), 0);
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "locked categories allocation is", lockedAssetClassesAllocation);
    // if we have all the allocations, but they do not sum up to 100, adjust them to sum up to 100
    if (currentAssetClassTargetAllocation.length === currencies.length && remainingAllocation !== 0) {
        // eslint-disable-next-line max-len
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "all currencies for this category are present in targetAllocation, but do not sum up to 100", JSON.stringify(currentAssetClassTargetAllocation, null, 2));
        const multiplier = (100 - lockedAssetClassesAllocation) / (sumOfAllocation - lockedAssetClassesAllocation); // see comment in the categories function above
        return currentAssetClassTargetAllocation.map((e)=>e.locked ? e : (0, $2qxEV._)((0, $9tqwB._)({}, e), {
                value: e.value * multiplier
            }));
    }
    // which currencies are missing in categoryLevelAllocation?
    const missingCurrencies = currencies.filter((c)=>!currentAssetClassTargetAllocation.find((e)=>e.currency === c));
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "following currencies do not have target allocation in", category, ":", missingCurrencies);
    if (!parentIsEmpty) {
        // apply allocation to missing currencies in the same proportion as the parent allocation
        const parentAllocationForMissingCurrencies = parentAllocation.filter((e)=>missingCurrencies.includes(e.currency));
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "parent allocation for the missing currencies are", JSON.stringify(parentAllocationForMissingCurrencies, null, 2));
        const sumParentAllocationForMissingCurrencies = parentAllocationForMissingCurrencies.reduce((sum, e)=>sum + Number(e.value), 0);
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "sum of parent allocation for the missing currencies is", sumParentAllocationForMissingCurrencies);
        return [
            ...currentAssetClassTargetAllocation,
            ...missingCurrencies.map((c)=>({
                    category: category,
                    assetClass: assetClass,
                    currency: c,
                    value: remainingAllocation * (parentAllocationForMissingCurrencies.find((a)=>a.currency === c).value / sumParentAllocationForMissingCurrencies)
                }))
        ];
    }
    // else apply allocation to missing currencies in equal proportions
    const categoryFactor = remainingAllocation / missingCurrencies.length;
    return [
        ...currentAssetClassTargetAllocation,
        ...missingCurrencies.map((c)=>({
                category: category,
                assetClass: assetClass,
                currency: c,
                value: categoryFactor
            }))
    ];
}
function $3aff36210e2443a5$export$2e2bcd8739ae039(targetAllocationFiltered, currentAllocationFiltered) {
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation: targetAllocationFiltered", targetAllocationFiltered, "currentAllocationFiltered", currentAllocationFiltered);
    // calculate unique values in the asset hierarchy and in categories
    const categories = [
        ...new Set(currentAllocationFiltered.map((entry)=>entry.category))
    ];
    const currencies = [
        ...new Set(currentAllocationFiltered.map((entry)=>entry.assetCurrency))
    ];
    // complete target allocation table based on user input (targetAllocation)
    const completeTargetAllocation = [];
    categories.forEach((category)=>{
        completeTargetAllocation.push(...$3aff36210e2443a5$export$7932e48679f368e0(category, currentAllocationFiltered, targetAllocationFiltered, currencies));
        // important: if all values in categoryLevelAllocation are null, we didn't manage to calculate the allocation on the category level
        const assetClasses = [
            ...new Set(currentAllocationFiltered.filter((entry)=>entry.category === category).map((entry)=>entry.assetClass))
        ];
        if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionAllocation:", category, "in category", category, "there are following asset classes:", assetClasses);
        if (assetClasses.length > 0 && assetClasses[0] !== undefined) assetClasses.forEach((assetClass)=>{
            completeTargetAllocation.push(...$3aff36210e2443a5$export$571c351d1708e65(category, assetClass, currentAllocationFiltered, targetAllocationFiltered, currencies));
        // important: if all values in categoryLevelAllocation are null, we didn't manage to calculate the allocation on the category level
        });
    });
    if ($3aff36210e2443a5$var$debugLevel > 2) console.info("calculateDimensionFactors: completeTargetAllocation", JSON.stringify(completeTargetAllocation, null, 2));
    return completeTargetAllocation; // at this stage completeTargetAllocation has rows for all categories, assetClasses and currencies; some of them may have null values;
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $07ee6236640c3c23$var$debugLevel = 0;
function $07ee6236640c3c23$export$2e2bcd8739ae039(currentAllocationFiltered, targetAllocationFiltered) {
    // filter out those rows of targetAllocation, which have a value in the category fields but have no values in all the other fields of assetHierarchy or the field which is now the dimension
    const targetAllocationCategories = targetAllocationFiltered.filter((row)=>row.category && !row.assetClass && !row.currency);
    // returns array of the rows which contain a value in the field topHierarchyLevel and have no values in all the other fields of assetHierarchy (i.e. for the category-level allocation)
    if ($07ee6236640c3c23$var$debugLevel > 2) console.info("getPortfolioDeltaFactors: received the following target allocation:", targetAllocationCategories);
    const totalSum = currentAllocationFiltered.reduce((acc, row)=>acc + row.current.valueBaseCurrency, 0);
    if ($07ee6236640c3c23$var$debugLevel > 2) console.info("getPortfolioDeltaFactors: current total of the entire portfolio is", totalSum);
    // calculate sum by category
    const categoryFactors = targetAllocationCategories.map((row)=>{
        // if the row.value is null, we assume that there is no allocation for any of the categories (it would otherwise be 0) and return factor of 0 (="leave unchanged")
        if (!row.value) return {
            category: row.category,
            assetClass: null,
            currency: null,
            factor: 0
        };
        const currentSumByCategory = currentAllocationFiltered.filter((position)=>position.category === row.category).reduce((acc, assetObject)=>acc + assetObject.current.valueBaseCurrency, 0);
        if ($07ee6236640c3c23$var$debugLevel > 2) console.info("getPortfolioDeltaFactors: current total of category", row.category, "is", currentSumByCategory);
        const targetSumByCategory = totalSum * (row.value / 100);
        if ($07ee6236640c3c23$var$debugLevel > 2) console.info("getPortfolioDeltaFactors: target total of category", row.category, "is", targetSumByCategory);
        return {
            category: row.category,
            assetClass: null,
            currency: null,
            factor: (targetSumByCategory - currentSumByCategory) / currentSumByCategory
        };
    });
    if ($07ee6236640c3c23$var$debugLevel > 2) console.info("getPortfolioDeltaFactors: categoryFactors", categoryFactors);
    return currentAllocationFiltered.map((row)=>{
        var _categoryFactors_find;
        const factor = ((_categoryFactors_find = categoryFactors.find((x)=>x.category === row.category)) === null || _categoryFactors_find === void 0 ? void 0 : _categoryFactors_find.factor) || 0;
        return (0, $2qxEV._)((0, $9tqwB._)({}, row), {
            categoryRebalancingAssetDeltaFactor: factor
        });
    });
}


/* eslint-disable max-len */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");
const $fed8d5f05838fc70$var$debugLevel = 0;
function $fed8d5f05838fc70$export$2e2bcd8739ae039(currentAllocationFiltered, targetAllocationFiltered) {
    // target allocation should be provided at assetClass level (even if no user data, it will be inherited), so we can skip category level
    // filter out those rows of targetAllocation, which have a value in the category fields but have no values in all the other fields of assetHierarchy or the field which is now the dimension
    // if there is no assetClass, add it with null
    const currentAllocationFilteredFixed = currentAllocationFiltered.map((x)=>x.assetClass ? x : (0, $2qxEV._)((0, $9tqwB._)({}, x), {
            assetClass: "null"
        })); // add assetClass if missing
    const categories = [
        ...new Set(currentAllocationFilteredFixed.map((entry)=>entry.category))
    ];
    const targetAssetClassAllocation = targetAllocationFiltered.map((row)=>(0, $2qxEV._)((0, $9tqwB._)({}, row), {
            assetClass: row.assetClass || "null"
        })).filter((row)=>row.category && row.assetClass && row.currency);
    // returns array of the rows which contain a value in the field topHierarchyLevel and have no values in all the other fields of assetHierarchy (i.e. for the category-level allocation)
    if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: targetAssetClassAllocation after replacing null fields", targetAssetClassAllocation);
    // return row for each assetClass and currency
    const rebalancingFactors = [];
    categories.forEach((category)=>{
        const assetClasses = [
            ...new Set(currentAllocationFilteredFixed.filter((x)=>x.category === category).map((entry)=>entry.assetClass))
        ];
        assetClasses.forEach((assetClass)=>{
            if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: starting loop for category", category, "and assetClass", assetClass);
            const assetClassCurrentAllocation = currentAllocationFilteredFixed.filter((row)=>row.category === category && row.assetClass === assetClass);
            const assetClassSum = assetClassCurrentAllocation.reduce((acc, row)=>acc + row.current.valueBaseCurrency, 0);
            if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: current holdings for", category, "and asset class", assetClass, "are", assetClassCurrentAllocation);
            if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: current asset sum for assetClass", assetClass, "is", assetClassSum);
            if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: target allocation for", category, "and asset class", assetClass, "are", targetAssetClassAllocation.filter((row)=>row.category === category && row.assetClass === assetClass));
            const targetAllocationWithFactor = targetAssetClassAllocation.filter((row)=>row.category === category && row.assetClass === assetClass) // this should produce an array with one element per each currency and assetClass
            .map((row)=>{
                const sumCurrentAmountByAssetClassAndCurrency = assetClassCurrentAllocation.filter((position)=>position.assetCurrency === row.currency).reduce((acc, assetObject)=>acc + assetObject.current.valueBaseCurrency, 0);
                // handle situation where there are only null values for the entire assetClass (if there is one null value in the assetClass, all other will also be null, otherwise there would be a 0)
                if (row.value === null) {
                    if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: target allocation value for category", category, "and assetClass", assetClass, "and currency", row.currency, "is null. Assumming no allocation available for this assetClass and returning factor of 0.");
                    return {
                        category: row.category,
                        assetClass: row.assetClass,
                        currency: row.currency,
                        dimensionRebalancingAssetDeltaFactor: 0
                    };
                }
                const sumTargetAmountByAssetClassAndCurrency = assetClassSum * (row.value / 100); // take the current total and determine what part should be allocated to this currency
                // FIXME: continue setting  stocks > EUR to 60% and debug the resulting logic (at the moment, current sum and target sum are not as expected)
                if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: current sum for category", category, "and assetClass", assetClass, "and currency", row.currency, "is", sumCurrentAmountByAssetClassAndCurrency);
                if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: target sum for category", category, "and assetClass", assetClass, "and currency", row.currency, "is", sumTargetAmountByAssetClassAndCurrency);
                return {
                    category: row.category,
                    assetClass: row.assetClass,
                    currency: row.currency,
                    dimensionRebalancingAssetDeltaFactor: (sumTargetAmountByAssetClassAndCurrency - sumCurrentAmountByAssetClassAndCurrency) / sumCurrentAmountByAssetClassAndCurrency
                };
            });
            rebalancingFactors.push(...targetAllocationWithFactor);
        });
    });
    console.log("getDimensionDeltaFactors: returnArray", rebalancingFactors);
    // TODO prevent users from entering null into the form
    // TODO remember 'null'
    return currentAllocationFilteredFixed.map((row)=>{
        const rowWithFactor = rebalancingFactors.find((x)=>x.category === row.category && String(x.assetClass) === String(row.assetClass) && x.currency === (row.assetCurrency || row.accountCurrency));
        if ($fed8d5f05838fc70$var$debugLevel > 2) console.info("getDimensionDeltaFactors: rowWithFactor", rowWithFactor, "matchingFactor:", rowWithFactor === null || rowWithFactor === void 0 ? void 0 : rowWithFactor.dimensionRebalancingAssetDeltaFactor);
        return (0, $2qxEV._)((0, $9tqwB._)({}, row), {
            assetClass: row.assetClass === "null" ? null : row.assetClass,
            dimensionRebalancingAssetDeltaFactor: (rowWithFactor === null || rowWithFactor === void 0 ? void 0 : rowWithFactor.dimensionRebalancingAssetDeltaFactor) || 0
        });
    });
}


const $e4c3e35ef609140c$export$c1af727b0dc3469a = 0;
function* $e4c3e35ef609140c$export$2e2bcd8739ae039(currentAllocation, targetAllocation) {
    if ($e4c3e35ef609140c$export$c1af727b0dc3469a > 2) console.info("calculateRebalancing: starting with currentAllocation", currentAllocation, "and targetAllocation", targetAllocation);
    const portfolioAllocation = (0, $5fb3c4274d9dfed0$export$2e2bcd8739ae039)(currentAllocation, targetAllocation);
    const dimensionAllocation = (0, $3aff36210e2443a5$export$2e2bcd8739ae039)(targetAllocation, currentAllocation);
    const completeTargetAllocation = [
        ...portfolioAllocation,
        ...dimensionAllocation
    ];
    yield completeTargetAllocation;
    if ($e4c3e35ef609140c$export$c1af727b0dc3469a > 2) console.info("calculateRebalancing: adjustment of target allocation completed for portfolio and dimension", completeTargetAllocation);
    const currentAllocationWithPortfolioFactor = (0, $07ee6236640c3c23$export$2e2bcd8739ae039)(currentAllocation, completeTargetAllocation);
    console.log("calculateRebalancing:", "currentAllocationWithPortfolioFactor", currentAllocationWithPortfolioFactor);
    const currentAllocationWithBothFactors = (0, $fed8d5f05838fc70$export$2e2bcd8739ae039)(currentAllocationWithPortfolioFactor, completeTargetAllocation);
    console.log("calculateRebalancing:", "currentAllocationWithBothFactors", currentAllocationWithBothFactors);
    yield currentAllocationWithBothFactors.map((row)=>(0, $2qxEV._)((0, $9tqwB._)({}, row), {
            // was: row.amount (deprecated)
            targetAmount: row.current.valueBaseCurrency * (1 + row.categoryRebalancingAssetDeltaFactor) * (1 + row.dimensionRebalancingAssetDeltaFactor)
        }));
}


/* eslint-disable react/prop-types */ /* eslint-disable object-curly-newline */ 

var $7fPBF = parcelRequire("7fPBF");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $116c65b94cd659f3$var$LockOpenIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M14.5 1A4.5 4.5 0 0 0 10 5.5V9H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1.5V5.5a3 3 0 1 1 6 0v2.75a.75.75 0 0 0 1.5 0V5.5A4.5 4.5 0 0 0 14.5 1Z",
        clipRule: "evenodd"
    }));
}
const $116c65b94cd659f3$var$ForwardRef = $7fPBF.forwardRef($116c65b94cd659f3$var$LockOpenIcon);
var $116c65b94cd659f3$export$2e2bcd8739ae039 = $116c65b94cd659f3$var$ForwardRef;


function $3ffd7ae58eedbd73$export$2e2bcd8739ae039(targetAllocation, setTargetAllocation, recalculatePressed) {
    return function InputField({ value: value, rowData: rowData, id: id }) {
        //
        // helper function -- get the correct entry from targetAllocation based on tableLevel field
        function getMatchingEntry(inputState) {
            // console.log('getMatchingEntry: finding matchingEntry for', rowData, id, 'in', inputState);
            if (inputState.length === 0) return null;
            let matchingEntry;
            const { tableLevel: tableLevel } = rowData;
            const currency = id.replace("Percent", "");
            if (tableLevel === "category") {
                // relevant columns in this row type: categoryPercent, EURPercent, USDPercent, etc.
                if (id === "categoryPercent") matchingEntry = inputState.find((entry)=>entry.category === rowData.category && !entry.assetClass && !entry.currency);
                else matchingEntry = inputState.find((entry)=>entry.category === rowData.category && !entry.assetClass && entry.currency === currency);
            }
            if (tableLevel === "assetClass") matchingEntry = inputState.find((entry)=>entry.category === rowData.category && entry.assetClass === rowData.assetClass && entry.currency === currency);
            // if (!matchingEntry) console.log('getMatchingEntry: matchingEntry not found', matchingEntry, 'inputState', inputState, 'rowData', rowData, 'id', id);
            return matchingEntry;
        }
        const [disabled, setDisabled] = (0, $7fPBF.useState)(false);
        const [displayDialog, setDisplayDialog] = (0, $7fPBF.useState)(false);
        const [inputValueMobileView, setInputValueMobileView] = (0, $7fPBF.useState)(null); // used in the mobile dialog below; not initialised and only used to pass values from the input field to the button
        const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("rebalancing");
        const matchingEntry = getMatchingEntry(targetAllocation);
        // console.log('matchingEntry', matchingEntry, matchingEntry?.value, rowData[id] * 100);
        const inputValue = ((matchingEntry === null || matchingEntry === void 0 ? void 0 : matchingEntry.value) || rowData[id] * 100).toFixed(2);
        const locked = (matchingEntry === null || matchingEntry === void 0 ? void 0 : matchingEntry.locked) || false;
        // when user presses Recalculate, move the values from the form to targetAllocation
        (0, $7fPBF.useEffect)(()=>{
            // update NULL entries in targetAllocation with the current value
            if (recalculatePressed && (matchingEntry === null || matchingEntry === void 0 ? void 0 : matchingEntry.value) === null) setTargetAllocation((prev)=>{
                const newTargetAllocation = [
                    ...prev
                ];
                const matchingEntryLocal = getMatchingEntry(newTargetAllocation);
                matchingEntryLocal.value = Number(rowData[id] * 100);
                return newTargetAllocation;
            });
        }, [
            recalculatePressed
        ]);
        (0, $7fPBF.useEffect)(()=>{
            function handleOutputMode(event) {
                if (event.detail === true) setDisabled(true);
                if (event.detail === false) setDisabled(false);
            }
            document.addEventListener("rebalancingOutputMode", handleOutputMode);
            return ()=>{
                document.removeEventListener("rebalancingOutputMode", handleOutputMode);
            };
        }, []);
        function handleMobileDialog() {
            setDisplayDialog(true);
        }
        function handleSetAllocation(e, useLock = false) {
            setTargetAllocation((prev)=>{
                const newTargetAllocation = [
                    ...prev
                ];
                const matchingEntryLocal = getMatchingEntry(newTargetAllocation);
                matchingEntryLocal.value = Number(e.target.value);
                if (useLock) matchingEntryLocal.locked = !locked;
                return newTargetAllocation;
            });
        }
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative flex justify-end space-x-1 items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            // eslint-disable-next-line max-len
                            className: "sm:hidden mb-1 flex-1 border border-gray-300 bg-gray-50 shadow-sm py-1.5 px-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 w-full min-w-0 rounded-md sm:text-sm text-right",
                            type: "button",
                            disabled: disabled,
                            onClick: handleMobileDialog,
                            children: [
                                inputValue,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "ml-1 text-sm font-medium text-gray-700",
                                    children: "%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            className: "hidden sm:block flex-1 border border-gray-300 py-0.5 px-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 w-full min-w-0 rounded-md sm:text-sm text-right",
                            type: "",
                            disabled: disabled,
                            defaultValue: inputValue,
                            onBlur: handleSetAllocation
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "hidden sm:inline ml-2 text-sm font-medium text-gray-700",
                            children: "%"
                        }),
                        !disabled && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "absolute left-1 hidden sm:inline-block",
                            disabled: disabled,
                            // onClick={() => {
                            //   setTargetAllocation((prev) => {
                            //     const newTargetAllocation = [...prev];
                            //     const matchingEntryLocal = getMatchingEntry(newTargetAllocation);
                            //     matchingEntryLocal.value = Number(inputValue);
                            //     matchingEntryLocal.locked = !locked;
                            //     return newTargetAllocation;
                            //   });
                            // }}
                            onClick: (e)=>handleSetAllocation(e, true),
                            children: locked ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81d773ef7a32fb70$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-400"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $116c65b94cd659f3$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-300"
                            })
                        })
                    ]
                }),
                displayDialog && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "absolute flex space-x-4 justify-between items-center z-10 top-0 left-0 bg-white w-full h-full opacity-100",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "ml-4 py-2 px-4 border border-gray-300 cursor-pointer bg-gray-50 shadow-sm rounded-md",
                            disabled: disabled,
                            onClick: (e)=>handleSetAllocation(e, true),
                            children: locked ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81d773ef7a32fb70$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-400"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $116c65b94cd659f3$export$2e2bcd8739ae039), {
                                className: "h-4 w-4 text-gray-300"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    className: "border border-gray-300 py-2 px-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 w-full min-w-0 rounded-md sm:text-sm text-right",
                                    type: "",
                                    disabled: disabled,
                                    defaultValue: inputValue,
                                    onChange: (e)=>{
                                        setInputValueMobileView(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "ml-2 text-sm font-medium text-gray-700",
                                    children: "%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "py-2 px-2 border border-gray-300 cursor-pointer bg-gray-50 shadow-sm rounded-md",
                            disabled: disabled,
                            onClick: (e)=>{
                                setTargetAllocation((prev)=>{
                                    const newTargetAllocation = [
                                        ...prev
                                    ];
                                    const matchingEntryLocal = getMatchingEntry(newTargetAllocation);
                                    matchingEntryLocal.value = Number(inputValueMobileView);
                                    return newTargetAllocation;
                                });
                                setDisplayDialog(false);
                            },
                            children: t("Save")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "py-2 px-2 border border-gray-300 cursor-pointer bg-gray-50 shadow-sm rounded-md",
                            disabled: disabled,
                            onClick: ()=>{
                                setDisplayDialog(false);
                            },
                            children: t("Cancel")
                        })
                    ]
                })
            ]
        });
    };
}


/* eslint-disable react/forbid-prop-types */ /* eslint-disable object-curly-newline */ 
var $bLhVg = parcelRequire("bLhVg");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");


const $35c4a9c065c3ad3e$var$tableLayout = [
    [
        {
            id: "accountName",
            type: "string",
            textAlign: "text-left"
        },
        {
            id: "category",
            type: "string",
            textAlign: "text-left",
            classNamesBody: "font-normal text-xs"
        }
    ],
    [
        {
            id: "transactionType",
            type: "string",
            textAlign: "text-left"
        }
    ],
    [
        {
            id: "displayName",
            type: "string",
            usesHeader: "assetId"
        },
        {
            id: "displaySymbol",
            type: "string",
            hideHeaderLabel: true,
            classNamesBody: "font-normal text-xs"
        }
    ],
    [
        {
            id: "deltaAmount",
            type: "currency0Decimals",
            usesHeader: "amount"
        }
    ]
];
function $35c4a9c065c3ad3e$export$2e2bcd8739ae039({ rawRebalancingResults: rawRebalancingResults, fxRates: fxRates }) {
    const [tableState, setTableState] = (0, $7fPBF.useState)({
        sortBy: "date",
        sortDirectionAsc: true,
        colWidths: [
            null,
            null,
            null,
            null
        ],
        tableHeight: 300
    });
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const presentableResults = rawRebalancingResults.filter(({ amount: amount, targetAmount: targetAmount })=>amount !== targetAmount && Math.abs(targetAmount - amount) > 100).map((_param)=>{
        var { category: category, displayName: displayName, displaySymbol: displaySymbol, amount: amount, accountName: accountName, targetAmount: targetAmount, currency: currency, amountAssetCurrency: amountAssetCurrency } = _param, rest = (0, $bLhVg._)(_param, [
            "category",
            "displayName",
            "displaySymbol",
            "amount",
            "accountName",
            "targetAmount",
            "currency",
            "amountAssetCurrency"
        ]);
        return {
            category: category,
            displayName: displayName,
            displaySymbol: displaySymbol,
            deltaAmount: targetAmount - amount,
            deltaAmountAssetCurrency: (targetAmount - amount) / fxRates.find(({ currency: fxRateCurrency })=>fxRateCurrency === currency).rate,
            accountName: accountName,
            transactionType: targetAmount - amount > 0 ? "buy" : "sell",
            currency: currency
        };
    });
    // TO DO -- PER ACCOUNT
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-col items-center",
        id: "rebalancing-output-mode",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "font-bold text-gray-900 text-lg xs:text-xl",
                "aria-label": "current allocation",
                children: t("Required transactions")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec5b0fbdb8c7bace$export$2e2bcd8739ae039), {
                    data: presentableResults,
                    tableLayout: $35c4a9c065c3ad3e$var$tableLayout,
                    tableState: tableState,
                    setTableState: setTableState,
                    groupByColumn: "category"
                })
            })
        ]
    });
}
$35c4a9c065c3ad3e$export$2e2bcd8739ae039.propTypes = {
    rawRebalancingResults: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    fxRates: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired
};



function $f98434f7adc8890b$var$convertDataToTableFormat(dimensionField, data, dimensionItemsArray, translateDashboard) {
    return data// remove rows with zero amount or erroneous
    .map((row)=>(0, $2qxEV._)((0, $9tqwB._)({}, row), {
            [row[dimensionField]]: row.current.valueBaseCurrency
        })) // e.g. { ..., EUR: 1234.24 } for assetCurrency
    // add category summary rows
    // data is pre-sorted by category, so if we encounter a new category, add a new row with just the category ("header row"); CAVEAT: it is added to assetId column for now
    .reduce((acc, curr, _, myself)=>{
        // at the very beginning add a summary row for the total (to show distribution by currency or other dimension field)
        if (acc.length === 0) {
            const totalSum = myself.reduce((sum, row)=>sum + row.current.valueBaseCurrency, 0);
            const totalRow = {
                category: null,
                assetId: null,
                categoryLabel: "TOTAL",
                categoryTotal: totalSum,
                categoryPercent: 1,
                isTotalRow: true,
                tableLevel: "total"
            };
            dimensionItemsArray.forEach((dimensionItem)=>{
                totalRow[dimensionItem] = myself.filter((row)=>row[dimensionField] === dimensionItem).reduce((sum, row)=>sum + row.current.valueBaseCurrency, 0);
                totalRow[`${dimensionItem}Percent`] = totalRow[dimensionItem] / totalSum;
            });
            acc.push(totalRow);
        }
        // add category row (if not there yet)
        if (acc.filter((x)=>x.category === curr.category && x.isSummaryRow === true).length === 0) {
            var _acc_find;
            const totalSum = (_acc_find = acc.find((row)=>row.categoryLabel === "TOTAL")) === null || _acc_find === void 0 ? void 0 : _acc_find.categoryTotal;
            const categorySum = myself.filter((row)=>row.category === curr.category).reduce((sum, row)=>sum + row.current.valueBaseCurrency, 0);
            const categoryRow = {
                category: curr.category,
                categoryLabel: translateDashboard(`categories.${curr.category}`),
                isSummaryRow: true,
                categoryTotal: categorySum,
                categoryPercent: categorySum / totalSum,
                tableLevel: "category"
            };
            dimensionItemsArray.forEach((dimensionItem)=>{
                categoryRow[dimensionItem] = myself.filter((row)=>row.category === curr.category && row[dimensionField] === dimensionItem).reduce((sum, row)=>sum + row.current.valueBaseCurrency, 0);
                categoryRow[`${dimensionItem}Percent`] = categoryRow[dimensionItem] / categorySum;
            });
            categoryRow.rowTotal = myself.filter((row)=>row.category === curr.category).reduce((sum, row)=>sum + row.current.valueBaseCurrency, 0);
            acc.push(categoryRow);
        }
        // add asset row
        acc.push((0, $2qxEV._)((0, $9tqwB._)({}, curr), {
            displayLabel: curr.category === "stocks" ? `${curr.displayName} (${curr.displaySymbol})` : curr.displayName,
            categoryTotal: curr.current.valueBaseCurrency,
            isSummaryRow: false,
            tableLevel: "bottom"
        }));
        return acc;
    }, []); // initial reduce value
}
function $f98434f7adc8890b$export$2e2bcd8739ae039({ closeCallback: closeCallback }) {
    const [targetAllocation, setTargetAllocation] = (0, $7fPBF.useState)([]); // #01 target allocation for rebalancing ({ })
    // when this is set to true, InputField will update all NULL targetAllocations to the actual form value; it is reset once targetAllocation gets recalculated (in a useEffect)
    const [recalculatePressed, setRecalculatePressed] = (0, $7fPBF.useState)(false); // #02
    const [outputMode, setOutputMode] = (0, $7fPBF.useState)(false); // #03 shows / hides the Output panel
    // when state changes, update ref
    (0, $7fPBF.useEffect)(()=>{
        const event = new CustomEvent("rebalancingOutputMode", {
            detail: outputMode
        });
        document.dispatchEvent(event);
    }, [
        outputMode
    ]);
    const initialTableLayoutCurrent = [
        [
            {
                id: "categoryPercent",
                highlight: false,
                type: "percentage",
                textAlign: "text-right",
                hideHeaderLabel: true
            },
            {
                id: "categoryTotal",
                highlight: false,
                type: "currency0Decimals",
                textAlign: "text-right",
                usesHeader: "total",
                classNamesBody: "font-normal text-xs"
            }
        ],
        [
            {
                ifSummaryRowDisplay: true,
                id: "categoryLabel",
                highlight: true,
                type: "string",
                textAlign: "text-left",
                hideHeaderLabel: true
            },
            {
                ifSummaryRowDisplay: false,
                id: "displayLabel",
                highlight: true,
                type: "string",
                textAlign: "text-left",
                usesHeader: "category",
                classNamesBody: "text-xs"
            }
        ]
    ];
    const initialTableLayoutTarget = [
        [
            {
                id: "categoryPercent",
                highlight: false,
                type: "percentage",
                textAlign: "text-right",
                hideHeaderLabel: true,
                // display InputField when isSummaryRow is present; display it _instead_ of the categoryPercent column as long as isSummaryRow is present
                // passSetTarget... is a wrapper that passes setTargetAllocation to component before rendering it (it is not possible to declare InputField in Rebalancing scope)
                displayElement: {
                    displayInstead: true,
                    displayInsteadWhenField: "isSummaryRow",
                    element: (0, $3ffd7ae58eedbd73$export$2e2bcd8739ae039)(targetAllocation, setTargetAllocation, recalculatePressed),
                    field: "isSummaryRow"
                }
            },
            {
                id: "categoryTotal",
                highlight: false,
                type: "currency0Decimals",
                textAlign: "text-right",
                usesHeader: "total",
                classNamesBody: "font-normal text-xs"
            }
        ],
        [
            {
                ifSummaryRowDisplay: true,
                id: "categoryLabel",
                highlight: true,
                type: "string",
                textAlign: "text-left",
                hideHeaderLabel: true
            },
            {
                ifSummaryRowDisplay: false,
                id: "displayLabel",
                highlight: true,
                type: "string",
                textAlign: "text-left",
                usesHeader: "category",
                classNamesBody: "text-xs"
            }
        ]
    ];
    const [tableState, setTableState] = (0, $7fPBF.useState)({
        sortBy: "date",
        sortDirectionAsc: true,
        colWidths: [
            null,
            null,
            null,
            null
        ],
        tableHeight: 300
    }); // #05
    const [dimensionItems, setDimensionItems] = (0, $7fPBF.useState)([]); // #06 holds COLUMNS in Target, i.e. all distinct members of the dimension being displayed (e.g. all currencies or all markets)
    const [tableLayoutCurrent, setTableLayoutCurrent] = (0, $7fPBF.useState)(initialTableLayoutCurrent); // #07
    const [tableLayoutTarget, setTableLayoutTarget] = (0, $7fPBF.useState)(initialTableLayoutTarget); // #08
    const [currentData, setCurrentData] = (0, $7fPBF.useState)([]); // #09 data for the current view (should be changed when currencies are recalculated)
    const [rawRebalancingResults, setRawRebalancingResults] = (0, $7fPBF.useState)([]); // #10 raw results from calculateRebalancing (before converting to table format)
    const [targetData, setTargetData] = (0, $7fPBF.useState)([]); // #11 data displayed by the Target Table component
    // ↓ which field to use for dimension (e.g. currency, market, etc.); this field must be provided in currentData (and targetData, but that should happen automatically)
    // const [dimensionField, setDimensionField] = useState('transactionCurrency'); // this can become state when needed (transactionCurrency is deprecated)
    const dimensionField = "assetCurrency"; // this can become state when needed
    const [fxRates, setFxRates] = (0, $7fPBF.useState)([]); // #12
    const { t: tRebalancing } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("rebalancing");
    const { t: tDashboard } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    // get positions from store
    const selectAssetPositions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$7cd09fd23199c464)); // if filter is on this, then there is a maxDepthExceeded problem
    const assetPositionsFiltered = selectAssetPositions.filter((row)=>row.current.quantity && row.current.quantity > 0);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    // when selector data change, first compute currencies (or other table columns) and "current" table layout for "current" view
    // also trigger recalculation when user changes dimensionField through the dropdown
    (0, $7fPBF.useEffect)(()=>{
        // select all distinct table columns in dataView
        setDimensionItems([
            ...new Set(assetPositionsFiltered.map((row)=>row[dimensionField]))
        ]);
        setTableLayoutCurrent([
            ...initialTableLayoutCurrent,
            ...(dimensionItems || []).map((dimensionItem)=>[
                    {
                        id: `${dimensionItem}Percent`,
                        type: "percentage",
                        usesHeader: dimensionItem,
                        textAlign: "text-right"
                    },
                    {
                        id: dimensionItem,
                        type: "currency0Decimals",
                        hideHeaderLabel: true,
                        textAlign: "text-right",
                        classNamesBody: "font-normal text-xs"
                    }
                ])
        ]);
    }, [
        selectAssetPositions,
        dimensionField
    ]);
    // once you are done computing currencies, make sure current data are updated
    // (it could have been done together with the useEffect above, but sometimes the currencies are not yet computed there)
    (0, $7fPBF.useEffect)(()=>{
        setCurrentData($f98434f7adc8890b$var$convertDataToTableFormat(dimensionField, assetPositionsFiltered, dimensionItems, tDashboard));
    }, [
        selectAssetPositions,
        dimensionItems
    ]);
    // get FX currencies for all currencies in assetPositionsFiltered (they will be used by OutputPane later on)
    (0, $7fPBF.useEffect)(()=>{
        async function fetchFxRates(currList) {
            const promises = currList.map((currency)=>(0, $d332a6fd4016af7b$export$dca80e37bfad9c5a)(1, currency, baseCurrency, new Date().valueOf()));
            const results = (await Promise.all(promises)).flat();
            setFxRates(results.map((row, idx)=>({
                    currency: currList[idx],
                    rate: row
                })));
        }
        const currencies = [
            ...new Set(assetPositionsFiltered.map((row)=>row.assetCurrency || row.accountCurrency))
        ];
        fetchFxRates(currencies);
    }, [
        selectAssetPositions
    ]);
    // dynamically compute table layout for target view (once targetData is calculated)
    (0, $7fPBF.useEffect)(()=>{
        setTableLayoutTarget([
            ...initialTableLayoutTarget,
            ...(dimensionItems || []).map((dimensionItem)=>[
                    {
                        id: `${dimensionItem}Percent`,
                        type: "percentage",
                        usesHeader: dimensionItem,
                        textAlign: "text-right",
                        displayElement: {
                            displayInstead: true,
                            displayInsteadWhenField: "isSummaryRow",
                            element: (0, $3ffd7ae58eedbd73$export$2e2bcd8739ae039)(targetAllocation, setTargetAllocation, recalculatePressed),
                            field: "isSummaryRow"
                        }
                    },
                    {
                        id: dimensionItem,
                        type: "currency0Decimals",
                        hideHeaderLabel: true,
                        textAlign: "text-right",
                        classNamesBody: "font-normal text-xs"
                    }
                ])
        ]);
        // set the recalculated flag to false, so that InputField will not update targetAllocation with the form values
        setRecalculatePressed(false);
    }, [
        targetData
    ]);
    // used by Recalculate button and whenever currentData change
    function handleRecalculate() {
        // calculateRebalancing uses 'yield' command to return intermediate results (targetAllocation) when called via f.next(); it returns a { value: <something>, done: true } object
        // console.info('input to calculateRebalancing', assetPositionsFiltered, targetAllocation);
        const f = (0, $e4c3e35ef609140c$export$2e2bcd8739ae039)(assetPositionsFiltered, targetAllocation);
        const newTargetAllocation = f.next().value; // this .next() gets the first value from calculateRebalancing (targetAllocation)
        console.info("Rebalancing: returned new target allocation", newTargetAllocation);
        setTargetAllocation(newTargetAllocation);
        const results = f.next().value; // this .next() gets the final value from calculateRebalancing (updated positions)
        console.info("Rebalancing: returned new target data (updated positions)", results);
        setRawRebalancingResults(results);
        const convertedResults = $f98434f7adc8890b$var$convertDataToTableFormat(dimensionField, results.map((row)=>(0, $2qxEV._)((0, $9tqwB._)({}, row), {
                current: {
                    valueBaseCurrency: row.targetAmount
                }
            })), dimensionItems, t);
        console.info("Rebalancing: new target data converted to table format", convertedResults);
        setTargetData(convertedResults);
    }
    // recalculate button additionally updates targetAllocation with form values (which are displayed to the user)
    // we cannot do it earlier because the categories may not get loaded at the same time (and after realEstate loads first, it would be set to 100%)
    function handleRecalculateButton() {
        setRecalculatePressed(true); // triggers useEffect in InputField, which transfers all field values to targetAllocation
        handleRecalculate();
    }
    // handles target calculation
    // if selectAssetPositions (once currentData is calculated though) or user presses Recalculate button, recalculate the targetData
    (0, $7fPBF.useEffect)(()=>{
        handleRecalculate();
    }, [
        currentData
    ]);
    function handleOutputMode() {
        setOutputMode(!outputMode);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25250cd4374f51ac$export$2e2bcd8739ae039), {
        id: "rebalancing-parent",
        closeCallback: closeCallback,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "px-4 md:px-0 pt-8 pb-16 space-y-4",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("header", {
                    "aria-label": "rebalancing header",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: "font-bold text-gray-900 text-xl xs:text-2xl sm:text-3xl",
                        children: "Rebalancing"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("menu", {
                    className: "pt-2 flex justify-start items-center space-x-6",
                    "aria-label": "rebalancing menu",
                    children: [
                        outputMode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            text: tRebalancing("Back to calculation"),
                            withAccent: false,
                            size: "xl",
                            onClick: handleOutputMode
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                            text: tRebalancing("Show required transactions"),
                            withAccent: true,
                            size: "xl",
                            onClick: handleOutputMode
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex flex-col sm:flex-row items-center",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "-mb-1 pr-2 block text-sm font-medium text-gray-700",
                                    children: "Rebalance by"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                    list: [
                                        tRebalancing("Currency")
                                    ],
                                    value: tRebalancing("Currency"),
                                    optional: false
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                    className: "pt-8 w-full overflow-y-visible scrollbar-thin",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "w-full grid grid-cols-1 xl:grid-cols-2 gap-8",
                        id: "rebalancing-grid-container",
                        children: [
                            !outputMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col items-center",
                                id: "rebalancing-current-parent",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        className: "font-bold text-gray-900 text-lg xs:text-xl",
                                        "aria-label": "current allocation",
                                        children: "Current"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec5b0fbdb8c7bace$export$2e2bcd8739ae039), {
                                        data: currentData,
                                        tableLayout: tableLayoutCurrent,
                                        tableState: tableState,
                                        setTableState: setTableState,
                                        groupByColumn: "category"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "flex flex-col items-center relative",
                                id: "rebalancing-target-parent",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "w-full grid grid-cols-3",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                className: "text-center col-start-2 font-bold text-gray-900 text-lg xs:text-xl",
                                                "aria-label": "target allocation",
                                                children: "Target"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "justify-self-end",
                                                children: !outputMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                    text: tRebalancing("Recalculate"),
                                                    withAccent: false,
                                                    size: "lg",
                                                    onClick: handleRecalculateButton
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ec5b0fbdb8c7bace$export$2e2bcd8739ae039), {
                                        data: targetData,
                                        tableLayout: tableLayoutTarget,
                                        tableState: tableState,
                                        setTableState: setTableState,
                                        groupByColumn: "category"
                                    })
                                ]
                            }),
                            outputMode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $35c4a9c065c3ad3e$export$2e2bcd8739ae039), {
                                rawRebalancingResults: rawRebalancingResults,
                                fxRates: fxRates
                            })
                        ]
                    })
                })
            ]
        })
    });
}
$f98434f7adc8890b$export$2e2bcd8739ae039.propTypes = {
    closeCallback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $08a7c03b8170678e$var$ChevronLeftIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
        clipRule: "evenodd"
    }));
}
const $08a7c03b8170678e$var$ForwardRef = $7fPBF.forwardRef($08a7c03b8170678e$var$ChevronLeftIcon);
var $08a7c03b8170678e$export$2e2bcd8739ae039 = $08a7c03b8170678e$var$ForwardRef;


function $d6bcdb96663edbf1$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $d6bcdb96663edbf1$var$addMonths(date, months) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() !== d) date.setDate(0);
    return date;
}
function $d6bcdb96663edbf1$var$addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
}
function $d6bcdb96663edbf1$var$generateDays(month, year) {
    // reminder: months are 0 - 11
    const firstDay = new Date(Date.UTC(year, month, 1));
    const lastDay = $d6bcdb96663edbf1$var$addDays($d6bcdb96663edbf1$var$addMonths(new Date(Date.UTC(year, month, 1)), 1), -1);
    firstDay.setUTCHours(0);
    lastDay.setUTCHours(0);
    // reminder: Sunday is 0
    const daysToAddBefore = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
    const daysToAddAfter = lastDay.getDay() === 0 ? 0 : 7 - lastDay.getDay();
    $d6bcdb96663edbf1$var$addDays(firstDay, -1 * daysToAddBefore);
    $d6bcdb96663edbf1$var$addDays(lastDay, daysToAddAfter);
    const days = [];
    for(let j = firstDay.valueOf(); j <= lastDay.valueOf(); j += 86400000)days.push({
        date: new Date(j).toISOString().split("T")[0],
        isCurrentMonth: new Date(j).getMonth() === month,
        isToday: new Date(j).toISOString().split("T")[0] === new Date().toISOString().split("T")[0]
    });
    return days;
}
function $d6bcdb96663edbf1$export$2e2bcd8739ae039({ calendarState: calendarState, setCalendarState: setCalendarState }) {
    const [currentMonth, setCurrentMonth] = (0, $7fPBF.useState)(new Date());
    const [days, setDays] = (0, $7fPBF.useState)(undefined);
    (0, $7fPBF.useEffect)(()=>{
        setDays($d6bcdb96663edbf1$var$generateDays(new Date(currentMonth).getMonth(), new Date(currentMonth).getFullYear()));
    }, [
        currentMonth
    ]);
    function handleSelect(dayIdx) {
        // remove the selected status from all days "wholesale" and enable it on the selected day
        // update the parent state
        // eslint-disable-next-line no-restricted-syntax
        const newDays = days.map((item)=>(0, $2qxEV._)((0, $9tqwB._)({}, item), {
                isSelected: false
            }));
        newDays[dayIdx].isSelected = true;
        setDays(newDays);
        setCalendarState((0, $2qxEV._)((0, $9tqwB._)({}, calendarState), {
            selectedDate: newDays[dayIdx].date
        }));
    }
    function handleSelectButton(e) {
        // callback is the dispatch baseline change function from Dashboard
        calendarState.callback(new Date(calendarState.selectedDate));
        setCalendarState((0, $2qxEV._)((0, $9tqwB._)({}, calendarState), {
            visible: false
        }));
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "absolute w-full h-full z-[60] top-0 left-0 p-0 xs:p-16 bg-gray-200 bg-opacity-90 flex justify-center items-start",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "bg-white overflow-hidden shadow p-8  sm:rounded-lg",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                className: "text-xl font-semibold text-gray-900",
                                children: "Select a day"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: (e)=>setCalendarState({
                                    selectedDate: null,
                                    visible: false,
                                    callback: null
                                }),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-gray-400"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-10 text-center lg:mt-9",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex flex-wrap justify-center sm:flex-nowrap sm:justify-around",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex items-center text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            className: "border rounded-sm flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
                                            onClick: (e)=>setCurrentMonth($d6bcdb96663edbf1$var$addMonths(new Date(currentMonth), -1)),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Previous month"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08a7c03b8170678e$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-auto font-semibold text-lg px-4",
                                            children: currentMonth.toLocaleString("default", {
                                                month: "long"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            className: "border rounded-sm flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
                                            onClick: (e)=>setCurrentMonth($d6bcdb96663edbf1$var$addMonths(new Date(currentMonth), 1)),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Next month"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb47cb945e5c730$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex items-center text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            className: "border rounded-sm flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
                                            onClick: (e)=>setCurrentMonth($d6bcdb96663edbf1$var$addMonths(new Date(currentMonth), -12)),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Previous year"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $08a7c03b8170678e$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "flex-auto font-semibold text-lg px-4",
                                            children: currentMonth.toISOString().split("-")[0]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            className: "border rounded-sm flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500",
                                            onClick: (e)=>setCurrentMonth($d6bcdb96663edbf1$var$addMonths(new Date(currentMonth), 12)),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Next year"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bb47cb945e5c730$export$2e2bcd8739ae039), {
                                                    className: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "mt-6 grid grid-cols-7 text-xs leading-6 text-gray-500",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "M"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "T"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "W"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "T"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "F"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "S"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: "S"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200",
                            children: days && days.map((day, dayIdx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>handleSelect(dayIdx),
                                    className: $d6bcdb96663edbf1$var$classNames("py-1.5 hover:bg-gray-100 focus:z-10", day.isCurrentMonth ? "bg-white" : "bg-gray-50", (day.isSelected || day.isToday) && "font-semibold", day.isSelected && "text-white", !day.isSelected && day.isCurrentMonth && !day.isToday && "text-gray-900", !day.isSelected && !day.isCurrentMonth && !day.isToday && "text-gray-400", day.isToday && !day.isSelected && "text-brandBlue-500", dayIdx === 0 && "rounded-tl-lg", dayIdx === 6 && "rounded-tr-lg", dayIdx === days.length - 7 && "rounded-bl-lg", dayIdx === days.length - 1 && "rounded-br-lg"),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("time", {
                                        dateTime: day.date,
                                        className: $d6bcdb96663edbf1$var$classNames("mx-auto flex h-7 w-7 items-center justify-center rounded-full", day.isSelected && day.isToday && "bg-brandBlue-500", day.isSelected && !day.isToday && "bg-gray-900"),
                                        children: day.date.split("-").pop().replace(/^0/, "")
                                    })
                                }, day.dayIdx))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "focus:outline-none mt-8 w-full rounded-md border border-transparent bg-brandBlue-500 py-2 px-4 text-base text-white shadow hover:bg-brandBlue-600 focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                            onClick: handleSelectButton,
                            children: "Select"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: (e)=>setCalendarState({
                                    selectedDate: null,
                                    visible: false,
                                    callback: null
                                }),
                            className: "focus:outline-none mt-4 w-full rounded-md border border-gray-400 bg-white py-2 px-4 text-base text-gray-400 shadow hover:bg-gray-100 focus:ring-2 focus:ring-brandBlue-400 focus:ring-offset-2",
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
}
$d6bcdb96663edbf1$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    calendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$d6bcdb96663edbf1$export$2e2bcd8739ae039.defaultProps = {
    calendarState: {},
    setCalendarState: {}
};


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $ab6676e849ba8635$export$2e2bcd8739ae039({ reportProps: reportProps }) {
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function handleClose(e) {
        e.preventDefault();
        dispatch({
            type: "CLEAR_FULLSCREEN_REPORT"
        });
    }
    const finalProps = (0, $9tqwB._)({}, reportProps);
    console.info("finalProps", finalProps);
    console.info("window", window.innerHeight, window.innerWidth);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25250cd4374f51ac$export$2e2bcd8739ae039), {
        closeCallback: handleClose,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "w-full h-[95vh] pt-8 grid grid-cols-1 justify-items-center",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $9tqwB._)({}, finalProps))
        })
    });
}
$ab6676e849ba8635$export$2e2bcd8739ae039.propTypes = {
    reportProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};


/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






function $28bd968d00880be4$export$e24bdb15dc3a0d85({ account: account }) {
    $28bd968d00880be4$export$e24bdb15dc3a0d85.propTypes = {
        account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
    };
    $28bd968d00880be4$export$e24bdb15dc3a0d85.defaultProps = {
        account: null
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "columns"
    });
    // if (!account) return true;
    const transactionsPerAccount = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $a368196802fe263c$export$3c400324181e2c4d)(state).filter((x)=>x.accountId === (account === null || account === void 0 ? void 0 : account.id)));
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const transactions = (transactionsPerAccount || []).sort((a, b)=>b.date - a.date).slice(0, 6).map((item)=>({
            date: item.date,
            accountCurrencyAmount: item.quantity.toLocaleString("de", {
                style: "currency",
                currency: (account === null || account === void 0 ? void 0 : account.currency) || "EUR",
                maximumFractionDigits: 2
            }),
            otherParty: item.otherParty,
            currency: item.currency
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        id: "transaction-preview",
        className: "py-4 align-middle hidden md:block",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                className: "divide-y divide-gray-300 table-fixed w-full max-w-full",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                        className: "text-xs font-semibold text-gray-900 uppercase bg-gray-50",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap w-1/4 py-3.5 pl-4 pr-3 text-left sm:pl-6",
                                    children: t("date")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap w-1/2 px-2 py-3.5 text-left",
                                    children: t("otherParty")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap w-1/4 px-2 py-3.5 pr-6 text-right",
                                    children: t("amount.label")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                        className: "divide-y divide-gray-200 bg-white text-sm text-gray-700",
                        children: transactions.map((transaction)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap w-1/4  py-3 pl-4 pr-3 sm:pl-6",
                                        children: new Date(transaction.date).toLocaleDateString("de", {
                                            year: "2-digit",
                                            month: "2-digit",
                                            day: "2-digit",
                                            timezone: "UTC"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "truncate px-2 py-3 w-1/2",
                                        children: transaction.otherParty
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap w-1/4 pl-2 py-3 text-right pr-6",
                                        children: transaction.accountCurrencyAmount
                                    })
                                ]
                            }, transaction.id || Math.random() * 10000))
                    })
                ]
            }),
            (account === null || account === void 0 ? void 0 : account.currency) && (account === null || account === void 0 ? void 0 : account.currency) !== baseCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "uppercase font-semibold mt-8 text-sm text-gray-700 w-full",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: `Current balance in ${(account === null || account === void 0 ? void 0 : account.currency) || null} `
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $778f4e3e2e2497ea$export$2e2bcd8739ae039), {
                            account: account,
                            category: "deposits",
                            currencyCodeFormat: "",
                            showInBaseCurrency: false
                        })
                    })
                ]
            })
        ]
    });
}
function $28bd968d00880be4$export$4c45ff2bc7b84d31({ account: account }) {
    $28bd968d00880be4$export$4c45ff2bc7b84d31.propTypes = {
        account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
    };
    $28bd968d00880be4$export$4c45ff2bc7b84d31.defaultProps = {
        account: null
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "columns"
    });
    const selectAssetBalances = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$7cd09fd23199c464));
    const positions = (selectAssetBalances || []).filter((ab)=>ab.accountId === account.id).sort((a, b)=>b.current.valueBaseCurrency - a.current.valueBaseCurrency).slice(0, 10);
    // console.log('DEBUG tab', positions);
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "transaction-preview",
        className: "inline-block min-w-full py-4 align-middle",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "overflow-hidden shadow ring-1 ring-black ring-opacity-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                className: "min-w-full divide-y divide-gray-300",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                        className: "bg-gray-50 text-xs font-semibold text-gray-900 uppercase",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap py-3.5 pl-4 pr-3 sm:pl-6 text-left",
                                    children: t("assetId.label")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap pl-2 py-3.5 text-right",
                                    children: t("priceShort.label")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap px-2 py-3.5 pr-6 text-right",
                                    children: t("value")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                        className: "divide-y divide-gray-200 bg-white text-sm text-gray-700",
                        children: positions.map((position)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-3 pl-4 pr-3 sm:pl-6",
                                        children: position.displayName.length > 25 ? `${position.displayName.substring(0, 25)}...` : position.displayName
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap pl-2 py-3 text-right",
                                        children: position.current.quoteBaseCurrency.toLocaleString("de", {
                                            style: "currency",
                                            currency: baseCurrency,
                                            maximumFractionDigits: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap pl-2 py-3 text-right pr-6",
                                        children: position.current.valueBaseCurrency.toLocaleString("de", {
                                            style: "currency",
                                            currency: baseCurrency,
                                            maximumFractionDigits: 0
                                        })
                                    })
                                ]
                            }, position.assetId))
                    })
                ]
            })
        })
    });
}
function $28bd968d00880be4$export$7fea16f60f0749a7({ account: account }) {
    $28bd968d00880be4$export$7fea16f60f0749a7.propTypes = {
        account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
    };
    $28bd968d00880be4$export$7fea16f60f0749a7.defaultProps = {
        account: null
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "columns"
    });
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const quotes = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $93bb2798871a68d2$export$443f4a6ebd922e0a)(state)[account.id]);
    // handle no valuations case
    if (Object.keys(quotes || []).length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "inline-block min-w-full py-4 align-middle",
        children: "No data yet."
    });
    const mostRecentQuotes = (Object.entries(quotes) || []).map(([date, quoteObject])=>(0, $2qxEV._)((0, $9tqwB._)({
            date: date
        }, quoteObject), {
            quote: (quoteObject.quoteBaseCurrency || 0).toLocaleString("de", {
                style: "currency",
                currency: baseCurrency,
                maximumFractionDigits: 0
            })
        })).filter((item)=>item.date < new Date().valueOf()) // HACK: this should be done centrally, but it seems quite heavy
    .sort((a, b)=>a.date - b.date) // sort to make the reduce below easy
    .reduce((prev, curr)=>curr.quoteDate > (prev[prev.length - 1] || {
            quoteDate: 0
        }).quoteDate ? [
            ...prev,
            curr
        ] : prev, []) // keep the first quote (it's sorted!) for each new quoteDate
    .sort((a, b)=>b.date - a.date).slice(0, 6);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "transaction-preview",
        className: "inline-block min-w-full py-4 align-middle",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "overflow-hidden ring-1 ring-black ring-opacity-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                className: "min-w-full divide-y divide-gray-300",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                        className: "text-xs font-semibold text-gray-900 uppercase bg-gray-50",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left sm:pl-6",
                                    children: t("date")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap px-2 py-3.5 text-left",
                                    children: t("value")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                        className: "divide-y divide-gray-200 bg-white text-sm text-gray-700",
                        children: mostRecentQuotes.map((valuation)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-3 pl-4 pr-3 sm:pl-6",
                                        children: new Date(Number(valuation.date)).toLocaleDateString("de", {
                                            year: "2-digit",
                                            month: "2-digit",
                                            day: "2-digit",
                                            timezone: "UTC"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap px-2 py-2",
                                        children: valuation.quote
                                    })
                                ]
                            }, valuation.id || Math.random() * 10000))
                    })
                ]
            })
        })
    });
}
function $28bd968d00880be4$export$e1709296284c224e({ account: account }) {
    var _selectTransactions_loans_account_id_account_currency, _selectTransactions_loans_account_id, _selectTransactions_loans;
    $28bd968d00880be4$export$e1709296284c224e.propTypes = {
        account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
    };
    $28bd968d00880be4$export$e1709296284c224e.defaultProps = {
        account: null
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "columns"
    });
    const selectTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$cb9c32c395459b9b));
    if (!selectTransactions) return true;
    const transactionsToShow = selectTransactions === null || selectTransactions === void 0 ? void 0 : (_selectTransactions_loans = selectTransactions.loans) === null || _selectTransactions_loans === void 0 ? void 0 : (_selectTransactions_loans_account_id = _selectTransactions_loans[account === null || account === void 0 ? void 0 : account.id]) === null || _selectTransactions_loans_account_id === void 0 ? void 0 : (_selectTransactions_loans_account_id_account_currency = _selectTransactions_loans_account_id[account === null || account === void 0 ? void 0 : account.currency]) === null || _selectTransactions_loans_account_id_account_currency === void 0 ? void 0 : _selectTransactions_loans_account_id_account_currency.transactions;
    const transactions = (transactionsToShow || []).sort((a, b)=>b.date - a.date).slice(0, 6).map((item)=>({
            date: item.date,
            name: item.description,
            quantity: (item.quantity * item.upac || 0).toLocaleString("de", {
                style: "currency",
                currency: item.accountCurrency,
                maximumFractionDigits: 2
            }),
            quantityInterest: (item.quantityInterest * item.upac || 0).toLocaleString("de", {
                style: "currency",
                currency: item.accountCurrency,
                maximumFractionDigits: 2
            })
        }));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "transaction-preview",
        className: "inline-block min-w-full py-4 align-middle",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "overflow-hidden shadow ring-1 ring-black ring-opacity-5",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                className: "min-w-full divide-y divide-gray-300",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                        className: "bg-gray-50 text-xs font-semibold text-gray-900 uppercase",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap py-3.5 pl-4 pr-3 sm:pl-6 text-left",
                                    children: t("date")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap px-2 py-3.5 text-left",
                                    children: t("description")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap pl-2 py-3.5 text-right",
                                    children: t("principal.label")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                    scope: "col",
                                    className: "whitespace-nowrap px-2 py-3.5 pr-6 text-right",
                                    children: t("interest.label")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                        className: "divide-y divide-gray-200 bg-white text-sm text-gray-700",
                        children: transactions.map((transaction)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap py-3 pl-4 pr-3 sm:pl-6",
                                        children: new Date(transaction.date).toLocaleDateString("de", {
                                            year: "2-digit",
                                            month: "2-digit",
                                            day: "2-digit",
                                            timezone: "UTC"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap px-2 py-3 ",
                                        children: transaction.name.length > 25 ? `${transaction.name.substring(0, 25)}...` : transaction.name
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap pl-2 py-3 text-right",
                                        children: transaction.quantity
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                        className: "whitespace-nowrap pl-2 py-3 text-right pr-6",
                                        children: transaction.quantityInterest
                                    })
                                ]
                            }, transaction.id || Math.random() * 10000))
                    })
                ]
            })
        })
    });
}
function $28bd968d00880be4$export$df368765cdd67a66({ account: account }) {
    var _selectQuotes_account_id, _currentSpecialQuotes_find, _currentSpecialQuotes_find1, _currentSpecialQuotes_find2, _currentSpecialQuotes_find3, _currentSpecialQuotes_find4;
    $28bd968d00880be4$export$df368765cdd67a66.propTypes = {
        account: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any)
    };
    $28bd968d00880be4$export$df368765cdd67a66.defaultProps = {
        account: null
    };
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "columns"
    });
    // I want to see recent payouts. If there are no payouts, show me contributions. If there are no contributions, show payout estimates from provider.
    // if (!account) return true;
    const selectTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $9a12762f4ca7889e$export$b2cccdcd27192b)(state));
    const thisAccountTransactions = selectTransactions.filter((x)=>{
        var _x_tags, _x_tags1;
        return ((_x_tags = x.tags) === null || _x_tags === void 0 ? void 0 : _x_tags.accountId) === (account === null || account === void 0 ? void 0 : account.id) || ((_x_tags1 = x.tags) === null || _x_tags1 === void 0 ? void 0 : _x_tags1.assetId) === (account === null || account === void 0 ? void 0 : account.id);
    });
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency) || "EUR";
    const contributions = thisAccountTransactions.filter((tx)=>tx.label === "investment-contribution");
    const payouts = thisAccountTransactions.filter((tx)=>tx.label === "investment-pension");
    const selectQuotes = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$443f4a6ebd922e0a));
    const currentSpecialQuotes = ((_selectQuotes_account_id = selectQuotes[account.id]) === null || _selectQuotes_account_id === void 0 ? void 0 : _selectQuotes_account_id.current.specialQuotes) || [];
    const displayMode = (()=>{
        if (payouts.length > 0) return "payouts";
        if (contributions.length > 0) return "contributions";
        return "quotes";
    })();
    if ([
        "payouts",
        "contributions"
    ].includes(displayMode)) {
        const transactions = (displayMode === "payouts" ? payouts : contributions).sort((a, b)=>b.date - a.date).slice(0, 6).map((item)=>({
                date: item.date,
                description: item.description,
                quantity: item.quantity.toLocaleString("de", {
                    style: "currency",
                    currency: (account === null || account === void 0 ? void 0 : account.currency) || "EUR",
                    maximumFractionDigits: 2
                }),
                currency: item.currency
            }));
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            id: "transaction-preview",
            className: "inline-block min-w-full py-4 align-middle",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "overflow-hidden ring-1 ring-black ring-opacity-5 ",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("table", {
                        className: "min-w-full divide-y divide-gray-300",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("thead", {
                                className: "text-xs font-semibold text-gray-900 uppercase bg-gray-50",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                            scope: "col",
                                            className: "whitespace-nowrap py-3.5 pl-4 pr-3 text-left sm:pl-6",
                                            children: t("date")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                            scope: "col",
                                            className: "whitespace-nowrap px-2 py-3.5 text-left",
                                            children: t("description")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("th", {
                                            scope: "col",
                                            className: "whitespace-nowrap px-2 py-3.5 pr-6 text-right",
                                            children: t("amount.label")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("tbody", {
                                className: "divide-y divide-gray-200 bg-white text-sm text-gray-700",
                                children: transactions.map((transaction)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                className: "whitespace-nowrap py-3 pl-4 pr-3 sm:pl-6",
                                                children: new Date(transaction.date).toLocaleDateString("de", {
                                                    year: "2-digit",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                    timezone: "UTC"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                className: "whitespace-nowrap px-2 py-3",
                                                children: transaction.description
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("td", {
                                                className: "whitespace-nowrap pl-2 py-3 text-right pr-6",
                                                children: transaction.quantity
                                            })
                                        ]
                                    }, transaction.id || Math.random() * 10000))
                            })
                        ]
                    })
                }),
                (account === null || account === void 0 ? void 0 : account.currency) && (account === null || account === void 0 ? void 0 : account.currency) !== baseCurrency && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                    className: "uppercase font-semibold my-8 text-sm text-gray-700 w-full",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: `Current balance in ${(account === null || account === void 0 ? void 0 : account.currency) || null} `
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $778f4e3e2e2497ea$export$2e2bcd8739ae039), {
                                account: account,
                                category: "deposits",
                                currencyCodeFormat: "",
                                showInBaseCurrency: false
                            })
                        })
                    ]
                })
            ]
        });
    }
    // handle quotes mode
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "transaction-preview",
        className: "inline-block min-w-full py-4 px-2 align-middle",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "overflow-hidden ring-1 ring-black ring-opacity-5 ",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "p-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "font-semibold text-sm mb-1 sm:mb-2",
                            children: t("payoutOnlyContributionsToDate.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "font-base text-gray-700 text-sm sm:text-base",
                            children: (_currentSpecialQuotes_find = currentSpecialQuotes.find((sq)=>sq.type === "payoutOnlyContributionsToDate")) === null || _currentSpecialQuotes_find === void 0 ? void 0 : _currentSpecialQuotes_find.quoteBaseCurrency.toLocaleString("de", {
                                style: "currency",
                                currency: baseCurrency,
                                maximumFractionDigits: 2
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "p-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "font-semibold text-sm mb-1 sm:mb-2",
                            children: t("payoutOnlyContributionsToDateIndexed.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "font-base text-gray-700 text-sm sm:text-base",
                            children: (_currentSpecialQuotes_find1 = currentSpecialQuotes.find((sq)=>sq.type === "payoutOnlyContributionsToDateIndexed")) === null || _currentSpecialQuotes_find1 === void 0 ? void 0 : _currentSpecialQuotes_find1.quoteBaseCurrency.toLocaleString("de", {
                                style: "currency",
                                currency: baseCurrency,
                                maximumFractionDigits: 2
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "p-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "font-semibold text-sm mb-1 sm:mb-2",
                            children: t("payoutAllPlannedContributions.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "font-base text-gray-700 text-sm sm:text-base",
                            children: (_currentSpecialQuotes_find2 = currentSpecialQuotes.find((sq)=>sq.type === "payoutAllPlannedContributions")) === null || _currentSpecialQuotes_find2 === void 0 ? void 0 : _currentSpecialQuotes_find2.quoteBaseCurrency.toLocaleString("de", {
                                style: "currency",
                                currency: baseCurrency,
                                maximumFractionDigits: 2
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "p-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "font-semibold text-sm mb-1 sm:mb-2",
                            children: t("payoutAllPlannedContributionsIndexed.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "font-base text-gray-700 text-sm sm:text-base",
                            children: (_currentSpecialQuotes_find3 = currentSpecialQuotes.find((sq)=>sq.type === "payoutAllPlannedContributionsIndexed")) === null || _currentSpecialQuotes_find3 === void 0 ? void 0 : _currentSpecialQuotes_find3.quoteBaseCurrency.toLocaleString("de", {
                                style: "currency",
                                currency: baseCurrency,
                                maximumFractionDigits: 2
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "p-2 mb-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "font-semibold text-sm mb-1 sm:mb-2",
                            children: t("payoutLumpSumVerrentet.label")
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "font-base text-gray-700 text-sm sm:text-base",
                            children: (_currentSpecialQuotes_find4 = currentSpecialQuotes.find((sq)=>sq.type === "payoutLumpSumVerrentet")) === null || _currentSpecialQuotes_find4 === void 0 ? void 0 : _currentSpecialQuotes_find4.quoteBaseCurrency.toLocaleString("de", {
                                style: "currency",
                                currency: baseCurrency,
                                maximumFractionDigits: 2
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $28bd968d00880be4$export$2e2bcd8739ae039({ tiletip: tiletip, setTiletip: setTiletip }) {
    let Component;
    const account = tiletip === null || tiletip === void 0 ? void 0 : tiletip.account;
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("charts");
    let header;
    switch((account === null || account === void 0 ? void 0 : account.category) || "deposits"){
        case "deposits":
            Component = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($28bd968d00880be4$export$e24bdb15dc3a0d85, {
                account: account
            });
            header = t("mostRecentTransactions");
            break;
        case "stocks":
        case "metals":
        case "crypto":
            Component = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($28bd968d00880be4$export$4c45ff2bc7b84d31, {
                account: account
            });
            header = t("currentPositions");
            break;
        case "realEstate":
        case "objectsOfValue":
        case "unlistedShares":
            Component = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($28bd968d00880be4$export$7fea16f60f0749a7, {
                account: account
            });
            header = t("mostRecentQuotes");
            break;
        case "loans":
            Component = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($28bd968d00880be4$export$e1709296284c224e, {
                account: account
            });
            header = t("mostRecentTransactions");
            break;
        case "pension":
            Component = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($28bd968d00880be4$export$df368765cdd67a66, {
                account: account
            });
            header = t("currentInformation");
            break;
        default:
            Component = true;
            header = t("mostRecentTransactions");
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b751aa1027c36e73$export$be58926105124dd4), {
        className: "fixed right-8 top-4 w-1/4 py-4 px-6 text-sm z-10 bg-white rounded-lg shadow-md border border-gray-100",
        unmount: true,
        show: !!tiletip,
        enter: "transition-opacity duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "text-base font-semibold text-gray-900",
                id: "chart-top-title",
                children: header
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                onClick: ()=>setTiletip(null),
                className: "absolute top-2 right-2 text-gray-400 hover:text-gray-500",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $125f450ca02db1e2$export$2e2bcd8739ae039), {
                    className: "h-5 w-5"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "py-2 align-middle bg-white min-h-full",
                children: Component
            })
        ]
    });
}
$28bd968d00880be4$export$2e2bcd8739ae039.propTypes = {
    tiletip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    setTiletip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$28bd968d00880be4$export$2e2bcd8739ae039.defaultProps = {
    tiletip: null
};


/* eslint-disable max-len */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $0e81d9e3e227ae03$var$DocumentDuplicateIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M7 3.5A1.5 1.5 0 0 1 8.5 2h3.879a1.5 1.5 0 0 1 1.06.44l3.122 3.12A1.5 1.5 0 0 1 17 6.622V12.5a1.5 1.5 0 0 1-1.5 1.5h-1v-3.379a3 3 0 0 0-.879-2.121L10.5 5.379A3 3 0 0 0 8.379 4.5H7v-1Z"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M4.5 6A1.5 1.5 0 0 0 3 7.5v9A1.5 1.5 0 0 0 4.5 18h7a1.5 1.5 0 0 0 1.5-1.5v-5.879a1.5 1.5 0 0 0-.44-1.06L9.44 6.439A1.5 1.5 0 0 0 8.378 6H4.5Z"
    }));
}
const $0e81d9e3e227ae03$var$ForwardRef = $7fPBF.forwardRef($0e81d9e3e227ae03$var$DocumentDuplicateIcon);
var $0e81d9e3e227ae03$export$2e2bcd8739ae039 = $0e81d9e3e227ae03$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $ae5e2b29089e5aaf$var$PencilIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z"
    }));
}
const $ae5e2b29089e5aaf$var$ForwardRef = $7fPBF.forwardRef($ae5e2b29089e5aaf$var$PencilIcon);
var $ae5e2b29089e5aaf$export$2e2bcd8739ae039 = $ae5e2b29089e5aaf$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $2cc83500ecc961f3$var$ShareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        d: "M13 4.5a2.5 2.5 0 1 1 .702 1.737L6.97 9.604a2.518 2.518 0 0 1 0 .792l6.733 3.367a2.5 2.5 0 1 1-.671 1.341l-6.733-3.367a2.5 2.5 0 1 1 0-3.475l6.733-3.366A2.52 2.52 0 0 1 13 4.5Z"
    }));
}
const $2cc83500ecc961f3$var$ForwardRef = $7fPBF.forwardRef($2cc83500ecc961f3$var$ShareIcon);
var $2cc83500ecc961f3$export$2e2bcd8739ae039 = $2cc83500ecc961f3$var$ForwardRef;







function $d046df3216ed3caf$var$ShareReportConfirmation({ url: url, passcode: passcode }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const { share: share } = navigator; // navigator API, share calls up the >Share< menu on a mobile device
    async function handleClick(e, value) {
        if (share && (0, $3433a3b89d1ad09b$exports.isMobile)) try {
            await navigator.share({
                title: t("title"),
                text: value,
                url: value
            });
            console.log("Successfully shared");
        } catch (error) {
            console.error("Error sharing:", error);
        }
        else // copy invitationText to clipboard and set copied to true
        navigator.clipboard.writeText(value);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "flex flex-col",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mt-2 space-y-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-sm text-gray-500",
                        children: t("shareReport.confirmation.copyBoth")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        className: "mx-auto flex flex-col justify-center items-center text-brandBlue-500 text-sm",
                        onClick: (e)=>handleClick(e, url),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: `https://www.monestry.de/${i18n.language}/shared/`
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: url.split("/").at(-1)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-2 w-24 flex justify-center items-center rounded-md shadow-sm space-x-2 text-sm px-1.5 py-1 font-sm cursor-pointer bg-white hover:bg-gray-50 text-brandBlue-500 border border-brandBlue-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0e81d9e3e227ae03$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 inline-block"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: t("shareReport.confirmation.copy")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "text-sm text-gray-500",
                        children: t("shareReport.confirmation.securityHint")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        className: "text-brandBlue-500 text-base",
                        onClick: (e)=>handleClick(e, passcode),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "text-brandBlue-500",
                                children: passcode
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-2 flex justify-center items-center rounded-md shadow-sm space-x-2 text-sm px-1.5 py-1 font-sm cursor-pointer bg-white hover:bg-gray-50 text-brandBlue-500 border border-brandBlue-400",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0e81d9e3e227ae03$export$2e2bcd8739ae039), {
                                        className: "h-4 w-4 inline-block"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        children: t("shareReport.confirmation.copy")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$d046df3216ed3caf$var$ShareReportConfirmation.propTypes = {
    url: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    passcode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};
function $d046df3216ed3caf$export$2e2bcd8739ae039({ editMode: editMode, setEditMode: setEditMode, getAllData: getAllData, mode: mode }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [reportFilename, setReportFilename] = (0, $7fPBF.useState)(undefined);
    const [passcode, setPasscode] = (0, $7fPBF.useState)(undefined);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    async function handleSync(e) {
        setLoading(true);
        await getAllData();
        setLoading(false);
    }
    // ---------------------------------------------------------
    // initiate DIALOG after pressing >Share< button
    // ---------------------------------------------------------
    function str() {
        return Math.floor(100 + Math.random() * 900).toString();
    }
    async function dispatchPostReport(value) {
        const result = await dispatch((0, $978bd0b55383d4f0$export$d695d27904197b5a)({
            passcode: value
        }));
        if (result === null || result === void 0 ? void 0 : result.error) {
            console.error("error in postSharedReport", result === null || result === void 0 ? void 0 : result.error);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("generalError"));
        } else {
            setReportFilename(result === null || result === void 0 ? void 0 : result.payload);
            setPasscode(value); // this will trigger the useEffect below and show the ALERT
            console.log("result of postSharedReport", JSON.stringify(result, null, 2));
        }
    }
    async function handleShare(e) {
        // display an alert, put the dispatch postSharedReport into callbackOk
        window.dispatchEvent(new CustomEvent("setDialog", {
            detail: {
                header: t("shareReport.header"),
                prompt: t("shareReport.tooltip"),
                value: `${str()}-${str()}-${str()}`,
                callback: dispatchPostReport,
                shareReport: true
            }
        }));
    }
    // ---------------------------------------------------------
    // intitiate ALERT after passcode is set
    // ---------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        if (passcode) window.dispatchEvent(new CustomEvent("setAlert", {
            detail: {
                id: "shareReportLinkSuccess",
                Component: $d046df3216ed3caf$var$ShareReportConfirmation,
                componentProps: {
                    url: `https://www.monestry.de/${i18n.language}/shared/${reportFilename.split(".")[0]}`,
                    passcode: passcode
                },
                callbackOK: ()=>{}
            }
        }));
    }, [
        passcode
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "xs:hidden only:col-span-1 self-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f), {
                    as: "div",
                    className: "relative inline-block text-left",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Button, {
                            className: "bg-none inline-flex items-center -mb-1 px-2 py-2",
                            id: "edit-sync-low-res-ellipsis-button",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a2a89f0f88dbf41$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-gray-400 lg:text-white",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                            enter: "transition ease-out duration-100",
                            enterFrom: "transform opacity-0 scale-95",
                            enterTo: "transform opacity-100 scale-100",
                            leave: "transition ease-in duration-75",
                            leaveFrom: "transform opacity-100 scale-100",
                            leaveTo: "transform opacity-0 scale-95",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Items, {
                                static: true,
                                className: "origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "py-1",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                            children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `block px-4 py-2 text-sm text-gray-700 w-full text-left ${active ? "bg-gray-100" : ""}`,
                                                    onClick: (e)=>setEditMode(!editMode),
                                                    children: editMode ? t("done") : t("edit")
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                            children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    disabled: editMode,
                                                    className: `block px-4 py-2 text-sm text-gray-700 w-full text-left ${active ? "bg-gray-100" : ""}`,
                                                    onClick: handleSync,
                                                    children: "Sync"
                                                })
                                        }),
                                        mode === "dashboard" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db88f0b86f6249bf$export$d9b273488cd8ce6f).Item, {
                                            children: ({ active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    disabled: editMode,
                                                    className: `block px-4 py-2 text-sm text-gray-700 w-full text-left ${active ? "bg-gray-100" : ""}`,
                                                    onClick: handleShare,
                                                    children: t("share")
                                                })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "hidden xs:flex p-4 col-span-1 space-x-4 self-center sm:justify-self-end",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        id: "edit-mode",
                        type: "button",
                        className: `${editMode ? "bg-gray-200 lg:bg-white lg:bg-opacity-30" : "bg-none hover:bg-white hover:bg-opacity-10"}
            inline-flex items-center -mb-1 px-2 sm:px-4 py-2 rounded-md shadow-sm text-sm font-semibold text-gray-400 lg:text-white`,
                        onClick: (e)=>setEditMode(!editMode),
                        children: [
                            editMode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ae5e2b29089e5aaf$export$2e2bcd8739ae039), {
                                className: "sm:-ml-1 sm:mr-2 h-4 w-4 text-gray-400 lg:text-white",
                                "aria-hidden": "true"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91420ff1f0fec24c$export$2e2bcd8739ae039), {
                                className: "sm:-ml-1 sm:mr-2 h-4 w-4 text-gray-400 lg:text-white",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "hidden sm:inline",
                                children: t("edit")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        id: "sync-all-button",
                        disabled: editMode,
                        onClick: handleSync,
                        // eslint-disable-next-line max-len
                        className: `bg-none hover:bg-white hover:bg-opacity-10 inline-flex items-center -mb-1 px-2 sm:px-4 py-2 lg:text-white
          rounded-md shadow-sm text-sm font-semibold text-gray-400`,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3ea1f91ff88fa2cb$export$59de000b07aa1ecd), {
                                className: `sm:-ml-1 sm:mr-2 h-4 w-4 text-gray-400 lg:text-white ${loading ? "animate-spin" : ""}`,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "hidden sm:inline",
                                children: "Sync"
                            })
                        ]
                    }),
                    mode === "dashboard" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        id: "share-button",
                        disabled: editMode,
                        onClick: handleShare,
                        // eslint-disable-next-line max-len
                        className: "bg-none hover:bg-white hover:bg-opacity-10 inline-flex items-center -mb-1 px-2 sm:px-4 py-2 rounded-md shadow-sm text-sm font-semibold text-gray-400 lg:text-white",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2cc83500ecc961f3$export$2e2bcd8739ae039), {
                                className: "sm:-ml-1 sm:mr-2 h-4 w-4 text-gray-400 lg:text-white",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "hidden sm:inline",
                                children: t("share")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$d046df3216ed3caf$export$2e2bcd8739ae039.propTypes = {
    editMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setEditMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    getAllData: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};






var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");









function $8fb6e0982c7673c9$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $8fb6e0982c7673c9$var$AddProjectTile() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("projects");
    const projectTemplate = {
        id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
        name: t("newProject"),
        settings: {
            progressIndicator: "duration",
            isIsolated: false
        },
        comments: []
    };
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        id: "add-new-project-button",
        // on click update the Dashboard addMode state so that the AddAccount component is displayed and the current category is passed as a prop
        onClick: (e)=>{
            dispatch((0, $101425bdfe5b6af9$export$757a8a8481b26284)(projectTemplate));
        },
        className: "relative col-span-1 grid columns-1 justify-center w-full max-w-[18rem] border-dashed border-2 border-gray-300 sm:min-w-full rounded-md cursor-pointer hover:bg-gray-50",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "py-6 align-middle",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $81b875b650c1863f$export$2e2bcd8739ae039), {
                className: "mx-auto h-9 w-9 text-gray-400"
            })
        })
    });
}
const $8fb6e0982c7673c9$var$ProjectTile = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(function ProjectTile({ project: project, deletePending: deletePending, onOpen: onOpen }) {
    const openProject = (0, $7fPBF.useCallback)(()=>{
        onOpen(project.id);
    }, [
        onOpen,
        project.id
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
        id: `project-tile-${project.name.replace(/[^a-zA-Z0-9]/g, "")}`,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: "button",
        className: `col-span-1 flex rounded-md shadow-sm w-full cursor-pointer ${deletePending ? "opacity-50 pointer-events-none" : ""}`,
        onClick: openProject,
        onKeyPress: ()=>{},
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: $8fb6e0982c7673c9$var$classNames("bg-brandViolet-600", "flex-shrink-0 flex items-center justify-center w-3 text-white text-sm font-medium rounded-l-md")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex flex-grow items-center truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white hover:bg-gray-50",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex-grow px-4 py-2 text-sm sm:grid sm:grid-cols-6 sm:space-x-4 lg:grid-cols-1 lg:space-x-0 xl:grid-cols-6 xl:space-x-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "text-[1rem] transform scale-y-110 sm:scale-y-100 sm:text-lg font-semibold text-gray-900 hover:text-gray-600 col-span-2",
                            children: project.name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "w-full h-16 col-span-4 flex items-center",
                            children: [
                                project.settings.progressIndicator === "duration" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $32655ef1093ac6e9$export$2e2bcd8739ae039), {
                                    projectId: project.id
                                }),
                                project.settings.progressIndicator === "roi" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecaa4797207ab7c3$export$2e2bcd8739ae039), {
                                    project: project
                                }),
                                project.settings.progressIndicator === "goal" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $be1ff2970a62d1fa$export$2e2bcd8739ae039), {
                                    project: project
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
$8fb6e0982c7673c9$var$ProjectTile.propTypes = {
    project: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    deletePending: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
function $8fb6e0982c7673c9$export$2e2bcd8739ae039({ setProjectId: setProjectId, editMode: editMode, projectsLoading: projectsLoading }) {
    const projects = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.projects);
    const signal = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.signal);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("header");
    const sortedProjects = (0, $7fPBF.useMemo)(()=>[
            ...projects
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        projects
    ]);
    const handleOpenProject = (0, $7fPBF.useCallback)((projectId)=>{
        setProjectId(projectId);
    }, [
        setProjectId
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
        id: "project-list",
        className: "rounded-md bg-white overflow-hidden shadow p-6",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "text-xl font-bold mb-4",
                children: t("projects")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: "mt-3 grid grid-cols-1 gap-5 sm:gap-6",
                children: [
                    sortedProjects.map((project)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8fb6e0982c7673c9$var$ProjectTile, {
                            project: project,
                            deletePending: signal[project.id] === "deleteProject",
                            onOpen: handleOpenProject
                        }, project.id)),
                    (editMode === true || !projectsLoading && projects && projects.length === 0) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8fb6e0982c7673c9$var$AddProjectTile, {})
                ]
            }),
            projectsLoading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "w-full h-20 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                    className: "w-6 h-6 text-gray-500 animate-spin "
                })
            })
        ]
    });
}
$8fb6e0982c7673c9$export$2e2bcd8739ae039.propTypes = {
    setProjectId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    editMode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    projectsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
};






/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-restricted-syntax */ /* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

const $63440b8a5aaffaa3$export$8039b2f11d6a2cca = "changeInValue";
const $63440b8a5aaffaa3$export$1e4f3c4864b3e860 = "currentNetWorth";
const $63440b8a5aaffaa3$export$3d996af5daf7b190 = "previousValue";


/* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

/* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



/* eslint-disable react/forbid-prop-types */ 

var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
/** @deprecated */ function $f0f3acd35a955886$var$ArrowSmallDownIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M12 3.75a.75.75 0 0 1 .75.75v13.19l5.47-5.47a.75.75 0 1 1 1.06 1.06l-6.75 6.75a.75.75 0 0 1-1.06 0l-6.75-6.75a.75.75 0 1 1 1.06-1.06l5.47 5.47V4.5a.75.75 0 0 1 .75-.75Z",
        clipRule: "evenodd"
    }));
}
const $f0f3acd35a955886$var$ForwardRef = $7fPBF.forwardRef($f0f3acd35a955886$var$ArrowSmallDownIcon);
var $f0f3acd35a955886$export$2e2bcd8739ae039 = $f0f3acd35a955886$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
/** @deprecated */ function $026022440f52ade4$var$ArrowSmallRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M3.75 12a.75.75 0 0 1 .75-.75h13.19l-5.47-5.47a.75.75 0 0 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06l-6.75 6.75a.75.75 0 1 1-1.06-1.06l5.47-5.47H4.5a.75.75 0 0 1-.75-.75Z",
        clipRule: "evenodd"
    }));
}
const $026022440f52ade4$var$ForwardRef = $7fPBF.forwardRef($026022440f52ade4$var$ArrowSmallRightIcon);
var $026022440f52ade4$export$2e2bcd8739ae039 = $026022440f52ade4$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
/** @deprecated */ function $88a0ce173c6aba99$var$ArrowSmallUpIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M12 20.25a.75.75 0 0 1-.75-.75V6.31l-5.47 5.47a.75.75 0 0 1-1.06-1.06l6.75-6.75a.75.75 0 0 1 1.06 0l6.75 6.75a.75.75 0 1 1-1.06 1.06l-5.47-5.47V19.5a.75.75 0 0 1-.75.75Z",
        clipRule: "evenodd"
    }));
}
const $88a0ce173c6aba99$var$ForwardRef = $7fPBF.forwardRef($88a0ce173c6aba99$var$ArrowSmallUpIcon);
var $88a0ce173c6aba99$export$2e2bcd8739ae039 = $88a0ce173c6aba99$var$ForwardRef;


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $de03fc91f2f268a7$var$ExclamationTriangleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
        clipRule: "evenodd"
    }));
}
const $de03fc91f2f268a7$var$ForwardRef = $7fPBF.forwardRef($de03fc91f2f268a7$var$ExclamationTriangleIcon);
var $de03fc91f2f268a7$export$2e2bcd8739ae039 = $de03fc91f2f268a7$var$ForwardRef;



var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



/* eslint-disable react/forbid-prop-types */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $970d7a116074ba18$var$ArrowRightCircleIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.28 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H8.25a.75.75 0 0 0 0 1.5h5.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3Z",
        clipRule: "evenodd"
    }));
}
const $970d7a116074ba18$var$ForwardRef = $7fPBF.forwardRef($970d7a116074ba18$var$ArrowRightCircleIcon);
var $970d7a116074ba18$export$2e2bcd8739ae039 = $970d7a116074ba18$var$ForwardRef;





var $2oXYc = parcelRequire("2oXYc");
parcelRequire("7fPBF");






function $d6d3c7195a80296f$export$2e2bcd8739ae039({ setDialogOpen: setDialogOpen, transactions: transactions, setAccountDetails: setAccountDetails }) {
    const selectDepositTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$3c400324181e2c4d));
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    function handleTransactionClick(transaction) {
        // try to find out the most likely deposit transaction in the connectedDepositAccounts (which every transaction in 'transactions' has)
        const connectedDepositAccountsIds = transaction.connectedDepositAccounts.map((a)=>a.id);
        // see if you can find any deposit transaction in the deposit accounts connected to this asset account
        // bear in mind that 'transaction' is an asset transaction, so quantity can be positive or negative (loans taken)
        // so find all transactions in connectedDepositAccounts.map((a) => a.id) which have a Math.abs(quantity) within 10% of transaction.quantity and date within 5 days of transaction.date
        // if found, add the transaction to connectedDepositTransactions
        const transactionCandidates = selectDepositTransactions.filter((txn)=>connectedDepositAccountsIds.includes(txn.accountId) && Math.abs(txn.quantity) >= Math.abs(transaction.quantity) * 0.9 && Math.abs(txn.quantity) <= Math.abs(transaction.quantity) * 1.1 && Math.abs(txn.date - transaction.date) <= 432000000);
        if (transactionCandidates.length > 0) {
            if (transactionCandidates.length === 1) {
                // if there is only one, setAccountDetails to the full Account object of that transaction's accountId and add highlightTransactionId
                const targetAccount = transaction.connectedDepositAccounts.find((a)=>a.id === transactionCandidates[0].accountId);
                setAccountDetails((0, $2qxEV._)((0, $9tqwB._)({}, targetAccount), {
                    highlightTransactionId: transactionCandidates[0].id
                }));
                return;
            }
            // if there is more than one candidate, just open the account without highlighting anything (show a warning to user)
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("moreThan1ConnectedAccountFound"));
            setAccountDetails(transaction.connectedDepositAccounts[0]);
        }
        setAccountDetails(transaction.connectedDepositAccounts[0]);
        setDialogOpen(false);
    }
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard", {
        keyPrefix: "sumtile.orphanedDialog"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "absolute flex bg-gray-500 bg-opacity-75 inset-0 z-10",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "relative max-w-2xl mx-auto my-auto bg-white p-12 rounded-md shadow-sm",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                    className: "absolute top-4 right-4 h-6 w-6 text-gray-500 hover:text-gray-900 cursor-pointer",
                    onClick: ()=>setDialogOpen(false)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    className: "w-full sm:w-auto text-xl sm:text-2xl font-bold text-gray-900 mb-6 prose",
                    children: t("assetTransactionsDialogTitle")
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $344a70c9f2a7e27e$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-brandBlue-500"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "w-full sm:w-auto text-sm font-normal text-gray-700 leading-snug mb-4 pr-4",
                            children: t("netWorthExplanation")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex space-x-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $970d7a116074ba18$export$2e2bcd8739ae039), {
                                className: "w-6 h-6 text-brandBlue-500"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "w-full sm:w-auto text-sm font-normal text-gray-700 leading-snug mb-4 pr-4",
                            children: t("notLinkedTransactionsExplanation")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "mt-4 space-y-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "p-2 w-full grid grid-cols-4 grid-flow-row gap-4 text-gray-900 text-xs font-bold uppercase",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t("transactionTableHeaders.date")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t("transactionTableHeaders.assetAccount")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t("transactionTableHeaders.assetName")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-right",
                                    children: t("transactionTableHeaders.amount")
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-right",
                                    children: t("transactionTableHeaders.value")
                                })
                            ]
                        }),
                        transactions.map((transaction)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>handleTransactionClick(transaction),
                                className: "px-4 py-2 w-full grid grid-cols-4 grid-flow-row gap-4 border rounded-md border-gray-300 text-sm items-center cursor-pointer hover:bg-gray-50",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "text-left",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(transaction.date).format("YYYY.MM.DD")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3b4d597555017c22$export$2e2bcd8739ae039), {
                                                accountName: transaction.accountName,
                                                category: transaction.category,
                                                styleClasses: "justify-self-start mt-1"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-left",
                                        children: transaction.displayName || transaction.accountName
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-right",
                                        children: transaction.quantity
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "text-right",
                                        children: `${(transaction.quantity * transaction.upac).toLocaleString("de", {
                                            style: "currency",
                                            currency: transaction.accountCurrency
                                        })}`
                                    })
                                ]
                            }, transaction.id))
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "mt-6 flex justify-end",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("closeButtonText"),
                        onClick: ()=>setDialogOpen(false),
                        withAccent: true
                    })
                })
            ]
        })
    });
}
$d6d3c7195a80296f$export$2e2bcd8739ae039.propTypes = {
    setDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    transactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    setAccountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$d6d3c7195a80296f$export$2e2bcd8739ae039.defaultProps = {
    transactions: []
};


function $983579dd62c1d017$export$2e2bcd8739ae039({ id: id, stat: stat, change: change, setKpiReportVisible: setKpiReportVisible, orphanedTransactions: orphanedTransactions, setAccountDetails: setAccountDetails }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const [dialogOpen, setDialogOpen] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "my-auto",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dt", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                    info: t(`sumtile.${id}.tooltip`),
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "text-xs sm:text-sm font-medium text-gray-500 lg:text-center xl:text-left truncate flex items-end space-x-1",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: t(`sumtile.${id}.label`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $071105eca597c3d9$export$2e2bcd8739ae039), {}),
                            orphanedTransactions.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                info: t("sumtile.warning"),
                                classNameOwn: "-mb-0.5",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setDialogOpen(true),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de03fc91f2f268a7$export$2e2bcd8739ae039), {
                                        className: "w-5 h-5 text-brandYellow-500 cursor-pointer"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("dd", {
                className: "flex flex-wrap 2xl:flex-nowrap justify-start items-baseline",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        // transform is needed to fix incorrect font rendering below xs
                        className: "text-[1rem] transform scale-y-110 sm:scale-y-100 xs:text-lg sm:text-xl md:text-2xl lg:text-xl xl:text-2xl font-semibold text-gray-900 mr-2",
                        children: stat
                    }),
                    change !== null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                        info: t("sumtile.change"),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            className: `
                ${change > 0 ? "text-green-500" : ""} ${change === 0 ? "text-yellow-500" : ""} ${change < 0 ? "text-brandRed-500" : ""}
                flex items-baseline text-xs md:text-sm font-normal sm:font-semibold
              `,
                            children: [
                                change > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $88a0ce173c6aba99$export$2e2bcd8739ae039), {
                                    className: "self-center flex-shrink-0 h-3 w-3 md:h-5 md:w-5 text-green-500",
                                    "aria-hidden": "true"
                                }),
                                change === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $026022440f52ade4$export$2e2bcd8739ae039), {
                                    className: "self-center flex-shrink-0 h-3 w-2 md:h-5 md:w-5 text-yellow-500",
                                    "aria-hidden": "true"
                                }),
                                change < 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0f3acd35a955886$export$2e2bcd8739ae039), {
                                    className: "self-center flex-shrink-0 h-3 w-3 md:h-5 md:w-5 text-brandRed-500",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                    className: "sr-only",
                                    children: [
                                        change >= 0 ? "Increased" : "Decreased",
                                        "by"
                                    ]
                                }),
                                (!change ? 0 : change).toLocaleString("de", {
                                    style: "percent",
                                    maximumFractionDigits: 2
                                })
                            ]
                        })
                    }),
                    dialogOpen && /*#__PURE__*/ (0, $fw0lo.createPortal)(// eslint-disable-next-line react/jsx-no-bind
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6d3c7195a80296f$export$2e2bcd8739ae039), {
                        setDialogOpen: setDialogOpen,
                        transactions: orphanedTransactions,
                        setAccountDetails: setAccountDetails
                    }), document.querySelector("div#dashboard-level-1"))
                ]
            })
        ]
    });
}
$983579dd62c1d017$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    stat: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    change: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    setKpiReportVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    orphanedTransactions: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object),
    setAccountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
$983579dd62c1d017$export$2e2bcd8739ae039.defaultProps = {
    change: null,
    setKpiReportVisible: null,
    orphanedTransactions: [],
    setAccountDetails: ()=>{}
};




function $af19545d76ff4406$var$SumCurrentNetWorth({ baseCurrency: baseCurrency, isViewer: isViewer }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    // imported a global selector defined in the reducer module
    const selectCurrentNetWorth = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.currentNetWorth) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$611bdd34eb5c8a52));
    const typeProps = {
        name: t("sumtile.currentNetWorth"),
        stat: selectCurrentNetWorth === null || selectCurrentNetWorth === void 0 ? void 0 : selectCurrentNetWorth.toLocaleString("de", {
            style: "currency",
            currency: baseCurrency || "EUR",
            maximumFractionDigits: 0
        }),
        icon: (0, $4de34f51288f4739$export$2e2bcd8739ae039)
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
        id: (0, $63440b8a5aaffaa3$export$1e4f3c4864b3e860),
        name: typeProps.name,
        stat: typeProps.stat,
        icon: typeProps.icon,
        change: typeProps.change,
        isViewer: isViewer
    });
}
$af19545d76ff4406$var$SumCurrentNetWorth.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$af19545d76ff4406$var$SumCurrentNetWorth.defaultProps = {
    isViewer: false
};
const $af19545d76ff4406$var$SumCurrentNetWorthMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($af19545d76ff4406$var$SumCurrentNetWorth);
var $af19545d76ff4406$export$2e2bcd8739ae039 = $af19545d76ff4406$var$SumCurrentNetWorthMemo;


/* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




function $f561b778ab3c93e0$var$SumCurrentNetWorth({ baseCurrency: baseCurrency, isViewer: isViewer }) {
    // imported a global selector defined in the reducer module
    const selectCurrentNetWorthBaseline = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.baselineNetWorth) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$be3d5997140286cf));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
        id: (0, $63440b8a5aaffaa3$export$3d996af5daf7b190),
        stat: selectCurrentNetWorthBaseline === null || selectCurrentNetWorthBaseline === void 0 ? void 0 : selectCurrentNetWorthBaseline.toLocaleString("de", {
            style: "currency",
            currency: baseCurrency || "EUR",
            maximumFractionDigits: 0
        }),
        isViewer: isViewer
    });
}
$f561b778ab3c93e0$var$SumCurrentNetWorth.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$f561b778ab3c93e0$var$SumCurrentNetWorth.defaultProps = {
    isViewer: false
};
const $f561b778ab3c93e0$var$SumCurrentNetWorthMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($f561b778ab3c93e0$var$SumCurrentNetWorth);
var $f561b778ab3c93e0$export$2e2bcd8739ae039 = $f561b778ab3c93e0$var$SumCurrentNetWorthMemo;


/* eslint-disable jsx-a11y/label-has-associated-control */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");






function $9e4993f18fb6a884$var$SumChangeInValue({ baseCurrency: baseCurrency, setKpiReportVisible: setKpiReportVisible, isViewer: isViewer }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    // imported a global selector defined in the reducer module
    const selectCurrentNetWorth = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.currentNetWorth) : (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$611bdd34eb5c8a52);
    const selectIncomeFromCapital = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.incomeFromCapital) : (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$f63326aa9088648b);
    const selectTotalOutflows = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.outflows) : (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$57f29db9c40dbad7);
    const selectTotalInflows = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.inflows) : (0, $51238fa605392ada$export$2105062e25df4afe)($a368196802fe263c$export$61408e9de6c25330);
    const selectCurrentNetWorthBaseline = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.baselineNetWorth) : (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$be3d5997140286cf);
    const selectAssetValueChange = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.assetValueChange) : (0, $51238fa605392ada$export$2105062e25df4afe)($3679aa7475d9bd44$export$de4ac74636de1fbc);
    const changeInValue = selectTotalInflows + selectTotalOutflows + selectAssetValueChange + selectIncomeFromCapital;
    const typeProps = {
        name: t("sumtile.changeInValue.label"),
        stat: changeInValue.toLocaleString("de", {
            style: "currency",
            currency: baseCurrency || "EUR",
            maximumFractionDigits: 0
        }),
        icon: (0, $4de34f51288f4739$export$2e2bcd8739ae039),
        change: (selectCurrentNetWorth - selectCurrentNetWorthBaseline) / selectCurrentNetWorthBaseline
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
        id: (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca),
        name: typeProps.name,
        stat: typeProps.stat,
        icon: typeProps.icon,
        change: typeProps.change,
        isViewer: isViewer
    });
}
$9e4993f18fb6a884$var$SumChangeInValue.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setKpiReportVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$9e4993f18fb6a884$var$SumChangeInValue.defaultProps = {
    setKpiReportVisible: ()=>{},
    isViewer: false
};
const $9e4993f18fb6a884$var$SumChangeInValueMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($9e4993f18fb6a884$var$SumChangeInValue);
var $9e4993f18fb6a884$export$2e2bcd8739ae039 = $9e4993f18fb6a884$var$SumChangeInValueMemo;



function $e84340f71ef6b3b8$var$SumTile({ id: id, baseCurrency: baseCurrency, setKpiReportVisible: setKpiReportVisible, mode: mode, onClick: onClick, outline: outline, isViewer: isViewer }) {
    function onClickLocal() {
        setKpiReportVisible(true);
    }
    let Component;
    switch(id){
        case 0, $63440b8a5aaffaa3$export$1e4f3c4864b3e860:
            Component = (0, $af19545d76ff4406$export$2e2bcd8739ae039);
            break;
        case 0, $63440b8a5aaffaa3$export$3d996af5daf7b190:
            Component = (0, $f561b778ab3c93e0$export$2e2bcd8739ae039);
            break;
        case 0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca:
            Component = (0, $9e4993f18fb6a884$export$2e2bcd8739ae039);
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
        as: "div",
        appear: true,
        show: true,
        enter: "transition-opacity duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-150",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        onClick: onClick || onClickLocal,
        className: `relative bg-white w-full max-w-[18rem] lg:min-w-full h-full py-4 sm:py-6 md:py-5 lg:py-6 px-2 xs:px-4 sm:px-6 lg:px-3 xl:px-4
      shadow rounded-md overflow-hidden grid space-y-4 divide-y cursor-pointer ${outline ? "border-2 border-brandBlue-500" : ""}`,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(Component, {
            baseCurrency: baseCurrency,
            setKpiReportVisible: setKpiReportVisible,
            isViewer: isViewer
        })
    }, id);
}
$e84340f71ef6b3b8$var$SumTile.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setKpiReportVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "button"
    ]),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$e84340f71ef6b3b8$var$SumTile.defaultProps = {
    setKpiReportVisible: ()=>{},
    mode: "button",
    onClick: ()=>{},
    outline: false,
    isViewer: false
};
const $e84340f71ef6b3b8$var$SumTileMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($e84340f71ef6b3b8$var$SumTile);
var $e84340f71ef6b3b8$export$2e2bcd8739ae039 = $e84340f71ef6b3b8$var$SumTileMemo;


/* eslint-disable react/forbid-prop-types */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/destructuring-assignment */ 




var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");



var $fw0lo = parcelRequire("fw0lo");



var $2oXYc = parcelRequire("2oXYc");
parcelRequire("7fPBF");




function $fa907abba1d39ba0$export$2e2bcd8739ae039({ calendarState: calendarState, setCalendarState: setCalendarState, baseCurrency: baseCurrency, isViewer: isViewer }) {
    // get global selectors
    const selectCurrentNetWorthBaseline = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.baselineNetWorth) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$be3d5997140286cf));
    const optionsLocaleCurrency = {
        style: "currency",
        currency: baseCurrency,
        maximumFractionDigits: 0
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-col justify-start",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
                id: "previousValue",
                stat: selectCurrentNetWorthBaseline.toLocaleString("de", optionsLocaleCurrency),
                isViewer: isViewer
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $007c634679518524$export$2e2bcd8739ae039), {
                calendarState: calendarState,
                setCalendarState: setCalendarState,
                isViewer: isViewer
            })
        ]
    });
}
$fa907abba1d39ba0$export$2e2bcd8739ae039.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    calendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$fa907abba1d39ba0$export$2e2bcd8739ae039.defaultProps = {
    calendarState: {},
    setCalendarState: {},
    isViewer: false
};



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



function $97a0ee991e395390$export$2e2bcd8739ae039({ baseCurrency: baseCurrency, isViewer: isViewer }) {
    // get global selectors
    const selectIncomeFromCapital = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.incomeFromCapital) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$f63326aa9088648b));
    const selectIncomeFromCapitalReferencePeriod = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.incomeFromCapitalReferencePeriod) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$16297c4826a11a44));
    const selectTotalInflows = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.inflows) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$61408e9de6c25330));
    const selectTotalInflowsReferencePeriod = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.inflowsReferencePeriod) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$1882d03801ff41ff));
    const selectTotalOutflows = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.outflows) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$57f29db9c40dbad7));
    const selectTotalOutflowsReferencePeriod = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.outflowsReferencePeriod) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $a368196802fe263c$export$43c37cdbf008db07));
    const selectCurrentAssetValueChange = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.assetValueChange) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$de4ac74636de1fbc));
    const selectCurrentAssetValueChangeReferencePeriod = isViewer ? (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer.kpis.assetValueChangeReferencePeriod) : (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$92fa9e056f78a7f9));
    const optionsLocaleCurrency = {
        style: "currency",
        currency: baseCurrency || "EUR",
        maximumFractionDigits: 0
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-col gap-4 sm:gap-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
                id: "generalIncome",
                stat: selectTotalInflows.toLocaleString("de", optionsLocaleCurrency),
                change: (selectTotalInflows - selectTotalInflowsReferencePeriod) / Math.abs(selectTotalInflowsReferencePeriod)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
                id: "incomeFromCapital",
                stat: selectIncomeFromCapital.toLocaleString("de", optionsLocaleCurrency),
                change: (selectIncomeFromCapital - selectIncomeFromCapitalReferencePeriod) / Math.abs(selectIncomeFromCapitalReferencePeriod)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
                id: "assetValueIncrease",
                stat: selectCurrentAssetValueChange.toLocaleString("de", optionsLocaleCurrency),
                change: (selectCurrentAssetValueChange - selectCurrentAssetValueChangeReferencePeriod) / Math.abs(selectCurrentAssetValueChangeReferencePeriod)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $983579dd62c1d017$export$2e2bcd8739ae039), {
                id: "outflows",
                stat: selectTotalOutflows.toLocaleString("de", optionsLocaleCurrency),
                change: (selectTotalOutflows - selectTotalOutflowsReferencePeriod) / Math.abs(selectTotalOutflowsReferencePeriod)
            })
        ]
    });
}
$97a0ee991e395390$export$2e2bcd8739ae039.propTypes = {
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$97a0ee991e395390$export$2e2bcd8739ae039.defaultProps = {
    isViewer: false
};









(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
const $890f9df2513422cc$export$c1af727b0dc3469a = 0;
function $890f9df2513422cc$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $890f9df2513422cc$var$SumTileExpendable({ id: id, calendarState: calendarState, setCalendarState: setCalendarState, setKpiReportVisible: setKpiReportVisible, setAccountDetails: setAccountDetails, baseCurrency: baseCurrency, noExpandButton: noExpandButton, isViewer: isViewer }) {
    const [expanded, setExpanded] = (0, $7fPBF.useState)(noExpandButton);
    const [orphanedDialogOpen, setOrphanedDialogOpen] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const orphanedTransactions = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $3679aa7475d9bd44$export$1b272b322aef6de0));
    const selectCategoryStatus = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data, (data)=>Object.keys(data).map((category)=>({
                category: category,
                status: data[category].status
            })));
    const allCategoriesReady = (0, $51238fa605392ada$export$2105062e25df4afe)(selectCategoryStatus).every((category)=>[
            "success",
            "inactive"
        ].includes(category.status));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b751aa1027c36e73$export$be58926105124dd4), {
        as: "div",
        appear: true,
        show: true,
        enter: "transition-opacity duration-200",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-150",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        id: `kpi-${id}`,
        className: `relative bg-white w-full max-w-[18rem] lg:min-w-full h-full px-2 xs:px-4 sm:px-6 lg:px-3 xl:px-4 pt-4 ${noExpandButton ? "pb-4 space-y-4" : "pb-10"} shadow rounded-lg overflow-hidden grid`,
        children: [
            expanded && id === (0, $63440b8a5aaffaa3$export$3d996af5daf7b190) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa907abba1d39ba0$export$2e2bcd8739ae039), {
                calendarState: calendarState,
                setCalendarState: setCalendarState,
                baseCurrency: baseCurrency,
                isViewer: isViewer
            }),
            !expanded && id === (0, $63440b8a5aaffaa3$export$3d996af5daf7b190) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f561b778ab3c93e0$export$2e2bcd8739ae039), {
                baseCurrency: baseCurrency,
                setKpiReportVisible: setKpiReportVisible,
                isViewer: isViewer
            }),
            expanded && id === (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $97a0ee991e395390$export$2e2bcd8739ae039), {
                isViewer: isViewer
            }),
            !expanded && id === (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9e4993f18fb6a884$export$2e2bcd8739ae039), {
                baseCurrency: baseCurrency,
                setKpiReportVisible: setKpiReportVisible,
                isViewer: isViewer
            }),
            allCategoriesReady && id === (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca) && orphanedTransactions.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                info: t("sumtile.warning"),
                classNameOwn: "-mb-0.5 absolute",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setOrphanedDialogOpen(true),
                    className: "bg-brandYellow-50 mt-2 py-1 px-2 rounded-md flex space-x-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de03fc91f2f268a7$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 text-brandYellow-500 cursor-pointer"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "text-xs text-brandYellow-600",
                            children: t("sumtile.inconsistent")
                        })
                    ]
                })
            }),
            !noExpandButton && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute grid justify-center bottom-0 inset-x-0 bg-gray-100 pt-1",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "text-sm",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        onClick: (e)=>setExpanded(!expanded),
                        className: "font-medium text-brandBlue-500 hover:text-brandBlue-600",
                        children: [
                            expanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c88e3f3391578fdf$export$2e2bcd8739ae039), {
                                className: "text-brandBlue-500 h-4 w-4"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $01f5965251d69098$export$2e2bcd8739ae039), {
                                className: "text-brandBlue-500 h-4 w-4"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "sr-only",
                                children: "changes in value stats"
                            })
                        ]
                    })
                })
            }),
            orphanedDialogOpen && /*#__PURE__*/ (0, $fw0lo.createPortal)(// eslint-disable-next-line react/jsx-no-bind
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6d3c7195a80296f$export$2e2bcd8739ae039), {
                setDialogOpen: setOrphanedDialogOpen,
                transactions: orphanedTransactions,
                setAccountDetails: setAccountDetails
            }), document.querySelector("div#dashboard-level-1"))
        ]
    }, "1");
}
$890f9df2513422cc$var$SumTileExpendable.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    calendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setKpiReportVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    setAccountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    noExpandButton: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$890f9df2513422cc$var$SumTileExpendable.defaultProps = {
    calendarState: {},
    setCalendarState: ()=>{},
    setKpiReportVisible: ()=>{},
    setAccountDetails: ()=>{},
    noExpandButton: false,
    isViewer: false
};
const $890f9df2513422cc$var$SumTileExpandableMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($890f9df2513422cc$var$SumTileExpendable);
var $890f9df2513422cc$export$2e2bcd8739ae039 = $890f9df2513422cc$var$SumTileExpandableMemo;


function $acdb9cfdc96986b7$export$2e2bcd8739ae039({ baseCurrency: baseCurrency, setKpiReportVisible: setKpiReportVisible, calendar: calendar, setCalendarState: setCalendarState, setAccountDetails: setAccountDetails, isViewer: isViewer }) {
    const [expandedMobile, setExpandedMobile] = (0, $7fPBF.useState)(null);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                "aria-labelledby": "KPIs",
                id: "net-worth-kpis",
                className: "hidden xs:grid xs:grid-cols-3 lg:grid-cols-1 justify-items-center items-center content-center gap-2 md:gap-4 gap-y-2 md:gap-y-4 lg:col-span-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e84340f71ef6b3b8$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$1e4f3c4864b3e860),
                        baseCurrency: baseCurrency,
                        setKpiReportVisible: setKpiReportVisible,
                        isViewer: isViewer
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $890f9df2513422cc$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca),
                        setKpiReportVisible: setKpiReportVisible,
                        setAccountDetails: setAccountDetails,
                        baseCurrency: baseCurrency,
                        isViewer: isViewer
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $890f9df2513422cc$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$3d996af5daf7b190),
                        calendarState: calendar,
                        setCalendarState: setCalendarState,
                        setKpiReportVisible: setKpiReportVisible,
                        baseCurrency: baseCurrency,
                        isViewer: isViewer
                    })
                ]
            }),
            !expandedMobile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                "aria-labelledby": "KPIs",
                id: "net-worth-kpis",
                className: "xs:hidden grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e84340f71ef6b3b8$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$1e4f3c4864b3e860),
                        setKpiReportVisible: setKpiReportVisible,
                        baseCurrency: baseCurrency,
                        mode: "button",
                        onClick: ()=>setExpandedMobile((0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca)),
                        isViewer: isViewer
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e84340f71ef6b3b8$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca),
                        setKpiReportVisible: setKpiReportVisible,
                        baseCurrency: baseCurrency,
                        mode: "button",
                        onClick: ()=>setExpandedMobile((0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca)),
                        isViewer: isViewer
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                "aria-labelledby": "KPIs",
                id: "net-worth-kpis",
                className: "xs:hidden grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e84340f71ef6b3b8$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$1e4f3c4864b3e860),
                        setKpiReportVisible: setKpiReportVisible,
                        baseCurrency: baseCurrency,
                        mode: "button",
                        onClick: ()=>setExpandedMobile(null),
                        isViewer: isViewer
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "row-span-3",
                        children: expandedMobile === (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $890f9df2513422cc$export$2e2bcd8739ae039), {
                            id: (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca),
                            setKpiReportVisible: setKpiReportVisible,
                            baseCurrency: baseCurrency,
                            mode: "button",
                            calendarState: calendar,
                            setCalendarState: setCalendarState,
                            setAccountDetails: setAccountDetails,
                            noExpandButton: true,
                            isViewer: isViewer
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $890f9df2513422cc$export$2e2bcd8739ae039), {
                            id: (0, $63440b8a5aaffaa3$export$3d996af5daf7b190),
                            setKpiReportVisible: setKpiReportVisible,
                            baseCurrency: baseCurrency,
                            mode: "button",
                            calendarState: calendar,
                            setCalendarState: setCalendarState,
                            setAccountDetails: setAccountDetails,
                            noExpandButton: true,
                            isViewer: isViewer
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e84340f71ef6b3b8$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca),
                        setKpiReportVisible: setKpiReportVisible,
                        baseCurrency: baseCurrency,
                        mode: "button",
                        outline: expandedMobile === (0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca),
                        onClick: ()=>setExpandedMobile((0, $63440b8a5aaffaa3$export$8039b2f11d6a2cca)),
                        isViewer: isViewer
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e84340f71ef6b3b8$export$2e2bcd8739ae039), {
                        id: (0, $63440b8a5aaffaa3$export$3d996af5daf7b190),
                        setKpiReportVisible: setKpiReportVisible,
                        baseCurrency: baseCurrency,
                        mode: "button",
                        outline: expandedMobile === (0, $63440b8a5aaffaa3$export$3d996af5daf7b190),
                        onClick: ()=>setExpandedMobile((0, $63440b8a5aaffaa3$export$3d996af5daf7b190)),
                        isViewer: isViewer
                    })
                ]
            })
        ]
    });
}
$acdb9cfdc96986b7$export$2e2bcd8739ae039.propTypes = {
    baseCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    setKpiReportVisible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    calendar: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        visible: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
        selectedDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))),
        callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }).isRequired,
    setCalendarState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setAccountDetails: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    isViewer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$acdb9cfdc96986b7$export$2e2bcd8739ae039.defaultProps = {
    isViewer: false
};






var $7fPBF = parcelRequire("7fPBF");
const $afe0d39a1771c519$var$FOCUSABLE_SELECTORS = [
    "a[href]",
    "area[href]",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])'
].join(", ");
function $afe0d39a1771c519$export$2e2bcd8739ae039(targetRef, active) {
    const previousFocusRef = (0, $7fPBF.useRef)(null);
    const tabStateRef = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(()=>{
        const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current;
        if (!target) return undefined;
        const supportsInert = "inert" in target;
        if (!active) {
            // Ensure any lingering state is cleaned up if the component remounts.
            if (supportsInert) {
                target.inert = false;
                target.removeAttribute("inert");
            } else if (tabStateRef.current.length) {
                tabStateRef.current.forEach(({ node: node, tabIndex: tabIndex })=>{
                    if (!node || !node.isConnected) return;
                    if (tabIndex === null) node.removeAttribute("tabindex");
                    else node.setAttribute("tabindex", tabIndex);
                });
                tabStateRef.current = [];
            }
            target.removeAttribute("aria-hidden");
            previousFocusRef.current = null;
            return undefined;
        }
        if (target.contains(document.activeElement)) previousFocusRef.current = document.activeElement;
        target.setAttribute("aria-hidden", "true");
        if (supportsInert) {
            target.inert = true;
            target.setAttribute("inert", "");
        } else {
            const focusable = Array.from(target.querySelectorAll($afe0d39a1771c519$var$FOCUSABLE_SELECTORS));
            tabStateRef.current = focusable.map((node)=>({
                    node: node,
                    tabIndex: node.getAttribute("tabindex")
                }));
            focusable.forEach((node)=>node.setAttribute("tabindex", "-1"));
        }
        return ()=>{
            if (supportsInert) {
                target.inert = false;
                target.removeAttribute("inert");
            } else if (tabStateRef.current.length) {
                tabStateRef.current.forEach(({ node: node, tabIndex: tabIndex })=>{
                    if (!node || !node.isConnected) return;
                    if (tabIndex === null) node.removeAttribute("tabindex");
                    else node.setAttribute("tabindex", tabIndex);
                });
                tabStateRef.current = [];
            }
            target.removeAttribute("aria-hidden");
            if (previousFocusRef.current && target.contains(previousFocusRef.current)) try {
                previousFocusRef.current.focus({
                    preventScroll: true
                });
            } catch (error) {
            // ignore
            }
            previousFocusRef.current = null;
        };
    }, [
        targetRef,
        active
    ]);
}


function $3900059271368e63$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $3900059271368e63$export$2e2bcd8739ae039({ mode: mode }) {
    const { t: tDashboard, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const { t: tCharts } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("charts");
    const [editMode, setEditMode] = (0, $7fPBF.useState)(false); // all categories and "add new" buttons are visible
    const [calendar, setCalendarState] = (0, $7fPBF.useState)({
        visible: false,
        selectedDate: null,
        callback: null
    }); // calendar used to set the baseline for comparison to current net worth
    const [addAccountMode, setAddAccountMode] = (0, $7fPBF.useState)({
        visible: false,
        category: null,
        addAccountState: undefined
    }); // displays AddAccount, if addAccountState is present, it will be passed to its state
    const [account, setAccount] = (0, $7fPBF.useState)(null); // controls the visibility of the AccountDetails component, has account object, do not use to change account props
    const [projectId, setProjectId] = (0, $7fPBF.useState)(null); // do not try to replace it with project object, because it does not get updated when Redux changes (e.g. when project name gets updated)
    const [rebalancing, setRebalancing] = (0, $7fPBF.useState)(false); // controls the visibility of the Rebalancing component // FIXME
    const [kpiReportVisible, setKpiReportVisible] = (0, $7fPBF.useState)(false);
    const [settings, setSettings] = (0, $7fPBF.useState)(false); // truthy or true for settings visible or name of tab; false or falsey for settings hidden
    const [recommendUsVisible, setRecommendUsVisible] = (0, $7fPBF.useState)(false); // controls the visibility of the RecommendUs component
    const [searchControl, setSearchControl] = (0, $7fPBF.useState)({
        text: "",
        searching: false,
        focus: null
    }); // search results for the search bar;
    const [tiletip, setTiletip] = (0, $7fPBF.useState)(null); // holds the transaction object for the transaction preview
    // focus is true when either Input or Results are in focus; click on Results would otherwise cause onBlur on Input to fire and hide the results
    const [projectsLoading, setProjectsLoading] = (0, $7fPBF.useState)(false);
    const [fileReceived, setFileReceived] = (0, $7fPBF.useState)(false);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const baseCurrency = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.profile.settings.baseCurrency);
    const sliderDate = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.baseDate);
    const fullscreenReport = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.fullscreenReport);
    // ----------------------------------
    // SET DASHBOARD MODE BASED ON URL
    // ----------------------------------
    // set the state.simulation.dashboardMode to 'projects' as soon as the location turns /app/projects
    // and set it back to 'dashboard' when the location is anything else
    (0, $7fPBF.useEffect)(()=>{
        // set dashboard / project mode based on URL
        if (location.pathname === `/${i18n.language}/app/projects`) {
            setProjectsLoading(true);
            dispatch({
                type: "simulation/setDashboardMode",
                payload: {
                    dashboardMode: "projects"
                }
            });
            dispatch((0, $101425bdfe5b6af9$export$b00a271f69f3d728)()).then(()=>setProjectsLoading(false), ()=>setProjectsLoading(false));
            dispatch((0, $47d2e16a1696e57a$export$284f9e3210b39fb4)({
                newDate: null
            })); // this needs the slider base date as argument
        } else {
            dispatch((0, $101425bdfe5b6af9$export$b00a271f69f3d728)()); // needed for loans (connectedProjectId dialog)
            dispatch({
                type: "simulation/setDashboardMode",
                payload: {
                    dashboardMode: "dashboard"
                }
            });
        }
    }, [
        location.pathname
    ]);
    // ----------------------------------
    // READ LOCATION.STATE AND HANDLE IT
    // ----------------------------------
    (0, $7fPBF.useEffect)(()=>{
        // show AccountDetails (e.g. when redirected from /app/reports after the user clicks on a search result)
        if (location.state && location.state.account) setAccount(location.state.account);
        // handle addAccount workflow reentry after being redirected to the provider (navigated from AddAccountCallbackReceiver)
        // ↓↓ this would be present if the user presses browser back while in WebForm
        if (localStorage.getItem("addAccountState")) (0, $e4f4fda4de0cf2ab$export$eb09a3dde63b84a2)("addAccountState").then((addAccountState)=>{
            // console.log('storageObject', addAccountState);
            const modifiedState = (0, $9tqwB._)({}, addAccountState);
            // ↓↓ this flag is set by AddAccountCallbackReceiver, which pushes the displayedStep ahead by 1 to proceed with the workflow
            if (!modifiedState.doNotChangeDisplayedStep) modifiedState.displayedStep -= 1;
            // console.log('modifiedState', modifiedState);
            setAddAccountMode({
                visible: true,
                category: modifiedState.category,
                addAccountState: modifiedState
            });
        });
        // handle provider callback after the user has authorised the app for the subsequent time (navigate from AddAccountCallbackReceiver)
        if (location.state && location.state.renewAccountAccess) {
            const { renewAccountAccess: renewAccountAccess } = location.state;
            console.log("location.state.renewAccountAccess", location.state.renewAccountAccess);
            if (renewAccountAccess.cancelled) {
                dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("renewAccountAccessCancelled"));
                localStorage.removeItem("renewAccountAccess");
                return;
            }
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("renewAccountAccessSuccess"));
            // refresh the account data for entire category, we may have more than one account modified (if there were more than one account with the same provider)
            dispatch((0, $f1c3fa004749592f$export$dfb022681f1048bc)(renewAccountAccess.category));
            localStorage.removeItem("renewAccountAccess");
        }
    }, [
        location.state
    ]);
    // ----------------------------------
    // HANDLE postFile (MOBILE APP ONLY)
    // ----------------------------------
    const accounts = (0, $51238fa605392ada$export$2105062e25df4afe)((0, $93bb2798871a68d2$export$8c577782bb016c47));
    const selectCategoryStatus = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data, (data)=>Object.keys(data).map((category)=>({
                category: category,
                status: data[category].status
            })));
    const categoryStatus = (0, $51238fa605392ada$export$2105062e25df4afe)(selectCategoryStatus);
    async function getAllData() {
        const promises = (0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e).map((category)=>dispatch((0, $f1c3fa004749592f$export$dfb022681f1048bc)(category)));
        await Promise.all(promises);
    }
    // FIXME: this will have the state from the moment it was attached to window, not the current state
    // check how ref is used to work around that and reapply this here (it is crucial that setFileReceived is the current version of the component)
    // this is fired-and-forgot from the mobile app, but should wait for async bits inside when it is running here
    async function postFile(fileData, fileName) {
        if (!fileData || !fileName) {
            (0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("fileUploadError");
            console.error("postFile called without fileData or fileName");
            return;
        }
        function postFileCallback(accountIdName) {
            // open account details for the selected account
            const targetAccount = accounts.find((a)=>a.id === accountIdName.id);
            setAccount(targetAccount); // this will open AccountDetails which will already receive fileReceived as prop
        }
        setFileReceived({
            fileData: fileData,
            fileName: fileName
        }); // add file to state for AccountDetails later
        const accountList = accounts.filter((a)=>[
                "deposts",
                "stocks"
            ].includes(a.category)).map((a)=>({
                name: a.name,
                id: a.id
            }));
        // webview removes redux state under some conditions (while keeping the UI unchanged!), so we need to check if it is still there
        // if categories are all either idle or inactive, it means that redux has been reset
        if (categoryStatus.every((c)=>[
                "inactive",
                "idle"
            ].includes(c.status))) {
            // need to reload data
            console.log("need to reload data, running getAllData");
            await getAllData(); // FIXME does this have to get ALL data?
        // console.log('data reload completed', JSON.stringify(categoryStatus, null, 2));
        }
        // run dialog and ask which account is this for
        window.dispatchEvent(new CustomEvent("setDialog", {
            detail: {
                header: tDashboard("postFile.header"),
                prompt: tDashboard("postFile.prompt"),
                value: accountList[0],
                callback: postFileCallback,
                dropdown: accountList
            }
        }));
    }
    // mobileApp mode only
    // postFile must be re-exposed every time the state gets updated, otherwise it "remembers" the old state only (a la jSpreadsheet)
    // once loading is complete, send message to mobileApp (in mobileApp mode only)
    (0, $7fPBF.useEffect)(()=>{
        // 'idle' is the initial status for active accounts; 'inactive' is the initial status for inactive accounts
        // we need all accounts to be either 'success', 'error', 'inactive' to be able to deduce that getData is finished
        if (window.mobileApp && categoryStatus.every((c)=>[
                "success",
                "error",
                "inactive"
            ].includes(c.status))) {
            window.postFile = postFile;
            window.mobileApp.postMessage("dashboardReady");
        }
        return ()=>{
            window.postFile = null;
        };
    }, [
        categoryStatus
    ]);
    // settings === true: call Settings with no openOnTab (i.e. default tab)
    // settings is string: call Settings with the string
    // settings is falsey: do not call Settings
    const SettingsComponent = settings ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7015f341e5714ae$export$2e2bcd8739ae039), {
        closeCallback: ()=>setSettings(false),
        openOnTab: settings === true ? null : settings,
        calendarState: calendar,
        setCalendarState: setCalendarState,
        setSettings: setSettings
    }) : null;
    // holds between renders and returns the function
    // keep only one (last) month of each year and current month (this is an annual chart)
    // also used in SharedReportViewer - consider changing it there as well
    const topChartFilterCallback = (0, $7fPBF.useCallback)((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(10, "year")) && ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).month() === 11 || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().startOf("month"))), []);
    const topChartLayoutOptions = (0, $7fPBF.useMemo)(()=>({
            // holds between renders and returns the value
            startLabel: false,
            endLabel: false,
            margin: {
                top: 10,
                right: 20,
                bottom: 30,
                left: 20
            }
        }), []);
    const overlayActive = calendar.visible || addAccountMode.visible || account || projectId || fullscreenReport || settings || recommendUsVisible || rebalancing;
    const overlayIsDisplayed = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    overlayIsDisplayed.current = overlayActive;
    const dashboardInteractiveRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    (0, $afe0d39a1771c519$export$2e2bcd8739ae039)(dashboardInteractiveRef, overlayActive);
    // handle TransactionPreview on and off + handle keyboard shortcut for edit mode
    (0, $7fPBF.useEffect)(()=>{
        const handleShowTiletip = (event)=>{
            // all custom parameters come in event.detail
            if (event.detail === null) setTiletip(null);
            else setTiletip(event.detail);
        };
        window.addEventListener("showTransactionPreview", handleShowTiletip);
        // if user presses e, toggle edit mode
        const handleKeyDown = (event)=>{
            if (!overlayIsDisplayed.current && event.key === "e") setEditMode((prev)=>!prev);
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("showTransactionPreview", handleShowTiletip);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "",
        id: "dashboard-root",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "static",
            id: "dashboard-level-1",
            children: [
                calendar.visible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6bcdb96663edbf1$export$2e2bcd8739ae039), {
                    calendarState: calendar,
                    setCalendarState: setCalendarState
                }),
                addAccountMode.visible && ([
                    "pension"
                ].includes(addAccountMode.category) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8c4bb5f070778851$export$2e2bcd8739ae039), {
                    category: addAccountMode.category,
                    addModeState: addAccountMode,
                    setAddModeState: setAddAccountMode,
                    addAccountState: addAccountMode.addAccountState
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $325eda4246b652c5$export$2e2bcd8739ae039), {
                    category: addAccountMode.category,
                    addModeState: addAccountMode,
                    setAddModeState: setAddAccountMode,
                    addAccountState: addAccountMode.addAccountState
                })),
                account && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a29e09d640495533$export$2e2bcd8739ae039), {
                    account: account,
                    setAccount: setAccount,
                    fileReceived: fileReceived,
                    setFileReceived: setFileReceived
                }),
                projectId && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $04a7d16a2460515d$export$2e2bcd8739ae039), {
                    projectId: projectId,
                    setProjectId: setProjectId,
                    setCalendarState: setCalendarState
                }),
                fullscreenReport && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab6676e849ba8635$export$2e2bcd8739ae039), {
                    reportProps: fullscreenReport
                }),
                SettingsComponent,
                recommendUsVisible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1efa4a2a7158b1cd$export$2e2bcd8739ae039), {
                    setRecommendUsVisible: setRecommendUsVisible
                }),
                rebalancing && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f98434f7adc8890b$export$2e2bcd8739ae039), {
                    setRebalancing: setRebalancing,
                    closeCallback: ()=>setRebalancing(false)
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $28bd968d00880be4$export$2e2bcd8739ae039), {
                    tiletip: tiletip,
                    setTiletip: setTiletip
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    ref: dashboardInteractiveRef,
                    className: "relative min-h-full bg-gray-50",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a05383fb5bb0535$export$2e2bcd8739ae039), {
                            mode: mode,
                            openSettings: ()=>setSettings(true),
                            openAccount: ()=>setSettings("account"),
                            searchControl: searchControl,
                            setSearchControl: setSearchControl,
                            setRecommendUsVisible: setRecommendUsVisible
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                            className: $3900059271368e63$export$ce4ab0c55987d1ff("pb-8", mode === "dashboard" ? "-mt-12 lg:-mt-20" : "-mt-40 lg:-mt-56"),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-[100rem] lg:px-8",
                                children: [
                                    searchControl.text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e9d517aec5d290d$export$aee53da69e9839be), {
                                        searchControl: searchControl,
                                        setSearchControl: setSearchControl,
                                        setAccount: setAccount
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                        className: "sr-only",
                                        children: "Profile"
                                    }),
                                    mode === "projects" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "w-full h-28 lg:mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                className: "text-white text-sm font-bold mb-6 text-center uppercase tracking-wider",
                                                children: tDashboard("setDate")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $18cd6c5722416c98$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-2 md:gap-4 items-start lg:grid-cols-12 lg:gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $acdb9cfdc96986b7$export$2e2bcd8739ae039), {
                                                baseCurrency: baseCurrency,
                                                setKpiReportVisible: setKpiReportVisible,
                                                calendar: calendar,
                                                setCalendarState: setCalendarState,
                                                setAccountDetails: setAccount
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "grid grid-cols-1 gap-4 lg:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                                        "aria-labelledby": "accounts-control-panel",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "xs:overflow-hidden flex flex-wrap justify-between sm:grid sm:grid-cols-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                    className: "sr-only",
                                                                    id: "profile-overview-title",
                                                                    children: "Accounts Overview"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "py-4 px-0 sm:px-3 md:px-4 sm:col-span-2",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                        className: "flex gap-3 align-baseline",
                                                                        id: "oneaboveyourassets",
                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                                                                            className: "text-2xl sm:text-3xl md:text-4xl lg:text-3xl xl:text-4xl font-bold text-gray-900 lg:text-white",
                                                                            id: "your-assets",
                                                                            children: [
                                                                                tDashboard("yourAssets"),
                                                                                mode === "projects" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                                                    children: [
                                                                                        " ",
                                                                                        "in",
                                                                                        " ",
                                                                                        new Date(sliderDate).toLocaleDateString(i18n.language, {
                                                                                            month: "short",
                                                                                            timeZone: "UTC"
                                                                                        }).substring(0, 3),
                                                                                        " ",
                                                                                        new Date(sliderDate).toLocaleDateString(i18n.language, {
                                                                                            year: "numeric",
                                                                                            timeZone: "UTC"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d046df3216ed3caf$export$2e2bcd8739ae039), {
                                                                    editMode: editMode,
                                                                    setEditMode: setEditMode,
                                                                    getAllData: getAllData,
                                                                    mode: mode
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    (0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e).map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2343165816cf73bf$export$2e2bcd8739ae039), {
                                                            category: category,
                                                            editMode: editMode,
                                                            setEditMode: setEditMode,
                                                            addMode: addAccountMode,
                                                            setAddMode: setAddAccountMode,
                                                            setAccount: setAccount
                                                        }, category))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                className: "grid grid-cols-1 gap-4 lg:col-span-4 ",
                                                children: mode === "projects" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8fb6e0982c7673c9$export$2e2bcd8739ae039), {
                                                    setProjectId: setProjectId,
                                                    editMode: editMode,
                                                    projectsLoading: projectsLoading
                                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                                            "aria-labelledby": "chart-title",
                                                            className: "",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "relative rounded-md bg-white overflow-hidden shadow",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: "p-6 h-[32rem]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                            className: "text-base font-semibold text-gray-900 pb-4",
                                                                            id: "chart-top-title",
                                                                            children: tCharts("last12months")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                            className: "w-full h-[80%]",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                                                reportId: "assetBalancesOverTime",
                                                                                filterCallback: topChartFilterCallback,
                                                                                layoutOptions: topChartLayoutOptions
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                            className: "mt-6 mb-6 bg-white",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                                onClick: ()=>navigate(`/${i18n.language}/app/reports`),
                                                                                text: tCharts("goToReports"),
                                                                                noFrame: true,
                                                                                size: "xl",
                                                                                formatting: "w-full bg-white"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                                            "aria-labelledby": "chart-title",
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "rounded-md bg-white overflow-hidden shadow z-10",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: "p-6 h-[32rem]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                            className: "mb-6 text-base font-semibold text-gray-900",
                                                                            id: "chart-bottom-title",
                                                                            children: tCharts("currentAllocation")
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                            className: "w-full h-[80%]",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c452aa40845053fb$export$2e2bcd8739ae039), {
                                                                                reportId: "allAssetsSunburstxxxx"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                            className: "mb-6 flex space-x-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                                    onClick: ()=>setRebalancing(true),
                                                                                    text: tCharts("rebalancing"),
                                                                                    noFrame: true,
                                                                                    size: "xl",
                                                                                    formatting: "w-full bg-white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                                    onClick: ()=>navigate(`/${i18n.language}/app/reports`),
                                                                                    text: tCharts("goToReports"),
                                                                                    noFrame: true,
                                                                                    size: "xl",
                                                                                    formatting: "w-full bg-white"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75977f0ca8247e66$export$2e2bcd8739ae039), {
                            componentName: "dashboard"
                        })
                    ]
                })
            ]
        })
    });
}
$3900059271368e63$export$2e2bcd8739ae039.propTypes = {
    mode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
$3900059271368e63$export$2e2bcd8739ae039.defaultProps = {
    mode: "dashboard"
};


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-restricted-syntax */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");












/* eslint-disable max-len */ /* eslint-disable func-names */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/no-unstable-nested-components */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable react/jsx-no-bind */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");


var $2oXYc = parcelRequire("2oXYc");



var $f455ece61e3e4c07$exports = {};
"use strict";
Object.defineProperty($f455ece61e3e4c07$exports, "__esModule", {
    value: true
});
$f455ece61e3e4c07$exports.Dropdown = $f455ece61e3e4c07$exports.DraggableAttribute = undefined;
var $f455ece61e3e4c07$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f455ece61e3e4c07$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $f455ece61e3e4c07$var$_react2 = $f455ece61e3e4c07$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $f455ece61e3e4c07$var$_propTypes2 = $f455ece61e3e4c07$var$_interopRequireDefault($2oXYc);
var $5c488a0ae7038a3f$exports = {};
var $7463ec9ff5b588fd$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $7463ec9ff5b588fd$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$7463ec9ff5b588fd$exports = $7463ec9ff5b588fd$var$invariant;


var $5c488a0ae7038a3f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5c488a0ae7038a3f$var$splice = Array.prototype.splice;
var $5c488a0ae7038a3f$var$toString = Object.prototype.toString;
var $5c488a0ae7038a3f$var$type = function(obj) {
    return $5c488a0ae7038a3f$var$toString.call(obj).slice(8, -1);
};
var $5c488a0ae7038a3f$var$assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
    $5c488a0ae7038a3f$var$getAllKeys(source).forEach(function(key) {
        if ($5c488a0ae7038a3f$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var $5c488a0ae7038a3f$var$getAllKeys = typeof Object.getOwnPropertySymbols === "function" ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ function(obj) {
    return Object.keys(obj);
};
/* istanbul ignore next */ function $5c488a0ae7038a3f$var$copy(object) {
    if (Array.isArray(object)) return $5c488a0ae7038a3f$var$assign(object.constructor(object.length), object);
    else if ($5c488a0ae7038a3f$var$type(object) === "Map") return new Map(object);
    else if ($5c488a0ae7038a3f$var$type(object) === "Set") return new Set(object);
    else if (object && typeof object === "object") {
        var prototype = Object.getPrototypeOf(object);
        return $5c488a0ae7038a3f$var$assign(Object.create(prototype), object);
    } else return object;
}
function $5c488a0ae7038a3f$var$newContext() {
    var commands = $5c488a0ae7038a3f$var$assign({}, $5c488a0ae7038a3f$var$defaultCommands);
    update.extend = function(directive, fn) {
        commands[directive] = fn;
    };
    update.isEquals = function(a, b) {
        return a === b;
    };
    return update;
    function update(object, spec) {
        if (typeof spec === "function") spec = {
            $apply: spec
        };
        if (!(Array.isArray(object) && Array.isArray(spec))) $7463ec9ff5b588fd$exports(!Array.isArray(spec), "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.");
        $7463ec9ff5b588fd$exports(typeof spec === "object" && spec !== null, "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the following commands: %s.", Object.keys(commands).join(", "));
        var nextObject = object;
        var index, key;
        $5c488a0ae7038a3f$var$getAllKeys(spec).forEach(function(key) {
            if ($5c488a0ae7038a3f$var$hasOwnProperty.call(commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && update.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = $5c488a0ae7038a3f$var$type(object) === "Map" ? update(object.get(key), spec[key]) : update(object[key], spec[key]);
                var nextObjectValue = $5c488a0ae7038a3f$var$type(nextObject) === "Map" ? nextObject.get(key) : nextObject[key];
                if (!update.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === "undefined" && !$5c488a0ae7038a3f$var$hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = $5c488a0ae7038a3f$var$copy(object);
                    if ($5c488a0ae7038a3f$var$type(nextObject) === "Map") nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    }
}
var $5c488a0ae7038a3f$var$defaultCommands = {
    $push: function(value, nextObject, spec) {
        $5c488a0ae7038a3f$var$invariantPushAndUnshift(nextObject, spec, "$push");
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        $5c488a0ae7038a3f$var$invariantPushAndUnshift(nextObject, spec, "$unshift");
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        $5c488a0ae7038a3f$var$invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            $5c488a0ae7038a3f$var$invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = $5c488a0ae7038a3f$var$copy(originalObject);
            $5c488a0ae7038a3f$var$splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, nextObject, spec) {
        $5c488a0ae7038a3f$var$invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        $5c488a0ae7038a3f$var$invariantSpecArray(targets, "$toggle");
        var nextObjectCopy = targets.length ? $5c488a0ae7038a3f$var$copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, spec, originalObject) {
        $5c488a0ae7038a3f$var$invariantSpecArray(value, "$unset");
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = $5c488a0ae7038a3f$var$copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(value, nextObject, spec, originalObject) {
        $5c488a0ae7038a3f$var$invariantMapOrSet(nextObject, "$add");
        $5c488a0ae7038a3f$var$invariantSpecArray(value, "$add");
        if ($5c488a0ae7038a3f$var$type(nextObject) === "Map") value.forEach(function(pair) {
            var key = pair[0];
            var value = pair[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = $5c488a0ae7038a3f$var$copy(originalObject);
            nextObject.set(key, value);
        });
        else value.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = $5c488a0ae7038a3f$var$copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, spec, originalObject) {
        $5c488a0ae7038a3f$var$invariantMapOrSet(nextObject, "$remove");
        $5c488a0ae7038a3f$var$invariantSpecArray(value, "$remove");
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = $5c488a0ae7038a3f$var$copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, spec, originalObject) {
        $5c488a0ae7038a3f$var$invariantMerge(nextObject, value);
        $5c488a0ae7038a3f$var$getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = $5c488a0ae7038a3f$var$copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        $5c488a0ae7038a3f$var$invariantApply(value);
        return value(original);
    }
};
var $5c488a0ae7038a3f$var$contextForExport = $5c488a0ae7038a3f$var$newContext();
$5c488a0ae7038a3f$exports = $5c488a0ae7038a3f$var$contextForExport;
$5c488a0ae7038a3f$exports.default = $5c488a0ae7038a3f$var$contextForExport;
$5c488a0ae7038a3f$exports.newContext = $5c488a0ae7038a3f$var$newContext;
// invariants
function $5c488a0ae7038a3f$var$invariantPushAndUnshift(value, spec, command) {
    $7463ec9ff5b588fd$exports(Array.isArray(value), "update(): expected target of %s to be an array; got %s.", command, value);
    $5c488a0ae7038a3f$var$invariantSpecArray(spec[command], command);
}
function $5c488a0ae7038a3f$var$invariantSpecArray(spec, command) {
    $7463ec9ff5b588fd$exports(Array.isArray(spec), "update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?", command, spec);
}
function $5c488a0ae7038a3f$var$invariantSplices(value, spec) {
    $7463ec9ff5b588fd$exports(Array.isArray(value), "Expected $splice target to be an array; got %s", value);
    $5c488a0ae7038a3f$var$invariantSplice(spec["$splice"]);
}
function $5c488a0ae7038a3f$var$invariantSplice(value) {
    $7463ec9ff5b588fd$exports(Array.isArray(value), "update(): expected spec of $splice to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?", value);
}
function $5c488a0ae7038a3f$var$invariantApply(fn) {
    $7463ec9ff5b588fd$exports(typeof fn === "function", "update(): expected spec of $apply to be a function; got %s.", fn);
}
function $5c488a0ae7038a3f$var$invariantSet(spec) {
    $7463ec9ff5b588fd$exports(Object.keys(spec).length === 1, "Cannot have more than one key in an object with $set");
}
function $5c488a0ae7038a3f$var$invariantMerge(target, specValue) {
    $7463ec9ff5b588fd$exports(specValue && typeof specValue === "object", "update(): $merge expects a spec of type 'object'; got %s", specValue);
    $7463ec9ff5b588fd$exports(target && typeof target === "object", "update(): $merge expects a target of type 'object'; got %s", target);
}
function $5c488a0ae7038a3f$var$invariantMapOrSet(target, command) {
    var typeOfTarget = $5c488a0ae7038a3f$var$type(target);
    $7463ec9ff5b588fd$exports(typeOfTarget === "Map" || typeOfTarget === "Set", "update(): %s expects a target of type Set or Map; got %s", command, typeOfTarget);
}


var $f455ece61e3e4c07$var$_immutabilityHelper2 = $f455ece61e3e4c07$var$_interopRequireDefault($5c488a0ae7038a3f$exports);

var $f455ece61e3e4c07$var$_dayjs2 = $f455ece61e3e4c07$var$_interopRequireDefault($615652efb7481f32$exports);
var $7e6577998ba0636b$exports = {};
!function(t, n) {
    $7e6577998ba0636b$exports = n();
}($7e6577998ba0636b$exports, function() {
    "use strict";
    var t = "month", n = "quarter";
    return function(e, i) {
        var r = i.prototype;
        r.quarter = function(t) {
            return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
        };
        var s = r.add;
        r.add = function(e, i) {
            return e = Number(e), this.$utils().p(i) === n ? this.add(3 * e, t) : s.bind(this)(e, i);
        };
        var u = r.startOf;
        r.startOf = function(e, i) {
            var r = this.$utils(), s = !!r.u(i) || i;
            if (r.p(e) === n) {
                var o = this.quarter() - 1;
                return s ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
            }
            return u.bind(this)(e, i);
        };
    };
});


var $f455ece61e3e4c07$var$_quarterOfYear2 = $f455ece61e3e4c07$var$_interopRequireDefault($7e6577998ba0636b$exports);


var $f455ece61e3e4c07$var$_PivotTable2 = $f455ece61e3e4c07$var$_interopRequireDefault($a66f03c34074fce6$exports);
var $49c5c5297ff65afa$exports = {};
"use strict";
var $6f773b4de7968909$exports = {};
"use strict";
Object.defineProperty($6f773b4de7968909$exports, "__esModule", {
    value: true
});
$6f773b4de7968909$exports.default = void 0;

var $6f773b4de7968909$var$_propTypes = $6f773b4de7968909$var$_interopRequireDefault((parcelRequire("2oXYc")));

var $6f773b4de7968909$var$_react = $6f773b4de7968909$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $6f773b4de7968909$var$_sortablejs = $6f773b4de7968909$var$_interopRequireDefault((parcelRequire("hHQoE")));
function $6f773b4de7968909$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $6f773b4de7968909$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f773b4de7968909$var$_extends() {
    $6f773b4de7968909$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f773b4de7968909$var$_extends.apply(this, arguments);
}
function $6f773b4de7968909$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6f773b4de7968909$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6f773b4de7968909$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6f773b4de7968909$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6f773b4de7968909$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6f773b4de7968909$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6f773b4de7968909$var$_typeof(obj);
}
function $6f773b4de7968909$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $6f773b4de7968909$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $6f773b4de7968909$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6f773b4de7968909$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6f773b4de7968909$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6f773b4de7968909$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6f773b4de7968909$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6f773b4de7968909$var$_possibleConstructorReturn(self, call) {
    if (call && ($6f773b4de7968909$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6f773b4de7968909$var$_assertThisInitialized(self);
}
function $6f773b4de7968909$var$_getPrototypeOf(o) {
    $6f773b4de7968909$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6f773b4de7968909$var$_getPrototypeOf(o);
}
function $6f773b4de7968909$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6f773b4de7968909$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6f773b4de7968909$var$_setPrototypeOf(subClass, superClass);
}
function $6f773b4de7968909$var$_setPrototypeOf(o, p) {
    $6f773b4de7968909$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6f773b4de7968909$var$_setPrototypeOf(o, p);
}
function $6f773b4de7968909$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6f773b4de7968909$var$store = {
    nextSibling: null,
    activeComponent: null
};
var $6f773b4de7968909$var$Sortable = /*#__PURE__*/ function(_Component) {
    $6f773b4de7968909$var$_inherits(Sortable, _Component);
    function Sortable() {
        var _getPrototypeOf2;
        var _this;
        $6f773b4de7968909$var$_classCallCheck(this, Sortable);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6f773b4de7968909$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6f773b4de7968909$var$_getPrototypeOf(Sortable)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6f773b4de7968909$var$_defineProperty($6f773b4de7968909$var$_assertThisInitialized(_this), "sortable", null);
        return _this;
    }
    $6f773b4de7968909$var$_createClass(Sortable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var options = $6f773b4de7968909$var$_objectSpread({}, this.props.options);
                [
                    "onChoose",
                    "onStart",
                    "onEnd",
                    "onAdd",
                    "onUpdate",
                    "onSort",
                    "onRemove",
                    "onFilter",
                    "onMove",
                    "onClone"
                ].forEach(function(name) {
                    var eventHandler = options[name];
                    options[name] = function() {
                        for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
                        var evt = params[0];
                        if (name === "onChoose") {
                            $6f773b4de7968909$var$store.nextSibling = evt.item.nextElementSibling;
                            $6f773b4de7968909$var$store.activeComponent = _this2;
                        } else if ((name === "onAdd" || name === "onUpdate") && _this2.props.onChange) {
                            var items = _this2.sortable.toArray();
                            var remote = $6f773b4de7968909$var$store.activeComponent;
                            var remoteItems = remote.sortable.toArray();
                            var referenceNode = $6f773b4de7968909$var$store.nextSibling && $6f773b4de7968909$var$store.nextSibling.parentNode !== null ? $6f773b4de7968909$var$store.nextSibling : null;
                            evt.from.insertBefore(evt.item, referenceNode);
                            if (remote !== _this2) {
                                var remoteOptions = remote.props.options || {};
                                if ($6f773b4de7968909$var$_typeof(remoteOptions.group) === "object" && remoteOptions.group.pull === "clone") // Remove the node with the same data-reactid
                                evt.item.parentNode.removeChild(evt.item);
                                remote.props.onChange && remote.props.onChange(remoteItems, remote.sortable, evt);
                            }
                            _this2.props.onChange && _this2.props.onChange(items, _this2.sortable, evt);
                        }
                        if (evt.type === "move") {
                            var _evt = params[0], originalEvent = params[1];
                            var canMove = eventHandler ? eventHandler(_evt, originalEvent) : true;
                            return canMove;
                        }
                        setTimeout(function() {
                            eventHandler && eventHandler(evt);
                        }, 0);
                    };
                });
                this.sortable = $6f773b4de7968909$var$_sortablejs.default.create(this.node, options);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                // If onChange is null, it is an UnControlled component
                // Don't let React re-render it by setting return to false
                if (!nextProps.onChange) return false;
                return true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.sortable) {
                    this.sortable.destroy();
                    this.sortable = null;
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props = this.props, Component = _this$props.tag, options = _this$props.options, onChange = _this$props.onChange, props = $6f773b4de7968909$var$_objectWithoutProperties(_this$props, [
                    "tag",
                    "options",
                    "onChange"
                ]);
                return $6f773b4de7968909$var$_react.default.createElement(Component, $6f773b4de7968909$var$_extends({}, props, {
                    ref: function ref(node) {
                        _this3.node = node;
                    }
                }));
            }
        }
    ]);
    return Sortable;
}($6f773b4de7968909$var$_react.Component);
$6f773b4de7968909$var$_defineProperty($6f773b4de7968909$var$Sortable, "propTypes", {
    options: $6f773b4de7968909$var$_propTypes.default.object,
    onChange: $6f773b4de7968909$var$_propTypes.default.func,
    tag: $6f773b4de7968909$var$_propTypes.default.oneOfType([
        $6f773b4de7968909$var$_propTypes.default.string,
        $6f773b4de7968909$var$_propTypes.default.func
    ]),
    style: $6f773b4de7968909$var$_propTypes.default.object
});
$6f773b4de7968909$var$_defineProperty($6f773b4de7968909$var$Sortable, "defaultProps", {
    options: {},
    tag: "div",
    style: {}
});
var $6f773b4de7968909$var$_default = $6f773b4de7968909$var$Sortable;
$6f773b4de7968909$exports.default = $6f773b4de7968909$var$_default;


var $49c5c5297ff65afa$require$Sortable = $6f773b4de7968909$exports.default;
$49c5c5297ff65afa$exports = $49c5c5297ff65afa$require$Sortable;


var $f455ece61e3e4c07$var$_reactSortablejs2 = $f455ece61e3e4c07$var$_interopRequireDefault($49c5c5297ff65afa$exports);
var $742bd248c4cf09b3$exports = {};


(function(global, factory) {
    $742bd248c4cf09b3$exports = factory((parcelRequire("fw0lo")), (parcelRequire("7fPBF")));
})($742bd248c4cf09b3$exports, function(ReactDOM, React) {
    "use strict";
    ReactDOM = ReactDOM && ReactDOM.hasOwnProperty("default") ? ReactDOM["default"] : ReactDOM;
    React = React && React.hasOwnProperty("default") ? React["default"] : React;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */ function makeEmptyFunction(arg) {
        return function() {
            return arg;
        };
    }
    /**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */ var emptyFunction = function emptyFunction() {};
    emptyFunction.thatReturns = makeEmptyFunction;
    emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
    emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
    emptyFunction.thatReturnsNull = makeEmptyFunction(null);
    emptyFunction.thatReturnsThis = function() {
        return this;
    };
    emptyFunction.thatReturnsArgument = function(arg) {
        return arg;
    };
    var emptyFunction_1 = emptyFunction;
    /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */ /**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */ var validateFormat = function validateFormat(format) {};
    validateFormat = function validateFormat(format) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    };
    function invariant(condition, format, a, b, c, d, e, f) {
        validateFormat(format);
        if (!condition) {
            var error;
            if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                error = new Error(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
                error.name = "Invariant Violation";
            }
            error.framesToPop = 1; // we don't care about invariant's own frame
            throw error;
        }
    }
    var invariant_1 = invariant;
    /**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */ var warning = emptyFunction_1;
    var printWarning = function printWarning(format) {
        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function warning(condition, format) {
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (format.indexOf("Failed Composite propType: ") === 0) return; // Ignore CompositeComponent proptype check.
        if (!condition) {
            for(var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
            printWarning.apply(undefined, [
                format
            ].concat(args));
        }
    };
    var warning_1 = warning;
    /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
        if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(val);
    }
    function shouldUseNative() {
        try {
            if (!Object.assign) return false;
            // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
            test1[5] = "de";
            if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
            var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
                return test2[n];
            });
            if (order2.join("") !== "0123456789") return false;
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
            return true;
        } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
        }
    }
    var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for(var s = 1; s < arguments.length; s++){
            from = Object(arguments[s]);
            for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
            }
        }
        return to;
    };
    /**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    var ReactPropTypesSecret_1 = ReactPropTypesSecret;
    var invariant$1 = invariant_1;
    var warning$1 = warning_1;
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    /**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
        for(var typeSpecName in typeSpecs)if (typeSpecs.hasOwnProperty(typeSpecName)) {
            var error;
            // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                invariant$1(typeof typeSpecs[typeSpecName] === "function", "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]);
                error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
            } catch (ex) {
                error = ex;
            }
            warning$1(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error);
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error.message] = true;
                var stack = getStack ? getStack() : "";
                warning$1(false, "Failed %s type: %s%s", location, error.message, stack != null ? stack : "");
            }
        }
    }
    var checkPropTypes_1 = checkPropTypes;
    var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
        /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
        /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */ function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
            if (typeof iteratorFn === "function") return iteratorFn;
        }
        /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */ var ANONYMOUS = "<<anonymous>>";
        // Important!
        // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
        var ReactPropTypes = {
            array: createPrimitiveTypeChecker("array"),
            bool: createPrimitiveTypeChecker("boolean"),
            func: createPrimitiveTypeChecker("function"),
            number: createPrimitiveTypeChecker("number"),
            object: createPrimitiveTypeChecker("object"),
            string: createPrimitiveTypeChecker("string"),
            symbol: createPrimitiveTypeChecker("symbol"),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
        };
        /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */ /*eslint-disable no-self-compare*/ function is(x, y) {
            // SameValue algorithm
            if (x === y) // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            return x !== 0 || 1 / x === 1 / y;
            else // Step 6.a: NaN == NaN
            return x !== x && y !== y;
        }
        /*eslint-enable no-self-compare*/ /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */ function PropTypeError(message) {
            this.message = message;
            this.stack = "";
        }
        // Make `instanceof Error` still work for returned errors.
        PropTypeError.prototype = Error.prototype;
        function createChainableTypeChecker(validate) {
            var manualPropTypeCallCache = {};
            var manualPropTypeWarningCount = 0;
            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                componentName = componentName || ANONYMOUS;
                propFullName = propFullName || propName;
                if (secret !== ReactPropTypesSecret_1) {
                    if (throwOnDirectAccess) // New behavior only for users of `prop-types` package
                    invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    else if (typeof console !== "undefined") {
                        // Old behavior for people using React.PropTypes
                        var cacheKey = componentName + ":" + propName;
                        if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                        manualPropTypeWarningCount < 3) {
                            warning_1(false, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName);
                            manualPropTypeCallCache[cacheKey] = true;
                            manualPropTypeWarningCount++;
                        }
                    }
                }
                if (props[propName] == null) {
                    if (isRequired) {
                        if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                        return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                    }
                    return null;
                } else return validate(props, propName, componentName, location, propFullName);
            }
            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
        }
        function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== expectedType) {
                    // `propValue` being instance of, say, date/regexp, pass the 'object'
                    // check, but we can offer a more precise error message here rather than
                    // 'of type `object`'.
                    var preciseType = getPreciseType(propValue);
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
        }
        function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
                if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                var propValue = props[propName];
                if (!Array.isArray(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
                }
                for(var i = 0; i < propValue.length; i++){
                    var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret_1);
                    if (error instanceof Error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                if (!isValidElement(propValue)) {
                    var propType = getPropType(propValue);
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
                if (!(props[propName] instanceof expectedClass)) {
                    var expectedClassName = expectedClass.name || ANONYMOUS;
                    var actualClassName = getClassName(props[propName]);
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) {
                warning_1(false, "Invalid argument supplied to oneOf, expected an instance of array.");
                return emptyFunction_1.thatReturnsNull;
            }
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                for(var i = 0; i < expectedValues.length; i++){
                    if (is(propValue, expectedValues[i])) return null;
                }
                var valuesString = JSON.stringify(expectedValues);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
            }
            return createChainableTypeChecker(validate);
        }
        function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
                if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
                for(var key in propValue)if (propValue.hasOwnProperty(key)) {
                    var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_1);
                    if (error instanceof Error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) {
                warning_1(false, "Invalid argument supplied to oneOfType, expected an instance of array.");
                return emptyFunction_1.thatReturnsNull;
            }
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                if (typeof checker !== "function") {
                    warning_1(false, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i);
                    return emptyFunction_1.thatReturnsNull;
                }
            }
            function validate(props, propName, componentName, location, propFullName) {
                for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                    var checker = arrayOfTypeCheckers[i];
                    if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) return null;
                }
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`."));
            }
            return createChainableTypeChecker(validate);
        }
        function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
                if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                for(var key in shapeTypes){
                    var checker = shapeTypes[key];
                    if (!checker) continue;
                    var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_1);
                    if (error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
                var propValue = props[propName];
                var propType = getPropType(propValue);
                if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
                // We need to check all keys in case some are required but missing from
                // props.
                var allKeys = objectAssign({}, props[propName], shapeTypes);
                for(var key in allKeys){
                    var checker = shapeTypes[key];
                    if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                    var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_1);
                    if (error) return error;
                }
                return null;
            }
            return createChainableTypeChecker(validate);
        }
        function isNode(propValue) {
            switch(typeof propValue){
                case "number":
                case "string":
                case "undefined":
                    return true;
                case "boolean":
                    return !propValue;
                case "object":
                    if (Array.isArray(propValue)) return propValue.every(isNode);
                    if (propValue === null || isValidElement(propValue)) return true;
                    var iteratorFn = getIteratorFn(propValue);
                    if (iteratorFn) {
                        var iterator = iteratorFn.call(propValue);
                        var step;
                        if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                            if (!isNode(step.value)) return false;
                        }
                        else // Iterator will provide entry [k,v] tuples rather than values.
                        while(!(step = iterator.next()).done){
                            var entry = step.value;
                            if (entry) {
                                if (!isNode(entry[1])) return false;
                            }
                        }
                    } else return false;
                    return true;
                default:
                    return false;
            }
        }
        function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === "symbol") return true;
            // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
            if (propValue["@@toStringTag"] === "Symbol") return true;
            // Fallback for non-spec compliant Symbols which are polyfilled.
            if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
            return false;
        }
        // Equivalent of `typeof` but with special handling for array and regexp.
        function getPropType(propValue) {
            var propType = typeof propValue;
            if (Array.isArray(propValue)) return "array";
            if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
            // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
            // passes PropTypes.object.
            return "object";
            if (isSymbol(propType, propValue)) return "symbol";
            return propType;
        }
        // This handles more types than `getPropType`. Only used for error messages.
        // See `createPrimitiveTypeChecker`.
        function getPreciseType(propValue) {
            if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
            var propType = getPropType(propValue);
            if (propType === "object") {
                if (propValue instanceof Date) return "date";
                else if (propValue instanceof RegExp) return "regexp";
            }
            return propType;
        }
        // Returns a string that is postfixed to a warning about an invalid type.
        // For example, "undefined" or "of type array"
        function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);
            switch(type){
                case "array":
                case "object":
                    return "an " + type;
                case "boolean":
                case "date":
                case "regexp":
                    return "a " + type;
                default:
                    return type;
            }
        }
        // Returns class name of the object, if any.
        function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
            return propValue.constructor.name;
        }
        ReactPropTypes.checkPropTypes = checkPropTypes_1;
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    var propTypes = createCommonjsModule(function(module1) {
        var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
        var isValidElement = function(object) {
            return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        };
        // By explicitly using `prop-types` you are opting into new development behavior.
        // http://fb.me/prop-types-in-prod
        var throwOnDirectAccess = true;
        module1.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
    });
    var classnames = createCommonjsModule(function(module1) {
        /*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/ /* global define */ (function() {
            var hasOwn = {}.hasOwnProperty;
            function classNames() {
                var classes = [];
                for(var i = 0; i < arguments.length; i++){
                    var arg = arguments[i];
                    if (!arg) continue;
                    var argType = typeof arg;
                    if (argType === "string" || argType === "number") classes.push(arg);
                    else if (Array.isArray(arg)) classes.push(classNames.apply(null, arg));
                    else if (argType === "object") {
                        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                    }
                }
                return classes.join(" ");
            }
            if (0, module1.exports) module1.exports = classNames;
            else window.classNames = classNames;
        })();
    });
    // @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
    function findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
        for(var i = 0, length = array.length; i < length; i++){
            if (callback.apply(callback, [
                array[i],
                i,
                array
            ])) return array[i];
        }
    }
    function isFunction(func /*: any*/ ) /*: boolean*/ {
        return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
    }
    function isNum(num /*: any*/ ) /*: boolean*/ {
        return typeof num === "number" && !isNaN(num);
    }
    function int(a /*: string*/ ) /*: number*/ {
        return parseInt(a, 10);
    }
    function dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) {
        if (props[propName]) return new Error("Invalid prop " + propName + " passed to " + componentName + " - do not set this, set it on the child.");
    }
    var prefixes = [
        "Moz",
        "Webkit",
        "O",
        "ms"
    ];
    function getPrefix() /*: string*/ {
        var prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
        // Checking specifically for 'window.document' is for pseudo-browser server-side
        // environments that define 'window' as the global context.
        // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
        if (typeof window === "undefined" || typeof window.document === "undefined") return "";
        var style = window.document.documentElement.style;
        if (prop in style) return "";
        for(var i = 0; i < prefixes.length; i++){
            if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
        }
        return "";
    }
    function browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
        return prefix ? "" + prefix + kebabToTitleCase(prop) : prop;
    }
    function kebabToTitleCase(str /*: string*/ ) /*: string*/ {
        var out = "";
        var shouldCapitalize = true;
        for(var i = 0; i < str.length; i++){
            if (shouldCapitalize) {
                out += str[i].toUpperCase();
                shouldCapitalize = false;
            } else if (str[i] === "-") shouldCapitalize = true;
            else out += str[i];
        }
        return out;
    }
    // Default export is the prefix itself, like 'Moz', 'Webkit', etc
    // Note that you may have to re-test for certain things; for instance, Chrome 50
    // can handle unprefixed `transform`, but not unprefixed `user-select`
    var browserPrefix = getPrefix();
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var defineProperty = function(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    };
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var inherits = function(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    var possibleConstructorReturn = function(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    /*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ var matchesSelectorFunc = "";
    function matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
        if (!matchesSelectorFunc) matchesSelectorFunc = findInArray([
            "matches",
            "webkitMatchesSelector",
            "mozMatchesSelector",
            "msMatchesSelector",
            "oMatchesSelector"
        ], function(method) {
            // $FlowIgnore: Doesn't think elements are indexable
            return isFunction(el[method]);
        });
        // Might not be found entirely (not an Element?) - in that case, bail
        // $FlowIgnore: Doesn't think elements are indexable
        if (!isFunction(el[matchesSelectorFunc])) return false;
        // $FlowIgnore: Doesn't think elements are indexable
        return el[matchesSelectorFunc](selector);
    }
    // Works up the tree to the draggable itself attempting to match selector.
    function matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
        var node = el;
        do {
            if (matchesSelector(node, selector)) return true;
            if (node === baseNode) return false;
            node = node.parentNode;
        }while (node);
        return false;
    }
    function addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ ) /*: void*/ {
        if (!el) return;
        if (el.attachEvent) el.attachEvent("on" + event, handler);
        else if (el.addEventListener) el.addEventListener(event, handler, true);
        else // $FlowIgnore: Doesn't think elements are indexable
        el["on" + event] = handler;
    }
    function removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ ) /*: void*/ {
        if (!el) return;
        if (el.detachEvent) el.detachEvent("on" + event, handler);
        else if (el.removeEventListener) el.removeEventListener(event, handler, true);
        else // $FlowIgnore: Doesn't think elements are indexable
        el["on" + event] = null;
    }
    function outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
        // This is deliberately excluding margin for our calculations, since we are using
        // offsetTop which is including margin. See getBoundPosition
        var height = node.clientHeight;
        var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
        height += int(computedStyle.borderTopWidth);
        height += int(computedStyle.borderBottomWidth);
        return height;
    }
    function outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
        // This is deliberately excluding margin for our calculations, since we are using
        // offsetLeft which is including margin. See getBoundPosition
        var width = node.clientWidth;
        var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
        width += int(computedStyle.borderLeftWidth);
        width += int(computedStyle.borderRightWidth);
        return width;
    }
    function innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
        var height = node.clientHeight;
        var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
        height -= int(computedStyle.paddingTop);
        height -= int(computedStyle.paddingBottom);
        return height;
    }
    function innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
        var width = node.clientWidth;
        var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
        width -= int(computedStyle.paddingLeft);
        width -= int(computedStyle.paddingRight);
        return width;
    }
    // Get from offsetParent
    function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/ , offsetParent /*: HTMLElement*/ ) /*: ControlPosition*/ {
        var isBody = offsetParent === offsetParent.ownerDocument.body;
        var offsetParentRect = isBody ? {
            left: 0,
            top: 0
        } : offsetParent.getBoundingClientRect();
        var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
        var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
        return {
            x: x,
            y: y
        };
    }
    function createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
        var translation = getTranslation(controlPos, positionOffset, "px");
        return defineProperty({}, browserPrefixToKey("transform", browserPrefix), translation);
    }
    function createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
        var translation = getTranslation(controlPos, positionOffset, "");
        return translation;
    }
    function getTranslation(_ref2, positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
        var x = _ref2.x, y = _ref2.y;
        var translation = "translate(" + x + unitSuffix + "," + y + unitSuffix + ")";
        if (positionOffset) {
            var defaultX = "" + (typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
            var defaultY = "" + (typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
            translation = "translate(" + defaultX + ", " + defaultY + ")" + translation;
        }
        return translation;
    }
    function getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
        return e.targetTouches && findInArray(e.targetTouches, function(t) {
            return identifier === t.identifier;
        }) || e.changedTouches && findInArray(e.changedTouches, function(t) {
            return identifier === t.identifier;
        });
    }
    function getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
        if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
        if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
    }
    // User-select Hacks:
    //
    // Useful for preventing blue highlights all over everything when dragging.
    // Note we're passing `document` b/c we could be iframed
    function addUserSelectStyles(doc /*: ?Document*/ ) {
        if (!doc) return;
        var styleEl = doc.getElementById("react-draggable-style-el");
        if (!styleEl) {
            styleEl = doc.createElement("style");
            styleEl.type = "text/css";
            styleEl.id = "react-draggable-style-el";
            styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
            styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
            doc.getElementsByTagName("head")[0].appendChild(styleEl);
        }
        if (doc.body) addClassName(doc.body, "react-draggable-transparent-selection");
    }
    function removeUserSelectStyles(doc /*: ?Document*/ ) {
        try {
            if (doc && doc.body) removeClassName(doc.body, "react-draggable-transparent-selection");
            // $FlowIgnore: IE
            if (doc.selection) // $FlowIgnore: IE
            doc.selection.empty();
            else window.getSelection().removeAllRanges(); // remove selection caused by scroll
        } catch (e) {
        // probably IE
        }
    }
    function styleHacks() /*: Object*/ {
        var childStyle /*: Object*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Workaround IE pointer events; see #51
        // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
        return _extends({
            touchAction: "none"
        }, childStyle);
    }
    function addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
        if (el.classList) el.classList.add(className);
        else if (!el.className.match(new RegExp("(?:^|\\s)" + className + "(?!\\S)"))) el.className += " " + className;
    }
    function removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
        if (el.classList) el.classList.remove(className);
        else el.className = el.className.replace(new RegExp("(?:^|\\s)" + className + "(?!\\S)", "g"), "");
    }
    /*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
        // If no bounds, short-circuit and move on
        if (!draggable.props.bounds) return [
            x,
            y
        ];
        // Clone new bounds
        var bounds = draggable.props.bounds;
        bounds = typeof bounds === "string" ? bounds : cloneBounds(bounds);
        var node = findDOMNode(draggable);
        if (typeof bounds === "string") {
            var ownerDocument = node.ownerDocument;
            var ownerWindow = ownerDocument.defaultView;
            var boundNode = void 0;
            if (bounds === "parent") boundNode = node.parentNode;
            else boundNode = ownerDocument.querySelector(bounds);
            if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
            var nodeStyle = ownerWindow.getComputedStyle(node);
            var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
            // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
            bounds = {
                left: -node.offsetLeft + int(boundNodeStyle.paddingLeft) + int(nodeStyle.marginLeft),
                top: -node.offsetTop + int(boundNodeStyle.paddingTop) + int(nodeStyle.marginTop),
                right: innerWidth(boundNode) - outerWidth(node) - node.offsetLeft + int(boundNodeStyle.paddingRight) - int(nodeStyle.marginRight),
                bottom: innerHeight(boundNode) - outerHeight(node) - node.offsetTop + int(boundNodeStyle.paddingBottom) - int(nodeStyle.marginBottom)
            };
        }
        // Keep x and y below right and bottom limits...
        if (isNum(bounds.right)) x = Math.min(x, bounds.right);
        if (isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);
        // But above left and top limits.
        if (isNum(bounds.left)) x = Math.max(x, bounds.left);
        if (isNum(bounds.top)) y = Math.max(y, bounds.top);
        return [
            x,
            y
        ];
    }
    function snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
        var x = Math.round(pendingX / grid[0]) * grid[0];
        var y = Math.round(pendingY / grid[1]) * grid[1];
        return [
            x,
            y
        ];
    }
    function canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
        return draggable.props.axis === "both" || draggable.props.axis === "x";
    }
    function canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
        return draggable.props.axis === "both" || draggable.props.axis === "y";
    }
    // Get {x, y} positions from event.
    function getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
        var touchObj = typeof touchIdentifier === "number" ? getTouch(e, touchIdentifier) : null;
        if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
        var node = findDOMNode(draggableCore);
        // User can provide an offsetParent if desired.
        var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
        return offsetXYFromParent(touchObj || e, offsetParent);
    }
    // Create an data object exposed by <DraggableCore>'s events
    function createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
        var state = draggable.state;
        var isStart = !isNum(state.lastX);
        var node = findDOMNode(draggable);
        if (isStart) // If this is our first move, use the x and y as last coords.
        return {
            node: node,
            deltaX: 0,
            deltaY: 0,
            lastX: x,
            lastY: y,
            x: x,
            y: y
        };
        else // Otherwise calculate proper values.
        return {
            node: node,
            deltaX: x - state.lastX,
            deltaY: y - state.lastY,
            lastX: state.lastX,
            lastY: state.lastY,
            x: x,
            y: y
        };
    }
    // Create an data exposed by <Draggable>'s events
    function createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
        var scale = draggable.props.scale;
        return {
            node: coreData.node,
            x: draggable.state.x + coreData.deltaX / scale,
            y: draggable.state.y + coreData.deltaY / scale,
            deltaX: coreData.deltaX / scale,
            deltaY: coreData.deltaY / scale,
            lastX: draggable.state.x,
            lastY: draggable.state.y
        };
    }
    // A lot faster than stringify/parse
    function cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
        return {
            left: bounds.left,
            top: bounds.top,
            right: bounds.right,
            bottom: bounds.bottom
        };
    }
    function findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
        var node = ReactDOM.findDOMNode(draggable);
        if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
        // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
        return node;
    }
    /*eslint no-console:0*/ function log() {}
    /*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ // Simple abstraction for dragging events names.
    /*:: import type {Element as ReactElement} from 'react';*/ var eventsFor = {
        touch: {
            start: "touchstart",
            move: "touchmove",
            stop: "touchend"
        },
        mouse: {
            start: "mousedown",
            move: "mousemove",
            stop: "mouseup"
        }
    };
    // Default to mouse events.
    var dragEventFor = eventsFor.mouse;
    /*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/ /*:: export type DraggableBounds = {
	  left: number,
	  right: number,
	  top: number,
	  bottom: number,
	};*/ /*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ //
    // Define <DraggableCore>.
    //
    // <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
    // work well with libraries that require more control over the element.
    //
    /*:: export type DraggableCoreProps = {
	  allowAnyClick: boolean,
	  cancel: string,
	  children: ReactElement<any>,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	};*/ var DraggableCore = function(_React$Component) {
        inherits(DraggableCore, _React$Component);
        function DraggableCore() {
            var _ref;
            var _temp, _this, _ret;
            classCallCheck(this, DraggableCore);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                dragging: false,
                // Used while dragging to determine deltas.
                lastX: NaN,
                lastY: NaN,
                touchIdentifier: null
            }, _this.handleDragStart = function(e) {
                // Make it possible to attach event handlers on top of this one.
                _this.props.onMouseDown(e);
                // Only accept left-clicks.
                if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false;
                // Get nodes. Be sure to grab relative document (could be iframed)
                var thisNode = ReactDOM.findDOMNode(_this);
                if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
                var ownerDocument = thisNode.ownerDocument;
                // Short circuit if handle or cancel prop was provided and selector doesn't match.
                if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo(e.target, _this.props.cancel, thisNode)) return;
                // Set touch identifier in component state if this is a touch event. This allows us to
                // distinguish between individual touches on multitouch screens by identifying which
                // touchpoint was set to this element.
                var touchIdentifier = getTouchIdentifier(e);
                _this.setState({
                    touchIdentifier: touchIdentifier
                });
                // Get the current drag point from the event. This is used as the offset.
                var position = getControlPosition(e, touchIdentifier, _this);
                if (position == null) return; // not possible but satisfies flow
                var x = position.x, y = position.y;
                // Create an event object with all the data parents need to make a decision here.
                var coreEvent = createCoreData(_this, x, y);
                // Call event handler. If it returns explicit false, cancel.
                log("calling", _this.props.onStart);
                var shouldUpdate = _this.props.onStart(e, coreEvent);
                if (shouldUpdate === false) return;
                // Add a style to the body to disable user-select. This prevents text from
                // being selected all over the page.
                if (_this.props.enableUserSelectHack) addUserSelectStyles(ownerDocument);
                // Initiate dragging. Set the current x and y as offsets
                // so we know how much we've moved during the drag. This allows us
                // to drag elements around even if they have been moved, without issue.
                _this.setState({
                    dragging: true,
                    lastX: x,
                    lastY: y
                });
                // Add events to the document directly so we catch when the user's mouse/touch moves outside of
                // this element. We use different events depending on whether or not we have detected that this
                // is a touch-capable device.
                addEvent(ownerDocument, dragEventFor.move, _this.handleDrag);
                addEvent(ownerDocument, dragEventFor.stop, _this.handleDragStop);
            }, _this.handleDrag = function(e) {
                // Prevent scrolling on mobile devices, like ipad/iphone.
                if (e.type === "touchmove") e.preventDefault();
                // Get the current drag point from the event. This is used as the offset.
                var position = getControlPosition(e, _this.state.touchIdentifier, _this);
                if (position == null) return;
                var x = position.x, y = position.y;
                // Snap to grid if prop has been provided
                if (Array.isArray(_this.props.grid)) {
                    var _deltaX = x - _this.state.lastX, _deltaY = y - _this.state.lastY;
                    var _snapToGrid = snapToGrid(_this.props.grid, _deltaX, _deltaY);
                    var _snapToGrid2 = slicedToArray(_snapToGrid, 2);
                    _deltaX = _snapToGrid2[0];
                    _deltaY = _snapToGrid2[1];
                    if (!_deltaX && !_deltaY) return; // skip useless drag
                    x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
                }
                var coreEvent = createCoreData(_this, x, y);
                // Call event handler. If it returns explicit false, trigger end.
                var shouldUpdate = _this.props.onDrag(e, coreEvent);
                if (shouldUpdate === false) {
                    try {
                        // $FlowIgnore
                        _this.handleDragStop(new MouseEvent("mouseup"));
                    } catch (err) {
                        // Old browsers
                        var event = document.createEvent("MouseEvents");
                        // I see why this insanity was deprecated
                        // $FlowIgnore
                        event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                        _this.handleDragStop(event);
                    }
                    return;
                }
                _this.setState({
                    lastX: x,
                    lastY: y
                });
            }, _this.handleDragStop = function(e) {
                if (!_this.state.dragging) return;
                var position = getControlPosition(e, _this.state.touchIdentifier, _this);
                if (position == null) return;
                var x = position.x, y = position.y;
                var coreEvent = createCoreData(_this, x, y);
                var thisNode = ReactDOM.findDOMNode(_this);
                if (thisNode) // Remove user-select hack
                {
                    if (_this.props.enableUserSelectHack) removeUserSelectStyles(thisNode.ownerDocument);
                }
                // Reset the el.
                _this.setState({
                    dragging: false,
                    lastX: NaN,
                    lastY: NaN
                });
                // Call event handler
                _this.props.onStop(e, coreEvent);
                if (thisNode) {
                    removeEvent(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
                    removeEvent(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
                }
            }, _this.onMouseDown = function(e) {
                dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
                return _this.handleDragStart(e);
            }, _this.onMouseUp = function(e) {
                dragEventFor = eventsFor.mouse;
                return _this.handleDragStop(e);
            }, _this.onTouchStart = function(e) {
                // We're on a touch device now, so change the event handlers
                dragEventFor = eventsFor.touch;
                return _this.handleDragStart(e);
            }, _this.onTouchEnd = function(e) {
                // We're on a touch device now, so change the event handlers
                dragEventFor = eventsFor.touch;
                return _this.handleDragStop(e);
            }, _temp), possibleConstructorReturn(_this, _ret);
        }
        createClass(DraggableCore, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    // Remove any leftover event handlers. Remove both touch and mouse handlers in case
                    // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
                    var thisNode = ReactDOM.findDOMNode(this);
                    if (thisNode) {
                        var ownerDocument = thisNode.ownerDocument;
                        removeEvent(ownerDocument, eventsFor.mouse.move, this.handleDrag);
                        removeEvent(ownerDocument, eventsFor.touch.move, this.handleDrag);
                        removeEvent(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
                        removeEvent(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
                        if (this.props.enableUserSelectHack) removeUserSelectStyles(ownerDocument);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    // Reuse the child provided
                    // This makes it flexible to use whatever element is wanted (div, ul, etc)
                    return React.cloneElement(React.Children.only(this.props.children), {
                        style: styleHacks(this.props.children.props.style),
                        // Note: mouseMove handler is attached to document so it will still function
                        // when the user drags quickly and leaves the bounds of the element.
                        onMouseDown: this.onMouseDown,
                        onTouchStart: this.onTouchStart,
                        onMouseUp: this.onMouseUp,
                        onTouchEnd: this.onTouchEnd
                    });
                }
            }
        ]);
        return DraggableCore;
    }(React.Component);
    DraggableCore.displayName = "DraggableCore";
    DraggableCore.propTypes = {
        /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */ allowAnyClick: propTypes.bool,
        /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */ disabled: propTypes.bool,
        /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */ enableUserSelectHack: propTypes.bool,
        /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */ offsetParent: function offsetParent(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
            if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
        },
        /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */ grid: propTypes.arrayOf(propTypes.number),
        /**
	   * `scale` specifies the scale of the area you are dragging inside of. It allows
	   * the drag deltas to scale correctly with how far zoomed in/out you are.
	   */ scale: propTypes.number,
        /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */ handle: propTypes.string,
        /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */ cancel: propTypes.string,
        /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */ onStart: propTypes.func,
        /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */ onDrag: propTypes.func,
        /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */ onStop: propTypes.func,
        /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */ onMouseDown: propTypes.func,
        /**
	   * These properties should be defined on the child, not here.
	   */ className: dontSetMe,
        style: dontSetMe,
        transform: dontSetMe
    };
    DraggableCore.defaultProps = {
        allowAnyClick: false,
        cancel: null,
        disabled: false,
        enableUserSelectHack: true,
        offsetParent: null,
        handle: null,
        grid: null,
        transform: null,
        onStart: function onStart() {},
        onDrag: function onDrag() {},
        onStop: function onStop() {},
        onMouseDown: function onMouseDown() {}
    };
    /*:: import type {DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean
	};*/ //
    // Define <Draggable>
    //
    /*:: export type DraggableProps = {
	  ...$Exact<DraggableCoreProps>,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: DraggableBounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  positionOffset: PositionOffsetControlPosition,
	  position: ControlPosition,
	  scale: number
	};*/ var Draggable = function(_React$Component) {
        inherits(Draggable, _React$Component);
        function Draggable(props /*: DraggableProps*/ ) {
            classCallCheck(this, Draggable);
            var _this = possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
            _this.onDragStart = function(e, coreData) {
                // Short-circuit if user's callback killed it.
                var shouldStart = _this.props.onStart(e, createDraggableData(_this, coreData));
                // Kills start event on core as well, so move handlers are never bound.
                if (shouldStart === false) return false;
                _this.setState({
                    dragging: true,
                    dragged: true
                });
            };
            _this.onDrag = function(e, coreData) {
                if (!_this.state.dragging) return false;
                var uiData = createDraggableData(_this, coreData);
                var newState /*: $Shape<DraggableState>*/  = {
                    x: uiData.x,
                    y: uiData.y
                };
                // Keep within bounds.
                if (_this.props.bounds) {
                    // Save original x and y.
                    var _x = newState.x, _y = newState.y;
                    // Add slack to the values used to calculate bound position. This will ensure that if
                    // we start removing slack, the element won't react to it right away until it's been
                    // completely removed.
                    newState.x += _this.state.slackX;
                    newState.y += _this.state.slackY;
                    // Get bound position. This will ceil/floor the x and y within the boundaries.
                    var _getBoundPosition = getBoundPosition(_this, newState.x, newState.y), _getBoundPosition2 = slicedToArray(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
                    newState.x = newStateX;
                    newState.y = newStateY;
                    // Recalculate slack by noting how much was shaved by the boundPosition handler.
                    newState.slackX = _this.state.slackX + (_x - newState.x);
                    newState.slackY = _this.state.slackY + (_y - newState.y);
                    // Update the event we fire to reflect what really happened after bounds took effect.
                    uiData.x = newState.x;
                    uiData.y = newState.y;
                    uiData.deltaX = newState.x - _this.state.x;
                    uiData.deltaY = newState.y - _this.state.y;
                }
                // Short-circuit if user's callback killed it.
                var shouldUpdate = _this.props.onDrag(e, uiData);
                if (shouldUpdate === false) return false;
                _this.setState(newState);
            };
            _this.onDragStop = function(e, coreData) {
                if (!_this.state.dragging) return false;
                // Short-circuit if user's callback killed it.
                var shouldStop = _this.props.onStop(e, createDraggableData(_this, coreData));
                if (shouldStop === false) return false;
                var newState /*: $Shape<DraggableState>*/  = {
                    dragging: false,
                    slackX: 0,
                    slackY: 0
                };
                // If this is a controlled component, the result of this operation will be to
                // revert back to the old position. We expect a handler on `onDragStop`, at the least.
                var controlled = Boolean(_this.props.position);
                if (controlled) {
                    var _this$props$position = _this.props.position, _x2 = _this$props$position.x, _y2 = _this$props$position.y;
                    newState.x = _x2;
                    newState.y = _y2;
                }
                _this.setState(newState);
            };
            _this.state = {
                // Whether or not we are currently dragging.
                dragging: false,
                // Whether or not we have been dragged before.
                dragged: false,
                // Current transform x and y.
                x: props.position ? props.position.x : props.defaultPosition.x,
                y: props.position ? props.position.y : props.defaultPosition.y,
                // Used for compensating for out-of-bounds drags
                slackX: 0,
                slackY: 0,
                // Can only determine if SVG after mounting
                isElementSVG: false
            };
            if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
            console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
            return _this;
        }
        createClass(Draggable, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Check to see if the element passed is an instanceof SVGElement
                    if (typeof window.SVGElement !== "undefined" && ReactDOM.findDOMNode(this) instanceof window.SVGElement) this.setState({
                        isElementSVG: true
                    });
                }
            },
            {
                key: "componentWillReceiveProps",
                value: function componentWillReceiveProps(nextProps /*: Object*/ ) {
                    // Set x/y if position has changed
                    if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) this.setState({
                        x: nextProps.position.x,
                        y: nextProps.position.y
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.setState({
                        dragging: false
                    }); // prevents invariant if unmounted while dragging
                }
            },
            {
                key: "render",
                value: function render() /*: ReactElement<any>*/ {
                    var _classNames;
                    var style = {}, svgTransform = null;
                    // If this is controlled, we don't want to move it - unless it's dragging.
                    var controlled = Boolean(this.props.position);
                    var draggable = !controlled || this.state.dragging;
                    var position = this.props.position || this.props.defaultPosition;
                    var transformOpts = {
                        // Set left if horizontal drag is enabled
                        x: canDragX(this) && draggable ? this.state.x : position.x,
                        // Set top if vertical drag is enabled
                        y: canDragY(this) && draggable ? this.state.y : position.y
                    };
                    // If this element was SVG, we use the `transform` attribute.
                    if (this.state.isElementSVG) svgTransform = createSVGTransform(transformOpts, this.props.positionOffset);
                    else // Add a CSS transform to move the element around. This allows us to move the element around
                    // without worrying about whether or not it is relatively or absolutely positioned.
                    // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
                    // has a clean slate.
                    style = createCSSTransform(transformOpts, this.props.positionOffset);
                    var _props = this.props, defaultClassName = _props.defaultClassName, defaultClassNameDragging = _props.defaultClassNameDragging, defaultClassNameDragged = _props.defaultClassNameDragged;
                    var children = React.Children.only(this.props.children);
                    // Mark with class while dragging
                    var className = classnames(children.props.className || "", defaultClassName, (_classNames = {}, defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
                    // Reuse the child provided
                    // This makes it flexible to use whatever element is wanted (div, ul, etc)
                    return React.createElement(DraggableCore, _extends({}, this.props, {
                        onStart: this.onDragStart,
                        onDrag: this.onDrag,
                        onStop: this.onDragStop
                    }), React.cloneElement(children, {
                        className: className,
                        style: _extends({}, children.props.style, style),
                        transform: svgTransform
                    }));
                }
            }
        ]);
        return Draggable;
    }(React.Component);
    Draggable.displayName = "Draggable";
    Draggable.propTypes = _extends({}, DraggableCore.propTypes, {
        /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */ axis: propTypes.oneOf([
            "both",
            "x",
            "y",
            "none"
        ]),
        /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */ bounds: propTypes.oneOfType([
            propTypes.shape({
                left: propTypes.number,
                right: propTypes.number,
                top: propTypes.number,
                bottom: propTypes.number
            }),
            propTypes.string,
            propTypes.oneOf([
                false
            ])
        ]),
        defaultClassName: propTypes.string,
        defaultClassNameDragging: propTypes.string,
        defaultClassNameDragged: propTypes.string,
        /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */ defaultPosition: propTypes.shape({
            x: propTypes.number,
            y: propTypes.number
        }),
        positionOffset: propTypes.shape({
            x: propTypes.oneOfType([
                propTypes.number,
                propTypes.string
            ]),
            y: propTypes.oneOfType([
                propTypes.number,
                propTypes.string
            ])
        }),
        /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */ position: propTypes.shape({
            x: propTypes.number,
            y: propTypes.number
        }),
        /**
	   * These properties should be defined on the child, not here.
	   */ className: dontSetMe,
        style: dontSetMe,
        transform: dontSetMe
    });
    Draggable.defaultProps = _extends({}, DraggableCore.defaultProps, {
        axis: "both",
        bounds: false,
        defaultClassName: "react-draggable",
        defaultClassNameDragging: "react-draggable-dragging",
        defaultClassNameDragged: "react-draggable-dragged",
        defaultPosition: {
            x: 0,
            y: 0
        },
        position: null,
        scale: 1
    });
    // Previous versions of this lib exported <Draggable> as the root export. As to not break
    // them, or TypeScript, we export *both* as the root and as 'default'.
    // See https://github.com/mzabriskie/react-draggable/pull/254
    // and https://github.com/mzabriskie/react-draggable/issues/266
    Draggable.default = Draggable;
    Draggable.DraggableCore = DraggableCore;
    return Draggable;
});


var $f455ece61e3e4c07$var$_reactDraggable2 = $f455ece61e3e4c07$var$_interopRequireDefault($742bd248c4cf09b3$exports);

function $f455ece61e3e4c07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f455ece61e3e4c07$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f455ece61e3e4c07$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f455ece61e3e4c07$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f455ece61e3e4c07$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-inline-comments */ 
/* eslint-disable no-magic-numbers */ $f455ece61e3e4c07$var$_dayjs2.default.extend($f455ece61e3e4c07$var$_quarterOfYear2.default);
/* eslint-disable react/prop-types */ // eslint can't see inherited propTypes!
var $f455ece61e3e4c07$var$DraggableAttribute = $f455ece61e3e4c07$exports.DraggableAttribute = function(_React$Component) {
    $f455ece61e3e4c07$var$_inherits(DraggableAttribute, _React$Component);
    function DraggableAttribute(props) {
        $f455ece61e3e4c07$var$_classCallCheck(this, DraggableAttribute);
        var _this = $f455ece61e3e4c07$var$_possibleConstructorReturn(this, (DraggableAttribute.__proto__ || Object.getPrototypeOf(DraggableAttribute)).call(this, props));
        _this.state = {
            open: false,
            filterText: ""
        };
        return _this;
    }
    $f455ece61e3e4c07$var$_createClass(DraggableAttribute, [
        {
            key: "toggleValue",
            value: function toggleValue(value) {
                if (value in this.props.valueFilter) this.props.removeValuesFromFilter(this.props.name, [
                    value
                ]);
                else this.props.addValuesToFilter(this.props.name, [
                    value
                ]);
            }
        },
        {
            key: "matchesFilter",
            value: function matchesFilter(x) {
                return x.toLowerCase().trim().includes(this.state.filterText.toLowerCase().trim());
            }
        },
        {
            key: "selectOnly",
            value: function selectOnly(e, value) {
                e.stopPropagation();
                this.props.setValuesInFilter(this.props.name, Object.keys(this.props.attrValues).filter(function(y) {
                    return y !== value;
                }));
            }
        },
        {
            key: "getFilterBox",
            value: function getFilterBox() {
                var _this2 = this;
                var showMenu = Object.keys(this.props.attrValues).length < this.props.menuLimit;
                var values = Object.keys(this.props.attrValues);
                var shown = values.filter(this.matchesFilter.bind(this)).sort(this.props.sorter);
                function ChevronDown(props) {
                    return $f455ece61e3e4c07$var$_react2.default.createElement("svg", $f455ece61e3e4c07$var$_extends({
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: "1.5",
                        stroke: "currentColor",
                        className: "w-4 h-4"
                    }, props), $f455ece61e3e4c07$var$_react2.default.createElement("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M4.5 15.75l7.5-7.5 7.5 7.5"
                    }));
                }
                function CheckIcon(props) {
                    return $f455ece61e3e4c07$var$_react2.default.createElement("svg", $f455ece61e3e4c07$var$_extends({
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: "1.5",
                        stroke: "currentColor",
                        className: "w-4 h-4"
                    }, props), $f455ece61e3e4c07$var$_react2.default.createElement("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M4.5 12.75l6 6 9-13.5"
                    }));
                }
                function applyFilterClause(dropdownOptionId) {
                    switch(dropdownOptionId){
                        case "currentMonth":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().startOf("month").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().valueOf(),
                                id: "currentMonth"
                            };
                        case "currentQuarter":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().startOf("quarter").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().valueOf(),
                                id: "currentQuarter"
                            };
                        case "previousMonth":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "month").startOf("month").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "month").endOf("month").valueOf(),
                                id: "previousMonth"
                            };
                        case "previousQuarter":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "quarter").startOf("quarter").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "quarter").endOf("quarter").valueOf(),
                                id: "previousQuarter"
                            };
                        case "currentYTD":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().startOf("year").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().valueOf(),
                                id: "currentYTD"
                            };
                        case "previousYTD":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "year").startOf("year").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "year").valueOf(),
                                id: "previousYTD"
                            };
                        case "previousYear":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "year").startOf("year").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "year").endOf("year").valueOf(),
                                id: "previousYear"
                            };
                        case "last3Months":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(3, "months").startOf("month").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "month").endOf("month").valueOf(),
                                id: "last3Months"
                            };
                        case "last6Months":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(6, "months").startOf("month").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "month").endOf("month").valueOf(),
                                id: "last6Months"
                            };
                        case "last12Months":
                            return {
                                from: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(12, "months").startOf("month").valueOf(),
                                to: (0, $f455ece61e3e4c07$var$_dayjs2.default)().subtract(1, "month").endOf("month").valueOf(),
                                id: "last12Months"
                            };
                        // handles noFilter as well
                        default:
                            return {
                                from: null,
                                to: null,
                                id: "noFilter"
                            };
                    }
                }
                return $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$_reactDraggable2.default, {
                    handle: ".pvtDragHandle"
                }, $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    className: "absolute mt-1 w-80 border border-gray-300 rounded-sm shadow-lg bg-white text-center min-h-[100px]",
                    style: {
                        cursor: "initial",
                        zIndex: this.props.zIndex
                    },
                    onClick: function onClick() {
                        return _this2.props.moveFilterBoxToTop(_this2.props.name);
                    }
                }, $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    className: "grid grid-cols-3 items-center mb-2"
                }, $f455ece61e3e4c07$var$_react2.default.createElement("span", {
                    className: "pl-1 pt-1 text-base text-gray-900 justify-self-start"
                }, "\u2630"), $f455ece61e3e4c07$var$_react2.default.createElement("h4", {
                    className: "text-sm font-bold text-gray-900 justify-self-stretch text-center"
                }, this.props.name), $f455ece61e3e4c07$var$_react2.default.createElement("button", {
                    type: "button",
                    onClick: function onClick() {
                        return _this2.setState({
                            open: false
                        });
                    },
                    className: "pr-1 pt-1 text-base text-gray-900 justify-self-end"
                }, "\xd7")), showMenu || $f455ece61e3e4c07$var$_react2.default.createElement("p", null, "(too many values to show)"), this.props.name.toLowerCase().indexOf("date") > -1 && $f455ece61e3e4c07$var$_react2.default.createElement($8d33aee4c6c0ce1f$export$74a362b31437ec83, {
                    defaultOpen: true
                }, function(_ref) {
                    var open = _ref.open;
                    return $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$_react2.default.Fragment, null, _this2.props.name.toLowerCase().indexOf("date") > -1, $f455ece61e3e4c07$var$_react2.default.createElement($8d33aee4c6c0ce1f$export$74a362b31437ec83.Button, {
                        className: "mx-auto flex justify-center items-center space-x-2 py-1 my-2 w-11/12 uppercase text-xs text-center font-semibold tracking-wider border border-transparent rounded-md bg-gray-100"
                    }, "Filter by period", $f455ece61e3e4c07$var$_react2.default.createElement(ChevronDown, {
                        className: "h-4 w-4 " + (open ? "rotate-180 transform" : "")
                    })), $f455ece61e3e4c07$var$_react2.default.createElement($8d33aee4c6c0ce1f$export$74a362b31437ec83.Panel, null, $f455ece61e3e4c07$var$_react2.default.createElement("select", {
                        id: "timeLimit",
                        name: "timeLimit",
                        onChange: function onChange(e) {
                            _this2.props.setFilterClause(applyFilterClause(e.target.value));
                        },
                        className: "mt-1 block w-9/12 mx-auto rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm",
                        defaultValue: _this2.props.dateFilter.id || "nofilter"
                    }, $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "noFilter"
                    }, "all dates"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "currentMonth"
                    }, "current month"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "currentQuarter"
                    }, "current quarter"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "previousMonth"
                    }, "previous month"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "previousQuarter"
                    }, "previous quarter"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "currentYTD"
                    }, "current year to date"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "previousYTD"
                    }, "previous year to date"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "previousYear"
                    }, "previous year"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "last3Months"
                    }, "last 3 months"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "last6Months"
                    }, "last 6 months"), $f455ece61e3e4c07$var$_react2.default.createElement("option", {
                        value: "last12Months"
                    }, "last 12 months"))));
                }), $f455ece61e3e4c07$var$_react2.default.createElement($8d33aee4c6c0ce1f$export$74a362b31437ec83, null, function(_ref2) {
                    var open = _ref2.open;
                    return $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$_react2.default.Fragment, null, $f455ece61e3e4c07$var$_react2.default.createElement($8d33aee4c6c0ce1f$export$74a362b31437ec83.Button, {
                        className: "mx-auto flex justify-center items-center space-x-2 py-1 my-2 w-11/12 uppercase text-xs text-center font-semibold tracking-wider border border-transparent rounded-md bg-gray-100"
                    }, "Filter by values", $f455ece61e3e4c07$var$_react2.default.createElement(ChevronDown, {
                        className: "h-4 w-4 " + (open ? "rotate-180 transform" : "")
                    })), $f455ece61e3e4c07$var$_react2.default.createElement($8d33aee4c6c0ce1f$export$74a362b31437ec83.Panel, {
                        className: "grid grid-cols-1 justify-items-center mb-1 w-11/12 mx-auto"
                    }, $f455ece61e3e4c07$var$_react2.default.createElement("input", {
                        type: "text",
                        placeholder: "Filter values",
                        className: "block w-9/12 mb-1 text-xs border border-gray-300 rounded-sm shadow-sm focus:ring-brandBlue-500 focus:border-brandBlue-500",
                        value: _this2.state.filterText,
                        onChange: function onChange(e) {
                            return _this2.setState({
                                filterText: e.target.value
                            });
                        }
                    }), $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                        className: "my-1 flex justify-around space-x-2"
                    }, $f455ece61e3e4c07$var$_react2.default.createElement("button", {
                        role: "button",
                        className: "text-xs text-gray-700 rounded-sm border border-gray-300 py-1 px-2",
                        onClick: function onClick() {
                            return _this2.props.removeValuesFromFilter(_this2.props.name, Object.keys(_this2.props.attrValues).filter(_this2.matchesFilter.bind(_this2)));
                        }
                    }, "Select ", values.length === shown.length ? "All" : shown.length), $f455ece61e3e4c07$var$_react2.default.createElement("button", {
                        role: "button",
                        className: "text-xs text-gray-700 rounded-sm border border-gray-300 py-1 px-2",
                        onClick: function onClick() {
                            return _this2.props.addValuesToFilter(_this2.props.name, Object.keys(_this2.props.attrValues).filter(_this2.matchesFilter.bind(_this2)));
                        }
                    }, "Deselect ", values.length === shown.length ? "All" : shown.length)), showMenu && $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                        className: "w-11/12 flex flex-col items-stretch justify-center"
                    }, shown.map(function(x) {
                        return $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                            role: "button",
                            key: x,
                            onClick: function onClick() {
                                return _this2.toggleValue(x);
                            },
                            className: "py-1 grid grid-cols-12 hover:bg-brandBlue-600 text-xs hover:text-white " + (x in _this2.props.valueFilter ? "" : "selected")
                        }, $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                            className: "justify-self-center"
                        }, x in _this2.props.valueFilter ? null : $f455ece61e3e4c07$var$_react2.default.createElement(CheckIcon, null)), $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                            className: "col-span-11 justify-self-start truncate"
                        }, x === "" ? $f455ece61e3e4c07$var$_react2.default.createElement("em", null, "null") : x));
                    }))));
                })));
            }
        },
        {
            key: "toggleFilterBox",
            value: function toggleFilterBox() {
                this.setState({
                    open: !this.state.open
                });
                this.props.moveFilterBoxToTop(this.props.name);
            }
        },
        {
            key: "render",
            value: function render() {
                var filtered = Object.keys(this.props.valueFilter).length !== 0 ? "pvtFilteredAttribute" : "";
                return $f455ece61e3e4c07$var$_react2.default.createElement("li", {
                    "data-id": this.props.name
                }, $f455ece61e3e4c07$var$_react2.default.createElement("span", {
                    className: "pvtAttr " + filtered
                }, this.props.name, $f455ece61e3e4c07$var$_react2.default.createElement("span", {
                    className: "pvtTriangle",
                    onClick: this.toggleFilterBox.bind(this)
                }, " ", "\u25BE")), this.state.open ? this.getFilterBox() : null);
            }
        }
    ]);
    return DraggableAttribute;
}($f455ece61e3e4c07$var$_react2.default.Component);
$f455ece61e3e4c07$var$DraggableAttribute.defaultProps = {
    valueFilter: {}
};
$f455ece61e3e4c07$var$DraggableAttribute.propTypes = {
    name: $f455ece61e3e4c07$var$_propTypes2.default.string.isRequired,
    addValuesToFilter: $f455ece61e3e4c07$var$_propTypes2.default.func.isRequired,
    removeValuesFromFilter: $f455ece61e3e4c07$var$_propTypes2.default.func.isRequired,
    attrValues: $f455ece61e3e4c07$var$_propTypes2.default.objectOf($f455ece61e3e4c07$var$_propTypes2.default.number).isRequired,
    valueFilter: $f455ece61e3e4c07$var$_propTypes2.default.objectOf($f455ece61e3e4c07$var$_propTypes2.default.bool),
    moveFilterBoxToTop: $f455ece61e3e4c07$var$_propTypes2.default.func.isRequired,
    sorter: $f455ece61e3e4c07$var$_propTypes2.default.func.isRequired,
    menuLimit: $f455ece61e3e4c07$var$_propTypes2.default.number,
    zIndex: $f455ece61e3e4c07$var$_propTypes2.default.number
};
var $f455ece61e3e4c07$var$Dropdown = $f455ece61e3e4c07$exports.Dropdown = function(_React$PureComponent) {
    $f455ece61e3e4c07$var$_inherits(Dropdown, _React$PureComponent);
    function Dropdown() {
        $f455ece61e3e4c07$var$_classCallCheck(this, Dropdown);
        return $f455ece61e3e4c07$var$_possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
    }
    $f455ece61e3e4c07$var$_createClass(Dropdown, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    className: "pvtDropdown",
                    style: {
                        zIndex: this.props.zIndex
                    }
                }, $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    onClick: function onClick(e) {
                        e.stopPropagation();
                        _this4.props.toggle();
                    },
                    className: "pvtDropdownValue pvtDropdownCurrent " + (this.props.open ? "pvtDropdownCurrentOpen" : ""),
                    role: "button"
                }, $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    className: "pvtDropdownIcon"
                }, this.props.open ? "\xd7" : "\u25BE"), this.props.current || $f455ece61e3e4c07$var$_react2.default.createElement("span", null, "\xa0")), this.props.open && $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    className: "pvtDropdownMenu"
                }, this.props.values.map(function(r) {
                    return $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                        key: r,
                        role: "button",
                        onClick: function onClick(e) {
                            e.stopPropagation();
                            if (_this4.props.current === r) _this4.props.toggle();
                            else _this4.props.setValue(r);
                        },
                        className: "pvtDropdownValue " + (r === _this4.props.current ? "pvtDropdownActiveValue" : "")
                    }, r);
                })));
            }
        }
    ]);
    return Dropdown;
}($f455ece61e3e4c07$var$_react2.default.PureComponent);
var $f455ece61e3e4c07$var$PivotTableUI = function(_React$PureComponent2) {
    $f455ece61e3e4c07$var$_inherits(PivotTableUI, _React$PureComponent2);
    function PivotTableUI(props) {
        $f455ece61e3e4c07$var$_classCallCheck(this, PivotTableUI);
        var _this5 = $f455ece61e3e4c07$var$_possibleConstructorReturn(this, (PivotTableUI.__proto__ || Object.getPrototypeOf(PivotTableUI)).call(this, props));
        _this5.state = {
            unusedOrder: [],
            zIndices: {},
            maxZIndex: 1000,
            openDropdown: false,
            attrValues: {},
            materializedInput: [],
            displayWarning: null
        };
        return _this5;
    }
    $f455ece61e3e4c07$var$_createClass(PivotTableUI, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.materializeInput(this.props.data);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.materializeInput(this.props.data);
            }
        },
        {
            key: "materializeInput",
            value: function materializeInput(nextDataInput) {
                var _this6 = this;
                // apply custom filter by date first
                var nextData = (nextDataInput || []).// CAUTION: the filter is alro reused in browser-app ChartWrapper ReportEdit & Reporting components, and must be kept in sync
                // eslint-disable-next-line no-magic-numbers
                filter(function(x) {
                    return x.date > (_this6.props.dateFilter.from || new Date(1902, 0, 1).valueOf()) && x.date <= (_this6.props.dateFilter.to || new Date(2200, 0, 1).valueOf());
                });
                // if .filter is applied on this function's input object, it no longer is identified as === to state.data, so a .length check has been introduced instead
                // this is a crude solution, but should work for this use case
                if ((this.state.data || []).length === (nextData || []).length) return;
                var newState = {
                    data: nextData,
                    attrValues: {},
                    materializedInput: []
                };
                var recordsProcessed = 0;
                $25ed1e0e429105db$exports.PivotData.forEachRecord(newState.data, this.props.derivedAttributes, function(record) {
                    newState.materializedInput.push(record);
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(record)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var attr = _step.value;
                            if (!(attr in newState.attrValues)) {
                                newState.attrValues[attr] = {};
                                if (recordsProcessed > 0) newState.attrValues[attr].null = recordsProcessed;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    for(var _attr in newState.attrValues){
                        var value = _attr in record ? record[_attr] : "null";
                        if (!(value in newState.attrValues[_attr])) newState.attrValues[_attr][value] = 0;
                        newState.attrValues[_attr][value]++;
                    }
                    recordsProcessed++;
                });
                this.setState(newState);
            }
        },
        {
            key: "sendPropUpdate",
            value: function sendPropUpdate(command) {
                this.props.onChange((0, $f455ece61e3e4c07$var$_immutabilityHelper2.default)(this.props, command));
            }
        },
        {
            key: "propUpdater",
            value: function propUpdater(key) {
                var _this7 = this;
                return function(value) {
                    return _this7.sendPropUpdate($f455ece61e3e4c07$var$_defineProperty({}, key, {
                        $set: value
                    }));
                };
            }
        },
        {
            key: "setValuesInFilter",
            value: function setValuesInFilter(attribute, values) {
                this.sendPropUpdate({
                    valueFilter: $f455ece61e3e4c07$var$_defineProperty({}, attribute, {
                        $set: values.reduce(function(r, v) {
                            r[v] = true;
                            return r;
                        }, {})
                    })
                });
            }
        },
        {
            key: "addValuesToFilter",
            value: function addValuesToFilter(attribute, values) {
                if (attribute in this.props.valueFilter) this.sendPropUpdate({
                    valueFilter: $f455ece61e3e4c07$var$_defineProperty({}, attribute, values.reduce(function(r, v) {
                        r[v] = {
                            $set: true
                        };
                        return r;
                    }, {}))
                });
                else this.setValuesInFilter(attribute, values);
            }
        },
        {
            key: "removeValuesFromFilter",
            value: function removeValuesFromFilter(attribute, values) {
                this.sendPropUpdate({
                    valueFilter: $f455ece61e3e4c07$var$_defineProperty({}, attribute, {
                        $unset: values
                    })
                });
            }
        },
        {
            key: "moveFilterBoxToTop",
            value: function moveFilterBoxToTop(attribute) {
                this.setState((0, $f455ece61e3e4c07$var$_immutabilityHelper2.default)(this.state, {
                    maxZIndex: {
                        $set: this.state.maxZIndex + 1
                    },
                    zIndices: $f455ece61e3e4c07$var$_defineProperty({}, attribute, {
                        $set: this.state.maxZIndex + 1
                    })
                }));
            }
        },
        {
            key: "setFilterClause",
            value: function setFilterClause(_ref3) {
                var from = _ref3.from, to = _ref3.to;
                this.props.setDateFilter(from, to);
            }
        },
        {
            key: "isOpen",
            value: function isOpen(dropdown) {
                return this.state.openDropdown === dropdown;
            }
        },
        {
            key: "makeDnDCell",
            value: function makeDnDCell(items, onChange, classes, id) {
                var _this8 = this;
                var label = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
                var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;
                return $f455ece61e3e4c07$var$_react2.default.createElement("td", {
                    className: classes,
                    rowSpan: id === "unusedAttrs" ? 2 : 1 // handles rowspan property necessary for unusedAttrs
                }, $f455ece61e3e4c07$var$_react2.default.createElement("h3", {
                    className: "text-sm font-bold text-gray-900 pb-2"
                }, label), this.state.displayWarning === id && $f455ece61e3e4c07$var$_react2.default.createElement("p", {
                    className: "text-xs font-normal text-red-500 pb-2"
                }, "Maximum number of attributes exceeded"), $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$_reactSortablejs2.default, {
                    options: {
                        group: "shared",
                        ghostClass: "pvtPlaceholder",
                        filter: ".pvtFilterBox",
                        preventOnFilter: false,
                        onMove: function onMove(event) {
                            // onMove event has acccess to the 'to' element; each Sortable receives a 'data-limit' property equal to its limit, as set in the makeDnDCell function
                            // this handler compares the limit to the actual amount of child nodes already available and returns true if the move is possible (and false if it is not)
                            // the onMove event happens always on the SOURCE container, so the state and id belong to the source container
                            // for debugging:
                            // console.log('onMove test -- source:', id, 'target:', event.to.id, 'target limit:', event.to.getAttribute('data-limit'), 'target usage:', event.to.childNodes.length); // items, sortable, customEvent
                            // console.log('onMove test:', event.to.getAttribute('data-limit') >= event.to.childNodes.length, _this8.state.disableMe);
                            if (event.to.childNodes.length + 1 <= Number(event.to.getAttribute("data-limit"))) return true; // move possible              };
                            _this8.setState((0, $f455ece61e3e4c07$var$_immutabilityHelper2.default)(_this8.state, {
                                displayWarning: {
                                    $set: event.to.id
                                }
                            }));
                            return false; // move impossible
                        },
                        onEnd: function onEnd() {
                            _this8.setState((0, $f455ece61e3e4c07$var$_immutabilityHelper2.default)(_this8.state, {
                                displayWarning: {
                                    $set: null
                                }
                            }));
                        }
                    },
                    tag: "div",
                    className: "flex flex-wrap max-w-xs",
                    id: id,
                    "data-limit": limit,
                    onChange: onChange
                }, items.map(function(x) {
                    return $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$DraggableAttribute, {
                        name: x,
                        key: x,
                        attrValues: _this8.state.attrValues[x],
                        valueFilter: _this8.props.valueFilter[x] || {},
                        sorter: (0, $25ed1e0e429105db$exports.getSort)(_this8.props.sorters, x),
                        menuLimit: _this8.props.menuLimit,
                        setValuesInFilter: _this8.setValuesInFilter.bind(_this8),
                        addValuesToFilter: _this8.addValuesToFilter.bind(_this8),
                        moveFilterBoxToTop: _this8.moveFilterBoxToTop.bind(_this8),
                        removeValuesFromFilter: _this8.removeValuesFromFilter.bind(_this8),
                        zIndex: _this8.state.zIndices[x] || _this8.state.maxZIndex,
                        setFilterClause: _this8.setFilterClause.bind(_this8),
                        dateFilter: _this8.props.dateFilter
                    });
                })));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var numValsAllowed = this.props.aggregators[this.props.aggregatorName]([])().numInputs || 0;
                var rendererName = this.props.rendererName in this.props.renderers ? this.props.rendererName : Object.keys(this.props.renderers)[0];
                var rendererCell = $f455ece61e3e4c07$var$_react2.default.createElement("td", {
                    className: "p-3 align-top"
                }, $f455ece61e3e4c07$var$_react2.default.createElement("h3", {
                    className: "text-sm font-bold text-gray-900 pb-2"
                }, "Report type"), $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$Dropdown, {
                    current: rendererName,
                    values: Object.keys(this.props.renderers),
                    open: this.isOpen("renderer"),
                    zIndex: this.isOpen("renderer") ? this.state.maxZIndex + 1 : 1,
                    toggle: function toggle() {
                        return _this9.setState({
                            openDropdown: _this9.isOpen("renderer") ? false : "renderer"
                        });
                    },
                    setValue: this.propUpdater("rendererName")
                }));
                var sortIcons = {
                    key_a_to_z: {
                        rowSymbol: "\u2195",
                        colSymbol: "\u2194",
                        next: "value_a_to_z"
                    },
                    value_a_to_z: {
                        rowSymbol: "\u2193",
                        colSymbol: "\u2192",
                        next: "value_z_to_a"
                    },
                    value_z_to_a: {
                        rowSymbol: "\u2191",
                        colSymbol: "\u2190",
                        next: "key_a_to_z"
                    }
                };
                var aggregatorCell = $f455ece61e3e4c07$var$_react2.default.createElement("td", {
                    className: "p-3 align-top"
                }, $f455ece61e3e4c07$var$_react2.default.createElement("h3", {
                    className: "text-sm font-bold text-gray-900 pb-2"
                }, this.props.rendererPivotTableUISettings.yAxisPrimary.label || "Vertical axis (Y) - values"), $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$Dropdown, {
                    current: this.props.aggregatorName,
                    values: Object.keys(this.props.aggregators),
                    open: this.isOpen("aggregators"),
                    zIndex: this.isOpen("aggregators") ? this.state.maxZIndex + 1 : 1,
                    toggle: function toggle() {
                        return _this9.setState({
                            openDropdown: _this9.isOpen("aggregators") ? false : "aggregators"
                        });
                    },
                    setValue: this.propUpdater("aggregatorName")
                }), $f455ece61e3e4c07$var$_react2.default.createElement("a", {
                    role: "button",
                    className: "pvtRowOrder",
                    onClick: function onClick() {
                        return _this9.propUpdater("rowOrder")(sortIcons[_this9.props.rowOrder].next);
                    }
                }, sortIcons[this.props.rowOrder].rowSymbol), $f455ece61e3e4c07$var$_react2.default.createElement("a", {
                    role: "button",
                    className: "pvtColOrder",
                    onClick: function onClick() {
                        return _this9.propUpdater("colOrder")(sortIcons[_this9.props.colOrder].next);
                    }
                }, sortIcons[this.props.colOrder].colSymbol), numValsAllowed > 0 && $f455ece61e3e4c07$var$_react2.default.createElement("br", null), new Array(numValsAllowed).fill().map(function(n, i) {
                    return [
                        $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$Dropdown, {
                            key: i,
                            current: _this9.props.vals[i],
                            values: Object.keys(_this9.state.attrValues).filter(function(e) {
                                return !_this9.props.hiddenAttributes.includes(e) && !_this9.props.hiddenFromAggregators.includes(e);
                            }),
                            open: _this9.isOpen("val" + i),
                            zIndex: _this9.isOpen("val" + i) ? _this9.state.maxZIndex + 1 : 1,
                            toggle: function toggle() {
                                return _this9.setState({
                                    openDropdown: _this9.isOpen("val" + i) ? false : "val" + i
                                });
                            },
                            setValue: function setValue(value) {
                                return _this9.sendPropUpdate({
                                    vals: {
                                        $splice: [
                                            [
                                                i,
                                                1,
                                                value
                                            ]
                                        ]
                                    }
                                });
                            }
                        }),
                        i + 1 !== numValsAllowed ? $f455ece61e3e4c07$var$_react2.default.createElement("br", {
                            key: "br" + i
                        }) : null
                    ];
                }));
                var unusedAttrs = Object.keys(this.state.attrValues).filter(function(e) {
                    return !_this9.props.rows.includes(e) && !_this9.props.cols.includes(e) && !_this9.props.hiddenAttributes.includes(e) && !_this9.props.hiddenFromDragDrop.includes(e);
                }).sort((0, $25ed1e0e429105db$exports.sortAs)(this.state.unusedOrder));
                var unusedLength = unusedAttrs.reduce(function(r, e) {
                    return r + e.length;
                }, 0);
                var horizUnused = unusedLength < this.props.unusedOrientationCutoff;
                var rendererPivotTableUISettings = this.props.rendererPivotTableUISettings;
                var unusedAttrsCell = this.makeDnDCell(unusedAttrs, function(order) {
                    return _this9.setState({
                        unusedOrder: order
                    });
                }, "p-3 align-top pvtAxisContainer pvtUnused " + (horizUnused ? "pvtHorizList" : "pvtVertList"), "unusedAttrs", "Unused columns");
                var colAttrs = this.props.cols.filter(function(e) {
                    return !_this9.props.hiddenAttributes.includes(e) && !_this9.props.hiddenFromDragDrop.includes(e);
                });
                var colAttrsCell = this.makeDnDCell(colAttrs, this.propUpdater("cols"), "pvtAxisContainer pvtHorizList pvtCols p-3 align-top", "colAttrs", rendererPivotTableUISettings.xAxisSecondary.label || "Secondary categories (X-axis) or table columns", rendererPivotTableUISettings.xAxisSecondary.limit || 1);
                var rowAttrs = this.props.rows.filter(function(e) {
                    return !_this9.props.hiddenAttributes.includes(e) && !_this9.props.hiddenFromDragDrop.includes(e);
                });
                var rowAttrsCell = this.makeDnDCell(rowAttrs, this.propUpdater("rows"), "pvtAxisContainer pvtVertList pvtRows p-3 align-top", "rowAttrs", rendererPivotTableUISettings.xAxisPrimary.label || "Main category (X-axis) or table rows", rendererPivotTableUISettings.xAxisPrimary.limit || 1);
                var outputCell = $f455ece61e3e4c07$var$_react2.default.createElement("td", {
                    className: "pvtOutput h-full",
                    rowSpan: 3
                }, $f455ece61e3e4c07$var$_react2.default.createElement("div", {
                    className: "p-8 h-full flex items-center justify-center"
                }, $f455ece61e3e4c07$var$_react2.default.createElement($f455ece61e3e4c07$var$_PivotTable2.default, (0, $f455ece61e3e4c07$var$_immutabilityHelper2.default)(this.props, {
                    data: {
                        $set: this.state.materializedInput
                    }
                }))));
                // vv this won't work with the current layout (because of rowspan)
                // if (horizUnused) {
                //   return (
                //     <table className="pvtUi">
                //       <tbody onClick={() => this.setState({ openDropdown: false })}>
                //         <tr>
                //           {rendererCell}
                //           {unusedAttrsCell}
                //         </tr>
                //         <tr>
                //           {aggregatorCell}
                //           {colAttrsCell}
                //         </tr>
                //         <tr>
                //           {rowAttrsCell}
                //           {outputCell}
                //         </tr>
                //       </tbody>
                //     </table>
                //   );
                // }
                return $f455ece61e3e4c07$var$_react2.default.createElement("table", {
                    className: "pvtUi h-full"
                }, $f455ece61e3e4c07$var$_react2.default.createElement("tbody", {
                    onClick: function onClick() {
                        return _this9.setState({
                            openDropdown: false
                        });
                    }
                }, $f455ece61e3e4c07$var$_react2.default.createElement("tr", null, rendererCell, aggregatorCell, outputCell), $f455ece61e3e4c07$var$_react2.default.createElement("tr", null, unusedAttrsCell, rowAttrsCell), $f455ece61e3e4c07$var$_react2.default.createElement("tr", null, colAttrsCell)));
            }
        }
    ]);
    return PivotTableUI;
}($f455ece61e3e4c07$var$_react2.default.PureComponent);
$f455ece61e3e4c07$var$PivotTableUI.propTypes = Object.assign({}, $f455ece61e3e4c07$var$_PivotTable2.default.propTypes, {
    onChange: $f455ece61e3e4c07$var$_propTypes2.default.func.isRequired,
    hiddenAttributes: $f455ece61e3e4c07$var$_propTypes2.default.arrayOf($f455ece61e3e4c07$var$_propTypes2.default.string),
    hiddenFromAggregators: $f455ece61e3e4c07$var$_propTypes2.default.arrayOf($f455ece61e3e4c07$var$_propTypes2.default.string),
    hiddenFromDragDrop: $f455ece61e3e4c07$var$_propTypes2.default.arrayOf($f455ece61e3e4c07$var$_propTypes2.default.string),
    unusedOrientationCutoff: $f455ece61e3e4c07$var$_propTypes2.default.number,
    menuLimit: $f455ece61e3e4c07$var$_propTypes2.default.number
});
$f455ece61e3e4c07$var$PivotTableUI.defaultProps = Object.assign({}, $f455ece61e3e4c07$var$_PivotTable2.default.defaultProps, {
    hiddenAttributes: [],
    hiddenFromAggregators: [],
    hiddenFromDragDrop: [],
    unusedOrientationCutoff: 85,
    menuLimit: 500
});
$f455ece61e3e4c07$exports.default = $f455ece61e3e4c07$var$PivotTableUI;










var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

function $220c144d45bb9a88$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $220c144d45bb9a88$export$99ca0c5cb670cc62({ value: value, callback: callback, formatting: formatting, attr: attr, stub: stub }) {
    // value is the value of the input field from the state of the parent component
    // callback is the function to be called when the input field is changed
    // formatting needs a string, attr as string (field name) and stub as string
    const [hasFocus, setFocus] = (0, $7fPBF.useState)(false);
    const [widthState, setWidthState] = (0, $7fPBF.useState)(0);
    const [measuringInProgress, setMeasuringInProgress] = (0, $7fPBF.useState)(false); // turns on and off the span component for a fraction of a sec, trick to measure / resize input field
    // ^^  turn this true for debug if there are any issues with length of the field
    const measurer = (0, $7fPBF.useRef)(null);
    const myInputField = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        setMeasuringInProgress(true);
    }, [
        value,
        hasFocus
    ]);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (measuringInProgress && (measurer === null || measurer === void 0 ? void 0 : measurer.current)) {
            const rect = measurer.current.getBoundingClientRect();
            setWidthState(rect.width + (hasFocus ? 72 : 0) + 24 /* account for padding */ );
            setMeasuringInProgress(false);
        }
    }, [
        measuringInProgress
    ]);
    function handleFieldOk(e) {
        setFocus(false);
        myInputField.current.blur();
    }
    function handleFieldCancel(e) {
        setFocus(false);
        myInputField.current.blur();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
        htmlFor: `${attr}-input`,
        className: "relative h-full",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: $220c144d45bb9a88$export$ce4ab0c55987d1ff(formatting, "whitespace-nowrap"),
                ref: measurer,
                children: measuringInProgress && (value || stub)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                className: $220c144d45bb9a88$export$ce4ab0c55987d1ff("bg-gray-50 border-none rounded", formatting, "hover:underline hover:cursor-pointer focus:cursor-text focus:ring-1 focus:ring-offset-0 focus:outline-none focus:ring-brandBlue-400"),
                style: {
                    width: widthState
                },
                id: `${attr}-input`,
                ref: myInputField,
                placeholder: stub,
                value: value,
                onChange: (e)=>callback(e.target.value),
                onKeyPress: (e)=>{
                    if (e.key === "Enter") handleFieldOk();
                },
                onFocus: ()=>setFocus(true),
                onBlur: (e)=>{
                    // a short timeout to delay the blur event until the onclick event of the buttons have been processed
                    setTimeout(()=>handleFieldCancel(e), 150);
                },
                type: "text"
            }),
            hasFocus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "absolute flex right-0 top-0 -mt-1 h-full space-x-2 pr-2 z-10",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: handleFieldOk,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef0832052dc462d9$export$2e2bcd8739ae039), {
                            className: $220c144d45bb9a88$export$ce4ab0c55987d1ff(attr === "name" ? "h-6 w-6" : "hidden", "text-gray-300 hover:text-gray-400 hover:cursor-pointer")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        onClick: (e)=>{
                            // a short timeout to delay the blur event until the onclick event of the buttons have been processed
                            setTimeout(()=>{
                                handleFieldCancel(e);
                            }, 150);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09a3181ea7eaeecc$export$2e2bcd8739ae039), {
                            className: $220c144d45bb9a88$export$ce4ab0c55987d1ff(attr === "name" ? "h-6 w-6" : "hidden", "text-gray-300 hover:text-gray-400 hover:cursor-pointer")
                        })
                    })
                ]
            })
        ]
    });
}
$220c144d45bb9a88$export$99ca0c5cb670cc62.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    formatting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    attr: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    stub: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired
};







function $d953e598c478eea1$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $d953e598c478eea1$export$2e2bcd8739ae039({ report: report, setReport: setReport, setDisplayedReportDef: setDisplayedReportDef }) {
    var _pivotTableUIRef_current;
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const reportTemplate = {
        cols: [
            "accountName"
        ],
        rows: [
            "category"
        ],
        vals: [
            "amount"
        ],
        aggregatorName: "Sum",
        rendererName: "Bar chart, vertical, grouped",
        name: "New report",
        dataScope: "transactions",
        valueFilter: {},
        dateFilter: {
            from: null,
            to: null,
            id: "noFilter"
        },
        colOrder: "key_a_to_z",
        rowOrder: "key_a_to_z"
    };
    // initialise chartState: spread default report template and then report values if there are any (there will be none if this is a new report)
    const [chartState, setChartState] = (0, $7fPBF.useState)((0, $2qxEV._)((0, $9tqwB._)({}, reportTemplate, report), {
        dateFilter: (0, $9tqwB._)({}, reportTemplate === null || reportTemplate === void 0 ? void 0 : reportTemplate.dateFilter, report === null || report === void 0 ? void 0 : report.dateFilter)
    }));
    const [formIsDirty, setFormIsDirty] = (0, $7fPBF.useState)(false); // keeps track of whether anything has been changed
    const pivotTableUIRef = (0, $7fPBF.useRef)();
    const pivotTableUIProps = (_pivotTableUIRef_current = pivotTableUIRef.current) === null || _pivotTableUIRef_current === void 0 ? void 0 : _pivotTableUIRef_current.props;
    const dataDependentSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $1d60fcd5cdaf946c$export$2e2bcd8739ae039)(state, chartState.dataScope));
    function twoValueSum() {
        return function([attr1, attr2]) {
            return function() {
                let sumAttr1 = 0;
                let sumAttr2 = 0;
                return {
                    push: (record)=>{
                        if (!Number.isNaN(parseFloat(record[attr1]))) sumAttr1 += parseFloat(record[attr1]);
                        if (!Number.isNaN(parseFloat(record[attr2]))) sumAttr2 += parseFloat(record[attr2]);
                    },
                    value: ()=>`${sumAttr1} ${sumAttr2}`,
                    format: (x)=>x,
                    numInputs: 2
                };
            };
        };
    }
    const customAggregators = {
        "Sum, two values": twoValueSum()
    };
    (0, $7fPBF.useEffect)(()=>{
        // on initial load (i.e. aggregators attribute is not there yet), copy the extended set of props from PivotTableUI up to chartState to keep them in sync
        // as this will then be used to save the report
        // this does not work with a dependency array, as the first pass still does not have the PivotTableUI props
        if (!chartState.aggregators) {
            console.log("copying default props from PivotTableUI to ReportEdit");
            setChartState((0, $2qxEV._)((0, $9tqwB._)({}, pivotTableUIProps, chartState), {
                aggregators: (0, $9tqwB._)({}, pivotTableUIProps === null || pivotTableUIProps === void 0 ? void 0 : pivotTableUIProps.aggregators, customAggregators)
            }));
        }
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        // if dataScope is changed, update the chartState with the new data, from where it will get updated in PivotTableUI
        setChartState((0, $9tqwB._)({}, chartState, dataDependentSettings));
    }, [
        chartState.dataScope,
        dataDependentSettings
    ]);
    const alert = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.alert);
    function handleClose(e) {
        setDisplayedReportDef(report);
        setReport(undefined);
    }
    // handle user input from alert modal when closing the entire form
    (0, $7fPBF.useEffect)(()=>{
        if ((alert === null || alert === void 0 ? void 0 : alert.id) === "aboutToLoseData") {
            if ((alert === null || alert === void 0 ? void 0 : alert.response) === "ok") handleClose();
        }
    }, [
        alert === null || alert === void 0 ? void 0 : alert.response
    ]);
    // FIXME: balances data source
    function handleSave(e) {
        const reportDef = {
            id: chartState.id || (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
            name: chartState.name,
            dataScope: chartState.dataScope,
            cols: chartState.cols,
            rows: chartState.rows,
            vals: chartState.vals,
            aggregatorName: chartState.aggregatorName,
            rendererName: chartState.rendererName,
            dateFilter: chartState.dateFilter,
            valueFilter: chartState.valueFilter,
            colOrder: chartState.colOrder,
            rowOrder: chartState.rowOrder
        };
        setReport(reportDef);
        if (chartState.id) {
            // there was an id in the chartState already, so this is an update
            console.info("updating report", reportDef);
            dispatch((0, $34d01d41f17850bb$export$4f2fb5656642a535)(reportDef));
        } else {
            console.info("saving new report", reportDef);
            dispatch((0, $34d01d41f17850bb$export$c8ce4d616f681ea6)((0, $9tqwB._)({}, reportDef)));
        }
        setDisplayedReportDef(reportDef);
        setReport(undefined);
    }
    function handleCancel(e) {
        if (formIsDirty) dispatch((0, $3b9398d0f9c152fb$export$91020d7983105237)("aboutToLoseData", chartState.id, ()=>handleClose()));
        else handleClose();
    }
    // handle user input from alert modal when deleting project
    (0, $7fPBF.useEffect)(()=>{
        if ((alert === null || alert === void 0 ? void 0 : alert.id) === "aboutToLoseData" && (alert === null || alert === void 0 ? void 0 : alert.caller) === chartState.id && (alert === null || alert === void 0 ? void 0 : alert.response)) {
            if ((alert === null || alert === void 0 ? void 0 : alert.response) === "ok") handleClose();
        }
        // presence of "alert.response" means the user clicked something, so we can clear the alert
        dispatch((0, $3b9398d0f9c152fb$export$e5a625708957e77)());
    }, [
        alert === null || alert === void 0 ? void 0 : alert.response
    ]);
    // this is used as callback from PivotTableUI which synchronises ReportEdit state
    function handleChange(reportDef) {
        setChartState(reportDef);
        setFormIsDirty(true);
    }
    function setDateFilter(from = null, to = null, id = "noFilter") {
        // check if the new filter criteria return any rows from data
        // if not, show a toas</td>t message and do not update the filter
        const newState = chartState.data.filter((x)=>x.date > (from || new Date(1902, 0, 1).valueOf()) && x.date <= (to || new Date(2200, 0, 1).valueOf()));
        if ((newState === null || newState === void 0 ? void 0 : newState.length) > 0) setChartState((0, $2qxEV._)((0, $9tqwB._)({}, chartState), {
            dateFilter: {
                from: from,
                to: to,
                id: id
            }
        }));
        else dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("noDataForDateFilter"));
    }
    // create an event listener which calls setAlert when the user hits Esc when there are changes in the Grid view
    // DO NOT attempt to move it to the Redux alert, it won't work, as hooks cannot be used in listeners
    (0, $7fPBF.useEffect)(()=>{
        function handleEsc(e) {
            if (e.key === "Escape") handleClose();
        }
        document.addEventListener("keydown", handleEsc, false);
        return ()=>{
            document.removeEventListener("keydown", handleEsc, false);
        };
    }, []); // it needs to be one object; if it is more, it creates several listeners
    // handle user input from alert modal when deleting project
    (0, $7fPBF.useEffect)(()=>{
        if ((alert === null || alert === void 0 ? void 0 : alert.id) === "youAreAboutToDeleteReport" && (alert === null || alert === void 0 ? void 0 : alert.caller) === chartState.id && (alert === null || alert === void 0 ? void 0 : alert.response)) {
            if ((alert === null || alert === void 0 ? void 0 : alert.response) === "ok") dispatch((0, $34d01d41f17850bb$export$da764d61c8c69f9a)(report)).then((data)=>{
                setReport(null);
            });
            // presence of "alert.response" means the user clicked something, so we can clear the alert
            dispatch((0, $3b9398d0f9c152fb$export$e5a625708957e77)());
        }
    }, [
        alert === null || alert === void 0 ? void 0 : alert.response
    ]);
    // these depend of which dataScope are we displaying
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        id: "projectDetailsParent",
        className: "absolute w-full h-auto min-h-full z-50 top-0 left-0 md:p-16 bg-gray-300 bg-opacity-90 space-y-6",
        role: "dialog",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: `relative bg-gray-50 shadow px-4 py-5 xl:h-[85vh] sm:rounded-lg sm:pl-8 sm:pr-10 sm:py-8 flex flex-col gap-4 sm:gap-8
        overflow-y-scroll scrollbar-thin scrollbar-track-rounded scrollbar-thumb-rounded scrollbar-track-gray-200 scrollbar-thumb-gray-400`,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: "fixed top-0 right-0 m-4 cursor-pointer",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $341a41b70f0b63cc$export$2e2bcd8739ae039), {
                        className: "w-6 h-6 text-gray-500 hover:text-gray-600",
                        onClick: handleClose
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                    "aria-label": "project header",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex items-center justify-between pt-4 sm:pt-0",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex-1 items-center min-w-min",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $220c144d45bb9a88$export$99ca0c5cb670cc62), {
                                    value: chartState === null || chartState === void 0 ? void 0 : chartState.name,
                                    callback: (newValue)=>setChartState((0, $2qxEV._)((0, $9tqwB._)({}, chartState), {
                                            name: newValue
                                        })),
                                    formatting: "sm:-ml-[0.4rem] sm:mr-2 text-2xl sm:text-3xl font-bold text-gray-900",
                                    attr: "name",
                                    stub: "Report name?"
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-1 w-full flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex items-center font-semibold text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    setChartState((0, $2qxEV._)((0, $9tqwB._)({}, chartState), {
                                                        dataScope: "transactions",
                                                        vals: [
                                                            "amount"
                                                        ]
                                                    })); // reset the 'value' to a value field available in transactions
                                                    setFormIsDirty(true);
                                                },
                                                // chartState is controlled by this component and is initialised to the report object, so check for dataScope there
                                                className: $d953e598c478eea1$var$classNames((chartState === null || chartState === void 0 ? void 0 : chartState.dataScope) === "transactions" ? "bg-gray-200 text-gray-900" : "bg-white text-gray-400", "relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 focus:border-brandBlue-400"),
                                                children: t("transactions")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    setChartState((0, $2qxEV._)((0, $9tqwB._)({}, chartState), {
                                                        dataScope: "assets",
                                                        vals: [
                                                            "currentValue"
                                                        ]
                                                    })); // reset the 'value' to a value field available in transactions
                                                    setFormIsDirty(true);
                                                },
                                                className: $d953e598c478eea1$var$classNames((chartState === null || chartState === void 0 ? void 0 : chartState.dataScope) === "assets" ? "bg-gray-200 text-gray-700" : "bg-white text-gray-400", "-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 focus:border-brandBlue-400"),
                                                children: t("balances")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>{
                                                    setChartState((0, $2qxEV._)((0, $9tqwB._)({}, chartState), {
                                                        dataScope: "snapshots",
                                                        vals: [
                                                            "value"
                                                        ]
                                                    })); // reset the 'value' to a value field available in transactions
                                                    setFormIsDirty(true);
                                                },
                                                className: $d953e598c478eea1$var$classNames((chartState === null || chartState === void 0 ? void 0 : chartState.dataScope) === "snapshots" ? "bg-gray-200 text-gray-700" : "bg-white text-gray-400", "-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-brandBlue-400 focus:border-brandBlue-400"),
                                                children: t("history")
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                id: "report-edit-help-button",
                                                href: `/${i18n.language}/blog/${(0, $99f87ace30ad8515$export$ed2efc2636e0089e)("reporting", i18n.language)}`,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "ml-4 cursor-pointer group",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                    info: t("accountDetails.help"),
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "text-brandBlue-400 text-sm font-semibold group-hover:text-brandBlue-500",
                                                            children: "How to use reports?"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $60f58cdd0c2aa415$export$2e2bcd8739ae039), {
                                                            className: "w-4 h-4 ml-1 text-brandBlue-400 group-hover:text-brandBlue-500"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "flex gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("save"),
                                                onClick: handleSave,
                                                withAccent: true
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                text: t("cancel"),
                                                onClick: handleCancel
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "h-full max-h-full -mx-4",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bf18c8a9090be1b$exports.ErrorBoundary), {
                        FallbackComponent: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f455ece61e3e4c07$exports))), (0, $2qxEV._)((0, $9tqwB._)({
                            ref: pivotTableUIRef
                        }, chartState), {
                            setDateFilter: setDateFilter,
                            onChange: handleChange,
                            renderers: (0, $1d1b0fee492045ec$export$2e2bcd8739ae039),
                            rendererPivotTableUISettings: (0, $5958bfc3d629e828$export$89ed09c46a8b3587)(chartState.rendererName),
                            unusedOrientationCutoff: 0
                        }))
                    })
                })
            ]
        })
    }));
}
$d953e598c478eea1$export$2e2bcd8739ae039.propTypes = {
    report: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    setReport: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    setDisplayedReportDef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$d953e598c478eea1$export$2e2bcd8739ae039.defaultProps = {
    report: undefined,
    setReport: null
};













/* eslint-disable max-len */ /* eslint-disable react/require-default-props */ /* eslint-disable react/forbid-prop-types */ 

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $bfff81cd0bb9f4a3$var$ChevronDoubleRightIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M13.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L11.69 12 4.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $7fPBF.createElement("path", {
        fillRule: "evenodd",
        d: "M19.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06L17.69 12l-6.97-6.97a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
        clipRule: "evenodd"
    }));
}
const $bfff81cd0bb9f4a3$var$ForwardRef = $7fPBF.forwardRef($bfff81cd0bb9f4a3$var$ChevronDoubleRightIcon);
var $bfff81cd0bb9f4a3$export$2e2bcd8739ae039 = $bfff81cd0bb9f4a3$var$ForwardRef;




function $e62d1efc735214a3$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $e62d1efc735214a3$export$2e2bcd8739ae039({ reportDefs: reportDefs, displayedReportDef: displayedReportDef, setDisplayedReportDef: setDisplayedReportDef, setReport: setReport, showSpinner: showSpinner }) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("reporting");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "hidden lg:block",
                children: [
                    [
                        ...reportDefs
                    ].sort((a, b)=>a.name.localeCompare(b.name)).map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setDisplayedReportDef(item),
                            onDoubleClick: ()=>setReport(item),
                            className: `
                    ${(item === null || item === void 0 ? void 0 : item.id) === (displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.id) ? "bg-brandBlue-50 border-brandBlue-500 text-brandBlue-700 hover:bg-brandBlue-50 hover:text-brandBlue-700" : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900"}
                    group border-l-4 px-3 py-2 flex items-center text-sm font-medium w-full`,
                            "aria-current": (item === null || item === void 0 ? void 0 : item.id) === (displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.id) ? "page" : undefined,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bfff81cd0bb9f4a3$export$2e2bcd8739ae039), {
                                    className: `
                      ${(item === null || item === void 0 ? void 0 : item.id) === (displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.id) ? "text-brandBlue-500 group-hover:text-brandBlue-500" : "text-gray-400 group-hover:text-gray-500"}
                      flex-shrink-0 -ml-1 mr-3 h-6 w-6`,
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "truncate",
                                    children: item.name
                                }),
                                !item.readOnly && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "ml-2 inline-flex items-center rounded-md bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-600",
                                    children: t("myReport")
                                })
                            ]
                        }, item.name)),
                    showSpinner && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "w-full flex justify-center",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                            className: "text-gray-300 w-10 h-10 animate-spin"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659), {
                className: "lg:hidden",
                value: displayedReportDef,
                onChange: setDisplayedReportDef,
                children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "relative mt-2",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Button, {
                                className: "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-brandBlue-600 sm:text-sm sm:leading-6",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "block truncate",
                                        children: displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.name
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1205e1ea1e824e93$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-gray-400",
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                show: open,
                                as: (0, $7fPBF.Fragment),
                                leave: "transition ease-in duration-100",
                                leaveFrom: "opacity-100",
                                leaveTo: "opacity-0",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Options, {
                                    className: "absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                    children: [
                                        ...reportDefs
                                    ].map((person)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb7e0d651f5bfe47$export$8bad31ff872c7659).Option, {
                                            className: ({ active: active })=>$e62d1efc735214a3$var$classNames(active ? "bg-brandBlue-500 text-white" : "text-gray-900", "relative cursor-default select-none py-2 pl-3 pr-9"),
                                            value: person,
                                            children: ({ selected: selected, active: active })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: $e62d1efc735214a3$var$classNames(selected ? "font-semibold" : "font-normal", "block truncate"),
                                                            children: person.name
                                                        }),
                                                        selected ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: $e62d1efc735214a3$var$classNames(active ? "text-white" : "text-brandBlue-500", "absolute inset-y-0 right-0 flex items-center pr-4"),
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $019bed45533ced54$export$2e2bcd8739ae039), {
                                                                className: "h-5 w-5",
                                                                "aria-hidden": "true"
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                        }, person.id))
                                })
                            })
                        ]
                    })
            })
        ]
    });
}
$e62d1efc735214a3$export$2e2bcd8739ae039.propTypes = {
    reportDefs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object).isRequired,
    displayedReportDef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any),
    setDisplayedReportDef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    setReport: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    showSpinner: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$e62d1efc735214a3$export$2e2bcd8739ae039.defaultProps = {
    displayedReportDef: null,
    showSpinner: false
};



function $677f2a0982b8fa97$export$2e2bcd8739ae039() {
    const [displayedReportDef, setDisplayedReportDef] = (0, $7fPBF.useState)(undefined); // which report is displayed in the current view
    const [report, setReport] = (0, $7fPBF.useState)(undefined); // undefined means initialised, null means new report, report obj means existing report
    const [calendar, setCalendarState] = (0, $7fPBF.useState)({
        visible: false,
        selectedDate: null,
        callback: null
    }); // calendar used to set the baseline for comparison to current net worth
    const [settings, setSettings] = (0, $7fPBF.useState)(false); // truthy or true for settings visible or name of tab; false or falsey for settings hidden
    const [recommendUsVisible, setRecommendUsVisible] = (0, $7fPBF.useState)(false); // truthy or true for recommendUs visible or name of tab; false or falsey for recommendUs hidden
    const [searchControl, setSearchControl] = (0, $7fPBF.useState)({
        text: "",
        searching: false,
        focus: null
    }); // search results for the search bar;
    // this memoizes data and makes it not get refreshed on every state update
    const selectCategoryStatus = (0, $5c22629b42831e80$export$595d22ed68ca2841)((state)=>state.data, (data)=>Object.entries(data).reduce((prev, [category, value])=>(0, $2qxEV._)((0, $9tqwB._)({}, prev), {
                [category]: value.status
            }), {}));
    const categoryStatus = (0, $51238fa605392ada$export$2105062e25df4afe)(selectCategoryStatus);
    const dashboardMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.simulation.dashboardMode);
    const rehydrationStatus = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.rehydrationStatus);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("reporting");
    // settings === true: call Settings with no openOnTab (i.e. default tab)
    // settings is string: call Settings with the string
    // settings is falsey: do not call Settings
    const SettingsComponent = settings ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c7015f341e5714ae$export$2e2bcd8739ae039), {
        closeCallback: ()=>setSettings(false),
        openOnTab: settings === true ? null : settings,
        calendarState: calendar,
        setCalendarState: setCalendarState,
        setSettings: setSettings
    }) : null;
    // if no data loaded, dispatch loading and suspend
    (0, $7fPBF.useEffect)(()=>{
        // get fx data from the separate service
        // quotes should be retrieved in the reducer by getData
        dispatch((0, $101425bdfe5b6af9$export$b00a271f69f3d728)());
        dispatch((0, $34d01d41f17850bb$export$9dc937f1c1abf620)());
        // get data if there is none (store initialises the category with status: 'idle')
        (0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e).forEach((category)=>{
            if (rehydrationStatus === "finished" && categoryStatus[category] !== "success") dispatch($f1c3fa004749592f$export$dfb022681f1048bc(category));
        });
    }, [
        rehydrationStatus
    ]);
    const reportDefs = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.reports);
    const fullscreenReport = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.message.fullscreenReport);
    // as soon as the reportDefs are loaded, set the displayed report to the first one
    const prevReportDefs = (0, $7fPBF.useRef)([]);
    (0, $7fPBF.useEffect)(()=>{
        var _prevReportDefs_current;
        if ((reportDefs === null || reportDefs === void 0 ? void 0 : reportDefs.length) > 0 && ((_prevReportDefs_current = prevReportDefs.current) === null || _prevReportDefs_current === void 0 ? void 0 : _prevReportDefs_current.length) === 0) // display sunburst if you can find it, otherwise display the first one
        setDisplayedReportDef(reportDefs.find((r)=>r.id === "allAssetsSunburstxxxx") || reportDefs[0]);
        prevReportDefs.current = reportDefs;
    }, [
        reportDefs
    ]);
    const standardPivotTableProps = {
        onChange: (s)=>setDisplayedReportDef(s),
        renderers: $5958bfc3d629e828$export$2e2bcd8739ae039
    };
    function handleNewReport() {
        // create new report from template
        setReport(null);
    // run postReport and wait for data to be refreshed and then set the new report as current in setReportId
    }
    function handleDeleteReport(e) {
        dispatch((0, $34d01d41f17850bb$export$da764d61c8c69f9a)(displayedReportDef));
        setDisplayedReportDef(undefined);
    }
    function handleDuplicateReport(e) {
        dispatch((0, $34d01d41f17850bb$export$c8ce4d616f681ea6)((0, $2qxEV._)((0, $9tqwB._)({}, displayedReportDef), {
            id: (0, $8136d14ed46fb244$export$ac4959f4f1338dfc)(),
            name: `${displayedReportDef.name} (copy)`
        })));
    }
    const dataSettings = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>(0, $1d60fcd5cdaf946c$export$2e2bcd8739ae039)(state, displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.dataScope));
    dataSettings.data = dataSettings.data.filter((x)=>{
        var _displayedReportDef_dateFilter, _displayedReportDef_dateFilter1;
        return x.date > ((displayedReportDef === null || displayedReportDef === void 0 ? void 0 : (_displayedReportDef_dateFilter = displayedReportDef.dateFilter) === null || _displayedReportDef_dateFilter === void 0 ? void 0 : _displayedReportDef_dateFilter.from) || new Date(1902, 0, 1).valueOf()) && x.date <= ((displayedReportDef === null || displayedReportDef === void 0 ? void 0 : (_displayedReportDef_dateFilter1 = displayedReportDef.dateFilter) === null || _displayedReportDef_dateFilter1 === void 0 ? void 0 : _displayedReportDef_dateFilter1.to) || new Date(2200, 0, 1).valueOf());
    });
    // CAUTION: this function is also used in ReportEdit, ChartWrapper and PivotTableUI, if changing it here - change it there as well
    function setAccount(account) {
        navigate(`/${i18n.language}/app/dashboard`, {
            state: {
                account: account
            }
        });
    }
    function handleModeSwitch() {
        if (dashboardMode === "dashboard") dispatch({
            type: "simulation/setDashboardMode",
            payload: {
                dashboardMode: "projects"
            }
        });
        if (dashboardMode === "projects") dispatch({
            type: "simulation/setDashboardMode",
            payload: {
                dashboardMode: "dashboard"
            }
        });
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "overflow-scroll h-screen",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "relative xl:static",
            children: [
                (report || report === null) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d953e598c478eea1$export$2e2bcd8739ae039), {
                    report: report,
                    setReport: setReport,
                    setDisplayedReportDef: setDisplayedReportDef
                }),
                SettingsComponent,
                recommendUsVisible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1efa4a2a7158b1cd$export$2e2bcd8739ae039), {
                    setRecommendUsVisible: setRecommendUsVisible
                }),
                fullscreenReport && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab6676e849ba8635$export$2e2bcd8739ae039), {
                    reportProps: fullscreenReport
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "relative min-h-full bg-gray-50",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a05383fb5bb0535$export$2e2bcd8739ae039), {
                            mode: "reports",
                            openSettings: ()=>setSettings(true),
                            openAccount: ()=>setSettings("account"),
                            searchControl: searchControl,
                            setSearchControl: setSearchControl,
                            setRecommendUsVisible: setRecommendUsVisible
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                            className: "pb-8 lg:-mt-36",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "relative max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-[100rem] lg:px-8",
                                children: [
                                    searchControl.text && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4e9d517aec5d290d$export$aee53da69e9839be), {
                                        searchControl: searchControl,
                                        setSearchControl: setSearchControl,
                                        setAccount: setAccount
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "relative lg:pl-4 pt-6 lg:pt-10 pb-2 lg:pb-8",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                            className: "text-2xl sm:text-3xl md:text-4xl lg:text-3xl xl:text-4xl font-bold text-gray-900 lg:text-white",
                                            children: t("yourReports")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "lg:bg-white lg:rounded-md lg:shadow flex flex-col gap-4",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("aside", {
                                                    className: "pt-4 pb-6 lg:col-span-3",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("nav", {
                                                        className: "space-y-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "text-sm lg:font-semibold lg:text-base lg:ml-4 mb-1 lg:mb-4",
                                                                children: t("selectReport")
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e62d1efc735214a3$export$2e2bcd8739ae039), {
                                                                reportDefs: reportDefs,
                                                                displayedReportDef: displayedReportDef,
                                                                setDisplayedReportDef: setDisplayedReportDef,
                                                                setReport: setReport
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "divide-y divide-gray-200 lg:col-span-9",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "hidden lg:flex py-6 px-4 sm:p-6 lg:pb-6 gap-2 items-center justify-between",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                    className: "flex items-center gap-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                            onClick: handleNewReport,
                                                                            text: t("new"),
                                                                            withAccent: true,
                                                                            size: "xl"
                                                                        }),
                                                                        displayedReportDef && !displayedReportDef.readOnly && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                                    info: t("tooltips.edit"),
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                                        onClick: ()=>setReport(displayedReportDef),
                                                                                        text: t("edit"),
                                                                                        size: "xl"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                                    info: t("tooltips.duplicate"),
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                                        onClick: handleDuplicateReport,
                                                                                        text: t("duplicate"),
                                                                                        size: "xl"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                                    info: t("tooltips.delete"),
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                                        onClick: handleDeleteReport,
                                                                                        text: t("delete"),
                                                                                        size: "xl"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                                            id: "report-edit-help-button",
                                                                            href: `/${i18n.language}/blog/${(0, $99f87ace30ad8515$export$ed2efc2636e0089e)("reporting", i18n.language)}`,
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            className: "ml-4 cursor-pointer group",
                                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $cb9574c61f730564$export$2e2bcd8739ae039), {
                                                                                info: t("accountDetails.help"),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                        className: "text-brandBlue-400 text-sm font-semibold group-hover:text-brandBlue-500",
                                                                                        children: "How to use reports?"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee0d8d9d593dfbcf$export$2e2bcd8739ae039), {
                                                                                        className: "w-4 h-4 ml-1 text-brandBlue-400 group-hover:text-brandBlue-500"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                                                    onClick: handleModeSwitch,
                                                                    text: dashboardMode === "dashboard" ? t("switchToProjects") : t("switchToDashboard"),
                                                                    formatting: "justify-self-end",
                                                                    size: "xl"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                            className: `py-6 px-4 sm:p-6 lg:pb-8 ${(displayedReportDef === null || displayedReportDef === void 0 ? void 0 : displayedReportDef.rendererName) === "List" ? "" : "min-h-[60vh] grid"}`,
                                                            children: Object.values(categoryStatus).every((status)=>status !== "loading") ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $9tqwB._)({}, standardPivotTableProps, dataSettings, displayedReportDef)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "w-full flex justify-center",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                                    className: "text-gray-300 w-10 h-10 animate-spin"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75977f0ca8247e66$export$2e2bcd8739ae039), {
                            componentName: "reporting"
                        })
                    ]
                })
            ]
        })
    });
}


/* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");


var $7fPBF = parcelRequire("7fPBF");



/* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");



parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function $f4858a250b66c7ec$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $f4858a250b66c7ec$export$2e2bcd8739ae039({ onClick: onClick, active: active, label: label }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: $f4858a250b66c7ec$var$classNames(active ? "bg-white border-gray-200 shadow-sm text-gray-900" : "border border-transparent text-gray-700 ", "relative w-1/2 rounded-md py-2 text-sm font-medium whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-brandBlue-500 focus:z-10 sm:w-auto sm:px-8"),
        children: label
    });
}
$f4858a250b66c7ec$export$2e2bcd8739ae039.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};




// order of this array matters (they will be displayed in this order, filtered by billingFrequency)
const $d4f53529bc97f8c8$var$products = (0, $79e0ab95975351a2$export$2e2bcd8739ae039)();
function $d4f53529bc97f8c8$export$2e2bcd8739ae039({ formState: formState, formSetState: formSetState, goForward: goForward, goBack: goBack }) {
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    function handleClick(tierId, tierType, frequency) {
        const annualBilling = frequency === "annually";
        const displayProducts = $d4f53529bc97f8c8$var$products.filter((product)=>product.billingFrequency === (annualBilling ? "annually" : "monthly"));
        const selectedProduct = displayProducts.find((product)=>product.tierId === tierId);
        // move billing day to a day that exists in all months
        const billingDayOfMonth = new Date().getDate() > 28 ? 28 : new Date().getDate();
        formSetState((0, $2qxEV._)((0, $9tqwB._)({}, formState), {
            tierType: selectedProduct.type,
            tierId: selectedProduct.tierId,
            annualBilling: annualBilling,
            stripePriceId: selectedProduct.stripePriceId,
            billingPerMonth: selectedProduct.monthlyPrice,
            billingDayOfMonth: billingDayOfMonth
        }));
        goForward();
    }
    const format = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 mt-12 sm:px-6 lg:px-8",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $845fa5e8f4bd3a65$export$2e2bcd8739ae039), {
                buttonFunction: handleClick,
                selectedTier: formState.tierId
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-center mt-8",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: "border border-brandBlue-400 rounded-md text-brandBlue-400 text-sm font-semibold hover:bg-gray-50 py-2 px-6",
                    onClick: goBack,
                    children: t("register.goBack")
                })
            })
        ]
    });
}
$d4f53529bc97f8c8$export$2e2bcd8739ae039.propTypes = {
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    formSetState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};


/* eslint-disable react/forbid-prop-types */ /* eslint-disable max-len */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");
var $9a07abecab93e2ee$exports = {};
"use strict";
Object.defineProperty($9a07abecab93e2ee$exports, "__esModule", {
    value: true
});
$9a07abecab93e2ee$exports.resetGlobalState = $9a07abecab93e2ee$exports.useEventSource = $9a07abecab93e2ee$exports.ReadyState = $9a07abecab93e2ee$exports.useSocketIO = $9a07abecab93e2ee$exports.default = void 0;
var $9b7740e6413257da$exports = {};
"use strict";
var $9b7740e6413257da$var$__assign = $9b7740e6413257da$exports && $9b7740e6413257da$exports.__assign || function() {
    $9b7740e6413257da$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9b7740e6413257da$var$__assign.apply(this, arguments);
};
var $9b7740e6413257da$var$__awaiter = $9b7740e6413257da$exports && $9b7740e6413257da$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b7740e6413257da$var$__generator = $9b7740e6413257da$exports && $9b7740e6413257da$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9b7740e6413257da$var$__importDefault = $9b7740e6413257da$exports && $9b7740e6413257da$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($9b7740e6413257da$exports, "__esModule", {
    value: true
});
$9b7740e6413257da$exports.useWebSocket = void 0;

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $35285354eccced0b$exports = {};
"use strict";
Object.defineProperty($35285354eccced0b$exports, "__esModule", {
    value: true
});
$35285354eccced0b$exports.isEventSourceSupported = $35285354eccced0b$exports.isReactNative = $35285354eccced0b$exports.ReadyState = $35285354eccced0b$exports.UNPARSABLE_JSON_OBJECT = $35285354eccced0b$exports.DEFAULT_RECONNECT_INTERVAL_MS = $35285354eccced0b$exports.DEFAULT_RECONNECT_LIMIT = $35285354eccced0b$exports.SOCKET_IO_PING_CODE = $35285354eccced0b$exports.SOCKET_IO_PATH = $35285354eccced0b$exports.SOCKET_IO_PING_INTERVAL = $35285354eccced0b$exports.DEFAULT_EVENT_SOURCE_OPTIONS = $35285354eccced0b$exports.EMPTY_EVENT_HANDLERS = $35285354eccced0b$exports.DEFAULT_OPTIONS = void 0;
var $35285354eccced0b$var$MILLISECONDS = 1;
var $35285354eccced0b$var$SECONDS = 1000 * $35285354eccced0b$var$MILLISECONDS;
$35285354eccced0b$exports.DEFAULT_OPTIONS = {};
$35285354eccced0b$exports.EMPTY_EVENT_HANDLERS = {};
$35285354eccced0b$exports.DEFAULT_EVENT_SOURCE_OPTIONS = {
    withCredentials: false,
    events: $35285354eccced0b$exports.EMPTY_EVENT_HANDLERS
};
$35285354eccced0b$exports.SOCKET_IO_PING_INTERVAL = 25 * $35285354eccced0b$var$SECONDS;
$35285354eccced0b$exports.SOCKET_IO_PATH = "/socket.io/?EIO=3&transport=websocket";
$35285354eccced0b$exports.SOCKET_IO_PING_CODE = "2";
$35285354eccced0b$exports.DEFAULT_RECONNECT_LIMIT = 20;
$35285354eccced0b$exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
$35285354eccced0b$exports.UNPARSABLE_JSON_OBJECT = {};
var $35285354eccced0b$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})($35285354eccced0b$var$ReadyState = $35285354eccced0b$exports.ReadyState || ($35285354eccced0b$exports.ReadyState = {}));
var $35285354eccced0b$var$eventSourceSupported = function() {
    try {
        return "EventSource" in globalThis;
    } catch (e) {
        return false;
    }
};
$35285354eccced0b$exports.isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
$35285354eccced0b$exports.isEventSourceSupported = !$35285354eccced0b$exports.isReactNative && $35285354eccced0b$var$eventSourceSupported();


var $4285dc7b0e6df2e2$exports = {};
"use strict";
Object.defineProperty($4285dc7b0e6df2e2$exports, "__esModule", {
    value: true
});
$4285dc7b0e6df2e2$exports.createOrJoinSocket = void 0;
var $72a0f9fded11617a$exports = {};
"use strict";
Object.defineProperty($72a0f9fded11617a$exports, "__esModule", {
    value: true
});
$72a0f9fded11617a$exports.resetWebSockets = $72a0f9fded11617a$exports.sharedWebSockets = void 0;
$72a0f9fded11617a$exports.sharedWebSockets = {};
var $72a0f9fded11617a$var$resetWebSockets = function(url) {
    if (url && $72a0f9fded11617a$exports.sharedWebSockets.hasOwnProperty(url)) delete $72a0f9fded11617a$exports.sharedWebSockets[url];
    else {
        for(var url_1 in $72a0f9fded11617a$exports.sharedWebSockets)if ($72a0f9fded11617a$exports.sharedWebSockets.hasOwnProperty(url_1)) delete $72a0f9fded11617a$exports.sharedWebSockets[url_1];
    }
};
$72a0f9fded11617a$exports.resetWebSockets = $72a0f9fded11617a$var$resetWebSockets;



var $82185ec80de7ab63$exports = {};
"use strict";
var $82185ec80de7ab63$var$__assign = $82185ec80de7ab63$exports && $82185ec80de7ab63$exports.__assign || function() {
    $82185ec80de7ab63$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $82185ec80de7ab63$var$__assign.apply(this, arguments);
};
Object.defineProperty($82185ec80de7ab63$exports, "__esModule", {
    value: true
});
$82185ec80de7ab63$exports.attachListeners = void 0;
var $ca9bd90c7e6f020d$exports = {};
"use strict";
Object.defineProperty($ca9bd90c7e6f020d$exports, "__esModule", {
    value: true
});
$ca9bd90c7e6f020d$exports.setUpSocketIOPing = $ca9bd90c7e6f020d$exports.appendQueryParams = $ca9bd90c7e6f020d$exports.parseSocketIOUrl = void 0;

var $ca9bd90c7e6f020d$var$parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, "");
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, "");
        var protocol = isSecure ? "wss" : "ws";
        return "".concat(protocol, "://").concat(removedFinalBackSlack).concat($35285354eccced0b$exports.SOCKET_IO_PATH);
    } else if (url === "") {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? "wss" : "ws";
        var port = window.location.port ? ":".concat(window.location.port) : "";
        return "".concat(protocol, "://").concat(window.location.hostname).concat(port).concat($35285354eccced0b$exports.SOCKET_IO_PATH);
    }
    return url;
};
$ca9bd90c7e6f020d$exports.parseSocketIOUrl = $ca9bd90c7e6f020d$var$parseSocketIOUrl;
var $ca9bd90c7e6f020d$var$appendQueryParams = function(url, params) {
    if (params === void 0) params = {};
    var hasParamsRegex = /\?([\w]+=[\w]+)/;
    var alreadyHasParams = hasParamsRegex.test(url);
    var stringified = "".concat(Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + "".concat(key, "=").concat(value, "&");
    }, "").slice(0, -1));
    return "".concat(url).concat(alreadyHasParams ? "&" : "?").concat(stringified);
};
$ca9bd90c7e6f020d$exports.appendQueryParams = $ca9bd90c7e6f020d$var$appendQueryParams;
var $ca9bd90c7e6f020d$var$setUpSocketIOPing = function(sendMessage, interval) {
    if (interval === void 0) interval = $35285354eccced0b$exports.SOCKET_IO_PING_INTERVAL;
    var ping = function() {
        return sendMessage($35285354eccced0b$exports.SOCKET_IO_PING_CODE);
    };
    return window.setInterval(ping, interval);
};
$ca9bd90c7e6f020d$exports.setUpSocketIOPing = $ca9bd90c7e6f020d$var$setUpSocketIOPing;



var $fb7bcda0d394836f$exports = {};
"use strict";
Object.defineProperty($fb7bcda0d394836f$exports, "__esModule", {
    value: true
});
$fb7bcda0d394836f$exports.resetGlobalState = $fb7bcda0d394836f$exports.assertIsWebSocket = void 0;

var $779a09b0ff68a8db$exports = {};
"use strict";
Object.defineProperty($779a09b0ff68a8db$exports, "__esModule", {
    value: true
});
$779a09b0ff68a8db$exports.resetSubscribers = $779a09b0ff68a8db$exports.removeSubscriber = $779a09b0ff68a8db$exports.addSubscriber = $779a09b0ff68a8db$exports.hasSubscribers = $779a09b0ff68a8db$exports.getSubscribers = void 0;
var $779a09b0ff68a8db$var$subscribers = {};
var $779a09b0ff68a8db$var$EMPTY_LIST = [];
var $779a09b0ff68a8db$var$getSubscribers = function(url) {
    if ((0, $779a09b0ff68a8db$exports.hasSubscribers)(url)) return Array.from($779a09b0ff68a8db$var$subscribers[url]);
    return $779a09b0ff68a8db$var$EMPTY_LIST;
};
$779a09b0ff68a8db$exports.getSubscribers = $779a09b0ff68a8db$var$getSubscribers;
var $779a09b0ff68a8db$var$hasSubscribers = function(url) {
    var _a;
    return ((_a = $779a09b0ff68a8db$var$subscribers[url]) === null || _a === void 0 ? void 0 : _a.size) > 0;
};
$779a09b0ff68a8db$exports.hasSubscribers = $779a09b0ff68a8db$var$hasSubscribers;
var $779a09b0ff68a8db$var$addSubscriber = function(url, subscriber) {
    $779a09b0ff68a8db$var$subscribers[url] = $779a09b0ff68a8db$var$subscribers[url] || new Set();
    $779a09b0ff68a8db$var$subscribers[url].add(subscriber);
};
$779a09b0ff68a8db$exports.addSubscriber = $779a09b0ff68a8db$var$addSubscriber;
var $779a09b0ff68a8db$var$removeSubscriber = function(url, subscriber) {
    $779a09b0ff68a8db$var$subscribers[url].delete(subscriber);
};
$779a09b0ff68a8db$exports.removeSubscriber = $779a09b0ff68a8db$var$removeSubscriber;
var $779a09b0ff68a8db$var$resetSubscribers = function(url) {
    if (url && $779a09b0ff68a8db$var$subscribers.hasOwnProperty(url)) delete $779a09b0ff68a8db$var$subscribers[url];
    else {
        for(var url_1 in $779a09b0ff68a8db$var$subscribers)if ($779a09b0ff68a8db$var$subscribers.hasOwnProperty(url_1)) delete $779a09b0ff68a8db$var$subscribers[url_1];
    }
};
$779a09b0ff68a8db$exports.resetSubscribers = $779a09b0ff68a8db$var$resetSubscribers;


function $fb7bcda0d394836f$var$assertIsWebSocket(webSocketInstance, skip) {
    if (!skip && webSocketInstance instanceof WebSocket === false) throw new Error("");
}
$fb7bcda0d394836f$exports.assertIsWebSocket = $fb7bcda0d394836f$var$assertIsWebSocket;
function $fb7bcda0d394836f$var$resetGlobalState(url) {
    (0, $779a09b0ff68a8db$exports.resetSubscribers)(url);
    (0, $72a0f9fded11617a$exports.resetWebSockets)(url);
}
$fb7bcda0d394836f$exports.resetGlobalState = $fb7bcda0d394836f$var$resetGlobalState;


var $82185ec80de7ab63$var$bindMessageHandler = function(webSocketInstance, optionsRef, setLastMessage) {
    webSocketInstance.onmessage = function(message) {
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof optionsRef.current.filter === "function" && optionsRef.current.filter(message) !== true) return;
        setLastMessage(message);
    };
};
var $82185ec80de7ab63$var$bindOpenHandler = function(webSocketInstance, optionsRef, setReadyState, reconnectCount) {
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState($35285354eccced0b$exports.ReadyState.OPEN);
    };
};
var $82185ec80de7ab63$var$bindCloseHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    if ($35285354eccced0b$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) return function() {};
    (0, $fb7bcda0d394836f$exports.assertIsWebSocket)(webSocketInstance, optionsRef.current.skipAssert);
    var reconnectTimeout;
    webSocketInstance.onclose = function(event) {
        var _a;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState($35285354eccced0b$exports.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $35285354eccced0b$exports.DEFAULT_RECONNECT_LIMIT;
            if (reconnectCount.current < reconnectAttempts) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $35285354eccced0b$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $82185ec80de7ab63$var$bindErrorHandler = function(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount) {
    var reconnectTimeout;
    webSocketInstance.onerror = function(error) {
        var _a;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if ($35285354eccced0b$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
            optionsRef.current.onClose && optionsRef.current.onClose($82185ec80de7ab63$var$__assign($82185ec80de7ab63$var$__assign({}, error), {
                code: 1006,
                reason: "An error occurred with the EventSource: ".concat(error),
                wasClean: false
            }));
            setReadyState($35285354eccced0b$exports.ReadyState.CLOSED);
            webSocketInstance.close();
        }
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < ((_a = optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $35285354eccced0b$exports.DEFAULT_RECONNECT_LIMIT)) {
                var nextReconnectInterval = typeof optionsRef.current.reconnectInterval === "function" ? optionsRef.current.reconnectInterval(reconnectCount.current) : optionsRef.current.reconnectInterval;
                reconnectTimeout = window.setTimeout(function() {
                    reconnectCount.current++;
                    reconnect();
                }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $35285354eccced0b$exports.DEFAULT_RECONNECT_INTERVAL_MS);
            } else {
                optionsRef.current.onReconnectStop && optionsRef.current.onReconnectStop(optionsRef.current.reconnectAttempts);
                console.warn("Max reconnect attempts of ".concat(optionsRef.current.reconnectAttempts, " exceeded"));
            }
        }
    };
    return function() {
        return reconnectTimeout && window.clearTimeout(reconnectTimeout);
    };
};
var $82185ec80de7ab63$var$attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount, sendMessage) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var cancelReconnectOnClose;
    var cancelReconnectOnError;
    if (optionsRef.current.fromSocketIO) interval = (0, $ca9bd90c7e6f020d$exports.setUpSocketIOPing)(sendMessage);
    $82185ec80de7ab63$var$bindMessageHandler(webSocketInstance, optionsRef, setLastMessage);
    $82185ec80de7ab63$var$bindOpenHandler(webSocketInstance, optionsRef, setReadyState, reconnectCount);
    cancelReconnectOnClose = $82185ec80de7ab63$var$bindCloseHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    cancelReconnectOnError = $82185ec80de7ab63$var$bindErrorHandler(webSocketInstance, optionsRef, setReadyState, reconnect, reconnectCount);
    return function() {
        setReadyState($35285354eccced0b$exports.ReadyState.CLOSING);
        cancelReconnectOnClose();
        cancelReconnectOnError();
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};
$82185ec80de7ab63$exports.attachListeners = $82185ec80de7ab63$var$attachListeners;


var $1d45736fc861f564$exports = {};
"use strict";
var $1d45736fc861f564$var$__assign = $1d45736fc861f564$exports && $1d45736fc861f564$exports.__assign || function() {
    $1d45736fc861f564$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d45736fc861f564$var$__assign.apply(this, arguments);
};
Object.defineProperty($1d45736fc861f564$exports, "__esModule", {
    value: true
});
$1d45736fc861f564$exports.attachSharedListeners = void 0;




var $1d45736fc861f564$var$bindMessageHandler = function(webSocketInstance, url) {
    webSocketInstance.onmessage = function(message) {
        (0, $779a09b0ff68a8db$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof subscriber.optionsRef.current.filter === "function" && subscriber.optionsRef.current.filter(message) !== true) return;
            subscriber.setLastMessage(message);
        });
    };
};
var $1d45736fc861f564$var$bindOpenHandler = function(webSocketInstance, url) {
    webSocketInstance.onopen = function(event) {
        (0, $779a09b0ff68a8db$exports.getSubscribers)(url).forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState($35285354eccced0b$exports.ReadyState.OPEN);
        });
    };
};
var $1d45736fc861f564$var$bindCloseHandler = function(webSocketInstance, url) {
    if (webSocketInstance instanceof WebSocket) webSocketInstance.onclose = function(event) {
        (0, $779a09b0ff68a8db$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState($35285354eccced0b$exports.ReadyState.CLOSED);
        });
        delete $72a0f9fded11617a$exports.sharedWebSockets[url];
        (0, $779a09b0ff68a8db$exports.getSubscribers)(url).forEach(function(subscriber) {
            var _a;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts) !== null && _a !== void 0 ? _a : $35285354eccced0b$exports.DEFAULT_RECONNECT_LIMIT;
                if (subscriber.reconnectCount.current < reconnectAttempts) {
                    var nextReconnectInterval = typeof subscriber.optionsRef.current.reconnectInterval === "function" ? subscriber.optionsRef.current.reconnectInterval(subscriber.reconnectCount.current) : subscriber.optionsRef.current.reconnectInterval;
                    setTimeout(function() {
                        subscriber.reconnectCount.current++;
                        subscriber.reconnect.current();
                    }, nextReconnectInterval !== null && nextReconnectInterval !== void 0 ? nextReconnectInterval : $35285354eccced0b$exports.DEFAULT_RECONNECT_INTERVAL_MS);
                } else {
                    subscriber.optionsRef.current.onReconnectStop && subscriber.optionsRef.current.onReconnectStop(subscriber.optionsRef.current.reconnectAttempts);
                    console.warn("Max reconnect attempts of ".concat(reconnectAttempts, " exceeded"));
                }
            }
        });
    };
};
var $1d45736fc861f564$var$bindErrorHandler = function(webSocketInstance, url) {
    webSocketInstance.onerror = function(error) {
        (0, $779a09b0ff68a8db$exports.getSubscribers)(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
            if ($35285354eccced0b$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) {
                subscriber.optionsRef.current.onClose && subscriber.optionsRef.current.onClose($1d45736fc861f564$var$__assign($1d45736fc861f564$var$__assign({}, error), {
                    code: 1006,
                    reason: "An error occurred with the EventSource: ".concat(error),
                    wasClean: false
                }));
                subscriber.setReadyState($35285354eccced0b$exports.ReadyState.CLOSED);
            }
        });
        if ($35285354eccced0b$exports.isEventSourceSupported && webSocketInstance instanceof EventSource) webSocketInstance.close();
    };
};
var $1d45736fc861f564$var$attachSharedListeners = function(webSocketInstance, url, optionsRef, sendMessage) {
    var interval;
    if (optionsRef.current.fromSocketIO) interval = (0, $ca9bd90c7e6f020d$exports.setUpSocketIOPing)(sendMessage);
    $1d45736fc861f564$var$bindMessageHandler(webSocketInstance, url);
    $1d45736fc861f564$var$bindCloseHandler(webSocketInstance, url);
    $1d45736fc861f564$var$bindOpenHandler(webSocketInstance, url);
    $1d45736fc861f564$var$bindErrorHandler(webSocketInstance, url);
    return function() {
        if (interval) clearInterval(interval);
    };
};
$1d45736fc861f564$exports.attachSharedListeners = $1d45736fc861f564$var$attachSharedListeners;



//TODO ensure that all onClose callbacks are called
var $4285dc7b0e6df2e2$var$cleanSubscribers = function(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval) {
    return function() {
        (0, $779a09b0ff68a8db$exports.removeSubscriber)(url, subscriber);
        if (!(0, $779a09b0ff68a8db$exports.hasSubscribers)(url)) {
            try {
                var socketLike = $72a0f9fded11617a$exports.sharedWebSockets[url];
                if (socketLike instanceof WebSocket) socketLike.onclose = function(event) {
                    if (optionsRef.current.onClose) optionsRef.current.onClose(event);
                    setReadyState($35285354eccced0b$exports.ReadyState.CLOSED);
                };
                socketLike.close();
            } catch (e) {}
            if (clearSocketIoPingInterval) clearSocketIoPingInterval();
            delete $72a0f9fded11617a$exports.sharedWebSockets[url];
        }
    };
};
var $4285dc7b0e6df2e2$var$createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount, sendMessage) {
    if (!$35285354eccced0b$exports.isEventSourceSupported && optionsRef.current.eventSourceOptions) {
        if ($35285354eccced0b$exports.isReactNative) throw new Error("EventSource is not supported in ReactNative");
        else throw new Error("EventSource is not supported");
    }
    if (optionsRef.current.share) {
        var clearSocketIoPingInterval = null;
        if ($72a0f9fded11617a$exports.sharedWebSockets[url] === undefined) {
            $72a0f9fded11617a$exports.sharedWebSockets[url] = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
            webSocketRef.current = $72a0f9fded11617a$exports.sharedWebSockets[url];
            setReadyState($35285354eccced0b$exports.ReadyState.CONNECTING);
            clearSocketIoPingInterval = (0, $1d45736fc861f564$exports.attachSharedListeners)($72a0f9fded11617a$exports.sharedWebSockets[url], url, optionsRef, sendMessage);
        } else {
            webSocketRef.current = $72a0f9fded11617a$exports.sharedWebSockets[url];
            setReadyState($72a0f9fded11617a$exports.sharedWebSockets[url].readyState);
        }
        var subscriber = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            reconnect: startRef
        };
        (0, $779a09b0ff68a8db$exports.addSubscriber)(url, subscriber);
        return $4285dc7b0e6df2e2$var$cleanSubscribers(url, subscriber, optionsRef, setReadyState, clearSocketIoPingInterval);
    } else {
        webSocketRef.current = optionsRef.current.eventSourceOptions ? new EventSource(url, optionsRef.current.eventSourceOptions) : new WebSocket(url, optionsRef.current.protocols);
        setReadyState($35285354eccced0b$exports.ReadyState.CONNECTING);
        if (!webSocketRef.current) throw new Error("WebSocket failed to be created");
        return (0, $82185ec80de7ab63$exports.attachListeners)(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount, sendMessage);
    }
};
$4285dc7b0e6df2e2$exports.createOrJoinSocket = $4285dc7b0e6df2e2$var$createOrJoinSocket;


var $57ac2761dff60c65$exports = {};
"use strict";
var $57ac2761dff60c65$var$__awaiter = $57ac2761dff60c65$exports && $57ac2761dff60c65$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $57ac2761dff60c65$var$__generator = $57ac2761dff60c65$exports && $57ac2761dff60c65$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($57ac2761dff60c65$exports, "__esModule", {
    value: true
});
$57ac2761dff60c65$exports.getUrl = void 0;

var $57ac2761dff60c65$var$getUrl = function(url, optionsRef) {
    return $57ac2761dff60c65$var$__awaiter(void 0, void 0, void 0, function() {
        var convertedUrl, parsedUrl, parsedWithQueryParams;
        return $57ac2761dff60c65$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(typeof url === "function")) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 1:
                    convertedUrl = _a.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    convertedUrl = url;
                    _a.label = 3;
                case 3:
                    parsedUrl = optionsRef.current.fromSocketIO ? (0, $ca9bd90c7e6f020d$exports.parseSocketIOUrl)(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? (0, $ca9bd90c7e6f020d$exports.appendQueryParams)(parsedUrl, optionsRef.current.queryParams) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};
$57ac2761dff60c65$exports.getUrl = $57ac2761dff60c65$var$getUrl;



var $9b7740e6413257da$var$proxy_1 = $9b7740e6413257da$var$__importDefault((parcelRequire("78Jai")));

var $9b7740e6413257da$var$useWebSocket = function(url, options, connect) {
    if (options === void 0) options = $35285354eccced0b$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = (0, $7fPBF.useState)(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = (0, $7fPBF.useState)({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = (0, $7fPBF.useMemo)(function() {
        if (lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return $35285354eccced0b$exports.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage
    ]);
    var convertedUrl = (0, $7fPBF.useRef)(null);
    var webSocketRef = (0, $7fPBF.useRef)(null);
    var startRef = (0, $7fPBF.useRef)(function() {
        return void 0;
    });
    var reconnectCount = (0, $7fPBF.useRef)(0);
    var messageQueue = (0, $7fPBF.useRef)([]);
    var webSocketProxy = (0, $7fPBF.useRef)(null);
    var optionsCache = (0, $7fPBF.useRef)(options);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? $35285354eccced0b$exports.ReadyState.CONNECTING : $35285354eccced0b$exports.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = (0, $7fPBF.useCallback)(function(message, keep) {
        var _a;
        if (keep === void 0) keep = true;
        if ($35285354eccced0b$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) {
            console.warn("Unable to send a message from an eventSource");
            return;
        }
        if (((_a = webSocketRef.current) === null || _a === void 0 ? void 0 : _a.readyState) === $35285354eccced0b$exports.ReadyState.OPEN) {
            (0, $fb7bcda0d394836f$exports.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketRef.current.send(message);
        } else if (keep) messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = (0, $7fPBF.useCallback)(function(message, keep) {
        if (keep === void 0) keep = true;
        sendMessage(JSON.stringify(message), keep);
    }, [
        sendMessage
    ]);
    var getWebSocket = (0, $7fPBF.useCallback)(function() {
        if (optionsCache.current.share !== true || $35285354eccced0b$exports.isEventSourceSupported && webSocketRef.current instanceof EventSource) return webSocketRef.current;
        if (webSocketProxy.current === null && webSocketRef.current) {
            (0, $fb7bcda0d394836f$exports.assertIsWebSocket)(webSocketRef.current, optionsCache.current.skipAssert);
            webSocketProxy.current = (0, $9b7740e6413257da$var$proxy_1.default)(webSocketRef.current, startRef);
        }
        return webSocketProxy.current;
    }, []);
    (0, $7fPBF.useEffect)(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var createOrJoin_1 = true;
            var start_1 = function() {
                return $9b7740e6413257da$var$__awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return $9b7740e6413257da$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    (0, $57ac2761dff60c65$exports.getUrl)(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) (0, $fw0lo.flushSync)(function() {
                                        return setLastMessage(message);
                                    });
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) (0, $fw0lo.flushSync)(function() {
                                        return setReadyState(function(prev) {
                                            var _a;
                                            return $9b7740e6413257da$var$__assign($9b7740e6413257da$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = state, _a));
                                        });
                                    });
                                };
                                if (createOrJoin_1) removeListeners_1 = (0, $4285dc7b0e6df2e2$exports.createOrJoinSocket)(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount, sendMessage);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                    start_1();
                }
            };
            start_1();
            return function() {
                expectClose_1 = true;
                createOrJoin_1 = false;
                if (webSocketProxy.current) webSocketProxy.current = null;
                removeListeners_1 === null || removeListeners_1 === void 0 || removeListeners_1();
                setLastMessage(null);
            };
        } else if (url === null || connect === false) {
            reconnectCount.current = 0; // reset reconnection attempts
            setReadyState(function(prev) {
                var _a;
                return $9b7740e6413257da$var$__assign($9b7740e6413257da$var$__assign({}, prev), convertedUrl.current && (_a = {}, _a[convertedUrl.current] = $35285354eccced0b$exports.ReadyState.CLOSED, _a));
            });
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        sendMessage
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (readyStateFromUrl === $35285354eccced0b$exports.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};
$9b7740e6413257da$exports.useWebSocket = $9b7740e6413257da$var$useWebSocket;


Object.defineProperty($9a07abecab93e2ee$exports, "default", {
    enumerable: true,
    get: function() {
        return $9b7740e6413257da$exports.useWebSocket;
    }
});
var $37effc0d9265e8bf$exports = {};
"use strict";
var $37effc0d9265e8bf$var$__assign = $37effc0d9265e8bf$exports && $37effc0d9265e8bf$exports.__assign || function() {
    $37effc0d9265e8bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37effc0d9265e8bf$var$__assign.apply(this, arguments);
};
Object.defineProperty($37effc0d9265e8bf$exports, "__esModule", {
    value: true
});
$37effc0d9265e8bf$exports.useSocketIO = void 0;

var $7fPBF = parcelRequire("7fPBF");


var $37effc0d9265e8bf$var$emptyEvent = {
    type: "empty",
    payload: null
};
var $37effc0d9265e8bf$var$getSocketData = function(event) {
    if (!event || !event.data) return $37effc0d9265e8bf$var$emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return $37effc0d9265e8bf$var$emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return $37effc0d9265e8bf$var$emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
var $37effc0d9265e8bf$var$useSocketIO = function(url, options, connect) {
    if (options === void 0) options = $35285354eccced0b$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = (0, $7fPBF.useMemo)(function() {
        return $37effc0d9265e8bf$var$__assign($37effc0d9265e8bf$var$__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = (0, $9b7740e6413257da$exports.useWebSocket)(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = (0, $7fPBF.useMemo)(function() {
        return $37effc0d9265e8bf$var$getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};
$37effc0d9265e8bf$exports.useSocketIO = $37effc0d9265e8bf$var$useSocketIO;


Object.defineProperty($9a07abecab93e2ee$exports, "useSocketIO", {
    enumerable: true,
    get: function() {
        return $37effc0d9265e8bf$exports.useSocketIO;
    }
});

Object.defineProperty($9a07abecab93e2ee$exports, "ReadyState", {
    enumerable: true,
    get: function() {
        return $35285354eccced0b$exports.ReadyState;
    }
});
var $f650b85428fe15e4$exports = {};
"use strict";
var $f650b85428fe15e4$var$__assign = $f650b85428fe15e4$exports && $f650b85428fe15e4$exports.__assign || function() {
    $f650b85428fe15e4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f650b85428fe15e4$var$__assign.apply(this, arguments);
};
var $f650b85428fe15e4$var$__rest = $f650b85428fe15e4$exports && $f650b85428fe15e4$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($f650b85428fe15e4$exports, "__esModule", {
    value: true
});
$f650b85428fe15e4$exports.useEventSource = void 0;

var $7fPBF = parcelRequire("7fPBF");


var $f650b85428fe15e4$var$useEventSource = function(url, _a, connect) {
    if (_a === void 0) _a = $35285354eccced0b$exports.DEFAULT_EVENT_SOURCE_OPTIONS;
    var withCredentials = _a.withCredentials, events = _a.events, options = $f650b85428fe15e4$var$__rest(_a, [
        "withCredentials",
        "events"
    ]);
    if (connect === void 0) connect = true;
    var optionsWithEventSource = $f650b85428fe15e4$var$__assign($f650b85428fe15e4$var$__assign({}, options), {
        eventSourceOptions: {
            withCredentials: withCredentials
        }
    });
    var eventsRef = (0, $7fPBF.useRef)($35285354eccced0b$exports.EMPTY_EVENT_HANDLERS);
    if (events) eventsRef.current = events;
    var _b = (0, $9b7740e6413257da$exports.useWebSocket)(url, optionsWithEventSource, connect), lastMessage = _b.lastMessage, readyState = _b.readyState, getWebSocket = _b.getWebSocket;
    (0, $7fPBF.useEffect)(function() {
        if (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) Object.entries(eventsRef.current).forEach(function(_a) {
            var type = _a[0], handler = _a[1];
            if (type === lastMessage.type) handler(lastMessage);
        });
    }, [
        lastMessage
    ]);
    return {
        lastEvent: lastMessage,
        readyState: readyState,
        getEventSource: getWebSocket
    };
};
$f650b85428fe15e4$exports.useEventSource = $f650b85428fe15e4$var$useEventSource;


Object.defineProperty($9a07abecab93e2ee$exports, "useEventSource", {
    enumerable: true,
    get: function() {
        return $f650b85428fe15e4$exports.useEventSource;
    }
});

Object.defineProperty($9a07abecab93e2ee$exports, "resetGlobalState", {
    enumerable: true,
    get: function() {
        return $fb7bcda0d394836f$exports.resetGlobalState;
    }
});





var $2oXYc = parcelRequire("2oXYc");


var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $c9b15cb88a7aa124$var$CreditCardIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
    }));
}
const $c9b15cb88a7aa124$var$ForwardRef = $7fPBF.forwardRef($c9b15cb88a7aa124$var$CreditCardIcon);
var $c9b15cb88a7aa124$export$2e2bcd8739ae039 = $c9b15cb88a7aa124$var$ForwardRef;



var $d03319e48a3a604e$var$V3_URL = "https://js.stripe.com/v3";
var $d03319e48a3a604e$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $d03319e48a3a604e$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $d03319e48a3a604e$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($d03319e48a3a604e$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$d03319e48a3a604e$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $d03319e48a3a604e$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($d03319e48a3a604e$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $d03319e48a3a604e$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.46.0",
        startTime: startTime
    });
};
var $d03319e48a3a604e$var$stripePromise = null;
var $d03319e48a3a604e$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($d03319e48a3a604e$var$stripePromise !== null) return $d03319e48a3a604e$var$stripePromise;
    $d03319e48a3a604e$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($d03319e48a3a604e$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $d03319e48a3a604e$var$findScript();
            if (script && params) console.warn($d03319e48a3a604e$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $d03319e48a3a604e$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $d03319e48a3a604e$var$stripePromise;
};
var $d03319e48a3a604e$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $d03319e48a3a604e$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $d03319e48a3a604e$var$stripePromise$1 = Promise.resolve().then(function() {
    return $d03319e48a3a604e$var$loadScript(null);
});
var $d03319e48a3a604e$var$loadCalled = false;
$d03319e48a3a604e$var$stripePromise$1["catch"](function(err) {
    if (!$d03319e48a3a604e$var$loadCalled) console.warn(err);
});
var $d03319e48a3a604e$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $d03319e48a3a604e$var$loadCalled = true;
    var startTime = Date.now();
    return $d03319e48a3a604e$var$stripePromise$1.then(function(maybeStripe) {
        return $d03319e48a3a604e$var$initStripe(maybeStripe, args, startTime);
    });
};


var $42e487d2a1927298$exports = {};

(function(global, factory) {
    factory($42e487d2a1927298$exports, (parcelRequire("7fPBF")));
})($42e487d2a1927298$exports, function(exports1, React) {
    "use strict";
    React = React && Object.prototype.hasOwnProperty.call(React, "default") ? React["default"] : React;
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function createCommonjsModule(fn, module) {
        return module = {
            exports: {}
        }, fn(module, module.exports), module.exports;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    var ReactPropTypesSecret_1 = ReactPropTypesSecret;
    function emptyFunction() {}
    function emptyFunctionWithReset() {}
    emptyFunctionWithReset.resetWarningCache = emptyFunction;
    var factoryWithThrowingShims = function() {
        function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret_1) // It is still safe when called from React.
            return;
            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            err.name = "Invariant Violation";
            throw err;
        }
        shim.isRequired = shim;
        function getShim() {
            return shim;
        }
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
        var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
    };
    var propTypes = createCommonjsModule(function(module) {
        // By explicitly using `prop-types` you are opting into new production behavior.
        // http://fb.me/prop-types-in-prod
        module.exports = factoryWithThrowingShims();
    });
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(INVALID_STRIPE_ERROR);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(validateStripe)
        };
        var stripe = validateStripe(raw);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    var CartElementContext = /*#__PURE__*/ React.createContext(null);
    CartElementContext.displayName = "CartElementContext";
    var parseCartElementContext = function parseCartElementContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), cart = _React$useState2[0], setCart = _React$useState2[1];
        var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), cartState = _React$useState4[0], setCartState = _React$useState4[1]; // For a sync stripe instance, initialize into context
        var _React$useState5 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState6 = _slicedToArray(_React$useState5, 2), ctx = _React$useState6[0], setContext = _React$useState6[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            var anyStripe = ctx.stripe;
            if (!anyStripe || !anyStripe._registerWrapper || !anyStripe.registerAppInfo) return;
            anyStripe._registerWrapper({
                name: "react-stripe-js",
                version: "1.16.4"
            });
            anyStripe.registerAppInfo({
                name: "react-stripe-js",
                version: "1.16.4",
                url: "https://stripe.com/docs/stripe-js/react"
            });
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CartElementContext.Provider, {
            value: {
                cart: cart,
                setCart: setCart,
                cartState: cartState,
                setCartState: setCartState
            }
        }, children));
    };
    Elements.propTypes = {
        stripe: propTypes.any,
        options: propTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    var useCartElementContextWithUseCase = function useCartElementContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(CartElementContext);
        return parseCartElementContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsContextWi2 = useElementsContextWithUseCase("calls useStripe()"), stripe = _useElementsContextWi2.stripe;
        return stripe;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElement = function useCartElement() {
        var _useCartElementContex = useCartElementContextWithUseCase("calls useCartElement()"), cart = _useCartElementContex.cart;
        return cart;
    };
    /**
   * @docs https://stripe.com/docs/payments/checkout/cart-element
   */ var useCartElementState = function useCartElementState() {
        var _useCartElementContex2 = useCartElementContextWithUseCase("calls useCartElementState()"), cartState = _useCartElementContex2.cartState;
        return cartState;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: propTypes.func.isRequired
    };
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onCheckout = _ref.onCheckout, onLineItemClick = _ref.onLineItemClick, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var _useElementsContextWi = useElementsContextWithUseCase("mounts <".concat(displayName, ">")), elements = _useElementsContextWi.elements;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null);
            var _useCartElementContex = useCartElementContextWithUseCase("mounts <".concat(displayName, ">")), setCart = _useCartElementContex.setCart, setCartState = _useCartElementContex.setCartState; // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "lineitemclick", onLineItemClick);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            var readyCallback;
            if (type === "cart") readyCallback = function readyCallback(event) {
                setCartState(event);
                onReady && onReady(event);
            };
            else if (onReady) {
                if (type === "payButton") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            var changeCallback = type === "cart" ? function(event) {
                setCartState(event);
                onChange && onChange(event);
            } : onChange;
            useAttachEvent(element, "change", changeCallback);
            var checkoutCallback = type === "cart" ? function(event) {
                setCartState(event);
                onCheckout && onCheckout(event);
            } : onCheckout;
            useAttachEvent(element, "checkout", checkoutCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && elements && domNode.current !== null) {
                    var newElement = elements.create(type, options);
                    if (type === "cart" && setCart) // we know that elements.create return value must be of type StripeCartElement if type is 'cart',
                    // we need to cast because typescript is not able to infer which overloaded method is used based off param type
                    setCart(newElement);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    newElement.mount(domNode.current);
                }
            }, [
                elements,
                options,
                setCart
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current) {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    }
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            // Validate that we are in the right context by calling useElementsContextWithUseCase.
            useElementsContextWithUseCase("mounts <".concat(displayName, ">"));
            useCartElementContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: propTypes.string,
            className: propTypes.string,
            onChange: propTypes.func,
            onBlur: propTypes.func,
            onFocus: propTypes.func,
            onReady: propTypes.func,
            onEscape: propTypes.func,
            onClick: propTypes.func,
            onLoadError: propTypes.func,
            onLoaderStart: propTypes.func,
            onNetworksChange: propTypes.func,
            onCheckout: propTypes.func,
            onLineItemClick: propTypes.func,
            onConfirm: propTypes.func,
            onCancel: propTypes.func,
            onShippingAddressChange: propTypes.func,
            onShippingRateChange: propTypes.func,
            options: propTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PayButtonElement = createElementComponent("payButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/elements/cart-element
   */ var CartElement = createElementComponent("cart", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CartElement = CartElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EpsBankElement = EpsBankElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PayButtonElement = PayButtonElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCartElement = useCartElement;
    exports1.useCartElementState = useCartElementState;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});




const $8523eeef36c69dd5$var$debugLevel = 0;

(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend($41426fe6dfa29819$exports);
function $8523eeef36c69dd5$var$classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $8523eeef36c69dd5$export$8658db3134856dc2({ formObject: formObject, goBack: goBack, subscription: subscription }) {
    const stripe = (0, $42e487d2a1927298$exports.useStripe)();
    const elements = (0, $42e487d2a1927298$exports.useElements)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const [message, setMessage] = (0, $7fPBF.useState)(null);
    const [submitting, setSubmitting] = (0, $7fPBF.useState)(false);
    const user = {
        username: formObject.userId,
        password: formObject.password,
        email: formObject.email,
        address: {
            countryCode: "DE"
        },
        preferredUsername: formObject.username,
        baseCurrency: formObject.baseCurrency,
        locale: i18n.language,
        provider: formObject.provider,
        externalProcess: !!formObject.provider,
        tierId: formObject.tierId,
        stripeCustomerId: subscription.stripeCustomerId
    };
    async function handleSubmit(e, payLater = false) {
        setSubmitting(true);
        e.preventDefault();
        // save form status to local storage should there be an error AFTER Stripe redirects user to return_url
        localStorage.setItem("signUpObject", JSON.stringify((0, $2qxEV._)((0, $9tqwB._)({}, user), {
            signUpState: "payment"
        })));
        // the user will be REDIRECTED to return_url (sometimes even to more pages first for SCA)
        // on the return_url the user will be asked to enter email verification from Cognito
        const returnUrl = `${window.location.origin}/callback?source=stripe`;
        if ($8523eeef36c69dd5$var$debugLevel > 2) console.log("checking return_url composition: ", returnUrl);
        // if it returns something, then it is an error; otherwise the user gets forwarded to a SCA verification page and then to return_url
        // if the user provided method of payment, confirm and save it with stripe, then redirect to /callback
        if (!payLater) {
            const { error: error } = await stripe.confirmSetup({
                elements: elements,
                confirmParams: {
                    return_url: returnUrl
                }
            });
            if (error) {
                // this point will only be reached if there is an immediate error when confirming the payment. Show error to your customer (for example, payment details incomplete)
                setMessage(error.message);
                setSubmitting(false);
            }
        } else {
            // if the user chose to pay later, redirect to /callback
            if ($8523eeef36c69dd5$var$debugLevel > 2) console.log("redirecting to /callback");
            window.location.href = `${returnUrl}?pay_later=1`;
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
        id: "payment-form",
        onSubmit: handleSubmit,
        className: "p-4",
        children: [
            message && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                id: "payment-message",
                className: "text-red-500 font-semibold",
                children: message
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e487d2a1927298$exports.PaymentElement), {
                id: "payment-element"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex justify-end space-x-4 py-4",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "inline-flex items-center px-3 py-2.5 border border-brandBlue-400 text-sm leading-4 font-semibold rounded-md shadow-sm text-brandBlue-500 hover:bg-brandBlue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 cursor-pointer",
                            onClick: (e)=>handleSubmit(e, true),
                            children: t("register.signUp3.payLater")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-end space-x-4 py-4",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "inline-flex items-center px-3 py-2 border border-brandBlue-400 text-sm leading-4 font-semibold rounded-md shadow-sm text-brandBlue-500 hover:bg-brandBlue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 cursor-pointer",
                                onClick: goBack,
                                children: t("general.back")
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                enabled: stripe && elements && !submitting,
                                loading: submitting,
                                text: t("register.signUp3.payNow"),
                                id: "submit",
                                name: "completetransaction",
                                withAccent: true,
                                type: "submit"
                            })
                        ]
                    })
                ]
            }),
            formObject.provider && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "rounded-md bg-blue-50 p-4",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b4cd863899309fad$export$2e2bcd8739ae039), {
                                className: "h-5 w-5 text-blue-400",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "ml-3 flex-1 md:flex md:justify-between",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "text-sm text-brandBlue-700",
                                    children: t("register.signUp3.externalInfo", {
                                        provider: formObject.provider.replace("LoginWith", "").replace("SignInWith", "")
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "mt-3 text-sm md:ml-6 md:mt-0"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
$8523eeef36c69dd5$export$8658db3134856dc2.propTypes = {
    formObject: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired,
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    subscription: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};
function $8523eeef36c69dd5$export$2e2bcd8739ae039({ formState: formState, goBack: goBack }) {
    var _this, _subscription_amount;
    const { i18n: i18n, t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.signUp3"
    });
    const [url, setUrl] = (0, $7fPBF.useState)(`${"wss://api-wss.monestry.de/"}customer-websocket?clientAuthParam=${(0, $8136d14ed46fb244$export$ac4959f4f1338dfc)()}`);
    const [stripePromise, setStripePromise] = (0, $7fPBF.useState)(null);
    const appearance = {
        theme: "stripe"
    };
    const [stripeOptions, setStripeOptions] = (0, $7fPBF.useState)({
        appearance: appearance,
        locale: i18n.language
    });
    const [subscription, setSubscription] = (0, $7fPBF.useState)(null); // subscription object from Stripe
    const terminateWebSocketConnection = (0, $7fPBF.useCallback)(()=>setUrl(null), []);
    const { sendJsonMessage: sendJsonMessage, lastMessage: lastMessage, readyState: readyState } = (0, (/*@__PURE__*/$parcel$interopDefault($9a07abecab93e2ee$exports)))(url, {
        onOpen: ()=>{
            if ($8523eeef36c69dd5$var$debugLevel > 2) console.log("SignUp3 > websocket connection opened");
        },
        onMessage: (message)=>{
            if ($8523eeef36c69dd5$var$debugLevel > 2) console.log("SignUp3 > websocket message received: ", message);
        },
        onError: (error)=>{
            if ($8523eeef36c69dd5$var$debugLevel > 2) console.error("SignUp3 > websocket error: ", error);
        }
    });
    // -------------------------
    // INITIALISE COMPONENT
    // -------------------------
    // send the action to register user, create subscription and get SecretID
    // once it is here, go to the payment component
    (0, $7fPBF.useEffect)(()=>{
        // when the status changes to 'connectionOpen', it means the connection got open
        if (readyState === (0, $9a07abecab93e2ee$exports.ReadyState).OPEN && !lastMessage) sendJsonMessage({
            action: "postCustomer",
            email: formState.email,
            username: formState.userId,
            registrationCode: formState.registrationCode,
            stripePriceId: formState.stripePriceId,
            tierId: formState.tierId
        });
        if (lastMessage && JSON.parse(lastMessage.data).clientSecret) {
            // postCustomer returns subscription parameters
            const parsedMessage = JSON.parse(lastMessage.data);
            setStripeOptions((0, $2qxEV._)((0, $9tqwB._)({}, stripeOptions), {
                clientSecret: parsedMessage.clientSecret
            }));
            setSubscription((0, $2qxEV._)((0, $9tqwB._)({}, parsedMessage), {
                billingCycleAnchor: parsedMessage.billingCycleAnchor * 1000
            })); // used to display basket item
            terminateWebSocketConnection();
        }
    }, [
        lastMessage,
        readyState
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (stripeOptions.clientSecret && !stripePromise) setStripePromise((0, $d03319e48a3a604e$export$de80f7562c3fd6b1)("pk_live_51KduP7HTQ5xnEau1hmXjZ0p3J8TdXTsbzGYUIEiDxNNFJMgsSiGPMWnDtQKFXX6fJFLHpJCpcOWow8ob2pS4U4jY00xN2vET3e"));
    }, [
        stripeOptions.clientSecret,
        stripePromise
    ]);
    // parse the incoming stripe subscription attrs
    const amountPerMonth = (_this = (subscription === null || subscription === void 0 ? void 0 : subscription.interval) === "year" ? ((subscription === null || subscription === void 0 ? void 0 : subscription.amount) || 0) / 12 : subscription === null || subscription === void 0 ? void 0 : subscription.amount) === null || _this === void 0 ? void 0 : _this.toLocaleString("de", {
        style: "currency",
        currency: (subscription === null || subscription === void 0 ? void 0 : subscription.currency) || "EUR",
        maximumFractionDigits: 2
    });
    const billingAmount = subscription === null || subscription === void 0 ? void 0 : (_subscription_amount = subscription.amount) === null || _subscription_amount === void 0 ? void 0 : _subscription_amount.toLocaleString("de", {
        style: "currency",
        currency: subscription === null || subscription === void 0 ? void 0 : subscription.currency,
        maximumFractionDigits: 2
    });
    const navigation = [
        {
            name: t("creditCard"),
            href: "#",
            icon: (0, $c9b15cb88a7aa124$export$2e2bcd8739ae039),
            current: true
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "mt-10 grid lg:grid-cols-12 lg:gap-x-5",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("aside", {
                className: "w-full sm:w-2/3 sm:mx-auto lg:w-full py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("nav", {
                    className: "space-y-1",
                    children: navigation.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                            href: item.href,
                            className: $8523eeef36c69dd5$var$classNames(item.current ? "bg-white text-brandBlue-500 hover:text-brandBlue-600 hover:bg-white" : "text-gray-900 hover:text-gray-900 hover:bg-white", "group rounded-md px-3 py-2 flex items-center text-sm font-medium"),
                            "aria-current": item.current ? "page" : undefined,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(item.icon, {
                                    className: $8523eeef36c69dd5$var$classNames(item.current ? "text-brandBlue-500 group-hover:text-brandBlue-600" : "text-gray-400 group-hover:text-gray-500", "flex-shrink-0 -ml-1 mr-3 h-6 w-6"),
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "truncate",
                                    children: item.name
                                })
                            ]
                        }, item.name))
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "bg-white space-y-6 sm:px-6 lg:px-0 lg:col-span-6",
                children: stripeOptions.clientSecret && stripePromise ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e487d2a1927298$exports.Elements), {
                    stripe: stripePromise,
                    options: stripeOptions,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8523eeef36c69dd5$export$8658db3134856dc2, {
                        formObject: formState,
                        goBack: goBack,
                        subscription: subscription
                    })
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "grid animate-pulse grid-cols-2 items-center h-full justify-center gap-4 m-5",
                        id: "paymentElementSkeleton",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "bg-gray-200 border border-gray-200 h-20 rounded-md col-span-2 w-full"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "bg-gray-200 border border-gray-200 h-20 rounded-md w-full"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "bg-gray-200 border border-gray-200 h-20 rounded-md w-full"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "bg-gray-200 border border-gray-200 h-20 rounded-md w-full"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "bg-gray-200 border border-gray-200 h-20 rounded-md w-full"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "order-first lg:order-last sm:px-6 lg:px-0 lg:col-span-3",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "w-full sm:w-2/3 sm:mx-auto lg:w-full space-y-1 bg-white text-gray-900 min-h-full rounded text-sm p-4",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "text-xl font-bold pb-3",
                            children: t("yourOrder")
                        }),
                        subscription ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                                    className: "text-base font-bold text-brandBlue-600",
                                    children: `Monestry ${formState.tierType.toUpperCase()}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: `${t("freeUntil")} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc((subscription === null || subscription === void 0 ? void 0 : subscription.billingCycleAnchor) || null).format("D.MM.YYYY")}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: `${t("afterwards")} ${amountPerMonth === null || amountPerMonth === void 0 ? void 0 : amountPerMonth.toLocaleString("de", {
                                        style: "currency",
                                        currency: subscription.currency,
                                        maximumFractionDigits: 2
                                    })}${t("perMonth")}`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t(`${subscription === null || subscription === void 0 ? void 0 : subscription.interval}Billing`)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex justify-between pt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: t("dueToday")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "font-bold",
                                            children: 0..toLocaleString("de", {
                                                style: "currency",
                                                currency: subscription.currency,
                                                maximumFractionDigits: 2
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            children: `${t("dueIn30Days")} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc((subscription === null || subscription === void 0 ? void 0 : subscription.billingCycleAnchor) || null).format("D.MM.YYYY")}`
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "font-bold",
                                            children: billingAmount.toLocaleString("de", {
                                                style: "currency",
                                                currency: subscription.currency,
                                                maximumFractionDigits: 2
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "flex flex-col gap-2 text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "pt-6 text-xs",
                                            children: `${t("subscriptionRenewsOn")} ${t(`every${subscription === null || subscription === void 0 ? void 0 : subscription.interval}`)} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc((subscription === null || subscription === void 0 ? void 0 : subscription.billingCycleAnchor) || null).format((subscription === null || subscription === void 0 ? void 0 : subscription.interval) === "year" ? "D.MM." : "D")}`
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-xs",
                                            children: t("cancelAnyTime")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "text-xs",
                                            children: t("upgradeAnyTime")
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex w-full h-96 justify-center items-center",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                className: "h-6 w-6 animate-spin text-gray-400"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$8523eeef36c69dd5$export$2e2bcd8739ae039.propTypes = {
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any).isRequired
};



function $00eeef16bd1a0e23$export$2e2bcd8739ae039() {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const payment = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.payment);
    const [state, setState] = (0, $7fPBF.useState)("username"); // 'username', 'package', 'payment', 'processing' - it will get texts from translation by using those
    const [formObject, setFormObject] = (0, $7fPBF.useState)({
        username: "",
        password: "",
        repeatPassword: "",
        email: "",
        country: "Germany",
        tier: "",
        annualBilling: null,
        billingPerMonth: 0
    });
    function goForward() {
        switch(state){
            case "username":
                setState("package");
                break;
            case "package":
                setState("payment");
                break;
            default:
                break;
        }
    }
    function goBack(event) {
        event.preventDefault();
        switch(state){
            case "package":
                setState("username");
                break;
            case "payment":
                setState("package");
                break;
            default:
                break;
        }
    }
    // handle reentry to payment after payment failed
    (0, $7fPBF.useEffect)(()=>{
        // SignUp3 would put the 'formObject' object into session storage
        // PaymentSuccessful would put 'error' status in the store
        // expect { signUpState, formObject } corresponding to state of this component (state, formState)
        const savedFormObject = sessionStorage.getItem("formObject");
        if ((payment === null || payment === void 0 ? void 0 : payment.status) === "error" && savedFormObject) {
            setFormObject(JSON.parse((0, $9tqwB._)({}, formObject, savedFormObject.formObject)));
            setState(savedFormObject.signUpState);
        }
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-gray-50",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "max-w-7xl mx-auto py-12 px-4 sm:py-8 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "mt-1 text-3xl font-black text-gray-900 sm:text-4xl sm:tracking-tight lg:text-5xl",
                                children: t(`site:register.${state}.header`)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "max-w-xl mt-5 mx-auto pb-2 text-xl text-gray-500",
                                children: t(`site:register.${state}.subheader`)
                            })
                        ]
                    }),
                    state === "username" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $25222a2cc67561a6$export$2e2bcd8739ae039), {
                        formObject: formObject,
                        formSetObject: setFormObject,
                        goForward: goForward
                    }) : null,
                    state === "package" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d4f53529bc97f8c8$export$2e2bcd8739ae039), {
                        formState: formObject,
                        formSetState: setFormObject,
                        goForward: goForward,
                        goBack: goBack
                    }) : null,
                    state === "payment" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8523eeef36c69dd5$export$2e2bcd8739ae039), {
                        formState: formObject,
                        formSetState: setFormObject,
                        goBack: goBack
                    }) : null,
                    state === "processing" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                        className: "h-5 w-5 animate-spin text-gray-400"
                    }) : null
                ]
            })
        })
    });
}


/* eslint-disable react/jsx-no-bind */ /* eslint-disable react/forbid-prop-types */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");






var $2oXYc = parcelRequire("2oXYc");







function $ace3485a2769e698$var$WelcomeMessage({ handleSubmit: handleSubmit, localConfirmationCode: localConfirmationCode, setLocalConfirmationCode: setLocalConfirmationCode, version: version, identityProvider: identityProvider, codeError: codeError, loading: loading }) {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.paymentSuccessful"
    });
    // version determines if to show the verification code input field + instruction (for internal user sign up) or just the welcome message with the login button
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                id: "registrationSuccessfulTitle",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "block text-sm font-semibold uppercase tracking-wide text-brandBlue-500 sm:text-base lg:text-sm xl:text-base",
                        children: t("registrationSuccessful")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "mt-1 block text-4xl tracking-tight font-black sm:text-6xl",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "block text-gray-900",
                            children: t("welcome")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl",
                children: t("thanksForOpening")
            }),
            version === "userNotConfirmed" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-3 text-base text-gray-500 sm:mt-5",
                        children: t("weSentYouAnEmail")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-3 text-base text-gray-500 sm:mt-5",
                        children: t("enterCode")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "my-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "col-span-6 md:col-span-4",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "username",
                                            className: "block text-sm font-medium text-gray-500",
                                            children: t("verificationCode")
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "mt-1 flex rounded-md shadow-sm",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "number",
                                                name: "verificationCode",
                                                id: "verification_code",
                                                placeholder: "123456",
                                                autoComplete: "off",
                                                onChange: (e)=>setLocalConfirmationCode(e.target.value),
                                                value: localConfirmationCode,
                                                className: "flex-1 focus:ring-brandBlue-400 focus:border-brandBlue-400 block w-full min-w-0 rounded-md sm:text-sm border-gray-300 placeholder:text-gray-400"
                                            })
                                        }),
                                        codeError === "CodeMismatchException" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "mt-1 text-sm text-brandRed-500",
                                            children: t("codeError")
                                        }),
                                        codeError && codeError !== "CodeMismatchException" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "mt-1 text-sm text-brandRed-500",
                                            children: t("genericError")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                                text: t("confirmAccount"),
                                spinnerOn: loading,
                                withAccent: true,
                                size: "xl",
                                enabled: !loading,
                                type: "submit"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-3 text-base text-gray-500 sm:mt-5",
                        children: t("federated.accountReady", {
                            provider: identityProvider.replace("LoginWith", "")
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "mt-3 text-base text-gray-500 sm:mt-5 mb-5",
                        children: t("federated.addPasswordLater")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4d6a115e8a6240d3$export$2e2bcd8739ae039), {
                        text: t("federated.proceedToDashboard"),
                        spinnerOn: loading,
                        withAccent: true,
                        size: "xl",
                        enabled: !loading,
                        onClick: ()=>navigate(`/${i18n.language}/app/getready`)
                    })
                ]
            })
        ]
    });
}
$ace3485a2769e698$var$WelcomeMessage.propTypes = {
    handleSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    localConfirmationCode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    setLocalConfirmationCode: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
    version: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    identityProvider: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    codeError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$ace3485a2769e698$var$WelcomeMessage.defaultProps = {
    localConfirmationCode: "",
    version: "userNotConfirmed",
    identityProvider: undefined,
    codeError: false,
    loading: false
};
function $ace3485a2769e698$var$ErrorMessage() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("site", {
        keyPrefix: "register.paymentSuccessful.errorMessage"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "block text-sm font-semibold uppercase tracking-wide text-brandBlue-500 sm:text-base lg:text-sm xl:text-base",
                        children: t("registrationFailed")
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "mt-1 block text-4xl tracking-tight font-black sm:text-6xl",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "block text-gray-900",
                            children: t("error")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl",
                children: t("thankYouForOpening")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "mt-3 text-base text-gray-500 sm:mt-5",
                children: t("problemWithPayment")
            })
        ]
    });
}
function $ace3485a2769e698$export$68b1aae2077d1f19({ clientSecret: clientSecret, payLater: payLater, isLoading: isLoading, setIsLoading: setIsLoading }) {
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const stripe = (0, $42e487d2a1927298$exports.useStripe)();
    const { userId: userId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const [localConfirmationCode, setLocalConfirmationCode] = (0, $7fPBF.useState)(undefined);
    const [user, _] = (0, $7fPBF.useState)(JSON.parse(localStorage.getItem("signUpObject")));
    const [displayError, setDisplayError] = (0, $7fPBF.useState)(false);
    const [codeError, setCodeError] = (0, $7fPBF.useState)(undefined);
    const [isSubmitting, setIsSubmitting] = (0, $7fPBF.useState)(false);
    const [url, setUrl] = (0, $7fPBF.useState)(null); // only initiate in LOST SESSION CASE (see below)
    const terminateWebSocketConnection = (0, $7fPBF.useCallback)(()=>setUrl(null), []);
    const { sendJsonMessage: sendJsonMessage, lastMessage: lastMessage, readyState: readyState } = (0, (/*@__PURE__*/$parcel$interopDefault($9a07abecab93e2ee$exports)))(url, {
        onOpen: ()=>console.log("SignUp3 > websocket connection opened"),
        onMessage: (message)=>{
            console.log("SignUp3 > websocket message received: ", message);
        },
        onError: (error)=>console.error("SignUp3 > websocket error: ", error)
    });
    (0, $7fPBF.useEffect)(()=>{
        if (user) localStorage.removeItem("signUpObject");
    }, [
        user
    ]);
    (0, $7fPBF.useEffect)(()=>{
        function handleError() {
            // set store.user.payment.status to 'error'
            dispatch({
                type: "PAYMENT_ERROR"
            });
            // redirect your user back to your payment page to attempt collecting
            // payment again (SignUp component will handle this)
            navigate(`/${i18n.language}/register`);
        }
        // PAY NOW CASE: IF there IS a clientSecret, then this component is loaded in the same session as the payment
        // so check the SetupIntent status with clientSecret, check Cognito user status and - if the latter is UNCONFIRMED - display confirmation code input field
        // PAY LATER CASE: IF there IS NO clientSecret, we need to figure out if this is a LOST SESSION or a PAY LATER case
        // to that end we need to look for payLater flag in the user object in the store (passed to this component from parent), which has been put there by hubListener during handling callback
        // LOST SESSION CASE: IF there IS NO clientSecret, the user has opened a new session basing on a link from the email (not implemented yet)
        // in that case find customer in Stripe and get a subscription status from Stripe by calling the backend (see the next useEffect)
        // handle PAY NOW case (user gets redirected here after payment completed with Stripe)
        if (clientSecret && stripe) // stripe loads async, need to wait a while for it to do so
        stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent: setupIntent })=>{
            // Inspect the SetupIntent `status` to indicate the status of the payment to your customer.
            //
            // Some payment methods will immediately succeed or fail upon confirmation, while others will first enter a `processing` state.
            // see: https://stripe.com/docs/payments/payment-methods#payment-notification
            switch(setupIntent.status){
                case "succeeded":
                    setIsLoading(false);
                    break;
                case "processing":
                    // do nothing, the Stripe webhook handler will receive something and act on it
                    // eslint-disable-next-line no-alert
                    alert("Payment processing takes unusually long. Please reach out to us for help at support@monestry.de");
                    break;
                case "requires_payment_method":
                    console.log("Payment failed. Please try another payment method.");
                    handleError();
                    break;
                default:
                    console.log("Unknown error while processing payment.");
                    handleError();
                    break;
            }
        });
    });
    // handle LOST SESSION CASE
    (0, $7fPBF.useEffect)(()=>{
        // initialise websocket connection
        if (!clientSecret && !payLater && userId) setUrl(`${"wss://api-wss.monestry.de/"}customer-websocket?clientAuthParam=${(0, $8136d14ed46fb244$export$ac4959f4f1338dfc)()}`); // this will start the connection
        // when the status changes to 'connectionOpen', send the message to the backend
        if (readyState === (0, $9a07abecab93e2ee$exports.ReadyState).OPEN && !lastMessage) {
            console.log("sent message");
            sendJsonMessage({
                action: "getCustomerSubscriptionStatus",
                userId: userId
            });
        }
        if (lastMessage && JSON.parse(lastMessage.data).stripeSubscriptionStatus) {
            // if the above is ok, resend email from Cognito
            console.log("message received ", lastMessage);
            terminateWebSocketConnection();
            const subscriptionStatus = JSON.parse(lastMessage.data).stripeSubscriptionStatus;
            // check in Cognito if user is confirmed, if not, send a new confirmation code (Auth.resendSignUp)
            // PL 240920: 'confirmed' was set by the USERMERGED handler, which is no longer in use
            // the federated sign up process will take the user directly to Prep > Dashboard and will not show this component
            // removing userState from the check
            // if (subscriptionStatus === 'active' && user.userState !== 'confirmed') {
            //   dispatch(resendConfirmationEmail(userId));
            //   // finish loading and show verification code input
            //   setIsLoading(false);
            // } else if (subscriptionStatus === 'active' && user.userState === 'confirmed') {
            //   setIsLoading(false);
            // } else {
            //   setIsLoading(false);
            //   setDisplayError(true);
            // }
            if (subscriptionStatus === "active") {
                dispatch((0, $8bd3fc2d0bca0786$export$3175f325678aaf85)(userId));
                // finish loading and show verification code input
                setIsLoading(false);
            } else {
                setIsLoading(false);
                setDisplayError(true);
            }
        }
    }, [
        clientSecret,
        lastMessage,
        payLater,
        readyState,
        userId
    ]);
    // handle PAY LATER CASE
    (0, $7fPBF.useEffect)(()=>{
        if (payLater) // we don't need to do anything here, Cognito has sent the verification email once it was dispatched from hubListener, so the user just needs to enter the verification code
        setIsLoading(false);
    }, [
        payLater
    ]);
    // situation: user has completed payment and stripe navigates to this page
    // need to verify the status of stripe SetupIntent (NEW -- need to be added to the non-rendered version where the user uses the link containing validation code from their email)
    // and user's email (they received a code)
    async function handleNextStep(passedConfirmationCode) {
        const confirmationCode = passedConfirmationCode || localConfirmationCode; // if there is a confirmation code in the form, it takes precedence
        try {
            await dispatch((0, $8bd3fc2d0bca0786$export$93d1a64d3f408c6)(userId, confirmationCode)); // this will trigger changes in the useEffect below (state.user.registration)
        } catch (err) {
            setIsSubmitting(false);
            if (err.message.includes("CodeMismatchException")) setCodeError("CodeMismatchException");
            else setCodeError("genericError");
        }
    }
    async function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);
        setCodeError(undefined);
        setLocalConfirmationCode(e.target[0].value); // first target is input field, second is button
        handleNextStep(e.target[0].value);
    }
    return isLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full h-[65vh;] flex flex-col gap-4 justify-center items-center text-gray-400",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                className: "h-12 w-12 animate-spin"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-xl text-gray-500",
                children: t("register.paymentStillProcessed")
            })
        ]
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative bg-white overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "hidden lg:block lg:absolute lg:inset-0",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                    className: "absolute top-0 left-1/2 transform translate-x-64 -translate-y-8",
                    width: 640,
                    height: 784,
                    fill: "none",
                    viewBox: "0 0 640 784",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                id: "9ebea6f4-a1f5-4d96-8c4e-4c2abf658047",
                                x: 118,
                                y: 0,
                                width: 20,
                                height: 20,
                                patternUnits: "userSpaceOnUse",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                    x: 0,
                                    y: 0,
                                    width: 4,
                                    height: 4,
                                    className: "text-gray-200",
                                    fill: "currentColor"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            y: 72,
                            width: 640,
                            height: 640,
                            className: "text-gray-50",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                            x: 118,
                            width: 404,
                            height: 784,
                            fill: "url(#9ebea6f4-a1f5-4d96-8c4e-4c2abf658047)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "relative pt-6 pb-16 sm:pb-24 lg:pb-32",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                    className: "mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "lg:grid lg:grid-cols-12 lg:gap-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left",
                                children: displayError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ace3485a2769e698$var$ErrorMessage, {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ace3485a2769e698$var$WelcomeMessage, {
                                    handleSubmit: handleSubmit,
                                    localConfirmationCode: localConfirmationCode,
                                    setLocalConfirmationCode: setLocalConfirmationCode,
                                    version: (user === null || user === void 0 ? void 0 : user.userState) === "confirmed" ? "userConfirmed" : "userNotConfirmed",
                                    identityProvider: user === null || user === void 0 ? void 0 : user.provider,
                                    codeError: codeError,
                                    loading: isSubmitting
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                        className: "absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-8 scale-75 origin-top sm:scale-100 lg:hidden",
                                        width: 640,
                                        height: 784,
                                        fill: "none",
                                        viewBox: "0 0 640 784",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pattern", {
                                                    id: "4f4f415c-a0e9-44c2-9601-6ded5a34a13e",
                                                    x: 118,
                                                    y: 0,
                                                    width: 20,
                                                    height: 20,
                                                    patternUnits: "userSpaceOnUse",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                        x: 0,
                                                        y: 0,
                                                        width: 4,
                                                        height: 4,
                                                        className: "text-gray-200",
                                                        fill: "currentColor"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                y: 72,
                                                width: 640,
                                                height: 640,
                                                className: "text-gray-50",
                                                fill: "currentColor"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                                                x: 118,
                                                width: 404,
                                                height: 784,
                                                fill: "url(#4f4f415c-a0e9-44c2-9601-6ded5a34a13e)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            className: "relative block w-full bg-white rounded-lg overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Watch our video to learn more"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    className: "w-full",
                                                    src: "https://images.unsplash.com/photo-1556740758-90de374c12ad?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                    className: "absolute inset-0 w-full h-full flex items-center justify-center",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", {
                                                        className: "h-20 w-20 text-indigo-500",
                                                        fill: "currentColor",
                                                        viewBox: "0 0 84 84",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                                                                opacity: "0.9",
                                                                cx: 42,
                                                                cy: 42,
                                                                r: 42,
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                                d: "M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
$ace3485a2769e698$export$68b1aae2077d1f19.propTypes = {
    clientSecret: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    payLater: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired,
    setIsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired
};
$ace3485a2769e698$export$68b1aae2077d1f19.defaultProps = {
    clientSecret: null,
    payLater: null
};
function $ace3485a2769e698$export$2e2bcd8739ae039() {
    const [showModal, setShowModal] = (0, $7fPBF.useState)({
        visible: false
    });
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [stripePromise, setStripePromise] = (0, $7fPBF.useState)(null);
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        "site"
    ]);
    // CallbackHandler should put the stripe params in sessionStorage
    const [setupIntentObject, _] = (0, $7fPBF.useState)(JSON.parse(sessionStorage.getItem("setupIntent")));
    const [payLater, __] = (0, $7fPBF.useState)(JSON.parse(sessionStorage.getItem("payLater")));
    const clientSecret = setupIntentObject === null || setupIntentObject === void 0 ? void 0 : setupIntentObject.setupIntentClientSecret;
    const isLoggedIn = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.isLoggedIn);
    const registration = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.registration);
    // TODO: to reenter at a later date, need to get clientSecret / setupIntent from Stripe
    // useful in case there is a crash between SignUp3 and here
    const { userId: userId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    // redirect away from this page if the user is logged in or there is no userId provided
    (0, $7fPBF.useEffect)(()=>{
        // if (isLoggedIn) navigate(`/${i18n.language}/app`);
        console.log("running useEffect in PAymentSuccessful");
        if (isLoggedIn) navigate(`/${i18n.language}/app/getready`); // Prep component (the one for adding demo data) will check if user has any data and if so, redirect to /app
        // user comes from clicking the email link, so there is a search parameter named confirmationCode, then go directly to dispatch
        // UPDATE: not possible now, as incoming url needs to have a client_secret from Stripe
        // if (userId && confirmationCodeUrl) handleNextStep();
        // if there is the userId parameter and no confirmation code, the user most likely came from registration and wants to fill out the code manually
        // (no action necessary, just render the page)
        // if there is neither userId parameter nor confirmation code, this shouldn't happen, so go to main page
        console.log("running useEffect in PAymentSuccessful");
        if (!userId) navigate(`/${i18n.language}/notfound`);
    });
    (0, $7fPBF.useEffect)(()=>{
        if (clientSecret && !stripePromise) setStripePromise((0, $d03319e48a3a604e$export$de80f7562c3fd6b1)("pk_live_51KduP7HTQ5xnEau1hmXjZ0p3J8TdXTsbzGYUIEiDxNNFJMgsSiGPMWnDtQKFXX6fJFLHpJCpcOWow8ob2pS4U4jY00xN2vET3e"));
    }, [
        clientSecret,
        stripePromise
    ]);
    // handles the next step after the user has entered the confirmation code (i.e. confirmation of Cognito registration )
    // if registration changes in the redux store, display a success message
    (0, $7fPBF.useEffect)(()=>{
        console.log("PaymentSuccessful - registration has changed - running useEffect", registration);
        // if registrationConfirmed changes to 'confirmed', means the user is confirmed already and should go to the dashboard
        if ((registration === null || registration === void 0 ? void 0 : registration.status) === "confirmed") {
            // if password is still in state / store, then use it to log in and forward user to App
            if ((registration === null || registration === void 0 ? void 0 : registration.username) && (registration === null || registration === void 0 ? void 0 : registration.password)) setShowModal({
                visible: true,
                alertId: "userRegistrationSuccessfulWithPassword"
            });
            else // show modal "success enter your login details on the next screen"
            setShowModal({
                visible: true,
                alertId: "userRegistrationSuccessful"
            });
        }
    }, [
        registration
    ]);
    // handle modal state changes from above
    (0, $7fPBF.useEffect)(()=>{
        async function handleAsyncSignin() {
            try {
                const returnObject = await (0, $134afd9bfa803edb$export$9670d83f11d4b64a)({
                    username: registration.username,
                    password: registration.password
                });
                return returnObject;
            } catch (err) {
                console.error("PaymentSuccessful - handleAsyncSigning . error when trying to sign up user", err);
            }
            return null;
        }
        console.log("PaymentSuccessful - showModal has changed - starting useEffect", showModal);
        if (!showModal.visible) {
            // modal has been closed
            if (showModal.alertId === "userRegistrationSuccessful") // this should automatically bring up the login screen for not-logged-in users
            // navigate(`/${i18n.language}/app`);
            navigate(`/${i18n.language}/app/getready`); // see above
            if (showModal.alertId === "userRegistrationSuccessfulWithPassword") // dispatch login, the change in isLoggedIn status will trigger the useEffect on top of this module and navigate to dashboard
            handleAsyncSignin();
        }
    }, [
        showModal
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            showModal.visible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7ec5014f9e38c963$export$2e2bcd8739ae039), {
                alertId: showModal.alertId,
                alertResetFunction: setShowModal,
                resetCallbackObject: (0, $2qxEV._)((0, $9tqwB._)({}, showModal), {
                    visible: false
                })
            }) : null,
            clientSecret && stripePromise ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e487d2a1927298$exports.Elements), {
                stripe: stripePromise,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ace3485a2769e698$export$68b1aae2077d1f19, {
                    clientSecret: clientSecret,
                    payLater: payLater,
                    isLoading: isLoading,
                    setIsLoading: setIsLoading,
                    userId: userId
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ace3485a2769e698$export$68b1aae2077d1f19, {
                clientSecret: clientSecret,
                payLater: payLater,
                isLoading: isLoading,
                setIsLoading: setIsLoading,
                userId: userId
            })
        ]
    });
}



var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");




var $bLhVg = parcelRequire("bLhVg");

var $7fPBF = parcelRequire("7fPBF");
function $4988a84873399da2$var$ShareIcon(_param, svgRef) {
    var { title: title, titleId: titleId } = _param, props = (0, $bLhVg._)(_param, [
        "title",
        "titleId"
    ]);
    return /*#__PURE__*/ $7fPBF.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $7fPBF.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $7fPBF.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
    }));
}
const $4988a84873399da2$var$ForwardRef = $7fPBF.forwardRef($4988a84873399da2$var$ShareIcon);
var $4988a84873399da2$export$2e2bcd8739ae039 = $4988a84873399da2$var$ForwardRef;







(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $1d6ef8b318b916d7$var$Icon({ isShareReport: isShareReport }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: `mx-auto flex items-center justify-center h-12 w-12 rounded-full ${isShareReport ? "bg-brandGreen-500" : "bg-brandBlue-100"}`,
        children: isShareReport ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4988a84873399da2$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-white",
            "aria-hidden": "true"
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $91420ff1f0fec24c$export$2e2bcd8739ae039), {
            className: "h-6 w-6 text-brandBlue-500",
            "aria-hidden": "true"
        })
    });
}
$1d6ef8b318b916d7$var$Icon.propTypes = {
    isShareReport: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
$1d6ef8b318b916d7$var$Icon.defaultProps = {
    isShareReport: false
};
function $1d6ef8b318b916d7$export$2e2bcd8739ae039() {
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [dialog, setDialog] = (0, $7fPBF.useState)({});
    const [isTouched, setIsTouched] = (0, $7fPBF.useState)(false);
    const [formValue, setFormValue] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const { t: tDashboard } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const { t: tAccountDetails } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("accountDetails", {
        keyPrefix: "buttons"
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    (0, $7fPBF.useEffect)(()=>{
        function handleDialogEvent(e) {
            var _e_detail;
            // console.log('DialogForm received event', JSON.stringify(e.detail, null, 2));
            if (e.detail) {
                setDialog((0, $2qxEV._)((0, $9tqwB._)({}, e.detail), {
                    visible: true
                }));
                setOpen(true);
            } else setOpen(false);
            if (((_e_detail = e.detail) === null || _e_detail === void 0 ? void 0 : _e_detail.value) !== undefined) {
                setFormValue(e.detail.value);
                setIsTouched(false);
            }
        }
        window.addEventListener("setDialog", handleDialogEvent);
        return ()=>{
            window.removeEventListener("setDialog", handleDialogEvent);
        };
    }, []);
    async function handleClick(e) {
        setLoading(true);
        try {
            await dialog.callback(formValue);
            // reset dialog
            setFormValue(null);
            setDialog({});
            setIsTouched(false);
            setLoading(false);
            setOpen(false);
        } catch (err) {
            console.log(err);
            dispatch((0, $3b9398d0f9c152fb$export$706cdae1b5419ef8)("accountCouldNotBeUpdated"));
            setLoading(false);
        }
    }
    function handleCancel() {
        setFormValue(null);
        setDialog({});
        setIsTouched(false);
        setOpen(false);
    }
    (0, $7fPBF.useEffect)(()=>{
        function handleEsc(e) {
            // ↓↓ if it is not open, we should just ignore it here
            if (!open) return;
            // if (open) e.stopImmediatePropagation(); // if it is open, stop the event from propagating; otherwise let other listeners receive it
            if (open && e.key === "Escape") {
                e.stopImmediatePropagation(); // if it is open, stop the event from propagating; otherwise let other listeners receive it
                handleCancel();
            }
        }
        // if (display === 'grid' || display === 'table') {
        document.addEventListener("keydown", handleEsc, false);
        // }
        return ()=>{
            document.removeEventListener("keydown", handleEsc, false);
        };
    }, [
        open
    ]); // if there are dependencies, then they all need to be in one object; if it is more, it creates several listeners
    // these two help with managing true / false / null in Dropdown
    function boolToStr(val) {
        if (val === true) return "strTrue";
        if (val === false) return "strFalse";
        return val;
    }
    function setValueBool(obj) {
        if (obj === null) {
            setFormValue(null);
            return;
        }
        if (obj.id === "strTrue") {
            setFormValue({
                id: true,
                name: "\u2714\uFE0F"
            });
            return;
        }
        if (obj.id === "strFalse") {
            setFormValue({
                id: false,
                name: "\u2716\uFE0F"
            });
            return;
        }
        setFormValue(null);
    }
    function handleShareReportForm(value, idx) {
        // if the value is not a number, reset
        const arr = formValue.split("-");
        arr[idx] = Number.isNaN(Number(value)) ? "000" : value;
        setFormValue(arr.join("-"));
        setIsTouched(true);
    }
    function handlePaste(e) {
        const pasteData = e.clipboardData.getData("text");
        const parts = pasteData.split("-");
        if (parts.length === 3 && parts.every((part)=>!Number.isNaN(Number(part))) && parts.every((part)=>part.length === 3)) setFormValue(pasteData);
    }
    const confirmButtonLabel = (dialog === null || dialog === void 0 ? void 0 : dialog.shareReport) ? tDashboard("shareReport.next") : tAccountDetails("save.label");
    return (dialog === null || dialog === void 0 ? void 0 : dialog.visible) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Root, {
        show: open,
        as: (0, $7fPBF.Fragment),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153), {
            as: "div",
            id: "dialog-form",
            className: "fixed z-50 inset-0 overflow-y-auto",
            onClose: setOpen,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: "div",
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                        "aria-hidden": "true",
                        children: "\u200B"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4).Child, {
                        as: "div",
                        id: "dialog-form-content",
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        className: `relative inline-block align-bottom rounded-lg px-4 pt-5 pb-4 text-left transform transition-all sm:my-8 sm:align-middle sm:p-6
            ${(dialog === null || dialog === void 0 ? void 0 : dialog.Component) ? "sm:max-w-5xl sm:w-full" : "shadow-xl bg-white sm:max-w-sm sm:w-full"}`,
                        children: (dialog === null || dialog === void 0 ? void 0 : dialog.Component) ? // if there is a Component, display it and do not render the rest of the dialog
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(dialog.Component, (0, $9tqwB._)({}, dialog.props)) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1d6ef8b318b916d7$var$Icon, {
                                            isShareReport: dialog === null || dialog === void 0 ? void 0 : dialog.shareReport
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "mt-3 text-center sm:mt-5",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ab39e0602eddb71e$export$3ddf2d174ce01153).Title, {
                                                    as: "h3",
                                                    className: "text-lg leading-6 font-bold text-gray-900",
                                                    children: dialog === null || dialog === void 0 ? void 0 : dialog.header
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    className: "mt-2 text-sm text-gray-500",
                                                    children: dialog === null || dialog === void 0 ? void 0 : dialog.prompt
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "mt-6",
                                                    children: [
                                                        !(dialog === null || dialog === void 0 ? void 0 : dialog.boolean) && !(dialog === null || dialog === void 0 ? void 0 : dialog.dropdown) && !(dialog === null || dialog === void 0 ? void 0 : dialog.array) && !dialog.shareReport && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                            type: dialog.date ? "date" : "text",
                                                            value: dialog.date ? (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(formValue).format("YYYY-MM-DD") : formValue,
                                                            onChange: (e)=>{
                                                                // handle number vs string
                                                                setFormValue(Number(e.target.value) || e.target.value);
                                                                if (!isTouched) setIsTouched(true);
                                                            },
                                                            // eslint-disable-next-line max-len
                                                            className: "block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brandBlue-600 sm:text-sm sm:leading-6"
                                                        }),
                                                        (dialog === null || dialog === void 0 ? void 0 : dialog.dropdown) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                            label: "",
                                                            list: dialog === null || dialog === void 0 ? void 0 : dialog.dropdown,
                                                            value: formValue,
                                                            onChange: (e)=>{
                                                                setFormValue(e);
                                                                setIsTouched(true);
                                                            },
                                                            optional: false
                                                        }),
                                                        (dialog === null || dialog === void 0 ? void 0 : dialog.array) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                            label: "",
                                                            list: dialog === null || dialog === void 0 ? void 0 : dialog.array,
                                                            value: formValue,
                                                            onChange: (e)=>{
                                                                setFormValue(e);
                                                                setIsTouched(true);
                                                            },
                                                            optional: false,
                                                            multiple: true
                                                        }),
                                                        (dialog === null || dialog === void 0 ? void 0 : dialog.boolean) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b864ec3e3c1aff7d$export$2e2bcd8739ae039), {
                                                            label: "",
                                                            list: [
                                                                {
                                                                    id: boolToStr(true),
                                                                    name: "\u2714\uFE0F"
                                                                },
                                                                {
                                                                    id: boolToStr(false),
                                                                    name: "\u2716\uFE0F"
                                                                },
                                                                null
                                                            ],
                                                            value: formValue !== null ? {
                                                                id: boolToStr(formValue),
                                                                name: formValue ? "\u2714\uFE0F" : "\u2716\uFE0F"
                                                            } : null,
                                                            onChange: (e)=>{
                                                                setValueBool(e);
                                                                setIsTouched(true);
                                                            },
                                                            optional: false
                                                        }),
                                                        (dialog === null || dialog === void 0 ? void 0 : dialog.shareReport) && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "w-full flex space-x-2 justify-center items-center align-middle",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                    className: "border border-gray-300 w-16 rounded-md text-gray-500 text-xl text-center",
                                                                    maxLength: 3,
                                                                    type: "text",
                                                                    value: formValue.split("-")[0],
                                                                    onChange: (e)=>handleShareReportForm(e.target.value, 0),
                                                                    onPaste: handlePaste
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: "text-xl font-black text-gray-400",
                                                                    children: "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                    className: "border border-gray-300 w-16 rounded-md text-gray-500 text-xl text-center",
                                                                    type: "text",
                                                                    maxLength: 3,
                                                                    value: formValue.split("-")[1],
                                                                    onChange: (e)=>handleShareReportForm(e.target.value, 1),
                                                                    onPaste: handlePaste
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    className: "text-xl font-black text-gray-400",
                                                                    children: "\u2014"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                    className: "border border-gray-300 w-16 rounded-md text-gray-500 text-xl text-center",
                                                                    type: "text",
                                                                    maxLength: 3,
                                                                    value: formValue.split("-")[2],
                                                                    onChange: (e)=>handleShareReportForm(e.target.value, 2),
                                                                    onPaste: handlePaste
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "mt-7 sm:mt-8 grid grid-cols-2 gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            name: "dialog-cancel-button",
                                            id: "dialog-form-cancel-button",
                                            // eslint-disable-next-line max-len
                                            className: "inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-500 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 sm:text-sm",
                                            onClick: handleCancel,
                                            children: tAccountDetails("cancel.label") || "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            name: "dialog-save-button",
                                            id: "dialog-form-save-button",
                                            // eslint-disable-next-line max-len
                                            className: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-brandBlue-500 text-base font-medium text-white hover:bg-brandBlue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandBlue-400 sm:text-sm",
                                            onClick: handleClick,
                                            children: loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-white animate-spin",
                                                "aria-hidden": "true"
                                            }) : confirmButtonLabel || "OK"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }) : null;
}


/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable no-restricted-syntax */ /* eslint-disable jsx-a11y/label-has-associated-control */ 
var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");


var $7fPBF = parcelRequire("7fPBF");




















(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($41426fe6dfa29819$exports))));
function $4566956bf6a424b0$export$ce4ab0c55987d1ff(...classes) {
    return classes.filter(Boolean).join(" ");
}
function $4566956bf6a424b0$export$2e2bcd8739ae039() {
    const { t: tDashboard, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("dashboard");
    const { t: tCharts } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)("charts");
    const params = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { reportId: reportId } = params;
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [errorState, setErrorState] = (0, $7fPBF.useState)(false);
    // initialise the report retrieval (async, no waiting for result)
    // the result will be loaded via the viewer reducer
    (0, $7fPBF.useEffect)(()=>{
        // show dialog with passcode prompt, ask for passcode, dispatch the below in callback
        window.dispatchEvent(new CustomEvent("setDialog", {
            detail: {
                header: tDashboard("sharedReportViewer.header"),
                prompt: tDashboard("sharedReportViewer.prompt"),
                value: "000-000-000",
                callback: async (value)=>{
                    const result = await dispatch((0, $978bd0b55383d4f0$export$91b19c3b6ec0ccaa)({
                        reportId: reportId,
                        passcode: value
                    }));
                    console.log("getSharedReport result:", result);
                    if (result.error) setErrorState(true);
                },
                shareReport: true
            }
        }));
    }, [
        reportId
    ]);
    const viewer = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.viewer);
    console.log("viewer contents", viewer);
    if (errorState) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full h-[65vh;] flex flex-col gap-4 justify-center items-center ",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-xl font-bold text-gray-900",
                children: tDashboard("sharedReportViewer.reportNotFound")
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-gray-700",
                children: tDashboard("sharedReportViewer.unableToLoadReport")
            })
        ]
    });
    if (Object.keys(viewer).length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-full h-[65vh;] flex flex-col gap-4 justify-center items-center text-gray-400",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e073a2cb8d5a7292$export$2e2bcd8739ae039), {
                className: "h-12 w-12 animate-spin"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "text-xl text-gray-500",
                children: tDashboard("pleaseWait")
            })
        ]
    });
    const { baseCurrency: baseCurrency, reportData: reportData } = viewer;
    // holds between renders and returns the function
    // keep only one (last) month of each year and current month (this is an annual chart)
    const assetBalanceChangeFilterCallback = (item)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().subtract(10, "year")) && ((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).month() === 11 || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))(item.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports)))().startOf("month")));
    const assetBalanceChangesData = {
        data: reportData.snapshots.filter(assetBalanceChangeFilterCallback)
    };
    const allAssetsSunburstData = {
        data: reportData.balances
    };
    // reports are displayed using PivotTable, which needs:
    // - standardPivotTableProps (the same for all)
    // - props from the report definition (import report definition file from /reports/prebuiltReports and spread it on PivotTable)
    // - data prop which is normally provided by reportingSelectors, but in this case we need to provide it ourselves (by using reportData from the viewer)
    // static props, do not depend on the report
    const standardPivotTableProps = {
        onChange: ()=>{},
        renderers: $5958bfc3d629e828$export$2e2bcd8739ae039
    };
    const topChartLayoutOptions = {
        // holds between renders and returns the value
        startLabel: false,
        endLabel: false,
        margin: {
            top: 10,
            right: 20,
            bottom: 30,
            left: 20
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "",
        id: "dashboard-root",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "relative xl:static",
            id: "dashboard-level-1",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "relative min-h-full bg-gray-50",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0a05383fb5bb0535$export$2e2bcd8739ae039), {
                        mode: "viewer",
                        openSettings: ()=>{},
                        openAccount: ()=>{},
                        searchControl: {},
                        setSearchControl: ()=>{},
                        setRecommendUsVisible: ()=>{}
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                        className: "pb-8 -mt-16 lg:-mt-20",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "relative max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-[100rem] lg:px-8",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                    className: "sr-only",
                                    children: "Profile"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "grid grid-cols-1 gap-2 md:gap-4 items-start lg:grid-cols-12 lg:gap-8",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $acdb9cfdc96986b7$export$2e2bcd8739ae039), {
                                            baseCurrency: baseCurrency,
                                            setKpiReportVisible: ()=>{},
                                            calendar: {},
                                            setCalendarState: ()=>{},
                                            setAccountDetails: ()=>{},
                                            isViewer: true
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "grid grid-cols-1 gap-4 lg:col-span-6",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                                    "aria-labelledby": "accounts-control-panel",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "xs:overflow-hidden flex flex-wrap justify-between sm:grid sm:grid-cols-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                className: "sr-only",
                                                                id: "profile-overview-title",
                                                                children: "Accounts Overview"
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "py-4 px-0 sm:px-3 md:px-4 sm:col-span-2",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "flex gap-3 align-baseline",
                                                                    id: "oneaboveyourassets",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                        className: "text-2xl sm:text-3xl md:text-4xl lg:text-3xl xl:text-4xl font-bold text-gray-900 lg:text-white",
                                                                        id: "your-assets",
                                                                        children: `${tDashboard("yourAssetsOn")} ${(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(viewer.metadata.publishedOn).format("DD.MM.YYYY")}`
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                (0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e).map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2343165816cf73bf$export$2e2bcd8739ae039), {
                                                                category: category,
                                                                editMode: false,
                                                                setEditMode: ()=>{},
                                                                addMode: false,
                                                                setAddMode: ()=>{},
                                                                setAccount: ()=>{},
                                                                isViewer: true
                                                            }, category),
                                                            category === "stocks" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "mx-4",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83), {
                                                                    as: "section",
                                                                    className: "px-4 py-2 bg-white w-full rounded-md",
                                                                    children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83).Button, {
                                                                                    className: "font-semibold w-full flex items-center justify-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                            className: "text-gray-500",
                                                                                            children: "Details"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c88e3f3391578fdf$export$2e2bcd8739ae039), {
                                                                                            className: `${open ? "rotate-180 transform" : ""} h-5 w-5 text-purple-500`
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                                                                    enter: "transition duration-100 ease-out",
                                                                                    enterFrom: "transform scale-95 opacity-0",
                                                                                    enterTo: "transform scale-100 opacity-100",
                                                                                    leave: "transition duration-75 ease-out",
                                                                                    leaveFrom: "transform scale-100 opacity-100",
                                                                                    leaveTo: "transform scale-95 opacity-0",
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83).Panel, {
                                                                                        className: "mt-2",
                                                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $2qxEV._)((0, $9tqwB._)({}, standardPivotTableProps, (0, $0f1cef2e461754dc$export$2e2bcd8739ae039)), {
                                                                                            isViewer: true
                                                                                        }))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                })
                                                            }),
                                                            category === "realEstate" && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                className: "mx-4",
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83), {
                                                                    as: "section",
                                                                    className: "px-4 py-2 bg-white w-full rounded-md",
                                                                    children: ({ open: open })=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83).Button, {
                                                                                    className: "font-semibold w-full flex items-center justify-between",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                                            className: "text-gray-500",
                                                                                            children: "Details"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c88e3f3391578fdf$export$2e2bcd8739ae039), {
                                                                                            className: `${open ? "rotate-180 transform" : ""} h-5 w-5 text-purple-500`
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b751aa1027c36e73$export$be58926105124dd4), {
                                                                                    enter: "transition duration-100 ease-out",
                                                                                    enterFrom: "transform scale-95 opacity-0",
                                                                                    enterTo: "transform scale-100 opacity-100",
                                                                                    leave: "transition duration-75 ease-out",
                                                                                    leaveFrom: "transform scale-100 opacity-100",
                                                                                    leaveTo: "transform scale-95 opacity-0",
                                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8d33aee4c6c0ce1f$export$74a362b31437ec83).Panel, {
                                                                                        className: "my-2 grid grid-cols-2 gap-4 pb-10",
                                                                                        children: reportData.balances.filter((b)=>b.category === "realEstate" && b.displayName !== "\u03A3").map((b)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                                                                className: "h-64 w-full",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                                                                        className: "text-base font-semibold text-gray-700 mt-4 mb-4",
                                                                                                        children: b.displayName
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $2qxEV._)((0, $9tqwB._)({}, standardPivotTableProps, (0, $dcb29d535f871e05$export$2e2bcd8739ae039)), {
                                                                                                        vals: [
                                                                                                            "quoteBaseCurrency"
                                                                                                        ],
                                                                                                        data: (0, $3e6d58b7292c657b$export$a537c627e243cb6e)(reportData.quotes[b.accountId]).filter((q)=>(0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(q.date).month() === 11 || (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(q.date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc().startOf("month"))).map((q)=>(0, $2qxEV._)((0, $9tqwB._)({}, q), {
                                                                                                                displayName: "empty",
                                                                                                                "Date (Year)": (0, (/*@__PURE__*/$parcel$interopDefault($615652efb7481f32$exports))).utc(q.date).year()
                                                                                                            })),
                                                                                                        layoutOptions: {
                                                                                                            axisBottom: {
                                                                                                                tickRotation: -90
                                                                                                            },
                                                                                                            margin: {
                                                                                                                bottom: 60
                                                                                                            }
                                                                                                        },
                                                                                                        isViewer: true
                                                                                                    }))
                                                                                                ]
                                                                                            }))
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                })
                                                            })
                                                        ]
                                                    }))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "grid grid-cols-1 gap-4 lg:col-span-4 ",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                                    "aria-labelledby": "chart-title",
                                                    className: "",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "relative rounded-md bg-white overflow-hidden shadow",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "p-6 h-[32rem]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                    className: "text-base font-semibold text-gray-900",
                                                                    id: "chart-top-title",
                                                                    children: tCharts("last12months")
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "w-full h-[80%]",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $2qxEV._)((0, $9tqwB._)({}, standardPivotTableProps, (0, $5b2ff690ae349b40$export$2e2bcd8739ae039), assetBalanceChangesData), {
                                                                        layoutOptions: topChartLayoutOptions,
                                                                        isViewer: true
                                                                    }))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                                    "aria-labelledby": "chart-title",
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                        className: "rounded-md bg-white overflow-hidden shadow z-10",
                                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                            className: "p-6 h-[32rem]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                    className: "mb-6 text-base font-semibold text-gray-900",
                                                                    id: "chart-bottom-title",
                                                                    children: tCharts("currentAllocation")
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                                                    className: "w-full h-[80%]",
                                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a66f03c34074fce6$exports))), (0, $9tqwB._)({}, standardPivotTableProps, (0, $2ac1f7d6b11cfce1$export$2e2bcd8739ae039), allAssetsSunburstData))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


// don't load SignUp and Dashboard until needed
// const Dashboard = React.lazy(() => import('./pages/Dashboard'));
// const SignUp = React.lazy(() => import('./pages/SignUp'));
// const PaymentSuccessful = React.lazy(() => import('./pages/PaymentSuccessful'));
const $7203b2e3a16473fb$var$debugLevel = 3;
const $7203b2e3a16473fb$var$isLocalhost = Boolean(window.location.hostname === "localhost" || window.location.hostname === "[::1]" || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
// authStatus is set by initApp in store
function $7203b2e3a16473fb$var$ProtectedRoute() {
    const isLoggedIn = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.isLoggedIn);
    const authStatus = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.authStatus);
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if ([
        null,
        "inProgress"
    ].includes(authStatus)) return null; // or a spinner/skeleton
    if (authStatus === "failed") return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: "AUTH FAILED"
    });
    return isLoggedIn ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: `/${i18n.language}/login`,
        state: location.pathname
    });
}
// const App = function () {
function $7203b2e3a16473fb$var$App() {
    // for Amplfiy debugging
    // window.LOG_LEVEL = 'DEBUG'; // DEBUG, VERBOSE, INFO, WARN, ERROR, NONE
    const isLoggedIn = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>state.user.isLoggedIn);
    const isViewerMode = (0, $51238fa605392ada$export$2105062e25df4afe)((state)=>{
        var _state_viewer_metadata, _state_viewer;
        return (_state_viewer = state.viewer) === null || _state_viewer === void 0 ? void 0 : (_state_viewer_metadata = _state_viewer.metadata) === null || _state_viewer_metadata === void 0 ? void 0 : _state_viewer_metadata.publishedOn;
    });
    const dispatch = (0, $0503a2a6eb4cf13a$export$8ad76b76a4c905f8)();
    const { i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)();
    const [render, rerender] = (0, $7fPBF.useState)(false);
    /**
   * @deprecated replaced by initAuth call below -- kept in case we missed any cases handled by RequireAuth
   * to be deleted
   */ function RequireAuth() {
        // get user authenticated before rendering the protected route
        // checks if there is an idToken in localStorage and verifies it locally
        // if user is not logged in, redirect to login page
        // returns true if user is authenticated, false if not and null when still waiting for the result of the authentification
        const [isAuth, setAuth] = (0, $7fPBF.useState)(null);
        const [isUnmounted, setIsUnmounted] = (0, $7fPBF.useState)(false);
        const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
        const afterLoginGoTo = location.pathname;
        // using useEffect here, because we assume React will render everything before Auth returns the async call?
        (0, $7fPBF.useEffect)(()=>{
            // define getToken first
            async function getToken() {
                let token;
                try {
                    token = await (0, $10933498be24bbfd$export$84773cc9bf7dbe87)();
                    if ($7203b2e3a16473fb$var$debugLevel > 2) console.info("RequireAuth > accessToken acquired.");
                } catch (err) {
                    console.error("RequireAuth > User authorisation is not possible.", err);
                    return false;
                }
                // get the JWT verified; if it succeeds, JWT is OK, if it fails, there is a problem with the token
                let result = false;
                try {
                    if (token) {
                        if ($7203b2e3a16473fb$var$debugLevel > 2) console.info("starting token verification");
                        result = await (0, $d759581364115054$export$c807668e63e7354b)(token, (0, $dd7c185588f01129$export$2e2bcd8739ae039));
                        if ($7203b2e3a16473fb$var$debugLevel > 2) console.log("token verification result:", result);
                    } // returns true or false
                } catch (err) {
                    console.error(err);
                }
                if ($7203b2e3a16473fb$var$debugLevel > 2) console.info("RequireAuth > User authorisation result:", result);
                return result;
            }
            getToken().then((result)=>{
                // if token is valid, set isAuth to true
                if ($7203b2e3a16473fb$var$debugLevel > 2) console.info("RequireAuth > token check finished.", result);
                if (result) {
                    if ($7203b2e3a16473fb$var$debugLevel > 2) console.info("RequireAuth > token is valid.");
                    if (!isUnmounted && !isAuth) setAuth(true);
                } else {
                    // handle getToken returning false
                    console.error("RequireAuth > token is invalid.");
                    setAuth(false); // if this is not set here, when PaymentSuccessful redirects to /app/getReady, it will not be redirected to /login
                    if (isLoggedIn) dispatch((0, $8bd3fc2d0bca0786$export$a0973bcfe11b05c9)()); // if token is invalid, log the user out in the store as well (if the user is logged in)
                    // return false;
                    if (!isUnmounted && isAuth) setAuth(false);
                }
            }, (err)=>{
                console.error("RequireAuth > error detected when validating token. ", err);
                // token not found or expired, return false to caller already
                // isAuth = false;
                // return false;
                if (!isUnmounted && isAuth) setAuth(false);
            });
            return ()=>{
                setIsUnmounted(true); // this is meant to stop sending new promises as soon as the component becomes unmounted
                if ($7203b2e3a16473fb$var$debugLevel > 2) console.info("RequireAuth > unmounting started");
            };
        }); // this is set to run at every render (useEffect is in fact not necessary here, but probably helps with the async stuff)
        if (isAuth === null) // still waiting for status to be set, it will rerender this component when promise fulfilled in getAuth (and its state changes)
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {});
        // if the token validation has just failed (isAuth === false),
        // redirect them to the /login page, but save the current location they were in location.state object.
        // This allows us to send the user along to that page after they login,
        // which is a nicer user experience than dropping them off on the home page.
        // the store MUST take care of removing the tokens (Auth.signOut()) before changing state of isLoggedIn
        if (!isAuth) console.log("RequireAuth > redirecting to login, afterLoginGoTo is", afterLoginGoTo);
        return isAuth ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
            to: `/${i18n.language}/login`,
            state: {
                afterLoginGoTo: afterLoginGoTo
            }
        });
    }
    const PerformLogout = function PerformLogout(props) {
        // needs to return a function otherwise is executed every time the whole app renders
        dispatch((0, $8bd3fc2d0bca0786$export$a0973bcfe11b05c9)());
        // eslint-disable-next-line react/destructuring-assignment
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
            to: props.targetPath
        });
    };
    // ------------------------------------------------------------
    // REGISTER AUTH CHANNEL ON HUB LISTENER AND UPDATE STORE WITH LOGIN STATUS
    // ------------------------------------------------------------
    (0, $7fPBF.useEffect)(()=>{
        const off = (0, $337062d98349aa9a$export$2e2bcd8739ae039)(dispatch);
        // cleanup (initAuth returns the Hub.listen function, so remove that)
        return ()=>typeof off === "function" && off();
    }, []);
    // ------------------------------------------------------------
    // CHECK IF USER IS STILL LOGGED IN AFTER STANDBY OR COVERED
    // ------------------------------------------------------------
    // this event happens when chrome is visible to user _again_, after standby or being covered by another window
    (0, $7fPBF.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === "visible" && !isViewerMode) // check if user is still logged in
            // if not, log them out
            (0, $10933498be24bbfd$export$e2edee8830cb9593)().then(()=>{}) // do nothing
            .catch(()=>{
                console.error("Unable to find valid tokens - logging out.");
                dispatch((0, $8bd3fc2d0bca0786$export$a0973bcfe11b05c9)()); // log out user
            }); // log out user
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            console.log("Removing visibility change listener");
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [
        isViewerMode
    ]);
    // handle RUM connection
    (0, $7fPBF.useEffect)(()=>{
        if (typeof window === "undefined") return undefined;
        try {
            const config = {
                sessionSampleRate: 1,
                guestRoleArn: !$7203b2e3a16473fb$var$isLocalhost ? "arn:aws:iam::475231208656:role/rum-client-rule" : "arn:aws:iam::483594703153:role/RUM-Monitor-eu-central-1-483594703153-5101467612961-Unauth",
                identityPoolId: !$7203b2e3a16473fb$var$isLocalhost ? "eu-central-1:150224b9-9d66-4ebc-9677-9e8f1ddc6c13" : "eu-central-1:9004dd33-2579-4d0e-ba50-64c8df44aa73",
                endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
                telemetries: [
                    "performance",
                    "errors",
                    "http"
                ],
                allowCookies: true,
                enableXRay: true
            };
            // initialises CloudWatch RUM once when the app mounts
            // eslint-disable-next-line no-new
            new (0, $afe47eb8223b4931$export$fb30ce7d244fa667)(!$7203b2e3a16473fb$var$isLocalhost ? "b9d74eea-478e-4256-82ef-dd098fcfd7ed" : "f2d95289-cefa-4ee5-909d-607e3da41547", !$7203b2e3a16473fb$var$isLocalhost ? "0.9.68" : "localhost", !$7203b2e3a16473fb$var$isLocalhost ? "eu-central-1" : "eu-central-1", config);
        } catch (error) {
            // Ignore errors thrown during CloudWatch RUM web client initialization
            console.error("Error during initialisation of AWS RUM", error);
        }
        return undefined;
    }, []);
    // initialise app-wide logger for components that do not live in the main app context (like contents of DialogForm, Redux reducers  etc.)
    (0, $7fPBF.useEffect)(()=>{
        function log(e) {
            console.log("Event-based logger:", e);
        }
        window.addEventListener("newLogEntry", log);
        return ()=>window.removeEventListener("newLogEntry", log);
    }, []);
    // initialise data
    (0, $7fPBF.useEffect)(function useEffectInApp() {
        async function execGetData() {
            const promises = (0, $89a24f7a54799e2c$export$1f4cdefbb27eb35e).map((category)=>dispatch((0, $f1c3fa004749592f$export$dfb022681f1048bc)(category)));
            await Promise.all(promises);
        }
        if (isLoggedIn) execGetData();
    }, [
        isLoggedIn
    ]);
    // FIXME footer cannot load first when entering via link localhost:3000/ Suspense
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0bf18c8a9090be1b$exports.ErrorBoundary), {
        FallbackComponent: (0, $cbe1190893083511$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cd4eb6c046d46984$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8f0e1b9f215fd49f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1d6ef8b318b916d7$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "h-screen overflow-auto",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7203b2e3a16473fb$var$ProtectedRoute, {}),
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                            path: "/:lang/app/*",
                                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/callback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/addAccountCallback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/:lang/mobileLogin",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/:lang/shared/*",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $22c5a69ba2799f42$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $288ae22ef857ab2c$export$2e2bcd8739ae039), {}) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/callback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bd414f4dcab720d8$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/fallback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5f040099692534d9$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/addAccountCallback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $55bdb067c8415ec9$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9ac7831776a0adc$export$2e2bcd8739ae039), {
                                            i18next: i18n
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                                                    to: `/${i18n.language}/`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/goto/:target",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $05a2551e51078849$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/:lang/goto/:target",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $05a2551e51078849$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                                                            to: `/${i18n.language}/login`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/login",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fa1bc39b019ebecd$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/legal",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4be5a3aa576d176c$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/contact",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5d8a82b288135cc1$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/register",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $00eeef16bd1a0e23$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/:lang/confirm/:userId",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ace3485a2769e698$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/:lang/mobileLogin",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4031aa798bd048f3$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/:lang/logout",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(PerformLogout, {
                                                    targetPath: `/${i18n.language}/`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/:lang/shared/:reportId",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4566956bf6a424b0$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7203b2e3a16473fb$var$ProtectedRoute, {}),
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/app/projects",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3900059271368e63$export$2e2bcd8739ae039), {
                                                            mode: "projects"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/app/reports",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $677f2a0982b8fa97$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/app/dashboard",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3900059271368e63$export$2e2bcd8739ae039), {
                                                            mode: "dashboard"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/app/getready",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $796298027c39e19e$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/app/sandbox",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9acad1ca7ba10f0a$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/app",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                                                            to: `/${i18n.language}/app/dashboard`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                        path: "/:lang/survey",
                                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $079c73b4144e3c9b$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "/:lang/notfound",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0c406b8db64f539$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0c406b8db64f539$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/callback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/addAccountCallback",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "/:lang/mobileLogin",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7203b2e3a16473fb$var$ProtectedRoute, {}),
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                            path: "/:lang/app/*",
                                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $913cec825392fdc0$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee486cb89111f160$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e20848388684b841$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}
var $7203b2e3a16473fb$export$2e2bcd8739ae039 = $7203b2e3a16473fb$var$App;



parcelRequire("7fPBF");

function $84014ee1bda5d393$var$Spinner() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "bg-white fixed top-0 left-0 right-0 h-screen z-50 grid place-content-center",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "w-16",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $10c3ddecbaea2060$export$42d15847cf9e98e1), {
                width: "75",
                height: "75",
                viewBox: "0 0 600 600"
            })
        })
    });
}
var $84014ee1bda5d393$export$2e2bcd8739ae039 = $84014ee1bda5d393$var$Spinner;


/* eslint-disable no-use-before-define */ // This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $b8077eed590c44e8$var$isLocalhost = Boolean(window.location.hostname === "localhost" || window.location.hostname === "[::1]" || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $b8077eed590c44e8$export$6503ec6e8aabbaf(config) {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener("load", ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($b8077eed590c44e8$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $b8077eed590c44e8$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $b8077eed590c44e8$var$registerValidSW(swUrl, config);
        });
    }
}
function $b8077eed590c44e8$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        // eslint-disable-next-line no-param-reassign
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log("Content is cached for offline use.");
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error("Error during service worker registration:", error);
    });
}
function $b8077eed590c44e8$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl, {
        headers: {
            "Service-Worker": "script"
        }
    }).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get("content-type");
        if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $b8077eed590c44e8$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $b8077eed590c44e8$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}




/* eslint-disable no-await-in-loop */ /* eslint-disable no-restricted-syntax */ 



var $lKcAt = parcelRequire("lKcAt");

var $aHcaX = parcelRequire("aHcaX");

// Function to load persisted slices from IndexedDB
const $c5da28b086ac05ef$var$loadPersistedSlice = async (sliceName, idToken)=>{
    // console.info(`Loading persisted slice: ${sliceName}`);
    const encryptedSlice = await (0, $5f2f08c7e6608317$export$ae6b3e7ea93fe912)(sliceName);
    if (!encryptedSlice) return null;
    try {
        const decryptedBytes = (0, (/*@__PURE__*/$parcel$interopDefault($aHcaX))).AES.decrypt(encryptedSlice, idToken);
        const decrypted = decryptedBytes.toString((0, (/*@__PURE__*/$parcel$interopDefault($aHcaX))).enc.Utf8);
        const decompressed = (0, $lKcAt.decompressFromUTF16)(decrypted);
        return JSON.parse(decompressed);
    } catch (error) {
        console.error(`Error decrypting or decompressing slice '${sliceName}'`, error);
        return null;
    }
};
var $c5da28b086ac05ef$export$2e2bcd8739ae039 = $c5da28b086ac05ef$var$loadPersistedSlice;


async function $841ea06cd59f1a3b$export$2e2bcd8739ae039(store) {
    // this block runs only once when the app is initialized
    try {
        // Check if the user is already authenticated and get the current session
        let sub;
        try {
            var _session_tokens_idToken, _session_tokens;
            const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
            ({ sub: sub } = ((_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.payload) || {});
        } catch (error) {
            if (error === "No current user") // the intended way of this working is rehydration of slices only when the user is signed in
            // console.info('initializeApp: No current user, exiting gracefully.');
            return;
            console.error("initializeApp: Error getting current session", error);
        }
        const currentState = store.getState();
        if (currentState.user.rehydrationStatus === "notStarted") ;
        else return;
        store.dispatch({
            type: "SET_REHYDRATION_STATUS",
            payload: "inProgress"
        });
        // Rehydrate each persisted slice asynchronously
        for (const sliceName of (0, $4d18ceaae7c86bf3$export$2e2bcd8739ae039)){
            const persistedSlice = await (0, $c5da28b086ac05ef$export$2e2bcd8739ae039)(sliceName, sub);
            // console.log('initializeApp: Rehydrating slice', sliceName, persistedSlice);
            if (persistedSlice) store.dispatch({
                type: `${sliceName}/hydrate`,
                payload: persistedSlice
            });
        }
        // Mark rehydration as finished
        store.dispatch({
            type: "SET_REHYDRATION_STATUS",
            payload: "finished"
        });
    } catch (error) {
        console.error("initializeApp: Error rehydrating persisted slices", error);
        store.dispatch({
            type: "SET_REHYDRATION_STATUS",
            payload: "finished"
        });
    }
    // Hub listener for subsequent auth events (should only run when rehydration is not in progress or done)
    (0, $317c15c2759ac41f$export$8c41bb232f1008b1).listen("auth", async ({ payload: { event: event, data: data } })=>{
        const currentState = store.getState();
        if ((event === "signIn" || event === "tokenRefresh") && currentState.user.rehydrationStatus === "notStarted") // console.log('initializeApp: Rehydrating persisted slices after auth event', event);
        try {
            var _session_tokens_idToken, _session_tokens;
            const session = await (0, $10933498be24bbfd$export$e2edee8830cb9593)();
            const { sub: sub } = ((_session_tokens = session.tokens) === null || _session_tokens === void 0 ? void 0 : (_session_tokens_idToken = _session_tokens.idToken) === null || _session_tokens_idToken === void 0 ? void 0 : _session_tokens_idToken.payload) || {};
            if (!sub) {
                console.error("Hub Listener: unable to rehydrate after auth event - user not found");
                return;
            }
            store.dispatch({
                type: "SET_REHYDRATION_STATUS",
                payload: "inProgress"
            });
            // Rehydrate persisted slices with new idToken
            for (const sliceName of (0, $4d18ceaae7c86bf3$export$2e2bcd8739ae039)){
                const persistedSlice = await (0, $c5da28b086ac05ef$export$2e2bcd8739ae039)(sliceName, sub);
                if (persistedSlice) store.dispatch({
                    type: `${sliceName}/hydrate`,
                    payload: persistedSlice
                });
            }
            // Update rehydration status
            store.dispatch({
                type: "SET_REHYDRATION_STATUS",
                payload: "finished"
            });
        } catch (error) {
            console.error("Hub Listener: Error rehydrating after auth event", error);
        }
        else if (event === "signOut") store.dispatch({
            type: "user/clear"
        });
    });
}




// this bit of code prepares the index.html using base url specific to the environment
if ((0, $cd7b47490a4d308b$export$fe8d61c54ed36ed5) && typeof document !== "undefined") {
    window.__ASSET_BASE_URL__ = (0, $cd7b47490a4d308b$export$fe8d61c54ed36ed5);
    document.documentElement.style.setProperty("--asset-base-url", (0, $cd7b47490a4d308b$export$fe8d61c54ed36ed5));
    const applyLink = (selector, filename)=>{
        const el = document.querySelector(selector);
        if (el) el.setAttribute("href", `${(0, $cd7b47490a4d308b$export$fe8d61c54ed36ed5)}${filename}`);
    };
    // Icons live under the asset base; manifest stays at the app root.
    applyLink('link[rel="icon"]', "favicon.ico");
    applyLink('link[rel="apple-touch-icon"]', "apple-touch-icon.png");
}
// TODO we don't know if this handles all the callback events from / to Cognito and Stripe correctly
(0, $317c15c2759ac41f$export$8c41bb232f1008b1).listen("auth", (capsule)=>(0, $a4825c1c5096d0fb$export$2e2bcd8739ae039)(capsule, (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039)));
(0, $317c15c2759ac41f$export$8c41bb232f1008b1).listen("core", (capsule)=>(0, $a4825c1c5096d0fb$export$2e2bcd8739ae039)(capsule, (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039)));
(0, $9d67c923c60ce67d$export$11ac3725994bec7b).configure((0, $dd7c185588f01129$export$2e2bcd8739ae039));
const $4a5191623062d5ff$var$container = document.getElementById("root");
const $4a5191623062d5ff$var$root = (0, $f11ec298ebcca059$export$882461b6382ed46c)($4a5191623062d5ff$var$container);
(0, $841ea06cd59f1a3b$export$2e2bcd8739ae039)((0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039)).then(()=>{
    $4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Suspense), {
            fallback: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $84014ee1bda5d393$export$2e2bcd8739ae039), {}),
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4c848518e85f237d$export$2e2bcd8739ae039), {
                store: (0, $2994cb1ba75a7bb3$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7203b2e3a16473fb$export$2e2bcd8739ae039), {})
            })
        })
    }));
});
// ReactDOM.render(
//   document.getElementById('root'),
// );
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$b8077eed590c44e8$export$d07f55d4c15c0440();


//# sourceMappingURL=index.da508c19.js.map
